'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var protobuf$1 = require('protobufjs/light');
var require$$1 = require('long');
var ByteBuffer = require('bytebuffer');
var buffer = require('buffer');
var require$$0 = require('protobufjs/minimal');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n["default"] = e;
    return Object.freeze(n);
}

var protobuf__namespace = /*#__PURE__*/_interopNamespace(protobuf$1);
var require$$1__default = /*#__PURE__*/_interopDefaultLegacy(require$$1);
var ByteBuffer__default = /*#__PURE__*/_interopDefaultLegacy(ByteBuffer);
var require$$0__default = /*#__PURE__*/_interopDefaultLegacy(require$$0);

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

const primitiveTypes = [
    'bool',
    'string',
    'bytes',
    'int32',
    'int64',
    'uint32',
    'uint64',
    'sint32',
    'sint64',
    'fixed32',
    'fixed64',
    'sfixed32',
    'sfixed64',
    'double',
    'float',
];
const isPrimitiveField = (field) => primitiveTypes.includes(field);

const transform$1 = (field, value) => {
    if ((field === null || field === void 0 ? void 0 : field.optional) && typeof value === 'undefined') {
        return null;
    }
    if ((field === null || field === void 0 ? void 0 : field.type) === 'bytes') {
        return ByteBuffer__default["default"].wrap(value).toString('hex');
    }
    if (field === null || field === void 0 ? void 0 : field.long) {
        if (Number.isSafeInteger(value.toNumber())) {
            return value.toNumber();
        }
        return value.toString();
    }
    return value;
};
function messageToJSON(Message, fields) {
    const message = __rest(Message, []);
    const res = {};
    Object.keys(fields).forEach(key => {
        const field = fields[key];
        const value = message[key];
        if (value == null) {
            if (field.optional) {
                res[key] = null;
            }
            return;
        }
        if (field.repeated) {
            if (isPrimitiveField(field.type)) {
                res[key] = value.map((v) => transform$1(field, v));
            }
            else if ('valuesById' in field.resolvedType) {
                res[key] = value;
            }
            else if ('fields' in field.resolvedType) {
                res[key] = value.map((v) => messageToJSON(v, field.resolvedType.fields));
            }
            else {
                throw new Error(`case not handled for repeated key: ${key}`);
            }
        }
        else if (isPrimitiveField(field.type)) {
            res[key] = transform$1(field, value);
        }
        else if ('valuesById' in field.resolvedType) {
            res[key] = field.resolvedType.valuesById[value];
        }
        else if (field.resolvedType.fields) {
            res[key] = value == null ? null : messageToJSON(value, field.resolvedType.fields);
        }
        else {
            throw new Error(`case not handled: ${key}`);
        }
    });
    return res;
}
const decode = (Message, data) => {
    const buff = data.toBuffer();
    const a = new Uint8Array(buff);
    let decoded;
    try {
        decoded = Message.decode(a);
    }
    catch (error) {
        if (a.length > 1 && a[a.length - 1] === 0xff) {
            a[a.length - 1] = 0x04;
            decoded = Message.decode(a);
        }
        else {
            throw error;
        }
    }
    return messageToJSON(decoded, decoded.$type.fields);
};

const transform = (fieldType, value) => {
    if (fieldType === 'bytes') {
        if (typeof value === 'string' && !value)
            return value;
        return buffer.Buffer.from(value, 'hex');
    }
    if (typeof value === 'number' && !Number.isSafeInteger(value)) {
        throw new RangeError('field value is not within safe integer range');
    }
    return value;
};
function patch(Message, payload) {
    const patched = {};
    if (!Message.fields) {
        return patched;
    }
    Object.keys(Message.fields).forEach(key => {
        const field = Message.fields[key];
        const value = payload[key];
        if (typeof value === 'undefined') {
            return;
        }
        if (field && isPrimitiveField(field.type)) {
            if (field.repeated) {
                patched[key] = value.map((v) => transform(field.type, v));
            }
            else {
                patched[key] = transform(field.type, value);
            }
            return;
        }
        if (field.repeated) {
            const RefMessage = Message.lookupTypeOrEnum(field.type);
            patched[key] =
                RefMessage instanceof protobuf$1.Enum
                    ? value.map((v) => transform(field.type, v))
                    : value.map((v) => patch(RefMessage, v));
        }
        else if (typeof value === 'object' && value !== null) {
            const RefMessage = Message.lookupType(field.type);
            patched[key] = patch(RefMessage, value);
        }
        else if (typeof value === 'number') {
            const RefMessage = Message.lookupEnum(field.type);
            patched[key] = RefMessage.values[value];
        }
        else {
            patched[key] = value;
        }
    });
    return patched;
}
const encode = (Message, data) => {
    const payload = patch(Message, data);
    const message = Message.fromObject(payload);
    const buffer = Message.encode(message).finish();
    const bytebuffer = new ByteBuffer__default["default"](buffer.byteLength);
    bytebuffer.append(buffer);
    bytebuffer.reset();
    return bytebuffer;
};

// Generated by scripts/protobuf-static.js. Do not edit.
/* istanbul ignore file */
const protobuf = require$$0__default["default"];
protobuf.util.Long = require$$1__default["default"];
protobuf.configure();
function schemaKey(schema) {
  return JSON.stringify(schema, (_key, value) => {
    if (value && typeof value === 'object' && !Array.isArray(value)) {
      return Object.keys(value)
        .sort()
        .reduce((result, key) => {
          result[key] = value[key];
          return result;
        }, {});
    }
    return value;
  });
}
var protobufStatic = { schemaKey, legacyProtocolInfoSchema: {"nested":{"LegacyProtocolInfo":{"fields":{"version":{"rule":"required","type":"uint32","id":1},"supported_messages":{"rule":"repeated","type":"uint32","id":2,"options":{"packed":false}},"protobuf_definition":{"type":"string","id":3}}}}}, schemas: {
"{\"nested\":{\"Address\":{\"fields\":{\"address\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"}}},\"AlephiumAddress\":{\"fields\":{\"address\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"},\"derived_path\":{\"id\":3,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"public_key\":{\"id\":2,\"type\":\"bytes\"}}},\"AlephiumBytecodeAck\":{\"fields\":{\"bytecode_data\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"AlephiumBytecodeRequest\":{\"fields\":{\"data_length\":{\"id\":1,\"type\":\"uint32\"},\"public_key\":{\"id\":2,\"type\":\"bytes\"},\"signature\":{\"id\":3,\"type\":\"bytes\"}}},\"AlephiumGetAddress\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"include_public_key\":{\"id\":3,\"type\":\"bool\"},\"show_display\":{\"id\":2,\"type\":\"bool\"},\"target_group\":{\"id\":4,\"type\":\"uint32\"}}},\"AlephiumMessageSignature\":{\"fields\":{\"address\":{\"id\":2,\"type\":\"string\"},\"signature\":{\"id\":1,\"type\":\"bytes\"}}},\"AlephiumSignMessage\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"message\":{\"id\":2,\"type\":\"bytes\"},\"message_type\":{\"id\":3,\"type\":\"bytes\"}}},\"AlephiumSignTx\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"data_initial_chunk\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"},\"data_length\":{\"id\":3,\"type\":\"uint32\"}}},\"AlephiumSignedTx\":{\"fields\":{\"address\":{\"id\":2,\"rule\":\"required\",\"type\":\"string\"},\"signature\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"AlephiumTxAck\":{\"fields\":{\"data_chunk\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"AlephiumTxRequest\":{\"fields\":{\"data_length\":{\"id\":1,\"type\":\"uint32\"},\"public_key\":{\"id\":2,\"type\":\"bytes\"},\"signature\":{\"id\":3,\"type\":\"bytes\"}}},\"AlgorandAddress\":{\"fields\":{\"address\":{\"id\":1,\"type\":\"string\"}}},\"AlgorandGetAddress\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"show_display\":{\"id\":3,\"type\":\"bool\"}}},\"AlgorandSignTx\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"raw_tx\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"AlgorandSignedTx\":{\"fields\":{\"signature\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"AmountUnit\":{\"values\":{\"BITCOIN\":0,\"MICROBITCOIN\":2,\"MILLIBITCOIN\":1,\"SATOSHI\":3}},\"ApplyFlags\":{\"fields\":{\"flags\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint32\"}}},\"ApplySettings\":{\"fields\":{\"_passphrase_source\":{\"id\":5,\"options\":{\"deprecated\":true},\"type\":\"uint32\"},\"auto_lock_delay_ms\":{\"id\":6,\"type\":\"uint32\"},\"auto_shutdown_delay_ms\":{\"id\":500,\"type\":\"uint32\"},\"change_brightness\":{\"id\":501,\"type\":\"bool\"},\"display_rotation\":{\"id\":7,\"type\":\"uint32\"},\"experimental_features\":{\"id\":10,\"type\":\"bool\"},\"fastpay_confirm\":{\"id\":104,\"type\":\"bool\"},\"fastpay_money_limit\":{\"id\":105,\"type\":\"uint64\"},\"fastpay_pin\":{\"id\":103,\"type\":\"bool\"},\"fastpay_times\":{\"id\":106,\"type\":\"uint32\"},\"haptic_feedback\":{\"id\":502,\"type\":\"bool\"},\"homescreen\":{\"id\":4,\"type\":\"bytes\"},\"is_bixinapp\":{\"id\":102,\"type\":\"bool\"},\"label\":{\"id\":2,\"type\":\"string\"},\"language\":{\"id\":1,\"type\":\"string\"},\"passphrase_always_on_device\":{\"id\":8,\"type\":\"bool\"},\"safety_checks\":{\"id\":9,\"type\":\"SafetyCheckLevel\"},\"use_ble\":{\"id\":100,\"type\":\"bool\"},\"use_passphrase\":{\"id\":3,\"type\":\"bool\"},\"use_se\":{\"id\":101,\"type\":\"bool\"}},\"nested\":{\"ExportType\":{\"values\":{\"MnemonicPlainExportType_YES\":2,\"SeedEncExportType_NO\":0,\"SeedEncExportType_YES\":1}}}},\"AptosAddress\":{\"fields\":{\"address\":{\"id\":1,\"type\":\"string\"}}},\"AptosGetAddress\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"show_display\":{\"id\":2,\"type\":\"bool\"}}},\"AptosMessageSignature\":{\"fields\":{\"address\":{\"id\":2,\"rule\":\"required\",\"type\":\"string\"},\"signature\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"AptosSignMessage\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"payload\":{\"id\":2,\"rule\":\"required\",\"type\":\"AptosMessagePayload\"}},\"nested\":{\"AptosMessagePayload\":{\"fields\":{\"address\":{\"id\":2,\"type\":\"string\"},\"application\":{\"id\":4,\"type\":\"string\"},\"chain_id\":{\"id\":3,\"type\":\"string\"},\"message\":{\"id\":6,\"rule\":\"required\",\"type\":\"string\"},\"nonce\":{\"id\":5,\"rule\":\"required\",\"type\":\"string\"}}}}},\"AptosSignSIWAMessage\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"siwa_payload\":{\"id\":2,\"rule\":\"required\",\"type\":\"string\"}}},\"AptosSignTx\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"raw_tx\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"},\"tx_type\":{\"id\":3,\"options\":{\"default\":\"STANDARD\"},\"type\":\"AptosTransactionType\"}},\"nested\":{\"AptosTransactionType\":{\"values\":{\"STANDARD\":0,\"WITH_DATA\":1}}}},\"AptosSignedTx\":{\"fields\":{\"public_key\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"},\"signature\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"AuthorizeCoinJoin\":{\"fields\":{\"address_n\":{\"id\":4,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"amount_unit\":{\"id\":11,\"options\":{\"default\":\"BITCOIN\"},\"type\":\"AmountUnit\"},\"coin_name\":{\"id\":5,\"options\":{\"default\":\"Bitcoin\"},\"type\":\"string\"},\"coordinator\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"},\"fee_per_anonymity\":{\"id\":3,\"options\":{\"default\":0},\"type\":\"uint32\"},\"max_total_fee\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint64\"},\"script_type\":{\"id\":6,\"options\":{\"default\":\"SPENDADDRESS\"},\"type\":\"InputScriptType\"}},\"options\":{\"(unstable)\":true}},\"BabylonDeriveContextHash\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"app_name\":{\"id\":3,\"rule\":\"required\",\"type\":\"bytes\"},\"context\":{\"id\":4,\"rule\":\"required\",\"type\":\"bytes\"},\"network\":{\"id\":5,\"rule\":\"required\",\"type\":\"CanonicalBitcoinNetwork\"},\"script_type\":{\"id\":2,\"rule\":\"required\",\"type\":\"InputScriptType\"}}},\"BabylonDerivedContextHash\":{\"fields\":{\"secret\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"BackupDevice\":{\"fields\":{}},\"BackupType\":{\"values\":{\"Bip39\":0,\"Slip39_Advanced\":2,\"Slip39_Basic\":1}},\"BatchGetPublickeys\":{\"fields\":{\"ecdsa_curve_name\":{\"id\":1,\"options\":{\"default\":\"ed25519\"},\"type\":\"string\"},\"include_node\":{\"id\":3,\"options\":{\"default\":false},\"type\":\"bool\"},\"paths\":{\"id\":2,\"rule\":\"repeated\",\"type\":\"Path\"}},\"nested\":{\"Path\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"}}}}},\"BenfenAddress\":{\"fields\":{\"address\":{\"id\":1,\"type\":\"string\"}}},\"BenfenGetAddress\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"show_display\":{\"id\":2,\"type\":\"bool\"}}},\"BenfenMessageSignature\":{\"fields\":{\"address\":{\"id\":2,\"rule\":\"required\",\"type\":\"string\"},\"signature\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"BenfenSignMessage\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"message\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"BenfenSignTx\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"coin_type\":{\"id\":4,\"type\":\"bytes\"},\"data_initial_chunk\":{\"id\":3,\"options\":{\"default\":\"\"},\"type\":\"bytes\"},\"data_length\":{\"id\":5,\"type\":\"uint32\"},\"raw_tx\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"BenfenSignedTx\":{\"fields\":{\"public_key\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"},\"signature\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"BenfenTxAck\":{\"fields\":{\"data_chunk\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"BenfenTxRequest\":{\"fields\":{\"data_length\":{\"id\":1,\"type\":\"uint32\"},\"public_key\":{\"id\":2,\"type\":\"bytes\"},\"signature\":{\"id\":3,\"type\":\"bytes\"}}},\"BinanceAddress\":{\"fields\":{\"address\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"}}},\"BinanceCancelMsg\":{\"fields\":{\"refid\":{\"id\":1,\"type\":\"string\"},\"sender\":{\"id\":2,\"type\":\"string\"},\"symbol\":{\"id\":3,\"type\":\"string\"}}},\"BinanceGetAddress\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"show_display\":{\"id\":2,\"type\":\"bool\"}}},\"BinanceGetPublicKey\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"show_display\":{\"id\":2,\"type\":\"bool\"}}},\"BinanceOrderMsg\":{\"fields\":{\"id\":{\"id\":1,\"type\":\"string\"},\"ordertype\":{\"id\":2,\"type\":\"BinanceOrderType\"},\"price\":{\"id\":3,\"type\":\"sint64\"},\"quantity\":{\"id\":4,\"type\":\"sint64\"},\"sender\":{\"id\":5,\"type\":\"string\"},\"side\":{\"id\":6,\"type\":\"BinanceOrderSide\"},\"symbol\":{\"id\":7,\"type\":\"string\"},\"timeinforce\":{\"id\":8,\"type\":\"BinanceTimeInForce\"}},\"nested\":{\"BinanceOrderSide\":{\"values\":{\"BUY\":1,\"SELL\":2,\"SIDE_UNKNOWN\":0}},\"BinanceOrderType\":{\"values\":{\"LIMIT\":2,\"MARKET\":1,\"OT_RESERVED\":3,\"OT_UNKNOWN\":0}},\"BinanceTimeInForce\":{\"values\":{\"GTE\":1,\"IOC\":3,\"TIF_RESERVED\":2,\"TIF_UNKNOWN\":0}}}},\"BinancePublicKey\":{\"fields\":{\"public_key\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"BinanceSignTx\":{\"fields\":{\"account_number\":{\"id\":3,\"type\":\"sint64\"},\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"chain_id\":{\"id\":4,\"type\":\"string\"},\"memo\":{\"id\":5,\"type\":\"string\"},\"msg_count\":{\"id\":2,\"type\":\"uint32\"},\"sequence\":{\"id\":6,\"type\":\"sint64\"},\"source\":{\"id\":7,\"type\":\"sint64\"}}},\"BinanceSignedTx\":{\"fields\":{\"public_key\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"},\"signature\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"BinanceTransferMsg\":{\"fields\":{\"inputs\":{\"id\":1,\"rule\":\"repeated\",\"type\":\"BinanceInputOutput\"},\"outputs\":{\"id\":2,\"rule\":\"repeated\",\"type\":\"BinanceInputOutput\"}},\"nested\":{\"BinanceCoin\":{\"fields\":{\"amount\":{\"id\":1,\"type\":\"sint64\"},\"denom\":{\"id\":2,\"type\":\"string\"}}},\"BinanceInputOutput\":{\"fields\":{\"address\":{\"id\":1,\"type\":\"string\"},\"coins\":{\"id\":2,\"rule\":\"repeated\",\"type\":\"BinanceCoin\"}}}}},\"BinanceTxRequest\":{\"fields\":{}},\"BixinBackupAck\":{\"fields\":{\"data\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"BixinBackupDevice\":{\"fields\":{}},\"BixinBackupDeviceAck\":{\"fields\":{\"mnemonics\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"}}},\"BixinBackupRequest\":{\"fields\":{}},\"BixinLoadDevice\":{\"fields\":{\"label\":{\"id\":6,\"type\":\"string\"},\"language\":{\"id\":5,\"options\":{\"default\":\"en-US\"},\"type\":\"string\"},\"mnemonics\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"},\"skip_checksum\":{\"id\":7,\"type\":\"bool\"}}},\"BixinMessageSE\":{\"fields\":{\"inputmessage\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"BixinOutMessageSE\":{\"fields\":{\"outmessage\":{\"id\":1,\"type\":\"bytes\"}}},\"BixinPinInputOnDevice\":{\"fields\":{}},\"BixinRestoreAck\":{\"fields\":{\"data\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"BixinRestoreRequest\":{\"fields\":{\"data\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"},\"label\":{\"id\":3,\"type\":\"string\"},\"language\":{\"id\":2,\"type\":\"string\"},\"passphrase_protection\":{\"id\":4,\"type\":\"bool\"}}},\"BixinSeedOperate\":{\"fields\":{\"seed_importData\":{\"id\":2,\"type\":\"bytes\"},\"type\":{\"id\":1,\"rule\":\"required\",\"type\":\"SeedRequestType\"}},\"nested\":{\"SeedRequestType\":{\"values\":{\"SeedRequestType_EncExport\":1,\"SeedRequestType_EncImport\":2,\"SeedRequestType_Gen\":0}}}},\"BixinVerifyDeviceAck\":{\"fields\":{\"cert\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"},\"signature\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"BixinVerifyDeviceRequest\":{\"fields\":{\"data\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"BixinWhiteListAck\":{\"fields\":{\"address\":{\"id\":1,\"rule\":\"repeated\",\"type\":\"string\"}}},\"BixinWhiteListRequest\":{\"fields\":{\"addr_in\":{\"id\":2,\"type\":\"string\"},\"type\":{\"id\":1,\"rule\":\"required\",\"type\":\"WL_OperationType\"}},\"nested\":{\"WL_OperationType\":{\"values\":{\"WL_OperationType_Add\":0,\"WL_OperationType_Delete\":1,\"WL_OperationType_Inquire\":2}}}},\"BlurRequest\":{\"fields\":{\"data_length\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint32\"},\"offset\":{\"id\":1,\"type\":\"uint32\"}}},\"ButtonAck\":{\"fields\":{}},\"ButtonRequest\":{\"fields\":{\"code\":{\"id\":1,\"type\":\"ButtonRequestType\"},\"pages\":{\"id\":2,\"type\":\"uint32\"}},\"nested\":{\"ButtonRequestType\":{\"values\":{\"ButtonRequest_Address\":10,\"ButtonRequest_AttachPin\":8000,\"ButtonRequest_ConfirmOutput\":3,\"ButtonRequest_ConfirmWord\":5,\"ButtonRequest_FeeOverThreshold\":2,\"ButtonRequest_FirmwareCheck\":9,\"ButtonRequest_MnemonicInput\":13,\"ButtonRequest_MnemonicWordCount\":12,\"ButtonRequest_Other\":1,\"ButtonRequest_PassphraseEntry\":19,\"ButtonRequest_PinEntry\":20,\"ButtonRequest_ProtectCall\":7,\"ButtonRequest_PublicKey\":11,\"ButtonRequest_RecoveryHomepage\":16,\"ButtonRequest_ResetDevice\":4,\"ButtonRequest_SignTx\":8,\"ButtonRequest_Success\":17,\"ButtonRequest_UnknownDerivationPath\":15,\"ButtonRequest_Warning\":18,\"ButtonRequest_WipeDevice\":6,\"_Deprecated_ButtonRequest_PassphraseType\":14}}}},\"Cancel\":{\"fields\":{}},\"CancelAuthorization\":{\"fields\":{}},\"CanonicalBitcoinNetwork\":{\"values\":{\"BITCOIN_MAINNET\":0,\"BITCOIN_REGTEST\":3,\"BITCOIN_SIGNET\":2,\"BITCOIN_TESTNET\":1}},\"CardanoAddress\":{\"fields\":{\"address\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"}}},\"CardanoAddressParametersType\":{\"fields\":{\"address_n\":{\"id\":2,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"address_n_staking\":{\"id\":3,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"address_type\":{\"id\":1,\"rule\":\"required\",\"type\":\"CardanoAddressType\"},\"certificate_pointer\":{\"id\":5,\"type\":\"CardanoBlockchainPointerType\"},\"script_payment_hash\":{\"id\":6,\"type\":\"bytes\"},\"script_staking_hash\":{\"id\":7,\"type\":\"bytes\"},\"staking_key_hash\":{\"id\":4,\"type\":\"bytes\"}}},\"CardanoAddressType\":{\"values\":{\"BASE\":0,\"BASE_KEY_SCRIPT\":2,\"BASE_SCRIPT_KEY\":1,\"BASE_SCRIPT_SCRIPT\":3,\"BYRON\":8,\"ENTERPRISE\":6,\"ENTERPRISE_SCRIPT\":7,\"POINTER\":4,\"POINTER_SCRIPT\":5,\"REWARD\":14,\"REWARD_SCRIPT\":15}},\"CardanoAssetGroup\":{\"fields\":{\"policy_id\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"},\"tokens_count\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint32\"}}},\"CardanoBlockchainPointerType\":{\"fields\":{\"block_index\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint32\"},\"certificate_index\":{\"id\":3,\"rule\":\"required\",\"type\":\"uint32\"},\"tx_index\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint32\"}}},\"CardanoCVoteRegistrationDelegation\":{\"fields\":{\"vote_public_key\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"},\"weight\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint32\"}}},\"CardanoCVoteRegistrationFormat\":{\"values\":{\"CIP15\":0,\"CIP36\":1}},\"CardanoCVoteRegistrationParametersType\":{\"fields\":{\"delegations\":{\"id\":6,\"rule\":\"repeated\",\"type\":\"CardanoCVoteRegistrationDelegation\"},\"format\":{\"id\":5,\"options\":{\"default\":\"CIP15\"},\"type\":\"CardanoCVoteRegistrationFormat\"},\"nonce\":{\"id\":4,\"rule\":\"required\",\"type\":\"uint64\"},\"payment_address\":{\"id\":8,\"type\":\"string\"},\"payment_address_parameters\":{\"id\":3,\"type\":\"CardanoAddressParametersType\"},\"staking_path\":{\"id\":2,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"vote_public_key\":{\"id\":1,\"type\":\"bytes\"},\"voting_purpose\":{\"id\":7,\"type\":\"uint64\"}}},\"CardanoCertificateType\":{\"values\":{\"STAKE_DELEGATION\":2,\"STAKE_DEREGISTRATION\":1,\"STAKE_DEREGISTRATION_CONWAY\":8,\"STAKE_POOL_REGISTRATION\":3,\"STAKE_REGISTRATION\":0,\"STAKE_REGISTRATION_CONWAY\":7,\"VOTE_DELEGATION\":9}},\"CardanoDRep\":{\"fields\":{\"key_hash\":{\"id\":2,\"type\":\"bytes\"},\"script_hash\":{\"id\":3,\"type\":\"bytes\"},\"type\":{\"id\":1,\"rule\":\"required\",\"type\":\"CardanoDRepType\"}}},\"CardanoDRepType\":{\"values\":{\"ABSTAIN\":2,\"KEY_HASH\":0,\"NO_CONFIDENCE\":3,\"SCRIPT_HASH\":1}},\"CardanoDerivationType\":{\"values\":{\"ICARUS\":1,\"ICARUS_TREZOR\":2,\"LEDGER\":0}},\"CardanoGetAddress\":{\"fields\":{\"address_parameters\":{\"id\":5,\"rule\":\"required\",\"type\":\"CardanoAddressParametersType\"},\"chunkify\":{\"id\":7,\"type\":\"bool\"},\"derivation_type\":{\"id\":6,\"rule\":\"required\",\"type\":\"CardanoDerivationType\"},\"network_id\":{\"id\":4,\"rule\":\"required\",\"type\":\"uint32\"},\"protocol_magic\":{\"id\":3,\"rule\":\"required\",\"type\":\"uint32\"},\"show_display\":{\"id\":2,\"options\":{\"default\":false},\"type\":\"bool\"}}},\"CardanoGetNativeScriptHash\":{\"fields\":{\"derivation_type\":{\"id\":3,\"rule\":\"required\",\"type\":\"CardanoDerivationType\"},\"display_format\":{\"id\":2,\"rule\":\"required\",\"type\":\"CardanoNativeScriptHashDisplayFormat\"},\"script\":{\"id\":1,\"rule\":\"required\",\"type\":\"CardanoNativeScript\"}}},\"CardanoGetPublicKey\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"derivation_type\":{\"id\":3,\"rule\":\"required\",\"type\":\"CardanoDerivationType\"},\"show_display\":{\"id\":2,\"type\":\"bool\"}}},\"CardanoMessageSignature\":{\"fields\":{\"key\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"},\"signature\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"CardanoNativeScript\":{\"fields\":{\"invalid_before\":{\"id\":6,\"type\":\"uint64\"},\"invalid_hereafter\":{\"id\":7,\"type\":\"uint64\"},\"key_hash\":{\"id\":3,\"type\":\"bytes\"},\"key_path\":{\"id\":4,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"required_signatures_count\":{\"id\":5,\"type\":\"uint32\"},\"scripts\":{\"id\":2,\"rule\":\"repeated\",\"type\":\"CardanoNativeScript\"},\"type\":{\"id\":1,\"rule\":\"required\",\"type\":\"CardanoNativeScriptType\"}}},\"CardanoNativeScriptHash\":{\"fields\":{\"script_hash\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"CardanoNativeScriptHashDisplayFormat\":{\"values\":{\"BECH32\":1,\"HIDE\":0,\"POLICY_ID\":2}},\"CardanoNativeScriptType\":{\"values\":{\"ALL\":1,\"ANY\":2,\"INVALID_BEFORE\":4,\"INVALID_HEREAFTER\":5,\"N_OF_K\":3,\"PUB_KEY\":0}},\"CardanoPoolMetadataType\":{\"fields\":{\"hash\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"},\"url\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"}}},\"CardanoPoolOwner\":{\"fields\":{\"staking_key_hash\":{\"id\":2,\"type\":\"bytes\"},\"staking_key_path\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"}}},\"CardanoPoolParametersType\":{\"fields\":{\"cost\":{\"id\":4,\"rule\":\"required\",\"type\":\"uint64\"},\"margin_denominator\":{\"id\":6,\"rule\":\"required\",\"type\":\"uint64\"},\"margin_numerator\":{\"id\":5,\"rule\":\"required\",\"type\":\"uint64\"},\"metadata\":{\"id\":10,\"type\":\"CardanoPoolMetadataType\"},\"owners_count\":{\"id\":11,\"rule\":\"required\",\"type\":\"uint32\"},\"pledge\":{\"id\":3,\"rule\":\"required\",\"type\":\"uint64\"},\"pool_id\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"},\"relays_count\":{\"id\":12,\"rule\":\"required\",\"type\":\"uint32\"},\"reward_account\":{\"id\":7,\"rule\":\"required\",\"type\":\"string\"},\"vrf_key_hash\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"CardanoPoolRelayParameters\":{\"fields\":{\"host_name\":{\"id\":4,\"type\":\"string\"},\"ipv4_address\":{\"id\":2,\"type\":\"bytes\"},\"ipv6_address\":{\"id\":3,\"type\":\"bytes\"},\"port\":{\"id\":5,\"type\":\"uint32\"},\"type\":{\"id\":1,\"rule\":\"required\",\"type\":\"CardanoPoolRelayType\"}}},\"CardanoPoolRelayType\":{\"values\":{\"MULTIPLE_HOST_NAME\":2,\"SINGLE_HOST_IP\":0,\"SINGLE_HOST_NAME\":1}},\"CardanoPublicKey\":{\"fields\":{\"node\":{\"id\":2,\"rule\":\"required\",\"type\":\"HDNodeType\"},\"xpub\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"}}},\"CardanoSignMessage\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"address_type\":{\"id\":5,\"type\":\"CardanoAddressType\"},\"derivation_type\":{\"id\":3,\"rule\":\"required\",\"type\":\"CardanoDerivationType\"},\"message\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"},\"network_id\":{\"id\":4,\"rule\":\"required\",\"type\":\"uint32\"},\"protocol_magic\":{\"id\":6,\"type\":\"uint32\"}}},\"CardanoSignTxFinished\":{\"fields\":{}},\"CardanoSignTxInit\":{\"fields\":{\"certificates_count\":{\"id\":8,\"rule\":\"required\",\"type\":\"uint32\"},\"chunkify\":{\"id\":22,\"type\":\"bool\"},\"collateral_inputs_count\":{\"id\":17,\"rule\":\"required\",\"type\":\"uint32\"},\"derivation_type\":{\"id\":14,\"rule\":\"required\",\"type\":\"CardanoDerivationType\"},\"fee\":{\"id\":6,\"rule\":\"required\",\"type\":\"uint64\"},\"has_auxiliary_data\":{\"id\":10,\"rule\":\"required\",\"type\":\"bool\"},\"has_collateral_return\":{\"id\":19,\"options\":{\"default\":false},\"type\":\"bool\"},\"include_network_id\":{\"id\":15,\"options\":{\"default\":false},\"type\":\"bool\"},\"inputs_count\":{\"id\":4,\"rule\":\"required\",\"type\":\"uint32\"},\"minting_asset_groups_count\":{\"id\":13,\"rule\":\"required\",\"type\":\"uint32\"},\"network_id\":{\"id\":3,\"rule\":\"required\",\"type\":\"uint32\"},\"outputs_count\":{\"id\":5,\"rule\":\"required\",\"type\":\"uint32\"},\"protocol_magic\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint32\"},\"reference_inputs_count\":{\"id\":21,\"options\":{\"default\":0},\"type\":\"uint32\"},\"required_signers_count\":{\"id\":18,\"rule\":\"required\",\"type\":\"uint32\"},\"script_data_hash\":{\"id\":16,\"type\":\"bytes\"},\"signing_mode\":{\"id\":1,\"rule\":\"required\",\"type\":\"CardanoTxSigningMode\"},\"tag_cbor_sets\":{\"id\":23,\"options\":{\"default\":false},\"type\":\"bool\"},\"total_collateral\":{\"id\":20,\"type\":\"uint64\"},\"ttl\":{\"id\":7,\"type\":\"uint64\"},\"validity_interval_start\":{\"id\":11,\"type\":\"uint64\"},\"withdrawals_count\":{\"id\":9,\"rule\":\"required\",\"type\":\"uint32\"},\"witness_requests_count\":{\"id\":12,\"rule\":\"required\",\"type\":\"uint32\"}}},\"CardanoToken\":{\"fields\":{\"amount\":{\"id\":2,\"type\":\"uint64\"},\"asset_name_bytes\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"},\"mint_amount\":{\"id\":3,\"type\":\"sint64\"}}},\"CardanoTxAuxiliaryData\":{\"fields\":{\"cvote_registration_parameters\":{\"id\":1,\"type\":\"CardanoCVoteRegistrationParametersType\"},\"hash\":{\"id\":2,\"type\":\"bytes\"}}},\"CardanoTxAuxiliaryDataSupplement\":{\"fields\":{\"auxiliary_data_hash\":{\"id\":2,\"type\":\"bytes\"},\"cvote_registration_signature\":{\"id\":3,\"type\":\"bytes\"},\"type\":{\"id\":1,\"rule\":\"required\",\"type\":\"CardanoTxAuxiliaryDataSupplementType\"}}},\"CardanoTxAuxiliaryDataSupplementType\":{\"values\":{\"CVOTE_REGISTRATION_SIGNATURE\":1,\"NONE\":0}},\"CardanoTxBodyHash\":{\"fields\":{\"tx_hash\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"CardanoTxCertificate\":{\"fields\":{\"deposit\":{\"id\":7,\"type\":\"uint64\"},\"drep\":{\"id\":8,\"type\":\"CardanoDRep\"},\"key_hash\":{\"id\":6,\"type\":\"bytes\"},\"path\":{\"id\":2,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"pool\":{\"id\":3,\"type\":\"bytes\"},\"pool_parameters\":{\"id\":4,\"type\":\"CardanoPoolParametersType\"},\"script_hash\":{\"id\":5,\"type\":\"bytes\"},\"type\":{\"id\":1,\"rule\":\"required\",\"type\":\"CardanoCertificateType\"}}},\"CardanoTxCollateralInput\":{\"fields\":{\"prev_hash\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"},\"prev_index\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint32\"}}},\"CardanoTxHostAck\":{\"fields\":{}},\"CardanoTxInlineDatumChunk\":{\"fields\":{\"data\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"CardanoTxInput\":{\"fields\":{\"prev_hash\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"},\"prev_index\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint32\"}}},\"CardanoTxItemAck\":{\"fields\":{}},\"CardanoTxMint\":{\"fields\":{\"asset_groups_count\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint32\"}}},\"CardanoTxOutput\":{\"fields\":{\"address\":{\"id\":1,\"type\":\"string\"},\"address_parameters\":{\"id\":2,\"type\":\"CardanoAddressParametersType\"},\"amount\":{\"id\":3,\"rule\":\"required\",\"type\":\"uint64\"},\"asset_groups_count\":{\"id\":4,\"rule\":\"required\",\"type\":\"uint32\"},\"datum_hash\":{\"id\":5,\"type\":\"bytes\"},\"format\":{\"id\":6,\"options\":{\"default\":\"ARRAY_LEGACY\"},\"type\":\"CardanoTxOutputSerializationFormat\"},\"inline_datum_size\":{\"id\":7,\"options\":{\"default\":0},\"type\":\"uint32\"},\"reference_script_size\":{\"id\":8,\"options\":{\"default\":0},\"type\":\"uint32\"}}},\"CardanoTxOutputSerializationFormat\":{\"values\":{\"ARRAY_LEGACY\":0,\"MAP_BABBAGE\":1}},\"CardanoTxReferenceInput\":{\"fields\":{\"prev_hash\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"},\"prev_index\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint32\"}}},\"CardanoTxReferenceScriptChunk\":{\"fields\":{\"data\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"CardanoTxRequiredSigner\":{\"fields\":{\"key_hash\":{\"id\":1,\"type\":\"bytes\"},\"key_path\":{\"id\":2,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"}}},\"CardanoTxSigningMode\":{\"values\":{\"MULTISIG_TRANSACTION\":2,\"ORDINARY_TRANSACTION\":0,\"PLUTUS_TRANSACTION\":3,\"POOL_REGISTRATION_AS_OWNER\":1}},\"CardanoTxWithdrawal\":{\"fields\":{\"amount\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint64\"},\"key_hash\":{\"id\":4,\"type\":\"bytes\"},\"path\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"script_hash\":{\"id\":3,\"type\":\"bytes\"}}},\"CardanoTxWitnessRequest\":{\"fields\":{\"path\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"}}},\"CardanoTxWitnessResponse\":{\"fields\":{\"chain_code\":{\"id\":4,\"type\":\"bytes\"},\"pub_key\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"},\"signature\":{\"id\":3,\"rule\":\"required\",\"type\":\"bytes\"},\"type\":{\"id\":1,\"rule\":\"required\",\"type\":\"CardanoTxWitnessType\"}}},\"CardanoTxWitnessType\":{\"values\":{\"BYRON_WITNESS\":0,\"SHELLEY_WITNESS\":1}},\"ChangePin\":{\"fields\":{\"remove\":{\"id\":1,\"type\":\"bool\"}}},\"ChangeWipeCode\":{\"fields\":{\"remove\":{\"id\":1,\"type\":\"bool\"}}},\"CipherKeyValue\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"ask_on_decrypt\":{\"id\":6,\"type\":\"bool\"},\"ask_on_encrypt\":{\"id\":5,\"type\":\"bool\"},\"encrypt\":{\"id\":4,\"type\":\"bool\"},\"iv\":{\"id\":7,\"type\":\"bytes\"},\"key\":{\"id\":2,\"rule\":\"required\",\"type\":\"string\"},\"value\":{\"id\":3,\"rule\":\"required\",\"type\":\"bytes\"}}},\"CipheredKeyValue\":{\"fields\":{\"value\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"CommandFlags\":{\"values\":{\"Default\":0,\"Factory_Only\":1}},\"ConfluxAddress\":{\"fields\":{\"address\":{\"id\":1,\"type\":\"string\"}}},\"ConfluxGetAddress\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"chain_id\":{\"id\":3,\"type\":\"uint32\"},\"show_display\":{\"id\":2,\"type\":\"bool\"}}},\"ConfluxMessageSignature\":{\"fields\":{\"address\":{\"id\":3,\"type\":\"string\"},\"signature\":{\"id\":2,\"type\":\"bytes\"}}},\"ConfluxSignMessage\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"message\":{\"id\":2,\"type\":\"bytes\"}}},\"ConfluxSignMessageCIP23\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"domain_hash\":{\"id\":2,\"type\":\"bytes\"},\"message_hash\":{\"id\":3,\"type\":\"bytes\"}}},\"ConfluxSignTx\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"chain_id\":{\"id\":11,\"type\":\"uint32\"},\"data_initial_chunk\":{\"id\":9,\"type\":\"bytes\"},\"data_length\":{\"id\":10,\"type\":\"uint32\"},\"epoch_height\":{\"id\":7,\"type\":\"bytes\"},\"gas_limit\":{\"id\":4,\"type\":\"bytes\"},\"gas_price\":{\"id\":3,\"type\":\"bytes\"},\"nonce\":{\"id\":2,\"type\":\"bytes\"},\"storage_limit\":{\"id\":8,\"type\":\"bytes\"},\"to\":{\"id\":5,\"type\":\"string\"},\"value\":{\"id\":6,\"type\":\"bytes\"}}},\"ConfluxTxAck\":{\"fields\":{\"data_chunk\":{\"id\":1,\"type\":\"bytes\"}}},\"ConfluxTxRequest\":{\"fields\":{\"data_length\":{\"id\":1,\"type\":\"uint32\"},\"signature_r\":{\"id\":3,\"type\":\"bytes\"},\"signature_s\":{\"id\":4,\"type\":\"bytes\"},\"signature_v\":{\"id\":2,\"type\":\"uint32\"}}},\"CosiCommit\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"data\":{\"id\":2,\"type\":\"bytes\"}}},\"CosiCommitment\":{\"fields\":{\"commitment\":{\"id\":1,\"type\":\"bytes\"},\"pubkey\":{\"id\":2,\"type\":\"bytes\"}}},\"CosiSign\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"data\":{\"id\":2,\"type\":\"bytes\"},\"global_commitment\":{\"id\":3,\"type\":\"bytes\"},\"global_pubkey\":{\"id\":4,\"type\":\"bytes\"}}},\"CosiSignature\":{\"fields\":{\"signature\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"CosmosAddress\":{\"fields\":{\"address\":{\"id\":1,\"type\":\"string\"}}},\"CosmosGetAddress\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"hrp\":{\"id\":2,\"type\":\"string\"},\"show_display\":{\"id\":3,\"type\":\"bool\"}}},\"CosmosSignTx\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"raw_tx\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"CosmosSignedTx\":{\"fields\":{\"signature\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"DebugLinkDecision\":{\"fields\":{\"hold_ms\":{\"id\":7,\"type\":\"uint32\"},\"input\":{\"id\":3,\"type\":\"string\"},\"swipe\":{\"id\":2,\"type\":\"DebugSwipeDirection\"},\"wait\":{\"id\":6,\"type\":\"bool\"},\"x\":{\"id\":4,\"type\":\"uint32\"},\"y\":{\"id\":5,\"type\":\"uint32\"},\"yes_no\":{\"id\":1,\"type\":\"bool\"}},\"nested\":{\"DebugSwipeDirection\":{\"values\":{\"DOWN\":1,\"LEFT\":2,\"RIGHT\":3,\"UP\":0}}}},\"DebugLinkEraseSdCard\":{\"fields\":{\"format\":{\"id\":1,\"type\":\"bool\"}}},\"DebugLinkFlashErase\":{\"fields\":{\"sector\":{\"id\":1,\"type\":\"uint32\"}}},\"DebugLinkGetState\":{\"fields\":{\"wait_layout\":{\"id\":3,\"type\":\"bool\"},\"wait_word_list\":{\"id\":1,\"type\":\"bool\"},\"wait_word_pos\":{\"id\":2,\"type\":\"bool\"}}},\"DebugLinkLayout\":{\"fields\":{\"lines\":{\"id\":1,\"rule\":\"repeated\",\"type\":\"string\"}}},\"DebugLinkLog\":{\"fields\":{\"bucket\":{\"id\":2,\"type\":\"string\"},\"level\":{\"id\":1,\"type\":\"uint32\"},\"text\":{\"id\":3,\"type\":\"string\"}}},\"DebugLinkMemory\":{\"fields\":{\"memory\":{\"id\":1,\"type\":\"bytes\"}}},\"DebugLinkMemoryRead\":{\"fields\":{\"address\":{\"id\":1,\"type\":\"uint32\"},\"length\":{\"id\":2,\"type\":\"uint32\"}}},\"DebugLinkMemoryWrite\":{\"fields\":{\"address\":{\"id\":1,\"type\":\"uint32\"},\"flash\":{\"id\":3,\"type\":\"bool\"},\"memory\":{\"id\":2,\"type\":\"bytes\"}}},\"DebugLinkRecordScreen\":{\"fields\":{\"target_directory\":{\"id\":1,\"type\":\"string\"}}},\"DebugLinkReseedRandom\":{\"fields\":{\"value\":{\"id\":1,\"type\":\"uint32\"}}},\"DebugLinkState\":{\"fields\":{\"layout\":{\"id\":1,\"type\":\"bytes\"},\"layout_lines\":{\"id\":13,\"rule\":\"repeated\",\"type\":\"string\"},\"matrix\":{\"id\":3,\"type\":\"string\"},\"mnemonic_secret\":{\"id\":4,\"type\":\"bytes\"},\"mnemonic_type\":{\"id\":12,\"type\":\"BackupType\"},\"node\":{\"id\":5,\"type\":\"HDNodeType\"},\"passphrase_protection\":{\"id\":6,\"type\":\"bool\"},\"pin\":{\"id\":2,\"type\":\"string\"},\"recovery_fake_word\":{\"id\":9,\"type\":\"string\"},\"recovery_word_pos\":{\"id\":10,\"type\":\"uint32\"},\"reset_entropy\":{\"id\":8,\"type\":\"bytes\"},\"reset_word\":{\"id\":7,\"type\":\"string\"},\"reset_word_pos\":{\"id\":11,\"type\":\"uint32\"}}},\"DebugLinkStop\":{\"fields\":{}},\"DebugLinkWatchLayout\":{\"fields\":{\"watch\":{\"id\":1,\"type\":\"bool\"}}},\"DebugMoneroDiagAck\":{\"fields\":{\"data1\":{\"id\":5,\"type\":\"bytes\"},\"data2\":{\"id\":6,\"type\":\"bytes\"},\"ins\":{\"id\":1,\"type\":\"uint64\"},\"p1\":{\"id\":2,\"type\":\"uint64\"},\"p2\":{\"id\":3,\"type\":\"uint64\"},\"pd\":{\"id\":4,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint64\"}}},\"DebugMoneroDiagRequest\":{\"fields\":{\"data1\":{\"id\":5,\"type\":\"bytes\"},\"data2\":{\"id\":6,\"type\":\"bytes\"},\"ins\":{\"id\":1,\"type\":\"uint64\"},\"p1\":{\"id\":2,\"type\":\"uint64\"},\"p2\":{\"id\":3,\"type\":\"uint64\"},\"pd\":{\"id\":4,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint64\"}}},\"DecredStakingSpendType\":{\"values\":{\"SSGen\":0,\"SSRTX\":1}},\"Deprecated_PassphraseStateAck\":{\"fields\":{},\"options\":{\"deprecated\":true}},\"Deprecated_PassphraseStateRequest\":{\"fields\":{\"state\":{\"id\":1,\"type\":\"bytes\"}},\"options\":{\"deprecated\":true}},\"DeviceBackToBoot\":{\"fields\":{}},\"DeviceEraseSector\":{\"fields\":{\"sector\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint32\"}}},\"DeviceInfo\":{\"fields\":{\"NFT_voucher\":{\"id\":4,\"type\":\"bytes\"},\"SE_info\":{\"id\":3,\"type\":\"string\"},\"cpu_info\":{\"id\":5,\"type\":\"string\"},\"pre_firmware\":{\"id\":6,\"type\":\"string\"},\"serial_no\":{\"id\":1,\"type\":\"string\"},\"spiFlash_info\":{\"id\":2,\"type\":\"string\"}}},\"DeviceInfoSettings\":{\"fields\":{\"cpu_info\":{\"id\":2,\"type\":\"string\"},\"pre_firmware\":{\"id\":3,\"type\":\"string\"},\"serial_no\":{\"id\":1,\"type\":\"string\"}}},\"DnxAddress\":{\"fields\":{\"address\":{\"id\":1,\"type\":\"string\"}}},\"DnxGetAddress\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"show_display\":{\"id\":2,\"type\":\"bool\"}}},\"DnxInputAck\":{\"fields\":{\"amount\":{\"id\":5,\"rule\":\"required\",\"type\":\"uint64\"},\"global_index\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint32\"},\"prev_index\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint32\"},\"prev_out_pubkey\":{\"id\":4,\"rule\":\"required\",\"type\":\"bytes\"},\"tx_pubkey\":{\"id\":3,\"rule\":\"required\",\"type\":\"bytes\"}}},\"DnxInputRequest\":{\"fields\":{\"computed_key_image\":{\"id\":3,\"type\":\"DnxComputedKeyImage\"},\"request_index\":{\"id\":1,\"type\":\"uint32\"},\"tx_key\":{\"id\":2,\"type\":\"DnxTxKey\"}},\"nested\":{\"DnxComputedKeyImage\":{\"fields\":{\"key_image\":{\"id\":1,\"type\":\"bytes\"}}},\"DnxTxKey\":{\"fields\":{\"ephemeral_tx_pub_key\":{\"id\":2,\"type\":\"bytes\"},\"ephemeral_tx_sec_key\":{\"id\":1,\"type\":\"bytes\"}}}}},\"DnxRTSigsRequest\":{\"fields\":{}},\"DnxSignTx\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"amount\":{\"id\":4,\"rule\":\"required\",\"type\":\"uint64\"},\"fee\":{\"id\":5,\"rule\":\"required\",\"type\":\"uint64\"},\"inputs_count\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint32\"},\"payment_id\":{\"id\":6,\"type\":\"bytes\"},\"to_address\":{\"id\":3,\"rule\":\"required\",\"type\":\"string\"}}},\"DnxSignedTx\":{\"fields\":{\"output_keys\":{\"id\":2,\"rule\":\"repeated\",\"type\":\"bytes\"},\"signatures\":{\"id\":1,\"rule\":\"repeated\",\"type\":\"bytes\"}}},\"DoPreauthorized\":{\"fields\":{}},\"ECDHSessionKey\":{\"fields\":{\"public_key\":{\"id\":2,\"type\":\"bytes\"},\"session_key\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"EcdsaPublicKeys\":{\"fields\":{\"hd_nodes\":{\"id\":2,\"rule\":\"repeated\",\"type\":\"HDNodeType\"},\"public_keys\":{\"id\":1,\"rule\":\"repeated\",\"type\":\"bytes\"},\"root_fingerprint\":{\"id\":3,\"type\":\"uint32\"}}},\"EmmcDir\":{\"fields\":{\"child_dirs\":{\"id\":2,\"type\":\"string\"},\"child_files\":{\"id\":3,\"type\":\"string\"},\"path\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"}}},\"EmmcDirList\":{\"fields\":{\"path\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"}}},\"EmmcDirMake\":{\"fields\":{\"path\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"}}},\"EmmcDirRemove\":{\"fields\":{\"path\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"}}},\"EmmcFile\":{\"fields\":{\"data\":{\"id\":4,\"type\":\"bytes\"},\"data_hash\":{\"id\":5,\"type\":\"uint32\"},\"len\":{\"id\":3,\"rule\":\"required\",\"type\":\"uint32\"},\"offset\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint32\"},\"path\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"},\"processed_byte\":{\"id\":6,\"type\":\"uint32\"}}},\"EmmcFileDelete\":{\"fields\":{\"path\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"}}},\"EmmcFileRead\":{\"fields\":{\"file\":{\"id\":1,\"rule\":\"required\",\"type\":\"EmmcFile\"},\"ui_percentage\":{\"id\":2,\"type\":\"uint32\"}}},\"EmmcFileWrite\":{\"fields\":{\"append\":{\"id\":3,\"rule\":\"required\",\"type\":\"bool\"},\"file\":{\"id\":1,\"rule\":\"required\",\"type\":\"EmmcFile\"},\"overwrite\":{\"id\":2,\"rule\":\"required\",\"type\":\"bool\"},\"ui_percentage\":{\"id\":4,\"type\":\"uint32\"}}},\"EmmcFixPermission\":{\"fields\":{}},\"EmmcPath\":{\"fields\":{\"archive\":{\"id\":12,\"rule\":\"required\",\"type\":\"bool\"},\"day\":{\"id\":5,\"rule\":\"required\",\"type\":\"uint32\"},\"directory\":{\"id\":13,\"rule\":\"required\",\"type\":\"bool\"},\"exist\":{\"id\":1,\"rule\":\"required\",\"type\":\"bool\"},\"hidden\":{\"id\":10,\"rule\":\"required\",\"type\":\"bool\"},\"hour\":{\"id\":6,\"rule\":\"required\",\"type\":\"uint32\"},\"minute\":{\"id\":7,\"rule\":\"required\",\"type\":\"uint32\"},\"month\":{\"id\":4,\"rule\":\"required\",\"type\":\"uint32\"},\"readonly\":{\"id\":9,\"rule\":\"required\",\"type\":\"bool\"},\"second\":{\"id\":8,\"rule\":\"required\",\"type\":\"uint32\"},\"size\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint64\"},\"system\":{\"id\":11,\"rule\":\"required\",\"type\":\"bool\"},\"year\":{\"id\":3,\"rule\":\"required\",\"type\":\"uint32\"}}},\"EmmcPathInfo\":{\"fields\":{\"path\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"}}},\"EndSession\":{\"fields\":{}},\"Entropy\":{\"fields\":{\"entropy\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"EntropyAck\":{\"fields\":{\"entropy\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"EntropyRequest\":{\"fields\":{}},\"EosGetPublicKey\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"show_display\":{\"id\":2,\"type\":\"bool\"}}},\"EosPublicKey\":{\"fields\":{\"raw_public_key\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"},\"wif_public_key\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"}}},\"EosSignTx\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"chain_id\":{\"id\":2,\"type\":\"bytes\"},\"header\":{\"id\":3,\"type\":\"EosTxHeader\"},\"num_actions\":{\"id\":4,\"type\":\"uint32\"}},\"nested\":{\"EosTxHeader\":{\"fields\":{\"delay_sec\":{\"id\":6,\"rule\":\"required\",\"type\":\"uint32\"},\"expiration\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint32\"},\"max_cpu_usage_ms\":{\"id\":5,\"rule\":\"required\",\"type\":\"uint32\"},\"max_net_usage_words\":{\"id\":4,\"rule\":\"required\",\"type\":\"uint32\"},\"ref_block_num\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint32\"},\"ref_block_prefix\":{\"id\":3,\"rule\":\"required\",\"type\":\"uint32\"}}}}},\"EosSignedTx\":{\"fields\":{\"signature\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"}}},\"EosTxActionAck\":{\"fields\":{\"buy_ram\":{\"id\":6,\"type\":\"EosActionBuyRam\"},\"buy_ram_bytes\":{\"id\":7,\"type\":\"EosActionBuyRamBytes\"},\"common\":{\"id\":1,\"type\":\"EosActionCommon\"},\"delegate\":{\"id\":3,\"type\":\"EosActionDelegate\"},\"delete_auth\":{\"id\":11,\"type\":\"EosActionDeleteAuth\"},\"link_auth\":{\"id\":12,\"type\":\"EosActionLinkAuth\"},\"new_account\":{\"id\":14,\"type\":\"EosActionNewAccount\"},\"refund\":{\"id\":5,\"type\":\"EosActionRefund\"},\"sell_ram\":{\"id\":8,\"type\":\"EosActionSellRam\"},\"transfer\":{\"id\":2,\"type\":\"EosActionTransfer\"},\"undelegate\":{\"id\":4,\"type\":\"EosActionUndelegate\"},\"unknown\":{\"id\":15,\"type\":\"EosActionUnknown\"},\"unlink_auth\":{\"id\":13,\"type\":\"EosActionUnlinkAuth\"},\"update_auth\":{\"id\":10,\"type\":\"EosActionUpdateAuth\"},\"vote_producer\":{\"id\":9,\"type\":\"EosActionVoteProducer\"}},\"nested\":{\"EosActionBuyRam\":{\"fields\":{\"payer\":{\"id\":1,\"type\":\"uint64\"},\"quantity\":{\"id\":3,\"type\":\"EosAsset\"},\"receiver\":{\"id\":2,\"type\":\"uint64\"}}},\"EosActionBuyRamBytes\":{\"fields\":{\"bytes\":{\"id\":3,\"type\":\"uint32\"},\"payer\":{\"id\":1,\"type\":\"uint64\"},\"receiver\":{\"id\":2,\"type\":\"uint64\"}}},\"EosActionCommon\":{\"fields\":{\"account\":{\"id\":1,\"type\":\"uint64\"},\"authorization\":{\"id\":3,\"rule\":\"repeated\",\"type\":\"EosPermissionLevel\"},\"name\":{\"id\":2,\"type\":\"uint64\"}}},\"EosActionDelegate\":{\"fields\":{\"cpu_quantity\":{\"id\":4,\"type\":\"EosAsset\"},\"net_quantity\":{\"id\":3,\"type\":\"EosAsset\"},\"receiver\":{\"id\":2,\"type\":\"uint64\"},\"sender\":{\"id\":1,\"type\":\"uint64\"},\"transfer\":{\"id\":5,\"type\":\"bool\"}}},\"EosActionDeleteAuth\":{\"fields\":{\"account\":{\"id\":1,\"type\":\"uint64\"},\"permission\":{\"id\":2,\"type\":\"uint64\"}}},\"EosActionLinkAuth\":{\"fields\":{\"account\":{\"id\":1,\"type\":\"uint64\"},\"code\":{\"id\":2,\"type\":\"uint64\"},\"requirement\":{\"id\":4,\"type\":\"uint64\"},\"type\":{\"id\":3,\"type\":\"uint64\"}}},\"EosActionNewAccount\":{\"fields\":{\"active\":{\"id\":4,\"type\":\"EosAuthorization\"},\"creator\":{\"id\":1,\"type\":\"uint64\"},\"name\":{\"id\":2,\"type\":\"uint64\"},\"owner\":{\"id\":3,\"type\":\"EosAuthorization\"}}},\"EosActionRefund\":{\"fields\":{\"owner\":{\"id\":1,\"type\":\"uint64\"}}},\"EosActionSellRam\":{\"fields\":{\"account\":{\"id\":1,\"type\":\"uint64\"},\"bytes\":{\"id\":2,\"type\":\"uint64\"}}},\"EosActionTransfer\":{\"fields\":{\"memo\":{\"id\":4,\"type\":\"string\"},\"quantity\":{\"id\":3,\"type\":\"EosAsset\"},\"receiver\":{\"id\":2,\"type\":\"uint64\"},\"sender\":{\"id\":1,\"type\":\"uint64\"}}},\"EosActionUndelegate\":{\"fields\":{\"cpu_quantity\":{\"id\":4,\"type\":\"EosAsset\"},\"net_quantity\":{\"id\":3,\"type\":\"EosAsset\"},\"receiver\":{\"id\":2,\"type\":\"uint64\"},\"sender\":{\"id\":1,\"type\":\"uint64\"}}},\"EosActionUnknown\":{\"fields\":{\"data_chunk\":{\"id\":2,\"type\":\"bytes\"},\"data_size\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint32\"}}},\"EosActionUnlinkAuth\":{\"fields\":{\"account\":{\"id\":1,\"type\":\"uint64\"},\"code\":{\"id\":2,\"type\":\"uint64\"},\"type\":{\"id\":3,\"type\":\"uint64\"}}},\"EosActionUpdateAuth\":{\"fields\":{\"account\":{\"id\":1,\"type\":\"uint64\"},\"auth\":{\"id\":4,\"type\":\"EosAuthorization\"},\"parent\":{\"id\":3,\"type\":\"uint64\"},\"permission\":{\"id\":2,\"type\":\"uint64\"}}},\"EosActionVoteProducer\":{\"fields\":{\"producers\":{\"id\":3,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint64\"},\"proxy\":{\"id\":2,\"type\":\"uint64\"},\"voter\":{\"id\":1,\"type\":\"uint64\"}}},\"EosAsset\":{\"fields\":{\"amount\":{\"id\":1,\"type\":\"sint64\"},\"symbol\":{\"id\":2,\"type\":\"uint64\"}}},\"EosAuthorization\":{\"fields\":{\"accounts\":{\"id\":3,\"rule\":\"repeated\",\"type\":\"EosAuthorizationAccount\"},\"keys\":{\"id\":2,\"rule\":\"repeated\",\"type\":\"EosAuthorizationKey\"},\"threshold\":{\"id\":1,\"type\":\"uint32\"},\"waits\":{\"id\":4,\"rule\":\"repeated\",\"type\":\"EosAuthorizationWait\"}}},\"EosAuthorizationAccount\":{\"fields\":{\"account\":{\"id\":1,\"type\":\"EosPermissionLevel\"},\"weight\":{\"id\":2,\"type\":\"uint32\"}}},\"EosAuthorizationKey\":{\"fields\":{\"address_n\":{\"id\":3,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"key\":{\"id\":2,\"type\":\"bytes\"},\"type\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint32\"},\"weight\":{\"id\":4,\"rule\":\"required\",\"type\":\"uint32\"}}},\"EosAuthorizationWait\":{\"fields\":{\"wait_sec\":{\"id\":1,\"type\":\"uint32\"},\"weight\":{\"id\":2,\"type\":\"uint32\"}}},\"EosPermissionLevel\":{\"fields\":{\"actor\":{\"id\":1,\"type\":\"uint64\"},\"permission\":{\"id\":2,\"type\":\"uint64\"}}}}},\"EosTxActionRequest\":{\"fields\":{\"data_size\":{\"id\":1,\"type\":\"uint32\"}}},\"EthereumAccessListOneKey\":{\"fields\":{\"address\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"},\"storage_keys\":{\"id\":2,\"rule\":\"repeated\",\"type\":\"bytes\"}}},\"EthereumAddress\":{\"fields\":{\"_old_address\":{\"id\":1,\"options\":{\"deprecated\":true},\"type\":\"bytes\"},\"address\":{\"id\":2,\"type\":\"string\"}}},\"EthereumAddressOneKey\":{\"fields\":{\"_old_address\":{\"id\":1,\"options\":{\"deprecated\":true},\"type\":\"bytes\"},\"address\":{\"id\":2,\"type\":\"string\"}}},\"EthereumAuthorizationSignature\":{\"fields\":{\"r\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"},\"s\":{\"id\":3,\"rule\":\"required\",\"type\":\"bytes\"},\"y_parity\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint32\"}}},\"EthereumDefinitionType\":{\"values\":{\"NETWORK\":0,\"TOKEN\":1}},\"EthereumDefinitions\":{\"fields\":{\"encoded_network\":{\"id\":1,\"type\":\"bytes\"},\"encoded_token\":{\"id\":2,\"type\":\"bytes\"}}},\"EthereumGetAddress\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"encoded_network\":{\"id\":3,\"type\":\"bytes\"},\"show_display\":{\"id\":2,\"type\":\"bool\"}}},\"EthereumGetAddressOneKey\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"chain_id\":{\"id\":3,\"type\":\"uint64\"},\"show_display\":{\"id\":2,\"type\":\"bool\"}}},\"EthereumGetPublicKey\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"show_display\":{\"id\":2,\"type\":\"bool\"}}},\"EthereumGetPublicKeyOneKey\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"chain_id\":{\"id\":3,\"type\":\"uint64\"},\"show_display\":{\"id\":2,\"type\":\"bool\"}}},\"EthereumGnosisSafeTxAck\":{\"fields\":{\"baseGas\":{\"id\":6,\"rule\":\"required\",\"type\":\"bytes\"},\"chain_id\":{\"id\":11,\"rule\":\"required\",\"type\":\"uint64\"},\"data\":{\"id\":3,\"type\":\"bytes\"},\"gasPrice\":{\"id\":7,\"rule\":\"required\",\"type\":\"bytes\"},\"gasToken\":{\"id\":8,\"rule\":\"required\",\"type\":\"string\"},\"nonce\":{\"id\":10,\"rule\":\"required\",\"type\":\"bytes\"},\"operation\":{\"id\":4,\"rule\":\"required\",\"type\":\"EthereumGnosisSafeTxOperation\"},\"refundReceiver\":{\"id\":9,\"rule\":\"required\",\"type\":\"string\"},\"safeTxGas\":{\"id\":5,\"rule\":\"required\",\"type\":\"bytes\"},\"to\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"},\"value\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"},\"verifyingContract\":{\"id\":12,\"rule\":\"required\",\"type\":\"string\"}}},\"EthereumGnosisSafeTxOperation\":{\"values\":{\"CALL\":0,\"DELEGATE_CALL\":1}},\"EthereumGnosisSafeTxRequest\":{\"fields\":{}},\"EthereumMessageSignature\":{\"fields\":{\"address\":{\"id\":3,\"rule\":\"required\",\"type\":\"string\"},\"signature\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"EthereumMessageSignatureOneKey\":{\"fields\":{\"address\":{\"id\":3,\"rule\":\"required\",\"type\":\"string\"},\"signature\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"EthereumNetworkInfo\":{\"fields\":{\"chain_id\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint64\"},\"icon\":{\"id\":101,\"type\":\"string\"},\"name\":{\"id\":4,\"rule\":\"required\",\"type\":\"string\"},\"primary_color\":{\"id\":102,\"type\":\"uint64\"},\"slip44\":{\"id\":3,\"rule\":\"required\",\"type\":\"uint32\"},\"symbol\":{\"id\":2,\"rule\":\"required\",\"type\":\"string\"}}},\"EthereumPublicKey\":{\"fields\":{\"node\":{\"id\":1,\"rule\":\"required\",\"type\":\"HDNodeType\"},\"xpub\":{\"id\":2,\"rule\":\"required\",\"type\":\"string\"}}},\"EthereumPublicKeyOneKey\":{\"fields\":{\"node\":{\"id\":1,\"rule\":\"required\",\"type\":\"HDNodeType\"},\"xpub\":{\"id\":2,\"rule\":\"required\",\"type\":\"string\"}}},\"EthereumSignMessage\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"encoded_network\":{\"id\":3,\"type\":\"bytes\"},\"message\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"EthereumSignMessageEIP712\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"domain_hash\":{\"id\":2,\"type\":\"bytes\"},\"message_hash\":{\"id\":3,\"type\":\"bytes\"}}},\"EthereumSignMessageOneKey\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"chain_id\":{\"id\":3,\"type\":\"uint64\"},\"message\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"EthereumSignTx\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"chain_id\":{\"id\":9,\"rule\":\"required\",\"type\":\"uint64\"},\"data_initial_chunk\":{\"id\":7,\"options\":{\"default\":\"\"},\"type\":\"bytes\"},\"data_length\":{\"id\":8,\"options\":{\"default\":0},\"type\":\"uint32\"},\"definitions\":{\"id\":12,\"type\":\"EthereumDefinitions\"},\"gas_limit\":{\"id\":4,\"rule\":\"required\",\"type\":\"bytes\"},\"gas_price\":{\"id\":3,\"rule\":\"required\",\"type\":\"bytes\"},\"nonce\":{\"id\":2,\"options\":{\"default\":\"\"},\"type\":\"bytes\"},\"to\":{\"id\":11,\"options\":{\"default\":\"\"},\"type\":\"string\"},\"tx_type\":{\"id\":10,\"type\":\"uint32\"},\"value\":{\"id\":6,\"options\":{\"default\":\"\"},\"type\":\"bytes\"}}},\"EthereumSignTxEIP1559\":{\"fields\":{\"access_list\":{\"id\":11,\"rule\":\"repeated\",\"type\":\"EthereumAccessList\"},\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"chain_id\":{\"id\":10,\"rule\":\"required\",\"type\":\"uint64\"},\"data_initial_chunk\":{\"id\":8,\"options\":{\"default\":\"\"},\"type\":\"bytes\"},\"data_length\":{\"id\":9,\"rule\":\"required\",\"type\":\"uint32\"},\"definitions\":{\"id\":12,\"type\":\"EthereumDefinitions\"},\"gas_limit\":{\"id\":5,\"rule\":\"required\",\"type\":\"bytes\"},\"max_gas_fee\":{\"id\":3,\"rule\":\"required\",\"type\":\"bytes\"},\"max_priority_fee\":{\"id\":4,\"rule\":\"required\",\"type\":\"bytes\"},\"nonce\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"},\"to\":{\"id\":6,\"options\":{\"default\":\"\"},\"type\":\"string\"},\"value\":{\"id\":7,\"rule\":\"required\",\"type\":\"bytes\"}},\"nested\":{\"EthereumAccessList\":{\"fields\":{\"address\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"},\"storage_keys\":{\"id\":2,\"rule\":\"repeated\",\"type\":\"bytes\"}}}}},\"EthereumSignTxEIP1559OneKey\":{\"fields\":{\"access_list\":{\"id\":11,\"rule\":\"repeated\",\"type\":\"EthereumAccessListOneKey\"},\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"chain_id\":{\"id\":10,\"rule\":\"required\",\"type\":\"uint64\"},\"data_initial_chunk\":{\"id\":8,\"options\":{\"default\":\"\"},\"type\":\"bytes\"},\"data_length\":{\"id\":9,\"rule\":\"required\",\"type\":\"uint32\"},\"gas_limit\":{\"id\":5,\"rule\":\"required\",\"type\":\"bytes\"},\"max_gas_fee\":{\"id\":3,\"rule\":\"required\",\"type\":\"bytes\"},\"max_priority_fee\":{\"id\":4,\"rule\":\"required\",\"type\":\"bytes\"},\"nonce\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"},\"to\":{\"id\":6,\"options\":{\"default\":\"\"},\"type\":\"string\"},\"value\":{\"id\":7,\"rule\":\"required\",\"type\":\"bytes\"}}},\"EthereumSignTxEIP7702OneKey\":{\"fields\":{\"access_list\":{\"id\":11,\"rule\":\"repeated\",\"type\":\"EthereumAccessListOneKey\"},\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"authorization_list\":{\"id\":12,\"rule\":\"repeated\",\"type\":\"EthereumAuthorizationOneKey\"},\"chain_id\":{\"id\":10,\"rule\":\"required\",\"type\":\"uint64\"},\"data_initial_chunk\":{\"id\":8,\"options\":{\"default\":\"\"},\"type\":\"bytes\"},\"data_length\":{\"id\":9,\"rule\":\"required\",\"type\":\"uint32\"},\"gas_limit\":{\"id\":5,\"rule\":\"required\",\"type\":\"bytes\"},\"max_gas_fee\":{\"id\":3,\"rule\":\"required\",\"type\":\"bytes\"},\"max_priority_fee\":{\"id\":4,\"rule\":\"required\",\"type\":\"bytes\"},\"nonce\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"},\"to\":{\"id\":6,\"rule\":\"required\",\"type\":\"string\"},\"value\":{\"id\":7,\"rule\":\"required\",\"type\":\"bytes\"}},\"nested\":{\"EthereumAuthorizationOneKey\":{\"fields\":{\"address\":{\"id\":3,\"rule\":\"required\",\"type\":\"string\"},\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"chain_id\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint64\"},\"nonce\":{\"id\":4,\"rule\":\"required\",\"type\":\"bytes\"},\"signature\":{\"id\":5,\"type\":\"EthereumAuthorizationSignature\"}}}}},\"EthereumSignTxOneKey\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"chain_id\":{\"id\":9,\"rule\":\"required\",\"type\":\"uint64\"},\"data_initial_chunk\":{\"id\":7,\"options\":{\"default\":\"\"},\"type\":\"bytes\"},\"data_length\":{\"id\":8,\"options\":{\"default\":0},\"type\":\"uint32\"},\"gas_limit\":{\"id\":4,\"rule\":\"required\",\"type\":\"bytes\"},\"gas_price\":{\"id\":3,\"rule\":\"required\",\"type\":\"bytes\"},\"nonce\":{\"id\":2,\"options\":{\"default\":\"\"},\"type\":\"bytes\"},\"to\":{\"id\":11,\"options\":{\"default\":\"\"},\"type\":\"string\"},\"tx_type\":{\"id\":10,\"type\":\"uint32\"},\"value\":{\"id\":6,\"options\":{\"default\":\"\"},\"type\":\"bytes\"}}},\"EthereumSignTypedData\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"definitions\":{\"id\":4,\"type\":\"EthereumDefinitions\"},\"metamask_v4_compat\":{\"id\":3,\"options\":{\"default\":true},\"type\":\"bool\"},\"primary_type\":{\"id\":2,\"rule\":\"required\",\"type\":\"string\"}}},\"EthereumSignTypedDataOneKey\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"chain_id\":{\"id\":4,\"type\":\"uint64\"},\"metamask_v4_compat\":{\"id\":3,\"options\":{\"default\":true},\"type\":\"bool\"},\"primary_type\":{\"id\":2,\"rule\":\"required\",\"type\":\"string\"}}},\"EthereumSignTypedHash\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"domain_separator_hash\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"},\"encoded_network\":{\"id\":4,\"type\":\"bytes\"},\"message_hash\":{\"id\":3,\"type\":\"bytes\"}}},\"EthereumSignTypedHashOneKey\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"chain_id\":{\"id\":4,\"type\":\"uint64\"},\"domain_separator_hash\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"},\"message_hash\":{\"id\":3,\"type\":\"bytes\"}}},\"EthereumTokenInfo\":{\"fields\":{\"address\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"},\"chain_id\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint64\"},\"decimals\":{\"id\":4,\"rule\":\"required\",\"type\":\"uint32\"},\"name\":{\"id\":5,\"rule\":\"required\",\"type\":\"string\"},\"symbol\":{\"id\":3,\"rule\":\"required\",\"type\":\"string\"}}},\"EthereumTxAck\":{\"fields\":{\"data_chunk\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"EthereumTxAckOneKey\":{\"fields\":{\"data_chunk\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"EthereumTxRequest\":{\"fields\":{\"data_length\":{\"id\":1,\"type\":\"uint32\"},\"signature_r\":{\"id\":3,\"type\":\"bytes\"},\"signature_s\":{\"id\":4,\"type\":\"bytes\"},\"signature_v\":{\"id\":2,\"type\":\"uint32\"}}},\"EthereumTxRequestOneKey\":{\"fields\":{\"authorization_signatures\":{\"id\":10,\"rule\":\"repeated\",\"type\":\"EthereumAuthorizationSignature\"},\"data_length\":{\"id\":1,\"type\":\"uint32\"},\"signature_r\":{\"id\":3,\"type\":\"bytes\"},\"signature_s\":{\"id\":4,\"type\":\"bytes\"},\"signature_v\":{\"id\":2,\"type\":\"uint32\"}}},\"EthereumTypedDataSignature\":{\"fields\":{\"address\":{\"id\":2,\"rule\":\"required\",\"type\":\"string\"},\"signature\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"EthereumTypedDataSignatureOneKey\":{\"fields\":{\"address\":{\"id\":2,\"rule\":\"required\",\"type\":\"string\"},\"signature\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"EthereumTypedDataStructAck\":{\"fields\":{\"members\":{\"id\":1,\"rule\":\"repeated\",\"type\":\"EthereumStructMember\"}},\"nested\":{\"EthereumDataType\":{\"values\":{\"ADDRESS\":6,\"ARRAY\":7,\"BOOL\":5,\"BYTES\":3,\"INT\":2,\"STRING\":4,\"STRUCT\":8,\"UINT\":1}},\"EthereumFieldType\":{\"fields\":{\"data_type\":{\"id\":1,\"rule\":\"required\",\"type\":\"EthereumDataType\"},\"entry_type\":{\"id\":3,\"type\":\"EthereumFieldType\"},\"size\":{\"id\":2,\"type\":\"uint32\"},\"struct_name\":{\"id\":4,\"type\":\"string\"}}},\"EthereumStructMember\":{\"fields\":{\"name\":{\"id\":2,\"rule\":\"required\",\"type\":\"string\"},\"type\":{\"id\":1,\"rule\":\"required\",\"type\":\"EthereumFieldType\"}}}}},\"EthereumTypedDataStructAckOneKey\":{\"fields\":{\"members\":{\"id\":1,\"rule\":\"repeated\",\"type\":\"EthereumStructMemberOneKey\"}},\"nested\":{\"EthereumDataTypeOneKey\":{\"values\":{\"ADDRESS\":6,\"ARRAY\":7,\"BOOL\":5,\"BYTES\":3,\"INT\":2,\"STRING\":4,\"STRUCT\":8,\"UINT\":1}},\"EthereumFieldTypeOneKey\":{\"fields\":{\"data_type\":{\"id\":1,\"rule\":\"required\",\"type\":\"EthereumDataTypeOneKey\"},\"entry_type\":{\"id\":3,\"type\":\"EthereumFieldTypeOneKey\"},\"size\":{\"id\":2,\"type\":\"uint32\"},\"struct_name\":{\"id\":4,\"type\":\"string\"}}},\"EthereumStructMemberOneKey\":{\"fields\":{\"name\":{\"id\":2,\"rule\":\"required\",\"type\":\"string\"},\"type\":{\"id\":1,\"rule\":\"required\",\"type\":\"EthereumFieldTypeOneKey\"}}}}},\"EthereumTypedDataStructRequest\":{\"fields\":{\"name\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"}}},\"EthereumTypedDataStructRequestOneKey\":{\"fields\":{\"name\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"}}},\"EthereumTypedDataValueAck\":{\"fields\":{\"value\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"EthereumTypedDataValueAckOneKey\":{\"fields\":{\"value\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"EthereumTypedDataValueRequest\":{\"fields\":{\"member_path\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"}}},\"EthereumTypedDataValueRequestOneKey\":{\"fields\":{\"member_path\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"}}},\"EthereumVerifyMessage\":{\"fields\":{\"address\":{\"id\":4,\"rule\":\"required\",\"type\":\"string\"},\"message\":{\"id\":3,\"rule\":\"required\",\"type\":\"bytes\"},\"signature\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"EthereumVerifyMessageOneKey\":{\"fields\":{\"address\":{\"id\":4,\"rule\":\"required\",\"type\":\"string\"},\"chain_id\":{\"id\":5,\"type\":\"uint64\"},\"message\":{\"id\":3,\"rule\":\"required\",\"type\":\"bytes\"},\"signature\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"Failure\":{\"fields\":{\"code\":{\"id\":1,\"type\":\"FailureType\"},\"message\":{\"id\":2,\"type\":\"string\"}},\"nested\":{\"FailureType\":{\"values\":{\"Failure_ActionCancelled\":4,\"Failure_ButtonExpected\":2,\"Failure_DataError\":3,\"Failure_FirmwareError\":99,\"Failure_InvalidSession\":14,\"Failure_InvalidSignature\":8,\"Failure_NotEnoughFunds\":10,\"Failure_NotInitialized\":11,\"Failure_PinCancelled\":6,\"Failure_PinExpected\":5,\"Failure_PinInvalid\":7,\"Failure_PinMismatch\":12,\"Failure_ProcessError\":9,\"Failure_UnexpectedMessage\":1,\"Failure_WipeCodeMismatch\":13}}}},\"Features\":{\"fields\":{\"NFT_voucher\":{\"id\":514,\"type\":\"bytes\"},\"_passphrase_cached\":{\"id\":17,\"options\":{\"deprecated\":true},\"type\":\"bool\"},\"attach_to_pin_user\":{\"id\":625,\"type\":\"bool\"},\"auto_lock_delay_ms\":{\"id\":38,\"type\":\"uint32\"},\"auto_shutdown_delay_ms\":{\"id\":524,\"type\":\"uint32\"},\"backup_only\":{\"id\":507,\"type\":\"bool\"},\"backup_type\":{\"id\":31,\"type\":\"BackupType\"},\"battery_level\":{\"id\":520,\"type\":\"uint32\"},\"ble_enable\":{\"id\":503,\"type\":\"bool\"},\"ble_name\":{\"id\":501,\"type\":\"string\"},\"ble_ver\":{\"id\":502,\"type\":\"string\"},\"boardloader_version\":{\"id\":519,\"type\":\"string\"},\"bootloader_hash\":{\"id\":14,\"type\":\"bytes\"},\"bootloader_mode\":{\"id\":5,\"type\":\"bool\"},\"bootloader_version\":{\"id\":510,\"type\":\"string\"},\"brightness_prcent\":{\"id\":522,\"type\":\"uint32\"},\"build_id\":{\"id\":518,\"type\":\"bytes\"},\"busy\":{\"id\":41,\"type\":\"bool\"},\"capabilities\":{\"id\":30,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"Capability\"},\"coin_switch\":{\"id\":517,\"type\":\"uint32\"},\"cpu_info\":{\"id\":515,\"type\":\"string\"},\"device_id\":{\"id\":6,\"type\":\"string\"},\"display_rotation\":{\"id\":39,\"type\":\"uint32\"},\"experimental_features\":{\"id\":40,\"type\":\"bool\"},\"firmware_present\":{\"id\":18,\"type\":\"bool\"},\"flags\":{\"id\":20,\"type\":\"uint32\"},\"fw_major\":{\"id\":22,\"type\":\"uint32\"},\"fw_minor\":{\"id\":23,\"type\":\"uint32\"},\"fw_patch\":{\"id\":24,\"type\":\"uint32\"},\"fw_vendor\":{\"id\":25,\"type\":\"string\"},\"haptic_feedback\":{\"id\":523,\"type\":\"bool\"},\"imported\":{\"id\":15,\"type\":\"bool\"},\"initialized\":{\"id\":12,\"type\":\"bool\"},\"initstates\":{\"id\":513,\"type\":\"uint32\"},\"label\":{\"id\":10,\"type\":\"string\"},\"language\":{\"id\":9,\"type\":\"string\"},\"major_version\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint32\"},\"minor_version\":{\"id\":3,\"rule\":\"required\",\"type\":\"uint32\"},\"model\":{\"id\":21,\"type\":\"string\"},\"needs_backup\":{\"id\":19,\"type\":\"bool\"},\"no_backup\":{\"id\":28,\"type\":\"bool\"},\"offset\":{\"id\":500,\"type\":\"uint32\"},\"onekey_ble_build_id\":{\"id\":616,\"type\":\"string\"},\"onekey_ble_hash\":{\"id\":617,\"type\":\"bytes\"},\"onekey_ble_name\":{\"id\":614,\"type\":\"string\"},\"onekey_ble_version\":{\"id\":615,\"type\":\"string\"},\"onekey_board_hash\":{\"id\":603,\"type\":\"bytes\"},\"onekey_board_version\":{\"id\":602,\"type\":\"string\"},\"onekey_boot_build_id\":{\"id\":613,\"type\":\"string\"},\"onekey_boot_hash\":{\"id\":605,\"type\":\"bytes\"},\"onekey_boot_version\":{\"id\":604,\"type\":\"string\"},\"onekey_device_type\":{\"id\":600,\"type\":\"OneKeyDeviceType\"},\"onekey_firmware_build_id\":{\"id\":611,\"type\":\"string\"},\"onekey_firmware_hash\":{\"id\":610,\"type\":\"bytes\"},\"onekey_firmware_version\":{\"id\":609,\"type\":\"string\"},\"onekey_se01_build_id\":{\"id\":608,\"type\":\"string\"},\"onekey_se01_hash\":{\"id\":607,\"type\":\"bytes\"},\"onekey_se01_state\":{\"id\":621,\"type\":\"OneKeySEState\"},\"onekey_se01_version\":{\"id\":606,\"type\":\"string\"},\"onekey_se02_state\":{\"id\":622,\"type\":\"OneKeySEState\"},\"onekey_se02_version\":{\"id\":618,\"type\":\"string\"},\"onekey_se03_state\":{\"id\":623,\"type\":\"OneKeySEState\"},\"onekey_se03_version\":{\"id\":619,\"type\":\"string\"},\"onekey_se04_state\":{\"id\":624,\"type\":\"OneKeySEState\"},\"onekey_se04_version\":{\"id\":620,\"type\":\"string\"},\"onekey_se_type\":{\"id\":601,\"type\":\"OneKeySeType\"},\"onekey_serial\":{\"id\":509,\"type\":\"string\"},\"onekey_serial_no\":{\"id\":612,\"type\":\"string\"},\"onekey_version\":{\"id\":508,\"type\":\"string\"},\"passphrase_always_on_device\":{\"id\":36,\"type\":\"bool\"},\"passphrase_protection\":{\"id\":8,\"type\":\"bool\"},\"patch_version\":{\"id\":4,\"rule\":\"required\",\"type\":\"uint32\"},\"pin_protection\":{\"id\":7,\"type\":\"bool\"},\"pre_firmware\":{\"id\":516,\"type\":\"string\"},\"product\":{\"id\":521,\"type\":\"string\"},\"recovery_mode\":{\"id\":29,\"type\":\"bool\"},\"revision\":{\"id\":13,\"type\":\"bytes\"},\"safety_checks\":{\"id\":37,\"type\":\"SafetyCheckLevel\"},\"sd_card_present\":{\"id\":32,\"type\":\"bool\"},\"sd_protection\":{\"id\":33,\"type\":\"bool\"},\"se_enable\":{\"id\":504,\"type\":\"bool\"},\"se_ver\":{\"id\":506,\"type\":\"string\"},\"serial_no\":{\"id\":511,\"type\":\"string\"},\"session_id\":{\"id\":35,\"type\":\"bytes\"},\"spi_flash\":{\"id\":512,\"type\":\"string\"},\"unfinished_backup\":{\"id\":27,\"type\":\"bool\"},\"unlocked\":{\"id\":16,\"type\":\"bool\"},\"unlocked_attach_pin\":{\"id\":626,\"type\":\"bool\"},\"vendor\":{\"id\":1,\"type\":\"string\"},\"wipe_code_protection\":{\"id\":34,\"type\":\"bool\"}},\"nested\":{\"Capability\":{\"options\":{\"(has_bitcoin_only_values)\":true},\"values\":{\"Capability_AttachToPin\":8000,\"Capability_Binance\":3,\"Capability_Bitcoin\":1,\"Capability_Bitcoin_like\":2,\"Capability_Cardano\":4,\"Capability_Crypto\":5,\"Capability_EOS\":6,\"Capability_Ethereum\":7,\"Capability_EthereumTypedData\":1000,\"Capability_Lisk\":8,\"Capability_Monero\":9,\"Capability_NEM\":10,\"Capability_PassphraseEntry\":17,\"Capability_Ripple\":11,\"Capability_Shamir\":15,\"Capability_ShamirGroups\":16,\"Capability_Stellar\":12,\"Capability_Tezos\":13,\"Capability_U2F\":14}}}},\"FileInfoList\":{\"fields\":{\"files\":{\"id\":1,\"rule\":\"repeated\",\"type\":\"FileInfo\"}},\"nested\":{\"FileInfo\":{\"fields\":{\"name\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"},\"size\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint64\"}}}}},\"FilecoinAddress\":{\"fields\":{\"address\":{\"id\":1,\"type\":\"string\"}}},\"FilecoinGetAddress\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"show_display\":{\"id\":2,\"type\":\"bool\"},\"testnet\":{\"id\":3,\"type\":\"bool\"}}},\"FilecoinSignTx\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"raw_tx\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"},\"testnet\":{\"id\":3,\"type\":\"bool\"}}},\"FilecoinSignedTx\":{\"fields\":{\"signature\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"FirmwareErase\":{\"fields\":{\"length\":{\"id\":1,\"type\":\"uint32\"}}},\"FirmwareErase_ex\":{\"fields\":{\"length\":{\"id\":1,\"type\":\"uint32\"}}},\"FirmwareRequest\":{\"fields\":{\"length\":{\"id\":2,\"type\":\"uint32\"},\"offset\":{\"id\":1,\"type\":\"uint32\"}}},\"FirmwareUpdateEmmc\":{\"fields\":{\"path\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"},\"reboot_on_success\":{\"id\":2,\"type\":\"bool\"}}},\"FirmwareUpload\":{\"fields\":{\"hash\":{\"id\":2,\"type\":\"bytes\"},\"payload\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"GetAddress\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"coin_name\":{\"id\":2,\"options\":{\"default\":\"Bitcoin\"},\"type\":\"string\"},\"ignore_xpub_magic\":{\"id\":6,\"type\":\"bool\"},\"multisig\":{\"id\":4,\"type\":\"MultisigRedeemScriptType\"},\"script_type\":{\"id\":5,\"options\":{\"default\":\"SPENDADDRESS\"},\"type\":\"InputScriptType\"},\"show_display\":{\"id\":3,\"type\":\"bool\"}}},\"GetDeviceInfo\":{\"fields\":{}},\"GetECDHSessionKey\":{\"fields\":{\"ecdsa_curve_name\":{\"id\":3,\"type\":\"string\"},\"identity\":{\"id\":1,\"rule\":\"required\",\"type\":\"IdentityType\"},\"peer_public_key\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"GetEntropy\":{\"fields\":{\"size\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint32\"}}},\"GetFeatures\":{\"fields\":{}},\"GetNextU2FCounter\":{\"fields\":{}},\"GetOwnershipId\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"coin_name\":{\"id\":2,\"options\":{\"default\":\"Bitcoin\"},\"type\":\"string\"},\"multisig\":{\"id\":3,\"type\":\"MultisigRedeemScriptType\"},\"script_type\":{\"id\":4,\"options\":{\"default\":\"SPENDADDRESS\"},\"type\":\"InputScriptType\"}}},\"GetOwnershipProof\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"coin_name\":{\"id\":2,\"options\":{\"default\":\"Bitcoin\"},\"type\":\"string\"},\"commitment_data\":{\"id\":7,\"options\":{\"default\":\"\"},\"type\":\"bytes\"},\"multisig\":{\"id\":4,\"type\":\"MultisigRedeemScriptType\"},\"ownership_ids\":{\"id\":6,\"rule\":\"repeated\",\"type\":\"bytes\"},\"script_type\":{\"id\":3,\"options\":{\"default\":\"SPENDWITNESS\"},\"type\":\"InputScriptType\"},\"user_confirmation\":{\"id\":5,\"options\":{\"default\":false},\"type\":\"bool\"}}},\"GetPassphraseState\":{\"fields\":{\"passphrase_state\":{\"id\":1,\"type\":\"string\"}}},\"GetPublicKey\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"coin_name\":{\"id\":4,\"options\":{\"default\":\"Bitcoin\"},\"type\":\"string\"},\"ecdsa_curve_name\":{\"id\":2,\"type\":\"string\"},\"ignore_xpub_magic\":{\"id\":6,\"type\":\"bool\"},\"script_type\":{\"id\":5,\"options\":{\"default\":\"SPENDADDRESS\"},\"type\":\"InputScriptType\"},\"show_display\":{\"id\":3,\"type\":\"bool\"}}},\"GetPublicKeyMultiple\":{\"fields\":{\"addresses\":{\"id\":1,\"rule\":\"repeated\",\"type\":\"BIP32Address\"},\"coin_name\":{\"id\":4,\"options\":{\"default\":\"Bitcoin\"},\"type\":\"string\"},\"ecdsa_curve_name\":{\"id\":2,\"type\":\"string\"},\"ignore_xpub_magic\":{\"id\":6,\"type\":\"bool\"},\"script_type\":{\"id\":5,\"options\":{\"default\":\"SPENDADDRESS\"},\"type\":\"InputScriptType\"},\"show_display\":{\"id\":3,\"type\":\"bool\"}},\"nested\":{\"BIP32Address\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"}}}}},\"HDNodeType\":{\"fields\":{\"chain_code\":{\"id\":4,\"rule\":\"required\",\"type\":\"bytes\"},\"child_num\":{\"id\":3,\"rule\":\"required\",\"type\":\"uint32\"},\"depth\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint32\"},\"fingerprint\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint32\"},\"private_key\":{\"id\":5,\"type\":\"bytes\"},\"public_key\":{\"id\":6,\"rule\":\"required\",\"type\":\"bytes\"}}},\"IdentityType\":{\"fields\":{\"host\":{\"id\":3,\"type\":\"string\"},\"index\":{\"id\":6,\"options\":{\"default\":0},\"type\":\"uint32\"},\"path\":{\"id\":5,\"type\":\"string\"},\"port\":{\"id\":4,\"type\":\"string\"},\"proto\":{\"id\":1,\"type\":\"string\"},\"user\":{\"id\":2,\"type\":\"string\"}}},\"Initialize\":{\"fields\":{\"_skip_passphrase\":{\"id\":2,\"options\":{\"deprecated\":true},\"type\":\"bool\"},\"derive_cardano\":{\"id\":3,\"type\":\"bool\"},\"is_contains_attach\":{\"id\":8001,\"type\":\"bool\"},\"passphrase_state\":{\"id\":8000,\"type\":\"string\"},\"session_id\":{\"id\":1,\"type\":\"bytes\"}}},\"InputScriptType\":{\"values\":{\"EXTERNAL\":2,\"SPENDADDRESS\":0,\"SPENDMULTISIG\":1,\"SPENDP2SHWITNESS\":4,\"SPENDTAPROOT\":5,\"SPENDWITNESS\":3}},\"KaspaAddress\":{\"fields\":{\"address\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"}}},\"KaspaGetAddress\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"prefix\":{\"id\":3,\"options\":{\"default\":\"kaspa\"},\"type\":\"string\"},\"scheme\":{\"id\":4,\"options\":{\"default\":\"schnorr\"},\"type\":\"string\"},\"show_display\":{\"id\":2,\"type\":\"bool\"},\"use_tweak\":{\"id\":5,\"options\":{\"default\":true},\"type\":\"bool\"}}},\"KaspaInputScriptType\":{\"values\":{\"KASPA_SPEND_P2PK_ECDSA\":1,\"KASPA_SPEND_P2PK_SCHNORR\":0}},\"KaspaOutpoint\":{\"fields\":{\"index\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint32\"},\"tx_id\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"KaspaOutputScriptType\":{\"values\":{\"KASPA_PAYTOADDRESS\":0,\"KASPA_PAYTOCHANGE\":1}},\"KaspaRequestType\":{\"values\":{\"KASPA_TX_FINISHED\":3,\"KASPA_TX_INPUT\":0,\"KASPA_TX_OUTPUT\":1,\"KASPA_TX_PAYLOAD\":2,\"KASPA_TX_PREV_META\":4}},\"KaspaSignTx\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"gas\":{\"id\":11,\"options\":{\"default\":0},\"type\":\"uint64\"},\"input_count\":{\"id\":5,\"options\":{\"default\":1},\"type\":\"uint32\"},\"lock_time\":{\"id\":9,\"options\":{\"default\":0},\"type\":\"uint64\"},\"output_count\":{\"id\":7,\"type\":\"uint32\"},\"payload_length\":{\"id\":12,\"options\":{\"default\":0},\"type\":\"uint32\"},\"prefix\":{\"id\":4,\"options\":{\"default\":\"kaspa\"},\"type\":\"string\"},\"raw_message\":{\"id\":2,\"type\":\"bytes\"},\"scheme\":{\"id\":3,\"options\":{\"default\":\"schnorr\"},\"type\":\"string\"},\"subnetwork_id\":{\"id\":10,\"type\":\"bytes\"},\"use_tweak\":{\"id\":6,\"options\":{\"default\":true},\"type\":\"bool\"},\"version\":{\"id\":8,\"options\":{\"default\":0},\"type\":\"uint32\"}}},\"KaspaSignedTx\":{\"fields\":{\"signature\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"KaspaTxAckInput\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"amount\":{\"id\":3,\"rule\":\"required\",\"type\":\"uint64\"},\"previous_outpoint\":{\"id\":2,\"rule\":\"required\",\"type\":\"KaspaOutpoint\"},\"script_type\":{\"id\":6,\"options\":{\"default\":\"KASPA_SPEND_P2PK_SCHNORR\"},\"type\":\"KaspaInputScriptType\"},\"sequence\":{\"id\":4,\"rule\":\"required\",\"type\":\"uint64\"},\"sig_op_count\":{\"id\":5,\"rule\":\"required\",\"type\":\"uint32\"},\"use_tweak\":{\"id\":9,\"options\":{\"default\":true},\"type\":\"bool\"}}},\"KaspaTxAckOutput\":{\"fields\":{\"address\":{\"id\":4,\"type\":\"string\"},\"address_n\":{\"id\":3,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"amount\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint64\"},\"scheme\":{\"id\":7,\"options\":{\"default\":\"schnorr\"},\"type\":\"string\"},\"script_type\":{\"id\":1,\"options\":{\"default\":\"KASPA_PAYTOADDRESS\"},\"type\":\"KaspaOutputScriptType\"},\"use_tweak\":{\"id\":8,\"options\":{\"default\":true},\"type\":\"bool\"}}},\"KaspaTxAckPayloadChunk\":{\"fields\":{\"payload_chunk\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"KaspaTxAckPrevInput\":{\"fields\":{\"previous_outpoint\":{\"id\":1,\"rule\":\"required\",\"type\":\"KaspaOutpoint\"},\"sequence\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint64\"}}},\"KaspaTxAckPrevMeta\":{\"fields\":{\"gas\":{\"id\":6,\"rule\":\"required\",\"type\":\"uint64\"},\"input_count\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint32\"},\"lock_time\":{\"id\":4,\"rule\":\"required\",\"type\":\"uint64\"},\"output_count\":{\"id\":3,\"rule\":\"required\",\"type\":\"uint32\"},\"payload_length\":{\"id\":7,\"rule\":\"required\",\"type\":\"uint32\"},\"subnetwork_id\":{\"id\":5,\"rule\":\"required\",\"type\":\"bytes\"},\"version\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint32\"}}},\"KaspaTxAckPrevOutput\":{\"fields\":{\"amount\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint64\"},\"script_public_key\":{\"id\":3,\"rule\":\"required\",\"type\":\"bytes\"},\"script_version\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint32\"}}},\"KaspaTxInputAck\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"raw_message\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"KaspaTxInputRequest\":{\"fields\":{\"request_index\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint32\"},\"signature\":{\"id\":2,\"type\":\"bytes\"}}},\"KaspaTxRequest\":{\"fields\":{\"prev_tx_id\":{\"id\":5,\"type\":\"bytes\"},\"request_index\":{\"id\":2,\"type\":\"uint32\"},\"request_payload_length\":{\"id\":4,\"type\":\"uint32\"},\"request_type\":{\"id\":1,\"rule\":\"required\",\"type\":\"KaspaRequestType\"},\"signature\":{\"id\":3,\"type\":\"KaspaTxRequestSignature\"}}},\"KaspaTxRequestSignature\":{\"fields\":{\"signature\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"},\"signature_index\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint32\"}}},\"ListResDir\":{\"fields\":{\"path\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"}}},\"LnurlAuth\":{\"fields\":{\"data\":{\"id\":3,\"rule\":\"required\",\"type\":\"bytes\"},\"domain\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"LnurlAuthResp\":{\"fields\":{\"path\":{\"id\":2,\"type\":\"string\"},\"publickey\":{\"id\":1,\"type\":\"string\"},\"signature\":{\"id\":3,\"type\":\"bytes\"}}},\"LoadDevice\":{\"fields\":{\"label\":{\"id\":6,\"type\":\"string\"},\"language\":{\"id\":5,\"options\":{\"default\":\"en-US\"},\"type\":\"string\"},\"mnemonics\":{\"id\":1,\"rule\":\"repeated\",\"type\":\"string\"},\"needs_backup\":{\"id\":9,\"type\":\"bool\"},\"no_backup\":{\"id\":10,\"type\":\"bool\"},\"passphrase_protection\":{\"id\":4,\"type\":\"bool\"},\"pin\":{\"id\":3,\"type\":\"string\"},\"skip_checksum\":{\"id\":7,\"type\":\"bool\"},\"u2f_counter\":{\"id\":8,\"type\":\"uint32\"}}},\"LockDevice\":{\"fields\":{}},\"MessageSignature\":{\"fields\":{\"address\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"},\"signature\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"MessageType\":{\"options\":{\"(has_bitcoin_only_values)\":true},\"values\":{\"MessageType_Address\":30,\"MessageType_AlephiumAddress\":12102,\"MessageType_AlephiumBytecodeAck\":12108,\"MessageType_AlephiumBytecodeRequest\":12107,\"MessageType_AlephiumGetAddress\":12101,\"MessageType_AlephiumMessageSignature\":12110,\"MessageType_AlephiumSignMessage\":12109,\"MessageType_AlephiumSignTx\":12103,\"MessageType_AlephiumSignedTx\":12104,\"MessageType_AlephiumTxAck\":12106,\"MessageType_AlephiumTxRequest\":12105,\"MessageType_AlgorandAddress\":10901,\"MessageType_AlgorandGetAddress\":10900,\"MessageType_AlgorandSignTx\":10902,\"MessageType_AlgorandSignedTx\":10903,\"MessageType_ApplyFlags\":28,\"MessageType_ApplySettings\":25,\"MessageType_AptosAddress\":10601,\"MessageType_AptosGetAddress\":10600,\"MessageType_AptosMessageSignature\":10605,\"MessageType_AptosSignMessage\":10604,\"MessageType_AptosSignSIWAMessage\":10606,\"MessageType_AptosSignTx\":10602,\"MessageType_AptosSignedTx\":10603,\"MessageType_AuthorizeCoinJoin\":51,\"MessageType_BabylonDeriveContextHash\":10054,\"MessageType_BabylonDerivedContextHash\":10055,\"MessageType_BackupDevice\":34,\"MessageType_BatchGetPublickeys\":10016,\"MessageType_BenfenAddress\":12202,\"MessageType_BenfenGetAddress\":12201,\"MessageType_BenfenMessageSignature\":12206,\"MessageType_BenfenSignMessage\":12205,\"MessageType_BenfenSignTx\":12203,\"MessageType_BenfenSignedTx\":12204,\"MessageType_BenfenTxAck\":12208,\"MessageType_BenfenTxRequest\":12207,\"MessageType_BinanceAddress\":701,\"MessageType_BinanceCancelMsg\":708,\"MessageType_BinanceGetAddress\":700,\"MessageType_BinanceGetPublicKey\":702,\"MessageType_BinanceOrderMsg\":707,\"MessageType_BinancePublicKey\":703,\"MessageType_BinanceSignTx\":704,\"MessageType_BinanceSignedTx\":709,\"MessageType_BinanceTransferMsg\":706,\"MessageType_BinanceTxRequest\":705,\"MessageType_BixinBackupAck\":906,\"MessageType_BixinBackupDevice\":914,\"MessageType_BixinBackupDeviceAck\":915,\"MessageType_BixinBackupRequest\":905,\"MessageType_BixinLoadDevice\":913,\"MessageType_BixinMessageSE\":902,\"MessageType_BixinOutMessageSE\":904,\"MessageType_BixinPinInputOnDevice\":10000,\"MessageType_BixinRestoreAck\":908,\"MessageType_BixinRestoreRequest\":907,\"MessageType_BixinSeedOperate\":901,\"MessageType_BixinVerifyDeviceAck\":910,\"MessageType_BixinVerifyDeviceRequest\":909,\"MessageType_BixinWhiteListAck\":912,\"MessageType_BixinWhiteListRequest\":911,\"MessageType_BlurRequest\":10032,\"MessageType_ButtonAck\":27,\"MessageType_ButtonRequest\":26,\"MessageType_Cancel\":20,\"MessageType_CancelAuthorization\":86,\"MessageType_CardanoAddress\":308,\"MessageType_CardanoAssetGroup\":323,\"MessageType_CardanoGetAddress\":307,\"MessageType_CardanoGetNativeScriptHash\":330,\"MessageType_CardanoGetPublicKey\":305,\"MessageType_CardanoMessageSignature\":351,\"MessageType_CardanoNativeScriptHash\":331,\"MessageType_CardanoPoolOwner\":328,\"MessageType_CardanoPoolRelayParameters\":329,\"MessageType_CardanoPublicKey\":306,\"MessageType_CardanoSignMessage\":350,\"MessageType_CardanoSignTxFinished\":319,\"MessageType_CardanoSignTxInit\":320,\"MessageType_CardanoToken\":324,\"MessageType_CardanoTxAuxiliaryData\":327,\"MessageType_CardanoTxAuxiliaryDataSupplement\":314,\"MessageType_CardanoTxBodyHash\":318,\"MessageType_CardanoTxCertificate\":325,\"MessageType_CardanoTxCollateralInput\":333,\"MessageType_CardanoTxHostAck\":317,\"MessageType_CardanoTxInlineDatumChunk\":335,\"MessageType_CardanoTxInput\":321,\"MessageType_CardanoTxItemAck\":313,\"MessageType_CardanoTxMint\":332,\"MessageType_CardanoTxOutput\":322,\"MessageType_CardanoTxReferenceInput\":337,\"MessageType_CardanoTxReferenceScriptChunk\":336,\"MessageType_CardanoTxRequiredSigner\":334,\"MessageType_CardanoTxWithdrawal\":326,\"MessageType_CardanoTxWitnessRequest\":315,\"MessageType_CardanoTxWitnessResponse\":316,\"MessageType_ChangePin\":4,\"MessageType_ChangeWipeCode\":82,\"MessageType_CipherKeyValue\":23,\"MessageType_CipheredKeyValue\":48,\"MessageType_ConfluxAddress\":10113,\"MessageType_ConfluxGetAddress\":10112,\"MessageType_ConfluxMessageSignature\":10119,\"MessageType_ConfluxSignMessage\":10117,\"MessageType_ConfluxSignMessageCIP23\":10118,\"MessageType_ConfluxSignTx\":10114,\"MessageType_ConfluxTxAck\":10116,\"MessageType_ConfluxTxRequest\":10115,\"MessageType_CosiCommit\":71,\"MessageType_CosiCommitment\":72,\"MessageType_CosiSign\":73,\"MessageType_CosiSignature\":74,\"MessageType_CosmosAddress\":10801,\"MessageType_CosmosGetAddress\":10800,\"MessageType_CosmosSignTx\":10802,\"MessageType_CosmosSignedTx\":10803,\"MessageType_DebugLinkDecision\":100,\"MessageType_DebugLinkEraseSdCard\":9005,\"MessageType_DebugLinkFlashErase\":113,\"MessageType_DebugLinkGetState\":101,\"MessageType_DebugLinkLayout\":9001,\"MessageType_DebugLinkLog\":104,\"MessageType_DebugLinkMemory\":111,\"MessageType_DebugLinkMemoryRead\":110,\"MessageType_DebugLinkMemoryWrite\":112,\"MessageType_DebugLinkRecordScreen\":9003,\"MessageType_DebugLinkReseedRandom\":9002,\"MessageType_DebugLinkState\":102,\"MessageType_DebugLinkStop\":103,\"MessageType_DebugLinkWatchLayout\":9006,\"MessageType_DebugMoneroDiagAck\":547,\"MessageType_DebugMoneroDiagRequest\":546,\"MessageType_Deprecated_PassphraseStateAck\":78,\"MessageType_Deprecated_PassphraseStateRequest\":77,\"MessageType_DeviceBackToBoot\":903,\"MessageType_DeviceInfo\":10003,\"MessageType_DeviceInfoSettings\":10001,\"MessageType_DnxAddress\":11801,\"MessageType_DnxGetAddress\":11800,\"MessageType_DnxInputAck\":11804,\"MessageType_DnxInputRequest\":11803,\"MessageType_DnxRTSigsRequest\":11805,\"MessageType_DnxSignTx\":11802,\"MessageType_DnxSignedTx\":11806,\"MessageType_DoPreauthorized\":84,\"MessageType_ECDHSessionKey\":62,\"MessageType_EcdsaPublicKeys\":10017,\"MessageType_EmmcDir\":30107,\"MessageType_EmmcDirList\":30108,\"MessageType_EmmcDirMake\":30109,\"MessageType_EmmcDirRemove\":30110,\"MessageType_EmmcFile\":30103,\"MessageType_EmmcFileDelete\":30106,\"MessageType_EmmcFileRead\":30104,\"MessageType_EmmcFileWrite\":30105,\"MessageType_EmmcFixPermission\":30100,\"MessageType_EmmcPath\":30101,\"MessageType_EmmcPathInfo\":30102,\"MessageType_EndSession\":83,\"MessageType_Entropy\":10,\"MessageType_EntropyAck\":36,\"MessageType_EntropyRequest\":35,\"MessageType_EosGetPublicKey\":600,\"MessageType_EosPublicKey\":601,\"MessageType_EosSignTx\":602,\"MessageType_EosSignedTx\":605,\"MessageType_EosTxActionAck\":604,\"MessageType_EosTxActionRequest\":603,\"MessageType_EthereumAddress\":57,\"MessageType_EthereumAddressOneKey\":20103,\"MessageType_EthereumGetAddress\":56,\"MessageType_EthereumGetAddressOneKey\":20102,\"MessageType_EthereumGetPublicKey\":450,\"MessageType_EthereumGetPublicKeyOneKey\":20100,\"MessageType_EthereumGnosisSafeTxAck\":20118,\"MessageType_EthereumGnosisSafeTxRequest\":20119,\"MessageType_EthereumMessageSignature\":66,\"MessageType_EthereumMessageSignatureOneKey\":20110,\"MessageType_EthereumPublicKey\":451,\"MessageType_EthereumPublicKeyOneKey\":20101,\"MessageType_EthereumSignMessage\":64,\"MessageType_EthereumSignMessageEIP712\":10200,\"MessageType_EthereumSignMessageOneKey\":20108,\"MessageType_EthereumSignTx\":58,\"MessageType_EthereumSignTxEIP1559\":452,\"MessageType_EthereumSignTxEIP1559OneKey\":20105,\"MessageType_EthereumSignTxEIP7702OneKey\":20120,\"MessageType_EthereumSignTxOneKey\":20104,\"MessageType_EthereumSignTypedData\":464,\"MessageType_EthereumSignTypedDataOneKey\":20111,\"MessageType_EthereumSignTypedHash\":470,\"MessageType_EthereumSignTypedHashOneKey\":20117,\"MessageType_EthereumTxAck\":60,\"MessageType_EthereumTxAckOneKey\":20107,\"MessageType_EthereumTxRequest\":59,\"MessageType_EthereumTxRequestOneKey\":20106,\"MessageType_EthereumTypedDataSignature\":469,\"MessageType_EthereumTypedDataSignatureOneKey\":20116,\"MessageType_EthereumTypedDataStructAck\":466,\"MessageType_EthereumTypedDataStructAckOneKey\":20113,\"MessageType_EthereumTypedDataStructRequest\":465,\"MessageType_EthereumTypedDataStructRequestOneKey\":20112,\"MessageType_EthereumTypedDataValueAck\":468,\"MessageType_EthereumTypedDataValueAckOneKey\":20115,\"MessageType_EthereumTypedDataValueRequest\":467,\"MessageType_EthereumTypedDataValueRequestOneKey\":20114,\"MessageType_EthereumVerifyMessage\":65,\"MessageType_EthereumVerifyMessageOneKey\":20109,\"MessageType_Failure\":3,\"MessageType_Features\":17,\"MessageType_FileInfoList\":10024,\"MessageType_FilecoinAddress\":11201,\"MessageType_FilecoinGetAddress\":11200,\"MessageType_FilecoinSignTx\":11202,\"MessageType_FilecoinSignedTx\":11203,\"MessageType_FirmwareErase\":6,\"MessageType_FirmwareErase_ex\":16,\"MessageType_FirmwareRequest\":8,\"MessageType_FirmwareUpdateEmmc\":30001,\"MessageType_FirmwareUpload\":7,\"MessageType_GetAddress\":29,\"MessageType_GetDeviceInfo\":10002,\"MessageType_GetECDHSessionKey\":61,\"MessageType_GetEntropy\":9,\"MessageType_GetFeatures\":55,\"MessageType_GetNextU2FCounter\":80,\"MessageType_GetOwnershipId\":43,\"MessageType_GetOwnershipProof\":49,\"MessageType_GetPassphraseState\":10028,\"MessageType_GetPublicKey\":11,\"MessageType_GetPublicKeyMultiple\":10210,\"MessageType_Initialize\":0,\"MessageType_KaspaAddress\":11301,\"MessageType_KaspaGetAddress\":11300,\"MessageType_KaspaSignTx\":11302,\"MessageType_KaspaSignedTx\":11303,\"MessageType_KaspaTxAckInput\":11307,\"MessageType_KaspaTxAckOutput\":11308,\"MessageType_KaspaTxAckPayloadChunk\":11309,\"MessageType_KaspaTxAckPrevInput\":11311,\"MessageType_KaspaTxAckPrevMeta\":11310,\"MessageType_KaspaTxAckPrevOutput\":11312,\"MessageType_KaspaTxInputAck\":11305,\"MessageType_KaspaTxInputRequest\":11304,\"MessageType_KaspaTxRequest\":11306,\"MessageType_ListResDir\":10023,\"MessageType_LnurlAuth\":11600,\"MessageType_LnurlAuthResp\":11601,\"MessageType_LoadDevice\":13,\"MessageType_LockDevice\":24,\"MessageType_MessageSignature\":40,\"MessageType_MoneroAddress\":541,\"MessageType_MoneroGetAddress\":540,\"MessageType_MoneroGetTxKeyAck\":551,\"MessageType_MoneroGetTxKeyRequest\":550,\"MessageType_MoneroGetWatchKey\":542,\"MessageType_MoneroKeyImageExportInitAck\":531,\"MessageType_MoneroKeyImageExportInitRequest\":530,\"MessageType_MoneroKeyImageSyncFinalAck\":535,\"MessageType_MoneroKeyImageSyncFinalRequest\":534,\"MessageType_MoneroKeyImageSyncStepAck\":533,\"MessageType_MoneroKeyImageSyncStepRequest\":532,\"MessageType_MoneroLiveRefreshFinalAck\":557,\"MessageType_MoneroLiveRefreshFinalRequest\":556,\"MessageType_MoneroLiveRefreshStartAck\":553,\"MessageType_MoneroLiveRefreshStartRequest\":552,\"MessageType_MoneroLiveRefreshStepAck\":555,\"MessageType_MoneroLiveRefreshStepRequest\":554,\"MessageType_MoneroTransactionAllInputsSetAck\":510,\"MessageType_MoneroTransactionAllInputsSetRequest\":509,\"MessageType_MoneroTransactionAllOutSetAck\":514,\"MessageType_MoneroTransactionAllOutSetRequest\":513,\"MessageType_MoneroTransactionFinalAck\":518,\"MessageType_MoneroTransactionFinalRequest\":517,\"MessageType_MoneroTransactionInitAck\":502,\"MessageType_MoneroTransactionInitRequest\":501,\"MessageType_MoneroTransactionInputViniAck\":508,\"MessageType_MoneroTransactionInputViniRequest\":507,\"MessageType_MoneroTransactionInputsPermutationAck\":506,\"MessageType_MoneroTransactionInputsPermutationRequest\":505,\"MessageType_MoneroTransactionSetInputAck\":504,\"MessageType_MoneroTransactionSetInputRequest\":503,\"MessageType_MoneroTransactionSetOutputAck\":512,\"MessageType_MoneroTransactionSetOutputRequest\":511,\"MessageType_MoneroTransactionSignInputAck\":516,\"MessageType_MoneroTransactionSignInputRequest\":515,\"MessageType_MoneroWatchKey\":543,\"MessageType_NEMAddress\":68,\"MessageType_NEMDecryptMessage\":75,\"MessageType_NEMDecryptedMessage\":76,\"MessageType_NEMGetAddress\":67,\"MessageType_NEMSignTx\":69,\"MessageType_NEMSignedTx\":70,\"MessageType_NFTWriteData\":10015,\"MessageType_NFTWriteInfo\":10014,\"MessageType_NearAddress\":10702,\"MessageType_NearGetAddress\":10701,\"MessageType_NearSignTx\":10703,\"MessageType_NearSignedTx\":10704,\"MessageType_NeoAddress\":12302,\"MessageType_NeoGetAddress\":12301,\"MessageType_NeoSignTx\":12303,\"MessageType_NeoSignedTx\":12304,\"MessageType_NervosAddress\":11702,\"MessageType_NervosGetAddress\":11701,\"MessageType_NervosSignTx\":11703,\"MessageType_NervosSignedTx\":11704,\"MessageType_NervosTxAck\":11706,\"MessageType_NervosTxRequest\":11705,\"MessageType_NexaAddress\":11401,\"MessageType_NexaGetAddress\":11400,\"MessageType_NexaSignTx\":11402,\"MessageType_NexaSignedTx\":11403,\"MessageType_NexaTxInputAck\":11405,\"MessageType_NexaTxInputRequest\":11404,\"MessageType_NextU2FCounter\":81,\"MessageType_NostrDecryptMessage\":11506,\"MessageType_NostrDecryptedMessage\":11507,\"MessageType_NostrEncryptMessage\":11504,\"MessageType_NostrEncryptedMessage\":11505,\"MessageType_NostrGetPublicKey\":11500,\"MessageType_NostrPublicKey\":11501,\"MessageType_NostrSignEvent\":11502,\"MessageType_NostrSignSchnorr\":11508,\"MessageType_NostrSignedEvent\":11503,\"MessageType_NostrSignedSchnorr\":11509,\"MessageType_OnekeyFeatures\":10026,\"MessageType_OnekeyGetFeatures\":10025,\"MessageType_OwnershipId\":44,\"MessageType_OwnershipProof\":50,\"MessageType_PassphraseAck\":42,\"MessageType_PassphraseRequest\":41,\"MessageType_PassphraseState\":10029,\"MessageType_PinMatrixAck\":19,\"MessageType_PinMatrixRequest\":18,\"MessageType_Ping\":1,\"MessageType_PolkadotAddress\":11001,\"MessageType_PolkadotGetAddress\":11000,\"MessageType_PolkadotSignTx\":11002,\"MessageType_PolkadotSignedTx\":11003,\"MessageType_PreauthorizedRequest\":85,\"MessageType_PublicKey\":12,\"MessageType_PublicKeyMultiple\":10211,\"MessageType_ReadSEPublicCert\":10007,\"MessageType_ReadSEPublicKey\":10004,\"MessageType_Reboot\":30000,\"MessageType_RebootToBootloader\":87,\"MessageType_RecoveryDevice\":45,\"MessageType_ResetDevice\":14,\"MessageType_ResourceAck\":10021,\"MessageType_ResourceRequest\":10020,\"MessageType_ResourceUpdate\":10022,\"MessageType_ResourceUpload\":10018,\"MessageType_RippleAddress\":401,\"MessageType_RippleGetAddress\":400,\"MessageType_RippleSignTx\":402,\"MessageType_RippleSignedTx\":403,\"MessageType_SEMessageSignature\":10013,\"MessageType_SEPublicCert\":10008,\"MessageType_SEPublicKey\":10005,\"MessageType_SESignMessage\":10012,\"MessageType_ScdoAddress\":12002,\"MessageType_ScdoGetAddress\":12001,\"MessageType_ScdoSignMessage\":12006,\"MessageType_ScdoSignTx\":12003,\"MessageType_ScdoSignedMessage\":12007,\"MessageType_ScdoSignedTx\":12004,\"MessageType_ScdoTxAck\":12005,\"MessageType_SdProtect\":79,\"MessageType_SelfTest\":32,\"MessageType_SetU2FCounter\":63,\"MessageType_SignIdentity\":53,\"MessageType_SignMessage\":38,\"MessageType_SignPsbt\":10052,\"MessageType_SignTx\":15,\"MessageType_SignedIdentity\":54,\"MessageType_SignedPsbt\":10053,\"MessageType_SolanaAddress\":10101,\"MessageType_SolanaGetAddress\":10100,\"MessageType_SolanaMessageSignature\":10105,\"MessageType_SolanaSignOffChainMessage\":10104,\"MessageType_SolanaSignTx\":10102,\"MessageType_SolanaSignUnsafeMessage\":10106,\"MessageType_SolanaSignedTx\":10103,\"MessageType_SpiFlashData\":10011,\"MessageType_SpiFlashRead\":10010,\"MessageType_SpiFlashWrite\":10009,\"MessageType_StarcoinAddress\":10301,\"MessageType_StarcoinGetAddress\":10300,\"MessageType_StarcoinGetPublicKey\":10302,\"MessageType_StarcoinMessageSignature\":10307,\"MessageType_StarcoinPublicKey\":10303,\"MessageType_StarcoinSignMessage\":10306,\"MessageType_StarcoinSignTx\":10304,\"MessageType_StarcoinSignedTx\":10305,\"MessageType_StarcoinVerifyMessage\":10308,\"MessageType_StellarAccountMergeOp\":218,\"MessageType_StellarAddress\":208,\"MessageType_StellarAllowTrustOp\":217,\"MessageType_StellarBumpSequenceOp\":221,\"MessageType_StellarChangeTrustOp\":216,\"MessageType_StellarCreateAccountOp\":210,\"MessageType_StellarCreatePassiveSellOfferOp\":214,\"MessageType_StellarGetAddress\":207,\"MessageType_StellarInvokeHostFunctionOp\":260,\"MessageType_StellarManageBuyOfferOp\":222,\"MessageType_StellarManageDataOp\":220,\"MessageType_StellarManageSellOfferOp\":213,\"MessageType_StellarPathPaymentStrictReceiveOp\":212,\"MessageType_StellarPathPaymentStrictSendOp\":223,\"MessageType_StellarPaymentOp\":211,\"MessageType_StellarSetOptionsOp\":215,\"MessageType_StellarSignTx\":202,\"MessageType_StellarSignedTx\":230,\"MessageType_StellarSorobanDataAck\":262,\"MessageType_StellarSorobanDataRequest\":261,\"MessageType_StellarTxOpRequest\":203,\"MessageType_Success\":2,\"MessageType_SuiAddress\":11101,\"MessageType_SuiGetAddress\":11100,\"MessageType_SuiMessageSignature\":11105,\"MessageType_SuiSignMessage\":11104,\"MessageType_SuiSignTx\":11102,\"MessageType_SuiSignedTx\":11103,\"MessageType_SuiTxAck\":11107,\"MessageType_SuiTxRequest\":11106,\"MessageType_TezosAddress\":151,\"MessageType_TezosGetAddress\":150,\"MessageType_TezosGetPublicKey\":154,\"MessageType_TezosPublicKey\":155,\"MessageType_TezosSignTx\":152,\"MessageType_TezosSignedTx\":153,\"MessageType_TonAddress\":11902,\"MessageType_TonGetAddress\":11901,\"MessageType_TonSignData\":11908,\"MessageType_TonSignMessage\":11903,\"MessageType_TonSignProof\":11905,\"MessageType_TonSignedData\":11909,\"MessageType_TonSignedMessage\":11904,\"MessageType_TonSignedProof\":11906,\"MessageType_TonTxAck\":11907,\"MessageType_TronAddress\":10502,\"MessageType_TronGetAddress\":10501,\"MessageType_TronMessageSignature\":10506,\"MessageType_TronSignMessage\":10505,\"MessageType_TronSignTx\":10503,\"MessageType_TronSignedTx\":10504,\"MessageType_TxAck\":22,\"MessageType_TxRequest\":21,\"MessageType_UnLockDevice\":10030,\"MessageType_UnLockDeviceResponse\":10031,\"MessageType_UpgradeFileHeader\":10050,\"MessageType_VerifyMessage\":39,\"MessageType_WebAuthnAddResidentCredential\":802,\"MessageType_WebAuthnCredentials\":801,\"MessageType_WebAuthnListResidentCredentials\":800,\"MessageType_WebAuthnRemoveResidentCredential\":803,\"MessageType_WipeDevice\":5,\"MessageType_WordAck\":47,\"MessageType_WordRequest\":46,\"MessageType_WriteSEPublicCert\":10006,\"MessageType_ZoomRequest\":10019}},\"MoneroAddress\":{\"fields\":{\"address\":{\"id\":1,\"type\":\"bytes\"}}},\"MoneroGetAddress\":{\"fields\":{\"account\":{\"id\":4,\"type\":\"uint32\"},\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"minor\":{\"id\":5,\"type\":\"uint32\"},\"network_type\":{\"id\":3,\"type\":\"uint32\"},\"payment_id\":{\"id\":6,\"type\":\"bytes\"},\"show_display\":{\"id\":2,\"type\":\"bool\"}}},\"MoneroGetTxKeyAck\":{\"fields\":{\"salt\":{\"id\":1,\"type\":\"bytes\"},\"tx_derivations\":{\"id\":3,\"type\":\"bytes\"},\"tx_keys\":{\"id\":2,\"type\":\"bytes\"}}},\"MoneroGetTxKeyRequest\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"network_type\":{\"id\":2,\"type\":\"uint32\"},\"reason\":{\"id\":7,\"type\":\"uint32\"},\"salt1\":{\"id\":3,\"type\":\"bytes\"},\"salt2\":{\"id\":4,\"type\":\"bytes\"},\"tx_enc_keys\":{\"id\":5,\"type\":\"bytes\"},\"tx_prefix_hash\":{\"id\":6,\"type\":\"bytes\"},\"view_public_key\":{\"id\":8,\"type\":\"bytes\"}}},\"MoneroGetWatchKey\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"network_type\":{\"id\":2,\"type\":\"uint32\"}}},\"MoneroKeyImageExportInitAck\":{\"fields\":{}},\"MoneroKeyImageExportInitRequest\":{\"fields\":{\"address_n\":{\"id\":3,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"hash\":{\"id\":2,\"type\":\"bytes\"},\"network_type\":{\"id\":4,\"type\":\"uint32\"},\"num\":{\"id\":1,\"type\":\"uint64\"},\"subs\":{\"id\":5,\"rule\":\"repeated\",\"type\":\"MoneroSubAddressIndicesList\"}},\"nested\":{\"MoneroSubAddressIndicesList\":{\"fields\":{\"account\":{\"id\":1,\"type\":\"uint32\"},\"minor_indices\":{\"id\":2,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"}}}}},\"MoneroKeyImageSyncFinalAck\":{\"fields\":{\"enc_key\":{\"id\":1,\"type\":\"bytes\"}}},\"MoneroKeyImageSyncFinalRequest\":{\"fields\":{}},\"MoneroKeyImageSyncStepAck\":{\"fields\":{\"kis\":{\"id\":1,\"rule\":\"repeated\",\"type\":\"MoneroExportedKeyImage\"}},\"nested\":{\"MoneroExportedKeyImage\":{\"fields\":{\"blob\":{\"id\":3,\"type\":\"bytes\"},\"iv\":{\"id\":1,\"type\":\"bytes\"}}}}},\"MoneroKeyImageSyncStepRequest\":{\"fields\":{\"tdis\":{\"id\":1,\"rule\":\"repeated\",\"type\":\"MoneroTransferDetails\"}},\"nested\":{\"MoneroTransferDetails\":{\"fields\":{\"additional_tx_pub_keys\":{\"id\":3,\"rule\":\"repeated\",\"type\":\"bytes\"},\"internal_output_index\":{\"id\":4,\"type\":\"uint64\"},\"out_key\":{\"id\":1,\"type\":\"bytes\"},\"sub_addr_major\":{\"id\":5,\"type\":\"uint32\"},\"sub_addr_minor\":{\"id\":6,\"type\":\"uint32\"},\"tx_pub_key\":{\"id\":2,\"type\":\"bytes\"}}}}},\"MoneroLiveRefreshFinalAck\":{\"fields\":{}},\"MoneroLiveRefreshFinalRequest\":{\"fields\":{}},\"MoneroLiveRefreshStartAck\":{\"fields\":{}},\"MoneroLiveRefreshStartRequest\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"network_type\":{\"id\":2,\"type\":\"uint32\"}}},\"MoneroLiveRefreshStepAck\":{\"fields\":{\"key_image\":{\"id\":2,\"type\":\"bytes\"},\"salt\":{\"id\":1,\"type\":\"bytes\"}}},\"MoneroLiveRefreshStepRequest\":{\"fields\":{\"out_key\":{\"id\":1,\"type\":\"bytes\"},\"real_out_idx\":{\"id\":3,\"type\":\"uint64\"},\"recv_deriv\":{\"id\":2,\"type\":\"bytes\"},\"sub_addr_major\":{\"id\":4,\"type\":\"uint32\"},\"sub_addr_minor\":{\"id\":5,\"type\":\"uint32\"}}},\"MoneroTransactionAllInputsSetAck\":{\"fields\":{\"rsig_data\":{\"id\":1,\"type\":\"MoneroTransactionRsigData\"}}},\"MoneroTransactionAllInputsSetRequest\":{\"fields\":{}},\"MoneroTransactionAllOutSetAck\":{\"fields\":{\"extra\":{\"id\":1,\"type\":\"bytes\"},\"full_message_hash\":{\"id\":5,\"type\":\"bytes\"},\"rv\":{\"id\":4,\"type\":\"MoneroRingCtSig\"},\"tx_prefix_hash\":{\"id\":2,\"type\":\"bytes\"}},\"nested\":{\"MoneroRingCtSig\":{\"fields\":{\"message\":{\"id\":2,\"type\":\"bytes\"},\"rv_type\":{\"id\":3,\"type\":\"uint32\"},\"txn_fee\":{\"id\":1,\"type\":\"uint64\"}}}}},\"MoneroTransactionAllOutSetRequest\":{\"fields\":{\"rsig_data\":{\"id\":1,\"type\":\"MoneroTransactionRsigData\"}}},\"MoneroTransactionDestinationEntry\":{\"fields\":{\"addr\":{\"id\":2,\"type\":\"MoneroAccountPublicAddress\"},\"amount\":{\"id\":1,\"type\":\"uint64\"},\"is_integrated\":{\"id\":5,\"type\":\"bool\"},\"is_subaddress\":{\"id\":3,\"type\":\"bool\"},\"original\":{\"id\":4,\"type\":\"bytes\"}},\"nested\":{\"MoneroAccountPublicAddress\":{\"fields\":{\"spend_public_key\":{\"id\":1,\"type\":\"bytes\"},\"view_public_key\":{\"id\":2,\"type\":\"bytes\"}}}}},\"MoneroTransactionFinalAck\":{\"fields\":{\"cout_key\":{\"id\":1,\"type\":\"bytes\"},\"opening_key\":{\"id\":5,\"type\":\"bytes\"},\"rand_mult\":{\"id\":3,\"type\":\"bytes\"},\"salt\":{\"id\":2,\"type\":\"bytes\"},\"tx_enc_keys\":{\"id\":4,\"type\":\"bytes\"}}},\"MoneroTransactionFinalRequest\":{\"fields\":{}},\"MoneroTransactionInitAck\":{\"fields\":{\"hmacs\":{\"id\":1,\"rule\":\"repeated\",\"type\":\"bytes\"},\"rsig_data\":{\"id\":2,\"type\":\"MoneroTransactionRsigData\"}}},\"MoneroTransactionInitRequest\":{\"fields\":{\"address_n\":{\"id\":2,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"network_type\":{\"id\":3,\"type\":\"uint32\"},\"tsx_data\":{\"id\":4,\"type\":\"MoneroTransactionData\"},\"version\":{\"id\":1,\"type\":\"uint32\"}},\"nested\":{\"MoneroTransactionData\":{\"fields\":{\"account\":{\"id\":9,\"type\":\"uint32\"},\"change_dts\":{\"id\":5,\"type\":\"MoneroTransactionDestinationEntry\"},\"client_version\":{\"id\":13,\"type\":\"uint32\"},\"fee\":{\"id\":8,\"type\":\"uint64\"},\"hard_fork\":{\"id\":14,\"type\":\"uint32\"},\"integrated_indices\":{\"id\":12,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"minor_indices\":{\"id\":10,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"mixin\":{\"id\":7,\"type\":\"uint32\"},\"monero_version\":{\"id\":15,\"type\":\"bytes\"},\"num_inputs\":{\"id\":6,\"type\":\"uint32\"},\"outputs\":{\"id\":4,\"rule\":\"repeated\",\"type\":\"MoneroTransactionDestinationEntry\"},\"payment_id\":{\"id\":2,\"type\":\"bytes\"},\"rsig_data\":{\"id\":11,\"type\":\"MoneroTransactionRsigData\"},\"unlock_time\":{\"id\":3,\"type\":\"uint64\"},\"version\":{\"id\":1,\"type\":\"uint32\"}}}}},\"MoneroTransactionInputViniAck\":{\"fields\":{}},\"MoneroTransactionInputViniRequest\":{\"fields\":{\"orig_idx\":{\"id\":6,\"type\":\"uint32\"},\"pseudo_out\":{\"id\":4,\"type\":\"bytes\"},\"pseudo_out_hmac\":{\"id\":5,\"type\":\"bytes\"},\"src_entr\":{\"id\":1,\"type\":\"MoneroTransactionSourceEntry\"},\"vini\":{\"id\":2,\"type\":\"bytes\"},\"vini_hmac\":{\"id\":3,\"type\":\"bytes\"}}},\"MoneroTransactionInputsPermutationAck\":{\"fields\":{}},\"MoneroTransactionInputsPermutationRequest\":{\"fields\":{\"perm\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"}}},\"MoneroTransactionRsigData\":{\"fields\":{\"bp_version\":{\"id\":7,\"type\":\"uint32\"},\"grouping\":{\"id\":3,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint64\"},\"mask\":{\"id\":4,\"type\":\"bytes\"},\"offload_type\":{\"id\":2,\"type\":\"uint32\"},\"rsig\":{\"id\":5,\"type\":\"bytes\"},\"rsig_parts\":{\"id\":6,\"rule\":\"repeated\",\"type\":\"bytes\"},\"rsig_type\":{\"id\":1,\"type\":\"uint32\"}}},\"MoneroTransactionSetInputAck\":{\"fields\":{\"pseudo_out\":{\"id\":3,\"type\":\"bytes\"},\"pseudo_out_alpha\":{\"id\":5,\"type\":\"bytes\"},\"pseudo_out_hmac\":{\"id\":4,\"type\":\"bytes\"},\"spend_key\":{\"id\":6,\"type\":\"bytes\"},\"vini\":{\"id\":1,\"type\":\"bytes\"},\"vini_hmac\":{\"id\":2,\"type\":\"bytes\"}}},\"MoneroTransactionSetInputRequest\":{\"fields\":{\"src_entr\":{\"id\":1,\"type\":\"MoneroTransactionSourceEntry\"}}},\"MoneroTransactionSetOutputAck\":{\"fields\":{\"ecdh_info\":{\"id\":5,\"type\":\"bytes\"},\"out_pk\":{\"id\":4,\"type\":\"bytes\"},\"rsig_data\":{\"id\":3,\"type\":\"MoneroTransactionRsigData\"},\"tx_out\":{\"id\":1,\"type\":\"bytes\"},\"vouti_hmac\":{\"id\":2,\"type\":\"bytes\"}}},\"MoneroTransactionSetOutputRequest\":{\"fields\":{\"dst_entr\":{\"id\":1,\"type\":\"MoneroTransactionDestinationEntry\"},\"dst_entr_hmac\":{\"id\":2,\"type\":\"bytes\"},\"is_offloaded_bp\":{\"id\":4,\"type\":\"bool\"},\"rsig_data\":{\"id\":3,\"type\":\"MoneroTransactionRsigData\"}}},\"MoneroTransactionSignInputAck\":{\"fields\":{\"pseudo_out\":{\"id\":2,\"type\":\"bytes\"},\"signature\":{\"id\":1,\"type\":\"bytes\"}}},\"MoneroTransactionSignInputRequest\":{\"fields\":{\"orig_idx\":{\"id\":8,\"type\":\"uint32\"},\"pseudo_out\":{\"id\":4,\"type\":\"bytes\"},\"pseudo_out_alpha\":{\"id\":6,\"type\":\"bytes\"},\"pseudo_out_hmac\":{\"id\":5,\"type\":\"bytes\"},\"spend_key\":{\"id\":7,\"type\":\"bytes\"},\"src_entr\":{\"id\":1,\"type\":\"MoneroTransactionSourceEntry\"},\"vini\":{\"id\":2,\"type\":\"bytes\"},\"vini_hmac\":{\"id\":3,\"type\":\"bytes\"}}},\"MoneroTransactionSourceEntry\":{\"fields\":{\"amount\":{\"id\":6,\"type\":\"uint64\"},\"mask\":{\"id\":8,\"type\":\"bytes\"},\"multisig_kLRki\":{\"id\":9,\"type\":\"MoneroMultisigKLRki\"},\"outputs\":{\"id\":1,\"rule\":\"repeated\",\"type\":\"MoneroOutputEntry\"},\"rct\":{\"id\":7,\"type\":\"bool\"},\"real_out_additional_tx_keys\":{\"id\":4,\"rule\":\"repeated\",\"type\":\"bytes\"},\"real_out_tx_key\":{\"id\":3,\"type\":\"bytes\"},\"real_output\":{\"id\":2,\"type\":\"uint64\"},\"real_output_in_tx_index\":{\"id\":5,\"type\":\"uint64\"},\"subaddr_minor\":{\"id\":10,\"type\":\"uint32\"}},\"nested\":{\"MoneroMultisigKLRki\":{\"fields\":{\"K\":{\"id\":1,\"type\":\"bytes\"},\"L\":{\"id\":2,\"type\":\"bytes\"},\"R\":{\"id\":3,\"type\":\"bytes\"},\"ki\":{\"id\":4,\"type\":\"bytes\"}}},\"MoneroOutputEntry\":{\"fields\":{\"idx\":{\"id\":1,\"type\":\"uint64\"},\"key\":{\"id\":2,\"type\":\"MoneroRctKeyPublic\"}},\"nested\":{\"MoneroRctKeyPublic\":{\"fields\":{\"commitment\":{\"id\":2,\"type\":\"bytes\"},\"dest\":{\"id\":1,\"type\":\"bytes\"}}}}}}},\"MoneroWatchKey\":{\"fields\":{\"address\":{\"id\":2,\"type\":\"bytes\"},\"watch_key\":{\"id\":1,\"type\":\"bytes\"}}},\"MultisigRedeemScriptType\":{\"fields\":{\"address_n\":{\"id\":5,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"m\":{\"id\":3,\"rule\":\"required\",\"type\":\"uint32\"},\"nodes\":{\"id\":4,\"rule\":\"repeated\",\"type\":\"HDNodeType\"},\"pubkeys\":{\"id\":1,\"rule\":\"repeated\",\"type\":\"HDNodePathType\"},\"signatures\":{\"id\":2,\"rule\":\"repeated\",\"type\":\"bytes\"}},\"nested\":{\"HDNodePathType\":{\"fields\":{\"address_n\":{\"id\":2,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"node\":{\"id\":1,\"rule\":\"required\",\"type\":\"HDNodeType\"}}}}},\"NEMAddress\":{\"fields\":{\"address\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"}}},\"NEMDecryptMessage\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"network\":{\"id\":2,\"type\":\"uint32\"},\"payload\":{\"id\":4,\"type\":\"bytes\"},\"public_key\":{\"id\":3,\"type\":\"bytes\"}}},\"NEMDecryptedMessage\":{\"fields\":{\"payload\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"NEMGetAddress\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"network\":{\"id\":2,\"type\":\"uint32\"},\"show_display\":{\"id\":3,\"type\":\"bool\"}}},\"NEMSignTx\":{\"fields\":{\"aggregate_modification\":{\"id\":8,\"type\":\"NEMAggregateModification\"},\"cosigning\":{\"id\":4,\"type\":\"bool\"},\"importance_transfer\":{\"id\":9,\"type\":\"NEMImportanceTransfer\"},\"mosaic_creation\":{\"id\":6,\"type\":\"NEMMosaicCreation\"},\"multisig\":{\"id\":2,\"type\":\"NEMTransactionCommon\"},\"provision_namespace\":{\"id\":5,\"type\":\"NEMProvisionNamespace\"},\"supply_change\":{\"id\":7,\"type\":\"NEMMosaicSupplyChange\"},\"transaction\":{\"id\":1,\"type\":\"NEMTransactionCommon\"},\"transfer\":{\"id\":3,\"type\":\"NEMTransfer\"}},\"nested\":{\"NEMAggregateModification\":{\"fields\":{\"modifications\":{\"id\":1,\"rule\":\"repeated\",\"type\":\"NEMCosignatoryModification\"},\"relative_change\":{\"id\":2,\"type\":\"sint32\"}},\"nested\":{\"NEMCosignatoryModification\":{\"fields\":{\"public_key\":{\"id\":2,\"type\":\"bytes\"},\"type\":{\"id\":1,\"type\":\"NEMModificationType\"}},\"nested\":{\"NEMModificationType\":{\"values\":{\"CosignatoryModification_Add\":1,\"CosignatoryModification_Delete\":2}}}}}},\"NEMImportanceTransfer\":{\"fields\":{\"mode\":{\"id\":1,\"type\":\"NEMImportanceTransferMode\"},\"public_key\":{\"id\":2,\"type\":\"bytes\"}},\"nested\":{\"NEMImportanceTransferMode\":{\"values\":{\"ImportanceTransfer_Activate\":1,\"ImportanceTransfer_Deactivate\":2}}}},\"NEMMosaicCreation\":{\"fields\":{\"definition\":{\"id\":1,\"type\":\"NEMMosaicDefinition\"},\"fee\":{\"id\":3,\"type\":\"uint64\"},\"sink\":{\"id\":2,\"type\":\"string\"}},\"nested\":{\"NEMMosaicDefinition\":{\"fields\":{\"description\":{\"id\":14,\"type\":\"string\"},\"divisibility\":{\"id\":5,\"type\":\"uint32\"},\"fee\":{\"id\":7,\"type\":\"uint64\"},\"levy\":{\"id\":6,\"type\":\"NEMMosaicLevy\"},\"levy_address\":{\"id\":8,\"type\":\"string\"},\"levy_mosaic\":{\"id\":10,\"type\":\"string\"},\"levy_namespace\":{\"id\":9,\"type\":\"string\"},\"mosaic\":{\"id\":4,\"type\":\"string\"},\"mutable_supply\":{\"id\":12,\"type\":\"bool\"},\"name\":{\"id\":1,\"type\":\"string\"},\"namespace\":{\"id\":3,\"type\":\"string\"},\"networks\":{\"id\":15,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"supply\":{\"id\":11,\"type\":\"uint64\"},\"ticker\":{\"id\":2,\"type\":\"string\"},\"transferable\":{\"id\":13,\"type\":\"bool\"}},\"nested\":{\"NEMMosaicLevy\":{\"values\":{\"MosaicLevy_Absolute\":1,\"MosaicLevy_Percentile\":2}}}}}},\"NEMMosaicSupplyChange\":{\"fields\":{\"delta\":{\"id\":4,\"type\":\"uint64\"},\"mosaic\":{\"id\":2,\"type\":\"string\"},\"namespace\":{\"id\":1,\"type\":\"string\"},\"type\":{\"id\":3,\"type\":\"NEMSupplyChangeType\"}},\"nested\":{\"NEMSupplyChangeType\":{\"values\":{\"SupplyChange_Decrease\":2,\"SupplyChange_Increase\":1}}}},\"NEMProvisionNamespace\":{\"fields\":{\"fee\":{\"id\":4,\"type\":\"uint64\"},\"namespace\":{\"id\":1,\"type\":\"string\"},\"parent\":{\"id\":2,\"type\":\"string\"},\"sink\":{\"id\":3,\"type\":\"string\"}}},\"NEMTransactionCommon\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"deadline\":{\"id\":5,\"type\":\"uint32\"},\"fee\":{\"id\":4,\"type\":\"uint64\"},\"network\":{\"id\":2,\"type\":\"uint32\"},\"signer\":{\"id\":6,\"type\":\"bytes\"},\"timestamp\":{\"id\":3,\"type\":\"uint32\"}}},\"NEMTransfer\":{\"fields\":{\"amount\":{\"id\":2,\"type\":\"uint64\"},\"mosaics\":{\"id\":5,\"rule\":\"repeated\",\"type\":\"NEMMosaic\"},\"payload\":{\"id\":3,\"type\":\"bytes\"},\"public_key\":{\"id\":4,\"type\":\"bytes\"},\"recipient\":{\"id\":1,\"type\":\"string\"}},\"nested\":{\"NEMMosaic\":{\"fields\":{\"mosaic\":{\"id\":2,\"type\":\"string\"},\"namespace\":{\"id\":1,\"type\":\"string\"},\"quantity\":{\"id\":3,\"type\":\"uint64\"}}}}}}},\"NEMSignedTx\":{\"fields\":{\"data\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"},\"signature\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"NFTWriteData\":{\"fields\":{\"data\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"},\"index\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint32\"},\"offset\":{\"id\":3,\"rule\":\"required\",\"type\":\"uint32\"}}},\"NFTWriteInfo\":{\"fields\":{\"height\":{\"id\":3,\"rule\":\"required\",\"type\":\"uint32\"},\"index\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint32\"},\"name_en\":{\"id\":5,\"type\":\"string\"},\"name_zh\":{\"id\":4,\"type\":\"string\"},\"width\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint32\"}}},\"NearAddress\":{\"fields\":{\"address\":{\"id\":1,\"type\":\"string\"}}},\"NearGetAddress\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"show_display\":{\"id\":2,\"type\":\"bool\"}}},\"NearSignTx\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"raw_tx\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"NearSignedTx\":{\"fields\":{\"signature\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"NeoAddress\":{\"fields\":{\"address\":{\"id\":1,\"type\":\"string\"},\"public_key\":{\"id\":2,\"type\":\"bytes\"}}},\"NeoGetAddress\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"show_display\":{\"id\":2,\"type\":\"bool\"}}},\"NeoSignTx\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"network_magic\":{\"id\":3,\"options\":{\"default\":860833102},\"type\":\"uint32\"},\"raw_tx\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"NeoSignedTx\":{\"fields\":{\"public_key\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"},\"signature\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"NervosAddress\":{\"fields\":{\"address\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"}}},\"NervosGetAddress\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"network\":{\"id\":2,\"rule\":\"required\",\"type\":\"string\"},\"show_display\":{\"id\":3,\"type\":\"bool\"}}},\"NervosSignTx\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"data_initial_chunk\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"},\"data_length\":{\"id\":5,\"type\":\"uint32\"},\"network\":{\"id\":4,\"rule\":\"required\",\"type\":\"string\"},\"witness_buffer\":{\"id\":3,\"rule\":\"required\",\"type\":\"bytes\"}}},\"NervosSignedTx\":{\"fields\":{\"address\":{\"id\":2,\"rule\":\"required\",\"type\":\"string\"},\"signature\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"NervosTxAck\":{\"fields\":{\"data_chunk\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"NervosTxRequest\":{\"fields\":{\"data_length\":{\"id\":1,\"type\":\"uint32\"},\"public_key\":{\"id\":2,\"type\":\"bytes\"},\"signature\":{\"id\":3,\"type\":\"bytes\"}}},\"NexaAddress\":{\"fields\":{\"address\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"},\"public_key\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"NexaGetAddress\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"prefix\":{\"id\":3,\"options\":{\"default\":\"nexa\"},\"type\":\"string\"},\"show_display\":{\"id\":2,\"type\":\"bool\"}}},\"NexaSignTx\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"input_count\":{\"id\":4,\"options\":{\"default\":1},\"type\":\"uint32\"},\"prefix\":{\"id\":3,\"options\":{\"default\":\"nexa\"},\"type\":\"string\"},\"raw_message\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"NexaSignedTx\":{\"fields\":{\"signature\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"NexaTxInputAck\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"raw_message\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"NexaTxInputRequest\":{\"fields\":{\"request_index\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint32\"},\"signature\":{\"id\":2,\"type\":\"bytes\"}}},\"NextU2FCounter\":{\"fields\":{\"u2f_counter\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint32\"}}},\"NostrDecryptMessage\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"msg\":{\"id\":3,\"rule\":\"required\",\"type\":\"string\"},\"pubkey\":{\"id\":2,\"rule\":\"required\",\"type\":\"string\"},\"show_display\":{\"id\":4,\"type\":\"bool\"}}},\"NostrDecryptedMessage\":{\"fields\":{\"msg\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"}}},\"NostrEncryptMessage\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"msg\":{\"id\":3,\"rule\":\"required\",\"type\":\"string\"},\"pubkey\":{\"id\":2,\"rule\":\"required\",\"type\":\"string\"},\"show_display\":{\"id\":4,\"type\":\"bool\"}}},\"NostrEncryptedMessage\":{\"fields\":{\"msg\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"}}},\"NostrGetPublicKey\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"show_display\":{\"id\":2,\"type\":\"bool\"}}},\"NostrPublicKey\":{\"fields\":{\"npub\":{\"id\":2,\"type\":\"string\"},\"publickey\":{\"id\":1,\"type\":\"string\"}}},\"NostrSignEvent\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"event\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"NostrSignSchnorr\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"hash\":{\"id\":2,\"rule\":\"required\",\"type\":\"string\"}}},\"NostrSignedEvent\":{\"fields\":{\"event\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"NostrSignedSchnorr\":{\"fields\":{\"signature\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"OneKeyDeviceType\":{\"values\":{\"CLASSIC\":0,\"CLASSIC1S\":1,\"MINI\":2,\"PRO\":5,\"PURE\":6,\"TOUCH\":3}},\"OneKeySEState\":{\"values\":{\"APP\":1,\"BOOT\":0}},\"OneKeySeType\":{\"values\":{\"SE608A\":1,\"THD89\":0}},\"OnekeyFeatures\":{\"fields\":{\"onekey_ble_build_id\":{\"id\":14,\"type\":\"string\"},\"onekey_ble_hash\":{\"id\":15,\"type\":\"bytes\"},\"onekey_ble_name\":{\"id\":12,\"type\":\"string\"},\"onekey_ble_version\":{\"id\":13,\"type\":\"string\"},\"onekey_board_build_id\":{\"id\":8,\"type\":\"string\"},\"onekey_board_hash\":{\"id\":5,\"type\":\"bytes\"},\"onekey_board_version\":{\"id\":2,\"type\":\"string\"},\"onekey_boot_build_id\":{\"id\":9,\"type\":\"string\"},\"onekey_boot_hash\":{\"id\":6,\"type\":\"bytes\"},\"onekey_boot_version\":{\"id\":3,\"type\":\"string\"},\"onekey_device_type\":{\"id\":1,\"type\":\"OneKeyDeviceType\"},\"onekey_firmware_build_id\":{\"id\":10,\"type\":\"string\"},\"onekey_firmware_hash\":{\"id\":7,\"type\":\"bytes\"},\"onekey_firmware_version\":{\"id\":4,\"type\":\"string\"},\"onekey_se01_boot_build_id\":{\"id\":41,\"type\":\"string\"},\"onekey_se01_boot_hash\":{\"id\":37,\"type\":\"bytes\"},\"onekey_se01_boot_version\":{\"id\":33,\"type\":\"string\"},\"onekey_se01_build_id\":{\"id\":29,\"type\":\"string\"},\"onekey_se01_hash\":{\"id\":25,\"type\":\"bytes\"},\"onekey_se01_state\":{\"id\":17,\"type\":\"OneKeySEState\"},\"onekey_se01_version\":{\"id\":21,\"type\":\"string\"},\"onekey_se02_boot_build_id\":{\"id\":42,\"type\":\"string\"},\"onekey_se02_boot_hash\":{\"id\":38,\"type\":\"bytes\"},\"onekey_se02_boot_version\":{\"id\":34,\"type\":\"string\"},\"onekey_se02_build_id\":{\"id\":30,\"type\":\"string\"},\"onekey_se02_hash\":{\"id\":26,\"type\":\"bytes\"},\"onekey_se02_state\":{\"id\":18,\"type\":\"OneKeySEState\"},\"onekey_se02_version\":{\"id\":22,\"type\":\"string\"},\"onekey_se03_boot_build_id\":{\"id\":43,\"type\":\"string\"},\"onekey_se03_boot_hash\":{\"id\":39,\"type\":\"bytes\"},\"onekey_se03_boot_version\":{\"id\":35,\"type\":\"string\"},\"onekey_se03_build_id\":{\"id\":31,\"type\":\"string\"},\"onekey_se03_hash\":{\"id\":27,\"type\":\"bytes\"},\"onekey_se03_state\":{\"id\":19,\"type\":\"OneKeySEState\"},\"onekey_se03_version\":{\"id\":23,\"type\":\"string\"},\"onekey_se04_boot_build_id\":{\"id\":44,\"type\":\"string\"},\"onekey_se04_boot_hash\":{\"id\":40,\"type\":\"bytes\"},\"onekey_se04_boot_version\":{\"id\":36,\"type\":\"string\"},\"onekey_se04_build_id\":{\"id\":32,\"type\":\"string\"},\"onekey_se04_hash\":{\"id\":28,\"type\":\"bytes\"},\"onekey_se04_state\":{\"id\":20,\"type\":\"OneKeySEState\"},\"onekey_se04_version\":{\"id\":24,\"type\":\"string\"},\"onekey_se_type\":{\"id\":16,\"type\":\"OneKeySeType\"},\"onekey_serial_no\":{\"id\":11,\"type\":\"string\"}}},\"OnekeyGetFeatures\":{\"fields\":{}},\"OutputScriptType\":{\"values\":{\"PAYTOADDRESS\":0,\"PAYTOMULTISIG\":2,\"PAYTOOPRETURN\":3,\"PAYTOP2SHWITNESS\":5,\"PAYTOSCRIPTHASH\":1,\"PAYTOTAPROOT\":6,\"PAYTOWITNESS\":4}},\"OwnershipId\":{\"fields\":{\"ownership_id\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"OwnershipProof\":{\"fields\":{\"ownership_proof\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"},\"signature\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"PassphraseAck\":{\"fields\":{\"_state\":{\"id\":2,\"options\":{\"deprecated\":true},\"type\":\"bytes\"},\"on_device\":{\"id\":3,\"type\":\"bool\"},\"on_device_attach_pin\":{\"id\":8000,\"type\":\"bool\"},\"passphrase\":{\"id\":1,\"type\":\"string\"}}},\"PassphraseRequest\":{\"fields\":{\"_on_device\":{\"id\":1,\"options\":{\"deprecated\":true},\"type\":\"bool\"},\"exists_attach_pin_user\":{\"id\":8000,\"type\":\"bool\"}}},\"PassphraseState\":{\"fields\":{\"passphrase_state\":{\"id\":1,\"type\":\"string\"},\"session_id\":{\"id\":2,\"type\":\"bytes\"},\"unlocked_attach_pin\":{\"id\":3,\"type\":\"bool\"}}},\"PinMatrixAck\":{\"fields\":{\"new_pin\":{\"id\":2,\"type\":\"string\"},\"pin\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"}}},\"PinMatrixRequest\":{\"fields\":{\"type\":{\"id\":1,\"type\":\"PinMatrixRequestType\"}},\"nested\":{\"PinMatrixRequestType\":{\"values\":{\"PinMatrixRequestType_AttachToPin\":8000,\"PinMatrixRequestType_BackupFirst\":6,\"PinMatrixRequestType_BackupSecond\":7,\"PinMatrixRequestType_Current\":1,\"PinMatrixRequestType_NewFirst\":2,\"PinMatrixRequestType_NewSecond\":3,\"PinMatrixRequestType_WipeCodeFirst\":4,\"PinMatrixRequestType_WipeCodeSecond\":5}}}},\"Ping\":{\"fields\":{\"button_protection\":{\"id\":2,\"type\":\"bool\"},\"message\":{\"id\":1,\"options\":{\"default\":\"\"},\"type\":\"string\"}}},\"PolkadotAddress\":{\"fields\":{\"address\":{\"id\":1,\"type\":\"string\"},\"public_key\":{\"id\":2,\"type\":\"string\"}}},\"PolkadotGetAddress\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"network\":{\"id\":3,\"rule\":\"required\",\"type\":\"string\"},\"prefix\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint32\"},\"show_display\":{\"id\":4,\"type\":\"bool\"}}},\"PolkadotSignTx\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"network\":{\"id\":3,\"rule\":\"required\",\"type\":\"string\"},\"prefix\":{\"id\":4,\"type\":\"uint32\"},\"raw_tx\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"PolkadotSignedTx\":{\"fields\":{\"signature\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"PreauthorizedRequest\":{\"fields\":{}},\"PrevInput\":{\"fields\":{\"decred_tree\":{\"id\":9,\"type\":\"uint32\"},\"prev_hash\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"},\"prev_index\":{\"id\":3,\"rule\":\"required\",\"type\":\"uint32\"},\"script_sig\":{\"id\":4,\"rule\":\"required\",\"type\":\"bytes\"},\"sequence\":{\"id\":5,\"rule\":\"required\",\"type\":\"uint32\"}}},\"PrevOutput\":{\"fields\":{\"amount\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint64\"},\"decred_script_version\":{\"id\":3,\"type\":\"uint32\"},\"script_pubkey\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"PrevTx\":{\"fields\":{\"branch_id\":{\"id\":14,\"type\":\"uint32\"},\"expiry\":{\"id\":10,\"type\":\"uint32\"},\"extra_data_len\":{\"id\":9,\"options\":{\"default\":0},\"type\":\"uint32\"},\"inputs_count\":{\"id\":6,\"rule\":\"required\",\"type\":\"uint32\"},\"lock_time\":{\"id\":4,\"rule\":\"required\",\"type\":\"uint32\"},\"outputs_count\":{\"id\":7,\"rule\":\"required\",\"type\":\"uint32\"},\"timestamp\":{\"id\":13,\"type\":\"uint32\"},\"version\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint32\"},\"version_group_id\":{\"id\":12,\"type\":\"uint32\"}}},\"PublicKey\":{\"fields\":{\"node\":{\"id\":1,\"rule\":\"required\",\"type\":\"HDNodeType\"},\"root_fingerprint\":{\"id\":3,\"type\":\"uint32\"},\"xpub\":{\"id\":2,\"rule\":\"required\",\"type\":\"string\"}}},\"PublicKeyMultiple\":{\"fields\":{\"xpubs\":{\"id\":1,\"rule\":\"repeated\",\"type\":\"string\"}}},\"ReadSEPublicCert\":{\"fields\":{}},\"ReadSEPublicKey\":{\"fields\":{}},\"Reboot\":{\"fields\":{\"reboot_type\":{\"id\":1,\"rule\":\"required\",\"type\":\"RebootType\"}}},\"RebootToBoardloader\":{\"fields\":{}},\"RebootToBootloader\":{\"fields\":{}},\"RebootType\":{\"values\":{\"Boardloader\":1,\"BootLoader\":2,\"Normal\":0}},\"RecoveryDevice\":{\"fields\":{\"dry_run\":{\"id\":10,\"type\":\"bool\"},\"enforce_wordlist\":{\"id\":6,\"type\":\"bool\"},\"label\":{\"id\":5,\"type\":\"string\"},\"language\":{\"id\":4,\"type\":\"string\"},\"passphrase_protection\":{\"id\":2,\"type\":\"bool\"},\"pin_protection\":{\"id\":3,\"type\":\"bool\"},\"type\":{\"id\":8,\"type\":\"RecoveryDeviceType\"},\"u2f_counter\":{\"id\":9,\"type\":\"uint32\"},\"word_count\":{\"id\":1,\"type\":\"uint32\"}},\"nested\":{\"RecoveryDeviceType\":{\"values\":{\"RecoveryDeviceType_Matrix\":1,\"RecoveryDeviceType_ScrambledWords\":0}}}},\"ResetDevice\":{\"fields\":{\"backup_type\":{\"id\":10,\"options\":{\"default\":\"Bip39\"},\"type\":\"BackupType\"},\"display_random\":{\"id\":1,\"type\":\"bool\"},\"label\":{\"id\":6,\"type\":\"string\"},\"language\":{\"id\":5,\"options\":{\"default\":\"en-US\"},\"type\":\"string\"},\"no_backup\":{\"id\":9,\"type\":\"bool\"},\"passphrase_protection\":{\"id\":3,\"type\":\"bool\"},\"pin_protection\":{\"id\":4,\"type\":\"bool\"},\"skip_backup\":{\"id\":8,\"type\":\"bool\"},\"strength\":{\"id\":2,\"options\":{\"default\":256},\"type\":\"uint32\"},\"u2f_counter\":{\"id\":7,\"type\":\"uint32\"}}},\"ResourceAck\":{\"fields\":{\"data_chunk\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"},\"hash\":{\"id\":2,\"type\":\"bytes\"}}},\"ResourceRequest\":{\"fields\":{\"data_length\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint32\"},\"offset\":{\"id\":1,\"type\":\"uint32\"}}},\"ResourceUpdate\":{\"fields\":{\"data_length\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint32\"},\"file_name\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"},\"hash\":{\"id\":4,\"type\":\"bytes\"},\"initial_data_chunk\":{\"id\":3,\"rule\":\"required\",\"type\":\"bytes\"}}},\"ResourceUpload\":{\"fields\":{\"blur_data_length\":{\"id\":7,\"type\":\"uint32\"},\"data_length\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint32\"},\"extension\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"},\"file_name_no_ext\":{\"id\":6,\"type\":\"string\"},\"nft_meta_data\":{\"id\":4,\"type\":\"bytes\"},\"res_type\":{\"id\":3,\"rule\":\"required\",\"type\":\"ResourceType\"},\"zoom_data_length\":{\"id\":5,\"rule\":\"required\",\"type\":\"uint32\"}},\"nested\":{\"ResourceType\":{\"values\":{\"Nft\":1,\"WallPaper\":0}}}},\"RippleAddress\":{\"fields\":{\"address\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"}}},\"RippleGetAddress\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"show_display\":{\"id\":2,\"type\":\"bool\"}}},\"RippleSignTx\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"fee\":{\"id\":2,\"type\":\"uint64\"},\"flags\":{\"id\":3,\"type\":\"uint32\"},\"last_ledger_sequence\":{\"id\":5,\"type\":\"uint32\"},\"payment\":{\"id\":6,\"type\":\"RipplePayment\"},\"sequence\":{\"id\":4,\"type\":\"uint32\"}},\"nested\":{\"RipplePayment\":{\"fields\":{\"amount\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint64\"},\"destination\":{\"id\":2,\"rule\":\"required\",\"type\":\"string\"},\"destination_tag\":{\"id\":3,\"type\":\"uint32\"}}}}},\"RippleSignedTx\":{\"fields\":{\"serialized_tx\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"},\"signature\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"SEMessageSignature\":{\"fields\":{\"signature\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"SEPublicCert\":{\"fields\":{\"public_cert\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"SEPublicKey\":{\"fields\":{\"public_key\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"SESignMessage\":{\"fields\":{\"message\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"SafetyCheckLevel\":{\"values\":{\"PromptAlways\":1,\"PromptTemporarily\":2,\"Strict\":0}},\"ScdoAddress\":{\"fields\":{\"address\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"}}},\"ScdoGetAddress\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"show_display\":{\"id\":2,\"type\":\"bool\"}}},\"ScdoSignMessage\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"message\":{\"id\":2,\"type\":\"bytes\"}}},\"ScdoSignTx\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"data_initial_chunk\":{\"id\":8,\"options\":{\"default\":\"\"},\"type\":\"bytes\"},\"data_length\":{\"id\":9,\"options\":{\"default\":0},\"type\":\"uint32\"},\"gas_limit\":{\"id\":4,\"rule\":\"required\",\"type\":\"bytes\"},\"gas_price\":{\"id\":3,\"rule\":\"required\",\"type\":\"bytes\"},\"nonce\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"},\"timestamp\":{\"id\":7,\"type\":\"bytes\"},\"to\":{\"id\":5,\"rule\":\"required\",\"type\":\"string\"},\"tx_type\":{\"id\":10,\"options\":{\"default\":0},\"type\":\"uint32\"},\"value\":{\"id\":6,\"rule\":\"required\",\"type\":\"bytes\"}}},\"ScdoSignedMessage\":{\"fields\":{\"address\":{\"id\":2,\"type\":\"string\"},\"signature\":{\"id\":1,\"type\":\"bytes\"}}},\"ScdoSignedTx\":{\"fields\":{\"data_length\":{\"id\":1,\"type\":\"uint32\"},\"signature\":{\"id\":2,\"type\":\"bytes\"}}},\"ScdoTxAck\":{\"fields\":{\"data_chunk\":{\"id\":1,\"type\":\"bytes\"}}},\"SdProtect\":{\"fields\":{\"operation\":{\"id\":1,\"rule\":\"required\",\"type\":\"SdProtectOperationType\"}},\"nested\":{\"SdProtectOperationType\":{\"values\":{\"DISABLE\":0,\"ENABLE\":1,\"REFRESH\":2}}}},\"SelfTest\":{\"fields\":{\"payload\":{\"id\":1,\"type\":\"bytes\"}}},\"SetU2FCounter\":{\"fields\":{\"u2f_counter\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint32\"}}},\"SignIdentity\":{\"fields\":{\"challenge_hidden\":{\"id\":2,\"options\":{\"default\":\"\"},\"type\":\"bytes\"},\"challenge_visual\":{\"id\":3,\"options\":{\"default\":\"\"},\"type\":\"string\"},\"ecdsa_curve_name\":{\"id\":4,\"type\":\"string\"},\"identity\":{\"id\":1,\"rule\":\"required\",\"type\":\"IdentityType\"}}},\"SignMessage\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"coin_name\":{\"id\":3,\"options\":{\"default\":\"Bitcoin\"},\"type\":\"string\"},\"is_bip322_simple\":{\"id\":10,\"options\":{\"default\":false},\"type\":\"bool\"},\"message\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"},\"no_script_type\":{\"id\":5,\"type\":\"bool\"},\"script_type\":{\"id\":4,\"options\":{\"default\":\"SPENDADDRESS\"},\"type\":\"InputScriptType\"}}},\"SignPsbt\":{\"fields\":{\"coin_name\":{\"id\":2,\"options\":{\"default\":\"Bitcoin\"},\"type\":\"string\"},\"psbt\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"SignTx\":{\"fields\":{\"amount_unit\":{\"id\":11,\"options\":{\"default\":\"BITCOIN\"},\"type\":\"AmountUnit\"},\"branch_id\":{\"id\":10,\"type\":\"uint32\"},\"coin_name\":{\"id\":3,\"options\":{\"default\":\"Bitcoin\"},\"type\":\"string\"},\"decred_staking_ticket\":{\"id\":12,\"options\":{\"default\":false},\"type\":\"bool\"},\"expiry\":{\"id\":6,\"type\":\"uint32\"},\"inputs_count\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint32\"},\"lock_time\":{\"id\":5,\"options\":{\"default\":0},\"type\":\"uint32\"},\"outputs_count\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint32\"},\"overwintered\":{\"id\":7,\"options\":{\"deprecated\":true},\"type\":\"bool\"},\"timestamp\":{\"id\":9,\"type\":\"uint32\"},\"version\":{\"id\":4,\"options\":{\"default\":1},\"type\":\"uint32\"},\"version_group_id\":{\"id\":8,\"type\":\"uint32\"}}},\"SignedIdentity\":{\"fields\":{\"address\":{\"id\":1,\"type\":\"string\"},\"public_key\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"},\"signature\":{\"id\":3,\"rule\":\"required\",\"type\":\"bytes\"}}},\"SignedPsbt\":{\"fields\":{\"psbt\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"SolanaAddress\":{\"fields\":{\"address\":{\"id\":1,\"type\":\"string\"}}},\"SolanaGetAddress\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"show_display\":{\"id\":2,\"type\":\"bool\"}}},\"SolanaMessageSignature\":{\"fields\":{\"public_key\":{\"id\":2,\"type\":\"bytes\"},\"signature\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"SolanaOffChainMessageFormat\":{\"values\":{\"V0_LIMITED_UTF8\":1,\"V0_RESTRICTED_ASCII\":0}},\"SolanaOffChainMessageVersion\":{\"values\":{\"MESSAGE_VERSION_0\":0,\"MESSAGE_VERSION_1\":1}},\"SolanaSignOffChainMessage\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"application_domain\":{\"id\":5,\"type\":\"bytes\"},\"message\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"},\"message_format\":{\"id\":4,\"type\":\"SolanaOffChainMessageFormat\"},\"message_version\":{\"id\":3,\"options\":{\"default\":\"MESSAGE_VERSION_0\"},\"type\":\"SolanaOffChainMessageVersion\"},\"required_signers\":{\"id\":7,\"rule\":\"repeated\",\"type\":\"bytes\"}}},\"SolanaSignTx\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"extra_info\":{\"id\":3,\"type\":\"SolanaTxExtraInfo\"},\"raw_tx\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"SolanaSignUnsafeMessage\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"message\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"SolanaSignedTx\":{\"fields\":{\"signature\":{\"id\":1,\"type\":\"bytes\"}}},\"SolanaTxATADetails\":{\"fields\":{\"associated_token_address\":{\"id\":4,\"rule\":\"required\",\"type\":\"string\"},\"mint_address\":{\"id\":3,\"rule\":\"required\",\"type\":\"string\"},\"owner_address\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"},\"program_id\":{\"id\":2,\"rule\":\"required\",\"type\":\"string\"}}},\"SolanaTxExtraInfo\":{\"fields\":{\"ata_details\":{\"id\":1,\"rule\":\"repeated\",\"type\":\"SolanaTxATADetails\"}}},\"SpiFlashData\":{\"fields\":{\"data\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"SpiFlashRead\":{\"fields\":{\"address\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint32\"},\"len\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint32\"}}},\"SpiFlashWrite\":{\"fields\":{\"address\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint32\"},\"data\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"StarcoinAddress\":{\"fields\":{\"address\":{\"id\":1,\"type\":\"string\"}}},\"StarcoinGetAddress\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"show_display\":{\"id\":2,\"type\":\"bool\"}}},\"StarcoinGetPublicKey\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"show_display\":{\"id\":2,\"type\":\"bool\"}}},\"StarcoinMessageSignature\":{\"fields\":{\"public_key\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"},\"signature\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"StarcoinPublicKey\":{\"fields\":{\"public_key\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"StarcoinSignMessage\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"message\":{\"id\":2,\"type\":\"bytes\"}}},\"StarcoinSignTx\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"raw_tx\":{\"id\":2,\"type\":\"bytes\"}}},\"StarcoinSignedTx\":{\"fields\":{\"public_key\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"},\"signature\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"StarcoinVerifyMessage\":{\"fields\":{\"message\":{\"id\":3,\"type\":\"bytes\"},\"public_key\":{\"id\":1,\"type\":\"bytes\"},\"signature\":{\"id\":2,\"type\":\"bytes\"}}},\"StellarAccountMergeOp\":{\"fields\":{\"destination_account\":{\"id\":2,\"rule\":\"required\",\"type\":\"string\"},\"source_account\":{\"id\":1,\"type\":\"string\"}}},\"StellarAddress\":{\"fields\":{\"address\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"}}},\"StellarAllowTrustOp\":{\"fields\":{\"asset_code\":{\"id\":4,\"type\":\"string\"},\"asset_type\":{\"id\":3,\"rule\":\"required\",\"type\":\"StellarAssetType\"},\"is_authorized\":{\"id\":5,\"rule\":\"required\",\"type\":\"bool\"},\"source_account\":{\"id\":1,\"type\":\"string\"},\"trusted_account\":{\"id\":2,\"rule\":\"required\",\"type\":\"string\"}}},\"StellarAsset\":{\"fields\":{\"code\":{\"id\":2,\"type\":\"string\"},\"issuer\":{\"id\":3,\"type\":\"string\"},\"type\":{\"id\":1,\"rule\":\"required\",\"type\":\"StellarAssetType\"}}},\"StellarAssetType\":{\"values\":{\"ALPHANUM12\":2,\"ALPHANUM4\":1,\"NATIVE\":0}},\"StellarBumpSequenceOp\":{\"fields\":{\"bump_to\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint64\"},\"source_account\":{\"id\":1,\"type\":\"string\"}}},\"StellarChangeTrustOp\":{\"fields\":{\"asset\":{\"id\":2,\"rule\":\"required\",\"type\":\"StellarAsset\"},\"limit\":{\"id\":3,\"rule\":\"required\",\"type\":\"uint64\"},\"source_account\":{\"id\":1,\"type\":\"string\"}}},\"StellarCreateAccountOp\":{\"fields\":{\"new_account\":{\"id\":2,\"rule\":\"required\",\"type\":\"string\"},\"source_account\":{\"id\":1,\"type\":\"string\"},\"starting_balance\":{\"id\":3,\"rule\":\"required\",\"type\":\"sint64\"}}},\"StellarCreatePassiveSellOfferOp\":{\"fields\":{\"amount\":{\"id\":4,\"rule\":\"required\",\"type\":\"sint64\"},\"buying_asset\":{\"id\":3,\"rule\":\"required\",\"type\":\"StellarAsset\"},\"price_d\":{\"id\":6,\"rule\":\"required\",\"type\":\"uint32\"},\"price_n\":{\"id\":5,\"rule\":\"required\",\"type\":\"uint32\"},\"selling_asset\":{\"id\":2,\"rule\":\"required\",\"type\":\"StellarAsset\"},\"source_account\":{\"id\":1,\"type\":\"string\"}}},\"StellarGetAddress\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"show_display\":{\"id\":2,\"type\":\"bool\"}}},\"StellarInvokeHostFunctionOp\":{\"fields\":{\"call_args_xdr_initial_chunk\":{\"id\":5,\"rule\":\"required\",\"type\":\"bytes\"},\"call_args_xdr_size\":{\"id\":4,\"rule\":\"required\",\"type\":\"uint32\"},\"contract_address\":{\"id\":2,\"rule\":\"required\",\"type\":\"string\"},\"function_name\":{\"id\":3,\"rule\":\"required\",\"type\":\"string\"},\"soroban_auth_xdr_initial_chunk\":{\"id\":7,\"rule\":\"required\",\"type\":\"bytes\"},\"soroban_auth_xdr_size\":{\"id\":6,\"rule\":\"required\",\"type\":\"uint32\"},\"source_account\":{\"id\":1,\"type\":\"string\"}}},\"StellarManageBuyOfferOp\":{\"fields\":{\"amount\":{\"id\":4,\"rule\":\"required\",\"type\":\"sint64\"},\"buying_asset\":{\"id\":3,\"rule\":\"required\",\"type\":\"StellarAsset\"},\"offer_id\":{\"id\":7,\"rule\":\"required\",\"type\":\"uint64\"},\"price_d\":{\"id\":6,\"rule\":\"required\",\"type\":\"uint32\"},\"price_n\":{\"id\":5,\"rule\":\"required\",\"type\":\"uint32\"},\"selling_asset\":{\"id\":2,\"rule\":\"required\",\"type\":\"StellarAsset\"},\"source_account\":{\"id\":1,\"type\":\"string\"}}},\"StellarManageDataOp\":{\"fields\":{\"key\":{\"id\":2,\"rule\":\"required\",\"type\":\"string\"},\"source_account\":{\"id\":1,\"type\":\"string\"},\"value\":{\"id\":3,\"type\":\"bytes\"}}},\"StellarManageSellOfferOp\":{\"fields\":{\"amount\":{\"id\":4,\"rule\":\"required\",\"type\":\"sint64\"},\"buying_asset\":{\"id\":3,\"rule\":\"required\",\"type\":\"StellarAsset\"},\"offer_id\":{\"id\":7,\"rule\":\"required\",\"type\":\"uint64\"},\"price_d\":{\"id\":6,\"rule\":\"required\",\"type\":\"uint32\"},\"price_n\":{\"id\":5,\"rule\":\"required\",\"type\":\"uint32\"},\"selling_asset\":{\"id\":2,\"rule\":\"required\",\"type\":\"StellarAsset\"},\"source_account\":{\"id\":1,\"type\":\"string\"}}},\"StellarPathPaymentStrictReceiveOp\":{\"fields\":{\"destination_account\":{\"id\":4,\"rule\":\"required\",\"type\":\"string\"},\"destination_amount\":{\"id\":6,\"rule\":\"required\",\"type\":\"sint64\"},\"destination_asset\":{\"id\":5,\"rule\":\"required\",\"type\":\"StellarAsset\"},\"paths\":{\"id\":7,\"rule\":\"repeated\",\"type\":\"StellarAsset\"},\"send_asset\":{\"id\":2,\"rule\":\"required\",\"type\":\"StellarAsset\"},\"send_max\":{\"id\":3,\"rule\":\"required\",\"type\":\"sint64\"},\"source_account\":{\"id\":1,\"type\":\"string\"}}},\"StellarPathPaymentStrictSendOp\":{\"fields\":{\"destination_account\":{\"id\":4,\"rule\":\"required\",\"type\":\"string\"},\"destination_asset\":{\"id\":5,\"rule\":\"required\",\"type\":\"StellarAsset\"},\"destination_min\":{\"id\":6,\"rule\":\"required\",\"type\":\"sint64\"},\"paths\":{\"id\":7,\"rule\":\"repeated\",\"type\":\"StellarAsset\"},\"send_amount\":{\"id\":3,\"rule\":\"required\",\"type\":\"sint64\"},\"send_asset\":{\"id\":2,\"rule\":\"required\",\"type\":\"StellarAsset\"},\"source_account\":{\"id\":1,\"type\":\"string\"}}},\"StellarPaymentOp\":{\"fields\":{\"amount\":{\"id\":4,\"rule\":\"required\",\"type\":\"sint64\"},\"asset\":{\"id\":3,\"rule\":\"required\",\"type\":\"StellarAsset\"},\"destination_account\":{\"id\":2,\"rule\":\"required\",\"type\":\"string\"},\"source_account\":{\"id\":1,\"type\":\"string\"}}},\"StellarSetOptionsOp\":{\"fields\":{\"clear_flags\":{\"id\":3,\"type\":\"uint32\"},\"high_threshold\":{\"id\":8,\"type\":\"uint32\"},\"home_domain\":{\"id\":9,\"type\":\"string\"},\"inflation_destination_account\":{\"id\":2,\"type\":\"string\"},\"low_threshold\":{\"id\":6,\"type\":\"uint32\"},\"master_weight\":{\"id\":5,\"type\":\"uint32\"},\"medium_threshold\":{\"id\":7,\"type\":\"uint32\"},\"set_flags\":{\"id\":4,\"type\":\"uint32\"},\"signer_key\":{\"id\":11,\"type\":\"bytes\"},\"signer_type\":{\"id\":10,\"type\":\"StellarSignerType\"},\"signer_weight\":{\"id\":12,\"type\":\"uint32\"},\"source_account\":{\"id\":1,\"type\":\"string\"}},\"nested\":{\"StellarSignerType\":{\"values\":{\"ACCOUNT\":0,\"HASH\":2,\"PRE_AUTH\":1}}}},\"StellarSignTx\":{\"fields\":{\"address_n\":{\"id\":2,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"fee\":{\"id\":5,\"rule\":\"required\",\"type\":\"uint32\"},\"memo_hash\":{\"id\":13,\"type\":\"bytes\"},\"memo_id\":{\"id\":12,\"type\":\"uint64\"},\"memo_text\":{\"id\":11,\"type\":\"string\"},\"memo_type\":{\"id\":10,\"rule\":\"required\",\"type\":\"StellarMemoType\"},\"network_passphrase\":{\"id\":3,\"rule\":\"required\",\"type\":\"string\"},\"num_operations\":{\"id\":14,\"rule\":\"required\",\"type\":\"uint32\"},\"sequence_number\":{\"id\":6,\"rule\":\"required\",\"type\":\"uint64\"},\"soroban_data_size\":{\"id\":60,\"options\":{\"default\":0},\"type\":\"uint32\"},\"source_account\":{\"id\":4,\"rule\":\"required\",\"type\":\"string\"},\"timebounds_end\":{\"id\":9,\"rule\":\"required\",\"type\":\"uint32\"},\"timebounds_start\":{\"id\":8,\"rule\":\"required\",\"type\":\"uint32\"}},\"nested\":{\"StellarMemoType\":{\"values\":{\"HASH\":3,\"ID\":2,\"NONE\":0,\"RETURN\":4,\"TEXT\":1}}}},\"StellarSignedTx\":{\"fields\":{\"public_key\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"},\"signature\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"StellarSorobanDataAck\":{\"fields\":{\"data_xdr\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"StellarSorobanDataRequest\":{\"fields\":{\"data_length\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint32\"},\"type\":{\"id\":1,\"rule\":\"required\",\"type\":\"StellarRequestType\"}},\"nested\":{\"StellarRequestType\":{\"values\":{\"AUTH\":1,\"CALL\":0,\"EXT\":2}}}},\"StellarTxOpRequest\":{\"fields\":{}},\"Success\":{\"fields\":{\"message\":{\"id\":1,\"options\":{\"default\":\"\"},\"type\":\"string\"}}},\"SuiAddress\":{\"fields\":{\"address\":{\"id\":1,\"type\":\"string\"}}},\"SuiGetAddress\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"show_display\":{\"id\":2,\"type\":\"bool\"}}},\"SuiMessageSignature\":{\"fields\":{\"address\":{\"id\":2,\"rule\":\"required\",\"type\":\"string\"},\"signature\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"SuiSignMessage\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"message\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"SuiSignTx\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"data_initial_chunk\":{\"id\":3,\"options\":{\"default\":\"\"},\"type\":\"bytes\"},\"data_length\":{\"id\":4,\"type\":\"uint32\"},\"raw_tx\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"SuiSignedTx\":{\"fields\":{\"public_key\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"},\"signature\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"SuiTxAck\":{\"fields\":{\"data_chunk\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"SuiTxRequest\":{\"fields\":{\"data_length\":{\"id\":1,\"type\":\"uint32\"},\"public_key\":{\"id\":2,\"type\":\"bytes\"},\"signature\":{\"id\":3,\"type\":\"bytes\"}}},\"TezosAddress\":{\"fields\":{\"address\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"}}},\"TezosGetAddress\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"show_display\":{\"id\":2,\"type\":\"bool\"}}},\"TezosGetPublicKey\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"show_display\":{\"id\":2,\"type\":\"bool\"}}},\"TezosPublicKey\":{\"fields\":{\"public_key\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"}}},\"TezosSignTx\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"ballot\":{\"id\":8,\"type\":\"TezosBallotOp\"},\"branch\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"},\"delegation\":{\"id\":6,\"type\":\"TezosDelegationOp\"},\"origination\":{\"id\":5,\"type\":\"TezosOriginationOp\"},\"proposal\":{\"id\":7,\"type\":\"TezosProposalOp\"},\"reveal\":{\"id\":3,\"type\":\"TezosRevealOp\"},\"transaction\":{\"id\":4,\"type\":\"TezosTransactionOp\"}},\"nested\":{\"TezosBallotOp\":{\"fields\":{\"ballot\":{\"id\":4,\"type\":\"TezosBallotType\"},\"period\":{\"id\":2,\"type\":\"uint64\"},\"proposal\":{\"id\":3,\"type\":\"bytes\"},\"source\":{\"id\":1,\"type\":\"bytes\"}},\"nested\":{\"TezosBallotType\":{\"values\":{\"Nay\":1,\"Pass\":2,\"Yay\":0}}}},\"TezosContractID\":{\"fields\":{\"hash\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"},\"tag\":{\"id\":1,\"rule\":\"required\",\"type\":\"TezosContractType\"}},\"nested\":{\"TezosContractType\":{\"values\":{\"Implicit\":0,\"Originated\":1}}}},\"TezosDelegationOp\":{\"fields\":{\"counter\":{\"id\":3,\"rule\":\"required\",\"type\":\"uint64\"},\"delegate\":{\"id\":6,\"rule\":\"required\",\"type\":\"bytes\"},\"fee\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint64\"},\"gas_limit\":{\"id\":4,\"rule\":\"required\",\"type\":\"uint64\"},\"source\":{\"id\":7,\"rule\":\"required\",\"type\":\"bytes\"},\"storage_limit\":{\"id\":5,\"rule\":\"required\",\"type\":\"uint64\"}}},\"TezosOriginationOp\":{\"fields\":{\"balance\":{\"id\":7,\"rule\":\"required\",\"type\":\"uint64\"},\"counter\":{\"id\":3,\"rule\":\"required\",\"type\":\"uint64\"},\"delegatable\":{\"id\":9,\"type\":\"bool\"},\"delegate\":{\"id\":10,\"type\":\"bytes\"},\"fee\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint64\"},\"gas_limit\":{\"id\":4,\"rule\":\"required\",\"type\":\"uint64\"},\"manager_pubkey\":{\"id\":6,\"type\":\"bytes\"},\"script\":{\"id\":11,\"rule\":\"required\",\"type\":\"bytes\"},\"source\":{\"id\":12,\"rule\":\"required\",\"type\":\"bytes\"},\"spendable\":{\"id\":8,\"type\":\"bool\"},\"storage_limit\":{\"id\":5,\"rule\":\"required\",\"type\":\"uint64\"}}},\"TezosProposalOp\":{\"fields\":{\"period\":{\"id\":2,\"type\":\"uint64\"},\"proposals\":{\"id\":4,\"rule\":\"repeated\",\"type\":\"bytes\"},\"source\":{\"id\":1,\"type\":\"bytes\"}}},\"TezosRevealOp\":{\"fields\":{\"counter\":{\"id\":3,\"rule\":\"required\",\"type\":\"uint64\"},\"fee\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint64\"},\"gas_limit\":{\"id\":4,\"rule\":\"required\",\"type\":\"uint64\"},\"public_key\":{\"id\":6,\"rule\":\"required\",\"type\":\"bytes\"},\"source\":{\"id\":7,\"rule\":\"required\",\"type\":\"bytes\"},\"storage_limit\":{\"id\":5,\"rule\":\"required\",\"type\":\"uint64\"}}},\"TezosTransactionOp\":{\"fields\":{\"amount\":{\"id\":6,\"rule\":\"required\",\"type\":\"uint64\"},\"counter\":{\"id\":3,\"rule\":\"required\",\"type\":\"uint64\"},\"destination\":{\"id\":7,\"rule\":\"required\",\"type\":\"TezosContractID\"},\"fee\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint64\"},\"gas_limit\":{\"id\":4,\"rule\":\"required\",\"type\":\"uint64\"},\"parameters\":{\"id\":8,\"type\":\"bytes\"},\"parameters_manager\":{\"id\":10,\"type\":\"TezosParametersManager\"},\"source\":{\"id\":9,\"rule\":\"required\",\"type\":\"bytes\"},\"storage_limit\":{\"id\":5,\"rule\":\"required\",\"type\":\"uint64\"}},\"nested\":{\"TezosParametersManager\":{\"fields\":{\"cancel_delegate\":{\"id\":2,\"type\":\"bool\"},\"set_delegate\":{\"id\":1,\"type\":\"bytes\"},\"transfer\":{\"id\":3,\"type\":\"TezosManagerTransfer\"}},\"nested\":{\"TezosManagerTransfer\":{\"fields\":{\"amount\":{\"id\":2,\"type\":\"uint64\"},\"destination\":{\"id\":1,\"type\":\"TezosContractID\"}}}}}}}}},\"TezosSignedTx\":{\"fields\":{\"operation_hash\":{\"id\":3,\"rule\":\"required\",\"type\":\"string\"},\"sig_op_contents\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"},\"signature\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"}}},\"TonAddress\":{\"fields\":{\"address\":{\"id\":2,\"rule\":\"required\",\"type\":\"string\"},\"public_key\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"TonGetAddress\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"is_bounceable\":{\"id\":4,\"options\":{\"default\":false},\"type\":\"bool\"},\"is_testnet_only\":{\"id\":5,\"options\":{\"default\":false},\"type\":\"bool\"},\"show_display\":{\"id\":2,\"type\":\"bool\"},\"wallet_id\":{\"id\":7,\"options\":{\"default\":698983191},\"type\":\"uint32\"},\"wallet_version\":{\"id\":3,\"options\":{\"default\":\"V4R2\"},\"type\":\"TonWalletVersion\"},\"workchain\":{\"id\":6,\"options\":{\"default\":\"BASECHAIN\"},\"type\":\"TonWorkChain\"}}},\"TonSignData\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"appdomain\":{\"id\":5,\"rule\":\"required\",\"type\":\"string\"},\"from_address\":{\"id\":7,\"type\":\"string\"},\"is_bounceable\":{\"id\":11,\"options\":{\"default\":false},\"type\":\"bool\"},\"is_testnet_only\":{\"id\":12,\"options\":{\"default\":false},\"type\":\"bool\"},\"payload\":{\"id\":3,\"rule\":\"required\",\"type\":\"bytes\"},\"schema\":{\"id\":4,\"type\":\"string\"},\"timestamp\":{\"id\":6,\"rule\":\"required\",\"type\":\"uint64\"},\"type\":{\"id\":2,\"rule\":\"required\",\"type\":\"TonSignDataType\"},\"wallet_id\":{\"id\":9,\"options\":{\"default\":698983191},\"type\":\"uint32\"},\"wallet_version\":{\"id\":8,\"options\":{\"default\":\"V4R2\"},\"type\":\"TonWalletVersion\"},\"workchain\":{\"id\":10,\"options\":{\"default\":\"BASECHAIN\"},\"type\":\"TonWorkChain\"}},\"nested\":{\"TonSignDataType\":{\"values\":{\"BINARY\":1,\"CELL\":2,\"TEXT\":0}}}},\"TonSignMessage\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"comment\":{\"id\":8,\"type\":\"string\"},\"destination\":{\"id\":2,\"rule\":\"required\",\"type\":\"string\"},\"expire_at\":{\"id\":12,\"rule\":\"required\",\"type\":\"uint64\"},\"ext_destination\":{\"id\":18,\"rule\":\"repeated\",\"type\":\"string\"},\"ext_payload\":{\"id\":20,\"rule\":\"repeated\",\"type\":\"string\"},\"ext_ton_amount\":{\"id\":19,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint64\"},\"fwd_fee\":{\"id\":7,\"options\":{\"default\":0},\"type\":\"uint64\"},\"init_data_initial_chunk\":{\"id\":22,\"type\":\"bytes\"},\"init_data_length\":{\"id\":23,\"type\":\"uint32\"},\"is_bounceable\":{\"id\":16,\"options\":{\"default\":false},\"type\":\"bool\"},\"is_raw_data\":{\"id\":9,\"options\":{\"default\":false},\"type\":\"bool\"},\"is_testnet_only\":{\"id\":17,\"options\":{\"default\":false},\"type\":\"bool\"},\"jetton_amount\":{\"id\":6,\"type\":\"uint64\"},\"jetton_amount_bytes\":{\"id\":21,\"type\":\"bytes\"},\"jetton_master_address\":{\"id\":3,\"type\":\"string\"},\"jetton_wallet_address\":{\"id\":4,\"type\":\"string\"},\"mode\":{\"id\":10,\"options\":{\"default\":3},\"type\":\"uint32\"},\"seqno\":{\"id\":11,\"rule\":\"required\",\"type\":\"uint32\"},\"signing_message_repr\":{\"id\":24,\"type\":\"bytes\"},\"ton_amount\":{\"id\":5,\"rule\":\"required\",\"type\":\"uint64\"},\"wallet_id\":{\"id\":14,\"options\":{\"default\":698983191},\"type\":\"uint32\"},\"wallet_version\":{\"id\":13,\"options\":{\"default\":\"V4R2\"},\"type\":\"TonWalletVersion\"},\"workchain\":{\"id\":15,\"options\":{\"default\":\"BASECHAIN\"},\"type\":\"TonWorkChain\"}}},\"TonSignProof\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"appdomain\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"},\"comment\":{\"id\":3,\"type\":\"bytes\"},\"expire_at\":{\"id\":4,\"rule\":\"required\",\"type\":\"uint64\"},\"is_bounceable\":{\"id\":8,\"options\":{\"default\":false},\"type\":\"bool\"},\"is_testnet_only\":{\"id\":9,\"options\":{\"default\":false},\"type\":\"bool\"},\"wallet_id\":{\"id\":6,\"options\":{\"default\":698983191},\"type\":\"uint32\"},\"wallet_version\":{\"id\":5,\"options\":{\"default\":\"V4R2\"},\"type\":\"TonWalletVersion\"},\"workchain\":{\"id\":7,\"options\":{\"default\":\"BASECHAIN\"},\"type\":\"TonWorkChain\"}}},\"TonSignedData\":{\"fields\":{\"digest\":{\"id\":2,\"type\":\"bytes\"},\"signature\":{\"id\":1,\"type\":\"bytes\"}}},\"TonSignedMessage\":{\"fields\":{\"init_data_length\":{\"id\":3,\"type\":\"uint32\"},\"signature\":{\"id\":1,\"type\":\"bytes\"},\"signning_message\":{\"id\":2,\"type\":\"bytes\"}}},\"TonSignedProof\":{\"fields\":{\"signature\":{\"id\":1,\"type\":\"bytes\"}}},\"TonTxAck\":{\"fields\":{\"init_data_chunk\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"TonWalletVersion\":{\"values\":{\"V4R2\":3}},\"TonWorkChain\":{\"values\":{\"BASECHAIN\":0,\"MASTERCHAIN\":1}},\"TronAddress\":{\"fields\":{\"address\":{\"id\":1,\"type\":\"string\"}}},\"TronGetAddress\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"show_display\":{\"id\":2,\"type\":\"bool\"}}},\"TronMessageSignature\":{\"fields\":{\"address\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"},\"signature\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"TronMessageType\":{\"values\":{\"V1\":1,\"V2\":2}},\"TronSignMessage\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"message\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"},\"message_type\":{\"id\":3,\"options\":{\"default\":\"V1\"},\"type\":\"TronMessageType\"}}},\"TronSignTx\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"contract\":{\"id\":6,\"rule\":\"required\",\"type\":\"TronContract\"},\"data\":{\"id\":5,\"type\":\"bytes\"},\"expiration\":{\"id\":4,\"rule\":\"required\",\"type\":\"uint64\"},\"fee_limit\":{\"id\":8,\"type\":\"uint64\"},\"ref_block_bytes\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"},\"ref_block_hash\":{\"id\":3,\"rule\":\"required\",\"type\":\"bytes\"},\"timestamp\":{\"id\":7,\"rule\":\"required\",\"type\":\"uint64\"}},\"nested\":{\"TronContract\":{\"fields\":{\"cancel_all_unfreeze_v2_contract\":{\"id\":59,\"type\":\"TronCancelAllUnfreezeV2Contract\"},\"contract_name\":{\"id\":5,\"type\":\"bytes\"},\"delegate_resource_contract\":{\"id\":57,\"type\":\"TronDelegateResourceContract\"},\"freeze_balance_contract\":{\"id\":11,\"type\":\"TronFreezeBalanceContract\"},\"freeze_balance_v2_contract\":{\"id\":54,\"type\":\"TronFreezeBalanceV2Contract\"},\"permission_id\":{\"id\":6,\"type\":\"uint32\"},\"provider\":{\"id\":3,\"type\":\"bytes\"},\"transfer_contract\":{\"id\":2,\"type\":\"TronTransferContract\"},\"trigger_smart_contract\":{\"id\":31,\"type\":\"TronTriggerSmartContract\"},\"undelegate_resource_contract\":{\"id\":58,\"type\":\"TronUnDelegateResourceContract\"},\"unfreeze_balance_contract\":{\"id\":12,\"type\":\"TronUnfreezeBalanceContract\"},\"unfreeze_balance_v2_contract\":{\"id\":55,\"type\":\"TronUnfreezeBalanceV2Contract\"},\"vote_witness_contract\":{\"id\":4,\"type\":\"TronVoteWitnessContract\"},\"withdraw_balance_contract\":{\"id\":13,\"type\":\"TronWithdrawBalanceContract\"},\"withdraw_expire_unfreeze_contract\":{\"id\":56,\"type\":\"TronWithdrawExpireUnfreezeContract\"}},\"nested\":{\"TronCancelAllUnfreezeV2Contract\":{\"fields\":{}},\"TronDelegateResourceContract\":{\"fields\":{\"balance\":{\"id\":3,\"type\":\"uint64\"},\"lock\":{\"id\":5,\"type\":\"bool\"},\"lock_period\":{\"id\":6,\"type\":\"uint64\"},\"receiver_address\":{\"id\":4,\"type\":\"string\"},\"resource\":{\"id\":2,\"type\":\"TronResourceCode\"}}},\"TronFreezeBalanceContract\":{\"fields\":{\"frozen_balance\":{\"id\":1,\"type\":\"uint64\"},\"frozen_duration\":{\"id\":2,\"type\":\"uint64\"},\"receiver_address\":{\"id\":4,\"type\":\"string\"},\"resource\":{\"id\":3,\"type\":\"TronResourceCode\"}}},\"TronFreezeBalanceV2Contract\":{\"fields\":{\"frozen_balance\":{\"id\":2,\"type\":\"uint64\"},\"resource\":{\"id\":3,\"type\":\"TronResourceCode\"}}},\"TronResourceCode\":{\"values\":{\"BANDWIDTH\":0,\"ENERGY\":1,\"TRON_POWER\":2}},\"TronTransferContract\":{\"fields\":{\"amount\":{\"id\":3,\"type\":\"uint64\"},\"to_address\":{\"id\":2,\"type\":\"string\"}}},\"TronTriggerSmartContract\":{\"fields\":{\"asset_id\":{\"id\":6,\"type\":\"uint64\"},\"call_token_value\":{\"id\":5,\"type\":\"uint64\"},\"call_value\":{\"id\":3,\"type\":\"uint64\"},\"contract_address\":{\"id\":2,\"type\":\"string\"},\"data\":{\"id\":4,\"type\":\"bytes\"}}},\"TronUnDelegateResourceContract\":{\"fields\":{\"balance\":{\"id\":3,\"type\":\"uint64\"},\"receiver_address\":{\"id\":4,\"type\":\"string\"},\"resource\":{\"id\":2,\"type\":\"TronResourceCode\"}}},\"TronUnfreezeBalanceContract\":{\"fields\":{\"receiver_address\":{\"id\":2,\"type\":\"string\"},\"resource\":{\"id\":1,\"type\":\"TronResourceCode\"}}},\"TronUnfreezeBalanceV2Contract\":{\"fields\":{\"resource\":{\"id\":3,\"type\":\"TronResourceCode\"},\"unfreeze_balance\":{\"id\":2,\"type\":\"uint64\"}}},\"TronVoteWitnessContract\":{\"fields\":{\"support\":{\"id\":3,\"type\":\"bool\"},\"votes\":{\"id\":2,\"rule\":\"repeated\",\"type\":\"Vote\"}},\"nested\":{\"Vote\":{\"fields\":{\"vote_address\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"},\"vote_count\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint32\"}}}}},\"TronWithdrawBalanceContract\":{\"fields\":{\"owner_address\":{\"id\":1,\"type\":\"bytes\"}}},\"TronWithdrawExpireUnfreezeContract\":{\"fields\":{}}}}}},\"TronSignedTx\":{\"fields\":{\"serialized_tx\":{\"id\":2,\"type\":\"bytes\"},\"signature\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"TxAck\":{\"fields\":{\"tx\":{\"id\":1,\"type\":\"TransactionType\"}},\"nested\":{\"TransactionType\":{\"fields\":{\"bin_outputs\":{\"id\":3,\"rule\":\"repeated\",\"type\":\"TxOutputBinType\"},\"branch_id\":{\"id\":14,\"type\":\"uint32\"},\"expiry\":{\"id\":10,\"type\":\"uint32\"},\"extra_data\":{\"id\":8,\"type\":\"bytes\"},\"extra_data_len\":{\"id\":9,\"type\":\"uint32\"},\"inputs\":{\"id\":2,\"rule\":\"repeated\",\"type\":\"TxInputType\"},\"inputs_cnt\":{\"id\":6,\"type\":\"uint32\"},\"lock_time\":{\"id\":4,\"type\":\"uint32\"},\"outputs\":{\"id\":5,\"rule\":\"repeated\",\"type\":\"TxOutputType\"},\"outputs_cnt\":{\"id\":7,\"type\":\"uint32\"},\"overwintered\":{\"id\":11,\"options\":{\"deprecated\":true},\"type\":\"bool\"},\"timestamp\":{\"id\":13,\"type\":\"uint32\"},\"version\":{\"id\":1,\"type\":\"uint32\"},\"version_group_id\":{\"id\":12,\"type\":\"uint32\"}},\"nested\":{\"TxInputType\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"amount\":{\"id\":8,\"type\":\"uint64\"},\"commitment_data\":{\"id\":15,\"type\":\"bytes\"},\"decred_staking_spend\":{\"id\":18,\"type\":\"DecredStakingSpendType\"},\"decred_tree\":{\"id\":9,\"type\":\"uint32\"},\"multisig\":{\"id\":7,\"type\":\"MultisigRedeemScriptType\"},\"orig_hash\":{\"id\":16,\"type\":\"bytes\"},\"orig_index\":{\"id\":17,\"type\":\"uint32\"},\"ownership_proof\":{\"id\":14,\"type\":\"bytes\"},\"prev_hash\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"},\"prev_index\":{\"id\":3,\"rule\":\"required\",\"type\":\"uint32\"},\"script_pubkey\":{\"id\":19,\"type\":\"bytes\"},\"script_sig\":{\"id\":4,\"type\":\"bytes\"},\"script_type\":{\"id\":6,\"options\":{\"default\":\"SPENDADDRESS\"},\"type\":\"InputScriptType\"},\"sequence\":{\"id\":5,\"options\":{\"default\":4294967295},\"type\":\"uint32\"},\"witness\":{\"id\":13,\"type\":\"bytes\"}}},\"TxOutputBinType\":{\"fields\":{\"amount\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint64\"},\"decred_script_version\":{\"id\":3,\"type\":\"uint32\"},\"script_pubkey\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"TxOutputType\":{\"fields\":{\"address\":{\"id\":1,\"type\":\"string\"},\"address_n\":{\"id\":2,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"amount\":{\"id\":3,\"rule\":\"required\",\"type\":\"uint64\"},\"multisig\":{\"id\":5,\"type\":\"MultisigRedeemScriptType\"},\"op_return_data\":{\"id\":6,\"type\":\"bytes\"},\"orig_hash\":{\"id\":10,\"type\":\"bytes\"},\"orig_index\":{\"id\":11,\"type\":\"uint32\"},\"script_type\":{\"id\":4,\"options\":{\"default\":\"PAYTOADDRESS\"},\"type\":\"OutputScriptType\"}}}}}},\"options\":{\"deprecated\":true}},\"TxAckInput\":{\"fields\":{\"tx\":{\"id\":1,\"rule\":\"required\",\"type\":\"TxAckInputWrapper\"}},\"nested\":{\"TxAckInputWrapper\":{\"fields\":{\"input\":{\"id\":2,\"rule\":\"required\",\"type\":\"TxInput\"}}}},\"options\":{\"(wire_type)\":22}},\"TxAckOutput\":{\"fields\":{\"tx\":{\"id\":1,\"rule\":\"required\",\"type\":\"TxAckOutputWrapper\"}},\"nested\":{\"TxAckOutputWrapper\":{\"fields\":{\"output\":{\"id\":5,\"rule\":\"required\",\"type\":\"TxOutput\"}}}},\"options\":{\"(wire_type)\":22}},\"TxAckPrevExtraData\":{\"fields\":{\"tx\":{\"id\":1,\"rule\":\"required\",\"type\":\"TxAckPrevExtraDataWrapper\"}},\"nested\":{\"TxAckPrevExtraDataWrapper\":{\"fields\":{\"extra_data_chunk\":{\"id\":8,\"rule\":\"required\",\"type\":\"bytes\"}}}},\"options\":{\"(wire_type)\":22}},\"TxAckPrevInput\":{\"fields\":{\"tx\":{\"id\":1,\"rule\":\"required\",\"type\":\"TxAckPrevInputWrapper\"}},\"nested\":{\"TxAckPrevInputWrapper\":{\"fields\":{\"input\":{\"id\":2,\"rule\":\"required\",\"type\":\"PrevInput\"}}}},\"options\":{\"(wire_type)\":22}},\"TxAckPrevMeta\":{\"fields\":{\"tx\":{\"id\":1,\"rule\":\"required\",\"type\":\"PrevTx\"}},\"options\":{\"(wire_type)\":22}},\"TxAckPrevOutput\":{\"fields\":{\"tx\":{\"id\":1,\"rule\":\"required\",\"type\":\"TxAckPrevOutputWrapper\"}},\"nested\":{\"TxAckPrevOutputWrapper\":{\"fields\":{\"output\":{\"id\":3,\"rule\":\"required\",\"type\":\"PrevOutput\"}}}},\"options\":{\"(wire_type)\":22}},\"TxInput\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"amount\":{\"id\":8,\"rule\":\"required\",\"type\":\"uint64\"},\"commitment_data\":{\"id\":15,\"type\":\"bytes\"},\"decred_staking_spend\":{\"id\":18,\"type\":\"DecredStakingSpendType\"},\"decred_tree\":{\"id\":9,\"type\":\"uint32\"},\"multisig\":{\"id\":7,\"type\":\"MultisigRedeemScriptType\"},\"orig_hash\":{\"id\":16,\"type\":\"bytes\"},\"orig_index\":{\"id\":17,\"type\":\"uint32\"},\"ownership_proof\":{\"id\":14,\"type\":\"bytes\"},\"prev_hash\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"},\"prev_index\":{\"id\":3,\"rule\":\"required\",\"type\":\"uint32\"},\"script_pubkey\":{\"id\":19,\"type\":\"bytes\"},\"script_sig\":{\"id\":4,\"type\":\"bytes\"},\"script_type\":{\"id\":6,\"options\":{\"default\":\"SPENDADDRESS\"},\"type\":\"InputScriptType\"},\"sequence\":{\"id\":5,\"options\":{\"default\":4294967295},\"type\":\"uint32\"},\"witness\":{\"id\":13,\"type\":\"bytes\"}}},\"TxOutput\":{\"fields\":{\"address\":{\"id\":1,\"type\":\"string\"},\"address_n\":{\"id\":2,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"amount\":{\"id\":3,\"rule\":\"required\",\"type\":\"uint64\"},\"multisig\":{\"id\":5,\"type\":\"MultisigRedeemScriptType\"},\"op_return_data\":{\"id\":6,\"type\":\"bytes\"},\"orig_hash\":{\"id\":10,\"type\":\"bytes\"},\"orig_index\":{\"id\":11,\"type\":\"uint32\"},\"script_type\":{\"id\":4,\"options\":{\"default\":\"PAYTOADDRESS\"},\"type\":\"OutputScriptType\"}}},\"TxRequest\":{\"fields\":{\"details\":{\"id\":2,\"type\":\"TxRequestDetailsType\"},\"request_type\":{\"id\":1,\"type\":\"RequestType\"},\"serialized\":{\"id\":3,\"type\":\"TxRequestSerializedType\"}},\"nested\":{\"RequestType\":{\"values\":{\"TXEXTRADATA\":4,\"TXFINISHED\":3,\"TXINPUT\":0,\"TXMETA\":2,\"TXORIGINPUT\":5,\"TXORIGOUTPUT\":6,\"TXOUTPUT\":1}},\"TxRequestDetailsType\":{\"fields\":{\"extra_data_len\":{\"id\":3,\"type\":\"uint32\"},\"extra_data_offset\":{\"id\":4,\"type\":\"uint32\"},\"request_index\":{\"id\":1,\"type\":\"uint32\"},\"tx_hash\":{\"id\":2,\"type\":\"bytes\"}}},\"TxRequestSerializedType\":{\"fields\":{\"serialized_tx\":{\"id\":3,\"type\":\"bytes\"},\"signature\":{\"id\":2,\"type\":\"bytes\"},\"signature_index\":{\"id\":1,\"type\":\"uint32\"}}}}},\"UnLockDevice\":{\"fields\":{}},\"UnLockDeviceResponse\":{\"fields\":{\"passphrase_protection\":{\"id\":3,\"type\":\"bool\"},\"unlocked\":{\"id\":1,\"type\":\"bool\"},\"unlocked_attach_pin\":{\"id\":2,\"type\":\"bool\"}}},\"UpgradeFileHeader\":{\"fields\":{\"data\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"VerifyMessage\":{\"fields\":{\"address\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"},\"coin_name\":{\"id\":4,\"options\":{\"default\":\"Bitcoin\"},\"type\":\"string\"},\"message\":{\"id\":3,\"rule\":\"required\",\"type\":\"bytes\"},\"signature\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"WebAuthnAddResidentCredential\":{\"fields\":{\"credential_id\":{\"id\":1,\"type\":\"bytes\"}}},\"WebAuthnCredentials\":{\"fields\":{\"credentials\":{\"id\":1,\"rule\":\"repeated\",\"type\":\"WebAuthnCredential\"}},\"nested\":{\"WebAuthnCredential\":{\"fields\":{\"algorithm\":{\"id\":11,\"type\":\"sint32\"},\"creation_time\":{\"id\":8,\"type\":\"uint32\"},\"curve\":{\"id\":12,\"type\":\"sint32\"},\"hmac_secret\":{\"id\":9,\"type\":\"bool\"},\"id\":{\"id\":2,\"type\":\"bytes\"},\"index\":{\"id\":1,\"type\":\"uint32\"},\"rp_id\":{\"id\":3,\"type\":\"string\"},\"rp_name\":{\"id\":4,\"type\":\"string\"},\"use_sign_count\":{\"id\":10,\"type\":\"bool\"},\"user_display_name\":{\"id\":7,\"type\":\"string\"},\"user_id\":{\"id\":5,\"type\":\"bytes\"},\"user_name\":{\"id\":6,\"type\":\"string\"}}}}},\"WebAuthnListResidentCredentials\":{\"fields\":{}},\"WebAuthnRemoveResidentCredential\":{\"fields\":{\"index\":{\"id\":1,\"type\":\"uint32\"}}},\"WipeDevice\":{\"fields\":{}},\"WordAck\":{\"fields\":{\"word\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"}}},\"WordRequest\":{\"fields\":{\"type\":{\"id\":1,\"rule\":\"required\",\"type\":\"WordRequestType\"}},\"nested\":{\"WordRequestType\":{\"values\":{\"WordRequestType_Matrix6\":2,\"WordRequestType_Matrix9\":1,\"WordRequestType_Plain\":0}}}},\"WriteSEPublicCert\":{\"fields\":{\"public_cert\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"ZoomRequest\":{\"fields\":{\"data_length\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint32\"},\"offset\":{\"id\":1,\"type\":\"uint32\"}}},\"bitcoin_only\":{\"extend\":\"google.protobuf.EnumValueOptions\",\"id\":60000,\"type\":\"bool\"},\"experimental\":{\"extend\":\"google.protobuf.FieldOptions\",\"id\":53001,\"type\":\"bool\"},\"facotry\":{\"extend\":\"google.protobuf.EnumValueOptions\",\"id\":50501,\"type\":\"bool\"},\"google\":{\"nested\":{\"protobuf\":{\"nested\":{\"DescriptorProto\":{\"fields\":{\"enum_type\":{\"id\":4,\"rule\":\"repeated\",\"type\":\"EnumDescriptorProto\"},\"extension\":{\"id\":6,\"rule\":\"repeated\",\"type\":\"FieldDescriptorProto\"},\"extension_range\":{\"id\":5,\"rule\":\"repeated\",\"type\":\"ExtensionRange\"},\"field\":{\"id\":2,\"rule\":\"repeated\",\"type\":\"FieldDescriptorProto\"},\"name\":{\"id\":1,\"type\":\"string\"},\"nested_type\":{\"id\":3,\"rule\":\"repeated\",\"type\":\"DescriptorProto\"},\"oneof_decl\":{\"id\":8,\"rule\":\"repeated\",\"type\":\"OneofDescriptorProto\"},\"options\":{\"id\":7,\"type\":\"MessageOptions\"},\"reserved_name\":{\"id\":10,\"rule\":\"repeated\",\"type\":\"string\"},\"reserved_range\":{\"id\":9,\"rule\":\"repeated\",\"type\":\"ReservedRange\"}},\"nested\":{\"ExtensionRange\":{\"fields\":{\"end\":{\"id\":2,\"type\":\"int32\"},\"start\":{\"id\":1,\"type\":\"int32\"}}},\"ReservedRange\":{\"fields\":{\"end\":{\"id\":2,\"type\":\"int32\"},\"start\":{\"id\":1,\"type\":\"int32\"}}}}},\"EnumDescriptorProto\":{\"fields\":{\"name\":{\"id\":1,\"type\":\"string\"},\"options\":{\"id\":3,\"type\":\"EnumOptions\"},\"value\":{\"id\":2,\"rule\":\"repeated\",\"type\":\"EnumValueDescriptorProto\"}}},\"EnumOptions\":{\"extensions\":[[1000,536870911]],\"fields\":{\"allow_alias\":{\"id\":2,\"type\":\"bool\"},\"deprecated\":{\"id\":3,\"type\":\"bool\"},\"uninterpreted_option\":{\"id\":999,\"rule\":\"repeated\",\"type\":\"UninterpretedOption\"}}},\"EnumValueDescriptorProto\":{\"fields\":{\"name\":{\"id\":1,\"type\":\"string\"},\"number\":{\"id\":2,\"type\":\"int32\"},\"options\":{\"id\":3,\"type\":\"EnumValueOptions\"}}},\"EnumValueOptions\":{\"extensions\":[[1000,536870911]],\"fields\":{\"deprecated\":{\"id\":1,\"type\":\"bool\"},\"uninterpreted_option\":{\"id\":999,\"rule\":\"repeated\",\"type\":\"UninterpretedOption\"}}},\"FieldDescriptorProto\":{\"fields\":{\"default_value\":{\"id\":7,\"type\":\"string\"},\"extendee\":{\"id\":2,\"type\":\"string\"},\"json_name\":{\"id\":10,\"type\":\"string\"},\"label\":{\"id\":4,\"type\":\"Label\"},\"name\":{\"id\":1,\"type\":\"string\"},\"number\":{\"id\":3,\"type\":\"int32\"},\"oneof_index\":{\"id\":9,\"type\":\"int32\"},\"options\":{\"id\":8,\"type\":\"FieldOptions\"},\"type\":{\"id\":5,\"type\":\"Type\"},\"type_name\":{\"id\":6,\"type\":\"string\"}},\"nested\":{\"Label\":{\"values\":{\"LABEL_OPTIONAL\":1,\"LABEL_REPEATED\":3,\"LABEL_REQUIRED\":2}},\"Type\":{\"values\":{\"TYPE_BOOL\":8,\"TYPE_BYTES\":12,\"TYPE_DOUBLE\":1,\"TYPE_ENUM\":14,\"TYPE_FIXED32\":7,\"TYPE_FIXED64\":6,\"TYPE_FLOAT\":2,\"TYPE_GROUP\":10,\"TYPE_INT32\":5,\"TYPE_INT64\":3,\"TYPE_MESSAGE\":11,\"TYPE_SFIXED32\":15,\"TYPE_SFIXED64\":16,\"TYPE_SINT32\":17,\"TYPE_SINT64\":18,\"TYPE_STRING\":9,\"TYPE_UINT32\":13,\"TYPE_UINT64\":4}}}},\"FieldOptions\":{\"extensions\":[[1000,536870911]],\"fields\":{\"ctype\":{\"id\":1,\"options\":{\"default\":\"STRING\"},\"type\":\"CType\"},\"deprecated\":{\"id\":3,\"type\":\"bool\"},\"jstype\":{\"id\":6,\"options\":{\"default\":\"JS_NORMAL\"},\"type\":\"JSType\"},\"lazy\":{\"id\":5,\"type\":\"bool\"},\"packed\":{\"id\":2,\"type\":\"bool\"},\"uninterpreted_option\":{\"id\":999,\"rule\":\"repeated\",\"type\":\"UninterpretedOption\"},\"weak\":{\"id\":10,\"type\":\"bool\"}},\"nested\":{\"CType\":{\"values\":{\"CORD\":1,\"STRING\":0,\"STRING_PIECE\":2}},\"JSType\":{\"values\":{\"JS_NORMAL\":0,\"JS_NUMBER\":2,\"JS_STRING\":1}}},\"reserved\":[[4,4]]},\"FileDescriptorProto\":{\"fields\":{\"dependency\":{\"id\":3,\"rule\":\"repeated\",\"type\":\"string\"},\"enum_type\":{\"id\":5,\"rule\":\"repeated\",\"type\":\"EnumDescriptorProto\"},\"extension\":{\"id\":7,\"rule\":\"repeated\",\"type\":\"FieldDescriptorProto\"},\"message_type\":{\"id\":4,\"rule\":\"repeated\",\"type\":\"DescriptorProto\"},\"name\":{\"id\":1,\"type\":\"string\"},\"options\":{\"id\":8,\"type\":\"FileOptions\"},\"package\":{\"id\":2,\"type\":\"string\"},\"public_dependency\":{\"id\":10,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"int32\"},\"service\":{\"id\":6,\"rule\":\"repeated\",\"type\":\"ServiceDescriptorProto\"},\"source_code_info\":{\"id\":9,\"type\":\"SourceCodeInfo\"},\"syntax\":{\"id\":12,\"type\":\"string\"},\"weak_dependency\":{\"id\":11,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"int32\"}}},\"FileDescriptorSet\":{\"fields\":{\"file\":{\"id\":1,\"rule\":\"repeated\",\"type\":\"FileDescriptorProto\"}}},\"FileOptions\":{\"extensions\":[[1000,536870911]],\"fields\":{\"cc_enable_arenas\":{\"id\":31,\"type\":\"bool\"},\"cc_generic_services\":{\"id\":16,\"type\":\"bool\"},\"csharp_namespace\":{\"id\":37,\"type\":\"string\"},\"deprecated\":{\"id\":23,\"type\":\"bool\"},\"go_package\":{\"id\":11,\"type\":\"string\"},\"java_generate_equals_and_hash\":{\"id\":20,\"options\":{\"deprecated\":true},\"type\":\"bool\"},\"java_generic_services\":{\"id\":17,\"type\":\"bool\"},\"java_multiple_files\":{\"id\":10,\"type\":\"bool\"},\"java_outer_classname\":{\"id\":8,\"type\":\"string\"},\"java_package\":{\"id\":1,\"type\":\"string\"},\"java_string_check_utf8\":{\"id\":27,\"type\":\"bool\"},\"objc_class_prefix\":{\"id\":36,\"type\":\"string\"},\"optimize_for\":{\"id\":9,\"options\":{\"default\":\"SPEED\"},\"type\":\"OptimizeMode\"},\"py_generic_services\":{\"id\":18,\"type\":\"bool\"},\"uninterpreted_option\":{\"id\":999,\"rule\":\"repeated\",\"type\":\"UninterpretedOption\"}},\"nested\":{\"OptimizeMode\":{\"values\":{\"CODE_SIZE\":2,\"LITE_RUNTIME\":3,\"SPEED\":1}}},\"reserved\":[[38,38]]},\"GeneratedCodeInfo\":{\"fields\":{\"annotation\":{\"id\":1,\"rule\":\"repeated\",\"type\":\"Annotation\"}},\"nested\":{\"Annotation\":{\"fields\":{\"begin\":{\"id\":3,\"type\":\"int32\"},\"end\":{\"id\":4,\"type\":\"int32\"},\"path\":{\"id\":1,\"rule\":\"repeated\",\"type\":\"int32\"},\"source_file\":{\"id\":2,\"type\":\"string\"}}}}},\"MessageOptions\":{\"extensions\":[[1000,536870911]],\"fields\":{\"deprecated\":{\"id\":3,\"type\":\"bool\"},\"map_entry\":{\"id\":7,\"type\":\"bool\"},\"message_set_wire_format\":{\"id\":1,\"type\":\"bool\"},\"no_standard_descriptor_accessor\":{\"id\":2,\"type\":\"bool\"},\"uninterpreted_option\":{\"id\":999,\"rule\":\"repeated\",\"type\":\"UninterpretedOption\"}},\"reserved\":[[8,8]]},\"MethodDescriptorProto\":{\"fields\":{\"client_streaming\":{\"id\":5,\"type\":\"bool\"},\"input_type\":{\"id\":2,\"type\":\"string\"},\"name\":{\"id\":1,\"type\":\"string\"},\"options\":{\"id\":4,\"type\":\"MethodOptions\"},\"output_type\":{\"id\":3,\"type\":\"string\"},\"server_streaming\":{\"id\":6,\"type\":\"bool\"}}},\"MethodOptions\":{\"extensions\":[[1000,536870911]],\"fields\":{\"deprecated\":{\"id\":33,\"type\":\"bool\"},\"uninterpreted_option\":{\"id\":999,\"rule\":\"repeated\",\"type\":\"UninterpretedOption\"}}},\"OneofDescriptorProto\":{\"fields\":{\"name\":{\"id\":1,\"type\":\"string\"},\"options\":{\"id\":2,\"type\":\"OneofOptions\"}}},\"OneofOptions\":{\"extensions\":[[1000,536870911]],\"fields\":{\"uninterpreted_option\":{\"id\":999,\"rule\":\"repeated\",\"type\":\"UninterpretedOption\"}}},\"ServiceDescriptorProto\":{\"fields\":{\"method\":{\"id\":2,\"rule\":\"repeated\",\"type\":\"MethodDescriptorProto\"},\"name\":{\"id\":1,\"type\":\"string\"},\"options\":{\"id\":3,\"type\":\"ServiceOptions\"}}},\"ServiceOptions\":{\"extensions\":[[1000,536870911]],\"fields\":{\"deprecated\":{\"id\":33,\"type\":\"bool\"},\"uninterpreted_option\":{\"id\":999,\"rule\":\"repeated\",\"type\":\"UninterpretedOption\"}}},\"SourceCodeInfo\":{\"fields\":{\"location\":{\"id\":1,\"rule\":\"repeated\",\"type\":\"Location\"}},\"nested\":{\"Location\":{\"fields\":{\"leading_comments\":{\"id\":3,\"type\":\"string\"},\"leading_detached_comments\":{\"id\":6,\"rule\":\"repeated\",\"type\":\"string\"},\"path\":{\"id\":1,\"rule\":\"repeated\",\"type\":\"int32\"},\"span\":{\"id\":2,\"rule\":\"repeated\",\"type\":\"int32\"},\"trailing_comments\":{\"id\":4,\"type\":\"string\"}}}}},\"UninterpretedOption\":{\"fields\":{\"aggregate_value\":{\"id\":8,\"type\":\"string\"},\"double_value\":{\"id\":6,\"type\":\"double\"},\"identifier_value\":{\"id\":3,\"type\":\"string\"},\"name\":{\"id\":2,\"rule\":\"repeated\",\"type\":\"NamePart\"},\"negative_int_value\":{\"id\":5,\"type\":\"int64\"},\"positive_int_value\":{\"id\":4,\"type\":\"uint64\"},\"string_value\":{\"id\":7,\"type\":\"bytes\"}},\"nested\":{\"NamePart\":{\"fields\":{\"is_extension\":{\"id\":2,\"rule\":\"required\",\"type\":\"bool\"},\"name_part\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"}}}}}}}}},\"has_bitcoin_only_values\":{\"extend\":\"google.protobuf.EnumOptions\",\"id\":51001,\"type\":\"bool\"},\"include_in_bitcoin_only\":{\"extend\":\"google.protobuf.FileOptions\",\"id\":60000,\"type\":\"bool\"},\"unstable\":{\"extend\":\"google.protobuf.MessageOptions\",\"id\":52001,\"type\":\"bool\"},\"wire_bootloader\":{\"extend\":\"google.protobuf.EnumValueOptions\",\"id\":50007,\"type\":\"bool\"},\"wire_debug_in\":{\"extend\":\"google.protobuf.EnumValueOptions\",\"id\":50004,\"type\":\"bool\"},\"wire_debug_out\":{\"extend\":\"google.protobuf.EnumValueOptions\",\"id\":50005,\"type\":\"bool\"},\"wire_in\":{\"extend\":\"google.protobuf.EnumValueOptions\",\"id\":50002,\"type\":\"bool\"},\"wire_no_fsm\":{\"extend\":\"google.protobuf.EnumValueOptions\",\"id\":50008,\"type\":\"bool\"},\"wire_out\":{\"extend\":\"google.protobuf.EnumValueOptions\",\"id\":50003,\"type\":\"bool\"},\"wire_tiny\":{\"extend\":\"google.protobuf.EnumValueOptions\",\"id\":50006,\"type\":\"bool\"},\"wire_type\":{\"extend\":\"google.protobuf.MessageOptions\",\"id\":52002,\"type\":\"uint32\"}}}": function () {
const $protobuf = { ...protobuf, roots: {} };
var $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

var $root = $protobuf.roots["onekey-csp-0"] || ($protobuf.roots["onekey-csp-0"] = {});

$root.AlephiumGetAddress = (function() {

    function AlephiumGetAddress(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    AlephiumGetAddress.prototype.address_n = $util.emptyArray;
    AlephiumGetAddress.prototype.show_display = false;
    AlephiumGetAddress.prototype.include_public_key = false;
    AlephiumGetAddress.prototype.target_group = 0;

    AlephiumGetAddress.create = function create(properties) {
        return new AlephiumGetAddress(properties);
    };

    AlephiumGetAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(16).bool(message.show_display);
        if (message.include_public_key != null && Object.hasOwnProperty.call(message, "include_public_key"))
            writer.uint32(24).bool(message.include_public_key);
        if (message.target_group != null && Object.hasOwnProperty.call(message, "target_group"))
            writer.uint32(32).uint32(message.target_group);
        return writer;
    };

    AlephiumGetAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    AlephiumGetAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.AlephiumGetAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.show_display = reader.bool();
                break;
            case 3:
                message.include_public_key = reader.bool();
                break;
            case 4:
                message.target_group = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    AlephiumGetAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    AlephiumGetAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        if (message.include_public_key != null && message.hasOwnProperty("include_public_key"))
            if (typeof message.include_public_key !== "boolean")
                return "include_public_key: boolean expected";
        if (message.target_group != null && message.hasOwnProperty("target_group"))
            if (!$util.isInteger(message.target_group))
                return "target_group: integer expected";
        return null;
    };

    AlephiumGetAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.AlephiumGetAddress)
            return object;
        var message = new $root.AlephiumGetAddress();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".AlephiumGetAddress.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        if (object.include_public_key != null)
            message.include_public_key = Boolean(object.include_public_key);
        if (object.target_group != null)
            message.target_group = object.target_group >>> 0;
        return message;
    };

    AlephiumGetAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            object.show_display = false;
            object.include_public_key = false;
            object.target_group = 0;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        if (message.include_public_key != null && message.hasOwnProperty("include_public_key"))
            object.include_public_key = message.include_public_key;
        if (message.target_group != null && message.hasOwnProperty("target_group"))
            object.target_group = message.target_group;
        return object;
    };

    AlephiumGetAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return AlephiumGetAddress;
})();

$root.AlephiumAddress = (function() {

    function AlephiumAddress(properties) {
        this.derived_path = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    AlephiumAddress.prototype.address = "";
    AlephiumAddress.prototype.public_key = $util.newBuffer([]);
    AlephiumAddress.prototype.derived_path = $util.emptyArray;

    AlephiumAddress.create = function create(properties) {
        return new AlephiumAddress(properties);
    };

    AlephiumAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.address);
        if (message.public_key != null && Object.hasOwnProperty.call(message, "public_key"))
            writer.uint32(18).bytes(message.public_key);
        if (message.derived_path != null && message.derived_path.length)
            for (var i = 0; i < message.derived_path.length; ++i)
                writer.uint32(24).uint32(message.derived_path[i]);
        return writer;
    };

    AlephiumAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    AlephiumAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.AlephiumAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.string();
                break;
            case 2:
                message.public_key = reader.bytes();
                break;
            case 3:
                if (!(message.derived_path && message.derived_path.length))
                    message.derived_path = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.derived_path.push(reader.uint32());
                } else
                    message.derived_path.push(reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("address"))
            throw $util.ProtocolError("missing required 'address'", { instance: message });
        return message;
    };

    AlephiumAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    AlephiumAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.address))
            return "address: string expected";
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            if (!(message.public_key && typeof message.public_key.length === "number" || $util.isString(message.public_key)))
                return "public_key: buffer expected";
        if (message.derived_path != null && message.hasOwnProperty("derived_path")) {
            if (!Array.isArray(message.derived_path))
                return "derived_path: array expected";
            for (var i = 0; i < message.derived_path.length; ++i)
                if (!$util.isInteger(message.derived_path[i]))
                    return "derived_path: integer[] expected";
        }
        return null;
    };

    AlephiumAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.AlephiumAddress)
            return object;
        var message = new $root.AlephiumAddress();
        if (object.address != null)
            message.address = String(object.address);
        if (object.public_key != null)
            if (typeof object.public_key === "string")
                $util.base64.decode(object.public_key, message.public_key = $util.newBuffer($util.base64.length(object.public_key)), 0);
            else if (object.public_key.length)
                message.public_key = object.public_key;
        if (object.derived_path) {
            if (!Array.isArray(object.derived_path))
                throw TypeError(".AlephiumAddress.derived_path: array expected");
            message.derived_path = [];
            for (var i = 0; i < object.derived_path.length; ++i)
                message.derived_path[i] = object.derived_path[i] >>> 0;
        }
        return message;
    };

    AlephiumAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.derived_path = [];
        if (options.defaults) {
            object.address = "";
            if (options.bytes === String)
                object.public_key = "";
            else {
                object.public_key = [];
                if (options.bytes !== Array)
                    object.public_key = $util.newBuffer(object.public_key);
            }
        }
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            object.public_key = options.bytes === String ? $util.base64.encode(message.public_key, 0, message.public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.public_key) : message.public_key;
        if (message.derived_path && message.derived_path.length) {
            object.derived_path = [];
            for (var j = 0; j < message.derived_path.length; ++j)
                object.derived_path[j] = message.derived_path[j];
        }
        return object;
    };

    AlephiumAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return AlephiumAddress;
})();

$root.AlephiumSignTx = (function() {

    function AlephiumSignTx(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    AlephiumSignTx.prototype.address_n = $util.emptyArray;
    AlephiumSignTx.prototype.data_initial_chunk = $util.newBuffer([]);
    AlephiumSignTx.prototype.data_length = 0;

    AlephiumSignTx.create = function create(properties) {
        return new AlephiumSignTx(properties);
    };

    AlephiumSignTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).bytes(message.data_initial_chunk);
        if (message.data_length != null && Object.hasOwnProperty.call(message, "data_length"))
            writer.uint32(24).uint32(message.data_length);
        return writer;
    };

    AlephiumSignTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    AlephiumSignTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.AlephiumSignTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.data_initial_chunk = reader.bytes();
                break;
            case 3:
                message.data_length = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("data_initial_chunk"))
            throw $util.ProtocolError("missing required 'data_initial_chunk'", { instance: message });
        return message;
    };

    AlephiumSignTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    AlephiumSignTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!(message.data_initial_chunk && typeof message.data_initial_chunk.length === "number" || $util.isString(message.data_initial_chunk)))
            return "data_initial_chunk: buffer expected";
        if (message.data_length != null && message.hasOwnProperty("data_length"))
            if (!$util.isInteger(message.data_length))
                return "data_length: integer expected";
        return null;
    };

    AlephiumSignTx.fromObject = function fromObject(object) {
        if (object instanceof $root.AlephiumSignTx)
            return object;
        var message = new $root.AlephiumSignTx();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".AlephiumSignTx.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.data_initial_chunk != null)
            if (typeof object.data_initial_chunk === "string")
                $util.base64.decode(object.data_initial_chunk, message.data_initial_chunk = $util.newBuffer($util.base64.length(object.data_initial_chunk)), 0);
            else if (object.data_initial_chunk.length)
                message.data_initial_chunk = object.data_initial_chunk;
        if (object.data_length != null)
            message.data_length = object.data_length >>> 0;
        return message;
    };

    AlephiumSignTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            if (options.bytes === String)
                object.data_initial_chunk = "";
            else {
                object.data_initial_chunk = [];
                if (options.bytes !== Array)
                    object.data_initial_chunk = $util.newBuffer(object.data_initial_chunk);
            }
            object.data_length = 0;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.data_initial_chunk != null && message.hasOwnProperty("data_initial_chunk"))
            object.data_initial_chunk = options.bytes === String ? $util.base64.encode(message.data_initial_chunk, 0, message.data_initial_chunk.length) : options.bytes === Array ? Array.prototype.slice.call(message.data_initial_chunk) : message.data_initial_chunk;
        if (message.data_length != null && message.hasOwnProperty("data_length"))
            object.data_length = message.data_length;
        return object;
    };

    AlephiumSignTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return AlephiumSignTx;
})();

$root.AlephiumSignedTx = (function() {

    function AlephiumSignedTx(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    AlephiumSignedTx.prototype.signature = $util.newBuffer([]);
    AlephiumSignedTx.prototype.address = "";

    AlephiumSignedTx.create = function create(properties) {
        return new AlephiumSignedTx(properties);
    };

    AlephiumSignedTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.signature);
        writer.uint32(18).string(message.address);
        return writer;
    };

    AlephiumSignedTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    AlephiumSignedTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.AlephiumSignedTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.signature = reader.bytes();
                break;
            case 2:
                message.address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        if (!message.hasOwnProperty("address"))
            throw $util.ProtocolError("missing required 'address'", { instance: message });
        return message;
    };

    AlephiumSignedTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    AlephiumSignedTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        if (!$util.isString(message.address))
            return "address: string expected";
        return null;
    };

    AlephiumSignedTx.fromObject = function fromObject(object) {
        if (object instanceof $root.AlephiumSignedTx)
            return object;
        var message = new $root.AlephiumSignedTx();
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        if (object.address != null)
            message.address = String(object.address);
        return message;
    };

    AlephiumSignedTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
            object.address = "";
        }
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    AlephiumSignedTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return AlephiumSignedTx;
})();

$root.AlephiumTxRequest = (function() {

    function AlephiumTxRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    AlephiumTxRequest.prototype.data_length = 0;
    AlephiumTxRequest.prototype.public_key = $util.newBuffer([]);
    AlephiumTxRequest.prototype.signature = $util.newBuffer([]);

    AlephiumTxRequest.create = function create(properties) {
        return new AlephiumTxRequest(properties);
    };

    AlephiumTxRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.data_length != null && Object.hasOwnProperty.call(message, "data_length"))
            writer.uint32(8).uint32(message.data_length);
        if (message.public_key != null && Object.hasOwnProperty.call(message, "public_key"))
            writer.uint32(18).bytes(message.public_key);
        if (message.signature != null && Object.hasOwnProperty.call(message, "signature"))
            writer.uint32(26).bytes(message.signature);
        return writer;
    };

    AlephiumTxRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    AlephiumTxRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.AlephiumTxRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.data_length = reader.uint32();
                break;
            case 2:
                message.public_key = reader.bytes();
                break;
            case 3:
                message.signature = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    AlephiumTxRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    AlephiumTxRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.data_length != null && message.hasOwnProperty("data_length"))
            if (!$util.isInteger(message.data_length))
                return "data_length: integer expected";
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            if (!(message.public_key && typeof message.public_key.length === "number" || $util.isString(message.public_key)))
                return "public_key: buffer expected";
        if (message.signature != null && message.hasOwnProperty("signature"))
            if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
                return "signature: buffer expected";
        return null;
    };

    AlephiumTxRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.AlephiumTxRequest)
            return object;
        var message = new $root.AlephiumTxRequest();
        if (object.data_length != null)
            message.data_length = object.data_length >>> 0;
        if (object.public_key != null)
            if (typeof object.public_key === "string")
                $util.base64.decode(object.public_key, message.public_key = $util.newBuffer($util.base64.length(object.public_key)), 0);
            else if (object.public_key.length)
                message.public_key = object.public_key;
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        return message;
    };

    AlephiumTxRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.data_length = 0;
            if (options.bytes === String)
                object.public_key = "";
            else {
                object.public_key = [];
                if (options.bytes !== Array)
                    object.public_key = $util.newBuffer(object.public_key);
            }
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
        }
        if (message.data_length != null && message.hasOwnProperty("data_length"))
            object.data_length = message.data_length;
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            object.public_key = options.bytes === String ? $util.base64.encode(message.public_key, 0, message.public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.public_key) : message.public_key;
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        return object;
    };

    AlephiumTxRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return AlephiumTxRequest;
})();

$root.AlephiumTxAck = (function() {

    function AlephiumTxAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    AlephiumTxAck.prototype.data_chunk = $util.newBuffer([]);

    AlephiumTxAck.create = function create(properties) {
        return new AlephiumTxAck(properties);
    };

    AlephiumTxAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.data_chunk);
        return writer;
    };

    AlephiumTxAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    AlephiumTxAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.AlephiumTxAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.data_chunk = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("data_chunk"))
            throw $util.ProtocolError("missing required 'data_chunk'", { instance: message });
        return message;
    };

    AlephiumTxAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    AlephiumTxAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.data_chunk && typeof message.data_chunk.length === "number" || $util.isString(message.data_chunk)))
            return "data_chunk: buffer expected";
        return null;
    };

    AlephiumTxAck.fromObject = function fromObject(object) {
        if (object instanceof $root.AlephiumTxAck)
            return object;
        var message = new $root.AlephiumTxAck();
        if (object.data_chunk != null)
            if (typeof object.data_chunk === "string")
                $util.base64.decode(object.data_chunk, message.data_chunk = $util.newBuffer($util.base64.length(object.data_chunk)), 0);
            else if (object.data_chunk.length)
                message.data_chunk = object.data_chunk;
        return message;
    };

    AlephiumTxAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.data_chunk = "";
            else {
                object.data_chunk = [];
                if (options.bytes !== Array)
                    object.data_chunk = $util.newBuffer(object.data_chunk);
            }
        if (message.data_chunk != null && message.hasOwnProperty("data_chunk"))
            object.data_chunk = options.bytes === String ? $util.base64.encode(message.data_chunk, 0, message.data_chunk.length) : options.bytes === Array ? Array.prototype.slice.call(message.data_chunk) : message.data_chunk;
        return object;
    };

    AlephiumTxAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return AlephiumTxAck;
})();

$root.AlephiumBytecodeRequest = (function() {

    function AlephiumBytecodeRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    AlephiumBytecodeRequest.prototype.data_length = 0;
    AlephiumBytecodeRequest.prototype.public_key = $util.newBuffer([]);
    AlephiumBytecodeRequest.prototype.signature = $util.newBuffer([]);

    AlephiumBytecodeRequest.create = function create(properties) {
        return new AlephiumBytecodeRequest(properties);
    };

    AlephiumBytecodeRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.data_length != null && Object.hasOwnProperty.call(message, "data_length"))
            writer.uint32(8).uint32(message.data_length);
        if (message.public_key != null && Object.hasOwnProperty.call(message, "public_key"))
            writer.uint32(18).bytes(message.public_key);
        if (message.signature != null && Object.hasOwnProperty.call(message, "signature"))
            writer.uint32(26).bytes(message.signature);
        return writer;
    };

    AlephiumBytecodeRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    AlephiumBytecodeRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.AlephiumBytecodeRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.data_length = reader.uint32();
                break;
            case 2:
                message.public_key = reader.bytes();
                break;
            case 3:
                message.signature = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    AlephiumBytecodeRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    AlephiumBytecodeRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.data_length != null && message.hasOwnProperty("data_length"))
            if (!$util.isInteger(message.data_length))
                return "data_length: integer expected";
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            if (!(message.public_key && typeof message.public_key.length === "number" || $util.isString(message.public_key)))
                return "public_key: buffer expected";
        if (message.signature != null && message.hasOwnProperty("signature"))
            if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
                return "signature: buffer expected";
        return null;
    };

    AlephiumBytecodeRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.AlephiumBytecodeRequest)
            return object;
        var message = new $root.AlephiumBytecodeRequest();
        if (object.data_length != null)
            message.data_length = object.data_length >>> 0;
        if (object.public_key != null)
            if (typeof object.public_key === "string")
                $util.base64.decode(object.public_key, message.public_key = $util.newBuffer($util.base64.length(object.public_key)), 0);
            else if (object.public_key.length)
                message.public_key = object.public_key;
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        return message;
    };

    AlephiumBytecodeRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.data_length = 0;
            if (options.bytes === String)
                object.public_key = "";
            else {
                object.public_key = [];
                if (options.bytes !== Array)
                    object.public_key = $util.newBuffer(object.public_key);
            }
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
        }
        if (message.data_length != null && message.hasOwnProperty("data_length"))
            object.data_length = message.data_length;
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            object.public_key = options.bytes === String ? $util.base64.encode(message.public_key, 0, message.public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.public_key) : message.public_key;
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        return object;
    };

    AlephiumBytecodeRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return AlephiumBytecodeRequest;
})();

$root.AlephiumBytecodeAck = (function() {

    function AlephiumBytecodeAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    AlephiumBytecodeAck.prototype.bytecode_data = $util.newBuffer([]);

    AlephiumBytecodeAck.create = function create(properties) {
        return new AlephiumBytecodeAck(properties);
    };

    AlephiumBytecodeAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.bytecode_data);
        return writer;
    };

    AlephiumBytecodeAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    AlephiumBytecodeAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.AlephiumBytecodeAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.bytecode_data = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("bytecode_data"))
            throw $util.ProtocolError("missing required 'bytecode_data'", { instance: message });
        return message;
    };

    AlephiumBytecodeAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    AlephiumBytecodeAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.bytecode_data && typeof message.bytecode_data.length === "number" || $util.isString(message.bytecode_data)))
            return "bytecode_data: buffer expected";
        return null;
    };

    AlephiumBytecodeAck.fromObject = function fromObject(object) {
        if (object instanceof $root.AlephiumBytecodeAck)
            return object;
        var message = new $root.AlephiumBytecodeAck();
        if (object.bytecode_data != null)
            if (typeof object.bytecode_data === "string")
                $util.base64.decode(object.bytecode_data, message.bytecode_data = $util.newBuffer($util.base64.length(object.bytecode_data)), 0);
            else if (object.bytecode_data.length)
                message.bytecode_data = object.bytecode_data;
        return message;
    };

    AlephiumBytecodeAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.bytecode_data = "";
            else {
                object.bytecode_data = [];
                if (options.bytes !== Array)
                    object.bytecode_data = $util.newBuffer(object.bytecode_data);
            }
        if (message.bytecode_data != null && message.hasOwnProperty("bytecode_data"))
            object.bytecode_data = options.bytes === String ? $util.base64.encode(message.bytecode_data, 0, message.bytecode_data.length) : options.bytes === Array ? Array.prototype.slice.call(message.bytecode_data) : message.bytecode_data;
        return object;
    };

    AlephiumBytecodeAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return AlephiumBytecodeAck;
})();

$root.AlephiumSignMessage = (function() {

    function AlephiumSignMessage(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    AlephiumSignMessage.prototype.address_n = $util.emptyArray;
    AlephiumSignMessage.prototype.message = $util.newBuffer([]);
    AlephiumSignMessage.prototype.message_type = $util.newBuffer([]);

    AlephiumSignMessage.create = function create(properties) {
        return new AlephiumSignMessage(properties);
    };

    AlephiumSignMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
            writer.uint32(18).bytes(message.message);
        if (message.message_type != null && Object.hasOwnProperty.call(message, "message_type"))
            writer.uint32(26).bytes(message.message_type);
        return writer;
    };

    AlephiumSignMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    AlephiumSignMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.AlephiumSignMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.message = reader.bytes();
                break;
            case 3:
                message.message_type = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    AlephiumSignMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    AlephiumSignMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.message != null && message.hasOwnProperty("message"))
            if (!(message.message && typeof message.message.length === "number" || $util.isString(message.message)))
                return "message: buffer expected";
        if (message.message_type != null && message.hasOwnProperty("message_type"))
            if (!(message.message_type && typeof message.message_type.length === "number" || $util.isString(message.message_type)))
                return "message_type: buffer expected";
        return null;
    };

    AlephiumSignMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.AlephiumSignMessage)
            return object;
        var message = new $root.AlephiumSignMessage();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".AlephiumSignMessage.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.message != null)
            if (typeof object.message === "string")
                $util.base64.decode(object.message, message.message = $util.newBuffer($util.base64.length(object.message)), 0);
            else if (object.message.length)
                message.message = object.message;
        if (object.message_type != null)
            if (typeof object.message_type === "string")
                $util.base64.decode(object.message_type, message.message_type = $util.newBuffer($util.base64.length(object.message_type)), 0);
            else if (object.message_type.length)
                message.message_type = object.message_type;
        return message;
    };

    AlephiumSignMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            if (options.bytes === String)
                object.message = "";
            else {
                object.message = [];
                if (options.bytes !== Array)
                    object.message = $util.newBuffer(object.message);
            }
            if (options.bytes === String)
                object.message_type = "";
            else {
                object.message_type = [];
                if (options.bytes !== Array)
                    object.message_type = $util.newBuffer(object.message_type);
            }
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.message != null && message.hasOwnProperty("message"))
            object.message = options.bytes === String ? $util.base64.encode(message.message, 0, message.message.length) : options.bytes === Array ? Array.prototype.slice.call(message.message) : message.message;
        if (message.message_type != null && message.hasOwnProperty("message_type"))
            object.message_type = options.bytes === String ? $util.base64.encode(message.message_type, 0, message.message_type.length) : options.bytes === Array ? Array.prototype.slice.call(message.message_type) : message.message_type;
        return object;
    };

    AlephiumSignMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return AlephiumSignMessage;
})();

$root.AlephiumMessageSignature = (function() {

    function AlephiumMessageSignature(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    AlephiumMessageSignature.prototype.signature = $util.newBuffer([]);
    AlephiumMessageSignature.prototype.address = "";

    AlephiumMessageSignature.create = function create(properties) {
        return new AlephiumMessageSignature(properties);
    };

    AlephiumMessageSignature.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.signature != null && Object.hasOwnProperty.call(message, "signature"))
            writer.uint32(10).bytes(message.signature);
        if (message.address != null && Object.hasOwnProperty.call(message, "address"))
            writer.uint32(18).string(message.address);
        return writer;
    };

    AlephiumMessageSignature.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    AlephiumMessageSignature.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.AlephiumMessageSignature();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.signature = reader.bytes();
                break;
            case 2:
                message.address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    AlephiumMessageSignature.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    AlephiumMessageSignature.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.signature != null && message.hasOwnProperty("signature"))
            if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
                return "signature: buffer expected";
        if (message.address != null && message.hasOwnProperty("address"))
            if (!$util.isString(message.address))
                return "address: string expected";
        return null;
    };

    AlephiumMessageSignature.fromObject = function fromObject(object) {
        if (object instanceof $root.AlephiumMessageSignature)
            return object;
        var message = new $root.AlephiumMessageSignature();
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        if (object.address != null)
            message.address = String(object.address);
        return message;
    };

    AlephiumMessageSignature.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
            object.address = "";
        }
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    AlephiumMessageSignature.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return AlephiumMessageSignature;
})();

$root.AlgorandGetAddress = (function() {

    function AlgorandGetAddress(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    AlgorandGetAddress.prototype.address_n = $util.emptyArray;
    AlgorandGetAddress.prototype.show_display = false;

    AlgorandGetAddress.create = function create(properties) {
        return new AlgorandGetAddress(properties);
    };

    AlgorandGetAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(24).bool(message.show_display);
        return writer;
    };

    AlgorandGetAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    AlgorandGetAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.AlgorandGetAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 3:
                message.show_display = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    AlgorandGetAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    AlgorandGetAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        return null;
    };

    AlgorandGetAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.AlgorandGetAddress)
            return object;
        var message = new $root.AlgorandGetAddress();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".AlgorandGetAddress.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        return message;
    };

    AlgorandGetAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            object.show_display = false;
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        return object;
    };

    AlgorandGetAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return AlgorandGetAddress;
})();

$root.AlgorandAddress = (function() {

    function AlgorandAddress(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    AlgorandAddress.prototype.address = "";

    AlgorandAddress.create = function create(properties) {
        return new AlgorandAddress(properties);
    };

    AlgorandAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address != null && Object.hasOwnProperty.call(message, "address"))
            writer.uint32(10).string(message.address);
        return writer;
    };

    AlgorandAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    AlgorandAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.AlgorandAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    AlgorandAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    AlgorandAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address != null && message.hasOwnProperty("address"))
            if (!$util.isString(message.address))
                return "address: string expected";
        return null;
    };

    AlgorandAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.AlgorandAddress)
            return object;
        var message = new $root.AlgorandAddress();
        if (object.address != null)
            message.address = String(object.address);
        return message;
    };

    AlgorandAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.address = "";
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    AlgorandAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return AlgorandAddress;
})();

$root.AlgorandSignTx = (function() {

    function AlgorandSignTx(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    AlgorandSignTx.prototype.address_n = $util.emptyArray;
    AlgorandSignTx.prototype.raw_tx = $util.newBuffer([]);

    AlgorandSignTx.create = function create(properties) {
        return new AlgorandSignTx(properties);
    };

    AlgorandSignTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).bytes(message.raw_tx);
        return writer;
    };

    AlgorandSignTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    AlgorandSignTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.AlgorandSignTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.raw_tx = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("raw_tx"))
            throw $util.ProtocolError("missing required 'raw_tx'", { instance: message });
        return message;
    };

    AlgorandSignTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    AlgorandSignTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!(message.raw_tx && typeof message.raw_tx.length === "number" || $util.isString(message.raw_tx)))
            return "raw_tx: buffer expected";
        return null;
    };

    AlgorandSignTx.fromObject = function fromObject(object) {
        if (object instanceof $root.AlgorandSignTx)
            return object;
        var message = new $root.AlgorandSignTx();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".AlgorandSignTx.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.raw_tx != null)
            if (typeof object.raw_tx === "string")
                $util.base64.decode(object.raw_tx, message.raw_tx = $util.newBuffer($util.base64.length(object.raw_tx)), 0);
            else if (object.raw_tx.length)
                message.raw_tx = object.raw_tx;
        return message;
    };

    AlgorandSignTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            if (options.bytes === String)
                object.raw_tx = "";
            else {
                object.raw_tx = [];
                if (options.bytes !== Array)
                    object.raw_tx = $util.newBuffer(object.raw_tx);
            }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.raw_tx != null && message.hasOwnProperty("raw_tx"))
            object.raw_tx = options.bytes === String ? $util.base64.encode(message.raw_tx, 0, message.raw_tx.length) : options.bytes === Array ? Array.prototype.slice.call(message.raw_tx) : message.raw_tx;
        return object;
    };

    AlgorandSignTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return AlgorandSignTx;
})();

$root.AlgorandSignedTx = (function() {

    function AlgorandSignedTx(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    AlgorandSignedTx.prototype.signature = $util.newBuffer([]);

    AlgorandSignedTx.create = function create(properties) {
        return new AlgorandSignedTx(properties);
    };

    AlgorandSignedTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.signature);
        return writer;
    };

    AlgorandSignedTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    AlgorandSignedTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.AlgorandSignedTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.signature = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        return message;
    };

    AlgorandSignedTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    AlgorandSignedTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        return null;
    };

    AlgorandSignedTx.fromObject = function fromObject(object) {
        if (object instanceof $root.AlgorandSignedTx)
            return object;
        var message = new $root.AlgorandSignedTx();
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        return message;
    };

    AlgorandSignedTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        return object;
    };

    AlgorandSignedTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return AlgorandSignedTx;
})();

$root.AptosGetAddress = (function() {

    function AptosGetAddress(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    AptosGetAddress.prototype.address_n = $util.emptyArray;
    AptosGetAddress.prototype.show_display = false;

    AptosGetAddress.create = function create(properties) {
        return new AptosGetAddress(properties);
    };

    AptosGetAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(16).bool(message.show_display);
        return writer;
    };

    AptosGetAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    AptosGetAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.AptosGetAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.show_display = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    AptosGetAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    AptosGetAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        return null;
    };

    AptosGetAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.AptosGetAddress)
            return object;
        var message = new $root.AptosGetAddress();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".AptosGetAddress.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        return message;
    };

    AptosGetAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            object.show_display = false;
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        return object;
    };

    AptosGetAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return AptosGetAddress;
})();

$root.AptosAddress = (function() {

    function AptosAddress(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    AptosAddress.prototype.address = "";

    AptosAddress.create = function create(properties) {
        return new AptosAddress(properties);
    };

    AptosAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address != null && Object.hasOwnProperty.call(message, "address"))
            writer.uint32(10).string(message.address);
        return writer;
    };

    AptosAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    AptosAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.AptosAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    AptosAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    AptosAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address != null && message.hasOwnProperty("address"))
            if (!$util.isString(message.address))
                return "address: string expected";
        return null;
    };

    AptosAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.AptosAddress)
            return object;
        var message = new $root.AptosAddress();
        if (object.address != null)
            message.address = String(object.address);
        return message;
    };

    AptosAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.address = "";
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    AptosAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return AptosAddress;
})();

$root.AptosSignTx = (function() {

    function AptosSignTx(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    AptosSignTx.prototype.address_n = $util.emptyArray;
    AptosSignTx.prototype.raw_tx = $util.newBuffer([]);
    AptosSignTx.prototype.tx_type = 0;

    AptosSignTx.create = function create(properties) {
        return new AptosSignTx(properties);
    };

    AptosSignTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).bytes(message.raw_tx);
        if (message.tx_type != null && Object.hasOwnProperty.call(message, "tx_type"))
            writer.uint32(24).int32(message.tx_type);
        return writer;
    };

    AptosSignTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    AptosSignTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.AptosSignTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.raw_tx = reader.bytes();
                break;
            case 3:
                message.tx_type = reader.int32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("raw_tx"))
            throw $util.ProtocolError("missing required 'raw_tx'", { instance: message });
        return message;
    };

    AptosSignTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    AptosSignTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!(message.raw_tx && typeof message.raw_tx.length === "number" || $util.isString(message.raw_tx)))
            return "raw_tx: buffer expected";
        if (message.tx_type != null && message.hasOwnProperty("tx_type"))
            switch (message.tx_type) {
            default:
                return "tx_type: enum value expected";
            case 0:
            case 1:
                break;
            }
        return null;
    };

    AptosSignTx.fromObject = function fromObject(object) {
        if (object instanceof $root.AptosSignTx)
            return object;
        var message = new $root.AptosSignTx();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".AptosSignTx.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.raw_tx != null)
            if (typeof object.raw_tx === "string")
                $util.base64.decode(object.raw_tx, message.raw_tx = $util.newBuffer($util.base64.length(object.raw_tx)), 0);
            else if (object.raw_tx.length)
                message.raw_tx = object.raw_tx;
        switch (object.tx_type) {
        case "STANDARD":
        case 0:
            message.tx_type = 0;
            break;
        case "WITH_DATA":
        case 1:
            message.tx_type = 1;
            break;
        }
        return message;
    };

    AptosSignTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            if (options.bytes === String)
                object.raw_tx = "";
            else {
                object.raw_tx = [];
                if (options.bytes !== Array)
                    object.raw_tx = $util.newBuffer(object.raw_tx);
            }
            object.tx_type = options.enums === String ? "STANDARD" : 0;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.raw_tx != null && message.hasOwnProperty("raw_tx"))
            object.raw_tx = options.bytes === String ? $util.base64.encode(message.raw_tx, 0, message.raw_tx.length) : options.bytes === Array ? Array.prototype.slice.call(message.raw_tx) : message.raw_tx;
        if (message.tx_type != null && message.hasOwnProperty("tx_type"))
            object.tx_type = options.enums === String ? $root.AptosSignTx.AptosTransactionType[message.tx_type] : message.tx_type;
        return object;
    };

    AptosSignTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    AptosSignTx.AptosTransactionType = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "STANDARD"] = 0;
        values[valuesById[1] = "WITH_DATA"] = 1;
        return values;
    })();

    return AptosSignTx;
})();

$root.AptosSignedTx = (function() {

    function AptosSignedTx(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    AptosSignedTx.prototype.public_key = $util.newBuffer([]);
    AptosSignedTx.prototype.signature = $util.newBuffer([]);

    AptosSignedTx.create = function create(properties) {
        return new AptosSignedTx(properties);
    };

    AptosSignedTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.public_key);
        writer.uint32(18).bytes(message.signature);
        return writer;
    };

    AptosSignedTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    AptosSignedTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.AptosSignedTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.public_key = reader.bytes();
                break;
            case 2:
                message.signature = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("public_key"))
            throw $util.ProtocolError("missing required 'public_key'", { instance: message });
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        return message;
    };

    AptosSignedTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    AptosSignedTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.public_key && typeof message.public_key.length === "number" || $util.isString(message.public_key)))
            return "public_key: buffer expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        return null;
    };

    AptosSignedTx.fromObject = function fromObject(object) {
        if (object instanceof $root.AptosSignedTx)
            return object;
        var message = new $root.AptosSignedTx();
        if (object.public_key != null)
            if (typeof object.public_key === "string")
                $util.base64.decode(object.public_key, message.public_key = $util.newBuffer($util.base64.length(object.public_key)), 0);
            else if (object.public_key.length)
                message.public_key = object.public_key;
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        return message;
    };

    AptosSignedTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.public_key = "";
            else {
                object.public_key = [];
                if (options.bytes !== Array)
                    object.public_key = $util.newBuffer(object.public_key);
            }
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
        }
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            object.public_key = options.bytes === String ? $util.base64.encode(message.public_key, 0, message.public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.public_key) : message.public_key;
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        return object;
    };

    AptosSignedTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return AptosSignedTx;
})();

$root.AptosSignMessage = (function() {

    function AptosSignMessage(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    AptosSignMessage.prototype.address_n = $util.emptyArray;
    AptosSignMessage.prototype.payload = null;

    AptosSignMessage.create = function create(properties) {
        return new AptosSignMessage(properties);
    };

    AptosSignMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        $root.AptosSignMessage.AptosMessagePayload.encode(message.payload, writer.uint32(18).fork()).ldelim();
        return writer;
    };

    AptosSignMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    AptosSignMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.AptosSignMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.payload = $root.AptosSignMessage.AptosMessagePayload.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("payload"))
            throw $util.ProtocolError("missing required 'payload'", { instance: message });
        return message;
    };

    AptosSignMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    AptosSignMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        {
            var error = $root.AptosSignMessage.AptosMessagePayload.verify(message.payload);
            if (error)
                return "payload." + error;
        }
        return null;
    };

    AptosSignMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.AptosSignMessage)
            return object;
        var message = new $root.AptosSignMessage();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".AptosSignMessage.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.payload != null) {
            if (typeof object.payload !== "object")
                throw TypeError(".AptosSignMessage.payload: object expected");
            message.payload = $root.AptosSignMessage.AptosMessagePayload.fromObject(object.payload);
        }
        return message;
    };

    AptosSignMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            object.payload = null;
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.payload != null && message.hasOwnProperty("payload"))
            object.payload = $root.AptosSignMessage.AptosMessagePayload.toObject(message.payload, options);
        return object;
    };

    AptosSignMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    AptosSignMessage.AptosMessagePayload = (function() {

        function AptosMessagePayload(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        AptosMessagePayload.prototype.address = "";
        AptosMessagePayload.prototype.chain_id = "";
        AptosMessagePayload.prototype.application = "";
        AptosMessagePayload.prototype.nonce = "";
        AptosMessagePayload.prototype.message = "";

        AptosMessagePayload.create = function create(properties) {
            return new AptosMessagePayload(properties);
        };

        AptosMessagePayload.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.address != null && Object.hasOwnProperty.call(message, "address"))
                writer.uint32(18).string(message.address);
            if (message.chain_id != null && Object.hasOwnProperty.call(message, "chain_id"))
                writer.uint32(26).string(message.chain_id);
            if (message.application != null && Object.hasOwnProperty.call(message, "application"))
                writer.uint32(34).string(message.application);
            writer.uint32(42).string(message.nonce);
            writer.uint32(50).string(message.message);
            return writer;
        };

        AptosMessagePayload.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        AptosMessagePayload.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.AptosSignMessage.AptosMessagePayload();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 2:
                    message.address = reader.string();
                    break;
                case 3:
                    message.chain_id = reader.string();
                    break;
                case 4:
                    message.application = reader.string();
                    break;
                case 5:
                    message.nonce = reader.string();
                    break;
                case 6:
                    message.message = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("nonce"))
                throw $util.ProtocolError("missing required 'nonce'", { instance: message });
            if (!message.hasOwnProperty("message"))
                throw $util.ProtocolError("missing required 'message'", { instance: message });
            return message;
        };

        AptosMessagePayload.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        AptosMessagePayload.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.address != null && message.hasOwnProperty("address"))
                if (!$util.isString(message.address))
                    return "address: string expected";
            if (message.chain_id != null && message.hasOwnProperty("chain_id"))
                if (!$util.isString(message.chain_id))
                    return "chain_id: string expected";
            if (message.application != null && message.hasOwnProperty("application"))
                if (!$util.isString(message.application))
                    return "application: string expected";
            if (!$util.isString(message.nonce))
                return "nonce: string expected";
            if (!$util.isString(message.message))
                return "message: string expected";
            return null;
        };

        AptosMessagePayload.fromObject = function fromObject(object) {
            if (object instanceof $root.AptosSignMessage.AptosMessagePayload)
                return object;
            var message = new $root.AptosSignMessage.AptosMessagePayload();
            if (object.address != null)
                message.address = String(object.address);
            if (object.chain_id != null)
                message.chain_id = String(object.chain_id);
            if (object.application != null)
                message.application = String(object.application);
            if (object.nonce != null)
                message.nonce = String(object.nonce);
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        AptosMessagePayload.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.address = "";
                object.chain_id = "";
                object.application = "";
                object.nonce = "";
                object.message = "";
            }
            if (message.address != null && message.hasOwnProperty("address"))
                object.address = message.address;
            if (message.chain_id != null && message.hasOwnProperty("chain_id"))
                object.chain_id = message.chain_id;
            if (message.application != null && message.hasOwnProperty("application"))
                object.application = message.application;
            if (message.nonce != null && message.hasOwnProperty("nonce"))
                object.nonce = message.nonce;
            if (message.message != null && message.hasOwnProperty("message"))
                object.message = message.message;
            return object;
        };

        AptosMessagePayload.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AptosMessagePayload;
    })();

    return AptosSignMessage;
})();

$root.AptosMessageSignature = (function() {

    function AptosMessageSignature(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    AptosMessageSignature.prototype.signature = $util.newBuffer([]);
    AptosMessageSignature.prototype.address = "";

    AptosMessageSignature.create = function create(properties) {
        return new AptosMessageSignature(properties);
    };

    AptosMessageSignature.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.signature);
        writer.uint32(18).string(message.address);
        return writer;
    };

    AptosMessageSignature.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    AptosMessageSignature.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.AptosMessageSignature();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.signature = reader.bytes();
                break;
            case 2:
                message.address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        if (!message.hasOwnProperty("address"))
            throw $util.ProtocolError("missing required 'address'", { instance: message });
        return message;
    };

    AptosMessageSignature.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    AptosMessageSignature.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        if (!$util.isString(message.address))
            return "address: string expected";
        return null;
    };

    AptosMessageSignature.fromObject = function fromObject(object) {
        if (object instanceof $root.AptosMessageSignature)
            return object;
        var message = new $root.AptosMessageSignature();
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        if (object.address != null)
            message.address = String(object.address);
        return message;
    };

    AptosMessageSignature.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
            object.address = "";
        }
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    AptosMessageSignature.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return AptosMessageSignature;
})();

$root.AptosSignSIWAMessage = (function() {

    function AptosSignSIWAMessage(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    AptosSignSIWAMessage.prototype.address_n = $util.emptyArray;
    AptosSignSIWAMessage.prototype.siwa_payload = "";

    AptosSignSIWAMessage.create = function create(properties) {
        return new AptosSignSIWAMessage(properties);
    };

    AptosSignSIWAMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).string(message.siwa_payload);
        return writer;
    };

    AptosSignSIWAMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    AptosSignSIWAMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.AptosSignSIWAMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.siwa_payload = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("siwa_payload"))
            throw $util.ProtocolError("missing required 'siwa_payload'", { instance: message });
        return message;
    };

    AptosSignSIWAMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    AptosSignSIWAMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!$util.isString(message.siwa_payload))
            return "siwa_payload: string expected";
        return null;
    };

    AptosSignSIWAMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.AptosSignSIWAMessage)
            return object;
        var message = new $root.AptosSignSIWAMessage();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".AptosSignSIWAMessage.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.siwa_payload != null)
            message.siwa_payload = String(object.siwa_payload);
        return message;
    };

    AptosSignSIWAMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            object.siwa_payload = "";
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.siwa_payload != null && message.hasOwnProperty("siwa_payload"))
            object.siwa_payload = message.siwa_payload;
        return object;
    };

    AptosSignSIWAMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return AptosSignSIWAMessage;
})();

$root.BenfenGetAddress = (function() {

    function BenfenGetAddress(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    BenfenGetAddress.prototype.address_n = $util.emptyArray;
    BenfenGetAddress.prototype.show_display = false;

    BenfenGetAddress.create = function create(properties) {
        return new BenfenGetAddress(properties);
    };

    BenfenGetAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(16).bool(message.show_display);
        return writer;
    };

    BenfenGetAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    BenfenGetAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BenfenGetAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.show_display = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    BenfenGetAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    BenfenGetAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        return null;
    };

    BenfenGetAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.BenfenGetAddress)
            return object;
        var message = new $root.BenfenGetAddress();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".BenfenGetAddress.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        return message;
    };

    BenfenGetAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            object.show_display = false;
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        return object;
    };

    BenfenGetAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return BenfenGetAddress;
})();

$root.BenfenAddress = (function() {

    function BenfenAddress(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    BenfenAddress.prototype.address = "";

    BenfenAddress.create = function create(properties) {
        return new BenfenAddress(properties);
    };

    BenfenAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address != null && Object.hasOwnProperty.call(message, "address"))
            writer.uint32(10).string(message.address);
        return writer;
    };

    BenfenAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    BenfenAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BenfenAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    BenfenAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    BenfenAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address != null && message.hasOwnProperty("address"))
            if (!$util.isString(message.address))
                return "address: string expected";
        return null;
    };

    BenfenAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.BenfenAddress)
            return object;
        var message = new $root.BenfenAddress();
        if (object.address != null)
            message.address = String(object.address);
        return message;
    };

    BenfenAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.address = "";
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    BenfenAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return BenfenAddress;
})();

$root.BenfenSignTx = (function() {

    function BenfenSignTx(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    BenfenSignTx.prototype.address_n = $util.emptyArray;
    BenfenSignTx.prototype.raw_tx = $util.newBuffer([]);
    BenfenSignTx.prototype.data_initial_chunk = $util.newBuffer([]);
    BenfenSignTx.prototype.coin_type = $util.newBuffer([]);
    BenfenSignTx.prototype.data_length = 0;

    BenfenSignTx.create = function create(properties) {
        return new BenfenSignTx(properties);
    };

    BenfenSignTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).bytes(message.raw_tx);
        if (message.data_initial_chunk != null && Object.hasOwnProperty.call(message, "data_initial_chunk"))
            writer.uint32(26).bytes(message.data_initial_chunk);
        if (message.coin_type != null && Object.hasOwnProperty.call(message, "coin_type"))
            writer.uint32(34).bytes(message.coin_type);
        if (message.data_length != null && Object.hasOwnProperty.call(message, "data_length"))
            writer.uint32(40).uint32(message.data_length);
        return writer;
    };

    BenfenSignTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    BenfenSignTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BenfenSignTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.raw_tx = reader.bytes();
                break;
            case 3:
                message.data_initial_chunk = reader.bytes();
                break;
            case 4:
                message.coin_type = reader.bytes();
                break;
            case 5:
                message.data_length = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("raw_tx"))
            throw $util.ProtocolError("missing required 'raw_tx'", { instance: message });
        return message;
    };

    BenfenSignTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    BenfenSignTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!(message.raw_tx && typeof message.raw_tx.length === "number" || $util.isString(message.raw_tx)))
            return "raw_tx: buffer expected";
        if (message.data_initial_chunk != null && message.hasOwnProperty("data_initial_chunk"))
            if (!(message.data_initial_chunk && typeof message.data_initial_chunk.length === "number" || $util.isString(message.data_initial_chunk)))
                return "data_initial_chunk: buffer expected";
        if (message.coin_type != null && message.hasOwnProperty("coin_type"))
            if (!(message.coin_type && typeof message.coin_type.length === "number" || $util.isString(message.coin_type)))
                return "coin_type: buffer expected";
        if (message.data_length != null && message.hasOwnProperty("data_length"))
            if (!$util.isInteger(message.data_length))
                return "data_length: integer expected";
        return null;
    };

    BenfenSignTx.fromObject = function fromObject(object) {
        if (object instanceof $root.BenfenSignTx)
            return object;
        var message = new $root.BenfenSignTx();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".BenfenSignTx.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.raw_tx != null)
            if (typeof object.raw_tx === "string")
                $util.base64.decode(object.raw_tx, message.raw_tx = $util.newBuffer($util.base64.length(object.raw_tx)), 0);
            else if (object.raw_tx.length)
                message.raw_tx = object.raw_tx;
        if (object.data_initial_chunk != null)
            if (typeof object.data_initial_chunk === "string")
                $util.base64.decode(object.data_initial_chunk, message.data_initial_chunk = $util.newBuffer($util.base64.length(object.data_initial_chunk)), 0);
            else if (object.data_initial_chunk.length)
                message.data_initial_chunk = object.data_initial_chunk;
        if (object.coin_type != null)
            if (typeof object.coin_type === "string")
                $util.base64.decode(object.coin_type, message.coin_type = $util.newBuffer($util.base64.length(object.coin_type)), 0);
            else if (object.coin_type.length)
                message.coin_type = object.coin_type;
        if (object.data_length != null)
            message.data_length = object.data_length >>> 0;
        return message;
    };

    BenfenSignTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            if (options.bytes === String)
                object.raw_tx = "";
            else {
                object.raw_tx = [];
                if (options.bytes !== Array)
                    object.raw_tx = $util.newBuffer(object.raw_tx);
            }
            if (options.bytes === String)
                object.data_initial_chunk = "";
            else {
                object.data_initial_chunk = [];
                if (options.bytes !== Array)
                    object.data_initial_chunk = $util.newBuffer(object.data_initial_chunk);
            }
            if (options.bytes === String)
                object.coin_type = "";
            else {
                object.coin_type = [];
                if (options.bytes !== Array)
                    object.coin_type = $util.newBuffer(object.coin_type);
            }
            object.data_length = 0;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.raw_tx != null && message.hasOwnProperty("raw_tx"))
            object.raw_tx = options.bytes === String ? $util.base64.encode(message.raw_tx, 0, message.raw_tx.length) : options.bytes === Array ? Array.prototype.slice.call(message.raw_tx) : message.raw_tx;
        if (message.data_initial_chunk != null && message.hasOwnProperty("data_initial_chunk"))
            object.data_initial_chunk = options.bytes === String ? $util.base64.encode(message.data_initial_chunk, 0, message.data_initial_chunk.length) : options.bytes === Array ? Array.prototype.slice.call(message.data_initial_chunk) : message.data_initial_chunk;
        if (message.coin_type != null && message.hasOwnProperty("coin_type"))
            object.coin_type = options.bytes === String ? $util.base64.encode(message.coin_type, 0, message.coin_type.length) : options.bytes === Array ? Array.prototype.slice.call(message.coin_type) : message.coin_type;
        if (message.data_length != null && message.hasOwnProperty("data_length"))
            object.data_length = message.data_length;
        return object;
    };

    BenfenSignTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return BenfenSignTx;
})();

$root.BenfenSignedTx = (function() {

    function BenfenSignedTx(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    BenfenSignedTx.prototype.public_key = $util.newBuffer([]);
    BenfenSignedTx.prototype.signature = $util.newBuffer([]);

    BenfenSignedTx.create = function create(properties) {
        return new BenfenSignedTx(properties);
    };

    BenfenSignedTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.public_key);
        writer.uint32(18).bytes(message.signature);
        return writer;
    };

    BenfenSignedTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    BenfenSignedTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BenfenSignedTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.public_key = reader.bytes();
                break;
            case 2:
                message.signature = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("public_key"))
            throw $util.ProtocolError("missing required 'public_key'", { instance: message });
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        return message;
    };

    BenfenSignedTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    BenfenSignedTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.public_key && typeof message.public_key.length === "number" || $util.isString(message.public_key)))
            return "public_key: buffer expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        return null;
    };

    BenfenSignedTx.fromObject = function fromObject(object) {
        if (object instanceof $root.BenfenSignedTx)
            return object;
        var message = new $root.BenfenSignedTx();
        if (object.public_key != null)
            if (typeof object.public_key === "string")
                $util.base64.decode(object.public_key, message.public_key = $util.newBuffer($util.base64.length(object.public_key)), 0);
            else if (object.public_key.length)
                message.public_key = object.public_key;
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        return message;
    };

    BenfenSignedTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.public_key = "";
            else {
                object.public_key = [];
                if (options.bytes !== Array)
                    object.public_key = $util.newBuffer(object.public_key);
            }
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
        }
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            object.public_key = options.bytes === String ? $util.base64.encode(message.public_key, 0, message.public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.public_key) : message.public_key;
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        return object;
    };

    BenfenSignedTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return BenfenSignedTx;
})();

$root.BenfenTxRequest = (function() {

    function BenfenTxRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    BenfenTxRequest.prototype.data_length = 0;
    BenfenTxRequest.prototype.public_key = $util.newBuffer([]);
    BenfenTxRequest.prototype.signature = $util.newBuffer([]);

    BenfenTxRequest.create = function create(properties) {
        return new BenfenTxRequest(properties);
    };

    BenfenTxRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.data_length != null && Object.hasOwnProperty.call(message, "data_length"))
            writer.uint32(8).uint32(message.data_length);
        if (message.public_key != null && Object.hasOwnProperty.call(message, "public_key"))
            writer.uint32(18).bytes(message.public_key);
        if (message.signature != null && Object.hasOwnProperty.call(message, "signature"))
            writer.uint32(26).bytes(message.signature);
        return writer;
    };

    BenfenTxRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    BenfenTxRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BenfenTxRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.data_length = reader.uint32();
                break;
            case 2:
                message.public_key = reader.bytes();
                break;
            case 3:
                message.signature = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    BenfenTxRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    BenfenTxRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.data_length != null && message.hasOwnProperty("data_length"))
            if (!$util.isInteger(message.data_length))
                return "data_length: integer expected";
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            if (!(message.public_key && typeof message.public_key.length === "number" || $util.isString(message.public_key)))
                return "public_key: buffer expected";
        if (message.signature != null && message.hasOwnProperty("signature"))
            if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
                return "signature: buffer expected";
        return null;
    };

    BenfenTxRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.BenfenTxRequest)
            return object;
        var message = new $root.BenfenTxRequest();
        if (object.data_length != null)
            message.data_length = object.data_length >>> 0;
        if (object.public_key != null)
            if (typeof object.public_key === "string")
                $util.base64.decode(object.public_key, message.public_key = $util.newBuffer($util.base64.length(object.public_key)), 0);
            else if (object.public_key.length)
                message.public_key = object.public_key;
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        return message;
    };

    BenfenTxRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.data_length = 0;
            if (options.bytes === String)
                object.public_key = "";
            else {
                object.public_key = [];
                if (options.bytes !== Array)
                    object.public_key = $util.newBuffer(object.public_key);
            }
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
        }
        if (message.data_length != null && message.hasOwnProperty("data_length"))
            object.data_length = message.data_length;
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            object.public_key = options.bytes === String ? $util.base64.encode(message.public_key, 0, message.public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.public_key) : message.public_key;
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        return object;
    };

    BenfenTxRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return BenfenTxRequest;
})();

$root.BenfenTxAck = (function() {

    function BenfenTxAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    BenfenTxAck.prototype.data_chunk = $util.newBuffer([]);

    BenfenTxAck.create = function create(properties) {
        return new BenfenTxAck(properties);
    };

    BenfenTxAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.data_chunk);
        return writer;
    };

    BenfenTxAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    BenfenTxAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BenfenTxAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.data_chunk = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("data_chunk"))
            throw $util.ProtocolError("missing required 'data_chunk'", { instance: message });
        return message;
    };

    BenfenTxAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    BenfenTxAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.data_chunk && typeof message.data_chunk.length === "number" || $util.isString(message.data_chunk)))
            return "data_chunk: buffer expected";
        return null;
    };

    BenfenTxAck.fromObject = function fromObject(object) {
        if (object instanceof $root.BenfenTxAck)
            return object;
        var message = new $root.BenfenTxAck();
        if (object.data_chunk != null)
            if (typeof object.data_chunk === "string")
                $util.base64.decode(object.data_chunk, message.data_chunk = $util.newBuffer($util.base64.length(object.data_chunk)), 0);
            else if (object.data_chunk.length)
                message.data_chunk = object.data_chunk;
        return message;
    };

    BenfenTxAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.data_chunk = "";
            else {
                object.data_chunk = [];
                if (options.bytes !== Array)
                    object.data_chunk = $util.newBuffer(object.data_chunk);
            }
        if (message.data_chunk != null && message.hasOwnProperty("data_chunk"))
            object.data_chunk = options.bytes === String ? $util.base64.encode(message.data_chunk, 0, message.data_chunk.length) : options.bytes === Array ? Array.prototype.slice.call(message.data_chunk) : message.data_chunk;
        return object;
    };

    BenfenTxAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return BenfenTxAck;
})();

$root.BenfenSignMessage = (function() {

    function BenfenSignMessage(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    BenfenSignMessage.prototype.address_n = $util.emptyArray;
    BenfenSignMessage.prototype.message = $util.newBuffer([]);

    BenfenSignMessage.create = function create(properties) {
        return new BenfenSignMessage(properties);
    };

    BenfenSignMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).bytes(message.message);
        return writer;
    };

    BenfenSignMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    BenfenSignMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BenfenSignMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.message = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("message"))
            throw $util.ProtocolError("missing required 'message'", { instance: message });
        return message;
    };

    BenfenSignMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    BenfenSignMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!(message.message && typeof message.message.length === "number" || $util.isString(message.message)))
            return "message: buffer expected";
        return null;
    };

    BenfenSignMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.BenfenSignMessage)
            return object;
        var message = new $root.BenfenSignMessage();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".BenfenSignMessage.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.message != null)
            if (typeof object.message === "string")
                $util.base64.decode(object.message, message.message = $util.newBuffer($util.base64.length(object.message)), 0);
            else if (object.message.length)
                message.message = object.message;
        return message;
    };

    BenfenSignMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            if (options.bytes === String)
                object.message = "";
            else {
                object.message = [];
                if (options.bytes !== Array)
                    object.message = $util.newBuffer(object.message);
            }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.message != null && message.hasOwnProperty("message"))
            object.message = options.bytes === String ? $util.base64.encode(message.message, 0, message.message.length) : options.bytes === Array ? Array.prototype.slice.call(message.message) : message.message;
        return object;
    };

    BenfenSignMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return BenfenSignMessage;
})();

$root.BenfenMessageSignature = (function() {

    function BenfenMessageSignature(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    BenfenMessageSignature.prototype.signature = $util.newBuffer([]);
    BenfenMessageSignature.prototype.address = "";

    BenfenMessageSignature.create = function create(properties) {
        return new BenfenMessageSignature(properties);
    };

    BenfenMessageSignature.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.signature);
        writer.uint32(18).string(message.address);
        return writer;
    };

    BenfenMessageSignature.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    BenfenMessageSignature.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BenfenMessageSignature();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.signature = reader.bytes();
                break;
            case 2:
                message.address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        if (!message.hasOwnProperty("address"))
            throw $util.ProtocolError("missing required 'address'", { instance: message });
        return message;
    };

    BenfenMessageSignature.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    BenfenMessageSignature.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        if (!$util.isString(message.address))
            return "address: string expected";
        return null;
    };

    BenfenMessageSignature.fromObject = function fromObject(object) {
        if (object instanceof $root.BenfenMessageSignature)
            return object;
        var message = new $root.BenfenMessageSignature();
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        if (object.address != null)
            message.address = String(object.address);
        return message;
    };

    BenfenMessageSignature.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
            object.address = "";
        }
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    BenfenMessageSignature.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return BenfenMessageSignature;
})();

$root.BinanceGetAddress = (function() {

    function BinanceGetAddress(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    BinanceGetAddress.prototype.address_n = $util.emptyArray;
    BinanceGetAddress.prototype.show_display = false;

    BinanceGetAddress.create = function create(properties) {
        return new BinanceGetAddress(properties);
    };

    BinanceGetAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(16).bool(message.show_display);
        return writer;
    };

    BinanceGetAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    BinanceGetAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BinanceGetAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.show_display = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    BinanceGetAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    BinanceGetAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        return null;
    };

    BinanceGetAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.BinanceGetAddress)
            return object;
        var message = new $root.BinanceGetAddress();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".BinanceGetAddress.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        return message;
    };

    BinanceGetAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            object.show_display = false;
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        return object;
    };

    BinanceGetAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return BinanceGetAddress;
})();

$root.BinanceAddress = (function() {

    function BinanceAddress(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    BinanceAddress.prototype.address = "";

    BinanceAddress.create = function create(properties) {
        return new BinanceAddress(properties);
    };

    BinanceAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.address);
        return writer;
    };

    BinanceAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    BinanceAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BinanceAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("address"))
            throw $util.ProtocolError("missing required 'address'", { instance: message });
        return message;
    };

    BinanceAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    BinanceAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.address))
            return "address: string expected";
        return null;
    };

    BinanceAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.BinanceAddress)
            return object;
        var message = new $root.BinanceAddress();
        if (object.address != null)
            message.address = String(object.address);
        return message;
    };

    BinanceAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.address = "";
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    BinanceAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return BinanceAddress;
})();

$root.BinanceGetPublicKey = (function() {

    function BinanceGetPublicKey(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    BinanceGetPublicKey.prototype.address_n = $util.emptyArray;
    BinanceGetPublicKey.prototype.show_display = false;

    BinanceGetPublicKey.create = function create(properties) {
        return new BinanceGetPublicKey(properties);
    };

    BinanceGetPublicKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(16).bool(message.show_display);
        return writer;
    };

    BinanceGetPublicKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    BinanceGetPublicKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BinanceGetPublicKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.show_display = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    BinanceGetPublicKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    BinanceGetPublicKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        return null;
    };

    BinanceGetPublicKey.fromObject = function fromObject(object) {
        if (object instanceof $root.BinanceGetPublicKey)
            return object;
        var message = new $root.BinanceGetPublicKey();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".BinanceGetPublicKey.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        return message;
    };

    BinanceGetPublicKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            object.show_display = false;
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        return object;
    };

    BinanceGetPublicKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return BinanceGetPublicKey;
})();

$root.BinancePublicKey = (function() {

    function BinancePublicKey(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    BinancePublicKey.prototype.public_key = $util.newBuffer([]);

    BinancePublicKey.create = function create(properties) {
        return new BinancePublicKey(properties);
    };

    BinancePublicKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.public_key);
        return writer;
    };

    BinancePublicKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    BinancePublicKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BinancePublicKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.public_key = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("public_key"))
            throw $util.ProtocolError("missing required 'public_key'", { instance: message });
        return message;
    };

    BinancePublicKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    BinancePublicKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.public_key && typeof message.public_key.length === "number" || $util.isString(message.public_key)))
            return "public_key: buffer expected";
        return null;
    };

    BinancePublicKey.fromObject = function fromObject(object) {
        if (object instanceof $root.BinancePublicKey)
            return object;
        var message = new $root.BinancePublicKey();
        if (object.public_key != null)
            if (typeof object.public_key === "string")
                $util.base64.decode(object.public_key, message.public_key = $util.newBuffer($util.base64.length(object.public_key)), 0);
            else if (object.public_key.length)
                message.public_key = object.public_key;
        return message;
    };

    BinancePublicKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.public_key = "";
            else {
                object.public_key = [];
                if (options.bytes !== Array)
                    object.public_key = $util.newBuffer(object.public_key);
            }
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            object.public_key = options.bytes === String ? $util.base64.encode(message.public_key, 0, message.public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.public_key) : message.public_key;
        return object;
    };

    BinancePublicKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return BinancePublicKey;
})();

$root.BinanceSignTx = (function() {

    function BinanceSignTx(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    BinanceSignTx.prototype.address_n = $util.emptyArray;
    BinanceSignTx.prototype.msg_count = 0;
    BinanceSignTx.prototype.account_number = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    BinanceSignTx.prototype.chain_id = "";
    BinanceSignTx.prototype.memo = "";
    BinanceSignTx.prototype.sequence = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    BinanceSignTx.prototype.source = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    BinanceSignTx.create = function create(properties) {
        return new BinanceSignTx(properties);
    };

    BinanceSignTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.msg_count != null && Object.hasOwnProperty.call(message, "msg_count"))
            writer.uint32(16).uint32(message.msg_count);
        if (message.account_number != null && Object.hasOwnProperty.call(message, "account_number"))
            writer.uint32(24).sint64(message.account_number);
        if (message.chain_id != null && Object.hasOwnProperty.call(message, "chain_id"))
            writer.uint32(34).string(message.chain_id);
        if (message.memo != null && Object.hasOwnProperty.call(message, "memo"))
            writer.uint32(42).string(message.memo);
        if (message.sequence != null && Object.hasOwnProperty.call(message, "sequence"))
            writer.uint32(48).sint64(message.sequence);
        if (message.source != null && Object.hasOwnProperty.call(message, "source"))
            writer.uint32(56).sint64(message.source);
        return writer;
    };

    BinanceSignTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    BinanceSignTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BinanceSignTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.msg_count = reader.uint32();
                break;
            case 3:
                message.account_number = reader.sint64();
                break;
            case 4:
                message.chain_id = reader.string();
                break;
            case 5:
                message.memo = reader.string();
                break;
            case 6:
                message.sequence = reader.sint64();
                break;
            case 7:
                message.source = reader.sint64();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    BinanceSignTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    BinanceSignTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.msg_count != null && message.hasOwnProperty("msg_count"))
            if (!$util.isInteger(message.msg_count))
                return "msg_count: integer expected";
        if (message.account_number != null && message.hasOwnProperty("account_number"))
            if (!$util.isInteger(message.account_number) && !(message.account_number && $util.isInteger(message.account_number.low) && $util.isInteger(message.account_number.high)))
                return "account_number: integer|Long expected";
        if (message.chain_id != null && message.hasOwnProperty("chain_id"))
            if (!$util.isString(message.chain_id))
                return "chain_id: string expected";
        if (message.memo != null && message.hasOwnProperty("memo"))
            if (!$util.isString(message.memo))
                return "memo: string expected";
        if (message.sequence != null && message.hasOwnProperty("sequence"))
            if (!$util.isInteger(message.sequence) && !(message.sequence && $util.isInteger(message.sequence.low) && $util.isInteger(message.sequence.high)))
                return "sequence: integer|Long expected";
        if (message.source != null && message.hasOwnProperty("source"))
            if (!$util.isInteger(message.source) && !(message.source && $util.isInteger(message.source.low) && $util.isInteger(message.source.high)))
                return "source: integer|Long expected";
        return null;
    };

    BinanceSignTx.fromObject = function fromObject(object) {
        if (object instanceof $root.BinanceSignTx)
            return object;
        var message = new $root.BinanceSignTx();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".BinanceSignTx.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.msg_count != null)
            message.msg_count = object.msg_count >>> 0;
        if (object.account_number != null)
            if ($util.Long)
                (message.account_number = $util.Long.fromValue(object.account_number)).unsigned = false;
            else if (typeof object.account_number === "string")
                message.account_number = parseInt(object.account_number, 10);
            else if (typeof object.account_number === "number")
                message.account_number = object.account_number;
            else if (typeof object.account_number === "object")
                message.account_number = new $util.LongBits(object.account_number.low >>> 0, object.account_number.high >>> 0).toNumber();
        if (object.chain_id != null)
            message.chain_id = String(object.chain_id);
        if (object.memo != null)
            message.memo = String(object.memo);
        if (object.sequence != null)
            if ($util.Long)
                (message.sequence = $util.Long.fromValue(object.sequence)).unsigned = false;
            else if (typeof object.sequence === "string")
                message.sequence = parseInt(object.sequence, 10);
            else if (typeof object.sequence === "number")
                message.sequence = object.sequence;
            else if (typeof object.sequence === "object")
                message.sequence = new $util.LongBits(object.sequence.low >>> 0, object.sequence.high >>> 0).toNumber();
        if (object.source != null)
            if ($util.Long)
                (message.source = $util.Long.fromValue(object.source)).unsigned = false;
            else if (typeof object.source === "string")
                message.source = parseInt(object.source, 10);
            else if (typeof object.source === "number")
                message.source = object.source;
            else if (typeof object.source === "object")
                message.source = new $util.LongBits(object.source.low >>> 0, object.source.high >>> 0).toNumber();
        return message;
    };

    BinanceSignTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            object.msg_count = 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.account_number = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.account_number = options.longs === String ? "0" : 0;
            object.chain_id = "";
            object.memo = "";
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.sequence = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.sequence = options.longs === String ? "0" : 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.source = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.source = options.longs === String ? "0" : 0;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.msg_count != null && message.hasOwnProperty("msg_count"))
            object.msg_count = message.msg_count;
        if (message.account_number != null && message.hasOwnProperty("account_number"))
            if (typeof message.account_number === "number")
                object.account_number = options.longs === String ? String(message.account_number) : message.account_number;
            else
                object.account_number = options.longs === String ? $util.Long.prototype.toString.call(message.account_number) : options.longs === Number ? new $util.LongBits(message.account_number.low >>> 0, message.account_number.high >>> 0).toNumber() : message.account_number;
        if (message.chain_id != null && message.hasOwnProperty("chain_id"))
            object.chain_id = message.chain_id;
        if (message.memo != null && message.hasOwnProperty("memo"))
            object.memo = message.memo;
        if (message.sequence != null && message.hasOwnProperty("sequence"))
            if (typeof message.sequence === "number")
                object.sequence = options.longs === String ? String(message.sequence) : message.sequence;
            else
                object.sequence = options.longs === String ? $util.Long.prototype.toString.call(message.sequence) : options.longs === Number ? new $util.LongBits(message.sequence.low >>> 0, message.sequence.high >>> 0).toNumber() : message.sequence;
        if (message.source != null && message.hasOwnProperty("source"))
            if (typeof message.source === "number")
                object.source = options.longs === String ? String(message.source) : message.source;
            else
                object.source = options.longs === String ? $util.Long.prototype.toString.call(message.source) : options.longs === Number ? new $util.LongBits(message.source.low >>> 0, message.source.high >>> 0).toNumber() : message.source;
        return object;
    };

    BinanceSignTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return BinanceSignTx;
})();

$root.BinanceTxRequest = (function() {

    function BinanceTxRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    BinanceTxRequest.create = function create(properties) {
        return new BinanceTxRequest(properties);
    };

    BinanceTxRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    BinanceTxRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    BinanceTxRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BinanceTxRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    BinanceTxRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    BinanceTxRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    BinanceTxRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.BinanceTxRequest)
            return object;
        return new $root.BinanceTxRequest();
    };

    BinanceTxRequest.toObject = function toObject() {
        return {};
    };

    BinanceTxRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return BinanceTxRequest;
})();

$root.BinanceTransferMsg = (function() {

    function BinanceTransferMsg(properties) {
        this.inputs = [];
        this.outputs = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    BinanceTransferMsg.prototype.inputs = $util.emptyArray;
    BinanceTransferMsg.prototype.outputs = $util.emptyArray;

    BinanceTransferMsg.create = function create(properties) {
        return new BinanceTransferMsg(properties);
    };

    BinanceTransferMsg.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.inputs != null && message.inputs.length)
            for (var i = 0; i < message.inputs.length; ++i)
                $root.BinanceTransferMsg.BinanceInputOutput.encode(message.inputs[i], writer.uint32(10).fork()).ldelim();
        if (message.outputs != null && message.outputs.length)
            for (var i = 0; i < message.outputs.length; ++i)
                $root.BinanceTransferMsg.BinanceInputOutput.encode(message.outputs[i], writer.uint32(18).fork()).ldelim();
        return writer;
    };

    BinanceTransferMsg.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    BinanceTransferMsg.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BinanceTransferMsg();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.inputs && message.inputs.length))
                    message.inputs = [];
                message.inputs.push($root.BinanceTransferMsg.BinanceInputOutput.decode(reader, reader.uint32()));
                break;
            case 2:
                if (!(message.outputs && message.outputs.length))
                    message.outputs = [];
                message.outputs.push($root.BinanceTransferMsg.BinanceInputOutput.decode(reader, reader.uint32()));
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    BinanceTransferMsg.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    BinanceTransferMsg.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.inputs != null && message.hasOwnProperty("inputs")) {
            if (!Array.isArray(message.inputs))
                return "inputs: array expected";
            for (var i = 0; i < message.inputs.length; ++i) {
                var error = $root.BinanceTransferMsg.BinanceInputOutput.verify(message.inputs[i]);
                if (error)
                    return "inputs." + error;
            }
        }
        if (message.outputs != null && message.hasOwnProperty("outputs")) {
            if (!Array.isArray(message.outputs))
                return "outputs: array expected";
            for (var i = 0; i < message.outputs.length; ++i) {
                var error = $root.BinanceTransferMsg.BinanceInputOutput.verify(message.outputs[i]);
                if (error)
                    return "outputs." + error;
            }
        }
        return null;
    };

    BinanceTransferMsg.fromObject = function fromObject(object) {
        if (object instanceof $root.BinanceTransferMsg)
            return object;
        var message = new $root.BinanceTransferMsg();
        if (object.inputs) {
            if (!Array.isArray(object.inputs))
                throw TypeError(".BinanceTransferMsg.inputs: array expected");
            message.inputs = [];
            for (var i = 0; i < object.inputs.length; ++i) {
                if (typeof object.inputs[i] !== "object")
                    throw TypeError(".BinanceTransferMsg.inputs: object expected");
                message.inputs[i] = $root.BinanceTransferMsg.BinanceInputOutput.fromObject(object.inputs[i]);
            }
        }
        if (object.outputs) {
            if (!Array.isArray(object.outputs))
                throw TypeError(".BinanceTransferMsg.outputs: array expected");
            message.outputs = [];
            for (var i = 0; i < object.outputs.length; ++i) {
                if (typeof object.outputs[i] !== "object")
                    throw TypeError(".BinanceTransferMsg.outputs: object expected");
                message.outputs[i] = $root.BinanceTransferMsg.BinanceInputOutput.fromObject(object.outputs[i]);
            }
        }
        return message;
    };

    BinanceTransferMsg.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults) {
            object.inputs = [];
            object.outputs = [];
        }
        if (message.inputs && message.inputs.length) {
            object.inputs = [];
            for (var j = 0; j < message.inputs.length; ++j)
                object.inputs[j] = $root.BinanceTransferMsg.BinanceInputOutput.toObject(message.inputs[j], options);
        }
        if (message.outputs && message.outputs.length) {
            object.outputs = [];
            for (var j = 0; j < message.outputs.length; ++j)
                object.outputs[j] = $root.BinanceTransferMsg.BinanceInputOutput.toObject(message.outputs[j], options);
        }
        return object;
    };

    BinanceTransferMsg.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    BinanceTransferMsg.BinanceInputOutput = (function() {

        function BinanceInputOutput(properties) {
            this.coins = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        BinanceInputOutput.prototype.address = "";
        BinanceInputOutput.prototype.coins = $util.emptyArray;

        BinanceInputOutput.create = function create(properties) {
            return new BinanceInputOutput(properties);
        };

        BinanceInputOutput.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.address != null && Object.hasOwnProperty.call(message, "address"))
                writer.uint32(10).string(message.address);
            if (message.coins != null && message.coins.length)
                for (var i = 0; i < message.coins.length; ++i)
                    $root.BinanceTransferMsg.BinanceCoin.encode(message.coins[i], writer.uint32(18).fork()).ldelim();
            return writer;
        };

        BinanceInputOutput.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        BinanceInputOutput.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BinanceTransferMsg.BinanceInputOutput();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    if (!(message.coins && message.coins.length))
                        message.coins = [];
                    message.coins.push($root.BinanceTransferMsg.BinanceCoin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        BinanceInputOutput.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        BinanceInputOutput.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.address != null && message.hasOwnProperty("address"))
                if (!$util.isString(message.address))
                    return "address: string expected";
            if (message.coins != null && message.hasOwnProperty("coins")) {
                if (!Array.isArray(message.coins))
                    return "coins: array expected";
                for (var i = 0; i < message.coins.length; ++i) {
                    var error = $root.BinanceTransferMsg.BinanceCoin.verify(message.coins[i]);
                    if (error)
                        return "coins." + error;
                }
            }
            return null;
        };

        BinanceInputOutput.fromObject = function fromObject(object) {
            if (object instanceof $root.BinanceTransferMsg.BinanceInputOutput)
                return object;
            var message = new $root.BinanceTransferMsg.BinanceInputOutput();
            if (object.address != null)
                message.address = String(object.address);
            if (object.coins) {
                if (!Array.isArray(object.coins))
                    throw TypeError(".BinanceTransferMsg.BinanceInputOutput.coins: array expected");
                message.coins = [];
                for (var i = 0; i < object.coins.length; ++i) {
                    if (typeof object.coins[i] !== "object")
                        throw TypeError(".BinanceTransferMsg.BinanceInputOutput.coins: object expected");
                    message.coins[i] = $root.BinanceTransferMsg.BinanceCoin.fromObject(object.coins[i]);
                }
            }
            return message;
        };

        BinanceInputOutput.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.coins = [];
            if (options.defaults)
                object.address = "";
            if (message.address != null && message.hasOwnProperty("address"))
                object.address = message.address;
            if (message.coins && message.coins.length) {
                object.coins = [];
                for (var j = 0; j < message.coins.length; ++j)
                    object.coins[j] = $root.BinanceTransferMsg.BinanceCoin.toObject(message.coins[j], options);
            }
            return object;
        };

        BinanceInputOutput.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return BinanceInputOutput;
    })();

    BinanceTransferMsg.BinanceCoin = (function() {

        function BinanceCoin(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        BinanceCoin.prototype.amount = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        BinanceCoin.prototype.denom = "";

        BinanceCoin.create = function create(properties) {
            return new BinanceCoin(properties);
        };

        BinanceCoin.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
                writer.uint32(8).sint64(message.amount);
            if (message.denom != null && Object.hasOwnProperty.call(message, "denom"))
                writer.uint32(18).string(message.denom);
            return writer;
        };

        BinanceCoin.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        BinanceCoin.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BinanceTransferMsg.BinanceCoin();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.amount = reader.sint64();
                    break;
                case 2:
                    message.denom = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        BinanceCoin.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        BinanceCoin.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.amount != null && message.hasOwnProperty("amount"))
                if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
                    return "amount: integer|Long expected";
            if (message.denom != null && message.hasOwnProperty("denom"))
                if (!$util.isString(message.denom))
                    return "denom: string expected";
            return null;
        };

        BinanceCoin.fromObject = function fromObject(object) {
            if (object instanceof $root.BinanceTransferMsg.BinanceCoin)
                return object;
            var message = new $root.BinanceTransferMsg.BinanceCoin();
            if (object.amount != null)
                if ($util.Long)
                    (message.amount = $util.Long.fromValue(object.amount)).unsigned = false;
                else if (typeof object.amount === "string")
                    message.amount = parseInt(object.amount, 10);
                else if (typeof object.amount === "number")
                    message.amount = object.amount;
                else if (typeof object.amount === "object")
                    message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber();
            if (object.denom != null)
                message.denom = String(object.denom);
            return message;
        };

        BinanceCoin.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.amount = options.longs === String ? "0" : 0;
                object.denom = "";
            }
            if (message.amount != null && message.hasOwnProperty("amount"))
                if (typeof message.amount === "number")
                    object.amount = options.longs === String ? String(message.amount) : message.amount;
                else
                    object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber() : message.amount;
            if (message.denom != null && message.hasOwnProperty("denom"))
                object.denom = message.denom;
            return object;
        };

        BinanceCoin.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return BinanceCoin;
    })();

    return BinanceTransferMsg;
})();

$root.BinanceOrderMsg = (function() {

    function BinanceOrderMsg(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    BinanceOrderMsg.prototype.id = "";
    BinanceOrderMsg.prototype.ordertype = 0;
    BinanceOrderMsg.prototype.price = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    BinanceOrderMsg.prototype.quantity = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    BinanceOrderMsg.prototype.sender = "";
    BinanceOrderMsg.prototype.side = 0;
    BinanceOrderMsg.prototype.symbol = "";
    BinanceOrderMsg.prototype.timeinforce = 0;

    BinanceOrderMsg.create = function create(properties) {
        return new BinanceOrderMsg(properties);
    };

    BinanceOrderMsg.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
            writer.uint32(10).string(message.id);
        if (message.ordertype != null && Object.hasOwnProperty.call(message, "ordertype"))
            writer.uint32(16).int32(message.ordertype);
        if (message.price != null && Object.hasOwnProperty.call(message, "price"))
            writer.uint32(24).sint64(message.price);
        if (message.quantity != null && Object.hasOwnProperty.call(message, "quantity"))
            writer.uint32(32).sint64(message.quantity);
        if (message.sender != null && Object.hasOwnProperty.call(message, "sender"))
            writer.uint32(42).string(message.sender);
        if (message.side != null && Object.hasOwnProperty.call(message, "side"))
            writer.uint32(48).int32(message.side);
        if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
            writer.uint32(58).string(message.symbol);
        if (message.timeinforce != null && Object.hasOwnProperty.call(message, "timeinforce"))
            writer.uint32(64).int32(message.timeinforce);
        return writer;
    };

    BinanceOrderMsg.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    BinanceOrderMsg.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BinanceOrderMsg();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.id = reader.string();
                break;
            case 2:
                message.ordertype = reader.int32();
                break;
            case 3:
                message.price = reader.sint64();
                break;
            case 4:
                message.quantity = reader.sint64();
                break;
            case 5:
                message.sender = reader.string();
                break;
            case 6:
                message.side = reader.int32();
                break;
            case 7:
                message.symbol = reader.string();
                break;
            case 8:
                message.timeinforce = reader.int32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    BinanceOrderMsg.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    BinanceOrderMsg.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.id != null && message.hasOwnProperty("id"))
            if (!$util.isString(message.id))
                return "id: string expected";
        if (message.ordertype != null && message.hasOwnProperty("ordertype"))
            switch (message.ordertype) {
            default:
                return "ordertype: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
                break;
            }
        if (message.price != null && message.hasOwnProperty("price"))
            if (!$util.isInteger(message.price) && !(message.price && $util.isInteger(message.price.low) && $util.isInteger(message.price.high)))
                return "price: integer|Long expected";
        if (message.quantity != null && message.hasOwnProperty("quantity"))
            if (!$util.isInteger(message.quantity) && !(message.quantity && $util.isInteger(message.quantity.low) && $util.isInteger(message.quantity.high)))
                return "quantity: integer|Long expected";
        if (message.sender != null && message.hasOwnProperty("sender"))
            if (!$util.isString(message.sender))
                return "sender: string expected";
        if (message.side != null && message.hasOwnProperty("side"))
            switch (message.side) {
            default:
                return "side: enum value expected";
            case 0:
            case 1:
            case 2:
                break;
            }
        if (message.symbol != null && message.hasOwnProperty("symbol"))
            if (!$util.isString(message.symbol))
                return "symbol: string expected";
        if (message.timeinforce != null && message.hasOwnProperty("timeinforce"))
            switch (message.timeinforce) {
            default:
                return "timeinforce: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
                break;
            }
        return null;
    };

    BinanceOrderMsg.fromObject = function fromObject(object) {
        if (object instanceof $root.BinanceOrderMsg)
            return object;
        var message = new $root.BinanceOrderMsg();
        if (object.id != null)
            message.id = String(object.id);
        switch (object.ordertype) {
        case "OT_UNKNOWN":
        case 0:
            message.ordertype = 0;
            break;
        case "MARKET":
        case 1:
            message.ordertype = 1;
            break;
        case "LIMIT":
        case 2:
            message.ordertype = 2;
            break;
        case "OT_RESERVED":
        case 3:
            message.ordertype = 3;
            break;
        }
        if (object.price != null)
            if ($util.Long)
                (message.price = $util.Long.fromValue(object.price)).unsigned = false;
            else if (typeof object.price === "string")
                message.price = parseInt(object.price, 10);
            else if (typeof object.price === "number")
                message.price = object.price;
            else if (typeof object.price === "object")
                message.price = new $util.LongBits(object.price.low >>> 0, object.price.high >>> 0).toNumber();
        if (object.quantity != null)
            if ($util.Long)
                (message.quantity = $util.Long.fromValue(object.quantity)).unsigned = false;
            else if (typeof object.quantity === "string")
                message.quantity = parseInt(object.quantity, 10);
            else if (typeof object.quantity === "number")
                message.quantity = object.quantity;
            else if (typeof object.quantity === "object")
                message.quantity = new $util.LongBits(object.quantity.low >>> 0, object.quantity.high >>> 0).toNumber();
        if (object.sender != null)
            message.sender = String(object.sender);
        switch (object.side) {
        case "SIDE_UNKNOWN":
        case 0:
            message.side = 0;
            break;
        case "BUY":
        case 1:
            message.side = 1;
            break;
        case "SELL":
        case 2:
            message.side = 2;
            break;
        }
        if (object.symbol != null)
            message.symbol = String(object.symbol);
        switch (object.timeinforce) {
        case "TIF_UNKNOWN":
        case 0:
            message.timeinforce = 0;
            break;
        case "GTE":
        case 1:
            message.timeinforce = 1;
            break;
        case "TIF_RESERVED":
        case 2:
            message.timeinforce = 2;
            break;
        case "IOC":
        case 3:
            message.timeinforce = 3;
            break;
        }
        return message;
    };

    BinanceOrderMsg.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.id = "";
            object.ordertype = options.enums === String ? "OT_UNKNOWN" : 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.price = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.price = options.longs === String ? "0" : 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.quantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.quantity = options.longs === String ? "0" : 0;
            object.sender = "";
            object.side = options.enums === String ? "SIDE_UNKNOWN" : 0;
            object.symbol = "";
            object.timeinforce = options.enums === String ? "TIF_UNKNOWN" : 0;
        }
        if (message.id != null && message.hasOwnProperty("id"))
            object.id = message.id;
        if (message.ordertype != null && message.hasOwnProperty("ordertype"))
            object.ordertype = options.enums === String ? $root.BinanceOrderMsg.BinanceOrderType[message.ordertype] : message.ordertype;
        if (message.price != null && message.hasOwnProperty("price"))
            if (typeof message.price === "number")
                object.price = options.longs === String ? String(message.price) : message.price;
            else
                object.price = options.longs === String ? $util.Long.prototype.toString.call(message.price) : options.longs === Number ? new $util.LongBits(message.price.low >>> 0, message.price.high >>> 0).toNumber() : message.price;
        if (message.quantity != null && message.hasOwnProperty("quantity"))
            if (typeof message.quantity === "number")
                object.quantity = options.longs === String ? String(message.quantity) : message.quantity;
            else
                object.quantity = options.longs === String ? $util.Long.prototype.toString.call(message.quantity) : options.longs === Number ? new $util.LongBits(message.quantity.low >>> 0, message.quantity.high >>> 0).toNumber() : message.quantity;
        if (message.sender != null && message.hasOwnProperty("sender"))
            object.sender = message.sender;
        if (message.side != null && message.hasOwnProperty("side"))
            object.side = options.enums === String ? $root.BinanceOrderMsg.BinanceOrderSide[message.side] : message.side;
        if (message.symbol != null && message.hasOwnProperty("symbol"))
            object.symbol = message.symbol;
        if (message.timeinforce != null && message.hasOwnProperty("timeinforce"))
            object.timeinforce = options.enums === String ? $root.BinanceOrderMsg.BinanceTimeInForce[message.timeinforce] : message.timeinforce;
        return object;
    };

    BinanceOrderMsg.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    BinanceOrderMsg.BinanceOrderType = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "OT_UNKNOWN"] = 0;
        values[valuesById[1] = "MARKET"] = 1;
        values[valuesById[2] = "LIMIT"] = 2;
        values[valuesById[3] = "OT_RESERVED"] = 3;
        return values;
    })();

    BinanceOrderMsg.BinanceOrderSide = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "SIDE_UNKNOWN"] = 0;
        values[valuesById[1] = "BUY"] = 1;
        values[valuesById[2] = "SELL"] = 2;
        return values;
    })();

    BinanceOrderMsg.BinanceTimeInForce = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "TIF_UNKNOWN"] = 0;
        values[valuesById[1] = "GTE"] = 1;
        values[valuesById[2] = "TIF_RESERVED"] = 2;
        values[valuesById[3] = "IOC"] = 3;
        return values;
    })();

    return BinanceOrderMsg;
})();

$root.BinanceCancelMsg = (function() {

    function BinanceCancelMsg(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    BinanceCancelMsg.prototype.refid = "";
    BinanceCancelMsg.prototype.sender = "";
    BinanceCancelMsg.prototype.symbol = "";

    BinanceCancelMsg.create = function create(properties) {
        return new BinanceCancelMsg(properties);
    };

    BinanceCancelMsg.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.refid != null && Object.hasOwnProperty.call(message, "refid"))
            writer.uint32(10).string(message.refid);
        if (message.sender != null && Object.hasOwnProperty.call(message, "sender"))
            writer.uint32(18).string(message.sender);
        if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
            writer.uint32(26).string(message.symbol);
        return writer;
    };

    BinanceCancelMsg.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    BinanceCancelMsg.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BinanceCancelMsg();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.refid = reader.string();
                break;
            case 2:
                message.sender = reader.string();
                break;
            case 3:
                message.symbol = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    BinanceCancelMsg.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    BinanceCancelMsg.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.refid != null && message.hasOwnProperty("refid"))
            if (!$util.isString(message.refid))
                return "refid: string expected";
        if (message.sender != null && message.hasOwnProperty("sender"))
            if (!$util.isString(message.sender))
                return "sender: string expected";
        if (message.symbol != null && message.hasOwnProperty("symbol"))
            if (!$util.isString(message.symbol))
                return "symbol: string expected";
        return null;
    };

    BinanceCancelMsg.fromObject = function fromObject(object) {
        if (object instanceof $root.BinanceCancelMsg)
            return object;
        var message = new $root.BinanceCancelMsg();
        if (object.refid != null)
            message.refid = String(object.refid);
        if (object.sender != null)
            message.sender = String(object.sender);
        if (object.symbol != null)
            message.symbol = String(object.symbol);
        return message;
    };

    BinanceCancelMsg.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.refid = "";
            object.sender = "";
            object.symbol = "";
        }
        if (message.refid != null && message.hasOwnProperty("refid"))
            object.refid = message.refid;
        if (message.sender != null && message.hasOwnProperty("sender"))
            object.sender = message.sender;
        if (message.symbol != null && message.hasOwnProperty("symbol"))
            object.symbol = message.symbol;
        return object;
    };

    BinanceCancelMsg.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return BinanceCancelMsg;
})();

$root.BinanceSignedTx = (function() {

    function BinanceSignedTx(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    BinanceSignedTx.prototype.signature = $util.newBuffer([]);
    BinanceSignedTx.prototype.public_key = $util.newBuffer([]);

    BinanceSignedTx.create = function create(properties) {
        return new BinanceSignedTx(properties);
    };

    BinanceSignedTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.signature);
        writer.uint32(18).bytes(message.public_key);
        return writer;
    };

    BinanceSignedTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    BinanceSignedTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BinanceSignedTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.signature = reader.bytes();
                break;
            case 2:
                message.public_key = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        if (!message.hasOwnProperty("public_key"))
            throw $util.ProtocolError("missing required 'public_key'", { instance: message });
        return message;
    };

    BinanceSignedTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    BinanceSignedTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        if (!(message.public_key && typeof message.public_key.length === "number" || $util.isString(message.public_key)))
            return "public_key: buffer expected";
        return null;
    };

    BinanceSignedTx.fromObject = function fromObject(object) {
        if (object instanceof $root.BinanceSignedTx)
            return object;
        var message = new $root.BinanceSignedTx();
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        if (object.public_key != null)
            if (typeof object.public_key === "string")
                $util.base64.decode(object.public_key, message.public_key = $util.newBuffer($util.base64.length(object.public_key)), 0);
            else if (object.public_key.length)
                message.public_key = object.public_key;
        return message;
    };

    BinanceSignedTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
            if (options.bytes === String)
                object.public_key = "";
            else {
                object.public_key = [];
                if (options.bytes !== Array)
                    object.public_key = $util.newBuffer(object.public_key);
            }
        }
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            object.public_key = options.bytes === String ? $util.base64.encode(message.public_key, 0, message.public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.public_key) : message.public_key;
        return object;
    };

    BinanceSignedTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return BinanceSignedTx;
})();

$root.InputScriptType = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "SPENDADDRESS"] = 0;
    values[valuesById[1] = "SPENDMULTISIG"] = 1;
    values[valuesById[2] = "EXTERNAL"] = 2;
    values[valuesById[3] = "SPENDWITNESS"] = 3;
    values[valuesById[4] = "SPENDP2SHWITNESS"] = 4;
    values[valuesById[5] = "SPENDTAPROOT"] = 5;
    return values;
})();

$root.OutputScriptType = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "PAYTOADDRESS"] = 0;
    values[valuesById[1] = "PAYTOSCRIPTHASH"] = 1;
    values[valuesById[2] = "PAYTOMULTISIG"] = 2;
    values[valuesById[3] = "PAYTOOPRETURN"] = 3;
    values[valuesById[4] = "PAYTOWITNESS"] = 4;
    values[valuesById[5] = "PAYTOP2SHWITNESS"] = 5;
    values[valuesById[6] = "PAYTOTAPROOT"] = 6;
    return values;
})();

$root.DecredStakingSpendType = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "SSGen"] = 0;
    values[valuesById[1] = "SSRTX"] = 1;
    return values;
})();

$root.AmountUnit = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "BITCOIN"] = 0;
    values[valuesById[1] = "MILLIBITCOIN"] = 1;
    values[valuesById[2] = "MICROBITCOIN"] = 2;
    values[valuesById[3] = "SATOSHI"] = 3;
    return values;
})();

$root.MultisigRedeemScriptType = (function() {

    function MultisigRedeemScriptType(properties) {
        this.pubkeys = [];
        this.signatures = [];
        this.nodes = [];
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MultisigRedeemScriptType.prototype.pubkeys = $util.emptyArray;
    MultisigRedeemScriptType.prototype.signatures = $util.emptyArray;
    MultisigRedeemScriptType.prototype.m = 0;
    MultisigRedeemScriptType.prototype.nodes = $util.emptyArray;
    MultisigRedeemScriptType.prototype.address_n = $util.emptyArray;

    MultisigRedeemScriptType.create = function create(properties) {
        return new MultisigRedeemScriptType(properties);
    };

    MultisigRedeemScriptType.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.pubkeys != null && message.pubkeys.length)
            for (var i = 0; i < message.pubkeys.length; ++i)
                $root.MultisigRedeemScriptType.HDNodePathType.encode(message.pubkeys[i], writer.uint32(10).fork()).ldelim();
        if (message.signatures != null && message.signatures.length)
            for (var i = 0; i < message.signatures.length; ++i)
                writer.uint32(18).bytes(message.signatures[i]);
        writer.uint32(24).uint32(message.m);
        if (message.nodes != null && message.nodes.length)
            for (var i = 0; i < message.nodes.length; ++i)
                $root.HDNodeType.encode(message.nodes[i], writer.uint32(34).fork()).ldelim();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(40).uint32(message.address_n[i]);
        return writer;
    };

    MultisigRedeemScriptType.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MultisigRedeemScriptType.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MultisigRedeemScriptType();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.pubkeys && message.pubkeys.length))
                    message.pubkeys = [];
                message.pubkeys.push($root.MultisigRedeemScriptType.HDNodePathType.decode(reader, reader.uint32()));
                break;
            case 2:
                if (!(message.signatures && message.signatures.length))
                    message.signatures = [];
                message.signatures.push(reader.bytes());
                break;
            case 3:
                message.m = reader.uint32();
                break;
            case 4:
                if (!(message.nodes && message.nodes.length))
                    message.nodes = [];
                message.nodes.push($root.HDNodeType.decode(reader, reader.uint32()));
                break;
            case 5:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("m"))
            throw $util.ProtocolError("missing required 'm'", { instance: message });
        return message;
    };

    MultisigRedeemScriptType.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MultisigRedeemScriptType.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.pubkeys != null && message.hasOwnProperty("pubkeys")) {
            if (!Array.isArray(message.pubkeys))
                return "pubkeys: array expected";
            for (var i = 0; i < message.pubkeys.length; ++i) {
                var error = $root.MultisigRedeemScriptType.HDNodePathType.verify(message.pubkeys[i]);
                if (error)
                    return "pubkeys." + error;
            }
        }
        if (message.signatures != null && message.hasOwnProperty("signatures")) {
            if (!Array.isArray(message.signatures))
                return "signatures: array expected";
            for (var i = 0; i < message.signatures.length; ++i)
                if (!(message.signatures[i] && typeof message.signatures[i].length === "number" || $util.isString(message.signatures[i])))
                    return "signatures: buffer[] expected";
        }
        if (!$util.isInteger(message.m))
            return "m: integer expected";
        if (message.nodes != null && message.hasOwnProperty("nodes")) {
            if (!Array.isArray(message.nodes))
                return "nodes: array expected";
            for (var i = 0; i < message.nodes.length; ++i) {
                var error = $root.HDNodeType.verify(message.nodes[i]);
                if (error)
                    return "nodes." + error;
            }
        }
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        return null;
    };

    MultisigRedeemScriptType.fromObject = function fromObject(object) {
        if (object instanceof $root.MultisigRedeemScriptType)
            return object;
        var message = new $root.MultisigRedeemScriptType();
        if (object.pubkeys) {
            if (!Array.isArray(object.pubkeys))
                throw TypeError(".MultisigRedeemScriptType.pubkeys: array expected");
            message.pubkeys = [];
            for (var i = 0; i < object.pubkeys.length; ++i) {
                if (typeof object.pubkeys[i] !== "object")
                    throw TypeError(".MultisigRedeemScriptType.pubkeys: object expected");
                message.pubkeys[i] = $root.MultisigRedeemScriptType.HDNodePathType.fromObject(object.pubkeys[i]);
            }
        }
        if (object.signatures) {
            if (!Array.isArray(object.signatures))
                throw TypeError(".MultisigRedeemScriptType.signatures: array expected");
            message.signatures = [];
            for (var i = 0; i < object.signatures.length; ++i)
                if (typeof object.signatures[i] === "string")
                    $util.base64.decode(object.signatures[i], message.signatures[i] = $util.newBuffer($util.base64.length(object.signatures[i])), 0);
                else if (object.signatures[i].length)
                    message.signatures[i] = object.signatures[i];
        }
        if (object.m != null)
            message.m = object.m >>> 0;
        if (object.nodes) {
            if (!Array.isArray(object.nodes))
                throw TypeError(".MultisigRedeemScriptType.nodes: array expected");
            message.nodes = [];
            for (var i = 0; i < object.nodes.length; ++i) {
                if (typeof object.nodes[i] !== "object")
                    throw TypeError(".MultisigRedeemScriptType.nodes: object expected");
                message.nodes[i] = $root.HDNodeType.fromObject(object.nodes[i]);
            }
        }
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".MultisigRedeemScriptType.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        return message;
    };

    MultisigRedeemScriptType.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults) {
            object.pubkeys = [];
            object.signatures = [];
            object.nodes = [];
            object.address_n = [];
        }
        if (options.defaults)
            object.m = 0;
        if (message.pubkeys && message.pubkeys.length) {
            object.pubkeys = [];
            for (var j = 0; j < message.pubkeys.length; ++j)
                object.pubkeys[j] = $root.MultisigRedeemScriptType.HDNodePathType.toObject(message.pubkeys[j], options);
        }
        if (message.signatures && message.signatures.length) {
            object.signatures = [];
            for (var j = 0; j < message.signatures.length; ++j)
                object.signatures[j] = options.bytes === String ? $util.base64.encode(message.signatures[j], 0, message.signatures[j].length) : options.bytes === Array ? Array.prototype.slice.call(message.signatures[j]) : message.signatures[j];
        }
        if (message.m != null && message.hasOwnProperty("m"))
            object.m = message.m;
        if (message.nodes && message.nodes.length) {
            object.nodes = [];
            for (var j = 0; j < message.nodes.length; ++j)
                object.nodes[j] = $root.HDNodeType.toObject(message.nodes[j], options);
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        return object;
    };

    MultisigRedeemScriptType.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    MultisigRedeemScriptType.HDNodePathType = (function() {

        function HDNodePathType(properties) {
            this.address_n = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        HDNodePathType.prototype.node = null;
        HDNodePathType.prototype.address_n = $util.emptyArray;

        HDNodePathType.create = function create(properties) {
            return new HDNodePathType(properties);
        };

        HDNodePathType.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            $root.HDNodeType.encode(message.node, writer.uint32(10).fork()).ldelim();
            if (message.address_n != null && message.address_n.length)
                for (var i = 0; i < message.address_n.length; ++i)
                    writer.uint32(16).uint32(message.address_n[i]);
            return writer;
        };

        HDNodePathType.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        HDNodePathType.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MultisigRedeemScriptType.HDNodePathType();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.node = $root.HDNodeType.decode(reader, reader.uint32());
                    break;
                case 2:
                    if (!(message.address_n && message.address_n.length))
                        message.address_n = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.address_n.push(reader.uint32());
                    } else
                        message.address_n.push(reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("node"))
                throw $util.ProtocolError("missing required 'node'", { instance: message });
            return message;
        };

        HDNodePathType.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        HDNodePathType.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            {
                var error = $root.HDNodeType.verify(message.node);
                if (error)
                    return "node." + error;
            }
            if (message.address_n != null && message.hasOwnProperty("address_n")) {
                if (!Array.isArray(message.address_n))
                    return "address_n: array expected";
                for (var i = 0; i < message.address_n.length; ++i)
                    if (!$util.isInteger(message.address_n[i]))
                        return "address_n: integer[] expected";
            }
            return null;
        };

        HDNodePathType.fromObject = function fromObject(object) {
            if (object instanceof $root.MultisigRedeemScriptType.HDNodePathType)
                return object;
            var message = new $root.MultisigRedeemScriptType.HDNodePathType();
            if (object.node != null) {
                if (typeof object.node !== "object")
                    throw TypeError(".MultisigRedeemScriptType.HDNodePathType.node: object expected");
                message.node = $root.HDNodeType.fromObject(object.node);
            }
            if (object.address_n) {
                if (!Array.isArray(object.address_n))
                    throw TypeError(".MultisigRedeemScriptType.HDNodePathType.address_n: array expected");
                message.address_n = [];
                for (var i = 0; i < object.address_n.length; ++i)
                    message.address_n[i] = object.address_n[i] >>> 0;
            }
            return message;
        };

        HDNodePathType.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.address_n = [];
            if (options.defaults)
                object.node = null;
            if (message.node != null && message.hasOwnProperty("node"))
                object.node = $root.HDNodeType.toObject(message.node, options);
            if (message.address_n && message.address_n.length) {
                object.address_n = [];
                for (var j = 0; j < message.address_n.length; ++j)
                    object.address_n[j] = message.address_n[j];
            }
            return object;
        };

        HDNodePathType.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return HDNodePathType;
    })();

    return MultisigRedeemScriptType;
})();

$root.GetPublicKey = (function() {

    function GetPublicKey(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    GetPublicKey.prototype.address_n = $util.emptyArray;
    GetPublicKey.prototype.ecdsa_curve_name = "";
    GetPublicKey.prototype.show_display = false;
    GetPublicKey.prototype.coin_name = "Bitcoin";
    GetPublicKey.prototype.script_type = 0;
    GetPublicKey.prototype.ignore_xpub_magic = false;

    GetPublicKey.create = function create(properties) {
        return new GetPublicKey(properties);
    };

    GetPublicKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.ecdsa_curve_name != null && Object.hasOwnProperty.call(message, "ecdsa_curve_name"))
            writer.uint32(18).string(message.ecdsa_curve_name);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(24).bool(message.show_display);
        if (message.coin_name != null && Object.hasOwnProperty.call(message, "coin_name"))
            writer.uint32(34).string(message.coin_name);
        if (message.script_type != null && Object.hasOwnProperty.call(message, "script_type"))
            writer.uint32(40).int32(message.script_type);
        if (message.ignore_xpub_magic != null && Object.hasOwnProperty.call(message, "ignore_xpub_magic"))
            writer.uint32(48).bool(message.ignore_xpub_magic);
        return writer;
    };

    GetPublicKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    GetPublicKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.GetPublicKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.ecdsa_curve_name = reader.string();
                break;
            case 3:
                message.show_display = reader.bool();
                break;
            case 4:
                message.coin_name = reader.string();
                break;
            case 5:
                message.script_type = reader.int32();
                break;
            case 6:
                message.ignore_xpub_magic = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    GetPublicKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    GetPublicKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.ecdsa_curve_name != null && message.hasOwnProperty("ecdsa_curve_name"))
            if (!$util.isString(message.ecdsa_curve_name))
                return "ecdsa_curve_name: string expected";
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        if (message.coin_name != null && message.hasOwnProperty("coin_name"))
            if (!$util.isString(message.coin_name))
                return "coin_name: string expected";
        if (message.script_type != null && message.hasOwnProperty("script_type"))
            switch (message.script_type) {
            default:
                return "script_type: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
                break;
            }
        if (message.ignore_xpub_magic != null && message.hasOwnProperty("ignore_xpub_magic"))
            if (typeof message.ignore_xpub_magic !== "boolean")
                return "ignore_xpub_magic: boolean expected";
        return null;
    };

    GetPublicKey.fromObject = function fromObject(object) {
        if (object instanceof $root.GetPublicKey)
            return object;
        var message = new $root.GetPublicKey();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".GetPublicKey.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.ecdsa_curve_name != null)
            message.ecdsa_curve_name = String(object.ecdsa_curve_name);
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        if (object.coin_name != null)
            message.coin_name = String(object.coin_name);
        switch (object.script_type) {
        case "SPENDADDRESS":
        case 0:
            message.script_type = 0;
            break;
        case "SPENDMULTISIG":
        case 1:
            message.script_type = 1;
            break;
        case "EXTERNAL":
        case 2:
            message.script_type = 2;
            break;
        case "SPENDWITNESS":
        case 3:
            message.script_type = 3;
            break;
        case "SPENDP2SHWITNESS":
        case 4:
            message.script_type = 4;
            break;
        case "SPENDTAPROOT":
        case 5:
            message.script_type = 5;
            break;
        }
        if (object.ignore_xpub_magic != null)
            message.ignore_xpub_magic = Boolean(object.ignore_xpub_magic);
        return message;
    };

    GetPublicKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            object.ecdsa_curve_name = "";
            object.show_display = false;
            object.coin_name = "Bitcoin";
            object.script_type = options.enums === String ? "SPENDADDRESS" : 0;
            object.ignore_xpub_magic = false;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.ecdsa_curve_name != null && message.hasOwnProperty("ecdsa_curve_name"))
            object.ecdsa_curve_name = message.ecdsa_curve_name;
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        if (message.coin_name != null && message.hasOwnProperty("coin_name"))
            object.coin_name = message.coin_name;
        if (message.script_type != null && message.hasOwnProperty("script_type"))
            object.script_type = options.enums === String ? $root.InputScriptType[message.script_type] : message.script_type;
        if (message.ignore_xpub_magic != null && message.hasOwnProperty("ignore_xpub_magic"))
            object.ignore_xpub_magic = message.ignore_xpub_magic;
        return object;
    };

    GetPublicKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return GetPublicKey;
})();

$root.PublicKey = (function() {

    function PublicKey(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    PublicKey.prototype.node = null;
    PublicKey.prototype.xpub = "";
    PublicKey.prototype.root_fingerprint = 0;

    PublicKey.create = function create(properties) {
        return new PublicKey(properties);
    };

    PublicKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        $root.HDNodeType.encode(message.node, writer.uint32(10).fork()).ldelim();
        writer.uint32(18).string(message.xpub);
        if (message.root_fingerprint != null && Object.hasOwnProperty.call(message, "root_fingerprint"))
            writer.uint32(24).uint32(message.root_fingerprint);
        return writer;
    };

    PublicKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    PublicKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.PublicKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.node = $root.HDNodeType.decode(reader, reader.uint32());
                break;
            case 2:
                message.xpub = reader.string();
                break;
            case 3:
                message.root_fingerprint = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("node"))
            throw $util.ProtocolError("missing required 'node'", { instance: message });
        if (!message.hasOwnProperty("xpub"))
            throw $util.ProtocolError("missing required 'xpub'", { instance: message });
        return message;
    };

    PublicKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    PublicKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        {
            var error = $root.HDNodeType.verify(message.node);
            if (error)
                return "node." + error;
        }
        if (!$util.isString(message.xpub))
            return "xpub: string expected";
        if (message.root_fingerprint != null && message.hasOwnProperty("root_fingerprint"))
            if (!$util.isInteger(message.root_fingerprint))
                return "root_fingerprint: integer expected";
        return null;
    };

    PublicKey.fromObject = function fromObject(object) {
        if (object instanceof $root.PublicKey)
            return object;
        var message = new $root.PublicKey();
        if (object.node != null) {
            if (typeof object.node !== "object")
                throw TypeError(".PublicKey.node: object expected");
            message.node = $root.HDNodeType.fromObject(object.node);
        }
        if (object.xpub != null)
            message.xpub = String(object.xpub);
        if (object.root_fingerprint != null)
            message.root_fingerprint = object.root_fingerprint >>> 0;
        return message;
    };

    PublicKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.node = null;
            object.xpub = "";
            object.root_fingerprint = 0;
        }
        if (message.node != null && message.hasOwnProperty("node"))
            object.node = $root.HDNodeType.toObject(message.node, options);
        if (message.xpub != null && message.hasOwnProperty("xpub"))
            object.xpub = message.xpub;
        if (message.root_fingerprint != null && message.hasOwnProperty("root_fingerprint"))
            object.root_fingerprint = message.root_fingerprint;
        return object;
    };

    PublicKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return PublicKey;
})();

$root.GetAddress = (function() {

    function GetAddress(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    GetAddress.prototype.address_n = $util.emptyArray;
    GetAddress.prototype.coin_name = "Bitcoin";
    GetAddress.prototype.show_display = false;
    GetAddress.prototype.multisig = null;
    GetAddress.prototype.script_type = 0;
    GetAddress.prototype.ignore_xpub_magic = false;

    GetAddress.create = function create(properties) {
        return new GetAddress(properties);
    };

    GetAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.coin_name != null && Object.hasOwnProperty.call(message, "coin_name"))
            writer.uint32(18).string(message.coin_name);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(24).bool(message.show_display);
        if (message.multisig != null && Object.hasOwnProperty.call(message, "multisig"))
            $root.MultisigRedeemScriptType.encode(message.multisig, writer.uint32(34).fork()).ldelim();
        if (message.script_type != null && Object.hasOwnProperty.call(message, "script_type"))
            writer.uint32(40).int32(message.script_type);
        if (message.ignore_xpub_magic != null && Object.hasOwnProperty.call(message, "ignore_xpub_magic"))
            writer.uint32(48).bool(message.ignore_xpub_magic);
        return writer;
    };

    GetAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    GetAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.GetAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.coin_name = reader.string();
                break;
            case 3:
                message.show_display = reader.bool();
                break;
            case 4:
                message.multisig = $root.MultisigRedeemScriptType.decode(reader, reader.uint32());
                break;
            case 5:
                message.script_type = reader.int32();
                break;
            case 6:
                message.ignore_xpub_magic = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    GetAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    GetAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.coin_name != null && message.hasOwnProperty("coin_name"))
            if (!$util.isString(message.coin_name))
                return "coin_name: string expected";
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        if (message.multisig != null && message.hasOwnProperty("multisig")) {
            var error = $root.MultisigRedeemScriptType.verify(message.multisig);
            if (error)
                return "multisig." + error;
        }
        if (message.script_type != null && message.hasOwnProperty("script_type"))
            switch (message.script_type) {
            default:
                return "script_type: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
                break;
            }
        if (message.ignore_xpub_magic != null && message.hasOwnProperty("ignore_xpub_magic"))
            if (typeof message.ignore_xpub_magic !== "boolean")
                return "ignore_xpub_magic: boolean expected";
        return null;
    };

    GetAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.GetAddress)
            return object;
        var message = new $root.GetAddress();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".GetAddress.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.coin_name != null)
            message.coin_name = String(object.coin_name);
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        if (object.multisig != null) {
            if (typeof object.multisig !== "object")
                throw TypeError(".GetAddress.multisig: object expected");
            message.multisig = $root.MultisigRedeemScriptType.fromObject(object.multisig);
        }
        switch (object.script_type) {
        case "SPENDADDRESS":
        case 0:
            message.script_type = 0;
            break;
        case "SPENDMULTISIG":
        case 1:
            message.script_type = 1;
            break;
        case "EXTERNAL":
        case 2:
            message.script_type = 2;
            break;
        case "SPENDWITNESS":
        case 3:
            message.script_type = 3;
            break;
        case "SPENDP2SHWITNESS":
        case 4:
            message.script_type = 4;
            break;
        case "SPENDTAPROOT":
        case 5:
            message.script_type = 5;
            break;
        }
        if (object.ignore_xpub_magic != null)
            message.ignore_xpub_magic = Boolean(object.ignore_xpub_magic);
        return message;
    };

    GetAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            object.coin_name = "Bitcoin";
            object.show_display = false;
            object.multisig = null;
            object.script_type = options.enums === String ? "SPENDADDRESS" : 0;
            object.ignore_xpub_magic = false;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.coin_name != null && message.hasOwnProperty("coin_name"))
            object.coin_name = message.coin_name;
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        if (message.multisig != null && message.hasOwnProperty("multisig"))
            object.multisig = $root.MultisigRedeemScriptType.toObject(message.multisig, options);
        if (message.script_type != null && message.hasOwnProperty("script_type"))
            object.script_type = options.enums === String ? $root.InputScriptType[message.script_type] : message.script_type;
        if (message.ignore_xpub_magic != null && message.hasOwnProperty("ignore_xpub_magic"))
            object.ignore_xpub_magic = message.ignore_xpub_magic;
        return object;
    };

    GetAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return GetAddress;
})();

$root.Address = (function() {

    function Address(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    Address.prototype.address = "";

    Address.create = function create(properties) {
        return new Address(properties);
    };

    Address.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.address);
        return writer;
    };

    Address.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    Address.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Address();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("address"))
            throw $util.ProtocolError("missing required 'address'", { instance: message });
        return message;
    };

    Address.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    Address.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.address))
            return "address: string expected";
        return null;
    };

    Address.fromObject = function fromObject(object) {
        if (object instanceof $root.Address)
            return object;
        var message = new $root.Address();
        if (object.address != null)
            message.address = String(object.address);
        return message;
    };

    Address.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.address = "";
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    Address.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return Address;
})();

$root.GetOwnershipId = (function() {

    function GetOwnershipId(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    GetOwnershipId.prototype.address_n = $util.emptyArray;
    GetOwnershipId.prototype.coin_name = "Bitcoin";
    GetOwnershipId.prototype.multisig = null;
    GetOwnershipId.prototype.script_type = 0;

    GetOwnershipId.create = function create(properties) {
        return new GetOwnershipId(properties);
    };

    GetOwnershipId.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.coin_name != null && Object.hasOwnProperty.call(message, "coin_name"))
            writer.uint32(18).string(message.coin_name);
        if (message.multisig != null && Object.hasOwnProperty.call(message, "multisig"))
            $root.MultisigRedeemScriptType.encode(message.multisig, writer.uint32(26).fork()).ldelim();
        if (message.script_type != null && Object.hasOwnProperty.call(message, "script_type"))
            writer.uint32(32).int32(message.script_type);
        return writer;
    };

    GetOwnershipId.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    GetOwnershipId.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.GetOwnershipId();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.coin_name = reader.string();
                break;
            case 3:
                message.multisig = $root.MultisigRedeemScriptType.decode(reader, reader.uint32());
                break;
            case 4:
                message.script_type = reader.int32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    GetOwnershipId.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    GetOwnershipId.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.coin_name != null && message.hasOwnProperty("coin_name"))
            if (!$util.isString(message.coin_name))
                return "coin_name: string expected";
        if (message.multisig != null && message.hasOwnProperty("multisig")) {
            var error = $root.MultisigRedeemScriptType.verify(message.multisig);
            if (error)
                return "multisig." + error;
        }
        if (message.script_type != null && message.hasOwnProperty("script_type"))
            switch (message.script_type) {
            default:
                return "script_type: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
                break;
            }
        return null;
    };

    GetOwnershipId.fromObject = function fromObject(object) {
        if (object instanceof $root.GetOwnershipId)
            return object;
        var message = new $root.GetOwnershipId();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".GetOwnershipId.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.coin_name != null)
            message.coin_name = String(object.coin_name);
        if (object.multisig != null) {
            if (typeof object.multisig !== "object")
                throw TypeError(".GetOwnershipId.multisig: object expected");
            message.multisig = $root.MultisigRedeemScriptType.fromObject(object.multisig);
        }
        switch (object.script_type) {
        case "SPENDADDRESS":
        case 0:
            message.script_type = 0;
            break;
        case "SPENDMULTISIG":
        case 1:
            message.script_type = 1;
            break;
        case "EXTERNAL":
        case 2:
            message.script_type = 2;
            break;
        case "SPENDWITNESS":
        case 3:
            message.script_type = 3;
            break;
        case "SPENDP2SHWITNESS":
        case 4:
            message.script_type = 4;
            break;
        case "SPENDTAPROOT":
        case 5:
            message.script_type = 5;
            break;
        }
        return message;
    };

    GetOwnershipId.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            object.coin_name = "Bitcoin";
            object.multisig = null;
            object.script_type = options.enums === String ? "SPENDADDRESS" : 0;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.coin_name != null && message.hasOwnProperty("coin_name"))
            object.coin_name = message.coin_name;
        if (message.multisig != null && message.hasOwnProperty("multisig"))
            object.multisig = $root.MultisigRedeemScriptType.toObject(message.multisig, options);
        if (message.script_type != null && message.hasOwnProperty("script_type"))
            object.script_type = options.enums === String ? $root.InputScriptType[message.script_type] : message.script_type;
        return object;
    };

    GetOwnershipId.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return GetOwnershipId;
})();

$root.OwnershipId = (function() {

    function OwnershipId(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    OwnershipId.prototype.ownership_id = $util.newBuffer([]);

    OwnershipId.create = function create(properties) {
        return new OwnershipId(properties);
    };

    OwnershipId.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.ownership_id);
        return writer;
    };

    OwnershipId.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    OwnershipId.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.OwnershipId();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.ownership_id = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("ownership_id"))
            throw $util.ProtocolError("missing required 'ownership_id'", { instance: message });
        return message;
    };

    OwnershipId.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    OwnershipId.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.ownership_id && typeof message.ownership_id.length === "number" || $util.isString(message.ownership_id)))
            return "ownership_id: buffer expected";
        return null;
    };

    OwnershipId.fromObject = function fromObject(object) {
        if (object instanceof $root.OwnershipId)
            return object;
        var message = new $root.OwnershipId();
        if (object.ownership_id != null)
            if (typeof object.ownership_id === "string")
                $util.base64.decode(object.ownership_id, message.ownership_id = $util.newBuffer($util.base64.length(object.ownership_id)), 0);
            else if (object.ownership_id.length)
                message.ownership_id = object.ownership_id;
        return message;
    };

    OwnershipId.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.ownership_id = "";
            else {
                object.ownership_id = [];
                if (options.bytes !== Array)
                    object.ownership_id = $util.newBuffer(object.ownership_id);
            }
        if (message.ownership_id != null && message.hasOwnProperty("ownership_id"))
            object.ownership_id = options.bytes === String ? $util.base64.encode(message.ownership_id, 0, message.ownership_id.length) : options.bytes === Array ? Array.prototype.slice.call(message.ownership_id) : message.ownership_id;
        return object;
    };

    OwnershipId.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return OwnershipId;
})();

$root.SignMessage = (function() {

    function SignMessage(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    SignMessage.prototype.address_n = $util.emptyArray;
    SignMessage.prototype.message = $util.newBuffer([]);
    SignMessage.prototype.coin_name = "Bitcoin";
    SignMessage.prototype.script_type = 0;
    SignMessage.prototype.no_script_type = false;
    SignMessage.prototype.is_bip322_simple = false;

    SignMessage.create = function create(properties) {
        return new SignMessage(properties);
    };

    SignMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).bytes(message.message);
        if (message.coin_name != null && Object.hasOwnProperty.call(message, "coin_name"))
            writer.uint32(26).string(message.coin_name);
        if (message.script_type != null && Object.hasOwnProperty.call(message, "script_type"))
            writer.uint32(32).int32(message.script_type);
        if (message.no_script_type != null && Object.hasOwnProperty.call(message, "no_script_type"))
            writer.uint32(40).bool(message.no_script_type);
        if (message.is_bip322_simple != null && Object.hasOwnProperty.call(message, "is_bip322_simple"))
            writer.uint32(80).bool(message.is_bip322_simple);
        return writer;
    };

    SignMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    SignMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SignMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.message = reader.bytes();
                break;
            case 3:
                message.coin_name = reader.string();
                break;
            case 4:
                message.script_type = reader.int32();
                break;
            case 5:
                message.no_script_type = reader.bool();
                break;
            case 10:
                message.is_bip322_simple = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("message"))
            throw $util.ProtocolError("missing required 'message'", { instance: message });
        return message;
    };

    SignMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    SignMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!(message.message && typeof message.message.length === "number" || $util.isString(message.message)))
            return "message: buffer expected";
        if (message.coin_name != null && message.hasOwnProperty("coin_name"))
            if (!$util.isString(message.coin_name))
                return "coin_name: string expected";
        if (message.script_type != null && message.hasOwnProperty("script_type"))
            switch (message.script_type) {
            default:
                return "script_type: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
                break;
            }
        if (message.no_script_type != null && message.hasOwnProperty("no_script_type"))
            if (typeof message.no_script_type !== "boolean")
                return "no_script_type: boolean expected";
        if (message.is_bip322_simple != null && message.hasOwnProperty("is_bip322_simple"))
            if (typeof message.is_bip322_simple !== "boolean")
                return "is_bip322_simple: boolean expected";
        return null;
    };

    SignMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.SignMessage)
            return object;
        var message = new $root.SignMessage();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".SignMessage.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.message != null)
            if (typeof object.message === "string")
                $util.base64.decode(object.message, message.message = $util.newBuffer($util.base64.length(object.message)), 0);
            else if (object.message.length)
                message.message = object.message;
        if (object.coin_name != null)
            message.coin_name = String(object.coin_name);
        switch (object.script_type) {
        case "SPENDADDRESS":
        case 0:
            message.script_type = 0;
            break;
        case "SPENDMULTISIG":
        case 1:
            message.script_type = 1;
            break;
        case "EXTERNAL":
        case 2:
            message.script_type = 2;
            break;
        case "SPENDWITNESS":
        case 3:
            message.script_type = 3;
            break;
        case "SPENDP2SHWITNESS":
        case 4:
            message.script_type = 4;
            break;
        case "SPENDTAPROOT":
        case 5:
            message.script_type = 5;
            break;
        }
        if (object.no_script_type != null)
            message.no_script_type = Boolean(object.no_script_type);
        if (object.is_bip322_simple != null)
            message.is_bip322_simple = Boolean(object.is_bip322_simple);
        return message;
    };

    SignMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            if (options.bytes === String)
                object.message = "";
            else {
                object.message = [];
                if (options.bytes !== Array)
                    object.message = $util.newBuffer(object.message);
            }
            object.coin_name = "Bitcoin";
            object.script_type = options.enums === String ? "SPENDADDRESS" : 0;
            object.no_script_type = false;
            object.is_bip322_simple = false;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.message != null && message.hasOwnProperty("message"))
            object.message = options.bytes === String ? $util.base64.encode(message.message, 0, message.message.length) : options.bytes === Array ? Array.prototype.slice.call(message.message) : message.message;
        if (message.coin_name != null && message.hasOwnProperty("coin_name"))
            object.coin_name = message.coin_name;
        if (message.script_type != null && message.hasOwnProperty("script_type"))
            object.script_type = options.enums === String ? $root.InputScriptType[message.script_type] : message.script_type;
        if (message.no_script_type != null && message.hasOwnProperty("no_script_type"))
            object.no_script_type = message.no_script_type;
        if (message.is_bip322_simple != null && message.hasOwnProperty("is_bip322_simple"))
            object.is_bip322_simple = message.is_bip322_simple;
        return object;
    };

    SignMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SignMessage;
})();

$root.MessageSignature = (function() {

    function MessageSignature(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MessageSignature.prototype.address = "";
    MessageSignature.prototype.signature = $util.newBuffer([]);

    MessageSignature.create = function create(properties) {
        return new MessageSignature(properties);
    };

    MessageSignature.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.address);
        writer.uint32(18).bytes(message.signature);
        return writer;
    };

    MessageSignature.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MessageSignature.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MessageSignature();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.string();
                break;
            case 2:
                message.signature = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("address"))
            throw $util.ProtocolError("missing required 'address'", { instance: message });
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        return message;
    };

    MessageSignature.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MessageSignature.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.address))
            return "address: string expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        return null;
    };

    MessageSignature.fromObject = function fromObject(object) {
        if (object instanceof $root.MessageSignature)
            return object;
        var message = new $root.MessageSignature();
        if (object.address != null)
            message.address = String(object.address);
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        return message;
    };

    MessageSignature.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.address = "";
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
        }
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        return object;
    };

    MessageSignature.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MessageSignature;
})();

$root.VerifyMessage = (function() {

    function VerifyMessage(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    VerifyMessage.prototype.address = "";
    VerifyMessage.prototype.signature = $util.newBuffer([]);
    VerifyMessage.prototype.message = $util.newBuffer([]);
    VerifyMessage.prototype.coin_name = "Bitcoin";

    VerifyMessage.create = function create(properties) {
        return new VerifyMessage(properties);
    };

    VerifyMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.address);
        writer.uint32(18).bytes(message.signature);
        writer.uint32(26).bytes(message.message);
        if (message.coin_name != null && Object.hasOwnProperty.call(message, "coin_name"))
            writer.uint32(34).string(message.coin_name);
        return writer;
    };

    VerifyMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    VerifyMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.VerifyMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.string();
                break;
            case 2:
                message.signature = reader.bytes();
                break;
            case 3:
                message.message = reader.bytes();
                break;
            case 4:
                message.coin_name = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("address"))
            throw $util.ProtocolError("missing required 'address'", { instance: message });
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        if (!message.hasOwnProperty("message"))
            throw $util.ProtocolError("missing required 'message'", { instance: message });
        return message;
    };

    VerifyMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    VerifyMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.address))
            return "address: string expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        if (!(message.message && typeof message.message.length === "number" || $util.isString(message.message)))
            return "message: buffer expected";
        if (message.coin_name != null && message.hasOwnProperty("coin_name"))
            if (!$util.isString(message.coin_name))
                return "coin_name: string expected";
        return null;
    };

    VerifyMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.VerifyMessage)
            return object;
        var message = new $root.VerifyMessage();
        if (object.address != null)
            message.address = String(object.address);
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        if (object.message != null)
            if (typeof object.message === "string")
                $util.base64.decode(object.message, message.message = $util.newBuffer($util.base64.length(object.message)), 0);
            else if (object.message.length)
                message.message = object.message;
        if (object.coin_name != null)
            message.coin_name = String(object.coin_name);
        return message;
    };

    VerifyMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.address = "";
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
            if (options.bytes === String)
                object.message = "";
            else {
                object.message = [];
                if (options.bytes !== Array)
                    object.message = $util.newBuffer(object.message);
            }
            object.coin_name = "Bitcoin";
        }
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        if (message.message != null && message.hasOwnProperty("message"))
            object.message = options.bytes === String ? $util.base64.encode(message.message, 0, message.message.length) : options.bytes === Array ? Array.prototype.slice.call(message.message) : message.message;
        if (message.coin_name != null && message.hasOwnProperty("coin_name"))
            object.coin_name = message.coin_name;
        return object;
    };

    VerifyMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return VerifyMessage;
})();

$root.SignTx = (function() {

    function SignTx(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    SignTx.prototype.outputs_count = 0;
    SignTx.prototype.inputs_count = 0;
    SignTx.prototype.coin_name = "Bitcoin";
    SignTx.prototype.version = 1;
    SignTx.prototype.lock_time = 0;
    SignTx.prototype.expiry = 0;
    SignTx.prototype.overwintered = false;
    SignTx.prototype.version_group_id = 0;
    SignTx.prototype.timestamp = 0;
    SignTx.prototype.branch_id = 0;
    SignTx.prototype.amount_unit = 0;
    SignTx.prototype.decred_staking_ticket = false;

    SignTx.create = function create(properties) {
        return new SignTx(properties);
    };

    SignTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).uint32(message.outputs_count);
        writer.uint32(16).uint32(message.inputs_count);
        if (message.coin_name != null && Object.hasOwnProperty.call(message, "coin_name"))
            writer.uint32(26).string(message.coin_name);
        if (message.version != null && Object.hasOwnProperty.call(message, "version"))
            writer.uint32(32).uint32(message.version);
        if (message.lock_time != null && Object.hasOwnProperty.call(message, "lock_time"))
            writer.uint32(40).uint32(message.lock_time);
        if (message.expiry != null && Object.hasOwnProperty.call(message, "expiry"))
            writer.uint32(48).uint32(message.expiry);
        if (message.overwintered != null && Object.hasOwnProperty.call(message, "overwintered"))
            writer.uint32(56).bool(message.overwintered);
        if (message.version_group_id != null && Object.hasOwnProperty.call(message, "version_group_id"))
            writer.uint32(64).uint32(message.version_group_id);
        if (message.timestamp != null && Object.hasOwnProperty.call(message, "timestamp"))
            writer.uint32(72).uint32(message.timestamp);
        if (message.branch_id != null && Object.hasOwnProperty.call(message, "branch_id"))
            writer.uint32(80).uint32(message.branch_id);
        if (message.amount_unit != null && Object.hasOwnProperty.call(message, "amount_unit"))
            writer.uint32(88).int32(message.amount_unit);
        if (message.decred_staking_ticket != null && Object.hasOwnProperty.call(message, "decred_staking_ticket"))
            writer.uint32(96).bool(message.decred_staking_ticket);
        return writer;
    };

    SignTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    SignTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SignTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.outputs_count = reader.uint32();
                break;
            case 2:
                message.inputs_count = reader.uint32();
                break;
            case 3:
                message.coin_name = reader.string();
                break;
            case 4:
                message.version = reader.uint32();
                break;
            case 5:
                message.lock_time = reader.uint32();
                break;
            case 6:
                message.expiry = reader.uint32();
                break;
            case 7:
                message.overwintered = reader.bool();
                break;
            case 8:
                message.version_group_id = reader.uint32();
                break;
            case 9:
                message.timestamp = reader.uint32();
                break;
            case 10:
                message.branch_id = reader.uint32();
                break;
            case 11:
                message.amount_unit = reader.int32();
                break;
            case 12:
                message.decred_staking_ticket = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("outputs_count"))
            throw $util.ProtocolError("missing required 'outputs_count'", { instance: message });
        if (!message.hasOwnProperty("inputs_count"))
            throw $util.ProtocolError("missing required 'inputs_count'", { instance: message });
        return message;
    };

    SignTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    SignTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isInteger(message.outputs_count))
            return "outputs_count: integer expected";
        if (!$util.isInteger(message.inputs_count))
            return "inputs_count: integer expected";
        if (message.coin_name != null && message.hasOwnProperty("coin_name"))
            if (!$util.isString(message.coin_name))
                return "coin_name: string expected";
        if (message.version != null && message.hasOwnProperty("version"))
            if (!$util.isInteger(message.version))
                return "version: integer expected";
        if (message.lock_time != null && message.hasOwnProperty("lock_time"))
            if (!$util.isInteger(message.lock_time))
                return "lock_time: integer expected";
        if (message.expiry != null && message.hasOwnProperty("expiry"))
            if (!$util.isInteger(message.expiry))
                return "expiry: integer expected";
        if (message.overwintered != null && message.hasOwnProperty("overwintered"))
            if (typeof message.overwintered !== "boolean")
                return "overwintered: boolean expected";
        if (message.version_group_id != null && message.hasOwnProperty("version_group_id"))
            if (!$util.isInteger(message.version_group_id))
                return "version_group_id: integer expected";
        if (message.timestamp != null && message.hasOwnProperty("timestamp"))
            if (!$util.isInteger(message.timestamp))
                return "timestamp: integer expected";
        if (message.branch_id != null && message.hasOwnProperty("branch_id"))
            if (!$util.isInteger(message.branch_id))
                return "branch_id: integer expected";
        if (message.amount_unit != null && message.hasOwnProperty("amount_unit"))
            switch (message.amount_unit) {
            default:
                return "amount_unit: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
                break;
            }
        if (message.decred_staking_ticket != null && message.hasOwnProperty("decred_staking_ticket"))
            if (typeof message.decred_staking_ticket !== "boolean")
                return "decred_staking_ticket: boolean expected";
        return null;
    };

    SignTx.fromObject = function fromObject(object) {
        if (object instanceof $root.SignTx)
            return object;
        var message = new $root.SignTx();
        if (object.outputs_count != null)
            message.outputs_count = object.outputs_count >>> 0;
        if (object.inputs_count != null)
            message.inputs_count = object.inputs_count >>> 0;
        if (object.coin_name != null)
            message.coin_name = String(object.coin_name);
        if (object.version != null)
            message.version = object.version >>> 0;
        if (object.lock_time != null)
            message.lock_time = object.lock_time >>> 0;
        if (object.expiry != null)
            message.expiry = object.expiry >>> 0;
        if (object.overwintered != null)
            message.overwintered = Boolean(object.overwintered);
        if (object.version_group_id != null)
            message.version_group_id = object.version_group_id >>> 0;
        if (object.timestamp != null)
            message.timestamp = object.timestamp >>> 0;
        if (object.branch_id != null)
            message.branch_id = object.branch_id >>> 0;
        switch (object.amount_unit) {
        case "BITCOIN":
        case 0:
            message.amount_unit = 0;
            break;
        case "MILLIBITCOIN":
        case 1:
            message.amount_unit = 1;
            break;
        case "MICROBITCOIN":
        case 2:
            message.amount_unit = 2;
            break;
        case "SATOSHI":
        case 3:
            message.amount_unit = 3;
            break;
        }
        if (object.decred_staking_ticket != null)
            message.decred_staking_ticket = Boolean(object.decred_staking_ticket);
        return message;
    };

    SignTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.outputs_count = 0;
            object.inputs_count = 0;
            object.coin_name = "Bitcoin";
            object.version = 1;
            object.lock_time = 0;
            object.expiry = 0;
            object.overwintered = false;
            object.version_group_id = 0;
            object.timestamp = 0;
            object.branch_id = 0;
            object.amount_unit = options.enums === String ? "BITCOIN" : 0;
            object.decred_staking_ticket = false;
        }
        if (message.outputs_count != null && message.hasOwnProperty("outputs_count"))
            object.outputs_count = message.outputs_count;
        if (message.inputs_count != null && message.hasOwnProperty("inputs_count"))
            object.inputs_count = message.inputs_count;
        if (message.coin_name != null && message.hasOwnProperty("coin_name"))
            object.coin_name = message.coin_name;
        if (message.version != null && message.hasOwnProperty("version"))
            object.version = message.version;
        if (message.lock_time != null && message.hasOwnProperty("lock_time"))
            object.lock_time = message.lock_time;
        if (message.expiry != null && message.hasOwnProperty("expiry"))
            object.expiry = message.expiry;
        if (message.overwintered != null && message.hasOwnProperty("overwintered"))
            object.overwintered = message.overwintered;
        if (message.version_group_id != null && message.hasOwnProperty("version_group_id"))
            object.version_group_id = message.version_group_id;
        if (message.timestamp != null && message.hasOwnProperty("timestamp"))
            object.timestamp = message.timestamp;
        if (message.branch_id != null && message.hasOwnProperty("branch_id"))
            object.branch_id = message.branch_id;
        if (message.amount_unit != null && message.hasOwnProperty("amount_unit"))
            object.amount_unit = options.enums === String ? $root.AmountUnit[message.amount_unit] : message.amount_unit;
        if (message.decred_staking_ticket != null && message.hasOwnProperty("decred_staking_ticket"))
            object.decred_staking_ticket = message.decred_staking_ticket;
        return object;
    };

    SignTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SignTx;
})();

$root.TxRequest = (function() {

    function TxRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    TxRequest.prototype.request_type = 0;
    TxRequest.prototype.details = null;
    TxRequest.prototype.serialized = null;

    TxRequest.create = function create(properties) {
        return new TxRequest(properties);
    };

    TxRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.request_type != null && Object.hasOwnProperty.call(message, "request_type"))
            writer.uint32(8).int32(message.request_type);
        if (message.details != null && Object.hasOwnProperty.call(message, "details"))
            $root.TxRequest.TxRequestDetailsType.encode(message.details, writer.uint32(18).fork()).ldelim();
        if (message.serialized != null && Object.hasOwnProperty.call(message, "serialized"))
            $root.TxRequest.TxRequestSerializedType.encode(message.serialized, writer.uint32(26).fork()).ldelim();
        return writer;
    };

    TxRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    TxRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TxRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.request_type = reader.int32();
                break;
            case 2:
                message.details = $root.TxRequest.TxRequestDetailsType.decode(reader, reader.uint32());
                break;
            case 3:
                message.serialized = $root.TxRequest.TxRequestSerializedType.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    TxRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    TxRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.request_type != null && message.hasOwnProperty("request_type"))
            switch (message.request_type) {
            default:
                return "request_type: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
                break;
            }
        if (message.details != null && message.hasOwnProperty("details")) {
            var error = $root.TxRequest.TxRequestDetailsType.verify(message.details);
            if (error)
                return "details." + error;
        }
        if (message.serialized != null && message.hasOwnProperty("serialized")) {
            var error = $root.TxRequest.TxRequestSerializedType.verify(message.serialized);
            if (error)
                return "serialized." + error;
        }
        return null;
    };

    TxRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.TxRequest)
            return object;
        var message = new $root.TxRequest();
        switch (object.request_type) {
        case "TXINPUT":
        case 0:
            message.request_type = 0;
            break;
        case "TXOUTPUT":
        case 1:
            message.request_type = 1;
            break;
        case "TXMETA":
        case 2:
            message.request_type = 2;
            break;
        case "TXFINISHED":
        case 3:
            message.request_type = 3;
            break;
        case "TXEXTRADATA":
        case 4:
            message.request_type = 4;
            break;
        case "TXORIGINPUT":
        case 5:
            message.request_type = 5;
            break;
        case "TXORIGOUTPUT":
        case 6:
            message.request_type = 6;
            break;
        }
        if (object.details != null) {
            if (typeof object.details !== "object")
                throw TypeError(".TxRequest.details: object expected");
            message.details = $root.TxRequest.TxRequestDetailsType.fromObject(object.details);
        }
        if (object.serialized != null) {
            if (typeof object.serialized !== "object")
                throw TypeError(".TxRequest.serialized: object expected");
            message.serialized = $root.TxRequest.TxRequestSerializedType.fromObject(object.serialized);
        }
        return message;
    };

    TxRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.request_type = options.enums === String ? "TXINPUT" : 0;
            object.details = null;
            object.serialized = null;
        }
        if (message.request_type != null && message.hasOwnProperty("request_type"))
            object.request_type = options.enums === String ? $root.TxRequest.RequestType[message.request_type] : message.request_type;
        if (message.details != null && message.hasOwnProperty("details"))
            object.details = $root.TxRequest.TxRequestDetailsType.toObject(message.details, options);
        if (message.serialized != null && message.hasOwnProperty("serialized"))
            object.serialized = $root.TxRequest.TxRequestSerializedType.toObject(message.serialized, options);
        return object;
    };

    TxRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    TxRequest.RequestType = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "TXINPUT"] = 0;
        values[valuesById[1] = "TXOUTPUT"] = 1;
        values[valuesById[2] = "TXMETA"] = 2;
        values[valuesById[3] = "TXFINISHED"] = 3;
        values[valuesById[4] = "TXEXTRADATA"] = 4;
        values[valuesById[5] = "TXORIGINPUT"] = 5;
        values[valuesById[6] = "TXORIGOUTPUT"] = 6;
        return values;
    })();

    TxRequest.TxRequestDetailsType = (function() {

        function TxRequestDetailsType(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        TxRequestDetailsType.prototype.request_index = 0;
        TxRequestDetailsType.prototype.tx_hash = $util.newBuffer([]);
        TxRequestDetailsType.prototype.extra_data_len = 0;
        TxRequestDetailsType.prototype.extra_data_offset = 0;

        TxRequestDetailsType.create = function create(properties) {
            return new TxRequestDetailsType(properties);
        };

        TxRequestDetailsType.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.request_index != null && Object.hasOwnProperty.call(message, "request_index"))
                writer.uint32(8).uint32(message.request_index);
            if (message.tx_hash != null && Object.hasOwnProperty.call(message, "tx_hash"))
                writer.uint32(18).bytes(message.tx_hash);
            if (message.extra_data_len != null && Object.hasOwnProperty.call(message, "extra_data_len"))
                writer.uint32(24).uint32(message.extra_data_len);
            if (message.extra_data_offset != null && Object.hasOwnProperty.call(message, "extra_data_offset"))
                writer.uint32(32).uint32(message.extra_data_offset);
            return writer;
        };

        TxRequestDetailsType.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        TxRequestDetailsType.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TxRequest.TxRequestDetailsType();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.request_index = reader.uint32();
                    break;
                case 2:
                    message.tx_hash = reader.bytes();
                    break;
                case 3:
                    message.extra_data_len = reader.uint32();
                    break;
                case 4:
                    message.extra_data_offset = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        TxRequestDetailsType.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        TxRequestDetailsType.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.request_index != null && message.hasOwnProperty("request_index"))
                if (!$util.isInteger(message.request_index))
                    return "request_index: integer expected";
            if (message.tx_hash != null && message.hasOwnProperty("tx_hash"))
                if (!(message.tx_hash && typeof message.tx_hash.length === "number" || $util.isString(message.tx_hash)))
                    return "tx_hash: buffer expected";
            if (message.extra_data_len != null && message.hasOwnProperty("extra_data_len"))
                if (!$util.isInteger(message.extra_data_len))
                    return "extra_data_len: integer expected";
            if (message.extra_data_offset != null && message.hasOwnProperty("extra_data_offset"))
                if (!$util.isInteger(message.extra_data_offset))
                    return "extra_data_offset: integer expected";
            return null;
        };

        TxRequestDetailsType.fromObject = function fromObject(object) {
            if (object instanceof $root.TxRequest.TxRequestDetailsType)
                return object;
            var message = new $root.TxRequest.TxRequestDetailsType();
            if (object.request_index != null)
                message.request_index = object.request_index >>> 0;
            if (object.tx_hash != null)
                if (typeof object.tx_hash === "string")
                    $util.base64.decode(object.tx_hash, message.tx_hash = $util.newBuffer($util.base64.length(object.tx_hash)), 0);
                else if (object.tx_hash.length)
                    message.tx_hash = object.tx_hash;
            if (object.extra_data_len != null)
                message.extra_data_len = object.extra_data_len >>> 0;
            if (object.extra_data_offset != null)
                message.extra_data_offset = object.extra_data_offset >>> 0;
            return message;
        };

        TxRequestDetailsType.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.request_index = 0;
                if (options.bytes === String)
                    object.tx_hash = "";
                else {
                    object.tx_hash = [];
                    if (options.bytes !== Array)
                        object.tx_hash = $util.newBuffer(object.tx_hash);
                }
                object.extra_data_len = 0;
                object.extra_data_offset = 0;
            }
            if (message.request_index != null && message.hasOwnProperty("request_index"))
                object.request_index = message.request_index;
            if (message.tx_hash != null && message.hasOwnProperty("tx_hash"))
                object.tx_hash = options.bytes === String ? $util.base64.encode(message.tx_hash, 0, message.tx_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.tx_hash) : message.tx_hash;
            if (message.extra_data_len != null && message.hasOwnProperty("extra_data_len"))
                object.extra_data_len = message.extra_data_len;
            if (message.extra_data_offset != null && message.hasOwnProperty("extra_data_offset"))
                object.extra_data_offset = message.extra_data_offset;
            return object;
        };

        TxRequestDetailsType.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TxRequestDetailsType;
    })();

    TxRequest.TxRequestSerializedType = (function() {

        function TxRequestSerializedType(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        TxRequestSerializedType.prototype.signature_index = 0;
        TxRequestSerializedType.prototype.signature = $util.newBuffer([]);
        TxRequestSerializedType.prototype.serialized_tx = $util.newBuffer([]);

        TxRequestSerializedType.create = function create(properties) {
            return new TxRequestSerializedType(properties);
        };

        TxRequestSerializedType.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.signature_index != null && Object.hasOwnProperty.call(message, "signature_index"))
                writer.uint32(8).uint32(message.signature_index);
            if (message.signature != null && Object.hasOwnProperty.call(message, "signature"))
                writer.uint32(18).bytes(message.signature);
            if (message.serialized_tx != null && Object.hasOwnProperty.call(message, "serialized_tx"))
                writer.uint32(26).bytes(message.serialized_tx);
            return writer;
        };

        TxRequestSerializedType.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        TxRequestSerializedType.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TxRequest.TxRequestSerializedType();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.signature_index = reader.uint32();
                    break;
                case 2:
                    message.signature = reader.bytes();
                    break;
                case 3:
                    message.serialized_tx = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        TxRequestSerializedType.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        TxRequestSerializedType.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.signature_index != null && message.hasOwnProperty("signature_index"))
                if (!$util.isInteger(message.signature_index))
                    return "signature_index: integer expected";
            if (message.signature != null && message.hasOwnProperty("signature"))
                if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
                    return "signature: buffer expected";
            if (message.serialized_tx != null && message.hasOwnProperty("serialized_tx"))
                if (!(message.serialized_tx && typeof message.serialized_tx.length === "number" || $util.isString(message.serialized_tx)))
                    return "serialized_tx: buffer expected";
            return null;
        };

        TxRequestSerializedType.fromObject = function fromObject(object) {
            if (object instanceof $root.TxRequest.TxRequestSerializedType)
                return object;
            var message = new $root.TxRequest.TxRequestSerializedType();
            if (object.signature_index != null)
                message.signature_index = object.signature_index >>> 0;
            if (object.signature != null)
                if (typeof object.signature === "string")
                    $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
                else if (object.signature.length)
                    message.signature = object.signature;
            if (object.serialized_tx != null)
                if (typeof object.serialized_tx === "string")
                    $util.base64.decode(object.serialized_tx, message.serialized_tx = $util.newBuffer($util.base64.length(object.serialized_tx)), 0);
                else if (object.serialized_tx.length)
                    message.serialized_tx = object.serialized_tx;
            return message;
        };

        TxRequestSerializedType.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.signature_index = 0;
                if (options.bytes === String)
                    object.signature = "";
                else {
                    object.signature = [];
                    if (options.bytes !== Array)
                        object.signature = $util.newBuffer(object.signature);
                }
                if (options.bytes === String)
                    object.serialized_tx = "";
                else {
                    object.serialized_tx = [];
                    if (options.bytes !== Array)
                        object.serialized_tx = $util.newBuffer(object.serialized_tx);
                }
            }
            if (message.signature_index != null && message.hasOwnProperty("signature_index"))
                object.signature_index = message.signature_index;
            if (message.signature != null && message.hasOwnProperty("signature"))
                object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
            if (message.serialized_tx != null && message.hasOwnProperty("serialized_tx"))
                object.serialized_tx = options.bytes === String ? $util.base64.encode(message.serialized_tx, 0, message.serialized_tx.length) : options.bytes === Array ? Array.prototype.slice.call(message.serialized_tx) : message.serialized_tx;
            return object;
        };

        TxRequestSerializedType.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TxRequestSerializedType;
    })();

    return TxRequest;
})();

$root.TxAck = (function() {

    function TxAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    TxAck.prototype.tx = null;

    TxAck.create = function create(properties) {
        return new TxAck(properties);
    };

    TxAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.tx != null && Object.hasOwnProperty.call(message, "tx"))
            $root.TxAck.TransactionType.encode(message.tx, writer.uint32(10).fork()).ldelim();
        return writer;
    };

    TxAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    TxAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TxAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.tx = $root.TxAck.TransactionType.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    TxAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    TxAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.tx != null && message.hasOwnProperty("tx")) {
            var error = $root.TxAck.TransactionType.verify(message.tx);
            if (error)
                return "tx." + error;
        }
        return null;
    };

    TxAck.fromObject = function fromObject(object) {
        if (object instanceof $root.TxAck)
            return object;
        var message = new $root.TxAck();
        if (object.tx != null) {
            if (typeof object.tx !== "object")
                throw TypeError(".TxAck.tx: object expected");
            message.tx = $root.TxAck.TransactionType.fromObject(object.tx);
        }
        return message;
    };

    TxAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.tx = null;
        if (message.tx != null && message.hasOwnProperty("tx"))
            object.tx = $root.TxAck.TransactionType.toObject(message.tx, options);
        return object;
    };

    TxAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    TxAck.TransactionType = (function() {

        function TransactionType(properties) {
            this.inputs = [];
            this.bin_outputs = [];
            this.outputs = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        TransactionType.prototype.version = 0;
        TransactionType.prototype.inputs = $util.emptyArray;
        TransactionType.prototype.bin_outputs = $util.emptyArray;
        TransactionType.prototype.lock_time = 0;
        TransactionType.prototype.outputs = $util.emptyArray;
        TransactionType.prototype.inputs_cnt = 0;
        TransactionType.prototype.outputs_cnt = 0;
        TransactionType.prototype.extra_data = $util.newBuffer([]);
        TransactionType.prototype.extra_data_len = 0;
        TransactionType.prototype.expiry = 0;
        TransactionType.prototype.overwintered = false;
        TransactionType.prototype.version_group_id = 0;
        TransactionType.prototype.timestamp = 0;
        TransactionType.prototype.branch_id = 0;

        TransactionType.create = function create(properties) {
            return new TransactionType(properties);
        };

        TransactionType.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.version != null && Object.hasOwnProperty.call(message, "version"))
                writer.uint32(8).uint32(message.version);
            if (message.inputs != null && message.inputs.length)
                for (var i = 0; i < message.inputs.length; ++i)
                    $root.TxAck.TransactionType.TxInputType.encode(message.inputs[i], writer.uint32(18).fork()).ldelim();
            if (message.bin_outputs != null && message.bin_outputs.length)
                for (var i = 0; i < message.bin_outputs.length; ++i)
                    $root.TxAck.TransactionType.TxOutputBinType.encode(message.bin_outputs[i], writer.uint32(26).fork()).ldelim();
            if (message.lock_time != null && Object.hasOwnProperty.call(message, "lock_time"))
                writer.uint32(32).uint32(message.lock_time);
            if (message.outputs != null && message.outputs.length)
                for (var i = 0; i < message.outputs.length; ++i)
                    $root.TxAck.TransactionType.TxOutputType.encode(message.outputs[i], writer.uint32(42).fork()).ldelim();
            if (message.inputs_cnt != null && Object.hasOwnProperty.call(message, "inputs_cnt"))
                writer.uint32(48).uint32(message.inputs_cnt);
            if (message.outputs_cnt != null && Object.hasOwnProperty.call(message, "outputs_cnt"))
                writer.uint32(56).uint32(message.outputs_cnt);
            if (message.extra_data != null && Object.hasOwnProperty.call(message, "extra_data"))
                writer.uint32(66).bytes(message.extra_data);
            if (message.extra_data_len != null && Object.hasOwnProperty.call(message, "extra_data_len"))
                writer.uint32(72).uint32(message.extra_data_len);
            if (message.expiry != null && Object.hasOwnProperty.call(message, "expiry"))
                writer.uint32(80).uint32(message.expiry);
            if (message.overwintered != null && Object.hasOwnProperty.call(message, "overwintered"))
                writer.uint32(88).bool(message.overwintered);
            if (message.version_group_id != null && Object.hasOwnProperty.call(message, "version_group_id"))
                writer.uint32(96).uint32(message.version_group_id);
            if (message.timestamp != null && Object.hasOwnProperty.call(message, "timestamp"))
                writer.uint32(104).uint32(message.timestamp);
            if (message.branch_id != null && Object.hasOwnProperty.call(message, "branch_id"))
                writer.uint32(112).uint32(message.branch_id);
            return writer;
        };

        TransactionType.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        TransactionType.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TxAck.TransactionType();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.version = reader.uint32();
                    break;
                case 2:
                    if (!(message.inputs && message.inputs.length))
                        message.inputs = [];
                    message.inputs.push($root.TxAck.TransactionType.TxInputType.decode(reader, reader.uint32()));
                    break;
                case 3:
                    if (!(message.bin_outputs && message.bin_outputs.length))
                        message.bin_outputs = [];
                    message.bin_outputs.push($root.TxAck.TransactionType.TxOutputBinType.decode(reader, reader.uint32()));
                    break;
                case 4:
                    message.lock_time = reader.uint32();
                    break;
                case 5:
                    if (!(message.outputs && message.outputs.length))
                        message.outputs = [];
                    message.outputs.push($root.TxAck.TransactionType.TxOutputType.decode(reader, reader.uint32()));
                    break;
                case 6:
                    message.inputs_cnt = reader.uint32();
                    break;
                case 7:
                    message.outputs_cnt = reader.uint32();
                    break;
                case 8:
                    message.extra_data = reader.bytes();
                    break;
                case 9:
                    message.extra_data_len = reader.uint32();
                    break;
                case 10:
                    message.expiry = reader.uint32();
                    break;
                case 11:
                    message.overwintered = reader.bool();
                    break;
                case 12:
                    message.version_group_id = reader.uint32();
                    break;
                case 13:
                    message.timestamp = reader.uint32();
                    break;
                case 14:
                    message.branch_id = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        TransactionType.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        TransactionType.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.version != null && message.hasOwnProperty("version"))
                if (!$util.isInteger(message.version))
                    return "version: integer expected";
            if (message.inputs != null && message.hasOwnProperty("inputs")) {
                if (!Array.isArray(message.inputs))
                    return "inputs: array expected";
                for (var i = 0; i < message.inputs.length; ++i) {
                    var error = $root.TxAck.TransactionType.TxInputType.verify(message.inputs[i]);
                    if (error)
                        return "inputs." + error;
                }
            }
            if (message.bin_outputs != null && message.hasOwnProperty("bin_outputs")) {
                if (!Array.isArray(message.bin_outputs))
                    return "bin_outputs: array expected";
                for (var i = 0; i < message.bin_outputs.length; ++i) {
                    var error = $root.TxAck.TransactionType.TxOutputBinType.verify(message.bin_outputs[i]);
                    if (error)
                        return "bin_outputs." + error;
                }
            }
            if (message.lock_time != null && message.hasOwnProperty("lock_time"))
                if (!$util.isInteger(message.lock_time))
                    return "lock_time: integer expected";
            if (message.outputs != null && message.hasOwnProperty("outputs")) {
                if (!Array.isArray(message.outputs))
                    return "outputs: array expected";
                for (var i = 0; i < message.outputs.length; ++i) {
                    var error = $root.TxAck.TransactionType.TxOutputType.verify(message.outputs[i]);
                    if (error)
                        return "outputs." + error;
                }
            }
            if (message.inputs_cnt != null && message.hasOwnProperty("inputs_cnt"))
                if (!$util.isInteger(message.inputs_cnt))
                    return "inputs_cnt: integer expected";
            if (message.outputs_cnt != null && message.hasOwnProperty("outputs_cnt"))
                if (!$util.isInteger(message.outputs_cnt))
                    return "outputs_cnt: integer expected";
            if (message.extra_data != null && message.hasOwnProperty("extra_data"))
                if (!(message.extra_data && typeof message.extra_data.length === "number" || $util.isString(message.extra_data)))
                    return "extra_data: buffer expected";
            if (message.extra_data_len != null && message.hasOwnProperty("extra_data_len"))
                if (!$util.isInteger(message.extra_data_len))
                    return "extra_data_len: integer expected";
            if (message.expiry != null && message.hasOwnProperty("expiry"))
                if (!$util.isInteger(message.expiry))
                    return "expiry: integer expected";
            if (message.overwintered != null && message.hasOwnProperty("overwintered"))
                if (typeof message.overwintered !== "boolean")
                    return "overwintered: boolean expected";
            if (message.version_group_id != null && message.hasOwnProperty("version_group_id"))
                if (!$util.isInteger(message.version_group_id))
                    return "version_group_id: integer expected";
            if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                if (!$util.isInteger(message.timestamp))
                    return "timestamp: integer expected";
            if (message.branch_id != null && message.hasOwnProperty("branch_id"))
                if (!$util.isInteger(message.branch_id))
                    return "branch_id: integer expected";
            return null;
        };

        TransactionType.fromObject = function fromObject(object) {
            if (object instanceof $root.TxAck.TransactionType)
                return object;
            var message = new $root.TxAck.TransactionType();
            if (object.version != null)
                message.version = object.version >>> 0;
            if (object.inputs) {
                if (!Array.isArray(object.inputs))
                    throw TypeError(".TxAck.TransactionType.inputs: array expected");
                message.inputs = [];
                for (var i = 0; i < object.inputs.length; ++i) {
                    if (typeof object.inputs[i] !== "object")
                        throw TypeError(".TxAck.TransactionType.inputs: object expected");
                    message.inputs[i] = $root.TxAck.TransactionType.TxInputType.fromObject(object.inputs[i]);
                }
            }
            if (object.bin_outputs) {
                if (!Array.isArray(object.bin_outputs))
                    throw TypeError(".TxAck.TransactionType.bin_outputs: array expected");
                message.bin_outputs = [];
                for (var i = 0; i < object.bin_outputs.length; ++i) {
                    if (typeof object.bin_outputs[i] !== "object")
                        throw TypeError(".TxAck.TransactionType.bin_outputs: object expected");
                    message.bin_outputs[i] = $root.TxAck.TransactionType.TxOutputBinType.fromObject(object.bin_outputs[i]);
                }
            }
            if (object.lock_time != null)
                message.lock_time = object.lock_time >>> 0;
            if (object.outputs) {
                if (!Array.isArray(object.outputs))
                    throw TypeError(".TxAck.TransactionType.outputs: array expected");
                message.outputs = [];
                for (var i = 0; i < object.outputs.length; ++i) {
                    if (typeof object.outputs[i] !== "object")
                        throw TypeError(".TxAck.TransactionType.outputs: object expected");
                    message.outputs[i] = $root.TxAck.TransactionType.TxOutputType.fromObject(object.outputs[i]);
                }
            }
            if (object.inputs_cnt != null)
                message.inputs_cnt = object.inputs_cnt >>> 0;
            if (object.outputs_cnt != null)
                message.outputs_cnt = object.outputs_cnt >>> 0;
            if (object.extra_data != null)
                if (typeof object.extra_data === "string")
                    $util.base64.decode(object.extra_data, message.extra_data = $util.newBuffer($util.base64.length(object.extra_data)), 0);
                else if (object.extra_data.length)
                    message.extra_data = object.extra_data;
            if (object.extra_data_len != null)
                message.extra_data_len = object.extra_data_len >>> 0;
            if (object.expiry != null)
                message.expiry = object.expiry >>> 0;
            if (object.overwintered != null)
                message.overwintered = Boolean(object.overwintered);
            if (object.version_group_id != null)
                message.version_group_id = object.version_group_id >>> 0;
            if (object.timestamp != null)
                message.timestamp = object.timestamp >>> 0;
            if (object.branch_id != null)
                message.branch_id = object.branch_id >>> 0;
            return message;
        };

        TransactionType.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.inputs = [];
                object.bin_outputs = [];
                object.outputs = [];
            }
            if (options.defaults) {
                object.version = 0;
                object.lock_time = 0;
                object.inputs_cnt = 0;
                object.outputs_cnt = 0;
                if (options.bytes === String)
                    object.extra_data = "";
                else {
                    object.extra_data = [];
                    if (options.bytes !== Array)
                        object.extra_data = $util.newBuffer(object.extra_data);
                }
                object.extra_data_len = 0;
                object.expiry = 0;
                object.overwintered = false;
                object.version_group_id = 0;
                object.timestamp = 0;
                object.branch_id = 0;
            }
            if (message.version != null && message.hasOwnProperty("version"))
                object.version = message.version;
            if (message.inputs && message.inputs.length) {
                object.inputs = [];
                for (var j = 0; j < message.inputs.length; ++j)
                    object.inputs[j] = $root.TxAck.TransactionType.TxInputType.toObject(message.inputs[j], options);
            }
            if (message.bin_outputs && message.bin_outputs.length) {
                object.bin_outputs = [];
                for (var j = 0; j < message.bin_outputs.length; ++j)
                    object.bin_outputs[j] = $root.TxAck.TransactionType.TxOutputBinType.toObject(message.bin_outputs[j], options);
            }
            if (message.lock_time != null && message.hasOwnProperty("lock_time"))
                object.lock_time = message.lock_time;
            if (message.outputs && message.outputs.length) {
                object.outputs = [];
                for (var j = 0; j < message.outputs.length; ++j)
                    object.outputs[j] = $root.TxAck.TransactionType.TxOutputType.toObject(message.outputs[j], options);
            }
            if (message.inputs_cnt != null && message.hasOwnProperty("inputs_cnt"))
                object.inputs_cnt = message.inputs_cnt;
            if (message.outputs_cnt != null && message.hasOwnProperty("outputs_cnt"))
                object.outputs_cnt = message.outputs_cnt;
            if (message.extra_data != null && message.hasOwnProperty("extra_data"))
                object.extra_data = options.bytes === String ? $util.base64.encode(message.extra_data, 0, message.extra_data.length) : options.bytes === Array ? Array.prototype.slice.call(message.extra_data) : message.extra_data;
            if (message.extra_data_len != null && message.hasOwnProperty("extra_data_len"))
                object.extra_data_len = message.extra_data_len;
            if (message.expiry != null && message.hasOwnProperty("expiry"))
                object.expiry = message.expiry;
            if (message.overwintered != null && message.hasOwnProperty("overwintered"))
                object.overwintered = message.overwintered;
            if (message.version_group_id != null && message.hasOwnProperty("version_group_id"))
                object.version_group_id = message.version_group_id;
            if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                object.timestamp = message.timestamp;
            if (message.branch_id != null && message.hasOwnProperty("branch_id"))
                object.branch_id = message.branch_id;
            return object;
        };

        TransactionType.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        TransactionType.TxInputType = (function() {

            function TxInputType(properties) {
                this.address_n = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            TxInputType.prototype.address_n = $util.emptyArray;
            TxInputType.prototype.prev_hash = $util.newBuffer([]);
            TxInputType.prototype.prev_index = 0;
            TxInputType.prototype.script_sig = $util.newBuffer([]);
            TxInputType.prototype.sequence = 4294967295;
            TxInputType.prototype.script_type = 0;
            TxInputType.prototype.multisig = null;
            TxInputType.prototype.amount = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
            TxInputType.prototype.decred_tree = 0;
            TxInputType.prototype.witness = $util.newBuffer([]);
            TxInputType.prototype.ownership_proof = $util.newBuffer([]);
            TxInputType.prototype.commitment_data = $util.newBuffer([]);
            TxInputType.prototype.orig_hash = $util.newBuffer([]);
            TxInputType.prototype.orig_index = 0;
            TxInputType.prototype.decred_staking_spend = 0;
            TxInputType.prototype.script_pubkey = $util.newBuffer([]);

            TxInputType.create = function create(properties) {
                return new TxInputType(properties);
            };

            TxInputType.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.address_n != null && message.address_n.length)
                    for (var i = 0; i < message.address_n.length; ++i)
                        writer.uint32(8).uint32(message.address_n[i]);
                writer.uint32(18).bytes(message.prev_hash);
                writer.uint32(24).uint32(message.prev_index);
                if (message.script_sig != null && Object.hasOwnProperty.call(message, "script_sig"))
                    writer.uint32(34).bytes(message.script_sig);
                if (message.sequence != null && Object.hasOwnProperty.call(message, "sequence"))
                    writer.uint32(40).uint32(message.sequence);
                if (message.script_type != null && Object.hasOwnProperty.call(message, "script_type"))
                    writer.uint32(48).int32(message.script_type);
                if (message.multisig != null && Object.hasOwnProperty.call(message, "multisig"))
                    $root.MultisigRedeemScriptType.encode(message.multisig, writer.uint32(58).fork()).ldelim();
                if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
                    writer.uint32(64).uint64(message.amount);
                if (message.decred_tree != null && Object.hasOwnProperty.call(message, "decred_tree"))
                    writer.uint32(72).uint32(message.decred_tree);
                if (message.witness != null && Object.hasOwnProperty.call(message, "witness"))
                    writer.uint32(106).bytes(message.witness);
                if (message.ownership_proof != null && Object.hasOwnProperty.call(message, "ownership_proof"))
                    writer.uint32(114).bytes(message.ownership_proof);
                if (message.commitment_data != null && Object.hasOwnProperty.call(message, "commitment_data"))
                    writer.uint32(122).bytes(message.commitment_data);
                if (message.orig_hash != null && Object.hasOwnProperty.call(message, "orig_hash"))
                    writer.uint32(130).bytes(message.orig_hash);
                if (message.orig_index != null && Object.hasOwnProperty.call(message, "orig_index"))
                    writer.uint32(136).uint32(message.orig_index);
                if (message.decred_staking_spend != null && Object.hasOwnProperty.call(message, "decred_staking_spend"))
                    writer.uint32(144).int32(message.decred_staking_spend);
                if (message.script_pubkey != null && Object.hasOwnProperty.call(message, "script_pubkey"))
                    writer.uint32(154).bytes(message.script_pubkey);
                return writer;
            };

            TxInputType.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            TxInputType.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TxAck.TransactionType.TxInputType();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (!(message.address_n && message.address_n.length))
                            message.address_n = [];
                        if ((tag & 7) === 2) {
                            var end2 = reader.uint32() + reader.pos;
                            while (reader.pos < end2)
                                message.address_n.push(reader.uint32());
                        } else
                            message.address_n.push(reader.uint32());
                        break;
                    case 2:
                        message.prev_hash = reader.bytes();
                        break;
                    case 3:
                        message.prev_index = reader.uint32();
                        break;
                    case 4:
                        message.script_sig = reader.bytes();
                        break;
                    case 5:
                        message.sequence = reader.uint32();
                        break;
                    case 6:
                        message.script_type = reader.int32();
                        break;
                    case 7:
                        message.multisig = $root.MultisigRedeemScriptType.decode(reader, reader.uint32());
                        break;
                    case 8:
                        message.amount = reader.uint64();
                        break;
                    case 9:
                        message.decred_tree = reader.uint32();
                        break;
                    case 13:
                        message.witness = reader.bytes();
                        break;
                    case 14:
                        message.ownership_proof = reader.bytes();
                        break;
                    case 15:
                        message.commitment_data = reader.bytes();
                        break;
                    case 16:
                        message.orig_hash = reader.bytes();
                        break;
                    case 17:
                        message.orig_index = reader.uint32();
                        break;
                    case 18:
                        message.decred_staking_spend = reader.int32();
                        break;
                    case 19:
                        message.script_pubkey = reader.bytes();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                if (!message.hasOwnProperty("prev_hash"))
                    throw $util.ProtocolError("missing required 'prev_hash'", { instance: message });
                if (!message.hasOwnProperty("prev_index"))
                    throw $util.ProtocolError("missing required 'prev_index'", { instance: message });
                return message;
            };

            TxInputType.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            TxInputType.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.address_n != null && message.hasOwnProperty("address_n")) {
                    if (!Array.isArray(message.address_n))
                        return "address_n: array expected";
                    for (var i = 0; i < message.address_n.length; ++i)
                        if (!$util.isInteger(message.address_n[i]))
                            return "address_n: integer[] expected";
                }
                if (!(message.prev_hash && typeof message.prev_hash.length === "number" || $util.isString(message.prev_hash)))
                    return "prev_hash: buffer expected";
                if (!$util.isInteger(message.prev_index))
                    return "prev_index: integer expected";
                if (message.script_sig != null && message.hasOwnProperty("script_sig"))
                    if (!(message.script_sig && typeof message.script_sig.length === "number" || $util.isString(message.script_sig)))
                        return "script_sig: buffer expected";
                if (message.sequence != null && message.hasOwnProperty("sequence"))
                    if (!$util.isInteger(message.sequence))
                        return "sequence: integer expected";
                if (message.script_type != null && message.hasOwnProperty("script_type"))
                    switch (message.script_type) {
                    default:
                        return "script_type: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                        break;
                    }
                if (message.multisig != null && message.hasOwnProperty("multisig")) {
                    var error = $root.MultisigRedeemScriptType.verify(message.multisig);
                    if (error)
                        return "multisig." + error;
                }
                if (message.amount != null && message.hasOwnProperty("amount"))
                    if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
                        return "amount: integer|Long expected";
                if (message.decred_tree != null && message.hasOwnProperty("decred_tree"))
                    if (!$util.isInteger(message.decred_tree))
                        return "decred_tree: integer expected";
                if (message.witness != null && message.hasOwnProperty("witness"))
                    if (!(message.witness && typeof message.witness.length === "number" || $util.isString(message.witness)))
                        return "witness: buffer expected";
                if (message.ownership_proof != null && message.hasOwnProperty("ownership_proof"))
                    if (!(message.ownership_proof && typeof message.ownership_proof.length === "number" || $util.isString(message.ownership_proof)))
                        return "ownership_proof: buffer expected";
                if (message.commitment_data != null && message.hasOwnProperty("commitment_data"))
                    if (!(message.commitment_data && typeof message.commitment_data.length === "number" || $util.isString(message.commitment_data)))
                        return "commitment_data: buffer expected";
                if (message.orig_hash != null && message.hasOwnProperty("orig_hash"))
                    if (!(message.orig_hash && typeof message.orig_hash.length === "number" || $util.isString(message.orig_hash)))
                        return "orig_hash: buffer expected";
                if (message.orig_index != null && message.hasOwnProperty("orig_index"))
                    if (!$util.isInteger(message.orig_index))
                        return "orig_index: integer expected";
                if (message.decred_staking_spend != null && message.hasOwnProperty("decred_staking_spend"))
                    switch (message.decred_staking_spend) {
                    default:
                        return "decred_staking_spend: enum value expected";
                    case 0:
                    case 1:
                        break;
                    }
                if (message.script_pubkey != null && message.hasOwnProperty("script_pubkey"))
                    if (!(message.script_pubkey && typeof message.script_pubkey.length === "number" || $util.isString(message.script_pubkey)))
                        return "script_pubkey: buffer expected";
                return null;
            };

            TxInputType.fromObject = function fromObject(object) {
                if (object instanceof $root.TxAck.TransactionType.TxInputType)
                    return object;
                var message = new $root.TxAck.TransactionType.TxInputType();
                if (object.address_n) {
                    if (!Array.isArray(object.address_n))
                        throw TypeError(".TxAck.TransactionType.TxInputType.address_n: array expected");
                    message.address_n = [];
                    for (var i = 0; i < object.address_n.length; ++i)
                        message.address_n[i] = object.address_n[i] >>> 0;
                }
                if (object.prev_hash != null)
                    if (typeof object.prev_hash === "string")
                        $util.base64.decode(object.prev_hash, message.prev_hash = $util.newBuffer($util.base64.length(object.prev_hash)), 0);
                    else if (object.prev_hash.length)
                        message.prev_hash = object.prev_hash;
                if (object.prev_index != null)
                    message.prev_index = object.prev_index >>> 0;
                if (object.script_sig != null)
                    if (typeof object.script_sig === "string")
                        $util.base64.decode(object.script_sig, message.script_sig = $util.newBuffer($util.base64.length(object.script_sig)), 0);
                    else if (object.script_sig.length)
                        message.script_sig = object.script_sig;
                if (object.sequence != null)
                    message.sequence = object.sequence >>> 0;
                switch (object.script_type) {
                case "SPENDADDRESS":
                case 0:
                    message.script_type = 0;
                    break;
                case "SPENDMULTISIG":
                case 1:
                    message.script_type = 1;
                    break;
                case "EXTERNAL":
                case 2:
                    message.script_type = 2;
                    break;
                case "SPENDWITNESS":
                case 3:
                    message.script_type = 3;
                    break;
                case "SPENDP2SHWITNESS":
                case 4:
                    message.script_type = 4;
                    break;
                case "SPENDTAPROOT":
                case 5:
                    message.script_type = 5;
                    break;
                }
                if (object.multisig != null) {
                    if (typeof object.multisig !== "object")
                        throw TypeError(".TxAck.TransactionType.TxInputType.multisig: object expected");
                    message.multisig = $root.MultisigRedeemScriptType.fromObject(object.multisig);
                }
                if (object.amount != null)
                    if ($util.Long)
                        (message.amount = $util.Long.fromValue(object.amount)).unsigned = true;
                    else if (typeof object.amount === "string")
                        message.amount = parseInt(object.amount, 10);
                    else if (typeof object.amount === "number")
                        message.amount = object.amount;
                    else if (typeof object.amount === "object")
                        message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber(true);
                if (object.decred_tree != null)
                    message.decred_tree = object.decred_tree >>> 0;
                if (object.witness != null)
                    if (typeof object.witness === "string")
                        $util.base64.decode(object.witness, message.witness = $util.newBuffer($util.base64.length(object.witness)), 0);
                    else if (object.witness.length)
                        message.witness = object.witness;
                if (object.ownership_proof != null)
                    if (typeof object.ownership_proof === "string")
                        $util.base64.decode(object.ownership_proof, message.ownership_proof = $util.newBuffer($util.base64.length(object.ownership_proof)), 0);
                    else if (object.ownership_proof.length)
                        message.ownership_proof = object.ownership_proof;
                if (object.commitment_data != null)
                    if (typeof object.commitment_data === "string")
                        $util.base64.decode(object.commitment_data, message.commitment_data = $util.newBuffer($util.base64.length(object.commitment_data)), 0);
                    else if (object.commitment_data.length)
                        message.commitment_data = object.commitment_data;
                if (object.orig_hash != null)
                    if (typeof object.orig_hash === "string")
                        $util.base64.decode(object.orig_hash, message.orig_hash = $util.newBuffer($util.base64.length(object.orig_hash)), 0);
                    else if (object.orig_hash.length)
                        message.orig_hash = object.orig_hash;
                if (object.orig_index != null)
                    message.orig_index = object.orig_index >>> 0;
                switch (object.decred_staking_spend) {
                case "SSGen":
                case 0:
                    message.decred_staking_spend = 0;
                    break;
                case "SSRTX":
                case 1:
                    message.decred_staking_spend = 1;
                    break;
                }
                if (object.script_pubkey != null)
                    if (typeof object.script_pubkey === "string")
                        $util.base64.decode(object.script_pubkey, message.script_pubkey = $util.newBuffer($util.base64.length(object.script_pubkey)), 0);
                    else if (object.script_pubkey.length)
                        message.script_pubkey = object.script_pubkey;
                return message;
            };

            TxInputType.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.address_n = [];
                if (options.defaults) {
                    if (options.bytes === String)
                        object.prev_hash = "";
                    else {
                        object.prev_hash = [];
                        if (options.bytes !== Array)
                            object.prev_hash = $util.newBuffer(object.prev_hash);
                    }
                    object.prev_index = 0;
                    if (options.bytes === String)
                        object.script_sig = "";
                    else {
                        object.script_sig = [];
                        if (options.bytes !== Array)
                            object.script_sig = $util.newBuffer(object.script_sig);
                    }
                    object.sequence = 4294967295;
                    object.script_type = options.enums === String ? "SPENDADDRESS" : 0;
                    object.multisig = null;
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, true);
                        object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.amount = options.longs === String ? "0" : 0;
                    object.decred_tree = 0;
                    if (options.bytes === String)
                        object.witness = "";
                    else {
                        object.witness = [];
                        if (options.bytes !== Array)
                            object.witness = $util.newBuffer(object.witness);
                    }
                    if (options.bytes === String)
                        object.ownership_proof = "";
                    else {
                        object.ownership_proof = [];
                        if (options.bytes !== Array)
                            object.ownership_proof = $util.newBuffer(object.ownership_proof);
                    }
                    if (options.bytes === String)
                        object.commitment_data = "";
                    else {
                        object.commitment_data = [];
                        if (options.bytes !== Array)
                            object.commitment_data = $util.newBuffer(object.commitment_data);
                    }
                    if (options.bytes === String)
                        object.orig_hash = "";
                    else {
                        object.orig_hash = [];
                        if (options.bytes !== Array)
                            object.orig_hash = $util.newBuffer(object.orig_hash);
                    }
                    object.orig_index = 0;
                    object.decred_staking_spend = options.enums === String ? "SSGen" : 0;
                    if (options.bytes === String)
                        object.script_pubkey = "";
                    else {
                        object.script_pubkey = [];
                        if (options.bytes !== Array)
                            object.script_pubkey = $util.newBuffer(object.script_pubkey);
                    }
                }
                if (message.address_n && message.address_n.length) {
                    object.address_n = [];
                    for (var j = 0; j < message.address_n.length; ++j)
                        object.address_n[j] = message.address_n[j];
                }
                if (message.prev_hash != null && message.hasOwnProperty("prev_hash"))
                    object.prev_hash = options.bytes === String ? $util.base64.encode(message.prev_hash, 0, message.prev_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.prev_hash) : message.prev_hash;
                if (message.prev_index != null && message.hasOwnProperty("prev_index"))
                    object.prev_index = message.prev_index;
                if (message.script_sig != null && message.hasOwnProperty("script_sig"))
                    object.script_sig = options.bytes === String ? $util.base64.encode(message.script_sig, 0, message.script_sig.length) : options.bytes === Array ? Array.prototype.slice.call(message.script_sig) : message.script_sig;
                if (message.sequence != null && message.hasOwnProperty("sequence"))
                    object.sequence = message.sequence;
                if (message.script_type != null && message.hasOwnProperty("script_type"))
                    object.script_type = options.enums === String ? $root.InputScriptType[message.script_type] : message.script_type;
                if (message.multisig != null && message.hasOwnProperty("multisig"))
                    object.multisig = $root.MultisigRedeemScriptType.toObject(message.multisig, options);
                if (message.amount != null && message.hasOwnProperty("amount"))
                    if (typeof message.amount === "number")
                        object.amount = options.longs === String ? String(message.amount) : message.amount;
                    else
                        object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber(true) : message.amount;
                if (message.decred_tree != null && message.hasOwnProperty("decred_tree"))
                    object.decred_tree = message.decred_tree;
                if (message.witness != null && message.hasOwnProperty("witness"))
                    object.witness = options.bytes === String ? $util.base64.encode(message.witness, 0, message.witness.length) : options.bytes === Array ? Array.prototype.slice.call(message.witness) : message.witness;
                if (message.ownership_proof != null && message.hasOwnProperty("ownership_proof"))
                    object.ownership_proof = options.bytes === String ? $util.base64.encode(message.ownership_proof, 0, message.ownership_proof.length) : options.bytes === Array ? Array.prototype.slice.call(message.ownership_proof) : message.ownership_proof;
                if (message.commitment_data != null && message.hasOwnProperty("commitment_data"))
                    object.commitment_data = options.bytes === String ? $util.base64.encode(message.commitment_data, 0, message.commitment_data.length) : options.bytes === Array ? Array.prototype.slice.call(message.commitment_data) : message.commitment_data;
                if (message.orig_hash != null && message.hasOwnProperty("orig_hash"))
                    object.orig_hash = options.bytes === String ? $util.base64.encode(message.orig_hash, 0, message.orig_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.orig_hash) : message.orig_hash;
                if (message.orig_index != null && message.hasOwnProperty("orig_index"))
                    object.orig_index = message.orig_index;
                if (message.decred_staking_spend != null && message.hasOwnProperty("decred_staking_spend"))
                    object.decred_staking_spend = options.enums === String ? $root.DecredStakingSpendType[message.decred_staking_spend] : message.decred_staking_spend;
                if (message.script_pubkey != null && message.hasOwnProperty("script_pubkey"))
                    object.script_pubkey = options.bytes === String ? $util.base64.encode(message.script_pubkey, 0, message.script_pubkey.length) : options.bytes === Array ? Array.prototype.slice.call(message.script_pubkey) : message.script_pubkey;
                return object;
            };

            TxInputType.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return TxInputType;
        })();

        TransactionType.TxOutputBinType = (function() {

            function TxOutputBinType(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            TxOutputBinType.prototype.amount = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
            TxOutputBinType.prototype.script_pubkey = $util.newBuffer([]);
            TxOutputBinType.prototype.decred_script_version = 0;

            TxOutputBinType.create = function create(properties) {
                return new TxOutputBinType(properties);
            };

            TxOutputBinType.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                writer.uint32(8).uint64(message.amount);
                writer.uint32(18).bytes(message.script_pubkey);
                if (message.decred_script_version != null && Object.hasOwnProperty.call(message, "decred_script_version"))
                    writer.uint32(24).uint32(message.decred_script_version);
                return writer;
            };

            TxOutputBinType.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            TxOutputBinType.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TxAck.TransactionType.TxOutputBinType();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.amount = reader.uint64();
                        break;
                    case 2:
                        message.script_pubkey = reader.bytes();
                        break;
                    case 3:
                        message.decred_script_version = reader.uint32();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                if (!message.hasOwnProperty("amount"))
                    throw $util.ProtocolError("missing required 'amount'", { instance: message });
                if (!message.hasOwnProperty("script_pubkey"))
                    throw $util.ProtocolError("missing required 'script_pubkey'", { instance: message });
                return message;
            };

            TxOutputBinType.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            TxOutputBinType.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
                    return "amount: integer|Long expected";
                if (!(message.script_pubkey && typeof message.script_pubkey.length === "number" || $util.isString(message.script_pubkey)))
                    return "script_pubkey: buffer expected";
                if (message.decred_script_version != null && message.hasOwnProperty("decred_script_version"))
                    if (!$util.isInteger(message.decred_script_version))
                        return "decred_script_version: integer expected";
                return null;
            };

            TxOutputBinType.fromObject = function fromObject(object) {
                if (object instanceof $root.TxAck.TransactionType.TxOutputBinType)
                    return object;
                var message = new $root.TxAck.TransactionType.TxOutputBinType();
                if (object.amount != null)
                    if ($util.Long)
                        (message.amount = $util.Long.fromValue(object.amount)).unsigned = true;
                    else if (typeof object.amount === "string")
                        message.amount = parseInt(object.amount, 10);
                    else if (typeof object.amount === "number")
                        message.amount = object.amount;
                    else if (typeof object.amount === "object")
                        message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber(true);
                if (object.script_pubkey != null)
                    if (typeof object.script_pubkey === "string")
                        $util.base64.decode(object.script_pubkey, message.script_pubkey = $util.newBuffer($util.base64.length(object.script_pubkey)), 0);
                    else if (object.script_pubkey.length)
                        message.script_pubkey = object.script_pubkey;
                if (object.decred_script_version != null)
                    message.decred_script_version = object.decred_script_version >>> 0;
                return message;
            };

            TxOutputBinType.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, true);
                        object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.amount = options.longs === String ? "0" : 0;
                    if (options.bytes === String)
                        object.script_pubkey = "";
                    else {
                        object.script_pubkey = [];
                        if (options.bytes !== Array)
                            object.script_pubkey = $util.newBuffer(object.script_pubkey);
                    }
                    object.decred_script_version = 0;
                }
                if (message.amount != null && message.hasOwnProperty("amount"))
                    if (typeof message.amount === "number")
                        object.amount = options.longs === String ? String(message.amount) : message.amount;
                    else
                        object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber(true) : message.amount;
                if (message.script_pubkey != null && message.hasOwnProperty("script_pubkey"))
                    object.script_pubkey = options.bytes === String ? $util.base64.encode(message.script_pubkey, 0, message.script_pubkey.length) : options.bytes === Array ? Array.prototype.slice.call(message.script_pubkey) : message.script_pubkey;
                if (message.decred_script_version != null && message.hasOwnProperty("decred_script_version"))
                    object.decred_script_version = message.decred_script_version;
                return object;
            };

            TxOutputBinType.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return TxOutputBinType;
        })();

        TransactionType.TxOutputType = (function() {

            function TxOutputType(properties) {
                this.address_n = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            TxOutputType.prototype.address = "";
            TxOutputType.prototype.address_n = $util.emptyArray;
            TxOutputType.prototype.amount = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
            TxOutputType.prototype.script_type = 0;
            TxOutputType.prototype.multisig = null;
            TxOutputType.prototype.op_return_data = $util.newBuffer([]);
            TxOutputType.prototype.orig_hash = $util.newBuffer([]);
            TxOutputType.prototype.orig_index = 0;

            TxOutputType.create = function create(properties) {
                return new TxOutputType(properties);
            };

            TxOutputType.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.address != null && Object.hasOwnProperty.call(message, "address"))
                    writer.uint32(10).string(message.address);
                if (message.address_n != null && message.address_n.length)
                    for (var i = 0; i < message.address_n.length; ++i)
                        writer.uint32(16).uint32(message.address_n[i]);
                writer.uint32(24).uint64(message.amount);
                if (message.script_type != null && Object.hasOwnProperty.call(message, "script_type"))
                    writer.uint32(32).int32(message.script_type);
                if (message.multisig != null && Object.hasOwnProperty.call(message, "multisig"))
                    $root.MultisigRedeemScriptType.encode(message.multisig, writer.uint32(42).fork()).ldelim();
                if (message.op_return_data != null && Object.hasOwnProperty.call(message, "op_return_data"))
                    writer.uint32(50).bytes(message.op_return_data);
                if (message.orig_hash != null && Object.hasOwnProperty.call(message, "orig_hash"))
                    writer.uint32(82).bytes(message.orig_hash);
                if (message.orig_index != null && Object.hasOwnProperty.call(message, "orig_index"))
                    writer.uint32(88).uint32(message.orig_index);
                return writer;
            };

            TxOutputType.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            TxOutputType.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TxAck.TransactionType.TxOutputType();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.address = reader.string();
                        break;
                    case 2:
                        if (!(message.address_n && message.address_n.length))
                            message.address_n = [];
                        if ((tag & 7) === 2) {
                            var end2 = reader.uint32() + reader.pos;
                            while (reader.pos < end2)
                                message.address_n.push(reader.uint32());
                        } else
                            message.address_n.push(reader.uint32());
                        break;
                    case 3:
                        message.amount = reader.uint64();
                        break;
                    case 4:
                        message.script_type = reader.int32();
                        break;
                    case 5:
                        message.multisig = $root.MultisigRedeemScriptType.decode(reader, reader.uint32());
                        break;
                    case 6:
                        message.op_return_data = reader.bytes();
                        break;
                    case 10:
                        message.orig_hash = reader.bytes();
                        break;
                    case 11:
                        message.orig_index = reader.uint32();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                if (!message.hasOwnProperty("amount"))
                    throw $util.ProtocolError("missing required 'amount'", { instance: message });
                return message;
            };

            TxOutputType.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            TxOutputType.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.address != null && message.hasOwnProperty("address"))
                    if (!$util.isString(message.address))
                        return "address: string expected";
                if (message.address_n != null && message.hasOwnProperty("address_n")) {
                    if (!Array.isArray(message.address_n))
                        return "address_n: array expected";
                    for (var i = 0; i < message.address_n.length; ++i)
                        if (!$util.isInteger(message.address_n[i]))
                            return "address_n: integer[] expected";
                }
                if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
                    return "amount: integer|Long expected";
                if (message.script_type != null && message.hasOwnProperty("script_type"))
                    switch (message.script_type) {
                    default:
                        return "script_type: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                    case 6:
                        break;
                    }
                if (message.multisig != null && message.hasOwnProperty("multisig")) {
                    var error = $root.MultisigRedeemScriptType.verify(message.multisig);
                    if (error)
                        return "multisig." + error;
                }
                if (message.op_return_data != null && message.hasOwnProperty("op_return_data"))
                    if (!(message.op_return_data && typeof message.op_return_data.length === "number" || $util.isString(message.op_return_data)))
                        return "op_return_data: buffer expected";
                if (message.orig_hash != null && message.hasOwnProperty("orig_hash"))
                    if (!(message.orig_hash && typeof message.orig_hash.length === "number" || $util.isString(message.orig_hash)))
                        return "orig_hash: buffer expected";
                if (message.orig_index != null && message.hasOwnProperty("orig_index"))
                    if (!$util.isInteger(message.orig_index))
                        return "orig_index: integer expected";
                return null;
            };

            TxOutputType.fromObject = function fromObject(object) {
                if (object instanceof $root.TxAck.TransactionType.TxOutputType)
                    return object;
                var message = new $root.TxAck.TransactionType.TxOutputType();
                if (object.address != null)
                    message.address = String(object.address);
                if (object.address_n) {
                    if (!Array.isArray(object.address_n))
                        throw TypeError(".TxAck.TransactionType.TxOutputType.address_n: array expected");
                    message.address_n = [];
                    for (var i = 0; i < object.address_n.length; ++i)
                        message.address_n[i] = object.address_n[i] >>> 0;
                }
                if (object.amount != null)
                    if ($util.Long)
                        (message.amount = $util.Long.fromValue(object.amount)).unsigned = true;
                    else if (typeof object.amount === "string")
                        message.amount = parseInt(object.amount, 10);
                    else if (typeof object.amount === "number")
                        message.amount = object.amount;
                    else if (typeof object.amount === "object")
                        message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber(true);
                switch (object.script_type) {
                case "PAYTOADDRESS":
                case 0:
                    message.script_type = 0;
                    break;
                case "PAYTOSCRIPTHASH":
                case 1:
                    message.script_type = 1;
                    break;
                case "PAYTOMULTISIG":
                case 2:
                    message.script_type = 2;
                    break;
                case "PAYTOOPRETURN":
                case 3:
                    message.script_type = 3;
                    break;
                case "PAYTOWITNESS":
                case 4:
                    message.script_type = 4;
                    break;
                case "PAYTOP2SHWITNESS":
                case 5:
                    message.script_type = 5;
                    break;
                case "PAYTOTAPROOT":
                case 6:
                    message.script_type = 6;
                    break;
                }
                if (object.multisig != null) {
                    if (typeof object.multisig !== "object")
                        throw TypeError(".TxAck.TransactionType.TxOutputType.multisig: object expected");
                    message.multisig = $root.MultisigRedeemScriptType.fromObject(object.multisig);
                }
                if (object.op_return_data != null)
                    if (typeof object.op_return_data === "string")
                        $util.base64.decode(object.op_return_data, message.op_return_data = $util.newBuffer($util.base64.length(object.op_return_data)), 0);
                    else if (object.op_return_data.length)
                        message.op_return_data = object.op_return_data;
                if (object.orig_hash != null)
                    if (typeof object.orig_hash === "string")
                        $util.base64.decode(object.orig_hash, message.orig_hash = $util.newBuffer($util.base64.length(object.orig_hash)), 0);
                    else if (object.orig_hash.length)
                        message.orig_hash = object.orig_hash;
                if (object.orig_index != null)
                    message.orig_index = object.orig_index >>> 0;
                return message;
            };

            TxOutputType.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.address_n = [];
                if (options.defaults) {
                    object.address = "";
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, true);
                        object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.amount = options.longs === String ? "0" : 0;
                    object.script_type = options.enums === String ? "PAYTOADDRESS" : 0;
                    object.multisig = null;
                    if (options.bytes === String)
                        object.op_return_data = "";
                    else {
                        object.op_return_data = [];
                        if (options.bytes !== Array)
                            object.op_return_data = $util.newBuffer(object.op_return_data);
                    }
                    if (options.bytes === String)
                        object.orig_hash = "";
                    else {
                        object.orig_hash = [];
                        if (options.bytes !== Array)
                            object.orig_hash = $util.newBuffer(object.orig_hash);
                    }
                    object.orig_index = 0;
                }
                if (message.address != null && message.hasOwnProperty("address"))
                    object.address = message.address;
                if (message.address_n && message.address_n.length) {
                    object.address_n = [];
                    for (var j = 0; j < message.address_n.length; ++j)
                        object.address_n[j] = message.address_n[j];
                }
                if (message.amount != null && message.hasOwnProperty("amount"))
                    if (typeof message.amount === "number")
                        object.amount = options.longs === String ? String(message.amount) : message.amount;
                    else
                        object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber(true) : message.amount;
                if (message.script_type != null && message.hasOwnProperty("script_type"))
                    object.script_type = options.enums === String ? $root.OutputScriptType[message.script_type] : message.script_type;
                if (message.multisig != null && message.hasOwnProperty("multisig"))
                    object.multisig = $root.MultisigRedeemScriptType.toObject(message.multisig, options);
                if (message.op_return_data != null && message.hasOwnProperty("op_return_data"))
                    object.op_return_data = options.bytes === String ? $util.base64.encode(message.op_return_data, 0, message.op_return_data.length) : options.bytes === Array ? Array.prototype.slice.call(message.op_return_data) : message.op_return_data;
                if (message.orig_hash != null && message.hasOwnProperty("orig_hash"))
                    object.orig_hash = options.bytes === String ? $util.base64.encode(message.orig_hash, 0, message.orig_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.orig_hash) : message.orig_hash;
                if (message.orig_index != null && message.hasOwnProperty("orig_index"))
                    object.orig_index = message.orig_index;
                return object;
            };

            TxOutputType.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return TxOutputType;
        })();

        return TransactionType;
    })();

    return TxAck;
})();

$root.TxInput = (function() {

    function TxInput(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    TxInput.prototype.address_n = $util.emptyArray;
    TxInput.prototype.prev_hash = $util.newBuffer([]);
    TxInput.prototype.prev_index = 0;
    TxInput.prototype.script_sig = $util.newBuffer([]);
    TxInput.prototype.sequence = 4294967295;
    TxInput.prototype.script_type = 0;
    TxInput.prototype.multisig = null;
    TxInput.prototype.amount = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    TxInput.prototype.decred_tree = 0;
    TxInput.prototype.witness = $util.newBuffer([]);
    TxInput.prototype.ownership_proof = $util.newBuffer([]);
    TxInput.prototype.commitment_data = $util.newBuffer([]);
    TxInput.prototype.orig_hash = $util.newBuffer([]);
    TxInput.prototype.orig_index = 0;
    TxInput.prototype.decred_staking_spend = 0;
    TxInput.prototype.script_pubkey = $util.newBuffer([]);

    TxInput.create = function create(properties) {
        return new TxInput(properties);
    };

    TxInput.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).bytes(message.prev_hash);
        writer.uint32(24).uint32(message.prev_index);
        if (message.script_sig != null && Object.hasOwnProperty.call(message, "script_sig"))
            writer.uint32(34).bytes(message.script_sig);
        if (message.sequence != null && Object.hasOwnProperty.call(message, "sequence"))
            writer.uint32(40).uint32(message.sequence);
        if (message.script_type != null && Object.hasOwnProperty.call(message, "script_type"))
            writer.uint32(48).int32(message.script_type);
        if (message.multisig != null && Object.hasOwnProperty.call(message, "multisig"))
            $root.MultisigRedeemScriptType.encode(message.multisig, writer.uint32(58).fork()).ldelim();
        writer.uint32(64).uint64(message.amount);
        if (message.decred_tree != null && Object.hasOwnProperty.call(message, "decred_tree"))
            writer.uint32(72).uint32(message.decred_tree);
        if (message.witness != null && Object.hasOwnProperty.call(message, "witness"))
            writer.uint32(106).bytes(message.witness);
        if (message.ownership_proof != null && Object.hasOwnProperty.call(message, "ownership_proof"))
            writer.uint32(114).bytes(message.ownership_proof);
        if (message.commitment_data != null && Object.hasOwnProperty.call(message, "commitment_data"))
            writer.uint32(122).bytes(message.commitment_data);
        if (message.orig_hash != null && Object.hasOwnProperty.call(message, "orig_hash"))
            writer.uint32(130).bytes(message.orig_hash);
        if (message.orig_index != null && Object.hasOwnProperty.call(message, "orig_index"))
            writer.uint32(136).uint32(message.orig_index);
        if (message.decred_staking_spend != null && Object.hasOwnProperty.call(message, "decred_staking_spend"))
            writer.uint32(144).int32(message.decred_staking_spend);
        if (message.script_pubkey != null && Object.hasOwnProperty.call(message, "script_pubkey"))
            writer.uint32(154).bytes(message.script_pubkey);
        return writer;
    };

    TxInput.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    TxInput.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TxInput();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.prev_hash = reader.bytes();
                break;
            case 3:
                message.prev_index = reader.uint32();
                break;
            case 4:
                message.script_sig = reader.bytes();
                break;
            case 5:
                message.sequence = reader.uint32();
                break;
            case 6:
                message.script_type = reader.int32();
                break;
            case 7:
                message.multisig = $root.MultisigRedeemScriptType.decode(reader, reader.uint32());
                break;
            case 8:
                message.amount = reader.uint64();
                break;
            case 9:
                message.decred_tree = reader.uint32();
                break;
            case 13:
                message.witness = reader.bytes();
                break;
            case 14:
                message.ownership_proof = reader.bytes();
                break;
            case 15:
                message.commitment_data = reader.bytes();
                break;
            case 16:
                message.orig_hash = reader.bytes();
                break;
            case 17:
                message.orig_index = reader.uint32();
                break;
            case 18:
                message.decred_staking_spend = reader.int32();
                break;
            case 19:
                message.script_pubkey = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("prev_hash"))
            throw $util.ProtocolError("missing required 'prev_hash'", { instance: message });
        if (!message.hasOwnProperty("prev_index"))
            throw $util.ProtocolError("missing required 'prev_index'", { instance: message });
        if (!message.hasOwnProperty("amount"))
            throw $util.ProtocolError("missing required 'amount'", { instance: message });
        return message;
    };

    TxInput.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    TxInput.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!(message.prev_hash && typeof message.prev_hash.length === "number" || $util.isString(message.prev_hash)))
            return "prev_hash: buffer expected";
        if (!$util.isInteger(message.prev_index))
            return "prev_index: integer expected";
        if (message.script_sig != null && message.hasOwnProperty("script_sig"))
            if (!(message.script_sig && typeof message.script_sig.length === "number" || $util.isString(message.script_sig)))
                return "script_sig: buffer expected";
        if (message.sequence != null && message.hasOwnProperty("sequence"))
            if (!$util.isInteger(message.sequence))
                return "sequence: integer expected";
        if (message.script_type != null && message.hasOwnProperty("script_type"))
            switch (message.script_type) {
            default:
                return "script_type: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
                break;
            }
        if (message.multisig != null && message.hasOwnProperty("multisig")) {
            var error = $root.MultisigRedeemScriptType.verify(message.multisig);
            if (error)
                return "multisig." + error;
        }
        if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
            return "amount: integer|Long expected";
        if (message.decred_tree != null && message.hasOwnProperty("decred_tree"))
            if (!$util.isInteger(message.decred_tree))
                return "decred_tree: integer expected";
        if (message.witness != null && message.hasOwnProperty("witness"))
            if (!(message.witness && typeof message.witness.length === "number" || $util.isString(message.witness)))
                return "witness: buffer expected";
        if (message.ownership_proof != null && message.hasOwnProperty("ownership_proof"))
            if (!(message.ownership_proof && typeof message.ownership_proof.length === "number" || $util.isString(message.ownership_proof)))
                return "ownership_proof: buffer expected";
        if (message.commitment_data != null && message.hasOwnProperty("commitment_data"))
            if (!(message.commitment_data && typeof message.commitment_data.length === "number" || $util.isString(message.commitment_data)))
                return "commitment_data: buffer expected";
        if (message.orig_hash != null && message.hasOwnProperty("orig_hash"))
            if (!(message.orig_hash && typeof message.orig_hash.length === "number" || $util.isString(message.orig_hash)))
                return "orig_hash: buffer expected";
        if (message.orig_index != null && message.hasOwnProperty("orig_index"))
            if (!$util.isInteger(message.orig_index))
                return "orig_index: integer expected";
        if (message.decred_staking_spend != null && message.hasOwnProperty("decred_staking_spend"))
            switch (message.decred_staking_spend) {
            default:
                return "decred_staking_spend: enum value expected";
            case 0:
            case 1:
                break;
            }
        if (message.script_pubkey != null && message.hasOwnProperty("script_pubkey"))
            if (!(message.script_pubkey && typeof message.script_pubkey.length === "number" || $util.isString(message.script_pubkey)))
                return "script_pubkey: buffer expected";
        return null;
    };

    TxInput.fromObject = function fromObject(object) {
        if (object instanceof $root.TxInput)
            return object;
        var message = new $root.TxInput();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".TxInput.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.prev_hash != null)
            if (typeof object.prev_hash === "string")
                $util.base64.decode(object.prev_hash, message.prev_hash = $util.newBuffer($util.base64.length(object.prev_hash)), 0);
            else if (object.prev_hash.length)
                message.prev_hash = object.prev_hash;
        if (object.prev_index != null)
            message.prev_index = object.prev_index >>> 0;
        if (object.script_sig != null)
            if (typeof object.script_sig === "string")
                $util.base64.decode(object.script_sig, message.script_sig = $util.newBuffer($util.base64.length(object.script_sig)), 0);
            else if (object.script_sig.length)
                message.script_sig = object.script_sig;
        if (object.sequence != null)
            message.sequence = object.sequence >>> 0;
        switch (object.script_type) {
        case "SPENDADDRESS":
        case 0:
            message.script_type = 0;
            break;
        case "SPENDMULTISIG":
        case 1:
            message.script_type = 1;
            break;
        case "EXTERNAL":
        case 2:
            message.script_type = 2;
            break;
        case "SPENDWITNESS":
        case 3:
            message.script_type = 3;
            break;
        case "SPENDP2SHWITNESS":
        case 4:
            message.script_type = 4;
            break;
        case "SPENDTAPROOT":
        case 5:
            message.script_type = 5;
            break;
        }
        if (object.multisig != null) {
            if (typeof object.multisig !== "object")
                throw TypeError(".TxInput.multisig: object expected");
            message.multisig = $root.MultisigRedeemScriptType.fromObject(object.multisig);
        }
        if (object.amount != null)
            if ($util.Long)
                (message.amount = $util.Long.fromValue(object.amount)).unsigned = true;
            else if (typeof object.amount === "string")
                message.amount = parseInt(object.amount, 10);
            else if (typeof object.amount === "number")
                message.amount = object.amount;
            else if (typeof object.amount === "object")
                message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber(true);
        if (object.decred_tree != null)
            message.decred_tree = object.decred_tree >>> 0;
        if (object.witness != null)
            if (typeof object.witness === "string")
                $util.base64.decode(object.witness, message.witness = $util.newBuffer($util.base64.length(object.witness)), 0);
            else if (object.witness.length)
                message.witness = object.witness;
        if (object.ownership_proof != null)
            if (typeof object.ownership_proof === "string")
                $util.base64.decode(object.ownership_proof, message.ownership_proof = $util.newBuffer($util.base64.length(object.ownership_proof)), 0);
            else if (object.ownership_proof.length)
                message.ownership_proof = object.ownership_proof;
        if (object.commitment_data != null)
            if (typeof object.commitment_data === "string")
                $util.base64.decode(object.commitment_data, message.commitment_data = $util.newBuffer($util.base64.length(object.commitment_data)), 0);
            else if (object.commitment_data.length)
                message.commitment_data = object.commitment_data;
        if (object.orig_hash != null)
            if (typeof object.orig_hash === "string")
                $util.base64.decode(object.orig_hash, message.orig_hash = $util.newBuffer($util.base64.length(object.orig_hash)), 0);
            else if (object.orig_hash.length)
                message.orig_hash = object.orig_hash;
        if (object.orig_index != null)
            message.orig_index = object.orig_index >>> 0;
        switch (object.decred_staking_spend) {
        case "SSGen":
        case 0:
            message.decred_staking_spend = 0;
            break;
        case "SSRTX":
        case 1:
            message.decred_staking_spend = 1;
            break;
        }
        if (object.script_pubkey != null)
            if (typeof object.script_pubkey === "string")
                $util.base64.decode(object.script_pubkey, message.script_pubkey = $util.newBuffer($util.base64.length(object.script_pubkey)), 0);
            else if (object.script_pubkey.length)
                message.script_pubkey = object.script_pubkey;
        return message;
    };

    TxInput.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            if (options.bytes === String)
                object.prev_hash = "";
            else {
                object.prev_hash = [];
                if (options.bytes !== Array)
                    object.prev_hash = $util.newBuffer(object.prev_hash);
            }
            object.prev_index = 0;
            if (options.bytes === String)
                object.script_sig = "";
            else {
                object.script_sig = [];
                if (options.bytes !== Array)
                    object.script_sig = $util.newBuffer(object.script_sig);
            }
            object.sequence = 4294967295;
            object.script_type = options.enums === String ? "SPENDADDRESS" : 0;
            object.multisig = null;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.amount = options.longs === String ? "0" : 0;
            object.decred_tree = 0;
            if (options.bytes === String)
                object.witness = "";
            else {
                object.witness = [];
                if (options.bytes !== Array)
                    object.witness = $util.newBuffer(object.witness);
            }
            if (options.bytes === String)
                object.ownership_proof = "";
            else {
                object.ownership_proof = [];
                if (options.bytes !== Array)
                    object.ownership_proof = $util.newBuffer(object.ownership_proof);
            }
            if (options.bytes === String)
                object.commitment_data = "";
            else {
                object.commitment_data = [];
                if (options.bytes !== Array)
                    object.commitment_data = $util.newBuffer(object.commitment_data);
            }
            if (options.bytes === String)
                object.orig_hash = "";
            else {
                object.orig_hash = [];
                if (options.bytes !== Array)
                    object.orig_hash = $util.newBuffer(object.orig_hash);
            }
            object.orig_index = 0;
            object.decred_staking_spend = options.enums === String ? "SSGen" : 0;
            if (options.bytes === String)
                object.script_pubkey = "";
            else {
                object.script_pubkey = [];
                if (options.bytes !== Array)
                    object.script_pubkey = $util.newBuffer(object.script_pubkey);
            }
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.prev_hash != null && message.hasOwnProperty("prev_hash"))
            object.prev_hash = options.bytes === String ? $util.base64.encode(message.prev_hash, 0, message.prev_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.prev_hash) : message.prev_hash;
        if (message.prev_index != null && message.hasOwnProperty("prev_index"))
            object.prev_index = message.prev_index;
        if (message.script_sig != null && message.hasOwnProperty("script_sig"))
            object.script_sig = options.bytes === String ? $util.base64.encode(message.script_sig, 0, message.script_sig.length) : options.bytes === Array ? Array.prototype.slice.call(message.script_sig) : message.script_sig;
        if (message.sequence != null && message.hasOwnProperty("sequence"))
            object.sequence = message.sequence;
        if (message.script_type != null && message.hasOwnProperty("script_type"))
            object.script_type = options.enums === String ? $root.InputScriptType[message.script_type] : message.script_type;
        if (message.multisig != null && message.hasOwnProperty("multisig"))
            object.multisig = $root.MultisigRedeemScriptType.toObject(message.multisig, options);
        if (message.amount != null && message.hasOwnProperty("amount"))
            if (typeof message.amount === "number")
                object.amount = options.longs === String ? String(message.amount) : message.amount;
            else
                object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber(true) : message.amount;
        if (message.decred_tree != null && message.hasOwnProperty("decred_tree"))
            object.decred_tree = message.decred_tree;
        if (message.witness != null && message.hasOwnProperty("witness"))
            object.witness = options.bytes === String ? $util.base64.encode(message.witness, 0, message.witness.length) : options.bytes === Array ? Array.prototype.slice.call(message.witness) : message.witness;
        if (message.ownership_proof != null && message.hasOwnProperty("ownership_proof"))
            object.ownership_proof = options.bytes === String ? $util.base64.encode(message.ownership_proof, 0, message.ownership_proof.length) : options.bytes === Array ? Array.prototype.slice.call(message.ownership_proof) : message.ownership_proof;
        if (message.commitment_data != null && message.hasOwnProperty("commitment_data"))
            object.commitment_data = options.bytes === String ? $util.base64.encode(message.commitment_data, 0, message.commitment_data.length) : options.bytes === Array ? Array.prototype.slice.call(message.commitment_data) : message.commitment_data;
        if (message.orig_hash != null && message.hasOwnProperty("orig_hash"))
            object.orig_hash = options.bytes === String ? $util.base64.encode(message.orig_hash, 0, message.orig_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.orig_hash) : message.orig_hash;
        if (message.orig_index != null && message.hasOwnProperty("orig_index"))
            object.orig_index = message.orig_index;
        if (message.decred_staking_spend != null && message.hasOwnProperty("decred_staking_spend"))
            object.decred_staking_spend = options.enums === String ? $root.DecredStakingSpendType[message.decred_staking_spend] : message.decred_staking_spend;
        if (message.script_pubkey != null && message.hasOwnProperty("script_pubkey"))
            object.script_pubkey = options.bytes === String ? $util.base64.encode(message.script_pubkey, 0, message.script_pubkey.length) : options.bytes === Array ? Array.prototype.slice.call(message.script_pubkey) : message.script_pubkey;
        return object;
    };

    TxInput.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return TxInput;
})();

$root.TxOutput = (function() {

    function TxOutput(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    TxOutput.prototype.address = "";
    TxOutput.prototype.address_n = $util.emptyArray;
    TxOutput.prototype.amount = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    TxOutput.prototype.script_type = 0;
    TxOutput.prototype.multisig = null;
    TxOutput.prototype.op_return_data = $util.newBuffer([]);
    TxOutput.prototype.orig_hash = $util.newBuffer([]);
    TxOutput.prototype.orig_index = 0;

    TxOutput.create = function create(properties) {
        return new TxOutput(properties);
    };

    TxOutput.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address != null && Object.hasOwnProperty.call(message, "address"))
            writer.uint32(10).string(message.address);
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(16).uint32(message.address_n[i]);
        writer.uint32(24).uint64(message.amount);
        if (message.script_type != null && Object.hasOwnProperty.call(message, "script_type"))
            writer.uint32(32).int32(message.script_type);
        if (message.multisig != null && Object.hasOwnProperty.call(message, "multisig"))
            $root.MultisigRedeemScriptType.encode(message.multisig, writer.uint32(42).fork()).ldelim();
        if (message.op_return_data != null && Object.hasOwnProperty.call(message, "op_return_data"))
            writer.uint32(50).bytes(message.op_return_data);
        if (message.orig_hash != null && Object.hasOwnProperty.call(message, "orig_hash"))
            writer.uint32(82).bytes(message.orig_hash);
        if (message.orig_index != null && Object.hasOwnProperty.call(message, "orig_index"))
            writer.uint32(88).uint32(message.orig_index);
        return writer;
    };

    TxOutput.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    TxOutput.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TxOutput();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.string();
                break;
            case 2:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 3:
                message.amount = reader.uint64();
                break;
            case 4:
                message.script_type = reader.int32();
                break;
            case 5:
                message.multisig = $root.MultisigRedeemScriptType.decode(reader, reader.uint32());
                break;
            case 6:
                message.op_return_data = reader.bytes();
                break;
            case 10:
                message.orig_hash = reader.bytes();
                break;
            case 11:
                message.orig_index = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("amount"))
            throw $util.ProtocolError("missing required 'amount'", { instance: message });
        return message;
    };

    TxOutput.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    TxOutput.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address != null && message.hasOwnProperty("address"))
            if (!$util.isString(message.address))
                return "address: string expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
            return "amount: integer|Long expected";
        if (message.script_type != null && message.hasOwnProperty("script_type"))
            switch (message.script_type) {
            default:
                return "script_type: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
                break;
            }
        if (message.multisig != null && message.hasOwnProperty("multisig")) {
            var error = $root.MultisigRedeemScriptType.verify(message.multisig);
            if (error)
                return "multisig." + error;
        }
        if (message.op_return_data != null && message.hasOwnProperty("op_return_data"))
            if (!(message.op_return_data && typeof message.op_return_data.length === "number" || $util.isString(message.op_return_data)))
                return "op_return_data: buffer expected";
        if (message.orig_hash != null && message.hasOwnProperty("orig_hash"))
            if (!(message.orig_hash && typeof message.orig_hash.length === "number" || $util.isString(message.orig_hash)))
                return "orig_hash: buffer expected";
        if (message.orig_index != null && message.hasOwnProperty("orig_index"))
            if (!$util.isInteger(message.orig_index))
                return "orig_index: integer expected";
        return null;
    };

    TxOutput.fromObject = function fromObject(object) {
        if (object instanceof $root.TxOutput)
            return object;
        var message = new $root.TxOutput();
        if (object.address != null)
            message.address = String(object.address);
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".TxOutput.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.amount != null)
            if ($util.Long)
                (message.amount = $util.Long.fromValue(object.amount)).unsigned = true;
            else if (typeof object.amount === "string")
                message.amount = parseInt(object.amount, 10);
            else if (typeof object.amount === "number")
                message.amount = object.amount;
            else if (typeof object.amount === "object")
                message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber(true);
        switch (object.script_type) {
        case "PAYTOADDRESS":
        case 0:
            message.script_type = 0;
            break;
        case "PAYTOSCRIPTHASH":
        case 1:
            message.script_type = 1;
            break;
        case "PAYTOMULTISIG":
        case 2:
            message.script_type = 2;
            break;
        case "PAYTOOPRETURN":
        case 3:
            message.script_type = 3;
            break;
        case "PAYTOWITNESS":
        case 4:
            message.script_type = 4;
            break;
        case "PAYTOP2SHWITNESS":
        case 5:
            message.script_type = 5;
            break;
        case "PAYTOTAPROOT":
        case 6:
            message.script_type = 6;
            break;
        }
        if (object.multisig != null) {
            if (typeof object.multisig !== "object")
                throw TypeError(".TxOutput.multisig: object expected");
            message.multisig = $root.MultisigRedeemScriptType.fromObject(object.multisig);
        }
        if (object.op_return_data != null)
            if (typeof object.op_return_data === "string")
                $util.base64.decode(object.op_return_data, message.op_return_data = $util.newBuffer($util.base64.length(object.op_return_data)), 0);
            else if (object.op_return_data.length)
                message.op_return_data = object.op_return_data;
        if (object.orig_hash != null)
            if (typeof object.orig_hash === "string")
                $util.base64.decode(object.orig_hash, message.orig_hash = $util.newBuffer($util.base64.length(object.orig_hash)), 0);
            else if (object.orig_hash.length)
                message.orig_hash = object.orig_hash;
        if (object.orig_index != null)
            message.orig_index = object.orig_index >>> 0;
        return message;
    };

    TxOutput.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            object.address = "";
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.amount = options.longs === String ? "0" : 0;
            object.script_type = options.enums === String ? "PAYTOADDRESS" : 0;
            object.multisig = null;
            if (options.bytes === String)
                object.op_return_data = "";
            else {
                object.op_return_data = [];
                if (options.bytes !== Array)
                    object.op_return_data = $util.newBuffer(object.op_return_data);
            }
            if (options.bytes === String)
                object.orig_hash = "";
            else {
                object.orig_hash = [];
                if (options.bytes !== Array)
                    object.orig_hash = $util.newBuffer(object.orig_hash);
            }
            object.orig_index = 0;
        }
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.amount != null && message.hasOwnProperty("amount"))
            if (typeof message.amount === "number")
                object.amount = options.longs === String ? String(message.amount) : message.amount;
            else
                object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber(true) : message.amount;
        if (message.script_type != null && message.hasOwnProperty("script_type"))
            object.script_type = options.enums === String ? $root.OutputScriptType[message.script_type] : message.script_type;
        if (message.multisig != null && message.hasOwnProperty("multisig"))
            object.multisig = $root.MultisigRedeemScriptType.toObject(message.multisig, options);
        if (message.op_return_data != null && message.hasOwnProperty("op_return_data"))
            object.op_return_data = options.bytes === String ? $util.base64.encode(message.op_return_data, 0, message.op_return_data.length) : options.bytes === Array ? Array.prototype.slice.call(message.op_return_data) : message.op_return_data;
        if (message.orig_hash != null && message.hasOwnProperty("orig_hash"))
            object.orig_hash = options.bytes === String ? $util.base64.encode(message.orig_hash, 0, message.orig_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.orig_hash) : message.orig_hash;
        if (message.orig_index != null && message.hasOwnProperty("orig_index"))
            object.orig_index = message.orig_index;
        return object;
    };

    TxOutput.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return TxOutput;
})();

$root.PrevTx = (function() {

    function PrevTx(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    PrevTx.prototype.version = 0;
    PrevTx.prototype.lock_time = 0;
    PrevTx.prototype.inputs_count = 0;
    PrevTx.prototype.outputs_count = 0;
    PrevTx.prototype.extra_data_len = 0;
    PrevTx.prototype.expiry = 0;
    PrevTx.prototype.version_group_id = 0;
    PrevTx.prototype.timestamp = 0;
    PrevTx.prototype.branch_id = 0;

    PrevTx.create = function create(properties) {
        return new PrevTx(properties);
    };

    PrevTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).uint32(message.version);
        writer.uint32(32).uint32(message.lock_time);
        writer.uint32(48).uint32(message.inputs_count);
        writer.uint32(56).uint32(message.outputs_count);
        if (message.extra_data_len != null && Object.hasOwnProperty.call(message, "extra_data_len"))
            writer.uint32(72).uint32(message.extra_data_len);
        if (message.expiry != null && Object.hasOwnProperty.call(message, "expiry"))
            writer.uint32(80).uint32(message.expiry);
        if (message.version_group_id != null && Object.hasOwnProperty.call(message, "version_group_id"))
            writer.uint32(96).uint32(message.version_group_id);
        if (message.timestamp != null && Object.hasOwnProperty.call(message, "timestamp"))
            writer.uint32(104).uint32(message.timestamp);
        if (message.branch_id != null && Object.hasOwnProperty.call(message, "branch_id"))
            writer.uint32(112).uint32(message.branch_id);
        return writer;
    };

    PrevTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    PrevTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.PrevTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.version = reader.uint32();
                break;
            case 4:
                message.lock_time = reader.uint32();
                break;
            case 6:
                message.inputs_count = reader.uint32();
                break;
            case 7:
                message.outputs_count = reader.uint32();
                break;
            case 9:
                message.extra_data_len = reader.uint32();
                break;
            case 10:
                message.expiry = reader.uint32();
                break;
            case 12:
                message.version_group_id = reader.uint32();
                break;
            case 13:
                message.timestamp = reader.uint32();
                break;
            case 14:
                message.branch_id = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("version"))
            throw $util.ProtocolError("missing required 'version'", { instance: message });
        if (!message.hasOwnProperty("lock_time"))
            throw $util.ProtocolError("missing required 'lock_time'", { instance: message });
        if (!message.hasOwnProperty("inputs_count"))
            throw $util.ProtocolError("missing required 'inputs_count'", { instance: message });
        if (!message.hasOwnProperty("outputs_count"))
            throw $util.ProtocolError("missing required 'outputs_count'", { instance: message });
        return message;
    };

    PrevTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    PrevTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isInteger(message.version))
            return "version: integer expected";
        if (!$util.isInteger(message.lock_time))
            return "lock_time: integer expected";
        if (!$util.isInteger(message.inputs_count))
            return "inputs_count: integer expected";
        if (!$util.isInteger(message.outputs_count))
            return "outputs_count: integer expected";
        if (message.extra_data_len != null && message.hasOwnProperty("extra_data_len"))
            if (!$util.isInteger(message.extra_data_len))
                return "extra_data_len: integer expected";
        if (message.expiry != null && message.hasOwnProperty("expiry"))
            if (!$util.isInteger(message.expiry))
                return "expiry: integer expected";
        if (message.version_group_id != null && message.hasOwnProperty("version_group_id"))
            if (!$util.isInteger(message.version_group_id))
                return "version_group_id: integer expected";
        if (message.timestamp != null && message.hasOwnProperty("timestamp"))
            if (!$util.isInteger(message.timestamp))
                return "timestamp: integer expected";
        if (message.branch_id != null && message.hasOwnProperty("branch_id"))
            if (!$util.isInteger(message.branch_id))
                return "branch_id: integer expected";
        return null;
    };

    PrevTx.fromObject = function fromObject(object) {
        if (object instanceof $root.PrevTx)
            return object;
        var message = new $root.PrevTx();
        if (object.version != null)
            message.version = object.version >>> 0;
        if (object.lock_time != null)
            message.lock_time = object.lock_time >>> 0;
        if (object.inputs_count != null)
            message.inputs_count = object.inputs_count >>> 0;
        if (object.outputs_count != null)
            message.outputs_count = object.outputs_count >>> 0;
        if (object.extra_data_len != null)
            message.extra_data_len = object.extra_data_len >>> 0;
        if (object.expiry != null)
            message.expiry = object.expiry >>> 0;
        if (object.version_group_id != null)
            message.version_group_id = object.version_group_id >>> 0;
        if (object.timestamp != null)
            message.timestamp = object.timestamp >>> 0;
        if (object.branch_id != null)
            message.branch_id = object.branch_id >>> 0;
        return message;
    };

    PrevTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.version = 0;
            object.lock_time = 0;
            object.inputs_count = 0;
            object.outputs_count = 0;
            object.extra_data_len = 0;
            object.expiry = 0;
            object.version_group_id = 0;
            object.timestamp = 0;
            object.branch_id = 0;
        }
        if (message.version != null && message.hasOwnProperty("version"))
            object.version = message.version;
        if (message.lock_time != null && message.hasOwnProperty("lock_time"))
            object.lock_time = message.lock_time;
        if (message.inputs_count != null && message.hasOwnProperty("inputs_count"))
            object.inputs_count = message.inputs_count;
        if (message.outputs_count != null && message.hasOwnProperty("outputs_count"))
            object.outputs_count = message.outputs_count;
        if (message.extra_data_len != null && message.hasOwnProperty("extra_data_len"))
            object.extra_data_len = message.extra_data_len;
        if (message.expiry != null && message.hasOwnProperty("expiry"))
            object.expiry = message.expiry;
        if (message.version_group_id != null && message.hasOwnProperty("version_group_id"))
            object.version_group_id = message.version_group_id;
        if (message.timestamp != null && message.hasOwnProperty("timestamp"))
            object.timestamp = message.timestamp;
        if (message.branch_id != null && message.hasOwnProperty("branch_id"))
            object.branch_id = message.branch_id;
        return object;
    };

    PrevTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return PrevTx;
})();

$root.PrevInput = (function() {

    function PrevInput(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    PrevInput.prototype.prev_hash = $util.newBuffer([]);
    PrevInput.prototype.prev_index = 0;
    PrevInput.prototype.script_sig = $util.newBuffer([]);
    PrevInput.prototype.sequence = 0;
    PrevInput.prototype.decred_tree = 0;

    PrevInput.create = function create(properties) {
        return new PrevInput(properties);
    };

    PrevInput.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(18).bytes(message.prev_hash);
        writer.uint32(24).uint32(message.prev_index);
        writer.uint32(34).bytes(message.script_sig);
        writer.uint32(40).uint32(message.sequence);
        if (message.decred_tree != null && Object.hasOwnProperty.call(message, "decred_tree"))
            writer.uint32(72).uint32(message.decred_tree);
        return writer;
    };

    PrevInput.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    PrevInput.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.PrevInput();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 2:
                message.prev_hash = reader.bytes();
                break;
            case 3:
                message.prev_index = reader.uint32();
                break;
            case 4:
                message.script_sig = reader.bytes();
                break;
            case 5:
                message.sequence = reader.uint32();
                break;
            case 9:
                message.decred_tree = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("prev_hash"))
            throw $util.ProtocolError("missing required 'prev_hash'", { instance: message });
        if (!message.hasOwnProperty("prev_index"))
            throw $util.ProtocolError("missing required 'prev_index'", { instance: message });
        if (!message.hasOwnProperty("script_sig"))
            throw $util.ProtocolError("missing required 'script_sig'", { instance: message });
        if (!message.hasOwnProperty("sequence"))
            throw $util.ProtocolError("missing required 'sequence'", { instance: message });
        return message;
    };

    PrevInput.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    PrevInput.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.prev_hash && typeof message.prev_hash.length === "number" || $util.isString(message.prev_hash)))
            return "prev_hash: buffer expected";
        if (!$util.isInteger(message.prev_index))
            return "prev_index: integer expected";
        if (!(message.script_sig && typeof message.script_sig.length === "number" || $util.isString(message.script_sig)))
            return "script_sig: buffer expected";
        if (!$util.isInteger(message.sequence))
            return "sequence: integer expected";
        if (message.decred_tree != null && message.hasOwnProperty("decred_tree"))
            if (!$util.isInteger(message.decred_tree))
                return "decred_tree: integer expected";
        return null;
    };

    PrevInput.fromObject = function fromObject(object) {
        if (object instanceof $root.PrevInput)
            return object;
        var message = new $root.PrevInput();
        if (object.prev_hash != null)
            if (typeof object.prev_hash === "string")
                $util.base64.decode(object.prev_hash, message.prev_hash = $util.newBuffer($util.base64.length(object.prev_hash)), 0);
            else if (object.prev_hash.length)
                message.prev_hash = object.prev_hash;
        if (object.prev_index != null)
            message.prev_index = object.prev_index >>> 0;
        if (object.script_sig != null)
            if (typeof object.script_sig === "string")
                $util.base64.decode(object.script_sig, message.script_sig = $util.newBuffer($util.base64.length(object.script_sig)), 0);
            else if (object.script_sig.length)
                message.script_sig = object.script_sig;
        if (object.sequence != null)
            message.sequence = object.sequence >>> 0;
        if (object.decred_tree != null)
            message.decred_tree = object.decred_tree >>> 0;
        return message;
    };

    PrevInput.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.prev_hash = "";
            else {
                object.prev_hash = [];
                if (options.bytes !== Array)
                    object.prev_hash = $util.newBuffer(object.prev_hash);
            }
            object.prev_index = 0;
            if (options.bytes === String)
                object.script_sig = "";
            else {
                object.script_sig = [];
                if (options.bytes !== Array)
                    object.script_sig = $util.newBuffer(object.script_sig);
            }
            object.sequence = 0;
            object.decred_tree = 0;
        }
        if (message.prev_hash != null && message.hasOwnProperty("prev_hash"))
            object.prev_hash = options.bytes === String ? $util.base64.encode(message.prev_hash, 0, message.prev_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.prev_hash) : message.prev_hash;
        if (message.prev_index != null && message.hasOwnProperty("prev_index"))
            object.prev_index = message.prev_index;
        if (message.script_sig != null && message.hasOwnProperty("script_sig"))
            object.script_sig = options.bytes === String ? $util.base64.encode(message.script_sig, 0, message.script_sig.length) : options.bytes === Array ? Array.prototype.slice.call(message.script_sig) : message.script_sig;
        if (message.sequence != null && message.hasOwnProperty("sequence"))
            object.sequence = message.sequence;
        if (message.decred_tree != null && message.hasOwnProperty("decred_tree"))
            object.decred_tree = message.decred_tree;
        return object;
    };

    PrevInput.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return PrevInput;
})();

$root.PrevOutput = (function() {

    function PrevOutput(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    PrevOutput.prototype.amount = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    PrevOutput.prototype.script_pubkey = $util.newBuffer([]);
    PrevOutput.prototype.decred_script_version = 0;

    PrevOutput.create = function create(properties) {
        return new PrevOutput(properties);
    };

    PrevOutput.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).uint64(message.amount);
        writer.uint32(18).bytes(message.script_pubkey);
        if (message.decred_script_version != null && Object.hasOwnProperty.call(message, "decred_script_version"))
            writer.uint32(24).uint32(message.decred_script_version);
        return writer;
    };

    PrevOutput.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    PrevOutput.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.PrevOutput();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.amount = reader.uint64();
                break;
            case 2:
                message.script_pubkey = reader.bytes();
                break;
            case 3:
                message.decred_script_version = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("amount"))
            throw $util.ProtocolError("missing required 'amount'", { instance: message });
        if (!message.hasOwnProperty("script_pubkey"))
            throw $util.ProtocolError("missing required 'script_pubkey'", { instance: message });
        return message;
    };

    PrevOutput.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    PrevOutput.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
            return "amount: integer|Long expected";
        if (!(message.script_pubkey && typeof message.script_pubkey.length === "number" || $util.isString(message.script_pubkey)))
            return "script_pubkey: buffer expected";
        if (message.decred_script_version != null && message.hasOwnProperty("decred_script_version"))
            if (!$util.isInteger(message.decred_script_version))
                return "decred_script_version: integer expected";
        return null;
    };

    PrevOutput.fromObject = function fromObject(object) {
        if (object instanceof $root.PrevOutput)
            return object;
        var message = new $root.PrevOutput();
        if (object.amount != null)
            if ($util.Long)
                (message.amount = $util.Long.fromValue(object.amount)).unsigned = true;
            else if (typeof object.amount === "string")
                message.amount = parseInt(object.amount, 10);
            else if (typeof object.amount === "number")
                message.amount = object.amount;
            else if (typeof object.amount === "object")
                message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber(true);
        if (object.script_pubkey != null)
            if (typeof object.script_pubkey === "string")
                $util.base64.decode(object.script_pubkey, message.script_pubkey = $util.newBuffer($util.base64.length(object.script_pubkey)), 0);
            else if (object.script_pubkey.length)
                message.script_pubkey = object.script_pubkey;
        if (object.decred_script_version != null)
            message.decred_script_version = object.decred_script_version >>> 0;
        return message;
    };

    PrevOutput.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.amount = options.longs === String ? "0" : 0;
            if (options.bytes === String)
                object.script_pubkey = "";
            else {
                object.script_pubkey = [];
                if (options.bytes !== Array)
                    object.script_pubkey = $util.newBuffer(object.script_pubkey);
            }
            object.decred_script_version = 0;
        }
        if (message.amount != null && message.hasOwnProperty("amount"))
            if (typeof message.amount === "number")
                object.amount = options.longs === String ? String(message.amount) : message.amount;
            else
                object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber(true) : message.amount;
        if (message.script_pubkey != null && message.hasOwnProperty("script_pubkey"))
            object.script_pubkey = options.bytes === String ? $util.base64.encode(message.script_pubkey, 0, message.script_pubkey.length) : options.bytes === Array ? Array.prototype.slice.call(message.script_pubkey) : message.script_pubkey;
        if (message.decred_script_version != null && message.hasOwnProperty("decred_script_version"))
            object.decred_script_version = message.decred_script_version;
        return object;
    };

    PrevOutput.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return PrevOutput;
})();

$root.TxAckInput = (function() {

    function TxAckInput(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    TxAckInput.prototype.tx = null;

    TxAckInput.create = function create(properties) {
        return new TxAckInput(properties);
    };

    TxAckInput.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        $root.TxAckInput.TxAckInputWrapper.encode(message.tx, writer.uint32(10).fork()).ldelim();
        return writer;
    };

    TxAckInput.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    TxAckInput.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TxAckInput();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.tx = $root.TxAckInput.TxAckInputWrapper.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("tx"))
            throw $util.ProtocolError("missing required 'tx'", { instance: message });
        return message;
    };

    TxAckInput.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    TxAckInput.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        {
            var error = $root.TxAckInput.TxAckInputWrapper.verify(message.tx);
            if (error)
                return "tx." + error;
        }
        return null;
    };

    TxAckInput.fromObject = function fromObject(object) {
        if (object instanceof $root.TxAckInput)
            return object;
        var message = new $root.TxAckInput();
        if (object.tx != null) {
            if (typeof object.tx !== "object")
                throw TypeError(".TxAckInput.tx: object expected");
            message.tx = $root.TxAckInput.TxAckInputWrapper.fromObject(object.tx);
        }
        return message;
    };

    TxAckInput.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.tx = null;
        if (message.tx != null && message.hasOwnProperty("tx"))
            object.tx = $root.TxAckInput.TxAckInputWrapper.toObject(message.tx, options);
        return object;
    };

    TxAckInput.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    TxAckInput.TxAckInputWrapper = (function() {

        function TxAckInputWrapper(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        TxAckInputWrapper.prototype.input = null;

        TxAckInputWrapper.create = function create(properties) {
            return new TxAckInputWrapper(properties);
        };

        TxAckInputWrapper.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            $root.TxInput.encode(message.input, writer.uint32(18).fork()).ldelim();
            return writer;
        };

        TxAckInputWrapper.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        TxAckInputWrapper.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TxAckInput.TxAckInputWrapper();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 2:
                    message.input = $root.TxInput.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("input"))
                throw $util.ProtocolError("missing required 'input'", { instance: message });
            return message;
        };

        TxAckInputWrapper.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        TxAckInputWrapper.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            {
                var error = $root.TxInput.verify(message.input);
                if (error)
                    return "input." + error;
            }
            return null;
        };

        TxAckInputWrapper.fromObject = function fromObject(object) {
            if (object instanceof $root.TxAckInput.TxAckInputWrapper)
                return object;
            var message = new $root.TxAckInput.TxAckInputWrapper();
            if (object.input != null) {
                if (typeof object.input !== "object")
                    throw TypeError(".TxAckInput.TxAckInputWrapper.input: object expected");
                message.input = $root.TxInput.fromObject(object.input);
            }
            return message;
        };

        TxAckInputWrapper.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.input = null;
            if (message.input != null && message.hasOwnProperty("input"))
                object.input = $root.TxInput.toObject(message.input, options);
            return object;
        };

        TxAckInputWrapper.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TxAckInputWrapper;
    })();

    return TxAckInput;
})();

$root.TxAckOutput = (function() {

    function TxAckOutput(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    TxAckOutput.prototype.tx = null;

    TxAckOutput.create = function create(properties) {
        return new TxAckOutput(properties);
    };

    TxAckOutput.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        $root.TxAckOutput.TxAckOutputWrapper.encode(message.tx, writer.uint32(10).fork()).ldelim();
        return writer;
    };

    TxAckOutput.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    TxAckOutput.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TxAckOutput();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.tx = $root.TxAckOutput.TxAckOutputWrapper.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("tx"))
            throw $util.ProtocolError("missing required 'tx'", { instance: message });
        return message;
    };

    TxAckOutput.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    TxAckOutput.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        {
            var error = $root.TxAckOutput.TxAckOutputWrapper.verify(message.tx);
            if (error)
                return "tx." + error;
        }
        return null;
    };

    TxAckOutput.fromObject = function fromObject(object) {
        if (object instanceof $root.TxAckOutput)
            return object;
        var message = new $root.TxAckOutput();
        if (object.tx != null) {
            if (typeof object.tx !== "object")
                throw TypeError(".TxAckOutput.tx: object expected");
            message.tx = $root.TxAckOutput.TxAckOutputWrapper.fromObject(object.tx);
        }
        return message;
    };

    TxAckOutput.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.tx = null;
        if (message.tx != null && message.hasOwnProperty("tx"))
            object.tx = $root.TxAckOutput.TxAckOutputWrapper.toObject(message.tx, options);
        return object;
    };

    TxAckOutput.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    TxAckOutput.TxAckOutputWrapper = (function() {

        function TxAckOutputWrapper(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        TxAckOutputWrapper.prototype.output = null;

        TxAckOutputWrapper.create = function create(properties) {
            return new TxAckOutputWrapper(properties);
        };

        TxAckOutputWrapper.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            $root.TxOutput.encode(message.output, writer.uint32(42).fork()).ldelim();
            return writer;
        };

        TxAckOutputWrapper.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        TxAckOutputWrapper.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TxAckOutput.TxAckOutputWrapper();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 5:
                    message.output = $root.TxOutput.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("output"))
                throw $util.ProtocolError("missing required 'output'", { instance: message });
            return message;
        };

        TxAckOutputWrapper.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        TxAckOutputWrapper.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            {
                var error = $root.TxOutput.verify(message.output);
                if (error)
                    return "output." + error;
            }
            return null;
        };

        TxAckOutputWrapper.fromObject = function fromObject(object) {
            if (object instanceof $root.TxAckOutput.TxAckOutputWrapper)
                return object;
            var message = new $root.TxAckOutput.TxAckOutputWrapper();
            if (object.output != null) {
                if (typeof object.output !== "object")
                    throw TypeError(".TxAckOutput.TxAckOutputWrapper.output: object expected");
                message.output = $root.TxOutput.fromObject(object.output);
            }
            return message;
        };

        TxAckOutputWrapper.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.output = null;
            if (message.output != null && message.hasOwnProperty("output"))
                object.output = $root.TxOutput.toObject(message.output, options);
            return object;
        };

        TxAckOutputWrapper.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TxAckOutputWrapper;
    })();

    return TxAckOutput;
})();

$root.TxAckPrevMeta = (function() {

    function TxAckPrevMeta(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    TxAckPrevMeta.prototype.tx = null;

    TxAckPrevMeta.create = function create(properties) {
        return new TxAckPrevMeta(properties);
    };

    TxAckPrevMeta.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        $root.PrevTx.encode(message.tx, writer.uint32(10).fork()).ldelim();
        return writer;
    };

    TxAckPrevMeta.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    TxAckPrevMeta.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TxAckPrevMeta();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.tx = $root.PrevTx.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("tx"))
            throw $util.ProtocolError("missing required 'tx'", { instance: message });
        return message;
    };

    TxAckPrevMeta.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    TxAckPrevMeta.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        {
            var error = $root.PrevTx.verify(message.tx);
            if (error)
                return "tx." + error;
        }
        return null;
    };

    TxAckPrevMeta.fromObject = function fromObject(object) {
        if (object instanceof $root.TxAckPrevMeta)
            return object;
        var message = new $root.TxAckPrevMeta();
        if (object.tx != null) {
            if (typeof object.tx !== "object")
                throw TypeError(".TxAckPrevMeta.tx: object expected");
            message.tx = $root.PrevTx.fromObject(object.tx);
        }
        return message;
    };

    TxAckPrevMeta.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.tx = null;
        if (message.tx != null && message.hasOwnProperty("tx"))
            object.tx = $root.PrevTx.toObject(message.tx, options);
        return object;
    };

    TxAckPrevMeta.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return TxAckPrevMeta;
})();

$root.TxAckPrevInput = (function() {

    function TxAckPrevInput(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    TxAckPrevInput.prototype.tx = null;

    TxAckPrevInput.create = function create(properties) {
        return new TxAckPrevInput(properties);
    };

    TxAckPrevInput.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        $root.TxAckPrevInput.TxAckPrevInputWrapper.encode(message.tx, writer.uint32(10).fork()).ldelim();
        return writer;
    };

    TxAckPrevInput.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    TxAckPrevInput.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TxAckPrevInput();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.tx = $root.TxAckPrevInput.TxAckPrevInputWrapper.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("tx"))
            throw $util.ProtocolError("missing required 'tx'", { instance: message });
        return message;
    };

    TxAckPrevInput.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    TxAckPrevInput.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        {
            var error = $root.TxAckPrevInput.TxAckPrevInputWrapper.verify(message.tx);
            if (error)
                return "tx." + error;
        }
        return null;
    };

    TxAckPrevInput.fromObject = function fromObject(object) {
        if (object instanceof $root.TxAckPrevInput)
            return object;
        var message = new $root.TxAckPrevInput();
        if (object.tx != null) {
            if (typeof object.tx !== "object")
                throw TypeError(".TxAckPrevInput.tx: object expected");
            message.tx = $root.TxAckPrevInput.TxAckPrevInputWrapper.fromObject(object.tx);
        }
        return message;
    };

    TxAckPrevInput.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.tx = null;
        if (message.tx != null && message.hasOwnProperty("tx"))
            object.tx = $root.TxAckPrevInput.TxAckPrevInputWrapper.toObject(message.tx, options);
        return object;
    };

    TxAckPrevInput.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    TxAckPrevInput.TxAckPrevInputWrapper = (function() {

        function TxAckPrevInputWrapper(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        TxAckPrevInputWrapper.prototype.input = null;

        TxAckPrevInputWrapper.create = function create(properties) {
            return new TxAckPrevInputWrapper(properties);
        };

        TxAckPrevInputWrapper.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            $root.PrevInput.encode(message.input, writer.uint32(18).fork()).ldelim();
            return writer;
        };

        TxAckPrevInputWrapper.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        TxAckPrevInputWrapper.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TxAckPrevInput.TxAckPrevInputWrapper();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 2:
                    message.input = $root.PrevInput.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("input"))
                throw $util.ProtocolError("missing required 'input'", { instance: message });
            return message;
        };

        TxAckPrevInputWrapper.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        TxAckPrevInputWrapper.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            {
                var error = $root.PrevInput.verify(message.input);
                if (error)
                    return "input." + error;
            }
            return null;
        };

        TxAckPrevInputWrapper.fromObject = function fromObject(object) {
            if (object instanceof $root.TxAckPrevInput.TxAckPrevInputWrapper)
                return object;
            var message = new $root.TxAckPrevInput.TxAckPrevInputWrapper();
            if (object.input != null) {
                if (typeof object.input !== "object")
                    throw TypeError(".TxAckPrevInput.TxAckPrevInputWrapper.input: object expected");
                message.input = $root.PrevInput.fromObject(object.input);
            }
            return message;
        };

        TxAckPrevInputWrapper.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.input = null;
            if (message.input != null && message.hasOwnProperty("input"))
                object.input = $root.PrevInput.toObject(message.input, options);
            return object;
        };

        TxAckPrevInputWrapper.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TxAckPrevInputWrapper;
    })();

    return TxAckPrevInput;
})();

$root.TxAckPrevOutput = (function() {

    function TxAckPrevOutput(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    TxAckPrevOutput.prototype.tx = null;

    TxAckPrevOutput.create = function create(properties) {
        return new TxAckPrevOutput(properties);
    };

    TxAckPrevOutput.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        $root.TxAckPrevOutput.TxAckPrevOutputWrapper.encode(message.tx, writer.uint32(10).fork()).ldelim();
        return writer;
    };

    TxAckPrevOutput.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    TxAckPrevOutput.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TxAckPrevOutput();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.tx = $root.TxAckPrevOutput.TxAckPrevOutputWrapper.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("tx"))
            throw $util.ProtocolError("missing required 'tx'", { instance: message });
        return message;
    };

    TxAckPrevOutput.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    TxAckPrevOutput.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        {
            var error = $root.TxAckPrevOutput.TxAckPrevOutputWrapper.verify(message.tx);
            if (error)
                return "tx." + error;
        }
        return null;
    };

    TxAckPrevOutput.fromObject = function fromObject(object) {
        if (object instanceof $root.TxAckPrevOutput)
            return object;
        var message = new $root.TxAckPrevOutput();
        if (object.tx != null) {
            if (typeof object.tx !== "object")
                throw TypeError(".TxAckPrevOutput.tx: object expected");
            message.tx = $root.TxAckPrevOutput.TxAckPrevOutputWrapper.fromObject(object.tx);
        }
        return message;
    };

    TxAckPrevOutput.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.tx = null;
        if (message.tx != null && message.hasOwnProperty("tx"))
            object.tx = $root.TxAckPrevOutput.TxAckPrevOutputWrapper.toObject(message.tx, options);
        return object;
    };

    TxAckPrevOutput.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    TxAckPrevOutput.TxAckPrevOutputWrapper = (function() {

        function TxAckPrevOutputWrapper(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        TxAckPrevOutputWrapper.prototype.output = null;

        TxAckPrevOutputWrapper.create = function create(properties) {
            return new TxAckPrevOutputWrapper(properties);
        };

        TxAckPrevOutputWrapper.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            $root.PrevOutput.encode(message.output, writer.uint32(26).fork()).ldelim();
            return writer;
        };

        TxAckPrevOutputWrapper.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        TxAckPrevOutputWrapper.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TxAckPrevOutput.TxAckPrevOutputWrapper();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 3:
                    message.output = $root.PrevOutput.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("output"))
                throw $util.ProtocolError("missing required 'output'", { instance: message });
            return message;
        };

        TxAckPrevOutputWrapper.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        TxAckPrevOutputWrapper.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            {
                var error = $root.PrevOutput.verify(message.output);
                if (error)
                    return "output." + error;
            }
            return null;
        };

        TxAckPrevOutputWrapper.fromObject = function fromObject(object) {
            if (object instanceof $root.TxAckPrevOutput.TxAckPrevOutputWrapper)
                return object;
            var message = new $root.TxAckPrevOutput.TxAckPrevOutputWrapper();
            if (object.output != null) {
                if (typeof object.output !== "object")
                    throw TypeError(".TxAckPrevOutput.TxAckPrevOutputWrapper.output: object expected");
                message.output = $root.PrevOutput.fromObject(object.output);
            }
            return message;
        };

        TxAckPrevOutputWrapper.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.output = null;
            if (message.output != null && message.hasOwnProperty("output"))
                object.output = $root.PrevOutput.toObject(message.output, options);
            return object;
        };

        TxAckPrevOutputWrapper.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TxAckPrevOutputWrapper;
    })();

    return TxAckPrevOutput;
})();

$root.TxAckPrevExtraData = (function() {

    function TxAckPrevExtraData(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    TxAckPrevExtraData.prototype.tx = null;

    TxAckPrevExtraData.create = function create(properties) {
        return new TxAckPrevExtraData(properties);
    };

    TxAckPrevExtraData.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        $root.TxAckPrevExtraData.TxAckPrevExtraDataWrapper.encode(message.tx, writer.uint32(10).fork()).ldelim();
        return writer;
    };

    TxAckPrevExtraData.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    TxAckPrevExtraData.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TxAckPrevExtraData();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.tx = $root.TxAckPrevExtraData.TxAckPrevExtraDataWrapper.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("tx"))
            throw $util.ProtocolError("missing required 'tx'", { instance: message });
        return message;
    };

    TxAckPrevExtraData.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    TxAckPrevExtraData.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        {
            var error = $root.TxAckPrevExtraData.TxAckPrevExtraDataWrapper.verify(message.tx);
            if (error)
                return "tx." + error;
        }
        return null;
    };

    TxAckPrevExtraData.fromObject = function fromObject(object) {
        if (object instanceof $root.TxAckPrevExtraData)
            return object;
        var message = new $root.TxAckPrevExtraData();
        if (object.tx != null) {
            if (typeof object.tx !== "object")
                throw TypeError(".TxAckPrevExtraData.tx: object expected");
            message.tx = $root.TxAckPrevExtraData.TxAckPrevExtraDataWrapper.fromObject(object.tx);
        }
        return message;
    };

    TxAckPrevExtraData.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.tx = null;
        if (message.tx != null && message.hasOwnProperty("tx"))
            object.tx = $root.TxAckPrevExtraData.TxAckPrevExtraDataWrapper.toObject(message.tx, options);
        return object;
    };

    TxAckPrevExtraData.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    TxAckPrevExtraData.TxAckPrevExtraDataWrapper = (function() {

        function TxAckPrevExtraDataWrapper(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        TxAckPrevExtraDataWrapper.prototype.extra_data_chunk = $util.newBuffer([]);

        TxAckPrevExtraDataWrapper.create = function create(properties) {
            return new TxAckPrevExtraDataWrapper(properties);
        };

        TxAckPrevExtraDataWrapper.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(66).bytes(message.extra_data_chunk);
            return writer;
        };

        TxAckPrevExtraDataWrapper.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        TxAckPrevExtraDataWrapper.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TxAckPrevExtraData.TxAckPrevExtraDataWrapper();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 8:
                    message.extra_data_chunk = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("extra_data_chunk"))
                throw $util.ProtocolError("missing required 'extra_data_chunk'", { instance: message });
            return message;
        };

        TxAckPrevExtraDataWrapper.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        TxAckPrevExtraDataWrapper.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!(message.extra_data_chunk && typeof message.extra_data_chunk.length === "number" || $util.isString(message.extra_data_chunk)))
                return "extra_data_chunk: buffer expected";
            return null;
        };

        TxAckPrevExtraDataWrapper.fromObject = function fromObject(object) {
            if (object instanceof $root.TxAckPrevExtraData.TxAckPrevExtraDataWrapper)
                return object;
            var message = new $root.TxAckPrevExtraData.TxAckPrevExtraDataWrapper();
            if (object.extra_data_chunk != null)
                if (typeof object.extra_data_chunk === "string")
                    $util.base64.decode(object.extra_data_chunk, message.extra_data_chunk = $util.newBuffer($util.base64.length(object.extra_data_chunk)), 0);
                else if (object.extra_data_chunk.length)
                    message.extra_data_chunk = object.extra_data_chunk;
            return message;
        };

        TxAckPrevExtraDataWrapper.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                if (options.bytes === String)
                    object.extra_data_chunk = "";
                else {
                    object.extra_data_chunk = [];
                    if (options.bytes !== Array)
                        object.extra_data_chunk = $util.newBuffer(object.extra_data_chunk);
                }
            if (message.extra_data_chunk != null && message.hasOwnProperty("extra_data_chunk"))
                object.extra_data_chunk = options.bytes === String ? $util.base64.encode(message.extra_data_chunk, 0, message.extra_data_chunk.length) : options.bytes === Array ? Array.prototype.slice.call(message.extra_data_chunk) : message.extra_data_chunk;
            return object;
        };

        TxAckPrevExtraDataWrapper.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TxAckPrevExtraDataWrapper;
    })();

    return TxAckPrevExtraData;
})();

$root.GetOwnershipProof = (function() {

    function GetOwnershipProof(properties) {
        this.address_n = [];
        this.ownership_ids = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    GetOwnershipProof.prototype.address_n = $util.emptyArray;
    GetOwnershipProof.prototype.coin_name = "Bitcoin";
    GetOwnershipProof.prototype.script_type = 3;
    GetOwnershipProof.prototype.multisig = null;
    GetOwnershipProof.prototype.user_confirmation = false;
    GetOwnershipProof.prototype.ownership_ids = $util.emptyArray;
    GetOwnershipProof.prototype.commitment_data = $util.newBuffer([]);

    GetOwnershipProof.create = function create(properties) {
        return new GetOwnershipProof(properties);
    };

    GetOwnershipProof.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.coin_name != null && Object.hasOwnProperty.call(message, "coin_name"))
            writer.uint32(18).string(message.coin_name);
        if (message.script_type != null && Object.hasOwnProperty.call(message, "script_type"))
            writer.uint32(24).int32(message.script_type);
        if (message.multisig != null && Object.hasOwnProperty.call(message, "multisig"))
            $root.MultisigRedeemScriptType.encode(message.multisig, writer.uint32(34).fork()).ldelim();
        if (message.user_confirmation != null && Object.hasOwnProperty.call(message, "user_confirmation"))
            writer.uint32(40).bool(message.user_confirmation);
        if (message.ownership_ids != null && message.ownership_ids.length)
            for (var i = 0; i < message.ownership_ids.length; ++i)
                writer.uint32(50).bytes(message.ownership_ids[i]);
        if (message.commitment_data != null && Object.hasOwnProperty.call(message, "commitment_data"))
            writer.uint32(58).bytes(message.commitment_data);
        return writer;
    };

    GetOwnershipProof.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    GetOwnershipProof.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.GetOwnershipProof();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.coin_name = reader.string();
                break;
            case 3:
                message.script_type = reader.int32();
                break;
            case 4:
                message.multisig = $root.MultisigRedeemScriptType.decode(reader, reader.uint32());
                break;
            case 5:
                message.user_confirmation = reader.bool();
                break;
            case 6:
                if (!(message.ownership_ids && message.ownership_ids.length))
                    message.ownership_ids = [];
                message.ownership_ids.push(reader.bytes());
                break;
            case 7:
                message.commitment_data = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    GetOwnershipProof.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    GetOwnershipProof.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.coin_name != null && message.hasOwnProperty("coin_name"))
            if (!$util.isString(message.coin_name))
                return "coin_name: string expected";
        if (message.script_type != null && message.hasOwnProperty("script_type"))
            switch (message.script_type) {
            default:
                return "script_type: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
                break;
            }
        if (message.multisig != null && message.hasOwnProperty("multisig")) {
            var error = $root.MultisigRedeemScriptType.verify(message.multisig);
            if (error)
                return "multisig." + error;
        }
        if (message.user_confirmation != null && message.hasOwnProperty("user_confirmation"))
            if (typeof message.user_confirmation !== "boolean")
                return "user_confirmation: boolean expected";
        if (message.ownership_ids != null && message.hasOwnProperty("ownership_ids")) {
            if (!Array.isArray(message.ownership_ids))
                return "ownership_ids: array expected";
            for (var i = 0; i < message.ownership_ids.length; ++i)
                if (!(message.ownership_ids[i] && typeof message.ownership_ids[i].length === "number" || $util.isString(message.ownership_ids[i])))
                    return "ownership_ids: buffer[] expected";
        }
        if (message.commitment_data != null && message.hasOwnProperty("commitment_data"))
            if (!(message.commitment_data && typeof message.commitment_data.length === "number" || $util.isString(message.commitment_data)))
                return "commitment_data: buffer expected";
        return null;
    };

    GetOwnershipProof.fromObject = function fromObject(object) {
        if (object instanceof $root.GetOwnershipProof)
            return object;
        var message = new $root.GetOwnershipProof();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".GetOwnershipProof.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.coin_name != null)
            message.coin_name = String(object.coin_name);
        switch (object.script_type) {
        case "SPENDADDRESS":
        case 0:
            message.script_type = 0;
            break;
        case "SPENDMULTISIG":
        case 1:
            message.script_type = 1;
            break;
        case "EXTERNAL":
        case 2:
            message.script_type = 2;
            break;
        case "SPENDWITNESS":
        case 3:
            message.script_type = 3;
            break;
        case "SPENDP2SHWITNESS":
        case 4:
            message.script_type = 4;
            break;
        case "SPENDTAPROOT":
        case 5:
            message.script_type = 5;
            break;
        }
        if (object.multisig != null) {
            if (typeof object.multisig !== "object")
                throw TypeError(".GetOwnershipProof.multisig: object expected");
            message.multisig = $root.MultisigRedeemScriptType.fromObject(object.multisig);
        }
        if (object.user_confirmation != null)
            message.user_confirmation = Boolean(object.user_confirmation);
        if (object.ownership_ids) {
            if (!Array.isArray(object.ownership_ids))
                throw TypeError(".GetOwnershipProof.ownership_ids: array expected");
            message.ownership_ids = [];
            for (var i = 0; i < object.ownership_ids.length; ++i)
                if (typeof object.ownership_ids[i] === "string")
                    $util.base64.decode(object.ownership_ids[i], message.ownership_ids[i] = $util.newBuffer($util.base64.length(object.ownership_ids[i])), 0);
                else if (object.ownership_ids[i].length)
                    message.ownership_ids[i] = object.ownership_ids[i];
        }
        if (object.commitment_data != null)
            if (typeof object.commitment_data === "string")
                $util.base64.decode(object.commitment_data, message.commitment_data = $util.newBuffer($util.base64.length(object.commitment_data)), 0);
            else if (object.commitment_data.length)
                message.commitment_data = object.commitment_data;
        return message;
    };

    GetOwnershipProof.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults) {
            object.address_n = [];
            object.ownership_ids = [];
        }
        if (options.defaults) {
            object.coin_name = "Bitcoin";
            object.script_type = options.enums === String ? "SPENDWITNESS" : 3;
            object.multisig = null;
            object.user_confirmation = false;
            if (options.bytes === String)
                object.commitment_data = "";
            else {
                object.commitment_data = [];
                if (options.bytes !== Array)
                    object.commitment_data = $util.newBuffer(object.commitment_data);
            }
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.coin_name != null && message.hasOwnProperty("coin_name"))
            object.coin_name = message.coin_name;
        if (message.script_type != null && message.hasOwnProperty("script_type"))
            object.script_type = options.enums === String ? $root.InputScriptType[message.script_type] : message.script_type;
        if (message.multisig != null && message.hasOwnProperty("multisig"))
            object.multisig = $root.MultisigRedeemScriptType.toObject(message.multisig, options);
        if (message.user_confirmation != null && message.hasOwnProperty("user_confirmation"))
            object.user_confirmation = message.user_confirmation;
        if (message.ownership_ids && message.ownership_ids.length) {
            object.ownership_ids = [];
            for (var j = 0; j < message.ownership_ids.length; ++j)
                object.ownership_ids[j] = options.bytes === String ? $util.base64.encode(message.ownership_ids[j], 0, message.ownership_ids[j].length) : options.bytes === Array ? Array.prototype.slice.call(message.ownership_ids[j]) : message.ownership_ids[j];
        }
        if (message.commitment_data != null && message.hasOwnProperty("commitment_data"))
            object.commitment_data = options.bytes === String ? $util.base64.encode(message.commitment_data, 0, message.commitment_data.length) : options.bytes === Array ? Array.prototype.slice.call(message.commitment_data) : message.commitment_data;
        return object;
    };

    GetOwnershipProof.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return GetOwnershipProof;
})();

$root.OwnershipProof = (function() {

    function OwnershipProof(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    OwnershipProof.prototype.ownership_proof = $util.newBuffer([]);
    OwnershipProof.prototype.signature = $util.newBuffer([]);

    OwnershipProof.create = function create(properties) {
        return new OwnershipProof(properties);
    };

    OwnershipProof.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.ownership_proof);
        writer.uint32(18).bytes(message.signature);
        return writer;
    };

    OwnershipProof.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    OwnershipProof.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.OwnershipProof();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.ownership_proof = reader.bytes();
                break;
            case 2:
                message.signature = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("ownership_proof"))
            throw $util.ProtocolError("missing required 'ownership_proof'", { instance: message });
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        return message;
    };

    OwnershipProof.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    OwnershipProof.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.ownership_proof && typeof message.ownership_proof.length === "number" || $util.isString(message.ownership_proof)))
            return "ownership_proof: buffer expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        return null;
    };

    OwnershipProof.fromObject = function fromObject(object) {
        if (object instanceof $root.OwnershipProof)
            return object;
        var message = new $root.OwnershipProof();
        if (object.ownership_proof != null)
            if (typeof object.ownership_proof === "string")
                $util.base64.decode(object.ownership_proof, message.ownership_proof = $util.newBuffer($util.base64.length(object.ownership_proof)), 0);
            else if (object.ownership_proof.length)
                message.ownership_proof = object.ownership_proof;
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        return message;
    };

    OwnershipProof.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.ownership_proof = "";
            else {
                object.ownership_proof = [];
                if (options.bytes !== Array)
                    object.ownership_proof = $util.newBuffer(object.ownership_proof);
            }
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
        }
        if (message.ownership_proof != null && message.hasOwnProperty("ownership_proof"))
            object.ownership_proof = options.bytes === String ? $util.base64.encode(message.ownership_proof, 0, message.ownership_proof.length) : options.bytes === Array ? Array.prototype.slice.call(message.ownership_proof) : message.ownership_proof;
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        return object;
    };

    OwnershipProof.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return OwnershipProof;
})();

$root.AuthorizeCoinJoin = (function() {

    function AuthorizeCoinJoin(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    AuthorizeCoinJoin.prototype.coordinator = "";
    AuthorizeCoinJoin.prototype.max_total_fee = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    AuthorizeCoinJoin.prototype.fee_per_anonymity = 0;
    AuthorizeCoinJoin.prototype.address_n = $util.emptyArray;
    AuthorizeCoinJoin.prototype.coin_name = "Bitcoin";
    AuthorizeCoinJoin.prototype.script_type = 0;
    AuthorizeCoinJoin.prototype.amount_unit = 0;

    AuthorizeCoinJoin.create = function create(properties) {
        return new AuthorizeCoinJoin(properties);
    };

    AuthorizeCoinJoin.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.coordinator);
        writer.uint32(16).uint64(message.max_total_fee);
        if (message.fee_per_anonymity != null && Object.hasOwnProperty.call(message, "fee_per_anonymity"))
            writer.uint32(24).uint32(message.fee_per_anonymity);
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(32).uint32(message.address_n[i]);
        if (message.coin_name != null && Object.hasOwnProperty.call(message, "coin_name"))
            writer.uint32(42).string(message.coin_name);
        if (message.script_type != null && Object.hasOwnProperty.call(message, "script_type"))
            writer.uint32(48).int32(message.script_type);
        if (message.amount_unit != null && Object.hasOwnProperty.call(message, "amount_unit"))
            writer.uint32(88).int32(message.amount_unit);
        return writer;
    };

    AuthorizeCoinJoin.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    AuthorizeCoinJoin.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.AuthorizeCoinJoin();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.coordinator = reader.string();
                break;
            case 2:
                message.max_total_fee = reader.uint64();
                break;
            case 3:
                message.fee_per_anonymity = reader.uint32();
                break;
            case 4:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 5:
                message.coin_name = reader.string();
                break;
            case 6:
                message.script_type = reader.int32();
                break;
            case 11:
                message.amount_unit = reader.int32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("coordinator"))
            throw $util.ProtocolError("missing required 'coordinator'", { instance: message });
        if (!message.hasOwnProperty("max_total_fee"))
            throw $util.ProtocolError("missing required 'max_total_fee'", { instance: message });
        return message;
    };

    AuthorizeCoinJoin.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    AuthorizeCoinJoin.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.coordinator))
            return "coordinator: string expected";
        if (!$util.isInteger(message.max_total_fee) && !(message.max_total_fee && $util.isInteger(message.max_total_fee.low) && $util.isInteger(message.max_total_fee.high)))
            return "max_total_fee: integer|Long expected";
        if (message.fee_per_anonymity != null && message.hasOwnProperty("fee_per_anonymity"))
            if (!$util.isInteger(message.fee_per_anonymity))
                return "fee_per_anonymity: integer expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.coin_name != null && message.hasOwnProperty("coin_name"))
            if (!$util.isString(message.coin_name))
                return "coin_name: string expected";
        if (message.script_type != null && message.hasOwnProperty("script_type"))
            switch (message.script_type) {
            default:
                return "script_type: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
                break;
            }
        if (message.amount_unit != null && message.hasOwnProperty("amount_unit"))
            switch (message.amount_unit) {
            default:
                return "amount_unit: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
                break;
            }
        return null;
    };

    AuthorizeCoinJoin.fromObject = function fromObject(object) {
        if (object instanceof $root.AuthorizeCoinJoin)
            return object;
        var message = new $root.AuthorizeCoinJoin();
        if (object.coordinator != null)
            message.coordinator = String(object.coordinator);
        if (object.max_total_fee != null)
            if ($util.Long)
                (message.max_total_fee = $util.Long.fromValue(object.max_total_fee)).unsigned = true;
            else if (typeof object.max_total_fee === "string")
                message.max_total_fee = parseInt(object.max_total_fee, 10);
            else if (typeof object.max_total_fee === "number")
                message.max_total_fee = object.max_total_fee;
            else if (typeof object.max_total_fee === "object")
                message.max_total_fee = new $util.LongBits(object.max_total_fee.low >>> 0, object.max_total_fee.high >>> 0).toNumber(true);
        if (object.fee_per_anonymity != null)
            message.fee_per_anonymity = object.fee_per_anonymity >>> 0;
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".AuthorizeCoinJoin.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.coin_name != null)
            message.coin_name = String(object.coin_name);
        switch (object.script_type) {
        case "SPENDADDRESS":
        case 0:
            message.script_type = 0;
            break;
        case "SPENDMULTISIG":
        case 1:
            message.script_type = 1;
            break;
        case "EXTERNAL":
        case 2:
            message.script_type = 2;
            break;
        case "SPENDWITNESS":
        case 3:
            message.script_type = 3;
            break;
        case "SPENDP2SHWITNESS":
        case 4:
            message.script_type = 4;
            break;
        case "SPENDTAPROOT":
        case 5:
            message.script_type = 5;
            break;
        }
        switch (object.amount_unit) {
        case "BITCOIN":
        case 0:
            message.amount_unit = 0;
            break;
        case "MILLIBITCOIN":
        case 1:
            message.amount_unit = 1;
            break;
        case "MICROBITCOIN":
        case 2:
            message.amount_unit = 2;
            break;
        case "SATOSHI":
        case 3:
            message.amount_unit = 3;
            break;
        }
        return message;
    };

    AuthorizeCoinJoin.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            object.coordinator = "";
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.max_total_fee = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.max_total_fee = options.longs === String ? "0" : 0;
            object.fee_per_anonymity = 0;
            object.coin_name = "Bitcoin";
            object.script_type = options.enums === String ? "SPENDADDRESS" : 0;
            object.amount_unit = options.enums === String ? "BITCOIN" : 0;
        }
        if (message.coordinator != null && message.hasOwnProperty("coordinator"))
            object.coordinator = message.coordinator;
        if (message.max_total_fee != null && message.hasOwnProperty("max_total_fee"))
            if (typeof message.max_total_fee === "number")
                object.max_total_fee = options.longs === String ? String(message.max_total_fee) : message.max_total_fee;
            else
                object.max_total_fee = options.longs === String ? $util.Long.prototype.toString.call(message.max_total_fee) : options.longs === Number ? new $util.LongBits(message.max_total_fee.low >>> 0, message.max_total_fee.high >>> 0).toNumber(true) : message.max_total_fee;
        if (message.fee_per_anonymity != null && message.hasOwnProperty("fee_per_anonymity"))
            object.fee_per_anonymity = message.fee_per_anonymity;
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.coin_name != null && message.hasOwnProperty("coin_name"))
            object.coin_name = message.coin_name;
        if (message.script_type != null && message.hasOwnProperty("script_type"))
            object.script_type = options.enums === String ? $root.InputScriptType[message.script_type] : message.script_type;
        if (message.amount_unit != null && message.hasOwnProperty("amount_unit"))
            object.amount_unit = options.enums === String ? $root.AmountUnit[message.amount_unit] : message.amount_unit;
        return object;
    };

    AuthorizeCoinJoin.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return AuthorizeCoinJoin;
})();

$root.GetPublicKeyMultiple = (function() {

    function GetPublicKeyMultiple(properties) {
        this.addresses = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    GetPublicKeyMultiple.prototype.addresses = $util.emptyArray;
    GetPublicKeyMultiple.prototype.ecdsa_curve_name = "";
    GetPublicKeyMultiple.prototype.show_display = false;
    GetPublicKeyMultiple.prototype.coin_name = "Bitcoin";
    GetPublicKeyMultiple.prototype.script_type = 0;
    GetPublicKeyMultiple.prototype.ignore_xpub_magic = false;

    GetPublicKeyMultiple.create = function create(properties) {
        return new GetPublicKeyMultiple(properties);
    };

    GetPublicKeyMultiple.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.addresses != null && message.addresses.length)
            for (var i = 0; i < message.addresses.length; ++i)
                $root.GetPublicKeyMultiple.BIP32Address.encode(message.addresses[i], writer.uint32(10).fork()).ldelim();
        if (message.ecdsa_curve_name != null && Object.hasOwnProperty.call(message, "ecdsa_curve_name"))
            writer.uint32(18).string(message.ecdsa_curve_name);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(24).bool(message.show_display);
        if (message.coin_name != null && Object.hasOwnProperty.call(message, "coin_name"))
            writer.uint32(34).string(message.coin_name);
        if (message.script_type != null && Object.hasOwnProperty.call(message, "script_type"))
            writer.uint32(40).int32(message.script_type);
        if (message.ignore_xpub_magic != null && Object.hasOwnProperty.call(message, "ignore_xpub_magic"))
            writer.uint32(48).bool(message.ignore_xpub_magic);
        return writer;
    };

    GetPublicKeyMultiple.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    GetPublicKeyMultiple.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.GetPublicKeyMultiple();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.addresses && message.addresses.length))
                    message.addresses = [];
                message.addresses.push($root.GetPublicKeyMultiple.BIP32Address.decode(reader, reader.uint32()));
                break;
            case 2:
                message.ecdsa_curve_name = reader.string();
                break;
            case 3:
                message.show_display = reader.bool();
                break;
            case 4:
                message.coin_name = reader.string();
                break;
            case 5:
                message.script_type = reader.int32();
                break;
            case 6:
                message.ignore_xpub_magic = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    GetPublicKeyMultiple.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    GetPublicKeyMultiple.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.addresses != null && message.hasOwnProperty("addresses")) {
            if (!Array.isArray(message.addresses))
                return "addresses: array expected";
            for (var i = 0; i < message.addresses.length; ++i) {
                var error = $root.GetPublicKeyMultiple.BIP32Address.verify(message.addresses[i]);
                if (error)
                    return "addresses." + error;
            }
        }
        if (message.ecdsa_curve_name != null && message.hasOwnProperty("ecdsa_curve_name"))
            if (!$util.isString(message.ecdsa_curve_name))
                return "ecdsa_curve_name: string expected";
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        if (message.coin_name != null && message.hasOwnProperty("coin_name"))
            if (!$util.isString(message.coin_name))
                return "coin_name: string expected";
        if (message.script_type != null && message.hasOwnProperty("script_type"))
            switch (message.script_type) {
            default:
                return "script_type: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
                break;
            }
        if (message.ignore_xpub_magic != null && message.hasOwnProperty("ignore_xpub_magic"))
            if (typeof message.ignore_xpub_magic !== "boolean")
                return "ignore_xpub_magic: boolean expected";
        return null;
    };

    GetPublicKeyMultiple.fromObject = function fromObject(object) {
        if (object instanceof $root.GetPublicKeyMultiple)
            return object;
        var message = new $root.GetPublicKeyMultiple();
        if (object.addresses) {
            if (!Array.isArray(object.addresses))
                throw TypeError(".GetPublicKeyMultiple.addresses: array expected");
            message.addresses = [];
            for (var i = 0; i < object.addresses.length; ++i) {
                if (typeof object.addresses[i] !== "object")
                    throw TypeError(".GetPublicKeyMultiple.addresses: object expected");
                message.addresses[i] = $root.GetPublicKeyMultiple.BIP32Address.fromObject(object.addresses[i]);
            }
        }
        if (object.ecdsa_curve_name != null)
            message.ecdsa_curve_name = String(object.ecdsa_curve_name);
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        if (object.coin_name != null)
            message.coin_name = String(object.coin_name);
        switch (object.script_type) {
        case "SPENDADDRESS":
        case 0:
            message.script_type = 0;
            break;
        case "SPENDMULTISIG":
        case 1:
            message.script_type = 1;
            break;
        case "EXTERNAL":
        case 2:
            message.script_type = 2;
            break;
        case "SPENDWITNESS":
        case 3:
            message.script_type = 3;
            break;
        case "SPENDP2SHWITNESS":
        case 4:
            message.script_type = 4;
            break;
        case "SPENDTAPROOT":
        case 5:
            message.script_type = 5;
            break;
        }
        if (object.ignore_xpub_magic != null)
            message.ignore_xpub_magic = Boolean(object.ignore_xpub_magic);
        return message;
    };

    GetPublicKeyMultiple.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.addresses = [];
        if (options.defaults) {
            object.ecdsa_curve_name = "";
            object.show_display = false;
            object.coin_name = "Bitcoin";
            object.script_type = options.enums === String ? "SPENDADDRESS" : 0;
            object.ignore_xpub_magic = false;
        }
        if (message.addresses && message.addresses.length) {
            object.addresses = [];
            for (var j = 0; j < message.addresses.length; ++j)
                object.addresses[j] = $root.GetPublicKeyMultiple.BIP32Address.toObject(message.addresses[j], options);
        }
        if (message.ecdsa_curve_name != null && message.hasOwnProperty("ecdsa_curve_name"))
            object.ecdsa_curve_name = message.ecdsa_curve_name;
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        if (message.coin_name != null && message.hasOwnProperty("coin_name"))
            object.coin_name = message.coin_name;
        if (message.script_type != null && message.hasOwnProperty("script_type"))
            object.script_type = options.enums === String ? $root.InputScriptType[message.script_type] : message.script_type;
        if (message.ignore_xpub_magic != null && message.hasOwnProperty("ignore_xpub_magic"))
            object.ignore_xpub_magic = message.ignore_xpub_magic;
        return object;
    };

    GetPublicKeyMultiple.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    GetPublicKeyMultiple.BIP32Address = (function() {

        function BIP32Address(properties) {
            this.address_n = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        BIP32Address.prototype.address_n = $util.emptyArray;

        BIP32Address.create = function create(properties) {
            return new BIP32Address(properties);
        };

        BIP32Address.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.address_n != null && message.address_n.length)
                for (var i = 0; i < message.address_n.length; ++i)
                    writer.uint32(8).uint32(message.address_n[i]);
            return writer;
        };

        BIP32Address.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        BIP32Address.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.GetPublicKeyMultiple.BIP32Address();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.address_n && message.address_n.length))
                        message.address_n = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.address_n.push(reader.uint32());
                    } else
                        message.address_n.push(reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        BIP32Address.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        BIP32Address.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.address_n != null && message.hasOwnProperty("address_n")) {
                if (!Array.isArray(message.address_n))
                    return "address_n: array expected";
                for (var i = 0; i < message.address_n.length; ++i)
                    if (!$util.isInteger(message.address_n[i]))
                        return "address_n: integer[] expected";
            }
            return null;
        };

        BIP32Address.fromObject = function fromObject(object) {
            if (object instanceof $root.GetPublicKeyMultiple.BIP32Address)
                return object;
            var message = new $root.GetPublicKeyMultiple.BIP32Address();
            if (object.address_n) {
                if (!Array.isArray(object.address_n))
                    throw TypeError(".GetPublicKeyMultiple.BIP32Address.address_n: array expected");
                message.address_n = [];
                for (var i = 0; i < object.address_n.length; ++i)
                    message.address_n[i] = object.address_n[i] >>> 0;
            }
            return message;
        };

        BIP32Address.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.address_n = [];
            if (message.address_n && message.address_n.length) {
                object.address_n = [];
                for (var j = 0; j < message.address_n.length; ++j)
                    object.address_n[j] = message.address_n[j];
            }
            return object;
        };

        BIP32Address.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return BIP32Address;
    })();

    return GetPublicKeyMultiple;
})();

$root.PublicKeyMultiple = (function() {

    function PublicKeyMultiple(properties) {
        this.xpubs = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    PublicKeyMultiple.prototype.xpubs = $util.emptyArray;

    PublicKeyMultiple.create = function create(properties) {
        return new PublicKeyMultiple(properties);
    };

    PublicKeyMultiple.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.xpubs != null && message.xpubs.length)
            for (var i = 0; i < message.xpubs.length; ++i)
                writer.uint32(10).string(message.xpubs[i]);
        return writer;
    };

    PublicKeyMultiple.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    PublicKeyMultiple.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.PublicKeyMultiple();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.xpubs && message.xpubs.length))
                    message.xpubs = [];
                message.xpubs.push(reader.string());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    PublicKeyMultiple.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    PublicKeyMultiple.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.xpubs != null && message.hasOwnProperty("xpubs")) {
            if (!Array.isArray(message.xpubs))
                return "xpubs: array expected";
            for (var i = 0; i < message.xpubs.length; ++i)
                if (!$util.isString(message.xpubs[i]))
                    return "xpubs: string[] expected";
        }
        return null;
    };

    PublicKeyMultiple.fromObject = function fromObject(object) {
        if (object instanceof $root.PublicKeyMultiple)
            return object;
        var message = new $root.PublicKeyMultiple();
        if (object.xpubs) {
            if (!Array.isArray(object.xpubs))
                throw TypeError(".PublicKeyMultiple.xpubs: array expected");
            message.xpubs = [];
            for (var i = 0; i < object.xpubs.length; ++i)
                message.xpubs[i] = String(object.xpubs[i]);
        }
        return message;
    };

    PublicKeyMultiple.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.xpubs = [];
        if (message.xpubs && message.xpubs.length) {
            object.xpubs = [];
            for (var j = 0; j < message.xpubs.length; ++j)
                object.xpubs[j] = message.xpubs[j];
        }
        return object;
    };

    PublicKeyMultiple.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return PublicKeyMultiple;
})();

$root.SignPsbt = (function() {

    function SignPsbt(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    SignPsbt.prototype.psbt = $util.newBuffer([]);
    SignPsbt.prototype.coin_name = "Bitcoin";

    SignPsbt.create = function create(properties) {
        return new SignPsbt(properties);
    };

    SignPsbt.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.psbt);
        if (message.coin_name != null && Object.hasOwnProperty.call(message, "coin_name"))
            writer.uint32(18).string(message.coin_name);
        return writer;
    };

    SignPsbt.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    SignPsbt.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SignPsbt();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.psbt = reader.bytes();
                break;
            case 2:
                message.coin_name = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("psbt"))
            throw $util.ProtocolError("missing required 'psbt'", { instance: message });
        return message;
    };

    SignPsbt.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    SignPsbt.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.psbt && typeof message.psbt.length === "number" || $util.isString(message.psbt)))
            return "psbt: buffer expected";
        if (message.coin_name != null && message.hasOwnProperty("coin_name"))
            if (!$util.isString(message.coin_name))
                return "coin_name: string expected";
        return null;
    };

    SignPsbt.fromObject = function fromObject(object) {
        if (object instanceof $root.SignPsbt)
            return object;
        var message = new $root.SignPsbt();
        if (object.psbt != null)
            if (typeof object.psbt === "string")
                $util.base64.decode(object.psbt, message.psbt = $util.newBuffer($util.base64.length(object.psbt)), 0);
            else if (object.psbt.length)
                message.psbt = object.psbt;
        if (object.coin_name != null)
            message.coin_name = String(object.coin_name);
        return message;
    };

    SignPsbt.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.psbt = "";
            else {
                object.psbt = [];
                if (options.bytes !== Array)
                    object.psbt = $util.newBuffer(object.psbt);
            }
            object.coin_name = "Bitcoin";
        }
        if (message.psbt != null && message.hasOwnProperty("psbt"))
            object.psbt = options.bytes === String ? $util.base64.encode(message.psbt, 0, message.psbt.length) : options.bytes === Array ? Array.prototype.slice.call(message.psbt) : message.psbt;
        if (message.coin_name != null && message.hasOwnProperty("coin_name"))
            object.coin_name = message.coin_name;
        return object;
    };

    SignPsbt.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SignPsbt;
})();

$root.SignedPsbt = (function() {

    function SignedPsbt(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    SignedPsbt.prototype.psbt = $util.newBuffer([]);

    SignedPsbt.create = function create(properties) {
        return new SignedPsbt(properties);
    };

    SignedPsbt.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.psbt);
        return writer;
    };

    SignedPsbt.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    SignedPsbt.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SignedPsbt();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.psbt = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("psbt"))
            throw $util.ProtocolError("missing required 'psbt'", { instance: message });
        return message;
    };

    SignedPsbt.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    SignedPsbt.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.psbt && typeof message.psbt.length === "number" || $util.isString(message.psbt)))
            return "psbt: buffer expected";
        return null;
    };

    SignedPsbt.fromObject = function fromObject(object) {
        if (object instanceof $root.SignedPsbt)
            return object;
        var message = new $root.SignedPsbt();
        if (object.psbt != null)
            if (typeof object.psbt === "string")
                $util.base64.decode(object.psbt, message.psbt = $util.newBuffer($util.base64.length(object.psbt)), 0);
            else if (object.psbt.length)
                message.psbt = object.psbt;
        return message;
    };

    SignedPsbt.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.psbt = "";
            else {
                object.psbt = [];
                if (options.bytes !== Array)
                    object.psbt = $util.newBuffer(object.psbt);
            }
        if (message.psbt != null && message.hasOwnProperty("psbt"))
            object.psbt = options.bytes === String ? $util.base64.encode(message.psbt, 0, message.psbt.length) : options.bytes === Array ? Array.prototype.slice.call(message.psbt) : message.psbt;
        return object;
    };

    SignedPsbt.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SignedPsbt;
})();

$root.FirmwareErase = (function() {

    function FirmwareErase(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    FirmwareErase.prototype.length = 0;

    FirmwareErase.create = function create(properties) {
        return new FirmwareErase(properties);
    };

    FirmwareErase.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.length != null && Object.hasOwnProperty.call(message, "length"))
            writer.uint32(8).uint32(message.length);
        return writer;
    };

    FirmwareErase.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    FirmwareErase.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.FirmwareErase();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.length = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    FirmwareErase.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    FirmwareErase.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.length != null && message.hasOwnProperty("length"))
            if (!$util.isInteger(message.length))
                return "length: integer expected";
        return null;
    };

    FirmwareErase.fromObject = function fromObject(object) {
        if (object instanceof $root.FirmwareErase)
            return object;
        var message = new $root.FirmwareErase();
        if (object.length != null)
            message.length = object.length >>> 0;
        return message;
    };

    FirmwareErase.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.length = 0;
        if (message.length != null && message.hasOwnProperty("length"))
            object.length = message.length;
        return object;
    };

    FirmwareErase.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return FirmwareErase;
})();

$root.FirmwareRequest = (function() {

    function FirmwareRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    FirmwareRequest.prototype.offset = 0;
    FirmwareRequest.prototype.length = 0;

    FirmwareRequest.create = function create(properties) {
        return new FirmwareRequest(properties);
    };

    FirmwareRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.offset != null && Object.hasOwnProperty.call(message, "offset"))
            writer.uint32(8).uint32(message.offset);
        if (message.length != null && Object.hasOwnProperty.call(message, "length"))
            writer.uint32(16).uint32(message.length);
        return writer;
    };

    FirmwareRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    FirmwareRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.FirmwareRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.offset = reader.uint32();
                break;
            case 2:
                message.length = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    FirmwareRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    FirmwareRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.offset != null && message.hasOwnProperty("offset"))
            if (!$util.isInteger(message.offset))
                return "offset: integer expected";
        if (message.length != null && message.hasOwnProperty("length"))
            if (!$util.isInteger(message.length))
                return "length: integer expected";
        return null;
    };

    FirmwareRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.FirmwareRequest)
            return object;
        var message = new $root.FirmwareRequest();
        if (object.offset != null)
            message.offset = object.offset >>> 0;
        if (object.length != null)
            message.length = object.length >>> 0;
        return message;
    };

    FirmwareRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.offset = 0;
            object.length = 0;
        }
        if (message.offset != null && message.hasOwnProperty("offset"))
            object.offset = message.offset;
        if (message.length != null && message.hasOwnProperty("length"))
            object.length = message.length;
        return object;
    };

    FirmwareRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return FirmwareRequest;
})();

$root.FirmwareUpload = (function() {

    function FirmwareUpload(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    FirmwareUpload.prototype.payload = $util.newBuffer([]);
    FirmwareUpload.prototype.hash = $util.newBuffer([]);

    FirmwareUpload.create = function create(properties) {
        return new FirmwareUpload(properties);
    };

    FirmwareUpload.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.payload);
        if (message.hash != null && Object.hasOwnProperty.call(message, "hash"))
            writer.uint32(18).bytes(message.hash);
        return writer;
    };

    FirmwareUpload.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    FirmwareUpload.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.FirmwareUpload();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.payload = reader.bytes();
                break;
            case 2:
                message.hash = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("payload"))
            throw $util.ProtocolError("missing required 'payload'", { instance: message });
        return message;
    };

    FirmwareUpload.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    FirmwareUpload.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.payload && typeof message.payload.length === "number" || $util.isString(message.payload)))
            return "payload: buffer expected";
        if (message.hash != null && message.hasOwnProperty("hash"))
            if (!(message.hash && typeof message.hash.length === "number" || $util.isString(message.hash)))
                return "hash: buffer expected";
        return null;
    };

    FirmwareUpload.fromObject = function fromObject(object) {
        if (object instanceof $root.FirmwareUpload)
            return object;
        var message = new $root.FirmwareUpload();
        if (object.payload != null)
            if (typeof object.payload === "string")
                $util.base64.decode(object.payload, message.payload = $util.newBuffer($util.base64.length(object.payload)), 0);
            else if (object.payload.length)
                message.payload = object.payload;
        if (object.hash != null)
            if (typeof object.hash === "string")
                $util.base64.decode(object.hash, message.hash = $util.newBuffer($util.base64.length(object.hash)), 0);
            else if (object.hash.length)
                message.hash = object.hash;
        return message;
    };

    FirmwareUpload.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.payload = "";
            else {
                object.payload = [];
                if (options.bytes !== Array)
                    object.payload = $util.newBuffer(object.payload);
            }
            if (options.bytes === String)
                object.hash = "";
            else {
                object.hash = [];
                if (options.bytes !== Array)
                    object.hash = $util.newBuffer(object.hash);
            }
        }
        if (message.payload != null && message.hasOwnProperty("payload"))
            object.payload = options.bytes === String ? $util.base64.encode(message.payload, 0, message.payload.length) : options.bytes === Array ? Array.prototype.slice.call(message.payload) : message.payload;
        if (message.hash != null && message.hasOwnProperty("hash"))
            object.hash = options.bytes === String ? $util.base64.encode(message.hash, 0, message.hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.hash) : message.hash;
        return object;
    };

    FirmwareUpload.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return FirmwareUpload;
})();

$root.SelfTest = (function() {

    function SelfTest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    SelfTest.prototype.payload = $util.newBuffer([]);

    SelfTest.create = function create(properties) {
        return new SelfTest(properties);
    };

    SelfTest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.payload != null && Object.hasOwnProperty.call(message, "payload"))
            writer.uint32(10).bytes(message.payload);
        return writer;
    };

    SelfTest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    SelfTest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SelfTest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.payload = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    SelfTest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    SelfTest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.payload != null && message.hasOwnProperty("payload"))
            if (!(message.payload && typeof message.payload.length === "number" || $util.isString(message.payload)))
                return "payload: buffer expected";
        return null;
    };

    SelfTest.fromObject = function fromObject(object) {
        if (object instanceof $root.SelfTest)
            return object;
        var message = new $root.SelfTest();
        if (object.payload != null)
            if (typeof object.payload === "string")
                $util.base64.decode(object.payload, message.payload = $util.newBuffer($util.base64.length(object.payload)), 0);
            else if (object.payload.length)
                message.payload = object.payload;
        return message;
    };

    SelfTest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.payload = "";
            else {
                object.payload = [];
                if (options.bytes !== Array)
                    object.payload = $util.newBuffer(object.payload);
            }
        if (message.payload != null && message.hasOwnProperty("payload"))
            object.payload = options.bytes === String ? $util.base64.encode(message.payload, 0, message.payload.length) : options.bytes === Array ? Array.prototype.slice.call(message.payload) : message.payload;
        return object;
    };

    SelfTest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SelfTest;
})();

$root.FirmwareErase_ex = (function() {

    function FirmwareErase_ex(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    FirmwareErase_ex.prototype.length = 0;

    FirmwareErase_ex.create = function create(properties) {
        return new FirmwareErase_ex(properties);
    };

    FirmwareErase_ex.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.length != null && Object.hasOwnProperty.call(message, "length"))
            writer.uint32(8).uint32(message.length);
        return writer;
    };

    FirmwareErase_ex.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    FirmwareErase_ex.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.FirmwareErase_ex();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.length = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    FirmwareErase_ex.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    FirmwareErase_ex.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.length != null && message.hasOwnProperty("length"))
            if (!$util.isInteger(message.length))
                return "length: integer expected";
        return null;
    };

    FirmwareErase_ex.fromObject = function fromObject(object) {
        if (object instanceof $root.FirmwareErase_ex)
            return object;
        var message = new $root.FirmwareErase_ex();
        if (object.length != null)
            message.length = object.length >>> 0;
        return message;
    };

    FirmwareErase_ex.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.length = 0;
        if (message.length != null && message.hasOwnProperty("length"))
            object.length = message.length;
        return object;
    };

    FirmwareErase_ex.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return FirmwareErase_ex;
})();

$root.RebootType = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "Normal"] = 0;
    values[valuesById[1] = "Boardloader"] = 1;
    values[valuesById[2] = "BootLoader"] = 2;
    return values;
})();

$root.Reboot = (function() {

    function Reboot(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    Reboot.prototype.reboot_type = 0;

    Reboot.create = function create(properties) {
        return new Reboot(properties);
    };

    Reboot.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).int32(message.reboot_type);
        return writer;
    };

    Reboot.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    Reboot.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Reboot();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.reboot_type = reader.int32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("reboot_type"))
            throw $util.ProtocolError("missing required 'reboot_type'", { instance: message });
        return message;
    };

    Reboot.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    Reboot.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        switch (message.reboot_type) {
        default:
            return "reboot_type: enum value expected";
        case 0:
        case 1:
        case 2:
            break;
        }
        return null;
    };

    Reboot.fromObject = function fromObject(object) {
        if (object instanceof $root.Reboot)
            return object;
        var message = new $root.Reboot();
        switch (object.reboot_type) {
        case "Normal":
        case 0:
            message.reboot_type = 0;
            break;
        case "Boardloader":
        case 1:
            message.reboot_type = 1;
            break;
        case "BootLoader":
        case 2:
            message.reboot_type = 2;
            break;
        }
        return message;
    };

    Reboot.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.reboot_type = options.enums === String ? "Normal" : 0;
        if (message.reboot_type != null && message.hasOwnProperty("reboot_type"))
            object.reboot_type = options.enums === String ? $root.RebootType[message.reboot_type] : message.reboot_type;
        return object;
    };

    Reboot.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return Reboot;
})();

$root.FirmwareUpdateEmmc = (function() {

    function FirmwareUpdateEmmc(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    FirmwareUpdateEmmc.prototype.path = "";
    FirmwareUpdateEmmc.prototype.reboot_on_success = false;

    FirmwareUpdateEmmc.create = function create(properties) {
        return new FirmwareUpdateEmmc(properties);
    };

    FirmwareUpdateEmmc.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.path);
        if (message.reboot_on_success != null && Object.hasOwnProperty.call(message, "reboot_on_success"))
            writer.uint32(16).bool(message.reboot_on_success);
        return writer;
    };

    FirmwareUpdateEmmc.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    FirmwareUpdateEmmc.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.FirmwareUpdateEmmc();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.path = reader.string();
                break;
            case 2:
                message.reboot_on_success = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("path"))
            throw $util.ProtocolError("missing required 'path'", { instance: message });
        return message;
    };

    FirmwareUpdateEmmc.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    FirmwareUpdateEmmc.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.path))
            return "path: string expected";
        if (message.reboot_on_success != null && message.hasOwnProperty("reboot_on_success"))
            if (typeof message.reboot_on_success !== "boolean")
                return "reboot_on_success: boolean expected";
        return null;
    };

    FirmwareUpdateEmmc.fromObject = function fromObject(object) {
        if (object instanceof $root.FirmwareUpdateEmmc)
            return object;
        var message = new $root.FirmwareUpdateEmmc();
        if (object.path != null)
            message.path = String(object.path);
        if (object.reboot_on_success != null)
            message.reboot_on_success = Boolean(object.reboot_on_success);
        return message;
    };

    FirmwareUpdateEmmc.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.path = "";
            object.reboot_on_success = false;
        }
        if (message.path != null && message.hasOwnProperty("path"))
            object.path = message.path;
        if (message.reboot_on_success != null && message.hasOwnProperty("reboot_on_success"))
            object.reboot_on_success = message.reboot_on_success;
        return object;
    };

    FirmwareUpdateEmmc.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return FirmwareUpdateEmmc;
})();

$root.UpgradeFileHeader = (function() {

    function UpgradeFileHeader(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    UpgradeFileHeader.prototype.data = $util.newBuffer([]);

    UpgradeFileHeader.create = function create(properties) {
        return new UpgradeFileHeader(properties);
    };

    UpgradeFileHeader.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.data);
        return writer;
    };

    UpgradeFileHeader.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    UpgradeFileHeader.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.UpgradeFileHeader();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.data = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("data"))
            throw $util.ProtocolError("missing required 'data'", { instance: message });
        return message;
    };

    UpgradeFileHeader.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    UpgradeFileHeader.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
            return "data: buffer expected";
        return null;
    };

    UpgradeFileHeader.fromObject = function fromObject(object) {
        if (object instanceof $root.UpgradeFileHeader)
            return object;
        var message = new $root.UpgradeFileHeader();
        if (object.data != null)
            if (typeof object.data === "string")
                $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
            else if (object.data.length)
                message.data = object.data;
        return message;
    };

    UpgradeFileHeader.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.data = "";
            else {
                object.data = [];
                if (options.bytes !== Array)
                    object.data = $util.newBuffer(object.data);
            }
        if (message.data != null && message.hasOwnProperty("data"))
            object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
        return object;
    };

    UpgradeFileHeader.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return UpgradeFileHeader;
})();

$root.CardanoDerivationType = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "LEDGER"] = 0;
    values[valuesById[1] = "ICARUS"] = 1;
    values[valuesById[2] = "ICARUS_TREZOR"] = 2;
    return values;
})();

$root.CardanoAddressType = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "BASE"] = 0;
    values[valuesById[1] = "BASE_SCRIPT_KEY"] = 1;
    values[valuesById[2] = "BASE_KEY_SCRIPT"] = 2;
    values[valuesById[3] = "BASE_SCRIPT_SCRIPT"] = 3;
    values[valuesById[4] = "POINTER"] = 4;
    values[valuesById[5] = "POINTER_SCRIPT"] = 5;
    values[valuesById[6] = "ENTERPRISE"] = 6;
    values[valuesById[7] = "ENTERPRISE_SCRIPT"] = 7;
    values[valuesById[8] = "BYRON"] = 8;
    values[valuesById[14] = "REWARD"] = 14;
    values[valuesById[15] = "REWARD_SCRIPT"] = 15;
    return values;
})();

$root.CardanoNativeScriptType = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "PUB_KEY"] = 0;
    values[valuesById[1] = "ALL"] = 1;
    values[valuesById[2] = "ANY"] = 2;
    values[valuesById[3] = "N_OF_K"] = 3;
    values[valuesById[4] = "INVALID_BEFORE"] = 4;
    values[valuesById[5] = "INVALID_HEREAFTER"] = 5;
    return values;
})();

$root.CardanoNativeScriptHashDisplayFormat = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "HIDE"] = 0;
    values[valuesById[1] = "BECH32"] = 1;
    values[valuesById[2] = "POLICY_ID"] = 2;
    return values;
})();

$root.CardanoTxOutputSerializationFormat = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "ARRAY_LEGACY"] = 0;
    values[valuesById[1] = "MAP_BABBAGE"] = 1;
    return values;
})();

$root.CardanoCertificateType = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "STAKE_REGISTRATION"] = 0;
    values[valuesById[1] = "STAKE_DEREGISTRATION"] = 1;
    values[valuesById[2] = "STAKE_DELEGATION"] = 2;
    values[valuesById[3] = "STAKE_POOL_REGISTRATION"] = 3;
    values[valuesById[7] = "STAKE_REGISTRATION_CONWAY"] = 7;
    values[valuesById[8] = "STAKE_DEREGISTRATION_CONWAY"] = 8;
    values[valuesById[9] = "VOTE_DELEGATION"] = 9;
    return values;
})();

$root.CardanoDRepType = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "KEY_HASH"] = 0;
    values[valuesById[1] = "SCRIPT_HASH"] = 1;
    values[valuesById[2] = "ABSTAIN"] = 2;
    values[valuesById[3] = "NO_CONFIDENCE"] = 3;
    return values;
})();

$root.CardanoPoolRelayType = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "SINGLE_HOST_IP"] = 0;
    values[valuesById[1] = "SINGLE_HOST_NAME"] = 1;
    values[valuesById[2] = "MULTIPLE_HOST_NAME"] = 2;
    return values;
})();

$root.CardanoTxAuxiliaryDataSupplementType = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "NONE"] = 0;
    values[valuesById[1] = "CVOTE_REGISTRATION_SIGNATURE"] = 1;
    return values;
})();

$root.CardanoCVoteRegistrationFormat = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "CIP15"] = 0;
    values[valuesById[1] = "CIP36"] = 1;
    return values;
})();

$root.CardanoTxSigningMode = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "ORDINARY_TRANSACTION"] = 0;
    values[valuesById[1] = "POOL_REGISTRATION_AS_OWNER"] = 1;
    values[valuesById[2] = "MULTISIG_TRANSACTION"] = 2;
    values[valuesById[3] = "PLUTUS_TRANSACTION"] = 3;
    return values;
})();

$root.CardanoTxWitnessType = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "BYRON_WITNESS"] = 0;
    values[valuesById[1] = "SHELLEY_WITNESS"] = 1;
    return values;
})();

$root.CardanoBlockchainPointerType = (function() {

    function CardanoBlockchainPointerType(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoBlockchainPointerType.prototype.block_index = 0;
    CardanoBlockchainPointerType.prototype.tx_index = 0;
    CardanoBlockchainPointerType.prototype.certificate_index = 0;

    CardanoBlockchainPointerType.create = function create(properties) {
        return new CardanoBlockchainPointerType(properties);
    };

    CardanoBlockchainPointerType.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).uint32(message.block_index);
        writer.uint32(16).uint32(message.tx_index);
        writer.uint32(24).uint32(message.certificate_index);
        return writer;
    };

    CardanoBlockchainPointerType.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoBlockchainPointerType.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoBlockchainPointerType();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.block_index = reader.uint32();
                break;
            case 2:
                message.tx_index = reader.uint32();
                break;
            case 3:
                message.certificate_index = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("block_index"))
            throw $util.ProtocolError("missing required 'block_index'", { instance: message });
        if (!message.hasOwnProperty("tx_index"))
            throw $util.ProtocolError("missing required 'tx_index'", { instance: message });
        if (!message.hasOwnProperty("certificate_index"))
            throw $util.ProtocolError("missing required 'certificate_index'", { instance: message });
        return message;
    };

    CardanoBlockchainPointerType.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoBlockchainPointerType.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isInteger(message.block_index))
            return "block_index: integer expected";
        if (!$util.isInteger(message.tx_index))
            return "tx_index: integer expected";
        if (!$util.isInteger(message.certificate_index))
            return "certificate_index: integer expected";
        return null;
    };

    CardanoBlockchainPointerType.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoBlockchainPointerType)
            return object;
        var message = new $root.CardanoBlockchainPointerType();
        if (object.block_index != null)
            message.block_index = object.block_index >>> 0;
        if (object.tx_index != null)
            message.tx_index = object.tx_index >>> 0;
        if (object.certificate_index != null)
            message.certificate_index = object.certificate_index >>> 0;
        return message;
    };

    CardanoBlockchainPointerType.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.block_index = 0;
            object.tx_index = 0;
            object.certificate_index = 0;
        }
        if (message.block_index != null && message.hasOwnProperty("block_index"))
            object.block_index = message.block_index;
        if (message.tx_index != null && message.hasOwnProperty("tx_index"))
            object.tx_index = message.tx_index;
        if (message.certificate_index != null && message.hasOwnProperty("certificate_index"))
            object.certificate_index = message.certificate_index;
        return object;
    };

    CardanoBlockchainPointerType.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoBlockchainPointerType;
})();

$root.CardanoNativeScript = (function() {

    function CardanoNativeScript(properties) {
        this.scripts = [];
        this.key_path = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoNativeScript.prototype.type = 0;
    CardanoNativeScript.prototype.scripts = $util.emptyArray;
    CardanoNativeScript.prototype.key_hash = $util.newBuffer([]);
    CardanoNativeScript.prototype.key_path = $util.emptyArray;
    CardanoNativeScript.prototype.required_signatures_count = 0;
    CardanoNativeScript.prototype.invalid_before = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    CardanoNativeScript.prototype.invalid_hereafter = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    CardanoNativeScript.create = function create(properties) {
        return new CardanoNativeScript(properties);
    };

    CardanoNativeScript.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).int32(message.type);
        if (message.scripts != null && message.scripts.length)
            for (var i = 0; i < message.scripts.length; ++i)
                $root.CardanoNativeScript.encode(message.scripts[i], writer.uint32(18).fork()).ldelim();
        if (message.key_hash != null && Object.hasOwnProperty.call(message, "key_hash"))
            writer.uint32(26).bytes(message.key_hash);
        if (message.key_path != null && message.key_path.length)
            for (var i = 0; i < message.key_path.length; ++i)
                writer.uint32(32).uint32(message.key_path[i]);
        if (message.required_signatures_count != null && Object.hasOwnProperty.call(message, "required_signatures_count"))
            writer.uint32(40).uint32(message.required_signatures_count);
        if (message.invalid_before != null && Object.hasOwnProperty.call(message, "invalid_before"))
            writer.uint32(48).uint64(message.invalid_before);
        if (message.invalid_hereafter != null && Object.hasOwnProperty.call(message, "invalid_hereafter"))
            writer.uint32(56).uint64(message.invalid_hereafter);
        return writer;
    };

    CardanoNativeScript.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoNativeScript.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoNativeScript();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.type = reader.int32();
                break;
            case 2:
                if (!(message.scripts && message.scripts.length))
                    message.scripts = [];
                message.scripts.push($root.CardanoNativeScript.decode(reader, reader.uint32()));
                break;
            case 3:
                message.key_hash = reader.bytes();
                break;
            case 4:
                if (!(message.key_path && message.key_path.length))
                    message.key_path = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.key_path.push(reader.uint32());
                } else
                    message.key_path.push(reader.uint32());
                break;
            case 5:
                message.required_signatures_count = reader.uint32();
                break;
            case 6:
                message.invalid_before = reader.uint64();
                break;
            case 7:
                message.invalid_hereafter = reader.uint64();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("type"))
            throw $util.ProtocolError("missing required 'type'", { instance: message });
        return message;
    };

    CardanoNativeScript.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoNativeScript.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        switch (message.type) {
        default:
            return "type: enum value expected";
        case 0:
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        }
        if (message.scripts != null && message.hasOwnProperty("scripts")) {
            if (!Array.isArray(message.scripts))
                return "scripts: array expected";
            for (var i = 0; i < message.scripts.length; ++i) {
                var error = $root.CardanoNativeScript.verify(message.scripts[i]);
                if (error)
                    return "scripts." + error;
            }
        }
        if (message.key_hash != null && message.hasOwnProperty("key_hash"))
            if (!(message.key_hash && typeof message.key_hash.length === "number" || $util.isString(message.key_hash)))
                return "key_hash: buffer expected";
        if (message.key_path != null && message.hasOwnProperty("key_path")) {
            if (!Array.isArray(message.key_path))
                return "key_path: array expected";
            for (var i = 0; i < message.key_path.length; ++i)
                if (!$util.isInteger(message.key_path[i]))
                    return "key_path: integer[] expected";
        }
        if (message.required_signatures_count != null && message.hasOwnProperty("required_signatures_count"))
            if (!$util.isInteger(message.required_signatures_count))
                return "required_signatures_count: integer expected";
        if (message.invalid_before != null && message.hasOwnProperty("invalid_before"))
            if (!$util.isInteger(message.invalid_before) && !(message.invalid_before && $util.isInteger(message.invalid_before.low) && $util.isInteger(message.invalid_before.high)))
                return "invalid_before: integer|Long expected";
        if (message.invalid_hereafter != null && message.hasOwnProperty("invalid_hereafter"))
            if (!$util.isInteger(message.invalid_hereafter) && !(message.invalid_hereafter && $util.isInteger(message.invalid_hereafter.low) && $util.isInteger(message.invalid_hereafter.high)))
                return "invalid_hereafter: integer|Long expected";
        return null;
    };

    CardanoNativeScript.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoNativeScript)
            return object;
        var message = new $root.CardanoNativeScript();
        switch (object.type) {
        case "PUB_KEY":
        case 0:
            message.type = 0;
            break;
        case "ALL":
        case 1:
            message.type = 1;
            break;
        case "ANY":
        case 2:
            message.type = 2;
            break;
        case "N_OF_K":
        case 3:
            message.type = 3;
            break;
        case "INVALID_BEFORE":
        case 4:
            message.type = 4;
            break;
        case "INVALID_HEREAFTER":
        case 5:
            message.type = 5;
            break;
        }
        if (object.scripts) {
            if (!Array.isArray(object.scripts))
                throw TypeError(".CardanoNativeScript.scripts: array expected");
            message.scripts = [];
            for (var i = 0; i < object.scripts.length; ++i) {
                if (typeof object.scripts[i] !== "object")
                    throw TypeError(".CardanoNativeScript.scripts: object expected");
                message.scripts[i] = $root.CardanoNativeScript.fromObject(object.scripts[i]);
            }
        }
        if (object.key_hash != null)
            if (typeof object.key_hash === "string")
                $util.base64.decode(object.key_hash, message.key_hash = $util.newBuffer($util.base64.length(object.key_hash)), 0);
            else if (object.key_hash.length)
                message.key_hash = object.key_hash;
        if (object.key_path) {
            if (!Array.isArray(object.key_path))
                throw TypeError(".CardanoNativeScript.key_path: array expected");
            message.key_path = [];
            for (var i = 0; i < object.key_path.length; ++i)
                message.key_path[i] = object.key_path[i] >>> 0;
        }
        if (object.required_signatures_count != null)
            message.required_signatures_count = object.required_signatures_count >>> 0;
        if (object.invalid_before != null)
            if ($util.Long)
                (message.invalid_before = $util.Long.fromValue(object.invalid_before)).unsigned = true;
            else if (typeof object.invalid_before === "string")
                message.invalid_before = parseInt(object.invalid_before, 10);
            else if (typeof object.invalid_before === "number")
                message.invalid_before = object.invalid_before;
            else if (typeof object.invalid_before === "object")
                message.invalid_before = new $util.LongBits(object.invalid_before.low >>> 0, object.invalid_before.high >>> 0).toNumber(true);
        if (object.invalid_hereafter != null)
            if ($util.Long)
                (message.invalid_hereafter = $util.Long.fromValue(object.invalid_hereafter)).unsigned = true;
            else if (typeof object.invalid_hereafter === "string")
                message.invalid_hereafter = parseInt(object.invalid_hereafter, 10);
            else if (typeof object.invalid_hereafter === "number")
                message.invalid_hereafter = object.invalid_hereafter;
            else if (typeof object.invalid_hereafter === "object")
                message.invalid_hereafter = new $util.LongBits(object.invalid_hereafter.low >>> 0, object.invalid_hereafter.high >>> 0).toNumber(true);
        return message;
    };

    CardanoNativeScript.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults) {
            object.scripts = [];
            object.key_path = [];
        }
        if (options.defaults) {
            object.type = options.enums === String ? "PUB_KEY" : 0;
            if (options.bytes === String)
                object.key_hash = "";
            else {
                object.key_hash = [];
                if (options.bytes !== Array)
                    object.key_hash = $util.newBuffer(object.key_hash);
            }
            object.required_signatures_count = 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.invalid_before = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.invalid_before = options.longs === String ? "0" : 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.invalid_hereafter = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.invalid_hereafter = options.longs === String ? "0" : 0;
        }
        if (message.type != null && message.hasOwnProperty("type"))
            object.type = options.enums === String ? $root.CardanoNativeScriptType[message.type] : message.type;
        if (message.scripts && message.scripts.length) {
            object.scripts = [];
            for (var j = 0; j < message.scripts.length; ++j)
                object.scripts[j] = $root.CardanoNativeScript.toObject(message.scripts[j], options);
        }
        if (message.key_hash != null && message.hasOwnProperty("key_hash"))
            object.key_hash = options.bytes === String ? $util.base64.encode(message.key_hash, 0, message.key_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.key_hash) : message.key_hash;
        if (message.key_path && message.key_path.length) {
            object.key_path = [];
            for (var j = 0; j < message.key_path.length; ++j)
                object.key_path[j] = message.key_path[j];
        }
        if (message.required_signatures_count != null && message.hasOwnProperty("required_signatures_count"))
            object.required_signatures_count = message.required_signatures_count;
        if (message.invalid_before != null && message.hasOwnProperty("invalid_before"))
            if (typeof message.invalid_before === "number")
                object.invalid_before = options.longs === String ? String(message.invalid_before) : message.invalid_before;
            else
                object.invalid_before = options.longs === String ? $util.Long.prototype.toString.call(message.invalid_before) : options.longs === Number ? new $util.LongBits(message.invalid_before.low >>> 0, message.invalid_before.high >>> 0).toNumber(true) : message.invalid_before;
        if (message.invalid_hereafter != null && message.hasOwnProperty("invalid_hereafter"))
            if (typeof message.invalid_hereafter === "number")
                object.invalid_hereafter = options.longs === String ? String(message.invalid_hereafter) : message.invalid_hereafter;
            else
                object.invalid_hereafter = options.longs === String ? $util.Long.prototype.toString.call(message.invalid_hereafter) : options.longs === Number ? new $util.LongBits(message.invalid_hereafter.low >>> 0, message.invalid_hereafter.high >>> 0).toNumber(true) : message.invalid_hereafter;
        return object;
    };

    CardanoNativeScript.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoNativeScript;
})();

$root.CardanoGetNativeScriptHash = (function() {

    function CardanoGetNativeScriptHash(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoGetNativeScriptHash.prototype.script = null;
    CardanoGetNativeScriptHash.prototype.display_format = 0;
    CardanoGetNativeScriptHash.prototype.derivation_type = 0;

    CardanoGetNativeScriptHash.create = function create(properties) {
        return new CardanoGetNativeScriptHash(properties);
    };

    CardanoGetNativeScriptHash.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        $root.CardanoNativeScript.encode(message.script, writer.uint32(10).fork()).ldelim();
        writer.uint32(16).int32(message.display_format);
        writer.uint32(24).int32(message.derivation_type);
        return writer;
    };

    CardanoGetNativeScriptHash.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoGetNativeScriptHash.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoGetNativeScriptHash();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.script = $root.CardanoNativeScript.decode(reader, reader.uint32());
                break;
            case 2:
                message.display_format = reader.int32();
                break;
            case 3:
                message.derivation_type = reader.int32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("script"))
            throw $util.ProtocolError("missing required 'script'", { instance: message });
        if (!message.hasOwnProperty("display_format"))
            throw $util.ProtocolError("missing required 'display_format'", { instance: message });
        if (!message.hasOwnProperty("derivation_type"))
            throw $util.ProtocolError("missing required 'derivation_type'", { instance: message });
        return message;
    };

    CardanoGetNativeScriptHash.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoGetNativeScriptHash.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        {
            var error = $root.CardanoNativeScript.verify(message.script);
            if (error)
                return "script." + error;
        }
        switch (message.display_format) {
        default:
            return "display_format: enum value expected";
        case 0:
        case 1:
        case 2:
            break;
        }
        switch (message.derivation_type) {
        default:
            return "derivation_type: enum value expected";
        case 0:
        case 1:
        case 2:
            break;
        }
        return null;
    };

    CardanoGetNativeScriptHash.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoGetNativeScriptHash)
            return object;
        var message = new $root.CardanoGetNativeScriptHash();
        if (object.script != null) {
            if (typeof object.script !== "object")
                throw TypeError(".CardanoGetNativeScriptHash.script: object expected");
            message.script = $root.CardanoNativeScript.fromObject(object.script);
        }
        switch (object.display_format) {
        case "HIDE":
        case 0:
            message.display_format = 0;
            break;
        case "BECH32":
        case 1:
            message.display_format = 1;
            break;
        case "POLICY_ID":
        case 2:
            message.display_format = 2;
            break;
        }
        switch (object.derivation_type) {
        case "LEDGER":
        case 0:
            message.derivation_type = 0;
            break;
        case "ICARUS":
        case 1:
            message.derivation_type = 1;
            break;
        case "ICARUS_TREZOR":
        case 2:
            message.derivation_type = 2;
            break;
        }
        return message;
    };

    CardanoGetNativeScriptHash.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.script = null;
            object.display_format = options.enums === String ? "HIDE" : 0;
            object.derivation_type = options.enums === String ? "LEDGER" : 0;
        }
        if (message.script != null && message.hasOwnProperty("script"))
            object.script = $root.CardanoNativeScript.toObject(message.script, options);
        if (message.display_format != null && message.hasOwnProperty("display_format"))
            object.display_format = options.enums === String ? $root.CardanoNativeScriptHashDisplayFormat[message.display_format] : message.display_format;
        if (message.derivation_type != null && message.hasOwnProperty("derivation_type"))
            object.derivation_type = options.enums === String ? $root.CardanoDerivationType[message.derivation_type] : message.derivation_type;
        return object;
    };

    CardanoGetNativeScriptHash.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoGetNativeScriptHash;
})();

$root.CardanoNativeScriptHash = (function() {

    function CardanoNativeScriptHash(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoNativeScriptHash.prototype.script_hash = $util.newBuffer([]);

    CardanoNativeScriptHash.create = function create(properties) {
        return new CardanoNativeScriptHash(properties);
    };

    CardanoNativeScriptHash.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.script_hash);
        return writer;
    };

    CardanoNativeScriptHash.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoNativeScriptHash.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoNativeScriptHash();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.script_hash = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("script_hash"))
            throw $util.ProtocolError("missing required 'script_hash'", { instance: message });
        return message;
    };

    CardanoNativeScriptHash.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoNativeScriptHash.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.script_hash && typeof message.script_hash.length === "number" || $util.isString(message.script_hash)))
            return "script_hash: buffer expected";
        return null;
    };

    CardanoNativeScriptHash.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoNativeScriptHash)
            return object;
        var message = new $root.CardanoNativeScriptHash();
        if (object.script_hash != null)
            if (typeof object.script_hash === "string")
                $util.base64.decode(object.script_hash, message.script_hash = $util.newBuffer($util.base64.length(object.script_hash)), 0);
            else if (object.script_hash.length)
                message.script_hash = object.script_hash;
        return message;
    };

    CardanoNativeScriptHash.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.script_hash = "";
            else {
                object.script_hash = [];
                if (options.bytes !== Array)
                    object.script_hash = $util.newBuffer(object.script_hash);
            }
        if (message.script_hash != null && message.hasOwnProperty("script_hash"))
            object.script_hash = options.bytes === String ? $util.base64.encode(message.script_hash, 0, message.script_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.script_hash) : message.script_hash;
        return object;
    };

    CardanoNativeScriptHash.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoNativeScriptHash;
})();

$root.CardanoAddressParametersType = (function() {

    function CardanoAddressParametersType(properties) {
        this.address_n = [];
        this.address_n_staking = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoAddressParametersType.prototype.address_type = 0;
    CardanoAddressParametersType.prototype.address_n = $util.emptyArray;
    CardanoAddressParametersType.prototype.address_n_staking = $util.emptyArray;
    CardanoAddressParametersType.prototype.staking_key_hash = $util.newBuffer([]);
    CardanoAddressParametersType.prototype.certificate_pointer = null;
    CardanoAddressParametersType.prototype.script_payment_hash = $util.newBuffer([]);
    CardanoAddressParametersType.prototype.script_staking_hash = $util.newBuffer([]);

    CardanoAddressParametersType.create = function create(properties) {
        return new CardanoAddressParametersType(properties);
    };

    CardanoAddressParametersType.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).int32(message.address_type);
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(16).uint32(message.address_n[i]);
        if (message.address_n_staking != null && message.address_n_staking.length)
            for (var i = 0; i < message.address_n_staking.length; ++i)
                writer.uint32(24).uint32(message.address_n_staking[i]);
        if (message.staking_key_hash != null && Object.hasOwnProperty.call(message, "staking_key_hash"))
            writer.uint32(34).bytes(message.staking_key_hash);
        if (message.certificate_pointer != null && Object.hasOwnProperty.call(message, "certificate_pointer"))
            $root.CardanoBlockchainPointerType.encode(message.certificate_pointer, writer.uint32(42).fork()).ldelim();
        if (message.script_payment_hash != null && Object.hasOwnProperty.call(message, "script_payment_hash"))
            writer.uint32(50).bytes(message.script_payment_hash);
        if (message.script_staking_hash != null && Object.hasOwnProperty.call(message, "script_staking_hash"))
            writer.uint32(58).bytes(message.script_staking_hash);
        return writer;
    };

    CardanoAddressParametersType.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoAddressParametersType.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoAddressParametersType();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address_type = reader.int32();
                break;
            case 2:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 3:
                if (!(message.address_n_staking && message.address_n_staking.length))
                    message.address_n_staking = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n_staking.push(reader.uint32());
                } else
                    message.address_n_staking.push(reader.uint32());
                break;
            case 4:
                message.staking_key_hash = reader.bytes();
                break;
            case 5:
                message.certificate_pointer = $root.CardanoBlockchainPointerType.decode(reader, reader.uint32());
                break;
            case 6:
                message.script_payment_hash = reader.bytes();
                break;
            case 7:
                message.script_staking_hash = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("address_type"))
            throw $util.ProtocolError("missing required 'address_type'", { instance: message });
        return message;
    };

    CardanoAddressParametersType.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoAddressParametersType.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        switch (message.address_type) {
        default:
            return "address_type: enum value expected";
        case 0:
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
        case 6:
        case 7:
        case 8:
        case 14:
        case 15:
            break;
        }
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.address_n_staking != null && message.hasOwnProperty("address_n_staking")) {
            if (!Array.isArray(message.address_n_staking))
                return "address_n_staking: array expected";
            for (var i = 0; i < message.address_n_staking.length; ++i)
                if (!$util.isInteger(message.address_n_staking[i]))
                    return "address_n_staking: integer[] expected";
        }
        if (message.staking_key_hash != null && message.hasOwnProperty("staking_key_hash"))
            if (!(message.staking_key_hash && typeof message.staking_key_hash.length === "number" || $util.isString(message.staking_key_hash)))
                return "staking_key_hash: buffer expected";
        if (message.certificate_pointer != null && message.hasOwnProperty("certificate_pointer")) {
            var error = $root.CardanoBlockchainPointerType.verify(message.certificate_pointer);
            if (error)
                return "certificate_pointer." + error;
        }
        if (message.script_payment_hash != null && message.hasOwnProperty("script_payment_hash"))
            if (!(message.script_payment_hash && typeof message.script_payment_hash.length === "number" || $util.isString(message.script_payment_hash)))
                return "script_payment_hash: buffer expected";
        if (message.script_staking_hash != null && message.hasOwnProperty("script_staking_hash"))
            if (!(message.script_staking_hash && typeof message.script_staking_hash.length === "number" || $util.isString(message.script_staking_hash)))
                return "script_staking_hash: buffer expected";
        return null;
    };

    CardanoAddressParametersType.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoAddressParametersType)
            return object;
        var message = new $root.CardanoAddressParametersType();
        switch (object.address_type) {
        case "BASE":
        case 0:
            message.address_type = 0;
            break;
        case "BASE_SCRIPT_KEY":
        case 1:
            message.address_type = 1;
            break;
        case "BASE_KEY_SCRIPT":
        case 2:
            message.address_type = 2;
            break;
        case "BASE_SCRIPT_SCRIPT":
        case 3:
            message.address_type = 3;
            break;
        case "POINTER":
        case 4:
            message.address_type = 4;
            break;
        case "POINTER_SCRIPT":
        case 5:
            message.address_type = 5;
            break;
        case "ENTERPRISE":
        case 6:
            message.address_type = 6;
            break;
        case "ENTERPRISE_SCRIPT":
        case 7:
            message.address_type = 7;
            break;
        case "BYRON":
        case 8:
            message.address_type = 8;
            break;
        case "REWARD":
        case 14:
            message.address_type = 14;
            break;
        case "REWARD_SCRIPT":
        case 15:
            message.address_type = 15;
            break;
        }
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".CardanoAddressParametersType.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.address_n_staking) {
            if (!Array.isArray(object.address_n_staking))
                throw TypeError(".CardanoAddressParametersType.address_n_staking: array expected");
            message.address_n_staking = [];
            for (var i = 0; i < object.address_n_staking.length; ++i)
                message.address_n_staking[i] = object.address_n_staking[i] >>> 0;
        }
        if (object.staking_key_hash != null)
            if (typeof object.staking_key_hash === "string")
                $util.base64.decode(object.staking_key_hash, message.staking_key_hash = $util.newBuffer($util.base64.length(object.staking_key_hash)), 0);
            else if (object.staking_key_hash.length)
                message.staking_key_hash = object.staking_key_hash;
        if (object.certificate_pointer != null) {
            if (typeof object.certificate_pointer !== "object")
                throw TypeError(".CardanoAddressParametersType.certificate_pointer: object expected");
            message.certificate_pointer = $root.CardanoBlockchainPointerType.fromObject(object.certificate_pointer);
        }
        if (object.script_payment_hash != null)
            if (typeof object.script_payment_hash === "string")
                $util.base64.decode(object.script_payment_hash, message.script_payment_hash = $util.newBuffer($util.base64.length(object.script_payment_hash)), 0);
            else if (object.script_payment_hash.length)
                message.script_payment_hash = object.script_payment_hash;
        if (object.script_staking_hash != null)
            if (typeof object.script_staking_hash === "string")
                $util.base64.decode(object.script_staking_hash, message.script_staking_hash = $util.newBuffer($util.base64.length(object.script_staking_hash)), 0);
            else if (object.script_staking_hash.length)
                message.script_staking_hash = object.script_staking_hash;
        return message;
    };

    CardanoAddressParametersType.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults) {
            object.address_n = [];
            object.address_n_staking = [];
        }
        if (options.defaults) {
            object.address_type = options.enums === String ? "BASE" : 0;
            if (options.bytes === String)
                object.staking_key_hash = "";
            else {
                object.staking_key_hash = [];
                if (options.bytes !== Array)
                    object.staking_key_hash = $util.newBuffer(object.staking_key_hash);
            }
            object.certificate_pointer = null;
            if (options.bytes === String)
                object.script_payment_hash = "";
            else {
                object.script_payment_hash = [];
                if (options.bytes !== Array)
                    object.script_payment_hash = $util.newBuffer(object.script_payment_hash);
            }
            if (options.bytes === String)
                object.script_staking_hash = "";
            else {
                object.script_staking_hash = [];
                if (options.bytes !== Array)
                    object.script_staking_hash = $util.newBuffer(object.script_staking_hash);
            }
        }
        if (message.address_type != null && message.hasOwnProperty("address_type"))
            object.address_type = options.enums === String ? $root.CardanoAddressType[message.address_type] : message.address_type;
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.address_n_staking && message.address_n_staking.length) {
            object.address_n_staking = [];
            for (var j = 0; j < message.address_n_staking.length; ++j)
                object.address_n_staking[j] = message.address_n_staking[j];
        }
        if (message.staking_key_hash != null && message.hasOwnProperty("staking_key_hash"))
            object.staking_key_hash = options.bytes === String ? $util.base64.encode(message.staking_key_hash, 0, message.staking_key_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.staking_key_hash) : message.staking_key_hash;
        if (message.certificate_pointer != null && message.hasOwnProperty("certificate_pointer"))
            object.certificate_pointer = $root.CardanoBlockchainPointerType.toObject(message.certificate_pointer, options);
        if (message.script_payment_hash != null && message.hasOwnProperty("script_payment_hash"))
            object.script_payment_hash = options.bytes === String ? $util.base64.encode(message.script_payment_hash, 0, message.script_payment_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.script_payment_hash) : message.script_payment_hash;
        if (message.script_staking_hash != null && message.hasOwnProperty("script_staking_hash"))
            object.script_staking_hash = options.bytes === String ? $util.base64.encode(message.script_staking_hash, 0, message.script_staking_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.script_staking_hash) : message.script_staking_hash;
        return object;
    };

    CardanoAddressParametersType.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoAddressParametersType;
})();

$root.CardanoGetAddress = (function() {

    function CardanoGetAddress(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoGetAddress.prototype.show_display = false;
    CardanoGetAddress.prototype.protocol_magic = 0;
    CardanoGetAddress.prototype.network_id = 0;
    CardanoGetAddress.prototype.address_parameters = null;
    CardanoGetAddress.prototype.derivation_type = 0;
    CardanoGetAddress.prototype.chunkify = false;

    CardanoGetAddress.create = function create(properties) {
        return new CardanoGetAddress(properties);
    };

    CardanoGetAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(16).bool(message.show_display);
        writer.uint32(24).uint32(message.protocol_magic);
        writer.uint32(32).uint32(message.network_id);
        $root.CardanoAddressParametersType.encode(message.address_parameters, writer.uint32(42).fork()).ldelim();
        writer.uint32(48).int32(message.derivation_type);
        if (message.chunkify != null && Object.hasOwnProperty.call(message, "chunkify"))
            writer.uint32(56).bool(message.chunkify);
        return writer;
    };

    CardanoGetAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoGetAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoGetAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 2:
                message.show_display = reader.bool();
                break;
            case 3:
                message.protocol_magic = reader.uint32();
                break;
            case 4:
                message.network_id = reader.uint32();
                break;
            case 5:
                message.address_parameters = $root.CardanoAddressParametersType.decode(reader, reader.uint32());
                break;
            case 6:
                message.derivation_type = reader.int32();
                break;
            case 7:
                message.chunkify = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("protocol_magic"))
            throw $util.ProtocolError("missing required 'protocol_magic'", { instance: message });
        if (!message.hasOwnProperty("network_id"))
            throw $util.ProtocolError("missing required 'network_id'", { instance: message });
        if (!message.hasOwnProperty("address_parameters"))
            throw $util.ProtocolError("missing required 'address_parameters'", { instance: message });
        if (!message.hasOwnProperty("derivation_type"))
            throw $util.ProtocolError("missing required 'derivation_type'", { instance: message });
        return message;
    };

    CardanoGetAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoGetAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        if (!$util.isInteger(message.protocol_magic))
            return "protocol_magic: integer expected";
        if (!$util.isInteger(message.network_id))
            return "network_id: integer expected";
        {
            var error = $root.CardanoAddressParametersType.verify(message.address_parameters);
            if (error)
                return "address_parameters." + error;
        }
        switch (message.derivation_type) {
        default:
            return "derivation_type: enum value expected";
        case 0:
        case 1:
        case 2:
            break;
        }
        if (message.chunkify != null && message.hasOwnProperty("chunkify"))
            if (typeof message.chunkify !== "boolean")
                return "chunkify: boolean expected";
        return null;
    };

    CardanoGetAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoGetAddress)
            return object;
        var message = new $root.CardanoGetAddress();
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        if (object.protocol_magic != null)
            message.protocol_magic = object.protocol_magic >>> 0;
        if (object.network_id != null)
            message.network_id = object.network_id >>> 0;
        if (object.address_parameters != null) {
            if (typeof object.address_parameters !== "object")
                throw TypeError(".CardanoGetAddress.address_parameters: object expected");
            message.address_parameters = $root.CardanoAddressParametersType.fromObject(object.address_parameters);
        }
        switch (object.derivation_type) {
        case "LEDGER":
        case 0:
            message.derivation_type = 0;
            break;
        case "ICARUS":
        case 1:
            message.derivation_type = 1;
            break;
        case "ICARUS_TREZOR":
        case 2:
            message.derivation_type = 2;
            break;
        }
        if (object.chunkify != null)
            message.chunkify = Boolean(object.chunkify);
        return message;
    };

    CardanoGetAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.show_display = false;
            object.protocol_magic = 0;
            object.network_id = 0;
            object.address_parameters = null;
            object.derivation_type = options.enums === String ? "LEDGER" : 0;
            object.chunkify = false;
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        if (message.protocol_magic != null && message.hasOwnProperty("protocol_magic"))
            object.protocol_magic = message.protocol_magic;
        if (message.network_id != null && message.hasOwnProperty("network_id"))
            object.network_id = message.network_id;
        if (message.address_parameters != null && message.hasOwnProperty("address_parameters"))
            object.address_parameters = $root.CardanoAddressParametersType.toObject(message.address_parameters, options);
        if (message.derivation_type != null && message.hasOwnProperty("derivation_type"))
            object.derivation_type = options.enums === String ? $root.CardanoDerivationType[message.derivation_type] : message.derivation_type;
        if (message.chunkify != null && message.hasOwnProperty("chunkify"))
            object.chunkify = message.chunkify;
        return object;
    };

    CardanoGetAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoGetAddress;
})();

$root.CardanoAddress = (function() {

    function CardanoAddress(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoAddress.prototype.address = "";

    CardanoAddress.create = function create(properties) {
        return new CardanoAddress(properties);
    };

    CardanoAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.address);
        return writer;
    };

    CardanoAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("address"))
            throw $util.ProtocolError("missing required 'address'", { instance: message });
        return message;
    };

    CardanoAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.address))
            return "address: string expected";
        return null;
    };

    CardanoAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoAddress)
            return object;
        var message = new $root.CardanoAddress();
        if (object.address != null)
            message.address = String(object.address);
        return message;
    };

    CardanoAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.address = "";
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    CardanoAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoAddress;
})();

$root.CardanoGetPublicKey = (function() {

    function CardanoGetPublicKey(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoGetPublicKey.prototype.address_n = $util.emptyArray;
    CardanoGetPublicKey.prototype.show_display = false;
    CardanoGetPublicKey.prototype.derivation_type = 0;

    CardanoGetPublicKey.create = function create(properties) {
        return new CardanoGetPublicKey(properties);
    };

    CardanoGetPublicKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(16).bool(message.show_display);
        writer.uint32(24).int32(message.derivation_type);
        return writer;
    };

    CardanoGetPublicKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoGetPublicKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoGetPublicKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.show_display = reader.bool();
                break;
            case 3:
                message.derivation_type = reader.int32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("derivation_type"))
            throw $util.ProtocolError("missing required 'derivation_type'", { instance: message });
        return message;
    };

    CardanoGetPublicKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoGetPublicKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        switch (message.derivation_type) {
        default:
            return "derivation_type: enum value expected";
        case 0:
        case 1:
        case 2:
            break;
        }
        return null;
    };

    CardanoGetPublicKey.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoGetPublicKey)
            return object;
        var message = new $root.CardanoGetPublicKey();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".CardanoGetPublicKey.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        switch (object.derivation_type) {
        case "LEDGER":
        case 0:
            message.derivation_type = 0;
            break;
        case "ICARUS":
        case 1:
            message.derivation_type = 1;
            break;
        case "ICARUS_TREZOR":
        case 2:
            message.derivation_type = 2;
            break;
        }
        return message;
    };

    CardanoGetPublicKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            object.show_display = false;
            object.derivation_type = options.enums === String ? "LEDGER" : 0;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        if (message.derivation_type != null && message.hasOwnProperty("derivation_type"))
            object.derivation_type = options.enums === String ? $root.CardanoDerivationType[message.derivation_type] : message.derivation_type;
        return object;
    };

    CardanoGetPublicKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoGetPublicKey;
})();

$root.CardanoPublicKey = (function() {

    function CardanoPublicKey(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoPublicKey.prototype.xpub = "";
    CardanoPublicKey.prototype.node = null;

    CardanoPublicKey.create = function create(properties) {
        return new CardanoPublicKey(properties);
    };

    CardanoPublicKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.xpub);
        $root.HDNodeType.encode(message.node, writer.uint32(18).fork()).ldelim();
        return writer;
    };

    CardanoPublicKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoPublicKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoPublicKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.xpub = reader.string();
                break;
            case 2:
                message.node = $root.HDNodeType.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("xpub"))
            throw $util.ProtocolError("missing required 'xpub'", { instance: message });
        if (!message.hasOwnProperty("node"))
            throw $util.ProtocolError("missing required 'node'", { instance: message });
        return message;
    };

    CardanoPublicKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoPublicKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.xpub))
            return "xpub: string expected";
        {
            var error = $root.HDNodeType.verify(message.node);
            if (error)
                return "node." + error;
        }
        return null;
    };

    CardanoPublicKey.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoPublicKey)
            return object;
        var message = new $root.CardanoPublicKey();
        if (object.xpub != null)
            message.xpub = String(object.xpub);
        if (object.node != null) {
            if (typeof object.node !== "object")
                throw TypeError(".CardanoPublicKey.node: object expected");
            message.node = $root.HDNodeType.fromObject(object.node);
        }
        return message;
    };

    CardanoPublicKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.xpub = "";
            object.node = null;
        }
        if (message.xpub != null && message.hasOwnProperty("xpub"))
            object.xpub = message.xpub;
        if (message.node != null && message.hasOwnProperty("node"))
            object.node = $root.HDNodeType.toObject(message.node, options);
        return object;
    };

    CardanoPublicKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoPublicKey;
})();

$root.CardanoSignTxInit = (function() {

    function CardanoSignTxInit(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoSignTxInit.prototype.signing_mode = 0;
    CardanoSignTxInit.prototype.protocol_magic = 0;
    CardanoSignTxInit.prototype.network_id = 0;
    CardanoSignTxInit.prototype.inputs_count = 0;
    CardanoSignTxInit.prototype.outputs_count = 0;
    CardanoSignTxInit.prototype.fee = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    CardanoSignTxInit.prototype.ttl = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    CardanoSignTxInit.prototype.certificates_count = 0;
    CardanoSignTxInit.prototype.withdrawals_count = 0;
    CardanoSignTxInit.prototype.has_auxiliary_data = false;
    CardanoSignTxInit.prototype.validity_interval_start = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    CardanoSignTxInit.prototype.witness_requests_count = 0;
    CardanoSignTxInit.prototype.minting_asset_groups_count = 0;
    CardanoSignTxInit.prototype.derivation_type = 0;
    CardanoSignTxInit.prototype.include_network_id = false;
    CardanoSignTxInit.prototype.script_data_hash = $util.newBuffer([]);
    CardanoSignTxInit.prototype.collateral_inputs_count = 0;
    CardanoSignTxInit.prototype.required_signers_count = 0;
    CardanoSignTxInit.prototype.has_collateral_return = false;
    CardanoSignTxInit.prototype.total_collateral = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    CardanoSignTxInit.prototype.reference_inputs_count = 0;
    CardanoSignTxInit.prototype.chunkify = false;
    CardanoSignTxInit.prototype.tag_cbor_sets = false;

    CardanoSignTxInit.create = function create(properties) {
        return new CardanoSignTxInit(properties);
    };

    CardanoSignTxInit.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).int32(message.signing_mode);
        writer.uint32(16).uint32(message.protocol_magic);
        writer.uint32(24).uint32(message.network_id);
        writer.uint32(32).uint32(message.inputs_count);
        writer.uint32(40).uint32(message.outputs_count);
        writer.uint32(48).uint64(message.fee);
        if (message.ttl != null && Object.hasOwnProperty.call(message, "ttl"))
            writer.uint32(56).uint64(message.ttl);
        writer.uint32(64).uint32(message.certificates_count);
        writer.uint32(72).uint32(message.withdrawals_count);
        writer.uint32(80).bool(message.has_auxiliary_data);
        if (message.validity_interval_start != null && Object.hasOwnProperty.call(message, "validity_interval_start"))
            writer.uint32(88).uint64(message.validity_interval_start);
        writer.uint32(96).uint32(message.witness_requests_count);
        writer.uint32(104).uint32(message.minting_asset_groups_count);
        writer.uint32(112).int32(message.derivation_type);
        if (message.include_network_id != null && Object.hasOwnProperty.call(message, "include_network_id"))
            writer.uint32(120).bool(message.include_network_id);
        if (message.script_data_hash != null && Object.hasOwnProperty.call(message, "script_data_hash"))
            writer.uint32(130).bytes(message.script_data_hash);
        writer.uint32(136).uint32(message.collateral_inputs_count);
        writer.uint32(144).uint32(message.required_signers_count);
        if (message.has_collateral_return != null && Object.hasOwnProperty.call(message, "has_collateral_return"))
            writer.uint32(152).bool(message.has_collateral_return);
        if (message.total_collateral != null && Object.hasOwnProperty.call(message, "total_collateral"))
            writer.uint32(160).uint64(message.total_collateral);
        if (message.reference_inputs_count != null && Object.hasOwnProperty.call(message, "reference_inputs_count"))
            writer.uint32(168).uint32(message.reference_inputs_count);
        if (message.chunkify != null && Object.hasOwnProperty.call(message, "chunkify"))
            writer.uint32(176).bool(message.chunkify);
        if (message.tag_cbor_sets != null && Object.hasOwnProperty.call(message, "tag_cbor_sets"))
            writer.uint32(184).bool(message.tag_cbor_sets);
        return writer;
    };

    CardanoSignTxInit.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoSignTxInit.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoSignTxInit();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.signing_mode = reader.int32();
                break;
            case 2:
                message.protocol_magic = reader.uint32();
                break;
            case 3:
                message.network_id = reader.uint32();
                break;
            case 4:
                message.inputs_count = reader.uint32();
                break;
            case 5:
                message.outputs_count = reader.uint32();
                break;
            case 6:
                message.fee = reader.uint64();
                break;
            case 7:
                message.ttl = reader.uint64();
                break;
            case 8:
                message.certificates_count = reader.uint32();
                break;
            case 9:
                message.withdrawals_count = reader.uint32();
                break;
            case 10:
                message.has_auxiliary_data = reader.bool();
                break;
            case 11:
                message.validity_interval_start = reader.uint64();
                break;
            case 12:
                message.witness_requests_count = reader.uint32();
                break;
            case 13:
                message.minting_asset_groups_count = reader.uint32();
                break;
            case 14:
                message.derivation_type = reader.int32();
                break;
            case 15:
                message.include_network_id = reader.bool();
                break;
            case 16:
                message.script_data_hash = reader.bytes();
                break;
            case 17:
                message.collateral_inputs_count = reader.uint32();
                break;
            case 18:
                message.required_signers_count = reader.uint32();
                break;
            case 19:
                message.has_collateral_return = reader.bool();
                break;
            case 20:
                message.total_collateral = reader.uint64();
                break;
            case 21:
                message.reference_inputs_count = reader.uint32();
                break;
            case 22:
                message.chunkify = reader.bool();
                break;
            case 23:
                message.tag_cbor_sets = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("signing_mode"))
            throw $util.ProtocolError("missing required 'signing_mode'", { instance: message });
        if (!message.hasOwnProperty("protocol_magic"))
            throw $util.ProtocolError("missing required 'protocol_magic'", { instance: message });
        if (!message.hasOwnProperty("network_id"))
            throw $util.ProtocolError("missing required 'network_id'", { instance: message });
        if (!message.hasOwnProperty("inputs_count"))
            throw $util.ProtocolError("missing required 'inputs_count'", { instance: message });
        if (!message.hasOwnProperty("outputs_count"))
            throw $util.ProtocolError("missing required 'outputs_count'", { instance: message });
        if (!message.hasOwnProperty("fee"))
            throw $util.ProtocolError("missing required 'fee'", { instance: message });
        if (!message.hasOwnProperty("certificates_count"))
            throw $util.ProtocolError("missing required 'certificates_count'", { instance: message });
        if (!message.hasOwnProperty("withdrawals_count"))
            throw $util.ProtocolError("missing required 'withdrawals_count'", { instance: message });
        if (!message.hasOwnProperty("has_auxiliary_data"))
            throw $util.ProtocolError("missing required 'has_auxiliary_data'", { instance: message });
        if (!message.hasOwnProperty("witness_requests_count"))
            throw $util.ProtocolError("missing required 'witness_requests_count'", { instance: message });
        if (!message.hasOwnProperty("minting_asset_groups_count"))
            throw $util.ProtocolError("missing required 'minting_asset_groups_count'", { instance: message });
        if (!message.hasOwnProperty("derivation_type"))
            throw $util.ProtocolError("missing required 'derivation_type'", { instance: message });
        if (!message.hasOwnProperty("collateral_inputs_count"))
            throw $util.ProtocolError("missing required 'collateral_inputs_count'", { instance: message });
        if (!message.hasOwnProperty("required_signers_count"))
            throw $util.ProtocolError("missing required 'required_signers_count'", { instance: message });
        return message;
    };

    CardanoSignTxInit.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoSignTxInit.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        switch (message.signing_mode) {
        default:
            return "signing_mode: enum value expected";
        case 0:
        case 1:
        case 2:
        case 3:
            break;
        }
        if (!$util.isInteger(message.protocol_magic))
            return "protocol_magic: integer expected";
        if (!$util.isInteger(message.network_id))
            return "network_id: integer expected";
        if (!$util.isInteger(message.inputs_count))
            return "inputs_count: integer expected";
        if (!$util.isInteger(message.outputs_count))
            return "outputs_count: integer expected";
        if (!$util.isInteger(message.fee) && !(message.fee && $util.isInteger(message.fee.low) && $util.isInteger(message.fee.high)))
            return "fee: integer|Long expected";
        if (message.ttl != null && message.hasOwnProperty("ttl"))
            if (!$util.isInteger(message.ttl) && !(message.ttl && $util.isInteger(message.ttl.low) && $util.isInteger(message.ttl.high)))
                return "ttl: integer|Long expected";
        if (!$util.isInteger(message.certificates_count))
            return "certificates_count: integer expected";
        if (!$util.isInteger(message.withdrawals_count))
            return "withdrawals_count: integer expected";
        if (typeof message.has_auxiliary_data !== "boolean")
            return "has_auxiliary_data: boolean expected";
        if (message.validity_interval_start != null && message.hasOwnProperty("validity_interval_start"))
            if (!$util.isInteger(message.validity_interval_start) && !(message.validity_interval_start && $util.isInteger(message.validity_interval_start.low) && $util.isInteger(message.validity_interval_start.high)))
                return "validity_interval_start: integer|Long expected";
        if (!$util.isInteger(message.witness_requests_count))
            return "witness_requests_count: integer expected";
        if (!$util.isInteger(message.minting_asset_groups_count))
            return "minting_asset_groups_count: integer expected";
        switch (message.derivation_type) {
        default:
            return "derivation_type: enum value expected";
        case 0:
        case 1:
        case 2:
            break;
        }
        if (message.include_network_id != null && message.hasOwnProperty("include_network_id"))
            if (typeof message.include_network_id !== "boolean")
                return "include_network_id: boolean expected";
        if (message.script_data_hash != null && message.hasOwnProperty("script_data_hash"))
            if (!(message.script_data_hash && typeof message.script_data_hash.length === "number" || $util.isString(message.script_data_hash)))
                return "script_data_hash: buffer expected";
        if (!$util.isInteger(message.collateral_inputs_count))
            return "collateral_inputs_count: integer expected";
        if (!$util.isInteger(message.required_signers_count))
            return "required_signers_count: integer expected";
        if (message.has_collateral_return != null && message.hasOwnProperty("has_collateral_return"))
            if (typeof message.has_collateral_return !== "boolean")
                return "has_collateral_return: boolean expected";
        if (message.total_collateral != null && message.hasOwnProperty("total_collateral"))
            if (!$util.isInteger(message.total_collateral) && !(message.total_collateral && $util.isInteger(message.total_collateral.low) && $util.isInteger(message.total_collateral.high)))
                return "total_collateral: integer|Long expected";
        if (message.reference_inputs_count != null && message.hasOwnProperty("reference_inputs_count"))
            if (!$util.isInteger(message.reference_inputs_count))
                return "reference_inputs_count: integer expected";
        if (message.chunkify != null && message.hasOwnProperty("chunkify"))
            if (typeof message.chunkify !== "boolean")
                return "chunkify: boolean expected";
        if (message.tag_cbor_sets != null && message.hasOwnProperty("tag_cbor_sets"))
            if (typeof message.tag_cbor_sets !== "boolean")
                return "tag_cbor_sets: boolean expected";
        return null;
    };

    CardanoSignTxInit.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoSignTxInit)
            return object;
        var message = new $root.CardanoSignTxInit();
        switch (object.signing_mode) {
        case "ORDINARY_TRANSACTION":
        case 0:
            message.signing_mode = 0;
            break;
        case "POOL_REGISTRATION_AS_OWNER":
        case 1:
            message.signing_mode = 1;
            break;
        case "MULTISIG_TRANSACTION":
        case 2:
            message.signing_mode = 2;
            break;
        case "PLUTUS_TRANSACTION":
        case 3:
            message.signing_mode = 3;
            break;
        }
        if (object.protocol_magic != null)
            message.protocol_magic = object.protocol_magic >>> 0;
        if (object.network_id != null)
            message.network_id = object.network_id >>> 0;
        if (object.inputs_count != null)
            message.inputs_count = object.inputs_count >>> 0;
        if (object.outputs_count != null)
            message.outputs_count = object.outputs_count >>> 0;
        if (object.fee != null)
            if ($util.Long)
                (message.fee = $util.Long.fromValue(object.fee)).unsigned = true;
            else if (typeof object.fee === "string")
                message.fee = parseInt(object.fee, 10);
            else if (typeof object.fee === "number")
                message.fee = object.fee;
            else if (typeof object.fee === "object")
                message.fee = new $util.LongBits(object.fee.low >>> 0, object.fee.high >>> 0).toNumber(true);
        if (object.ttl != null)
            if ($util.Long)
                (message.ttl = $util.Long.fromValue(object.ttl)).unsigned = true;
            else if (typeof object.ttl === "string")
                message.ttl = parseInt(object.ttl, 10);
            else if (typeof object.ttl === "number")
                message.ttl = object.ttl;
            else if (typeof object.ttl === "object")
                message.ttl = new $util.LongBits(object.ttl.low >>> 0, object.ttl.high >>> 0).toNumber(true);
        if (object.certificates_count != null)
            message.certificates_count = object.certificates_count >>> 0;
        if (object.withdrawals_count != null)
            message.withdrawals_count = object.withdrawals_count >>> 0;
        if (object.has_auxiliary_data != null)
            message.has_auxiliary_data = Boolean(object.has_auxiliary_data);
        if (object.validity_interval_start != null)
            if ($util.Long)
                (message.validity_interval_start = $util.Long.fromValue(object.validity_interval_start)).unsigned = true;
            else if (typeof object.validity_interval_start === "string")
                message.validity_interval_start = parseInt(object.validity_interval_start, 10);
            else if (typeof object.validity_interval_start === "number")
                message.validity_interval_start = object.validity_interval_start;
            else if (typeof object.validity_interval_start === "object")
                message.validity_interval_start = new $util.LongBits(object.validity_interval_start.low >>> 0, object.validity_interval_start.high >>> 0).toNumber(true);
        if (object.witness_requests_count != null)
            message.witness_requests_count = object.witness_requests_count >>> 0;
        if (object.minting_asset_groups_count != null)
            message.minting_asset_groups_count = object.minting_asset_groups_count >>> 0;
        switch (object.derivation_type) {
        case "LEDGER":
        case 0:
            message.derivation_type = 0;
            break;
        case "ICARUS":
        case 1:
            message.derivation_type = 1;
            break;
        case "ICARUS_TREZOR":
        case 2:
            message.derivation_type = 2;
            break;
        }
        if (object.include_network_id != null)
            message.include_network_id = Boolean(object.include_network_id);
        if (object.script_data_hash != null)
            if (typeof object.script_data_hash === "string")
                $util.base64.decode(object.script_data_hash, message.script_data_hash = $util.newBuffer($util.base64.length(object.script_data_hash)), 0);
            else if (object.script_data_hash.length)
                message.script_data_hash = object.script_data_hash;
        if (object.collateral_inputs_count != null)
            message.collateral_inputs_count = object.collateral_inputs_count >>> 0;
        if (object.required_signers_count != null)
            message.required_signers_count = object.required_signers_count >>> 0;
        if (object.has_collateral_return != null)
            message.has_collateral_return = Boolean(object.has_collateral_return);
        if (object.total_collateral != null)
            if ($util.Long)
                (message.total_collateral = $util.Long.fromValue(object.total_collateral)).unsigned = true;
            else if (typeof object.total_collateral === "string")
                message.total_collateral = parseInt(object.total_collateral, 10);
            else if (typeof object.total_collateral === "number")
                message.total_collateral = object.total_collateral;
            else if (typeof object.total_collateral === "object")
                message.total_collateral = new $util.LongBits(object.total_collateral.low >>> 0, object.total_collateral.high >>> 0).toNumber(true);
        if (object.reference_inputs_count != null)
            message.reference_inputs_count = object.reference_inputs_count >>> 0;
        if (object.chunkify != null)
            message.chunkify = Boolean(object.chunkify);
        if (object.tag_cbor_sets != null)
            message.tag_cbor_sets = Boolean(object.tag_cbor_sets);
        return message;
    };

    CardanoSignTxInit.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.signing_mode = options.enums === String ? "ORDINARY_TRANSACTION" : 0;
            object.protocol_magic = 0;
            object.network_id = 0;
            object.inputs_count = 0;
            object.outputs_count = 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.fee = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.fee = options.longs === String ? "0" : 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.ttl = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.ttl = options.longs === String ? "0" : 0;
            object.certificates_count = 0;
            object.withdrawals_count = 0;
            object.has_auxiliary_data = false;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.validity_interval_start = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.validity_interval_start = options.longs === String ? "0" : 0;
            object.witness_requests_count = 0;
            object.minting_asset_groups_count = 0;
            object.derivation_type = options.enums === String ? "LEDGER" : 0;
            object.include_network_id = false;
            if (options.bytes === String)
                object.script_data_hash = "";
            else {
                object.script_data_hash = [];
                if (options.bytes !== Array)
                    object.script_data_hash = $util.newBuffer(object.script_data_hash);
            }
            object.collateral_inputs_count = 0;
            object.required_signers_count = 0;
            object.has_collateral_return = false;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.total_collateral = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.total_collateral = options.longs === String ? "0" : 0;
            object.reference_inputs_count = 0;
            object.chunkify = false;
            object.tag_cbor_sets = false;
        }
        if (message.signing_mode != null && message.hasOwnProperty("signing_mode"))
            object.signing_mode = options.enums === String ? $root.CardanoTxSigningMode[message.signing_mode] : message.signing_mode;
        if (message.protocol_magic != null && message.hasOwnProperty("protocol_magic"))
            object.protocol_magic = message.protocol_magic;
        if (message.network_id != null && message.hasOwnProperty("network_id"))
            object.network_id = message.network_id;
        if (message.inputs_count != null && message.hasOwnProperty("inputs_count"))
            object.inputs_count = message.inputs_count;
        if (message.outputs_count != null && message.hasOwnProperty("outputs_count"))
            object.outputs_count = message.outputs_count;
        if (message.fee != null && message.hasOwnProperty("fee"))
            if (typeof message.fee === "number")
                object.fee = options.longs === String ? String(message.fee) : message.fee;
            else
                object.fee = options.longs === String ? $util.Long.prototype.toString.call(message.fee) : options.longs === Number ? new $util.LongBits(message.fee.low >>> 0, message.fee.high >>> 0).toNumber(true) : message.fee;
        if (message.ttl != null && message.hasOwnProperty("ttl"))
            if (typeof message.ttl === "number")
                object.ttl = options.longs === String ? String(message.ttl) : message.ttl;
            else
                object.ttl = options.longs === String ? $util.Long.prototype.toString.call(message.ttl) : options.longs === Number ? new $util.LongBits(message.ttl.low >>> 0, message.ttl.high >>> 0).toNumber(true) : message.ttl;
        if (message.certificates_count != null && message.hasOwnProperty("certificates_count"))
            object.certificates_count = message.certificates_count;
        if (message.withdrawals_count != null && message.hasOwnProperty("withdrawals_count"))
            object.withdrawals_count = message.withdrawals_count;
        if (message.has_auxiliary_data != null && message.hasOwnProperty("has_auxiliary_data"))
            object.has_auxiliary_data = message.has_auxiliary_data;
        if (message.validity_interval_start != null && message.hasOwnProperty("validity_interval_start"))
            if (typeof message.validity_interval_start === "number")
                object.validity_interval_start = options.longs === String ? String(message.validity_interval_start) : message.validity_interval_start;
            else
                object.validity_interval_start = options.longs === String ? $util.Long.prototype.toString.call(message.validity_interval_start) : options.longs === Number ? new $util.LongBits(message.validity_interval_start.low >>> 0, message.validity_interval_start.high >>> 0).toNumber(true) : message.validity_interval_start;
        if (message.witness_requests_count != null && message.hasOwnProperty("witness_requests_count"))
            object.witness_requests_count = message.witness_requests_count;
        if (message.minting_asset_groups_count != null && message.hasOwnProperty("minting_asset_groups_count"))
            object.minting_asset_groups_count = message.minting_asset_groups_count;
        if (message.derivation_type != null && message.hasOwnProperty("derivation_type"))
            object.derivation_type = options.enums === String ? $root.CardanoDerivationType[message.derivation_type] : message.derivation_type;
        if (message.include_network_id != null && message.hasOwnProperty("include_network_id"))
            object.include_network_id = message.include_network_id;
        if (message.script_data_hash != null && message.hasOwnProperty("script_data_hash"))
            object.script_data_hash = options.bytes === String ? $util.base64.encode(message.script_data_hash, 0, message.script_data_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.script_data_hash) : message.script_data_hash;
        if (message.collateral_inputs_count != null && message.hasOwnProperty("collateral_inputs_count"))
            object.collateral_inputs_count = message.collateral_inputs_count;
        if (message.required_signers_count != null && message.hasOwnProperty("required_signers_count"))
            object.required_signers_count = message.required_signers_count;
        if (message.has_collateral_return != null && message.hasOwnProperty("has_collateral_return"))
            object.has_collateral_return = message.has_collateral_return;
        if (message.total_collateral != null && message.hasOwnProperty("total_collateral"))
            if (typeof message.total_collateral === "number")
                object.total_collateral = options.longs === String ? String(message.total_collateral) : message.total_collateral;
            else
                object.total_collateral = options.longs === String ? $util.Long.prototype.toString.call(message.total_collateral) : options.longs === Number ? new $util.LongBits(message.total_collateral.low >>> 0, message.total_collateral.high >>> 0).toNumber(true) : message.total_collateral;
        if (message.reference_inputs_count != null && message.hasOwnProperty("reference_inputs_count"))
            object.reference_inputs_count = message.reference_inputs_count;
        if (message.chunkify != null && message.hasOwnProperty("chunkify"))
            object.chunkify = message.chunkify;
        if (message.tag_cbor_sets != null && message.hasOwnProperty("tag_cbor_sets"))
            object.tag_cbor_sets = message.tag_cbor_sets;
        return object;
    };

    CardanoSignTxInit.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoSignTxInit;
})();

$root.CardanoTxInput = (function() {

    function CardanoTxInput(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoTxInput.prototype.prev_hash = $util.newBuffer([]);
    CardanoTxInput.prototype.prev_index = 0;

    CardanoTxInput.create = function create(properties) {
        return new CardanoTxInput(properties);
    };

    CardanoTxInput.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.prev_hash);
        writer.uint32(16).uint32(message.prev_index);
        return writer;
    };

    CardanoTxInput.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoTxInput.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoTxInput();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.prev_hash = reader.bytes();
                break;
            case 2:
                message.prev_index = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("prev_hash"))
            throw $util.ProtocolError("missing required 'prev_hash'", { instance: message });
        if (!message.hasOwnProperty("prev_index"))
            throw $util.ProtocolError("missing required 'prev_index'", { instance: message });
        return message;
    };

    CardanoTxInput.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoTxInput.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.prev_hash && typeof message.prev_hash.length === "number" || $util.isString(message.prev_hash)))
            return "prev_hash: buffer expected";
        if (!$util.isInteger(message.prev_index))
            return "prev_index: integer expected";
        return null;
    };

    CardanoTxInput.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoTxInput)
            return object;
        var message = new $root.CardanoTxInput();
        if (object.prev_hash != null)
            if (typeof object.prev_hash === "string")
                $util.base64.decode(object.prev_hash, message.prev_hash = $util.newBuffer($util.base64.length(object.prev_hash)), 0);
            else if (object.prev_hash.length)
                message.prev_hash = object.prev_hash;
        if (object.prev_index != null)
            message.prev_index = object.prev_index >>> 0;
        return message;
    };

    CardanoTxInput.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.prev_hash = "";
            else {
                object.prev_hash = [];
                if (options.bytes !== Array)
                    object.prev_hash = $util.newBuffer(object.prev_hash);
            }
            object.prev_index = 0;
        }
        if (message.prev_hash != null && message.hasOwnProperty("prev_hash"))
            object.prev_hash = options.bytes === String ? $util.base64.encode(message.prev_hash, 0, message.prev_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.prev_hash) : message.prev_hash;
        if (message.prev_index != null && message.hasOwnProperty("prev_index"))
            object.prev_index = message.prev_index;
        return object;
    };

    CardanoTxInput.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoTxInput;
})();

$root.CardanoTxOutput = (function() {

    function CardanoTxOutput(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoTxOutput.prototype.address = "";
    CardanoTxOutput.prototype.address_parameters = null;
    CardanoTxOutput.prototype.amount = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    CardanoTxOutput.prototype.asset_groups_count = 0;
    CardanoTxOutput.prototype.datum_hash = $util.newBuffer([]);
    CardanoTxOutput.prototype.format = 0;
    CardanoTxOutput.prototype.inline_datum_size = 0;
    CardanoTxOutput.prototype.reference_script_size = 0;

    CardanoTxOutput.create = function create(properties) {
        return new CardanoTxOutput(properties);
    };

    CardanoTxOutput.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address != null && Object.hasOwnProperty.call(message, "address"))
            writer.uint32(10).string(message.address);
        if (message.address_parameters != null && Object.hasOwnProperty.call(message, "address_parameters"))
            $root.CardanoAddressParametersType.encode(message.address_parameters, writer.uint32(18).fork()).ldelim();
        writer.uint32(24).uint64(message.amount);
        writer.uint32(32).uint32(message.asset_groups_count);
        if (message.datum_hash != null && Object.hasOwnProperty.call(message, "datum_hash"))
            writer.uint32(42).bytes(message.datum_hash);
        if (message.format != null && Object.hasOwnProperty.call(message, "format"))
            writer.uint32(48).int32(message.format);
        if (message.inline_datum_size != null && Object.hasOwnProperty.call(message, "inline_datum_size"))
            writer.uint32(56).uint32(message.inline_datum_size);
        if (message.reference_script_size != null && Object.hasOwnProperty.call(message, "reference_script_size"))
            writer.uint32(64).uint32(message.reference_script_size);
        return writer;
    };

    CardanoTxOutput.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoTxOutput.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoTxOutput();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.string();
                break;
            case 2:
                message.address_parameters = $root.CardanoAddressParametersType.decode(reader, reader.uint32());
                break;
            case 3:
                message.amount = reader.uint64();
                break;
            case 4:
                message.asset_groups_count = reader.uint32();
                break;
            case 5:
                message.datum_hash = reader.bytes();
                break;
            case 6:
                message.format = reader.int32();
                break;
            case 7:
                message.inline_datum_size = reader.uint32();
                break;
            case 8:
                message.reference_script_size = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("amount"))
            throw $util.ProtocolError("missing required 'amount'", { instance: message });
        if (!message.hasOwnProperty("asset_groups_count"))
            throw $util.ProtocolError("missing required 'asset_groups_count'", { instance: message });
        return message;
    };

    CardanoTxOutput.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoTxOutput.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address != null && message.hasOwnProperty("address"))
            if (!$util.isString(message.address))
                return "address: string expected";
        if (message.address_parameters != null && message.hasOwnProperty("address_parameters")) {
            var error = $root.CardanoAddressParametersType.verify(message.address_parameters);
            if (error)
                return "address_parameters." + error;
        }
        if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
            return "amount: integer|Long expected";
        if (!$util.isInteger(message.asset_groups_count))
            return "asset_groups_count: integer expected";
        if (message.datum_hash != null && message.hasOwnProperty("datum_hash"))
            if (!(message.datum_hash && typeof message.datum_hash.length === "number" || $util.isString(message.datum_hash)))
                return "datum_hash: buffer expected";
        if (message.format != null && message.hasOwnProperty("format"))
            switch (message.format) {
            default:
                return "format: enum value expected";
            case 0:
            case 1:
                break;
            }
        if (message.inline_datum_size != null && message.hasOwnProperty("inline_datum_size"))
            if (!$util.isInteger(message.inline_datum_size))
                return "inline_datum_size: integer expected";
        if (message.reference_script_size != null && message.hasOwnProperty("reference_script_size"))
            if (!$util.isInteger(message.reference_script_size))
                return "reference_script_size: integer expected";
        return null;
    };

    CardanoTxOutput.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoTxOutput)
            return object;
        var message = new $root.CardanoTxOutput();
        if (object.address != null)
            message.address = String(object.address);
        if (object.address_parameters != null) {
            if (typeof object.address_parameters !== "object")
                throw TypeError(".CardanoTxOutput.address_parameters: object expected");
            message.address_parameters = $root.CardanoAddressParametersType.fromObject(object.address_parameters);
        }
        if (object.amount != null)
            if ($util.Long)
                (message.amount = $util.Long.fromValue(object.amount)).unsigned = true;
            else if (typeof object.amount === "string")
                message.amount = parseInt(object.amount, 10);
            else if (typeof object.amount === "number")
                message.amount = object.amount;
            else if (typeof object.amount === "object")
                message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber(true);
        if (object.asset_groups_count != null)
            message.asset_groups_count = object.asset_groups_count >>> 0;
        if (object.datum_hash != null)
            if (typeof object.datum_hash === "string")
                $util.base64.decode(object.datum_hash, message.datum_hash = $util.newBuffer($util.base64.length(object.datum_hash)), 0);
            else if (object.datum_hash.length)
                message.datum_hash = object.datum_hash;
        switch (object.format) {
        case "ARRAY_LEGACY":
        case 0:
            message.format = 0;
            break;
        case "MAP_BABBAGE":
        case 1:
            message.format = 1;
            break;
        }
        if (object.inline_datum_size != null)
            message.inline_datum_size = object.inline_datum_size >>> 0;
        if (object.reference_script_size != null)
            message.reference_script_size = object.reference_script_size >>> 0;
        return message;
    };

    CardanoTxOutput.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.address = "";
            object.address_parameters = null;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.amount = options.longs === String ? "0" : 0;
            object.asset_groups_count = 0;
            if (options.bytes === String)
                object.datum_hash = "";
            else {
                object.datum_hash = [];
                if (options.bytes !== Array)
                    object.datum_hash = $util.newBuffer(object.datum_hash);
            }
            object.format = options.enums === String ? "ARRAY_LEGACY" : 0;
            object.inline_datum_size = 0;
            object.reference_script_size = 0;
        }
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        if (message.address_parameters != null && message.hasOwnProperty("address_parameters"))
            object.address_parameters = $root.CardanoAddressParametersType.toObject(message.address_parameters, options);
        if (message.amount != null && message.hasOwnProperty("amount"))
            if (typeof message.amount === "number")
                object.amount = options.longs === String ? String(message.amount) : message.amount;
            else
                object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber(true) : message.amount;
        if (message.asset_groups_count != null && message.hasOwnProperty("asset_groups_count"))
            object.asset_groups_count = message.asset_groups_count;
        if (message.datum_hash != null && message.hasOwnProperty("datum_hash"))
            object.datum_hash = options.bytes === String ? $util.base64.encode(message.datum_hash, 0, message.datum_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.datum_hash) : message.datum_hash;
        if (message.format != null && message.hasOwnProperty("format"))
            object.format = options.enums === String ? $root.CardanoTxOutputSerializationFormat[message.format] : message.format;
        if (message.inline_datum_size != null && message.hasOwnProperty("inline_datum_size"))
            object.inline_datum_size = message.inline_datum_size;
        if (message.reference_script_size != null && message.hasOwnProperty("reference_script_size"))
            object.reference_script_size = message.reference_script_size;
        return object;
    };

    CardanoTxOutput.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoTxOutput;
})();

$root.CardanoAssetGroup = (function() {

    function CardanoAssetGroup(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoAssetGroup.prototype.policy_id = $util.newBuffer([]);
    CardanoAssetGroup.prototype.tokens_count = 0;

    CardanoAssetGroup.create = function create(properties) {
        return new CardanoAssetGroup(properties);
    };

    CardanoAssetGroup.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.policy_id);
        writer.uint32(16).uint32(message.tokens_count);
        return writer;
    };

    CardanoAssetGroup.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoAssetGroup.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoAssetGroup();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.policy_id = reader.bytes();
                break;
            case 2:
                message.tokens_count = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("policy_id"))
            throw $util.ProtocolError("missing required 'policy_id'", { instance: message });
        if (!message.hasOwnProperty("tokens_count"))
            throw $util.ProtocolError("missing required 'tokens_count'", { instance: message });
        return message;
    };

    CardanoAssetGroup.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoAssetGroup.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.policy_id && typeof message.policy_id.length === "number" || $util.isString(message.policy_id)))
            return "policy_id: buffer expected";
        if (!$util.isInteger(message.tokens_count))
            return "tokens_count: integer expected";
        return null;
    };

    CardanoAssetGroup.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoAssetGroup)
            return object;
        var message = new $root.CardanoAssetGroup();
        if (object.policy_id != null)
            if (typeof object.policy_id === "string")
                $util.base64.decode(object.policy_id, message.policy_id = $util.newBuffer($util.base64.length(object.policy_id)), 0);
            else if (object.policy_id.length)
                message.policy_id = object.policy_id;
        if (object.tokens_count != null)
            message.tokens_count = object.tokens_count >>> 0;
        return message;
    };

    CardanoAssetGroup.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.policy_id = "";
            else {
                object.policy_id = [];
                if (options.bytes !== Array)
                    object.policy_id = $util.newBuffer(object.policy_id);
            }
            object.tokens_count = 0;
        }
        if (message.policy_id != null && message.hasOwnProperty("policy_id"))
            object.policy_id = options.bytes === String ? $util.base64.encode(message.policy_id, 0, message.policy_id.length) : options.bytes === Array ? Array.prototype.slice.call(message.policy_id) : message.policy_id;
        if (message.tokens_count != null && message.hasOwnProperty("tokens_count"))
            object.tokens_count = message.tokens_count;
        return object;
    };

    CardanoAssetGroup.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoAssetGroup;
})();

$root.CardanoToken = (function() {

    function CardanoToken(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoToken.prototype.asset_name_bytes = $util.newBuffer([]);
    CardanoToken.prototype.amount = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    CardanoToken.prototype.mint_amount = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    CardanoToken.create = function create(properties) {
        return new CardanoToken(properties);
    };

    CardanoToken.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.asset_name_bytes);
        if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
            writer.uint32(16).uint64(message.amount);
        if (message.mint_amount != null && Object.hasOwnProperty.call(message, "mint_amount"))
            writer.uint32(24).sint64(message.mint_amount);
        return writer;
    };

    CardanoToken.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoToken.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoToken();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.asset_name_bytes = reader.bytes();
                break;
            case 2:
                message.amount = reader.uint64();
                break;
            case 3:
                message.mint_amount = reader.sint64();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("asset_name_bytes"))
            throw $util.ProtocolError("missing required 'asset_name_bytes'", { instance: message });
        return message;
    };

    CardanoToken.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoToken.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.asset_name_bytes && typeof message.asset_name_bytes.length === "number" || $util.isString(message.asset_name_bytes)))
            return "asset_name_bytes: buffer expected";
        if (message.amount != null && message.hasOwnProperty("amount"))
            if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
                return "amount: integer|Long expected";
        if (message.mint_amount != null && message.hasOwnProperty("mint_amount"))
            if (!$util.isInteger(message.mint_amount) && !(message.mint_amount && $util.isInteger(message.mint_amount.low) && $util.isInteger(message.mint_amount.high)))
                return "mint_amount: integer|Long expected";
        return null;
    };

    CardanoToken.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoToken)
            return object;
        var message = new $root.CardanoToken();
        if (object.asset_name_bytes != null)
            if (typeof object.asset_name_bytes === "string")
                $util.base64.decode(object.asset_name_bytes, message.asset_name_bytes = $util.newBuffer($util.base64.length(object.asset_name_bytes)), 0);
            else if (object.asset_name_bytes.length)
                message.asset_name_bytes = object.asset_name_bytes;
        if (object.amount != null)
            if ($util.Long)
                (message.amount = $util.Long.fromValue(object.amount)).unsigned = true;
            else if (typeof object.amount === "string")
                message.amount = parseInt(object.amount, 10);
            else if (typeof object.amount === "number")
                message.amount = object.amount;
            else if (typeof object.amount === "object")
                message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber(true);
        if (object.mint_amount != null)
            if ($util.Long)
                (message.mint_amount = $util.Long.fromValue(object.mint_amount)).unsigned = false;
            else if (typeof object.mint_amount === "string")
                message.mint_amount = parseInt(object.mint_amount, 10);
            else if (typeof object.mint_amount === "number")
                message.mint_amount = object.mint_amount;
            else if (typeof object.mint_amount === "object")
                message.mint_amount = new $util.LongBits(object.mint_amount.low >>> 0, object.mint_amount.high >>> 0).toNumber();
        return message;
    };

    CardanoToken.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.asset_name_bytes = "";
            else {
                object.asset_name_bytes = [];
                if (options.bytes !== Array)
                    object.asset_name_bytes = $util.newBuffer(object.asset_name_bytes);
            }
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.amount = options.longs === String ? "0" : 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.mint_amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.mint_amount = options.longs === String ? "0" : 0;
        }
        if (message.asset_name_bytes != null && message.hasOwnProperty("asset_name_bytes"))
            object.asset_name_bytes = options.bytes === String ? $util.base64.encode(message.asset_name_bytes, 0, message.asset_name_bytes.length) : options.bytes === Array ? Array.prototype.slice.call(message.asset_name_bytes) : message.asset_name_bytes;
        if (message.amount != null && message.hasOwnProperty("amount"))
            if (typeof message.amount === "number")
                object.amount = options.longs === String ? String(message.amount) : message.amount;
            else
                object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber(true) : message.amount;
        if (message.mint_amount != null && message.hasOwnProperty("mint_amount"))
            if (typeof message.mint_amount === "number")
                object.mint_amount = options.longs === String ? String(message.mint_amount) : message.mint_amount;
            else
                object.mint_amount = options.longs === String ? $util.Long.prototype.toString.call(message.mint_amount) : options.longs === Number ? new $util.LongBits(message.mint_amount.low >>> 0, message.mint_amount.high >>> 0).toNumber() : message.mint_amount;
        return object;
    };

    CardanoToken.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoToken;
})();

$root.CardanoTxInlineDatumChunk = (function() {

    function CardanoTxInlineDatumChunk(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoTxInlineDatumChunk.prototype.data = $util.newBuffer([]);

    CardanoTxInlineDatumChunk.create = function create(properties) {
        return new CardanoTxInlineDatumChunk(properties);
    };

    CardanoTxInlineDatumChunk.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.data);
        return writer;
    };

    CardanoTxInlineDatumChunk.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoTxInlineDatumChunk.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoTxInlineDatumChunk();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.data = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("data"))
            throw $util.ProtocolError("missing required 'data'", { instance: message });
        return message;
    };

    CardanoTxInlineDatumChunk.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoTxInlineDatumChunk.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
            return "data: buffer expected";
        return null;
    };

    CardanoTxInlineDatumChunk.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoTxInlineDatumChunk)
            return object;
        var message = new $root.CardanoTxInlineDatumChunk();
        if (object.data != null)
            if (typeof object.data === "string")
                $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
            else if (object.data.length)
                message.data = object.data;
        return message;
    };

    CardanoTxInlineDatumChunk.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.data = "";
            else {
                object.data = [];
                if (options.bytes !== Array)
                    object.data = $util.newBuffer(object.data);
            }
        if (message.data != null && message.hasOwnProperty("data"))
            object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
        return object;
    };

    CardanoTxInlineDatumChunk.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoTxInlineDatumChunk;
})();

$root.CardanoTxReferenceScriptChunk = (function() {

    function CardanoTxReferenceScriptChunk(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoTxReferenceScriptChunk.prototype.data = $util.newBuffer([]);

    CardanoTxReferenceScriptChunk.create = function create(properties) {
        return new CardanoTxReferenceScriptChunk(properties);
    };

    CardanoTxReferenceScriptChunk.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.data);
        return writer;
    };

    CardanoTxReferenceScriptChunk.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoTxReferenceScriptChunk.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoTxReferenceScriptChunk();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.data = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("data"))
            throw $util.ProtocolError("missing required 'data'", { instance: message });
        return message;
    };

    CardanoTxReferenceScriptChunk.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoTxReferenceScriptChunk.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
            return "data: buffer expected";
        return null;
    };

    CardanoTxReferenceScriptChunk.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoTxReferenceScriptChunk)
            return object;
        var message = new $root.CardanoTxReferenceScriptChunk();
        if (object.data != null)
            if (typeof object.data === "string")
                $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
            else if (object.data.length)
                message.data = object.data;
        return message;
    };

    CardanoTxReferenceScriptChunk.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.data = "";
            else {
                object.data = [];
                if (options.bytes !== Array)
                    object.data = $util.newBuffer(object.data);
            }
        if (message.data != null && message.hasOwnProperty("data"))
            object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
        return object;
    };

    CardanoTxReferenceScriptChunk.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoTxReferenceScriptChunk;
})();

$root.CardanoPoolOwner = (function() {

    function CardanoPoolOwner(properties) {
        this.staking_key_path = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoPoolOwner.prototype.staking_key_path = $util.emptyArray;
    CardanoPoolOwner.prototype.staking_key_hash = $util.newBuffer([]);

    CardanoPoolOwner.create = function create(properties) {
        return new CardanoPoolOwner(properties);
    };

    CardanoPoolOwner.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.staking_key_path != null && message.staking_key_path.length)
            for (var i = 0; i < message.staking_key_path.length; ++i)
                writer.uint32(8).uint32(message.staking_key_path[i]);
        if (message.staking_key_hash != null && Object.hasOwnProperty.call(message, "staking_key_hash"))
            writer.uint32(18).bytes(message.staking_key_hash);
        return writer;
    };

    CardanoPoolOwner.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoPoolOwner.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoPoolOwner();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.staking_key_path && message.staking_key_path.length))
                    message.staking_key_path = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.staking_key_path.push(reader.uint32());
                } else
                    message.staking_key_path.push(reader.uint32());
                break;
            case 2:
                message.staking_key_hash = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    CardanoPoolOwner.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoPoolOwner.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.staking_key_path != null && message.hasOwnProperty("staking_key_path")) {
            if (!Array.isArray(message.staking_key_path))
                return "staking_key_path: array expected";
            for (var i = 0; i < message.staking_key_path.length; ++i)
                if (!$util.isInteger(message.staking_key_path[i]))
                    return "staking_key_path: integer[] expected";
        }
        if (message.staking_key_hash != null && message.hasOwnProperty("staking_key_hash"))
            if (!(message.staking_key_hash && typeof message.staking_key_hash.length === "number" || $util.isString(message.staking_key_hash)))
                return "staking_key_hash: buffer expected";
        return null;
    };

    CardanoPoolOwner.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoPoolOwner)
            return object;
        var message = new $root.CardanoPoolOwner();
        if (object.staking_key_path) {
            if (!Array.isArray(object.staking_key_path))
                throw TypeError(".CardanoPoolOwner.staking_key_path: array expected");
            message.staking_key_path = [];
            for (var i = 0; i < object.staking_key_path.length; ++i)
                message.staking_key_path[i] = object.staking_key_path[i] >>> 0;
        }
        if (object.staking_key_hash != null)
            if (typeof object.staking_key_hash === "string")
                $util.base64.decode(object.staking_key_hash, message.staking_key_hash = $util.newBuffer($util.base64.length(object.staking_key_hash)), 0);
            else if (object.staking_key_hash.length)
                message.staking_key_hash = object.staking_key_hash;
        return message;
    };

    CardanoPoolOwner.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.staking_key_path = [];
        if (options.defaults)
            if (options.bytes === String)
                object.staking_key_hash = "";
            else {
                object.staking_key_hash = [];
                if (options.bytes !== Array)
                    object.staking_key_hash = $util.newBuffer(object.staking_key_hash);
            }
        if (message.staking_key_path && message.staking_key_path.length) {
            object.staking_key_path = [];
            for (var j = 0; j < message.staking_key_path.length; ++j)
                object.staking_key_path[j] = message.staking_key_path[j];
        }
        if (message.staking_key_hash != null && message.hasOwnProperty("staking_key_hash"))
            object.staking_key_hash = options.bytes === String ? $util.base64.encode(message.staking_key_hash, 0, message.staking_key_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.staking_key_hash) : message.staking_key_hash;
        return object;
    };

    CardanoPoolOwner.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoPoolOwner;
})();

$root.CardanoPoolRelayParameters = (function() {

    function CardanoPoolRelayParameters(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoPoolRelayParameters.prototype.type = 0;
    CardanoPoolRelayParameters.prototype.ipv4_address = $util.newBuffer([]);
    CardanoPoolRelayParameters.prototype.ipv6_address = $util.newBuffer([]);
    CardanoPoolRelayParameters.prototype.host_name = "";
    CardanoPoolRelayParameters.prototype.port = 0;

    CardanoPoolRelayParameters.create = function create(properties) {
        return new CardanoPoolRelayParameters(properties);
    };

    CardanoPoolRelayParameters.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).int32(message.type);
        if (message.ipv4_address != null && Object.hasOwnProperty.call(message, "ipv4_address"))
            writer.uint32(18).bytes(message.ipv4_address);
        if (message.ipv6_address != null && Object.hasOwnProperty.call(message, "ipv6_address"))
            writer.uint32(26).bytes(message.ipv6_address);
        if (message.host_name != null && Object.hasOwnProperty.call(message, "host_name"))
            writer.uint32(34).string(message.host_name);
        if (message.port != null && Object.hasOwnProperty.call(message, "port"))
            writer.uint32(40).uint32(message.port);
        return writer;
    };

    CardanoPoolRelayParameters.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoPoolRelayParameters.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoPoolRelayParameters();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.type = reader.int32();
                break;
            case 2:
                message.ipv4_address = reader.bytes();
                break;
            case 3:
                message.ipv6_address = reader.bytes();
                break;
            case 4:
                message.host_name = reader.string();
                break;
            case 5:
                message.port = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("type"))
            throw $util.ProtocolError("missing required 'type'", { instance: message });
        return message;
    };

    CardanoPoolRelayParameters.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoPoolRelayParameters.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        switch (message.type) {
        default:
            return "type: enum value expected";
        case 0:
        case 1:
        case 2:
            break;
        }
        if (message.ipv4_address != null && message.hasOwnProperty("ipv4_address"))
            if (!(message.ipv4_address && typeof message.ipv4_address.length === "number" || $util.isString(message.ipv4_address)))
                return "ipv4_address: buffer expected";
        if (message.ipv6_address != null && message.hasOwnProperty("ipv6_address"))
            if (!(message.ipv6_address && typeof message.ipv6_address.length === "number" || $util.isString(message.ipv6_address)))
                return "ipv6_address: buffer expected";
        if (message.host_name != null && message.hasOwnProperty("host_name"))
            if (!$util.isString(message.host_name))
                return "host_name: string expected";
        if (message.port != null && message.hasOwnProperty("port"))
            if (!$util.isInteger(message.port))
                return "port: integer expected";
        return null;
    };

    CardanoPoolRelayParameters.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoPoolRelayParameters)
            return object;
        var message = new $root.CardanoPoolRelayParameters();
        switch (object.type) {
        case "SINGLE_HOST_IP":
        case 0:
            message.type = 0;
            break;
        case "SINGLE_HOST_NAME":
        case 1:
            message.type = 1;
            break;
        case "MULTIPLE_HOST_NAME":
        case 2:
            message.type = 2;
            break;
        }
        if (object.ipv4_address != null)
            if (typeof object.ipv4_address === "string")
                $util.base64.decode(object.ipv4_address, message.ipv4_address = $util.newBuffer($util.base64.length(object.ipv4_address)), 0);
            else if (object.ipv4_address.length)
                message.ipv4_address = object.ipv4_address;
        if (object.ipv6_address != null)
            if (typeof object.ipv6_address === "string")
                $util.base64.decode(object.ipv6_address, message.ipv6_address = $util.newBuffer($util.base64.length(object.ipv6_address)), 0);
            else if (object.ipv6_address.length)
                message.ipv6_address = object.ipv6_address;
        if (object.host_name != null)
            message.host_name = String(object.host_name);
        if (object.port != null)
            message.port = object.port >>> 0;
        return message;
    };

    CardanoPoolRelayParameters.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.type = options.enums === String ? "SINGLE_HOST_IP" : 0;
            if (options.bytes === String)
                object.ipv4_address = "";
            else {
                object.ipv4_address = [];
                if (options.bytes !== Array)
                    object.ipv4_address = $util.newBuffer(object.ipv4_address);
            }
            if (options.bytes === String)
                object.ipv6_address = "";
            else {
                object.ipv6_address = [];
                if (options.bytes !== Array)
                    object.ipv6_address = $util.newBuffer(object.ipv6_address);
            }
            object.host_name = "";
            object.port = 0;
        }
        if (message.type != null && message.hasOwnProperty("type"))
            object.type = options.enums === String ? $root.CardanoPoolRelayType[message.type] : message.type;
        if (message.ipv4_address != null && message.hasOwnProperty("ipv4_address"))
            object.ipv4_address = options.bytes === String ? $util.base64.encode(message.ipv4_address, 0, message.ipv4_address.length) : options.bytes === Array ? Array.prototype.slice.call(message.ipv4_address) : message.ipv4_address;
        if (message.ipv6_address != null && message.hasOwnProperty("ipv6_address"))
            object.ipv6_address = options.bytes === String ? $util.base64.encode(message.ipv6_address, 0, message.ipv6_address.length) : options.bytes === Array ? Array.prototype.slice.call(message.ipv6_address) : message.ipv6_address;
        if (message.host_name != null && message.hasOwnProperty("host_name"))
            object.host_name = message.host_name;
        if (message.port != null && message.hasOwnProperty("port"))
            object.port = message.port;
        return object;
    };

    CardanoPoolRelayParameters.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoPoolRelayParameters;
})();

$root.CardanoPoolMetadataType = (function() {

    function CardanoPoolMetadataType(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoPoolMetadataType.prototype.url = "";
    CardanoPoolMetadataType.prototype.hash = $util.newBuffer([]);

    CardanoPoolMetadataType.create = function create(properties) {
        return new CardanoPoolMetadataType(properties);
    };

    CardanoPoolMetadataType.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.url);
        writer.uint32(18).bytes(message.hash);
        return writer;
    };

    CardanoPoolMetadataType.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoPoolMetadataType.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoPoolMetadataType();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.url = reader.string();
                break;
            case 2:
                message.hash = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("url"))
            throw $util.ProtocolError("missing required 'url'", { instance: message });
        if (!message.hasOwnProperty("hash"))
            throw $util.ProtocolError("missing required 'hash'", { instance: message });
        return message;
    };

    CardanoPoolMetadataType.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoPoolMetadataType.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.url))
            return "url: string expected";
        if (!(message.hash && typeof message.hash.length === "number" || $util.isString(message.hash)))
            return "hash: buffer expected";
        return null;
    };

    CardanoPoolMetadataType.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoPoolMetadataType)
            return object;
        var message = new $root.CardanoPoolMetadataType();
        if (object.url != null)
            message.url = String(object.url);
        if (object.hash != null)
            if (typeof object.hash === "string")
                $util.base64.decode(object.hash, message.hash = $util.newBuffer($util.base64.length(object.hash)), 0);
            else if (object.hash.length)
                message.hash = object.hash;
        return message;
    };

    CardanoPoolMetadataType.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.url = "";
            if (options.bytes === String)
                object.hash = "";
            else {
                object.hash = [];
                if (options.bytes !== Array)
                    object.hash = $util.newBuffer(object.hash);
            }
        }
        if (message.url != null && message.hasOwnProperty("url"))
            object.url = message.url;
        if (message.hash != null && message.hasOwnProperty("hash"))
            object.hash = options.bytes === String ? $util.base64.encode(message.hash, 0, message.hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.hash) : message.hash;
        return object;
    };

    CardanoPoolMetadataType.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoPoolMetadataType;
})();

$root.CardanoPoolParametersType = (function() {

    function CardanoPoolParametersType(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoPoolParametersType.prototype.pool_id = $util.newBuffer([]);
    CardanoPoolParametersType.prototype.vrf_key_hash = $util.newBuffer([]);
    CardanoPoolParametersType.prototype.pledge = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    CardanoPoolParametersType.prototype.cost = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    CardanoPoolParametersType.prototype.margin_numerator = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    CardanoPoolParametersType.prototype.margin_denominator = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    CardanoPoolParametersType.prototype.reward_account = "";
    CardanoPoolParametersType.prototype.metadata = null;
    CardanoPoolParametersType.prototype.owners_count = 0;
    CardanoPoolParametersType.prototype.relays_count = 0;

    CardanoPoolParametersType.create = function create(properties) {
        return new CardanoPoolParametersType(properties);
    };

    CardanoPoolParametersType.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.pool_id);
        writer.uint32(18).bytes(message.vrf_key_hash);
        writer.uint32(24).uint64(message.pledge);
        writer.uint32(32).uint64(message.cost);
        writer.uint32(40).uint64(message.margin_numerator);
        writer.uint32(48).uint64(message.margin_denominator);
        writer.uint32(58).string(message.reward_account);
        if (message.metadata != null && Object.hasOwnProperty.call(message, "metadata"))
            $root.CardanoPoolMetadataType.encode(message.metadata, writer.uint32(82).fork()).ldelim();
        writer.uint32(88).uint32(message.owners_count);
        writer.uint32(96).uint32(message.relays_count);
        return writer;
    };

    CardanoPoolParametersType.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoPoolParametersType.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoPoolParametersType();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.pool_id = reader.bytes();
                break;
            case 2:
                message.vrf_key_hash = reader.bytes();
                break;
            case 3:
                message.pledge = reader.uint64();
                break;
            case 4:
                message.cost = reader.uint64();
                break;
            case 5:
                message.margin_numerator = reader.uint64();
                break;
            case 6:
                message.margin_denominator = reader.uint64();
                break;
            case 7:
                message.reward_account = reader.string();
                break;
            case 10:
                message.metadata = $root.CardanoPoolMetadataType.decode(reader, reader.uint32());
                break;
            case 11:
                message.owners_count = reader.uint32();
                break;
            case 12:
                message.relays_count = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("pool_id"))
            throw $util.ProtocolError("missing required 'pool_id'", { instance: message });
        if (!message.hasOwnProperty("vrf_key_hash"))
            throw $util.ProtocolError("missing required 'vrf_key_hash'", { instance: message });
        if (!message.hasOwnProperty("pledge"))
            throw $util.ProtocolError("missing required 'pledge'", { instance: message });
        if (!message.hasOwnProperty("cost"))
            throw $util.ProtocolError("missing required 'cost'", { instance: message });
        if (!message.hasOwnProperty("margin_numerator"))
            throw $util.ProtocolError("missing required 'margin_numerator'", { instance: message });
        if (!message.hasOwnProperty("margin_denominator"))
            throw $util.ProtocolError("missing required 'margin_denominator'", { instance: message });
        if (!message.hasOwnProperty("reward_account"))
            throw $util.ProtocolError("missing required 'reward_account'", { instance: message });
        if (!message.hasOwnProperty("owners_count"))
            throw $util.ProtocolError("missing required 'owners_count'", { instance: message });
        if (!message.hasOwnProperty("relays_count"))
            throw $util.ProtocolError("missing required 'relays_count'", { instance: message });
        return message;
    };

    CardanoPoolParametersType.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoPoolParametersType.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.pool_id && typeof message.pool_id.length === "number" || $util.isString(message.pool_id)))
            return "pool_id: buffer expected";
        if (!(message.vrf_key_hash && typeof message.vrf_key_hash.length === "number" || $util.isString(message.vrf_key_hash)))
            return "vrf_key_hash: buffer expected";
        if (!$util.isInteger(message.pledge) && !(message.pledge && $util.isInteger(message.pledge.low) && $util.isInteger(message.pledge.high)))
            return "pledge: integer|Long expected";
        if (!$util.isInteger(message.cost) && !(message.cost && $util.isInteger(message.cost.low) && $util.isInteger(message.cost.high)))
            return "cost: integer|Long expected";
        if (!$util.isInteger(message.margin_numerator) && !(message.margin_numerator && $util.isInteger(message.margin_numerator.low) && $util.isInteger(message.margin_numerator.high)))
            return "margin_numerator: integer|Long expected";
        if (!$util.isInteger(message.margin_denominator) && !(message.margin_denominator && $util.isInteger(message.margin_denominator.low) && $util.isInteger(message.margin_denominator.high)))
            return "margin_denominator: integer|Long expected";
        if (!$util.isString(message.reward_account))
            return "reward_account: string expected";
        if (message.metadata != null && message.hasOwnProperty("metadata")) {
            var error = $root.CardanoPoolMetadataType.verify(message.metadata);
            if (error)
                return "metadata." + error;
        }
        if (!$util.isInteger(message.owners_count))
            return "owners_count: integer expected";
        if (!$util.isInteger(message.relays_count))
            return "relays_count: integer expected";
        return null;
    };

    CardanoPoolParametersType.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoPoolParametersType)
            return object;
        var message = new $root.CardanoPoolParametersType();
        if (object.pool_id != null)
            if (typeof object.pool_id === "string")
                $util.base64.decode(object.pool_id, message.pool_id = $util.newBuffer($util.base64.length(object.pool_id)), 0);
            else if (object.pool_id.length)
                message.pool_id = object.pool_id;
        if (object.vrf_key_hash != null)
            if (typeof object.vrf_key_hash === "string")
                $util.base64.decode(object.vrf_key_hash, message.vrf_key_hash = $util.newBuffer($util.base64.length(object.vrf_key_hash)), 0);
            else if (object.vrf_key_hash.length)
                message.vrf_key_hash = object.vrf_key_hash;
        if (object.pledge != null)
            if ($util.Long)
                (message.pledge = $util.Long.fromValue(object.pledge)).unsigned = true;
            else if (typeof object.pledge === "string")
                message.pledge = parseInt(object.pledge, 10);
            else if (typeof object.pledge === "number")
                message.pledge = object.pledge;
            else if (typeof object.pledge === "object")
                message.pledge = new $util.LongBits(object.pledge.low >>> 0, object.pledge.high >>> 0).toNumber(true);
        if (object.cost != null)
            if ($util.Long)
                (message.cost = $util.Long.fromValue(object.cost)).unsigned = true;
            else if (typeof object.cost === "string")
                message.cost = parseInt(object.cost, 10);
            else if (typeof object.cost === "number")
                message.cost = object.cost;
            else if (typeof object.cost === "object")
                message.cost = new $util.LongBits(object.cost.low >>> 0, object.cost.high >>> 0).toNumber(true);
        if (object.margin_numerator != null)
            if ($util.Long)
                (message.margin_numerator = $util.Long.fromValue(object.margin_numerator)).unsigned = true;
            else if (typeof object.margin_numerator === "string")
                message.margin_numerator = parseInt(object.margin_numerator, 10);
            else if (typeof object.margin_numerator === "number")
                message.margin_numerator = object.margin_numerator;
            else if (typeof object.margin_numerator === "object")
                message.margin_numerator = new $util.LongBits(object.margin_numerator.low >>> 0, object.margin_numerator.high >>> 0).toNumber(true);
        if (object.margin_denominator != null)
            if ($util.Long)
                (message.margin_denominator = $util.Long.fromValue(object.margin_denominator)).unsigned = true;
            else if (typeof object.margin_denominator === "string")
                message.margin_denominator = parseInt(object.margin_denominator, 10);
            else if (typeof object.margin_denominator === "number")
                message.margin_denominator = object.margin_denominator;
            else if (typeof object.margin_denominator === "object")
                message.margin_denominator = new $util.LongBits(object.margin_denominator.low >>> 0, object.margin_denominator.high >>> 0).toNumber(true);
        if (object.reward_account != null)
            message.reward_account = String(object.reward_account);
        if (object.metadata != null) {
            if (typeof object.metadata !== "object")
                throw TypeError(".CardanoPoolParametersType.metadata: object expected");
            message.metadata = $root.CardanoPoolMetadataType.fromObject(object.metadata);
        }
        if (object.owners_count != null)
            message.owners_count = object.owners_count >>> 0;
        if (object.relays_count != null)
            message.relays_count = object.relays_count >>> 0;
        return message;
    };

    CardanoPoolParametersType.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.pool_id = "";
            else {
                object.pool_id = [];
                if (options.bytes !== Array)
                    object.pool_id = $util.newBuffer(object.pool_id);
            }
            if (options.bytes === String)
                object.vrf_key_hash = "";
            else {
                object.vrf_key_hash = [];
                if (options.bytes !== Array)
                    object.vrf_key_hash = $util.newBuffer(object.vrf_key_hash);
            }
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.pledge = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.pledge = options.longs === String ? "0" : 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.cost = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.cost = options.longs === String ? "0" : 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.margin_numerator = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.margin_numerator = options.longs === String ? "0" : 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.margin_denominator = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.margin_denominator = options.longs === String ? "0" : 0;
            object.reward_account = "";
            object.metadata = null;
            object.owners_count = 0;
            object.relays_count = 0;
        }
        if (message.pool_id != null && message.hasOwnProperty("pool_id"))
            object.pool_id = options.bytes === String ? $util.base64.encode(message.pool_id, 0, message.pool_id.length) : options.bytes === Array ? Array.prototype.slice.call(message.pool_id) : message.pool_id;
        if (message.vrf_key_hash != null && message.hasOwnProperty("vrf_key_hash"))
            object.vrf_key_hash = options.bytes === String ? $util.base64.encode(message.vrf_key_hash, 0, message.vrf_key_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.vrf_key_hash) : message.vrf_key_hash;
        if (message.pledge != null && message.hasOwnProperty("pledge"))
            if (typeof message.pledge === "number")
                object.pledge = options.longs === String ? String(message.pledge) : message.pledge;
            else
                object.pledge = options.longs === String ? $util.Long.prototype.toString.call(message.pledge) : options.longs === Number ? new $util.LongBits(message.pledge.low >>> 0, message.pledge.high >>> 0).toNumber(true) : message.pledge;
        if (message.cost != null && message.hasOwnProperty("cost"))
            if (typeof message.cost === "number")
                object.cost = options.longs === String ? String(message.cost) : message.cost;
            else
                object.cost = options.longs === String ? $util.Long.prototype.toString.call(message.cost) : options.longs === Number ? new $util.LongBits(message.cost.low >>> 0, message.cost.high >>> 0).toNumber(true) : message.cost;
        if (message.margin_numerator != null && message.hasOwnProperty("margin_numerator"))
            if (typeof message.margin_numerator === "number")
                object.margin_numerator = options.longs === String ? String(message.margin_numerator) : message.margin_numerator;
            else
                object.margin_numerator = options.longs === String ? $util.Long.prototype.toString.call(message.margin_numerator) : options.longs === Number ? new $util.LongBits(message.margin_numerator.low >>> 0, message.margin_numerator.high >>> 0).toNumber(true) : message.margin_numerator;
        if (message.margin_denominator != null && message.hasOwnProperty("margin_denominator"))
            if (typeof message.margin_denominator === "number")
                object.margin_denominator = options.longs === String ? String(message.margin_denominator) : message.margin_denominator;
            else
                object.margin_denominator = options.longs === String ? $util.Long.prototype.toString.call(message.margin_denominator) : options.longs === Number ? new $util.LongBits(message.margin_denominator.low >>> 0, message.margin_denominator.high >>> 0).toNumber(true) : message.margin_denominator;
        if (message.reward_account != null && message.hasOwnProperty("reward_account"))
            object.reward_account = message.reward_account;
        if (message.metadata != null && message.hasOwnProperty("metadata"))
            object.metadata = $root.CardanoPoolMetadataType.toObject(message.metadata, options);
        if (message.owners_count != null && message.hasOwnProperty("owners_count"))
            object.owners_count = message.owners_count;
        if (message.relays_count != null && message.hasOwnProperty("relays_count"))
            object.relays_count = message.relays_count;
        return object;
    };

    CardanoPoolParametersType.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoPoolParametersType;
})();

$root.CardanoDRep = (function() {

    function CardanoDRep(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoDRep.prototype.type = 0;
    CardanoDRep.prototype.key_hash = $util.newBuffer([]);
    CardanoDRep.prototype.script_hash = $util.newBuffer([]);

    CardanoDRep.create = function create(properties) {
        return new CardanoDRep(properties);
    };

    CardanoDRep.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).int32(message.type);
        if (message.key_hash != null && Object.hasOwnProperty.call(message, "key_hash"))
            writer.uint32(18).bytes(message.key_hash);
        if (message.script_hash != null && Object.hasOwnProperty.call(message, "script_hash"))
            writer.uint32(26).bytes(message.script_hash);
        return writer;
    };

    CardanoDRep.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoDRep.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoDRep();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.type = reader.int32();
                break;
            case 2:
                message.key_hash = reader.bytes();
                break;
            case 3:
                message.script_hash = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("type"))
            throw $util.ProtocolError("missing required 'type'", { instance: message });
        return message;
    };

    CardanoDRep.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoDRep.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        switch (message.type) {
        default:
            return "type: enum value expected";
        case 0:
        case 1:
        case 2:
        case 3:
            break;
        }
        if (message.key_hash != null && message.hasOwnProperty("key_hash"))
            if (!(message.key_hash && typeof message.key_hash.length === "number" || $util.isString(message.key_hash)))
                return "key_hash: buffer expected";
        if (message.script_hash != null && message.hasOwnProperty("script_hash"))
            if (!(message.script_hash && typeof message.script_hash.length === "number" || $util.isString(message.script_hash)))
                return "script_hash: buffer expected";
        return null;
    };

    CardanoDRep.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoDRep)
            return object;
        var message = new $root.CardanoDRep();
        switch (object.type) {
        case "KEY_HASH":
        case 0:
            message.type = 0;
            break;
        case "SCRIPT_HASH":
        case 1:
            message.type = 1;
            break;
        case "ABSTAIN":
        case 2:
            message.type = 2;
            break;
        case "NO_CONFIDENCE":
        case 3:
            message.type = 3;
            break;
        }
        if (object.key_hash != null)
            if (typeof object.key_hash === "string")
                $util.base64.decode(object.key_hash, message.key_hash = $util.newBuffer($util.base64.length(object.key_hash)), 0);
            else if (object.key_hash.length)
                message.key_hash = object.key_hash;
        if (object.script_hash != null)
            if (typeof object.script_hash === "string")
                $util.base64.decode(object.script_hash, message.script_hash = $util.newBuffer($util.base64.length(object.script_hash)), 0);
            else if (object.script_hash.length)
                message.script_hash = object.script_hash;
        return message;
    };

    CardanoDRep.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.type = options.enums === String ? "KEY_HASH" : 0;
            if (options.bytes === String)
                object.key_hash = "";
            else {
                object.key_hash = [];
                if (options.bytes !== Array)
                    object.key_hash = $util.newBuffer(object.key_hash);
            }
            if (options.bytes === String)
                object.script_hash = "";
            else {
                object.script_hash = [];
                if (options.bytes !== Array)
                    object.script_hash = $util.newBuffer(object.script_hash);
            }
        }
        if (message.type != null && message.hasOwnProperty("type"))
            object.type = options.enums === String ? $root.CardanoDRepType[message.type] : message.type;
        if (message.key_hash != null && message.hasOwnProperty("key_hash"))
            object.key_hash = options.bytes === String ? $util.base64.encode(message.key_hash, 0, message.key_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.key_hash) : message.key_hash;
        if (message.script_hash != null && message.hasOwnProperty("script_hash"))
            object.script_hash = options.bytes === String ? $util.base64.encode(message.script_hash, 0, message.script_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.script_hash) : message.script_hash;
        return object;
    };

    CardanoDRep.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoDRep;
})();

$root.CardanoTxCertificate = (function() {

    function CardanoTxCertificate(properties) {
        this.path = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoTxCertificate.prototype.type = 0;
    CardanoTxCertificate.prototype.path = $util.emptyArray;
    CardanoTxCertificate.prototype.pool = $util.newBuffer([]);
    CardanoTxCertificate.prototype.pool_parameters = null;
    CardanoTxCertificate.prototype.script_hash = $util.newBuffer([]);
    CardanoTxCertificate.prototype.key_hash = $util.newBuffer([]);
    CardanoTxCertificate.prototype.deposit = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    CardanoTxCertificate.prototype.drep = null;

    CardanoTxCertificate.create = function create(properties) {
        return new CardanoTxCertificate(properties);
    };

    CardanoTxCertificate.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).int32(message.type);
        if (message.path != null && message.path.length)
            for (var i = 0; i < message.path.length; ++i)
                writer.uint32(16).uint32(message.path[i]);
        if (message.pool != null && Object.hasOwnProperty.call(message, "pool"))
            writer.uint32(26).bytes(message.pool);
        if (message.pool_parameters != null && Object.hasOwnProperty.call(message, "pool_parameters"))
            $root.CardanoPoolParametersType.encode(message.pool_parameters, writer.uint32(34).fork()).ldelim();
        if (message.script_hash != null && Object.hasOwnProperty.call(message, "script_hash"))
            writer.uint32(42).bytes(message.script_hash);
        if (message.key_hash != null && Object.hasOwnProperty.call(message, "key_hash"))
            writer.uint32(50).bytes(message.key_hash);
        if (message.deposit != null && Object.hasOwnProperty.call(message, "deposit"))
            writer.uint32(56).uint64(message.deposit);
        if (message.drep != null && Object.hasOwnProperty.call(message, "drep"))
            $root.CardanoDRep.encode(message.drep, writer.uint32(66).fork()).ldelim();
        return writer;
    };

    CardanoTxCertificate.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoTxCertificate.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoTxCertificate();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.type = reader.int32();
                break;
            case 2:
                if (!(message.path && message.path.length))
                    message.path = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.path.push(reader.uint32());
                } else
                    message.path.push(reader.uint32());
                break;
            case 3:
                message.pool = reader.bytes();
                break;
            case 4:
                message.pool_parameters = $root.CardanoPoolParametersType.decode(reader, reader.uint32());
                break;
            case 5:
                message.script_hash = reader.bytes();
                break;
            case 6:
                message.key_hash = reader.bytes();
                break;
            case 7:
                message.deposit = reader.uint64();
                break;
            case 8:
                message.drep = $root.CardanoDRep.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("type"))
            throw $util.ProtocolError("missing required 'type'", { instance: message });
        return message;
    };

    CardanoTxCertificate.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoTxCertificate.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        switch (message.type) {
        default:
            return "type: enum value expected";
        case 0:
        case 1:
        case 2:
        case 3:
        case 7:
        case 8:
        case 9:
            break;
        }
        if (message.path != null && message.hasOwnProperty("path")) {
            if (!Array.isArray(message.path))
                return "path: array expected";
            for (var i = 0; i < message.path.length; ++i)
                if (!$util.isInteger(message.path[i]))
                    return "path: integer[] expected";
        }
        if (message.pool != null && message.hasOwnProperty("pool"))
            if (!(message.pool && typeof message.pool.length === "number" || $util.isString(message.pool)))
                return "pool: buffer expected";
        if (message.pool_parameters != null && message.hasOwnProperty("pool_parameters")) {
            var error = $root.CardanoPoolParametersType.verify(message.pool_parameters);
            if (error)
                return "pool_parameters." + error;
        }
        if (message.script_hash != null && message.hasOwnProperty("script_hash"))
            if (!(message.script_hash && typeof message.script_hash.length === "number" || $util.isString(message.script_hash)))
                return "script_hash: buffer expected";
        if (message.key_hash != null && message.hasOwnProperty("key_hash"))
            if (!(message.key_hash && typeof message.key_hash.length === "number" || $util.isString(message.key_hash)))
                return "key_hash: buffer expected";
        if (message.deposit != null && message.hasOwnProperty("deposit"))
            if (!$util.isInteger(message.deposit) && !(message.deposit && $util.isInteger(message.deposit.low) && $util.isInteger(message.deposit.high)))
                return "deposit: integer|Long expected";
        if (message.drep != null && message.hasOwnProperty("drep")) {
            var error = $root.CardanoDRep.verify(message.drep);
            if (error)
                return "drep." + error;
        }
        return null;
    };

    CardanoTxCertificate.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoTxCertificate)
            return object;
        var message = new $root.CardanoTxCertificate();
        switch (object.type) {
        case "STAKE_REGISTRATION":
        case 0:
            message.type = 0;
            break;
        case "STAKE_DEREGISTRATION":
        case 1:
            message.type = 1;
            break;
        case "STAKE_DELEGATION":
        case 2:
            message.type = 2;
            break;
        case "STAKE_POOL_REGISTRATION":
        case 3:
            message.type = 3;
            break;
        case "STAKE_REGISTRATION_CONWAY":
        case 7:
            message.type = 7;
            break;
        case "STAKE_DEREGISTRATION_CONWAY":
        case 8:
            message.type = 8;
            break;
        case "VOTE_DELEGATION":
        case 9:
            message.type = 9;
            break;
        }
        if (object.path) {
            if (!Array.isArray(object.path))
                throw TypeError(".CardanoTxCertificate.path: array expected");
            message.path = [];
            for (var i = 0; i < object.path.length; ++i)
                message.path[i] = object.path[i] >>> 0;
        }
        if (object.pool != null)
            if (typeof object.pool === "string")
                $util.base64.decode(object.pool, message.pool = $util.newBuffer($util.base64.length(object.pool)), 0);
            else if (object.pool.length)
                message.pool = object.pool;
        if (object.pool_parameters != null) {
            if (typeof object.pool_parameters !== "object")
                throw TypeError(".CardanoTxCertificate.pool_parameters: object expected");
            message.pool_parameters = $root.CardanoPoolParametersType.fromObject(object.pool_parameters);
        }
        if (object.script_hash != null)
            if (typeof object.script_hash === "string")
                $util.base64.decode(object.script_hash, message.script_hash = $util.newBuffer($util.base64.length(object.script_hash)), 0);
            else if (object.script_hash.length)
                message.script_hash = object.script_hash;
        if (object.key_hash != null)
            if (typeof object.key_hash === "string")
                $util.base64.decode(object.key_hash, message.key_hash = $util.newBuffer($util.base64.length(object.key_hash)), 0);
            else if (object.key_hash.length)
                message.key_hash = object.key_hash;
        if (object.deposit != null)
            if ($util.Long)
                (message.deposit = $util.Long.fromValue(object.deposit)).unsigned = true;
            else if (typeof object.deposit === "string")
                message.deposit = parseInt(object.deposit, 10);
            else if (typeof object.deposit === "number")
                message.deposit = object.deposit;
            else if (typeof object.deposit === "object")
                message.deposit = new $util.LongBits(object.deposit.low >>> 0, object.deposit.high >>> 0).toNumber(true);
        if (object.drep != null) {
            if (typeof object.drep !== "object")
                throw TypeError(".CardanoTxCertificate.drep: object expected");
            message.drep = $root.CardanoDRep.fromObject(object.drep);
        }
        return message;
    };

    CardanoTxCertificate.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.path = [];
        if (options.defaults) {
            object.type = options.enums === String ? "STAKE_REGISTRATION" : 0;
            if (options.bytes === String)
                object.pool = "";
            else {
                object.pool = [];
                if (options.bytes !== Array)
                    object.pool = $util.newBuffer(object.pool);
            }
            object.pool_parameters = null;
            if (options.bytes === String)
                object.script_hash = "";
            else {
                object.script_hash = [];
                if (options.bytes !== Array)
                    object.script_hash = $util.newBuffer(object.script_hash);
            }
            if (options.bytes === String)
                object.key_hash = "";
            else {
                object.key_hash = [];
                if (options.bytes !== Array)
                    object.key_hash = $util.newBuffer(object.key_hash);
            }
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.deposit = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.deposit = options.longs === String ? "0" : 0;
            object.drep = null;
        }
        if (message.type != null && message.hasOwnProperty("type"))
            object.type = options.enums === String ? $root.CardanoCertificateType[message.type] : message.type;
        if (message.path && message.path.length) {
            object.path = [];
            for (var j = 0; j < message.path.length; ++j)
                object.path[j] = message.path[j];
        }
        if (message.pool != null && message.hasOwnProperty("pool"))
            object.pool = options.bytes === String ? $util.base64.encode(message.pool, 0, message.pool.length) : options.bytes === Array ? Array.prototype.slice.call(message.pool) : message.pool;
        if (message.pool_parameters != null && message.hasOwnProperty("pool_parameters"))
            object.pool_parameters = $root.CardanoPoolParametersType.toObject(message.pool_parameters, options);
        if (message.script_hash != null && message.hasOwnProperty("script_hash"))
            object.script_hash = options.bytes === String ? $util.base64.encode(message.script_hash, 0, message.script_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.script_hash) : message.script_hash;
        if (message.key_hash != null && message.hasOwnProperty("key_hash"))
            object.key_hash = options.bytes === String ? $util.base64.encode(message.key_hash, 0, message.key_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.key_hash) : message.key_hash;
        if (message.deposit != null && message.hasOwnProperty("deposit"))
            if (typeof message.deposit === "number")
                object.deposit = options.longs === String ? String(message.deposit) : message.deposit;
            else
                object.deposit = options.longs === String ? $util.Long.prototype.toString.call(message.deposit) : options.longs === Number ? new $util.LongBits(message.deposit.low >>> 0, message.deposit.high >>> 0).toNumber(true) : message.deposit;
        if (message.drep != null && message.hasOwnProperty("drep"))
            object.drep = $root.CardanoDRep.toObject(message.drep, options);
        return object;
    };

    CardanoTxCertificate.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoTxCertificate;
})();

$root.CardanoTxWithdrawal = (function() {

    function CardanoTxWithdrawal(properties) {
        this.path = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoTxWithdrawal.prototype.path = $util.emptyArray;
    CardanoTxWithdrawal.prototype.amount = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    CardanoTxWithdrawal.prototype.script_hash = $util.newBuffer([]);
    CardanoTxWithdrawal.prototype.key_hash = $util.newBuffer([]);

    CardanoTxWithdrawal.create = function create(properties) {
        return new CardanoTxWithdrawal(properties);
    };

    CardanoTxWithdrawal.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.path != null && message.path.length)
            for (var i = 0; i < message.path.length; ++i)
                writer.uint32(8).uint32(message.path[i]);
        writer.uint32(16).uint64(message.amount);
        if (message.script_hash != null && Object.hasOwnProperty.call(message, "script_hash"))
            writer.uint32(26).bytes(message.script_hash);
        if (message.key_hash != null && Object.hasOwnProperty.call(message, "key_hash"))
            writer.uint32(34).bytes(message.key_hash);
        return writer;
    };

    CardanoTxWithdrawal.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoTxWithdrawal.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoTxWithdrawal();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.path && message.path.length))
                    message.path = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.path.push(reader.uint32());
                } else
                    message.path.push(reader.uint32());
                break;
            case 2:
                message.amount = reader.uint64();
                break;
            case 3:
                message.script_hash = reader.bytes();
                break;
            case 4:
                message.key_hash = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("amount"))
            throw $util.ProtocolError("missing required 'amount'", { instance: message });
        return message;
    };

    CardanoTxWithdrawal.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoTxWithdrawal.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.path != null && message.hasOwnProperty("path")) {
            if (!Array.isArray(message.path))
                return "path: array expected";
            for (var i = 0; i < message.path.length; ++i)
                if (!$util.isInteger(message.path[i]))
                    return "path: integer[] expected";
        }
        if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
            return "amount: integer|Long expected";
        if (message.script_hash != null && message.hasOwnProperty("script_hash"))
            if (!(message.script_hash && typeof message.script_hash.length === "number" || $util.isString(message.script_hash)))
                return "script_hash: buffer expected";
        if (message.key_hash != null && message.hasOwnProperty("key_hash"))
            if (!(message.key_hash && typeof message.key_hash.length === "number" || $util.isString(message.key_hash)))
                return "key_hash: buffer expected";
        return null;
    };

    CardanoTxWithdrawal.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoTxWithdrawal)
            return object;
        var message = new $root.CardanoTxWithdrawal();
        if (object.path) {
            if (!Array.isArray(object.path))
                throw TypeError(".CardanoTxWithdrawal.path: array expected");
            message.path = [];
            for (var i = 0; i < object.path.length; ++i)
                message.path[i] = object.path[i] >>> 0;
        }
        if (object.amount != null)
            if ($util.Long)
                (message.amount = $util.Long.fromValue(object.amount)).unsigned = true;
            else if (typeof object.amount === "string")
                message.amount = parseInt(object.amount, 10);
            else if (typeof object.amount === "number")
                message.amount = object.amount;
            else if (typeof object.amount === "object")
                message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber(true);
        if (object.script_hash != null)
            if (typeof object.script_hash === "string")
                $util.base64.decode(object.script_hash, message.script_hash = $util.newBuffer($util.base64.length(object.script_hash)), 0);
            else if (object.script_hash.length)
                message.script_hash = object.script_hash;
        if (object.key_hash != null)
            if (typeof object.key_hash === "string")
                $util.base64.decode(object.key_hash, message.key_hash = $util.newBuffer($util.base64.length(object.key_hash)), 0);
            else if (object.key_hash.length)
                message.key_hash = object.key_hash;
        return message;
    };

    CardanoTxWithdrawal.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.path = [];
        if (options.defaults) {
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.amount = options.longs === String ? "0" : 0;
            if (options.bytes === String)
                object.script_hash = "";
            else {
                object.script_hash = [];
                if (options.bytes !== Array)
                    object.script_hash = $util.newBuffer(object.script_hash);
            }
            if (options.bytes === String)
                object.key_hash = "";
            else {
                object.key_hash = [];
                if (options.bytes !== Array)
                    object.key_hash = $util.newBuffer(object.key_hash);
            }
        }
        if (message.path && message.path.length) {
            object.path = [];
            for (var j = 0; j < message.path.length; ++j)
                object.path[j] = message.path[j];
        }
        if (message.amount != null && message.hasOwnProperty("amount"))
            if (typeof message.amount === "number")
                object.amount = options.longs === String ? String(message.amount) : message.amount;
            else
                object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber(true) : message.amount;
        if (message.script_hash != null && message.hasOwnProperty("script_hash"))
            object.script_hash = options.bytes === String ? $util.base64.encode(message.script_hash, 0, message.script_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.script_hash) : message.script_hash;
        if (message.key_hash != null && message.hasOwnProperty("key_hash"))
            object.key_hash = options.bytes === String ? $util.base64.encode(message.key_hash, 0, message.key_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.key_hash) : message.key_hash;
        return object;
    };

    CardanoTxWithdrawal.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoTxWithdrawal;
})();

$root.CardanoCVoteRegistrationDelegation = (function() {

    function CardanoCVoteRegistrationDelegation(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoCVoteRegistrationDelegation.prototype.vote_public_key = $util.newBuffer([]);
    CardanoCVoteRegistrationDelegation.prototype.weight = 0;

    CardanoCVoteRegistrationDelegation.create = function create(properties) {
        return new CardanoCVoteRegistrationDelegation(properties);
    };

    CardanoCVoteRegistrationDelegation.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.vote_public_key);
        writer.uint32(16).uint32(message.weight);
        return writer;
    };

    CardanoCVoteRegistrationDelegation.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoCVoteRegistrationDelegation.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoCVoteRegistrationDelegation();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.vote_public_key = reader.bytes();
                break;
            case 2:
                message.weight = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("vote_public_key"))
            throw $util.ProtocolError("missing required 'vote_public_key'", { instance: message });
        if (!message.hasOwnProperty("weight"))
            throw $util.ProtocolError("missing required 'weight'", { instance: message });
        return message;
    };

    CardanoCVoteRegistrationDelegation.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoCVoteRegistrationDelegation.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.vote_public_key && typeof message.vote_public_key.length === "number" || $util.isString(message.vote_public_key)))
            return "vote_public_key: buffer expected";
        if (!$util.isInteger(message.weight))
            return "weight: integer expected";
        return null;
    };

    CardanoCVoteRegistrationDelegation.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoCVoteRegistrationDelegation)
            return object;
        var message = new $root.CardanoCVoteRegistrationDelegation();
        if (object.vote_public_key != null)
            if (typeof object.vote_public_key === "string")
                $util.base64.decode(object.vote_public_key, message.vote_public_key = $util.newBuffer($util.base64.length(object.vote_public_key)), 0);
            else if (object.vote_public_key.length)
                message.vote_public_key = object.vote_public_key;
        if (object.weight != null)
            message.weight = object.weight >>> 0;
        return message;
    };

    CardanoCVoteRegistrationDelegation.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.vote_public_key = "";
            else {
                object.vote_public_key = [];
                if (options.bytes !== Array)
                    object.vote_public_key = $util.newBuffer(object.vote_public_key);
            }
            object.weight = 0;
        }
        if (message.vote_public_key != null && message.hasOwnProperty("vote_public_key"))
            object.vote_public_key = options.bytes === String ? $util.base64.encode(message.vote_public_key, 0, message.vote_public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.vote_public_key) : message.vote_public_key;
        if (message.weight != null && message.hasOwnProperty("weight"))
            object.weight = message.weight;
        return object;
    };

    CardanoCVoteRegistrationDelegation.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoCVoteRegistrationDelegation;
})();

$root.CardanoCVoteRegistrationParametersType = (function() {

    function CardanoCVoteRegistrationParametersType(properties) {
        this.staking_path = [];
        this.delegations = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoCVoteRegistrationParametersType.prototype.vote_public_key = $util.newBuffer([]);
    CardanoCVoteRegistrationParametersType.prototype.staking_path = $util.emptyArray;
    CardanoCVoteRegistrationParametersType.prototype.payment_address_parameters = null;
    CardanoCVoteRegistrationParametersType.prototype.nonce = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    CardanoCVoteRegistrationParametersType.prototype.format = 0;
    CardanoCVoteRegistrationParametersType.prototype.delegations = $util.emptyArray;
    CardanoCVoteRegistrationParametersType.prototype.voting_purpose = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    CardanoCVoteRegistrationParametersType.prototype.payment_address = "";

    CardanoCVoteRegistrationParametersType.create = function create(properties) {
        return new CardanoCVoteRegistrationParametersType(properties);
    };

    CardanoCVoteRegistrationParametersType.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.vote_public_key != null && Object.hasOwnProperty.call(message, "vote_public_key"))
            writer.uint32(10).bytes(message.vote_public_key);
        if (message.staking_path != null && message.staking_path.length)
            for (var i = 0; i < message.staking_path.length; ++i)
                writer.uint32(16).uint32(message.staking_path[i]);
        if (message.payment_address_parameters != null && Object.hasOwnProperty.call(message, "payment_address_parameters"))
            $root.CardanoAddressParametersType.encode(message.payment_address_parameters, writer.uint32(26).fork()).ldelim();
        writer.uint32(32).uint64(message.nonce);
        if (message.format != null && Object.hasOwnProperty.call(message, "format"))
            writer.uint32(40).int32(message.format);
        if (message.delegations != null && message.delegations.length)
            for (var i = 0; i < message.delegations.length; ++i)
                $root.CardanoCVoteRegistrationDelegation.encode(message.delegations[i], writer.uint32(50).fork()).ldelim();
        if (message.voting_purpose != null && Object.hasOwnProperty.call(message, "voting_purpose"))
            writer.uint32(56).uint64(message.voting_purpose);
        if (message.payment_address != null && Object.hasOwnProperty.call(message, "payment_address"))
            writer.uint32(66).string(message.payment_address);
        return writer;
    };

    CardanoCVoteRegistrationParametersType.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoCVoteRegistrationParametersType.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoCVoteRegistrationParametersType();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.vote_public_key = reader.bytes();
                break;
            case 2:
                if (!(message.staking_path && message.staking_path.length))
                    message.staking_path = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.staking_path.push(reader.uint32());
                } else
                    message.staking_path.push(reader.uint32());
                break;
            case 3:
                message.payment_address_parameters = $root.CardanoAddressParametersType.decode(reader, reader.uint32());
                break;
            case 4:
                message.nonce = reader.uint64();
                break;
            case 5:
                message.format = reader.int32();
                break;
            case 6:
                if (!(message.delegations && message.delegations.length))
                    message.delegations = [];
                message.delegations.push($root.CardanoCVoteRegistrationDelegation.decode(reader, reader.uint32()));
                break;
            case 7:
                message.voting_purpose = reader.uint64();
                break;
            case 8:
                message.payment_address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("nonce"))
            throw $util.ProtocolError("missing required 'nonce'", { instance: message });
        return message;
    };

    CardanoCVoteRegistrationParametersType.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoCVoteRegistrationParametersType.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.vote_public_key != null && message.hasOwnProperty("vote_public_key"))
            if (!(message.vote_public_key && typeof message.vote_public_key.length === "number" || $util.isString(message.vote_public_key)))
                return "vote_public_key: buffer expected";
        if (message.staking_path != null && message.hasOwnProperty("staking_path")) {
            if (!Array.isArray(message.staking_path))
                return "staking_path: array expected";
            for (var i = 0; i < message.staking_path.length; ++i)
                if (!$util.isInteger(message.staking_path[i]))
                    return "staking_path: integer[] expected";
        }
        if (message.payment_address_parameters != null && message.hasOwnProperty("payment_address_parameters")) {
            var error = $root.CardanoAddressParametersType.verify(message.payment_address_parameters);
            if (error)
                return "payment_address_parameters." + error;
        }
        if (!$util.isInteger(message.nonce) && !(message.nonce && $util.isInteger(message.nonce.low) && $util.isInteger(message.nonce.high)))
            return "nonce: integer|Long expected";
        if (message.format != null && message.hasOwnProperty("format"))
            switch (message.format) {
            default:
                return "format: enum value expected";
            case 0:
            case 1:
                break;
            }
        if (message.delegations != null && message.hasOwnProperty("delegations")) {
            if (!Array.isArray(message.delegations))
                return "delegations: array expected";
            for (var i = 0; i < message.delegations.length; ++i) {
                var error = $root.CardanoCVoteRegistrationDelegation.verify(message.delegations[i]);
                if (error)
                    return "delegations." + error;
            }
        }
        if (message.voting_purpose != null && message.hasOwnProperty("voting_purpose"))
            if (!$util.isInteger(message.voting_purpose) && !(message.voting_purpose && $util.isInteger(message.voting_purpose.low) && $util.isInteger(message.voting_purpose.high)))
                return "voting_purpose: integer|Long expected";
        if (message.payment_address != null && message.hasOwnProperty("payment_address"))
            if (!$util.isString(message.payment_address))
                return "payment_address: string expected";
        return null;
    };

    CardanoCVoteRegistrationParametersType.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoCVoteRegistrationParametersType)
            return object;
        var message = new $root.CardanoCVoteRegistrationParametersType();
        if (object.vote_public_key != null)
            if (typeof object.vote_public_key === "string")
                $util.base64.decode(object.vote_public_key, message.vote_public_key = $util.newBuffer($util.base64.length(object.vote_public_key)), 0);
            else if (object.vote_public_key.length)
                message.vote_public_key = object.vote_public_key;
        if (object.staking_path) {
            if (!Array.isArray(object.staking_path))
                throw TypeError(".CardanoCVoteRegistrationParametersType.staking_path: array expected");
            message.staking_path = [];
            for (var i = 0; i < object.staking_path.length; ++i)
                message.staking_path[i] = object.staking_path[i] >>> 0;
        }
        if (object.payment_address_parameters != null) {
            if (typeof object.payment_address_parameters !== "object")
                throw TypeError(".CardanoCVoteRegistrationParametersType.payment_address_parameters: object expected");
            message.payment_address_parameters = $root.CardanoAddressParametersType.fromObject(object.payment_address_parameters);
        }
        if (object.nonce != null)
            if ($util.Long)
                (message.nonce = $util.Long.fromValue(object.nonce)).unsigned = true;
            else if (typeof object.nonce === "string")
                message.nonce = parseInt(object.nonce, 10);
            else if (typeof object.nonce === "number")
                message.nonce = object.nonce;
            else if (typeof object.nonce === "object")
                message.nonce = new $util.LongBits(object.nonce.low >>> 0, object.nonce.high >>> 0).toNumber(true);
        switch (object.format) {
        case "CIP15":
        case 0:
            message.format = 0;
            break;
        case "CIP36":
        case 1:
            message.format = 1;
            break;
        }
        if (object.delegations) {
            if (!Array.isArray(object.delegations))
                throw TypeError(".CardanoCVoteRegistrationParametersType.delegations: array expected");
            message.delegations = [];
            for (var i = 0; i < object.delegations.length; ++i) {
                if (typeof object.delegations[i] !== "object")
                    throw TypeError(".CardanoCVoteRegistrationParametersType.delegations: object expected");
                message.delegations[i] = $root.CardanoCVoteRegistrationDelegation.fromObject(object.delegations[i]);
            }
        }
        if (object.voting_purpose != null)
            if ($util.Long)
                (message.voting_purpose = $util.Long.fromValue(object.voting_purpose)).unsigned = true;
            else if (typeof object.voting_purpose === "string")
                message.voting_purpose = parseInt(object.voting_purpose, 10);
            else if (typeof object.voting_purpose === "number")
                message.voting_purpose = object.voting_purpose;
            else if (typeof object.voting_purpose === "object")
                message.voting_purpose = new $util.LongBits(object.voting_purpose.low >>> 0, object.voting_purpose.high >>> 0).toNumber(true);
        if (object.payment_address != null)
            message.payment_address = String(object.payment_address);
        return message;
    };

    CardanoCVoteRegistrationParametersType.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults) {
            object.staking_path = [];
            object.delegations = [];
        }
        if (options.defaults) {
            if (options.bytes === String)
                object.vote_public_key = "";
            else {
                object.vote_public_key = [];
                if (options.bytes !== Array)
                    object.vote_public_key = $util.newBuffer(object.vote_public_key);
            }
            object.payment_address_parameters = null;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.nonce = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.nonce = options.longs === String ? "0" : 0;
            object.format = options.enums === String ? "CIP15" : 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.voting_purpose = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.voting_purpose = options.longs === String ? "0" : 0;
            object.payment_address = "";
        }
        if (message.vote_public_key != null && message.hasOwnProperty("vote_public_key"))
            object.vote_public_key = options.bytes === String ? $util.base64.encode(message.vote_public_key, 0, message.vote_public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.vote_public_key) : message.vote_public_key;
        if (message.staking_path && message.staking_path.length) {
            object.staking_path = [];
            for (var j = 0; j < message.staking_path.length; ++j)
                object.staking_path[j] = message.staking_path[j];
        }
        if (message.payment_address_parameters != null && message.hasOwnProperty("payment_address_parameters"))
            object.payment_address_parameters = $root.CardanoAddressParametersType.toObject(message.payment_address_parameters, options);
        if (message.nonce != null && message.hasOwnProperty("nonce"))
            if (typeof message.nonce === "number")
                object.nonce = options.longs === String ? String(message.nonce) : message.nonce;
            else
                object.nonce = options.longs === String ? $util.Long.prototype.toString.call(message.nonce) : options.longs === Number ? new $util.LongBits(message.nonce.low >>> 0, message.nonce.high >>> 0).toNumber(true) : message.nonce;
        if (message.format != null && message.hasOwnProperty("format"))
            object.format = options.enums === String ? $root.CardanoCVoteRegistrationFormat[message.format] : message.format;
        if (message.delegations && message.delegations.length) {
            object.delegations = [];
            for (var j = 0; j < message.delegations.length; ++j)
                object.delegations[j] = $root.CardanoCVoteRegistrationDelegation.toObject(message.delegations[j], options);
        }
        if (message.voting_purpose != null && message.hasOwnProperty("voting_purpose"))
            if (typeof message.voting_purpose === "number")
                object.voting_purpose = options.longs === String ? String(message.voting_purpose) : message.voting_purpose;
            else
                object.voting_purpose = options.longs === String ? $util.Long.prototype.toString.call(message.voting_purpose) : options.longs === Number ? new $util.LongBits(message.voting_purpose.low >>> 0, message.voting_purpose.high >>> 0).toNumber(true) : message.voting_purpose;
        if (message.payment_address != null && message.hasOwnProperty("payment_address"))
            object.payment_address = message.payment_address;
        return object;
    };

    CardanoCVoteRegistrationParametersType.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoCVoteRegistrationParametersType;
})();

$root.CardanoTxAuxiliaryData = (function() {

    function CardanoTxAuxiliaryData(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoTxAuxiliaryData.prototype.cvote_registration_parameters = null;
    CardanoTxAuxiliaryData.prototype.hash = $util.newBuffer([]);

    CardanoTxAuxiliaryData.create = function create(properties) {
        return new CardanoTxAuxiliaryData(properties);
    };

    CardanoTxAuxiliaryData.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.cvote_registration_parameters != null && Object.hasOwnProperty.call(message, "cvote_registration_parameters"))
            $root.CardanoCVoteRegistrationParametersType.encode(message.cvote_registration_parameters, writer.uint32(10).fork()).ldelim();
        if (message.hash != null && Object.hasOwnProperty.call(message, "hash"))
            writer.uint32(18).bytes(message.hash);
        return writer;
    };

    CardanoTxAuxiliaryData.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoTxAuxiliaryData.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoTxAuxiliaryData();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.cvote_registration_parameters = $root.CardanoCVoteRegistrationParametersType.decode(reader, reader.uint32());
                break;
            case 2:
                message.hash = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    CardanoTxAuxiliaryData.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoTxAuxiliaryData.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.cvote_registration_parameters != null && message.hasOwnProperty("cvote_registration_parameters")) {
            var error = $root.CardanoCVoteRegistrationParametersType.verify(message.cvote_registration_parameters);
            if (error)
                return "cvote_registration_parameters." + error;
        }
        if (message.hash != null && message.hasOwnProperty("hash"))
            if (!(message.hash && typeof message.hash.length === "number" || $util.isString(message.hash)))
                return "hash: buffer expected";
        return null;
    };

    CardanoTxAuxiliaryData.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoTxAuxiliaryData)
            return object;
        var message = new $root.CardanoTxAuxiliaryData();
        if (object.cvote_registration_parameters != null) {
            if (typeof object.cvote_registration_parameters !== "object")
                throw TypeError(".CardanoTxAuxiliaryData.cvote_registration_parameters: object expected");
            message.cvote_registration_parameters = $root.CardanoCVoteRegistrationParametersType.fromObject(object.cvote_registration_parameters);
        }
        if (object.hash != null)
            if (typeof object.hash === "string")
                $util.base64.decode(object.hash, message.hash = $util.newBuffer($util.base64.length(object.hash)), 0);
            else if (object.hash.length)
                message.hash = object.hash;
        return message;
    };

    CardanoTxAuxiliaryData.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.cvote_registration_parameters = null;
            if (options.bytes === String)
                object.hash = "";
            else {
                object.hash = [];
                if (options.bytes !== Array)
                    object.hash = $util.newBuffer(object.hash);
            }
        }
        if (message.cvote_registration_parameters != null && message.hasOwnProperty("cvote_registration_parameters"))
            object.cvote_registration_parameters = $root.CardanoCVoteRegistrationParametersType.toObject(message.cvote_registration_parameters, options);
        if (message.hash != null && message.hasOwnProperty("hash"))
            object.hash = options.bytes === String ? $util.base64.encode(message.hash, 0, message.hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.hash) : message.hash;
        return object;
    };

    CardanoTxAuxiliaryData.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoTxAuxiliaryData;
})();

$root.CardanoTxMint = (function() {

    function CardanoTxMint(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoTxMint.prototype.asset_groups_count = 0;

    CardanoTxMint.create = function create(properties) {
        return new CardanoTxMint(properties);
    };

    CardanoTxMint.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).uint32(message.asset_groups_count);
        return writer;
    };

    CardanoTxMint.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoTxMint.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoTxMint();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.asset_groups_count = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("asset_groups_count"))
            throw $util.ProtocolError("missing required 'asset_groups_count'", { instance: message });
        return message;
    };

    CardanoTxMint.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoTxMint.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isInteger(message.asset_groups_count))
            return "asset_groups_count: integer expected";
        return null;
    };

    CardanoTxMint.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoTxMint)
            return object;
        var message = new $root.CardanoTxMint();
        if (object.asset_groups_count != null)
            message.asset_groups_count = object.asset_groups_count >>> 0;
        return message;
    };

    CardanoTxMint.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.asset_groups_count = 0;
        if (message.asset_groups_count != null && message.hasOwnProperty("asset_groups_count"))
            object.asset_groups_count = message.asset_groups_count;
        return object;
    };

    CardanoTxMint.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoTxMint;
})();

$root.CardanoTxCollateralInput = (function() {

    function CardanoTxCollateralInput(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoTxCollateralInput.prototype.prev_hash = $util.newBuffer([]);
    CardanoTxCollateralInput.prototype.prev_index = 0;

    CardanoTxCollateralInput.create = function create(properties) {
        return new CardanoTxCollateralInput(properties);
    };

    CardanoTxCollateralInput.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.prev_hash);
        writer.uint32(16).uint32(message.prev_index);
        return writer;
    };

    CardanoTxCollateralInput.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoTxCollateralInput.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoTxCollateralInput();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.prev_hash = reader.bytes();
                break;
            case 2:
                message.prev_index = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("prev_hash"))
            throw $util.ProtocolError("missing required 'prev_hash'", { instance: message });
        if (!message.hasOwnProperty("prev_index"))
            throw $util.ProtocolError("missing required 'prev_index'", { instance: message });
        return message;
    };

    CardanoTxCollateralInput.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoTxCollateralInput.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.prev_hash && typeof message.prev_hash.length === "number" || $util.isString(message.prev_hash)))
            return "prev_hash: buffer expected";
        if (!$util.isInteger(message.prev_index))
            return "prev_index: integer expected";
        return null;
    };

    CardanoTxCollateralInput.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoTxCollateralInput)
            return object;
        var message = new $root.CardanoTxCollateralInput();
        if (object.prev_hash != null)
            if (typeof object.prev_hash === "string")
                $util.base64.decode(object.prev_hash, message.prev_hash = $util.newBuffer($util.base64.length(object.prev_hash)), 0);
            else if (object.prev_hash.length)
                message.prev_hash = object.prev_hash;
        if (object.prev_index != null)
            message.prev_index = object.prev_index >>> 0;
        return message;
    };

    CardanoTxCollateralInput.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.prev_hash = "";
            else {
                object.prev_hash = [];
                if (options.bytes !== Array)
                    object.prev_hash = $util.newBuffer(object.prev_hash);
            }
            object.prev_index = 0;
        }
        if (message.prev_hash != null && message.hasOwnProperty("prev_hash"))
            object.prev_hash = options.bytes === String ? $util.base64.encode(message.prev_hash, 0, message.prev_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.prev_hash) : message.prev_hash;
        if (message.prev_index != null && message.hasOwnProperty("prev_index"))
            object.prev_index = message.prev_index;
        return object;
    };

    CardanoTxCollateralInput.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoTxCollateralInput;
})();

$root.CardanoTxRequiredSigner = (function() {

    function CardanoTxRequiredSigner(properties) {
        this.key_path = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoTxRequiredSigner.prototype.key_hash = $util.newBuffer([]);
    CardanoTxRequiredSigner.prototype.key_path = $util.emptyArray;

    CardanoTxRequiredSigner.create = function create(properties) {
        return new CardanoTxRequiredSigner(properties);
    };

    CardanoTxRequiredSigner.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.key_hash != null && Object.hasOwnProperty.call(message, "key_hash"))
            writer.uint32(10).bytes(message.key_hash);
        if (message.key_path != null && message.key_path.length)
            for (var i = 0; i < message.key_path.length; ++i)
                writer.uint32(16).uint32(message.key_path[i]);
        return writer;
    };

    CardanoTxRequiredSigner.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoTxRequiredSigner.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoTxRequiredSigner();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.key_hash = reader.bytes();
                break;
            case 2:
                if (!(message.key_path && message.key_path.length))
                    message.key_path = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.key_path.push(reader.uint32());
                } else
                    message.key_path.push(reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    CardanoTxRequiredSigner.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoTxRequiredSigner.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.key_hash != null && message.hasOwnProperty("key_hash"))
            if (!(message.key_hash && typeof message.key_hash.length === "number" || $util.isString(message.key_hash)))
                return "key_hash: buffer expected";
        if (message.key_path != null && message.hasOwnProperty("key_path")) {
            if (!Array.isArray(message.key_path))
                return "key_path: array expected";
            for (var i = 0; i < message.key_path.length; ++i)
                if (!$util.isInteger(message.key_path[i]))
                    return "key_path: integer[] expected";
        }
        return null;
    };

    CardanoTxRequiredSigner.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoTxRequiredSigner)
            return object;
        var message = new $root.CardanoTxRequiredSigner();
        if (object.key_hash != null)
            if (typeof object.key_hash === "string")
                $util.base64.decode(object.key_hash, message.key_hash = $util.newBuffer($util.base64.length(object.key_hash)), 0);
            else if (object.key_hash.length)
                message.key_hash = object.key_hash;
        if (object.key_path) {
            if (!Array.isArray(object.key_path))
                throw TypeError(".CardanoTxRequiredSigner.key_path: array expected");
            message.key_path = [];
            for (var i = 0; i < object.key_path.length; ++i)
                message.key_path[i] = object.key_path[i] >>> 0;
        }
        return message;
    };

    CardanoTxRequiredSigner.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.key_path = [];
        if (options.defaults)
            if (options.bytes === String)
                object.key_hash = "";
            else {
                object.key_hash = [];
                if (options.bytes !== Array)
                    object.key_hash = $util.newBuffer(object.key_hash);
            }
        if (message.key_hash != null && message.hasOwnProperty("key_hash"))
            object.key_hash = options.bytes === String ? $util.base64.encode(message.key_hash, 0, message.key_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.key_hash) : message.key_hash;
        if (message.key_path && message.key_path.length) {
            object.key_path = [];
            for (var j = 0; j < message.key_path.length; ++j)
                object.key_path[j] = message.key_path[j];
        }
        return object;
    };

    CardanoTxRequiredSigner.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoTxRequiredSigner;
})();

$root.CardanoTxReferenceInput = (function() {

    function CardanoTxReferenceInput(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoTxReferenceInput.prototype.prev_hash = $util.newBuffer([]);
    CardanoTxReferenceInput.prototype.prev_index = 0;

    CardanoTxReferenceInput.create = function create(properties) {
        return new CardanoTxReferenceInput(properties);
    };

    CardanoTxReferenceInput.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.prev_hash);
        writer.uint32(16).uint32(message.prev_index);
        return writer;
    };

    CardanoTxReferenceInput.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoTxReferenceInput.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoTxReferenceInput();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.prev_hash = reader.bytes();
                break;
            case 2:
                message.prev_index = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("prev_hash"))
            throw $util.ProtocolError("missing required 'prev_hash'", { instance: message });
        if (!message.hasOwnProperty("prev_index"))
            throw $util.ProtocolError("missing required 'prev_index'", { instance: message });
        return message;
    };

    CardanoTxReferenceInput.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoTxReferenceInput.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.prev_hash && typeof message.prev_hash.length === "number" || $util.isString(message.prev_hash)))
            return "prev_hash: buffer expected";
        if (!$util.isInteger(message.prev_index))
            return "prev_index: integer expected";
        return null;
    };

    CardanoTxReferenceInput.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoTxReferenceInput)
            return object;
        var message = new $root.CardanoTxReferenceInput();
        if (object.prev_hash != null)
            if (typeof object.prev_hash === "string")
                $util.base64.decode(object.prev_hash, message.prev_hash = $util.newBuffer($util.base64.length(object.prev_hash)), 0);
            else if (object.prev_hash.length)
                message.prev_hash = object.prev_hash;
        if (object.prev_index != null)
            message.prev_index = object.prev_index >>> 0;
        return message;
    };

    CardanoTxReferenceInput.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.prev_hash = "";
            else {
                object.prev_hash = [];
                if (options.bytes !== Array)
                    object.prev_hash = $util.newBuffer(object.prev_hash);
            }
            object.prev_index = 0;
        }
        if (message.prev_hash != null && message.hasOwnProperty("prev_hash"))
            object.prev_hash = options.bytes === String ? $util.base64.encode(message.prev_hash, 0, message.prev_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.prev_hash) : message.prev_hash;
        if (message.prev_index != null && message.hasOwnProperty("prev_index"))
            object.prev_index = message.prev_index;
        return object;
    };

    CardanoTxReferenceInput.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoTxReferenceInput;
})();

$root.CardanoTxItemAck = (function() {

    function CardanoTxItemAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoTxItemAck.create = function create(properties) {
        return new CardanoTxItemAck(properties);
    };

    CardanoTxItemAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    CardanoTxItemAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoTxItemAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoTxItemAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    CardanoTxItemAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoTxItemAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    CardanoTxItemAck.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoTxItemAck)
            return object;
        return new $root.CardanoTxItemAck();
    };

    CardanoTxItemAck.toObject = function toObject() {
        return {};
    };

    CardanoTxItemAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoTxItemAck;
})();

$root.CardanoTxAuxiliaryDataSupplement = (function() {

    function CardanoTxAuxiliaryDataSupplement(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoTxAuxiliaryDataSupplement.prototype.type = 0;
    CardanoTxAuxiliaryDataSupplement.prototype.auxiliary_data_hash = $util.newBuffer([]);
    CardanoTxAuxiliaryDataSupplement.prototype.cvote_registration_signature = $util.newBuffer([]);

    CardanoTxAuxiliaryDataSupplement.create = function create(properties) {
        return new CardanoTxAuxiliaryDataSupplement(properties);
    };

    CardanoTxAuxiliaryDataSupplement.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).int32(message.type);
        if (message.auxiliary_data_hash != null && Object.hasOwnProperty.call(message, "auxiliary_data_hash"))
            writer.uint32(18).bytes(message.auxiliary_data_hash);
        if (message.cvote_registration_signature != null && Object.hasOwnProperty.call(message, "cvote_registration_signature"))
            writer.uint32(26).bytes(message.cvote_registration_signature);
        return writer;
    };

    CardanoTxAuxiliaryDataSupplement.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoTxAuxiliaryDataSupplement.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoTxAuxiliaryDataSupplement();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.type = reader.int32();
                break;
            case 2:
                message.auxiliary_data_hash = reader.bytes();
                break;
            case 3:
                message.cvote_registration_signature = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("type"))
            throw $util.ProtocolError("missing required 'type'", { instance: message });
        return message;
    };

    CardanoTxAuxiliaryDataSupplement.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoTxAuxiliaryDataSupplement.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        switch (message.type) {
        default:
            return "type: enum value expected";
        case 0:
        case 1:
            break;
        }
        if (message.auxiliary_data_hash != null && message.hasOwnProperty("auxiliary_data_hash"))
            if (!(message.auxiliary_data_hash && typeof message.auxiliary_data_hash.length === "number" || $util.isString(message.auxiliary_data_hash)))
                return "auxiliary_data_hash: buffer expected";
        if (message.cvote_registration_signature != null && message.hasOwnProperty("cvote_registration_signature"))
            if (!(message.cvote_registration_signature && typeof message.cvote_registration_signature.length === "number" || $util.isString(message.cvote_registration_signature)))
                return "cvote_registration_signature: buffer expected";
        return null;
    };

    CardanoTxAuxiliaryDataSupplement.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoTxAuxiliaryDataSupplement)
            return object;
        var message = new $root.CardanoTxAuxiliaryDataSupplement();
        switch (object.type) {
        case "NONE":
        case 0:
            message.type = 0;
            break;
        case "CVOTE_REGISTRATION_SIGNATURE":
        case 1:
            message.type = 1;
            break;
        }
        if (object.auxiliary_data_hash != null)
            if (typeof object.auxiliary_data_hash === "string")
                $util.base64.decode(object.auxiliary_data_hash, message.auxiliary_data_hash = $util.newBuffer($util.base64.length(object.auxiliary_data_hash)), 0);
            else if (object.auxiliary_data_hash.length)
                message.auxiliary_data_hash = object.auxiliary_data_hash;
        if (object.cvote_registration_signature != null)
            if (typeof object.cvote_registration_signature === "string")
                $util.base64.decode(object.cvote_registration_signature, message.cvote_registration_signature = $util.newBuffer($util.base64.length(object.cvote_registration_signature)), 0);
            else if (object.cvote_registration_signature.length)
                message.cvote_registration_signature = object.cvote_registration_signature;
        return message;
    };

    CardanoTxAuxiliaryDataSupplement.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.type = options.enums === String ? "NONE" : 0;
            if (options.bytes === String)
                object.auxiliary_data_hash = "";
            else {
                object.auxiliary_data_hash = [];
                if (options.bytes !== Array)
                    object.auxiliary_data_hash = $util.newBuffer(object.auxiliary_data_hash);
            }
            if (options.bytes === String)
                object.cvote_registration_signature = "";
            else {
                object.cvote_registration_signature = [];
                if (options.bytes !== Array)
                    object.cvote_registration_signature = $util.newBuffer(object.cvote_registration_signature);
            }
        }
        if (message.type != null && message.hasOwnProperty("type"))
            object.type = options.enums === String ? $root.CardanoTxAuxiliaryDataSupplementType[message.type] : message.type;
        if (message.auxiliary_data_hash != null && message.hasOwnProperty("auxiliary_data_hash"))
            object.auxiliary_data_hash = options.bytes === String ? $util.base64.encode(message.auxiliary_data_hash, 0, message.auxiliary_data_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.auxiliary_data_hash) : message.auxiliary_data_hash;
        if (message.cvote_registration_signature != null && message.hasOwnProperty("cvote_registration_signature"))
            object.cvote_registration_signature = options.bytes === String ? $util.base64.encode(message.cvote_registration_signature, 0, message.cvote_registration_signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.cvote_registration_signature) : message.cvote_registration_signature;
        return object;
    };

    CardanoTxAuxiliaryDataSupplement.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoTxAuxiliaryDataSupplement;
})();

$root.CardanoTxWitnessRequest = (function() {

    function CardanoTxWitnessRequest(properties) {
        this.path = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoTxWitnessRequest.prototype.path = $util.emptyArray;

    CardanoTxWitnessRequest.create = function create(properties) {
        return new CardanoTxWitnessRequest(properties);
    };

    CardanoTxWitnessRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.path != null && message.path.length)
            for (var i = 0; i < message.path.length; ++i)
                writer.uint32(8).uint32(message.path[i]);
        return writer;
    };

    CardanoTxWitnessRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoTxWitnessRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoTxWitnessRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.path && message.path.length))
                    message.path = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.path.push(reader.uint32());
                } else
                    message.path.push(reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    CardanoTxWitnessRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoTxWitnessRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.path != null && message.hasOwnProperty("path")) {
            if (!Array.isArray(message.path))
                return "path: array expected";
            for (var i = 0; i < message.path.length; ++i)
                if (!$util.isInteger(message.path[i]))
                    return "path: integer[] expected";
        }
        return null;
    };

    CardanoTxWitnessRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoTxWitnessRequest)
            return object;
        var message = new $root.CardanoTxWitnessRequest();
        if (object.path) {
            if (!Array.isArray(object.path))
                throw TypeError(".CardanoTxWitnessRequest.path: array expected");
            message.path = [];
            for (var i = 0; i < object.path.length; ++i)
                message.path[i] = object.path[i] >>> 0;
        }
        return message;
    };

    CardanoTxWitnessRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.path = [];
        if (message.path && message.path.length) {
            object.path = [];
            for (var j = 0; j < message.path.length; ++j)
                object.path[j] = message.path[j];
        }
        return object;
    };

    CardanoTxWitnessRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoTxWitnessRequest;
})();

$root.CardanoTxWitnessResponse = (function() {

    function CardanoTxWitnessResponse(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoTxWitnessResponse.prototype.type = 0;
    CardanoTxWitnessResponse.prototype.pub_key = $util.newBuffer([]);
    CardanoTxWitnessResponse.prototype.signature = $util.newBuffer([]);
    CardanoTxWitnessResponse.prototype.chain_code = $util.newBuffer([]);

    CardanoTxWitnessResponse.create = function create(properties) {
        return new CardanoTxWitnessResponse(properties);
    };

    CardanoTxWitnessResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).int32(message.type);
        writer.uint32(18).bytes(message.pub_key);
        writer.uint32(26).bytes(message.signature);
        if (message.chain_code != null && Object.hasOwnProperty.call(message, "chain_code"))
            writer.uint32(34).bytes(message.chain_code);
        return writer;
    };

    CardanoTxWitnessResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoTxWitnessResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoTxWitnessResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.type = reader.int32();
                break;
            case 2:
                message.pub_key = reader.bytes();
                break;
            case 3:
                message.signature = reader.bytes();
                break;
            case 4:
                message.chain_code = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("type"))
            throw $util.ProtocolError("missing required 'type'", { instance: message });
        if (!message.hasOwnProperty("pub_key"))
            throw $util.ProtocolError("missing required 'pub_key'", { instance: message });
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        return message;
    };

    CardanoTxWitnessResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoTxWitnessResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        switch (message.type) {
        default:
            return "type: enum value expected";
        case 0:
        case 1:
            break;
        }
        if (!(message.pub_key && typeof message.pub_key.length === "number" || $util.isString(message.pub_key)))
            return "pub_key: buffer expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        if (message.chain_code != null && message.hasOwnProperty("chain_code"))
            if (!(message.chain_code && typeof message.chain_code.length === "number" || $util.isString(message.chain_code)))
                return "chain_code: buffer expected";
        return null;
    };

    CardanoTxWitnessResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoTxWitnessResponse)
            return object;
        var message = new $root.CardanoTxWitnessResponse();
        switch (object.type) {
        case "BYRON_WITNESS":
        case 0:
            message.type = 0;
            break;
        case "SHELLEY_WITNESS":
        case 1:
            message.type = 1;
            break;
        }
        if (object.pub_key != null)
            if (typeof object.pub_key === "string")
                $util.base64.decode(object.pub_key, message.pub_key = $util.newBuffer($util.base64.length(object.pub_key)), 0);
            else if (object.pub_key.length)
                message.pub_key = object.pub_key;
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        if (object.chain_code != null)
            if (typeof object.chain_code === "string")
                $util.base64.decode(object.chain_code, message.chain_code = $util.newBuffer($util.base64.length(object.chain_code)), 0);
            else if (object.chain_code.length)
                message.chain_code = object.chain_code;
        return message;
    };

    CardanoTxWitnessResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.type = options.enums === String ? "BYRON_WITNESS" : 0;
            if (options.bytes === String)
                object.pub_key = "";
            else {
                object.pub_key = [];
                if (options.bytes !== Array)
                    object.pub_key = $util.newBuffer(object.pub_key);
            }
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
            if (options.bytes === String)
                object.chain_code = "";
            else {
                object.chain_code = [];
                if (options.bytes !== Array)
                    object.chain_code = $util.newBuffer(object.chain_code);
            }
        }
        if (message.type != null && message.hasOwnProperty("type"))
            object.type = options.enums === String ? $root.CardanoTxWitnessType[message.type] : message.type;
        if (message.pub_key != null && message.hasOwnProperty("pub_key"))
            object.pub_key = options.bytes === String ? $util.base64.encode(message.pub_key, 0, message.pub_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.pub_key) : message.pub_key;
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        if (message.chain_code != null && message.hasOwnProperty("chain_code"))
            object.chain_code = options.bytes === String ? $util.base64.encode(message.chain_code, 0, message.chain_code.length) : options.bytes === Array ? Array.prototype.slice.call(message.chain_code) : message.chain_code;
        return object;
    };

    CardanoTxWitnessResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoTxWitnessResponse;
})();

$root.CardanoTxHostAck = (function() {

    function CardanoTxHostAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoTxHostAck.create = function create(properties) {
        return new CardanoTxHostAck(properties);
    };

    CardanoTxHostAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    CardanoTxHostAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoTxHostAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoTxHostAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    CardanoTxHostAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoTxHostAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    CardanoTxHostAck.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoTxHostAck)
            return object;
        return new $root.CardanoTxHostAck();
    };

    CardanoTxHostAck.toObject = function toObject() {
        return {};
    };

    CardanoTxHostAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoTxHostAck;
})();

$root.CardanoTxBodyHash = (function() {

    function CardanoTxBodyHash(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoTxBodyHash.prototype.tx_hash = $util.newBuffer([]);

    CardanoTxBodyHash.create = function create(properties) {
        return new CardanoTxBodyHash(properties);
    };

    CardanoTxBodyHash.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.tx_hash);
        return writer;
    };

    CardanoTxBodyHash.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoTxBodyHash.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoTxBodyHash();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.tx_hash = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("tx_hash"))
            throw $util.ProtocolError("missing required 'tx_hash'", { instance: message });
        return message;
    };

    CardanoTxBodyHash.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoTxBodyHash.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.tx_hash && typeof message.tx_hash.length === "number" || $util.isString(message.tx_hash)))
            return "tx_hash: buffer expected";
        return null;
    };

    CardanoTxBodyHash.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoTxBodyHash)
            return object;
        var message = new $root.CardanoTxBodyHash();
        if (object.tx_hash != null)
            if (typeof object.tx_hash === "string")
                $util.base64.decode(object.tx_hash, message.tx_hash = $util.newBuffer($util.base64.length(object.tx_hash)), 0);
            else if (object.tx_hash.length)
                message.tx_hash = object.tx_hash;
        return message;
    };

    CardanoTxBodyHash.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.tx_hash = "";
            else {
                object.tx_hash = [];
                if (options.bytes !== Array)
                    object.tx_hash = $util.newBuffer(object.tx_hash);
            }
        if (message.tx_hash != null && message.hasOwnProperty("tx_hash"))
            object.tx_hash = options.bytes === String ? $util.base64.encode(message.tx_hash, 0, message.tx_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.tx_hash) : message.tx_hash;
        return object;
    };

    CardanoTxBodyHash.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoTxBodyHash;
})();

$root.CardanoSignTxFinished = (function() {

    function CardanoSignTxFinished(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoSignTxFinished.create = function create(properties) {
        return new CardanoSignTxFinished(properties);
    };

    CardanoSignTxFinished.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    CardanoSignTxFinished.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoSignTxFinished.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoSignTxFinished();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    CardanoSignTxFinished.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoSignTxFinished.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    CardanoSignTxFinished.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoSignTxFinished)
            return object;
        return new $root.CardanoSignTxFinished();
    };

    CardanoSignTxFinished.toObject = function toObject() {
        return {};
    };

    CardanoSignTxFinished.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoSignTxFinished;
})();

$root.CardanoSignMessage = (function() {

    function CardanoSignMessage(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoSignMessage.prototype.address_n = $util.emptyArray;
    CardanoSignMessage.prototype.message = $util.newBuffer([]);
    CardanoSignMessage.prototype.derivation_type = 0;
    CardanoSignMessage.prototype.network_id = 0;
    CardanoSignMessage.prototype.address_type = 0;
    CardanoSignMessage.prototype.protocol_magic = 0;

    CardanoSignMessage.create = function create(properties) {
        return new CardanoSignMessage(properties);
    };

    CardanoSignMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).bytes(message.message);
        writer.uint32(24).int32(message.derivation_type);
        writer.uint32(32).uint32(message.network_id);
        if (message.address_type != null && Object.hasOwnProperty.call(message, "address_type"))
            writer.uint32(40).int32(message.address_type);
        if (message.protocol_magic != null && Object.hasOwnProperty.call(message, "protocol_magic"))
            writer.uint32(48).uint32(message.protocol_magic);
        return writer;
    };

    CardanoSignMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoSignMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoSignMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.message = reader.bytes();
                break;
            case 3:
                message.derivation_type = reader.int32();
                break;
            case 4:
                message.network_id = reader.uint32();
                break;
            case 5:
                message.address_type = reader.int32();
                break;
            case 6:
                message.protocol_magic = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("message"))
            throw $util.ProtocolError("missing required 'message'", { instance: message });
        if (!message.hasOwnProperty("derivation_type"))
            throw $util.ProtocolError("missing required 'derivation_type'", { instance: message });
        if (!message.hasOwnProperty("network_id"))
            throw $util.ProtocolError("missing required 'network_id'", { instance: message });
        return message;
    };

    CardanoSignMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoSignMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!(message.message && typeof message.message.length === "number" || $util.isString(message.message)))
            return "message: buffer expected";
        switch (message.derivation_type) {
        default:
            return "derivation_type: enum value expected";
        case 0:
        case 1:
        case 2:
            break;
        }
        if (!$util.isInteger(message.network_id))
            return "network_id: integer expected";
        if (message.address_type != null && message.hasOwnProperty("address_type"))
            switch (message.address_type) {
            default:
                return "address_type: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
            case 8:
            case 14:
            case 15:
                break;
            }
        if (message.protocol_magic != null && message.hasOwnProperty("protocol_magic"))
            if (!$util.isInteger(message.protocol_magic))
                return "protocol_magic: integer expected";
        return null;
    };

    CardanoSignMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoSignMessage)
            return object;
        var message = new $root.CardanoSignMessage();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".CardanoSignMessage.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.message != null)
            if (typeof object.message === "string")
                $util.base64.decode(object.message, message.message = $util.newBuffer($util.base64.length(object.message)), 0);
            else if (object.message.length)
                message.message = object.message;
        switch (object.derivation_type) {
        case "LEDGER":
        case 0:
            message.derivation_type = 0;
            break;
        case "ICARUS":
        case 1:
            message.derivation_type = 1;
            break;
        case "ICARUS_TREZOR":
        case 2:
            message.derivation_type = 2;
            break;
        }
        if (object.network_id != null)
            message.network_id = object.network_id >>> 0;
        switch (object.address_type) {
        case "BASE":
        case 0:
            message.address_type = 0;
            break;
        case "BASE_SCRIPT_KEY":
        case 1:
            message.address_type = 1;
            break;
        case "BASE_KEY_SCRIPT":
        case 2:
            message.address_type = 2;
            break;
        case "BASE_SCRIPT_SCRIPT":
        case 3:
            message.address_type = 3;
            break;
        case "POINTER":
        case 4:
            message.address_type = 4;
            break;
        case "POINTER_SCRIPT":
        case 5:
            message.address_type = 5;
            break;
        case "ENTERPRISE":
        case 6:
            message.address_type = 6;
            break;
        case "ENTERPRISE_SCRIPT":
        case 7:
            message.address_type = 7;
            break;
        case "BYRON":
        case 8:
            message.address_type = 8;
            break;
        case "REWARD":
        case 14:
            message.address_type = 14;
            break;
        case "REWARD_SCRIPT":
        case 15:
            message.address_type = 15;
            break;
        }
        if (object.protocol_magic != null)
            message.protocol_magic = object.protocol_magic >>> 0;
        return message;
    };

    CardanoSignMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            if (options.bytes === String)
                object.message = "";
            else {
                object.message = [];
                if (options.bytes !== Array)
                    object.message = $util.newBuffer(object.message);
            }
            object.derivation_type = options.enums === String ? "LEDGER" : 0;
            object.network_id = 0;
            object.address_type = options.enums === String ? "BASE" : 0;
            object.protocol_magic = 0;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.message != null && message.hasOwnProperty("message"))
            object.message = options.bytes === String ? $util.base64.encode(message.message, 0, message.message.length) : options.bytes === Array ? Array.prototype.slice.call(message.message) : message.message;
        if (message.derivation_type != null && message.hasOwnProperty("derivation_type"))
            object.derivation_type = options.enums === String ? $root.CardanoDerivationType[message.derivation_type] : message.derivation_type;
        if (message.network_id != null && message.hasOwnProperty("network_id"))
            object.network_id = message.network_id;
        if (message.address_type != null && message.hasOwnProperty("address_type"))
            object.address_type = options.enums === String ? $root.CardanoAddressType[message.address_type] : message.address_type;
        if (message.protocol_magic != null && message.hasOwnProperty("protocol_magic"))
            object.protocol_magic = message.protocol_magic;
        return object;
    };

    CardanoSignMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoSignMessage;
})();

$root.CardanoMessageSignature = (function() {

    function CardanoMessageSignature(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoMessageSignature.prototype.signature = $util.newBuffer([]);
    CardanoMessageSignature.prototype.key = $util.newBuffer([]);

    CardanoMessageSignature.create = function create(properties) {
        return new CardanoMessageSignature(properties);
    };

    CardanoMessageSignature.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.signature);
        writer.uint32(18).bytes(message.key);
        return writer;
    };

    CardanoMessageSignature.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoMessageSignature.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoMessageSignature();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.signature = reader.bytes();
                break;
            case 2:
                message.key = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        if (!message.hasOwnProperty("key"))
            throw $util.ProtocolError("missing required 'key'", { instance: message });
        return message;
    };

    CardanoMessageSignature.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoMessageSignature.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        if (!(message.key && typeof message.key.length === "number" || $util.isString(message.key)))
            return "key: buffer expected";
        return null;
    };

    CardanoMessageSignature.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoMessageSignature)
            return object;
        var message = new $root.CardanoMessageSignature();
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        if (object.key != null)
            if (typeof object.key === "string")
                $util.base64.decode(object.key, message.key = $util.newBuffer($util.base64.length(object.key)), 0);
            else if (object.key.length)
                message.key = object.key;
        return message;
    };

    CardanoMessageSignature.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
            if (options.bytes === String)
                object.key = "";
            else {
                object.key = [];
                if (options.bytes !== Array)
                    object.key = $util.newBuffer(object.key);
            }
        }
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        if (message.key != null && message.hasOwnProperty("key"))
            object.key = options.bytes === String ? $util.base64.encode(message.key, 0, message.key.length) : options.bytes === Array ? Array.prototype.slice.call(message.key) : message.key;
        return object;
    };

    CardanoMessageSignature.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoMessageSignature;
})();

$root.Success = (function() {

    function Success(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    Success.prototype.message = "";

    Success.create = function create(properties) {
        return new Success(properties);
    };

    Success.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
            writer.uint32(10).string(message.message);
        return writer;
    };

    Success.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    Success.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Success();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.message = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    Success.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    Success.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.message != null && message.hasOwnProperty("message"))
            if (!$util.isString(message.message))
                return "message: string expected";
        return null;
    };

    Success.fromObject = function fromObject(object) {
        if (object instanceof $root.Success)
            return object;
        var message = new $root.Success();
        if (object.message != null)
            message.message = String(object.message);
        return message;
    };

    Success.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.message = "";
        if (message.message != null && message.hasOwnProperty("message"))
            object.message = message.message;
        return object;
    };

    Success.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return Success;
})();

$root.Failure = (function() {

    function Failure(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    Failure.prototype.code = 1;
    Failure.prototype.message = "";

    Failure.create = function create(properties) {
        return new Failure(properties);
    };

    Failure.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.code != null && Object.hasOwnProperty.call(message, "code"))
            writer.uint32(8).int32(message.code);
        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
            writer.uint32(18).string(message.message);
        return writer;
    };

    Failure.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    Failure.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Failure();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.code = reader.int32();
                break;
            case 2:
                message.message = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    Failure.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    Failure.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.code != null && message.hasOwnProperty("code"))
            switch (message.code) {
            default:
                return "code: enum value expected";
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
            case 8:
            case 9:
            case 10:
            case 11:
            case 12:
            case 13:
            case 14:
            case 99:
                break;
            }
        if (message.message != null && message.hasOwnProperty("message"))
            if (!$util.isString(message.message))
                return "message: string expected";
        return null;
    };

    Failure.fromObject = function fromObject(object) {
        if (object instanceof $root.Failure)
            return object;
        var message = new $root.Failure();
        switch (object.code) {
        case "Failure_UnexpectedMessage":
        case 1:
            message.code = 1;
            break;
        case "Failure_ButtonExpected":
        case 2:
            message.code = 2;
            break;
        case "Failure_DataError":
        case 3:
            message.code = 3;
            break;
        case "Failure_ActionCancelled":
        case 4:
            message.code = 4;
            break;
        case "Failure_PinExpected":
        case 5:
            message.code = 5;
            break;
        case "Failure_PinCancelled":
        case 6:
            message.code = 6;
            break;
        case "Failure_PinInvalid":
        case 7:
            message.code = 7;
            break;
        case "Failure_InvalidSignature":
        case 8:
            message.code = 8;
            break;
        case "Failure_ProcessError":
        case 9:
            message.code = 9;
            break;
        case "Failure_NotEnoughFunds":
        case 10:
            message.code = 10;
            break;
        case "Failure_NotInitialized":
        case 11:
            message.code = 11;
            break;
        case "Failure_PinMismatch":
        case 12:
            message.code = 12;
            break;
        case "Failure_WipeCodeMismatch":
        case 13:
            message.code = 13;
            break;
        case "Failure_InvalidSession":
        case 14:
            message.code = 14;
            break;
        case "Failure_FirmwareError":
        case 99:
            message.code = 99;
            break;
        }
        if (object.message != null)
            message.message = String(object.message);
        return message;
    };

    Failure.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.code = options.enums === String ? "Failure_UnexpectedMessage" : 1;
            object.message = "";
        }
        if (message.code != null && message.hasOwnProperty("code"))
            object.code = options.enums === String ? $root.Failure.FailureType[message.code] : message.code;
        if (message.message != null && message.hasOwnProperty("message"))
            object.message = message.message;
        return object;
    };

    Failure.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    Failure.FailureType = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[1] = "Failure_UnexpectedMessage"] = 1;
        values[valuesById[2] = "Failure_ButtonExpected"] = 2;
        values[valuesById[3] = "Failure_DataError"] = 3;
        values[valuesById[4] = "Failure_ActionCancelled"] = 4;
        values[valuesById[5] = "Failure_PinExpected"] = 5;
        values[valuesById[6] = "Failure_PinCancelled"] = 6;
        values[valuesById[7] = "Failure_PinInvalid"] = 7;
        values[valuesById[8] = "Failure_InvalidSignature"] = 8;
        values[valuesById[9] = "Failure_ProcessError"] = 9;
        values[valuesById[10] = "Failure_NotEnoughFunds"] = 10;
        values[valuesById[11] = "Failure_NotInitialized"] = 11;
        values[valuesById[12] = "Failure_PinMismatch"] = 12;
        values[valuesById[13] = "Failure_WipeCodeMismatch"] = 13;
        values[valuesById[14] = "Failure_InvalidSession"] = 14;
        values[valuesById[99] = "Failure_FirmwareError"] = 99;
        return values;
    })();

    return Failure;
})();

$root.ButtonRequest = (function() {

    function ButtonRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ButtonRequest.prototype.code = 1;
    ButtonRequest.prototype.pages = 0;

    ButtonRequest.create = function create(properties) {
        return new ButtonRequest(properties);
    };

    ButtonRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.code != null && Object.hasOwnProperty.call(message, "code"))
            writer.uint32(8).int32(message.code);
        if (message.pages != null && Object.hasOwnProperty.call(message, "pages"))
            writer.uint32(16).uint32(message.pages);
        return writer;
    };

    ButtonRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ButtonRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ButtonRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.code = reader.int32();
                break;
            case 2:
                message.pages = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    ButtonRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ButtonRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.code != null && message.hasOwnProperty("code"))
            switch (message.code) {
            default:
                return "code: enum value expected";
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
            case 8:
            case 9:
            case 10:
            case 11:
            case 12:
            case 13:
            case 14:
            case 15:
            case 16:
            case 17:
            case 18:
            case 19:
            case 20:
            case 8000:
                break;
            }
        if (message.pages != null && message.hasOwnProperty("pages"))
            if (!$util.isInteger(message.pages))
                return "pages: integer expected";
        return null;
    };

    ButtonRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.ButtonRequest)
            return object;
        var message = new $root.ButtonRequest();
        switch (object.code) {
        case "ButtonRequest_Other":
        case 1:
            message.code = 1;
            break;
        case "ButtonRequest_FeeOverThreshold":
        case 2:
            message.code = 2;
            break;
        case "ButtonRequest_ConfirmOutput":
        case 3:
            message.code = 3;
            break;
        case "ButtonRequest_ResetDevice":
        case 4:
            message.code = 4;
            break;
        case "ButtonRequest_ConfirmWord":
        case 5:
            message.code = 5;
            break;
        case "ButtonRequest_WipeDevice":
        case 6:
            message.code = 6;
            break;
        case "ButtonRequest_ProtectCall":
        case 7:
            message.code = 7;
            break;
        case "ButtonRequest_SignTx":
        case 8:
            message.code = 8;
            break;
        case "ButtonRequest_FirmwareCheck":
        case 9:
            message.code = 9;
            break;
        case "ButtonRequest_Address":
        case 10:
            message.code = 10;
            break;
        case "ButtonRequest_PublicKey":
        case 11:
            message.code = 11;
            break;
        case "ButtonRequest_MnemonicWordCount":
        case 12:
            message.code = 12;
            break;
        case "ButtonRequest_MnemonicInput":
        case 13:
            message.code = 13;
            break;
        case "_Deprecated_ButtonRequest_PassphraseType":
        case 14:
            message.code = 14;
            break;
        case "ButtonRequest_UnknownDerivationPath":
        case 15:
            message.code = 15;
            break;
        case "ButtonRequest_RecoveryHomepage":
        case 16:
            message.code = 16;
            break;
        case "ButtonRequest_Success":
        case 17:
            message.code = 17;
            break;
        case "ButtonRequest_Warning":
        case 18:
            message.code = 18;
            break;
        case "ButtonRequest_PassphraseEntry":
        case 19:
            message.code = 19;
            break;
        case "ButtonRequest_PinEntry":
        case 20:
            message.code = 20;
            break;
        case "ButtonRequest_AttachPin":
        case 8000:
            message.code = 8000;
            break;
        }
        if (object.pages != null)
            message.pages = object.pages >>> 0;
        return message;
    };

    ButtonRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.code = options.enums === String ? "ButtonRequest_Other" : 1;
            object.pages = 0;
        }
        if (message.code != null && message.hasOwnProperty("code"))
            object.code = options.enums === String ? $root.ButtonRequest.ButtonRequestType[message.code] : message.code;
        if (message.pages != null && message.hasOwnProperty("pages"))
            object.pages = message.pages;
        return object;
    };

    ButtonRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    ButtonRequest.ButtonRequestType = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[1] = "ButtonRequest_Other"] = 1;
        values[valuesById[2] = "ButtonRequest_FeeOverThreshold"] = 2;
        values[valuesById[3] = "ButtonRequest_ConfirmOutput"] = 3;
        values[valuesById[4] = "ButtonRequest_ResetDevice"] = 4;
        values[valuesById[5] = "ButtonRequest_ConfirmWord"] = 5;
        values[valuesById[6] = "ButtonRequest_WipeDevice"] = 6;
        values[valuesById[7] = "ButtonRequest_ProtectCall"] = 7;
        values[valuesById[8] = "ButtonRequest_SignTx"] = 8;
        values[valuesById[9] = "ButtonRequest_FirmwareCheck"] = 9;
        values[valuesById[10] = "ButtonRequest_Address"] = 10;
        values[valuesById[11] = "ButtonRequest_PublicKey"] = 11;
        values[valuesById[12] = "ButtonRequest_MnemonicWordCount"] = 12;
        values[valuesById[13] = "ButtonRequest_MnemonicInput"] = 13;
        values[valuesById[14] = "_Deprecated_ButtonRequest_PassphraseType"] = 14;
        values[valuesById[15] = "ButtonRequest_UnknownDerivationPath"] = 15;
        values[valuesById[16] = "ButtonRequest_RecoveryHomepage"] = 16;
        values[valuesById[17] = "ButtonRequest_Success"] = 17;
        values[valuesById[18] = "ButtonRequest_Warning"] = 18;
        values[valuesById[19] = "ButtonRequest_PassphraseEntry"] = 19;
        values[valuesById[20] = "ButtonRequest_PinEntry"] = 20;
        values[valuesById[8000] = "ButtonRequest_AttachPin"] = 8000;
        return values;
    })();

    return ButtonRequest;
})();

$root.ButtonAck = (function() {

    function ButtonAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ButtonAck.create = function create(properties) {
        return new ButtonAck(properties);
    };

    ButtonAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    ButtonAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ButtonAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ButtonAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    ButtonAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ButtonAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    ButtonAck.fromObject = function fromObject(object) {
        if (object instanceof $root.ButtonAck)
            return object;
        return new $root.ButtonAck();
    };

    ButtonAck.toObject = function toObject() {
        return {};
    };

    ButtonAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ButtonAck;
})();

$root.PinMatrixRequest = (function() {

    function PinMatrixRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    PinMatrixRequest.prototype.type = 1;

    PinMatrixRequest.create = function create(properties) {
        return new PinMatrixRequest(properties);
    };

    PinMatrixRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.type != null && Object.hasOwnProperty.call(message, "type"))
            writer.uint32(8).int32(message.type);
        return writer;
    };

    PinMatrixRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    PinMatrixRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.PinMatrixRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.type = reader.int32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    PinMatrixRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    PinMatrixRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.type != null && message.hasOwnProperty("type"))
            switch (message.type) {
            default:
                return "type: enum value expected";
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
            case 8000:
                break;
            }
        return null;
    };

    PinMatrixRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.PinMatrixRequest)
            return object;
        var message = new $root.PinMatrixRequest();
        switch (object.type) {
        case "PinMatrixRequestType_Current":
        case 1:
            message.type = 1;
            break;
        case "PinMatrixRequestType_NewFirst":
        case 2:
            message.type = 2;
            break;
        case "PinMatrixRequestType_NewSecond":
        case 3:
            message.type = 3;
            break;
        case "PinMatrixRequestType_WipeCodeFirst":
        case 4:
            message.type = 4;
            break;
        case "PinMatrixRequestType_WipeCodeSecond":
        case 5:
            message.type = 5;
            break;
        case "PinMatrixRequestType_BackupFirst":
        case 6:
            message.type = 6;
            break;
        case "PinMatrixRequestType_BackupSecond":
        case 7:
            message.type = 7;
            break;
        case "PinMatrixRequestType_AttachToPin":
        case 8000:
            message.type = 8000;
            break;
        }
        return message;
    };

    PinMatrixRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.type = options.enums === String ? "PinMatrixRequestType_Current" : 1;
        if (message.type != null && message.hasOwnProperty("type"))
            object.type = options.enums === String ? $root.PinMatrixRequest.PinMatrixRequestType[message.type] : message.type;
        return object;
    };

    PinMatrixRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    PinMatrixRequest.PinMatrixRequestType = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[1] = "PinMatrixRequestType_Current"] = 1;
        values[valuesById[2] = "PinMatrixRequestType_NewFirst"] = 2;
        values[valuesById[3] = "PinMatrixRequestType_NewSecond"] = 3;
        values[valuesById[4] = "PinMatrixRequestType_WipeCodeFirst"] = 4;
        values[valuesById[5] = "PinMatrixRequestType_WipeCodeSecond"] = 5;
        values[valuesById[6] = "PinMatrixRequestType_BackupFirst"] = 6;
        values[valuesById[7] = "PinMatrixRequestType_BackupSecond"] = 7;
        values[valuesById[8000] = "PinMatrixRequestType_AttachToPin"] = 8000;
        return values;
    })();

    return PinMatrixRequest;
})();

$root.PinMatrixAck = (function() {

    function PinMatrixAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    PinMatrixAck.prototype.pin = "";
    PinMatrixAck.prototype.new_pin = "";

    PinMatrixAck.create = function create(properties) {
        return new PinMatrixAck(properties);
    };

    PinMatrixAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.pin);
        if (message.new_pin != null && Object.hasOwnProperty.call(message, "new_pin"))
            writer.uint32(18).string(message.new_pin);
        return writer;
    };

    PinMatrixAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    PinMatrixAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.PinMatrixAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.pin = reader.string();
                break;
            case 2:
                message.new_pin = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("pin"))
            throw $util.ProtocolError("missing required 'pin'", { instance: message });
        return message;
    };

    PinMatrixAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    PinMatrixAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.pin))
            return "pin: string expected";
        if (message.new_pin != null && message.hasOwnProperty("new_pin"))
            if (!$util.isString(message.new_pin))
                return "new_pin: string expected";
        return null;
    };

    PinMatrixAck.fromObject = function fromObject(object) {
        if (object instanceof $root.PinMatrixAck)
            return object;
        var message = new $root.PinMatrixAck();
        if (object.pin != null)
            message.pin = String(object.pin);
        if (object.new_pin != null)
            message.new_pin = String(object.new_pin);
        return message;
    };

    PinMatrixAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.pin = "";
            object.new_pin = "";
        }
        if (message.pin != null && message.hasOwnProperty("pin"))
            object.pin = message.pin;
        if (message.new_pin != null && message.hasOwnProperty("new_pin"))
            object.new_pin = message.new_pin;
        return object;
    };

    PinMatrixAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return PinMatrixAck;
})();

$root.PassphraseRequest = (function() {

    function PassphraseRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    PassphraseRequest.prototype._on_device = false;
    PassphraseRequest.prototype.exists_attach_pin_user = false;

    PassphraseRequest.create = function create(properties) {
        return new PassphraseRequest(properties);
    };

    PassphraseRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message._on_device != null && Object.hasOwnProperty.call(message, "_on_device"))
            writer.uint32(8).bool(message._on_device);
        if (message.exists_attach_pin_user != null && Object.hasOwnProperty.call(message, "exists_attach_pin_user"))
            writer.uint32(64000).bool(message.exists_attach_pin_user);
        return writer;
    };

    PassphraseRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    PassphraseRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.PassphraseRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message._on_device = reader.bool();
                break;
            case 8000:
                message.exists_attach_pin_user = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    PassphraseRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    PassphraseRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message._on_device != null && message.hasOwnProperty("_on_device"))
            if (typeof message._on_device !== "boolean")
                return "_on_device: boolean expected";
        if (message.exists_attach_pin_user != null && message.hasOwnProperty("exists_attach_pin_user"))
            if (typeof message.exists_attach_pin_user !== "boolean")
                return "exists_attach_pin_user: boolean expected";
        return null;
    };

    PassphraseRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.PassphraseRequest)
            return object;
        var message = new $root.PassphraseRequest();
        if (object._on_device != null)
            message._on_device = Boolean(object._on_device);
        if (object.exists_attach_pin_user != null)
            message.exists_attach_pin_user = Boolean(object.exists_attach_pin_user);
        return message;
    };

    PassphraseRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object._on_device = false;
            object.exists_attach_pin_user = false;
        }
        if (message._on_device != null && message.hasOwnProperty("_on_device"))
            object._on_device = message._on_device;
        if (message.exists_attach_pin_user != null && message.hasOwnProperty("exists_attach_pin_user"))
            object.exists_attach_pin_user = message.exists_attach_pin_user;
        return object;
    };

    PassphraseRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return PassphraseRequest;
})();

$root.PassphraseAck = (function() {

    function PassphraseAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    PassphraseAck.prototype.passphrase = "";
    PassphraseAck.prototype._state = $util.newBuffer([]);
    PassphraseAck.prototype.on_device = false;
    PassphraseAck.prototype.on_device_attach_pin = false;

    PassphraseAck.create = function create(properties) {
        return new PassphraseAck(properties);
    };

    PassphraseAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.passphrase != null && Object.hasOwnProperty.call(message, "passphrase"))
            writer.uint32(10).string(message.passphrase);
        if (message._state != null && Object.hasOwnProperty.call(message, "_state"))
            writer.uint32(18).bytes(message._state);
        if (message.on_device != null && Object.hasOwnProperty.call(message, "on_device"))
            writer.uint32(24).bool(message.on_device);
        if (message.on_device_attach_pin != null && Object.hasOwnProperty.call(message, "on_device_attach_pin"))
            writer.uint32(64000).bool(message.on_device_attach_pin);
        return writer;
    };

    PassphraseAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    PassphraseAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.PassphraseAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.passphrase = reader.string();
                break;
            case 2:
                message._state = reader.bytes();
                break;
            case 3:
                message.on_device = reader.bool();
                break;
            case 8000:
                message.on_device_attach_pin = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    PassphraseAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    PassphraseAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.passphrase != null && message.hasOwnProperty("passphrase"))
            if (!$util.isString(message.passphrase))
                return "passphrase: string expected";
        if (message._state != null && message.hasOwnProperty("_state"))
            if (!(message._state && typeof message._state.length === "number" || $util.isString(message._state)))
                return "_state: buffer expected";
        if (message.on_device != null && message.hasOwnProperty("on_device"))
            if (typeof message.on_device !== "boolean")
                return "on_device: boolean expected";
        if (message.on_device_attach_pin != null && message.hasOwnProperty("on_device_attach_pin"))
            if (typeof message.on_device_attach_pin !== "boolean")
                return "on_device_attach_pin: boolean expected";
        return null;
    };

    PassphraseAck.fromObject = function fromObject(object) {
        if (object instanceof $root.PassphraseAck)
            return object;
        var message = new $root.PassphraseAck();
        if (object.passphrase != null)
            message.passphrase = String(object.passphrase);
        if (object._state != null)
            if (typeof object._state === "string")
                $util.base64.decode(object._state, message._state = $util.newBuffer($util.base64.length(object._state)), 0);
            else if (object._state.length)
                message._state = object._state;
        if (object.on_device != null)
            message.on_device = Boolean(object.on_device);
        if (object.on_device_attach_pin != null)
            message.on_device_attach_pin = Boolean(object.on_device_attach_pin);
        return message;
    };

    PassphraseAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.passphrase = "";
            if (options.bytes === String)
                object._state = "";
            else {
                object._state = [];
                if (options.bytes !== Array)
                    object._state = $util.newBuffer(object._state);
            }
            object.on_device = false;
            object.on_device_attach_pin = false;
        }
        if (message.passphrase != null && message.hasOwnProperty("passphrase"))
            object.passphrase = message.passphrase;
        if (message._state != null && message.hasOwnProperty("_state"))
            object._state = options.bytes === String ? $util.base64.encode(message._state, 0, message._state.length) : options.bytes === Array ? Array.prototype.slice.call(message._state) : message._state;
        if (message.on_device != null && message.hasOwnProperty("on_device"))
            object.on_device = message.on_device;
        if (message.on_device_attach_pin != null && message.hasOwnProperty("on_device_attach_pin"))
            object.on_device_attach_pin = message.on_device_attach_pin;
        return object;
    };

    PassphraseAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return PassphraseAck;
})();

$root.Deprecated_PassphraseStateRequest = (function() {

    function Deprecated_PassphraseStateRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    Deprecated_PassphraseStateRequest.prototype.state = $util.newBuffer([]);

    Deprecated_PassphraseStateRequest.create = function create(properties) {
        return new Deprecated_PassphraseStateRequest(properties);
    };

    Deprecated_PassphraseStateRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.state != null && Object.hasOwnProperty.call(message, "state"))
            writer.uint32(10).bytes(message.state);
        return writer;
    };

    Deprecated_PassphraseStateRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    Deprecated_PassphraseStateRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Deprecated_PassphraseStateRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.state = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    Deprecated_PassphraseStateRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    Deprecated_PassphraseStateRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.state != null && message.hasOwnProperty("state"))
            if (!(message.state && typeof message.state.length === "number" || $util.isString(message.state)))
                return "state: buffer expected";
        return null;
    };

    Deprecated_PassphraseStateRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.Deprecated_PassphraseStateRequest)
            return object;
        var message = new $root.Deprecated_PassphraseStateRequest();
        if (object.state != null)
            if (typeof object.state === "string")
                $util.base64.decode(object.state, message.state = $util.newBuffer($util.base64.length(object.state)), 0);
            else if (object.state.length)
                message.state = object.state;
        return message;
    };

    Deprecated_PassphraseStateRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.state = "";
            else {
                object.state = [];
                if (options.bytes !== Array)
                    object.state = $util.newBuffer(object.state);
            }
        if (message.state != null && message.hasOwnProperty("state"))
            object.state = options.bytes === String ? $util.base64.encode(message.state, 0, message.state.length) : options.bytes === Array ? Array.prototype.slice.call(message.state) : message.state;
        return object;
    };

    Deprecated_PassphraseStateRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return Deprecated_PassphraseStateRequest;
})();

$root.Deprecated_PassphraseStateAck = (function() {

    function Deprecated_PassphraseStateAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    Deprecated_PassphraseStateAck.create = function create(properties) {
        return new Deprecated_PassphraseStateAck(properties);
    };

    Deprecated_PassphraseStateAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    Deprecated_PassphraseStateAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    Deprecated_PassphraseStateAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Deprecated_PassphraseStateAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    Deprecated_PassphraseStateAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    Deprecated_PassphraseStateAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    Deprecated_PassphraseStateAck.fromObject = function fromObject(object) {
        if (object instanceof $root.Deprecated_PassphraseStateAck)
            return object;
        return new $root.Deprecated_PassphraseStateAck();
    };

    Deprecated_PassphraseStateAck.toObject = function toObject() {
        return {};
    };

    Deprecated_PassphraseStateAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return Deprecated_PassphraseStateAck;
})();

$root.HDNodeType = (function() {

    function HDNodeType(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    HDNodeType.prototype.depth = 0;
    HDNodeType.prototype.fingerprint = 0;
    HDNodeType.prototype.child_num = 0;
    HDNodeType.prototype.chain_code = $util.newBuffer([]);
    HDNodeType.prototype.private_key = $util.newBuffer([]);
    HDNodeType.prototype.public_key = $util.newBuffer([]);

    HDNodeType.create = function create(properties) {
        return new HDNodeType(properties);
    };

    HDNodeType.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).uint32(message.depth);
        writer.uint32(16).uint32(message.fingerprint);
        writer.uint32(24).uint32(message.child_num);
        writer.uint32(34).bytes(message.chain_code);
        if (message.private_key != null && Object.hasOwnProperty.call(message, "private_key"))
            writer.uint32(42).bytes(message.private_key);
        writer.uint32(50).bytes(message.public_key);
        return writer;
    };

    HDNodeType.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    HDNodeType.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.HDNodeType();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.depth = reader.uint32();
                break;
            case 2:
                message.fingerprint = reader.uint32();
                break;
            case 3:
                message.child_num = reader.uint32();
                break;
            case 4:
                message.chain_code = reader.bytes();
                break;
            case 5:
                message.private_key = reader.bytes();
                break;
            case 6:
                message.public_key = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("depth"))
            throw $util.ProtocolError("missing required 'depth'", { instance: message });
        if (!message.hasOwnProperty("fingerprint"))
            throw $util.ProtocolError("missing required 'fingerprint'", { instance: message });
        if (!message.hasOwnProperty("child_num"))
            throw $util.ProtocolError("missing required 'child_num'", { instance: message });
        if (!message.hasOwnProperty("chain_code"))
            throw $util.ProtocolError("missing required 'chain_code'", { instance: message });
        if (!message.hasOwnProperty("public_key"))
            throw $util.ProtocolError("missing required 'public_key'", { instance: message });
        return message;
    };

    HDNodeType.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    HDNodeType.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isInteger(message.depth))
            return "depth: integer expected";
        if (!$util.isInteger(message.fingerprint))
            return "fingerprint: integer expected";
        if (!$util.isInteger(message.child_num))
            return "child_num: integer expected";
        if (!(message.chain_code && typeof message.chain_code.length === "number" || $util.isString(message.chain_code)))
            return "chain_code: buffer expected";
        if (message.private_key != null && message.hasOwnProperty("private_key"))
            if (!(message.private_key && typeof message.private_key.length === "number" || $util.isString(message.private_key)))
                return "private_key: buffer expected";
        if (!(message.public_key && typeof message.public_key.length === "number" || $util.isString(message.public_key)))
            return "public_key: buffer expected";
        return null;
    };

    HDNodeType.fromObject = function fromObject(object) {
        if (object instanceof $root.HDNodeType)
            return object;
        var message = new $root.HDNodeType();
        if (object.depth != null)
            message.depth = object.depth >>> 0;
        if (object.fingerprint != null)
            message.fingerprint = object.fingerprint >>> 0;
        if (object.child_num != null)
            message.child_num = object.child_num >>> 0;
        if (object.chain_code != null)
            if (typeof object.chain_code === "string")
                $util.base64.decode(object.chain_code, message.chain_code = $util.newBuffer($util.base64.length(object.chain_code)), 0);
            else if (object.chain_code.length)
                message.chain_code = object.chain_code;
        if (object.private_key != null)
            if (typeof object.private_key === "string")
                $util.base64.decode(object.private_key, message.private_key = $util.newBuffer($util.base64.length(object.private_key)), 0);
            else if (object.private_key.length)
                message.private_key = object.private_key;
        if (object.public_key != null)
            if (typeof object.public_key === "string")
                $util.base64.decode(object.public_key, message.public_key = $util.newBuffer($util.base64.length(object.public_key)), 0);
            else if (object.public_key.length)
                message.public_key = object.public_key;
        return message;
    };

    HDNodeType.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.depth = 0;
            object.fingerprint = 0;
            object.child_num = 0;
            if (options.bytes === String)
                object.chain_code = "";
            else {
                object.chain_code = [];
                if (options.bytes !== Array)
                    object.chain_code = $util.newBuffer(object.chain_code);
            }
            if (options.bytes === String)
                object.private_key = "";
            else {
                object.private_key = [];
                if (options.bytes !== Array)
                    object.private_key = $util.newBuffer(object.private_key);
            }
            if (options.bytes === String)
                object.public_key = "";
            else {
                object.public_key = [];
                if (options.bytes !== Array)
                    object.public_key = $util.newBuffer(object.public_key);
            }
        }
        if (message.depth != null && message.hasOwnProperty("depth"))
            object.depth = message.depth;
        if (message.fingerprint != null && message.hasOwnProperty("fingerprint"))
            object.fingerprint = message.fingerprint;
        if (message.child_num != null && message.hasOwnProperty("child_num"))
            object.child_num = message.child_num;
        if (message.chain_code != null && message.hasOwnProperty("chain_code"))
            object.chain_code = options.bytes === String ? $util.base64.encode(message.chain_code, 0, message.chain_code.length) : options.bytes === Array ? Array.prototype.slice.call(message.chain_code) : message.chain_code;
        if (message.private_key != null && message.hasOwnProperty("private_key"))
            object.private_key = options.bytes === String ? $util.base64.encode(message.private_key, 0, message.private_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.private_key) : message.private_key;
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            object.public_key = options.bytes === String ? $util.base64.encode(message.public_key, 0, message.public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.public_key) : message.public_key;
        return object;
    };

    HDNodeType.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return HDNodeType;
})();

$root.BixinPinInputOnDevice = (function() {

    function BixinPinInputOnDevice(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    BixinPinInputOnDevice.create = function create(properties) {
        return new BixinPinInputOnDevice(properties);
    };

    BixinPinInputOnDevice.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    BixinPinInputOnDevice.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    BixinPinInputOnDevice.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BixinPinInputOnDevice();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    BixinPinInputOnDevice.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    BixinPinInputOnDevice.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    BixinPinInputOnDevice.fromObject = function fromObject(object) {
        if (object instanceof $root.BixinPinInputOnDevice)
            return object;
        return new $root.BixinPinInputOnDevice();
    };

    BixinPinInputOnDevice.toObject = function toObject() {
        return {};
    };

    BixinPinInputOnDevice.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return BixinPinInputOnDevice;
})();

$root.ConfluxGetAddress = (function() {

    function ConfluxGetAddress(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ConfluxGetAddress.prototype.address_n = $util.emptyArray;
    ConfluxGetAddress.prototype.show_display = false;
    ConfluxGetAddress.prototype.chain_id = 0;

    ConfluxGetAddress.create = function create(properties) {
        return new ConfluxGetAddress(properties);
    };

    ConfluxGetAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(16).bool(message.show_display);
        if (message.chain_id != null && Object.hasOwnProperty.call(message, "chain_id"))
            writer.uint32(24).uint32(message.chain_id);
        return writer;
    };

    ConfluxGetAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ConfluxGetAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ConfluxGetAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.show_display = reader.bool();
                break;
            case 3:
                message.chain_id = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    ConfluxGetAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ConfluxGetAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        if (message.chain_id != null && message.hasOwnProperty("chain_id"))
            if (!$util.isInteger(message.chain_id))
                return "chain_id: integer expected";
        return null;
    };

    ConfluxGetAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.ConfluxGetAddress)
            return object;
        var message = new $root.ConfluxGetAddress();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".ConfluxGetAddress.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        if (object.chain_id != null)
            message.chain_id = object.chain_id >>> 0;
        return message;
    };

    ConfluxGetAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            object.show_display = false;
            object.chain_id = 0;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        if (message.chain_id != null && message.hasOwnProperty("chain_id"))
            object.chain_id = message.chain_id;
        return object;
    };

    ConfluxGetAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ConfluxGetAddress;
})();

$root.ConfluxAddress = (function() {

    function ConfluxAddress(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ConfluxAddress.prototype.address = "";

    ConfluxAddress.create = function create(properties) {
        return new ConfluxAddress(properties);
    };

    ConfluxAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address != null && Object.hasOwnProperty.call(message, "address"))
            writer.uint32(10).string(message.address);
        return writer;
    };

    ConfluxAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ConfluxAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ConfluxAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    ConfluxAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ConfluxAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address != null && message.hasOwnProperty("address"))
            if (!$util.isString(message.address))
                return "address: string expected";
        return null;
    };

    ConfluxAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.ConfluxAddress)
            return object;
        var message = new $root.ConfluxAddress();
        if (object.address != null)
            message.address = String(object.address);
        return message;
    };

    ConfluxAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.address = "";
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    ConfluxAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ConfluxAddress;
})();

$root.ConfluxSignTx = (function() {

    function ConfluxSignTx(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ConfluxSignTx.prototype.address_n = $util.emptyArray;
    ConfluxSignTx.prototype.nonce = $util.newBuffer([]);
    ConfluxSignTx.prototype.gas_price = $util.newBuffer([]);
    ConfluxSignTx.prototype.gas_limit = $util.newBuffer([]);
    ConfluxSignTx.prototype.to = "";
    ConfluxSignTx.prototype.value = $util.newBuffer([]);
    ConfluxSignTx.prototype.epoch_height = $util.newBuffer([]);
    ConfluxSignTx.prototype.storage_limit = $util.newBuffer([]);
    ConfluxSignTx.prototype.data_initial_chunk = $util.newBuffer([]);
    ConfluxSignTx.prototype.data_length = 0;
    ConfluxSignTx.prototype.chain_id = 0;

    ConfluxSignTx.create = function create(properties) {
        return new ConfluxSignTx(properties);
    };

    ConfluxSignTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.nonce != null && Object.hasOwnProperty.call(message, "nonce"))
            writer.uint32(18).bytes(message.nonce);
        if (message.gas_price != null && Object.hasOwnProperty.call(message, "gas_price"))
            writer.uint32(26).bytes(message.gas_price);
        if (message.gas_limit != null && Object.hasOwnProperty.call(message, "gas_limit"))
            writer.uint32(34).bytes(message.gas_limit);
        if (message.to != null && Object.hasOwnProperty.call(message, "to"))
            writer.uint32(42).string(message.to);
        if (message.value != null && Object.hasOwnProperty.call(message, "value"))
            writer.uint32(50).bytes(message.value);
        if (message.epoch_height != null && Object.hasOwnProperty.call(message, "epoch_height"))
            writer.uint32(58).bytes(message.epoch_height);
        if (message.storage_limit != null && Object.hasOwnProperty.call(message, "storage_limit"))
            writer.uint32(66).bytes(message.storage_limit);
        if (message.data_initial_chunk != null && Object.hasOwnProperty.call(message, "data_initial_chunk"))
            writer.uint32(74).bytes(message.data_initial_chunk);
        if (message.data_length != null && Object.hasOwnProperty.call(message, "data_length"))
            writer.uint32(80).uint32(message.data_length);
        if (message.chain_id != null && Object.hasOwnProperty.call(message, "chain_id"))
            writer.uint32(88).uint32(message.chain_id);
        return writer;
    };

    ConfluxSignTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ConfluxSignTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ConfluxSignTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.nonce = reader.bytes();
                break;
            case 3:
                message.gas_price = reader.bytes();
                break;
            case 4:
                message.gas_limit = reader.bytes();
                break;
            case 5:
                message.to = reader.string();
                break;
            case 6:
                message.value = reader.bytes();
                break;
            case 7:
                message.epoch_height = reader.bytes();
                break;
            case 8:
                message.storage_limit = reader.bytes();
                break;
            case 9:
                message.data_initial_chunk = reader.bytes();
                break;
            case 10:
                message.data_length = reader.uint32();
                break;
            case 11:
                message.chain_id = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    ConfluxSignTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ConfluxSignTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.nonce != null && message.hasOwnProperty("nonce"))
            if (!(message.nonce && typeof message.nonce.length === "number" || $util.isString(message.nonce)))
                return "nonce: buffer expected";
        if (message.gas_price != null && message.hasOwnProperty("gas_price"))
            if (!(message.gas_price && typeof message.gas_price.length === "number" || $util.isString(message.gas_price)))
                return "gas_price: buffer expected";
        if (message.gas_limit != null && message.hasOwnProperty("gas_limit"))
            if (!(message.gas_limit && typeof message.gas_limit.length === "number" || $util.isString(message.gas_limit)))
                return "gas_limit: buffer expected";
        if (message.to != null && message.hasOwnProperty("to"))
            if (!$util.isString(message.to))
                return "to: string expected";
        if (message.value != null && message.hasOwnProperty("value"))
            if (!(message.value && typeof message.value.length === "number" || $util.isString(message.value)))
                return "value: buffer expected";
        if (message.epoch_height != null && message.hasOwnProperty("epoch_height"))
            if (!(message.epoch_height && typeof message.epoch_height.length === "number" || $util.isString(message.epoch_height)))
                return "epoch_height: buffer expected";
        if (message.storage_limit != null && message.hasOwnProperty("storage_limit"))
            if (!(message.storage_limit && typeof message.storage_limit.length === "number" || $util.isString(message.storage_limit)))
                return "storage_limit: buffer expected";
        if (message.data_initial_chunk != null && message.hasOwnProperty("data_initial_chunk"))
            if (!(message.data_initial_chunk && typeof message.data_initial_chunk.length === "number" || $util.isString(message.data_initial_chunk)))
                return "data_initial_chunk: buffer expected";
        if (message.data_length != null && message.hasOwnProperty("data_length"))
            if (!$util.isInteger(message.data_length))
                return "data_length: integer expected";
        if (message.chain_id != null && message.hasOwnProperty("chain_id"))
            if (!$util.isInteger(message.chain_id))
                return "chain_id: integer expected";
        return null;
    };

    ConfluxSignTx.fromObject = function fromObject(object) {
        if (object instanceof $root.ConfluxSignTx)
            return object;
        var message = new $root.ConfluxSignTx();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".ConfluxSignTx.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.nonce != null)
            if (typeof object.nonce === "string")
                $util.base64.decode(object.nonce, message.nonce = $util.newBuffer($util.base64.length(object.nonce)), 0);
            else if (object.nonce.length)
                message.nonce = object.nonce;
        if (object.gas_price != null)
            if (typeof object.gas_price === "string")
                $util.base64.decode(object.gas_price, message.gas_price = $util.newBuffer($util.base64.length(object.gas_price)), 0);
            else if (object.gas_price.length)
                message.gas_price = object.gas_price;
        if (object.gas_limit != null)
            if (typeof object.gas_limit === "string")
                $util.base64.decode(object.gas_limit, message.gas_limit = $util.newBuffer($util.base64.length(object.gas_limit)), 0);
            else if (object.gas_limit.length)
                message.gas_limit = object.gas_limit;
        if (object.to != null)
            message.to = String(object.to);
        if (object.value != null)
            if (typeof object.value === "string")
                $util.base64.decode(object.value, message.value = $util.newBuffer($util.base64.length(object.value)), 0);
            else if (object.value.length)
                message.value = object.value;
        if (object.epoch_height != null)
            if (typeof object.epoch_height === "string")
                $util.base64.decode(object.epoch_height, message.epoch_height = $util.newBuffer($util.base64.length(object.epoch_height)), 0);
            else if (object.epoch_height.length)
                message.epoch_height = object.epoch_height;
        if (object.storage_limit != null)
            if (typeof object.storage_limit === "string")
                $util.base64.decode(object.storage_limit, message.storage_limit = $util.newBuffer($util.base64.length(object.storage_limit)), 0);
            else if (object.storage_limit.length)
                message.storage_limit = object.storage_limit;
        if (object.data_initial_chunk != null)
            if (typeof object.data_initial_chunk === "string")
                $util.base64.decode(object.data_initial_chunk, message.data_initial_chunk = $util.newBuffer($util.base64.length(object.data_initial_chunk)), 0);
            else if (object.data_initial_chunk.length)
                message.data_initial_chunk = object.data_initial_chunk;
        if (object.data_length != null)
            message.data_length = object.data_length >>> 0;
        if (object.chain_id != null)
            message.chain_id = object.chain_id >>> 0;
        return message;
    };

    ConfluxSignTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            if (options.bytes === String)
                object.nonce = "";
            else {
                object.nonce = [];
                if (options.bytes !== Array)
                    object.nonce = $util.newBuffer(object.nonce);
            }
            if (options.bytes === String)
                object.gas_price = "";
            else {
                object.gas_price = [];
                if (options.bytes !== Array)
                    object.gas_price = $util.newBuffer(object.gas_price);
            }
            if (options.bytes === String)
                object.gas_limit = "";
            else {
                object.gas_limit = [];
                if (options.bytes !== Array)
                    object.gas_limit = $util.newBuffer(object.gas_limit);
            }
            object.to = "";
            if (options.bytes === String)
                object.value = "";
            else {
                object.value = [];
                if (options.bytes !== Array)
                    object.value = $util.newBuffer(object.value);
            }
            if (options.bytes === String)
                object.epoch_height = "";
            else {
                object.epoch_height = [];
                if (options.bytes !== Array)
                    object.epoch_height = $util.newBuffer(object.epoch_height);
            }
            if (options.bytes === String)
                object.storage_limit = "";
            else {
                object.storage_limit = [];
                if (options.bytes !== Array)
                    object.storage_limit = $util.newBuffer(object.storage_limit);
            }
            if (options.bytes === String)
                object.data_initial_chunk = "";
            else {
                object.data_initial_chunk = [];
                if (options.bytes !== Array)
                    object.data_initial_chunk = $util.newBuffer(object.data_initial_chunk);
            }
            object.data_length = 0;
            object.chain_id = 0;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.nonce != null && message.hasOwnProperty("nonce"))
            object.nonce = options.bytes === String ? $util.base64.encode(message.nonce, 0, message.nonce.length) : options.bytes === Array ? Array.prototype.slice.call(message.nonce) : message.nonce;
        if (message.gas_price != null && message.hasOwnProperty("gas_price"))
            object.gas_price = options.bytes === String ? $util.base64.encode(message.gas_price, 0, message.gas_price.length) : options.bytes === Array ? Array.prototype.slice.call(message.gas_price) : message.gas_price;
        if (message.gas_limit != null && message.hasOwnProperty("gas_limit"))
            object.gas_limit = options.bytes === String ? $util.base64.encode(message.gas_limit, 0, message.gas_limit.length) : options.bytes === Array ? Array.prototype.slice.call(message.gas_limit) : message.gas_limit;
        if (message.to != null && message.hasOwnProperty("to"))
            object.to = message.to;
        if (message.value != null && message.hasOwnProperty("value"))
            object.value = options.bytes === String ? $util.base64.encode(message.value, 0, message.value.length) : options.bytes === Array ? Array.prototype.slice.call(message.value) : message.value;
        if (message.epoch_height != null && message.hasOwnProperty("epoch_height"))
            object.epoch_height = options.bytes === String ? $util.base64.encode(message.epoch_height, 0, message.epoch_height.length) : options.bytes === Array ? Array.prototype.slice.call(message.epoch_height) : message.epoch_height;
        if (message.storage_limit != null && message.hasOwnProperty("storage_limit"))
            object.storage_limit = options.bytes === String ? $util.base64.encode(message.storage_limit, 0, message.storage_limit.length) : options.bytes === Array ? Array.prototype.slice.call(message.storage_limit) : message.storage_limit;
        if (message.data_initial_chunk != null && message.hasOwnProperty("data_initial_chunk"))
            object.data_initial_chunk = options.bytes === String ? $util.base64.encode(message.data_initial_chunk, 0, message.data_initial_chunk.length) : options.bytes === Array ? Array.prototype.slice.call(message.data_initial_chunk) : message.data_initial_chunk;
        if (message.data_length != null && message.hasOwnProperty("data_length"))
            object.data_length = message.data_length;
        if (message.chain_id != null && message.hasOwnProperty("chain_id"))
            object.chain_id = message.chain_id;
        return object;
    };

    ConfluxSignTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ConfluxSignTx;
})();

$root.ConfluxTxRequest = (function() {

    function ConfluxTxRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ConfluxTxRequest.prototype.data_length = 0;
    ConfluxTxRequest.prototype.signature_v = 0;
    ConfluxTxRequest.prototype.signature_r = $util.newBuffer([]);
    ConfluxTxRequest.prototype.signature_s = $util.newBuffer([]);

    ConfluxTxRequest.create = function create(properties) {
        return new ConfluxTxRequest(properties);
    };

    ConfluxTxRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.data_length != null && Object.hasOwnProperty.call(message, "data_length"))
            writer.uint32(8).uint32(message.data_length);
        if (message.signature_v != null && Object.hasOwnProperty.call(message, "signature_v"))
            writer.uint32(16).uint32(message.signature_v);
        if (message.signature_r != null && Object.hasOwnProperty.call(message, "signature_r"))
            writer.uint32(26).bytes(message.signature_r);
        if (message.signature_s != null && Object.hasOwnProperty.call(message, "signature_s"))
            writer.uint32(34).bytes(message.signature_s);
        return writer;
    };

    ConfluxTxRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ConfluxTxRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ConfluxTxRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.data_length = reader.uint32();
                break;
            case 2:
                message.signature_v = reader.uint32();
                break;
            case 3:
                message.signature_r = reader.bytes();
                break;
            case 4:
                message.signature_s = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    ConfluxTxRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ConfluxTxRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.data_length != null && message.hasOwnProperty("data_length"))
            if (!$util.isInteger(message.data_length))
                return "data_length: integer expected";
        if (message.signature_v != null && message.hasOwnProperty("signature_v"))
            if (!$util.isInteger(message.signature_v))
                return "signature_v: integer expected";
        if (message.signature_r != null && message.hasOwnProperty("signature_r"))
            if (!(message.signature_r && typeof message.signature_r.length === "number" || $util.isString(message.signature_r)))
                return "signature_r: buffer expected";
        if (message.signature_s != null && message.hasOwnProperty("signature_s"))
            if (!(message.signature_s && typeof message.signature_s.length === "number" || $util.isString(message.signature_s)))
                return "signature_s: buffer expected";
        return null;
    };

    ConfluxTxRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.ConfluxTxRequest)
            return object;
        var message = new $root.ConfluxTxRequest();
        if (object.data_length != null)
            message.data_length = object.data_length >>> 0;
        if (object.signature_v != null)
            message.signature_v = object.signature_v >>> 0;
        if (object.signature_r != null)
            if (typeof object.signature_r === "string")
                $util.base64.decode(object.signature_r, message.signature_r = $util.newBuffer($util.base64.length(object.signature_r)), 0);
            else if (object.signature_r.length)
                message.signature_r = object.signature_r;
        if (object.signature_s != null)
            if (typeof object.signature_s === "string")
                $util.base64.decode(object.signature_s, message.signature_s = $util.newBuffer($util.base64.length(object.signature_s)), 0);
            else if (object.signature_s.length)
                message.signature_s = object.signature_s;
        return message;
    };

    ConfluxTxRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.data_length = 0;
            object.signature_v = 0;
            if (options.bytes === String)
                object.signature_r = "";
            else {
                object.signature_r = [];
                if (options.bytes !== Array)
                    object.signature_r = $util.newBuffer(object.signature_r);
            }
            if (options.bytes === String)
                object.signature_s = "";
            else {
                object.signature_s = [];
                if (options.bytes !== Array)
                    object.signature_s = $util.newBuffer(object.signature_s);
            }
        }
        if (message.data_length != null && message.hasOwnProperty("data_length"))
            object.data_length = message.data_length;
        if (message.signature_v != null && message.hasOwnProperty("signature_v"))
            object.signature_v = message.signature_v;
        if (message.signature_r != null && message.hasOwnProperty("signature_r"))
            object.signature_r = options.bytes === String ? $util.base64.encode(message.signature_r, 0, message.signature_r.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature_r) : message.signature_r;
        if (message.signature_s != null && message.hasOwnProperty("signature_s"))
            object.signature_s = options.bytes === String ? $util.base64.encode(message.signature_s, 0, message.signature_s.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature_s) : message.signature_s;
        return object;
    };

    ConfluxTxRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ConfluxTxRequest;
})();

$root.ConfluxTxAck = (function() {

    function ConfluxTxAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ConfluxTxAck.prototype.data_chunk = $util.newBuffer([]);

    ConfluxTxAck.create = function create(properties) {
        return new ConfluxTxAck(properties);
    };

    ConfluxTxAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.data_chunk != null && Object.hasOwnProperty.call(message, "data_chunk"))
            writer.uint32(10).bytes(message.data_chunk);
        return writer;
    };

    ConfluxTxAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ConfluxTxAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ConfluxTxAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.data_chunk = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    ConfluxTxAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ConfluxTxAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.data_chunk != null && message.hasOwnProperty("data_chunk"))
            if (!(message.data_chunk && typeof message.data_chunk.length === "number" || $util.isString(message.data_chunk)))
                return "data_chunk: buffer expected";
        return null;
    };

    ConfluxTxAck.fromObject = function fromObject(object) {
        if (object instanceof $root.ConfluxTxAck)
            return object;
        var message = new $root.ConfluxTxAck();
        if (object.data_chunk != null)
            if (typeof object.data_chunk === "string")
                $util.base64.decode(object.data_chunk, message.data_chunk = $util.newBuffer($util.base64.length(object.data_chunk)), 0);
            else if (object.data_chunk.length)
                message.data_chunk = object.data_chunk;
        return message;
    };

    ConfluxTxAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.data_chunk = "";
            else {
                object.data_chunk = [];
                if (options.bytes !== Array)
                    object.data_chunk = $util.newBuffer(object.data_chunk);
            }
        if (message.data_chunk != null && message.hasOwnProperty("data_chunk"))
            object.data_chunk = options.bytes === String ? $util.base64.encode(message.data_chunk, 0, message.data_chunk.length) : options.bytes === Array ? Array.prototype.slice.call(message.data_chunk) : message.data_chunk;
        return object;
    };

    ConfluxTxAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ConfluxTxAck;
})();

$root.ConfluxSignMessage = (function() {

    function ConfluxSignMessage(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ConfluxSignMessage.prototype.address_n = $util.emptyArray;
    ConfluxSignMessage.prototype.message = $util.newBuffer([]);

    ConfluxSignMessage.create = function create(properties) {
        return new ConfluxSignMessage(properties);
    };

    ConfluxSignMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
            writer.uint32(18).bytes(message.message);
        return writer;
    };

    ConfluxSignMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ConfluxSignMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ConfluxSignMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.message = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    ConfluxSignMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ConfluxSignMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.message != null && message.hasOwnProperty("message"))
            if (!(message.message && typeof message.message.length === "number" || $util.isString(message.message)))
                return "message: buffer expected";
        return null;
    };

    ConfluxSignMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.ConfluxSignMessage)
            return object;
        var message = new $root.ConfluxSignMessage();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".ConfluxSignMessage.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.message != null)
            if (typeof object.message === "string")
                $util.base64.decode(object.message, message.message = $util.newBuffer($util.base64.length(object.message)), 0);
            else if (object.message.length)
                message.message = object.message;
        return message;
    };

    ConfluxSignMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            if (options.bytes === String)
                object.message = "";
            else {
                object.message = [];
                if (options.bytes !== Array)
                    object.message = $util.newBuffer(object.message);
            }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.message != null && message.hasOwnProperty("message"))
            object.message = options.bytes === String ? $util.base64.encode(message.message, 0, message.message.length) : options.bytes === Array ? Array.prototype.slice.call(message.message) : message.message;
        return object;
    };

    ConfluxSignMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ConfluxSignMessage;
})();

$root.ConfluxMessageSignature = (function() {

    function ConfluxMessageSignature(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ConfluxMessageSignature.prototype.signature = $util.newBuffer([]);
    ConfluxMessageSignature.prototype.address = "";

    ConfluxMessageSignature.create = function create(properties) {
        return new ConfluxMessageSignature(properties);
    };

    ConfluxMessageSignature.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.signature != null && Object.hasOwnProperty.call(message, "signature"))
            writer.uint32(18).bytes(message.signature);
        if (message.address != null && Object.hasOwnProperty.call(message, "address"))
            writer.uint32(26).string(message.address);
        return writer;
    };

    ConfluxMessageSignature.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ConfluxMessageSignature.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ConfluxMessageSignature();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 2:
                message.signature = reader.bytes();
                break;
            case 3:
                message.address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    ConfluxMessageSignature.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ConfluxMessageSignature.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.signature != null && message.hasOwnProperty("signature"))
            if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
                return "signature: buffer expected";
        if (message.address != null && message.hasOwnProperty("address"))
            if (!$util.isString(message.address))
                return "address: string expected";
        return null;
    };

    ConfluxMessageSignature.fromObject = function fromObject(object) {
        if (object instanceof $root.ConfluxMessageSignature)
            return object;
        var message = new $root.ConfluxMessageSignature();
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        if (object.address != null)
            message.address = String(object.address);
        return message;
    };

    ConfluxMessageSignature.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
            object.address = "";
        }
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    ConfluxMessageSignature.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ConfluxMessageSignature;
})();

$root.ConfluxSignMessageCIP23 = (function() {

    function ConfluxSignMessageCIP23(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ConfluxSignMessageCIP23.prototype.address_n = $util.emptyArray;
    ConfluxSignMessageCIP23.prototype.domain_hash = $util.newBuffer([]);
    ConfluxSignMessageCIP23.prototype.message_hash = $util.newBuffer([]);

    ConfluxSignMessageCIP23.create = function create(properties) {
        return new ConfluxSignMessageCIP23(properties);
    };

    ConfluxSignMessageCIP23.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.domain_hash != null && Object.hasOwnProperty.call(message, "domain_hash"))
            writer.uint32(18).bytes(message.domain_hash);
        if (message.message_hash != null && Object.hasOwnProperty.call(message, "message_hash"))
            writer.uint32(26).bytes(message.message_hash);
        return writer;
    };

    ConfluxSignMessageCIP23.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ConfluxSignMessageCIP23.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ConfluxSignMessageCIP23();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.domain_hash = reader.bytes();
                break;
            case 3:
                message.message_hash = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    ConfluxSignMessageCIP23.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ConfluxSignMessageCIP23.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.domain_hash != null && message.hasOwnProperty("domain_hash"))
            if (!(message.domain_hash && typeof message.domain_hash.length === "number" || $util.isString(message.domain_hash)))
                return "domain_hash: buffer expected";
        if (message.message_hash != null && message.hasOwnProperty("message_hash"))
            if (!(message.message_hash && typeof message.message_hash.length === "number" || $util.isString(message.message_hash)))
                return "message_hash: buffer expected";
        return null;
    };

    ConfluxSignMessageCIP23.fromObject = function fromObject(object) {
        if (object instanceof $root.ConfluxSignMessageCIP23)
            return object;
        var message = new $root.ConfluxSignMessageCIP23();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".ConfluxSignMessageCIP23.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.domain_hash != null)
            if (typeof object.domain_hash === "string")
                $util.base64.decode(object.domain_hash, message.domain_hash = $util.newBuffer($util.base64.length(object.domain_hash)), 0);
            else if (object.domain_hash.length)
                message.domain_hash = object.domain_hash;
        if (object.message_hash != null)
            if (typeof object.message_hash === "string")
                $util.base64.decode(object.message_hash, message.message_hash = $util.newBuffer($util.base64.length(object.message_hash)), 0);
            else if (object.message_hash.length)
                message.message_hash = object.message_hash;
        return message;
    };

    ConfluxSignMessageCIP23.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            if (options.bytes === String)
                object.domain_hash = "";
            else {
                object.domain_hash = [];
                if (options.bytes !== Array)
                    object.domain_hash = $util.newBuffer(object.domain_hash);
            }
            if (options.bytes === String)
                object.message_hash = "";
            else {
                object.message_hash = [];
                if (options.bytes !== Array)
                    object.message_hash = $util.newBuffer(object.message_hash);
            }
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.domain_hash != null && message.hasOwnProperty("domain_hash"))
            object.domain_hash = options.bytes === String ? $util.base64.encode(message.domain_hash, 0, message.domain_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.domain_hash) : message.domain_hash;
        if (message.message_hash != null && message.hasOwnProperty("message_hash"))
            object.message_hash = options.bytes === String ? $util.base64.encode(message.message_hash, 0, message.message_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.message_hash) : message.message_hash;
        return object;
    };

    ConfluxSignMessageCIP23.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ConfluxSignMessageCIP23;
})();

$root.CosmosGetAddress = (function() {

    function CosmosGetAddress(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CosmosGetAddress.prototype.address_n = $util.emptyArray;
    CosmosGetAddress.prototype.hrp = "";
    CosmosGetAddress.prototype.show_display = false;

    CosmosGetAddress.create = function create(properties) {
        return new CosmosGetAddress(properties);
    };

    CosmosGetAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.hrp != null && Object.hasOwnProperty.call(message, "hrp"))
            writer.uint32(18).string(message.hrp);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(24).bool(message.show_display);
        return writer;
    };

    CosmosGetAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CosmosGetAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CosmosGetAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.hrp = reader.string();
                break;
            case 3:
                message.show_display = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    CosmosGetAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CosmosGetAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.hrp != null && message.hasOwnProperty("hrp"))
            if (!$util.isString(message.hrp))
                return "hrp: string expected";
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        return null;
    };

    CosmosGetAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.CosmosGetAddress)
            return object;
        var message = new $root.CosmosGetAddress();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".CosmosGetAddress.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.hrp != null)
            message.hrp = String(object.hrp);
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        return message;
    };

    CosmosGetAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            object.hrp = "";
            object.show_display = false;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.hrp != null && message.hasOwnProperty("hrp"))
            object.hrp = message.hrp;
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        return object;
    };

    CosmosGetAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CosmosGetAddress;
})();

$root.CosmosAddress = (function() {

    function CosmosAddress(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CosmosAddress.prototype.address = "";

    CosmosAddress.create = function create(properties) {
        return new CosmosAddress(properties);
    };

    CosmosAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address != null && Object.hasOwnProperty.call(message, "address"))
            writer.uint32(10).string(message.address);
        return writer;
    };

    CosmosAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CosmosAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CosmosAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    CosmosAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CosmosAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address != null && message.hasOwnProperty("address"))
            if (!$util.isString(message.address))
                return "address: string expected";
        return null;
    };

    CosmosAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.CosmosAddress)
            return object;
        var message = new $root.CosmosAddress();
        if (object.address != null)
            message.address = String(object.address);
        return message;
    };

    CosmosAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.address = "";
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    CosmosAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CosmosAddress;
})();

$root.CosmosSignTx = (function() {

    function CosmosSignTx(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CosmosSignTx.prototype.address_n = $util.emptyArray;
    CosmosSignTx.prototype.raw_tx = $util.newBuffer([]);

    CosmosSignTx.create = function create(properties) {
        return new CosmosSignTx(properties);
    };

    CosmosSignTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).bytes(message.raw_tx);
        return writer;
    };

    CosmosSignTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CosmosSignTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CosmosSignTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.raw_tx = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("raw_tx"))
            throw $util.ProtocolError("missing required 'raw_tx'", { instance: message });
        return message;
    };

    CosmosSignTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CosmosSignTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!(message.raw_tx && typeof message.raw_tx.length === "number" || $util.isString(message.raw_tx)))
            return "raw_tx: buffer expected";
        return null;
    };

    CosmosSignTx.fromObject = function fromObject(object) {
        if (object instanceof $root.CosmosSignTx)
            return object;
        var message = new $root.CosmosSignTx();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".CosmosSignTx.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.raw_tx != null)
            if (typeof object.raw_tx === "string")
                $util.base64.decode(object.raw_tx, message.raw_tx = $util.newBuffer($util.base64.length(object.raw_tx)), 0);
            else if (object.raw_tx.length)
                message.raw_tx = object.raw_tx;
        return message;
    };

    CosmosSignTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            if (options.bytes === String)
                object.raw_tx = "";
            else {
                object.raw_tx = [];
                if (options.bytes !== Array)
                    object.raw_tx = $util.newBuffer(object.raw_tx);
            }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.raw_tx != null && message.hasOwnProperty("raw_tx"))
            object.raw_tx = options.bytes === String ? $util.base64.encode(message.raw_tx, 0, message.raw_tx.length) : options.bytes === Array ? Array.prototype.slice.call(message.raw_tx) : message.raw_tx;
        return object;
    };

    CosmosSignTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CosmosSignTx;
})();

$root.CosmosSignedTx = (function() {

    function CosmosSignedTx(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CosmosSignedTx.prototype.signature = $util.newBuffer([]);

    CosmosSignedTx.create = function create(properties) {
        return new CosmosSignedTx(properties);
    };

    CosmosSignedTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.signature);
        return writer;
    };

    CosmosSignedTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CosmosSignedTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CosmosSignedTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.signature = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        return message;
    };

    CosmosSignedTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CosmosSignedTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        return null;
    };

    CosmosSignedTx.fromObject = function fromObject(object) {
        if (object instanceof $root.CosmosSignedTx)
            return object;
        var message = new $root.CosmosSignedTx();
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        return message;
    };

    CosmosSignedTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        return object;
    };

    CosmosSignedTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CosmosSignedTx;
})();

$root.CipherKeyValue = (function() {

    function CipherKeyValue(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CipherKeyValue.prototype.address_n = $util.emptyArray;
    CipherKeyValue.prototype.key = "";
    CipherKeyValue.prototype.value = $util.newBuffer([]);
    CipherKeyValue.prototype.encrypt = false;
    CipherKeyValue.prototype.ask_on_encrypt = false;
    CipherKeyValue.prototype.ask_on_decrypt = false;
    CipherKeyValue.prototype.iv = $util.newBuffer([]);

    CipherKeyValue.create = function create(properties) {
        return new CipherKeyValue(properties);
    };

    CipherKeyValue.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).string(message.key);
        writer.uint32(26).bytes(message.value);
        if (message.encrypt != null && Object.hasOwnProperty.call(message, "encrypt"))
            writer.uint32(32).bool(message.encrypt);
        if (message.ask_on_encrypt != null && Object.hasOwnProperty.call(message, "ask_on_encrypt"))
            writer.uint32(40).bool(message.ask_on_encrypt);
        if (message.ask_on_decrypt != null && Object.hasOwnProperty.call(message, "ask_on_decrypt"))
            writer.uint32(48).bool(message.ask_on_decrypt);
        if (message.iv != null && Object.hasOwnProperty.call(message, "iv"))
            writer.uint32(58).bytes(message.iv);
        return writer;
    };

    CipherKeyValue.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CipherKeyValue.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CipherKeyValue();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.key = reader.string();
                break;
            case 3:
                message.value = reader.bytes();
                break;
            case 4:
                message.encrypt = reader.bool();
                break;
            case 5:
                message.ask_on_encrypt = reader.bool();
                break;
            case 6:
                message.ask_on_decrypt = reader.bool();
                break;
            case 7:
                message.iv = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("key"))
            throw $util.ProtocolError("missing required 'key'", { instance: message });
        if (!message.hasOwnProperty("value"))
            throw $util.ProtocolError("missing required 'value'", { instance: message });
        return message;
    };

    CipherKeyValue.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CipherKeyValue.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!$util.isString(message.key))
            return "key: string expected";
        if (!(message.value && typeof message.value.length === "number" || $util.isString(message.value)))
            return "value: buffer expected";
        if (message.encrypt != null && message.hasOwnProperty("encrypt"))
            if (typeof message.encrypt !== "boolean")
                return "encrypt: boolean expected";
        if (message.ask_on_encrypt != null && message.hasOwnProperty("ask_on_encrypt"))
            if (typeof message.ask_on_encrypt !== "boolean")
                return "ask_on_encrypt: boolean expected";
        if (message.ask_on_decrypt != null && message.hasOwnProperty("ask_on_decrypt"))
            if (typeof message.ask_on_decrypt !== "boolean")
                return "ask_on_decrypt: boolean expected";
        if (message.iv != null && message.hasOwnProperty("iv"))
            if (!(message.iv && typeof message.iv.length === "number" || $util.isString(message.iv)))
                return "iv: buffer expected";
        return null;
    };

    CipherKeyValue.fromObject = function fromObject(object) {
        if (object instanceof $root.CipherKeyValue)
            return object;
        var message = new $root.CipherKeyValue();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".CipherKeyValue.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.key != null)
            message.key = String(object.key);
        if (object.value != null)
            if (typeof object.value === "string")
                $util.base64.decode(object.value, message.value = $util.newBuffer($util.base64.length(object.value)), 0);
            else if (object.value.length)
                message.value = object.value;
        if (object.encrypt != null)
            message.encrypt = Boolean(object.encrypt);
        if (object.ask_on_encrypt != null)
            message.ask_on_encrypt = Boolean(object.ask_on_encrypt);
        if (object.ask_on_decrypt != null)
            message.ask_on_decrypt = Boolean(object.ask_on_decrypt);
        if (object.iv != null)
            if (typeof object.iv === "string")
                $util.base64.decode(object.iv, message.iv = $util.newBuffer($util.base64.length(object.iv)), 0);
            else if (object.iv.length)
                message.iv = object.iv;
        return message;
    };

    CipherKeyValue.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            object.key = "";
            if (options.bytes === String)
                object.value = "";
            else {
                object.value = [];
                if (options.bytes !== Array)
                    object.value = $util.newBuffer(object.value);
            }
            object.encrypt = false;
            object.ask_on_encrypt = false;
            object.ask_on_decrypt = false;
            if (options.bytes === String)
                object.iv = "";
            else {
                object.iv = [];
                if (options.bytes !== Array)
                    object.iv = $util.newBuffer(object.iv);
            }
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.key != null && message.hasOwnProperty("key"))
            object.key = message.key;
        if (message.value != null && message.hasOwnProperty("value"))
            object.value = options.bytes === String ? $util.base64.encode(message.value, 0, message.value.length) : options.bytes === Array ? Array.prototype.slice.call(message.value) : message.value;
        if (message.encrypt != null && message.hasOwnProperty("encrypt"))
            object.encrypt = message.encrypt;
        if (message.ask_on_encrypt != null && message.hasOwnProperty("ask_on_encrypt"))
            object.ask_on_encrypt = message.ask_on_encrypt;
        if (message.ask_on_decrypt != null && message.hasOwnProperty("ask_on_decrypt"))
            object.ask_on_decrypt = message.ask_on_decrypt;
        if (message.iv != null && message.hasOwnProperty("iv"))
            object.iv = options.bytes === String ? $util.base64.encode(message.iv, 0, message.iv.length) : options.bytes === Array ? Array.prototype.slice.call(message.iv) : message.iv;
        return object;
    };

    CipherKeyValue.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CipherKeyValue;
})();

$root.CipheredKeyValue = (function() {

    function CipheredKeyValue(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CipheredKeyValue.prototype.value = $util.newBuffer([]);

    CipheredKeyValue.create = function create(properties) {
        return new CipheredKeyValue(properties);
    };

    CipheredKeyValue.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.value);
        return writer;
    };

    CipheredKeyValue.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CipheredKeyValue.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CipheredKeyValue();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.value = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("value"))
            throw $util.ProtocolError("missing required 'value'", { instance: message });
        return message;
    };

    CipheredKeyValue.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CipheredKeyValue.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.value && typeof message.value.length === "number" || $util.isString(message.value)))
            return "value: buffer expected";
        return null;
    };

    CipheredKeyValue.fromObject = function fromObject(object) {
        if (object instanceof $root.CipheredKeyValue)
            return object;
        var message = new $root.CipheredKeyValue();
        if (object.value != null)
            if (typeof object.value === "string")
                $util.base64.decode(object.value, message.value = $util.newBuffer($util.base64.length(object.value)), 0);
            else if (object.value.length)
                message.value = object.value;
        return message;
    };

    CipheredKeyValue.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.value = "";
            else {
                object.value = [];
                if (options.bytes !== Array)
                    object.value = $util.newBuffer(object.value);
            }
        if (message.value != null && message.hasOwnProperty("value"))
            object.value = options.bytes === String ? $util.base64.encode(message.value, 0, message.value.length) : options.bytes === Array ? Array.prototype.slice.call(message.value) : message.value;
        return object;
    };

    CipheredKeyValue.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CipheredKeyValue;
})();

$root.IdentityType = (function() {

    function IdentityType(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    IdentityType.prototype.proto = "";
    IdentityType.prototype.user = "";
    IdentityType.prototype.host = "";
    IdentityType.prototype.port = "";
    IdentityType.prototype.path = "";
    IdentityType.prototype.index = 0;

    IdentityType.create = function create(properties) {
        return new IdentityType(properties);
    };

    IdentityType.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.proto != null && Object.hasOwnProperty.call(message, "proto"))
            writer.uint32(10).string(message.proto);
        if (message.user != null && Object.hasOwnProperty.call(message, "user"))
            writer.uint32(18).string(message.user);
        if (message.host != null && Object.hasOwnProperty.call(message, "host"))
            writer.uint32(26).string(message.host);
        if (message.port != null && Object.hasOwnProperty.call(message, "port"))
            writer.uint32(34).string(message.port);
        if (message.path != null && Object.hasOwnProperty.call(message, "path"))
            writer.uint32(42).string(message.path);
        if (message.index != null && Object.hasOwnProperty.call(message, "index"))
            writer.uint32(48).uint32(message.index);
        return writer;
    };

    IdentityType.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    IdentityType.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.IdentityType();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.proto = reader.string();
                break;
            case 2:
                message.user = reader.string();
                break;
            case 3:
                message.host = reader.string();
                break;
            case 4:
                message.port = reader.string();
                break;
            case 5:
                message.path = reader.string();
                break;
            case 6:
                message.index = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    IdentityType.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    IdentityType.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.proto != null && message.hasOwnProperty("proto"))
            if (!$util.isString(message.proto))
                return "proto: string expected";
        if (message.user != null && message.hasOwnProperty("user"))
            if (!$util.isString(message.user))
                return "user: string expected";
        if (message.host != null && message.hasOwnProperty("host"))
            if (!$util.isString(message.host))
                return "host: string expected";
        if (message.port != null && message.hasOwnProperty("port"))
            if (!$util.isString(message.port))
                return "port: string expected";
        if (message.path != null && message.hasOwnProperty("path"))
            if (!$util.isString(message.path))
                return "path: string expected";
        if (message.index != null && message.hasOwnProperty("index"))
            if (!$util.isInteger(message.index))
                return "index: integer expected";
        return null;
    };

    IdentityType.fromObject = function fromObject(object) {
        if (object instanceof $root.IdentityType)
            return object;
        var message = new $root.IdentityType();
        if (object.proto != null)
            message.proto = String(object.proto);
        if (object.user != null)
            message.user = String(object.user);
        if (object.host != null)
            message.host = String(object.host);
        if (object.port != null)
            message.port = String(object.port);
        if (object.path != null)
            message.path = String(object.path);
        if (object.index != null)
            message.index = object.index >>> 0;
        return message;
    };

    IdentityType.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.proto = "";
            object.user = "";
            object.host = "";
            object.port = "";
            object.path = "";
            object.index = 0;
        }
        if (message.proto != null && message.hasOwnProperty("proto"))
            object.proto = message.proto;
        if (message.user != null && message.hasOwnProperty("user"))
            object.user = message.user;
        if (message.host != null && message.hasOwnProperty("host"))
            object.host = message.host;
        if (message.port != null && message.hasOwnProperty("port"))
            object.port = message.port;
        if (message.path != null && message.hasOwnProperty("path"))
            object.path = message.path;
        if (message.index != null && message.hasOwnProperty("index"))
            object.index = message.index;
        return object;
    };

    IdentityType.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return IdentityType;
})();

$root.SignIdentity = (function() {

    function SignIdentity(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    SignIdentity.prototype.identity = null;
    SignIdentity.prototype.challenge_hidden = $util.newBuffer([]);
    SignIdentity.prototype.challenge_visual = "";
    SignIdentity.prototype.ecdsa_curve_name = "";

    SignIdentity.create = function create(properties) {
        return new SignIdentity(properties);
    };

    SignIdentity.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        $root.IdentityType.encode(message.identity, writer.uint32(10).fork()).ldelim();
        if (message.challenge_hidden != null && Object.hasOwnProperty.call(message, "challenge_hidden"))
            writer.uint32(18).bytes(message.challenge_hidden);
        if (message.challenge_visual != null && Object.hasOwnProperty.call(message, "challenge_visual"))
            writer.uint32(26).string(message.challenge_visual);
        if (message.ecdsa_curve_name != null && Object.hasOwnProperty.call(message, "ecdsa_curve_name"))
            writer.uint32(34).string(message.ecdsa_curve_name);
        return writer;
    };

    SignIdentity.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    SignIdentity.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SignIdentity();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.identity = $root.IdentityType.decode(reader, reader.uint32());
                break;
            case 2:
                message.challenge_hidden = reader.bytes();
                break;
            case 3:
                message.challenge_visual = reader.string();
                break;
            case 4:
                message.ecdsa_curve_name = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("identity"))
            throw $util.ProtocolError("missing required 'identity'", { instance: message });
        return message;
    };

    SignIdentity.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    SignIdentity.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        {
            var error = $root.IdentityType.verify(message.identity);
            if (error)
                return "identity." + error;
        }
        if (message.challenge_hidden != null && message.hasOwnProperty("challenge_hidden"))
            if (!(message.challenge_hidden && typeof message.challenge_hidden.length === "number" || $util.isString(message.challenge_hidden)))
                return "challenge_hidden: buffer expected";
        if (message.challenge_visual != null && message.hasOwnProperty("challenge_visual"))
            if (!$util.isString(message.challenge_visual))
                return "challenge_visual: string expected";
        if (message.ecdsa_curve_name != null && message.hasOwnProperty("ecdsa_curve_name"))
            if (!$util.isString(message.ecdsa_curve_name))
                return "ecdsa_curve_name: string expected";
        return null;
    };

    SignIdentity.fromObject = function fromObject(object) {
        if (object instanceof $root.SignIdentity)
            return object;
        var message = new $root.SignIdentity();
        if (object.identity != null) {
            if (typeof object.identity !== "object")
                throw TypeError(".SignIdentity.identity: object expected");
            message.identity = $root.IdentityType.fromObject(object.identity);
        }
        if (object.challenge_hidden != null)
            if (typeof object.challenge_hidden === "string")
                $util.base64.decode(object.challenge_hidden, message.challenge_hidden = $util.newBuffer($util.base64.length(object.challenge_hidden)), 0);
            else if (object.challenge_hidden.length)
                message.challenge_hidden = object.challenge_hidden;
        if (object.challenge_visual != null)
            message.challenge_visual = String(object.challenge_visual);
        if (object.ecdsa_curve_name != null)
            message.ecdsa_curve_name = String(object.ecdsa_curve_name);
        return message;
    };

    SignIdentity.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.identity = null;
            if (options.bytes === String)
                object.challenge_hidden = "";
            else {
                object.challenge_hidden = [];
                if (options.bytes !== Array)
                    object.challenge_hidden = $util.newBuffer(object.challenge_hidden);
            }
            object.challenge_visual = "";
            object.ecdsa_curve_name = "";
        }
        if (message.identity != null && message.hasOwnProperty("identity"))
            object.identity = $root.IdentityType.toObject(message.identity, options);
        if (message.challenge_hidden != null && message.hasOwnProperty("challenge_hidden"))
            object.challenge_hidden = options.bytes === String ? $util.base64.encode(message.challenge_hidden, 0, message.challenge_hidden.length) : options.bytes === Array ? Array.prototype.slice.call(message.challenge_hidden) : message.challenge_hidden;
        if (message.challenge_visual != null && message.hasOwnProperty("challenge_visual"))
            object.challenge_visual = message.challenge_visual;
        if (message.ecdsa_curve_name != null && message.hasOwnProperty("ecdsa_curve_name"))
            object.ecdsa_curve_name = message.ecdsa_curve_name;
        return object;
    };

    SignIdentity.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SignIdentity;
})();

$root.SignedIdentity = (function() {

    function SignedIdentity(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    SignedIdentity.prototype.address = "";
    SignedIdentity.prototype.public_key = $util.newBuffer([]);
    SignedIdentity.prototype.signature = $util.newBuffer([]);

    SignedIdentity.create = function create(properties) {
        return new SignedIdentity(properties);
    };

    SignedIdentity.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address != null && Object.hasOwnProperty.call(message, "address"))
            writer.uint32(10).string(message.address);
        writer.uint32(18).bytes(message.public_key);
        writer.uint32(26).bytes(message.signature);
        return writer;
    };

    SignedIdentity.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    SignedIdentity.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SignedIdentity();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.string();
                break;
            case 2:
                message.public_key = reader.bytes();
                break;
            case 3:
                message.signature = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("public_key"))
            throw $util.ProtocolError("missing required 'public_key'", { instance: message });
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        return message;
    };

    SignedIdentity.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    SignedIdentity.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address != null && message.hasOwnProperty("address"))
            if (!$util.isString(message.address))
                return "address: string expected";
        if (!(message.public_key && typeof message.public_key.length === "number" || $util.isString(message.public_key)))
            return "public_key: buffer expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        return null;
    };

    SignedIdentity.fromObject = function fromObject(object) {
        if (object instanceof $root.SignedIdentity)
            return object;
        var message = new $root.SignedIdentity();
        if (object.address != null)
            message.address = String(object.address);
        if (object.public_key != null)
            if (typeof object.public_key === "string")
                $util.base64.decode(object.public_key, message.public_key = $util.newBuffer($util.base64.length(object.public_key)), 0);
            else if (object.public_key.length)
                message.public_key = object.public_key;
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        return message;
    };

    SignedIdentity.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.address = "";
            if (options.bytes === String)
                object.public_key = "";
            else {
                object.public_key = [];
                if (options.bytes !== Array)
                    object.public_key = $util.newBuffer(object.public_key);
            }
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
        }
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            object.public_key = options.bytes === String ? $util.base64.encode(message.public_key, 0, message.public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.public_key) : message.public_key;
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        return object;
    };

    SignedIdentity.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SignedIdentity;
})();

$root.GetECDHSessionKey = (function() {

    function GetECDHSessionKey(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    GetECDHSessionKey.prototype.identity = null;
    GetECDHSessionKey.prototype.peer_public_key = $util.newBuffer([]);
    GetECDHSessionKey.prototype.ecdsa_curve_name = "";

    GetECDHSessionKey.create = function create(properties) {
        return new GetECDHSessionKey(properties);
    };

    GetECDHSessionKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        $root.IdentityType.encode(message.identity, writer.uint32(10).fork()).ldelim();
        writer.uint32(18).bytes(message.peer_public_key);
        if (message.ecdsa_curve_name != null && Object.hasOwnProperty.call(message, "ecdsa_curve_name"))
            writer.uint32(26).string(message.ecdsa_curve_name);
        return writer;
    };

    GetECDHSessionKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    GetECDHSessionKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.GetECDHSessionKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.identity = $root.IdentityType.decode(reader, reader.uint32());
                break;
            case 2:
                message.peer_public_key = reader.bytes();
                break;
            case 3:
                message.ecdsa_curve_name = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("identity"))
            throw $util.ProtocolError("missing required 'identity'", { instance: message });
        if (!message.hasOwnProperty("peer_public_key"))
            throw $util.ProtocolError("missing required 'peer_public_key'", { instance: message });
        return message;
    };

    GetECDHSessionKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    GetECDHSessionKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        {
            var error = $root.IdentityType.verify(message.identity);
            if (error)
                return "identity." + error;
        }
        if (!(message.peer_public_key && typeof message.peer_public_key.length === "number" || $util.isString(message.peer_public_key)))
            return "peer_public_key: buffer expected";
        if (message.ecdsa_curve_name != null && message.hasOwnProperty("ecdsa_curve_name"))
            if (!$util.isString(message.ecdsa_curve_name))
                return "ecdsa_curve_name: string expected";
        return null;
    };

    GetECDHSessionKey.fromObject = function fromObject(object) {
        if (object instanceof $root.GetECDHSessionKey)
            return object;
        var message = new $root.GetECDHSessionKey();
        if (object.identity != null) {
            if (typeof object.identity !== "object")
                throw TypeError(".GetECDHSessionKey.identity: object expected");
            message.identity = $root.IdentityType.fromObject(object.identity);
        }
        if (object.peer_public_key != null)
            if (typeof object.peer_public_key === "string")
                $util.base64.decode(object.peer_public_key, message.peer_public_key = $util.newBuffer($util.base64.length(object.peer_public_key)), 0);
            else if (object.peer_public_key.length)
                message.peer_public_key = object.peer_public_key;
        if (object.ecdsa_curve_name != null)
            message.ecdsa_curve_name = String(object.ecdsa_curve_name);
        return message;
    };

    GetECDHSessionKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.identity = null;
            if (options.bytes === String)
                object.peer_public_key = "";
            else {
                object.peer_public_key = [];
                if (options.bytes !== Array)
                    object.peer_public_key = $util.newBuffer(object.peer_public_key);
            }
            object.ecdsa_curve_name = "";
        }
        if (message.identity != null && message.hasOwnProperty("identity"))
            object.identity = $root.IdentityType.toObject(message.identity, options);
        if (message.peer_public_key != null && message.hasOwnProperty("peer_public_key"))
            object.peer_public_key = options.bytes === String ? $util.base64.encode(message.peer_public_key, 0, message.peer_public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.peer_public_key) : message.peer_public_key;
        if (message.ecdsa_curve_name != null && message.hasOwnProperty("ecdsa_curve_name"))
            object.ecdsa_curve_name = message.ecdsa_curve_name;
        return object;
    };

    GetECDHSessionKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return GetECDHSessionKey;
})();

$root.ECDHSessionKey = (function() {

    function ECDHSessionKey(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ECDHSessionKey.prototype.session_key = $util.newBuffer([]);
    ECDHSessionKey.prototype.public_key = $util.newBuffer([]);

    ECDHSessionKey.create = function create(properties) {
        return new ECDHSessionKey(properties);
    };

    ECDHSessionKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.session_key);
        if (message.public_key != null && Object.hasOwnProperty.call(message, "public_key"))
            writer.uint32(18).bytes(message.public_key);
        return writer;
    };

    ECDHSessionKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ECDHSessionKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ECDHSessionKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.session_key = reader.bytes();
                break;
            case 2:
                message.public_key = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("session_key"))
            throw $util.ProtocolError("missing required 'session_key'", { instance: message });
        return message;
    };

    ECDHSessionKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ECDHSessionKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.session_key && typeof message.session_key.length === "number" || $util.isString(message.session_key)))
            return "session_key: buffer expected";
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            if (!(message.public_key && typeof message.public_key.length === "number" || $util.isString(message.public_key)))
                return "public_key: buffer expected";
        return null;
    };

    ECDHSessionKey.fromObject = function fromObject(object) {
        if (object instanceof $root.ECDHSessionKey)
            return object;
        var message = new $root.ECDHSessionKey();
        if (object.session_key != null)
            if (typeof object.session_key === "string")
                $util.base64.decode(object.session_key, message.session_key = $util.newBuffer($util.base64.length(object.session_key)), 0);
            else if (object.session_key.length)
                message.session_key = object.session_key;
        if (object.public_key != null)
            if (typeof object.public_key === "string")
                $util.base64.decode(object.public_key, message.public_key = $util.newBuffer($util.base64.length(object.public_key)), 0);
            else if (object.public_key.length)
                message.public_key = object.public_key;
        return message;
    };

    ECDHSessionKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.session_key = "";
            else {
                object.session_key = [];
                if (options.bytes !== Array)
                    object.session_key = $util.newBuffer(object.session_key);
            }
            if (options.bytes === String)
                object.public_key = "";
            else {
                object.public_key = [];
                if (options.bytes !== Array)
                    object.public_key = $util.newBuffer(object.public_key);
            }
        }
        if (message.session_key != null && message.hasOwnProperty("session_key"))
            object.session_key = options.bytes === String ? $util.base64.encode(message.session_key, 0, message.session_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.session_key) : message.session_key;
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            object.public_key = options.bytes === String ? $util.base64.encode(message.public_key, 0, message.public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.public_key) : message.public_key;
        return object;
    };

    ECDHSessionKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ECDHSessionKey;
})();

$root.CosiCommit = (function() {

    function CosiCommit(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CosiCommit.prototype.address_n = $util.emptyArray;
    CosiCommit.prototype.data = $util.newBuffer([]);

    CosiCommit.create = function create(properties) {
        return new CosiCommit(properties);
    };

    CosiCommit.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.data != null && Object.hasOwnProperty.call(message, "data"))
            writer.uint32(18).bytes(message.data);
        return writer;
    };

    CosiCommit.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CosiCommit.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CosiCommit();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.data = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    CosiCommit.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CosiCommit.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.data != null && message.hasOwnProperty("data"))
            if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
                return "data: buffer expected";
        return null;
    };

    CosiCommit.fromObject = function fromObject(object) {
        if (object instanceof $root.CosiCommit)
            return object;
        var message = new $root.CosiCommit();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".CosiCommit.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.data != null)
            if (typeof object.data === "string")
                $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
            else if (object.data.length)
                message.data = object.data;
        return message;
    };

    CosiCommit.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            if (options.bytes === String)
                object.data = "";
            else {
                object.data = [];
                if (options.bytes !== Array)
                    object.data = $util.newBuffer(object.data);
            }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.data != null && message.hasOwnProperty("data"))
            object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
        return object;
    };

    CosiCommit.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CosiCommit;
})();

$root.CosiCommitment = (function() {

    function CosiCommitment(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CosiCommitment.prototype.commitment = $util.newBuffer([]);
    CosiCommitment.prototype.pubkey = $util.newBuffer([]);

    CosiCommitment.create = function create(properties) {
        return new CosiCommitment(properties);
    };

    CosiCommitment.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.commitment != null && Object.hasOwnProperty.call(message, "commitment"))
            writer.uint32(10).bytes(message.commitment);
        if (message.pubkey != null && Object.hasOwnProperty.call(message, "pubkey"))
            writer.uint32(18).bytes(message.pubkey);
        return writer;
    };

    CosiCommitment.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CosiCommitment.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CosiCommitment();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.commitment = reader.bytes();
                break;
            case 2:
                message.pubkey = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    CosiCommitment.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CosiCommitment.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.commitment != null && message.hasOwnProperty("commitment"))
            if (!(message.commitment && typeof message.commitment.length === "number" || $util.isString(message.commitment)))
                return "commitment: buffer expected";
        if (message.pubkey != null && message.hasOwnProperty("pubkey"))
            if (!(message.pubkey && typeof message.pubkey.length === "number" || $util.isString(message.pubkey)))
                return "pubkey: buffer expected";
        return null;
    };

    CosiCommitment.fromObject = function fromObject(object) {
        if (object instanceof $root.CosiCommitment)
            return object;
        var message = new $root.CosiCommitment();
        if (object.commitment != null)
            if (typeof object.commitment === "string")
                $util.base64.decode(object.commitment, message.commitment = $util.newBuffer($util.base64.length(object.commitment)), 0);
            else if (object.commitment.length)
                message.commitment = object.commitment;
        if (object.pubkey != null)
            if (typeof object.pubkey === "string")
                $util.base64.decode(object.pubkey, message.pubkey = $util.newBuffer($util.base64.length(object.pubkey)), 0);
            else if (object.pubkey.length)
                message.pubkey = object.pubkey;
        return message;
    };

    CosiCommitment.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.commitment = "";
            else {
                object.commitment = [];
                if (options.bytes !== Array)
                    object.commitment = $util.newBuffer(object.commitment);
            }
            if (options.bytes === String)
                object.pubkey = "";
            else {
                object.pubkey = [];
                if (options.bytes !== Array)
                    object.pubkey = $util.newBuffer(object.pubkey);
            }
        }
        if (message.commitment != null && message.hasOwnProperty("commitment"))
            object.commitment = options.bytes === String ? $util.base64.encode(message.commitment, 0, message.commitment.length) : options.bytes === Array ? Array.prototype.slice.call(message.commitment) : message.commitment;
        if (message.pubkey != null && message.hasOwnProperty("pubkey"))
            object.pubkey = options.bytes === String ? $util.base64.encode(message.pubkey, 0, message.pubkey.length) : options.bytes === Array ? Array.prototype.slice.call(message.pubkey) : message.pubkey;
        return object;
    };

    CosiCommitment.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CosiCommitment;
})();

$root.CosiSign = (function() {

    function CosiSign(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CosiSign.prototype.address_n = $util.emptyArray;
    CosiSign.prototype.data = $util.newBuffer([]);
    CosiSign.prototype.global_commitment = $util.newBuffer([]);
    CosiSign.prototype.global_pubkey = $util.newBuffer([]);

    CosiSign.create = function create(properties) {
        return new CosiSign(properties);
    };

    CosiSign.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.data != null && Object.hasOwnProperty.call(message, "data"))
            writer.uint32(18).bytes(message.data);
        if (message.global_commitment != null && Object.hasOwnProperty.call(message, "global_commitment"))
            writer.uint32(26).bytes(message.global_commitment);
        if (message.global_pubkey != null && Object.hasOwnProperty.call(message, "global_pubkey"))
            writer.uint32(34).bytes(message.global_pubkey);
        return writer;
    };

    CosiSign.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CosiSign.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CosiSign();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.data = reader.bytes();
                break;
            case 3:
                message.global_commitment = reader.bytes();
                break;
            case 4:
                message.global_pubkey = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    CosiSign.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CosiSign.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.data != null && message.hasOwnProperty("data"))
            if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
                return "data: buffer expected";
        if (message.global_commitment != null && message.hasOwnProperty("global_commitment"))
            if (!(message.global_commitment && typeof message.global_commitment.length === "number" || $util.isString(message.global_commitment)))
                return "global_commitment: buffer expected";
        if (message.global_pubkey != null && message.hasOwnProperty("global_pubkey"))
            if (!(message.global_pubkey && typeof message.global_pubkey.length === "number" || $util.isString(message.global_pubkey)))
                return "global_pubkey: buffer expected";
        return null;
    };

    CosiSign.fromObject = function fromObject(object) {
        if (object instanceof $root.CosiSign)
            return object;
        var message = new $root.CosiSign();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".CosiSign.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.data != null)
            if (typeof object.data === "string")
                $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
            else if (object.data.length)
                message.data = object.data;
        if (object.global_commitment != null)
            if (typeof object.global_commitment === "string")
                $util.base64.decode(object.global_commitment, message.global_commitment = $util.newBuffer($util.base64.length(object.global_commitment)), 0);
            else if (object.global_commitment.length)
                message.global_commitment = object.global_commitment;
        if (object.global_pubkey != null)
            if (typeof object.global_pubkey === "string")
                $util.base64.decode(object.global_pubkey, message.global_pubkey = $util.newBuffer($util.base64.length(object.global_pubkey)), 0);
            else if (object.global_pubkey.length)
                message.global_pubkey = object.global_pubkey;
        return message;
    };

    CosiSign.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            if (options.bytes === String)
                object.data = "";
            else {
                object.data = [];
                if (options.bytes !== Array)
                    object.data = $util.newBuffer(object.data);
            }
            if (options.bytes === String)
                object.global_commitment = "";
            else {
                object.global_commitment = [];
                if (options.bytes !== Array)
                    object.global_commitment = $util.newBuffer(object.global_commitment);
            }
            if (options.bytes === String)
                object.global_pubkey = "";
            else {
                object.global_pubkey = [];
                if (options.bytes !== Array)
                    object.global_pubkey = $util.newBuffer(object.global_pubkey);
            }
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.data != null && message.hasOwnProperty("data"))
            object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
        if (message.global_commitment != null && message.hasOwnProperty("global_commitment"))
            object.global_commitment = options.bytes === String ? $util.base64.encode(message.global_commitment, 0, message.global_commitment.length) : options.bytes === Array ? Array.prototype.slice.call(message.global_commitment) : message.global_commitment;
        if (message.global_pubkey != null && message.hasOwnProperty("global_pubkey"))
            object.global_pubkey = options.bytes === String ? $util.base64.encode(message.global_pubkey, 0, message.global_pubkey.length) : options.bytes === Array ? Array.prototype.slice.call(message.global_pubkey) : message.global_pubkey;
        return object;
    };

    CosiSign.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CosiSign;
})();

$root.CosiSignature = (function() {

    function CosiSignature(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CosiSignature.prototype.signature = $util.newBuffer([]);

    CosiSignature.create = function create(properties) {
        return new CosiSignature(properties);
    };

    CosiSignature.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.signature);
        return writer;
    };

    CosiSignature.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CosiSignature.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CosiSignature();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.signature = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        return message;
    };

    CosiSignature.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CosiSignature.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        return null;
    };

    CosiSignature.fromObject = function fromObject(object) {
        if (object instanceof $root.CosiSignature)
            return object;
        var message = new $root.CosiSignature();
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        return message;
    };

    CosiSignature.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        return object;
    };

    CosiSignature.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CosiSignature;
})();

$root.BatchGetPublickeys = (function() {

    function BatchGetPublickeys(properties) {
        this.paths = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    BatchGetPublickeys.prototype.ecdsa_curve_name = "ed25519";
    BatchGetPublickeys.prototype.paths = $util.emptyArray;
    BatchGetPublickeys.prototype.include_node = false;

    BatchGetPublickeys.create = function create(properties) {
        return new BatchGetPublickeys(properties);
    };

    BatchGetPublickeys.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.ecdsa_curve_name != null && Object.hasOwnProperty.call(message, "ecdsa_curve_name"))
            writer.uint32(10).string(message.ecdsa_curve_name);
        if (message.paths != null && message.paths.length)
            for (var i = 0; i < message.paths.length; ++i)
                $root.BatchGetPublickeys.Path.encode(message.paths[i], writer.uint32(18).fork()).ldelim();
        if (message.include_node != null && Object.hasOwnProperty.call(message, "include_node"))
            writer.uint32(24).bool(message.include_node);
        return writer;
    };

    BatchGetPublickeys.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    BatchGetPublickeys.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BatchGetPublickeys();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.ecdsa_curve_name = reader.string();
                break;
            case 2:
                if (!(message.paths && message.paths.length))
                    message.paths = [];
                message.paths.push($root.BatchGetPublickeys.Path.decode(reader, reader.uint32()));
                break;
            case 3:
                message.include_node = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    BatchGetPublickeys.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    BatchGetPublickeys.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.ecdsa_curve_name != null && message.hasOwnProperty("ecdsa_curve_name"))
            if (!$util.isString(message.ecdsa_curve_name))
                return "ecdsa_curve_name: string expected";
        if (message.paths != null && message.hasOwnProperty("paths")) {
            if (!Array.isArray(message.paths))
                return "paths: array expected";
            for (var i = 0; i < message.paths.length; ++i) {
                var error = $root.BatchGetPublickeys.Path.verify(message.paths[i]);
                if (error)
                    return "paths." + error;
            }
        }
        if (message.include_node != null && message.hasOwnProperty("include_node"))
            if (typeof message.include_node !== "boolean")
                return "include_node: boolean expected";
        return null;
    };

    BatchGetPublickeys.fromObject = function fromObject(object) {
        if (object instanceof $root.BatchGetPublickeys)
            return object;
        var message = new $root.BatchGetPublickeys();
        if (object.ecdsa_curve_name != null)
            message.ecdsa_curve_name = String(object.ecdsa_curve_name);
        if (object.paths) {
            if (!Array.isArray(object.paths))
                throw TypeError(".BatchGetPublickeys.paths: array expected");
            message.paths = [];
            for (var i = 0; i < object.paths.length; ++i) {
                if (typeof object.paths[i] !== "object")
                    throw TypeError(".BatchGetPublickeys.paths: object expected");
                message.paths[i] = $root.BatchGetPublickeys.Path.fromObject(object.paths[i]);
            }
        }
        if (object.include_node != null)
            message.include_node = Boolean(object.include_node);
        return message;
    };

    BatchGetPublickeys.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.paths = [];
        if (options.defaults) {
            object.ecdsa_curve_name = "ed25519";
            object.include_node = false;
        }
        if (message.ecdsa_curve_name != null && message.hasOwnProperty("ecdsa_curve_name"))
            object.ecdsa_curve_name = message.ecdsa_curve_name;
        if (message.paths && message.paths.length) {
            object.paths = [];
            for (var j = 0; j < message.paths.length; ++j)
                object.paths[j] = $root.BatchGetPublickeys.Path.toObject(message.paths[j], options);
        }
        if (message.include_node != null && message.hasOwnProperty("include_node"))
            object.include_node = message.include_node;
        return object;
    };

    BatchGetPublickeys.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    BatchGetPublickeys.Path = (function() {

        function Path(properties) {
            this.address_n = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        Path.prototype.address_n = $util.emptyArray;

        Path.create = function create(properties) {
            return new Path(properties);
        };

        Path.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.address_n != null && message.address_n.length)
                for (var i = 0; i < message.address_n.length; ++i)
                    writer.uint32(8).uint32(message.address_n[i]);
            return writer;
        };

        Path.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        Path.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BatchGetPublickeys.Path();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.address_n && message.address_n.length))
                        message.address_n = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.address_n.push(reader.uint32());
                    } else
                        message.address_n.push(reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        Path.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        Path.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.address_n != null && message.hasOwnProperty("address_n")) {
                if (!Array.isArray(message.address_n))
                    return "address_n: array expected";
                for (var i = 0; i < message.address_n.length; ++i)
                    if (!$util.isInteger(message.address_n[i]))
                        return "address_n: integer[] expected";
            }
            return null;
        };

        Path.fromObject = function fromObject(object) {
            if (object instanceof $root.BatchGetPublickeys.Path)
                return object;
            var message = new $root.BatchGetPublickeys.Path();
            if (object.address_n) {
                if (!Array.isArray(object.address_n))
                    throw TypeError(".BatchGetPublickeys.Path.address_n: array expected");
                message.address_n = [];
                for (var i = 0; i < object.address_n.length; ++i)
                    message.address_n[i] = object.address_n[i] >>> 0;
            }
            return message;
        };

        Path.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.address_n = [];
            if (message.address_n && message.address_n.length) {
                object.address_n = [];
                for (var j = 0; j < message.address_n.length; ++j)
                    object.address_n[j] = message.address_n[j];
            }
            return object;
        };

        Path.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Path;
    })();

    return BatchGetPublickeys;
})();

$root.EcdsaPublicKeys = (function() {

    function EcdsaPublicKeys(properties) {
        this.public_keys = [];
        this.hd_nodes = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EcdsaPublicKeys.prototype.public_keys = $util.emptyArray;
    EcdsaPublicKeys.prototype.hd_nodes = $util.emptyArray;
    EcdsaPublicKeys.prototype.root_fingerprint = 0;

    EcdsaPublicKeys.create = function create(properties) {
        return new EcdsaPublicKeys(properties);
    };

    EcdsaPublicKeys.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.public_keys != null && message.public_keys.length)
            for (var i = 0; i < message.public_keys.length; ++i)
                writer.uint32(10).bytes(message.public_keys[i]);
        if (message.hd_nodes != null && message.hd_nodes.length)
            for (var i = 0; i < message.hd_nodes.length; ++i)
                $root.HDNodeType.encode(message.hd_nodes[i], writer.uint32(18).fork()).ldelim();
        if (message.root_fingerprint != null && Object.hasOwnProperty.call(message, "root_fingerprint"))
            writer.uint32(24).uint32(message.root_fingerprint);
        return writer;
    };

    EcdsaPublicKeys.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EcdsaPublicKeys.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EcdsaPublicKeys();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.public_keys && message.public_keys.length))
                    message.public_keys = [];
                message.public_keys.push(reader.bytes());
                break;
            case 2:
                if (!(message.hd_nodes && message.hd_nodes.length))
                    message.hd_nodes = [];
                message.hd_nodes.push($root.HDNodeType.decode(reader, reader.uint32()));
                break;
            case 3:
                message.root_fingerprint = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    EcdsaPublicKeys.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EcdsaPublicKeys.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.public_keys != null && message.hasOwnProperty("public_keys")) {
            if (!Array.isArray(message.public_keys))
                return "public_keys: array expected";
            for (var i = 0; i < message.public_keys.length; ++i)
                if (!(message.public_keys[i] && typeof message.public_keys[i].length === "number" || $util.isString(message.public_keys[i])))
                    return "public_keys: buffer[] expected";
        }
        if (message.hd_nodes != null && message.hasOwnProperty("hd_nodes")) {
            if (!Array.isArray(message.hd_nodes))
                return "hd_nodes: array expected";
            for (var i = 0; i < message.hd_nodes.length; ++i) {
                var error = $root.HDNodeType.verify(message.hd_nodes[i]);
                if (error)
                    return "hd_nodes." + error;
            }
        }
        if (message.root_fingerprint != null && message.hasOwnProperty("root_fingerprint"))
            if (!$util.isInteger(message.root_fingerprint))
                return "root_fingerprint: integer expected";
        return null;
    };

    EcdsaPublicKeys.fromObject = function fromObject(object) {
        if (object instanceof $root.EcdsaPublicKeys)
            return object;
        var message = new $root.EcdsaPublicKeys();
        if (object.public_keys) {
            if (!Array.isArray(object.public_keys))
                throw TypeError(".EcdsaPublicKeys.public_keys: array expected");
            message.public_keys = [];
            for (var i = 0; i < object.public_keys.length; ++i)
                if (typeof object.public_keys[i] === "string")
                    $util.base64.decode(object.public_keys[i], message.public_keys[i] = $util.newBuffer($util.base64.length(object.public_keys[i])), 0);
                else if (object.public_keys[i].length)
                    message.public_keys[i] = object.public_keys[i];
        }
        if (object.hd_nodes) {
            if (!Array.isArray(object.hd_nodes))
                throw TypeError(".EcdsaPublicKeys.hd_nodes: array expected");
            message.hd_nodes = [];
            for (var i = 0; i < object.hd_nodes.length; ++i) {
                if (typeof object.hd_nodes[i] !== "object")
                    throw TypeError(".EcdsaPublicKeys.hd_nodes: object expected");
                message.hd_nodes[i] = $root.HDNodeType.fromObject(object.hd_nodes[i]);
            }
        }
        if (object.root_fingerprint != null)
            message.root_fingerprint = object.root_fingerprint >>> 0;
        return message;
    };

    EcdsaPublicKeys.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults) {
            object.public_keys = [];
            object.hd_nodes = [];
        }
        if (options.defaults)
            object.root_fingerprint = 0;
        if (message.public_keys && message.public_keys.length) {
            object.public_keys = [];
            for (var j = 0; j < message.public_keys.length; ++j)
                object.public_keys[j] = options.bytes === String ? $util.base64.encode(message.public_keys[j], 0, message.public_keys[j].length) : options.bytes === Array ? Array.prototype.slice.call(message.public_keys[j]) : message.public_keys[j];
        }
        if (message.hd_nodes && message.hd_nodes.length) {
            object.hd_nodes = [];
            for (var j = 0; j < message.hd_nodes.length; ++j)
                object.hd_nodes[j] = $root.HDNodeType.toObject(message.hd_nodes[j], options);
        }
        if (message.root_fingerprint != null && message.hasOwnProperty("root_fingerprint"))
            object.root_fingerprint = message.root_fingerprint;
        return object;
    };

    EcdsaPublicKeys.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EcdsaPublicKeys;
})();

$root.DebugLinkDecision = (function() {

    function DebugLinkDecision(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DebugLinkDecision.prototype.yes_no = false;
    DebugLinkDecision.prototype.swipe = 0;
    DebugLinkDecision.prototype.input = "";
    DebugLinkDecision.prototype.x = 0;
    DebugLinkDecision.prototype.y = 0;
    DebugLinkDecision.prototype.wait = false;
    DebugLinkDecision.prototype.hold_ms = 0;

    DebugLinkDecision.create = function create(properties) {
        return new DebugLinkDecision(properties);
    };

    DebugLinkDecision.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.yes_no != null && Object.hasOwnProperty.call(message, "yes_no"))
            writer.uint32(8).bool(message.yes_no);
        if (message.swipe != null && Object.hasOwnProperty.call(message, "swipe"))
            writer.uint32(16).int32(message.swipe);
        if (message.input != null && Object.hasOwnProperty.call(message, "input"))
            writer.uint32(26).string(message.input);
        if (message.x != null && Object.hasOwnProperty.call(message, "x"))
            writer.uint32(32).uint32(message.x);
        if (message.y != null && Object.hasOwnProperty.call(message, "y"))
            writer.uint32(40).uint32(message.y);
        if (message.wait != null && Object.hasOwnProperty.call(message, "wait"))
            writer.uint32(48).bool(message.wait);
        if (message.hold_ms != null && Object.hasOwnProperty.call(message, "hold_ms"))
            writer.uint32(56).uint32(message.hold_ms);
        return writer;
    };

    DebugLinkDecision.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DebugLinkDecision.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DebugLinkDecision();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.yes_no = reader.bool();
                break;
            case 2:
                message.swipe = reader.int32();
                break;
            case 3:
                message.input = reader.string();
                break;
            case 4:
                message.x = reader.uint32();
                break;
            case 5:
                message.y = reader.uint32();
                break;
            case 6:
                message.wait = reader.bool();
                break;
            case 7:
                message.hold_ms = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    DebugLinkDecision.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DebugLinkDecision.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.yes_no != null && message.hasOwnProperty("yes_no"))
            if (typeof message.yes_no !== "boolean")
                return "yes_no: boolean expected";
        if (message.swipe != null && message.hasOwnProperty("swipe"))
            switch (message.swipe) {
            default:
                return "swipe: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
                break;
            }
        if (message.input != null && message.hasOwnProperty("input"))
            if (!$util.isString(message.input))
                return "input: string expected";
        if (message.x != null && message.hasOwnProperty("x"))
            if (!$util.isInteger(message.x))
                return "x: integer expected";
        if (message.y != null && message.hasOwnProperty("y"))
            if (!$util.isInteger(message.y))
                return "y: integer expected";
        if (message.wait != null && message.hasOwnProperty("wait"))
            if (typeof message.wait !== "boolean")
                return "wait: boolean expected";
        if (message.hold_ms != null && message.hasOwnProperty("hold_ms"))
            if (!$util.isInteger(message.hold_ms))
                return "hold_ms: integer expected";
        return null;
    };

    DebugLinkDecision.fromObject = function fromObject(object) {
        if (object instanceof $root.DebugLinkDecision)
            return object;
        var message = new $root.DebugLinkDecision();
        if (object.yes_no != null)
            message.yes_no = Boolean(object.yes_no);
        switch (object.swipe) {
        case "UP":
        case 0:
            message.swipe = 0;
            break;
        case "DOWN":
        case 1:
            message.swipe = 1;
            break;
        case "LEFT":
        case 2:
            message.swipe = 2;
            break;
        case "RIGHT":
        case 3:
            message.swipe = 3;
            break;
        }
        if (object.input != null)
            message.input = String(object.input);
        if (object.x != null)
            message.x = object.x >>> 0;
        if (object.y != null)
            message.y = object.y >>> 0;
        if (object.wait != null)
            message.wait = Boolean(object.wait);
        if (object.hold_ms != null)
            message.hold_ms = object.hold_ms >>> 0;
        return message;
    };

    DebugLinkDecision.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.yes_no = false;
            object.swipe = options.enums === String ? "UP" : 0;
            object.input = "";
            object.x = 0;
            object.y = 0;
            object.wait = false;
            object.hold_ms = 0;
        }
        if (message.yes_no != null && message.hasOwnProperty("yes_no"))
            object.yes_no = message.yes_no;
        if (message.swipe != null && message.hasOwnProperty("swipe"))
            object.swipe = options.enums === String ? $root.DebugLinkDecision.DebugSwipeDirection[message.swipe] : message.swipe;
        if (message.input != null && message.hasOwnProperty("input"))
            object.input = message.input;
        if (message.x != null && message.hasOwnProperty("x"))
            object.x = message.x;
        if (message.y != null && message.hasOwnProperty("y"))
            object.y = message.y;
        if (message.wait != null && message.hasOwnProperty("wait"))
            object.wait = message.wait;
        if (message.hold_ms != null && message.hasOwnProperty("hold_ms"))
            object.hold_ms = message.hold_ms;
        return object;
    };

    DebugLinkDecision.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    DebugLinkDecision.DebugSwipeDirection = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UP"] = 0;
        values[valuesById[1] = "DOWN"] = 1;
        values[valuesById[2] = "LEFT"] = 2;
        values[valuesById[3] = "RIGHT"] = 3;
        return values;
    })();

    return DebugLinkDecision;
})();

$root.DebugLinkLayout = (function() {

    function DebugLinkLayout(properties) {
        this.lines = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DebugLinkLayout.prototype.lines = $util.emptyArray;

    DebugLinkLayout.create = function create(properties) {
        return new DebugLinkLayout(properties);
    };

    DebugLinkLayout.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.lines != null && message.lines.length)
            for (var i = 0; i < message.lines.length; ++i)
                writer.uint32(10).string(message.lines[i]);
        return writer;
    };

    DebugLinkLayout.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DebugLinkLayout.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DebugLinkLayout();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.lines && message.lines.length))
                    message.lines = [];
                message.lines.push(reader.string());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    DebugLinkLayout.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DebugLinkLayout.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.lines != null && message.hasOwnProperty("lines")) {
            if (!Array.isArray(message.lines))
                return "lines: array expected";
            for (var i = 0; i < message.lines.length; ++i)
                if (!$util.isString(message.lines[i]))
                    return "lines: string[] expected";
        }
        return null;
    };

    DebugLinkLayout.fromObject = function fromObject(object) {
        if (object instanceof $root.DebugLinkLayout)
            return object;
        var message = new $root.DebugLinkLayout();
        if (object.lines) {
            if (!Array.isArray(object.lines))
                throw TypeError(".DebugLinkLayout.lines: array expected");
            message.lines = [];
            for (var i = 0; i < object.lines.length; ++i)
                message.lines[i] = String(object.lines[i]);
        }
        return message;
    };

    DebugLinkLayout.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.lines = [];
        if (message.lines && message.lines.length) {
            object.lines = [];
            for (var j = 0; j < message.lines.length; ++j)
                object.lines[j] = message.lines[j];
        }
        return object;
    };

    DebugLinkLayout.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DebugLinkLayout;
})();

$root.DebugLinkReseedRandom = (function() {

    function DebugLinkReseedRandom(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DebugLinkReseedRandom.prototype.value = 0;

    DebugLinkReseedRandom.create = function create(properties) {
        return new DebugLinkReseedRandom(properties);
    };

    DebugLinkReseedRandom.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.value != null && Object.hasOwnProperty.call(message, "value"))
            writer.uint32(8).uint32(message.value);
        return writer;
    };

    DebugLinkReseedRandom.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DebugLinkReseedRandom.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DebugLinkReseedRandom();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.value = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    DebugLinkReseedRandom.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DebugLinkReseedRandom.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.value != null && message.hasOwnProperty("value"))
            if (!$util.isInteger(message.value))
                return "value: integer expected";
        return null;
    };

    DebugLinkReseedRandom.fromObject = function fromObject(object) {
        if (object instanceof $root.DebugLinkReseedRandom)
            return object;
        var message = new $root.DebugLinkReseedRandom();
        if (object.value != null)
            message.value = object.value >>> 0;
        return message;
    };

    DebugLinkReseedRandom.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.value = 0;
        if (message.value != null && message.hasOwnProperty("value"))
            object.value = message.value;
        return object;
    };

    DebugLinkReseedRandom.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DebugLinkReseedRandom;
})();

$root.DebugLinkRecordScreen = (function() {

    function DebugLinkRecordScreen(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DebugLinkRecordScreen.prototype.target_directory = "";

    DebugLinkRecordScreen.create = function create(properties) {
        return new DebugLinkRecordScreen(properties);
    };

    DebugLinkRecordScreen.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.target_directory != null && Object.hasOwnProperty.call(message, "target_directory"))
            writer.uint32(10).string(message.target_directory);
        return writer;
    };

    DebugLinkRecordScreen.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DebugLinkRecordScreen.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DebugLinkRecordScreen();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.target_directory = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    DebugLinkRecordScreen.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DebugLinkRecordScreen.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.target_directory != null && message.hasOwnProperty("target_directory"))
            if (!$util.isString(message.target_directory))
                return "target_directory: string expected";
        return null;
    };

    DebugLinkRecordScreen.fromObject = function fromObject(object) {
        if (object instanceof $root.DebugLinkRecordScreen)
            return object;
        var message = new $root.DebugLinkRecordScreen();
        if (object.target_directory != null)
            message.target_directory = String(object.target_directory);
        return message;
    };

    DebugLinkRecordScreen.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.target_directory = "";
        if (message.target_directory != null && message.hasOwnProperty("target_directory"))
            object.target_directory = message.target_directory;
        return object;
    };

    DebugLinkRecordScreen.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DebugLinkRecordScreen;
})();

$root.DebugLinkGetState = (function() {

    function DebugLinkGetState(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DebugLinkGetState.prototype.wait_word_list = false;
    DebugLinkGetState.prototype.wait_word_pos = false;
    DebugLinkGetState.prototype.wait_layout = false;

    DebugLinkGetState.create = function create(properties) {
        return new DebugLinkGetState(properties);
    };

    DebugLinkGetState.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.wait_word_list != null && Object.hasOwnProperty.call(message, "wait_word_list"))
            writer.uint32(8).bool(message.wait_word_list);
        if (message.wait_word_pos != null && Object.hasOwnProperty.call(message, "wait_word_pos"))
            writer.uint32(16).bool(message.wait_word_pos);
        if (message.wait_layout != null && Object.hasOwnProperty.call(message, "wait_layout"))
            writer.uint32(24).bool(message.wait_layout);
        return writer;
    };

    DebugLinkGetState.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DebugLinkGetState.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DebugLinkGetState();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.wait_word_list = reader.bool();
                break;
            case 2:
                message.wait_word_pos = reader.bool();
                break;
            case 3:
                message.wait_layout = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    DebugLinkGetState.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DebugLinkGetState.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.wait_word_list != null && message.hasOwnProperty("wait_word_list"))
            if (typeof message.wait_word_list !== "boolean")
                return "wait_word_list: boolean expected";
        if (message.wait_word_pos != null && message.hasOwnProperty("wait_word_pos"))
            if (typeof message.wait_word_pos !== "boolean")
                return "wait_word_pos: boolean expected";
        if (message.wait_layout != null && message.hasOwnProperty("wait_layout"))
            if (typeof message.wait_layout !== "boolean")
                return "wait_layout: boolean expected";
        return null;
    };

    DebugLinkGetState.fromObject = function fromObject(object) {
        if (object instanceof $root.DebugLinkGetState)
            return object;
        var message = new $root.DebugLinkGetState();
        if (object.wait_word_list != null)
            message.wait_word_list = Boolean(object.wait_word_list);
        if (object.wait_word_pos != null)
            message.wait_word_pos = Boolean(object.wait_word_pos);
        if (object.wait_layout != null)
            message.wait_layout = Boolean(object.wait_layout);
        return message;
    };

    DebugLinkGetState.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.wait_word_list = false;
            object.wait_word_pos = false;
            object.wait_layout = false;
        }
        if (message.wait_word_list != null && message.hasOwnProperty("wait_word_list"))
            object.wait_word_list = message.wait_word_list;
        if (message.wait_word_pos != null && message.hasOwnProperty("wait_word_pos"))
            object.wait_word_pos = message.wait_word_pos;
        if (message.wait_layout != null && message.hasOwnProperty("wait_layout"))
            object.wait_layout = message.wait_layout;
        return object;
    };

    DebugLinkGetState.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DebugLinkGetState;
})();

$root.DebugLinkState = (function() {

    function DebugLinkState(properties) {
        this.layout_lines = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DebugLinkState.prototype.layout = $util.newBuffer([]);
    DebugLinkState.prototype.pin = "";
    DebugLinkState.prototype.matrix = "";
    DebugLinkState.prototype.mnemonic_secret = $util.newBuffer([]);
    DebugLinkState.prototype.node = null;
    DebugLinkState.prototype.passphrase_protection = false;
    DebugLinkState.prototype.reset_word = "";
    DebugLinkState.prototype.reset_entropy = $util.newBuffer([]);
    DebugLinkState.prototype.recovery_fake_word = "";
    DebugLinkState.prototype.recovery_word_pos = 0;
    DebugLinkState.prototype.reset_word_pos = 0;
    DebugLinkState.prototype.mnemonic_type = 0;
    DebugLinkState.prototype.layout_lines = $util.emptyArray;

    DebugLinkState.create = function create(properties) {
        return new DebugLinkState(properties);
    };

    DebugLinkState.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.layout != null && Object.hasOwnProperty.call(message, "layout"))
            writer.uint32(10).bytes(message.layout);
        if (message.pin != null && Object.hasOwnProperty.call(message, "pin"))
            writer.uint32(18).string(message.pin);
        if (message.matrix != null && Object.hasOwnProperty.call(message, "matrix"))
            writer.uint32(26).string(message.matrix);
        if (message.mnemonic_secret != null && Object.hasOwnProperty.call(message, "mnemonic_secret"))
            writer.uint32(34).bytes(message.mnemonic_secret);
        if (message.node != null && Object.hasOwnProperty.call(message, "node"))
            $root.HDNodeType.encode(message.node, writer.uint32(42).fork()).ldelim();
        if (message.passphrase_protection != null && Object.hasOwnProperty.call(message, "passphrase_protection"))
            writer.uint32(48).bool(message.passphrase_protection);
        if (message.reset_word != null && Object.hasOwnProperty.call(message, "reset_word"))
            writer.uint32(58).string(message.reset_word);
        if (message.reset_entropy != null && Object.hasOwnProperty.call(message, "reset_entropy"))
            writer.uint32(66).bytes(message.reset_entropy);
        if (message.recovery_fake_word != null && Object.hasOwnProperty.call(message, "recovery_fake_word"))
            writer.uint32(74).string(message.recovery_fake_word);
        if (message.recovery_word_pos != null && Object.hasOwnProperty.call(message, "recovery_word_pos"))
            writer.uint32(80).uint32(message.recovery_word_pos);
        if (message.reset_word_pos != null && Object.hasOwnProperty.call(message, "reset_word_pos"))
            writer.uint32(88).uint32(message.reset_word_pos);
        if (message.mnemonic_type != null && Object.hasOwnProperty.call(message, "mnemonic_type"))
            writer.uint32(96).int32(message.mnemonic_type);
        if (message.layout_lines != null && message.layout_lines.length)
            for (var i = 0; i < message.layout_lines.length; ++i)
                writer.uint32(106).string(message.layout_lines[i]);
        return writer;
    };

    DebugLinkState.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DebugLinkState.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DebugLinkState();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.layout = reader.bytes();
                break;
            case 2:
                message.pin = reader.string();
                break;
            case 3:
                message.matrix = reader.string();
                break;
            case 4:
                message.mnemonic_secret = reader.bytes();
                break;
            case 5:
                message.node = $root.HDNodeType.decode(reader, reader.uint32());
                break;
            case 6:
                message.passphrase_protection = reader.bool();
                break;
            case 7:
                message.reset_word = reader.string();
                break;
            case 8:
                message.reset_entropy = reader.bytes();
                break;
            case 9:
                message.recovery_fake_word = reader.string();
                break;
            case 10:
                message.recovery_word_pos = reader.uint32();
                break;
            case 11:
                message.reset_word_pos = reader.uint32();
                break;
            case 12:
                message.mnemonic_type = reader.int32();
                break;
            case 13:
                if (!(message.layout_lines && message.layout_lines.length))
                    message.layout_lines = [];
                message.layout_lines.push(reader.string());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    DebugLinkState.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DebugLinkState.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.layout != null && message.hasOwnProperty("layout"))
            if (!(message.layout && typeof message.layout.length === "number" || $util.isString(message.layout)))
                return "layout: buffer expected";
        if (message.pin != null && message.hasOwnProperty("pin"))
            if (!$util.isString(message.pin))
                return "pin: string expected";
        if (message.matrix != null && message.hasOwnProperty("matrix"))
            if (!$util.isString(message.matrix))
                return "matrix: string expected";
        if (message.mnemonic_secret != null && message.hasOwnProperty("mnemonic_secret"))
            if (!(message.mnemonic_secret && typeof message.mnemonic_secret.length === "number" || $util.isString(message.mnemonic_secret)))
                return "mnemonic_secret: buffer expected";
        if (message.node != null && message.hasOwnProperty("node")) {
            var error = $root.HDNodeType.verify(message.node);
            if (error)
                return "node." + error;
        }
        if (message.passphrase_protection != null && message.hasOwnProperty("passphrase_protection"))
            if (typeof message.passphrase_protection !== "boolean")
                return "passphrase_protection: boolean expected";
        if (message.reset_word != null && message.hasOwnProperty("reset_word"))
            if (!$util.isString(message.reset_word))
                return "reset_word: string expected";
        if (message.reset_entropy != null && message.hasOwnProperty("reset_entropy"))
            if (!(message.reset_entropy && typeof message.reset_entropy.length === "number" || $util.isString(message.reset_entropy)))
                return "reset_entropy: buffer expected";
        if (message.recovery_fake_word != null && message.hasOwnProperty("recovery_fake_word"))
            if (!$util.isString(message.recovery_fake_word))
                return "recovery_fake_word: string expected";
        if (message.recovery_word_pos != null && message.hasOwnProperty("recovery_word_pos"))
            if (!$util.isInteger(message.recovery_word_pos))
                return "recovery_word_pos: integer expected";
        if (message.reset_word_pos != null && message.hasOwnProperty("reset_word_pos"))
            if (!$util.isInteger(message.reset_word_pos))
                return "reset_word_pos: integer expected";
        if (message.mnemonic_type != null && message.hasOwnProperty("mnemonic_type"))
            switch (message.mnemonic_type) {
            default:
                return "mnemonic_type: enum value expected";
            case 0:
            case 1:
            case 2:
                break;
            }
        if (message.layout_lines != null && message.hasOwnProperty("layout_lines")) {
            if (!Array.isArray(message.layout_lines))
                return "layout_lines: array expected";
            for (var i = 0; i < message.layout_lines.length; ++i)
                if (!$util.isString(message.layout_lines[i]))
                    return "layout_lines: string[] expected";
        }
        return null;
    };

    DebugLinkState.fromObject = function fromObject(object) {
        if (object instanceof $root.DebugLinkState)
            return object;
        var message = new $root.DebugLinkState();
        if (object.layout != null)
            if (typeof object.layout === "string")
                $util.base64.decode(object.layout, message.layout = $util.newBuffer($util.base64.length(object.layout)), 0);
            else if (object.layout.length)
                message.layout = object.layout;
        if (object.pin != null)
            message.pin = String(object.pin);
        if (object.matrix != null)
            message.matrix = String(object.matrix);
        if (object.mnemonic_secret != null)
            if (typeof object.mnemonic_secret === "string")
                $util.base64.decode(object.mnemonic_secret, message.mnemonic_secret = $util.newBuffer($util.base64.length(object.mnemonic_secret)), 0);
            else if (object.mnemonic_secret.length)
                message.mnemonic_secret = object.mnemonic_secret;
        if (object.node != null) {
            if (typeof object.node !== "object")
                throw TypeError(".DebugLinkState.node: object expected");
            message.node = $root.HDNodeType.fromObject(object.node);
        }
        if (object.passphrase_protection != null)
            message.passphrase_protection = Boolean(object.passphrase_protection);
        if (object.reset_word != null)
            message.reset_word = String(object.reset_word);
        if (object.reset_entropy != null)
            if (typeof object.reset_entropy === "string")
                $util.base64.decode(object.reset_entropy, message.reset_entropy = $util.newBuffer($util.base64.length(object.reset_entropy)), 0);
            else if (object.reset_entropy.length)
                message.reset_entropy = object.reset_entropy;
        if (object.recovery_fake_word != null)
            message.recovery_fake_word = String(object.recovery_fake_word);
        if (object.recovery_word_pos != null)
            message.recovery_word_pos = object.recovery_word_pos >>> 0;
        if (object.reset_word_pos != null)
            message.reset_word_pos = object.reset_word_pos >>> 0;
        switch (object.mnemonic_type) {
        case "Bip39":
        case 0:
            message.mnemonic_type = 0;
            break;
        case "Slip39_Basic":
        case 1:
            message.mnemonic_type = 1;
            break;
        case "Slip39_Advanced":
        case 2:
            message.mnemonic_type = 2;
            break;
        }
        if (object.layout_lines) {
            if (!Array.isArray(object.layout_lines))
                throw TypeError(".DebugLinkState.layout_lines: array expected");
            message.layout_lines = [];
            for (var i = 0; i < object.layout_lines.length; ++i)
                message.layout_lines[i] = String(object.layout_lines[i]);
        }
        return message;
    };

    DebugLinkState.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.layout_lines = [];
        if (options.defaults) {
            if (options.bytes === String)
                object.layout = "";
            else {
                object.layout = [];
                if (options.bytes !== Array)
                    object.layout = $util.newBuffer(object.layout);
            }
            object.pin = "";
            object.matrix = "";
            if (options.bytes === String)
                object.mnemonic_secret = "";
            else {
                object.mnemonic_secret = [];
                if (options.bytes !== Array)
                    object.mnemonic_secret = $util.newBuffer(object.mnemonic_secret);
            }
            object.node = null;
            object.passphrase_protection = false;
            object.reset_word = "";
            if (options.bytes === String)
                object.reset_entropy = "";
            else {
                object.reset_entropy = [];
                if (options.bytes !== Array)
                    object.reset_entropy = $util.newBuffer(object.reset_entropy);
            }
            object.recovery_fake_word = "";
            object.recovery_word_pos = 0;
            object.reset_word_pos = 0;
            object.mnemonic_type = options.enums === String ? "Bip39" : 0;
        }
        if (message.layout != null && message.hasOwnProperty("layout"))
            object.layout = options.bytes === String ? $util.base64.encode(message.layout, 0, message.layout.length) : options.bytes === Array ? Array.prototype.slice.call(message.layout) : message.layout;
        if (message.pin != null && message.hasOwnProperty("pin"))
            object.pin = message.pin;
        if (message.matrix != null && message.hasOwnProperty("matrix"))
            object.matrix = message.matrix;
        if (message.mnemonic_secret != null && message.hasOwnProperty("mnemonic_secret"))
            object.mnemonic_secret = options.bytes === String ? $util.base64.encode(message.mnemonic_secret, 0, message.mnemonic_secret.length) : options.bytes === Array ? Array.prototype.slice.call(message.mnemonic_secret) : message.mnemonic_secret;
        if (message.node != null && message.hasOwnProperty("node"))
            object.node = $root.HDNodeType.toObject(message.node, options);
        if (message.passphrase_protection != null && message.hasOwnProperty("passphrase_protection"))
            object.passphrase_protection = message.passphrase_protection;
        if (message.reset_word != null && message.hasOwnProperty("reset_word"))
            object.reset_word = message.reset_word;
        if (message.reset_entropy != null && message.hasOwnProperty("reset_entropy"))
            object.reset_entropy = options.bytes === String ? $util.base64.encode(message.reset_entropy, 0, message.reset_entropy.length) : options.bytes === Array ? Array.prototype.slice.call(message.reset_entropy) : message.reset_entropy;
        if (message.recovery_fake_word != null && message.hasOwnProperty("recovery_fake_word"))
            object.recovery_fake_word = message.recovery_fake_word;
        if (message.recovery_word_pos != null && message.hasOwnProperty("recovery_word_pos"))
            object.recovery_word_pos = message.recovery_word_pos;
        if (message.reset_word_pos != null && message.hasOwnProperty("reset_word_pos"))
            object.reset_word_pos = message.reset_word_pos;
        if (message.mnemonic_type != null && message.hasOwnProperty("mnemonic_type"))
            object.mnemonic_type = options.enums === String ? $root.BackupType[message.mnemonic_type] : message.mnemonic_type;
        if (message.layout_lines && message.layout_lines.length) {
            object.layout_lines = [];
            for (var j = 0; j < message.layout_lines.length; ++j)
                object.layout_lines[j] = message.layout_lines[j];
        }
        return object;
    };

    DebugLinkState.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DebugLinkState;
})();

$root.DebugLinkStop = (function() {

    function DebugLinkStop(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DebugLinkStop.create = function create(properties) {
        return new DebugLinkStop(properties);
    };

    DebugLinkStop.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    DebugLinkStop.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DebugLinkStop.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DebugLinkStop();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    DebugLinkStop.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DebugLinkStop.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    DebugLinkStop.fromObject = function fromObject(object) {
        if (object instanceof $root.DebugLinkStop)
            return object;
        return new $root.DebugLinkStop();
    };

    DebugLinkStop.toObject = function toObject() {
        return {};
    };

    DebugLinkStop.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DebugLinkStop;
})();

$root.DebugLinkLog = (function() {

    function DebugLinkLog(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DebugLinkLog.prototype.level = 0;
    DebugLinkLog.prototype.bucket = "";
    DebugLinkLog.prototype.text = "";

    DebugLinkLog.create = function create(properties) {
        return new DebugLinkLog(properties);
    };

    DebugLinkLog.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.level != null && Object.hasOwnProperty.call(message, "level"))
            writer.uint32(8).uint32(message.level);
        if (message.bucket != null && Object.hasOwnProperty.call(message, "bucket"))
            writer.uint32(18).string(message.bucket);
        if (message.text != null && Object.hasOwnProperty.call(message, "text"))
            writer.uint32(26).string(message.text);
        return writer;
    };

    DebugLinkLog.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DebugLinkLog.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DebugLinkLog();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.level = reader.uint32();
                break;
            case 2:
                message.bucket = reader.string();
                break;
            case 3:
                message.text = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    DebugLinkLog.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DebugLinkLog.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.level != null && message.hasOwnProperty("level"))
            if (!$util.isInteger(message.level))
                return "level: integer expected";
        if (message.bucket != null && message.hasOwnProperty("bucket"))
            if (!$util.isString(message.bucket))
                return "bucket: string expected";
        if (message.text != null && message.hasOwnProperty("text"))
            if (!$util.isString(message.text))
                return "text: string expected";
        return null;
    };

    DebugLinkLog.fromObject = function fromObject(object) {
        if (object instanceof $root.DebugLinkLog)
            return object;
        var message = new $root.DebugLinkLog();
        if (object.level != null)
            message.level = object.level >>> 0;
        if (object.bucket != null)
            message.bucket = String(object.bucket);
        if (object.text != null)
            message.text = String(object.text);
        return message;
    };

    DebugLinkLog.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.level = 0;
            object.bucket = "";
            object.text = "";
        }
        if (message.level != null && message.hasOwnProperty("level"))
            object.level = message.level;
        if (message.bucket != null && message.hasOwnProperty("bucket"))
            object.bucket = message.bucket;
        if (message.text != null && message.hasOwnProperty("text"))
            object.text = message.text;
        return object;
    };

    DebugLinkLog.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DebugLinkLog;
})();

$root.DebugLinkMemoryRead = (function() {

    function DebugLinkMemoryRead(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DebugLinkMemoryRead.prototype.address = 0;
    DebugLinkMemoryRead.prototype.length = 0;

    DebugLinkMemoryRead.create = function create(properties) {
        return new DebugLinkMemoryRead(properties);
    };

    DebugLinkMemoryRead.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address != null && Object.hasOwnProperty.call(message, "address"))
            writer.uint32(8).uint32(message.address);
        if (message.length != null && Object.hasOwnProperty.call(message, "length"))
            writer.uint32(16).uint32(message.length);
        return writer;
    };

    DebugLinkMemoryRead.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DebugLinkMemoryRead.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DebugLinkMemoryRead();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.uint32();
                break;
            case 2:
                message.length = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    DebugLinkMemoryRead.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DebugLinkMemoryRead.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address != null && message.hasOwnProperty("address"))
            if (!$util.isInteger(message.address))
                return "address: integer expected";
        if (message.length != null && message.hasOwnProperty("length"))
            if (!$util.isInteger(message.length))
                return "length: integer expected";
        return null;
    };

    DebugLinkMemoryRead.fromObject = function fromObject(object) {
        if (object instanceof $root.DebugLinkMemoryRead)
            return object;
        var message = new $root.DebugLinkMemoryRead();
        if (object.address != null)
            message.address = object.address >>> 0;
        if (object.length != null)
            message.length = object.length >>> 0;
        return message;
    };

    DebugLinkMemoryRead.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.address = 0;
            object.length = 0;
        }
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        if (message.length != null && message.hasOwnProperty("length"))
            object.length = message.length;
        return object;
    };

    DebugLinkMemoryRead.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DebugLinkMemoryRead;
})();

$root.DebugLinkMemory = (function() {

    function DebugLinkMemory(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DebugLinkMemory.prototype.memory = $util.newBuffer([]);

    DebugLinkMemory.create = function create(properties) {
        return new DebugLinkMemory(properties);
    };

    DebugLinkMemory.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.memory != null && Object.hasOwnProperty.call(message, "memory"))
            writer.uint32(10).bytes(message.memory);
        return writer;
    };

    DebugLinkMemory.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DebugLinkMemory.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DebugLinkMemory();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.memory = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    DebugLinkMemory.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DebugLinkMemory.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.memory != null && message.hasOwnProperty("memory"))
            if (!(message.memory && typeof message.memory.length === "number" || $util.isString(message.memory)))
                return "memory: buffer expected";
        return null;
    };

    DebugLinkMemory.fromObject = function fromObject(object) {
        if (object instanceof $root.DebugLinkMemory)
            return object;
        var message = new $root.DebugLinkMemory();
        if (object.memory != null)
            if (typeof object.memory === "string")
                $util.base64.decode(object.memory, message.memory = $util.newBuffer($util.base64.length(object.memory)), 0);
            else if (object.memory.length)
                message.memory = object.memory;
        return message;
    };

    DebugLinkMemory.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.memory = "";
            else {
                object.memory = [];
                if (options.bytes !== Array)
                    object.memory = $util.newBuffer(object.memory);
            }
        if (message.memory != null && message.hasOwnProperty("memory"))
            object.memory = options.bytes === String ? $util.base64.encode(message.memory, 0, message.memory.length) : options.bytes === Array ? Array.prototype.slice.call(message.memory) : message.memory;
        return object;
    };

    DebugLinkMemory.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DebugLinkMemory;
})();

$root.DebugLinkMemoryWrite = (function() {

    function DebugLinkMemoryWrite(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DebugLinkMemoryWrite.prototype.address = 0;
    DebugLinkMemoryWrite.prototype.memory = $util.newBuffer([]);
    DebugLinkMemoryWrite.prototype.flash = false;

    DebugLinkMemoryWrite.create = function create(properties) {
        return new DebugLinkMemoryWrite(properties);
    };

    DebugLinkMemoryWrite.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address != null && Object.hasOwnProperty.call(message, "address"))
            writer.uint32(8).uint32(message.address);
        if (message.memory != null && Object.hasOwnProperty.call(message, "memory"))
            writer.uint32(18).bytes(message.memory);
        if (message.flash != null && Object.hasOwnProperty.call(message, "flash"))
            writer.uint32(24).bool(message.flash);
        return writer;
    };

    DebugLinkMemoryWrite.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DebugLinkMemoryWrite.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DebugLinkMemoryWrite();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.uint32();
                break;
            case 2:
                message.memory = reader.bytes();
                break;
            case 3:
                message.flash = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    DebugLinkMemoryWrite.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DebugLinkMemoryWrite.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address != null && message.hasOwnProperty("address"))
            if (!$util.isInteger(message.address))
                return "address: integer expected";
        if (message.memory != null && message.hasOwnProperty("memory"))
            if (!(message.memory && typeof message.memory.length === "number" || $util.isString(message.memory)))
                return "memory: buffer expected";
        if (message.flash != null && message.hasOwnProperty("flash"))
            if (typeof message.flash !== "boolean")
                return "flash: boolean expected";
        return null;
    };

    DebugLinkMemoryWrite.fromObject = function fromObject(object) {
        if (object instanceof $root.DebugLinkMemoryWrite)
            return object;
        var message = new $root.DebugLinkMemoryWrite();
        if (object.address != null)
            message.address = object.address >>> 0;
        if (object.memory != null)
            if (typeof object.memory === "string")
                $util.base64.decode(object.memory, message.memory = $util.newBuffer($util.base64.length(object.memory)), 0);
            else if (object.memory.length)
                message.memory = object.memory;
        if (object.flash != null)
            message.flash = Boolean(object.flash);
        return message;
    };

    DebugLinkMemoryWrite.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.address = 0;
            if (options.bytes === String)
                object.memory = "";
            else {
                object.memory = [];
                if (options.bytes !== Array)
                    object.memory = $util.newBuffer(object.memory);
            }
            object.flash = false;
        }
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        if (message.memory != null && message.hasOwnProperty("memory"))
            object.memory = options.bytes === String ? $util.base64.encode(message.memory, 0, message.memory.length) : options.bytes === Array ? Array.prototype.slice.call(message.memory) : message.memory;
        if (message.flash != null && message.hasOwnProperty("flash"))
            object.flash = message.flash;
        return object;
    };

    DebugLinkMemoryWrite.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DebugLinkMemoryWrite;
})();

$root.DebugLinkFlashErase = (function() {

    function DebugLinkFlashErase(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DebugLinkFlashErase.prototype.sector = 0;

    DebugLinkFlashErase.create = function create(properties) {
        return new DebugLinkFlashErase(properties);
    };

    DebugLinkFlashErase.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.sector != null && Object.hasOwnProperty.call(message, "sector"))
            writer.uint32(8).uint32(message.sector);
        return writer;
    };

    DebugLinkFlashErase.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DebugLinkFlashErase.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DebugLinkFlashErase();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.sector = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    DebugLinkFlashErase.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DebugLinkFlashErase.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.sector != null && message.hasOwnProperty("sector"))
            if (!$util.isInteger(message.sector))
                return "sector: integer expected";
        return null;
    };

    DebugLinkFlashErase.fromObject = function fromObject(object) {
        if (object instanceof $root.DebugLinkFlashErase)
            return object;
        var message = new $root.DebugLinkFlashErase();
        if (object.sector != null)
            message.sector = object.sector >>> 0;
        return message;
    };

    DebugLinkFlashErase.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.sector = 0;
        if (message.sector != null && message.hasOwnProperty("sector"))
            object.sector = message.sector;
        return object;
    };

    DebugLinkFlashErase.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DebugLinkFlashErase;
})();

$root.DebugLinkEraseSdCard = (function() {

    function DebugLinkEraseSdCard(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DebugLinkEraseSdCard.prototype.format = false;

    DebugLinkEraseSdCard.create = function create(properties) {
        return new DebugLinkEraseSdCard(properties);
    };

    DebugLinkEraseSdCard.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.format != null && Object.hasOwnProperty.call(message, "format"))
            writer.uint32(8).bool(message.format);
        return writer;
    };

    DebugLinkEraseSdCard.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DebugLinkEraseSdCard.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DebugLinkEraseSdCard();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.format = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    DebugLinkEraseSdCard.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DebugLinkEraseSdCard.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.format != null && message.hasOwnProperty("format"))
            if (typeof message.format !== "boolean")
                return "format: boolean expected";
        return null;
    };

    DebugLinkEraseSdCard.fromObject = function fromObject(object) {
        if (object instanceof $root.DebugLinkEraseSdCard)
            return object;
        var message = new $root.DebugLinkEraseSdCard();
        if (object.format != null)
            message.format = Boolean(object.format);
        return message;
    };

    DebugLinkEraseSdCard.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.format = false;
        if (message.format != null && message.hasOwnProperty("format"))
            object.format = message.format;
        return object;
    };

    DebugLinkEraseSdCard.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DebugLinkEraseSdCard;
})();

$root.DebugLinkWatchLayout = (function() {

    function DebugLinkWatchLayout(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DebugLinkWatchLayout.prototype.watch = false;

    DebugLinkWatchLayout.create = function create(properties) {
        return new DebugLinkWatchLayout(properties);
    };

    DebugLinkWatchLayout.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.watch != null && Object.hasOwnProperty.call(message, "watch"))
            writer.uint32(8).bool(message.watch);
        return writer;
    };

    DebugLinkWatchLayout.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DebugLinkWatchLayout.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DebugLinkWatchLayout();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.watch = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    DebugLinkWatchLayout.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DebugLinkWatchLayout.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.watch != null && message.hasOwnProperty("watch"))
            if (typeof message.watch !== "boolean")
                return "watch: boolean expected";
        return null;
    };

    DebugLinkWatchLayout.fromObject = function fromObject(object) {
        if (object instanceof $root.DebugLinkWatchLayout)
            return object;
        var message = new $root.DebugLinkWatchLayout();
        if (object.watch != null)
            message.watch = Boolean(object.watch);
        return message;
    };

    DebugLinkWatchLayout.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.watch = false;
        if (message.watch != null && message.hasOwnProperty("watch"))
            object.watch = message.watch;
        return object;
    };

    DebugLinkWatchLayout.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DebugLinkWatchLayout;
})();

$root.DnxGetAddress = (function() {

    function DnxGetAddress(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DnxGetAddress.prototype.address_n = $util.emptyArray;
    DnxGetAddress.prototype.show_display = false;

    DnxGetAddress.create = function create(properties) {
        return new DnxGetAddress(properties);
    };

    DnxGetAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(16).bool(message.show_display);
        return writer;
    };

    DnxGetAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DnxGetAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DnxGetAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.show_display = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    DnxGetAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DnxGetAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        return null;
    };

    DnxGetAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.DnxGetAddress)
            return object;
        var message = new $root.DnxGetAddress();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".DnxGetAddress.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        return message;
    };

    DnxGetAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            object.show_display = false;
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        return object;
    };

    DnxGetAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DnxGetAddress;
})();

$root.DnxAddress = (function() {

    function DnxAddress(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DnxAddress.prototype.address = "";

    DnxAddress.create = function create(properties) {
        return new DnxAddress(properties);
    };

    DnxAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address != null && Object.hasOwnProperty.call(message, "address"))
            writer.uint32(10).string(message.address);
        return writer;
    };

    DnxAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DnxAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DnxAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    DnxAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DnxAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address != null && message.hasOwnProperty("address"))
            if (!$util.isString(message.address))
                return "address: string expected";
        return null;
    };

    DnxAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.DnxAddress)
            return object;
        var message = new $root.DnxAddress();
        if (object.address != null)
            message.address = String(object.address);
        return message;
    };

    DnxAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.address = "";
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    DnxAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DnxAddress;
})();

$root.DnxSignTx = (function() {

    function DnxSignTx(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DnxSignTx.prototype.address_n = $util.emptyArray;
    DnxSignTx.prototype.inputs_count = 0;
    DnxSignTx.prototype.to_address = "";
    DnxSignTx.prototype.amount = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    DnxSignTx.prototype.fee = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    DnxSignTx.prototype.payment_id = $util.newBuffer([]);

    DnxSignTx.create = function create(properties) {
        return new DnxSignTx(properties);
    };

    DnxSignTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(16).uint32(message.inputs_count);
        writer.uint32(26).string(message.to_address);
        writer.uint32(32).uint64(message.amount);
        writer.uint32(40).uint64(message.fee);
        if (message.payment_id != null && Object.hasOwnProperty.call(message, "payment_id"))
            writer.uint32(50).bytes(message.payment_id);
        return writer;
    };

    DnxSignTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DnxSignTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DnxSignTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.inputs_count = reader.uint32();
                break;
            case 3:
                message.to_address = reader.string();
                break;
            case 4:
                message.amount = reader.uint64();
                break;
            case 5:
                message.fee = reader.uint64();
                break;
            case 6:
                message.payment_id = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("inputs_count"))
            throw $util.ProtocolError("missing required 'inputs_count'", { instance: message });
        if (!message.hasOwnProperty("to_address"))
            throw $util.ProtocolError("missing required 'to_address'", { instance: message });
        if (!message.hasOwnProperty("amount"))
            throw $util.ProtocolError("missing required 'amount'", { instance: message });
        if (!message.hasOwnProperty("fee"))
            throw $util.ProtocolError("missing required 'fee'", { instance: message });
        return message;
    };

    DnxSignTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DnxSignTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!$util.isInteger(message.inputs_count))
            return "inputs_count: integer expected";
        if (!$util.isString(message.to_address))
            return "to_address: string expected";
        if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
            return "amount: integer|Long expected";
        if (!$util.isInteger(message.fee) && !(message.fee && $util.isInteger(message.fee.low) && $util.isInteger(message.fee.high)))
            return "fee: integer|Long expected";
        if (message.payment_id != null && message.hasOwnProperty("payment_id"))
            if (!(message.payment_id && typeof message.payment_id.length === "number" || $util.isString(message.payment_id)))
                return "payment_id: buffer expected";
        return null;
    };

    DnxSignTx.fromObject = function fromObject(object) {
        if (object instanceof $root.DnxSignTx)
            return object;
        var message = new $root.DnxSignTx();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".DnxSignTx.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.inputs_count != null)
            message.inputs_count = object.inputs_count >>> 0;
        if (object.to_address != null)
            message.to_address = String(object.to_address);
        if (object.amount != null)
            if ($util.Long)
                (message.amount = $util.Long.fromValue(object.amount)).unsigned = true;
            else if (typeof object.amount === "string")
                message.amount = parseInt(object.amount, 10);
            else if (typeof object.amount === "number")
                message.amount = object.amount;
            else if (typeof object.amount === "object")
                message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber(true);
        if (object.fee != null)
            if ($util.Long)
                (message.fee = $util.Long.fromValue(object.fee)).unsigned = true;
            else if (typeof object.fee === "string")
                message.fee = parseInt(object.fee, 10);
            else if (typeof object.fee === "number")
                message.fee = object.fee;
            else if (typeof object.fee === "object")
                message.fee = new $util.LongBits(object.fee.low >>> 0, object.fee.high >>> 0).toNumber(true);
        if (object.payment_id != null)
            if (typeof object.payment_id === "string")
                $util.base64.decode(object.payment_id, message.payment_id = $util.newBuffer($util.base64.length(object.payment_id)), 0);
            else if (object.payment_id.length)
                message.payment_id = object.payment_id;
        return message;
    };

    DnxSignTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            object.inputs_count = 0;
            object.to_address = "";
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.amount = options.longs === String ? "0" : 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.fee = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.fee = options.longs === String ? "0" : 0;
            if (options.bytes === String)
                object.payment_id = "";
            else {
                object.payment_id = [];
                if (options.bytes !== Array)
                    object.payment_id = $util.newBuffer(object.payment_id);
            }
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.inputs_count != null && message.hasOwnProperty("inputs_count"))
            object.inputs_count = message.inputs_count;
        if (message.to_address != null && message.hasOwnProperty("to_address"))
            object.to_address = message.to_address;
        if (message.amount != null && message.hasOwnProperty("amount"))
            if (typeof message.amount === "number")
                object.amount = options.longs === String ? String(message.amount) : message.amount;
            else
                object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber(true) : message.amount;
        if (message.fee != null && message.hasOwnProperty("fee"))
            if (typeof message.fee === "number")
                object.fee = options.longs === String ? String(message.fee) : message.fee;
            else
                object.fee = options.longs === String ? $util.Long.prototype.toString.call(message.fee) : options.longs === Number ? new $util.LongBits(message.fee.low >>> 0, message.fee.high >>> 0).toNumber(true) : message.fee;
        if (message.payment_id != null && message.hasOwnProperty("payment_id"))
            object.payment_id = options.bytes === String ? $util.base64.encode(message.payment_id, 0, message.payment_id.length) : options.bytes === Array ? Array.prototype.slice.call(message.payment_id) : message.payment_id;
        return object;
    };

    DnxSignTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DnxSignTx;
})();

$root.DnxInputRequest = (function() {

    function DnxInputRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DnxInputRequest.prototype.request_index = 0;
    DnxInputRequest.prototype.tx_key = null;
    DnxInputRequest.prototype.computed_key_image = null;

    DnxInputRequest.create = function create(properties) {
        return new DnxInputRequest(properties);
    };

    DnxInputRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.request_index != null && Object.hasOwnProperty.call(message, "request_index"))
            writer.uint32(8).uint32(message.request_index);
        if (message.tx_key != null && Object.hasOwnProperty.call(message, "tx_key"))
            $root.DnxInputRequest.DnxTxKey.encode(message.tx_key, writer.uint32(18).fork()).ldelim();
        if (message.computed_key_image != null && Object.hasOwnProperty.call(message, "computed_key_image"))
            $root.DnxInputRequest.DnxComputedKeyImage.encode(message.computed_key_image, writer.uint32(26).fork()).ldelim();
        return writer;
    };

    DnxInputRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DnxInputRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DnxInputRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.request_index = reader.uint32();
                break;
            case 2:
                message.tx_key = $root.DnxInputRequest.DnxTxKey.decode(reader, reader.uint32());
                break;
            case 3:
                message.computed_key_image = $root.DnxInputRequest.DnxComputedKeyImage.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    DnxInputRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DnxInputRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.request_index != null && message.hasOwnProperty("request_index"))
            if (!$util.isInteger(message.request_index))
                return "request_index: integer expected";
        if (message.tx_key != null && message.hasOwnProperty("tx_key")) {
            var error = $root.DnxInputRequest.DnxTxKey.verify(message.tx_key);
            if (error)
                return "tx_key." + error;
        }
        if (message.computed_key_image != null && message.hasOwnProperty("computed_key_image")) {
            var error = $root.DnxInputRequest.DnxComputedKeyImage.verify(message.computed_key_image);
            if (error)
                return "computed_key_image." + error;
        }
        return null;
    };

    DnxInputRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.DnxInputRequest)
            return object;
        var message = new $root.DnxInputRequest();
        if (object.request_index != null)
            message.request_index = object.request_index >>> 0;
        if (object.tx_key != null) {
            if (typeof object.tx_key !== "object")
                throw TypeError(".DnxInputRequest.tx_key: object expected");
            message.tx_key = $root.DnxInputRequest.DnxTxKey.fromObject(object.tx_key);
        }
        if (object.computed_key_image != null) {
            if (typeof object.computed_key_image !== "object")
                throw TypeError(".DnxInputRequest.computed_key_image: object expected");
            message.computed_key_image = $root.DnxInputRequest.DnxComputedKeyImage.fromObject(object.computed_key_image);
        }
        return message;
    };

    DnxInputRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.request_index = 0;
            object.tx_key = null;
            object.computed_key_image = null;
        }
        if (message.request_index != null && message.hasOwnProperty("request_index"))
            object.request_index = message.request_index;
        if (message.tx_key != null && message.hasOwnProperty("tx_key"))
            object.tx_key = $root.DnxInputRequest.DnxTxKey.toObject(message.tx_key, options);
        if (message.computed_key_image != null && message.hasOwnProperty("computed_key_image"))
            object.computed_key_image = $root.DnxInputRequest.DnxComputedKeyImage.toObject(message.computed_key_image, options);
        return object;
    };

    DnxInputRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    DnxInputRequest.DnxTxKey = (function() {

        function DnxTxKey(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        DnxTxKey.prototype.ephemeral_tx_sec_key = $util.newBuffer([]);
        DnxTxKey.prototype.ephemeral_tx_pub_key = $util.newBuffer([]);

        DnxTxKey.create = function create(properties) {
            return new DnxTxKey(properties);
        };

        DnxTxKey.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.ephemeral_tx_sec_key != null && Object.hasOwnProperty.call(message, "ephemeral_tx_sec_key"))
                writer.uint32(10).bytes(message.ephemeral_tx_sec_key);
            if (message.ephemeral_tx_pub_key != null && Object.hasOwnProperty.call(message, "ephemeral_tx_pub_key"))
                writer.uint32(18).bytes(message.ephemeral_tx_pub_key);
            return writer;
        };

        DnxTxKey.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        DnxTxKey.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DnxInputRequest.DnxTxKey();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.ephemeral_tx_sec_key = reader.bytes();
                    break;
                case 2:
                    message.ephemeral_tx_pub_key = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        DnxTxKey.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        DnxTxKey.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.ephemeral_tx_sec_key != null && message.hasOwnProperty("ephemeral_tx_sec_key"))
                if (!(message.ephemeral_tx_sec_key && typeof message.ephemeral_tx_sec_key.length === "number" || $util.isString(message.ephemeral_tx_sec_key)))
                    return "ephemeral_tx_sec_key: buffer expected";
            if (message.ephemeral_tx_pub_key != null && message.hasOwnProperty("ephemeral_tx_pub_key"))
                if (!(message.ephemeral_tx_pub_key && typeof message.ephemeral_tx_pub_key.length === "number" || $util.isString(message.ephemeral_tx_pub_key)))
                    return "ephemeral_tx_pub_key: buffer expected";
            return null;
        };

        DnxTxKey.fromObject = function fromObject(object) {
            if (object instanceof $root.DnxInputRequest.DnxTxKey)
                return object;
            var message = new $root.DnxInputRequest.DnxTxKey();
            if (object.ephemeral_tx_sec_key != null)
                if (typeof object.ephemeral_tx_sec_key === "string")
                    $util.base64.decode(object.ephemeral_tx_sec_key, message.ephemeral_tx_sec_key = $util.newBuffer($util.base64.length(object.ephemeral_tx_sec_key)), 0);
                else if (object.ephemeral_tx_sec_key.length)
                    message.ephemeral_tx_sec_key = object.ephemeral_tx_sec_key;
            if (object.ephemeral_tx_pub_key != null)
                if (typeof object.ephemeral_tx_pub_key === "string")
                    $util.base64.decode(object.ephemeral_tx_pub_key, message.ephemeral_tx_pub_key = $util.newBuffer($util.base64.length(object.ephemeral_tx_pub_key)), 0);
                else if (object.ephemeral_tx_pub_key.length)
                    message.ephemeral_tx_pub_key = object.ephemeral_tx_pub_key;
            return message;
        };

        DnxTxKey.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if (options.bytes === String)
                    object.ephemeral_tx_sec_key = "";
                else {
                    object.ephemeral_tx_sec_key = [];
                    if (options.bytes !== Array)
                        object.ephemeral_tx_sec_key = $util.newBuffer(object.ephemeral_tx_sec_key);
                }
                if (options.bytes === String)
                    object.ephemeral_tx_pub_key = "";
                else {
                    object.ephemeral_tx_pub_key = [];
                    if (options.bytes !== Array)
                        object.ephemeral_tx_pub_key = $util.newBuffer(object.ephemeral_tx_pub_key);
                }
            }
            if (message.ephemeral_tx_sec_key != null && message.hasOwnProperty("ephemeral_tx_sec_key"))
                object.ephemeral_tx_sec_key = options.bytes === String ? $util.base64.encode(message.ephemeral_tx_sec_key, 0, message.ephemeral_tx_sec_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.ephemeral_tx_sec_key) : message.ephemeral_tx_sec_key;
            if (message.ephemeral_tx_pub_key != null && message.hasOwnProperty("ephemeral_tx_pub_key"))
                object.ephemeral_tx_pub_key = options.bytes === String ? $util.base64.encode(message.ephemeral_tx_pub_key, 0, message.ephemeral_tx_pub_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.ephemeral_tx_pub_key) : message.ephemeral_tx_pub_key;
            return object;
        };

        DnxTxKey.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return DnxTxKey;
    })();

    DnxInputRequest.DnxComputedKeyImage = (function() {

        function DnxComputedKeyImage(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        DnxComputedKeyImage.prototype.key_image = $util.newBuffer([]);

        DnxComputedKeyImage.create = function create(properties) {
            return new DnxComputedKeyImage(properties);
        };

        DnxComputedKeyImage.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.key_image != null && Object.hasOwnProperty.call(message, "key_image"))
                writer.uint32(10).bytes(message.key_image);
            return writer;
        };

        DnxComputedKeyImage.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        DnxComputedKeyImage.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DnxInputRequest.DnxComputedKeyImage();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.key_image = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        DnxComputedKeyImage.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        DnxComputedKeyImage.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.key_image != null && message.hasOwnProperty("key_image"))
                if (!(message.key_image && typeof message.key_image.length === "number" || $util.isString(message.key_image)))
                    return "key_image: buffer expected";
            return null;
        };

        DnxComputedKeyImage.fromObject = function fromObject(object) {
            if (object instanceof $root.DnxInputRequest.DnxComputedKeyImage)
                return object;
            var message = new $root.DnxInputRequest.DnxComputedKeyImage();
            if (object.key_image != null)
                if (typeof object.key_image === "string")
                    $util.base64.decode(object.key_image, message.key_image = $util.newBuffer($util.base64.length(object.key_image)), 0);
                else if (object.key_image.length)
                    message.key_image = object.key_image;
            return message;
        };

        DnxComputedKeyImage.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                if (options.bytes === String)
                    object.key_image = "";
                else {
                    object.key_image = [];
                    if (options.bytes !== Array)
                        object.key_image = $util.newBuffer(object.key_image);
                }
            if (message.key_image != null && message.hasOwnProperty("key_image"))
                object.key_image = options.bytes === String ? $util.base64.encode(message.key_image, 0, message.key_image.length) : options.bytes === Array ? Array.prototype.slice.call(message.key_image) : message.key_image;
            return object;
        };

        DnxComputedKeyImage.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return DnxComputedKeyImage;
    })();

    return DnxInputRequest;
})();

$root.DnxInputAck = (function() {

    function DnxInputAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DnxInputAck.prototype.prev_index = 0;
    DnxInputAck.prototype.global_index = 0;
    DnxInputAck.prototype.tx_pubkey = $util.newBuffer([]);
    DnxInputAck.prototype.prev_out_pubkey = $util.newBuffer([]);
    DnxInputAck.prototype.amount = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    DnxInputAck.create = function create(properties) {
        return new DnxInputAck(properties);
    };

    DnxInputAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).uint32(message.prev_index);
        writer.uint32(16).uint32(message.global_index);
        writer.uint32(26).bytes(message.tx_pubkey);
        writer.uint32(34).bytes(message.prev_out_pubkey);
        writer.uint32(40).uint64(message.amount);
        return writer;
    };

    DnxInputAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DnxInputAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DnxInputAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.prev_index = reader.uint32();
                break;
            case 2:
                message.global_index = reader.uint32();
                break;
            case 3:
                message.tx_pubkey = reader.bytes();
                break;
            case 4:
                message.prev_out_pubkey = reader.bytes();
                break;
            case 5:
                message.amount = reader.uint64();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("prev_index"))
            throw $util.ProtocolError("missing required 'prev_index'", { instance: message });
        if (!message.hasOwnProperty("global_index"))
            throw $util.ProtocolError("missing required 'global_index'", { instance: message });
        if (!message.hasOwnProperty("tx_pubkey"))
            throw $util.ProtocolError("missing required 'tx_pubkey'", { instance: message });
        if (!message.hasOwnProperty("prev_out_pubkey"))
            throw $util.ProtocolError("missing required 'prev_out_pubkey'", { instance: message });
        if (!message.hasOwnProperty("amount"))
            throw $util.ProtocolError("missing required 'amount'", { instance: message });
        return message;
    };

    DnxInputAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DnxInputAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isInteger(message.prev_index))
            return "prev_index: integer expected";
        if (!$util.isInteger(message.global_index))
            return "global_index: integer expected";
        if (!(message.tx_pubkey && typeof message.tx_pubkey.length === "number" || $util.isString(message.tx_pubkey)))
            return "tx_pubkey: buffer expected";
        if (!(message.prev_out_pubkey && typeof message.prev_out_pubkey.length === "number" || $util.isString(message.prev_out_pubkey)))
            return "prev_out_pubkey: buffer expected";
        if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
            return "amount: integer|Long expected";
        return null;
    };

    DnxInputAck.fromObject = function fromObject(object) {
        if (object instanceof $root.DnxInputAck)
            return object;
        var message = new $root.DnxInputAck();
        if (object.prev_index != null)
            message.prev_index = object.prev_index >>> 0;
        if (object.global_index != null)
            message.global_index = object.global_index >>> 0;
        if (object.tx_pubkey != null)
            if (typeof object.tx_pubkey === "string")
                $util.base64.decode(object.tx_pubkey, message.tx_pubkey = $util.newBuffer($util.base64.length(object.tx_pubkey)), 0);
            else if (object.tx_pubkey.length)
                message.tx_pubkey = object.tx_pubkey;
        if (object.prev_out_pubkey != null)
            if (typeof object.prev_out_pubkey === "string")
                $util.base64.decode(object.prev_out_pubkey, message.prev_out_pubkey = $util.newBuffer($util.base64.length(object.prev_out_pubkey)), 0);
            else if (object.prev_out_pubkey.length)
                message.prev_out_pubkey = object.prev_out_pubkey;
        if (object.amount != null)
            if ($util.Long)
                (message.amount = $util.Long.fromValue(object.amount)).unsigned = true;
            else if (typeof object.amount === "string")
                message.amount = parseInt(object.amount, 10);
            else if (typeof object.amount === "number")
                message.amount = object.amount;
            else if (typeof object.amount === "object")
                message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber(true);
        return message;
    };

    DnxInputAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.prev_index = 0;
            object.global_index = 0;
            if (options.bytes === String)
                object.tx_pubkey = "";
            else {
                object.tx_pubkey = [];
                if (options.bytes !== Array)
                    object.tx_pubkey = $util.newBuffer(object.tx_pubkey);
            }
            if (options.bytes === String)
                object.prev_out_pubkey = "";
            else {
                object.prev_out_pubkey = [];
                if (options.bytes !== Array)
                    object.prev_out_pubkey = $util.newBuffer(object.prev_out_pubkey);
            }
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.amount = options.longs === String ? "0" : 0;
        }
        if (message.prev_index != null && message.hasOwnProperty("prev_index"))
            object.prev_index = message.prev_index;
        if (message.global_index != null && message.hasOwnProperty("global_index"))
            object.global_index = message.global_index;
        if (message.tx_pubkey != null && message.hasOwnProperty("tx_pubkey"))
            object.tx_pubkey = options.bytes === String ? $util.base64.encode(message.tx_pubkey, 0, message.tx_pubkey.length) : options.bytes === Array ? Array.prototype.slice.call(message.tx_pubkey) : message.tx_pubkey;
        if (message.prev_out_pubkey != null && message.hasOwnProperty("prev_out_pubkey"))
            object.prev_out_pubkey = options.bytes === String ? $util.base64.encode(message.prev_out_pubkey, 0, message.prev_out_pubkey.length) : options.bytes === Array ? Array.prototype.slice.call(message.prev_out_pubkey) : message.prev_out_pubkey;
        if (message.amount != null && message.hasOwnProperty("amount"))
            if (typeof message.amount === "number")
                object.amount = options.longs === String ? String(message.amount) : message.amount;
            else
                object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber(true) : message.amount;
        return object;
    };

    DnxInputAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DnxInputAck;
})();

$root.DnxRTSigsRequest = (function() {

    function DnxRTSigsRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DnxRTSigsRequest.create = function create(properties) {
        return new DnxRTSigsRequest(properties);
    };

    DnxRTSigsRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    DnxRTSigsRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DnxRTSigsRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DnxRTSigsRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    DnxRTSigsRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DnxRTSigsRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    DnxRTSigsRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.DnxRTSigsRequest)
            return object;
        return new $root.DnxRTSigsRequest();
    };

    DnxRTSigsRequest.toObject = function toObject() {
        return {};
    };

    DnxRTSigsRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DnxRTSigsRequest;
})();

$root.DnxSignedTx = (function() {

    function DnxSignedTx(properties) {
        this.signatures = [];
        this.output_keys = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DnxSignedTx.prototype.signatures = $util.emptyArray;
    DnxSignedTx.prototype.output_keys = $util.emptyArray;

    DnxSignedTx.create = function create(properties) {
        return new DnxSignedTx(properties);
    };

    DnxSignedTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.signatures != null && message.signatures.length)
            for (var i = 0; i < message.signatures.length; ++i)
                writer.uint32(10).bytes(message.signatures[i]);
        if (message.output_keys != null && message.output_keys.length)
            for (var i = 0; i < message.output_keys.length; ++i)
                writer.uint32(18).bytes(message.output_keys[i]);
        return writer;
    };

    DnxSignedTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DnxSignedTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DnxSignedTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.signatures && message.signatures.length))
                    message.signatures = [];
                message.signatures.push(reader.bytes());
                break;
            case 2:
                if (!(message.output_keys && message.output_keys.length))
                    message.output_keys = [];
                message.output_keys.push(reader.bytes());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    DnxSignedTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DnxSignedTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.signatures != null && message.hasOwnProperty("signatures")) {
            if (!Array.isArray(message.signatures))
                return "signatures: array expected";
            for (var i = 0; i < message.signatures.length; ++i)
                if (!(message.signatures[i] && typeof message.signatures[i].length === "number" || $util.isString(message.signatures[i])))
                    return "signatures: buffer[] expected";
        }
        if (message.output_keys != null && message.hasOwnProperty("output_keys")) {
            if (!Array.isArray(message.output_keys))
                return "output_keys: array expected";
            for (var i = 0; i < message.output_keys.length; ++i)
                if (!(message.output_keys[i] && typeof message.output_keys[i].length === "number" || $util.isString(message.output_keys[i])))
                    return "output_keys: buffer[] expected";
        }
        return null;
    };

    DnxSignedTx.fromObject = function fromObject(object) {
        if (object instanceof $root.DnxSignedTx)
            return object;
        var message = new $root.DnxSignedTx();
        if (object.signatures) {
            if (!Array.isArray(object.signatures))
                throw TypeError(".DnxSignedTx.signatures: array expected");
            message.signatures = [];
            for (var i = 0; i < object.signatures.length; ++i)
                if (typeof object.signatures[i] === "string")
                    $util.base64.decode(object.signatures[i], message.signatures[i] = $util.newBuffer($util.base64.length(object.signatures[i])), 0);
                else if (object.signatures[i].length)
                    message.signatures[i] = object.signatures[i];
        }
        if (object.output_keys) {
            if (!Array.isArray(object.output_keys))
                throw TypeError(".DnxSignedTx.output_keys: array expected");
            message.output_keys = [];
            for (var i = 0; i < object.output_keys.length; ++i)
                if (typeof object.output_keys[i] === "string")
                    $util.base64.decode(object.output_keys[i], message.output_keys[i] = $util.newBuffer($util.base64.length(object.output_keys[i])), 0);
                else if (object.output_keys[i].length)
                    message.output_keys[i] = object.output_keys[i];
        }
        return message;
    };

    DnxSignedTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults) {
            object.signatures = [];
            object.output_keys = [];
        }
        if (message.signatures && message.signatures.length) {
            object.signatures = [];
            for (var j = 0; j < message.signatures.length; ++j)
                object.signatures[j] = options.bytes === String ? $util.base64.encode(message.signatures[j], 0, message.signatures[j].length) : options.bytes === Array ? Array.prototype.slice.call(message.signatures[j]) : message.signatures[j];
        }
        if (message.output_keys && message.output_keys.length) {
            object.output_keys = [];
            for (var j = 0; j < message.output_keys.length; ++j)
                object.output_keys[j] = options.bytes === String ? $util.base64.encode(message.output_keys[j], 0, message.output_keys[j].length) : options.bytes === Array ? Array.prototype.slice.call(message.output_keys[j]) : message.output_keys[j];
        }
        return object;
    };

    DnxSignedTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DnxSignedTx;
})();

$root.EmmcFixPermission = (function() {

    function EmmcFixPermission(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EmmcFixPermission.create = function create(properties) {
        return new EmmcFixPermission(properties);
    };

    EmmcFixPermission.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    EmmcFixPermission.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EmmcFixPermission.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EmmcFixPermission();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    EmmcFixPermission.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EmmcFixPermission.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    EmmcFixPermission.fromObject = function fromObject(object) {
        if (object instanceof $root.EmmcFixPermission)
            return object;
        return new $root.EmmcFixPermission();
    };

    EmmcFixPermission.toObject = function toObject() {
        return {};
    };

    EmmcFixPermission.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EmmcFixPermission;
})();

$root.EmmcPath = (function() {

    function EmmcPath(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EmmcPath.prototype.exist = false;
    EmmcPath.prototype.size = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    EmmcPath.prototype.year = 0;
    EmmcPath.prototype.month = 0;
    EmmcPath.prototype.day = 0;
    EmmcPath.prototype.hour = 0;
    EmmcPath.prototype.minute = 0;
    EmmcPath.prototype.second = 0;
    EmmcPath.prototype.readonly = false;
    EmmcPath.prototype.hidden = false;
    EmmcPath.prototype.system = false;
    EmmcPath.prototype.archive = false;
    EmmcPath.prototype.directory = false;

    EmmcPath.create = function create(properties) {
        return new EmmcPath(properties);
    };

    EmmcPath.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).bool(message.exist);
        writer.uint32(16).uint64(message.size);
        writer.uint32(24).uint32(message.year);
        writer.uint32(32).uint32(message.month);
        writer.uint32(40).uint32(message.day);
        writer.uint32(48).uint32(message.hour);
        writer.uint32(56).uint32(message.minute);
        writer.uint32(64).uint32(message.second);
        writer.uint32(72).bool(message.readonly);
        writer.uint32(80).bool(message.hidden);
        writer.uint32(88).bool(message.system);
        writer.uint32(96).bool(message.archive);
        writer.uint32(104).bool(message.directory);
        return writer;
    };

    EmmcPath.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EmmcPath.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EmmcPath();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.exist = reader.bool();
                break;
            case 2:
                message.size = reader.uint64();
                break;
            case 3:
                message.year = reader.uint32();
                break;
            case 4:
                message.month = reader.uint32();
                break;
            case 5:
                message.day = reader.uint32();
                break;
            case 6:
                message.hour = reader.uint32();
                break;
            case 7:
                message.minute = reader.uint32();
                break;
            case 8:
                message.second = reader.uint32();
                break;
            case 9:
                message.readonly = reader.bool();
                break;
            case 10:
                message.hidden = reader.bool();
                break;
            case 11:
                message.system = reader.bool();
                break;
            case 12:
                message.archive = reader.bool();
                break;
            case 13:
                message.directory = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("exist"))
            throw $util.ProtocolError("missing required 'exist'", { instance: message });
        if (!message.hasOwnProperty("size"))
            throw $util.ProtocolError("missing required 'size'", { instance: message });
        if (!message.hasOwnProperty("year"))
            throw $util.ProtocolError("missing required 'year'", { instance: message });
        if (!message.hasOwnProperty("month"))
            throw $util.ProtocolError("missing required 'month'", { instance: message });
        if (!message.hasOwnProperty("day"))
            throw $util.ProtocolError("missing required 'day'", { instance: message });
        if (!message.hasOwnProperty("hour"))
            throw $util.ProtocolError("missing required 'hour'", { instance: message });
        if (!message.hasOwnProperty("minute"))
            throw $util.ProtocolError("missing required 'minute'", { instance: message });
        if (!message.hasOwnProperty("second"))
            throw $util.ProtocolError("missing required 'second'", { instance: message });
        if (!message.hasOwnProperty("readonly"))
            throw $util.ProtocolError("missing required 'readonly'", { instance: message });
        if (!message.hasOwnProperty("hidden"))
            throw $util.ProtocolError("missing required 'hidden'", { instance: message });
        if (!message.hasOwnProperty("system"))
            throw $util.ProtocolError("missing required 'system'", { instance: message });
        if (!message.hasOwnProperty("archive"))
            throw $util.ProtocolError("missing required 'archive'", { instance: message });
        if (!message.hasOwnProperty("directory"))
            throw $util.ProtocolError("missing required 'directory'", { instance: message });
        return message;
    };

    EmmcPath.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EmmcPath.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (typeof message.exist !== "boolean")
            return "exist: boolean expected";
        if (!$util.isInteger(message.size) && !(message.size && $util.isInteger(message.size.low) && $util.isInteger(message.size.high)))
            return "size: integer|Long expected";
        if (!$util.isInteger(message.year))
            return "year: integer expected";
        if (!$util.isInteger(message.month))
            return "month: integer expected";
        if (!$util.isInteger(message.day))
            return "day: integer expected";
        if (!$util.isInteger(message.hour))
            return "hour: integer expected";
        if (!$util.isInteger(message.minute))
            return "minute: integer expected";
        if (!$util.isInteger(message.second))
            return "second: integer expected";
        if (typeof message.readonly !== "boolean")
            return "readonly: boolean expected";
        if (typeof message.hidden !== "boolean")
            return "hidden: boolean expected";
        if (typeof message.system !== "boolean")
            return "system: boolean expected";
        if (typeof message.archive !== "boolean")
            return "archive: boolean expected";
        if (typeof message.directory !== "boolean")
            return "directory: boolean expected";
        return null;
    };

    EmmcPath.fromObject = function fromObject(object) {
        if (object instanceof $root.EmmcPath)
            return object;
        var message = new $root.EmmcPath();
        if (object.exist != null)
            message.exist = Boolean(object.exist);
        if (object.size != null)
            if ($util.Long)
                (message.size = $util.Long.fromValue(object.size)).unsigned = true;
            else if (typeof object.size === "string")
                message.size = parseInt(object.size, 10);
            else if (typeof object.size === "number")
                message.size = object.size;
            else if (typeof object.size === "object")
                message.size = new $util.LongBits(object.size.low >>> 0, object.size.high >>> 0).toNumber(true);
        if (object.year != null)
            message.year = object.year >>> 0;
        if (object.month != null)
            message.month = object.month >>> 0;
        if (object.day != null)
            message.day = object.day >>> 0;
        if (object.hour != null)
            message.hour = object.hour >>> 0;
        if (object.minute != null)
            message.minute = object.minute >>> 0;
        if (object.second != null)
            message.second = object.second >>> 0;
        if (object.readonly != null)
            message.readonly = Boolean(object.readonly);
        if (object.hidden != null)
            message.hidden = Boolean(object.hidden);
        if (object.system != null)
            message.system = Boolean(object.system);
        if (object.archive != null)
            message.archive = Boolean(object.archive);
        if (object.directory != null)
            message.directory = Boolean(object.directory);
        return message;
    };

    EmmcPath.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.exist = false;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.size = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.size = options.longs === String ? "0" : 0;
            object.year = 0;
            object.month = 0;
            object.day = 0;
            object.hour = 0;
            object.minute = 0;
            object.second = 0;
            object.readonly = false;
            object.hidden = false;
            object.system = false;
            object.archive = false;
            object.directory = false;
        }
        if (message.exist != null && message.hasOwnProperty("exist"))
            object.exist = message.exist;
        if (message.size != null && message.hasOwnProperty("size"))
            if (typeof message.size === "number")
                object.size = options.longs === String ? String(message.size) : message.size;
            else
                object.size = options.longs === String ? $util.Long.prototype.toString.call(message.size) : options.longs === Number ? new $util.LongBits(message.size.low >>> 0, message.size.high >>> 0).toNumber(true) : message.size;
        if (message.year != null && message.hasOwnProperty("year"))
            object.year = message.year;
        if (message.month != null && message.hasOwnProperty("month"))
            object.month = message.month;
        if (message.day != null && message.hasOwnProperty("day"))
            object.day = message.day;
        if (message.hour != null && message.hasOwnProperty("hour"))
            object.hour = message.hour;
        if (message.minute != null && message.hasOwnProperty("minute"))
            object.minute = message.minute;
        if (message.second != null && message.hasOwnProperty("second"))
            object.second = message.second;
        if (message.readonly != null && message.hasOwnProperty("readonly"))
            object.readonly = message.readonly;
        if (message.hidden != null && message.hasOwnProperty("hidden"))
            object.hidden = message.hidden;
        if (message.system != null && message.hasOwnProperty("system"))
            object.system = message.system;
        if (message.archive != null && message.hasOwnProperty("archive"))
            object.archive = message.archive;
        if (message.directory != null && message.hasOwnProperty("directory"))
            object.directory = message.directory;
        return object;
    };

    EmmcPath.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EmmcPath;
})();

$root.EmmcPathInfo = (function() {

    function EmmcPathInfo(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EmmcPathInfo.prototype.path = "";

    EmmcPathInfo.create = function create(properties) {
        return new EmmcPathInfo(properties);
    };

    EmmcPathInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.path);
        return writer;
    };

    EmmcPathInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EmmcPathInfo.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EmmcPathInfo();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.path = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("path"))
            throw $util.ProtocolError("missing required 'path'", { instance: message });
        return message;
    };

    EmmcPathInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EmmcPathInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.path))
            return "path: string expected";
        return null;
    };

    EmmcPathInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.EmmcPathInfo)
            return object;
        var message = new $root.EmmcPathInfo();
        if (object.path != null)
            message.path = String(object.path);
        return message;
    };

    EmmcPathInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.path = "";
        if (message.path != null && message.hasOwnProperty("path"))
            object.path = message.path;
        return object;
    };

    EmmcPathInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EmmcPathInfo;
})();

$root.EmmcFile = (function() {

    function EmmcFile(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EmmcFile.prototype.path = "";
    EmmcFile.prototype.offset = 0;
    EmmcFile.prototype.len = 0;
    EmmcFile.prototype.data = $util.newBuffer([]);
    EmmcFile.prototype.data_hash = 0;
    EmmcFile.prototype.processed_byte = 0;

    EmmcFile.create = function create(properties) {
        return new EmmcFile(properties);
    };

    EmmcFile.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.path);
        writer.uint32(16).uint32(message.offset);
        writer.uint32(24).uint32(message.len);
        if (message.data != null && Object.hasOwnProperty.call(message, "data"))
            writer.uint32(34).bytes(message.data);
        if (message.data_hash != null && Object.hasOwnProperty.call(message, "data_hash"))
            writer.uint32(40).uint32(message.data_hash);
        if (message.processed_byte != null && Object.hasOwnProperty.call(message, "processed_byte"))
            writer.uint32(48).uint32(message.processed_byte);
        return writer;
    };

    EmmcFile.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EmmcFile.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EmmcFile();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.path = reader.string();
                break;
            case 2:
                message.offset = reader.uint32();
                break;
            case 3:
                message.len = reader.uint32();
                break;
            case 4:
                message.data = reader.bytes();
                break;
            case 5:
                message.data_hash = reader.uint32();
                break;
            case 6:
                message.processed_byte = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("path"))
            throw $util.ProtocolError("missing required 'path'", { instance: message });
        if (!message.hasOwnProperty("offset"))
            throw $util.ProtocolError("missing required 'offset'", { instance: message });
        if (!message.hasOwnProperty("len"))
            throw $util.ProtocolError("missing required 'len'", { instance: message });
        return message;
    };

    EmmcFile.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EmmcFile.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.path))
            return "path: string expected";
        if (!$util.isInteger(message.offset))
            return "offset: integer expected";
        if (!$util.isInteger(message.len))
            return "len: integer expected";
        if (message.data != null && message.hasOwnProperty("data"))
            if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
                return "data: buffer expected";
        if (message.data_hash != null && message.hasOwnProperty("data_hash"))
            if (!$util.isInteger(message.data_hash))
                return "data_hash: integer expected";
        if (message.processed_byte != null && message.hasOwnProperty("processed_byte"))
            if (!$util.isInteger(message.processed_byte))
                return "processed_byte: integer expected";
        return null;
    };

    EmmcFile.fromObject = function fromObject(object) {
        if (object instanceof $root.EmmcFile)
            return object;
        var message = new $root.EmmcFile();
        if (object.path != null)
            message.path = String(object.path);
        if (object.offset != null)
            message.offset = object.offset >>> 0;
        if (object.len != null)
            message.len = object.len >>> 0;
        if (object.data != null)
            if (typeof object.data === "string")
                $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
            else if (object.data.length)
                message.data = object.data;
        if (object.data_hash != null)
            message.data_hash = object.data_hash >>> 0;
        if (object.processed_byte != null)
            message.processed_byte = object.processed_byte >>> 0;
        return message;
    };

    EmmcFile.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.path = "";
            object.offset = 0;
            object.len = 0;
            if (options.bytes === String)
                object.data = "";
            else {
                object.data = [];
                if (options.bytes !== Array)
                    object.data = $util.newBuffer(object.data);
            }
            object.data_hash = 0;
            object.processed_byte = 0;
        }
        if (message.path != null && message.hasOwnProperty("path"))
            object.path = message.path;
        if (message.offset != null && message.hasOwnProperty("offset"))
            object.offset = message.offset;
        if (message.len != null && message.hasOwnProperty("len"))
            object.len = message.len;
        if (message.data != null && message.hasOwnProperty("data"))
            object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
        if (message.data_hash != null && message.hasOwnProperty("data_hash"))
            object.data_hash = message.data_hash;
        if (message.processed_byte != null && message.hasOwnProperty("processed_byte"))
            object.processed_byte = message.processed_byte;
        return object;
    };

    EmmcFile.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EmmcFile;
})();

$root.EmmcFileRead = (function() {

    function EmmcFileRead(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EmmcFileRead.prototype.file = null;
    EmmcFileRead.prototype.ui_percentage = 0;

    EmmcFileRead.create = function create(properties) {
        return new EmmcFileRead(properties);
    };

    EmmcFileRead.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        $root.EmmcFile.encode(message.file, writer.uint32(10).fork()).ldelim();
        if (message.ui_percentage != null && Object.hasOwnProperty.call(message, "ui_percentage"))
            writer.uint32(16).uint32(message.ui_percentage);
        return writer;
    };

    EmmcFileRead.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EmmcFileRead.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EmmcFileRead();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.file = $root.EmmcFile.decode(reader, reader.uint32());
                break;
            case 2:
                message.ui_percentage = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("file"))
            throw $util.ProtocolError("missing required 'file'", { instance: message });
        return message;
    };

    EmmcFileRead.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EmmcFileRead.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        {
            var error = $root.EmmcFile.verify(message.file);
            if (error)
                return "file." + error;
        }
        if (message.ui_percentage != null && message.hasOwnProperty("ui_percentage"))
            if (!$util.isInteger(message.ui_percentage))
                return "ui_percentage: integer expected";
        return null;
    };

    EmmcFileRead.fromObject = function fromObject(object) {
        if (object instanceof $root.EmmcFileRead)
            return object;
        var message = new $root.EmmcFileRead();
        if (object.file != null) {
            if (typeof object.file !== "object")
                throw TypeError(".EmmcFileRead.file: object expected");
            message.file = $root.EmmcFile.fromObject(object.file);
        }
        if (object.ui_percentage != null)
            message.ui_percentage = object.ui_percentage >>> 0;
        return message;
    };

    EmmcFileRead.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.file = null;
            object.ui_percentage = 0;
        }
        if (message.file != null && message.hasOwnProperty("file"))
            object.file = $root.EmmcFile.toObject(message.file, options);
        if (message.ui_percentage != null && message.hasOwnProperty("ui_percentage"))
            object.ui_percentage = message.ui_percentage;
        return object;
    };

    EmmcFileRead.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EmmcFileRead;
})();

$root.EmmcFileWrite = (function() {

    function EmmcFileWrite(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EmmcFileWrite.prototype.file = null;
    EmmcFileWrite.prototype.overwrite = false;
    EmmcFileWrite.prototype.append = false;
    EmmcFileWrite.prototype.ui_percentage = 0;

    EmmcFileWrite.create = function create(properties) {
        return new EmmcFileWrite(properties);
    };

    EmmcFileWrite.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        $root.EmmcFile.encode(message.file, writer.uint32(10).fork()).ldelim();
        writer.uint32(16).bool(message.overwrite);
        writer.uint32(24).bool(message.append);
        if (message.ui_percentage != null && Object.hasOwnProperty.call(message, "ui_percentage"))
            writer.uint32(32).uint32(message.ui_percentage);
        return writer;
    };

    EmmcFileWrite.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EmmcFileWrite.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EmmcFileWrite();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.file = $root.EmmcFile.decode(reader, reader.uint32());
                break;
            case 2:
                message.overwrite = reader.bool();
                break;
            case 3:
                message.append = reader.bool();
                break;
            case 4:
                message.ui_percentage = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("file"))
            throw $util.ProtocolError("missing required 'file'", { instance: message });
        if (!message.hasOwnProperty("overwrite"))
            throw $util.ProtocolError("missing required 'overwrite'", { instance: message });
        if (!message.hasOwnProperty("append"))
            throw $util.ProtocolError("missing required 'append'", { instance: message });
        return message;
    };

    EmmcFileWrite.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EmmcFileWrite.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        {
            var error = $root.EmmcFile.verify(message.file);
            if (error)
                return "file." + error;
        }
        if (typeof message.overwrite !== "boolean")
            return "overwrite: boolean expected";
        if (typeof message.append !== "boolean")
            return "append: boolean expected";
        if (message.ui_percentage != null && message.hasOwnProperty("ui_percentage"))
            if (!$util.isInteger(message.ui_percentage))
                return "ui_percentage: integer expected";
        return null;
    };

    EmmcFileWrite.fromObject = function fromObject(object) {
        if (object instanceof $root.EmmcFileWrite)
            return object;
        var message = new $root.EmmcFileWrite();
        if (object.file != null) {
            if (typeof object.file !== "object")
                throw TypeError(".EmmcFileWrite.file: object expected");
            message.file = $root.EmmcFile.fromObject(object.file);
        }
        if (object.overwrite != null)
            message.overwrite = Boolean(object.overwrite);
        if (object.append != null)
            message.append = Boolean(object.append);
        if (object.ui_percentage != null)
            message.ui_percentage = object.ui_percentage >>> 0;
        return message;
    };

    EmmcFileWrite.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.file = null;
            object.overwrite = false;
            object.append = false;
            object.ui_percentage = 0;
        }
        if (message.file != null && message.hasOwnProperty("file"))
            object.file = $root.EmmcFile.toObject(message.file, options);
        if (message.overwrite != null && message.hasOwnProperty("overwrite"))
            object.overwrite = message.overwrite;
        if (message.append != null && message.hasOwnProperty("append"))
            object.append = message.append;
        if (message.ui_percentage != null && message.hasOwnProperty("ui_percentage"))
            object.ui_percentage = message.ui_percentage;
        return object;
    };

    EmmcFileWrite.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EmmcFileWrite;
})();

$root.EmmcFileDelete = (function() {

    function EmmcFileDelete(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EmmcFileDelete.prototype.path = "";

    EmmcFileDelete.create = function create(properties) {
        return new EmmcFileDelete(properties);
    };

    EmmcFileDelete.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.path);
        return writer;
    };

    EmmcFileDelete.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EmmcFileDelete.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EmmcFileDelete();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.path = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("path"))
            throw $util.ProtocolError("missing required 'path'", { instance: message });
        return message;
    };

    EmmcFileDelete.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EmmcFileDelete.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.path))
            return "path: string expected";
        return null;
    };

    EmmcFileDelete.fromObject = function fromObject(object) {
        if (object instanceof $root.EmmcFileDelete)
            return object;
        var message = new $root.EmmcFileDelete();
        if (object.path != null)
            message.path = String(object.path);
        return message;
    };

    EmmcFileDelete.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.path = "";
        if (message.path != null && message.hasOwnProperty("path"))
            object.path = message.path;
        return object;
    };

    EmmcFileDelete.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EmmcFileDelete;
})();

$root.EmmcDir = (function() {

    function EmmcDir(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EmmcDir.prototype.path = "";
    EmmcDir.prototype.child_dirs = "";
    EmmcDir.prototype.child_files = "";

    EmmcDir.create = function create(properties) {
        return new EmmcDir(properties);
    };

    EmmcDir.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.path);
        if (message.child_dirs != null && Object.hasOwnProperty.call(message, "child_dirs"))
            writer.uint32(18).string(message.child_dirs);
        if (message.child_files != null && Object.hasOwnProperty.call(message, "child_files"))
            writer.uint32(26).string(message.child_files);
        return writer;
    };

    EmmcDir.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EmmcDir.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EmmcDir();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.path = reader.string();
                break;
            case 2:
                message.child_dirs = reader.string();
                break;
            case 3:
                message.child_files = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("path"))
            throw $util.ProtocolError("missing required 'path'", { instance: message });
        return message;
    };

    EmmcDir.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EmmcDir.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.path))
            return "path: string expected";
        if (message.child_dirs != null && message.hasOwnProperty("child_dirs"))
            if (!$util.isString(message.child_dirs))
                return "child_dirs: string expected";
        if (message.child_files != null && message.hasOwnProperty("child_files"))
            if (!$util.isString(message.child_files))
                return "child_files: string expected";
        return null;
    };

    EmmcDir.fromObject = function fromObject(object) {
        if (object instanceof $root.EmmcDir)
            return object;
        var message = new $root.EmmcDir();
        if (object.path != null)
            message.path = String(object.path);
        if (object.child_dirs != null)
            message.child_dirs = String(object.child_dirs);
        if (object.child_files != null)
            message.child_files = String(object.child_files);
        return message;
    };

    EmmcDir.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.path = "";
            object.child_dirs = "";
            object.child_files = "";
        }
        if (message.path != null && message.hasOwnProperty("path"))
            object.path = message.path;
        if (message.child_dirs != null && message.hasOwnProperty("child_dirs"))
            object.child_dirs = message.child_dirs;
        if (message.child_files != null && message.hasOwnProperty("child_files"))
            object.child_files = message.child_files;
        return object;
    };

    EmmcDir.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EmmcDir;
})();

$root.EmmcDirList = (function() {

    function EmmcDirList(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EmmcDirList.prototype.path = "";

    EmmcDirList.create = function create(properties) {
        return new EmmcDirList(properties);
    };

    EmmcDirList.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.path);
        return writer;
    };

    EmmcDirList.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EmmcDirList.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EmmcDirList();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.path = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("path"))
            throw $util.ProtocolError("missing required 'path'", { instance: message });
        return message;
    };

    EmmcDirList.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EmmcDirList.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.path))
            return "path: string expected";
        return null;
    };

    EmmcDirList.fromObject = function fromObject(object) {
        if (object instanceof $root.EmmcDirList)
            return object;
        var message = new $root.EmmcDirList();
        if (object.path != null)
            message.path = String(object.path);
        return message;
    };

    EmmcDirList.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.path = "";
        if (message.path != null && message.hasOwnProperty("path"))
            object.path = message.path;
        return object;
    };

    EmmcDirList.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EmmcDirList;
})();

$root.EmmcDirMake = (function() {

    function EmmcDirMake(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EmmcDirMake.prototype.path = "";

    EmmcDirMake.create = function create(properties) {
        return new EmmcDirMake(properties);
    };

    EmmcDirMake.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.path);
        return writer;
    };

    EmmcDirMake.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EmmcDirMake.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EmmcDirMake();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.path = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("path"))
            throw $util.ProtocolError("missing required 'path'", { instance: message });
        return message;
    };

    EmmcDirMake.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EmmcDirMake.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.path))
            return "path: string expected";
        return null;
    };

    EmmcDirMake.fromObject = function fromObject(object) {
        if (object instanceof $root.EmmcDirMake)
            return object;
        var message = new $root.EmmcDirMake();
        if (object.path != null)
            message.path = String(object.path);
        return message;
    };

    EmmcDirMake.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.path = "";
        if (message.path != null && message.hasOwnProperty("path"))
            object.path = message.path;
        return object;
    };

    EmmcDirMake.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EmmcDirMake;
})();

$root.EmmcDirRemove = (function() {

    function EmmcDirRemove(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EmmcDirRemove.prototype.path = "";

    EmmcDirRemove.create = function create(properties) {
        return new EmmcDirRemove(properties);
    };

    EmmcDirRemove.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.path);
        return writer;
    };

    EmmcDirRemove.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EmmcDirRemove.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EmmcDirRemove();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.path = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("path"))
            throw $util.ProtocolError("missing required 'path'", { instance: message });
        return message;
    };

    EmmcDirRemove.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EmmcDirRemove.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.path))
            return "path: string expected";
        return null;
    };

    EmmcDirRemove.fromObject = function fromObject(object) {
        if (object instanceof $root.EmmcDirRemove)
            return object;
        var message = new $root.EmmcDirRemove();
        if (object.path != null)
            message.path = String(object.path);
        return message;
    };

    EmmcDirRemove.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.path = "";
        if (message.path != null && message.hasOwnProperty("path"))
            object.path = message.path;
        return object;
    };

    EmmcDirRemove.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EmmcDirRemove;
})();

$root.EosGetPublicKey = (function() {

    function EosGetPublicKey(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EosGetPublicKey.prototype.address_n = $util.emptyArray;
    EosGetPublicKey.prototype.show_display = false;

    EosGetPublicKey.create = function create(properties) {
        return new EosGetPublicKey(properties);
    };

    EosGetPublicKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(16).bool(message.show_display);
        return writer;
    };

    EosGetPublicKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EosGetPublicKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EosGetPublicKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.show_display = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    EosGetPublicKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EosGetPublicKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        return null;
    };

    EosGetPublicKey.fromObject = function fromObject(object) {
        if (object instanceof $root.EosGetPublicKey)
            return object;
        var message = new $root.EosGetPublicKey();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".EosGetPublicKey.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        return message;
    };

    EosGetPublicKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            object.show_display = false;
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        return object;
    };

    EosGetPublicKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EosGetPublicKey;
})();

$root.EosPublicKey = (function() {

    function EosPublicKey(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EosPublicKey.prototype.wif_public_key = "";
    EosPublicKey.prototype.raw_public_key = $util.newBuffer([]);

    EosPublicKey.create = function create(properties) {
        return new EosPublicKey(properties);
    };

    EosPublicKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.wif_public_key);
        writer.uint32(18).bytes(message.raw_public_key);
        return writer;
    };

    EosPublicKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EosPublicKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EosPublicKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.wif_public_key = reader.string();
                break;
            case 2:
                message.raw_public_key = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("wif_public_key"))
            throw $util.ProtocolError("missing required 'wif_public_key'", { instance: message });
        if (!message.hasOwnProperty("raw_public_key"))
            throw $util.ProtocolError("missing required 'raw_public_key'", { instance: message });
        return message;
    };

    EosPublicKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EosPublicKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.wif_public_key))
            return "wif_public_key: string expected";
        if (!(message.raw_public_key && typeof message.raw_public_key.length === "number" || $util.isString(message.raw_public_key)))
            return "raw_public_key: buffer expected";
        return null;
    };

    EosPublicKey.fromObject = function fromObject(object) {
        if (object instanceof $root.EosPublicKey)
            return object;
        var message = new $root.EosPublicKey();
        if (object.wif_public_key != null)
            message.wif_public_key = String(object.wif_public_key);
        if (object.raw_public_key != null)
            if (typeof object.raw_public_key === "string")
                $util.base64.decode(object.raw_public_key, message.raw_public_key = $util.newBuffer($util.base64.length(object.raw_public_key)), 0);
            else if (object.raw_public_key.length)
                message.raw_public_key = object.raw_public_key;
        return message;
    };

    EosPublicKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.wif_public_key = "";
            if (options.bytes === String)
                object.raw_public_key = "";
            else {
                object.raw_public_key = [];
                if (options.bytes !== Array)
                    object.raw_public_key = $util.newBuffer(object.raw_public_key);
            }
        }
        if (message.wif_public_key != null && message.hasOwnProperty("wif_public_key"))
            object.wif_public_key = message.wif_public_key;
        if (message.raw_public_key != null && message.hasOwnProperty("raw_public_key"))
            object.raw_public_key = options.bytes === String ? $util.base64.encode(message.raw_public_key, 0, message.raw_public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.raw_public_key) : message.raw_public_key;
        return object;
    };

    EosPublicKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EosPublicKey;
})();

$root.EosSignTx = (function() {

    function EosSignTx(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EosSignTx.prototype.address_n = $util.emptyArray;
    EosSignTx.prototype.chain_id = $util.newBuffer([]);
    EosSignTx.prototype.header = null;
    EosSignTx.prototype.num_actions = 0;

    EosSignTx.create = function create(properties) {
        return new EosSignTx(properties);
    };

    EosSignTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.chain_id != null && Object.hasOwnProperty.call(message, "chain_id"))
            writer.uint32(18).bytes(message.chain_id);
        if (message.header != null && Object.hasOwnProperty.call(message, "header"))
            $root.EosSignTx.EosTxHeader.encode(message.header, writer.uint32(26).fork()).ldelim();
        if (message.num_actions != null && Object.hasOwnProperty.call(message, "num_actions"))
            writer.uint32(32).uint32(message.num_actions);
        return writer;
    };

    EosSignTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EosSignTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EosSignTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.chain_id = reader.bytes();
                break;
            case 3:
                message.header = $root.EosSignTx.EosTxHeader.decode(reader, reader.uint32());
                break;
            case 4:
                message.num_actions = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    EosSignTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EosSignTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.chain_id != null && message.hasOwnProperty("chain_id"))
            if (!(message.chain_id && typeof message.chain_id.length === "number" || $util.isString(message.chain_id)))
                return "chain_id: buffer expected";
        if (message.header != null && message.hasOwnProperty("header")) {
            var error = $root.EosSignTx.EosTxHeader.verify(message.header);
            if (error)
                return "header." + error;
        }
        if (message.num_actions != null && message.hasOwnProperty("num_actions"))
            if (!$util.isInteger(message.num_actions))
                return "num_actions: integer expected";
        return null;
    };

    EosSignTx.fromObject = function fromObject(object) {
        if (object instanceof $root.EosSignTx)
            return object;
        var message = new $root.EosSignTx();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".EosSignTx.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.chain_id != null)
            if (typeof object.chain_id === "string")
                $util.base64.decode(object.chain_id, message.chain_id = $util.newBuffer($util.base64.length(object.chain_id)), 0);
            else if (object.chain_id.length)
                message.chain_id = object.chain_id;
        if (object.header != null) {
            if (typeof object.header !== "object")
                throw TypeError(".EosSignTx.header: object expected");
            message.header = $root.EosSignTx.EosTxHeader.fromObject(object.header);
        }
        if (object.num_actions != null)
            message.num_actions = object.num_actions >>> 0;
        return message;
    };

    EosSignTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            if (options.bytes === String)
                object.chain_id = "";
            else {
                object.chain_id = [];
                if (options.bytes !== Array)
                    object.chain_id = $util.newBuffer(object.chain_id);
            }
            object.header = null;
            object.num_actions = 0;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.chain_id != null && message.hasOwnProperty("chain_id"))
            object.chain_id = options.bytes === String ? $util.base64.encode(message.chain_id, 0, message.chain_id.length) : options.bytes === Array ? Array.prototype.slice.call(message.chain_id) : message.chain_id;
        if (message.header != null && message.hasOwnProperty("header"))
            object.header = $root.EosSignTx.EosTxHeader.toObject(message.header, options);
        if (message.num_actions != null && message.hasOwnProperty("num_actions"))
            object.num_actions = message.num_actions;
        return object;
    };

    EosSignTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    EosSignTx.EosTxHeader = (function() {

        function EosTxHeader(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        EosTxHeader.prototype.expiration = 0;
        EosTxHeader.prototype.ref_block_num = 0;
        EosTxHeader.prototype.ref_block_prefix = 0;
        EosTxHeader.prototype.max_net_usage_words = 0;
        EosTxHeader.prototype.max_cpu_usage_ms = 0;
        EosTxHeader.prototype.delay_sec = 0;

        EosTxHeader.create = function create(properties) {
            return new EosTxHeader(properties);
        };

        EosTxHeader.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(8).uint32(message.expiration);
            writer.uint32(16).uint32(message.ref_block_num);
            writer.uint32(24).uint32(message.ref_block_prefix);
            writer.uint32(32).uint32(message.max_net_usage_words);
            writer.uint32(40).uint32(message.max_cpu_usage_ms);
            writer.uint32(48).uint32(message.delay_sec);
            return writer;
        };

        EosTxHeader.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        EosTxHeader.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EosSignTx.EosTxHeader();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.expiration = reader.uint32();
                    break;
                case 2:
                    message.ref_block_num = reader.uint32();
                    break;
                case 3:
                    message.ref_block_prefix = reader.uint32();
                    break;
                case 4:
                    message.max_net_usage_words = reader.uint32();
                    break;
                case 5:
                    message.max_cpu_usage_ms = reader.uint32();
                    break;
                case 6:
                    message.delay_sec = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("expiration"))
                throw $util.ProtocolError("missing required 'expiration'", { instance: message });
            if (!message.hasOwnProperty("ref_block_num"))
                throw $util.ProtocolError("missing required 'ref_block_num'", { instance: message });
            if (!message.hasOwnProperty("ref_block_prefix"))
                throw $util.ProtocolError("missing required 'ref_block_prefix'", { instance: message });
            if (!message.hasOwnProperty("max_net_usage_words"))
                throw $util.ProtocolError("missing required 'max_net_usage_words'", { instance: message });
            if (!message.hasOwnProperty("max_cpu_usage_ms"))
                throw $util.ProtocolError("missing required 'max_cpu_usage_ms'", { instance: message });
            if (!message.hasOwnProperty("delay_sec"))
                throw $util.ProtocolError("missing required 'delay_sec'", { instance: message });
            return message;
        };

        EosTxHeader.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        EosTxHeader.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isInteger(message.expiration))
                return "expiration: integer expected";
            if (!$util.isInteger(message.ref_block_num))
                return "ref_block_num: integer expected";
            if (!$util.isInteger(message.ref_block_prefix))
                return "ref_block_prefix: integer expected";
            if (!$util.isInteger(message.max_net_usage_words))
                return "max_net_usage_words: integer expected";
            if (!$util.isInteger(message.max_cpu_usage_ms))
                return "max_cpu_usage_ms: integer expected";
            if (!$util.isInteger(message.delay_sec))
                return "delay_sec: integer expected";
            return null;
        };

        EosTxHeader.fromObject = function fromObject(object) {
            if (object instanceof $root.EosSignTx.EosTxHeader)
                return object;
            var message = new $root.EosSignTx.EosTxHeader();
            if (object.expiration != null)
                message.expiration = object.expiration >>> 0;
            if (object.ref_block_num != null)
                message.ref_block_num = object.ref_block_num >>> 0;
            if (object.ref_block_prefix != null)
                message.ref_block_prefix = object.ref_block_prefix >>> 0;
            if (object.max_net_usage_words != null)
                message.max_net_usage_words = object.max_net_usage_words >>> 0;
            if (object.max_cpu_usage_ms != null)
                message.max_cpu_usage_ms = object.max_cpu_usage_ms >>> 0;
            if (object.delay_sec != null)
                message.delay_sec = object.delay_sec >>> 0;
            return message;
        };

        EosTxHeader.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.expiration = 0;
                object.ref_block_num = 0;
                object.ref_block_prefix = 0;
                object.max_net_usage_words = 0;
                object.max_cpu_usage_ms = 0;
                object.delay_sec = 0;
            }
            if (message.expiration != null && message.hasOwnProperty("expiration"))
                object.expiration = message.expiration;
            if (message.ref_block_num != null && message.hasOwnProperty("ref_block_num"))
                object.ref_block_num = message.ref_block_num;
            if (message.ref_block_prefix != null && message.hasOwnProperty("ref_block_prefix"))
                object.ref_block_prefix = message.ref_block_prefix;
            if (message.max_net_usage_words != null && message.hasOwnProperty("max_net_usage_words"))
                object.max_net_usage_words = message.max_net_usage_words;
            if (message.max_cpu_usage_ms != null && message.hasOwnProperty("max_cpu_usage_ms"))
                object.max_cpu_usage_ms = message.max_cpu_usage_ms;
            if (message.delay_sec != null && message.hasOwnProperty("delay_sec"))
                object.delay_sec = message.delay_sec;
            return object;
        };

        EosTxHeader.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EosTxHeader;
    })();

    return EosSignTx;
})();

$root.EosTxActionRequest = (function() {

    function EosTxActionRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EosTxActionRequest.prototype.data_size = 0;

    EosTxActionRequest.create = function create(properties) {
        return new EosTxActionRequest(properties);
    };

    EosTxActionRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.data_size != null && Object.hasOwnProperty.call(message, "data_size"))
            writer.uint32(8).uint32(message.data_size);
        return writer;
    };

    EosTxActionRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EosTxActionRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EosTxActionRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.data_size = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    EosTxActionRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EosTxActionRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.data_size != null && message.hasOwnProperty("data_size"))
            if (!$util.isInteger(message.data_size))
                return "data_size: integer expected";
        return null;
    };

    EosTxActionRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.EosTxActionRequest)
            return object;
        var message = new $root.EosTxActionRequest();
        if (object.data_size != null)
            message.data_size = object.data_size >>> 0;
        return message;
    };

    EosTxActionRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.data_size = 0;
        if (message.data_size != null && message.hasOwnProperty("data_size"))
            object.data_size = message.data_size;
        return object;
    };

    EosTxActionRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EosTxActionRequest;
})();

$root.EosTxActionAck = (function() {

    function EosTxActionAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EosTxActionAck.prototype.common = null;
    EosTxActionAck.prototype.transfer = null;
    EosTxActionAck.prototype.delegate = null;
    EosTxActionAck.prototype.undelegate = null;
    EosTxActionAck.prototype.refund = null;
    EosTxActionAck.prototype.buy_ram = null;
    EosTxActionAck.prototype.buy_ram_bytes = null;
    EosTxActionAck.prototype.sell_ram = null;
    EosTxActionAck.prototype.vote_producer = null;
    EosTxActionAck.prototype.update_auth = null;
    EosTxActionAck.prototype.delete_auth = null;
    EosTxActionAck.prototype.link_auth = null;
    EosTxActionAck.prototype.unlink_auth = null;
    EosTxActionAck.prototype.new_account = null;
    EosTxActionAck.prototype.unknown = null;

    EosTxActionAck.create = function create(properties) {
        return new EosTxActionAck(properties);
    };

    EosTxActionAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.common != null && Object.hasOwnProperty.call(message, "common"))
            $root.EosTxActionAck.EosActionCommon.encode(message.common, writer.uint32(10).fork()).ldelim();
        if (message.transfer != null && Object.hasOwnProperty.call(message, "transfer"))
            $root.EosTxActionAck.EosActionTransfer.encode(message.transfer, writer.uint32(18).fork()).ldelim();
        if (message.delegate != null && Object.hasOwnProperty.call(message, "delegate"))
            $root.EosTxActionAck.EosActionDelegate.encode(message.delegate, writer.uint32(26).fork()).ldelim();
        if (message.undelegate != null && Object.hasOwnProperty.call(message, "undelegate"))
            $root.EosTxActionAck.EosActionUndelegate.encode(message.undelegate, writer.uint32(34).fork()).ldelim();
        if (message.refund != null && Object.hasOwnProperty.call(message, "refund"))
            $root.EosTxActionAck.EosActionRefund.encode(message.refund, writer.uint32(42).fork()).ldelim();
        if (message.buy_ram != null && Object.hasOwnProperty.call(message, "buy_ram"))
            $root.EosTxActionAck.EosActionBuyRam.encode(message.buy_ram, writer.uint32(50).fork()).ldelim();
        if (message.buy_ram_bytes != null && Object.hasOwnProperty.call(message, "buy_ram_bytes"))
            $root.EosTxActionAck.EosActionBuyRamBytes.encode(message.buy_ram_bytes, writer.uint32(58).fork()).ldelim();
        if (message.sell_ram != null && Object.hasOwnProperty.call(message, "sell_ram"))
            $root.EosTxActionAck.EosActionSellRam.encode(message.sell_ram, writer.uint32(66).fork()).ldelim();
        if (message.vote_producer != null && Object.hasOwnProperty.call(message, "vote_producer"))
            $root.EosTxActionAck.EosActionVoteProducer.encode(message.vote_producer, writer.uint32(74).fork()).ldelim();
        if (message.update_auth != null && Object.hasOwnProperty.call(message, "update_auth"))
            $root.EosTxActionAck.EosActionUpdateAuth.encode(message.update_auth, writer.uint32(82).fork()).ldelim();
        if (message.delete_auth != null && Object.hasOwnProperty.call(message, "delete_auth"))
            $root.EosTxActionAck.EosActionDeleteAuth.encode(message.delete_auth, writer.uint32(90).fork()).ldelim();
        if (message.link_auth != null && Object.hasOwnProperty.call(message, "link_auth"))
            $root.EosTxActionAck.EosActionLinkAuth.encode(message.link_auth, writer.uint32(98).fork()).ldelim();
        if (message.unlink_auth != null && Object.hasOwnProperty.call(message, "unlink_auth"))
            $root.EosTxActionAck.EosActionUnlinkAuth.encode(message.unlink_auth, writer.uint32(106).fork()).ldelim();
        if (message.new_account != null && Object.hasOwnProperty.call(message, "new_account"))
            $root.EosTxActionAck.EosActionNewAccount.encode(message.new_account, writer.uint32(114).fork()).ldelim();
        if (message.unknown != null && Object.hasOwnProperty.call(message, "unknown"))
            $root.EosTxActionAck.EosActionUnknown.encode(message.unknown, writer.uint32(122).fork()).ldelim();
        return writer;
    };

    EosTxActionAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EosTxActionAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EosTxActionAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.common = $root.EosTxActionAck.EosActionCommon.decode(reader, reader.uint32());
                break;
            case 2:
                message.transfer = $root.EosTxActionAck.EosActionTransfer.decode(reader, reader.uint32());
                break;
            case 3:
                message.delegate = $root.EosTxActionAck.EosActionDelegate.decode(reader, reader.uint32());
                break;
            case 4:
                message.undelegate = $root.EosTxActionAck.EosActionUndelegate.decode(reader, reader.uint32());
                break;
            case 5:
                message.refund = $root.EosTxActionAck.EosActionRefund.decode(reader, reader.uint32());
                break;
            case 6:
                message.buy_ram = $root.EosTxActionAck.EosActionBuyRam.decode(reader, reader.uint32());
                break;
            case 7:
                message.buy_ram_bytes = $root.EosTxActionAck.EosActionBuyRamBytes.decode(reader, reader.uint32());
                break;
            case 8:
                message.sell_ram = $root.EosTxActionAck.EosActionSellRam.decode(reader, reader.uint32());
                break;
            case 9:
                message.vote_producer = $root.EosTxActionAck.EosActionVoteProducer.decode(reader, reader.uint32());
                break;
            case 10:
                message.update_auth = $root.EosTxActionAck.EosActionUpdateAuth.decode(reader, reader.uint32());
                break;
            case 11:
                message.delete_auth = $root.EosTxActionAck.EosActionDeleteAuth.decode(reader, reader.uint32());
                break;
            case 12:
                message.link_auth = $root.EosTxActionAck.EosActionLinkAuth.decode(reader, reader.uint32());
                break;
            case 13:
                message.unlink_auth = $root.EosTxActionAck.EosActionUnlinkAuth.decode(reader, reader.uint32());
                break;
            case 14:
                message.new_account = $root.EosTxActionAck.EosActionNewAccount.decode(reader, reader.uint32());
                break;
            case 15:
                message.unknown = $root.EosTxActionAck.EosActionUnknown.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    EosTxActionAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EosTxActionAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.common != null && message.hasOwnProperty("common")) {
            var error = $root.EosTxActionAck.EosActionCommon.verify(message.common);
            if (error)
                return "common." + error;
        }
        if (message.transfer != null && message.hasOwnProperty("transfer")) {
            var error = $root.EosTxActionAck.EosActionTransfer.verify(message.transfer);
            if (error)
                return "transfer." + error;
        }
        if (message.delegate != null && message.hasOwnProperty("delegate")) {
            var error = $root.EosTxActionAck.EosActionDelegate.verify(message.delegate);
            if (error)
                return "delegate." + error;
        }
        if (message.undelegate != null && message.hasOwnProperty("undelegate")) {
            var error = $root.EosTxActionAck.EosActionUndelegate.verify(message.undelegate);
            if (error)
                return "undelegate." + error;
        }
        if (message.refund != null && message.hasOwnProperty("refund")) {
            var error = $root.EosTxActionAck.EosActionRefund.verify(message.refund);
            if (error)
                return "refund." + error;
        }
        if (message.buy_ram != null && message.hasOwnProperty("buy_ram")) {
            var error = $root.EosTxActionAck.EosActionBuyRam.verify(message.buy_ram);
            if (error)
                return "buy_ram." + error;
        }
        if (message.buy_ram_bytes != null && message.hasOwnProperty("buy_ram_bytes")) {
            var error = $root.EosTxActionAck.EosActionBuyRamBytes.verify(message.buy_ram_bytes);
            if (error)
                return "buy_ram_bytes." + error;
        }
        if (message.sell_ram != null && message.hasOwnProperty("sell_ram")) {
            var error = $root.EosTxActionAck.EosActionSellRam.verify(message.sell_ram);
            if (error)
                return "sell_ram." + error;
        }
        if (message.vote_producer != null && message.hasOwnProperty("vote_producer")) {
            var error = $root.EosTxActionAck.EosActionVoteProducer.verify(message.vote_producer);
            if (error)
                return "vote_producer." + error;
        }
        if (message.update_auth != null && message.hasOwnProperty("update_auth")) {
            var error = $root.EosTxActionAck.EosActionUpdateAuth.verify(message.update_auth);
            if (error)
                return "update_auth." + error;
        }
        if (message.delete_auth != null && message.hasOwnProperty("delete_auth")) {
            var error = $root.EosTxActionAck.EosActionDeleteAuth.verify(message.delete_auth);
            if (error)
                return "delete_auth." + error;
        }
        if (message.link_auth != null && message.hasOwnProperty("link_auth")) {
            var error = $root.EosTxActionAck.EosActionLinkAuth.verify(message.link_auth);
            if (error)
                return "link_auth." + error;
        }
        if (message.unlink_auth != null && message.hasOwnProperty("unlink_auth")) {
            var error = $root.EosTxActionAck.EosActionUnlinkAuth.verify(message.unlink_auth);
            if (error)
                return "unlink_auth." + error;
        }
        if (message.new_account != null && message.hasOwnProperty("new_account")) {
            var error = $root.EosTxActionAck.EosActionNewAccount.verify(message.new_account);
            if (error)
                return "new_account." + error;
        }
        if (message.unknown != null && message.hasOwnProperty("unknown")) {
            var error = $root.EosTxActionAck.EosActionUnknown.verify(message.unknown);
            if (error)
                return "unknown." + error;
        }
        return null;
    };

    EosTxActionAck.fromObject = function fromObject(object) {
        if (object instanceof $root.EosTxActionAck)
            return object;
        var message = new $root.EosTxActionAck();
        if (object.common != null) {
            if (typeof object.common !== "object")
                throw TypeError(".EosTxActionAck.common: object expected");
            message.common = $root.EosTxActionAck.EosActionCommon.fromObject(object.common);
        }
        if (object.transfer != null) {
            if (typeof object.transfer !== "object")
                throw TypeError(".EosTxActionAck.transfer: object expected");
            message.transfer = $root.EosTxActionAck.EosActionTransfer.fromObject(object.transfer);
        }
        if (object.delegate != null) {
            if (typeof object.delegate !== "object")
                throw TypeError(".EosTxActionAck.delegate: object expected");
            message.delegate = $root.EosTxActionAck.EosActionDelegate.fromObject(object.delegate);
        }
        if (object.undelegate != null) {
            if (typeof object.undelegate !== "object")
                throw TypeError(".EosTxActionAck.undelegate: object expected");
            message.undelegate = $root.EosTxActionAck.EosActionUndelegate.fromObject(object.undelegate);
        }
        if (object.refund != null) {
            if (typeof object.refund !== "object")
                throw TypeError(".EosTxActionAck.refund: object expected");
            message.refund = $root.EosTxActionAck.EosActionRefund.fromObject(object.refund);
        }
        if (object.buy_ram != null) {
            if (typeof object.buy_ram !== "object")
                throw TypeError(".EosTxActionAck.buy_ram: object expected");
            message.buy_ram = $root.EosTxActionAck.EosActionBuyRam.fromObject(object.buy_ram);
        }
        if (object.buy_ram_bytes != null) {
            if (typeof object.buy_ram_bytes !== "object")
                throw TypeError(".EosTxActionAck.buy_ram_bytes: object expected");
            message.buy_ram_bytes = $root.EosTxActionAck.EosActionBuyRamBytes.fromObject(object.buy_ram_bytes);
        }
        if (object.sell_ram != null) {
            if (typeof object.sell_ram !== "object")
                throw TypeError(".EosTxActionAck.sell_ram: object expected");
            message.sell_ram = $root.EosTxActionAck.EosActionSellRam.fromObject(object.sell_ram);
        }
        if (object.vote_producer != null) {
            if (typeof object.vote_producer !== "object")
                throw TypeError(".EosTxActionAck.vote_producer: object expected");
            message.vote_producer = $root.EosTxActionAck.EosActionVoteProducer.fromObject(object.vote_producer);
        }
        if (object.update_auth != null) {
            if (typeof object.update_auth !== "object")
                throw TypeError(".EosTxActionAck.update_auth: object expected");
            message.update_auth = $root.EosTxActionAck.EosActionUpdateAuth.fromObject(object.update_auth);
        }
        if (object.delete_auth != null) {
            if (typeof object.delete_auth !== "object")
                throw TypeError(".EosTxActionAck.delete_auth: object expected");
            message.delete_auth = $root.EosTxActionAck.EosActionDeleteAuth.fromObject(object.delete_auth);
        }
        if (object.link_auth != null) {
            if (typeof object.link_auth !== "object")
                throw TypeError(".EosTxActionAck.link_auth: object expected");
            message.link_auth = $root.EosTxActionAck.EosActionLinkAuth.fromObject(object.link_auth);
        }
        if (object.unlink_auth != null) {
            if (typeof object.unlink_auth !== "object")
                throw TypeError(".EosTxActionAck.unlink_auth: object expected");
            message.unlink_auth = $root.EosTxActionAck.EosActionUnlinkAuth.fromObject(object.unlink_auth);
        }
        if (object.new_account != null) {
            if (typeof object.new_account !== "object")
                throw TypeError(".EosTxActionAck.new_account: object expected");
            message.new_account = $root.EosTxActionAck.EosActionNewAccount.fromObject(object.new_account);
        }
        if (object.unknown != null) {
            if (typeof object.unknown !== "object")
                throw TypeError(".EosTxActionAck.unknown: object expected");
            message.unknown = $root.EosTxActionAck.EosActionUnknown.fromObject(object.unknown);
        }
        return message;
    };

    EosTxActionAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.common = null;
            object.transfer = null;
            object.delegate = null;
            object.undelegate = null;
            object.refund = null;
            object.buy_ram = null;
            object.buy_ram_bytes = null;
            object.sell_ram = null;
            object.vote_producer = null;
            object.update_auth = null;
            object.delete_auth = null;
            object.link_auth = null;
            object.unlink_auth = null;
            object.new_account = null;
            object.unknown = null;
        }
        if (message.common != null && message.hasOwnProperty("common"))
            object.common = $root.EosTxActionAck.EosActionCommon.toObject(message.common, options);
        if (message.transfer != null && message.hasOwnProperty("transfer"))
            object.transfer = $root.EosTxActionAck.EosActionTransfer.toObject(message.transfer, options);
        if (message.delegate != null && message.hasOwnProperty("delegate"))
            object.delegate = $root.EosTxActionAck.EosActionDelegate.toObject(message.delegate, options);
        if (message.undelegate != null && message.hasOwnProperty("undelegate"))
            object.undelegate = $root.EosTxActionAck.EosActionUndelegate.toObject(message.undelegate, options);
        if (message.refund != null && message.hasOwnProperty("refund"))
            object.refund = $root.EosTxActionAck.EosActionRefund.toObject(message.refund, options);
        if (message.buy_ram != null && message.hasOwnProperty("buy_ram"))
            object.buy_ram = $root.EosTxActionAck.EosActionBuyRam.toObject(message.buy_ram, options);
        if (message.buy_ram_bytes != null && message.hasOwnProperty("buy_ram_bytes"))
            object.buy_ram_bytes = $root.EosTxActionAck.EosActionBuyRamBytes.toObject(message.buy_ram_bytes, options);
        if (message.sell_ram != null && message.hasOwnProperty("sell_ram"))
            object.sell_ram = $root.EosTxActionAck.EosActionSellRam.toObject(message.sell_ram, options);
        if (message.vote_producer != null && message.hasOwnProperty("vote_producer"))
            object.vote_producer = $root.EosTxActionAck.EosActionVoteProducer.toObject(message.vote_producer, options);
        if (message.update_auth != null && message.hasOwnProperty("update_auth"))
            object.update_auth = $root.EosTxActionAck.EosActionUpdateAuth.toObject(message.update_auth, options);
        if (message.delete_auth != null && message.hasOwnProperty("delete_auth"))
            object.delete_auth = $root.EosTxActionAck.EosActionDeleteAuth.toObject(message.delete_auth, options);
        if (message.link_auth != null && message.hasOwnProperty("link_auth"))
            object.link_auth = $root.EosTxActionAck.EosActionLinkAuth.toObject(message.link_auth, options);
        if (message.unlink_auth != null && message.hasOwnProperty("unlink_auth"))
            object.unlink_auth = $root.EosTxActionAck.EosActionUnlinkAuth.toObject(message.unlink_auth, options);
        if (message.new_account != null && message.hasOwnProperty("new_account"))
            object.new_account = $root.EosTxActionAck.EosActionNewAccount.toObject(message.new_account, options);
        if (message.unknown != null && message.hasOwnProperty("unknown"))
            object.unknown = $root.EosTxActionAck.EosActionUnknown.toObject(message.unknown, options);
        return object;
    };

    EosTxActionAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    EosTxActionAck.EosAsset = (function() {

        function EosAsset(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        EosAsset.prototype.amount = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        EosAsset.prototype.symbol = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        EosAsset.create = function create(properties) {
            return new EosAsset(properties);
        };

        EosAsset.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
                writer.uint32(8).sint64(message.amount);
            if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
                writer.uint32(16).uint64(message.symbol);
            return writer;
        };

        EosAsset.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        EosAsset.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EosTxActionAck.EosAsset();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.amount = reader.sint64();
                    break;
                case 2:
                    message.symbol = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        EosAsset.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        EosAsset.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.amount != null && message.hasOwnProperty("amount"))
                if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
                    return "amount: integer|Long expected";
            if (message.symbol != null && message.hasOwnProperty("symbol"))
                if (!$util.isInteger(message.symbol) && !(message.symbol && $util.isInteger(message.symbol.low) && $util.isInteger(message.symbol.high)))
                    return "symbol: integer|Long expected";
            return null;
        };

        EosAsset.fromObject = function fromObject(object) {
            if (object instanceof $root.EosTxActionAck.EosAsset)
                return object;
            var message = new $root.EosTxActionAck.EosAsset();
            if (object.amount != null)
                if ($util.Long)
                    (message.amount = $util.Long.fromValue(object.amount)).unsigned = false;
                else if (typeof object.amount === "string")
                    message.amount = parseInt(object.amount, 10);
                else if (typeof object.amount === "number")
                    message.amount = object.amount;
                else if (typeof object.amount === "object")
                    message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber();
            if (object.symbol != null)
                if ($util.Long)
                    (message.symbol = $util.Long.fromValue(object.symbol)).unsigned = true;
                else if (typeof object.symbol === "string")
                    message.symbol = parseInt(object.symbol, 10);
                else if (typeof object.symbol === "number")
                    message.symbol = object.symbol;
                else if (typeof object.symbol === "object")
                    message.symbol = new $util.LongBits(object.symbol.low >>> 0, object.symbol.high >>> 0).toNumber(true);
            return message;
        };

        EosAsset.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.amount = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.symbol = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.symbol = options.longs === String ? "0" : 0;
            }
            if (message.amount != null && message.hasOwnProperty("amount"))
                if (typeof message.amount === "number")
                    object.amount = options.longs === String ? String(message.amount) : message.amount;
                else
                    object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber() : message.amount;
            if (message.symbol != null && message.hasOwnProperty("symbol"))
                if (typeof message.symbol === "number")
                    object.symbol = options.longs === String ? String(message.symbol) : message.symbol;
                else
                    object.symbol = options.longs === String ? $util.Long.prototype.toString.call(message.symbol) : options.longs === Number ? new $util.LongBits(message.symbol.low >>> 0, message.symbol.high >>> 0).toNumber(true) : message.symbol;
            return object;
        };

        EosAsset.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EosAsset;
    })();

    EosTxActionAck.EosPermissionLevel = (function() {

        function EosPermissionLevel(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        EosPermissionLevel.prototype.actor = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        EosPermissionLevel.prototype.permission = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        EosPermissionLevel.create = function create(properties) {
            return new EosPermissionLevel(properties);
        };

        EosPermissionLevel.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.actor != null && Object.hasOwnProperty.call(message, "actor"))
                writer.uint32(8).uint64(message.actor);
            if (message.permission != null && Object.hasOwnProperty.call(message, "permission"))
                writer.uint32(16).uint64(message.permission);
            return writer;
        };

        EosPermissionLevel.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        EosPermissionLevel.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EosTxActionAck.EosPermissionLevel();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.actor = reader.uint64();
                    break;
                case 2:
                    message.permission = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        EosPermissionLevel.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        EosPermissionLevel.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.actor != null && message.hasOwnProperty("actor"))
                if (!$util.isInteger(message.actor) && !(message.actor && $util.isInteger(message.actor.low) && $util.isInteger(message.actor.high)))
                    return "actor: integer|Long expected";
            if (message.permission != null && message.hasOwnProperty("permission"))
                if (!$util.isInteger(message.permission) && !(message.permission && $util.isInteger(message.permission.low) && $util.isInteger(message.permission.high)))
                    return "permission: integer|Long expected";
            return null;
        };

        EosPermissionLevel.fromObject = function fromObject(object) {
            if (object instanceof $root.EosTxActionAck.EosPermissionLevel)
                return object;
            var message = new $root.EosTxActionAck.EosPermissionLevel();
            if (object.actor != null)
                if ($util.Long)
                    (message.actor = $util.Long.fromValue(object.actor)).unsigned = true;
                else if (typeof object.actor === "string")
                    message.actor = parseInt(object.actor, 10);
                else if (typeof object.actor === "number")
                    message.actor = object.actor;
                else if (typeof object.actor === "object")
                    message.actor = new $util.LongBits(object.actor.low >>> 0, object.actor.high >>> 0).toNumber(true);
            if (object.permission != null)
                if ($util.Long)
                    (message.permission = $util.Long.fromValue(object.permission)).unsigned = true;
                else if (typeof object.permission === "string")
                    message.permission = parseInt(object.permission, 10);
                else if (typeof object.permission === "number")
                    message.permission = object.permission;
                else if (typeof object.permission === "object")
                    message.permission = new $util.LongBits(object.permission.low >>> 0, object.permission.high >>> 0).toNumber(true);
            return message;
        };

        EosPermissionLevel.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.actor = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.actor = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.permission = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.permission = options.longs === String ? "0" : 0;
            }
            if (message.actor != null && message.hasOwnProperty("actor"))
                if (typeof message.actor === "number")
                    object.actor = options.longs === String ? String(message.actor) : message.actor;
                else
                    object.actor = options.longs === String ? $util.Long.prototype.toString.call(message.actor) : options.longs === Number ? new $util.LongBits(message.actor.low >>> 0, message.actor.high >>> 0).toNumber(true) : message.actor;
            if (message.permission != null && message.hasOwnProperty("permission"))
                if (typeof message.permission === "number")
                    object.permission = options.longs === String ? String(message.permission) : message.permission;
                else
                    object.permission = options.longs === String ? $util.Long.prototype.toString.call(message.permission) : options.longs === Number ? new $util.LongBits(message.permission.low >>> 0, message.permission.high >>> 0).toNumber(true) : message.permission;
            return object;
        };

        EosPermissionLevel.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EosPermissionLevel;
    })();

    EosTxActionAck.EosAuthorizationKey = (function() {

        function EosAuthorizationKey(properties) {
            this.address_n = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        EosAuthorizationKey.prototype.type = 0;
        EosAuthorizationKey.prototype.key = $util.newBuffer([]);
        EosAuthorizationKey.prototype.address_n = $util.emptyArray;
        EosAuthorizationKey.prototype.weight = 0;

        EosAuthorizationKey.create = function create(properties) {
            return new EosAuthorizationKey(properties);
        };

        EosAuthorizationKey.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(8).uint32(message.type);
            if (message.key != null && Object.hasOwnProperty.call(message, "key"))
                writer.uint32(18).bytes(message.key);
            if (message.address_n != null && message.address_n.length)
                for (var i = 0; i < message.address_n.length; ++i)
                    writer.uint32(24).uint32(message.address_n[i]);
            writer.uint32(32).uint32(message.weight);
            return writer;
        };

        EosAuthorizationKey.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        EosAuthorizationKey.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EosTxActionAck.EosAuthorizationKey();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.type = reader.uint32();
                    break;
                case 2:
                    message.key = reader.bytes();
                    break;
                case 3:
                    if (!(message.address_n && message.address_n.length))
                        message.address_n = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.address_n.push(reader.uint32());
                    } else
                        message.address_n.push(reader.uint32());
                    break;
                case 4:
                    message.weight = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("type"))
                throw $util.ProtocolError("missing required 'type'", { instance: message });
            if (!message.hasOwnProperty("weight"))
                throw $util.ProtocolError("missing required 'weight'", { instance: message });
            return message;
        };

        EosAuthorizationKey.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        EosAuthorizationKey.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isInteger(message.type))
                return "type: integer expected";
            if (message.key != null && message.hasOwnProperty("key"))
                if (!(message.key && typeof message.key.length === "number" || $util.isString(message.key)))
                    return "key: buffer expected";
            if (message.address_n != null && message.hasOwnProperty("address_n")) {
                if (!Array.isArray(message.address_n))
                    return "address_n: array expected";
                for (var i = 0; i < message.address_n.length; ++i)
                    if (!$util.isInteger(message.address_n[i]))
                        return "address_n: integer[] expected";
            }
            if (!$util.isInteger(message.weight))
                return "weight: integer expected";
            return null;
        };

        EosAuthorizationKey.fromObject = function fromObject(object) {
            if (object instanceof $root.EosTxActionAck.EosAuthorizationKey)
                return object;
            var message = new $root.EosTxActionAck.EosAuthorizationKey();
            if (object.type != null)
                message.type = object.type >>> 0;
            if (object.key != null)
                if (typeof object.key === "string")
                    $util.base64.decode(object.key, message.key = $util.newBuffer($util.base64.length(object.key)), 0);
                else if (object.key.length)
                    message.key = object.key;
            if (object.address_n) {
                if (!Array.isArray(object.address_n))
                    throw TypeError(".EosTxActionAck.EosAuthorizationKey.address_n: array expected");
                message.address_n = [];
                for (var i = 0; i < object.address_n.length; ++i)
                    message.address_n[i] = object.address_n[i] >>> 0;
            }
            if (object.weight != null)
                message.weight = object.weight >>> 0;
            return message;
        };

        EosAuthorizationKey.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.address_n = [];
            if (options.defaults) {
                object.type = 0;
                if (options.bytes === String)
                    object.key = "";
                else {
                    object.key = [];
                    if (options.bytes !== Array)
                        object.key = $util.newBuffer(object.key);
                }
                object.weight = 0;
            }
            if (message.type != null && message.hasOwnProperty("type"))
                object.type = message.type;
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = options.bytes === String ? $util.base64.encode(message.key, 0, message.key.length) : options.bytes === Array ? Array.prototype.slice.call(message.key) : message.key;
            if (message.address_n && message.address_n.length) {
                object.address_n = [];
                for (var j = 0; j < message.address_n.length; ++j)
                    object.address_n[j] = message.address_n[j];
            }
            if (message.weight != null && message.hasOwnProperty("weight"))
                object.weight = message.weight;
            return object;
        };

        EosAuthorizationKey.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EosAuthorizationKey;
    })();

    EosTxActionAck.EosAuthorizationAccount = (function() {

        function EosAuthorizationAccount(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        EosAuthorizationAccount.prototype.account = null;
        EosAuthorizationAccount.prototype.weight = 0;

        EosAuthorizationAccount.create = function create(properties) {
            return new EosAuthorizationAccount(properties);
        };

        EosAuthorizationAccount.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.account != null && Object.hasOwnProperty.call(message, "account"))
                $root.EosTxActionAck.EosPermissionLevel.encode(message.account, writer.uint32(10).fork()).ldelim();
            if (message.weight != null && Object.hasOwnProperty.call(message, "weight"))
                writer.uint32(16).uint32(message.weight);
            return writer;
        };

        EosAuthorizationAccount.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        EosAuthorizationAccount.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EosTxActionAck.EosAuthorizationAccount();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.account = $root.EosTxActionAck.EosPermissionLevel.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.weight = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        EosAuthorizationAccount.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        EosAuthorizationAccount.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.account != null && message.hasOwnProperty("account")) {
                var error = $root.EosTxActionAck.EosPermissionLevel.verify(message.account);
                if (error)
                    return "account." + error;
            }
            if (message.weight != null && message.hasOwnProperty("weight"))
                if (!$util.isInteger(message.weight))
                    return "weight: integer expected";
            return null;
        };

        EosAuthorizationAccount.fromObject = function fromObject(object) {
            if (object instanceof $root.EosTxActionAck.EosAuthorizationAccount)
                return object;
            var message = new $root.EosTxActionAck.EosAuthorizationAccount();
            if (object.account != null) {
                if (typeof object.account !== "object")
                    throw TypeError(".EosTxActionAck.EosAuthorizationAccount.account: object expected");
                message.account = $root.EosTxActionAck.EosPermissionLevel.fromObject(object.account);
            }
            if (object.weight != null)
                message.weight = object.weight >>> 0;
            return message;
        };

        EosAuthorizationAccount.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.account = null;
                object.weight = 0;
            }
            if (message.account != null && message.hasOwnProperty("account"))
                object.account = $root.EosTxActionAck.EosPermissionLevel.toObject(message.account, options);
            if (message.weight != null && message.hasOwnProperty("weight"))
                object.weight = message.weight;
            return object;
        };

        EosAuthorizationAccount.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EosAuthorizationAccount;
    })();

    EosTxActionAck.EosAuthorizationWait = (function() {

        function EosAuthorizationWait(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        EosAuthorizationWait.prototype.wait_sec = 0;
        EosAuthorizationWait.prototype.weight = 0;

        EosAuthorizationWait.create = function create(properties) {
            return new EosAuthorizationWait(properties);
        };

        EosAuthorizationWait.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.wait_sec != null && Object.hasOwnProperty.call(message, "wait_sec"))
                writer.uint32(8).uint32(message.wait_sec);
            if (message.weight != null && Object.hasOwnProperty.call(message, "weight"))
                writer.uint32(16).uint32(message.weight);
            return writer;
        };

        EosAuthorizationWait.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        EosAuthorizationWait.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EosTxActionAck.EosAuthorizationWait();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.wait_sec = reader.uint32();
                    break;
                case 2:
                    message.weight = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        EosAuthorizationWait.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        EosAuthorizationWait.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.wait_sec != null && message.hasOwnProperty("wait_sec"))
                if (!$util.isInteger(message.wait_sec))
                    return "wait_sec: integer expected";
            if (message.weight != null && message.hasOwnProperty("weight"))
                if (!$util.isInteger(message.weight))
                    return "weight: integer expected";
            return null;
        };

        EosAuthorizationWait.fromObject = function fromObject(object) {
            if (object instanceof $root.EosTxActionAck.EosAuthorizationWait)
                return object;
            var message = new $root.EosTxActionAck.EosAuthorizationWait();
            if (object.wait_sec != null)
                message.wait_sec = object.wait_sec >>> 0;
            if (object.weight != null)
                message.weight = object.weight >>> 0;
            return message;
        };

        EosAuthorizationWait.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.wait_sec = 0;
                object.weight = 0;
            }
            if (message.wait_sec != null && message.hasOwnProperty("wait_sec"))
                object.wait_sec = message.wait_sec;
            if (message.weight != null && message.hasOwnProperty("weight"))
                object.weight = message.weight;
            return object;
        };

        EosAuthorizationWait.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EosAuthorizationWait;
    })();

    EosTxActionAck.EosAuthorization = (function() {

        function EosAuthorization(properties) {
            this.keys = [];
            this.accounts = [];
            this.waits = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        EosAuthorization.prototype.threshold = 0;
        EosAuthorization.prototype.keys = $util.emptyArray;
        EosAuthorization.prototype.accounts = $util.emptyArray;
        EosAuthorization.prototype.waits = $util.emptyArray;

        EosAuthorization.create = function create(properties) {
            return new EosAuthorization(properties);
        };

        EosAuthorization.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.threshold != null && Object.hasOwnProperty.call(message, "threshold"))
                writer.uint32(8).uint32(message.threshold);
            if (message.keys != null && message.keys.length)
                for (var i = 0; i < message.keys.length; ++i)
                    $root.EosTxActionAck.EosAuthorizationKey.encode(message.keys[i], writer.uint32(18).fork()).ldelim();
            if (message.accounts != null && message.accounts.length)
                for (var i = 0; i < message.accounts.length; ++i)
                    $root.EosTxActionAck.EosAuthorizationAccount.encode(message.accounts[i], writer.uint32(26).fork()).ldelim();
            if (message.waits != null && message.waits.length)
                for (var i = 0; i < message.waits.length; ++i)
                    $root.EosTxActionAck.EosAuthorizationWait.encode(message.waits[i], writer.uint32(34).fork()).ldelim();
            return writer;
        };

        EosAuthorization.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        EosAuthorization.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EosTxActionAck.EosAuthorization();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.threshold = reader.uint32();
                    break;
                case 2:
                    if (!(message.keys && message.keys.length))
                        message.keys = [];
                    message.keys.push($root.EosTxActionAck.EosAuthorizationKey.decode(reader, reader.uint32()));
                    break;
                case 3:
                    if (!(message.accounts && message.accounts.length))
                        message.accounts = [];
                    message.accounts.push($root.EosTxActionAck.EosAuthorizationAccount.decode(reader, reader.uint32()));
                    break;
                case 4:
                    if (!(message.waits && message.waits.length))
                        message.waits = [];
                    message.waits.push($root.EosTxActionAck.EosAuthorizationWait.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        EosAuthorization.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        EosAuthorization.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.threshold != null && message.hasOwnProperty("threshold"))
                if (!$util.isInteger(message.threshold))
                    return "threshold: integer expected";
            if (message.keys != null && message.hasOwnProperty("keys")) {
                if (!Array.isArray(message.keys))
                    return "keys: array expected";
                for (var i = 0; i < message.keys.length; ++i) {
                    var error = $root.EosTxActionAck.EosAuthorizationKey.verify(message.keys[i]);
                    if (error)
                        return "keys." + error;
                }
            }
            if (message.accounts != null && message.hasOwnProperty("accounts")) {
                if (!Array.isArray(message.accounts))
                    return "accounts: array expected";
                for (var i = 0; i < message.accounts.length; ++i) {
                    var error = $root.EosTxActionAck.EosAuthorizationAccount.verify(message.accounts[i]);
                    if (error)
                        return "accounts." + error;
                }
            }
            if (message.waits != null && message.hasOwnProperty("waits")) {
                if (!Array.isArray(message.waits))
                    return "waits: array expected";
                for (var i = 0; i < message.waits.length; ++i) {
                    var error = $root.EosTxActionAck.EosAuthorizationWait.verify(message.waits[i]);
                    if (error)
                        return "waits." + error;
                }
            }
            return null;
        };

        EosAuthorization.fromObject = function fromObject(object) {
            if (object instanceof $root.EosTxActionAck.EosAuthorization)
                return object;
            var message = new $root.EosTxActionAck.EosAuthorization();
            if (object.threshold != null)
                message.threshold = object.threshold >>> 0;
            if (object.keys) {
                if (!Array.isArray(object.keys))
                    throw TypeError(".EosTxActionAck.EosAuthorization.keys: array expected");
                message.keys = [];
                for (var i = 0; i < object.keys.length; ++i) {
                    if (typeof object.keys[i] !== "object")
                        throw TypeError(".EosTxActionAck.EosAuthorization.keys: object expected");
                    message.keys[i] = $root.EosTxActionAck.EosAuthorizationKey.fromObject(object.keys[i]);
                }
            }
            if (object.accounts) {
                if (!Array.isArray(object.accounts))
                    throw TypeError(".EosTxActionAck.EosAuthorization.accounts: array expected");
                message.accounts = [];
                for (var i = 0; i < object.accounts.length; ++i) {
                    if (typeof object.accounts[i] !== "object")
                        throw TypeError(".EosTxActionAck.EosAuthorization.accounts: object expected");
                    message.accounts[i] = $root.EosTxActionAck.EosAuthorizationAccount.fromObject(object.accounts[i]);
                }
            }
            if (object.waits) {
                if (!Array.isArray(object.waits))
                    throw TypeError(".EosTxActionAck.EosAuthorization.waits: array expected");
                message.waits = [];
                for (var i = 0; i < object.waits.length; ++i) {
                    if (typeof object.waits[i] !== "object")
                        throw TypeError(".EosTxActionAck.EosAuthorization.waits: object expected");
                    message.waits[i] = $root.EosTxActionAck.EosAuthorizationWait.fromObject(object.waits[i]);
                }
            }
            return message;
        };

        EosAuthorization.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.keys = [];
                object.accounts = [];
                object.waits = [];
            }
            if (options.defaults)
                object.threshold = 0;
            if (message.threshold != null && message.hasOwnProperty("threshold"))
                object.threshold = message.threshold;
            if (message.keys && message.keys.length) {
                object.keys = [];
                for (var j = 0; j < message.keys.length; ++j)
                    object.keys[j] = $root.EosTxActionAck.EosAuthorizationKey.toObject(message.keys[j], options);
            }
            if (message.accounts && message.accounts.length) {
                object.accounts = [];
                for (var j = 0; j < message.accounts.length; ++j)
                    object.accounts[j] = $root.EosTxActionAck.EosAuthorizationAccount.toObject(message.accounts[j], options);
            }
            if (message.waits && message.waits.length) {
                object.waits = [];
                for (var j = 0; j < message.waits.length; ++j)
                    object.waits[j] = $root.EosTxActionAck.EosAuthorizationWait.toObject(message.waits[j], options);
            }
            return object;
        };

        EosAuthorization.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EosAuthorization;
    })();

    EosTxActionAck.EosActionCommon = (function() {

        function EosActionCommon(properties) {
            this.authorization = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        EosActionCommon.prototype.account = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        EosActionCommon.prototype.name = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        EosActionCommon.prototype.authorization = $util.emptyArray;

        EosActionCommon.create = function create(properties) {
            return new EosActionCommon(properties);
        };

        EosActionCommon.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.account != null && Object.hasOwnProperty.call(message, "account"))
                writer.uint32(8).uint64(message.account);
            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                writer.uint32(16).uint64(message.name);
            if (message.authorization != null && message.authorization.length)
                for (var i = 0; i < message.authorization.length; ++i)
                    $root.EosTxActionAck.EosPermissionLevel.encode(message.authorization[i], writer.uint32(26).fork()).ldelim();
            return writer;
        };

        EosActionCommon.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        EosActionCommon.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EosTxActionAck.EosActionCommon();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.account = reader.uint64();
                    break;
                case 2:
                    message.name = reader.uint64();
                    break;
                case 3:
                    if (!(message.authorization && message.authorization.length))
                        message.authorization = [];
                    message.authorization.push($root.EosTxActionAck.EosPermissionLevel.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        EosActionCommon.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        EosActionCommon.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.account != null && message.hasOwnProperty("account"))
                if (!$util.isInteger(message.account) && !(message.account && $util.isInteger(message.account.low) && $util.isInteger(message.account.high)))
                    return "account: integer|Long expected";
            if (message.name != null && message.hasOwnProperty("name"))
                if (!$util.isInteger(message.name) && !(message.name && $util.isInteger(message.name.low) && $util.isInteger(message.name.high)))
                    return "name: integer|Long expected";
            if (message.authorization != null && message.hasOwnProperty("authorization")) {
                if (!Array.isArray(message.authorization))
                    return "authorization: array expected";
                for (var i = 0; i < message.authorization.length; ++i) {
                    var error = $root.EosTxActionAck.EosPermissionLevel.verify(message.authorization[i]);
                    if (error)
                        return "authorization." + error;
                }
            }
            return null;
        };

        EosActionCommon.fromObject = function fromObject(object) {
            if (object instanceof $root.EosTxActionAck.EosActionCommon)
                return object;
            var message = new $root.EosTxActionAck.EosActionCommon();
            if (object.account != null)
                if ($util.Long)
                    (message.account = $util.Long.fromValue(object.account)).unsigned = true;
                else if (typeof object.account === "string")
                    message.account = parseInt(object.account, 10);
                else if (typeof object.account === "number")
                    message.account = object.account;
                else if (typeof object.account === "object")
                    message.account = new $util.LongBits(object.account.low >>> 0, object.account.high >>> 0).toNumber(true);
            if (object.name != null)
                if ($util.Long)
                    (message.name = $util.Long.fromValue(object.name)).unsigned = true;
                else if (typeof object.name === "string")
                    message.name = parseInt(object.name, 10);
                else if (typeof object.name === "number")
                    message.name = object.name;
                else if (typeof object.name === "object")
                    message.name = new $util.LongBits(object.name.low >>> 0, object.name.high >>> 0).toNumber(true);
            if (object.authorization) {
                if (!Array.isArray(object.authorization))
                    throw TypeError(".EosTxActionAck.EosActionCommon.authorization: array expected");
                message.authorization = [];
                for (var i = 0; i < object.authorization.length; ++i) {
                    if (typeof object.authorization[i] !== "object")
                        throw TypeError(".EosTxActionAck.EosActionCommon.authorization: object expected");
                    message.authorization[i] = $root.EosTxActionAck.EosPermissionLevel.fromObject(object.authorization[i]);
                }
            }
            return message;
        };

        EosActionCommon.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.authorization = [];
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.account = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.account = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.name = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.name = options.longs === String ? "0" : 0;
            }
            if (message.account != null && message.hasOwnProperty("account"))
                if (typeof message.account === "number")
                    object.account = options.longs === String ? String(message.account) : message.account;
                else
                    object.account = options.longs === String ? $util.Long.prototype.toString.call(message.account) : options.longs === Number ? new $util.LongBits(message.account.low >>> 0, message.account.high >>> 0).toNumber(true) : message.account;
            if (message.name != null && message.hasOwnProperty("name"))
                if (typeof message.name === "number")
                    object.name = options.longs === String ? String(message.name) : message.name;
                else
                    object.name = options.longs === String ? $util.Long.prototype.toString.call(message.name) : options.longs === Number ? new $util.LongBits(message.name.low >>> 0, message.name.high >>> 0).toNumber(true) : message.name;
            if (message.authorization && message.authorization.length) {
                object.authorization = [];
                for (var j = 0; j < message.authorization.length; ++j)
                    object.authorization[j] = $root.EosTxActionAck.EosPermissionLevel.toObject(message.authorization[j], options);
            }
            return object;
        };

        EosActionCommon.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EosActionCommon;
    })();

    EosTxActionAck.EosActionTransfer = (function() {

        function EosActionTransfer(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        EosActionTransfer.prototype.sender = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        EosActionTransfer.prototype.receiver = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        EosActionTransfer.prototype.quantity = null;
        EosActionTransfer.prototype.memo = "";

        EosActionTransfer.create = function create(properties) {
            return new EosActionTransfer(properties);
        };

        EosActionTransfer.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.sender != null && Object.hasOwnProperty.call(message, "sender"))
                writer.uint32(8).uint64(message.sender);
            if (message.receiver != null && Object.hasOwnProperty.call(message, "receiver"))
                writer.uint32(16).uint64(message.receiver);
            if (message.quantity != null && Object.hasOwnProperty.call(message, "quantity"))
                $root.EosTxActionAck.EosAsset.encode(message.quantity, writer.uint32(26).fork()).ldelim();
            if (message.memo != null && Object.hasOwnProperty.call(message, "memo"))
                writer.uint32(34).string(message.memo);
            return writer;
        };

        EosActionTransfer.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        EosActionTransfer.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EosTxActionAck.EosActionTransfer();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.sender = reader.uint64();
                    break;
                case 2:
                    message.receiver = reader.uint64();
                    break;
                case 3:
                    message.quantity = $root.EosTxActionAck.EosAsset.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.memo = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        EosActionTransfer.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        EosActionTransfer.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.sender != null && message.hasOwnProperty("sender"))
                if (!$util.isInteger(message.sender) && !(message.sender && $util.isInteger(message.sender.low) && $util.isInteger(message.sender.high)))
                    return "sender: integer|Long expected";
            if (message.receiver != null && message.hasOwnProperty("receiver"))
                if (!$util.isInteger(message.receiver) && !(message.receiver && $util.isInteger(message.receiver.low) && $util.isInteger(message.receiver.high)))
                    return "receiver: integer|Long expected";
            if (message.quantity != null && message.hasOwnProperty("quantity")) {
                var error = $root.EosTxActionAck.EosAsset.verify(message.quantity);
                if (error)
                    return "quantity." + error;
            }
            if (message.memo != null && message.hasOwnProperty("memo"))
                if (!$util.isString(message.memo))
                    return "memo: string expected";
            return null;
        };

        EosActionTransfer.fromObject = function fromObject(object) {
            if (object instanceof $root.EosTxActionAck.EosActionTransfer)
                return object;
            var message = new $root.EosTxActionAck.EosActionTransfer();
            if (object.sender != null)
                if ($util.Long)
                    (message.sender = $util.Long.fromValue(object.sender)).unsigned = true;
                else if (typeof object.sender === "string")
                    message.sender = parseInt(object.sender, 10);
                else if (typeof object.sender === "number")
                    message.sender = object.sender;
                else if (typeof object.sender === "object")
                    message.sender = new $util.LongBits(object.sender.low >>> 0, object.sender.high >>> 0).toNumber(true);
            if (object.receiver != null)
                if ($util.Long)
                    (message.receiver = $util.Long.fromValue(object.receiver)).unsigned = true;
                else if (typeof object.receiver === "string")
                    message.receiver = parseInt(object.receiver, 10);
                else if (typeof object.receiver === "number")
                    message.receiver = object.receiver;
                else if (typeof object.receiver === "object")
                    message.receiver = new $util.LongBits(object.receiver.low >>> 0, object.receiver.high >>> 0).toNumber(true);
            if (object.quantity != null) {
                if (typeof object.quantity !== "object")
                    throw TypeError(".EosTxActionAck.EosActionTransfer.quantity: object expected");
                message.quantity = $root.EosTxActionAck.EosAsset.fromObject(object.quantity);
            }
            if (object.memo != null)
                message.memo = String(object.memo);
            return message;
        };

        EosActionTransfer.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.sender = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.sender = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.receiver = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.receiver = options.longs === String ? "0" : 0;
                object.quantity = null;
                object.memo = "";
            }
            if (message.sender != null && message.hasOwnProperty("sender"))
                if (typeof message.sender === "number")
                    object.sender = options.longs === String ? String(message.sender) : message.sender;
                else
                    object.sender = options.longs === String ? $util.Long.prototype.toString.call(message.sender) : options.longs === Number ? new $util.LongBits(message.sender.low >>> 0, message.sender.high >>> 0).toNumber(true) : message.sender;
            if (message.receiver != null && message.hasOwnProperty("receiver"))
                if (typeof message.receiver === "number")
                    object.receiver = options.longs === String ? String(message.receiver) : message.receiver;
                else
                    object.receiver = options.longs === String ? $util.Long.prototype.toString.call(message.receiver) : options.longs === Number ? new $util.LongBits(message.receiver.low >>> 0, message.receiver.high >>> 0).toNumber(true) : message.receiver;
            if (message.quantity != null && message.hasOwnProperty("quantity"))
                object.quantity = $root.EosTxActionAck.EosAsset.toObject(message.quantity, options);
            if (message.memo != null && message.hasOwnProperty("memo"))
                object.memo = message.memo;
            return object;
        };

        EosActionTransfer.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EosActionTransfer;
    })();

    EosTxActionAck.EosActionDelegate = (function() {

        function EosActionDelegate(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        EosActionDelegate.prototype.sender = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        EosActionDelegate.prototype.receiver = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        EosActionDelegate.prototype.net_quantity = null;
        EosActionDelegate.prototype.cpu_quantity = null;
        EosActionDelegate.prototype.transfer = false;

        EosActionDelegate.create = function create(properties) {
            return new EosActionDelegate(properties);
        };

        EosActionDelegate.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.sender != null && Object.hasOwnProperty.call(message, "sender"))
                writer.uint32(8).uint64(message.sender);
            if (message.receiver != null && Object.hasOwnProperty.call(message, "receiver"))
                writer.uint32(16).uint64(message.receiver);
            if (message.net_quantity != null && Object.hasOwnProperty.call(message, "net_quantity"))
                $root.EosTxActionAck.EosAsset.encode(message.net_quantity, writer.uint32(26).fork()).ldelim();
            if (message.cpu_quantity != null && Object.hasOwnProperty.call(message, "cpu_quantity"))
                $root.EosTxActionAck.EosAsset.encode(message.cpu_quantity, writer.uint32(34).fork()).ldelim();
            if (message.transfer != null && Object.hasOwnProperty.call(message, "transfer"))
                writer.uint32(40).bool(message.transfer);
            return writer;
        };

        EosActionDelegate.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        EosActionDelegate.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EosTxActionAck.EosActionDelegate();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.sender = reader.uint64();
                    break;
                case 2:
                    message.receiver = reader.uint64();
                    break;
                case 3:
                    message.net_quantity = $root.EosTxActionAck.EosAsset.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.cpu_quantity = $root.EosTxActionAck.EosAsset.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.transfer = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        EosActionDelegate.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        EosActionDelegate.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.sender != null && message.hasOwnProperty("sender"))
                if (!$util.isInteger(message.sender) && !(message.sender && $util.isInteger(message.sender.low) && $util.isInteger(message.sender.high)))
                    return "sender: integer|Long expected";
            if (message.receiver != null && message.hasOwnProperty("receiver"))
                if (!$util.isInteger(message.receiver) && !(message.receiver && $util.isInteger(message.receiver.low) && $util.isInteger(message.receiver.high)))
                    return "receiver: integer|Long expected";
            if (message.net_quantity != null && message.hasOwnProperty("net_quantity")) {
                var error = $root.EosTxActionAck.EosAsset.verify(message.net_quantity);
                if (error)
                    return "net_quantity." + error;
            }
            if (message.cpu_quantity != null && message.hasOwnProperty("cpu_quantity")) {
                var error = $root.EosTxActionAck.EosAsset.verify(message.cpu_quantity);
                if (error)
                    return "cpu_quantity." + error;
            }
            if (message.transfer != null && message.hasOwnProperty("transfer"))
                if (typeof message.transfer !== "boolean")
                    return "transfer: boolean expected";
            return null;
        };

        EosActionDelegate.fromObject = function fromObject(object) {
            if (object instanceof $root.EosTxActionAck.EosActionDelegate)
                return object;
            var message = new $root.EosTxActionAck.EosActionDelegate();
            if (object.sender != null)
                if ($util.Long)
                    (message.sender = $util.Long.fromValue(object.sender)).unsigned = true;
                else if (typeof object.sender === "string")
                    message.sender = parseInt(object.sender, 10);
                else if (typeof object.sender === "number")
                    message.sender = object.sender;
                else if (typeof object.sender === "object")
                    message.sender = new $util.LongBits(object.sender.low >>> 0, object.sender.high >>> 0).toNumber(true);
            if (object.receiver != null)
                if ($util.Long)
                    (message.receiver = $util.Long.fromValue(object.receiver)).unsigned = true;
                else if (typeof object.receiver === "string")
                    message.receiver = parseInt(object.receiver, 10);
                else if (typeof object.receiver === "number")
                    message.receiver = object.receiver;
                else if (typeof object.receiver === "object")
                    message.receiver = new $util.LongBits(object.receiver.low >>> 0, object.receiver.high >>> 0).toNumber(true);
            if (object.net_quantity != null) {
                if (typeof object.net_quantity !== "object")
                    throw TypeError(".EosTxActionAck.EosActionDelegate.net_quantity: object expected");
                message.net_quantity = $root.EosTxActionAck.EosAsset.fromObject(object.net_quantity);
            }
            if (object.cpu_quantity != null) {
                if (typeof object.cpu_quantity !== "object")
                    throw TypeError(".EosTxActionAck.EosActionDelegate.cpu_quantity: object expected");
                message.cpu_quantity = $root.EosTxActionAck.EosAsset.fromObject(object.cpu_quantity);
            }
            if (object.transfer != null)
                message.transfer = Boolean(object.transfer);
            return message;
        };

        EosActionDelegate.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.sender = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.sender = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.receiver = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.receiver = options.longs === String ? "0" : 0;
                object.net_quantity = null;
                object.cpu_quantity = null;
                object.transfer = false;
            }
            if (message.sender != null && message.hasOwnProperty("sender"))
                if (typeof message.sender === "number")
                    object.sender = options.longs === String ? String(message.sender) : message.sender;
                else
                    object.sender = options.longs === String ? $util.Long.prototype.toString.call(message.sender) : options.longs === Number ? new $util.LongBits(message.sender.low >>> 0, message.sender.high >>> 0).toNumber(true) : message.sender;
            if (message.receiver != null && message.hasOwnProperty("receiver"))
                if (typeof message.receiver === "number")
                    object.receiver = options.longs === String ? String(message.receiver) : message.receiver;
                else
                    object.receiver = options.longs === String ? $util.Long.prototype.toString.call(message.receiver) : options.longs === Number ? new $util.LongBits(message.receiver.low >>> 0, message.receiver.high >>> 0).toNumber(true) : message.receiver;
            if (message.net_quantity != null && message.hasOwnProperty("net_quantity"))
                object.net_quantity = $root.EosTxActionAck.EosAsset.toObject(message.net_quantity, options);
            if (message.cpu_quantity != null && message.hasOwnProperty("cpu_quantity"))
                object.cpu_quantity = $root.EosTxActionAck.EosAsset.toObject(message.cpu_quantity, options);
            if (message.transfer != null && message.hasOwnProperty("transfer"))
                object.transfer = message.transfer;
            return object;
        };

        EosActionDelegate.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EosActionDelegate;
    })();

    EosTxActionAck.EosActionUndelegate = (function() {

        function EosActionUndelegate(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        EosActionUndelegate.prototype.sender = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        EosActionUndelegate.prototype.receiver = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        EosActionUndelegate.prototype.net_quantity = null;
        EosActionUndelegate.prototype.cpu_quantity = null;

        EosActionUndelegate.create = function create(properties) {
            return new EosActionUndelegate(properties);
        };

        EosActionUndelegate.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.sender != null && Object.hasOwnProperty.call(message, "sender"))
                writer.uint32(8).uint64(message.sender);
            if (message.receiver != null && Object.hasOwnProperty.call(message, "receiver"))
                writer.uint32(16).uint64(message.receiver);
            if (message.net_quantity != null && Object.hasOwnProperty.call(message, "net_quantity"))
                $root.EosTxActionAck.EosAsset.encode(message.net_quantity, writer.uint32(26).fork()).ldelim();
            if (message.cpu_quantity != null && Object.hasOwnProperty.call(message, "cpu_quantity"))
                $root.EosTxActionAck.EosAsset.encode(message.cpu_quantity, writer.uint32(34).fork()).ldelim();
            return writer;
        };

        EosActionUndelegate.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        EosActionUndelegate.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EosTxActionAck.EosActionUndelegate();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.sender = reader.uint64();
                    break;
                case 2:
                    message.receiver = reader.uint64();
                    break;
                case 3:
                    message.net_quantity = $root.EosTxActionAck.EosAsset.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.cpu_quantity = $root.EosTxActionAck.EosAsset.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        EosActionUndelegate.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        EosActionUndelegate.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.sender != null && message.hasOwnProperty("sender"))
                if (!$util.isInteger(message.sender) && !(message.sender && $util.isInteger(message.sender.low) && $util.isInteger(message.sender.high)))
                    return "sender: integer|Long expected";
            if (message.receiver != null && message.hasOwnProperty("receiver"))
                if (!$util.isInteger(message.receiver) && !(message.receiver && $util.isInteger(message.receiver.low) && $util.isInteger(message.receiver.high)))
                    return "receiver: integer|Long expected";
            if (message.net_quantity != null && message.hasOwnProperty("net_quantity")) {
                var error = $root.EosTxActionAck.EosAsset.verify(message.net_quantity);
                if (error)
                    return "net_quantity." + error;
            }
            if (message.cpu_quantity != null && message.hasOwnProperty("cpu_quantity")) {
                var error = $root.EosTxActionAck.EosAsset.verify(message.cpu_quantity);
                if (error)
                    return "cpu_quantity." + error;
            }
            return null;
        };

        EosActionUndelegate.fromObject = function fromObject(object) {
            if (object instanceof $root.EosTxActionAck.EosActionUndelegate)
                return object;
            var message = new $root.EosTxActionAck.EosActionUndelegate();
            if (object.sender != null)
                if ($util.Long)
                    (message.sender = $util.Long.fromValue(object.sender)).unsigned = true;
                else if (typeof object.sender === "string")
                    message.sender = parseInt(object.sender, 10);
                else if (typeof object.sender === "number")
                    message.sender = object.sender;
                else if (typeof object.sender === "object")
                    message.sender = new $util.LongBits(object.sender.low >>> 0, object.sender.high >>> 0).toNumber(true);
            if (object.receiver != null)
                if ($util.Long)
                    (message.receiver = $util.Long.fromValue(object.receiver)).unsigned = true;
                else if (typeof object.receiver === "string")
                    message.receiver = parseInt(object.receiver, 10);
                else if (typeof object.receiver === "number")
                    message.receiver = object.receiver;
                else if (typeof object.receiver === "object")
                    message.receiver = new $util.LongBits(object.receiver.low >>> 0, object.receiver.high >>> 0).toNumber(true);
            if (object.net_quantity != null) {
                if (typeof object.net_quantity !== "object")
                    throw TypeError(".EosTxActionAck.EosActionUndelegate.net_quantity: object expected");
                message.net_quantity = $root.EosTxActionAck.EosAsset.fromObject(object.net_quantity);
            }
            if (object.cpu_quantity != null) {
                if (typeof object.cpu_quantity !== "object")
                    throw TypeError(".EosTxActionAck.EosActionUndelegate.cpu_quantity: object expected");
                message.cpu_quantity = $root.EosTxActionAck.EosAsset.fromObject(object.cpu_quantity);
            }
            return message;
        };

        EosActionUndelegate.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.sender = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.sender = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.receiver = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.receiver = options.longs === String ? "0" : 0;
                object.net_quantity = null;
                object.cpu_quantity = null;
            }
            if (message.sender != null && message.hasOwnProperty("sender"))
                if (typeof message.sender === "number")
                    object.sender = options.longs === String ? String(message.sender) : message.sender;
                else
                    object.sender = options.longs === String ? $util.Long.prototype.toString.call(message.sender) : options.longs === Number ? new $util.LongBits(message.sender.low >>> 0, message.sender.high >>> 0).toNumber(true) : message.sender;
            if (message.receiver != null && message.hasOwnProperty("receiver"))
                if (typeof message.receiver === "number")
                    object.receiver = options.longs === String ? String(message.receiver) : message.receiver;
                else
                    object.receiver = options.longs === String ? $util.Long.prototype.toString.call(message.receiver) : options.longs === Number ? new $util.LongBits(message.receiver.low >>> 0, message.receiver.high >>> 0).toNumber(true) : message.receiver;
            if (message.net_quantity != null && message.hasOwnProperty("net_quantity"))
                object.net_quantity = $root.EosTxActionAck.EosAsset.toObject(message.net_quantity, options);
            if (message.cpu_quantity != null && message.hasOwnProperty("cpu_quantity"))
                object.cpu_quantity = $root.EosTxActionAck.EosAsset.toObject(message.cpu_quantity, options);
            return object;
        };

        EosActionUndelegate.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EosActionUndelegate;
    })();

    EosTxActionAck.EosActionRefund = (function() {

        function EosActionRefund(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        EosActionRefund.prototype.owner = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        EosActionRefund.create = function create(properties) {
            return new EosActionRefund(properties);
        };

        EosActionRefund.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.owner != null && Object.hasOwnProperty.call(message, "owner"))
                writer.uint32(8).uint64(message.owner);
            return writer;
        };

        EosActionRefund.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        EosActionRefund.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EosTxActionAck.EosActionRefund();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.owner = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        EosActionRefund.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        EosActionRefund.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.owner != null && message.hasOwnProperty("owner"))
                if (!$util.isInteger(message.owner) && !(message.owner && $util.isInteger(message.owner.low) && $util.isInteger(message.owner.high)))
                    return "owner: integer|Long expected";
            return null;
        };

        EosActionRefund.fromObject = function fromObject(object) {
            if (object instanceof $root.EosTxActionAck.EosActionRefund)
                return object;
            var message = new $root.EosTxActionAck.EosActionRefund();
            if (object.owner != null)
                if ($util.Long)
                    (message.owner = $util.Long.fromValue(object.owner)).unsigned = true;
                else if (typeof object.owner === "string")
                    message.owner = parseInt(object.owner, 10);
                else if (typeof object.owner === "number")
                    message.owner = object.owner;
                else if (typeof object.owner === "object")
                    message.owner = new $util.LongBits(object.owner.low >>> 0, object.owner.high >>> 0).toNumber(true);
            return message;
        };

        EosActionRefund.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.owner = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.owner = options.longs === String ? "0" : 0;
            if (message.owner != null && message.hasOwnProperty("owner"))
                if (typeof message.owner === "number")
                    object.owner = options.longs === String ? String(message.owner) : message.owner;
                else
                    object.owner = options.longs === String ? $util.Long.prototype.toString.call(message.owner) : options.longs === Number ? new $util.LongBits(message.owner.low >>> 0, message.owner.high >>> 0).toNumber(true) : message.owner;
            return object;
        };

        EosActionRefund.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EosActionRefund;
    })();

    EosTxActionAck.EosActionBuyRam = (function() {

        function EosActionBuyRam(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        EosActionBuyRam.prototype.payer = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        EosActionBuyRam.prototype.receiver = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        EosActionBuyRam.prototype.quantity = null;

        EosActionBuyRam.create = function create(properties) {
            return new EosActionBuyRam(properties);
        };

        EosActionBuyRam.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.payer != null && Object.hasOwnProperty.call(message, "payer"))
                writer.uint32(8).uint64(message.payer);
            if (message.receiver != null && Object.hasOwnProperty.call(message, "receiver"))
                writer.uint32(16).uint64(message.receiver);
            if (message.quantity != null && Object.hasOwnProperty.call(message, "quantity"))
                $root.EosTxActionAck.EosAsset.encode(message.quantity, writer.uint32(26).fork()).ldelim();
            return writer;
        };

        EosActionBuyRam.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        EosActionBuyRam.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EosTxActionAck.EosActionBuyRam();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.payer = reader.uint64();
                    break;
                case 2:
                    message.receiver = reader.uint64();
                    break;
                case 3:
                    message.quantity = $root.EosTxActionAck.EosAsset.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        EosActionBuyRam.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        EosActionBuyRam.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.payer != null && message.hasOwnProperty("payer"))
                if (!$util.isInteger(message.payer) && !(message.payer && $util.isInteger(message.payer.low) && $util.isInteger(message.payer.high)))
                    return "payer: integer|Long expected";
            if (message.receiver != null && message.hasOwnProperty("receiver"))
                if (!$util.isInteger(message.receiver) && !(message.receiver && $util.isInteger(message.receiver.low) && $util.isInteger(message.receiver.high)))
                    return "receiver: integer|Long expected";
            if (message.quantity != null && message.hasOwnProperty("quantity")) {
                var error = $root.EosTxActionAck.EosAsset.verify(message.quantity);
                if (error)
                    return "quantity." + error;
            }
            return null;
        };

        EosActionBuyRam.fromObject = function fromObject(object) {
            if (object instanceof $root.EosTxActionAck.EosActionBuyRam)
                return object;
            var message = new $root.EosTxActionAck.EosActionBuyRam();
            if (object.payer != null)
                if ($util.Long)
                    (message.payer = $util.Long.fromValue(object.payer)).unsigned = true;
                else if (typeof object.payer === "string")
                    message.payer = parseInt(object.payer, 10);
                else if (typeof object.payer === "number")
                    message.payer = object.payer;
                else if (typeof object.payer === "object")
                    message.payer = new $util.LongBits(object.payer.low >>> 0, object.payer.high >>> 0).toNumber(true);
            if (object.receiver != null)
                if ($util.Long)
                    (message.receiver = $util.Long.fromValue(object.receiver)).unsigned = true;
                else if (typeof object.receiver === "string")
                    message.receiver = parseInt(object.receiver, 10);
                else if (typeof object.receiver === "number")
                    message.receiver = object.receiver;
                else if (typeof object.receiver === "object")
                    message.receiver = new $util.LongBits(object.receiver.low >>> 0, object.receiver.high >>> 0).toNumber(true);
            if (object.quantity != null) {
                if (typeof object.quantity !== "object")
                    throw TypeError(".EosTxActionAck.EosActionBuyRam.quantity: object expected");
                message.quantity = $root.EosTxActionAck.EosAsset.fromObject(object.quantity);
            }
            return message;
        };

        EosActionBuyRam.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.payer = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.payer = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.receiver = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.receiver = options.longs === String ? "0" : 0;
                object.quantity = null;
            }
            if (message.payer != null && message.hasOwnProperty("payer"))
                if (typeof message.payer === "number")
                    object.payer = options.longs === String ? String(message.payer) : message.payer;
                else
                    object.payer = options.longs === String ? $util.Long.prototype.toString.call(message.payer) : options.longs === Number ? new $util.LongBits(message.payer.low >>> 0, message.payer.high >>> 0).toNumber(true) : message.payer;
            if (message.receiver != null && message.hasOwnProperty("receiver"))
                if (typeof message.receiver === "number")
                    object.receiver = options.longs === String ? String(message.receiver) : message.receiver;
                else
                    object.receiver = options.longs === String ? $util.Long.prototype.toString.call(message.receiver) : options.longs === Number ? new $util.LongBits(message.receiver.low >>> 0, message.receiver.high >>> 0).toNumber(true) : message.receiver;
            if (message.quantity != null && message.hasOwnProperty("quantity"))
                object.quantity = $root.EosTxActionAck.EosAsset.toObject(message.quantity, options);
            return object;
        };

        EosActionBuyRam.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EosActionBuyRam;
    })();

    EosTxActionAck.EosActionBuyRamBytes = (function() {

        function EosActionBuyRamBytes(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        EosActionBuyRamBytes.prototype.payer = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        EosActionBuyRamBytes.prototype.receiver = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        EosActionBuyRamBytes.prototype.bytes = 0;

        EosActionBuyRamBytes.create = function create(properties) {
            return new EosActionBuyRamBytes(properties);
        };

        EosActionBuyRamBytes.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.payer != null && Object.hasOwnProperty.call(message, "payer"))
                writer.uint32(8).uint64(message.payer);
            if (message.receiver != null && Object.hasOwnProperty.call(message, "receiver"))
                writer.uint32(16).uint64(message.receiver);
            if (message.bytes != null && Object.hasOwnProperty.call(message, "bytes"))
                writer.uint32(24).uint32(message.bytes);
            return writer;
        };

        EosActionBuyRamBytes.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        EosActionBuyRamBytes.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EosTxActionAck.EosActionBuyRamBytes();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.payer = reader.uint64();
                    break;
                case 2:
                    message.receiver = reader.uint64();
                    break;
                case 3:
                    message.bytes = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        EosActionBuyRamBytes.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        EosActionBuyRamBytes.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.payer != null && message.hasOwnProperty("payer"))
                if (!$util.isInteger(message.payer) && !(message.payer && $util.isInteger(message.payer.low) && $util.isInteger(message.payer.high)))
                    return "payer: integer|Long expected";
            if (message.receiver != null && message.hasOwnProperty("receiver"))
                if (!$util.isInteger(message.receiver) && !(message.receiver && $util.isInteger(message.receiver.low) && $util.isInteger(message.receiver.high)))
                    return "receiver: integer|Long expected";
            if (message.bytes != null && message.hasOwnProperty("bytes"))
                if (!$util.isInteger(message.bytes))
                    return "bytes: integer expected";
            return null;
        };

        EosActionBuyRamBytes.fromObject = function fromObject(object) {
            if (object instanceof $root.EosTxActionAck.EosActionBuyRamBytes)
                return object;
            var message = new $root.EosTxActionAck.EosActionBuyRamBytes();
            if (object.payer != null)
                if ($util.Long)
                    (message.payer = $util.Long.fromValue(object.payer)).unsigned = true;
                else if (typeof object.payer === "string")
                    message.payer = parseInt(object.payer, 10);
                else if (typeof object.payer === "number")
                    message.payer = object.payer;
                else if (typeof object.payer === "object")
                    message.payer = new $util.LongBits(object.payer.low >>> 0, object.payer.high >>> 0).toNumber(true);
            if (object.receiver != null)
                if ($util.Long)
                    (message.receiver = $util.Long.fromValue(object.receiver)).unsigned = true;
                else if (typeof object.receiver === "string")
                    message.receiver = parseInt(object.receiver, 10);
                else if (typeof object.receiver === "number")
                    message.receiver = object.receiver;
                else if (typeof object.receiver === "object")
                    message.receiver = new $util.LongBits(object.receiver.low >>> 0, object.receiver.high >>> 0).toNumber(true);
            if (object.bytes != null)
                message.bytes = object.bytes >>> 0;
            return message;
        };

        EosActionBuyRamBytes.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.payer = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.payer = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.receiver = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.receiver = options.longs === String ? "0" : 0;
                object.bytes = 0;
            }
            if (message.payer != null && message.hasOwnProperty("payer"))
                if (typeof message.payer === "number")
                    object.payer = options.longs === String ? String(message.payer) : message.payer;
                else
                    object.payer = options.longs === String ? $util.Long.prototype.toString.call(message.payer) : options.longs === Number ? new $util.LongBits(message.payer.low >>> 0, message.payer.high >>> 0).toNumber(true) : message.payer;
            if (message.receiver != null && message.hasOwnProperty("receiver"))
                if (typeof message.receiver === "number")
                    object.receiver = options.longs === String ? String(message.receiver) : message.receiver;
                else
                    object.receiver = options.longs === String ? $util.Long.prototype.toString.call(message.receiver) : options.longs === Number ? new $util.LongBits(message.receiver.low >>> 0, message.receiver.high >>> 0).toNumber(true) : message.receiver;
            if (message.bytes != null && message.hasOwnProperty("bytes"))
                object.bytes = message.bytes;
            return object;
        };

        EosActionBuyRamBytes.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EosActionBuyRamBytes;
    })();

    EosTxActionAck.EosActionSellRam = (function() {

        function EosActionSellRam(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        EosActionSellRam.prototype.account = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        EosActionSellRam.prototype.bytes = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        EosActionSellRam.create = function create(properties) {
            return new EosActionSellRam(properties);
        };

        EosActionSellRam.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.account != null && Object.hasOwnProperty.call(message, "account"))
                writer.uint32(8).uint64(message.account);
            if (message.bytes != null && Object.hasOwnProperty.call(message, "bytes"))
                writer.uint32(16).uint64(message.bytes);
            return writer;
        };

        EosActionSellRam.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        EosActionSellRam.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EosTxActionAck.EosActionSellRam();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.account = reader.uint64();
                    break;
                case 2:
                    message.bytes = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        EosActionSellRam.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        EosActionSellRam.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.account != null && message.hasOwnProperty("account"))
                if (!$util.isInteger(message.account) && !(message.account && $util.isInteger(message.account.low) && $util.isInteger(message.account.high)))
                    return "account: integer|Long expected";
            if (message.bytes != null && message.hasOwnProperty("bytes"))
                if (!$util.isInteger(message.bytes) && !(message.bytes && $util.isInteger(message.bytes.low) && $util.isInteger(message.bytes.high)))
                    return "bytes: integer|Long expected";
            return null;
        };

        EosActionSellRam.fromObject = function fromObject(object) {
            if (object instanceof $root.EosTxActionAck.EosActionSellRam)
                return object;
            var message = new $root.EosTxActionAck.EosActionSellRam();
            if (object.account != null)
                if ($util.Long)
                    (message.account = $util.Long.fromValue(object.account)).unsigned = true;
                else if (typeof object.account === "string")
                    message.account = parseInt(object.account, 10);
                else if (typeof object.account === "number")
                    message.account = object.account;
                else if (typeof object.account === "object")
                    message.account = new $util.LongBits(object.account.low >>> 0, object.account.high >>> 0).toNumber(true);
            if (object.bytes != null)
                if ($util.Long)
                    (message.bytes = $util.Long.fromValue(object.bytes)).unsigned = true;
                else if (typeof object.bytes === "string")
                    message.bytes = parseInt(object.bytes, 10);
                else if (typeof object.bytes === "number")
                    message.bytes = object.bytes;
                else if (typeof object.bytes === "object")
                    message.bytes = new $util.LongBits(object.bytes.low >>> 0, object.bytes.high >>> 0).toNumber(true);
            return message;
        };

        EosActionSellRam.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.account = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.account = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.bytes = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.bytes = options.longs === String ? "0" : 0;
            }
            if (message.account != null && message.hasOwnProperty("account"))
                if (typeof message.account === "number")
                    object.account = options.longs === String ? String(message.account) : message.account;
                else
                    object.account = options.longs === String ? $util.Long.prototype.toString.call(message.account) : options.longs === Number ? new $util.LongBits(message.account.low >>> 0, message.account.high >>> 0).toNumber(true) : message.account;
            if (message.bytes != null && message.hasOwnProperty("bytes"))
                if (typeof message.bytes === "number")
                    object.bytes = options.longs === String ? String(message.bytes) : message.bytes;
                else
                    object.bytes = options.longs === String ? $util.Long.prototype.toString.call(message.bytes) : options.longs === Number ? new $util.LongBits(message.bytes.low >>> 0, message.bytes.high >>> 0).toNumber(true) : message.bytes;
            return object;
        };

        EosActionSellRam.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EosActionSellRam;
    })();

    EosTxActionAck.EosActionVoteProducer = (function() {

        function EosActionVoteProducer(properties) {
            this.producers = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        EosActionVoteProducer.prototype.voter = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        EosActionVoteProducer.prototype.proxy = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        EosActionVoteProducer.prototype.producers = $util.emptyArray;

        EosActionVoteProducer.create = function create(properties) {
            return new EosActionVoteProducer(properties);
        };

        EosActionVoteProducer.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.voter != null && Object.hasOwnProperty.call(message, "voter"))
                writer.uint32(8).uint64(message.voter);
            if (message.proxy != null && Object.hasOwnProperty.call(message, "proxy"))
                writer.uint32(16).uint64(message.proxy);
            if (message.producers != null && message.producers.length)
                for (var i = 0; i < message.producers.length; ++i)
                    writer.uint32(24).uint64(message.producers[i]);
            return writer;
        };

        EosActionVoteProducer.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        EosActionVoteProducer.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EosTxActionAck.EosActionVoteProducer();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.voter = reader.uint64();
                    break;
                case 2:
                    message.proxy = reader.uint64();
                    break;
                case 3:
                    if (!(message.producers && message.producers.length))
                        message.producers = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.producers.push(reader.uint64());
                    } else
                        message.producers.push(reader.uint64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        EosActionVoteProducer.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        EosActionVoteProducer.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.voter != null && message.hasOwnProperty("voter"))
                if (!$util.isInteger(message.voter) && !(message.voter && $util.isInteger(message.voter.low) && $util.isInteger(message.voter.high)))
                    return "voter: integer|Long expected";
            if (message.proxy != null && message.hasOwnProperty("proxy"))
                if (!$util.isInteger(message.proxy) && !(message.proxy && $util.isInteger(message.proxy.low) && $util.isInteger(message.proxy.high)))
                    return "proxy: integer|Long expected";
            if (message.producers != null && message.hasOwnProperty("producers")) {
                if (!Array.isArray(message.producers))
                    return "producers: array expected";
                for (var i = 0; i < message.producers.length; ++i)
                    if (!$util.isInteger(message.producers[i]) && !(message.producers[i] && $util.isInteger(message.producers[i].low) && $util.isInteger(message.producers[i].high)))
                        return "producers: integer|Long[] expected";
            }
            return null;
        };

        EosActionVoteProducer.fromObject = function fromObject(object) {
            if (object instanceof $root.EosTxActionAck.EosActionVoteProducer)
                return object;
            var message = new $root.EosTxActionAck.EosActionVoteProducer();
            if (object.voter != null)
                if ($util.Long)
                    (message.voter = $util.Long.fromValue(object.voter)).unsigned = true;
                else if (typeof object.voter === "string")
                    message.voter = parseInt(object.voter, 10);
                else if (typeof object.voter === "number")
                    message.voter = object.voter;
                else if (typeof object.voter === "object")
                    message.voter = new $util.LongBits(object.voter.low >>> 0, object.voter.high >>> 0).toNumber(true);
            if (object.proxy != null)
                if ($util.Long)
                    (message.proxy = $util.Long.fromValue(object.proxy)).unsigned = true;
                else if (typeof object.proxy === "string")
                    message.proxy = parseInt(object.proxy, 10);
                else if (typeof object.proxy === "number")
                    message.proxy = object.proxy;
                else if (typeof object.proxy === "object")
                    message.proxy = new $util.LongBits(object.proxy.low >>> 0, object.proxy.high >>> 0).toNumber(true);
            if (object.producers) {
                if (!Array.isArray(object.producers))
                    throw TypeError(".EosTxActionAck.EosActionVoteProducer.producers: array expected");
                message.producers = [];
                for (var i = 0; i < object.producers.length; ++i)
                    if ($util.Long)
                        (message.producers[i] = $util.Long.fromValue(object.producers[i])).unsigned = true;
                    else if (typeof object.producers[i] === "string")
                        message.producers[i] = parseInt(object.producers[i], 10);
                    else if (typeof object.producers[i] === "number")
                        message.producers[i] = object.producers[i];
                    else if (typeof object.producers[i] === "object")
                        message.producers[i] = new $util.LongBits(object.producers[i].low >>> 0, object.producers[i].high >>> 0).toNumber(true);
            }
            return message;
        };

        EosActionVoteProducer.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.producers = [];
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.voter = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.voter = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.proxy = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.proxy = options.longs === String ? "0" : 0;
            }
            if (message.voter != null && message.hasOwnProperty("voter"))
                if (typeof message.voter === "number")
                    object.voter = options.longs === String ? String(message.voter) : message.voter;
                else
                    object.voter = options.longs === String ? $util.Long.prototype.toString.call(message.voter) : options.longs === Number ? new $util.LongBits(message.voter.low >>> 0, message.voter.high >>> 0).toNumber(true) : message.voter;
            if (message.proxy != null && message.hasOwnProperty("proxy"))
                if (typeof message.proxy === "number")
                    object.proxy = options.longs === String ? String(message.proxy) : message.proxy;
                else
                    object.proxy = options.longs === String ? $util.Long.prototype.toString.call(message.proxy) : options.longs === Number ? new $util.LongBits(message.proxy.low >>> 0, message.proxy.high >>> 0).toNumber(true) : message.proxy;
            if (message.producers && message.producers.length) {
                object.producers = [];
                for (var j = 0; j < message.producers.length; ++j)
                    if (typeof message.producers[j] === "number")
                        object.producers[j] = options.longs === String ? String(message.producers[j]) : message.producers[j];
                    else
                        object.producers[j] = options.longs === String ? $util.Long.prototype.toString.call(message.producers[j]) : options.longs === Number ? new $util.LongBits(message.producers[j].low >>> 0, message.producers[j].high >>> 0).toNumber(true) : message.producers[j];
            }
            return object;
        };

        EosActionVoteProducer.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EosActionVoteProducer;
    })();

    EosTxActionAck.EosActionUpdateAuth = (function() {

        function EosActionUpdateAuth(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        EosActionUpdateAuth.prototype.account = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        EosActionUpdateAuth.prototype.permission = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        EosActionUpdateAuth.prototype.parent = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        EosActionUpdateAuth.prototype.auth = null;

        EosActionUpdateAuth.create = function create(properties) {
            return new EosActionUpdateAuth(properties);
        };

        EosActionUpdateAuth.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.account != null && Object.hasOwnProperty.call(message, "account"))
                writer.uint32(8).uint64(message.account);
            if (message.permission != null && Object.hasOwnProperty.call(message, "permission"))
                writer.uint32(16).uint64(message.permission);
            if (message.parent != null && Object.hasOwnProperty.call(message, "parent"))
                writer.uint32(24).uint64(message.parent);
            if (message.auth != null && Object.hasOwnProperty.call(message, "auth"))
                $root.EosTxActionAck.EosAuthorization.encode(message.auth, writer.uint32(34).fork()).ldelim();
            return writer;
        };

        EosActionUpdateAuth.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        EosActionUpdateAuth.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EosTxActionAck.EosActionUpdateAuth();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.account = reader.uint64();
                    break;
                case 2:
                    message.permission = reader.uint64();
                    break;
                case 3:
                    message.parent = reader.uint64();
                    break;
                case 4:
                    message.auth = $root.EosTxActionAck.EosAuthorization.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        EosActionUpdateAuth.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        EosActionUpdateAuth.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.account != null && message.hasOwnProperty("account"))
                if (!$util.isInteger(message.account) && !(message.account && $util.isInteger(message.account.low) && $util.isInteger(message.account.high)))
                    return "account: integer|Long expected";
            if (message.permission != null && message.hasOwnProperty("permission"))
                if (!$util.isInteger(message.permission) && !(message.permission && $util.isInteger(message.permission.low) && $util.isInteger(message.permission.high)))
                    return "permission: integer|Long expected";
            if (message.parent != null && message.hasOwnProperty("parent"))
                if (!$util.isInteger(message.parent) && !(message.parent && $util.isInteger(message.parent.low) && $util.isInteger(message.parent.high)))
                    return "parent: integer|Long expected";
            if (message.auth != null && message.hasOwnProperty("auth")) {
                var error = $root.EosTxActionAck.EosAuthorization.verify(message.auth);
                if (error)
                    return "auth." + error;
            }
            return null;
        };

        EosActionUpdateAuth.fromObject = function fromObject(object) {
            if (object instanceof $root.EosTxActionAck.EosActionUpdateAuth)
                return object;
            var message = new $root.EosTxActionAck.EosActionUpdateAuth();
            if (object.account != null)
                if ($util.Long)
                    (message.account = $util.Long.fromValue(object.account)).unsigned = true;
                else if (typeof object.account === "string")
                    message.account = parseInt(object.account, 10);
                else if (typeof object.account === "number")
                    message.account = object.account;
                else if (typeof object.account === "object")
                    message.account = new $util.LongBits(object.account.low >>> 0, object.account.high >>> 0).toNumber(true);
            if (object.permission != null)
                if ($util.Long)
                    (message.permission = $util.Long.fromValue(object.permission)).unsigned = true;
                else if (typeof object.permission === "string")
                    message.permission = parseInt(object.permission, 10);
                else if (typeof object.permission === "number")
                    message.permission = object.permission;
                else if (typeof object.permission === "object")
                    message.permission = new $util.LongBits(object.permission.low >>> 0, object.permission.high >>> 0).toNumber(true);
            if (object.parent != null)
                if ($util.Long)
                    (message.parent = $util.Long.fromValue(object.parent)).unsigned = true;
                else if (typeof object.parent === "string")
                    message.parent = parseInt(object.parent, 10);
                else if (typeof object.parent === "number")
                    message.parent = object.parent;
                else if (typeof object.parent === "object")
                    message.parent = new $util.LongBits(object.parent.low >>> 0, object.parent.high >>> 0).toNumber(true);
            if (object.auth != null) {
                if (typeof object.auth !== "object")
                    throw TypeError(".EosTxActionAck.EosActionUpdateAuth.auth: object expected");
                message.auth = $root.EosTxActionAck.EosAuthorization.fromObject(object.auth);
            }
            return message;
        };

        EosActionUpdateAuth.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.account = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.account = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.permission = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.permission = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.parent = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.parent = options.longs === String ? "0" : 0;
                object.auth = null;
            }
            if (message.account != null && message.hasOwnProperty("account"))
                if (typeof message.account === "number")
                    object.account = options.longs === String ? String(message.account) : message.account;
                else
                    object.account = options.longs === String ? $util.Long.prototype.toString.call(message.account) : options.longs === Number ? new $util.LongBits(message.account.low >>> 0, message.account.high >>> 0).toNumber(true) : message.account;
            if (message.permission != null && message.hasOwnProperty("permission"))
                if (typeof message.permission === "number")
                    object.permission = options.longs === String ? String(message.permission) : message.permission;
                else
                    object.permission = options.longs === String ? $util.Long.prototype.toString.call(message.permission) : options.longs === Number ? new $util.LongBits(message.permission.low >>> 0, message.permission.high >>> 0).toNumber(true) : message.permission;
            if (message.parent != null && message.hasOwnProperty("parent"))
                if (typeof message.parent === "number")
                    object.parent = options.longs === String ? String(message.parent) : message.parent;
                else
                    object.parent = options.longs === String ? $util.Long.prototype.toString.call(message.parent) : options.longs === Number ? new $util.LongBits(message.parent.low >>> 0, message.parent.high >>> 0).toNumber(true) : message.parent;
            if (message.auth != null && message.hasOwnProperty("auth"))
                object.auth = $root.EosTxActionAck.EosAuthorization.toObject(message.auth, options);
            return object;
        };

        EosActionUpdateAuth.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EosActionUpdateAuth;
    })();

    EosTxActionAck.EosActionDeleteAuth = (function() {

        function EosActionDeleteAuth(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        EosActionDeleteAuth.prototype.account = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        EosActionDeleteAuth.prototype.permission = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        EosActionDeleteAuth.create = function create(properties) {
            return new EosActionDeleteAuth(properties);
        };

        EosActionDeleteAuth.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.account != null && Object.hasOwnProperty.call(message, "account"))
                writer.uint32(8).uint64(message.account);
            if (message.permission != null && Object.hasOwnProperty.call(message, "permission"))
                writer.uint32(16).uint64(message.permission);
            return writer;
        };

        EosActionDeleteAuth.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        EosActionDeleteAuth.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EosTxActionAck.EosActionDeleteAuth();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.account = reader.uint64();
                    break;
                case 2:
                    message.permission = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        EosActionDeleteAuth.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        EosActionDeleteAuth.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.account != null && message.hasOwnProperty("account"))
                if (!$util.isInteger(message.account) && !(message.account && $util.isInteger(message.account.low) && $util.isInteger(message.account.high)))
                    return "account: integer|Long expected";
            if (message.permission != null && message.hasOwnProperty("permission"))
                if (!$util.isInteger(message.permission) && !(message.permission && $util.isInteger(message.permission.low) && $util.isInteger(message.permission.high)))
                    return "permission: integer|Long expected";
            return null;
        };

        EosActionDeleteAuth.fromObject = function fromObject(object) {
            if (object instanceof $root.EosTxActionAck.EosActionDeleteAuth)
                return object;
            var message = new $root.EosTxActionAck.EosActionDeleteAuth();
            if (object.account != null)
                if ($util.Long)
                    (message.account = $util.Long.fromValue(object.account)).unsigned = true;
                else if (typeof object.account === "string")
                    message.account = parseInt(object.account, 10);
                else if (typeof object.account === "number")
                    message.account = object.account;
                else if (typeof object.account === "object")
                    message.account = new $util.LongBits(object.account.low >>> 0, object.account.high >>> 0).toNumber(true);
            if (object.permission != null)
                if ($util.Long)
                    (message.permission = $util.Long.fromValue(object.permission)).unsigned = true;
                else if (typeof object.permission === "string")
                    message.permission = parseInt(object.permission, 10);
                else if (typeof object.permission === "number")
                    message.permission = object.permission;
                else if (typeof object.permission === "object")
                    message.permission = new $util.LongBits(object.permission.low >>> 0, object.permission.high >>> 0).toNumber(true);
            return message;
        };

        EosActionDeleteAuth.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.account = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.account = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.permission = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.permission = options.longs === String ? "0" : 0;
            }
            if (message.account != null && message.hasOwnProperty("account"))
                if (typeof message.account === "number")
                    object.account = options.longs === String ? String(message.account) : message.account;
                else
                    object.account = options.longs === String ? $util.Long.prototype.toString.call(message.account) : options.longs === Number ? new $util.LongBits(message.account.low >>> 0, message.account.high >>> 0).toNumber(true) : message.account;
            if (message.permission != null && message.hasOwnProperty("permission"))
                if (typeof message.permission === "number")
                    object.permission = options.longs === String ? String(message.permission) : message.permission;
                else
                    object.permission = options.longs === String ? $util.Long.prototype.toString.call(message.permission) : options.longs === Number ? new $util.LongBits(message.permission.low >>> 0, message.permission.high >>> 0).toNumber(true) : message.permission;
            return object;
        };

        EosActionDeleteAuth.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EosActionDeleteAuth;
    })();

    EosTxActionAck.EosActionLinkAuth = (function() {

        function EosActionLinkAuth(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        EosActionLinkAuth.prototype.account = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        EosActionLinkAuth.prototype.code = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        EosActionLinkAuth.prototype.type = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        EosActionLinkAuth.prototype.requirement = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        EosActionLinkAuth.create = function create(properties) {
            return new EosActionLinkAuth(properties);
        };

        EosActionLinkAuth.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.account != null && Object.hasOwnProperty.call(message, "account"))
                writer.uint32(8).uint64(message.account);
            if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                writer.uint32(16).uint64(message.code);
            if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                writer.uint32(24).uint64(message.type);
            if (message.requirement != null && Object.hasOwnProperty.call(message, "requirement"))
                writer.uint32(32).uint64(message.requirement);
            return writer;
        };

        EosActionLinkAuth.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        EosActionLinkAuth.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EosTxActionAck.EosActionLinkAuth();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.account = reader.uint64();
                    break;
                case 2:
                    message.code = reader.uint64();
                    break;
                case 3:
                    message.type = reader.uint64();
                    break;
                case 4:
                    message.requirement = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        EosActionLinkAuth.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        EosActionLinkAuth.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.account != null && message.hasOwnProperty("account"))
                if (!$util.isInteger(message.account) && !(message.account && $util.isInteger(message.account.low) && $util.isInteger(message.account.high)))
                    return "account: integer|Long expected";
            if (message.code != null && message.hasOwnProperty("code"))
                if (!$util.isInteger(message.code) && !(message.code && $util.isInteger(message.code.low) && $util.isInteger(message.code.high)))
                    return "code: integer|Long expected";
            if (message.type != null && message.hasOwnProperty("type"))
                if (!$util.isInteger(message.type) && !(message.type && $util.isInteger(message.type.low) && $util.isInteger(message.type.high)))
                    return "type: integer|Long expected";
            if (message.requirement != null && message.hasOwnProperty("requirement"))
                if (!$util.isInteger(message.requirement) && !(message.requirement && $util.isInteger(message.requirement.low) && $util.isInteger(message.requirement.high)))
                    return "requirement: integer|Long expected";
            return null;
        };

        EosActionLinkAuth.fromObject = function fromObject(object) {
            if (object instanceof $root.EosTxActionAck.EosActionLinkAuth)
                return object;
            var message = new $root.EosTxActionAck.EosActionLinkAuth();
            if (object.account != null)
                if ($util.Long)
                    (message.account = $util.Long.fromValue(object.account)).unsigned = true;
                else if (typeof object.account === "string")
                    message.account = parseInt(object.account, 10);
                else if (typeof object.account === "number")
                    message.account = object.account;
                else if (typeof object.account === "object")
                    message.account = new $util.LongBits(object.account.low >>> 0, object.account.high >>> 0).toNumber(true);
            if (object.code != null)
                if ($util.Long)
                    (message.code = $util.Long.fromValue(object.code)).unsigned = true;
                else if (typeof object.code === "string")
                    message.code = parseInt(object.code, 10);
                else if (typeof object.code === "number")
                    message.code = object.code;
                else if (typeof object.code === "object")
                    message.code = new $util.LongBits(object.code.low >>> 0, object.code.high >>> 0).toNumber(true);
            if (object.type != null)
                if ($util.Long)
                    (message.type = $util.Long.fromValue(object.type)).unsigned = true;
                else if (typeof object.type === "string")
                    message.type = parseInt(object.type, 10);
                else if (typeof object.type === "number")
                    message.type = object.type;
                else if (typeof object.type === "object")
                    message.type = new $util.LongBits(object.type.low >>> 0, object.type.high >>> 0).toNumber(true);
            if (object.requirement != null)
                if ($util.Long)
                    (message.requirement = $util.Long.fromValue(object.requirement)).unsigned = true;
                else if (typeof object.requirement === "string")
                    message.requirement = parseInt(object.requirement, 10);
                else if (typeof object.requirement === "number")
                    message.requirement = object.requirement;
                else if (typeof object.requirement === "object")
                    message.requirement = new $util.LongBits(object.requirement.low >>> 0, object.requirement.high >>> 0).toNumber(true);
            return message;
        };

        EosActionLinkAuth.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.account = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.account = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.code = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.code = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.type = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.type = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.requirement = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.requirement = options.longs === String ? "0" : 0;
            }
            if (message.account != null && message.hasOwnProperty("account"))
                if (typeof message.account === "number")
                    object.account = options.longs === String ? String(message.account) : message.account;
                else
                    object.account = options.longs === String ? $util.Long.prototype.toString.call(message.account) : options.longs === Number ? new $util.LongBits(message.account.low >>> 0, message.account.high >>> 0).toNumber(true) : message.account;
            if (message.code != null && message.hasOwnProperty("code"))
                if (typeof message.code === "number")
                    object.code = options.longs === String ? String(message.code) : message.code;
                else
                    object.code = options.longs === String ? $util.Long.prototype.toString.call(message.code) : options.longs === Number ? new $util.LongBits(message.code.low >>> 0, message.code.high >>> 0).toNumber(true) : message.code;
            if (message.type != null && message.hasOwnProperty("type"))
                if (typeof message.type === "number")
                    object.type = options.longs === String ? String(message.type) : message.type;
                else
                    object.type = options.longs === String ? $util.Long.prototype.toString.call(message.type) : options.longs === Number ? new $util.LongBits(message.type.low >>> 0, message.type.high >>> 0).toNumber(true) : message.type;
            if (message.requirement != null && message.hasOwnProperty("requirement"))
                if (typeof message.requirement === "number")
                    object.requirement = options.longs === String ? String(message.requirement) : message.requirement;
                else
                    object.requirement = options.longs === String ? $util.Long.prototype.toString.call(message.requirement) : options.longs === Number ? new $util.LongBits(message.requirement.low >>> 0, message.requirement.high >>> 0).toNumber(true) : message.requirement;
            return object;
        };

        EosActionLinkAuth.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EosActionLinkAuth;
    })();

    EosTxActionAck.EosActionUnlinkAuth = (function() {

        function EosActionUnlinkAuth(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        EosActionUnlinkAuth.prototype.account = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        EosActionUnlinkAuth.prototype.code = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        EosActionUnlinkAuth.prototype.type = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        EosActionUnlinkAuth.create = function create(properties) {
            return new EosActionUnlinkAuth(properties);
        };

        EosActionUnlinkAuth.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.account != null && Object.hasOwnProperty.call(message, "account"))
                writer.uint32(8).uint64(message.account);
            if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                writer.uint32(16).uint64(message.code);
            if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                writer.uint32(24).uint64(message.type);
            return writer;
        };

        EosActionUnlinkAuth.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        EosActionUnlinkAuth.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EosTxActionAck.EosActionUnlinkAuth();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.account = reader.uint64();
                    break;
                case 2:
                    message.code = reader.uint64();
                    break;
                case 3:
                    message.type = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        EosActionUnlinkAuth.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        EosActionUnlinkAuth.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.account != null && message.hasOwnProperty("account"))
                if (!$util.isInteger(message.account) && !(message.account && $util.isInteger(message.account.low) && $util.isInteger(message.account.high)))
                    return "account: integer|Long expected";
            if (message.code != null && message.hasOwnProperty("code"))
                if (!$util.isInteger(message.code) && !(message.code && $util.isInteger(message.code.low) && $util.isInteger(message.code.high)))
                    return "code: integer|Long expected";
            if (message.type != null && message.hasOwnProperty("type"))
                if (!$util.isInteger(message.type) && !(message.type && $util.isInteger(message.type.low) && $util.isInteger(message.type.high)))
                    return "type: integer|Long expected";
            return null;
        };

        EosActionUnlinkAuth.fromObject = function fromObject(object) {
            if (object instanceof $root.EosTxActionAck.EosActionUnlinkAuth)
                return object;
            var message = new $root.EosTxActionAck.EosActionUnlinkAuth();
            if (object.account != null)
                if ($util.Long)
                    (message.account = $util.Long.fromValue(object.account)).unsigned = true;
                else if (typeof object.account === "string")
                    message.account = parseInt(object.account, 10);
                else if (typeof object.account === "number")
                    message.account = object.account;
                else if (typeof object.account === "object")
                    message.account = new $util.LongBits(object.account.low >>> 0, object.account.high >>> 0).toNumber(true);
            if (object.code != null)
                if ($util.Long)
                    (message.code = $util.Long.fromValue(object.code)).unsigned = true;
                else if (typeof object.code === "string")
                    message.code = parseInt(object.code, 10);
                else if (typeof object.code === "number")
                    message.code = object.code;
                else if (typeof object.code === "object")
                    message.code = new $util.LongBits(object.code.low >>> 0, object.code.high >>> 0).toNumber(true);
            if (object.type != null)
                if ($util.Long)
                    (message.type = $util.Long.fromValue(object.type)).unsigned = true;
                else if (typeof object.type === "string")
                    message.type = parseInt(object.type, 10);
                else if (typeof object.type === "number")
                    message.type = object.type;
                else if (typeof object.type === "object")
                    message.type = new $util.LongBits(object.type.low >>> 0, object.type.high >>> 0).toNumber(true);
            return message;
        };

        EosActionUnlinkAuth.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.account = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.account = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.code = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.code = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.type = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.type = options.longs === String ? "0" : 0;
            }
            if (message.account != null && message.hasOwnProperty("account"))
                if (typeof message.account === "number")
                    object.account = options.longs === String ? String(message.account) : message.account;
                else
                    object.account = options.longs === String ? $util.Long.prototype.toString.call(message.account) : options.longs === Number ? new $util.LongBits(message.account.low >>> 0, message.account.high >>> 0).toNumber(true) : message.account;
            if (message.code != null && message.hasOwnProperty("code"))
                if (typeof message.code === "number")
                    object.code = options.longs === String ? String(message.code) : message.code;
                else
                    object.code = options.longs === String ? $util.Long.prototype.toString.call(message.code) : options.longs === Number ? new $util.LongBits(message.code.low >>> 0, message.code.high >>> 0).toNumber(true) : message.code;
            if (message.type != null && message.hasOwnProperty("type"))
                if (typeof message.type === "number")
                    object.type = options.longs === String ? String(message.type) : message.type;
                else
                    object.type = options.longs === String ? $util.Long.prototype.toString.call(message.type) : options.longs === Number ? new $util.LongBits(message.type.low >>> 0, message.type.high >>> 0).toNumber(true) : message.type;
            return object;
        };

        EosActionUnlinkAuth.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EosActionUnlinkAuth;
    })();

    EosTxActionAck.EosActionNewAccount = (function() {

        function EosActionNewAccount(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        EosActionNewAccount.prototype.creator = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        EosActionNewAccount.prototype.name = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        EosActionNewAccount.prototype.owner = null;
        EosActionNewAccount.prototype.active = null;

        EosActionNewAccount.create = function create(properties) {
            return new EosActionNewAccount(properties);
        };

        EosActionNewAccount.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.creator != null && Object.hasOwnProperty.call(message, "creator"))
                writer.uint32(8).uint64(message.creator);
            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                writer.uint32(16).uint64(message.name);
            if (message.owner != null && Object.hasOwnProperty.call(message, "owner"))
                $root.EosTxActionAck.EosAuthorization.encode(message.owner, writer.uint32(26).fork()).ldelim();
            if (message.active != null && Object.hasOwnProperty.call(message, "active"))
                $root.EosTxActionAck.EosAuthorization.encode(message.active, writer.uint32(34).fork()).ldelim();
            return writer;
        };

        EosActionNewAccount.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        EosActionNewAccount.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EosTxActionAck.EosActionNewAccount();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.creator = reader.uint64();
                    break;
                case 2:
                    message.name = reader.uint64();
                    break;
                case 3:
                    message.owner = $root.EosTxActionAck.EosAuthorization.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.active = $root.EosTxActionAck.EosAuthorization.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        EosActionNewAccount.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        EosActionNewAccount.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.creator != null && message.hasOwnProperty("creator"))
                if (!$util.isInteger(message.creator) && !(message.creator && $util.isInteger(message.creator.low) && $util.isInteger(message.creator.high)))
                    return "creator: integer|Long expected";
            if (message.name != null && message.hasOwnProperty("name"))
                if (!$util.isInteger(message.name) && !(message.name && $util.isInteger(message.name.low) && $util.isInteger(message.name.high)))
                    return "name: integer|Long expected";
            if (message.owner != null && message.hasOwnProperty("owner")) {
                var error = $root.EosTxActionAck.EosAuthorization.verify(message.owner);
                if (error)
                    return "owner." + error;
            }
            if (message.active != null && message.hasOwnProperty("active")) {
                var error = $root.EosTxActionAck.EosAuthorization.verify(message.active);
                if (error)
                    return "active." + error;
            }
            return null;
        };

        EosActionNewAccount.fromObject = function fromObject(object) {
            if (object instanceof $root.EosTxActionAck.EosActionNewAccount)
                return object;
            var message = new $root.EosTxActionAck.EosActionNewAccount();
            if (object.creator != null)
                if ($util.Long)
                    (message.creator = $util.Long.fromValue(object.creator)).unsigned = true;
                else if (typeof object.creator === "string")
                    message.creator = parseInt(object.creator, 10);
                else if (typeof object.creator === "number")
                    message.creator = object.creator;
                else if (typeof object.creator === "object")
                    message.creator = new $util.LongBits(object.creator.low >>> 0, object.creator.high >>> 0).toNumber(true);
            if (object.name != null)
                if ($util.Long)
                    (message.name = $util.Long.fromValue(object.name)).unsigned = true;
                else if (typeof object.name === "string")
                    message.name = parseInt(object.name, 10);
                else if (typeof object.name === "number")
                    message.name = object.name;
                else if (typeof object.name === "object")
                    message.name = new $util.LongBits(object.name.low >>> 0, object.name.high >>> 0).toNumber(true);
            if (object.owner != null) {
                if (typeof object.owner !== "object")
                    throw TypeError(".EosTxActionAck.EosActionNewAccount.owner: object expected");
                message.owner = $root.EosTxActionAck.EosAuthorization.fromObject(object.owner);
            }
            if (object.active != null) {
                if (typeof object.active !== "object")
                    throw TypeError(".EosTxActionAck.EosActionNewAccount.active: object expected");
                message.active = $root.EosTxActionAck.EosAuthorization.fromObject(object.active);
            }
            return message;
        };

        EosActionNewAccount.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.creator = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.creator = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.name = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.name = options.longs === String ? "0" : 0;
                object.owner = null;
                object.active = null;
            }
            if (message.creator != null && message.hasOwnProperty("creator"))
                if (typeof message.creator === "number")
                    object.creator = options.longs === String ? String(message.creator) : message.creator;
                else
                    object.creator = options.longs === String ? $util.Long.prototype.toString.call(message.creator) : options.longs === Number ? new $util.LongBits(message.creator.low >>> 0, message.creator.high >>> 0).toNumber(true) : message.creator;
            if (message.name != null && message.hasOwnProperty("name"))
                if (typeof message.name === "number")
                    object.name = options.longs === String ? String(message.name) : message.name;
                else
                    object.name = options.longs === String ? $util.Long.prototype.toString.call(message.name) : options.longs === Number ? new $util.LongBits(message.name.low >>> 0, message.name.high >>> 0).toNumber(true) : message.name;
            if (message.owner != null && message.hasOwnProperty("owner"))
                object.owner = $root.EosTxActionAck.EosAuthorization.toObject(message.owner, options);
            if (message.active != null && message.hasOwnProperty("active"))
                object.active = $root.EosTxActionAck.EosAuthorization.toObject(message.active, options);
            return object;
        };

        EosActionNewAccount.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EosActionNewAccount;
    })();

    EosTxActionAck.EosActionUnknown = (function() {

        function EosActionUnknown(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        EosActionUnknown.prototype.data_size = 0;
        EosActionUnknown.prototype.data_chunk = $util.newBuffer([]);

        EosActionUnknown.create = function create(properties) {
            return new EosActionUnknown(properties);
        };

        EosActionUnknown.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(8).uint32(message.data_size);
            if (message.data_chunk != null && Object.hasOwnProperty.call(message, "data_chunk"))
                writer.uint32(18).bytes(message.data_chunk);
            return writer;
        };

        EosActionUnknown.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        EosActionUnknown.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EosTxActionAck.EosActionUnknown();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.data_size = reader.uint32();
                    break;
                case 2:
                    message.data_chunk = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("data_size"))
                throw $util.ProtocolError("missing required 'data_size'", { instance: message });
            return message;
        };

        EosActionUnknown.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        EosActionUnknown.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isInteger(message.data_size))
                return "data_size: integer expected";
            if (message.data_chunk != null && message.hasOwnProperty("data_chunk"))
                if (!(message.data_chunk && typeof message.data_chunk.length === "number" || $util.isString(message.data_chunk)))
                    return "data_chunk: buffer expected";
            return null;
        };

        EosActionUnknown.fromObject = function fromObject(object) {
            if (object instanceof $root.EosTxActionAck.EosActionUnknown)
                return object;
            var message = new $root.EosTxActionAck.EosActionUnknown();
            if (object.data_size != null)
                message.data_size = object.data_size >>> 0;
            if (object.data_chunk != null)
                if (typeof object.data_chunk === "string")
                    $util.base64.decode(object.data_chunk, message.data_chunk = $util.newBuffer($util.base64.length(object.data_chunk)), 0);
                else if (object.data_chunk.length)
                    message.data_chunk = object.data_chunk;
            return message;
        };

        EosActionUnknown.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.data_size = 0;
                if (options.bytes === String)
                    object.data_chunk = "";
                else {
                    object.data_chunk = [];
                    if (options.bytes !== Array)
                        object.data_chunk = $util.newBuffer(object.data_chunk);
                }
            }
            if (message.data_size != null && message.hasOwnProperty("data_size"))
                object.data_size = message.data_size;
            if (message.data_chunk != null && message.hasOwnProperty("data_chunk"))
                object.data_chunk = options.bytes === String ? $util.base64.encode(message.data_chunk, 0, message.data_chunk.length) : options.bytes === Array ? Array.prototype.slice.call(message.data_chunk) : message.data_chunk;
            return object;
        };

        EosActionUnknown.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EosActionUnknown;
    })();

    return EosTxActionAck;
})();

$root.EosSignedTx = (function() {

    function EosSignedTx(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EosSignedTx.prototype.signature = "";

    EosSignedTx.create = function create(properties) {
        return new EosSignedTx(properties);
    };

    EosSignedTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.signature);
        return writer;
    };

    EosSignedTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EosSignedTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EosSignedTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.signature = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        return message;
    };

    EosSignedTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EosSignedTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.signature))
            return "signature: string expected";
        return null;
    };

    EosSignedTx.fromObject = function fromObject(object) {
        if (object instanceof $root.EosSignedTx)
            return object;
        var message = new $root.EosSignedTx();
        if (object.signature != null)
            message.signature = String(object.signature);
        return message;
    };

    EosSignedTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.signature = "";
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = message.signature;
        return object;
    };

    EosSignedTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EosSignedTx;
})();

$root.EthereumDefinitionType = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "NETWORK"] = 0;
    values[valuesById[1] = "TOKEN"] = 1;
    return values;
})();

$root.EthereumNetworkInfo = (function() {

    function EthereumNetworkInfo(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumNetworkInfo.prototype.chain_id = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    EthereumNetworkInfo.prototype.symbol = "";
    EthereumNetworkInfo.prototype.slip44 = 0;
    EthereumNetworkInfo.prototype.name = "";
    EthereumNetworkInfo.prototype.icon = "";
    EthereumNetworkInfo.prototype.primary_color = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    EthereumNetworkInfo.create = function create(properties) {
        return new EthereumNetworkInfo(properties);
    };

    EthereumNetworkInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).uint64(message.chain_id);
        writer.uint32(18).string(message.symbol);
        writer.uint32(24).uint32(message.slip44);
        writer.uint32(34).string(message.name);
        if (message.icon != null && Object.hasOwnProperty.call(message, "icon"))
            writer.uint32(810).string(message.icon);
        if (message.primary_color != null && Object.hasOwnProperty.call(message, "primary_color"))
            writer.uint32(816).uint64(message.primary_color);
        return writer;
    };

    EthereumNetworkInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumNetworkInfo.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumNetworkInfo();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.chain_id = reader.uint64();
                break;
            case 2:
                message.symbol = reader.string();
                break;
            case 3:
                message.slip44 = reader.uint32();
                break;
            case 4:
                message.name = reader.string();
                break;
            case 101:
                message.icon = reader.string();
                break;
            case 102:
                message.primary_color = reader.uint64();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("chain_id"))
            throw $util.ProtocolError("missing required 'chain_id'", { instance: message });
        if (!message.hasOwnProperty("symbol"))
            throw $util.ProtocolError("missing required 'symbol'", { instance: message });
        if (!message.hasOwnProperty("slip44"))
            throw $util.ProtocolError("missing required 'slip44'", { instance: message });
        if (!message.hasOwnProperty("name"))
            throw $util.ProtocolError("missing required 'name'", { instance: message });
        return message;
    };

    EthereumNetworkInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumNetworkInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isInteger(message.chain_id) && !(message.chain_id && $util.isInteger(message.chain_id.low) && $util.isInteger(message.chain_id.high)))
            return "chain_id: integer|Long expected";
        if (!$util.isString(message.symbol))
            return "symbol: string expected";
        if (!$util.isInteger(message.slip44))
            return "slip44: integer expected";
        if (!$util.isString(message.name))
            return "name: string expected";
        if (message.icon != null && message.hasOwnProperty("icon"))
            if (!$util.isString(message.icon))
                return "icon: string expected";
        if (message.primary_color != null && message.hasOwnProperty("primary_color"))
            if (!$util.isInteger(message.primary_color) && !(message.primary_color && $util.isInteger(message.primary_color.low) && $util.isInteger(message.primary_color.high)))
                return "primary_color: integer|Long expected";
        return null;
    };

    EthereumNetworkInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumNetworkInfo)
            return object;
        var message = new $root.EthereumNetworkInfo();
        if (object.chain_id != null)
            if ($util.Long)
                (message.chain_id = $util.Long.fromValue(object.chain_id)).unsigned = true;
            else if (typeof object.chain_id === "string")
                message.chain_id = parseInt(object.chain_id, 10);
            else if (typeof object.chain_id === "number")
                message.chain_id = object.chain_id;
            else if (typeof object.chain_id === "object")
                message.chain_id = new $util.LongBits(object.chain_id.low >>> 0, object.chain_id.high >>> 0).toNumber(true);
        if (object.symbol != null)
            message.symbol = String(object.symbol);
        if (object.slip44 != null)
            message.slip44 = object.slip44 >>> 0;
        if (object.name != null)
            message.name = String(object.name);
        if (object.icon != null)
            message.icon = String(object.icon);
        if (object.primary_color != null)
            if ($util.Long)
                (message.primary_color = $util.Long.fromValue(object.primary_color)).unsigned = true;
            else if (typeof object.primary_color === "string")
                message.primary_color = parseInt(object.primary_color, 10);
            else if (typeof object.primary_color === "number")
                message.primary_color = object.primary_color;
            else if (typeof object.primary_color === "object")
                message.primary_color = new $util.LongBits(object.primary_color.low >>> 0, object.primary_color.high >>> 0).toNumber(true);
        return message;
    };

    EthereumNetworkInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.chain_id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.chain_id = options.longs === String ? "0" : 0;
            object.symbol = "";
            object.slip44 = 0;
            object.name = "";
            object.icon = "";
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.primary_color = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.primary_color = options.longs === String ? "0" : 0;
        }
        if (message.chain_id != null && message.hasOwnProperty("chain_id"))
            if (typeof message.chain_id === "number")
                object.chain_id = options.longs === String ? String(message.chain_id) : message.chain_id;
            else
                object.chain_id = options.longs === String ? $util.Long.prototype.toString.call(message.chain_id) : options.longs === Number ? new $util.LongBits(message.chain_id.low >>> 0, message.chain_id.high >>> 0).toNumber(true) : message.chain_id;
        if (message.symbol != null && message.hasOwnProperty("symbol"))
            object.symbol = message.symbol;
        if (message.slip44 != null && message.hasOwnProperty("slip44"))
            object.slip44 = message.slip44;
        if (message.name != null && message.hasOwnProperty("name"))
            object.name = message.name;
        if (message.icon != null && message.hasOwnProperty("icon"))
            object.icon = message.icon;
        if (message.primary_color != null && message.hasOwnProperty("primary_color"))
            if (typeof message.primary_color === "number")
                object.primary_color = options.longs === String ? String(message.primary_color) : message.primary_color;
            else
                object.primary_color = options.longs === String ? $util.Long.prototype.toString.call(message.primary_color) : options.longs === Number ? new $util.LongBits(message.primary_color.low >>> 0, message.primary_color.high >>> 0).toNumber(true) : message.primary_color;
        return object;
    };

    EthereumNetworkInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumNetworkInfo;
})();

$root.EthereumTokenInfo = (function() {

    function EthereumTokenInfo(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumTokenInfo.prototype.address = $util.newBuffer([]);
    EthereumTokenInfo.prototype.chain_id = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    EthereumTokenInfo.prototype.symbol = "";
    EthereumTokenInfo.prototype.decimals = 0;
    EthereumTokenInfo.prototype.name = "";

    EthereumTokenInfo.create = function create(properties) {
        return new EthereumTokenInfo(properties);
    };

    EthereumTokenInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.address);
        writer.uint32(16).uint64(message.chain_id);
        writer.uint32(26).string(message.symbol);
        writer.uint32(32).uint32(message.decimals);
        writer.uint32(42).string(message.name);
        return writer;
    };

    EthereumTokenInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumTokenInfo.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumTokenInfo();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.bytes();
                break;
            case 2:
                message.chain_id = reader.uint64();
                break;
            case 3:
                message.symbol = reader.string();
                break;
            case 4:
                message.decimals = reader.uint32();
                break;
            case 5:
                message.name = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("address"))
            throw $util.ProtocolError("missing required 'address'", { instance: message });
        if (!message.hasOwnProperty("chain_id"))
            throw $util.ProtocolError("missing required 'chain_id'", { instance: message });
        if (!message.hasOwnProperty("symbol"))
            throw $util.ProtocolError("missing required 'symbol'", { instance: message });
        if (!message.hasOwnProperty("decimals"))
            throw $util.ProtocolError("missing required 'decimals'", { instance: message });
        if (!message.hasOwnProperty("name"))
            throw $util.ProtocolError("missing required 'name'", { instance: message });
        return message;
    };

    EthereumTokenInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumTokenInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.address && typeof message.address.length === "number" || $util.isString(message.address)))
            return "address: buffer expected";
        if (!$util.isInteger(message.chain_id) && !(message.chain_id && $util.isInteger(message.chain_id.low) && $util.isInteger(message.chain_id.high)))
            return "chain_id: integer|Long expected";
        if (!$util.isString(message.symbol))
            return "symbol: string expected";
        if (!$util.isInteger(message.decimals))
            return "decimals: integer expected";
        if (!$util.isString(message.name))
            return "name: string expected";
        return null;
    };

    EthereumTokenInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumTokenInfo)
            return object;
        var message = new $root.EthereumTokenInfo();
        if (object.address != null)
            if (typeof object.address === "string")
                $util.base64.decode(object.address, message.address = $util.newBuffer($util.base64.length(object.address)), 0);
            else if (object.address.length)
                message.address = object.address;
        if (object.chain_id != null)
            if ($util.Long)
                (message.chain_id = $util.Long.fromValue(object.chain_id)).unsigned = true;
            else if (typeof object.chain_id === "string")
                message.chain_id = parseInt(object.chain_id, 10);
            else if (typeof object.chain_id === "number")
                message.chain_id = object.chain_id;
            else if (typeof object.chain_id === "object")
                message.chain_id = new $util.LongBits(object.chain_id.low >>> 0, object.chain_id.high >>> 0).toNumber(true);
        if (object.symbol != null)
            message.symbol = String(object.symbol);
        if (object.decimals != null)
            message.decimals = object.decimals >>> 0;
        if (object.name != null)
            message.name = String(object.name);
        return message;
    };

    EthereumTokenInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.address = "";
            else {
                object.address = [];
                if (options.bytes !== Array)
                    object.address = $util.newBuffer(object.address);
            }
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.chain_id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.chain_id = options.longs === String ? "0" : 0;
            object.symbol = "";
            object.decimals = 0;
            object.name = "";
        }
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = options.bytes === String ? $util.base64.encode(message.address, 0, message.address.length) : options.bytes === Array ? Array.prototype.slice.call(message.address) : message.address;
        if (message.chain_id != null && message.hasOwnProperty("chain_id"))
            if (typeof message.chain_id === "number")
                object.chain_id = options.longs === String ? String(message.chain_id) : message.chain_id;
            else
                object.chain_id = options.longs === String ? $util.Long.prototype.toString.call(message.chain_id) : options.longs === Number ? new $util.LongBits(message.chain_id.low >>> 0, message.chain_id.high >>> 0).toNumber(true) : message.chain_id;
        if (message.symbol != null && message.hasOwnProperty("symbol"))
            object.symbol = message.symbol;
        if (message.decimals != null && message.hasOwnProperty("decimals"))
            object.decimals = message.decimals;
        if (message.name != null && message.hasOwnProperty("name"))
            object.name = message.name;
        return object;
    };

    EthereumTokenInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumTokenInfo;
})();

$root.EthereumDefinitions = (function() {

    function EthereumDefinitions(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumDefinitions.prototype.encoded_network = $util.newBuffer([]);
    EthereumDefinitions.prototype.encoded_token = $util.newBuffer([]);

    EthereumDefinitions.create = function create(properties) {
        return new EthereumDefinitions(properties);
    };

    EthereumDefinitions.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.encoded_network != null && Object.hasOwnProperty.call(message, "encoded_network"))
            writer.uint32(10).bytes(message.encoded_network);
        if (message.encoded_token != null && Object.hasOwnProperty.call(message, "encoded_token"))
            writer.uint32(18).bytes(message.encoded_token);
        return writer;
    };

    EthereumDefinitions.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumDefinitions.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumDefinitions();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.encoded_network = reader.bytes();
                break;
            case 2:
                message.encoded_token = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    EthereumDefinitions.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumDefinitions.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.encoded_network != null && message.hasOwnProperty("encoded_network"))
            if (!(message.encoded_network && typeof message.encoded_network.length === "number" || $util.isString(message.encoded_network)))
                return "encoded_network: buffer expected";
        if (message.encoded_token != null && message.hasOwnProperty("encoded_token"))
            if (!(message.encoded_token && typeof message.encoded_token.length === "number" || $util.isString(message.encoded_token)))
                return "encoded_token: buffer expected";
        return null;
    };

    EthereumDefinitions.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumDefinitions)
            return object;
        var message = new $root.EthereumDefinitions();
        if (object.encoded_network != null)
            if (typeof object.encoded_network === "string")
                $util.base64.decode(object.encoded_network, message.encoded_network = $util.newBuffer($util.base64.length(object.encoded_network)), 0);
            else if (object.encoded_network.length)
                message.encoded_network = object.encoded_network;
        if (object.encoded_token != null)
            if (typeof object.encoded_token === "string")
                $util.base64.decode(object.encoded_token, message.encoded_token = $util.newBuffer($util.base64.length(object.encoded_token)), 0);
            else if (object.encoded_token.length)
                message.encoded_token = object.encoded_token;
        return message;
    };

    EthereumDefinitions.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.encoded_network = "";
            else {
                object.encoded_network = [];
                if (options.bytes !== Array)
                    object.encoded_network = $util.newBuffer(object.encoded_network);
            }
            if (options.bytes === String)
                object.encoded_token = "";
            else {
                object.encoded_token = [];
                if (options.bytes !== Array)
                    object.encoded_token = $util.newBuffer(object.encoded_token);
            }
        }
        if (message.encoded_network != null && message.hasOwnProperty("encoded_network"))
            object.encoded_network = options.bytes === String ? $util.base64.encode(message.encoded_network, 0, message.encoded_network.length) : options.bytes === Array ? Array.prototype.slice.call(message.encoded_network) : message.encoded_network;
        if (message.encoded_token != null && message.hasOwnProperty("encoded_token"))
            object.encoded_token = options.bytes === String ? $util.base64.encode(message.encoded_token, 0, message.encoded_token.length) : options.bytes === Array ? Array.prototype.slice.call(message.encoded_token) : message.encoded_token;
        return object;
    };

    EthereumDefinitions.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumDefinitions;
})();

$root.EthereumSignTypedDataOneKey = (function() {

    function EthereumSignTypedDataOneKey(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumSignTypedDataOneKey.prototype.address_n = $util.emptyArray;
    EthereumSignTypedDataOneKey.prototype.primary_type = "";
    EthereumSignTypedDataOneKey.prototype.metamask_v4_compat = true;
    EthereumSignTypedDataOneKey.prototype.chain_id = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    EthereumSignTypedDataOneKey.create = function create(properties) {
        return new EthereumSignTypedDataOneKey(properties);
    };

    EthereumSignTypedDataOneKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).string(message.primary_type);
        if (message.metamask_v4_compat != null && Object.hasOwnProperty.call(message, "metamask_v4_compat"))
            writer.uint32(24).bool(message.metamask_v4_compat);
        if (message.chain_id != null && Object.hasOwnProperty.call(message, "chain_id"))
            writer.uint32(32).uint64(message.chain_id);
        return writer;
    };

    EthereumSignTypedDataOneKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumSignTypedDataOneKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumSignTypedDataOneKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.primary_type = reader.string();
                break;
            case 3:
                message.metamask_v4_compat = reader.bool();
                break;
            case 4:
                message.chain_id = reader.uint64();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("primary_type"))
            throw $util.ProtocolError("missing required 'primary_type'", { instance: message });
        return message;
    };

    EthereumSignTypedDataOneKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumSignTypedDataOneKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!$util.isString(message.primary_type))
            return "primary_type: string expected";
        if (message.metamask_v4_compat != null && message.hasOwnProperty("metamask_v4_compat"))
            if (typeof message.metamask_v4_compat !== "boolean")
                return "metamask_v4_compat: boolean expected";
        if (message.chain_id != null && message.hasOwnProperty("chain_id"))
            if (!$util.isInteger(message.chain_id) && !(message.chain_id && $util.isInteger(message.chain_id.low) && $util.isInteger(message.chain_id.high)))
                return "chain_id: integer|Long expected";
        return null;
    };

    EthereumSignTypedDataOneKey.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumSignTypedDataOneKey)
            return object;
        var message = new $root.EthereumSignTypedDataOneKey();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".EthereumSignTypedDataOneKey.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.primary_type != null)
            message.primary_type = String(object.primary_type);
        if (object.metamask_v4_compat != null)
            message.metamask_v4_compat = Boolean(object.metamask_v4_compat);
        if (object.chain_id != null)
            if ($util.Long)
                (message.chain_id = $util.Long.fromValue(object.chain_id)).unsigned = true;
            else if (typeof object.chain_id === "string")
                message.chain_id = parseInt(object.chain_id, 10);
            else if (typeof object.chain_id === "number")
                message.chain_id = object.chain_id;
            else if (typeof object.chain_id === "object")
                message.chain_id = new $util.LongBits(object.chain_id.low >>> 0, object.chain_id.high >>> 0).toNumber(true);
        return message;
    };

    EthereumSignTypedDataOneKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            object.primary_type = "";
            object.metamask_v4_compat = true;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.chain_id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.chain_id = options.longs === String ? "0" : 0;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.primary_type != null && message.hasOwnProperty("primary_type"))
            object.primary_type = message.primary_type;
        if (message.metamask_v4_compat != null && message.hasOwnProperty("metamask_v4_compat"))
            object.metamask_v4_compat = message.metamask_v4_compat;
        if (message.chain_id != null && message.hasOwnProperty("chain_id"))
            if (typeof message.chain_id === "number")
                object.chain_id = options.longs === String ? String(message.chain_id) : message.chain_id;
            else
                object.chain_id = options.longs === String ? $util.Long.prototype.toString.call(message.chain_id) : options.longs === Number ? new $util.LongBits(message.chain_id.low >>> 0, message.chain_id.high >>> 0).toNumber(true) : message.chain_id;
        return object;
    };

    EthereumSignTypedDataOneKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumSignTypedDataOneKey;
})();

$root.EthereumGnosisSafeTxOperation = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "CALL"] = 0;
    values[valuesById[1] = "DELEGATE_CALL"] = 1;
    return values;
})();

$root.EthereumGnosisSafeTxRequest = (function() {

    function EthereumGnosisSafeTxRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumGnosisSafeTxRequest.create = function create(properties) {
        return new EthereumGnosisSafeTxRequest(properties);
    };

    EthereumGnosisSafeTxRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    EthereumGnosisSafeTxRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumGnosisSafeTxRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumGnosisSafeTxRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    EthereumGnosisSafeTxRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumGnosisSafeTxRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    EthereumGnosisSafeTxRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumGnosisSafeTxRequest)
            return object;
        return new $root.EthereumGnosisSafeTxRequest();
    };

    EthereumGnosisSafeTxRequest.toObject = function toObject() {
        return {};
    };

    EthereumGnosisSafeTxRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumGnosisSafeTxRequest;
})();

$root.EthereumGnosisSafeTxAck = (function() {

    function EthereumGnosisSafeTxAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumGnosisSafeTxAck.prototype.to = "";
    EthereumGnosisSafeTxAck.prototype.value = $util.newBuffer([]);
    EthereumGnosisSafeTxAck.prototype.data = $util.newBuffer([]);
    EthereumGnosisSafeTxAck.prototype.operation = 0;
    EthereumGnosisSafeTxAck.prototype.safeTxGas = $util.newBuffer([]);
    EthereumGnosisSafeTxAck.prototype.baseGas = $util.newBuffer([]);
    EthereumGnosisSafeTxAck.prototype.gasPrice = $util.newBuffer([]);
    EthereumGnosisSafeTxAck.prototype.gasToken = "";
    EthereumGnosisSafeTxAck.prototype.refundReceiver = "";
    EthereumGnosisSafeTxAck.prototype.nonce = $util.newBuffer([]);
    EthereumGnosisSafeTxAck.prototype.chain_id = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    EthereumGnosisSafeTxAck.prototype.verifyingContract = "";

    EthereumGnosisSafeTxAck.create = function create(properties) {
        return new EthereumGnosisSafeTxAck(properties);
    };

    EthereumGnosisSafeTxAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.to);
        writer.uint32(18).bytes(message.value);
        if (message.data != null && Object.hasOwnProperty.call(message, "data"))
            writer.uint32(26).bytes(message.data);
        writer.uint32(32).int32(message.operation);
        writer.uint32(42).bytes(message.safeTxGas);
        writer.uint32(50).bytes(message.baseGas);
        writer.uint32(58).bytes(message.gasPrice);
        writer.uint32(66).string(message.gasToken);
        writer.uint32(74).string(message.refundReceiver);
        writer.uint32(82).bytes(message.nonce);
        writer.uint32(88).uint64(message.chain_id);
        writer.uint32(98).string(message.verifyingContract);
        return writer;
    };

    EthereumGnosisSafeTxAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumGnosisSafeTxAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumGnosisSafeTxAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.to = reader.string();
                break;
            case 2:
                message.value = reader.bytes();
                break;
            case 3:
                message.data = reader.bytes();
                break;
            case 4:
                message.operation = reader.int32();
                break;
            case 5:
                message.safeTxGas = reader.bytes();
                break;
            case 6:
                message.baseGas = reader.bytes();
                break;
            case 7:
                message.gasPrice = reader.bytes();
                break;
            case 8:
                message.gasToken = reader.string();
                break;
            case 9:
                message.refundReceiver = reader.string();
                break;
            case 10:
                message.nonce = reader.bytes();
                break;
            case 11:
                message.chain_id = reader.uint64();
                break;
            case 12:
                message.verifyingContract = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("to"))
            throw $util.ProtocolError("missing required 'to'", { instance: message });
        if (!message.hasOwnProperty("value"))
            throw $util.ProtocolError("missing required 'value'", { instance: message });
        if (!message.hasOwnProperty("operation"))
            throw $util.ProtocolError("missing required 'operation'", { instance: message });
        if (!message.hasOwnProperty("safeTxGas"))
            throw $util.ProtocolError("missing required 'safeTxGas'", { instance: message });
        if (!message.hasOwnProperty("baseGas"))
            throw $util.ProtocolError("missing required 'baseGas'", { instance: message });
        if (!message.hasOwnProperty("gasPrice"))
            throw $util.ProtocolError("missing required 'gasPrice'", { instance: message });
        if (!message.hasOwnProperty("gasToken"))
            throw $util.ProtocolError("missing required 'gasToken'", { instance: message });
        if (!message.hasOwnProperty("refundReceiver"))
            throw $util.ProtocolError("missing required 'refundReceiver'", { instance: message });
        if (!message.hasOwnProperty("nonce"))
            throw $util.ProtocolError("missing required 'nonce'", { instance: message });
        if (!message.hasOwnProperty("chain_id"))
            throw $util.ProtocolError("missing required 'chain_id'", { instance: message });
        if (!message.hasOwnProperty("verifyingContract"))
            throw $util.ProtocolError("missing required 'verifyingContract'", { instance: message });
        return message;
    };

    EthereumGnosisSafeTxAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumGnosisSafeTxAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.to))
            return "to: string expected";
        if (!(message.value && typeof message.value.length === "number" || $util.isString(message.value)))
            return "value: buffer expected";
        if (message.data != null && message.hasOwnProperty("data"))
            if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
                return "data: buffer expected";
        switch (message.operation) {
        default:
            return "operation: enum value expected";
        case 0:
        case 1:
            break;
        }
        if (!(message.safeTxGas && typeof message.safeTxGas.length === "number" || $util.isString(message.safeTxGas)))
            return "safeTxGas: buffer expected";
        if (!(message.baseGas && typeof message.baseGas.length === "number" || $util.isString(message.baseGas)))
            return "baseGas: buffer expected";
        if (!(message.gasPrice && typeof message.gasPrice.length === "number" || $util.isString(message.gasPrice)))
            return "gasPrice: buffer expected";
        if (!$util.isString(message.gasToken))
            return "gasToken: string expected";
        if (!$util.isString(message.refundReceiver))
            return "refundReceiver: string expected";
        if (!(message.nonce && typeof message.nonce.length === "number" || $util.isString(message.nonce)))
            return "nonce: buffer expected";
        if (!$util.isInteger(message.chain_id) && !(message.chain_id && $util.isInteger(message.chain_id.low) && $util.isInteger(message.chain_id.high)))
            return "chain_id: integer|Long expected";
        if (!$util.isString(message.verifyingContract))
            return "verifyingContract: string expected";
        return null;
    };

    EthereumGnosisSafeTxAck.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumGnosisSafeTxAck)
            return object;
        var message = new $root.EthereumGnosisSafeTxAck();
        if (object.to != null)
            message.to = String(object.to);
        if (object.value != null)
            if (typeof object.value === "string")
                $util.base64.decode(object.value, message.value = $util.newBuffer($util.base64.length(object.value)), 0);
            else if (object.value.length)
                message.value = object.value;
        if (object.data != null)
            if (typeof object.data === "string")
                $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
            else if (object.data.length)
                message.data = object.data;
        switch (object.operation) {
        case "CALL":
        case 0:
            message.operation = 0;
            break;
        case "DELEGATE_CALL":
        case 1:
            message.operation = 1;
            break;
        }
        if (object.safeTxGas != null)
            if (typeof object.safeTxGas === "string")
                $util.base64.decode(object.safeTxGas, message.safeTxGas = $util.newBuffer($util.base64.length(object.safeTxGas)), 0);
            else if (object.safeTxGas.length)
                message.safeTxGas = object.safeTxGas;
        if (object.baseGas != null)
            if (typeof object.baseGas === "string")
                $util.base64.decode(object.baseGas, message.baseGas = $util.newBuffer($util.base64.length(object.baseGas)), 0);
            else if (object.baseGas.length)
                message.baseGas = object.baseGas;
        if (object.gasPrice != null)
            if (typeof object.gasPrice === "string")
                $util.base64.decode(object.gasPrice, message.gasPrice = $util.newBuffer($util.base64.length(object.gasPrice)), 0);
            else if (object.gasPrice.length)
                message.gasPrice = object.gasPrice;
        if (object.gasToken != null)
            message.gasToken = String(object.gasToken);
        if (object.refundReceiver != null)
            message.refundReceiver = String(object.refundReceiver);
        if (object.nonce != null)
            if (typeof object.nonce === "string")
                $util.base64.decode(object.nonce, message.nonce = $util.newBuffer($util.base64.length(object.nonce)), 0);
            else if (object.nonce.length)
                message.nonce = object.nonce;
        if (object.chain_id != null)
            if ($util.Long)
                (message.chain_id = $util.Long.fromValue(object.chain_id)).unsigned = true;
            else if (typeof object.chain_id === "string")
                message.chain_id = parseInt(object.chain_id, 10);
            else if (typeof object.chain_id === "number")
                message.chain_id = object.chain_id;
            else if (typeof object.chain_id === "object")
                message.chain_id = new $util.LongBits(object.chain_id.low >>> 0, object.chain_id.high >>> 0).toNumber(true);
        if (object.verifyingContract != null)
            message.verifyingContract = String(object.verifyingContract);
        return message;
    };

    EthereumGnosisSafeTxAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.to = "";
            if (options.bytes === String)
                object.value = "";
            else {
                object.value = [];
                if (options.bytes !== Array)
                    object.value = $util.newBuffer(object.value);
            }
            if (options.bytes === String)
                object.data = "";
            else {
                object.data = [];
                if (options.bytes !== Array)
                    object.data = $util.newBuffer(object.data);
            }
            object.operation = options.enums === String ? "CALL" : 0;
            if (options.bytes === String)
                object.safeTxGas = "";
            else {
                object.safeTxGas = [];
                if (options.bytes !== Array)
                    object.safeTxGas = $util.newBuffer(object.safeTxGas);
            }
            if (options.bytes === String)
                object.baseGas = "";
            else {
                object.baseGas = [];
                if (options.bytes !== Array)
                    object.baseGas = $util.newBuffer(object.baseGas);
            }
            if (options.bytes === String)
                object.gasPrice = "";
            else {
                object.gasPrice = [];
                if (options.bytes !== Array)
                    object.gasPrice = $util.newBuffer(object.gasPrice);
            }
            object.gasToken = "";
            object.refundReceiver = "";
            if (options.bytes === String)
                object.nonce = "";
            else {
                object.nonce = [];
                if (options.bytes !== Array)
                    object.nonce = $util.newBuffer(object.nonce);
            }
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.chain_id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.chain_id = options.longs === String ? "0" : 0;
            object.verifyingContract = "";
        }
        if (message.to != null && message.hasOwnProperty("to"))
            object.to = message.to;
        if (message.value != null && message.hasOwnProperty("value"))
            object.value = options.bytes === String ? $util.base64.encode(message.value, 0, message.value.length) : options.bytes === Array ? Array.prototype.slice.call(message.value) : message.value;
        if (message.data != null && message.hasOwnProperty("data"))
            object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
        if (message.operation != null && message.hasOwnProperty("operation"))
            object.operation = options.enums === String ? $root.EthereumGnosisSafeTxOperation[message.operation] : message.operation;
        if (message.safeTxGas != null && message.hasOwnProperty("safeTxGas"))
            object.safeTxGas = options.bytes === String ? $util.base64.encode(message.safeTxGas, 0, message.safeTxGas.length) : options.bytes === Array ? Array.prototype.slice.call(message.safeTxGas) : message.safeTxGas;
        if (message.baseGas != null && message.hasOwnProperty("baseGas"))
            object.baseGas = options.bytes === String ? $util.base64.encode(message.baseGas, 0, message.baseGas.length) : options.bytes === Array ? Array.prototype.slice.call(message.baseGas) : message.baseGas;
        if (message.gasPrice != null && message.hasOwnProperty("gasPrice"))
            object.gasPrice = options.bytes === String ? $util.base64.encode(message.gasPrice, 0, message.gasPrice.length) : options.bytes === Array ? Array.prototype.slice.call(message.gasPrice) : message.gasPrice;
        if (message.gasToken != null && message.hasOwnProperty("gasToken"))
            object.gasToken = message.gasToken;
        if (message.refundReceiver != null && message.hasOwnProperty("refundReceiver"))
            object.refundReceiver = message.refundReceiver;
        if (message.nonce != null && message.hasOwnProperty("nonce"))
            object.nonce = options.bytes === String ? $util.base64.encode(message.nonce, 0, message.nonce.length) : options.bytes === Array ? Array.prototype.slice.call(message.nonce) : message.nonce;
        if (message.chain_id != null && message.hasOwnProperty("chain_id"))
            if (typeof message.chain_id === "number")
                object.chain_id = options.longs === String ? String(message.chain_id) : message.chain_id;
            else
                object.chain_id = options.longs === String ? $util.Long.prototype.toString.call(message.chain_id) : options.longs === Number ? new $util.LongBits(message.chain_id.low >>> 0, message.chain_id.high >>> 0).toNumber(true) : message.chain_id;
        if (message.verifyingContract != null && message.hasOwnProperty("verifyingContract"))
            object.verifyingContract = message.verifyingContract;
        return object;
    };

    EthereumGnosisSafeTxAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumGnosisSafeTxAck;
})();

$root.EthereumTypedDataStructRequestOneKey = (function() {

    function EthereumTypedDataStructRequestOneKey(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumTypedDataStructRequestOneKey.prototype.name = "";

    EthereumTypedDataStructRequestOneKey.create = function create(properties) {
        return new EthereumTypedDataStructRequestOneKey(properties);
    };

    EthereumTypedDataStructRequestOneKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.name);
        return writer;
    };

    EthereumTypedDataStructRequestOneKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumTypedDataStructRequestOneKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumTypedDataStructRequestOneKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.name = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("name"))
            throw $util.ProtocolError("missing required 'name'", { instance: message });
        return message;
    };

    EthereumTypedDataStructRequestOneKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumTypedDataStructRequestOneKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.name))
            return "name: string expected";
        return null;
    };

    EthereumTypedDataStructRequestOneKey.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumTypedDataStructRequestOneKey)
            return object;
        var message = new $root.EthereumTypedDataStructRequestOneKey();
        if (object.name != null)
            message.name = String(object.name);
        return message;
    };

    EthereumTypedDataStructRequestOneKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.name = "";
        if (message.name != null && message.hasOwnProperty("name"))
            object.name = message.name;
        return object;
    };

    EthereumTypedDataStructRequestOneKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumTypedDataStructRequestOneKey;
})();

$root.EthereumTypedDataStructAckOneKey = (function() {

    function EthereumTypedDataStructAckOneKey(properties) {
        this.members = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumTypedDataStructAckOneKey.prototype.members = $util.emptyArray;

    EthereumTypedDataStructAckOneKey.create = function create(properties) {
        return new EthereumTypedDataStructAckOneKey(properties);
    };

    EthereumTypedDataStructAckOneKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.members != null && message.members.length)
            for (var i = 0; i < message.members.length; ++i)
                $root.EthereumTypedDataStructAckOneKey.EthereumStructMemberOneKey.encode(message.members[i], writer.uint32(10).fork()).ldelim();
        return writer;
    };

    EthereumTypedDataStructAckOneKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumTypedDataStructAckOneKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumTypedDataStructAckOneKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.members && message.members.length))
                    message.members = [];
                message.members.push($root.EthereumTypedDataStructAckOneKey.EthereumStructMemberOneKey.decode(reader, reader.uint32()));
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    EthereumTypedDataStructAckOneKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumTypedDataStructAckOneKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.members != null && message.hasOwnProperty("members")) {
            if (!Array.isArray(message.members))
                return "members: array expected";
            for (var i = 0; i < message.members.length; ++i) {
                var error = $root.EthereumTypedDataStructAckOneKey.EthereumStructMemberOneKey.verify(message.members[i]);
                if (error)
                    return "members." + error;
            }
        }
        return null;
    };

    EthereumTypedDataStructAckOneKey.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumTypedDataStructAckOneKey)
            return object;
        var message = new $root.EthereumTypedDataStructAckOneKey();
        if (object.members) {
            if (!Array.isArray(object.members))
                throw TypeError(".EthereumTypedDataStructAckOneKey.members: array expected");
            message.members = [];
            for (var i = 0; i < object.members.length; ++i) {
                if (typeof object.members[i] !== "object")
                    throw TypeError(".EthereumTypedDataStructAckOneKey.members: object expected");
                message.members[i] = $root.EthereumTypedDataStructAckOneKey.EthereumStructMemberOneKey.fromObject(object.members[i]);
            }
        }
        return message;
    };

    EthereumTypedDataStructAckOneKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.members = [];
        if (message.members && message.members.length) {
            object.members = [];
            for (var j = 0; j < message.members.length; ++j)
                object.members[j] = $root.EthereumTypedDataStructAckOneKey.EthereumStructMemberOneKey.toObject(message.members[j], options);
        }
        return object;
    };

    EthereumTypedDataStructAckOneKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    EthereumTypedDataStructAckOneKey.EthereumStructMemberOneKey = (function() {

        function EthereumStructMemberOneKey(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        EthereumStructMemberOneKey.prototype.type = null;
        EthereumStructMemberOneKey.prototype.name = "";

        EthereumStructMemberOneKey.create = function create(properties) {
            return new EthereumStructMemberOneKey(properties);
        };

        EthereumStructMemberOneKey.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            $root.EthereumTypedDataStructAckOneKey.EthereumFieldTypeOneKey.encode(message.type, writer.uint32(10).fork()).ldelim();
            writer.uint32(18).string(message.name);
            return writer;
        };

        EthereumStructMemberOneKey.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        EthereumStructMemberOneKey.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumTypedDataStructAckOneKey.EthereumStructMemberOneKey();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.type = $root.EthereumTypedDataStructAckOneKey.EthereumFieldTypeOneKey.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.name = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("type"))
                throw $util.ProtocolError("missing required 'type'", { instance: message });
            if (!message.hasOwnProperty("name"))
                throw $util.ProtocolError("missing required 'name'", { instance: message });
            return message;
        };

        EthereumStructMemberOneKey.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        EthereumStructMemberOneKey.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            {
                var error = $root.EthereumTypedDataStructAckOneKey.EthereumFieldTypeOneKey.verify(message.type);
                if (error)
                    return "type." + error;
            }
            if (!$util.isString(message.name))
                return "name: string expected";
            return null;
        };

        EthereumStructMemberOneKey.fromObject = function fromObject(object) {
            if (object instanceof $root.EthereumTypedDataStructAckOneKey.EthereumStructMemberOneKey)
                return object;
            var message = new $root.EthereumTypedDataStructAckOneKey.EthereumStructMemberOneKey();
            if (object.type != null) {
                if (typeof object.type !== "object")
                    throw TypeError(".EthereumTypedDataStructAckOneKey.EthereumStructMemberOneKey.type: object expected");
                message.type = $root.EthereumTypedDataStructAckOneKey.EthereumFieldTypeOneKey.fromObject(object.type);
            }
            if (object.name != null)
                message.name = String(object.name);
            return message;
        };

        EthereumStructMemberOneKey.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.type = null;
                object.name = "";
            }
            if (message.type != null && message.hasOwnProperty("type"))
                object.type = $root.EthereumTypedDataStructAckOneKey.EthereumFieldTypeOneKey.toObject(message.type, options);
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            return object;
        };

        EthereumStructMemberOneKey.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EthereumStructMemberOneKey;
    })();

    EthereumTypedDataStructAckOneKey.EthereumFieldTypeOneKey = (function() {

        function EthereumFieldTypeOneKey(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        EthereumFieldTypeOneKey.prototype.data_type = 1;
        EthereumFieldTypeOneKey.prototype.size = 0;
        EthereumFieldTypeOneKey.prototype.entry_type = null;
        EthereumFieldTypeOneKey.prototype.struct_name = "";

        EthereumFieldTypeOneKey.create = function create(properties) {
            return new EthereumFieldTypeOneKey(properties);
        };

        EthereumFieldTypeOneKey.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(8).int32(message.data_type);
            if (message.size != null && Object.hasOwnProperty.call(message, "size"))
                writer.uint32(16).uint32(message.size);
            if (message.entry_type != null && Object.hasOwnProperty.call(message, "entry_type"))
                $root.EthereumTypedDataStructAckOneKey.EthereumFieldTypeOneKey.encode(message.entry_type, writer.uint32(26).fork()).ldelim();
            if (message.struct_name != null && Object.hasOwnProperty.call(message, "struct_name"))
                writer.uint32(34).string(message.struct_name);
            return writer;
        };

        EthereumFieldTypeOneKey.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        EthereumFieldTypeOneKey.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumTypedDataStructAckOneKey.EthereumFieldTypeOneKey();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.data_type = reader.int32();
                    break;
                case 2:
                    message.size = reader.uint32();
                    break;
                case 3:
                    message.entry_type = $root.EthereumTypedDataStructAckOneKey.EthereumFieldTypeOneKey.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.struct_name = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("data_type"))
                throw $util.ProtocolError("missing required 'data_type'", { instance: message });
            return message;
        };

        EthereumFieldTypeOneKey.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        EthereumFieldTypeOneKey.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            switch (message.data_type) {
            default:
                return "data_type: enum value expected";
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
            case 8:
                break;
            }
            if (message.size != null && message.hasOwnProperty("size"))
                if (!$util.isInteger(message.size))
                    return "size: integer expected";
            if (message.entry_type != null && message.hasOwnProperty("entry_type")) {
                var error = $root.EthereumTypedDataStructAckOneKey.EthereumFieldTypeOneKey.verify(message.entry_type);
                if (error)
                    return "entry_type." + error;
            }
            if (message.struct_name != null && message.hasOwnProperty("struct_name"))
                if (!$util.isString(message.struct_name))
                    return "struct_name: string expected";
            return null;
        };

        EthereumFieldTypeOneKey.fromObject = function fromObject(object) {
            if (object instanceof $root.EthereumTypedDataStructAckOneKey.EthereumFieldTypeOneKey)
                return object;
            var message = new $root.EthereumTypedDataStructAckOneKey.EthereumFieldTypeOneKey();
            switch (object.data_type) {
            case "UINT":
            case 1:
                message.data_type = 1;
                break;
            case "INT":
            case 2:
                message.data_type = 2;
                break;
            case "BYTES":
            case 3:
                message.data_type = 3;
                break;
            case "STRING":
            case 4:
                message.data_type = 4;
                break;
            case "BOOL":
            case 5:
                message.data_type = 5;
                break;
            case "ADDRESS":
            case 6:
                message.data_type = 6;
                break;
            case "ARRAY":
            case 7:
                message.data_type = 7;
                break;
            case "STRUCT":
            case 8:
                message.data_type = 8;
                break;
            }
            if (object.size != null)
                message.size = object.size >>> 0;
            if (object.entry_type != null) {
                if (typeof object.entry_type !== "object")
                    throw TypeError(".EthereumTypedDataStructAckOneKey.EthereumFieldTypeOneKey.entry_type: object expected");
                message.entry_type = $root.EthereumTypedDataStructAckOneKey.EthereumFieldTypeOneKey.fromObject(object.entry_type);
            }
            if (object.struct_name != null)
                message.struct_name = String(object.struct_name);
            return message;
        };

        EthereumFieldTypeOneKey.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.data_type = options.enums === String ? "UINT" : 1;
                object.size = 0;
                object.entry_type = null;
                object.struct_name = "";
            }
            if (message.data_type != null && message.hasOwnProperty("data_type"))
                object.data_type = options.enums === String ? $root.EthereumTypedDataStructAckOneKey.EthereumDataTypeOneKey[message.data_type] : message.data_type;
            if (message.size != null && message.hasOwnProperty("size"))
                object.size = message.size;
            if (message.entry_type != null && message.hasOwnProperty("entry_type"))
                object.entry_type = $root.EthereumTypedDataStructAckOneKey.EthereumFieldTypeOneKey.toObject(message.entry_type, options);
            if (message.struct_name != null && message.hasOwnProperty("struct_name"))
                object.struct_name = message.struct_name;
            return object;
        };

        EthereumFieldTypeOneKey.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EthereumFieldTypeOneKey;
    })();

    EthereumTypedDataStructAckOneKey.EthereumDataTypeOneKey = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[1] = "UINT"] = 1;
        values[valuesById[2] = "INT"] = 2;
        values[valuesById[3] = "BYTES"] = 3;
        values[valuesById[4] = "STRING"] = 4;
        values[valuesById[5] = "BOOL"] = 5;
        values[valuesById[6] = "ADDRESS"] = 6;
        values[valuesById[7] = "ARRAY"] = 7;
        values[valuesById[8] = "STRUCT"] = 8;
        return values;
    })();

    return EthereumTypedDataStructAckOneKey;
})();

$root.EthereumTypedDataValueRequestOneKey = (function() {

    function EthereumTypedDataValueRequestOneKey(properties) {
        this.member_path = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumTypedDataValueRequestOneKey.prototype.member_path = $util.emptyArray;

    EthereumTypedDataValueRequestOneKey.create = function create(properties) {
        return new EthereumTypedDataValueRequestOneKey(properties);
    };

    EthereumTypedDataValueRequestOneKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.member_path != null && message.member_path.length)
            for (var i = 0; i < message.member_path.length; ++i)
                writer.uint32(8).uint32(message.member_path[i]);
        return writer;
    };

    EthereumTypedDataValueRequestOneKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumTypedDataValueRequestOneKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumTypedDataValueRequestOneKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.member_path && message.member_path.length))
                    message.member_path = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.member_path.push(reader.uint32());
                } else
                    message.member_path.push(reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    EthereumTypedDataValueRequestOneKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumTypedDataValueRequestOneKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.member_path != null && message.hasOwnProperty("member_path")) {
            if (!Array.isArray(message.member_path))
                return "member_path: array expected";
            for (var i = 0; i < message.member_path.length; ++i)
                if (!$util.isInteger(message.member_path[i]))
                    return "member_path: integer[] expected";
        }
        return null;
    };

    EthereumTypedDataValueRequestOneKey.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumTypedDataValueRequestOneKey)
            return object;
        var message = new $root.EthereumTypedDataValueRequestOneKey();
        if (object.member_path) {
            if (!Array.isArray(object.member_path))
                throw TypeError(".EthereumTypedDataValueRequestOneKey.member_path: array expected");
            message.member_path = [];
            for (var i = 0; i < object.member_path.length; ++i)
                message.member_path[i] = object.member_path[i] >>> 0;
        }
        return message;
    };

    EthereumTypedDataValueRequestOneKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.member_path = [];
        if (message.member_path && message.member_path.length) {
            object.member_path = [];
            for (var j = 0; j < message.member_path.length; ++j)
                object.member_path[j] = message.member_path[j];
        }
        return object;
    };

    EthereumTypedDataValueRequestOneKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumTypedDataValueRequestOneKey;
})();

$root.EthereumTypedDataValueAckOneKey = (function() {

    function EthereumTypedDataValueAckOneKey(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumTypedDataValueAckOneKey.prototype.value = $util.newBuffer([]);

    EthereumTypedDataValueAckOneKey.create = function create(properties) {
        return new EthereumTypedDataValueAckOneKey(properties);
    };

    EthereumTypedDataValueAckOneKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.value);
        return writer;
    };

    EthereumTypedDataValueAckOneKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumTypedDataValueAckOneKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumTypedDataValueAckOneKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.value = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("value"))
            throw $util.ProtocolError("missing required 'value'", { instance: message });
        return message;
    };

    EthereumTypedDataValueAckOneKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumTypedDataValueAckOneKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.value && typeof message.value.length === "number" || $util.isString(message.value)))
            return "value: buffer expected";
        return null;
    };

    EthereumTypedDataValueAckOneKey.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumTypedDataValueAckOneKey)
            return object;
        var message = new $root.EthereumTypedDataValueAckOneKey();
        if (object.value != null)
            if (typeof object.value === "string")
                $util.base64.decode(object.value, message.value = $util.newBuffer($util.base64.length(object.value)), 0);
            else if (object.value.length)
                message.value = object.value;
        return message;
    };

    EthereumTypedDataValueAckOneKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.value = "";
            else {
                object.value = [];
                if (options.bytes !== Array)
                    object.value = $util.newBuffer(object.value);
            }
        if (message.value != null && message.hasOwnProperty("value"))
            object.value = options.bytes === String ? $util.base64.encode(message.value, 0, message.value.length) : options.bytes === Array ? Array.prototype.slice.call(message.value) : message.value;
        return object;
    };

    EthereumTypedDataValueAckOneKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumTypedDataValueAckOneKey;
})();

$root.EthereumSignTypedData = (function() {

    function EthereumSignTypedData(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumSignTypedData.prototype.address_n = $util.emptyArray;
    EthereumSignTypedData.prototype.primary_type = "";
    EthereumSignTypedData.prototype.metamask_v4_compat = true;
    EthereumSignTypedData.prototype.definitions = null;

    EthereumSignTypedData.create = function create(properties) {
        return new EthereumSignTypedData(properties);
    };

    EthereumSignTypedData.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).string(message.primary_type);
        if (message.metamask_v4_compat != null && Object.hasOwnProperty.call(message, "metamask_v4_compat"))
            writer.uint32(24).bool(message.metamask_v4_compat);
        if (message.definitions != null && Object.hasOwnProperty.call(message, "definitions"))
            $root.EthereumDefinitions.encode(message.definitions, writer.uint32(34).fork()).ldelim();
        return writer;
    };

    EthereumSignTypedData.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumSignTypedData.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumSignTypedData();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.primary_type = reader.string();
                break;
            case 3:
                message.metamask_v4_compat = reader.bool();
                break;
            case 4:
                message.definitions = $root.EthereumDefinitions.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("primary_type"))
            throw $util.ProtocolError("missing required 'primary_type'", { instance: message });
        return message;
    };

    EthereumSignTypedData.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumSignTypedData.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!$util.isString(message.primary_type))
            return "primary_type: string expected";
        if (message.metamask_v4_compat != null && message.hasOwnProperty("metamask_v4_compat"))
            if (typeof message.metamask_v4_compat !== "boolean")
                return "metamask_v4_compat: boolean expected";
        if (message.definitions != null && message.hasOwnProperty("definitions")) {
            var error = $root.EthereumDefinitions.verify(message.definitions);
            if (error)
                return "definitions." + error;
        }
        return null;
    };

    EthereumSignTypedData.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumSignTypedData)
            return object;
        var message = new $root.EthereumSignTypedData();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".EthereumSignTypedData.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.primary_type != null)
            message.primary_type = String(object.primary_type);
        if (object.metamask_v4_compat != null)
            message.metamask_v4_compat = Boolean(object.metamask_v4_compat);
        if (object.definitions != null) {
            if (typeof object.definitions !== "object")
                throw TypeError(".EthereumSignTypedData.definitions: object expected");
            message.definitions = $root.EthereumDefinitions.fromObject(object.definitions);
        }
        return message;
    };

    EthereumSignTypedData.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            object.primary_type = "";
            object.metamask_v4_compat = true;
            object.definitions = null;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.primary_type != null && message.hasOwnProperty("primary_type"))
            object.primary_type = message.primary_type;
        if (message.metamask_v4_compat != null && message.hasOwnProperty("metamask_v4_compat"))
            object.metamask_v4_compat = message.metamask_v4_compat;
        if (message.definitions != null && message.hasOwnProperty("definitions"))
            object.definitions = $root.EthereumDefinitions.toObject(message.definitions, options);
        return object;
    };

    EthereumSignTypedData.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumSignTypedData;
})();

$root.EthereumTypedDataStructRequest = (function() {

    function EthereumTypedDataStructRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumTypedDataStructRequest.prototype.name = "";

    EthereumTypedDataStructRequest.create = function create(properties) {
        return new EthereumTypedDataStructRequest(properties);
    };

    EthereumTypedDataStructRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.name);
        return writer;
    };

    EthereumTypedDataStructRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumTypedDataStructRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumTypedDataStructRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.name = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("name"))
            throw $util.ProtocolError("missing required 'name'", { instance: message });
        return message;
    };

    EthereumTypedDataStructRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumTypedDataStructRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.name))
            return "name: string expected";
        return null;
    };

    EthereumTypedDataStructRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumTypedDataStructRequest)
            return object;
        var message = new $root.EthereumTypedDataStructRequest();
        if (object.name != null)
            message.name = String(object.name);
        return message;
    };

    EthereumTypedDataStructRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.name = "";
        if (message.name != null && message.hasOwnProperty("name"))
            object.name = message.name;
        return object;
    };

    EthereumTypedDataStructRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumTypedDataStructRequest;
})();

$root.EthereumTypedDataStructAck = (function() {

    function EthereumTypedDataStructAck(properties) {
        this.members = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumTypedDataStructAck.prototype.members = $util.emptyArray;

    EthereumTypedDataStructAck.create = function create(properties) {
        return new EthereumTypedDataStructAck(properties);
    };

    EthereumTypedDataStructAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.members != null && message.members.length)
            for (var i = 0; i < message.members.length; ++i)
                $root.EthereumTypedDataStructAck.EthereumStructMember.encode(message.members[i], writer.uint32(10).fork()).ldelim();
        return writer;
    };

    EthereumTypedDataStructAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumTypedDataStructAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumTypedDataStructAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.members && message.members.length))
                    message.members = [];
                message.members.push($root.EthereumTypedDataStructAck.EthereumStructMember.decode(reader, reader.uint32()));
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    EthereumTypedDataStructAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumTypedDataStructAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.members != null && message.hasOwnProperty("members")) {
            if (!Array.isArray(message.members))
                return "members: array expected";
            for (var i = 0; i < message.members.length; ++i) {
                var error = $root.EthereumTypedDataStructAck.EthereumStructMember.verify(message.members[i]);
                if (error)
                    return "members." + error;
            }
        }
        return null;
    };

    EthereumTypedDataStructAck.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumTypedDataStructAck)
            return object;
        var message = new $root.EthereumTypedDataStructAck();
        if (object.members) {
            if (!Array.isArray(object.members))
                throw TypeError(".EthereumTypedDataStructAck.members: array expected");
            message.members = [];
            for (var i = 0; i < object.members.length; ++i) {
                if (typeof object.members[i] !== "object")
                    throw TypeError(".EthereumTypedDataStructAck.members: object expected");
                message.members[i] = $root.EthereumTypedDataStructAck.EthereumStructMember.fromObject(object.members[i]);
            }
        }
        return message;
    };

    EthereumTypedDataStructAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.members = [];
        if (message.members && message.members.length) {
            object.members = [];
            for (var j = 0; j < message.members.length; ++j)
                object.members[j] = $root.EthereumTypedDataStructAck.EthereumStructMember.toObject(message.members[j], options);
        }
        return object;
    };

    EthereumTypedDataStructAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    EthereumTypedDataStructAck.EthereumStructMember = (function() {

        function EthereumStructMember(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        EthereumStructMember.prototype.type = null;
        EthereumStructMember.prototype.name = "";

        EthereumStructMember.create = function create(properties) {
            return new EthereumStructMember(properties);
        };

        EthereumStructMember.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            $root.EthereumTypedDataStructAck.EthereumFieldType.encode(message.type, writer.uint32(10).fork()).ldelim();
            writer.uint32(18).string(message.name);
            return writer;
        };

        EthereumStructMember.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        EthereumStructMember.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumTypedDataStructAck.EthereumStructMember();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.type = $root.EthereumTypedDataStructAck.EthereumFieldType.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.name = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("type"))
                throw $util.ProtocolError("missing required 'type'", { instance: message });
            if (!message.hasOwnProperty("name"))
                throw $util.ProtocolError("missing required 'name'", { instance: message });
            return message;
        };

        EthereumStructMember.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        EthereumStructMember.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            {
                var error = $root.EthereumTypedDataStructAck.EthereumFieldType.verify(message.type);
                if (error)
                    return "type." + error;
            }
            if (!$util.isString(message.name))
                return "name: string expected";
            return null;
        };

        EthereumStructMember.fromObject = function fromObject(object) {
            if (object instanceof $root.EthereumTypedDataStructAck.EthereumStructMember)
                return object;
            var message = new $root.EthereumTypedDataStructAck.EthereumStructMember();
            if (object.type != null) {
                if (typeof object.type !== "object")
                    throw TypeError(".EthereumTypedDataStructAck.EthereumStructMember.type: object expected");
                message.type = $root.EthereumTypedDataStructAck.EthereumFieldType.fromObject(object.type);
            }
            if (object.name != null)
                message.name = String(object.name);
            return message;
        };

        EthereumStructMember.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.type = null;
                object.name = "";
            }
            if (message.type != null && message.hasOwnProperty("type"))
                object.type = $root.EthereumTypedDataStructAck.EthereumFieldType.toObject(message.type, options);
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            return object;
        };

        EthereumStructMember.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EthereumStructMember;
    })();

    EthereumTypedDataStructAck.EthereumFieldType = (function() {

        function EthereumFieldType(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        EthereumFieldType.prototype.data_type = 1;
        EthereumFieldType.prototype.size = 0;
        EthereumFieldType.prototype.entry_type = null;
        EthereumFieldType.prototype.struct_name = "";

        EthereumFieldType.create = function create(properties) {
            return new EthereumFieldType(properties);
        };

        EthereumFieldType.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(8).int32(message.data_type);
            if (message.size != null && Object.hasOwnProperty.call(message, "size"))
                writer.uint32(16).uint32(message.size);
            if (message.entry_type != null && Object.hasOwnProperty.call(message, "entry_type"))
                $root.EthereumTypedDataStructAck.EthereumFieldType.encode(message.entry_type, writer.uint32(26).fork()).ldelim();
            if (message.struct_name != null && Object.hasOwnProperty.call(message, "struct_name"))
                writer.uint32(34).string(message.struct_name);
            return writer;
        };

        EthereumFieldType.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        EthereumFieldType.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumTypedDataStructAck.EthereumFieldType();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.data_type = reader.int32();
                    break;
                case 2:
                    message.size = reader.uint32();
                    break;
                case 3:
                    message.entry_type = $root.EthereumTypedDataStructAck.EthereumFieldType.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.struct_name = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("data_type"))
                throw $util.ProtocolError("missing required 'data_type'", { instance: message });
            return message;
        };

        EthereumFieldType.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        EthereumFieldType.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            switch (message.data_type) {
            default:
                return "data_type: enum value expected";
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
            case 8:
                break;
            }
            if (message.size != null && message.hasOwnProperty("size"))
                if (!$util.isInteger(message.size))
                    return "size: integer expected";
            if (message.entry_type != null && message.hasOwnProperty("entry_type")) {
                var error = $root.EthereumTypedDataStructAck.EthereumFieldType.verify(message.entry_type);
                if (error)
                    return "entry_type." + error;
            }
            if (message.struct_name != null && message.hasOwnProperty("struct_name"))
                if (!$util.isString(message.struct_name))
                    return "struct_name: string expected";
            return null;
        };

        EthereumFieldType.fromObject = function fromObject(object) {
            if (object instanceof $root.EthereumTypedDataStructAck.EthereumFieldType)
                return object;
            var message = new $root.EthereumTypedDataStructAck.EthereumFieldType();
            switch (object.data_type) {
            case "UINT":
            case 1:
                message.data_type = 1;
                break;
            case "INT":
            case 2:
                message.data_type = 2;
                break;
            case "BYTES":
            case 3:
                message.data_type = 3;
                break;
            case "STRING":
            case 4:
                message.data_type = 4;
                break;
            case "BOOL":
            case 5:
                message.data_type = 5;
                break;
            case "ADDRESS":
            case 6:
                message.data_type = 6;
                break;
            case "ARRAY":
            case 7:
                message.data_type = 7;
                break;
            case "STRUCT":
            case 8:
                message.data_type = 8;
                break;
            }
            if (object.size != null)
                message.size = object.size >>> 0;
            if (object.entry_type != null) {
                if (typeof object.entry_type !== "object")
                    throw TypeError(".EthereumTypedDataStructAck.EthereumFieldType.entry_type: object expected");
                message.entry_type = $root.EthereumTypedDataStructAck.EthereumFieldType.fromObject(object.entry_type);
            }
            if (object.struct_name != null)
                message.struct_name = String(object.struct_name);
            return message;
        };

        EthereumFieldType.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.data_type = options.enums === String ? "UINT" : 1;
                object.size = 0;
                object.entry_type = null;
                object.struct_name = "";
            }
            if (message.data_type != null && message.hasOwnProperty("data_type"))
                object.data_type = options.enums === String ? $root.EthereumTypedDataStructAck.EthereumDataType[message.data_type] : message.data_type;
            if (message.size != null && message.hasOwnProperty("size"))
                object.size = message.size;
            if (message.entry_type != null && message.hasOwnProperty("entry_type"))
                object.entry_type = $root.EthereumTypedDataStructAck.EthereumFieldType.toObject(message.entry_type, options);
            if (message.struct_name != null && message.hasOwnProperty("struct_name"))
                object.struct_name = message.struct_name;
            return object;
        };

        EthereumFieldType.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EthereumFieldType;
    })();

    EthereumTypedDataStructAck.EthereumDataType = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[1] = "UINT"] = 1;
        values[valuesById[2] = "INT"] = 2;
        values[valuesById[3] = "BYTES"] = 3;
        values[valuesById[4] = "STRING"] = 4;
        values[valuesById[5] = "BOOL"] = 5;
        values[valuesById[6] = "ADDRESS"] = 6;
        values[valuesById[7] = "ARRAY"] = 7;
        values[valuesById[8] = "STRUCT"] = 8;
        return values;
    })();

    return EthereumTypedDataStructAck;
})();

$root.EthereumTypedDataValueRequest = (function() {

    function EthereumTypedDataValueRequest(properties) {
        this.member_path = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumTypedDataValueRequest.prototype.member_path = $util.emptyArray;

    EthereumTypedDataValueRequest.create = function create(properties) {
        return new EthereumTypedDataValueRequest(properties);
    };

    EthereumTypedDataValueRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.member_path != null && message.member_path.length)
            for (var i = 0; i < message.member_path.length; ++i)
                writer.uint32(8).uint32(message.member_path[i]);
        return writer;
    };

    EthereumTypedDataValueRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumTypedDataValueRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumTypedDataValueRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.member_path && message.member_path.length))
                    message.member_path = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.member_path.push(reader.uint32());
                } else
                    message.member_path.push(reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    EthereumTypedDataValueRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumTypedDataValueRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.member_path != null && message.hasOwnProperty("member_path")) {
            if (!Array.isArray(message.member_path))
                return "member_path: array expected";
            for (var i = 0; i < message.member_path.length; ++i)
                if (!$util.isInteger(message.member_path[i]))
                    return "member_path: integer[] expected";
        }
        return null;
    };

    EthereumTypedDataValueRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumTypedDataValueRequest)
            return object;
        var message = new $root.EthereumTypedDataValueRequest();
        if (object.member_path) {
            if (!Array.isArray(object.member_path))
                throw TypeError(".EthereumTypedDataValueRequest.member_path: array expected");
            message.member_path = [];
            for (var i = 0; i < object.member_path.length; ++i)
                message.member_path[i] = object.member_path[i] >>> 0;
        }
        return message;
    };

    EthereumTypedDataValueRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.member_path = [];
        if (message.member_path && message.member_path.length) {
            object.member_path = [];
            for (var j = 0; j < message.member_path.length; ++j)
                object.member_path[j] = message.member_path[j];
        }
        return object;
    };

    EthereumTypedDataValueRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumTypedDataValueRequest;
})();

$root.EthereumTypedDataValueAck = (function() {

    function EthereumTypedDataValueAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumTypedDataValueAck.prototype.value = $util.newBuffer([]);

    EthereumTypedDataValueAck.create = function create(properties) {
        return new EthereumTypedDataValueAck(properties);
    };

    EthereumTypedDataValueAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.value);
        return writer;
    };

    EthereumTypedDataValueAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumTypedDataValueAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumTypedDataValueAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.value = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("value"))
            throw $util.ProtocolError("missing required 'value'", { instance: message });
        return message;
    };

    EthereumTypedDataValueAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumTypedDataValueAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.value && typeof message.value.length === "number" || $util.isString(message.value)))
            return "value: buffer expected";
        return null;
    };

    EthereumTypedDataValueAck.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumTypedDataValueAck)
            return object;
        var message = new $root.EthereumTypedDataValueAck();
        if (object.value != null)
            if (typeof object.value === "string")
                $util.base64.decode(object.value, message.value = $util.newBuffer($util.base64.length(object.value)), 0);
            else if (object.value.length)
                message.value = object.value;
        return message;
    };

    EthereumTypedDataValueAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.value = "";
            else {
                object.value = [];
                if (options.bytes !== Array)
                    object.value = $util.newBuffer(object.value);
            }
        if (message.value != null && message.hasOwnProperty("value"))
            object.value = options.bytes === String ? $util.base64.encode(message.value, 0, message.value.length) : options.bytes === Array ? Array.prototype.slice.call(message.value) : message.value;
        return object;
    };

    EthereumTypedDataValueAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumTypedDataValueAck;
})();

$root.EthereumGetPublicKeyOneKey = (function() {

    function EthereumGetPublicKeyOneKey(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumGetPublicKeyOneKey.prototype.address_n = $util.emptyArray;
    EthereumGetPublicKeyOneKey.prototype.show_display = false;
    EthereumGetPublicKeyOneKey.prototype.chain_id = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    EthereumGetPublicKeyOneKey.create = function create(properties) {
        return new EthereumGetPublicKeyOneKey(properties);
    };

    EthereumGetPublicKeyOneKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(16).bool(message.show_display);
        if (message.chain_id != null && Object.hasOwnProperty.call(message, "chain_id"))
            writer.uint32(24).uint64(message.chain_id);
        return writer;
    };

    EthereumGetPublicKeyOneKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumGetPublicKeyOneKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumGetPublicKeyOneKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.show_display = reader.bool();
                break;
            case 3:
                message.chain_id = reader.uint64();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    EthereumGetPublicKeyOneKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumGetPublicKeyOneKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        if (message.chain_id != null && message.hasOwnProperty("chain_id"))
            if (!$util.isInteger(message.chain_id) && !(message.chain_id && $util.isInteger(message.chain_id.low) && $util.isInteger(message.chain_id.high)))
                return "chain_id: integer|Long expected";
        return null;
    };

    EthereumGetPublicKeyOneKey.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumGetPublicKeyOneKey)
            return object;
        var message = new $root.EthereumGetPublicKeyOneKey();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".EthereumGetPublicKeyOneKey.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        if (object.chain_id != null)
            if ($util.Long)
                (message.chain_id = $util.Long.fromValue(object.chain_id)).unsigned = true;
            else if (typeof object.chain_id === "string")
                message.chain_id = parseInt(object.chain_id, 10);
            else if (typeof object.chain_id === "number")
                message.chain_id = object.chain_id;
            else if (typeof object.chain_id === "object")
                message.chain_id = new $util.LongBits(object.chain_id.low >>> 0, object.chain_id.high >>> 0).toNumber(true);
        return message;
    };

    EthereumGetPublicKeyOneKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            object.show_display = false;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.chain_id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.chain_id = options.longs === String ? "0" : 0;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        if (message.chain_id != null && message.hasOwnProperty("chain_id"))
            if (typeof message.chain_id === "number")
                object.chain_id = options.longs === String ? String(message.chain_id) : message.chain_id;
            else
                object.chain_id = options.longs === String ? $util.Long.prototype.toString.call(message.chain_id) : options.longs === Number ? new $util.LongBits(message.chain_id.low >>> 0, message.chain_id.high >>> 0).toNumber(true) : message.chain_id;
        return object;
    };

    EthereumGetPublicKeyOneKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumGetPublicKeyOneKey;
})();

$root.EthereumPublicKeyOneKey = (function() {

    function EthereumPublicKeyOneKey(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumPublicKeyOneKey.prototype.node = null;
    EthereumPublicKeyOneKey.prototype.xpub = "";

    EthereumPublicKeyOneKey.create = function create(properties) {
        return new EthereumPublicKeyOneKey(properties);
    };

    EthereumPublicKeyOneKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        $root.HDNodeType.encode(message.node, writer.uint32(10).fork()).ldelim();
        writer.uint32(18).string(message.xpub);
        return writer;
    };

    EthereumPublicKeyOneKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumPublicKeyOneKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumPublicKeyOneKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.node = $root.HDNodeType.decode(reader, reader.uint32());
                break;
            case 2:
                message.xpub = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("node"))
            throw $util.ProtocolError("missing required 'node'", { instance: message });
        if (!message.hasOwnProperty("xpub"))
            throw $util.ProtocolError("missing required 'xpub'", { instance: message });
        return message;
    };

    EthereumPublicKeyOneKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumPublicKeyOneKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        {
            var error = $root.HDNodeType.verify(message.node);
            if (error)
                return "node." + error;
        }
        if (!$util.isString(message.xpub))
            return "xpub: string expected";
        return null;
    };

    EthereumPublicKeyOneKey.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumPublicKeyOneKey)
            return object;
        var message = new $root.EthereumPublicKeyOneKey();
        if (object.node != null) {
            if (typeof object.node !== "object")
                throw TypeError(".EthereumPublicKeyOneKey.node: object expected");
            message.node = $root.HDNodeType.fromObject(object.node);
        }
        if (object.xpub != null)
            message.xpub = String(object.xpub);
        return message;
    };

    EthereumPublicKeyOneKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.node = null;
            object.xpub = "";
        }
        if (message.node != null && message.hasOwnProperty("node"))
            object.node = $root.HDNodeType.toObject(message.node, options);
        if (message.xpub != null && message.hasOwnProperty("xpub"))
            object.xpub = message.xpub;
        return object;
    };

    EthereumPublicKeyOneKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumPublicKeyOneKey;
})();

$root.EthereumGetAddressOneKey = (function() {

    function EthereumGetAddressOneKey(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumGetAddressOneKey.prototype.address_n = $util.emptyArray;
    EthereumGetAddressOneKey.prototype.show_display = false;
    EthereumGetAddressOneKey.prototype.chain_id = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    EthereumGetAddressOneKey.create = function create(properties) {
        return new EthereumGetAddressOneKey(properties);
    };

    EthereumGetAddressOneKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(16).bool(message.show_display);
        if (message.chain_id != null && Object.hasOwnProperty.call(message, "chain_id"))
            writer.uint32(24).uint64(message.chain_id);
        return writer;
    };

    EthereumGetAddressOneKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumGetAddressOneKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumGetAddressOneKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.show_display = reader.bool();
                break;
            case 3:
                message.chain_id = reader.uint64();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    EthereumGetAddressOneKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumGetAddressOneKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        if (message.chain_id != null && message.hasOwnProperty("chain_id"))
            if (!$util.isInteger(message.chain_id) && !(message.chain_id && $util.isInteger(message.chain_id.low) && $util.isInteger(message.chain_id.high)))
                return "chain_id: integer|Long expected";
        return null;
    };

    EthereumGetAddressOneKey.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumGetAddressOneKey)
            return object;
        var message = new $root.EthereumGetAddressOneKey();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".EthereumGetAddressOneKey.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        if (object.chain_id != null)
            if ($util.Long)
                (message.chain_id = $util.Long.fromValue(object.chain_id)).unsigned = true;
            else if (typeof object.chain_id === "string")
                message.chain_id = parseInt(object.chain_id, 10);
            else if (typeof object.chain_id === "number")
                message.chain_id = object.chain_id;
            else if (typeof object.chain_id === "object")
                message.chain_id = new $util.LongBits(object.chain_id.low >>> 0, object.chain_id.high >>> 0).toNumber(true);
        return message;
    };

    EthereumGetAddressOneKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            object.show_display = false;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.chain_id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.chain_id = options.longs === String ? "0" : 0;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        if (message.chain_id != null && message.hasOwnProperty("chain_id"))
            if (typeof message.chain_id === "number")
                object.chain_id = options.longs === String ? String(message.chain_id) : message.chain_id;
            else
                object.chain_id = options.longs === String ? $util.Long.prototype.toString.call(message.chain_id) : options.longs === Number ? new $util.LongBits(message.chain_id.low >>> 0, message.chain_id.high >>> 0).toNumber(true) : message.chain_id;
        return object;
    };

    EthereumGetAddressOneKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumGetAddressOneKey;
})();

$root.EthereumAddressOneKey = (function() {

    function EthereumAddressOneKey(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumAddressOneKey.prototype._old_address = $util.newBuffer([]);
    EthereumAddressOneKey.prototype.address = "";

    EthereumAddressOneKey.create = function create(properties) {
        return new EthereumAddressOneKey(properties);
    };

    EthereumAddressOneKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message._old_address != null && Object.hasOwnProperty.call(message, "_old_address"))
            writer.uint32(10).bytes(message._old_address);
        if (message.address != null && Object.hasOwnProperty.call(message, "address"))
            writer.uint32(18).string(message.address);
        return writer;
    };

    EthereumAddressOneKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumAddressOneKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumAddressOneKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message._old_address = reader.bytes();
                break;
            case 2:
                message.address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    EthereumAddressOneKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumAddressOneKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message._old_address != null && message.hasOwnProperty("_old_address"))
            if (!(message._old_address && typeof message._old_address.length === "number" || $util.isString(message._old_address)))
                return "_old_address: buffer expected";
        if (message.address != null && message.hasOwnProperty("address"))
            if (!$util.isString(message.address))
                return "address: string expected";
        return null;
    };

    EthereumAddressOneKey.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumAddressOneKey)
            return object;
        var message = new $root.EthereumAddressOneKey();
        if (object._old_address != null)
            if (typeof object._old_address === "string")
                $util.base64.decode(object._old_address, message._old_address = $util.newBuffer($util.base64.length(object._old_address)), 0);
            else if (object._old_address.length)
                message._old_address = object._old_address;
        if (object.address != null)
            message.address = String(object.address);
        return message;
    };

    EthereumAddressOneKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object._old_address = "";
            else {
                object._old_address = [];
                if (options.bytes !== Array)
                    object._old_address = $util.newBuffer(object._old_address);
            }
            object.address = "";
        }
        if (message._old_address != null && message.hasOwnProperty("_old_address"))
            object._old_address = options.bytes === String ? $util.base64.encode(message._old_address, 0, message._old_address.length) : options.bytes === Array ? Array.prototype.slice.call(message._old_address) : message._old_address;
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    EthereumAddressOneKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumAddressOneKey;
})();

$root.EthereumSignTxOneKey = (function() {

    function EthereumSignTxOneKey(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumSignTxOneKey.prototype.address_n = $util.emptyArray;
    EthereumSignTxOneKey.prototype.nonce = $util.newBuffer([]);
    EthereumSignTxOneKey.prototype.gas_price = $util.newBuffer([]);
    EthereumSignTxOneKey.prototype.gas_limit = $util.newBuffer([]);
    EthereumSignTxOneKey.prototype.to = "";
    EthereumSignTxOneKey.prototype.value = $util.newBuffer([]);
    EthereumSignTxOneKey.prototype.data_initial_chunk = $util.newBuffer([]);
    EthereumSignTxOneKey.prototype.data_length = 0;
    EthereumSignTxOneKey.prototype.chain_id = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    EthereumSignTxOneKey.prototype.tx_type = 0;

    EthereumSignTxOneKey.create = function create(properties) {
        return new EthereumSignTxOneKey(properties);
    };

    EthereumSignTxOneKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.nonce != null && Object.hasOwnProperty.call(message, "nonce"))
            writer.uint32(18).bytes(message.nonce);
        writer.uint32(26).bytes(message.gas_price);
        writer.uint32(34).bytes(message.gas_limit);
        if (message.value != null && Object.hasOwnProperty.call(message, "value"))
            writer.uint32(50).bytes(message.value);
        if (message.data_initial_chunk != null && Object.hasOwnProperty.call(message, "data_initial_chunk"))
            writer.uint32(58).bytes(message.data_initial_chunk);
        if (message.data_length != null && Object.hasOwnProperty.call(message, "data_length"))
            writer.uint32(64).uint32(message.data_length);
        writer.uint32(72).uint64(message.chain_id);
        if (message.tx_type != null && Object.hasOwnProperty.call(message, "tx_type"))
            writer.uint32(80).uint32(message.tx_type);
        if (message.to != null && Object.hasOwnProperty.call(message, "to"))
            writer.uint32(90).string(message.to);
        return writer;
    };

    EthereumSignTxOneKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumSignTxOneKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumSignTxOneKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.nonce = reader.bytes();
                break;
            case 3:
                message.gas_price = reader.bytes();
                break;
            case 4:
                message.gas_limit = reader.bytes();
                break;
            case 11:
                message.to = reader.string();
                break;
            case 6:
                message.value = reader.bytes();
                break;
            case 7:
                message.data_initial_chunk = reader.bytes();
                break;
            case 8:
                message.data_length = reader.uint32();
                break;
            case 9:
                message.chain_id = reader.uint64();
                break;
            case 10:
                message.tx_type = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("gas_price"))
            throw $util.ProtocolError("missing required 'gas_price'", { instance: message });
        if (!message.hasOwnProperty("gas_limit"))
            throw $util.ProtocolError("missing required 'gas_limit'", { instance: message });
        if (!message.hasOwnProperty("chain_id"))
            throw $util.ProtocolError("missing required 'chain_id'", { instance: message });
        return message;
    };

    EthereumSignTxOneKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumSignTxOneKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.nonce != null && message.hasOwnProperty("nonce"))
            if (!(message.nonce && typeof message.nonce.length === "number" || $util.isString(message.nonce)))
                return "nonce: buffer expected";
        if (!(message.gas_price && typeof message.gas_price.length === "number" || $util.isString(message.gas_price)))
            return "gas_price: buffer expected";
        if (!(message.gas_limit && typeof message.gas_limit.length === "number" || $util.isString(message.gas_limit)))
            return "gas_limit: buffer expected";
        if (message.to != null && message.hasOwnProperty("to"))
            if (!$util.isString(message.to))
                return "to: string expected";
        if (message.value != null && message.hasOwnProperty("value"))
            if (!(message.value && typeof message.value.length === "number" || $util.isString(message.value)))
                return "value: buffer expected";
        if (message.data_initial_chunk != null && message.hasOwnProperty("data_initial_chunk"))
            if (!(message.data_initial_chunk && typeof message.data_initial_chunk.length === "number" || $util.isString(message.data_initial_chunk)))
                return "data_initial_chunk: buffer expected";
        if (message.data_length != null && message.hasOwnProperty("data_length"))
            if (!$util.isInteger(message.data_length))
                return "data_length: integer expected";
        if (!$util.isInteger(message.chain_id) && !(message.chain_id && $util.isInteger(message.chain_id.low) && $util.isInteger(message.chain_id.high)))
            return "chain_id: integer|Long expected";
        if (message.tx_type != null && message.hasOwnProperty("tx_type"))
            if (!$util.isInteger(message.tx_type))
                return "tx_type: integer expected";
        return null;
    };

    EthereumSignTxOneKey.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumSignTxOneKey)
            return object;
        var message = new $root.EthereumSignTxOneKey();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".EthereumSignTxOneKey.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.nonce != null)
            if (typeof object.nonce === "string")
                $util.base64.decode(object.nonce, message.nonce = $util.newBuffer($util.base64.length(object.nonce)), 0);
            else if (object.nonce.length)
                message.nonce = object.nonce;
        if (object.gas_price != null)
            if (typeof object.gas_price === "string")
                $util.base64.decode(object.gas_price, message.gas_price = $util.newBuffer($util.base64.length(object.gas_price)), 0);
            else if (object.gas_price.length)
                message.gas_price = object.gas_price;
        if (object.gas_limit != null)
            if (typeof object.gas_limit === "string")
                $util.base64.decode(object.gas_limit, message.gas_limit = $util.newBuffer($util.base64.length(object.gas_limit)), 0);
            else if (object.gas_limit.length)
                message.gas_limit = object.gas_limit;
        if (object.to != null)
            message.to = String(object.to);
        if (object.value != null)
            if (typeof object.value === "string")
                $util.base64.decode(object.value, message.value = $util.newBuffer($util.base64.length(object.value)), 0);
            else if (object.value.length)
                message.value = object.value;
        if (object.data_initial_chunk != null)
            if (typeof object.data_initial_chunk === "string")
                $util.base64.decode(object.data_initial_chunk, message.data_initial_chunk = $util.newBuffer($util.base64.length(object.data_initial_chunk)), 0);
            else if (object.data_initial_chunk.length)
                message.data_initial_chunk = object.data_initial_chunk;
        if (object.data_length != null)
            message.data_length = object.data_length >>> 0;
        if (object.chain_id != null)
            if ($util.Long)
                (message.chain_id = $util.Long.fromValue(object.chain_id)).unsigned = true;
            else if (typeof object.chain_id === "string")
                message.chain_id = parseInt(object.chain_id, 10);
            else if (typeof object.chain_id === "number")
                message.chain_id = object.chain_id;
            else if (typeof object.chain_id === "object")
                message.chain_id = new $util.LongBits(object.chain_id.low >>> 0, object.chain_id.high >>> 0).toNumber(true);
        if (object.tx_type != null)
            message.tx_type = object.tx_type >>> 0;
        return message;
    };

    EthereumSignTxOneKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            if (options.bytes === String)
                object.nonce = "";
            else {
                object.nonce = [];
                if (options.bytes !== Array)
                    object.nonce = $util.newBuffer(object.nonce);
            }
            if (options.bytes === String)
                object.gas_price = "";
            else {
                object.gas_price = [];
                if (options.bytes !== Array)
                    object.gas_price = $util.newBuffer(object.gas_price);
            }
            if (options.bytes === String)
                object.gas_limit = "";
            else {
                object.gas_limit = [];
                if (options.bytes !== Array)
                    object.gas_limit = $util.newBuffer(object.gas_limit);
            }
            if (options.bytes === String)
                object.value = "";
            else {
                object.value = [];
                if (options.bytes !== Array)
                    object.value = $util.newBuffer(object.value);
            }
            if (options.bytes === String)
                object.data_initial_chunk = "";
            else {
                object.data_initial_chunk = [];
                if (options.bytes !== Array)
                    object.data_initial_chunk = $util.newBuffer(object.data_initial_chunk);
            }
            object.data_length = 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.chain_id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.chain_id = options.longs === String ? "0" : 0;
            object.tx_type = 0;
            object.to = "";
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.nonce != null && message.hasOwnProperty("nonce"))
            object.nonce = options.bytes === String ? $util.base64.encode(message.nonce, 0, message.nonce.length) : options.bytes === Array ? Array.prototype.slice.call(message.nonce) : message.nonce;
        if (message.gas_price != null && message.hasOwnProperty("gas_price"))
            object.gas_price = options.bytes === String ? $util.base64.encode(message.gas_price, 0, message.gas_price.length) : options.bytes === Array ? Array.prototype.slice.call(message.gas_price) : message.gas_price;
        if (message.gas_limit != null && message.hasOwnProperty("gas_limit"))
            object.gas_limit = options.bytes === String ? $util.base64.encode(message.gas_limit, 0, message.gas_limit.length) : options.bytes === Array ? Array.prototype.slice.call(message.gas_limit) : message.gas_limit;
        if (message.value != null && message.hasOwnProperty("value"))
            object.value = options.bytes === String ? $util.base64.encode(message.value, 0, message.value.length) : options.bytes === Array ? Array.prototype.slice.call(message.value) : message.value;
        if (message.data_initial_chunk != null && message.hasOwnProperty("data_initial_chunk"))
            object.data_initial_chunk = options.bytes === String ? $util.base64.encode(message.data_initial_chunk, 0, message.data_initial_chunk.length) : options.bytes === Array ? Array.prototype.slice.call(message.data_initial_chunk) : message.data_initial_chunk;
        if (message.data_length != null && message.hasOwnProperty("data_length"))
            object.data_length = message.data_length;
        if (message.chain_id != null && message.hasOwnProperty("chain_id"))
            if (typeof message.chain_id === "number")
                object.chain_id = options.longs === String ? String(message.chain_id) : message.chain_id;
            else
                object.chain_id = options.longs === String ? $util.Long.prototype.toString.call(message.chain_id) : options.longs === Number ? new $util.LongBits(message.chain_id.low >>> 0, message.chain_id.high >>> 0).toNumber(true) : message.chain_id;
        if (message.tx_type != null && message.hasOwnProperty("tx_type"))
            object.tx_type = message.tx_type;
        if (message.to != null && message.hasOwnProperty("to"))
            object.to = message.to;
        return object;
    };

    EthereumSignTxOneKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumSignTxOneKey;
})();

$root.EthereumAccessListOneKey = (function() {

    function EthereumAccessListOneKey(properties) {
        this.storage_keys = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumAccessListOneKey.prototype.address = "";
    EthereumAccessListOneKey.prototype.storage_keys = $util.emptyArray;

    EthereumAccessListOneKey.create = function create(properties) {
        return new EthereumAccessListOneKey(properties);
    };

    EthereumAccessListOneKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.address);
        if (message.storage_keys != null && message.storage_keys.length)
            for (var i = 0; i < message.storage_keys.length; ++i)
                writer.uint32(18).bytes(message.storage_keys[i]);
        return writer;
    };

    EthereumAccessListOneKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumAccessListOneKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumAccessListOneKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.string();
                break;
            case 2:
                if (!(message.storage_keys && message.storage_keys.length))
                    message.storage_keys = [];
                message.storage_keys.push(reader.bytes());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("address"))
            throw $util.ProtocolError("missing required 'address'", { instance: message });
        return message;
    };

    EthereumAccessListOneKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumAccessListOneKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.address))
            return "address: string expected";
        if (message.storage_keys != null && message.hasOwnProperty("storage_keys")) {
            if (!Array.isArray(message.storage_keys))
                return "storage_keys: array expected";
            for (var i = 0; i < message.storage_keys.length; ++i)
                if (!(message.storage_keys[i] && typeof message.storage_keys[i].length === "number" || $util.isString(message.storage_keys[i])))
                    return "storage_keys: buffer[] expected";
        }
        return null;
    };

    EthereumAccessListOneKey.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumAccessListOneKey)
            return object;
        var message = new $root.EthereumAccessListOneKey();
        if (object.address != null)
            message.address = String(object.address);
        if (object.storage_keys) {
            if (!Array.isArray(object.storage_keys))
                throw TypeError(".EthereumAccessListOneKey.storage_keys: array expected");
            message.storage_keys = [];
            for (var i = 0; i < object.storage_keys.length; ++i)
                if (typeof object.storage_keys[i] === "string")
                    $util.base64.decode(object.storage_keys[i], message.storage_keys[i] = $util.newBuffer($util.base64.length(object.storage_keys[i])), 0);
                else if (object.storage_keys[i].length)
                    message.storage_keys[i] = object.storage_keys[i];
        }
        return message;
    };

    EthereumAccessListOneKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.storage_keys = [];
        if (options.defaults)
            object.address = "";
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        if (message.storage_keys && message.storage_keys.length) {
            object.storage_keys = [];
            for (var j = 0; j < message.storage_keys.length; ++j)
                object.storage_keys[j] = options.bytes === String ? $util.base64.encode(message.storage_keys[j], 0, message.storage_keys[j].length) : options.bytes === Array ? Array.prototype.slice.call(message.storage_keys[j]) : message.storage_keys[j];
        }
        return object;
    };

    EthereumAccessListOneKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumAccessListOneKey;
})();

$root.EthereumSignTxEIP1559OneKey = (function() {

    function EthereumSignTxEIP1559OneKey(properties) {
        this.address_n = [];
        this.access_list = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumSignTxEIP1559OneKey.prototype.address_n = $util.emptyArray;
    EthereumSignTxEIP1559OneKey.prototype.nonce = $util.newBuffer([]);
    EthereumSignTxEIP1559OneKey.prototype.max_gas_fee = $util.newBuffer([]);
    EthereumSignTxEIP1559OneKey.prototype.max_priority_fee = $util.newBuffer([]);
    EthereumSignTxEIP1559OneKey.prototype.gas_limit = $util.newBuffer([]);
    EthereumSignTxEIP1559OneKey.prototype.to = "";
    EthereumSignTxEIP1559OneKey.prototype.value = $util.newBuffer([]);
    EthereumSignTxEIP1559OneKey.prototype.data_initial_chunk = $util.newBuffer([]);
    EthereumSignTxEIP1559OneKey.prototype.data_length = 0;
    EthereumSignTxEIP1559OneKey.prototype.chain_id = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    EthereumSignTxEIP1559OneKey.prototype.access_list = $util.emptyArray;

    EthereumSignTxEIP1559OneKey.create = function create(properties) {
        return new EthereumSignTxEIP1559OneKey(properties);
    };

    EthereumSignTxEIP1559OneKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).bytes(message.nonce);
        writer.uint32(26).bytes(message.max_gas_fee);
        writer.uint32(34).bytes(message.max_priority_fee);
        writer.uint32(42).bytes(message.gas_limit);
        if (message.to != null && Object.hasOwnProperty.call(message, "to"))
            writer.uint32(50).string(message.to);
        writer.uint32(58).bytes(message.value);
        if (message.data_initial_chunk != null && Object.hasOwnProperty.call(message, "data_initial_chunk"))
            writer.uint32(66).bytes(message.data_initial_chunk);
        writer.uint32(72).uint32(message.data_length);
        writer.uint32(80).uint64(message.chain_id);
        if (message.access_list != null && message.access_list.length)
            for (var i = 0; i < message.access_list.length; ++i)
                $root.EthereumAccessListOneKey.encode(message.access_list[i], writer.uint32(90).fork()).ldelim();
        return writer;
    };

    EthereumSignTxEIP1559OneKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumSignTxEIP1559OneKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumSignTxEIP1559OneKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.nonce = reader.bytes();
                break;
            case 3:
                message.max_gas_fee = reader.bytes();
                break;
            case 4:
                message.max_priority_fee = reader.bytes();
                break;
            case 5:
                message.gas_limit = reader.bytes();
                break;
            case 6:
                message.to = reader.string();
                break;
            case 7:
                message.value = reader.bytes();
                break;
            case 8:
                message.data_initial_chunk = reader.bytes();
                break;
            case 9:
                message.data_length = reader.uint32();
                break;
            case 10:
                message.chain_id = reader.uint64();
                break;
            case 11:
                if (!(message.access_list && message.access_list.length))
                    message.access_list = [];
                message.access_list.push($root.EthereumAccessListOneKey.decode(reader, reader.uint32()));
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("nonce"))
            throw $util.ProtocolError("missing required 'nonce'", { instance: message });
        if (!message.hasOwnProperty("max_gas_fee"))
            throw $util.ProtocolError("missing required 'max_gas_fee'", { instance: message });
        if (!message.hasOwnProperty("max_priority_fee"))
            throw $util.ProtocolError("missing required 'max_priority_fee'", { instance: message });
        if (!message.hasOwnProperty("gas_limit"))
            throw $util.ProtocolError("missing required 'gas_limit'", { instance: message });
        if (!message.hasOwnProperty("value"))
            throw $util.ProtocolError("missing required 'value'", { instance: message });
        if (!message.hasOwnProperty("data_length"))
            throw $util.ProtocolError("missing required 'data_length'", { instance: message });
        if (!message.hasOwnProperty("chain_id"))
            throw $util.ProtocolError("missing required 'chain_id'", { instance: message });
        return message;
    };

    EthereumSignTxEIP1559OneKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumSignTxEIP1559OneKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!(message.nonce && typeof message.nonce.length === "number" || $util.isString(message.nonce)))
            return "nonce: buffer expected";
        if (!(message.max_gas_fee && typeof message.max_gas_fee.length === "number" || $util.isString(message.max_gas_fee)))
            return "max_gas_fee: buffer expected";
        if (!(message.max_priority_fee && typeof message.max_priority_fee.length === "number" || $util.isString(message.max_priority_fee)))
            return "max_priority_fee: buffer expected";
        if (!(message.gas_limit && typeof message.gas_limit.length === "number" || $util.isString(message.gas_limit)))
            return "gas_limit: buffer expected";
        if (message.to != null && message.hasOwnProperty("to"))
            if (!$util.isString(message.to))
                return "to: string expected";
        if (!(message.value && typeof message.value.length === "number" || $util.isString(message.value)))
            return "value: buffer expected";
        if (message.data_initial_chunk != null && message.hasOwnProperty("data_initial_chunk"))
            if (!(message.data_initial_chunk && typeof message.data_initial_chunk.length === "number" || $util.isString(message.data_initial_chunk)))
                return "data_initial_chunk: buffer expected";
        if (!$util.isInteger(message.data_length))
            return "data_length: integer expected";
        if (!$util.isInteger(message.chain_id) && !(message.chain_id && $util.isInteger(message.chain_id.low) && $util.isInteger(message.chain_id.high)))
            return "chain_id: integer|Long expected";
        if (message.access_list != null && message.hasOwnProperty("access_list")) {
            if (!Array.isArray(message.access_list))
                return "access_list: array expected";
            for (var i = 0; i < message.access_list.length; ++i) {
                var error = $root.EthereumAccessListOneKey.verify(message.access_list[i]);
                if (error)
                    return "access_list." + error;
            }
        }
        return null;
    };

    EthereumSignTxEIP1559OneKey.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumSignTxEIP1559OneKey)
            return object;
        var message = new $root.EthereumSignTxEIP1559OneKey();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".EthereumSignTxEIP1559OneKey.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.nonce != null)
            if (typeof object.nonce === "string")
                $util.base64.decode(object.nonce, message.nonce = $util.newBuffer($util.base64.length(object.nonce)), 0);
            else if (object.nonce.length)
                message.nonce = object.nonce;
        if (object.max_gas_fee != null)
            if (typeof object.max_gas_fee === "string")
                $util.base64.decode(object.max_gas_fee, message.max_gas_fee = $util.newBuffer($util.base64.length(object.max_gas_fee)), 0);
            else if (object.max_gas_fee.length)
                message.max_gas_fee = object.max_gas_fee;
        if (object.max_priority_fee != null)
            if (typeof object.max_priority_fee === "string")
                $util.base64.decode(object.max_priority_fee, message.max_priority_fee = $util.newBuffer($util.base64.length(object.max_priority_fee)), 0);
            else if (object.max_priority_fee.length)
                message.max_priority_fee = object.max_priority_fee;
        if (object.gas_limit != null)
            if (typeof object.gas_limit === "string")
                $util.base64.decode(object.gas_limit, message.gas_limit = $util.newBuffer($util.base64.length(object.gas_limit)), 0);
            else if (object.gas_limit.length)
                message.gas_limit = object.gas_limit;
        if (object.to != null)
            message.to = String(object.to);
        if (object.value != null)
            if (typeof object.value === "string")
                $util.base64.decode(object.value, message.value = $util.newBuffer($util.base64.length(object.value)), 0);
            else if (object.value.length)
                message.value = object.value;
        if (object.data_initial_chunk != null)
            if (typeof object.data_initial_chunk === "string")
                $util.base64.decode(object.data_initial_chunk, message.data_initial_chunk = $util.newBuffer($util.base64.length(object.data_initial_chunk)), 0);
            else if (object.data_initial_chunk.length)
                message.data_initial_chunk = object.data_initial_chunk;
        if (object.data_length != null)
            message.data_length = object.data_length >>> 0;
        if (object.chain_id != null)
            if ($util.Long)
                (message.chain_id = $util.Long.fromValue(object.chain_id)).unsigned = true;
            else if (typeof object.chain_id === "string")
                message.chain_id = parseInt(object.chain_id, 10);
            else if (typeof object.chain_id === "number")
                message.chain_id = object.chain_id;
            else if (typeof object.chain_id === "object")
                message.chain_id = new $util.LongBits(object.chain_id.low >>> 0, object.chain_id.high >>> 0).toNumber(true);
        if (object.access_list) {
            if (!Array.isArray(object.access_list))
                throw TypeError(".EthereumSignTxEIP1559OneKey.access_list: array expected");
            message.access_list = [];
            for (var i = 0; i < object.access_list.length; ++i) {
                if (typeof object.access_list[i] !== "object")
                    throw TypeError(".EthereumSignTxEIP1559OneKey.access_list: object expected");
                message.access_list[i] = $root.EthereumAccessListOneKey.fromObject(object.access_list[i]);
            }
        }
        return message;
    };

    EthereumSignTxEIP1559OneKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults) {
            object.address_n = [];
            object.access_list = [];
        }
        if (options.defaults) {
            if (options.bytes === String)
                object.nonce = "";
            else {
                object.nonce = [];
                if (options.bytes !== Array)
                    object.nonce = $util.newBuffer(object.nonce);
            }
            if (options.bytes === String)
                object.max_gas_fee = "";
            else {
                object.max_gas_fee = [];
                if (options.bytes !== Array)
                    object.max_gas_fee = $util.newBuffer(object.max_gas_fee);
            }
            if (options.bytes === String)
                object.max_priority_fee = "";
            else {
                object.max_priority_fee = [];
                if (options.bytes !== Array)
                    object.max_priority_fee = $util.newBuffer(object.max_priority_fee);
            }
            if (options.bytes === String)
                object.gas_limit = "";
            else {
                object.gas_limit = [];
                if (options.bytes !== Array)
                    object.gas_limit = $util.newBuffer(object.gas_limit);
            }
            object.to = "";
            if (options.bytes === String)
                object.value = "";
            else {
                object.value = [];
                if (options.bytes !== Array)
                    object.value = $util.newBuffer(object.value);
            }
            if (options.bytes === String)
                object.data_initial_chunk = "";
            else {
                object.data_initial_chunk = [];
                if (options.bytes !== Array)
                    object.data_initial_chunk = $util.newBuffer(object.data_initial_chunk);
            }
            object.data_length = 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.chain_id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.chain_id = options.longs === String ? "0" : 0;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.nonce != null && message.hasOwnProperty("nonce"))
            object.nonce = options.bytes === String ? $util.base64.encode(message.nonce, 0, message.nonce.length) : options.bytes === Array ? Array.prototype.slice.call(message.nonce) : message.nonce;
        if (message.max_gas_fee != null && message.hasOwnProperty("max_gas_fee"))
            object.max_gas_fee = options.bytes === String ? $util.base64.encode(message.max_gas_fee, 0, message.max_gas_fee.length) : options.bytes === Array ? Array.prototype.slice.call(message.max_gas_fee) : message.max_gas_fee;
        if (message.max_priority_fee != null && message.hasOwnProperty("max_priority_fee"))
            object.max_priority_fee = options.bytes === String ? $util.base64.encode(message.max_priority_fee, 0, message.max_priority_fee.length) : options.bytes === Array ? Array.prototype.slice.call(message.max_priority_fee) : message.max_priority_fee;
        if (message.gas_limit != null && message.hasOwnProperty("gas_limit"))
            object.gas_limit = options.bytes === String ? $util.base64.encode(message.gas_limit, 0, message.gas_limit.length) : options.bytes === Array ? Array.prototype.slice.call(message.gas_limit) : message.gas_limit;
        if (message.to != null && message.hasOwnProperty("to"))
            object.to = message.to;
        if (message.value != null && message.hasOwnProperty("value"))
            object.value = options.bytes === String ? $util.base64.encode(message.value, 0, message.value.length) : options.bytes === Array ? Array.prototype.slice.call(message.value) : message.value;
        if (message.data_initial_chunk != null && message.hasOwnProperty("data_initial_chunk"))
            object.data_initial_chunk = options.bytes === String ? $util.base64.encode(message.data_initial_chunk, 0, message.data_initial_chunk.length) : options.bytes === Array ? Array.prototype.slice.call(message.data_initial_chunk) : message.data_initial_chunk;
        if (message.data_length != null && message.hasOwnProperty("data_length"))
            object.data_length = message.data_length;
        if (message.chain_id != null && message.hasOwnProperty("chain_id"))
            if (typeof message.chain_id === "number")
                object.chain_id = options.longs === String ? String(message.chain_id) : message.chain_id;
            else
                object.chain_id = options.longs === String ? $util.Long.prototype.toString.call(message.chain_id) : options.longs === Number ? new $util.LongBits(message.chain_id.low >>> 0, message.chain_id.high >>> 0).toNumber(true) : message.chain_id;
        if (message.access_list && message.access_list.length) {
            object.access_list = [];
            for (var j = 0; j < message.access_list.length; ++j)
                object.access_list[j] = $root.EthereumAccessListOneKey.toObject(message.access_list[j], options);
        }
        return object;
    };

    EthereumSignTxEIP1559OneKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumSignTxEIP1559OneKey;
})();

$root.EthereumAuthorizationSignature = (function() {

    function EthereumAuthorizationSignature(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumAuthorizationSignature.prototype.y_parity = 0;
    EthereumAuthorizationSignature.prototype.r = $util.newBuffer([]);
    EthereumAuthorizationSignature.prototype.s = $util.newBuffer([]);

    EthereumAuthorizationSignature.create = function create(properties) {
        return new EthereumAuthorizationSignature(properties);
    };

    EthereumAuthorizationSignature.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).uint32(message.y_parity);
        writer.uint32(18).bytes(message.r);
        writer.uint32(26).bytes(message.s);
        return writer;
    };

    EthereumAuthorizationSignature.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumAuthorizationSignature.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumAuthorizationSignature();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.y_parity = reader.uint32();
                break;
            case 2:
                message.r = reader.bytes();
                break;
            case 3:
                message.s = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("y_parity"))
            throw $util.ProtocolError("missing required 'y_parity'", { instance: message });
        if (!message.hasOwnProperty("r"))
            throw $util.ProtocolError("missing required 'r'", { instance: message });
        if (!message.hasOwnProperty("s"))
            throw $util.ProtocolError("missing required 's'", { instance: message });
        return message;
    };

    EthereumAuthorizationSignature.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumAuthorizationSignature.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isInteger(message.y_parity))
            return "y_parity: integer expected";
        if (!(message.r && typeof message.r.length === "number" || $util.isString(message.r)))
            return "r: buffer expected";
        if (!(message.s && typeof message.s.length === "number" || $util.isString(message.s)))
            return "s: buffer expected";
        return null;
    };

    EthereumAuthorizationSignature.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumAuthorizationSignature)
            return object;
        var message = new $root.EthereumAuthorizationSignature();
        if (object.y_parity != null)
            message.y_parity = object.y_parity >>> 0;
        if (object.r != null)
            if (typeof object.r === "string")
                $util.base64.decode(object.r, message.r = $util.newBuffer($util.base64.length(object.r)), 0);
            else if (object.r.length)
                message.r = object.r;
        if (object.s != null)
            if (typeof object.s === "string")
                $util.base64.decode(object.s, message.s = $util.newBuffer($util.base64.length(object.s)), 0);
            else if (object.s.length)
                message.s = object.s;
        return message;
    };

    EthereumAuthorizationSignature.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.y_parity = 0;
            if (options.bytes === String)
                object.r = "";
            else {
                object.r = [];
                if (options.bytes !== Array)
                    object.r = $util.newBuffer(object.r);
            }
            if (options.bytes === String)
                object.s = "";
            else {
                object.s = [];
                if (options.bytes !== Array)
                    object.s = $util.newBuffer(object.s);
            }
        }
        if (message.y_parity != null && message.hasOwnProperty("y_parity"))
            object.y_parity = message.y_parity;
        if (message.r != null && message.hasOwnProperty("r"))
            object.r = options.bytes === String ? $util.base64.encode(message.r, 0, message.r.length) : options.bytes === Array ? Array.prototype.slice.call(message.r) : message.r;
        if (message.s != null && message.hasOwnProperty("s"))
            object.s = options.bytes === String ? $util.base64.encode(message.s, 0, message.s.length) : options.bytes === Array ? Array.prototype.slice.call(message.s) : message.s;
        return object;
    };

    EthereumAuthorizationSignature.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumAuthorizationSignature;
})();

$root.EthereumSignTxEIP7702OneKey = (function() {

    function EthereumSignTxEIP7702OneKey(properties) {
        this.address_n = [];
        this.access_list = [];
        this.authorization_list = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumSignTxEIP7702OneKey.prototype.address_n = $util.emptyArray;
    EthereumSignTxEIP7702OneKey.prototype.nonce = $util.newBuffer([]);
    EthereumSignTxEIP7702OneKey.prototype.max_gas_fee = $util.newBuffer([]);
    EthereumSignTxEIP7702OneKey.prototype.max_priority_fee = $util.newBuffer([]);
    EthereumSignTxEIP7702OneKey.prototype.gas_limit = $util.newBuffer([]);
    EthereumSignTxEIP7702OneKey.prototype.to = "";
    EthereumSignTxEIP7702OneKey.prototype.value = $util.newBuffer([]);
    EthereumSignTxEIP7702OneKey.prototype.data_initial_chunk = $util.newBuffer([]);
    EthereumSignTxEIP7702OneKey.prototype.data_length = 0;
    EthereumSignTxEIP7702OneKey.prototype.chain_id = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    EthereumSignTxEIP7702OneKey.prototype.access_list = $util.emptyArray;
    EthereumSignTxEIP7702OneKey.prototype.authorization_list = $util.emptyArray;

    EthereumSignTxEIP7702OneKey.create = function create(properties) {
        return new EthereumSignTxEIP7702OneKey(properties);
    };

    EthereumSignTxEIP7702OneKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).bytes(message.nonce);
        writer.uint32(26).bytes(message.max_gas_fee);
        writer.uint32(34).bytes(message.max_priority_fee);
        writer.uint32(42).bytes(message.gas_limit);
        writer.uint32(50).string(message.to);
        writer.uint32(58).bytes(message.value);
        if (message.data_initial_chunk != null && Object.hasOwnProperty.call(message, "data_initial_chunk"))
            writer.uint32(66).bytes(message.data_initial_chunk);
        writer.uint32(72).uint32(message.data_length);
        writer.uint32(80).uint64(message.chain_id);
        if (message.access_list != null && message.access_list.length)
            for (var i = 0; i < message.access_list.length; ++i)
                $root.EthereumAccessListOneKey.encode(message.access_list[i], writer.uint32(90).fork()).ldelim();
        if (message.authorization_list != null && message.authorization_list.length)
            for (var i = 0; i < message.authorization_list.length; ++i)
                $root.EthereumSignTxEIP7702OneKey.EthereumAuthorizationOneKey.encode(message.authorization_list[i], writer.uint32(98).fork()).ldelim();
        return writer;
    };

    EthereumSignTxEIP7702OneKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumSignTxEIP7702OneKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumSignTxEIP7702OneKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.nonce = reader.bytes();
                break;
            case 3:
                message.max_gas_fee = reader.bytes();
                break;
            case 4:
                message.max_priority_fee = reader.bytes();
                break;
            case 5:
                message.gas_limit = reader.bytes();
                break;
            case 6:
                message.to = reader.string();
                break;
            case 7:
                message.value = reader.bytes();
                break;
            case 8:
                message.data_initial_chunk = reader.bytes();
                break;
            case 9:
                message.data_length = reader.uint32();
                break;
            case 10:
                message.chain_id = reader.uint64();
                break;
            case 11:
                if (!(message.access_list && message.access_list.length))
                    message.access_list = [];
                message.access_list.push($root.EthereumAccessListOneKey.decode(reader, reader.uint32()));
                break;
            case 12:
                if (!(message.authorization_list && message.authorization_list.length))
                    message.authorization_list = [];
                message.authorization_list.push($root.EthereumSignTxEIP7702OneKey.EthereumAuthorizationOneKey.decode(reader, reader.uint32()));
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("nonce"))
            throw $util.ProtocolError("missing required 'nonce'", { instance: message });
        if (!message.hasOwnProperty("max_gas_fee"))
            throw $util.ProtocolError("missing required 'max_gas_fee'", { instance: message });
        if (!message.hasOwnProperty("max_priority_fee"))
            throw $util.ProtocolError("missing required 'max_priority_fee'", { instance: message });
        if (!message.hasOwnProperty("gas_limit"))
            throw $util.ProtocolError("missing required 'gas_limit'", { instance: message });
        if (!message.hasOwnProperty("to"))
            throw $util.ProtocolError("missing required 'to'", { instance: message });
        if (!message.hasOwnProperty("value"))
            throw $util.ProtocolError("missing required 'value'", { instance: message });
        if (!message.hasOwnProperty("data_length"))
            throw $util.ProtocolError("missing required 'data_length'", { instance: message });
        if (!message.hasOwnProperty("chain_id"))
            throw $util.ProtocolError("missing required 'chain_id'", { instance: message });
        return message;
    };

    EthereumSignTxEIP7702OneKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumSignTxEIP7702OneKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!(message.nonce && typeof message.nonce.length === "number" || $util.isString(message.nonce)))
            return "nonce: buffer expected";
        if (!(message.max_gas_fee && typeof message.max_gas_fee.length === "number" || $util.isString(message.max_gas_fee)))
            return "max_gas_fee: buffer expected";
        if (!(message.max_priority_fee && typeof message.max_priority_fee.length === "number" || $util.isString(message.max_priority_fee)))
            return "max_priority_fee: buffer expected";
        if (!(message.gas_limit && typeof message.gas_limit.length === "number" || $util.isString(message.gas_limit)))
            return "gas_limit: buffer expected";
        if (!$util.isString(message.to))
            return "to: string expected";
        if (!(message.value && typeof message.value.length === "number" || $util.isString(message.value)))
            return "value: buffer expected";
        if (message.data_initial_chunk != null && message.hasOwnProperty("data_initial_chunk"))
            if (!(message.data_initial_chunk && typeof message.data_initial_chunk.length === "number" || $util.isString(message.data_initial_chunk)))
                return "data_initial_chunk: buffer expected";
        if (!$util.isInteger(message.data_length))
            return "data_length: integer expected";
        if (!$util.isInteger(message.chain_id) && !(message.chain_id && $util.isInteger(message.chain_id.low) && $util.isInteger(message.chain_id.high)))
            return "chain_id: integer|Long expected";
        if (message.access_list != null && message.hasOwnProperty("access_list")) {
            if (!Array.isArray(message.access_list))
                return "access_list: array expected";
            for (var i = 0; i < message.access_list.length; ++i) {
                var error = $root.EthereumAccessListOneKey.verify(message.access_list[i]);
                if (error)
                    return "access_list." + error;
            }
        }
        if (message.authorization_list != null && message.hasOwnProperty("authorization_list")) {
            if (!Array.isArray(message.authorization_list))
                return "authorization_list: array expected";
            for (var i = 0; i < message.authorization_list.length; ++i) {
                var error = $root.EthereumSignTxEIP7702OneKey.EthereumAuthorizationOneKey.verify(message.authorization_list[i]);
                if (error)
                    return "authorization_list." + error;
            }
        }
        return null;
    };

    EthereumSignTxEIP7702OneKey.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumSignTxEIP7702OneKey)
            return object;
        var message = new $root.EthereumSignTxEIP7702OneKey();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".EthereumSignTxEIP7702OneKey.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.nonce != null)
            if (typeof object.nonce === "string")
                $util.base64.decode(object.nonce, message.nonce = $util.newBuffer($util.base64.length(object.nonce)), 0);
            else if (object.nonce.length)
                message.nonce = object.nonce;
        if (object.max_gas_fee != null)
            if (typeof object.max_gas_fee === "string")
                $util.base64.decode(object.max_gas_fee, message.max_gas_fee = $util.newBuffer($util.base64.length(object.max_gas_fee)), 0);
            else if (object.max_gas_fee.length)
                message.max_gas_fee = object.max_gas_fee;
        if (object.max_priority_fee != null)
            if (typeof object.max_priority_fee === "string")
                $util.base64.decode(object.max_priority_fee, message.max_priority_fee = $util.newBuffer($util.base64.length(object.max_priority_fee)), 0);
            else if (object.max_priority_fee.length)
                message.max_priority_fee = object.max_priority_fee;
        if (object.gas_limit != null)
            if (typeof object.gas_limit === "string")
                $util.base64.decode(object.gas_limit, message.gas_limit = $util.newBuffer($util.base64.length(object.gas_limit)), 0);
            else if (object.gas_limit.length)
                message.gas_limit = object.gas_limit;
        if (object.to != null)
            message.to = String(object.to);
        if (object.value != null)
            if (typeof object.value === "string")
                $util.base64.decode(object.value, message.value = $util.newBuffer($util.base64.length(object.value)), 0);
            else if (object.value.length)
                message.value = object.value;
        if (object.data_initial_chunk != null)
            if (typeof object.data_initial_chunk === "string")
                $util.base64.decode(object.data_initial_chunk, message.data_initial_chunk = $util.newBuffer($util.base64.length(object.data_initial_chunk)), 0);
            else if (object.data_initial_chunk.length)
                message.data_initial_chunk = object.data_initial_chunk;
        if (object.data_length != null)
            message.data_length = object.data_length >>> 0;
        if (object.chain_id != null)
            if ($util.Long)
                (message.chain_id = $util.Long.fromValue(object.chain_id)).unsigned = true;
            else if (typeof object.chain_id === "string")
                message.chain_id = parseInt(object.chain_id, 10);
            else if (typeof object.chain_id === "number")
                message.chain_id = object.chain_id;
            else if (typeof object.chain_id === "object")
                message.chain_id = new $util.LongBits(object.chain_id.low >>> 0, object.chain_id.high >>> 0).toNumber(true);
        if (object.access_list) {
            if (!Array.isArray(object.access_list))
                throw TypeError(".EthereumSignTxEIP7702OneKey.access_list: array expected");
            message.access_list = [];
            for (var i = 0; i < object.access_list.length; ++i) {
                if (typeof object.access_list[i] !== "object")
                    throw TypeError(".EthereumSignTxEIP7702OneKey.access_list: object expected");
                message.access_list[i] = $root.EthereumAccessListOneKey.fromObject(object.access_list[i]);
            }
        }
        if (object.authorization_list) {
            if (!Array.isArray(object.authorization_list))
                throw TypeError(".EthereumSignTxEIP7702OneKey.authorization_list: array expected");
            message.authorization_list = [];
            for (var i = 0; i < object.authorization_list.length; ++i) {
                if (typeof object.authorization_list[i] !== "object")
                    throw TypeError(".EthereumSignTxEIP7702OneKey.authorization_list: object expected");
                message.authorization_list[i] = $root.EthereumSignTxEIP7702OneKey.EthereumAuthorizationOneKey.fromObject(object.authorization_list[i]);
            }
        }
        return message;
    };

    EthereumSignTxEIP7702OneKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults) {
            object.address_n = [];
            object.access_list = [];
            object.authorization_list = [];
        }
        if (options.defaults) {
            if (options.bytes === String)
                object.nonce = "";
            else {
                object.nonce = [];
                if (options.bytes !== Array)
                    object.nonce = $util.newBuffer(object.nonce);
            }
            if (options.bytes === String)
                object.max_gas_fee = "";
            else {
                object.max_gas_fee = [];
                if (options.bytes !== Array)
                    object.max_gas_fee = $util.newBuffer(object.max_gas_fee);
            }
            if (options.bytes === String)
                object.max_priority_fee = "";
            else {
                object.max_priority_fee = [];
                if (options.bytes !== Array)
                    object.max_priority_fee = $util.newBuffer(object.max_priority_fee);
            }
            if (options.bytes === String)
                object.gas_limit = "";
            else {
                object.gas_limit = [];
                if (options.bytes !== Array)
                    object.gas_limit = $util.newBuffer(object.gas_limit);
            }
            object.to = "";
            if (options.bytes === String)
                object.value = "";
            else {
                object.value = [];
                if (options.bytes !== Array)
                    object.value = $util.newBuffer(object.value);
            }
            if (options.bytes === String)
                object.data_initial_chunk = "";
            else {
                object.data_initial_chunk = [];
                if (options.bytes !== Array)
                    object.data_initial_chunk = $util.newBuffer(object.data_initial_chunk);
            }
            object.data_length = 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.chain_id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.chain_id = options.longs === String ? "0" : 0;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.nonce != null && message.hasOwnProperty("nonce"))
            object.nonce = options.bytes === String ? $util.base64.encode(message.nonce, 0, message.nonce.length) : options.bytes === Array ? Array.prototype.slice.call(message.nonce) : message.nonce;
        if (message.max_gas_fee != null && message.hasOwnProperty("max_gas_fee"))
            object.max_gas_fee = options.bytes === String ? $util.base64.encode(message.max_gas_fee, 0, message.max_gas_fee.length) : options.bytes === Array ? Array.prototype.slice.call(message.max_gas_fee) : message.max_gas_fee;
        if (message.max_priority_fee != null && message.hasOwnProperty("max_priority_fee"))
            object.max_priority_fee = options.bytes === String ? $util.base64.encode(message.max_priority_fee, 0, message.max_priority_fee.length) : options.bytes === Array ? Array.prototype.slice.call(message.max_priority_fee) : message.max_priority_fee;
        if (message.gas_limit != null && message.hasOwnProperty("gas_limit"))
            object.gas_limit = options.bytes === String ? $util.base64.encode(message.gas_limit, 0, message.gas_limit.length) : options.bytes === Array ? Array.prototype.slice.call(message.gas_limit) : message.gas_limit;
        if (message.to != null && message.hasOwnProperty("to"))
            object.to = message.to;
        if (message.value != null && message.hasOwnProperty("value"))
            object.value = options.bytes === String ? $util.base64.encode(message.value, 0, message.value.length) : options.bytes === Array ? Array.prototype.slice.call(message.value) : message.value;
        if (message.data_initial_chunk != null && message.hasOwnProperty("data_initial_chunk"))
            object.data_initial_chunk = options.bytes === String ? $util.base64.encode(message.data_initial_chunk, 0, message.data_initial_chunk.length) : options.bytes === Array ? Array.prototype.slice.call(message.data_initial_chunk) : message.data_initial_chunk;
        if (message.data_length != null && message.hasOwnProperty("data_length"))
            object.data_length = message.data_length;
        if (message.chain_id != null && message.hasOwnProperty("chain_id"))
            if (typeof message.chain_id === "number")
                object.chain_id = options.longs === String ? String(message.chain_id) : message.chain_id;
            else
                object.chain_id = options.longs === String ? $util.Long.prototype.toString.call(message.chain_id) : options.longs === Number ? new $util.LongBits(message.chain_id.low >>> 0, message.chain_id.high >>> 0).toNumber(true) : message.chain_id;
        if (message.access_list && message.access_list.length) {
            object.access_list = [];
            for (var j = 0; j < message.access_list.length; ++j)
                object.access_list[j] = $root.EthereumAccessListOneKey.toObject(message.access_list[j], options);
        }
        if (message.authorization_list && message.authorization_list.length) {
            object.authorization_list = [];
            for (var j = 0; j < message.authorization_list.length; ++j)
                object.authorization_list[j] = $root.EthereumSignTxEIP7702OneKey.EthereumAuthorizationOneKey.toObject(message.authorization_list[j], options);
        }
        return object;
    };

    EthereumSignTxEIP7702OneKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    EthereumSignTxEIP7702OneKey.EthereumAuthorizationOneKey = (function() {

        function EthereumAuthorizationOneKey(properties) {
            this.address_n = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        EthereumAuthorizationOneKey.prototype.address_n = $util.emptyArray;
        EthereumAuthorizationOneKey.prototype.chain_id = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        EthereumAuthorizationOneKey.prototype.address = "";
        EthereumAuthorizationOneKey.prototype.nonce = $util.newBuffer([]);
        EthereumAuthorizationOneKey.prototype.signature = null;

        EthereumAuthorizationOneKey.create = function create(properties) {
            return new EthereumAuthorizationOneKey(properties);
        };

        EthereumAuthorizationOneKey.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.address_n != null && message.address_n.length)
                for (var i = 0; i < message.address_n.length; ++i)
                    writer.uint32(8).uint32(message.address_n[i]);
            writer.uint32(16).uint64(message.chain_id);
            writer.uint32(26).string(message.address);
            writer.uint32(34).bytes(message.nonce);
            if (message.signature != null && Object.hasOwnProperty.call(message, "signature"))
                $root.EthereumAuthorizationSignature.encode(message.signature, writer.uint32(42).fork()).ldelim();
            return writer;
        };

        EthereumAuthorizationOneKey.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        EthereumAuthorizationOneKey.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumSignTxEIP7702OneKey.EthereumAuthorizationOneKey();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.address_n && message.address_n.length))
                        message.address_n = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.address_n.push(reader.uint32());
                    } else
                        message.address_n.push(reader.uint32());
                    break;
                case 2:
                    message.chain_id = reader.uint64();
                    break;
                case 3:
                    message.address = reader.string();
                    break;
                case 4:
                    message.nonce = reader.bytes();
                    break;
                case 5:
                    message.signature = $root.EthereumAuthorizationSignature.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("chain_id"))
                throw $util.ProtocolError("missing required 'chain_id'", { instance: message });
            if (!message.hasOwnProperty("address"))
                throw $util.ProtocolError("missing required 'address'", { instance: message });
            if (!message.hasOwnProperty("nonce"))
                throw $util.ProtocolError("missing required 'nonce'", { instance: message });
            return message;
        };

        EthereumAuthorizationOneKey.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        EthereumAuthorizationOneKey.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.address_n != null && message.hasOwnProperty("address_n")) {
                if (!Array.isArray(message.address_n))
                    return "address_n: array expected";
                for (var i = 0; i < message.address_n.length; ++i)
                    if (!$util.isInteger(message.address_n[i]))
                        return "address_n: integer[] expected";
            }
            if (!$util.isInteger(message.chain_id) && !(message.chain_id && $util.isInteger(message.chain_id.low) && $util.isInteger(message.chain_id.high)))
                return "chain_id: integer|Long expected";
            if (!$util.isString(message.address))
                return "address: string expected";
            if (!(message.nonce && typeof message.nonce.length === "number" || $util.isString(message.nonce)))
                return "nonce: buffer expected";
            if (message.signature != null && message.hasOwnProperty("signature")) {
                var error = $root.EthereumAuthorizationSignature.verify(message.signature);
                if (error)
                    return "signature." + error;
            }
            return null;
        };

        EthereumAuthorizationOneKey.fromObject = function fromObject(object) {
            if (object instanceof $root.EthereumSignTxEIP7702OneKey.EthereumAuthorizationOneKey)
                return object;
            var message = new $root.EthereumSignTxEIP7702OneKey.EthereumAuthorizationOneKey();
            if (object.address_n) {
                if (!Array.isArray(object.address_n))
                    throw TypeError(".EthereumSignTxEIP7702OneKey.EthereumAuthorizationOneKey.address_n: array expected");
                message.address_n = [];
                for (var i = 0; i < object.address_n.length; ++i)
                    message.address_n[i] = object.address_n[i] >>> 0;
            }
            if (object.chain_id != null)
                if ($util.Long)
                    (message.chain_id = $util.Long.fromValue(object.chain_id)).unsigned = true;
                else if (typeof object.chain_id === "string")
                    message.chain_id = parseInt(object.chain_id, 10);
                else if (typeof object.chain_id === "number")
                    message.chain_id = object.chain_id;
                else if (typeof object.chain_id === "object")
                    message.chain_id = new $util.LongBits(object.chain_id.low >>> 0, object.chain_id.high >>> 0).toNumber(true);
            if (object.address != null)
                message.address = String(object.address);
            if (object.nonce != null)
                if (typeof object.nonce === "string")
                    $util.base64.decode(object.nonce, message.nonce = $util.newBuffer($util.base64.length(object.nonce)), 0);
                else if (object.nonce.length)
                    message.nonce = object.nonce;
            if (object.signature != null) {
                if (typeof object.signature !== "object")
                    throw TypeError(".EthereumSignTxEIP7702OneKey.EthereumAuthorizationOneKey.signature: object expected");
                message.signature = $root.EthereumAuthorizationSignature.fromObject(object.signature);
            }
            return message;
        };

        EthereumAuthorizationOneKey.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.address_n = [];
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.chain_id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.chain_id = options.longs === String ? "0" : 0;
                object.address = "";
                if (options.bytes === String)
                    object.nonce = "";
                else {
                    object.nonce = [];
                    if (options.bytes !== Array)
                        object.nonce = $util.newBuffer(object.nonce);
                }
                object.signature = null;
            }
            if (message.address_n && message.address_n.length) {
                object.address_n = [];
                for (var j = 0; j < message.address_n.length; ++j)
                    object.address_n[j] = message.address_n[j];
            }
            if (message.chain_id != null && message.hasOwnProperty("chain_id"))
                if (typeof message.chain_id === "number")
                    object.chain_id = options.longs === String ? String(message.chain_id) : message.chain_id;
                else
                    object.chain_id = options.longs === String ? $util.Long.prototype.toString.call(message.chain_id) : options.longs === Number ? new $util.LongBits(message.chain_id.low >>> 0, message.chain_id.high >>> 0).toNumber(true) : message.chain_id;
            if (message.address != null && message.hasOwnProperty("address"))
                object.address = message.address;
            if (message.nonce != null && message.hasOwnProperty("nonce"))
                object.nonce = options.bytes === String ? $util.base64.encode(message.nonce, 0, message.nonce.length) : options.bytes === Array ? Array.prototype.slice.call(message.nonce) : message.nonce;
            if (message.signature != null && message.hasOwnProperty("signature"))
                object.signature = $root.EthereumAuthorizationSignature.toObject(message.signature, options);
            return object;
        };

        EthereumAuthorizationOneKey.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EthereumAuthorizationOneKey;
    })();

    return EthereumSignTxEIP7702OneKey;
})();

$root.EthereumTxRequestOneKey = (function() {

    function EthereumTxRequestOneKey(properties) {
        this.authorization_signatures = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumTxRequestOneKey.prototype.data_length = 0;
    EthereumTxRequestOneKey.prototype.signature_v = 0;
    EthereumTxRequestOneKey.prototype.signature_r = $util.newBuffer([]);
    EthereumTxRequestOneKey.prototype.signature_s = $util.newBuffer([]);
    EthereumTxRequestOneKey.prototype.authorization_signatures = $util.emptyArray;

    EthereumTxRequestOneKey.create = function create(properties) {
        return new EthereumTxRequestOneKey(properties);
    };

    EthereumTxRequestOneKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.data_length != null && Object.hasOwnProperty.call(message, "data_length"))
            writer.uint32(8).uint32(message.data_length);
        if (message.signature_v != null && Object.hasOwnProperty.call(message, "signature_v"))
            writer.uint32(16).uint32(message.signature_v);
        if (message.signature_r != null && Object.hasOwnProperty.call(message, "signature_r"))
            writer.uint32(26).bytes(message.signature_r);
        if (message.signature_s != null && Object.hasOwnProperty.call(message, "signature_s"))
            writer.uint32(34).bytes(message.signature_s);
        if (message.authorization_signatures != null && message.authorization_signatures.length)
            for (var i = 0; i < message.authorization_signatures.length; ++i)
                $root.EthereumAuthorizationSignature.encode(message.authorization_signatures[i], writer.uint32(82).fork()).ldelim();
        return writer;
    };

    EthereumTxRequestOneKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumTxRequestOneKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumTxRequestOneKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.data_length = reader.uint32();
                break;
            case 2:
                message.signature_v = reader.uint32();
                break;
            case 3:
                message.signature_r = reader.bytes();
                break;
            case 4:
                message.signature_s = reader.bytes();
                break;
            case 10:
                if (!(message.authorization_signatures && message.authorization_signatures.length))
                    message.authorization_signatures = [];
                message.authorization_signatures.push($root.EthereumAuthorizationSignature.decode(reader, reader.uint32()));
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    EthereumTxRequestOneKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumTxRequestOneKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.data_length != null && message.hasOwnProperty("data_length"))
            if (!$util.isInteger(message.data_length))
                return "data_length: integer expected";
        if (message.signature_v != null && message.hasOwnProperty("signature_v"))
            if (!$util.isInteger(message.signature_v))
                return "signature_v: integer expected";
        if (message.signature_r != null && message.hasOwnProperty("signature_r"))
            if (!(message.signature_r && typeof message.signature_r.length === "number" || $util.isString(message.signature_r)))
                return "signature_r: buffer expected";
        if (message.signature_s != null && message.hasOwnProperty("signature_s"))
            if (!(message.signature_s && typeof message.signature_s.length === "number" || $util.isString(message.signature_s)))
                return "signature_s: buffer expected";
        if (message.authorization_signatures != null && message.hasOwnProperty("authorization_signatures")) {
            if (!Array.isArray(message.authorization_signatures))
                return "authorization_signatures: array expected";
            for (var i = 0; i < message.authorization_signatures.length; ++i) {
                var error = $root.EthereumAuthorizationSignature.verify(message.authorization_signatures[i]);
                if (error)
                    return "authorization_signatures." + error;
            }
        }
        return null;
    };

    EthereumTxRequestOneKey.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumTxRequestOneKey)
            return object;
        var message = new $root.EthereumTxRequestOneKey();
        if (object.data_length != null)
            message.data_length = object.data_length >>> 0;
        if (object.signature_v != null)
            message.signature_v = object.signature_v >>> 0;
        if (object.signature_r != null)
            if (typeof object.signature_r === "string")
                $util.base64.decode(object.signature_r, message.signature_r = $util.newBuffer($util.base64.length(object.signature_r)), 0);
            else if (object.signature_r.length)
                message.signature_r = object.signature_r;
        if (object.signature_s != null)
            if (typeof object.signature_s === "string")
                $util.base64.decode(object.signature_s, message.signature_s = $util.newBuffer($util.base64.length(object.signature_s)), 0);
            else if (object.signature_s.length)
                message.signature_s = object.signature_s;
        if (object.authorization_signatures) {
            if (!Array.isArray(object.authorization_signatures))
                throw TypeError(".EthereumTxRequestOneKey.authorization_signatures: array expected");
            message.authorization_signatures = [];
            for (var i = 0; i < object.authorization_signatures.length; ++i) {
                if (typeof object.authorization_signatures[i] !== "object")
                    throw TypeError(".EthereumTxRequestOneKey.authorization_signatures: object expected");
                message.authorization_signatures[i] = $root.EthereumAuthorizationSignature.fromObject(object.authorization_signatures[i]);
            }
        }
        return message;
    };

    EthereumTxRequestOneKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.authorization_signatures = [];
        if (options.defaults) {
            object.data_length = 0;
            object.signature_v = 0;
            if (options.bytes === String)
                object.signature_r = "";
            else {
                object.signature_r = [];
                if (options.bytes !== Array)
                    object.signature_r = $util.newBuffer(object.signature_r);
            }
            if (options.bytes === String)
                object.signature_s = "";
            else {
                object.signature_s = [];
                if (options.bytes !== Array)
                    object.signature_s = $util.newBuffer(object.signature_s);
            }
        }
        if (message.data_length != null && message.hasOwnProperty("data_length"))
            object.data_length = message.data_length;
        if (message.signature_v != null && message.hasOwnProperty("signature_v"))
            object.signature_v = message.signature_v;
        if (message.signature_r != null && message.hasOwnProperty("signature_r"))
            object.signature_r = options.bytes === String ? $util.base64.encode(message.signature_r, 0, message.signature_r.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature_r) : message.signature_r;
        if (message.signature_s != null && message.hasOwnProperty("signature_s"))
            object.signature_s = options.bytes === String ? $util.base64.encode(message.signature_s, 0, message.signature_s.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature_s) : message.signature_s;
        if (message.authorization_signatures && message.authorization_signatures.length) {
            object.authorization_signatures = [];
            for (var j = 0; j < message.authorization_signatures.length; ++j)
                object.authorization_signatures[j] = $root.EthereumAuthorizationSignature.toObject(message.authorization_signatures[j], options);
        }
        return object;
    };

    EthereumTxRequestOneKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumTxRequestOneKey;
})();

$root.EthereumTxAckOneKey = (function() {

    function EthereumTxAckOneKey(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumTxAckOneKey.prototype.data_chunk = $util.newBuffer([]);

    EthereumTxAckOneKey.create = function create(properties) {
        return new EthereumTxAckOneKey(properties);
    };

    EthereumTxAckOneKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.data_chunk);
        return writer;
    };

    EthereumTxAckOneKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumTxAckOneKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumTxAckOneKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.data_chunk = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("data_chunk"))
            throw $util.ProtocolError("missing required 'data_chunk'", { instance: message });
        return message;
    };

    EthereumTxAckOneKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumTxAckOneKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.data_chunk && typeof message.data_chunk.length === "number" || $util.isString(message.data_chunk)))
            return "data_chunk: buffer expected";
        return null;
    };

    EthereumTxAckOneKey.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumTxAckOneKey)
            return object;
        var message = new $root.EthereumTxAckOneKey();
        if (object.data_chunk != null)
            if (typeof object.data_chunk === "string")
                $util.base64.decode(object.data_chunk, message.data_chunk = $util.newBuffer($util.base64.length(object.data_chunk)), 0);
            else if (object.data_chunk.length)
                message.data_chunk = object.data_chunk;
        return message;
    };

    EthereumTxAckOneKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.data_chunk = "";
            else {
                object.data_chunk = [];
                if (options.bytes !== Array)
                    object.data_chunk = $util.newBuffer(object.data_chunk);
            }
        if (message.data_chunk != null && message.hasOwnProperty("data_chunk"))
            object.data_chunk = options.bytes === String ? $util.base64.encode(message.data_chunk, 0, message.data_chunk.length) : options.bytes === Array ? Array.prototype.slice.call(message.data_chunk) : message.data_chunk;
        return object;
    };

    EthereumTxAckOneKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumTxAckOneKey;
})();

$root.EthereumSignMessageOneKey = (function() {

    function EthereumSignMessageOneKey(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumSignMessageOneKey.prototype.address_n = $util.emptyArray;
    EthereumSignMessageOneKey.prototype.message = $util.newBuffer([]);
    EthereumSignMessageOneKey.prototype.chain_id = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    EthereumSignMessageOneKey.create = function create(properties) {
        return new EthereumSignMessageOneKey(properties);
    };

    EthereumSignMessageOneKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).bytes(message.message);
        if (message.chain_id != null && Object.hasOwnProperty.call(message, "chain_id"))
            writer.uint32(24).uint64(message.chain_id);
        return writer;
    };

    EthereumSignMessageOneKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumSignMessageOneKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumSignMessageOneKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.message = reader.bytes();
                break;
            case 3:
                message.chain_id = reader.uint64();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("message"))
            throw $util.ProtocolError("missing required 'message'", { instance: message });
        return message;
    };

    EthereumSignMessageOneKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumSignMessageOneKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!(message.message && typeof message.message.length === "number" || $util.isString(message.message)))
            return "message: buffer expected";
        if (message.chain_id != null && message.hasOwnProperty("chain_id"))
            if (!$util.isInteger(message.chain_id) && !(message.chain_id && $util.isInteger(message.chain_id.low) && $util.isInteger(message.chain_id.high)))
                return "chain_id: integer|Long expected";
        return null;
    };

    EthereumSignMessageOneKey.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumSignMessageOneKey)
            return object;
        var message = new $root.EthereumSignMessageOneKey();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".EthereumSignMessageOneKey.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.message != null)
            if (typeof object.message === "string")
                $util.base64.decode(object.message, message.message = $util.newBuffer($util.base64.length(object.message)), 0);
            else if (object.message.length)
                message.message = object.message;
        if (object.chain_id != null)
            if ($util.Long)
                (message.chain_id = $util.Long.fromValue(object.chain_id)).unsigned = true;
            else if (typeof object.chain_id === "string")
                message.chain_id = parseInt(object.chain_id, 10);
            else if (typeof object.chain_id === "number")
                message.chain_id = object.chain_id;
            else if (typeof object.chain_id === "object")
                message.chain_id = new $util.LongBits(object.chain_id.low >>> 0, object.chain_id.high >>> 0).toNumber(true);
        return message;
    };

    EthereumSignMessageOneKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            if (options.bytes === String)
                object.message = "";
            else {
                object.message = [];
                if (options.bytes !== Array)
                    object.message = $util.newBuffer(object.message);
            }
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.chain_id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.chain_id = options.longs === String ? "0" : 0;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.message != null && message.hasOwnProperty("message"))
            object.message = options.bytes === String ? $util.base64.encode(message.message, 0, message.message.length) : options.bytes === Array ? Array.prototype.slice.call(message.message) : message.message;
        if (message.chain_id != null && message.hasOwnProperty("chain_id"))
            if (typeof message.chain_id === "number")
                object.chain_id = options.longs === String ? String(message.chain_id) : message.chain_id;
            else
                object.chain_id = options.longs === String ? $util.Long.prototype.toString.call(message.chain_id) : options.longs === Number ? new $util.LongBits(message.chain_id.low >>> 0, message.chain_id.high >>> 0).toNumber(true) : message.chain_id;
        return object;
    };

    EthereumSignMessageOneKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumSignMessageOneKey;
})();

$root.EthereumMessageSignatureOneKey = (function() {

    function EthereumMessageSignatureOneKey(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumMessageSignatureOneKey.prototype.signature = $util.newBuffer([]);
    EthereumMessageSignatureOneKey.prototype.address = "";

    EthereumMessageSignatureOneKey.create = function create(properties) {
        return new EthereumMessageSignatureOneKey(properties);
    };

    EthereumMessageSignatureOneKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(18).bytes(message.signature);
        writer.uint32(26).string(message.address);
        return writer;
    };

    EthereumMessageSignatureOneKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumMessageSignatureOneKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumMessageSignatureOneKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 2:
                message.signature = reader.bytes();
                break;
            case 3:
                message.address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        if (!message.hasOwnProperty("address"))
            throw $util.ProtocolError("missing required 'address'", { instance: message });
        return message;
    };

    EthereumMessageSignatureOneKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumMessageSignatureOneKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        if (!$util.isString(message.address))
            return "address: string expected";
        return null;
    };

    EthereumMessageSignatureOneKey.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumMessageSignatureOneKey)
            return object;
        var message = new $root.EthereumMessageSignatureOneKey();
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        if (object.address != null)
            message.address = String(object.address);
        return message;
    };

    EthereumMessageSignatureOneKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
            object.address = "";
        }
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    EthereumMessageSignatureOneKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumMessageSignatureOneKey;
})();

$root.EthereumVerifyMessageOneKey = (function() {

    function EthereumVerifyMessageOneKey(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumVerifyMessageOneKey.prototype.signature = $util.newBuffer([]);
    EthereumVerifyMessageOneKey.prototype.message = $util.newBuffer([]);
    EthereumVerifyMessageOneKey.prototype.address = "";
    EthereumVerifyMessageOneKey.prototype.chain_id = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    EthereumVerifyMessageOneKey.create = function create(properties) {
        return new EthereumVerifyMessageOneKey(properties);
    };

    EthereumVerifyMessageOneKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(18).bytes(message.signature);
        writer.uint32(26).bytes(message.message);
        writer.uint32(34).string(message.address);
        if (message.chain_id != null && Object.hasOwnProperty.call(message, "chain_id"))
            writer.uint32(40).uint64(message.chain_id);
        return writer;
    };

    EthereumVerifyMessageOneKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumVerifyMessageOneKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumVerifyMessageOneKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 2:
                message.signature = reader.bytes();
                break;
            case 3:
                message.message = reader.bytes();
                break;
            case 4:
                message.address = reader.string();
                break;
            case 5:
                message.chain_id = reader.uint64();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        if (!message.hasOwnProperty("message"))
            throw $util.ProtocolError("missing required 'message'", { instance: message });
        if (!message.hasOwnProperty("address"))
            throw $util.ProtocolError("missing required 'address'", { instance: message });
        return message;
    };

    EthereumVerifyMessageOneKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumVerifyMessageOneKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        if (!(message.message && typeof message.message.length === "number" || $util.isString(message.message)))
            return "message: buffer expected";
        if (!$util.isString(message.address))
            return "address: string expected";
        if (message.chain_id != null && message.hasOwnProperty("chain_id"))
            if (!$util.isInteger(message.chain_id) && !(message.chain_id && $util.isInteger(message.chain_id.low) && $util.isInteger(message.chain_id.high)))
                return "chain_id: integer|Long expected";
        return null;
    };

    EthereumVerifyMessageOneKey.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumVerifyMessageOneKey)
            return object;
        var message = new $root.EthereumVerifyMessageOneKey();
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        if (object.message != null)
            if (typeof object.message === "string")
                $util.base64.decode(object.message, message.message = $util.newBuffer($util.base64.length(object.message)), 0);
            else if (object.message.length)
                message.message = object.message;
        if (object.address != null)
            message.address = String(object.address);
        if (object.chain_id != null)
            if ($util.Long)
                (message.chain_id = $util.Long.fromValue(object.chain_id)).unsigned = true;
            else if (typeof object.chain_id === "string")
                message.chain_id = parseInt(object.chain_id, 10);
            else if (typeof object.chain_id === "number")
                message.chain_id = object.chain_id;
            else if (typeof object.chain_id === "object")
                message.chain_id = new $util.LongBits(object.chain_id.low >>> 0, object.chain_id.high >>> 0).toNumber(true);
        return message;
    };

    EthereumVerifyMessageOneKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
            if (options.bytes === String)
                object.message = "";
            else {
                object.message = [];
                if (options.bytes !== Array)
                    object.message = $util.newBuffer(object.message);
            }
            object.address = "";
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.chain_id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.chain_id = options.longs === String ? "0" : 0;
        }
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        if (message.message != null && message.hasOwnProperty("message"))
            object.message = options.bytes === String ? $util.base64.encode(message.message, 0, message.message.length) : options.bytes === Array ? Array.prototype.slice.call(message.message) : message.message;
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        if (message.chain_id != null && message.hasOwnProperty("chain_id"))
            if (typeof message.chain_id === "number")
                object.chain_id = options.longs === String ? String(message.chain_id) : message.chain_id;
            else
                object.chain_id = options.longs === String ? $util.Long.prototype.toString.call(message.chain_id) : options.longs === Number ? new $util.LongBits(message.chain_id.low >>> 0, message.chain_id.high >>> 0).toNumber(true) : message.chain_id;
        return object;
    };

    EthereumVerifyMessageOneKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumVerifyMessageOneKey;
})();

$root.EthereumSignTypedHashOneKey = (function() {

    function EthereumSignTypedHashOneKey(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumSignTypedHashOneKey.prototype.address_n = $util.emptyArray;
    EthereumSignTypedHashOneKey.prototype.domain_separator_hash = $util.newBuffer([]);
    EthereumSignTypedHashOneKey.prototype.message_hash = $util.newBuffer([]);
    EthereumSignTypedHashOneKey.prototype.chain_id = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    EthereumSignTypedHashOneKey.create = function create(properties) {
        return new EthereumSignTypedHashOneKey(properties);
    };

    EthereumSignTypedHashOneKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).bytes(message.domain_separator_hash);
        if (message.message_hash != null && Object.hasOwnProperty.call(message, "message_hash"))
            writer.uint32(26).bytes(message.message_hash);
        if (message.chain_id != null && Object.hasOwnProperty.call(message, "chain_id"))
            writer.uint32(32).uint64(message.chain_id);
        return writer;
    };

    EthereumSignTypedHashOneKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumSignTypedHashOneKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumSignTypedHashOneKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.domain_separator_hash = reader.bytes();
                break;
            case 3:
                message.message_hash = reader.bytes();
                break;
            case 4:
                message.chain_id = reader.uint64();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("domain_separator_hash"))
            throw $util.ProtocolError("missing required 'domain_separator_hash'", { instance: message });
        return message;
    };

    EthereumSignTypedHashOneKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumSignTypedHashOneKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!(message.domain_separator_hash && typeof message.domain_separator_hash.length === "number" || $util.isString(message.domain_separator_hash)))
            return "domain_separator_hash: buffer expected";
        if (message.message_hash != null && message.hasOwnProperty("message_hash"))
            if (!(message.message_hash && typeof message.message_hash.length === "number" || $util.isString(message.message_hash)))
                return "message_hash: buffer expected";
        if (message.chain_id != null && message.hasOwnProperty("chain_id"))
            if (!$util.isInteger(message.chain_id) && !(message.chain_id && $util.isInteger(message.chain_id.low) && $util.isInteger(message.chain_id.high)))
                return "chain_id: integer|Long expected";
        return null;
    };

    EthereumSignTypedHashOneKey.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumSignTypedHashOneKey)
            return object;
        var message = new $root.EthereumSignTypedHashOneKey();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".EthereumSignTypedHashOneKey.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.domain_separator_hash != null)
            if (typeof object.domain_separator_hash === "string")
                $util.base64.decode(object.domain_separator_hash, message.domain_separator_hash = $util.newBuffer($util.base64.length(object.domain_separator_hash)), 0);
            else if (object.domain_separator_hash.length)
                message.domain_separator_hash = object.domain_separator_hash;
        if (object.message_hash != null)
            if (typeof object.message_hash === "string")
                $util.base64.decode(object.message_hash, message.message_hash = $util.newBuffer($util.base64.length(object.message_hash)), 0);
            else if (object.message_hash.length)
                message.message_hash = object.message_hash;
        if (object.chain_id != null)
            if ($util.Long)
                (message.chain_id = $util.Long.fromValue(object.chain_id)).unsigned = true;
            else if (typeof object.chain_id === "string")
                message.chain_id = parseInt(object.chain_id, 10);
            else if (typeof object.chain_id === "number")
                message.chain_id = object.chain_id;
            else if (typeof object.chain_id === "object")
                message.chain_id = new $util.LongBits(object.chain_id.low >>> 0, object.chain_id.high >>> 0).toNumber(true);
        return message;
    };

    EthereumSignTypedHashOneKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            if (options.bytes === String)
                object.domain_separator_hash = "";
            else {
                object.domain_separator_hash = [];
                if (options.bytes !== Array)
                    object.domain_separator_hash = $util.newBuffer(object.domain_separator_hash);
            }
            if (options.bytes === String)
                object.message_hash = "";
            else {
                object.message_hash = [];
                if (options.bytes !== Array)
                    object.message_hash = $util.newBuffer(object.message_hash);
            }
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.chain_id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.chain_id = options.longs === String ? "0" : 0;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.domain_separator_hash != null && message.hasOwnProperty("domain_separator_hash"))
            object.domain_separator_hash = options.bytes === String ? $util.base64.encode(message.domain_separator_hash, 0, message.domain_separator_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.domain_separator_hash) : message.domain_separator_hash;
        if (message.message_hash != null && message.hasOwnProperty("message_hash"))
            object.message_hash = options.bytes === String ? $util.base64.encode(message.message_hash, 0, message.message_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.message_hash) : message.message_hash;
        if (message.chain_id != null && message.hasOwnProperty("chain_id"))
            if (typeof message.chain_id === "number")
                object.chain_id = options.longs === String ? String(message.chain_id) : message.chain_id;
            else
                object.chain_id = options.longs === String ? $util.Long.prototype.toString.call(message.chain_id) : options.longs === Number ? new $util.LongBits(message.chain_id.low >>> 0, message.chain_id.high >>> 0).toNumber(true) : message.chain_id;
        return object;
    };

    EthereumSignTypedHashOneKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumSignTypedHashOneKey;
})();

$root.EthereumTypedDataSignatureOneKey = (function() {

    function EthereumTypedDataSignatureOneKey(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumTypedDataSignatureOneKey.prototype.signature = $util.newBuffer([]);
    EthereumTypedDataSignatureOneKey.prototype.address = "";

    EthereumTypedDataSignatureOneKey.create = function create(properties) {
        return new EthereumTypedDataSignatureOneKey(properties);
    };

    EthereumTypedDataSignatureOneKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.signature);
        writer.uint32(18).string(message.address);
        return writer;
    };

    EthereumTypedDataSignatureOneKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumTypedDataSignatureOneKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumTypedDataSignatureOneKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.signature = reader.bytes();
                break;
            case 2:
                message.address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        if (!message.hasOwnProperty("address"))
            throw $util.ProtocolError("missing required 'address'", { instance: message });
        return message;
    };

    EthereumTypedDataSignatureOneKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumTypedDataSignatureOneKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        if (!$util.isString(message.address))
            return "address: string expected";
        return null;
    };

    EthereumTypedDataSignatureOneKey.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumTypedDataSignatureOneKey)
            return object;
        var message = new $root.EthereumTypedDataSignatureOneKey();
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        if (object.address != null)
            message.address = String(object.address);
        return message;
    };

    EthereumTypedDataSignatureOneKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
            object.address = "";
        }
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    EthereumTypedDataSignatureOneKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumTypedDataSignatureOneKey;
})();

$root.EthereumSignMessageEIP712 = (function() {

    function EthereumSignMessageEIP712(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumSignMessageEIP712.prototype.address_n = $util.emptyArray;
    EthereumSignMessageEIP712.prototype.domain_hash = $util.newBuffer([]);
    EthereumSignMessageEIP712.prototype.message_hash = $util.newBuffer([]);

    EthereumSignMessageEIP712.create = function create(properties) {
        return new EthereumSignMessageEIP712(properties);
    };

    EthereumSignMessageEIP712.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.domain_hash != null && Object.hasOwnProperty.call(message, "domain_hash"))
            writer.uint32(18).bytes(message.domain_hash);
        if (message.message_hash != null && Object.hasOwnProperty.call(message, "message_hash"))
            writer.uint32(26).bytes(message.message_hash);
        return writer;
    };

    EthereumSignMessageEIP712.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumSignMessageEIP712.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumSignMessageEIP712();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.domain_hash = reader.bytes();
                break;
            case 3:
                message.message_hash = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    EthereumSignMessageEIP712.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumSignMessageEIP712.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.domain_hash != null && message.hasOwnProperty("domain_hash"))
            if (!(message.domain_hash && typeof message.domain_hash.length === "number" || $util.isString(message.domain_hash)))
                return "domain_hash: buffer expected";
        if (message.message_hash != null && message.hasOwnProperty("message_hash"))
            if (!(message.message_hash && typeof message.message_hash.length === "number" || $util.isString(message.message_hash)))
                return "message_hash: buffer expected";
        return null;
    };

    EthereumSignMessageEIP712.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumSignMessageEIP712)
            return object;
        var message = new $root.EthereumSignMessageEIP712();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".EthereumSignMessageEIP712.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.domain_hash != null)
            if (typeof object.domain_hash === "string")
                $util.base64.decode(object.domain_hash, message.domain_hash = $util.newBuffer($util.base64.length(object.domain_hash)), 0);
            else if (object.domain_hash.length)
                message.domain_hash = object.domain_hash;
        if (object.message_hash != null)
            if (typeof object.message_hash === "string")
                $util.base64.decode(object.message_hash, message.message_hash = $util.newBuffer($util.base64.length(object.message_hash)), 0);
            else if (object.message_hash.length)
                message.message_hash = object.message_hash;
        return message;
    };

    EthereumSignMessageEIP712.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            if (options.bytes === String)
                object.domain_hash = "";
            else {
                object.domain_hash = [];
                if (options.bytes !== Array)
                    object.domain_hash = $util.newBuffer(object.domain_hash);
            }
            if (options.bytes === String)
                object.message_hash = "";
            else {
                object.message_hash = [];
                if (options.bytes !== Array)
                    object.message_hash = $util.newBuffer(object.message_hash);
            }
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.domain_hash != null && message.hasOwnProperty("domain_hash"))
            object.domain_hash = options.bytes === String ? $util.base64.encode(message.domain_hash, 0, message.domain_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.domain_hash) : message.domain_hash;
        if (message.message_hash != null && message.hasOwnProperty("message_hash"))
            object.message_hash = options.bytes === String ? $util.base64.encode(message.message_hash, 0, message.message_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.message_hash) : message.message_hash;
        return object;
    };

    EthereumSignMessageEIP712.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumSignMessageEIP712;
})();

$root.EthereumGetPublicKey = (function() {

    function EthereumGetPublicKey(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumGetPublicKey.prototype.address_n = $util.emptyArray;
    EthereumGetPublicKey.prototype.show_display = false;

    EthereumGetPublicKey.create = function create(properties) {
        return new EthereumGetPublicKey(properties);
    };

    EthereumGetPublicKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(16).bool(message.show_display);
        return writer;
    };

    EthereumGetPublicKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumGetPublicKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumGetPublicKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.show_display = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    EthereumGetPublicKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumGetPublicKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        return null;
    };

    EthereumGetPublicKey.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumGetPublicKey)
            return object;
        var message = new $root.EthereumGetPublicKey();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".EthereumGetPublicKey.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        return message;
    };

    EthereumGetPublicKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            object.show_display = false;
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        return object;
    };

    EthereumGetPublicKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumGetPublicKey;
})();

$root.EthereumPublicKey = (function() {

    function EthereumPublicKey(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumPublicKey.prototype.node = null;
    EthereumPublicKey.prototype.xpub = "";

    EthereumPublicKey.create = function create(properties) {
        return new EthereumPublicKey(properties);
    };

    EthereumPublicKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        $root.HDNodeType.encode(message.node, writer.uint32(10).fork()).ldelim();
        writer.uint32(18).string(message.xpub);
        return writer;
    };

    EthereumPublicKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumPublicKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumPublicKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.node = $root.HDNodeType.decode(reader, reader.uint32());
                break;
            case 2:
                message.xpub = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("node"))
            throw $util.ProtocolError("missing required 'node'", { instance: message });
        if (!message.hasOwnProperty("xpub"))
            throw $util.ProtocolError("missing required 'xpub'", { instance: message });
        return message;
    };

    EthereumPublicKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumPublicKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        {
            var error = $root.HDNodeType.verify(message.node);
            if (error)
                return "node." + error;
        }
        if (!$util.isString(message.xpub))
            return "xpub: string expected";
        return null;
    };

    EthereumPublicKey.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumPublicKey)
            return object;
        var message = new $root.EthereumPublicKey();
        if (object.node != null) {
            if (typeof object.node !== "object")
                throw TypeError(".EthereumPublicKey.node: object expected");
            message.node = $root.HDNodeType.fromObject(object.node);
        }
        if (object.xpub != null)
            message.xpub = String(object.xpub);
        return message;
    };

    EthereumPublicKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.node = null;
            object.xpub = "";
        }
        if (message.node != null && message.hasOwnProperty("node"))
            object.node = $root.HDNodeType.toObject(message.node, options);
        if (message.xpub != null && message.hasOwnProperty("xpub"))
            object.xpub = message.xpub;
        return object;
    };

    EthereumPublicKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumPublicKey;
})();

$root.EthereumGetAddress = (function() {

    function EthereumGetAddress(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumGetAddress.prototype.address_n = $util.emptyArray;
    EthereumGetAddress.prototype.show_display = false;
    EthereumGetAddress.prototype.encoded_network = $util.newBuffer([]);

    EthereumGetAddress.create = function create(properties) {
        return new EthereumGetAddress(properties);
    };

    EthereumGetAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(16).bool(message.show_display);
        if (message.encoded_network != null && Object.hasOwnProperty.call(message, "encoded_network"))
            writer.uint32(26).bytes(message.encoded_network);
        return writer;
    };

    EthereumGetAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumGetAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumGetAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.show_display = reader.bool();
                break;
            case 3:
                message.encoded_network = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    EthereumGetAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumGetAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        if (message.encoded_network != null && message.hasOwnProperty("encoded_network"))
            if (!(message.encoded_network && typeof message.encoded_network.length === "number" || $util.isString(message.encoded_network)))
                return "encoded_network: buffer expected";
        return null;
    };

    EthereumGetAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumGetAddress)
            return object;
        var message = new $root.EthereumGetAddress();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".EthereumGetAddress.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        if (object.encoded_network != null)
            if (typeof object.encoded_network === "string")
                $util.base64.decode(object.encoded_network, message.encoded_network = $util.newBuffer($util.base64.length(object.encoded_network)), 0);
            else if (object.encoded_network.length)
                message.encoded_network = object.encoded_network;
        return message;
    };

    EthereumGetAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            object.show_display = false;
            if (options.bytes === String)
                object.encoded_network = "";
            else {
                object.encoded_network = [];
                if (options.bytes !== Array)
                    object.encoded_network = $util.newBuffer(object.encoded_network);
            }
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        if (message.encoded_network != null && message.hasOwnProperty("encoded_network"))
            object.encoded_network = options.bytes === String ? $util.base64.encode(message.encoded_network, 0, message.encoded_network.length) : options.bytes === Array ? Array.prototype.slice.call(message.encoded_network) : message.encoded_network;
        return object;
    };

    EthereumGetAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumGetAddress;
})();

$root.EthereumAddress = (function() {

    function EthereumAddress(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumAddress.prototype._old_address = $util.newBuffer([]);
    EthereumAddress.prototype.address = "";

    EthereumAddress.create = function create(properties) {
        return new EthereumAddress(properties);
    };

    EthereumAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message._old_address != null && Object.hasOwnProperty.call(message, "_old_address"))
            writer.uint32(10).bytes(message._old_address);
        if (message.address != null && Object.hasOwnProperty.call(message, "address"))
            writer.uint32(18).string(message.address);
        return writer;
    };

    EthereumAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message._old_address = reader.bytes();
                break;
            case 2:
                message.address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    EthereumAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message._old_address != null && message.hasOwnProperty("_old_address"))
            if (!(message._old_address && typeof message._old_address.length === "number" || $util.isString(message._old_address)))
                return "_old_address: buffer expected";
        if (message.address != null && message.hasOwnProperty("address"))
            if (!$util.isString(message.address))
                return "address: string expected";
        return null;
    };

    EthereumAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumAddress)
            return object;
        var message = new $root.EthereumAddress();
        if (object._old_address != null)
            if (typeof object._old_address === "string")
                $util.base64.decode(object._old_address, message._old_address = $util.newBuffer($util.base64.length(object._old_address)), 0);
            else if (object._old_address.length)
                message._old_address = object._old_address;
        if (object.address != null)
            message.address = String(object.address);
        return message;
    };

    EthereumAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object._old_address = "";
            else {
                object._old_address = [];
                if (options.bytes !== Array)
                    object._old_address = $util.newBuffer(object._old_address);
            }
            object.address = "";
        }
        if (message._old_address != null && message.hasOwnProperty("_old_address"))
            object._old_address = options.bytes === String ? $util.base64.encode(message._old_address, 0, message._old_address.length) : options.bytes === Array ? Array.prototype.slice.call(message._old_address) : message._old_address;
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    EthereumAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumAddress;
})();

$root.EthereumSignTx = (function() {

    function EthereumSignTx(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumSignTx.prototype.address_n = $util.emptyArray;
    EthereumSignTx.prototype.nonce = $util.newBuffer([]);
    EthereumSignTx.prototype.gas_price = $util.newBuffer([]);
    EthereumSignTx.prototype.gas_limit = $util.newBuffer([]);
    EthereumSignTx.prototype.to = "";
    EthereumSignTx.prototype.value = $util.newBuffer([]);
    EthereumSignTx.prototype.data_initial_chunk = $util.newBuffer([]);
    EthereumSignTx.prototype.data_length = 0;
    EthereumSignTx.prototype.chain_id = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    EthereumSignTx.prototype.tx_type = 0;
    EthereumSignTx.prototype.definitions = null;

    EthereumSignTx.create = function create(properties) {
        return new EthereumSignTx(properties);
    };

    EthereumSignTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.nonce != null && Object.hasOwnProperty.call(message, "nonce"))
            writer.uint32(18).bytes(message.nonce);
        writer.uint32(26).bytes(message.gas_price);
        writer.uint32(34).bytes(message.gas_limit);
        if (message.value != null && Object.hasOwnProperty.call(message, "value"))
            writer.uint32(50).bytes(message.value);
        if (message.data_initial_chunk != null && Object.hasOwnProperty.call(message, "data_initial_chunk"))
            writer.uint32(58).bytes(message.data_initial_chunk);
        if (message.data_length != null && Object.hasOwnProperty.call(message, "data_length"))
            writer.uint32(64).uint32(message.data_length);
        writer.uint32(72).uint64(message.chain_id);
        if (message.tx_type != null && Object.hasOwnProperty.call(message, "tx_type"))
            writer.uint32(80).uint32(message.tx_type);
        if (message.to != null && Object.hasOwnProperty.call(message, "to"))
            writer.uint32(90).string(message.to);
        if (message.definitions != null && Object.hasOwnProperty.call(message, "definitions"))
            $root.EthereumDefinitions.encode(message.definitions, writer.uint32(98).fork()).ldelim();
        return writer;
    };

    EthereumSignTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumSignTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumSignTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.nonce = reader.bytes();
                break;
            case 3:
                message.gas_price = reader.bytes();
                break;
            case 4:
                message.gas_limit = reader.bytes();
                break;
            case 11:
                message.to = reader.string();
                break;
            case 6:
                message.value = reader.bytes();
                break;
            case 7:
                message.data_initial_chunk = reader.bytes();
                break;
            case 8:
                message.data_length = reader.uint32();
                break;
            case 9:
                message.chain_id = reader.uint64();
                break;
            case 10:
                message.tx_type = reader.uint32();
                break;
            case 12:
                message.definitions = $root.EthereumDefinitions.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("gas_price"))
            throw $util.ProtocolError("missing required 'gas_price'", { instance: message });
        if (!message.hasOwnProperty("gas_limit"))
            throw $util.ProtocolError("missing required 'gas_limit'", { instance: message });
        if (!message.hasOwnProperty("chain_id"))
            throw $util.ProtocolError("missing required 'chain_id'", { instance: message });
        return message;
    };

    EthereumSignTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumSignTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.nonce != null && message.hasOwnProperty("nonce"))
            if (!(message.nonce && typeof message.nonce.length === "number" || $util.isString(message.nonce)))
                return "nonce: buffer expected";
        if (!(message.gas_price && typeof message.gas_price.length === "number" || $util.isString(message.gas_price)))
            return "gas_price: buffer expected";
        if (!(message.gas_limit && typeof message.gas_limit.length === "number" || $util.isString(message.gas_limit)))
            return "gas_limit: buffer expected";
        if (message.to != null && message.hasOwnProperty("to"))
            if (!$util.isString(message.to))
                return "to: string expected";
        if (message.value != null && message.hasOwnProperty("value"))
            if (!(message.value && typeof message.value.length === "number" || $util.isString(message.value)))
                return "value: buffer expected";
        if (message.data_initial_chunk != null && message.hasOwnProperty("data_initial_chunk"))
            if (!(message.data_initial_chunk && typeof message.data_initial_chunk.length === "number" || $util.isString(message.data_initial_chunk)))
                return "data_initial_chunk: buffer expected";
        if (message.data_length != null && message.hasOwnProperty("data_length"))
            if (!$util.isInteger(message.data_length))
                return "data_length: integer expected";
        if (!$util.isInteger(message.chain_id) && !(message.chain_id && $util.isInteger(message.chain_id.low) && $util.isInteger(message.chain_id.high)))
            return "chain_id: integer|Long expected";
        if (message.tx_type != null && message.hasOwnProperty("tx_type"))
            if (!$util.isInteger(message.tx_type))
                return "tx_type: integer expected";
        if (message.definitions != null && message.hasOwnProperty("definitions")) {
            var error = $root.EthereumDefinitions.verify(message.definitions);
            if (error)
                return "definitions." + error;
        }
        return null;
    };

    EthereumSignTx.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumSignTx)
            return object;
        var message = new $root.EthereumSignTx();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".EthereumSignTx.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.nonce != null)
            if (typeof object.nonce === "string")
                $util.base64.decode(object.nonce, message.nonce = $util.newBuffer($util.base64.length(object.nonce)), 0);
            else if (object.nonce.length)
                message.nonce = object.nonce;
        if (object.gas_price != null)
            if (typeof object.gas_price === "string")
                $util.base64.decode(object.gas_price, message.gas_price = $util.newBuffer($util.base64.length(object.gas_price)), 0);
            else if (object.gas_price.length)
                message.gas_price = object.gas_price;
        if (object.gas_limit != null)
            if (typeof object.gas_limit === "string")
                $util.base64.decode(object.gas_limit, message.gas_limit = $util.newBuffer($util.base64.length(object.gas_limit)), 0);
            else if (object.gas_limit.length)
                message.gas_limit = object.gas_limit;
        if (object.to != null)
            message.to = String(object.to);
        if (object.value != null)
            if (typeof object.value === "string")
                $util.base64.decode(object.value, message.value = $util.newBuffer($util.base64.length(object.value)), 0);
            else if (object.value.length)
                message.value = object.value;
        if (object.data_initial_chunk != null)
            if (typeof object.data_initial_chunk === "string")
                $util.base64.decode(object.data_initial_chunk, message.data_initial_chunk = $util.newBuffer($util.base64.length(object.data_initial_chunk)), 0);
            else if (object.data_initial_chunk.length)
                message.data_initial_chunk = object.data_initial_chunk;
        if (object.data_length != null)
            message.data_length = object.data_length >>> 0;
        if (object.chain_id != null)
            if ($util.Long)
                (message.chain_id = $util.Long.fromValue(object.chain_id)).unsigned = true;
            else if (typeof object.chain_id === "string")
                message.chain_id = parseInt(object.chain_id, 10);
            else if (typeof object.chain_id === "number")
                message.chain_id = object.chain_id;
            else if (typeof object.chain_id === "object")
                message.chain_id = new $util.LongBits(object.chain_id.low >>> 0, object.chain_id.high >>> 0).toNumber(true);
        if (object.tx_type != null)
            message.tx_type = object.tx_type >>> 0;
        if (object.definitions != null) {
            if (typeof object.definitions !== "object")
                throw TypeError(".EthereumSignTx.definitions: object expected");
            message.definitions = $root.EthereumDefinitions.fromObject(object.definitions);
        }
        return message;
    };

    EthereumSignTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            if (options.bytes === String)
                object.nonce = "";
            else {
                object.nonce = [];
                if (options.bytes !== Array)
                    object.nonce = $util.newBuffer(object.nonce);
            }
            if (options.bytes === String)
                object.gas_price = "";
            else {
                object.gas_price = [];
                if (options.bytes !== Array)
                    object.gas_price = $util.newBuffer(object.gas_price);
            }
            if (options.bytes === String)
                object.gas_limit = "";
            else {
                object.gas_limit = [];
                if (options.bytes !== Array)
                    object.gas_limit = $util.newBuffer(object.gas_limit);
            }
            if (options.bytes === String)
                object.value = "";
            else {
                object.value = [];
                if (options.bytes !== Array)
                    object.value = $util.newBuffer(object.value);
            }
            if (options.bytes === String)
                object.data_initial_chunk = "";
            else {
                object.data_initial_chunk = [];
                if (options.bytes !== Array)
                    object.data_initial_chunk = $util.newBuffer(object.data_initial_chunk);
            }
            object.data_length = 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.chain_id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.chain_id = options.longs === String ? "0" : 0;
            object.tx_type = 0;
            object.to = "";
            object.definitions = null;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.nonce != null && message.hasOwnProperty("nonce"))
            object.nonce = options.bytes === String ? $util.base64.encode(message.nonce, 0, message.nonce.length) : options.bytes === Array ? Array.prototype.slice.call(message.nonce) : message.nonce;
        if (message.gas_price != null && message.hasOwnProperty("gas_price"))
            object.gas_price = options.bytes === String ? $util.base64.encode(message.gas_price, 0, message.gas_price.length) : options.bytes === Array ? Array.prototype.slice.call(message.gas_price) : message.gas_price;
        if (message.gas_limit != null && message.hasOwnProperty("gas_limit"))
            object.gas_limit = options.bytes === String ? $util.base64.encode(message.gas_limit, 0, message.gas_limit.length) : options.bytes === Array ? Array.prototype.slice.call(message.gas_limit) : message.gas_limit;
        if (message.value != null && message.hasOwnProperty("value"))
            object.value = options.bytes === String ? $util.base64.encode(message.value, 0, message.value.length) : options.bytes === Array ? Array.prototype.slice.call(message.value) : message.value;
        if (message.data_initial_chunk != null && message.hasOwnProperty("data_initial_chunk"))
            object.data_initial_chunk = options.bytes === String ? $util.base64.encode(message.data_initial_chunk, 0, message.data_initial_chunk.length) : options.bytes === Array ? Array.prototype.slice.call(message.data_initial_chunk) : message.data_initial_chunk;
        if (message.data_length != null && message.hasOwnProperty("data_length"))
            object.data_length = message.data_length;
        if (message.chain_id != null && message.hasOwnProperty("chain_id"))
            if (typeof message.chain_id === "number")
                object.chain_id = options.longs === String ? String(message.chain_id) : message.chain_id;
            else
                object.chain_id = options.longs === String ? $util.Long.prototype.toString.call(message.chain_id) : options.longs === Number ? new $util.LongBits(message.chain_id.low >>> 0, message.chain_id.high >>> 0).toNumber(true) : message.chain_id;
        if (message.tx_type != null && message.hasOwnProperty("tx_type"))
            object.tx_type = message.tx_type;
        if (message.to != null && message.hasOwnProperty("to"))
            object.to = message.to;
        if (message.definitions != null && message.hasOwnProperty("definitions"))
            object.definitions = $root.EthereumDefinitions.toObject(message.definitions, options);
        return object;
    };

    EthereumSignTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumSignTx;
})();

$root.EthereumSignTxEIP1559 = (function() {

    function EthereumSignTxEIP1559(properties) {
        this.address_n = [];
        this.access_list = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumSignTxEIP1559.prototype.address_n = $util.emptyArray;
    EthereumSignTxEIP1559.prototype.nonce = $util.newBuffer([]);
    EthereumSignTxEIP1559.prototype.max_gas_fee = $util.newBuffer([]);
    EthereumSignTxEIP1559.prototype.max_priority_fee = $util.newBuffer([]);
    EthereumSignTxEIP1559.prototype.gas_limit = $util.newBuffer([]);
    EthereumSignTxEIP1559.prototype.to = "";
    EthereumSignTxEIP1559.prototype.value = $util.newBuffer([]);
    EthereumSignTxEIP1559.prototype.data_initial_chunk = $util.newBuffer([]);
    EthereumSignTxEIP1559.prototype.data_length = 0;
    EthereumSignTxEIP1559.prototype.chain_id = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    EthereumSignTxEIP1559.prototype.access_list = $util.emptyArray;
    EthereumSignTxEIP1559.prototype.definitions = null;

    EthereumSignTxEIP1559.create = function create(properties) {
        return new EthereumSignTxEIP1559(properties);
    };

    EthereumSignTxEIP1559.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).bytes(message.nonce);
        writer.uint32(26).bytes(message.max_gas_fee);
        writer.uint32(34).bytes(message.max_priority_fee);
        writer.uint32(42).bytes(message.gas_limit);
        if (message.to != null && Object.hasOwnProperty.call(message, "to"))
            writer.uint32(50).string(message.to);
        writer.uint32(58).bytes(message.value);
        if (message.data_initial_chunk != null && Object.hasOwnProperty.call(message, "data_initial_chunk"))
            writer.uint32(66).bytes(message.data_initial_chunk);
        writer.uint32(72).uint32(message.data_length);
        writer.uint32(80).uint64(message.chain_id);
        if (message.access_list != null && message.access_list.length)
            for (var i = 0; i < message.access_list.length; ++i)
                $root.EthereumSignTxEIP1559.EthereumAccessList.encode(message.access_list[i], writer.uint32(90).fork()).ldelim();
        if (message.definitions != null && Object.hasOwnProperty.call(message, "definitions"))
            $root.EthereumDefinitions.encode(message.definitions, writer.uint32(98).fork()).ldelim();
        return writer;
    };

    EthereumSignTxEIP1559.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumSignTxEIP1559.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumSignTxEIP1559();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.nonce = reader.bytes();
                break;
            case 3:
                message.max_gas_fee = reader.bytes();
                break;
            case 4:
                message.max_priority_fee = reader.bytes();
                break;
            case 5:
                message.gas_limit = reader.bytes();
                break;
            case 6:
                message.to = reader.string();
                break;
            case 7:
                message.value = reader.bytes();
                break;
            case 8:
                message.data_initial_chunk = reader.bytes();
                break;
            case 9:
                message.data_length = reader.uint32();
                break;
            case 10:
                message.chain_id = reader.uint64();
                break;
            case 11:
                if (!(message.access_list && message.access_list.length))
                    message.access_list = [];
                message.access_list.push($root.EthereumSignTxEIP1559.EthereumAccessList.decode(reader, reader.uint32()));
                break;
            case 12:
                message.definitions = $root.EthereumDefinitions.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("nonce"))
            throw $util.ProtocolError("missing required 'nonce'", { instance: message });
        if (!message.hasOwnProperty("max_gas_fee"))
            throw $util.ProtocolError("missing required 'max_gas_fee'", { instance: message });
        if (!message.hasOwnProperty("max_priority_fee"))
            throw $util.ProtocolError("missing required 'max_priority_fee'", { instance: message });
        if (!message.hasOwnProperty("gas_limit"))
            throw $util.ProtocolError("missing required 'gas_limit'", { instance: message });
        if (!message.hasOwnProperty("value"))
            throw $util.ProtocolError("missing required 'value'", { instance: message });
        if (!message.hasOwnProperty("data_length"))
            throw $util.ProtocolError("missing required 'data_length'", { instance: message });
        if (!message.hasOwnProperty("chain_id"))
            throw $util.ProtocolError("missing required 'chain_id'", { instance: message });
        return message;
    };

    EthereumSignTxEIP1559.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumSignTxEIP1559.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!(message.nonce && typeof message.nonce.length === "number" || $util.isString(message.nonce)))
            return "nonce: buffer expected";
        if (!(message.max_gas_fee && typeof message.max_gas_fee.length === "number" || $util.isString(message.max_gas_fee)))
            return "max_gas_fee: buffer expected";
        if (!(message.max_priority_fee && typeof message.max_priority_fee.length === "number" || $util.isString(message.max_priority_fee)))
            return "max_priority_fee: buffer expected";
        if (!(message.gas_limit && typeof message.gas_limit.length === "number" || $util.isString(message.gas_limit)))
            return "gas_limit: buffer expected";
        if (message.to != null && message.hasOwnProperty("to"))
            if (!$util.isString(message.to))
                return "to: string expected";
        if (!(message.value && typeof message.value.length === "number" || $util.isString(message.value)))
            return "value: buffer expected";
        if (message.data_initial_chunk != null && message.hasOwnProperty("data_initial_chunk"))
            if (!(message.data_initial_chunk && typeof message.data_initial_chunk.length === "number" || $util.isString(message.data_initial_chunk)))
                return "data_initial_chunk: buffer expected";
        if (!$util.isInteger(message.data_length))
            return "data_length: integer expected";
        if (!$util.isInteger(message.chain_id) && !(message.chain_id && $util.isInteger(message.chain_id.low) && $util.isInteger(message.chain_id.high)))
            return "chain_id: integer|Long expected";
        if (message.access_list != null && message.hasOwnProperty("access_list")) {
            if (!Array.isArray(message.access_list))
                return "access_list: array expected";
            for (var i = 0; i < message.access_list.length; ++i) {
                var error = $root.EthereumSignTxEIP1559.EthereumAccessList.verify(message.access_list[i]);
                if (error)
                    return "access_list." + error;
            }
        }
        if (message.definitions != null && message.hasOwnProperty("definitions")) {
            var error = $root.EthereumDefinitions.verify(message.definitions);
            if (error)
                return "definitions." + error;
        }
        return null;
    };

    EthereumSignTxEIP1559.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumSignTxEIP1559)
            return object;
        var message = new $root.EthereumSignTxEIP1559();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".EthereumSignTxEIP1559.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.nonce != null)
            if (typeof object.nonce === "string")
                $util.base64.decode(object.nonce, message.nonce = $util.newBuffer($util.base64.length(object.nonce)), 0);
            else if (object.nonce.length)
                message.nonce = object.nonce;
        if (object.max_gas_fee != null)
            if (typeof object.max_gas_fee === "string")
                $util.base64.decode(object.max_gas_fee, message.max_gas_fee = $util.newBuffer($util.base64.length(object.max_gas_fee)), 0);
            else if (object.max_gas_fee.length)
                message.max_gas_fee = object.max_gas_fee;
        if (object.max_priority_fee != null)
            if (typeof object.max_priority_fee === "string")
                $util.base64.decode(object.max_priority_fee, message.max_priority_fee = $util.newBuffer($util.base64.length(object.max_priority_fee)), 0);
            else if (object.max_priority_fee.length)
                message.max_priority_fee = object.max_priority_fee;
        if (object.gas_limit != null)
            if (typeof object.gas_limit === "string")
                $util.base64.decode(object.gas_limit, message.gas_limit = $util.newBuffer($util.base64.length(object.gas_limit)), 0);
            else if (object.gas_limit.length)
                message.gas_limit = object.gas_limit;
        if (object.to != null)
            message.to = String(object.to);
        if (object.value != null)
            if (typeof object.value === "string")
                $util.base64.decode(object.value, message.value = $util.newBuffer($util.base64.length(object.value)), 0);
            else if (object.value.length)
                message.value = object.value;
        if (object.data_initial_chunk != null)
            if (typeof object.data_initial_chunk === "string")
                $util.base64.decode(object.data_initial_chunk, message.data_initial_chunk = $util.newBuffer($util.base64.length(object.data_initial_chunk)), 0);
            else if (object.data_initial_chunk.length)
                message.data_initial_chunk = object.data_initial_chunk;
        if (object.data_length != null)
            message.data_length = object.data_length >>> 0;
        if (object.chain_id != null)
            if ($util.Long)
                (message.chain_id = $util.Long.fromValue(object.chain_id)).unsigned = true;
            else if (typeof object.chain_id === "string")
                message.chain_id = parseInt(object.chain_id, 10);
            else if (typeof object.chain_id === "number")
                message.chain_id = object.chain_id;
            else if (typeof object.chain_id === "object")
                message.chain_id = new $util.LongBits(object.chain_id.low >>> 0, object.chain_id.high >>> 0).toNumber(true);
        if (object.access_list) {
            if (!Array.isArray(object.access_list))
                throw TypeError(".EthereumSignTxEIP1559.access_list: array expected");
            message.access_list = [];
            for (var i = 0; i < object.access_list.length; ++i) {
                if (typeof object.access_list[i] !== "object")
                    throw TypeError(".EthereumSignTxEIP1559.access_list: object expected");
                message.access_list[i] = $root.EthereumSignTxEIP1559.EthereumAccessList.fromObject(object.access_list[i]);
            }
        }
        if (object.definitions != null) {
            if (typeof object.definitions !== "object")
                throw TypeError(".EthereumSignTxEIP1559.definitions: object expected");
            message.definitions = $root.EthereumDefinitions.fromObject(object.definitions);
        }
        return message;
    };

    EthereumSignTxEIP1559.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults) {
            object.address_n = [];
            object.access_list = [];
        }
        if (options.defaults) {
            if (options.bytes === String)
                object.nonce = "";
            else {
                object.nonce = [];
                if (options.bytes !== Array)
                    object.nonce = $util.newBuffer(object.nonce);
            }
            if (options.bytes === String)
                object.max_gas_fee = "";
            else {
                object.max_gas_fee = [];
                if (options.bytes !== Array)
                    object.max_gas_fee = $util.newBuffer(object.max_gas_fee);
            }
            if (options.bytes === String)
                object.max_priority_fee = "";
            else {
                object.max_priority_fee = [];
                if (options.bytes !== Array)
                    object.max_priority_fee = $util.newBuffer(object.max_priority_fee);
            }
            if (options.bytes === String)
                object.gas_limit = "";
            else {
                object.gas_limit = [];
                if (options.bytes !== Array)
                    object.gas_limit = $util.newBuffer(object.gas_limit);
            }
            object.to = "";
            if (options.bytes === String)
                object.value = "";
            else {
                object.value = [];
                if (options.bytes !== Array)
                    object.value = $util.newBuffer(object.value);
            }
            if (options.bytes === String)
                object.data_initial_chunk = "";
            else {
                object.data_initial_chunk = [];
                if (options.bytes !== Array)
                    object.data_initial_chunk = $util.newBuffer(object.data_initial_chunk);
            }
            object.data_length = 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.chain_id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.chain_id = options.longs === String ? "0" : 0;
            object.definitions = null;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.nonce != null && message.hasOwnProperty("nonce"))
            object.nonce = options.bytes === String ? $util.base64.encode(message.nonce, 0, message.nonce.length) : options.bytes === Array ? Array.prototype.slice.call(message.nonce) : message.nonce;
        if (message.max_gas_fee != null && message.hasOwnProperty("max_gas_fee"))
            object.max_gas_fee = options.bytes === String ? $util.base64.encode(message.max_gas_fee, 0, message.max_gas_fee.length) : options.bytes === Array ? Array.prototype.slice.call(message.max_gas_fee) : message.max_gas_fee;
        if (message.max_priority_fee != null && message.hasOwnProperty("max_priority_fee"))
            object.max_priority_fee = options.bytes === String ? $util.base64.encode(message.max_priority_fee, 0, message.max_priority_fee.length) : options.bytes === Array ? Array.prototype.slice.call(message.max_priority_fee) : message.max_priority_fee;
        if (message.gas_limit != null && message.hasOwnProperty("gas_limit"))
            object.gas_limit = options.bytes === String ? $util.base64.encode(message.gas_limit, 0, message.gas_limit.length) : options.bytes === Array ? Array.prototype.slice.call(message.gas_limit) : message.gas_limit;
        if (message.to != null && message.hasOwnProperty("to"))
            object.to = message.to;
        if (message.value != null && message.hasOwnProperty("value"))
            object.value = options.bytes === String ? $util.base64.encode(message.value, 0, message.value.length) : options.bytes === Array ? Array.prototype.slice.call(message.value) : message.value;
        if (message.data_initial_chunk != null && message.hasOwnProperty("data_initial_chunk"))
            object.data_initial_chunk = options.bytes === String ? $util.base64.encode(message.data_initial_chunk, 0, message.data_initial_chunk.length) : options.bytes === Array ? Array.prototype.slice.call(message.data_initial_chunk) : message.data_initial_chunk;
        if (message.data_length != null && message.hasOwnProperty("data_length"))
            object.data_length = message.data_length;
        if (message.chain_id != null && message.hasOwnProperty("chain_id"))
            if (typeof message.chain_id === "number")
                object.chain_id = options.longs === String ? String(message.chain_id) : message.chain_id;
            else
                object.chain_id = options.longs === String ? $util.Long.prototype.toString.call(message.chain_id) : options.longs === Number ? new $util.LongBits(message.chain_id.low >>> 0, message.chain_id.high >>> 0).toNumber(true) : message.chain_id;
        if (message.access_list && message.access_list.length) {
            object.access_list = [];
            for (var j = 0; j < message.access_list.length; ++j)
                object.access_list[j] = $root.EthereumSignTxEIP1559.EthereumAccessList.toObject(message.access_list[j], options);
        }
        if (message.definitions != null && message.hasOwnProperty("definitions"))
            object.definitions = $root.EthereumDefinitions.toObject(message.definitions, options);
        return object;
    };

    EthereumSignTxEIP1559.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    EthereumSignTxEIP1559.EthereumAccessList = (function() {

        function EthereumAccessList(properties) {
            this.storage_keys = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        EthereumAccessList.prototype.address = "";
        EthereumAccessList.prototype.storage_keys = $util.emptyArray;

        EthereumAccessList.create = function create(properties) {
            return new EthereumAccessList(properties);
        };

        EthereumAccessList.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(10).string(message.address);
            if (message.storage_keys != null && message.storage_keys.length)
                for (var i = 0; i < message.storage_keys.length; ++i)
                    writer.uint32(18).bytes(message.storage_keys[i]);
            return writer;
        };

        EthereumAccessList.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        EthereumAccessList.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumSignTxEIP1559.EthereumAccessList();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    if (!(message.storage_keys && message.storage_keys.length))
                        message.storage_keys = [];
                    message.storage_keys.push(reader.bytes());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("address"))
                throw $util.ProtocolError("missing required 'address'", { instance: message });
            return message;
        };

        EthereumAccessList.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        EthereumAccessList.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isString(message.address))
                return "address: string expected";
            if (message.storage_keys != null && message.hasOwnProperty("storage_keys")) {
                if (!Array.isArray(message.storage_keys))
                    return "storage_keys: array expected";
                for (var i = 0; i < message.storage_keys.length; ++i)
                    if (!(message.storage_keys[i] && typeof message.storage_keys[i].length === "number" || $util.isString(message.storage_keys[i])))
                        return "storage_keys: buffer[] expected";
            }
            return null;
        };

        EthereumAccessList.fromObject = function fromObject(object) {
            if (object instanceof $root.EthereumSignTxEIP1559.EthereumAccessList)
                return object;
            var message = new $root.EthereumSignTxEIP1559.EthereumAccessList();
            if (object.address != null)
                message.address = String(object.address);
            if (object.storage_keys) {
                if (!Array.isArray(object.storage_keys))
                    throw TypeError(".EthereumSignTxEIP1559.EthereumAccessList.storage_keys: array expected");
                message.storage_keys = [];
                for (var i = 0; i < object.storage_keys.length; ++i)
                    if (typeof object.storage_keys[i] === "string")
                        $util.base64.decode(object.storage_keys[i], message.storage_keys[i] = $util.newBuffer($util.base64.length(object.storage_keys[i])), 0);
                    else if (object.storage_keys[i].length)
                        message.storage_keys[i] = object.storage_keys[i];
            }
            return message;
        };

        EthereumAccessList.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.storage_keys = [];
            if (options.defaults)
                object.address = "";
            if (message.address != null && message.hasOwnProperty("address"))
                object.address = message.address;
            if (message.storage_keys && message.storage_keys.length) {
                object.storage_keys = [];
                for (var j = 0; j < message.storage_keys.length; ++j)
                    object.storage_keys[j] = options.bytes === String ? $util.base64.encode(message.storage_keys[j], 0, message.storage_keys[j].length) : options.bytes === Array ? Array.prototype.slice.call(message.storage_keys[j]) : message.storage_keys[j];
            }
            return object;
        };

        EthereumAccessList.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EthereumAccessList;
    })();

    return EthereumSignTxEIP1559;
})();

$root.EthereumTxRequest = (function() {

    function EthereumTxRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumTxRequest.prototype.data_length = 0;
    EthereumTxRequest.prototype.signature_v = 0;
    EthereumTxRequest.prototype.signature_r = $util.newBuffer([]);
    EthereumTxRequest.prototype.signature_s = $util.newBuffer([]);

    EthereumTxRequest.create = function create(properties) {
        return new EthereumTxRequest(properties);
    };

    EthereumTxRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.data_length != null && Object.hasOwnProperty.call(message, "data_length"))
            writer.uint32(8).uint32(message.data_length);
        if (message.signature_v != null && Object.hasOwnProperty.call(message, "signature_v"))
            writer.uint32(16).uint32(message.signature_v);
        if (message.signature_r != null && Object.hasOwnProperty.call(message, "signature_r"))
            writer.uint32(26).bytes(message.signature_r);
        if (message.signature_s != null && Object.hasOwnProperty.call(message, "signature_s"))
            writer.uint32(34).bytes(message.signature_s);
        return writer;
    };

    EthereumTxRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumTxRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumTxRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.data_length = reader.uint32();
                break;
            case 2:
                message.signature_v = reader.uint32();
                break;
            case 3:
                message.signature_r = reader.bytes();
                break;
            case 4:
                message.signature_s = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    EthereumTxRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumTxRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.data_length != null && message.hasOwnProperty("data_length"))
            if (!$util.isInteger(message.data_length))
                return "data_length: integer expected";
        if (message.signature_v != null && message.hasOwnProperty("signature_v"))
            if (!$util.isInteger(message.signature_v))
                return "signature_v: integer expected";
        if (message.signature_r != null && message.hasOwnProperty("signature_r"))
            if (!(message.signature_r && typeof message.signature_r.length === "number" || $util.isString(message.signature_r)))
                return "signature_r: buffer expected";
        if (message.signature_s != null && message.hasOwnProperty("signature_s"))
            if (!(message.signature_s && typeof message.signature_s.length === "number" || $util.isString(message.signature_s)))
                return "signature_s: buffer expected";
        return null;
    };

    EthereumTxRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumTxRequest)
            return object;
        var message = new $root.EthereumTxRequest();
        if (object.data_length != null)
            message.data_length = object.data_length >>> 0;
        if (object.signature_v != null)
            message.signature_v = object.signature_v >>> 0;
        if (object.signature_r != null)
            if (typeof object.signature_r === "string")
                $util.base64.decode(object.signature_r, message.signature_r = $util.newBuffer($util.base64.length(object.signature_r)), 0);
            else if (object.signature_r.length)
                message.signature_r = object.signature_r;
        if (object.signature_s != null)
            if (typeof object.signature_s === "string")
                $util.base64.decode(object.signature_s, message.signature_s = $util.newBuffer($util.base64.length(object.signature_s)), 0);
            else if (object.signature_s.length)
                message.signature_s = object.signature_s;
        return message;
    };

    EthereumTxRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.data_length = 0;
            object.signature_v = 0;
            if (options.bytes === String)
                object.signature_r = "";
            else {
                object.signature_r = [];
                if (options.bytes !== Array)
                    object.signature_r = $util.newBuffer(object.signature_r);
            }
            if (options.bytes === String)
                object.signature_s = "";
            else {
                object.signature_s = [];
                if (options.bytes !== Array)
                    object.signature_s = $util.newBuffer(object.signature_s);
            }
        }
        if (message.data_length != null && message.hasOwnProperty("data_length"))
            object.data_length = message.data_length;
        if (message.signature_v != null && message.hasOwnProperty("signature_v"))
            object.signature_v = message.signature_v;
        if (message.signature_r != null && message.hasOwnProperty("signature_r"))
            object.signature_r = options.bytes === String ? $util.base64.encode(message.signature_r, 0, message.signature_r.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature_r) : message.signature_r;
        if (message.signature_s != null && message.hasOwnProperty("signature_s"))
            object.signature_s = options.bytes === String ? $util.base64.encode(message.signature_s, 0, message.signature_s.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature_s) : message.signature_s;
        return object;
    };

    EthereumTxRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumTxRequest;
})();

$root.EthereumTxAck = (function() {

    function EthereumTxAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumTxAck.prototype.data_chunk = $util.newBuffer([]);

    EthereumTxAck.create = function create(properties) {
        return new EthereumTxAck(properties);
    };

    EthereumTxAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.data_chunk);
        return writer;
    };

    EthereumTxAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumTxAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumTxAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.data_chunk = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("data_chunk"))
            throw $util.ProtocolError("missing required 'data_chunk'", { instance: message });
        return message;
    };

    EthereumTxAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumTxAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.data_chunk && typeof message.data_chunk.length === "number" || $util.isString(message.data_chunk)))
            return "data_chunk: buffer expected";
        return null;
    };

    EthereumTxAck.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumTxAck)
            return object;
        var message = new $root.EthereumTxAck();
        if (object.data_chunk != null)
            if (typeof object.data_chunk === "string")
                $util.base64.decode(object.data_chunk, message.data_chunk = $util.newBuffer($util.base64.length(object.data_chunk)), 0);
            else if (object.data_chunk.length)
                message.data_chunk = object.data_chunk;
        return message;
    };

    EthereumTxAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.data_chunk = "";
            else {
                object.data_chunk = [];
                if (options.bytes !== Array)
                    object.data_chunk = $util.newBuffer(object.data_chunk);
            }
        if (message.data_chunk != null && message.hasOwnProperty("data_chunk"))
            object.data_chunk = options.bytes === String ? $util.base64.encode(message.data_chunk, 0, message.data_chunk.length) : options.bytes === Array ? Array.prototype.slice.call(message.data_chunk) : message.data_chunk;
        return object;
    };

    EthereumTxAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumTxAck;
})();

$root.EthereumSignMessage = (function() {

    function EthereumSignMessage(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumSignMessage.prototype.address_n = $util.emptyArray;
    EthereumSignMessage.prototype.message = $util.newBuffer([]);
    EthereumSignMessage.prototype.encoded_network = $util.newBuffer([]);

    EthereumSignMessage.create = function create(properties) {
        return new EthereumSignMessage(properties);
    };

    EthereumSignMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).bytes(message.message);
        if (message.encoded_network != null && Object.hasOwnProperty.call(message, "encoded_network"))
            writer.uint32(26).bytes(message.encoded_network);
        return writer;
    };

    EthereumSignMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumSignMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumSignMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.message = reader.bytes();
                break;
            case 3:
                message.encoded_network = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("message"))
            throw $util.ProtocolError("missing required 'message'", { instance: message });
        return message;
    };

    EthereumSignMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumSignMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!(message.message && typeof message.message.length === "number" || $util.isString(message.message)))
            return "message: buffer expected";
        if (message.encoded_network != null && message.hasOwnProperty("encoded_network"))
            if (!(message.encoded_network && typeof message.encoded_network.length === "number" || $util.isString(message.encoded_network)))
                return "encoded_network: buffer expected";
        return null;
    };

    EthereumSignMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumSignMessage)
            return object;
        var message = new $root.EthereumSignMessage();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".EthereumSignMessage.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.message != null)
            if (typeof object.message === "string")
                $util.base64.decode(object.message, message.message = $util.newBuffer($util.base64.length(object.message)), 0);
            else if (object.message.length)
                message.message = object.message;
        if (object.encoded_network != null)
            if (typeof object.encoded_network === "string")
                $util.base64.decode(object.encoded_network, message.encoded_network = $util.newBuffer($util.base64.length(object.encoded_network)), 0);
            else if (object.encoded_network.length)
                message.encoded_network = object.encoded_network;
        return message;
    };

    EthereumSignMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            if (options.bytes === String)
                object.message = "";
            else {
                object.message = [];
                if (options.bytes !== Array)
                    object.message = $util.newBuffer(object.message);
            }
            if (options.bytes === String)
                object.encoded_network = "";
            else {
                object.encoded_network = [];
                if (options.bytes !== Array)
                    object.encoded_network = $util.newBuffer(object.encoded_network);
            }
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.message != null && message.hasOwnProperty("message"))
            object.message = options.bytes === String ? $util.base64.encode(message.message, 0, message.message.length) : options.bytes === Array ? Array.prototype.slice.call(message.message) : message.message;
        if (message.encoded_network != null && message.hasOwnProperty("encoded_network"))
            object.encoded_network = options.bytes === String ? $util.base64.encode(message.encoded_network, 0, message.encoded_network.length) : options.bytes === Array ? Array.prototype.slice.call(message.encoded_network) : message.encoded_network;
        return object;
    };

    EthereumSignMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumSignMessage;
})();

$root.EthereumMessageSignature = (function() {

    function EthereumMessageSignature(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumMessageSignature.prototype.signature = $util.newBuffer([]);
    EthereumMessageSignature.prototype.address = "";

    EthereumMessageSignature.create = function create(properties) {
        return new EthereumMessageSignature(properties);
    };

    EthereumMessageSignature.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(18).bytes(message.signature);
        writer.uint32(26).string(message.address);
        return writer;
    };

    EthereumMessageSignature.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumMessageSignature.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumMessageSignature();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 2:
                message.signature = reader.bytes();
                break;
            case 3:
                message.address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        if (!message.hasOwnProperty("address"))
            throw $util.ProtocolError("missing required 'address'", { instance: message });
        return message;
    };

    EthereumMessageSignature.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumMessageSignature.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        if (!$util.isString(message.address))
            return "address: string expected";
        return null;
    };

    EthereumMessageSignature.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumMessageSignature)
            return object;
        var message = new $root.EthereumMessageSignature();
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        if (object.address != null)
            message.address = String(object.address);
        return message;
    };

    EthereumMessageSignature.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
            object.address = "";
        }
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    EthereumMessageSignature.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumMessageSignature;
})();

$root.EthereumVerifyMessage = (function() {

    function EthereumVerifyMessage(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumVerifyMessage.prototype.signature = $util.newBuffer([]);
    EthereumVerifyMessage.prototype.message = $util.newBuffer([]);
    EthereumVerifyMessage.prototype.address = "";

    EthereumVerifyMessage.create = function create(properties) {
        return new EthereumVerifyMessage(properties);
    };

    EthereumVerifyMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(18).bytes(message.signature);
        writer.uint32(26).bytes(message.message);
        writer.uint32(34).string(message.address);
        return writer;
    };

    EthereumVerifyMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumVerifyMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumVerifyMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 2:
                message.signature = reader.bytes();
                break;
            case 3:
                message.message = reader.bytes();
                break;
            case 4:
                message.address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        if (!message.hasOwnProperty("message"))
            throw $util.ProtocolError("missing required 'message'", { instance: message });
        if (!message.hasOwnProperty("address"))
            throw $util.ProtocolError("missing required 'address'", { instance: message });
        return message;
    };

    EthereumVerifyMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumVerifyMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        if (!(message.message && typeof message.message.length === "number" || $util.isString(message.message)))
            return "message: buffer expected";
        if (!$util.isString(message.address))
            return "address: string expected";
        return null;
    };

    EthereumVerifyMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumVerifyMessage)
            return object;
        var message = new $root.EthereumVerifyMessage();
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        if (object.message != null)
            if (typeof object.message === "string")
                $util.base64.decode(object.message, message.message = $util.newBuffer($util.base64.length(object.message)), 0);
            else if (object.message.length)
                message.message = object.message;
        if (object.address != null)
            message.address = String(object.address);
        return message;
    };

    EthereumVerifyMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
            if (options.bytes === String)
                object.message = "";
            else {
                object.message = [];
                if (options.bytes !== Array)
                    object.message = $util.newBuffer(object.message);
            }
            object.address = "";
        }
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        if (message.message != null && message.hasOwnProperty("message"))
            object.message = options.bytes === String ? $util.base64.encode(message.message, 0, message.message.length) : options.bytes === Array ? Array.prototype.slice.call(message.message) : message.message;
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    EthereumVerifyMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumVerifyMessage;
})();

$root.EthereumSignTypedHash = (function() {

    function EthereumSignTypedHash(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumSignTypedHash.prototype.address_n = $util.emptyArray;
    EthereumSignTypedHash.prototype.domain_separator_hash = $util.newBuffer([]);
    EthereumSignTypedHash.prototype.message_hash = $util.newBuffer([]);
    EthereumSignTypedHash.prototype.encoded_network = $util.newBuffer([]);

    EthereumSignTypedHash.create = function create(properties) {
        return new EthereumSignTypedHash(properties);
    };

    EthereumSignTypedHash.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).bytes(message.domain_separator_hash);
        if (message.message_hash != null && Object.hasOwnProperty.call(message, "message_hash"))
            writer.uint32(26).bytes(message.message_hash);
        if (message.encoded_network != null && Object.hasOwnProperty.call(message, "encoded_network"))
            writer.uint32(34).bytes(message.encoded_network);
        return writer;
    };

    EthereumSignTypedHash.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumSignTypedHash.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumSignTypedHash();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.domain_separator_hash = reader.bytes();
                break;
            case 3:
                message.message_hash = reader.bytes();
                break;
            case 4:
                message.encoded_network = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("domain_separator_hash"))
            throw $util.ProtocolError("missing required 'domain_separator_hash'", { instance: message });
        return message;
    };

    EthereumSignTypedHash.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumSignTypedHash.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!(message.domain_separator_hash && typeof message.domain_separator_hash.length === "number" || $util.isString(message.domain_separator_hash)))
            return "domain_separator_hash: buffer expected";
        if (message.message_hash != null && message.hasOwnProperty("message_hash"))
            if (!(message.message_hash && typeof message.message_hash.length === "number" || $util.isString(message.message_hash)))
                return "message_hash: buffer expected";
        if (message.encoded_network != null && message.hasOwnProperty("encoded_network"))
            if (!(message.encoded_network && typeof message.encoded_network.length === "number" || $util.isString(message.encoded_network)))
                return "encoded_network: buffer expected";
        return null;
    };

    EthereumSignTypedHash.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumSignTypedHash)
            return object;
        var message = new $root.EthereumSignTypedHash();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".EthereumSignTypedHash.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.domain_separator_hash != null)
            if (typeof object.domain_separator_hash === "string")
                $util.base64.decode(object.domain_separator_hash, message.domain_separator_hash = $util.newBuffer($util.base64.length(object.domain_separator_hash)), 0);
            else if (object.domain_separator_hash.length)
                message.domain_separator_hash = object.domain_separator_hash;
        if (object.message_hash != null)
            if (typeof object.message_hash === "string")
                $util.base64.decode(object.message_hash, message.message_hash = $util.newBuffer($util.base64.length(object.message_hash)), 0);
            else if (object.message_hash.length)
                message.message_hash = object.message_hash;
        if (object.encoded_network != null)
            if (typeof object.encoded_network === "string")
                $util.base64.decode(object.encoded_network, message.encoded_network = $util.newBuffer($util.base64.length(object.encoded_network)), 0);
            else if (object.encoded_network.length)
                message.encoded_network = object.encoded_network;
        return message;
    };

    EthereumSignTypedHash.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            if (options.bytes === String)
                object.domain_separator_hash = "";
            else {
                object.domain_separator_hash = [];
                if (options.bytes !== Array)
                    object.domain_separator_hash = $util.newBuffer(object.domain_separator_hash);
            }
            if (options.bytes === String)
                object.message_hash = "";
            else {
                object.message_hash = [];
                if (options.bytes !== Array)
                    object.message_hash = $util.newBuffer(object.message_hash);
            }
            if (options.bytes === String)
                object.encoded_network = "";
            else {
                object.encoded_network = [];
                if (options.bytes !== Array)
                    object.encoded_network = $util.newBuffer(object.encoded_network);
            }
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.domain_separator_hash != null && message.hasOwnProperty("domain_separator_hash"))
            object.domain_separator_hash = options.bytes === String ? $util.base64.encode(message.domain_separator_hash, 0, message.domain_separator_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.domain_separator_hash) : message.domain_separator_hash;
        if (message.message_hash != null && message.hasOwnProperty("message_hash"))
            object.message_hash = options.bytes === String ? $util.base64.encode(message.message_hash, 0, message.message_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.message_hash) : message.message_hash;
        if (message.encoded_network != null && message.hasOwnProperty("encoded_network"))
            object.encoded_network = options.bytes === String ? $util.base64.encode(message.encoded_network, 0, message.encoded_network.length) : options.bytes === Array ? Array.prototype.slice.call(message.encoded_network) : message.encoded_network;
        return object;
    };

    EthereumSignTypedHash.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumSignTypedHash;
})();

$root.EthereumTypedDataSignature = (function() {

    function EthereumTypedDataSignature(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumTypedDataSignature.prototype.signature = $util.newBuffer([]);
    EthereumTypedDataSignature.prototype.address = "";

    EthereumTypedDataSignature.create = function create(properties) {
        return new EthereumTypedDataSignature(properties);
    };

    EthereumTypedDataSignature.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.signature);
        writer.uint32(18).string(message.address);
        return writer;
    };

    EthereumTypedDataSignature.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumTypedDataSignature.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumTypedDataSignature();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.signature = reader.bytes();
                break;
            case 2:
                message.address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        if (!message.hasOwnProperty("address"))
            throw $util.ProtocolError("missing required 'address'", { instance: message });
        return message;
    };

    EthereumTypedDataSignature.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumTypedDataSignature.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        if (!$util.isString(message.address))
            return "address: string expected";
        return null;
    };

    EthereumTypedDataSignature.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumTypedDataSignature)
            return object;
        var message = new $root.EthereumTypedDataSignature();
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        if (object.address != null)
            message.address = String(object.address);
        return message;
    };

    EthereumTypedDataSignature.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
            object.address = "";
        }
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    EthereumTypedDataSignature.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumTypedDataSignature;
})();

$root.FilecoinGetAddress = (function() {

    function FilecoinGetAddress(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    FilecoinGetAddress.prototype.address_n = $util.emptyArray;
    FilecoinGetAddress.prototype.show_display = false;
    FilecoinGetAddress.prototype.testnet = false;

    FilecoinGetAddress.create = function create(properties) {
        return new FilecoinGetAddress(properties);
    };

    FilecoinGetAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(16).bool(message.show_display);
        if (message.testnet != null && Object.hasOwnProperty.call(message, "testnet"))
            writer.uint32(24).bool(message.testnet);
        return writer;
    };

    FilecoinGetAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    FilecoinGetAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.FilecoinGetAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.show_display = reader.bool();
                break;
            case 3:
                message.testnet = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    FilecoinGetAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    FilecoinGetAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        if (message.testnet != null && message.hasOwnProperty("testnet"))
            if (typeof message.testnet !== "boolean")
                return "testnet: boolean expected";
        return null;
    };

    FilecoinGetAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.FilecoinGetAddress)
            return object;
        var message = new $root.FilecoinGetAddress();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".FilecoinGetAddress.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        if (object.testnet != null)
            message.testnet = Boolean(object.testnet);
        return message;
    };

    FilecoinGetAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            object.show_display = false;
            object.testnet = false;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        if (message.testnet != null && message.hasOwnProperty("testnet"))
            object.testnet = message.testnet;
        return object;
    };

    FilecoinGetAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return FilecoinGetAddress;
})();

$root.FilecoinAddress = (function() {

    function FilecoinAddress(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    FilecoinAddress.prototype.address = "";

    FilecoinAddress.create = function create(properties) {
        return new FilecoinAddress(properties);
    };

    FilecoinAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address != null && Object.hasOwnProperty.call(message, "address"))
            writer.uint32(10).string(message.address);
        return writer;
    };

    FilecoinAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    FilecoinAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.FilecoinAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    FilecoinAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    FilecoinAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address != null && message.hasOwnProperty("address"))
            if (!$util.isString(message.address))
                return "address: string expected";
        return null;
    };

    FilecoinAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.FilecoinAddress)
            return object;
        var message = new $root.FilecoinAddress();
        if (object.address != null)
            message.address = String(object.address);
        return message;
    };

    FilecoinAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.address = "";
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    FilecoinAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return FilecoinAddress;
})();

$root.FilecoinSignTx = (function() {

    function FilecoinSignTx(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    FilecoinSignTx.prototype.address_n = $util.emptyArray;
    FilecoinSignTx.prototype.raw_tx = $util.newBuffer([]);
    FilecoinSignTx.prototype.testnet = false;

    FilecoinSignTx.create = function create(properties) {
        return new FilecoinSignTx(properties);
    };

    FilecoinSignTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).bytes(message.raw_tx);
        if (message.testnet != null && Object.hasOwnProperty.call(message, "testnet"))
            writer.uint32(24).bool(message.testnet);
        return writer;
    };

    FilecoinSignTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    FilecoinSignTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.FilecoinSignTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.raw_tx = reader.bytes();
                break;
            case 3:
                message.testnet = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("raw_tx"))
            throw $util.ProtocolError("missing required 'raw_tx'", { instance: message });
        return message;
    };

    FilecoinSignTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    FilecoinSignTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!(message.raw_tx && typeof message.raw_tx.length === "number" || $util.isString(message.raw_tx)))
            return "raw_tx: buffer expected";
        if (message.testnet != null && message.hasOwnProperty("testnet"))
            if (typeof message.testnet !== "boolean")
                return "testnet: boolean expected";
        return null;
    };

    FilecoinSignTx.fromObject = function fromObject(object) {
        if (object instanceof $root.FilecoinSignTx)
            return object;
        var message = new $root.FilecoinSignTx();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".FilecoinSignTx.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.raw_tx != null)
            if (typeof object.raw_tx === "string")
                $util.base64.decode(object.raw_tx, message.raw_tx = $util.newBuffer($util.base64.length(object.raw_tx)), 0);
            else if (object.raw_tx.length)
                message.raw_tx = object.raw_tx;
        if (object.testnet != null)
            message.testnet = Boolean(object.testnet);
        return message;
    };

    FilecoinSignTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            if (options.bytes === String)
                object.raw_tx = "";
            else {
                object.raw_tx = [];
                if (options.bytes !== Array)
                    object.raw_tx = $util.newBuffer(object.raw_tx);
            }
            object.testnet = false;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.raw_tx != null && message.hasOwnProperty("raw_tx"))
            object.raw_tx = options.bytes === String ? $util.base64.encode(message.raw_tx, 0, message.raw_tx.length) : options.bytes === Array ? Array.prototype.slice.call(message.raw_tx) : message.raw_tx;
        if (message.testnet != null && message.hasOwnProperty("testnet"))
            object.testnet = message.testnet;
        return object;
    };

    FilecoinSignTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return FilecoinSignTx;
})();

$root.FilecoinSignedTx = (function() {

    function FilecoinSignedTx(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    FilecoinSignedTx.prototype.signature = $util.newBuffer([]);

    FilecoinSignedTx.create = function create(properties) {
        return new FilecoinSignedTx(properties);
    };

    FilecoinSignedTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.signature);
        return writer;
    };

    FilecoinSignedTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    FilecoinSignedTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.FilecoinSignedTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.signature = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        return message;
    };

    FilecoinSignedTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    FilecoinSignedTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        return null;
    };

    FilecoinSignedTx.fromObject = function fromObject(object) {
        if (object instanceof $root.FilecoinSignedTx)
            return object;
        var message = new $root.FilecoinSignedTx();
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        return message;
    };

    FilecoinSignedTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        return object;
    };

    FilecoinSignedTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return FilecoinSignedTx;
})();

$root.KaspaGetAddress = (function() {

    function KaspaGetAddress(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    KaspaGetAddress.prototype.address_n = $util.emptyArray;
    KaspaGetAddress.prototype.show_display = false;
    KaspaGetAddress.prototype.prefix = "kaspa";
    KaspaGetAddress.prototype.scheme = "schnorr";
    KaspaGetAddress.prototype.use_tweak = true;

    KaspaGetAddress.create = function create(properties) {
        return new KaspaGetAddress(properties);
    };

    KaspaGetAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(16).bool(message.show_display);
        if (message.prefix != null && Object.hasOwnProperty.call(message, "prefix"))
            writer.uint32(26).string(message.prefix);
        if (message.scheme != null && Object.hasOwnProperty.call(message, "scheme"))
            writer.uint32(34).string(message.scheme);
        if (message.use_tweak != null && Object.hasOwnProperty.call(message, "use_tweak"))
            writer.uint32(40).bool(message.use_tweak);
        return writer;
    };

    KaspaGetAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    KaspaGetAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.KaspaGetAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.show_display = reader.bool();
                break;
            case 3:
                message.prefix = reader.string();
                break;
            case 4:
                message.scheme = reader.string();
                break;
            case 5:
                message.use_tweak = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    KaspaGetAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    KaspaGetAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        if (message.prefix != null && message.hasOwnProperty("prefix"))
            if (!$util.isString(message.prefix))
                return "prefix: string expected";
        if (message.scheme != null && message.hasOwnProperty("scheme"))
            if (!$util.isString(message.scheme))
                return "scheme: string expected";
        if (message.use_tweak != null && message.hasOwnProperty("use_tweak"))
            if (typeof message.use_tweak !== "boolean")
                return "use_tweak: boolean expected";
        return null;
    };

    KaspaGetAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.KaspaGetAddress)
            return object;
        var message = new $root.KaspaGetAddress();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".KaspaGetAddress.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        if (object.prefix != null)
            message.prefix = String(object.prefix);
        if (object.scheme != null)
            message.scheme = String(object.scheme);
        if (object.use_tweak != null)
            message.use_tweak = Boolean(object.use_tweak);
        return message;
    };

    KaspaGetAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            object.show_display = false;
            object.prefix = "kaspa";
            object.scheme = "schnorr";
            object.use_tweak = true;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        if (message.prefix != null && message.hasOwnProperty("prefix"))
            object.prefix = message.prefix;
        if (message.scheme != null && message.hasOwnProperty("scheme"))
            object.scheme = message.scheme;
        if (message.use_tweak != null && message.hasOwnProperty("use_tweak"))
            object.use_tweak = message.use_tweak;
        return object;
    };

    KaspaGetAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return KaspaGetAddress;
})();

$root.KaspaAddress = (function() {

    function KaspaAddress(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    KaspaAddress.prototype.address = "";

    KaspaAddress.create = function create(properties) {
        return new KaspaAddress(properties);
    };

    KaspaAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.address);
        return writer;
    };

    KaspaAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    KaspaAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.KaspaAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("address"))
            throw $util.ProtocolError("missing required 'address'", { instance: message });
        return message;
    };

    KaspaAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    KaspaAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.address))
            return "address: string expected";
        return null;
    };

    KaspaAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.KaspaAddress)
            return object;
        var message = new $root.KaspaAddress();
        if (object.address != null)
            message.address = String(object.address);
        return message;
    };

    KaspaAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.address = "";
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    KaspaAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return KaspaAddress;
})();

$root.KaspaSignTx = (function() {

    function KaspaSignTx(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    KaspaSignTx.prototype.address_n = $util.emptyArray;
    KaspaSignTx.prototype.raw_message = $util.newBuffer([]);
    KaspaSignTx.prototype.scheme = "schnorr";
    KaspaSignTx.prototype.prefix = "kaspa";
    KaspaSignTx.prototype.input_count = 1;
    KaspaSignTx.prototype.use_tweak = true;
    KaspaSignTx.prototype.output_count = 0;
    KaspaSignTx.prototype.version = 0;
    KaspaSignTx.prototype.lock_time = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    KaspaSignTx.prototype.subnetwork_id = $util.newBuffer([]);
    KaspaSignTx.prototype.gas = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    KaspaSignTx.prototype.payload_length = 0;

    KaspaSignTx.create = function create(properties) {
        return new KaspaSignTx(properties);
    };

    KaspaSignTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.raw_message != null && Object.hasOwnProperty.call(message, "raw_message"))
            writer.uint32(18).bytes(message.raw_message);
        if (message.scheme != null && Object.hasOwnProperty.call(message, "scheme"))
            writer.uint32(26).string(message.scheme);
        if (message.prefix != null && Object.hasOwnProperty.call(message, "prefix"))
            writer.uint32(34).string(message.prefix);
        if (message.input_count != null && Object.hasOwnProperty.call(message, "input_count"))
            writer.uint32(40).uint32(message.input_count);
        if (message.use_tweak != null && Object.hasOwnProperty.call(message, "use_tweak"))
            writer.uint32(48).bool(message.use_tweak);
        if (message.output_count != null && Object.hasOwnProperty.call(message, "output_count"))
            writer.uint32(56).uint32(message.output_count);
        if (message.version != null && Object.hasOwnProperty.call(message, "version"))
            writer.uint32(64).uint32(message.version);
        if (message.lock_time != null && Object.hasOwnProperty.call(message, "lock_time"))
            writer.uint32(72).uint64(message.lock_time);
        if (message.subnetwork_id != null && Object.hasOwnProperty.call(message, "subnetwork_id"))
            writer.uint32(82).bytes(message.subnetwork_id);
        if (message.gas != null && Object.hasOwnProperty.call(message, "gas"))
            writer.uint32(88).uint64(message.gas);
        if (message.payload_length != null && Object.hasOwnProperty.call(message, "payload_length"))
            writer.uint32(96).uint32(message.payload_length);
        return writer;
    };

    KaspaSignTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    KaspaSignTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.KaspaSignTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.raw_message = reader.bytes();
                break;
            case 3:
                message.scheme = reader.string();
                break;
            case 4:
                message.prefix = reader.string();
                break;
            case 5:
                message.input_count = reader.uint32();
                break;
            case 6:
                message.use_tweak = reader.bool();
                break;
            case 7:
                message.output_count = reader.uint32();
                break;
            case 8:
                message.version = reader.uint32();
                break;
            case 9:
                message.lock_time = reader.uint64();
                break;
            case 10:
                message.subnetwork_id = reader.bytes();
                break;
            case 11:
                message.gas = reader.uint64();
                break;
            case 12:
                message.payload_length = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    KaspaSignTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    KaspaSignTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.raw_message != null && message.hasOwnProperty("raw_message"))
            if (!(message.raw_message && typeof message.raw_message.length === "number" || $util.isString(message.raw_message)))
                return "raw_message: buffer expected";
        if (message.scheme != null && message.hasOwnProperty("scheme"))
            if (!$util.isString(message.scheme))
                return "scheme: string expected";
        if (message.prefix != null && message.hasOwnProperty("prefix"))
            if (!$util.isString(message.prefix))
                return "prefix: string expected";
        if (message.input_count != null && message.hasOwnProperty("input_count"))
            if (!$util.isInteger(message.input_count))
                return "input_count: integer expected";
        if (message.use_tweak != null && message.hasOwnProperty("use_tweak"))
            if (typeof message.use_tweak !== "boolean")
                return "use_tweak: boolean expected";
        if (message.output_count != null && message.hasOwnProperty("output_count"))
            if (!$util.isInteger(message.output_count))
                return "output_count: integer expected";
        if (message.version != null && message.hasOwnProperty("version"))
            if (!$util.isInteger(message.version))
                return "version: integer expected";
        if (message.lock_time != null && message.hasOwnProperty("lock_time"))
            if (!$util.isInteger(message.lock_time) && !(message.lock_time && $util.isInteger(message.lock_time.low) && $util.isInteger(message.lock_time.high)))
                return "lock_time: integer|Long expected";
        if (message.subnetwork_id != null && message.hasOwnProperty("subnetwork_id"))
            if (!(message.subnetwork_id && typeof message.subnetwork_id.length === "number" || $util.isString(message.subnetwork_id)))
                return "subnetwork_id: buffer expected";
        if (message.gas != null && message.hasOwnProperty("gas"))
            if (!$util.isInteger(message.gas) && !(message.gas && $util.isInteger(message.gas.low) && $util.isInteger(message.gas.high)))
                return "gas: integer|Long expected";
        if (message.payload_length != null && message.hasOwnProperty("payload_length"))
            if (!$util.isInteger(message.payload_length))
                return "payload_length: integer expected";
        return null;
    };

    KaspaSignTx.fromObject = function fromObject(object) {
        if (object instanceof $root.KaspaSignTx)
            return object;
        var message = new $root.KaspaSignTx();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".KaspaSignTx.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.raw_message != null)
            if (typeof object.raw_message === "string")
                $util.base64.decode(object.raw_message, message.raw_message = $util.newBuffer($util.base64.length(object.raw_message)), 0);
            else if (object.raw_message.length)
                message.raw_message = object.raw_message;
        if (object.scheme != null)
            message.scheme = String(object.scheme);
        if (object.prefix != null)
            message.prefix = String(object.prefix);
        if (object.input_count != null)
            message.input_count = object.input_count >>> 0;
        if (object.use_tweak != null)
            message.use_tweak = Boolean(object.use_tweak);
        if (object.output_count != null)
            message.output_count = object.output_count >>> 0;
        if (object.version != null)
            message.version = object.version >>> 0;
        if (object.lock_time != null)
            if ($util.Long)
                (message.lock_time = $util.Long.fromValue(object.lock_time)).unsigned = true;
            else if (typeof object.lock_time === "string")
                message.lock_time = parseInt(object.lock_time, 10);
            else if (typeof object.lock_time === "number")
                message.lock_time = object.lock_time;
            else if (typeof object.lock_time === "object")
                message.lock_time = new $util.LongBits(object.lock_time.low >>> 0, object.lock_time.high >>> 0).toNumber(true);
        if (object.subnetwork_id != null)
            if (typeof object.subnetwork_id === "string")
                $util.base64.decode(object.subnetwork_id, message.subnetwork_id = $util.newBuffer($util.base64.length(object.subnetwork_id)), 0);
            else if (object.subnetwork_id.length)
                message.subnetwork_id = object.subnetwork_id;
        if (object.gas != null)
            if ($util.Long)
                (message.gas = $util.Long.fromValue(object.gas)).unsigned = true;
            else if (typeof object.gas === "string")
                message.gas = parseInt(object.gas, 10);
            else if (typeof object.gas === "number")
                message.gas = object.gas;
            else if (typeof object.gas === "object")
                message.gas = new $util.LongBits(object.gas.low >>> 0, object.gas.high >>> 0).toNumber(true);
        if (object.payload_length != null)
            message.payload_length = object.payload_length >>> 0;
        return message;
    };

    KaspaSignTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            if (options.bytes === String)
                object.raw_message = "";
            else {
                object.raw_message = [];
                if (options.bytes !== Array)
                    object.raw_message = $util.newBuffer(object.raw_message);
            }
            object.scheme = "schnorr";
            object.prefix = "kaspa";
            object.input_count = 1;
            object.use_tweak = true;
            object.output_count = 0;
            object.version = 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.lock_time = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.lock_time = options.longs === String ? "0" : 0;
            if (options.bytes === String)
                object.subnetwork_id = "";
            else {
                object.subnetwork_id = [];
                if (options.bytes !== Array)
                    object.subnetwork_id = $util.newBuffer(object.subnetwork_id);
            }
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.gas = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.gas = options.longs === String ? "0" : 0;
            object.payload_length = 0;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.raw_message != null && message.hasOwnProperty("raw_message"))
            object.raw_message = options.bytes === String ? $util.base64.encode(message.raw_message, 0, message.raw_message.length) : options.bytes === Array ? Array.prototype.slice.call(message.raw_message) : message.raw_message;
        if (message.scheme != null && message.hasOwnProperty("scheme"))
            object.scheme = message.scheme;
        if (message.prefix != null && message.hasOwnProperty("prefix"))
            object.prefix = message.prefix;
        if (message.input_count != null && message.hasOwnProperty("input_count"))
            object.input_count = message.input_count;
        if (message.use_tweak != null && message.hasOwnProperty("use_tweak"))
            object.use_tweak = message.use_tweak;
        if (message.output_count != null && message.hasOwnProperty("output_count"))
            object.output_count = message.output_count;
        if (message.version != null && message.hasOwnProperty("version"))
            object.version = message.version;
        if (message.lock_time != null && message.hasOwnProperty("lock_time"))
            if (typeof message.lock_time === "number")
                object.lock_time = options.longs === String ? String(message.lock_time) : message.lock_time;
            else
                object.lock_time = options.longs === String ? $util.Long.prototype.toString.call(message.lock_time) : options.longs === Number ? new $util.LongBits(message.lock_time.low >>> 0, message.lock_time.high >>> 0).toNumber(true) : message.lock_time;
        if (message.subnetwork_id != null && message.hasOwnProperty("subnetwork_id"))
            object.subnetwork_id = options.bytes === String ? $util.base64.encode(message.subnetwork_id, 0, message.subnetwork_id.length) : options.bytes === Array ? Array.prototype.slice.call(message.subnetwork_id) : message.subnetwork_id;
        if (message.gas != null && message.hasOwnProperty("gas"))
            if (typeof message.gas === "number")
                object.gas = options.longs === String ? String(message.gas) : message.gas;
            else
                object.gas = options.longs === String ? $util.Long.prototype.toString.call(message.gas) : options.longs === Number ? new $util.LongBits(message.gas.low >>> 0, message.gas.high >>> 0).toNumber(true) : message.gas;
        if (message.payload_length != null && message.hasOwnProperty("payload_length"))
            object.payload_length = message.payload_length;
        return object;
    };

    KaspaSignTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return KaspaSignTx;
})();

$root.KaspaTxInputRequest = (function() {

    function KaspaTxInputRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    KaspaTxInputRequest.prototype.request_index = 0;
    KaspaTxInputRequest.prototype.signature = $util.newBuffer([]);

    KaspaTxInputRequest.create = function create(properties) {
        return new KaspaTxInputRequest(properties);
    };

    KaspaTxInputRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).uint32(message.request_index);
        if (message.signature != null && Object.hasOwnProperty.call(message, "signature"))
            writer.uint32(18).bytes(message.signature);
        return writer;
    };

    KaspaTxInputRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    KaspaTxInputRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.KaspaTxInputRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.request_index = reader.uint32();
                break;
            case 2:
                message.signature = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("request_index"))
            throw $util.ProtocolError("missing required 'request_index'", { instance: message });
        return message;
    };

    KaspaTxInputRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    KaspaTxInputRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isInteger(message.request_index))
            return "request_index: integer expected";
        if (message.signature != null && message.hasOwnProperty("signature"))
            if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
                return "signature: buffer expected";
        return null;
    };

    KaspaTxInputRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.KaspaTxInputRequest)
            return object;
        var message = new $root.KaspaTxInputRequest();
        if (object.request_index != null)
            message.request_index = object.request_index >>> 0;
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        return message;
    };

    KaspaTxInputRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.request_index = 0;
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
        }
        if (message.request_index != null && message.hasOwnProperty("request_index"))
            object.request_index = message.request_index;
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        return object;
    };

    KaspaTxInputRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return KaspaTxInputRequest;
})();

$root.KaspaTxInputAck = (function() {

    function KaspaTxInputAck(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    KaspaTxInputAck.prototype.address_n = $util.emptyArray;
    KaspaTxInputAck.prototype.raw_message = $util.newBuffer([]);

    KaspaTxInputAck.create = function create(properties) {
        return new KaspaTxInputAck(properties);
    };

    KaspaTxInputAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).bytes(message.raw_message);
        return writer;
    };

    KaspaTxInputAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    KaspaTxInputAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.KaspaTxInputAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.raw_message = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("raw_message"))
            throw $util.ProtocolError("missing required 'raw_message'", { instance: message });
        return message;
    };

    KaspaTxInputAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    KaspaTxInputAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!(message.raw_message && typeof message.raw_message.length === "number" || $util.isString(message.raw_message)))
            return "raw_message: buffer expected";
        return null;
    };

    KaspaTxInputAck.fromObject = function fromObject(object) {
        if (object instanceof $root.KaspaTxInputAck)
            return object;
        var message = new $root.KaspaTxInputAck();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".KaspaTxInputAck.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.raw_message != null)
            if (typeof object.raw_message === "string")
                $util.base64.decode(object.raw_message, message.raw_message = $util.newBuffer($util.base64.length(object.raw_message)), 0);
            else if (object.raw_message.length)
                message.raw_message = object.raw_message;
        return message;
    };

    KaspaTxInputAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            if (options.bytes === String)
                object.raw_message = "";
            else {
                object.raw_message = [];
                if (options.bytes !== Array)
                    object.raw_message = $util.newBuffer(object.raw_message);
            }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.raw_message != null && message.hasOwnProperty("raw_message"))
            object.raw_message = options.bytes === String ? $util.base64.encode(message.raw_message, 0, message.raw_message.length) : options.bytes === Array ? Array.prototype.slice.call(message.raw_message) : message.raw_message;
        return object;
    };

    KaspaTxInputAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return KaspaTxInputAck;
})();

$root.KaspaOutpoint = (function() {

    function KaspaOutpoint(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    KaspaOutpoint.prototype.tx_id = $util.newBuffer([]);
    KaspaOutpoint.prototype.index = 0;

    KaspaOutpoint.create = function create(properties) {
        return new KaspaOutpoint(properties);
    };

    KaspaOutpoint.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.tx_id);
        writer.uint32(16).uint32(message.index);
        return writer;
    };

    KaspaOutpoint.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    KaspaOutpoint.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.KaspaOutpoint();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.tx_id = reader.bytes();
                break;
            case 2:
                message.index = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("tx_id"))
            throw $util.ProtocolError("missing required 'tx_id'", { instance: message });
        if (!message.hasOwnProperty("index"))
            throw $util.ProtocolError("missing required 'index'", { instance: message });
        return message;
    };

    KaspaOutpoint.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    KaspaOutpoint.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.tx_id && typeof message.tx_id.length === "number" || $util.isString(message.tx_id)))
            return "tx_id: buffer expected";
        if (!$util.isInteger(message.index))
            return "index: integer expected";
        return null;
    };

    KaspaOutpoint.fromObject = function fromObject(object) {
        if (object instanceof $root.KaspaOutpoint)
            return object;
        var message = new $root.KaspaOutpoint();
        if (object.tx_id != null)
            if (typeof object.tx_id === "string")
                $util.base64.decode(object.tx_id, message.tx_id = $util.newBuffer($util.base64.length(object.tx_id)), 0);
            else if (object.tx_id.length)
                message.tx_id = object.tx_id;
        if (object.index != null)
            message.index = object.index >>> 0;
        return message;
    };

    KaspaOutpoint.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.tx_id = "";
            else {
                object.tx_id = [];
                if (options.bytes !== Array)
                    object.tx_id = $util.newBuffer(object.tx_id);
            }
            object.index = 0;
        }
        if (message.tx_id != null && message.hasOwnProperty("tx_id"))
            object.tx_id = options.bytes === String ? $util.base64.encode(message.tx_id, 0, message.tx_id.length) : options.bytes === Array ? Array.prototype.slice.call(message.tx_id) : message.tx_id;
        if (message.index != null && message.hasOwnProperty("index"))
            object.index = message.index;
        return object;
    };

    KaspaOutpoint.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return KaspaOutpoint;
})();

$root.KaspaInputScriptType = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "KASPA_SPEND_P2PK_SCHNORR"] = 0;
    values[valuesById[1] = "KASPA_SPEND_P2PK_ECDSA"] = 1;
    return values;
})();

$root.KaspaOutputScriptType = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "KASPA_PAYTOADDRESS"] = 0;
    values[valuesById[1] = "KASPA_PAYTOCHANGE"] = 1;
    return values;
})();

$root.KaspaRequestType = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "KASPA_TX_INPUT"] = 0;
    values[valuesById[1] = "KASPA_TX_OUTPUT"] = 1;
    values[valuesById[2] = "KASPA_TX_PAYLOAD"] = 2;
    values[valuesById[3] = "KASPA_TX_FINISHED"] = 3;
    values[valuesById[4] = "KASPA_TX_PREV_META"] = 4;
    return values;
})();

$root.KaspaTxRequestSignature = (function() {

    function KaspaTxRequestSignature(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    KaspaTxRequestSignature.prototype.signature_index = 0;
    KaspaTxRequestSignature.prototype.signature = $util.newBuffer([]);

    KaspaTxRequestSignature.create = function create(properties) {
        return new KaspaTxRequestSignature(properties);
    };

    KaspaTxRequestSignature.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).uint32(message.signature_index);
        writer.uint32(18).bytes(message.signature);
        return writer;
    };

    KaspaTxRequestSignature.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    KaspaTxRequestSignature.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.KaspaTxRequestSignature();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.signature_index = reader.uint32();
                break;
            case 2:
                message.signature = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("signature_index"))
            throw $util.ProtocolError("missing required 'signature_index'", { instance: message });
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        return message;
    };

    KaspaTxRequestSignature.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    KaspaTxRequestSignature.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isInteger(message.signature_index))
            return "signature_index: integer expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        return null;
    };

    KaspaTxRequestSignature.fromObject = function fromObject(object) {
        if (object instanceof $root.KaspaTxRequestSignature)
            return object;
        var message = new $root.KaspaTxRequestSignature();
        if (object.signature_index != null)
            message.signature_index = object.signature_index >>> 0;
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        return message;
    };

    KaspaTxRequestSignature.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.signature_index = 0;
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
        }
        if (message.signature_index != null && message.hasOwnProperty("signature_index"))
            object.signature_index = message.signature_index;
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        return object;
    };

    KaspaTxRequestSignature.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return KaspaTxRequestSignature;
})();

$root.KaspaTxRequest = (function() {

    function KaspaTxRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    KaspaTxRequest.prototype.request_type = 0;
    KaspaTxRequest.prototype.request_index = 0;
    KaspaTxRequest.prototype.signature = null;
    KaspaTxRequest.prototype.request_payload_length = 0;
    KaspaTxRequest.prototype.prev_tx_id = $util.newBuffer([]);

    KaspaTxRequest.create = function create(properties) {
        return new KaspaTxRequest(properties);
    };

    KaspaTxRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).int32(message.request_type);
        if (message.request_index != null && Object.hasOwnProperty.call(message, "request_index"))
            writer.uint32(16).uint32(message.request_index);
        if (message.signature != null && Object.hasOwnProperty.call(message, "signature"))
            $root.KaspaTxRequestSignature.encode(message.signature, writer.uint32(26).fork()).ldelim();
        if (message.request_payload_length != null && Object.hasOwnProperty.call(message, "request_payload_length"))
            writer.uint32(32).uint32(message.request_payload_length);
        if (message.prev_tx_id != null && Object.hasOwnProperty.call(message, "prev_tx_id"))
            writer.uint32(42).bytes(message.prev_tx_id);
        return writer;
    };

    KaspaTxRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    KaspaTxRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.KaspaTxRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.request_type = reader.int32();
                break;
            case 2:
                message.request_index = reader.uint32();
                break;
            case 3:
                message.signature = $root.KaspaTxRequestSignature.decode(reader, reader.uint32());
                break;
            case 4:
                message.request_payload_length = reader.uint32();
                break;
            case 5:
                message.prev_tx_id = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("request_type"))
            throw $util.ProtocolError("missing required 'request_type'", { instance: message });
        return message;
    };

    KaspaTxRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    KaspaTxRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        switch (message.request_type) {
        default:
            return "request_type: enum value expected";
        case 0:
        case 1:
        case 2:
        case 3:
        case 4:
            break;
        }
        if (message.request_index != null && message.hasOwnProperty("request_index"))
            if (!$util.isInteger(message.request_index))
                return "request_index: integer expected";
        if (message.signature != null && message.hasOwnProperty("signature")) {
            var error = $root.KaspaTxRequestSignature.verify(message.signature);
            if (error)
                return "signature." + error;
        }
        if (message.request_payload_length != null && message.hasOwnProperty("request_payload_length"))
            if (!$util.isInteger(message.request_payload_length))
                return "request_payload_length: integer expected";
        if (message.prev_tx_id != null && message.hasOwnProperty("prev_tx_id"))
            if (!(message.prev_tx_id && typeof message.prev_tx_id.length === "number" || $util.isString(message.prev_tx_id)))
                return "prev_tx_id: buffer expected";
        return null;
    };

    KaspaTxRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.KaspaTxRequest)
            return object;
        var message = new $root.KaspaTxRequest();
        switch (object.request_type) {
        case "KASPA_TX_INPUT":
        case 0:
            message.request_type = 0;
            break;
        case "KASPA_TX_OUTPUT":
        case 1:
            message.request_type = 1;
            break;
        case "KASPA_TX_PAYLOAD":
        case 2:
            message.request_type = 2;
            break;
        case "KASPA_TX_FINISHED":
        case 3:
            message.request_type = 3;
            break;
        case "KASPA_TX_PREV_META":
        case 4:
            message.request_type = 4;
            break;
        }
        if (object.request_index != null)
            message.request_index = object.request_index >>> 0;
        if (object.signature != null) {
            if (typeof object.signature !== "object")
                throw TypeError(".KaspaTxRequest.signature: object expected");
            message.signature = $root.KaspaTxRequestSignature.fromObject(object.signature);
        }
        if (object.request_payload_length != null)
            message.request_payload_length = object.request_payload_length >>> 0;
        if (object.prev_tx_id != null)
            if (typeof object.prev_tx_id === "string")
                $util.base64.decode(object.prev_tx_id, message.prev_tx_id = $util.newBuffer($util.base64.length(object.prev_tx_id)), 0);
            else if (object.prev_tx_id.length)
                message.prev_tx_id = object.prev_tx_id;
        return message;
    };

    KaspaTxRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.request_type = options.enums === String ? "KASPA_TX_INPUT" : 0;
            object.request_index = 0;
            object.signature = null;
            object.request_payload_length = 0;
            if (options.bytes === String)
                object.prev_tx_id = "";
            else {
                object.prev_tx_id = [];
                if (options.bytes !== Array)
                    object.prev_tx_id = $util.newBuffer(object.prev_tx_id);
            }
        }
        if (message.request_type != null && message.hasOwnProperty("request_type"))
            object.request_type = options.enums === String ? $root.KaspaRequestType[message.request_type] : message.request_type;
        if (message.request_index != null && message.hasOwnProperty("request_index"))
            object.request_index = message.request_index;
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = $root.KaspaTxRequestSignature.toObject(message.signature, options);
        if (message.request_payload_length != null && message.hasOwnProperty("request_payload_length"))
            object.request_payload_length = message.request_payload_length;
        if (message.prev_tx_id != null && message.hasOwnProperty("prev_tx_id"))
            object.prev_tx_id = options.bytes === String ? $util.base64.encode(message.prev_tx_id, 0, message.prev_tx_id.length) : options.bytes === Array ? Array.prototype.slice.call(message.prev_tx_id) : message.prev_tx_id;
        return object;
    };

    KaspaTxRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return KaspaTxRequest;
})();

$root.KaspaTxAckInput = (function() {

    function KaspaTxAckInput(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    KaspaTxAckInput.prototype.address_n = $util.emptyArray;
    KaspaTxAckInput.prototype.previous_outpoint = null;
    KaspaTxAckInput.prototype.amount = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    KaspaTxAckInput.prototype.sequence = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    KaspaTxAckInput.prototype.sig_op_count = 0;
    KaspaTxAckInput.prototype.script_type = 0;
    KaspaTxAckInput.prototype.use_tweak = true;

    KaspaTxAckInput.create = function create(properties) {
        return new KaspaTxAckInput(properties);
    };

    KaspaTxAckInput.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        $root.KaspaOutpoint.encode(message.previous_outpoint, writer.uint32(18).fork()).ldelim();
        writer.uint32(24).uint64(message.amount);
        writer.uint32(32).uint64(message.sequence);
        writer.uint32(40).uint32(message.sig_op_count);
        if (message.script_type != null && Object.hasOwnProperty.call(message, "script_type"))
            writer.uint32(48).int32(message.script_type);
        if (message.use_tweak != null && Object.hasOwnProperty.call(message, "use_tweak"))
            writer.uint32(72).bool(message.use_tweak);
        return writer;
    };

    KaspaTxAckInput.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    KaspaTxAckInput.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.KaspaTxAckInput();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.previous_outpoint = $root.KaspaOutpoint.decode(reader, reader.uint32());
                break;
            case 3:
                message.amount = reader.uint64();
                break;
            case 4:
                message.sequence = reader.uint64();
                break;
            case 5:
                message.sig_op_count = reader.uint32();
                break;
            case 6:
                message.script_type = reader.int32();
                break;
            case 9:
                message.use_tweak = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("previous_outpoint"))
            throw $util.ProtocolError("missing required 'previous_outpoint'", { instance: message });
        if (!message.hasOwnProperty("amount"))
            throw $util.ProtocolError("missing required 'amount'", { instance: message });
        if (!message.hasOwnProperty("sequence"))
            throw $util.ProtocolError("missing required 'sequence'", { instance: message });
        if (!message.hasOwnProperty("sig_op_count"))
            throw $util.ProtocolError("missing required 'sig_op_count'", { instance: message });
        return message;
    };

    KaspaTxAckInput.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    KaspaTxAckInput.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        {
            var error = $root.KaspaOutpoint.verify(message.previous_outpoint);
            if (error)
                return "previous_outpoint." + error;
        }
        if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
            return "amount: integer|Long expected";
        if (!$util.isInteger(message.sequence) && !(message.sequence && $util.isInteger(message.sequence.low) && $util.isInteger(message.sequence.high)))
            return "sequence: integer|Long expected";
        if (!$util.isInteger(message.sig_op_count))
            return "sig_op_count: integer expected";
        if (message.script_type != null && message.hasOwnProperty("script_type"))
            switch (message.script_type) {
            default:
                return "script_type: enum value expected";
            case 0:
            case 1:
                break;
            }
        if (message.use_tweak != null && message.hasOwnProperty("use_tweak"))
            if (typeof message.use_tweak !== "boolean")
                return "use_tweak: boolean expected";
        return null;
    };

    KaspaTxAckInput.fromObject = function fromObject(object) {
        if (object instanceof $root.KaspaTxAckInput)
            return object;
        var message = new $root.KaspaTxAckInput();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".KaspaTxAckInput.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.previous_outpoint != null) {
            if (typeof object.previous_outpoint !== "object")
                throw TypeError(".KaspaTxAckInput.previous_outpoint: object expected");
            message.previous_outpoint = $root.KaspaOutpoint.fromObject(object.previous_outpoint);
        }
        if (object.amount != null)
            if ($util.Long)
                (message.amount = $util.Long.fromValue(object.amount)).unsigned = true;
            else if (typeof object.amount === "string")
                message.amount = parseInt(object.amount, 10);
            else if (typeof object.amount === "number")
                message.amount = object.amount;
            else if (typeof object.amount === "object")
                message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber(true);
        if (object.sequence != null)
            if ($util.Long)
                (message.sequence = $util.Long.fromValue(object.sequence)).unsigned = true;
            else if (typeof object.sequence === "string")
                message.sequence = parseInt(object.sequence, 10);
            else if (typeof object.sequence === "number")
                message.sequence = object.sequence;
            else if (typeof object.sequence === "object")
                message.sequence = new $util.LongBits(object.sequence.low >>> 0, object.sequence.high >>> 0).toNumber(true);
        if (object.sig_op_count != null)
            message.sig_op_count = object.sig_op_count >>> 0;
        switch (object.script_type) {
        case "KASPA_SPEND_P2PK_SCHNORR":
        case 0:
            message.script_type = 0;
            break;
        case "KASPA_SPEND_P2PK_ECDSA":
        case 1:
            message.script_type = 1;
            break;
        }
        if (object.use_tweak != null)
            message.use_tweak = Boolean(object.use_tweak);
        return message;
    };

    KaspaTxAckInput.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            object.previous_outpoint = null;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.amount = options.longs === String ? "0" : 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.sequence = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.sequence = options.longs === String ? "0" : 0;
            object.sig_op_count = 0;
            object.script_type = options.enums === String ? "KASPA_SPEND_P2PK_SCHNORR" : 0;
            object.use_tweak = true;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.previous_outpoint != null && message.hasOwnProperty("previous_outpoint"))
            object.previous_outpoint = $root.KaspaOutpoint.toObject(message.previous_outpoint, options);
        if (message.amount != null && message.hasOwnProperty("amount"))
            if (typeof message.amount === "number")
                object.amount = options.longs === String ? String(message.amount) : message.amount;
            else
                object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber(true) : message.amount;
        if (message.sequence != null && message.hasOwnProperty("sequence"))
            if (typeof message.sequence === "number")
                object.sequence = options.longs === String ? String(message.sequence) : message.sequence;
            else
                object.sequence = options.longs === String ? $util.Long.prototype.toString.call(message.sequence) : options.longs === Number ? new $util.LongBits(message.sequence.low >>> 0, message.sequence.high >>> 0).toNumber(true) : message.sequence;
        if (message.sig_op_count != null && message.hasOwnProperty("sig_op_count"))
            object.sig_op_count = message.sig_op_count;
        if (message.script_type != null && message.hasOwnProperty("script_type"))
            object.script_type = options.enums === String ? $root.KaspaInputScriptType[message.script_type] : message.script_type;
        if (message.use_tweak != null && message.hasOwnProperty("use_tweak"))
            object.use_tweak = message.use_tweak;
        return object;
    };

    KaspaTxAckInput.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return KaspaTxAckInput;
})();

$root.KaspaTxAckOutput = (function() {

    function KaspaTxAckOutput(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    KaspaTxAckOutput.prototype.script_type = 0;
    KaspaTxAckOutput.prototype.amount = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    KaspaTxAckOutput.prototype.address_n = $util.emptyArray;
    KaspaTxAckOutput.prototype.address = "";
    KaspaTxAckOutput.prototype.scheme = "schnorr";
    KaspaTxAckOutput.prototype.use_tweak = true;

    KaspaTxAckOutput.create = function create(properties) {
        return new KaspaTxAckOutput(properties);
    };

    KaspaTxAckOutput.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.script_type != null && Object.hasOwnProperty.call(message, "script_type"))
            writer.uint32(8).int32(message.script_type);
        writer.uint32(16).uint64(message.amount);
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(24).uint32(message.address_n[i]);
        if (message.address != null && Object.hasOwnProperty.call(message, "address"))
            writer.uint32(34).string(message.address);
        if (message.scheme != null && Object.hasOwnProperty.call(message, "scheme"))
            writer.uint32(58).string(message.scheme);
        if (message.use_tweak != null && Object.hasOwnProperty.call(message, "use_tweak"))
            writer.uint32(64).bool(message.use_tweak);
        return writer;
    };

    KaspaTxAckOutput.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    KaspaTxAckOutput.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.KaspaTxAckOutput();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.script_type = reader.int32();
                break;
            case 2:
                message.amount = reader.uint64();
                break;
            case 3:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 4:
                message.address = reader.string();
                break;
            case 7:
                message.scheme = reader.string();
                break;
            case 8:
                message.use_tweak = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("amount"))
            throw $util.ProtocolError("missing required 'amount'", { instance: message });
        return message;
    };

    KaspaTxAckOutput.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    KaspaTxAckOutput.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.script_type != null && message.hasOwnProperty("script_type"))
            switch (message.script_type) {
            default:
                return "script_type: enum value expected";
            case 0:
            case 1:
                break;
            }
        if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
            return "amount: integer|Long expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.address != null && message.hasOwnProperty("address"))
            if (!$util.isString(message.address))
                return "address: string expected";
        if (message.scheme != null && message.hasOwnProperty("scheme"))
            if (!$util.isString(message.scheme))
                return "scheme: string expected";
        if (message.use_tweak != null && message.hasOwnProperty("use_tweak"))
            if (typeof message.use_tweak !== "boolean")
                return "use_tweak: boolean expected";
        return null;
    };

    KaspaTxAckOutput.fromObject = function fromObject(object) {
        if (object instanceof $root.KaspaTxAckOutput)
            return object;
        var message = new $root.KaspaTxAckOutput();
        switch (object.script_type) {
        case "KASPA_PAYTOADDRESS":
        case 0:
            message.script_type = 0;
            break;
        case "KASPA_PAYTOCHANGE":
        case 1:
            message.script_type = 1;
            break;
        }
        if (object.amount != null)
            if ($util.Long)
                (message.amount = $util.Long.fromValue(object.amount)).unsigned = true;
            else if (typeof object.amount === "string")
                message.amount = parseInt(object.amount, 10);
            else if (typeof object.amount === "number")
                message.amount = object.amount;
            else if (typeof object.amount === "object")
                message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber(true);
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".KaspaTxAckOutput.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.address != null)
            message.address = String(object.address);
        if (object.scheme != null)
            message.scheme = String(object.scheme);
        if (object.use_tweak != null)
            message.use_tweak = Boolean(object.use_tweak);
        return message;
    };

    KaspaTxAckOutput.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            object.script_type = options.enums === String ? "KASPA_PAYTOADDRESS" : 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.amount = options.longs === String ? "0" : 0;
            object.address = "";
            object.scheme = "schnorr";
            object.use_tweak = true;
        }
        if (message.script_type != null && message.hasOwnProperty("script_type"))
            object.script_type = options.enums === String ? $root.KaspaOutputScriptType[message.script_type] : message.script_type;
        if (message.amount != null && message.hasOwnProperty("amount"))
            if (typeof message.amount === "number")
                object.amount = options.longs === String ? String(message.amount) : message.amount;
            else
                object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber(true) : message.amount;
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        if (message.scheme != null && message.hasOwnProperty("scheme"))
            object.scheme = message.scheme;
        if (message.use_tweak != null && message.hasOwnProperty("use_tweak"))
            object.use_tweak = message.use_tweak;
        return object;
    };

    KaspaTxAckOutput.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return KaspaTxAckOutput;
})();

$root.KaspaTxAckPayloadChunk = (function() {

    function KaspaTxAckPayloadChunk(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    KaspaTxAckPayloadChunk.prototype.payload_chunk = $util.newBuffer([]);

    KaspaTxAckPayloadChunk.create = function create(properties) {
        return new KaspaTxAckPayloadChunk(properties);
    };

    KaspaTxAckPayloadChunk.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.payload_chunk);
        return writer;
    };

    KaspaTxAckPayloadChunk.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    KaspaTxAckPayloadChunk.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.KaspaTxAckPayloadChunk();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.payload_chunk = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("payload_chunk"))
            throw $util.ProtocolError("missing required 'payload_chunk'", { instance: message });
        return message;
    };

    KaspaTxAckPayloadChunk.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    KaspaTxAckPayloadChunk.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.payload_chunk && typeof message.payload_chunk.length === "number" || $util.isString(message.payload_chunk)))
            return "payload_chunk: buffer expected";
        return null;
    };

    KaspaTxAckPayloadChunk.fromObject = function fromObject(object) {
        if (object instanceof $root.KaspaTxAckPayloadChunk)
            return object;
        var message = new $root.KaspaTxAckPayloadChunk();
        if (object.payload_chunk != null)
            if (typeof object.payload_chunk === "string")
                $util.base64.decode(object.payload_chunk, message.payload_chunk = $util.newBuffer($util.base64.length(object.payload_chunk)), 0);
            else if (object.payload_chunk.length)
                message.payload_chunk = object.payload_chunk;
        return message;
    };

    KaspaTxAckPayloadChunk.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.payload_chunk = "";
            else {
                object.payload_chunk = [];
                if (options.bytes !== Array)
                    object.payload_chunk = $util.newBuffer(object.payload_chunk);
            }
        if (message.payload_chunk != null && message.hasOwnProperty("payload_chunk"))
            object.payload_chunk = options.bytes === String ? $util.base64.encode(message.payload_chunk, 0, message.payload_chunk.length) : options.bytes === Array ? Array.prototype.slice.call(message.payload_chunk) : message.payload_chunk;
        return object;
    };

    KaspaTxAckPayloadChunk.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return KaspaTxAckPayloadChunk;
})();

$root.KaspaTxAckPrevMeta = (function() {

    function KaspaTxAckPrevMeta(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    KaspaTxAckPrevMeta.prototype.version = 0;
    KaspaTxAckPrevMeta.prototype.input_count = 0;
    KaspaTxAckPrevMeta.prototype.output_count = 0;
    KaspaTxAckPrevMeta.prototype.lock_time = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    KaspaTxAckPrevMeta.prototype.subnetwork_id = $util.newBuffer([]);
    KaspaTxAckPrevMeta.prototype.gas = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    KaspaTxAckPrevMeta.prototype.payload_length = 0;

    KaspaTxAckPrevMeta.create = function create(properties) {
        return new KaspaTxAckPrevMeta(properties);
    };

    KaspaTxAckPrevMeta.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).uint32(message.version);
        writer.uint32(16).uint32(message.input_count);
        writer.uint32(24).uint32(message.output_count);
        writer.uint32(32).uint64(message.lock_time);
        writer.uint32(42).bytes(message.subnetwork_id);
        writer.uint32(48).uint64(message.gas);
        writer.uint32(56).uint32(message.payload_length);
        return writer;
    };

    KaspaTxAckPrevMeta.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    KaspaTxAckPrevMeta.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.KaspaTxAckPrevMeta();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.version = reader.uint32();
                break;
            case 2:
                message.input_count = reader.uint32();
                break;
            case 3:
                message.output_count = reader.uint32();
                break;
            case 4:
                message.lock_time = reader.uint64();
                break;
            case 5:
                message.subnetwork_id = reader.bytes();
                break;
            case 6:
                message.gas = reader.uint64();
                break;
            case 7:
                message.payload_length = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("version"))
            throw $util.ProtocolError("missing required 'version'", { instance: message });
        if (!message.hasOwnProperty("input_count"))
            throw $util.ProtocolError("missing required 'input_count'", { instance: message });
        if (!message.hasOwnProperty("output_count"))
            throw $util.ProtocolError("missing required 'output_count'", { instance: message });
        if (!message.hasOwnProperty("lock_time"))
            throw $util.ProtocolError("missing required 'lock_time'", { instance: message });
        if (!message.hasOwnProperty("subnetwork_id"))
            throw $util.ProtocolError("missing required 'subnetwork_id'", { instance: message });
        if (!message.hasOwnProperty("gas"))
            throw $util.ProtocolError("missing required 'gas'", { instance: message });
        if (!message.hasOwnProperty("payload_length"))
            throw $util.ProtocolError("missing required 'payload_length'", { instance: message });
        return message;
    };

    KaspaTxAckPrevMeta.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    KaspaTxAckPrevMeta.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isInteger(message.version))
            return "version: integer expected";
        if (!$util.isInteger(message.input_count))
            return "input_count: integer expected";
        if (!$util.isInteger(message.output_count))
            return "output_count: integer expected";
        if (!$util.isInteger(message.lock_time) && !(message.lock_time && $util.isInteger(message.lock_time.low) && $util.isInteger(message.lock_time.high)))
            return "lock_time: integer|Long expected";
        if (!(message.subnetwork_id && typeof message.subnetwork_id.length === "number" || $util.isString(message.subnetwork_id)))
            return "subnetwork_id: buffer expected";
        if (!$util.isInteger(message.gas) && !(message.gas && $util.isInteger(message.gas.low) && $util.isInteger(message.gas.high)))
            return "gas: integer|Long expected";
        if (!$util.isInteger(message.payload_length))
            return "payload_length: integer expected";
        return null;
    };

    KaspaTxAckPrevMeta.fromObject = function fromObject(object) {
        if (object instanceof $root.KaspaTxAckPrevMeta)
            return object;
        var message = new $root.KaspaTxAckPrevMeta();
        if (object.version != null)
            message.version = object.version >>> 0;
        if (object.input_count != null)
            message.input_count = object.input_count >>> 0;
        if (object.output_count != null)
            message.output_count = object.output_count >>> 0;
        if (object.lock_time != null)
            if ($util.Long)
                (message.lock_time = $util.Long.fromValue(object.lock_time)).unsigned = true;
            else if (typeof object.lock_time === "string")
                message.lock_time = parseInt(object.lock_time, 10);
            else if (typeof object.lock_time === "number")
                message.lock_time = object.lock_time;
            else if (typeof object.lock_time === "object")
                message.lock_time = new $util.LongBits(object.lock_time.low >>> 0, object.lock_time.high >>> 0).toNumber(true);
        if (object.subnetwork_id != null)
            if (typeof object.subnetwork_id === "string")
                $util.base64.decode(object.subnetwork_id, message.subnetwork_id = $util.newBuffer($util.base64.length(object.subnetwork_id)), 0);
            else if (object.subnetwork_id.length)
                message.subnetwork_id = object.subnetwork_id;
        if (object.gas != null)
            if ($util.Long)
                (message.gas = $util.Long.fromValue(object.gas)).unsigned = true;
            else if (typeof object.gas === "string")
                message.gas = parseInt(object.gas, 10);
            else if (typeof object.gas === "number")
                message.gas = object.gas;
            else if (typeof object.gas === "object")
                message.gas = new $util.LongBits(object.gas.low >>> 0, object.gas.high >>> 0).toNumber(true);
        if (object.payload_length != null)
            message.payload_length = object.payload_length >>> 0;
        return message;
    };

    KaspaTxAckPrevMeta.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.version = 0;
            object.input_count = 0;
            object.output_count = 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.lock_time = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.lock_time = options.longs === String ? "0" : 0;
            if (options.bytes === String)
                object.subnetwork_id = "";
            else {
                object.subnetwork_id = [];
                if (options.bytes !== Array)
                    object.subnetwork_id = $util.newBuffer(object.subnetwork_id);
            }
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.gas = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.gas = options.longs === String ? "0" : 0;
            object.payload_length = 0;
        }
        if (message.version != null && message.hasOwnProperty("version"))
            object.version = message.version;
        if (message.input_count != null && message.hasOwnProperty("input_count"))
            object.input_count = message.input_count;
        if (message.output_count != null && message.hasOwnProperty("output_count"))
            object.output_count = message.output_count;
        if (message.lock_time != null && message.hasOwnProperty("lock_time"))
            if (typeof message.lock_time === "number")
                object.lock_time = options.longs === String ? String(message.lock_time) : message.lock_time;
            else
                object.lock_time = options.longs === String ? $util.Long.prototype.toString.call(message.lock_time) : options.longs === Number ? new $util.LongBits(message.lock_time.low >>> 0, message.lock_time.high >>> 0).toNumber(true) : message.lock_time;
        if (message.subnetwork_id != null && message.hasOwnProperty("subnetwork_id"))
            object.subnetwork_id = options.bytes === String ? $util.base64.encode(message.subnetwork_id, 0, message.subnetwork_id.length) : options.bytes === Array ? Array.prototype.slice.call(message.subnetwork_id) : message.subnetwork_id;
        if (message.gas != null && message.hasOwnProperty("gas"))
            if (typeof message.gas === "number")
                object.gas = options.longs === String ? String(message.gas) : message.gas;
            else
                object.gas = options.longs === String ? $util.Long.prototype.toString.call(message.gas) : options.longs === Number ? new $util.LongBits(message.gas.low >>> 0, message.gas.high >>> 0).toNumber(true) : message.gas;
        if (message.payload_length != null && message.hasOwnProperty("payload_length"))
            object.payload_length = message.payload_length;
        return object;
    };

    KaspaTxAckPrevMeta.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return KaspaTxAckPrevMeta;
})();

$root.KaspaTxAckPrevInput = (function() {

    function KaspaTxAckPrevInput(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    KaspaTxAckPrevInput.prototype.previous_outpoint = null;
    KaspaTxAckPrevInput.prototype.sequence = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    KaspaTxAckPrevInput.create = function create(properties) {
        return new KaspaTxAckPrevInput(properties);
    };

    KaspaTxAckPrevInput.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        $root.KaspaOutpoint.encode(message.previous_outpoint, writer.uint32(10).fork()).ldelim();
        writer.uint32(16).uint64(message.sequence);
        return writer;
    };

    KaspaTxAckPrevInput.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    KaspaTxAckPrevInput.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.KaspaTxAckPrevInput();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.previous_outpoint = $root.KaspaOutpoint.decode(reader, reader.uint32());
                break;
            case 2:
                message.sequence = reader.uint64();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("previous_outpoint"))
            throw $util.ProtocolError("missing required 'previous_outpoint'", { instance: message });
        if (!message.hasOwnProperty("sequence"))
            throw $util.ProtocolError("missing required 'sequence'", { instance: message });
        return message;
    };

    KaspaTxAckPrevInput.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    KaspaTxAckPrevInput.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        {
            var error = $root.KaspaOutpoint.verify(message.previous_outpoint);
            if (error)
                return "previous_outpoint." + error;
        }
        if (!$util.isInteger(message.sequence) && !(message.sequence && $util.isInteger(message.sequence.low) && $util.isInteger(message.sequence.high)))
            return "sequence: integer|Long expected";
        return null;
    };

    KaspaTxAckPrevInput.fromObject = function fromObject(object) {
        if (object instanceof $root.KaspaTxAckPrevInput)
            return object;
        var message = new $root.KaspaTxAckPrevInput();
        if (object.previous_outpoint != null) {
            if (typeof object.previous_outpoint !== "object")
                throw TypeError(".KaspaTxAckPrevInput.previous_outpoint: object expected");
            message.previous_outpoint = $root.KaspaOutpoint.fromObject(object.previous_outpoint);
        }
        if (object.sequence != null)
            if ($util.Long)
                (message.sequence = $util.Long.fromValue(object.sequence)).unsigned = true;
            else if (typeof object.sequence === "string")
                message.sequence = parseInt(object.sequence, 10);
            else if (typeof object.sequence === "number")
                message.sequence = object.sequence;
            else if (typeof object.sequence === "object")
                message.sequence = new $util.LongBits(object.sequence.low >>> 0, object.sequence.high >>> 0).toNumber(true);
        return message;
    };

    KaspaTxAckPrevInput.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.previous_outpoint = null;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.sequence = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.sequence = options.longs === String ? "0" : 0;
        }
        if (message.previous_outpoint != null && message.hasOwnProperty("previous_outpoint"))
            object.previous_outpoint = $root.KaspaOutpoint.toObject(message.previous_outpoint, options);
        if (message.sequence != null && message.hasOwnProperty("sequence"))
            if (typeof message.sequence === "number")
                object.sequence = options.longs === String ? String(message.sequence) : message.sequence;
            else
                object.sequence = options.longs === String ? $util.Long.prototype.toString.call(message.sequence) : options.longs === Number ? new $util.LongBits(message.sequence.low >>> 0, message.sequence.high >>> 0).toNumber(true) : message.sequence;
        return object;
    };

    KaspaTxAckPrevInput.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return KaspaTxAckPrevInput;
})();

$root.KaspaTxAckPrevOutput = (function() {

    function KaspaTxAckPrevOutput(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    KaspaTxAckPrevOutput.prototype.amount = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    KaspaTxAckPrevOutput.prototype.script_version = 0;
    KaspaTxAckPrevOutput.prototype.script_public_key = $util.newBuffer([]);

    KaspaTxAckPrevOutput.create = function create(properties) {
        return new KaspaTxAckPrevOutput(properties);
    };

    KaspaTxAckPrevOutput.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).uint64(message.amount);
        writer.uint32(16).uint32(message.script_version);
        writer.uint32(26).bytes(message.script_public_key);
        return writer;
    };

    KaspaTxAckPrevOutput.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    KaspaTxAckPrevOutput.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.KaspaTxAckPrevOutput();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.amount = reader.uint64();
                break;
            case 2:
                message.script_version = reader.uint32();
                break;
            case 3:
                message.script_public_key = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("amount"))
            throw $util.ProtocolError("missing required 'amount'", { instance: message });
        if (!message.hasOwnProperty("script_version"))
            throw $util.ProtocolError("missing required 'script_version'", { instance: message });
        if (!message.hasOwnProperty("script_public_key"))
            throw $util.ProtocolError("missing required 'script_public_key'", { instance: message });
        return message;
    };

    KaspaTxAckPrevOutput.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    KaspaTxAckPrevOutput.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
            return "amount: integer|Long expected";
        if (!$util.isInteger(message.script_version))
            return "script_version: integer expected";
        if (!(message.script_public_key && typeof message.script_public_key.length === "number" || $util.isString(message.script_public_key)))
            return "script_public_key: buffer expected";
        return null;
    };

    KaspaTxAckPrevOutput.fromObject = function fromObject(object) {
        if (object instanceof $root.KaspaTxAckPrevOutput)
            return object;
        var message = new $root.KaspaTxAckPrevOutput();
        if (object.amount != null)
            if ($util.Long)
                (message.amount = $util.Long.fromValue(object.amount)).unsigned = true;
            else if (typeof object.amount === "string")
                message.amount = parseInt(object.amount, 10);
            else if (typeof object.amount === "number")
                message.amount = object.amount;
            else if (typeof object.amount === "object")
                message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber(true);
        if (object.script_version != null)
            message.script_version = object.script_version >>> 0;
        if (object.script_public_key != null)
            if (typeof object.script_public_key === "string")
                $util.base64.decode(object.script_public_key, message.script_public_key = $util.newBuffer($util.base64.length(object.script_public_key)), 0);
            else if (object.script_public_key.length)
                message.script_public_key = object.script_public_key;
        return message;
    };

    KaspaTxAckPrevOutput.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.amount = options.longs === String ? "0" : 0;
            object.script_version = 0;
            if (options.bytes === String)
                object.script_public_key = "";
            else {
                object.script_public_key = [];
                if (options.bytes !== Array)
                    object.script_public_key = $util.newBuffer(object.script_public_key);
            }
        }
        if (message.amount != null && message.hasOwnProperty("amount"))
            if (typeof message.amount === "number")
                object.amount = options.longs === String ? String(message.amount) : message.amount;
            else
                object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber(true) : message.amount;
        if (message.script_version != null && message.hasOwnProperty("script_version"))
            object.script_version = message.script_version;
        if (message.script_public_key != null && message.hasOwnProperty("script_public_key"))
            object.script_public_key = options.bytes === String ? $util.base64.encode(message.script_public_key, 0, message.script_public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.script_public_key) : message.script_public_key;
        return object;
    };

    KaspaTxAckPrevOutput.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return KaspaTxAckPrevOutput;
})();

$root.KaspaSignedTx = (function() {

    function KaspaSignedTx(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    KaspaSignedTx.prototype.signature = $util.newBuffer([]);

    KaspaSignedTx.create = function create(properties) {
        return new KaspaSignedTx(properties);
    };

    KaspaSignedTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(18).bytes(message.signature);
        return writer;
    };

    KaspaSignedTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    KaspaSignedTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.KaspaSignedTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 2:
                message.signature = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        return message;
    };

    KaspaSignedTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    KaspaSignedTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        return null;
    };

    KaspaSignedTx.fromObject = function fromObject(object) {
        if (object instanceof $root.KaspaSignedTx)
            return object;
        var message = new $root.KaspaSignedTx();
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        return message;
    };

    KaspaSignedTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        return object;
    };

    KaspaSignedTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return KaspaSignedTx;
})();

$root.LnurlAuth = (function() {

    function LnurlAuth(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    LnurlAuth.prototype.domain = $util.newBuffer([]);
    LnurlAuth.prototype.data = $util.newBuffer([]);

    LnurlAuth.create = function create(properties) {
        return new LnurlAuth(properties);
    };

    LnurlAuth.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(18).bytes(message.domain);
        writer.uint32(26).bytes(message.data);
        return writer;
    };

    LnurlAuth.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    LnurlAuth.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.LnurlAuth();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 2:
                message.domain = reader.bytes();
                break;
            case 3:
                message.data = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("domain"))
            throw $util.ProtocolError("missing required 'domain'", { instance: message });
        if (!message.hasOwnProperty("data"))
            throw $util.ProtocolError("missing required 'data'", { instance: message });
        return message;
    };

    LnurlAuth.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    LnurlAuth.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.domain && typeof message.domain.length === "number" || $util.isString(message.domain)))
            return "domain: buffer expected";
        if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
            return "data: buffer expected";
        return null;
    };

    LnurlAuth.fromObject = function fromObject(object) {
        if (object instanceof $root.LnurlAuth)
            return object;
        var message = new $root.LnurlAuth();
        if (object.domain != null)
            if (typeof object.domain === "string")
                $util.base64.decode(object.domain, message.domain = $util.newBuffer($util.base64.length(object.domain)), 0);
            else if (object.domain.length)
                message.domain = object.domain;
        if (object.data != null)
            if (typeof object.data === "string")
                $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
            else if (object.data.length)
                message.data = object.data;
        return message;
    };

    LnurlAuth.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.domain = "";
            else {
                object.domain = [];
                if (options.bytes !== Array)
                    object.domain = $util.newBuffer(object.domain);
            }
            if (options.bytes === String)
                object.data = "";
            else {
                object.data = [];
                if (options.bytes !== Array)
                    object.data = $util.newBuffer(object.data);
            }
        }
        if (message.domain != null && message.hasOwnProperty("domain"))
            object.domain = options.bytes === String ? $util.base64.encode(message.domain, 0, message.domain.length) : options.bytes === Array ? Array.prototype.slice.call(message.domain) : message.domain;
        if (message.data != null && message.hasOwnProperty("data"))
            object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
        return object;
    };

    LnurlAuth.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return LnurlAuth;
})();

$root.LnurlAuthResp = (function() {

    function LnurlAuthResp(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    LnurlAuthResp.prototype.publickey = "";
    LnurlAuthResp.prototype.path = "";
    LnurlAuthResp.prototype.signature = $util.newBuffer([]);

    LnurlAuthResp.create = function create(properties) {
        return new LnurlAuthResp(properties);
    };

    LnurlAuthResp.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.publickey != null && Object.hasOwnProperty.call(message, "publickey"))
            writer.uint32(10).string(message.publickey);
        if (message.path != null && Object.hasOwnProperty.call(message, "path"))
            writer.uint32(18).string(message.path);
        if (message.signature != null && Object.hasOwnProperty.call(message, "signature"))
            writer.uint32(26).bytes(message.signature);
        return writer;
    };

    LnurlAuthResp.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    LnurlAuthResp.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.LnurlAuthResp();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.publickey = reader.string();
                break;
            case 2:
                message.path = reader.string();
                break;
            case 3:
                message.signature = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    LnurlAuthResp.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    LnurlAuthResp.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.publickey != null && message.hasOwnProperty("publickey"))
            if (!$util.isString(message.publickey))
                return "publickey: string expected";
        if (message.path != null && message.hasOwnProperty("path"))
            if (!$util.isString(message.path))
                return "path: string expected";
        if (message.signature != null && message.hasOwnProperty("signature"))
            if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
                return "signature: buffer expected";
        return null;
    };

    LnurlAuthResp.fromObject = function fromObject(object) {
        if (object instanceof $root.LnurlAuthResp)
            return object;
        var message = new $root.LnurlAuthResp();
        if (object.publickey != null)
            message.publickey = String(object.publickey);
        if (object.path != null)
            message.path = String(object.path);
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        return message;
    };

    LnurlAuthResp.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.publickey = "";
            object.path = "";
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
        }
        if (message.publickey != null && message.hasOwnProperty("publickey"))
            object.publickey = message.publickey;
        if (message.path != null && message.hasOwnProperty("path"))
            object.path = message.path;
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        return object;
    };

    LnurlAuthResp.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return LnurlAuthResp;
})();

$root.BackupType = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "Bip39"] = 0;
    values[valuesById[1] = "Slip39_Basic"] = 1;
    values[valuesById[2] = "Slip39_Advanced"] = 2;
    return values;
})();

$root.SafetyCheckLevel = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "Strict"] = 0;
    values[valuesById[1] = "PromptAlways"] = 1;
    values[valuesById[2] = "PromptTemporarily"] = 2;
    return values;
})();

$root.Initialize = (function() {

    function Initialize(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    Initialize.prototype.session_id = $util.newBuffer([]);
    Initialize.prototype._skip_passphrase = false;
    Initialize.prototype.derive_cardano = false;
    Initialize.prototype.passphrase_state = "";
    Initialize.prototype.is_contains_attach = false;

    Initialize.create = function create(properties) {
        return new Initialize(properties);
    };

    Initialize.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.session_id != null && Object.hasOwnProperty.call(message, "session_id"))
            writer.uint32(10).bytes(message.session_id);
        if (message._skip_passphrase != null && Object.hasOwnProperty.call(message, "_skip_passphrase"))
            writer.uint32(16).bool(message._skip_passphrase);
        if (message.derive_cardano != null && Object.hasOwnProperty.call(message, "derive_cardano"))
            writer.uint32(24).bool(message.derive_cardano);
        if (message.passphrase_state != null && Object.hasOwnProperty.call(message, "passphrase_state"))
            writer.uint32(64002).string(message.passphrase_state);
        if (message.is_contains_attach != null && Object.hasOwnProperty.call(message, "is_contains_attach"))
            writer.uint32(64008).bool(message.is_contains_attach);
        return writer;
    };

    Initialize.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    Initialize.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Initialize();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.session_id = reader.bytes();
                break;
            case 2:
                message._skip_passphrase = reader.bool();
                break;
            case 3:
                message.derive_cardano = reader.bool();
                break;
            case 8000:
                message.passphrase_state = reader.string();
                break;
            case 8001:
                message.is_contains_attach = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    Initialize.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    Initialize.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.session_id != null && message.hasOwnProperty("session_id"))
            if (!(message.session_id && typeof message.session_id.length === "number" || $util.isString(message.session_id)))
                return "session_id: buffer expected";
        if (message._skip_passphrase != null && message.hasOwnProperty("_skip_passphrase"))
            if (typeof message._skip_passphrase !== "boolean")
                return "_skip_passphrase: boolean expected";
        if (message.derive_cardano != null && message.hasOwnProperty("derive_cardano"))
            if (typeof message.derive_cardano !== "boolean")
                return "derive_cardano: boolean expected";
        if (message.passphrase_state != null && message.hasOwnProperty("passphrase_state"))
            if (!$util.isString(message.passphrase_state))
                return "passphrase_state: string expected";
        if (message.is_contains_attach != null && message.hasOwnProperty("is_contains_attach"))
            if (typeof message.is_contains_attach !== "boolean")
                return "is_contains_attach: boolean expected";
        return null;
    };

    Initialize.fromObject = function fromObject(object) {
        if (object instanceof $root.Initialize)
            return object;
        var message = new $root.Initialize();
        if (object.session_id != null)
            if (typeof object.session_id === "string")
                $util.base64.decode(object.session_id, message.session_id = $util.newBuffer($util.base64.length(object.session_id)), 0);
            else if (object.session_id.length)
                message.session_id = object.session_id;
        if (object._skip_passphrase != null)
            message._skip_passphrase = Boolean(object._skip_passphrase);
        if (object.derive_cardano != null)
            message.derive_cardano = Boolean(object.derive_cardano);
        if (object.passphrase_state != null)
            message.passphrase_state = String(object.passphrase_state);
        if (object.is_contains_attach != null)
            message.is_contains_attach = Boolean(object.is_contains_attach);
        return message;
    };

    Initialize.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.session_id = "";
            else {
                object.session_id = [];
                if (options.bytes !== Array)
                    object.session_id = $util.newBuffer(object.session_id);
            }
            object._skip_passphrase = false;
            object.derive_cardano = false;
            object.passphrase_state = "";
            object.is_contains_attach = false;
        }
        if (message.session_id != null && message.hasOwnProperty("session_id"))
            object.session_id = options.bytes === String ? $util.base64.encode(message.session_id, 0, message.session_id.length) : options.bytes === Array ? Array.prototype.slice.call(message.session_id) : message.session_id;
        if (message._skip_passphrase != null && message.hasOwnProperty("_skip_passphrase"))
            object._skip_passphrase = message._skip_passphrase;
        if (message.derive_cardano != null && message.hasOwnProperty("derive_cardano"))
            object.derive_cardano = message.derive_cardano;
        if (message.passphrase_state != null && message.hasOwnProperty("passphrase_state"))
            object.passphrase_state = message.passphrase_state;
        if (message.is_contains_attach != null && message.hasOwnProperty("is_contains_attach"))
            object.is_contains_attach = message.is_contains_attach;
        return object;
    };

    Initialize.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return Initialize;
})();

$root.GetFeatures = (function() {

    function GetFeatures(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    GetFeatures.create = function create(properties) {
        return new GetFeatures(properties);
    };

    GetFeatures.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    GetFeatures.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    GetFeatures.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.GetFeatures();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    GetFeatures.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    GetFeatures.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    GetFeatures.fromObject = function fromObject(object) {
        if (object instanceof $root.GetFeatures)
            return object;
        return new $root.GetFeatures();
    };

    GetFeatures.toObject = function toObject() {
        return {};
    };

    GetFeatures.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return GetFeatures;
})();

$root.OnekeyGetFeatures = (function() {

    function OnekeyGetFeatures(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    OnekeyGetFeatures.create = function create(properties) {
        return new OnekeyGetFeatures(properties);
    };

    OnekeyGetFeatures.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    OnekeyGetFeatures.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    OnekeyGetFeatures.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.OnekeyGetFeatures();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    OnekeyGetFeatures.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    OnekeyGetFeatures.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    OnekeyGetFeatures.fromObject = function fromObject(object) {
        if (object instanceof $root.OnekeyGetFeatures)
            return object;
        return new $root.OnekeyGetFeatures();
    };

    OnekeyGetFeatures.toObject = function toObject() {
        return {};
    };

    OnekeyGetFeatures.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return OnekeyGetFeatures;
})();

$root.OneKeyDeviceType = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "CLASSIC"] = 0;
    values[valuesById[1] = "CLASSIC1S"] = 1;
    values[valuesById[2] = "MINI"] = 2;
    values[valuesById[3] = "TOUCH"] = 3;
    values[valuesById[5] = "PRO"] = 5;
    values[valuesById[6] = "PURE"] = 6;
    return values;
})();

$root.OneKeySeType = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "THD89"] = 0;
    values[valuesById[1] = "SE608A"] = 1;
    return values;
})();

$root.OneKeySEState = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "BOOT"] = 0;
    values[valuesById[1] = "APP"] = 1;
    return values;
})();

$root.Features = (function() {

    function Features(properties) {
        this.capabilities = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    Features.prototype.vendor = "";
    Features.prototype.major_version = 0;
    Features.prototype.minor_version = 0;
    Features.prototype.patch_version = 0;
    Features.prototype.bootloader_mode = false;
    Features.prototype.device_id = "";
    Features.prototype.pin_protection = false;
    Features.prototype.passphrase_protection = false;
    Features.prototype.language = "";
    Features.prototype.label = "";
    Features.prototype.initialized = false;
    Features.prototype.revision = $util.newBuffer([]);
    Features.prototype.bootloader_hash = $util.newBuffer([]);
    Features.prototype.imported = false;
    Features.prototype.unlocked = false;
    Features.prototype._passphrase_cached = false;
    Features.prototype.firmware_present = false;
    Features.prototype.needs_backup = false;
    Features.prototype.flags = 0;
    Features.prototype.model = "";
    Features.prototype.fw_major = 0;
    Features.prototype.fw_minor = 0;
    Features.prototype.fw_patch = 0;
    Features.prototype.fw_vendor = "";
    Features.prototype.unfinished_backup = false;
    Features.prototype.no_backup = false;
    Features.prototype.recovery_mode = false;
    Features.prototype.capabilities = $util.emptyArray;
    Features.prototype.backup_type = 0;
    Features.prototype.sd_card_present = false;
    Features.prototype.sd_protection = false;
    Features.prototype.wipe_code_protection = false;
    Features.prototype.session_id = $util.newBuffer([]);
    Features.prototype.passphrase_always_on_device = false;
    Features.prototype.safety_checks = 0;
    Features.prototype.auto_lock_delay_ms = 0;
    Features.prototype.display_rotation = 0;
    Features.prototype.experimental_features = false;
    Features.prototype.busy = false;
    Features.prototype.offset = 0;
    Features.prototype.ble_name = "";
    Features.prototype.ble_ver = "";
    Features.prototype.ble_enable = false;
    Features.prototype.se_enable = false;
    Features.prototype.se_ver = "";
    Features.prototype.backup_only = false;
    Features.prototype.onekey_version = "";
    Features.prototype.onekey_serial = "";
    Features.prototype.bootloader_version = "";
    Features.prototype.serial_no = "";
    Features.prototype.spi_flash = "";
    Features.prototype.initstates = 0;
    Features.prototype.NFT_voucher = $util.newBuffer([]);
    Features.prototype.cpu_info = "";
    Features.prototype.pre_firmware = "";
    Features.prototype.coin_switch = 0;
    Features.prototype.build_id = $util.newBuffer([]);
    Features.prototype.boardloader_version = "";
    Features.prototype.battery_level = 0;
    Features.prototype.product = "";
    Features.prototype.brightness_prcent = 0;
    Features.prototype.haptic_feedback = false;
    Features.prototype.auto_shutdown_delay_ms = 0;
    Features.prototype.onekey_device_type = 0;
    Features.prototype.onekey_se_type = 0;
    Features.prototype.onekey_board_version = "";
    Features.prototype.onekey_board_hash = $util.newBuffer([]);
    Features.prototype.onekey_boot_version = "";
    Features.prototype.onekey_boot_hash = $util.newBuffer([]);
    Features.prototype.onekey_se01_version = "";
    Features.prototype.onekey_se01_hash = $util.newBuffer([]);
    Features.prototype.onekey_se01_build_id = "";
    Features.prototype.onekey_firmware_version = "";
    Features.prototype.onekey_firmware_hash = $util.newBuffer([]);
    Features.prototype.onekey_firmware_build_id = "";
    Features.prototype.onekey_serial_no = "";
    Features.prototype.onekey_boot_build_id = "";
    Features.prototype.onekey_ble_name = "";
    Features.prototype.onekey_ble_version = "";
    Features.prototype.onekey_ble_build_id = "";
    Features.prototype.onekey_ble_hash = $util.newBuffer([]);
    Features.prototype.onekey_se02_version = "";
    Features.prototype.onekey_se03_version = "";
    Features.prototype.onekey_se04_version = "";
    Features.prototype.onekey_se01_state = 0;
    Features.prototype.onekey_se02_state = 0;
    Features.prototype.onekey_se03_state = 0;
    Features.prototype.onekey_se04_state = 0;
    Features.prototype.attach_to_pin_user = false;
    Features.prototype.unlocked_attach_pin = false;

    Features.create = function create(properties) {
        return new Features(properties);
    };

    Features.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.vendor != null && Object.hasOwnProperty.call(message, "vendor"))
            writer.uint32(10).string(message.vendor);
        writer.uint32(16).uint32(message.major_version);
        writer.uint32(24).uint32(message.minor_version);
        writer.uint32(32).uint32(message.patch_version);
        if (message.bootloader_mode != null && Object.hasOwnProperty.call(message, "bootloader_mode"))
            writer.uint32(40).bool(message.bootloader_mode);
        if (message.device_id != null && Object.hasOwnProperty.call(message, "device_id"))
            writer.uint32(50).string(message.device_id);
        if (message.pin_protection != null && Object.hasOwnProperty.call(message, "pin_protection"))
            writer.uint32(56).bool(message.pin_protection);
        if (message.passphrase_protection != null && Object.hasOwnProperty.call(message, "passphrase_protection"))
            writer.uint32(64).bool(message.passphrase_protection);
        if (message.language != null && Object.hasOwnProperty.call(message, "language"))
            writer.uint32(74).string(message.language);
        if (message.label != null && Object.hasOwnProperty.call(message, "label"))
            writer.uint32(82).string(message.label);
        if (message.initialized != null && Object.hasOwnProperty.call(message, "initialized"))
            writer.uint32(96).bool(message.initialized);
        if (message.revision != null && Object.hasOwnProperty.call(message, "revision"))
            writer.uint32(106).bytes(message.revision);
        if (message.bootloader_hash != null && Object.hasOwnProperty.call(message, "bootloader_hash"))
            writer.uint32(114).bytes(message.bootloader_hash);
        if (message.imported != null && Object.hasOwnProperty.call(message, "imported"))
            writer.uint32(120).bool(message.imported);
        if (message.unlocked != null && Object.hasOwnProperty.call(message, "unlocked"))
            writer.uint32(128).bool(message.unlocked);
        if (message._passphrase_cached != null && Object.hasOwnProperty.call(message, "_passphrase_cached"))
            writer.uint32(136).bool(message._passphrase_cached);
        if (message.firmware_present != null && Object.hasOwnProperty.call(message, "firmware_present"))
            writer.uint32(144).bool(message.firmware_present);
        if (message.needs_backup != null && Object.hasOwnProperty.call(message, "needs_backup"))
            writer.uint32(152).bool(message.needs_backup);
        if (message.flags != null && Object.hasOwnProperty.call(message, "flags"))
            writer.uint32(160).uint32(message.flags);
        if (message.model != null && Object.hasOwnProperty.call(message, "model"))
            writer.uint32(170).string(message.model);
        if (message.fw_major != null && Object.hasOwnProperty.call(message, "fw_major"))
            writer.uint32(176).uint32(message.fw_major);
        if (message.fw_minor != null && Object.hasOwnProperty.call(message, "fw_minor"))
            writer.uint32(184).uint32(message.fw_minor);
        if (message.fw_patch != null && Object.hasOwnProperty.call(message, "fw_patch"))
            writer.uint32(192).uint32(message.fw_patch);
        if (message.fw_vendor != null && Object.hasOwnProperty.call(message, "fw_vendor"))
            writer.uint32(202).string(message.fw_vendor);
        if (message.unfinished_backup != null && Object.hasOwnProperty.call(message, "unfinished_backup"))
            writer.uint32(216).bool(message.unfinished_backup);
        if (message.no_backup != null && Object.hasOwnProperty.call(message, "no_backup"))
            writer.uint32(224).bool(message.no_backup);
        if (message.recovery_mode != null && Object.hasOwnProperty.call(message, "recovery_mode"))
            writer.uint32(232).bool(message.recovery_mode);
        if (message.capabilities != null && message.capabilities.length)
            for (var i = 0; i < message.capabilities.length; ++i)
                writer.uint32(240).int32(message.capabilities[i]);
        if (message.backup_type != null && Object.hasOwnProperty.call(message, "backup_type"))
            writer.uint32(248).int32(message.backup_type);
        if (message.sd_card_present != null && Object.hasOwnProperty.call(message, "sd_card_present"))
            writer.uint32(256).bool(message.sd_card_present);
        if (message.sd_protection != null && Object.hasOwnProperty.call(message, "sd_protection"))
            writer.uint32(264).bool(message.sd_protection);
        if (message.wipe_code_protection != null && Object.hasOwnProperty.call(message, "wipe_code_protection"))
            writer.uint32(272).bool(message.wipe_code_protection);
        if (message.session_id != null && Object.hasOwnProperty.call(message, "session_id"))
            writer.uint32(282).bytes(message.session_id);
        if (message.passphrase_always_on_device != null && Object.hasOwnProperty.call(message, "passphrase_always_on_device"))
            writer.uint32(288).bool(message.passphrase_always_on_device);
        if (message.safety_checks != null && Object.hasOwnProperty.call(message, "safety_checks"))
            writer.uint32(296).int32(message.safety_checks);
        if (message.auto_lock_delay_ms != null && Object.hasOwnProperty.call(message, "auto_lock_delay_ms"))
            writer.uint32(304).uint32(message.auto_lock_delay_ms);
        if (message.display_rotation != null && Object.hasOwnProperty.call(message, "display_rotation"))
            writer.uint32(312).uint32(message.display_rotation);
        if (message.experimental_features != null && Object.hasOwnProperty.call(message, "experimental_features"))
            writer.uint32(320).bool(message.experimental_features);
        if (message.busy != null && Object.hasOwnProperty.call(message, "busy"))
            writer.uint32(328).bool(message.busy);
        if (message.offset != null && Object.hasOwnProperty.call(message, "offset"))
            writer.uint32(4000).uint32(message.offset);
        if (message.ble_name != null && Object.hasOwnProperty.call(message, "ble_name"))
            writer.uint32(4010).string(message.ble_name);
        if (message.ble_ver != null && Object.hasOwnProperty.call(message, "ble_ver"))
            writer.uint32(4018).string(message.ble_ver);
        if (message.ble_enable != null && Object.hasOwnProperty.call(message, "ble_enable"))
            writer.uint32(4024).bool(message.ble_enable);
        if (message.se_enable != null && Object.hasOwnProperty.call(message, "se_enable"))
            writer.uint32(4032).bool(message.se_enable);
        if (message.se_ver != null && Object.hasOwnProperty.call(message, "se_ver"))
            writer.uint32(4050).string(message.se_ver);
        if (message.backup_only != null && Object.hasOwnProperty.call(message, "backup_only"))
            writer.uint32(4056).bool(message.backup_only);
        if (message.onekey_version != null && Object.hasOwnProperty.call(message, "onekey_version"))
            writer.uint32(4066).string(message.onekey_version);
        if (message.onekey_serial != null && Object.hasOwnProperty.call(message, "onekey_serial"))
            writer.uint32(4074).string(message.onekey_serial);
        if (message.bootloader_version != null && Object.hasOwnProperty.call(message, "bootloader_version"))
            writer.uint32(4082).string(message.bootloader_version);
        if (message.serial_no != null && Object.hasOwnProperty.call(message, "serial_no"))
            writer.uint32(4090).string(message.serial_no);
        if (message.spi_flash != null && Object.hasOwnProperty.call(message, "spi_flash"))
            writer.uint32(4098).string(message.spi_flash);
        if (message.initstates != null && Object.hasOwnProperty.call(message, "initstates"))
            writer.uint32(4104).uint32(message.initstates);
        if (message.NFT_voucher != null && Object.hasOwnProperty.call(message, "NFT_voucher"))
            writer.uint32(4114).bytes(message.NFT_voucher);
        if (message.cpu_info != null && Object.hasOwnProperty.call(message, "cpu_info"))
            writer.uint32(4122).string(message.cpu_info);
        if (message.pre_firmware != null && Object.hasOwnProperty.call(message, "pre_firmware"))
            writer.uint32(4130).string(message.pre_firmware);
        if (message.coin_switch != null && Object.hasOwnProperty.call(message, "coin_switch"))
            writer.uint32(4136).uint32(message.coin_switch);
        if (message.build_id != null && Object.hasOwnProperty.call(message, "build_id"))
            writer.uint32(4146).bytes(message.build_id);
        if (message.boardloader_version != null && Object.hasOwnProperty.call(message, "boardloader_version"))
            writer.uint32(4154).string(message.boardloader_version);
        if (message.battery_level != null && Object.hasOwnProperty.call(message, "battery_level"))
            writer.uint32(4160).uint32(message.battery_level);
        if (message.product != null && Object.hasOwnProperty.call(message, "product"))
            writer.uint32(4170).string(message.product);
        if (message.brightness_prcent != null && Object.hasOwnProperty.call(message, "brightness_prcent"))
            writer.uint32(4176).uint32(message.brightness_prcent);
        if (message.haptic_feedback != null && Object.hasOwnProperty.call(message, "haptic_feedback"))
            writer.uint32(4184).bool(message.haptic_feedback);
        if (message.auto_shutdown_delay_ms != null && Object.hasOwnProperty.call(message, "auto_shutdown_delay_ms"))
            writer.uint32(4192).uint32(message.auto_shutdown_delay_ms);
        if (message.onekey_device_type != null && Object.hasOwnProperty.call(message, "onekey_device_type"))
            writer.uint32(4800).int32(message.onekey_device_type);
        if (message.onekey_se_type != null && Object.hasOwnProperty.call(message, "onekey_se_type"))
            writer.uint32(4808).int32(message.onekey_se_type);
        if (message.onekey_board_version != null && Object.hasOwnProperty.call(message, "onekey_board_version"))
            writer.uint32(4818).string(message.onekey_board_version);
        if (message.onekey_board_hash != null && Object.hasOwnProperty.call(message, "onekey_board_hash"))
            writer.uint32(4826).bytes(message.onekey_board_hash);
        if (message.onekey_boot_version != null && Object.hasOwnProperty.call(message, "onekey_boot_version"))
            writer.uint32(4834).string(message.onekey_boot_version);
        if (message.onekey_boot_hash != null && Object.hasOwnProperty.call(message, "onekey_boot_hash"))
            writer.uint32(4842).bytes(message.onekey_boot_hash);
        if (message.onekey_se01_version != null && Object.hasOwnProperty.call(message, "onekey_se01_version"))
            writer.uint32(4850).string(message.onekey_se01_version);
        if (message.onekey_se01_hash != null && Object.hasOwnProperty.call(message, "onekey_se01_hash"))
            writer.uint32(4858).bytes(message.onekey_se01_hash);
        if (message.onekey_se01_build_id != null && Object.hasOwnProperty.call(message, "onekey_se01_build_id"))
            writer.uint32(4866).string(message.onekey_se01_build_id);
        if (message.onekey_firmware_version != null && Object.hasOwnProperty.call(message, "onekey_firmware_version"))
            writer.uint32(4874).string(message.onekey_firmware_version);
        if (message.onekey_firmware_hash != null && Object.hasOwnProperty.call(message, "onekey_firmware_hash"))
            writer.uint32(4882).bytes(message.onekey_firmware_hash);
        if (message.onekey_firmware_build_id != null && Object.hasOwnProperty.call(message, "onekey_firmware_build_id"))
            writer.uint32(4890).string(message.onekey_firmware_build_id);
        if (message.onekey_serial_no != null && Object.hasOwnProperty.call(message, "onekey_serial_no"))
            writer.uint32(4898).string(message.onekey_serial_no);
        if (message.onekey_boot_build_id != null && Object.hasOwnProperty.call(message, "onekey_boot_build_id"))
            writer.uint32(4906).string(message.onekey_boot_build_id);
        if (message.onekey_ble_name != null && Object.hasOwnProperty.call(message, "onekey_ble_name"))
            writer.uint32(4914).string(message.onekey_ble_name);
        if (message.onekey_ble_version != null && Object.hasOwnProperty.call(message, "onekey_ble_version"))
            writer.uint32(4922).string(message.onekey_ble_version);
        if (message.onekey_ble_build_id != null && Object.hasOwnProperty.call(message, "onekey_ble_build_id"))
            writer.uint32(4930).string(message.onekey_ble_build_id);
        if (message.onekey_ble_hash != null && Object.hasOwnProperty.call(message, "onekey_ble_hash"))
            writer.uint32(4938).bytes(message.onekey_ble_hash);
        if (message.onekey_se02_version != null && Object.hasOwnProperty.call(message, "onekey_se02_version"))
            writer.uint32(4946).string(message.onekey_se02_version);
        if (message.onekey_se03_version != null && Object.hasOwnProperty.call(message, "onekey_se03_version"))
            writer.uint32(4954).string(message.onekey_se03_version);
        if (message.onekey_se04_version != null && Object.hasOwnProperty.call(message, "onekey_se04_version"))
            writer.uint32(4962).string(message.onekey_se04_version);
        if (message.onekey_se01_state != null && Object.hasOwnProperty.call(message, "onekey_se01_state"))
            writer.uint32(4968).int32(message.onekey_se01_state);
        if (message.onekey_se02_state != null && Object.hasOwnProperty.call(message, "onekey_se02_state"))
            writer.uint32(4976).int32(message.onekey_se02_state);
        if (message.onekey_se03_state != null && Object.hasOwnProperty.call(message, "onekey_se03_state"))
            writer.uint32(4984).int32(message.onekey_se03_state);
        if (message.onekey_se04_state != null && Object.hasOwnProperty.call(message, "onekey_se04_state"))
            writer.uint32(4992).int32(message.onekey_se04_state);
        if (message.attach_to_pin_user != null && Object.hasOwnProperty.call(message, "attach_to_pin_user"))
            writer.uint32(5000).bool(message.attach_to_pin_user);
        if (message.unlocked_attach_pin != null && Object.hasOwnProperty.call(message, "unlocked_attach_pin"))
            writer.uint32(5008).bool(message.unlocked_attach_pin);
        return writer;
    };

    Features.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    Features.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Features();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.vendor = reader.string();
                break;
            case 2:
                message.major_version = reader.uint32();
                break;
            case 3:
                message.minor_version = reader.uint32();
                break;
            case 4:
                message.patch_version = reader.uint32();
                break;
            case 5:
                message.bootloader_mode = reader.bool();
                break;
            case 6:
                message.device_id = reader.string();
                break;
            case 7:
                message.pin_protection = reader.bool();
                break;
            case 8:
                message.passphrase_protection = reader.bool();
                break;
            case 9:
                message.language = reader.string();
                break;
            case 10:
                message.label = reader.string();
                break;
            case 12:
                message.initialized = reader.bool();
                break;
            case 13:
                message.revision = reader.bytes();
                break;
            case 14:
                message.bootloader_hash = reader.bytes();
                break;
            case 15:
                message.imported = reader.bool();
                break;
            case 16:
                message.unlocked = reader.bool();
                break;
            case 17:
                message._passphrase_cached = reader.bool();
                break;
            case 18:
                message.firmware_present = reader.bool();
                break;
            case 19:
                message.needs_backup = reader.bool();
                break;
            case 20:
                message.flags = reader.uint32();
                break;
            case 21:
                message.model = reader.string();
                break;
            case 22:
                message.fw_major = reader.uint32();
                break;
            case 23:
                message.fw_minor = reader.uint32();
                break;
            case 24:
                message.fw_patch = reader.uint32();
                break;
            case 25:
                message.fw_vendor = reader.string();
                break;
            case 27:
                message.unfinished_backup = reader.bool();
                break;
            case 28:
                message.no_backup = reader.bool();
                break;
            case 29:
                message.recovery_mode = reader.bool();
                break;
            case 30:
                if (!(message.capabilities && message.capabilities.length))
                    message.capabilities = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.capabilities.push(reader.int32());
                } else
                    message.capabilities.push(reader.int32());
                break;
            case 31:
                message.backup_type = reader.int32();
                break;
            case 32:
                message.sd_card_present = reader.bool();
                break;
            case 33:
                message.sd_protection = reader.bool();
                break;
            case 34:
                message.wipe_code_protection = reader.bool();
                break;
            case 35:
                message.session_id = reader.bytes();
                break;
            case 36:
                message.passphrase_always_on_device = reader.bool();
                break;
            case 37:
                message.safety_checks = reader.int32();
                break;
            case 38:
                message.auto_lock_delay_ms = reader.uint32();
                break;
            case 39:
                message.display_rotation = reader.uint32();
                break;
            case 40:
                message.experimental_features = reader.bool();
                break;
            case 41:
                message.busy = reader.bool();
                break;
            case 500:
                message.offset = reader.uint32();
                break;
            case 501:
                message.ble_name = reader.string();
                break;
            case 502:
                message.ble_ver = reader.string();
                break;
            case 503:
                message.ble_enable = reader.bool();
                break;
            case 504:
                message.se_enable = reader.bool();
                break;
            case 506:
                message.se_ver = reader.string();
                break;
            case 507:
                message.backup_only = reader.bool();
                break;
            case 508:
                message.onekey_version = reader.string();
                break;
            case 509:
                message.onekey_serial = reader.string();
                break;
            case 510:
                message.bootloader_version = reader.string();
                break;
            case 511:
                message.serial_no = reader.string();
                break;
            case 512:
                message.spi_flash = reader.string();
                break;
            case 513:
                message.initstates = reader.uint32();
                break;
            case 514:
                message.NFT_voucher = reader.bytes();
                break;
            case 515:
                message.cpu_info = reader.string();
                break;
            case 516:
                message.pre_firmware = reader.string();
                break;
            case 517:
                message.coin_switch = reader.uint32();
                break;
            case 518:
                message.build_id = reader.bytes();
                break;
            case 519:
                message.boardloader_version = reader.string();
                break;
            case 520:
                message.battery_level = reader.uint32();
                break;
            case 521:
                message.product = reader.string();
                break;
            case 522:
                message.brightness_prcent = reader.uint32();
                break;
            case 523:
                message.haptic_feedback = reader.bool();
                break;
            case 524:
                message.auto_shutdown_delay_ms = reader.uint32();
                break;
            case 600:
                message.onekey_device_type = reader.int32();
                break;
            case 601:
                message.onekey_se_type = reader.int32();
                break;
            case 602:
                message.onekey_board_version = reader.string();
                break;
            case 603:
                message.onekey_board_hash = reader.bytes();
                break;
            case 604:
                message.onekey_boot_version = reader.string();
                break;
            case 605:
                message.onekey_boot_hash = reader.bytes();
                break;
            case 606:
                message.onekey_se01_version = reader.string();
                break;
            case 607:
                message.onekey_se01_hash = reader.bytes();
                break;
            case 608:
                message.onekey_se01_build_id = reader.string();
                break;
            case 609:
                message.onekey_firmware_version = reader.string();
                break;
            case 610:
                message.onekey_firmware_hash = reader.bytes();
                break;
            case 611:
                message.onekey_firmware_build_id = reader.string();
                break;
            case 612:
                message.onekey_serial_no = reader.string();
                break;
            case 613:
                message.onekey_boot_build_id = reader.string();
                break;
            case 614:
                message.onekey_ble_name = reader.string();
                break;
            case 615:
                message.onekey_ble_version = reader.string();
                break;
            case 616:
                message.onekey_ble_build_id = reader.string();
                break;
            case 617:
                message.onekey_ble_hash = reader.bytes();
                break;
            case 618:
                message.onekey_se02_version = reader.string();
                break;
            case 619:
                message.onekey_se03_version = reader.string();
                break;
            case 620:
                message.onekey_se04_version = reader.string();
                break;
            case 621:
                message.onekey_se01_state = reader.int32();
                break;
            case 622:
                message.onekey_se02_state = reader.int32();
                break;
            case 623:
                message.onekey_se03_state = reader.int32();
                break;
            case 624:
                message.onekey_se04_state = reader.int32();
                break;
            case 625:
                message.attach_to_pin_user = reader.bool();
                break;
            case 626:
                message.unlocked_attach_pin = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("major_version"))
            throw $util.ProtocolError("missing required 'major_version'", { instance: message });
        if (!message.hasOwnProperty("minor_version"))
            throw $util.ProtocolError("missing required 'minor_version'", { instance: message });
        if (!message.hasOwnProperty("patch_version"))
            throw $util.ProtocolError("missing required 'patch_version'", { instance: message });
        return message;
    };

    Features.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    Features.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.vendor != null && message.hasOwnProperty("vendor"))
            if (!$util.isString(message.vendor))
                return "vendor: string expected";
        if (!$util.isInteger(message.major_version))
            return "major_version: integer expected";
        if (!$util.isInteger(message.minor_version))
            return "minor_version: integer expected";
        if (!$util.isInteger(message.patch_version))
            return "patch_version: integer expected";
        if (message.bootloader_mode != null && message.hasOwnProperty("bootloader_mode"))
            if (typeof message.bootloader_mode !== "boolean")
                return "bootloader_mode: boolean expected";
        if (message.device_id != null && message.hasOwnProperty("device_id"))
            if (!$util.isString(message.device_id))
                return "device_id: string expected";
        if (message.pin_protection != null && message.hasOwnProperty("pin_protection"))
            if (typeof message.pin_protection !== "boolean")
                return "pin_protection: boolean expected";
        if (message.passphrase_protection != null && message.hasOwnProperty("passphrase_protection"))
            if (typeof message.passphrase_protection !== "boolean")
                return "passphrase_protection: boolean expected";
        if (message.language != null && message.hasOwnProperty("language"))
            if (!$util.isString(message.language))
                return "language: string expected";
        if (message.label != null && message.hasOwnProperty("label"))
            if (!$util.isString(message.label))
                return "label: string expected";
        if (message.initialized != null && message.hasOwnProperty("initialized"))
            if (typeof message.initialized !== "boolean")
                return "initialized: boolean expected";
        if (message.revision != null && message.hasOwnProperty("revision"))
            if (!(message.revision && typeof message.revision.length === "number" || $util.isString(message.revision)))
                return "revision: buffer expected";
        if (message.bootloader_hash != null && message.hasOwnProperty("bootloader_hash"))
            if (!(message.bootloader_hash && typeof message.bootloader_hash.length === "number" || $util.isString(message.bootloader_hash)))
                return "bootloader_hash: buffer expected";
        if (message.imported != null && message.hasOwnProperty("imported"))
            if (typeof message.imported !== "boolean")
                return "imported: boolean expected";
        if (message.unlocked != null && message.hasOwnProperty("unlocked"))
            if (typeof message.unlocked !== "boolean")
                return "unlocked: boolean expected";
        if (message._passphrase_cached != null && message.hasOwnProperty("_passphrase_cached"))
            if (typeof message._passphrase_cached !== "boolean")
                return "_passphrase_cached: boolean expected";
        if (message.firmware_present != null && message.hasOwnProperty("firmware_present"))
            if (typeof message.firmware_present !== "boolean")
                return "firmware_present: boolean expected";
        if (message.needs_backup != null && message.hasOwnProperty("needs_backup"))
            if (typeof message.needs_backup !== "boolean")
                return "needs_backup: boolean expected";
        if (message.flags != null && message.hasOwnProperty("flags"))
            if (!$util.isInteger(message.flags))
                return "flags: integer expected";
        if (message.model != null && message.hasOwnProperty("model"))
            if (!$util.isString(message.model))
                return "model: string expected";
        if (message.fw_major != null && message.hasOwnProperty("fw_major"))
            if (!$util.isInteger(message.fw_major))
                return "fw_major: integer expected";
        if (message.fw_minor != null && message.hasOwnProperty("fw_minor"))
            if (!$util.isInteger(message.fw_minor))
                return "fw_minor: integer expected";
        if (message.fw_patch != null && message.hasOwnProperty("fw_patch"))
            if (!$util.isInteger(message.fw_patch))
                return "fw_patch: integer expected";
        if (message.fw_vendor != null && message.hasOwnProperty("fw_vendor"))
            if (!$util.isString(message.fw_vendor))
                return "fw_vendor: string expected";
        if (message.unfinished_backup != null && message.hasOwnProperty("unfinished_backup"))
            if (typeof message.unfinished_backup !== "boolean")
                return "unfinished_backup: boolean expected";
        if (message.no_backup != null && message.hasOwnProperty("no_backup"))
            if (typeof message.no_backup !== "boolean")
                return "no_backup: boolean expected";
        if (message.recovery_mode != null && message.hasOwnProperty("recovery_mode"))
            if (typeof message.recovery_mode !== "boolean")
                return "recovery_mode: boolean expected";
        if (message.capabilities != null && message.hasOwnProperty("capabilities")) {
            if (!Array.isArray(message.capabilities))
                return "capabilities: array expected";
            for (var i = 0; i < message.capabilities.length; ++i)
                switch (message.capabilities[i]) {
                default:
                    return "capabilities: enum value[] expected";
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 1000:
                case 8000:
                    break;
                }
        }
        if (message.backup_type != null && message.hasOwnProperty("backup_type"))
            switch (message.backup_type) {
            default:
                return "backup_type: enum value expected";
            case 0:
            case 1:
            case 2:
                break;
            }
        if (message.sd_card_present != null && message.hasOwnProperty("sd_card_present"))
            if (typeof message.sd_card_present !== "boolean")
                return "sd_card_present: boolean expected";
        if (message.sd_protection != null && message.hasOwnProperty("sd_protection"))
            if (typeof message.sd_protection !== "boolean")
                return "sd_protection: boolean expected";
        if (message.wipe_code_protection != null && message.hasOwnProperty("wipe_code_protection"))
            if (typeof message.wipe_code_protection !== "boolean")
                return "wipe_code_protection: boolean expected";
        if (message.session_id != null && message.hasOwnProperty("session_id"))
            if (!(message.session_id && typeof message.session_id.length === "number" || $util.isString(message.session_id)))
                return "session_id: buffer expected";
        if (message.passphrase_always_on_device != null && message.hasOwnProperty("passphrase_always_on_device"))
            if (typeof message.passphrase_always_on_device !== "boolean")
                return "passphrase_always_on_device: boolean expected";
        if (message.safety_checks != null && message.hasOwnProperty("safety_checks"))
            switch (message.safety_checks) {
            default:
                return "safety_checks: enum value expected";
            case 0:
            case 1:
            case 2:
                break;
            }
        if (message.auto_lock_delay_ms != null && message.hasOwnProperty("auto_lock_delay_ms"))
            if (!$util.isInteger(message.auto_lock_delay_ms))
                return "auto_lock_delay_ms: integer expected";
        if (message.display_rotation != null && message.hasOwnProperty("display_rotation"))
            if (!$util.isInteger(message.display_rotation))
                return "display_rotation: integer expected";
        if (message.experimental_features != null && message.hasOwnProperty("experimental_features"))
            if (typeof message.experimental_features !== "boolean")
                return "experimental_features: boolean expected";
        if (message.busy != null && message.hasOwnProperty("busy"))
            if (typeof message.busy !== "boolean")
                return "busy: boolean expected";
        if (message.offset != null && message.hasOwnProperty("offset"))
            if (!$util.isInteger(message.offset))
                return "offset: integer expected";
        if (message.ble_name != null && message.hasOwnProperty("ble_name"))
            if (!$util.isString(message.ble_name))
                return "ble_name: string expected";
        if (message.ble_ver != null && message.hasOwnProperty("ble_ver"))
            if (!$util.isString(message.ble_ver))
                return "ble_ver: string expected";
        if (message.ble_enable != null && message.hasOwnProperty("ble_enable"))
            if (typeof message.ble_enable !== "boolean")
                return "ble_enable: boolean expected";
        if (message.se_enable != null && message.hasOwnProperty("se_enable"))
            if (typeof message.se_enable !== "boolean")
                return "se_enable: boolean expected";
        if (message.se_ver != null && message.hasOwnProperty("se_ver"))
            if (!$util.isString(message.se_ver))
                return "se_ver: string expected";
        if (message.backup_only != null && message.hasOwnProperty("backup_only"))
            if (typeof message.backup_only !== "boolean")
                return "backup_only: boolean expected";
        if (message.onekey_version != null && message.hasOwnProperty("onekey_version"))
            if (!$util.isString(message.onekey_version))
                return "onekey_version: string expected";
        if (message.onekey_serial != null && message.hasOwnProperty("onekey_serial"))
            if (!$util.isString(message.onekey_serial))
                return "onekey_serial: string expected";
        if (message.bootloader_version != null && message.hasOwnProperty("bootloader_version"))
            if (!$util.isString(message.bootloader_version))
                return "bootloader_version: string expected";
        if (message.serial_no != null && message.hasOwnProperty("serial_no"))
            if (!$util.isString(message.serial_no))
                return "serial_no: string expected";
        if (message.spi_flash != null && message.hasOwnProperty("spi_flash"))
            if (!$util.isString(message.spi_flash))
                return "spi_flash: string expected";
        if (message.initstates != null && message.hasOwnProperty("initstates"))
            if (!$util.isInteger(message.initstates))
                return "initstates: integer expected";
        if (message.NFT_voucher != null && message.hasOwnProperty("NFT_voucher"))
            if (!(message.NFT_voucher && typeof message.NFT_voucher.length === "number" || $util.isString(message.NFT_voucher)))
                return "NFT_voucher: buffer expected";
        if (message.cpu_info != null && message.hasOwnProperty("cpu_info"))
            if (!$util.isString(message.cpu_info))
                return "cpu_info: string expected";
        if (message.pre_firmware != null && message.hasOwnProperty("pre_firmware"))
            if (!$util.isString(message.pre_firmware))
                return "pre_firmware: string expected";
        if (message.coin_switch != null && message.hasOwnProperty("coin_switch"))
            if (!$util.isInteger(message.coin_switch))
                return "coin_switch: integer expected";
        if (message.build_id != null && message.hasOwnProperty("build_id"))
            if (!(message.build_id && typeof message.build_id.length === "number" || $util.isString(message.build_id)))
                return "build_id: buffer expected";
        if (message.boardloader_version != null && message.hasOwnProperty("boardloader_version"))
            if (!$util.isString(message.boardloader_version))
                return "boardloader_version: string expected";
        if (message.battery_level != null && message.hasOwnProperty("battery_level"))
            if (!$util.isInteger(message.battery_level))
                return "battery_level: integer expected";
        if (message.product != null && message.hasOwnProperty("product"))
            if (!$util.isString(message.product))
                return "product: string expected";
        if (message.brightness_prcent != null && message.hasOwnProperty("brightness_prcent"))
            if (!$util.isInteger(message.brightness_prcent))
                return "brightness_prcent: integer expected";
        if (message.haptic_feedback != null && message.hasOwnProperty("haptic_feedback"))
            if (typeof message.haptic_feedback !== "boolean")
                return "haptic_feedback: boolean expected";
        if (message.auto_shutdown_delay_ms != null && message.hasOwnProperty("auto_shutdown_delay_ms"))
            if (!$util.isInteger(message.auto_shutdown_delay_ms))
                return "auto_shutdown_delay_ms: integer expected";
        if (message.onekey_device_type != null && message.hasOwnProperty("onekey_device_type"))
            switch (message.onekey_device_type) {
            default:
                return "onekey_device_type: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 5:
            case 6:
                break;
            }
        if (message.onekey_se_type != null && message.hasOwnProperty("onekey_se_type"))
            switch (message.onekey_se_type) {
            default:
                return "onekey_se_type: enum value expected";
            case 0:
            case 1:
                break;
            }
        if (message.onekey_board_version != null && message.hasOwnProperty("onekey_board_version"))
            if (!$util.isString(message.onekey_board_version))
                return "onekey_board_version: string expected";
        if (message.onekey_board_hash != null && message.hasOwnProperty("onekey_board_hash"))
            if (!(message.onekey_board_hash && typeof message.onekey_board_hash.length === "number" || $util.isString(message.onekey_board_hash)))
                return "onekey_board_hash: buffer expected";
        if (message.onekey_boot_version != null && message.hasOwnProperty("onekey_boot_version"))
            if (!$util.isString(message.onekey_boot_version))
                return "onekey_boot_version: string expected";
        if (message.onekey_boot_hash != null && message.hasOwnProperty("onekey_boot_hash"))
            if (!(message.onekey_boot_hash && typeof message.onekey_boot_hash.length === "number" || $util.isString(message.onekey_boot_hash)))
                return "onekey_boot_hash: buffer expected";
        if (message.onekey_se01_version != null && message.hasOwnProperty("onekey_se01_version"))
            if (!$util.isString(message.onekey_se01_version))
                return "onekey_se01_version: string expected";
        if (message.onekey_se01_hash != null && message.hasOwnProperty("onekey_se01_hash"))
            if (!(message.onekey_se01_hash && typeof message.onekey_se01_hash.length === "number" || $util.isString(message.onekey_se01_hash)))
                return "onekey_se01_hash: buffer expected";
        if (message.onekey_se01_build_id != null && message.hasOwnProperty("onekey_se01_build_id"))
            if (!$util.isString(message.onekey_se01_build_id))
                return "onekey_se01_build_id: string expected";
        if (message.onekey_firmware_version != null && message.hasOwnProperty("onekey_firmware_version"))
            if (!$util.isString(message.onekey_firmware_version))
                return "onekey_firmware_version: string expected";
        if (message.onekey_firmware_hash != null && message.hasOwnProperty("onekey_firmware_hash"))
            if (!(message.onekey_firmware_hash && typeof message.onekey_firmware_hash.length === "number" || $util.isString(message.onekey_firmware_hash)))
                return "onekey_firmware_hash: buffer expected";
        if (message.onekey_firmware_build_id != null && message.hasOwnProperty("onekey_firmware_build_id"))
            if (!$util.isString(message.onekey_firmware_build_id))
                return "onekey_firmware_build_id: string expected";
        if (message.onekey_serial_no != null && message.hasOwnProperty("onekey_serial_no"))
            if (!$util.isString(message.onekey_serial_no))
                return "onekey_serial_no: string expected";
        if (message.onekey_boot_build_id != null && message.hasOwnProperty("onekey_boot_build_id"))
            if (!$util.isString(message.onekey_boot_build_id))
                return "onekey_boot_build_id: string expected";
        if (message.onekey_ble_name != null && message.hasOwnProperty("onekey_ble_name"))
            if (!$util.isString(message.onekey_ble_name))
                return "onekey_ble_name: string expected";
        if (message.onekey_ble_version != null && message.hasOwnProperty("onekey_ble_version"))
            if (!$util.isString(message.onekey_ble_version))
                return "onekey_ble_version: string expected";
        if (message.onekey_ble_build_id != null && message.hasOwnProperty("onekey_ble_build_id"))
            if (!$util.isString(message.onekey_ble_build_id))
                return "onekey_ble_build_id: string expected";
        if (message.onekey_ble_hash != null && message.hasOwnProperty("onekey_ble_hash"))
            if (!(message.onekey_ble_hash && typeof message.onekey_ble_hash.length === "number" || $util.isString(message.onekey_ble_hash)))
                return "onekey_ble_hash: buffer expected";
        if (message.onekey_se02_version != null && message.hasOwnProperty("onekey_se02_version"))
            if (!$util.isString(message.onekey_se02_version))
                return "onekey_se02_version: string expected";
        if (message.onekey_se03_version != null && message.hasOwnProperty("onekey_se03_version"))
            if (!$util.isString(message.onekey_se03_version))
                return "onekey_se03_version: string expected";
        if (message.onekey_se04_version != null && message.hasOwnProperty("onekey_se04_version"))
            if (!$util.isString(message.onekey_se04_version))
                return "onekey_se04_version: string expected";
        if (message.onekey_se01_state != null && message.hasOwnProperty("onekey_se01_state"))
            switch (message.onekey_se01_state) {
            default:
                return "onekey_se01_state: enum value expected";
            case 0:
            case 1:
                break;
            }
        if (message.onekey_se02_state != null && message.hasOwnProperty("onekey_se02_state"))
            switch (message.onekey_se02_state) {
            default:
                return "onekey_se02_state: enum value expected";
            case 0:
            case 1:
                break;
            }
        if (message.onekey_se03_state != null && message.hasOwnProperty("onekey_se03_state"))
            switch (message.onekey_se03_state) {
            default:
                return "onekey_se03_state: enum value expected";
            case 0:
            case 1:
                break;
            }
        if (message.onekey_se04_state != null && message.hasOwnProperty("onekey_se04_state"))
            switch (message.onekey_se04_state) {
            default:
                return "onekey_se04_state: enum value expected";
            case 0:
            case 1:
                break;
            }
        if (message.attach_to_pin_user != null && message.hasOwnProperty("attach_to_pin_user"))
            if (typeof message.attach_to_pin_user !== "boolean")
                return "attach_to_pin_user: boolean expected";
        if (message.unlocked_attach_pin != null && message.hasOwnProperty("unlocked_attach_pin"))
            if (typeof message.unlocked_attach_pin !== "boolean")
                return "unlocked_attach_pin: boolean expected";
        return null;
    };

    Features.fromObject = function fromObject(object) {
        if (object instanceof $root.Features)
            return object;
        var message = new $root.Features();
        if (object.vendor != null)
            message.vendor = String(object.vendor);
        if (object.major_version != null)
            message.major_version = object.major_version >>> 0;
        if (object.minor_version != null)
            message.minor_version = object.minor_version >>> 0;
        if (object.patch_version != null)
            message.patch_version = object.patch_version >>> 0;
        if (object.bootloader_mode != null)
            message.bootloader_mode = Boolean(object.bootloader_mode);
        if (object.device_id != null)
            message.device_id = String(object.device_id);
        if (object.pin_protection != null)
            message.pin_protection = Boolean(object.pin_protection);
        if (object.passphrase_protection != null)
            message.passphrase_protection = Boolean(object.passphrase_protection);
        if (object.language != null)
            message.language = String(object.language);
        if (object.label != null)
            message.label = String(object.label);
        if (object.initialized != null)
            message.initialized = Boolean(object.initialized);
        if (object.revision != null)
            if (typeof object.revision === "string")
                $util.base64.decode(object.revision, message.revision = $util.newBuffer($util.base64.length(object.revision)), 0);
            else if (object.revision.length)
                message.revision = object.revision;
        if (object.bootloader_hash != null)
            if (typeof object.bootloader_hash === "string")
                $util.base64.decode(object.bootloader_hash, message.bootloader_hash = $util.newBuffer($util.base64.length(object.bootloader_hash)), 0);
            else if (object.bootloader_hash.length)
                message.bootloader_hash = object.bootloader_hash;
        if (object.imported != null)
            message.imported = Boolean(object.imported);
        if (object.unlocked != null)
            message.unlocked = Boolean(object.unlocked);
        if (object._passphrase_cached != null)
            message._passphrase_cached = Boolean(object._passphrase_cached);
        if (object.firmware_present != null)
            message.firmware_present = Boolean(object.firmware_present);
        if (object.needs_backup != null)
            message.needs_backup = Boolean(object.needs_backup);
        if (object.flags != null)
            message.flags = object.flags >>> 0;
        if (object.model != null)
            message.model = String(object.model);
        if (object.fw_major != null)
            message.fw_major = object.fw_major >>> 0;
        if (object.fw_minor != null)
            message.fw_minor = object.fw_minor >>> 0;
        if (object.fw_patch != null)
            message.fw_patch = object.fw_patch >>> 0;
        if (object.fw_vendor != null)
            message.fw_vendor = String(object.fw_vendor);
        if (object.unfinished_backup != null)
            message.unfinished_backup = Boolean(object.unfinished_backup);
        if (object.no_backup != null)
            message.no_backup = Boolean(object.no_backup);
        if (object.recovery_mode != null)
            message.recovery_mode = Boolean(object.recovery_mode);
        if (object.capabilities) {
            if (!Array.isArray(object.capabilities))
                throw TypeError(".Features.capabilities: array expected");
            message.capabilities = [];
            for (var i = 0; i < object.capabilities.length; ++i)
                switch (object.capabilities[i]) {
                default:
                case "Capability_Bitcoin":
                case 1:
                    message.capabilities[i] = 1;
                    break;
                case "Capability_Bitcoin_like":
                case 2:
                    message.capabilities[i] = 2;
                    break;
                case "Capability_Binance":
                case 3:
                    message.capabilities[i] = 3;
                    break;
                case "Capability_Cardano":
                case 4:
                    message.capabilities[i] = 4;
                    break;
                case "Capability_Crypto":
                case 5:
                    message.capabilities[i] = 5;
                    break;
                case "Capability_EOS":
                case 6:
                    message.capabilities[i] = 6;
                    break;
                case "Capability_Ethereum":
                case 7:
                    message.capabilities[i] = 7;
                    break;
                case "Capability_Lisk":
                case 8:
                    message.capabilities[i] = 8;
                    break;
                case "Capability_Monero":
                case 9:
                    message.capabilities[i] = 9;
                    break;
                case "Capability_NEM":
                case 10:
                    message.capabilities[i] = 10;
                    break;
                case "Capability_Ripple":
                case 11:
                    message.capabilities[i] = 11;
                    break;
                case "Capability_Stellar":
                case 12:
                    message.capabilities[i] = 12;
                    break;
                case "Capability_Tezos":
                case 13:
                    message.capabilities[i] = 13;
                    break;
                case "Capability_U2F":
                case 14:
                    message.capabilities[i] = 14;
                    break;
                case "Capability_Shamir":
                case 15:
                    message.capabilities[i] = 15;
                    break;
                case "Capability_ShamirGroups":
                case 16:
                    message.capabilities[i] = 16;
                    break;
                case "Capability_PassphraseEntry":
                case 17:
                    message.capabilities[i] = 17;
                    break;
                case "Capability_EthereumTypedData":
                case 1000:
                    message.capabilities[i] = 1000;
                    break;
                case "Capability_AttachToPin":
                case 8000:
                    message.capabilities[i] = 8000;
                    break;
                }
        }
        switch (object.backup_type) {
        case "Bip39":
        case 0:
            message.backup_type = 0;
            break;
        case "Slip39_Basic":
        case 1:
            message.backup_type = 1;
            break;
        case "Slip39_Advanced":
        case 2:
            message.backup_type = 2;
            break;
        }
        if (object.sd_card_present != null)
            message.sd_card_present = Boolean(object.sd_card_present);
        if (object.sd_protection != null)
            message.sd_protection = Boolean(object.sd_protection);
        if (object.wipe_code_protection != null)
            message.wipe_code_protection = Boolean(object.wipe_code_protection);
        if (object.session_id != null)
            if (typeof object.session_id === "string")
                $util.base64.decode(object.session_id, message.session_id = $util.newBuffer($util.base64.length(object.session_id)), 0);
            else if (object.session_id.length)
                message.session_id = object.session_id;
        if (object.passphrase_always_on_device != null)
            message.passphrase_always_on_device = Boolean(object.passphrase_always_on_device);
        switch (object.safety_checks) {
        case "Strict":
        case 0:
            message.safety_checks = 0;
            break;
        case "PromptAlways":
        case 1:
            message.safety_checks = 1;
            break;
        case "PromptTemporarily":
        case 2:
            message.safety_checks = 2;
            break;
        }
        if (object.auto_lock_delay_ms != null)
            message.auto_lock_delay_ms = object.auto_lock_delay_ms >>> 0;
        if (object.display_rotation != null)
            message.display_rotation = object.display_rotation >>> 0;
        if (object.experimental_features != null)
            message.experimental_features = Boolean(object.experimental_features);
        if (object.busy != null)
            message.busy = Boolean(object.busy);
        if (object.offset != null)
            message.offset = object.offset >>> 0;
        if (object.ble_name != null)
            message.ble_name = String(object.ble_name);
        if (object.ble_ver != null)
            message.ble_ver = String(object.ble_ver);
        if (object.ble_enable != null)
            message.ble_enable = Boolean(object.ble_enable);
        if (object.se_enable != null)
            message.se_enable = Boolean(object.se_enable);
        if (object.se_ver != null)
            message.se_ver = String(object.se_ver);
        if (object.backup_only != null)
            message.backup_only = Boolean(object.backup_only);
        if (object.onekey_version != null)
            message.onekey_version = String(object.onekey_version);
        if (object.onekey_serial != null)
            message.onekey_serial = String(object.onekey_serial);
        if (object.bootloader_version != null)
            message.bootloader_version = String(object.bootloader_version);
        if (object.serial_no != null)
            message.serial_no = String(object.serial_no);
        if (object.spi_flash != null)
            message.spi_flash = String(object.spi_flash);
        if (object.initstates != null)
            message.initstates = object.initstates >>> 0;
        if (object.NFT_voucher != null)
            if (typeof object.NFT_voucher === "string")
                $util.base64.decode(object.NFT_voucher, message.NFT_voucher = $util.newBuffer($util.base64.length(object.NFT_voucher)), 0);
            else if (object.NFT_voucher.length)
                message.NFT_voucher = object.NFT_voucher;
        if (object.cpu_info != null)
            message.cpu_info = String(object.cpu_info);
        if (object.pre_firmware != null)
            message.pre_firmware = String(object.pre_firmware);
        if (object.coin_switch != null)
            message.coin_switch = object.coin_switch >>> 0;
        if (object.build_id != null)
            if (typeof object.build_id === "string")
                $util.base64.decode(object.build_id, message.build_id = $util.newBuffer($util.base64.length(object.build_id)), 0);
            else if (object.build_id.length)
                message.build_id = object.build_id;
        if (object.boardloader_version != null)
            message.boardloader_version = String(object.boardloader_version);
        if (object.battery_level != null)
            message.battery_level = object.battery_level >>> 0;
        if (object.product != null)
            message.product = String(object.product);
        if (object.brightness_prcent != null)
            message.brightness_prcent = object.brightness_prcent >>> 0;
        if (object.haptic_feedback != null)
            message.haptic_feedback = Boolean(object.haptic_feedback);
        if (object.auto_shutdown_delay_ms != null)
            message.auto_shutdown_delay_ms = object.auto_shutdown_delay_ms >>> 0;
        switch (object.onekey_device_type) {
        case "CLASSIC":
        case 0:
            message.onekey_device_type = 0;
            break;
        case "CLASSIC1S":
        case 1:
            message.onekey_device_type = 1;
            break;
        case "MINI":
        case 2:
            message.onekey_device_type = 2;
            break;
        case "TOUCH":
        case 3:
            message.onekey_device_type = 3;
            break;
        case "PRO":
        case 5:
            message.onekey_device_type = 5;
            break;
        case "PURE":
        case 6:
            message.onekey_device_type = 6;
            break;
        }
        switch (object.onekey_se_type) {
        case "THD89":
        case 0:
            message.onekey_se_type = 0;
            break;
        case "SE608A":
        case 1:
            message.onekey_se_type = 1;
            break;
        }
        if (object.onekey_board_version != null)
            message.onekey_board_version = String(object.onekey_board_version);
        if (object.onekey_board_hash != null)
            if (typeof object.onekey_board_hash === "string")
                $util.base64.decode(object.onekey_board_hash, message.onekey_board_hash = $util.newBuffer($util.base64.length(object.onekey_board_hash)), 0);
            else if (object.onekey_board_hash.length)
                message.onekey_board_hash = object.onekey_board_hash;
        if (object.onekey_boot_version != null)
            message.onekey_boot_version = String(object.onekey_boot_version);
        if (object.onekey_boot_hash != null)
            if (typeof object.onekey_boot_hash === "string")
                $util.base64.decode(object.onekey_boot_hash, message.onekey_boot_hash = $util.newBuffer($util.base64.length(object.onekey_boot_hash)), 0);
            else if (object.onekey_boot_hash.length)
                message.onekey_boot_hash = object.onekey_boot_hash;
        if (object.onekey_se01_version != null)
            message.onekey_se01_version = String(object.onekey_se01_version);
        if (object.onekey_se01_hash != null)
            if (typeof object.onekey_se01_hash === "string")
                $util.base64.decode(object.onekey_se01_hash, message.onekey_se01_hash = $util.newBuffer($util.base64.length(object.onekey_se01_hash)), 0);
            else if (object.onekey_se01_hash.length)
                message.onekey_se01_hash = object.onekey_se01_hash;
        if (object.onekey_se01_build_id != null)
            message.onekey_se01_build_id = String(object.onekey_se01_build_id);
        if (object.onekey_firmware_version != null)
            message.onekey_firmware_version = String(object.onekey_firmware_version);
        if (object.onekey_firmware_hash != null)
            if (typeof object.onekey_firmware_hash === "string")
                $util.base64.decode(object.onekey_firmware_hash, message.onekey_firmware_hash = $util.newBuffer($util.base64.length(object.onekey_firmware_hash)), 0);
            else if (object.onekey_firmware_hash.length)
                message.onekey_firmware_hash = object.onekey_firmware_hash;
        if (object.onekey_firmware_build_id != null)
            message.onekey_firmware_build_id = String(object.onekey_firmware_build_id);
        if (object.onekey_serial_no != null)
            message.onekey_serial_no = String(object.onekey_serial_no);
        if (object.onekey_boot_build_id != null)
            message.onekey_boot_build_id = String(object.onekey_boot_build_id);
        if (object.onekey_ble_name != null)
            message.onekey_ble_name = String(object.onekey_ble_name);
        if (object.onekey_ble_version != null)
            message.onekey_ble_version = String(object.onekey_ble_version);
        if (object.onekey_ble_build_id != null)
            message.onekey_ble_build_id = String(object.onekey_ble_build_id);
        if (object.onekey_ble_hash != null)
            if (typeof object.onekey_ble_hash === "string")
                $util.base64.decode(object.onekey_ble_hash, message.onekey_ble_hash = $util.newBuffer($util.base64.length(object.onekey_ble_hash)), 0);
            else if (object.onekey_ble_hash.length)
                message.onekey_ble_hash = object.onekey_ble_hash;
        if (object.onekey_se02_version != null)
            message.onekey_se02_version = String(object.onekey_se02_version);
        if (object.onekey_se03_version != null)
            message.onekey_se03_version = String(object.onekey_se03_version);
        if (object.onekey_se04_version != null)
            message.onekey_se04_version = String(object.onekey_se04_version);
        switch (object.onekey_se01_state) {
        case "BOOT":
        case 0:
            message.onekey_se01_state = 0;
            break;
        case "APP":
        case 1:
            message.onekey_se01_state = 1;
            break;
        }
        switch (object.onekey_se02_state) {
        case "BOOT":
        case 0:
            message.onekey_se02_state = 0;
            break;
        case "APP":
        case 1:
            message.onekey_se02_state = 1;
            break;
        }
        switch (object.onekey_se03_state) {
        case "BOOT":
        case 0:
            message.onekey_se03_state = 0;
            break;
        case "APP":
        case 1:
            message.onekey_se03_state = 1;
            break;
        }
        switch (object.onekey_se04_state) {
        case "BOOT":
        case 0:
            message.onekey_se04_state = 0;
            break;
        case "APP":
        case 1:
            message.onekey_se04_state = 1;
            break;
        }
        if (object.attach_to_pin_user != null)
            message.attach_to_pin_user = Boolean(object.attach_to_pin_user);
        if (object.unlocked_attach_pin != null)
            message.unlocked_attach_pin = Boolean(object.unlocked_attach_pin);
        return message;
    };

    Features.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.capabilities = [];
        if (options.defaults) {
            object.vendor = "";
            object.major_version = 0;
            object.minor_version = 0;
            object.patch_version = 0;
            object.bootloader_mode = false;
            object.device_id = "";
            object.pin_protection = false;
            object.passphrase_protection = false;
            object.language = "";
            object.label = "";
            object.initialized = false;
            if (options.bytes === String)
                object.revision = "";
            else {
                object.revision = [];
                if (options.bytes !== Array)
                    object.revision = $util.newBuffer(object.revision);
            }
            if (options.bytes === String)
                object.bootloader_hash = "";
            else {
                object.bootloader_hash = [];
                if (options.bytes !== Array)
                    object.bootloader_hash = $util.newBuffer(object.bootloader_hash);
            }
            object.imported = false;
            object.unlocked = false;
            object._passphrase_cached = false;
            object.firmware_present = false;
            object.needs_backup = false;
            object.flags = 0;
            object.model = "";
            object.fw_major = 0;
            object.fw_minor = 0;
            object.fw_patch = 0;
            object.fw_vendor = "";
            object.unfinished_backup = false;
            object.no_backup = false;
            object.recovery_mode = false;
            object.backup_type = options.enums === String ? "Bip39" : 0;
            object.sd_card_present = false;
            object.sd_protection = false;
            object.wipe_code_protection = false;
            if (options.bytes === String)
                object.session_id = "";
            else {
                object.session_id = [];
                if (options.bytes !== Array)
                    object.session_id = $util.newBuffer(object.session_id);
            }
            object.passphrase_always_on_device = false;
            object.safety_checks = options.enums === String ? "Strict" : 0;
            object.auto_lock_delay_ms = 0;
            object.display_rotation = 0;
            object.experimental_features = false;
            object.busy = false;
            object.offset = 0;
            object.ble_name = "";
            object.ble_ver = "";
            object.ble_enable = false;
            object.se_enable = false;
            object.se_ver = "";
            object.backup_only = false;
            object.onekey_version = "";
            object.onekey_serial = "";
            object.bootloader_version = "";
            object.serial_no = "";
            object.spi_flash = "";
            object.initstates = 0;
            if (options.bytes === String)
                object.NFT_voucher = "";
            else {
                object.NFT_voucher = [];
                if (options.bytes !== Array)
                    object.NFT_voucher = $util.newBuffer(object.NFT_voucher);
            }
            object.cpu_info = "";
            object.pre_firmware = "";
            object.coin_switch = 0;
            if (options.bytes === String)
                object.build_id = "";
            else {
                object.build_id = [];
                if (options.bytes !== Array)
                    object.build_id = $util.newBuffer(object.build_id);
            }
            object.boardloader_version = "";
            object.battery_level = 0;
            object.product = "";
            object.brightness_prcent = 0;
            object.haptic_feedback = false;
            object.auto_shutdown_delay_ms = 0;
            object.onekey_device_type = options.enums === String ? "CLASSIC" : 0;
            object.onekey_se_type = options.enums === String ? "THD89" : 0;
            object.onekey_board_version = "";
            if (options.bytes === String)
                object.onekey_board_hash = "";
            else {
                object.onekey_board_hash = [];
                if (options.bytes !== Array)
                    object.onekey_board_hash = $util.newBuffer(object.onekey_board_hash);
            }
            object.onekey_boot_version = "";
            if (options.bytes === String)
                object.onekey_boot_hash = "";
            else {
                object.onekey_boot_hash = [];
                if (options.bytes !== Array)
                    object.onekey_boot_hash = $util.newBuffer(object.onekey_boot_hash);
            }
            object.onekey_se01_version = "";
            if (options.bytes === String)
                object.onekey_se01_hash = "";
            else {
                object.onekey_se01_hash = [];
                if (options.bytes !== Array)
                    object.onekey_se01_hash = $util.newBuffer(object.onekey_se01_hash);
            }
            object.onekey_se01_build_id = "";
            object.onekey_firmware_version = "";
            if (options.bytes === String)
                object.onekey_firmware_hash = "";
            else {
                object.onekey_firmware_hash = [];
                if (options.bytes !== Array)
                    object.onekey_firmware_hash = $util.newBuffer(object.onekey_firmware_hash);
            }
            object.onekey_firmware_build_id = "";
            object.onekey_serial_no = "";
            object.onekey_boot_build_id = "";
            object.onekey_ble_name = "";
            object.onekey_ble_version = "";
            object.onekey_ble_build_id = "";
            if (options.bytes === String)
                object.onekey_ble_hash = "";
            else {
                object.onekey_ble_hash = [];
                if (options.bytes !== Array)
                    object.onekey_ble_hash = $util.newBuffer(object.onekey_ble_hash);
            }
            object.onekey_se02_version = "";
            object.onekey_se03_version = "";
            object.onekey_se04_version = "";
            object.onekey_se01_state = options.enums === String ? "BOOT" : 0;
            object.onekey_se02_state = options.enums === String ? "BOOT" : 0;
            object.onekey_se03_state = options.enums === String ? "BOOT" : 0;
            object.onekey_se04_state = options.enums === String ? "BOOT" : 0;
            object.attach_to_pin_user = false;
            object.unlocked_attach_pin = false;
        }
        if (message.vendor != null && message.hasOwnProperty("vendor"))
            object.vendor = message.vendor;
        if (message.major_version != null && message.hasOwnProperty("major_version"))
            object.major_version = message.major_version;
        if (message.minor_version != null && message.hasOwnProperty("minor_version"))
            object.minor_version = message.minor_version;
        if (message.patch_version != null && message.hasOwnProperty("patch_version"))
            object.patch_version = message.patch_version;
        if (message.bootloader_mode != null && message.hasOwnProperty("bootloader_mode"))
            object.bootloader_mode = message.bootloader_mode;
        if (message.device_id != null && message.hasOwnProperty("device_id"))
            object.device_id = message.device_id;
        if (message.pin_protection != null && message.hasOwnProperty("pin_protection"))
            object.pin_protection = message.pin_protection;
        if (message.passphrase_protection != null && message.hasOwnProperty("passphrase_protection"))
            object.passphrase_protection = message.passphrase_protection;
        if (message.language != null && message.hasOwnProperty("language"))
            object.language = message.language;
        if (message.label != null && message.hasOwnProperty("label"))
            object.label = message.label;
        if (message.initialized != null && message.hasOwnProperty("initialized"))
            object.initialized = message.initialized;
        if (message.revision != null && message.hasOwnProperty("revision"))
            object.revision = options.bytes === String ? $util.base64.encode(message.revision, 0, message.revision.length) : options.bytes === Array ? Array.prototype.slice.call(message.revision) : message.revision;
        if (message.bootloader_hash != null && message.hasOwnProperty("bootloader_hash"))
            object.bootloader_hash = options.bytes === String ? $util.base64.encode(message.bootloader_hash, 0, message.bootloader_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.bootloader_hash) : message.bootloader_hash;
        if (message.imported != null && message.hasOwnProperty("imported"))
            object.imported = message.imported;
        if (message.unlocked != null && message.hasOwnProperty("unlocked"))
            object.unlocked = message.unlocked;
        if (message._passphrase_cached != null && message.hasOwnProperty("_passphrase_cached"))
            object._passphrase_cached = message._passphrase_cached;
        if (message.firmware_present != null && message.hasOwnProperty("firmware_present"))
            object.firmware_present = message.firmware_present;
        if (message.needs_backup != null && message.hasOwnProperty("needs_backup"))
            object.needs_backup = message.needs_backup;
        if (message.flags != null && message.hasOwnProperty("flags"))
            object.flags = message.flags;
        if (message.model != null && message.hasOwnProperty("model"))
            object.model = message.model;
        if (message.fw_major != null && message.hasOwnProperty("fw_major"))
            object.fw_major = message.fw_major;
        if (message.fw_minor != null && message.hasOwnProperty("fw_minor"))
            object.fw_minor = message.fw_minor;
        if (message.fw_patch != null && message.hasOwnProperty("fw_patch"))
            object.fw_patch = message.fw_patch;
        if (message.fw_vendor != null && message.hasOwnProperty("fw_vendor"))
            object.fw_vendor = message.fw_vendor;
        if (message.unfinished_backup != null && message.hasOwnProperty("unfinished_backup"))
            object.unfinished_backup = message.unfinished_backup;
        if (message.no_backup != null && message.hasOwnProperty("no_backup"))
            object.no_backup = message.no_backup;
        if (message.recovery_mode != null && message.hasOwnProperty("recovery_mode"))
            object.recovery_mode = message.recovery_mode;
        if (message.capabilities && message.capabilities.length) {
            object.capabilities = [];
            for (var j = 0; j < message.capabilities.length; ++j)
                object.capabilities[j] = options.enums === String ? $root.Features.Capability[message.capabilities[j]] : message.capabilities[j];
        }
        if (message.backup_type != null && message.hasOwnProperty("backup_type"))
            object.backup_type = options.enums === String ? $root.BackupType[message.backup_type] : message.backup_type;
        if (message.sd_card_present != null && message.hasOwnProperty("sd_card_present"))
            object.sd_card_present = message.sd_card_present;
        if (message.sd_protection != null && message.hasOwnProperty("sd_protection"))
            object.sd_protection = message.sd_protection;
        if (message.wipe_code_protection != null && message.hasOwnProperty("wipe_code_protection"))
            object.wipe_code_protection = message.wipe_code_protection;
        if (message.session_id != null && message.hasOwnProperty("session_id"))
            object.session_id = options.bytes === String ? $util.base64.encode(message.session_id, 0, message.session_id.length) : options.bytes === Array ? Array.prototype.slice.call(message.session_id) : message.session_id;
        if (message.passphrase_always_on_device != null && message.hasOwnProperty("passphrase_always_on_device"))
            object.passphrase_always_on_device = message.passphrase_always_on_device;
        if (message.safety_checks != null && message.hasOwnProperty("safety_checks"))
            object.safety_checks = options.enums === String ? $root.SafetyCheckLevel[message.safety_checks] : message.safety_checks;
        if (message.auto_lock_delay_ms != null && message.hasOwnProperty("auto_lock_delay_ms"))
            object.auto_lock_delay_ms = message.auto_lock_delay_ms;
        if (message.display_rotation != null && message.hasOwnProperty("display_rotation"))
            object.display_rotation = message.display_rotation;
        if (message.experimental_features != null && message.hasOwnProperty("experimental_features"))
            object.experimental_features = message.experimental_features;
        if (message.busy != null && message.hasOwnProperty("busy"))
            object.busy = message.busy;
        if (message.offset != null && message.hasOwnProperty("offset"))
            object.offset = message.offset;
        if (message.ble_name != null && message.hasOwnProperty("ble_name"))
            object.ble_name = message.ble_name;
        if (message.ble_ver != null && message.hasOwnProperty("ble_ver"))
            object.ble_ver = message.ble_ver;
        if (message.ble_enable != null && message.hasOwnProperty("ble_enable"))
            object.ble_enable = message.ble_enable;
        if (message.se_enable != null && message.hasOwnProperty("se_enable"))
            object.se_enable = message.se_enable;
        if (message.se_ver != null && message.hasOwnProperty("se_ver"))
            object.se_ver = message.se_ver;
        if (message.backup_only != null && message.hasOwnProperty("backup_only"))
            object.backup_only = message.backup_only;
        if (message.onekey_version != null && message.hasOwnProperty("onekey_version"))
            object.onekey_version = message.onekey_version;
        if (message.onekey_serial != null && message.hasOwnProperty("onekey_serial"))
            object.onekey_serial = message.onekey_serial;
        if (message.bootloader_version != null && message.hasOwnProperty("bootloader_version"))
            object.bootloader_version = message.bootloader_version;
        if (message.serial_no != null && message.hasOwnProperty("serial_no"))
            object.serial_no = message.serial_no;
        if (message.spi_flash != null && message.hasOwnProperty("spi_flash"))
            object.spi_flash = message.spi_flash;
        if (message.initstates != null && message.hasOwnProperty("initstates"))
            object.initstates = message.initstates;
        if (message.NFT_voucher != null && message.hasOwnProperty("NFT_voucher"))
            object.NFT_voucher = options.bytes === String ? $util.base64.encode(message.NFT_voucher, 0, message.NFT_voucher.length) : options.bytes === Array ? Array.prototype.slice.call(message.NFT_voucher) : message.NFT_voucher;
        if (message.cpu_info != null && message.hasOwnProperty("cpu_info"))
            object.cpu_info = message.cpu_info;
        if (message.pre_firmware != null && message.hasOwnProperty("pre_firmware"))
            object.pre_firmware = message.pre_firmware;
        if (message.coin_switch != null && message.hasOwnProperty("coin_switch"))
            object.coin_switch = message.coin_switch;
        if (message.build_id != null && message.hasOwnProperty("build_id"))
            object.build_id = options.bytes === String ? $util.base64.encode(message.build_id, 0, message.build_id.length) : options.bytes === Array ? Array.prototype.slice.call(message.build_id) : message.build_id;
        if (message.boardloader_version != null && message.hasOwnProperty("boardloader_version"))
            object.boardloader_version = message.boardloader_version;
        if (message.battery_level != null && message.hasOwnProperty("battery_level"))
            object.battery_level = message.battery_level;
        if (message.product != null && message.hasOwnProperty("product"))
            object.product = message.product;
        if (message.brightness_prcent != null && message.hasOwnProperty("brightness_prcent"))
            object.brightness_prcent = message.brightness_prcent;
        if (message.haptic_feedback != null && message.hasOwnProperty("haptic_feedback"))
            object.haptic_feedback = message.haptic_feedback;
        if (message.auto_shutdown_delay_ms != null && message.hasOwnProperty("auto_shutdown_delay_ms"))
            object.auto_shutdown_delay_ms = message.auto_shutdown_delay_ms;
        if (message.onekey_device_type != null && message.hasOwnProperty("onekey_device_type"))
            object.onekey_device_type = options.enums === String ? $root.OneKeyDeviceType[message.onekey_device_type] : message.onekey_device_type;
        if (message.onekey_se_type != null && message.hasOwnProperty("onekey_se_type"))
            object.onekey_se_type = options.enums === String ? $root.OneKeySeType[message.onekey_se_type] : message.onekey_se_type;
        if (message.onekey_board_version != null && message.hasOwnProperty("onekey_board_version"))
            object.onekey_board_version = message.onekey_board_version;
        if (message.onekey_board_hash != null && message.hasOwnProperty("onekey_board_hash"))
            object.onekey_board_hash = options.bytes === String ? $util.base64.encode(message.onekey_board_hash, 0, message.onekey_board_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.onekey_board_hash) : message.onekey_board_hash;
        if (message.onekey_boot_version != null && message.hasOwnProperty("onekey_boot_version"))
            object.onekey_boot_version = message.onekey_boot_version;
        if (message.onekey_boot_hash != null && message.hasOwnProperty("onekey_boot_hash"))
            object.onekey_boot_hash = options.bytes === String ? $util.base64.encode(message.onekey_boot_hash, 0, message.onekey_boot_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.onekey_boot_hash) : message.onekey_boot_hash;
        if (message.onekey_se01_version != null && message.hasOwnProperty("onekey_se01_version"))
            object.onekey_se01_version = message.onekey_se01_version;
        if (message.onekey_se01_hash != null && message.hasOwnProperty("onekey_se01_hash"))
            object.onekey_se01_hash = options.bytes === String ? $util.base64.encode(message.onekey_se01_hash, 0, message.onekey_se01_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.onekey_se01_hash) : message.onekey_se01_hash;
        if (message.onekey_se01_build_id != null && message.hasOwnProperty("onekey_se01_build_id"))
            object.onekey_se01_build_id = message.onekey_se01_build_id;
        if (message.onekey_firmware_version != null && message.hasOwnProperty("onekey_firmware_version"))
            object.onekey_firmware_version = message.onekey_firmware_version;
        if (message.onekey_firmware_hash != null && message.hasOwnProperty("onekey_firmware_hash"))
            object.onekey_firmware_hash = options.bytes === String ? $util.base64.encode(message.onekey_firmware_hash, 0, message.onekey_firmware_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.onekey_firmware_hash) : message.onekey_firmware_hash;
        if (message.onekey_firmware_build_id != null && message.hasOwnProperty("onekey_firmware_build_id"))
            object.onekey_firmware_build_id = message.onekey_firmware_build_id;
        if (message.onekey_serial_no != null && message.hasOwnProperty("onekey_serial_no"))
            object.onekey_serial_no = message.onekey_serial_no;
        if (message.onekey_boot_build_id != null && message.hasOwnProperty("onekey_boot_build_id"))
            object.onekey_boot_build_id = message.onekey_boot_build_id;
        if (message.onekey_ble_name != null && message.hasOwnProperty("onekey_ble_name"))
            object.onekey_ble_name = message.onekey_ble_name;
        if (message.onekey_ble_version != null && message.hasOwnProperty("onekey_ble_version"))
            object.onekey_ble_version = message.onekey_ble_version;
        if (message.onekey_ble_build_id != null && message.hasOwnProperty("onekey_ble_build_id"))
            object.onekey_ble_build_id = message.onekey_ble_build_id;
        if (message.onekey_ble_hash != null && message.hasOwnProperty("onekey_ble_hash"))
            object.onekey_ble_hash = options.bytes === String ? $util.base64.encode(message.onekey_ble_hash, 0, message.onekey_ble_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.onekey_ble_hash) : message.onekey_ble_hash;
        if (message.onekey_se02_version != null && message.hasOwnProperty("onekey_se02_version"))
            object.onekey_se02_version = message.onekey_se02_version;
        if (message.onekey_se03_version != null && message.hasOwnProperty("onekey_se03_version"))
            object.onekey_se03_version = message.onekey_se03_version;
        if (message.onekey_se04_version != null && message.hasOwnProperty("onekey_se04_version"))
            object.onekey_se04_version = message.onekey_se04_version;
        if (message.onekey_se01_state != null && message.hasOwnProperty("onekey_se01_state"))
            object.onekey_se01_state = options.enums === String ? $root.OneKeySEState[message.onekey_se01_state] : message.onekey_se01_state;
        if (message.onekey_se02_state != null && message.hasOwnProperty("onekey_se02_state"))
            object.onekey_se02_state = options.enums === String ? $root.OneKeySEState[message.onekey_se02_state] : message.onekey_se02_state;
        if (message.onekey_se03_state != null && message.hasOwnProperty("onekey_se03_state"))
            object.onekey_se03_state = options.enums === String ? $root.OneKeySEState[message.onekey_se03_state] : message.onekey_se03_state;
        if (message.onekey_se04_state != null && message.hasOwnProperty("onekey_se04_state"))
            object.onekey_se04_state = options.enums === String ? $root.OneKeySEState[message.onekey_se04_state] : message.onekey_se04_state;
        if (message.attach_to_pin_user != null && message.hasOwnProperty("attach_to_pin_user"))
            object.attach_to_pin_user = message.attach_to_pin_user;
        if (message.unlocked_attach_pin != null && message.hasOwnProperty("unlocked_attach_pin"))
            object.unlocked_attach_pin = message.unlocked_attach_pin;
        return object;
    };

    Features.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    Features.Capability = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[1] = "Capability_Bitcoin"] = 1;
        values[valuesById[2] = "Capability_Bitcoin_like"] = 2;
        values[valuesById[3] = "Capability_Binance"] = 3;
        values[valuesById[4] = "Capability_Cardano"] = 4;
        values[valuesById[5] = "Capability_Crypto"] = 5;
        values[valuesById[6] = "Capability_EOS"] = 6;
        values[valuesById[7] = "Capability_Ethereum"] = 7;
        values[valuesById[8] = "Capability_Lisk"] = 8;
        values[valuesById[9] = "Capability_Monero"] = 9;
        values[valuesById[10] = "Capability_NEM"] = 10;
        values[valuesById[11] = "Capability_Ripple"] = 11;
        values[valuesById[12] = "Capability_Stellar"] = 12;
        values[valuesById[13] = "Capability_Tezos"] = 13;
        values[valuesById[14] = "Capability_U2F"] = 14;
        values[valuesById[15] = "Capability_Shamir"] = 15;
        values[valuesById[16] = "Capability_ShamirGroups"] = 16;
        values[valuesById[17] = "Capability_PassphraseEntry"] = 17;
        values[valuesById[1000] = "Capability_EthereumTypedData"] = 1000;
        values[valuesById[8000] = "Capability_AttachToPin"] = 8000;
        return values;
    })();

    return Features;
})();

$root.OnekeyFeatures = (function() {

    function OnekeyFeatures(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    OnekeyFeatures.prototype.onekey_device_type = 0;
    OnekeyFeatures.prototype.onekey_board_version = "";
    OnekeyFeatures.prototype.onekey_boot_version = "";
    OnekeyFeatures.prototype.onekey_firmware_version = "";
    OnekeyFeatures.prototype.onekey_board_hash = $util.newBuffer([]);
    OnekeyFeatures.prototype.onekey_boot_hash = $util.newBuffer([]);
    OnekeyFeatures.prototype.onekey_firmware_hash = $util.newBuffer([]);
    OnekeyFeatures.prototype.onekey_board_build_id = "";
    OnekeyFeatures.prototype.onekey_boot_build_id = "";
    OnekeyFeatures.prototype.onekey_firmware_build_id = "";
    OnekeyFeatures.prototype.onekey_serial_no = "";
    OnekeyFeatures.prototype.onekey_ble_name = "";
    OnekeyFeatures.prototype.onekey_ble_version = "";
    OnekeyFeatures.prototype.onekey_ble_build_id = "";
    OnekeyFeatures.prototype.onekey_ble_hash = $util.newBuffer([]);
    OnekeyFeatures.prototype.onekey_se_type = 0;
    OnekeyFeatures.prototype.onekey_se01_state = 0;
    OnekeyFeatures.prototype.onekey_se02_state = 0;
    OnekeyFeatures.prototype.onekey_se03_state = 0;
    OnekeyFeatures.prototype.onekey_se04_state = 0;
    OnekeyFeatures.prototype.onekey_se01_version = "";
    OnekeyFeatures.prototype.onekey_se02_version = "";
    OnekeyFeatures.prototype.onekey_se03_version = "";
    OnekeyFeatures.prototype.onekey_se04_version = "";
    OnekeyFeatures.prototype.onekey_se01_hash = $util.newBuffer([]);
    OnekeyFeatures.prototype.onekey_se02_hash = $util.newBuffer([]);
    OnekeyFeatures.prototype.onekey_se03_hash = $util.newBuffer([]);
    OnekeyFeatures.prototype.onekey_se04_hash = $util.newBuffer([]);
    OnekeyFeatures.prototype.onekey_se01_build_id = "";
    OnekeyFeatures.prototype.onekey_se02_build_id = "";
    OnekeyFeatures.prototype.onekey_se03_build_id = "";
    OnekeyFeatures.prototype.onekey_se04_build_id = "";
    OnekeyFeatures.prototype.onekey_se01_boot_version = "";
    OnekeyFeatures.prototype.onekey_se02_boot_version = "";
    OnekeyFeatures.prototype.onekey_se03_boot_version = "";
    OnekeyFeatures.prototype.onekey_se04_boot_version = "";
    OnekeyFeatures.prototype.onekey_se01_boot_hash = $util.newBuffer([]);
    OnekeyFeatures.prototype.onekey_se02_boot_hash = $util.newBuffer([]);
    OnekeyFeatures.prototype.onekey_se03_boot_hash = $util.newBuffer([]);
    OnekeyFeatures.prototype.onekey_se04_boot_hash = $util.newBuffer([]);
    OnekeyFeatures.prototype.onekey_se01_boot_build_id = "";
    OnekeyFeatures.prototype.onekey_se02_boot_build_id = "";
    OnekeyFeatures.prototype.onekey_se03_boot_build_id = "";
    OnekeyFeatures.prototype.onekey_se04_boot_build_id = "";

    OnekeyFeatures.create = function create(properties) {
        return new OnekeyFeatures(properties);
    };

    OnekeyFeatures.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.onekey_device_type != null && Object.hasOwnProperty.call(message, "onekey_device_type"))
            writer.uint32(8).int32(message.onekey_device_type);
        if (message.onekey_board_version != null && Object.hasOwnProperty.call(message, "onekey_board_version"))
            writer.uint32(18).string(message.onekey_board_version);
        if (message.onekey_boot_version != null && Object.hasOwnProperty.call(message, "onekey_boot_version"))
            writer.uint32(26).string(message.onekey_boot_version);
        if (message.onekey_firmware_version != null && Object.hasOwnProperty.call(message, "onekey_firmware_version"))
            writer.uint32(34).string(message.onekey_firmware_version);
        if (message.onekey_board_hash != null && Object.hasOwnProperty.call(message, "onekey_board_hash"))
            writer.uint32(42).bytes(message.onekey_board_hash);
        if (message.onekey_boot_hash != null && Object.hasOwnProperty.call(message, "onekey_boot_hash"))
            writer.uint32(50).bytes(message.onekey_boot_hash);
        if (message.onekey_firmware_hash != null && Object.hasOwnProperty.call(message, "onekey_firmware_hash"))
            writer.uint32(58).bytes(message.onekey_firmware_hash);
        if (message.onekey_board_build_id != null && Object.hasOwnProperty.call(message, "onekey_board_build_id"))
            writer.uint32(66).string(message.onekey_board_build_id);
        if (message.onekey_boot_build_id != null && Object.hasOwnProperty.call(message, "onekey_boot_build_id"))
            writer.uint32(74).string(message.onekey_boot_build_id);
        if (message.onekey_firmware_build_id != null && Object.hasOwnProperty.call(message, "onekey_firmware_build_id"))
            writer.uint32(82).string(message.onekey_firmware_build_id);
        if (message.onekey_serial_no != null && Object.hasOwnProperty.call(message, "onekey_serial_no"))
            writer.uint32(90).string(message.onekey_serial_no);
        if (message.onekey_ble_name != null && Object.hasOwnProperty.call(message, "onekey_ble_name"))
            writer.uint32(98).string(message.onekey_ble_name);
        if (message.onekey_ble_version != null && Object.hasOwnProperty.call(message, "onekey_ble_version"))
            writer.uint32(106).string(message.onekey_ble_version);
        if (message.onekey_ble_build_id != null && Object.hasOwnProperty.call(message, "onekey_ble_build_id"))
            writer.uint32(114).string(message.onekey_ble_build_id);
        if (message.onekey_ble_hash != null && Object.hasOwnProperty.call(message, "onekey_ble_hash"))
            writer.uint32(122).bytes(message.onekey_ble_hash);
        if (message.onekey_se_type != null && Object.hasOwnProperty.call(message, "onekey_se_type"))
            writer.uint32(128).int32(message.onekey_se_type);
        if (message.onekey_se01_state != null && Object.hasOwnProperty.call(message, "onekey_se01_state"))
            writer.uint32(136).int32(message.onekey_se01_state);
        if (message.onekey_se02_state != null && Object.hasOwnProperty.call(message, "onekey_se02_state"))
            writer.uint32(144).int32(message.onekey_se02_state);
        if (message.onekey_se03_state != null && Object.hasOwnProperty.call(message, "onekey_se03_state"))
            writer.uint32(152).int32(message.onekey_se03_state);
        if (message.onekey_se04_state != null && Object.hasOwnProperty.call(message, "onekey_se04_state"))
            writer.uint32(160).int32(message.onekey_se04_state);
        if (message.onekey_se01_version != null && Object.hasOwnProperty.call(message, "onekey_se01_version"))
            writer.uint32(170).string(message.onekey_se01_version);
        if (message.onekey_se02_version != null && Object.hasOwnProperty.call(message, "onekey_se02_version"))
            writer.uint32(178).string(message.onekey_se02_version);
        if (message.onekey_se03_version != null && Object.hasOwnProperty.call(message, "onekey_se03_version"))
            writer.uint32(186).string(message.onekey_se03_version);
        if (message.onekey_se04_version != null && Object.hasOwnProperty.call(message, "onekey_se04_version"))
            writer.uint32(194).string(message.onekey_se04_version);
        if (message.onekey_se01_hash != null && Object.hasOwnProperty.call(message, "onekey_se01_hash"))
            writer.uint32(202).bytes(message.onekey_se01_hash);
        if (message.onekey_se02_hash != null && Object.hasOwnProperty.call(message, "onekey_se02_hash"))
            writer.uint32(210).bytes(message.onekey_se02_hash);
        if (message.onekey_se03_hash != null && Object.hasOwnProperty.call(message, "onekey_se03_hash"))
            writer.uint32(218).bytes(message.onekey_se03_hash);
        if (message.onekey_se04_hash != null && Object.hasOwnProperty.call(message, "onekey_se04_hash"))
            writer.uint32(226).bytes(message.onekey_se04_hash);
        if (message.onekey_se01_build_id != null && Object.hasOwnProperty.call(message, "onekey_se01_build_id"))
            writer.uint32(234).string(message.onekey_se01_build_id);
        if (message.onekey_se02_build_id != null && Object.hasOwnProperty.call(message, "onekey_se02_build_id"))
            writer.uint32(242).string(message.onekey_se02_build_id);
        if (message.onekey_se03_build_id != null && Object.hasOwnProperty.call(message, "onekey_se03_build_id"))
            writer.uint32(250).string(message.onekey_se03_build_id);
        if (message.onekey_se04_build_id != null && Object.hasOwnProperty.call(message, "onekey_se04_build_id"))
            writer.uint32(258).string(message.onekey_se04_build_id);
        if (message.onekey_se01_boot_version != null && Object.hasOwnProperty.call(message, "onekey_se01_boot_version"))
            writer.uint32(266).string(message.onekey_se01_boot_version);
        if (message.onekey_se02_boot_version != null && Object.hasOwnProperty.call(message, "onekey_se02_boot_version"))
            writer.uint32(274).string(message.onekey_se02_boot_version);
        if (message.onekey_se03_boot_version != null && Object.hasOwnProperty.call(message, "onekey_se03_boot_version"))
            writer.uint32(282).string(message.onekey_se03_boot_version);
        if (message.onekey_se04_boot_version != null && Object.hasOwnProperty.call(message, "onekey_se04_boot_version"))
            writer.uint32(290).string(message.onekey_se04_boot_version);
        if (message.onekey_se01_boot_hash != null && Object.hasOwnProperty.call(message, "onekey_se01_boot_hash"))
            writer.uint32(298).bytes(message.onekey_se01_boot_hash);
        if (message.onekey_se02_boot_hash != null && Object.hasOwnProperty.call(message, "onekey_se02_boot_hash"))
            writer.uint32(306).bytes(message.onekey_se02_boot_hash);
        if (message.onekey_se03_boot_hash != null && Object.hasOwnProperty.call(message, "onekey_se03_boot_hash"))
            writer.uint32(314).bytes(message.onekey_se03_boot_hash);
        if (message.onekey_se04_boot_hash != null && Object.hasOwnProperty.call(message, "onekey_se04_boot_hash"))
            writer.uint32(322).bytes(message.onekey_se04_boot_hash);
        if (message.onekey_se01_boot_build_id != null && Object.hasOwnProperty.call(message, "onekey_se01_boot_build_id"))
            writer.uint32(330).string(message.onekey_se01_boot_build_id);
        if (message.onekey_se02_boot_build_id != null && Object.hasOwnProperty.call(message, "onekey_se02_boot_build_id"))
            writer.uint32(338).string(message.onekey_se02_boot_build_id);
        if (message.onekey_se03_boot_build_id != null && Object.hasOwnProperty.call(message, "onekey_se03_boot_build_id"))
            writer.uint32(346).string(message.onekey_se03_boot_build_id);
        if (message.onekey_se04_boot_build_id != null && Object.hasOwnProperty.call(message, "onekey_se04_boot_build_id"))
            writer.uint32(354).string(message.onekey_se04_boot_build_id);
        return writer;
    };

    OnekeyFeatures.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    OnekeyFeatures.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.OnekeyFeatures();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.onekey_device_type = reader.int32();
                break;
            case 2:
                message.onekey_board_version = reader.string();
                break;
            case 3:
                message.onekey_boot_version = reader.string();
                break;
            case 4:
                message.onekey_firmware_version = reader.string();
                break;
            case 5:
                message.onekey_board_hash = reader.bytes();
                break;
            case 6:
                message.onekey_boot_hash = reader.bytes();
                break;
            case 7:
                message.onekey_firmware_hash = reader.bytes();
                break;
            case 8:
                message.onekey_board_build_id = reader.string();
                break;
            case 9:
                message.onekey_boot_build_id = reader.string();
                break;
            case 10:
                message.onekey_firmware_build_id = reader.string();
                break;
            case 11:
                message.onekey_serial_no = reader.string();
                break;
            case 12:
                message.onekey_ble_name = reader.string();
                break;
            case 13:
                message.onekey_ble_version = reader.string();
                break;
            case 14:
                message.onekey_ble_build_id = reader.string();
                break;
            case 15:
                message.onekey_ble_hash = reader.bytes();
                break;
            case 16:
                message.onekey_se_type = reader.int32();
                break;
            case 17:
                message.onekey_se01_state = reader.int32();
                break;
            case 18:
                message.onekey_se02_state = reader.int32();
                break;
            case 19:
                message.onekey_se03_state = reader.int32();
                break;
            case 20:
                message.onekey_se04_state = reader.int32();
                break;
            case 21:
                message.onekey_se01_version = reader.string();
                break;
            case 22:
                message.onekey_se02_version = reader.string();
                break;
            case 23:
                message.onekey_se03_version = reader.string();
                break;
            case 24:
                message.onekey_se04_version = reader.string();
                break;
            case 25:
                message.onekey_se01_hash = reader.bytes();
                break;
            case 26:
                message.onekey_se02_hash = reader.bytes();
                break;
            case 27:
                message.onekey_se03_hash = reader.bytes();
                break;
            case 28:
                message.onekey_se04_hash = reader.bytes();
                break;
            case 29:
                message.onekey_se01_build_id = reader.string();
                break;
            case 30:
                message.onekey_se02_build_id = reader.string();
                break;
            case 31:
                message.onekey_se03_build_id = reader.string();
                break;
            case 32:
                message.onekey_se04_build_id = reader.string();
                break;
            case 33:
                message.onekey_se01_boot_version = reader.string();
                break;
            case 34:
                message.onekey_se02_boot_version = reader.string();
                break;
            case 35:
                message.onekey_se03_boot_version = reader.string();
                break;
            case 36:
                message.onekey_se04_boot_version = reader.string();
                break;
            case 37:
                message.onekey_se01_boot_hash = reader.bytes();
                break;
            case 38:
                message.onekey_se02_boot_hash = reader.bytes();
                break;
            case 39:
                message.onekey_se03_boot_hash = reader.bytes();
                break;
            case 40:
                message.onekey_se04_boot_hash = reader.bytes();
                break;
            case 41:
                message.onekey_se01_boot_build_id = reader.string();
                break;
            case 42:
                message.onekey_se02_boot_build_id = reader.string();
                break;
            case 43:
                message.onekey_se03_boot_build_id = reader.string();
                break;
            case 44:
                message.onekey_se04_boot_build_id = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    OnekeyFeatures.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    OnekeyFeatures.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.onekey_device_type != null && message.hasOwnProperty("onekey_device_type"))
            switch (message.onekey_device_type) {
            default:
                return "onekey_device_type: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 5:
            case 6:
                break;
            }
        if (message.onekey_board_version != null && message.hasOwnProperty("onekey_board_version"))
            if (!$util.isString(message.onekey_board_version))
                return "onekey_board_version: string expected";
        if (message.onekey_boot_version != null && message.hasOwnProperty("onekey_boot_version"))
            if (!$util.isString(message.onekey_boot_version))
                return "onekey_boot_version: string expected";
        if (message.onekey_firmware_version != null && message.hasOwnProperty("onekey_firmware_version"))
            if (!$util.isString(message.onekey_firmware_version))
                return "onekey_firmware_version: string expected";
        if (message.onekey_board_hash != null && message.hasOwnProperty("onekey_board_hash"))
            if (!(message.onekey_board_hash && typeof message.onekey_board_hash.length === "number" || $util.isString(message.onekey_board_hash)))
                return "onekey_board_hash: buffer expected";
        if (message.onekey_boot_hash != null && message.hasOwnProperty("onekey_boot_hash"))
            if (!(message.onekey_boot_hash && typeof message.onekey_boot_hash.length === "number" || $util.isString(message.onekey_boot_hash)))
                return "onekey_boot_hash: buffer expected";
        if (message.onekey_firmware_hash != null && message.hasOwnProperty("onekey_firmware_hash"))
            if (!(message.onekey_firmware_hash && typeof message.onekey_firmware_hash.length === "number" || $util.isString(message.onekey_firmware_hash)))
                return "onekey_firmware_hash: buffer expected";
        if (message.onekey_board_build_id != null && message.hasOwnProperty("onekey_board_build_id"))
            if (!$util.isString(message.onekey_board_build_id))
                return "onekey_board_build_id: string expected";
        if (message.onekey_boot_build_id != null && message.hasOwnProperty("onekey_boot_build_id"))
            if (!$util.isString(message.onekey_boot_build_id))
                return "onekey_boot_build_id: string expected";
        if (message.onekey_firmware_build_id != null && message.hasOwnProperty("onekey_firmware_build_id"))
            if (!$util.isString(message.onekey_firmware_build_id))
                return "onekey_firmware_build_id: string expected";
        if (message.onekey_serial_no != null && message.hasOwnProperty("onekey_serial_no"))
            if (!$util.isString(message.onekey_serial_no))
                return "onekey_serial_no: string expected";
        if (message.onekey_ble_name != null && message.hasOwnProperty("onekey_ble_name"))
            if (!$util.isString(message.onekey_ble_name))
                return "onekey_ble_name: string expected";
        if (message.onekey_ble_version != null && message.hasOwnProperty("onekey_ble_version"))
            if (!$util.isString(message.onekey_ble_version))
                return "onekey_ble_version: string expected";
        if (message.onekey_ble_build_id != null && message.hasOwnProperty("onekey_ble_build_id"))
            if (!$util.isString(message.onekey_ble_build_id))
                return "onekey_ble_build_id: string expected";
        if (message.onekey_ble_hash != null && message.hasOwnProperty("onekey_ble_hash"))
            if (!(message.onekey_ble_hash && typeof message.onekey_ble_hash.length === "number" || $util.isString(message.onekey_ble_hash)))
                return "onekey_ble_hash: buffer expected";
        if (message.onekey_se_type != null && message.hasOwnProperty("onekey_se_type"))
            switch (message.onekey_se_type) {
            default:
                return "onekey_se_type: enum value expected";
            case 0:
            case 1:
                break;
            }
        if (message.onekey_se01_state != null && message.hasOwnProperty("onekey_se01_state"))
            switch (message.onekey_se01_state) {
            default:
                return "onekey_se01_state: enum value expected";
            case 0:
            case 1:
                break;
            }
        if (message.onekey_se02_state != null && message.hasOwnProperty("onekey_se02_state"))
            switch (message.onekey_se02_state) {
            default:
                return "onekey_se02_state: enum value expected";
            case 0:
            case 1:
                break;
            }
        if (message.onekey_se03_state != null && message.hasOwnProperty("onekey_se03_state"))
            switch (message.onekey_se03_state) {
            default:
                return "onekey_se03_state: enum value expected";
            case 0:
            case 1:
                break;
            }
        if (message.onekey_se04_state != null && message.hasOwnProperty("onekey_se04_state"))
            switch (message.onekey_se04_state) {
            default:
                return "onekey_se04_state: enum value expected";
            case 0:
            case 1:
                break;
            }
        if (message.onekey_se01_version != null && message.hasOwnProperty("onekey_se01_version"))
            if (!$util.isString(message.onekey_se01_version))
                return "onekey_se01_version: string expected";
        if (message.onekey_se02_version != null && message.hasOwnProperty("onekey_se02_version"))
            if (!$util.isString(message.onekey_se02_version))
                return "onekey_se02_version: string expected";
        if (message.onekey_se03_version != null && message.hasOwnProperty("onekey_se03_version"))
            if (!$util.isString(message.onekey_se03_version))
                return "onekey_se03_version: string expected";
        if (message.onekey_se04_version != null && message.hasOwnProperty("onekey_se04_version"))
            if (!$util.isString(message.onekey_se04_version))
                return "onekey_se04_version: string expected";
        if (message.onekey_se01_hash != null && message.hasOwnProperty("onekey_se01_hash"))
            if (!(message.onekey_se01_hash && typeof message.onekey_se01_hash.length === "number" || $util.isString(message.onekey_se01_hash)))
                return "onekey_se01_hash: buffer expected";
        if (message.onekey_se02_hash != null && message.hasOwnProperty("onekey_se02_hash"))
            if (!(message.onekey_se02_hash && typeof message.onekey_se02_hash.length === "number" || $util.isString(message.onekey_se02_hash)))
                return "onekey_se02_hash: buffer expected";
        if (message.onekey_se03_hash != null && message.hasOwnProperty("onekey_se03_hash"))
            if (!(message.onekey_se03_hash && typeof message.onekey_se03_hash.length === "number" || $util.isString(message.onekey_se03_hash)))
                return "onekey_se03_hash: buffer expected";
        if (message.onekey_se04_hash != null && message.hasOwnProperty("onekey_se04_hash"))
            if (!(message.onekey_se04_hash && typeof message.onekey_se04_hash.length === "number" || $util.isString(message.onekey_se04_hash)))
                return "onekey_se04_hash: buffer expected";
        if (message.onekey_se01_build_id != null && message.hasOwnProperty("onekey_se01_build_id"))
            if (!$util.isString(message.onekey_se01_build_id))
                return "onekey_se01_build_id: string expected";
        if (message.onekey_se02_build_id != null && message.hasOwnProperty("onekey_se02_build_id"))
            if (!$util.isString(message.onekey_se02_build_id))
                return "onekey_se02_build_id: string expected";
        if (message.onekey_se03_build_id != null && message.hasOwnProperty("onekey_se03_build_id"))
            if (!$util.isString(message.onekey_se03_build_id))
                return "onekey_se03_build_id: string expected";
        if (message.onekey_se04_build_id != null && message.hasOwnProperty("onekey_se04_build_id"))
            if (!$util.isString(message.onekey_se04_build_id))
                return "onekey_se04_build_id: string expected";
        if (message.onekey_se01_boot_version != null && message.hasOwnProperty("onekey_se01_boot_version"))
            if (!$util.isString(message.onekey_se01_boot_version))
                return "onekey_se01_boot_version: string expected";
        if (message.onekey_se02_boot_version != null && message.hasOwnProperty("onekey_se02_boot_version"))
            if (!$util.isString(message.onekey_se02_boot_version))
                return "onekey_se02_boot_version: string expected";
        if (message.onekey_se03_boot_version != null && message.hasOwnProperty("onekey_se03_boot_version"))
            if (!$util.isString(message.onekey_se03_boot_version))
                return "onekey_se03_boot_version: string expected";
        if (message.onekey_se04_boot_version != null && message.hasOwnProperty("onekey_se04_boot_version"))
            if (!$util.isString(message.onekey_se04_boot_version))
                return "onekey_se04_boot_version: string expected";
        if (message.onekey_se01_boot_hash != null && message.hasOwnProperty("onekey_se01_boot_hash"))
            if (!(message.onekey_se01_boot_hash && typeof message.onekey_se01_boot_hash.length === "number" || $util.isString(message.onekey_se01_boot_hash)))
                return "onekey_se01_boot_hash: buffer expected";
        if (message.onekey_se02_boot_hash != null && message.hasOwnProperty("onekey_se02_boot_hash"))
            if (!(message.onekey_se02_boot_hash && typeof message.onekey_se02_boot_hash.length === "number" || $util.isString(message.onekey_se02_boot_hash)))
                return "onekey_se02_boot_hash: buffer expected";
        if (message.onekey_se03_boot_hash != null && message.hasOwnProperty("onekey_se03_boot_hash"))
            if (!(message.onekey_se03_boot_hash && typeof message.onekey_se03_boot_hash.length === "number" || $util.isString(message.onekey_se03_boot_hash)))
                return "onekey_se03_boot_hash: buffer expected";
        if (message.onekey_se04_boot_hash != null && message.hasOwnProperty("onekey_se04_boot_hash"))
            if (!(message.onekey_se04_boot_hash && typeof message.onekey_se04_boot_hash.length === "number" || $util.isString(message.onekey_se04_boot_hash)))
                return "onekey_se04_boot_hash: buffer expected";
        if (message.onekey_se01_boot_build_id != null && message.hasOwnProperty("onekey_se01_boot_build_id"))
            if (!$util.isString(message.onekey_se01_boot_build_id))
                return "onekey_se01_boot_build_id: string expected";
        if (message.onekey_se02_boot_build_id != null && message.hasOwnProperty("onekey_se02_boot_build_id"))
            if (!$util.isString(message.onekey_se02_boot_build_id))
                return "onekey_se02_boot_build_id: string expected";
        if (message.onekey_se03_boot_build_id != null && message.hasOwnProperty("onekey_se03_boot_build_id"))
            if (!$util.isString(message.onekey_se03_boot_build_id))
                return "onekey_se03_boot_build_id: string expected";
        if (message.onekey_se04_boot_build_id != null && message.hasOwnProperty("onekey_se04_boot_build_id"))
            if (!$util.isString(message.onekey_se04_boot_build_id))
                return "onekey_se04_boot_build_id: string expected";
        return null;
    };

    OnekeyFeatures.fromObject = function fromObject(object) {
        if (object instanceof $root.OnekeyFeatures)
            return object;
        var message = new $root.OnekeyFeatures();
        switch (object.onekey_device_type) {
        case "CLASSIC":
        case 0:
            message.onekey_device_type = 0;
            break;
        case "CLASSIC1S":
        case 1:
            message.onekey_device_type = 1;
            break;
        case "MINI":
        case 2:
            message.onekey_device_type = 2;
            break;
        case "TOUCH":
        case 3:
            message.onekey_device_type = 3;
            break;
        case "PRO":
        case 5:
            message.onekey_device_type = 5;
            break;
        case "PURE":
        case 6:
            message.onekey_device_type = 6;
            break;
        }
        if (object.onekey_board_version != null)
            message.onekey_board_version = String(object.onekey_board_version);
        if (object.onekey_boot_version != null)
            message.onekey_boot_version = String(object.onekey_boot_version);
        if (object.onekey_firmware_version != null)
            message.onekey_firmware_version = String(object.onekey_firmware_version);
        if (object.onekey_board_hash != null)
            if (typeof object.onekey_board_hash === "string")
                $util.base64.decode(object.onekey_board_hash, message.onekey_board_hash = $util.newBuffer($util.base64.length(object.onekey_board_hash)), 0);
            else if (object.onekey_board_hash.length)
                message.onekey_board_hash = object.onekey_board_hash;
        if (object.onekey_boot_hash != null)
            if (typeof object.onekey_boot_hash === "string")
                $util.base64.decode(object.onekey_boot_hash, message.onekey_boot_hash = $util.newBuffer($util.base64.length(object.onekey_boot_hash)), 0);
            else if (object.onekey_boot_hash.length)
                message.onekey_boot_hash = object.onekey_boot_hash;
        if (object.onekey_firmware_hash != null)
            if (typeof object.onekey_firmware_hash === "string")
                $util.base64.decode(object.onekey_firmware_hash, message.onekey_firmware_hash = $util.newBuffer($util.base64.length(object.onekey_firmware_hash)), 0);
            else if (object.onekey_firmware_hash.length)
                message.onekey_firmware_hash = object.onekey_firmware_hash;
        if (object.onekey_board_build_id != null)
            message.onekey_board_build_id = String(object.onekey_board_build_id);
        if (object.onekey_boot_build_id != null)
            message.onekey_boot_build_id = String(object.onekey_boot_build_id);
        if (object.onekey_firmware_build_id != null)
            message.onekey_firmware_build_id = String(object.onekey_firmware_build_id);
        if (object.onekey_serial_no != null)
            message.onekey_serial_no = String(object.onekey_serial_no);
        if (object.onekey_ble_name != null)
            message.onekey_ble_name = String(object.onekey_ble_name);
        if (object.onekey_ble_version != null)
            message.onekey_ble_version = String(object.onekey_ble_version);
        if (object.onekey_ble_build_id != null)
            message.onekey_ble_build_id = String(object.onekey_ble_build_id);
        if (object.onekey_ble_hash != null)
            if (typeof object.onekey_ble_hash === "string")
                $util.base64.decode(object.onekey_ble_hash, message.onekey_ble_hash = $util.newBuffer($util.base64.length(object.onekey_ble_hash)), 0);
            else if (object.onekey_ble_hash.length)
                message.onekey_ble_hash = object.onekey_ble_hash;
        switch (object.onekey_se_type) {
        case "THD89":
        case 0:
            message.onekey_se_type = 0;
            break;
        case "SE608A":
        case 1:
            message.onekey_se_type = 1;
            break;
        }
        switch (object.onekey_se01_state) {
        case "BOOT":
        case 0:
            message.onekey_se01_state = 0;
            break;
        case "APP":
        case 1:
            message.onekey_se01_state = 1;
            break;
        }
        switch (object.onekey_se02_state) {
        case "BOOT":
        case 0:
            message.onekey_se02_state = 0;
            break;
        case "APP":
        case 1:
            message.onekey_se02_state = 1;
            break;
        }
        switch (object.onekey_se03_state) {
        case "BOOT":
        case 0:
            message.onekey_se03_state = 0;
            break;
        case "APP":
        case 1:
            message.onekey_se03_state = 1;
            break;
        }
        switch (object.onekey_se04_state) {
        case "BOOT":
        case 0:
            message.onekey_se04_state = 0;
            break;
        case "APP":
        case 1:
            message.onekey_se04_state = 1;
            break;
        }
        if (object.onekey_se01_version != null)
            message.onekey_se01_version = String(object.onekey_se01_version);
        if (object.onekey_se02_version != null)
            message.onekey_se02_version = String(object.onekey_se02_version);
        if (object.onekey_se03_version != null)
            message.onekey_se03_version = String(object.onekey_se03_version);
        if (object.onekey_se04_version != null)
            message.onekey_se04_version = String(object.onekey_se04_version);
        if (object.onekey_se01_hash != null)
            if (typeof object.onekey_se01_hash === "string")
                $util.base64.decode(object.onekey_se01_hash, message.onekey_se01_hash = $util.newBuffer($util.base64.length(object.onekey_se01_hash)), 0);
            else if (object.onekey_se01_hash.length)
                message.onekey_se01_hash = object.onekey_se01_hash;
        if (object.onekey_se02_hash != null)
            if (typeof object.onekey_se02_hash === "string")
                $util.base64.decode(object.onekey_se02_hash, message.onekey_se02_hash = $util.newBuffer($util.base64.length(object.onekey_se02_hash)), 0);
            else if (object.onekey_se02_hash.length)
                message.onekey_se02_hash = object.onekey_se02_hash;
        if (object.onekey_se03_hash != null)
            if (typeof object.onekey_se03_hash === "string")
                $util.base64.decode(object.onekey_se03_hash, message.onekey_se03_hash = $util.newBuffer($util.base64.length(object.onekey_se03_hash)), 0);
            else if (object.onekey_se03_hash.length)
                message.onekey_se03_hash = object.onekey_se03_hash;
        if (object.onekey_se04_hash != null)
            if (typeof object.onekey_se04_hash === "string")
                $util.base64.decode(object.onekey_se04_hash, message.onekey_se04_hash = $util.newBuffer($util.base64.length(object.onekey_se04_hash)), 0);
            else if (object.onekey_se04_hash.length)
                message.onekey_se04_hash = object.onekey_se04_hash;
        if (object.onekey_se01_build_id != null)
            message.onekey_se01_build_id = String(object.onekey_se01_build_id);
        if (object.onekey_se02_build_id != null)
            message.onekey_se02_build_id = String(object.onekey_se02_build_id);
        if (object.onekey_se03_build_id != null)
            message.onekey_se03_build_id = String(object.onekey_se03_build_id);
        if (object.onekey_se04_build_id != null)
            message.onekey_se04_build_id = String(object.onekey_se04_build_id);
        if (object.onekey_se01_boot_version != null)
            message.onekey_se01_boot_version = String(object.onekey_se01_boot_version);
        if (object.onekey_se02_boot_version != null)
            message.onekey_se02_boot_version = String(object.onekey_se02_boot_version);
        if (object.onekey_se03_boot_version != null)
            message.onekey_se03_boot_version = String(object.onekey_se03_boot_version);
        if (object.onekey_se04_boot_version != null)
            message.onekey_se04_boot_version = String(object.onekey_se04_boot_version);
        if (object.onekey_se01_boot_hash != null)
            if (typeof object.onekey_se01_boot_hash === "string")
                $util.base64.decode(object.onekey_se01_boot_hash, message.onekey_se01_boot_hash = $util.newBuffer($util.base64.length(object.onekey_se01_boot_hash)), 0);
            else if (object.onekey_se01_boot_hash.length)
                message.onekey_se01_boot_hash = object.onekey_se01_boot_hash;
        if (object.onekey_se02_boot_hash != null)
            if (typeof object.onekey_se02_boot_hash === "string")
                $util.base64.decode(object.onekey_se02_boot_hash, message.onekey_se02_boot_hash = $util.newBuffer($util.base64.length(object.onekey_se02_boot_hash)), 0);
            else if (object.onekey_se02_boot_hash.length)
                message.onekey_se02_boot_hash = object.onekey_se02_boot_hash;
        if (object.onekey_se03_boot_hash != null)
            if (typeof object.onekey_se03_boot_hash === "string")
                $util.base64.decode(object.onekey_se03_boot_hash, message.onekey_se03_boot_hash = $util.newBuffer($util.base64.length(object.onekey_se03_boot_hash)), 0);
            else if (object.onekey_se03_boot_hash.length)
                message.onekey_se03_boot_hash = object.onekey_se03_boot_hash;
        if (object.onekey_se04_boot_hash != null)
            if (typeof object.onekey_se04_boot_hash === "string")
                $util.base64.decode(object.onekey_se04_boot_hash, message.onekey_se04_boot_hash = $util.newBuffer($util.base64.length(object.onekey_se04_boot_hash)), 0);
            else if (object.onekey_se04_boot_hash.length)
                message.onekey_se04_boot_hash = object.onekey_se04_boot_hash;
        if (object.onekey_se01_boot_build_id != null)
            message.onekey_se01_boot_build_id = String(object.onekey_se01_boot_build_id);
        if (object.onekey_se02_boot_build_id != null)
            message.onekey_se02_boot_build_id = String(object.onekey_se02_boot_build_id);
        if (object.onekey_se03_boot_build_id != null)
            message.onekey_se03_boot_build_id = String(object.onekey_se03_boot_build_id);
        if (object.onekey_se04_boot_build_id != null)
            message.onekey_se04_boot_build_id = String(object.onekey_se04_boot_build_id);
        return message;
    };

    OnekeyFeatures.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.onekey_device_type = options.enums === String ? "CLASSIC" : 0;
            object.onekey_board_version = "";
            object.onekey_boot_version = "";
            object.onekey_firmware_version = "";
            if (options.bytes === String)
                object.onekey_board_hash = "";
            else {
                object.onekey_board_hash = [];
                if (options.bytes !== Array)
                    object.onekey_board_hash = $util.newBuffer(object.onekey_board_hash);
            }
            if (options.bytes === String)
                object.onekey_boot_hash = "";
            else {
                object.onekey_boot_hash = [];
                if (options.bytes !== Array)
                    object.onekey_boot_hash = $util.newBuffer(object.onekey_boot_hash);
            }
            if (options.bytes === String)
                object.onekey_firmware_hash = "";
            else {
                object.onekey_firmware_hash = [];
                if (options.bytes !== Array)
                    object.onekey_firmware_hash = $util.newBuffer(object.onekey_firmware_hash);
            }
            object.onekey_board_build_id = "";
            object.onekey_boot_build_id = "";
            object.onekey_firmware_build_id = "";
            object.onekey_serial_no = "";
            object.onekey_ble_name = "";
            object.onekey_ble_version = "";
            object.onekey_ble_build_id = "";
            if (options.bytes === String)
                object.onekey_ble_hash = "";
            else {
                object.onekey_ble_hash = [];
                if (options.bytes !== Array)
                    object.onekey_ble_hash = $util.newBuffer(object.onekey_ble_hash);
            }
            object.onekey_se_type = options.enums === String ? "THD89" : 0;
            object.onekey_se01_state = options.enums === String ? "BOOT" : 0;
            object.onekey_se02_state = options.enums === String ? "BOOT" : 0;
            object.onekey_se03_state = options.enums === String ? "BOOT" : 0;
            object.onekey_se04_state = options.enums === String ? "BOOT" : 0;
            object.onekey_se01_version = "";
            object.onekey_se02_version = "";
            object.onekey_se03_version = "";
            object.onekey_se04_version = "";
            if (options.bytes === String)
                object.onekey_se01_hash = "";
            else {
                object.onekey_se01_hash = [];
                if (options.bytes !== Array)
                    object.onekey_se01_hash = $util.newBuffer(object.onekey_se01_hash);
            }
            if (options.bytes === String)
                object.onekey_se02_hash = "";
            else {
                object.onekey_se02_hash = [];
                if (options.bytes !== Array)
                    object.onekey_se02_hash = $util.newBuffer(object.onekey_se02_hash);
            }
            if (options.bytes === String)
                object.onekey_se03_hash = "";
            else {
                object.onekey_se03_hash = [];
                if (options.bytes !== Array)
                    object.onekey_se03_hash = $util.newBuffer(object.onekey_se03_hash);
            }
            if (options.bytes === String)
                object.onekey_se04_hash = "";
            else {
                object.onekey_se04_hash = [];
                if (options.bytes !== Array)
                    object.onekey_se04_hash = $util.newBuffer(object.onekey_se04_hash);
            }
            object.onekey_se01_build_id = "";
            object.onekey_se02_build_id = "";
            object.onekey_se03_build_id = "";
            object.onekey_se04_build_id = "";
            object.onekey_se01_boot_version = "";
            object.onekey_se02_boot_version = "";
            object.onekey_se03_boot_version = "";
            object.onekey_se04_boot_version = "";
            if (options.bytes === String)
                object.onekey_se01_boot_hash = "";
            else {
                object.onekey_se01_boot_hash = [];
                if (options.bytes !== Array)
                    object.onekey_se01_boot_hash = $util.newBuffer(object.onekey_se01_boot_hash);
            }
            if (options.bytes === String)
                object.onekey_se02_boot_hash = "";
            else {
                object.onekey_se02_boot_hash = [];
                if (options.bytes !== Array)
                    object.onekey_se02_boot_hash = $util.newBuffer(object.onekey_se02_boot_hash);
            }
            if (options.bytes === String)
                object.onekey_se03_boot_hash = "";
            else {
                object.onekey_se03_boot_hash = [];
                if (options.bytes !== Array)
                    object.onekey_se03_boot_hash = $util.newBuffer(object.onekey_se03_boot_hash);
            }
            if (options.bytes === String)
                object.onekey_se04_boot_hash = "";
            else {
                object.onekey_se04_boot_hash = [];
                if (options.bytes !== Array)
                    object.onekey_se04_boot_hash = $util.newBuffer(object.onekey_se04_boot_hash);
            }
            object.onekey_se01_boot_build_id = "";
            object.onekey_se02_boot_build_id = "";
            object.onekey_se03_boot_build_id = "";
            object.onekey_se04_boot_build_id = "";
        }
        if (message.onekey_device_type != null && message.hasOwnProperty("onekey_device_type"))
            object.onekey_device_type = options.enums === String ? $root.OneKeyDeviceType[message.onekey_device_type] : message.onekey_device_type;
        if (message.onekey_board_version != null && message.hasOwnProperty("onekey_board_version"))
            object.onekey_board_version = message.onekey_board_version;
        if (message.onekey_boot_version != null && message.hasOwnProperty("onekey_boot_version"))
            object.onekey_boot_version = message.onekey_boot_version;
        if (message.onekey_firmware_version != null && message.hasOwnProperty("onekey_firmware_version"))
            object.onekey_firmware_version = message.onekey_firmware_version;
        if (message.onekey_board_hash != null && message.hasOwnProperty("onekey_board_hash"))
            object.onekey_board_hash = options.bytes === String ? $util.base64.encode(message.onekey_board_hash, 0, message.onekey_board_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.onekey_board_hash) : message.onekey_board_hash;
        if (message.onekey_boot_hash != null && message.hasOwnProperty("onekey_boot_hash"))
            object.onekey_boot_hash = options.bytes === String ? $util.base64.encode(message.onekey_boot_hash, 0, message.onekey_boot_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.onekey_boot_hash) : message.onekey_boot_hash;
        if (message.onekey_firmware_hash != null && message.hasOwnProperty("onekey_firmware_hash"))
            object.onekey_firmware_hash = options.bytes === String ? $util.base64.encode(message.onekey_firmware_hash, 0, message.onekey_firmware_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.onekey_firmware_hash) : message.onekey_firmware_hash;
        if (message.onekey_board_build_id != null && message.hasOwnProperty("onekey_board_build_id"))
            object.onekey_board_build_id = message.onekey_board_build_id;
        if (message.onekey_boot_build_id != null && message.hasOwnProperty("onekey_boot_build_id"))
            object.onekey_boot_build_id = message.onekey_boot_build_id;
        if (message.onekey_firmware_build_id != null && message.hasOwnProperty("onekey_firmware_build_id"))
            object.onekey_firmware_build_id = message.onekey_firmware_build_id;
        if (message.onekey_serial_no != null && message.hasOwnProperty("onekey_serial_no"))
            object.onekey_serial_no = message.onekey_serial_no;
        if (message.onekey_ble_name != null && message.hasOwnProperty("onekey_ble_name"))
            object.onekey_ble_name = message.onekey_ble_name;
        if (message.onekey_ble_version != null && message.hasOwnProperty("onekey_ble_version"))
            object.onekey_ble_version = message.onekey_ble_version;
        if (message.onekey_ble_build_id != null && message.hasOwnProperty("onekey_ble_build_id"))
            object.onekey_ble_build_id = message.onekey_ble_build_id;
        if (message.onekey_ble_hash != null && message.hasOwnProperty("onekey_ble_hash"))
            object.onekey_ble_hash = options.bytes === String ? $util.base64.encode(message.onekey_ble_hash, 0, message.onekey_ble_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.onekey_ble_hash) : message.onekey_ble_hash;
        if (message.onekey_se_type != null && message.hasOwnProperty("onekey_se_type"))
            object.onekey_se_type = options.enums === String ? $root.OneKeySeType[message.onekey_se_type] : message.onekey_se_type;
        if (message.onekey_se01_state != null && message.hasOwnProperty("onekey_se01_state"))
            object.onekey_se01_state = options.enums === String ? $root.OneKeySEState[message.onekey_se01_state] : message.onekey_se01_state;
        if (message.onekey_se02_state != null && message.hasOwnProperty("onekey_se02_state"))
            object.onekey_se02_state = options.enums === String ? $root.OneKeySEState[message.onekey_se02_state] : message.onekey_se02_state;
        if (message.onekey_se03_state != null && message.hasOwnProperty("onekey_se03_state"))
            object.onekey_se03_state = options.enums === String ? $root.OneKeySEState[message.onekey_se03_state] : message.onekey_se03_state;
        if (message.onekey_se04_state != null && message.hasOwnProperty("onekey_se04_state"))
            object.onekey_se04_state = options.enums === String ? $root.OneKeySEState[message.onekey_se04_state] : message.onekey_se04_state;
        if (message.onekey_se01_version != null && message.hasOwnProperty("onekey_se01_version"))
            object.onekey_se01_version = message.onekey_se01_version;
        if (message.onekey_se02_version != null && message.hasOwnProperty("onekey_se02_version"))
            object.onekey_se02_version = message.onekey_se02_version;
        if (message.onekey_se03_version != null && message.hasOwnProperty("onekey_se03_version"))
            object.onekey_se03_version = message.onekey_se03_version;
        if (message.onekey_se04_version != null && message.hasOwnProperty("onekey_se04_version"))
            object.onekey_se04_version = message.onekey_se04_version;
        if (message.onekey_se01_hash != null && message.hasOwnProperty("onekey_se01_hash"))
            object.onekey_se01_hash = options.bytes === String ? $util.base64.encode(message.onekey_se01_hash, 0, message.onekey_se01_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.onekey_se01_hash) : message.onekey_se01_hash;
        if (message.onekey_se02_hash != null && message.hasOwnProperty("onekey_se02_hash"))
            object.onekey_se02_hash = options.bytes === String ? $util.base64.encode(message.onekey_se02_hash, 0, message.onekey_se02_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.onekey_se02_hash) : message.onekey_se02_hash;
        if (message.onekey_se03_hash != null && message.hasOwnProperty("onekey_se03_hash"))
            object.onekey_se03_hash = options.bytes === String ? $util.base64.encode(message.onekey_se03_hash, 0, message.onekey_se03_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.onekey_se03_hash) : message.onekey_se03_hash;
        if (message.onekey_se04_hash != null && message.hasOwnProperty("onekey_se04_hash"))
            object.onekey_se04_hash = options.bytes === String ? $util.base64.encode(message.onekey_se04_hash, 0, message.onekey_se04_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.onekey_se04_hash) : message.onekey_se04_hash;
        if (message.onekey_se01_build_id != null && message.hasOwnProperty("onekey_se01_build_id"))
            object.onekey_se01_build_id = message.onekey_se01_build_id;
        if (message.onekey_se02_build_id != null && message.hasOwnProperty("onekey_se02_build_id"))
            object.onekey_se02_build_id = message.onekey_se02_build_id;
        if (message.onekey_se03_build_id != null && message.hasOwnProperty("onekey_se03_build_id"))
            object.onekey_se03_build_id = message.onekey_se03_build_id;
        if (message.onekey_se04_build_id != null && message.hasOwnProperty("onekey_se04_build_id"))
            object.onekey_se04_build_id = message.onekey_se04_build_id;
        if (message.onekey_se01_boot_version != null && message.hasOwnProperty("onekey_se01_boot_version"))
            object.onekey_se01_boot_version = message.onekey_se01_boot_version;
        if (message.onekey_se02_boot_version != null && message.hasOwnProperty("onekey_se02_boot_version"))
            object.onekey_se02_boot_version = message.onekey_se02_boot_version;
        if (message.onekey_se03_boot_version != null && message.hasOwnProperty("onekey_se03_boot_version"))
            object.onekey_se03_boot_version = message.onekey_se03_boot_version;
        if (message.onekey_se04_boot_version != null && message.hasOwnProperty("onekey_se04_boot_version"))
            object.onekey_se04_boot_version = message.onekey_se04_boot_version;
        if (message.onekey_se01_boot_hash != null && message.hasOwnProperty("onekey_se01_boot_hash"))
            object.onekey_se01_boot_hash = options.bytes === String ? $util.base64.encode(message.onekey_se01_boot_hash, 0, message.onekey_se01_boot_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.onekey_se01_boot_hash) : message.onekey_se01_boot_hash;
        if (message.onekey_se02_boot_hash != null && message.hasOwnProperty("onekey_se02_boot_hash"))
            object.onekey_se02_boot_hash = options.bytes === String ? $util.base64.encode(message.onekey_se02_boot_hash, 0, message.onekey_se02_boot_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.onekey_se02_boot_hash) : message.onekey_se02_boot_hash;
        if (message.onekey_se03_boot_hash != null && message.hasOwnProperty("onekey_se03_boot_hash"))
            object.onekey_se03_boot_hash = options.bytes === String ? $util.base64.encode(message.onekey_se03_boot_hash, 0, message.onekey_se03_boot_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.onekey_se03_boot_hash) : message.onekey_se03_boot_hash;
        if (message.onekey_se04_boot_hash != null && message.hasOwnProperty("onekey_se04_boot_hash"))
            object.onekey_se04_boot_hash = options.bytes === String ? $util.base64.encode(message.onekey_se04_boot_hash, 0, message.onekey_se04_boot_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.onekey_se04_boot_hash) : message.onekey_se04_boot_hash;
        if (message.onekey_se01_boot_build_id != null && message.hasOwnProperty("onekey_se01_boot_build_id"))
            object.onekey_se01_boot_build_id = message.onekey_se01_boot_build_id;
        if (message.onekey_se02_boot_build_id != null && message.hasOwnProperty("onekey_se02_boot_build_id"))
            object.onekey_se02_boot_build_id = message.onekey_se02_boot_build_id;
        if (message.onekey_se03_boot_build_id != null && message.hasOwnProperty("onekey_se03_boot_build_id"))
            object.onekey_se03_boot_build_id = message.onekey_se03_boot_build_id;
        if (message.onekey_se04_boot_build_id != null && message.hasOwnProperty("onekey_se04_boot_build_id"))
            object.onekey_se04_boot_build_id = message.onekey_se04_boot_build_id;
        return object;
    };

    OnekeyFeatures.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return OnekeyFeatures;
})();

$root.LockDevice = (function() {

    function LockDevice(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    LockDevice.create = function create(properties) {
        return new LockDevice(properties);
    };

    LockDevice.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    LockDevice.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    LockDevice.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.LockDevice();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    LockDevice.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    LockDevice.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    LockDevice.fromObject = function fromObject(object) {
        if (object instanceof $root.LockDevice)
            return object;
        return new $root.LockDevice();
    };

    LockDevice.toObject = function toObject() {
        return {};
    };

    LockDevice.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return LockDevice;
})();

$root.EndSession = (function() {

    function EndSession(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EndSession.create = function create(properties) {
        return new EndSession(properties);
    };

    EndSession.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    EndSession.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EndSession.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EndSession();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    EndSession.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EndSession.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    EndSession.fromObject = function fromObject(object) {
        if (object instanceof $root.EndSession)
            return object;
        return new $root.EndSession();
    };

    EndSession.toObject = function toObject() {
        return {};
    };

    EndSession.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EndSession;
})();

$root.ApplySettings = (function() {

    function ApplySettings(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ApplySettings.prototype.language = "";
    ApplySettings.prototype.label = "";
    ApplySettings.prototype.use_passphrase = false;
    ApplySettings.prototype.homescreen = $util.newBuffer([]);
    ApplySettings.prototype._passphrase_source = 0;
    ApplySettings.prototype.auto_lock_delay_ms = 0;
    ApplySettings.prototype.display_rotation = 0;
    ApplySettings.prototype.passphrase_always_on_device = false;
    ApplySettings.prototype.safety_checks = 0;
    ApplySettings.prototype.experimental_features = false;
    ApplySettings.prototype.use_ble = false;
    ApplySettings.prototype.use_se = false;
    ApplySettings.prototype.is_bixinapp = false;
    ApplySettings.prototype.fastpay_pin = false;
    ApplySettings.prototype.fastpay_confirm = false;
    ApplySettings.prototype.fastpay_money_limit = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    ApplySettings.prototype.fastpay_times = 0;
    ApplySettings.prototype.auto_shutdown_delay_ms = 0;
    ApplySettings.prototype.change_brightness = false;
    ApplySettings.prototype.haptic_feedback = false;

    ApplySettings.create = function create(properties) {
        return new ApplySettings(properties);
    };

    ApplySettings.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.language != null && Object.hasOwnProperty.call(message, "language"))
            writer.uint32(10).string(message.language);
        if (message.label != null && Object.hasOwnProperty.call(message, "label"))
            writer.uint32(18).string(message.label);
        if (message.use_passphrase != null && Object.hasOwnProperty.call(message, "use_passphrase"))
            writer.uint32(24).bool(message.use_passphrase);
        if (message.homescreen != null && Object.hasOwnProperty.call(message, "homescreen"))
            writer.uint32(34).bytes(message.homescreen);
        if (message._passphrase_source != null && Object.hasOwnProperty.call(message, "_passphrase_source"))
            writer.uint32(40).uint32(message._passphrase_source);
        if (message.auto_lock_delay_ms != null && Object.hasOwnProperty.call(message, "auto_lock_delay_ms"))
            writer.uint32(48).uint32(message.auto_lock_delay_ms);
        if (message.display_rotation != null && Object.hasOwnProperty.call(message, "display_rotation"))
            writer.uint32(56).uint32(message.display_rotation);
        if (message.passphrase_always_on_device != null && Object.hasOwnProperty.call(message, "passphrase_always_on_device"))
            writer.uint32(64).bool(message.passphrase_always_on_device);
        if (message.safety_checks != null && Object.hasOwnProperty.call(message, "safety_checks"))
            writer.uint32(72).int32(message.safety_checks);
        if (message.experimental_features != null && Object.hasOwnProperty.call(message, "experimental_features"))
            writer.uint32(80).bool(message.experimental_features);
        if (message.use_ble != null && Object.hasOwnProperty.call(message, "use_ble"))
            writer.uint32(800).bool(message.use_ble);
        if (message.use_se != null && Object.hasOwnProperty.call(message, "use_se"))
            writer.uint32(808).bool(message.use_se);
        if (message.is_bixinapp != null && Object.hasOwnProperty.call(message, "is_bixinapp"))
            writer.uint32(816).bool(message.is_bixinapp);
        if (message.fastpay_pin != null && Object.hasOwnProperty.call(message, "fastpay_pin"))
            writer.uint32(824).bool(message.fastpay_pin);
        if (message.fastpay_confirm != null && Object.hasOwnProperty.call(message, "fastpay_confirm"))
            writer.uint32(832).bool(message.fastpay_confirm);
        if (message.fastpay_money_limit != null && Object.hasOwnProperty.call(message, "fastpay_money_limit"))
            writer.uint32(840).uint64(message.fastpay_money_limit);
        if (message.fastpay_times != null && Object.hasOwnProperty.call(message, "fastpay_times"))
            writer.uint32(848).uint32(message.fastpay_times);
        if (message.auto_shutdown_delay_ms != null && Object.hasOwnProperty.call(message, "auto_shutdown_delay_ms"))
            writer.uint32(4000).uint32(message.auto_shutdown_delay_ms);
        if (message.change_brightness != null && Object.hasOwnProperty.call(message, "change_brightness"))
            writer.uint32(4008).bool(message.change_brightness);
        if (message.haptic_feedback != null && Object.hasOwnProperty.call(message, "haptic_feedback"))
            writer.uint32(4016).bool(message.haptic_feedback);
        return writer;
    };

    ApplySettings.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ApplySettings.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ApplySettings();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.language = reader.string();
                break;
            case 2:
                message.label = reader.string();
                break;
            case 3:
                message.use_passphrase = reader.bool();
                break;
            case 4:
                message.homescreen = reader.bytes();
                break;
            case 5:
                message._passphrase_source = reader.uint32();
                break;
            case 6:
                message.auto_lock_delay_ms = reader.uint32();
                break;
            case 7:
                message.display_rotation = reader.uint32();
                break;
            case 8:
                message.passphrase_always_on_device = reader.bool();
                break;
            case 9:
                message.safety_checks = reader.int32();
                break;
            case 10:
                message.experimental_features = reader.bool();
                break;
            case 100:
                message.use_ble = reader.bool();
                break;
            case 101:
                message.use_se = reader.bool();
                break;
            case 102:
                message.is_bixinapp = reader.bool();
                break;
            case 103:
                message.fastpay_pin = reader.bool();
                break;
            case 104:
                message.fastpay_confirm = reader.bool();
                break;
            case 105:
                message.fastpay_money_limit = reader.uint64();
                break;
            case 106:
                message.fastpay_times = reader.uint32();
                break;
            case 500:
                message.auto_shutdown_delay_ms = reader.uint32();
                break;
            case 501:
                message.change_brightness = reader.bool();
                break;
            case 502:
                message.haptic_feedback = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    ApplySettings.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ApplySettings.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.language != null && message.hasOwnProperty("language"))
            if (!$util.isString(message.language))
                return "language: string expected";
        if (message.label != null && message.hasOwnProperty("label"))
            if (!$util.isString(message.label))
                return "label: string expected";
        if (message.use_passphrase != null && message.hasOwnProperty("use_passphrase"))
            if (typeof message.use_passphrase !== "boolean")
                return "use_passphrase: boolean expected";
        if (message.homescreen != null && message.hasOwnProperty("homescreen"))
            if (!(message.homescreen && typeof message.homescreen.length === "number" || $util.isString(message.homescreen)))
                return "homescreen: buffer expected";
        if (message._passphrase_source != null && message.hasOwnProperty("_passphrase_source"))
            if (!$util.isInteger(message._passphrase_source))
                return "_passphrase_source: integer expected";
        if (message.auto_lock_delay_ms != null && message.hasOwnProperty("auto_lock_delay_ms"))
            if (!$util.isInteger(message.auto_lock_delay_ms))
                return "auto_lock_delay_ms: integer expected";
        if (message.display_rotation != null && message.hasOwnProperty("display_rotation"))
            if (!$util.isInteger(message.display_rotation))
                return "display_rotation: integer expected";
        if (message.passphrase_always_on_device != null && message.hasOwnProperty("passphrase_always_on_device"))
            if (typeof message.passphrase_always_on_device !== "boolean")
                return "passphrase_always_on_device: boolean expected";
        if (message.safety_checks != null && message.hasOwnProperty("safety_checks"))
            switch (message.safety_checks) {
            default:
                return "safety_checks: enum value expected";
            case 0:
            case 1:
            case 2:
                break;
            }
        if (message.experimental_features != null && message.hasOwnProperty("experimental_features"))
            if (typeof message.experimental_features !== "boolean")
                return "experimental_features: boolean expected";
        if (message.use_ble != null && message.hasOwnProperty("use_ble"))
            if (typeof message.use_ble !== "boolean")
                return "use_ble: boolean expected";
        if (message.use_se != null && message.hasOwnProperty("use_se"))
            if (typeof message.use_se !== "boolean")
                return "use_se: boolean expected";
        if (message.is_bixinapp != null && message.hasOwnProperty("is_bixinapp"))
            if (typeof message.is_bixinapp !== "boolean")
                return "is_bixinapp: boolean expected";
        if (message.fastpay_pin != null && message.hasOwnProperty("fastpay_pin"))
            if (typeof message.fastpay_pin !== "boolean")
                return "fastpay_pin: boolean expected";
        if (message.fastpay_confirm != null && message.hasOwnProperty("fastpay_confirm"))
            if (typeof message.fastpay_confirm !== "boolean")
                return "fastpay_confirm: boolean expected";
        if (message.fastpay_money_limit != null && message.hasOwnProperty("fastpay_money_limit"))
            if (!$util.isInteger(message.fastpay_money_limit) && !(message.fastpay_money_limit && $util.isInteger(message.fastpay_money_limit.low) && $util.isInteger(message.fastpay_money_limit.high)))
                return "fastpay_money_limit: integer|Long expected";
        if (message.fastpay_times != null && message.hasOwnProperty("fastpay_times"))
            if (!$util.isInteger(message.fastpay_times))
                return "fastpay_times: integer expected";
        if (message.auto_shutdown_delay_ms != null && message.hasOwnProperty("auto_shutdown_delay_ms"))
            if (!$util.isInteger(message.auto_shutdown_delay_ms))
                return "auto_shutdown_delay_ms: integer expected";
        if (message.change_brightness != null && message.hasOwnProperty("change_brightness"))
            if (typeof message.change_brightness !== "boolean")
                return "change_brightness: boolean expected";
        if (message.haptic_feedback != null && message.hasOwnProperty("haptic_feedback"))
            if (typeof message.haptic_feedback !== "boolean")
                return "haptic_feedback: boolean expected";
        return null;
    };

    ApplySettings.fromObject = function fromObject(object) {
        if (object instanceof $root.ApplySettings)
            return object;
        var message = new $root.ApplySettings();
        if (object.language != null)
            message.language = String(object.language);
        if (object.label != null)
            message.label = String(object.label);
        if (object.use_passphrase != null)
            message.use_passphrase = Boolean(object.use_passphrase);
        if (object.homescreen != null)
            if (typeof object.homescreen === "string")
                $util.base64.decode(object.homescreen, message.homescreen = $util.newBuffer($util.base64.length(object.homescreen)), 0);
            else if (object.homescreen.length)
                message.homescreen = object.homescreen;
        if (object._passphrase_source != null)
            message._passphrase_source = object._passphrase_source >>> 0;
        if (object.auto_lock_delay_ms != null)
            message.auto_lock_delay_ms = object.auto_lock_delay_ms >>> 0;
        if (object.display_rotation != null)
            message.display_rotation = object.display_rotation >>> 0;
        if (object.passphrase_always_on_device != null)
            message.passphrase_always_on_device = Boolean(object.passphrase_always_on_device);
        switch (object.safety_checks) {
        case "Strict":
        case 0:
            message.safety_checks = 0;
            break;
        case "PromptAlways":
        case 1:
            message.safety_checks = 1;
            break;
        case "PromptTemporarily":
        case 2:
            message.safety_checks = 2;
            break;
        }
        if (object.experimental_features != null)
            message.experimental_features = Boolean(object.experimental_features);
        if (object.use_ble != null)
            message.use_ble = Boolean(object.use_ble);
        if (object.use_se != null)
            message.use_se = Boolean(object.use_se);
        if (object.is_bixinapp != null)
            message.is_bixinapp = Boolean(object.is_bixinapp);
        if (object.fastpay_pin != null)
            message.fastpay_pin = Boolean(object.fastpay_pin);
        if (object.fastpay_confirm != null)
            message.fastpay_confirm = Boolean(object.fastpay_confirm);
        if (object.fastpay_money_limit != null)
            if ($util.Long)
                (message.fastpay_money_limit = $util.Long.fromValue(object.fastpay_money_limit)).unsigned = true;
            else if (typeof object.fastpay_money_limit === "string")
                message.fastpay_money_limit = parseInt(object.fastpay_money_limit, 10);
            else if (typeof object.fastpay_money_limit === "number")
                message.fastpay_money_limit = object.fastpay_money_limit;
            else if (typeof object.fastpay_money_limit === "object")
                message.fastpay_money_limit = new $util.LongBits(object.fastpay_money_limit.low >>> 0, object.fastpay_money_limit.high >>> 0).toNumber(true);
        if (object.fastpay_times != null)
            message.fastpay_times = object.fastpay_times >>> 0;
        if (object.auto_shutdown_delay_ms != null)
            message.auto_shutdown_delay_ms = object.auto_shutdown_delay_ms >>> 0;
        if (object.change_brightness != null)
            message.change_brightness = Boolean(object.change_brightness);
        if (object.haptic_feedback != null)
            message.haptic_feedback = Boolean(object.haptic_feedback);
        return message;
    };

    ApplySettings.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.language = "";
            object.label = "";
            object.use_passphrase = false;
            if (options.bytes === String)
                object.homescreen = "";
            else {
                object.homescreen = [];
                if (options.bytes !== Array)
                    object.homescreen = $util.newBuffer(object.homescreen);
            }
            object._passphrase_source = 0;
            object.auto_lock_delay_ms = 0;
            object.display_rotation = 0;
            object.passphrase_always_on_device = false;
            object.safety_checks = options.enums === String ? "Strict" : 0;
            object.experimental_features = false;
            object.use_ble = false;
            object.use_se = false;
            object.is_bixinapp = false;
            object.fastpay_pin = false;
            object.fastpay_confirm = false;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.fastpay_money_limit = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.fastpay_money_limit = options.longs === String ? "0" : 0;
            object.fastpay_times = 0;
            object.auto_shutdown_delay_ms = 0;
            object.change_brightness = false;
            object.haptic_feedback = false;
        }
        if (message.language != null && message.hasOwnProperty("language"))
            object.language = message.language;
        if (message.label != null && message.hasOwnProperty("label"))
            object.label = message.label;
        if (message.use_passphrase != null && message.hasOwnProperty("use_passphrase"))
            object.use_passphrase = message.use_passphrase;
        if (message.homescreen != null && message.hasOwnProperty("homescreen"))
            object.homescreen = options.bytes === String ? $util.base64.encode(message.homescreen, 0, message.homescreen.length) : options.bytes === Array ? Array.prototype.slice.call(message.homescreen) : message.homescreen;
        if (message._passphrase_source != null && message.hasOwnProperty("_passphrase_source"))
            object._passphrase_source = message._passphrase_source;
        if (message.auto_lock_delay_ms != null && message.hasOwnProperty("auto_lock_delay_ms"))
            object.auto_lock_delay_ms = message.auto_lock_delay_ms;
        if (message.display_rotation != null && message.hasOwnProperty("display_rotation"))
            object.display_rotation = message.display_rotation;
        if (message.passphrase_always_on_device != null && message.hasOwnProperty("passphrase_always_on_device"))
            object.passphrase_always_on_device = message.passphrase_always_on_device;
        if (message.safety_checks != null && message.hasOwnProperty("safety_checks"))
            object.safety_checks = options.enums === String ? $root.SafetyCheckLevel[message.safety_checks] : message.safety_checks;
        if (message.experimental_features != null && message.hasOwnProperty("experimental_features"))
            object.experimental_features = message.experimental_features;
        if (message.use_ble != null && message.hasOwnProperty("use_ble"))
            object.use_ble = message.use_ble;
        if (message.use_se != null && message.hasOwnProperty("use_se"))
            object.use_se = message.use_se;
        if (message.is_bixinapp != null && message.hasOwnProperty("is_bixinapp"))
            object.is_bixinapp = message.is_bixinapp;
        if (message.fastpay_pin != null && message.hasOwnProperty("fastpay_pin"))
            object.fastpay_pin = message.fastpay_pin;
        if (message.fastpay_confirm != null && message.hasOwnProperty("fastpay_confirm"))
            object.fastpay_confirm = message.fastpay_confirm;
        if (message.fastpay_money_limit != null && message.hasOwnProperty("fastpay_money_limit"))
            if (typeof message.fastpay_money_limit === "number")
                object.fastpay_money_limit = options.longs === String ? String(message.fastpay_money_limit) : message.fastpay_money_limit;
            else
                object.fastpay_money_limit = options.longs === String ? $util.Long.prototype.toString.call(message.fastpay_money_limit) : options.longs === Number ? new $util.LongBits(message.fastpay_money_limit.low >>> 0, message.fastpay_money_limit.high >>> 0).toNumber(true) : message.fastpay_money_limit;
        if (message.fastpay_times != null && message.hasOwnProperty("fastpay_times"))
            object.fastpay_times = message.fastpay_times;
        if (message.auto_shutdown_delay_ms != null && message.hasOwnProperty("auto_shutdown_delay_ms"))
            object.auto_shutdown_delay_ms = message.auto_shutdown_delay_ms;
        if (message.change_brightness != null && message.hasOwnProperty("change_brightness"))
            object.change_brightness = message.change_brightness;
        if (message.haptic_feedback != null && message.hasOwnProperty("haptic_feedback"))
            object.haptic_feedback = message.haptic_feedback;
        return object;
    };

    ApplySettings.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    ApplySettings.ExportType = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "SeedEncExportType_NO"] = 0;
        values[valuesById[1] = "SeedEncExportType_YES"] = 1;
        values[valuesById[2] = "MnemonicPlainExportType_YES"] = 2;
        return values;
    })();

    return ApplySettings;
})();

$root.ApplyFlags = (function() {

    function ApplyFlags(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ApplyFlags.prototype.flags = 0;

    ApplyFlags.create = function create(properties) {
        return new ApplyFlags(properties);
    };

    ApplyFlags.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).uint32(message.flags);
        return writer;
    };

    ApplyFlags.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ApplyFlags.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ApplyFlags();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.flags = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("flags"))
            throw $util.ProtocolError("missing required 'flags'", { instance: message });
        return message;
    };

    ApplyFlags.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ApplyFlags.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isInteger(message.flags))
            return "flags: integer expected";
        return null;
    };

    ApplyFlags.fromObject = function fromObject(object) {
        if (object instanceof $root.ApplyFlags)
            return object;
        var message = new $root.ApplyFlags();
        if (object.flags != null)
            message.flags = object.flags >>> 0;
        return message;
    };

    ApplyFlags.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.flags = 0;
        if (message.flags != null && message.hasOwnProperty("flags"))
            object.flags = message.flags;
        return object;
    };

    ApplyFlags.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ApplyFlags;
})();

$root.ChangePin = (function() {

    function ChangePin(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ChangePin.prototype.remove = false;

    ChangePin.create = function create(properties) {
        return new ChangePin(properties);
    };

    ChangePin.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.remove != null && Object.hasOwnProperty.call(message, "remove"))
            writer.uint32(8).bool(message.remove);
        return writer;
    };

    ChangePin.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ChangePin.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ChangePin();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.remove = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    ChangePin.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ChangePin.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.remove != null && message.hasOwnProperty("remove"))
            if (typeof message.remove !== "boolean")
                return "remove: boolean expected";
        return null;
    };

    ChangePin.fromObject = function fromObject(object) {
        if (object instanceof $root.ChangePin)
            return object;
        var message = new $root.ChangePin();
        if (object.remove != null)
            message.remove = Boolean(object.remove);
        return message;
    };

    ChangePin.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.remove = false;
        if (message.remove != null && message.hasOwnProperty("remove"))
            object.remove = message.remove;
        return object;
    };

    ChangePin.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ChangePin;
})();

$root.ChangeWipeCode = (function() {

    function ChangeWipeCode(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ChangeWipeCode.prototype.remove = false;

    ChangeWipeCode.create = function create(properties) {
        return new ChangeWipeCode(properties);
    };

    ChangeWipeCode.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.remove != null && Object.hasOwnProperty.call(message, "remove"))
            writer.uint32(8).bool(message.remove);
        return writer;
    };

    ChangeWipeCode.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ChangeWipeCode.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ChangeWipeCode();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.remove = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    ChangeWipeCode.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ChangeWipeCode.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.remove != null && message.hasOwnProperty("remove"))
            if (typeof message.remove !== "boolean")
                return "remove: boolean expected";
        return null;
    };

    ChangeWipeCode.fromObject = function fromObject(object) {
        if (object instanceof $root.ChangeWipeCode)
            return object;
        var message = new $root.ChangeWipeCode();
        if (object.remove != null)
            message.remove = Boolean(object.remove);
        return message;
    };

    ChangeWipeCode.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.remove = false;
        if (message.remove != null && message.hasOwnProperty("remove"))
            object.remove = message.remove;
        return object;
    };

    ChangeWipeCode.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ChangeWipeCode;
})();

$root.SdProtect = (function() {

    function SdProtect(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    SdProtect.prototype.operation = 0;

    SdProtect.create = function create(properties) {
        return new SdProtect(properties);
    };

    SdProtect.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).int32(message.operation);
        return writer;
    };

    SdProtect.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    SdProtect.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SdProtect();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.operation = reader.int32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("operation"))
            throw $util.ProtocolError("missing required 'operation'", { instance: message });
        return message;
    };

    SdProtect.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    SdProtect.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        switch (message.operation) {
        default:
            return "operation: enum value expected";
        case 0:
        case 1:
        case 2:
            break;
        }
        return null;
    };

    SdProtect.fromObject = function fromObject(object) {
        if (object instanceof $root.SdProtect)
            return object;
        var message = new $root.SdProtect();
        switch (object.operation) {
        case "DISABLE":
        case 0:
            message.operation = 0;
            break;
        case "ENABLE":
        case 1:
            message.operation = 1;
            break;
        case "REFRESH":
        case 2:
            message.operation = 2;
            break;
        }
        return message;
    };

    SdProtect.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.operation = options.enums === String ? "DISABLE" : 0;
        if (message.operation != null && message.hasOwnProperty("operation"))
            object.operation = options.enums === String ? $root.SdProtect.SdProtectOperationType[message.operation] : message.operation;
        return object;
    };

    SdProtect.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    SdProtect.SdProtectOperationType = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "DISABLE"] = 0;
        values[valuesById[1] = "ENABLE"] = 1;
        values[valuesById[2] = "REFRESH"] = 2;
        return values;
    })();

    return SdProtect;
})();

$root.Ping = (function() {

    function Ping(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    Ping.prototype.message = "";
    Ping.prototype.button_protection = false;

    Ping.create = function create(properties) {
        return new Ping(properties);
    };

    Ping.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
            writer.uint32(10).string(message.message);
        if (message.button_protection != null && Object.hasOwnProperty.call(message, "button_protection"))
            writer.uint32(16).bool(message.button_protection);
        return writer;
    };

    Ping.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    Ping.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Ping();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.message = reader.string();
                break;
            case 2:
                message.button_protection = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    Ping.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    Ping.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.message != null && message.hasOwnProperty("message"))
            if (!$util.isString(message.message))
                return "message: string expected";
        if (message.button_protection != null && message.hasOwnProperty("button_protection"))
            if (typeof message.button_protection !== "boolean")
                return "button_protection: boolean expected";
        return null;
    };

    Ping.fromObject = function fromObject(object) {
        if (object instanceof $root.Ping)
            return object;
        var message = new $root.Ping();
        if (object.message != null)
            message.message = String(object.message);
        if (object.button_protection != null)
            message.button_protection = Boolean(object.button_protection);
        return message;
    };

    Ping.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.message = "";
            object.button_protection = false;
        }
        if (message.message != null && message.hasOwnProperty("message"))
            object.message = message.message;
        if (message.button_protection != null && message.hasOwnProperty("button_protection"))
            object.button_protection = message.button_protection;
        return object;
    };

    Ping.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return Ping;
})();

$root.Cancel = (function() {

    function Cancel(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    Cancel.create = function create(properties) {
        return new Cancel(properties);
    };

    Cancel.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    Cancel.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    Cancel.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Cancel();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    Cancel.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    Cancel.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    Cancel.fromObject = function fromObject(object) {
        if (object instanceof $root.Cancel)
            return object;
        return new $root.Cancel();
    };

    Cancel.toObject = function toObject() {
        return {};
    };

    Cancel.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return Cancel;
})();

$root.GetEntropy = (function() {

    function GetEntropy(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    GetEntropy.prototype.size = 0;

    GetEntropy.create = function create(properties) {
        return new GetEntropy(properties);
    };

    GetEntropy.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).uint32(message.size);
        return writer;
    };

    GetEntropy.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    GetEntropy.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.GetEntropy();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.size = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("size"))
            throw $util.ProtocolError("missing required 'size'", { instance: message });
        return message;
    };

    GetEntropy.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    GetEntropy.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isInteger(message.size))
            return "size: integer expected";
        return null;
    };

    GetEntropy.fromObject = function fromObject(object) {
        if (object instanceof $root.GetEntropy)
            return object;
        var message = new $root.GetEntropy();
        if (object.size != null)
            message.size = object.size >>> 0;
        return message;
    };

    GetEntropy.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.size = 0;
        if (message.size != null && message.hasOwnProperty("size"))
            object.size = message.size;
        return object;
    };

    GetEntropy.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return GetEntropy;
})();

$root.Entropy = (function() {

    function Entropy(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    Entropy.prototype.entropy = $util.newBuffer([]);

    Entropy.create = function create(properties) {
        return new Entropy(properties);
    };

    Entropy.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.entropy);
        return writer;
    };

    Entropy.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    Entropy.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Entropy();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.entropy = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("entropy"))
            throw $util.ProtocolError("missing required 'entropy'", { instance: message });
        return message;
    };

    Entropy.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    Entropy.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.entropy && typeof message.entropy.length === "number" || $util.isString(message.entropy)))
            return "entropy: buffer expected";
        return null;
    };

    Entropy.fromObject = function fromObject(object) {
        if (object instanceof $root.Entropy)
            return object;
        var message = new $root.Entropy();
        if (object.entropy != null)
            if (typeof object.entropy === "string")
                $util.base64.decode(object.entropy, message.entropy = $util.newBuffer($util.base64.length(object.entropy)), 0);
            else if (object.entropy.length)
                message.entropy = object.entropy;
        return message;
    };

    Entropy.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.entropy = "";
            else {
                object.entropy = [];
                if (options.bytes !== Array)
                    object.entropy = $util.newBuffer(object.entropy);
            }
        if (message.entropy != null && message.hasOwnProperty("entropy"))
            object.entropy = options.bytes === String ? $util.base64.encode(message.entropy, 0, message.entropy.length) : options.bytes === Array ? Array.prototype.slice.call(message.entropy) : message.entropy;
        return object;
    };

    Entropy.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return Entropy;
})();

$root.WipeDevice = (function() {

    function WipeDevice(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    WipeDevice.create = function create(properties) {
        return new WipeDevice(properties);
    };

    WipeDevice.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    WipeDevice.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    WipeDevice.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.WipeDevice();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    WipeDevice.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    WipeDevice.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    WipeDevice.fromObject = function fromObject(object) {
        if (object instanceof $root.WipeDevice)
            return object;
        return new $root.WipeDevice();
    };

    WipeDevice.toObject = function toObject() {
        return {};
    };

    WipeDevice.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return WipeDevice;
})();

$root.LoadDevice = (function() {

    function LoadDevice(properties) {
        this.mnemonics = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    LoadDevice.prototype.mnemonics = $util.emptyArray;
    LoadDevice.prototype.pin = "";
    LoadDevice.prototype.passphrase_protection = false;
    LoadDevice.prototype.language = "en-US";
    LoadDevice.prototype.label = "";
    LoadDevice.prototype.skip_checksum = false;
    LoadDevice.prototype.u2f_counter = 0;
    LoadDevice.prototype.needs_backup = false;
    LoadDevice.prototype.no_backup = false;

    LoadDevice.create = function create(properties) {
        return new LoadDevice(properties);
    };

    LoadDevice.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.mnemonics != null && message.mnemonics.length)
            for (var i = 0; i < message.mnemonics.length; ++i)
                writer.uint32(10).string(message.mnemonics[i]);
        if (message.pin != null && Object.hasOwnProperty.call(message, "pin"))
            writer.uint32(26).string(message.pin);
        if (message.passphrase_protection != null && Object.hasOwnProperty.call(message, "passphrase_protection"))
            writer.uint32(32).bool(message.passphrase_protection);
        if (message.language != null && Object.hasOwnProperty.call(message, "language"))
            writer.uint32(42).string(message.language);
        if (message.label != null && Object.hasOwnProperty.call(message, "label"))
            writer.uint32(50).string(message.label);
        if (message.skip_checksum != null && Object.hasOwnProperty.call(message, "skip_checksum"))
            writer.uint32(56).bool(message.skip_checksum);
        if (message.u2f_counter != null && Object.hasOwnProperty.call(message, "u2f_counter"))
            writer.uint32(64).uint32(message.u2f_counter);
        if (message.needs_backup != null && Object.hasOwnProperty.call(message, "needs_backup"))
            writer.uint32(72).bool(message.needs_backup);
        if (message.no_backup != null && Object.hasOwnProperty.call(message, "no_backup"))
            writer.uint32(80).bool(message.no_backup);
        return writer;
    };

    LoadDevice.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    LoadDevice.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.LoadDevice();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.mnemonics && message.mnemonics.length))
                    message.mnemonics = [];
                message.mnemonics.push(reader.string());
                break;
            case 3:
                message.pin = reader.string();
                break;
            case 4:
                message.passphrase_protection = reader.bool();
                break;
            case 5:
                message.language = reader.string();
                break;
            case 6:
                message.label = reader.string();
                break;
            case 7:
                message.skip_checksum = reader.bool();
                break;
            case 8:
                message.u2f_counter = reader.uint32();
                break;
            case 9:
                message.needs_backup = reader.bool();
                break;
            case 10:
                message.no_backup = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    LoadDevice.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    LoadDevice.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.mnemonics != null && message.hasOwnProperty("mnemonics")) {
            if (!Array.isArray(message.mnemonics))
                return "mnemonics: array expected";
            for (var i = 0; i < message.mnemonics.length; ++i)
                if (!$util.isString(message.mnemonics[i]))
                    return "mnemonics: string[] expected";
        }
        if (message.pin != null && message.hasOwnProperty("pin"))
            if (!$util.isString(message.pin))
                return "pin: string expected";
        if (message.passphrase_protection != null && message.hasOwnProperty("passphrase_protection"))
            if (typeof message.passphrase_protection !== "boolean")
                return "passphrase_protection: boolean expected";
        if (message.language != null && message.hasOwnProperty("language"))
            if (!$util.isString(message.language))
                return "language: string expected";
        if (message.label != null && message.hasOwnProperty("label"))
            if (!$util.isString(message.label))
                return "label: string expected";
        if (message.skip_checksum != null && message.hasOwnProperty("skip_checksum"))
            if (typeof message.skip_checksum !== "boolean")
                return "skip_checksum: boolean expected";
        if (message.u2f_counter != null && message.hasOwnProperty("u2f_counter"))
            if (!$util.isInteger(message.u2f_counter))
                return "u2f_counter: integer expected";
        if (message.needs_backup != null && message.hasOwnProperty("needs_backup"))
            if (typeof message.needs_backup !== "boolean")
                return "needs_backup: boolean expected";
        if (message.no_backup != null && message.hasOwnProperty("no_backup"))
            if (typeof message.no_backup !== "boolean")
                return "no_backup: boolean expected";
        return null;
    };

    LoadDevice.fromObject = function fromObject(object) {
        if (object instanceof $root.LoadDevice)
            return object;
        var message = new $root.LoadDevice();
        if (object.mnemonics) {
            if (!Array.isArray(object.mnemonics))
                throw TypeError(".LoadDevice.mnemonics: array expected");
            message.mnemonics = [];
            for (var i = 0; i < object.mnemonics.length; ++i)
                message.mnemonics[i] = String(object.mnemonics[i]);
        }
        if (object.pin != null)
            message.pin = String(object.pin);
        if (object.passphrase_protection != null)
            message.passphrase_protection = Boolean(object.passphrase_protection);
        if (object.language != null)
            message.language = String(object.language);
        if (object.label != null)
            message.label = String(object.label);
        if (object.skip_checksum != null)
            message.skip_checksum = Boolean(object.skip_checksum);
        if (object.u2f_counter != null)
            message.u2f_counter = object.u2f_counter >>> 0;
        if (object.needs_backup != null)
            message.needs_backup = Boolean(object.needs_backup);
        if (object.no_backup != null)
            message.no_backup = Boolean(object.no_backup);
        return message;
    };

    LoadDevice.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.mnemonics = [];
        if (options.defaults) {
            object.pin = "";
            object.passphrase_protection = false;
            object.language = "en-US";
            object.label = "";
            object.skip_checksum = false;
            object.u2f_counter = 0;
            object.needs_backup = false;
            object.no_backup = false;
        }
        if (message.mnemonics && message.mnemonics.length) {
            object.mnemonics = [];
            for (var j = 0; j < message.mnemonics.length; ++j)
                object.mnemonics[j] = message.mnemonics[j];
        }
        if (message.pin != null && message.hasOwnProperty("pin"))
            object.pin = message.pin;
        if (message.passphrase_protection != null && message.hasOwnProperty("passphrase_protection"))
            object.passphrase_protection = message.passphrase_protection;
        if (message.language != null && message.hasOwnProperty("language"))
            object.language = message.language;
        if (message.label != null && message.hasOwnProperty("label"))
            object.label = message.label;
        if (message.skip_checksum != null && message.hasOwnProperty("skip_checksum"))
            object.skip_checksum = message.skip_checksum;
        if (message.u2f_counter != null && message.hasOwnProperty("u2f_counter"))
            object.u2f_counter = message.u2f_counter;
        if (message.needs_backup != null && message.hasOwnProperty("needs_backup"))
            object.needs_backup = message.needs_backup;
        if (message.no_backup != null && message.hasOwnProperty("no_backup"))
            object.no_backup = message.no_backup;
        return object;
    };

    LoadDevice.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return LoadDevice;
})();

$root.ResetDevice = (function() {

    function ResetDevice(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ResetDevice.prototype.display_random = false;
    ResetDevice.prototype.strength = 256;
    ResetDevice.prototype.passphrase_protection = false;
    ResetDevice.prototype.pin_protection = false;
    ResetDevice.prototype.language = "en-US";
    ResetDevice.prototype.label = "";
    ResetDevice.prototype.u2f_counter = 0;
    ResetDevice.prototype.skip_backup = false;
    ResetDevice.prototype.no_backup = false;
    ResetDevice.prototype.backup_type = 0;

    ResetDevice.create = function create(properties) {
        return new ResetDevice(properties);
    };

    ResetDevice.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.display_random != null && Object.hasOwnProperty.call(message, "display_random"))
            writer.uint32(8).bool(message.display_random);
        if (message.strength != null && Object.hasOwnProperty.call(message, "strength"))
            writer.uint32(16).uint32(message.strength);
        if (message.passphrase_protection != null && Object.hasOwnProperty.call(message, "passphrase_protection"))
            writer.uint32(24).bool(message.passphrase_protection);
        if (message.pin_protection != null && Object.hasOwnProperty.call(message, "pin_protection"))
            writer.uint32(32).bool(message.pin_protection);
        if (message.language != null && Object.hasOwnProperty.call(message, "language"))
            writer.uint32(42).string(message.language);
        if (message.label != null && Object.hasOwnProperty.call(message, "label"))
            writer.uint32(50).string(message.label);
        if (message.u2f_counter != null && Object.hasOwnProperty.call(message, "u2f_counter"))
            writer.uint32(56).uint32(message.u2f_counter);
        if (message.skip_backup != null && Object.hasOwnProperty.call(message, "skip_backup"))
            writer.uint32(64).bool(message.skip_backup);
        if (message.no_backup != null && Object.hasOwnProperty.call(message, "no_backup"))
            writer.uint32(72).bool(message.no_backup);
        if (message.backup_type != null && Object.hasOwnProperty.call(message, "backup_type"))
            writer.uint32(80).int32(message.backup_type);
        return writer;
    };

    ResetDevice.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ResetDevice.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ResetDevice();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.display_random = reader.bool();
                break;
            case 2:
                message.strength = reader.uint32();
                break;
            case 3:
                message.passphrase_protection = reader.bool();
                break;
            case 4:
                message.pin_protection = reader.bool();
                break;
            case 5:
                message.language = reader.string();
                break;
            case 6:
                message.label = reader.string();
                break;
            case 7:
                message.u2f_counter = reader.uint32();
                break;
            case 8:
                message.skip_backup = reader.bool();
                break;
            case 9:
                message.no_backup = reader.bool();
                break;
            case 10:
                message.backup_type = reader.int32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    ResetDevice.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ResetDevice.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.display_random != null && message.hasOwnProperty("display_random"))
            if (typeof message.display_random !== "boolean")
                return "display_random: boolean expected";
        if (message.strength != null && message.hasOwnProperty("strength"))
            if (!$util.isInteger(message.strength))
                return "strength: integer expected";
        if (message.passphrase_protection != null && message.hasOwnProperty("passphrase_protection"))
            if (typeof message.passphrase_protection !== "boolean")
                return "passphrase_protection: boolean expected";
        if (message.pin_protection != null && message.hasOwnProperty("pin_protection"))
            if (typeof message.pin_protection !== "boolean")
                return "pin_protection: boolean expected";
        if (message.language != null && message.hasOwnProperty("language"))
            if (!$util.isString(message.language))
                return "language: string expected";
        if (message.label != null && message.hasOwnProperty("label"))
            if (!$util.isString(message.label))
                return "label: string expected";
        if (message.u2f_counter != null && message.hasOwnProperty("u2f_counter"))
            if (!$util.isInteger(message.u2f_counter))
                return "u2f_counter: integer expected";
        if (message.skip_backup != null && message.hasOwnProperty("skip_backup"))
            if (typeof message.skip_backup !== "boolean")
                return "skip_backup: boolean expected";
        if (message.no_backup != null && message.hasOwnProperty("no_backup"))
            if (typeof message.no_backup !== "boolean")
                return "no_backup: boolean expected";
        if (message.backup_type != null && message.hasOwnProperty("backup_type"))
            switch (message.backup_type) {
            default:
                return "backup_type: enum value expected";
            case 0:
            case 1:
            case 2:
                break;
            }
        return null;
    };

    ResetDevice.fromObject = function fromObject(object) {
        if (object instanceof $root.ResetDevice)
            return object;
        var message = new $root.ResetDevice();
        if (object.display_random != null)
            message.display_random = Boolean(object.display_random);
        if (object.strength != null)
            message.strength = object.strength >>> 0;
        if (object.passphrase_protection != null)
            message.passphrase_protection = Boolean(object.passphrase_protection);
        if (object.pin_protection != null)
            message.pin_protection = Boolean(object.pin_protection);
        if (object.language != null)
            message.language = String(object.language);
        if (object.label != null)
            message.label = String(object.label);
        if (object.u2f_counter != null)
            message.u2f_counter = object.u2f_counter >>> 0;
        if (object.skip_backup != null)
            message.skip_backup = Boolean(object.skip_backup);
        if (object.no_backup != null)
            message.no_backup = Boolean(object.no_backup);
        switch (object.backup_type) {
        case "Bip39":
        case 0:
            message.backup_type = 0;
            break;
        case "Slip39_Basic":
        case 1:
            message.backup_type = 1;
            break;
        case "Slip39_Advanced":
        case 2:
            message.backup_type = 2;
            break;
        }
        return message;
    };

    ResetDevice.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.display_random = false;
            object.strength = 256;
            object.passphrase_protection = false;
            object.pin_protection = false;
            object.language = "en-US";
            object.label = "";
            object.u2f_counter = 0;
            object.skip_backup = false;
            object.no_backup = false;
            object.backup_type = options.enums === String ? "Bip39" : 0;
        }
        if (message.display_random != null && message.hasOwnProperty("display_random"))
            object.display_random = message.display_random;
        if (message.strength != null && message.hasOwnProperty("strength"))
            object.strength = message.strength;
        if (message.passphrase_protection != null && message.hasOwnProperty("passphrase_protection"))
            object.passphrase_protection = message.passphrase_protection;
        if (message.pin_protection != null && message.hasOwnProperty("pin_protection"))
            object.pin_protection = message.pin_protection;
        if (message.language != null && message.hasOwnProperty("language"))
            object.language = message.language;
        if (message.label != null && message.hasOwnProperty("label"))
            object.label = message.label;
        if (message.u2f_counter != null && message.hasOwnProperty("u2f_counter"))
            object.u2f_counter = message.u2f_counter;
        if (message.skip_backup != null && message.hasOwnProperty("skip_backup"))
            object.skip_backup = message.skip_backup;
        if (message.no_backup != null && message.hasOwnProperty("no_backup"))
            object.no_backup = message.no_backup;
        if (message.backup_type != null && message.hasOwnProperty("backup_type"))
            object.backup_type = options.enums === String ? $root.BackupType[message.backup_type] : message.backup_type;
        return object;
    };

    ResetDevice.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ResetDevice;
})();

$root.BackupDevice = (function() {

    function BackupDevice(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    BackupDevice.create = function create(properties) {
        return new BackupDevice(properties);
    };

    BackupDevice.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    BackupDevice.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    BackupDevice.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BackupDevice();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    BackupDevice.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    BackupDevice.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    BackupDevice.fromObject = function fromObject(object) {
        if (object instanceof $root.BackupDevice)
            return object;
        return new $root.BackupDevice();
    };

    BackupDevice.toObject = function toObject() {
        return {};
    };

    BackupDevice.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return BackupDevice;
})();

$root.EntropyRequest = (function() {

    function EntropyRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EntropyRequest.create = function create(properties) {
        return new EntropyRequest(properties);
    };

    EntropyRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    EntropyRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EntropyRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EntropyRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    EntropyRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EntropyRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    EntropyRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.EntropyRequest)
            return object;
        return new $root.EntropyRequest();
    };

    EntropyRequest.toObject = function toObject() {
        return {};
    };

    EntropyRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EntropyRequest;
})();

$root.EntropyAck = (function() {

    function EntropyAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EntropyAck.prototype.entropy = $util.newBuffer([]);

    EntropyAck.create = function create(properties) {
        return new EntropyAck(properties);
    };

    EntropyAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.entropy);
        return writer;
    };

    EntropyAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EntropyAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EntropyAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.entropy = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("entropy"))
            throw $util.ProtocolError("missing required 'entropy'", { instance: message });
        return message;
    };

    EntropyAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EntropyAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.entropy && typeof message.entropy.length === "number" || $util.isString(message.entropy)))
            return "entropy: buffer expected";
        return null;
    };

    EntropyAck.fromObject = function fromObject(object) {
        if (object instanceof $root.EntropyAck)
            return object;
        var message = new $root.EntropyAck();
        if (object.entropy != null)
            if (typeof object.entropy === "string")
                $util.base64.decode(object.entropy, message.entropy = $util.newBuffer($util.base64.length(object.entropy)), 0);
            else if (object.entropy.length)
                message.entropy = object.entropy;
        return message;
    };

    EntropyAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.entropy = "";
            else {
                object.entropy = [];
                if (options.bytes !== Array)
                    object.entropy = $util.newBuffer(object.entropy);
            }
        if (message.entropy != null && message.hasOwnProperty("entropy"))
            object.entropy = options.bytes === String ? $util.base64.encode(message.entropy, 0, message.entropy.length) : options.bytes === Array ? Array.prototype.slice.call(message.entropy) : message.entropy;
        return object;
    };

    EntropyAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EntropyAck;
})();

$root.RecoveryDevice = (function() {

    function RecoveryDevice(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    RecoveryDevice.prototype.word_count = 0;
    RecoveryDevice.prototype.passphrase_protection = false;
    RecoveryDevice.prototype.pin_protection = false;
    RecoveryDevice.prototype.language = "";
    RecoveryDevice.prototype.label = "";
    RecoveryDevice.prototype.enforce_wordlist = false;
    RecoveryDevice.prototype.type = 0;
    RecoveryDevice.prototype.u2f_counter = 0;
    RecoveryDevice.prototype.dry_run = false;

    RecoveryDevice.create = function create(properties) {
        return new RecoveryDevice(properties);
    };

    RecoveryDevice.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.word_count != null && Object.hasOwnProperty.call(message, "word_count"))
            writer.uint32(8).uint32(message.word_count);
        if (message.passphrase_protection != null && Object.hasOwnProperty.call(message, "passphrase_protection"))
            writer.uint32(16).bool(message.passphrase_protection);
        if (message.pin_protection != null && Object.hasOwnProperty.call(message, "pin_protection"))
            writer.uint32(24).bool(message.pin_protection);
        if (message.language != null && Object.hasOwnProperty.call(message, "language"))
            writer.uint32(34).string(message.language);
        if (message.label != null && Object.hasOwnProperty.call(message, "label"))
            writer.uint32(42).string(message.label);
        if (message.enforce_wordlist != null && Object.hasOwnProperty.call(message, "enforce_wordlist"))
            writer.uint32(48).bool(message.enforce_wordlist);
        if (message.type != null && Object.hasOwnProperty.call(message, "type"))
            writer.uint32(64).int32(message.type);
        if (message.u2f_counter != null && Object.hasOwnProperty.call(message, "u2f_counter"))
            writer.uint32(72).uint32(message.u2f_counter);
        if (message.dry_run != null && Object.hasOwnProperty.call(message, "dry_run"))
            writer.uint32(80).bool(message.dry_run);
        return writer;
    };

    RecoveryDevice.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    RecoveryDevice.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.RecoveryDevice();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.word_count = reader.uint32();
                break;
            case 2:
                message.passphrase_protection = reader.bool();
                break;
            case 3:
                message.pin_protection = reader.bool();
                break;
            case 4:
                message.language = reader.string();
                break;
            case 5:
                message.label = reader.string();
                break;
            case 6:
                message.enforce_wordlist = reader.bool();
                break;
            case 8:
                message.type = reader.int32();
                break;
            case 9:
                message.u2f_counter = reader.uint32();
                break;
            case 10:
                message.dry_run = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    RecoveryDevice.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    RecoveryDevice.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.word_count != null && message.hasOwnProperty("word_count"))
            if (!$util.isInteger(message.word_count))
                return "word_count: integer expected";
        if (message.passphrase_protection != null && message.hasOwnProperty("passphrase_protection"))
            if (typeof message.passphrase_protection !== "boolean")
                return "passphrase_protection: boolean expected";
        if (message.pin_protection != null && message.hasOwnProperty("pin_protection"))
            if (typeof message.pin_protection !== "boolean")
                return "pin_protection: boolean expected";
        if (message.language != null && message.hasOwnProperty("language"))
            if (!$util.isString(message.language))
                return "language: string expected";
        if (message.label != null && message.hasOwnProperty("label"))
            if (!$util.isString(message.label))
                return "label: string expected";
        if (message.enforce_wordlist != null && message.hasOwnProperty("enforce_wordlist"))
            if (typeof message.enforce_wordlist !== "boolean")
                return "enforce_wordlist: boolean expected";
        if (message.type != null && message.hasOwnProperty("type"))
            switch (message.type) {
            default:
                return "type: enum value expected";
            case 0:
            case 1:
                break;
            }
        if (message.u2f_counter != null && message.hasOwnProperty("u2f_counter"))
            if (!$util.isInteger(message.u2f_counter))
                return "u2f_counter: integer expected";
        if (message.dry_run != null && message.hasOwnProperty("dry_run"))
            if (typeof message.dry_run !== "boolean")
                return "dry_run: boolean expected";
        return null;
    };

    RecoveryDevice.fromObject = function fromObject(object) {
        if (object instanceof $root.RecoveryDevice)
            return object;
        var message = new $root.RecoveryDevice();
        if (object.word_count != null)
            message.word_count = object.word_count >>> 0;
        if (object.passphrase_protection != null)
            message.passphrase_protection = Boolean(object.passphrase_protection);
        if (object.pin_protection != null)
            message.pin_protection = Boolean(object.pin_protection);
        if (object.language != null)
            message.language = String(object.language);
        if (object.label != null)
            message.label = String(object.label);
        if (object.enforce_wordlist != null)
            message.enforce_wordlist = Boolean(object.enforce_wordlist);
        switch (object.type) {
        case "RecoveryDeviceType_ScrambledWords":
        case 0:
            message.type = 0;
            break;
        case "RecoveryDeviceType_Matrix":
        case 1:
            message.type = 1;
            break;
        }
        if (object.u2f_counter != null)
            message.u2f_counter = object.u2f_counter >>> 0;
        if (object.dry_run != null)
            message.dry_run = Boolean(object.dry_run);
        return message;
    };

    RecoveryDevice.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.word_count = 0;
            object.passphrase_protection = false;
            object.pin_protection = false;
            object.language = "";
            object.label = "";
            object.enforce_wordlist = false;
            object.type = options.enums === String ? "RecoveryDeviceType_ScrambledWords" : 0;
            object.u2f_counter = 0;
            object.dry_run = false;
        }
        if (message.word_count != null && message.hasOwnProperty("word_count"))
            object.word_count = message.word_count;
        if (message.passphrase_protection != null && message.hasOwnProperty("passphrase_protection"))
            object.passphrase_protection = message.passphrase_protection;
        if (message.pin_protection != null && message.hasOwnProperty("pin_protection"))
            object.pin_protection = message.pin_protection;
        if (message.language != null && message.hasOwnProperty("language"))
            object.language = message.language;
        if (message.label != null && message.hasOwnProperty("label"))
            object.label = message.label;
        if (message.enforce_wordlist != null && message.hasOwnProperty("enforce_wordlist"))
            object.enforce_wordlist = message.enforce_wordlist;
        if (message.type != null && message.hasOwnProperty("type"))
            object.type = options.enums === String ? $root.RecoveryDevice.RecoveryDeviceType[message.type] : message.type;
        if (message.u2f_counter != null && message.hasOwnProperty("u2f_counter"))
            object.u2f_counter = message.u2f_counter;
        if (message.dry_run != null && message.hasOwnProperty("dry_run"))
            object.dry_run = message.dry_run;
        return object;
    };

    RecoveryDevice.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    RecoveryDevice.RecoveryDeviceType = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "RecoveryDeviceType_ScrambledWords"] = 0;
        values[valuesById[1] = "RecoveryDeviceType_Matrix"] = 1;
        return values;
    })();

    return RecoveryDevice;
})();

$root.WordRequest = (function() {

    function WordRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    WordRequest.prototype.type = 0;

    WordRequest.create = function create(properties) {
        return new WordRequest(properties);
    };

    WordRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).int32(message.type);
        return writer;
    };

    WordRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    WordRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.WordRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.type = reader.int32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("type"))
            throw $util.ProtocolError("missing required 'type'", { instance: message });
        return message;
    };

    WordRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    WordRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        switch (message.type) {
        default:
            return "type: enum value expected";
        case 0:
        case 1:
        case 2:
            break;
        }
        return null;
    };

    WordRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.WordRequest)
            return object;
        var message = new $root.WordRequest();
        switch (object.type) {
        case "WordRequestType_Plain":
        case 0:
            message.type = 0;
            break;
        case "WordRequestType_Matrix9":
        case 1:
            message.type = 1;
            break;
        case "WordRequestType_Matrix6":
        case 2:
            message.type = 2;
            break;
        }
        return message;
    };

    WordRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.type = options.enums === String ? "WordRequestType_Plain" : 0;
        if (message.type != null && message.hasOwnProperty("type"))
            object.type = options.enums === String ? $root.WordRequest.WordRequestType[message.type] : message.type;
        return object;
    };

    WordRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    WordRequest.WordRequestType = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "WordRequestType_Plain"] = 0;
        values[valuesById[1] = "WordRequestType_Matrix9"] = 1;
        values[valuesById[2] = "WordRequestType_Matrix6"] = 2;
        return values;
    })();

    return WordRequest;
})();

$root.WordAck = (function() {

    function WordAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    WordAck.prototype.word = "";

    WordAck.create = function create(properties) {
        return new WordAck(properties);
    };

    WordAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.word);
        return writer;
    };

    WordAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    WordAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.WordAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.word = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("word"))
            throw $util.ProtocolError("missing required 'word'", { instance: message });
        return message;
    };

    WordAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    WordAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.word))
            return "word: string expected";
        return null;
    };

    WordAck.fromObject = function fromObject(object) {
        if (object instanceof $root.WordAck)
            return object;
        var message = new $root.WordAck();
        if (object.word != null)
            message.word = String(object.word);
        return message;
    };

    WordAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.word = "";
        if (message.word != null && message.hasOwnProperty("word"))
            object.word = message.word;
        return object;
    };

    WordAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return WordAck;
})();

$root.SetU2FCounter = (function() {

    function SetU2FCounter(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    SetU2FCounter.prototype.u2f_counter = 0;

    SetU2FCounter.create = function create(properties) {
        return new SetU2FCounter(properties);
    };

    SetU2FCounter.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).uint32(message.u2f_counter);
        return writer;
    };

    SetU2FCounter.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    SetU2FCounter.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SetU2FCounter();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.u2f_counter = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("u2f_counter"))
            throw $util.ProtocolError("missing required 'u2f_counter'", { instance: message });
        return message;
    };

    SetU2FCounter.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    SetU2FCounter.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isInteger(message.u2f_counter))
            return "u2f_counter: integer expected";
        return null;
    };

    SetU2FCounter.fromObject = function fromObject(object) {
        if (object instanceof $root.SetU2FCounter)
            return object;
        var message = new $root.SetU2FCounter();
        if (object.u2f_counter != null)
            message.u2f_counter = object.u2f_counter >>> 0;
        return message;
    };

    SetU2FCounter.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.u2f_counter = 0;
        if (message.u2f_counter != null && message.hasOwnProperty("u2f_counter"))
            object.u2f_counter = message.u2f_counter;
        return object;
    };

    SetU2FCounter.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SetU2FCounter;
})();

$root.GetNextU2FCounter = (function() {

    function GetNextU2FCounter(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    GetNextU2FCounter.create = function create(properties) {
        return new GetNextU2FCounter(properties);
    };

    GetNextU2FCounter.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    GetNextU2FCounter.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    GetNextU2FCounter.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.GetNextU2FCounter();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    GetNextU2FCounter.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    GetNextU2FCounter.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    GetNextU2FCounter.fromObject = function fromObject(object) {
        if (object instanceof $root.GetNextU2FCounter)
            return object;
        return new $root.GetNextU2FCounter();
    };

    GetNextU2FCounter.toObject = function toObject() {
        return {};
    };

    GetNextU2FCounter.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return GetNextU2FCounter;
})();

$root.NextU2FCounter = (function() {

    function NextU2FCounter(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NextU2FCounter.prototype.u2f_counter = 0;

    NextU2FCounter.create = function create(properties) {
        return new NextU2FCounter(properties);
    };

    NextU2FCounter.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).uint32(message.u2f_counter);
        return writer;
    };

    NextU2FCounter.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NextU2FCounter.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NextU2FCounter();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.u2f_counter = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("u2f_counter"))
            throw $util.ProtocolError("missing required 'u2f_counter'", { instance: message });
        return message;
    };

    NextU2FCounter.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NextU2FCounter.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isInteger(message.u2f_counter))
            return "u2f_counter: integer expected";
        return null;
    };

    NextU2FCounter.fromObject = function fromObject(object) {
        if (object instanceof $root.NextU2FCounter)
            return object;
        var message = new $root.NextU2FCounter();
        if (object.u2f_counter != null)
            message.u2f_counter = object.u2f_counter >>> 0;
        return message;
    };

    NextU2FCounter.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.u2f_counter = 0;
        if (message.u2f_counter != null && message.hasOwnProperty("u2f_counter"))
            object.u2f_counter = message.u2f_counter;
        return object;
    };

    NextU2FCounter.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NextU2FCounter;
})();

$root.DoPreauthorized = (function() {

    function DoPreauthorized(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DoPreauthorized.create = function create(properties) {
        return new DoPreauthorized(properties);
    };

    DoPreauthorized.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    DoPreauthorized.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DoPreauthorized.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DoPreauthorized();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    DoPreauthorized.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DoPreauthorized.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    DoPreauthorized.fromObject = function fromObject(object) {
        if (object instanceof $root.DoPreauthorized)
            return object;
        return new $root.DoPreauthorized();
    };

    DoPreauthorized.toObject = function toObject() {
        return {};
    };

    DoPreauthorized.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DoPreauthorized;
})();

$root.PreauthorizedRequest = (function() {

    function PreauthorizedRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    PreauthorizedRequest.create = function create(properties) {
        return new PreauthorizedRequest(properties);
    };

    PreauthorizedRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    PreauthorizedRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    PreauthorizedRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.PreauthorizedRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    PreauthorizedRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    PreauthorizedRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    PreauthorizedRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.PreauthorizedRequest)
            return object;
        return new $root.PreauthorizedRequest();
    };

    PreauthorizedRequest.toObject = function toObject() {
        return {};
    };

    PreauthorizedRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return PreauthorizedRequest;
})();

$root.CancelAuthorization = (function() {

    function CancelAuthorization(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CancelAuthorization.create = function create(properties) {
        return new CancelAuthorization(properties);
    };

    CancelAuthorization.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    CancelAuthorization.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CancelAuthorization.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CancelAuthorization();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    CancelAuthorization.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CancelAuthorization.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    CancelAuthorization.fromObject = function fromObject(object) {
        if (object instanceof $root.CancelAuthorization)
            return object;
        return new $root.CancelAuthorization();
    };

    CancelAuthorization.toObject = function toObject() {
        return {};
    };

    CancelAuthorization.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CancelAuthorization;
})();

$root.BixinSeedOperate = (function() {

    function BixinSeedOperate(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    BixinSeedOperate.prototype.type = 0;
    BixinSeedOperate.prototype.seed_importData = $util.newBuffer([]);

    BixinSeedOperate.create = function create(properties) {
        return new BixinSeedOperate(properties);
    };

    BixinSeedOperate.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).int32(message.type);
        if (message.seed_importData != null && Object.hasOwnProperty.call(message, "seed_importData"))
            writer.uint32(18).bytes(message.seed_importData);
        return writer;
    };

    BixinSeedOperate.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    BixinSeedOperate.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BixinSeedOperate();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.type = reader.int32();
                break;
            case 2:
                message.seed_importData = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("type"))
            throw $util.ProtocolError("missing required 'type'", { instance: message });
        return message;
    };

    BixinSeedOperate.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    BixinSeedOperate.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        switch (message.type) {
        default:
            return "type: enum value expected";
        case 0:
        case 1:
        case 2:
            break;
        }
        if (message.seed_importData != null && message.hasOwnProperty("seed_importData"))
            if (!(message.seed_importData && typeof message.seed_importData.length === "number" || $util.isString(message.seed_importData)))
                return "seed_importData: buffer expected";
        return null;
    };

    BixinSeedOperate.fromObject = function fromObject(object) {
        if (object instanceof $root.BixinSeedOperate)
            return object;
        var message = new $root.BixinSeedOperate();
        switch (object.type) {
        case "SeedRequestType_Gen":
        case 0:
            message.type = 0;
            break;
        case "SeedRequestType_EncExport":
        case 1:
            message.type = 1;
            break;
        case "SeedRequestType_EncImport":
        case 2:
            message.type = 2;
            break;
        }
        if (object.seed_importData != null)
            if (typeof object.seed_importData === "string")
                $util.base64.decode(object.seed_importData, message.seed_importData = $util.newBuffer($util.base64.length(object.seed_importData)), 0);
            else if (object.seed_importData.length)
                message.seed_importData = object.seed_importData;
        return message;
    };

    BixinSeedOperate.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.type = options.enums === String ? "SeedRequestType_Gen" : 0;
            if (options.bytes === String)
                object.seed_importData = "";
            else {
                object.seed_importData = [];
                if (options.bytes !== Array)
                    object.seed_importData = $util.newBuffer(object.seed_importData);
            }
        }
        if (message.type != null && message.hasOwnProperty("type"))
            object.type = options.enums === String ? $root.BixinSeedOperate.SeedRequestType[message.type] : message.type;
        if (message.seed_importData != null && message.hasOwnProperty("seed_importData"))
            object.seed_importData = options.bytes === String ? $util.base64.encode(message.seed_importData, 0, message.seed_importData.length) : options.bytes === Array ? Array.prototype.slice.call(message.seed_importData) : message.seed_importData;
        return object;
    };

    BixinSeedOperate.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    BixinSeedOperate.SeedRequestType = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "SeedRequestType_Gen"] = 0;
        values[valuesById[1] = "SeedRequestType_EncExport"] = 1;
        values[valuesById[2] = "SeedRequestType_EncImport"] = 2;
        return values;
    })();

    return BixinSeedOperate;
})();

$root.BixinMessageSE = (function() {

    function BixinMessageSE(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    BixinMessageSE.prototype.inputmessage = $util.newBuffer([]);

    BixinMessageSE.create = function create(properties) {
        return new BixinMessageSE(properties);
    };

    BixinMessageSE.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.inputmessage);
        return writer;
    };

    BixinMessageSE.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    BixinMessageSE.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BixinMessageSE();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.inputmessage = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("inputmessage"))
            throw $util.ProtocolError("missing required 'inputmessage'", { instance: message });
        return message;
    };

    BixinMessageSE.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    BixinMessageSE.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.inputmessage && typeof message.inputmessage.length === "number" || $util.isString(message.inputmessage)))
            return "inputmessage: buffer expected";
        return null;
    };

    BixinMessageSE.fromObject = function fromObject(object) {
        if (object instanceof $root.BixinMessageSE)
            return object;
        var message = new $root.BixinMessageSE();
        if (object.inputmessage != null)
            if (typeof object.inputmessage === "string")
                $util.base64.decode(object.inputmessage, message.inputmessage = $util.newBuffer($util.base64.length(object.inputmessage)), 0);
            else if (object.inputmessage.length)
                message.inputmessage = object.inputmessage;
        return message;
    };

    BixinMessageSE.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.inputmessage = "";
            else {
                object.inputmessage = [];
                if (options.bytes !== Array)
                    object.inputmessage = $util.newBuffer(object.inputmessage);
            }
        if (message.inputmessage != null && message.hasOwnProperty("inputmessage"))
            object.inputmessage = options.bytes === String ? $util.base64.encode(message.inputmessage, 0, message.inputmessage.length) : options.bytes === Array ? Array.prototype.slice.call(message.inputmessage) : message.inputmessage;
        return object;
    };

    BixinMessageSE.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return BixinMessageSE;
})();

$root.BixinOutMessageSE = (function() {

    function BixinOutMessageSE(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    BixinOutMessageSE.prototype.outmessage = $util.newBuffer([]);

    BixinOutMessageSE.create = function create(properties) {
        return new BixinOutMessageSE(properties);
    };

    BixinOutMessageSE.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.outmessage != null && Object.hasOwnProperty.call(message, "outmessage"))
            writer.uint32(10).bytes(message.outmessage);
        return writer;
    };

    BixinOutMessageSE.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    BixinOutMessageSE.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BixinOutMessageSE();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.outmessage = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    BixinOutMessageSE.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    BixinOutMessageSE.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.outmessage != null && message.hasOwnProperty("outmessage"))
            if (!(message.outmessage && typeof message.outmessage.length === "number" || $util.isString(message.outmessage)))
                return "outmessage: buffer expected";
        return null;
    };

    BixinOutMessageSE.fromObject = function fromObject(object) {
        if (object instanceof $root.BixinOutMessageSE)
            return object;
        var message = new $root.BixinOutMessageSE();
        if (object.outmessage != null)
            if (typeof object.outmessage === "string")
                $util.base64.decode(object.outmessage, message.outmessage = $util.newBuffer($util.base64.length(object.outmessage)), 0);
            else if (object.outmessage.length)
                message.outmessage = object.outmessage;
        return message;
    };

    BixinOutMessageSE.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.outmessage = "";
            else {
                object.outmessage = [];
                if (options.bytes !== Array)
                    object.outmessage = $util.newBuffer(object.outmessage);
            }
        if (message.outmessage != null && message.hasOwnProperty("outmessage"))
            object.outmessage = options.bytes === String ? $util.base64.encode(message.outmessage, 0, message.outmessage.length) : options.bytes === Array ? Array.prototype.slice.call(message.outmessage) : message.outmessage;
        return object;
    };

    BixinOutMessageSE.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return BixinOutMessageSE;
})();

$root.DeviceBackToBoot = (function() {

    function DeviceBackToBoot(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DeviceBackToBoot.create = function create(properties) {
        return new DeviceBackToBoot(properties);
    };

    DeviceBackToBoot.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    DeviceBackToBoot.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DeviceBackToBoot.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DeviceBackToBoot();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    DeviceBackToBoot.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DeviceBackToBoot.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    DeviceBackToBoot.fromObject = function fromObject(object) {
        if (object instanceof $root.DeviceBackToBoot)
            return object;
        return new $root.DeviceBackToBoot();
    };

    DeviceBackToBoot.toObject = function toObject() {
        return {};
    };

    DeviceBackToBoot.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DeviceBackToBoot;
})();

$root.BixinBackupRequest = (function() {

    function BixinBackupRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    BixinBackupRequest.create = function create(properties) {
        return new BixinBackupRequest(properties);
    };

    BixinBackupRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    BixinBackupRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    BixinBackupRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BixinBackupRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    BixinBackupRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    BixinBackupRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    BixinBackupRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.BixinBackupRequest)
            return object;
        return new $root.BixinBackupRequest();
    };

    BixinBackupRequest.toObject = function toObject() {
        return {};
    };

    BixinBackupRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return BixinBackupRequest;
})();

$root.BixinBackupAck = (function() {

    function BixinBackupAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    BixinBackupAck.prototype.data = $util.newBuffer([]);

    BixinBackupAck.create = function create(properties) {
        return new BixinBackupAck(properties);
    };

    BixinBackupAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.data);
        return writer;
    };

    BixinBackupAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    BixinBackupAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BixinBackupAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.data = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("data"))
            throw $util.ProtocolError("missing required 'data'", { instance: message });
        return message;
    };

    BixinBackupAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    BixinBackupAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
            return "data: buffer expected";
        return null;
    };

    BixinBackupAck.fromObject = function fromObject(object) {
        if (object instanceof $root.BixinBackupAck)
            return object;
        var message = new $root.BixinBackupAck();
        if (object.data != null)
            if (typeof object.data === "string")
                $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
            else if (object.data.length)
                message.data = object.data;
        return message;
    };

    BixinBackupAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.data = "";
            else {
                object.data = [];
                if (options.bytes !== Array)
                    object.data = $util.newBuffer(object.data);
            }
        if (message.data != null && message.hasOwnProperty("data"))
            object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
        return object;
    };

    BixinBackupAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return BixinBackupAck;
})();

$root.BixinRestoreRequest = (function() {

    function BixinRestoreRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    BixinRestoreRequest.prototype.data = $util.newBuffer([]);
    BixinRestoreRequest.prototype.language = "";
    BixinRestoreRequest.prototype.label = "";
    BixinRestoreRequest.prototype.passphrase_protection = false;

    BixinRestoreRequest.create = function create(properties) {
        return new BixinRestoreRequest(properties);
    };

    BixinRestoreRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.data);
        if (message.language != null && Object.hasOwnProperty.call(message, "language"))
            writer.uint32(18).string(message.language);
        if (message.label != null && Object.hasOwnProperty.call(message, "label"))
            writer.uint32(26).string(message.label);
        if (message.passphrase_protection != null && Object.hasOwnProperty.call(message, "passphrase_protection"))
            writer.uint32(32).bool(message.passphrase_protection);
        return writer;
    };

    BixinRestoreRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    BixinRestoreRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BixinRestoreRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.data = reader.bytes();
                break;
            case 2:
                message.language = reader.string();
                break;
            case 3:
                message.label = reader.string();
                break;
            case 4:
                message.passphrase_protection = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("data"))
            throw $util.ProtocolError("missing required 'data'", { instance: message });
        return message;
    };

    BixinRestoreRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    BixinRestoreRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
            return "data: buffer expected";
        if (message.language != null && message.hasOwnProperty("language"))
            if (!$util.isString(message.language))
                return "language: string expected";
        if (message.label != null && message.hasOwnProperty("label"))
            if (!$util.isString(message.label))
                return "label: string expected";
        if (message.passphrase_protection != null && message.hasOwnProperty("passphrase_protection"))
            if (typeof message.passphrase_protection !== "boolean")
                return "passphrase_protection: boolean expected";
        return null;
    };

    BixinRestoreRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.BixinRestoreRequest)
            return object;
        var message = new $root.BixinRestoreRequest();
        if (object.data != null)
            if (typeof object.data === "string")
                $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
            else if (object.data.length)
                message.data = object.data;
        if (object.language != null)
            message.language = String(object.language);
        if (object.label != null)
            message.label = String(object.label);
        if (object.passphrase_protection != null)
            message.passphrase_protection = Boolean(object.passphrase_protection);
        return message;
    };

    BixinRestoreRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.data = "";
            else {
                object.data = [];
                if (options.bytes !== Array)
                    object.data = $util.newBuffer(object.data);
            }
            object.language = "";
            object.label = "";
            object.passphrase_protection = false;
        }
        if (message.data != null && message.hasOwnProperty("data"))
            object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
        if (message.language != null && message.hasOwnProperty("language"))
            object.language = message.language;
        if (message.label != null && message.hasOwnProperty("label"))
            object.label = message.label;
        if (message.passphrase_protection != null && message.hasOwnProperty("passphrase_protection"))
            object.passphrase_protection = message.passphrase_protection;
        return object;
    };

    BixinRestoreRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return BixinRestoreRequest;
})();

$root.BixinRestoreAck = (function() {

    function BixinRestoreAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    BixinRestoreAck.prototype.data = $util.newBuffer([]);

    BixinRestoreAck.create = function create(properties) {
        return new BixinRestoreAck(properties);
    };

    BixinRestoreAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.data);
        return writer;
    };

    BixinRestoreAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    BixinRestoreAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BixinRestoreAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.data = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("data"))
            throw $util.ProtocolError("missing required 'data'", { instance: message });
        return message;
    };

    BixinRestoreAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    BixinRestoreAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
            return "data: buffer expected";
        return null;
    };

    BixinRestoreAck.fromObject = function fromObject(object) {
        if (object instanceof $root.BixinRestoreAck)
            return object;
        var message = new $root.BixinRestoreAck();
        if (object.data != null)
            if (typeof object.data === "string")
                $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
            else if (object.data.length)
                message.data = object.data;
        return message;
    };

    BixinRestoreAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.data = "";
            else {
                object.data = [];
                if (options.bytes !== Array)
                    object.data = $util.newBuffer(object.data);
            }
        if (message.data != null && message.hasOwnProperty("data"))
            object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
        return object;
    };

    BixinRestoreAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return BixinRestoreAck;
})();

$root.BixinVerifyDeviceRequest = (function() {

    function BixinVerifyDeviceRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    BixinVerifyDeviceRequest.prototype.data = $util.newBuffer([]);

    BixinVerifyDeviceRequest.create = function create(properties) {
        return new BixinVerifyDeviceRequest(properties);
    };

    BixinVerifyDeviceRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.data);
        return writer;
    };

    BixinVerifyDeviceRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    BixinVerifyDeviceRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BixinVerifyDeviceRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.data = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("data"))
            throw $util.ProtocolError("missing required 'data'", { instance: message });
        return message;
    };

    BixinVerifyDeviceRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    BixinVerifyDeviceRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
            return "data: buffer expected";
        return null;
    };

    BixinVerifyDeviceRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.BixinVerifyDeviceRequest)
            return object;
        var message = new $root.BixinVerifyDeviceRequest();
        if (object.data != null)
            if (typeof object.data === "string")
                $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
            else if (object.data.length)
                message.data = object.data;
        return message;
    };

    BixinVerifyDeviceRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.data = "";
            else {
                object.data = [];
                if (options.bytes !== Array)
                    object.data = $util.newBuffer(object.data);
            }
        if (message.data != null && message.hasOwnProperty("data"))
            object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
        return object;
    };

    BixinVerifyDeviceRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return BixinVerifyDeviceRequest;
})();

$root.BixinVerifyDeviceAck = (function() {

    function BixinVerifyDeviceAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    BixinVerifyDeviceAck.prototype.cert = $util.newBuffer([]);
    BixinVerifyDeviceAck.prototype.signature = $util.newBuffer([]);

    BixinVerifyDeviceAck.create = function create(properties) {
        return new BixinVerifyDeviceAck(properties);
    };

    BixinVerifyDeviceAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.cert);
        writer.uint32(18).bytes(message.signature);
        return writer;
    };

    BixinVerifyDeviceAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    BixinVerifyDeviceAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BixinVerifyDeviceAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.cert = reader.bytes();
                break;
            case 2:
                message.signature = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("cert"))
            throw $util.ProtocolError("missing required 'cert'", { instance: message });
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        return message;
    };

    BixinVerifyDeviceAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    BixinVerifyDeviceAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.cert && typeof message.cert.length === "number" || $util.isString(message.cert)))
            return "cert: buffer expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        return null;
    };

    BixinVerifyDeviceAck.fromObject = function fromObject(object) {
        if (object instanceof $root.BixinVerifyDeviceAck)
            return object;
        var message = new $root.BixinVerifyDeviceAck();
        if (object.cert != null)
            if (typeof object.cert === "string")
                $util.base64.decode(object.cert, message.cert = $util.newBuffer($util.base64.length(object.cert)), 0);
            else if (object.cert.length)
                message.cert = object.cert;
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        return message;
    };

    BixinVerifyDeviceAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.cert = "";
            else {
                object.cert = [];
                if (options.bytes !== Array)
                    object.cert = $util.newBuffer(object.cert);
            }
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
        }
        if (message.cert != null && message.hasOwnProperty("cert"))
            object.cert = options.bytes === String ? $util.base64.encode(message.cert, 0, message.cert.length) : options.bytes === Array ? Array.prototype.slice.call(message.cert) : message.cert;
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        return object;
    };

    BixinVerifyDeviceAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return BixinVerifyDeviceAck;
})();

$root.BixinWhiteListRequest = (function() {

    function BixinWhiteListRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    BixinWhiteListRequest.prototype.type = 0;
    BixinWhiteListRequest.prototype.addr_in = "";

    BixinWhiteListRequest.create = function create(properties) {
        return new BixinWhiteListRequest(properties);
    };

    BixinWhiteListRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).int32(message.type);
        if (message.addr_in != null && Object.hasOwnProperty.call(message, "addr_in"))
            writer.uint32(18).string(message.addr_in);
        return writer;
    };

    BixinWhiteListRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    BixinWhiteListRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BixinWhiteListRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.type = reader.int32();
                break;
            case 2:
                message.addr_in = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("type"))
            throw $util.ProtocolError("missing required 'type'", { instance: message });
        return message;
    };

    BixinWhiteListRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    BixinWhiteListRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        switch (message.type) {
        default:
            return "type: enum value expected";
        case 0:
        case 1:
        case 2:
            break;
        }
        if (message.addr_in != null && message.hasOwnProperty("addr_in"))
            if (!$util.isString(message.addr_in))
                return "addr_in: string expected";
        return null;
    };

    BixinWhiteListRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.BixinWhiteListRequest)
            return object;
        var message = new $root.BixinWhiteListRequest();
        switch (object.type) {
        case "WL_OperationType_Add":
        case 0:
            message.type = 0;
            break;
        case "WL_OperationType_Delete":
        case 1:
            message.type = 1;
            break;
        case "WL_OperationType_Inquire":
        case 2:
            message.type = 2;
            break;
        }
        if (object.addr_in != null)
            message.addr_in = String(object.addr_in);
        return message;
    };

    BixinWhiteListRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.type = options.enums === String ? "WL_OperationType_Add" : 0;
            object.addr_in = "";
        }
        if (message.type != null && message.hasOwnProperty("type"))
            object.type = options.enums === String ? $root.BixinWhiteListRequest.WL_OperationType[message.type] : message.type;
        if (message.addr_in != null && message.hasOwnProperty("addr_in"))
            object.addr_in = message.addr_in;
        return object;
    };

    BixinWhiteListRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    BixinWhiteListRequest.WL_OperationType = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "WL_OperationType_Add"] = 0;
        values[valuesById[1] = "WL_OperationType_Delete"] = 1;
        values[valuesById[2] = "WL_OperationType_Inquire"] = 2;
        return values;
    })();

    return BixinWhiteListRequest;
})();

$root.BixinWhiteListAck = (function() {

    function BixinWhiteListAck(properties) {
        this.address = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    BixinWhiteListAck.prototype.address = $util.emptyArray;

    BixinWhiteListAck.create = function create(properties) {
        return new BixinWhiteListAck(properties);
    };

    BixinWhiteListAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address != null && message.address.length)
            for (var i = 0; i < message.address.length; ++i)
                writer.uint32(10).string(message.address[i]);
        return writer;
    };

    BixinWhiteListAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    BixinWhiteListAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BixinWhiteListAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address && message.address.length))
                    message.address = [];
                message.address.push(reader.string());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    BixinWhiteListAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    BixinWhiteListAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address != null && message.hasOwnProperty("address")) {
            if (!Array.isArray(message.address))
                return "address: array expected";
            for (var i = 0; i < message.address.length; ++i)
                if (!$util.isString(message.address[i]))
                    return "address: string[] expected";
        }
        return null;
    };

    BixinWhiteListAck.fromObject = function fromObject(object) {
        if (object instanceof $root.BixinWhiteListAck)
            return object;
        var message = new $root.BixinWhiteListAck();
        if (object.address) {
            if (!Array.isArray(object.address))
                throw TypeError(".BixinWhiteListAck.address: array expected");
            message.address = [];
            for (var i = 0; i < object.address.length; ++i)
                message.address[i] = String(object.address[i]);
        }
        return message;
    };

    BixinWhiteListAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address = [];
        if (message.address && message.address.length) {
            object.address = [];
            for (var j = 0; j < message.address.length; ++j)
                object.address[j] = message.address[j];
        }
        return object;
    };

    BixinWhiteListAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return BixinWhiteListAck;
})();

$root.BixinLoadDevice = (function() {

    function BixinLoadDevice(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    BixinLoadDevice.prototype.mnemonics = "";
    BixinLoadDevice.prototype.language = "en-US";
    BixinLoadDevice.prototype.label = "";
    BixinLoadDevice.prototype.skip_checksum = false;

    BixinLoadDevice.create = function create(properties) {
        return new BixinLoadDevice(properties);
    };

    BixinLoadDevice.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.mnemonics);
        if (message.language != null && Object.hasOwnProperty.call(message, "language"))
            writer.uint32(42).string(message.language);
        if (message.label != null && Object.hasOwnProperty.call(message, "label"))
            writer.uint32(50).string(message.label);
        if (message.skip_checksum != null && Object.hasOwnProperty.call(message, "skip_checksum"))
            writer.uint32(56).bool(message.skip_checksum);
        return writer;
    };

    BixinLoadDevice.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    BixinLoadDevice.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BixinLoadDevice();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.mnemonics = reader.string();
                break;
            case 5:
                message.language = reader.string();
                break;
            case 6:
                message.label = reader.string();
                break;
            case 7:
                message.skip_checksum = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("mnemonics"))
            throw $util.ProtocolError("missing required 'mnemonics'", { instance: message });
        return message;
    };

    BixinLoadDevice.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    BixinLoadDevice.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.mnemonics))
            return "mnemonics: string expected";
        if (message.language != null && message.hasOwnProperty("language"))
            if (!$util.isString(message.language))
                return "language: string expected";
        if (message.label != null && message.hasOwnProperty("label"))
            if (!$util.isString(message.label))
                return "label: string expected";
        if (message.skip_checksum != null && message.hasOwnProperty("skip_checksum"))
            if (typeof message.skip_checksum !== "boolean")
                return "skip_checksum: boolean expected";
        return null;
    };

    BixinLoadDevice.fromObject = function fromObject(object) {
        if (object instanceof $root.BixinLoadDevice)
            return object;
        var message = new $root.BixinLoadDevice();
        if (object.mnemonics != null)
            message.mnemonics = String(object.mnemonics);
        if (object.language != null)
            message.language = String(object.language);
        if (object.label != null)
            message.label = String(object.label);
        if (object.skip_checksum != null)
            message.skip_checksum = Boolean(object.skip_checksum);
        return message;
    };

    BixinLoadDevice.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.mnemonics = "";
            object.language = "en-US";
            object.label = "";
            object.skip_checksum = false;
        }
        if (message.mnemonics != null && message.hasOwnProperty("mnemonics"))
            object.mnemonics = message.mnemonics;
        if (message.language != null && message.hasOwnProperty("language"))
            object.language = message.language;
        if (message.label != null && message.hasOwnProperty("label"))
            object.label = message.label;
        if (message.skip_checksum != null && message.hasOwnProperty("skip_checksum"))
            object.skip_checksum = message.skip_checksum;
        return object;
    };

    BixinLoadDevice.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return BixinLoadDevice;
})();

$root.BixinBackupDevice = (function() {

    function BixinBackupDevice(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    BixinBackupDevice.create = function create(properties) {
        return new BixinBackupDevice(properties);
    };

    BixinBackupDevice.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    BixinBackupDevice.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    BixinBackupDevice.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BixinBackupDevice();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    BixinBackupDevice.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    BixinBackupDevice.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    BixinBackupDevice.fromObject = function fromObject(object) {
        if (object instanceof $root.BixinBackupDevice)
            return object;
        return new $root.BixinBackupDevice();
    };

    BixinBackupDevice.toObject = function toObject() {
        return {};
    };

    BixinBackupDevice.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return BixinBackupDevice;
})();

$root.BixinBackupDeviceAck = (function() {

    function BixinBackupDeviceAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    BixinBackupDeviceAck.prototype.mnemonics = "";

    BixinBackupDeviceAck.create = function create(properties) {
        return new BixinBackupDeviceAck(properties);
    };

    BixinBackupDeviceAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.mnemonics);
        return writer;
    };

    BixinBackupDeviceAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    BixinBackupDeviceAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BixinBackupDeviceAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.mnemonics = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("mnemonics"))
            throw $util.ProtocolError("missing required 'mnemonics'", { instance: message });
        return message;
    };

    BixinBackupDeviceAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    BixinBackupDeviceAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.mnemonics))
            return "mnemonics: string expected";
        return null;
    };

    BixinBackupDeviceAck.fromObject = function fromObject(object) {
        if (object instanceof $root.BixinBackupDeviceAck)
            return object;
        var message = new $root.BixinBackupDeviceAck();
        if (object.mnemonics != null)
            message.mnemonics = String(object.mnemonics);
        return message;
    };

    BixinBackupDeviceAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.mnemonics = "";
        if (message.mnemonics != null && message.hasOwnProperty("mnemonics"))
            object.mnemonics = message.mnemonics;
        return object;
    };

    BixinBackupDeviceAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return BixinBackupDeviceAck;
})();

$root.DeviceInfoSettings = (function() {

    function DeviceInfoSettings(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DeviceInfoSettings.prototype.serial_no = "";
    DeviceInfoSettings.prototype.cpu_info = "";
    DeviceInfoSettings.prototype.pre_firmware = "";

    DeviceInfoSettings.create = function create(properties) {
        return new DeviceInfoSettings(properties);
    };

    DeviceInfoSettings.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.serial_no != null && Object.hasOwnProperty.call(message, "serial_no"))
            writer.uint32(10).string(message.serial_no);
        if (message.cpu_info != null && Object.hasOwnProperty.call(message, "cpu_info"))
            writer.uint32(18).string(message.cpu_info);
        if (message.pre_firmware != null && Object.hasOwnProperty.call(message, "pre_firmware"))
            writer.uint32(26).string(message.pre_firmware);
        return writer;
    };

    DeviceInfoSettings.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DeviceInfoSettings.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DeviceInfoSettings();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.serial_no = reader.string();
                break;
            case 2:
                message.cpu_info = reader.string();
                break;
            case 3:
                message.pre_firmware = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    DeviceInfoSettings.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DeviceInfoSettings.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.serial_no != null && message.hasOwnProperty("serial_no"))
            if (!$util.isString(message.serial_no))
                return "serial_no: string expected";
        if (message.cpu_info != null && message.hasOwnProperty("cpu_info"))
            if (!$util.isString(message.cpu_info))
                return "cpu_info: string expected";
        if (message.pre_firmware != null && message.hasOwnProperty("pre_firmware"))
            if (!$util.isString(message.pre_firmware))
                return "pre_firmware: string expected";
        return null;
    };

    DeviceInfoSettings.fromObject = function fromObject(object) {
        if (object instanceof $root.DeviceInfoSettings)
            return object;
        var message = new $root.DeviceInfoSettings();
        if (object.serial_no != null)
            message.serial_no = String(object.serial_no);
        if (object.cpu_info != null)
            message.cpu_info = String(object.cpu_info);
        if (object.pre_firmware != null)
            message.pre_firmware = String(object.pre_firmware);
        return message;
    };

    DeviceInfoSettings.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.serial_no = "";
            object.cpu_info = "";
            object.pre_firmware = "";
        }
        if (message.serial_no != null && message.hasOwnProperty("serial_no"))
            object.serial_no = message.serial_no;
        if (message.cpu_info != null && message.hasOwnProperty("cpu_info"))
            object.cpu_info = message.cpu_info;
        if (message.pre_firmware != null && message.hasOwnProperty("pre_firmware"))
            object.pre_firmware = message.pre_firmware;
        return object;
    };

    DeviceInfoSettings.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DeviceInfoSettings;
})();

$root.GetDeviceInfo = (function() {

    function GetDeviceInfo(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    GetDeviceInfo.create = function create(properties) {
        return new GetDeviceInfo(properties);
    };

    GetDeviceInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    GetDeviceInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    GetDeviceInfo.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.GetDeviceInfo();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    GetDeviceInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    GetDeviceInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    GetDeviceInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.GetDeviceInfo)
            return object;
        return new $root.GetDeviceInfo();
    };

    GetDeviceInfo.toObject = function toObject() {
        return {};
    };

    GetDeviceInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return GetDeviceInfo;
})();

$root.DeviceInfo = (function() {

    function DeviceInfo(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DeviceInfo.prototype.serial_no = "";
    DeviceInfo.prototype.spiFlash_info = "";
    DeviceInfo.prototype.SE_info = "";
    DeviceInfo.prototype.NFT_voucher = $util.newBuffer([]);
    DeviceInfo.prototype.cpu_info = "";
    DeviceInfo.prototype.pre_firmware = "";

    DeviceInfo.create = function create(properties) {
        return new DeviceInfo(properties);
    };

    DeviceInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.serial_no != null && Object.hasOwnProperty.call(message, "serial_no"))
            writer.uint32(10).string(message.serial_no);
        if (message.spiFlash_info != null && Object.hasOwnProperty.call(message, "spiFlash_info"))
            writer.uint32(18).string(message.spiFlash_info);
        if (message.SE_info != null && Object.hasOwnProperty.call(message, "SE_info"))
            writer.uint32(26).string(message.SE_info);
        if (message.NFT_voucher != null && Object.hasOwnProperty.call(message, "NFT_voucher"))
            writer.uint32(34).bytes(message.NFT_voucher);
        if (message.cpu_info != null && Object.hasOwnProperty.call(message, "cpu_info"))
            writer.uint32(42).string(message.cpu_info);
        if (message.pre_firmware != null && Object.hasOwnProperty.call(message, "pre_firmware"))
            writer.uint32(50).string(message.pre_firmware);
        return writer;
    };

    DeviceInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DeviceInfo.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DeviceInfo();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.serial_no = reader.string();
                break;
            case 2:
                message.spiFlash_info = reader.string();
                break;
            case 3:
                message.SE_info = reader.string();
                break;
            case 4:
                message.NFT_voucher = reader.bytes();
                break;
            case 5:
                message.cpu_info = reader.string();
                break;
            case 6:
                message.pre_firmware = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    DeviceInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DeviceInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.serial_no != null && message.hasOwnProperty("serial_no"))
            if (!$util.isString(message.serial_no))
                return "serial_no: string expected";
        if (message.spiFlash_info != null && message.hasOwnProperty("spiFlash_info"))
            if (!$util.isString(message.spiFlash_info))
                return "spiFlash_info: string expected";
        if (message.SE_info != null && message.hasOwnProperty("SE_info"))
            if (!$util.isString(message.SE_info))
                return "SE_info: string expected";
        if (message.NFT_voucher != null && message.hasOwnProperty("NFT_voucher"))
            if (!(message.NFT_voucher && typeof message.NFT_voucher.length === "number" || $util.isString(message.NFT_voucher)))
                return "NFT_voucher: buffer expected";
        if (message.cpu_info != null && message.hasOwnProperty("cpu_info"))
            if (!$util.isString(message.cpu_info))
                return "cpu_info: string expected";
        if (message.pre_firmware != null && message.hasOwnProperty("pre_firmware"))
            if (!$util.isString(message.pre_firmware))
                return "pre_firmware: string expected";
        return null;
    };

    DeviceInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.DeviceInfo)
            return object;
        var message = new $root.DeviceInfo();
        if (object.serial_no != null)
            message.serial_no = String(object.serial_no);
        if (object.spiFlash_info != null)
            message.spiFlash_info = String(object.spiFlash_info);
        if (object.SE_info != null)
            message.SE_info = String(object.SE_info);
        if (object.NFT_voucher != null)
            if (typeof object.NFT_voucher === "string")
                $util.base64.decode(object.NFT_voucher, message.NFT_voucher = $util.newBuffer($util.base64.length(object.NFT_voucher)), 0);
            else if (object.NFT_voucher.length)
                message.NFT_voucher = object.NFT_voucher;
        if (object.cpu_info != null)
            message.cpu_info = String(object.cpu_info);
        if (object.pre_firmware != null)
            message.pre_firmware = String(object.pre_firmware);
        return message;
    };

    DeviceInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.serial_no = "";
            object.spiFlash_info = "";
            object.SE_info = "";
            if (options.bytes === String)
                object.NFT_voucher = "";
            else {
                object.NFT_voucher = [];
                if (options.bytes !== Array)
                    object.NFT_voucher = $util.newBuffer(object.NFT_voucher);
            }
            object.cpu_info = "";
            object.pre_firmware = "";
        }
        if (message.serial_no != null && message.hasOwnProperty("serial_no"))
            object.serial_no = message.serial_no;
        if (message.spiFlash_info != null && message.hasOwnProperty("spiFlash_info"))
            object.spiFlash_info = message.spiFlash_info;
        if (message.SE_info != null && message.hasOwnProperty("SE_info"))
            object.SE_info = message.SE_info;
        if (message.NFT_voucher != null && message.hasOwnProperty("NFT_voucher"))
            object.NFT_voucher = options.bytes === String ? $util.base64.encode(message.NFT_voucher, 0, message.NFT_voucher.length) : options.bytes === Array ? Array.prototype.slice.call(message.NFT_voucher) : message.NFT_voucher;
        if (message.cpu_info != null && message.hasOwnProperty("cpu_info"))
            object.cpu_info = message.cpu_info;
        if (message.pre_firmware != null && message.hasOwnProperty("pre_firmware"))
            object.pre_firmware = message.pre_firmware;
        return object;
    };

    DeviceInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DeviceInfo;
})();

$root.ReadSEPublicKey = (function() {

    function ReadSEPublicKey(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ReadSEPublicKey.create = function create(properties) {
        return new ReadSEPublicKey(properties);
    };

    ReadSEPublicKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    ReadSEPublicKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ReadSEPublicKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ReadSEPublicKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    ReadSEPublicKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ReadSEPublicKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    ReadSEPublicKey.fromObject = function fromObject(object) {
        if (object instanceof $root.ReadSEPublicKey)
            return object;
        return new $root.ReadSEPublicKey();
    };

    ReadSEPublicKey.toObject = function toObject() {
        return {};
    };

    ReadSEPublicKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ReadSEPublicKey;
})();

$root.SEPublicKey = (function() {

    function SEPublicKey(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    SEPublicKey.prototype.public_key = $util.newBuffer([]);

    SEPublicKey.create = function create(properties) {
        return new SEPublicKey(properties);
    };

    SEPublicKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.public_key);
        return writer;
    };

    SEPublicKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    SEPublicKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SEPublicKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.public_key = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("public_key"))
            throw $util.ProtocolError("missing required 'public_key'", { instance: message });
        return message;
    };

    SEPublicKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    SEPublicKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.public_key && typeof message.public_key.length === "number" || $util.isString(message.public_key)))
            return "public_key: buffer expected";
        return null;
    };

    SEPublicKey.fromObject = function fromObject(object) {
        if (object instanceof $root.SEPublicKey)
            return object;
        var message = new $root.SEPublicKey();
        if (object.public_key != null)
            if (typeof object.public_key === "string")
                $util.base64.decode(object.public_key, message.public_key = $util.newBuffer($util.base64.length(object.public_key)), 0);
            else if (object.public_key.length)
                message.public_key = object.public_key;
        return message;
    };

    SEPublicKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.public_key = "";
            else {
                object.public_key = [];
                if (options.bytes !== Array)
                    object.public_key = $util.newBuffer(object.public_key);
            }
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            object.public_key = options.bytes === String ? $util.base64.encode(message.public_key, 0, message.public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.public_key) : message.public_key;
        return object;
    };

    SEPublicKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SEPublicKey;
})();

$root.WriteSEPublicCert = (function() {

    function WriteSEPublicCert(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    WriteSEPublicCert.prototype.public_cert = $util.newBuffer([]);

    WriteSEPublicCert.create = function create(properties) {
        return new WriteSEPublicCert(properties);
    };

    WriteSEPublicCert.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.public_cert);
        return writer;
    };

    WriteSEPublicCert.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    WriteSEPublicCert.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.WriteSEPublicCert();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.public_cert = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("public_cert"))
            throw $util.ProtocolError("missing required 'public_cert'", { instance: message });
        return message;
    };

    WriteSEPublicCert.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    WriteSEPublicCert.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.public_cert && typeof message.public_cert.length === "number" || $util.isString(message.public_cert)))
            return "public_cert: buffer expected";
        return null;
    };

    WriteSEPublicCert.fromObject = function fromObject(object) {
        if (object instanceof $root.WriteSEPublicCert)
            return object;
        var message = new $root.WriteSEPublicCert();
        if (object.public_cert != null)
            if (typeof object.public_cert === "string")
                $util.base64.decode(object.public_cert, message.public_cert = $util.newBuffer($util.base64.length(object.public_cert)), 0);
            else if (object.public_cert.length)
                message.public_cert = object.public_cert;
        return message;
    };

    WriteSEPublicCert.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.public_cert = "";
            else {
                object.public_cert = [];
                if (options.bytes !== Array)
                    object.public_cert = $util.newBuffer(object.public_cert);
            }
        if (message.public_cert != null && message.hasOwnProperty("public_cert"))
            object.public_cert = options.bytes === String ? $util.base64.encode(message.public_cert, 0, message.public_cert.length) : options.bytes === Array ? Array.prototype.slice.call(message.public_cert) : message.public_cert;
        return object;
    };

    WriteSEPublicCert.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return WriteSEPublicCert;
})();

$root.ReadSEPublicCert = (function() {

    function ReadSEPublicCert(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ReadSEPublicCert.create = function create(properties) {
        return new ReadSEPublicCert(properties);
    };

    ReadSEPublicCert.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    ReadSEPublicCert.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ReadSEPublicCert.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ReadSEPublicCert();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    ReadSEPublicCert.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ReadSEPublicCert.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    ReadSEPublicCert.fromObject = function fromObject(object) {
        if (object instanceof $root.ReadSEPublicCert)
            return object;
        return new $root.ReadSEPublicCert();
    };

    ReadSEPublicCert.toObject = function toObject() {
        return {};
    };

    ReadSEPublicCert.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ReadSEPublicCert;
})();

$root.SEPublicCert = (function() {

    function SEPublicCert(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    SEPublicCert.prototype.public_cert = $util.newBuffer([]);

    SEPublicCert.create = function create(properties) {
        return new SEPublicCert(properties);
    };

    SEPublicCert.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.public_cert);
        return writer;
    };

    SEPublicCert.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    SEPublicCert.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SEPublicCert();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.public_cert = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("public_cert"))
            throw $util.ProtocolError("missing required 'public_cert'", { instance: message });
        return message;
    };

    SEPublicCert.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    SEPublicCert.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.public_cert && typeof message.public_cert.length === "number" || $util.isString(message.public_cert)))
            return "public_cert: buffer expected";
        return null;
    };

    SEPublicCert.fromObject = function fromObject(object) {
        if (object instanceof $root.SEPublicCert)
            return object;
        var message = new $root.SEPublicCert();
        if (object.public_cert != null)
            if (typeof object.public_cert === "string")
                $util.base64.decode(object.public_cert, message.public_cert = $util.newBuffer($util.base64.length(object.public_cert)), 0);
            else if (object.public_cert.length)
                message.public_cert = object.public_cert;
        return message;
    };

    SEPublicCert.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.public_cert = "";
            else {
                object.public_cert = [];
                if (options.bytes !== Array)
                    object.public_cert = $util.newBuffer(object.public_cert);
            }
        if (message.public_cert != null && message.hasOwnProperty("public_cert"))
            object.public_cert = options.bytes === String ? $util.base64.encode(message.public_cert, 0, message.public_cert.length) : options.bytes === Array ? Array.prototype.slice.call(message.public_cert) : message.public_cert;
        return object;
    };

    SEPublicCert.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SEPublicCert;
})();

$root.SpiFlashWrite = (function() {

    function SpiFlashWrite(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    SpiFlashWrite.prototype.address = 0;
    SpiFlashWrite.prototype.data = $util.newBuffer([]);

    SpiFlashWrite.create = function create(properties) {
        return new SpiFlashWrite(properties);
    };

    SpiFlashWrite.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).uint32(message.address);
        writer.uint32(18).bytes(message.data);
        return writer;
    };

    SpiFlashWrite.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    SpiFlashWrite.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SpiFlashWrite();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.uint32();
                break;
            case 2:
                message.data = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("address"))
            throw $util.ProtocolError("missing required 'address'", { instance: message });
        if (!message.hasOwnProperty("data"))
            throw $util.ProtocolError("missing required 'data'", { instance: message });
        return message;
    };

    SpiFlashWrite.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    SpiFlashWrite.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isInteger(message.address))
            return "address: integer expected";
        if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
            return "data: buffer expected";
        return null;
    };

    SpiFlashWrite.fromObject = function fromObject(object) {
        if (object instanceof $root.SpiFlashWrite)
            return object;
        var message = new $root.SpiFlashWrite();
        if (object.address != null)
            message.address = object.address >>> 0;
        if (object.data != null)
            if (typeof object.data === "string")
                $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
            else if (object.data.length)
                message.data = object.data;
        return message;
    };

    SpiFlashWrite.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.address = 0;
            if (options.bytes === String)
                object.data = "";
            else {
                object.data = [];
                if (options.bytes !== Array)
                    object.data = $util.newBuffer(object.data);
            }
        }
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        if (message.data != null && message.hasOwnProperty("data"))
            object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
        return object;
    };

    SpiFlashWrite.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SpiFlashWrite;
})();

$root.SpiFlashRead = (function() {

    function SpiFlashRead(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    SpiFlashRead.prototype.address = 0;
    SpiFlashRead.prototype.len = 0;

    SpiFlashRead.create = function create(properties) {
        return new SpiFlashRead(properties);
    };

    SpiFlashRead.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).uint32(message.address);
        writer.uint32(16).uint32(message.len);
        return writer;
    };

    SpiFlashRead.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    SpiFlashRead.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SpiFlashRead();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.uint32();
                break;
            case 2:
                message.len = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("address"))
            throw $util.ProtocolError("missing required 'address'", { instance: message });
        if (!message.hasOwnProperty("len"))
            throw $util.ProtocolError("missing required 'len'", { instance: message });
        return message;
    };

    SpiFlashRead.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    SpiFlashRead.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isInteger(message.address))
            return "address: integer expected";
        if (!$util.isInteger(message.len))
            return "len: integer expected";
        return null;
    };

    SpiFlashRead.fromObject = function fromObject(object) {
        if (object instanceof $root.SpiFlashRead)
            return object;
        var message = new $root.SpiFlashRead();
        if (object.address != null)
            message.address = object.address >>> 0;
        if (object.len != null)
            message.len = object.len >>> 0;
        return message;
    };

    SpiFlashRead.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.address = 0;
            object.len = 0;
        }
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        if (message.len != null && message.hasOwnProperty("len"))
            object.len = message.len;
        return object;
    };

    SpiFlashRead.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SpiFlashRead;
})();

$root.SpiFlashData = (function() {

    function SpiFlashData(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    SpiFlashData.prototype.data = $util.newBuffer([]);

    SpiFlashData.create = function create(properties) {
        return new SpiFlashData(properties);
    };

    SpiFlashData.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.data);
        return writer;
    };

    SpiFlashData.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    SpiFlashData.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SpiFlashData();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.data = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("data"))
            throw $util.ProtocolError("missing required 'data'", { instance: message });
        return message;
    };

    SpiFlashData.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    SpiFlashData.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
            return "data: buffer expected";
        return null;
    };

    SpiFlashData.fromObject = function fromObject(object) {
        if (object instanceof $root.SpiFlashData)
            return object;
        var message = new $root.SpiFlashData();
        if (object.data != null)
            if (typeof object.data === "string")
                $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
            else if (object.data.length)
                message.data = object.data;
        return message;
    };

    SpiFlashData.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.data = "";
            else {
                object.data = [];
                if (options.bytes !== Array)
                    object.data = $util.newBuffer(object.data);
            }
        if (message.data != null && message.hasOwnProperty("data"))
            object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
        return object;
    };

    SpiFlashData.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SpiFlashData;
})();

$root.SESignMessage = (function() {

    function SESignMessage(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    SESignMessage.prototype.message = $util.newBuffer([]);

    SESignMessage.create = function create(properties) {
        return new SESignMessage(properties);
    };

    SESignMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.message);
        return writer;
    };

    SESignMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    SESignMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SESignMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.message = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("message"))
            throw $util.ProtocolError("missing required 'message'", { instance: message });
        return message;
    };

    SESignMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    SESignMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.message && typeof message.message.length === "number" || $util.isString(message.message)))
            return "message: buffer expected";
        return null;
    };

    SESignMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.SESignMessage)
            return object;
        var message = new $root.SESignMessage();
        if (object.message != null)
            if (typeof object.message === "string")
                $util.base64.decode(object.message, message.message = $util.newBuffer($util.base64.length(object.message)), 0);
            else if (object.message.length)
                message.message = object.message;
        return message;
    };

    SESignMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.message = "";
            else {
                object.message = [];
                if (options.bytes !== Array)
                    object.message = $util.newBuffer(object.message);
            }
        if (message.message != null && message.hasOwnProperty("message"))
            object.message = options.bytes === String ? $util.base64.encode(message.message, 0, message.message.length) : options.bytes === Array ? Array.prototype.slice.call(message.message) : message.message;
        return object;
    };

    SESignMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SESignMessage;
})();

$root.SEMessageSignature = (function() {

    function SEMessageSignature(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    SEMessageSignature.prototype.signature = $util.newBuffer([]);

    SEMessageSignature.create = function create(properties) {
        return new SEMessageSignature(properties);
    };

    SEMessageSignature.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.signature);
        return writer;
    };

    SEMessageSignature.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    SEMessageSignature.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SEMessageSignature();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.signature = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        return message;
    };

    SEMessageSignature.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    SEMessageSignature.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        return null;
    };

    SEMessageSignature.fromObject = function fromObject(object) {
        if (object instanceof $root.SEMessageSignature)
            return object;
        var message = new $root.SEMessageSignature();
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        return message;
    };

    SEMessageSignature.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        return object;
    };

    SEMessageSignature.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SEMessageSignature;
})();

$root.ResourceUpload = (function() {

    function ResourceUpload(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ResourceUpload.prototype.extension = "";
    ResourceUpload.prototype.data_length = 0;
    ResourceUpload.prototype.res_type = 0;
    ResourceUpload.prototype.nft_meta_data = $util.newBuffer([]);
    ResourceUpload.prototype.zoom_data_length = 0;
    ResourceUpload.prototype.file_name_no_ext = "";
    ResourceUpload.prototype.blur_data_length = 0;

    ResourceUpload.create = function create(properties) {
        return new ResourceUpload(properties);
    };

    ResourceUpload.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.extension);
        writer.uint32(16).uint32(message.data_length);
        writer.uint32(24).int32(message.res_type);
        if (message.nft_meta_data != null && Object.hasOwnProperty.call(message, "nft_meta_data"))
            writer.uint32(34).bytes(message.nft_meta_data);
        writer.uint32(40).uint32(message.zoom_data_length);
        if (message.file_name_no_ext != null && Object.hasOwnProperty.call(message, "file_name_no_ext"))
            writer.uint32(50).string(message.file_name_no_ext);
        if (message.blur_data_length != null && Object.hasOwnProperty.call(message, "blur_data_length"))
            writer.uint32(56).uint32(message.blur_data_length);
        return writer;
    };

    ResourceUpload.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ResourceUpload.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ResourceUpload();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.extension = reader.string();
                break;
            case 2:
                message.data_length = reader.uint32();
                break;
            case 3:
                message.res_type = reader.int32();
                break;
            case 4:
                message.nft_meta_data = reader.bytes();
                break;
            case 5:
                message.zoom_data_length = reader.uint32();
                break;
            case 6:
                message.file_name_no_ext = reader.string();
                break;
            case 7:
                message.blur_data_length = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("extension"))
            throw $util.ProtocolError("missing required 'extension'", { instance: message });
        if (!message.hasOwnProperty("data_length"))
            throw $util.ProtocolError("missing required 'data_length'", { instance: message });
        if (!message.hasOwnProperty("res_type"))
            throw $util.ProtocolError("missing required 'res_type'", { instance: message });
        if (!message.hasOwnProperty("zoom_data_length"))
            throw $util.ProtocolError("missing required 'zoom_data_length'", { instance: message });
        return message;
    };

    ResourceUpload.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ResourceUpload.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.extension))
            return "extension: string expected";
        if (!$util.isInteger(message.data_length))
            return "data_length: integer expected";
        switch (message.res_type) {
        default:
            return "res_type: enum value expected";
        case 0:
        case 1:
            break;
        }
        if (message.nft_meta_data != null && message.hasOwnProperty("nft_meta_data"))
            if (!(message.nft_meta_data && typeof message.nft_meta_data.length === "number" || $util.isString(message.nft_meta_data)))
                return "nft_meta_data: buffer expected";
        if (!$util.isInteger(message.zoom_data_length))
            return "zoom_data_length: integer expected";
        if (message.file_name_no_ext != null && message.hasOwnProperty("file_name_no_ext"))
            if (!$util.isString(message.file_name_no_ext))
                return "file_name_no_ext: string expected";
        if (message.blur_data_length != null && message.hasOwnProperty("blur_data_length"))
            if (!$util.isInteger(message.blur_data_length))
                return "blur_data_length: integer expected";
        return null;
    };

    ResourceUpload.fromObject = function fromObject(object) {
        if (object instanceof $root.ResourceUpload)
            return object;
        var message = new $root.ResourceUpload();
        if (object.extension != null)
            message.extension = String(object.extension);
        if (object.data_length != null)
            message.data_length = object.data_length >>> 0;
        switch (object.res_type) {
        case "WallPaper":
        case 0:
            message.res_type = 0;
            break;
        case "Nft":
        case 1:
            message.res_type = 1;
            break;
        }
        if (object.nft_meta_data != null)
            if (typeof object.nft_meta_data === "string")
                $util.base64.decode(object.nft_meta_data, message.nft_meta_data = $util.newBuffer($util.base64.length(object.nft_meta_data)), 0);
            else if (object.nft_meta_data.length)
                message.nft_meta_data = object.nft_meta_data;
        if (object.zoom_data_length != null)
            message.zoom_data_length = object.zoom_data_length >>> 0;
        if (object.file_name_no_ext != null)
            message.file_name_no_ext = String(object.file_name_no_ext);
        if (object.blur_data_length != null)
            message.blur_data_length = object.blur_data_length >>> 0;
        return message;
    };

    ResourceUpload.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.extension = "";
            object.data_length = 0;
            object.res_type = options.enums === String ? "WallPaper" : 0;
            if (options.bytes === String)
                object.nft_meta_data = "";
            else {
                object.nft_meta_data = [];
                if (options.bytes !== Array)
                    object.nft_meta_data = $util.newBuffer(object.nft_meta_data);
            }
            object.zoom_data_length = 0;
            object.file_name_no_ext = "";
            object.blur_data_length = 0;
        }
        if (message.extension != null && message.hasOwnProperty("extension"))
            object.extension = message.extension;
        if (message.data_length != null && message.hasOwnProperty("data_length"))
            object.data_length = message.data_length;
        if (message.res_type != null && message.hasOwnProperty("res_type"))
            object.res_type = options.enums === String ? $root.ResourceUpload.ResourceType[message.res_type] : message.res_type;
        if (message.nft_meta_data != null && message.hasOwnProperty("nft_meta_data"))
            object.nft_meta_data = options.bytes === String ? $util.base64.encode(message.nft_meta_data, 0, message.nft_meta_data.length) : options.bytes === Array ? Array.prototype.slice.call(message.nft_meta_data) : message.nft_meta_data;
        if (message.zoom_data_length != null && message.hasOwnProperty("zoom_data_length"))
            object.zoom_data_length = message.zoom_data_length;
        if (message.file_name_no_ext != null && message.hasOwnProperty("file_name_no_ext"))
            object.file_name_no_ext = message.file_name_no_ext;
        if (message.blur_data_length != null && message.hasOwnProperty("blur_data_length"))
            object.blur_data_length = message.blur_data_length;
        return object;
    };

    ResourceUpload.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    ResourceUpload.ResourceType = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "WallPaper"] = 0;
        values[valuesById[1] = "Nft"] = 1;
        return values;
    })();

    return ResourceUpload;
})();

$root.ZoomRequest = (function() {

    function ZoomRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ZoomRequest.prototype.offset = 0;
    ZoomRequest.prototype.data_length = 0;

    ZoomRequest.create = function create(properties) {
        return new ZoomRequest(properties);
    };

    ZoomRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.offset != null && Object.hasOwnProperty.call(message, "offset"))
            writer.uint32(8).uint32(message.offset);
        writer.uint32(16).uint32(message.data_length);
        return writer;
    };

    ZoomRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ZoomRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ZoomRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.offset = reader.uint32();
                break;
            case 2:
                message.data_length = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("data_length"))
            throw $util.ProtocolError("missing required 'data_length'", { instance: message });
        return message;
    };

    ZoomRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ZoomRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.offset != null && message.hasOwnProperty("offset"))
            if (!$util.isInteger(message.offset))
                return "offset: integer expected";
        if (!$util.isInteger(message.data_length))
            return "data_length: integer expected";
        return null;
    };

    ZoomRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.ZoomRequest)
            return object;
        var message = new $root.ZoomRequest();
        if (object.offset != null)
            message.offset = object.offset >>> 0;
        if (object.data_length != null)
            message.data_length = object.data_length >>> 0;
        return message;
    };

    ZoomRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.offset = 0;
            object.data_length = 0;
        }
        if (message.offset != null && message.hasOwnProperty("offset"))
            object.offset = message.offset;
        if (message.data_length != null && message.hasOwnProperty("data_length"))
            object.data_length = message.data_length;
        return object;
    };

    ZoomRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ZoomRequest;
})();

$root.BlurRequest = (function() {

    function BlurRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    BlurRequest.prototype.offset = 0;
    BlurRequest.prototype.data_length = 0;

    BlurRequest.create = function create(properties) {
        return new BlurRequest(properties);
    };

    BlurRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.offset != null && Object.hasOwnProperty.call(message, "offset"))
            writer.uint32(8).uint32(message.offset);
        writer.uint32(16).uint32(message.data_length);
        return writer;
    };

    BlurRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    BlurRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BlurRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.offset = reader.uint32();
                break;
            case 2:
                message.data_length = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("data_length"))
            throw $util.ProtocolError("missing required 'data_length'", { instance: message });
        return message;
    };

    BlurRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    BlurRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.offset != null && message.hasOwnProperty("offset"))
            if (!$util.isInteger(message.offset))
                return "offset: integer expected";
        if (!$util.isInteger(message.data_length))
            return "data_length: integer expected";
        return null;
    };

    BlurRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.BlurRequest)
            return object;
        var message = new $root.BlurRequest();
        if (object.offset != null)
            message.offset = object.offset >>> 0;
        if (object.data_length != null)
            message.data_length = object.data_length >>> 0;
        return message;
    };

    BlurRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.offset = 0;
            object.data_length = 0;
        }
        if (message.offset != null && message.hasOwnProperty("offset"))
            object.offset = message.offset;
        if (message.data_length != null && message.hasOwnProperty("data_length"))
            object.data_length = message.data_length;
        return object;
    };

    BlurRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return BlurRequest;
})();

$root.ResourceRequest = (function() {

    function ResourceRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ResourceRequest.prototype.offset = 0;
    ResourceRequest.prototype.data_length = 0;

    ResourceRequest.create = function create(properties) {
        return new ResourceRequest(properties);
    };

    ResourceRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.offset != null && Object.hasOwnProperty.call(message, "offset"))
            writer.uint32(8).uint32(message.offset);
        writer.uint32(16).uint32(message.data_length);
        return writer;
    };

    ResourceRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ResourceRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ResourceRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.offset = reader.uint32();
                break;
            case 2:
                message.data_length = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("data_length"))
            throw $util.ProtocolError("missing required 'data_length'", { instance: message });
        return message;
    };

    ResourceRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ResourceRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.offset != null && message.hasOwnProperty("offset"))
            if (!$util.isInteger(message.offset))
                return "offset: integer expected";
        if (!$util.isInteger(message.data_length))
            return "data_length: integer expected";
        return null;
    };

    ResourceRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.ResourceRequest)
            return object;
        var message = new $root.ResourceRequest();
        if (object.offset != null)
            message.offset = object.offset >>> 0;
        if (object.data_length != null)
            message.data_length = object.data_length >>> 0;
        return message;
    };

    ResourceRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.offset = 0;
            object.data_length = 0;
        }
        if (message.offset != null && message.hasOwnProperty("offset"))
            object.offset = message.offset;
        if (message.data_length != null && message.hasOwnProperty("data_length"))
            object.data_length = message.data_length;
        return object;
    };

    ResourceRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ResourceRequest;
})();

$root.ResourceAck = (function() {

    function ResourceAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ResourceAck.prototype.data_chunk = $util.newBuffer([]);
    ResourceAck.prototype.hash = $util.newBuffer([]);

    ResourceAck.create = function create(properties) {
        return new ResourceAck(properties);
    };

    ResourceAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.data_chunk);
        if (message.hash != null && Object.hasOwnProperty.call(message, "hash"))
            writer.uint32(18).bytes(message.hash);
        return writer;
    };

    ResourceAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ResourceAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ResourceAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.data_chunk = reader.bytes();
                break;
            case 2:
                message.hash = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("data_chunk"))
            throw $util.ProtocolError("missing required 'data_chunk'", { instance: message });
        return message;
    };

    ResourceAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ResourceAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.data_chunk && typeof message.data_chunk.length === "number" || $util.isString(message.data_chunk)))
            return "data_chunk: buffer expected";
        if (message.hash != null && message.hasOwnProperty("hash"))
            if (!(message.hash && typeof message.hash.length === "number" || $util.isString(message.hash)))
                return "hash: buffer expected";
        return null;
    };

    ResourceAck.fromObject = function fromObject(object) {
        if (object instanceof $root.ResourceAck)
            return object;
        var message = new $root.ResourceAck();
        if (object.data_chunk != null)
            if (typeof object.data_chunk === "string")
                $util.base64.decode(object.data_chunk, message.data_chunk = $util.newBuffer($util.base64.length(object.data_chunk)), 0);
            else if (object.data_chunk.length)
                message.data_chunk = object.data_chunk;
        if (object.hash != null)
            if (typeof object.hash === "string")
                $util.base64.decode(object.hash, message.hash = $util.newBuffer($util.base64.length(object.hash)), 0);
            else if (object.hash.length)
                message.hash = object.hash;
        return message;
    };

    ResourceAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.data_chunk = "";
            else {
                object.data_chunk = [];
                if (options.bytes !== Array)
                    object.data_chunk = $util.newBuffer(object.data_chunk);
            }
            if (options.bytes === String)
                object.hash = "";
            else {
                object.hash = [];
                if (options.bytes !== Array)
                    object.hash = $util.newBuffer(object.hash);
            }
        }
        if (message.data_chunk != null && message.hasOwnProperty("data_chunk"))
            object.data_chunk = options.bytes === String ? $util.base64.encode(message.data_chunk, 0, message.data_chunk.length) : options.bytes === Array ? Array.prototype.slice.call(message.data_chunk) : message.data_chunk;
        if (message.hash != null && message.hasOwnProperty("hash"))
            object.hash = options.bytes === String ? $util.base64.encode(message.hash, 0, message.hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.hash) : message.hash;
        return object;
    };

    ResourceAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ResourceAck;
})();

$root.ResourceUpdate = (function() {

    function ResourceUpdate(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ResourceUpdate.prototype.file_name = "";
    ResourceUpdate.prototype.data_length = 0;
    ResourceUpdate.prototype.initial_data_chunk = $util.newBuffer([]);
    ResourceUpdate.prototype.hash = $util.newBuffer([]);

    ResourceUpdate.create = function create(properties) {
        return new ResourceUpdate(properties);
    };

    ResourceUpdate.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.file_name);
        writer.uint32(16).uint32(message.data_length);
        writer.uint32(26).bytes(message.initial_data_chunk);
        if (message.hash != null && Object.hasOwnProperty.call(message, "hash"))
            writer.uint32(34).bytes(message.hash);
        return writer;
    };

    ResourceUpdate.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ResourceUpdate.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ResourceUpdate();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.file_name = reader.string();
                break;
            case 2:
                message.data_length = reader.uint32();
                break;
            case 3:
                message.initial_data_chunk = reader.bytes();
                break;
            case 4:
                message.hash = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("file_name"))
            throw $util.ProtocolError("missing required 'file_name'", { instance: message });
        if (!message.hasOwnProperty("data_length"))
            throw $util.ProtocolError("missing required 'data_length'", { instance: message });
        if (!message.hasOwnProperty("initial_data_chunk"))
            throw $util.ProtocolError("missing required 'initial_data_chunk'", { instance: message });
        return message;
    };

    ResourceUpdate.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ResourceUpdate.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.file_name))
            return "file_name: string expected";
        if (!$util.isInteger(message.data_length))
            return "data_length: integer expected";
        if (!(message.initial_data_chunk && typeof message.initial_data_chunk.length === "number" || $util.isString(message.initial_data_chunk)))
            return "initial_data_chunk: buffer expected";
        if (message.hash != null && message.hasOwnProperty("hash"))
            if (!(message.hash && typeof message.hash.length === "number" || $util.isString(message.hash)))
                return "hash: buffer expected";
        return null;
    };

    ResourceUpdate.fromObject = function fromObject(object) {
        if (object instanceof $root.ResourceUpdate)
            return object;
        var message = new $root.ResourceUpdate();
        if (object.file_name != null)
            message.file_name = String(object.file_name);
        if (object.data_length != null)
            message.data_length = object.data_length >>> 0;
        if (object.initial_data_chunk != null)
            if (typeof object.initial_data_chunk === "string")
                $util.base64.decode(object.initial_data_chunk, message.initial_data_chunk = $util.newBuffer($util.base64.length(object.initial_data_chunk)), 0);
            else if (object.initial_data_chunk.length)
                message.initial_data_chunk = object.initial_data_chunk;
        if (object.hash != null)
            if (typeof object.hash === "string")
                $util.base64.decode(object.hash, message.hash = $util.newBuffer($util.base64.length(object.hash)), 0);
            else if (object.hash.length)
                message.hash = object.hash;
        return message;
    };

    ResourceUpdate.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.file_name = "";
            object.data_length = 0;
            if (options.bytes === String)
                object.initial_data_chunk = "";
            else {
                object.initial_data_chunk = [];
                if (options.bytes !== Array)
                    object.initial_data_chunk = $util.newBuffer(object.initial_data_chunk);
            }
            if (options.bytes === String)
                object.hash = "";
            else {
                object.hash = [];
                if (options.bytes !== Array)
                    object.hash = $util.newBuffer(object.hash);
            }
        }
        if (message.file_name != null && message.hasOwnProperty("file_name"))
            object.file_name = message.file_name;
        if (message.data_length != null && message.hasOwnProperty("data_length"))
            object.data_length = message.data_length;
        if (message.initial_data_chunk != null && message.hasOwnProperty("initial_data_chunk"))
            object.initial_data_chunk = options.bytes === String ? $util.base64.encode(message.initial_data_chunk, 0, message.initial_data_chunk.length) : options.bytes === Array ? Array.prototype.slice.call(message.initial_data_chunk) : message.initial_data_chunk;
        if (message.hash != null && message.hasOwnProperty("hash"))
            object.hash = options.bytes === String ? $util.base64.encode(message.hash, 0, message.hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.hash) : message.hash;
        return object;
    };

    ResourceUpdate.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ResourceUpdate;
})();

$root.NFTWriteInfo = (function() {

    function NFTWriteInfo(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NFTWriteInfo.prototype.index = 0;
    NFTWriteInfo.prototype.width = 0;
    NFTWriteInfo.prototype.height = 0;
    NFTWriteInfo.prototype.name_zh = "";
    NFTWriteInfo.prototype.name_en = "";

    NFTWriteInfo.create = function create(properties) {
        return new NFTWriteInfo(properties);
    };

    NFTWriteInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).uint32(message.index);
        writer.uint32(16).uint32(message.width);
        writer.uint32(24).uint32(message.height);
        if (message.name_zh != null && Object.hasOwnProperty.call(message, "name_zh"))
            writer.uint32(34).string(message.name_zh);
        if (message.name_en != null && Object.hasOwnProperty.call(message, "name_en"))
            writer.uint32(42).string(message.name_en);
        return writer;
    };

    NFTWriteInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NFTWriteInfo.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NFTWriteInfo();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.index = reader.uint32();
                break;
            case 2:
                message.width = reader.uint32();
                break;
            case 3:
                message.height = reader.uint32();
                break;
            case 4:
                message.name_zh = reader.string();
                break;
            case 5:
                message.name_en = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("index"))
            throw $util.ProtocolError("missing required 'index'", { instance: message });
        if (!message.hasOwnProperty("width"))
            throw $util.ProtocolError("missing required 'width'", { instance: message });
        if (!message.hasOwnProperty("height"))
            throw $util.ProtocolError("missing required 'height'", { instance: message });
        return message;
    };

    NFTWriteInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NFTWriteInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isInteger(message.index))
            return "index: integer expected";
        if (!$util.isInteger(message.width))
            return "width: integer expected";
        if (!$util.isInteger(message.height))
            return "height: integer expected";
        if (message.name_zh != null && message.hasOwnProperty("name_zh"))
            if (!$util.isString(message.name_zh))
                return "name_zh: string expected";
        if (message.name_en != null && message.hasOwnProperty("name_en"))
            if (!$util.isString(message.name_en))
                return "name_en: string expected";
        return null;
    };

    NFTWriteInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.NFTWriteInfo)
            return object;
        var message = new $root.NFTWriteInfo();
        if (object.index != null)
            message.index = object.index >>> 0;
        if (object.width != null)
            message.width = object.width >>> 0;
        if (object.height != null)
            message.height = object.height >>> 0;
        if (object.name_zh != null)
            message.name_zh = String(object.name_zh);
        if (object.name_en != null)
            message.name_en = String(object.name_en);
        return message;
    };

    NFTWriteInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.index = 0;
            object.width = 0;
            object.height = 0;
            object.name_zh = "";
            object.name_en = "";
        }
        if (message.index != null && message.hasOwnProperty("index"))
            object.index = message.index;
        if (message.width != null && message.hasOwnProperty("width"))
            object.width = message.width;
        if (message.height != null && message.hasOwnProperty("height"))
            object.height = message.height;
        if (message.name_zh != null && message.hasOwnProperty("name_zh"))
            object.name_zh = message.name_zh;
        if (message.name_en != null && message.hasOwnProperty("name_en"))
            object.name_en = message.name_en;
        return object;
    };

    NFTWriteInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NFTWriteInfo;
})();

$root.NFTWriteData = (function() {

    function NFTWriteData(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NFTWriteData.prototype.index = 0;
    NFTWriteData.prototype.data = $util.newBuffer([]);
    NFTWriteData.prototype.offset = 0;

    NFTWriteData.create = function create(properties) {
        return new NFTWriteData(properties);
    };

    NFTWriteData.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).uint32(message.index);
        writer.uint32(18).bytes(message.data);
        writer.uint32(24).uint32(message.offset);
        return writer;
    };

    NFTWriteData.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NFTWriteData.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NFTWriteData();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.index = reader.uint32();
                break;
            case 2:
                message.data = reader.bytes();
                break;
            case 3:
                message.offset = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("index"))
            throw $util.ProtocolError("missing required 'index'", { instance: message });
        if (!message.hasOwnProperty("data"))
            throw $util.ProtocolError("missing required 'data'", { instance: message });
        if (!message.hasOwnProperty("offset"))
            throw $util.ProtocolError("missing required 'offset'", { instance: message });
        return message;
    };

    NFTWriteData.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NFTWriteData.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isInteger(message.index))
            return "index: integer expected";
        if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
            return "data: buffer expected";
        if (!$util.isInteger(message.offset))
            return "offset: integer expected";
        return null;
    };

    NFTWriteData.fromObject = function fromObject(object) {
        if (object instanceof $root.NFTWriteData)
            return object;
        var message = new $root.NFTWriteData();
        if (object.index != null)
            message.index = object.index >>> 0;
        if (object.data != null)
            if (typeof object.data === "string")
                $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
            else if (object.data.length)
                message.data = object.data;
        if (object.offset != null)
            message.offset = object.offset >>> 0;
        return message;
    };

    NFTWriteData.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.index = 0;
            if (options.bytes === String)
                object.data = "";
            else {
                object.data = [];
                if (options.bytes !== Array)
                    object.data = $util.newBuffer(object.data);
            }
            object.offset = 0;
        }
        if (message.index != null && message.hasOwnProperty("index"))
            object.index = message.index;
        if (message.data != null && message.hasOwnProperty("data"))
            object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
        if (message.offset != null && message.hasOwnProperty("offset"))
            object.offset = message.offset;
        return object;
    };

    NFTWriteData.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NFTWriteData;
})();

$root.RebootToBootloader = (function() {

    function RebootToBootloader(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    RebootToBootloader.create = function create(properties) {
        return new RebootToBootloader(properties);
    };

    RebootToBootloader.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    RebootToBootloader.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    RebootToBootloader.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.RebootToBootloader();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    RebootToBootloader.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    RebootToBootloader.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    RebootToBootloader.fromObject = function fromObject(object) {
        if (object instanceof $root.RebootToBootloader)
            return object;
        return new $root.RebootToBootloader();
    };

    RebootToBootloader.toObject = function toObject() {
        return {};
    };

    RebootToBootloader.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return RebootToBootloader;
})();

$root.RebootToBoardloader = (function() {

    function RebootToBoardloader(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    RebootToBoardloader.create = function create(properties) {
        return new RebootToBoardloader(properties);
    };

    RebootToBoardloader.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    RebootToBoardloader.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    RebootToBoardloader.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.RebootToBoardloader();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    RebootToBoardloader.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    RebootToBoardloader.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    RebootToBoardloader.fromObject = function fromObject(object) {
        if (object instanceof $root.RebootToBoardloader)
            return object;
        return new $root.RebootToBoardloader();
    };

    RebootToBoardloader.toObject = function toObject() {
        return {};
    };

    RebootToBoardloader.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return RebootToBoardloader;
})();

$root.ListResDir = (function() {

    function ListResDir(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ListResDir.prototype.path = "";

    ListResDir.create = function create(properties) {
        return new ListResDir(properties);
    };

    ListResDir.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.path);
        return writer;
    };

    ListResDir.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ListResDir.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ListResDir();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.path = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("path"))
            throw $util.ProtocolError("missing required 'path'", { instance: message });
        return message;
    };

    ListResDir.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ListResDir.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.path))
            return "path: string expected";
        return null;
    };

    ListResDir.fromObject = function fromObject(object) {
        if (object instanceof $root.ListResDir)
            return object;
        var message = new $root.ListResDir();
        if (object.path != null)
            message.path = String(object.path);
        return message;
    };

    ListResDir.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.path = "";
        if (message.path != null && message.hasOwnProperty("path"))
            object.path = message.path;
        return object;
    };

    ListResDir.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ListResDir;
})();

$root.FileInfoList = (function() {

    function FileInfoList(properties) {
        this.files = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    FileInfoList.prototype.files = $util.emptyArray;

    FileInfoList.create = function create(properties) {
        return new FileInfoList(properties);
    };

    FileInfoList.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.files != null && message.files.length)
            for (var i = 0; i < message.files.length; ++i)
                $root.FileInfoList.FileInfo.encode(message.files[i], writer.uint32(10).fork()).ldelim();
        return writer;
    };

    FileInfoList.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    FileInfoList.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.FileInfoList();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.files && message.files.length))
                    message.files = [];
                message.files.push($root.FileInfoList.FileInfo.decode(reader, reader.uint32()));
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    FileInfoList.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    FileInfoList.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.files != null && message.hasOwnProperty("files")) {
            if (!Array.isArray(message.files))
                return "files: array expected";
            for (var i = 0; i < message.files.length; ++i) {
                var error = $root.FileInfoList.FileInfo.verify(message.files[i]);
                if (error)
                    return "files." + error;
            }
        }
        return null;
    };

    FileInfoList.fromObject = function fromObject(object) {
        if (object instanceof $root.FileInfoList)
            return object;
        var message = new $root.FileInfoList();
        if (object.files) {
            if (!Array.isArray(object.files))
                throw TypeError(".FileInfoList.files: array expected");
            message.files = [];
            for (var i = 0; i < object.files.length; ++i) {
                if (typeof object.files[i] !== "object")
                    throw TypeError(".FileInfoList.files: object expected");
                message.files[i] = $root.FileInfoList.FileInfo.fromObject(object.files[i]);
            }
        }
        return message;
    };

    FileInfoList.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.files = [];
        if (message.files && message.files.length) {
            object.files = [];
            for (var j = 0; j < message.files.length; ++j)
                object.files[j] = $root.FileInfoList.FileInfo.toObject(message.files[j], options);
        }
        return object;
    };

    FileInfoList.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    FileInfoList.FileInfo = (function() {

        function FileInfo(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        FileInfo.prototype.name = "";
        FileInfo.prototype.size = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        FileInfo.create = function create(properties) {
            return new FileInfo(properties);
        };

        FileInfo.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(10).string(message.name);
            writer.uint32(16).uint64(message.size);
            return writer;
        };

        FileInfo.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        FileInfo.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.FileInfoList.FileInfo();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.name = reader.string();
                    break;
                case 2:
                    message.size = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("name"))
                throw $util.ProtocolError("missing required 'name'", { instance: message });
            if (!message.hasOwnProperty("size"))
                throw $util.ProtocolError("missing required 'size'", { instance: message });
            return message;
        };

        FileInfo.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        FileInfo.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isString(message.name))
                return "name: string expected";
            if (!$util.isInteger(message.size) && !(message.size && $util.isInteger(message.size.low) && $util.isInteger(message.size.high)))
                return "size: integer|Long expected";
            return null;
        };

        FileInfo.fromObject = function fromObject(object) {
            if (object instanceof $root.FileInfoList.FileInfo)
                return object;
            var message = new $root.FileInfoList.FileInfo();
            if (object.name != null)
                message.name = String(object.name);
            if (object.size != null)
                if ($util.Long)
                    (message.size = $util.Long.fromValue(object.size)).unsigned = true;
                else if (typeof object.size === "string")
                    message.size = parseInt(object.size, 10);
                else if (typeof object.size === "number")
                    message.size = object.size;
                else if (typeof object.size === "object")
                    message.size = new $util.LongBits(object.size.low >>> 0, object.size.high >>> 0).toNumber(true);
            return message;
        };

        FileInfo.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.name = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.size = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.size = options.longs === String ? "0" : 0;
            }
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.size != null && message.hasOwnProperty("size"))
                if (typeof message.size === "number")
                    object.size = options.longs === String ? String(message.size) : message.size;
                else
                    object.size = options.longs === String ? $util.Long.prototype.toString.call(message.size) : options.longs === Number ? new $util.LongBits(message.size.low >>> 0, message.size.high >>> 0).toNumber(true) : message.size;
            return object;
        };

        FileInfo.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return FileInfo;
    })();

    return FileInfoList;
})();

$root.DeviceEraseSector = (function() {

    function DeviceEraseSector(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DeviceEraseSector.prototype.sector = 0;

    DeviceEraseSector.create = function create(properties) {
        return new DeviceEraseSector(properties);
    };

    DeviceEraseSector.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).uint32(message.sector);
        return writer;
    };

    DeviceEraseSector.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DeviceEraseSector.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DeviceEraseSector();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.sector = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("sector"))
            throw $util.ProtocolError("missing required 'sector'", { instance: message });
        return message;
    };

    DeviceEraseSector.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DeviceEraseSector.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isInteger(message.sector))
            return "sector: integer expected";
        return null;
    };

    DeviceEraseSector.fromObject = function fromObject(object) {
        if (object instanceof $root.DeviceEraseSector)
            return object;
        var message = new $root.DeviceEraseSector();
        if (object.sector != null)
            message.sector = object.sector >>> 0;
        return message;
    };

    DeviceEraseSector.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.sector = 0;
        if (message.sector != null && message.hasOwnProperty("sector"))
            object.sector = message.sector;
        return object;
    };

    DeviceEraseSector.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DeviceEraseSector;
})();

$root.UnLockDevice = (function() {

    function UnLockDevice(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    UnLockDevice.create = function create(properties) {
        return new UnLockDevice(properties);
    };

    UnLockDevice.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    UnLockDevice.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    UnLockDevice.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.UnLockDevice();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    UnLockDevice.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    UnLockDevice.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    UnLockDevice.fromObject = function fromObject(object) {
        if (object instanceof $root.UnLockDevice)
            return object;
        return new $root.UnLockDevice();
    };

    UnLockDevice.toObject = function toObject() {
        return {};
    };

    UnLockDevice.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return UnLockDevice;
})();

$root.UnLockDeviceResponse = (function() {

    function UnLockDeviceResponse(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    UnLockDeviceResponse.prototype.unlocked = false;
    UnLockDeviceResponse.prototype.unlocked_attach_pin = false;
    UnLockDeviceResponse.prototype.passphrase_protection = false;

    UnLockDeviceResponse.create = function create(properties) {
        return new UnLockDeviceResponse(properties);
    };

    UnLockDeviceResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.unlocked != null && Object.hasOwnProperty.call(message, "unlocked"))
            writer.uint32(8).bool(message.unlocked);
        if (message.unlocked_attach_pin != null && Object.hasOwnProperty.call(message, "unlocked_attach_pin"))
            writer.uint32(16).bool(message.unlocked_attach_pin);
        if (message.passphrase_protection != null && Object.hasOwnProperty.call(message, "passphrase_protection"))
            writer.uint32(24).bool(message.passphrase_protection);
        return writer;
    };

    UnLockDeviceResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    UnLockDeviceResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.UnLockDeviceResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.unlocked = reader.bool();
                break;
            case 2:
                message.unlocked_attach_pin = reader.bool();
                break;
            case 3:
                message.passphrase_protection = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    UnLockDeviceResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    UnLockDeviceResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.unlocked != null && message.hasOwnProperty("unlocked"))
            if (typeof message.unlocked !== "boolean")
                return "unlocked: boolean expected";
        if (message.unlocked_attach_pin != null && message.hasOwnProperty("unlocked_attach_pin"))
            if (typeof message.unlocked_attach_pin !== "boolean")
                return "unlocked_attach_pin: boolean expected";
        if (message.passphrase_protection != null && message.hasOwnProperty("passphrase_protection"))
            if (typeof message.passphrase_protection !== "boolean")
                return "passphrase_protection: boolean expected";
        return null;
    };

    UnLockDeviceResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.UnLockDeviceResponse)
            return object;
        var message = new $root.UnLockDeviceResponse();
        if (object.unlocked != null)
            message.unlocked = Boolean(object.unlocked);
        if (object.unlocked_attach_pin != null)
            message.unlocked_attach_pin = Boolean(object.unlocked_attach_pin);
        if (object.passphrase_protection != null)
            message.passphrase_protection = Boolean(object.passphrase_protection);
        return message;
    };

    UnLockDeviceResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.unlocked = false;
            object.unlocked_attach_pin = false;
            object.passphrase_protection = false;
        }
        if (message.unlocked != null && message.hasOwnProperty("unlocked"))
            object.unlocked = message.unlocked;
        if (message.unlocked_attach_pin != null && message.hasOwnProperty("unlocked_attach_pin"))
            object.unlocked_attach_pin = message.unlocked_attach_pin;
        if (message.passphrase_protection != null && message.hasOwnProperty("passphrase_protection"))
            object.passphrase_protection = message.passphrase_protection;
        return object;
    };

    UnLockDeviceResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return UnLockDeviceResponse;
})();

$root.GetPassphraseState = (function() {

    function GetPassphraseState(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    GetPassphraseState.prototype.passphrase_state = "";

    GetPassphraseState.create = function create(properties) {
        return new GetPassphraseState(properties);
    };

    GetPassphraseState.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.passphrase_state != null && Object.hasOwnProperty.call(message, "passphrase_state"))
            writer.uint32(10).string(message.passphrase_state);
        return writer;
    };

    GetPassphraseState.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    GetPassphraseState.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.GetPassphraseState();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.passphrase_state = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    GetPassphraseState.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    GetPassphraseState.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.passphrase_state != null && message.hasOwnProperty("passphrase_state"))
            if (!$util.isString(message.passphrase_state))
                return "passphrase_state: string expected";
        return null;
    };

    GetPassphraseState.fromObject = function fromObject(object) {
        if (object instanceof $root.GetPassphraseState)
            return object;
        var message = new $root.GetPassphraseState();
        if (object.passphrase_state != null)
            message.passphrase_state = String(object.passphrase_state);
        return message;
    };

    GetPassphraseState.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.passphrase_state = "";
        if (message.passphrase_state != null && message.hasOwnProperty("passphrase_state"))
            object.passphrase_state = message.passphrase_state;
        return object;
    };

    GetPassphraseState.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return GetPassphraseState;
})();

$root.PassphraseState = (function() {

    function PassphraseState(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    PassphraseState.prototype.passphrase_state = "";
    PassphraseState.prototype.session_id = $util.newBuffer([]);
    PassphraseState.prototype.unlocked_attach_pin = false;

    PassphraseState.create = function create(properties) {
        return new PassphraseState(properties);
    };

    PassphraseState.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.passphrase_state != null && Object.hasOwnProperty.call(message, "passphrase_state"))
            writer.uint32(10).string(message.passphrase_state);
        if (message.session_id != null && Object.hasOwnProperty.call(message, "session_id"))
            writer.uint32(18).bytes(message.session_id);
        if (message.unlocked_attach_pin != null && Object.hasOwnProperty.call(message, "unlocked_attach_pin"))
            writer.uint32(24).bool(message.unlocked_attach_pin);
        return writer;
    };

    PassphraseState.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    PassphraseState.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.PassphraseState();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.passphrase_state = reader.string();
                break;
            case 2:
                message.session_id = reader.bytes();
                break;
            case 3:
                message.unlocked_attach_pin = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    PassphraseState.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    PassphraseState.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.passphrase_state != null && message.hasOwnProperty("passphrase_state"))
            if (!$util.isString(message.passphrase_state))
                return "passphrase_state: string expected";
        if (message.session_id != null && message.hasOwnProperty("session_id"))
            if (!(message.session_id && typeof message.session_id.length === "number" || $util.isString(message.session_id)))
                return "session_id: buffer expected";
        if (message.unlocked_attach_pin != null && message.hasOwnProperty("unlocked_attach_pin"))
            if (typeof message.unlocked_attach_pin !== "boolean")
                return "unlocked_attach_pin: boolean expected";
        return null;
    };

    PassphraseState.fromObject = function fromObject(object) {
        if (object instanceof $root.PassphraseState)
            return object;
        var message = new $root.PassphraseState();
        if (object.passphrase_state != null)
            message.passphrase_state = String(object.passphrase_state);
        if (object.session_id != null)
            if (typeof object.session_id === "string")
                $util.base64.decode(object.session_id, message.session_id = $util.newBuffer($util.base64.length(object.session_id)), 0);
            else if (object.session_id.length)
                message.session_id = object.session_id;
        if (object.unlocked_attach_pin != null)
            message.unlocked_attach_pin = Boolean(object.unlocked_attach_pin);
        return message;
    };

    PassphraseState.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.passphrase_state = "";
            if (options.bytes === String)
                object.session_id = "";
            else {
                object.session_id = [];
                if (options.bytes !== Array)
                    object.session_id = $util.newBuffer(object.session_id);
            }
            object.unlocked_attach_pin = false;
        }
        if (message.passphrase_state != null && message.hasOwnProperty("passphrase_state"))
            object.passphrase_state = message.passphrase_state;
        if (message.session_id != null && message.hasOwnProperty("session_id"))
            object.session_id = options.bytes === String ? $util.base64.encode(message.session_id, 0, message.session_id.length) : options.bytes === Array ? Array.prototype.slice.call(message.session_id) : message.session_id;
        if (message.unlocked_attach_pin != null && message.hasOwnProperty("unlocked_attach_pin"))
            object.unlocked_attach_pin = message.unlocked_attach_pin;
        return object;
    };

    PassphraseState.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return PassphraseState;
})();

$root.MoneroTransactionSourceEntry = (function() {

    function MoneroTransactionSourceEntry(properties) {
        this.outputs = [];
        this.real_out_additional_tx_keys = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroTransactionSourceEntry.prototype.outputs = $util.emptyArray;
    MoneroTransactionSourceEntry.prototype.real_output = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    MoneroTransactionSourceEntry.prototype.real_out_tx_key = $util.newBuffer([]);
    MoneroTransactionSourceEntry.prototype.real_out_additional_tx_keys = $util.emptyArray;
    MoneroTransactionSourceEntry.prototype.real_output_in_tx_index = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    MoneroTransactionSourceEntry.prototype.amount = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    MoneroTransactionSourceEntry.prototype.rct = false;
    MoneroTransactionSourceEntry.prototype.mask = $util.newBuffer([]);
    MoneroTransactionSourceEntry.prototype.multisig_kLRki = null;
    MoneroTransactionSourceEntry.prototype.subaddr_minor = 0;

    MoneroTransactionSourceEntry.create = function create(properties) {
        return new MoneroTransactionSourceEntry(properties);
    };

    MoneroTransactionSourceEntry.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.outputs != null && message.outputs.length)
            for (var i = 0; i < message.outputs.length; ++i)
                $root.MoneroTransactionSourceEntry.MoneroOutputEntry.encode(message.outputs[i], writer.uint32(10).fork()).ldelim();
        if (message.real_output != null && Object.hasOwnProperty.call(message, "real_output"))
            writer.uint32(16).uint64(message.real_output);
        if (message.real_out_tx_key != null && Object.hasOwnProperty.call(message, "real_out_tx_key"))
            writer.uint32(26).bytes(message.real_out_tx_key);
        if (message.real_out_additional_tx_keys != null && message.real_out_additional_tx_keys.length)
            for (var i = 0; i < message.real_out_additional_tx_keys.length; ++i)
                writer.uint32(34).bytes(message.real_out_additional_tx_keys[i]);
        if (message.real_output_in_tx_index != null && Object.hasOwnProperty.call(message, "real_output_in_tx_index"))
            writer.uint32(40).uint64(message.real_output_in_tx_index);
        if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
            writer.uint32(48).uint64(message.amount);
        if (message.rct != null && Object.hasOwnProperty.call(message, "rct"))
            writer.uint32(56).bool(message.rct);
        if (message.mask != null && Object.hasOwnProperty.call(message, "mask"))
            writer.uint32(66).bytes(message.mask);
        if (message.multisig_kLRki != null && Object.hasOwnProperty.call(message, "multisig_kLRki"))
            $root.MoneroTransactionSourceEntry.MoneroMultisigKLRki.encode(message.multisig_kLRki, writer.uint32(74).fork()).ldelim();
        if (message.subaddr_minor != null && Object.hasOwnProperty.call(message, "subaddr_minor"))
            writer.uint32(80).uint32(message.subaddr_minor);
        return writer;
    };

    MoneroTransactionSourceEntry.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroTransactionSourceEntry.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroTransactionSourceEntry();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.outputs && message.outputs.length))
                    message.outputs = [];
                message.outputs.push($root.MoneroTransactionSourceEntry.MoneroOutputEntry.decode(reader, reader.uint32()));
                break;
            case 2:
                message.real_output = reader.uint64();
                break;
            case 3:
                message.real_out_tx_key = reader.bytes();
                break;
            case 4:
                if (!(message.real_out_additional_tx_keys && message.real_out_additional_tx_keys.length))
                    message.real_out_additional_tx_keys = [];
                message.real_out_additional_tx_keys.push(reader.bytes());
                break;
            case 5:
                message.real_output_in_tx_index = reader.uint64();
                break;
            case 6:
                message.amount = reader.uint64();
                break;
            case 7:
                message.rct = reader.bool();
                break;
            case 8:
                message.mask = reader.bytes();
                break;
            case 9:
                message.multisig_kLRki = $root.MoneroTransactionSourceEntry.MoneroMultisigKLRki.decode(reader, reader.uint32());
                break;
            case 10:
                message.subaddr_minor = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroTransactionSourceEntry.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroTransactionSourceEntry.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.outputs != null && message.hasOwnProperty("outputs")) {
            if (!Array.isArray(message.outputs))
                return "outputs: array expected";
            for (var i = 0; i < message.outputs.length; ++i) {
                var error = $root.MoneroTransactionSourceEntry.MoneroOutputEntry.verify(message.outputs[i]);
                if (error)
                    return "outputs." + error;
            }
        }
        if (message.real_output != null && message.hasOwnProperty("real_output"))
            if (!$util.isInteger(message.real_output) && !(message.real_output && $util.isInteger(message.real_output.low) && $util.isInteger(message.real_output.high)))
                return "real_output: integer|Long expected";
        if (message.real_out_tx_key != null && message.hasOwnProperty("real_out_tx_key"))
            if (!(message.real_out_tx_key && typeof message.real_out_tx_key.length === "number" || $util.isString(message.real_out_tx_key)))
                return "real_out_tx_key: buffer expected";
        if (message.real_out_additional_tx_keys != null && message.hasOwnProperty("real_out_additional_tx_keys")) {
            if (!Array.isArray(message.real_out_additional_tx_keys))
                return "real_out_additional_tx_keys: array expected";
            for (var i = 0; i < message.real_out_additional_tx_keys.length; ++i)
                if (!(message.real_out_additional_tx_keys[i] && typeof message.real_out_additional_tx_keys[i].length === "number" || $util.isString(message.real_out_additional_tx_keys[i])))
                    return "real_out_additional_tx_keys: buffer[] expected";
        }
        if (message.real_output_in_tx_index != null && message.hasOwnProperty("real_output_in_tx_index"))
            if (!$util.isInteger(message.real_output_in_tx_index) && !(message.real_output_in_tx_index && $util.isInteger(message.real_output_in_tx_index.low) && $util.isInteger(message.real_output_in_tx_index.high)))
                return "real_output_in_tx_index: integer|Long expected";
        if (message.amount != null && message.hasOwnProperty("amount"))
            if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
                return "amount: integer|Long expected";
        if (message.rct != null && message.hasOwnProperty("rct"))
            if (typeof message.rct !== "boolean")
                return "rct: boolean expected";
        if (message.mask != null && message.hasOwnProperty("mask"))
            if (!(message.mask && typeof message.mask.length === "number" || $util.isString(message.mask)))
                return "mask: buffer expected";
        if (message.multisig_kLRki != null && message.hasOwnProperty("multisig_kLRki")) {
            var error = $root.MoneroTransactionSourceEntry.MoneroMultisigKLRki.verify(message.multisig_kLRki);
            if (error)
                return "multisig_kLRki." + error;
        }
        if (message.subaddr_minor != null && message.hasOwnProperty("subaddr_minor"))
            if (!$util.isInteger(message.subaddr_minor))
                return "subaddr_minor: integer expected";
        return null;
    };

    MoneroTransactionSourceEntry.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroTransactionSourceEntry)
            return object;
        var message = new $root.MoneroTransactionSourceEntry();
        if (object.outputs) {
            if (!Array.isArray(object.outputs))
                throw TypeError(".MoneroTransactionSourceEntry.outputs: array expected");
            message.outputs = [];
            for (var i = 0; i < object.outputs.length; ++i) {
                if (typeof object.outputs[i] !== "object")
                    throw TypeError(".MoneroTransactionSourceEntry.outputs: object expected");
                message.outputs[i] = $root.MoneroTransactionSourceEntry.MoneroOutputEntry.fromObject(object.outputs[i]);
            }
        }
        if (object.real_output != null)
            if ($util.Long)
                (message.real_output = $util.Long.fromValue(object.real_output)).unsigned = true;
            else if (typeof object.real_output === "string")
                message.real_output = parseInt(object.real_output, 10);
            else if (typeof object.real_output === "number")
                message.real_output = object.real_output;
            else if (typeof object.real_output === "object")
                message.real_output = new $util.LongBits(object.real_output.low >>> 0, object.real_output.high >>> 0).toNumber(true);
        if (object.real_out_tx_key != null)
            if (typeof object.real_out_tx_key === "string")
                $util.base64.decode(object.real_out_tx_key, message.real_out_tx_key = $util.newBuffer($util.base64.length(object.real_out_tx_key)), 0);
            else if (object.real_out_tx_key.length)
                message.real_out_tx_key = object.real_out_tx_key;
        if (object.real_out_additional_tx_keys) {
            if (!Array.isArray(object.real_out_additional_tx_keys))
                throw TypeError(".MoneroTransactionSourceEntry.real_out_additional_tx_keys: array expected");
            message.real_out_additional_tx_keys = [];
            for (var i = 0; i < object.real_out_additional_tx_keys.length; ++i)
                if (typeof object.real_out_additional_tx_keys[i] === "string")
                    $util.base64.decode(object.real_out_additional_tx_keys[i], message.real_out_additional_tx_keys[i] = $util.newBuffer($util.base64.length(object.real_out_additional_tx_keys[i])), 0);
                else if (object.real_out_additional_tx_keys[i].length)
                    message.real_out_additional_tx_keys[i] = object.real_out_additional_tx_keys[i];
        }
        if (object.real_output_in_tx_index != null)
            if ($util.Long)
                (message.real_output_in_tx_index = $util.Long.fromValue(object.real_output_in_tx_index)).unsigned = true;
            else if (typeof object.real_output_in_tx_index === "string")
                message.real_output_in_tx_index = parseInt(object.real_output_in_tx_index, 10);
            else if (typeof object.real_output_in_tx_index === "number")
                message.real_output_in_tx_index = object.real_output_in_tx_index;
            else if (typeof object.real_output_in_tx_index === "object")
                message.real_output_in_tx_index = new $util.LongBits(object.real_output_in_tx_index.low >>> 0, object.real_output_in_tx_index.high >>> 0).toNumber(true);
        if (object.amount != null)
            if ($util.Long)
                (message.amount = $util.Long.fromValue(object.amount)).unsigned = true;
            else if (typeof object.amount === "string")
                message.amount = parseInt(object.amount, 10);
            else if (typeof object.amount === "number")
                message.amount = object.amount;
            else if (typeof object.amount === "object")
                message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber(true);
        if (object.rct != null)
            message.rct = Boolean(object.rct);
        if (object.mask != null)
            if (typeof object.mask === "string")
                $util.base64.decode(object.mask, message.mask = $util.newBuffer($util.base64.length(object.mask)), 0);
            else if (object.mask.length)
                message.mask = object.mask;
        if (object.multisig_kLRki != null) {
            if (typeof object.multisig_kLRki !== "object")
                throw TypeError(".MoneroTransactionSourceEntry.multisig_kLRki: object expected");
            message.multisig_kLRki = $root.MoneroTransactionSourceEntry.MoneroMultisigKLRki.fromObject(object.multisig_kLRki);
        }
        if (object.subaddr_minor != null)
            message.subaddr_minor = object.subaddr_minor >>> 0;
        return message;
    };

    MoneroTransactionSourceEntry.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults) {
            object.outputs = [];
            object.real_out_additional_tx_keys = [];
        }
        if (options.defaults) {
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.real_output = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.real_output = options.longs === String ? "0" : 0;
            if (options.bytes === String)
                object.real_out_tx_key = "";
            else {
                object.real_out_tx_key = [];
                if (options.bytes !== Array)
                    object.real_out_tx_key = $util.newBuffer(object.real_out_tx_key);
            }
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.real_output_in_tx_index = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.real_output_in_tx_index = options.longs === String ? "0" : 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.amount = options.longs === String ? "0" : 0;
            object.rct = false;
            if (options.bytes === String)
                object.mask = "";
            else {
                object.mask = [];
                if (options.bytes !== Array)
                    object.mask = $util.newBuffer(object.mask);
            }
            object.multisig_kLRki = null;
            object.subaddr_minor = 0;
        }
        if (message.outputs && message.outputs.length) {
            object.outputs = [];
            for (var j = 0; j < message.outputs.length; ++j)
                object.outputs[j] = $root.MoneroTransactionSourceEntry.MoneroOutputEntry.toObject(message.outputs[j], options);
        }
        if (message.real_output != null && message.hasOwnProperty("real_output"))
            if (typeof message.real_output === "number")
                object.real_output = options.longs === String ? String(message.real_output) : message.real_output;
            else
                object.real_output = options.longs === String ? $util.Long.prototype.toString.call(message.real_output) : options.longs === Number ? new $util.LongBits(message.real_output.low >>> 0, message.real_output.high >>> 0).toNumber(true) : message.real_output;
        if (message.real_out_tx_key != null && message.hasOwnProperty("real_out_tx_key"))
            object.real_out_tx_key = options.bytes === String ? $util.base64.encode(message.real_out_tx_key, 0, message.real_out_tx_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.real_out_tx_key) : message.real_out_tx_key;
        if (message.real_out_additional_tx_keys && message.real_out_additional_tx_keys.length) {
            object.real_out_additional_tx_keys = [];
            for (var j = 0; j < message.real_out_additional_tx_keys.length; ++j)
                object.real_out_additional_tx_keys[j] = options.bytes === String ? $util.base64.encode(message.real_out_additional_tx_keys[j], 0, message.real_out_additional_tx_keys[j].length) : options.bytes === Array ? Array.prototype.slice.call(message.real_out_additional_tx_keys[j]) : message.real_out_additional_tx_keys[j];
        }
        if (message.real_output_in_tx_index != null && message.hasOwnProperty("real_output_in_tx_index"))
            if (typeof message.real_output_in_tx_index === "number")
                object.real_output_in_tx_index = options.longs === String ? String(message.real_output_in_tx_index) : message.real_output_in_tx_index;
            else
                object.real_output_in_tx_index = options.longs === String ? $util.Long.prototype.toString.call(message.real_output_in_tx_index) : options.longs === Number ? new $util.LongBits(message.real_output_in_tx_index.low >>> 0, message.real_output_in_tx_index.high >>> 0).toNumber(true) : message.real_output_in_tx_index;
        if (message.amount != null && message.hasOwnProperty("amount"))
            if (typeof message.amount === "number")
                object.amount = options.longs === String ? String(message.amount) : message.amount;
            else
                object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber(true) : message.amount;
        if (message.rct != null && message.hasOwnProperty("rct"))
            object.rct = message.rct;
        if (message.mask != null && message.hasOwnProperty("mask"))
            object.mask = options.bytes === String ? $util.base64.encode(message.mask, 0, message.mask.length) : options.bytes === Array ? Array.prototype.slice.call(message.mask) : message.mask;
        if (message.multisig_kLRki != null && message.hasOwnProperty("multisig_kLRki"))
            object.multisig_kLRki = $root.MoneroTransactionSourceEntry.MoneroMultisigKLRki.toObject(message.multisig_kLRki, options);
        if (message.subaddr_minor != null && message.hasOwnProperty("subaddr_minor"))
            object.subaddr_minor = message.subaddr_minor;
        return object;
    };

    MoneroTransactionSourceEntry.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    MoneroTransactionSourceEntry.MoneroOutputEntry = (function() {

        function MoneroOutputEntry(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        MoneroOutputEntry.prototype.idx = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        MoneroOutputEntry.prototype.key = null;

        MoneroOutputEntry.create = function create(properties) {
            return new MoneroOutputEntry(properties);
        };

        MoneroOutputEntry.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.idx != null && Object.hasOwnProperty.call(message, "idx"))
                writer.uint32(8).uint64(message.idx);
            if (message.key != null && Object.hasOwnProperty.call(message, "key"))
                $root.MoneroTransactionSourceEntry.MoneroOutputEntry.MoneroRctKeyPublic.encode(message.key, writer.uint32(18).fork()).ldelim();
            return writer;
        };

        MoneroOutputEntry.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        MoneroOutputEntry.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroTransactionSourceEntry.MoneroOutputEntry();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.idx = reader.uint64();
                    break;
                case 2:
                    message.key = $root.MoneroTransactionSourceEntry.MoneroOutputEntry.MoneroRctKeyPublic.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        MoneroOutputEntry.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        MoneroOutputEntry.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.idx != null && message.hasOwnProperty("idx"))
                if (!$util.isInteger(message.idx) && !(message.idx && $util.isInteger(message.idx.low) && $util.isInteger(message.idx.high)))
                    return "idx: integer|Long expected";
            if (message.key != null && message.hasOwnProperty("key")) {
                var error = $root.MoneroTransactionSourceEntry.MoneroOutputEntry.MoneroRctKeyPublic.verify(message.key);
                if (error)
                    return "key." + error;
            }
            return null;
        };

        MoneroOutputEntry.fromObject = function fromObject(object) {
            if (object instanceof $root.MoneroTransactionSourceEntry.MoneroOutputEntry)
                return object;
            var message = new $root.MoneroTransactionSourceEntry.MoneroOutputEntry();
            if (object.idx != null)
                if ($util.Long)
                    (message.idx = $util.Long.fromValue(object.idx)).unsigned = true;
                else if (typeof object.idx === "string")
                    message.idx = parseInt(object.idx, 10);
                else if (typeof object.idx === "number")
                    message.idx = object.idx;
                else if (typeof object.idx === "object")
                    message.idx = new $util.LongBits(object.idx.low >>> 0, object.idx.high >>> 0).toNumber(true);
            if (object.key != null) {
                if (typeof object.key !== "object")
                    throw TypeError(".MoneroTransactionSourceEntry.MoneroOutputEntry.key: object expected");
                message.key = $root.MoneroTransactionSourceEntry.MoneroOutputEntry.MoneroRctKeyPublic.fromObject(object.key);
            }
            return message;
        };

        MoneroOutputEntry.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.idx = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.idx = options.longs === String ? "0" : 0;
                object.key = null;
            }
            if (message.idx != null && message.hasOwnProperty("idx"))
                if (typeof message.idx === "number")
                    object.idx = options.longs === String ? String(message.idx) : message.idx;
                else
                    object.idx = options.longs === String ? $util.Long.prototype.toString.call(message.idx) : options.longs === Number ? new $util.LongBits(message.idx.low >>> 0, message.idx.high >>> 0).toNumber(true) : message.idx;
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = $root.MoneroTransactionSourceEntry.MoneroOutputEntry.MoneroRctKeyPublic.toObject(message.key, options);
            return object;
        };

        MoneroOutputEntry.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        MoneroOutputEntry.MoneroRctKeyPublic = (function() {

            function MoneroRctKeyPublic(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            MoneroRctKeyPublic.prototype.dest = $util.newBuffer([]);
            MoneroRctKeyPublic.prototype.commitment = $util.newBuffer([]);

            MoneroRctKeyPublic.create = function create(properties) {
                return new MoneroRctKeyPublic(properties);
            };

            MoneroRctKeyPublic.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.dest != null && Object.hasOwnProperty.call(message, "dest"))
                    writer.uint32(10).bytes(message.dest);
                if (message.commitment != null && Object.hasOwnProperty.call(message, "commitment"))
                    writer.uint32(18).bytes(message.commitment);
                return writer;
            };

            MoneroRctKeyPublic.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            MoneroRctKeyPublic.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroTransactionSourceEntry.MoneroOutputEntry.MoneroRctKeyPublic();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.dest = reader.bytes();
                        break;
                    case 2:
                        message.commitment = reader.bytes();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            MoneroRctKeyPublic.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            MoneroRctKeyPublic.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.dest != null && message.hasOwnProperty("dest"))
                    if (!(message.dest && typeof message.dest.length === "number" || $util.isString(message.dest)))
                        return "dest: buffer expected";
                if (message.commitment != null && message.hasOwnProperty("commitment"))
                    if (!(message.commitment && typeof message.commitment.length === "number" || $util.isString(message.commitment)))
                        return "commitment: buffer expected";
                return null;
            };

            MoneroRctKeyPublic.fromObject = function fromObject(object) {
                if (object instanceof $root.MoneroTransactionSourceEntry.MoneroOutputEntry.MoneroRctKeyPublic)
                    return object;
                var message = new $root.MoneroTransactionSourceEntry.MoneroOutputEntry.MoneroRctKeyPublic();
                if (object.dest != null)
                    if (typeof object.dest === "string")
                        $util.base64.decode(object.dest, message.dest = $util.newBuffer($util.base64.length(object.dest)), 0);
                    else if (object.dest.length)
                        message.dest = object.dest;
                if (object.commitment != null)
                    if (typeof object.commitment === "string")
                        $util.base64.decode(object.commitment, message.commitment = $util.newBuffer($util.base64.length(object.commitment)), 0);
                    else if (object.commitment.length)
                        message.commitment = object.commitment;
                return message;
            };

            MoneroRctKeyPublic.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    if (options.bytes === String)
                        object.dest = "";
                    else {
                        object.dest = [];
                        if (options.bytes !== Array)
                            object.dest = $util.newBuffer(object.dest);
                    }
                    if (options.bytes === String)
                        object.commitment = "";
                    else {
                        object.commitment = [];
                        if (options.bytes !== Array)
                            object.commitment = $util.newBuffer(object.commitment);
                    }
                }
                if (message.dest != null && message.hasOwnProperty("dest"))
                    object.dest = options.bytes === String ? $util.base64.encode(message.dest, 0, message.dest.length) : options.bytes === Array ? Array.prototype.slice.call(message.dest) : message.dest;
                if (message.commitment != null && message.hasOwnProperty("commitment"))
                    object.commitment = options.bytes === String ? $util.base64.encode(message.commitment, 0, message.commitment.length) : options.bytes === Array ? Array.prototype.slice.call(message.commitment) : message.commitment;
                return object;
            };

            MoneroRctKeyPublic.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return MoneroRctKeyPublic;
        })();

        return MoneroOutputEntry;
    })();

    MoneroTransactionSourceEntry.MoneroMultisigKLRki = (function() {

        function MoneroMultisigKLRki(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        MoneroMultisigKLRki.prototype.K = $util.newBuffer([]);
        MoneroMultisigKLRki.prototype.L = $util.newBuffer([]);
        MoneroMultisigKLRki.prototype.R = $util.newBuffer([]);
        MoneroMultisigKLRki.prototype.ki = $util.newBuffer([]);

        MoneroMultisigKLRki.create = function create(properties) {
            return new MoneroMultisigKLRki(properties);
        };

        MoneroMultisigKLRki.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.K != null && Object.hasOwnProperty.call(message, "K"))
                writer.uint32(10).bytes(message.K);
            if (message.L != null && Object.hasOwnProperty.call(message, "L"))
                writer.uint32(18).bytes(message.L);
            if (message.R != null && Object.hasOwnProperty.call(message, "R"))
                writer.uint32(26).bytes(message.R);
            if (message.ki != null && Object.hasOwnProperty.call(message, "ki"))
                writer.uint32(34).bytes(message.ki);
            return writer;
        };

        MoneroMultisigKLRki.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        MoneroMultisigKLRki.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroTransactionSourceEntry.MoneroMultisigKLRki();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.K = reader.bytes();
                    break;
                case 2:
                    message.L = reader.bytes();
                    break;
                case 3:
                    message.R = reader.bytes();
                    break;
                case 4:
                    message.ki = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        MoneroMultisigKLRki.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        MoneroMultisigKLRki.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.K != null && message.hasOwnProperty("K"))
                if (!(message.K && typeof message.K.length === "number" || $util.isString(message.K)))
                    return "K: buffer expected";
            if (message.L != null && message.hasOwnProperty("L"))
                if (!(message.L && typeof message.L.length === "number" || $util.isString(message.L)))
                    return "L: buffer expected";
            if (message.R != null && message.hasOwnProperty("R"))
                if (!(message.R && typeof message.R.length === "number" || $util.isString(message.R)))
                    return "R: buffer expected";
            if (message.ki != null && message.hasOwnProperty("ki"))
                if (!(message.ki && typeof message.ki.length === "number" || $util.isString(message.ki)))
                    return "ki: buffer expected";
            return null;
        };

        MoneroMultisigKLRki.fromObject = function fromObject(object) {
            if (object instanceof $root.MoneroTransactionSourceEntry.MoneroMultisigKLRki)
                return object;
            var message = new $root.MoneroTransactionSourceEntry.MoneroMultisigKLRki();
            if (object.K != null)
                if (typeof object.K === "string")
                    $util.base64.decode(object.K, message.K = $util.newBuffer($util.base64.length(object.K)), 0);
                else if (object.K.length)
                    message.K = object.K;
            if (object.L != null)
                if (typeof object.L === "string")
                    $util.base64.decode(object.L, message.L = $util.newBuffer($util.base64.length(object.L)), 0);
                else if (object.L.length)
                    message.L = object.L;
            if (object.R != null)
                if (typeof object.R === "string")
                    $util.base64.decode(object.R, message.R = $util.newBuffer($util.base64.length(object.R)), 0);
                else if (object.R.length)
                    message.R = object.R;
            if (object.ki != null)
                if (typeof object.ki === "string")
                    $util.base64.decode(object.ki, message.ki = $util.newBuffer($util.base64.length(object.ki)), 0);
                else if (object.ki.length)
                    message.ki = object.ki;
            return message;
        };

        MoneroMultisigKLRki.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if (options.bytes === String)
                    object.K = "";
                else {
                    object.K = [];
                    if (options.bytes !== Array)
                        object.K = $util.newBuffer(object.K);
                }
                if (options.bytes === String)
                    object.L = "";
                else {
                    object.L = [];
                    if (options.bytes !== Array)
                        object.L = $util.newBuffer(object.L);
                }
                if (options.bytes === String)
                    object.R = "";
                else {
                    object.R = [];
                    if (options.bytes !== Array)
                        object.R = $util.newBuffer(object.R);
                }
                if (options.bytes === String)
                    object.ki = "";
                else {
                    object.ki = [];
                    if (options.bytes !== Array)
                        object.ki = $util.newBuffer(object.ki);
                }
            }
            if (message.K != null && message.hasOwnProperty("K"))
                object.K = options.bytes === String ? $util.base64.encode(message.K, 0, message.K.length) : options.bytes === Array ? Array.prototype.slice.call(message.K) : message.K;
            if (message.L != null && message.hasOwnProperty("L"))
                object.L = options.bytes === String ? $util.base64.encode(message.L, 0, message.L.length) : options.bytes === Array ? Array.prototype.slice.call(message.L) : message.L;
            if (message.R != null && message.hasOwnProperty("R"))
                object.R = options.bytes === String ? $util.base64.encode(message.R, 0, message.R.length) : options.bytes === Array ? Array.prototype.slice.call(message.R) : message.R;
            if (message.ki != null && message.hasOwnProperty("ki"))
                object.ki = options.bytes === String ? $util.base64.encode(message.ki, 0, message.ki.length) : options.bytes === Array ? Array.prototype.slice.call(message.ki) : message.ki;
            return object;
        };

        MoneroMultisigKLRki.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return MoneroMultisigKLRki;
    })();

    return MoneroTransactionSourceEntry;
})();

$root.MoneroTransactionDestinationEntry = (function() {

    function MoneroTransactionDestinationEntry(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroTransactionDestinationEntry.prototype.amount = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    MoneroTransactionDestinationEntry.prototype.addr = null;
    MoneroTransactionDestinationEntry.prototype.is_subaddress = false;
    MoneroTransactionDestinationEntry.prototype.original = $util.newBuffer([]);
    MoneroTransactionDestinationEntry.prototype.is_integrated = false;

    MoneroTransactionDestinationEntry.create = function create(properties) {
        return new MoneroTransactionDestinationEntry(properties);
    };

    MoneroTransactionDestinationEntry.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
            writer.uint32(8).uint64(message.amount);
        if (message.addr != null && Object.hasOwnProperty.call(message, "addr"))
            $root.MoneroTransactionDestinationEntry.MoneroAccountPublicAddress.encode(message.addr, writer.uint32(18).fork()).ldelim();
        if (message.is_subaddress != null && Object.hasOwnProperty.call(message, "is_subaddress"))
            writer.uint32(24).bool(message.is_subaddress);
        if (message.original != null && Object.hasOwnProperty.call(message, "original"))
            writer.uint32(34).bytes(message.original);
        if (message.is_integrated != null && Object.hasOwnProperty.call(message, "is_integrated"))
            writer.uint32(40).bool(message.is_integrated);
        return writer;
    };

    MoneroTransactionDestinationEntry.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroTransactionDestinationEntry.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroTransactionDestinationEntry();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.amount = reader.uint64();
                break;
            case 2:
                message.addr = $root.MoneroTransactionDestinationEntry.MoneroAccountPublicAddress.decode(reader, reader.uint32());
                break;
            case 3:
                message.is_subaddress = reader.bool();
                break;
            case 4:
                message.original = reader.bytes();
                break;
            case 5:
                message.is_integrated = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroTransactionDestinationEntry.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroTransactionDestinationEntry.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.amount != null && message.hasOwnProperty("amount"))
            if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
                return "amount: integer|Long expected";
        if (message.addr != null && message.hasOwnProperty("addr")) {
            var error = $root.MoneroTransactionDestinationEntry.MoneroAccountPublicAddress.verify(message.addr);
            if (error)
                return "addr." + error;
        }
        if (message.is_subaddress != null && message.hasOwnProperty("is_subaddress"))
            if (typeof message.is_subaddress !== "boolean")
                return "is_subaddress: boolean expected";
        if (message.original != null && message.hasOwnProperty("original"))
            if (!(message.original && typeof message.original.length === "number" || $util.isString(message.original)))
                return "original: buffer expected";
        if (message.is_integrated != null && message.hasOwnProperty("is_integrated"))
            if (typeof message.is_integrated !== "boolean")
                return "is_integrated: boolean expected";
        return null;
    };

    MoneroTransactionDestinationEntry.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroTransactionDestinationEntry)
            return object;
        var message = new $root.MoneroTransactionDestinationEntry();
        if (object.amount != null)
            if ($util.Long)
                (message.amount = $util.Long.fromValue(object.amount)).unsigned = true;
            else if (typeof object.amount === "string")
                message.amount = parseInt(object.amount, 10);
            else if (typeof object.amount === "number")
                message.amount = object.amount;
            else if (typeof object.amount === "object")
                message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber(true);
        if (object.addr != null) {
            if (typeof object.addr !== "object")
                throw TypeError(".MoneroTransactionDestinationEntry.addr: object expected");
            message.addr = $root.MoneroTransactionDestinationEntry.MoneroAccountPublicAddress.fromObject(object.addr);
        }
        if (object.is_subaddress != null)
            message.is_subaddress = Boolean(object.is_subaddress);
        if (object.original != null)
            if (typeof object.original === "string")
                $util.base64.decode(object.original, message.original = $util.newBuffer($util.base64.length(object.original)), 0);
            else if (object.original.length)
                message.original = object.original;
        if (object.is_integrated != null)
            message.is_integrated = Boolean(object.is_integrated);
        return message;
    };

    MoneroTransactionDestinationEntry.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.amount = options.longs === String ? "0" : 0;
            object.addr = null;
            object.is_subaddress = false;
            if (options.bytes === String)
                object.original = "";
            else {
                object.original = [];
                if (options.bytes !== Array)
                    object.original = $util.newBuffer(object.original);
            }
            object.is_integrated = false;
        }
        if (message.amount != null && message.hasOwnProperty("amount"))
            if (typeof message.amount === "number")
                object.amount = options.longs === String ? String(message.amount) : message.amount;
            else
                object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber(true) : message.amount;
        if (message.addr != null && message.hasOwnProperty("addr"))
            object.addr = $root.MoneroTransactionDestinationEntry.MoneroAccountPublicAddress.toObject(message.addr, options);
        if (message.is_subaddress != null && message.hasOwnProperty("is_subaddress"))
            object.is_subaddress = message.is_subaddress;
        if (message.original != null && message.hasOwnProperty("original"))
            object.original = options.bytes === String ? $util.base64.encode(message.original, 0, message.original.length) : options.bytes === Array ? Array.prototype.slice.call(message.original) : message.original;
        if (message.is_integrated != null && message.hasOwnProperty("is_integrated"))
            object.is_integrated = message.is_integrated;
        return object;
    };

    MoneroTransactionDestinationEntry.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    MoneroTransactionDestinationEntry.MoneroAccountPublicAddress = (function() {

        function MoneroAccountPublicAddress(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        MoneroAccountPublicAddress.prototype.spend_public_key = $util.newBuffer([]);
        MoneroAccountPublicAddress.prototype.view_public_key = $util.newBuffer([]);

        MoneroAccountPublicAddress.create = function create(properties) {
            return new MoneroAccountPublicAddress(properties);
        };

        MoneroAccountPublicAddress.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.spend_public_key != null && Object.hasOwnProperty.call(message, "spend_public_key"))
                writer.uint32(10).bytes(message.spend_public_key);
            if (message.view_public_key != null && Object.hasOwnProperty.call(message, "view_public_key"))
                writer.uint32(18).bytes(message.view_public_key);
            return writer;
        };

        MoneroAccountPublicAddress.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        MoneroAccountPublicAddress.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroTransactionDestinationEntry.MoneroAccountPublicAddress();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.spend_public_key = reader.bytes();
                    break;
                case 2:
                    message.view_public_key = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        MoneroAccountPublicAddress.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        MoneroAccountPublicAddress.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.spend_public_key != null && message.hasOwnProperty("spend_public_key"))
                if (!(message.spend_public_key && typeof message.spend_public_key.length === "number" || $util.isString(message.spend_public_key)))
                    return "spend_public_key: buffer expected";
            if (message.view_public_key != null && message.hasOwnProperty("view_public_key"))
                if (!(message.view_public_key && typeof message.view_public_key.length === "number" || $util.isString(message.view_public_key)))
                    return "view_public_key: buffer expected";
            return null;
        };

        MoneroAccountPublicAddress.fromObject = function fromObject(object) {
            if (object instanceof $root.MoneroTransactionDestinationEntry.MoneroAccountPublicAddress)
                return object;
            var message = new $root.MoneroTransactionDestinationEntry.MoneroAccountPublicAddress();
            if (object.spend_public_key != null)
                if (typeof object.spend_public_key === "string")
                    $util.base64.decode(object.spend_public_key, message.spend_public_key = $util.newBuffer($util.base64.length(object.spend_public_key)), 0);
                else if (object.spend_public_key.length)
                    message.spend_public_key = object.spend_public_key;
            if (object.view_public_key != null)
                if (typeof object.view_public_key === "string")
                    $util.base64.decode(object.view_public_key, message.view_public_key = $util.newBuffer($util.base64.length(object.view_public_key)), 0);
                else if (object.view_public_key.length)
                    message.view_public_key = object.view_public_key;
            return message;
        };

        MoneroAccountPublicAddress.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if (options.bytes === String)
                    object.spend_public_key = "";
                else {
                    object.spend_public_key = [];
                    if (options.bytes !== Array)
                        object.spend_public_key = $util.newBuffer(object.spend_public_key);
                }
                if (options.bytes === String)
                    object.view_public_key = "";
                else {
                    object.view_public_key = [];
                    if (options.bytes !== Array)
                        object.view_public_key = $util.newBuffer(object.view_public_key);
                }
            }
            if (message.spend_public_key != null && message.hasOwnProperty("spend_public_key"))
                object.spend_public_key = options.bytes === String ? $util.base64.encode(message.spend_public_key, 0, message.spend_public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.spend_public_key) : message.spend_public_key;
            if (message.view_public_key != null && message.hasOwnProperty("view_public_key"))
                object.view_public_key = options.bytes === String ? $util.base64.encode(message.view_public_key, 0, message.view_public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.view_public_key) : message.view_public_key;
            return object;
        };

        MoneroAccountPublicAddress.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return MoneroAccountPublicAddress;
    })();

    return MoneroTransactionDestinationEntry;
})();

$root.MoneroTransactionRsigData = (function() {

    function MoneroTransactionRsigData(properties) {
        this.grouping = [];
        this.rsig_parts = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroTransactionRsigData.prototype.rsig_type = 0;
    MoneroTransactionRsigData.prototype.offload_type = 0;
    MoneroTransactionRsigData.prototype.grouping = $util.emptyArray;
    MoneroTransactionRsigData.prototype.mask = $util.newBuffer([]);
    MoneroTransactionRsigData.prototype.rsig = $util.newBuffer([]);
    MoneroTransactionRsigData.prototype.rsig_parts = $util.emptyArray;
    MoneroTransactionRsigData.prototype.bp_version = 0;

    MoneroTransactionRsigData.create = function create(properties) {
        return new MoneroTransactionRsigData(properties);
    };

    MoneroTransactionRsigData.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.rsig_type != null && Object.hasOwnProperty.call(message, "rsig_type"))
            writer.uint32(8).uint32(message.rsig_type);
        if (message.offload_type != null && Object.hasOwnProperty.call(message, "offload_type"))
            writer.uint32(16).uint32(message.offload_type);
        if (message.grouping != null && message.grouping.length)
            for (var i = 0; i < message.grouping.length; ++i)
                writer.uint32(24).uint64(message.grouping[i]);
        if (message.mask != null && Object.hasOwnProperty.call(message, "mask"))
            writer.uint32(34).bytes(message.mask);
        if (message.rsig != null && Object.hasOwnProperty.call(message, "rsig"))
            writer.uint32(42).bytes(message.rsig);
        if (message.rsig_parts != null && message.rsig_parts.length)
            for (var i = 0; i < message.rsig_parts.length; ++i)
                writer.uint32(50).bytes(message.rsig_parts[i]);
        if (message.bp_version != null && Object.hasOwnProperty.call(message, "bp_version"))
            writer.uint32(56).uint32(message.bp_version);
        return writer;
    };

    MoneroTransactionRsigData.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroTransactionRsigData.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroTransactionRsigData();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.rsig_type = reader.uint32();
                break;
            case 2:
                message.offload_type = reader.uint32();
                break;
            case 3:
                if (!(message.grouping && message.grouping.length))
                    message.grouping = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.grouping.push(reader.uint64());
                } else
                    message.grouping.push(reader.uint64());
                break;
            case 4:
                message.mask = reader.bytes();
                break;
            case 5:
                message.rsig = reader.bytes();
                break;
            case 6:
                if (!(message.rsig_parts && message.rsig_parts.length))
                    message.rsig_parts = [];
                message.rsig_parts.push(reader.bytes());
                break;
            case 7:
                message.bp_version = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroTransactionRsigData.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroTransactionRsigData.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.rsig_type != null && message.hasOwnProperty("rsig_type"))
            if (!$util.isInteger(message.rsig_type))
                return "rsig_type: integer expected";
        if (message.offload_type != null && message.hasOwnProperty("offload_type"))
            if (!$util.isInteger(message.offload_type))
                return "offload_type: integer expected";
        if (message.grouping != null && message.hasOwnProperty("grouping")) {
            if (!Array.isArray(message.grouping))
                return "grouping: array expected";
            for (var i = 0; i < message.grouping.length; ++i)
                if (!$util.isInteger(message.grouping[i]) && !(message.grouping[i] && $util.isInteger(message.grouping[i].low) && $util.isInteger(message.grouping[i].high)))
                    return "grouping: integer|Long[] expected";
        }
        if (message.mask != null && message.hasOwnProperty("mask"))
            if (!(message.mask && typeof message.mask.length === "number" || $util.isString(message.mask)))
                return "mask: buffer expected";
        if (message.rsig != null && message.hasOwnProperty("rsig"))
            if (!(message.rsig && typeof message.rsig.length === "number" || $util.isString(message.rsig)))
                return "rsig: buffer expected";
        if (message.rsig_parts != null && message.hasOwnProperty("rsig_parts")) {
            if (!Array.isArray(message.rsig_parts))
                return "rsig_parts: array expected";
            for (var i = 0; i < message.rsig_parts.length; ++i)
                if (!(message.rsig_parts[i] && typeof message.rsig_parts[i].length === "number" || $util.isString(message.rsig_parts[i])))
                    return "rsig_parts: buffer[] expected";
        }
        if (message.bp_version != null && message.hasOwnProperty("bp_version"))
            if (!$util.isInteger(message.bp_version))
                return "bp_version: integer expected";
        return null;
    };

    MoneroTransactionRsigData.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroTransactionRsigData)
            return object;
        var message = new $root.MoneroTransactionRsigData();
        if (object.rsig_type != null)
            message.rsig_type = object.rsig_type >>> 0;
        if (object.offload_type != null)
            message.offload_type = object.offload_type >>> 0;
        if (object.grouping) {
            if (!Array.isArray(object.grouping))
                throw TypeError(".MoneroTransactionRsigData.grouping: array expected");
            message.grouping = [];
            for (var i = 0; i < object.grouping.length; ++i)
                if ($util.Long)
                    (message.grouping[i] = $util.Long.fromValue(object.grouping[i])).unsigned = true;
                else if (typeof object.grouping[i] === "string")
                    message.grouping[i] = parseInt(object.grouping[i], 10);
                else if (typeof object.grouping[i] === "number")
                    message.grouping[i] = object.grouping[i];
                else if (typeof object.grouping[i] === "object")
                    message.grouping[i] = new $util.LongBits(object.grouping[i].low >>> 0, object.grouping[i].high >>> 0).toNumber(true);
        }
        if (object.mask != null)
            if (typeof object.mask === "string")
                $util.base64.decode(object.mask, message.mask = $util.newBuffer($util.base64.length(object.mask)), 0);
            else if (object.mask.length)
                message.mask = object.mask;
        if (object.rsig != null)
            if (typeof object.rsig === "string")
                $util.base64.decode(object.rsig, message.rsig = $util.newBuffer($util.base64.length(object.rsig)), 0);
            else if (object.rsig.length)
                message.rsig = object.rsig;
        if (object.rsig_parts) {
            if (!Array.isArray(object.rsig_parts))
                throw TypeError(".MoneroTransactionRsigData.rsig_parts: array expected");
            message.rsig_parts = [];
            for (var i = 0; i < object.rsig_parts.length; ++i)
                if (typeof object.rsig_parts[i] === "string")
                    $util.base64.decode(object.rsig_parts[i], message.rsig_parts[i] = $util.newBuffer($util.base64.length(object.rsig_parts[i])), 0);
                else if (object.rsig_parts[i].length)
                    message.rsig_parts[i] = object.rsig_parts[i];
        }
        if (object.bp_version != null)
            message.bp_version = object.bp_version >>> 0;
        return message;
    };

    MoneroTransactionRsigData.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults) {
            object.grouping = [];
            object.rsig_parts = [];
        }
        if (options.defaults) {
            object.rsig_type = 0;
            object.offload_type = 0;
            if (options.bytes === String)
                object.mask = "";
            else {
                object.mask = [];
                if (options.bytes !== Array)
                    object.mask = $util.newBuffer(object.mask);
            }
            if (options.bytes === String)
                object.rsig = "";
            else {
                object.rsig = [];
                if (options.bytes !== Array)
                    object.rsig = $util.newBuffer(object.rsig);
            }
            object.bp_version = 0;
        }
        if (message.rsig_type != null && message.hasOwnProperty("rsig_type"))
            object.rsig_type = message.rsig_type;
        if (message.offload_type != null && message.hasOwnProperty("offload_type"))
            object.offload_type = message.offload_type;
        if (message.grouping && message.grouping.length) {
            object.grouping = [];
            for (var j = 0; j < message.grouping.length; ++j)
                if (typeof message.grouping[j] === "number")
                    object.grouping[j] = options.longs === String ? String(message.grouping[j]) : message.grouping[j];
                else
                    object.grouping[j] = options.longs === String ? $util.Long.prototype.toString.call(message.grouping[j]) : options.longs === Number ? new $util.LongBits(message.grouping[j].low >>> 0, message.grouping[j].high >>> 0).toNumber(true) : message.grouping[j];
        }
        if (message.mask != null && message.hasOwnProperty("mask"))
            object.mask = options.bytes === String ? $util.base64.encode(message.mask, 0, message.mask.length) : options.bytes === Array ? Array.prototype.slice.call(message.mask) : message.mask;
        if (message.rsig != null && message.hasOwnProperty("rsig"))
            object.rsig = options.bytes === String ? $util.base64.encode(message.rsig, 0, message.rsig.length) : options.bytes === Array ? Array.prototype.slice.call(message.rsig) : message.rsig;
        if (message.rsig_parts && message.rsig_parts.length) {
            object.rsig_parts = [];
            for (var j = 0; j < message.rsig_parts.length; ++j)
                object.rsig_parts[j] = options.bytes === String ? $util.base64.encode(message.rsig_parts[j], 0, message.rsig_parts[j].length) : options.bytes === Array ? Array.prototype.slice.call(message.rsig_parts[j]) : message.rsig_parts[j];
        }
        if (message.bp_version != null && message.hasOwnProperty("bp_version"))
            object.bp_version = message.bp_version;
        return object;
    };

    MoneroTransactionRsigData.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoneroTransactionRsigData;
})();

$root.MoneroGetAddress = (function() {

    function MoneroGetAddress(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroGetAddress.prototype.address_n = $util.emptyArray;
    MoneroGetAddress.prototype.show_display = false;
    MoneroGetAddress.prototype.network_type = 0;
    MoneroGetAddress.prototype.account = 0;
    MoneroGetAddress.prototype.minor = 0;
    MoneroGetAddress.prototype.payment_id = $util.newBuffer([]);

    MoneroGetAddress.create = function create(properties) {
        return new MoneroGetAddress(properties);
    };

    MoneroGetAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(16).bool(message.show_display);
        if (message.network_type != null && Object.hasOwnProperty.call(message, "network_type"))
            writer.uint32(24).uint32(message.network_type);
        if (message.account != null && Object.hasOwnProperty.call(message, "account"))
            writer.uint32(32).uint32(message.account);
        if (message.minor != null && Object.hasOwnProperty.call(message, "minor"))
            writer.uint32(40).uint32(message.minor);
        if (message.payment_id != null && Object.hasOwnProperty.call(message, "payment_id"))
            writer.uint32(50).bytes(message.payment_id);
        return writer;
    };

    MoneroGetAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroGetAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroGetAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.show_display = reader.bool();
                break;
            case 3:
                message.network_type = reader.uint32();
                break;
            case 4:
                message.account = reader.uint32();
                break;
            case 5:
                message.minor = reader.uint32();
                break;
            case 6:
                message.payment_id = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroGetAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroGetAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        if (message.network_type != null && message.hasOwnProperty("network_type"))
            if (!$util.isInteger(message.network_type))
                return "network_type: integer expected";
        if (message.account != null && message.hasOwnProperty("account"))
            if (!$util.isInteger(message.account))
                return "account: integer expected";
        if (message.minor != null && message.hasOwnProperty("minor"))
            if (!$util.isInteger(message.minor))
                return "minor: integer expected";
        if (message.payment_id != null && message.hasOwnProperty("payment_id"))
            if (!(message.payment_id && typeof message.payment_id.length === "number" || $util.isString(message.payment_id)))
                return "payment_id: buffer expected";
        return null;
    };

    MoneroGetAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroGetAddress)
            return object;
        var message = new $root.MoneroGetAddress();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".MoneroGetAddress.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        if (object.network_type != null)
            message.network_type = object.network_type >>> 0;
        if (object.account != null)
            message.account = object.account >>> 0;
        if (object.minor != null)
            message.minor = object.minor >>> 0;
        if (object.payment_id != null)
            if (typeof object.payment_id === "string")
                $util.base64.decode(object.payment_id, message.payment_id = $util.newBuffer($util.base64.length(object.payment_id)), 0);
            else if (object.payment_id.length)
                message.payment_id = object.payment_id;
        return message;
    };

    MoneroGetAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            object.show_display = false;
            object.network_type = 0;
            object.account = 0;
            object.minor = 0;
            if (options.bytes === String)
                object.payment_id = "";
            else {
                object.payment_id = [];
                if (options.bytes !== Array)
                    object.payment_id = $util.newBuffer(object.payment_id);
            }
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        if (message.network_type != null && message.hasOwnProperty("network_type"))
            object.network_type = message.network_type;
        if (message.account != null && message.hasOwnProperty("account"))
            object.account = message.account;
        if (message.minor != null && message.hasOwnProperty("minor"))
            object.minor = message.minor;
        if (message.payment_id != null && message.hasOwnProperty("payment_id"))
            object.payment_id = options.bytes === String ? $util.base64.encode(message.payment_id, 0, message.payment_id.length) : options.bytes === Array ? Array.prototype.slice.call(message.payment_id) : message.payment_id;
        return object;
    };

    MoneroGetAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoneroGetAddress;
})();

$root.MoneroAddress = (function() {

    function MoneroAddress(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroAddress.prototype.address = $util.newBuffer([]);

    MoneroAddress.create = function create(properties) {
        return new MoneroAddress(properties);
    };

    MoneroAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address != null && Object.hasOwnProperty.call(message, "address"))
            writer.uint32(10).bytes(message.address);
        return writer;
    };

    MoneroAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address != null && message.hasOwnProperty("address"))
            if (!(message.address && typeof message.address.length === "number" || $util.isString(message.address)))
                return "address: buffer expected";
        return null;
    };

    MoneroAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroAddress)
            return object;
        var message = new $root.MoneroAddress();
        if (object.address != null)
            if (typeof object.address === "string")
                $util.base64.decode(object.address, message.address = $util.newBuffer($util.base64.length(object.address)), 0);
            else if (object.address.length)
                message.address = object.address;
        return message;
    };

    MoneroAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.address = "";
            else {
                object.address = [];
                if (options.bytes !== Array)
                    object.address = $util.newBuffer(object.address);
            }
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = options.bytes === String ? $util.base64.encode(message.address, 0, message.address.length) : options.bytes === Array ? Array.prototype.slice.call(message.address) : message.address;
        return object;
    };

    MoneroAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoneroAddress;
})();

$root.MoneroGetWatchKey = (function() {

    function MoneroGetWatchKey(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroGetWatchKey.prototype.address_n = $util.emptyArray;
    MoneroGetWatchKey.prototype.network_type = 0;

    MoneroGetWatchKey.create = function create(properties) {
        return new MoneroGetWatchKey(properties);
    };

    MoneroGetWatchKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.network_type != null && Object.hasOwnProperty.call(message, "network_type"))
            writer.uint32(16).uint32(message.network_type);
        return writer;
    };

    MoneroGetWatchKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroGetWatchKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroGetWatchKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.network_type = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroGetWatchKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroGetWatchKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.network_type != null && message.hasOwnProperty("network_type"))
            if (!$util.isInteger(message.network_type))
                return "network_type: integer expected";
        return null;
    };

    MoneroGetWatchKey.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroGetWatchKey)
            return object;
        var message = new $root.MoneroGetWatchKey();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".MoneroGetWatchKey.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.network_type != null)
            message.network_type = object.network_type >>> 0;
        return message;
    };

    MoneroGetWatchKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            object.network_type = 0;
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.network_type != null && message.hasOwnProperty("network_type"))
            object.network_type = message.network_type;
        return object;
    };

    MoneroGetWatchKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoneroGetWatchKey;
})();

$root.MoneroWatchKey = (function() {

    function MoneroWatchKey(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroWatchKey.prototype.watch_key = $util.newBuffer([]);
    MoneroWatchKey.prototype.address = $util.newBuffer([]);

    MoneroWatchKey.create = function create(properties) {
        return new MoneroWatchKey(properties);
    };

    MoneroWatchKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.watch_key != null && Object.hasOwnProperty.call(message, "watch_key"))
            writer.uint32(10).bytes(message.watch_key);
        if (message.address != null && Object.hasOwnProperty.call(message, "address"))
            writer.uint32(18).bytes(message.address);
        return writer;
    };

    MoneroWatchKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroWatchKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroWatchKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.watch_key = reader.bytes();
                break;
            case 2:
                message.address = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroWatchKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroWatchKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.watch_key != null && message.hasOwnProperty("watch_key"))
            if (!(message.watch_key && typeof message.watch_key.length === "number" || $util.isString(message.watch_key)))
                return "watch_key: buffer expected";
        if (message.address != null && message.hasOwnProperty("address"))
            if (!(message.address && typeof message.address.length === "number" || $util.isString(message.address)))
                return "address: buffer expected";
        return null;
    };

    MoneroWatchKey.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroWatchKey)
            return object;
        var message = new $root.MoneroWatchKey();
        if (object.watch_key != null)
            if (typeof object.watch_key === "string")
                $util.base64.decode(object.watch_key, message.watch_key = $util.newBuffer($util.base64.length(object.watch_key)), 0);
            else if (object.watch_key.length)
                message.watch_key = object.watch_key;
        if (object.address != null)
            if (typeof object.address === "string")
                $util.base64.decode(object.address, message.address = $util.newBuffer($util.base64.length(object.address)), 0);
            else if (object.address.length)
                message.address = object.address;
        return message;
    };

    MoneroWatchKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.watch_key = "";
            else {
                object.watch_key = [];
                if (options.bytes !== Array)
                    object.watch_key = $util.newBuffer(object.watch_key);
            }
            if (options.bytes === String)
                object.address = "";
            else {
                object.address = [];
                if (options.bytes !== Array)
                    object.address = $util.newBuffer(object.address);
            }
        }
        if (message.watch_key != null && message.hasOwnProperty("watch_key"))
            object.watch_key = options.bytes === String ? $util.base64.encode(message.watch_key, 0, message.watch_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.watch_key) : message.watch_key;
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = options.bytes === String ? $util.base64.encode(message.address, 0, message.address.length) : options.bytes === Array ? Array.prototype.slice.call(message.address) : message.address;
        return object;
    };

    MoneroWatchKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoneroWatchKey;
})();

$root.MoneroTransactionInitRequest = (function() {

    function MoneroTransactionInitRequest(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroTransactionInitRequest.prototype.version = 0;
    MoneroTransactionInitRequest.prototype.address_n = $util.emptyArray;
    MoneroTransactionInitRequest.prototype.network_type = 0;
    MoneroTransactionInitRequest.prototype.tsx_data = null;

    MoneroTransactionInitRequest.create = function create(properties) {
        return new MoneroTransactionInitRequest(properties);
    };

    MoneroTransactionInitRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.version != null && Object.hasOwnProperty.call(message, "version"))
            writer.uint32(8).uint32(message.version);
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(16).uint32(message.address_n[i]);
        if (message.network_type != null && Object.hasOwnProperty.call(message, "network_type"))
            writer.uint32(24).uint32(message.network_type);
        if (message.tsx_data != null && Object.hasOwnProperty.call(message, "tsx_data"))
            $root.MoneroTransactionInitRequest.MoneroTransactionData.encode(message.tsx_data, writer.uint32(34).fork()).ldelim();
        return writer;
    };

    MoneroTransactionInitRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroTransactionInitRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroTransactionInitRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.version = reader.uint32();
                break;
            case 2:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 3:
                message.network_type = reader.uint32();
                break;
            case 4:
                message.tsx_data = $root.MoneroTransactionInitRequest.MoneroTransactionData.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroTransactionInitRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroTransactionInitRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.version != null && message.hasOwnProperty("version"))
            if (!$util.isInteger(message.version))
                return "version: integer expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.network_type != null && message.hasOwnProperty("network_type"))
            if (!$util.isInteger(message.network_type))
                return "network_type: integer expected";
        if (message.tsx_data != null && message.hasOwnProperty("tsx_data")) {
            var error = $root.MoneroTransactionInitRequest.MoneroTransactionData.verify(message.tsx_data);
            if (error)
                return "tsx_data." + error;
        }
        return null;
    };

    MoneroTransactionInitRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroTransactionInitRequest)
            return object;
        var message = new $root.MoneroTransactionInitRequest();
        if (object.version != null)
            message.version = object.version >>> 0;
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".MoneroTransactionInitRequest.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.network_type != null)
            message.network_type = object.network_type >>> 0;
        if (object.tsx_data != null) {
            if (typeof object.tsx_data !== "object")
                throw TypeError(".MoneroTransactionInitRequest.tsx_data: object expected");
            message.tsx_data = $root.MoneroTransactionInitRequest.MoneroTransactionData.fromObject(object.tsx_data);
        }
        return message;
    };

    MoneroTransactionInitRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            object.version = 0;
            object.network_type = 0;
            object.tsx_data = null;
        }
        if (message.version != null && message.hasOwnProperty("version"))
            object.version = message.version;
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.network_type != null && message.hasOwnProperty("network_type"))
            object.network_type = message.network_type;
        if (message.tsx_data != null && message.hasOwnProperty("tsx_data"))
            object.tsx_data = $root.MoneroTransactionInitRequest.MoneroTransactionData.toObject(message.tsx_data, options);
        return object;
    };

    MoneroTransactionInitRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    MoneroTransactionInitRequest.MoneroTransactionData = (function() {

        function MoneroTransactionData(properties) {
            this.outputs = [];
            this.minor_indices = [];
            this.integrated_indices = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        MoneroTransactionData.prototype.version = 0;
        MoneroTransactionData.prototype.payment_id = $util.newBuffer([]);
        MoneroTransactionData.prototype.unlock_time = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        MoneroTransactionData.prototype.outputs = $util.emptyArray;
        MoneroTransactionData.prototype.change_dts = null;
        MoneroTransactionData.prototype.num_inputs = 0;
        MoneroTransactionData.prototype.mixin = 0;
        MoneroTransactionData.prototype.fee = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        MoneroTransactionData.prototype.account = 0;
        MoneroTransactionData.prototype.minor_indices = $util.emptyArray;
        MoneroTransactionData.prototype.rsig_data = null;
        MoneroTransactionData.prototype.integrated_indices = $util.emptyArray;
        MoneroTransactionData.prototype.client_version = 0;
        MoneroTransactionData.prototype.hard_fork = 0;
        MoneroTransactionData.prototype.monero_version = $util.newBuffer([]);

        MoneroTransactionData.create = function create(properties) {
            return new MoneroTransactionData(properties);
        };

        MoneroTransactionData.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.version != null && Object.hasOwnProperty.call(message, "version"))
                writer.uint32(8).uint32(message.version);
            if (message.payment_id != null && Object.hasOwnProperty.call(message, "payment_id"))
                writer.uint32(18).bytes(message.payment_id);
            if (message.unlock_time != null && Object.hasOwnProperty.call(message, "unlock_time"))
                writer.uint32(24).uint64(message.unlock_time);
            if (message.outputs != null && message.outputs.length)
                for (var i = 0; i < message.outputs.length; ++i)
                    $root.MoneroTransactionDestinationEntry.encode(message.outputs[i], writer.uint32(34).fork()).ldelim();
            if (message.change_dts != null && Object.hasOwnProperty.call(message, "change_dts"))
                $root.MoneroTransactionDestinationEntry.encode(message.change_dts, writer.uint32(42).fork()).ldelim();
            if (message.num_inputs != null && Object.hasOwnProperty.call(message, "num_inputs"))
                writer.uint32(48).uint32(message.num_inputs);
            if (message.mixin != null && Object.hasOwnProperty.call(message, "mixin"))
                writer.uint32(56).uint32(message.mixin);
            if (message.fee != null && Object.hasOwnProperty.call(message, "fee"))
                writer.uint32(64).uint64(message.fee);
            if (message.account != null && Object.hasOwnProperty.call(message, "account"))
                writer.uint32(72).uint32(message.account);
            if (message.minor_indices != null && message.minor_indices.length)
                for (var i = 0; i < message.minor_indices.length; ++i)
                    writer.uint32(80).uint32(message.minor_indices[i]);
            if (message.rsig_data != null && Object.hasOwnProperty.call(message, "rsig_data"))
                $root.MoneroTransactionRsigData.encode(message.rsig_data, writer.uint32(90).fork()).ldelim();
            if (message.integrated_indices != null && message.integrated_indices.length)
                for (var i = 0; i < message.integrated_indices.length; ++i)
                    writer.uint32(96).uint32(message.integrated_indices[i]);
            if (message.client_version != null && Object.hasOwnProperty.call(message, "client_version"))
                writer.uint32(104).uint32(message.client_version);
            if (message.hard_fork != null && Object.hasOwnProperty.call(message, "hard_fork"))
                writer.uint32(112).uint32(message.hard_fork);
            if (message.monero_version != null && Object.hasOwnProperty.call(message, "monero_version"))
                writer.uint32(122).bytes(message.monero_version);
            return writer;
        };

        MoneroTransactionData.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        MoneroTransactionData.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroTransactionInitRequest.MoneroTransactionData();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.version = reader.uint32();
                    break;
                case 2:
                    message.payment_id = reader.bytes();
                    break;
                case 3:
                    message.unlock_time = reader.uint64();
                    break;
                case 4:
                    if (!(message.outputs && message.outputs.length))
                        message.outputs = [];
                    message.outputs.push($root.MoneroTransactionDestinationEntry.decode(reader, reader.uint32()));
                    break;
                case 5:
                    message.change_dts = $root.MoneroTransactionDestinationEntry.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.num_inputs = reader.uint32();
                    break;
                case 7:
                    message.mixin = reader.uint32();
                    break;
                case 8:
                    message.fee = reader.uint64();
                    break;
                case 9:
                    message.account = reader.uint32();
                    break;
                case 10:
                    if (!(message.minor_indices && message.minor_indices.length))
                        message.minor_indices = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.minor_indices.push(reader.uint32());
                    } else
                        message.minor_indices.push(reader.uint32());
                    break;
                case 11:
                    message.rsig_data = $root.MoneroTransactionRsigData.decode(reader, reader.uint32());
                    break;
                case 12:
                    if (!(message.integrated_indices && message.integrated_indices.length))
                        message.integrated_indices = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.integrated_indices.push(reader.uint32());
                    } else
                        message.integrated_indices.push(reader.uint32());
                    break;
                case 13:
                    message.client_version = reader.uint32();
                    break;
                case 14:
                    message.hard_fork = reader.uint32();
                    break;
                case 15:
                    message.monero_version = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        MoneroTransactionData.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        MoneroTransactionData.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.version != null && message.hasOwnProperty("version"))
                if (!$util.isInteger(message.version))
                    return "version: integer expected";
            if (message.payment_id != null && message.hasOwnProperty("payment_id"))
                if (!(message.payment_id && typeof message.payment_id.length === "number" || $util.isString(message.payment_id)))
                    return "payment_id: buffer expected";
            if (message.unlock_time != null && message.hasOwnProperty("unlock_time"))
                if (!$util.isInteger(message.unlock_time) && !(message.unlock_time && $util.isInteger(message.unlock_time.low) && $util.isInteger(message.unlock_time.high)))
                    return "unlock_time: integer|Long expected";
            if (message.outputs != null && message.hasOwnProperty("outputs")) {
                if (!Array.isArray(message.outputs))
                    return "outputs: array expected";
                for (var i = 0; i < message.outputs.length; ++i) {
                    var error = $root.MoneroTransactionDestinationEntry.verify(message.outputs[i]);
                    if (error)
                        return "outputs." + error;
                }
            }
            if (message.change_dts != null && message.hasOwnProperty("change_dts")) {
                var error = $root.MoneroTransactionDestinationEntry.verify(message.change_dts);
                if (error)
                    return "change_dts." + error;
            }
            if (message.num_inputs != null && message.hasOwnProperty("num_inputs"))
                if (!$util.isInteger(message.num_inputs))
                    return "num_inputs: integer expected";
            if (message.mixin != null && message.hasOwnProperty("mixin"))
                if (!$util.isInteger(message.mixin))
                    return "mixin: integer expected";
            if (message.fee != null && message.hasOwnProperty("fee"))
                if (!$util.isInteger(message.fee) && !(message.fee && $util.isInteger(message.fee.low) && $util.isInteger(message.fee.high)))
                    return "fee: integer|Long expected";
            if (message.account != null && message.hasOwnProperty("account"))
                if (!$util.isInteger(message.account))
                    return "account: integer expected";
            if (message.minor_indices != null && message.hasOwnProperty("minor_indices")) {
                if (!Array.isArray(message.minor_indices))
                    return "minor_indices: array expected";
                for (var i = 0; i < message.minor_indices.length; ++i)
                    if (!$util.isInteger(message.minor_indices[i]))
                        return "minor_indices: integer[] expected";
            }
            if (message.rsig_data != null && message.hasOwnProperty("rsig_data")) {
                var error = $root.MoneroTransactionRsigData.verify(message.rsig_data);
                if (error)
                    return "rsig_data." + error;
            }
            if (message.integrated_indices != null && message.hasOwnProperty("integrated_indices")) {
                if (!Array.isArray(message.integrated_indices))
                    return "integrated_indices: array expected";
                for (var i = 0; i < message.integrated_indices.length; ++i)
                    if (!$util.isInteger(message.integrated_indices[i]))
                        return "integrated_indices: integer[] expected";
            }
            if (message.client_version != null && message.hasOwnProperty("client_version"))
                if (!$util.isInteger(message.client_version))
                    return "client_version: integer expected";
            if (message.hard_fork != null && message.hasOwnProperty("hard_fork"))
                if (!$util.isInteger(message.hard_fork))
                    return "hard_fork: integer expected";
            if (message.monero_version != null && message.hasOwnProperty("monero_version"))
                if (!(message.monero_version && typeof message.monero_version.length === "number" || $util.isString(message.monero_version)))
                    return "monero_version: buffer expected";
            return null;
        };

        MoneroTransactionData.fromObject = function fromObject(object) {
            if (object instanceof $root.MoneroTransactionInitRequest.MoneroTransactionData)
                return object;
            var message = new $root.MoneroTransactionInitRequest.MoneroTransactionData();
            if (object.version != null)
                message.version = object.version >>> 0;
            if (object.payment_id != null)
                if (typeof object.payment_id === "string")
                    $util.base64.decode(object.payment_id, message.payment_id = $util.newBuffer($util.base64.length(object.payment_id)), 0);
                else if (object.payment_id.length)
                    message.payment_id = object.payment_id;
            if (object.unlock_time != null)
                if ($util.Long)
                    (message.unlock_time = $util.Long.fromValue(object.unlock_time)).unsigned = true;
                else if (typeof object.unlock_time === "string")
                    message.unlock_time = parseInt(object.unlock_time, 10);
                else if (typeof object.unlock_time === "number")
                    message.unlock_time = object.unlock_time;
                else if (typeof object.unlock_time === "object")
                    message.unlock_time = new $util.LongBits(object.unlock_time.low >>> 0, object.unlock_time.high >>> 0).toNumber(true);
            if (object.outputs) {
                if (!Array.isArray(object.outputs))
                    throw TypeError(".MoneroTransactionInitRequest.MoneroTransactionData.outputs: array expected");
                message.outputs = [];
                for (var i = 0; i < object.outputs.length; ++i) {
                    if (typeof object.outputs[i] !== "object")
                        throw TypeError(".MoneroTransactionInitRequest.MoneroTransactionData.outputs: object expected");
                    message.outputs[i] = $root.MoneroTransactionDestinationEntry.fromObject(object.outputs[i]);
                }
            }
            if (object.change_dts != null) {
                if (typeof object.change_dts !== "object")
                    throw TypeError(".MoneroTransactionInitRequest.MoneroTransactionData.change_dts: object expected");
                message.change_dts = $root.MoneroTransactionDestinationEntry.fromObject(object.change_dts);
            }
            if (object.num_inputs != null)
                message.num_inputs = object.num_inputs >>> 0;
            if (object.mixin != null)
                message.mixin = object.mixin >>> 0;
            if (object.fee != null)
                if ($util.Long)
                    (message.fee = $util.Long.fromValue(object.fee)).unsigned = true;
                else if (typeof object.fee === "string")
                    message.fee = parseInt(object.fee, 10);
                else if (typeof object.fee === "number")
                    message.fee = object.fee;
                else if (typeof object.fee === "object")
                    message.fee = new $util.LongBits(object.fee.low >>> 0, object.fee.high >>> 0).toNumber(true);
            if (object.account != null)
                message.account = object.account >>> 0;
            if (object.minor_indices) {
                if (!Array.isArray(object.minor_indices))
                    throw TypeError(".MoneroTransactionInitRequest.MoneroTransactionData.minor_indices: array expected");
                message.minor_indices = [];
                for (var i = 0; i < object.minor_indices.length; ++i)
                    message.minor_indices[i] = object.minor_indices[i] >>> 0;
            }
            if (object.rsig_data != null) {
                if (typeof object.rsig_data !== "object")
                    throw TypeError(".MoneroTransactionInitRequest.MoneroTransactionData.rsig_data: object expected");
                message.rsig_data = $root.MoneroTransactionRsigData.fromObject(object.rsig_data);
            }
            if (object.integrated_indices) {
                if (!Array.isArray(object.integrated_indices))
                    throw TypeError(".MoneroTransactionInitRequest.MoneroTransactionData.integrated_indices: array expected");
                message.integrated_indices = [];
                for (var i = 0; i < object.integrated_indices.length; ++i)
                    message.integrated_indices[i] = object.integrated_indices[i] >>> 0;
            }
            if (object.client_version != null)
                message.client_version = object.client_version >>> 0;
            if (object.hard_fork != null)
                message.hard_fork = object.hard_fork >>> 0;
            if (object.monero_version != null)
                if (typeof object.monero_version === "string")
                    $util.base64.decode(object.monero_version, message.monero_version = $util.newBuffer($util.base64.length(object.monero_version)), 0);
                else if (object.monero_version.length)
                    message.monero_version = object.monero_version;
            return message;
        };

        MoneroTransactionData.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.outputs = [];
                object.minor_indices = [];
                object.integrated_indices = [];
            }
            if (options.defaults) {
                object.version = 0;
                if (options.bytes === String)
                    object.payment_id = "";
                else {
                    object.payment_id = [];
                    if (options.bytes !== Array)
                        object.payment_id = $util.newBuffer(object.payment_id);
                }
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.unlock_time = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.unlock_time = options.longs === String ? "0" : 0;
                object.change_dts = null;
                object.num_inputs = 0;
                object.mixin = 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.fee = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.fee = options.longs === String ? "0" : 0;
                object.account = 0;
                object.rsig_data = null;
                object.client_version = 0;
                object.hard_fork = 0;
                if (options.bytes === String)
                    object.monero_version = "";
                else {
                    object.monero_version = [];
                    if (options.bytes !== Array)
                        object.monero_version = $util.newBuffer(object.monero_version);
                }
            }
            if (message.version != null && message.hasOwnProperty("version"))
                object.version = message.version;
            if (message.payment_id != null && message.hasOwnProperty("payment_id"))
                object.payment_id = options.bytes === String ? $util.base64.encode(message.payment_id, 0, message.payment_id.length) : options.bytes === Array ? Array.prototype.slice.call(message.payment_id) : message.payment_id;
            if (message.unlock_time != null && message.hasOwnProperty("unlock_time"))
                if (typeof message.unlock_time === "number")
                    object.unlock_time = options.longs === String ? String(message.unlock_time) : message.unlock_time;
                else
                    object.unlock_time = options.longs === String ? $util.Long.prototype.toString.call(message.unlock_time) : options.longs === Number ? new $util.LongBits(message.unlock_time.low >>> 0, message.unlock_time.high >>> 0).toNumber(true) : message.unlock_time;
            if (message.outputs && message.outputs.length) {
                object.outputs = [];
                for (var j = 0; j < message.outputs.length; ++j)
                    object.outputs[j] = $root.MoneroTransactionDestinationEntry.toObject(message.outputs[j], options);
            }
            if (message.change_dts != null && message.hasOwnProperty("change_dts"))
                object.change_dts = $root.MoneroTransactionDestinationEntry.toObject(message.change_dts, options);
            if (message.num_inputs != null && message.hasOwnProperty("num_inputs"))
                object.num_inputs = message.num_inputs;
            if (message.mixin != null && message.hasOwnProperty("mixin"))
                object.mixin = message.mixin;
            if (message.fee != null && message.hasOwnProperty("fee"))
                if (typeof message.fee === "number")
                    object.fee = options.longs === String ? String(message.fee) : message.fee;
                else
                    object.fee = options.longs === String ? $util.Long.prototype.toString.call(message.fee) : options.longs === Number ? new $util.LongBits(message.fee.low >>> 0, message.fee.high >>> 0).toNumber(true) : message.fee;
            if (message.account != null && message.hasOwnProperty("account"))
                object.account = message.account;
            if (message.minor_indices && message.minor_indices.length) {
                object.minor_indices = [];
                for (var j = 0; j < message.minor_indices.length; ++j)
                    object.minor_indices[j] = message.minor_indices[j];
            }
            if (message.rsig_data != null && message.hasOwnProperty("rsig_data"))
                object.rsig_data = $root.MoneroTransactionRsigData.toObject(message.rsig_data, options);
            if (message.integrated_indices && message.integrated_indices.length) {
                object.integrated_indices = [];
                for (var j = 0; j < message.integrated_indices.length; ++j)
                    object.integrated_indices[j] = message.integrated_indices[j];
            }
            if (message.client_version != null && message.hasOwnProperty("client_version"))
                object.client_version = message.client_version;
            if (message.hard_fork != null && message.hasOwnProperty("hard_fork"))
                object.hard_fork = message.hard_fork;
            if (message.monero_version != null && message.hasOwnProperty("monero_version"))
                object.monero_version = options.bytes === String ? $util.base64.encode(message.monero_version, 0, message.monero_version.length) : options.bytes === Array ? Array.prototype.slice.call(message.monero_version) : message.monero_version;
            return object;
        };

        MoneroTransactionData.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return MoneroTransactionData;
    })();

    return MoneroTransactionInitRequest;
})();

$root.MoneroTransactionInitAck = (function() {

    function MoneroTransactionInitAck(properties) {
        this.hmacs = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroTransactionInitAck.prototype.hmacs = $util.emptyArray;
    MoneroTransactionInitAck.prototype.rsig_data = null;

    MoneroTransactionInitAck.create = function create(properties) {
        return new MoneroTransactionInitAck(properties);
    };

    MoneroTransactionInitAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.hmacs != null && message.hmacs.length)
            for (var i = 0; i < message.hmacs.length; ++i)
                writer.uint32(10).bytes(message.hmacs[i]);
        if (message.rsig_data != null && Object.hasOwnProperty.call(message, "rsig_data"))
            $root.MoneroTransactionRsigData.encode(message.rsig_data, writer.uint32(18).fork()).ldelim();
        return writer;
    };

    MoneroTransactionInitAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroTransactionInitAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroTransactionInitAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.hmacs && message.hmacs.length))
                    message.hmacs = [];
                message.hmacs.push(reader.bytes());
                break;
            case 2:
                message.rsig_data = $root.MoneroTransactionRsigData.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroTransactionInitAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroTransactionInitAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.hmacs != null && message.hasOwnProperty("hmacs")) {
            if (!Array.isArray(message.hmacs))
                return "hmacs: array expected";
            for (var i = 0; i < message.hmacs.length; ++i)
                if (!(message.hmacs[i] && typeof message.hmacs[i].length === "number" || $util.isString(message.hmacs[i])))
                    return "hmacs: buffer[] expected";
        }
        if (message.rsig_data != null && message.hasOwnProperty("rsig_data")) {
            var error = $root.MoneroTransactionRsigData.verify(message.rsig_data);
            if (error)
                return "rsig_data." + error;
        }
        return null;
    };

    MoneroTransactionInitAck.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroTransactionInitAck)
            return object;
        var message = new $root.MoneroTransactionInitAck();
        if (object.hmacs) {
            if (!Array.isArray(object.hmacs))
                throw TypeError(".MoneroTransactionInitAck.hmacs: array expected");
            message.hmacs = [];
            for (var i = 0; i < object.hmacs.length; ++i)
                if (typeof object.hmacs[i] === "string")
                    $util.base64.decode(object.hmacs[i], message.hmacs[i] = $util.newBuffer($util.base64.length(object.hmacs[i])), 0);
                else if (object.hmacs[i].length)
                    message.hmacs[i] = object.hmacs[i];
        }
        if (object.rsig_data != null) {
            if (typeof object.rsig_data !== "object")
                throw TypeError(".MoneroTransactionInitAck.rsig_data: object expected");
            message.rsig_data = $root.MoneroTransactionRsigData.fromObject(object.rsig_data);
        }
        return message;
    };

    MoneroTransactionInitAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.hmacs = [];
        if (options.defaults)
            object.rsig_data = null;
        if (message.hmacs && message.hmacs.length) {
            object.hmacs = [];
            for (var j = 0; j < message.hmacs.length; ++j)
                object.hmacs[j] = options.bytes === String ? $util.base64.encode(message.hmacs[j], 0, message.hmacs[j].length) : options.bytes === Array ? Array.prototype.slice.call(message.hmacs[j]) : message.hmacs[j];
        }
        if (message.rsig_data != null && message.hasOwnProperty("rsig_data"))
            object.rsig_data = $root.MoneroTransactionRsigData.toObject(message.rsig_data, options);
        return object;
    };

    MoneroTransactionInitAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoneroTransactionInitAck;
})();

$root.MoneroTransactionSetInputRequest = (function() {

    function MoneroTransactionSetInputRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroTransactionSetInputRequest.prototype.src_entr = null;

    MoneroTransactionSetInputRequest.create = function create(properties) {
        return new MoneroTransactionSetInputRequest(properties);
    };

    MoneroTransactionSetInputRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.src_entr != null && Object.hasOwnProperty.call(message, "src_entr"))
            $root.MoneroTransactionSourceEntry.encode(message.src_entr, writer.uint32(10).fork()).ldelim();
        return writer;
    };

    MoneroTransactionSetInputRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroTransactionSetInputRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroTransactionSetInputRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.src_entr = $root.MoneroTransactionSourceEntry.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroTransactionSetInputRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroTransactionSetInputRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.src_entr != null && message.hasOwnProperty("src_entr")) {
            var error = $root.MoneroTransactionSourceEntry.verify(message.src_entr);
            if (error)
                return "src_entr." + error;
        }
        return null;
    };

    MoneroTransactionSetInputRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroTransactionSetInputRequest)
            return object;
        var message = new $root.MoneroTransactionSetInputRequest();
        if (object.src_entr != null) {
            if (typeof object.src_entr !== "object")
                throw TypeError(".MoneroTransactionSetInputRequest.src_entr: object expected");
            message.src_entr = $root.MoneroTransactionSourceEntry.fromObject(object.src_entr);
        }
        return message;
    };

    MoneroTransactionSetInputRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.src_entr = null;
        if (message.src_entr != null && message.hasOwnProperty("src_entr"))
            object.src_entr = $root.MoneroTransactionSourceEntry.toObject(message.src_entr, options);
        return object;
    };

    MoneroTransactionSetInputRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoneroTransactionSetInputRequest;
})();

$root.MoneroTransactionSetInputAck = (function() {

    function MoneroTransactionSetInputAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroTransactionSetInputAck.prototype.vini = $util.newBuffer([]);
    MoneroTransactionSetInputAck.prototype.vini_hmac = $util.newBuffer([]);
    MoneroTransactionSetInputAck.prototype.pseudo_out = $util.newBuffer([]);
    MoneroTransactionSetInputAck.prototype.pseudo_out_hmac = $util.newBuffer([]);
    MoneroTransactionSetInputAck.prototype.pseudo_out_alpha = $util.newBuffer([]);
    MoneroTransactionSetInputAck.prototype.spend_key = $util.newBuffer([]);

    MoneroTransactionSetInputAck.create = function create(properties) {
        return new MoneroTransactionSetInputAck(properties);
    };

    MoneroTransactionSetInputAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.vini != null && Object.hasOwnProperty.call(message, "vini"))
            writer.uint32(10).bytes(message.vini);
        if (message.vini_hmac != null && Object.hasOwnProperty.call(message, "vini_hmac"))
            writer.uint32(18).bytes(message.vini_hmac);
        if (message.pseudo_out != null && Object.hasOwnProperty.call(message, "pseudo_out"))
            writer.uint32(26).bytes(message.pseudo_out);
        if (message.pseudo_out_hmac != null && Object.hasOwnProperty.call(message, "pseudo_out_hmac"))
            writer.uint32(34).bytes(message.pseudo_out_hmac);
        if (message.pseudo_out_alpha != null && Object.hasOwnProperty.call(message, "pseudo_out_alpha"))
            writer.uint32(42).bytes(message.pseudo_out_alpha);
        if (message.spend_key != null && Object.hasOwnProperty.call(message, "spend_key"))
            writer.uint32(50).bytes(message.spend_key);
        return writer;
    };

    MoneroTransactionSetInputAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroTransactionSetInputAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroTransactionSetInputAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.vini = reader.bytes();
                break;
            case 2:
                message.vini_hmac = reader.bytes();
                break;
            case 3:
                message.pseudo_out = reader.bytes();
                break;
            case 4:
                message.pseudo_out_hmac = reader.bytes();
                break;
            case 5:
                message.pseudo_out_alpha = reader.bytes();
                break;
            case 6:
                message.spend_key = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroTransactionSetInputAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroTransactionSetInputAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.vini != null && message.hasOwnProperty("vini"))
            if (!(message.vini && typeof message.vini.length === "number" || $util.isString(message.vini)))
                return "vini: buffer expected";
        if (message.vini_hmac != null && message.hasOwnProperty("vini_hmac"))
            if (!(message.vini_hmac && typeof message.vini_hmac.length === "number" || $util.isString(message.vini_hmac)))
                return "vini_hmac: buffer expected";
        if (message.pseudo_out != null && message.hasOwnProperty("pseudo_out"))
            if (!(message.pseudo_out && typeof message.pseudo_out.length === "number" || $util.isString(message.pseudo_out)))
                return "pseudo_out: buffer expected";
        if (message.pseudo_out_hmac != null && message.hasOwnProperty("pseudo_out_hmac"))
            if (!(message.pseudo_out_hmac && typeof message.pseudo_out_hmac.length === "number" || $util.isString(message.pseudo_out_hmac)))
                return "pseudo_out_hmac: buffer expected";
        if (message.pseudo_out_alpha != null && message.hasOwnProperty("pseudo_out_alpha"))
            if (!(message.pseudo_out_alpha && typeof message.pseudo_out_alpha.length === "number" || $util.isString(message.pseudo_out_alpha)))
                return "pseudo_out_alpha: buffer expected";
        if (message.spend_key != null && message.hasOwnProperty("spend_key"))
            if (!(message.spend_key && typeof message.spend_key.length === "number" || $util.isString(message.spend_key)))
                return "spend_key: buffer expected";
        return null;
    };

    MoneroTransactionSetInputAck.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroTransactionSetInputAck)
            return object;
        var message = new $root.MoneroTransactionSetInputAck();
        if (object.vini != null)
            if (typeof object.vini === "string")
                $util.base64.decode(object.vini, message.vini = $util.newBuffer($util.base64.length(object.vini)), 0);
            else if (object.vini.length)
                message.vini = object.vini;
        if (object.vini_hmac != null)
            if (typeof object.vini_hmac === "string")
                $util.base64.decode(object.vini_hmac, message.vini_hmac = $util.newBuffer($util.base64.length(object.vini_hmac)), 0);
            else if (object.vini_hmac.length)
                message.vini_hmac = object.vini_hmac;
        if (object.pseudo_out != null)
            if (typeof object.pseudo_out === "string")
                $util.base64.decode(object.pseudo_out, message.pseudo_out = $util.newBuffer($util.base64.length(object.pseudo_out)), 0);
            else if (object.pseudo_out.length)
                message.pseudo_out = object.pseudo_out;
        if (object.pseudo_out_hmac != null)
            if (typeof object.pseudo_out_hmac === "string")
                $util.base64.decode(object.pseudo_out_hmac, message.pseudo_out_hmac = $util.newBuffer($util.base64.length(object.pseudo_out_hmac)), 0);
            else if (object.pseudo_out_hmac.length)
                message.pseudo_out_hmac = object.pseudo_out_hmac;
        if (object.pseudo_out_alpha != null)
            if (typeof object.pseudo_out_alpha === "string")
                $util.base64.decode(object.pseudo_out_alpha, message.pseudo_out_alpha = $util.newBuffer($util.base64.length(object.pseudo_out_alpha)), 0);
            else if (object.pseudo_out_alpha.length)
                message.pseudo_out_alpha = object.pseudo_out_alpha;
        if (object.spend_key != null)
            if (typeof object.spend_key === "string")
                $util.base64.decode(object.spend_key, message.spend_key = $util.newBuffer($util.base64.length(object.spend_key)), 0);
            else if (object.spend_key.length)
                message.spend_key = object.spend_key;
        return message;
    };

    MoneroTransactionSetInputAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.vini = "";
            else {
                object.vini = [];
                if (options.bytes !== Array)
                    object.vini = $util.newBuffer(object.vini);
            }
            if (options.bytes === String)
                object.vini_hmac = "";
            else {
                object.vini_hmac = [];
                if (options.bytes !== Array)
                    object.vini_hmac = $util.newBuffer(object.vini_hmac);
            }
            if (options.bytes === String)
                object.pseudo_out = "";
            else {
                object.pseudo_out = [];
                if (options.bytes !== Array)
                    object.pseudo_out = $util.newBuffer(object.pseudo_out);
            }
            if (options.bytes === String)
                object.pseudo_out_hmac = "";
            else {
                object.pseudo_out_hmac = [];
                if (options.bytes !== Array)
                    object.pseudo_out_hmac = $util.newBuffer(object.pseudo_out_hmac);
            }
            if (options.bytes === String)
                object.pseudo_out_alpha = "";
            else {
                object.pseudo_out_alpha = [];
                if (options.bytes !== Array)
                    object.pseudo_out_alpha = $util.newBuffer(object.pseudo_out_alpha);
            }
            if (options.bytes === String)
                object.spend_key = "";
            else {
                object.spend_key = [];
                if (options.bytes !== Array)
                    object.spend_key = $util.newBuffer(object.spend_key);
            }
        }
        if (message.vini != null && message.hasOwnProperty("vini"))
            object.vini = options.bytes === String ? $util.base64.encode(message.vini, 0, message.vini.length) : options.bytes === Array ? Array.prototype.slice.call(message.vini) : message.vini;
        if (message.vini_hmac != null && message.hasOwnProperty("vini_hmac"))
            object.vini_hmac = options.bytes === String ? $util.base64.encode(message.vini_hmac, 0, message.vini_hmac.length) : options.bytes === Array ? Array.prototype.slice.call(message.vini_hmac) : message.vini_hmac;
        if (message.pseudo_out != null && message.hasOwnProperty("pseudo_out"))
            object.pseudo_out = options.bytes === String ? $util.base64.encode(message.pseudo_out, 0, message.pseudo_out.length) : options.bytes === Array ? Array.prototype.slice.call(message.pseudo_out) : message.pseudo_out;
        if (message.pseudo_out_hmac != null && message.hasOwnProperty("pseudo_out_hmac"))
            object.pseudo_out_hmac = options.bytes === String ? $util.base64.encode(message.pseudo_out_hmac, 0, message.pseudo_out_hmac.length) : options.bytes === Array ? Array.prototype.slice.call(message.pseudo_out_hmac) : message.pseudo_out_hmac;
        if (message.pseudo_out_alpha != null && message.hasOwnProperty("pseudo_out_alpha"))
            object.pseudo_out_alpha = options.bytes === String ? $util.base64.encode(message.pseudo_out_alpha, 0, message.pseudo_out_alpha.length) : options.bytes === Array ? Array.prototype.slice.call(message.pseudo_out_alpha) : message.pseudo_out_alpha;
        if (message.spend_key != null && message.hasOwnProperty("spend_key"))
            object.spend_key = options.bytes === String ? $util.base64.encode(message.spend_key, 0, message.spend_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.spend_key) : message.spend_key;
        return object;
    };

    MoneroTransactionSetInputAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoneroTransactionSetInputAck;
})();

$root.MoneroTransactionInputsPermutationRequest = (function() {

    function MoneroTransactionInputsPermutationRequest(properties) {
        this.perm = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroTransactionInputsPermutationRequest.prototype.perm = $util.emptyArray;

    MoneroTransactionInputsPermutationRequest.create = function create(properties) {
        return new MoneroTransactionInputsPermutationRequest(properties);
    };

    MoneroTransactionInputsPermutationRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.perm != null && message.perm.length)
            for (var i = 0; i < message.perm.length; ++i)
                writer.uint32(8).uint32(message.perm[i]);
        return writer;
    };

    MoneroTransactionInputsPermutationRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroTransactionInputsPermutationRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroTransactionInputsPermutationRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.perm && message.perm.length))
                    message.perm = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.perm.push(reader.uint32());
                } else
                    message.perm.push(reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroTransactionInputsPermutationRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroTransactionInputsPermutationRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.perm != null && message.hasOwnProperty("perm")) {
            if (!Array.isArray(message.perm))
                return "perm: array expected";
            for (var i = 0; i < message.perm.length; ++i)
                if (!$util.isInteger(message.perm[i]))
                    return "perm: integer[] expected";
        }
        return null;
    };

    MoneroTransactionInputsPermutationRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroTransactionInputsPermutationRequest)
            return object;
        var message = new $root.MoneroTransactionInputsPermutationRequest();
        if (object.perm) {
            if (!Array.isArray(object.perm))
                throw TypeError(".MoneroTransactionInputsPermutationRequest.perm: array expected");
            message.perm = [];
            for (var i = 0; i < object.perm.length; ++i)
                message.perm[i] = object.perm[i] >>> 0;
        }
        return message;
    };

    MoneroTransactionInputsPermutationRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.perm = [];
        if (message.perm && message.perm.length) {
            object.perm = [];
            for (var j = 0; j < message.perm.length; ++j)
                object.perm[j] = message.perm[j];
        }
        return object;
    };

    MoneroTransactionInputsPermutationRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoneroTransactionInputsPermutationRequest;
})();

$root.MoneroTransactionInputsPermutationAck = (function() {

    function MoneroTransactionInputsPermutationAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroTransactionInputsPermutationAck.create = function create(properties) {
        return new MoneroTransactionInputsPermutationAck(properties);
    };

    MoneroTransactionInputsPermutationAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    MoneroTransactionInputsPermutationAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroTransactionInputsPermutationAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroTransactionInputsPermutationAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroTransactionInputsPermutationAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroTransactionInputsPermutationAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    MoneroTransactionInputsPermutationAck.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroTransactionInputsPermutationAck)
            return object;
        return new $root.MoneroTransactionInputsPermutationAck();
    };

    MoneroTransactionInputsPermutationAck.toObject = function toObject() {
        return {};
    };

    MoneroTransactionInputsPermutationAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoneroTransactionInputsPermutationAck;
})();

$root.MoneroTransactionInputViniRequest = (function() {

    function MoneroTransactionInputViniRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroTransactionInputViniRequest.prototype.src_entr = null;
    MoneroTransactionInputViniRequest.prototype.vini = $util.newBuffer([]);
    MoneroTransactionInputViniRequest.prototype.vini_hmac = $util.newBuffer([]);
    MoneroTransactionInputViniRequest.prototype.pseudo_out = $util.newBuffer([]);
    MoneroTransactionInputViniRequest.prototype.pseudo_out_hmac = $util.newBuffer([]);
    MoneroTransactionInputViniRequest.prototype.orig_idx = 0;

    MoneroTransactionInputViniRequest.create = function create(properties) {
        return new MoneroTransactionInputViniRequest(properties);
    };

    MoneroTransactionInputViniRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.src_entr != null && Object.hasOwnProperty.call(message, "src_entr"))
            $root.MoneroTransactionSourceEntry.encode(message.src_entr, writer.uint32(10).fork()).ldelim();
        if (message.vini != null && Object.hasOwnProperty.call(message, "vini"))
            writer.uint32(18).bytes(message.vini);
        if (message.vini_hmac != null && Object.hasOwnProperty.call(message, "vini_hmac"))
            writer.uint32(26).bytes(message.vini_hmac);
        if (message.pseudo_out != null && Object.hasOwnProperty.call(message, "pseudo_out"))
            writer.uint32(34).bytes(message.pseudo_out);
        if (message.pseudo_out_hmac != null && Object.hasOwnProperty.call(message, "pseudo_out_hmac"))
            writer.uint32(42).bytes(message.pseudo_out_hmac);
        if (message.orig_idx != null && Object.hasOwnProperty.call(message, "orig_idx"))
            writer.uint32(48).uint32(message.orig_idx);
        return writer;
    };

    MoneroTransactionInputViniRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroTransactionInputViniRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroTransactionInputViniRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.src_entr = $root.MoneroTransactionSourceEntry.decode(reader, reader.uint32());
                break;
            case 2:
                message.vini = reader.bytes();
                break;
            case 3:
                message.vini_hmac = reader.bytes();
                break;
            case 4:
                message.pseudo_out = reader.bytes();
                break;
            case 5:
                message.pseudo_out_hmac = reader.bytes();
                break;
            case 6:
                message.orig_idx = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroTransactionInputViniRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroTransactionInputViniRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.src_entr != null && message.hasOwnProperty("src_entr")) {
            var error = $root.MoneroTransactionSourceEntry.verify(message.src_entr);
            if (error)
                return "src_entr." + error;
        }
        if (message.vini != null && message.hasOwnProperty("vini"))
            if (!(message.vini && typeof message.vini.length === "number" || $util.isString(message.vini)))
                return "vini: buffer expected";
        if (message.vini_hmac != null && message.hasOwnProperty("vini_hmac"))
            if (!(message.vini_hmac && typeof message.vini_hmac.length === "number" || $util.isString(message.vini_hmac)))
                return "vini_hmac: buffer expected";
        if (message.pseudo_out != null && message.hasOwnProperty("pseudo_out"))
            if (!(message.pseudo_out && typeof message.pseudo_out.length === "number" || $util.isString(message.pseudo_out)))
                return "pseudo_out: buffer expected";
        if (message.pseudo_out_hmac != null && message.hasOwnProperty("pseudo_out_hmac"))
            if (!(message.pseudo_out_hmac && typeof message.pseudo_out_hmac.length === "number" || $util.isString(message.pseudo_out_hmac)))
                return "pseudo_out_hmac: buffer expected";
        if (message.orig_idx != null && message.hasOwnProperty("orig_idx"))
            if (!$util.isInteger(message.orig_idx))
                return "orig_idx: integer expected";
        return null;
    };

    MoneroTransactionInputViniRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroTransactionInputViniRequest)
            return object;
        var message = new $root.MoneroTransactionInputViniRequest();
        if (object.src_entr != null) {
            if (typeof object.src_entr !== "object")
                throw TypeError(".MoneroTransactionInputViniRequest.src_entr: object expected");
            message.src_entr = $root.MoneroTransactionSourceEntry.fromObject(object.src_entr);
        }
        if (object.vini != null)
            if (typeof object.vini === "string")
                $util.base64.decode(object.vini, message.vini = $util.newBuffer($util.base64.length(object.vini)), 0);
            else if (object.vini.length)
                message.vini = object.vini;
        if (object.vini_hmac != null)
            if (typeof object.vini_hmac === "string")
                $util.base64.decode(object.vini_hmac, message.vini_hmac = $util.newBuffer($util.base64.length(object.vini_hmac)), 0);
            else if (object.vini_hmac.length)
                message.vini_hmac = object.vini_hmac;
        if (object.pseudo_out != null)
            if (typeof object.pseudo_out === "string")
                $util.base64.decode(object.pseudo_out, message.pseudo_out = $util.newBuffer($util.base64.length(object.pseudo_out)), 0);
            else if (object.pseudo_out.length)
                message.pseudo_out = object.pseudo_out;
        if (object.pseudo_out_hmac != null)
            if (typeof object.pseudo_out_hmac === "string")
                $util.base64.decode(object.pseudo_out_hmac, message.pseudo_out_hmac = $util.newBuffer($util.base64.length(object.pseudo_out_hmac)), 0);
            else if (object.pseudo_out_hmac.length)
                message.pseudo_out_hmac = object.pseudo_out_hmac;
        if (object.orig_idx != null)
            message.orig_idx = object.orig_idx >>> 0;
        return message;
    };

    MoneroTransactionInputViniRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.src_entr = null;
            if (options.bytes === String)
                object.vini = "";
            else {
                object.vini = [];
                if (options.bytes !== Array)
                    object.vini = $util.newBuffer(object.vini);
            }
            if (options.bytes === String)
                object.vini_hmac = "";
            else {
                object.vini_hmac = [];
                if (options.bytes !== Array)
                    object.vini_hmac = $util.newBuffer(object.vini_hmac);
            }
            if (options.bytes === String)
                object.pseudo_out = "";
            else {
                object.pseudo_out = [];
                if (options.bytes !== Array)
                    object.pseudo_out = $util.newBuffer(object.pseudo_out);
            }
            if (options.bytes === String)
                object.pseudo_out_hmac = "";
            else {
                object.pseudo_out_hmac = [];
                if (options.bytes !== Array)
                    object.pseudo_out_hmac = $util.newBuffer(object.pseudo_out_hmac);
            }
            object.orig_idx = 0;
        }
        if (message.src_entr != null && message.hasOwnProperty("src_entr"))
            object.src_entr = $root.MoneroTransactionSourceEntry.toObject(message.src_entr, options);
        if (message.vini != null && message.hasOwnProperty("vini"))
            object.vini = options.bytes === String ? $util.base64.encode(message.vini, 0, message.vini.length) : options.bytes === Array ? Array.prototype.slice.call(message.vini) : message.vini;
        if (message.vini_hmac != null && message.hasOwnProperty("vini_hmac"))
            object.vini_hmac = options.bytes === String ? $util.base64.encode(message.vini_hmac, 0, message.vini_hmac.length) : options.bytes === Array ? Array.prototype.slice.call(message.vini_hmac) : message.vini_hmac;
        if (message.pseudo_out != null && message.hasOwnProperty("pseudo_out"))
            object.pseudo_out = options.bytes === String ? $util.base64.encode(message.pseudo_out, 0, message.pseudo_out.length) : options.bytes === Array ? Array.prototype.slice.call(message.pseudo_out) : message.pseudo_out;
        if (message.pseudo_out_hmac != null && message.hasOwnProperty("pseudo_out_hmac"))
            object.pseudo_out_hmac = options.bytes === String ? $util.base64.encode(message.pseudo_out_hmac, 0, message.pseudo_out_hmac.length) : options.bytes === Array ? Array.prototype.slice.call(message.pseudo_out_hmac) : message.pseudo_out_hmac;
        if (message.orig_idx != null && message.hasOwnProperty("orig_idx"))
            object.orig_idx = message.orig_idx;
        return object;
    };

    MoneroTransactionInputViniRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoneroTransactionInputViniRequest;
})();

$root.MoneroTransactionInputViniAck = (function() {

    function MoneroTransactionInputViniAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroTransactionInputViniAck.create = function create(properties) {
        return new MoneroTransactionInputViniAck(properties);
    };

    MoneroTransactionInputViniAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    MoneroTransactionInputViniAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroTransactionInputViniAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroTransactionInputViniAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroTransactionInputViniAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroTransactionInputViniAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    MoneroTransactionInputViniAck.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroTransactionInputViniAck)
            return object;
        return new $root.MoneroTransactionInputViniAck();
    };

    MoneroTransactionInputViniAck.toObject = function toObject() {
        return {};
    };

    MoneroTransactionInputViniAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoneroTransactionInputViniAck;
})();

$root.MoneroTransactionAllInputsSetRequest = (function() {

    function MoneroTransactionAllInputsSetRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroTransactionAllInputsSetRequest.create = function create(properties) {
        return new MoneroTransactionAllInputsSetRequest(properties);
    };

    MoneroTransactionAllInputsSetRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    MoneroTransactionAllInputsSetRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroTransactionAllInputsSetRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroTransactionAllInputsSetRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroTransactionAllInputsSetRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroTransactionAllInputsSetRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    MoneroTransactionAllInputsSetRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroTransactionAllInputsSetRequest)
            return object;
        return new $root.MoneroTransactionAllInputsSetRequest();
    };

    MoneroTransactionAllInputsSetRequest.toObject = function toObject() {
        return {};
    };

    MoneroTransactionAllInputsSetRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoneroTransactionAllInputsSetRequest;
})();

$root.MoneroTransactionAllInputsSetAck = (function() {

    function MoneroTransactionAllInputsSetAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroTransactionAllInputsSetAck.prototype.rsig_data = null;

    MoneroTransactionAllInputsSetAck.create = function create(properties) {
        return new MoneroTransactionAllInputsSetAck(properties);
    };

    MoneroTransactionAllInputsSetAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.rsig_data != null && Object.hasOwnProperty.call(message, "rsig_data"))
            $root.MoneroTransactionRsigData.encode(message.rsig_data, writer.uint32(10).fork()).ldelim();
        return writer;
    };

    MoneroTransactionAllInputsSetAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroTransactionAllInputsSetAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroTransactionAllInputsSetAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.rsig_data = $root.MoneroTransactionRsigData.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroTransactionAllInputsSetAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroTransactionAllInputsSetAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.rsig_data != null && message.hasOwnProperty("rsig_data")) {
            var error = $root.MoneroTransactionRsigData.verify(message.rsig_data);
            if (error)
                return "rsig_data." + error;
        }
        return null;
    };

    MoneroTransactionAllInputsSetAck.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroTransactionAllInputsSetAck)
            return object;
        var message = new $root.MoneroTransactionAllInputsSetAck();
        if (object.rsig_data != null) {
            if (typeof object.rsig_data !== "object")
                throw TypeError(".MoneroTransactionAllInputsSetAck.rsig_data: object expected");
            message.rsig_data = $root.MoneroTransactionRsigData.fromObject(object.rsig_data);
        }
        return message;
    };

    MoneroTransactionAllInputsSetAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.rsig_data = null;
        if (message.rsig_data != null && message.hasOwnProperty("rsig_data"))
            object.rsig_data = $root.MoneroTransactionRsigData.toObject(message.rsig_data, options);
        return object;
    };

    MoneroTransactionAllInputsSetAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoneroTransactionAllInputsSetAck;
})();

$root.MoneroTransactionSetOutputRequest = (function() {

    function MoneroTransactionSetOutputRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroTransactionSetOutputRequest.prototype.dst_entr = null;
    MoneroTransactionSetOutputRequest.prototype.dst_entr_hmac = $util.newBuffer([]);
    MoneroTransactionSetOutputRequest.prototype.rsig_data = null;
    MoneroTransactionSetOutputRequest.prototype.is_offloaded_bp = false;

    MoneroTransactionSetOutputRequest.create = function create(properties) {
        return new MoneroTransactionSetOutputRequest(properties);
    };

    MoneroTransactionSetOutputRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.dst_entr != null && Object.hasOwnProperty.call(message, "dst_entr"))
            $root.MoneroTransactionDestinationEntry.encode(message.dst_entr, writer.uint32(10).fork()).ldelim();
        if (message.dst_entr_hmac != null && Object.hasOwnProperty.call(message, "dst_entr_hmac"))
            writer.uint32(18).bytes(message.dst_entr_hmac);
        if (message.rsig_data != null && Object.hasOwnProperty.call(message, "rsig_data"))
            $root.MoneroTransactionRsigData.encode(message.rsig_data, writer.uint32(26).fork()).ldelim();
        if (message.is_offloaded_bp != null && Object.hasOwnProperty.call(message, "is_offloaded_bp"))
            writer.uint32(32).bool(message.is_offloaded_bp);
        return writer;
    };

    MoneroTransactionSetOutputRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroTransactionSetOutputRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroTransactionSetOutputRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.dst_entr = $root.MoneroTransactionDestinationEntry.decode(reader, reader.uint32());
                break;
            case 2:
                message.dst_entr_hmac = reader.bytes();
                break;
            case 3:
                message.rsig_data = $root.MoneroTransactionRsigData.decode(reader, reader.uint32());
                break;
            case 4:
                message.is_offloaded_bp = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroTransactionSetOutputRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroTransactionSetOutputRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.dst_entr != null && message.hasOwnProperty("dst_entr")) {
            var error = $root.MoneroTransactionDestinationEntry.verify(message.dst_entr);
            if (error)
                return "dst_entr." + error;
        }
        if (message.dst_entr_hmac != null && message.hasOwnProperty("dst_entr_hmac"))
            if (!(message.dst_entr_hmac && typeof message.dst_entr_hmac.length === "number" || $util.isString(message.dst_entr_hmac)))
                return "dst_entr_hmac: buffer expected";
        if (message.rsig_data != null && message.hasOwnProperty("rsig_data")) {
            var error = $root.MoneroTransactionRsigData.verify(message.rsig_data);
            if (error)
                return "rsig_data." + error;
        }
        if (message.is_offloaded_bp != null && message.hasOwnProperty("is_offloaded_bp"))
            if (typeof message.is_offloaded_bp !== "boolean")
                return "is_offloaded_bp: boolean expected";
        return null;
    };

    MoneroTransactionSetOutputRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroTransactionSetOutputRequest)
            return object;
        var message = new $root.MoneroTransactionSetOutputRequest();
        if (object.dst_entr != null) {
            if (typeof object.dst_entr !== "object")
                throw TypeError(".MoneroTransactionSetOutputRequest.dst_entr: object expected");
            message.dst_entr = $root.MoneroTransactionDestinationEntry.fromObject(object.dst_entr);
        }
        if (object.dst_entr_hmac != null)
            if (typeof object.dst_entr_hmac === "string")
                $util.base64.decode(object.dst_entr_hmac, message.dst_entr_hmac = $util.newBuffer($util.base64.length(object.dst_entr_hmac)), 0);
            else if (object.dst_entr_hmac.length)
                message.dst_entr_hmac = object.dst_entr_hmac;
        if (object.rsig_data != null) {
            if (typeof object.rsig_data !== "object")
                throw TypeError(".MoneroTransactionSetOutputRequest.rsig_data: object expected");
            message.rsig_data = $root.MoneroTransactionRsigData.fromObject(object.rsig_data);
        }
        if (object.is_offloaded_bp != null)
            message.is_offloaded_bp = Boolean(object.is_offloaded_bp);
        return message;
    };

    MoneroTransactionSetOutputRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.dst_entr = null;
            if (options.bytes === String)
                object.dst_entr_hmac = "";
            else {
                object.dst_entr_hmac = [];
                if (options.bytes !== Array)
                    object.dst_entr_hmac = $util.newBuffer(object.dst_entr_hmac);
            }
            object.rsig_data = null;
            object.is_offloaded_bp = false;
        }
        if (message.dst_entr != null && message.hasOwnProperty("dst_entr"))
            object.dst_entr = $root.MoneroTransactionDestinationEntry.toObject(message.dst_entr, options);
        if (message.dst_entr_hmac != null && message.hasOwnProperty("dst_entr_hmac"))
            object.dst_entr_hmac = options.bytes === String ? $util.base64.encode(message.dst_entr_hmac, 0, message.dst_entr_hmac.length) : options.bytes === Array ? Array.prototype.slice.call(message.dst_entr_hmac) : message.dst_entr_hmac;
        if (message.rsig_data != null && message.hasOwnProperty("rsig_data"))
            object.rsig_data = $root.MoneroTransactionRsigData.toObject(message.rsig_data, options);
        if (message.is_offloaded_bp != null && message.hasOwnProperty("is_offloaded_bp"))
            object.is_offloaded_bp = message.is_offloaded_bp;
        return object;
    };

    MoneroTransactionSetOutputRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoneroTransactionSetOutputRequest;
})();

$root.MoneroTransactionSetOutputAck = (function() {

    function MoneroTransactionSetOutputAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroTransactionSetOutputAck.prototype.tx_out = $util.newBuffer([]);
    MoneroTransactionSetOutputAck.prototype.vouti_hmac = $util.newBuffer([]);
    MoneroTransactionSetOutputAck.prototype.rsig_data = null;
    MoneroTransactionSetOutputAck.prototype.out_pk = $util.newBuffer([]);
    MoneroTransactionSetOutputAck.prototype.ecdh_info = $util.newBuffer([]);

    MoneroTransactionSetOutputAck.create = function create(properties) {
        return new MoneroTransactionSetOutputAck(properties);
    };

    MoneroTransactionSetOutputAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.tx_out != null && Object.hasOwnProperty.call(message, "tx_out"))
            writer.uint32(10).bytes(message.tx_out);
        if (message.vouti_hmac != null && Object.hasOwnProperty.call(message, "vouti_hmac"))
            writer.uint32(18).bytes(message.vouti_hmac);
        if (message.rsig_data != null && Object.hasOwnProperty.call(message, "rsig_data"))
            $root.MoneroTransactionRsigData.encode(message.rsig_data, writer.uint32(26).fork()).ldelim();
        if (message.out_pk != null && Object.hasOwnProperty.call(message, "out_pk"))
            writer.uint32(34).bytes(message.out_pk);
        if (message.ecdh_info != null && Object.hasOwnProperty.call(message, "ecdh_info"))
            writer.uint32(42).bytes(message.ecdh_info);
        return writer;
    };

    MoneroTransactionSetOutputAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroTransactionSetOutputAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroTransactionSetOutputAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.tx_out = reader.bytes();
                break;
            case 2:
                message.vouti_hmac = reader.bytes();
                break;
            case 3:
                message.rsig_data = $root.MoneroTransactionRsigData.decode(reader, reader.uint32());
                break;
            case 4:
                message.out_pk = reader.bytes();
                break;
            case 5:
                message.ecdh_info = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroTransactionSetOutputAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroTransactionSetOutputAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.tx_out != null && message.hasOwnProperty("tx_out"))
            if (!(message.tx_out && typeof message.tx_out.length === "number" || $util.isString(message.tx_out)))
                return "tx_out: buffer expected";
        if (message.vouti_hmac != null && message.hasOwnProperty("vouti_hmac"))
            if (!(message.vouti_hmac && typeof message.vouti_hmac.length === "number" || $util.isString(message.vouti_hmac)))
                return "vouti_hmac: buffer expected";
        if (message.rsig_data != null && message.hasOwnProperty("rsig_data")) {
            var error = $root.MoneroTransactionRsigData.verify(message.rsig_data);
            if (error)
                return "rsig_data." + error;
        }
        if (message.out_pk != null && message.hasOwnProperty("out_pk"))
            if (!(message.out_pk && typeof message.out_pk.length === "number" || $util.isString(message.out_pk)))
                return "out_pk: buffer expected";
        if (message.ecdh_info != null && message.hasOwnProperty("ecdh_info"))
            if (!(message.ecdh_info && typeof message.ecdh_info.length === "number" || $util.isString(message.ecdh_info)))
                return "ecdh_info: buffer expected";
        return null;
    };

    MoneroTransactionSetOutputAck.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroTransactionSetOutputAck)
            return object;
        var message = new $root.MoneroTransactionSetOutputAck();
        if (object.tx_out != null)
            if (typeof object.tx_out === "string")
                $util.base64.decode(object.tx_out, message.tx_out = $util.newBuffer($util.base64.length(object.tx_out)), 0);
            else if (object.tx_out.length)
                message.tx_out = object.tx_out;
        if (object.vouti_hmac != null)
            if (typeof object.vouti_hmac === "string")
                $util.base64.decode(object.vouti_hmac, message.vouti_hmac = $util.newBuffer($util.base64.length(object.vouti_hmac)), 0);
            else if (object.vouti_hmac.length)
                message.vouti_hmac = object.vouti_hmac;
        if (object.rsig_data != null) {
            if (typeof object.rsig_data !== "object")
                throw TypeError(".MoneroTransactionSetOutputAck.rsig_data: object expected");
            message.rsig_data = $root.MoneroTransactionRsigData.fromObject(object.rsig_data);
        }
        if (object.out_pk != null)
            if (typeof object.out_pk === "string")
                $util.base64.decode(object.out_pk, message.out_pk = $util.newBuffer($util.base64.length(object.out_pk)), 0);
            else if (object.out_pk.length)
                message.out_pk = object.out_pk;
        if (object.ecdh_info != null)
            if (typeof object.ecdh_info === "string")
                $util.base64.decode(object.ecdh_info, message.ecdh_info = $util.newBuffer($util.base64.length(object.ecdh_info)), 0);
            else if (object.ecdh_info.length)
                message.ecdh_info = object.ecdh_info;
        return message;
    };

    MoneroTransactionSetOutputAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.tx_out = "";
            else {
                object.tx_out = [];
                if (options.bytes !== Array)
                    object.tx_out = $util.newBuffer(object.tx_out);
            }
            if (options.bytes === String)
                object.vouti_hmac = "";
            else {
                object.vouti_hmac = [];
                if (options.bytes !== Array)
                    object.vouti_hmac = $util.newBuffer(object.vouti_hmac);
            }
            object.rsig_data = null;
            if (options.bytes === String)
                object.out_pk = "";
            else {
                object.out_pk = [];
                if (options.bytes !== Array)
                    object.out_pk = $util.newBuffer(object.out_pk);
            }
            if (options.bytes === String)
                object.ecdh_info = "";
            else {
                object.ecdh_info = [];
                if (options.bytes !== Array)
                    object.ecdh_info = $util.newBuffer(object.ecdh_info);
            }
        }
        if (message.tx_out != null && message.hasOwnProperty("tx_out"))
            object.tx_out = options.bytes === String ? $util.base64.encode(message.tx_out, 0, message.tx_out.length) : options.bytes === Array ? Array.prototype.slice.call(message.tx_out) : message.tx_out;
        if (message.vouti_hmac != null && message.hasOwnProperty("vouti_hmac"))
            object.vouti_hmac = options.bytes === String ? $util.base64.encode(message.vouti_hmac, 0, message.vouti_hmac.length) : options.bytes === Array ? Array.prototype.slice.call(message.vouti_hmac) : message.vouti_hmac;
        if (message.rsig_data != null && message.hasOwnProperty("rsig_data"))
            object.rsig_data = $root.MoneroTransactionRsigData.toObject(message.rsig_data, options);
        if (message.out_pk != null && message.hasOwnProperty("out_pk"))
            object.out_pk = options.bytes === String ? $util.base64.encode(message.out_pk, 0, message.out_pk.length) : options.bytes === Array ? Array.prototype.slice.call(message.out_pk) : message.out_pk;
        if (message.ecdh_info != null && message.hasOwnProperty("ecdh_info"))
            object.ecdh_info = options.bytes === String ? $util.base64.encode(message.ecdh_info, 0, message.ecdh_info.length) : options.bytes === Array ? Array.prototype.slice.call(message.ecdh_info) : message.ecdh_info;
        return object;
    };

    MoneroTransactionSetOutputAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoneroTransactionSetOutputAck;
})();

$root.MoneroTransactionAllOutSetRequest = (function() {

    function MoneroTransactionAllOutSetRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroTransactionAllOutSetRequest.prototype.rsig_data = null;

    MoneroTransactionAllOutSetRequest.create = function create(properties) {
        return new MoneroTransactionAllOutSetRequest(properties);
    };

    MoneroTransactionAllOutSetRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.rsig_data != null && Object.hasOwnProperty.call(message, "rsig_data"))
            $root.MoneroTransactionRsigData.encode(message.rsig_data, writer.uint32(10).fork()).ldelim();
        return writer;
    };

    MoneroTransactionAllOutSetRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroTransactionAllOutSetRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroTransactionAllOutSetRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.rsig_data = $root.MoneroTransactionRsigData.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroTransactionAllOutSetRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroTransactionAllOutSetRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.rsig_data != null && message.hasOwnProperty("rsig_data")) {
            var error = $root.MoneroTransactionRsigData.verify(message.rsig_data);
            if (error)
                return "rsig_data." + error;
        }
        return null;
    };

    MoneroTransactionAllOutSetRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroTransactionAllOutSetRequest)
            return object;
        var message = new $root.MoneroTransactionAllOutSetRequest();
        if (object.rsig_data != null) {
            if (typeof object.rsig_data !== "object")
                throw TypeError(".MoneroTransactionAllOutSetRequest.rsig_data: object expected");
            message.rsig_data = $root.MoneroTransactionRsigData.fromObject(object.rsig_data);
        }
        return message;
    };

    MoneroTransactionAllOutSetRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.rsig_data = null;
        if (message.rsig_data != null && message.hasOwnProperty("rsig_data"))
            object.rsig_data = $root.MoneroTransactionRsigData.toObject(message.rsig_data, options);
        return object;
    };

    MoneroTransactionAllOutSetRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoneroTransactionAllOutSetRequest;
})();

$root.MoneroTransactionAllOutSetAck = (function() {

    function MoneroTransactionAllOutSetAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroTransactionAllOutSetAck.prototype.extra = $util.newBuffer([]);
    MoneroTransactionAllOutSetAck.prototype.tx_prefix_hash = $util.newBuffer([]);
    MoneroTransactionAllOutSetAck.prototype.rv = null;
    MoneroTransactionAllOutSetAck.prototype.full_message_hash = $util.newBuffer([]);

    MoneroTransactionAllOutSetAck.create = function create(properties) {
        return new MoneroTransactionAllOutSetAck(properties);
    };

    MoneroTransactionAllOutSetAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.extra != null && Object.hasOwnProperty.call(message, "extra"))
            writer.uint32(10).bytes(message.extra);
        if (message.tx_prefix_hash != null && Object.hasOwnProperty.call(message, "tx_prefix_hash"))
            writer.uint32(18).bytes(message.tx_prefix_hash);
        if (message.rv != null && Object.hasOwnProperty.call(message, "rv"))
            $root.MoneroTransactionAllOutSetAck.MoneroRingCtSig.encode(message.rv, writer.uint32(34).fork()).ldelim();
        if (message.full_message_hash != null && Object.hasOwnProperty.call(message, "full_message_hash"))
            writer.uint32(42).bytes(message.full_message_hash);
        return writer;
    };

    MoneroTransactionAllOutSetAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroTransactionAllOutSetAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroTransactionAllOutSetAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.extra = reader.bytes();
                break;
            case 2:
                message.tx_prefix_hash = reader.bytes();
                break;
            case 4:
                message.rv = $root.MoneroTransactionAllOutSetAck.MoneroRingCtSig.decode(reader, reader.uint32());
                break;
            case 5:
                message.full_message_hash = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroTransactionAllOutSetAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroTransactionAllOutSetAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.extra != null && message.hasOwnProperty("extra"))
            if (!(message.extra && typeof message.extra.length === "number" || $util.isString(message.extra)))
                return "extra: buffer expected";
        if (message.tx_prefix_hash != null && message.hasOwnProperty("tx_prefix_hash"))
            if (!(message.tx_prefix_hash && typeof message.tx_prefix_hash.length === "number" || $util.isString(message.tx_prefix_hash)))
                return "tx_prefix_hash: buffer expected";
        if (message.rv != null && message.hasOwnProperty("rv")) {
            var error = $root.MoneroTransactionAllOutSetAck.MoneroRingCtSig.verify(message.rv);
            if (error)
                return "rv." + error;
        }
        if (message.full_message_hash != null && message.hasOwnProperty("full_message_hash"))
            if (!(message.full_message_hash && typeof message.full_message_hash.length === "number" || $util.isString(message.full_message_hash)))
                return "full_message_hash: buffer expected";
        return null;
    };

    MoneroTransactionAllOutSetAck.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroTransactionAllOutSetAck)
            return object;
        var message = new $root.MoneroTransactionAllOutSetAck();
        if (object.extra != null)
            if (typeof object.extra === "string")
                $util.base64.decode(object.extra, message.extra = $util.newBuffer($util.base64.length(object.extra)), 0);
            else if (object.extra.length)
                message.extra = object.extra;
        if (object.tx_prefix_hash != null)
            if (typeof object.tx_prefix_hash === "string")
                $util.base64.decode(object.tx_prefix_hash, message.tx_prefix_hash = $util.newBuffer($util.base64.length(object.tx_prefix_hash)), 0);
            else if (object.tx_prefix_hash.length)
                message.tx_prefix_hash = object.tx_prefix_hash;
        if (object.rv != null) {
            if (typeof object.rv !== "object")
                throw TypeError(".MoneroTransactionAllOutSetAck.rv: object expected");
            message.rv = $root.MoneroTransactionAllOutSetAck.MoneroRingCtSig.fromObject(object.rv);
        }
        if (object.full_message_hash != null)
            if (typeof object.full_message_hash === "string")
                $util.base64.decode(object.full_message_hash, message.full_message_hash = $util.newBuffer($util.base64.length(object.full_message_hash)), 0);
            else if (object.full_message_hash.length)
                message.full_message_hash = object.full_message_hash;
        return message;
    };

    MoneroTransactionAllOutSetAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.extra = "";
            else {
                object.extra = [];
                if (options.bytes !== Array)
                    object.extra = $util.newBuffer(object.extra);
            }
            if (options.bytes === String)
                object.tx_prefix_hash = "";
            else {
                object.tx_prefix_hash = [];
                if (options.bytes !== Array)
                    object.tx_prefix_hash = $util.newBuffer(object.tx_prefix_hash);
            }
            object.rv = null;
            if (options.bytes === String)
                object.full_message_hash = "";
            else {
                object.full_message_hash = [];
                if (options.bytes !== Array)
                    object.full_message_hash = $util.newBuffer(object.full_message_hash);
            }
        }
        if (message.extra != null && message.hasOwnProperty("extra"))
            object.extra = options.bytes === String ? $util.base64.encode(message.extra, 0, message.extra.length) : options.bytes === Array ? Array.prototype.slice.call(message.extra) : message.extra;
        if (message.tx_prefix_hash != null && message.hasOwnProperty("tx_prefix_hash"))
            object.tx_prefix_hash = options.bytes === String ? $util.base64.encode(message.tx_prefix_hash, 0, message.tx_prefix_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.tx_prefix_hash) : message.tx_prefix_hash;
        if (message.rv != null && message.hasOwnProperty("rv"))
            object.rv = $root.MoneroTransactionAllOutSetAck.MoneroRingCtSig.toObject(message.rv, options);
        if (message.full_message_hash != null && message.hasOwnProperty("full_message_hash"))
            object.full_message_hash = options.bytes === String ? $util.base64.encode(message.full_message_hash, 0, message.full_message_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.full_message_hash) : message.full_message_hash;
        return object;
    };

    MoneroTransactionAllOutSetAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    MoneroTransactionAllOutSetAck.MoneroRingCtSig = (function() {

        function MoneroRingCtSig(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        MoneroRingCtSig.prototype.txn_fee = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        MoneroRingCtSig.prototype.message = $util.newBuffer([]);
        MoneroRingCtSig.prototype.rv_type = 0;

        MoneroRingCtSig.create = function create(properties) {
            return new MoneroRingCtSig(properties);
        };

        MoneroRingCtSig.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.txn_fee != null && Object.hasOwnProperty.call(message, "txn_fee"))
                writer.uint32(8).uint64(message.txn_fee);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(18).bytes(message.message);
            if (message.rv_type != null && Object.hasOwnProperty.call(message, "rv_type"))
                writer.uint32(24).uint32(message.rv_type);
            return writer;
        };

        MoneroRingCtSig.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        MoneroRingCtSig.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroTransactionAllOutSetAck.MoneroRingCtSig();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.txn_fee = reader.uint64();
                    break;
                case 2:
                    message.message = reader.bytes();
                    break;
                case 3:
                    message.rv_type = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        MoneroRingCtSig.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        MoneroRingCtSig.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.txn_fee != null && message.hasOwnProperty("txn_fee"))
                if (!$util.isInteger(message.txn_fee) && !(message.txn_fee && $util.isInteger(message.txn_fee.low) && $util.isInteger(message.txn_fee.high)))
                    return "txn_fee: integer|Long expected";
            if (message.message != null && message.hasOwnProperty("message"))
                if (!(message.message && typeof message.message.length === "number" || $util.isString(message.message)))
                    return "message: buffer expected";
            if (message.rv_type != null && message.hasOwnProperty("rv_type"))
                if (!$util.isInteger(message.rv_type))
                    return "rv_type: integer expected";
            return null;
        };

        MoneroRingCtSig.fromObject = function fromObject(object) {
            if (object instanceof $root.MoneroTransactionAllOutSetAck.MoneroRingCtSig)
                return object;
            var message = new $root.MoneroTransactionAllOutSetAck.MoneroRingCtSig();
            if (object.txn_fee != null)
                if ($util.Long)
                    (message.txn_fee = $util.Long.fromValue(object.txn_fee)).unsigned = true;
                else if (typeof object.txn_fee === "string")
                    message.txn_fee = parseInt(object.txn_fee, 10);
                else if (typeof object.txn_fee === "number")
                    message.txn_fee = object.txn_fee;
                else if (typeof object.txn_fee === "object")
                    message.txn_fee = new $util.LongBits(object.txn_fee.low >>> 0, object.txn_fee.high >>> 0).toNumber(true);
            if (object.message != null)
                if (typeof object.message === "string")
                    $util.base64.decode(object.message, message.message = $util.newBuffer($util.base64.length(object.message)), 0);
                else if (object.message.length)
                    message.message = object.message;
            if (object.rv_type != null)
                message.rv_type = object.rv_type >>> 0;
            return message;
        };

        MoneroRingCtSig.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.txn_fee = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.txn_fee = options.longs === String ? "0" : 0;
                if (options.bytes === String)
                    object.message = "";
                else {
                    object.message = [];
                    if (options.bytes !== Array)
                        object.message = $util.newBuffer(object.message);
                }
                object.rv_type = 0;
            }
            if (message.txn_fee != null && message.hasOwnProperty("txn_fee"))
                if (typeof message.txn_fee === "number")
                    object.txn_fee = options.longs === String ? String(message.txn_fee) : message.txn_fee;
                else
                    object.txn_fee = options.longs === String ? $util.Long.prototype.toString.call(message.txn_fee) : options.longs === Number ? new $util.LongBits(message.txn_fee.low >>> 0, message.txn_fee.high >>> 0).toNumber(true) : message.txn_fee;
            if (message.message != null && message.hasOwnProperty("message"))
                object.message = options.bytes === String ? $util.base64.encode(message.message, 0, message.message.length) : options.bytes === Array ? Array.prototype.slice.call(message.message) : message.message;
            if (message.rv_type != null && message.hasOwnProperty("rv_type"))
                object.rv_type = message.rv_type;
            return object;
        };

        MoneroRingCtSig.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return MoneroRingCtSig;
    })();

    return MoneroTransactionAllOutSetAck;
})();

$root.MoneroTransactionSignInputRequest = (function() {

    function MoneroTransactionSignInputRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroTransactionSignInputRequest.prototype.src_entr = null;
    MoneroTransactionSignInputRequest.prototype.vini = $util.newBuffer([]);
    MoneroTransactionSignInputRequest.prototype.vini_hmac = $util.newBuffer([]);
    MoneroTransactionSignInputRequest.prototype.pseudo_out = $util.newBuffer([]);
    MoneroTransactionSignInputRequest.prototype.pseudo_out_hmac = $util.newBuffer([]);
    MoneroTransactionSignInputRequest.prototype.pseudo_out_alpha = $util.newBuffer([]);
    MoneroTransactionSignInputRequest.prototype.spend_key = $util.newBuffer([]);
    MoneroTransactionSignInputRequest.prototype.orig_idx = 0;

    MoneroTransactionSignInputRequest.create = function create(properties) {
        return new MoneroTransactionSignInputRequest(properties);
    };

    MoneroTransactionSignInputRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.src_entr != null && Object.hasOwnProperty.call(message, "src_entr"))
            $root.MoneroTransactionSourceEntry.encode(message.src_entr, writer.uint32(10).fork()).ldelim();
        if (message.vini != null && Object.hasOwnProperty.call(message, "vini"))
            writer.uint32(18).bytes(message.vini);
        if (message.vini_hmac != null && Object.hasOwnProperty.call(message, "vini_hmac"))
            writer.uint32(26).bytes(message.vini_hmac);
        if (message.pseudo_out != null && Object.hasOwnProperty.call(message, "pseudo_out"))
            writer.uint32(34).bytes(message.pseudo_out);
        if (message.pseudo_out_hmac != null && Object.hasOwnProperty.call(message, "pseudo_out_hmac"))
            writer.uint32(42).bytes(message.pseudo_out_hmac);
        if (message.pseudo_out_alpha != null && Object.hasOwnProperty.call(message, "pseudo_out_alpha"))
            writer.uint32(50).bytes(message.pseudo_out_alpha);
        if (message.spend_key != null && Object.hasOwnProperty.call(message, "spend_key"))
            writer.uint32(58).bytes(message.spend_key);
        if (message.orig_idx != null && Object.hasOwnProperty.call(message, "orig_idx"))
            writer.uint32(64).uint32(message.orig_idx);
        return writer;
    };

    MoneroTransactionSignInputRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroTransactionSignInputRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroTransactionSignInputRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.src_entr = $root.MoneroTransactionSourceEntry.decode(reader, reader.uint32());
                break;
            case 2:
                message.vini = reader.bytes();
                break;
            case 3:
                message.vini_hmac = reader.bytes();
                break;
            case 4:
                message.pseudo_out = reader.bytes();
                break;
            case 5:
                message.pseudo_out_hmac = reader.bytes();
                break;
            case 6:
                message.pseudo_out_alpha = reader.bytes();
                break;
            case 7:
                message.spend_key = reader.bytes();
                break;
            case 8:
                message.orig_idx = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroTransactionSignInputRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroTransactionSignInputRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.src_entr != null && message.hasOwnProperty("src_entr")) {
            var error = $root.MoneroTransactionSourceEntry.verify(message.src_entr);
            if (error)
                return "src_entr." + error;
        }
        if (message.vini != null && message.hasOwnProperty("vini"))
            if (!(message.vini && typeof message.vini.length === "number" || $util.isString(message.vini)))
                return "vini: buffer expected";
        if (message.vini_hmac != null && message.hasOwnProperty("vini_hmac"))
            if (!(message.vini_hmac && typeof message.vini_hmac.length === "number" || $util.isString(message.vini_hmac)))
                return "vini_hmac: buffer expected";
        if (message.pseudo_out != null && message.hasOwnProperty("pseudo_out"))
            if (!(message.pseudo_out && typeof message.pseudo_out.length === "number" || $util.isString(message.pseudo_out)))
                return "pseudo_out: buffer expected";
        if (message.pseudo_out_hmac != null && message.hasOwnProperty("pseudo_out_hmac"))
            if (!(message.pseudo_out_hmac && typeof message.pseudo_out_hmac.length === "number" || $util.isString(message.pseudo_out_hmac)))
                return "pseudo_out_hmac: buffer expected";
        if (message.pseudo_out_alpha != null && message.hasOwnProperty("pseudo_out_alpha"))
            if (!(message.pseudo_out_alpha && typeof message.pseudo_out_alpha.length === "number" || $util.isString(message.pseudo_out_alpha)))
                return "pseudo_out_alpha: buffer expected";
        if (message.spend_key != null && message.hasOwnProperty("spend_key"))
            if (!(message.spend_key && typeof message.spend_key.length === "number" || $util.isString(message.spend_key)))
                return "spend_key: buffer expected";
        if (message.orig_idx != null && message.hasOwnProperty("orig_idx"))
            if (!$util.isInteger(message.orig_idx))
                return "orig_idx: integer expected";
        return null;
    };

    MoneroTransactionSignInputRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroTransactionSignInputRequest)
            return object;
        var message = new $root.MoneroTransactionSignInputRequest();
        if (object.src_entr != null) {
            if (typeof object.src_entr !== "object")
                throw TypeError(".MoneroTransactionSignInputRequest.src_entr: object expected");
            message.src_entr = $root.MoneroTransactionSourceEntry.fromObject(object.src_entr);
        }
        if (object.vini != null)
            if (typeof object.vini === "string")
                $util.base64.decode(object.vini, message.vini = $util.newBuffer($util.base64.length(object.vini)), 0);
            else if (object.vini.length)
                message.vini = object.vini;
        if (object.vini_hmac != null)
            if (typeof object.vini_hmac === "string")
                $util.base64.decode(object.vini_hmac, message.vini_hmac = $util.newBuffer($util.base64.length(object.vini_hmac)), 0);
            else if (object.vini_hmac.length)
                message.vini_hmac = object.vini_hmac;
        if (object.pseudo_out != null)
            if (typeof object.pseudo_out === "string")
                $util.base64.decode(object.pseudo_out, message.pseudo_out = $util.newBuffer($util.base64.length(object.pseudo_out)), 0);
            else if (object.pseudo_out.length)
                message.pseudo_out = object.pseudo_out;
        if (object.pseudo_out_hmac != null)
            if (typeof object.pseudo_out_hmac === "string")
                $util.base64.decode(object.pseudo_out_hmac, message.pseudo_out_hmac = $util.newBuffer($util.base64.length(object.pseudo_out_hmac)), 0);
            else if (object.pseudo_out_hmac.length)
                message.pseudo_out_hmac = object.pseudo_out_hmac;
        if (object.pseudo_out_alpha != null)
            if (typeof object.pseudo_out_alpha === "string")
                $util.base64.decode(object.pseudo_out_alpha, message.pseudo_out_alpha = $util.newBuffer($util.base64.length(object.pseudo_out_alpha)), 0);
            else if (object.pseudo_out_alpha.length)
                message.pseudo_out_alpha = object.pseudo_out_alpha;
        if (object.spend_key != null)
            if (typeof object.spend_key === "string")
                $util.base64.decode(object.spend_key, message.spend_key = $util.newBuffer($util.base64.length(object.spend_key)), 0);
            else if (object.spend_key.length)
                message.spend_key = object.spend_key;
        if (object.orig_idx != null)
            message.orig_idx = object.orig_idx >>> 0;
        return message;
    };

    MoneroTransactionSignInputRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.src_entr = null;
            if (options.bytes === String)
                object.vini = "";
            else {
                object.vini = [];
                if (options.bytes !== Array)
                    object.vini = $util.newBuffer(object.vini);
            }
            if (options.bytes === String)
                object.vini_hmac = "";
            else {
                object.vini_hmac = [];
                if (options.bytes !== Array)
                    object.vini_hmac = $util.newBuffer(object.vini_hmac);
            }
            if (options.bytes === String)
                object.pseudo_out = "";
            else {
                object.pseudo_out = [];
                if (options.bytes !== Array)
                    object.pseudo_out = $util.newBuffer(object.pseudo_out);
            }
            if (options.bytes === String)
                object.pseudo_out_hmac = "";
            else {
                object.pseudo_out_hmac = [];
                if (options.bytes !== Array)
                    object.pseudo_out_hmac = $util.newBuffer(object.pseudo_out_hmac);
            }
            if (options.bytes === String)
                object.pseudo_out_alpha = "";
            else {
                object.pseudo_out_alpha = [];
                if (options.bytes !== Array)
                    object.pseudo_out_alpha = $util.newBuffer(object.pseudo_out_alpha);
            }
            if (options.bytes === String)
                object.spend_key = "";
            else {
                object.spend_key = [];
                if (options.bytes !== Array)
                    object.spend_key = $util.newBuffer(object.spend_key);
            }
            object.orig_idx = 0;
        }
        if (message.src_entr != null && message.hasOwnProperty("src_entr"))
            object.src_entr = $root.MoneroTransactionSourceEntry.toObject(message.src_entr, options);
        if (message.vini != null && message.hasOwnProperty("vini"))
            object.vini = options.bytes === String ? $util.base64.encode(message.vini, 0, message.vini.length) : options.bytes === Array ? Array.prototype.slice.call(message.vini) : message.vini;
        if (message.vini_hmac != null && message.hasOwnProperty("vini_hmac"))
            object.vini_hmac = options.bytes === String ? $util.base64.encode(message.vini_hmac, 0, message.vini_hmac.length) : options.bytes === Array ? Array.prototype.slice.call(message.vini_hmac) : message.vini_hmac;
        if (message.pseudo_out != null && message.hasOwnProperty("pseudo_out"))
            object.pseudo_out = options.bytes === String ? $util.base64.encode(message.pseudo_out, 0, message.pseudo_out.length) : options.bytes === Array ? Array.prototype.slice.call(message.pseudo_out) : message.pseudo_out;
        if (message.pseudo_out_hmac != null && message.hasOwnProperty("pseudo_out_hmac"))
            object.pseudo_out_hmac = options.bytes === String ? $util.base64.encode(message.pseudo_out_hmac, 0, message.pseudo_out_hmac.length) : options.bytes === Array ? Array.prototype.slice.call(message.pseudo_out_hmac) : message.pseudo_out_hmac;
        if (message.pseudo_out_alpha != null && message.hasOwnProperty("pseudo_out_alpha"))
            object.pseudo_out_alpha = options.bytes === String ? $util.base64.encode(message.pseudo_out_alpha, 0, message.pseudo_out_alpha.length) : options.bytes === Array ? Array.prototype.slice.call(message.pseudo_out_alpha) : message.pseudo_out_alpha;
        if (message.spend_key != null && message.hasOwnProperty("spend_key"))
            object.spend_key = options.bytes === String ? $util.base64.encode(message.spend_key, 0, message.spend_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.spend_key) : message.spend_key;
        if (message.orig_idx != null && message.hasOwnProperty("orig_idx"))
            object.orig_idx = message.orig_idx;
        return object;
    };

    MoneroTransactionSignInputRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoneroTransactionSignInputRequest;
})();

$root.MoneroTransactionSignInputAck = (function() {

    function MoneroTransactionSignInputAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroTransactionSignInputAck.prototype.signature = $util.newBuffer([]);
    MoneroTransactionSignInputAck.prototype.pseudo_out = $util.newBuffer([]);

    MoneroTransactionSignInputAck.create = function create(properties) {
        return new MoneroTransactionSignInputAck(properties);
    };

    MoneroTransactionSignInputAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.signature != null && Object.hasOwnProperty.call(message, "signature"))
            writer.uint32(10).bytes(message.signature);
        if (message.pseudo_out != null && Object.hasOwnProperty.call(message, "pseudo_out"))
            writer.uint32(18).bytes(message.pseudo_out);
        return writer;
    };

    MoneroTransactionSignInputAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroTransactionSignInputAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroTransactionSignInputAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.signature = reader.bytes();
                break;
            case 2:
                message.pseudo_out = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroTransactionSignInputAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroTransactionSignInputAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.signature != null && message.hasOwnProperty("signature"))
            if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
                return "signature: buffer expected";
        if (message.pseudo_out != null && message.hasOwnProperty("pseudo_out"))
            if (!(message.pseudo_out && typeof message.pseudo_out.length === "number" || $util.isString(message.pseudo_out)))
                return "pseudo_out: buffer expected";
        return null;
    };

    MoneroTransactionSignInputAck.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroTransactionSignInputAck)
            return object;
        var message = new $root.MoneroTransactionSignInputAck();
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        if (object.pseudo_out != null)
            if (typeof object.pseudo_out === "string")
                $util.base64.decode(object.pseudo_out, message.pseudo_out = $util.newBuffer($util.base64.length(object.pseudo_out)), 0);
            else if (object.pseudo_out.length)
                message.pseudo_out = object.pseudo_out;
        return message;
    };

    MoneroTransactionSignInputAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
            if (options.bytes === String)
                object.pseudo_out = "";
            else {
                object.pseudo_out = [];
                if (options.bytes !== Array)
                    object.pseudo_out = $util.newBuffer(object.pseudo_out);
            }
        }
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        if (message.pseudo_out != null && message.hasOwnProperty("pseudo_out"))
            object.pseudo_out = options.bytes === String ? $util.base64.encode(message.pseudo_out, 0, message.pseudo_out.length) : options.bytes === Array ? Array.prototype.slice.call(message.pseudo_out) : message.pseudo_out;
        return object;
    };

    MoneroTransactionSignInputAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoneroTransactionSignInputAck;
})();

$root.MoneroTransactionFinalRequest = (function() {

    function MoneroTransactionFinalRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroTransactionFinalRequest.create = function create(properties) {
        return new MoneroTransactionFinalRequest(properties);
    };

    MoneroTransactionFinalRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    MoneroTransactionFinalRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroTransactionFinalRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroTransactionFinalRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroTransactionFinalRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroTransactionFinalRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    MoneroTransactionFinalRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroTransactionFinalRequest)
            return object;
        return new $root.MoneroTransactionFinalRequest();
    };

    MoneroTransactionFinalRequest.toObject = function toObject() {
        return {};
    };

    MoneroTransactionFinalRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoneroTransactionFinalRequest;
})();

$root.MoneroTransactionFinalAck = (function() {

    function MoneroTransactionFinalAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroTransactionFinalAck.prototype.cout_key = $util.newBuffer([]);
    MoneroTransactionFinalAck.prototype.salt = $util.newBuffer([]);
    MoneroTransactionFinalAck.prototype.rand_mult = $util.newBuffer([]);
    MoneroTransactionFinalAck.prototype.tx_enc_keys = $util.newBuffer([]);
    MoneroTransactionFinalAck.prototype.opening_key = $util.newBuffer([]);

    MoneroTransactionFinalAck.create = function create(properties) {
        return new MoneroTransactionFinalAck(properties);
    };

    MoneroTransactionFinalAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.cout_key != null && Object.hasOwnProperty.call(message, "cout_key"))
            writer.uint32(10).bytes(message.cout_key);
        if (message.salt != null && Object.hasOwnProperty.call(message, "salt"))
            writer.uint32(18).bytes(message.salt);
        if (message.rand_mult != null && Object.hasOwnProperty.call(message, "rand_mult"))
            writer.uint32(26).bytes(message.rand_mult);
        if (message.tx_enc_keys != null && Object.hasOwnProperty.call(message, "tx_enc_keys"))
            writer.uint32(34).bytes(message.tx_enc_keys);
        if (message.opening_key != null && Object.hasOwnProperty.call(message, "opening_key"))
            writer.uint32(42).bytes(message.opening_key);
        return writer;
    };

    MoneroTransactionFinalAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroTransactionFinalAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroTransactionFinalAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.cout_key = reader.bytes();
                break;
            case 2:
                message.salt = reader.bytes();
                break;
            case 3:
                message.rand_mult = reader.bytes();
                break;
            case 4:
                message.tx_enc_keys = reader.bytes();
                break;
            case 5:
                message.opening_key = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroTransactionFinalAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroTransactionFinalAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.cout_key != null && message.hasOwnProperty("cout_key"))
            if (!(message.cout_key && typeof message.cout_key.length === "number" || $util.isString(message.cout_key)))
                return "cout_key: buffer expected";
        if (message.salt != null && message.hasOwnProperty("salt"))
            if (!(message.salt && typeof message.salt.length === "number" || $util.isString(message.salt)))
                return "salt: buffer expected";
        if (message.rand_mult != null && message.hasOwnProperty("rand_mult"))
            if (!(message.rand_mult && typeof message.rand_mult.length === "number" || $util.isString(message.rand_mult)))
                return "rand_mult: buffer expected";
        if (message.tx_enc_keys != null && message.hasOwnProperty("tx_enc_keys"))
            if (!(message.tx_enc_keys && typeof message.tx_enc_keys.length === "number" || $util.isString(message.tx_enc_keys)))
                return "tx_enc_keys: buffer expected";
        if (message.opening_key != null && message.hasOwnProperty("opening_key"))
            if (!(message.opening_key && typeof message.opening_key.length === "number" || $util.isString(message.opening_key)))
                return "opening_key: buffer expected";
        return null;
    };

    MoneroTransactionFinalAck.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroTransactionFinalAck)
            return object;
        var message = new $root.MoneroTransactionFinalAck();
        if (object.cout_key != null)
            if (typeof object.cout_key === "string")
                $util.base64.decode(object.cout_key, message.cout_key = $util.newBuffer($util.base64.length(object.cout_key)), 0);
            else if (object.cout_key.length)
                message.cout_key = object.cout_key;
        if (object.salt != null)
            if (typeof object.salt === "string")
                $util.base64.decode(object.salt, message.salt = $util.newBuffer($util.base64.length(object.salt)), 0);
            else if (object.salt.length)
                message.salt = object.salt;
        if (object.rand_mult != null)
            if (typeof object.rand_mult === "string")
                $util.base64.decode(object.rand_mult, message.rand_mult = $util.newBuffer($util.base64.length(object.rand_mult)), 0);
            else if (object.rand_mult.length)
                message.rand_mult = object.rand_mult;
        if (object.tx_enc_keys != null)
            if (typeof object.tx_enc_keys === "string")
                $util.base64.decode(object.tx_enc_keys, message.tx_enc_keys = $util.newBuffer($util.base64.length(object.tx_enc_keys)), 0);
            else if (object.tx_enc_keys.length)
                message.tx_enc_keys = object.tx_enc_keys;
        if (object.opening_key != null)
            if (typeof object.opening_key === "string")
                $util.base64.decode(object.opening_key, message.opening_key = $util.newBuffer($util.base64.length(object.opening_key)), 0);
            else if (object.opening_key.length)
                message.opening_key = object.opening_key;
        return message;
    };

    MoneroTransactionFinalAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.cout_key = "";
            else {
                object.cout_key = [];
                if (options.bytes !== Array)
                    object.cout_key = $util.newBuffer(object.cout_key);
            }
            if (options.bytes === String)
                object.salt = "";
            else {
                object.salt = [];
                if (options.bytes !== Array)
                    object.salt = $util.newBuffer(object.salt);
            }
            if (options.bytes === String)
                object.rand_mult = "";
            else {
                object.rand_mult = [];
                if (options.bytes !== Array)
                    object.rand_mult = $util.newBuffer(object.rand_mult);
            }
            if (options.bytes === String)
                object.tx_enc_keys = "";
            else {
                object.tx_enc_keys = [];
                if (options.bytes !== Array)
                    object.tx_enc_keys = $util.newBuffer(object.tx_enc_keys);
            }
            if (options.bytes === String)
                object.opening_key = "";
            else {
                object.opening_key = [];
                if (options.bytes !== Array)
                    object.opening_key = $util.newBuffer(object.opening_key);
            }
        }
        if (message.cout_key != null && message.hasOwnProperty("cout_key"))
            object.cout_key = options.bytes === String ? $util.base64.encode(message.cout_key, 0, message.cout_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.cout_key) : message.cout_key;
        if (message.salt != null && message.hasOwnProperty("salt"))
            object.salt = options.bytes === String ? $util.base64.encode(message.salt, 0, message.salt.length) : options.bytes === Array ? Array.prototype.slice.call(message.salt) : message.salt;
        if (message.rand_mult != null && message.hasOwnProperty("rand_mult"))
            object.rand_mult = options.bytes === String ? $util.base64.encode(message.rand_mult, 0, message.rand_mult.length) : options.bytes === Array ? Array.prototype.slice.call(message.rand_mult) : message.rand_mult;
        if (message.tx_enc_keys != null && message.hasOwnProperty("tx_enc_keys"))
            object.tx_enc_keys = options.bytes === String ? $util.base64.encode(message.tx_enc_keys, 0, message.tx_enc_keys.length) : options.bytes === Array ? Array.prototype.slice.call(message.tx_enc_keys) : message.tx_enc_keys;
        if (message.opening_key != null && message.hasOwnProperty("opening_key"))
            object.opening_key = options.bytes === String ? $util.base64.encode(message.opening_key, 0, message.opening_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.opening_key) : message.opening_key;
        return object;
    };

    MoneroTransactionFinalAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoneroTransactionFinalAck;
})();

$root.MoneroKeyImageExportInitRequest = (function() {

    function MoneroKeyImageExportInitRequest(properties) {
        this.address_n = [];
        this.subs = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroKeyImageExportInitRequest.prototype.num = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    MoneroKeyImageExportInitRequest.prototype.hash = $util.newBuffer([]);
    MoneroKeyImageExportInitRequest.prototype.address_n = $util.emptyArray;
    MoneroKeyImageExportInitRequest.prototype.network_type = 0;
    MoneroKeyImageExportInitRequest.prototype.subs = $util.emptyArray;

    MoneroKeyImageExportInitRequest.create = function create(properties) {
        return new MoneroKeyImageExportInitRequest(properties);
    };

    MoneroKeyImageExportInitRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.num != null && Object.hasOwnProperty.call(message, "num"))
            writer.uint32(8).uint64(message.num);
        if (message.hash != null && Object.hasOwnProperty.call(message, "hash"))
            writer.uint32(18).bytes(message.hash);
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(24).uint32(message.address_n[i]);
        if (message.network_type != null && Object.hasOwnProperty.call(message, "network_type"))
            writer.uint32(32).uint32(message.network_type);
        if (message.subs != null && message.subs.length)
            for (var i = 0; i < message.subs.length; ++i)
                $root.MoneroKeyImageExportInitRequest.MoneroSubAddressIndicesList.encode(message.subs[i], writer.uint32(42).fork()).ldelim();
        return writer;
    };

    MoneroKeyImageExportInitRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroKeyImageExportInitRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroKeyImageExportInitRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.num = reader.uint64();
                break;
            case 2:
                message.hash = reader.bytes();
                break;
            case 3:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 4:
                message.network_type = reader.uint32();
                break;
            case 5:
                if (!(message.subs && message.subs.length))
                    message.subs = [];
                message.subs.push($root.MoneroKeyImageExportInitRequest.MoneroSubAddressIndicesList.decode(reader, reader.uint32()));
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroKeyImageExportInitRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroKeyImageExportInitRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.num != null && message.hasOwnProperty("num"))
            if (!$util.isInteger(message.num) && !(message.num && $util.isInteger(message.num.low) && $util.isInteger(message.num.high)))
                return "num: integer|Long expected";
        if (message.hash != null && message.hasOwnProperty("hash"))
            if (!(message.hash && typeof message.hash.length === "number" || $util.isString(message.hash)))
                return "hash: buffer expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.network_type != null && message.hasOwnProperty("network_type"))
            if (!$util.isInteger(message.network_type))
                return "network_type: integer expected";
        if (message.subs != null && message.hasOwnProperty("subs")) {
            if (!Array.isArray(message.subs))
                return "subs: array expected";
            for (var i = 0; i < message.subs.length; ++i) {
                var error = $root.MoneroKeyImageExportInitRequest.MoneroSubAddressIndicesList.verify(message.subs[i]);
                if (error)
                    return "subs." + error;
            }
        }
        return null;
    };

    MoneroKeyImageExportInitRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroKeyImageExportInitRequest)
            return object;
        var message = new $root.MoneroKeyImageExportInitRequest();
        if (object.num != null)
            if ($util.Long)
                (message.num = $util.Long.fromValue(object.num)).unsigned = true;
            else if (typeof object.num === "string")
                message.num = parseInt(object.num, 10);
            else if (typeof object.num === "number")
                message.num = object.num;
            else if (typeof object.num === "object")
                message.num = new $util.LongBits(object.num.low >>> 0, object.num.high >>> 0).toNumber(true);
        if (object.hash != null)
            if (typeof object.hash === "string")
                $util.base64.decode(object.hash, message.hash = $util.newBuffer($util.base64.length(object.hash)), 0);
            else if (object.hash.length)
                message.hash = object.hash;
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".MoneroKeyImageExportInitRequest.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.network_type != null)
            message.network_type = object.network_type >>> 0;
        if (object.subs) {
            if (!Array.isArray(object.subs))
                throw TypeError(".MoneroKeyImageExportInitRequest.subs: array expected");
            message.subs = [];
            for (var i = 0; i < object.subs.length; ++i) {
                if (typeof object.subs[i] !== "object")
                    throw TypeError(".MoneroKeyImageExportInitRequest.subs: object expected");
                message.subs[i] = $root.MoneroKeyImageExportInitRequest.MoneroSubAddressIndicesList.fromObject(object.subs[i]);
            }
        }
        return message;
    };

    MoneroKeyImageExportInitRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults) {
            object.address_n = [];
            object.subs = [];
        }
        if (options.defaults) {
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.num = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.num = options.longs === String ? "0" : 0;
            if (options.bytes === String)
                object.hash = "";
            else {
                object.hash = [];
                if (options.bytes !== Array)
                    object.hash = $util.newBuffer(object.hash);
            }
            object.network_type = 0;
        }
        if (message.num != null && message.hasOwnProperty("num"))
            if (typeof message.num === "number")
                object.num = options.longs === String ? String(message.num) : message.num;
            else
                object.num = options.longs === String ? $util.Long.prototype.toString.call(message.num) : options.longs === Number ? new $util.LongBits(message.num.low >>> 0, message.num.high >>> 0).toNumber(true) : message.num;
        if (message.hash != null && message.hasOwnProperty("hash"))
            object.hash = options.bytes === String ? $util.base64.encode(message.hash, 0, message.hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.hash) : message.hash;
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.network_type != null && message.hasOwnProperty("network_type"))
            object.network_type = message.network_type;
        if (message.subs && message.subs.length) {
            object.subs = [];
            for (var j = 0; j < message.subs.length; ++j)
                object.subs[j] = $root.MoneroKeyImageExportInitRequest.MoneroSubAddressIndicesList.toObject(message.subs[j], options);
        }
        return object;
    };

    MoneroKeyImageExportInitRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    MoneroKeyImageExportInitRequest.MoneroSubAddressIndicesList = (function() {

        function MoneroSubAddressIndicesList(properties) {
            this.minor_indices = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        MoneroSubAddressIndicesList.prototype.account = 0;
        MoneroSubAddressIndicesList.prototype.minor_indices = $util.emptyArray;

        MoneroSubAddressIndicesList.create = function create(properties) {
            return new MoneroSubAddressIndicesList(properties);
        };

        MoneroSubAddressIndicesList.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.account != null && Object.hasOwnProperty.call(message, "account"))
                writer.uint32(8).uint32(message.account);
            if (message.minor_indices != null && message.minor_indices.length)
                for (var i = 0; i < message.minor_indices.length; ++i)
                    writer.uint32(16).uint32(message.minor_indices[i]);
            return writer;
        };

        MoneroSubAddressIndicesList.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        MoneroSubAddressIndicesList.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroKeyImageExportInitRequest.MoneroSubAddressIndicesList();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.account = reader.uint32();
                    break;
                case 2:
                    if (!(message.minor_indices && message.minor_indices.length))
                        message.minor_indices = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.minor_indices.push(reader.uint32());
                    } else
                        message.minor_indices.push(reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        MoneroSubAddressIndicesList.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        MoneroSubAddressIndicesList.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.account != null && message.hasOwnProperty("account"))
                if (!$util.isInteger(message.account))
                    return "account: integer expected";
            if (message.minor_indices != null && message.hasOwnProperty("minor_indices")) {
                if (!Array.isArray(message.minor_indices))
                    return "minor_indices: array expected";
                for (var i = 0; i < message.minor_indices.length; ++i)
                    if (!$util.isInteger(message.minor_indices[i]))
                        return "minor_indices: integer[] expected";
            }
            return null;
        };

        MoneroSubAddressIndicesList.fromObject = function fromObject(object) {
            if (object instanceof $root.MoneroKeyImageExportInitRequest.MoneroSubAddressIndicesList)
                return object;
            var message = new $root.MoneroKeyImageExportInitRequest.MoneroSubAddressIndicesList();
            if (object.account != null)
                message.account = object.account >>> 0;
            if (object.minor_indices) {
                if (!Array.isArray(object.minor_indices))
                    throw TypeError(".MoneroKeyImageExportInitRequest.MoneroSubAddressIndicesList.minor_indices: array expected");
                message.minor_indices = [];
                for (var i = 0; i < object.minor_indices.length; ++i)
                    message.minor_indices[i] = object.minor_indices[i] >>> 0;
            }
            return message;
        };

        MoneroSubAddressIndicesList.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.minor_indices = [];
            if (options.defaults)
                object.account = 0;
            if (message.account != null && message.hasOwnProperty("account"))
                object.account = message.account;
            if (message.minor_indices && message.minor_indices.length) {
                object.minor_indices = [];
                for (var j = 0; j < message.minor_indices.length; ++j)
                    object.minor_indices[j] = message.minor_indices[j];
            }
            return object;
        };

        MoneroSubAddressIndicesList.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return MoneroSubAddressIndicesList;
    })();

    return MoneroKeyImageExportInitRequest;
})();

$root.MoneroKeyImageExportInitAck = (function() {

    function MoneroKeyImageExportInitAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroKeyImageExportInitAck.create = function create(properties) {
        return new MoneroKeyImageExportInitAck(properties);
    };

    MoneroKeyImageExportInitAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    MoneroKeyImageExportInitAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroKeyImageExportInitAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroKeyImageExportInitAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroKeyImageExportInitAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroKeyImageExportInitAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    MoneroKeyImageExportInitAck.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroKeyImageExportInitAck)
            return object;
        return new $root.MoneroKeyImageExportInitAck();
    };

    MoneroKeyImageExportInitAck.toObject = function toObject() {
        return {};
    };

    MoneroKeyImageExportInitAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoneroKeyImageExportInitAck;
})();

$root.MoneroKeyImageSyncStepRequest = (function() {

    function MoneroKeyImageSyncStepRequest(properties) {
        this.tdis = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroKeyImageSyncStepRequest.prototype.tdis = $util.emptyArray;

    MoneroKeyImageSyncStepRequest.create = function create(properties) {
        return new MoneroKeyImageSyncStepRequest(properties);
    };

    MoneroKeyImageSyncStepRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.tdis != null && message.tdis.length)
            for (var i = 0; i < message.tdis.length; ++i)
                $root.MoneroKeyImageSyncStepRequest.MoneroTransferDetails.encode(message.tdis[i], writer.uint32(10).fork()).ldelim();
        return writer;
    };

    MoneroKeyImageSyncStepRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroKeyImageSyncStepRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroKeyImageSyncStepRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.tdis && message.tdis.length))
                    message.tdis = [];
                message.tdis.push($root.MoneroKeyImageSyncStepRequest.MoneroTransferDetails.decode(reader, reader.uint32()));
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroKeyImageSyncStepRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroKeyImageSyncStepRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.tdis != null && message.hasOwnProperty("tdis")) {
            if (!Array.isArray(message.tdis))
                return "tdis: array expected";
            for (var i = 0; i < message.tdis.length; ++i) {
                var error = $root.MoneroKeyImageSyncStepRequest.MoneroTransferDetails.verify(message.tdis[i]);
                if (error)
                    return "tdis." + error;
            }
        }
        return null;
    };

    MoneroKeyImageSyncStepRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroKeyImageSyncStepRequest)
            return object;
        var message = new $root.MoneroKeyImageSyncStepRequest();
        if (object.tdis) {
            if (!Array.isArray(object.tdis))
                throw TypeError(".MoneroKeyImageSyncStepRequest.tdis: array expected");
            message.tdis = [];
            for (var i = 0; i < object.tdis.length; ++i) {
                if (typeof object.tdis[i] !== "object")
                    throw TypeError(".MoneroKeyImageSyncStepRequest.tdis: object expected");
                message.tdis[i] = $root.MoneroKeyImageSyncStepRequest.MoneroTransferDetails.fromObject(object.tdis[i]);
            }
        }
        return message;
    };

    MoneroKeyImageSyncStepRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.tdis = [];
        if (message.tdis && message.tdis.length) {
            object.tdis = [];
            for (var j = 0; j < message.tdis.length; ++j)
                object.tdis[j] = $root.MoneroKeyImageSyncStepRequest.MoneroTransferDetails.toObject(message.tdis[j], options);
        }
        return object;
    };

    MoneroKeyImageSyncStepRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    MoneroKeyImageSyncStepRequest.MoneroTransferDetails = (function() {

        function MoneroTransferDetails(properties) {
            this.additional_tx_pub_keys = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        MoneroTransferDetails.prototype.out_key = $util.newBuffer([]);
        MoneroTransferDetails.prototype.tx_pub_key = $util.newBuffer([]);
        MoneroTransferDetails.prototype.additional_tx_pub_keys = $util.emptyArray;
        MoneroTransferDetails.prototype.internal_output_index = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        MoneroTransferDetails.prototype.sub_addr_major = 0;
        MoneroTransferDetails.prototype.sub_addr_minor = 0;

        MoneroTransferDetails.create = function create(properties) {
            return new MoneroTransferDetails(properties);
        };

        MoneroTransferDetails.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.out_key != null && Object.hasOwnProperty.call(message, "out_key"))
                writer.uint32(10).bytes(message.out_key);
            if (message.tx_pub_key != null && Object.hasOwnProperty.call(message, "tx_pub_key"))
                writer.uint32(18).bytes(message.tx_pub_key);
            if (message.additional_tx_pub_keys != null && message.additional_tx_pub_keys.length)
                for (var i = 0; i < message.additional_tx_pub_keys.length; ++i)
                    writer.uint32(26).bytes(message.additional_tx_pub_keys[i]);
            if (message.internal_output_index != null && Object.hasOwnProperty.call(message, "internal_output_index"))
                writer.uint32(32).uint64(message.internal_output_index);
            if (message.sub_addr_major != null && Object.hasOwnProperty.call(message, "sub_addr_major"))
                writer.uint32(40).uint32(message.sub_addr_major);
            if (message.sub_addr_minor != null && Object.hasOwnProperty.call(message, "sub_addr_minor"))
                writer.uint32(48).uint32(message.sub_addr_minor);
            return writer;
        };

        MoneroTransferDetails.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        MoneroTransferDetails.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroKeyImageSyncStepRequest.MoneroTransferDetails();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.out_key = reader.bytes();
                    break;
                case 2:
                    message.tx_pub_key = reader.bytes();
                    break;
                case 3:
                    if (!(message.additional_tx_pub_keys && message.additional_tx_pub_keys.length))
                        message.additional_tx_pub_keys = [];
                    message.additional_tx_pub_keys.push(reader.bytes());
                    break;
                case 4:
                    message.internal_output_index = reader.uint64();
                    break;
                case 5:
                    message.sub_addr_major = reader.uint32();
                    break;
                case 6:
                    message.sub_addr_minor = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        MoneroTransferDetails.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        MoneroTransferDetails.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.out_key != null && message.hasOwnProperty("out_key"))
                if (!(message.out_key && typeof message.out_key.length === "number" || $util.isString(message.out_key)))
                    return "out_key: buffer expected";
            if (message.tx_pub_key != null && message.hasOwnProperty("tx_pub_key"))
                if (!(message.tx_pub_key && typeof message.tx_pub_key.length === "number" || $util.isString(message.tx_pub_key)))
                    return "tx_pub_key: buffer expected";
            if (message.additional_tx_pub_keys != null && message.hasOwnProperty("additional_tx_pub_keys")) {
                if (!Array.isArray(message.additional_tx_pub_keys))
                    return "additional_tx_pub_keys: array expected";
                for (var i = 0; i < message.additional_tx_pub_keys.length; ++i)
                    if (!(message.additional_tx_pub_keys[i] && typeof message.additional_tx_pub_keys[i].length === "number" || $util.isString(message.additional_tx_pub_keys[i])))
                        return "additional_tx_pub_keys: buffer[] expected";
            }
            if (message.internal_output_index != null && message.hasOwnProperty("internal_output_index"))
                if (!$util.isInteger(message.internal_output_index) && !(message.internal_output_index && $util.isInteger(message.internal_output_index.low) && $util.isInteger(message.internal_output_index.high)))
                    return "internal_output_index: integer|Long expected";
            if (message.sub_addr_major != null && message.hasOwnProperty("sub_addr_major"))
                if (!$util.isInteger(message.sub_addr_major))
                    return "sub_addr_major: integer expected";
            if (message.sub_addr_minor != null && message.hasOwnProperty("sub_addr_minor"))
                if (!$util.isInteger(message.sub_addr_minor))
                    return "sub_addr_minor: integer expected";
            return null;
        };

        MoneroTransferDetails.fromObject = function fromObject(object) {
            if (object instanceof $root.MoneroKeyImageSyncStepRequest.MoneroTransferDetails)
                return object;
            var message = new $root.MoneroKeyImageSyncStepRequest.MoneroTransferDetails();
            if (object.out_key != null)
                if (typeof object.out_key === "string")
                    $util.base64.decode(object.out_key, message.out_key = $util.newBuffer($util.base64.length(object.out_key)), 0);
                else if (object.out_key.length)
                    message.out_key = object.out_key;
            if (object.tx_pub_key != null)
                if (typeof object.tx_pub_key === "string")
                    $util.base64.decode(object.tx_pub_key, message.tx_pub_key = $util.newBuffer($util.base64.length(object.tx_pub_key)), 0);
                else if (object.tx_pub_key.length)
                    message.tx_pub_key = object.tx_pub_key;
            if (object.additional_tx_pub_keys) {
                if (!Array.isArray(object.additional_tx_pub_keys))
                    throw TypeError(".MoneroKeyImageSyncStepRequest.MoneroTransferDetails.additional_tx_pub_keys: array expected");
                message.additional_tx_pub_keys = [];
                for (var i = 0; i < object.additional_tx_pub_keys.length; ++i)
                    if (typeof object.additional_tx_pub_keys[i] === "string")
                        $util.base64.decode(object.additional_tx_pub_keys[i], message.additional_tx_pub_keys[i] = $util.newBuffer($util.base64.length(object.additional_tx_pub_keys[i])), 0);
                    else if (object.additional_tx_pub_keys[i].length)
                        message.additional_tx_pub_keys[i] = object.additional_tx_pub_keys[i];
            }
            if (object.internal_output_index != null)
                if ($util.Long)
                    (message.internal_output_index = $util.Long.fromValue(object.internal_output_index)).unsigned = true;
                else if (typeof object.internal_output_index === "string")
                    message.internal_output_index = parseInt(object.internal_output_index, 10);
                else if (typeof object.internal_output_index === "number")
                    message.internal_output_index = object.internal_output_index;
                else if (typeof object.internal_output_index === "object")
                    message.internal_output_index = new $util.LongBits(object.internal_output_index.low >>> 0, object.internal_output_index.high >>> 0).toNumber(true);
            if (object.sub_addr_major != null)
                message.sub_addr_major = object.sub_addr_major >>> 0;
            if (object.sub_addr_minor != null)
                message.sub_addr_minor = object.sub_addr_minor >>> 0;
            return message;
        };

        MoneroTransferDetails.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.additional_tx_pub_keys = [];
            if (options.defaults) {
                if (options.bytes === String)
                    object.out_key = "";
                else {
                    object.out_key = [];
                    if (options.bytes !== Array)
                        object.out_key = $util.newBuffer(object.out_key);
                }
                if (options.bytes === String)
                    object.tx_pub_key = "";
                else {
                    object.tx_pub_key = [];
                    if (options.bytes !== Array)
                        object.tx_pub_key = $util.newBuffer(object.tx_pub_key);
                }
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.internal_output_index = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.internal_output_index = options.longs === String ? "0" : 0;
                object.sub_addr_major = 0;
                object.sub_addr_minor = 0;
            }
            if (message.out_key != null && message.hasOwnProperty("out_key"))
                object.out_key = options.bytes === String ? $util.base64.encode(message.out_key, 0, message.out_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.out_key) : message.out_key;
            if (message.tx_pub_key != null && message.hasOwnProperty("tx_pub_key"))
                object.tx_pub_key = options.bytes === String ? $util.base64.encode(message.tx_pub_key, 0, message.tx_pub_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.tx_pub_key) : message.tx_pub_key;
            if (message.additional_tx_pub_keys && message.additional_tx_pub_keys.length) {
                object.additional_tx_pub_keys = [];
                for (var j = 0; j < message.additional_tx_pub_keys.length; ++j)
                    object.additional_tx_pub_keys[j] = options.bytes === String ? $util.base64.encode(message.additional_tx_pub_keys[j], 0, message.additional_tx_pub_keys[j].length) : options.bytes === Array ? Array.prototype.slice.call(message.additional_tx_pub_keys[j]) : message.additional_tx_pub_keys[j];
            }
            if (message.internal_output_index != null && message.hasOwnProperty("internal_output_index"))
                if (typeof message.internal_output_index === "number")
                    object.internal_output_index = options.longs === String ? String(message.internal_output_index) : message.internal_output_index;
                else
                    object.internal_output_index = options.longs === String ? $util.Long.prototype.toString.call(message.internal_output_index) : options.longs === Number ? new $util.LongBits(message.internal_output_index.low >>> 0, message.internal_output_index.high >>> 0).toNumber(true) : message.internal_output_index;
            if (message.sub_addr_major != null && message.hasOwnProperty("sub_addr_major"))
                object.sub_addr_major = message.sub_addr_major;
            if (message.sub_addr_minor != null && message.hasOwnProperty("sub_addr_minor"))
                object.sub_addr_minor = message.sub_addr_minor;
            return object;
        };

        MoneroTransferDetails.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return MoneroTransferDetails;
    })();

    return MoneroKeyImageSyncStepRequest;
})();

$root.MoneroKeyImageSyncStepAck = (function() {

    function MoneroKeyImageSyncStepAck(properties) {
        this.kis = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroKeyImageSyncStepAck.prototype.kis = $util.emptyArray;

    MoneroKeyImageSyncStepAck.create = function create(properties) {
        return new MoneroKeyImageSyncStepAck(properties);
    };

    MoneroKeyImageSyncStepAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.kis != null && message.kis.length)
            for (var i = 0; i < message.kis.length; ++i)
                $root.MoneroKeyImageSyncStepAck.MoneroExportedKeyImage.encode(message.kis[i], writer.uint32(10).fork()).ldelim();
        return writer;
    };

    MoneroKeyImageSyncStepAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroKeyImageSyncStepAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroKeyImageSyncStepAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.kis && message.kis.length))
                    message.kis = [];
                message.kis.push($root.MoneroKeyImageSyncStepAck.MoneroExportedKeyImage.decode(reader, reader.uint32()));
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroKeyImageSyncStepAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroKeyImageSyncStepAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.kis != null && message.hasOwnProperty("kis")) {
            if (!Array.isArray(message.kis))
                return "kis: array expected";
            for (var i = 0; i < message.kis.length; ++i) {
                var error = $root.MoneroKeyImageSyncStepAck.MoneroExportedKeyImage.verify(message.kis[i]);
                if (error)
                    return "kis." + error;
            }
        }
        return null;
    };

    MoneroKeyImageSyncStepAck.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroKeyImageSyncStepAck)
            return object;
        var message = new $root.MoneroKeyImageSyncStepAck();
        if (object.kis) {
            if (!Array.isArray(object.kis))
                throw TypeError(".MoneroKeyImageSyncStepAck.kis: array expected");
            message.kis = [];
            for (var i = 0; i < object.kis.length; ++i) {
                if (typeof object.kis[i] !== "object")
                    throw TypeError(".MoneroKeyImageSyncStepAck.kis: object expected");
                message.kis[i] = $root.MoneroKeyImageSyncStepAck.MoneroExportedKeyImage.fromObject(object.kis[i]);
            }
        }
        return message;
    };

    MoneroKeyImageSyncStepAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.kis = [];
        if (message.kis && message.kis.length) {
            object.kis = [];
            for (var j = 0; j < message.kis.length; ++j)
                object.kis[j] = $root.MoneroKeyImageSyncStepAck.MoneroExportedKeyImage.toObject(message.kis[j], options);
        }
        return object;
    };

    MoneroKeyImageSyncStepAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    MoneroKeyImageSyncStepAck.MoneroExportedKeyImage = (function() {

        function MoneroExportedKeyImage(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        MoneroExportedKeyImage.prototype.iv = $util.newBuffer([]);
        MoneroExportedKeyImage.prototype.blob = $util.newBuffer([]);

        MoneroExportedKeyImage.create = function create(properties) {
            return new MoneroExportedKeyImage(properties);
        };

        MoneroExportedKeyImage.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.iv != null && Object.hasOwnProperty.call(message, "iv"))
                writer.uint32(10).bytes(message.iv);
            if (message.blob != null && Object.hasOwnProperty.call(message, "blob"))
                writer.uint32(26).bytes(message.blob);
            return writer;
        };

        MoneroExportedKeyImage.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        MoneroExportedKeyImage.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroKeyImageSyncStepAck.MoneroExportedKeyImage();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.iv = reader.bytes();
                    break;
                case 3:
                    message.blob = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        MoneroExportedKeyImage.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        MoneroExportedKeyImage.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.iv != null && message.hasOwnProperty("iv"))
                if (!(message.iv && typeof message.iv.length === "number" || $util.isString(message.iv)))
                    return "iv: buffer expected";
            if (message.blob != null && message.hasOwnProperty("blob"))
                if (!(message.blob && typeof message.blob.length === "number" || $util.isString(message.blob)))
                    return "blob: buffer expected";
            return null;
        };

        MoneroExportedKeyImage.fromObject = function fromObject(object) {
            if (object instanceof $root.MoneroKeyImageSyncStepAck.MoneroExportedKeyImage)
                return object;
            var message = new $root.MoneroKeyImageSyncStepAck.MoneroExportedKeyImage();
            if (object.iv != null)
                if (typeof object.iv === "string")
                    $util.base64.decode(object.iv, message.iv = $util.newBuffer($util.base64.length(object.iv)), 0);
                else if (object.iv.length)
                    message.iv = object.iv;
            if (object.blob != null)
                if (typeof object.blob === "string")
                    $util.base64.decode(object.blob, message.blob = $util.newBuffer($util.base64.length(object.blob)), 0);
                else if (object.blob.length)
                    message.blob = object.blob;
            return message;
        };

        MoneroExportedKeyImage.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if (options.bytes === String)
                    object.iv = "";
                else {
                    object.iv = [];
                    if (options.bytes !== Array)
                        object.iv = $util.newBuffer(object.iv);
                }
                if (options.bytes === String)
                    object.blob = "";
                else {
                    object.blob = [];
                    if (options.bytes !== Array)
                        object.blob = $util.newBuffer(object.blob);
                }
            }
            if (message.iv != null && message.hasOwnProperty("iv"))
                object.iv = options.bytes === String ? $util.base64.encode(message.iv, 0, message.iv.length) : options.bytes === Array ? Array.prototype.slice.call(message.iv) : message.iv;
            if (message.blob != null && message.hasOwnProperty("blob"))
                object.blob = options.bytes === String ? $util.base64.encode(message.blob, 0, message.blob.length) : options.bytes === Array ? Array.prototype.slice.call(message.blob) : message.blob;
            return object;
        };

        MoneroExportedKeyImage.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return MoneroExportedKeyImage;
    })();

    return MoneroKeyImageSyncStepAck;
})();

$root.MoneroKeyImageSyncFinalRequest = (function() {

    function MoneroKeyImageSyncFinalRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroKeyImageSyncFinalRequest.create = function create(properties) {
        return new MoneroKeyImageSyncFinalRequest(properties);
    };

    MoneroKeyImageSyncFinalRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    MoneroKeyImageSyncFinalRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroKeyImageSyncFinalRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroKeyImageSyncFinalRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroKeyImageSyncFinalRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroKeyImageSyncFinalRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    MoneroKeyImageSyncFinalRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroKeyImageSyncFinalRequest)
            return object;
        return new $root.MoneroKeyImageSyncFinalRequest();
    };

    MoneroKeyImageSyncFinalRequest.toObject = function toObject() {
        return {};
    };

    MoneroKeyImageSyncFinalRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoneroKeyImageSyncFinalRequest;
})();

$root.MoneroKeyImageSyncFinalAck = (function() {

    function MoneroKeyImageSyncFinalAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroKeyImageSyncFinalAck.prototype.enc_key = $util.newBuffer([]);

    MoneroKeyImageSyncFinalAck.create = function create(properties) {
        return new MoneroKeyImageSyncFinalAck(properties);
    };

    MoneroKeyImageSyncFinalAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.enc_key != null && Object.hasOwnProperty.call(message, "enc_key"))
            writer.uint32(10).bytes(message.enc_key);
        return writer;
    };

    MoneroKeyImageSyncFinalAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroKeyImageSyncFinalAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroKeyImageSyncFinalAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.enc_key = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroKeyImageSyncFinalAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroKeyImageSyncFinalAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.enc_key != null && message.hasOwnProperty("enc_key"))
            if (!(message.enc_key && typeof message.enc_key.length === "number" || $util.isString(message.enc_key)))
                return "enc_key: buffer expected";
        return null;
    };

    MoneroKeyImageSyncFinalAck.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroKeyImageSyncFinalAck)
            return object;
        var message = new $root.MoneroKeyImageSyncFinalAck();
        if (object.enc_key != null)
            if (typeof object.enc_key === "string")
                $util.base64.decode(object.enc_key, message.enc_key = $util.newBuffer($util.base64.length(object.enc_key)), 0);
            else if (object.enc_key.length)
                message.enc_key = object.enc_key;
        return message;
    };

    MoneroKeyImageSyncFinalAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.enc_key = "";
            else {
                object.enc_key = [];
                if (options.bytes !== Array)
                    object.enc_key = $util.newBuffer(object.enc_key);
            }
        if (message.enc_key != null && message.hasOwnProperty("enc_key"))
            object.enc_key = options.bytes === String ? $util.base64.encode(message.enc_key, 0, message.enc_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.enc_key) : message.enc_key;
        return object;
    };

    MoneroKeyImageSyncFinalAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoneroKeyImageSyncFinalAck;
})();

$root.MoneroGetTxKeyRequest = (function() {

    function MoneroGetTxKeyRequest(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroGetTxKeyRequest.prototype.address_n = $util.emptyArray;
    MoneroGetTxKeyRequest.prototype.network_type = 0;
    MoneroGetTxKeyRequest.prototype.salt1 = $util.newBuffer([]);
    MoneroGetTxKeyRequest.prototype.salt2 = $util.newBuffer([]);
    MoneroGetTxKeyRequest.prototype.tx_enc_keys = $util.newBuffer([]);
    MoneroGetTxKeyRequest.prototype.tx_prefix_hash = $util.newBuffer([]);
    MoneroGetTxKeyRequest.prototype.reason = 0;
    MoneroGetTxKeyRequest.prototype.view_public_key = $util.newBuffer([]);

    MoneroGetTxKeyRequest.create = function create(properties) {
        return new MoneroGetTxKeyRequest(properties);
    };

    MoneroGetTxKeyRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.network_type != null && Object.hasOwnProperty.call(message, "network_type"))
            writer.uint32(16).uint32(message.network_type);
        if (message.salt1 != null && Object.hasOwnProperty.call(message, "salt1"))
            writer.uint32(26).bytes(message.salt1);
        if (message.salt2 != null && Object.hasOwnProperty.call(message, "salt2"))
            writer.uint32(34).bytes(message.salt2);
        if (message.tx_enc_keys != null && Object.hasOwnProperty.call(message, "tx_enc_keys"))
            writer.uint32(42).bytes(message.tx_enc_keys);
        if (message.tx_prefix_hash != null && Object.hasOwnProperty.call(message, "tx_prefix_hash"))
            writer.uint32(50).bytes(message.tx_prefix_hash);
        if (message.reason != null && Object.hasOwnProperty.call(message, "reason"))
            writer.uint32(56).uint32(message.reason);
        if (message.view_public_key != null && Object.hasOwnProperty.call(message, "view_public_key"))
            writer.uint32(66).bytes(message.view_public_key);
        return writer;
    };

    MoneroGetTxKeyRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroGetTxKeyRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroGetTxKeyRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.network_type = reader.uint32();
                break;
            case 3:
                message.salt1 = reader.bytes();
                break;
            case 4:
                message.salt2 = reader.bytes();
                break;
            case 5:
                message.tx_enc_keys = reader.bytes();
                break;
            case 6:
                message.tx_prefix_hash = reader.bytes();
                break;
            case 7:
                message.reason = reader.uint32();
                break;
            case 8:
                message.view_public_key = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroGetTxKeyRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroGetTxKeyRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.network_type != null && message.hasOwnProperty("network_type"))
            if (!$util.isInteger(message.network_type))
                return "network_type: integer expected";
        if (message.salt1 != null && message.hasOwnProperty("salt1"))
            if (!(message.salt1 && typeof message.salt1.length === "number" || $util.isString(message.salt1)))
                return "salt1: buffer expected";
        if (message.salt2 != null && message.hasOwnProperty("salt2"))
            if (!(message.salt2 && typeof message.salt2.length === "number" || $util.isString(message.salt2)))
                return "salt2: buffer expected";
        if (message.tx_enc_keys != null && message.hasOwnProperty("tx_enc_keys"))
            if (!(message.tx_enc_keys && typeof message.tx_enc_keys.length === "number" || $util.isString(message.tx_enc_keys)))
                return "tx_enc_keys: buffer expected";
        if (message.tx_prefix_hash != null && message.hasOwnProperty("tx_prefix_hash"))
            if (!(message.tx_prefix_hash && typeof message.tx_prefix_hash.length === "number" || $util.isString(message.tx_prefix_hash)))
                return "tx_prefix_hash: buffer expected";
        if (message.reason != null && message.hasOwnProperty("reason"))
            if (!$util.isInteger(message.reason))
                return "reason: integer expected";
        if (message.view_public_key != null && message.hasOwnProperty("view_public_key"))
            if (!(message.view_public_key && typeof message.view_public_key.length === "number" || $util.isString(message.view_public_key)))
                return "view_public_key: buffer expected";
        return null;
    };

    MoneroGetTxKeyRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroGetTxKeyRequest)
            return object;
        var message = new $root.MoneroGetTxKeyRequest();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".MoneroGetTxKeyRequest.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.network_type != null)
            message.network_type = object.network_type >>> 0;
        if (object.salt1 != null)
            if (typeof object.salt1 === "string")
                $util.base64.decode(object.salt1, message.salt1 = $util.newBuffer($util.base64.length(object.salt1)), 0);
            else if (object.salt1.length)
                message.salt1 = object.salt1;
        if (object.salt2 != null)
            if (typeof object.salt2 === "string")
                $util.base64.decode(object.salt2, message.salt2 = $util.newBuffer($util.base64.length(object.salt2)), 0);
            else if (object.salt2.length)
                message.salt2 = object.salt2;
        if (object.tx_enc_keys != null)
            if (typeof object.tx_enc_keys === "string")
                $util.base64.decode(object.tx_enc_keys, message.tx_enc_keys = $util.newBuffer($util.base64.length(object.tx_enc_keys)), 0);
            else if (object.tx_enc_keys.length)
                message.tx_enc_keys = object.tx_enc_keys;
        if (object.tx_prefix_hash != null)
            if (typeof object.tx_prefix_hash === "string")
                $util.base64.decode(object.tx_prefix_hash, message.tx_prefix_hash = $util.newBuffer($util.base64.length(object.tx_prefix_hash)), 0);
            else if (object.tx_prefix_hash.length)
                message.tx_prefix_hash = object.tx_prefix_hash;
        if (object.reason != null)
            message.reason = object.reason >>> 0;
        if (object.view_public_key != null)
            if (typeof object.view_public_key === "string")
                $util.base64.decode(object.view_public_key, message.view_public_key = $util.newBuffer($util.base64.length(object.view_public_key)), 0);
            else if (object.view_public_key.length)
                message.view_public_key = object.view_public_key;
        return message;
    };

    MoneroGetTxKeyRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            object.network_type = 0;
            if (options.bytes === String)
                object.salt1 = "";
            else {
                object.salt1 = [];
                if (options.bytes !== Array)
                    object.salt1 = $util.newBuffer(object.salt1);
            }
            if (options.bytes === String)
                object.salt2 = "";
            else {
                object.salt2 = [];
                if (options.bytes !== Array)
                    object.salt2 = $util.newBuffer(object.salt2);
            }
            if (options.bytes === String)
                object.tx_enc_keys = "";
            else {
                object.tx_enc_keys = [];
                if (options.bytes !== Array)
                    object.tx_enc_keys = $util.newBuffer(object.tx_enc_keys);
            }
            if (options.bytes === String)
                object.tx_prefix_hash = "";
            else {
                object.tx_prefix_hash = [];
                if (options.bytes !== Array)
                    object.tx_prefix_hash = $util.newBuffer(object.tx_prefix_hash);
            }
            object.reason = 0;
            if (options.bytes === String)
                object.view_public_key = "";
            else {
                object.view_public_key = [];
                if (options.bytes !== Array)
                    object.view_public_key = $util.newBuffer(object.view_public_key);
            }
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.network_type != null && message.hasOwnProperty("network_type"))
            object.network_type = message.network_type;
        if (message.salt1 != null && message.hasOwnProperty("salt1"))
            object.salt1 = options.bytes === String ? $util.base64.encode(message.salt1, 0, message.salt1.length) : options.bytes === Array ? Array.prototype.slice.call(message.salt1) : message.salt1;
        if (message.salt2 != null && message.hasOwnProperty("salt2"))
            object.salt2 = options.bytes === String ? $util.base64.encode(message.salt2, 0, message.salt2.length) : options.bytes === Array ? Array.prototype.slice.call(message.salt2) : message.salt2;
        if (message.tx_enc_keys != null && message.hasOwnProperty("tx_enc_keys"))
            object.tx_enc_keys = options.bytes === String ? $util.base64.encode(message.tx_enc_keys, 0, message.tx_enc_keys.length) : options.bytes === Array ? Array.prototype.slice.call(message.tx_enc_keys) : message.tx_enc_keys;
        if (message.tx_prefix_hash != null && message.hasOwnProperty("tx_prefix_hash"))
            object.tx_prefix_hash = options.bytes === String ? $util.base64.encode(message.tx_prefix_hash, 0, message.tx_prefix_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.tx_prefix_hash) : message.tx_prefix_hash;
        if (message.reason != null && message.hasOwnProperty("reason"))
            object.reason = message.reason;
        if (message.view_public_key != null && message.hasOwnProperty("view_public_key"))
            object.view_public_key = options.bytes === String ? $util.base64.encode(message.view_public_key, 0, message.view_public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.view_public_key) : message.view_public_key;
        return object;
    };

    MoneroGetTxKeyRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoneroGetTxKeyRequest;
})();

$root.MoneroGetTxKeyAck = (function() {

    function MoneroGetTxKeyAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroGetTxKeyAck.prototype.salt = $util.newBuffer([]);
    MoneroGetTxKeyAck.prototype.tx_keys = $util.newBuffer([]);
    MoneroGetTxKeyAck.prototype.tx_derivations = $util.newBuffer([]);

    MoneroGetTxKeyAck.create = function create(properties) {
        return new MoneroGetTxKeyAck(properties);
    };

    MoneroGetTxKeyAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.salt != null && Object.hasOwnProperty.call(message, "salt"))
            writer.uint32(10).bytes(message.salt);
        if (message.tx_keys != null && Object.hasOwnProperty.call(message, "tx_keys"))
            writer.uint32(18).bytes(message.tx_keys);
        if (message.tx_derivations != null && Object.hasOwnProperty.call(message, "tx_derivations"))
            writer.uint32(26).bytes(message.tx_derivations);
        return writer;
    };

    MoneroGetTxKeyAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroGetTxKeyAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroGetTxKeyAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.salt = reader.bytes();
                break;
            case 2:
                message.tx_keys = reader.bytes();
                break;
            case 3:
                message.tx_derivations = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroGetTxKeyAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroGetTxKeyAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.salt != null && message.hasOwnProperty("salt"))
            if (!(message.salt && typeof message.salt.length === "number" || $util.isString(message.salt)))
                return "salt: buffer expected";
        if (message.tx_keys != null && message.hasOwnProperty("tx_keys"))
            if (!(message.tx_keys && typeof message.tx_keys.length === "number" || $util.isString(message.tx_keys)))
                return "tx_keys: buffer expected";
        if (message.tx_derivations != null && message.hasOwnProperty("tx_derivations"))
            if (!(message.tx_derivations && typeof message.tx_derivations.length === "number" || $util.isString(message.tx_derivations)))
                return "tx_derivations: buffer expected";
        return null;
    };

    MoneroGetTxKeyAck.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroGetTxKeyAck)
            return object;
        var message = new $root.MoneroGetTxKeyAck();
        if (object.salt != null)
            if (typeof object.salt === "string")
                $util.base64.decode(object.salt, message.salt = $util.newBuffer($util.base64.length(object.salt)), 0);
            else if (object.salt.length)
                message.salt = object.salt;
        if (object.tx_keys != null)
            if (typeof object.tx_keys === "string")
                $util.base64.decode(object.tx_keys, message.tx_keys = $util.newBuffer($util.base64.length(object.tx_keys)), 0);
            else if (object.tx_keys.length)
                message.tx_keys = object.tx_keys;
        if (object.tx_derivations != null)
            if (typeof object.tx_derivations === "string")
                $util.base64.decode(object.tx_derivations, message.tx_derivations = $util.newBuffer($util.base64.length(object.tx_derivations)), 0);
            else if (object.tx_derivations.length)
                message.tx_derivations = object.tx_derivations;
        return message;
    };

    MoneroGetTxKeyAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.salt = "";
            else {
                object.salt = [];
                if (options.bytes !== Array)
                    object.salt = $util.newBuffer(object.salt);
            }
            if (options.bytes === String)
                object.tx_keys = "";
            else {
                object.tx_keys = [];
                if (options.bytes !== Array)
                    object.tx_keys = $util.newBuffer(object.tx_keys);
            }
            if (options.bytes === String)
                object.tx_derivations = "";
            else {
                object.tx_derivations = [];
                if (options.bytes !== Array)
                    object.tx_derivations = $util.newBuffer(object.tx_derivations);
            }
        }
        if (message.salt != null && message.hasOwnProperty("salt"))
            object.salt = options.bytes === String ? $util.base64.encode(message.salt, 0, message.salt.length) : options.bytes === Array ? Array.prototype.slice.call(message.salt) : message.salt;
        if (message.tx_keys != null && message.hasOwnProperty("tx_keys"))
            object.tx_keys = options.bytes === String ? $util.base64.encode(message.tx_keys, 0, message.tx_keys.length) : options.bytes === Array ? Array.prototype.slice.call(message.tx_keys) : message.tx_keys;
        if (message.tx_derivations != null && message.hasOwnProperty("tx_derivations"))
            object.tx_derivations = options.bytes === String ? $util.base64.encode(message.tx_derivations, 0, message.tx_derivations.length) : options.bytes === Array ? Array.prototype.slice.call(message.tx_derivations) : message.tx_derivations;
        return object;
    };

    MoneroGetTxKeyAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoneroGetTxKeyAck;
})();

$root.MoneroLiveRefreshStartRequest = (function() {

    function MoneroLiveRefreshStartRequest(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroLiveRefreshStartRequest.prototype.address_n = $util.emptyArray;
    MoneroLiveRefreshStartRequest.prototype.network_type = 0;

    MoneroLiveRefreshStartRequest.create = function create(properties) {
        return new MoneroLiveRefreshStartRequest(properties);
    };

    MoneroLiveRefreshStartRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.network_type != null && Object.hasOwnProperty.call(message, "network_type"))
            writer.uint32(16).uint32(message.network_type);
        return writer;
    };

    MoneroLiveRefreshStartRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroLiveRefreshStartRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroLiveRefreshStartRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.network_type = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroLiveRefreshStartRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroLiveRefreshStartRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.network_type != null && message.hasOwnProperty("network_type"))
            if (!$util.isInteger(message.network_type))
                return "network_type: integer expected";
        return null;
    };

    MoneroLiveRefreshStartRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroLiveRefreshStartRequest)
            return object;
        var message = new $root.MoneroLiveRefreshStartRequest();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".MoneroLiveRefreshStartRequest.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.network_type != null)
            message.network_type = object.network_type >>> 0;
        return message;
    };

    MoneroLiveRefreshStartRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            object.network_type = 0;
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.network_type != null && message.hasOwnProperty("network_type"))
            object.network_type = message.network_type;
        return object;
    };

    MoneroLiveRefreshStartRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoneroLiveRefreshStartRequest;
})();

$root.MoneroLiveRefreshStartAck = (function() {

    function MoneroLiveRefreshStartAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroLiveRefreshStartAck.create = function create(properties) {
        return new MoneroLiveRefreshStartAck(properties);
    };

    MoneroLiveRefreshStartAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    MoneroLiveRefreshStartAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroLiveRefreshStartAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroLiveRefreshStartAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroLiveRefreshStartAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroLiveRefreshStartAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    MoneroLiveRefreshStartAck.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroLiveRefreshStartAck)
            return object;
        return new $root.MoneroLiveRefreshStartAck();
    };

    MoneroLiveRefreshStartAck.toObject = function toObject() {
        return {};
    };

    MoneroLiveRefreshStartAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoneroLiveRefreshStartAck;
})();

$root.MoneroLiveRefreshStepRequest = (function() {

    function MoneroLiveRefreshStepRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroLiveRefreshStepRequest.prototype.out_key = $util.newBuffer([]);
    MoneroLiveRefreshStepRequest.prototype.recv_deriv = $util.newBuffer([]);
    MoneroLiveRefreshStepRequest.prototype.real_out_idx = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    MoneroLiveRefreshStepRequest.prototype.sub_addr_major = 0;
    MoneroLiveRefreshStepRequest.prototype.sub_addr_minor = 0;

    MoneroLiveRefreshStepRequest.create = function create(properties) {
        return new MoneroLiveRefreshStepRequest(properties);
    };

    MoneroLiveRefreshStepRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.out_key != null && Object.hasOwnProperty.call(message, "out_key"))
            writer.uint32(10).bytes(message.out_key);
        if (message.recv_deriv != null && Object.hasOwnProperty.call(message, "recv_deriv"))
            writer.uint32(18).bytes(message.recv_deriv);
        if (message.real_out_idx != null && Object.hasOwnProperty.call(message, "real_out_idx"))
            writer.uint32(24).uint64(message.real_out_idx);
        if (message.sub_addr_major != null && Object.hasOwnProperty.call(message, "sub_addr_major"))
            writer.uint32(32).uint32(message.sub_addr_major);
        if (message.sub_addr_minor != null && Object.hasOwnProperty.call(message, "sub_addr_minor"))
            writer.uint32(40).uint32(message.sub_addr_minor);
        return writer;
    };

    MoneroLiveRefreshStepRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroLiveRefreshStepRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroLiveRefreshStepRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.out_key = reader.bytes();
                break;
            case 2:
                message.recv_deriv = reader.bytes();
                break;
            case 3:
                message.real_out_idx = reader.uint64();
                break;
            case 4:
                message.sub_addr_major = reader.uint32();
                break;
            case 5:
                message.sub_addr_minor = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroLiveRefreshStepRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroLiveRefreshStepRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.out_key != null && message.hasOwnProperty("out_key"))
            if (!(message.out_key && typeof message.out_key.length === "number" || $util.isString(message.out_key)))
                return "out_key: buffer expected";
        if (message.recv_deriv != null && message.hasOwnProperty("recv_deriv"))
            if (!(message.recv_deriv && typeof message.recv_deriv.length === "number" || $util.isString(message.recv_deriv)))
                return "recv_deriv: buffer expected";
        if (message.real_out_idx != null && message.hasOwnProperty("real_out_idx"))
            if (!$util.isInteger(message.real_out_idx) && !(message.real_out_idx && $util.isInteger(message.real_out_idx.low) && $util.isInteger(message.real_out_idx.high)))
                return "real_out_idx: integer|Long expected";
        if (message.sub_addr_major != null && message.hasOwnProperty("sub_addr_major"))
            if (!$util.isInteger(message.sub_addr_major))
                return "sub_addr_major: integer expected";
        if (message.sub_addr_minor != null && message.hasOwnProperty("sub_addr_minor"))
            if (!$util.isInteger(message.sub_addr_minor))
                return "sub_addr_minor: integer expected";
        return null;
    };

    MoneroLiveRefreshStepRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroLiveRefreshStepRequest)
            return object;
        var message = new $root.MoneroLiveRefreshStepRequest();
        if (object.out_key != null)
            if (typeof object.out_key === "string")
                $util.base64.decode(object.out_key, message.out_key = $util.newBuffer($util.base64.length(object.out_key)), 0);
            else if (object.out_key.length)
                message.out_key = object.out_key;
        if (object.recv_deriv != null)
            if (typeof object.recv_deriv === "string")
                $util.base64.decode(object.recv_deriv, message.recv_deriv = $util.newBuffer($util.base64.length(object.recv_deriv)), 0);
            else if (object.recv_deriv.length)
                message.recv_deriv = object.recv_deriv;
        if (object.real_out_idx != null)
            if ($util.Long)
                (message.real_out_idx = $util.Long.fromValue(object.real_out_idx)).unsigned = true;
            else if (typeof object.real_out_idx === "string")
                message.real_out_idx = parseInt(object.real_out_idx, 10);
            else if (typeof object.real_out_idx === "number")
                message.real_out_idx = object.real_out_idx;
            else if (typeof object.real_out_idx === "object")
                message.real_out_idx = new $util.LongBits(object.real_out_idx.low >>> 0, object.real_out_idx.high >>> 0).toNumber(true);
        if (object.sub_addr_major != null)
            message.sub_addr_major = object.sub_addr_major >>> 0;
        if (object.sub_addr_minor != null)
            message.sub_addr_minor = object.sub_addr_minor >>> 0;
        return message;
    };

    MoneroLiveRefreshStepRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.out_key = "";
            else {
                object.out_key = [];
                if (options.bytes !== Array)
                    object.out_key = $util.newBuffer(object.out_key);
            }
            if (options.bytes === String)
                object.recv_deriv = "";
            else {
                object.recv_deriv = [];
                if (options.bytes !== Array)
                    object.recv_deriv = $util.newBuffer(object.recv_deriv);
            }
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.real_out_idx = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.real_out_idx = options.longs === String ? "0" : 0;
            object.sub_addr_major = 0;
            object.sub_addr_minor = 0;
        }
        if (message.out_key != null && message.hasOwnProperty("out_key"))
            object.out_key = options.bytes === String ? $util.base64.encode(message.out_key, 0, message.out_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.out_key) : message.out_key;
        if (message.recv_deriv != null && message.hasOwnProperty("recv_deriv"))
            object.recv_deriv = options.bytes === String ? $util.base64.encode(message.recv_deriv, 0, message.recv_deriv.length) : options.bytes === Array ? Array.prototype.slice.call(message.recv_deriv) : message.recv_deriv;
        if (message.real_out_idx != null && message.hasOwnProperty("real_out_idx"))
            if (typeof message.real_out_idx === "number")
                object.real_out_idx = options.longs === String ? String(message.real_out_idx) : message.real_out_idx;
            else
                object.real_out_idx = options.longs === String ? $util.Long.prototype.toString.call(message.real_out_idx) : options.longs === Number ? new $util.LongBits(message.real_out_idx.low >>> 0, message.real_out_idx.high >>> 0).toNumber(true) : message.real_out_idx;
        if (message.sub_addr_major != null && message.hasOwnProperty("sub_addr_major"))
            object.sub_addr_major = message.sub_addr_major;
        if (message.sub_addr_minor != null && message.hasOwnProperty("sub_addr_minor"))
            object.sub_addr_minor = message.sub_addr_minor;
        return object;
    };

    MoneroLiveRefreshStepRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoneroLiveRefreshStepRequest;
})();

$root.MoneroLiveRefreshStepAck = (function() {

    function MoneroLiveRefreshStepAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroLiveRefreshStepAck.prototype.salt = $util.newBuffer([]);
    MoneroLiveRefreshStepAck.prototype.key_image = $util.newBuffer([]);

    MoneroLiveRefreshStepAck.create = function create(properties) {
        return new MoneroLiveRefreshStepAck(properties);
    };

    MoneroLiveRefreshStepAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.salt != null && Object.hasOwnProperty.call(message, "salt"))
            writer.uint32(10).bytes(message.salt);
        if (message.key_image != null && Object.hasOwnProperty.call(message, "key_image"))
            writer.uint32(18).bytes(message.key_image);
        return writer;
    };

    MoneroLiveRefreshStepAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroLiveRefreshStepAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroLiveRefreshStepAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.salt = reader.bytes();
                break;
            case 2:
                message.key_image = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroLiveRefreshStepAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroLiveRefreshStepAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.salt != null && message.hasOwnProperty("salt"))
            if (!(message.salt && typeof message.salt.length === "number" || $util.isString(message.salt)))
                return "salt: buffer expected";
        if (message.key_image != null && message.hasOwnProperty("key_image"))
            if (!(message.key_image && typeof message.key_image.length === "number" || $util.isString(message.key_image)))
                return "key_image: buffer expected";
        return null;
    };

    MoneroLiveRefreshStepAck.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroLiveRefreshStepAck)
            return object;
        var message = new $root.MoneroLiveRefreshStepAck();
        if (object.salt != null)
            if (typeof object.salt === "string")
                $util.base64.decode(object.salt, message.salt = $util.newBuffer($util.base64.length(object.salt)), 0);
            else if (object.salt.length)
                message.salt = object.salt;
        if (object.key_image != null)
            if (typeof object.key_image === "string")
                $util.base64.decode(object.key_image, message.key_image = $util.newBuffer($util.base64.length(object.key_image)), 0);
            else if (object.key_image.length)
                message.key_image = object.key_image;
        return message;
    };

    MoneroLiveRefreshStepAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.salt = "";
            else {
                object.salt = [];
                if (options.bytes !== Array)
                    object.salt = $util.newBuffer(object.salt);
            }
            if (options.bytes === String)
                object.key_image = "";
            else {
                object.key_image = [];
                if (options.bytes !== Array)
                    object.key_image = $util.newBuffer(object.key_image);
            }
        }
        if (message.salt != null && message.hasOwnProperty("salt"))
            object.salt = options.bytes === String ? $util.base64.encode(message.salt, 0, message.salt.length) : options.bytes === Array ? Array.prototype.slice.call(message.salt) : message.salt;
        if (message.key_image != null && message.hasOwnProperty("key_image"))
            object.key_image = options.bytes === String ? $util.base64.encode(message.key_image, 0, message.key_image.length) : options.bytes === Array ? Array.prototype.slice.call(message.key_image) : message.key_image;
        return object;
    };

    MoneroLiveRefreshStepAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoneroLiveRefreshStepAck;
})();

$root.MoneroLiveRefreshFinalRequest = (function() {

    function MoneroLiveRefreshFinalRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroLiveRefreshFinalRequest.create = function create(properties) {
        return new MoneroLiveRefreshFinalRequest(properties);
    };

    MoneroLiveRefreshFinalRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    MoneroLiveRefreshFinalRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroLiveRefreshFinalRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroLiveRefreshFinalRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroLiveRefreshFinalRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroLiveRefreshFinalRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    MoneroLiveRefreshFinalRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroLiveRefreshFinalRequest)
            return object;
        return new $root.MoneroLiveRefreshFinalRequest();
    };

    MoneroLiveRefreshFinalRequest.toObject = function toObject() {
        return {};
    };

    MoneroLiveRefreshFinalRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoneroLiveRefreshFinalRequest;
})();

$root.MoneroLiveRefreshFinalAck = (function() {

    function MoneroLiveRefreshFinalAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroLiveRefreshFinalAck.create = function create(properties) {
        return new MoneroLiveRefreshFinalAck(properties);
    };

    MoneroLiveRefreshFinalAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    MoneroLiveRefreshFinalAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroLiveRefreshFinalAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroLiveRefreshFinalAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroLiveRefreshFinalAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroLiveRefreshFinalAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    MoneroLiveRefreshFinalAck.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroLiveRefreshFinalAck)
            return object;
        return new $root.MoneroLiveRefreshFinalAck();
    };

    MoneroLiveRefreshFinalAck.toObject = function toObject() {
        return {};
    };

    MoneroLiveRefreshFinalAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoneroLiveRefreshFinalAck;
})();

$root.DebugMoneroDiagRequest = (function() {

    function DebugMoneroDiagRequest(properties) {
        this.pd = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DebugMoneroDiagRequest.prototype.ins = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    DebugMoneroDiagRequest.prototype.p1 = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    DebugMoneroDiagRequest.prototype.p2 = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    DebugMoneroDiagRequest.prototype.pd = $util.emptyArray;
    DebugMoneroDiagRequest.prototype.data1 = $util.newBuffer([]);
    DebugMoneroDiagRequest.prototype.data2 = $util.newBuffer([]);

    DebugMoneroDiagRequest.create = function create(properties) {
        return new DebugMoneroDiagRequest(properties);
    };

    DebugMoneroDiagRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.ins != null && Object.hasOwnProperty.call(message, "ins"))
            writer.uint32(8).uint64(message.ins);
        if (message.p1 != null && Object.hasOwnProperty.call(message, "p1"))
            writer.uint32(16).uint64(message.p1);
        if (message.p2 != null && Object.hasOwnProperty.call(message, "p2"))
            writer.uint32(24).uint64(message.p2);
        if (message.pd != null && message.pd.length)
            for (var i = 0; i < message.pd.length; ++i)
                writer.uint32(32).uint64(message.pd[i]);
        if (message.data1 != null && Object.hasOwnProperty.call(message, "data1"))
            writer.uint32(42).bytes(message.data1);
        if (message.data2 != null && Object.hasOwnProperty.call(message, "data2"))
            writer.uint32(50).bytes(message.data2);
        return writer;
    };

    DebugMoneroDiagRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DebugMoneroDiagRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DebugMoneroDiagRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.ins = reader.uint64();
                break;
            case 2:
                message.p1 = reader.uint64();
                break;
            case 3:
                message.p2 = reader.uint64();
                break;
            case 4:
                if (!(message.pd && message.pd.length))
                    message.pd = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.pd.push(reader.uint64());
                } else
                    message.pd.push(reader.uint64());
                break;
            case 5:
                message.data1 = reader.bytes();
                break;
            case 6:
                message.data2 = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    DebugMoneroDiagRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DebugMoneroDiagRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.ins != null && message.hasOwnProperty("ins"))
            if (!$util.isInteger(message.ins) && !(message.ins && $util.isInteger(message.ins.low) && $util.isInteger(message.ins.high)))
                return "ins: integer|Long expected";
        if (message.p1 != null && message.hasOwnProperty("p1"))
            if (!$util.isInteger(message.p1) && !(message.p1 && $util.isInteger(message.p1.low) && $util.isInteger(message.p1.high)))
                return "p1: integer|Long expected";
        if (message.p2 != null && message.hasOwnProperty("p2"))
            if (!$util.isInteger(message.p2) && !(message.p2 && $util.isInteger(message.p2.low) && $util.isInteger(message.p2.high)))
                return "p2: integer|Long expected";
        if (message.pd != null && message.hasOwnProperty("pd")) {
            if (!Array.isArray(message.pd))
                return "pd: array expected";
            for (var i = 0; i < message.pd.length; ++i)
                if (!$util.isInteger(message.pd[i]) && !(message.pd[i] && $util.isInteger(message.pd[i].low) && $util.isInteger(message.pd[i].high)))
                    return "pd: integer|Long[] expected";
        }
        if (message.data1 != null && message.hasOwnProperty("data1"))
            if (!(message.data1 && typeof message.data1.length === "number" || $util.isString(message.data1)))
                return "data1: buffer expected";
        if (message.data2 != null && message.hasOwnProperty("data2"))
            if (!(message.data2 && typeof message.data2.length === "number" || $util.isString(message.data2)))
                return "data2: buffer expected";
        return null;
    };

    DebugMoneroDiagRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.DebugMoneroDiagRequest)
            return object;
        var message = new $root.DebugMoneroDiagRequest();
        if (object.ins != null)
            if ($util.Long)
                (message.ins = $util.Long.fromValue(object.ins)).unsigned = true;
            else if (typeof object.ins === "string")
                message.ins = parseInt(object.ins, 10);
            else if (typeof object.ins === "number")
                message.ins = object.ins;
            else if (typeof object.ins === "object")
                message.ins = new $util.LongBits(object.ins.low >>> 0, object.ins.high >>> 0).toNumber(true);
        if (object.p1 != null)
            if ($util.Long)
                (message.p1 = $util.Long.fromValue(object.p1)).unsigned = true;
            else if (typeof object.p1 === "string")
                message.p1 = parseInt(object.p1, 10);
            else if (typeof object.p1 === "number")
                message.p1 = object.p1;
            else if (typeof object.p1 === "object")
                message.p1 = new $util.LongBits(object.p1.low >>> 0, object.p1.high >>> 0).toNumber(true);
        if (object.p2 != null)
            if ($util.Long)
                (message.p2 = $util.Long.fromValue(object.p2)).unsigned = true;
            else if (typeof object.p2 === "string")
                message.p2 = parseInt(object.p2, 10);
            else if (typeof object.p2 === "number")
                message.p2 = object.p2;
            else if (typeof object.p2 === "object")
                message.p2 = new $util.LongBits(object.p2.low >>> 0, object.p2.high >>> 0).toNumber(true);
        if (object.pd) {
            if (!Array.isArray(object.pd))
                throw TypeError(".DebugMoneroDiagRequest.pd: array expected");
            message.pd = [];
            for (var i = 0; i < object.pd.length; ++i)
                if ($util.Long)
                    (message.pd[i] = $util.Long.fromValue(object.pd[i])).unsigned = true;
                else if (typeof object.pd[i] === "string")
                    message.pd[i] = parseInt(object.pd[i], 10);
                else if (typeof object.pd[i] === "number")
                    message.pd[i] = object.pd[i];
                else if (typeof object.pd[i] === "object")
                    message.pd[i] = new $util.LongBits(object.pd[i].low >>> 0, object.pd[i].high >>> 0).toNumber(true);
        }
        if (object.data1 != null)
            if (typeof object.data1 === "string")
                $util.base64.decode(object.data1, message.data1 = $util.newBuffer($util.base64.length(object.data1)), 0);
            else if (object.data1.length)
                message.data1 = object.data1;
        if (object.data2 != null)
            if (typeof object.data2 === "string")
                $util.base64.decode(object.data2, message.data2 = $util.newBuffer($util.base64.length(object.data2)), 0);
            else if (object.data2.length)
                message.data2 = object.data2;
        return message;
    };

    DebugMoneroDiagRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.pd = [];
        if (options.defaults) {
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.ins = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.ins = options.longs === String ? "0" : 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.p1 = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.p1 = options.longs === String ? "0" : 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.p2 = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.p2 = options.longs === String ? "0" : 0;
            if (options.bytes === String)
                object.data1 = "";
            else {
                object.data1 = [];
                if (options.bytes !== Array)
                    object.data1 = $util.newBuffer(object.data1);
            }
            if (options.bytes === String)
                object.data2 = "";
            else {
                object.data2 = [];
                if (options.bytes !== Array)
                    object.data2 = $util.newBuffer(object.data2);
            }
        }
        if (message.ins != null && message.hasOwnProperty("ins"))
            if (typeof message.ins === "number")
                object.ins = options.longs === String ? String(message.ins) : message.ins;
            else
                object.ins = options.longs === String ? $util.Long.prototype.toString.call(message.ins) : options.longs === Number ? new $util.LongBits(message.ins.low >>> 0, message.ins.high >>> 0).toNumber(true) : message.ins;
        if (message.p1 != null && message.hasOwnProperty("p1"))
            if (typeof message.p1 === "number")
                object.p1 = options.longs === String ? String(message.p1) : message.p1;
            else
                object.p1 = options.longs === String ? $util.Long.prototype.toString.call(message.p1) : options.longs === Number ? new $util.LongBits(message.p1.low >>> 0, message.p1.high >>> 0).toNumber(true) : message.p1;
        if (message.p2 != null && message.hasOwnProperty("p2"))
            if (typeof message.p2 === "number")
                object.p2 = options.longs === String ? String(message.p2) : message.p2;
            else
                object.p2 = options.longs === String ? $util.Long.prototype.toString.call(message.p2) : options.longs === Number ? new $util.LongBits(message.p2.low >>> 0, message.p2.high >>> 0).toNumber(true) : message.p2;
        if (message.pd && message.pd.length) {
            object.pd = [];
            for (var j = 0; j < message.pd.length; ++j)
                if (typeof message.pd[j] === "number")
                    object.pd[j] = options.longs === String ? String(message.pd[j]) : message.pd[j];
                else
                    object.pd[j] = options.longs === String ? $util.Long.prototype.toString.call(message.pd[j]) : options.longs === Number ? new $util.LongBits(message.pd[j].low >>> 0, message.pd[j].high >>> 0).toNumber(true) : message.pd[j];
        }
        if (message.data1 != null && message.hasOwnProperty("data1"))
            object.data1 = options.bytes === String ? $util.base64.encode(message.data1, 0, message.data1.length) : options.bytes === Array ? Array.prototype.slice.call(message.data1) : message.data1;
        if (message.data2 != null && message.hasOwnProperty("data2"))
            object.data2 = options.bytes === String ? $util.base64.encode(message.data2, 0, message.data2.length) : options.bytes === Array ? Array.prototype.slice.call(message.data2) : message.data2;
        return object;
    };

    DebugMoneroDiagRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DebugMoneroDiagRequest;
})();

$root.DebugMoneroDiagAck = (function() {

    function DebugMoneroDiagAck(properties) {
        this.pd = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DebugMoneroDiagAck.prototype.ins = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    DebugMoneroDiagAck.prototype.p1 = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    DebugMoneroDiagAck.prototype.p2 = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    DebugMoneroDiagAck.prototype.pd = $util.emptyArray;
    DebugMoneroDiagAck.prototype.data1 = $util.newBuffer([]);
    DebugMoneroDiagAck.prototype.data2 = $util.newBuffer([]);

    DebugMoneroDiagAck.create = function create(properties) {
        return new DebugMoneroDiagAck(properties);
    };

    DebugMoneroDiagAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.ins != null && Object.hasOwnProperty.call(message, "ins"))
            writer.uint32(8).uint64(message.ins);
        if (message.p1 != null && Object.hasOwnProperty.call(message, "p1"))
            writer.uint32(16).uint64(message.p1);
        if (message.p2 != null && Object.hasOwnProperty.call(message, "p2"))
            writer.uint32(24).uint64(message.p2);
        if (message.pd != null && message.pd.length)
            for (var i = 0; i < message.pd.length; ++i)
                writer.uint32(32).uint64(message.pd[i]);
        if (message.data1 != null && Object.hasOwnProperty.call(message, "data1"))
            writer.uint32(42).bytes(message.data1);
        if (message.data2 != null && Object.hasOwnProperty.call(message, "data2"))
            writer.uint32(50).bytes(message.data2);
        return writer;
    };

    DebugMoneroDiagAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DebugMoneroDiagAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DebugMoneroDiagAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.ins = reader.uint64();
                break;
            case 2:
                message.p1 = reader.uint64();
                break;
            case 3:
                message.p2 = reader.uint64();
                break;
            case 4:
                if (!(message.pd && message.pd.length))
                    message.pd = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.pd.push(reader.uint64());
                } else
                    message.pd.push(reader.uint64());
                break;
            case 5:
                message.data1 = reader.bytes();
                break;
            case 6:
                message.data2 = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    DebugMoneroDiagAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DebugMoneroDiagAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.ins != null && message.hasOwnProperty("ins"))
            if (!$util.isInteger(message.ins) && !(message.ins && $util.isInteger(message.ins.low) && $util.isInteger(message.ins.high)))
                return "ins: integer|Long expected";
        if (message.p1 != null && message.hasOwnProperty("p1"))
            if (!$util.isInteger(message.p1) && !(message.p1 && $util.isInteger(message.p1.low) && $util.isInteger(message.p1.high)))
                return "p1: integer|Long expected";
        if (message.p2 != null && message.hasOwnProperty("p2"))
            if (!$util.isInteger(message.p2) && !(message.p2 && $util.isInteger(message.p2.low) && $util.isInteger(message.p2.high)))
                return "p2: integer|Long expected";
        if (message.pd != null && message.hasOwnProperty("pd")) {
            if (!Array.isArray(message.pd))
                return "pd: array expected";
            for (var i = 0; i < message.pd.length; ++i)
                if (!$util.isInteger(message.pd[i]) && !(message.pd[i] && $util.isInteger(message.pd[i].low) && $util.isInteger(message.pd[i].high)))
                    return "pd: integer|Long[] expected";
        }
        if (message.data1 != null && message.hasOwnProperty("data1"))
            if (!(message.data1 && typeof message.data1.length === "number" || $util.isString(message.data1)))
                return "data1: buffer expected";
        if (message.data2 != null && message.hasOwnProperty("data2"))
            if (!(message.data2 && typeof message.data2.length === "number" || $util.isString(message.data2)))
                return "data2: buffer expected";
        return null;
    };

    DebugMoneroDiagAck.fromObject = function fromObject(object) {
        if (object instanceof $root.DebugMoneroDiagAck)
            return object;
        var message = new $root.DebugMoneroDiagAck();
        if (object.ins != null)
            if ($util.Long)
                (message.ins = $util.Long.fromValue(object.ins)).unsigned = true;
            else if (typeof object.ins === "string")
                message.ins = parseInt(object.ins, 10);
            else if (typeof object.ins === "number")
                message.ins = object.ins;
            else if (typeof object.ins === "object")
                message.ins = new $util.LongBits(object.ins.low >>> 0, object.ins.high >>> 0).toNumber(true);
        if (object.p1 != null)
            if ($util.Long)
                (message.p1 = $util.Long.fromValue(object.p1)).unsigned = true;
            else if (typeof object.p1 === "string")
                message.p1 = parseInt(object.p1, 10);
            else if (typeof object.p1 === "number")
                message.p1 = object.p1;
            else if (typeof object.p1 === "object")
                message.p1 = new $util.LongBits(object.p1.low >>> 0, object.p1.high >>> 0).toNumber(true);
        if (object.p2 != null)
            if ($util.Long)
                (message.p2 = $util.Long.fromValue(object.p2)).unsigned = true;
            else if (typeof object.p2 === "string")
                message.p2 = parseInt(object.p2, 10);
            else if (typeof object.p2 === "number")
                message.p2 = object.p2;
            else if (typeof object.p2 === "object")
                message.p2 = new $util.LongBits(object.p2.low >>> 0, object.p2.high >>> 0).toNumber(true);
        if (object.pd) {
            if (!Array.isArray(object.pd))
                throw TypeError(".DebugMoneroDiagAck.pd: array expected");
            message.pd = [];
            for (var i = 0; i < object.pd.length; ++i)
                if ($util.Long)
                    (message.pd[i] = $util.Long.fromValue(object.pd[i])).unsigned = true;
                else if (typeof object.pd[i] === "string")
                    message.pd[i] = parseInt(object.pd[i], 10);
                else if (typeof object.pd[i] === "number")
                    message.pd[i] = object.pd[i];
                else if (typeof object.pd[i] === "object")
                    message.pd[i] = new $util.LongBits(object.pd[i].low >>> 0, object.pd[i].high >>> 0).toNumber(true);
        }
        if (object.data1 != null)
            if (typeof object.data1 === "string")
                $util.base64.decode(object.data1, message.data1 = $util.newBuffer($util.base64.length(object.data1)), 0);
            else if (object.data1.length)
                message.data1 = object.data1;
        if (object.data2 != null)
            if (typeof object.data2 === "string")
                $util.base64.decode(object.data2, message.data2 = $util.newBuffer($util.base64.length(object.data2)), 0);
            else if (object.data2.length)
                message.data2 = object.data2;
        return message;
    };

    DebugMoneroDiagAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.pd = [];
        if (options.defaults) {
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.ins = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.ins = options.longs === String ? "0" : 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.p1 = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.p1 = options.longs === String ? "0" : 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.p2 = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.p2 = options.longs === String ? "0" : 0;
            if (options.bytes === String)
                object.data1 = "";
            else {
                object.data1 = [];
                if (options.bytes !== Array)
                    object.data1 = $util.newBuffer(object.data1);
            }
            if (options.bytes === String)
                object.data2 = "";
            else {
                object.data2 = [];
                if (options.bytes !== Array)
                    object.data2 = $util.newBuffer(object.data2);
            }
        }
        if (message.ins != null && message.hasOwnProperty("ins"))
            if (typeof message.ins === "number")
                object.ins = options.longs === String ? String(message.ins) : message.ins;
            else
                object.ins = options.longs === String ? $util.Long.prototype.toString.call(message.ins) : options.longs === Number ? new $util.LongBits(message.ins.low >>> 0, message.ins.high >>> 0).toNumber(true) : message.ins;
        if (message.p1 != null && message.hasOwnProperty("p1"))
            if (typeof message.p1 === "number")
                object.p1 = options.longs === String ? String(message.p1) : message.p1;
            else
                object.p1 = options.longs === String ? $util.Long.prototype.toString.call(message.p1) : options.longs === Number ? new $util.LongBits(message.p1.low >>> 0, message.p1.high >>> 0).toNumber(true) : message.p1;
        if (message.p2 != null && message.hasOwnProperty("p2"))
            if (typeof message.p2 === "number")
                object.p2 = options.longs === String ? String(message.p2) : message.p2;
            else
                object.p2 = options.longs === String ? $util.Long.prototype.toString.call(message.p2) : options.longs === Number ? new $util.LongBits(message.p2.low >>> 0, message.p2.high >>> 0).toNumber(true) : message.p2;
        if (message.pd && message.pd.length) {
            object.pd = [];
            for (var j = 0; j < message.pd.length; ++j)
                if (typeof message.pd[j] === "number")
                    object.pd[j] = options.longs === String ? String(message.pd[j]) : message.pd[j];
                else
                    object.pd[j] = options.longs === String ? $util.Long.prototype.toString.call(message.pd[j]) : options.longs === Number ? new $util.LongBits(message.pd[j].low >>> 0, message.pd[j].high >>> 0).toNumber(true) : message.pd[j];
        }
        if (message.data1 != null && message.hasOwnProperty("data1"))
            object.data1 = options.bytes === String ? $util.base64.encode(message.data1, 0, message.data1.length) : options.bytes === Array ? Array.prototype.slice.call(message.data1) : message.data1;
        if (message.data2 != null && message.hasOwnProperty("data2"))
            object.data2 = options.bytes === String ? $util.base64.encode(message.data2, 0, message.data2.length) : options.bytes === Array ? Array.prototype.slice.call(message.data2) : message.data2;
        return object;
    };

    DebugMoneroDiagAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DebugMoneroDiagAck;
})();

$root.NearGetAddress = (function() {

    function NearGetAddress(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NearGetAddress.prototype.address_n = $util.emptyArray;
    NearGetAddress.prototype.show_display = false;

    NearGetAddress.create = function create(properties) {
        return new NearGetAddress(properties);
    };

    NearGetAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(16).bool(message.show_display);
        return writer;
    };

    NearGetAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NearGetAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NearGetAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.show_display = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    NearGetAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NearGetAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        return null;
    };

    NearGetAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.NearGetAddress)
            return object;
        var message = new $root.NearGetAddress();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".NearGetAddress.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        return message;
    };

    NearGetAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            object.show_display = false;
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        return object;
    };

    NearGetAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NearGetAddress;
})();

$root.NearAddress = (function() {

    function NearAddress(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NearAddress.prototype.address = "";

    NearAddress.create = function create(properties) {
        return new NearAddress(properties);
    };

    NearAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address != null && Object.hasOwnProperty.call(message, "address"))
            writer.uint32(10).string(message.address);
        return writer;
    };

    NearAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NearAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NearAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    NearAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NearAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address != null && message.hasOwnProperty("address"))
            if (!$util.isString(message.address))
                return "address: string expected";
        return null;
    };

    NearAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.NearAddress)
            return object;
        var message = new $root.NearAddress();
        if (object.address != null)
            message.address = String(object.address);
        return message;
    };

    NearAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.address = "";
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    NearAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NearAddress;
})();

$root.NearSignTx = (function() {

    function NearSignTx(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NearSignTx.prototype.address_n = $util.emptyArray;
    NearSignTx.prototype.raw_tx = $util.newBuffer([]);

    NearSignTx.create = function create(properties) {
        return new NearSignTx(properties);
    };

    NearSignTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).bytes(message.raw_tx);
        return writer;
    };

    NearSignTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NearSignTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NearSignTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.raw_tx = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("raw_tx"))
            throw $util.ProtocolError("missing required 'raw_tx'", { instance: message });
        return message;
    };

    NearSignTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NearSignTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!(message.raw_tx && typeof message.raw_tx.length === "number" || $util.isString(message.raw_tx)))
            return "raw_tx: buffer expected";
        return null;
    };

    NearSignTx.fromObject = function fromObject(object) {
        if (object instanceof $root.NearSignTx)
            return object;
        var message = new $root.NearSignTx();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".NearSignTx.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.raw_tx != null)
            if (typeof object.raw_tx === "string")
                $util.base64.decode(object.raw_tx, message.raw_tx = $util.newBuffer($util.base64.length(object.raw_tx)), 0);
            else if (object.raw_tx.length)
                message.raw_tx = object.raw_tx;
        return message;
    };

    NearSignTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            if (options.bytes === String)
                object.raw_tx = "";
            else {
                object.raw_tx = [];
                if (options.bytes !== Array)
                    object.raw_tx = $util.newBuffer(object.raw_tx);
            }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.raw_tx != null && message.hasOwnProperty("raw_tx"))
            object.raw_tx = options.bytes === String ? $util.base64.encode(message.raw_tx, 0, message.raw_tx.length) : options.bytes === Array ? Array.prototype.slice.call(message.raw_tx) : message.raw_tx;
        return object;
    };

    NearSignTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NearSignTx;
})();

$root.NearSignedTx = (function() {

    function NearSignedTx(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NearSignedTx.prototype.signature = $util.newBuffer([]);

    NearSignedTx.create = function create(properties) {
        return new NearSignedTx(properties);
    };

    NearSignedTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.signature);
        return writer;
    };

    NearSignedTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NearSignedTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NearSignedTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.signature = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        return message;
    };

    NearSignedTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NearSignedTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        return null;
    };

    NearSignedTx.fromObject = function fromObject(object) {
        if (object instanceof $root.NearSignedTx)
            return object;
        var message = new $root.NearSignedTx();
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        return message;
    };

    NearSignedTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        return object;
    };

    NearSignedTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NearSignedTx;
})();

$root.NEMGetAddress = (function() {

    function NEMGetAddress(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NEMGetAddress.prototype.address_n = $util.emptyArray;
    NEMGetAddress.prototype.network = 0;
    NEMGetAddress.prototype.show_display = false;

    NEMGetAddress.create = function create(properties) {
        return new NEMGetAddress(properties);
    };

    NEMGetAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.network != null && Object.hasOwnProperty.call(message, "network"))
            writer.uint32(16).uint32(message.network);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(24).bool(message.show_display);
        return writer;
    };

    NEMGetAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NEMGetAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NEMGetAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.network = reader.uint32();
                break;
            case 3:
                message.show_display = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    NEMGetAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NEMGetAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.network != null && message.hasOwnProperty("network"))
            if (!$util.isInteger(message.network))
                return "network: integer expected";
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        return null;
    };

    NEMGetAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.NEMGetAddress)
            return object;
        var message = new $root.NEMGetAddress();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".NEMGetAddress.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.network != null)
            message.network = object.network >>> 0;
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        return message;
    };

    NEMGetAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            object.network = 0;
            object.show_display = false;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.network != null && message.hasOwnProperty("network"))
            object.network = message.network;
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        return object;
    };

    NEMGetAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NEMGetAddress;
})();

$root.NEMAddress = (function() {

    function NEMAddress(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NEMAddress.prototype.address = "";

    NEMAddress.create = function create(properties) {
        return new NEMAddress(properties);
    };

    NEMAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.address);
        return writer;
    };

    NEMAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NEMAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NEMAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("address"))
            throw $util.ProtocolError("missing required 'address'", { instance: message });
        return message;
    };

    NEMAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NEMAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.address))
            return "address: string expected";
        return null;
    };

    NEMAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.NEMAddress)
            return object;
        var message = new $root.NEMAddress();
        if (object.address != null)
            message.address = String(object.address);
        return message;
    };

    NEMAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.address = "";
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    NEMAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NEMAddress;
})();

$root.NEMSignTx = (function() {

    function NEMSignTx(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NEMSignTx.prototype.transaction = null;
    NEMSignTx.prototype.multisig = null;
    NEMSignTx.prototype.transfer = null;
    NEMSignTx.prototype.cosigning = false;
    NEMSignTx.prototype.provision_namespace = null;
    NEMSignTx.prototype.mosaic_creation = null;
    NEMSignTx.prototype.supply_change = null;
    NEMSignTx.prototype.aggregate_modification = null;
    NEMSignTx.prototype.importance_transfer = null;

    NEMSignTx.create = function create(properties) {
        return new NEMSignTx(properties);
    };

    NEMSignTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.transaction != null && Object.hasOwnProperty.call(message, "transaction"))
            $root.NEMSignTx.NEMTransactionCommon.encode(message.transaction, writer.uint32(10).fork()).ldelim();
        if (message.multisig != null && Object.hasOwnProperty.call(message, "multisig"))
            $root.NEMSignTx.NEMTransactionCommon.encode(message.multisig, writer.uint32(18).fork()).ldelim();
        if (message.transfer != null && Object.hasOwnProperty.call(message, "transfer"))
            $root.NEMSignTx.NEMTransfer.encode(message.transfer, writer.uint32(26).fork()).ldelim();
        if (message.cosigning != null && Object.hasOwnProperty.call(message, "cosigning"))
            writer.uint32(32).bool(message.cosigning);
        if (message.provision_namespace != null && Object.hasOwnProperty.call(message, "provision_namespace"))
            $root.NEMSignTx.NEMProvisionNamespace.encode(message.provision_namespace, writer.uint32(42).fork()).ldelim();
        if (message.mosaic_creation != null && Object.hasOwnProperty.call(message, "mosaic_creation"))
            $root.NEMSignTx.NEMMosaicCreation.encode(message.mosaic_creation, writer.uint32(50).fork()).ldelim();
        if (message.supply_change != null && Object.hasOwnProperty.call(message, "supply_change"))
            $root.NEMSignTx.NEMMosaicSupplyChange.encode(message.supply_change, writer.uint32(58).fork()).ldelim();
        if (message.aggregate_modification != null && Object.hasOwnProperty.call(message, "aggregate_modification"))
            $root.NEMSignTx.NEMAggregateModification.encode(message.aggregate_modification, writer.uint32(66).fork()).ldelim();
        if (message.importance_transfer != null && Object.hasOwnProperty.call(message, "importance_transfer"))
            $root.NEMSignTx.NEMImportanceTransfer.encode(message.importance_transfer, writer.uint32(74).fork()).ldelim();
        return writer;
    };

    NEMSignTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NEMSignTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NEMSignTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.transaction = $root.NEMSignTx.NEMTransactionCommon.decode(reader, reader.uint32());
                break;
            case 2:
                message.multisig = $root.NEMSignTx.NEMTransactionCommon.decode(reader, reader.uint32());
                break;
            case 3:
                message.transfer = $root.NEMSignTx.NEMTransfer.decode(reader, reader.uint32());
                break;
            case 4:
                message.cosigning = reader.bool();
                break;
            case 5:
                message.provision_namespace = $root.NEMSignTx.NEMProvisionNamespace.decode(reader, reader.uint32());
                break;
            case 6:
                message.mosaic_creation = $root.NEMSignTx.NEMMosaicCreation.decode(reader, reader.uint32());
                break;
            case 7:
                message.supply_change = $root.NEMSignTx.NEMMosaicSupplyChange.decode(reader, reader.uint32());
                break;
            case 8:
                message.aggregate_modification = $root.NEMSignTx.NEMAggregateModification.decode(reader, reader.uint32());
                break;
            case 9:
                message.importance_transfer = $root.NEMSignTx.NEMImportanceTransfer.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    NEMSignTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NEMSignTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.transaction != null && message.hasOwnProperty("transaction")) {
            var error = $root.NEMSignTx.NEMTransactionCommon.verify(message.transaction);
            if (error)
                return "transaction." + error;
        }
        if (message.multisig != null && message.hasOwnProperty("multisig")) {
            var error = $root.NEMSignTx.NEMTransactionCommon.verify(message.multisig);
            if (error)
                return "multisig." + error;
        }
        if (message.transfer != null && message.hasOwnProperty("transfer")) {
            var error = $root.NEMSignTx.NEMTransfer.verify(message.transfer);
            if (error)
                return "transfer." + error;
        }
        if (message.cosigning != null && message.hasOwnProperty("cosigning"))
            if (typeof message.cosigning !== "boolean")
                return "cosigning: boolean expected";
        if (message.provision_namespace != null && message.hasOwnProperty("provision_namespace")) {
            var error = $root.NEMSignTx.NEMProvisionNamespace.verify(message.provision_namespace);
            if (error)
                return "provision_namespace." + error;
        }
        if (message.mosaic_creation != null && message.hasOwnProperty("mosaic_creation")) {
            var error = $root.NEMSignTx.NEMMosaicCreation.verify(message.mosaic_creation);
            if (error)
                return "mosaic_creation." + error;
        }
        if (message.supply_change != null && message.hasOwnProperty("supply_change")) {
            var error = $root.NEMSignTx.NEMMosaicSupplyChange.verify(message.supply_change);
            if (error)
                return "supply_change." + error;
        }
        if (message.aggregate_modification != null && message.hasOwnProperty("aggregate_modification")) {
            var error = $root.NEMSignTx.NEMAggregateModification.verify(message.aggregate_modification);
            if (error)
                return "aggregate_modification." + error;
        }
        if (message.importance_transfer != null && message.hasOwnProperty("importance_transfer")) {
            var error = $root.NEMSignTx.NEMImportanceTransfer.verify(message.importance_transfer);
            if (error)
                return "importance_transfer." + error;
        }
        return null;
    };

    NEMSignTx.fromObject = function fromObject(object) {
        if (object instanceof $root.NEMSignTx)
            return object;
        var message = new $root.NEMSignTx();
        if (object.transaction != null) {
            if (typeof object.transaction !== "object")
                throw TypeError(".NEMSignTx.transaction: object expected");
            message.transaction = $root.NEMSignTx.NEMTransactionCommon.fromObject(object.transaction);
        }
        if (object.multisig != null) {
            if (typeof object.multisig !== "object")
                throw TypeError(".NEMSignTx.multisig: object expected");
            message.multisig = $root.NEMSignTx.NEMTransactionCommon.fromObject(object.multisig);
        }
        if (object.transfer != null) {
            if (typeof object.transfer !== "object")
                throw TypeError(".NEMSignTx.transfer: object expected");
            message.transfer = $root.NEMSignTx.NEMTransfer.fromObject(object.transfer);
        }
        if (object.cosigning != null)
            message.cosigning = Boolean(object.cosigning);
        if (object.provision_namespace != null) {
            if (typeof object.provision_namespace !== "object")
                throw TypeError(".NEMSignTx.provision_namespace: object expected");
            message.provision_namespace = $root.NEMSignTx.NEMProvisionNamespace.fromObject(object.provision_namespace);
        }
        if (object.mosaic_creation != null) {
            if (typeof object.mosaic_creation !== "object")
                throw TypeError(".NEMSignTx.mosaic_creation: object expected");
            message.mosaic_creation = $root.NEMSignTx.NEMMosaicCreation.fromObject(object.mosaic_creation);
        }
        if (object.supply_change != null) {
            if (typeof object.supply_change !== "object")
                throw TypeError(".NEMSignTx.supply_change: object expected");
            message.supply_change = $root.NEMSignTx.NEMMosaicSupplyChange.fromObject(object.supply_change);
        }
        if (object.aggregate_modification != null) {
            if (typeof object.aggregate_modification !== "object")
                throw TypeError(".NEMSignTx.aggregate_modification: object expected");
            message.aggregate_modification = $root.NEMSignTx.NEMAggregateModification.fromObject(object.aggregate_modification);
        }
        if (object.importance_transfer != null) {
            if (typeof object.importance_transfer !== "object")
                throw TypeError(".NEMSignTx.importance_transfer: object expected");
            message.importance_transfer = $root.NEMSignTx.NEMImportanceTransfer.fromObject(object.importance_transfer);
        }
        return message;
    };

    NEMSignTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.transaction = null;
            object.multisig = null;
            object.transfer = null;
            object.cosigning = false;
            object.provision_namespace = null;
            object.mosaic_creation = null;
            object.supply_change = null;
            object.aggregate_modification = null;
            object.importance_transfer = null;
        }
        if (message.transaction != null && message.hasOwnProperty("transaction"))
            object.transaction = $root.NEMSignTx.NEMTransactionCommon.toObject(message.transaction, options);
        if (message.multisig != null && message.hasOwnProperty("multisig"))
            object.multisig = $root.NEMSignTx.NEMTransactionCommon.toObject(message.multisig, options);
        if (message.transfer != null && message.hasOwnProperty("transfer"))
            object.transfer = $root.NEMSignTx.NEMTransfer.toObject(message.transfer, options);
        if (message.cosigning != null && message.hasOwnProperty("cosigning"))
            object.cosigning = message.cosigning;
        if (message.provision_namespace != null && message.hasOwnProperty("provision_namespace"))
            object.provision_namespace = $root.NEMSignTx.NEMProvisionNamespace.toObject(message.provision_namespace, options);
        if (message.mosaic_creation != null && message.hasOwnProperty("mosaic_creation"))
            object.mosaic_creation = $root.NEMSignTx.NEMMosaicCreation.toObject(message.mosaic_creation, options);
        if (message.supply_change != null && message.hasOwnProperty("supply_change"))
            object.supply_change = $root.NEMSignTx.NEMMosaicSupplyChange.toObject(message.supply_change, options);
        if (message.aggregate_modification != null && message.hasOwnProperty("aggregate_modification"))
            object.aggregate_modification = $root.NEMSignTx.NEMAggregateModification.toObject(message.aggregate_modification, options);
        if (message.importance_transfer != null && message.hasOwnProperty("importance_transfer"))
            object.importance_transfer = $root.NEMSignTx.NEMImportanceTransfer.toObject(message.importance_transfer, options);
        return object;
    };

    NEMSignTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    NEMSignTx.NEMTransactionCommon = (function() {

        function NEMTransactionCommon(properties) {
            this.address_n = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        NEMTransactionCommon.prototype.address_n = $util.emptyArray;
        NEMTransactionCommon.prototype.network = 0;
        NEMTransactionCommon.prototype.timestamp = 0;
        NEMTransactionCommon.prototype.fee = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        NEMTransactionCommon.prototype.deadline = 0;
        NEMTransactionCommon.prototype.signer = $util.newBuffer([]);

        NEMTransactionCommon.create = function create(properties) {
            return new NEMTransactionCommon(properties);
        };

        NEMTransactionCommon.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.address_n != null && message.address_n.length)
                for (var i = 0; i < message.address_n.length; ++i)
                    writer.uint32(8).uint32(message.address_n[i]);
            if (message.network != null && Object.hasOwnProperty.call(message, "network"))
                writer.uint32(16).uint32(message.network);
            if (message.timestamp != null && Object.hasOwnProperty.call(message, "timestamp"))
                writer.uint32(24).uint32(message.timestamp);
            if (message.fee != null && Object.hasOwnProperty.call(message, "fee"))
                writer.uint32(32).uint64(message.fee);
            if (message.deadline != null && Object.hasOwnProperty.call(message, "deadline"))
                writer.uint32(40).uint32(message.deadline);
            if (message.signer != null && Object.hasOwnProperty.call(message, "signer"))
                writer.uint32(50).bytes(message.signer);
            return writer;
        };

        NEMTransactionCommon.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        NEMTransactionCommon.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NEMSignTx.NEMTransactionCommon();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.address_n && message.address_n.length))
                        message.address_n = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.address_n.push(reader.uint32());
                    } else
                        message.address_n.push(reader.uint32());
                    break;
                case 2:
                    message.network = reader.uint32();
                    break;
                case 3:
                    message.timestamp = reader.uint32();
                    break;
                case 4:
                    message.fee = reader.uint64();
                    break;
                case 5:
                    message.deadline = reader.uint32();
                    break;
                case 6:
                    message.signer = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        NEMTransactionCommon.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        NEMTransactionCommon.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.address_n != null && message.hasOwnProperty("address_n")) {
                if (!Array.isArray(message.address_n))
                    return "address_n: array expected";
                for (var i = 0; i < message.address_n.length; ++i)
                    if (!$util.isInteger(message.address_n[i]))
                        return "address_n: integer[] expected";
            }
            if (message.network != null && message.hasOwnProperty("network"))
                if (!$util.isInteger(message.network))
                    return "network: integer expected";
            if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                if (!$util.isInteger(message.timestamp))
                    return "timestamp: integer expected";
            if (message.fee != null && message.hasOwnProperty("fee"))
                if (!$util.isInteger(message.fee) && !(message.fee && $util.isInteger(message.fee.low) && $util.isInteger(message.fee.high)))
                    return "fee: integer|Long expected";
            if (message.deadline != null && message.hasOwnProperty("deadline"))
                if (!$util.isInteger(message.deadline))
                    return "deadline: integer expected";
            if (message.signer != null && message.hasOwnProperty("signer"))
                if (!(message.signer && typeof message.signer.length === "number" || $util.isString(message.signer)))
                    return "signer: buffer expected";
            return null;
        };

        NEMTransactionCommon.fromObject = function fromObject(object) {
            if (object instanceof $root.NEMSignTx.NEMTransactionCommon)
                return object;
            var message = new $root.NEMSignTx.NEMTransactionCommon();
            if (object.address_n) {
                if (!Array.isArray(object.address_n))
                    throw TypeError(".NEMSignTx.NEMTransactionCommon.address_n: array expected");
                message.address_n = [];
                for (var i = 0; i < object.address_n.length; ++i)
                    message.address_n[i] = object.address_n[i] >>> 0;
            }
            if (object.network != null)
                message.network = object.network >>> 0;
            if (object.timestamp != null)
                message.timestamp = object.timestamp >>> 0;
            if (object.fee != null)
                if ($util.Long)
                    (message.fee = $util.Long.fromValue(object.fee)).unsigned = true;
                else if (typeof object.fee === "string")
                    message.fee = parseInt(object.fee, 10);
                else if (typeof object.fee === "number")
                    message.fee = object.fee;
                else if (typeof object.fee === "object")
                    message.fee = new $util.LongBits(object.fee.low >>> 0, object.fee.high >>> 0).toNumber(true);
            if (object.deadline != null)
                message.deadline = object.deadline >>> 0;
            if (object.signer != null)
                if (typeof object.signer === "string")
                    $util.base64.decode(object.signer, message.signer = $util.newBuffer($util.base64.length(object.signer)), 0);
                else if (object.signer.length)
                    message.signer = object.signer;
            return message;
        };

        NEMTransactionCommon.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.address_n = [];
            if (options.defaults) {
                object.network = 0;
                object.timestamp = 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.fee = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.fee = options.longs === String ? "0" : 0;
                object.deadline = 0;
                if (options.bytes === String)
                    object.signer = "";
                else {
                    object.signer = [];
                    if (options.bytes !== Array)
                        object.signer = $util.newBuffer(object.signer);
                }
            }
            if (message.address_n && message.address_n.length) {
                object.address_n = [];
                for (var j = 0; j < message.address_n.length; ++j)
                    object.address_n[j] = message.address_n[j];
            }
            if (message.network != null && message.hasOwnProperty("network"))
                object.network = message.network;
            if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                object.timestamp = message.timestamp;
            if (message.fee != null && message.hasOwnProperty("fee"))
                if (typeof message.fee === "number")
                    object.fee = options.longs === String ? String(message.fee) : message.fee;
                else
                    object.fee = options.longs === String ? $util.Long.prototype.toString.call(message.fee) : options.longs === Number ? new $util.LongBits(message.fee.low >>> 0, message.fee.high >>> 0).toNumber(true) : message.fee;
            if (message.deadline != null && message.hasOwnProperty("deadline"))
                object.deadline = message.deadline;
            if (message.signer != null && message.hasOwnProperty("signer"))
                object.signer = options.bytes === String ? $util.base64.encode(message.signer, 0, message.signer.length) : options.bytes === Array ? Array.prototype.slice.call(message.signer) : message.signer;
            return object;
        };

        NEMTransactionCommon.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return NEMTransactionCommon;
    })();

    NEMSignTx.NEMTransfer = (function() {

        function NEMTransfer(properties) {
            this.mosaics = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        NEMTransfer.prototype.recipient = "";
        NEMTransfer.prototype.amount = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        NEMTransfer.prototype.payload = $util.newBuffer([]);
        NEMTransfer.prototype.public_key = $util.newBuffer([]);
        NEMTransfer.prototype.mosaics = $util.emptyArray;

        NEMTransfer.create = function create(properties) {
            return new NEMTransfer(properties);
        };

        NEMTransfer.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.recipient != null && Object.hasOwnProperty.call(message, "recipient"))
                writer.uint32(10).string(message.recipient);
            if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
                writer.uint32(16).uint64(message.amount);
            if (message.payload != null && Object.hasOwnProperty.call(message, "payload"))
                writer.uint32(26).bytes(message.payload);
            if (message.public_key != null && Object.hasOwnProperty.call(message, "public_key"))
                writer.uint32(34).bytes(message.public_key);
            if (message.mosaics != null && message.mosaics.length)
                for (var i = 0; i < message.mosaics.length; ++i)
                    $root.NEMSignTx.NEMTransfer.NEMMosaic.encode(message.mosaics[i], writer.uint32(42).fork()).ldelim();
            return writer;
        };

        NEMTransfer.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        NEMTransfer.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NEMSignTx.NEMTransfer();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.recipient = reader.string();
                    break;
                case 2:
                    message.amount = reader.uint64();
                    break;
                case 3:
                    message.payload = reader.bytes();
                    break;
                case 4:
                    message.public_key = reader.bytes();
                    break;
                case 5:
                    if (!(message.mosaics && message.mosaics.length))
                        message.mosaics = [];
                    message.mosaics.push($root.NEMSignTx.NEMTransfer.NEMMosaic.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        NEMTransfer.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        NEMTransfer.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.recipient != null && message.hasOwnProperty("recipient"))
                if (!$util.isString(message.recipient))
                    return "recipient: string expected";
            if (message.amount != null && message.hasOwnProperty("amount"))
                if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
                    return "amount: integer|Long expected";
            if (message.payload != null && message.hasOwnProperty("payload"))
                if (!(message.payload && typeof message.payload.length === "number" || $util.isString(message.payload)))
                    return "payload: buffer expected";
            if (message.public_key != null && message.hasOwnProperty("public_key"))
                if (!(message.public_key && typeof message.public_key.length === "number" || $util.isString(message.public_key)))
                    return "public_key: buffer expected";
            if (message.mosaics != null && message.hasOwnProperty("mosaics")) {
                if (!Array.isArray(message.mosaics))
                    return "mosaics: array expected";
                for (var i = 0; i < message.mosaics.length; ++i) {
                    var error = $root.NEMSignTx.NEMTransfer.NEMMosaic.verify(message.mosaics[i]);
                    if (error)
                        return "mosaics." + error;
                }
            }
            return null;
        };

        NEMTransfer.fromObject = function fromObject(object) {
            if (object instanceof $root.NEMSignTx.NEMTransfer)
                return object;
            var message = new $root.NEMSignTx.NEMTransfer();
            if (object.recipient != null)
                message.recipient = String(object.recipient);
            if (object.amount != null)
                if ($util.Long)
                    (message.amount = $util.Long.fromValue(object.amount)).unsigned = true;
                else if (typeof object.amount === "string")
                    message.amount = parseInt(object.amount, 10);
                else if (typeof object.amount === "number")
                    message.amount = object.amount;
                else if (typeof object.amount === "object")
                    message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber(true);
            if (object.payload != null)
                if (typeof object.payload === "string")
                    $util.base64.decode(object.payload, message.payload = $util.newBuffer($util.base64.length(object.payload)), 0);
                else if (object.payload.length)
                    message.payload = object.payload;
            if (object.public_key != null)
                if (typeof object.public_key === "string")
                    $util.base64.decode(object.public_key, message.public_key = $util.newBuffer($util.base64.length(object.public_key)), 0);
                else if (object.public_key.length)
                    message.public_key = object.public_key;
            if (object.mosaics) {
                if (!Array.isArray(object.mosaics))
                    throw TypeError(".NEMSignTx.NEMTransfer.mosaics: array expected");
                message.mosaics = [];
                for (var i = 0; i < object.mosaics.length; ++i) {
                    if (typeof object.mosaics[i] !== "object")
                        throw TypeError(".NEMSignTx.NEMTransfer.mosaics: object expected");
                    message.mosaics[i] = $root.NEMSignTx.NEMTransfer.NEMMosaic.fromObject(object.mosaics[i]);
                }
            }
            return message;
        };

        NEMTransfer.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.mosaics = [];
            if (options.defaults) {
                object.recipient = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.amount = options.longs === String ? "0" : 0;
                if (options.bytes === String)
                    object.payload = "";
                else {
                    object.payload = [];
                    if (options.bytes !== Array)
                        object.payload = $util.newBuffer(object.payload);
                }
                if (options.bytes === String)
                    object.public_key = "";
                else {
                    object.public_key = [];
                    if (options.bytes !== Array)
                        object.public_key = $util.newBuffer(object.public_key);
                }
            }
            if (message.recipient != null && message.hasOwnProperty("recipient"))
                object.recipient = message.recipient;
            if (message.amount != null && message.hasOwnProperty("amount"))
                if (typeof message.amount === "number")
                    object.amount = options.longs === String ? String(message.amount) : message.amount;
                else
                    object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber(true) : message.amount;
            if (message.payload != null && message.hasOwnProperty("payload"))
                object.payload = options.bytes === String ? $util.base64.encode(message.payload, 0, message.payload.length) : options.bytes === Array ? Array.prototype.slice.call(message.payload) : message.payload;
            if (message.public_key != null && message.hasOwnProperty("public_key"))
                object.public_key = options.bytes === String ? $util.base64.encode(message.public_key, 0, message.public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.public_key) : message.public_key;
            if (message.mosaics && message.mosaics.length) {
                object.mosaics = [];
                for (var j = 0; j < message.mosaics.length; ++j)
                    object.mosaics[j] = $root.NEMSignTx.NEMTransfer.NEMMosaic.toObject(message.mosaics[j], options);
            }
            return object;
        };

        NEMTransfer.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        NEMTransfer.NEMMosaic = (function() {

            function NEMMosaic(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            NEMMosaic.prototype.namespace = "";
            NEMMosaic.prototype.mosaic = "";
            NEMMosaic.prototype.quantity = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

            NEMMosaic.create = function create(properties) {
                return new NEMMosaic(properties);
            };

            NEMMosaic.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.namespace != null && Object.hasOwnProperty.call(message, "namespace"))
                    writer.uint32(10).string(message.namespace);
                if (message.mosaic != null && Object.hasOwnProperty.call(message, "mosaic"))
                    writer.uint32(18).string(message.mosaic);
                if (message.quantity != null && Object.hasOwnProperty.call(message, "quantity"))
                    writer.uint32(24).uint64(message.quantity);
                return writer;
            };

            NEMMosaic.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            NEMMosaic.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NEMSignTx.NEMTransfer.NEMMosaic();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.namespace = reader.string();
                        break;
                    case 2:
                        message.mosaic = reader.string();
                        break;
                    case 3:
                        message.quantity = reader.uint64();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            NEMMosaic.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            NEMMosaic.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.namespace != null && message.hasOwnProperty("namespace"))
                    if (!$util.isString(message.namespace))
                        return "namespace: string expected";
                if (message.mosaic != null && message.hasOwnProperty("mosaic"))
                    if (!$util.isString(message.mosaic))
                        return "mosaic: string expected";
                if (message.quantity != null && message.hasOwnProperty("quantity"))
                    if (!$util.isInteger(message.quantity) && !(message.quantity && $util.isInteger(message.quantity.low) && $util.isInteger(message.quantity.high)))
                        return "quantity: integer|Long expected";
                return null;
            };

            NEMMosaic.fromObject = function fromObject(object) {
                if (object instanceof $root.NEMSignTx.NEMTransfer.NEMMosaic)
                    return object;
                var message = new $root.NEMSignTx.NEMTransfer.NEMMosaic();
                if (object.namespace != null)
                    message.namespace = String(object.namespace);
                if (object.mosaic != null)
                    message.mosaic = String(object.mosaic);
                if (object.quantity != null)
                    if ($util.Long)
                        (message.quantity = $util.Long.fromValue(object.quantity)).unsigned = true;
                    else if (typeof object.quantity === "string")
                        message.quantity = parseInt(object.quantity, 10);
                    else if (typeof object.quantity === "number")
                        message.quantity = object.quantity;
                    else if (typeof object.quantity === "object")
                        message.quantity = new $util.LongBits(object.quantity.low >>> 0, object.quantity.high >>> 0).toNumber(true);
                return message;
            };

            NEMMosaic.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.namespace = "";
                    object.mosaic = "";
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, true);
                        object.quantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.quantity = options.longs === String ? "0" : 0;
                }
                if (message.namespace != null && message.hasOwnProperty("namespace"))
                    object.namespace = message.namespace;
                if (message.mosaic != null && message.hasOwnProperty("mosaic"))
                    object.mosaic = message.mosaic;
                if (message.quantity != null && message.hasOwnProperty("quantity"))
                    if (typeof message.quantity === "number")
                        object.quantity = options.longs === String ? String(message.quantity) : message.quantity;
                    else
                        object.quantity = options.longs === String ? $util.Long.prototype.toString.call(message.quantity) : options.longs === Number ? new $util.LongBits(message.quantity.low >>> 0, message.quantity.high >>> 0).toNumber(true) : message.quantity;
                return object;
            };

            NEMMosaic.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return NEMMosaic;
        })();

        return NEMTransfer;
    })();

    NEMSignTx.NEMProvisionNamespace = (function() {

        function NEMProvisionNamespace(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        NEMProvisionNamespace.prototype.namespace = "";
        NEMProvisionNamespace.prototype.parent = "";
        NEMProvisionNamespace.prototype.sink = "";
        NEMProvisionNamespace.prototype.fee = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        NEMProvisionNamespace.create = function create(properties) {
            return new NEMProvisionNamespace(properties);
        };

        NEMProvisionNamespace.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.namespace != null && Object.hasOwnProperty.call(message, "namespace"))
                writer.uint32(10).string(message.namespace);
            if (message.parent != null && Object.hasOwnProperty.call(message, "parent"))
                writer.uint32(18).string(message.parent);
            if (message.sink != null && Object.hasOwnProperty.call(message, "sink"))
                writer.uint32(26).string(message.sink);
            if (message.fee != null && Object.hasOwnProperty.call(message, "fee"))
                writer.uint32(32).uint64(message.fee);
            return writer;
        };

        NEMProvisionNamespace.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        NEMProvisionNamespace.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NEMSignTx.NEMProvisionNamespace();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.namespace = reader.string();
                    break;
                case 2:
                    message.parent = reader.string();
                    break;
                case 3:
                    message.sink = reader.string();
                    break;
                case 4:
                    message.fee = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        NEMProvisionNamespace.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        NEMProvisionNamespace.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.namespace != null && message.hasOwnProperty("namespace"))
                if (!$util.isString(message.namespace))
                    return "namespace: string expected";
            if (message.parent != null && message.hasOwnProperty("parent"))
                if (!$util.isString(message.parent))
                    return "parent: string expected";
            if (message.sink != null && message.hasOwnProperty("sink"))
                if (!$util.isString(message.sink))
                    return "sink: string expected";
            if (message.fee != null && message.hasOwnProperty("fee"))
                if (!$util.isInteger(message.fee) && !(message.fee && $util.isInteger(message.fee.low) && $util.isInteger(message.fee.high)))
                    return "fee: integer|Long expected";
            return null;
        };

        NEMProvisionNamespace.fromObject = function fromObject(object) {
            if (object instanceof $root.NEMSignTx.NEMProvisionNamespace)
                return object;
            var message = new $root.NEMSignTx.NEMProvisionNamespace();
            if (object.namespace != null)
                message.namespace = String(object.namespace);
            if (object.parent != null)
                message.parent = String(object.parent);
            if (object.sink != null)
                message.sink = String(object.sink);
            if (object.fee != null)
                if ($util.Long)
                    (message.fee = $util.Long.fromValue(object.fee)).unsigned = true;
                else if (typeof object.fee === "string")
                    message.fee = parseInt(object.fee, 10);
                else if (typeof object.fee === "number")
                    message.fee = object.fee;
                else if (typeof object.fee === "object")
                    message.fee = new $util.LongBits(object.fee.low >>> 0, object.fee.high >>> 0).toNumber(true);
            return message;
        };

        NEMProvisionNamespace.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.namespace = "";
                object.parent = "";
                object.sink = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.fee = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.fee = options.longs === String ? "0" : 0;
            }
            if (message.namespace != null && message.hasOwnProperty("namespace"))
                object.namespace = message.namespace;
            if (message.parent != null && message.hasOwnProperty("parent"))
                object.parent = message.parent;
            if (message.sink != null && message.hasOwnProperty("sink"))
                object.sink = message.sink;
            if (message.fee != null && message.hasOwnProperty("fee"))
                if (typeof message.fee === "number")
                    object.fee = options.longs === String ? String(message.fee) : message.fee;
                else
                    object.fee = options.longs === String ? $util.Long.prototype.toString.call(message.fee) : options.longs === Number ? new $util.LongBits(message.fee.low >>> 0, message.fee.high >>> 0).toNumber(true) : message.fee;
            return object;
        };

        NEMProvisionNamespace.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return NEMProvisionNamespace;
    })();

    NEMSignTx.NEMMosaicCreation = (function() {

        function NEMMosaicCreation(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        NEMMosaicCreation.prototype.definition = null;
        NEMMosaicCreation.prototype.sink = "";
        NEMMosaicCreation.prototype.fee = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        NEMMosaicCreation.create = function create(properties) {
            return new NEMMosaicCreation(properties);
        };

        NEMMosaicCreation.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.definition != null && Object.hasOwnProperty.call(message, "definition"))
                $root.NEMSignTx.NEMMosaicCreation.NEMMosaicDefinition.encode(message.definition, writer.uint32(10).fork()).ldelim();
            if (message.sink != null && Object.hasOwnProperty.call(message, "sink"))
                writer.uint32(18).string(message.sink);
            if (message.fee != null && Object.hasOwnProperty.call(message, "fee"))
                writer.uint32(24).uint64(message.fee);
            return writer;
        };

        NEMMosaicCreation.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        NEMMosaicCreation.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NEMSignTx.NEMMosaicCreation();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.definition = $root.NEMSignTx.NEMMosaicCreation.NEMMosaicDefinition.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.sink = reader.string();
                    break;
                case 3:
                    message.fee = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        NEMMosaicCreation.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        NEMMosaicCreation.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.definition != null && message.hasOwnProperty("definition")) {
                var error = $root.NEMSignTx.NEMMosaicCreation.NEMMosaicDefinition.verify(message.definition);
                if (error)
                    return "definition." + error;
            }
            if (message.sink != null && message.hasOwnProperty("sink"))
                if (!$util.isString(message.sink))
                    return "sink: string expected";
            if (message.fee != null && message.hasOwnProperty("fee"))
                if (!$util.isInteger(message.fee) && !(message.fee && $util.isInteger(message.fee.low) && $util.isInteger(message.fee.high)))
                    return "fee: integer|Long expected";
            return null;
        };

        NEMMosaicCreation.fromObject = function fromObject(object) {
            if (object instanceof $root.NEMSignTx.NEMMosaicCreation)
                return object;
            var message = new $root.NEMSignTx.NEMMosaicCreation();
            if (object.definition != null) {
                if (typeof object.definition !== "object")
                    throw TypeError(".NEMSignTx.NEMMosaicCreation.definition: object expected");
                message.definition = $root.NEMSignTx.NEMMosaicCreation.NEMMosaicDefinition.fromObject(object.definition);
            }
            if (object.sink != null)
                message.sink = String(object.sink);
            if (object.fee != null)
                if ($util.Long)
                    (message.fee = $util.Long.fromValue(object.fee)).unsigned = true;
                else if (typeof object.fee === "string")
                    message.fee = parseInt(object.fee, 10);
                else if (typeof object.fee === "number")
                    message.fee = object.fee;
                else if (typeof object.fee === "object")
                    message.fee = new $util.LongBits(object.fee.low >>> 0, object.fee.high >>> 0).toNumber(true);
            return message;
        };

        NEMMosaicCreation.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.definition = null;
                object.sink = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.fee = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.fee = options.longs === String ? "0" : 0;
            }
            if (message.definition != null && message.hasOwnProperty("definition"))
                object.definition = $root.NEMSignTx.NEMMosaicCreation.NEMMosaicDefinition.toObject(message.definition, options);
            if (message.sink != null && message.hasOwnProperty("sink"))
                object.sink = message.sink;
            if (message.fee != null && message.hasOwnProperty("fee"))
                if (typeof message.fee === "number")
                    object.fee = options.longs === String ? String(message.fee) : message.fee;
                else
                    object.fee = options.longs === String ? $util.Long.prototype.toString.call(message.fee) : options.longs === Number ? new $util.LongBits(message.fee.low >>> 0, message.fee.high >>> 0).toNumber(true) : message.fee;
            return object;
        };

        NEMMosaicCreation.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        NEMMosaicCreation.NEMMosaicDefinition = (function() {

            function NEMMosaicDefinition(properties) {
                this.networks = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            NEMMosaicDefinition.prototype.name = "";
            NEMMosaicDefinition.prototype.ticker = "";
            NEMMosaicDefinition.prototype.namespace = "";
            NEMMosaicDefinition.prototype.mosaic = "";
            NEMMosaicDefinition.prototype.divisibility = 0;
            NEMMosaicDefinition.prototype.levy = 1;
            NEMMosaicDefinition.prototype.fee = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
            NEMMosaicDefinition.prototype.levy_address = "";
            NEMMosaicDefinition.prototype.levy_namespace = "";
            NEMMosaicDefinition.prototype.levy_mosaic = "";
            NEMMosaicDefinition.prototype.supply = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
            NEMMosaicDefinition.prototype.mutable_supply = false;
            NEMMosaicDefinition.prototype.transferable = false;
            NEMMosaicDefinition.prototype.description = "";
            NEMMosaicDefinition.prototype.networks = $util.emptyArray;

            NEMMosaicDefinition.create = function create(properties) {
                return new NEMMosaicDefinition(properties);
            };

            NEMMosaicDefinition.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                    writer.uint32(10).string(message.name);
                if (message.ticker != null && Object.hasOwnProperty.call(message, "ticker"))
                    writer.uint32(18).string(message.ticker);
                if (message.namespace != null && Object.hasOwnProperty.call(message, "namespace"))
                    writer.uint32(26).string(message.namespace);
                if (message.mosaic != null && Object.hasOwnProperty.call(message, "mosaic"))
                    writer.uint32(34).string(message.mosaic);
                if (message.divisibility != null && Object.hasOwnProperty.call(message, "divisibility"))
                    writer.uint32(40).uint32(message.divisibility);
                if (message.levy != null && Object.hasOwnProperty.call(message, "levy"))
                    writer.uint32(48).int32(message.levy);
                if (message.fee != null && Object.hasOwnProperty.call(message, "fee"))
                    writer.uint32(56).uint64(message.fee);
                if (message.levy_address != null && Object.hasOwnProperty.call(message, "levy_address"))
                    writer.uint32(66).string(message.levy_address);
                if (message.levy_namespace != null && Object.hasOwnProperty.call(message, "levy_namespace"))
                    writer.uint32(74).string(message.levy_namespace);
                if (message.levy_mosaic != null && Object.hasOwnProperty.call(message, "levy_mosaic"))
                    writer.uint32(82).string(message.levy_mosaic);
                if (message.supply != null && Object.hasOwnProperty.call(message, "supply"))
                    writer.uint32(88).uint64(message.supply);
                if (message.mutable_supply != null && Object.hasOwnProperty.call(message, "mutable_supply"))
                    writer.uint32(96).bool(message.mutable_supply);
                if (message.transferable != null && Object.hasOwnProperty.call(message, "transferable"))
                    writer.uint32(104).bool(message.transferable);
                if (message.description != null && Object.hasOwnProperty.call(message, "description"))
                    writer.uint32(114).string(message.description);
                if (message.networks != null && message.networks.length)
                    for (var i = 0; i < message.networks.length; ++i)
                        writer.uint32(120).uint32(message.networks[i]);
                return writer;
            };

            NEMMosaicDefinition.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            NEMMosaicDefinition.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NEMSignTx.NEMMosaicCreation.NEMMosaicDefinition();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.name = reader.string();
                        break;
                    case 2:
                        message.ticker = reader.string();
                        break;
                    case 3:
                        message.namespace = reader.string();
                        break;
                    case 4:
                        message.mosaic = reader.string();
                        break;
                    case 5:
                        message.divisibility = reader.uint32();
                        break;
                    case 6:
                        message.levy = reader.int32();
                        break;
                    case 7:
                        message.fee = reader.uint64();
                        break;
                    case 8:
                        message.levy_address = reader.string();
                        break;
                    case 9:
                        message.levy_namespace = reader.string();
                        break;
                    case 10:
                        message.levy_mosaic = reader.string();
                        break;
                    case 11:
                        message.supply = reader.uint64();
                        break;
                    case 12:
                        message.mutable_supply = reader.bool();
                        break;
                    case 13:
                        message.transferable = reader.bool();
                        break;
                    case 14:
                        message.description = reader.string();
                        break;
                    case 15:
                        if (!(message.networks && message.networks.length))
                            message.networks = [];
                        if ((tag & 7) === 2) {
                            var end2 = reader.uint32() + reader.pos;
                            while (reader.pos < end2)
                                message.networks.push(reader.uint32());
                        } else
                            message.networks.push(reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            NEMMosaicDefinition.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            NEMMosaicDefinition.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.name != null && message.hasOwnProperty("name"))
                    if (!$util.isString(message.name))
                        return "name: string expected";
                if (message.ticker != null && message.hasOwnProperty("ticker"))
                    if (!$util.isString(message.ticker))
                        return "ticker: string expected";
                if (message.namespace != null && message.hasOwnProperty("namespace"))
                    if (!$util.isString(message.namespace))
                        return "namespace: string expected";
                if (message.mosaic != null && message.hasOwnProperty("mosaic"))
                    if (!$util.isString(message.mosaic))
                        return "mosaic: string expected";
                if (message.divisibility != null && message.hasOwnProperty("divisibility"))
                    if (!$util.isInteger(message.divisibility))
                        return "divisibility: integer expected";
                if (message.levy != null && message.hasOwnProperty("levy"))
                    switch (message.levy) {
                    default:
                        return "levy: enum value expected";
                    case 1:
                    case 2:
                        break;
                    }
                if (message.fee != null && message.hasOwnProperty("fee"))
                    if (!$util.isInteger(message.fee) && !(message.fee && $util.isInteger(message.fee.low) && $util.isInteger(message.fee.high)))
                        return "fee: integer|Long expected";
                if (message.levy_address != null && message.hasOwnProperty("levy_address"))
                    if (!$util.isString(message.levy_address))
                        return "levy_address: string expected";
                if (message.levy_namespace != null && message.hasOwnProperty("levy_namespace"))
                    if (!$util.isString(message.levy_namespace))
                        return "levy_namespace: string expected";
                if (message.levy_mosaic != null && message.hasOwnProperty("levy_mosaic"))
                    if (!$util.isString(message.levy_mosaic))
                        return "levy_mosaic: string expected";
                if (message.supply != null && message.hasOwnProperty("supply"))
                    if (!$util.isInteger(message.supply) && !(message.supply && $util.isInteger(message.supply.low) && $util.isInteger(message.supply.high)))
                        return "supply: integer|Long expected";
                if (message.mutable_supply != null && message.hasOwnProperty("mutable_supply"))
                    if (typeof message.mutable_supply !== "boolean")
                        return "mutable_supply: boolean expected";
                if (message.transferable != null && message.hasOwnProperty("transferable"))
                    if (typeof message.transferable !== "boolean")
                        return "transferable: boolean expected";
                if (message.description != null && message.hasOwnProperty("description"))
                    if (!$util.isString(message.description))
                        return "description: string expected";
                if (message.networks != null && message.hasOwnProperty("networks")) {
                    if (!Array.isArray(message.networks))
                        return "networks: array expected";
                    for (var i = 0; i < message.networks.length; ++i)
                        if (!$util.isInteger(message.networks[i]))
                            return "networks: integer[] expected";
                }
                return null;
            };

            NEMMosaicDefinition.fromObject = function fromObject(object) {
                if (object instanceof $root.NEMSignTx.NEMMosaicCreation.NEMMosaicDefinition)
                    return object;
                var message = new $root.NEMSignTx.NEMMosaicCreation.NEMMosaicDefinition();
                if (object.name != null)
                    message.name = String(object.name);
                if (object.ticker != null)
                    message.ticker = String(object.ticker);
                if (object.namespace != null)
                    message.namespace = String(object.namespace);
                if (object.mosaic != null)
                    message.mosaic = String(object.mosaic);
                if (object.divisibility != null)
                    message.divisibility = object.divisibility >>> 0;
                switch (object.levy) {
                case "MosaicLevy_Absolute":
                case 1:
                    message.levy = 1;
                    break;
                case "MosaicLevy_Percentile":
                case 2:
                    message.levy = 2;
                    break;
                }
                if (object.fee != null)
                    if ($util.Long)
                        (message.fee = $util.Long.fromValue(object.fee)).unsigned = true;
                    else if (typeof object.fee === "string")
                        message.fee = parseInt(object.fee, 10);
                    else if (typeof object.fee === "number")
                        message.fee = object.fee;
                    else if (typeof object.fee === "object")
                        message.fee = new $util.LongBits(object.fee.low >>> 0, object.fee.high >>> 0).toNumber(true);
                if (object.levy_address != null)
                    message.levy_address = String(object.levy_address);
                if (object.levy_namespace != null)
                    message.levy_namespace = String(object.levy_namespace);
                if (object.levy_mosaic != null)
                    message.levy_mosaic = String(object.levy_mosaic);
                if (object.supply != null)
                    if ($util.Long)
                        (message.supply = $util.Long.fromValue(object.supply)).unsigned = true;
                    else if (typeof object.supply === "string")
                        message.supply = parseInt(object.supply, 10);
                    else if (typeof object.supply === "number")
                        message.supply = object.supply;
                    else if (typeof object.supply === "object")
                        message.supply = new $util.LongBits(object.supply.low >>> 0, object.supply.high >>> 0).toNumber(true);
                if (object.mutable_supply != null)
                    message.mutable_supply = Boolean(object.mutable_supply);
                if (object.transferable != null)
                    message.transferable = Boolean(object.transferable);
                if (object.description != null)
                    message.description = String(object.description);
                if (object.networks) {
                    if (!Array.isArray(object.networks))
                        throw TypeError(".NEMSignTx.NEMMosaicCreation.NEMMosaicDefinition.networks: array expected");
                    message.networks = [];
                    for (var i = 0; i < object.networks.length; ++i)
                        message.networks[i] = object.networks[i] >>> 0;
                }
                return message;
            };

            NEMMosaicDefinition.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.networks = [];
                if (options.defaults) {
                    object.name = "";
                    object.ticker = "";
                    object.namespace = "";
                    object.mosaic = "";
                    object.divisibility = 0;
                    object.levy = options.enums === String ? "MosaicLevy_Absolute" : 1;
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, true);
                        object.fee = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.fee = options.longs === String ? "0" : 0;
                    object.levy_address = "";
                    object.levy_namespace = "";
                    object.levy_mosaic = "";
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, true);
                        object.supply = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.supply = options.longs === String ? "0" : 0;
                    object.mutable_supply = false;
                    object.transferable = false;
                    object.description = "";
                }
                if (message.name != null && message.hasOwnProperty("name"))
                    object.name = message.name;
                if (message.ticker != null && message.hasOwnProperty("ticker"))
                    object.ticker = message.ticker;
                if (message.namespace != null && message.hasOwnProperty("namespace"))
                    object.namespace = message.namespace;
                if (message.mosaic != null && message.hasOwnProperty("mosaic"))
                    object.mosaic = message.mosaic;
                if (message.divisibility != null && message.hasOwnProperty("divisibility"))
                    object.divisibility = message.divisibility;
                if (message.levy != null && message.hasOwnProperty("levy"))
                    object.levy = options.enums === String ? $root.NEMSignTx.NEMMosaicCreation.NEMMosaicDefinition.NEMMosaicLevy[message.levy] : message.levy;
                if (message.fee != null && message.hasOwnProperty("fee"))
                    if (typeof message.fee === "number")
                        object.fee = options.longs === String ? String(message.fee) : message.fee;
                    else
                        object.fee = options.longs === String ? $util.Long.prototype.toString.call(message.fee) : options.longs === Number ? new $util.LongBits(message.fee.low >>> 0, message.fee.high >>> 0).toNumber(true) : message.fee;
                if (message.levy_address != null && message.hasOwnProperty("levy_address"))
                    object.levy_address = message.levy_address;
                if (message.levy_namespace != null && message.hasOwnProperty("levy_namespace"))
                    object.levy_namespace = message.levy_namespace;
                if (message.levy_mosaic != null && message.hasOwnProperty("levy_mosaic"))
                    object.levy_mosaic = message.levy_mosaic;
                if (message.supply != null && message.hasOwnProperty("supply"))
                    if (typeof message.supply === "number")
                        object.supply = options.longs === String ? String(message.supply) : message.supply;
                    else
                        object.supply = options.longs === String ? $util.Long.prototype.toString.call(message.supply) : options.longs === Number ? new $util.LongBits(message.supply.low >>> 0, message.supply.high >>> 0).toNumber(true) : message.supply;
                if (message.mutable_supply != null && message.hasOwnProperty("mutable_supply"))
                    object.mutable_supply = message.mutable_supply;
                if (message.transferable != null && message.hasOwnProperty("transferable"))
                    object.transferable = message.transferable;
                if (message.description != null && message.hasOwnProperty("description"))
                    object.description = message.description;
                if (message.networks && message.networks.length) {
                    object.networks = [];
                    for (var j = 0; j < message.networks.length; ++j)
                        object.networks[j] = message.networks[j];
                }
                return object;
            };

            NEMMosaicDefinition.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            NEMMosaicDefinition.NEMMosaicLevy = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[1] = "MosaicLevy_Absolute"] = 1;
                values[valuesById[2] = "MosaicLevy_Percentile"] = 2;
                return values;
            })();

            return NEMMosaicDefinition;
        })();

        return NEMMosaicCreation;
    })();

    NEMSignTx.NEMMosaicSupplyChange = (function() {

        function NEMMosaicSupplyChange(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        NEMMosaicSupplyChange.prototype.namespace = "";
        NEMMosaicSupplyChange.prototype.mosaic = "";
        NEMMosaicSupplyChange.prototype.type = 1;
        NEMMosaicSupplyChange.prototype.delta = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        NEMMosaicSupplyChange.create = function create(properties) {
            return new NEMMosaicSupplyChange(properties);
        };

        NEMMosaicSupplyChange.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.namespace != null && Object.hasOwnProperty.call(message, "namespace"))
                writer.uint32(10).string(message.namespace);
            if (message.mosaic != null && Object.hasOwnProperty.call(message, "mosaic"))
                writer.uint32(18).string(message.mosaic);
            if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                writer.uint32(24).int32(message.type);
            if (message.delta != null && Object.hasOwnProperty.call(message, "delta"))
                writer.uint32(32).uint64(message.delta);
            return writer;
        };

        NEMMosaicSupplyChange.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        NEMMosaicSupplyChange.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NEMSignTx.NEMMosaicSupplyChange();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.namespace = reader.string();
                    break;
                case 2:
                    message.mosaic = reader.string();
                    break;
                case 3:
                    message.type = reader.int32();
                    break;
                case 4:
                    message.delta = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        NEMMosaicSupplyChange.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        NEMMosaicSupplyChange.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.namespace != null && message.hasOwnProperty("namespace"))
                if (!$util.isString(message.namespace))
                    return "namespace: string expected";
            if (message.mosaic != null && message.hasOwnProperty("mosaic"))
                if (!$util.isString(message.mosaic))
                    return "mosaic: string expected";
            if (message.type != null && message.hasOwnProperty("type"))
                switch (message.type) {
                default:
                    return "type: enum value expected";
                case 1:
                case 2:
                    break;
                }
            if (message.delta != null && message.hasOwnProperty("delta"))
                if (!$util.isInteger(message.delta) && !(message.delta && $util.isInteger(message.delta.low) && $util.isInteger(message.delta.high)))
                    return "delta: integer|Long expected";
            return null;
        };

        NEMMosaicSupplyChange.fromObject = function fromObject(object) {
            if (object instanceof $root.NEMSignTx.NEMMosaicSupplyChange)
                return object;
            var message = new $root.NEMSignTx.NEMMosaicSupplyChange();
            if (object.namespace != null)
                message.namespace = String(object.namespace);
            if (object.mosaic != null)
                message.mosaic = String(object.mosaic);
            switch (object.type) {
            case "SupplyChange_Increase":
            case 1:
                message.type = 1;
                break;
            case "SupplyChange_Decrease":
            case 2:
                message.type = 2;
                break;
            }
            if (object.delta != null)
                if ($util.Long)
                    (message.delta = $util.Long.fromValue(object.delta)).unsigned = true;
                else if (typeof object.delta === "string")
                    message.delta = parseInt(object.delta, 10);
                else if (typeof object.delta === "number")
                    message.delta = object.delta;
                else if (typeof object.delta === "object")
                    message.delta = new $util.LongBits(object.delta.low >>> 0, object.delta.high >>> 0).toNumber(true);
            return message;
        };

        NEMMosaicSupplyChange.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.namespace = "";
                object.mosaic = "";
                object.type = options.enums === String ? "SupplyChange_Increase" : 1;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.delta = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.delta = options.longs === String ? "0" : 0;
            }
            if (message.namespace != null && message.hasOwnProperty("namespace"))
                object.namespace = message.namespace;
            if (message.mosaic != null && message.hasOwnProperty("mosaic"))
                object.mosaic = message.mosaic;
            if (message.type != null && message.hasOwnProperty("type"))
                object.type = options.enums === String ? $root.NEMSignTx.NEMMosaicSupplyChange.NEMSupplyChangeType[message.type] : message.type;
            if (message.delta != null && message.hasOwnProperty("delta"))
                if (typeof message.delta === "number")
                    object.delta = options.longs === String ? String(message.delta) : message.delta;
                else
                    object.delta = options.longs === String ? $util.Long.prototype.toString.call(message.delta) : options.longs === Number ? new $util.LongBits(message.delta.low >>> 0, message.delta.high >>> 0).toNumber(true) : message.delta;
            return object;
        };

        NEMMosaicSupplyChange.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        NEMMosaicSupplyChange.NEMSupplyChangeType = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[1] = "SupplyChange_Increase"] = 1;
            values[valuesById[2] = "SupplyChange_Decrease"] = 2;
            return values;
        })();

        return NEMMosaicSupplyChange;
    })();

    NEMSignTx.NEMAggregateModification = (function() {

        function NEMAggregateModification(properties) {
            this.modifications = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        NEMAggregateModification.prototype.modifications = $util.emptyArray;
        NEMAggregateModification.prototype.relative_change = 0;

        NEMAggregateModification.create = function create(properties) {
            return new NEMAggregateModification(properties);
        };

        NEMAggregateModification.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.modifications != null && message.modifications.length)
                for (var i = 0; i < message.modifications.length; ++i)
                    $root.NEMSignTx.NEMAggregateModification.NEMCosignatoryModification.encode(message.modifications[i], writer.uint32(10).fork()).ldelim();
            if (message.relative_change != null && Object.hasOwnProperty.call(message, "relative_change"))
                writer.uint32(16).sint32(message.relative_change);
            return writer;
        };

        NEMAggregateModification.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        NEMAggregateModification.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NEMSignTx.NEMAggregateModification();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.modifications && message.modifications.length))
                        message.modifications = [];
                    message.modifications.push($root.NEMSignTx.NEMAggregateModification.NEMCosignatoryModification.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.relative_change = reader.sint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        NEMAggregateModification.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        NEMAggregateModification.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.modifications != null && message.hasOwnProperty("modifications")) {
                if (!Array.isArray(message.modifications))
                    return "modifications: array expected";
                for (var i = 0; i < message.modifications.length; ++i) {
                    var error = $root.NEMSignTx.NEMAggregateModification.NEMCosignatoryModification.verify(message.modifications[i]);
                    if (error)
                        return "modifications." + error;
                }
            }
            if (message.relative_change != null && message.hasOwnProperty("relative_change"))
                if (!$util.isInteger(message.relative_change))
                    return "relative_change: integer expected";
            return null;
        };

        NEMAggregateModification.fromObject = function fromObject(object) {
            if (object instanceof $root.NEMSignTx.NEMAggregateModification)
                return object;
            var message = new $root.NEMSignTx.NEMAggregateModification();
            if (object.modifications) {
                if (!Array.isArray(object.modifications))
                    throw TypeError(".NEMSignTx.NEMAggregateModification.modifications: array expected");
                message.modifications = [];
                for (var i = 0; i < object.modifications.length; ++i) {
                    if (typeof object.modifications[i] !== "object")
                        throw TypeError(".NEMSignTx.NEMAggregateModification.modifications: object expected");
                    message.modifications[i] = $root.NEMSignTx.NEMAggregateModification.NEMCosignatoryModification.fromObject(object.modifications[i]);
                }
            }
            if (object.relative_change != null)
                message.relative_change = object.relative_change | 0;
            return message;
        };

        NEMAggregateModification.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.modifications = [];
            if (options.defaults)
                object.relative_change = 0;
            if (message.modifications && message.modifications.length) {
                object.modifications = [];
                for (var j = 0; j < message.modifications.length; ++j)
                    object.modifications[j] = $root.NEMSignTx.NEMAggregateModification.NEMCosignatoryModification.toObject(message.modifications[j], options);
            }
            if (message.relative_change != null && message.hasOwnProperty("relative_change"))
                object.relative_change = message.relative_change;
            return object;
        };

        NEMAggregateModification.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        NEMAggregateModification.NEMCosignatoryModification = (function() {

            function NEMCosignatoryModification(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            NEMCosignatoryModification.prototype.type = 1;
            NEMCosignatoryModification.prototype.public_key = $util.newBuffer([]);

            NEMCosignatoryModification.create = function create(properties) {
                return new NEMCosignatoryModification(properties);
            };

            NEMCosignatoryModification.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                    writer.uint32(8).int32(message.type);
                if (message.public_key != null && Object.hasOwnProperty.call(message, "public_key"))
                    writer.uint32(18).bytes(message.public_key);
                return writer;
            };

            NEMCosignatoryModification.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            NEMCosignatoryModification.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NEMSignTx.NEMAggregateModification.NEMCosignatoryModification();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.type = reader.int32();
                        break;
                    case 2:
                        message.public_key = reader.bytes();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            NEMCosignatoryModification.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            NEMCosignatoryModification.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.type != null && message.hasOwnProperty("type"))
                    switch (message.type) {
                    default:
                        return "type: enum value expected";
                    case 1:
                    case 2:
                        break;
                    }
                if (message.public_key != null && message.hasOwnProperty("public_key"))
                    if (!(message.public_key && typeof message.public_key.length === "number" || $util.isString(message.public_key)))
                        return "public_key: buffer expected";
                return null;
            };

            NEMCosignatoryModification.fromObject = function fromObject(object) {
                if (object instanceof $root.NEMSignTx.NEMAggregateModification.NEMCosignatoryModification)
                    return object;
                var message = new $root.NEMSignTx.NEMAggregateModification.NEMCosignatoryModification();
                switch (object.type) {
                case "CosignatoryModification_Add":
                case 1:
                    message.type = 1;
                    break;
                case "CosignatoryModification_Delete":
                case 2:
                    message.type = 2;
                    break;
                }
                if (object.public_key != null)
                    if (typeof object.public_key === "string")
                        $util.base64.decode(object.public_key, message.public_key = $util.newBuffer($util.base64.length(object.public_key)), 0);
                    else if (object.public_key.length)
                        message.public_key = object.public_key;
                return message;
            };

            NEMCosignatoryModification.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.type = options.enums === String ? "CosignatoryModification_Add" : 1;
                    if (options.bytes === String)
                        object.public_key = "";
                    else {
                        object.public_key = [];
                        if (options.bytes !== Array)
                            object.public_key = $util.newBuffer(object.public_key);
                    }
                }
                if (message.type != null && message.hasOwnProperty("type"))
                    object.type = options.enums === String ? $root.NEMSignTx.NEMAggregateModification.NEMCosignatoryModification.NEMModificationType[message.type] : message.type;
                if (message.public_key != null && message.hasOwnProperty("public_key"))
                    object.public_key = options.bytes === String ? $util.base64.encode(message.public_key, 0, message.public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.public_key) : message.public_key;
                return object;
            };

            NEMCosignatoryModification.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            NEMCosignatoryModification.NEMModificationType = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[1] = "CosignatoryModification_Add"] = 1;
                values[valuesById[2] = "CosignatoryModification_Delete"] = 2;
                return values;
            })();

            return NEMCosignatoryModification;
        })();

        return NEMAggregateModification;
    })();

    NEMSignTx.NEMImportanceTransfer = (function() {

        function NEMImportanceTransfer(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        NEMImportanceTransfer.prototype.mode = 1;
        NEMImportanceTransfer.prototype.public_key = $util.newBuffer([]);

        NEMImportanceTransfer.create = function create(properties) {
            return new NEMImportanceTransfer(properties);
        };

        NEMImportanceTransfer.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.mode != null && Object.hasOwnProperty.call(message, "mode"))
                writer.uint32(8).int32(message.mode);
            if (message.public_key != null && Object.hasOwnProperty.call(message, "public_key"))
                writer.uint32(18).bytes(message.public_key);
            return writer;
        };

        NEMImportanceTransfer.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        NEMImportanceTransfer.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NEMSignTx.NEMImportanceTransfer();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.mode = reader.int32();
                    break;
                case 2:
                    message.public_key = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        NEMImportanceTransfer.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        NEMImportanceTransfer.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.mode != null && message.hasOwnProperty("mode"))
                switch (message.mode) {
                default:
                    return "mode: enum value expected";
                case 1:
                case 2:
                    break;
                }
            if (message.public_key != null && message.hasOwnProperty("public_key"))
                if (!(message.public_key && typeof message.public_key.length === "number" || $util.isString(message.public_key)))
                    return "public_key: buffer expected";
            return null;
        };

        NEMImportanceTransfer.fromObject = function fromObject(object) {
            if (object instanceof $root.NEMSignTx.NEMImportanceTransfer)
                return object;
            var message = new $root.NEMSignTx.NEMImportanceTransfer();
            switch (object.mode) {
            case "ImportanceTransfer_Activate":
            case 1:
                message.mode = 1;
                break;
            case "ImportanceTransfer_Deactivate":
            case 2:
                message.mode = 2;
                break;
            }
            if (object.public_key != null)
                if (typeof object.public_key === "string")
                    $util.base64.decode(object.public_key, message.public_key = $util.newBuffer($util.base64.length(object.public_key)), 0);
                else if (object.public_key.length)
                    message.public_key = object.public_key;
            return message;
        };

        NEMImportanceTransfer.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.mode = options.enums === String ? "ImportanceTransfer_Activate" : 1;
                if (options.bytes === String)
                    object.public_key = "";
                else {
                    object.public_key = [];
                    if (options.bytes !== Array)
                        object.public_key = $util.newBuffer(object.public_key);
                }
            }
            if (message.mode != null && message.hasOwnProperty("mode"))
                object.mode = options.enums === String ? $root.NEMSignTx.NEMImportanceTransfer.NEMImportanceTransferMode[message.mode] : message.mode;
            if (message.public_key != null && message.hasOwnProperty("public_key"))
                object.public_key = options.bytes === String ? $util.base64.encode(message.public_key, 0, message.public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.public_key) : message.public_key;
            return object;
        };

        NEMImportanceTransfer.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        NEMImportanceTransfer.NEMImportanceTransferMode = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[1] = "ImportanceTransfer_Activate"] = 1;
            values[valuesById[2] = "ImportanceTransfer_Deactivate"] = 2;
            return values;
        })();

        return NEMImportanceTransfer;
    })();

    return NEMSignTx;
})();

$root.NEMSignedTx = (function() {

    function NEMSignedTx(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NEMSignedTx.prototype.data = $util.newBuffer([]);
    NEMSignedTx.prototype.signature = $util.newBuffer([]);

    NEMSignedTx.create = function create(properties) {
        return new NEMSignedTx(properties);
    };

    NEMSignedTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.data);
        writer.uint32(18).bytes(message.signature);
        return writer;
    };

    NEMSignedTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NEMSignedTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NEMSignedTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.data = reader.bytes();
                break;
            case 2:
                message.signature = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("data"))
            throw $util.ProtocolError("missing required 'data'", { instance: message });
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        return message;
    };

    NEMSignedTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NEMSignedTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
            return "data: buffer expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        return null;
    };

    NEMSignedTx.fromObject = function fromObject(object) {
        if (object instanceof $root.NEMSignedTx)
            return object;
        var message = new $root.NEMSignedTx();
        if (object.data != null)
            if (typeof object.data === "string")
                $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
            else if (object.data.length)
                message.data = object.data;
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        return message;
    };

    NEMSignedTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.data = "";
            else {
                object.data = [];
                if (options.bytes !== Array)
                    object.data = $util.newBuffer(object.data);
            }
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
        }
        if (message.data != null && message.hasOwnProperty("data"))
            object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        return object;
    };

    NEMSignedTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NEMSignedTx;
})();

$root.NEMDecryptMessage = (function() {

    function NEMDecryptMessage(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NEMDecryptMessage.prototype.address_n = $util.emptyArray;
    NEMDecryptMessage.prototype.network = 0;
    NEMDecryptMessage.prototype.public_key = $util.newBuffer([]);
    NEMDecryptMessage.prototype.payload = $util.newBuffer([]);

    NEMDecryptMessage.create = function create(properties) {
        return new NEMDecryptMessage(properties);
    };

    NEMDecryptMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.network != null && Object.hasOwnProperty.call(message, "network"))
            writer.uint32(16).uint32(message.network);
        if (message.public_key != null && Object.hasOwnProperty.call(message, "public_key"))
            writer.uint32(26).bytes(message.public_key);
        if (message.payload != null && Object.hasOwnProperty.call(message, "payload"))
            writer.uint32(34).bytes(message.payload);
        return writer;
    };

    NEMDecryptMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NEMDecryptMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NEMDecryptMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.network = reader.uint32();
                break;
            case 3:
                message.public_key = reader.bytes();
                break;
            case 4:
                message.payload = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    NEMDecryptMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NEMDecryptMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.network != null && message.hasOwnProperty("network"))
            if (!$util.isInteger(message.network))
                return "network: integer expected";
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            if (!(message.public_key && typeof message.public_key.length === "number" || $util.isString(message.public_key)))
                return "public_key: buffer expected";
        if (message.payload != null && message.hasOwnProperty("payload"))
            if (!(message.payload && typeof message.payload.length === "number" || $util.isString(message.payload)))
                return "payload: buffer expected";
        return null;
    };

    NEMDecryptMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.NEMDecryptMessage)
            return object;
        var message = new $root.NEMDecryptMessage();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".NEMDecryptMessage.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.network != null)
            message.network = object.network >>> 0;
        if (object.public_key != null)
            if (typeof object.public_key === "string")
                $util.base64.decode(object.public_key, message.public_key = $util.newBuffer($util.base64.length(object.public_key)), 0);
            else if (object.public_key.length)
                message.public_key = object.public_key;
        if (object.payload != null)
            if (typeof object.payload === "string")
                $util.base64.decode(object.payload, message.payload = $util.newBuffer($util.base64.length(object.payload)), 0);
            else if (object.payload.length)
                message.payload = object.payload;
        return message;
    };

    NEMDecryptMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            object.network = 0;
            if (options.bytes === String)
                object.public_key = "";
            else {
                object.public_key = [];
                if (options.bytes !== Array)
                    object.public_key = $util.newBuffer(object.public_key);
            }
            if (options.bytes === String)
                object.payload = "";
            else {
                object.payload = [];
                if (options.bytes !== Array)
                    object.payload = $util.newBuffer(object.payload);
            }
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.network != null && message.hasOwnProperty("network"))
            object.network = message.network;
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            object.public_key = options.bytes === String ? $util.base64.encode(message.public_key, 0, message.public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.public_key) : message.public_key;
        if (message.payload != null && message.hasOwnProperty("payload"))
            object.payload = options.bytes === String ? $util.base64.encode(message.payload, 0, message.payload.length) : options.bytes === Array ? Array.prototype.slice.call(message.payload) : message.payload;
        return object;
    };

    NEMDecryptMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NEMDecryptMessage;
})();

$root.NEMDecryptedMessage = (function() {

    function NEMDecryptedMessage(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NEMDecryptedMessage.prototype.payload = $util.newBuffer([]);

    NEMDecryptedMessage.create = function create(properties) {
        return new NEMDecryptedMessage(properties);
    };

    NEMDecryptedMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.payload);
        return writer;
    };

    NEMDecryptedMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NEMDecryptedMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NEMDecryptedMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.payload = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("payload"))
            throw $util.ProtocolError("missing required 'payload'", { instance: message });
        return message;
    };

    NEMDecryptedMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NEMDecryptedMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.payload && typeof message.payload.length === "number" || $util.isString(message.payload)))
            return "payload: buffer expected";
        return null;
    };

    NEMDecryptedMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.NEMDecryptedMessage)
            return object;
        var message = new $root.NEMDecryptedMessage();
        if (object.payload != null)
            if (typeof object.payload === "string")
                $util.base64.decode(object.payload, message.payload = $util.newBuffer($util.base64.length(object.payload)), 0);
            else if (object.payload.length)
                message.payload = object.payload;
        return message;
    };

    NEMDecryptedMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.payload = "";
            else {
                object.payload = [];
                if (options.bytes !== Array)
                    object.payload = $util.newBuffer(object.payload);
            }
        if (message.payload != null && message.hasOwnProperty("payload"))
            object.payload = options.bytes === String ? $util.base64.encode(message.payload, 0, message.payload.length) : options.bytes === Array ? Array.prototype.slice.call(message.payload) : message.payload;
        return object;
    };

    NEMDecryptedMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NEMDecryptedMessage;
})();

$root.NeoGetAddress = (function() {

    function NeoGetAddress(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NeoGetAddress.prototype.address_n = $util.emptyArray;
    NeoGetAddress.prototype.show_display = false;

    NeoGetAddress.create = function create(properties) {
        return new NeoGetAddress(properties);
    };

    NeoGetAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(16).bool(message.show_display);
        return writer;
    };

    NeoGetAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NeoGetAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NeoGetAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.show_display = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    NeoGetAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NeoGetAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        return null;
    };

    NeoGetAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.NeoGetAddress)
            return object;
        var message = new $root.NeoGetAddress();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".NeoGetAddress.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        return message;
    };

    NeoGetAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            object.show_display = false;
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        return object;
    };

    NeoGetAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NeoGetAddress;
})();

$root.NeoAddress = (function() {

    function NeoAddress(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NeoAddress.prototype.address = "";
    NeoAddress.prototype.public_key = $util.newBuffer([]);

    NeoAddress.create = function create(properties) {
        return new NeoAddress(properties);
    };

    NeoAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address != null && Object.hasOwnProperty.call(message, "address"))
            writer.uint32(10).string(message.address);
        if (message.public_key != null && Object.hasOwnProperty.call(message, "public_key"))
            writer.uint32(18).bytes(message.public_key);
        return writer;
    };

    NeoAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NeoAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NeoAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.string();
                break;
            case 2:
                message.public_key = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    NeoAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NeoAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address != null && message.hasOwnProperty("address"))
            if (!$util.isString(message.address))
                return "address: string expected";
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            if (!(message.public_key && typeof message.public_key.length === "number" || $util.isString(message.public_key)))
                return "public_key: buffer expected";
        return null;
    };

    NeoAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.NeoAddress)
            return object;
        var message = new $root.NeoAddress();
        if (object.address != null)
            message.address = String(object.address);
        if (object.public_key != null)
            if (typeof object.public_key === "string")
                $util.base64.decode(object.public_key, message.public_key = $util.newBuffer($util.base64.length(object.public_key)), 0);
            else if (object.public_key.length)
                message.public_key = object.public_key;
        return message;
    };

    NeoAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.address = "";
            if (options.bytes === String)
                object.public_key = "";
            else {
                object.public_key = [];
                if (options.bytes !== Array)
                    object.public_key = $util.newBuffer(object.public_key);
            }
        }
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            object.public_key = options.bytes === String ? $util.base64.encode(message.public_key, 0, message.public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.public_key) : message.public_key;
        return object;
    };

    NeoAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NeoAddress;
})();

$root.NeoSignTx = (function() {

    function NeoSignTx(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NeoSignTx.prototype.address_n = $util.emptyArray;
    NeoSignTx.prototype.raw_tx = $util.newBuffer([]);
    NeoSignTx.prototype.network_magic = 860833102;

    NeoSignTx.create = function create(properties) {
        return new NeoSignTx(properties);
    };

    NeoSignTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).bytes(message.raw_tx);
        if (message.network_magic != null && Object.hasOwnProperty.call(message, "network_magic"))
            writer.uint32(24).uint32(message.network_magic);
        return writer;
    };

    NeoSignTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NeoSignTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NeoSignTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.raw_tx = reader.bytes();
                break;
            case 3:
                message.network_magic = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("raw_tx"))
            throw $util.ProtocolError("missing required 'raw_tx'", { instance: message });
        return message;
    };

    NeoSignTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NeoSignTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!(message.raw_tx && typeof message.raw_tx.length === "number" || $util.isString(message.raw_tx)))
            return "raw_tx: buffer expected";
        if (message.network_magic != null && message.hasOwnProperty("network_magic"))
            if (!$util.isInteger(message.network_magic))
                return "network_magic: integer expected";
        return null;
    };

    NeoSignTx.fromObject = function fromObject(object) {
        if (object instanceof $root.NeoSignTx)
            return object;
        var message = new $root.NeoSignTx();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".NeoSignTx.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.raw_tx != null)
            if (typeof object.raw_tx === "string")
                $util.base64.decode(object.raw_tx, message.raw_tx = $util.newBuffer($util.base64.length(object.raw_tx)), 0);
            else if (object.raw_tx.length)
                message.raw_tx = object.raw_tx;
        if (object.network_magic != null)
            message.network_magic = object.network_magic >>> 0;
        return message;
    };

    NeoSignTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            if (options.bytes === String)
                object.raw_tx = "";
            else {
                object.raw_tx = [];
                if (options.bytes !== Array)
                    object.raw_tx = $util.newBuffer(object.raw_tx);
            }
            object.network_magic = 860833102;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.raw_tx != null && message.hasOwnProperty("raw_tx"))
            object.raw_tx = options.bytes === String ? $util.base64.encode(message.raw_tx, 0, message.raw_tx.length) : options.bytes === Array ? Array.prototype.slice.call(message.raw_tx) : message.raw_tx;
        if (message.network_magic != null && message.hasOwnProperty("network_magic"))
            object.network_magic = message.network_magic;
        return object;
    };

    NeoSignTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NeoSignTx;
})();

$root.NeoSignedTx = (function() {

    function NeoSignedTx(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NeoSignedTx.prototype.public_key = $util.newBuffer([]);
    NeoSignedTx.prototype.signature = $util.newBuffer([]);

    NeoSignedTx.create = function create(properties) {
        return new NeoSignedTx(properties);
    };

    NeoSignedTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.public_key);
        writer.uint32(18).bytes(message.signature);
        return writer;
    };

    NeoSignedTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NeoSignedTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NeoSignedTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.public_key = reader.bytes();
                break;
            case 2:
                message.signature = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("public_key"))
            throw $util.ProtocolError("missing required 'public_key'", { instance: message });
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        return message;
    };

    NeoSignedTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NeoSignedTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.public_key && typeof message.public_key.length === "number" || $util.isString(message.public_key)))
            return "public_key: buffer expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        return null;
    };

    NeoSignedTx.fromObject = function fromObject(object) {
        if (object instanceof $root.NeoSignedTx)
            return object;
        var message = new $root.NeoSignedTx();
        if (object.public_key != null)
            if (typeof object.public_key === "string")
                $util.base64.decode(object.public_key, message.public_key = $util.newBuffer($util.base64.length(object.public_key)), 0);
            else if (object.public_key.length)
                message.public_key = object.public_key;
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        return message;
    };

    NeoSignedTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.public_key = "";
            else {
                object.public_key = [];
                if (options.bytes !== Array)
                    object.public_key = $util.newBuffer(object.public_key);
            }
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
        }
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            object.public_key = options.bytes === String ? $util.base64.encode(message.public_key, 0, message.public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.public_key) : message.public_key;
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        return object;
    };

    NeoSignedTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NeoSignedTx;
})();

$root.NervosGetAddress = (function() {

    function NervosGetAddress(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NervosGetAddress.prototype.address_n = $util.emptyArray;
    NervosGetAddress.prototype.network = "";
    NervosGetAddress.prototype.show_display = false;

    NervosGetAddress.create = function create(properties) {
        return new NervosGetAddress(properties);
    };

    NervosGetAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).string(message.network);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(24).bool(message.show_display);
        return writer;
    };

    NervosGetAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NervosGetAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NervosGetAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.network = reader.string();
                break;
            case 3:
                message.show_display = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("network"))
            throw $util.ProtocolError("missing required 'network'", { instance: message });
        return message;
    };

    NervosGetAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NervosGetAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!$util.isString(message.network))
            return "network: string expected";
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        return null;
    };

    NervosGetAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.NervosGetAddress)
            return object;
        var message = new $root.NervosGetAddress();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".NervosGetAddress.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.network != null)
            message.network = String(object.network);
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        return message;
    };

    NervosGetAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            object.network = "";
            object.show_display = false;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.network != null && message.hasOwnProperty("network"))
            object.network = message.network;
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        return object;
    };

    NervosGetAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NervosGetAddress;
})();

$root.NervosAddress = (function() {

    function NervosAddress(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NervosAddress.prototype.address = "";

    NervosAddress.create = function create(properties) {
        return new NervosAddress(properties);
    };

    NervosAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.address);
        return writer;
    };

    NervosAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NervosAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NervosAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("address"))
            throw $util.ProtocolError("missing required 'address'", { instance: message });
        return message;
    };

    NervosAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NervosAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.address))
            return "address: string expected";
        return null;
    };

    NervosAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.NervosAddress)
            return object;
        var message = new $root.NervosAddress();
        if (object.address != null)
            message.address = String(object.address);
        return message;
    };

    NervosAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.address = "";
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    NervosAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NervosAddress;
})();

$root.NervosSignTx = (function() {

    function NervosSignTx(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NervosSignTx.prototype.address_n = $util.emptyArray;
    NervosSignTx.prototype.data_initial_chunk = $util.newBuffer([]);
    NervosSignTx.prototype.witness_buffer = $util.newBuffer([]);
    NervosSignTx.prototype.network = "";
    NervosSignTx.prototype.data_length = 0;

    NervosSignTx.create = function create(properties) {
        return new NervosSignTx(properties);
    };

    NervosSignTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).bytes(message.data_initial_chunk);
        writer.uint32(26).bytes(message.witness_buffer);
        writer.uint32(34).string(message.network);
        if (message.data_length != null && Object.hasOwnProperty.call(message, "data_length"))
            writer.uint32(40).uint32(message.data_length);
        return writer;
    };

    NervosSignTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NervosSignTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NervosSignTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.data_initial_chunk = reader.bytes();
                break;
            case 3:
                message.witness_buffer = reader.bytes();
                break;
            case 4:
                message.network = reader.string();
                break;
            case 5:
                message.data_length = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("data_initial_chunk"))
            throw $util.ProtocolError("missing required 'data_initial_chunk'", { instance: message });
        if (!message.hasOwnProperty("witness_buffer"))
            throw $util.ProtocolError("missing required 'witness_buffer'", { instance: message });
        if (!message.hasOwnProperty("network"))
            throw $util.ProtocolError("missing required 'network'", { instance: message });
        return message;
    };

    NervosSignTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NervosSignTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!(message.data_initial_chunk && typeof message.data_initial_chunk.length === "number" || $util.isString(message.data_initial_chunk)))
            return "data_initial_chunk: buffer expected";
        if (!(message.witness_buffer && typeof message.witness_buffer.length === "number" || $util.isString(message.witness_buffer)))
            return "witness_buffer: buffer expected";
        if (!$util.isString(message.network))
            return "network: string expected";
        if (message.data_length != null && message.hasOwnProperty("data_length"))
            if (!$util.isInteger(message.data_length))
                return "data_length: integer expected";
        return null;
    };

    NervosSignTx.fromObject = function fromObject(object) {
        if (object instanceof $root.NervosSignTx)
            return object;
        var message = new $root.NervosSignTx();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".NervosSignTx.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.data_initial_chunk != null)
            if (typeof object.data_initial_chunk === "string")
                $util.base64.decode(object.data_initial_chunk, message.data_initial_chunk = $util.newBuffer($util.base64.length(object.data_initial_chunk)), 0);
            else if (object.data_initial_chunk.length)
                message.data_initial_chunk = object.data_initial_chunk;
        if (object.witness_buffer != null)
            if (typeof object.witness_buffer === "string")
                $util.base64.decode(object.witness_buffer, message.witness_buffer = $util.newBuffer($util.base64.length(object.witness_buffer)), 0);
            else if (object.witness_buffer.length)
                message.witness_buffer = object.witness_buffer;
        if (object.network != null)
            message.network = String(object.network);
        if (object.data_length != null)
            message.data_length = object.data_length >>> 0;
        return message;
    };

    NervosSignTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            if (options.bytes === String)
                object.data_initial_chunk = "";
            else {
                object.data_initial_chunk = [];
                if (options.bytes !== Array)
                    object.data_initial_chunk = $util.newBuffer(object.data_initial_chunk);
            }
            if (options.bytes === String)
                object.witness_buffer = "";
            else {
                object.witness_buffer = [];
                if (options.bytes !== Array)
                    object.witness_buffer = $util.newBuffer(object.witness_buffer);
            }
            object.network = "";
            object.data_length = 0;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.data_initial_chunk != null && message.hasOwnProperty("data_initial_chunk"))
            object.data_initial_chunk = options.bytes === String ? $util.base64.encode(message.data_initial_chunk, 0, message.data_initial_chunk.length) : options.bytes === Array ? Array.prototype.slice.call(message.data_initial_chunk) : message.data_initial_chunk;
        if (message.witness_buffer != null && message.hasOwnProperty("witness_buffer"))
            object.witness_buffer = options.bytes === String ? $util.base64.encode(message.witness_buffer, 0, message.witness_buffer.length) : options.bytes === Array ? Array.prototype.slice.call(message.witness_buffer) : message.witness_buffer;
        if (message.network != null && message.hasOwnProperty("network"))
            object.network = message.network;
        if (message.data_length != null && message.hasOwnProperty("data_length"))
            object.data_length = message.data_length;
        return object;
    };

    NervosSignTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NervosSignTx;
})();

$root.NervosSignedTx = (function() {

    function NervosSignedTx(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NervosSignedTx.prototype.signature = $util.newBuffer([]);
    NervosSignedTx.prototype.address = "";

    NervosSignedTx.create = function create(properties) {
        return new NervosSignedTx(properties);
    };

    NervosSignedTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.signature);
        writer.uint32(18).string(message.address);
        return writer;
    };

    NervosSignedTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NervosSignedTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NervosSignedTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.signature = reader.bytes();
                break;
            case 2:
                message.address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        if (!message.hasOwnProperty("address"))
            throw $util.ProtocolError("missing required 'address'", { instance: message });
        return message;
    };

    NervosSignedTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NervosSignedTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        if (!$util.isString(message.address))
            return "address: string expected";
        return null;
    };

    NervosSignedTx.fromObject = function fromObject(object) {
        if (object instanceof $root.NervosSignedTx)
            return object;
        var message = new $root.NervosSignedTx();
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        if (object.address != null)
            message.address = String(object.address);
        return message;
    };

    NervosSignedTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
            object.address = "";
        }
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    NervosSignedTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NervosSignedTx;
})();

$root.NervosTxRequest = (function() {

    function NervosTxRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NervosTxRequest.prototype.data_length = 0;
    NervosTxRequest.prototype.public_key = $util.newBuffer([]);
    NervosTxRequest.prototype.signature = $util.newBuffer([]);

    NervosTxRequest.create = function create(properties) {
        return new NervosTxRequest(properties);
    };

    NervosTxRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.data_length != null && Object.hasOwnProperty.call(message, "data_length"))
            writer.uint32(8).uint32(message.data_length);
        if (message.public_key != null && Object.hasOwnProperty.call(message, "public_key"))
            writer.uint32(18).bytes(message.public_key);
        if (message.signature != null && Object.hasOwnProperty.call(message, "signature"))
            writer.uint32(26).bytes(message.signature);
        return writer;
    };

    NervosTxRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NervosTxRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NervosTxRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.data_length = reader.uint32();
                break;
            case 2:
                message.public_key = reader.bytes();
                break;
            case 3:
                message.signature = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    NervosTxRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NervosTxRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.data_length != null && message.hasOwnProperty("data_length"))
            if (!$util.isInteger(message.data_length))
                return "data_length: integer expected";
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            if (!(message.public_key && typeof message.public_key.length === "number" || $util.isString(message.public_key)))
                return "public_key: buffer expected";
        if (message.signature != null && message.hasOwnProperty("signature"))
            if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
                return "signature: buffer expected";
        return null;
    };

    NervosTxRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.NervosTxRequest)
            return object;
        var message = new $root.NervosTxRequest();
        if (object.data_length != null)
            message.data_length = object.data_length >>> 0;
        if (object.public_key != null)
            if (typeof object.public_key === "string")
                $util.base64.decode(object.public_key, message.public_key = $util.newBuffer($util.base64.length(object.public_key)), 0);
            else if (object.public_key.length)
                message.public_key = object.public_key;
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        return message;
    };

    NervosTxRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.data_length = 0;
            if (options.bytes === String)
                object.public_key = "";
            else {
                object.public_key = [];
                if (options.bytes !== Array)
                    object.public_key = $util.newBuffer(object.public_key);
            }
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
        }
        if (message.data_length != null && message.hasOwnProperty("data_length"))
            object.data_length = message.data_length;
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            object.public_key = options.bytes === String ? $util.base64.encode(message.public_key, 0, message.public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.public_key) : message.public_key;
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        return object;
    };

    NervosTxRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NervosTxRequest;
})();

$root.NervosTxAck = (function() {

    function NervosTxAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NervosTxAck.prototype.data_chunk = $util.newBuffer([]);

    NervosTxAck.create = function create(properties) {
        return new NervosTxAck(properties);
    };

    NervosTxAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.data_chunk);
        return writer;
    };

    NervosTxAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NervosTxAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NervosTxAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.data_chunk = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("data_chunk"))
            throw $util.ProtocolError("missing required 'data_chunk'", { instance: message });
        return message;
    };

    NervosTxAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NervosTxAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.data_chunk && typeof message.data_chunk.length === "number" || $util.isString(message.data_chunk)))
            return "data_chunk: buffer expected";
        return null;
    };

    NervosTxAck.fromObject = function fromObject(object) {
        if (object instanceof $root.NervosTxAck)
            return object;
        var message = new $root.NervosTxAck();
        if (object.data_chunk != null)
            if (typeof object.data_chunk === "string")
                $util.base64.decode(object.data_chunk, message.data_chunk = $util.newBuffer($util.base64.length(object.data_chunk)), 0);
            else if (object.data_chunk.length)
                message.data_chunk = object.data_chunk;
        return message;
    };

    NervosTxAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.data_chunk = "";
            else {
                object.data_chunk = [];
                if (options.bytes !== Array)
                    object.data_chunk = $util.newBuffer(object.data_chunk);
            }
        if (message.data_chunk != null && message.hasOwnProperty("data_chunk"))
            object.data_chunk = options.bytes === String ? $util.base64.encode(message.data_chunk, 0, message.data_chunk.length) : options.bytes === Array ? Array.prototype.slice.call(message.data_chunk) : message.data_chunk;
        return object;
    };

    NervosTxAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NervosTxAck;
})();

$root.NexaGetAddress = (function() {

    function NexaGetAddress(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NexaGetAddress.prototype.address_n = $util.emptyArray;
    NexaGetAddress.prototype.show_display = false;
    NexaGetAddress.prototype.prefix = "nexa";

    NexaGetAddress.create = function create(properties) {
        return new NexaGetAddress(properties);
    };

    NexaGetAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(16).bool(message.show_display);
        if (message.prefix != null && Object.hasOwnProperty.call(message, "prefix"))
            writer.uint32(26).string(message.prefix);
        return writer;
    };

    NexaGetAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NexaGetAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NexaGetAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.show_display = reader.bool();
                break;
            case 3:
                message.prefix = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    NexaGetAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NexaGetAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        if (message.prefix != null && message.hasOwnProperty("prefix"))
            if (!$util.isString(message.prefix))
                return "prefix: string expected";
        return null;
    };

    NexaGetAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.NexaGetAddress)
            return object;
        var message = new $root.NexaGetAddress();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".NexaGetAddress.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        if (object.prefix != null)
            message.prefix = String(object.prefix);
        return message;
    };

    NexaGetAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            object.show_display = false;
            object.prefix = "nexa";
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        if (message.prefix != null && message.hasOwnProperty("prefix"))
            object.prefix = message.prefix;
        return object;
    };

    NexaGetAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NexaGetAddress;
})();

$root.NexaAddress = (function() {

    function NexaAddress(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NexaAddress.prototype.address = "";
    NexaAddress.prototype.public_key = $util.newBuffer([]);

    NexaAddress.create = function create(properties) {
        return new NexaAddress(properties);
    };

    NexaAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.address);
        writer.uint32(18).bytes(message.public_key);
        return writer;
    };

    NexaAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NexaAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NexaAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.string();
                break;
            case 2:
                message.public_key = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("address"))
            throw $util.ProtocolError("missing required 'address'", { instance: message });
        if (!message.hasOwnProperty("public_key"))
            throw $util.ProtocolError("missing required 'public_key'", { instance: message });
        return message;
    };

    NexaAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NexaAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.address))
            return "address: string expected";
        if (!(message.public_key && typeof message.public_key.length === "number" || $util.isString(message.public_key)))
            return "public_key: buffer expected";
        return null;
    };

    NexaAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.NexaAddress)
            return object;
        var message = new $root.NexaAddress();
        if (object.address != null)
            message.address = String(object.address);
        if (object.public_key != null)
            if (typeof object.public_key === "string")
                $util.base64.decode(object.public_key, message.public_key = $util.newBuffer($util.base64.length(object.public_key)), 0);
            else if (object.public_key.length)
                message.public_key = object.public_key;
        return message;
    };

    NexaAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.address = "";
            if (options.bytes === String)
                object.public_key = "";
            else {
                object.public_key = [];
                if (options.bytes !== Array)
                    object.public_key = $util.newBuffer(object.public_key);
            }
        }
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            object.public_key = options.bytes === String ? $util.base64.encode(message.public_key, 0, message.public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.public_key) : message.public_key;
        return object;
    };

    NexaAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NexaAddress;
})();

$root.NexaSignTx = (function() {

    function NexaSignTx(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NexaSignTx.prototype.address_n = $util.emptyArray;
    NexaSignTx.prototype.raw_message = $util.newBuffer([]);
    NexaSignTx.prototype.prefix = "nexa";
    NexaSignTx.prototype.input_count = 1;

    NexaSignTx.create = function create(properties) {
        return new NexaSignTx(properties);
    };

    NexaSignTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).bytes(message.raw_message);
        if (message.prefix != null && Object.hasOwnProperty.call(message, "prefix"))
            writer.uint32(26).string(message.prefix);
        if (message.input_count != null && Object.hasOwnProperty.call(message, "input_count"))
            writer.uint32(32).uint32(message.input_count);
        return writer;
    };

    NexaSignTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NexaSignTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NexaSignTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.raw_message = reader.bytes();
                break;
            case 3:
                message.prefix = reader.string();
                break;
            case 4:
                message.input_count = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("raw_message"))
            throw $util.ProtocolError("missing required 'raw_message'", { instance: message });
        return message;
    };

    NexaSignTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NexaSignTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!(message.raw_message && typeof message.raw_message.length === "number" || $util.isString(message.raw_message)))
            return "raw_message: buffer expected";
        if (message.prefix != null && message.hasOwnProperty("prefix"))
            if (!$util.isString(message.prefix))
                return "prefix: string expected";
        if (message.input_count != null && message.hasOwnProperty("input_count"))
            if (!$util.isInteger(message.input_count))
                return "input_count: integer expected";
        return null;
    };

    NexaSignTx.fromObject = function fromObject(object) {
        if (object instanceof $root.NexaSignTx)
            return object;
        var message = new $root.NexaSignTx();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".NexaSignTx.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.raw_message != null)
            if (typeof object.raw_message === "string")
                $util.base64.decode(object.raw_message, message.raw_message = $util.newBuffer($util.base64.length(object.raw_message)), 0);
            else if (object.raw_message.length)
                message.raw_message = object.raw_message;
        if (object.prefix != null)
            message.prefix = String(object.prefix);
        if (object.input_count != null)
            message.input_count = object.input_count >>> 0;
        return message;
    };

    NexaSignTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            if (options.bytes === String)
                object.raw_message = "";
            else {
                object.raw_message = [];
                if (options.bytes !== Array)
                    object.raw_message = $util.newBuffer(object.raw_message);
            }
            object.prefix = "nexa";
            object.input_count = 1;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.raw_message != null && message.hasOwnProperty("raw_message"))
            object.raw_message = options.bytes === String ? $util.base64.encode(message.raw_message, 0, message.raw_message.length) : options.bytes === Array ? Array.prototype.slice.call(message.raw_message) : message.raw_message;
        if (message.prefix != null && message.hasOwnProperty("prefix"))
            object.prefix = message.prefix;
        if (message.input_count != null && message.hasOwnProperty("input_count"))
            object.input_count = message.input_count;
        return object;
    };

    NexaSignTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NexaSignTx;
})();

$root.NexaTxInputRequest = (function() {

    function NexaTxInputRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NexaTxInputRequest.prototype.request_index = 0;
    NexaTxInputRequest.prototype.signature = $util.newBuffer([]);

    NexaTxInputRequest.create = function create(properties) {
        return new NexaTxInputRequest(properties);
    };

    NexaTxInputRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).uint32(message.request_index);
        if (message.signature != null && Object.hasOwnProperty.call(message, "signature"))
            writer.uint32(18).bytes(message.signature);
        return writer;
    };

    NexaTxInputRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NexaTxInputRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NexaTxInputRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.request_index = reader.uint32();
                break;
            case 2:
                message.signature = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("request_index"))
            throw $util.ProtocolError("missing required 'request_index'", { instance: message });
        return message;
    };

    NexaTxInputRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NexaTxInputRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isInteger(message.request_index))
            return "request_index: integer expected";
        if (message.signature != null && message.hasOwnProperty("signature"))
            if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
                return "signature: buffer expected";
        return null;
    };

    NexaTxInputRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.NexaTxInputRequest)
            return object;
        var message = new $root.NexaTxInputRequest();
        if (object.request_index != null)
            message.request_index = object.request_index >>> 0;
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        return message;
    };

    NexaTxInputRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.request_index = 0;
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
        }
        if (message.request_index != null && message.hasOwnProperty("request_index"))
            object.request_index = message.request_index;
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        return object;
    };

    NexaTxInputRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NexaTxInputRequest;
})();

$root.NexaTxInputAck = (function() {

    function NexaTxInputAck(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NexaTxInputAck.prototype.address_n = $util.emptyArray;
    NexaTxInputAck.prototype.raw_message = $util.newBuffer([]);

    NexaTxInputAck.create = function create(properties) {
        return new NexaTxInputAck(properties);
    };

    NexaTxInputAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).bytes(message.raw_message);
        return writer;
    };

    NexaTxInputAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NexaTxInputAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NexaTxInputAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.raw_message = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("raw_message"))
            throw $util.ProtocolError("missing required 'raw_message'", { instance: message });
        return message;
    };

    NexaTxInputAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NexaTxInputAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!(message.raw_message && typeof message.raw_message.length === "number" || $util.isString(message.raw_message)))
            return "raw_message: buffer expected";
        return null;
    };

    NexaTxInputAck.fromObject = function fromObject(object) {
        if (object instanceof $root.NexaTxInputAck)
            return object;
        var message = new $root.NexaTxInputAck();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".NexaTxInputAck.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.raw_message != null)
            if (typeof object.raw_message === "string")
                $util.base64.decode(object.raw_message, message.raw_message = $util.newBuffer($util.base64.length(object.raw_message)), 0);
            else if (object.raw_message.length)
                message.raw_message = object.raw_message;
        return message;
    };

    NexaTxInputAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            if (options.bytes === String)
                object.raw_message = "";
            else {
                object.raw_message = [];
                if (options.bytes !== Array)
                    object.raw_message = $util.newBuffer(object.raw_message);
            }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.raw_message != null && message.hasOwnProperty("raw_message"))
            object.raw_message = options.bytes === String ? $util.base64.encode(message.raw_message, 0, message.raw_message.length) : options.bytes === Array ? Array.prototype.slice.call(message.raw_message) : message.raw_message;
        return object;
    };

    NexaTxInputAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NexaTxInputAck;
})();

$root.NexaSignedTx = (function() {

    function NexaSignedTx(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NexaSignedTx.prototype.signature = $util.newBuffer([]);

    NexaSignedTx.create = function create(properties) {
        return new NexaSignedTx(properties);
    };

    NexaSignedTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.signature);
        return writer;
    };

    NexaSignedTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NexaSignedTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NexaSignedTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.signature = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        return message;
    };

    NexaSignedTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NexaSignedTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        return null;
    };

    NexaSignedTx.fromObject = function fromObject(object) {
        if (object instanceof $root.NexaSignedTx)
            return object;
        var message = new $root.NexaSignedTx();
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        return message;
    };

    NexaSignedTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        return object;
    };

    NexaSignedTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NexaSignedTx;
})();

$root.NostrGetPublicKey = (function() {

    function NostrGetPublicKey(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NostrGetPublicKey.prototype.address_n = $util.emptyArray;
    NostrGetPublicKey.prototype.show_display = false;

    NostrGetPublicKey.create = function create(properties) {
        return new NostrGetPublicKey(properties);
    };

    NostrGetPublicKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(16).bool(message.show_display);
        return writer;
    };

    NostrGetPublicKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NostrGetPublicKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NostrGetPublicKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.show_display = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    NostrGetPublicKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NostrGetPublicKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        return null;
    };

    NostrGetPublicKey.fromObject = function fromObject(object) {
        if (object instanceof $root.NostrGetPublicKey)
            return object;
        var message = new $root.NostrGetPublicKey();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".NostrGetPublicKey.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        return message;
    };

    NostrGetPublicKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            object.show_display = false;
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        return object;
    };

    NostrGetPublicKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NostrGetPublicKey;
})();

$root.NostrPublicKey = (function() {

    function NostrPublicKey(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NostrPublicKey.prototype.publickey = "";
    NostrPublicKey.prototype.npub = "";

    NostrPublicKey.create = function create(properties) {
        return new NostrPublicKey(properties);
    };

    NostrPublicKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.publickey != null && Object.hasOwnProperty.call(message, "publickey"))
            writer.uint32(10).string(message.publickey);
        if (message.npub != null && Object.hasOwnProperty.call(message, "npub"))
            writer.uint32(18).string(message.npub);
        return writer;
    };

    NostrPublicKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NostrPublicKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NostrPublicKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.publickey = reader.string();
                break;
            case 2:
                message.npub = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    NostrPublicKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NostrPublicKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.publickey != null && message.hasOwnProperty("publickey"))
            if (!$util.isString(message.publickey))
                return "publickey: string expected";
        if (message.npub != null && message.hasOwnProperty("npub"))
            if (!$util.isString(message.npub))
                return "npub: string expected";
        return null;
    };

    NostrPublicKey.fromObject = function fromObject(object) {
        if (object instanceof $root.NostrPublicKey)
            return object;
        var message = new $root.NostrPublicKey();
        if (object.publickey != null)
            message.publickey = String(object.publickey);
        if (object.npub != null)
            message.npub = String(object.npub);
        return message;
    };

    NostrPublicKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.publickey = "";
            object.npub = "";
        }
        if (message.publickey != null && message.hasOwnProperty("publickey"))
            object.publickey = message.publickey;
        if (message.npub != null && message.hasOwnProperty("npub"))
            object.npub = message.npub;
        return object;
    };

    NostrPublicKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NostrPublicKey;
})();

$root.NostrSignEvent = (function() {

    function NostrSignEvent(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NostrSignEvent.prototype.address_n = $util.emptyArray;
    NostrSignEvent.prototype.event = $util.newBuffer([]);

    NostrSignEvent.create = function create(properties) {
        return new NostrSignEvent(properties);
    };

    NostrSignEvent.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).bytes(message.event);
        return writer;
    };

    NostrSignEvent.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NostrSignEvent.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NostrSignEvent();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.event = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("event"))
            throw $util.ProtocolError("missing required 'event'", { instance: message });
        return message;
    };

    NostrSignEvent.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NostrSignEvent.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!(message.event && typeof message.event.length === "number" || $util.isString(message.event)))
            return "event: buffer expected";
        return null;
    };

    NostrSignEvent.fromObject = function fromObject(object) {
        if (object instanceof $root.NostrSignEvent)
            return object;
        var message = new $root.NostrSignEvent();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".NostrSignEvent.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.event != null)
            if (typeof object.event === "string")
                $util.base64.decode(object.event, message.event = $util.newBuffer($util.base64.length(object.event)), 0);
            else if (object.event.length)
                message.event = object.event;
        return message;
    };

    NostrSignEvent.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            if (options.bytes === String)
                object.event = "";
            else {
                object.event = [];
                if (options.bytes !== Array)
                    object.event = $util.newBuffer(object.event);
            }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.event != null && message.hasOwnProperty("event"))
            object.event = options.bytes === String ? $util.base64.encode(message.event, 0, message.event.length) : options.bytes === Array ? Array.prototype.slice.call(message.event) : message.event;
        return object;
    };

    NostrSignEvent.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NostrSignEvent;
})();

$root.NostrSignedEvent = (function() {

    function NostrSignedEvent(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NostrSignedEvent.prototype.event = $util.newBuffer([]);

    NostrSignedEvent.create = function create(properties) {
        return new NostrSignedEvent(properties);
    };

    NostrSignedEvent.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.event);
        return writer;
    };

    NostrSignedEvent.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NostrSignedEvent.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NostrSignedEvent();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.event = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("event"))
            throw $util.ProtocolError("missing required 'event'", { instance: message });
        return message;
    };

    NostrSignedEvent.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NostrSignedEvent.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.event && typeof message.event.length === "number" || $util.isString(message.event)))
            return "event: buffer expected";
        return null;
    };

    NostrSignedEvent.fromObject = function fromObject(object) {
        if (object instanceof $root.NostrSignedEvent)
            return object;
        var message = new $root.NostrSignedEvent();
        if (object.event != null)
            if (typeof object.event === "string")
                $util.base64.decode(object.event, message.event = $util.newBuffer($util.base64.length(object.event)), 0);
            else if (object.event.length)
                message.event = object.event;
        return message;
    };

    NostrSignedEvent.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.event = "";
            else {
                object.event = [];
                if (options.bytes !== Array)
                    object.event = $util.newBuffer(object.event);
            }
        if (message.event != null && message.hasOwnProperty("event"))
            object.event = options.bytes === String ? $util.base64.encode(message.event, 0, message.event.length) : options.bytes === Array ? Array.prototype.slice.call(message.event) : message.event;
        return object;
    };

    NostrSignedEvent.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NostrSignedEvent;
})();

$root.NostrSignSchnorr = (function() {

    function NostrSignSchnorr(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NostrSignSchnorr.prototype.address_n = $util.emptyArray;
    NostrSignSchnorr.prototype.hash = "";

    NostrSignSchnorr.create = function create(properties) {
        return new NostrSignSchnorr(properties);
    };

    NostrSignSchnorr.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).string(message.hash);
        return writer;
    };

    NostrSignSchnorr.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NostrSignSchnorr.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NostrSignSchnorr();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.hash = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("hash"))
            throw $util.ProtocolError("missing required 'hash'", { instance: message });
        return message;
    };

    NostrSignSchnorr.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NostrSignSchnorr.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!$util.isString(message.hash))
            return "hash: string expected";
        return null;
    };

    NostrSignSchnorr.fromObject = function fromObject(object) {
        if (object instanceof $root.NostrSignSchnorr)
            return object;
        var message = new $root.NostrSignSchnorr();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".NostrSignSchnorr.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.hash != null)
            message.hash = String(object.hash);
        return message;
    };

    NostrSignSchnorr.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            object.hash = "";
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.hash != null && message.hasOwnProperty("hash"))
            object.hash = message.hash;
        return object;
    };

    NostrSignSchnorr.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NostrSignSchnorr;
})();

$root.NostrSignedSchnorr = (function() {

    function NostrSignedSchnorr(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NostrSignedSchnorr.prototype.signature = $util.newBuffer([]);

    NostrSignedSchnorr.create = function create(properties) {
        return new NostrSignedSchnorr(properties);
    };

    NostrSignedSchnorr.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.signature);
        return writer;
    };

    NostrSignedSchnorr.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NostrSignedSchnorr.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NostrSignedSchnorr();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.signature = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        return message;
    };

    NostrSignedSchnorr.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NostrSignedSchnorr.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        return null;
    };

    NostrSignedSchnorr.fromObject = function fromObject(object) {
        if (object instanceof $root.NostrSignedSchnorr)
            return object;
        var message = new $root.NostrSignedSchnorr();
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        return message;
    };

    NostrSignedSchnorr.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        return object;
    };

    NostrSignedSchnorr.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NostrSignedSchnorr;
})();

$root.NostrEncryptMessage = (function() {

    function NostrEncryptMessage(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NostrEncryptMessage.prototype.address_n = $util.emptyArray;
    NostrEncryptMessage.prototype.pubkey = "";
    NostrEncryptMessage.prototype.msg = "";
    NostrEncryptMessage.prototype.show_display = false;

    NostrEncryptMessage.create = function create(properties) {
        return new NostrEncryptMessage(properties);
    };

    NostrEncryptMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).string(message.pubkey);
        writer.uint32(26).string(message.msg);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(32).bool(message.show_display);
        return writer;
    };

    NostrEncryptMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NostrEncryptMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NostrEncryptMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.pubkey = reader.string();
                break;
            case 3:
                message.msg = reader.string();
                break;
            case 4:
                message.show_display = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("pubkey"))
            throw $util.ProtocolError("missing required 'pubkey'", { instance: message });
        if (!message.hasOwnProperty("msg"))
            throw $util.ProtocolError("missing required 'msg'", { instance: message });
        return message;
    };

    NostrEncryptMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NostrEncryptMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!$util.isString(message.pubkey))
            return "pubkey: string expected";
        if (!$util.isString(message.msg))
            return "msg: string expected";
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        return null;
    };

    NostrEncryptMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.NostrEncryptMessage)
            return object;
        var message = new $root.NostrEncryptMessage();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".NostrEncryptMessage.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.pubkey != null)
            message.pubkey = String(object.pubkey);
        if (object.msg != null)
            message.msg = String(object.msg);
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        return message;
    };

    NostrEncryptMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            object.pubkey = "";
            object.msg = "";
            object.show_display = false;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.pubkey != null && message.hasOwnProperty("pubkey"))
            object.pubkey = message.pubkey;
        if (message.msg != null && message.hasOwnProperty("msg"))
            object.msg = message.msg;
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        return object;
    };

    NostrEncryptMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NostrEncryptMessage;
})();

$root.NostrEncryptedMessage = (function() {

    function NostrEncryptedMessage(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NostrEncryptedMessage.prototype.msg = "";

    NostrEncryptedMessage.create = function create(properties) {
        return new NostrEncryptedMessage(properties);
    };

    NostrEncryptedMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.msg);
        return writer;
    };

    NostrEncryptedMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NostrEncryptedMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NostrEncryptedMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.msg = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("msg"))
            throw $util.ProtocolError("missing required 'msg'", { instance: message });
        return message;
    };

    NostrEncryptedMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NostrEncryptedMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.msg))
            return "msg: string expected";
        return null;
    };

    NostrEncryptedMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.NostrEncryptedMessage)
            return object;
        var message = new $root.NostrEncryptedMessage();
        if (object.msg != null)
            message.msg = String(object.msg);
        return message;
    };

    NostrEncryptedMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.msg = "";
        if (message.msg != null && message.hasOwnProperty("msg"))
            object.msg = message.msg;
        return object;
    };

    NostrEncryptedMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NostrEncryptedMessage;
})();

$root.NostrDecryptMessage = (function() {

    function NostrDecryptMessage(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NostrDecryptMessage.prototype.address_n = $util.emptyArray;
    NostrDecryptMessage.prototype.pubkey = "";
    NostrDecryptMessage.prototype.msg = "";
    NostrDecryptMessage.prototype.show_display = false;

    NostrDecryptMessage.create = function create(properties) {
        return new NostrDecryptMessage(properties);
    };

    NostrDecryptMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).string(message.pubkey);
        writer.uint32(26).string(message.msg);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(32).bool(message.show_display);
        return writer;
    };

    NostrDecryptMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NostrDecryptMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NostrDecryptMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.pubkey = reader.string();
                break;
            case 3:
                message.msg = reader.string();
                break;
            case 4:
                message.show_display = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("pubkey"))
            throw $util.ProtocolError("missing required 'pubkey'", { instance: message });
        if (!message.hasOwnProperty("msg"))
            throw $util.ProtocolError("missing required 'msg'", { instance: message });
        return message;
    };

    NostrDecryptMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NostrDecryptMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!$util.isString(message.pubkey))
            return "pubkey: string expected";
        if (!$util.isString(message.msg))
            return "msg: string expected";
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        return null;
    };

    NostrDecryptMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.NostrDecryptMessage)
            return object;
        var message = new $root.NostrDecryptMessage();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".NostrDecryptMessage.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.pubkey != null)
            message.pubkey = String(object.pubkey);
        if (object.msg != null)
            message.msg = String(object.msg);
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        return message;
    };

    NostrDecryptMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            object.pubkey = "";
            object.msg = "";
            object.show_display = false;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.pubkey != null && message.hasOwnProperty("pubkey"))
            object.pubkey = message.pubkey;
        if (message.msg != null && message.hasOwnProperty("msg"))
            object.msg = message.msg;
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        return object;
    };

    NostrDecryptMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NostrDecryptMessage;
})();

$root.NostrDecryptedMessage = (function() {

    function NostrDecryptedMessage(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NostrDecryptedMessage.prototype.msg = "";

    NostrDecryptedMessage.create = function create(properties) {
        return new NostrDecryptedMessage(properties);
    };

    NostrDecryptedMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.msg);
        return writer;
    };

    NostrDecryptedMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NostrDecryptedMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NostrDecryptedMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.msg = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("msg"))
            throw $util.ProtocolError("missing required 'msg'", { instance: message });
        return message;
    };

    NostrDecryptedMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NostrDecryptedMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.msg))
            return "msg: string expected";
        return null;
    };

    NostrDecryptedMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.NostrDecryptedMessage)
            return object;
        var message = new $root.NostrDecryptedMessage();
        if (object.msg != null)
            message.msg = String(object.msg);
        return message;
    };

    NostrDecryptedMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.msg = "";
        if (message.msg != null && message.hasOwnProperty("msg"))
            object.msg = message.msg;
        return object;
    };

    NostrDecryptedMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NostrDecryptedMessage;
})();

$root.PolkadotGetAddress = (function() {

    function PolkadotGetAddress(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    PolkadotGetAddress.prototype.address_n = $util.emptyArray;
    PolkadotGetAddress.prototype.prefix = 0;
    PolkadotGetAddress.prototype.network = "";
    PolkadotGetAddress.prototype.show_display = false;

    PolkadotGetAddress.create = function create(properties) {
        return new PolkadotGetAddress(properties);
    };

    PolkadotGetAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(16).uint32(message.prefix);
        writer.uint32(26).string(message.network);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(32).bool(message.show_display);
        return writer;
    };

    PolkadotGetAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    PolkadotGetAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.PolkadotGetAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.prefix = reader.uint32();
                break;
            case 3:
                message.network = reader.string();
                break;
            case 4:
                message.show_display = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("prefix"))
            throw $util.ProtocolError("missing required 'prefix'", { instance: message });
        if (!message.hasOwnProperty("network"))
            throw $util.ProtocolError("missing required 'network'", { instance: message });
        return message;
    };

    PolkadotGetAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    PolkadotGetAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!$util.isInteger(message.prefix))
            return "prefix: integer expected";
        if (!$util.isString(message.network))
            return "network: string expected";
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        return null;
    };

    PolkadotGetAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.PolkadotGetAddress)
            return object;
        var message = new $root.PolkadotGetAddress();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".PolkadotGetAddress.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.prefix != null)
            message.prefix = object.prefix >>> 0;
        if (object.network != null)
            message.network = String(object.network);
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        return message;
    };

    PolkadotGetAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            object.prefix = 0;
            object.network = "";
            object.show_display = false;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.prefix != null && message.hasOwnProperty("prefix"))
            object.prefix = message.prefix;
        if (message.network != null && message.hasOwnProperty("network"))
            object.network = message.network;
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        return object;
    };

    PolkadotGetAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return PolkadotGetAddress;
})();

$root.PolkadotAddress = (function() {

    function PolkadotAddress(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    PolkadotAddress.prototype.address = "";
    PolkadotAddress.prototype.public_key = "";

    PolkadotAddress.create = function create(properties) {
        return new PolkadotAddress(properties);
    };

    PolkadotAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address != null && Object.hasOwnProperty.call(message, "address"))
            writer.uint32(10).string(message.address);
        if (message.public_key != null && Object.hasOwnProperty.call(message, "public_key"))
            writer.uint32(18).string(message.public_key);
        return writer;
    };

    PolkadotAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    PolkadotAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.PolkadotAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.string();
                break;
            case 2:
                message.public_key = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    PolkadotAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    PolkadotAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address != null && message.hasOwnProperty("address"))
            if (!$util.isString(message.address))
                return "address: string expected";
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            if (!$util.isString(message.public_key))
                return "public_key: string expected";
        return null;
    };

    PolkadotAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.PolkadotAddress)
            return object;
        var message = new $root.PolkadotAddress();
        if (object.address != null)
            message.address = String(object.address);
        if (object.public_key != null)
            message.public_key = String(object.public_key);
        return message;
    };

    PolkadotAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.address = "";
            object.public_key = "";
        }
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            object.public_key = message.public_key;
        return object;
    };

    PolkadotAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return PolkadotAddress;
})();

$root.PolkadotSignTx = (function() {

    function PolkadotSignTx(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    PolkadotSignTx.prototype.address_n = $util.emptyArray;
    PolkadotSignTx.prototype.raw_tx = $util.newBuffer([]);
    PolkadotSignTx.prototype.network = "";
    PolkadotSignTx.prototype.prefix = 0;

    PolkadotSignTx.create = function create(properties) {
        return new PolkadotSignTx(properties);
    };

    PolkadotSignTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).bytes(message.raw_tx);
        writer.uint32(26).string(message.network);
        if (message.prefix != null && Object.hasOwnProperty.call(message, "prefix"))
            writer.uint32(32).uint32(message.prefix);
        return writer;
    };

    PolkadotSignTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    PolkadotSignTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.PolkadotSignTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.raw_tx = reader.bytes();
                break;
            case 3:
                message.network = reader.string();
                break;
            case 4:
                message.prefix = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("raw_tx"))
            throw $util.ProtocolError("missing required 'raw_tx'", { instance: message });
        if (!message.hasOwnProperty("network"))
            throw $util.ProtocolError("missing required 'network'", { instance: message });
        return message;
    };

    PolkadotSignTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    PolkadotSignTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!(message.raw_tx && typeof message.raw_tx.length === "number" || $util.isString(message.raw_tx)))
            return "raw_tx: buffer expected";
        if (!$util.isString(message.network))
            return "network: string expected";
        if (message.prefix != null && message.hasOwnProperty("prefix"))
            if (!$util.isInteger(message.prefix))
                return "prefix: integer expected";
        return null;
    };

    PolkadotSignTx.fromObject = function fromObject(object) {
        if (object instanceof $root.PolkadotSignTx)
            return object;
        var message = new $root.PolkadotSignTx();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".PolkadotSignTx.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.raw_tx != null)
            if (typeof object.raw_tx === "string")
                $util.base64.decode(object.raw_tx, message.raw_tx = $util.newBuffer($util.base64.length(object.raw_tx)), 0);
            else if (object.raw_tx.length)
                message.raw_tx = object.raw_tx;
        if (object.network != null)
            message.network = String(object.network);
        if (object.prefix != null)
            message.prefix = object.prefix >>> 0;
        return message;
    };

    PolkadotSignTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            if (options.bytes === String)
                object.raw_tx = "";
            else {
                object.raw_tx = [];
                if (options.bytes !== Array)
                    object.raw_tx = $util.newBuffer(object.raw_tx);
            }
            object.network = "";
            object.prefix = 0;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.raw_tx != null && message.hasOwnProperty("raw_tx"))
            object.raw_tx = options.bytes === String ? $util.base64.encode(message.raw_tx, 0, message.raw_tx.length) : options.bytes === Array ? Array.prototype.slice.call(message.raw_tx) : message.raw_tx;
        if (message.network != null && message.hasOwnProperty("network"))
            object.network = message.network;
        if (message.prefix != null && message.hasOwnProperty("prefix"))
            object.prefix = message.prefix;
        return object;
    };

    PolkadotSignTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return PolkadotSignTx;
})();

$root.PolkadotSignedTx = (function() {

    function PolkadotSignedTx(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    PolkadotSignedTx.prototype.signature = $util.newBuffer([]);

    PolkadotSignedTx.create = function create(properties) {
        return new PolkadotSignedTx(properties);
    };

    PolkadotSignedTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.signature);
        return writer;
    };

    PolkadotSignedTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    PolkadotSignedTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.PolkadotSignedTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.signature = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        return message;
    };

    PolkadotSignedTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    PolkadotSignedTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        return null;
    };

    PolkadotSignedTx.fromObject = function fromObject(object) {
        if (object instanceof $root.PolkadotSignedTx)
            return object;
        var message = new $root.PolkadotSignedTx();
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        return message;
    };

    PolkadotSignedTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        return object;
    };

    PolkadotSignedTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return PolkadotSignedTx;
})();

$root.RippleGetAddress = (function() {

    function RippleGetAddress(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    RippleGetAddress.prototype.address_n = $util.emptyArray;
    RippleGetAddress.prototype.show_display = false;

    RippleGetAddress.create = function create(properties) {
        return new RippleGetAddress(properties);
    };

    RippleGetAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(16).bool(message.show_display);
        return writer;
    };

    RippleGetAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    RippleGetAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.RippleGetAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.show_display = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    RippleGetAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    RippleGetAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        return null;
    };

    RippleGetAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.RippleGetAddress)
            return object;
        var message = new $root.RippleGetAddress();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".RippleGetAddress.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        return message;
    };

    RippleGetAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            object.show_display = false;
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        return object;
    };

    RippleGetAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return RippleGetAddress;
})();

$root.RippleAddress = (function() {

    function RippleAddress(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    RippleAddress.prototype.address = "";

    RippleAddress.create = function create(properties) {
        return new RippleAddress(properties);
    };

    RippleAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.address);
        return writer;
    };

    RippleAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    RippleAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.RippleAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("address"))
            throw $util.ProtocolError("missing required 'address'", { instance: message });
        return message;
    };

    RippleAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    RippleAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.address))
            return "address: string expected";
        return null;
    };

    RippleAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.RippleAddress)
            return object;
        var message = new $root.RippleAddress();
        if (object.address != null)
            message.address = String(object.address);
        return message;
    };

    RippleAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.address = "";
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    RippleAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return RippleAddress;
})();

$root.RippleSignTx = (function() {

    function RippleSignTx(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    RippleSignTx.prototype.address_n = $util.emptyArray;
    RippleSignTx.prototype.fee = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    RippleSignTx.prototype.flags = 0;
    RippleSignTx.prototype.sequence = 0;
    RippleSignTx.prototype.last_ledger_sequence = 0;
    RippleSignTx.prototype.payment = null;

    RippleSignTx.create = function create(properties) {
        return new RippleSignTx(properties);
    };

    RippleSignTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.fee != null && Object.hasOwnProperty.call(message, "fee"))
            writer.uint32(16).uint64(message.fee);
        if (message.flags != null && Object.hasOwnProperty.call(message, "flags"))
            writer.uint32(24).uint32(message.flags);
        if (message.sequence != null && Object.hasOwnProperty.call(message, "sequence"))
            writer.uint32(32).uint32(message.sequence);
        if (message.last_ledger_sequence != null && Object.hasOwnProperty.call(message, "last_ledger_sequence"))
            writer.uint32(40).uint32(message.last_ledger_sequence);
        if (message.payment != null && Object.hasOwnProperty.call(message, "payment"))
            $root.RippleSignTx.RipplePayment.encode(message.payment, writer.uint32(50).fork()).ldelim();
        return writer;
    };

    RippleSignTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    RippleSignTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.RippleSignTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.fee = reader.uint64();
                break;
            case 3:
                message.flags = reader.uint32();
                break;
            case 4:
                message.sequence = reader.uint32();
                break;
            case 5:
                message.last_ledger_sequence = reader.uint32();
                break;
            case 6:
                message.payment = $root.RippleSignTx.RipplePayment.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    RippleSignTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    RippleSignTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.fee != null && message.hasOwnProperty("fee"))
            if (!$util.isInteger(message.fee) && !(message.fee && $util.isInteger(message.fee.low) && $util.isInteger(message.fee.high)))
                return "fee: integer|Long expected";
        if (message.flags != null && message.hasOwnProperty("flags"))
            if (!$util.isInteger(message.flags))
                return "flags: integer expected";
        if (message.sequence != null && message.hasOwnProperty("sequence"))
            if (!$util.isInteger(message.sequence))
                return "sequence: integer expected";
        if (message.last_ledger_sequence != null && message.hasOwnProperty("last_ledger_sequence"))
            if (!$util.isInteger(message.last_ledger_sequence))
                return "last_ledger_sequence: integer expected";
        if (message.payment != null && message.hasOwnProperty("payment")) {
            var error = $root.RippleSignTx.RipplePayment.verify(message.payment);
            if (error)
                return "payment." + error;
        }
        return null;
    };

    RippleSignTx.fromObject = function fromObject(object) {
        if (object instanceof $root.RippleSignTx)
            return object;
        var message = new $root.RippleSignTx();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".RippleSignTx.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.fee != null)
            if ($util.Long)
                (message.fee = $util.Long.fromValue(object.fee)).unsigned = true;
            else if (typeof object.fee === "string")
                message.fee = parseInt(object.fee, 10);
            else if (typeof object.fee === "number")
                message.fee = object.fee;
            else if (typeof object.fee === "object")
                message.fee = new $util.LongBits(object.fee.low >>> 0, object.fee.high >>> 0).toNumber(true);
        if (object.flags != null)
            message.flags = object.flags >>> 0;
        if (object.sequence != null)
            message.sequence = object.sequence >>> 0;
        if (object.last_ledger_sequence != null)
            message.last_ledger_sequence = object.last_ledger_sequence >>> 0;
        if (object.payment != null) {
            if (typeof object.payment !== "object")
                throw TypeError(".RippleSignTx.payment: object expected");
            message.payment = $root.RippleSignTx.RipplePayment.fromObject(object.payment);
        }
        return message;
    };

    RippleSignTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.fee = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.fee = options.longs === String ? "0" : 0;
            object.flags = 0;
            object.sequence = 0;
            object.last_ledger_sequence = 0;
            object.payment = null;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.fee != null && message.hasOwnProperty("fee"))
            if (typeof message.fee === "number")
                object.fee = options.longs === String ? String(message.fee) : message.fee;
            else
                object.fee = options.longs === String ? $util.Long.prototype.toString.call(message.fee) : options.longs === Number ? new $util.LongBits(message.fee.low >>> 0, message.fee.high >>> 0).toNumber(true) : message.fee;
        if (message.flags != null && message.hasOwnProperty("flags"))
            object.flags = message.flags;
        if (message.sequence != null && message.hasOwnProperty("sequence"))
            object.sequence = message.sequence;
        if (message.last_ledger_sequence != null && message.hasOwnProperty("last_ledger_sequence"))
            object.last_ledger_sequence = message.last_ledger_sequence;
        if (message.payment != null && message.hasOwnProperty("payment"))
            object.payment = $root.RippleSignTx.RipplePayment.toObject(message.payment, options);
        return object;
    };

    RippleSignTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    RippleSignTx.RipplePayment = (function() {

        function RipplePayment(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        RipplePayment.prototype.amount = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        RipplePayment.prototype.destination = "";
        RipplePayment.prototype.destination_tag = 0;

        RipplePayment.create = function create(properties) {
            return new RipplePayment(properties);
        };

        RipplePayment.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(8).uint64(message.amount);
            writer.uint32(18).string(message.destination);
            if (message.destination_tag != null && Object.hasOwnProperty.call(message, "destination_tag"))
                writer.uint32(24).uint32(message.destination_tag);
            return writer;
        };

        RipplePayment.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        RipplePayment.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.RippleSignTx.RipplePayment();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.amount = reader.uint64();
                    break;
                case 2:
                    message.destination = reader.string();
                    break;
                case 3:
                    message.destination_tag = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("amount"))
                throw $util.ProtocolError("missing required 'amount'", { instance: message });
            if (!message.hasOwnProperty("destination"))
                throw $util.ProtocolError("missing required 'destination'", { instance: message });
            return message;
        };

        RipplePayment.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        RipplePayment.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
                return "amount: integer|Long expected";
            if (!$util.isString(message.destination))
                return "destination: string expected";
            if (message.destination_tag != null && message.hasOwnProperty("destination_tag"))
                if (!$util.isInteger(message.destination_tag))
                    return "destination_tag: integer expected";
            return null;
        };

        RipplePayment.fromObject = function fromObject(object) {
            if (object instanceof $root.RippleSignTx.RipplePayment)
                return object;
            var message = new $root.RippleSignTx.RipplePayment();
            if (object.amount != null)
                if ($util.Long)
                    (message.amount = $util.Long.fromValue(object.amount)).unsigned = true;
                else if (typeof object.amount === "string")
                    message.amount = parseInt(object.amount, 10);
                else if (typeof object.amount === "number")
                    message.amount = object.amount;
                else if (typeof object.amount === "object")
                    message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber(true);
            if (object.destination != null)
                message.destination = String(object.destination);
            if (object.destination_tag != null)
                message.destination_tag = object.destination_tag >>> 0;
            return message;
        };

        RipplePayment.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.amount = options.longs === String ? "0" : 0;
                object.destination = "";
                object.destination_tag = 0;
            }
            if (message.amount != null && message.hasOwnProperty("amount"))
                if (typeof message.amount === "number")
                    object.amount = options.longs === String ? String(message.amount) : message.amount;
                else
                    object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber(true) : message.amount;
            if (message.destination != null && message.hasOwnProperty("destination"))
                object.destination = message.destination;
            if (message.destination_tag != null && message.hasOwnProperty("destination_tag"))
                object.destination_tag = message.destination_tag;
            return object;
        };

        RipplePayment.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RipplePayment;
    })();

    return RippleSignTx;
})();

$root.RippleSignedTx = (function() {

    function RippleSignedTx(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    RippleSignedTx.prototype.signature = $util.newBuffer([]);
    RippleSignedTx.prototype.serialized_tx = $util.newBuffer([]);

    RippleSignedTx.create = function create(properties) {
        return new RippleSignedTx(properties);
    };

    RippleSignedTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.signature);
        writer.uint32(18).bytes(message.serialized_tx);
        return writer;
    };

    RippleSignedTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    RippleSignedTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.RippleSignedTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.signature = reader.bytes();
                break;
            case 2:
                message.serialized_tx = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        if (!message.hasOwnProperty("serialized_tx"))
            throw $util.ProtocolError("missing required 'serialized_tx'", { instance: message });
        return message;
    };

    RippleSignedTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    RippleSignedTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        if (!(message.serialized_tx && typeof message.serialized_tx.length === "number" || $util.isString(message.serialized_tx)))
            return "serialized_tx: buffer expected";
        return null;
    };

    RippleSignedTx.fromObject = function fromObject(object) {
        if (object instanceof $root.RippleSignedTx)
            return object;
        var message = new $root.RippleSignedTx();
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        if (object.serialized_tx != null)
            if (typeof object.serialized_tx === "string")
                $util.base64.decode(object.serialized_tx, message.serialized_tx = $util.newBuffer($util.base64.length(object.serialized_tx)), 0);
            else if (object.serialized_tx.length)
                message.serialized_tx = object.serialized_tx;
        return message;
    };

    RippleSignedTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
            if (options.bytes === String)
                object.serialized_tx = "";
            else {
                object.serialized_tx = [];
                if (options.bytes !== Array)
                    object.serialized_tx = $util.newBuffer(object.serialized_tx);
            }
        }
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        if (message.serialized_tx != null && message.hasOwnProperty("serialized_tx"))
            object.serialized_tx = options.bytes === String ? $util.base64.encode(message.serialized_tx, 0, message.serialized_tx.length) : options.bytes === Array ? Array.prototype.slice.call(message.serialized_tx) : message.serialized_tx;
        return object;
    };

    RippleSignedTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return RippleSignedTx;
})();

$root.ScdoGetAddress = (function() {

    function ScdoGetAddress(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ScdoGetAddress.prototype.address_n = $util.emptyArray;
    ScdoGetAddress.prototype.show_display = false;

    ScdoGetAddress.create = function create(properties) {
        return new ScdoGetAddress(properties);
    };

    ScdoGetAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(16).bool(message.show_display);
        return writer;
    };

    ScdoGetAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ScdoGetAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ScdoGetAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.show_display = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    ScdoGetAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ScdoGetAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        return null;
    };

    ScdoGetAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.ScdoGetAddress)
            return object;
        var message = new $root.ScdoGetAddress();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".ScdoGetAddress.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        return message;
    };

    ScdoGetAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            object.show_display = false;
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        return object;
    };

    ScdoGetAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ScdoGetAddress;
})();

$root.ScdoAddress = (function() {

    function ScdoAddress(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ScdoAddress.prototype.address = "";

    ScdoAddress.create = function create(properties) {
        return new ScdoAddress(properties);
    };

    ScdoAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.address);
        return writer;
    };

    ScdoAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ScdoAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ScdoAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("address"))
            throw $util.ProtocolError("missing required 'address'", { instance: message });
        return message;
    };

    ScdoAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ScdoAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.address))
            return "address: string expected";
        return null;
    };

    ScdoAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.ScdoAddress)
            return object;
        var message = new $root.ScdoAddress();
        if (object.address != null)
            message.address = String(object.address);
        return message;
    };

    ScdoAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.address = "";
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    ScdoAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ScdoAddress;
})();

$root.ScdoSignTx = (function() {

    function ScdoSignTx(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ScdoSignTx.prototype.address_n = $util.emptyArray;
    ScdoSignTx.prototype.nonce = $util.newBuffer([]);
    ScdoSignTx.prototype.gas_price = $util.newBuffer([]);
    ScdoSignTx.prototype.gas_limit = $util.newBuffer([]);
    ScdoSignTx.prototype.to = "";
    ScdoSignTx.prototype.value = $util.newBuffer([]);
    ScdoSignTx.prototype.timestamp = $util.newBuffer([]);
    ScdoSignTx.prototype.data_initial_chunk = $util.newBuffer([]);
    ScdoSignTx.prototype.data_length = 0;
    ScdoSignTx.prototype.tx_type = 0;

    ScdoSignTx.create = function create(properties) {
        return new ScdoSignTx(properties);
    };

    ScdoSignTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).bytes(message.nonce);
        writer.uint32(26).bytes(message.gas_price);
        writer.uint32(34).bytes(message.gas_limit);
        writer.uint32(42).string(message.to);
        writer.uint32(50).bytes(message.value);
        if (message.timestamp != null && Object.hasOwnProperty.call(message, "timestamp"))
            writer.uint32(58).bytes(message.timestamp);
        if (message.data_initial_chunk != null && Object.hasOwnProperty.call(message, "data_initial_chunk"))
            writer.uint32(66).bytes(message.data_initial_chunk);
        if (message.data_length != null && Object.hasOwnProperty.call(message, "data_length"))
            writer.uint32(72).uint32(message.data_length);
        if (message.tx_type != null && Object.hasOwnProperty.call(message, "tx_type"))
            writer.uint32(80).uint32(message.tx_type);
        return writer;
    };

    ScdoSignTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ScdoSignTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ScdoSignTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.nonce = reader.bytes();
                break;
            case 3:
                message.gas_price = reader.bytes();
                break;
            case 4:
                message.gas_limit = reader.bytes();
                break;
            case 5:
                message.to = reader.string();
                break;
            case 6:
                message.value = reader.bytes();
                break;
            case 7:
                message.timestamp = reader.bytes();
                break;
            case 8:
                message.data_initial_chunk = reader.bytes();
                break;
            case 9:
                message.data_length = reader.uint32();
                break;
            case 10:
                message.tx_type = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("nonce"))
            throw $util.ProtocolError("missing required 'nonce'", { instance: message });
        if (!message.hasOwnProperty("gas_price"))
            throw $util.ProtocolError("missing required 'gas_price'", { instance: message });
        if (!message.hasOwnProperty("gas_limit"))
            throw $util.ProtocolError("missing required 'gas_limit'", { instance: message });
        if (!message.hasOwnProperty("to"))
            throw $util.ProtocolError("missing required 'to'", { instance: message });
        if (!message.hasOwnProperty("value"))
            throw $util.ProtocolError("missing required 'value'", { instance: message });
        return message;
    };

    ScdoSignTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ScdoSignTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!(message.nonce && typeof message.nonce.length === "number" || $util.isString(message.nonce)))
            return "nonce: buffer expected";
        if (!(message.gas_price && typeof message.gas_price.length === "number" || $util.isString(message.gas_price)))
            return "gas_price: buffer expected";
        if (!(message.gas_limit && typeof message.gas_limit.length === "number" || $util.isString(message.gas_limit)))
            return "gas_limit: buffer expected";
        if (!$util.isString(message.to))
            return "to: string expected";
        if (!(message.value && typeof message.value.length === "number" || $util.isString(message.value)))
            return "value: buffer expected";
        if (message.timestamp != null && message.hasOwnProperty("timestamp"))
            if (!(message.timestamp && typeof message.timestamp.length === "number" || $util.isString(message.timestamp)))
                return "timestamp: buffer expected";
        if (message.data_initial_chunk != null && message.hasOwnProperty("data_initial_chunk"))
            if (!(message.data_initial_chunk && typeof message.data_initial_chunk.length === "number" || $util.isString(message.data_initial_chunk)))
                return "data_initial_chunk: buffer expected";
        if (message.data_length != null && message.hasOwnProperty("data_length"))
            if (!$util.isInteger(message.data_length))
                return "data_length: integer expected";
        if (message.tx_type != null && message.hasOwnProperty("tx_type"))
            if (!$util.isInteger(message.tx_type))
                return "tx_type: integer expected";
        return null;
    };

    ScdoSignTx.fromObject = function fromObject(object) {
        if (object instanceof $root.ScdoSignTx)
            return object;
        var message = new $root.ScdoSignTx();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".ScdoSignTx.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.nonce != null)
            if (typeof object.nonce === "string")
                $util.base64.decode(object.nonce, message.nonce = $util.newBuffer($util.base64.length(object.nonce)), 0);
            else if (object.nonce.length)
                message.nonce = object.nonce;
        if (object.gas_price != null)
            if (typeof object.gas_price === "string")
                $util.base64.decode(object.gas_price, message.gas_price = $util.newBuffer($util.base64.length(object.gas_price)), 0);
            else if (object.gas_price.length)
                message.gas_price = object.gas_price;
        if (object.gas_limit != null)
            if (typeof object.gas_limit === "string")
                $util.base64.decode(object.gas_limit, message.gas_limit = $util.newBuffer($util.base64.length(object.gas_limit)), 0);
            else if (object.gas_limit.length)
                message.gas_limit = object.gas_limit;
        if (object.to != null)
            message.to = String(object.to);
        if (object.value != null)
            if (typeof object.value === "string")
                $util.base64.decode(object.value, message.value = $util.newBuffer($util.base64.length(object.value)), 0);
            else if (object.value.length)
                message.value = object.value;
        if (object.timestamp != null)
            if (typeof object.timestamp === "string")
                $util.base64.decode(object.timestamp, message.timestamp = $util.newBuffer($util.base64.length(object.timestamp)), 0);
            else if (object.timestamp.length)
                message.timestamp = object.timestamp;
        if (object.data_initial_chunk != null)
            if (typeof object.data_initial_chunk === "string")
                $util.base64.decode(object.data_initial_chunk, message.data_initial_chunk = $util.newBuffer($util.base64.length(object.data_initial_chunk)), 0);
            else if (object.data_initial_chunk.length)
                message.data_initial_chunk = object.data_initial_chunk;
        if (object.data_length != null)
            message.data_length = object.data_length >>> 0;
        if (object.tx_type != null)
            message.tx_type = object.tx_type >>> 0;
        return message;
    };

    ScdoSignTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            if (options.bytes === String)
                object.nonce = "";
            else {
                object.nonce = [];
                if (options.bytes !== Array)
                    object.nonce = $util.newBuffer(object.nonce);
            }
            if (options.bytes === String)
                object.gas_price = "";
            else {
                object.gas_price = [];
                if (options.bytes !== Array)
                    object.gas_price = $util.newBuffer(object.gas_price);
            }
            if (options.bytes === String)
                object.gas_limit = "";
            else {
                object.gas_limit = [];
                if (options.bytes !== Array)
                    object.gas_limit = $util.newBuffer(object.gas_limit);
            }
            object.to = "";
            if (options.bytes === String)
                object.value = "";
            else {
                object.value = [];
                if (options.bytes !== Array)
                    object.value = $util.newBuffer(object.value);
            }
            if (options.bytes === String)
                object.timestamp = "";
            else {
                object.timestamp = [];
                if (options.bytes !== Array)
                    object.timestamp = $util.newBuffer(object.timestamp);
            }
            if (options.bytes === String)
                object.data_initial_chunk = "";
            else {
                object.data_initial_chunk = [];
                if (options.bytes !== Array)
                    object.data_initial_chunk = $util.newBuffer(object.data_initial_chunk);
            }
            object.data_length = 0;
            object.tx_type = 0;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.nonce != null && message.hasOwnProperty("nonce"))
            object.nonce = options.bytes === String ? $util.base64.encode(message.nonce, 0, message.nonce.length) : options.bytes === Array ? Array.prototype.slice.call(message.nonce) : message.nonce;
        if (message.gas_price != null && message.hasOwnProperty("gas_price"))
            object.gas_price = options.bytes === String ? $util.base64.encode(message.gas_price, 0, message.gas_price.length) : options.bytes === Array ? Array.prototype.slice.call(message.gas_price) : message.gas_price;
        if (message.gas_limit != null && message.hasOwnProperty("gas_limit"))
            object.gas_limit = options.bytes === String ? $util.base64.encode(message.gas_limit, 0, message.gas_limit.length) : options.bytes === Array ? Array.prototype.slice.call(message.gas_limit) : message.gas_limit;
        if (message.to != null && message.hasOwnProperty("to"))
            object.to = message.to;
        if (message.value != null && message.hasOwnProperty("value"))
            object.value = options.bytes === String ? $util.base64.encode(message.value, 0, message.value.length) : options.bytes === Array ? Array.prototype.slice.call(message.value) : message.value;
        if (message.timestamp != null && message.hasOwnProperty("timestamp"))
            object.timestamp = options.bytes === String ? $util.base64.encode(message.timestamp, 0, message.timestamp.length) : options.bytes === Array ? Array.prototype.slice.call(message.timestamp) : message.timestamp;
        if (message.data_initial_chunk != null && message.hasOwnProperty("data_initial_chunk"))
            object.data_initial_chunk = options.bytes === String ? $util.base64.encode(message.data_initial_chunk, 0, message.data_initial_chunk.length) : options.bytes === Array ? Array.prototype.slice.call(message.data_initial_chunk) : message.data_initial_chunk;
        if (message.data_length != null && message.hasOwnProperty("data_length"))
            object.data_length = message.data_length;
        if (message.tx_type != null && message.hasOwnProperty("tx_type"))
            object.tx_type = message.tx_type;
        return object;
    };

    ScdoSignTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ScdoSignTx;
})();

$root.ScdoSignedTx = (function() {

    function ScdoSignedTx(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ScdoSignedTx.prototype.data_length = 0;
    ScdoSignedTx.prototype.signature = $util.newBuffer([]);

    ScdoSignedTx.create = function create(properties) {
        return new ScdoSignedTx(properties);
    };

    ScdoSignedTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.data_length != null && Object.hasOwnProperty.call(message, "data_length"))
            writer.uint32(8).uint32(message.data_length);
        if (message.signature != null && Object.hasOwnProperty.call(message, "signature"))
            writer.uint32(18).bytes(message.signature);
        return writer;
    };

    ScdoSignedTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ScdoSignedTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ScdoSignedTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.data_length = reader.uint32();
                break;
            case 2:
                message.signature = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    ScdoSignedTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ScdoSignedTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.data_length != null && message.hasOwnProperty("data_length"))
            if (!$util.isInteger(message.data_length))
                return "data_length: integer expected";
        if (message.signature != null && message.hasOwnProperty("signature"))
            if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
                return "signature: buffer expected";
        return null;
    };

    ScdoSignedTx.fromObject = function fromObject(object) {
        if (object instanceof $root.ScdoSignedTx)
            return object;
        var message = new $root.ScdoSignedTx();
        if (object.data_length != null)
            message.data_length = object.data_length >>> 0;
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        return message;
    };

    ScdoSignedTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.data_length = 0;
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
        }
        if (message.data_length != null && message.hasOwnProperty("data_length"))
            object.data_length = message.data_length;
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        return object;
    };

    ScdoSignedTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ScdoSignedTx;
})();

$root.ScdoTxAck = (function() {

    function ScdoTxAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ScdoTxAck.prototype.data_chunk = $util.newBuffer([]);

    ScdoTxAck.create = function create(properties) {
        return new ScdoTxAck(properties);
    };

    ScdoTxAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.data_chunk != null && Object.hasOwnProperty.call(message, "data_chunk"))
            writer.uint32(10).bytes(message.data_chunk);
        return writer;
    };

    ScdoTxAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ScdoTxAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ScdoTxAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.data_chunk = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    ScdoTxAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ScdoTxAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.data_chunk != null && message.hasOwnProperty("data_chunk"))
            if (!(message.data_chunk && typeof message.data_chunk.length === "number" || $util.isString(message.data_chunk)))
                return "data_chunk: buffer expected";
        return null;
    };

    ScdoTxAck.fromObject = function fromObject(object) {
        if (object instanceof $root.ScdoTxAck)
            return object;
        var message = new $root.ScdoTxAck();
        if (object.data_chunk != null)
            if (typeof object.data_chunk === "string")
                $util.base64.decode(object.data_chunk, message.data_chunk = $util.newBuffer($util.base64.length(object.data_chunk)), 0);
            else if (object.data_chunk.length)
                message.data_chunk = object.data_chunk;
        return message;
    };

    ScdoTxAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.data_chunk = "";
            else {
                object.data_chunk = [];
                if (options.bytes !== Array)
                    object.data_chunk = $util.newBuffer(object.data_chunk);
            }
        if (message.data_chunk != null && message.hasOwnProperty("data_chunk"))
            object.data_chunk = options.bytes === String ? $util.base64.encode(message.data_chunk, 0, message.data_chunk.length) : options.bytes === Array ? Array.prototype.slice.call(message.data_chunk) : message.data_chunk;
        return object;
    };

    ScdoTxAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ScdoTxAck;
})();

$root.ScdoSignMessage = (function() {

    function ScdoSignMessage(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ScdoSignMessage.prototype.address_n = $util.emptyArray;
    ScdoSignMessage.prototype.message = $util.newBuffer([]);

    ScdoSignMessage.create = function create(properties) {
        return new ScdoSignMessage(properties);
    };

    ScdoSignMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
            writer.uint32(18).bytes(message.message);
        return writer;
    };

    ScdoSignMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ScdoSignMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ScdoSignMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.message = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    ScdoSignMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ScdoSignMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.message != null && message.hasOwnProperty("message"))
            if (!(message.message && typeof message.message.length === "number" || $util.isString(message.message)))
                return "message: buffer expected";
        return null;
    };

    ScdoSignMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.ScdoSignMessage)
            return object;
        var message = new $root.ScdoSignMessage();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".ScdoSignMessage.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.message != null)
            if (typeof object.message === "string")
                $util.base64.decode(object.message, message.message = $util.newBuffer($util.base64.length(object.message)), 0);
            else if (object.message.length)
                message.message = object.message;
        return message;
    };

    ScdoSignMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            if (options.bytes === String)
                object.message = "";
            else {
                object.message = [];
                if (options.bytes !== Array)
                    object.message = $util.newBuffer(object.message);
            }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.message != null && message.hasOwnProperty("message"))
            object.message = options.bytes === String ? $util.base64.encode(message.message, 0, message.message.length) : options.bytes === Array ? Array.prototype.slice.call(message.message) : message.message;
        return object;
    };

    ScdoSignMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ScdoSignMessage;
})();

$root.ScdoSignedMessage = (function() {

    function ScdoSignedMessage(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ScdoSignedMessage.prototype.signature = $util.newBuffer([]);
    ScdoSignedMessage.prototype.address = "";

    ScdoSignedMessage.create = function create(properties) {
        return new ScdoSignedMessage(properties);
    };

    ScdoSignedMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.signature != null && Object.hasOwnProperty.call(message, "signature"))
            writer.uint32(10).bytes(message.signature);
        if (message.address != null && Object.hasOwnProperty.call(message, "address"))
            writer.uint32(18).string(message.address);
        return writer;
    };

    ScdoSignedMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ScdoSignedMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ScdoSignedMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.signature = reader.bytes();
                break;
            case 2:
                message.address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    ScdoSignedMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ScdoSignedMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.signature != null && message.hasOwnProperty("signature"))
            if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
                return "signature: buffer expected";
        if (message.address != null && message.hasOwnProperty("address"))
            if (!$util.isString(message.address))
                return "address: string expected";
        return null;
    };

    ScdoSignedMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.ScdoSignedMessage)
            return object;
        var message = new $root.ScdoSignedMessage();
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        if (object.address != null)
            message.address = String(object.address);
        return message;
    };

    ScdoSignedMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
            object.address = "";
        }
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    ScdoSignedMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ScdoSignedMessage;
})();

$root.SolanaGetAddress = (function() {

    function SolanaGetAddress(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    SolanaGetAddress.prototype.address_n = $util.emptyArray;
    SolanaGetAddress.prototype.show_display = false;

    SolanaGetAddress.create = function create(properties) {
        return new SolanaGetAddress(properties);
    };

    SolanaGetAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(16).bool(message.show_display);
        return writer;
    };

    SolanaGetAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    SolanaGetAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SolanaGetAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.show_display = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    SolanaGetAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    SolanaGetAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        return null;
    };

    SolanaGetAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.SolanaGetAddress)
            return object;
        var message = new $root.SolanaGetAddress();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".SolanaGetAddress.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        return message;
    };

    SolanaGetAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            object.show_display = false;
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        return object;
    };

    SolanaGetAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SolanaGetAddress;
})();

$root.SolanaAddress = (function() {

    function SolanaAddress(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    SolanaAddress.prototype.address = "";

    SolanaAddress.create = function create(properties) {
        return new SolanaAddress(properties);
    };

    SolanaAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address != null && Object.hasOwnProperty.call(message, "address"))
            writer.uint32(10).string(message.address);
        return writer;
    };

    SolanaAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    SolanaAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SolanaAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    SolanaAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    SolanaAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address != null && message.hasOwnProperty("address"))
            if (!$util.isString(message.address))
                return "address: string expected";
        return null;
    };

    SolanaAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.SolanaAddress)
            return object;
        var message = new $root.SolanaAddress();
        if (object.address != null)
            message.address = String(object.address);
        return message;
    };

    SolanaAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.address = "";
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    SolanaAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SolanaAddress;
})();

$root.SolanaTxATADetails = (function() {

    function SolanaTxATADetails(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    SolanaTxATADetails.prototype.owner_address = "";
    SolanaTxATADetails.prototype.program_id = "";
    SolanaTxATADetails.prototype.mint_address = "";
    SolanaTxATADetails.prototype.associated_token_address = "";

    SolanaTxATADetails.create = function create(properties) {
        return new SolanaTxATADetails(properties);
    };

    SolanaTxATADetails.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.owner_address);
        writer.uint32(18).string(message.program_id);
        writer.uint32(26).string(message.mint_address);
        writer.uint32(34).string(message.associated_token_address);
        return writer;
    };

    SolanaTxATADetails.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    SolanaTxATADetails.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SolanaTxATADetails();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.owner_address = reader.string();
                break;
            case 2:
                message.program_id = reader.string();
                break;
            case 3:
                message.mint_address = reader.string();
                break;
            case 4:
                message.associated_token_address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("owner_address"))
            throw $util.ProtocolError("missing required 'owner_address'", { instance: message });
        if (!message.hasOwnProperty("program_id"))
            throw $util.ProtocolError("missing required 'program_id'", { instance: message });
        if (!message.hasOwnProperty("mint_address"))
            throw $util.ProtocolError("missing required 'mint_address'", { instance: message });
        if (!message.hasOwnProperty("associated_token_address"))
            throw $util.ProtocolError("missing required 'associated_token_address'", { instance: message });
        return message;
    };

    SolanaTxATADetails.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    SolanaTxATADetails.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.owner_address))
            return "owner_address: string expected";
        if (!$util.isString(message.program_id))
            return "program_id: string expected";
        if (!$util.isString(message.mint_address))
            return "mint_address: string expected";
        if (!$util.isString(message.associated_token_address))
            return "associated_token_address: string expected";
        return null;
    };

    SolanaTxATADetails.fromObject = function fromObject(object) {
        if (object instanceof $root.SolanaTxATADetails)
            return object;
        var message = new $root.SolanaTxATADetails();
        if (object.owner_address != null)
            message.owner_address = String(object.owner_address);
        if (object.program_id != null)
            message.program_id = String(object.program_id);
        if (object.mint_address != null)
            message.mint_address = String(object.mint_address);
        if (object.associated_token_address != null)
            message.associated_token_address = String(object.associated_token_address);
        return message;
    };

    SolanaTxATADetails.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.owner_address = "";
            object.program_id = "";
            object.mint_address = "";
            object.associated_token_address = "";
        }
        if (message.owner_address != null && message.hasOwnProperty("owner_address"))
            object.owner_address = message.owner_address;
        if (message.program_id != null && message.hasOwnProperty("program_id"))
            object.program_id = message.program_id;
        if (message.mint_address != null && message.hasOwnProperty("mint_address"))
            object.mint_address = message.mint_address;
        if (message.associated_token_address != null && message.hasOwnProperty("associated_token_address"))
            object.associated_token_address = message.associated_token_address;
        return object;
    };

    SolanaTxATADetails.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SolanaTxATADetails;
})();

$root.SolanaTxExtraInfo = (function() {

    function SolanaTxExtraInfo(properties) {
        this.ata_details = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    SolanaTxExtraInfo.prototype.ata_details = $util.emptyArray;

    SolanaTxExtraInfo.create = function create(properties) {
        return new SolanaTxExtraInfo(properties);
    };

    SolanaTxExtraInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.ata_details != null && message.ata_details.length)
            for (var i = 0; i < message.ata_details.length; ++i)
                $root.SolanaTxATADetails.encode(message.ata_details[i], writer.uint32(10).fork()).ldelim();
        return writer;
    };

    SolanaTxExtraInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    SolanaTxExtraInfo.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SolanaTxExtraInfo();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.ata_details && message.ata_details.length))
                    message.ata_details = [];
                message.ata_details.push($root.SolanaTxATADetails.decode(reader, reader.uint32()));
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    SolanaTxExtraInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    SolanaTxExtraInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.ata_details != null && message.hasOwnProperty("ata_details")) {
            if (!Array.isArray(message.ata_details))
                return "ata_details: array expected";
            for (var i = 0; i < message.ata_details.length; ++i) {
                var error = $root.SolanaTxATADetails.verify(message.ata_details[i]);
                if (error)
                    return "ata_details." + error;
            }
        }
        return null;
    };

    SolanaTxExtraInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.SolanaTxExtraInfo)
            return object;
        var message = new $root.SolanaTxExtraInfo();
        if (object.ata_details) {
            if (!Array.isArray(object.ata_details))
                throw TypeError(".SolanaTxExtraInfo.ata_details: array expected");
            message.ata_details = [];
            for (var i = 0; i < object.ata_details.length; ++i) {
                if (typeof object.ata_details[i] !== "object")
                    throw TypeError(".SolanaTxExtraInfo.ata_details: object expected");
                message.ata_details[i] = $root.SolanaTxATADetails.fromObject(object.ata_details[i]);
            }
        }
        return message;
    };

    SolanaTxExtraInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.ata_details = [];
        if (message.ata_details && message.ata_details.length) {
            object.ata_details = [];
            for (var j = 0; j < message.ata_details.length; ++j)
                object.ata_details[j] = $root.SolanaTxATADetails.toObject(message.ata_details[j], options);
        }
        return object;
    };

    SolanaTxExtraInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SolanaTxExtraInfo;
})();

$root.SolanaSignTx = (function() {

    function SolanaSignTx(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    SolanaSignTx.prototype.address_n = $util.emptyArray;
    SolanaSignTx.prototype.raw_tx = $util.newBuffer([]);
    SolanaSignTx.prototype.extra_info = null;

    SolanaSignTx.create = function create(properties) {
        return new SolanaSignTx(properties);
    };

    SolanaSignTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).bytes(message.raw_tx);
        if (message.extra_info != null && Object.hasOwnProperty.call(message, "extra_info"))
            $root.SolanaTxExtraInfo.encode(message.extra_info, writer.uint32(26).fork()).ldelim();
        return writer;
    };

    SolanaSignTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    SolanaSignTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SolanaSignTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.raw_tx = reader.bytes();
                break;
            case 3:
                message.extra_info = $root.SolanaTxExtraInfo.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("raw_tx"))
            throw $util.ProtocolError("missing required 'raw_tx'", { instance: message });
        return message;
    };

    SolanaSignTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    SolanaSignTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!(message.raw_tx && typeof message.raw_tx.length === "number" || $util.isString(message.raw_tx)))
            return "raw_tx: buffer expected";
        if (message.extra_info != null && message.hasOwnProperty("extra_info")) {
            var error = $root.SolanaTxExtraInfo.verify(message.extra_info);
            if (error)
                return "extra_info." + error;
        }
        return null;
    };

    SolanaSignTx.fromObject = function fromObject(object) {
        if (object instanceof $root.SolanaSignTx)
            return object;
        var message = new $root.SolanaSignTx();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".SolanaSignTx.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.raw_tx != null)
            if (typeof object.raw_tx === "string")
                $util.base64.decode(object.raw_tx, message.raw_tx = $util.newBuffer($util.base64.length(object.raw_tx)), 0);
            else if (object.raw_tx.length)
                message.raw_tx = object.raw_tx;
        if (object.extra_info != null) {
            if (typeof object.extra_info !== "object")
                throw TypeError(".SolanaSignTx.extra_info: object expected");
            message.extra_info = $root.SolanaTxExtraInfo.fromObject(object.extra_info);
        }
        return message;
    };

    SolanaSignTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            if (options.bytes === String)
                object.raw_tx = "";
            else {
                object.raw_tx = [];
                if (options.bytes !== Array)
                    object.raw_tx = $util.newBuffer(object.raw_tx);
            }
            object.extra_info = null;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.raw_tx != null && message.hasOwnProperty("raw_tx"))
            object.raw_tx = options.bytes === String ? $util.base64.encode(message.raw_tx, 0, message.raw_tx.length) : options.bytes === Array ? Array.prototype.slice.call(message.raw_tx) : message.raw_tx;
        if (message.extra_info != null && message.hasOwnProperty("extra_info"))
            object.extra_info = $root.SolanaTxExtraInfo.toObject(message.extra_info, options);
        return object;
    };

    SolanaSignTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SolanaSignTx;
})();

$root.SolanaSignedTx = (function() {

    function SolanaSignedTx(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    SolanaSignedTx.prototype.signature = $util.newBuffer([]);

    SolanaSignedTx.create = function create(properties) {
        return new SolanaSignedTx(properties);
    };

    SolanaSignedTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.signature != null && Object.hasOwnProperty.call(message, "signature"))
            writer.uint32(10).bytes(message.signature);
        return writer;
    };

    SolanaSignedTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    SolanaSignedTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SolanaSignedTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.signature = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    SolanaSignedTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    SolanaSignedTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.signature != null && message.hasOwnProperty("signature"))
            if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
                return "signature: buffer expected";
        return null;
    };

    SolanaSignedTx.fromObject = function fromObject(object) {
        if (object instanceof $root.SolanaSignedTx)
            return object;
        var message = new $root.SolanaSignedTx();
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        return message;
    };

    SolanaSignedTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        return object;
    };

    SolanaSignedTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SolanaSignedTx;
})();

$root.SolanaOffChainMessageVersion = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "MESSAGE_VERSION_0"] = 0;
    values[valuesById[1] = "MESSAGE_VERSION_1"] = 1;
    return values;
})();

$root.SolanaOffChainMessageFormat = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "V0_RESTRICTED_ASCII"] = 0;
    values[valuesById[1] = "V0_LIMITED_UTF8"] = 1;
    return values;
})();

$root.SolanaSignOffChainMessage = (function() {

    function SolanaSignOffChainMessage(properties) {
        this.address_n = [];
        this.required_signers = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    SolanaSignOffChainMessage.prototype.address_n = $util.emptyArray;
    SolanaSignOffChainMessage.prototype.message = $util.newBuffer([]);
    SolanaSignOffChainMessage.prototype.message_version = 0;
    SolanaSignOffChainMessage.prototype.message_format = 0;
    SolanaSignOffChainMessage.prototype.application_domain = $util.newBuffer([]);
    SolanaSignOffChainMessage.prototype.required_signers = $util.emptyArray;

    SolanaSignOffChainMessage.create = function create(properties) {
        return new SolanaSignOffChainMessage(properties);
    };

    SolanaSignOffChainMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).bytes(message.message);
        if (message.message_version != null && Object.hasOwnProperty.call(message, "message_version"))
            writer.uint32(24).int32(message.message_version);
        if (message.message_format != null && Object.hasOwnProperty.call(message, "message_format"))
            writer.uint32(32).int32(message.message_format);
        if (message.application_domain != null && Object.hasOwnProperty.call(message, "application_domain"))
            writer.uint32(42).bytes(message.application_domain);
        if (message.required_signers != null && message.required_signers.length)
            for (var i = 0; i < message.required_signers.length; ++i)
                writer.uint32(58).bytes(message.required_signers[i]);
        return writer;
    };

    SolanaSignOffChainMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    SolanaSignOffChainMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SolanaSignOffChainMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.message = reader.bytes();
                break;
            case 3:
                message.message_version = reader.int32();
                break;
            case 4:
                message.message_format = reader.int32();
                break;
            case 5:
                message.application_domain = reader.bytes();
                break;
            case 7:
                if (!(message.required_signers && message.required_signers.length))
                    message.required_signers = [];
                message.required_signers.push(reader.bytes());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("message"))
            throw $util.ProtocolError("missing required 'message'", { instance: message });
        return message;
    };

    SolanaSignOffChainMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    SolanaSignOffChainMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!(message.message && typeof message.message.length === "number" || $util.isString(message.message)))
            return "message: buffer expected";
        if (message.message_version != null && message.hasOwnProperty("message_version"))
            switch (message.message_version) {
            default:
                return "message_version: enum value expected";
            case 0:
            case 1:
                break;
            }
        if (message.message_format != null && message.hasOwnProperty("message_format"))
            switch (message.message_format) {
            default:
                return "message_format: enum value expected";
            case 0:
            case 1:
                break;
            }
        if (message.application_domain != null && message.hasOwnProperty("application_domain"))
            if (!(message.application_domain && typeof message.application_domain.length === "number" || $util.isString(message.application_domain)))
                return "application_domain: buffer expected";
        if (message.required_signers != null && message.hasOwnProperty("required_signers")) {
            if (!Array.isArray(message.required_signers))
                return "required_signers: array expected";
            for (var i = 0; i < message.required_signers.length; ++i)
                if (!(message.required_signers[i] && typeof message.required_signers[i].length === "number" || $util.isString(message.required_signers[i])))
                    return "required_signers: buffer[] expected";
        }
        return null;
    };

    SolanaSignOffChainMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.SolanaSignOffChainMessage)
            return object;
        var message = new $root.SolanaSignOffChainMessage();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".SolanaSignOffChainMessage.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.message != null)
            if (typeof object.message === "string")
                $util.base64.decode(object.message, message.message = $util.newBuffer($util.base64.length(object.message)), 0);
            else if (object.message.length)
                message.message = object.message;
        switch (object.message_version) {
        case "MESSAGE_VERSION_0":
        case 0:
            message.message_version = 0;
            break;
        case "MESSAGE_VERSION_1":
        case 1:
            message.message_version = 1;
            break;
        }
        switch (object.message_format) {
        case "V0_RESTRICTED_ASCII":
        case 0:
            message.message_format = 0;
            break;
        case "V0_LIMITED_UTF8":
        case 1:
            message.message_format = 1;
            break;
        }
        if (object.application_domain != null)
            if (typeof object.application_domain === "string")
                $util.base64.decode(object.application_domain, message.application_domain = $util.newBuffer($util.base64.length(object.application_domain)), 0);
            else if (object.application_domain.length)
                message.application_domain = object.application_domain;
        if (object.required_signers) {
            if (!Array.isArray(object.required_signers))
                throw TypeError(".SolanaSignOffChainMessage.required_signers: array expected");
            message.required_signers = [];
            for (var i = 0; i < object.required_signers.length; ++i)
                if (typeof object.required_signers[i] === "string")
                    $util.base64.decode(object.required_signers[i], message.required_signers[i] = $util.newBuffer($util.base64.length(object.required_signers[i])), 0);
                else if (object.required_signers[i].length)
                    message.required_signers[i] = object.required_signers[i];
        }
        return message;
    };

    SolanaSignOffChainMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults) {
            object.address_n = [];
            object.required_signers = [];
        }
        if (options.defaults) {
            if (options.bytes === String)
                object.message = "";
            else {
                object.message = [];
                if (options.bytes !== Array)
                    object.message = $util.newBuffer(object.message);
            }
            object.message_version = options.enums === String ? "MESSAGE_VERSION_0" : 0;
            object.message_format = options.enums === String ? "V0_RESTRICTED_ASCII" : 0;
            if (options.bytes === String)
                object.application_domain = "";
            else {
                object.application_domain = [];
                if (options.bytes !== Array)
                    object.application_domain = $util.newBuffer(object.application_domain);
            }
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.message != null && message.hasOwnProperty("message"))
            object.message = options.bytes === String ? $util.base64.encode(message.message, 0, message.message.length) : options.bytes === Array ? Array.prototype.slice.call(message.message) : message.message;
        if (message.message_version != null && message.hasOwnProperty("message_version"))
            object.message_version = options.enums === String ? $root.SolanaOffChainMessageVersion[message.message_version] : message.message_version;
        if (message.message_format != null && message.hasOwnProperty("message_format"))
            object.message_format = options.enums === String ? $root.SolanaOffChainMessageFormat[message.message_format] : message.message_format;
        if (message.application_domain != null && message.hasOwnProperty("application_domain"))
            object.application_domain = options.bytes === String ? $util.base64.encode(message.application_domain, 0, message.application_domain.length) : options.bytes === Array ? Array.prototype.slice.call(message.application_domain) : message.application_domain;
        if (message.required_signers && message.required_signers.length) {
            object.required_signers = [];
            for (var j = 0; j < message.required_signers.length; ++j)
                object.required_signers[j] = options.bytes === String ? $util.base64.encode(message.required_signers[j], 0, message.required_signers[j].length) : options.bytes === Array ? Array.prototype.slice.call(message.required_signers[j]) : message.required_signers[j];
        }
        return object;
    };

    SolanaSignOffChainMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SolanaSignOffChainMessage;
})();

$root.SolanaSignUnsafeMessage = (function() {

    function SolanaSignUnsafeMessage(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    SolanaSignUnsafeMessage.prototype.address_n = $util.emptyArray;
    SolanaSignUnsafeMessage.prototype.message = $util.newBuffer([]);

    SolanaSignUnsafeMessage.create = function create(properties) {
        return new SolanaSignUnsafeMessage(properties);
    };

    SolanaSignUnsafeMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).bytes(message.message);
        return writer;
    };

    SolanaSignUnsafeMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    SolanaSignUnsafeMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SolanaSignUnsafeMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.message = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("message"))
            throw $util.ProtocolError("missing required 'message'", { instance: message });
        return message;
    };

    SolanaSignUnsafeMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    SolanaSignUnsafeMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!(message.message && typeof message.message.length === "number" || $util.isString(message.message)))
            return "message: buffer expected";
        return null;
    };

    SolanaSignUnsafeMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.SolanaSignUnsafeMessage)
            return object;
        var message = new $root.SolanaSignUnsafeMessage();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".SolanaSignUnsafeMessage.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.message != null)
            if (typeof object.message === "string")
                $util.base64.decode(object.message, message.message = $util.newBuffer($util.base64.length(object.message)), 0);
            else if (object.message.length)
                message.message = object.message;
        return message;
    };

    SolanaSignUnsafeMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            if (options.bytes === String)
                object.message = "";
            else {
                object.message = [];
                if (options.bytes !== Array)
                    object.message = $util.newBuffer(object.message);
            }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.message != null && message.hasOwnProperty("message"))
            object.message = options.bytes === String ? $util.base64.encode(message.message, 0, message.message.length) : options.bytes === Array ? Array.prototype.slice.call(message.message) : message.message;
        return object;
    };

    SolanaSignUnsafeMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SolanaSignUnsafeMessage;
})();

$root.SolanaMessageSignature = (function() {

    function SolanaMessageSignature(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    SolanaMessageSignature.prototype.signature = $util.newBuffer([]);
    SolanaMessageSignature.prototype.public_key = $util.newBuffer([]);

    SolanaMessageSignature.create = function create(properties) {
        return new SolanaMessageSignature(properties);
    };

    SolanaMessageSignature.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.signature);
        if (message.public_key != null && Object.hasOwnProperty.call(message, "public_key"))
            writer.uint32(18).bytes(message.public_key);
        return writer;
    };

    SolanaMessageSignature.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    SolanaMessageSignature.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SolanaMessageSignature();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.signature = reader.bytes();
                break;
            case 2:
                message.public_key = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        return message;
    };

    SolanaMessageSignature.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    SolanaMessageSignature.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            if (!(message.public_key && typeof message.public_key.length === "number" || $util.isString(message.public_key)))
                return "public_key: buffer expected";
        return null;
    };

    SolanaMessageSignature.fromObject = function fromObject(object) {
        if (object instanceof $root.SolanaMessageSignature)
            return object;
        var message = new $root.SolanaMessageSignature();
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        if (object.public_key != null)
            if (typeof object.public_key === "string")
                $util.base64.decode(object.public_key, message.public_key = $util.newBuffer($util.base64.length(object.public_key)), 0);
            else if (object.public_key.length)
                message.public_key = object.public_key;
        return message;
    };

    SolanaMessageSignature.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
            if (options.bytes === String)
                object.public_key = "";
            else {
                object.public_key = [];
                if (options.bytes !== Array)
                    object.public_key = $util.newBuffer(object.public_key);
            }
        }
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            object.public_key = options.bytes === String ? $util.base64.encode(message.public_key, 0, message.public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.public_key) : message.public_key;
        return object;
    };

    SolanaMessageSignature.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SolanaMessageSignature;
})();

$root.StarcoinGetAddress = (function() {

    function StarcoinGetAddress(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    StarcoinGetAddress.prototype.address_n = $util.emptyArray;
    StarcoinGetAddress.prototype.show_display = false;

    StarcoinGetAddress.create = function create(properties) {
        return new StarcoinGetAddress(properties);
    };

    StarcoinGetAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(16).bool(message.show_display);
        return writer;
    };

    StarcoinGetAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    StarcoinGetAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.StarcoinGetAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.show_display = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    StarcoinGetAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    StarcoinGetAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        return null;
    };

    StarcoinGetAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.StarcoinGetAddress)
            return object;
        var message = new $root.StarcoinGetAddress();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".StarcoinGetAddress.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        return message;
    };

    StarcoinGetAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            object.show_display = false;
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        return object;
    };

    StarcoinGetAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return StarcoinGetAddress;
})();

$root.StarcoinAddress = (function() {

    function StarcoinAddress(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    StarcoinAddress.prototype.address = "";

    StarcoinAddress.create = function create(properties) {
        return new StarcoinAddress(properties);
    };

    StarcoinAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address != null && Object.hasOwnProperty.call(message, "address"))
            writer.uint32(10).string(message.address);
        return writer;
    };

    StarcoinAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    StarcoinAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.StarcoinAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    StarcoinAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    StarcoinAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address != null && message.hasOwnProperty("address"))
            if (!$util.isString(message.address))
                return "address: string expected";
        return null;
    };

    StarcoinAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.StarcoinAddress)
            return object;
        var message = new $root.StarcoinAddress();
        if (object.address != null)
            message.address = String(object.address);
        return message;
    };

    StarcoinAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.address = "";
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    StarcoinAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return StarcoinAddress;
})();

$root.StarcoinGetPublicKey = (function() {

    function StarcoinGetPublicKey(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    StarcoinGetPublicKey.prototype.address_n = $util.emptyArray;
    StarcoinGetPublicKey.prototype.show_display = false;

    StarcoinGetPublicKey.create = function create(properties) {
        return new StarcoinGetPublicKey(properties);
    };

    StarcoinGetPublicKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(16).bool(message.show_display);
        return writer;
    };

    StarcoinGetPublicKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    StarcoinGetPublicKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.StarcoinGetPublicKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.show_display = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    StarcoinGetPublicKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    StarcoinGetPublicKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        return null;
    };

    StarcoinGetPublicKey.fromObject = function fromObject(object) {
        if (object instanceof $root.StarcoinGetPublicKey)
            return object;
        var message = new $root.StarcoinGetPublicKey();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".StarcoinGetPublicKey.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        return message;
    };

    StarcoinGetPublicKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            object.show_display = false;
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        return object;
    };

    StarcoinGetPublicKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return StarcoinGetPublicKey;
})();

$root.StarcoinPublicKey = (function() {

    function StarcoinPublicKey(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    StarcoinPublicKey.prototype.public_key = $util.newBuffer([]);

    StarcoinPublicKey.create = function create(properties) {
        return new StarcoinPublicKey(properties);
    };

    StarcoinPublicKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.public_key);
        return writer;
    };

    StarcoinPublicKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    StarcoinPublicKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.StarcoinPublicKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.public_key = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("public_key"))
            throw $util.ProtocolError("missing required 'public_key'", { instance: message });
        return message;
    };

    StarcoinPublicKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    StarcoinPublicKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.public_key && typeof message.public_key.length === "number" || $util.isString(message.public_key)))
            return "public_key: buffer expected";
        return null;
    };

    StarcoinPublicKey.fromObject = function fromObject(object) {
        if (object instanceof $root.StarcoinPublicKey)
            return object;
        var message = new $root.StarcoinPublicKey();
        if (object.public_key != null)
            if (typeof object.public_key === "string")
                $util.base64.decode(object.public_key, message.public_key = $util.newBuffer($util.base64.length(object.public_key)), 0);
            else if (object.public_key.length)
                message.public_key = object.public_key;
        return message;
    };

    StarcoinPublicKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.public_key = "";
            else {
                object.public_key = [];
                if (options.bytes !== Array)
                    object.public_key = $util.newBuffer(object.public_key);
            }
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            object.public_key = options.bytes === String ? $util.base64.encode(message.public_key, 0, message.public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.public_key) : message.public_key;
        return object;
    };

    StarcoinPublicKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return StarcoinPublicKey;
})();

$root.StarcoinSignTx = (function() {

    function StarcoinSignTx(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    StarcoinSignTx.prototype.address_n = $util.emptyArray;
    StarcoinSignTx.prototype.raw_tx = $util.newBuffer([]);

    StarcoinSignTx.create = function create(properties) {
        return new StarcoinSignTx(properties);
    };

    StarcoinSignTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.raw_tx != null && Object.hasOwnProperty.call(message, "raw_tx"))
            writer.uint32(18).bytes(message.raw_tx);
        return writer;
    };

    StarcoinSignTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    StarcoinSignTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.StarcoinSignTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.raw_tx = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    StarcoinSignTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    StarcoinSignTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.raw_tx != null && message.hasOwnProperty("raw_tx"))
            if (!(message.raw_tx && typeof message.raw_tx.length === "number" || $util.isString(message.raw_tx)))
                return "raw_tx: buffer expected";
        return null;
    };

    StarcoinSignTx.fromObject = function fromObject(object) {
        if (object instanceof $root.StarcoinSignTx)
            return object;
        var message = new $root.StarcoinSignTx();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".StarcoinSignTx.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.raw_tx != null)
            if (typeof object.raw_tx === "string")
                $util.base64.decode(object.raw_tx, message.raw_tx = $util.newBuffer($util.base64.length(object.raw_tx)), 0);
            else if (object.raw_tx.length)
                message.raw_tx = object.raw_tx;
        return message;
    };

    StarcoinSignTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            if (options.bytes === String)
                object.raw_tx = "";
            else {
                object.raw_tx = [];
                if (options.bytes !== Array)
                    object.raw_tx = $util.newBuffer(object.raw_tx);
            }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.raw_tx != null && message.hasOwnProperty("raw_tx"))
            object.raw_tx = options.bytes === String ? $util.base64.encode(message.raw_tx, 0, message.raw_tx.length) : options.bytes === Array ? Array.prototype.slice.call(message.raw_tx) : message.raw_tx;
        return object;
    };

    StarcoinSignTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return StarcoinSignTx;
})();

$root.StarcoinSignedTx = (function() {

    function StarcoinSignedTx(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    StarcoinSignedTx.prototype.public_key = $util.newBuffer([]);
    StarcoinSignedTx.prototype.signature = $util.newBuffer([]);

    StarcoinSignedTx.create = function create(properties) {
        return new StarcoinSignedTx(properties);
    };

    StarcoinSignedTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.public_key);
        writer.uint32(18).bytes(message.signature);
        return writer;
    };

    StarcoinSignedTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    StarcoinSignedTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.StarcoinSignedTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.public_key = reader.bytes();
                break;
            case 2:
                message.signature = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("public_key"))
            throw $util.ProtocolError("missing required 'public_key'", { instance: message });
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        return message;
    };

    StarcoinSignedTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    StarcoinSignedTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.public_key && typeof message.public_key.length === "number" || $util.isString(message.public_key)))
            return "public_key: buffer expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        return null;
    };

    StarcoinSignedTx.fromObject = function fromObject(object) {
        if (object instanceof $root.StarcoinSignedTx)
            return object;
        var message = new $root.StarcoinSignedTx();
        if (object.public_key != null)
            if (typeof object.public_key === "string")
                $util.base64.decode(object.public_key, message.public_key = $util.newBuffer($util.base64.length(object.public_key)), 0);
            else if (object.public_key.length)
                message.public_key = object.public_key;
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        return message;
    };

    StarcoinSignedTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.public_key = "";
            else {
                object.public_key = [];
                if (options.bytes !== Array)
                    object.public_key = $util.newBuffer(object.public_key);
            }
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
        }
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            object.public_key = options.bytes === String ? $util.base64.encode(message.public_key, 0, message.public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.public_key) : message.public_key;
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        return object;
    };

    StarcoinSignedTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return StarcoinSignedTx;
})();

$root.StarcoinSignMessage = (function() {

    function StarcoinSignMessage(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    StarcoinSignMessage.prototype.address_n = $util.emptyArray;
    StarcoinSignMessage.prototype.message = $util.newBuffer([]);

    StarcoinSignMessage.create = function create(properties) {
        return new StarcoinSignMessage(properties);
    };

    StarcoinSignMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
            writer.uint32(18).bytes(message.message);
        return writer;
    };

    StarcoinSignMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    StarcoinSignMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.StarcoinSignMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.message = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    StarcoinSignMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    StarcoinSignMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.message != null && message.hasOwnProperty("message"))
            if (!(message.message && typeof message.message.length === "number" || $util.isString(message.message)))
                return "message: buffer expected";
        return null;
    };

    StarcoinSignMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.StarcoinSignMessage)
            return object;
        var message = new $root.StarcoinSignMessage();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".StarcoinSignMessage.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.message != null)
            if (typeof object.message === "string")
                $util.base64.decode(object.message, message.message = $util.newBuffer($util.base64.length(object.message)), 0);
            else if (object.message.length)
                message.message = object.message;
        return message;
    };

    StarcoinSignMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            if (options.bytes === String)
                object.message = "";
            else {
                object.message = [];
                if (options.bytes !== Array)
                    object.message = $util.newBuffer(object.message);
            }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.message != null && message.hasOwnProperty("message"))
            object.message = options.bytes === String ? $util.base64.encode(message.message, 0, message.message.length) : options.bytes === Array ? Array.prototype.slice.call(message.message) : message.message;
        return object;
    };

    StarcoinSignMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return StarcoinSignMessage;
})();

$root.StarcoinMessageSignature = (function() {

    function StarcoinMessageSignature(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    StarcoinMessageSignature.prototype.public_key = $util.newBuffer([]);
    StarcoinMessageSignature.prototype.signature = $util.newBuffer([]);

    StarcoinMessageSignature.create = function create(properties) {
        return new StarcoinMessageSignature(properties);
    };

    StarcoinMessageSignature.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.public_key);
        writer.uint32(18).bytes(message.signature);
        return writer;
    };

    StarcoinMessageSignature.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    StarcoinMessageSignature.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.StarcoinMessageSignature();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.public_key = reader.bytes();
                break;
            case 2:
                message.signature = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("public_key"))
            throw $util.ProtocolError("missing required 'public_key'", { instance: message });
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        return message;
    };

    StarcoinMessageSignature.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    StarcoinMessageSignature.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.public_key && typeof message.public_key.length === "number" || $util.isString(message.public_key)))
            return "public_key: buffer expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        return null;
    };

    StarcoinMessageSignature.fromObject = function fromObject(object) {
        if (object instanceof $root.StarcoinMessageSignature)
            return object;
        var message = new $root.StarcoinMessageSignature();
        if (object.public_key != null)
            if (typeof object.public_key === "string")
                $util.base64.decode(object.public_key, message.public_key = $util.newBuffer($util.base64.length(object.public_key)), 0);
            else if (object.public_key.length)
                message.public_key = object.public_key;
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        return message;
    };

    StarcoinMessageSignature.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.public_key = "";
            else {
                object.public_key = [];
                if (options.bytes !== Array)
                    object.public_key = $util.newBuffer(object.public_key);
            }
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
        }
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            object.public_key = options.bytes === String ? $util.base64.encode(message.public_key, 0, message.public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.public_key) : message.public_key;
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        return object;
    };

    StarcoinMessageSignature.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return StarcoinMessageSignature;
})();

$root.StarcoinVerifyMessage = (function() {

    function StarcoinVerifyMessage(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    StarcoinVerifyMessage.prototype.public_key = $util.newBuffer([]);
    StarcoinVerifyMessage.prototype.signature = $util.newBuffer([]);
    StarcoinVerifyMessage.prototype.message = $util.newBuffer([]);

    StarcoinVerifyMessage.create = function create(properties) {
        return new StarcoinVerifyMessage(properties);
    };

    StarcoinVerifyMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.public_key != null && Object.hasOwnProperty.call(message, "public_key"))
            writer.uint32(10).bytes(message.public_key);
        if (message.signature != null && Object.hasOwnProperty.call(message, "signature"))
            writer.uint32(18).bytes(message.signature);
        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
            writer.uint32(26).bytes(message.message);
        return writer;
    };

    StarcoinVerifyMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    StarcoinVerifyMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.StarcoinVerifyMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.public_key = reader.bytes();
                break;
            case 2:
                message.signature = reader.bytes();
                break;
            case 3:
                message.message = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    StarcoinVerifyMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    StarcoinVerifyMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            if (!(message.public_key && typeof message.public_key.length === "number" || $util.isString(message.public_key)))
                return "public_key: buffer expected";
        if (message.signature != null && message.hasOwnProperty("signature"))
            if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
                return "signature: buffer expected";
        if (message.message != null && message.hasOwnProperty("message"))
            if (!(message.message && typeof message.message.length === "number" || $util.isString(message.message)))
                return "message: buffer expected";
        return null;
    };

    StarcoinVerifyMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.StarcoinVerifyMessage)
            return object;
        var message = new $root.StarcoinVerifyMessage();
        if (object.public_key != null)
            if (typeof object.public_key === "string")
                $util.base64.decode(object.public_key, message.public_key = $util.newBuffer($util.base64.length(object.public_key)), 0);
            else if (object.public_key.length)
                message.public_key = object.public_key;
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        if (object.message != null)
            if (typeof object.message === "string")
                $util.base64.decode(object.message, message.message = $util.newBuffer($util.base64.length(object.message)), 0);
            else if (object.message.length)
                message.message = object.message;
        return message;
    };

    StarcoinVerifyMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.public_key = "";
            else {
                object.public_key = [];
                if (options.bytes !== Array)
                    object.public_key = $util.newBuffer(object.public_key);
            }
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
            if (options.bytes === String)
                object.message = "";
            else {
                object.message = [];
                if (options.bytes !== Array)
                    object.message = $util.newBuffer(object.message);
            }
        }
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            object.public_key = options.bytes === String ? $util.base64.encode(message.public_key, 0, message.public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.public_key) : message.public_key;
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        if (message.message != null && message.hasOwnProperty("message"))
            object.message = options.bytes === String ? $util.base64.encode(message.message, 0, message.message.length) : options.bytes === Array ? Array.prototype.slice.call(message.message) : message.message;
        return object;
    };

    StarcoinVerifyMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return StarcoinVerifyMessage;
})();

$root.StellarAssetType = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "NATIVE"] = 0;
    values[valuesById[1] = "ALPHANUM4"] = 1;
    values[valuesById[2] = "ALPHANUM12"] = 2;
    return values;
})();

$root.StellarAsset = (function() {

    function StellarAsset(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    StellarAsset.prototype.type = 0;
    StellarAsset.prototype.code = "";
    StellarAsset.prototype.issuer = "";

    StellarAsset.create = function create(properties) {
        return new StellarAsset(properties);
    };

    StellarAsset.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).int32(message.type);
        if (message.code != null && Object.hasOwnProperty.call(message, "code"))
            writer.uint32(18).string(message.code);
        if (message.issuer != null && Object.hasOwnProperty.call(message, "issuer"))
            writer.uint32(26).string(message.issuer);
        return writer;
    };

    StellarAsset.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    StellarAsset.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.StellarAsset();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.type = reader.int32();
                break;
            case 2:
                message.code = reader.string();
                break;
            case 3:
                message.issuer = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("type"))
            throw $util.ProtocolError("missing required 'type'", { instance: message });
        return message;
    };

    StellarAsset.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    StellarAsset.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        switch (message.type) {
        default:
            return "type: enum value expected";
        case 0:
        case 1:
        case 2:
            break;
        }
        if (message.code != null && message.hasOwnProperty("code"))
            if (!$util.isString(message.code))
                return "code: string expected";
        if (message.issuer != null && message.hasOwnProperty("issuer"))
            if (!$util.isString(message.issuer))
                return "issuer: string expected";
        return null;
    };

    StellarAsset.fromObject = function fromObject(object) {
        if (object instanceof $root.StellarAsset)
            return object;
        var message = new $root.StellarAsset();
        switch (object.type) {
        case "NATIVE":
        case 0:
            message.type = 0;
            break;
        case "ALPHANUM4":
        case 1:
            message.type = 1;
            break;
        case "ALPHANUM12":
        case 2:
            message.type = 2;
            break;
        }
        if (object.code != null)
            message.code = String(object.code);
        if (object.issuer != null)
            message.issuer = String(object.issuer);
        return message;
    };

    StellarAsset.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.type = options.enums === String ? "NATIVE" : 0;
            object.code = "";
            object.issuer = "";
        }
        if (message.type != null && message.hasOwnProperty("type"))
            object.type = options.enums === String ? $root.StellarAssetType[message.type] : message.type;
        if (message.code != null && message.hasOwnProperty("code"))
            object.code = message.code;
        if (message.issuer != null && message.hasOwnProperty("issuer"))
            object.issuer = message.issuer;
        return object;
    };

    StellarAsset.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return StellarAsset;
})();

$root.StellarGetAddress = (function() {

    function StellarGetAddress(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    StellarGetAddress.prototype.address_n = $util.emptyArray;
    StellarGetAddress.prototype.show_display = false;

    StellarGetAddress.create = function create(properties) {
        return new StellarGetAddress(properties);
    };

    StellarGetAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(16).bool(message.show_display);
        return writer;
    };

    StellarGetAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    StellarGetAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.StellarGetAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.show_display = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    StellarGetAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    StellarGetAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        return null;
    };

    StellarGetAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.StellarGetAddress)
            return object;
        var message = new $root.StellarGetAddress();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".StellarGetAddress.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        return message;
    };

    StellarGetAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            object.show_display = false;
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        return object;
    };

    StellarGetAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return StellarGetAddress;
})();

$root.StellarAddress = (function() {

    function StellarAddress(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    StellarAddress.prototype.address = "";

    StellarAddress.create = function create(properties) {
        return new StellarAddress(properties);
    };

    StellarAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.address);
        return writer;
    };

    StellarAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    StellarAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.StellarAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("address"))
            throw $util.ProtocolError("missing required 'address'", { instance: message });
        return message;
    };

    StellarAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    StellarAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.address))
            return "address: string expected";
        return null;
    };

    StellarAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.StellarAddress)
            return object;
        var message = new $root.StellarAddress();
        if (object.address != null)
            message.address = String(object.address);
        return message;
    };

    StellarAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.address = "";
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    StellarAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return StellarAddress;
})();

$root.StellarSignTx = (function() {

    function StellarSignTx(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    StellarSignTx.prototype.address_n = $util.emptyArray;
    StellarSignTx.prototype.network_passphrase = "";
    StellarSignTx.prototype.source_account = "";
    StellarSignTx.prototype.fee = 0;
    StellarSignTx.prototype.sequence_number = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    StellarSignTx.prototype.timebounds_start = 0;
    StellarSignTx.prototype.timebounds_end = 0;
    StellarSignTx.prototype.memo_type = 0;
    StellarSignTx.prototype.memo_text = "";
    StellarSignTx.prototype.memo_id = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    StellarSignTx.prototype.memo_hash = $util.newBuffer([]);
    StellarSignTx.prototype.num_operations = 0;
    StellarSignTx.prototype.soroban_data_size = 0;

    StellarSignTx.create = function create(properties) {
        return new StellarSignTx(properties);
    };

    StellarSignTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(16).uint32(message.address_n[i]);
        writer.uint32(26).string(message.network_passphrase);
        writer.uint32(34).string(message.source_account);
        writer.uint32(40).uint32(message.fee);
        writer.uint32(48).uint64(message.sequence_number);
        writer.uint32(64).uint32(message.timebounds_start);
        writer.uint32(72).uint32(message.timebounds_end);
        writer.uint32(80).int32(message.memo_type);
        if (message.memo_text != null && Object.hasOwnProperty.call(message, "memo_text"))
            writer.uint32(90).string(message.memo_text);
        if (message.memo_id != null && Object.hasOwnProperty.call(message, "memo_id"))
            writer.uint32(96).uint64(message.memo_id);
        if (message.memo_hash != null && Object.hasOwnProperty.call(message, "memo_hash"))
            writer.uint32(106).bytes(message.memo_hash);
        writer.uint32(112).uint32(message.num_operations);
        if (message.soroban_data_size != null && Object.hasOwnProperty.call(message, "soroban_data_size"))
            writer.uint32(480).uint32(message.soroban_data_size);
        return writer;
    };

    StellarSignTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    StellarSignTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.StellarSignTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 2:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 3:
                message.network_passphrase = reader.string();
                break;
            case 4:
                message.source_account = reader.string();
                break;
            case 5:
                message.fee = reader.uint32();
                break;
            case 6:
                message.sequence_number = reader.uint64();
                break;
            case 8:
                message.timebounds_start = reader.uint32();
                break;
            case 9:
                message.timebounds_end = reader.uint32();
                break;
            case 10:
                message.memo_type = reader.int32();
                break;
            case 11:
                message.memo_text = reader.string();
                break;
            case 12:
                message.memo_id = reader.uint64();
                break;
            case 13:
                message.memo_hash = reader.bytes();
                break;
            case 14:
                message.num_operations = reader.uint32();
                break;
            case 60:
                message.soroban_data_size = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("network_passphrase"))
            throw $util.ProtocolError("missing required 'network_passphrase'", { instance: message });
        if (!message.hasOwnProperty("source_account"))
            throw $util.ProtocolError("missing required 'source_account'", { instance: message });
        if (!message.hasOwnProperty("fee"))
            throw $util.ProtocolError("missing required 'fee'", { instance: message });
        if (!message.hasOwnProperty("sequence_number"))
            throw $util.ProtocolError("missing required 'sequence_number'", { instance: message });
        if (!message.hasOwnProperty("timebounds_start"))
            throw $util.ProtocolError("missing required 'timebounds_start'", { instance: message });
        if (!message.hasOwnProperty("timebounds_end"))
            throw $util.ProtocolError("missing required 'timebounds_end'", { instance: message });
        if (!message.hasOwnProperty("memo_type"))
            throw $util.ProtocolError("missing required 'memo_type'", { instance: message });
        if (!message.hasOwnProperty("num_operations"))
            throw $util.ProtocolError("missing required 'num_operations'", { instance: message });
        return message;
    };

    StellarSignTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    StellarSignTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!$util.isString(message.network_passphrase))
            return "network_passphrase: string expected";
        if (!$util.isString(message.source_account))
            return "source_account: string expected";
        if (!$util.isInteger(message.fee))
            return "fee: integer expected";
        if (!$util.isInteger(message.sequence_number) && !(message.sequence_number && $util.isInteger(message.sequence_number.low) && $util.isInteger(message.sequence_number.high)))
            return "sequence_number: integer|Long expected";
        if (!$util.isInteger(message.timebounds_start))
            return "timebounds_start: integer expected";
        if (!$util.isInteger(message.timebounds_end))
            return "timebounds_end: integer expected";
        switch (message.memo_type) {
        default:
            return "memo_type: enum value expected";
        case 0:
        case 1:
        case 2:
        case 3:
        case 4:
            break;
        }
        if (message.memo_text != null && message.hasOwnProperty("memo_text"))
            if (!$util.isString(message.memo_text))
                return "memo_text: string expected";
        if (message.memo_id != null && message.hasOwnProperty("memo_id"))
            if (!$util.isInteger(message.memo_id) && !(message.memo_id && $util.isInteger(message.memo_id.low) && $util.isInteger(message.memo_id.high)))
                return "memo_id: integer|Long expected";
        if (message.memo_hash != null && message.hasOwnProperty("memo_hash"))
            if (!(message.memo_hash && typeof message.memo_hash.length === "number" || $util.isString(message.memo_hash)))
                return "memo_hash: buffer expected";
        if (!$util.isInteger(message.num_operations))
            return "num_operations: integer expected";
        if (message.soroban_data_size != null && message.hasOwnProperty("soroban_data_size"))
            if (!$util.isInteger(message.soroban_data_size))
                return "soroban_data_size: integer expected";
        return null;
    };

    StellarSignTx.fromObject = function fromObject(object) {
        if (object instanceof $root.StellarSignTx)
            return object;
        var message = new $root.StellarSignTx();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".StellarSignTx.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.network_passphrase != null)
            message.network_passphrase = String(object.network_passphrase);
        if (object.source_account != null)
            message.source_account = String(object.source_account);
        if (object.fee != null)
            message.fee = object.fee >>> 0;
        if (object.sequence_number != null)
            if ($util.Long)
                (message.sequence_number = $util.Long.fromValue(object.sequence_number)).unsigned = true;
            else if (typeof object.sequence_number === "string")
                message.sequence_number = parseInt(object.sequence_number, 10);
            else if (typeof object.sequence_number === "number")
                message.sequence_number = object.sequence_number;
            else if (typeof object.sequence_number === "object")
                message.sequence_number = new $util.LongBits(object.sequence_number.low >>> 0, object.sequence_number.high >>> 0).toNumber(true);
        if (object.timebounds_start != null)
            message.timebounds_start = object.timebounds_start >>> 0;
        if (object.timebounds_end != null)
            message.timebounds_end = object.timebounds_end >>> 0;
        switch (object.memo_type) {
        case "NONE":
        case 0:
            message.memo_type = 0;
            break;
        case "TEXT":
        case 1:
            message.memo_type = 1;
            break;
        case "ID":
        case 2:
            message.memo_type = 2;
            break;
        case "HASH":
        case 3:
            message.memo_type = 3;
            break;
        case "RETURN":
        case 4:
            message.memo_type = 4;
            break;
        }
        if (object.memo_text != null)
            message.memo_text = String(object.memo_text);
        if (object.memo_id != null)
            if ($util.Long)
                (message.memo_id = $util.Long.fromValue(object.memo_id)).unsigned = true;
            else if (typeof object.memo_id === "string")
                message.memo_id = parseInt(object.memo_id, 10);
            else if (typeof object.memo_id === "number")
                message.memo_id = object.memo_id;
            else if (typeof object.memo_id === "object")
                message.memo_id = new $util.LongBits(object.memo_id.low >>> 0, object.memo_id.high >>> 0).toNumber(true);
        if (object.memo_hash != null)
            if (typeof object.memo_hash === "string")
                $util.base64.decode(object.memo_hash, message.memo_hash = $util.newBuffer($util.base64.length(object.memo_hash)), 0);
            else if (object.memo_hash.length)
                message.memo_hash = object.memo_hash;
        if (object.num_operations != null)
            message.num_operations = object.num_operations >>> 0;
        if (object.soroban_data_size != null)
            message.soroban_data_size = object.soroban_data_size >>> 0;
        return message;
    };

    StellarSignTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            object.network_passphrase = "";
            object.source_account = "";
            object.fee = 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.sequence_number = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.sequence_number = options.longs === String ? "0" : 0;
            object.timebounds_start = 0;
            object.timebounds_end = 0;
            object.memo_type = options.enums === String ? "NONE" : 0;
            object.memo_text = "";
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.memo_id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.memo_id = options.longs === String ? "0" : 0;
            if (options.bytes === String)
                object.memo_hash = "";
            else {
                object.memo_hash = [];
                if (options.bytes !== Array)
                    object.memo_hash = $util.newBuffer(object.memo_hash);
            }
            object.num_operations = 0;
            object.soroban_data_size = 0;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.network_passphrase != null && message.hasOwnProperty("network_passphrase"))
            object.network_passphrase = message.network_passphrase;
        if (message.source_account != null && message.hasOwnProperty("source_account"))
            object.source_account = message.source_account;
        if (message.fee != null && message.hasOwnProperty("fee"))
            object.fee = message.fee;
        if (message.sequence_number != null && message.hasOwnProperty("sequence_number"))
            if (typeof message.sequence_number === "number")
                object.sequence_number = options.longs === String ? String(message.sequence_number) : message.sequence_number;
            else
                object.sequence_number = options.longs === String ? $util.Long.prototype.toString.call(message.sequence_number) : options.longs === Number ? new $util.LongBits(message.sequence_number.low >>> 0, message.sequence_number.high >>> 0).toNumber(true) : message.sequence_number;
        if (message.timebounds_start != null && message.hasOwnProperty("timebounds_start"))
            object.timebounds_start = message.timebounds_start;
        if (message.timebounds_end != null && message.hasOwnProperty("timebounds_end"))
            object.timebounds_end = message.timebounds_end;
        if (message.memo_type != null && message.hasOwnProperty("memo_type"))
            object.memo_type = options.enums === String ? $root.StellarSignTx.StellarMemoType[message.memo_type] : message.memo_type;
        if (message.memo_text != null && message.hasOwnProperty("memo_text"))
            object.memo_text = message.memo_text;
        if (message.memo_id != null && message.hasOwnProperty("memo_id"))
            if (typeof message.memo_id === "number")
                object.memo_id = options.longs === String ? String(message.memo_id) : message.memo_id;
            else
                object.memo_id = options.longs === String ? $util.Long.prototype.toString.call(message.memo_id) : options.longs === Number ? new $util.LongBits(message.memo_id.low >>> 0, message.memo_id.high >>> 0).toNumber(true) : message.memo_id;
        if (message.memo_hash != null && message.hasOwnProperty("memo_hash"))
            object.memo_hash = options.bytes === String ? $util.base64.encode(message.memo_hash, 0, message.memo_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.memo_hash) : message.memo_hash;
        if (message.num_operations != null && message.hasOwnProperty("num_operations"))
            object.num_operations = message.num_operations;
        if (message.soroban_data_size != null && message.hasOwnProperty("soroban_data_size"))
            object.soroban_data_size = message.soroban_data_size;
        return object;
    };

    StellarSignTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    StellarSignTx.StellarMemoType = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "NONE"] = 0;
        values[valuesById[1] = "TEXT"] = 1;
        values[valuesById[2] = "ID"] = 2;
        values[valuesById[3] = "HASH"] = 3;
        values[valuesById[4] = "RETURN"] = 4;
        return values;
    })();

    return StellarSignTx;
})();

$root.StellarTxOpRequest = (function() {

    function StellarTxOpRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    StellarTxOpRequest.create = function create(properties) {
        return new StellarTxOpRequest(properties);
    };

    StellarTxOpRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    StellarTxOpRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    StellarTxOpRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.StellarTxOpRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    StellarTxOpRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    StellarTxOpRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    StellarTxOpRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.StellarTxOpRequest)
            return object;
        return new $root.StellarTxOpRequest();
    };

    StellarTxOpRequest.toObject = function toObject() {
        return {};
    };

    StellarTxOpRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return StellarTxOpRequest;
})();

$root.StellarPaymentOp = (function() {

    function StellarPaymentOp(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    StellarPaymentOp.prototype.source_account = "";
    StellarPaymentOp.prototype.destination_account = "";
    StellarPaymentOp.prototype.asset = null;
    StellarPaymentOp.prototype.amount = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    StellarPaymentOp.create = function create(properties) {
        return new StellarPaymentOp(properties);
    };

    StellarPaymentOp.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.source_account != null && Object.hasOwnProperty.call(message, "source_account"))
            writer.uint32(10).string(message.source_account);
        writer.uint32(18).string(message.destination_account);
        $root.StellarAsset.encode(message.asset, writer.uint32(26).fork()).ldelim();
        writer.uint32(32).sint64(message.amount);
        return writer;
    };

    StellarPaymentOp.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    StellarPaymentOp.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.StellarPaymentOp();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.source_account = reader.string();
                break;
            case 2:
                message.destination_account = reader.string();
                break;
            case 3:
                message.asset = $root.StellarAsset.decode(reader, reader.uint32());
                break;
            case 4:
                message.amount = reader.sint64();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("destination_account"))
            throw $util.ProtocolError("missing required 'destination_account'", { instance: message });
        if (!message.hasOwnProperty("asset"))
            throw $util.ProtocolError("missing required 'asset'", { instance: message });
        if (!message.hasOwnProperty("amount"))
            throw $util.ProtocolError("missing required 'amount'", { instance: message });
        return message;
    };

    StellarPaymentOp.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    StellarPaymentOp.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.source_account != null && message.hasOwnProperty("source_account"))
            if (!$util.isString(message.source_account))
                return "source_account: string expected";
        if (!$util.isString(message.destination_account))
            return "destination_account: string expected";
        {
            var error = $root.StellarAsset.verify(message.asset);
            if (error)
                return "asset." + error;
        }
        if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
            return "amount: integer|Long expected";
        return null;
    };

    StellarPaymentOp.fromObject = function fromObject(object) {
        if (object instanceof $root.StellarPaymentOp)
            return object;
        var message = new $root.StellarPaymentOp();
        if (object.source_account != null)
            message.source_account = String(object.source_account);
        if (object.destination_account != null)
            message.destination_account = String(object.destination_account);
        if (object.asset != null) {
            if (typeof object.asset !== "object")
                throw TypeError(".StellarPaymentOp.asset: object expected");
            message.asset = $root.StellarAsset.fromObject(object.asset);
        }
        if (object.amount != null)
            if ($util.Long)
                (message.amount = $util.Long.fromValue(object.amount)).unsigned = false;
            else if (typeof object.amount === "string")
                message.amount = parseInt(object.amount, 10);
            else if (typeof object.amount === "number")
                message.amount = object.amount;
            else if (typeof object.amount === "object")
                message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber();
        return message;
    };

    StellarPaymentOp.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.source_account = "";
            object.destination_account = "";
            object.asset = null;
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.amount = options.longs === String ? "0" : 0;
        }
        if (message.source_account != null && message.hasOwnProperty("source_account"))
            object.source_account = message.source_account;
        if (message.destination_account != null && message.hasOwnProperty("destination_account"))
            object.destination_account = message.destination_account;
        if (message.asset != null && message.hasOwnProperty("asset"))
            object.asset = $root.StellarAsset.toObject(message.asset, options);
        if (message.amount != null && message.hasOwnProperty("amount"))
            if (typeof message.amount === "number")
                object.amount = options.longs === String ? String(message.amount) : message.amount;
            else
                object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber() : message.amount;
        return object;
    };

    StellarPaymentOp.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return StellarPaymentOp;
})();

$root.StellarCreateAccountOp = (function() {

    function StellarCreateAccountOp(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    StellarCreateAccountOp.prototype.source_account = "";
    StellarCreateAccountOp.prototype.new_account = "";
    StellarCreateAccountOp.prototype.starting_balance = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    StellarCreateAccountOp.create = function create(properties) {
        return new StellarCreateAccountOp(properties);
    };

    StellarCreateAccountOp.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.source_account != null && Object.hasOwnProperty.call(message, "source_account"))
            writer.uint32(10).string(message.source_account);
        writer.uint32(18).string(message.new_account);
        writer.uint32(24).sint64(message.starting_balance);
        return writer;
    };

    StellarCreateAccountOp.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    StellarCreateAccountOp.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.StellarCreateAccountOp();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.source_account = reader.string();
                break;
            case 2:
                message.new_account = reader.string();
                break;
            case 3:
                message.starting_balance = reader.sint64();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("new_account"))
            throw $util.ProtocolError("missing required 'new_account'", { instance: message });
        if (!message.hasOwnProperty("starting_balance"))
            throw $util.ProtocolError("missing required 'starting_balance'", { instance: message });
        return message;
    };

    StellarCreateAccountOp.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    StellarCreateAccountOp.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.source_account != null && message.hasOwnProperty("source_account"))
            if (!$util.isString(message.source_account))
                return "source_account: string expected";
        if (!$util.isString(message.new_account))
            return "new_account: string expected";
        if (!$util.isInteger(message.starting_balance) && !(message.starting_balance && $util.isInteger(message.starting_balance.low) && $util.isInteger(message.starting_balance.high)))
            return "starting_balance: integer|Long expected";
        return null;
    };

    StellarCreateAccountOp.fromObject = function fromObject(object) {
        if (object instanceof $root.StellarCreateAccountOp)
            return object;
        var message = new $root.StellarCreateAccountOp();
        if (object.source_account != null)
            message.source_account = String(object.source_account);
        if (object.new_account != null)
            message.new_account = String(object.new_account);
        if (object.starting_balance != null)
            if ($util.Long)
                (message.starting_balance = $util.Long.fromValue(object.starting_balance)).unsigned = false;
            else if (typeof object.starting_balance === "string")
                message.starting_balance = parseInt(object.starting_balance, 10);
            else if (typeof object.starting_balance === "number")
                message.starting_balance = object.starting_balance;
            else if (typeof object.starting_balance === "object")
                message.starting_balance = new $util.LongBits(object.starting_balance.low >>> 0, object.starting_balance.high >>> 0).toNumber();
        return message;
    };

    StellarCreateAccountOp.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.source_account = "";
            object.new_account = "";
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.starting_balance = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.starting_balance = options.longs === String ? "0" : 0;
        }
        if (message.source_account != null && message.hasOwnProperty("source_account"))
            object.source_account = message.source_account;
        if (message.new_account != null && message.hasOwnProperty("new_account"))
            object.new_account = message.new_account;
        if (message.starting_balance != null && message.hasOwnProperty("starting_balance"))
            if (typeof message.starting_balance === "number")
                object.starting_balance = options.longs === String ? String(message.starting_balance) : message.starting_balance;
            else
                object.starting_balance = options.longs === String ? $util.Long.prototype.toString.call(message.starting_balance) : options.longs === Number ? new $util.LongBits(message.starting_balance.low >>> 0, message.starting_balance.high >>> 0).toNumber() : message.starting_balance;
        return object;
    };

    StellarCreateAccountOp.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return StellarCreateAccountOp;
})();

$root.StellarPathPaymentStrictReceiveOp = (function() {

    function StellarPathPaymentStrictReceiveOp(properties) {
        this.paths = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    StellarPathPaymentStrictReceiveOp.prototype.source_account = "";
    StellarPathPaymentStrictReceiveOp.prototype.send_asset = null;
    StellarPathPaymentStrictReceiveOp.prototype.send_max = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    StellarPathPaymentStrictReceiveOp.prototype.destination_account = "";
    StellarPathPaymentStrictReceiveOp.prototype.destination_asset = null;
    StellarPathPaymentStrictReceiveOp.prototype.destination_amount = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    StellarPathPaymentStrictReceiveOp.prototype.paths = $util.emptyArray;

    StellarPathPaymentStrictReceiveOp.create = function create(properties) {
        return new StellarPathPaymentStrictReceiveOp(properties);
    };

    StellarPathPaymentStrictReceiveOp.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.source_account != null && Object.hasOwnProperty.call(message, "source_account"))
            writer.uint32(10).string(message.source_account);
        $root.StellarAsset.encode(message.send_asset, writer.uint32(18).fork()).ldelim();
        writer.uint32(24).sint64(message.send_max);
        writer.uint32(34).string(message.destination_account);
        $root.StellarAsset.encode(message.destination_asset, writer.uint32(42).fork()).ldelim();
        writer.uint32(48).sint64(message.destination_amount);
        if (message.paths != null && message.paths.length)
            for (var i = 0; i < message.paths.length; ++i)
                $root.StellarAsset.encode(message.paths[i], writer.uint32(58).fork()).ldelim();
        return writer;
    };

    StellarPathPaymentStrictReceiveOp.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    StellarPathPaymentStrictReceiveOp.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.StellarPathPaymentStrictReceiveOp();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.source_account = reader.string();
                break;
            case 2:
                message.send_asset = $root.StellarAsset.decode(reader, reader.uint32());
                break;
            case 3:
                message.send_max = reader.sint64();
                break;
            case 4:
                message.destination_account = reader.string();
                break;
            case 5:
                message.destination_asset = $root.StellarAsset.decode(reader, reader.uint32());
                break;
            case 6:
                message.destination_amount = reader.sint64();
                break;
            case 7:
                if (!(message.paths && message.paths.length))
                    message.paths = [];
                message.paths.push($root.StellarAsset.decode(reader, reader.uint32()));
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("send_asset"))
            throw $util.ProtocolError("missing required 'send_asset'", { instance: message });
        if (!message.hasOwnProperty("send_max"))
            throw $util.ProtocolError("missing required 'send_max'", { instance: message });
        if (!message.hasOwnProperty("destination_account"))
            throw $util.ProtocolError("missing required 'destination_account'", { instance: message });
        if (!message.hasOwnProperty("destination_asset"))
            throw $util.ProtocolError("missing required 'destination_asset'", { instance: message });
        if (!message.hasOwnProperty("destination_amount"))
            throw $util.ProtocolError("missing required 'destination_amount'", { instance: message });
        return message;
    };

    StellarPathPaymentStrictReceiveOp.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    StellarPathPaymentStrictReceiveOp.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.source_account != null && message.hasOwnProperty("source_account"))
            if (!$util.isString(message.source_account))
                return "source_account: string expected";
        {
            var error = $root.StellarAsset.verify(message.send_asset);
            if (error)
                return "send_asset." + error;
        }
        if (!$util.isInteger(message.send_max) && !(message.send_max && $util.isInteger(message.send_max.low) && $util.isInteger(message.send_max.high)))
            return "send_max: integer|Long expected";
        if (!$util.isString(message.destination_account))
            return "destination_account: string expected";
        {
            var error = $root.StellarAsset.verify(message.destination_asset);
            if (error)
                return "destination_asset." + error;
        }
        if (!$util.isInteger(message.destination_amount) && !(message.destination_amount && $util.isInteger(message.destination_amount.low) && $util.isInteger(message.destination_amount.high)))
            return "destination_amount: integer|Long expected";
        if (message.paths != null && message.hasOwnProperty("paths")) {
            if (!Array.isArray(message.paths))
                return "paths: array expected";
            for (var i = 0; i < message.paths.length; ++i) {
                var error = $root.StellarAsset.verify(message.paths[i]);
                if (error)
                    return "paths." + error;
            }
        }
        return null;
    };

    StellarPathPaymentStrictReceiveOp.fromObject = function fromObject(object) {
        if (object instanceof $root.StellarPathPaymentStrictReceiveOp)
            return object;
        var message = new $root.StellarPathPaymentStrictReceiveOp();
        if (object.source_account != null)
            message.source_account = String(object.source_account);
        if (object.send_asset != null) {
            if (typeof object.send_asset !== "object")
                throw TypeError(".StellarPathPaymentStrictReceiveOp.send_asset: object expected");
            message.send_asset = $root.StellarAsset.fromObject(object.send_asset);
        }
        if (object.send_max != null)
            if ($util.Long)
                (message.send_max = $util.Long.fromValue(object.send_max)).unsigned = false;
            else if (typeof object.send_max === "string")
                message.send_max = parseInt(object.send_max, 10);
            else if (typeof object.send_max === "number")
                message.send_max = object.send_max;
            else if (typeof object.send_max === "object")
                message.send_max = new $util.LongBits(object.send_max.low >>> 0, object.send_max.high >>> 0).toNumber();
        if (object.destination_account != null)
            message.destination_account = String(object.destination_account);
        if (object.destination_asset != null) {
            if (typeof object.destination_asset !== "object")
                throw TypeError(".StellarPathPaymentStrictReceiveOp.destination_asset: object expected");
            message.destination_asset = $root.StellarAsset.fromObject(object.destination_asset);
        }
        if (object.destination_amount != null)
            if ($util.Long)
                (message.destination_amount = $util.Long.fromValue(object.destination_amount)).unsigned = false;
            else if (typeof object.destination_amount === "string")
                message.destination_amount = parseInt(object.destination_amount, 10);
            else if (typeof object.destination_amount === "number")
                message.destination_amount = object.destination_amount;
            else if (typeof object.destination_amount === "object")
                message.destination_amount = new $util.LongBits(object.destination_amount.low >>> 0, object.destination_amount.high >>> 0).toNumber();
        if (object.paths) {
            if (!Array.isArray(object.paths))
                throw TypeError(".StellarPathPaymentStrictReceiveOp.paths: array expected");
            message.paths = [];
            for (var i = 0; i < object.paths.length; ++i) {
                if (typeof object.paths[i] !== "object")
                    throw TypeError(".StellarPathPaymentStrictReceiveOp.paths: object expected");
                message.paths[i] = $root.StellarAsset.fromObject(object.paths[i]);
            }
        }
        return message;
    };

    StellarPathPaymentStrictReceiveOp.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.paths = [];
        if (options.defaults) {
            object.source_account = "";
            object.send_asset = null;
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.send_max = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.send_max = options.longs === String ? "0" : 0;
            object.destination_account = "";
            object.destination_asset = null;
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.destination_amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.destination_amount = options.longs === String ? "0" : 0;
        }
        if (message.source_account != null && message.hasOwnProperty("source_account"))
            object.source_account = message.source_account;
        if (message.send_asset != null && message.hasOwnProperty("send_asset"))
            object.send_asset = $root.StellarAsset.toObject(message.send_asset, options);
        if (message.send_max != null && message.hasOwnProperty("send_max"))
            if (typeof message.send_max === "number")
                object.send_max = options.longs === String ? String(message.send_max) : message.send_max;
            else
                object.send_max = options.longs === String ? $util.Long.prototype.toString.call(message.send_max) : options.longs === Number ? new $util.LongBits(message.send_max.low >>> 0, message.send_max.high >>> 0).toNumber() : message.send_max;
        if (message.destination_account != null && message.hasOwnProperty("destination_account"))
            object.destination_account = message.destination_account;
        if (message.destination_asset != null && message.hasOwnProperty("destination_asset"))
            object.destination_asset = $root.StellarAsset.toObject(message.destination_asset, options);
        if (message.destination_amount != null && message.hasOwnProperty("destination_amount"))
            if (typeof message.destination_amount === "number")
                object.destination_amount = options.longs === String ? String(message.destination_amount) : message.destination_amount;
            else
                object.destination_amount = options.longs === String ? $util.Long.prototype.toString.call(message.destination_amount) : options.longs === Number ? new $util.LongBits(message.destination_amount.low >>> 0, message.destination_amount.high >>> 0).toNumber() : message.destination_amount;
        if (message.paths && message.paths.length) {
            object.paths = [];
            for (var j = 0; j < message.paths.length; ++j)
                object.paths[j] = $root.StellarAsset.toObject(message.paths[j], options);
        }
        return object;
    };

    StellarPathPaymentStrictReceiveOp.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return StellarPathPaymentStrictReceiveOp;
})();

$root.StellarPathPaymentStrictSendOp = (function() {

    function StellarPathPaymentStrictSendOp(properties) {
        this.paths = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    StellarPathPaymentStrictSendOp.prototype.source_account = "";
    StellarPathPaymentStrictSendOp.prototype.send_asset = null;
    StellarPathPaymentStrictSendOp.prototype.send_amount = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    StellarPathPaymentStrictSendOp.prototype.destination_account = "";
    StellarPathPaymentStrictSendOp.prototype.destination_asset = null;
    StellarPathPaymentStrictSendOp.prototype.destination_min = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    StellarPathPaymentStrictSendOp.prototype.paths = $util.emptyArray;

    StellarPathPaymentStrictSendOp.create = function create(properties) {
        return new StellarPathPaymentStrictSendOp(properties);
    };

    StellarPathPaymentStrictSendOp.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.source_account != null && Object.hasOwnProperty.call(message, "source_account"))
            writer.uint32(10).string(message.source_account);
        $root.StellarAsset.encode(message.send_asset, writer.uint32(18).fork()).ldelim();
        writer.uint32(24).sint64(message.send_amount);
        writer.uint32(34).string(message.destination_account);
        $root.StellarAsset.encode(message.destination_asset, writer.uint32(42).fork()).ldelim();
        writer.uint32(48).sint64(message.destination_min);
        if (message.paths != null && message.paths.length)
            for (var i = 0; i < message.paths.length; ++i)
                $root.StellarAsset.encode(message.paths[i], writer.uint32(58).fork()).ldelim();
        return writer;
    };

    StellarPathPaymentStrictSendOp.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    StellarPathPaymentStrictSendOp.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.StellarPathPaymentStrictSendOp();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.source_account = reader.string();
                break;
            case 2:
                message.send_asset = $root.StellarAsset.decode(reader, reader.uint32());
                break;
            case 3:
                message.send_amount = reader.sint64();
                break;
            case 4:
                message.destination_account = reader.string();
                break;
            case 5:
                message.destination_asset = $root.StellarAsset.decode(reader, reader.uint32());
                break;
            case 6:
                message.destination_min = reader.sint64();
                break;
            case 7:
                if (!(message.paths && message.paths.length))
                    message.paths = [];
                message.paths.push($root.StellarAsset.decode(reader, reader.uint32()));
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("send_asset"))
            throw $util.ProtocolError("missing required 'send_asset'", { instance: message });
        if (!message.hasOwnProperty("send_amount"))
            throw $util.ProtocolError("missing required 'send_amount'", { instance: message });
        if (!message.hasOwnProperty("destination_account"))
            throw $util.ProtocolError("missing required 'destination_account'", { instance: message });
        if (!message.hasOwnProperty("destination_asset"))
            throw $util.ProtocolError("missing required 'destination_asset'", { instance: message });
        if (!message.hasOwnProperty("destination_min"))
            throw $util.ProtocolError("missing required 'destination_min'", { instance: message });
        return message;
    };

    StellarPathPaymentStrictSendOp.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    StellarPathPaymentStrictSendOp.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.source_account != null && message.hasOwnProperty("source_account"))
            if (!$util.isString(message.source_account))
                return "source_account: string expected";
        {
            var error = $root.StellarAsset.verify(message.send_asset);
            if (error)
                return "send_asset." + error;
        }
        if (!$util.isInteger(message.send_amount) && !(message.send_amount && $util.isInteger(message.send_amount.low) && $util.isInteger(message.send_amount.high)))
            return "send_amount: integer|Long expected";
        if (!$util.isString(message.destination_account))
            return "destination_account: string expected";
        {
            var error = $root.StellarAsset.verify(message.destination_asset);
            if (error)
                return "destination_asset." + error;
        }
        if (!$util.isInteger(message.destination_min) && !(message.destination_min && $util.isInteger(message.destination_min.low) && $util.isInteger(message.destination_min.high)))
            return "destination_min: integer|Long expected";
        if (message.paths != null && message.hasOwnProperty("paths")) {
            if (!Array.isArray(message.paths))
                return "paths: array expected";
            for (var i = 0; i < message.paths.length; ++i) {
                var error = $root.StellarAsset.verify(message.paths[i]);
                if (error)
                    return "paths." + error;
            }
        }
        return null;
    };

    StellarPathPaymentStrictSendOp.fromObject = function fromObject(object) {
        if (object instanceof $root.StellarPathPaymentStrictSendOp)
            return object;
        var message = new $root.StellarPathPaymentStrictSendOp();
        if (object.source_account != null)
            message.source_account = String(object.source_account);
        if (object.send_asset != null) {
            if (typeof object.send_asset !== "object")
                throw TypeError(".StellarPathPaymentStrictSendOp.send_asset: object expected");
            message.send_asset = $root.StellarAsset.fromObject(object.send_asset);
        }
        if (object.send_amount != null)
            if ($util.Long)
                (message.send_amount = $util.Long.fromValue(object.send_amount)).unsigned = false;
            else if (typeof object.send_amount === "string")
                message.send_amount = parseInt(object.send_amount, 10);
            else if (typeof object.send_amount === "number")
                message.send_amount = object.send_amount;
            else if (typeof object.send_amount === "object")
                message.send_amount = new $util.LongBits(object.send_amount.low >>> 0, object.send_amount.high >>> 0).toNumber();
        if (object.destination_account != null)
            message.destination_account = String(object.destination_account);
        if (object.destination_asset != null) {
            if (typeof object.destination_asset !== "object")
                throw TypeError(".StellarPathPaymentStrictSendOp.destination_asset: object expected");
            message.destination_asset = $root.StellarAsset.fromObject(object.destination_asset);
        }
        if (object.destination_min != null)
            if ($util.Long)
                (message.destination_min = $util.Long.fromValue(object.destination_min)).unsigned = false;
            else if (typeof object.destination_min === "string")
                message.destination_min = parseInt(object.destination_min, 10);
            else if (typeof object.destination_min === "number")
                message.destination_min = object.destination_min;
            else if (typeof object.destination_min === "object")
                message.destination_min = new $util.LongBits(object.destination_min.low >>> 0, object.destination_min.high >>> 0).toNumber();
        if (object.paths) {
            if (!Array.isArray(object.paths))
                throw TypeError(".StellarPathPaymentStrictSendOp.paths: array expected");
            message.paths = [];
            for (var i = 0; i < object.paths.length; ++i) {
                if (typeof object.paths[i] !== "object")
                    throw TypeError(".StellarPathPaymentStrictSendOp.paths: object expected");
                message.paths[i] = $root.StellarAsset.fromObject(object.paths[i]);
            }
        }
        return message;
    };

    StellarPathPaymentStrictSendOp.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.paths = [];
        if (options.defaults) {
            object.source_account = "";
            object.send_asset = null;
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.send_amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.send_amount = options.longs === String ? "0" : 0;
            object.destination_account = "";
            object.destination_asset = null;
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.destination_min = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.destination_min = options.longs === String ? "0" : 0;
        }
        if (message.source_account != null && message.hasOwnProperty("source_account"))
            object.source_account = message.source_account;
        if (message.send_asset != null && message.hasOwnProperty("send_asset"))
            object.send_asset = $root.StellarAsset.toObject(message.send_asset, options);
        if (message.send_amount != null && message.hasOwnProperty("send_amount"))
            if (typeof message.send_amount === "number")
                object.send_amount = options.longs === String ? String(message.send_amount) : message.send_amount;
            else
                object.send_amount = options.longs === String ? $util.Long.prototype.toString.call(message.send_amount) : options.longs === Number ? new $util.LongBits(message.send_amount.low >>> 0, message.send_amount.high >>> 0).toNumber() : message.send_amount;
        if (message.destination_account != null && message.hasOwnProperty("destination_account"))
            object.destination_account = message.destination_account;
        if (message.destination_asset != null && message.hasOwnProperty("destination_asset"))
            object.destination_asset = $root.StellarAsset.toObject(message.destination_asset, options);
        if (message.destination_min != null && message.hasOwnProperty("destination_min"))
            if (typeof message.destination_min === "number")
                object.destination_min = options.longs === String ? String(message.destination_min) : message.destination_min;
            else
                object.destination_min = options.longs === String ? $util.Long.prototype.toString.call(message.destination_min) : options.longs === Number ? new $util.LongBits(message.destination_min.low >>> 0, message.destination_min.high >>> 0).toNumber() : message.destination_min;
        if (message.paths && message.paths.length) {
            object.paths = [];
            for (var j = 0; j < message.paths.length; ++j)
                object.paths[j] = $root.StellarAsset.toObject(message.paths[j], options);
        }
        return object;
    };

    StellarPathPaymentStrictSendOp.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return StellarPathPaymentStrictSendOp;
})();

$root.StellarManageSellOfferOp = (function() {

    function StellarManageSellOfferOp(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    StellarManageSellOfferOp.prototype.source_account = "";
    StellarManageSellOfferOp.prototype.selling_asset = null;
    StellarManageSellOfferOp.prototype.buying_asset = null;
    StellarManageSellOfferOp.prototype.amount = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    StellarManageSellOfferOp.prototype.price_n = 0;
    StellarManageSellOfferOp.prototype.price_d = 0;
    StellarManageSellOfferOp.prototype.offer_id = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    StellarManageSellOfferOp.create = function create(properties) {
        return new StellarManageSellOfferOp(properties);
    };

    StellarManageSellOfferOp.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.source_account != null && Object.hasOwnProperty.call(message, "source_account"))
            writer.uint32(10).string(message.source_account);
        $root.StellarAsset.encode(message.selling_asset, writer.uint32(18).fork()).ldelim();
        $root.StellarAsset.encode(message.buying_asset, writer.uint32(26).fork()).ldelim();
        writer.uint32(32).sint64(message.amount);
        writer.uint32(40).uint32(message.price_n);
        writer.uint32(48).uint32(message.price_d);
        writer.uint32(56).uint64(message.offer_id);
        return writer;
    };

    StellarManageSellOfferOp.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    StellarManageSellOfferOp.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.StellarManageSellOfferOp();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.source_account = reader.string();
                break;
            case 2:
                message.selling_asset = $root.StellarAsset.decode(reader, reader.uint32());
                break;
            case 3:
                message.buying_asset = $root.StellarAsset.decode(reader, reader.uint32());
                break;
            case 4:
                message.amount = reader.sint64();
                break;
            case 5:
                message.price_n = reader.uint32();
                break;
            case 6:
                message.price_d = reader.uint32();
                break;
            case 7:
                message.offer_id = reader.uint64();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("selling_asset"))
            throw $util.ProtocolError("missing required 'selling_asset'", { instance: message });
        if (!message.hasOwnProperty("buying_asset"))
            throw $util.ProtocolError("missing required 'buying_asset'", { instance: message });
        if (!message.hasOwnProperty("amount"))
            throw $util.ProtocolError("missing required 'amount'", { instance: message });
        if (!message.hasOwnProperty("price_n"))
            throw $util.ProtocolError("missing required 'price_n'", { instance: message });
        if (!message.hasOwnProperty("price_d"))
            throw $util.ProtocolError("missing required 'price_d'", { instance: message });
        if (!message.hasOwnProperty("offer_id"))
            throw $util.ProtocolError("missing required 'offer_id'", { instance: message });
        return message;
    };

    StellarManageSellOfferOp.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    StellarManageSellOfferOp.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.source_account != null && message.hasOwnProperty("source_account"))
            if (!$util.isString(message.source_account))
                return "source_account: string expected";
        {
            var error = $root.StellarAsset.verify(message.selling_asset);
            if (error)
                return "selling_asset." + error;
        }
        {
            var error = $root.StellarAsset.verify(message.buying_asset);
            if (error)
                return "buying_asset." + error;
        }
        if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
            return "amount: integer|Long expected";
        if (!$util.isInteger(message.price_n))
            return "price_n: integer expected";
        if (!$util.isInteger(message.price_d))
            return "price_d: integer expected";
        if (!$util.isInteger(message.offer_id) && !(message.offer_id && $util.isInteger(message.offer_id.low) && $util.isInteger(message.offer_id.high)))
            return "offer_id: integer|Long expected";
        return null;
    };

    StellarManageSellOfferOp.fromObject = function fromObject(object) {
        if (object instanceof $root.StellarManageSellOfferOp)
            return object;
        var message = new $root.StellarManageSellOfferOp();
        if (object.source_account != null)
            message.source_account = String(object.source_account);
        if (object.selling_asset != null) {
            if (typeof object.selling_asset !== "object")
                throw TypeError(".StellarManageSellOfferOp.selling_asset: object expected");
            message.selling_asset = $root.StellarAsset.fromObject(object.selling_asset);
        }
        if (object.buying_asset != null) {
            if (typeof object.buying_asset !== "object")
                throw TypeError(".StellarManageSellOfferOp.buying_asset: object expected");
            message.buying_asset = $root.StellarAsset.fromObject(object.buying_asset);
        }
        if (object.amount != null)
            if ($util.Long)
                (message.amount = $util.Long.fromValue(object.amount)).unsigned = false;
            else if (typeof object.amount === "string")
                message.amount = parseInt(object.amount, 10);
            else if (typeof object.amount === "number")
                message.amount = object.amount;
            else if (typeof object.amount === "object")
                message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber();
        if (object.price_n != null)
            message.price_n = object.price_n >>> 0;
        if (object.price_d != null)
            message.price_d = object.price_d >>> 0;
        if (object.offer_id != null)
            if ($util.Long)
                (message.offer_id = $util.Long.fromValue(object.offer_id)).unsigned = true;
            else if (typeof object.offer_id === "string")
                message.offer_id = parseInt(object.offer_id, 10);
            else if (typeof object.offer_id === "number")
                message.offer_id = object.offer_id;
            else if (typeof object.offer_id === "object")
                message.offer_id = new $util.LongBits(object.offer_id.low >>> 0, object.offer_id.high >>> 0).toNumber(true);
        return message;
    };

    StellarManageSellOfferOp.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.source_account = "";
            object.selling_asset = null;
            object.buying_asset = null;
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.amount = options.longs === String ? "0" : 0;
            object.price_n = 0;
            object.price_d = 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.offer_id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.offer_id = options.longs === String ? "0" : 0;
        }
        if (message.source_account != null && message.hasOwnProperty("source_account"))
            object.source_account = message.source_account;
        if (message.selling_asset != null && message.hasOwnProperty("selling_asset"))
            object.selling_asset = $root.StellarAsset.toObject(message.selling_asset, options);
        if (message.buying_asset != null && message.hasOwnProperty("buying_asset"))
            object.buying_asset = $root.StellarAsset.toObject(message.buying_asset, options);
        if (message.amount != null && message.hasOwnProperty("amount"))
            if (typeof message.amount === "number")
                object.amount = options.longs === String ? String(message.amount) : message.amount;
            else
                object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber() : message.amount;
        if (message.price_n != null && message.hasOwnProperty("price_n"))
            object.price_n = message.price_n;
        if (message.price_d != null && message.hasOwnProperty("price_d"))
            object.price_d = message.price_d;
        if (message.offer_id != null && message.hasOwnProperty("offer_id"))
            if (typeof message.offer_id === "number")
                object.offer_id = options.longs === String ? String(message.offer_id) : message.offer_id;
            else
                object.offer_id = options.longs === String ? $util.Long.prototype.toString.call(message.offer_id) : options.longs === Number ? new $util.LongBits(message.offer_id.low >>> 0, message.offer_id.high >>> 0).toNumber(true) : message.offer_id;
        return object;
    };

    StellarManageSellOfferOp.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return StellarManageSellOfferOp;
})();

$root.StellarManageBuyOfferOp = (function() {

    function StellarManageBuyOfferOp(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    StellarManageBuyOfferOp.prototype.source_account = "";
    StellarManageBuyOfferOp.prototype.selling_asset = null;
    StellarManageBuyOfferOp.prototype.buying_asset = null;
    StellarManageBuyOfferOp.prototype.amount = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    StellarManageBuyOfferOp.prototype.price_n = 0;
    StellarManageBuyOfferOp.prototype.price_d = 0;
    StellarManageBuyOfferOp.prototype.offer_id = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    StellarManageBuyOfferOp.create = function create(properties) {
        return new StellarManageBuyOfferOp(properties);
    };

    StellarManageBuyOfferOp.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.source_account != null && Object.hasOwnProperty.call(message, "source_account"))
            writer.uint32(10).string(message.source_account);
        $root.StellarAsset.encode(message.selling_asset, writer.uint32(18).fork()).ldelim();
        $root.StellarAsset.encode(message.buying_asset, writer.uint32(26).fork()).ldelim();
        writer.uint32(32).sint64(message.amount);
        writer.uint32(40).uint32(message.price_n);
        writer.uint32(48).uint32(message.price_d);
        writer.uint32(56).uint64(message.offer_id);
        return writer;
    };

    StellarManageBuyOfferOp.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    StellarManageBuyOfferOp.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.StellarManageBuyOfferOp();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.source_account = reader.string();
                break;
            case 2:
                message.selling_asset = $root.StellarAsset.decode(reader, reader.uint32());
                break;
            case 3:
                message.buying_asset = $root.StellarAsset.decode(reader, reader.uint32());
                break;
            case 4:
                message.amount = reader.sint64();
                break;
            case 5:
                message.price_n = reader.uint32();
                break;
            case 6:
                message.price_d = reader.uint32();
                break;
            case 7:
                message.offer_id = reader.uint64();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("selling_asset"))
            throw $util.ProtocolError("missing required 'selling_asset'", { instance: message });
        if (!message.hasOwnProperty("buying_asset"))
            throw $util.ProtocolError("missing required 'buying_asset'", { instance: message });
        if (!message.hasOwnProperty("amount"))
            throw $util.ProtocolError("missing required 'amount'", { instance: message });
        if (!message.hasOwnProperty("price_n"))
            throw $util.ProtocolError("missing required 'price_n'", { instance: message });
        if (!message.hasOwnProperty("price_d"))
            throw $util.ProtocolError("missing required 'price_d'", { instance: message });
        if (!message.hasOwnProperty("offer_id"))
            throw $util.ProtocolError("missing required 'offer_id'", { instance: message });
        return message;
    };

    StellarManageBuyOfferOp.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    StellarManageBuyOfferOp.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.source_account != null && message.hasOwnProperty("source_account"))
            if (!$util.isString(message.source_account))
                return "source_account: string expected";
        {
            var error = $root.StellarAsset.verify(message.selling_asset);
            if (error)
                return "selling_asset." + error;
        }
        {
            var error = $root.StellarAsset.verify(message.buying_asset);
            if (error)
                return "buying_asset." + error;
        }
        if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
            return "amount: integer|Long expected";
        if (!$util.isInteger(message.price_n))
            return "price_n: integer expected";
        if (!$util.isInteger(message.price_d))
            return "price_d: integer expected";
        if (!$util.isInteger(message.offer_id) && !(message.offer_id && $util.isInteger(message.offer_id.low) && $util.isInteger(message.offer_id.high)))
            return "offer_id: integer|Long expected";
        return null;
    };

    StellarManageBuyOfferOp.fromObject = function fromObject(object) {
        if (object instanceof $root.StellarManageBuyOfferOp)
            return object;
        var message = new $root.StellarManageBuyOfferOp();
        if (object.source_account != null)
            message.source_account = String(object.source_account);
        if (object.selling_asset != null) {
            if (typeof object.selling_asset !== "object")
                throw TypeError(".StellarManageBuyOfferOp.selling_asset: object expected");
            message.selling_asset = $root.StellarAsset.fromObject(object.selling_asset);
        }
        if (object.buying_asset != null) {
            if (typeof object.buying_asset !== "object")
                throw TypeError(".StellarManageBuyOfferOp.buying_asset: object expected");
            message.buying_asset = $root.StellarAsset.fromObject(object.buying_asset);
        }
        if (object.amount != null)
            if ($util.Long)
                (message.amount = $util.Long.fromValue(object.amount)).unsigned = false;
            else if (typeof object.amount === "string")
                message.amount = parseInt(object.amount, 10);
            else if (typeof object.amount === "number")
                message.amount = object.amount;
            else if (typeof object.amount === "object")
                message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber();
        if (object.price_n != null)
            message.price_n = object.price_n >>> 0;
        if (object.price_d != null)
            message.price_d = object.price_d >>> 0;
        if (object.offer_id != null)
            if ($util.Long)
                (message.offer_id = $util.Long.fromValue(object.offer_id)).unsigned = true;
            else if (typeof object.offer_id === "string")
                message.offer_id = parseInt(object.offer_id, 10);
            else if (typeof object.offer_id === "number")
                message.offer_id = object.offer_id;
            else if (typeof object.offer_id === "object")
                message.offer_id = new $util.LongBits(object.offer_id.low >>> 0, object.offer_id.high >>> 0).toNumber(true);
        return message;
    };

    StellarManageBuyOfferOp.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.source_account = "";
            object.selling_asset = null;
            object.buying_asset = null;
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.amount = options.longs === String ? "0" : 0;
            object.price_n = 0;
            object.price_d = 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.offer_id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.offer_id = options.longs === String ? "0" : 0;
        }
        if (message.source_account != null && message.hasOwnProperty("source_account"))
            object.source_account = message.source_account;
        if (message.selling_asset != null && message.hasOwnProperty("selling_asset"))
            object.selling_asset = $root.StellarAsset.toObject(message.selling_asset, options);
        if (message.buying_asset != null && message.hasOwnProperty("buying_asset"))
            object.buying_asset = $root.StellarAsset.toObject(message.buying_asset, options);
        if (message.amount != null && message.hasOwnProperty("amount"))
            if (typeof message.amount === "number")
                object.amount = options.longs === String ? String(message.amount) : message.amount;
            else
                object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber() : message.amount;
        if (message.price_n != null && message.hasOwnProperty("price_n"))
            object.price_n = message.price_n;
        if (message.price_d != null && message.hasOwnProperty("price_d"))
            object.price_d = message.price_d;
        if (message.offer_id != null && message.hasOwnProperty("offer_id"))
            if (typeof message.offer_id === "number")
                object.offer_id = options.longs === String ? String(message.offer_id) : message.offer_id;
            else
                object.offer_id = options.longs === String ? $util.Long.prototype.toString.call(message.offer_id) : options.longs === Number ? new $util.LongBits(message.offer_id.low >>> 0, message.offer_id.high >>> 0).toNumber(true) : message.offer_id;
        return object;
    };

    StellarManageBuyOfferOp.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return StellarManageBuyOfferOp;
})();

$root.StellarCreatePassiveSellOfferOp = (function() {

    function StellarCreatePassiveSellOfferOp(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    StellarCreatePassiveSellOfferOp.prototype.source_account = "";
    StellarCreatePassiveSellOfferOp.prototype.selling_asset = null;
    StellarCreatePassiveSellOfferOp.prototype.buying_asset = null;
    StellarCreatePassiveSellOfferOp.prototype.amount = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    StellarCreatePassiveSellOfferOp.prototype.price_n = 0;
    StellarCreatePassiveSellOfferOp.prototype.price_d = 0;

    StellarCreatePassiveSellOfferOp.create = function create(properties) {
        return new StellarCreatePassiveSellOfferOp(properties);
    };

    StellarCreatePassiveSellOfferOp.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.source_account != null && Object.hasOwnProperty.call(message, "source_account"))
            writer.uint32(10).string(message.source_account);
        $root.StellarAsset.encode(message.selling_asset, writer.uint32(18).fork()).ldelim();
        $root.StellarAsset.encode(message.buying_asset, writer.uint32(26).fork()).ldelim();
        writer.uint32(32).sint64(message.amount);
        writer.uint32(40).uint32(message.price_n);
        writer.uint32(48).uint32(message.price_d);
        return writer;
    };

    StellarCreatePassiveSellOfferOp.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    StellarCreatePassiveSellOfferOp.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.StellarCreatePassiveSellOfferOp();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.source_account = reader.string();
                break;
            case 2:
                message.selling_asset = $root.StellarAsset.decode(reader, reader.uint32());
                break;
            case 3:
                message.buying_asset = $root.StellarAsset.decode(reader, reader.uint32());
                break;
            case 4:
                message.amount = reader.sint64();
                break;
            case 5:
                message.price_n = reader.uint32();
                break;
            case 6:
                message.price_d = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("selling_asset"))
            throw $util.ProtocolError("missing required 'selling_asset'", { instance: message });
        if (!message.hasOwnProperty("buying_asset"))
            throw $util.ProtocolError("missing required 'buying_asset'", { instance: message });
        if (!message.hasOwnProperty("amount"))
            throw $util.ProtocolError("missing required 'amount'", { instance: message });
        if (!message.hasOwnProperty("price_n"))
            throw $util.ProtocolError("missing required 'price_n'", { instance: message });
        if (!message.hasOwnProperty("price_d"))
            throw $util.ProtocolError("missing required 'price_d'", { instance: message });
        return message;
    };

    StellarCreatePassiveSellOfferOp.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    StellarCreatePassiveSellOfferOp.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.source_account != null && message.hasOwnProperty("source_account"))
            if (!$util.isString(message.source_account))
                return "source_account: string expected";
        {
            var error = $root.StellarAsset.verify(message.selling_asset);
            if (error)
                return "selling_asset." + error;
        }
        {
            var error = $root.StellarAsset.verify(message.buying_asset);
            if (error)
                return "buying_asset." + error;
        }
        if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
            return "amount: integer|Long expected";
        if (!$util.isInteger(message.price_n))
            return "price_n: integer expected";
        if (!$util.isInteger(message.price_d))
            return "price_d: integer expected";
        return null;
    };

    StellarCreatePassiveSellOfferOp.fromObject = function fromObject(object) {
        if (object instanceof $root.StellarCreatePassiveSellOfferOp)
            return object;
        var message = new $root.StellarCreatePassiveSellOfferOp();
        if (object.source_account != null)
            message.source_account = String(object.source_account);
        if (object.selling_asset != null) {
            if (typeof object.selling_asset !== "object")
                throw TypeError(".StellarCreatePassiveSellOfferOp.selling_asset: object expected");
            message.selling_asset = $root.StellarAsset.fromObject(object.selling_asset);
        }
        if (object.buying_asset != null) {
            if (typeof object.buying_asset !== "object")
                throw TypeError(".StellarCreatePassiveSellOfferOp.buying_asset: object expected");
            message.buying_asset = $root.StellarAsset.fromObject(object.buying_asset);
        }
        if (object.amount != null)
            if ($util.Long)
                (message.amount = $util.Long.fromValue(object.amount)).unsigned = false;
            else if (typeof object.amount === "string")
                message.amount = parseInt(object.amount, 10);
            else if (typeof object.amount === "number")
                message.amount = object.amount;
            else if (typeof object.amount === "object")
                message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber();
        if (object.price_n != null)
            message.price_n = object.price_n >>> 0;
        if (object.price_d != null)
            message.price_d = object.price_d >>> 0;
        return message;
    };

    StellarCreatePassiveSellOfferOp.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.source_account = "";
            object.selling_asset = null;
            object.buying_asset = null;
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.amount = options.longs === String ? "0" : 0;
            object.price_n = 0;
            object.price_d = 0;
        }
        if (message.source_account != null && message.hasOwnProperty("source_account"))
            object.source_account = message.source_account;
        if (message.selling_asset != null && message.hasOwnProperty("selling_asset"))
            object.selling_asset = $root.StellarAsset.toObject(message.selling_asset, options);
        if (message.buying_asset != null && message.hasOwnProperty("buying_asset"))
            object.buying_asset = $root.StellarAsset.toObject(message.buying_asset, options);
        if (message.amount != null && message.hasOwnProperty("amount"))
            if (typeof message.amount === "number")
                object.amount = options.longs === String ? String(message.amount) : message.amount;
            else
                object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber() : message.amount;
        if (message.price_n != null && message.hasOwnProperty("price_n"))
            object.price_n = message.price_n;
        if (message.price_d != null && message.hasOwnProperty("price_d"))
            object.price_d = message.price_d;
        return object;
    };

    StellarCreatePassiveSellOfferOp.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return StellarCreatePassiveSellOfferOp;
})();

$root.StellarSetOptionsOp = (function() {

    function StellarSetOptionsOp(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    StellarSetOptionsOp.prototype.source_account = "";
    StellarSetOptionsOp.prototype.inflation_destination_account = "";
    StellarSetOptionsOp.prototype.clear_flags = 0;
    StellarSetOptionsOp.prototype.set_flags = 0;
    StellarSetOptionsOp.prototype.master_weight = 0;
    StellarSetOptionsOp.prototype.low_threshold = 0;
    StellarSetOptionsOp.prototype.medium_threshold = 0;
    StellarSetOptionsOp.prototype.high_threshold = 0;
    StellarSetOptionsOp.prototype.home_domain = "";
    StellarSetOptionsOp.prototype.signer_type = 0;
    StellarSetOptionsOp.prototype.signer_key = $util.newBuffer([]);
    StellarSetOptionsOp.prototype.signer_weight = 0;

    StellarSetOptionsOp.create = function create(properties) {
        return new StellarSetOptionsOp(properties);
    };

    StellarSetOptionsOp.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.source_account != null && Object.hasOwnProperty.call(message, "source_account"))
            writer.uint32(10).string(message.source_account);
        if (message.inflation_destination_account != null && Object.hasOwnProperty.call(message, "inflation_destination_account"))
            writer.uint32(18).string(message.inflation_destination_account);
        if (message.clear_flags != null && Object.hasOwnProperty.call(message, "clear_flags"))
            writer.uint32(24).uint32(message.clear_flags);
        if (message.set_flags != null && Object.hasOwnProperty.call(message, "set_flags"))
            writer.uint32(32).uint32(message.set_flags);
        if (message.master_weight != null && Object.hasOwnProperty.call(message, "master_weight"))
            writer.uint32(40).uint32(message.master_weight);
        if (message.low_threshold != null && Object.hasOwnProperty.call(message, "low_threshold"))
            writer.uint32(48).uint32(message.low_threshold);
        if (message.medium_threshold != null && Object.hasOwnProperty.call(message, "medium_threshold"))
            writer.uint32(56).uint32(message.medium_threshold);
        if (message.high_threshold != null && Object.hasOwnProperty.call(message, "high_threshold"))
            writer.uint32(64).uint32(message.high_threshold);
        if (message.home_domain != null && Object.hasOwnProperty.call(message, "home_domain"))
            writer.uint32(74).string(message.home_domain);
        if (message.signer_type != null && Object.hasOwnProperty.call(message, "signer_type"))
            writer.uint32(80).int32(message.signer_type);
        if (message.signer_key != null && Object.hasOwnProperty.call(message, "signer_key"))
            writer.uint32(90).bytes(message.signer_key);
        if (message.signer_weight != null && Object.hasOwnProperty.call(message, "signer_weight"))
            writer.uint32(96).uint32(message.signer_weight);
        return writer;
    };

    StellarSetOptionsOp.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    StellarSetOptionsOp.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.StellarSetOptionsOp();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.source_account = reader.string();
                break;
            case 2:
                message.inflation_destination_account = reader.string();
                break;
            case 3:
                message.clear_flags = reader.uint32();
                break;
            case 4:
                message.set_flags = reader.uint32();
                break;
            case 5:
                message.master_weight = reader.uint32();
                break;
            case 6:
                message.low_threshold = reader.uint32();
                break;
            case 7:
                message.medium_threshold = reader.uint32();
                break;
            case 8:
                message.high_threshold = reader.uint32();
                break;
            case 9:
                message.home_domain = reader.string();
                break;
            case 10:
                message.signer_type = reader.int32();
                break;
            case 11:
                message.signer_key = reader.bytes();
                break;
            case 12:
                message.signer_weight = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    StellarSetOptionsOp.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    StellarSetOptionsOp.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.source_account != null && message.hasOwnProperty("source_account"))
            if (!$util.isString(message.source_account))
                return "source_account: string expected";
        if (message.inflation_destination_account != null && message.hasOwnProperty("inflation_destination_account"))
            if (!$util.isString(message.inflation_destination_account))
                return "inflation_destination_account: string expected";
        if (message.clear_flags != null && message.hasOwnProperty("clear_flags"))
            if (!$util.isInteger(message.clear_flags))
                return "clear_flags: integer expected";
        if (message.set_flags != null && message.hasOwnProperty("set_flags"))
            if (!$util.isInteger(message.set_flags))
                return "set_flags: integer expected";
        if (message.master_weight != null && message.hasOwnProperty("master_weight"))
            if (!$util.isInteger(message.master_weight))
                return "master_weight: integer expected";
        if (message.low_threshold != null && message.hasOwnProperty("low_threshold"))
            if (!$util.isInteger(message.low_threshold))
                return "low_threshold: integer expected";
        if (message.medium_threshold != null && message.hasOwnProperty("medium_threshold"))
            if (!$util.isInteger(message.medium_threshold))
                return "medium_threshold: integer expected";
        if (message.high_threshold != null && message.hasOwnProperty("high_threshold"))
            if (!$util.isInteger(message.high_threshold))
                return "high_threshold: integer expected";
        if (message.home_domain != null && message.hasOwnProperty("home_domain"))
            if (!$util.isString(message.home_domain))
                return "home_domain: string expected";
        if (message.signer_type != null && message.hasOwnProperty("signer_type"))
            switch (message.signer_type) {
            default:
                return "signer_type: enum value expected";
            case 0:
            case 1:
            case 2:
                break;
            }
        if (message.signer_key != null && message.hasOwnProperty("signer_key"))
            if (!(message.signer_key && typeof message.signer_key.length === "number" || $util.isString(message.signer_key)))
                return "signer_key: buffer expected";
        if (message.signer_weight != null && message.hasOwnProperty("signer_weight"))
            if (!$util.isInteger(message.signer_weight))
                return "signer_weight: integer expected";
        return null;
    };

    StellarSetOptionsOp.fromObject = function fromObject(object) {
        if (object instanceof $root.StellarSetOptionsOp)
            return object;
        var message = new $root.StellarSetOptionsOp();
        if (object.source_account != null)
            message.source_account = String(object.source_account);
        if (object.inflation_destination_account != null)
            message.inflation_destination_account = String(object.inflation_destination_account);
        if (object.clear_flags != null)
            message.clear_flags = object.clear_flags >>> 0;
        if (object.set_flags != null)
            message.set_flags = object.set_flags >>> 0;
        if (object.master_weight != null)
            message.master_weight = object.master_weight >>> 0;
        if (object.low_threshold != null)
            message.low_threshold = object.low_threshold >>> 0;
        if (object.medium_threshold != null)
            message.medium_threshold = object.medium_threshold >>> 0;
        if (object.high_threshold != null)
            message.high_threshold = object.high_threshold >>> 0;
        if (object.home_domain != null)
            message.home_domain = String(object.home_domain);
        switch (object.signer_type) {
        case "ACCOUNT":
        case 0:
            message.signer_type = 0;
            break;
        case "PRE_AUTH":
        case 1:
            message.signer_type = 1;
            break;
        case "HASH":
        case 2:
            message.signer_type = 2;
            break;
        }
        if (object.signer_key != null)
            if (typeof object.signer_key === "string")
                $util.base64.decode(object.signer_key, message.signer_key = $util.newBuffer($util.base64.length(object.signer_key)), 0);
            else if (object.signer_key.length)
                message.signer_key = object.signer_key;
        if (object.signer_weight != null)
            message.signer_weight = object.signer_weight >>> 0;
        return message;
    };

    StellarSetOptionsOp.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.source_account = "";
            object.inflation_destination_account = "";
            object.clear_flags = 0;
            object.set_flags = 0;
            object.master_weight = 0;
            object.low_threshold = 0;
            object.medium_threshold = 0;
            object.high_threshold = 0;
            object.home_domain = "";
            object.signer_type = options.enums === String ? "ACCOUNT" : 0;
            if (options.bytes === String)
                object.signer_key = "";
            else {
                object.signer_key = [];
                if (options.bytes !== Array)
                    object.signer_key = $util.newBuffer(object.signer_key);
            }
            object.signer_weight = 0;
        }
        if (message.source_account != null && message.hasOwnProperty("source_account"))
            object.source_account = message.source_account;
        if (message.inflation_destination_account != null && message.hasOwnProperty("inflation_destination_account"))
            object.inflation_destination_account = message.inflation_destination_account;
        if (message.clear_flags != null && message.hasOwnProperty("clear_flags"))
            object.clear_flags = message.clear_flags;
        if (message.set_flags != null && message.hasOwnProperty("set_flags"))
            object.set_flags = message.set_flags;
        if (message.master_weight != null && message.hasOwnProperty("master_weight"))
            object.master_weight = message.master_weight;
        if (message.low_threshold != null && message.hasOwnProperty("low_threshold"))
            object.low_threshold = message.low_threshold;
        if (message.medium_threshold != null && message.hasOwnProperty("medium_threshold"))
            object.medium_threshold = message.medium_threshold;
        if (message.high_threshold != null && message.hasOwnProperty("high_threshold"))
            object.high_threshold = message.high_threshold;
        if (message.home_domain != null && message.hasOwnProperty("home_domain"))
            object.home_domain = message.home_domain;
        if (message.signer_type != null && message.hasOwnProperty("signer_type"))
            object.signer_type = options.enums === String ? $root.StellarSetOptionsOp.StellarSignerType[message.signer_type] : message.signer_type;
        if (message.signer_key != null && message.hasOwnProperty("signer_key"))
            object.signer_key = options.bytes === String ? $util.base64.encode(message.signer_key, 0, message.signer_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.signer_key) : message.signer_key;
        if (message.signer_weight != null && message.hasOwnProperty("signer_weight"))
            object.signer_weight = message.signer_weight;
        return object;
    };

    StellarSetOptionsOp.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    StellarSetOptionsOp.StellarSignerType = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "ACCOUNT"] = 0;
        values[valuesById[1] = "PRE_AUTH"] = 1;
        values[valuesById[2] = "HASH"] = 2;
        return values;
    })();

    return StellarSetOptionsOp;
})();

$root.StellarChangeTrustOp = (function() {

    function StellarChangeTrustOp(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    StellarChangeTrustOp.prototype.source_account = "";
    StellarChangeTrustOp.prototype.asset = null;
    StellarChangeTrustOp.prototype.limit = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    StellarChangeTrustOp.create = function create(properties) {
        return new StellarChangeTrustOp(properties);
    };

    StellarChangeTrustOp.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.source_account != null && Object.hasOwnProperty.call(message, "source_account"))
            writer.uint32(10).string(message.source_account);
        $root.StellarAsset.encode(message.asset, writer.uint32(18).fork()).ldelim();
        writer.uint32(24).uint64(message.limit);
        return writer;
    };

    StellarChangeTrustOp.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    StellarChangeTrustOp.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.StellarChangeTrustOp();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.source_account = reader.string();
                break;
            case 2:
                message.asset = $root.StellarAsset.decode(reader, reader.uint32());
                break;
            case 3:
                message.limit = reader.uint64();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("asset"))
            throw $util.ProtocolError("missing required 'asset'", { instance: message });
        if (!message.hasOwnProperty("limit"))
            throw $util.ProtocolError("missing required 'limit'", { instance: message });
        return message;
    };

    StellarChangeTrustOp.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    StellarChangeTrustOp.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.source_account != null && message.hasOwnProperty("source_account"))
            if (!$util.isString(message.source_account))
                return "source_account: string expected";
        {
            var error = $root.StellarAsset.verify(message.asset);
            if (error)
                return "asset." + error;
        }
        if (!$util.isInteger(message.limit) && !(message.limit && $util.isInteger(message.limit.low) && $util.isInteger(message.limit.high)))
            return "limit: integer|Long expected";
        return null;
    };

    StellarChangeTrustOp.fromObject = function fromObject(object) {
        if (object instanceof $root.StellarChangeTrustOp)
            return object;
        var message = new $root.StellarChangeTrustOp();
        if (object.source_account != null)
            message.source_account = String(object.source_account);
        if (object.asset != null) {
            if (typeof object.asset !== "object")
                throw TypeError(".StellarChangeTrustOp.asset: object expected");
            message.asset = $root.StellarAsset.fromObject(object.asset);
        }
        if (object.limit != null)
            if ($util.Long)
                (message.limit = $util.Long.fromValue(object.limit)).unsigned = true;
            else if (typeof object.limit === "string")
                message.limit = parseInt(object.limit, 10);
            else if (typeof object.limit === "number")
                message.limit = object.limit;
            else if (typeof object.limit === "object")
                message.limit = new $util.LongBits(object.limit.low >>> 0, object.limit.high >>> 0).toNumber(true);
        return message;
    };

    StellarChangeTrustOp.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.source_account = "";
            object.asset = null;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.limit = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.limit = options.longs === String ? "0" : 0;
        }
        if (message.source_account != null && message.hasOwnProperty("source_account"))
            object.source_account = message.source_account;
        if (message.asset != null && message.hasOwnProperty("asset"))
            object.asset = $root.StellarAsset.toObject(message.asset, options);
        if (message.limit != null && message.hasOwnProperty("limit"))
            if (typeof message.limit === "number")
                object.limit = options.longs === String ? String(message.limit) : message.limit;
            else
                object.limit = options.longs === String ? $util.Long.prototype.toString.call(message.limit) : options.longs === Number ? new $util.LongBits(message.limit.low >>> 0, message.limit.high >>> 0).toNumber(true) : message.limit;
        return object;
    };

    StellarChangeTrustOp.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return StellarChangeTrustOp;
})();

$root.StellarAllowTrustOp = (function() {

    function StellarAllowTrustOp(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    StellarAllowTrustOp.prototype.source_account = "";
    StellarAllowTrustOp.prototype.trusted_account = "";
    StellarAllowTrustOp.prototype.asset_type = 0;
    StellarAllowTrustOp.prototype.asset_code = "";
    StellarAllowTrustOp.prototype.is_authorized = false;

    StellarAllowTrustOp.create = function create(properties) {
        return new StellarAllowTrustOp(properties);
    };

    StellarAllowTrustOp.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.source_account != null && Object.hasOwnProperty.call(message, "source_account"))
            writer.uint32(10).string(message.source_account);
        writer.uint32(18).string(message.trusted_account);
        writer.uint32(24).int32(message.asset_type);
        if (message.asset_code != null && Object.hasOwnProperty.call(message, "asset_code"))
            writer.uint32(34).string(message.asset_code);
        writer.uint32(40).bool(message.is_authorized);
        return writer;
    };

    StellarAllowTrustOp.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    StellarAllowTrustOp.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.StellarAllowTrustOp();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.source_account = reader.string();
                break;
            case 2:
                message.trusted_account = reader.string();
                break;
            case 3:
                message.asset_type = reader.int32();
                break;
            case 4:
                message.asset_code = reader.string();
                break;
            case 5:
                message.is_authorized = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("trusted_account"))
            throw $util.ProtocolError("missing required 'trusted_account'", { instance: message });
        if (!message.hasOwnProperty("asset_type"))
            throw $util.ProtocolError("missing required 'asset_type'", { instance: message });
        if (!message.hasOwnProperty("is_authorized"))
            throw $util.ProtocolError("missing required 'is_authorized'", { instance: message });
        return message;
    };

    StellarAllowTrustOp.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    StellarAllowTrustOp.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.source_account != null && message.hasOwnProperty("source_account"))
            if (!$util.isString(message.source_account))
                return "source_account: string expected";
        if (!$util.isString(message.trusted_account))
            return "trusted_account: string expected";
        switch (message.asset_type) {
        default:
            return "asset_type: enum value expected";
        case 0:
        case 1:
        case 2:
            break;
        }
        if (message.asset_code != null && message.hasOwnProperty("asset_code"))
            if (!$util.isString(message.asset_code))
                return "asset_code: string expected";
        if (typeof message.is_authorized !== "boolean")
            return "is_authorized: boolean expected";
        return null;
    };

    StellarAllowTrustOp.fromObject = function fromObject(object) {
        if (object instanceof $root.StellarAllowTrustOp)
            return object;
        var message = new $root.StellarAllowTrustOp();
        if (object.source_account != null)
            message.source_account = String(object.source_account);
        if (object.trusted_account != null)
            message.trusted_account = String(object.trusted_account);
        switch (object.asset_type) {
        case "NATIVE":
        case 0:
            message.asset_type = 0;
            break;
        case "ALPHANUM4":
        case 1:
            message.asset_type = 1;
            break;
        case "ALPHANUM12":
        case 2:
            message.asset_type = 2;
            break;
        }
        if (object.asset_code != null)
            message.asset_code = String(object.asset_code);
        if (object.is_authorized != null)
            message.is_authorized = Boolean(object.is_authorized);
        return message;
    };

    StellarAllowTrustOp.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.source_account = "";
            object.trusted_account = "";
            object.asset_type = options.enums === String ? "NATIVE" : 0;
            object.asset_code = "";
            object.is_authorized = false;
        }
        if (message.source_account != null && message.hasOwnProperty("source_account"))
            object.source_account = message.source_account;
        if (message.trusted_account != null && message.hasOwnProperty("trusted_account"))
            object.trusted_account = message.trusted_account;
        if (message.asset_type != null && message.hasOwnProperty("asset_type"))
            object.asset_type = options.enums === String ? $root.StellarAssetType[message.asset_type] : message.asset_type;
        if (message.asset_code != null && message.hasOwnProperty("asset_code"))
            object.asset_code = message.asset_code;
        if (message.is_authorized != null && message.hasOwnProperty("is_authorized"))
            object.is_authorized = message.is_authorized;
        return object;
    };

    StellarAllowTrustOp.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return StellarAllowTrustOp;
})();

$root.StellarAccountMergeOp = (function() {

    function StellarAccountMergeOp(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    StellarAccountMergeOp.prototype.source_account = "";
    StellarAccountMergeOp.prototype.destination_account = "";

    StellarAccountMergeOp.create = function create(properties) {
        return new StellarAccountMergeOp(properties);
    };

    StellarAccountMergeOp.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.source_account != null && Object.hasOwnProperty.call(message, "source_account"))
            writer.uint32(10).string(message.source_account);
        writer.uint32(18).string(message.destination_account);
        return writer;
    };

    StellarAccountMergeOp.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    StellarAccountMergeOp.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.StellarAccountMergeOp();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.source_account = reader.string();
                break;
            case 2:
                message.destination_account = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("destination_account"))
            throw $util.ProtocolError("missing required 'destination_account'", { instance: message });
        return message;
    };

    StellarAccountMergeOp.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    StellarAccountMergeOp.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.source_account != null && message.hasOwnProperty("source_account"))
            if (!$util.isString(message.source_account))
                return "source_account: string expected";
        if (!$util.isString(message.destination_account))
            return "destination_account: string expected";
        return null;
    };

    StellarAccountMergeOp.fromObject = function fromObject(object) {
        if (object instanceof $root.StellarAccountMergeOp)
            return object;
        var message = new $root.StellarAccountMergeOp();
        if (object.source_account != null)
            message.source_account = String(object.source_account);
        if (object.destination_account != null)
            message.destination_account = String(object.destination_account);
        return message;
    };

    StellarAccountMergeOp.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.source_account = "";
            object.destination_account = "";
        }
        if (message.source_account != null && message.hasOwnProperty("source_account"))
            object.source_account = message.source_account;
        if (message.destination_account != null && message.hasOwnProperty("destination_account"))
            object.destination_account = message.destination_account;
        return object;
    };

    StellarAccountMergeOp.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return StellarAccountMergeOp;
})();

$root.StellarManageDataOp = (function() {

    function StellarManageDataOp(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    StellarManageDataOp.prototype.source_account = "";
    StellarManageDataOp.prototype.key = "";
    StellarManageDataOp.prototype.value = $util.newBuffer([]);

    StellarManageDataOp.create = function create(properties) {
        return new StellarManageDataOp(properties);
    };

    StellarManageDataOp.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.source_account != null && Object.hasOwnProperty.call(message, "source_account"))
            writer.uint32(10).string(message.source_account);
        writer.uint32(18).string(message.key);
        if (message.value != null && Object.hasOwnProperty.call(message, "value"))
            writer.uint32(26).bytes(message.value);
        return writer;
    };

    StellarManageDataOp.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    StellarManageDataOp.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.StellarManageDataOp();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.source_account = reader.string();
                break;
            case 2:
                message.key = reader.string();
                break;
            case 3:
                message.value = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("key"))
            throw $util.ProtocolError("missing required 'key'", { instance: message });
        return message;
    };

    StellarManageDataOp.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    StellarManageDataOp.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.source_account != null && message.hasOwnProperty("source_account"))
            if (!$util.isString(message.source_account))
                return "source_account: string expected";
        if (!$util.isString(message.key))
            return "key: string expected";
        if (message.value != null && message.hasOwnProperty("value"))
            if (!(message.value && typeof message.value.length === "number" || $util.isString(message.value)))
                return "value: buffer expected";
        return null;
    };

    StellarManageDataOp.fromObject = function fromObject(object) {
        if (object instanceof $root.StellarManageDataOp)
            return object;
        var message = new $root.StellarManageDataOp();
        if (object.source_account != null)
            message.source_account = String(object.source_account);
        if (object.key != null)
            message.key = String(object.key);
        if (object.value != null)
            if (typeof object.value === "string")
                $util.base64.decode(object.value, message.value = $util.newBuffer($util.base64.length(object.value)), 0);
            else if (object.value.length)
                message.value = object.value;
        return message;
    };

    StellarManageDataOp.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.source_account = "";
            object.key = "";
            if (options.bytes === String)
                object.value = "";
            else {
                object.value = [];
                if (options.bytes !== Array)
                    object.value = $util.newBuffer(object.value);
            }
        }
        if (message.source_account != null && message.hasOwnProperty("source_account"))
            object.source_account = message.source_account;
        if (message.key != null && message.hasOwnProperty("key"))
            object.key = message.key;
        if (message.value != null && message.hasOwnProperty("value"))
            object.value = options.bytes === String ? $util.base64.encode(message.value, 0, message.value.length) : options.bytes === Array ? Array.prototype.slice.call(message.value) : message.value;
        return object;
    };

    StellarManageDataOp.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return StellarManageDataOp;
})();

$root.StellarBumpSequenceOp = (function() {

    function StellarBumpSequenceOp(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    StellarBumpSequenceOp.prototype.source_account = "";
    StellarBumpSequenceOp.prototype.bump_to = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    StellarBumpSequenceOp.create = function create(properties) {
        return new StellarBumpSequenceOp(properties);
    };

    StellarBumpSequenceOp.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.source_account != null && Object.hasOwnProperty.call(message, "source_account"))
            writer.uint32(10).string(message.source_account);
        writer.uint32(16).uint64(message.bump_to);
        return writer;
    };

    StellarBumpSequenceOp.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    StellarBumpSequenceOp.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.StellarBumpSequenceOp();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.source_account = reader.string();
                break;
            case 2:
                message.bump_to = reader.uint64();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("bump_to"))
            throw $util.ProtocolError("missing required 'bump_to'", { instance: message });
        return message;
    };

    StellarBumpSequenceOp.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    StellarBumpSequenceOp.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.source_account != null && message.hasOwnProperty("source_account"))
            if (!$util.isString(message.source_account))
                return "source_account: string expected";
        if (!$util.isInteger(message.bump_to) && !(message.bump_to && $util.isInteger(message.bump_to.low) && $util.isInteger(message.bump_to.high)))
            return "bump_to: integer|Long expected";
        return null;
    };

    StellarBumpSequenceOp.fromObject = function fromObject(object) {
        if (object instanceof $root.StellarBumpSequenceOp)
            return object;
        var message = new $root.StellarBumpSequenceOp();
        if (object.source_account != null)
            message.source_account = String(object.source_account);
        if (object.bump_to != null)
            if ($util.Long)
                (message.bump_to = $util.Long.fromValue(object.bump_to)).unsigned = true;
            else if (typeof object.bump_to === "string")
                message.bump_to = parseInt(object.bump_to, 10);
            else if (typeof object.bump_to === "number")
                message.bump_to = object.bump_to;
            else if (typeof object.bump_to === "object")
                message.bump_to = new $util.LongBits(object.bump_to.low >>> 0, object.bump_to.high >>> 0).toNumber(true);
        return message;
    };

    StellarBumpSequenceOp.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.source_account = "";
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.bump_to = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.bump_to = options.longs === String ? "0" : 0;
        }
        if (message.source_account != null && message.hasOwnProperty("source_account"))
            object.source_account = message.source_account;
        if (message.bump_to != null && message.hasOwnProperty("bump_to"))
            if (typeof message.bump_to === "number")
                object.bump_to = options.longs === String ? String(message.bump_to) : message.bump_to;
            else
                object.bump_to = options.longs === String ? $util.Long.prototype.toString.call(message.bump_to) : options.longs === Number ? new $util.LongBits(message.bump_to.low >>> 0, message.bump_to.high >>> 0).toNumber(true) : message.bump_to;
        return object;
    };

    StellarBumpSequenceOp.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return StellarBumpSequenceOp;
})();

$root.StellarInvokeHostFunctionOp = (function() {

    function StellarInvokeHostFunctionOp(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    StellarInvokeHostFunctionOp.prototype.source_account = "";
    StellarInvokeHostFunctionOp.prototype.contract_address = "";
    StellarInvokeHostFunctionOp.prototype.function_name = "";
    StellarInvokeHostFunctionOp.prototype.call_args_xdr_size = 0;
    StellarInvokeHostFunctionOp.prototype.call_args_xdr_initial_chunk = $util.newBuffer([]);
    StellarInvokeHostFunctionOp.prototype.soroban_auth_xdr_size = 0;
    StellarInvokeHostFunctionOp.prototype.soroban_auth_xdr_initial_chunk = $util.newBuffer([]);

    StellarInvokeHostFunctionOp.create = function create(properties) {
        return new StellarInvokeHostFunctionOp(properties);
    };

    StellarInvokeHostFunctionOp.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.source_account != null && Object.hasOwnProperty.call(message, "source_account"))
            writer.uint32(10).string(message.source_account);
        writer.uint32(18).string(message.contract_address);
        writer.uint32(26).string(message.function_name);
        writer.uint32(32).uint32(message.call_args_xdr_size);
        writer.uint32(42).bytes(message.call_args_xdr_initial_chunk);
        writer.uint32(48).uint32(message.soroban_auth_xdr_size);
        writer.uint32(58).bytes(message.soroban_auth_xdr_initial_chunk);
        return writer;
    };

    StellarInvokeHostFunctionOp.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    StellarInvokeHostFunctionOp.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.StellarInvokeHostFunctionOp();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.source_account = reader.string();
                break;
            case 2:
                message.contract_address = reader.string();
                break;
            case 3:
                message.function_name = reader.string();
                break;
            case 4:
                message.call_args_xdr_size = reader.uint32();
                break;
            case 5:
                message.call_args_xdr_initial_chunk = reader.bytes();
                break;
            case 6:
                message.soroban_auth_xdr_size = reader.uint32();
                break;
            case 7:
                message.soroban_auth_xdr_initial_chunk = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("contract_address"))
            throw $util.ProtocolError("missing required 'contract_address'", { instance: message });
        if (!message.hasOwnProperty("function_name"))
            throw $util.ProtocolError("missing required 'function_name'", { instance: message });
        if (!message.hasOwnProperty("call_args_xdr_size"))
            throw $util.ProtocolError("missing required 'call_args_xdr_size'", { instance: message });
        if (!message.hasOwnProperty("call_args_xdr_initial_chunk"))
            throw $util.ProtocolError("missing required 'call_args_xdr_initial_chunk'", { instance: message });
        if (!message.hasOwnProperty("soroban_auth_xdr_size"))
            throw $util.ProtocolError("missing required 'soroban_auth_xdr_size'", { instance: message });
        if (!message.hasOwnProperty("soroban_auth_xdr_initial_chunk"))
            throw $util.ProtocolError("missing required 'soroban_auth_xdr_initial_chunk'", { instance: message });
        return message;
    };

    StellarInvokeHostFunctionOp.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    StellarInvokeHostFunctionOp.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.source_account != null && message.hasOwnProperty("source_account"))
            if (!$util.isString(message.source_account))
                return "source_account: string expected";
        if (!$util.isString(message.contract_address))
            return "contract_address: string expected";
        if (!$util.isString(message.function_name))
            return "function_name: string expected";
        if (!$util.isInteger(message.call_args_xdr_size))
            return "call_args_xdr_size: integer expected";
        if (!(message.call_args_xdr_initial_chunk && typeof message.call_args_xdr_initial_chunk.length === "number" || $util.isString(message.call_args_xdr_initial_chunk)))
            return "call_args_xdr_initial_chunk: buffer expected";
        if (!$util.isInteger(message.soroban_auth_xdr_size))
            return "soroban_auth_xdr_size: integer expected";
        if (!(message.soroban_auth_xdr_initial_chunk && typeof message.soroban_auth_xdr_initial_chunk.length === "number" || $util.isString(message.soroban_auth_xdr_initial_chunk)))
            return "soroban_auth_xdr_initial_chunk: buffer expected";
        return null;
    };

    StellarInvokeHostFunctionOp.fromObject = function fromObject(object) {
        if (object instanceof $root.StellarInvokeHostFunctionOp)
            return object;
        var message = new $root.StellarInvokeHostFunctionOp();
        if (object.source_account != null)
            message.source_account = String(object.source_account);
        if (object.contract_address != null)
            message.contract_address = String(object.contract_address);
        if (object.function_name != null)
            message.function_name = String(object.function_name);
        if (object.call_args_xdr_size != null)
            message.call_args_xdr_size = object.call_args_xdr_size >>> 0;
        if (object.call_args_xdr_initial_chunk != null)
            if (typeof object.call_args_xdr_initial_chunk === "string")
                $util.base64.decode(object.call_args_xdr_initial_chunk, message.call_args_xdr_initial_chunk = $util.newBuffer($util.base64.length(object.call_args_xdr_initial_chunk)), 0);
            else if (object.call_args_xdr_initial_chunk.length)
                message.call_args_xdr_initial_chunk = object.call_args_xdr_initial_chunk;
        if (object.soroban_auth_xdr_size != null)
            message.soroban_auth_xdr_size = object.soroban_auth_xdr_size >>> 0;
        if (object.soroban_auth_xdr_initial_chunk != null)
            if (typeof object.soroban_auth_xdr_initial_chunk === "string")
                $util.base64.decode(object.soroban_auth_xdr_initial_chunk, message.soroban_auth_xdr_initial_chunk = $util.newBuffer($util.base64.length(object.soroban_auth_xdr_initial_chunk)), 0);
            else if (object.soroban_auth_xdr_initial_chunk.length)
                message.soroban_auth_xdr_initial_chunk = object.soroban_auth_xdr_initial_chunk;
        return message;
    };

    StellarInvokeHostFunctionOp.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.source_account = "";
            object.contract_address = "";
            object.function_name = "";
            object.call_args_xdr_size = 0;
            if (options.bytes === String)
                object.call_args_xdr_initial_chunk = "";
            else {
                object.call_args_xdr_initial_chunk = [];
                if (options.bytes !== Array)
                    object.call_args_xdr_initial_chunk = $util.newBuffer(object.call_args_xdr_initial_chunk);
            }
            object.soroban_auth_xdr_size = 0;
            if (options.bytes === String)
                object.soroban_auth_xdr_initial_chunk = "";
            else {
                object.soroban_auth_xdr_initial_chunk = [];
                if (options.bytes !== Array)
                    object.soroban_auth_xdr_initial_chunk = $util.newBuffer(object.soroban_auth_xdr_initial_chunk);
            }
        }
        if (message.source_account != null && message.hasOwnProperty("source_account"))
            object.source_account = message.source_account;
        if (message.contract_address != null && message.hasOwnProperty("contract_address"))
            object.contract_address = message.contract_address;
        if (message.function_name != null && message.hasOwnProperty("function_name"))
            object.function_name = message.function_name;
        if (message.call_args_xdr_size != null && message.hasOwnProperty("call_args_xdr_size"))
            object.call_args_xdr_size = message.call_args_xdr_size;
        if (message.call_args_xdr_initial_chunk != null && message.hasOwnProperty("call_args_xdr_initial_chunk"))
            object.call_args_xdr_initial_chunk = options.bytes === String ? $util.base64.encode(message.call_args_xdr_initial_chunk, 0, message.call_args_xdr_initial_chunk.length) : options.bytes === Array ? Array.prototype.slice.call(message.call_args_xdr_initial_chunk) : message.call_args_xdr_initial_chunk;
        if (message.soroban_auth_xdr_size != null && message.hasOwnProperty("soroban_auth_xdr_size"))
            object.soroban_auth_xdr_size = message.soroban_auth_xdr_size;
        if (message.soroban_auth_xdr_initial_chunk != null && message.hasOwnProperty("soroban_auth_xdr_initial_chunk"))
            object.soroban_auth_xdr_initial_chunk = options.bytes === String ? $util.base64.encode(message.soroban_auth_xdr_initial_chunk, 0, message.soroban_auth_xdr_initial_chunk.length) : options.bytes === Array ? Array.prototype.slice.call(message.soroban_auth_xdr_initial_chunk) : message.soroban_auth_xdr_initial_chunk;
        return object;
    };

    StellarInvokeHostFunctionOp.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return StellarInvokeHostFunctionOp;
})();

$root.StellarSorobanDataRequest = (function() {

    function StellarSorobanDataRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    StellarSorobanDataRequest.prototype.type = 0;
    StellarSorobanDataRequest.prototype.data_length = 0;

    StellarSorobanDataRequest.create = function create(properties) {
        return new StellarSorobanDataRequest(properties);
    };

    StellarSorobanDataRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).int32(message.type);
        writer.uint32(16).uint32(message.data_length);
        return writer;
    };

    StellarSorobanDataRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    StellarSorobanDataRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.StellarSorobanDataRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.type = reader.int32();
                break;
            case 2:
                message.data_length = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("type"))
            throw $util.ProtocolError("missing required 'type'", { instance: message });
        if (!message.hasOwnProperty("data_length"))
            throw $util.ProtocolError("missing required 'data_length'", { instance: message });
        return message;
    };

    StellarSorobanDataRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    StellarSorobanDataRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        switch (message.type) {
        default:
            return "type: enum value expected";
        case 0:
        case 1:
        case 2:
            break;
        }
        if (!$util.isInteger(message.data_length))
            return "data_length: integer expected";
        return null;
    };

    StellarSorobanDataRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.StellarSorobanDataRequest)
            return object;
        var message = new $root.StellarSorobanDataRequest();
        switch (object.type) {
        case "CALL":
        case 0:
            message.type = 0;
            break;
        case "AUTH":
        case 1:
            message.type = 1;
            break;
        case "EXT":
        case 2:
            message.type = 2;
            break;
        }
        if (object.data_length != null)
            message.data_length = object.data_length >>> 0;
        return message;
    };

    StellarSorobanDataRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.type = options.enums === String ? "CALL" : 0;
            object.data_length = 0;
        }
        if (message.type != null && message.hasOwnProperty("type"))
            object.type = options.enums === String ? $root.StellarSorobanDataRequest.StellarRequestType[message.type] : message.type;
        if (message.data_length != null && message.hasOwnProperty("data_length"))
            object.data_length = message.data_length;
        return object;
    };

    StellarSorobanDataRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    StellarSorobanDataRequest.StellarRequestType = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "CALL"] = 0;
        values[valuesById[1] = "AUTH"] = 1;
        values[valuesById[2] = "EXT"] = 2;
        return values;
    })();

    return StellarSorobanDataRequest;
})();

$root.StellarSorobanDataAck = (function() {

    function StellarSorobanDataAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    StellarSorobanDataAck.prototype.data_xdr = $util.newBuffer([]);

    StellarSorobanDataAck.create = function create(properties) {
        return new StellarSorobanDataAck(properties);
    };

    StellarSorobanDataAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.data_xdr);
        return writer;
    };

    StellarSorobanDataAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    StellarSorobanDataAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.StellarSorobanDataAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.data_xdr = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("data_xdr"))
            throw $util.ProtocolError("missing required 'data_xdr'", { instance: message });
        return message;
    };

    StellarSorobanDataAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    StellarSorobanDataAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.data_xdr && typeof message.data_xdr.length === "number" || $util.isString(message.data_xdr)))
            return "data_xdr: buffer expected";
        return null;
    };

    StellarSorobanDataAck.fromObject = function fromObject(object) {
        if (object instanceof $root.StellarSorobanDataAck)
            return object;
        var message = new $root.StellarSorobanDataAck();
        if (object.data_xdr != null)
            if (typeof object.data_xdr === "string")
                $util.base64.decode(object.data_xdr, message.data_xdr = $util.newBuffer($util.base64.length(object.data_xdr)), 0);
            else if (object.data_xdr.length)
                message.data_xdr = object.data_xdr;
        return message;
    };

    StellarSorobanDataAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.data_xdr = "";
            else {
                object.data_xdr = [];
                if (options.bytes !== Array)
                    object.data_xdr = $util.newBuffer(object.data_xdr);
            }
        if (message.data_xdr != null && message.hasOwnProperty("data_xdr"))
            object.data_xdr = options.bytes === String ? $util.base64.encode(message.data_xdr, 0, message.data_xdr.length) : options.bytes === Array ? Array.prototype.slice.call(message.data_xdr) : message.data_xdr;
        return object;
    };

    StellarSorobanDataAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return StellarSorobanDataAck;
})();

$root.StellarSignedTx = (function() {

    function StellarSignedTx(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    StellarSignedTx.prototype.public_key = $util.newBuffer([]);
    StellarSignedTx.prototype.signature = $util.newBuffer([]);

    StellarSignedTx.create = function create(properties) {
        return new StellarSignedTx(properties);
    };

    StellarSignedTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.public_key);
        writer.uint32(18).bytes(message.signature);
        return writer;
    };

    StellarSignedTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    StellarSignedTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.StellarSignedTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.public_key = reader.bytes();
                break;
            case 2:
                message.signature = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("public_key"))
            throw $util.ProtocolError("missing required 'public_key'", { instance: message });
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        return message;
    };

    StellarSignedTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    StellarSignedTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.public_key && typeof message.public_key.length === "number" || $util.isString(message.public_key)))
            return "public_key: buffer expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        return null;
    };

    StellarSignedTx.fromObject = function fromObject(object) {
        if (object instanceof $root.StellarSignedTx)
            return object;
        var message = new $root.StellarSignedTx();
        if (object.public_key != null)
            if (typeof object.public_key === "string")
                $util.base64.decode(object.public_key, message.public_key = $util.newBuffer($util.base64.length(object.public_key)), 0);
            else if (object.public_key.length)
                message.public_key = object.public_key;
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        return message;
    };

    StellarSignedTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.public_key = "";
            else {
                object.public_key = [];
                if (options.bytes !== Array)
                    object.public_key = $util.newBuffer(object.public_key);
            }
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
        }
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            object.public_key = options.bytes === String ? $util.base64.encode(message.public_key, 0, message.public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.public_key) : message.public_key;
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        return object;
    };

    StellarSignedTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return StellarSignedTx;
})();

$root.SuiGetAddress = (function() {

    function SuiGetAddress(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    SuiGetAddress.prototype.address_n = $util.emptyArray;
    SuiGetAddress.prototype.show_display = false;

    SuiGetAddress.create = function create(properties) {
        return new SuiGetAddress(properties);
    };

    SuiGetAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(16).bool(message.show_display);
        return writer;
    };

    SuiGetAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    SuiGetAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SuiGetAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.show_display = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    SuiGetAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    SuiGetAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        return null;
    };

    SuiGetAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.SuiGetAddress)
            return object;
        var message = new $root.SuiGetAddress();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".SuiGetAddress.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        return message;
    };

    SuiGetAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            object.show_display = false;
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        return object;
    };

    SuiGetAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SuiGetAddress;
})();

$root.SuiAddress = (function() {

    function SuiAddress(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    SuiAddress.prototype.address = "";

    SuiAddress.create = function create(properties) {
        return new SuiAddress(properties);
    };

    SuiAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address != null && Object.hasOwnProperty.call(message, "address"))
            writer.uint32(10).string(message.address);
        return writer;
    };

    SuiAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    SuiAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SuiAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    SuiAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    SuiAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address != null && message.hasOwnProperty("address"))
            if (!$util.isString(message.address))
                return "address: string expected";
        return null;
    };

    SuiAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.SuiAddress)
            return object;
        var message = new $root.SuiAddress();
        if (object.address != null)
            message.address = String(object.address);
        return message;
    };

    SuiAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.address = "";
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    SuiAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SuiAddress;
})();

$root.SuiSignTx = (function() {

    function SuiSignTx(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    SuiSignTx.prototype.address_n = $util.emptyArray;
    SuiSignTx.prototype.raw_tx = $util.newBuffer([]);
    SuiSignTx.prototype.data_initial_chunk = $util.newBuffer([]);
    SuiSignTx.prototype.data_length = 0;

    SuiSignTx.create = function create(properties) {
        return new SuiSignTx(properties);
    };

    SuiSignTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).bytes(message.raw_tx);
        if (message.data_initial_chunk != null && Object.hasOwnProperty.call(message, "data_initial_chunk"))
            writer.uint32(26).bytes(message.data_initial_chunk);
        if (message.data_length != null && Object.hasOwnProperty.call(message, "data_length"))
            writer.uint32(32).uint32(message.data_length);
        return writer;
    };

    SuiSignTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    SuiSignTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SuiSignTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.raw_tx = reader.bytes();
                break;
            case 3:
                message.data_initial_chunk = reader.bytes();
                break;
            case 4:
                message.data_length = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("raw_tx"))
            throw $util.ProtocolError("missing required 'raw_tx'", { instance: message });
        return message;
    };

    SuiSignTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    SuiSignTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!(message.raw_tx && typeof message.raw_tx.length === "number" || $util.isString(message.raw_tx)))
            return "raw_tx: buffer expected";
        if (message.data_initial_chunk != null && message.hasOwnProperty("data_initial_chunk"))
            if (!(message.data_initial_chunk && typeof message.data_initial_chunk.length === "number" || $util.isString(message.data_initial_chunk)))
                return "data_initial_chunk: buffer expected";
        if (message.data_length != null && message.hasOwnProperty("data_length"))
            if (!$util.isInteger(message.data_length))
                return "data_length: integer expected";
        return null;
    };

    SuiSignTx.fromObject = function fromObject(object) {
        if (object instanceof $root.SuiSignTx)
            return object;
        var message = new $root.SuiSignTx();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".SuiSignTx.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.raw_tx != null)
            if (typeof object.raw_tx === "string")
                $util.base64.decode(object.raw_tx, message.raw_tx = $util.newBuffer($util.base64.length(object.raw_tx)), 0);
            else if (object.raw_tx.length)
                message.raw_tx = object.raw_tx;
        if (object.data_initial_chunk != null)
            if (typeof object.data_initial_chunk === "string")
                $util.base64.decode(object.data_initial_chunk, message.data_initial_chunk = $util.newBuffer($util.base64.length(object.data_initial_chunk)), 0);
            else if (object.data_initial_chunk.length)
                message.data_initial_chunk = object.data_initial_chunk;
        if (object.data_length != null)
            message.data_length = object.data_length >>> 0;
        return message;
    };

    SuiSignTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            if (options.bytes === String)
                object.raw_tx = "";
            else {
                object.raw_tx = [];
                if (options.bytes !== Array)
                    object.raw_tx = $util.newBuffer(object.raw_tx);
            }
            if (options.bytes === String)
                object.data_initial_chunk = "";
            else {
                object.data_initial_chunk = [];
                if (options.bytes !== Array)
                    object.data_initial_chunk = $util.newBuffer(object.data_initial_chunk);
            }
            object.data_length = 0;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.raw_tx != null && message.hasOwnProperty("raw_tx"))
            object.raw_tx = options.bytes === String ? $util.base64.encode(message.raw_tx, 0, message.raw_tx.length) : options.bytes === Array ? Array.prototype.slice.call(message.raw_tx) : message.raw_tx;
        if (message.data_initial_chunk != null && message.hasOwnProperty("data_initial_chunk"))
            object.data_initial_chunk = options.bytes === String ? $util.base64.encode(message.data_initial_chunk, 0, message.data_initial_chunk.length) : options.bytes === Array ? Array.prototype.slice.call(message.data_initial_chunk) : message.data_initial_chunk;
        if (message.data_length != null && message.hasOwnProperty("data_length"))
            object.data_length = message.data_length;
        return object;
    };

    SuiSignTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SuiSignTx;
})();

$root.SuiSignedTx = (function() {

    function SuiSignedTx(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    SuiSignedTx.prototype.public_key = $util.newBuffer([]);
    SuiSignedTx.prototype.signature = $util.newBuffer([]);

    SuiSignedTx.create = function create(properties) {
        return new SuiSignedTx(properties);
    };

    SuiSignedTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.public_key);
        writer.uint32(18).bytes(message.signature);
        return writer;
    };

    SuiSignedTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    SuiSignedTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SuiSignedTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.public_key = reader.bytes();
                break;
            case 2:
                message.signature = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("public_key"))
            throw $util.ProtocolError("missing required 'public_key'", { instance: message });
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        return message;
    };

    SuiSignedTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    SuiSignedTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.public_key && typeof message.public_key.length === "number" || $util.isString(message.public_key)))
            return "public_key: buffer expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        return null;
    };

    SuiSignedTx.fromObject = function fromObject(object) {
        if (object instanceof $root.SuiSignedTx)
            return object;
        var message = new $root.SuiSignedTx();
        if (object.public_key != null)
            if (typeof object.public_key === "string")
                $util.base64.decode(object.public_key, message.public_key = $util.newBuffer($util.base64.length(object.public_key)), 0);
            else if (object.public_key.length)
                message.public_key = object.public_key;
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        return message;
    };

    SuiSignedTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.public_key = "";
            else {
                object.public_key = [];
                if (options.bytes !== Array)
                    object.public_key = $util.newBuffer(object.public_key);
            }
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
        }
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            object.public_key = options.bytes === String ? $util.base64.encode(message.public_key, 0, message.public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.public_key) : message.public_key;
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        return object;
    };

    SuiSignedTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SuiSignedTx;
})();

$root.SuiTxRequest = (function() {

    function SuiTxRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    SuiTxRequest.prototype.data_length = 0;
    SuiTxRequest.prototype.public_key = $util.newBuffer([]);
    SuiTxRequest.prototype.signature = $util.newBuffer([]);

    SuiTxRequest.create = function create(properties) {
        return new SuiTxRequest(properties);
    };

    SuiTxRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.data_length != null && Object.hasOwnProperty.call(message, "data_length"))
            writer.uint32(8).uint32(message.data_length);
        if (message.public_key != null && Object.hasOwnProperty.call(message, "public_key"))
            writer.uint32(18).bytes(message.public_key);
        if (message.signature != null && Object.hasOwnProperty.call(message, "signature"))
            writer.uint32(26).bytes(message.signature);
        return writer;
    };

    SuiTxRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    SuiTxRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SuiTxRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.data_length = reader.uint32();
                break;
            case 2:
                message.public_key = reader.bytes();
                break;
            case 3:
                message.signature = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    SuiTxRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    SuiTxRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.data_length != null && message.hasOwnProperty("data_length"))
            if (!$util.isInteger(message.data_length))
                return "data_length: integer expected";
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            if (!(message.public_key && typeof message.public_key.length === "number" || $util.isString(message.public_key)))
                return "public_key: buffer expected";
        if (message.signature != null && message.hasOwnProperty("signature"))
            if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
                return "signature: buffer expected";
        return null;
    };

    SuiTxRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.SuiTxRequest)
            return object;
        var message = new $root.SuiTxRequest();
        if (object.data_length != null)
            message.data_length = object.data_length >>> 0;
        if (object.public_key != null)
            if (typeof object.public_key === "string")
                $util.base64.decode(object.public_key, message.public_key = $util.newBuffer($util.base64.length(object.public_key)), 0);
            else if (object.public_key.length)
                message.public_key = object.public_key;
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        return message;
    };

    SuiTxRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.data_length = 0;
            if (options.bytes === String)
                object.public_key = "";
            else {
                object.public_key = [];
                if (options.bytes !== Array)
                    object.public_key = $util.newBuffer(object.public_key);
            }
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
        }
        if (message.data_length != null && message.hasOwnProperty("data_length"))
            object.data_length = message.data_length;
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            object.public_key = options.bytes === String ? $util.base64.encode(message.public_key, 0, message.public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.public_key) : message.public_key;
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        return object;
    };

    SuiTxRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SuiTxRequest;
})();

$root.SuiTxAck = (function() {

    function SuiTxAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    SuiTxAck.prototype.data_chunk = $util.newBuffer([]);

    SuiTxAck.create = function create(properties) {
        return new SuiTxAck(properties);
    };

    SuiTxAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.data_chunk);
        return writer;
    };

    SuiTxAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    SuiTxAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SuiTxAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.data_chunk = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("data_chunk"))
            throw $util.ProtocolError("missing required 'data_chunk'", { instance: message });
        return message;
    };

    SuiTxAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    SuiTxAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.data_chunk && typeof message.data_chunk.length === "number" || $util.isString(message.data_chunk)))
            return "data_chunk: buffer expected";
        return null;
    };

    SuiTxAck.fromObject = function fromObject(object) {
        if (object instanceof $root.SuiTxAck)
            return object;
        var message = new $root.SuiTxAck();
        if (object.data_chunk != null)
            if (typeof object.data_chunk === "string")
                $util.base64.decode(object.data_chunk, message.data_chunk = $util.newBuffer($util.base64.length(object.data_chunk)), 0);
            else if (object.data_chunk.length)
                message.data_chunk = object.data_chunk;
        return message;
    };

    SuiTxAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.data_chunk = "";
            else {
                object.data_chunk = [];
                if (options.bytes !== Array)
                    object.data_chunk = $util.newBuffer(object.data_chunk);
            }
        if (message.data_chunk != null && message.hasOwnProperty("data_chunk"))
            object.data_chunk = options.bytes === String ? $util.base64.encode(message.data_chunk, 0, message.data_chunk.length) : options.bytes === Array ? Array.prototype.slice.call(message.data_chunk) : message.data_chunk;
        return object;
    };

    SuiTxAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SuiTxAck;
})();

$root.SuiSignMessage = (function() {

    function SuiSignMessage(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    SuiSignMessage.prototype.address_n = $util.emptyArray;
    SuiSignMessage.prototype.message = $util.newBuffer([]);

    SuiSignMessage.create = function create(properties) {
        return new SuiSignMessage(properties);
    };

    SuiSignMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).bytes(message.message);
        return writer;
    };

    SuiSignMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    SuiSignMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SuiSignMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.message = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("message"))
            throw $util.ProtocolError("missing required 'message'", { instance: message });
        return message;
    };

    SuiSignMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    SuiSignMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!(message.message && typeof message.message.length === "number" || $util.isString(message.message)))
            return "message: buffer expected";
        return null;
    };

    SuiSignMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.SuiSignMessage)
            return object;
        var message = new $root.SuiSignMessage();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".SuiSignMessage.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.message != null)
            if (typeof object.message === "string")
                $util.base64.decode(object.message, message.message = $util.newBuffer($util.base64.length(object.message)), 0);
            else if (object.message.length)
                message.message = object.message;
        return message;
    };

    SuiSignMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            if (options.bytes === String)
                object.message = "";
            else {
                object.message = [];
                if (options.bytes !== Array)
                    object.message = $util.newBuffer(object.message);
            }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.message != null && message.hasOwnProperty("message"))
            object.message = options.bytes === String ? $util.base64.encode(message.message, 0, message.message.length) : options.bytes === Array ? Array.prototype.slice.call(message.message) : message.message;
        return object;
    };

    SuiSignMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SuiSignMessage;
})();

$root.SuiMessageSignature = (function() {

    function SuiMessageSignature(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    SuiMessageSignature.prototype.signature = $util.newBuffer([]);
    SuiMessageSignature.prototype.address = "";

    SuiMessageSignature.create = function create(properties) {
        return new SuiMessageSignature(properties);
    };

    SuiMessageSignature.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.signature);
        writer.uint32(18).string(message.address);
        return writer;
    };

    SuiMessageSignature.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    SuiMessageSignature.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SuiMessageSignature();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.signature = reader.bytes();
                break;
            case 2:
                message.address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        if (!message.hasOwnProperty("address"))
            throw $util.ProtocolError("missing required 'address'", { instance: message });
        return message;
    };

    SuiMessageSignature.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    SuiMessageSignature.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        if (!$util.isString(message.address))
            return "address: string expected";
        return null;
    };

    SuiMessageSignature.fromObject = function fromObject(object) {
        if (object instanceof $root.SuiMessageSignature)
            return object;
        var message = new $root.SuiMessageSignature();
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        if (object.address != null)
            message.address = String(object.address);
        return message;
    };

    SuiMessageSignature.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
            object.address = "";
        }
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    SuiMessageSignature.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SuiMessageSignature;
})();

$root.TezosGetAddress = (function() {

    function TezosGetAddress(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    TezosGetAddress.prototype.address_n = $util.emptyArray;
    TezosGetAddress.prototype.show_display = false;

    TezosGetAddress.create = function create(properties) {
        return new TezosGetAddress(properties);
    };

    TezosGetAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(16).bool(message.show_display);
        return writer;
    };

    TezosGetAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    TezosGetAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TezosGetAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.show_display = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    TezosGetAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    TezosGetAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        return null;
    };

    TezosGetAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.TezosGetAddress)
            return object;
        var message = new $root.TezosGetAddress();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".TezosGetAddress.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        return message;
    };

    TezosGetAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            object.show_display = false;
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        return object;
    };

    TezosGetAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return TezosGetAddress;
})();

$root.TezosAddress = (function() {

    function TezosAddress(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    TezosAddress.prototype.address = "";

    TezosAddress.create = function create(properties) {
        return new TezosAddress(properties);
    };

    TezosAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.address);
        return writer;
    };

    TezosAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    TezosAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TezosAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("address"))
            throw $util.ProtocolError("missing required 'address'", { instance: message });
        return message;
    };

    TezosAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    TezosAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.address))
            return "address: string expected";
        return null;
    };

    TezosAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.TezosAddress)
            return object;
        var message = new $root.TezosAddress();
        if (object.address != null)
            message.address = String(object.address);
        return message;
    };

    TezosAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.address = "";
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    TezosAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return TezosAddress;
})();

$root.TezosGetPublicKey = (function() {

    function TezosGetPublicKey(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    TezosGetPublicKey.prototype.address_n = $util.emptyArray;
    TezosGetPublicKey.prototype.show_display = false;

    TezosGetPublicKey.create = function create(properties) {
        return new TezosGetPublicKey(properties);
    };

    TezosGetPublicKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(16).bool(message.show_display);
        return writer;
    };

    TezosGetPublicKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    TezosGetPublicKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TezosGetPublicKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.show_display = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    TezosGetPublicKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    TezosGetPublicKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        return null;
    };

    TezosGetPublicKey.fromObject = function fromObject(object) {
        if (object instanceof $root.TezosGetPublicKey)
            return object;
        var message = new $root.TezosGetPublicKey();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".TezosGetPublicKey.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        return message;
    };

    TezosGetPublicKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            object.show_display = false;
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        return object;
    };

    TezosGetPublicKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return TezosGetPublicKey;
})();

$root.TezosPublicKey = (function() {

    function TezosPublicKey(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    TezosPublicKey.prototype.public_key = "";

    TezosPublicKey.create = function create(properties) {
        return new TezosPublicKey(properties);
    };

    TezosPublicKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.public_key);
        return writer;
    };

    TezosPublicKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    TezosPublicKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TezosPublicKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.public_key = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("public_key"))
            throw $util.ProtocolError("missing required 'public_key'", { instance: message });
        return message;
    };

    TezosPublicKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    TezosPublicKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.public_key))
            return "public_key: string expected";
        return null;
    };

    TezosPublicKey.fromObject = function fromObject(object) {
        if (object instanceof $root.TezosPublicKey)
            return object;
        var message = new $root.TezosPublicKey();
        if (object.public_key != null)
            message.public_key = String(object.public_key);
        return message;
    };

    TezosPublicKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.public_key = "";
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            object.public_key = message.public_key;
        return object;
    };

    TezosPublicKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return TezosPublicKey;
})();

$root.TezosSignTx = (function() {

    function TezosSignTx(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    TezosSignTx.prototype.address_n = $util.emptyArray;
    TezosSignTx.prototype.branch = $util.newBuffer([]);
    TezosSignTx.prototype.reveal = null;
    TezosSignTx.prototype.transaction = null;
    TezosSignTx.prototype.origination = null;
    TezosSignTx.prototype.delegation = null;
    TezosSignTx.prototype.proposal = null;
    TezosSignTx.prototype.ballot = null;

    TezosSignTx.create = function create(properties) {
        return new TezosSignTx(properties);
    };

    TezosSignTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).bytes(message.branch);
        if (message.reveal != null && Object.hasOwnProperty.call(message, "reveal"))
            $root.TezosSignTx.TezosRevealOp.encode(message.reveal, writer.uint32(26).fork()).ldelim();
        if (message.transaction != null && Object.hasOwnProperty.call(message, "transaction"))
            $root.TezosSignTx.TezosTransactionOp.encode(message.transaction, writer.uint32(34).fork()).ldelim();
        if (message.origination != null && Object.hasOwnProperty.call(message, "origination"))
            $root.TezosSignTx.TezosOriginationOp.encode(message.origination, writer.uint32(42).fork()).ldelim();
        if (message.delegation != null && Object.hasOwnProperty.call(message, "delegation"))
            $root.TezosSignTx.TezosDelegationOp.encode(message.delegation, writer.uint32(50).fork()).ldelim();
        if (message.proposal != null && Object.hasOwnProperty.call(message, "proposal"))
            $root.TezosSignTx.TezosProposalOp.encode(message.proposal, writer.uint32(58).fork()).ldelim();
        if (message.ballot != null && Object.hasOwnProperty.call(message, "ballot"))
            $root.TezosSignTx.TezosBallotOp.encode(message.ballot, writer.uint32(66).fork()).ldelim();
        return writer;
    };

    TezosSignTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    TezosSignTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TezosSignTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.branch = reader.bytes();
                break;
            case 3:
                message.reveal = $root.TezosSignTx.TezosRevealOp.decode(reader, reader.uint32());
                break;
            case 4:
                message.transaction = $root.TezosSignTx.TezosTransactionOp.decode(reader, reader.uint32());
                break;
            case 5:
                message.origination = $root.TezosSignTx.TezosOriginationOp.decode(reader, reader.uint32());
                break;
            case 6:
                message.delegation = $root.TezosSignTx.TezosDelegationOp.decode(reader, reader.uint32());
                break;
            case 7:
                message.proposal = $root.TezosSignTx.TezosProposalOp.decode(reader, reader.uint32());
                break;
            case 8:
                message.ballot = $root.TezosSignTx.TezosBallotOp.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("branch"))
            throw $util.ProtocolError("missing required 'branch'", { instance: message });
        return message;
    };

    TezosSignTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    TezosSignTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!(message.branch && typeof message.branch.length === "number" || $util.isString(message.branch)))
            return "branch: buffer expected";
        if (message.reveal != null && message.hasOwnProperty("reveal")) {
            var error = $root.TezosSignTx.TezosRevealOp.verify(message.reveal);
            if (error)
                return "reveal." + error;
        }
        if (message.transaction != null && message.hasOwnProperty("transaction")) {
            var error = $root.TezosSignTx.TezosTransactionOp.verify(message.transaction);
            if (error)
                return "transaction." + error;
        }
        if (message.origination != null && message.hasOwnProperty("origination")) {
            var error = $root.TezosSignTx.TezosOriginationOp.verify(message.origination);
            if (error)
                return "origination." + error;
        }
        if (message.delegation != null && message.hasOwnProperty("delegation")) {
            var error = $root.TezosSignTx.TezosDelegationOp.verify(message.delegation);
            if (error)
                return "delegation." + error;
        }
        if (message.proposal != null && message.hasOwnProperty("proposal")) {
            var error = $root.TezosSignTx.TezosProposalOp.verify(message.proposal);
            if (error)
                return "proposal." + error;
        }
        if (message.ballot != null && message.hasOwnProperty("ballot")) {
            var error = $root.TezosSignTx.TezosBallotOp.verify(message.ballot);
            if (error)
                return "ballot." + error;
        }
        return null;
    };

    TezosSignTx.fromObject = function fromObject(object) {
        if (object instanceof $root.TezosSignTx)
            return object;
        var message = new $root.TezosSignTx();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".TezosSignTx.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.branch != null)
            if (typeof object.branch === "string")
                $util.base64.decode(object.branch, message.branch = $util.newBuffer($util.base64.length(object.branch)), 0);
            else if (object.branch.length)
                message.branch = object.branch;
        if (object.reveal != null) {
            if (typeof object.reveal !== "object")
                throw TypeError(".TezosSignTx.reveal: object expected");
            message.reveal = $root.TezosSignTx.TezosRevealOp.fromObject(object.reveal);
        }
        if (object.transaction != null) {
            if (typeof object.transaction !== "object")
                throw TypeError(".TezosSignTx.transaction: object expected");
            message.transaction = $root.TezosSignTx.TezosTransactionOp.fromObject(object.transaction);
        }
        if (object.origination != null) {
            if (typeof object.origination !== "object")
                throw TypeError(".TezosSignTx.origination: object expected");
            message.origination = $root.TezosSignTx.TezosOriginationOp.fromObject(object.origination);
        }
        if (object.delegation != null) {
            if (typeof object.delegation !== "object")
                throw TypeError(".TezosSignTx.delegation: object expected");
            message.delegation = $root.TezosSignTx.TezosDelegationOp.fromObject(object.delegation);
        }
        if (object.proposal != null) {
            if (typeof object.proposal !== "object")
                throw TypeError(".TezosSignTx.proposal: object expected");
            message.proposal = $root.TezosSignTx.TezosProposalOp.fromObject(object.proposal);
        }
        if (object.ballot != null) {
            if (typeof object.ballot !== "object")
                throw TypeError(".TezosSignTx.ballot: object expected");
            message.ballot = $root.TezosSignTx.TezosBallotOp.fromObject(object.ballot);
        }
        return message;
    };

    TezosSignTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            if (options.bytes === String)
                object.branch = "";
            else {
                object.branch = [];
                if (options.bytes !== Array)
                    object.branch = $util.newBuffer(object.branch);
            }
            object.reveal = null;
            object.transaction = null;
            object.origination = null;
            object.delegation = null;
            object.proposal = null;
            object.ballot = null;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.branch != null && message.hasOwnProperty("branch"))
            object.branch = options.bytes === String ? $util.base64.encode(message.branch, 0, message.branch.length) : options.bytes === Array ? Array.prototype.slice.call(message.branch) : message.branch;
        if (message.reveal != null && message.hasOwnProperty("reveal"))
            object.reveal = $root.TezosSignTx.TezosRevealOp.toObject(message.reveal, options);
        if (message.transaction != null && message.hasOwnProperty("transaction"))
            object.transaction = $root.TezosSignTx.TezosTransactionOp.toObject(message.transaction, options);
        if (message.origination != null && message.hasOwnProperty("origination"))
            object.origination = $root.TezosSignTx.TezosOriginationOp.toObject(message.origination, options);
        if (message.delegation != null && message.hasOwnProperty("delegation"))
            object.delegation = $root.TezosSignTx.TezosDelegationOp.toObject(message.delegation, options);
        if (message.proposal != null && message.hasOwnProperty("proposal"))
            object.proposal = $root.TezosSignTx.TezosProposalOp.toObject(message.proposal, options);
        if (message.ballot != null && message.hasOwnProperty("ballot"))
            object.ballot = $root.TezosSignTx.TezosBallotOp.toObject(message.ballot, options);
        return object;
    };

    TezosSignTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    TezosSignTx.TezosContractID = (function() {

        function TezosContractID(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        TezosContractID.prototype.tag = 0;
        TezosContractID.prototype.hash = $util.newBuffer([]);

        TezosContractID.create = function create(properties) {
            return new TezosContractID(properties);
        };

        TezosContractID.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(8).int32(message.tag);
            writer.uint32(18).bytes(message.hash);
            return writer;
        };

        TezosContractID.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        TezosContractID.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TezosSignTx.TezosContractID();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.tag = reader.int32();
                    break;
                case 2:
                    message.hash = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("tag"))
                throw $util.ProtocolError("missing required 'tag'", { instance: message });
            if (!message.hasOwnProperty("hash"))
                throw $util.ProtocolError("missing required 'hash'", { instance: message });
            return message;
        };

        TezosContractID.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        TezosContractID.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            switch (message.tag) {
            default:
                return "tag: enum value expected";
            case 0:
            case 1:
                break;
            }
            if (!(message.hash && typeof message.hash.length === "number" || $util.isString(message.hash)))
                return "hash: buffer expected";
            return null;
        };

        TezosContractID.fromObject = function fromObject(object) {
            if (object instanceof $root.TezosSignTx.TezosContractID)
                return object;
            var message = new $root.TezosSignTx.TezosContractID();
            switch (object.tag) {
            case "Implicit":
            case 0:
                message.tag = 0;
                break;
            case "Originated":
            case 1:
                message.tag = 1;
                break;
            }
            if (object.hash != null)
                if (typeof object.hash === "string")
                    $util.base64.decode(object.hash, message.hash = $util.newBuffer($util.base64.length(object.hash)), 0);
                else if (object.hash.length)
                    message.hash = object.hash;
            return message;
        };

        TezosContractID.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.tag = options.enums === String ? "Implicit" : 0;
                if (options.bytes === String)
                    object.hash = "";
                else {
                    object.hash = [];
                    if (options.bytes !== Array)
                        object.hash = $util.newBuffer(object.hash);
                }
            }
            if (message.tag != null && message.hasOwnProperty("tag"))
                object.tag = options.enums === String ? $root.TezosSignTx.TezosContractID.TezosContractType[message.tag] : message.tag;
            if (message.hash != null && message.hasOwnProperty("hash"))
                object.hash = options.bytes === String ? $util.base64.encode(message.hash, 0, message.hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.hash) : message.hash;
            return object;
        };

        TezosContractID.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        TezosContractID.TezosContractType = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "Implicit"] = 0;
            values[valuesById[1] = "Originated"] = 1;
            return values;
        })();

        return TezosContractID;
    })();

    TezosSignTx.TezosRevealOp = (function() {

        function TezosRevealOp(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        TezosRevealOp.prototype.source = $util.newBuffer([]);
        TezosRevealOp.prototype.fee = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        TezosRevealOp.prototype.counter = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        TezosRevealOp.prototype.gas_limit = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        TezosRevealOp.prototype.storage_limit = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        TezosRevealOp.prototype.public_key = $util.newBuffer([]);

        TezosRevealOp.create = function create(properties) {
            return new TezosRevealOp(properties);
        };

        TezosRevealOp.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(16).uint64(message.fee);
            writer.uint32(24).uint64(message.counter);
            writer.uint32(32).uint64(message.gas_limit);
            writer.uint32(40).uint64(message.storage_limit);
            writer.uint32(50).bytes(message.public_key);
            writer.uint32(58).bytes(message.source);
            return writer;
        };

        TezosRevealOp.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        TezosRevealOp.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TezosSignTx.TezosRevealOp();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 7:
                    message.source = reader.bytes();
                    break;
                case 2:
                    message.fee = reader.uint64();
                    break;
                case 3:
                    message.counter = reader.uint64();
                    break;
                case 4:
                    message.gas_limit = reader.uint64();
                    break;
                case 5:
                    message.storage_limit = reader.uint64();
                    break;
                case 6:
                    message.public_key = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("source"))
                throw $util.ProtocolError("missing required 'source'", { instance: message });
            if (!message.hasOwnProperty("fee"))
                throw $util.ProtocolError("missing required 'fee'", { instance: message });
            if (!message.hasOwnProperty("counter"))
                throw $util.ProtocolError("missing required 'counter'", { instance: message });
            if (!message.hasOwnProperty("gas_limit"))
                throw $util.ProtocolError("missing required 'gas_limit'", { instance: message });
            if (!message.hasOwnProperty("storage_limit"))
                throw $util.ProtocolError("missing required 'storage_limit'", { instance: message });
            if (!message.hasOwnProperty("public_key"))
                throw $util.ProtocolError("missing required 'public_key'", { instance: message });
            return message;
        };

        TezosRevealOp.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        TezosRevealOp.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!(message.source && typeof message.source.length === "number" || $util.isString(message.source)))
                return "source: buffer expected";
            if (!$util.isInteger(message.fee) && !(message.fee && $util.isInteger(message.fee.low) && $util.isInteger(message.fee.high)))
                return "fee: integer|Long expected";
            if (!$util.isInteger(message.counter) && !(message.counter && $util.isInteger(message.counter.low) && $util.isInteger(message.counter.high)))
                return "counter: integer|Long expected";
            if (!$util.isInteger(message.gas_limit) && !(message.gas_limit && $util.isInteger(message.gas_limit.low) && $util.isInteger(message.gas_limit.high)))
                return "gas_limit: integer|Long expected";
            if (!$util.isInteger(message.storage_limit) && !(message.storage_limit && $util.isInteger(message.storage_limit.low) && $util.isInteger(message.storage_limit.high)))
                return "storage_limit: integer|Long expected";
            if (!(message.public_key && typeof message.public_key.length === "number" || $util.isString(message.public_key)))
                return "public_key: buffer expected";
            return null;
        };

        TezosRevealOp.fromObject = function fromObject(object) {
            if (object instanceof $root.TezosSignTx.TezosRevealOp)
                return object;
            var message = new $root.TezosSignTx.TezosRevealOp();
            if (object.source != null)
                if (typeof object.source === "string")
                    $util.base64.decode(object.source, message.source = $util.newBuffer($util.base64.length(object.source)), 0);
                else if (object.source.length)
                    message.source = object.source;
            if (object.fee != null)
                if ($util.Long)
                    (message.fee = $util.Long.fromValue(object.fee)).unsigned = true;
                else if (typeof object.fee === "string")
                    message.fee = parseInt(object.fee, 10);
                else if (typeof object.fee === "number")
                    message.fee = object.fee;
                else if (typeof object.fee === "object")
                    message.fee = new $util.LongBits(object.fee.low >>> 0, object.fee.high >>> 0).toNumber(true);
            if (object.counter != null)
                if ($util.Long)
                    (message.counter = $util.Long.fromValue(object.counter)).unsigned = true;
                else if (typeof object.counter === "string")
                    message.counter = parseInt(object.counter, 10);
                else if (typeof object.counter === "number")
                    message.counter = object.counter;
                else if (typeof object.counter === "object")
                    message.counter = new $util.LongBits(object.counter.low >>> 0, object.counter.high >>> 0).toNumber(true);
            if (object.gas_limit != null)
                if ($util.Long)
                    (message.gas_limit = $util.Long.fromValue(object.gas_limit)).unsigned = true;
                else if (typeof object.gas_limit === "string")
                    message.gas_limit = parseInt(object.gas_limit, 10);
                else if (typeof object.gas_limit === "number")
                    message.gas_limit = object.gas_limit;
                else if (typeof object.gas_limit === "object")
                    message.gas_limit = new $util.LongBits(object.gas_limit.low >>> 0, object.gas_limit.high >>> 0).toNumber(true);
            if (object.storage_limit != null)
                if ($util.Long)
                    (message.storage_limit = $util.Long.fromValue(object.storage_limit)).unsigned = true;
                else if (typeof object.storage_limit === "string")
                    message.storage_limit = parseInt(object.storage_limit, 10);
                else if (typeof object.storage_limit === "number")
                    message.storage_limit = object.storage_limit;
                else if (typeof object.storage_limit === "object")
                    message.storage_limit = new $util.LongBits(object.storage_limit.low >>> 0, object.storage_limit.high >>> 0).toNumber(true);
            if (object.public_key != null)
                if (typeof object.public_key === "string")
                    $util.base64.decode(object.public_key, message.public_key = $util.newBuffer($util.base64.length(object.public_key)), 0);
                else if (object.public_key.length)
                    message.public_key = object.public_key;
            return message;
        };

        TezosRevealOp.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.fee = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.fee = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.counter = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.counter = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.gas_limit = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.gas_limit = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.storage_limit = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.storage_limit = options.longs === String ? "0" : 0;
                if (options.bytes === String)
                    object.public_key = "";
                else {
                    object.public_key = [];
                    if (options.bytes !== Array)
                        object.public_key = $util.newBuffer(object.public_key);
                }
                if (options.bytes === String)
                    object.source = "";
                else {
                    object.source = [];
                    if (options.bytes !== Array)
                        object.source = $util.newBuffer(object.source);
                }
            }
            if (message.fee != null && message.hasOwnProperty("fee"))
                if (typeof message.fee === "number")
                    object.fee = options.longs === String ? String(message.fee) : message.fee;
                else
                    object.fee = options.longs === String ? $util.Long.prototype.toString.call(message.fee) : options.longs === Number ? new $util.LongBits(message.fee.low >>> 0, message.fee.high >>> 0).toNumber(true) : message.fee;
            if (message.counter != null && message.hasOwnProperty("counter"))
                if (typeof message.counter === "number")
                    object.counter = options.longs === String ? String(message.counter) : message.counter;
                else
                    object.counter = options.longs === String ? $util.Long.prototype.toString.call(message.counter) : options.longs === Number ? new $util.LongBits(message.counter.low >>> 0, message.counter.high >>> 0).toNumber(true) : message.counter;
            if (message.gas_limit != null && message.hasOwnProperty("gas_limit"))
                if (typeof message.gas_limit === "number")
                    object.gas_limit = options.longs === String ? String(message.gas_limit) : message.gas_limit;
                else
                    object.gas_limit = options.longs === String ? $util.Long.prototype.toString.call(message.gas_limit) : options.longs === Number ? new $util.LongBits(message.gas_limit.low >>> 0, message.gas_limit.high >>> 0).toNumber(true) : message.gas_limit;
            if (message.storage_limit != null && message.hasOwnProperty("storage_limit"))
                if (typeof message.storage_limit === "number")
                    object.storage_limit = options.longs === String ? String(message.storage_limit) : message.storage_limit;
                else
                    object.storage_limit = options.longs === String ? $util.Long.prototype.toString.call(message.storage_limit) : options.longs === Number ? new $util.LongBits(message.storage_limit.low >>> 0, message.storage_limit.high >>> 0).toNumber(true) : message.storage_limit;
            if (message.public_key != null && message.hasOwnProperty("public_key"))
                object.public_key = options.bytes === String ? $util.base64.encode(message.public_key, 0, message.public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.public_key) : message.public_key;
            if (message.source != null && message.hasOwnProperty("source"))
                object.source = options.bytes === String ? $util.base64.encode(message.source, 0, message.source.length) : options.bytes === Array ? Array.prototype.slice.call(message.source) : message.source;
            return object;
        };

        TezosRevealOp.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TezosRevealOp;
    })();

    TezosSignTx.TezosTransactionOp = (function() {

        function TezosTransactionOp(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        TezosTransactionOp.prototype.source = $util.newBuffer([]);
        TezosTransactionOp.prototype.fee = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        TezosTransactionOp.prototype.counter = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        TezosTransactionOp.prototype.gas_limit = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        TezosTransactionOp.prototype.storage_limit = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        TezosTransactionOp.prototype.amount = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        TezosTransactionOp.prototype.destination = null;
        TezosTransactionOp.prototype.parameters = $util.newBuffer([]);
        TezosTransactionOp.prototype.parameters_manager = null;

        TezosTransactionOp.create = function create(properties) {
            return new TezosTransactionOp(properties);
        };

        TezosTransactionOp.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(16).uint64(message.fee);
            writer.uint32(24).uint64(message.counter);
            writer.uint32(32).uint64(message.gas_limit);
            writer.uint32(40).uint64(message.storage_limit);
            writer.uint32(48).uint64(message.amount);
            $root.TezosSignTx.TezosContractID.encode(message.destination, writer.uint32(58).fork()).ldelim();
            if (message.parameters != null && Object.hasOwnProperty.call(message, "parameters"))
                writer.uint32(66).bytes(message.parameters);
            writer.uint32(74).bytes(message.source);
            if (message.parameters_manager != null && Object.hasOwnProperty.call(message, "parameters_manager"))
                $root.TezosSignTx.TezosTransactionOp.TezosParametersManager.encode(message.parameters_manager, writer.uint32(82).fork()).ldelim();
            return writer;
        };

        TezosTransactionOp.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        TezosTransactionOp.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TezosSignTx.TezosTransactionOp();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 9:
                    message.source = reader.bytes();
                    break;
                case 2:
                    message.fee = reader.uint64();
                    break;
                case 3:
                    message.counter = reader.uint64();
                    break;
                case 4:
                    message.gas_limit = reader.uint64();
                    break;
                case 5:
                    message.storage_limit = reader.uint64();
                    break;
                case 6:
                    message.amount = reader.uint64();
                    break;
                case 7:
                    message.destination = $root.TezosSignTx.TezosContractID.decode(reader, reader.uint32());
                    break;
                case 8:
                    message.parameters = reader.bytes();
                    break;
                case 10:
                    message.parameters_manager = $root.TezosSignTx.TezosTransactionOp.TezosParametersManager.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("source"))
                throw $util.ProtocolError("missing required 'source'", { instance: message });
            if (!message.hasOwnProperty("fee"))
                throw $util.ProtocolError("missing required 'fee'", { instance: message });
            if (!message.hasOwnProperty("counter"))
                throw $util.ProtocolError("missing required 'counter'", { instance: message });
            if (!message.hasOwnProperty("gas_limit"))
                throw $util.ProtocolError("missing required 'gas_limit'", { instance: message });
            if (!message.hasOwnProperty("storage_limit"))
                throw $util.ProtocolError("missing required 'storage_limit'", { instance: message });
            if (!message.hasOwnProperty("amount"))
                throw $util.ProtocolError("missing required 'amount'", { instance: message });
            if (!message.hasOwnProperty("destination"))
                throw $util.ProtocolError("missing required 'destination'", { instance: message });
            return message;
        };

        TezosTransactionOp.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        TezosTransactionOp.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!(message.source && typeof message.source.length === "number" || $util.isString(message.source)))
                return "source: buffer expected";
            if (!$util.isInteger(message.fee) && !(message.fee && $util.isInteger(message.fee.low) && $util.isInteger(message.fee.high)))
                return "fee: integer|Long expected";
            if (!$util.isInteger(message.counter) && !(message.counter && $util.isInteger(message.counter.low) && $util.isInteger(message.counter.high)))
                return "counter: integer|Long expected";
            if (!$util.isInteger(message.gas_limit) && !(message.gas_limit && $util.isInteger(message.gas_limit.low) && $util.isInteger(message.gas_limit.high)))
                return "gas_limit: integer|Long expected";
            if (!$util.isInteger(message.storage_limit) && !(message.storage_limit && $util.isInteger(message.storage_limit.low) && $util.isInteger(message.storage_limit.high)))
                return "storage_limit: integer|Long expected";
            if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
                return "amount: integer|Long expected";
            {
                var error = $root.TezosSignTx.TezosContractID.verify(message.destination);
                if (error)
                    return "destination." + error;
            }
            if (message.parameters != null && message.hasOwnProperty("parameters"))
                if (!(message.parameters && typeof message.parameters.length === "number" || $util.isString(message.parameters)))
                    return "parameters: buffer expected";
            if (message.parameters_manager != null && message.hasOwnProperty("parameters_manager")) {
                var error = $root.TezosSignTx.TezosTransactionOp.TezosParametersManager.verify(message.parameters_manager);
                if (error)
                    return "parameters_manager." + error;
            }
            return null;
        };

        TezosTransactionOp.fromObject = function fromObject(object) {
            if (object instanceof $root.TezosSignTx.TezosTransactionOp)
                return object;
            var message = new $root.TezosSignTx.TezosTransactionOp();
            if (object.source != null)
                if (typeof object.source === "string")
                    $util.base64.decode(object.source, message.source = $util.newBuffer($util.base64.length(object.source)), 0);
                else if (object.source.length)
                    message.source = object.source;
            if (object.fee != null)
                if ($util.Long)
                    (message.fee = $util.Long.fromValue(object.fee)).unsigned = true;
                else if (typeof object.fee === "string")
                    message.fee = parseInt(object.fee, 10);
                else if (typeof object.fee === "number")
                    message.fee = object.fee;
                else if (typeof object.fee === "object")
                    message.fee = new $util.LongBits(object.fee.low >>> 0, object.fee.high >>> 0).toNumber(true);
            if (object.counter != null)
                if ($util.Long)
                    (message.counter = $util.Long.fromValue(object.counter)).unsigned = true;
                else if (typeof object.counter === "string")
                    message.counter = parseInt(object.counter, 10);
                else if (typeof object.counter === "number")
                    message.counter = object.counter;
                else if (typeof object.counter === "object")
                    message.counter = new $util.LongBits(object.counter.low >>> 0, object.counter.high >>> 0).toNumber(true);
            if (object.gas_limit != null)
                if ($util.Long)
                    (message.gas_limit = $util.Long.fromValue(object.gas_limit)).unsigned = true;
                else if (typeof object.gas_limit === "string")
                    message.gas_limit = parseInt(object.gas_limit, 10);
                else if (typeof object.gas_limit === "number")
                    message.gas_limit = object.gas_limit;
                else if (typeof object.gas_limit === "object")
                    message.gas_limit = new $util.LongBits(object.gas_limit.low >>> 0, object.gas_limit.high >>> 0).toNumber(true);
            if (object.storage_limit != null)
                if ($util.Long)
                    (message.storage_limit = $util.Long.fromValue(object.storage_limit)).unsigned = true;
                else if (typeof object.storage_limit === "string")
                    message.storage_limit = parseInt(object.storage_limit, 10);
                else if (typeof object.storage_limit === "number")
                    message.storage_limit = object.storage_limit;
                else if (typeof object.storage_limit === "object")
                    message.storage_limit = new $util.LongBits(object.storage_limit.low >>> 0, object.storage_limit.high >>> 0).toNumber(true);
            if (object.amount != null)
                if ($util.Long)
                    (message.amount = $util.Long.fromValue(object.amount)).unsigned = true;
                else if (typeof object.amount === "string")
                    message.amount = parseInt(object.amount, 10);
                else if (typeof object.amount === "number")
                    message.amount = object.amount;
                else if (typeof object.amount === "object")
                    message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber(true);
            if (object.destination != null) {
                if (typeof object.destination !== "object")
                    throw TypeError(".TezosSignTx.TezosTransactionOp.destination: object expected");
                message.destination = $root.TezosSignTx.TezosContractID.fromObject(object.destination);
            }
            if (object.parameters != null)
                if (typeof object.parameters === "string")
                    $util.base64.decode(object.parameters, message.parameters = $util.newBuffer($util.base64.length(object.parameters)), 0);
                else if (object.parameters.length)
                    message.parameters = object.parameters;
            if (object.parameters_manager != null) {
                if (typeof object.parameters_manager !== "object")
                    throw TypeError(".TezosSignTx.TezosTransactionOp.parameters_manager: object expected");
                message.parameters_manager = $root.TezosSignTx.TezosTransactionOp.TezosParametersManager.fromObject(object.parameters_manager);
            }
            return message;
        };

        TezosTransactionOp.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.fee = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.fee = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.counter = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.counter = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.gas_limit = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.gas_limit = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.storage_limit = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.storage_limit = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.amount = options.longs === String ? "0" : 0;
                object.destination = null;
                if (options.bytes === String)
                    object.parameters = "";
                else {
                    object.parameters = [];
                    if (options.bytes !== Array)
                        object.parameters = $util.newBuffer(object.parameters);
                }
                if (options.bytes === String)
                    object.source = "";
                else {
                    object.source = [];
                    if (options.bytes !== Array)
                        object.source = $util.newBuffer(object.source);
                }
                object.parameters_manager = null;
            }
            if (message.fee != null && message.hasOwnProperty("fee"))
                if (typeof message.fee === "number")
                    object.fee = options.longs === String ? String(message.fee) : message.fee;
                else
                    object.fee = options.longs === String ? $util.Long.prototype.toString.call(message.fee) : options.longs === Number ? new $util.LongBits(message.fee.low >>> 0, message.fee.high >>> 0).toNumber(true) : message.fee;
            if (message.counter != null && message.hasOwnProperty("counter"))
                if (typeof message.counter === "number")
                    object.counter = options.longs === String ? String(message.counter) : message.counter;
                else
                    object.counter = options.longs === String ? $util.Long.prototype.toString.call(message.counter) : options.longs === Number ? new $util.LongBits(message.counter.low >>> 0, message.counter.high >>> 0).toNumber(true) : message.counter;
            if (message.gas_limit != null && message.hasOwnProperty("gas_limit"))
                if (typeof message.gas_limit === "number")
                    object.gas_limit = options.longs === String ? String(message.gas_limit) : message.gas_limit;
                else
                    object.gas_limit = options.longs === String ? $util.Long.prototype.toString.call(message.gas_limit) : options.longs === Number ? new $util.LongBits(message.gas_limit.low >>> 0, message.gas_limit.high >>> 0).toNumber(true) : message.gas_limit;
            if (message.storage_limit != null && message.hasOwnProperty("storage_limit"))
                if (typeof message.storage_limit === "number")
                    object.storage_limit = options.longs === String ? String(message.storage_limit) : message.storage_limit;
                else
                    object.storage_limit = options.longs === String ? $util.Long.prototype.toString.call(message.storage_limit) : options.longs === Number ? new $util.LongBits(message.storage_limit.low >>> 0, message.storage_limit.high >>> 0).toNumber(true) : message.storage_limit;
            if (message.amount != null && message.hasOwnProperty("amount"))
                if (typeof message.amount === "number")
                    object.amount = options.longs === String ? String(message.amount) : message.amount;
                else
                    object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber(true) : message.amount;
            if (message.destination != null && message.hasOwnProperty("destination"))
                object.destination = $root.TezosSignTx.TezosContractID.toObject(message.destination, options);
            if (message.parameters != null && message.hasOwnProperty("parameters"))
                object.parameters = options.bytes === String ? $util.base64.encode(message.parameters, 0, message.parameters.length) : options.bytes === Array ? Array.prototype.slice.call(message.parameters) : message.parameters;
            if (message.source != null && message.hasOwnProperty("source"))
                object.source = options.bytes === String ? $util.base64.encode(message.source, 0, message.source.length) : options.bytes === Array ? Array.prototype.slice.call(message.source) : message.source;
            if (message.parameters_manager != null && message.hasOwnProperty("parameters_manager"))
                object.parameters_manager = $root.TezosSignTx.TezosTransactionOp.TezosParametersManager.toObject(message.parameters_manager, options);
            return object;
        };

        TezosTransactionOp.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        TezosTransactionOp.TezosParametersManager = (function() {

            function TezosParametersManager(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            TezosParametersManager.prototype.set_delegate = $util.newBuffer([]);
            TezosParametersManager.prototype.cancel_delegate = false;
            TezosParametersManager.prototype.transfer = null;

            TezosParametersManager.create = function create(properties) {
                return new TezosParametersManager(properties);
            };

            TezosParametersManager.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.set_delegate != null && Object.hasOwnProperty.call(message, "set_delegate"))
                    writer.uint32(10).bytes(message.set_delegate);
                if (message.cancel_delegate != null && Object.hasOwnProperty.call(message, "cancel_delegate"))
                    writer.uint32(16).bool(message.cancel_delegate);
                if (message.transfer != null && Object.hasOwnProperty.call(message, "transfer"))
                    $root.TezosSignTx.TezosTransactionOp.TezosParametersManager.TezosManagerTransfer.encode(message.transfer, writer.uint32(26).fork()).ldelim();
                return writer;
            };

            TezosParametersManager.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            TezosParametersManager.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TezosSignTx.TezosTransactionOp.TezosParametersManager();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.set_delegate = reader.bytes();
                        break;
                    case 2:
                        message.cancel_delegate = reader.bool();
                        break;
                    case 3:
                        message.transfer = $root.TezosSignTx.TezosTransactionOp.TezosParametersManager.TezosManagerTransfer.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            TezosParametersManager.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            TezosParametersManager.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.set_delegate != null && message.hasOwnProperty("set_delegate"))
                    if (!(message.set_delegate && typeof message.set_delegate.length === "number" || $util.isString(message.set_delegate)))
                        return "set_delegate: buffer expected";
                if (message.cancel_delegate != null && message.hasOwnProperty("cancel_delegate"))
                    if (typeof message.cancel_delegate !== "boolean")
                        return "cancel_delegate: boolean expected";
                if (message.transfer != null && message.hasOwnProperty("transfer")) {
                    var error = $root.TezosSignTx.TezosTransactionOp.TezosParametersManager.TezosManagerTransfer.verify(message.transfer);
                    if (error)
                        return "transfer." + error;
                }
                return null;
            };

            TezosParametersManager.fromObject = function fromObject(object) {
                if (object instanceof $root.TezosSignTx.TezosTransactionOp.TezosParametersManager)
                    return object;
                var message = new $root.TezosSignTx.TezosTransactionOp.TezosParametersManager();
                if (object.set_delegate != null)
                    if (typeof object.set_delegate === "string")
                        $util.base64.decode(object.set_delegate, message.set_delegate = $util.newBuffer($util.base64.length(object.set_delegate)), 0);
                    else if (object.set_delegate.length)
                        message.set_delegate = object.set_delegate;
                if (object.cancel_delegate != null)
                    message.cancel_delegate = Boolean(object.cancel_delegate);
                if (object.transfer != null) {
                    if (typeof object.transfer !== "object")
                        throw TypeError(".TezosSignTx.TezosTransactionOp.TezosParametersManager.transfer: object expected");
                    message.transfer = $root.TezosSignTx.TezosTransactionOp.TezosParametersManager.TezosManagerTransfer.fromObject(object.transfer);
                }
                return message;
            };

            TezosParametersManager.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    if (options.bytes === String)
                        object.set_delegate = "";
                    else {
                        object.set_delegate = [];
                        if (options.bytes !== Array)
                            object.set_delegate = $util.newBuffer(object.set_delegate);
                    }
                    object.cancel_delegate = false;
                    object.transfer = null;
                }
                if (message.set_delegate != null && message.hasOwnProperty("set_delegate"))
                    object.set_delegate = options.bytes === String ? $util.base64.encode(message.set_delegate, 0, message.set_delegate.length) : options.bytes === Array ? Array.prototype.slice.call(message.set_delegate) : message.set_delegate;
                if (message.cancel_delegate != null && message.hasOwnProperty("cancel_delegate"))
                    object.cancel_delegate = message.cancel_delegate;
                if (message.transfer != null && message.hasOwnProperty("transfer"))
                    object.transfer = $root.TezosSignTx.TezosTransactionOp.TezosParametersManager.TezosManagerTransfer.toObject(message.transfer, options);
                return object;
            };

            TezosParametersManager.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            TezosParametersManager.TezosManagerTransfer = (function() {

                function TezosManagerTransfer(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                TezosManagerTransfer.prototype.destination = null;
                TezosManagerTransfer.prototype.amount = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

                TezosManagerTransfer.create = function create(properties) {
                    return new TezosManagerTransfer(properties);
                };

                TezosManagerTransfer.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.destination != null && Object.hasOwnProperty.call(message, "destination"))
                        $root.TezosSignTx.TezosContractID.encode(message.destination, writer.uint32(10).fork()).ldelim();
                    if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
                        writer.uint32(16).uint64(message.amount);
                    return writer;
                };

                TezosManagerTransfer.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                TezosManagerTransfer.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TezosSignTx.TezosTransactionOp.TezosParametersManager.TezosManagerTransfer();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.destination = $root.TezosSignTx.TezosContractID.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.amount = reader.uint64();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                TezosManagerTransfer.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                TezosManagerTransfer.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.destination != null && message.hasOwnProperty("destination")) {
                        var error = $root.TezosSignTx.TezosContractID.verify(message.destination);
                        if (error)
                            return "destination." + error;
                    }
                    if (message.amount != null && message.hasOwnProperty("amount"))
                        if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
                            return "amount: integer|Long expected";
                    return null;
                };

                TezosManagerTransfer.fromObject = function fromObject(object) {
                    if (object instanceof $root.TezosSignTx.TezosTransactionOp.TezosParametersManager.TezosManagerTransfer)
                        return object;
                    var message = new $root.TezosSignTx.TezosTransactionOp.TezosParametersManager.TezosManagerTransfer();
                    if (object.destination != null) {
                        if (typeof object.destination !== "object")
                            throw TypeError(".TezosSignTx.TezosTransactionOp.TezosParametersManager.TezosManagerTransfer.destination: object expected");
                        message.destination = $root.TezosSignTx.TezosContractID.fromObject(object.destination);
                    }
                    if (object.amount != null)
                        if ($util.Long)
                            (message.amount = $util.Long.fromValue(object.amount)).unsigned = true;
                        else if (typeof object.amount === "string")
                            message.amount = parseInt(object.amount, 10);
                        else if (typeof object.amount === "number")
                            message.amount = object.amount;
                        else if (typeof object.amount === "object")
                            message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber(true);
                    return message;
                };

                TezosManagerTransfer.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.destination = null;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, true);
                            object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.amount = options.longs === String ? "0" : 0;
                    }
                    if (message.destination != null && message.hasOwnProperty("destination"))
                        object.destination = $root.TezosSignTx.TezosContractID.toObject(message.destination, options);
                    if (message.amount != null && message.hasOwnProperty("amount"))
                        if (typeof message.amount === "number")
                            object.amount = options.longs === String ? String(message.amount) : message.amount;
                        else
                            object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber(true) : message.amount;
                    return object;
                };

                TezosManagerTransfer.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return TezosManagerTransfer;
            })();

            return TezosParametersManager;
        })();

        return TezosTransactionOp;
    })();

    TezosSignTx.TezosOriginationOp = (function() {

        function TezosOriginationOp(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        TezosOriginationOp.prototype.source = $util.newBuffer([]);
        TezosOriginationOp.prototype.fee = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        TezosOriginationOp.prototype.counter = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        TezosOriginationOp.prototype.gas_limit = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        TezosOriginationOp.prototype.storage_limit = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        TezosOriginationOp.prototype.manager_pubkey = $util.newBuffer([]);
        TezosOriginationOp.prototype.balance = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        TezosOriginationOp.prototype.spendable = false;
        TezosOriginationOp.prototype.delegatable = false;
        TezosOriginationOp.prototype.delegate = $util.newBuffer([]);
        TezosOriginationOp.prototype.script = $util.newBuffer([]);

        TezosOriginationOp.create = function create(properties) {
            return new TezosOriginationOp(properties);
        };

        TezosOriginationOp.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(16).uint64(message.fee);
            writer.uint32(24).uint64(message.counter);
            writer.uint32(32).uint64(message.gas_limit);
            writer.uint32(40).uint64(message.storage_limit);
            if (message.manager_pubkey != null && Object.hasOwnProperty.call(message, "manager_pubkey"))
                writer.uint32(50).bytes(message.manager_pubkey);
            writer.uint32(56).uint64(message.balance);
            if (message.spendable != null && Object.hasOwnProperty.call(message, "spendable"))
                writer.uint32(64).bool(message.spendable);
            if (message.delegatable != null && Object.hasOwnProperty.call(message, "delegatable"))
                writer.uint32(72).bool(message.delegatable);
            if (message.delegate != null && Object.hasOwnProperty.call(message, "delegate"))
                writer.uint32(82).bytes(message.delegate);
            writer.uint32(90).bytes(message.script);
            writer.uint32(98).bytes(message.source);
            return writer;
        };

        TezosOriginationOp.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        TezosOriginationOp.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TezosSignTx.TezosOriginationOp();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 12:
                    message.source = reader.bytes();
                    break;
                case 2:
                    message.fee = reader.uint64();
                    break;
                case 3:
                    message.counter = reader.uint64();
                    break;
                case 4:
                    message.gas_limit = reader.uint64();
                    break;
                case 5:
                    message.storage_limit = reader.uint64();
                    break;
                case 6:
                    message.manager_pubkey = reader.bytes();
                    break;
                case 7:
                    message.balance = reader.uint64();
                    break;
                case 8:
                    message.spendable = reader.bool();
                    break;
                case 9:
                    message.delegatable = reader.bool();
                    break;
                case 10:
                    message.delegate = reader.bytes();
                    break;
                case 11:
                    message.script = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("source"))
                throw $util.ProtocolError("missing required 'source'", { instance: message });
            if (!message.hasOwnProperty("fee"))
                throw $util.ProtocolError("missing required 'fee'", { instance: message });
            if (!message.hasOwnProperty("counter"))
                throw $util.ProtocolError("missing required 'counter'", { instance: message });
            if (!message.hasOwnProperty("gas_limit"))
                throw $util.ProtocolError("missing required 'gas_limit'", { instance: message });
            if (!message.hasOwnProperty("storage_limit"))
                throw $util.ProtocolError("missing required 'storage_limit'", { instance: message });
            if (!message.hasOwnProperty("balance"))
                throw $util.ProtocolError("missing required 'balance'", { instance: message });
            if (!message.hasOwnProperty("script"))
                throw $util.ProtocolError("missing required 'script'", { instance: message });
            return message;
        };

        TezosOriginationOp.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        TezosOriginationOp.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!(message.source && typeof message.source.length === "number" || $util.isString(message.source)))
                return "source: buffer expected";
            if (!$util.isInteger(message.fee) && !(message.fee && $util.isInteger(message.fee.low) && $util.isInteger(message.fee.high)))
                return "fee: integer|Long expected";
            if (!$util.isInteger(message.counter) && !(message.counter && $util.isInteger(message.counter.low) && $util.isInteger(message.counter.high)))
                return "counter: integer|Long expected";
            if (!$util.isInteger(message.gas_limit) && !(message.gas_limit && $util.isInteger(message.gas_limit.low) && $util.isInteger(message.gas_limit.high)))
                return "gas_limit: integer|Long expected";
            if (!$util.isInteger(message.storage_limit) && !(message.storage_limit && $util.isInteger(message.storage_limit.low) && $util.isInteger(message.storage_limit.high)))
                return "storage_limit: integer|Long expected";
            if (message.manager_pubkey != null && message.hasOwnProperty("manager_pubkey"))
                if (!(message.manager_pubkey && typeof message.manager_pubkey.length === "number" || $util.isString(message.manager_pubkey)))
                    return "manager_pubkey: buffer expected";
            if (!$util.isInteger(message.balance) && !(message.balance && $util.isInteger(message.balance.low) && $util.isInteger(message.balance.high)))
                return "balance: integer|Long expected";
            if (message.spendable != null && message.hasOwnProperty("spendable"))
                if (typeof message.spendable !== "boolean")
                    return "spendable: boolean expected";
            if (message.delegatable != null && message.hasOwnProperty("delegatable"))
                if (typeof message.delegatable !== "boolean")
                    return "delegatable: boolean expected";
            if (message.delegate != null && message.hasOwnProperty("delegate"))
                if (!(message.delegate && typeof message.delegate.length === "number" || $util.isString(message.delegate)))
                    return "delegate: buffer expected";
            if (!(message.script && typeof message.script.length === "number" || $util.isString(message.script)))
                return "script: buffer expected";
            return null;
        };

        TezosOriginationOp.fromObject = function fromObject(object) {
            if (object instanceof $root.TezosSignTx.TezosOriginationOp)
                return object;
            var message = new $root.TezosSignTx.TezosOriginationOp();
            if (object.source != null)
                if (typeof object.source === "string")
                    $util.base64.decode(object.source, message.source = $util.newBuffer($util.base64.length(object.source)), 0);
                else if (object.source.length)
                    message.source = object.source;
            if (object.fee != null)
                if ($util.Long)
                    (message.fee = $util.Long.fromValue(object.fee)).unsigned = true;
                else if (typeof object.fee === "string")
                    message.fee = parseInt(object.fee, 10);
                else if (typeof object.fee === "number")
                    message.fee = object.fee;
                else if (typeof object.fee === "object")
                    message.fee = new $util.LongBits(object.fee.low >>> 0, object.fee.high >>> 0).toNumber(true);
            if (object.counter != null)
                if ($util.Long)
                    (message.counter = $util.Long.fromValue(object.counter)).unsigned = true;
                else if (typeof object.counter === "string")
                    message.counter = parseInt(object.counter, 10);
                else if (typeof object.counter === "number")
                    message.counter = object.counter;
                else if (typeof object.counter === "object")
                    message.counter = new $util.LongBits(object.counter.low >>> 0, object.counter.high >>> 0).toNumber(true);
            if (object.gas_limit != null)
                if ($util.Long)
                    (message.gas_limit = $util.Long.fromValue(object.gas_limit)).unsigned = true;
                else if (typeof object.gas_limit === "string")
                    message.gas_limit = parseInt(object.gas_limit, 10);
                else if (typeof object.gas_limit === "number")
                    message.gas_limit = object.gas_limit;
                else if (typeof object.gas_limit === "object")
                    message.gas_limit = new $util.LongBits(object.gas_limit.low >>> 0, object.gas_limit.high >>> 0).toNumber(true);
            if (object.storage_limit != null)
                if ($util.Long)
                    (message.storage_limit = $util.Long.fromValue(object.storage_limit)).unsigned = true;
                else if (typeof object.storage_limit === "string")
                    message.storage_limit = parseInt(object.storage_limit, 10);
                else if (typeof object.storage_limit === "number")
                    message.storage_limit = object.storage_limit;
                else if (typeof object.storage_limit === "object")
                    message.storage_limit = new $util.LongBits(object.storage_limit.low >>> 0, object.storage_limit.high >>> 0).toNumber(true);
            if (object.manager_pubkey != null)
                if (typeof object.manager_pubkey === "string")
                    $util.base64.decode(object.manager_pubkey, message.manager_pubkey = $util.newBuffer($util.base64.length(object.manager_pubkey)), 0);
                else if (object.manager_pubkey.length)
                    message.manager_pubkey = object.manager_pubkey;
            if (object.balance != null)
                if ($util.Long)
                    (message.balance = $util.Long.fromValue(object.balance)).unsigned = true;
                else if (typeof object.balance === "string")
                    message.balance = parseInt(object.balance, 10);
                else if (typeof object.balance === "number")
                    message.balance = object.balance;
                else if (typeof object.balance === "object")
                    message.balance = new $util.LongBits(object.balance.low >>> 0, object.balance.high >>> 0).toNumber(true);
            if (object.spendable != null)
                message.spendable = Boolean(object.spendable);
            if (object.delegatable != null)
                message.delegatable = Boolean(object.delegatable);
            if (object.delegate != null)
                if (typeof object.delegate === "string")
                    $util.base64.decode(object.delegate, message.delegate = $util.newBuffer($util.base64.length(object.delegate)), 0);
                else if (object.delegate.length)
                    message.delegate = object.delegate;
            if (object.script != null)
                if (typeof object.script === "string")
                    $util.base64.decode(object.script, message.script = $util.newBuffer($util.base64.length(object.script)), 0);
                else if (object.script.length)
                    message.script = object.script;
            return message;
        };

        TezosOriginationOp.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.fee = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.fee = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.counter = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.counter = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.gas_limit = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.gas_limit = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.storage_limit = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.storage_limit = options.longs === String ? "0" : 0;
                if (options.bytes === String)
                    object.manager_pubkey = "";
                else {
                    object.manager_pubkey = [];
                    if (options.bytes !== Array)
                        object.manager_pubkey = $util.newBuffer(object.manager_pubkey);
                }
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.balance = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.balance = options.longs === String ? "0" : 0;
                object.spendable = false;
                object.delegatable = false;
                if (options.bytes === String)
                    object.delegate = "";
                else {
                    object.delegate = [];
                    if (options.bytes !== Array)
                        object.delegate = $util.newBuffer(object.delegate);
                }
                if (options.bytes === String)
                    object.script = "";
                else {
                    object.script = [];
                    if (options.bytes !== Array)
                        object.script = $util.newBuffer(object.script);
                }
                if (options.bytes === String)
                    object.source = "";
                else {
                    object.source = [];
                    if (options.bytes !== Array)
                        object.source = $util.newBuffer(object.source);
                }
            }
            if (message.fee != null && message.hasOwnProperty("fee"))
                if (typeof message.fee === "number")
                    object.fee = options.longs === String ? String(message.fee) : message.fee;
                else
                    object.fee = options.longs === String ? $util.Long.prototype.toString.call(message.fee) : options.longs === Number ? new $util.LongBits(message.fee.low >>> 0, message.fee.high >>> 0).toNumber(true) : message.fee;
            if (message.counter != null && message.hasOwnProperty("counter"))
                if (typeof message.counter === "number")
                    object.counter = options.longs === String ? String(message.counter) : message.counter;
                else
                    object.counter = options.longs === String ? $util.Long.prototype.toString.call(message.counter) : options.longs === Number ? new $util.LongBits(message.counter.low >>> 0, message.counter.high >>> 0).toNumber(true) : message.counter;
            if (message.gas_limit != null && message.hasOwnProperty("gas_limit"))
                if (typeof message.gas_limit === "number")
                    object.gas_limit = options.longs === String ? String(message.gas_limit) : message.gas_limit;
                else
                    object.gas_limit = options.longs === String ? $util.Long.prototype.toString.call(message.gas_limit) : options.longs === Number ? new $util.LongBits(message.gas_limit.low >>> 0, message.gas_limit.high >>> 0).toNumber(true) : message.gas_limit;
            if (message.storage_limit != null && message.hasOwnProperty("storage_limit"))
                if (typeof message.storage_limit === "number")
                    object.storage_limit = options.longs === String ? String(message.storage_limit) : message.storage_limit;
                else
                    object.storage_limit = options.longs === String ? $util.Long.prototype.toString.call(message.storage_limit) : options.longs === Number ? new $util.LongBits(message.storage_limit.low >>> 0, message.storage_limit.high >>> 0).toNumber(true) : message.storage_limit;
            if (message.manager_pubkey != null && message.hasOwnProperty("manager_pubkey"))
                object.manager_pubkey = options.bytes === String ? $util.base64.encode(message.manager_pubkey, 0, message.manager_pubkey.length) : options.bytes === Array ? Array.prototype.slice.call(message.manager_pubkey) : message.manager_pubkey;
            if (message.balance != null && message.hasOwnProperty("balance"))
                if (typeof message.balance === "number")
                    object.balance = options.longs === String ? String(message.balance) : message.balance;
                else
                    object.balance = options.longs === String ? $util.Long.prototype.toString.call(message.balance) : options.longs === Number ? new $util.LongBits(message.balance.low >>> 0, message.balance.high >>> 0).toNumber(true) : message.balance;
            if (message.spendable != null && message.hasOwnProperty("spendable"))
                object.spendable = message.spendable;
            if (message.delegatable != null && message.hasOwnProperty("delegatable"))
                object.delegatable = message.delegatable;
            if (message.delegate != null && message.hasOwnProperty("delegate"))
                object.delegate = options.bytes === String ? $util.base64.encode(message.delegate, 0, message.delegate.length) : options.bytes === Array ? Array.prototype.slice.call(message.delegate) : message.delegate;
            if (message.script != null && message.hasOwnProperty("script"))
                object.script = options.bytes === String ? $util.base64.encode(message.script, 0, message.script.length) : options.bytes === Array ? Array.prototype.slice.call(message.script) : message.script;
            if (message.source != null && message.hasOwnProperty("source"))
                object.source = options.bytes === String ? $util.base64.encode(message.source, 0, message.source.length) : options.bytes === Array ? Array.prototype.slice.call(message.source) : message.source;
            return object;
        };

        TezosOriginationOp.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TezosOriginationOp;
    })();

    TezosSignTx.TezosDelegationOp = (function() {

        function TezosDelegationOp(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        TezosDelegationOp.prototype.source = $util.newBuffer([]);
        TezosDelegationOp.prototype.fee = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        TezosDelegationOp.prototype.counter = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        TezosDelegationOp.prototype.gas_limit = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        TezosDelegationOp.prototype.storage_limit = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        TezosDelegationOp.prototype.delegate = $util.newBuffer([]);

        TezosDelegationOp.create = function create(properties) {
            return new TezosDelegationOp(properties);
        };

        TezosDelegationOp.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(16).uint64(message.fee);
            writer.uint32(24).uint64(message.counter);
            writer.uint32(32).uint64(message.gas_limit);
            writer.uint32(40).uint64(message.storage_limit);
            writer.uint32(50).bytes(message.delegate);
            writer.uint32(58).bytes(message.source);
            return writer;
        };

        TezosDelegationOp.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        TezosDelegationOp.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TezosSignTx.TezosDelegationOp();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 7:
                    message.source = reader.bytes();
                    break;
                case 2:
                    message.fee = reader.uint64();
                    break;
                case 3:
                    message.counter = reader.uint64();
                    break;
                case 4:
                    message.gas_limit = reader.uint64();
                    break;
                case 5:
                    message.storage_limit = reader.uint64();
                    break;
                case 6:
                    message.delegate = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("source"))
                throw $util.ProtocolError("missing required 'source'", { instance: message });
            if (!message.hasOwnProperty("fee"))
                throw $util.ProtocolError("missing required 'fee'", { instance: message });
            if (!message.hasOwnProperty("counter"))
                throw $util.ProtocolError("missing required 'counter'", { instance: message });
            if (!message.hasOwnProperty("gas_limit"))
                throw $util.ProtocolError("missing required 'gas_limit'", { instance: message });
            if (!message.hasOwnProperty("storage_limit"))
                throw $util.ProtocolError("missing required 'storage_limit'", { instance: message });
            if (!message.hasOwnProperty("delegate"))
                throw $util.ProtocolError("missing required 'delegate'", { instance: message });
            return message;
        };

        TezosDelegationOp.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        TezosDelegationOp.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!(message.source && typeof message.source.length === "number" || $util.isString(message.source)))
                return "source: buffer expected";
            if (!$util.isInteger(message.fee) && !(message.fee && $util.isInteger(message.fee.low) && $util.isInteger(message.fee.high)))
                return "fee: integer|Long expected";
            if (!$util.isInteger(message.counter) && !(message.counter && $util.isInteger(message.counter.low) && $util.isInteger(message.counter.high)))
                return "counter: integer|Long expected";
            if (!$util.isInteger(message.gas_limit) && !(message.gas_limit && $util.isInteger(message.gas_limit.low) && $util.isInteger(message.gas_limit.high)))
                return "gas_limit: integer|Long expected";
            if (!$util.isInteger(message.storage_limit) && !(message.storage_limit && $util.isInteger(message.storage_limit.low) && $util.isInteger(message.storage_limit.high)))
                return "storage_limit: integer|Long expected";
            if (!(message.delegate && typeof message.delegate.length === "number" || $util.isString(message.delegate)))
                return "delegate: buffer expected";
            return null;
        };

        TezosDelegationOp.fromObject = function fromObject(object) {
            if (object instanceof $root.TezosSignTx.TezosDelegationOp)
                return object;
            var message = new $root.TezosSignTx.TezosDelegationOp();
            if (object.source != null)
                if (typeof object.source === "string")
                    $util.base64.decode(object.source, message.source = $util.newBuffer($util.base64.length(object.source)), 0);
                else if (object.source.length)
                    message.source = object.source;
            if (object.fee != null)
                if ($util.Long)
                    (message.fee = $util.Long.fromValue(object.fee)).unsigned = true;
                else if (typeof object.fee === "string")
                    message.fee = parseInt(object.fee, 10);
                else if (typeof object.fee === "number")
                    message.fee = object.fee;
                else if (typeof object.fee === "object")
                    message.fee = new $util.LongBits(object.fee.low >>> 0, object.fee.high >>> 0).toNumber(true);
            if (object.counter != null)
                if ($util.Long)
                    (message.counter = $util.Long.fromValue(object.counter)).unsigned = true;
                else if (typeof object.counter === "string")
                    message.counter = parseInt(object.counter, 10);
                else if (typeof object.counter === "number")
                    message.counter = object.counter;
                else if (typeof object.counter === "object")
                    message.counter = new $util.LongBits(object.counter.low >>> 0, object.counter.high >>> 0).toNumber(true);
            if (object.gas_limit != null)
                if ($util.Long)
                    (message.gas_limit = $util.Long.fromValue(object.gas_limit)).unsigned = true;
                else if (typeof object.gas_limit === "string")
                    message.gas_limit = parseInt(object.gas_limit, 10);
                else if (typeof object.gas_limit === "number")
                    message.gas_limit = object.gas_limit;
                else if (typeof object.gas_limit === "object")
                    message.gas_limit = new $util.LongBits(object.gas_limit.low >>> 0, object.gas_limit.high >>> 0).toNumber(true);
            if (object.storage_limit != null)
                if ($util.Long)
                    (message.storage_limit = $util.Long.fromValue(object.storage_limit)).unsigned = true;
                else if (typeof object.storage_limit === "string")
                    message.storage_limit = parseInt(object.storage_limit, 10);
                else if (typeof object.storage_limit === "number")
                    message.storage_limit = object.storage_limit;
                else if (typeof object.storage_limit === "object")
                    message.storage_limit = new $util.LongBits(object.storage_limit.low >>> 0, object.storage_limit.high >>> 0).toNumber(true);
            if (object.delegate != null)
                if (typeof object.delegate === "string")
                    $util.base64.decode(object.delegate, message.delegate = $util.newBuffer($util.base64.length(object.delegate)), 0);
                else if (object.delegate.length)
                    message.delegate = object.delegate;
            return message;
        };

        TezosDelegationOp.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.fee = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.fee = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.counter = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.counter = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.gas_limit = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.gas_limit = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.storage_limit = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.storage_limit = options.longs === String ? "0" : 0;
                if (options.bytes === String)
                    object.delegate = "";
                else {
                    object.delegate = [];
                    if (options.bytes !== Array)
                        object.delegate = $util.newBuffer(object.delegate);
                }
                if (options.bytes === String)
                    object.source = "";
                else {
                    object.source = [];
                    if (options.bytes !== Array)
                        object.source = $util.newBuffer(object.source);
                }
            }
            if (message.fee != null && message.hasOwnProperty("fee"))
                if (typeof message.fee === "number")
                    object.fee = options.longs === String ? String(message.fee) : message.fee;
                else
                    object.fee = options.longs === String ? $util.Long.prototype.toString.call(message.fee) : options.longs === Number ? new $util.LongBits(message.fee.low >>> 0, message.fee.high >>> 0).toNumber(true) : message.fee;
            if (message.counter != null && message.hasOwnProperty("counter"))
                if (typeof message.counter === "number")
                    object.counter = options.longs === String ? String(message.counter) : message.counter;
                else
                    object.counter = options.longs === String ? $util.Long.prototype.toString.call(message.counter) : options.longs === Number ? new $util.LongBits(message.counter.low >>> 0, message.counter.high >>> 0).toNumber(true) : message.counter;
            if (message.gas_limit != null && message.hasOwnProperty("gas_limit"))
                if (typeof message.gas_limit === "number")
                    object.gas_limit = options.longs === String ? String(message.gas_limit) : message.gas_limit;
                else
                    object.gas_limit = options.longs === String ? $util.Long.prototype.toString.call(message.gas_limit) : options.longs === Number ? new $util.LongBits(message.gas_limit.low >>> 0, message.gas_limit.high >>> 0).toNumber(true) : message.gas_limit;
            if (message.storage_limit != null && message.hasOwnProperty("storage_limit"))
                if (typeof message.storage_limit === "number")
                    object.storage_limit = options.longs === String ? String(message.storage_limit) : message.storage_limit;
                else
                    object.storage_limit = options.longs === String ? $util.Long.prototype.toString.call(message.storage_limit) : options.longs === Number ? new $util.LongBits(message.storage_limit.low >>> 0, message.storage_limit.high >>> 0).toNumber(true) : message.storage_limit;
            if (message.delegate != null && message.hasOwnProperty("delegate"))
                object.delegate = options.bytes === String ? $util.base64.encode(message.delegate, 0, message.delegate.length) : options.bytes === Array ? Array.prototype.slice.call(message.delegate) : message.delegate;
            if (message.source != null && message.hasOwnProperty("source"))
                object.source = options.bytes === String ? $util.base64.encode(message.source, 0, message.source.length) : options.bytes === Array ? Array.prototype.slice.call(message.source) : message.source;
            return object;
        };

        TezosDelegationOp.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TezosDelegationOp;
    })();

    TezosSignTx.TezosProposalOp = (function() {

        function TezosProposalOp(properties) {
            this.proposals = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        TezosProposalOp.prototype.source = $util.newBuffer([]);
        TezosProposalOp.prototype.period = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        TezosProposalOp.prototype.proposals = $util.emptyArray;

        TezosProposalOp.create = function create(properties) {
            return new TezosProposalOp(properties);
        };

        TezosProposalOp.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.source != null && Object.hasOwnProperty.call(message, "source"))
                writer.uint32(10).bytes(message.source);
            if (message.period != null && Object.hasOwnProperty.call(message, "period"))
                writer.uint32(16).uint64(message.period);
            if (message.proposals != null && message.proposals.length)
                for (var i = 0; i < message.proposals.length; ++i)
                    writer.uint32(34).bytes(message.proposals[i]);
            return writer;
        };

        TezosProposalOp.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        TezosProposalOp.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TezosSignTx.TezosProposalOp();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.source = reader.bytes();
                    break;
                case 2:
                    message.period = reader.uint64();
                    break;
                case 4:
                    if (!(message.proposals && message.proposals.length))
                        message.proposals = [];
                    message.proposals.push(reader.bytes());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        TezosProposalOp.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        TezosProposalOp.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.source != null && message.hasOwnProperty("source"))
                if (!(message.source && typeof message.source.length === "number" || $util.isString(message.source)))
                    return "source: buffer expected";
            if (message.period != null && message.hasOwnProperty("period"))
                if (!$util.isInteger(message.period) && !(message.period && $util.isInteger(message.period.low) && $util.isInteger(message.period.high)))
                    return "period: integer|Long expected";
            if (message.proposals != null && message.hasOwnProperty("proposals")) {
                if (!Array.isArray(message.proposals))
                    return "proposals: array expected";
                for (var i = 0; i < message.proposals.length; ++i)
                    if (!(message.proposals[i] && typeof message.proposals[i].length === "number" || $util.isString(message.proposals[i])))
                        return "proposals: buffer[] expected";
            }
            return null;
        };

        TezosProposalOp.fromObject = function fromObject(object) {
            if (object instanceof $root.TezosSignTx.TezosProposalOp)
                return object;
            var message = new $root.TezosSignTx.TezosProposalOp();
            if (object.source != null)
                if (typeof object.source === "string")
                    $util.base64.decode(object.source, message.source = $util.newBuffer($util.base64.length(object.source)), 0);
                else if (object.source.length)
                    message.source = object.source;
            if (object.period != null)
                if ($util.Long)
                    (message.period = $util.Long.fromValue(object.period)).unsigned = true;
                else if (typeof object.period === "string")
                    message.period = parseInt(object.period, 10);
                else if (typeof object.period === "number")
                    message.period = object.period;
                else if (typeof object.period === "object")
                    message.period = new $util.LongBits(object.period.low >>> 0, object.period.high >>> 0).toNumber(true);
            if (object.proposals) {
                if (!Array.isArray(object.proposals))
                    throw TypeError(".TezosSignTx.TezosProposalOp.proposals: array expected");
                message.proposals = [];
                for (var i = 0; i < object.proposals.length; ++i)
                    if (typeof object.proposals[i] === "string")
                        $util.base64.decode(object.proposals[i], message.proposals[i] = $util.newBuffer($util.base64.length(object.proposals[i])), 0);
                    else if (object.proposals[i].length)
                        message.proposals[i] = object.proposals[i];
            }
            return message;
        };

        TezosProposalOp.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.proposals = [];
            if (options.defaults) {
                if (options.bytes === String)
                    object.source = "";
                else {
                    object.source = [];
                    if (options.bytes !== Array)
                        object.source = $util.newBuffer(object.source);
                }
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.period = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.period = options.longs === String ? "0" : 0;
            }
            if (message.source != null && message.hasOwnProperty("source"))
                object.source = options.bytes === String ? $util.base64.encode(message.source, 0, message.source.length) : options.bytes === Array ? Array.prototype.slice.call(message.source) : message.source;
            if (message.period != null && message.hasOwnProperty("period"))
                if (typeof message.period === "number")
                    object.period = options.longs === String ? String(message.period) : message.period;
                else
                    object.period = options.longs === String ? $util.Long.prototype.toString.call(message.period) : options.longs === Number ? new $util.LongBits(message.period.low >>> 0, message.period.high >>> 0).toNumber(true) : message.period;
            if (message.proposals && message.proposals.length) {
                object.proposals = [];
                for (var j = 0; j < message.proposals.length; ++j)
                    object.proposals[j] = options.bytes === String ? $util.base64.encode(message.proposals[j], 0, message.proposals[j].length) : options.bytes === Array ? Array.prototype.slice.call(message.proposals[j]) : message.proposals[j];
            }
            return object;
        };

        TezosProposalOp.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TezosProposalOp;
    })();

    TezosSignTx.TezosBallotOp = (function() {

        function TezosBallotOp(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        TezosBallotOp.prototype.source = $util.newBuffer([]);
        TezosBallotOp.prototype.period = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        TezosBallotOp.prototype.proposal = $util.newBuffer([]);
        TezosBallotOp.prototype.ballot = 0;

        TezosBallotOp.create = function create(properties) {
            return new TezosBallotOp(properties);
        };

        TezosBallotOp.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.source != null && Object.hasOwnProperty.call(message, "source"))
                writer.uint32(10).bytes(message.source);
            if (message.period != null && Object.hasOwnProperty.call(message, "period"))
                writer.uint32(16).uint64(message.period);
            if (message.proposal != null && Object.hasOwnProperty.call(message, "proposal"))
                writer.uint32(26).bytes(message.proposal);
            if (message.ballot != null && Object.hasOwnProperty.call(message, "ballot"))
                writer.uint32(32).int32(message.ballot);
            return writer;
        };

        TezosBallotOp.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        TezosBallotOp.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TezosSignTx.TezosBallotOp();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.source = reader.bytes();
                    break;
                case 2:
                    message.period = reader.uint64();
                    break;
                case 3:
                    message.proposal = reader.bytes();
                    break;
                case 4:
                    message.ballot = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        TezosBallotOp.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        TezosBallotOp.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.source != null && message.hasOwnProperty("source"))
                if (!(message.source && typeof message.source.length === "number" || $util.isString(message.source)))
                    return "source: buffer expected";
            if (message.period != null && message.hasOwnProperty("period"))
                if (!$util.isInteger(message.period) && !(message.period && $util.isInteger(message.period.low) && $util.isInteger(message.period.high)))
                    return "period: integer|Long expected";
            if (message.proposal != null && message.hasOwnProperty("proposal"))
                if (!(message.proposal && typeof message.proposal.length === "number" || $util.isString(message.proposal)))
                    return "proposal: buffer expected";
            if (message.ballot != null && message.hasOwnProperty("ballot"))
                switch (message.ballot) {
                default:
                    return "ballot: enum value expected";
                case 0:
                case 1:
                case 2:
                    break;
                }
            return null;
        };

        TezosBallotOp.fromObject = function fromObject(object) {
            if (object instanceof $root.TezosSignTx.TezosBallotOp)
                return object;
            var message = new $root.TezosSignTx.TezosBallotOp();
            if (object.source != null)
                if (typeof object.source === "string")
                    $util.base64.decode(object.source, message.source = $util.newBuffer($util.base64.length(object.source)), 0);
                else if (object.source.length)
                    message.source = object.source;
            if (object.period != null)
                if ($util.Long)
                    (message.period = $util.Long.fromValue(object.period)).unsigned = true;
                else if (typeof object.period === "string")
                    message.period = parseInt(object.period, 10);
                else if (typeof object.period === "number")
                    message.period = object.period;
                else if (typeof object.period === "object")
                    message.period = new $util.LongBits(object.period.low >>> 0, object.period.high >>> 0).toNumber(true);
            if (object.proposal != null)
                if (typeof object.proposal === "string")
                    $util.base64.decode(object.proposal, message.proposal = $util.newBuffer($util.base64.length(object.proposal)), 0);
                else if (object.proposal.length)
                    message.proposal = object.proposal;
            switch (object.ballot) {
            case "Yay":
            case 0:
                message.ballot = 0;
                break;
            case "Nay":
            case 1:
                message.ballot = 1;
                break;
            case "Pass":
            case 2:
                message.ballot = 2;
                break;
            }
            return message;
        };

        TezosBallotOp.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if (options.bytes === String)
                    object.source = "";
                else {
                    object.source = [];
                    if (options.bytes !== Array)
                        object.source = $util.newBuffer(object.source);
                }
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.period = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.period = options.longs === String ? "0" : 0;
                if (options.bytes === String)
                    object.proposal = "";
                else {
                    object.proposal = [];
                    if (options.bytes !== Array)
                        object.proposal = $util.newBuffer(object.proposal);
                }
                object.ballot = options.enums === String ? "Yay" : 0;
            }
            if (message.source != null && message.hasOwnProperty("source"))
                object.source = options.bytes === String ? $util.base64.encode(message.source, 0, message.source.length) : options.bytes === Array ? Array.prototype.slice.call(message.source) : message.source;
            if (message.period != null && message.hasOwnProperty("period"))
                if (typeof message.period === "number")
                    object.period = options.longs === String ? String(message.period) : message.period;
                else
                    object.period = options.longs === String ? $util.Long.prototype.toString.call(message.period) : options.longs === Number ? new $util.LongBits(message.period.low >>> 0, message.period.high >>> 0).toNumber(true) : message.period;
            if (message.proposal != null && message.hasOwnProperty("proposal"))
                object.proposal = options.bytes === String ? $util.base64.encode(message.proposal, 0, message.proposal.length) : options.bytes === Array ? Array.prototype.slice.call(message.proposal) : message.proposal;
            if (message.ballot != null && message.hasOwnProperty("ballot"))
                object.ballot = options.enums === String ? $root.TezosSignTx.TezosBallotOp.TezosBallotType[message.ballot] : message.ballot;
            return object;
        };

        TezosBallotOp.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        TezosBallotOp.TezosBallotType = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "Yay"] = 0;
            values[valuesById[1] = "Nay"] = 1;
            values[valuesById[2] = "Pass"] = 2;
            return values;
        })();

        return TezosBallotOp;
    })();

    return TezosSignTx;
})();

$root.TezosSignedTx = (function() {

    function TezosSignedTx(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    TezosSignedTx.prototype.signature = "";
    TezosSignedTx.prototype.sig_op_contents = $util.newBuffer([]);
    TezosSignedTx.prototype.operation_hash = "";

    TezosSignedTx.create = function create(properties) {
        return new TezosSignedTx(properties);
    };

    TezosSignedTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.signature);
        writer.uint32(18).bytes(message.sig_op_contents);
        writer.uint32(26).string(message.operation_hash);
        return writer;
    };

    TezosSignedTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    TezosSignedTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TezosSignedTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.signature = reader.string();
                break;
            case 2:
                message.sig_op_contents = reader.bytes();
                break;
            case 3:
                message.operation_hash = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        if (!message.hasOwnProperty("sig_op_contents"))
            throw $util.ProtocolError("missing required 'sig_op_contents'", { instance: message });
        if (!message.hasOwnProperty("operation_hash"))
            throw $util.ProtocolError("missing required 'operation_hash'", { instance: message });
        return message;
    };

    TezosSignedTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    TezosSignedTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.signature))
            return "signature: string expected";
        if (!(message.sig_op_contents && typeof message.sig_op_contents.length === "number" || $util.isString(message.sig_op_contents)))
            return "sig_op_contents: buffer expected";
        if (!$util.isString(message.operation_hash))
            return "operation_hash: string expected";
        return null;
    };

    TezosSignedTx.fromObject = function fromObject(object) {
        if (object instanceof $root.TezosSignedTx)
            return object;
        var message = new $root.TezosSignedTx();
        if (object.signature != null)
            message.signature = String(object.signature);
        if (object.sig_op_contents != null)
            if (typeof object.sig_op_contents === "string")
                $util.base64.decode(object.sig_op_contents, message.sig_op_contents = $util.newBuffer($util.base64.length(object.sig_op_contents)), 0);
            else if (object.sig_op_contents.length)
                message.sig_op_contents = object.sig_op_contents;
        if (object.operation_hash != null)
            message.operation_hash = String(object.operation_hash);
        return message;
    };

    TezosSignedTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.signature = "";
            if (options.bytes === String)
                object.sig_op_contents = "";
            else {
                object.sig_op_contents = [];
                if (options.bytes !== Array)
                    object.sig_op_contents = $util.newBuffer(object.sig_op_contents);
            }
            object.operation_hash = "";
        }
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = message.signature;
        if (message.sig_op_contents != null && message.hasOwnProperty("sig_op_contents"))
            object.sig_op_contents = options.bytes === String ? $util.base64.encode(message.sig_op_contents, 0, message.sig_op_contents.length) : options.bytes === Array ? Array.prototype.slice.call(message.sig_op_contents) : message.sig_op_contents;
        if (message.operation_hash != null && message.hasOwnProperty("operation_hash"))
            object.operation_hash = message.operation_hash;
        return object;
    };

    TezosSignedTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return TezosSignedTx;
})();

$root.TonWalletVersion = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[3] = "V4R2"] = 3;
    return values;
})();

$root.TonWorkChain = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "BASECHAIN"] = 0;
    values[valuesById[1] = "MASTERCHAIN"] = 1;
    return values;
})();

$root.TonGetAddress = (function() {

    function TonGetAddress(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    TonGetAddress.prototype.address_n = $util.emptyArray;
    TonGetAddress.prototype.show_display = false;
    TonGetAddress.prototype.wallet_version = 3;
    TonGetAddress.prototype.is_bounceable = false;
    TonGetAddress.prototype.is_testnet_only = false;
    TonGetAddress.prototype.workchain = 0;
    TonGetAddress.prototype.wallet_id = 698983191;

    TonGetAddress.create = function create(properties) {
        return new TonGetAddress(properties);
    };

    TonGetAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(16).bool(message.show_display);
        if (message.wallet_version != null && Object.hasOwnProperty.call(message, "wallet_version"))
            writer.uint32(24).int32(message.wallet_version);
        if (message.is_bounceable != null && Object.hasOwnProperty.call(message, "is_bounceable"))
            writer.uint32(32).bool(message.is_bounceable);
        if (message.is_testnet_only != null && Object.hasOwnProperty.call(message, "is_testnet_only"))
            writer.uint32(40).bool(message.is_testnet_only);
        if (message.workchain != null && Object.hasOwnProperty.call(message, "workchain"))
            writer.uint32(48).int32(message.workchain);
        if (message.wallet_id != null && Object.hasOwnProperty.call(message, "wallet_id"))
            writer.uint32(56).uint32(message.wallet_id);
        return writer;
    };

    TonGetAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    TonGetAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TonGetAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.show_display = reader.bool();
                break;
            case 3:
                message.wallet_version = reader.int32();
                break;
            case 4:
                message.is_bounceable = reader.bool();
                break;
            case 5:
                message.is_testnet_only = reader.bool();
                break;
            case 6:
                message.workchain = reader.int32();
                break;
            case 7:
                message.wallet_id = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    TonGetAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    TonGetAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        if (message.wallet_version != null && message.hasOwnProperty("wallet_version"))
            switch (message.wallet_version) {
            default:
                return "wallet_version: enum value expected";
            case 3:
                break;
            }
        if (message.is_bounceable != null && message.hasOwnProperty("is_bounceable"))
            if (typeof message.is_bounceable !== "boolean")
                return "is_bounceable: boolean expected";
        if (message.is_testnet_only != null && message.hasOwnProperty("is_testnet_only"))
            if (typeof message.is_testnet_only !== "boolean")
                return "is_testnet_only: boolean expected";
        if (message.workchain != null && message.hasOwnProperty("workchain"))
            switch (message.workchain) {
            default:
                return "workchain: enum value expected";
            case 0:
            case 1:
                break;
            }
        if (message.wallet_id != null && message.hasOwnProperty("wallet_id"))
            if (!$util.isInteger(message.wallet_id))
                return "wallet_id: integer expected";
        return null;
    };

    TonGetAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.TonGetAddress)
            return object;
        var message = new $root.TonGetAddress();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".TonGetAddress.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        switch (object.wallet_version) {
        case "V4R2":
        case 3:
            message.wallet_version = 3;
            break;
        }
        if (object.is_bounceable != null)
            message.is_bounceable = Boolean(object.is_bounceable);
        if (object.is_testnet_only != null)
            message.is_testnet_only = Boolean(object.is_testnet_only);
        switch (object.workchain) {
        case "BASECHAIN":
        case 0:
            message.workchain = 0;
            break;
        case "MASTERCHAIN":
        case 1:
            message.workchain = 1;
            break;
        }
        if (object.wallet_id != null)
            message.wallet_id = object.wallet_id >>> 0;
        return message;
    };

    TonGetAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            object.show_display = false;
            object.wallet_version = options.enums === String ? "V4R2" : 3;
            object.is_bounceable = false;
            object.is_testnet_only = false;
            object.workchain = options.enums === String ? "BASECHAIN" : 0;
            object.wallet_id = 698983191;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        if (message.wallet_version != null && message.hasOwnProperty("wallet_version"))
            object.wallet_version = options.enums === String ? $root.TonWalletVersion[message.wallet_version] : message.wallet_version;
        if (message.is_bounceable != null && message.hasOwnProperty("is_bounceable"))
            object.is_bounceable = message.is_bounceable;
        if (message.is_testnet_only != null && message.hasOwnProperty("is_testnet_only"))
            object.is_testnet_only = message.is_testnet_only;
        if (message.workchain != null && message.hasOwnProperty("workchain"))
            object.workchain = options.enums === String ? $root.TonWorkChain[message.workchain] : message.workchain;
        if (message.wallet_id != null && message.hasOwnProperty("wallet_id"))
            object.wallet_id = message.wallet_id;
        return object;
    };

    TonGetAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return TonGetAddress;
})();

$root.TonAddress = (function() {

    function TonAddress(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    TonAddress.prototype.public_key = $util.newBuffer([]);
    TonAddress.prototype.address = "";

    TonAddress.create = function create(properties) {
        return new TonAddress(properties);
    };

    TonAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.public_key);
        writer.uint32(18).string(message.address);
        return writer;
    };

    TonAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    TonAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TonAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.public_key = reader.bytes();
                break;
            case 2:
                message.address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("public_key"))
            throw $util.ProtocolError("missing required 'public_key'", { instance: message });
        if (!message.hasOwnProperty("address"))
            throw $util.ProtocolError("missing required 'address'", { instance: message });
        return message;
    };

    TonAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    TonAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.public_key && typeof message.public_key.length === "number" || $util.isString(message.public_key)))
            return "public_key: buffer expected";
        if (!$util.isString(message.address))
            return "address: string expected";
        return null;
    };

    TonAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.TonAddress)
            return object;
        var message = new $root.TonAddress();
        if (object.public_key != null)
            if (typeof object.public_key === "string")
                $util.base64.decode(object.public_key, message.public_key = $util.newBuffer($util.base64.length(object.public_key)), 0);
            else if (object.public_key.length)
                message.public_key = object.public_key;
        if (object.address != null)
            message.address = String(object.address);
        return message;
    };

    TonAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.public_key = "";
            else {
                object.public_key = [];
                if (options.bytes !== Array)
                    object.public_key = $util.newBuffer(object.public_key);
            }
            object.address = "";
        }
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            object.public_key = options.bytes === String ? $util.base64.encode(message.public_key, 0, message.public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.public_key) : message.public_key;
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    TonAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return TonAddress;
})();

$root.TonSignMessage = (function() {

    function TonSignMessage(properties) {
        this.address_n = [];
        this.ext_destination = [];
        this.ext_ton_amount = [];
        this.ext_payload = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    TonSignMessage.prototype.address_n = $util.emptyArray;
    TonSignMessage.prototype.destination = "";
    TonSignMessage.prototype.jetton_master_address = "";
    TonSignMessage.prototype.jetton_wallet_address = "";
    TonSignMessage.prototype.ton_amount = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    TonSignMessage.prototype.jetton_amount = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    TonSignMessage.prototype.fwd_fee = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    TonSignMessage.prototype.comment = "";
    TonSignMessage.prototype.is_raw_data = false;
    TonSignMessage.prototype.mode = 3;
    TonSignMessage.prototype.seqno = 0;
    TonSignMessage.prototype.expire_at = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    TonSignMessage.prototype.wallet_version = 3;
    TonSignMessage.prototype.wallet_id = 698983191;
    TonSignMessage.prototype.workchain = 0;
    TonSignMessage.prototype.is_bounceable = false;
    TonSignMessage.prototype.is_testnet_only = false;
    TonSignMessage.prototype.ext_destination = $util.emptyArray;
    TonSignMessage.prototype.ext_ton_amount = $util.emptyArray;
    TonSignMessage.prototype.ext_payload = $util.emptyArray;
    TonSignMessage.prototype.jetton_amount_bytes = $util.newBuffer([]);
    TonSignMessage.prototype.init_data_initial_chunk = $util.newBuffer([]);
    TonSignMessage.prototype.init_data_length = 0;
    TonSignMessage.prototype.signing_message_repr = $util.newBuffer([]);

    TonSignMessage.create = function create(properties) {
        return new TonSignMessage(properties);
    };

    TonSignMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).string(message.destination);
        if (message.jetton_master_address != null && Object.hasOwnProperty.call(message, "jetton_master_address"))
            writer.uint32(26).string(message.jetton_master_address);
        if (message.jetton_wallet_address != null && Object.hasOwnProperty.call(message, "jetton_wallet_address"))
            writer.uint32(34).string(message.jetton_wallet_address);
        writer.uint32(40).uint64(message.ton_amount);
        if (message.jetton_amount != null && Object.hasOwnProperty.call(message, "jetton_amount"))
            writer.uint32(48).uint64(message.jetton_amount);
        if (message.fwd_fee != null && Object.hasOwnProperty.call(message, "fwd_fee"))
            writer.uint32(56).uint64(message.fwd_fee);
        if (message.comment != null && Object.hasOwnProperty.call(message, "comment"))
            writer.uint32(66).string(message.comment);
        if (message.is_raw_data != null && Object.hasOwnProperty.call(message, "is_raw_data"))
            writer.uint32(72).bool(message.is_raw_data);
        if (message.mode != null && Object.hasOwnProperty.call(message, "mode"))
            writer.uint32(80).uint32(message.mode);
        writer.uint32(88).uint32(message.seqno);
        writer.uint32(96).uint64(message.expire_at);
        if (message.wallet_version != null && Object.hasOwnProperty.call(message, "wallet_version"))
            writer.uint32(104).int32(message.wallet_version);
        if (message.wallet_id != null && Object.hasOwnProperty.call(message, "wallet_id"))
            writer.uint32(112).uint32(message.wallet_id);
        if (message.workchain != null && Object.hasOwnProperty.call(message, "workchain"))
            writer.uint32(120).int32(message.workchain);
        if (message.is_bounceable != null && Object.hasOwnProperty.call(message, "is_bounceable"))
            writer.uint32(128).bool(message.is_bounceable);
        if (message.is_testnet_only != null && Object.hasOwnProperty.call(message, "is_testnet_only"))
            writer.uint32(136).bool(message.is_testnet_only);
        if (message.ext_destination != null && message.ext_destination.length)
            for (var i = 0; i < message.ext_destination.length; ++i)
                writer.uint32(146).string(message.ext_destination[i]);
        if (message.ext_ton_amount != null && message.ext_ton_amount.length)
            for (var i = 0; i < message.ext_ton_amount.length; ++i)
                writer.uint32(152).uint64(message.ext_ton_amount[i]);
        if (message.ext_payload != null && message.ext_payload.length)
            for (var i = 0; i < message.ext_payload.length; ++i)
                writer.uint32(162).string(message.ext_payload[i]);
        if (message.jetton_amount_bytes != null && Object.hasOwnProperty.call(message, "jetton_amount_bytes"))
            writer.uint32(170).bytes(message.jetton_amount_bytes);
        if (message.init_data_initial_chunk != null && Object.hasOwnProperty.call(message, "init_data_initial_chunk"))
            writer.uint32(178).bytes(message.init_data_initial_chunk);
        if (message.init_data_length != null && Object.hasOwnProperty.call(message, "init_data_length"))
            writer.uint32(184).uint32(message.init_data_length);
        if (message.signing_message_repr != null && Object.hasOwnProperty.call(message, "signing_message_repr"))
            writer.uint32(194).bytes(message.signing_message_repr);
        return writer;
    };

    TonSignMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    TonSignMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TonSignMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.destination = reader.string();
                break;
            case 3:
                message.jetton_master_address = reader.string();
                break;
            case 4:
                message.jetton_wallet_address = reader.string();
                break;
            case 5:
                message.ton_amount = reader.uint64();
                break;
            case 6:
                message.jetton_amount = reader.uint64();
                break;
            case 7:
                message.fwd_fee = reader.uint64();
                break;
            case 8:
                message.comment = reader.string();
                break;
            case 9:
                message.is_raw_data = reader.bool();
                break;
            case 10:
                message.mode = reader.uint32();
                break;
            case 11:
                message.seqno = reader.uint32();
                break;
            case 12:
                message.expire_at = reader.uint64();
                break;
            case 13:
                message.wallet_version = reader.int32();
                break;
            case 14:
                message.wallet_id = reader.uint32();
                break;
            case 15:
                message.workchain = reader.int32();
                break;
            case 16:
                message.is_bounceable = reader.bool();
                break;
            case 17:
                message.is_testnet_only = reader.bool();
                break;
            case 18:
                if (!(message.ext_destination && message.ext_destination.length))
                    message.ext_destination = [];
                message.ext_destination.push(reader.string());
                break;
            case 19:
                if (!(message.ext_ton_amount && message.ext_ton_amount.length))
                    message.ext_ton_amount = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.ext_ton_amount.push(reader.uint64());
                } else
                    message.ext_ton_amount.push(reader.uint64());
                break;
            case 20:
                if (!(message.ext_payload && message.ext_payload.length))
                    message.ext_payload = [];
                message.ext_payload.push(reader.string());
                break;
            case 21:
                message.jetton_amount_bytes = reader.bytes();
                break;
            case 22:
                message.init_data_initial_chunk = reader.bytes();
                break;
            case 23:
                message.init_data_length = reader.uint32();
                break;
            case 24:
                message.signing_message_repr = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("destination"))
            throw $util.ProtocolError("missing required 'destination'", { instance: message });
        if (!message.hasOwnProperty("ton_amount"))
            throw $util.ProtocolError("missing required 'ton_amount'", { instance: message });
        if (!message.hasOwnProperty("seqno"))
            throw $util.ProtocolError("missing required 'seqno'", { instance: message });
        if (!message.hasOwnProperty("expire_at"))
            throw $util.ProtocolError("missing required 'expire_at'", { instance: message });
        return message;
    };

    TonSignMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    TonSignMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!$util.isString(message.destination))
            return "destination: string expected";
        if (message.jetton_master_address != null && message.hasOwnProperty("jetton_master_address"))
            if (!$util.isString(message.jetton_master_address))
                return "jetton_master_address: string expected";
        if (message.jetton_wallet_address != null && message.hasOwnProperty("jetton_wallet_address"))
            if (!$util.isString(message.jetton_wallet_address))
                return "jetton_wallet_address: string expected";
        if (!$util.isInteger(message.ton_amount) && !(message.ton_amount && $util.isInteger(message.ton_amount.low) && $util.isInteger(message.ton_amount.high)))
            return "ton_amount: integer|Long expected";
        if (message.jetton_amount != null && message.hasOwnProperty("jetton_amount"))
            if (!$util.isInteger(message.jetton_amount) && !(message.jetton_amount && $util.isInteger(message.jetton_amount.low) && $util.isInteger(message.jetton_amount.high)))
                return "jetton_amount: integer|Long expected";
        if (message.fwd_fee != null && message.hasOwnProperty("fwd_fee"))
            if (!$util.isInteger(message.fwd_fee) && !(message.fwd_fee && $util.isInteger(message.fwd_fee.low) && $util.isInteger(message.fwd_fee.high)))
                return "fwd_fee: integer|Long expected";
        if (message.comment != null && message.hasOwnProperty("comment"))
            if (!$util.isString(message.comment))
                return "comment: string expected";
        if (message.is_raw_data != null && message.hasOwnProperty("is_raw_data"))
            if (typeof message.is_raw_data !== "boolean")
                return "is_raw_data: boolean expected";
        if (message.mode != null && message.hasOwnProperty("mode"))
            if (!$util.isInteger(message.mode))
                return "mode: integer expected";
        if (!$util.isInteger(message.seqno))
            return "seqno: integer expected";
        if (!$util.isInteger(message.expire_at) && !(message.expire_at && $util.isInteger(message.expire_at.low) && $util.isInteger(message.expire_at.high)))
            return "expire_at: integer|Long expected";
        if (message.wallet_version != null && message.hasOwnProperty("wallet_version"))
            switch (message.wallet_version) {
            default:
                return "wallet_version: enum value expected";
            case 3:
                break;
            }
        if (message.wallet_id != null && message.hasOwnProperty("wallet_id"))
            if (!$util.isInteger(message.wallet_id))
                return "wallet_id: integer expected";
        if (message.workchain != null && message.hasOwnProperty("workchain"))
            switch (message.workchain) {
            default:
                return "workchain: enum value expected";
            case 0:
            case 1:
                break;
            }
        if (message.is_bounceable != null && message.hasOwnProperty("is_bounceable"))
            if (typeof message.is_bounceable !== "boolean")
                return "is_bounceable: boolean expected";
        if (message.is_testnet_only != null && message.hasOwnProperty("is_testnet_only"))
            if (typeof message.is_testnet_only !== "boolean")
                return "is_testnet_only: boolean expected";
        if (message.ext_destination != null && message.hasOwnProperty("ext_destination")) {
            if (!Array.isArray(message.ext_destination))
                return "ext_destination: array expected";
            for (var i = 0; i < message.ext_destination.length; ++i)
                if (!$util.isString(message.ext_destination[i]))
                    return "ext_destination: string[] expected";
        }
        if (message.ext_ton_amount != null && message.hasOwnProperty("ext_ton_amount")) {
            if (!Array.isArray(message.ext_ton_amount))
                return "ext_ton_amount: array expected";
            for (var i = 0; i < message.ext_ton_amount.length; ++i)
                if (!$util.isInteger(message.ext_ton_amount[i]) && !(message.ext_ton_amount[i] && $util.isInteger(message.ext_ton_amount[i].low) && $util.isInteger(message.ext_ton_amount[i].high)))
                    return "ext_ton_amount: integer|Long[] expected";
        }
        if (message.ext_payload != null && message.hasOwnProperty("ext_payload")) {
            if (!Array.isArray(message.ext_payload))
                return "ext_payload: array expected";
            for (var i = 0; i < message.ext_payload.length; ++i)
                if (!$util.isString(message.ext_payload[i]))
                    return "ext_payload: string[] expected";
        }
        if (message.jetton_amount_bytes != null && message.hasOwnProperty("jetton_amount_bytes"))
            if (!(message.jetton_amount_bytes && typeof message.jetton_amount_bytes.length === "number" || $util.isString(message.jetton_amount_bytes)))
                return "jetton_amount_bytes: buffer expected";
        if (message.init_data_initial_chunk != null && message.hasOwnProperty("init_data_initial_chunk"))
            if (!(message.init_data_initial_chunk && typeof message.init_data_initial_chunk.length === "number" || $util.isString(message.init_data_initial_chunk)))
                return "init_data_initial_chunk: buffer expected";
        if (message.init_data_length != null && message.hasOwnProperty("init_data_length"))
            if (!$util.isInteger(message.init_data_length))
                return "init_data_length: integer expected";
        if (message.signing_message_repr != null && message.hasOwnProperty("signing_message_repr"))
            if (!(message.signing_message_repr && typeof message.signing_message_repr.length === "number" || $util.isString(message.signing_message_repr)))
                return "signing_message_repr: buffer expected";
        return null;
    };

    TonSignMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.TonSignMessage)
            return object;
        var message = new $root.TonSignMessage();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".TonSignMessage.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.destination != null)
            message.destination = String(object.destination);
        if (object.jetton_master_address != null)
            message.jetton_master_address = String(object.jetton_master_address);
        if (object.jetton_wallet_address != null)
            message.jetton_wallet_address = String(object.jetton_wallet_address);
        if (object.ton_amount != null)
            if ($util.Long)
                (message.ton_amount = $util.Long.fromValue(object.ton_amount)).unsigned = true;
            else if (typeof object.ton_amount === "string")
                message.ton_amount = parseInt(object.ton_amount, 10);
            else if (typeof object.ton_amount === "number")
                message.ton_amount = object.ton_amount;
            else if (typeof object.ton_amount === "object")
                message.ton_amount = new $util.LongBits(object.ton_amount.low >>> 0, object.ton_amount.high >>> 0).toNumber(true);
        if (object.jetton_amount != null)
            if ($util.Long)
                (message.jetton_amount = $util.Long.fromValue(object.jetton_amount)).unsigned = true;
            else if (typeof object.jetton_amount === "string")
                message.jetton_amount = parseInt(object.jetton_amount, 10);
            else if (typeof object.jetton_amount === "number")
                message.jetton_amount = object.jetton_amount;
            else if (typeof object.jetton_amount === "object")
                message.jetton_amount = new $util.LongBits(object.jetton_amount.low >>> 0, object.jetton_amount.high >>> 0).toNumber(true);
        if (object.fwd_fee != null)
            if ($util.Long)
                (message.fwd_fee = $util.Long.fromValue(object.fwd_fee)).unsigned = true;
            else if (typeof object.fwd_fee === "string")
                message.fwd_fee = parseInt(object.fwd_fee, 10);
            else if (typeof object.fwd_fee === "number")
                message.fwd_fee = object.fwd_fee;
            else if (typeof object.fwd_fee === "object")
                message.fwd_fee = new $util.LongBits(object.fwd_fee.low >>> 0, object.fwd_fee.high >>> 0).toNumber(true);
        if (object.comment != null)
            message.comment = String(object.comment);
        if (object.is_raw_data != null)
            message.is_raw_data = Boolean(object.is_raw_data);
        if (object.mode != null)
            message.mode = object.mode >>> 0;
        if (object.seqno != null)
            message.seqno = object.seqno >>> 0;
        if (object.expire_at != null)
            if ($util.Long)
                (message.expire_at = $util.Long.fromValue(object.expire_at)).unsigned = true;
            else if (typeof object.expire_at === "string")
                message.expire_at = parseInt(object.expire_at, 10);
            else if (typeof object.expire_at === "number")
                message.expire_at = object.expire_at;
            else if (typeof object.expire_at === "object")
                message.expire_at = new $util.LongBits(object.expire_at.low >>> 0, object.expire_at.high >>> 0).toNumber(true);
        switch (object.wallet_version) {
        case "V4R2":
        case 3:
            message.wallet_version = 3;
            break;
        }
        if (object.wallet_id != null)
            message.wallet_id = object.wallet_id >>> 0;
        switch (object.workchain) {
        case "BASECHAIN":
        case 0:
            message.workchain = 0;
            break;
        case "MASTERCHAIN":
        case 1:
            message.workchain = 1;
            break;
        }
        if (object.is_bounceable != null)
            message.is_bounceable = Boolean(object.is_bounceable);
        if (object.is_testnet_only != null)
            message.is_testnet_only = Boolean(object.is_testnet_only);
        if (object.ext_destination) {
            if (!Array.isArray(object.ext_destination))
                throw TypeError(".TonSignMessage.ext_destination: array expected");
            message.ext_destination = [];
            for (var i = 0; i < object.ext_destination.length; ++i)
                message.ext_destination[i] = String(object.ext_destination[i]);
        }
        if (object.ext_ton_amount) {
            if (!Array.isArray(object.ext_ton_amount))
                throw TypeError(".TonSignMessage.ext_ton_amount: array expected");
            message.ext_ton_amount = [];
            for (var i = 0; i < object.ext_ton_amount.length; ++i)
                if ($util.Long)
                    (message.ext_ton_amount[i] = $util.Long.fromValue(object.ext_ton_amount[i])).unsigned = true;
                else if (typeof object.ext_ton_amount[i] === "string")
                    message.ext_ton_amount[i] = parseInt(object.ext_ton_amount[i], 10);
                else if (typeof object.ext_ton_amount[i] === "number")
                    message.ext_ton_amount[i] = object.ext_ton_amount[i];
                else if (typeof object.ext_ton_amount[i] === "object")
                    message.ext_ton_amount[i] = new $util.LongBits(object.ext_ton_amount[i].low >>> 0, object.ext_ton_amount[i].high >>> 0).toNumber(true);
        }
        if (object.ext_payload) {
            if (!Array.isArray(object.ext_payload))
                throw TypeError(".TonSignMessage.ext_payload: array expected");
            message.ext_payload = [];
            for (var i = 0; i < object.ext_payload.length; ++i)
                message.ext_payload[i] = String(object.ext_payload[i]);
        }
        if (object.jetton_amount_bytes != null)
            if (typeof object.jetton_amount_bytes === "string")
                $util.base64.decode(object.jetton_amount_bytes, message.jetton_amount_bytes = $util.newBuffer($util.base64.length(object.jetton_amount_bytes)), 0);
            else if (object.jetton_amount_bytes.length)
                message.jetton_amount_bytes = object.jetton_amount_bytes;
        if (object.init_data_initial_chunk != null)
            if (typeof object.init_data_initial_chunk === "string")
                $util.base64.decode(object.init_data_initial_chunk, message.init_data_initial_chunk = $util.newBuffer($util.base64.length(object.init_data_initial_chunk)), 0);
            else if (object.init_data_initial_chunk.length)
                message.init_data_initial_chunk = object.init_data_initial_chunk;
        if (object.init_data_length != null)
            message.init_data_length = object.init_data_length >>> 0;
        if (object.signing_message_repr != null)
            if (typeof object.signing_message_repr === "string")
                $util.base64.decode(object.signing_message_repr, message.signing_message_repr = $util.newBuffer($util.base64.length(object.signing_message_repr)), 0);
            else if (object.signing_message_repr.length)
                message.signing_message_repr = object.signing_message_repr;
        return message;
    };

    TonSignMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults) {
            object.address_n = [];
            object.ext_destination = [];
            object.ext_ton_amount = [];
            object.ext_payload = [];
        }
        if (options.defaults) {
            object.destination = "";
            object.jetton_master_address = "";
            object.jetton_wallet_address = "";
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.ton_amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.ton_amount = options.longs === String ? "0" : 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.jetton_amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.jetton_amount = options.longs === String ? "0" : 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.fwd_fee = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.fwd_fee = options.longs === String ? "0" : 0;
            object.comment = "";
            object.is_raw_data = false;
            object.mode = 3;
            object.seqno = 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.expire_at = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.expire_at = options.longs === String ? "0" : 0;
            object.wallet_version = options.enums === String ? "V4R2" : 3;
            object.wallet_id = 698983191;
            object.workchain = options.enums === String ? "BASECHAIN" : 0;
            object.is_bounceable = false;
            object.is_testnet_only = false;
            if (options.bytes === String)
                object.jetton_amount_bytes = "";
            else {
                object.jetton_amount_bytes = [];
                if (options.bytes !== Array)
                    object.jetton_amount_bytes = $util.newBuffer(object.jetton_amount_bytes);
            }
            if (options.bytes === String)
                object.init_data_initial_chunk = "";
            else {
                object.init_data_initial_chunk = [];
                if (options.bytes !== Array)
                    object.init_data_initial_chunk = $util.newBuffer(object.init_data_initial_chunk);
            }
            object.init_data_length = 0;
            if (options.bytes === String)
                object.signing_message_repr = "";
            else {
                object.signing_message_repr = [];
                if (options.bytes !== Array)
                    object.signing_message_repr = $util.newBuffer(object.signing_message_repr);
            }
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.destination != null && message.hasOwnProperty("destination"))
            object.destination = message.destination;
        if (message.jetton_master_address != null && message.hasOwnProperty("jetton_master_address"))
            object.jetton_master_address = message.jetton_master_address;
        if (message.jetton_wallet_address != null && message.hasOwnProperty("jetton_wallet_address"))
            object.jetton_wallet_address = message.jetton_wallet_address;
        if (message.ton_amount != null && message.hasOwnProperty("ton_amount"))
            if (typeof message.ton_amount === "number")
                object.ton_amount = options.longs === String ? String(message.ton_amount) : message.ton_amount;
            else
                object.ton_amount = options.longs === String ? $util.Long.prototype.toString.call(message.ton_amount) : options.longs === Number ? new $util.LongBits(message.ton_amount.low >>> 0, message.ton_amount.high >>> 0).toNumber(true) : message.ton_amount;
        if (message.jetton_amount != null && message.hasOwnProperty("jetton_amount"))
            if (typeof message.jetton_amount === "number")
                object.jetton_amount = options.longs === String ? String(message.jetton_amount) : message.jetton_amount;
            else
                object.jetton_amount = options.longs === String ? $util.Long.prototype.toString.call(message.jetton_amount) : options.longs === Number ? new $util.LongBits(message.jetton_amount.low >>> 0, message.jetton_amount.high >>> 0).toNumber(true) : message.jetton_amount;
        if (message.fwd_fee != null && message.hasOwnProperty("fwd_fee"))
            if (typeof message.fwd_fee === "number")
                object.fwd_fee = options.longs === String ? String(message.fwd_fee) : message.fwd_fee;
            else
                object.fwd_fee = options.longs === String ? $util.Long.prototype.toString.call(message.fwd_fee) : options.longs === Number ? new $util.LongBits(message.fwd_fee.low >>> 0, message.fwd_fee.high >>> 0).toNumber(true) : message.fwd_fee;
        if (message.comment != null && message.hasOwnProperty("comment"))
            object.comment = message.comment;
        if (message.is_raw_data != null && message.hasOwnProperty("is_raw_data"))
            object.is_raw_data = message.is_raw_data;
        if (message.mode != null && message.hasOwnProperty("mode"))
            object.mode = message.mode;
        if (message.seqno != null && message.hasOwnProperty("seqno"))
            object.seqno = message.seqno;
        if (message.expire_at != null && message.hasOwnProperty("expire_at"))
            if (typeof message.expire_at === "number")
                object.expire_at = options.longs === String ? String(message.expire_at) : message.expire_at;
            else
                object.expire_at = options.longs === String ? $util.Long.prototype.toString.call(message.expire_at) : options.longs === Number ? new $util.LongBits(message.expire_at.low >>> 0, message.expire_at.high >>> 0).toNumber(true) : message.expire_at;
        if (message.wallet_version != null && message.hasOwnProperty("wallet_version"))
            object.wallet_version = options.enums === String ? $root.TonWalletVersion[message.wallet_version] : message.wallet_version;
        if (message.wallet_id != null && message.hasOwnProperty("wallet_id"))
            object.wallet_id = message.wallet_id;
        if (message.workchain != null && message.hasOwnProperty("workchain"))
            object.workchain = options.enums === String ? $root.TonWorkChain[message.workchain] : message.workchain;
        if (message.is_bounceable != null && message.hasOwnProperty("is_bounceable"))
            object.is_bounceable = message.is_bounceable;
        if (message.is_testnet_only != null && message.hasOwnProperty("is_testnet_only"))
            object.is_testnet_only = message.is_testnet_only;
        if (message.ext_destination && message.ext_destination.length) {
            object.ext_destination = [];
            for (var j = 0; j < message.ext_destination.length; ++j)
                object.ext_destination[j] = message.ext_destination[j];
        }
        if (message.ext_ton_amount && message.ext_ton_amount.length) {
            object.ext_ton_amount = [];
            for (var j = 0; j < message.ext_ton_amount.length; ++j)
                if (typeof message.ext_ton_amount[j] === "number")
                    object.ext_ton_amount[j] = options.longs === String ? String(message.ext_ton_amount[j]) : message.ext_ton_amount[j];
                else
                    object.ext_ton_amount[j] = options.longs === String ? $util.Long.prototype.toString.call(message.ext_ton_amount[j]) : options.longs === Number ? new $util.LongBits(message.ext_ton_amount[j].low >>> 0, message.ext_ton_amount[j].high >>> 0).toNumber(true) : message.ext_ton_amount[j];
        }
        if (message.ext_payload && message.ext_payload.length) {
            object.ext_payload = [];
            for (var j = 0; j < message.ext_payload.length; ++j)
                object.ext_payload[j] = message.ext_payload[j];
        }
        if (message.jetton_amount_bytes != null && message.hasOwnProperty("jetton_amount_bytes"))
            object.jetton_amount_bytes = options.bytes === String ? $util.base64.encode(message.jetton_amount_bytes, 0, message.jetton_amount_bytes.length) : options.bytes === Array ? Array.prototype.slice.call(message.jetton_amount_bytes) : message.jetton_amount_bytes;
        if (message.init_data_initial_chunk != null && message.hasOwnProperty("init_data_initial_chunk"))
            object.init_data_initial_chunk = options.bytes === String ? $util.base64.encode(message.init_data_initial_chunk, 0, message.init_data_initial_chunk.length) : options.bytes === Array ? Array.prototype.slice.call(message.init_data_initial_chunk) : message.init_data_initial_chunk;
        if (message.init_data_length != null && message.hasOwnProperty("init_data_length"))
            object.init_data_length = message.init_data_length;
        if (message.signing_message_repr != null && message.hasOwnProperty("signing_message_repr"))
            object.signing_message_repr = options.bytes === String ? $util.base64.encode(message.signing_message_repr, 0, message.signing_message_repr.length) : options.bytes === Array ? Array.prototype.slice.call(message.signing_message_repr) : message.signing_message_repr;
        return object;
    };

    TonSignMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return TonSignMessage;
})();

$root.TonTxAck = (function() {

    function TonTxAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    TonTxAck.prototype.init_data_chunk = $util.newBuffer([]);

    TonTxAck.create = function create(properties) {
        return new TonTxAck(properties);
    };

    TonTxAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.init_data_chunk);
        return writer;
    };

    TonTxAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    TonTxAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TonTxAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.init_data_chunk = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("init_data_chunk"))
            throw $util.ProtocolError("missing required 'init_data_chunk'", { instance: message });
        return message;
    };

    TonTxAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    TonTxAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.init_data_chunk && typeof message.init_data_chunk.length === "number" || $util.isString(message.init_data_chunk)))
            return "init_data_chunk: buffer expected";
        return null;
    };

    TonTxAck.fromObject = function fromObject(object) {
        if (object instanceof $root.TonTxAck)
            return object;
        var message = new $root.TonTxAck();
        if (object.init_data_chunk != null)
            if (typeof object.init_data_chunk === "string")
                $util.base64.decode(object.init_data_chunk, message.init_data_chunk = $util.newBuffer($util.base64.length(object.init_data_chunk)), 0);
            else if (object.init_data_chunk.length)
                message.init_data_chunk = object.init_data_chunk;
        return message;
    };

    TonTxAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.init_data_chunk = "";
            else {
                object.init_data_chunk = [];
                if (options.bytes !== Array)
                    object.init_data_chunk = $util.newBuffer(object.init_data_chunk);
            }
        if (message.init_data_chunk != null && message.hasOwnProperty("init_data_chunk"))
            object.init_data_chunk = options.bytes === String ? $util.base64.encode(message.init_data_chunk, 0, message.init_data_chunk.length) : options.bytes === Array ? Array.prototype.slice.call(message.init_data_chunk) : message.init_data_chunk;
        return object;
    };

    TonTxAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return TonTxAck;
})();

$root.TonSignedMessage = (function() {

    function TonSignedMessage(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    TonSignedMessage.prototype.signature = $util.newBuffer([]);
    TonSignedMessage.prototype.signning_message = $util.newBuffer([]);
    TonSignedMessage.prototype.init_data_length = 0;

    TonSignedMessage.create = function create(properties) {
        return new TonSignedMessage(properties);
    };

    TonSignedMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.signature != null && Object.hasOwnProperty.call(message, "signature"))
            writer.uint32(10).bytes(message.signature);
        if (message.signning_message != null && Object.hasOwnProperty.call(message, "signning_message"))
            writer.uint32(18).bytes(message.signning_message);
        if (message.init_data_length != null && Object.hasOwnProperty.call(message, "init_data_length"))
            writer.uint32(24).uint32(message.init_data_length);
        return writer;
    };

    TonSignedMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    TonSignedMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TonSignedMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.signature = reader.bytes();
                break;
            case 2:
                message.signning_message = reader.bytes();
                break;
            case 3:
                message.init_data_length = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    TonSignedMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    TonSignedMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.signature != null && message.hasOwnProperty("signature"))
            if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
                return "signature: buffer expected";
        if (message.signning_message != null && message.hasOwnProperty("signning_message"))
            if (!(message.signning_message && typeof message.signning_message.length === "number" || $util.isString(message.signning_message)))
                return "signning_message: buffer expected";
        if (message.init_data_length != null && message.hasOwnProperty("init_data_length"))
            if (!$util.isInteger(message.init_data_length))
                return "init_data_length: integer expected";
        return null;
    };

    TonSignedMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.TonSignedMessage)
            return object;
        var message = new $root.TonSignedMessage();
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        if (object.signning_message != null)
            if (typeof object.signning_message === "string")
                $util.base64.decode(object.signning_message, message.signning_message = $util.newBuffer($util.base64.length(object.signning_message)), 0);
            else if (object.signning_message.length)
                message.signning_message = object.signning_message;
        if (object.init_data_length != null)
            message.init_data_length = object.init_data_length >>> 0;
        return message;
    };

    TonSignedMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
            if (options.bytes === String)
                object.signning_message = "";
            else {
                object.signning_message = [];
                if (options.bytes !== Array)
                    object.signning_message = $util.newBuffer(object.signning_message);
            }
            object.init_data_length = 0;
        }
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        if (message.signning_message != null && message.hasOwnProperty("signning_message"))
            object.signning_message = options.bytes === String ? $util.base64.encode(message.signning_message, 0, message.signning_message.length) : options.bytes === Array ? Array.prototype.slice.call(message.signning_message) : message.signning_message;
        if (message.init_data_length != null && message.hasOwnProperty("init_data_length"))
            object.init_data_length = message.init_data_length;
        return object;
    };

    TonSignedMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return TonSignedMessage;
})();

$root.TonSignProof = (function() {

    function TonSignProof(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    TonSignProof.prototype.address_n = $util.emptyArray;
    TonSignProof.prototype.appdomain = $util.newBuffer([]);
    TonSignProof.prototype.comment = $util.newBuffer([]);
    TonSignProof.prototype.expire_at = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    TonSignProof.prototype.wallet_version = 3;
    TonSignProof.prototype.wallet_id = 698983191;
    TonSignProof.prototype.workchain = 0;
    TonSignProof.prototype.is_bounceable = false;
    TonSignProof.prototype.is_testnet_only = false;

    TonSignProof.create = function create(properties) {
        return new TonSignProof(properties);
    };

    TonSignProof.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).bytes(message.appdomain);
        if (message.comment != null && Object.hasOwnProperty.call(message, "comment"))
            writer.uint32(26).bytes(message.comment);
        writer.uint32(32).uint64(message.expire_at);
        if (message.wallet_version != null && Object.hasOwnProperty.call(message, "wallet_version"))
            writer.uint32(40).int32(message.wallet_version);
        if (message.wallet_id != null && Object.hasOwnProperty.call(message, "wallet_id"))
            writer.uint32(48).uint32(message.wallet_id);
        if (message.workchain != null && Object.hasOwnProperty.call(message, "workchain"))
            writer.uint32(56).int32(message.workchain);
        if (message.is_bounceable != null && Object.hasOwnProperty.call(message, "is_bounceable"))
            writer.uint32(64).bool(message.is_bounceable);
        if (message.is_testnet_only != null && Object.hasOwnProperty.call(message, "is_testnet_only"))
            writer.uint32(72).bool(message.is_testnet_only);
        return writer;
    };

    TonSignProof.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    TonSignProof.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TonSignProof();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.appdomain = reader.bytes();
                break;
            case 3:
                message.comment = reader.bytes();
                break;
            case 4:
                message.expire_at = reader.uint64();
                break;
            case 5:
                message.wallet_version = reader.int32();
                break;
            case 6:
                message.wallet_id = reader.uint32();
                break;
            case 7:
                message.workchain = reader.int32();
                break;
            case 8:
                message.is_bounceable = reader.bool();
                break;
            case 9:
                message.is_testnet_only = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("appdomain"))
            throw $util.ProtocolError("missing required 'appdomain'", { instance: message });
        if (!message.hasOwnProperty("expire_at"))
            throw $util.ProtocolError("missing required 'expire_at'", { instance: message });
        return message;
    };

    TonSignProof.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    TonSignProof.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!(message.appdomain && typeof message.appdomain.length === "number" || $util.isString(message.appdomain)))
            return "appdomain: buffer expected";
        if (message.comment != null && message.hasOwnProperty("comment"))
            if (!(message.comment && typeof message.comment.length === "number" || $util.isString(message.comment)))
                return "comment: buffer expected";
        if (!$util.isInteger(message.expire_at) && !(message.expire_at && $util.isInteger(message.expire_at.low) && $util.isInteger(message.expire_at.high)))
            return "expire_at: integer|Long expected";
        if (message.wallet_version != null && message.hasOwnProperty("wallet_version"))
            switch (message.wallet_version) {
            default:
                return "wallet_version: enum value expected";
            case 3:
                break;
            }
        if (message.wallet_id != null && message.hasOwnProperty("wallet_id"))
            if (!$util.isInteger(message.wallet_id))
                return "wallet_id: integer expected";
        if (message.workchain != null && message.hasOwnProperty("workchain"))
            switch (message.workchain) {
            default:
                return "workchain: enum value expected";
            case 0:
            case 1:
                break;
            }
        if (message.is_bounceable != null && message.hasOwnProperty("is_bounceable"))
            if (typeof message.is_bounceable !== "boolean")
                return "is_bounceable: boolean expected";
        if (message.is_testnet_only != null && message.hasOwnProperty("is_testnet_only"))
            if (typeof message.is_testnet_only !== "boolean")
                return "is_testnet_only: boolean expected";
        return null;
    };

    TonSignProof.fromObject = function fromObject(object) {
        if (object instanceof $root.TonSignProof)
            return object;
        var message = new $root.TonSignProof();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".TonSignProof.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.appdomain != null)
            if (typeof object.appdomain === "string")
                $util.base64.decode(object.appdomain, message.appdomain = $util.newBuffer($util.base64.length(object.appdomain)), 0);
            else if (object.appdomain.length)
                message.appdomain = object.appdomain;
        if (object.comment != null)
            if (typeof object.comment === "string")
                $util.base64.decode(object.comment, message.comment = $util.newBuffer($util.base64.length(object.comment)), 0);
            else if (object.comment.length)
                message.comment = object.comment;
        if (object.expire_at != null)
            if ($util.Long)
                (message.expire_at = $util.Long.fromValue(object.expire_at)).unsigned = true;
            else if (typeof object.expire_at === "string")
                message.expire_at = parseInt(object.expire_at, 10);
            else if (typeof object.expire_at === "number")
                message.expire_at = object.expire_at;
            else if (typeof object.expire_at === "object")
                message.expire_at = new $util.LongBits(object.expire_at.low >>> 0, object.expire_at.high >>> 0).toNumber(true);
        switch (object.wallet_version) {
        case "V4R2":
        case 3:
            message.wallet_version = 3;
            break;
        }
        if (object.wallet_id != null)
            message.wallet_id = object.wallet_id >>> 0;
        switch (object.workchain) {
        case "BASECHAIN":
        case 0:
            message.workchain = 0;
            break;
        case "MASTERCHAIN":
        case 1:
            message.workchain = 1;
            break;
        }
        if (object.is_bounceable != null)
            message.is_bounceable = Boolean(object.is_bounceable);
        if (object.is_testnet_only != null)
            message.is_testnet_only = Boolean(object.is_testnet_only);
        return message;
    };

    TonSignProof.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            if (options.bytes === String)
                object.appdomain = "";
            else {
                object.appdomain = [];
                if (options.bytes !== Array)
                    object.appdomain = $util.newBuffer(object.appdomain);
            }
            if (options.bytes === String)
                object.comment = "";
            else {
                object.comment = [];
                if (options.bytes !== Array)
                    object.comment = $util.newBuffer(object.comment);
            }
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.expire_at = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.expire_at = options.longs === String ? "0" : 0;
            object.wallet_version = options.enums === String ? "V4R2" : 3;
            object.wallet_id = 698983191;
            object.workchain = options.enums === String ? "BASECHAIN" : 0;
            object.is_bounceable = false;
            object.is_testnet_only = false;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.appdomain != null && message.hasOwnProperty("appdomain"))
            object.appdomain = options.bytes === String ? $util.base64.encode(message.appdomain, 0, message.appdomain.length) : options.bytes === Array ? Array.prototype.slice.call(message.appdomain) : message.appdomain;
        if (message.comment != null && message.hasOwnProperty("comment"))
            object.comment = options.bytes === String ? $util.base64.encode(message.comment, 0, message.comment.length) : options.bytes === Array ? Array.prototype.slice.call(message.comment) : message.comment;
        if (message.expire_at != null && message.hasOwnProperty("expire_at"))
            if (typeof message.expire_at === "number")
                object.expire_at = options.longs === String ? String(message.expire_at) : message.expire_at;
            else
                object.expire_at = options.longs === String ? $util.Long.prototype.toString.call(message.expire_at) : options.longs === Number ? new $util.LongBits(message.expire_at.low >>> 0, message.expire_at.high >>> 0).toNumber(true) : message.expire_at;
        if (message.wallet_version != null && message.hasOwnProperty("wallet_version"))
            object.wallet_version = options.enums === String ? $root.TonWalletVersion[message.wallet_version] : message.wallet_version;
        if (message.wallet_id != null && message.hasOwnProperty("wallet_id"))
            object.wallet_id = message.wallet_id;
        if (message.workchain != null && message.hasOwnProperty("workchain"))
            object.workchain = options.enums === String ? $root.TonWorkChain[message.workchain] : message.workchain;
        if (message.is_bounceable != null && message.hasOwnProperty("is_bounceable"))
            object.is_bounceable = message.is_bounceable;
        if (message.is_testnet_only != null && message.hasOwnProperty("is_testnet_only"))
            object.is_testnet_only = message.is_testnet_only;
        return object;
    };

    TonSignProof.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return TonSignProof;
})();

$root.TonSignedProof = (function() {

    function TonSignedProof(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    TonSignedProof.prototype.signature = $util.newBuffer([]);

    TonSignedProof.create = function create(properties) {
        return new TonSignedProof(properties);
    };

    TonSignedProof.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.signature != null && Object.hasOwnProperty.call(message, "signature"))
            writer.uint32(10).bytes(message.signature);
        return writer;
    };

    TonSignedProof.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    TonSignedProof.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TonSignedProof();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.signature = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    TonSignedProof.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    TonSignedProof.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.signature != null && message.hasOwnProperty("signature"))
            if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
                return "signature: buffer expected";
        return null;
    };

    TonSignedProof.fromObject = function fromObject(object) {
        if (object instanceof $root.TonSignedProof)
            return object;
        var message = new $root.TonSignedProof();
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        return message;
    };

    TonSignedProof.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        return object;
    };

    TonSignedProof.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return TonSignedProof;
})();

$root.TonSignData = (function() {

    function TonSignData(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    TonSignData.prototype.address_n = $util.emptyArray;
    TonSignData.prototype.type = 0;
    TonSignData.prototype.payload = $util.newBuffer([]);
    TonSignData.prototype.schema = "";
    TonSignData.prototype.appdomain = "";
    TonSignData.prototype.timestamp = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    TonSignData.prototype.from_address = "";
    TonSignData.prototype.wallet_version = 3;
    TonSignData.prototype.wallet_id = 698983191;
    TonSignData.prototype.workchain = 0;
    TonSignData.prototype.is_bounceable = false;
    TonSignData.prototype.is_testnet_only = false;

    TonSignData.create = function create(properties) {
        return new TonSignData(properties);
    };

    TonSignData.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(16).int32(message.type);
        writer.uint32(26).bytes(message.payload);
        if (message.schema != null && Object.hasOwnProperty.call(message, "schema"))
            writer.uint32(34).string(message.schema);
        writer.uint32(42).string(message.appdomain);
        writer.uint32(48).uint64(message.timestamp);
        if (message.from_address != null && Object.hasOwnProperty.call(message, "from_address"))
            writer.uint32(58).string(message.from_address);
        if (message.wallet_version != null && Object.hasOwnProperty.call(message, "wallet_version"))
            writer.uint32(64).int32(message.wallet_version);
        if (message.wallet_id != null && Object.hasOwnProperty.call(message, "wallet_id"))
            writer.uint32(72).uint32(message.wallet_id);
        if (message.workchain != null && Object.hasOwnProperty.call(message, "workchain"))
            writer.uint32(80).int32(message.workchain);
        if (message.is_bounceable != null && Object.hasOwnProperty.call(message, "is_bounceable"))
            writer.uint32(88).bool(message.is_bounceable);
        if (message.is_testnet_only != null && Object.hasOwnProperty.call(message, "is_testnet_only"))
            writer.uint32(96).bool(message.is_testnet_only);
        return writer;
    };

    TonSignData.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    TonSignData.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TonSignData();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.type = reader.int32();
                break;
            case 3:
                message.payload = reader.bytes();
                break;
            case 4:
                message.schema = reader.string();
                break;
            case 5:
                message.appdomain = reader.string();
                break;
            case 6:
                message.timestamp = reader.uint64();
                break;
            case 7:
                message.from_address = reader.string();
                break;
            case 8:
                message.wallet_version = reader.int32();
                break;
            case 9:
                message.wallet_id = reader.uint32();
                break;
            case 10:
                message.workchain = reader.int32();
                break;
            case 11:
                message.is_bounceable = reader.bool();
                break;
            case 12:
                message.is_testnet_only = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("type"))
            throw $util.ProtocolError("missing required 'type'", { instance: message });
        if (!message.hasOwnProperty("payload"))
            throw $util.ProtocolError("missing required 'payload'", { instance: message });
        if (!message.hasOwnProperty("appdomain"))
            throw $util.ProtocolError("missing required 'appdomain'", { instance: message });
        if (!message.hasOwnProperty("timestamp"))
            throw $util.ProtocolError("missing required 'timestamp'", { instance: message });
        return message;
    };

    TonSignData.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    TonSignData.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        switch (message.type) {
        default:
            return "type: enum value expected";
        case 0:
        case 1:
        case 2:
            break;
        }
        if (!(message.payload && typeof message.payload.length === "number" || $util.isString(message.payload)))
            return "payload: buffer expected";
        if (message.schema != null && message.hasOwnProperty("schema"))
            if (!$util.isString(message.schema))
                return "schema: string expected";
        if (!$util.isString(message.appdomain))
            return "appdomain: string expected";
        if (!$util.isInteger(message.timestamp) && !(message.timestamp && $util.isInteger(message.timestamp.low) && $util.isInteger(message.timestamp.high)))
            return "timestamp: integer|Long expected";
        if (message.from_address != null && message.hasOwnProperty("from_address"))
            if (!$util.isString(message.from_address))
                return "from_address: string expected";
        if (message.wallet_version != null && message.hasOwnProperty("wallet_version"))
            switch (message.wallet_version) {
            default:
                return "wallet_version: enum value expected";
            case 3:
                break;
            }
        if (message.wallet_id != null && message.hasOwnProperty("wallet_id"))
            if (!$util.isInteger(message.wallet_id))
                return "wallet_id: integer expected";
        if (message.workchain != null && message.hasOwnProperty("workchain"))
            switch (message.workchain) {
            default:
                return "workchain: enum value expected";
            case 0:
            case 1:
                break;
            }
        if (message.is_bounceable != null && message.hasOwnProperty("is_bounceable"))
            if (typeof message.is_bounceable !== "boolean")
                return "is_bounceable: boolean expected";
        if (message.is_testnet_only != null && message.hasOwnProperty("is_testnet_only"))
            if (typeof message.is_testnet_only !== "boolean")
                return "is_testnet_only: boolean expected";
        return null;
    };

    TonSignData.fromObject = function fromObject(object) {
        if (object instanceof $root.TonSignData)
            return object;
        var message = new $root.TonSignData();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".TonSignData.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        switch (object.type) {
        case "TEXT":
        case 0:
            message.type = 0;
            break;
        case "BINARY":
        case 1:
            message.type = 1;
            break;
        case "CELL":
        case 2:
            message.type = 2;
            break;
        }
        if (object.payload != null)
            if (typeof object.payload === "string")
                $util.base64.decode(object.payload, message.payload = $util.newBuffer($util.base64.length(object.payload)), 0);
            else if (object.payload.length)
                message.payload = object.payload;
        if (object.schema != null)
            message.schema = String(object.schema);
        if (object.appdomain != null)
            message.appdomain = String(object.appdomain);
        if (object.timestamp != null)
            if ($util.Long)
                (message.timestamp = $util.Long.fromValue(object.timestamp)).unsigned = true;
            else if (typeof object.timestamp === "string")
                message.timestamp = parseInt(object.timestamp, 10);
            else if (typeof object.timestamp === "number")
                message.timestamp = object.timestamp;
            else if (typeof object.timestamp === "object")
                message.timestamp = new $util.LongBits(object.timestamp.low >>> 0, object.timestamp.high >>> 0).toNumber(true);
        if (object.from_address != null)
            message.from_address = String(object.from_address);
        switch (object.wallet_version) {
        case "V4R2":
        case 3:
            message.wallet_version = 3;
            break;
        }
        if (object.wallet_id != null)
            message.wallet_id = object.wallet_id >>> 0;
        switch (object.workchain) {
        case "BASECHAIN":
        case 0:
            message.workchain = 0;
            break;
        case "MASTERCHAIN":
        case 1:
            message.workchain = 1;
            break;
        }
        if (object.is_bounceable != null)
            message.is_bounceable = Boolean(object.is_bounceable);
        if (object.is_testnet_only != null)
            message.is_testnet_only = Boolean(object.is_testnet_only);
        return message;
    };

    TonSignData.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            object.type = options.enums === String ? "TEXT" : 0;
            if (options.bytes === String)
                object.payload = "";
            else {
                object.payload = [];
                if (options.bytes !== Array)
                    object.payload = $util.newBuffer(object.payload);
            }
            object.schema = "";
            object.appdomain = "";
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.timestamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.timestamp = options.longs === String ? "0" : 0;
            object.from_address = "";
            object.wallet_version = options.enums === String ? "V4R2" : 3;
            object.wallet_id = 698983191;
            object.workchain = options.enums === String ? "BASECHAIN" : 0;
            object.is_bounceable = false;
            object.is_testnet_only = false;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.type != null && message.hasOwnProperty("type"))
            object.type = options.enums === String ? $root.TonSignData.TonSignDataType[message.type] : message.type;
        if (message.payload != null && message.hasOwnProperty("payload"))
            object.payload = options.bytes === String ? $util.base64.encode(message.payload, 0, message.payload.length) : options.bytes === Array ? Array.prototype.slice.call(message.payload) : message.payload;
        if (message.schema != null && message.hasOwnProperty("schema"))
            object.schema = message.schema;
        if (message.appdomain != null && message.hasOwnProperty("appdomain"))
            object.appdomain = message.appdomain;
        if (message.timestamp != null && message.hasOwnProperty("timestamp"))
            if (typeof message.timestamp === "number")
                object.timestamp = options.longs === String ? String(message.timestamp) : message.timestamp;
            else
                object.timestamp = options.longs === String ? $util.Long.prototype.toString.call(message.timestamp) : options.longs === Number ? new $util.LongBits(message.timestamp.low >>> 0, message.timestamp.high >>> 0).toNumber(true) : message.timestamp;
        if (message.from_address != null && message.hasOwnProperty("from_address"))
            object.from_address = message.from_address;
        if (message.wallet_version != null && message.hasOwnProperty("wallet_version"))
            object.wallet_version = options.enums === String ? $root.TonWalletVersion[message.wallet_version] : message.wallet_version;
        if (message.wallet_id != null && message.hasOwnProperty("wallet_id"))
            object.wallet_id = message.wallet_id;
        if (message.workchain != null && message.hasOwnProperty("workchain"))
            object.workchain = options.enums === String ? $root.TonWorkChain[message.workchain] : message.workchain;
        if (message.is_bounceable != null && message.hasOwnProperty("is_bounceable"))
            object.is_bounceable = message.is_bounceable;
        if (message.is_testnet_only != null && message.hasOwnProperty("is_testnet_only"))
            object.is_testnet_only = message.is_testnet_only;
        return object;
    };

    TonSignData.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    TonSignData.TonSignDataType = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "TEXT"] = 0;
        values[valuesById[1] = "BINARY"] = 1;
        values[valuesById[2] = "CELL"] = 2;
        return values;
    })();

    return TonSignData;
})();

$root.TonSignedData = (function() {

    function TonSignedData(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    TonSignedData.prototype.signature = $util.newBuffer([]);
    TonSignedData.prototype.digest = $util.newBuffer([]);

    TonSignedData.create = function create(properties) {
        return new TonSignedData(properties);
    };

    TonSignedData.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.signature != null && Object.hasOwnProperty.call(message, "signature"))
            writer.uint32(10).bytes(message.signature);
        if (message.digest != null && Object.hasOwnProperty.call(message, "digest"))
            writer.uint32(18).bytes(message.digest);
        return writer;
    };

    TonSignedData.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    TonSignedData.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TonSignedData();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.signature = reader.bytes();
                break;
            case 2:
                message.digest = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    TonSignedData.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    TonSignedData.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.signature != null && message.hasOwnProperty("signature"))
            if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
                return "signature: buffer expected";
        if (message.digest != null && message.hasOwnProperty("digest"))
            if (!(message.digest && typeof message.digest.length === "number" || $util.isString(message.digest)))
                return "digest: buffer expected";
        return null;
    };

    TonSignedData.fromObject = function fromObject(object) {
        if (object instanceof $root.TonSignedData)
            return object;
        var message = new $root.TonSignedData();
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        if (object.digest != null)
            if (typeof object.digest === "string")
                $util.base64.decode(object.digest, message.digest = $util.newBuffer($util.base64.length(object.digest)), 0);
            else if (object.digest.length)
                message.digest = object.digest;
        return message;
    };

    TonSignedData.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
            if (options.bytes === String)
                object.digest = "";
            else {
                object.digest = [];
                if (options.bytes !== Array)
                    object.digest = $util.newBuffer(object.digest);
            }
        }
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        if (message.digest != null && message.hasOwnProperty("digest"))
            object.digest = options.bytes === String ? $util.base64.encode(message.digest, 0, message.digest.length) : options.bytes === Array ? Array.prototype.slice.call(message.digest) : message.digest;
        return object;
    };

    TonSignedData.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return TonSignedData;
})();

$root.TronGetAddress = (function() {

    function TronGetAddress(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    TronGetAddress.prototype.address_n = $util.emptyArray;
    TronGetAddress.prototype.show_display = false;

    TronGetAddress.create = function create(properties) {
        return new TronGetAddress(properties);
    };

    TronGetAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(16).bool(message.show_display);
        return writer;
    };

    TronGetAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    TronGetAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TronGetAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.show_display = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    TronGetAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    TronGetAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        return null;
    };

    TronGetAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.TronGetAddress)
            return object;
        var message = new $root.TronGetAddress();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".TronGetAddress.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        return message;
    };

    TronGetAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            object.show_display = false;
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        return object;
    };

    TronGetAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return TronGetAddress;
})();

$root.TronAddress = (function() {

    function TronAddress(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    TronAddress.prototype.address = "";

    TronAddress.create = function create(properties) {
        return new TronAddress(properties);
    };

    TronAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address != null && Object.hasOwnProperty.call(message, "address"))
            writer.uint32(10).string(message.address);
        return writer;
    };

    TronAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    TronAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TronAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    TronAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    TronAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address != null && message.hasOwnProperty("address"))
            if (!$util.isString(message.address))
                return "address: string expected";
        return null;
    };

    TronAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.TronAddress)
            return object;
        var message = new $root.TronAddress();
        if (object.address != null)
            message.address = String(object.address);
        return message;
    };

    TronAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.address = "";
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    TronAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return TronAddress;
})();

$root.TronSignTx = (function() {

    function TronSignTx(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    TronSignTx.prototype.address_n = $util.emptyArray;
    TronSignTx.prototype.ref_block_bytes = $util.newBuffer([]);
    TronSignTx.prototype.ref_block_hash = $util.newBuffer([]);
    TronSignTx.prototype.expiration = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    TronSignTx.prototype.data = $util.newBuffer([]);
    TronSignTx.prototype.contract = null;
    TronSignTx.prototype.timestamp = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    TronSignTx.prototype.fee_limit = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    TronSignTx.create = function create(properties) {
        return new TronSignTx(properties);
    };

    TronSignTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).bytes(message.ref_block_bytes);
        writer.uint32(26).bytes(message.ref_block_hash);
        writer.uint32(32).uint64(message.expiration);
        if (message.data != null && Object.hasOwnProperty.call(message, "data"))
            writer.uint32(42).bytes(message.data);
        $root.TronSignTx.TronContract.encode(message.contract, writer.uint32(50).fork()).ldelim();
        writer.uint32(56).uint64(message.timestamp);
        if (message.fee_limit != null && Object.hasOwnProperty.call(message, "fee_limit"))
            writer.uint32(64).uint64(message.fee_limit);
        return writer;
    };

    TronSignTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    TronSignTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TronSignTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.ref_block_bytes = reader.bytes();
                break;
            case 3:
                message.ref_block_hash = reader.bytes();
                break;
            case 4:
                message.expiration = reader.uint64();
                break;
            case 5:
                message.data = reader.bytes();
                break;
            case 6:
                message.contract = $root.TronSignTx.TronContract.decode(reader, reader.uint32());
                break;
            case 7:
                message.timestamp = reader.uint64();
                break;
            case 8:
                message.fee_limit = reader.uint64();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("ref_block_bytes"))
            throw $util.ProtocolError("missing required 'ref_block_bytes'", { instance: message });
        if (!message.hasOwnProperty("ref_block_hash"))
            throw $util.ProtocolError("missing required 'ref_block_hash'", { instance: message });
        if (!message.hasOwnProperty("expiration"))
            throw $util.ProtocolError("missing required 'expiration'", { instance: message });
        if (!message.hasOwnProperty("contract"))
            throw $util.ProtocolError("missing required 'contract'", { instance: message });
        if (!message.hasOwnProperty("timestamp"))
            throw $util.ProtocolError("missing required 'timestamp'", { instance: message });
        return message;
    };

    TronSignTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    TronSignTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!(message.ref_block_bytes && typeof message.ref_block_bytes.length === "number" || $util.isString(message.ref_block_bytes)))
            return "ref_block_bytes: buffer expected";
        if (!(message.ref_block_hash && typeof message.ref_block_hash.length === "number" || $util.isString(message.ref_block_hash)))
            return "ref_block_hash: buffer expected";
        if (!$util.isInteger(message.expiration) && !(message.expiration && $util.isInteger(message.expiration.low) && $util.isInteger(message.expiration.high)))
            return "expiration: integer|Long expected";
        if (message.data != null && message.hasOwnProperty("data"))
            if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
                return "data: buffer expected";
        {
            var error = $root.TronSignTx.TronContract.verify(message.contract);
            if (error)
                return "contract." + error;
        }
        if (!$util.isInteger(message.timestamp) && !(message.timestamp && $util.isInteger(message.timestamp.low) && $util.isInteger(message.timestamp.high)))
            return "timestamp: integer|Long expected";
        if (message.fee_limit != null && message.hasOwnProperty("fee_limit"))
            if (!$util.isInteger(message.fee_limit) && !(message.fee_limit && $util.isInteger(message.fee_limit.low) && $util.isInteger(message.fee_limit.high)))
                return "fee_limit: integer|Long expected";
        return null;
    };

    TronSignTx.fromObject = function fromObject(object) {
        if (object instanceof $root.TronSignTx)
            return object;
        var message = new $root.TronSignTx();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".TronSignTx.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.ref_block_bytes != null)
            if (typeof object.ref_block_bytes === "string")
                $util.base64.decode(object.ref_block_bytes, message.ref_block_bytes = $util.newBuffer($util.base64.length(object.ref_block_bytes)), 0);
            else if (object.ref_block_bytes.length)
                message.ref_block_bytes = object.ref_block_bytes;
        if (object.ref_block_hash != null)
            if (typeof object.ref_block_hash === "string")
                $util.base64.decode(object.ref_block_hash, message.ref_block_hash = $util.newBuffer($util.base64.length(object.ref_block_hash)), 0);
            else if (object.ref_block_hash.length)
                message.ref_block_hash = object.ref_block_hash;
        if (object.expiration != null)
            if ($util.Long)
                (message.expiration = $util.Long.fromValue(object.expiration)).unsigned = true;
            else if (typeof object.expiration === "string")
                message.expiration = parseInt(object.expiration, 10);
            else if (typeof object.expiration === "number")
                message.expiration = object.expiration;
            else if (typeof object.expiration === "object")
                message.expiration = new $util.LongBits(object.expiration.low >>> 0, object.expiration.high >>> 0).toNumber(true);
        if (object.data != null)
            if (typeof object.data === "string")
                $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
            else if (object.data.length)
                message.data = object.data;
        if (object.contract != null) {
            if (typeof object.contract !== "object")
                throw TypeError(".TronSignTx.contract: object expected");
            message.contract = $root.TronSignTx.TronContract.fromObject(object.contract);
        }
        if (object.timestamp != null)
            if ($util.Long)
                (message.timestamp = $util.Long.fromValue(object.timestamp)).unsigned = true;
            else if (typeof object.timestamp === "string")
                message.timestamp = parseInt(object.timestamp, 10);
            else if (typeof object.timestamp === "number")
                message.timestamp = object.timestamp;
            else if (typeof object.timestamp === "object")
                message.timestamp = new $util.LongBits(object.timestamp.low >>> 0, object.timestamp.high >>> 0).toNumber(true);
        if (object.fee_limit != null)
            if ($util.Long)
                (message.fee_limit = $util.Long.fromValue(object.fee_limit)).unsigned = true;
            else if (typeof object.fee_limit === "string")
                message.fee_limit = parseInt(object.fee_limit, 10);
            else if (typeof object.fee_limit === "number")
                message.fee_limit = object.fee_limit;
            else if (typeof object.fee_limit === "object")
                message.fee_limit = new $util.LongBits(object.fee_limit.low >>> 0, object.fee_limit.high >>> 0).toNumber(true);
        return message;
    };

    TronSignTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            if (options.bytes === String)
                object.ref_block_bytes = "";
            else {
                object.ref_block_bytes = [];
                if (options.bytes !== Array)
                    object.ref_block_bytes = $util.newBuffer(object.ref_block_bytes);
            }
            if (options.bytes === String)
                object.ref_block_hash = "";
            else {
                object.ref_block_hash = [];
                if (options.bytes !== Array)
                    object.ref_block_hash = $util.newBuffer(object.ref_block_hash);
            }
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.expiration = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.expiration = options.longs === String ? "0" : 0;
            if (options.bytes === String)
                object.data = "";
            else {
                object.data = [];
                if (options.bytes !== Array)
                    object.data = $util.newBuffer(object.data);
            }
            object.contract = null;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.timestamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.timestamp = options.longs === String ? "0" : 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.fee_limit = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.fee_limit = options.longs === String ? "0" : 0;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.ref_block_bytes != null && message.hasOwnProperty("ref_block_bytes"))
            object.ref_block_bytes = options.bytes === String ? $util.base64.encode(message.ref_block_bytes, 0, message.ref_block_bytes.length) : options.bytes === Array ? Array.prototype.slice.call(message.ref_block_bytes) : message.ref_block_bytes;
        if (message.ref_block_hash != null && message.hasOwnProperty("ref_block_hash"))
            object.ref_block_hash = options.bytes === String ? $util.base64.encode(message.ref_block_hash, 0, message.ref_block_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.ref_block_hash) : message.ref_block_hash;
        if (message.expiration != null && message.hasOwnProperty("expiration"))
            if (typeof message.expiration === "number")
                object.expiration = options.longs === String ? String(message.expiration) : message.expiration;
            else
                object.expiration = options.longs === String ? $util.Long.prototype.toString.call(message.expiration) : options.longs === Number ? new $util.LongBits(message.expiration.low >>> 0, message.expiration.high >>> 0).toNumber(true) : message.expiration;
        if (message.data != null && message.hasOwnProperty("data"))
            object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
        if (message.contract != null && message.hasOwnProperty("contract"))
            object.contract = $root.TronSignTx.TronContract.toObject(message.contract, options);
        if (message.timestamp != null && message.hasOwnProperty("timestamp"))
            if (typeof message.timestamp === "number")
                object.timestamp = options.longs === String ? String(message.timestamp) : message.timestamp;
            else
                object.timestamp = options.longs === String ? $util.Long.prototype.toString.call(message.timestamp) : options.longs === Number ? new $util.LongBits(message.timestamp.low >>> 0, message.timestamp.high >>> 0).toNumber(true) : message.timestamp;
        if (message.fee_limit != null && message.hasOwnProperty("fee_limit"))
            if (typeof message.fee_limit === "number")
                object.fee_limit = options.longs === String ? String(message.fee_limit) : message.fee_limit;
            else
                object.fee_limit = options.longs === String ? $util.Long.prototype.toString.call(message.fee_limit) : options.longs === Number ? new $util.LongBits(message.fee_limit.low >>> 0, message.fee_limit.high >>> 0).toNumber(true) : message.fee_limit;
        return object;
    };

    TronSignTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    TronSignTx.TronContract = (function() {

        function TronContract(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        TronContract.prototype.transfer_contract = null;
        TronContract.prototype.provider = $util.newBuffer([]);
        TronContract.prototype.vote_witness_contract = null;
        TronContract.prototype.contract_name = $util.newBuffer([]);
        TronContract.prototype.permission_id = 0;
        TronContract.prototype.freeze_balance_contract = null;
        TronContract.prototype.unfreeze_balance_contract = null;
        TronContract.prototype.withdraw_balance_contract = null;
        TronContract.prototype.trigger_smart_contract = null;
        TronContract.prototype.freeze_balance_v2_contract = null;
        TronContract.prototype.unfreeze_balance_v2_contract = null;
        TronContract.prototype.withdraw_expire_unfreeze_contract = null;
        TronContract.prototype.delegate_resource_contract = null;
        TronContract.prototype.undelegate_resource_contract = null;
        TronContract.prototype.cancel_all_unfreeze_v2_contract = null;

        TronContract.create = function create(properties) {
            return new TronContract(properties);
        };

        TronContract.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.transfer_contract != null && Object.hasOwnProperty.call(message, "transfer_contract"))
                $root.TronSignTx.TronContract.TronTransferContract.encode(message.transfer_contract, writer.uint32(18).fork()).ldelim();
            if (message.provider != null && Object.hasOwnProperty.call(message, "provider"))
                writer.uint32(26).bytes(message.provider);
            if (message.vote_witness_contract != null && Object.hasOwnProperty.call(message, "vote_witness_contract"))
                $root.TronSignTx.TronContract.TronVoteWitnessContract.encode(message.vote_witness_contract, writer.uint32(34).fork()).ldelim();
            if (message.contract_name != null && Object.hasOwnProperty.call(message, "contract_name"))
                writer.uint32(42).bytes(message.contract_name);
            if (message.permission_id != null && Object.hasOwnProperty.call(message, "permission_id"))
                writer.uint32(48).uint32(message.permission_id);
            if (message.freeze_balance_contract != null && Object.hasOwnProperty.call(message, "freeze_balance_contract"))
                $root.TronSignTx.TronContract.TronFreezeBalanceContract.encode(message.freeze_balance_contract, writer.uint32(90).fork()).ldelim();
            if (message.unfreeze_balance_contract != null && Object.hasOwnProperty.call(message, "unfreeze_balance_contract"))
                $root.TronSignTx.TronContract.TronUnfreezeBalanceContract.encode(message.unfreeze_balance_contract, writer.uint32(98).fork()).ldelim();
            if (message.withdraw_balance_contract != null && Object.hasOwnProperty.call(message, "withdraw_balance_contract"))
                $root.TronSignTx.TronContract.TronWithdrawBalanceContract.encode(message.withdraw_balance_contract, writer.uint32(106).fork()).ldelim();
            if (message.trigger_smart_contract != null && Object.hasOwnProperty.call(message, "trigger_smart_contract"))
                $root.TronSignTx.TronContract.TronTriggerSmartContract.encode(message.trigger_smart_contract, writer.uint32(250).fork()).ldelim();
            if (message.freeze_balance_v2_contract != null && Object.hasOwnProperty.call(message, "freeze_balance_v2_contract"))
                $root.TronSignTx.TronContract.TronFreezeBalanceV2Contract.encode(message.freeze_balance_v2_contract, writer.uint32(434).fork()).ldelim();
            if (message.unfreeze_balance_v2_contract != null && Object.hasOwnProperty.call(message, "unfreeze_balance_v2_contract"))
                $root.TronSignTx.TronContract.TronUnfreezeBalanceV2Contract.encode(message.unfreeze_balance_v2_contract, writer.uint32(442).fork()).ldelim();
            if (message.withdraw_expire_unfreeze_contract != null && Object.hasOwnProperty.call(message, "withdraw_expire_unfreeze_contract"))
                $root.TronSignTx.TronContract.TronWithdrawExpireUnfreezeContract.encode(message.withdraw_expire_unfreeze_contract, writer.uint32(450).fork()).ldelim();
            if (message.delegate_resource_contract != null && Object.hasOwnProperty.call(message, "delegate_resource_contract"))
                $root.TronSignTx.TronContract.TronDelegateResourceContract.encode(message.delegate_resource_contract, writer.uint32(458).fork()).ldelim();
            if (message.undelegate_resource_contract != null && Object.hasOwnProperty.call(message, "undelegate_resource_contract"))
                $root.TronSignTx.TronContract.TronUnDelegateResourceContract.encode(message.undelegate_resource_contract, writer.uint32(466).fork()).ldelim();
            if (message.cancel_all_unfreeze_v2_contract != null && Object.hasOwnProperty.call(message, "cancel_all_unfreeze_v2_contract"))
                $root.TronSignTx.TronContract.TronCancelAllUnfreezeV2Contract.encode(message.cancel_all_unfreeze_v2_contract, writer.uint32(474).fork()).ldelim();
            return writer;
        };

        TronContract.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        TronContract.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TronSignTx.TronContract();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 2:
                    message.transfer_contract = $root.TronSignTx.TronContract.TronTransferContract.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.provider = reader.bytes();
                    break;
                case 4:
                    message.vote_witness_contract = $root.TronSignTx.TronContract.TronVoteWitnessContract.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.contract_name = reader.bytes();
                    break;
                case 6:
                    message.permission_id = reader.uint32();
                    break;
                case 11:
                    message.freeze_balance_contract = $root.TronSignTx.TronContract.TronFreezeBalanceContract.decode(reader, reader.uint32());
                    break;
                case 12:
                    message.unfreeze_balance_contract = $root.TronSignTx.TronContract.TronUnfreezeBalanceContract.decode(reader, reader.uint32());
                    break;
                case 13:
                    message.withdraw_balance_contract = $root.TronSignTx.TronContract.TronWithdrawBalanceContract.decode(reader, reader.uint32());
                    break;
                case 31:
                    message.trigger_smart_contract = $root.TronSignTx.TronContract.TronTriggerSmartContract.decode(reader, reader.uint32());
                    break;
                case 54:
                    message.freeze_balance_v2_contract = $root.TronSignTx.TronContract.TronFreezeBalanceV2Contract.decode(reader, reader.uint32());
                    break;
                case 55:
                    message.unfreeze_balance_v2_contract = $root.TronSignTx.TronContract.TronUnfreezeBalanceV2Contract.decode(reader, reader.uint32());
                    break;
                case 56:
                    message.withdraw_expire_unfreeze_contract = $root.TronSignTx.TronContract.TronWithdrawExpireUnfreezeContract.decode(reader, reader.uint32());
                    break;
                case 57:
                    message.delegate_resource_contract = $root.TronSignTx.TronContract.TronDelegateResourceContract.decode(reader, reader.uint32());
                    break;
                case 58:
                    message.undelegate_resource_contract = $root.TronSignTx.TronContract.TronUnDelegateResourceContract.decode(reader, reader.uint32());
                    break;
                case 59:
                    message.cancel_all_unfreeze_v2_contract = $root.TronSignTx.TronContract.TronCancelAllUnfreezeV2Contract.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        TronContract.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        TronContract.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.transfer_contract != null && message.hasOwnProperty("transfer_contract")) {
                var error = $root.TronSignTx.TronContract.TronTransferContract.verify(message.transfer_contract);
                if (error)
                    return "transfer_contract." + error;
            }
            if (message.provider != null && message.hasOwnProperty("provider"))
                if (!(message.provider && typeof message.provider.length === "number" || $util.isString(message.provider)))
                    return "provider: buffer expected";
            if (message.vote_witness_contract != null && message.hasOwnProperty("vote_witness_contract")) {
                var error = $root.TronSignTx.TronContract.TronVoteWitnessContract.verify(message.vote_witness_contract);
                if (error)
                    return "vote_witness_contract." + error;
            }
            if (message.contract_name != null && message.hasOwnProperty("contract_name"))
                if (!(message.contract_name && typeof message.contract_name.length === "number" || $util.isString(message.contract_name)))
                    return "contract_name: buffer expected";
            if (message.permission_id != null && message.hasOwnProperty("permission_id"))
                if (!$util.isInteger(message.permission_id))
                    return "permission_id: integer expected";
            if (message.freeze_balance_contract != null && message.hasOwnProperty("freeze_balance_contract")) {
                var error = $root.TronSignTx.TronContract.TronFreezeBalanceContract.verify(message.freeze_balance_contract);
                if (error)
                    return "freeze_balance_contract." + error;
            }
            if (message.unfreeze_balance_contract != null && message.hasOwnProperty("unfreeze_balance_contract")) {
                var error = $root.TronSignTx.TronContract.TronUnfreezeBalanceContract.verify(message.unfreeze_balance_contract);
                if (error)
                    return "unfreeze_balance_contract." + error;
            }
            if (message.withdraw_balance_contract != null && message.hasOwnProperty("withdraw_balance_contract")) {
                var error = $root.TronSignTx.TronContract.TronWithdrawBalanceContract.verify(message.withdraw_balance_contract);
                if (error)
                    return "withdraw_balance_contract." + error;
            }
            if (message.trigger_smart_contract != null && message.hasOwnProperty("trigger_smart_contract")) {
                var error = $root.TronSignTx.TronContract.TronTriggerSmartContract.verify(message.trigger_smart_contract);
                if (error)
                    return "trigger_smart_contract." + error;
            }
            if (message.freeze_balance_v2_contract != null && message.hasOwnProperty("freeze_balance_v2_contract")) {
                var error = $root.TronSignTx.TronContract.TronFreezeBalanceV2Contract.verify(message.freeze_balance_v2_contract);
                if (error)
                    return "freeze_balance_v2_contract." + error;
            }
            if (message.unfreeze_balance_v2_contract != null && message.hasOwnProperty("unfreeze_balance_v2_contract")) {
                var error = $root.TronSignTx.TronContract.TronUnfreezeBalanceV2Contract.verify(message.unfreeze_balance_v2_contract);
                if (error)
                    return "unfreeze_balance_v2_contract." + error;
            }
            if (message.withdraw_expire_unfreeze_contract != null && message.hasOwnProperty("withdraw_expire_unfreeze_contract")) {
                var error = $root.TronSignTx.TronContract.TronWithdrawExpireUnfreezeContract.verify(message.withdraw_expire_unfreeze_contract);
                if (error)
                    return "withdraw_expire_unfreeze_contract." + error;
            }
            if (message.delegate_resource_contract != null && message.hasOwnProperty("delegate_resource_contract")) {
                var error = $root.TronSignTx.TronContract.TronDelegateResourceContract.verify(message.delegate_resource_contract);
                if (error)
                    return "delegate_resource_contract." + error;
            }
            if (message.undelegate_resource_contract != null && message.hasOwnProperty("undelegate_resource_contract")) {
                var error = $root.TronSignTx.TronContract.TronUnDelegateResourceContract.verify(message.undelegate_resource_contract);
                if (error)
                    return "undelegate_resource_contract." + error;
            }
            if (message.cancel_all_unfreeze_v2_contract != null && message.hasOwnProperty("cancel_all_unfreeze_v2_contract")) {
                var error = $root.TronSignTx.TronContract.TronCancelAllUnfreezeV2Contract.verify(message.cancel_all_unfreeze_v2_contract);
                if (error)
                    return "cancel_all_unfreeze_v2_contract." + error;
            }
            return null;
        };

        TronContract.fromObject = function fromObject(object) {
            if (object instanceof $root.TronSignTx.TronContract)
                return object;
            var message = new $root.TronSignTx.TronContract();
            if (object.transfer_contract != null) {
                if (typeof object.transfer_contract !== "object")
                    throw TypeError(".TronSignTx.TronContract.transfer_contract: object expected");
                message.transfer_contract = $root.TronSignTx.TronContract.TronTransferContract.fromObject(object.transfer_contract);
            }
            if (object.provider != null)
                if (typeof object.provider === "string")
                    $util.base64.decode(object.provider, message.provider = $util.newBuffer($util.base64.length(object.provider)), 0);
                else if (object.provider.length)
                    message.provider = object.provider;
            if (object.vote_witness_contract != null) {
                if (typeof object.vote_witness_contract !== "object")
                    throw TypeError(".TronSignTx.TronContract.vote_witness_contract: object expected");
                message.vote_witness_contract = $root.TronSignTx.TronContract.TronVoteWitnessContract.fromObject(object.vote_witness_contract);
            }
            if (object.contract_name != null)
                if (typeof object.contract_name === "string")
                    $util.base64.decode(object.contract_name, message.contract_name = $util.newBuffer($util.base64.length(object.contract_name)), 0);
                else if (object.contract_name.length)
                    message.contract_name = object.contract_name;
            if (object.permission_id != null)
                message.permission_id = object.permission_id >>> 0;
            if (object.freeze_balance_contract != null) {
                if (typeof object.freeze_balance_contract !== "object")
                    throw TypeError(".TronSignTx.TronContract.freeze_balance_contract: object expected");
                message.freeze_balance_contract = $root.TronSignTx.TronContract.TronFreezeBalanceContract.fromObject(object.freeze_balance_contract);
            }
            if (object.unfreeze_balance_contract != null) {
                if (typeof object.unfreeze_balance_contract !== "object")
                    throw TypeError(".TronSignTx.TronContract.unfreeze_balance_contract: object expected");
                message.unfreeze_balance_contract = $root.TronSignTx.TronContract.TronUnfreezeBalanceContract.fromObject(object.unfreeze_balance_contract);
            }
            if (object.withdraw_balance_contract != null) {
                if (typeof object.withdraw_balance_contract !== "object")
                    throw TypeError(".TronSignTx.TronContract.withdraw_balance_contract: object expected");
                message.withdraw_balance_contract = $root.TronSignTx.TronContract.TronWithdrawBalanceContract.fromObject(object.withdraw_balance_contract);
            }
            if (object.trigger_smart_contract != null) {
                if (typeof object.trigger_smart_contract !== "object")
                    throw TypeError(".TronSignTx.TronContract.trigger_smart_contract: object expected");
                message.trigger_smart_contract = $root.TronSignTx.TronContract.TronTriggerSmartContract.fromObject(object.trigger_smart_contract);
            }
            if (object.freeze_balance_v2_contract != null) {
                if (typeof object.freeze_balance_v2_contract !== "object")
                    throw TypeError(".TronSignTx.TronContract.freeze_balance_v2_contract: object expected");
                message.freeze_balance_v2_contract = $root.TronSignTx.TronContract.TronFreezeBalanceV2Contract.fromObject(object.freeze_balance_v2_contract);
            }
            if (object.unfreeze_balance_v2_contract != null) {
                if (typeof object.unfreeze_balance_v2_contract !== "object")
                    throw TypeError(".TronSignTx.TronContract.unfreeze_balance_v2_contract: object expected");
                message.unfreeze_balance_v2_contract = $root.TronSignTx.TronContract.TronUnfreezeBalanceV2Contract.fromObject(object.unfreeze_balance_v2_contract);
            }
            if (object.withdraw_expire_unfreeze_contract != null) {
                if (typeof object.withdraw_expire_unfreeze_contract !== "object")
                    throw TypeError(".TronSignTx.TronContract.withdraw_expire_unfreeze_contract: object expected");
                message.withdraw_expire_unfreeze_contract = $root.TronSignTx.TronContract.TronWithdrawExpireUnfreezeContract.fromObject(object.withdraw_expire_unfreeze_contract);
            }
            if (object.delegate_resource_contract != null) {
                if (typeof object.delegate_resource_contract !== "object")
                    throw TypeError(".TronSignTx.TronContract.delegate_resource_contract: object expected");
                message.delegate_resource_contract = $root.TronSignTx.TronContract.TronDelegateResourceContract.fromObject(object.delegate_resource_contract);
            }
            if (object.undelegate_resource_contract != null) {
                if (typeof object.undelegate_resource_contract !== "object")
                    throw TypeError(".TronSignTx.TronContract.undelegate_resource_contract: object expected");
                message.undelegate_resource_contract = $root.TronSignTx.TronContract.TronUnDelegateResourceContract.fromObject(object.undelegate_resource_contract);
            }
            if (object.cancel_all_unfreeze_v2_contract != null) {
                if (typeof object.cancel_all_unfreeze_v2_contract !== "object")
                    throw TypeError(".TronSignTx.TronContract.cancel_all_unfreeze_v2_contract: object expected");
                message.cancel_all_unfreeze_v2_contract = $root.TronSignTx.TronContract.TronCancelAllUnfreezeV2Contract.fromObject(object.cancel_all_unfreeze_v2_contract);
            }
            return message;
        };

        TronContract.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.transfer_contract = null;
                if (options.bytes === String)
                    object.provider = "";
                else {
                    object.provider = [];
                    if (options.bytes !== Array)
                        object.provider = $util.newBuffer(object.provider);
                }
                object.vote_witness_contract = null;
                if (options.bytes === String)
                    object.contract_name = "";
                else {
                    object.contract_name = [];
                    if (options.bytes !== Array)
                        object.contract_name = $util.newBuffer(object.contract_name);
                }
                object.permission_id = 0;
                object.freeze_balance_contract = null;
                object.unfreeze_balance_contract = null;
                object.withdraw_balance_contract = null;
                object.trigger_smart_contract = null;
                object.freeze_balance_v2_contract = null;
                object.unfreeze_balance_v2_contract = null;
                object.withdraw_expire_unfreeze_contract = null;
                object.delegate_resource_contract = null;
                object.undelegate_resource_contract = null;
                object.cancel_all_unfreeze_v2_contract = null;
            }
            if (message.transfer_contract != null && message.hasOwnProperty("transfer_contract"))
                object.transfer_contract = $root.TronSignTx.TronContract.TronTransferContract.toObject(message.transfer_contract, options);
            if (message.provider != null && message.hasOwnProperty("provider"))
                object.provider = options.bytes === String ? $util.base64.encode(message.provider, 0, message.provider.length) : options.bytes === Array ? Array.prototype.slice.call(message.provider) : message.provider;
            if (message.vote_witness_contract != null && message.hasOwnProperty("vote_witness_contract"))
                object.vote_witness_contract = $root.TronSignTx.TronContract.TronVoteWitnessContract.toObject(message.vote_witness_contract, options);
            if (message.contract_name != null && message.hasOwnProperty("contract_name"))
                object.contract_name = options.bytes === String ? $util.base64.encode(message.contract_name, 0, message.contract_name.length) : options.bytes === Array ? Array.prototype.slice.call(message.contract_name) : message.contract_name;
            if (message.permission_id != null && message.hasOwnProperty("permission_id"))
                object.permission_id = message.permission_id;
            if (message.freeze_balance_contract != null && message.hasOwnProperty("freeze_balance_contract"))
                object.freeze_balance_contract = $root.TronSignTx.TronContract.TronFreezeBalanceContract.toObject(message.freeze_balance_contract, options);
            if (message.unfreeze_balance_contract != null && message.hasOwnProperty("unfreeze_balance_contract"))
                object.unfreeze_balance_contract = $root.TronSignTx.TronContract.TronUnfreezeBalanceContract.toObject(message.unfreeze_balance_contract, options);
            if (message.withdraw_balance_contract != null && message.hasOwnProperty("withdraw_balance_contract"))
                object.withdraw_balance_contract = $root.TronSignTx.TronContract.TronWithdrawBalanceContract.toObject(message.withdraw_balance_contract, options);
            if (message.trigger_smart_contract != null && message.hasOwnProperty("trigger_smart_contract"))
                object.trigger_smart_contract = $root.TronSignTx.TronContract.TronTriggerSmartContract.toObject(message.trigger_smart_contract, options);
            if (message.freeze_balance_v2_contract != null && message.hasOwnProperty("freeze_balance_v2_contract"))
                object.freeze_balance_v2_contract = $root.TronSignTx.TronContract.TronFreezeBalanceV2Contract.toObject(message.freeze_balance_v2_contract, options);
            if (message.unfreeze_balance_v2_contract != null && message.hasOwnProperty("unfreeze_balance_v2_contract"))
                object.unfreeze_balance_v2_contract = $root.TronSignTx.TronContract.TronUnfreezeBalanceV2Contract.toObject(message.unfreeze_balance_v2_contract, options);
            if (message.withdraw_expire_unfreeze_contract != null && message.hasOwnProperty("withdraw_expire_unfreeze_contract"))
                object.withdraw_expire_unfreeze_contract = $root.TronSignTx.TronContract.TronWithdrawExpireUnfreezeContract.toObject(message.withdraw_expire_unfreeze_contract, options);
            if (message.delegate_resource_contract != null && message.hasOwnProperty("delegate_resource_contract"))
                object.delegate_resource_contract = $root.TronSignTx.TronContract.TronDelegateResourceContract.toObject(message.delegate_resource_contract, options);
            if (message.undelegate_resource_contract != null && message.hasOwnProperty("undelegate_resource_contract"))
                object.undelegate_resource_contract = $root.TronSignTx.TronContract.TronUnDelegateResourceContract.toObject(message.undelegate_resource_contract, options);
            if (message.cancel_all_unfreeze_v2_contract != null && message.hasOwnProperty("cancel_all_unfreeze_v2_contract"))
                object.cancel_all_unfreeze_v2_contract = $root.TronSignTx.TronContract.TronCancelAllUnfreezeV2Contract.toObject(message.cancel_all_unfreeze_v2_contract, options);
            return object;
        };

        TronContract.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        TronContract.TronTransferContract = (function() {

            function TronTransferContract(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            TronTransferContract.prototype.to_address = "";
            TronTransferContract.prototype.amount = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

            TronTransferContract.create = function create(properties) {
                return new TronTransferContract(properties);
            };

            TronTransferContract.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.to_address != null && Object.hasOwnProperty.call(message, "to_address"))
                    writer.uint32(18).string(message.to_address);
                if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
                    writer.uint32(24).uint64(message.amount);
                return writer;
            };

            TronTransferContract.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            TronTransferContract.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TronSignTx.TronContract.TronTransferContract();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 2:
                        message.to_address = reader.string();
                        break;
                    case 3:
                        message.amount = reader.uint64();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            TronTransferContract.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            TronTransferContract.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.to_address != null && message.hasOwnProperty("to_address"))
                    if (!$util.isString(message.to_address))
                        return "to_address: string expected";
                if (message.amount != null && message.hasOwnProperty("amount"))
                    if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
                        return "amount: integer|Long expected";
                return null;
            };

            TronTransferContract.fromObject = function fromObject(object) {
                if (object instanceof $root.TronSignTx.TronContract.TronTransferContract)
                    return object;
                var message = new $root.TronSignTx.TronContract.TronTransferContract();
                if (object.to_address != null)
                    message.to_address = String(object.to_address);
                if (object.amount != null)
                    if ($util.Long)
                        (message.amount = $util.Long.fromValue(object.amount)).unsigned = true;
                    else if (typeof object.amount === "string")
                        message.amount = parseInt(object.amount, 10);
                    else if (typeof object.amount === "number")
                        message.amount = object.amount;
                    else if (typeof object.amount === "object")
                        message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber(true);
                return message;
            };

            TronTransferContract.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.to_address = "";
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, true);
                        object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.amount = options.longs === String ? "0" : 0;
                }
                if (message.to_address != null && message.hasOwnProperty("to_address"))
                    object.to_address = message.to_address;
                if (message.amount != null && message.hasOwnProperty("amount"))
                    if (typeof message.amount === "number")
                        object.amount = options.longs === String ? String(message.amount) : message.amount;
                    else
                        object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber(true) : message.amount;
                return object;
            };

            TronTransferContract.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return TronTransferContract;
        })();

        TronContract.TronTriggerSmartContract = (function() {

            function TronTriggerSmartContract(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            TronTriggerSmartContract.prototype.contract_address = "";
            TronTriggerSmartContract.prototype.call_value = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
            TronTriggerSmartContract.prototype.data = $util.newBuffer([]);
            TronTriggerSmartContract.prototype.call_token_value = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
            TronTriggerSmartContract.prototype.asset_id = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

            TronTriggerSmartContract.create = function create(properties) {
                return new TronTriggerSmartContract(properties);
            };

            TronTriggerSmartContract.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.contract_address != null && Object.hasOwnProperty.call(message, "contract_address"))
                    writer.uint32(18).string(message.contract_address);
                if (message.call_value != null && Object.hasOwnProperty.call(message, "call_value"))
                    writer.uint32(24).uint64(message.call_value);
                if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                    writer.uint32(34).bytes(message.data);
                if (message.call_token_value != null && Object.hasOwnProperty.call(message, "call_token_value"))
                    writer.uint32(40).uint64(message.call_token_value);
                if (message.asset_id != null && Object.hasOwnProperty.call(message, "asset_id"))
                    writer.uint32(48).uint64(message.asset_id);
                return writer;
            };

            TronTriggerSmartContract.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            TronTriggerSmartContract.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TronSignTx.TronContract.TronTriggerSmartContract();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 2:
                        message.contract_address = reader.string();
                        break;
                    case 3:
                        message.call_value = reader.uint64();
                        break;
                    case 4:
                        message.data = reader.bytes();
                        break;
                    case 5:
                        message.call_token_value = reader.uint64();
                        break;
                    case 6:
                        message.asset_id = reader.uint64();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            TronTriggerSmartContract.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            TronTriggerSmartContract.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.contract_address != null && message.hasOwnProperty("contract_address"))
                    if (!$util.isString(message.contract_address))
                        return "contract_address: string expected";
                if (message.call_value != null && message.hasOwnProperty("call_value"))
                    if (!$util.isInteger(message.call_value) && !(message.call_value && $util.isInteger(message.call_value.low) && $util.isInteger(message.call_value.high)))
                        return "call_value: integer|Long expected";
                if (message.data != null && message.hasOwnProperty("data"))
                    if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
                        return "data: buffer expected";
                if (message.call_token_value != null && message.hasOwnProperty("call_token_value"))
                    if (!$util.isInteger(message.call_token_value) && !(message.call_token_value && $util.isInteger(message.call_token_value.low) && $util.isInteger(message.call_token_value.high)))
                        return "call_token_value: integer|Long expected";
                if (message.asset_id != null && message.hasOwnProperty("asset_id"))
                    if (!$util.isInteger(message.asset_id) && !(message.asset_id && $util.isInteger(message.asset_id.low) && $util.isInteger(message.asset_id.high)))
                        return "asset_id: integer|Long expected";
                return null;
            };

            TronTriggerSmartContract.fromObject = function fromObject(object) {
                if (object instanceof $root.TronSignTx.TronContract.TronTriggerSmartContract)
                    return object;
                var message = new $root.TronSignTx.TronContract.TronTriggerSmartContract();
                if (object.contract_address != null)
                    message.contract_address = String(object.contract_address);
                if (object.call_value != null)
                    if ($util.Long)
                        (message.call_value = $util.Long.fromValue(object.call_value)).unsigned = true;
                    else if (typeof object.call_value === "string")
                        message.call_value = parseInt(object.call_value, 10);
                    else if (typeof object.call_value === "number")
                        message.call_value = object.call_value;
                    else if (typeof object.call_value === "object")
                        message.call_value = new $util.LongBits(object.call_value.low >>> 0, object.call_value.high >>> 0).toNumber(true);
                if (object.data != null)
                    if (typeof object.data === "string")
                        $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
                    else if (object.data.length)
                        message.data = object.data;
                if (object.call_token_value != null)
                    if ($util.Long)
                        (message.call_token_value = $util.Long.fromValue(object.call_token_value)).unsigned = true;
                    else if (typeof object.call_token_value === "string")
                        message.call_token_value = parseInt(object.call_token_value, 10);
                    else if (typeof object.call_token_value === "number")
                        message.call_token_value = object.call_token_value;
                    else if (typeof object.call_token_value === "object")
                        message.call_token_value = new $util.LongBits(object.call_token_value.low >>> 0, object.call_token_value.high >>> 0).toNumber(true);
                if (object.asset_id != null)
                    if ($util.Long)
                        (message.asset_id = $util.Long.fromValue(object.asset_id)).unsigned = true;
                    else if (typeof object.asset_id === "string")
                        message.asset_id = parseInt(object.asset_id, 10);
                    else if (typeof object.asset_id === "number")
                        message.asset_id = object.asset_id;
                    else if (typeof object.asset_id === "object")
                        message.asset_id = new $util.LongBits(object.asset_id.low >>> 0, object.asset_id.high >>> 0).toNumber(true);
                return message;
            };

            TronTriggerSmartContract.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.contract_address = "";
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, true);
                        object.call_value = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.call_value = options.longs === String ? "0" : 0;
                    if (options.bytes === String)
                        object.data = "";
                    else {
                        object.data = [];
                        if (options.bytes !== Array)
                            object.data = $util.newBuffer(object.data);
                    }
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, true);
                        object.call_token_value = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.call_token_value = options.longs === String ? "0" : 0;
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, true);
                        object.asset_id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.asset_id = options.longs === String ? "0" : 0;
                }
                if (message.contract_address != null && message.hasOwnProperty("contract_address"))
                    object.contract_address = message.contract_address;
                if (message.call_value != null && message.hasOwnProperty("call_value"))
                    if (typeof message.call_value === "number")
                        object.call_value = options.longs === String ? String(message.call_value) : message.call_value;
                    else
                        object.call_value = options.longs === String ? $util.Long.prototype.toString.call(message.call_value) : options.longs === Number ? new $util.LongBits(message.call_value.low >>> 0, message.call_value.high >>> 0).toNumber(true) : message.call_value;
                if (message.data != null && message.hasOwnProperty("data"))
                    object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
                if (message.call_token_value != null && message.hasOwnProperty("call_token_value"))
                    if (typeof message.call_token_value === "number")
                        object.call_token_value = options.longs === String ? String(message.call_token_value) : message.call_token_value;
                    else
                        object.call_token_value = options.longs === String ? $util.Long.prototype.toString.call(message.call_token_value) : options.longs === Number ? new $util.LongBits(message.call_token_value.low >>> 0, message.call_token_value.high >>> 0).toNumber(true) : message.call_token_value;
                if (message.asset_id != null && message.hasOwnProperty("asset_id"))
                    if (typeof message.asset_id === "number")
                        object.asset_id = options.longs === String ? String(message.asset_id) : message.asset_id;
                    else
                        object.asset_id = options.longs === String ? $util.Long.prototype.toString.call(message.asset_id) : options.longs === Number ? new $util.LongBits(message.asset_id.low >>> 0, message.asset_id.high >>> 0).toNumber(true) : message.asset_id;
                return object;
            };

            TronTriggerSmartContract.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return TronTriggerSmartContract;
        })();

        TronContract.TronResourceCode = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "BANDWIDTH"] = 0;
            values[valuesById[1] = "ENERGY"] = 1;
            values[valuesById[2] = "TRON_POWER"] = 2;
            return values;
        })();

        TronContract.TronFreezeBalanceContract = (function() {

            function TronFreezeBalanceContract(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            TronFreezeBalanceContract.prototype.frozen_balance = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
            TronFreezeBalanceContract.prototype.frozen_duration = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
            TronFreezeBalanceContract.prototype.resource = 0;
            TronFreezeBalanceContract.prototype.receiver_address = "";

            TronFreezeBalanceContract.create = function create(properties) {
                return new TronFreezeBalanceContract(properties);
            };

            TronFreezeBalanceContract.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.frozen_balance != null && Object.hasOwnProperty.call(message, "frozen_balance"))
                    writer.uint32(8).uint64(message.frozen_balance);
                if (message.frozen_duration != null && Object.hasOwnProperty.call(message, "frozen_duration"))
                    writer.uint32(16).uint64(message.frozen_duration);
                if (message.resource != null && Object.hasOwnProperty.call(message, "resource"))
                    writer.uint32(24).int32(message.resource);
                if (message.receiver_address != null && Object.hasOwnProperty.call(message, "receiver_address"))
                    writer.uint32(34).string(message.receiver_address);
                return writer;
            };

            TronFreezeBalanceContract.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            TronFreezeBalanceContract.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TronSignTx.TronContract.TronFreezeBalanceContract();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.frozen_balance = reader.uint64();
                        break;
                    case 2:
                        message.frozen_duration = reader.uint64();
                        break;
                    case 3:
                        message.resource = reader.int32();
                        break;
                    case 4:
                        message.receiver_address = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            TronFreezeBalanceContract.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            TronFreezeBalanceContract.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.frozen_balance != null && message.hasOwnProperty("frozen_balance"))
                    if (!$util.isInteger(message.frozen_balance) && !(message.frozen_balance && $util.isInteger(message.frozen_balance.low) && $util.isInteger(message.frozen_balance.high)))
                        return "frozen_balance: integer|Long expected";
                if (message.frozen_duration != null && message.hasOwnProperty("frozen_duration"))
                    if (!$util.isInteger(message.frozen_duration) && !(message.frozen_duration && $util.isInteger(message.frozen_duration.low) && $util.isInteger(message.frozen_duration.high)))
                        return "frozen_duration: integer|Long expected";
                if (message.resource != null && message.hasOwnProperty("resource"))
                    switch (message.resource) {
                    default:
                        return "resource: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                        break;
                    }
                if (message.receiver_address != null && message.hasOwnProperty("receiver_address"))
                    if (!$util.isString(message.receiver_address))
                        return "receiver_address: string expected";
                return null;
            };

            TronFreezeBalanceContract.fromObject = function fromObject(object) {
                if (object instanceof $root.TronSignTx.TronContract.TronFreezeBalanceContract)
                    return object;
                var message = new $root.TronSignTx.TronContract.TronFreezeBalanceContract();
                if (object.frozen_balance != null)
                    if ($util.Long)
                        (message.frozen_balance = $util.Long.fromValue(object.frozen_balance)).unsigned = true;
                    else if (typeof object.frozen_balance === "string")
                        message.frozen_balance = parseInt(object.frozen_balance, 10);
                    else if (typeof object.frozen_balance === "number")
                        message.frozen_balance = object.frozen_balance;
                    else if (typeof object.frozen_balance === "object")
                        message.frozen_balance = new $util.LongBits(object.frozen_balance.low >>> 0, object.frozen_balance.high >>> 0).toNumber(true);
                if (object.frozen_duration != null)
                    if ($util.Long)
                        (message.frozen_duration = $util.Long.fromValue(object.frozen_duration)).unsigned = true;
                    else if (typeof object.frozen_duration === "string")
                        message.frozen_duration = parseInt(object.frozen_duration, 10);
                    else if (typeof object.frozen_duration === "number")
                        message.frozen_duration = object.frozen_duration;
                    else if (typeof object.frozen_duration === "object")
                        message.frozen_duration = new $util.LongBits(object.frozen_duration.low >>> 0, object.frozen_duration.high >>> 0).toNumber(true);
                switch (object.resource) {
                case "BANDWIDTH":
                case 0:
                    message.resource = 0;
                    break;
                case "ENERGY":
                case 1:
                    message.resource = 1;
                    break;
                case "TRON_POWER":
                case 2:
                    message.resource = 2;
                    break;
                }
                if (object.receiver_address != null)
                    message.receiver_address = String(object.receiver_address);
                return message;
            };

            TronFreezeBalanceContract.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, true);
                        object.frozen_balance = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.frozen_balance = options.longs === String ? "0" : 0;
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, true);
                        object.frozen_duration = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.frozen_duration = options.longs === String ? "0" : 0;
                    object.resource = options.enums === String ? "BANDWIDTH" : 0;
                    object.receiver_address = "";
                }
                if (message.frozen_balance != null && message.hasOwnProperty("frozen_balance"))
                    if (typeof message.frozen_balance === "number")
                        object.frozen_balance = options.longs === String ? String(message.frozen_balance) : message.frozen_balance;
                    else
                        object.frozen_balance = options.longs === String ? $util.Long.prototype.toString.call(message.frozen_balance) : options.longs === Number ? new $util.LongBits(message.frozen_balance.low >>> 0, message.frozen_balance.high >>> 0).toNumber(true) : message.frozen_balance;
                if (message.frozen_duration != null && message.hasOwnProperty("frozen_duration"))
                    if (typeof message.frozen_duration === "number")
                        object.frozen_duration = options.longs === String ? String(message.frozen_duration) : message.frozen_duration;
                    else
                        object.frozen_duration = options.longs === String ? $util.Long.prototype.toString.call(message.frozen_duration) : options.longs === Number ? new $util.LongBits(message.frozen_duration.low >>> 0, message.frozen_duration.high >>> 0).toNumber(true) : message.frozen_duration;
                if (message.resource != null && message.hasOwnProperty("resource"))
                    object.resource = options.enums === String ? $root.TronSignTx.TronContract.TronResourceCode[message.resource] : message.resource;
                if (message.receiver_address != null && message.hasOwnProperty("receiver_address"))
                    object.receiver_address = message.receiver_address;
                return object;
            };

            TronFreezeBalanceContract.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return TronFreezeBalanceContract;
        })();

        TronContract.TronUnfreezeBalanceContract = (function() {

            function TronUnfreezeBalanceContract(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            TronUnfreezeBalanceContract.prototype.resource = 0;
            TronUnfreezeBalanceContract.prototype.receiver_address = "";

            TronUnfreezeBalanceContract.create = function create(properties) {
                return new TronUnfreezeBalanceContract(properties);
            };

            TronUnfreezeBalanceContract.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.resource != null && Object.hasOwnProperty.call(message, "resource"))
                    writer.uint32(8).int32(message.resource);
                if (message.receiver_address != null && Object.hasOwnProperty.call(message, "receiver_address"))
                    writer.uint32(18).string(message.receiver_address);
                return writer;
            };

            TronUnfreezeBalanceContract.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            TronUnfreezeBalanceContract.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TronSignTx.TronContract.TronUnfreezeBalanceContract();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.resource = reader.int32();
                        break;
                    case 2:
                        message.receiver_address = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            TronUnfreezeBalanceContract.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            TronUnfreezeBalanceContract.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.resource != null && message.hasOwnProperty("resource"))
                    switch (message.resource) {
                    default:
                        return "resource: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                        break;
                    }
                if (message.receiver_address != null && message.hasOwnProperty("receiver_address"))
                    if (!$util.isString(message.receiver_address))
                        return "receiver_address: string expected";
                return null;
            };

            TronUnfreezeBalanceContract.fromObject = function fromObject(object) {
                if (object instanceof $root.TronSignTx.TronContract.TronUnfreezeBalanceContract)
                    return object;
                var message = new $root.TronSignTx.TronContract.TronUnfreezeBalanceContract();
                switch (object.resource) {
                case "BANDWIDTH":
                case 0:
                    message.resource = 0;
                    break;
                case "ENERGY":
                case 1:
                    message.resource = 1;
                    break;
                case "TRON_POWER":
                case 2:
                    message.resource = 2;
                    break;
                }
                if (object.receiver_address != null)
                    message.receiver_address = String(object.receiver_address);
                return message;
            };

            TronUnfreezeBalanceContract.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.resource = options.enums === String ? "BANDWIDTH" : 0;
                    object.receiver_address = "";
                }
                if (message.resource != null && message.hasOwnProperty("resource"))
                    object.resource = options.enums === String ? $root.TronSignTx.TronContract.TronResourceCode[message.resource] : message.resource;
                if (message.receiver_address != null && message.hasOwnProperty("receiver_address"))
                    object.receiver_address = message.receiver_address;
                return object;
            };

            TronUnfreezeBalanceContract.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return TronUnfreezeBalanceContract;
        })();

        TronContract.TronWithdrawBalanceContract = (function() {

            function TronWithdrawBalanceContract(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            TronWithdrawBalanceContract.prototype.owner_address = $util.newBuffer([]);

            TronWithdrawBalanceContract.create = function create(properties) {
                return new TronWithdrawBalanceContract(properties);
            };

            TronWithdrawBalanceContract.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.owner_address != null && Object.hasOwnProperty.call(message, "owner_address"))
                    writer.uint32(10).bytes(message.owner_address);
                return writer;
            };

            TronWithdrawBalanceContract.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            TronWithdrawBalanceContract.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TronSignTx.TronContract.TronWithdrawBalanceContract();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.owner_address = reader.bytes();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            TronWithdrawBalanceContract.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            TronWithdrawBalanceContract.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.owner_address != null && message.hasOwnProperty("owner_address"))
                    if (!(message.owner_address && typeof message.owner_address.length === "number" || $util.isString(message.owner_address)))
                        return "owner_address: buffer expected";
                return null;
            };

            TronWithdrawBalanceContract.fromObject = function fromObject(object) {
                if (object instanceof $root.TronSignTx.TronContract.TronWithdrawBalanceContract)
                    return object;
                var message = new $root.TronSignTx.TronContract.TronWithdrawBalanceContract();
                if (object.owner_address != null)
                    if (typeof object.owner_address === "string")
                        $util.base64.decode(object.owner_address, message.owner_address = $util.newBuffer($util.base64.length(object.owner_address)), 0);
                    else if (object.owner_address.length)
                        message.owner_address = object.owner_address;
                return message;
            };

            TronWithdrawBalanceContract.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults)
                    if (options.bytes === String)
                        object.owner_address = "";
                    else {
                        object.owner_address = [];
                        if (options.bytes !== Array)
                            object.owner_address = $util.newBuffer(object.owner_address);
                    }
                if (message.owner_address != null && message.hasOwnProperty("owner_address"))
                    object.owner_address = options.bytes === String ? $util.base64.encode(message.owner_address, 0, message.owner_address.length) : options.bytes === Array ? Array.prototype.slice.call(message.owner_address) : message.owner_address;
                return object;
            };

            TronWithdrawBalanceContract.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return TronWithdrawBalanceContract;
        })();

        TronContract.TronFreezeBalanceV2Contract = (function() {

            function TronFreezeBalanceV2Contract(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            TronFreezeBalanceV2Contract.prototype.frozen_balance = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
            TronFreezeBalanceV2Contract.prototype.resource = 0;

            TronFreezeBalanceV2Contract.create = function create(properties) {
                return new TronFreezeBalanceV2Contract(properties);
            };

            TronFreezeBalanceV2Contract.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.frozen_balance != null && Object.hasOwnProperty.call(message, "frozen_balance"))
                    writer.uint32(16).uint64(message.frozen_balance);
                if (message.resource != null && Object.hasOwnProperty.call(message, "resource"))
                    writer.uint32(24).int32(message.resource);
                return writer;
            };

            TronFreezeBalanceV2Contract.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            TronFreezeBalanceV2Contract.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TronSignTx.TronContract.TronFreezeBalanceV2Contract();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 2:
                        message.frozen_balance = reader.uint64();
                        break;
                    case 3:
                        message.resource = reader.int32();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            TronFreezeBalanceV2Contract.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            TronFreezeBalanceV2Contract.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.frozen_balance != null && message.hasOwnProperty("frozen_balance"))
                    if (!$util.isInteger(message.frozen_balance) && !(message.frozen_balance && $util.isInteger(message.frozen_balance.low) && $util.isInteger(message.frozen_balance.high)))
                        return "frozen_balance: integer|Long expected";
                if (message.resource != null && message.hasOwnProperty("resource"))
                    switch (message.resource) {
                    default:
                        return "resource: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                        break;
                    }
                return null;
            };

            TronFreezeBalanceV2Contract.fromObject = function fromObject(object) {
                if (object instanceof $root.TronSignTx.TronContract.TronFreezeBalanceV2Contract)
                    return object;
                var message = new $root.TronSignTx.TronContract.TronFreezeBalanceV2Contract();
                if (object.frozen_balance != null)
                    if ($util.Long)
                        (message.frozen_balance = $util.Long.fromValue(object.frozen_balance)).unsigned = true;
                    else if (typeof object.frozen_balance === "string")
                        message.frozen_balance = parseInt(object.frozen_balance, 10);
                    else if (typeof object.frozen_balance === "number")
                        message.frozen_balance = object.frozen_balance;
                    else if (typeof object.frozen_balance === "object")
                        message.frozen_balance = new $util.LongBits(object.frozen_balance.low >>> 0, object.frozen_balance.high >>> 0).toNumber(true);
                switch (object.resource) {
                case "BANDWIDTH":
                case 0:
                    message.resource = 0;
                    break;
                case "ENERGY":
                case 1:
                    message.resource = 1;
                    break;
                case "TRON_POWER":
                case 2:
                    message.resource = 2;
                    break;
                }
                return message;
            };

            TronFreezeBalanceV2Contract.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, true);
                        object.frozen_balance = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.frozen_balance = options.longs === String ? "0" : 0;
                    object.resource = options.enums === String ? "BANDWIDTH" : 0;
                }
                if (message.frozen_balance != null && message.hasOwnProperty("frozen_balance"))
                    if (typeof message.frozen_balance === "number")
                        object.frozen_balance = options.longs === String ? String(message.frozen_balance) : message.frozen_balance;
                    else
                        object.frozen_balance = options.longs === String ? $util.Long.prototype.toString.call(message.frozen_balance) : options.longs === Number ? new $util.LongBits(message.frozen_balance.low >>> 0, message.frozen_balance.high >>> 0).toNumber(true) : message.frozen_balance;
                if (message.resource != null && message.hasOwnProperty("resource"))
                    object.resource = options.enums === String ? $root.TronSignTx.TronContract.TronResourceCode[message.resource] : message.resource;
                return object;
            };

            TronFreezeBalanceV2Contract.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return TronFreezeBalanceV2Contract;
        })();

        TronContract.TronUnfreezeBalanceV2Contract = (function() {

            function TronUnfreezeBalanceV2Contract(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            TronUnfreezeBalanceV2Contract.prototype.unfreeze_balance = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
            TronUnfreezeBalanceV2Contract.prototype.resource = 0;

            TronUnfreezeBalanceV2Contract.create = function create(properties) {
                return new TronUnfreezeBalanceV2Contract(properties);
            };

            TronUnfreezeBalanceV2Contract.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.unfreeze_balance != null && Object.hasOwnProperty.call(message, "unfreeze_balance"))
                    writer.uint32(16).uint64(message.unfreeze_balance);
                if (message.resource != null && Object.hasOwnProperty.call(message, "resource"))
                    writer.uint32(24).int32(message.resource);
                return writer;
            };

            TronUnfreezeBalanceV2Contract.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            TronUnfreezeBalanceV2Contract.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TronSignTx.TronContract.TronUnfreezeBalanceV2Contract();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 2:
                        message.unfreeze_balance = reader.uint64();
                        break;
                    case 3:
                        message.resource = reader.int32();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            TronUnfreezeBalanceV2Contract.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            TronUnfreezeBalanceV2Contract.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.unfreeze_balance != null && message.hasOwnProperty("unfreeze_balance"))
                    if (!$util.isInteger(message.unfreeze_balance) && !(message.unfreeze_balance && $util.isInteger(message.unfreeze_balance.low) && $util.isInteger(message.unfreeze_balance.high)))
                        return "unfreeze_balance: integer|Long expected";
                if (message.resource != null && message.hasOwnProperty("resource"))
                    switch (message.resource) {
                    default:
                        return "resource: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                        break;
                    }
                return null;
            };

            TronUnfreezeBalanceV2Contract.fromObject = function fromObject(object) {
                if (object instanceof $root.TronSignTx.TronContract.TronUnfreezeBalanceV2Contract)
                    return object;
                var message = new $root.TronSignTx.TronContract.TronUnfreezeBalanceV2Contract();
                if (object.unfreeze_balance != null)
                    if ($util.Long)
                        (message.unfreeze_balance = $util.Long.fromValue(object.unfreeze_balance)).unsigned = true;
                    else if (typeof object.unfreeze_balance === "string")
                        message.unfreeze_balance = parseInt(object.unfreeze_balance, 10);
                    else if (typeof object.unfreeze_balance === "number")
                        message.unfreeze_balance = object.unfreeze_balance;
                    else if (typeof object.unfreeze_balance === "object")
                        message.unfreeze_balance = new $util.LongBits(object.unfreeze_balance.low >>> 0, object.unfreeze_balance.high >>> 0).toNumber(true);
                switch (object.resource) {
                case "BANDWIDTH":
                case 0:
                    message.resource = 0;
                    break;
                case "ENERGY":
                case 1:
                    message.resource = 1;
                    break;
                case "TRON_POWER":
                case 2:
                    message.resource = 2;
                    break;
                }
                return message;
            };

            TronUnfreezeBalanceV2Contract.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, true);
                        object.unfreeze_balance = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.unfreeze_balance = options.longs === String ? "0" : 0;
                    object.resource = options.enums === String ? "BANDWIDTH" : 0;
                }
                if (message.unfreeze_balance != null && message.hasOwnProperty("unfreeze_balance"))
                    if (typeof message.unfreeze_balance === "number")
                        object.unfreeze_balance = options.longs === String ? String(message.unfreeze_balance) : message.unfreeze_balance;
                    else
                        object.unfreeze_balance = options.longs === String ? $util.Long.prototype.toString.call(message.unfreeze_balance) : options.longs === Number ? new $util.LongBits(message.unfreeze_balance.low >>> 0, message.unfreeze_balance.high >>> 0).toNumber(true) : message.unfreeze_balance;
                if (message.resource != null && message.hasOwnProperty("resource"))
                    object.resource = options.enums === String ? $root.TronSignTx.TronContract.TronResourceCode[message.resource] : message.resource;
                return object;
            };

            TronUnfreezeBalanceV2Contract.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return TronUnfreezeBalanceV2Contract;
        })();

        TronContract.TronWithdrawExpireUnfreezeContract = (function() {

            function TronWithdrawExpireUnfreezeContract(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            TronWithdrawExpireUnfreezeContract.create = function create(properties) {
                return new TronWithdrawExpireUnfreezeContract(properties);
            };

            TronWithdrawExpireUnfreezeContract.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            TronWithdrawExpireUnfreezeContract.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            TronWithdrawExpireUnfreezeContract.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TronSignTx.TronContract.TronWithdrawExpireUnfreezeContract();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            TronWithdrawExpireUnfreezeContract.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            TronWithdrawExpireUnfreezeContract.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            TronWithdrawExpireUnfreezeContract.fromObject = function fromObject(object) {
                if (object instanceof $root.TronSignTx.TronContract.TronWithdrawExpireUnfreezeContract)
                    return object;
                return new $root.TronSignTx.TronContract.TronWithdrawExpireUnfreezeContract();
            };

            TronWithdrawExpireUnfreezeContract.toObject = function toObject() {
                return {};
            };

            TronWithdrawExpireUnfreezeContract.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return TronWithdrawExpireUnfreezeContract;
        })();

        TronContract.TronDelegateResourceContract = (function() {

            function TronDelegateResourceContract(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            TronDelegateResourceContract.prototype.resource = 0;
            TronDelegateResourceContract.prototype.balance = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
            TronDelegateResourceContract.prototype.receiver_address = "";
            TronDelegateResourceContract.prototype.lock = false;
            TronDelegateResourceContract.prototype.lock_period = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

            TronDelegateResourceContract.create = function create(properties) {
                return new TronDelegateResourceContract(properties);
            };

            TronDelegateResourceContract.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.resource != null && Object.hasOwnProperty.call(message, "resource"))
                    writer.uint32(16).int32(message.resource);
                if (message.balance != null && Object.hasOwnProperty.call(message, "balance"))
                    writer.uint32(24).uint64(message.balance);
                if (message.receiver_address != null && Object.hasOwnProperty.call(message, "receiver_address"))
                    writer.uint32(34).string(message.receiver_address);
                if (message.lock != null && Object.hasOwnProperty.call(message, "lock"))
                    writer.uint32(40).bool(message.lock);
                if (message.lock_period != null && Object.hasOwnProperty.call(message, "lock_period"))
                    writer.uint32(48).uint64(message.lock_period);
                return writer;
            };

            TronDelegateResourceContract.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            TronDelegateResourceContract.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TronSignTx.TronContract.TronDelegateResourceContract();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 2:
                        message.resource = reader.int32();
                        break;
                    case 3:
                        message.balance = reader.uint64();
                        break;
                    case 4:
                        message.receiver_address = reader.string();
                        break;
                    case 5:
                        message.lock = reader.bool();
                        break;
                    case 6:
                        message.lock_period = reader.uint64();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            TronDelegateResourceContract.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            TronDelegateResourceContract.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.resource != null && message.hasOwnProperty("resource"))
                    switch (message.resource) {
                    default:
                        return "resource: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                        break;
                    }
                if (message.balance != null && message.hasOwnProperty("balance"))
                    if (!$util.isInteger(message.balance) && !(message.balance && $util.isInteger(message.balance.low) && $util.isInteger(message.balance.high)))
                        return "balance: integer|Long expected";
                if (message.receiver_address != null && message.hasOwnProperty("receiver_address"))
                    if (!$util.isString(message.receiver_address))
                        return "receiver_address: string expected";
                if (message.lock != null && message.hasOwnProperty("lock"))
                    if (typeof message.lock !== "boolean")
                        return "lock: boolean expected";
                if (message.lock_period != null && message.hasOwnProperty("lock_period"))
                    if (!$util.isInteger(message.lock_period) && !(message.lock_period && $util.isInteger(message.lock_period.low) && $util.isInteger(message.lock_period.high)))
                        return "lock_period: integer|Long expected";
                return null;
            };

            TronDelegateResourceContract.fromObject = function fromObject(object) {
                if (object instanceof $root.TronSignTx.TronContract.TronDelegateResourceContract)
                    return object;
                var message = new $root.TronSignTx.TronContract.TronDelegateResourceContract();
                switch (object.resource) {
                case "BANDWIDTH":
                case 0:
                    message.resource = 0;
                    break;
                case "ENERGY":
                case 1:
                    message.resource = 1;
                    break;
                case "TRON_POWER":
                case 2:
                    message.resource = 2;
                    break;
                }
                if (object.balance != null)
                    if ($util.Long)
                        (message.balance = $util.Long.fromValue(object.balance)).unsigned = true;
                    else if (typeof object.balance === "string")
                        message.balance = parseInt(object.balance, 10);
                    else if (typeof object.balance === "number")
                        message.balance = object.balance;
                    else if (typeof object.balance === "object")
                        message.balance = new $util.LongBits(object.balance.low >>> 0, object.balance.high >>> 0).toNumber(true);
                if (object.receiver_address != null)
                    message.receiver_address = String(object.receiver_address);
                if (object.lock != null)
                    message.lock = Boolean(object.lock);
                if (object.lock_period != null)
                    if ($util.Long)
                        (message.lock_period = $util.Long.fromValue(object.lock_period)).unsigned = true;
                    else if (typeof object.lock_period === "string")
                        message.lock_period = parseInt(object.lock_period, 10);
                    else if (typeof object.lock_period === "number")
                        message.lock_period = object.lock_period;
                    else if (typeof object.lock_period === "object")
                        message.lock_period = new $util.LongBits(object.lock_period.low >>> 0, object.lock_period.high >>> 0).toNumber(true);
                return message;
            };

            TronDelegateResourceContract.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.resource = options.enums === String ? "BANDWIDTH" : 0;
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, true);
                        object.balance = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.balance = options.longs === String ? "0" : 0;
                    object.receiver_address = "";
                    object.lock = false;
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, true);
                        object.lock_period = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.lock_period = options.longs === String ? "0" : 0;
                }
                if (message.resource != null && message.hasOwnProperty("resource"))
                    object.resource = options.enums === String ? $root.TronSignTx.TronContract.TronResourceCode[message.resource] : message.resource;
                if (message.balance != null && message.hasOwnProperty("balance"))
                    if (typeof message.balance === "number")
                        object.balance = options.longs === String ? String(message.balance) : message.balance;
                    else
                        object.balance = options.longs === String ? $util.Long.prototype.toString.call(message.balance) : options.longs === Number ? new $util.LongBits(message.balance.low >>> 0, message.balance.high >>> 0).toNumber(true) : message.balance;
                if (message.receiver_address != null && message.hasOwnProperty("receiver_address"))
                    object.receiver_address = message.receiver_address;
                if (message.lock != null && message.hasOwnProperty("lock"))
                    object.lock = message.lock;
                if (message.lock_period != null && message.hasOwnProperty("lock_period"))
                    if (typeof message.lock_period === "number")
                        object.lock_period = options.longs === String ? String(message.lock_period) : message.lock_period;
                    else
                        object.lock_period = options.longs === String ? $util.Long.prototype.toString.call(message.lock_period) : options.longs === Number ? new $util.LongBits(message.lock_period.low >>> 0, message.lock_period.high >>> 0).toNumber(true) : message.lock_period;
                return object;
            };

            TronDelegateResourceContract.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return TronDelegateResourceContract;
        })();

        TronContract.TronUnDelegateResourceContract = (function() {

            function TronUnDelegateResourceContract(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            TronUnDelegateResourceContract.prototype.resource = 0;
            TronUnDelegateResourceContract.prototype.balance = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
            TronUnDelegateResourceContract.prototype.receiver_address = "";

            TronUnDelegateResourceContract.create = function create(properties) {
                return new TronUnDelegateResourceContract(properties);
            };

            TronUnDelegateResourceContract.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.resource != null && Object.hasOwnProperty.call(message, "resource"))
                    writer.uint32(16).int32(message.resource);
                if (message.balance != null && Object.hasOwnProperty.call(message, "balance"))
                    writer.uint32(24).uint64(message.balance);
                if (message.receiver_address != null && Object.hasOwnProperty.call(message, "receiver_address"))
                    writer.uint32(34).string(message.receiver_address);
                return writer;
            };

            TronUnDelegateResourceContract.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            TronUnDelegateResourceContract.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TronSignTx.TronContract.TronUnDelegateResourceContract();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 2:
                        message.resource = reader.int32();
                        break;
                    case 3:
                        message.balance = reader.uint64();
                        break;
                    case 4:
                        message.receiver_address = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            TronUnDelegateResourceContract.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            TronUnDelegateResourceContract.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.resource != null && message.hasOwnProperty("resource"))
                    switch (message.resource) {
                    default:
                        return "resource: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                        break;
                    }
                if (message.balance != null && message.hasOwnProperty("balance"))
                    if (!$util.isInteger(message.balance) && !(message.balance && $util.isInteger(message.balance.low) && $util.isInteger(message.balance.high)))
                        return "balance: integer|Long expected";
                if (message.receiver_address != null && message.hasOwnProperty("receiver_address"))
                    if (!$util.isString(message.receiver_address))
                        return "receiver_address: string expected";
                return null;
            };

            TronUnDelegateResourceContract.fromObject = function fromObject(object) {
                if (object instanceof $root.TronSignTx.TronContract.TronUnDelegateResourceContract)
                    return object;
                var message = new $root.TronSignTx.TronContract.TronUnDelegateResourceContract();
                switch (object.resource) {
                case "BANDWIDTH":
                case 0:
                    message.resource = 0;
                    break;
                case "ENERGY":
                case 1:
                    message.resource = 1;
                    break;
                case "TRON_POWER":
                case 2:
                    message.resource = 2;
                    break;
                }
                if (object.balance != null)
                    if ($util.Long)
                        (message.balance = $util.Long.fromValue(object.balance)).unsigned = true;
                    else if (typeof object.balance === "string")
                        message.balance = parseInt(object.balance, 10);
                    else if (typeof object.balance === "number")
                        message.balance = object.balance;
                    else if (typeof object.balance === "object")
                        message.balance = new $util.LongBits(object.balance.low >>> 0, object.balance.high >>> 0).toNumber(true);
                if (object.receiver_address != null)
                    message.receiver_address = String(object.receiver_address);
                return message;
            };

            TronUnDelegateResourceContract.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.resource = options.enums === String ? "BANDWIDTH" : 0;
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, true);
                        object.balance = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.balance = options.longs === String ? "0" : 0;
                    object.receiver_address = "";
                }
                if (message.resource != null && message.hasOwnProperty("resource"))
                    object.resource = options.enums === String ? $root.TronSignTx.TronContract.TronResourceCode[message.resource] : message.resource;
                if (message.balance != null && message.hasOwnProperty("balance"))
                    if (typeof message.balance === "number")
                        object.balance = options.longs === String ? String(message.balance) : message.balance;
                    else
                        object.balance = options.longs === String ? $util.Long.prototype.toString.call(message.balance) : options.longs === Number ? new $util.LongBits(message.balance.low >>> 0, message.balance.high >>> 0).toNumber(true) : message.balance;
                if (message.receiver_address != null && message.hasOwnProperty("receiver_address"))
                    object.receiver_address = message.receiver_address;
                return object;
            };

            TronUnDelegateResourceContract.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return TronUnDelegateResourceContract;
        })();

        TronContract.TronVoteWitnessContract = (function() {

            function TronVoteWitnessContract(properties) {
                this.votes = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            TronVoteWitnessContract.prototype.votes = $util.emptyArray;
            TronVoteWitnessContract.prototype.support = false;

            TronVoteWitnessContract.create = function create(properties) {
                return new TronVoteWitnessContract(properties);
            };

            TronVoteWitnessContract.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.votes != null && message.votes.length)
                    for (var i = 0; i < message.votes.length; ++i)
                        $root.TronSignTx.TronContract.TronVoteWitnessContract.Vote.encode(message.votes[i], writer.uint32(18).fork()).ldelim();
                if (message.support != null && Object.hasOwnProperty.call(message, "support"))
                    writer.uint32(24).bool(message.support);
                return writer;
            };

            TronVoteWitnessContract.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            TronVoteWitnessContract.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TronSignTx.TronContract.TronVoteWitnessContract();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 2:
                        if (!(message.votes && message.votes.length))
                            message.votes = [];
                        message.votes.push($root.TronSignTx.TronContract.TronVoteWitnessContract.Vote.decode(reader, reader.uint32()));
                        break;
                    case 3:
                        message.support = reader.bool();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            TronVoteWitnessContract.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            TronVoteWitnessContract.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.votes != null && message.hasOwnProperty("votes")) {
                    if (!Array.isArray(message.votes))
                        return "votes: array expected";
                    for (var i = 0; i < message.votes.length; ++i) {
                        var error = $root.TronSignTx.TronContract.TronVoteWitnessContract.Vote.verify(message.votes[i]);
                        if (error)
                            return "votes." + error;
                    }
                }
                if (message.support != null && message.hasOwnProperty("support"))
                    if (typeof message.support !== "boolean")
                        return "support: boolean expected";
                return null;
            };

            TronVoteWitnessContract.fromObject = function fromObject(object) {
                if (object instanceof $root.TronSignTx.TronContract.TronVoteWitnessContract)
                    return object;
                var message = new $root.TronSignTx.TronContract.TronVoteWitnessContract();
                if (object.votes) {
                    if (!Array.isArray(object.votes))
                        throw TypeError(".TronSignTx.TronContract.TronVoteWitnessContract.votes: array expected");
                    message.votes = [];
                    for (var i = 0; i < object.votes.length; ++i) {
                        if (typeof object.votes[i] !== "object")
                            throw TypeError(".TronSignTx.TronContract.TronVoteWitnessContract.votes: object expected");
                        message.votes[i] = $root.TronSignTx.TronContract.TronVoteWitnessContract.Vote.fromObject(object.votes[i]);
                    }
                }
                if (object.support != null)
                    message.support = Boolean(object.support);
                return message;
            };

            TronVoteWitnessContract.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.votes = [];
                if (options.defaults)
                    object.support = false;
                if (message.votes && message.votes.length) {
                    object.votes = [];
                    for (var j = 0; j < message.votes.length; ++j)
                        object.votes[j] = $root.TronSignTx.TronContract.TronVoteWitnessContract.Vote.toObject(message.votes[j], options);
                }
                if (message.support != null && message.hasOwnProperty("support"))
                    object.support = message.support;
                return object;
            };

            TronVoteWitnessContract.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            TronVoteWitnessContract.Vote = (function() {

                function Vote(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                Vote.prototype.vote_address = "";
                Vote.prototype.vote_count = 0;

                Vote.create = function create(properties) {
                    return new Vote(properties);
                };

                Vote.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    writer.uint32(10).string(message.vote_address);
                    writer.uint32(16).uint32(message.vote_count);
                    return writer;
                };

                Vote.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                Vote.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TronSignTx.TronContract.TronVoteWitnessContract.Vote();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.vote_address = reader.string();
                            break;
                        case 2:
                            message.vote_count = reader.uint32();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    if (!message.hasOwnProperty("vote_address"))
                        throw $util.ProtocolError("missing required 'vote_address'", { instance: message });
                    if (!message.hasOwnProperty("vote_count"))
                        throw $util.ProtocolError("missing required 'vote_count'", { instance: message });
                    return message;
                };

                Vote.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                Vote.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (!$util.isString(message.vote_address))
                        return "vote_address: string expected";
                    if (!$util.isInteger(message.vote_count))
                        return "vote_count: integer expected";
                    return null;
                };

                Vote.fromObject = function fromObject(object) {
                    if (object instanceof $root.TronSignTx.TronContract.TronVoteWitnessContract.Vote)
                        return object;
                    var message = new $root.TronSignTx.TronContract.TronVoteWitnessContract.Vote();
                    if (object.vote_address != null)
                        message.vote_address = String(object.vote_address);
                    if (object.vote_count != null)
                        message.vote_count = object.vote_count >>> 0;
                    return message;
                };

                Vote.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.vote_address = "";
                        object.vote_count = 0;
                    }
                    if (message.vote_address != null && message.hasOwnProperty("vote_address"))
                        object.vote_address = message.vote_address;
                    if (message.vote_count != null && message.hasOwnProperty("vote_count"))
                        object.vote_count = message.vote_count;
                    return object;
                };

                Vote.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return Vote;
            })();

            return TronVoteWitnessContract;
        })();

        TronContract.TronCancelAllUnfreezeV2Contract = (function() {

            function TronCancelAllUnfreezeV2Contract(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            TronCancelAllUnfreezeV2Contract.create = function create(properties) {
                return new TronCancelAllUnfreezeV2Contract(properties);
            };

            TronCancelAllUnfreezeV2Contract.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            TronCancelAllUnfreezeV2Contract.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            TronCancelAllUnfreezeV2Contract.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TronSignTx.TronContract.TronCancelAllUnfreezeV2Contract();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            TronCancelAllUnfreezeV2Contract.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            TronCancelAllUnfreezeV2Contract.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            TronCancelAllUnfreezeV2Contract.fromObject = function fromObject(object) {
                if (object instanceof $root.TronSignTx.TronContract.TronCancelAllUnfreezeV2Contract)
                    return object;
                return new $root.TronSignTx.TronContract.TronCancelAllUnfreezeV2Contract();
            };

            TronCancelAllUnfreezeV2Contract.toObject = function toObject() {
                return {};
            };

            TronCancelAllUnfreezeV2Contract.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return TronCancelAllUnfreezeV2Contract;
        })();

        return TronContract;
    })();

    return TronSignTx;
})();

$root.TronSignedTx = (function() {

    function TronSignedTx(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    TronSignedTx.prototype.signature = $util.newBuffer([]);
    TronSignedTx.prototype.serialized_tx = $util.newBuffer([]);

    TronSignedTx.create = function create(properties) {
        return new TronSignedTx(properties);
    };

    TronSignedTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.signature);
        if (message.serialized_tx != null && Object.hasOwnProperty.call(message, "serialized_tx"))
            writer.uint32(18).bytes(message.serialized_tx);
        return writer;
    };

    TronSignedTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    TronSignedTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TronSignedTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.signature = reader.bytes();
                break;
            case 2:
                message.serialized_tx = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        return message;
    };

    TronSignedTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    TronSignedTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        if (message.serialized_tx != null && message.hasOwnProperty("serialized_tx"))
            if (!(message.serialized_tx && typeof message.serialized_tx.length === "number" || $util.isString(message.serialized_tx)))
                return "serialized_tx: buffer expected";
        return null;
    };

    TronSignedTx.fromObject = function fromObject(object) {
        if (object instanceof $root.TronSignedTx)
            return object;
        var message = new $root.TronSignedTx();
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        if (object.serialized_tx != null)
            if (typeof object.serialized_tx === "string")
                $util.base64.decode(object.serialized_tx, message.serialized_tx = $util.newBuffer($util.base64.length(object.serialized_tx)), 0);
            else if (object.serialized_tx.length)
                message.serialized_tx = object.serialized_tx;
        return message;
    };

    TronSignedTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
            if (options.bytes === String)
                object.serialized_tx = "";
            else {
                object.serialized_tx = [];
                if (options.bytes !== Array)
                    object.serialized_tx = $util.newBuffer(object.serialized_tx);
            }
        }
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        if (message.serialized_tx != null && message.hasOwnProperty("serialized_tx"))
            object.serialized_tx = options.bytes === String ? $util.base64.encode(message.serialized_tx, 0, message.serialized_tx.length) : options.bytes === Array ? Array.prototype.slice.call(message.serialized_tx) : message.serialized_tx;
        return object;
    };

    TronSignedTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return TronSignedTx;
})();

$root.TronMessageType = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[1] = "V1"] = 1;
    values[valuesById[2] = "V2"] = 2;
    return values;
})();

$root.TronSignMessage = (function() {

    function TronSignMessage(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    TronSignMessage.prototype.address_n = $util.emptyArray;
    TronSignMessage.prototype.message = $util.newBuffer([]);
    TronSignMessage.prototype.message_type = 1;

    TronSignMessage.create = function create(properties) {
        return new TronSignMessage(properties);
    };

    TronSignMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).bytes(message.message);
        if (message.message_type != null && Object.hasOwnProperty.call(message, "message_type"))
            writer.uint32(24).int32(message.message_type);
        return writer;
    };

    TronSignMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    TronSignMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TronSignMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.message = reader.bytes();
                break;
            case 3:
                message.message_type = reader.int32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("message"))
            throw $util.ProtocolError("missing required 'message'", { instance: message });
        return message;
    };

    TronSignMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    TronSignMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!(message.message && typeof message.message.length === "number" || $util.isString(message.message)))
            return "message: buffer expected";
        if (message.message_type != null && message.hasOwnProperty("message_type"))
            switch (message.message_type) {
            default:
                return "message_type: enum value expected";
            case 1:
            case 2:
                break;
            }
        return null;
    };

    TronSignMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.TronSignMessage)
            return object;
        var message = new $root.TronSignMessage();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".TronSignMessage.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.message != null)
            if (typeof object.message === "string")
                $util.base64.decode(object.message, message.message = $util.newBuffer($util.base64.length(object.message)), 0);
            else if (object.message.length)
                message.message = object.message;
        switch (object.message_type) {
        case "V1":
        case 1:
            message.message_type = 1;
            break;
        case "V2":
        case 2:
            message.message_type = 2;
            break;
        }
        return message;
    };

    TronSignMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            if (options.bytes === String)
                object.message = "";
            else {
                object.message = [];
                if (options.bytes !== Array)
                    object.message = $util.newBuffer(object.message);
            }
            object.message_type = options.enums === String ? "V1" : 1;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.message != null && message.hasOwnProperty("message"))
            object.message = options.bytes === String ? $util.base64.encode(message.message, 0, message.message.length) : options.bytes === Array ? Array.prototype.slice.call(message.message) : message.message;
        if (message.message_type != null && message.hasOwnProperty("message_type"))
            object.message_type = options.enums === String ? $root.TronMessageType[message.message_type] : message.message_type;
        return object;
    };

    TronSignMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return TronSignMessage;
})();

$root.TronMessageSignature = (function() {

    function TronMessageSignature(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    TronMessageSignature.prototype.address = $util.newBuffer([]);
    TronMessageSignature.prototype.signature = $util.newBuffer([]);

    TronMessageSignature.create = function create(properties) {
        return new TronMessageSignature(properties);
    };

    TronMessageSignature.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.address);
        writer.uint32(18).bytes(message.signature);
        return writer;
    };

    TronMessageSignature.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    TronMessageSignature.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TronMessageSignature();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.bytes();
                break;
            case 2:
                message.signature = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("address"))
            throw $util.ProtocolError("missing required 'address'", { instance: message });
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        return message;
    };

    TronMessageSignature.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    TronMessageSignature.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.address && typeof message.address.length === "number" || $util.isString(message.address)))
            return "address: buffer expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        return null;
    };

    TronMessageSignature.fromObject = function fromObject(object) {
        if (object instanceof $root.TronMessageSignature)
            return object;
        var message = new $root.TronMessageSignature();
        if (object.address != null)
            if (typeof object.address === "string")
                $util.base64.decode(object.address, message.address = $util.newBuffer($util.base64.length(object.address)), 0);
            else if (object.address.length)
                message.address = object.address;
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        return message;
    };

    TronMessageSignature.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.address = "";
            else {
                object.address = [];
                if (options.bytes !== Array)
                    object.address = $util.newBuffer(object.address);
            }
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
        }
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = options.bytes === String ? $util.base64.encode(message.address, 0, message.address.length) : options.bytes === Array ? Array.prototype.slice.call(message.address) : message.address;
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        return object;
    };

    TronMessageSignature.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return TronMessageSignature;
})();

$root.WebAuthnListResidentCredentials = (function() {

    function WebAuthnListResidentCredentials(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    WebAuthnListResidentCredentials.create = function create(properties) {
        return new WebAuthnListResidentCredentials(properties);
    };

    WebAuthnListResidentCredentials.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    WebAuthnListResidentCredentials.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    WebAuthnListResidentCredentials.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.WebAuthnListResidentCredentials();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    WebAuthnListResidentCredentials.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    WebAuthnListResidentCredentials.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    WebAuthnListResidentCredentials.fromObject = function fromObject(object) {
        if (object instanceof $root.WebAuthnListResidentCredentials)
            return object;
        return new $root.WebAuthnListResidentCredentials();
    };

    WebAuthnListResidentCredentials.toObject = function toObject() {
        return {};
    };

    WebAuthnListResidentCredentials.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return WebAuthnListResidentCredentials;
})();

$root.WebAuthnAddResidentCredential = (function() {

    function WebAuthnAddResidentCredential(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    WebAuthnAddResidentCredential.prototype.credential_id = $util.newBuffer([]);

    WebAuthnAddResidentCredential.create = function create(properties) {
        return new WebAuthnAddResidentCredential(properties);
    };

    WebAuthnAddResidentCredential.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.credential_id != null && Object.hasOwnProperty.call(message, "credential_id"))
            writer.uint32(10).bytes(message.credential_id);
        return writer;
    };

    WebAuthnAddResidentCredential.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    WebAuthnAddResidentCredential.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.WebAuthnAddResidentCredential();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.credential_id = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    WebAuthnAddResidentCredential.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    WebAuthnAddResidentCredential.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.credential_id != null && message.hasOwnProperty("credential_id"))
            if (!(message.credential_id && typeof message.credential_id.length === "number" || $util.isString(message.credential_id)))
                return "credential_id: buffer expected";
        return null;
    };

    WebAuthnAddResidentCredential.fromObject = function fromObject(object) {
        if (object instanceof $root.WebAuthnAddResidentCredential)
            return object;
        var message = new $root.WebAuthnAddResidentCredential();
        if (object.credential_id != null)
            if (typeof object.credential_id === "string")
                $util.base64.decode(object.credential_id, message.credential_id = $util.newBuffer($util.base64.length(object.credential_id)), 0);
            else if (object.credential_id.length)
                message.credential_id = object.credential_id;
        return message;
    };

    WebAuthnAddResidentCredential.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.credential_id = "";
            else {
                object.credential_id = [];
                if (options.bytes !== Array)
                    object.credential_id = $util.newBuffer(object.credential_id);
            }
        if (message.credential_id != null && message.hasOwnProperty("credential_id"))
            object.credential_id = options.bytes === String ? $util.base64.encode(message.credential_id, 0, message.credential_id.length) : options.bytes === Array ? Array.prototype.slice.call(message.credential_id) : message.credential_id;
        return object;
    };

    WebAuthnAddResidentCredential.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return WebAuthnAddResidentCredential;
})();

$root.WebAuthnRemoveResidentCredential = (function() {

    function WebAuthnRemoveResidentCredential(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    WebAuthnRemoveResidentCredential.prototype.index = 0;

    WebAuthnRemoveResidentCredential.create = function create(properties) {
        return new WebAuthnRemoveResidentCredential(properties);
    };

    WebAuthnRemoveResidentCredential.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.index != null && Object.hasOwnProperty.call(message, "index"))
            writer.uint32(8).uint32(message.index);
        return writer;
    };

    WebAuthnRemoveResidentCredential.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    WebAuthnRemoveResidentCredential.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.WebAuthnRemoveResidentCredential();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.index = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    WebAuthnRemoveResidentCredential.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    WebAuthnRemoveResidentCredential.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.index != null && message.hasOwnProperty("index"))
            if (!$util.isInteger(message.index))
                return "index: integer expected";
        return null;
    };

    WebAuthnRemoveResidentCredential.fromObject = function fromObject(object) {
        if (object instanceof $root.WebAuthnRemoveResidentCredential)
            return object;
        var message = new $root.WebAuthnRemoveResidentCredential();
        if (object.index != null)
            message.index = object.index >>> 0;
        return message;
    };

    WebAuthnRemoveResidentCredential.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.index = 0;
        if (message.index != null && message.hasOwnProperty("index"))
            object.index = message.index;
        return object;
    };

    WebAuthnRemoveResidentCredential.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return WebAuthnRemoveResidentCredential;
})();

$root.WebAuthnCredentials = (function() {

    function WebAuthnCredentials(properties) {
        this.credentials = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    WebAuthnCredentials.prototype.credentials = $util.emptyArray;

    WebAuthnCredentials.create = function create(properties) {
        return new WebAuthnCredentials(properties);
    };

    WebAuthnCredentials.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.credentials != null && message.credentials.length)
            for (var i = 0; i < message.credentials.length; ++i)
                $root.WebAuthnCredentials.WebAuthnCredential.encode(message.credentials[i], writer.uint32(10).fork()).ldelim();
        return writer;
    };

    WebAuthnCredentials.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    WebAuthnCredentials.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.WebAuthnCredentials();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.credentials && message.credentials.length))
                    message.credentials = [];
                message.credentials.push($root.WebAuthnCredentials.WebAuthnCredential.decode(reader, reader.uint32()));
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    WebAuthnCredentials.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    WebAuthnCredentials.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.credentials != null && message.hasOwnProperty("credentials")) {
            if (!Array.isArray(message.credentials))
                return "credentials: array expected";
            for (var i = 0; i < message.credentials.length; ++i) {
                var error = $root.WebAuthnCredentials.WebAuthnCredential.verify(message.credentials[i]);
                if (error)
                    return "credentials." + error;
            }
        }
        return null;
    };

    WebAuthnCredentials.fromObject = function fromObject(object) {
        if (object instanceof $root.WebAuthnCredentials)
            return object;
        var message = new $root.WebAuthnCredentials();
        if (object.credentials) {
            if (!Array.isArray(object.credentials))
                throw TypeError(".WebAuthnCredentials.credentials: array expected");
            message.credentials = [];
            for (var i = 0; i < object.credentials.length; ++i) {
                if (typeof object.credentials[i] !== "object")
                    throw TypeError(".WebAuthnCredentials.credentials: object expected");
                message.credentials[i] = $root.WebAuthnCredentials.WebAuthnCredential.fromObject(object.credentials[i]);
            }
        }
        return message;
    };

    WebAuthnCredentials.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.credentials = [];
        if (message.credentials && message.credentials.length) {
            object.credentials = [];
            for (var j = 0; j < message.credentials.length; ++j)
                object.credentials[j] = $root.WebAuthnCredentials.WebAuthnCredential.toObject(message.credentials[j], options);
        }
        return object;
    };

    WebAuthnCredentials.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    WebAuthnCredentials.WebAuthnCredential = (function() {

        function WebAuthnCredential(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        WebAuthnCredential.prototype.index = 0;
        WebAuthnCredential.prototype.id = $util.newBuffer([]);
        WebAuthnCredential.prototype.rp_id = "";
        WebAuthnCredential.prototype.rp_name = "";
        WebAuthnCredential.prototype.user_id = $util.newBuffer([]);
        WebAuthnCredential.prototype.user_name = "";
        WebAuthnCredential.prototype.user_display_name = "";
        WebAuthnCredential.prototype.creation_time = 0;
        WebAuthnCredential.prototype.hmac_secret = false;
        WebAuthnCredential.prototype.use_sign_count = false;
        WebAuthnCredential.prototype.algorithm = 0;
        WebAuthnCredential.prototype.curve = 0;

        WebAuthnCredential.create = function create(properties) {
            return new WebAuthnCredential(properties);
        };

        WebAuthnCredential.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.index != null && Object.hasOwnProperty.call(message, "index"))
                writer.uint32(8).uint32(message.index);
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(18).bytes(message.id);
            if (message.rp_id != null && Object.hasOwnProperty.call(message, "rp_id"))
                writer.uint32(26).string(message.rp_id);
            if (message.rp_name != null && Object.hasOwnProperty.call(message, "rp_name"))
                writer.uint32(34).string(message.rp_name);
            if (message.user_id != null && Object.hasOwnProperty.call(message, "user_id"))
                writer.uint32(42).bytes(message.user_id);
            if (message.user_name != null && Object.hasOwnProperty.call(message, "user_name"))
                writer.uint32(50).string(message.user_name);
            if (message.user_display_name != null && Object.hasOwnProperty.call(message, "user_display_name"))
                writer.uint32(58).string(message.user_display_name);
            if (message.creation_time != null && Object.hasOwnProperty.call(message, "creation_time"))
                writer.uint32(64).uint32(message.creation_time);
            if (message.hmac_secret != null && Object.hasOwnProperty.call(message, "hmac_secret"))
                writer.uint32(72).bool(message.hmac_secret);
            if (message.use_sign_count != null && Object.hasOwnProperty.call(message, "use_sign_count"))
                writer.uint32(80).bool(message.use_sign_count);
            if (message.algorithm != null && Object.hasOwnProperty.call(message, "algorithm"))
                writer.uint32(88).sint32(message.algorithm);
            if (message.curve != null && Object.hasOwnProperty.call(message, "curve"))
                writer.uint32(96).sint32(message.curve);
            return writer;
        };

        WebAuthnCredential.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        WebAuthnCredential.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.WebAuthnCredentials.WebAuthnCredential();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.index = reader.uint32();
                    break;
                case 2:
                    message.id = reader.bytes();
                    break;
                case 3:
                    message.rp_id = reader.string();
                    break;
                case 4:
                    message.rp_name = reader.string();
                    break;
                case 5:
                    message.user_id = reader.bytes();
                    break;
                case 6:
                    message.user_name = reader.string();
                    break;
                case 7:
                    message.user_display_name = reader.string();
                    break;
                case 8:
                    message.creation_time = reader.uint32();
                    break;
                case 9:
                    message.hmac_secret = reader.bool();
                    break;
                case 10:
                    message.use_sign_count = reader.bool();
                    break;
                case 11:
                    message.algorithm = reader.sint32();
                    break;
                case 12:
                    message.curve = reader.sint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        WebAuthnCredential.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        WebAuthnCredential.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.index != null && message.hasOwnProperty("index"))
                if (!$util.isInteger(message.index))
                    return "index: integer expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!(message.id && typeof message.id.length === "number" || $util.isString(message.id)))
                    return "id: buffer expected";
            if (message.rp_id != null && message.hasOwnProperty("rp_id"))
                if (!$util.isString(message.rp_id))
                    return "rp_id: string expected";
            if (message.rp_name != null && message.hasOwnProperty("rp_name"))
                if (!$util.isString(message.rp_name))
                    return "rp_name: string expected";
            if (message.user_id != null && message.hasOwnProperty("user_id"))
                if (!(message.user_id && typeof message.user_id.length === "number" || $util.isString(message.user_id)))
                    return "user_id: buffer expected";
            if (message.user_name != null && message.hasOwnProperty("user_name"))
                if (!$util.isString(message.user_name))
                    return "user_name: string expected";
            if (message.user_display_name != null && message.hasOwnProperty("user_display_name"))
                if (!$util.isString(message.user_display_name))
                    return "user_display_name: string expected";
            if (message.creation_time != null && message.hasOwnProperty("creation_time"))
                if (!$util.isInteger(message.creation_time))
                    return "creation_time: integer expected";
            if (message.hmac_secret != null && message.hasOwnProperty("hmac_secret"))
                if (typeof message.hmac_secret !== "boolean")
                    return "hmac_secret: boolean expected";
            if (message.use_sign_count != null && message.hasOwnProperty("use_sign_count"))
                if (typeof message.use_sign_count !== "boolean")
                    return "use_sign_count: boolean expected";
            if (message.algorithm != null && message.hasOwnProperty("algorithm"))
                if (!$util.isInteger(message.algorithm))
                    return "algorithm: integer expected";
            if (message.curve != null && message.hasOwnProperty("curve"))
                if (!$util.isInteger(message.curve))
                    return "curve: integer expected";
            return null;
        };

        WebAuthnCredential.fromObject = function fromObject(object) {
            if (object instanceof $root.WebAuthnCredentials.WebAuthnCredential)
                return object;
            var message = new $root.WebAuthnCredentials.WebAuthnCredential();
            if (object.index != null)
                message.index = object.index >>> 0;
            if (object.id != null)
                if (typeof object.id === "string")
                    $util.base64.decode(object.id, message.id = $util.newBuffer($util.base64.length(object.id)), 0);
                else if (object.id.length)
                    message.id = object.id;
            if (object.rp_id != null)
                message.rp_id = String(object.rp_id);
            if (object.rp_name != null)
                message.rp_name = String(object.rp_name);
            if (object.user_id != null)
                if (typeof object.user_id === "string")
                    $util.base64.decode(object.user_id, message.user_id = $util.newBuffer($util.base64.length(object.user_id)), 0);
                else if (object.user_id.length)
                    message.user_id = object.user_id;
            if (object.user_name != null)
                message.user_name = String(object.user_name);
            if (object.user_display_name != null)
                message.user_display_name = String(object.user_display_name);
            if (object.creation_time != null)
                message.creation_time = object.creation_time >>> 0;
            if (object.hmac_secret != null)
                message.hmac_secret = Boolean(object.hmac_secret);
            if (object.use_sign_count != null)
                message.use_sign_count = Boolean(object.use_sign_count);
            if (object.algorithm != null)
                message.algorithm = object.algorithm | 0;
            if (object.curve != null)
                message.curve = object.curve | 0;
            return message;
        };

        WebAuthnCredential.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.index = 0;
                if (options.bytes === String)
                    object.id = "";
                else {
                    object.id = [];
                    if (options.bytes !== Array)
                        object.id = $util.newBuffer(object.id);
                }
                object.rp_id = "";
                object.rp_name = "";
                if (options.bytes === String)
                    object.user_id = "";
                else {
                    object.user_id = [];
                    if (options.bytes !== Array)
                        object.user_id = $util.newBuffer(object.user_id);
                }
                object.user_name = "";
                object.user_display_name = "";
                object.creation_time = 0;
                object.hmac_secret = false;
                object.use_sign_count = false;
                object.algorithm = 0;
                object.curve = 0;
            }
            if (message.index != null && message.hasOwnProperty("index"))
                object.index = message.index;
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = options.bytes === String ? $util.base64.encode(message.id, 0, message.id.length) : options.bytes === Array ? Array.prototype.slice.call(message.id) : message.id;
            if (message.rp_id != null && message.hasOwnProperty("rp_id"))
                object.rp_id = message.rp_id;
            if (message.rp_name != null && message.hasOwnProperty("rp_name"))
                object.rp_name = message.rp_name;
            if (message.user_id != null && message.hasOwnProperty("user_id"))
                object.user_id = options.bytes === String ? $util.base64.encode(message.user_id, 0, message.user_id.length) : options.bytes === Array ? Array.prototype.slice.call(message.user_id) : message.user_id;
            if (message.user_name != null && message.hasOwnProperty("user_name"))
                object.user_name = message.user_name;
            if (message.user_display_name != null && message.hasOwnProperty("user_display_name"))
                object.user_display_name = message.user_display_name;
            if (message.creation_time != null && message.hasOwnProperty("creation_time"))
                object.creation_time = message.creation_time;
            if (message.hmac_secret != null && message.hasOwnProperty("hmac_secret"))
                object.hmac_secret = message.hmac_secret;
            if (message.use_sign_count != null && message.hasOwnProperty("use_sign_count"))
                object.use_sign_count = message.use_sign_count;
            if (message.algorithm != null && message.hasOwnProperty("algorithm"))
                object.algorithm = message.algorithm;
            if (message.curve != null && message.hasOwnProperty("curve"))
                object.curve = message.curve;
            return object;
        };

        WebAuthnCredential.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return WebAuthnCredential;
    })();

    return WebAuthnCredentials;
})();

$root.CommandFlags = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "Default"] = 0;
    values[valuesById[1] = "Factory_Only"] = 1;
    return values;
})();

$root.MessageType = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[10054] = "MessageType_BabylonDeriveContextHash"] = 10054;
    values[valuesById[10055] = "MessageType_BabylonDerivedContextHash"] = 10055;
    values[valuesById[0] = "MessageType_Initialize"] = 0;
    values[valuesById[1] = "MessageType_Ping"] = 1;
    values[valuesById[2] = "MessageType_Success"] = 2;
    values[valuesById[3] = "MessageType_Failure"] = 3;
    values[valuesById[4] = "MessageType_ChangePin"] = 4;
    values[valuesById[5] = "MessageType_WipeDevice"] = 5;
    values[valuesById[9] = "MessageType_GetEntropy"] = 9;
    values[valuesById[10] = "MessageType_Entropy"] = 10;
    values[valuesById[13] = "MessageType_LoadDevice"] = 13;
    values[valuesById[14] = "MessageType_ResetDevice"] = 14;
    values[valuesById[17] = "MessageType_Features"] = 17;
    values[valuesById[18] = "MessageType_PinMatrixRequest"] = 18;
    values[valuesById[19] = "MessageType_PinMatrixAck"] = 19;
    values[valuesById[20] = "MessageType_Cancel"] = 20;
    values[valuesById[24] = "MessageType_LockDevice"] = 24;
    values[valuesById[25] = "MessageType_ApplySettings"] = 25;
    values[valuesById[26] = "MessageType_ButtonRequest"] = 26;
    values[valuesById[27] = "MessageType_ButtonAck"] = 27;
    values[valuesById[28] = "MessageType_ApplyFlags"] = 28;
    values[valuesById[34] = "MessageType_BackupDevice"] = 34;
    values[valuesById[35] = "MessageType_EntropyRequest"] = 35;
    values[valuesById[36] = "MessageType_EntropyAck"] = 36;
    values[valuesById[41] = "MessageType_PassphraseRequest"] = 41;
    values[valuesById[42] = "MessageType_PassphraseAck"] = 42;
    values[valuesById[45] = "MessageType_RecoveryDevice"] = 45;
    values[valuesById[46] = "MessageType_WordRequest"] = 46;
    values[valuesById[47] = "MessageType_WordAck"] = 47;
    values[valuesById[55] = "MessageType_GetFeatures"] = 55;
    values[valuesById[79] = "MessageType_SdProtect"] = 79;
    values[valuesById[82] = "MessageType_ChangeWipeCode"] = 82;
    values[valuesById[83] = "MessageType_EndSession"] = 83;
    values[valuesById[84] = "MessageType_DoPreauthorized"] = 84;
    values[valuesById[85] = "MessageType_PreauthorizedRequest"] = 85;
    values[valuesById[86] = "MessageType_CancelAuthorization"] = 86;
    values[valuesById[87] = "MessageType_RebootToBootloader"] = 87;
    values[valuesById[63] = "MessageType_SetU2FCounter"] = 63;
    values[valuesById[80] = "MessageType_GetNextU2FCounter"] = 80;
    values[valuesById[81] = "MessageType_NextU2FCounter"] = 81;
    values[valuesById[77] = "MessageType_Deprecated_PassphraseStateRequest"] = 77;
    values[valuesById[78] = "MessageType_Deprecated_PassphraseStateAck"] = 78;
    values[valuesById[6] = "MessageType_FirmwareErase"] = 6;
    values[valuesById[16] = "MessageType_FirmwareErase_ex"] = 16;
    values[valuesById[7] = "MessageType_FirmwareUpload"] = 7;
    values[valuesById[8] = "MessageType_FirmwareRequest"] = 8;
    values[valuesById[32] = "MessageType_SelfTest"] = 32;
    values[valuesById[30000] = "MessageType_Reboot"] = 30000;
    values[valuesById[30001] = "MessageType_FirmwareUpdateEmmc"] = 30001;
    values[valuesById[11] = "MessageType_GetPublicKey"] = 11;
    values[valuesById[12] = "MessageType_PublicKey"] = 12;
    values[valuesById[15] = "MessageType_SignTx"] = 15;
    values[valuesById[21] = "MessageType_TxRequest"] = 21;
    values[valuesById[22] = "MessageType_TxAck"] = 22;
    values[valuesById[29] = "MessageType_GetAddress"] = 29;
    values[valuesById[30] = "MessageType_Address"] = 30;
    values[valuesById[38] = "MessageType_SignMessage"] = 38;
    values[valuesById[39] = "MessageType_VerifyMessage"] = 39;
    values[valuesById[40] = "MessageType_MessageSignature"] = 40;
    values[valuesById[43] = "MessageType_GetOwnershipId"] = 43;
    values[valuesById[44] = "MessageType_OwnershipId"] = 44;
    values[valuesById[49] = "MessageType_GetOwnershipProof"] = 49;
    values[valuesById[50] = "MessageType_OwnershipProof"] = 50;
    values[valuesById[51] = "MessageType_AuthorizeCoinJoin"] = 51;
    values[valuesById[10052] = "MessageType_SignPsbt"] = 10052;
    values[valuesById[10053] = "MessageType_SignedPsbt"] = 10053;
    values[valuesById[23] = "MessageType_CipherKeyValue"] = 23;
    values[valuesById[48] = "MessageType_CipheredKeyValue"] = 48;
    values[valuesById[53] = "MessageType_SignIdentity"] = 53;
    values[valuesById[54] = "MessageType_SignedIdentity"] = 54;
    values[valuesById[61] = "MessageType_GetECDHSessionKey"] = 61;
    values[valuesById[62] = "MessageType_ECDHSessionKey"] = 62;
    values[valuesById[71] = "MessageType_CosiCommit"] = 71;
    values[valuesById[72] = "MessageType_CosiCommitment"] = 72;
    values[valuesById[73] = "MessageType_CosiSign"] = 73;
    values[valuesById[74] = "MessageType_CosiSignature"] = 74;
    values[valuesById[10016] = "MessageType_BatchGetPublickeys"] = 10016;
    values[valuesById[10017] = "MessageType_EcdsaPublicKeys"] = 10017;
    values[valuesById[100] = "MessageType_DebugLinkDecision"] = 100;
    values[valuesById[101] = "MessageType_DebugLinkGetState"] = 101;
    values[valuesById[102] = "MessageType_DebugLinkState"] = 102;
    values[valuesById[103] = "MessageType_DebugLinkStop"] = 103;
    values[valuesById[104] = "MessageType_DebugLinkLog"] = 104;
    values[valuesById[110] = "MessageType_DebugLinkMemoryRead"] = 110;
    values[valuesById[111] = "MessageType_DebugLinkMemory"] = 111;
    values[valuesById[112] = "MessageType_DebugLinkMemoryWrite"] = 112;
    values[valuesById[113] = "MessageType_DebugLinkFlashErase"] = 113;
    values[valuesById[9001] = "MessageType_DebugLinkLayout"] = 9001;
    values[valuesById[9002] = "MessageType_DebugLinkReseedRandom"] = 9002;
    values[valuesById[9003] = "MessageType_DebugLinkRecordScreen"] = 9003;
    values[valuesById[9005] = "MessageType_DebugLinkEraseSdCard"] = 9005;
    values[valuesById[9006] = "MessageType_DebugLinkWatchLayout"] = 9006;
    values[valuesById[30100] = "MessageType_EmmcFixPermission"] = 30100;
    values[valuesById[30101] = "MessageType_EmmcPath"] = 30101;
    values[valuesById[30102] = "MessageType_EmmcPathInfo"] = 30102;
    values[valuesById[30103] = "MessageType_EmmcFile"] = 30103;
    values[valuesById[30104] = "MessageType_EmmcFileRead"] = 30104;
    values[valuesById[30105] = "MessageType_EmmcFileWrite"] = 30105;
    values[valuesById[30106] = "MessageType_EmmcFileDelete"] = 30106;
    values[valuesById[30107] = "MessageType_EmmcDir"] = 30107;
    values[valuesById[30108] = "MessageType_EmmcDirList"] = 30108;
    values[valuesById[30109] = "MessageType_EmmcDirMake"] = 30109;
    values[valuesById[30110] = "MessageType_EmmcDirRemove"] = 30110;
    values[valuesById[450] = "MessageType_EthereumGetPublicKey"] = 450;
    values[valuesById[451] = "MessageType_EthereumPublicKey"] = 451;
    values[valuesById[56] = "MessageType_EthereumGetAddress"] = 56;
    values[valuesById[57] = "MessageType_EthereumAddress"] = 57;
    values[valuesById[58] = "MessageType_EthereumSignTx"] = 58;
    values[valuesById[452] = "MessageType_EthereumSignTxEIP1559"] = 452;
    values[valuesById[59] = "MessageType_EthereumTxRequest"] = 59;
    values[valuesById[60] = "MessageType_EthereumTxAck"] = 60;
    values[valuesById[64] = "MessageType_EthereumSignMessage"] = 64;
    values[valuesById[65] = "MessageType_EthereumVerifyMessage"] = 65;
    values[valuesById[66] = "MessageType_EthereumMessageSignature"] = 66;
    values[valuesById[464] = "MessageType_EthereumSignTypedData"] = 464;
    values[valuesById[465] = "MessageType_EthereumTypedDataStructRequest"] = 465;
    values[valuesById[466] = "MessageType_EthereumTypedDataStructAck"] = 466;
    values[valuesById[467] = "MessageType_EthereumTypedDataValueRequest"] = 467;
    values[valuesById[468] = "MessageType_EthereumTypedDataValueAck"] = 468;
    values[valuesById[469] = "MessageType_EthereumTypedDataSignature"] = 469;
    values[valuesById[470] = "MessageType_EthereumSignTypedHash"] = 470;
    values[valuesById[20100] = "MessageType_EthereumGetPublicKeyOneKey"] = 20100;
    values[valuesById[20101] = "MessageType_EthereumPublicKeyOneKey"] = 20101;
    values[valuesById[20102] = "MessageType_EthereumGetAddressOneKey"] = 20102;
    values[valuesById[20103] = "MessageType_EthereumAddressOneKey"] = 20103;
    values[valuesById[20104] = "MessageType_EthereumSignTxOneKey"] = 20104;
    values[valuesById[20105] = "MessageType_EthereumSignTxEIP1559OneKey"] = 20105;
    values[valuesById[20106] = "MessageType_EthereumTxRequestOneKey"] = 20106;
    values[valuesById[20107] = "MessageType_EthereumTxAckOneKey"] = 20107;
    values[valuesById[20108] = "MessageType_EthereumSignMessageOneKey"] = 20108;
    values[valuesById[20109] = "MessageType_EthereumVerifyMessageOneKey"] = 20109;
    values[valuesById[20110] = "MessageType_EthereumMessageSignatureOneKey"] = 20110;
    values[valuesById[20111] = "MessageType_EthereumSignTypedDataOneKey"] = 20111;
    values[valuesById[20112] = "MessageType_EthereumTypedDataStructRequestOneKey"] = 20112;
    values[valuesById[20113] = "MessageType_EthereumTypedDataStructAckOneKey"] = 20113;
    values[valuesById[20114] = "MessageType_EthereumTypedDataValueRequestOneKey"] = 20114;
    values[valuesById[20115] = "MessageType_EthereumTypedDataValueAckOneKey"] = 20115;
    values[valuesById[20116] = "MessageType_EthereumTypedDataSignatureOneKey"] = 20116;
    values[valuesById[20117] = "MessageType_EthereumSignTypedHashOneKey"] = 20117;
    values[valuesById[20118] = "MessageType_EthereumGnosisSafeTxAck"] = 20118;
    values[valuesById[20119] = "MessageType_EthereumGnosisSafeTxRequest"] = 20119;
    values[valuesById[20120] = "MessageType_EthereumSignTxEIP7702OneKey"] = 20120;
    values[valuesById[67] = "MessageType_NEMGetAddress"] = 67;
    values[valuesById[68] = "MessageType_NEMAddress"] = 68;
    values[valuesById[69] = "MessageType_NEMSignTx"] = 69;
    values[valuesById[70] = "MessageType_NEMSignedTx"] = 70;
    values[valuesById[75] = "MessageType_NEMDecryptMessage"] = 75;
    values[valuesById[76] = "MessageType_NEMDecryptedMessage"] = 76;
    values[valuesById[150] = "MessageType_TezosGetAddress"] = 150;
    values[valuesById[151] = "MessageType_TezosAddress"] = 151;
    values[valuesById[152] = "MessageType_TezosSignTx"] = 152;
    values[valuesById[153] = "MessageType_TezosSignedTx"] = 153;
    values[valuesById[154] = "MessageType_TezosGetPublicKey"] = 154;
    values[valuesById[155] = "MessageType_TezosPublicKey"] = 155;
    values[valuesById[202] = "MessageType_StellarSignTx"] = 202;
    values[valuesById[203] = "MessageType_StellarTxOpRequest"] = 203;
    values[valuesById[207] = "MessageType_StellarGetAddress"] = 207;
    values[valuesById[208] = "MessageType_StellarAddress"] = 208;
    values[valuesById[210] = "MessageType_StellarCreateAccountOp"] = 210;
    values[valuesById[211] = "MessageType_StellarPaymentOp"] = 211;
    values[valuesById[212] = "MessageType_StellarPathPaymentStrictReceiveOp"] = 212;
    values[valuesById[213] = "MessageType_StellarManageSellOfferOp"] = 213;
    values[valuesById[214] = "MessageType_StellarCreatePassiveSellOfferOp"] = 214;
    values[valuesById[215] = "MessageType_StellarSetOptionsOp"] = 215;
    values[valuesById[216] = "MessageType_StellarChangeTrustOp"] = 216;
    values[valuesById[217] = "MessageType_StellarAllowTrustOp"] = 217;
    values[valuesById[218] = "MessageType_StellarAccountMergeOp"] = 218;
    values[valuesById[220] = "MessageType_StellarManageDataOp"] = 220;
    values[valuesById[221] = "MessageType_StellarBumpSequenceOp"] = 221;
    values[valuesById[222] = "MessageType_StellarManageBuyOfferOp"] = 222;
    values[valuesById[223] = "MessageType_StellarPathPaymentStrictSendOp"] = 223;
    values[valuesById[230] = "MessageType_StellarSignedTx"] = 230;
    values[valuesById[260] = "MessageType_StellarInvokeHostFunctionOp"] = 260;
    values[valuesById[261] = "MessageType_StellarSorobanDataRequest"] = 261;
    values[valuesById[262] = "MessageType_StellarSorobanDataAck"] = 262;
    values[valuesById[305] = "MessageType_CardanoGetPublicKey"] = 305;
    values[valuesById[306] = "MessageType_CardanoPublicKey"] = 306;
    values[valuesById[307] = "MessageType_CardanoGetAddress"] = 307;
    values[valuesById[308] = "MessageType_CardanoAddress"] = 308;
    values[valuesById[313] = "MessageType_CardanoTxItemAck"] = 313;
    values[valuesById[314] = "MessageType_CardanoTxAuxiliaryDataSupplement"] = 314;
    values[valuesById[315] = "MessageType_CardanoTxWitnessRequest"] = 315;
    values[valuesById[316] = "MessageType_CardanoTxWitnessResponse"] = 316;
    values[valuesById[317] = "MessageType_CardanoTxHostAck"] = 317;
    values[valuesById[318] = "MessageType_CardanoTxBodyHash"] = 318;
    values[valuesById[319] = "MessageType_CardanoSignTxFinished"] = 319;
    values[valuesById[320] = "MessageType_CardanoSignTxInit"] = 320;
    values[valuesById[321] = "MessageType_CardanoTxInput"] = 321;
    values[valuesById[322] = "MessageType_CardanoTxOutput"] = 322;
    values[valuesById[323] = "MessageType_CardanoAssetGroup"] = 323;
    values[valuesById[324] = "MessageType_CardanoToken"] = 324;
    values[valuesById[325] = "MessageType_CardanoTxCertificate"] = 325;
    values[valuesById[326] = "MessageType_CardanoTxWithdrawal"] = 326;
    values[valuesById[327] = "MessageType_CardanoTxAuxiliaryData"] = 327;
    values[valuesById[328] = "MessageType_CardanoPoolOwner"] = 328;
    values[valuesById[329] = "MessageType_CardanoPoolRelayParameters"] = 329;
    values[valuesById[330] = "MessageType_CardanoGetNativeScriptHash"] = 330;
    values[valuesById[331] = "MessageType_CardanoNativeScriptHash"] = 331;
    values[valuesById[332] = "MessageType_CardanoTxMint"] = 332;
    values[valuesById[333] = "MessageType_CardanoTxCollateralInput"] = 333;
    values[valuesById[334] = "MessageType_CardanoTxRequiredSigner"] = 334;
    values[valuesById[335] = "MessageType_CardanoTxInlineDatumChunk"] = 335;
    values[valuesById[336] = "MessageType_CardanoTxReferenceScriptChunk"] = 336;
    values[valuesById[337] = "MessageType_CardanoTxReferenceInput"] = 337;
    values[valuesById[350] = "MessageType_CardanoSignMessage"] = 350;
    values[valuesById[351] = "MessageType_CardanoMessageSignature"] = 351;
    values[valuesById[400] = "MessageType_RippleGetAddress"] = 400;
    values[valuesById[401] = "MessageType_RippleAddress"] = 401;
    values[valuesById[402] = "MessageType_RippleSignTx"] = 402;
    values[valuesById[403] = "MessageType_RippleSignedTx"] = 403;
    values[valuesById[501] = "MessageType_MoneroTransactionInitRequest"] = 501;
    values[valuesById[502] = "MessageType_MoneroTransactionInitAck"] = 502;
    values[valuesById[503] = "MessageType_MoneroTransactionSetInputRequest"] = 503;
    values[valuesById[504] = "MessageType_MoneroTransactionSetInputAck"] = 504;
    values[valuesById[505] = "MessageType_MoneroTransactionInputsPermutationRequest"] = 505;
    values[valuesById[506] = "MessageType_MoneroTransactionInputsPermutationAck"] = 506;
    values[valuesById[507] = "MessageType_MoneroTransactionInputViniRequest"] = 507;
    values[valuesById[508] = "MessageType_MoneroTransactionInputViniAck"] = 508;
    values[valuesById[509] = "MessageType_MoneroTransactionAllInputsSetRequest"] = 509;
    values[valuesById[510] = "MessageType_MoneroTransactionAllInputsSetAck"] = 510;
    values[valuesById[511] = "MessageType_MoneroTransactionSetOutputRequest"] = 511;
    values[valuesById[512] = "MessageType_MoneroTransactionSetOutputAck"] = 512;
    values[valuesById[513] = "MessageType_MoneroTransactionAllOutSetRequest"] = 513;
    values[valuesById[514] = "MessageType_MoneroTransactionAllOutSetAck"] = 514;
    values[valuesById[515] = "MessageType_MoneroTransactionSignInputRequest"] = 515;
    values[valuesById[516] = "MessageType_MoneroTransactionSignInputAck"] = 516;
    values[valuesById[517] = "MessageType_MoneroTransactionFinalRequest"] = 517;
    values[valuesById[518] = "MessageType_MoneroTransactionFinalAck"] = 518;
    values[valuesById[530] = "MessageType_MoneroKeyImageExportInitRequest"] = 530;
    values[valuesById[531] = "MessageType_MoneroKeyImageExportInitAck"] = 531;
    values[valuesById[532] = "MessageType_MoneroKeyImageSyncStepRequest"] = 532;
    values[valuesById[533] = "MessageType_MoneroKeyImageSyncStepAck"] = 533;
    values[valuesById[534] = "MessageType_MoneroKeyImageSyncFinalRequest"] = 534;
    values[valuesById[535] = "MessageType_MoneroKeyImageSyncFinalAck"] = 535;
    values[valuesById[540] = "MessageType_MoneroGetAddress"] = 540;
    values[valuesById[541] = "MessageType_MoneroAddress"] = 541;
    values[valuesById[542] = "MessageType_MoneroGetWatchKey"] = 542;
    values[valuesById[543] = "MessageType_MoneroWatchKey"] = 543;
    values[valuesById[546] = "MessageType_DebugMoneroDiagRequest"] = 546;
    values[valuesById[547] = "MessageType_DebugMoneroDiagAck"] = 547;
    values[valuesById[550] = "MessageType_MoneroGetTxKeyRequest"] = 550;
    values[valuesById[551] = "MessageType_MoneroGetTxKeyAck"] = 551;
    values[valuesById[552] = "MessageType_MoneroLiveRefreshStartRequest"] = 552;
    values[valuesById[553] = "MessageType_MoneroLiveRefreshStartAck"] = 553;
    values[valuesById[554] = "MessageType_MoneroLiveRefreshStepRequest"] = 554;
    values[valuesById[555] = "MessageType_MoneroLiveRefreshStepAck"] = 555;
    values[valuesById[556] = "MessageType_MoneroLiveRefreshFinalRequest"] = 556;
    values[valuesById[557] = "MessageType_MoneroLiveRefreshFinalAck"] = 557;
    values[valuesById[600] = "MessageType_EosGetPublicKey"] = 600;
    values[valuesById[601] = "MessageType_EosPublicKey"] = 601;
    values[valuesById[602] = "MessageType_EosSignTx"] = 602;
    values[valuesById[603] = "MessageType_EosTxActionRequest"] = 603;
    values[valuesById[604] = "MessageType_EosTxActionAck"] = 604;
    values[valuesById[605] = "MessageType_EosSignedTx"] = 605;
    values[valuesById[700] = "MessageType_BinanceGetAddress"] = 700;
    values[valuesById[701] = "MessageType_BinanceAddress"] = 701;
    values[valuesById[702] = "MessageType_BinanceGetPublicKey"] = 702;
    values[valuesById[703] = "MessageType_BinancePublicKey"] = 703;
    values[valuesById[704] = "MessageType_BinanceSignTx"] = 704;
    values[valuesById[705] = "MessageType_BinanceTxRequest"] = 705;
    values[valuesById[706] = "MessageType_BinanceTransferMsg"] = 706;
    values[valuesById[707] = "MessageType_BinanceOrderMsg"] = 707;
    values[valuesById[708] = "MessageType_BinanceCancelMsg"] = 708;
    values[valuesById[709] = "MessageType_BinanceSignedTx"] = 709;
    values[valuesById[10100] = "MessageType_SolanaGetAddress"] = 10100;
    values[valuesById[10101] = "MessageType_SolanaAddress"] = 10101;
    values[valuesById[10102] = "MessageType_SolanaSignTx"] = 10102;
    values[valuesById[10103] = "MessageType_SolanaSignedTx"] = 10103;
    values[valuesById[10104] = "MessageType_SolanaSignOffChainMessage"] = 10104;
    values[valuesById[10105] = "MessageType_SolanaMessageSignature"] = 10105;
    values[valuesById[10106] = "MessageType_SolanaSignUnsafeMessage"] = 10106;
    values[valuesById[10300] = "MessageType_StarcoinGetAddress"] = 10300;
    values[valuesById[10301] = "MessageType_StarcoinAddress"] = 10301;
    values[valuesById[10302] = "MessageType_StarcoinGetPublicKey"] = 10302;
    values[valuesById[10303] = "MessageType_StarcoinPublicKey"] = 10303;
    values[valuesById[10304] = "MessageType_StarcoinSignTx"] = 10304;
    values[valuesById[10305] = "MessageType_StarcoinSignedTx"] = 10305;
    values[valuesById[10306] = "MessageType_StarcoinSignMessage"] = 10306;
    values[valuesById[10307] = "MessageType_StarcoinMessageSignature"] = 10307;
    values[valuesById[10308] = "MessageType_StarcoinVerifyMessage"] = 10308;
    values[valuesById[10600] = "MessageType_AptosGetAddress"] = 10600;
    values[valuesById[10601] = "MessageType_AptosAddress"] = 10601;
    values[valuesById[10602] = "MessageType_AptosSignTx"] = 10602;
    values[valuesById[10603] = "MessageType_AptosSignedTx"] = 10603;
    values[valuesById[10604] = "MessageType_AptosSignMessage"] = 10604;
    values[valuesById[10605] = "MessageType_AptosMessageSignature"] = 10605;
    values[valuesById[10606] = "MessageType_AptosSignSIWAMessage"] = 10606;
    values[valuesById[800] = "MessageType_WebAuthnListResidentCredentials"] = 800;
    values[valuesById[801] = "MessageType_WebAuthnCredentials"] = 801;
    values[valuesById[802] = "MessageType_WebAuthnAddResidentCredential"] = 802;
    values[valuesById[803] = "MessageType_WebAuthnRemoveResidentCredential"] = 803;
    values[valuesById[901] = "MessageType_BixinSeedOperate"] = 901;
    values[valuesById[902] = "MessageType_BixinMessageSE"] = 902;
    values[valuesById[904] = "MessageType_BixinOutMessageSE"] = 904;
    values[valuesById[905] = "MessageType_BixinBackupRequest"] = 905;
    values[valuesById[906] = "MessageType_BixinBackupAck"] = 906;
    values[valuesById[907] = "MessageType_BixinRestoreRequest"] = 907;
    values[valuesById[908] = "MessageType_BixinRestoreAck"] = 908;
    values[valuesById[909] = "MessageType_BixinVerifyDeviceRequest"] = 909;
    values[valuesById[910] = "MessageType_BixinVerifyDeviceAck"] = 910;
    values[valuesById[911] = "MessageType_BixinWhiteListRequest"] = 911;
    values[valuesById[912] = "MessageType_BixinWhiteListAck"] = 912;
    values[valuesById[913] = "MessageType_BixinLoadDevice"] = 913;
    values[valuesById[914] = "MessageType_BixinBackupDevice"] = 914;
    values[valuesById[915] = "MessageType_BixinBackupDeviceAck"] = 915;
    values[valuesById[10000] = "MessageType_BixinPinInputOnDevice"] = 10000;
    values[valuesById[10200] = "MessageType_EthereumSignMessageEIP712"] = 10200;
    values[valuesById[10210] = "MessageType_GetPublicKeyMultiple"] = 10210;
    values[valuesById[10211] = "MessageType_PublicKeyMultiple"] = 10211;
    values[valuesById[10112] = "MessageType_ConfluxGetAddress"] = 10112;
    values[valuesById[10113] = "MessageType_ConfluxAddress"] = 10113;
    values[valuesById[10114] = "MessageType_ConfluxSignTx"] = 10114;
    values[valuesById[10115] = "MessageType_ConfluxTxRequest"] = 10115;
    values[valuesById[10116] = "MessageType_ConfluxTxAck"] = 10116;
    values[valuesById[10117] = "MessageType_ConfluxSignMessage"] = 10117;
    values[valuesById[10118] = "MessageType_ConfluxSignMessageCIP23"] = 10118;
    values[valuesById[10119] = "MessageType_ConfluxMessageSignature"] = 10119;
    values[valuesById[10501] = "MessageType_TronGetAddress"] = 10501;
    values[valuesById[10502] = "MessageType_TronAddress"] = 10502;
    values[valuesById[10503] = "MessageType_TronSignTx"] = 10503;
    values[valuesById[10504] = "MessageType_TronSignedTx"] = 10504;
    values[valuesById[10505] = "MessageType_TronSignMessage"] = 10505;
    values[valuesById[10506] = "MessageType_TronMessageSignature"] = 10506;
    values[valuesById[10701] = "MessageType_NearGetAddress"] = 10701;
    values[valuesById[10702] = "MessageType_NearAddress"] = 10702;
    values[valuesById[10703] = "MessageType_NearSignTx"] = 10703;
    values[valuesById[10704] = "MessageType_NearSignedTx"] = 10704;
    values[valuesById[10800] = "MessageType_CosmosGetAddress"] = 10800;
    values[valuesById[10801] = "MessageType_CosmosAddress"] = 10801;
    values[valuesById[10802] = "MessageType_CosmosSignTx"] = 10802;
    values[valuesById[10803] = "MessageType_CosmosSignedTx"] = 10803;
    values[valuesById[10900] = "MessageType_AlgorandGetAddress"] = 10900;
    values[valuesById[10901] = "MessageType_AlgorandAddress"] = 10901;
    values[valuesById[10902] = "MessageType_AlgorandSignTx"] = 10902;
    values[valuesById[10903] = "MessageType_AlgorandSignedTx"] = 10903;
    values[valuesById[11000] = "MessageType_PolkadotGetAddress"] = 11000;
    values[valuesById[11001] = "MessageType_PolkadotAddress"] = 11001;
    values[valuesById[11002] = "MessageType_PolkadotSignTx"] = 11002;
    values[valuesById[11003] = "MessageType_PolkadotSignedTx"] = 11003;
    values[valuesById[11100] = "MessageType_SuiGetAddress"] = 11100;
    values[valuesById[11101] = "MessageType_SuiAddress"] = 11101;
    values[valuesById[11102] = "MessageType_SuiSignTx"] = 11102;
    values[valuesById[11103] = "MessageType_SuiSignedTx"] = 11103;
    values[valuesById[11104] = "MessageType_SuiSignMessage"] = 11104;
    values[valuesById[11105] = "MessageType_SuiMessageSignature"] = 11105;
    values[valuesById[11106] = "MessageType_SuiTxRequest"] = 11106;
    values[valuesById[11107] = "MessageType_SuiTxAck"] = 11107;
    values[valuesById[11200] = "MessageType_FilecoinGetAddress"] = 11200;
    values[valuesById[11201] = "MessageType_FilecoinAddress"] = 11201;
    values[valuesById[11202] = "MessageType_FilecoinSignTx"] = 11202;
    values[valuesById[11203] = "MessageType_FilecoinSignedTx"] = 11203;
    values[valuesById[11300] = "MessageType_KaspaGetAddress"] = 11300;
    values[valuesById[11301] = "MessageType_KaspaAddress"] = 11301;
    values[valuesById[11302] = "MessageType_KaspaSignTx"] = 11302;
    values[valuesById[11303] = "MessageType_KaspaSignedTx"] = 11303;
    values[valuesById[11304] = "MessageType_KaspaTxInputRequest"] = 11304;
    values[valuesById[11305] = "MessageType_KaspaTxInputAck"] = 11305;
    values[valuesById[11306] = "MessageType_KaspaTxRequest"] = 11306;
    values[valuesById[11307] = "MessageType_KaspaTxAckInput"] = 11307;
    values[valuesById[11308] = "MessageType_KaspaTxAckOutput"] = 11308;
    values[valuesById[11309] = "MessageType_KaspaTxAckPayloadChunk"] = 11309;
    values[valuesById[11310] = "MessageType_KaspaTxAckPrevMeta"] = 11310;
    values[valuesById[11311] = "MessageType_KaspaTxAckPrevInput"] = 11311;
    values[valuesById[11312] = "MessageType_KaspaTxAckPrevOutput"] = 11312;
    values[valuesById[11400] = "MessageType_NexaGetAddress"] = 11400;
    values[valuesById[11401] = "MessageType_NexaAddress"] = 11401;
    values[valuesById[11402] = "MessageType_NexaSignTx"] = 11402;
    values[valuesById[11403] = "MessageType_NexaSignedTx"] = 11403;
    values[valuesById[11404] = "MessageType_NexaTxInputRequest"] = 11404;
    values[valuesById[11405] = "MessageType_NexaTxInputAck"] = 11405;
    values[valuesById[11500] = "MessageType_NostrGetPublicKey"] = 11500;
    values[valuesById[11501] = "MessageType_NostrPublicKey"] = 11501;
    values[valuesById[11502] = "MessageType_NostrSignEvent"] = 11502;
    values[valuesById[11503] = "MessageType_NostrSignedEvent"] = 11503;
    values[valuesById[11504] = "MessageType_NostrEncryptMessage"] = 11504;
    values[valuesById[11505] = "MessageType_NostrEncryptedMessage"] = 11505;
    values[valuesById[11506] = "MessageType_NostrDecryptMessage"] = 11506;
    values[valuesById[11507] = "MessageType_NostrDecryptedMessage"] = 11507;
    values[valuesById[11508] = "MessageType_NostrSignSchnorr"] = 11508;
    values[valuesById[11509] = "MessageType_NostrSignedSchnorr"] = 11509;
    values[valuesById[11600] = "MessageType_LnurlAuth"] = 11600;
    values[valuesById[11601] = "MessageType_LnurlAuthResp"] = 11601;
    values[valuesById[11701] = "MessageType_NervosGetAddress"] = 11701;
    values[valuesById[11702] = "MessageType_NervosAddress"] = 11702;
    values[valuesById[11703] = "MessageType_NervosSignTx"] = 11703;
    values[valuesById[11704] = "MessageType_NervosSignedTx"] = 11704;
    values[valuesById[11705] = "MessageType_NervosTxRequest"] = 11705;
    values[valuesById[11706] = "MessageType_NervosTxAck"] = 11706;
    values[valuesById[11800] = "MessageType_DnxGetAddress"] = 11800;
    values[valuesById[11801] = "MessageType_DnxAddress"] = 11801;
    values[valuesById[11802] = "MessageType_DnxSignTx"] = 11802;
    values[valuesById[11803] = "MessageType_DnxInputRequest"] = 11803;
    values[valuesById[11804] = "MessageType_DnxInputAck"] = 11804;
    values[valuesById[11805] = "MessageType_DnxRTSigsRequest"] = 11805;
    values[valuesById[11806] = "MessageType_DnxSignedTx"] = 11806;
    values[valuesById[11901] = "MessageType_TonGetAddress"] = 11901;
    values[valuesById[11902] = "MessageType_TonAddress"] = 11902;
    values[valuesById[11903] = "MessageType_TonSignMessage"] = 11903;
    values[valuesById[11904] = "MessageType_TonSignedMessage"] = 11904;
    values[valuesById[11905] = "MessageType_TonSignProof"] = 11905;
    values[valuesById[11906] = "MessageType_TonSignedProof"] = 11906;
    values[valuesById[11907] = "MessageType_TonTxAck"] = 11907;
    values[valuesById[11908] = "MessageType_TonSignData"] = 11908;
    values[valuesById[11909] = "MessageType_TonSignedData"] = 11909;
    values[valuesById[12001] = "MessageType_ScdoGetAddress"] = 12001;
    values[valuesById[12002] = "MessageType_ScdoAddress"] = 12002;
    values[valuesById[12003] = "MessageType_ScdoSignTx"] = 12003;
    values[valuesById[12004] = "MessageType_ScdoSignedTx"] = 12004;
    values[valuesById[12005] = "MessageType_ScdoTxAck"] = 12005;
    values[valuesById[12006] = "MessageType_ScdoSignMessage"] = 12006;
    values[valuesById[12007] = "MessageType_ScdoSignedMessage"] = 12007;
    values[valuesById[12101] = "MessageType_AlephiumGetAddress"] = 12101;
    values[valuesById[12102] = "MessageType_AlephiumAddress"] = 12102;
    values[valuesById[12103] = "MessageType_AlephiumSignTx"] = 12103;
    values[valuesById[12104] = "MessageType_AlephiumSignedTx"] = 12104;
    values[valuesById[12105] = "MessageType_AlephiumTxRequest"] = 12105;
    values[valuesById[12106] = "MessageType_AlephiumTxAck"] = 12106;
    values[valuesById[12107] = "MessageType_AlephiumBytecodeRequest"] = 12107;
    values[valuesById[12108] = "MessageType_AlephiumBytecodeAck"] = 12108;
    values[valuesById[12109] = "MessageType_AlephiumSignMessage"] = 12109;
    values[valuesById[12110] = "MessageType_AlephiumMessageSignature"] = 12110;
    values[valuesById[12201] = "MessageType_BenfenGetAddress"] = 12201;
    values[valuesById[12202] = "MessageType_BenfenAddress"] = 12202;
    values[valuesById[12203] = "MessageType_BenfenSignTx"] = 12203;
    values[valuesById[12204] = "MessageType_BenfenSignedTx"] = 12204;
    values[valuesById[12205] = "MessageType_BenfenSignMessage"] = 12205;
    values[valuesById[12206] = "MessageType_BenfenMessageSignature"] = 12206;
    values[valuesById[12207] = "MessageType_BenfenTxRequest"] = 12207;
    values[valuesById[12208] = "MessageType_BenfenTxAck"] = 12208;
    values[valuesById[12301] = "MessageType_NeoGetAddress"] = 12301;
    values[valuesById[12302] = "MessageType_NeoAddress"] = 12302;
    values[valuesById[12303] = "MessageType_NeoSignTx"] = 12303;
    values[valuesById[12304] = "MessageType_NeoSignedTx"] = 12304;
    values[valuesById[903] = "MessageType_DeviceBackToBoot"] = 903;
    values[valuesById[10001] = "MessageType_DeviceInfoSettings"] = 10001;
    values[valuesById[10002] = "MessageType_GetDeviceInfo"] = 10002;
    values[valuesById[10003] = "MessageType_DeviceInfo"] = 10003;
    values[valuesById[10004] = "MessageType_ReadSEPublicKey"] = 10004;
    values[valuesById[10005] = "MessageType_SEPublicKey"] = 10005;
    values[valuesById[10006] = "MessageType_WriteSEPublicCert"] = 10006;
    values[valuesById[10007] = "MessageType_ReadSEPublicCert"] = 10007;
    values[valuesById[10008] = "MessageType_SEPublicCert"] = 10008;
    values[valuesById[10009] = "MessageType_SpiFlashWrite"] = 10009;
    values[valuesById[10010] = "MessageType_SpiFlashRead"] = 10010;
    values[valuesById[10011] = "MessageType_SpiFlashData"] = 10011;
    values[valuesById[10012] = "MessageType_SESignMessage"] = 10012;
    values[valuesById[10013] = "MessageType_SEMessageSignature"] = 10013;
    values[valuesById[10014] = "MessageType_NFTWriteInfo"] = 10014;
    values[valuesById[10015] = "MessageType_NFTWriteData"] = 10015;
    values[valuesById[10018] = "MessageType_ResourceUpload"] = 10018;
    values[valuesById[10019] = "MessageType_ZoomRequest"] = 10019;
    values[valuesById[10032] = "MessageType_BlurRequest"] = 10032;
    values[valuesById[10020] = "MessageType_ResourceRequest"] = 10020;
    values[valuesById[10021] = "MessageType_ResourceAck"] = 10021;
    values[valuesById[10022] = "MessageType_ResourceUpdate"] = 10022;
    values[valuesById[10023] = "MessageType_ListResDir"] = 10023;
    values[valuesById[10024] = "MessageType_FileInfoList"] = 10024;
    values[valuesById[10025] = "MessageType_OnekeyGetFeatures"] = 10025;
    values[valuesById[10026] = "MessageType_OnekeyFeatures"] = 10026;
    values[valuesById[10028] = "MessageType_GetPassphraseState"] = 10028;
    values[valuesById[10029] = "MessageType_PassphraseState"] = 10029;
    values[valuesById[10030] = "MessageType_UnLockDevice"] = 10030;
    values[valuesById[10031] = "MessageType_UnLockDeviceResponse"] = 10031;
    values[valuesById[10050] = "MessageType_UpgradeFileHeader"] = 10050;
    return values;
})();

$root.CanonicalBitcoinNetwork = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "BITCOIN_MAINNET"] = 0;
    values[valuesById[1] = "BITCOIN_TESTNET"] = 1;
    values[valuesById[2] = "BITCOIN_SIGNET"] = 2;
    values[valuesById[3] = "BITCOIN_REGTEST"] = 3;
    return values;
})();

$root.BabylonDeriveContextHash = (function() {

    function BabylonDeriveContextHash(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    BabylonDeriveContextHash.prototype.address_n = $util.emptyArray;
    BabylonDeriveContextHash.prototype.script_type = 0;
    BabylonDeriveContextHash.prototype.app_name = $util.newBuffer([]);
    BabylonDeriveContextHash.prototype.context = $util.newBuffer([]);
    BabylonDeriveContextHash.prototype.network = 0;

    BabylonDeriveContextHash.create = function create(properties) {
        return new BabylonDeriveContextHash(properties);
    };

    BabylonDeriveContextHash.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(16).int32(message.script_type);
        writer.uint32(26).bytes(message.app_name);
        writer.uint32(34).bytes(message.context);
        writer.uint32(40).int32(message.network);
        return writer;
    };

    BabylonDeriveContextHash.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    BabylonDeriveContextHash.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BabylonDeriveContextHash();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.script_type = reader.int32();
                break;
            case 3:
                message.app_name = reader.bytes();
                break;
            case 4:
                message.context = reader.bytes();
                break;
            case 5:
                message.network = reader.int32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("script_type"))
            throw $util.ProtocolError("missing required 'script_type'", { instance: message });
        if (!message.hasOwnProperty("app_name"))
            throw $util.ProtocolError("missing required 'app_name'", { instance: message });
        if (!message.hasOwnProperty("context"))
            throw $util.ProtocolError("missing required 'context'", { instance: message });
        if (!message.hasOwnProperty("network"))
            throw $util.ProtocolError("missing required 'network'", { instance: message });
        return message;
    };

    BabylonDeriveContextHash.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    BabylonDeriveContextHash.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        switch (message.script_type) {
        default:
            return "script_type: enum value expected";
        case 0:
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        }
        if (!(message.app_name && typeof message.app_name.length === "number" || $util.isString(message.app_name)))
            return "app_name: buffer expected";
        if (!(message.context && typeof message.context.length === "number" || $util.isString(message.context)))
            return "context: buffer expected";
        switch (message.network) {
        default:
            return "network: enum value expected";
        case 0:
        case 1:
        case 2:
        case 3:
            break;
        }
        return null;
    };

    BabylonDeriveContextHash.fromObject = function fromObject(object) {
        if (object instanceof $root.BabylonDeriveContextHash)
            return object;
        var message = new $root.BabylonDeriveContextHash();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".BabylonDeriveContextHash.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        switch (object.script_type) {
        case "SPENDADDRESS":
        case 0:
            message.script_type = 0;
            break;
        case "SPENDMULTISIG":
        case 1:
            message.script_type = 1;
            break;
        case "EXTERNAL":
        case 2:
            message.script_type = 2;
            break;
        case "SPENDWITNESS":
        case 3:
            message.script_type = 3;
            break;
        case "SPENDP2SHWITNESS":
        case 4:
            message.script_type = 4;
            break;
        case "SPENDTAPROOT":
        case 5:
            message.script_type = 5;
            break;
        }
        if (object.app_name != null)
            if (typeof object.app_name === "string")
                $util.base64.decode(object.app_name, message.app_name = $util.newBuffer($util.base64.length(object.app_name)), 0);
            else if (object.app_name.length)
                message.app_name = object.app_name;
        if (object.context != null)
            if (typeof object.context === "string")
                $util.base64.decode(object.context, message.context = $util.newBuffer($util.base64.length(object.context)), 0);
            else if (object.context.length)
                message.context = object.context;
        switch (object.network) {
        case "BITCOIN_MAINNET":
        case 0:
            message.network = 0;
            break;
        case "BITCOIN_TESTNET":
        case 1:
            message.network = 1;
            break;
        case "BITCOIN_SIGNET":
        case 2:
            message.network = 2;
            break;
        case "BITCOIN_REGTEST":
        case 3:
            message.network = 3;
            break;
        }
        return message;
    };

    BabylonDeriveContextHash.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            object.script_type = options.enums === String ? "SPENDADDRESS" : 0;
            if (options.bytes === String)
                object.app_name = "";
            else {
                object.app_name = [];
                if (options.bytes !== Array)
                    object.app_name = $util.newBuffer(object.app_name);
            }
            if (options.bytes === String)
                object.context = "";
            else {
                object.context = [];
                if (options.bytes !== Array)
                    object.context = $util.newBuffer(object.context);
            }
            object.network = options.enums === String ? "BITCOIN_MAINNET" : 0;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.script_type != null && message.hasOwnProperty("script_type"))
            object.script_type = options.enums === String ? $root.InputScriptType[message.script_type] : message.script_type;
        if (message.app_name != null && message.hasOwnProperty("app_name"))
            object.app_name = options.bytes === String ? $util.base64.encode(message.app_name, 0, message.app_name.length) : options.bytes === Array ? Array.prototype.slice.call(message.app_name) : message.app_name;
        if (message.context != null && message.hasOwnProperty("context"))
            object.context = options.bytes === String ? $util.base64.encode(message.context, 0, message.context.length) : options.bytes === Array ? Array.prototype.slice.call(message.context) : message.context;
        if (message.network != null && message.hasOwnProperty("network"))
            object.network = options.enums === String ? $root.CanonicalBitcoinNetwork[message.network] : message.network;
        return object;
    };

    BabylonDeriveContextHash.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return BabylonDeriveContextHash;
})();

$root.BabylonDerivedContextHash = (function() {

    function BabylonDerivedContextHash(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    BabylonDerivedContextHash.prototype.secret = $util.newBuffer([]);

    BabylonDerivedContextHash.create = function create(properties) {
        return new BabylonDerivedContextHash(properties);
    };

    BabylonDerivedContextHash.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.secret);
        return writer;
    };

    BabylonDerivedContextHash.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    BabylonDerivedContextHash.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BabylonDerivedContextHash();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.secret = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("secret"))
            throw $util.ProtocolError("missing required 'secret'", { instance: message });
        return message;
    };

    BabylonDerivedContextHash.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    BabylonDerivedContextHash.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.secret && typeof message.secret.length === "number" || $util.isString(message.secret)))
            return "secret: buffer expected";
        return null;
    };

    BabylonDerivedContextHash.fromObject = function fromObject(object) {
        if (object instanceof $root.BabylonDerivedContextHash)
            return object;
        var message = new $root.BabylonDerivedContextHash();
        if (object.secret != null)
            if (typeof object.secret === "string")
                $util.base64.decode(object.secret, message.secret = $util.newBuffer($util.base64.length(object.secret)), 0);
            else if (object.secret.length)
                message.secret = object.secret;
        return message;
    };

    BabylonDerivedContextHash.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.secret = "";
            else {
                object.secret = [];
                if (options.bytes !== Array)
                    object.secret = $util.newBuffer(object.secret);
            }
        if (message.secret != null && message.hasOwnProperty("secret"))
            object.secret = options.bytes === String ? $util.base64.encode(message.secret, 0, message.secret.length) : options.bytes === Array ? Array.prototype.slice.call(message.secret) : message.secret;
        return object;
    };

    BabylonDerivedContextHash.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return BabylonDerivedContextHash;
})();

$root.google = (function() {

    var google = {};

    google.protobuf = (function() {

        var protobuf = {};

        protobuf.FileDescriptorSet = (function() {

            function FileDescriptorSet(properties) {
                this.file = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            FileDescriptorSet.prototype.file = $util.emptyArray;

            FileDescriptorSet.create = function create(properties) {
                return new FileDescriptorSet(properties);
            };

            FileDescriptorSet.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.file != null && message.file.length)
                    for (var i = 0; i < message.file.length; ++i)
                        $root.google.protobuf.FileDescriptorProto.encode(message.file[i], writer.uint32(10).fork()).ldelim();
                return writer;
            };

            FileDescriptorSet.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            FileDescriptorSet.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.FileDescriptorSet();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (!(message.file && message.file.length))
                            message.file = [];
                        message.file.push($root.google.protobuf.FileDescriptorProto.decode(reader, reader.uint32()));
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            FileDescriptorSet.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            FileDescriptorSet.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.file != null && message.hasOwnProperty("file")) {
                    if (!Array.isArray(message.file))
                        return "file: array expected";
                    for (var i = 0; i < message.file.length; ++i) {
                        var error = $root.google.protobuf.FileDescriptorProto.verify(message.file[i]);
                        if (error)
                            return "file." + error;
                    }
                }
                return null;
            };

            FileDescriptorSet.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.FileDescriptorSet)
                    return object;
                var message = new $root.google.protobuf.FileDescriptorSet();
                if (object.file) {
                    if (!Array.isArray(object.file))
                        throw TypeError(".google.protobuf.FileDescriptorSet.file: array expected");
                    message.file = [];
                    for (var i = 0; i < object.file.length; ++i) {
                        if (typeof object.file[i] !== "object")
                            throw TypeError(".google.protobuf.FileDescriptorSet.file: object expected");
                        message.file[i] = $root.google.protobuf.FileDescriptorProto.fromObject(object.file[i]);
                    }
                }
                return message;
            };

            FileDescriptorSet.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.file = [];
                if (message.file && message.file.length) {
                    object.file = [];
                    for (var j = 0; j < message.file.length; ++j)
                        object.file[j] = $root.google.protobuf.FileDescriptorProto.toObject(message.file[j], options);
                }
                return object;
            };

            FileDescriptorSet.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return FileDescriptorSet;
        })();

        protobuf.FileDescriptorProto = (function() {

            function FileDescriptorProto(properties) {
                this.dependency = [];
                this.public_dependency = [];
                this.weak_dependency = [];
                this.message_type = [];
                this.enum_type = [];
                this.service = [];
                this.extension = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            FileDescriptorProto.prototype.name = "";
            FileDescriptorProto.prototype["package"] = "";
            FileDescriptorProto.prototype.dependency = $util.emptyArray;
            FileDescriptorProto.prototype.public_dependency = $util.emptyArray;
            FileDescriptorProto.prototype.weak_dependency = $util.emptyArray;
            FileDescriptorProto.prototype.message_type = $util.emptyArray;
            FileDescriptorProto.prototype.enum_type = $util.emptyArray;
            FileDescriptorProto.prototype.service = $util.emptyArray;
            FileDescriptorProto.prototype.extension = $util.emptyArray;
            FileDescriptorProto.prototype.options = null;
            FileDescriptorProto.prototype.source_code_info = null;
            FileDescriptorProto.prototype.syntax = "";

            FileDescriptorProto.create = function create(properties) {
                return new FileDescriptorProto(properties);
            };

            FileDescriptorProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                    writer.uint32(10).string(message.name);
                if (message["package"] != null && Object.hasOwnProperty.call(message, "package"))
                    writer.uint32(18).string(message["package"]);
                if (message.dependency != null && message.dependency.length)
                    for (var i = 0; i < message.dependency.length; ++i)
                        writer.uint32(26).string(message.dependency[i]);
                if (message.message_type != null && message.message_type.length)
                    for (var i = 0; i < message.message_type.length; ++i)
                        $root.google.protobuf.DescriptorProto.encode(message.message_type[i], writer.uint32(34).fork()).ldelim();
                if (message.enum_type != null && message.enum_type.length)
                    for (var i = 0; i < message.enum_type.length; ++i)
                        $root.google.protobuf.EnumDescriptorProto.encode(message.enum_type[i], writer.uint32(42).fork()).ldelim();
                if (message.service != null && message.service.length)
                    for (var i = 0; i < message.service.length; ++i)
                        $root.google.protobuf.ServiceDescriptorProto.encode(message.service[i], writer.uint32(50).fork()).ldelim();
                if (message.extension != null && message.extension.length)
                    for (var i = 0; i < message.extension.length; ++i)
                        $root.google.protobuf.FieldDescriptorProto.encode(message.extension[i], writer.uint32(58).fork()).ldelim();
                if (message.options != null && Object.hasOwnProperty.call(message, "options"))
                    $root.google.protobuf.FileOptions.encode(message.options, writer.uint32(66).fork()).ldelim();
                if (message.source_code_info != null && Object.hasOwnProperty.call(message, "source_code_info"))
                    $root.google.protobuf.SourceCodeInfo.encode(message.source_code_info, writer.uint32(74).fork()).ldelim();
                if (message.public_dependency != null && message.public_dependency.length)
                    for (var i = 0; i < message.public_dependency.length; ++i)
                        writer.uint32(80).int32(message.public_dependency[i]);
                if (message.weak_dependency != null && message.weak_dependency.length)
                    for (var i = 0; i < message.weak_dependency.length; ++i)
                        writer.uint32(88).int32(message.weak_dependency[i]);
                if (message.syntax != null && Object.hasOwnProperty.call(message, "syntax"))
                    writer.uint32(98).string(message.syntax);
                return writer;
            };

            FileDescriptorProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            FileDescriptorProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.FileDescriptorProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.name = reader.string();
                        break;
                    case 2:
                        message["package"] = reader.string();
                        break;
                    case 3:
                        if (!(message.dependency && message.dependency.length))
                            message.dependency = [];
                        message.dependency.push(reader.string());
                        break;
                    case 10:
                        if (!(message.public_dependency && message.public_dependency.length))
                            message.public_dependency = [];
                        if ((tag & 7) === 2) {
                            var end2 = reader.uint32() + reader.pos;
                            while (reader.pos < end2)
                                message.public_dependency.push(reader.int32());
                        } else
                            message.public_dependency.push(reader.int32());
                        break;
                    case 11:
                        if (!(message.weak_dependency && message.weak_dependency.length))
                            message.weak_dependency = [];
                        if ((tag & 7) === 2) {
                            var end2 = reader.uint32() + reader.pos;
                            while (reader.pos < end2)
                                message.weak_dependency.push(reader.int32());
                        } else
                            message.weak_dependency.push(reader.int32());
                        break;
                    case 4:
                        if (!(message.message_type && message.message_type.length))
                            message.message_type = [];
                        message.message_type.push($root.google.protobuf.DescriptorProto.decode(reader, reader.uint32()));
                        break;
                    case 5:
                        if (!(message.enum_type && message.enum_type.length))
                            message.enum_type = [];
                        message.enum_type.push($root.google.protobuf.EnumDescriptorProto.decode(reader, reader.uint32()));
                        break;
                    case 6:
                        if (!(message.service && message.service.length))
                            message.service = [];
                        message.service.push($root.google.protobuf.ServiceDescriptorProto.decode(reader, reader.uint32()));
                        break;
                    case 7:
                        if (!(message.extension && message.extension.length))
                            message.extension = [];
                        message.extension.push($root.google.protobuf.FieldDescriptorProto.decode(reader, reader.uint32()));
                        break;
                    case 8:
                        message.options = $root.google.protobuf.FileOptions.decode(reader, reader.uint32());
                        break;
                    case 9:
                        message.source_code_info = $root.google.protobuf.SourceCodeInfo.decode(reader, reader.uint32());
                        break;
                    case 12:
                        message.syntax = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            FileDescriptorProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            FileDescriptorProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.name != null && message.hasOwnProperty("name"))
                    if (!$util.isString(message.name))
                        return "name: string expected";
                if (message["package"] != null && message.hasOwnProperty("package"))
                    if (!$util.isString(message["package"]))
                        return "package: string expected";
                if (message.dependency != null && message.hasOwnProperty("dependency")) {
                    if (!Array.isArray(message.dependency))
                        return "dependency: array expected";
                    for (var i = 0; i < message.dependency.length; ++i)
                        if (!$util.isString(message.dependency[i]))
                            return "dependency: string[] expected";
                }
                if (message.public_dependency != null && message.hasOwnProperty("public_dependency")) {
                    if (!Array.isArray(message.public_dependency))
                        return "public_dependency: array expected";
                    for (var i = 0; i < message.public_dependency.length; ++i)
                        if (!$util.isInteger(message.public_dependency[i]))
                            return "public_dependency: integer[] expected";
                }
                if (message.weak_dependency != null && message.hasOwnProperty("weak_dependency")) {
                    if (!Array.isArray(message.weak_dependency))
                        return "weak_dependency: array expected";
                    for (var i = 0; i < message.weak_dependency.length; ++i)
                        if (!$util.isInteger(message.weak_dependency[i]))
                            return "weak_dependency: integer[] expected";
                }
                if (message.message_type != null && message.hasOwnProperty("message_type")) {
                    if (!Array.isArray(message.message_type))
                        return "message_type: array expected";
                    for (var i = 0; i < message.message_type.length; ++i) {
                        var error = $root.google.protobuf.DescriptorProto.verify(message.message_type[i]);
                        if (error)
                            return "message_type." + error;
                    }
                }
                if (message.enum_type != null && message.hasOwnProperty("enum_type")) {
                    if (!Array.isArray(message.enum_type))
                        return "enum_type: array expected";
                    for (var i = 0; i < message.enum_type.length; ++i) {
                        var error = $root.google.protobuf.EnumDescriptorProto.verify(message.enum_type[i]);
                        if (error)
                            return "enum_type." + error;
                    }
                }
                if (message.service != null && message.hasOwnProperty("service")) {
                    if (!Array.isArray(message.service))
                        return "service: array expected";
                    for (var i = 0; i < message.service.length; ++i) {
                        var error = $root.google.protobuf.ServiceDescriptorProto.verify(message.service[i]);
                        if (error)
                            return "service." + error;
                    }
                }
                if (message.extension != null && message.hasOwnProperty("extension")) {
                    if (!Array.isArray(message.extension))
                        return "extension: array expected";
                    for (var i = 0; i < message.extension.length; ++i) {
                        var error = $root.google.protobuf.FieldDescriptorProto.verify(message.extension[i]);
                        if (error)
                            return "extension." + error;
                    }
                }
                if (message.options != null && message.hasOwnProperty("options")) {
                    var error = $root.google.protobuf.FileOptions.verify(message.options);
                    if (error)
                        return "options." + error;
                }
                if (message.source_code_info != null && message.hasOwnProperty("source_code_info")) {
                    var error = $root.google.protobuf.SourceCodeInfo.verify(message.source_code_info);
                    if (error)
                        return "source_code_info." + error;
                }
                if (message.syntax != null && message.hasOwnProperty("syntax"))
                    if (!$util.isString(message.syntax))
                        return "syntax: string expected";
                return null;
            };

            FileDescriptorProto.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.FileDescriptorProto)
                    return object;
                var message = new $root.google.protobuf.FileDescriptorProto();
                if (object.name != null)
                    message.name = String(object.name);
                if (object["package"] != null)
                    message["package"] = String(object["package"]);
                if (object.dependency) {
                    if (!Array.isArray(object.dependency))
                        throw TypeError(".google.protobuf.FileDescriptorProto.dependency: array expected");
                    message.dependency = [];
                    for (var i = 0; i < object.dependency.length; ++i)
                        message.dependency[i] = String(object.dependency[i]);
                }
                if (object.public_dependency) {
                    if (!Array.isArray(object.public_dependency))
                        throw TypeError(".google.protobuf.FileDescriptorProto.public_dependency: array expected");
                    message.public_dependency = [];
                    for (var i = 0; i < object.public_dependency.length; ++i)
                        message.public_dependency[i] = object.public_dependency[i] | 0;
                }
                if (object.weak_dependency) {
                    if (!Array.isArray(object.weak_dependency))
                        throw TypeError(".google.protobuf.FileDescriptorProto.weak_dependency: array expected");
                    message.weak_dependency = [];
                    for (var i = 0; i < object.weak_dependency.length; ++i)
                        message.weak_dependency[i] = object.weak_dependency[i] | 0;
                }
                if (object.message_type) {
                    if (!Array.isArray(object.message_type))
                        throw TypeError(".google.protobuf.FileDescriptorProto.message_type: array expected");
                    message.message_type = [];
                    for (var i = 0; i < object.message_type.length; ++i) {
                        if (typeof object.message_type[i] !== "object")
                            throw TypeError(".google.protobuf.FileDescriptorProto.message_type: object expected");
                        message.message_type[i] = $root.google.protobuf.DescriptorProto.fromObject(object.message_type[i]);
                    }
                }
                if (object.enum_type) {
                    if (!Array.isArray(object.enum_type))
                        throw TypeError(".google.protobuf.FileDescriptorProto.enum_type: array expected");
                    message.enum_type = [];
                    for (var i = 0; i < object.enum_type.length; ++i) {
                        if (typeof object.enum_type[i] !== "object")
                            throw TypeError(".google.protobuf.FileDescriptorProto.enum_type: object expected");
                        message.enum_type[i] = $root.google.protobuf.EnumDescriptorProto.fromObject(object.enum_type[i]);
                    }
                }
                if (object.service) {
                    if (!Array.isArray(object.service))
                        throw TypeError(".google.protobuf.FileDescriptorProto.service: array expected");
                    message.service = [];
                    for (var i = 0; i < object.service.length; ++i) {
                        if (typeof object.service[i] !== "object")
                            throw TypeError(".google.protobuf.FileDescriptorProto.service: object expected");
                        message.service[i] = $root.google.protobuf.ServiceDescriptorProto.fromObject(object.service[i]);
                    }
                }
                if (object.extension) {
                    if (!Array.isArray(object.extension))
                        throw TypeError(".google.protobuf.FileDescriptorProto.extension: array expected");
                    message.extension = [];
                    for (var i = 0; i < object.extension.length; ++i) {
                        if (typeof object.extension[i] !== "object")
                            throw TypeError(".google.protobuf.FileDescriptorProto.extension: object expected");
                        message.extension[i] = $root.google.protobuf.FieldDescriptorProto.fromObject(object.extension[i]);
                    }
                }
                if (object.options != null) {
                    if (typeof object.options !== "object")
                        throw TypeError(".google.protobuf.FileDescriptorProto.options: object expected");
                    message.options = $root.google.protobuf.FileOptions.fromObject(object.options);
                }
                if (object.source_code_info != null) {
                    if (typeof object.source_code_info !== "object")
                        throw TypeError(".google.protobuf.FileDescriptorProto.source_code_info: object expected");
                    message.source_code_info = $root.google.protobuf.SourceCodeInfo.fromObject(object.source_code_info);
                }
                if (object.syntax != null)
                    message.syntax = String(object.syntax);
                return message;
            };

            FileDescriptorProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults) {
                    object.dependency = [];
                    object.message_type = [];
                    object.enum_type = [];
                    object.service = [];
                    object.extension = [];
                    object.public_dependency = [];
                    object.weak_dependency = [];
                }
                if (options.defaults) {
                    object.name = "";
                    object["package"] = "";
                    object.options = null;
                    object.source_code_info = null;
                    object.syntax = "";
                }
                if (message.name != null && message.hasOwnProperty("name"))
                    object.name = message.name;
                if (message["package"] != null && message.hasOwnProperty("package"))
                    object["package"] = message["package"];
                if (message.dependency && message.dependency.length) {
                    object.dependency = [];
                    for (var j = 0; j < message.dependency.length; ++j)
                        object.dependency[j] = message.dependency[j];
                }
                if (message.message_type && message.message_type.length) {
                    object.message_type = [];
                    for (var j = 0; j < message.message_type.length; ++j)
                        object.message_type[j] = $root.google.protobuf.DescriptorProto.toObject(message.message_type[j], options);
                }
                if (message.enum_type && message.enum_type.length) {
                    object.enum_type = [];
                    for (var j = 0; j < message.enum_type.length; ++j)
                        object.enum_type[j] = $root.google.protobuf.EnumDescriptorProto.toObject(message.enum_type[j], options);
                }
                if (message.service && message.service.length) {
                    object.service = [];
                    for (var j = 0; j < message.service.length; ++j)
                        object.service[j] = $root.google.protobuf.ServiceDescriptorProto.toObject(message.service[j], options);
                }
                if (message.extension && message.extension.length) {
                    object.extension = [];
                    for (var j = 0; j < message.extension.length; ++j)
                        object.extension[j] = $root.google.protobuf.FieldDescriptorProto.toObject(message.extension[j], options);
                }
                if (message.options != null && message.hasOwnProperty("options"))
                    object.options = $root.google.protobuf.FileOptions.toObject(message.options, options);
                if (message.source_code_info != null && message.hasOwnProperty("source_code_info"))
                    object.source_code_info = $root.google.protobuf.SourceCodeInfo.toObject(message.source_code_info, options);
                if (message.public_dependency && message.public_dependency.length) {
                    object.public_dependency = [];
                    for (var j = 0; j < message.public_dependency.length; ++j)
                        object.public_dependency[j] = message.public_dependency[j];
                }
                if (message.weak_dependency && message.weak_dependency.length) {
                    object.weak_dependency = [];
                    for (var j = 0; j < message.weak_dependency.length; ++j)
                        object.weak_dependency[j] = message.weak_dependency[j];
                }
                if (message.syntax != null && message.hasOwnProperty("syntax"))
                    object.syntax = message.syntax;
                return object;
            };

            FileDescriptorProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return FileDescriptorProto;
        })();

        protobuf.DescriptorProto = (function() {

            function DescriptorProto(properties) {
                this.field = [];
                this.extension = [];
                this.nested_type = [];
                this.enum_type = [];
                this.extension_range = [];
                this.oneof_decl = [];
                this.reserved_range = [];
                this.reserved_name = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            DescriptorProto.prototype.name = "";
            DescriptorProto.prototype.field = $util.emptyArray;
            DescriptorProto.prototype.extension = $util.emptyArray;
            DescriptorProto.prototype.nested_type = $util.emptyArray;
            DescriptorProto.prototype.enum_type = $util.emptyArray;
            DescriptorProto.prototype.extension_range = $util.emptyArray;
            DescriptorProto.prototype.oneof_decl = $util.emptyArray;
            DescriptorProto.prototype.options = null;
            DescriptorProto.prototype.reserved_range = $util.emptyArray;
            DescriptorProto.prototype.reserved_name = $util.emptyArray;

            DescriptorProto.create = function create(properties) {
                return new DescriptorProto(properties);
            };

            DescriptorProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                    writer.uint32(10).string(message.name);
                if (message.field != null && message.field.length)
                    for (var i = 0; i < message.field.length; ++i)
                        $root.google.protobuf.FieldDescriptorProto.encode(message.field[i], writer.uint32(18).fork()).ldelim();
                if (message.nested_type != null && message.nested_type.length)
                    for (var i = 0; i < message.nested_type.length; ++i)
                        $root.google.protobuf.DescriptorProto.encode(message.nested_type[i], writer.uint32(26).fork()).ldelim();
                if (message.enum_type != null && message.enum_type.length)
                    for (var i = 0; i < message.enum_type.length; ++i)
                        $root.google.protobuf.EnumDescriptorProto.encode(message.enum_type[i], writer.uint32(34).fork()).ldelim();
                if (message.extension_range != null && message.extension_range.length)
                    for (var i = 0; i < message.extension_range.length; ++i)
                        $root.google.protobuf.DescriptorProto.ExtensionRange.encode(message.extension_range[i], writer.uint32(42).fork()).ldelim();
                if (message.extension != null && message.extension.length)
                    for (var i = 0; i < message.extension.length; ++i)
                        $root.google.protobuf.FieldDescriptorProto.encode(message.extension[i], writer.uint32(50).fork()).ldelim();
                if (message.options != null && Object.hasOwnProperty.call(message, "options"))
                    $root.google.protobuf.MessageOptions.encode(message.options, writer.uint32(58).fork()).ldelim();
                if (message.oneof_decl != null && message.oneof_decl.length)
                    for (var i = 0; i < message.oneof_decl.length; ++i)
                        $root.google.protobuf.OneofDescriptorProto.encode(message.oneof_decl[i], writer.uint32(66).fork()).ldelim();
                if (message.reserved_range != null && message.reserved_range.length)
                    for (var i = 0; i < message.reserved_range.length; ++i)
                        $root.google.protobuf.DescriptorProto.ReservedRange.encode(message.reserved_range[i], writer.uint32(74).fork()).ldelim();
                if (message.reserved_name != null && message.reserved_name.length)
                    for (var i = 0; i < message.reserved_name.length; ++i)
                        writer.uint32(82).string(message.reserved_name[i]);
                return writer;
            };

            DescriptorProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            DescriptorProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.DescriptorProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.name = reader.string();
                        break;
                    case 2:
                        if (!(message.field && message.field.length))
                            message.field = [];
                        message.field.push($root.google.protobuf.FieldDescriptorProto.decode(reader, reader.uint32()));
                        break;
                    case 6:
                        if (!(message.extension && message.extension.length))
                            message.extension = [];
                        message.extension.push($root.google.protobuf.FieldDescriptorProto.decode(reader, reader.uint32()));
                        break;
                    case 3:
                        if (!(message.nested_type && message.nested_type.length))
                            message.nested_type = [];
                        message.nested_type.push($root.google.protobuf.DescriptorProto.decode(reader, reader.uint32()));
                        break;
                    case 4:
                        if (!(message.enum_type && message.enum_type.length))
                            message.enum_type = [];
                        message.enum_type.push($root.google.protobuf.EnumDescriptorProto.decode(reader, reader.uint32()));
                        break;
                    case 5:
                        if (!(message.extension_range && message.extension_range.length))
                            message.extension_range = [];
                        message.extension_range.push($root.google.protobuf.DescriptorProto.ExtensionRange.decode(reader, reader.uint32()));
                        break;
                    case 8:
                        if (!(message.oneof_decl && message.oneof_decl.length))
                            message.oneof_decl = [];
                        message.oneof_decl.push($root.google.protobuf.OneofDescriptorProto.decode(reader, reader.uint32()));
                        break;
                    case 7:
                        message.options = $root.google.protobuf.MessageOptions.decode(reader, reader.uint32());
                        break;
                    case 9:
                        if (!(message.reserved_range && message.reserved_range.length))
                            message.reserved_range = [];
                        message.reserved_range.push($root.google.protobuf.DescriptorProto.ReservedRange.decode(reader, reader.uint32()));
                        break;
                    case 10:
                        if (!(message.reserved_name && message.reserved_name.length))
                            message.reserved_name = [];
                        message.reserved_name.push(reader.string());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            DescriptorProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            DescriptorProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.name != null && message.hasOwnProperty("name"))
                    if (!$util.isString(message.name))
                        return "name: string expected";
                if (message.field != null && message.hasOwnProperty("field")) {
                    if (!Array.isArray(message.field))
                        return "field: array expected";
                    for (var i = 0; i < message.field.length; ++i) {
                        var error = $root.google.protobuf.FieldDescriptorProto.verify(message.field[i]);
                        if (error)
                            return "field." + error;
                    }
                }
                if (message.extension != null && message.hasOwnProperty("extension")) {
                    if (!Array.isArray(message.extension))
                        return "extension: array expected";
                    for (var i = 0; i < message.extension.length; ++i) {
                        var error = $root.google.protobuf.FieldDescriptorProto.verify(message.extension[i]);
                        if (error)
                            return "extension." + error;
                    }
                }
                if (message.nested_type != null && message.hasOwnProperty("nested_type")) {
                    if (!Array.isArray(message.nested_type))
                        return "nested_type: array expected";
                    for (var i = 0; i < message.nested_type.length; ++i) {
                        var error = $root.google.protobuf.DescriptorProto.verify(message.nested_type[i]);
                        if (error)
                            return "nested_type." + error;
                    }
                }
                if (message.enum_type != null && message.hasOwnProperty("enum_type")) {
                    if (!Array.isArray(message.enum_type))
                        return "enum_type: array expected";
                    for (var i = 0; i < message.enum_type.length; ++i) {
                        var error = $root.google.protobuf.EnumDescriptorProto.verify(message.enum_type[i]);
                        if (error)
                            return "enum_type." + error;
                    }
                }
                if (message.extension_range != null && message.hasOwnProperty("extension_range")) {
                    if (!Array.isArray(message.extension_range))
                        return "extension_range: array expected";
                    for (var i = 0; i < message.extension_range.length; ++i) {
                        var error = $root.google.protobuf.DescriptorProto.ExtensionRange.verify(message.extension_range[i]);
                        if (error)
                            return "extension_range." + error;
                    }
                }
                if (message.oneof_decl != null && message.hasOwnProperty("oneof_decl")) {
                    if (!Array.isArray(message.oneof_decl))
                        return "oneof_decl: array expected";
                    for (var i = 0; i < message.oneof_decl.length; ++i) {
                        var error = $root.google.protobuf.OneofDescriptorProto.verify(message.oneof_decl[i]);
                        if (error)
                            return "oneof_decl." + error;
                    }
                }
                if (message.options != null && message.hasOwnProperty("options")) {
                    var error = $root.google.protobuf.MessageOptions.verify(message.options);
                    if (error)
                        return "options." + error;
                }
                if (message.reserved_range != null && message.hasOwnProperty("reserved_range")) {
                    if (!Array.isArray(message.reserved_range))
                        return "reserved_range: array expected";
                    for (var i = 0; i < message.reserved_range.length; ++i) {
                        var error = $root.google.protobuf.DescriptorProto.ReservedRange.verify(message.reserved_range[i]);
                        if (error)
                            return "reserved_range." + error;
                    }
                }
                if (message.reserved_name != null && message.hasOwnProperty("reserved_name")) {
                    if (!Array.isArray(message.reserved_name))
                        return "reserved_name: array expected";
                    for (var i = 0; i < message.reserved_name.length; ++i)
                        if (!$util.isString(message.reserved_name[i]))
                            return "reserved_name: string[] expected";
                }
                return null;
            };

            DescriptorProto.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.DescriptorProto)
                    return object;
                var message = new $root.google.protobuf.DescriptorProto();
                if (object.name != null)
                    message.name = String(object.name);
                if (object.field) {
                    if (!Array.isArray(object.field))
                        throw TypeError(".google.protobuf.DescriptorProto.field: array expected");
                    message.field = [];
                    for (var i = 0; i < object.field.length; ++i) {
                        if (typeof object.field[i] !== "object")
                            throw TypeError(".google.protobuf.DescriptorProto.field: object expected");
                        message.field[i] = $root.google.protobuf.FieldDescriptorProto.fromObject(object.field[i]);
                    }
                }
                if (object.extension) {
                    if (!Array.isArray(object.extension))
                        throw TypeError(".google.protobuf.DescriptorProto.extension: array expected");
                    message.extension = [];
                    for (var i = 0; i < object.extension.length; ++i) {
                        if (typeof object.extension[i] !== "object")
                            throw TypeError(".google.protobuf.DescriptorProto.extension: object expected");
                        message.extension[i] = $root.google.protobuf.FieldDescriptorProto.fromObject(object.extension[i]);
                    }
                }
                if (object.nested_type) {
                    if (!Array.isArray(object.nested_type))
                        throw TypeError(".google.protobuf.DescriptorProto.nested_type: array expected");
                    message.nested_type = [];
                    for (var i = 0; i < object.nested_type.length; ++i) {
                        if (typeof object.nested_type[i] !== "object")
                            throw TypeError(".google.protobuf.DescriptorProto.nested_type: object expected");
                        message.nested_type[i] = $root.google.protobuf.DescriptorProto.fromObject(object.nested_type[i]);
                    }
                }
                if (object.enum_type) {
                    if (!Array.isArray(object.enum_type))
                        throw TypeError(".google.protobuf.DescriptorProto.enum_type: array expected");
                    message.enum_type = [];
                    for (var i = 0; i < object.enum_type.length; ++i) {
                        if (typeof object.enum_type[i] !== "object")
                            throw TypeError(".google.protobuf.DescriptorProto.enum_type: object expected");
                        message.enum_type[i] = $root.google.protobuf.EnumDescriptorProto.fromObject(object.enum_type[i]);
                    }
                }
                if (object.extension_range) {
                    if (!Array.isArray(object.extension_range))
                        throw TypeError(".google.protobuf.DescriptorProto.extension_range: array expected");
                    message.extension_range = [];
                    for (var i = 0; i < object.extension_range.length; ++i) {
                        if (typeof object.extension_range[i] !== "object")
                            throw TypeError(".google.protobuf.DescriptorProto.extension_range: object expected");
                        message.extension_range[i] = $root.google.protobuf.DescriptorProto.ExtensionRange.fromObject(object.extension_range[i]);
                    }
                }
                if (object.oneof_decl) {
                    if (!Array.isArray(object.oneof_decl))
                        throw TypeError(".google.protobuf.DescriptorProto.oneof_decl: array expected");
                    message.oneof_decl = [];
                    for (var i = 0; i < object.oneof_decl.length; ++i) {
                        if (typeof object.oneof_decl[i] !== "object")
                            throw TypeError(".google.protobuf.DescriptorProto.oneof_decl: object expected");
                        message.oneof_decl[i] = $root.google.protobuf.OneofDescriptorProto.fromObject(object.oneof_decl[i]);
                    }
                }
                if (object.options != null) {
                    if (typeof object.options !== "object")
                        throw TypeError(".google.protobuf.DescriptorProto.options: object expected");
                    message.options = $root.google.protobuf.MessageOptions.fromObject(object.options);
                }
                if (object.reserved_range) {
                    if (!Array.isArray(object.reserved_range))
                        throw TypeError(".google.protobuf.DescriptorProto.reserved_range: array expected");
                    message.reserved_range = [];
                    for (var i = 0; i < object.reserved_range.length; ++i) {
                        if (typeof object.reserved_range[i] !== "object")
                            throw TypeError(".google.protobuf.DescriptorProto.reserved_range: object expected");
                        message.reserved_range[i] = $root.google.protobuf.DescriptorProto.ReservedRange.fromObject(object.reserved_range[i]);
                    }
                }
                if (object.reserved_name) {
                    if (!Array.isArray(object.reserved_name))
                        throw TypeError(".google.protobuf.DescriptorProto.reserved_name: array expected");
                    message.reserved_name = [];
                    for (var i = 0; i < object.reserved_name.length; ++i)
                        message.reserved_name[i] = String(object.reserved_name[i]);
                }
                return message;
            };

            DescriptorProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults) {
                    object.field = [];
                    object.nested_type = [];
                    object.enum_type = [];
                    object.extension_range = [];
                    object.extension = [];
                    object.oneof_decl = [];
                    object.reserved_range = [];
                    object.reserved_name = [];
                }
                if (options.defaults) {
                    object.name = "";
                    object.options = null;
                }
                if (message.name != null && message.hasOwnProperty("name"))
                    object.name = message.name;
                if (message.field && message.field.length) {
                    object.field = [];
                    for (var j = 0; j < message.field.length; ++j)
                        object.field[j] = $root.google.protobuf.FieldDescriptorProto.toObject(message.field[j], options);
                }
                if (message.nested_type && message.nested_type.length) {
                    object.nested_type = [];
                    for (var j = 0; j < message.nested_type.length; ++j)
                        object.nested_type[j] = $root.google.protobuf.DescriptorProto.toObject(message.nested_type[j], options);
                }
                if (message.enum_type && message.enum_type.length) {
                    object.enum_type = [];
                    for (var j = 0; j < message.enum_type.length; ++j)
                        object.enum_type[j] = $root.google.protobuf.EnumDescriptorProto.toObject(message.enum_type[j], options);
                }
                if (message.extension_range && message.extension_range.length) {
                    object.extension_range = [];
                    for (var j = 0; j < message.extension_range.length; ++j)
                        object.extension_range[j] = $root.google.protobuf.DescriptorProto.ExtensionRange.toObject(message.extension_range[j], options);
                }
                if (message.extension && message.extension.length) {
                    object.extension = [];
                    for (var j = 0; j < message.extension.length; ++j)
                        object.extension[j] = $root.google.protobuf.FieldDescriptorProto.toObject(message.extension[j], options);
                }
                if (message.options != null && message.hasOwnProperty("options"))
                    object.options = $root.google.protobuf.MessageOptions.toObject(message.options, options);
                if (message.oneof_decl && message.oneof_decl.length) {
                    object.oneof_decl = [];
                    for (var j = 0; j < message.oneof_decl.length; ++j)
                        object.oneof_decl[j] = $root.google.protobuf.OneofDescriptorProto.toObject(message.oneof_decl[j], options);
                }
                if (message.reserved_range && message.reserved_range.length) {
                    object.reserved_range = [];
                    for (var j = 0; j < message.reserved_range.length; ++j)
                        object.reserved_range[j] = $root.google.protobuf.DescriptorProto.ReservedRange.toObject(message.reserved_range[j], options);
                }
                if (message.reserved_name && message.reserved_name.length) {
                    object.reserved_name = [];
                    for (var j = 0; j < message.reserved_name.length; ++j)
                        object.reserved_name[j] = message.reserved_name[j];
                }
                return object;
            };

            DescriptorProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            DescriptorProto.ExtensionRange = (function() {

                function ExtensionRange(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                ExtensionRange.prototype.start = 0;
                ExtensionRange.prototype.end = 0;

                ExtensionRange.create = function create(properties) {
                    return new ExtensionRange(properties);
                };

                ExtensionRange.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.start != null && Object.hasOwnProperty.call(message, "start"))
                        writer.uint32(8).int32(message.start);
                    if (message.end != null && Object.hasOwnProperty.call(message, "end"))
                        writer.uint32(16).int32(message.end);
                    return writer;
                };

                ExtensionRange.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                ExtensionRange.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.DescriptorProto.ExtensionRange();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.start = reader.int32();
                            break;
                        case 2:
                            message.end = reader.int32();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                ExtensionRange.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                ExtensionRange.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.start != null && message.hasOwnProperty("start"))
                        if (!$util.isInteger(message.start))
                            return "start: integer expected";
                    if (message.end != null && message.hasOwnProperty("end"))
                        if (!$util.isInteger(message.end))
                            return "end: integer expected";
                    return null;
                };

                ExtensionRange.fromObject = function fromObject(object) {
                    if (object instanceof $root.google.protobuf.DescriptorProto.ExtensionRange)
                        return object;
                    var message = new $root.google.protobuf.DescriptorProto.ExtensionRange();
                    if (object.start != null)
                        message.start = object.start | 0;
                    if (object.end != null)
                        message.end = object.end | 0;
                    return message;
                };

                ExtensionRange.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.start = 0;
                        object.end = 0;
                    }
                    if (message.start != null && message.hasOwnProperty("start"))
                        object.start = message.start;
                    if (message.end != null && message.hasOwnProperty("end"))
                        object.end = message.end;
                    return object;
                };

                ExtensionRange.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return ExtensionRange;
            })();

            DescriptorProto.ReservedRange = (function() {

                function ReservedRange(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                ReservedRange.prototype.start = 0;
                ReservedRange.prototype.end = 0;

                ReservedRange.create = function create(properties) {
                    return new ReservedRange(properties);
                };

                ReservedRange.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.start != null && Object.hasOwnProperty.call(message, "start"))
                        writer.uint32(8).int32(message.start);
                    if (message.end != null && Object.hasOwnProperty.call(message, "end"))
                        writer.uint32(16).int32(message.end);
                    return writer;
                };

                ReservedRange.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                ReservedRange.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.DescriptorProto.ReservedRange();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.start = reader.int32();
                            break;
                        case 2:
                            message.end = reader.int32();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                ReservedRange.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                ReservedRange.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.start != null && message.hasOwnProperty("start"))
                        if (!$util.isInteger(message.start))
                            return "start: integer expected";
                    if (message.end != null && message.hasOwnProperty("end"))
                        if (!$util.isInteger(message.end))
                            return "end: integer expected";
                    return null;
                };

                ReservedRange.fromObject = function fromObject(object) {
                    if (object instanceof $root.google.protobuf.DescriptorProto.ReservedRange)
                        return object;
                    var message = new $root.google.protobuf.DescriptorProto.ReservedRange();
                    if (object.start != null)
                        message.start = object.start | 0;
                    if (object.end != null)
                        message.end = object.end | 0;
                    return message;
                };

                ReservedRange.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.start = 0;
                        object.end = 0;
                    }
                    if (message.start != null && message.hasOwnProperty("start"))
                        object.start = message.start;
                    if (message.end != null && message.hasOwnProperty("end"))
                        object.end = message.end;
                    return object;
                };

                ReservedRange.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return ReservedRange;
            })();

            return DescriptorProto;
        })();

        protobuf.FieldDescriptorProto = (function() {

            function FieldDescriptorProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            FieldDescriptorProto.prototype.name = "";
            FieldDescriptorProto.prototype.number = 0;
            FieldDescriptorProto.prototype.label = 1;
            FieldDescriptorProto.prototype.type = 1;
            FieldDescriptorProto.prototype.type_name = "";
            FieldDescriptorProto.prototype.extendee = "";
            FieldDescriptorProto.prototype.default_value = "";
            FieldDescriptorProto.prototype.oneof_index = 0;
            FieldDescriptorProto.prototype.json_name = "";
            FieldDescriptorProto.prototype.options = null;

            FieldDescriptorProto.create = function create(properties) {
                return new FieldDescriptorProto(properties);
            };

            FieldDescriptorProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                    writer.uint32(10).string(message.name);
                if (message.extendee != null && Object.hasOwnProperty.call(message, "extendee"))
                    writer.uint32(18).string(message.extendee);
                if (message.number != null && Object.hasOwnProperty.call(message, "number"))
                    writer.uint32(24).int32(message.number);
                if (message.label != null && Object.hasOwnProperty.call(message, "label"))
                    writer.uint32(32).int32(message.label);
                if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                    writer.uint32(40).int32(message.type);
                if (message.type_name != null && Object.hasOwnProperty.call(message, "type_name"))
                    writer.uint32(50).string(message.type_name);
                if (message.default_value != null && Object.hasOwnProperty.call(message, "default_value"))
                    writer.uint32(58).string(message.default_value);
                if (message.options != null && Object.hasOwnProperty.call(message, "options"))
                    $root.google.protobuf.FieldOptions.encode(message.options, writer.uint32(66).fork()).ldelim();
                if (message.oneof_index != null && Object.hasOwnProperty.call(message, "oneof_index"))
                    writer.uint32(72).int32(message.oneof_index);
                if (message.json_name != null && Object.hasOwnProperty.call(message, "json_name"))
                    writer.uint32(82).string(message.json_name);
                return writer;
            };

            FieldDescriptorProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            FieldDescriptorProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.FieldDescriptorProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.name = reader.string();
                        break;
                    case 3:
                        message.number = reader.int32();
                        break;
                    case 4:
                        message.label = reader.int32();
                        break;
                    case 5:
                        message.type = reader.int32();
                        break;
                    case 6:
                        message.type_name = reader.string();
                        break;
                    case 2:
                        message.extendee = reader.string();
                        break;
                    case 7:
                        message.default_value = reader.string();
                        break;
                    case 9:
                        message.oneof_index = reader.int32();
                        break;
                    case 10:
                        message.json_name = reader.string();
                        break;
                    case 8:
                        message.options = $root.google.protobuf.FieldOptions.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            FieldDescriptorProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            FieldDescriptorProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.name != null && message.hasOwnProperty("name"))
                    if (!$util.isString(message.name))
                        return "name: string expected";
                if (message.number != null && message.hasOwnProperty("number"))
                    if (!$util.isInteger(message.number))
                        return "number: integer expected";
                if (message.label != null && message.hasOwnProperty("label"))
                    switch (message.label) {
                    default:
                        return "label: enum value expected";
                    case 1:
                    case 2:
                    case 3:
                        break;
                    }
                if (message.type != null && message.hasOwnProperty("type"))
                    switch (message.type) {
                    default:
                        return "type: enum value expected";
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                    case 6:
                    case 7:
                    case 8:
                    case 9:
                    case 10:
                    case 11:
                    case 12:
                    case 13:
                    case 14:
                    case 15:
                    case 16:
                    case 17:
                    case 18:
                        break;
                    }
                if (message.type_name != null && message.hasOwnProperty("type_name"))
                    if (!$util.isString(message.type_name))
                        return "type_name: string expected";
                if (message.extendee != null && message.hasOwnProperty("extendee"))
                    if (!$util.isString(message.extendee))
                        return "extendee: string expected";
                if (message.default_value != null && message.hasOwnProperty("default_value"))
                    if (!$util.isString(message.default_value))
                        return "default_value: string expected";
                if (message.oneof_index != null && message.hasOwnProperty("oneof_index"))
                    if (!$util.isInteger(message.oneof_index))
                        return "oneof_index: integer expected";
                if (message.json_name != null && message.hasOwnProperty("json_name"))
                    if (!$util.isString(message.json_name))
                        return "json_name: string expected";
                if (message.options != null && message.hasOwnProperty("options")) {
                    var error = $root.google.protobuf.FieldOptions.verify(message.options);
                    if (error)
                        return "options." + error;
                }
                return null;
            };

            FieldDescriptorProto.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.FieldDescriptorProto)
                    return object;
                var message = new $root.google.protobuf.FieldDescriptorProto();
                if (object.name != null)
                    message.name = String(object.name);
                if (object.number != null)
                    message.number = object.number | 0;
                switch (object.label) {
                case "LABEL_OPTIONAL":
                case 1:
                    message.label = 1;
                    break;
                case "LABEL_REQUIRED":
                case 2:
                    message.label = 2;
                    break;
                case "LABEL_REPEATED":
                case 3:
                    message.label = 3;
                    break;
                }
                switch (object.type) {
                case "TYPE_DOUBLE":
                case 1:
                    message.type = 1;
                    break;
                case "TYPE_FLOAT":
                case 2:
                    message.type = 2;
                    break;
                case "TYPE_INT64":
                case 3:
                    message.type = 3;
                    break;
                case "TYPE_UINT64":
                case 4:
                    message.type = 4;
                    break;
                case "TYPE_INT32":
                case 5:
                    message.type = 5;
                    break;
                case "TYPE_FIXED64":
                case 6:
                    message.type = 6;
                    break;
                case "TYPE_FIXED32":
                case 7:
                    message.type = 7;
                    break;
                case "TYPE_BOOL":
                case 8:
                    message.type = 8;
                    break;
                case "TYPE_STRING":
                case 9:
                    message.type = 9;
                    break;
                case "TYPE_GROUP":
                case 10:
                    message.type = 10;
                    break;
                case "TYPE_MESSAGE":
                case 11:
                    message.type = 11;
                    break;
                case "TYPE_BYTES":
                case 12:
                    message.type = 12;
                    break;
                case "TYPE_UINT32":
                case 13:
                    message.type = 13;
                    break;
                case "TYPE_ENUM":
                case 14:
                    message.type = 14;
                    break;
                case "TYPE_SFIXED32":
                case 15:
                    message.type = 15;
                    break;
                case "TYPE_SFIXED64":
                case 16:
                    message.type = 16;
                    break;
                case "TYPE_SINT32":
                case 17:
                    message.type = 17;
                    break;
                case "TYPE_SINT64":
                case 18:
                    message.type = 18;
                    break;
                }
                if (object.type_name != null)
                    message.type_name = String(object.type_name);
                if (object.extendee != null)
                    message.extendee = String(object.extendee);
                if (object.default_value != null)
                    message.default_value = String(object.default_value);
                if (object.oneof_index != null)
                    message.oneof_index = object.oneof_index | 0;
                if (object.json_name != null)
                    message.json_name = String(object.json_name);
                if (object.options != null) {
                    if (typeof object.options !== "object")
                        throw TypeError(".google.protobuf.FieldDescriptorProto.options: object expected");
                    message.options = $root.google.protobuf.FieldOptions.fromObject(object.options);
                }
                return message;
            };

            FieldDescriptorProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.name = "";
                    object.extendee = "";
                    object.number = 0;
                    object.label = options.enums === String ? "LABEL_OPTIONAL" : 1;
                    object.type = options.enums === String ? "TYPE_DOUBLE" : 1;
                    object.type_name = "";
                    object.default_value = "";
                    object.options = null;
                    object.oneof_index = 0;
                    object.json_name = "";
                }
                if (message.name != null && message.hasOwnProperty("name"))
                    object.name = message.name;
                if (message.extendee != null && message.hasOwnProperty("extendee"))
                    object.extendee = message.extendee;
                if (message.number != null && message.hasOwnProperty("number"))
                    object.number = message.number;
                if (message.label != null && message.hasOwnProperty("label"))
                    object.label = options.enums === String ? $root.google.protobuf.FieldDescriptorProto.Label[message.label] : message.label;
                if (message.type != null && message.hasOwnProperty("type"))
                    object.type = options.enums === String ? $root.google.protobuf.FieldDescriptorProto.Type[message.type] : message.type;
                if (message.type_name != null && message.hasOwnProperty("type_name"))
                    object.type_name = message.type_name;
                if (message.default_value != null && message.hasOwnProperty("default_value"))
                    object.default_value = message.default_value;
                if (message.options != null && message.hasOwnProperty("options"))
                    object.options = $root.google.protobuf.FieldOptions.toObject(message.options, options);
                if (message.oneof_index != null && message.hasOwnProperty("oneof_index"))
                    object.oneof_index = message.oneof_index;
                if (message.json_name != null && message.hasOwnProperty("json_name"))
                    object.json_name = message.json_name;
                return object;
            };

            FieldDescriptorProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            FieldDescriptorProto.Type = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[1] = "TYPE_DOUBLE"] = 1;
                values[valuesById[2] = "TYPE_FLOAT"] = 2;
                values[valuesById[3] = "TYPE_INT64"] = 3;
                values[valuesById[4] = "TYPE_UINT64"] = 4;
                values[valuesById[5] = "TYPE_INT32"] = 5;
                values[valuesById[6] = "TYPE_FIXED64"] = 6;
                values[valuesById[7] = "TYPE_FIXED32"] = 7;
                values[valuesById[8] = "TYPE_BOOL"] = 8;
                values[valuesById[9] = "TYPE_STRING"] = 9;
                values[valuesById[10] = "TYPE_GROUP"] = 10;
                values[valuesById[11] = "TYPE_MESSAGE"] = 11;
                values[valuesById[12] = "TYPE_BYTES"] = 12;
                values[valuesById[13] = "TYPE_UINT32"] = 13;
                values[valuesById[14] = "TYPE_ENUM"] = 14;
                values[valuesById[15] = "TYPE_SFIXED32"] = 15;
                values[valuesById[16] = "TYPE_SFIXED64"] = 16;
                values[valuesById[17] = "TYPE_SINT32"] = 17;
                values[valuesById[18] = "TYPE_SINT64"] = 18;
                return values;
            })();

            FieldDescriptorProto.Label = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[1] = "LABEL_OPTIONAL"] = 1;
                values[valuesById[2] = "LABEL_REQUIRED"] = 2;
                values[valuesById[3] = "LABEL_REPEATED"] = 3;
                return values;
            })();

            return FieldDescriptorProto;
        })();

        protobuf.OneofDescriptorProto = (function() {

            function OneofDescriptorProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            OneofDescriptorProto.prototype.name = "";
            OneofDescriptorProto.prototype.options = null;

            OneofDescriptorProto.create = function create(properties) {
                return new OneofDescriptorProto(properties);
            };

            OneofDescriptorProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                    writer.uint32(10).string(message.name);
                if (message.options != null && Object.hasOwnProperty.call(message, "options"))
                    $root.google.protobuf.OneofOptions.encode(message.options, writer.uint32(18).fork()).ldelim();
                return writer;
            };

            OneofDescriptorProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            OneofDescriptorProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.OneofDescriptorProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.name = reader.string();
                        break;
                    case 2:
                        message.options = $root.google.protobuf.OneofOptions.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            OneofDescriptorProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            OneofDescriptorProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.name != null && message.hasOwnProperty("name"))
                    if (!$util.isString(message.name))
                        return "name: string expected";
                if (message.options != null && message.hasOwnProperty("options")) {
                    var error = $root.google.protobuf.OneofOptions.verify(message.options);
                    if (error)
                        return "options." + error;
                }
                return null;
            };

            OneofDescriptorProto.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.OneofDescriptorProto)
                    return object;
                var message = new $root.google.protobuf.OneofDescriptorProto();
                if (object.name != null)
                    message.name = String(object.name);
                if (object.options != null) {
                    if (typeof object.options !== "object")
                        throw TypeError(".google.protobuf.OneofDescriptorProto.options: object expected");
                    message.options = $root.google.protobuf.OneofOptions.fromObject(object.options);
                }
                return message;
            };

            OneofDescriptorProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.name = "";
                    object.options = null;
                }
                if (message.name != null && message.hasOwnProperty("name"))
                    object.name = message.name;
                if (message.options != null && message.hasOwnProperty("options"))
                    object.options = $root.google.protobuf.OneofOptions.toObject(message.options, options);
                return object;
            };

            OneofDescriptorProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return OneofDescriptorProto;
        })();

        protobuf.EnumDescriptorProto = (function() {

            function EnumDescriptorProto(properties) {
                this.value = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            EnumDescriptorProto.prototype.name = "";
            EnumDescriptorProto.prototype.value = $util.emptyArray;
            EnumDescriptorProto.prototype.options = null;

            EnumDescriptorProto.create = function create(properties) {
                return new EnumDescriptorProto(properties);
            };

            EnumDescriptorProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                    writer.uint32(10).string(message.name);
                if (message.value != null && message.value.length)
                    for (var i = 0; i < message.value.length; ++i)
                        $root.google.protobuf.EnumValueDescriptorProto.encode(message.value[i], writer.uint32(18).fork()).ldelim();
                if (message.options != null && Object.hasOwnProperty.call(message, "options"))
                    $root.google.protobuf.EnumOptions.encode(message.options, writer.uint32(26).fork()).ldelim();
                return writer;
            };

            EnumDescriptorProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            EnumDescriptorProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.EnumDescriptorProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.name = reader.string();
                        break;
                    case 2:
                        if (!(message.value && message.value.length))
                            message.value = [];
                        message.value.push($root.google.protobuf.EnumValueDescriptorProto.decode(reader, reader.uint32()));
                        break;
                    case 3:
                        message.options = $root.google.protobuf.EnumOptions.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            EnumDescriptorProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            EnumDescriptorProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.name != null && message.hasOwnProperty("name"))
                    if (!$util.isString(message.name))
                        return "name: string expected";
                if (message.value != null && message.hasOwnProperty("value")) {
                    if (!Array.isArray(message.value))
                        return "value: array expected";
                    for (var i = 0; i < message.value.length; ++i) {
                        var error = $root.google.protobuf.EnumValueDescriptorProto.verify(message.value[i]);
                        if (error)
                            return "value." + error;
                    }
                }
                if (message.options != null && message.hasOwnProperty("options")) {
                    var error = $root.google.protobuf.EnumOptions.verify(message.options);
                    if (error)
                        return "options." + error;
                }
                return null;
            };

            EnumDescriptorProto.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.EnumDescriptorProto)
                    return object;
                var message = new $root.google.protobuf.EnumDescriptorProto();
                if (object.name != null)
                    message.name = String(object.name);
                if (object.value) {
                    if (!Array.isArray(object.value))
                        throw TypeError(".google.protobuf.EnumDescriptorProto.value: array expected");
                    message.value = [];
                    for (var i = 0; i < object.value.length; ++i) {
                        if (typeof object.value[i] !== "object")
                            throw TypeError(".google.protobuf.EnumDescriptorProto.value: object expected");
                        message.value[i] = $root.google.protobuf.EnumValueDescriptorProto.fromObject(object.value[i]);
                    }
                }
                if (object.options != null) {
                    if (typeof object.options !== "object")
                        throw TypeError(".google.protobuf.EnumDescriptorProto.options: object expected");
                    message.options = $root.google.protobuf.EnumOptions.fromObject(object.options);
                }
                return message;
            };

            EnumDescriptorProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.value = [];
                if (options.defaults) {
                    object.name = "";
                    object.options = null;
                }
                if (message.name != null && message.hasOwnProperty("name"))
                    object.name = message.name;
                if (message.value && message.value.length) {
                    object.value = [];
                    for (var j = 0; j < message.value.length; ++j)
                        object.value[j] = $root.google.protobuf.EnumValueDescriptorProto.toObject(message.value[j], options);
                }
                if (message.options != null && message.hasOwnProperty("options"))
                    object.options = $root.google.protobuf.EnumOptions.toObject(message.options, options);
                return object;
            };

            EnumDescriptorProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return EnumDescriptorProto;
        })();

        protobuf.EnumValueDescriptorProto = (function() {

            function EnumValueDescriptorProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            EnumValueDescriptorProto.prototype.name = "";
            EnumValueDescriptorProto.prototype.number = 0;
            EnumValueDescriptorProto.prototype.options = null;

            EnumValueDescriptorProto.create = function create(properties) {
                return new EnumValueDescriptorProto(properties);
            };

            EnumValueDescriptorProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                    writer.uint32(10).string(message.name);
                if (message.number != null && Object.hasOwnProperty.call(message, "number"))
                    writer.uint32(16).int32(message.number);
                if (message.options != null && Object.hasOwnProperty.call(message, "options"))
                    $root.google.protobuf.EnumValueOptions.encode(message.options, writer.uint32(26).fork()).ldelim();
                return writer;
            };

            EnumValueDescriptorProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            EnumValueDescriptorProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.EnumValueDescriptorProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.name = reader.string();
                        break;
                    case 2:
                        message.number = reader.int32();
                        break;
                    case 3:
                        message.options = $root.google.protobuf.EnumValueOptions.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            EnumValueDescriptorProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            EnumValueDescriptorProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.name != null && message.hasOwnProperty("name"))
                    if (!$util.isString(message.name))
                        return "name: string expected";
                if (message.number != null && message.hasOwnProperty("number"))
                    if (!$util.isInteger(message.number))
                        return "number: integer expected";
                if (message.options != null && message.hasOwnProperty("options")) {
                    var error = $root.google.protobuf.EnumValueOptions.verify(message.options);
                    if (error)
                        return "options." + error;
                }
                return null;
            };

            EnumValueDescriptorProto.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.EnumValueDescriptorProto)
                    return object;
                var message = new $root.google.protobuf.EnumValueDescriptorProto();
                if (object.name != null)
                    message.name = String(object.name);
                if (object.number != null)
                    message.number = object.number | 0;
                if (object.options != null) {
                    if (typeof object.options !== "object")
                        throw TypeError(".google.protobuf.EnumValueDescriptorProto.options: object expected");
                    message.options = $root.google.protobuf.EnumValueOptions.fromObject(object.options);
                }
                return message;
            };

            EnumValueDescriptorProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.name = "";
                    object.number = 0;
                    object.options = null;
                }
                if (message.name != null && message.hasOwnProperty("name"))
                    object.name = message.name;
                if (message.number != null && message.hasOwnProperty("number"))
                    object.number = message.number;
                if (message.options != null && message.hasOwnProperty("options"))
                    object.options = $root.google.protobuf.EnumValueOptions.toObject(message.options, options);
                return object;
            };

            EnumValueDescriptorProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return EnumValueDescriptorProto;
        })();

        protobuf.ServiceDescriptorProto = (function() {

            function ServiceDescriptorProto(properties) {
                this.method = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            ServiceDescriptorProto.prototype.name = "";
            ServiceDescriptorProto.prototype.method = $util.emptyArray;
            ServiceDescriptorProto.prototype.options = null;

            ServiceDescriptorProto.create = function create(properties) {
                return new ServiceDescriptorProto(properties);
            };

            ServiceDescriptorProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                    writer.uint32(10).string(message.name);
                if (message.method != null && message.method.length)
                    for (var i = 0; i < message.method.length; ++i)
                        $root.google.protobuf.MethodDescriptorProto.encode(message.method[i], writer.uint32(18).fork()).ldelim();
                if (message.options != null && Object.hasOwnProperty.call(message, "options"))
                    $root.google.protobuf.ServiceOptions.encode(message.options, writer.uint32(26).fork()).ldelim();
                return writer;
            };

            ServiceDescriptorProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            ServiceDescriptorProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.ServiceDescriptorProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.name = reader.string();
                        break;
                    case 2:
                        if (!(message.method && message.method.length))
                            message.method = [];
                        message.method.push($root.google.protobuf.MethodDescriptorProto.decode(reader, reader.uint32()));
                        break;
                    case 3:
                        message.options = $root.google.protobuf.ServiceOptions.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            ServiceDescriptorProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            ServiceDescriptorProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.name != null && message.hasOwnProperty("name"))
                    if (!$util.isString(message.name))
                        return "name: string expected";
                if (message.method != null && message.hasOwnProperty("method")) {
                    if (!Array.isArray(message.method))
                        return "method: array expected";
                    for (var i = 0; i < message.method.length; ++i) {
                        var error = $root.google.protobuf.MethodDescriptorProto.verify(message.method[i]);
                        if (error)
                            return "method." + error;
                    }
                }
                if (message.options != null && message.hasOwnProperty("options")) {
                    var error = $root.google.protobuf.ServiceOptions.verify(message.options);
                    if (error)
                        return "options." + error;
                }
                return null;
            };

            ServiceDescriptorProto.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.ServiceDescriptorProto)
                    return object;
                var message = new $root.google.protobuf.ServiceDescriptorProto();
                if (object.name != null)
                    message.name = String(object.name);
                if (object.method) {
                    if (!Array.isArray(object.method))
                        throw TypeError(".google.protobuf.ServiceDescriptorProto.method: array expected");
                    message.method = [];
                    for (var i = 0; i < object.method.length; ++i) {
                        if (typeof object.method[i] !== "object")
                            throw TypeError(".google.protobuf.ServiceDescriptorProto.method: object expected");
                        message.method[i] = $root.google.protobuf.MethodDescriptorProto.fromObject(object.method[i]);
                    }
                }
                if (object.options != null) {
                    if (typeof object.options !== "object")
                        throw TypeError(".google.protobuf.ServiceDescriptorProto.options: object expected");
                    message.options = $root.google.protobuf.ServiceOptions.fromObject(object.options);
                }
                return message;
            };

            ServiceDescriptorProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.method = [];
                if (options.defaults) {
                    object.name = "";
                    object.options = null;
                }
                if (message.name != null && message.hasOwnProperty("name"))
                    object.name = message.name;
                if (message.method && message.method.length) {
                    object.method = [];
                    for (var j = 0; j < message.method.length; ++j)
                        object.method[j] = $root.google.protobuf.MethodDescriptorProto.toObject(message.method[j], options);
                }
                if (message.options != null && message.hasOwnProperty("options"))
                    object.options = $root.google.protobuf.ServiceOptions.toObject(message.options, options);
                return object;
            };

            ServiceDescriptorProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return ServiceDescriptorProto;
        })();

        protobuf.MethodDescriptorProto = (function() {

            function MethodDescriptorProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            MethodDescriptorProto.prototype.name = "";
            MethodDescriptorProto.prototype.input_type = "";
            MethodDescriptorProto.prototype.output_type = "";
            MethodDescriptorProto.prototype.options = null;
            MethodDescriptorProto.prototype.client_streaming = false;
            MethodDescriptorProto.prototype.server_streaming = false;

            MethodDescriptorProto.create = function create(properties) {
                return new MethodDescriptorProto(properties);
            };

            MethodDescriptorProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                    writer.uint32(10).string(message.name);
                if (message.input_type != null && Object.hasOwnProperty.call(message, "input_type"))
                    writer.uint32(18).string(message.input_type);
                if (message.output_type != null && Object.hasOwnProperty.call(message, "output_type"))
                    writer.uint32(26).string(message.output_type);
                if (message.options != null && Object.hasOwnProperty.call(message, "options"))
                    $root.google.protobuf.MethodOptions.encode(message.options, writer.uint32(34).fork()).ldelim();
                if (message.client_streaming != null && Object.hasOwnProperty.call(message, "client_streaming"))
                    writer.uint32(40).bool(message.client_streaming);
                if (message.server_streaming != null && Object.hasOwnProperty.call(message, "server_streaming"))
                    writer.uint32(48).bool(message.server_streaming);
                return writer;
            };

            MethodDescriptorProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            MethodDescriptorProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.MethodDescriptorProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.name = reader.string();
                        break;
                    case 2:
                        message.input_type = reader.string();
                        break;
                    case 3:
                        message.output_type = reader.string();
                        break;
                    case 4:
                        message.options = $root.google.protobuf.MethodOptions.decode(reader, reader.uint32());
                        break;
                    case 5:
                        message.client_streaming = reader.bool();
                        break;
                    case 6:
                        message.server_streaming = reader.bool();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            MethodDescriptorProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            MethodDescriptorProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.name != null && message.hasOwnProperty("name"))
                    if (!$util.isString(message.name))
                        return "name: string expected";
                if (message.input_type != null && message.hasOwnProperty("input_type"))
                    if (!$util.isString(message.input_type))
                        return "input_type: string expected";
                if (message.output_type != null && message.hasOwnProperty("output_type"))
                    if (!$util.isString(message.output_type))
                        return "output_type: string expected";
                if (message.options != null && message.hasOwnProperty("options")) {
                    var error = $root.google.protobuf.MethodOptions.verify(message.options);
                    if (error)
                        return "options." + error;
                }
                if (message.client_streaming != null && message.hasOwnProperty("client_streaming"))
                    if (typeof message.client_streaming !== "boolean")
                        return "client_streaming: boolean expected";
                if (message.server_streaming != null && message.hasOwnProperty("server_streaming"))
                    if (typeof message.server_streaming !== "boolean")
                        return "server_streaming: boolean expected";
                return null;
            };

            MethodDescriptorProto.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.MethodDescriptorProto)
                    return object;
                var message = new $root.google.protobuf.MethodDescriptorProto();
                if (object.name != null)
                    message.name = String(object.name);
                if (object.input_type != null)
                    message.input_type = String(object.input_type);
                if (object.output_type != null)
                    message.output_type = String(object.output_type);
                if (object.options != null) {
                    if (typeof object.options !== "object")
                        throw TypeError(".google.protobuf.MethodDescriptorProto.options: object expected");
                    message.options = $root.google.protobuf.MethodOptions.fromObject(object.options);
                }
                if (object.client_streaming != null)
                    message.client_streaming = Boolean(object.client_streaming);
                if (object.server_streaming != null)
                    message.server_streaming = Boolean(object.server_streaming);
                return message;
            };

            MethodDescriptorProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.name = "";
                    object.input_type = "";
                    object.output_type = "";
                    object.options = null;
                    object.client_streaming = false;
                    object.server_streaming = false;
                }
                if (message.name != null && message.hasOwnProperty("name"))
                    object.name = message.name;
                if (message.input_type != null && message.hasOwnProperty("input_type"))
                    object.input_type = message.input_type;
                if (message.output_type != null && message.hasOwnProperty("output_type"))
                    object.output_type = message.output_type;
                if (message.options != null && message.hasOwnProperty("options"))
                    object.options = $root.google.protobuf.MethodOptions.toObject(message.options, options);
                if (message.client_streaming != null && message.hasOwnProperty("client_streaming"))
                    object.client_streaming = message.client_streaming;
                if (message.server_streaming != null && message.hasOwnProperty("server_streaming"))
                    object.server_streaming = message.server_streaming;
                return object;
            };

            MethodDescriptorProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return MethodDescriptorProto;
        })();

        protobuf.FileOptions = (function() {

            function FileOptions(properties) {
                this.uninterpreted_option = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            FileOptions.prototype.java_package = "";
            FileOptions.prototype.java_outer_classname = "";
            FileOptions.prototype.java_multiple_files = false;
            FileOptions.prototype.java_generate_equals_and_hash = false;
            FileOptions.prototype.java_string_check_utf8 = false;
            FileOptions.prototype.optimize_for = 1;
            FileOptions.prototype.go_package = "";
            FileOptions.prototype.cc_generic_services = false;
            FileOptions.prototype.java_generic_services = false;
            FileOptions.prototype.py_generic_services = false;
            FileOptions.prototype.deprecated = false;
            FileOptions.prototype.cc_enable_arenas = false;
            FileOptions.prototype.objc_class_prefix = "";
            FileOptions.prototype.csharp_namespace = "";
            FileOptions.prototype.uninterpreted_option = $util.emptyArray;
            FileOptions.prototype[".include_in_bitcoin_only"] = false;

            FileOptions.create = function create(properties) {
                return new FileOptions(properties);
            };

            FileOptions.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.java_package != null && Object.hasOwnProperty.call(message, "java_package"))
                    writer.uint32(10).string(message.java_package);
                if (message.java_outer_classname != null && Object.hasOwnProperty.call(message, "java_outer_classname"))
                    writer.uint32(66).string(message.java_outer_classname);
                if (message.optimize_for != null && Object.hasOwnProperty.call(message, "optimize_for"))
                    writer.uint32(72).int32(message.optimize_for);
                if (message.java_multiple_files != null && Object.hasOwnProperty.call(message, "java_multiple_files"))
                    writer.uint32(80).bool(message.java_multiple_files);
                if (message.go_package != null && Object.hasOwnProperty.call(message, "go_package"))
                    writer.uint32(90).string(message.go_package);
                if (message.cc_generic_services != null && Object.hasOwnProperty.call(message, "cc_generic_services"))
                    writer.uint32(128).bool(message.cc_generic_services);
                if (message.java_generic_services != null && Object.hasOwnProperty.call(message, "java_generic_services"))
                    writer.uint32(136).bool(message.java_generic_services);
                if (message.py_generic_services != null && Object.hasOwnProperty.call(message, "py_generic_services"))
                    writer.uint32(144).bool(message.py_generic_services);
                if (message.java_generate_equals_and_hash != null && Object.hasOwnProperty.call(message, "java_generate_equals_and_hash"))
                    writer.uint32(160).bool(message.java_generate_equals_and_hash);
                if (message.deprecated != null && Object.hasOwnProperty.call(message, "deprecated"))
                    writer.uint32(184).bool(message.deprecated);
                if (message.java_string_check_utf8 != null && Object.hasOwnProperty.call(message, "java_string_check_utf8"))
                    writer.uint32(216).bool(message.java_string_check_utf8);
                if (message.cc_enable_arenas != null && Object.hasOwnProperty.call(message, "cc_enable_arenas"))
                    writer.uint32(248).bool(message.cc_enable_arenas);
                if (message.objc_class_prefix != null && Object.hasOwnProperty.call(message, "objc_class_prefix"))
                    writer.uint32(290).string(message.objc_class_prefix);
                if (message.csharp_namespace != null && Object.hasOwnProperty.call(message, "csharp_namespace"))
                    writer.uint32(298).string(message.csharp_namespace);
                if (message.uninterpreted_option != null && message.uninterpreted_option.length)
                    for (var i = 0; i < message.uninterpreted_option.length; ++i)
                        $root.google.protobuf.UninterpretedOption.encode(message.uninterpreted_option[i], writer.uint32(7994).fork()).ldelim();
                if (message[".include_in_bitcoin_only"] != null && Object.hasOwnProperty.call(message, ".include_in_bitcoin_only"))
                    writer.uint32(480000).bool(message[".include_in_bitcoin_only"]);
                return writer;
            };

            FileOptions.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            FileOptions.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.FileOptions();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.java_package = reader.string();
                        break;
                    case 8:
                        message.java_outer_classname = reader.string();
                        break;
                    case 10:
                        message.java_multiple_files = reader.bool();
                        break;
                    case 20:
                        message.java_generate_equals_and_hash = reader.bool();
                        break;
                    case 27:
                        message.java_string_check_utf8 = reader.bool();
                        break;
                    case 9:
                        message.optimize_for = reader.int32();
                        break;
                    case 11:
                        message.go_package = reader.string();
                        break;
                    case 16:
                        message.cc_generic_services = reader.bool();
                        break;
                    case 17:
                        message.java_generic_services = reader.bool();
                        break;
                    case 18:
                        message.py_generic_services = reader.bool();
                        break;
                    case 23:
                        message.deprecated = reader.bool();
                        break;
                    case 31:
                        message.cc_enable_arenas = reader.bool();
                        break;
                    case 36:
                        message.objc_class_prefix = reader.string();
                        break;
                    case 37:
                        message.csharp_namespace = reader.string();
                        break;
                    case 999:
                        if (!(message.uninterpreted_option && message.uninterpreted_option.length))
                            message.uninterpreted_option = [];
                        message.uninterpreted_option.push($root.google.protobuf.UninterpretedOption.decode(reader, reader.uint32()));
                        break;
                    case 60000:
                        message[".include_in_bitcoin_only"] = reader.bool();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            FileOptions.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            FileOptions.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.java_package != null && message.hasOwnProperty("java_package"))
                    if (!$util.isString(message.java_package))
                        return "java_package: string expected";
                if (message.java_outer_classname != null && message.hasOwnProperty("java_outer_classname"))
                    if (!$util.isString(message.java_outer_classname))
                        return "java_outer_classname: string expected";
                if (message.java_multiple_files != null && message.hasOwnProperty("java_multiple_files"))
                    if (typeof message.java_multiple_files !== "boolean")
                        return "java_multiple_files: boolean expected";
                if (message.java_generate_equals_and_hash != null && message.hasOwnProperty("java_generate_equals_and_hash"))
                    if (typeof message.java_generate_equals_and_hash !== "boolean")
                        return "java_generate_equals_and_hash: boolean expected";
                if (message.java_string_check_utf8 != null && message.hasOwnProperty("java_string_check_utf8"))
                    if (typeof message.java_string_check_utf8 !== "boolean")
                        return "java_string_check_utf8: boolean expected";
                if (message.optimize_for != null && message.hasOwnProperty("optimize_for"))
                    switch (message.optimize_for) {
                    default:
                        return "optimize_for: enum value expected";
                    case 1:
                    case 2:
                    case 3:
                        break;
                    }
                if (message.go_package != null && message.hasOwnProperty("go_package"))
                    if (!$util.isString(message.go_package))
                        return "go_package: string expected";
                if (message.cc_generic_services != null && message.hasOwnProperty("cc_generic_services"))
                    if (typeof message.cc_generic_services !== "boolean")
                        return "cc_generic_services: boolean expected";
                if (message.java_generic_services != null && message.hasOwnProperty("java_generic_services"))
                    if (typeof message.java_generic_services !== "boolean")
                        return "java_generic_services: boolean expected";
                if (message.py_generic_services != null && message.hasOwnProperty("py_generic_services"))
                    if (typeof message.py_generic_services !== "boolean")
                        return "py_generic_services: boolean expected";
                if (message.deprecated != null && message.hasOwnProperty("deprecated"))
                    if (typeof message.deprecated !== "boolean")
                        return "deprecated: boolean expected";
                if (message.cc_enable_arenas != null && message.hasOwnProperty("cc_enable_arenas"))
                    if (typeof message.cc_enable_arenas !== "boolean")
                        return "cc_enable_arenas: boolean expected";
                if (message.objc_class_prefix != null && message.hasOwnProperty("objc_class_prefix"))
                    if (!$util.isString(message.objc_class_prefix))
                        return "objc_class_prefix: string expected";
                if (message.csharp_namespace != null && message.hasOwnProperty("csharp_namespace"))
                    if (!$util.isString(message.csharp_namespace))
                        return "csharp_namespace: string expected";
                if (message.uninterpreted_option != null && message.hasOwnProperty("uninterpreted_option")) {
                    if (!Array.isArray(message.uninterpreted_option))
                        return "uninterpreted_option: array expected";
                    for (var i = 0; i < message.uninterpreted_option.length; ++i) {
                        var error = $root.google.protobuf.UninterpretedOption.verify(message.uninterpreted_option[i]);
                        if (error)
                            return "uninterpreted_option." + error;
                    }
                }
                if (message[".include_in_bitcoin_only"] != null && message.hasOwnProperty(".include_in_bitcoin_only"))
                    if (typeof message[".include_in_bitcoin_only"] !== "boolean")
                        return ".include_in_bitcoin_only: boolean expected";
                return null;
            };

            FileOptions.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.FileOptions)
                    return object;
                var message = new $root.google.protobuf.FileOptions();
                if (object.java_package != null)
                    message.java_package = String(object.java_package);
                if (object.java_outer_classname != null)
                    message.java_outer_classname = String(object.java_outer_classname);
                if (object.java_multiple_files != null)
                    message.java_multiple_files = Boolean(object.java_multiple_files);
                if (object.java_generate_equals_and_hash != null)
                    message.java_generate_equals_and_hash = Boolean(object.java_generate_equals_and_hash);
                if (object.java_string_check_utf8 != null)
                    message.java_string_check_utf8 = Boolean(object.java_string_check_utf8);
                switch (object.optimize_for) {
                case "SPEED":
                case 1:
                    message.optimize_for = 1;
                    break;
                case "CODE_SIZE":
                case 2:
                    message.optimize_for = 2;
                    break;
                case "LITE_RUNTIME":
                case 3:
                    message.optimize_for = 3;
                    break;
                }
                if (object.go_package != null)
                    message.go_package = String(object.go_package);
                if (object.cc_generic_services != null)
                    message.cc_generic_services = Boolean(object.cc_generic_services);
                if (object.java_generic_services != null)
                    message.java_generic_services = Boolean(object.java_generic_services);
                if (object.py_generic_services != null)
                    message.py_generic_services = Boolean(object.py_generic_services);
                if (object.deprecated != null)
                    message.deprecated = Boolean(object.deprecated);
                if (object.cc_enable_arenas != null)
                    message.cc_enable_arenas = Boolean(object.cc_enable_arenas);
                if (object.objc_class_prefix != null)
                    message.objc_class_prefix = String(object.objc_class_prefix);
                if (object.csharp_namespace != null)
                    message.csharp_namespace = String(object.csharp_namespace);
                if (object.uninterpreted_option) {
                    if (!Array.isArray(object.uninterpreted_option))
                        throw TypeError(".google.protobuf.FileOptions.uninterpreted_option: array expected");
                    message.uninterpreted_option = [];
                    for (var i = 0; i < object.uninterpreted_option.length; ++i) {
                        if (typeof object.uninterpreted_option[i] !== "object")
                            throw TypeError(".google.protobuf.FileOptions.uninterpreted_option: object expected");
                        message.uninterpreted_option[i] = $root.google.protobuf.UninterpretedOption.fromObject(object.uninterpreted_option[i]);
                    }
                }
                if (object[".include_in_bitcoin_only"] != null)
                    message[".include_in_bitcoin_only"] = Boolean(object[".include_in_bitcoin_only"]);
                return message;
            };

            FileOptions.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.uninterpreted_option = [];
                if (options.defaults) {
                    object.java_package = "";
                    object.java_outer_classname = "";
                    object.optimize_for = options.enums === String ? "SPEED" : 1;
                    object.java_multiple_files = false;
                    object.go_package = "";
                    object.cc_generic_services = false;
                    object.java_generic_services = false;
                    object.py_generic_services = false;
                    object.java_generate_equals_and_hash = false;
                    object.deprecated = false;
                    object.java_string_check_utf8 = false;
                    object.cc_enable_arenas = false;
                    object.objc_class_prefix = "";
                    object.csharp_namespace = "";
                    object[".include_in_bitcoin_only"] = false;
                }
                if (message.java_package != null && message.hasOwnProperty("java_package"))
                    object.java_package = message.java_package;
                if (message.java_outer_classname != null && message.hasOwnProperty("java_outer_classname"))
                    object.java_outer_classname = message.java_outer_classname;
                if (message.optimize_for != null && message.hasOwnProperty("optimize_for"))
                    object.optimize_for = options.enums === String ? $root.google.protobuf.FileOptions.OptimizeMode[message.optimize_for] : message.optimize_for;
                if (message.java_multiple_files != null && message.hasOwnProperty("java_multiple_files"))
                    object.java_multiple_files = message.java_multiple_files;
                if (message.go_package != null && message.hasOwnProperty("go_package"))
                    object.go_package = message.go_package;
                if (message.cc_generic_services != null && message.hasOwnProperty("cc_generic_services"))
                    object.cc_generic_services = message.cc_generic_services;
                if (message.java_generic_services != null && message.hasOwnProperty("java_generic_services"))
                    object.java_generic_services = message.java_generic_services;
                if (message.py_generic_services != null && message.hasOwnProperty("py_generic_services"))
                    object.py_generic_services = message.py_generic_services;
                if (message.java_generate_equals_and_hash != null && message.hasOwnProperty("java_generate_equals_and_hash"))
                    object.java_generate_equals_and_hash = message.java_generate_equals_and_hash;
                if (message.deprecated != null && message.hasOwnProperty("deprecated"))
                    object.deprecated = message.deprecated;
                if (message.java_string_check_utf8 != null && message.hasOwnProperty("java_string_check_utf8"))
                    object.java_string_check_utf8 = message.java_string_check_utf8;
                if (message.cc_enable_arenas != null && message.hasOwnProperty("cc_enable_arenas"))
                    object.cc_enable_arenas = message.cc_enable_arenas;
                if (message.objc_class_prefix != null && message.hasOwnProperty("objc_class_prefix"))
                    object.objc_class_prefix = message.objc_class_prefix;
                if (message.csharp_namespace != null && message.hasOwnProperty("csharp_namespace"))
                    object.csharp_namespace = message.csharp_namespace;
                if (message.uninterpreted_option && message.uninterpreted_option.length) {
                    object.uninterpreted_option = [];
                    for (var j = 0; j < message.uninterpreted_option.length; ++j)
                        object.uninterpreted_option[j] = $root.google.protobuf.UninterpretedOption.toObject(message.uninterpreted_option[j], options);
                }
                if (message[".include_in_bitcoin_only"] != null && message.hasOwnProperty(".include_in_bitcoin_only"))
                    object[".include_in_bitcoin_only"] = message[".include_in_bitcoin_only"];
                return object;
            };

            FileOptions.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            FileOptions.OptimizeMode = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[1] = "SPEED"] = 1;
                values[valuesById[2] = "CODE_SIZE"] = 2;
                values[valuesById[3] = "LITE_RUNTIME"] = 3;
                return values;
            })();

            return FileOptions;
        })();

        protobuf.MessageOptions = (function() {

            function MessageOptions(properties) {
                this.uninterpreted_option = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            MessageOptions.prototype.message_set_wire_format = false;
            MessageOptions.prototype.no_standard_descriptor_accessor = false;
            MessageOptions.prototype.deprecated = false;
            MessageOptions.prototype.map_entry = false;
            MessageOptions.prototype.uninterpreted_option = $util.emptyArray;
            MessageOptions.prototype[".unstable"] = false;
            MessageOptions.prototype[".wire_type"] = 0;

            MessageOptions.create = function create(properties) {
                return new MessageOptions(properties);
            };

            MessageOptions.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.message_set_wire_format != null && Object.hasOwnProperty.call(message, "message_set_wire_format"))
                    writer.uint32(8).bool(message.message_set_wire_format);
                if (message.no_standard_descriptor_accessor != null && Object.hasOwnProperty.call(message, "no_standard_descriptor_accessor"))
                    writer.uint32(16).bool(message.no_standard_descriptor_accessor);
                if (message.deprecated != null && Object.hasOwnProperty.call(message, "deprecated"))
                    writer.uint32(24).bool(message.deprecated);
                if (message.map_entry != null && Object.hasOwnProperty.call(message, "map_entry"))
                    writer.uint32(56).bool(message.map_entry);
                if (message.uninterpreted_option != null && message.uninterpreted_option.length)
                    for (var i = 0; i < message.uninterpreted_option.length; ++i)
                        $root.google.protobuf.UninterpretedOption.encode(message.uninterpreted_option[i], writer.uint32(7994).fork()).ldelim();
                if (message[".unstable"] != null && Object.hasOwnProperty.call(message, ".unstable"))
                    writer.uint32(416008).bool(message[".unstable"]);
                if (message[".wire_type"] != null && Object.hasOwnProperty.call(message, ".wire_type"))
                    writer.uint32(416016).uint32(message[".wire_type"]);
                return writer;
            };

            MessageOptions.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            MessageOptions.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.MessageOptions();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.message_set_wire_format = reader.bool();
                        break;
                    case 2:
                        message.no_standard_descriptor_accessor = reader.bool();
                        break;
                    case 3:
                        message.deprecated = reader.bool();
                        break;
                    case 7:
                        message.map_entry = reader.bool();
                        break;
                    case 999:
                        if (!(message.uninterpreted_option && message.uninterpreted_option.length))
                            message.uninterpreted_option = [];
                        message.uninterpreted_option.push($root.google.protobuf.UninterpretedOption.decode(reader, reader.uint32()));
                        break;
                    case 52001:
                        message[".unstable"] = reader.bool();
                        break;
                    case 52002:
                        message[".wire_type"] = reader.uint32();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            MessageOptions.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            MessageOptions.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.message_set_wire_format != null && message.hasOwnProperty("message_set_wire_format"))
                    if (typeof message.message_set_wire_format !== "boolean")
                        return "message_set_wire_format: boolean expected";
                if (message.no_standard_descriptor_accessor != null && message.hasOwnProperty("no_standard_descriptor_accessor"))
                    if (typeof message.no_standard_descriptor_accessor !== "boolean")
                        return "no_standard_descriptor_accessor: boolean expected";
                if (message.deprecated != null && message.hasOwnProperty("deprecated"))
                    if (typeof message.deprecated !== "boolean")
                        return "deprecated: boolean expected";
                if (message.map_entry != null && message.hasOwnProperty("map_entry"))
                    if (typeof message.map_entry !== "boolean")
                        return "map_entry: boolean expected";
                if (message.uninterpreted_option != null && message.hasOwnProperty("uninterpreted_option")) {
                    if (!Array.isArray(message.uninterpreted_option))
                        return "uninterpreted_option: array expected";
                    for (var i = 0; i < message.uninterpreted_option.length; ++i) {
                        var error = $root.google.protobuf.UninterpretedOption.verify(message.uninterpreted_option[i]);
                        if (error)
                            return "uninterpreted_option." + error;
                    }
                }
                if (message[".unstable"] != null && message.hasOwnProperty(".unstable"))
                    if (typeof message[".unstable"] !== "boolean")
                        return ".unstable: boolean expected";
                if (message[".wire_type"] != null && message.hasOwnProperty(".wire_type"))
                    if (!$util.isInteger(message[".wire_type"]))
                        return ".wire_type: integer expected";
                return null;
            };

            MessageOptions.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.MessageOptions)
                    return object;
                var message = new $root.google.protobuf.MessageOptions();
                if (object.message_set_wire_format != null)
                    message.message_set_wire_format = Boolean(object.message_set_wire_format);
                if (object.no_standard_descriptor_accessor != null)
                    message.no_standard_descriptor_accessor = Boolean(object.no_standard_descriptor_accessor);
                if (object.deprecated != null)
                    message.deprecated = Boolean(object.deprecated);
                if (object.map_entry != null)
                    message.map_entry = Boolean(object.map_entry);
                if (object.uninterpreted_option) {
                    if (!Array.isArray(object.uninterpreted_option))
                        throw TypeError(".google.protobuf.MessageOptions.uninterpreted_option: array expected");
                    message.uninterpreted_option = [];
                    for (var i = 0; i < object.uninterpreted_option.length; ++i) {
                        if (typeof object.uninterpreted_option[i] !== "object")
                            throw TypeError(".google.protobuf.MessageOptions.uninterpreted_option: object expected");
                        message.uninterpreted_option[i] = $root.google.protobuf.UninterpretedOption.fromObject(object.uninterpreted_option[i]);
                    }
                }
                if (object[".unstable"] != null)
                    message[".unstable"] = Boolean(object[".unstable"]);
                if (object[".wire_type"] != null)
                    message[".wire_type"] = object[".wire_type"] >>> 0;
                return message;
            };

            MessageOptions.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.uninterpreted_option = [];
                if (options.defaults) {
                    object.message_set_wire_format = false;
                    object.no_standard_descriptor_accessor = false;
                    object.deprecated = false;
                    object.map_entry = false;
                    object[".unstable"] = false;
                    object[".wire_type"] = 0;
                }
                if (message.message_set_wire_format != null && message.hasOwnProperty("message_set_wire_format"))
                    object.message_set_wire_format = message.message_set_wire_format;
                if (message.no_standard_descriptor_accessor != null && message.hasOwnProperty("no_standard_descriptor_accessor"))
                    object.no_standard_descriptor_accessor = message.no_standard_descriptor_accessor;
                if (message.deprecated != null && message.hasOwnProperty("deprecated"))
                    object.deprecated = message.deprecated;
                if (message.map_entry != null && message.hasOwnProperty("map_entry"))
                    object.map_entry = message.map_entry;
                if (message.uninterpreted_option && message.uninterpreted_option.length) {
                    object.uninterpreted_option = [];
                    for (var j = 0; j < message.uninterpreted_option.length; ++j)
                        object.uninterpreted_option[j] = $root.google.protobuf.UninterpretedOption.toObject(message.uninterpreted_option[j], options);
                }
                if (message[".unstable"] != null && message.hasOwnProperty(".unstable"))
                    object[".unstable"] = message[".unstable"];
                if (message[".wire_type"] != null && message.hasOwnProperty(".wire_type"))
                    object[".wire_type"] = message[".wire_type"];
                return object;
            };

            MessageOptions.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return MessageOptions;
        })();

        protobuf.FieldOptions = (function() {

            function FieldOptions(properties) {
                this.uninterpreted_option = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            FieldOptions.prototype.ctype = 0;
            FieldOptions.prototype.packed = false;
            FieldOptions.prototype.jstype = 0;
            FieldOptions.prototype.lazy = false;
            FieldOptions.prototype.deprecated = false;
            FieldOptions.prototype.weak = false;
            FieldOptions.prototype.uninterpreted_option = $util.emptyArray;
            FieldOptions.prototype[".experimental"] = false;

            FieldOptions.create = function create(properties) {
                return new FieldOptions(properties);
            };

            FieldOptions.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.ctype != null && Object.hasOwnProperty.call(message, "ctype"))
                    writer.uint32(8).int32(message.ctype);
                if (message.packed != null && Object.hasOwnProperty.call(message, "packed"))
                    writer.uint32(16).bool(message.packed);
                if (message.deprecated != null && Object.hasOwnProperty.call(message, "deprecated"))
                    writer.uint32(24).bool(message.deprecated);
                if (message.lazy != null && Object.hasOwnProperty.call(message, "lazy"))
                    writer.uint32(40).bool(message.lazy);
                if (message.jstype != null && Object.hasOwnProperty.call(message, "jstype"))
                    writer.uint32(48).int32(message.jstype);
                if (message.weak != null && Object.hasOwnProperty.call(message, "weak"))
                    writer.uint32(80).bool(message.weak);
                if (message.uninterpreted_option != null && message.uninterpreted_option.length)
                    for (var i = 0; i < message.uninterpreted_option.length; ++i)
                        $root.google.protobuf.UninterpretedOption.encode(message.uninterpreted_option[i], writer.uint32(7994).fork()).ldelim();
                if (message[".experimental"] != null && Object.hasOwnProperty.call(message, ".experimental"))
                    writer.uint32(424008).bool(message[".experimental"]);
                return writer;
            };

            FieldOptions.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            FieldOptions.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.FieldOptions();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.ctype = reader.int32();
                        break;
                    case 2:
                        message.packed = reader.bool();
                        break;
                    case 6:
                        message.jstype = reader.int32();
                        break;
                    case 5:
                        message.lazy = reader.bool();
                        break;
                    case 3:
                        message.deprecated = reader.bool();
                        break;
                    case 10:
                        message.weak = reader.bool();
                        break;
                    case 999:
                        if (!(message.uninterpreted_option && message.uninterpreted_option.length))
                            message.uninterpreted_option = [];
                        message.uninterpreted_option.push($root.google.protobuf.UninterpretedOption.decode(reader, reader.uint32()));
                        break;
                    case 53001:
                        message[".experimental"] = reader.bool();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            FieldOptions.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            FieldOptions.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.ctype != null && message.hasOwnProperty("ctype"))
                    switch (message.ctype) {
                    default:
                        return "ctype: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                        break;
                    }
                if (message.packed != null && message.hasOwnProperty("packed"))
                    if (typeof message.packed !== "boolean")
                        return "packed: boolean expected";
                if (message.jstype != null && message.hasOwnProperty("jstype"))
                    switch (message.jstype) {
                    default:
                        return "jstype: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                        break;
                    }
                if (message.lazy != null && message.hasOwnProperty("lazy"))
                    if (typeof message.lazy !== "boolean")
                        return "lazy: boolean expected";
                if (message.deprecated != null && message.hasOwnProperty("deprecated"))
                    if (typeof message.deprecated !== "boolean")
                        return "deprecated: boolean expected";
                if (message.weak != null && message.hasOwnProperty("weak"))
                    if (typeof message.weak !== "boolean")
                        return "weak: boolean expected";
                if (message.uninterpreted_option != null && message.hasOwnProperty("uninterpreted_option")) {
                    if (!Array.isArray(message.uninterpreted_option))
                        return "uninterpreted_option: array expected";
                    for (var i = 0; i < message.uninterpreted_option.length; ++i) {
                        var error = $root.google.protobuf.UninterpretedOption.verify(message.uninterpreted_option[i]);
                        if (error)
                            return "uninterpreted_option." + error;
                    }
                }
                if (message[".experimental"] != null && message.hasOwnProperty(".experimental"))
                    if (typeof message[".experimental"] !== "boolean")
                        return ".experimental: boolean expected";
                return null;
            };

            FieldOptions.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.FieldOptions)
                    return object;
                var message = new $root.google.protobuf.FieldOptions();
                switch (object.ctype) {
                case "STRING":
                case 0:
                    message.ctype = 0;
                    break;
                case "CORD":
                case 1:
                    message.ctype = 1;
                    break;
                case "STRING_PIECE":
                case 2:
                    message.ctype = 2;
                    break;
                }
                if (object.packed != null)
                    message.packed = Boolean(object.packed);
                switch (object.jstype) {
                case "JS_NORMAL":
                case 0:
                    message.jstype = 0;
                    break;
                case "JS_STRING":
                case 1:
                    message.jstype = 1;
                    break;
                case "JS_NUMBER":
                case 2:
                    message.jstype = 2;
                    break;
                }
                if (object.lazy != null)
                    message.lazy = Boolean(object.lazy);
                if (object.deprecated != null)
                    message.deprecated = Boolean(object.deprecated);
                if (object.weak != null)
                    message.weak = Boolean(object.weak);
                if (object.uninterpreted_option) {
                    if (!Array.isArray(object.uninterpreted_option))
                        throw TypeError(".google.protobuf.FieldOptions.uninterpreted_option: array expected");
                    message.uninterpreted_option = [];
                    for (var i = 0; i < object.uninterpreted_option.length; ++i) {
                        if (typeof object.uninterpreted_option[i] !== "object")
                            throw TypeError(".google.protobuf.FieldOptions.uninterpreted_option: object expected");
                        message.uninterpreted_option[i] = $root.google.protobuf.UninterpretedOption.fromObject(object.uninterpreted_option[i]);
                    }
                }
                if (object[".experimental"] != null)
                    message[".experimental"] = Boolean(object[".experimental"]);
                return message;
            };

            FieldOptions.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.uninterpreted_option = [];
                if (options.defaults) {
                    object.ctype = options.enums === String ? "STRING" : 0;
                    object.packed = false;
                    object.deprecated = false;
                    object.lazy = false;
                    object.jstype = options.enums === String ? "JS_NORMAL" : 0;
                    object.weak = false;
                    object[".experimental"] = false;
                }
                if (message.ctype != null && message.hasOwnProperty("ctype"))
                    object.ctype = options.enums === String ? $root.google.protobuf.FieldOptions.CType[message.ctype] : message.ctype;
                if (message.packed != null && message.hasOwnProperty("packed"))
                    object.packed = message.packed;
                if (message.deprecated != null && message.hasOwnProperty("deprecated"))
                    object.deprecated = message.deprecated;
                if (message.lazy != null && message.hasOwnProperty("lazy"))
                    object.lazy = message.lazy;
                if (message.jstype != null && message.hasOwnProperty("jstype"))
                    object.jstype = options.enums === String ? $root.google.protobuf.FieldOptions.JSType[message.jstype] : message.jstype;
                if (message.weak != null && message.hasOwnProperty("weak"))
                    object.weak = message.weak;
                if (message.uninterpreted_option && message.uninterpreted_option.length) {
                    object.uninterpreted_option = [];
                    for (var j = 0; j < message.uninterpreted_option.length; ++j)
                        object.uninterpreted_option[j] = $root.google.protobuf.UninterpretedOption.toObject(message.uninterpreted_option[j], options);
                }
                if (message[".experimental"] != null && message.hasOwnProperty(".experimental"))
                    object[".experimental"] = message[".experimental"];
                return object;
            };

            FieldOptions.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            FieldOptions.CType = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "STRING"] = 0;
                values[valuesById[1] = "CORD"] = 1;
                values[valuesById[2] = "STRING_PIECE"] = 2;
                return values;
            })();

            FieldOptions.JSType = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "JS_NORMAL"] = 0;
                values[valuesById[1] = "JS_STRING"] = 1;
                values[valuesById[2] = "JS_NUMBER"] = 2;
                return values;
            })();

            return FieldOptions;
        })();

        protobuf.OneofOptions = (function() {

            function OneofOptions(properties) {
                this.uninterpreted_option = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            OneofOptions.prototype.uninterpreted_option = $util.emptyArray;

            OneofOptions.create = function create(properties) {
                return new OneofOptions(properties);
            };

            OneofOptions.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.uninterpreted_option != null && message.uninterpreted_option.length)
                    for (var i = 0; i < message.uninterpreted_option.length; ++i)
                        $root.google.protobuf.UninterpretedOption.encode(message.uninterpreted_option[i], writer.uint32(7994).fork()).ldelim();
                return writer;
            };

            OneofOptions.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            OneofOptions.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.OneofOptions();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 999:
                        if (!(message.uninterpreted_option && message.uninterpreted_option.length))
                            message.uninterpreted_option = [];
                        message.uninterpreted_option.push($root.google.protobuf.UninterpretedOption.decode(reader, reader.uint32()));
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            OneofOptions.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            OneofOptions.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.uninterpreted_option != null && message.hasOwnProperty("uninterpreted_option")) {
                    if (!Array.isArray(message.uninterpreted_option))
                        return "uninterpreted_option: array expected";
                    for (var i = 0; i < message.uninterpreted_option.length; ++i) {
                        var error = $root.google.protobuf.UninterpretedOption.verify(message.uninterpreted_option[i]);
                        if (error)
                            return "uninterpreted_option." + error;
                    }
                }
                return null;
            };

            OneofOptions.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.OneofOptions)
                    return object;
                var message = new $root.google.protobuf.OneofOptions();
                if (object.uninterpreted_option) {
                    if (!Array.isArray(object.uninterpreted_option))
                        throw TypeError(".google.protobuf.OneofOptions.uninterpreted_option: array expected");
                    message.uninterpreted_option = [];
                    for (var i = 0; i < object.uninterpreted_option.length; ++i) {
                        if (typeof object.uninterpreted_option[i] !== "object")
                            throw TypeError(".google.protobuf.OneofOptions.uninterpreted_option: object expected");
                        message.uninterpreted_option[i] = $root.google.protobuf.UninterpretedOption.fromObject(object.uninterpreted_option[i]);
                    }
                }
                return message;
            };

            OneofOptions.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.uninterpreted_option = [];
                if (message.uninterpreted_option && message.uninterpreted_option.length) {
                    object.uninterpreted_option = [];
                    for (var j = 0; j < message.uninterpreted_option.length; ++j)
                        object.uninterpreted_option[j] = $root.google.protobuf.UninterpretedOption.toObject(message.uninterpreted_option[j], options);
                }
                return object;
            };

            OneofOptions.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return OneofOptions;
        })();

        protobuf.EnumOptions = (function() {

            function EnumOptions(properties) {
                this.uninterpreted_option = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            EnumOptions.prototype.allow_alias = false;
            EnumOptions.prototype.deprecated = false;
            EnumOptions.prototype.uninterpreted_option = $util.emptyArray;
            EnumOptions.prototype[".has_bitcoin_only_values"] = false;

            EnumOptions.create = function create(properties) {
                return new EnumOptions(properties);
            };

            EnumOptions.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.allow_alias != null && Object.hasOwnProperty.call(message, "allow_alias"))
                    writer.uint32(16).bool(message.allow_alias);
                if (message.deprecated != null && Object.hasOwnProperty.call(message, "deprecated"))
                    writer.uint32(24).bool(message.deprecated);
                if (message.uninterpreted_option != null && message.uninterpreted_option.length)
                    for (var i = 0; i < message.uninterpreted_option.length; ++i)
                        $root.google.protobuf.UninterpretedOption.encode(message.uninterpreted_option[i], writer.uint32(7994).fork()).ldelim();
                if (message[".has_bitcoin_only_values"] != null && Object.hasOwnProperty.call(message, ".has_bitcoin_only_values"))
                    writer.uint32(408008).bool(message[".has_bitcoin_only_values"]);
                return writer;
            };

            EnumOptions.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            EnumOptions.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.EnumOptions();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 2:
                        message.allow_alias = reader.bool();
                        break;
                    case 3:
                        message.deprecated = reader.bool();
                        break;
                    case 999:
                        if (!(message.uninterpreted_option && message.uninterpreted_option.length))
                            message.uninterpreted_option = [];
                        message.uninterpreted_option.push($root.google.protobuf.UninterpretedOption.decode(reader, reader.uint32()));
                        break;
                    case 51001:
                        message[".has_bitcoin_only_values"] = reader.bool();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            EnumOptions.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            EnumOptions.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.allow_alias != null && message.hasOwnProperty("allow_alias"))
                    if (typeof message.allow_alias !== "boolean")
                        return "allow_alias: boolean expected";
                if (message.deprecated != null && message.hasOwnProperty("deprecated"))
                    if (typeof message.deprecated !== "boolean")
                        return "deprecated: boolean expected";
                if (message.uninterpreted_option != null && message.hasOwnProperty("uninterpreted_option")) {
                    if (!Array.isArray(message.uninterpreted_option))
                        return "uninterpreted_option: array expected";
                    for (var i = 0; i < message.uninterpreted_option.length; ++i) {
                        var error = $root.google.protobuf.UninterpretedOption.verify(message.uninterpreted_option[i]);
                        if (error)
                            return "uninterpreted_option." + error;
                    }
                }
                if (message[".has_bitcoin_only_values"] != null && message.hasOwnProperty(".has_bitcoin_only_values"))
                    if (typeof message[".has_bitcoin_only_values"] !== "boolean")
                        return ".has_bitcoin_only_values: boolean expected";
                return null;
            };

            EnumOptions.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.EnumOptions)
                    return object;
                var message = new $root.google.protobuf.EnumOptions();
                if (object.allow_alias != null)
                    message.allow_alias = Boolean(object.allow_alias);
                if (object.deprecated != null)
                    message.deprecated = Boolean(object.deprecated);
                if (object.uninterpreted_option) {
                    if (!Array.isArray(object.uninterpreted_option))
                        throw TypeError(".google.protobuf.EnumOptions.uninterpreted_option: array expected");
                    message.uninterpreted_option = [];
                    for (var i = 0; i < object.uninterpreted_option.length; ++i) {
                        if (typeof object.uninterpreted_option[i] !== "object")
                            throw TypeError(".google.protobuf.EnumOptions.uninterpreted_option: object expected");
                        message.uninterpreted_option[i] = $root.google.protobuf.UninterpretedOption.fromObject(object.uninterpreted_option[i]);
                    }
                }
                if (object[".has_bitcoin_only_values"] != null)
                    message[".has_bitcoin_only_values"] = Boolean(object[".has_bitcoin_only_values"]);
                return message;
            };

            EnumOptions.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.uninterpreted_option = [];
                if (options.defaults) {
                    object.allow_alias = false;
                    object.deprecated = false;
                    object[".has_bitcoin_only_values"] = false;
                }
                if (message.allow_alias != null && message.hasOwnProperty("allow_alias"))
                    object.allow_alias = message.allow_alias;
                if (message.deprecated != null && message.hasOwnProperty("deprecated"))
                    object.deprecated = message.deprecated;
                if (message.uninterpreted_option && message.uninterpreted_option.length) {
                    object.uninterpreted_option = [];
                    for (var j = 0; j < message.uninterpreted_option.length; ++j)
                        object.uninterpreted_option[j] = $root.google.protobuf.UninterpretedOption.toObject(message.uninterpreted_option[j], options);
                }
                if (message[".has_bitcoin_only_values"] != null && message.hasOwnProperty(".has_bitcoin_only_values"))
                    object[".has_bitcoin_only_values"] = message[".has_bitcoin_only_values"];
                return object;
            };

            EnumOptions.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return EnumOptions;
        })();

        protobuf.EnumValueOptions = (function() {

            function EnumValueOptions(properties) {
                this.uninterpreted_option = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            EnumValueOptions.prototype.deprecated = false;
            EnumValueOptions.prototype.uninterpreted_option = $util.emptyArray;
            EnumValueOptions.prototype[".wire_in"] = false;
            EnumValueOptions.prototype[".wire_out"] = false;
            EnumValueOptions.prototype[".wire_debug_in"] = false;
            EnumValueOptions.prototype[".wire_debug_out"] = false;
            EnumValueOptions.prototype[".wire_tiny"] = false;
            EnumValueOptions.prototype[".wire_bootloader"] = false;
            EnumValueOptions.prototype[".wire_no_fsm"] = false;
            EnumValueOptions.prototype[".facotry"] = false;
            EnumValueOptions.prototype[".bitcoin_only"] = false;

            EnumValueOptions.create = function create(properties) {
                return new EnumValueOptions(properties);
            };

            EnumValueOptions.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.deprecated != null && Object.hasOwnProperty.call(message, "deprecated"))
                    writer.uint32(8).bool(message.deprecated);
                if (message.uninterpreted_option != null && message.uninterpreted_option.length)
                    for (var i = 0; i < message.uninterpreted_option.length; ++i)
                        $root.google.protobuf.UninterpretedOption.encode(message.uninterpreted_option[i], writer.uint32(7994).fork()).ldelim();
                if (message[".wire_in"] != null && Object.hasOwnProperty.call(message, ".wire_in"))
                    writer.uint32(400016).bool(message[".wire_in"]);
                if (message[".wire_out"] != null && Object.hasOwnProperty.call(message, ".wire_out"))
                    writer.uint32(400024).bool(message[".wire_out"]);
                if (message[".wire_debug_in"] != null && Object.hasOwnProperty.call(message, ".wire_debug_in"))
                    writer.uint32(400032).bool(message[".wire_debug_in"]);
                if (message[".wire_debug_out"] != null && Object.hasOwnProperty.call(message, ".wire_debug_out"))
                    writer.uint32(400040).bool(message[".wire_debug_out"]);
                if (message[".wire_tiny"] != null && Object.hasOwnProperty.call(message, ".wire_tiny"))
                    writer.uint32(400048).bool(message[".wire_tiny"]);
                if (message[".wire_bootloader"] != null && Object.hasOwnProperty.call(message, ".wire_bootloader"))
                    writer.uint32(400056).bool(message[".wire_bootloader"]);
                if (message[".wire_no_fsm"] != null && Object.hasOwnProperty.call(message, ".wire_no_fsm"))
                    writer.uint32(400064).bool(message[".wire_no_fsm"]);
                if (message[".facotry"] != null && Object.hasOwnProperty.call(message, ".facotry"))
                    writer.uint32(404008).bool(message[".facotry"]);
                if (message[".bitcoin_only"] != null && Object.hasOwnProperty.call(message, ".bitcoin_only"))
                    writer.uint32(480000).bool(message[".bitcoin_only"]);
                return writer;
            };

            EnumValueOptions.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            EnumValueOptions.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.EnumValueOptions();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.deprecated = reader.bool();
                        break;
                    case 999:
                        if (!(message.uninterpreted_option && message.uninterpreted_option.length))
                            message.uninterpreted_option = [];
                        message.uninterpreted_option.push($root.google.protobuf.UninterpretedOption.decode(reader, reader.uint32()));
                        break;
                    case 50002:
                        message[".wire_in"] = reader.bool();
                        break;
                    case 50003:
                        message[".wire_out"] = reader.bool();
                        break;
                    case 50004:
                        message[".wire_debug_in"] = reader.bool();
                        break;
                    case 50005:
                        message[".wire_debug_out"] = reader.bool();
                        break;
                    case 50006:
                        message[".wire_tiny"] = reader.bool();
                        break;
                    case 50007:
                        message[".wire_bootloader"] = reader.bool();
                        break;
                    case 50008:
                        message[".wire_no_fsm"] = reader.bool();
                        break;
                    case 50501:
                        message[".facotry"] = reader.bool();
                        break;
                    case 60000:
                        message[".bitcoin_only"] = reader.bool();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            EnumValueOptions.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            EnumValueOptions.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.deprecated != null && message.hasOwnProperty("deprecated"))
                    if (typeof message.deprecated !== "boolean")
                        return "deprecated: boolean expected";
                if (message.uninterpreted_option != null && message.hasOwnProperty("uninterpreted_option")) {
                    if (!Array.isArray(message.uninterpreted_option))
                        return "uninterpreted_option: array expected";
                    for (var i = 0; i < message.uninterpreted_option.length; ++i) {
                        var error = $root.google.protobuf.UninterpretedOption.verify(message.uninterpreted_option[i]);
                        if (error)
                            return "uninterpreted_option." + error;
                    }
                }
                if (message[".wire_in"] != null && message.hasOwnProperty(".wire_in"))
                    if (typeof message[".wire_in"] !== "boolean")
                        return ".wire_in: boolean expected";
                if (message[".wire_out"] != null && message.hasOwnProperty(".wire_out"))
                    if (typeof message[".wire_out"] !== "boolean")
                        return ".wire_out: boolean expected";
                if (message[".wire_debug_in"] != null && message.hasOwnProperty(".wire_debug_in"))
                    if (typeof message[".wire_debug_in"] !== "boolean")
                        return ".wire_debug_in: boolean expected";
                if (message[".wire_debug_out"] != null && message.hasOwnProperty(".wire_debug_out"))
                    if (typeof message[".wire_debug_out"] !== "boolean")
                        return ".wire_debug_out: boolean expected";
                if (message[".wire_tiny"] != null && message.hasOwnProperty(".wire_tiny"))
                    if (typeof message[".wire_tiny"] !== "boolean")
                        return ".wire_tiny: boolean expected";
                if (message[".wire_bootloader"] != null && message.hasOwnProperty(".wire_bootloader"))
                    if (typeof message[".wire_bootloader"] !== "boolean")
                        return ".wire_bootloader: boolean expected";
                if (message[".wire_no_fsm"] != null && message.hasOwnProperty(".wire_no_fsm"))
                    if (typeof message[".wire_no_fsm"] !== "boolean")
                        return ".wire_no_fsm: boolean expected";
                if (message[".facotry"] != null && message.hasOwnProperty(".facotry"))
                    if (typeof message[".facotry"] !== "boolean")
                        return ".facotry: boolean expected";
                if (message[".bitcoin_only"] != null && message.hasOwnProperty(".bitcoin_only"))
                    if (typeof message[".bitcoin_only"] !== "boolean")
                        return ".bitcoin_only: boolean expected";
                return null;
            };

            EnumValueOptions.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.EnumValueOptions)
                    return object;
                var message = new $root.google.protobuf.EnumValueOptions();
                if (object.deprecated != null)
                    message.deprecated = Boolean(object.deprecated);
                if (object.uninterpreted_option) {
                    if (!Array.isArray(object.uninterpreted_option))
                        throw TypeError(".google.protobuf.EnumValueOptions.uninterpreted_option: array expected");
                    message.uninterpreted_option = [];
                    for (var i = 0; i < object.uninterpreted_option.length; ++i) {
                        if (typeof object.uninterpreted_option[i] !== "object")
                            throw TypeError(".google.protobuf.EnumValueOptions.uninterpreted_option: object expected");
                        message.uninterpreted_option[i] = $root.google.protobuf.UninterpretedOption.fromObject(object.uninterpreted_option[i]);
                    }
                }
                if (object[".wire_in"] != null)
                    message[".wire_in"] = Boolean(object[".wire_in"]);
                if (object[".wire_out"] != null)
                    message[".wire_out"] = Boolean(object[".wire_out"]);
                if (object[".wire_debug_in"] != null)
                    message[".wire_debug_in"] = Boolean(object[".wire_debug_in"]);
                if (object[".wire_debug_out"] != null)
                    message[".wire_debug_out"] = Boolean(object[".wire_debug_out"]);
                if (object[".wire_tiny"] != null)
                    message[".wire_tiny"] = Boolean(object[".wire_tiny"]);
                if (object[".wire_bootloader"] != null)
                    message[".wire_bootloader"] = Boolean(object[".wire_bootloader"]);
                if (object[".wire_no_fsm"] != null)
                    message[".wire_no_fsm"] = Boolean(object[".wire_no_fsm"]);
                if (object[".facotry"] != null)
                    message[".facotry"] = Boolean(object[".facotry"]);
                if (object[".bitcoin_only"] != null)
                    message[".bitcoin_only"] = Boolean(object[".bitcoin_only"]);
                return message;
            };

            EnumValueOptions.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.uninterpreted_option = [];
                if (options.defaults) {
                    object.deprecated = false;
                    object[".wire_in"] = false;
                    object[".wire_out"] = false;
                    object[".wire_debug_in"] = false;
                    object[".wire_debug_out"] = false;
                    object[".wire_tiny"] = false;
                    object[".wire_bootloader"] = false;
                    object[".wire_no_fsm"] = false;
                    object[".facotry"] = false;
                    object[".bitcoin_only"] = false;
                }
                if (message.deprecated != null && message.hasOwnProperty("deprecated"))
                    object.deprecated = message.deprecated;
                if (message.uninterpreted_option && message.uninterpreted_option.length) {
                    object.uninterpreted_option = [];
                    for (var j = 0; j < message.uninterpreted_option.length; ++j)
                        object.uninterpreted_option[j] = $root.google.protobuf.UninterpretedOption.toObject(message.uninterpreted_option[j], options);
                }
                if (message[".wire_in"] != null && message.hasOwnProperty(".wire_in"))
                    object[".wire_in"] = message[".wire_in"];
                if (message[".wire_out"] != null && message.hasOwnProperty(".wire_out"))
                    object[".wire_out"] = message[".wire_out"];
                if (message[".wire_debug_in"] != null && message.hasOwnProperty(".wire_debug_in"))
                    object[".wire_debug_in"] = message[".wire_debug_in"];
                if (message[".wire_debug_out"] != null && message.hasOwnProperty(".wire_debug_out"))
                    object[".wire_debug_out"] = message[".wire_debug_out"];
                if (message[".wire_tiny"] != null && message.hasOwnProperty(".wire_tiny"))
                    object[".wire_tiny"] = message[".wire_tiny"];
                if (message[".wire_bootloader"] != null && message.hasOwnProperty(".wire_bootloader"))
                    object[".wire_bootloader"] = message[".wire_bootloader"];
                if (message[".wire_no_fsm"] != null && message.hasOwnProperty(".wire_no_fsm"))
                    object[".wire_no_fsm"] = message[".wire_no_fsm"];
                if (message[".facotry"] != null && message.hasOwnProperty(".facotry"))
                    object[".facotry"] = message[".facotry"];
                if (message[".bitcoin_only"] != null && message.hasOwnProperty(".bitcoin_only"))
                    object[".bitcoin_only"] = message[".bitcoin_only"];
                return object;
            };

            EnumValueOptions.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return EnumValueOptions;
        })();

        protobuf.ServiceOptions = (function() {

            function ServiceOptions(properties) {
                this.uninterpreted_option = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            ServiceOptions.prototype.deprecated = false;
            ServiceOptions.prototype.uninterpreted_option = $util.emptyArray;

            ServiceOptions.create = function create(properties) {
                return new ServiceOptions(properties);
            };

            ServiceOptions.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.deprecated != null && Object.hasOwnProperty.call(message, "deprecated"))
                    writer.uint32(264).bool(message.deprecated);
                if (message.uninterpreted_option != null && message.uninterpreted_option.length)
                    for (var i = 0; i < message.uninterpreted_option.length; ++i)
                        $root.google.protobuf.UninterpretedOption.encode(message.uninterpreted_option[i], writer.uint32(7994).fork()).ldelim();
                return writer;
            };

            ServiceOptions.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            ServiceOptions.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.ServiceOptions();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 33:
                        message.deprecated = reader.bool();
                        break;
                    case 999:
                        if (!(message.uninterpreted_option && message.uninterpreted_option.length))
                            message.uninterpreted_option = [];
                        message.uninterpreted_option.push($root.google.protobuf.UninterpretedOption.decode(reader, reader.uint32()));
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            ServiceOptions.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            ServiceOptions.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.deprecated != null && message.hasOwnProperty("deprecated"))
                    if (typeof message.deprecated !== "boolean")
                        return "deprecated: boolean expected";
                if (message.uninterpreted_option != null && message.hasOwnProperty("uninterpreted_option")) {
                    if (!Array.isArray(message.uninterpreted_option))
                        return "uninterpreted_option: array expected";
                    for (var i = 0; i < message.uninterpreted_option.length; ++i) {
                        var error = $root.google.protobuf.UninterpretedOption.verify(message.uninterpreted_option[i]);
                        if (error)
                            return "uninterpreted_option." + error;
                    }
                }
                return null;
            };

            ServiceOptions.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.ServiceOptions)
                    return object;
                var message = new $root.google.protobuf.ServiceOptions();
                if (object.deprecated != null)
                    message.deprecated = Boolean(object.deprecated);
                if (object.uninterpreted_option) {
                    if (!Array.isArray(object.uninterpreted_option))
                        throw TypeError(".google.protobuf.ServiceOptions.uninterpreted_option: array expected");
                    message.uninterpreted_option = [];
                    for (var i = 0; i < object.uninterpreted_option.length; ++i) {
                        if (typeof object.uninterpreted_option[i] !== "object")
                            throw TypeError(".google.protobuf.ServiceOptions.uninterpreted_option: object expected");
                        message.uninterpreted_option[i] = $root.google.protobuf.UninterpretedOption.fromObject(object.uninterpreted_option[i]);
                    }
                }
                return message;
            };

            ServiceOptions.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.uninterpreted_option = [];
                if (options.defaults)
                    object.deprecated = false;
                if (message.deprecated != null && message.hasOwnProperty("deprecated"))
                    object.deprecated = message.deprecated;
                if (message.uninterpreted_option && message.uninterpreted_option.length) {
                    object.uninterpreted_option = [];
                    for (var j = 0; j < message.uninterpreted_option.length; ++j)
                        object.uninterpreted_option[j] = $root.google.protobuf.UninterpretedOption.toObject(message.uninterpreted_option[j], options);
                }
                return object;
            };

            ServiceOptions.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return ServiceOptions;
        })();

        protobuf.MethodOptions = (function() {

            function MethodOptions(properties) {
                this.uninterpreted_option = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            MethodOptions.prototype.deprecated = false;
            MethodOptions.prototype.uninterpreted_option = $util.emptyArray;

            MethodOptions.create = function create(properties) {
                return new MethodOptions(properties);
            };

            MethodOptions.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.deprecated != null && Object.hasOwnProperty.call(message, "deprecated"))
                    writer.uint32(264).bool(message.deprecated);
                if (message.uninterpreted_option != null && message.uninterpreted_option.length)
                    for (var i = 0; i < message.uninterpreted_option.length; ++i)
                        $root.google.protobuf.UninterpretedOption.encode(message.uninterpreted_option[i], writer.uint32(7994).fork()).ldelim();
                return writer;
            };

            MethodOptions.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            MethodOptions.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.MethodOptions();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 33:
                        message.deprecated = reader.bool();
                        break;
                    case 999:
                        if (!(message.uninterpreted_option && message.uninterpreted_option.length))
                            message.uninterpreted_option = [];
                        message.uninterpreted_option.push($root.google.protobuf.UninterpretedOption.decode(reader, reader.uint32()));
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            MethodOptions.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            MethodOptions.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.deprecated != null && message.hasOwnProperty("deprecated"))
                    if (typeof message.deprecated !== "boolean")
                        return "deprecated: boolean expected";
                if (message.uninterpreted_option != null && message.hasOwnProperty("uninterpreted_option")) {
                    if (!Array.isArray(message.uninterpreted_option))
                        return "uninterpreted_option: array expected";
                    for (var i = 0; i < message.uninterpreted_option.length; ++i) {
                        var error = $root.google.protobuf.UninterpretedOption.verify(message.uninterpreted_option[i]);
                        if (error)
                            return "uninterpreted_option." + error;
                    }
                }
                return null;
            };

            MethodOptions.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.MethodOptions)
                    return object;
                var message = new $root.google.protobuf.MethodOptions();
                if (object.deprecated != null)
                    message.deprecated = Boolean(object.deprecated);
                if (object.uninterpreted_option) {
                    if (!Array.isArray(object.uninterpreted_option))
                        throw TypeError(".google.protobuf.MethodOptions.uninterpreted_option: array expected");
                    message.uninterpreted_option = [];
                    for (var i = 0; i < object.uninterpreted_option.length; ++i) {
                        if (typeof object.uninterpreted_option[i] !== "object")
                            throw TypeError(".google.protobuf.MethodOptions.uninterpreted_option: object expected");
                        message.uninterpreted_option[i] = $root.google.protobuf.UninterpretedOption.fromObject(object.uninterpreted_option[i]);
                    }
                }
                return message;
            };

            MethodOptions.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.uninterpreted_option = [];
                if (options.defaults)
                    object.deprecated = false;
                if (message.deprecated != null && message.hasOwnProperty("deprecated"))
                    object.deprecated = message.deprecated;
                if (message.uninterpreted_option && message.uninterpreted_option.length) {
                    object.uninterpreted_option = [];
                    for (var j = 0; j < message.uninterpreted_option.length; ++j)
                        object.uninterpreted_option[j] = $root.google.protobuf.UninterpretedOption.toObject(message.uninterpreted_option[j], options);
                }
                return object;
            };

            MethodOptions.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return MethodOptions;
        })();

        protobuf.UninterpretedOption = (function() {

            function UninterpretedOption(properties) {
                this.name = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            UninterpretedOption.prototype.name = $util.emptyArray;
            UninterpretedOption.prototype.identifier_value = "";
            UninterpretedOption.prototype.positive_int_value = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
            UninterpretedOption.prototype.negative_int_value = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
            UninterpretedOption.prototype.double_value = 0;
            UninterpretedOption.prototype.string_value = $util.newBuffer([]);
            UninterpretedOption.prototype.aggregate_value = "";

            UninterpretedOption.create = function create(properties) {
                return new UninterpretedOption(properties);
            };

            UninterpretedOption.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.name != null && message.name.length)
                    for (var i = 0; i < message.name.length; ++i)
                        $root.google.protobuf.UninterpretedOption.NamePart.encode(message.name[i], writer.uint32(18).fork()).ldelim();
                if (message.identifier_value != null && Object.hasOwnProperty.call(message, "identifier_value"))
                    writer.uint32(26).string(message.identifier_value);
                if (message.positive_int_value != null && Object.hasOwnProperty.call(message, "positive_int_value"))
                    writer.uint32(32).uint64(message.positive_int_value);
                if (message.negative_int_value != null && Object.hasOwnProperty.call(message, "negative_int_value"))
                    writer.uint32(40).int64(message.negative_int_value);
                if (message.double_value != null && Object.hasOwnProperty.call(message, "double_value"))
                    writer.uint32(49).double(message.double_value);
                if (message.string_value != null && Object.hasOwnProperty.call(message, "string_value"))
                    writer.uint32(58).bytes(message.string_value);
                if (message.aggregate_value != null && Object.hasOwnProperty.call(message, "aggregate_value"))
                    writer.uint32(66).string(message.aggregate_value);
                return writer;
            };

            UninterpretedOption.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            UninterpretedOption.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.UninterpretedOption();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 2:
                        if (!(message.name && message.name.length))
                            message.name = [];
                        message.name.push($root.google.protobuf.UninterpretedOption.NamePart.decode(reader, reader.uint32()));
                        break;
                    case 3:
                        message.identifier_value = reader.string();
                        break;
                    case 4:
                        message.positive_int_value = reader.uint64();
                        break;
                    case 5:
                        message.negative_int_value = reader.int64();
                        break;
                    case 6:
                        message.double_value = reader.double();
                        break;
                    case 7:
                        message.string_value = reader.bytes();
                        break;
                    case 8:
                        message.aggregate_value = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            UninterpretedOption.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            UninterpretedOption.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.name != null && message.hasOwnProperty("name")) {
                    if (!Array.isArray(message.name))
                        return "name: array expected";
                    for (var i = 0; i < message.name.length; ++i) {
                        var error = $root.google.protobuf.UninterpretedOption.NamePart.verify(message.name[i]);
                        if (error)
                            return "name." + error;
                    }
                }
                if (message.identifier_value != null && message.hasOwnProperty("identifier_value"))
                    if (!$util.isString(message.identifier_value))
                        return "identifier_value: string expected";
                if (message.positive_int_value != null && message.hasOwnProperty("positive_int_value"))
                    if (!$util.isInteger(message.positive_int_value) && !(message.positive_int_value && $util.isInteger(message.positive_int_value.low) && $util.isInteger(message.positive_int_value.high)))
                        return "positive_int_value: integer|Long expected";
                if (message.negative_int_value != null && message.hasOwnProperty("negative_int_value"))
                    if (!$util.isInteger(message.negative_int_value) && !(message.negative_int_value && $util.isInteger(message.negative_int_value.low) && $util.isInteger(message.negative_int_value.high)))
                        return "negative_int_value: integer|Long expected";
                if (message.double_value != null && message.hasOwnProperty("double_value"))
                    if (typeof message.double_value !== "number")
                        return "double_value: number expected";
                if (message.string_value != null && message.hasOwnProperty("string_value"))
                    if (!(message.string_value && typeof message.string_value.length === "number" || $util.isString(message.string_value)))
                        return "string_value: buffer expected";
                if (message.aggregate_value != null && message.hasOwnProperty("aggregate_value"))
                    if (!$util.isString(message.aggregate_value))
                        return "aggregate_value: string expected";
                return null;
            };

            UninterpretedOption.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.UninterpretedOption)
                    return object;
                var message = new $root.google.protobuf.UninterpretedOption();
                if (object.name) {
                    if (!Array.isArray(object.name))
                        throw TypeError(".google.protobuf.UninterpretedOption.name: array expected");
                    message.name = [];
                    for (var i = 0; i < object.name.length; ++i) {
                        if (typeof object.name[i] !== "object")
                            throw TypeError(".google.protobuf.UninterpretedOption.name: object expected");
                        message.name[i] = $root.google.protobuf.UninterpretedOption.NamePart.fromObject(object.name[i]);
                    }
                }
                if (object.identifier_value != null)
                    message.identifier_value = String(object.identifier_value);
                if (object.positive_int_value != null)
                    if ($util.Long)
                        (message.positive_int_value = $util.Long.fromValue(object.positive_int_value)).unsigned = true;
                    else if (typeof object.positive_int_value === "string")
                        message.positive_int_value = parseInt(object.positive_int_value, 10);
                    else if (typeof object.positive_int_value === "number")
                        message.positive_int_value = object.positive_int_value;
                    else if (typeof object.positive_int_value === "object")
                        message.positive_int_value = new $util.LongBits(object.positive_int_value.low >>> 0, object.positive_int_value.high >>> 0).toNumber(true);
                if (object.negative_int_value != null)
                    if ($util.Long)
                        (message.negative_int_value = $util.Long.fromValue(object.negative_int_value)).unsigned = false;
                    else if (typeof object.negative_int_value === "string")
                        message.negative_int_value = parseInt(object.negative_int_value, 10);
                    else if (typeof object.negative_int_value === "number")
                        message.negative_int_value = object.negative_int_value;
                    else if (typeof object.negative_int_value === "object")
                        message.negative_int_value = new $util.LongBits(object.negative_int_value.low >>> 0, object.negative_int_value.high >>> 0).toNumber();
                if (object.double_value != null)
                    message.double_value = Number(object.double_value);
                if (object.string_value != null)
                    if (typeof object.string_value === "string")
                        $util.base64.decode(object.string_value, message.string_value = $util.newBuffer($util.base64.length(object.string_value)), 0);
                    else if (object.string_value.length)
                        message.string_value = object.string_value;
                if (object.aggregate_value != null)
                    message.aggregate_value = String(object.aggregate_value);
                return message;
            };

            UninterpretedOption.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.name = [];
                if (options.defaults) {
                    object.identifier_value = "";
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, true);
                        object.positive_int_value = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.positive_int_value = options.longs === String ? "0" : 0;
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.negative_int_value = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.negative_int_value = options.longs === String ? "0" : 0;
                    object.double_value = 0;
                    if (options.bytes === String)
                        object.string_value = "";
                    else {
                        object.string_value = [];
                        if (options.bytes !== Array)
                            object.string_value = $util.newBuffer(object.string_value);
                    }
                    object.aggregate_value = "";
                }
                if (message.name && message.name.length) {
                    object.name = [];
                    for (var j = 0; j < message.name.length; ++j)
                        object.name[j] = $root.google.protobuf.UninterpretedOption.NamePart.toObject(message.name[j], options);
                }
                if (message.identifier_value != null && message.hasOwnProperty("identifier_value"))
                    object.identifier_value = message.identifier_value;
                if (message.positive_int_value != null && message.hasOwnProperty("positive_int_value"))
                    if (typeof message.positive_int_value === "number")
                        object.positive_int_value = options.longs === String ? String(message.positive_int_value) : message.positive_int_value;
                    else
                        object.positive_int_value = options.longs === String ? $util.Long.prototype.toString.call(message.positive_int_value) : options.longs === Number ? new $util.LongBits(message.positive_int_value.low >>> 0, message.positive_int_value.high >>> 0).toNumber(true) : message.positive_int_value;
                if (message.negative_int_value != null && message.hasOwnProperty("negative_int_value"))
                    if (typeof message.negative_int_value === "number")
                        object.negative_int_value = options.longs === String ? String(message.negative_int_value) : message.negative_int_value;
                    else
                        object.negative_int_value = options.longs === String ? $util.Long.prototype.toString.call(message.negative_int_value) : options.longs === Number ? new $util.LongBits(message.negative_int_value.low >>> 0, message.negative_int_value.high >>> 0).toNumber() : message.negative_int_value;
                if (message.double_value != null && message.hasOwnProperty("double_value"))
                    object.double_value = options.json && !isFinite(message.double_value) ? String(message.double_value) : message.double_value;
                if (message.string_value != null && message.hasOwnProperty("string_value"))
                    object.string_value = options.bytes === String ? $util.base64.encode(message.string_value, 0, message.string_value.length) : options.bytes === Array ? Array.prototype.slice.call(message.string_value) : message.string_value;
                if (message.aggregate_value != null && message.hasOwnProperty("aggregate_value"))
                    object.aggregate_value = message.aggregate_value;
                return object;
            };

            UninterpretedOption.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            UninterpretedOption.NamePart = (function() {

                function NamePart(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                NamePart.prototype.name_part = "";
                NamePart.prototype.is_extension = false;

                NamePart.create = function create(properties) {
                    return new NamePart(properties);
                };

                NamePart.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    writer.uint32(10).string(message.name_part);
                    writer.uint32(16).bool(message.is_extension);
                    return writer;
                };

                NamePart.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                NamePart.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.UninterpretedOption.NamePart();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.name_part = reader.string();
                            break;
                        case 2:
                            message.is_extension = reader.bool();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    if (!message.hasOwnProperty("name_part"))
                        throw $util.ProtocolError("missing required 'name_part'", { instance: message });
                    if (!message.hasOwnProperty("is_extension"))
                        throw $util.ProtocolError("missing required 'is_extension'", { instance: message });
                    return message;
                };

                NamePart.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                NamePart.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (!$util.isString(message.name_part))
                        return "name_part: string expected";
                    if (typeof message.is_extension !== "boolean")
                        return "is_extension: boolean expected";
                    return null;
                };

                NamePart.fromObject = function fromObject(object) {
                    if (object instanceof $root.google.protobuf.UninterpretedOption.NamePart)
                        return object;
                    var message = new $root.google.protobuf.UninterpretedOption.NamePart();
                    if (object.name_part != null)
                        message.name_part = String(object.name_part);
                    if (object.is_extension != null)
                        message.is_extension = Boolean(object.is_extension);
                    return message;
                };

                NamePart.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.name_part = "";
                        object.is_extension = false;
                    }
                    if (message.name_part != null && message.hasOwnProperty("name_part"))
                        object.name_part = message.name_part;
                    if (message.is_extension != null && message.hasOwnProperty("is_extension"))
                        object.is_extension = message.is_extension;
                    return object;
                };

                NamePart.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return NamePart;
            })();

            return UninterpretedOption;
        })();

        protobuf.SourceCodeInfo = (function() {

            function SourceCodeInfo(properties) {
                this.location = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            SourceCodeInfo.prototype.location = $util.emptyArray;

            SourceCodeInfo.create = function create(properties) {
                return new SourceCodeInfo(properties);
            };

            SourceCodeInfo.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.location != null && message.location.length)
                    for (var i = 0; i < message.location.length; ++i)
                        $root.google.protobuf.SourceCodeInfo.Location.encode(message.location[i], writer.uint32(10).fork()).ldelim();
                return writer;
            };

            SourceCodeInfo.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            SourceCodeInfo.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.SourceCodeInfo();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (!(message.location && message.location.length))
                            message.location = [];
                        message.location.push($root.google.protobuf.SourceCodeInfo.Location.decode(reader, reader.uint32()));
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            SourceCodeInfo.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            SourceCodeInfo.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.location != null && message.hasOwnProperty("location")) {
                    if (!Array.isArray(message.location))
                        return "location: array expected";
                    for (var i = 0; i < message.location.length; ++i) {
                        var error = $root.google.protobuf.SourceCodeInfo.Location.verify(message.location[i]);
                        if (error)
                            return "location." + error;
                    }
                }
                return null;
            };

            SourceCodeInfo.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.SourceCodeInfo)
                    return object;
                var message = new $root.google.protobuf.SourceCodeInfo();
                if (object.location) {
                    if (!Array.isArray(object.location))
                        throw TypeError(".google.protobuf.SourceCodeInfo.location: array expected");
                    message.location = [];
                    for (var i = 0; i < object.location.length; ++i) {
                        if (typeof object.location[i] !== "object")
                            throw TypeError(".google.protobuf.SourceCodeInfo.location: object expected");
                        message.location[i] = $root.google.protobuf.SourceCodeInfo.Location.fromObject(object.location[i]);
                    }
                }
                return message;
            };

            SourceCodeInfo.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.location = [];
                if (message.location && message.location.length) {
                    object.location = [];
                    for (var j = 0; j < message.location.length; ++j)
                        object.location[j] = $root.google.protobuf.SourceCodeInfo.Location.toObject(message.location[j], options);
                }
                return object;
            };

            SourceCodeInfo.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            SourceCodeInfo.Location = (function() {

                function Location(properties) {
                    this.path = [];
                    this.span = [];
                    this.leading_detached_comments = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                Location.prototype.path = $util.emptyArray;
                Location.prototype.span = $util.emptyArray;
                Location.prototype.leading_comments = "";
                Location.prototype.trailing_comments = "";
                Location.prototype.leading_detached_comments = $util.emptyArray;

                Location.create = function create(properties) {
                    return new Location(properties);
                };

                Location.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.path != null && message.path.length) {
                        writer.uint32(10).fork();
                        for (var i = 0; i < message.path.length; ++i)
                            writer.int32(message.path[i]);
                        writer.ldelim();
                    }
                    if (message.span != null && message.span.length) {
                        writer.uint32(18).fork();
                        for (var i = 0; i < message.span.length; ++i)
                            writer.int32(message.span[i]);
                        writer.ldelim();
                    }
                    if (message.leading_comments != null && Object.hasOwnProperty.call(message, "leading_comments"))
                        writer.uint32(26).string(message.leading_comments);
                    if (message.trailing_comments != null && Object.hasOwnProperty.call(message, "trailing_comments"))
                        writer.uint32(34).string(message.trailing_comments);
                    if (message.leading_detached_comments != null && message.leading_detached_comments.length)
                        for (var i = 0; i < message.leading_detached_comments.length; ++i)
                            writer.uint32(50).string(message.leading_detached_comments[i]);
                    return writer;
                };

                Location.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                Location.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.SourceCodeInfo.Location();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            if (!(message.path && message.path.length))
                                message.path = [];
                            if ((tag & 7) === 2) {
                                var end2 = reader.uint32() + reader.pos;
                                while (reader.pos < end2)
                                    message.path.push(reader.int32());
                            } else
                                message.path.push(reader.int32());
                            break;
                        case 2:
                            if (!(message.span && message.span.length))
                                message.span = [];
                            if ((tag & 7) === 2) {
                                var end2 = reader.uint32() + reader.pos;
                                while (reader.pos < end2)
                                    message.span.push(reader.int32());
                            } else
                                message.span.push(reader.int32());
                            break;
                        case 3:
                            message.leading_comments = reader.string();
                            break;
                        case 4:
                            message.trailing_comments = reader.string();
                            break;
                        case 6:
                            if (!(message.leading_detached_comments && message.leading_detached_comments.length))
                                message.leading_detached_comments = [];
                            message.leading_detached_comments.push(reader.string());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                Location.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                Location.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.path != null && message.hasOwnProperty("path")) {
                        if (!Array.isArray(message.path))
                            return "path: array expected";
                        for (var i = 0; i < message.path.length; ++i)
                            if (!$util.isInteger(message.path[i]))
                                return "path: integer[] expected";
                    }
                    if (message.span != null && message.hasOwnProperty("span")) {
                        if (!Array.isArray(message.span))
                            return "span: array expected";
                        for (var i = 0; i < message.span.length; ++i)
                            if (!$util.isInteger(message.span[i]))
                                return "span: integer[] expected";
                    }
                    if (message.leading_comments != null && message.hasOwnProperty("leading_comments"))
                        if (!$util.isString(message.leading_comments))
                            return "leading_comments: string expected";
                    if (message.trailing_comments != null && message.hasOwnProperty("trailing_comments"))
                        if (!$util.isString(message.trailing_comments))
                            return "trailing_comments: string expected";
                    if (message.leading_detached_comments != null && message.hasOwnProperty("leading_detached_comments")) {
                        if (!Array.isArray(message.leading_detached_comments))
                            return "leading_detached_comments: array expected";
                        for (var i = 0; i < message.leading_detached_comments.length; ++i)
                            if (!$util.isString(message.leading_detached_comments[i]))
                                return "leading_detached_comments: string[] expected";
                    }
                    return null;
                };

                Location.fromObject = function fromObject(object) {
                    if (object instanceof $root.google.protobuf.SourceCodeInfo.Location)
                        return object;
                    var message = new $root.google.protobuf.SourceCodeInfo.Location();
                    if (object.path) {
                        if (!Array.isArray(object.path))
                            throw TypeError(".google.protobuf.SourceCodeInfo.Location.path: array expected");
                        message.path = [];
                        for (var i = 0; i < object.path.length; ++i)
                            message.path[i] = object.path[i] | 0;
                    }
                    if (object.span) {
                        if (!Array.isArray(object.span))
                            throw TypeError(".google.protobuf.SourceCodeInfo.Location.span: array expected");
                        message.span = [];
                        for (var i = 0; i < object.span.length; ++i)
                            message.span[i] = object.span[i] | 0;
                    }
                    if (object.leading_comments != null)
                        message.leading_comments = String(object.leading_comments);
                    if (object.trailing_comments != null)
                        message.trailing_comments = String(object.trailing_comments);
                    if (object.leading_detached_comments) {
                        if (!Array.isArray(object.leading_detached_comments))
                            throw TypeError(".google.protobuf.SourceCodeInfo.Location.leading_detached_comments: array expected");
                        message.leading_detached_comments = [];
                        for (var i = 0; i < object.leading_detached_comments.length; ++i)
                            message.leading_detached_comments[i] = String(object.leading_detached_comments[i]);
                    }
                    return message;
                };

                Location.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults) {
                        object.path = [];
                        object.span = [];
                        object.leading_detached_comments = [];
                    }
                    if (options.defaults) {
                        object.leading_comments = "";
                        object.trailing_comments = "";
                    }
                    if (message.path && message.path.length) {
                        object.path = [];
                        for (var j = 0; j < message.path.length; ++j)
                            object.path[j] = message.path[j];
                    }
                    if (message.span && message.span.length) {
                        object.span = [];
                        for (var j = 0; j < message.span.length; ++j)
                            object.span[j] = message.span[j];
                    }
                    if (message.leading_comments != null && message.hasOwnProperty("leading_comments"))
                        object.leading_comments = message.leading_comments;
                    if (message.trailing_comments != null && message.hasOwnProperty("trailing_comments"))
                        object.trailing_comments = message.trailing_comments;
                    if (message.leading_detached_comments && message.leading_detached_comments.length) {
                        object.leading_detached_comments = [];
                        for (var j = 0; j < message.leading_detached_comments.length; ++j)
                            object.leading_detached_comments[j] = message.leading_detached_comments[j];
                    }
                    return object;
                };

                Location.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return Location;
            })();

            return SourceCodeInfo;
        })();

        protobuf.GeneratedCodeInfo = (function() {

            function GeneratedCodeInfo(properties) {
                this.annotation = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            GeneratedCodeInfo.prototype.annotation = $util.emptyArray;

            GeneratedCodeInfo.create = function create(properties) {
                return new GeneratedCodeInfo(properties);
            };

            GeneratedCodeInfo.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.annotation != null && message.annotation.length)
                    for (var i = 0; i < message.annotation.length; ++i)
                        $root.google.protobuf.GeneratedCodeInfo.Annotation.encode(message.annotation[i], writer.uint32(10).fork()).ldelim();
                return writer;
            };

            GeneratedCodeInfo.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            GeneratedCodeInfo.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.GeneratedCodeInfo();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (!(message.annotation && message.annotation.length))
                            message.annotation = [];
                        message.annotation.push($root.google.protobuf.GeneratedCodeInfo.Annotation.decode(reader, reader.uint32()));
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            GeneratedCodeInfo.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            GeneratedCodeInfo.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.annotation != null && message.hasOwnProperty("annotation")) {
                    if (!Array.isArray(message.annotation))
                        return "annotation: array expected";
                    for (var i = 0; i < message.annotation.length; ++i) {
                        var error = $root.google.protobuf.GeneratedCodeInfo.Annotation.verify(message.annotation[i]);
                        if (error)
                            return "annotation." + error;
                    }
                }
                return null;
            };

            GeneratedCodeInfo.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.GeneratedCodeInfo)
                    return object;
                var message = new $root.google.protobuf.GeneratedCodeInfo();
                if (object.annotation) {
                    if (!Array.isArray(object.annotation))
                        throw TypeError(".google.protobuf.GeneratedCodeInfo.annotation: array expected");
                    message.annotation = [];
                    for (var i = 0; i < object.annotation.length; ++i) {
                        if (typeof object.annotation[i] !== "object")
                            throw TypeError(".google.protobuf.GeneratedCodeInfo.annotation: object expected");
                        message.annotation[i] = $root.google.protobuf.GeneratedCodeInfo.Annotation.fromObject(object.annotation[i]);
                    }
                }
                return message;
            };

            GeneratedCodeInfo.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.annotation = [];
                if (message.annotation && message.annotation.length) {
                    object.annotation = [];
                    for (var j = 0; j < message.annotation.length; ++j)
                        object.annotation[j] = $root.google.protobuf.GeneratedCodeInfo.Annotation.toObject(message.annotation[j], options);
                }
                return object;
            };

            GeneratedCodeInfo.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            GeneratedCodeInfo.Annotation = (function() {

                function Annotation(properties) {
                    this.path = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                Annotation.prototype.path = $util.emptyArray;
                Annotation.prototype.source_file = "";
                Annotation.prototype.begin = 0;
                Annotation.prototype.end = 0;

                Annotation.create = function create(properties) {
                    return new Annotation(properties);
                };

                Annotation.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.path != null && message.path.length) {
                        writer.uint32(10).fork();
                        for (var i = 0; i < message.path.length; ++i)
                            writer.int32(message.path[i]);
                        writer.ldelim();
                    }
                    if (message.source_file != null && Object.hasOwnProperty.call(message, "source_file"))
                        writer.uint32(18).string(message.source_file);
                    if (message.begin != null && Object.hasOwnProperty.call(message, "begin"))
                        writer.uint32(24).int32(message.begin);
                    if (message.end != null && Object.hasOwnProperty.call(message, "end"))
                        writer.uint32(32).int32(message.end);
                    return writer;
                };

                Annotation.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                Annotation.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.GeneratedCodeInfo.Annotation();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            if (!(message.path && message.path.length))
                                message.path = [];
                            if ((tag & 7) === 2) {
                                var end2 = reader.uint32() + reader.pos;
                                while (reader.pos < end2)
                                    message.path.push(reader.int32());
                            } else
                                message.path.push(reader.int32());
                            break;
                        case 2:
                            message.source_file = reader.string();
                            break;
                        case 3:
                            message.begin = reader.int32();
                            break;
                        case 4:
                            message.end = reader.int32();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                Annotation.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                Annotation.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.path != null && message.hasOwnProperty("path")) {
                        if (!Array.isArray(message.path))
                            return "path: array expected";
                        for (var i = 0; i < message.path.length; ++i)
                            if (!$util.isInteger(message.path[i]))
                                return "path: integer[] expected";
                    }
                    if (message.source_file != null && message.hasOwnProperty("source_file"))
                        if (!$util.isString(message.source_file))
                            return "source_file: string expected";
                    if (message.begin != null && message.hasOwnProperty("begin"))
                        if (!$util.isInteger(message.begin))
                            return "begin: integer expected";
                    if (message.end != null && message.hasOwnProperty("end"))
                        if (!$util.isInteger(message.end))
                            return "end: integer expected";
                    return null;
                };

                Annotation.fromObject = function fromObject(object) {
                    if (object instanceof $root.google.protobuf.GeneratedCodeInfo.Annotation)
                        return object;
                    var message = new $root.google.protobuf.GeneratedCodeInfo.Annotation();
                    if (object.path) {
                        if (!Array.isArray(object.path))
                            throw TypeError(".google.protobuf.GeneratedCodeInfo.Annotation.path: array expected");
                        message.path = [];
                        for (var i = 0; i < object.path.length; ++i)
                            message.path[i] = object.path[i] | 0;
                    }
                    if (object.source_file != null)
                        message.source_file = String(object.source_file);
                    if (object.begin != null)
                        message.begin = object.begin | 0;
                    if (object.end != null)
                        message.end = object.end | 0;
                    return message;
                };

                Annotation.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.path = [];
                    if (options.defaults) {
                        object.source_file = "";
                        object.begin = 0;
                        object.end = 0;
                    }
                    if (message.path && message.path.length) {
                        object.path = [];
                        for (var j = 0; j < message.path.length; ++j)
                            object.path[j] = message.path[j];
                    }
                    if (message.source_file != null && message.hasOwnProperty("source_file"))
                        object.source_file = message.source_file;
                    if (message.begin != null && message.hasOwnProperty("begin"))
                        object.begin = message.begin;
                    if (message.end != null && message.hasOwnProperty("end"))
                        object.end = message.end;
                    return object;
                };

                Annotation.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return Annotation;
            })();

            return GeneratedCodeInfo;
        })();

        return protobuf;
    })();

    return google;
})();
return {".AlephiumGetAddress": $root["AlephiumGetAddress"],
".AlephiumAddress": $root["AlephiumAddress"],
".AlephiumSignTx": $root["AlephiumSignTx"],
".AlephiumSignedTx": $root["AlephiumSignedTx"],
".AlephiumTxRequest": $root["AlephiumTxRequest"],
".AlephiumTxAck": $root["AlephiumTxAck"],
".AlephiumBytecodeRequest": $root["AlephiumBytecodeRequest"],
".AlephiumBytecodeAck": $root["AlephiumBytecodeAck"],
".AlephiumSignMessage": $root["AlephiumSignMessage"],
".AlephiumMessageSignature": $root["AlephiumMessageSignature"],
".AlgorandGetAddress": $root["AlgorandGetAddress"],
".AlgorandAddress": $root["AlgorandAddress"],
".AlgorandSignTx": $root["AlgorandSignTx"],
".AlgorandSignedTx": $root["AlgorandSignedTx"],
".AptosGetAddress": $root["AptosGetAddress"],
".AptosAddress": $root["AptosAddress"],
".AptosSignTx": $root["AptosSignTx"],
".AptosSignedTx": $root["AptosSignedTx"],
".AptosSignMessage": $root["AptosSignMessage"],
".AptosSignMessage.AptosMessagePayload": $root["AptosSignMessage"]["AptosMessagePayload"],
".AptosMessageSignature": $root["AptosMessageSignature"],
".AptosSignSIWAMessage": $root["AptosSignSIWAMessage"],
".BenfenGetAddress": $root["BenfenGetAddress"],
".BenfenAddress": $root["BenfenAddress"],
".BenfenSignTx": $root["BenfenSignTx"],
".BenfenSignedTx": $root["BenfenSignedTx"],
".BenfenTxRequest": $root["BenfenTxRequest"],
".BenfenTxAck": $root["BenfenTxAck"],
".BenfenSignMessage": $root["BenfenSignMessage"],
".BenfenMessageSignature": $root["BenfenMessageSignature"],
".BinanceGetAddress": $root["BinanceGetAddress"],
".BinanceAddress": $root["BinanceAddress"],
".BinanceGetPublicKey": $root["BinanceGetPublicKey"],
".BinancePublicKey": $root["BinancePublicKey"],
".BinanceSignTx": $root["BinanceSignTx"],
".BinanceTxRequest": $root["BinanceTxRequest"],
".BinanceTransferMsg": $root["BinanceTransferMsg"],
".BinanceTransferMsg.BinanceInputOutput": $root["BinanceTransferMsg"]["BinanceInputOutput"],
".BinanceTransferMsg.BinanceCoin": $root["BinanceTransferMsg"]["BinanceCoin"],
".BinanceOrderMsg": $root["BinanceOrderMsg"],
".BinanceCancelMsg": $root["BinanceCancelMsg"],
".BinanceSignedTx": $root["BinanceSignedTx"],
".MultisigRedeemScriptType": $root["MultisigRedeemScriptType"],
".MultisigRedeemScriptType.HDNodePathType": $root["MultisigRedeemScriptType"]["HDNodePathType"],
".GetPublicKey": $root["GetPublicKey"],
".PublicKey": $root["PublicKey"],
".GetAddress": $root["GetAddress"],
".Address": $root["Address"],
".GetOwnershipId": $root["GetOwnershipId"],
".OwnershipId": $root["OwnershipId"],
".SignMessage": $root["SignMessage"],
".MessageSignature": $root["MessageSignature"],
".VerifyMessage": $root["VerifyMessage"],
".SignTx": $root["SignTx"],
".TxRequest": $root["TxRequest"],
".TxRequest.TxRequestDetailsType": $root["TxRequest"]["TxRequestDetailsType"],
".TxRequest.TxRequestSerializedType": $root["TxRequest"]["TxRequestSerializedType"],
".TxAck": $root["TxAck"],
".TxAck.TransactionType": $root["TxAck"]["TransactionType"],
".TxAck.TransactionType.TxInputType": $root["TxAck"]["TransactionType"]["TxInputType"],
".TxAck.TransactionType.TxOutputBinType": $root["TxAck"]["TransactionType"]["TxOutputBinType"],
".TxAck.TransactionType.TxOutputType": $root["TxAck"]["TransactionType"]["TxOutputType"],
".TxInput": $root["TxInput"],
".TxOutput": $root["TxOutput"],
".PrevTx": $root["PrevTx"],
".PrevInput": $root["PrevInput"],
".PrevOutput": $root["PrevOutput"],
".TxAckInput": $root["TxAckInput"],
".TxAckInput.TxAckInputWrapper": $root["TxAckInput"]["TxAckInputWrapper"],
".TxAckOutput": $root["TxAckOutput"],
".TxAckOutput.TxAckOutputWrapper": $root["TxAckOutput"]["TxAckOutputWrapper"],
".TxAckPrevMeta": $root["TxAckPrevMeta"],
".TxAckPrevInput": $root["TxAckPrevInput"],
".TxAckPrevInput.TxAckPrevInputWrapper": $root["TxAckPrevInput"]["TxAckPrevInputWrapper"],
".TxAckPrevOutput": $root["TxAckPrevOutput"],
".TxAckPrevOutput.TxAckPrevOutputWrapper": $root["TxAckPrevOutput"]["TxAckPrevOutputWrapper"],
".TxAckPrevExtraData": $root["TxAckPrevExtraData"],
".TxAckPrevExtraData.TxAckPrevExtraDataWrapper": $root["TxAckPrevExtraData"]["TxAckPrevExtraDataWrapper"],
".GetOwnershipProof": $root["GetOwnershipProof"],
".OwnershipProof": $root["OwnershipProof"],
".AuthorizeCoinJoin": $root["AuthorizeCoinJoin"],
".GetPublicKeyMultiple": $root["GetPublicKeyMultiple"],
".GetPublicKeyMultiple.BIP32Address": $root["GetPublicKeyMultiple"]["BIP32Address"],
".PublicKeyMultiple": $root["PublicKeyMultiple"],
".SignPsbt": $root["SignPsbt"],
".SignedPsbt": $root["SignedPsbt"],
".FirmwareErase": $root["FirmwareErase"],
".FirmwareRequest": $root["FirmwareRequest"],
".FirmwareUpload": $root["FirmwareUpload"],
".SelfTest": $root["SelfTest"],
".FirmwareErase_ex": $root["FirmwareErase_ex"],
".Reboot": $root["Reboot"],
".FirmwareUpdateEmmc": $root["FirmwareUpdateEmmc"],
".UpgradeFileHeader": $root["UpgradeFileHeader"],
".CardanoBlockchainPointerType": $root["CardanoBlockchainPointerType"],
".CardanoNativeScript": $root["CardanoNativeScript"],
".CardanoGetNativeScriptHash": $root["CardanoGetNativeScriptHash"],
".CardanoNativeScriptHash": $root["CardanoNativeScriptHash"],
".CardanoAddressParametersType": $root["CardanoAddressParametersType"],
".CardanoGetAddress": $root["CardanoGetAddress"],
".CardanoAddress": $root["CardanoAddress"],
".CardanoGetPublicKey": $root["CardanoGetPublicKey"],
".CardanoPublicKey": $root["CardanoPublicKey"],
".CardanoSignTxInit": $root["CardanoSignTxInit"],
".CardanoTxInput": $root["CardanoTxInput"],
".CardanoTxOutput": $root["CardanoTxOutput"],
".CardanoAssetGroup": $root["CardanoAssetGroup"],
".CardanoToken": $root["CardanoToken"],
".CardanoTxInlineDatumChunk": $root["CardanoTxInlineDatumChunk"],
".CardanoTxReferenceScriptChunk": $root["CardanoTxReferenceScriptChunk"],
".CardanoPoolOwner": $root["CardanoPoolOwner"],
".CardanoPoolRelayParameters": $root["CardanoPoolRelayParameters"],
".CardanoPoolMetadataType": $root["CardanoPoolMetadataType"],
".CardanoPoolParametersType": $root["CardanoPoolParametersType"],
".CardanoDRep": $root["CardanoDRep"],
".CardanoTxCertificate": $root["CardanoTxCertificate"],
".CardanoTxWithdrawal": $root["CardanoTxWithdrawal"],
".CardanoCVoteRegistrationDelegation": $root["CardanoCVoteRegistrationDelegation"],
".CardanoCVoteRegistrationParametersType": $root["CardanoCVoteRegistrationParametersType"],
".CardanoTxAuxiliaryData": $root["CardanoTxAuxiliaryData"],
".CardanoTxMint": $root["CardanoTxMint"],
".CardanoTxCollateralInput": $root["CardanoTxCollateralInput"],
".CardanoTxRequiredSigner": $root["CardanoTxRequiredSigner"],
".CardanoTxReferenceInput": $root["CardanoTxReferenceInput"],
".CardanoTxItemAck": $root["CardanoTxItemAck"],
".CardanoTxAuxiliaryDataSupplement": $root["CardanoTxAuxiliaryDataSupplement"],
".CardanoTxWitnessRequest": $root["CardanoTxWitnessRequest"],
".CardanoTxWitnessResponse": $root["CardanoTxWitnessResponse"],
".CardanoTxHostAck": $root["CardanoTxHostAck"],
".CardanoTxBodyHash": $root["CardanoTxBodyHash"],
".CardanoSignTxFinished": $root["CardanoSignTxFinished"],
".CardanoSignMessage": $root["CardanoSignMessage"],
".CardanoMessageSignature": $root["CardanoMessageSignature"],
".Success": $root["Success"],
".Failure": $root["Failure"],
".ButtonRequest": $root["ButtonRequest"],
".ButtonAck": $root["ButtonAck"],
".PinMatrixRequest": $root["PinMatrixRequest"],
".PinMatrixAck": $root["PinMatrixAck"],
".PassphraseRequest": $root["PassphraseRequest"],
".PassphraseAck": $root["PassphraseAck"],
".Deprecated_PassphraseStateRequest": $root["Deprecated_PassphraseStateRequest"],
".Deprecated_PassphraseStateAck": $root["Deprecated_PassphraseStateAck"],
".HDNodeType": $root["HDNodeType"],
".BixinPinInputOnDevice": $root["BixinPinInputOnDevice"],
".ConfluxGetAddress": $root["ConfluxGetAddress"],
".ConfluxAddress": $root["ConfluxAddress"],
".ConfluxSignTx": $root["ConfluxSignTx"],
".ConfluxTxRequest": $root["ConfluxTxRequest"],
".ConfluxTxAck": $root["ConfluxTxAck"],
".ConfluxSignMessage": $root["ConfluxSignMessage"],
".ConfluxMessageSignature": $root["ConfluxMessageSignature"],
".ConfluxSignMessageCIP23": $root["ConfluxSignMessageCIP23"],
".CosmosGetAddress": $root["CosmosGetAddress"],
".CosmosAddress": $root["CosmosAddress"],
".CosmosSignTx": $root["CosmosSignTx"],
".CosmosSignedTx": $root["CosmosSignedTx"],
".CipherKeyValue": $root["CipherKeyValue"],
".CipheredKeyValue": $root["CipheredKeyValue"],
".IdentityType": $root["IdentityType"],
".SignIdentity": $root["SignIdentity"],
".SignedIdentity": $root["SignedIdentity"],
".GetECDHSessionKey": $root["GetECDHSessionKey"],
".ECDHSessionKey": $root["ECDHSessionKey"],
".CosiCommit": $root["CosiCommit"],
".CosiCommitment": $root["CosiCommitment"],
".CosiSign": $root["CosiSign"],
".CosiSignature": $root["CosiSignature"],
".BatchGetPublickeys": $root["BatchGetPublickeys"],
".BatchGetPublickeys.Path": $root["BatchGetPublickeys"]["Path"],
".EcdsaPublicKeys": $root["EcdsaPublicKeys"],
".DebugLinkDecision": $root["DebugLinkDecision"],
".DebugLinkLayout": $root["DebugLinkLayout"],
".DebugLinkReseedRandom": $root["DebugLinkReseedRandom"],
".DebugLinkRecordScreen": $root["DebugLinkRecordScreen"],
".DebugLinkGetState": $root["DebugLinkGetState"],
".DebugLinkState": $root["DebugLinkState"],
".DebugLinkStop": $root["DebugLinkStop"],
".DebugLinkLog": $root["DebugLinkLog"],
".DebugLinkMemoryRead": $root["DebugLinkMemoryRead"],
".DebugLinkMemory": $root["DebugLinkMemory"],
".DebugLinkMemoryWrite": $root["DebugLinkMemoryWrite"],
".DebugLinkFlashErase": $root["DebugLinkFlashErase"],
".DebugLinkEraseSdCard": $root["DebugLinkEraseSdCard"],
".DebugLinkWatchLayout": $root["DebugLinkWatchLayout"],
".DnxGetAddress": $root["DnxGetAddress"],
".DnxAddress": $root["DnxAddress"],
".DnxSignTx": $root["DnxSignTx"],
".DnxInputRequest": $root["DnxInputRequest"],
".DnxInputRequest.DnxTxKey": $root["DnxInputRequest"]["DnxTxKey"],
".DnxInputRequest.DnxComputedKeyImage": $root["DnxInputRequest"]["DnxComputedKeyImage"],
".DnxInputAck": $root["DnxInputAck"],
".DnxRTSigsRequest": $root["DnxRTSigsRequest"],
".DnxSignedTx": $root["DnxSignedTx"],
".EmmcFixPermission": $root["EmmcFixPermission"],
".EmmcPath": $root["EmmcPath"],
".EmmcPathInfo": $root["EmmcPathInfo"],
".EmmcFile": $root["EmmcFile"],
".EmmcFileRead": $root["EmmcFileRead"],
".EmmcFileWrite": $root["EmmcFileWrite"],
".EmmcFileDelete": $root["EmmcFileDelete"],
".EmmcDir": $root["EmmcDir"],
".EmmcDirList": $root["EmmcDirList"],
".EmmcDirMake": $root["EmmcDirMake"],
".EmmcDirRemove": $root["EmmcDirRemove"],
".EosGetPublicKey": $root["EosGetPublicKey"],
".EosPublicKey": $root["EosPublicKey"],
".EosSignTx": $root["EosSignTx"],
".EosSignTx.EosTxHeader": $root["EosSignTx"]["EosTxHeader"],
".EosTxActionRequest": $root["EosTxActionRequest"],
".EosTxActionAck": $root["EosTxActionAck"],
".EosTxActionAck.EosAsset": $root["EosTxActionAck"]["EosAsset"],
".EosTxActionAck.EosPermissionLevel": $root["EosTxActionAck"]["EosPermissionLevel"],
".EosTxActionAck.EosAuthorizationKey": $root["EosTxActionAck"]["EosAuthorizationKey"],
".EosTxActionAck.EosAuthorizationAccount": $root["EosTxActionAck"]["EosAuthorizationAccount"],
".EosTxActionAck.EosAuthorizationWait": $root["EosTxActionAck"]["EosAuthorizationWait"],
".EosTxActionAck.EosAuthorization": $root["EosTxActionAck"]["EosAuthorization"],
".EosTxActionAck.EosActionCommon": $root["EosTxActionAck"]["EosActionCommon"],
".EosTxActionAck.EosActionTransfer": $root["EosTxActionAck"]["EosActionTransfer"],
".EosTxActionAck.EosActionDelegate": $root["EosTxActionAck"]["EosActionDelegate"],
".EosTxActionAck.EosActionUndelegate": $root["EosTxActionAck"]["EosActionUndelegate"],
".EosTxActionAck.EosActionRefund": $root["EosTxActionAck"]["EosActionRefund"],
".EosTxActionAck.EosActionBuyRam": $root["EosTxActionAck"]["EosActionBuyRam"],
".EosTxActionAck.EosActionBuyRamBytes": $root["EosTxActionAck"]["EosActionBuyRamBytes"],
".EosTxActionAck.EosActionSellRam": $root["EosTxActionAck"]["EosActionSellRam"],
".EosTxActionAck.EosActionVoteProducer": $root["EosTxActionAck"]["EosActionVoteProducer"],
".EosTxActionAck.EosActionUpdateAuth": $root["EosTxActionAck"]["EosActionUpdateAuth"],
".EosTxActionAck.EosActionDeleteAuth": $root["EosTxActionAck"]["EosActionDeleteAuth"],
".EosTxActionAck.EosActionLinkAuth": $root["EosTxActionAck"]["EosActionLinkAuth"],
".EosTxActionAck.EosActionUnlinkAuth": $root["EosTxActionAck"]["EosActionUnlinkAuth"],
".EosTxActionAck.EosActionNewAccount": $root["EosTxActionAck"]["EosActionNewAccount"],
".EosTxActionAck.EosActionUnknown": $root["EosTxActionAck"]["EosActionUnknown"],
".EosSignedTx": $root["EosSignedTx"],
".EthereumNetworkInfo": $root["EthereumNetworkInfo"],
".EthereumTokenInfo": $root["EthereumTokenInfo"],
".EthereumDefinitions": $root["EthereumDefinitions"],
".EthereumSignTypedDataOneKey": $root["EthereumSignTypedDataOneKey"],
".EthereumGnosisSafeTxRequest": $root["EthereumGnosisSafeTxRequest"],
".EthereumGnosisSafeTxAck": $root["EthereumGnosisSafeTxAck"],
".EthereumTypedDataStructRequestOneKey": $root["EthereumTypedDataStructRequestOneKey"],
".EthereumTypedDataStructAckOneKey": $root["EthereumTypedDataStructAckOneKey"],
".EthereumTypedDataStructAckOneKey.EthereumStructMemberOneKey": $root["EthereumTypedDataStructAckOneKey"]["EthereumStructMemberOneKey"],
".EthereumTypedDataStructAckOneKey.EthereumFieldTypeOneKey": $root["EthereumTypedDataStructAckOneKey"]["EthereumFieldTypeOneKey"],
".EthereumTypedDataValueRequestOneKey": $root["EthereumTypedDataValueRequestOneKey"],
".EthereumTypedDataValueAckOneKey": $root["EthereumTypedDataValueAckOneKey"],
".EthereumSignTypedData": $root["EthereumSignTypedData"],
".EthereumTypedDataStructRequest": $root["EthereumTypedDataStructRequest"],
".EthereumTypedDataStructAck": $root["EthereumTypedDataStructAck"],
".EthereumTypedDataStructAck.EthereumStructMember": $root["EthereumTypedDataStructAck"]["EthereumStructMember"],
".EthereumTypedDataStructAck.EthereumFieldType": $root["EthereumTypedDataStructAck"]["EthereumFieldType"],
".EthereumTypedDataValueRequest": $root["EthereumTypedDataValueRequest"],
".EthereumTypedDataValueAck": $root["EthereumTypedDataValueAck"],
".EthereumGetPublicKeyOneKey": $root["EthereumGetPublicKeyOneKey"],
".EthereumPublicKeyOneKey": $root["EthereumPublicKeyOneKey"],
".EthereumGetAddressOneKey": $root["EthereumGetAddressOneKey"],
".EthereumAddressOneKey": $root["EthereumAddressOneKey"],
".EthereumSignTxOneKey": $root["EthereumSignTxOneKey"],
".EthereumAccessListOneKey": $root["EthereumAccessListOneKey"],
".EthereumSignTxEIP1559OneKey": $root["EthereumSignTxEIP1559OneKey"],
".EthereumAuthorizationSignature": $root["EthereumAuthorizationSignature"],
".EthereumSignTxEIP7702OneKey": $root["EthereumSignTxEIP7702OneKey"],
".EthereumSignTxEIP7702OneKey.EthereumAuthorizationOneKey": $root["EthereumSignTxEIP7702OneKey"]["EthereumAuthorizationOneKey"],
".EthereumTxRequestOneKey": $root["EthereumTxRequestOneKey"],
".EthereumTxAckOneKey": $root["EthereumTxAckOneKey"],
".EthereumSignMessageOneKey": $root["EthereumSignMessageOneKey"],
".EthereumMessageSignatureOneKey": $root["EthereumMessageSignatureOneKey"],
".EthereumVerifyMessageOneKey": $root["EthereumVerifyMessageOneKey"],
".EthereumSignTypedHashOneKey": $root["EthereumSignTypedHashOneKey"],
".EthereumTypedDataSignatureOneKey": $root["EthereumTypedDataSignatureOneKey"],
".EthereumSignMessageEIP712": $root["EthereumSignMessageEIP712"],
".EthereumGetPublicKey": $root["EthereumGetPublicKey"],
".EthereumPublicKey": $root["EthereumPublicKey"],
".EthereumGetAddress": $root["EthereumGetAddress"],
".EthereumAddress": $root["EthereumAddress"],
".EthereumSignTx": $root["EthereumSignTx"],
".EthereumSignTxEIP1559": $root["EthereumSignTxEIP1559"],
".EthereumSignTxEIP1559.EthereumAccessList": $root["EthereumSignTxEIP1559"]["EthereumAccessList"],
".EthereumTxRequest": $root["EthereumTxRequest"],
".EthereumTxAck": $root["EthereumTxAck"],
".EthereumSignMessage": $root["EthereumSignMessage"],
".EthereumMessageSignature": $root["EthereumMessageSignature"],
".EthereumVerifyMessage": $root["EthereumVerifyMessage"],
".EthereumSignTypedHash": $root["EthereumSignTypedHash"],
".EthereumTypedDataSignature": $root["EthereumTypedDataSignature"],
".FilecoinGetAddress": $root["FilecoinGetAddress"],
".FilecoinAddress": $root["FilecoinAddress"],
".FilecoinSignTx": $root["FilecoinSignTx"],
".FilecoinSignedTx": $root["FilecoinSignedTx"],
".KaspaGetAddress": $root["KaspaGetAddress"],
".KaspaAddress": $root["KaspaAddress"],
".KaspaSignTx": $root["KaspaSignTx"],
".KaspaTxInputRequest": $root["KaspaTxInputRequest"],
".KaspaTxInputAck": $root["KaspaTxInputAck"],
".KaspaOutpoint": $root["KaspaOutpoint"],
".KaspaTxRequestSignature": $root["KaspaTxRequestSignature"],
".KaspaTxRequest": $root["KaspaTxRequest"],
".KaspaTxAckInput": $root["KaspaTxAckInput"],
".KaspaTxAckOutput": $root["KaspaTxAckOutput"],
".KaspaTxAckPayloadChunk": $root["KaspaTxAckPayloadChunk"],
".KaspaTxAckPrevMeta": $root["KaspaTxAckPrevMeta"],
".KaspaTxAckPrevInput": $root["KaspaTxAckPrevInput"],
".KaspaTxAckPrevOutput": $root["KaspaTxAckPrevOutput"],
".KaspaSignedTx": $root["KaspaSignedTx"],
".LnurlAuth": $root["LnurlAuth"],
".LnurlAuthResp": $root["LnurlAuthResp"],
".Initialize": $root["Initialize"],
".GetFeatures": $root["GetFeatures"],
".OnekeyGetFeatures": $root["OnekeyGetFeatures"],
".Features": $root["Features"],
".OnekeyFeatures": $root["OnekeyFeatures"],
".LockDevice": $root["LockDevice"],
".EndSession": $root["EndSession"],
".ApplySettings": $root["ApplySettings"],
".ApplyFlags": $root["ApplyFlags"],
".ChangePin": $root["ChangePin"],
".ChangeWipeCode": $root["ChangeWipeCode"],
".SdProtect": $root["SdProtect"],
".Ping": $root["Ping"],
".Cancel": $root["Cancel"],
".GetEntropy": $root["GetEntropy"],
".Entropy": $root["Entropy"],
".WipeDevice": $root["WipeDevice"],
".LoadDevice": $root["LoadDevice"],
".ResetDevice": $root["ResetDevice"],
".BackupDevice": $root["BackupDevice"],
".EntropyRequest": $root["EntropyRequest"],
".EntropyAck": $root["EntropyAck"],
".RecoveryDevice": $root["RecoveryDevice"],
".WordRequest": $root["WordRequest"],
".WordAck": $root["WordAck"],
".SetU2FCounter": $root["SetU2FCounter"],
".GetNextU2FCounter": $root["GetNextU2FCounter"],
".NextU2FCounter": $root["NextU2FCounter"],
".DoPreauthorized": $root["DoPreauthorized"],
".PreauthorizedRequest": $root["PreauthorizedRequest"],
".CancelAuthorization": $root["CancelAuthorization"],
".BixinSeedOperate": $root["BixinSeedOperate"],
".BixinMessageSE": $root["BixinMessageSE"],
".BixinOutMessageSE": $root["BixinOutMessageSE"],
".DeviceBackToBoot": $root["DeviceBackToBoot"],
".BixinBackupRequest": $root["BixinBackupRequest"],
".BixinBackupAck": $root["BixinBackupAck"],
".BixinRestoreRequest": $root["BixinRestoreRequest"],
".BixinRestoreAck": $root["BixinRestoreAck"],
".BixinVerifyDeviceRequest": $root["BixinVerifyDeviceRequest"],
".BixinVerifyDeviceAck": $root["BixinVerifyDeviceAck"],
".BixinWhiteListRequest": $root["BixinWhiteListRequest"],
".BixinWhiteListAck": $root["BixinWhiteListAck"],
".BixinLoadDevice": $root["BixinLoadDevice"],
".BixinBackupDevice": $root["BixinBackupDevice"],
".BixinBackupDeviceAck": $root["BixinBackupDeviceAck"],
".DeviceInfoSettings": $root["DeviceInfoSettings"],
".GetDeviceInfo": $root["GetDeviceInfo"],
".DeviceInfo": $root["DeviceInfo"],
".ReadSEPublicKey": $root["ReadSEPublicKey"],
".SEPublicKey": $root["SEPublicKey"],
".WriteSEPublicCert": $root["WriteSEPublicCert"],
".ReadSEPublicCert": $root["ReadSEPublicCert"],
".SEPublicCert": $root["SEPublicCert"],
".SpiFlashWrite": $root["SpiFlashWrite"],
".SpiFlashRead": $root["SpiFlashRead"],
".SpiFlashData": $root["SpiFlashData"],
".SESignMessage": $root["SESignMessage"],
".SEMessageSignature": $root["SEMessageSignature"],
".ResourceUpload": $root["ResourceUpload"],
".ZoomRequest": $root["ZoomRequest"],
".BlurRequest": $root["BlurRequest"],
".ResourceRequest": $root["ResourceRequest"],
".ResourceAck": $root["ResourceAck"],
".ResourceUpdate": $root["ResourceUpdate"],
".NFTWriteInfo": $root["NFTWriteInfo"],
".NFTWriteData": $root["NFTWriteData"],
".RebootToBootloader": $root["RebootToBootloader"],
".RebootToBoardloader": $root["RebootToBoardloader"],
".ListResDir": $root["ListResDir"],
".FileInfoList": $root["FileInfoList"],
".FileInfoList.FileInfo": $root["FileInfoList"]["FileInfo"],
".DeviceEraseSector": $root["DeviceEraseSector"],
".UnLockDevice": $root["UnLockDevice"],
".UnLockDeviceResponse": $root["UnLockDeviceResponse"],
".GetPassphraseState": $root["GetPassphraseState"],
".PassphraseState": $root["PassphraseState"],
".MoneroTransactionSourceEntry": $root["MoneroTransactionSourceEntry"],
".MoneroTransactionSourceEntry.MoneroOutputEntry": $root["MoneroTransactionSourceEntry"]["MoneroOutputEntry"],
".MoneroTransactionSourceEntry.MoneroOutputEntry.MoneroRctKeyPublic": $root["MoneroTransactionSourceEntry"]["MoneroOutputEntry"]["MoneroRctKeyPublic"],
".MoneroTransactionSourceEntry.MoneroMultisigKLRki": $root["MoneroTransactionSourceEntry"]["MoneroMultisigKLRki"],
".MoneroTransactionDestinationEntry": $root["MoneroTransactionDestinationEntry"],
".MoneroTransactionDestinationEntry.MoneroAccountPublicAddress": $root["MoneroTransactionDestinationEntry"]["MoneroAccountPublicAddress"],
".MoneroTransactionRsigData": $root["MoneroTransactionRsigData"],
".MoneroGetAddress": $root["MoneroGetAddress"],
".MoneroAddress": $root["MoneroAddress"],
".MoneroGetWatchKey": $root["MoneroGetWatchKey"],
".MoneroWatchKey": $root["MoneroWatchKey"],
".MoneroTransactionInitRequest": $root["MoneroTransactionInitRequest"],
".MoneroTransactionInitRequest.MoneroTransactionData": $root["MoneroTransactionInitRequest"]["MoneroTransactionData"],
".MoneroTransactionInitAck": $root["MoneroTransactionInitAck"],
".MoneroTransactionSetInputRequest": $root["MoneroTransactionSetInputRequest"],
".MoneroTransactionSetInputAck": $root["MoneroTransactionSetInputAck"],
".MoneroTransactionInputsPermutationRequest": $root["MoneroTransactionInputsPermutationRequest"],
".MoneroTransactionInputsPermutationAck": $root["MoneroTransactionInputsPermutationAck"],
".MoneroTransactionInputViniRequest": $root["MoneroTransactionInputViniRequest"],
".MoneroTransactionInputViniAck": $root["MoneroTransactionInputViniAck"],
".MoneroTransactionAllInputsSetRequest": $root["MoneroTransactionAllInputsSetRequest"],
".MoneroTransactionAllInputsSetAck": $root["MoneroTransactionAllInputsSetAck"],
".MoneroTransactionSetOutputRequest": $root["MoneroTransactionSetOutputRequest"],
".MoneroTransactionSetOutputAck": $root["MoneroTransactionSetOutputAck"],
".MoneroTransactionAllOutSetRequest": $root["MoneroTransactionAllOutSetRequest"],
".MoneroTransactionAllOutSetAck": $root["MoneroTransactionAllOutSetAck"],
".MoneroTransactionAllOutSetAck.MoneroRingCtSig": $root["MoneroTransactionAllOutSetAck"]["MoneroRingCtSig"],
".MoneroTransactionSignInputRequest": $root["MoneroTransactionSignInputRequest"],
".MoneroTransactionSignInputAck": $root["MoneroTransactionSignInputAck"],
".MoneroTransactionFinalRequest": $root["MoneroTransactionFinalRequest"],
".MoneroTransactionFinalAck": $root["MoneroTransactionFinalAck"],
".MoneroKeyImageExportInitRequest": $root["MoneroKeyImageExportInitRequest"],
".MoneroKeyImageExportInitRequest.MoneroSubAddressIndicesList": $root["MoneroKeyImageExportInitRequest"]["MoneroSubAddressIndicesList"],
".MoneroKeyImageExportInitAck": $root["MoneroKeyImageExportInitAck"],
".MoneroKeyImageSyncStepRequest": $root["MoneroKeyImageSyncStepRequest"],
".MoneroKeyImageSyncStepRequest.MoneroTransferDetails": $root["MoneroKeyImageSyncStepRequest"]["MoneroTransferDetails"],
".MoneroKeyImageSyncStepAck": $root["MoneroKeyImageSyncStepAck"],
".MoneroKeyImageSyncStepAck.MoneroExportedKeyImage": $root["MoneroKeyImageSyncStepAck"]["MoneroExportedKeyImage"],
".MoneroKeyImageSyncFinalRequest": $root["MoneroKeyImageSyncFinalRequest"],
".MoneroKeyImageSyncFinalAck": $root["MoneroKeyImageSyncFinalAck"],
".MoneroGetTxKeyRequest": $root["MoneroGetTxKeyRequest"],
".MoneroGetTxKeyAck": $root["MoneroGetTxKeyAck"],
".MoneroLiveRefreshStartRequest": $root["MoneroLiveRefreshStartRequest"],
".MoneroLiveRefreshStartAck": $root["MoneroLiveRefreshStartAck"],
".MoneroLiveRefreshStepRequest": $root["MoneroLiveRefreshStepRequest"],
".MoneroLiveRefreshStepAck": $root["MoneroLiveRefreshStepAck"],
".MoneroLiveRefreshFinalRequest": $root["MoneroLiveRefreshFinalRequest"],
".MoneroLiveRefreshFinalAck": $root["MoneroLiveRefreshFinalAck"],
".DebugMoneroDiagRequest": $root["DebugMoneroDiagRequest"],
".DebugMoneroDiagAck": $root["DebugMoneroDiagAck"],
".NearGetAddress": $root["NearGetAddress"],
".NearAddress": $root["NearAddress"],
".NearSignTx": $root["NearSignTx"],
".NearSignedTx": $root["NearSignedTx"],
".NEMGetAddress": $root["NEMGetAddress"],
".NEMAddress": $root["NEMAddress"],
".NEMSignTx": $root["NEMSignTx"],
".NEMSignTx.NEMTransactionCommon": $root["NEMSignTx"]["NEMTransactionCommon"],
".NEMSignTx.NEMTransfer": $root["NEMSignTx"]["NEMTransfer"],
".NEMSignTx.NEMTransfer.NEMMosaic": $root["NEMSignTx"]["NEMTransfer"]["NEMMosaic"],
".NEMSignTx.NEMProvisionNamespace": $root["NEMSignTx"]["NEMProvisionNamespace"],
".NEMSignTx.NEMMosaicCreation": $root["NEMSignTx"]["NEMMosaicCreation"],
".NEMSignTx.NEMMosaicCreation.NEMMosaicDefinition": $root["NEMSignTx"]["NEMMosaicCreation"]["NEMMosaicDefinition"],
".NEMSignTx.NEMMosaicSupplyChange": $root["NEMSignTx"]["NEMMosaicSupplyChange"],
".NEMSignTx.NEMAggregateModification": $root["NEMSignTx"]["NEMAggregateModification"],
".NEMSignTx.NEMAggregateModification.NEMCosignatoryModification": $root["NEMSignTx"]["NEMAggregateModification"]["NEMCosignatoryModification"],
".NEMSignTx.NEMImportanceTransfer": $root["NEMSignTx"]["NEMImportanceTransfer"],
".NEMSignedTx": $root["NEMSignedTx"],
".NEMDecryptMessage": $root["NEMDecryptMessage"],
".NEMDecryptedMessage": $root["NEMDecryptedMessage"],
".NeoGetAddress": $root["NeoGetAddress"],
".NeoAddress": $root["NeoAddress"],
".NeoSignTx": $root["NeoSignTx"],
".NeoSignedTx": $root["NeoSignedTx"],
".NervosGetAddress": $root["NervosGetAddress"],
".NervosAddress": $root["NervosAddress"],
".NervosSignTx": $root["NervosSignTx"],
".NervosSignedTx": $root["NervosSignedTx"],
".NervosTxRequest": $root["NervosTxRequest"],
".NervosTxAck": $root["NervosTxAck"],
".NexaGetAddress": $root["NexaGetAddress"],
".NexaAddress": $root["NexaAddress"],
".NexaSignTx": $root["NexaSignTx"],
".NexaTxInputRequest": $root["NexaTxInputRequest"],
".NexaTxInputAck": $root["NexaTxInputAck"],
".NexaSignedTx": $root["NexaSignedTx"],
".NostrGetPublicKey": $root["NostrGetPublicKey"],
".NostrPublicKey": $root["NostrPublicKey"],
".NostrSignEvent": $root["NostrSignEvent"],
".NostrSignedEvent": $root["NostrSignedEvent"],
".NostrSignSchnorr": $root["NostrSignSchnorr"],
".NostrSignedSchnorr": $root["NostrSignedSchnorr"],
".NostrEncryptMessage": $root["NostrEncryptMessage"],
".NostrEncryptedMessage": $root["NostrEncryptedMessage"],
".NostrDecryptMessage": $root["NostrDecryptMessage"],
".NostrDecryptedMessage": $root["NostrDecryptedMessage"],
".PolkadotGetAddress": $root["PolkadotGetAddress"],
".PolkadotAddress": $root["PolkadotAddress"],
".PolkadotSignTx": $root["PolkadotSignTx"],
".PolkadotSignedTx": $root["PolkadotSignedTx"],
".RippleGetAddress": $root["RippleGetAddress"],
".RippleAddress": $root["RippleAddress"],
".RippleSignTx": $root["RippleSignTx"],
".RippleSignTx.RipplePayment": $root["RippleSignTx"]["RipplePayment"],
".RippleSignedTx": $root["RippleSignedTx"],
".ScdoGetAddress": $root["ScdoGetAddress"],
".ScdoAddress": $root["ScdoAddress"],
".ScdoSignTx": $root["ScdoSignTx"],
".ScdoSignedTx": $root["ScdoSignedTx"],
".ScdoTxAck": $root["ScdoTxAck"],
".ScdoSignMessage": $root["ScdoSignMessage"],
".ScdoSignedMessage": $root["ScdoSignedMessage"],
".SolanaGetAddress": $root["SolanaGetAddress"],
".SolanaAddress": $root["SolanaAddress"],
".SolanaTxATADetails": $root["SolanaTxATADetails"],
".SolanaTxExtraInfo": $root["SolanaTxExtraInfo"],
".SolanaSignTx": $root["SolanaSignTx"],
".SolanaSignedTx": $root["SolanaSignedTx"],
".SolanaSignOffChainMessage": $root["SolanaSignOffChainMessage"],
".SolanaSignUnsafeMessage": $root["SolanaSignUnsafeMessage"],
".SolanaMessageSignature": $root["SolanaMessageSignature"],
".StarcoinGetAddress": $root["StarcoinGetAddress"],
".StarcoinAddress": $root["StarcoinAddress"],
".StarcoinGetPublicKey": $root["StarcoinGetPublicKey"],
".StarcoinPublicKey": $root["StarcoinPublicKey"],
".StarcoinSignTx": $root["StarcoinSignTx"],
".StarcoinSignedTx": $root["StarcoinSignedTx"],
".StarcoinSignMessage": $root["StarcoinSignMessage"],
".StarcoinMessageSignature": $root["StarcoinMessageSignature"],
".StarcoinVerifyMessage": $root["StarcoinVerifyMessage"],
".StellarAsset": $root["StellarAsset"],
".StellarGetAddress": $root["StellarGetAddress"],
".StellarAddress": $root["StellarAddress"],
".StellarSignTx": $root["StellarSignTx"],
".StellarTxOpRequest": $root["StellarTxOpRequest"],
".StellarPaymentOp": $root["StellarPaymentOp"],
".StellarCreateAccountOp": $root["StellarCreateAccountOp"],
".StellarPathPaymentStrictReceiveOp": $root["StellarPathPaymentStrictReceiveOp"],
".StellarPathPaymentStrictSendOp": $root["StellarPathPaymentStrictSendOp"],
".StellarManageSellOfferOp": $root["StellarManageSellOfferOp"],
".StellarManageBuyOfferOp": $root["StellarManageBuyOfferOp"],
".StellarCreatePassiveSellOfferOp": $root["StellarCreatePassiveSellOfferOp"],
".StellarSetOptionsOp": $root["StellarSetOptionsOp"],
".StellarChangeTrustOp": $root["StellarChangeTrustOp"],
".StellarAllowTrustOp": $root["StellarAllowTrustOp"],
".StellarAccountMergeOp": $root["StellarAccountMergeOp"],
".StellarManageDataOp": $root["StellarManageDataOp"],
".StellarBumpSequenceOp": $root["StellarBumpSequenceOp"],
".StellarInvokeHostFunctionOp": $root["StellarInvokeHostFunctionOp"],
".StellarSorobanDataRequest": $root["StellarSorobanDataRequest"],
".StellarSorobanDataAck": $root["StellarSorobanDataAck"],
".StellarSignedTx": $root["StellarSignedTx"],
".SuiGetAddress": $root["SuiGetAddress"],
".SuiAddress": $root["SuiAddress"],
".SuiSignTx": $root["SuiSignTx"],
".SuiSignedTx": $root["SuiSignedTx"],
".SuiTxRequest": $root["SuiTxRequest"],
".SuiTxAck": $root["SuiTxAck"],
".SuiSignMessage": $root["SuiSignMessage"],
".SuiMessageSignature": $root["SuiMessageSignature"],
".TezosGetAddress": $root["TezosGetAddress"],
".TezosAddress": $root["TezosAddress"],
".TezosGetPublicKey": $root["TezosGetPublicKey"],
".TezosPublicKey": $root["TezosPublicKey"],
".TezosSignTx": $root["TezosSignTx"],
".TezosSignTx.TezosContractID": $root["TezosSignTx"]["TezosContractID"],
".TezosSignTx.TezosRevealOp": $root["TezosSignTx"]["TezosRevealOp"],
".TezosSignTx.TezosTransactionOp": $root["TezosSignTx"]["TezosTransactionOp"],
".TezosSignTx.TezosTransactionOp.TezosParametersManager": $root["TezosSignTx"]["TezosTransactionOp"]["TezosParametersManager"],
".TezosSignTx.TezosTransactionOp.TezosParametersManager.TezosManagerTransfer": $root["TezosSignTx"]["TezosTransactionOp"]["TezosParametersManager"]["TezosManagerTransfer"],
".TezosSignTx.TezosOriginationOp": $root["TezosSignTx"]["TezosOriginationOp"],
".TezosSignTx.TezosDelegationOp": $root["TezosSignTx"]["TezosDelegationOp"],
".TezosSignTx.TezosProposalOp": $root["TezosSignTx"]["TezosProposalOp"],
".TezosSignTx.TezosBallotOp": $root["TezosSignTx"]["TezosBallotOp"],
".TezosSignedTx": $root["TezosSignedTx"],
".TonGetAddress": $root["TonGetAddress"],
".TonAddress": $root["TonAddress"],
".TonSignMessage": $root["TonSignMessage"],
".TonTxAck": $root["TonTxAck"],
".TonSignedMessage": $root["TonSignedMessage"],
".TonSignProof": $root["TonSignProof"],
".TonSignedProof": $root["TonSignedProof"],
".TonSignData": $root["TonSignData"],
".TonSignedData": $root["TonSignedData"],
".TronGetAddress": $root["TronGetAddress"],
".TronAddress": $root["TronAddress"],
".TronSignTx": $root["TronSignTx"],
".TronSignTx.TronContract": $root["TronSignTx"]["TronContract"],
".TronSignTx.TronContract.TronTransferContract": $root["TronSignTx"]["TronContract"]["TronTransferContract"],
".TronSignTx.TronContract.TronTriggerSmartContract": $root["TronSignTx"]["TronContract"]["TronTriggerSmartContract"],
".TronSignTx.TronContract.TronFreezeBalanceContract": $root["TronSignTx"]["TronContract"]["TronFreezeBalanceContract"],
".TronSignTx.TronContract.TronUnfreezeBalanceContract": $root["TronSignTx"]["TronContract"]["TronUnfreezeBalanceContract"],
".TronSignTx.TronContract.TronWithdrawBalanceContract": $root["TronSignTx"]["TronContract"]["TronWithdrawBalanceContract"],
".TronSignTx.TronContract.TronFreezeBalanceV2Contract": $root["TronSignTx"]["TronContract"]["TronFreezeBalanceV2Contract"],
".TronSignTx.TronContract.TronUnfreezeBalanceV2Contract": $root["TronSignTx"]["TronContract"]["TronUnfreezeBalanceV2Contract"],
".TronSignTx.TronContract.TronWithdrawExpireUnfreezeContract": $root["TronSignTx"]["TronContract"]["TronWithdrawExpireUnfreezeContract"],
".TronSignTx.TronContract.TronDelegateResourceContract": $root["TronSignTx"]["TronContract"]["TronDelegateResourceContract"],
".TronSignTx.TronContract.TronUnDelegateResourceContract": $root["TronSignTx"]["TronContract"]["TronUnDelegateResourceContract"],
".TronSignTx.TronContract.TronVoteWitnessContract": $root["TronSignTx"]["TronContract"]["TronVoteWitnessContract"],
".TronSignTx.TronContract.TronVoteWitnessContract.Vote": $root["TronSignTx"]["TronContract"]["TronVoteWitnessContract"]["Vote"],
".TronSignTx.TronContract.TronCancelAllUnfreezeV2Contract": $root["TronSignTx"]["TronContract"]["TronCancelAllUnfreezeV2Contract"],
".TronSignedTx": $root["TronSignedTx"],
".TronSignMessage": $root["TronSignMessage"],
".TronMessageSignature": $root["TronMessageSignature"],
".WebAuthnListResidentCredentials": $root["WebAuthnListResidentCredentials"],
".WebAuthnAddResidentCredential": $root["WebAuthnAddResidentCredential"],
".WebAuthnRemoveResidentCredential": $root["WebAuthnRemoveResidentCredential"],
".WebAuthnCredentials": $root["WebAuthnCredentials"],
".WebAuthnCredentials.WebAuthnCredential": $root["WebAuthnCredentials"]["WebAuthnCredential"],
".BabylonDeriveContextHash": $root["BabylonDeriveContextHash"],
".BabylonDerivedContextHash": $root["BabylonDerivedContextHash"],
".google.protobuf.FileDescriptorSet": $root["google"]["protobuf"]["FileDescriptorSet"],
".google.protobuf.FileDescriptorProto": $root["google"]["protobuf"]["FileDescriptorProto"],
".google.protobuf.DescriptorProto": $root["google"]["protobuf"]["DescriptorProto"],
".google.protobuf.DescriptorProto.ExtensionRange": $root["google"]["protobuf"]["DescriptorProto"]["ExtensionRange"],
".google.protobuf.DescriptorProto.ReservedRange": $root["google"]["protobuf"]["DescriptorProto"]["ReservedRange"],
".google.protobuf.FieldDescriptorProto": $root["google"]["protobuf"]["FieldDescriptorProto"],
".google.protobuf.OneofDescriptorProto": $root["google"]["protobuf"]["OneofDescriptorProto"],
".google.protobuf.EnumDescriptorProto": $root["google"]["protobuf"]["EnumDescriptorProto"],
".google.protobuf.EnumValueDescriptorProto": $root["google"]["protobuf"]["EnumValueDescriptorProto"],
".google.protobuf.ServiceDescriptorProto": $root["google"]["protobuf"]["ServiceDescriptorProto"],
".google.protobuf.MethodDescriptorProto": $root["google"]["protobuf"]["MethodDescriptorProto"],
".google.protobuf.FileOptions": $root["google"]["protobuf"]["FileOptions"],
".google.protobuf.MessageOptions": $root["google"]["protobuf"]["MessageOptions"],
".google.protobuf.FieldOptions": $root["google"]["protobuf"]["FieldOptions"],
".google.protobuf.OneofOptions": $root["google"]["protobuf"]["OneofOptions"],
".google.protobuf.EnumOptions": $root["google"]["protobuf"]["EnumOptions"],
".google.protobuf.EnumValueOptions": $root["google"]["protobuf"]["EnumValueOptions"],
".google.protobuf.ServiceOptions": $root["google"]["protobuf"]["ServiceOptions"],
".google.protobuf.MethodOptions": $root["google"]["protobuf"]["MethodOptions"],
".google.protobuf.UninterpretedOption": $root["google"]["protobuf"]["UninterpretedOption"],
".google.protobuf.UninterpretedOption.NamePart": $root["google"]["protobuf"]["UninterpretedOption"]["NamePart"],
".google.protobuf.SourceCodeInfo": $root["google"]["protobuf"]["SourceCodeInfo"],
".google.protobuf.SourceCodeInfo.Location": $root["google"]["protobuf"]["SourceCodeInfo"]["Location"],
".google.protobuf.GeneratedCodeInfo": $root["google"]["protobuf"]["GeneratedCodeInfo"],
".google.protobuf.GeneratedCodeInfo.Annotation": $root["google"]["protobuf"]["GeneratedCodeInfo"]["Annotation"]};
},
"{\"nested\":{\"Address\":{\"fields\":{\"address\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"}}},\"AlgorandAddress\":{\"fields\":{\"address\":{\"id\":1,\"type\":\"string\"}}},\"AlgorandGetAddress\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"show_display\":{\"id\":3,\"type\":\"bool\"}}},\"AlgorandSignTx\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"raw_tx\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"AlgorandSignedTx\":{\"fields\":{\"signature\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"AmountUnit\":{\"values\":{\"BITCOIN\":0,\"MICROBITCOIN\":2,\"MILLIBITCOIN\":1,\"SATOSHI\":3}},\"ApplyFlags\":{\"fields\":{\"flags\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint32\"}}},\"ApplySettings\":{\"fields\":{\"_passphrase_source\":{\"id\":5,\"options\":{\"deprecated\":true},\"type\":\"uint32\"},\"auto_lock_delay_ms\":{\"id\":6,\"type\":\"uint32\"},\"display_rotation\":{\"id\":7,\"type\":\"uint32\"},\"experimental_features\":{\"id\":10,\"type\":\"bool\"},\"fastpay_confirm\":{\"id\":104,\"type\":\"bool\"},\"fastpay_money_limit\":{\"id\":105,\"type\":\"uint64\"},\"fastpay_pin\":{\"id\":103,\"type\":\"bool\"},\"fastpay_times\":{\"id\":106,\"type\":\"uint32\"},\"homescreen\":{\"id\":4,\"type\":\"bytes\"},\"is_bixinapp\":{\"id\":102,\"type\":\"bool\"},\"label\":{\"id\":2,\"type\":\"string\"},\"language\":{\"id\":1,\"type\":\"string\"},\"passphrase_always_on_device\":{\"id\":8,\"type\":\"bool\"},\"safety_checks\":{\"id\":9,\"type\":\"SafetyCheckLevel\"},\"use_ble\":{\"id\":100,\"type\":\"bool\"},\"use_passphrase\":{\"id\":3,\"type\":\"bool\"},\"use_se\":{\"id\":101,\"type\":\"bool\"}},\"nested\":{\"ExportType\":{\"values\":{\"MnemonicPlainExportType_YES\":2,\"SeedEncExportType_NO\":0,\"SeedEncExportType_YES\":1}}}},\"AptosAddress\":{\"fields\":{\"address\":{\"id\":1,\"type\":\"string\"}}},\"AptosGetAddress\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"show_display\":{\"id\":2,\"type\":\"bool\"}}},\"AptosMessageSignature\":{\"fields\":{\"address\":{\"id\":2,\"rule\":\"required\",\"type\":\"string\"},\"signature\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"AptosSignMessage\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"payload\":{\"id\":2,\"rule\":\"required\",\"type\":\"AptosMessagePayload\"}},\"nested\":{\"AptosMessagePayload\":{\"fields\":{\"address\":{\"id\":2,\"type\":\"string\"},\"application\":{\"id\":4,\"type\":\"string\"},\"chain_id\":{\"id\":3,\"type\":\"string\"},\"message\":{\"id\":6,\"rule\":\"required\",\"type\":\"string\"},\"nonce\":{\"id\":5,\"rule\":\"required\",\"type\":\"string\"}}}}},\"AptosSignTx\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"raw_tx\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"AptosSignedTx\":{\"fields\":{\"public_key\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"},\"signature\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"AuthorizeCoinJoin\":{\"fields\":{\"address_n\":{\"id\":4,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"amount_unit\":{\"id\":11,\"options\":{\"default\":\"BITCOIN\"},\"type\":\"AmountUnit\"},\"coin_name\":{\"id\":5,\"options\":{\"default\":\"Bitcoin\"},\"type\":\"string\"},\"coordinator\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"},\"fee_per_anonymity\":{\"id\":3,\"options\":{\"default\":0},\"type\":\"uint32\"},\"max_total_fee\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint64\"},\"script_type\":{\"id\":6,\"options\":{\"default\":\"SPENDADDRESS\"},\"type\":\"InputScriptType\"}},\"options\":{\"(unstable)\":true}},\"BackupDevice\":{\"fields\":{}},\"BackupType\":{\"values\":{\"Bip39\":0,\"Slip39_Advanced\":2,\"Slip39_Basic\":1}},\"BatchGetPublickeys\":{\"fields\":{\"ecdsa_curve_name\":{\"id\":1,\"options\":{\"default\":\"ed25519\"},\"type\":\"string\"},\"paths\":{\"id\":2,\"rule\":\"repeated\",\"type\":\"Path\"}},\"nested\":{\"Path\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"}}}}},\"BinanceAddress\":{\"fields\":{\"address\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"}}},\"BinanceCancelMsg\":{\"fields\":{\"refid\":{\"id\":1,\"type\":\"string\"},\"sender\":{\"id\":2,\"type\":\"string\"},\"symbol\":{\"id\":3,\"type\":\"string\"}}},\"BinanceGetAddress\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"show_display\":{\"id\":2,\"type\":\"bool\"}}},\"BinanceGetPublicKey\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"show_display\":{\"id\":2,\"type\":\"bool\"}}},\"BinanceOrderMsg\":{\"fields\":{\"id\":{\"id\":1,\"type\":\"string\"},\"ordertype\":{\"id\":2,\"type\":\"BinanceOrderType\"},\"price\":{\"id\":3,\"type\":\"sint64\"},\"quantity\":{\"id\":4,\"type\":\"sint64\"},\"sender\":{\"id\":5,\"type\":\"string\"},\"side\":{\"id\":6,\"type\":\"BinanceOrderSide\"},\"symbol\":{\"id\":7,\"type\":\"string\"},\"timeinforce\":{\"id\":8,\"type\":\"BinanceTimeInForce\"}},\"nested\":{\"BinanceOrderSide\":{\"values\":{\"BUY\":1,\"SELL\":2,\"SIDE_UNKNOWN\":0}},\"BinanceOrderType\":{\"values\":{\"LIMIT\":2,\"MARKET\":1,\"OT_RESERVED\":3,\"OT_UNKNOWN\":0}},\"BinanceTimeInForce\":{\"values\":{\"GTE\":1,\"IOC\":3,\"TIF_RESERVED\":2,\"TIF_UNKNOWN\":0}}}},\"BinancePublicKey\":{\"fields\":{\"public_key\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"BinanceSignTx\":{\"fields\":{\"account_number\":{\"id\":3,\"type\":\"sint64\"},\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"chain_id\":{\"id\":4,\"type\":\"string\"},\"memo\":{\"id\":5,\"type\":\"string\"},\"msg_count\":{\"id\":2,\"type\":\"uint32\"},\"sequence\":{\"id\":6,\"type\":\"sint64\"},\"source\":{\"id\":7,\"type\":\"sint64\"}}},\"BinanceSignedTx\":{\"fields\":{\"public_key\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"},\"signature\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"BinanceTransferMsg\":{\"fields\":{\"inputs\":{\"id\":1,\"rule\":\"repeated\",\"type\":\"BinanceInputOutput\"},\"outputs\":{\"id\":2,\"rule\":\"repeated\",\"type\":\"BinanceInputOutput\"}},\"nested\":{\"BinanceCoin\":{\"fields\":{\"amount\":{\"id\":1,\"type\":\"sint64\"},\"denom\":{\"id\":2,\"type\":\"string\"}}},\"BinanceInputOutput\":{\"fields\":{\"address\":{\"id\":1,\"type\":\"string\"},\"coins\":{\"id\":2,\"rule\":\"repeated\",\"type\":\"BinanceCoin\"}}}}},\"BinanceTxRequest\":{\"fields\":{}},\"BixinBackupAck\":{\"fields\":{\"data\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"BixinBackupDevice\":{\"fields\":{}},\"BixinBackupDeviceAck\":{\"fields\":{\"mnemonics\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"}}},\"BixinBackupRequest\":{\"fields\":{}},\"BixinLoadDevice\":{\"fields\":{\"label\":{\"id\":6,\"type\":\"string\"},\"language\":{\"id\":5,\"options\":{\"default\":\"en-US\"},\"type\":\"string\"},\"mnemonics\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"},\"skip_checksum\":{\"id\":7,\"type\":\"bool\"}}},\"BixinMessageSE\":{\"fields\":{\"inputmessage\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"BixinOutMessageSE\":{\"fields\":{\"outmessage\":{\"id\":1,\"type\":\"bytes\"}}},\"BixinPinInputOnDevice\":{\"fields\":{}},\"BixinRestoreAck\":{\"fields\":{\"data\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"BixinRestoreRequest\":{\"fields\":{\"data\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"},\"label\":{\"id\":3,\"type\":\"string\"},\"language\":{\"id\":2,\"type\":\"string\"},\"passphrase_protection\":{\"id\":4,\"type\":\"bool\"}}},\"BixinSeedOperate\":{\"fields\":{\"seed_importData\":{\"id\":2,\"type\":\"bytes\"},\"type\":{\"id\":1,\"rule\":\"required\",\"type\":\"SeedRequestType\"}},\"nested\":{\"SeedRequestType\":{\"values\":{\"SeedRequestType_EncExport\":1,\"SeedRequestType_EncImport\":2,\"SeedRequestType_Gen\":0}}}},\"BixinVerifyDeviceAck\":{\"fields\":{\"cert\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"},\"signature\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"BixinVerifyDeviceRequest\":{\"fields\":{\"data\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"BixinWhiteListAck\":{\"fields\":{\"address\":{\"id\":1,\"rule\":\"repeated\",\"type\":\"string\"}}},\"BixinWhiteListRequest\":{\"fields\":{\"addr_in\":{\"id\":2,\"type\":\"string\"},\"type\":{\"id\":1,\"rule\":\"required\",\"type\":\"WL_OperationType\"}},\"nested\":{\"WL_OperationType\":{\"values\":{\"WL_OperationType_Add\":0,\"WL_OperationType_Delete\":1,\"WL_OperationType_Inquire\":2}}}},\"ButtonAck\":{\"fields\":{}},\"ButtonRequest\":{\"fields\":{\"code\":{\"id\":1,\"type\":\"ButtonRequestType\"},\"pages\":{\"id\":2,\"type\":\"uint32\"}},\"nested\":{\"ButtonRequestType\":{\"values\":{\"ButtonRequest_Address\":10,\"ButtonRequest_ConfirmOutput\":3,\"ButtonRequest_ConfirmWord\":5,\"ButtonRequest_FeeOverThreshold\":2,\"ButtonRequest_FirmwareCheck\":9,\"ButtonRequest_MnemonicInput\":13,\"ButtonRequest_MnemonicWordCount\":12,\"ButtonRequest_Other\":1,\"ButtonRequest_PassphraseEntry\":19,\"ButtonRequest_PinEntry\":20,\"ButtonRequest_ProtectCall\":7,\"ButtonRequest_PublicKey\":11,\"ButtonRequest_RecoveryHomepage\":16,\"ButtonRequest_ResetDevice\":4,\"ButtonRequest_SignTx\":8,\"ButtonRequest_Success\":17,\"ButtonRequest_UnknownDerivationPath\":15,\"ButtonRequest_Warning\":18,\"ButtonRequest_WipeDevice\":6,\"_Deprecated_ButtonRequest_PassphraseType\":14}}}},\"Cancel\":{\"fields\":{}},\"CancelAuthorization\":{\"fields\":{}},\"CardanoAddress\":{\"fields\":{\"address\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"}}},\"CardanoAddressParametersType\":{\"fields\":{\"address_n\":{\"id\":2,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"address_n_staking\":{\"id\":3,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"address_type\":{\"id\":1,\"rule\":\"required\",\"type\":\"CardanoAddressType\"},\"certificate_pointer\":{\"id\":5,\"type\":\"CardanoBlockchainPointerType\"},\"script_payment_hash\":{\"id\":6,\"type\":\"bytes\"},\"script_staking_hash\":{\"id\":7,\"type\":\"bytes\"},\"staking_key_hash\":{\"id\":4,\"type\":\"bytes\"}}},\"CardanoAddressType\":{\"values\":{\"BASE\":0,\"BASE_KEY_SCRIPT\":2,\"BASE_SCRIPT_KEY\":1,\"BASE_SCRIPT_SCRIPT\":3,\"BYRON\":8,\"ENTERPRISE\":6,\"ENTERPRISE_SCRIPT\":7,\"POINTER\":4,\"POINTER_SCRIPT\":5,\"REWARD\":14,\"REWARD_SCRIPT\":15}},\"CardanoAssetGroup\":{\"fields\":{\"policy_id\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"},\"tokens_count\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint32\"}}},\"CardanoBlockchainPointerType\":{\"fields\":{\"block_index\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint32\"},\"certificate_index\":{\"id\":3,\"rule\":\"required\",\"type\":\"uint32\"},\"tx_index\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint32\"}}},\"CardanoCertificateType\":{\"values\":{\"STAKE_DELEGATION\":2,\"STAKE_DEREGISTRATION\":1,\"STAKE_POOL_REGISTRATION\":3,\"STAKE_REGISTRATION\":0}},\"CardanoDerivationType\":{\"values\":{\"ICARUS\":1,\"ICARUS_TREZOR\":2,\"LEDGER\":0}},\"CardanoGetAddress\":{\"fields\":{\"address_parameters\":{\"id\":5,\"rule\":\"required\",\"type\":\"CardanoAddressParametersType\"},\"derivation_type\":{\"id\":6,\"rule\":\"required\",\"type\":\"CardanoDerivationType\"},\"network_id\":{\"id\":4,\"rule\":\"required\",\"type\":\"uint32\"},\"protocol_magic\":{\"id\":3,\"rule\":\"required\",\"type\":\"uint32\"},\"show_display\":{\"id\":2,\"options\":{\"default\":false},\"type\":\"bool\"}}},\"CardanoGetNativeScriptHash\":{\"fields\":{\"derivation_type\":{\"id\":3,\"rule\":\"required\",\"type\":\"CardanoDerivationType\"},\"display_format\":{\"id\":2,\"rule\":\"required\",\"type\":\"CardanoNativeScriptHashDisplayFormat\"},\"script\":{\"id\":1,\"rule\":\"required\",\"type\":\"CardanoNativeScript\"}}},\"CardanoGetPublicKey\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"derivation_type\":{\"id\":3,\"rule\":\"required\",\"type\":\"CardanoDerivationType\"},\"show_display\":{\"id\":2,\"type\":\"bool\"}}},\"CardanoGovernanceRegistrationDelegation\":{\"fields\":{\"voting_public_key\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"},\"weight\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint32\"}}},\"CardanoGovernanceRegistrationFormat\":{\"values\":{\"CIP15\":0,\"CIP36\":1}},\"CardanoGovernanceRegistrationParametersType\":{\"fields\":{\"delegations\":{\"id\":6,\"rule\":\"repeated\",\"type\":\"CardanoGovernanceRegistrationDelegation\"},\"format\":{\"id\":5,\"options\":{\"default\":\"CIP15\"},\"type\":\"CardanoGovernanceRegistrationFormat\"},\"nonce\":{\"id\":4,\"rule\":\"required\",\"type\":\"uint64\"},\"reward_address_parameters\":{\"id\":3,\"rule\":\"required\",\"type\":\"CardanoAddressParametersType\"},\"staking_path\":{\"id\":2,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"voting_public_key\":{\"id\":1,\"type\":\"bytes\"},\"voting_purpose\":{\"id\":7,\"type\":\"uint64\"}}},\"CardanoMessageSignature\":{\"fields\":{\"key\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"},\"signature\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"CardanoNativeScript\":{\"fields\":{\"invalid_before\":{\"id\":6,\"type\":\"uint64\"},\"invalid_hereafter\":{\"id\":7,\"type\":\"uint64\"},\"key_hash\":{\"id\":3,\"type\":\"bytes\"},\"key_path\":{\"id\":4,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"required_signatures_count\":{\"id\":5,\"type\":\"uint32\"},\"scripts\":{\"id\":2,\"rule\":\"repeated\",\"type\":\"CardanoNativeScript\"},\"type\":{\"id\":1,\"rule\":\"required\",\"type\":\"CardanoNativeScriptType\"}}},\"CardanoNativeScriptHash\":{\"fields\":{\"script_hash\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"CardanoNativeScriptHashDisplayFormat\":{\"values\":{\"BECH32\":1,\"HIDE\":0,\"POLICY_ID\":2}},\"CardanoNativeScriptType\":{\"values\":{\"ALL\":1,\"ANY\":2,\"INVALID_BEFORE\":4,\"INVALID_HEREAFTER\":5,\"N_OF_K\":3,\"PUB_KEY\":0}},\"CardanoPoolMetadataType\":{\"fields\":{\"hash\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"},\"url\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"}}},\"CardanoPoolOwner\":{\"fields\":{\"staking_key_hash\":{\"id\":2,\"type\":\"bytes\"},\"staking_key_path\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"}}},\"CardanoPoolParametersType\":{\"fields\":{\"cost\":{\"id\":4,\"rule\":\"required\",\"type\":\"uint64\"},\"margin_denominator\":{\"id\":6,\"rule\":\"required\",\"type\":\"uint64\"},\"margin_numerator\":{\"id\":5,\"rule\":\"required\",\"type\":\"uint64\"},\"metadata\":{\"id\":10,\"type\":\"CardanoPoolMetadataType\"},\"owners_count\":{\"id\":11,\"rule\":\"required\",\"type\":\"uint32\"},\"pledge\":{\"id\":3,\"rule\":\"required\",\"type\":\"uint64\"},\"pool_id\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"},\"relays_count\":{\"id\":12,\"rule\":\"required\",\"type\":\"uint32\"},\"reward_account\":{\"id\":7,\"rule\":\"required\",\"type\":\"string\"},\"vrf_key_hash\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"CardanoPoolRelayParameters\":{\"fields\":{\"host_name\":{\"id\":4,\"type\":\"string\"},\"ipv4_address\":{\"id\":2,\"type\":\"bytes\"},\"ipv6_address\":{\"id\":3,\"type\":\"bytes\"},\"port\":{\"id\":5,\"type\":\"uint32\"},\"type\":{\"id\":1,\"rule\":\"required\",\"type\":\"CardanoPoolRelayType\"}}},\"CardanoPoolRelayType\":{\"values\":{\"MULTIPLE_HOST_NAME\":2,\"SINGLE_HOST_IP\":0,\"SINGLE_HOST_NAME\":1}},\"CardanoPublicKey\":{\"fields\":{\"node\":{\"id\":2,\"rule\":\"required\",\"type\":\"HDNodeType\"},\"xpub\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"}}},\"CardanoSignMessage\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"derivation_type\":{\"id\":3,\"rule\":\"required\",\"type\":\"CardanoDerivationType\"},\"message\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"},\"network_id\":{\"id\":4,\"rule\":\"required\",\"type\":\"uint32\"}}},\"CardanoSignTxFinished\":{\"fields\":{}},\"CardanoSignTxInit\":{\"fields\":{\"certificates_count\":{\"id\":8,\"rule\":\"required\",\"type\":\"uint32\"},\"collateral_inputs_count\":{\"id\":17,\"rule\":\"required\",\"type\":\"uint32\"},\"derivation_type\":{\"id\":14,\"rule\":\"required\",\"type\":\"CardanoDerivationType\"},\"fee\":{\"id\":6,\"rule\":\"required\",\"type\":\"uint64\"},\"has_auxiliary_data\":{\"id\":10,\"rule\":\"required\",\"type\":\"bool\"},\"has_collateral_return\":{\"id\":19,\"options\":{\"default\":false},\"type\":\"bool\"},\"include_network_id\":{\"id\":15,\"options\":{\"default\":false},\"type\":\"bool\"},\"inputs_count\":{\"id\":4,\"rule\":\"required\",\"type\":\"uint32\"},\"minting_asset_groups_count\":{\"id\":13,\"rule\":\"required\",\"type\":\"uint32\"},\"network_id\":{\"id\":3,\"rule\":\"required\",\"type\":\"uint32\"},\"outputs_count\":{\"id\":5,\"rule\":\"required\",\"type\":\"uint32\"},\"protocol_magic\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint32\"},\"reference_inputs_count\":{\"id\":21,\"options\":{\"default\":0},\"type\":\"uint32\"},\"required_signers_count\":{\"id\":18,\"rule\":\"required\",\"type\":\"uint32\"},\"script_data_hash\":{\"id\":16,\"type\":\"bytes\"},\"signing_mode\":{\"id\":1,\"rule\":\"required\",\"type\":\"CardanoTxSigningMode\"},\"total_collateral\":{\"id\":20,\"type\":\"uint64\"},\"ttl\":{\"id\":7,\"type\":\"uint64\"},\"validity_interval_start\":{\"id\":11,\"type\":\"uint64\"},\"withdrawals_count\":{\"id\":9,\"rule\":\"required\",\"type\":\"uint32\"},\"witness_requests_count\":{\"id\":12,\"rule\":\"required\",\"type\":\"uint32\"}}},\"CardanoToken\":{\"fields\":{\"amount\":{\"id\":2,\"type\":\"uint64\"},\"asset_name_bytes\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"},\"mint_amount\":{\"id\":3,\"type\":\"sint64\"}}},\"CardanoTxAuxiliaryData\":{\"fields\":{\"governance_registration_parameters\":{\"id\":1,\"type\":\"CardanoGovernanceRegistrationParametersType\"},\"hash\":{\"id\":2,\"type\":\"bytes\"}}},\"CardanoTxAuxiliaryDataSupplement\":{\"fields\":{\"auxiliary_data_hash\":{\"id\":2,\"type\":\"bytes\"},\"governance_signature\":{\"id\":3,\"type\":\"bytes\"},\"type\":{\"id\":1,\"rule\":\"required\",\"type\":\"CardanoTxAuxiliaryDataSupplementType\"}}},\"CardanoTxAuxiliaryDataSupplementType\":{\"values\":{\"GOVERNANCE_REGISTRATION_SIGNATURE\":1,\"NONE\":0}},\"CardanoTxBodyHash\":{\"fields\":{\"tx_hash\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"CardanoTxCertificate\":{\"fields\":{\"key_hash\":{\"id\":6,\"type\":\"bytes\"},\"path\":{\"id\":2,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"pool\":{\"id\":3,\"type\":\"bytes\"},\"pool_parameters\":{\"id\":4,\"type\":\"CardanoPoolParametersType\"},\"script_hash\":{\"id\":5,\"type\":\"bytes\"},\"type\":{\"id\":1,\"rule\":\"required\",\"type\":\"CardanoCertificateType\"}}},\"CardanoTxCollateralInput\":{\"fields\":{\"prev_hash\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"},\"prev_index\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint32\"}}},\"CardanoTxHostAck\":{\"fields\":{}},\"CardanoTxInlineDatumChunk\":{\"fields\":{\"data\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"CardanoTxInput\":{\"fields\":{\"prev_hash\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"},\"prev_index\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint32\"}}},\"CardanoTxItemAck\":{\"fields\":{}},\"CardanoTxMint\":{\"fields\":{\"asset_groups_count\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint32\"}}},\"CardanoTxOutput\":{\"fields\":{\"address\":{\"id\":1,\"type\":\"string\"},\"address_parameters\":{\"id\":2,\"type\":\"CardanoAddressParametersType\"},\"amount\":{\"id\":3,\"rule\":\"required\",\"type\":\"uint64\"},\"asset_groups_count\":{\"id\":4,\"rule\":\"required\",\"type\":\"uint32\"},\"datum_hash\":{\"id\":5,\"type\":\"bytes\"},\"format\":{\"id\":6,\"options\":{\"default\":\"ARRAY_LEGACY\"},\"type\":\"CardanoTxOutputSerializationFormat\"},\"inline_datum_size\":{\"id\":7,\"options\":{\"default\":0},\"type\":\"uint32\"},\"reference_script_size\":{\"id\":8,\"options\":{\"default\":0},\"type\":\"uint32\"}}},\"CardanoTxOutputSerializationFormat\":{\"values\":{\"ARRAY_LEGACY\":0,\"MAP_BABBAGE\":1}},\"CardanoTxReferenceInput\":{\"fields\":{\"prev_hash\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"},\"prev_index\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint32\"}}},\"CardanoTxReferenceScriptChunk\":{\"fields\":{\"data\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"CardanoTxRequiredSigner\":{\"fields\":{\"key_hash\":{\"id\":1,\"type\":\"bytes\"},\"key_path\":{\"id\":2,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"}}},\"CardanoTxSigningMode\":{\"values\":{\"MULTISIG_TRANSACTION\":2,\"ORDINARY_TRANSACTION\":0,\"PLUTUS_TRANSACTION\":3,\"POOL_REGISTRATION_AS_OWNER\":1}},\"CardanoTxWithdrawal\":{\"fields\":{\"amount\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint64\"},\"key_hash\":{\"id\":4,\"type\":\"bytes\"},\"path\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"script_hash\":{\"id\":3,\"type\":\"bytes\"}}},\"CardanoTxWitnessRequest\":{\"fields\":{\"path\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"}}},\"CardanoTxWitnessResponse\":{\"fields\":{\"chain_code\":{\"id\":4,\"type\":\"bytes\"},\"pub_key\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"},\"signature\":{\"id\":3,\"rule\":\"required\",\"type\":\"bytes\"},\"type\":{\"id\":1,\"rule\":\"required\",\"type\":\"CardanoTxWitnessType\"}}},\"CardanoTxWitnessType\":{\"values\":{\"BYRON_WITNESS\":0,\"SHELLEY_WITNESS\":1}},\"ChangePin\":{\"fields\":{\"remove\":{\"id\":1,\"type\":\"bool\"}}},\"ChangeWipeCode\":{\"fields\":{\"remove\":{\"id\":1,\"type\":\"bool\"}}},\"CipherKeyValue\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"ask_on_decrypt\":{\"id\":6,\"type\":\"bool\"},\"ask_on_encrypt\":{\"id\":5,\"type\":\"bool\"},\"encrypt\":{\"id\":4,\"type\":\"bool\"},\"iv\":{\"id\":7,\"type\":\"bytes\"},\"key\":{\"id\":2,\"rule\":\"required\",\"type\":\"string\"},\"value\":{\"id\":3,\"rule\":\"required\",\"type\":\"bytes\"}}},\"CipheredKeyValue\":{\"fields\":{\"value\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"CommandFlags\":{\"values\":{\"Default\":0,\"Factory_Only\":1}},\"ConfluxAddress\":{\"fields\":{\"address\":{\"id\":1,\"type\":\"string\"}}},\"ConfluxGetAddress\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"chain_id\":{\"id\":3,\"type\":\"uint32\"},\"show_display\":{\"id\":2,\"type\":\"bool\"}}},\"ConfluxMessageSignature\":{\"fields\":{\"address\":{\"id\":3,\"type\":\"string\"},\"signature\":{\"id\":2,\"type\":\"bytes\"}}},\"ConfluxSignMessage\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"message\":{\"id\":2,\"type\":\"bytes\"}}},\"ConfluxSignMessageCIP23\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"domain_hash\":{\"id\":2,\"type\":\"bytes\"},\"message_hash\":{\"id\":3,\"type\":\"bytes\"}}},\"ConfluxSignTx\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"chain_id\":{\"id\":11,\"type\":\"uint32\"},\"data_initial_chunk\":{\"id\":9,\"type\":\"bytes\"},\"data_length\":{\"id\":10,\"type\":\"uint32\"},\"epoch_height\":{\"id\":7,\"type\":\"bytes\"},\"gas_limit\":{\"id\":4,\"type\":\"bytes\"},\"gas_price\":{\"id\":3,\"type\":\"bytes\"},\"nonce\":{\"id\":2,\"type\":\"bytes\"},\"storage_limit\":{\"id\":8,\"type\":\"bytes\"},\"to\":{\"id\":5,\"type\":\"string\"},\"value\":{\"id\":6,\"type\":\"bytes\"}}},\"ConfluxTxAck\":{\"fields\":{\"data_chunk\":{\"id\":1,\"type\":\"bytes\"}}},\"ConfluxTxRequest\":{\"fields\":{\"data_length\":{\"id\":1,\"type\":\"uint32\"},\"signature_r\":{\"id\":3,\"type\":\"bytes\"},\"signature_s\":{\"id\":4,\"type\":\"bytes\"},\"signature_v\":{\"id\":2,\"type\":\"uint32\"}}},\"CosiCommit\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"data\":{\"id\":2,\"type\":\"bytes\"}}},\"CosiCommitment\":{\"fields\":{\"commitment\":{\"id\":1,\"type\":\"bytes\"},\"pubkey\":{\"id\":2,\"type\":\"bytes\"}}},\"CosiSign\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"data\":{\"id\":2,\"type\":\"bytes\"},\"global_commitment\":{\"id\":3,\"type\":\"bytes\"},\"global_pubkey\":{\"id\":4,\"type\":\"bytes\"}}},\"CosiSignature\":{\"fields\":{\"signature\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"CosmosAddress\":{\"fields\":{\"address\":{\"id\":1,\"type\":\"string\"}}},\"CosmosGetAddress\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"hrp\":{\"id\":2,\"type\":\"string\"},\"show_display\":{\"id\":3,\"type\":\"bool\"}}},\"CosmosSignTx\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"raw_tx\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"CosmosSignedTx\":{\"fields\":{\"signature\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"DebugLinkDecision\":{\"fields\":{\"hold_ms\":{\"id\":7,\"type\":\"uint32\"},\"input\":{\"id\":3,\"type\":\"string\"},\"swipe\":{\"id\":2,\"type\":\"DebugSwipeDirection\"},\"wait\":{\"id\":6,\"type\":\"bool\"},\"x\":{\"id\":4,\"type\":\"uint32\"},\"y\":{\"id\":5,\"type\":\"uint32\"},\"yes_no\":{\"id\":1,\"type\":\"bool\"}},\"nested\":{\"DebugSwipeDirection\":{\"values\":{\"DOWN\":1,\"LEFT\":2,\"RIGHT\":3,\"UP\":0}}}},\"DebugLinkEraseSdCard\":{\"fields\":{\"format\":{\"id\":1,\"type\":\"bool\"}}},\"DebugLinkFlashErase\":{\"fields\":{\"sector\":{\"id\":1,\"type\":\"uint32\"}}},\"DebugLinkGetState\":{\"fields\":{\"wait_layout\":{\"id\":3,\"type\":\"bool\"},\"wait_word_list\":{\"id\":1,\"type\":\"bool\"},\"wait_word_pos\":{\"id\":2,\"type\":\"bool\"}}},\"DebugLinkLayout\":{\"fields\":{\"lines\":{\"id\":1,\"rule\":\"repeated\",\"type\":\"string\"}}},\"DebugLinkLog\":{\"fields\":{\"bucket\":{\"id\":2,\"type\":\"string\"},\"level\":{\"id\":1,\"type\":\"uint32\"},\"text\":{\"id\":3,\"type\":\"string\"}}},\"DebugLinkMemory\":{\"fields\":{\"memory\":{\"id\":1,\"type\":\"bytes\"}}},\"DebugLinkMemoryRead\":{\"fields\":{\"address\":{\"id\":1,\"type\":\"uint32\"},\"length\":{\"id\":2,\"type\":\"uint32\"}}},\"DebugLinkMemoryWrite\":{\"fields\":{\"address\":{\"id\":1,\"type\":\"uint32\"},\"flash\":{\"id\":3,\"type\":\"bool\"},\"memory\":{\"id\":2,\"type\":\"bytes\"}}},\"DebugLinkRecordScreen\":{\"fields\":{\"target_directory\":{\"id\":1,\"type\":\"string\"}}},\"DebugLinkReseedRandom\":{\"fields\":{\"value\":{\"id\":1,\"type\":\"uint32\"}}},\"DebugLinkState\":{\"fields\":{\"layout\":{\"id\":1,\"type\":\"bytes\"},\"layout_lines\":{\"id\":13,\"rule\":\"repeated\",\"type\":\"string\"},\"matrix\":{\"id\":3,\"type\":\"string\"},\"mnemonic_secret\":{\"id\":4,\"type\":\"bytes\"},\"mnemonic_type\":{\"id\":12,\"type\":\"BackupType\"},\"node\":{\"id\":5,\"type\":\"HDNodeType\"},\"passphrase_protection\":{\"id\":6,\"type\":\"bool\"},\"pin\":{\"id\":2,\"type\":\"string\"},\"recovery_fake_word\":{\"id\":9,\"type\":\"string\"},\"recovery_word_pos\":{\"id\":10,\"type\":\"uint32\"},\"reset_entropy\":{\"id\":8,\"type\":\"bytes\"},\"reset_word\":{\"id\":7,\"type\":\"string\"},\"reset_word_pos\":{\"id\":11,\"type\":\"uint32\"}}},\"DebugLinkStop\":{\"fields\":{}},\"DebugLinkWatchLayout\":{\"fields\":{\"watch\":{\"id\":1,\"type\":\"bool\"}}},\"DebugMoneroDiagAck\":{\"fields\":{\"data1\":{\"id\":5,\"type\":\"bytes\"},\"data2\":{\"id\":6,\"type\":\"bytes\"},\"ins\":{\"id\":1,\"type\":\"uint64\"},\"p1\":{\"id\":2,\"type\":\"uint64\"},\"p2\":{\"id\":3,\"type\":\"uint64\"},\"pd\":{\"id\":4,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint64\"}}},\"DebugMoneroDiagRequest\":{\"fields\":{\"data1\":{\"id\":5,\"type\":\"bytes\"},\"data2\":{\"id\":6,\"type\":\"bytes\"},\"ins\":{\"id\":1,\"type\":\"uint64\"},\"p1\":{\"id\":2,\"type\":\"uint64\"},\"p2\":{\"id\":3,\"type\":\"uint64\"},\"pd\":{\"id\":4,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint64\"}}},\"DecredStakingSpendType\":{\"values\":{\"SSGen\":0,\"SSRTX\":1}},\"Deprecated_PassphraseStateAck\":{\"fields\":{},\"options\":{\"deprecated\":true}},\"Deprecated_PassphraseStateRequest\":{\"fields\":{\"state\":{\"id\":1,\"type\":\"bytes\"}},\"options\":{\"deprecated\":true}},\"DeviceBackToBoot\":{\"fields\":{}},\"DeviceEraseSector\":{\"fields\":{\"sector\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint32\"}}},\"DeviceInfo\":{\"fields\":{\"NFT_voucher\":{\"id\":4,\"type\":\"bytes\"},\"SE_info\":{\"id\":3,\"type\":\"string\"},\"cpu_info\":{\"id\":5,\"type\":\"string\"},\"pre_firmware\":{\"id\":6,\"type\":\"string\"},\"serial_no\":{\"id\":1,\"type\":\"string\"},\"spiFlash_info\":{\"id\":2,\"type\":\"string\"}}},\"DeviceInfoSettings\":{\"fields\":{\"cpu_info\":{\"id\":2,\"type\":\"string\"},\"pre_firmware\":{\"id\":3,\"type\":\"string\"},\"serial_no\":{\"id\":1,\"type\":\"string\"}}},\"DoPreauthorized\":{\"fields\":{}},\"ECDHSessionKey\":{\"fields\":{\"public_key\":{\"id\":2,\"type\":\"bytes\"},\"session_key\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"EcdsaPublicKeys\":{\"fields\":{\"public_keys\":{\"id\":1,\"rule\":\"repeated\",\"type\":\"bytes\"}}},\"EmmcDir\":{\"fields\":{\"child_dirs\":{\"id\":2,\"type\":\"string\"},\"child_files\":{\"id\":3,\"type\":\"string\"},\"path\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"}}},\"EmmcDirList\":{\"fields\":{\"path\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"}}},\"EmmcDirMake\":{\"fields\":{\"path\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"}}},\"EmmcDirRemove\":{\"fields\":{\"path\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"}}},\"EmmcFile\":{\"fields\":{\"data\":{\"id\":4,\"type\":\"bytes\"},\"data_hash\":{\"id\":5,\"type\":\"uint32\"},\"len\":{\"id\":3,\"rule\":\"required\",\"type\":\"uint32\"},\"offset\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint32\"},\"path\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"},\"processed_byte\":{\"id\":6,\"type\":\"uint32\"}}},\"EmmcFileDelete\":{\"fields\":{\"path\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"}}},\"EmmcFileRead\":{\"fields\":{\"file\":{\"id\":1,\"rule\":\"required\",\"type\":\"EmmcFile\"},\"ui_percentage\":{\"id\":2,\"type\":\"uint32\"}}},\"EmmcFileWrite\":{\"fields\":{\"append\":{\"id\":3,\"rule\":\"required\",\"type\":\"bool\"},\"file\":{\"id\":1,\"rule\":\"required\",\"type\":\"EmmcFile\"},\"overwrite\":{\"id\":2,\"rule\":\"required\",\"type\":\"bool\"},\"ui_percentage\":{\"id\":4,\"type\":\"uint32\"}}},\"EmmcFixPermission\":{\"fields\":{}},\"EmmcPath\":{\"fields\":{\"archive\":{\"id\":12,\"rule\":\"required\",\"type\":\"bool\"},\"day\":{\"id\":5,\"rule\":\"required\",\"type\":\"uint32\"},\"directory\":{\"id\":13,\"rule\":\"required\",\"type\":\"bool\"},\"exist\":{\"id\":1,\"rule\":\"required\",\"type\":\"bool\"},\"hidden\":{\"id\":10,\"rule\":\"required\",\"type\":\"bool\"},\"hour\":{\"id\":6,\"rule\":\"required\",\"type\":\"uint32\"},\"minute\":{\"id\":7,\"rule\":\"required\",\"type\":\"uint32\"},\"month\":{\"id\":4,\"rule\":\"required\",\"type\":\"uint32\"},\"readonly\":{\"id\":9,\"rule\":\"required\",\"type\":\"bool\"},\"second\":{\"id\":8,\"rule\":\"required\",\"type\":\"uint32\"},\"size\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint64\"},\"system\":{\"id\":11,\"rule\":\"required\",\"type\":\"bool\"},\"year\":{\"id\":3,\"rule\":\"required\",\"type\":\"uint32\"}}},\"EmmcPathInfo\":{\"fields\":{\"path\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"}}},\"EndSession\":{\"fields\":{}},\"Entropy\":{\"fields\":{\"entropy\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"EntropyAck\":{\"fields\":{\"entropy\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"EntropyRequest\":{\"fields\":{}},\"EosGetPublicKey\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"show_display\":{\"id\":2,\"type\":\"bool\"}}},\"EosPublicKey\":{\"fields\":{\"raw_public_key\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"},\"wif_public_key\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"}}},\"EosSignTx\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"chain_id\":{\"id\":2,\"type\":\"bytes\"},\"header\":{\"id\":3,\"type\":\"EosTxHeader\"},\"num_actions\":{\"id\":4,\"type\":\"uint32\"}},\"nested\":{\"EosTxHeader\":{\"fields\":{\"delay_sec\":{\"id\":6,\"rule\":\"required\",\"type\":\"uint32\"},\"expiration\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint32\"},\"max_cpu_usage_ms\":{\"id\":5,\"rule\":\"required\",\"type\":\"uint32\"},\"max_net_usage_words\":{\"id\":4,\"rule\":\"required\",\"type\":\"uint32\"},\"ref_block_num\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint32\"},\"ref_block_prefix\":{\"id\":3,\"rule\":\"required\",\"type\":\"uint32\"}}}}},\"EosSignedTx\":{\"fields\":{\"signature\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"}}},\"EosTxActionAck\":{\"fields\":{\"buy_ram\":{\"id\":6,\"type\":\"EosActionBuyRam\"},\"buy_ram_bytes\":{\"id\":7,\"type\":\"EosActionBuyRamBytes\"},\"common\":{\"id\":1,\"type\":\"EosActionCommon\"},\"delegate\":{\"id\":3,\"type\":\"EosActionDelegate\"},\"delete_auth\":{\"id\":11,\"type\":\"EosActionDeleteAuth\"},\"link_auth\":{\"id\":12,\"type\":\"EosActionLinkAuth\"},\"new_account\":{\"id\":14,\"type\":\"EosActionNewAccount\"},\"refund\":{\"id\":5,\"type\":\"EosActionRefund\"},\"sell_ram\":{\"id\":8,\"type\":\"EosActionSellRam\"},\"transfer\":{\"id\":2,\"type\":\"EosActionTransfer\"},\"undelegate\":{\"id\":4,\"type\":\"EosActionUndelegate\"},\"unknown\":{\"id\":15,\"type\":\"EosActionUnknown\"},\"unlink_auth\":{\"id\":13,\"type\":\"EosActionUnlinkAuth\"},\"update_auth\":{\"id\":10,\"type\":\"EosActionUpdateAuth\"},\"vote_producer\":{\"id\":9,\"type\":\"EosActionVoteProducer\"}},\"nested\":{\"EosActionBuyRam\":{\"fields\":{\"payer\":{\"id\":1,\"type\":\"uint64\"},\"quantity\":{\"id\":3,\"type\":\"EosAsset\"},\"receiver\":{\"id\":2,\"type\":\"uint64\"}}},\"EosActionBuyRamBytes\":{\"fields\":{\"bytes\":{\"id\":3,\"type\":\"uint32\"},\"payer\":{\"id\":1,\"type\":\"uint64\"},\"receiver\":{\"id\":2,\"type\":\"uint64\"}}},\"EosActionCommon\":{\"fields\":{\"account\":{\"id\":1,\"type\":\"uint64\"},\"authorization\":{\"id\":3,\"rule\":\"repeated\",\"type\":\"EosPermissionLevel\"},\"name\":{\"id\":2,\"type\":\"uint64\"}}},\"EosActionDelegate\":{\"fields\":{\"cpu_quantity\":{\"id\":4,\"type\":\"EosAsset\"},\"net_quantity\":{\"id\":3,\"type\":\"EosAsset\"},\"receiver\":{\"id\":2,\"type\":\"uint64\"},\"sender\":{\"id\":1,\"type\":\"uint64\"},\"transfer\":{\"id\":5,\"type\":\"bool\"}}},\"EosActionDeleteAuth\":{\"fields\":{\"account\":{\"id\":1,\"type\":\"uint64\"},\"permission\":{\"id\":2,\"type\":\"uint64\"}}},\"EosActionLinkAuth\":{\"fields\":{\"account\":{\"id\":1,\"type\":\"uint64\"},\"code\":{\"id\":2,\"type\":\"uint64\"},\"requirement\":{\"id\":4,\"type\":\"uint64\"},\"type\":{\"id\":3,\"type\":\"uint64\"}}},\"EosActionNewAccount\":{\"fields\":{\"active\":{\"id\":4,\"type\":\"EosAuthorization\"},\"creator\":{\"id\":1,\"type\":\"uint64\"},\"name\":{\"id\":2,\"type\":\"uint64\"},\"owner\":{\"id\":3,\"type\":\"EosAuthorization\"}}},\"EosActionRefund\":{\"fields\":{\"owner\":{\"id\":1,\"type\":\"uint64\"}}},\"EosActionSellRam\":{\"fields\":{\"account\":{\"id\":1,\"type\":\"uint64\"},\"bytes\":{\"id\":2,\"type\":\"uint64\"}}},\"EosActionTransfer\":{\"fields\":{\"memo\":{\"id\":4,\"type\":\"string\"},\"quantity\":{\"id\":3,\"type\":\"EosAsset\"},\"receiver\":{\"id\":2,\"type\":\"uint64\"},\"sender\":{\"id\":1,\"type\":\"uint64\"}}},\"EosActionUndelegate\":{\"fields\":{\"cpu_quantity\":{\"id\":4,\"type\":\"EosAsset\"},\"net_quantity\":{\"id\":3,\"type\":\"EosAsset\"},\"receiver\":{\"id\":2,\"type\":\"uint64\"},\"sender\":{\"id\":1,\"type\":\"uint64\"}}},\"EosActionUnknown\":{\"fields\":{\"data_chunk\":{\"id\":2,\"type\":\"bytes\"},\"data_size\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint32\"}}},\"EosActionUnlinkAuth\":{\"fields\":{\"account\":{\"id\":1,\"type\":\"uint64\"},\"code\":{\"id\":2,\"type\":\"uint64\"},\"type\":{\"id\":3,\"type\":\"uint64\"}}},\"EosActionUpdateAuth\":{\"fields\":{\"account\":{\"id\":1,\"type\":\"uint64\"},\"auth\":{\"id\":4,\"type\":\"EosAuthorization\"},\"parent\":{\"id\":3,\"type\":\"uint64\"},\"permission\":{\"id\":2,\"type\":\"uint64\"}}},\"EosActionVoteProducer\":{\"fields\":{\"producers\":{\"id\":3,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint64\"},\"proxy\":{\"id\":2,\"type\":\"uint64\"},\"voter\":{\"id\":1,\"type\":\"uint64\"}}},\"EosAsset\":{\"fields\":{\"amount\":{\"id\":1,\"type\":\"sint64\"},\"symbol\":{\"id\":2,\"type\":\"uint64\"}}},\"EosAuthorization\":{\"fields\":{\"accounts\":{\"id\":3,\"rule\":\"repeated\",\"type\":\"EosAuthorizationAccount\"},\"keys\":{\"id\":2,\"rule\":\"repeated\",\"type\":\"EosAuthorizationKey\"},\"threshold\":{\"id\":1,\"type\":\"uint32\"},\"waits\":{\"id\":4,\"rule\":\"repeated\",\"type\":\"EosAuthorizationWait\"}}},\"EosAuthorizationAccount\":{\"fields\":{\"account\":{\"id\":1,\"type\":\"EosPermissionLevel\"},\"weight\":{\"id\":2,\"type\":\"uint32\"}}},\"EosAuthorizationKey\":{\"fields\":{\"address_n\":{\"id\":3,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"key\":{\"id\":2,\"type\":\"bytes\"},\"type\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint32\"},\"weight\":{\"id\":4,\"rule\":\"required\",\"type\":\"uint32\"}}},\"EosAuthorizationWait\":{\"fields\":{\"wait_sec\":{\"id\":1,\"type\":\"uint32\"},\"weight\":{\"id\":2,\"type\":\"uint32\"}}},\"EosPermissionLevel\":{\"fields\":{\"actor\":{\"id\":1,\"type\":\"uint64\"},\"permission\":{\"id\":2,\"type\":\"uint64\"}}}}},\"EosTxActionRequest\":{\"fields\":{\"data_size\":{\"id\":1,\"type\":\"uint32\"}}},\"EthereumAddress\":{\"fields\":{\"_old_address\":{\"id\":1,\"options\":{\"deprecated\":true},\"type\":\"bytes\"},\"address\":{\"id\":2,\"type\":\"string\"}}},\"EthereumGetAddress\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"chain_id\":{\"id\":3,\"type\":\"uint64\"},\"show_display\":{\"id\":2,\"type\":\"bool\"}}},\"EthereumGetPublicKey\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"chain_id\":{\"id\":3,\"type\":\"uint64\"},\"show_display\":{\"id\":2,\"type\":\"bool\"}}},\"EthereumMessageSignature\":{\"fields\":{\"address\":{\"id\":3,\"rule\":\"required\",\"type\":\"string\"},\"signature\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"EthereumPublicKey\":{\"fields\":{\"node\":{\"id\":1,\"rule\":\"required\",\"type\":\"HDNodeType\"},\"xpub\":{\"id\":2,\"rule\":\"required\",\"type\":\"string\"}}},\"EthereumSignMessage\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"chain_id\":{\"id\":3,\"type\":\"uint64\"},\"message\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"EthereumSignMessageEIP712\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"domain_hash\":{\"id\":2,\"type\":\"bytes\"},\"message_hash\":{\"id\":3,\"type\":\"bytes\"}}},\"EthereumSignTx\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"chain_id\":{\"id\":9,\"rule\":\"required\",\"type\":\"uint64\"},\"data_initial_chunk\":{\"id\":7,\"options\":{\"default\":\"\"},\"type\":\"bytes\"},\"data_length\":{\"id\":8,\"options\":{\"default\":0},\"type\":\"uint32\"},\"gas_limit\":{\"id\":4,\"rule\":\"required\",\"type\":\"bytes\"},\"gas_price\":{\"id\":3,\"rule\":\"required\",\"type\":\"bytes\"},\"nonce\":{\"id\":2,\"options\":{\"default\":\"\"},\"type\":\"bytes\"},\"to\":{\"id\":11,\"options\":{\"default\":\"\"},\"type\":\"string\"},\"tx_type\":{\"id\":10,\"type\":\"uint32\"},\"value\":{\"id\":6,\"options\":{\"default\":\"\"},\"type\":\"bytes\"}}},\"EthereumSignTxEIP1559\":{\"fields\":{\"access_list\":{\"id\":11,\"rule\":\"repeated\",\"type\":\"EthereumAccessList\"},\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"chain_id\":{\"id\":10,\"rule\":\"required\",\"type\":\"uint64\"},\"data_initial_chunk\":{\"id\":8,\"options\":{\"default\":\"\"},\"type\":\"bytes\"},\"data_length\":{\"id\":9,\"rule\":\"required\",\"type\":\"uint32\"},\"gas_limit\":{\"id\":5,\"rule\":\"required\",\"type\":\"bytes\"},\"max_gas_fee\":{\"id\":3,\"rule\":\"required\",\"type\":\"bytes\"},\"max_priority_fee\":{\"id\":4,\"rule\":\"required\",\"type\":\"bytes\"},\"nonce\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"},\"to\":{\"id\":6,\"options\":{\"default\":\"\"},\"type\":\"string\"},\"value\":{\"id\":7,\"rule\":\"required\",\"type\":\"bytes\"}},\"nested\":{\"EthereumAccessList\":{\"fields\":{\"address\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"},\"storage_keys\":{\"id\":2,\"rule\":\"repeated\",\"type\":\"bytes\"}}}}},\"EthereumSignTypedData\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"chain_id\":{\"id\":4,\"type\":\"uint64\"},\"metamask_v4_compat\":{\"id\":3,\"options\":{\"default\":true},\"type\":\"bool\"},\"primary_type\":{\"id\":2,\"rule\":\"required\",\"type\":\"string\"}}},\"EthereumSignTypedHash\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"chain_id\":{\"id\":4,\"type\":\"uint64\"},\"domain_separator_hash\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"},\"message_hash\":{\"id\":3,\"type\":\"bytes\"}}},\"EthereumTxAck\":{\"fields\":{\"data_chunk\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"EthereumTxRequest\":{\"fields\":{\"data_length\":{\"id\":1,\"type\":\"uint32\"},\"signature_r\":{\"id\":3,\"type\":\"bytes\"},\"signature_s\":{\"id\":4,\"type\":\"bytes\"},\"signature_v\":{\"id\":2,\"type\":\"uint32\"}}},\"EthereumTypedDataSignature\":{\"fields\":{\"address\":{\"id\":2,\"rule\":\"required\",\"type\":\"string\"},\"signature\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"EthereumTypedDataStructAck\":{\"fields\":{\"members\":{\"id\":1,\"rule\":\"repeated\",\"type\":\"EthereumStructMember\"}},\"nested\":{\"EthereumDataType\":{\"values\":{\"ADDRESS\":6,\"ARRAY\":7,\"BOOL\":5,\"BYTES\":3,\"INT\":2,\"STRING\":4,\"STRUCT\":8,\"UINT\":1}},\"EthereumFieldType\":{\"fields\":{\"data_type\":{\"id\":1,\"rule\":\"required\",\"type\":\"EthereumDataType\"},\"entry_type\":{\"id\":3,\"type\":\"EthereumFieldType\"},\"size\":{\"id\":2,\"type\":\"uint32\"},\"struct_name\":{\"id\":4,\"type\":\"string\"}}},\"EthereumStructMember\":{\"fields\":{\"name\":{\"id\":2,\"rule\":\"required\",\"type\":\"string\"},\"type\":{\"id\":1,\"rule\":\"required\",\"type\":\"EthereumFieldType\"}}}}},\"EthereumTypedDataStructRequest\":{\"fields\":{\"name\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"}}},\"EthereumTypedDataValueAck\":{\"fields\":{\"value\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"EthereumTypedDataValueRequest\":{\"fields\":{\"member_path\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"}}},\"EthereumVerifyMessage\":{\"fields\":{\"address\":{\"id\":4,\"rule\":\"required\",\"type\":\"string\"},\"chain_id\":{\"id\":5,\"type\":\"uint64\"},\"message\":{\"id\":3,\"rule\":\"required\",\"type\":\"bytes\"},\"signature\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"Failure\":{\"fields\":{\"code\":{\"id\":1,\"type\":\"FailureType\"},\"message\":{\"id\":2,\"type\":\"string\"}},\"nested\":{\"FailureType\":{\"values\":{\"Failure_ActionCancelled\":4,\"Failure_ButtonExpected\":2,\"Failure_DataError\":3,\"Failure_FirmwareError\":99,\"Failure_InvalidSession\":14,\"Failure_InvalidSignature\":8,\"Failure_NotEnoughFunds\":10,\"Failure_NotInitialized\":11,\"Failure_PinCancelled\":6,\"Failure_PinExpected\":5,\"Failure_PinInvalid\":7,\"Failure_PinMismatch\":12,\"Failure_ProcessError\":9,\"Failure_UnexpectedMessage\":1,\"Failure_WipeCodeMismatch\":13}}}},\"Features\":{\"fields\":{\"NFT_voucher\":{\"id\":514,\"type\":\"bytes\"},\"_passphrase_cached\":{\"id\":17,\"options\":{\"deprecated\":true},\"type\":\"bool\"},\"auto_lock_delay_ms\":{\"id\":38,\"type\":\"uint32\"},\"auto_shutdown_delay_ms\":{\"id\":523,\"type\":\"uint32\"},\"backup_only\":{\"id\":507,\"type\":\"bool\"},\"backup_type\":{\"id\":31,\"type\":\"BackupType\"},\"battery_level\":{\"id\":520,\"type\":\"uint32\"},\"ble_enable\":{\"id\":503,\"type\":\"bool\"},\"ble_name\":{\"id\":501,\"type\":\"string\"},\"ble_ver\":{\"id\":502,\"type\":\"string\"},\"bootloader_hash\":{\"id\":14,\"type\":\"bytes\"},\"bootloader_mode\":{\"id\":5,\"type\":\"bool\"},\"bootloader_version\":{\"id\":510,\"type\":\"string\"},\"brightness_prcent\":{\"id\":521,\"type\":\"uint32\"},\"build_id\":{\"id\":518,\"type\":\"string\"},\"capabilities\":{\"id\":30,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"Capability\"},\"coin_switch\":{\"id\":517,\"type\":\"uint32\"},\"cpu_info\":{\"id\":515,\"type\":\"string\"},\"device_id\":{\"id\":6,\"type\":\"string\"},\"display_rotation\":{\"id\":39,\"type\":\"uint32\"},\"experimental_features\":{\"id\":40,\"type\":\"bool\"},\"firmware_present\":{\"id\":18,\"type\":\"bool\"},\"flags\":{\"id\":20,\"type\":\"uint32\"},\"fw_major\":{\"id\":22,\"type\":\"uint32\"},\"fw_minor\":{\"id\":23,\"type\":\"uint32\"},\"fw_patch\":{\"id\":24,\"type\":\"uint32\"},\"fw_vendor\":{\"id\":25,\"type\":\"string\"},\"fw_vendor_keys\":{\"id\":26,\"type\":\"bytes\"},\"haptic_feedback\":{\"id\":522,\"type\":\"bool\"},\"imported\":{\"id\":15,\"type\":\"bool\"},\"initialized\":{\"id\":12,\"type\":\"bool\"},\"initstates\":{\"id\":513,\"type\":\"uint32\"},\"label\":{\"id\":10,\"type\":\"string\"},\"language\":{\"id\":9,\"type\":\"string\"},\"major_version\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint32\"},\"minor_version\":{\"id\":3,\"rule\":\"required\",\"type\":\"uint32\"},\"model\":{\"id\":21,\"type\":\"string\"},\"needs_backup\":{\"id\":19,\"type\":\"bool\"},\"no_backup\":{\"id\":28,\"type\":\"bool\"},\"offset\":{\"id\":500,\"type\":\"uint32\"},\"onekey_serial\":{\"id\":509,\"type\":\"string\"},\"onekey_version\":{\"id\":508,\"type\":\"string\"},\"passphrase_always_on_device\":{\"id\":36,\"type\":\"bool\"},\"passphrase_protection\":{\"id\":8,\"type\":\"bool\"},\"patch_version\":{\"id\":4,\"rule\":\"required\",\"type\":\"uint32\"},\"pin_protection\":{\"id\":7,\"type\":\"bool\"},\"pre_firmware\":{\"id\":516,\"type\":\"string\"},\"recovery_mode\":{\"id\":29,\"type\":\"bool\"},\"revision\":{\"id\":13,\"type\":\"bytes\"},\"safety_checks\":{\"id\":37,\"type\":\"SafetyCheckLevel\"},\"sd_card_present\":{\"id\":32,\"type\":\"bool\"},\"sd_protection\":{\"id\":33,\"type\":\"bool\"},\"se_enable\":{\"id\":504,\"type\":\"bool\"},\"se_ver\":{\"id\":506,\"type\":\"string\"},\"serial_no\":{\"id\":511,\"type\":\"string\"},\"session_id\":{\"id\":35,\"type\":\"bytes\"},\"spi_flash\":{\"id\":512,\"type\":\"string\"},\"unfinished_backup\":{\"id\":27,\"type\":\"bool\"},\"unlocked\":{\"id\":16,\"type\":\"bool\"},\"vendor\":{\"id\":1,\"type\":\"string\"},\"wipe_code_protection\":{\"id\":34,\"type\":\"bool\"}},\"nested\":{\"Capability\":{\"options\":{\"(has_bitcoin_only_values)\":true},\"values\":{\"Capability_Binance\":3,\"Capability_Bitcoin\":1,\"Capability_Bitcoin_like\":2,\"Capability_Cardano\":4,\"Capability_Crypto\":5,\"Capability_EOS\":6,\"Capability_Ethereum\":7,\"Capability_Lisk\":8,\"Capability_Monero\":9,\"Capability_NEM\":10,\"Capability_PassphraseEntry\":17,\"Capability_Ripple\":11,\"Capability_Shamir\":15,\"Capability_ShamirGroups\":16,\"Capability_Stellar\":12,\"Capability_Tezos\":13,\"Capability_U2F\":14}}}},\"FileInfoList\":{\"fields\":{\"files\":{\"id\":1,\"rule\":\"repeated\",\"type\":\"FileInfo\"}},\"nested\":{\"FileInfo\":{\"fields\":{\"name\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"},\"size\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint64\"}}}}},\"FilecoinAddress\":{\"fields\":{\"address\":{\"id\":1,\"type\":\"string\"}}},\"FilecoinGetAddress\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"show_display\":{\"id\":2,\"type\":\"bool\"},\"testnet\":{\"id\":3,\"type\":\"bool\"}}},\"FilecoinSignTx\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"raw_tx\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"},\"testnet\":{\"id\":3,\"type\":\"bool\"}}},\"FilecoinSignedTx\":{\"fields\":{\"signature\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"FirmwareErase\":{\"fields\":{\"length\":{\"id\":1,\"type\":\"uint32\"}}},\"FirmwareErase_ex\":{\"fields\":{\"length\":{\"id\":1,\"type\":\"uint32\"}}},\"FirmwareRequest\":{\"fields\":{\"length\":{\"id\":2,\"type\":\"uint32\"},\"offset\":{\"id\":1,\"type\":\"uint32\"}}},\"FirmwareUpdateEmmc\":{\"fields\":{\"path\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"},\"reboot_on_success\":{\"id\":2,\"type\":\"bool\"}}},\"FirmwareUpload\":{\"fields\":{\"hash\":{\"id\":2,\"type\":\"bytes\"},\"payload\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"GetAddress\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"coin_name\":{\"id\":2,\"options\":{\"default\":\"Bitcoin\"},\"type\":\"string\"},\"ignore_xpub_magic\":{\"id\":6,\"type\":\"bool\"},\"multisig\":{\"id\":4,\"type\":\"MultisigRedeemScriptType\"},\"script_type\":{\"id\":5,\"options\":{\"default\":\"SPENDADDRESS\"},\"type\":\"InputScriptType\"},\"show_display\":{\"id\":3,\"type\":\"bool\"}}},\"GetDeviceInfo\":{\"fields\":{}},\"GetECDHSessionKey\":{\"fields\":{\"ecdsa_curve_name\":{\"id\":3,\"type\":\"string\"},\"identity\":{\"id\":1,\"rule\":\"required\",\"type\":\"IdentityType\"},\"peer_public_key\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"GetEntropy\":{\"fields\":{\"size\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint32\"}}},\"GetFeatures\":{\"fields\":{}},\"GetNextU2FCounter\":{\"fields\":{}},\"GetOwnershipId\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"coin_name\":{\"id\":2,\"options\":{\"default\":\"Bitcoin\"},\"type\":\"string\"},\"multisig\":{\"id\":3,\"type\":\"MultisigRedeemScriptType\"},\"script_type\":{\"id\":4,\"options\":{\"default\":\"SPENDADDRESS\"},\"type\":\"InputScriptType\"}}},\"GetOwnershipProof\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"coin_name\":{\"id\":2,\"options\":{\"default\":\"Bitcoin\"},\"type\":\"string\"},\"commitment_data\":{\"id\":7,\"options\":{\"default\":\"\"},\"type\":\"bytes\"},\"multisig\":{\"id\":4,\"type\":\"MultisigRedeemScriptType\"},\"ownership_ids\":{\"id\":6,\"rule\":\"repeated\",\"type\":\"bytes\"},\"script_type\":{\"id\":3,\"options\":{\"default\":\"SPENDWITNESS\"},\"type\":\"InputScriptType\"},\"user_confirmation\":{\"id\":5,\"options\":{\"default\":false},\"type\":\"bool\"}}},\"GetPublicKey\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"coin_name\":{\"id\":4,\"options\":{\"default\":\"Bitcoin\"},\"type\":\"string\"},\"ecdsa_curve_name\":{\"id\":2,\"type\":\"string\"},\"ignore_xpub_magic\":{\"id\":6,\"type\":\"bool\"},\"script_type\":{\"id\":5,\"options\":{\"default\":\"SPENDADDRESS\"},\"type\":\"InputScriptType\"},\"show_display\":{\"id\":3,\"type\":\"bool\"}}},\"GetPublicKeyMultiple\":{\"fields\":{\"addresses\":{\"id\":1,\"rule\":\"repeated\",\"type\":\"BIP32Address\"},\"coin_name\":{\"id\":4,\"options\":{\"default\":\"Bitcoin\"},\"type\":\"string\"},\"ecdsa_curve_name\":{\"id\":2,\"type\":\"string\"},\"ignore_xpub_magic\":{\"id\":6,\"type\":\"bool\"},\"script_type\":{\"id\":5,\"options\":{\"default\":\"SPENDADDRESS\"},\"type\":\"InputScriptType\"},\"show_display\":{\"id\":3,\"type\":\"bool\"}},\"nested\":{\"BIP32Address\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"}}}}},\"HDNodeType\":{\"fields\":{\"chain_code\":{\"id\":4,\"rule\":\"required\",\"type\":\"bytes\"},\"child_num\":{\"id\":3,\"rule\":\"required\",\"type\":\"uint32\"},\"depth\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint32\"},\"fingerprint\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint32\"},\"private_key\":{\"id\":5,\"type\":\"bytes\"},\"public_key\":{\"id\":6,\"rule\":\"required\",\"type\":\"bytes\"}}},\"IdentityType\":{\"fields\":{\"host\":{\"id\":3,\"type\":\"string\"},\"index\":{\"id\":6,\"options\":{\"default\":0},\"type\":\"uint32\"},\"path\":{\"id\":5,\"type\":\"string\"},\"port\":{\"id\":4,\"type\":\"string\"},\"proto\":{\"id\":1,\"type\":\"string\"},\"user\":{\"id\":2,\"type\":\"string\"}}},\"Initialize\":{\"fields\":{\"_skip_passphrase\":{\"id\":2,\"options\":{\"deprecated\":true},\"type\":\"bool\"},\"derive_cardano\":{\"id\":3,\"type\":\"bool\"},\"session_id\":{\"id\":1,\"type\":\"bytes\"}}},\"InputScriptType\":{\"values\":{\"EXTERNAL\":2,\"SPENDADDRESS\":0,\"SPENDMULTISIG\":1,\"SPENDP2SHWITNESS\":4,\"SPENDTAPROOT\":5,\"SPENDWITNESS\":3}},\"KaspaAddress\":{\"fields\":{\"address\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"}}},\"KaspaGetAddress\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"prefix\":{\"id\":3,\"options\":{\"default\":\"kaspa\"},\"type\":\"string\"},\"scheme\":{\"id\":4,\"options\":{\"default\":\"schnorr\"},\"type\":\"string\"},\"show_display\":{\"id\":2,\"type\":\"bool\"}}},\"KaspaSignTx\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"input_count\":{\"id\":5,\"options\":{\"default\":1},\"type\":\"uint32\"},\"prefix\":{\"id\":4,\"options\":{\"default\":\"kaspa\"},\"type\":\"string\"},\"raw_message\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"},\"scheme\":{\"id\":3,\"options\":{\"default\":\"schnorr\"},\"type\":\"string\"}}},\"KaspaSignedTx\":{\"fields\":{\"signature\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"KaspaTxInputAck\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"raw_message\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"KaspaTxInputRequest\":{\"fields\":{\"request_index\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint32\"},\"signature\":{\"id\":2,\"type\":\"bytes\"}}},\"ListResDir\":{\"fields\":{\"path\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"}}},\"LoadDevice\":{\"fields\":{\"label\":{\"id\":6,\"type\":\"string\"},\"language\":{\"id\":5,\"options\":{\"default\":\"en-US\"},\"type\":\"string\"},\"mnemonics\":{\"id\":1,\"rule\":\"repeated\",\"type\":\"string\"},\"needs_backup\":{\"id\":9,\"type\":\"bool\"},\"no_backup\":{\"id\":10,\"type\":\"bool\"},\"passphrase_protection\":{\"id\":4,\"type\":\"bool\"},\"pin\":{\"id\":3,\"type\":\"string\"},\"skip_checksum\":{\"id\":7,\"type\":\"bool\"},\"u2f_counter\":{\"id\":8,\"type\":\"uint32\"}}},\"LockDevice\":{\"fields\":{}},\"MessageSignature\":{\"fields\":{\"address\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"},\"signature\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"MessageType\":{\"options\":{\"(has_bitcoin_only_values)\":true},\"values\":{\"MessageType_Address\":30,\"MessageType_AlgorandAddress\":10901,\"MessageType_AlgorandGetAddress\":10900,\"MessageType_AlgorandSignTx\":10902,\"MessageType_AlgorandSignedTx\":10903,\"MessageType_ApplyFlags\":28,\"MessageType_ApplySettings\":25,\"MessageType_AptosAddress\":10601,\"MessageType_AptosGetAddress\":10600,\"MessageType_AptosMessageSignature\":10605,\"MessageType_AptosSignMessage\":10604,\"MessageType_AptosSignTx\":10602,\"MessageType_AptosSignedTx\":10603,\"MessageType_AuthorizeCoinJoin\":51,\"MessageType_BackupDevice\":34,\"MessageType_BatchGetPublickeys\":10016,\"MessageType_BinanceAddress\":701,\"MessageType_BinanceCancelMsg\":708,\"MessageType_BinanceGetAddress\":700,\"MessageType_BinanceGetPublicKey\":702,\"MessageType_BinanceOrderMsg\":707,\"MessageType_BinancePublicKey\":703,\"MessageType_BinanceSignTx\":704,\"MessageType_BinanceSignedTx\":709,\"MessageType_BinanceTransferMsg\":706,\"MessageType_BinanceTxRequest\":705,\"MessageType_BixinBackupAck\":906,\"MessageType_BixinBackupDevice\":914,\"MessageType_BixinBackupDeviceAck\":915,\"MessageType_BixinBackupRequest\":905,\"MessageType_BixinLoadDevice\":913,\"MessageType_BixinMessageSE\":902,\"MessageType_BixinOutMessageSE\":904,\"MessageType_BixinPinInputOnDevice\":10000,\"MessageType_BixinRestoreAck\":908,\"MessageType_BixinRestoreRequest\":907,\"MessageType_BixinSeedOperate\":901,\"MessageType_BixinVerifyDeviceAck\":910,\"MessageType_BixinVerifyDeviceRequest\":909,\"MessageType_BixinWhiteListAck\":912,\"MessageType_BixinWhiteListRequest\":911,\"MessageType_ButtonAck\":27,\"MessageType_ButtonRequest\":26,\"MessageType_Cancel\":20,\"MessageType_CancelAuthorization\":86,\"MessageType_CardanoAddress\":308,\"MessageType_CardanoAssetGroup\":323,\"MessageType_CardanoGetAddress\":307,\"MessageType_CardanoGetNativeScriptHash\":330,\"MessageType_CardanoGetPublicKey\":305,\"MessageType_CardanoMessageSignature\":351,\"MessageType_CardanoNativeScriptHash\":331,\"MessageType_CardanoPoolOwner\":328,\"MessageType_CardanoPoolRelayParameters\":329,\"MessageType_CardanoPublicKey\":306,\"MessageType_CardanoSignMessage\":350,\"MessageType_CardanoSignTxFinished\":319,\"MessageType_CardanoSignTxInit\":320,\"MessageType_CardanoToken\":324,\"MessageType_CardanoTxAuxiliaryData\":327,\"MessageType_CardanoTxAuxiliaryDataSupplement\":314,\"MessageType_CardanoTxBodyHash\":318,\"MessageType_CardanoTxCertificate\":325,\"MessageType_CardanoTxCollateralInput\":333,\"MessageType_CardanoTxHostAck\":317,\"MessageType_CardanoTxInlineDatumChunk\":335,\"MessageType_CardanoTxInput\":321,\"MessageType_CardanoTxItemAck\":313,\"MessageType_CardanoTxMint\":332,\"MessageType_CardanoTxOutput\":322,\"MessageType_CardanoTxReferenceInput\":337,\"MessageType_CardanoTxReferenceScriptChunk\":336,\"MessageType_CardanoTxRequiredSigner\":334,\"MessageType_CardanoTxWithdrawal\":326,\"MessageType_CardanoTxWitnessRequest\":315,\"MessageType_CardanoTxWitnessResponse\":316,\"MessageType_ChangePin\":4,\"MessageType_ChangeWipeCode\":82,\"MessageType_CipherKeyValue\":23,\"MessageType_CipheredKeyValue\":48,\"MessageType_ConfluxAddress\":10113,\"MessageType_ConfluxGetAddress\":10112,\"MessageType_ConfluxMessageSignature\":10119,\"MessageType_ConfluxSignMessage\":10117,\"MessageType_ConfluxSignMessageCIP23\":10118,\"MessageType_ConfluxSignTx\":10114,\"MessageType_ConfluxTxAck\":10116,\"MessageType_ConfluxTxRequest\":10115,\"MessageType_CosiCommit\":71,\"MessageType_CosiCommitment\":72,\"MessageType_CosiSign\":73,\"MessageType_CosiSignature\":74,\"MessageType_CosmosAddress\":10801,\"MessageType_CosmosGetAddress\":10800,\"MessageType_CosmosSignTx\":10802,\"MessageType_CosmosSignedTx\":10803,\"MessageType_DebugLinkDecision\":100,\"MessageType_DebugLinkEraseSdCard\":9005,\"MessageType_DebugLinkFlashErase\":113,\"MessageType_DebugLinkGetState\":101,\"MessageType_DebugLinkLayout\":9001,\"MessageType_DebugLinkLog\":104,\"MessageType_DebugLinkMemory\":111,\"MessageType_DebugLinkMemoryRead\":110,\"MessageType_DebugLinkMemoryWrite\":112,\"MessageType_DebugLinkRecordScreen\":9003,\"MessageType_DebugLinkReseedRandom\":9002,\"MessageType_DebugLinkState\":102,\"MessageType_DebugLinkStop\":103,\"MessageType_DebugLinkWatchLayout\":9006,\"MessageType_DebugMoneroDiagAck\":547,\"MessageType_DebugMoneroDiagRequest\":546,\"MessageType_Deprecated_PassphraseStateAck\":78,\"MessageType_Deprecated_PassphraseStateRequest\":77,\"MessageType_DeviceBackToBoot\":903,\"MessageType_DeviceEraseSector\":10026,\"MessageType_DeviceInfo\":10003,\"MessageType_DeviceInfoSettings\":10001,\"MessageType_DoPreauthorized\":84,\"MessageType_ECDHSessionKey\":62,\"MessageType_EcdsaPublicKeys\":10017,\"MessageType_EmmcDir\":30107,\"MessageType_EmmcDirList\":30108,\"MessageType_EmmcDirMake\":30109,\"MessageType_EmmcDirRemove\":30110,\"MessageType_EmmcFile\":30103,\"MessageType_EmmcFileDelete\":30106,\"MessageType_EmmcFileRead\":30104,\"MessageType_EmmcFileWrite\":30105,\"MessageType_EmmcFixPermission\":30100,\"MessageType_EmmcPath\":30101,\"MessageType_EmmcPathInfo\":30102,\"MessageType_EndSession\":83,\"MessageType_Entropy\":10,\"MessageType_EntropyAck\":36,\"MessageType_EntropyRequest\":35,\"MessageType_EosGetPublicKey\":600,\"MessageType_EosPublicKey\":601,\"MessageType_EosSignTx\":602,\"MessageType_EosSignedTx\":605,\"MessageType_EosTxActionAck\":604,\"MessageType_EosTxActionRequest\":603,\"MessageType_EthereumAddress\":57,\"MessageType_EthereumGetAddress\":56,\"MessageType_EthereumGetPublicKey\":450,\"MessageType_EthereumMessageSignature\":66,\"MessageType_EthereumPublicKey\":451,\"MessageType_EthereumSignMessage\":64,\"MessageType_EthereumSignMessageEIP712\":10200,\"MessageType_EthereumSignTx\":58,\"MessageType_EthereumSignTxEIP1559\":452,\"MessageType_EthereumSignTypedData\":464,\"MessageType_EthereumSignTypedHash\":470,\"MessageType_EthereumTxAck\":60,\"MessageType_EthereumTxRequest\":59,\"MessageType_EthereumTypedDataSignature\":469,\"MessageType_EthereumTypedDataStructAck\":466,\"MessageType_EthereumTypedDataStructRequest\":465,\"MessageType_EthereumTypedDataValueAck\":468,\"MessageType_EthereumTypedDataValueRequest\":467,\"MessageType_EthereumVerifyMessage\":65,\"MessageType_Failure\":3,\"MessageType_Features\":17,\"MessageType_FileInfoList\":10024,\"MessageType_FilecoinAddress\":11201,\"MessageType_FilecoinGetAddress\":11200,\"MessageType_FilecoinSignTx\":11202,\"MessageType_FilecoinSignedTx\":11203,\"MessageType_FirmwareErase\":6,\"MessageType_FirmwareErase_ex\":16,\"MessageType_FirmwareRequest\":8,\"MessageType_FirmwareUpdateEmmc\":30001,\"MessageType_FirmwareUpload\":7,\"MessageType_GetAddress\":29,\"MessageType_GetDeviceInfo\":10002,\"MessageType_GetECDHSessionKey\":61,\"MessageType_GetEntropy\":9,\"MessageType_GetFeatures\":55,\"MessageType_GetNextU2FCounter\":80,\"MessageType_GetOwnershipId\":43,\"MessageType_GetOwnershipProof\":49,\"MessageType_GetPublicKey\":11,\"MessageType_GetPublicKeyMultiple\":10210,\"MessageType_Initialize\":0,\"MessageType_KaspaAddress\":11301,\"MessageType_KaspaGetAddress\":11300,\"MessageType_KaspaSignTx\":11302,\"MessageType_KaspaSignedTx\":11303,\"MessageType_KaspaTxInputAck\":11305,\"MessageType_KaspaTxInputRequest\":11304,\"MessageType_ListResDir\":10023,\"MessageType_LoadDevice\":13,\"MessageType_LockDevice\":24,\"MessageType_MessageSignature\":40,\"MessageType_MoneroAddress\":541,\"MessageType_MoneroGetAddress\":540,\"MessageType_MoneroGetTxKeyAck\":551,\"MessageType_MoneroGetTxKeyRequest\":550,\"MessageType_MoneroGetWatchKey\":542,\"MessageType_MoneroKeyImageExportInitAck\":531,\"MessageType_MoneroKeyImageExportInitRequest\":530,\"MessageType_MoneroKeyImageSyncFinalAck\":535,\"MessageType_MoneroKeyImageSyncFinalRequest\":534,\"MessageType_MoneroKeyImageSyncStepAck\":533,\"MessageType_MoneroKeyImageSyncStepRequest\":532,\"MessageType_MoneroLiveRefreshFinalAck\":557,\"MessageType_MoneroLiveRefreshFinalRequest\":556,\"MessageType_MoneroLiveRefreshStartAck\":553,\"MessageType_MoneroLiveRefreshStartRequest\":552,\"MessageType_MoneroLiveRefreshStepAck\":555,\"MessageType_MoneroLiveRefreshStepRequest\":554,\"MessageType_MoneroTransactionAllInputsSetAck\":510,\"MessageType_MoneroTransactionAllInputsSetRequest\":509,\"MessageType_MoneroTransactionAllOutSetAck\":514,\"MessageType_MoneroTransactionAllOutSetRequest\":513,\"MessageType_MoneroTransactionFinalAck\":518,\"MessageType_MoneroTransactionFinalRequest\":517,\"MessageType_MoneroTransactionInitAck\":502,\"MessageType_MoneroTransactionInitRequest\":501,\"MessageType_MoneroTransactionInputViniAck\":508,\"MessageType_MoneroTransactionInputViniRequest\":507,\"MessageType_MoneroTransactionInputsPermutationAck\":506,\"MessageType_MoneroTransactionInputsPermutationRequest\":505,\"MessageType_MoneroTransactionSetInputAck\":504,\"MessageType_MoneroTransactionSetInputRequest\":503,\"MessageType_MoneroTransactionSetOutputAck\":512,\"MessageType_MoneroTransactionSetOutputRequest\":511,\"MessageType_MoneroTransactionSignInputAck\":516,\"MessageType_MoneroTransactionSignInputRequest\":515,\"MessageType_MoneroWatchKey\":543,\"MessageType_NEMAddress\":68,\"MessageType_NEMDecryptMessage\":75,\"MessageType_NEMDecryptedMessage\":76,\"MessageType_NEMGetAddress\":67,\"MessageType_NEMSignTx\":69,\"MessageType_NEMSignedTx\":70,\"MessageType_NFTWriteData\":10015,\"MessageType_NFTWriteInfo\":10014,\"MessageType_NearAddress\":10702,\"MessageType_NearGetAddress\":10701,\"MessageType_NearSignTx\":10703,\"MessageType_NearSignedTx\":10704,\"MessageType_NexaAddress\":11401,\"MessageType_NexaGetAddress\":11400,\"MessageType_NexaSignTx\":11402,\"MessageType_NexaSignedTx\":11403,\"MessageType_NexaTxInputAck\":11405,\"MessageType_NexaTxInputRequest\":11404,\"MessageType_NextU2FCounter\":81,\"MessageType_OwnershipId\":44,\"MessageType_OwnershipProof\":50,\"MessageType_PassphraseAck\":42,\"MessageType_PassphraseRequest\":41,\"MessageType_PinMatrixAck\":19,\"MessageType_PinMatrixRequest\":18,\"MessageType_Ping\":1,\"MessageType_PolkadotAddress\":11001,\"MessageType_PolkadotGetAddress\":11000,\"MessageType_PolkadotSignTx\":11002,\"MessageType_PolkadotSignedTx\":11003,\"MessageType_PreauthorizedRequest\":85,\"MessageType_PublicKey\":12,\"MessageType_PublicKeyMultiple\":10211,\"MessageType_ReadSEPublicCert\":10007,\"MessageType_ReadSEPublicKey\":10004,\"MessageType_Reboot\":30000,\"MessageType_RebootToBoardloader\":10025,\"MessageType_RebootToBootloader\":87,\"MessageType_RecoveryDevice\":45,\"MessageType_ResetDevice\":14,\"MessageType_ResourceAck\":10021,\"MessageType_ResourceRequest\":10020,\"MessageType_ResourceUpdate\":10022,\"MessageType_ResourceUpload\":10018,\"MessageType_RippleAddress\":401,\"MessageType_RippleGetAddress\":400,\"MessageType_RippleSignTx\":402,\"MessageType_RippleSignedTx\":403,\"MessageType_SEMessageSignature\":10013,\"MessageType_SEPublicCert\":10008,\"MessageType_SEPublicKey\":10005,\"MessageType_SESignMessage\":10012,\"MessageType_SdProtect\":79,\"MessageType_SelfTest\":32,\"MessageType_SetU2FCounter\":63,\"MessageType_SignIdentity\":53,\"MessageType_SignMessage\":38,\"MessageType_SignTx\":15,\"MessageType_SignedIdentity\":54,\"MessageType_SolanaAddress\":10101,\"MessageType_SolanaGetAddress\":10100,\"MessageType_SolanaSignTx\":10102,\"MessageType_SolanaSignedTx\":10103,\"MessageType_SpiFlashData\":10011,\"MessageType_SpiFlashRead\":10010,\"MessageType_SpiFlashWrite\":10009,\"MessageType_StarcoinAddress\":10301,\"MessageType_StarcoinGetAddress\":10300,\"MessageType_StarcoinGetPublicKey\":10302,\"MessageType_StarcoinMessageSignature\":10307,\"MessageType_StarcoinPublicKey\":10303,\"MessageType_StarcoinSignMessage\":10306,\"MessageType_StarcoinSignTx\":10304,\"MessageType_StarcoinSignedTx\":10305,\"MessageType_StarcoinVerifyMessage\":10308,\"MessageType_StellarAccountMergeOp\":218,\"MessageType_StellarAddress\":208,\"MessageType_StellarAllowTrustOp\":217,\"MessageType_StellarBumpSequenceOp\":221,\"MessageType_StellarChangeTrustOp\":216,\"MessageType_StellarCreateAccountOp\":210,\"MessageType_StellarCreatePassiveSellOfferOp\":214,\"MessageType_StellarGetAddress\":207,\"MessageType_StellarManageBuyOfferOp\":222,\"MessageType_StellarManageDataOp\":220,\"MessageType_StellarManageSellOfferOp\":213,\"MessageType_StellarPathPaymentStrictReceiveOp\":212,\"MessageType_StellarPathPaymentStrictSendOp\":223,\"MessageType_StellarPaymentOp\":211,\"MessageType_StellarSetOptionsOp\":215,\"MessageType_StellarSignTx\":202,\"MessageType_StellarSignedTx\":230,\"MessageType_StellarTxOpRequest\":203,\"MessageType_Success\":2,\"MessageType_SuiAddress\":11101,\"MessageType_SuiGetAddress\":11100,\"MessageType_SuiSignTx\":11102,\"MessageType_SuiSignedTx\":11103,\"MessageType_TezosAddress\":151,\"MessageType_TezosGetAddress\":150,\"MessageType_TezosGetPublicKey\":154,\"MessageType_TezosPublicKey\":155,\"MessageType_TezosSignTx\":152,\"MessageType_TezosSignedTx\":153,\"MessageType_TronAddress\":10502,\"MessageType_TronGetAddress\":10501,\"MessageType_TronMessageSignature\":10506,\"MessageType_TronSignMessage\":10505,\"MessageType_TronSignTx\":10503,\"MessageType_TronSignedTx\":10504,\"MessageType_TxAck\":22,\"MessageType_TxRequest\":21,\"MessageType_VerifyMessage\":39,\"MessageType_WebAuthnAddResidentCredential\":802,\"MessageType_WebAuthnCredentials\":801,\"MessageType_WebAuthnListResidentCredentials\":800,\"MessageType_WebAuthnRemoveResidentCredential\":803,\"MessageType_WipeDevice\":5,\"MessageType_WordAck\":47,\"MessageType_WordRequest\":46,\"MessageType_WriteSEPublicCert\":10006,\"MessageType_ZoomRequest\":10019}},\"MoneroAddress\":{\"fields\":{\"address\":{\"id\":1,\"type\":\"bytes\"}}},\"MoneroGetAddress\":{\"fields\":{\"account\":{\"id\":4,\"type\":\"uint32\"},\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"minor\":{\"id\":5,\"type\":\"uint32\"},\"network_type\":{\"id\":3,\"type\":\"uint32\"},\"payment_id\":{\"id\":6,\"type\":\"bytes\"},\"show_display\":{\"id\":2,\"type\":\"bool\"}}},\"MoneroGetTxKeyAck\":{\"fields\":{\"salt\":{\"id\":1,\"type\":\"bytes\"},\"tx_derivations\":{\"id\":3,\"type\":\"bytes\"},\"tx_keys\":{\"id\":2,\"type\":\"bytes\"}}},\"MoneroGetTxKeyRequest\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"network_type\":{\"id\":2,\"type\":\"uint32\"},\"reason\":{\"id\":7,\"type\":\"uint32\"},\"salt1\":{\"id\":3,\"type\":\"bytes\"},\"salt2\":{\"id\":4,\"type\":\"bytes\"},\"tx_enc_keys\":{\"id\":5,\"type\":\"bytes\"},\"tx_prefix_hash\":{\"id\":6,\"type\":\"bytes\"},\"view_public_key\":{\"id\":8,\"type\":\"bytes\"}}},\"MoneroGetWatchKey\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"network_type\":{\"id\":2,\"type\":\"uint32\"}}},\"MoneroKeyImageExportInitAck\":{\"fields\":{}},\"MoneroKeyImageExportInitRequest\":{\"fields\":{\"address_n\":{\"id\":3,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"hash\":{\"id\":2,\"type\":\"bytes\"},\"network_type\":{\"id\":4,\"type\":\"uint32\"},\"num\":{\"id\":1,\"type\":\"uint64\"},\"subs\":{\"id\":5,\"rule\":\"repeated\",\"type\":\"MoneroSubAddressIndicesList\"}},\"nested\":{\"MoneroSubAddressIndicesList\":{\"fields\":{\"account\":{\"id\":1,\"type\":\"uint32\"},\"minor_indices\":{\"id\":2,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"}}}}},\"MoneroKeyImageSyncFinalAck\":{\"fields\":{\"enc_key\":{\"id\":1,\"type\":\"bytes\"}}},\"MoneroKeyImageSyncFinalRequest\":{\"fields\":{}},\"MoneroKeyImageSyncStepAck\":{\"fields\":{\"kis\":{\"id\":1,\"rule\":\"repeated\",\"type\":\"MoneroExportedKeyImage\"}},\"nested\":{\"MoneroExportedKeyImage\":{\"fields\":{\"blob\":{\"id\":3,\"type\":\"bytes\"},\"iv\":{\"id\":1,\"type\":\"bytes\"}}}}},\"MoneroKeyImageSyncStepRequest\":{\"fields\":{\"tdis\":{\"id\":1,\"rule\":\"repeated\",\"type\":\"MoneroTransferDetails\"}},\"nested\":{\"MoneroTransferDetails\":{\"fields\":{\"additional_tx_pub_keys\":{\"id\":3,\"rule\":\"repeated\",\"type\":\"bytes\"},\"internal_output_index\":{\"id\":4,\"type\":\"uint64\"},\"out_key\":{\"id\":1,\"type\":\"bytes\"},\"sub_addr_major\":{\"id\":5,\"type\":\"uint32\"},\"sub_addr_minor\":{\"id\":6,\"type\":\"uint32\"},\"tx_pub_key\":{\"id\":2,\"type\":\"bytes\"}}}}},\"MoneroLiveRefreshFinalAck\":{\"fields\":{}},\"MoneroLiveRefreshFinalRequest\":{\"fields\":{}},\"MoneroLiveRefreshStartAck\":{\"fields\":{}},\"MoneroLiveRefreshStartRequest\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"network_type\":{\"id\":2,\"type\":\"uint32\"}}},\"MoneroLiveRefreshStepAck\":{\"fields\":{\"key_image\":{\"id\":2,\"type\":\"bytes\"},\"salt\":{\"id\":1,\"type\":\"bytes\"}}},\"MoneroLiveRefreshStepRequest\":{\"fields\":{\"out_key\":{\"id\":1,\"type\":\"bytes\"},\"real_out_idx\":{\"id\":3,\"type\":\"uint64\"},\"recv_deriv\":{\"id\":2,\"type\":\"bytes\"},\"sub_addr_major\":{\"id\":4,\"type\":\"uint32\"},\"sub_addr_minor\":{\"id\":5,\"type\":\"uint32\"}}},\"MoneroTransactionAllInputsSetAck\":{\"fields\":{\"rsig_data\":{\"id\":1,\"type\":\"MoneroTransactionRsigData\"}}},\"MoneroTransactionAllInputsSetRequest\":{\"fields\":{}},\"MoneroTransactionAllOutSetAck\":{\"fields\":{\"extra\":{\"id\":1,\"type\":\"bytes\"},\"full_message_hash\":{\"id\":5,\"type\":\"bytes\"},\"rv\":{\"id\":4,\"type\":\"MoneroRingCtSig\"},\"tx_prefix_hash\":{\"id\":2,\"type\":\"bytes\"}},\"nested\":{\"MoneroRingCtSig\":{\"fields\":{\"message\":{\"id\":2,\"type\":\"bytes\"},\"rv_type\":{\"id\":3,\"type\":\"uint32\"},\"txn_fee\":{\"id\":1,\"type\":\"uint64\"}}}}},\"MoneroTransactionAllOutSetRequest\":{\"fields\":{\"rsig_data\":{\"id\":1,\"type\":\"MoneroTransactionRsigData\"}}},\"MoneroTransactionDestinationEntry\":{\"fields\":{\"addr\":{\"id\":2,\"type\":\"MoneroAccountPublicAddress\"},\"amount\":{\"id\":1,\"type\":\"uint64\"},\"is_integrated\":{\"id\":5,\"type\":\"bool\"},\"is_subaddress\":{\"id\":3,\"type\":\"bool\"},\"original\":{\"id\":4,\"type\":\"bytes\"}},\"nested\":{\"MoneroAccountPublicAddress\":{\"fields\":{\"spend_public_key\":{\"id\":1,\"type\":\"bytes\"},\"view_public_key\":{\"id\":2,\"type\":\"bytes\"}}}}},\"MoneroTransactionFinalAck\":{\"fields\":{\"cout_key\":{\"id\":1,\"type\":\"bytes\"},\"opening_key\":{\"id\":5,\"type\":\"bytes\"},\"rand_mult\":{\"id\":3,\"type\":\"bytes\"},\"salt\":{\"id\":2,\"type\":\"bytes\"},\"tx_enc_keys\":{\"id\":4,\"type\":\"bytes\"}}},\"MoneroTransactionFinalRequest\":{\"fields\":{}},\"MoneroTransactionInitAck\":{\"fields\":{\"hmacs\":{\"id\":1,\"rule\":\"repeated\",\"type\":\"bytes\"},\"rsig_data\":{\"id\":2,\"type\":\"MoneroTransactionRsigData\"}}},\"MoneroTransactionInitRequest\":{\"fields\":{\"address_n\":{\"id\":2,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"network_type\":{\"id\":3,\"type\":\"uint32\"},\"tsx_data\":{\"id\":4,\"type\":\"MoneroTransactionData\"},\"version\":{\"id\":1,\"type\":\"uint32\"}},\"nested\":{\"MoneroTransactionData\":{\"fields\":{\"account\":{\"id\":9,\"type\":\"uint32\"},\"change_dts\":{\"id\":5,\"type\":\"MoneroTransactionDestinationEntry\"},\"client_version\":{\"id\":13,\"type\":\"uint32\"},\"fee\":{\"id\":8,\"type\":\"uint64\"},\"hard_fork\":{\"id\":14,\"type\":\"uint32\"},\"integrated_indices\":{\"id\":12,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"minor_indices\":{\"id\":10,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"mixin\":{\"id\":7,\"type\":\"uint32\"},\"monero_version\":{\"id\":15,\"type\":\"bytes\"},\"num_inputs\":{\"id\":6,\"type\":\"uint32\"},\"outputs\":{\"id\":4,\"rule\":\"repeated\",\"type\":\"MoneroTransactionDestinationEntry\"},\"payment_id\":{\"id\":2,\"type\":\"bytes\"},\"rsig_data\":{\"id\":11,\"type\":\"MoneroTransactionRsigData\"},\"unlock_time\":{\"id\":3,\"type\":\"uint64\"},\"version\":{\"id\":1,\"type\":\"uint32\"}}}}},\"MoneroTransactionInputViniAck\":{\"fields\":{}},\"MoneroTransactionInputViniRequest\":{\"fields\":{\"orig_idx\":{\"id\":6,\"type\":\"uint32\"},\"pseudo_out\":{\"id\":4,\"type\":\"bytes\"},\"pseudo_out_hmac\":{\"id\":5,\"type\":\"bytes\"},\"src_entr\":{\"id\":1,\"type\":\"MoneroTransactionSourceEntry\"},\"vini\":{\"id\":2,\"type\":\"bytes\"},\"vini_hmac\":{\"id\":3,\"type\":\"bytes\"}}},\"MoneroTransactionInputsPermutationAck\":{\"fields\":{}},\"MoneroTransactionInputsPermutationRequest\":{\"fields\":{\"perm\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"}}},\"MoneroTransactionRsigData\":{\"fields\":{\"bp_version\":{\"id\":7,\"type\":\"uint32\"},\"grouping\":{\"id\":3,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint64\"},\"mask\":{\"id\":4,\"type\":\"bytes\"},\"offload_type\":{\"id\":2,\"type\":\"uint32\"},\"rsig\":{\"id\":5,\"type\":\"bytes\"},\"rsig_parts\":{\"id\":6,\"rule\":\"repeated\",\"type\":\"bytes\"},\"rsig_type\":{\"id\":1,\"type\":\"uint32\"}}},\"MoneroTransactionSetInputAck\":{\"fields\":{\"pseudo_out\":{\"id\":3,\"type\":\"bytes\"},\"pseudo_out_alpha\":{\"id\":5,\"type\":\"bytes\"},\"pseudo_out_hmac\":{\"id\":4,\"type\":\"bytes\"},\"spend_key\":{\"id\":6,\"type\":\"bytes\"},\"vini\":{\"id\":1,\"type\":\"bytes\"},\"vini_hmac\":{\"id\":2,\"type\":\"bytes\"}}},\"MoneroTransactionSetInputRequest\":{\"fields\":{\"src_entr\":{\"id\":1,\"type\":\"MoneroTransactionSourceEntry\"}}},\"MoneroTransactionSetOutputAck\":{\"fields\":{\"ecdh_info\":{\"id\":5,\"type\":\"bytes\"},\"out_pk\":{\"id\":4,\"type\":\"bytes\"},\"rsig_data\":{\"id\":3,\"type\":\"MoneroTransactionRsigData\"},\"tx_out\":{\"id\":1,\"type\":\"bytes\"},\"vouti_hmac\":{\"id\":2,\"type\":\"bytes\"}}},\"MoneroTransactionSetOutputRequest\":{\"fields\":{\"dst_entr\":{\"id\":1,\"type\":\"MoneroTransactionDestinationEntry\"},\"dst_entr_hmac\":{\"id\":2,\"type\":\"bytes\"},\"is_offloaded_bp\":{\"id\":4,\"type\":\"bool\"},\"rsig_data\":{\"id\":3,\"type\":\"MoneroTransactionRsigData\"}}},\"MoneroTransactionSignInputAck\":{\"fields\":{\"pseudo_out\":{\"id\":2,\"type\":\"bytes\"},\"signature\":{\"id\":1,\"type\":\"bytes\"}}},\"MoneroTransactionSignInputRequest\":{\"fields\":{\"orig_idx\":{\"id\":8,\"type\":\"uint32\"},\"pseudo_out\":{\"id\":4,\"type\":\"bytes\"},\"pseudo_out_alpha\":{\"id\":6,\"type\":\"bytes\"},\"pseudo_out_hmac\":{\"id\":5,\"type\":\"bytes\"},\"spend_key\":{\"id\":7,\"type\":\"bytes\"},\"src_entr\":{\"id\":1,\"type\":\"MoneroTransactionSourceEntry\"},\"vini\":{\"id\":2,\"type\":\"bytes\"},\"vini_hmac\":{\"id\":3,\"type\":\"bytes\"}}},\"MoneroTransactionSourceEntry\":{\"fields\":{\"amount\":{\"id\":6,\"type\":\"uint64\"},\"mask\":{\"id\":8,\"type\":\"bytes\"},\"multisig_kLRki\":{\"id\":9,\"type\":\"MoneroMultisigKLRki\"},\"outputs\":{\"id\":1,\"rule\":\"repeated\",\"type\":\"MoneroOutputEntry\"},\"rct\":{\"id\":7,\"type\":\"bool\"},\"real_out_additional_tx_keys\":{\"id\":4,\"rule\":\"repeated\",\"type\":\"bytes\"},\"real_out_tx_key\":{\"id\":3,\"type\":\"bytes\"},\"real_output\":{\"id\":2,\"type\":\"uint64\"},\"real_output_in_tx_index\":{\"id\":5,\"type\":\"uint64\"},\"subaddr_minor\":{\"id\":10,\"type\":\"uint32\"}},\"nested\":{\"MoneroMultisigKLRki\":{\"fields\":{\"K\":{\"id\":1,\"type\":\"bytes\"},\"L\":{\"id\":2,\"type\":\"bytes\"},\"R\":{\"id\":3,\"type\":\"bytes\"},\"ki\":{\"id\":4,\"type\":\"bytes\"}}},\"MoneroOutputEntry\":{\"fields\":{\"idx\":{\"id\":1,\"type\":\"uint64\"},\"key\":{\"id\":2,\"type\":\"MoneroRctKeyPublic\"}},\"nested\":{\"MoneroRctKeyPublic\":{\"fields\":{\"commitment\":{\"id\":2,\"type\":\"bytes\"},\"dest\":{\"id\":1,\"type\":\"bytes\"}}}}}}},\"MoneroWatchKey\":{\"fields\":{\"address\":{\"id\":2,\"type\":\"bytes\"},\"watch_key\":{\"id\":1,\"type\":\"bytes\"}}},\"MultisigRedeemScriptType\":{\"fields\":{\"address_n\":{\"id\":5,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"m\":{\"id\":3,\"rule\":\"required\",\"type\":\"uint32\"},\"nodes\":{\"id\":4,\"rule\":\"repeated\",\"type\":\"HDNodeType\"},\"pubkeys\":{\"id\":1,\"rule\":\"repeated\",\"type\":\"HDNodePathType\"},\"signatures\":{\"id\":2,\"rule\":\"repeated\",\"type\":\"bytes\"}},\"nested\":{\"HDNodePathType\":{\"fields\":{\"address_n\":{\"id\":2,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"node\":{\"id\":1,\"rule\":\"required\",\"type\":\"HDNodeType\"}}}}},\"NEMAddress\":{\"fields\":{\"address\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"}}},\"NEMDecryptMessage\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"network\":{\"id\":2,\"type\":\"uint32\"},\"payload\":{\"id\":4,\"type\":\"bytes\"},\"public_key\":{\"id\":3,\"type\":\"bytes\"}}},\"NEMDecryptedMessage\":{\"fields\":{\"payload\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"NEMGetAddress\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"network\":{\"id\":2,\"type\":\"uint32\"},\"show_display\":{\"id\":3,\"type\":\"bool\"}}},\"NEMSignTx\":{\"fields\":{\"aggregate_modification\":{\"id\":8,\"type\":\"NEMAggregateModification\"},\"cosigning\":{\"id\":4,\"type\":\"bool\"},\"importance_transfer\":{\"id\":9,\"type\":\"NEMImportanceTransfer\"},\"mosaic_creation\":{\"id\":6,\"type\":\"NEMMosaicCreation\"},\"multisig\":{\"id\":2,\"type\":\"NEMTransactionCommon\"},\"provision_namespace\":{\"id\":5,\"type\":\"NEMProvisionNamespace\"},\"supply_change\":{\"id\":7,\"type\":\"NEMMosaicSupplyChange\"},\"transaction\":{\"id\":1,\"type\":\"NEMTransactionCommon\"},\"transfer\":{\"id\":3,\"type\":\"NEMTransfer\"}},\"nested\":{\"NEMAggregateModification\":{\"fields\":{\"modifications\":{\"id\":1,\"rule\":\"repeated\",\"type\":\"NEMCosignatoryModification\"},\"relative_change\":{\"id\":2,\"type\":\"sint32\"}},\"nested\":{\"NEMCosignatoryModification\":{\"fields\":{\"public_key\":{\"id\":2,\"type\":\"bytes\"},\"type\":{\"id\":1,\"type\":\"NEMModificationType\"}},\"nested\":{\"NEMModificationType\":{\"values\":{\"CosignatoryModification_Add\":1,\"CosignatoryModification_Delete\":2}}}}}},\"NEMImportanceTransfer\":{\"fields\":{\"mode\":{\"id\":1,\"type\":\"NEMImportanceTransferMode\"},\"public_key\":{\"id\":2,\"type\":\"bytes\"}},\"nested\":{\"NEMImportanceTransferMode\":{\"values\":{\"ImportanceTransfer_Activate\":1,\"ImportanceTransfer_Deactivate\":2}}}},\"NEMMosaicCreation\":{\"fields\":{\"definition\":{\"id\":1,\"type\":\"NEMMosaicDefinition\"},\"fee\":{\"id\":3,\"type\":\"uint64\"},\"sink\":{\"id\":2,\"type\":\"string\"}},\"nested\":{\"NEMMosaicDefinition\":{\"fields\":{\"description\":{\"id\":14,\"type\":\"string\"},\"divisibility\":{\"id\":5,\"type\":\"uint32\"},\"fee\":{\"id\":7,\"type\":\"uint64\"},\"levy\":{\"id\":6,\"type\":\"NEMMosaicLevy\"},\"levy_address\":{\"id\":8,\"type\":\"string\"},\"levy_mosaic\":{\"id\":10,\"type\":\"string\"},\"levy_namespace\":{\"id\":9,\"type\":\"string\"},\"mosaic\":{\"id\":4,\"type\":\"string\"},\"mutable_supply\":{\"id\":12,\"type\":\"bool\"},\"name\":{\"id\":1,\"type\":\"string\"},\"namespace\":{\"id\":3,\"type\":\"string\"},\"networks\":{\"id\":15,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"supply\":{\"id\":11,\"type\":\"uint64\"},\"ticker\":{\"id\":2,\"type\":\"string\"},\"transferable\":{\"id\":13,\"type\":\"bool\"}},\"nested\":{\"NEMMosaicLevy\":{\"values\":{\"MosaicLevy_Absolute\":1,\"MosaicLevy_Percentile\":2}}}}}},\"NEMMosaicSupplyChange\":{\"fields\":{\"delta\":{\"id\":4,\"type\":\"uint64\"},\"mosaic\":{\"id\":2,\"type\":\"string\"},\"namespace\":{\"id\":1,\"type\":\"string\"},\"type\":{\"id\":3,\"type\":\"NEMSupplyChangeType\"}},\"nested\":{\"NEMSupplyChangeType\":{\"values\":{\"SupplyChange_Decrease\":2,\"SupplyChange_Increase\":1}}}},\"NEMProvisionNamespace\":{\"fields\":{\"fee\":{\"id\":4,\"type\":\"uint64\"},\"namespace\":{\"id\":1,\"type\":\"string\"},\"parent\":{\"id\":2,\"type\":\"string\"},\"sink\":{\"id\":3,\"type\":\"string\"}}},\"NEMTransactionCommon\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"deadline\":{\"id\":5,\"type\":\"uint32\"},\"fee\":{\"id\":4,\"type\":\"uint64\"},\"network\":{\"id\":2,\"type\":\"uint32\"},\"signer\":{\"id\":6,\"type\":\"bytes\"},\"timestamp\":{\"id\":3,\"type\":\"uint32\"}}},\"NEMTransfer\":{\"fields\":{\"amount\":{\"id\":2,\"type\":\"uint64\"},\"mosaics\":{\"id\":5,\"rule\":\"repeated\",\"type\":\"NEMMosaic\"},\"payload\":{\"id\":3,\"type\":\"bytes\"},\"public_key\":{\"id\":4,\"type\":\"bytes\"},\"recipient\":{\"id\":1,\"type\":\"string\"}},\"nested\":{\"NEMMosaic\":{\"fields\":{\"mosaic\":{\"id\":2,\"type\":\"string\"},\"namespace\":{\"id\":1,\"type\":\"string\"},\"quantity\":{\"id\":3,\"type\":\"uint64\"}}}}}}},\"NEMSignedTx\":{\"fields\":{\"data\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"},\"signature\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"NFTWriteData\":{\"fields\":{\"data\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"},\"index\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint32\"},\"offset\":{\"id\":3,\"rule\":\"required\",\"type\":\"uint32\"}}},\"NFTWriteInfo\":{\"fields\":{\"height\":{\"id\":3,\"rule\":\"required\",\"type\":\"uint32\"},\"index\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint32\"},\"name_en\":{\"id\":5,\"type\":\"string\"},\"name_zh\":{\"id\":4,\"type\":\"string\"},\"width\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint32\"}}},\"NearAddress\":{\"fields\":{\"address\":{\"id\":1,\"type\":\"string\"}}},\"NearGetAddress\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"show_display\":{\"id\":2,\"type\":\"bool\"}}},\"NearSignTx\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"raw_tx\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"NearSignedTx\":{\"fields\":{\"signature\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"NexaAddress\":{\"fields\":{\"address\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"},\"public_key\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"NexaGetAddress\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"prefix\":{\"id\":3,\"options\":{\"default\":\"nexa\"},\"type\":\"string\"},\"show_display\":{\"id\":2,\"type\":\"bool\"}}},\"NexaSignTx\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"input_count\":{\"id\":4,\"options\":{\"default\":1},\"type\":\"uint32\"},\"prefix\":{\"id\":3,\"options\":{\"default\":\"nexa\"},\"type\":\"string\"},\"raw_message\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"NexaSignedTx\":{\"fields\":{\"signature\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"NexaTxInputAck\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"raw_message\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"NexaTxInputRequest\":{\"fields\":{\"request_index\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint32\"},\"signature\":{\"id\":2,\"type\":\"bytes\"}}},\"NextU2FCounter\":{\"fields\":{\"u2f_counter\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint32\"}}},\"OutputScriptType\":{\"values\":{\"PAYTOADDRESS\":0,\"PAYTOMULTISIG\":2,\"PAYTOOPRETURN\":3,\"PAYTOP2SHWITNESS\":5,\"PAYTOSCRIPTHASH\":1,\"PAYTOTAPROOT\":6,\"PAYTOWITNESS\":4}},\"OwnershipId\":{\"fields\":{\"ownership_id\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"OwnershipProof\":{\"fields\":{\"ownership_proof\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"},\"signature\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"PassphraseAck\":{\"fields\":{\"_state\":{\"id\":2,\"options\":{\"deprecated\":true},\"type\":\"bytes\"},\"on_device\":{\"id\":3,\"type\":\"bool\"},\"passphrase\":{\"id\":1,\"type\":\"string\"}}},\"PassphraseRequest\":{\"fields\":{\"_on_device\":{\"id\":1,\"options\":{\"deprecated\":true},\"type\":\"bool\"}}},\"PinMatrixAck\":{\"fields\":{\"new_pin\":{\"id\":2,\"type\":\"string\"},\"pin\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"}}},\"PinMatrixRequest\":{\"fields\":{\"type\":{\"id\":1,\"type\":\"PinMatrixRequestType\"}},\"nested\":{\"PinMatrixRequestType\":{\"values\":{\"PinMatrixRequestType_BackupFirst\":6,\"PinMatrixRequestType_BackupSecond\":7,\"PinMatrixRequestType_Current\":1,\"PinMatrixRequestType_NewFirst\":2,\"PinMatrixRequestType_NewSecond\":3,\"PinMatrixRequestType_WipeCodeFirst\":4,\"PinMatrixRequestType_WipeCodeSecond\":5}}}},\"Ping\":{\"fields\":{\"button_protection\":{\"id\":2,\"type\":\"bool\"},\"message\":{\"id\":1,\"options\":{\"default\":\"\"},\"type\":\"string\"}}},\"PolkadotAddress\":{\"fields\":{\"address\":{\"id\":1,\"type\":\"string\"},\"public_key\":{\"id\":2,\"type\":\"string\"}}},\"PolkadotGetAddress\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"network\":{\"id\":3,\"rule\":\"required\",\"type\":\"string\"},\"prefix\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint32\"},\"show_display\":{\"id\":4,\"type\":\"bool\"}}},\"PolkadotSignTx\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"network\":{\"id\":3,\"rule\":\"required\",\"type\":\"string\"},\"raw_tx\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"PolkadotSignedTx\":{\"fields\":{\"signature\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"PreauthorizedRequest\":{\"fields\":{}},\"PrevInput\":{\"fields\":{\"decred_tree\":{\"id\":9,\"type\":\"uint32\"},\"prev_hash\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"},\"prev_index\":{\"id\":3,\"rule\":\"required\",\"type\":\"uint32\"},\"script_sig\":{\"id\":4,\"rule\":\"required\",\"type\":\"bytes\"},\"sequence\":{\"id\":5,\"rule\":\"required\",\"type\":\"uint32\"}}},\"PrevOutput\":{\"fields\":{\"amount\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint64\"},\"decred_script_version\":{\"id\":3,\"type\":\"uint32\"},\"script_pubkey\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"PrevTx\":{\"fields\":{\"branch_id\":{\"id\":14,\"type\":\"uint32\"},\"expiry\":{\"id\":10,\"type\":\"uint32\"},\"extra_data_len\":{\"id\":9,\"options\":{\"default\":0},\"type\":\"uint32\"},\"inputs_count\":{\"id\":6,\"rule\":\"required\",\"type\":\"uint32\"},\"lock_time\":{\"id\":4,\"rule\":\"required\",\"type\":\"uint32\"},\"outputs_count\":{\"id\":7,\"rule\":\"required\",\"type\":\"uint32\"},\"timestamp\":{\"id\":13,\"type\":\"uint32\"},\"version\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint32\"},\"version_group_id\":{\"id\":12,\"type\":\"uint32\"}}},\"PublicKey\":{\"fields\":{\"node\":{\"id\":1,\"rule\":\"required\",\"type\":\"HDNodeType\"},\"root_fingerprint\":{\"id\":3,\"type\":\"uint32\"},\"xpub\":{\"id\":2,\"rule\":\"required\",\"type\":\"string\"}}},\"PublicKeyMultiple\":{\"fields\":{\"xpubs\":{\"id\":1,\"rule\":\"repeated\",\"type\":\"string\"}}},\"ReadSEPublicCert\":{\"fields\":{}},\"ReadSEPublicKey\":{\"fields\":{}},\"Reboot\":{\"fields\":{\"reboot_type\":{\"id\":1,\"rule\":\"required\",\"type\":\"RebootType\"}}},\"RebootToBoardloader\":{\"fields\":{}},\"RebootToBootloader\":{\"fields\":{}},\"RebootType\":{\"values\":{\"Boardloader\":1,\"BootLoader\":2,\"Normal\":0}},\"RecoveryDevice\":{\"fields\":{\"dry_run\":{\"id\":10,\"type\":\"bool\"},\"enforce_wordlist\":{\"id\":6,\"type\":\"bool\"},\"label\":{\"id\":5,\"type\":\"string\"},\"language\":{\"id\":4,\"type\":\"string\"},\"passphrase_protection\":{\"id\":2,\"type\":\"bool\"},\"pin_protection\":{\"id\":3,\"type\":\"bool\"},\"type\":{\"id\":8,\"type\":\"RecoveryDeviceType\"},\"u2f_counter\":{\"id\":9,\"type\":\"uint32\"},\"word_count\":{\"id\":1,\"type\":\"uint32\"}},\"nested\":{\"RecoveryDeviceType\":{\"values\":{\"RecoveryDeviceType_Matrix\":1,\"RecoveryDeviceType_ScrambledWords\":0}}}},\"ResetDevice\":{\"fields\":{\"backup_type\":{\"id\":10,\"options\":{\"default\":\"Bip39\"},\"type\":\"BackupType\"},\"display_random\":{\"id\":1,\"type\":\"bool\"},\"label\":{\"id\":6,\"type\":\"string\"},\"language\":{\"id\":5,\"options\":{\"default\":\"en-US\"},\"type\":\"string\"},\"no_backup\":{\"id\":9,\"type\":\"bool\"},\"passphrase_protection\":{\"id\":3,\"type\":\"bool\"},\"pin_protection\":{\"id\":4,\"type\":\"bool\"},\"skip_backup\":{\"id\":8,\"type\":\"bool\"},\"strength\":{\"id\":2,\"options\":{\"default\":256},\"type\":\"uint32\"},\"u2f_counter\":{\"id\":7,\"type\":\"uint32\"}}},\"ResourceAck\":{\"fields\":{\"data_chunk\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"},\"hash\":{\"id\":2,\"type\":\"bytes\"}}},\"ResourceRequest\":{\"fields\":{\"data_length\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint32\"},\"offset\":{\"id\":1,\"type\":\"uint32\"}}},\"ResourceUpdate\":{\"fields\":{\"data_length\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint32\"},\"file_name\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"},\"hash\":{\"id\":4,\"type\":\"bytes\"},\"initial_data_chunk\":{\"id\":3,\"rule\":\"required\",\"type\":\"bytes\"}}},\"ResourceUpload\":{\"fields\":{\"data_length\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint32\"},\"extension\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"},\"file_name_no_ext\":{\"id\":6,\"type\":\"string\"},\"nft_meta_data\":{\"id\":4,\"type\":\"bytes\"},\"res_type\":{\"id\":3,\"rule\":\"required\",\"type\":\"ResourceType\"},\"zoom_data_length\":{\"id\":5,\"rule\":\"required\",\"type\":\"uint32\"}},\"nested\":{\"ResourceType\":{\"values\":{\"Nft\":1,\"WallPaper\":0}}}},\"RippleAddress\":{\"fields\":{\"address\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"}}},\"RippleGetAddress\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"show_display\":{\"id\":2,\"type\":\"bool\"}}},\"RippleSignTx\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"fee\":{\"id\":2,\"type\":\"uint64\"},\"flags\":{\"id\":3,\"type\":\"uint32\"},\"last_ledger_sequence\":{\"id\":5,\"type\":\"uint32\"},\"payment\":{\"id\":6,\"type\":\"RipplePayment\"},\"sequence\":{\"id\":4,\"type\":\"uint32\"}},\"nested\":{\"RipplePayment\":{\"fields\":{\"amount\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint64\"},\"destination\":{\"id\":2,\"rule\":\"required\",\"type\":\"string\"},\"destination_tag\":{\"id\":3,\"type\":\"uint32\"}}}}},\"RippleSignedTx\":{\"fields\":{\"serialized_tx\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"},\"signature\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"SEMessageSignature\":{\"fields\":{\"signature\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"SEPublicCert\":{\"fields\":{\"public_cert\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"SEPublicKey\":{\"fields\":{\"public_key\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"SESignMessage\":{\"fields\":{\"message\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"SafetyCheckLevel\":{\"values\":{\"PromptAlways\":1,\"PromptTemporarily\":2,\"Strict\":0}},\"SdProtect\":{\"fields\":{\"operation\":{\"id\":1,\"rule\":\"required\",\"type\":\"SdProtectOperationType\"}},\"nested\":{\"SdProtectOperationType\":{\"values\":{\"DISABLE\":0,\"ENABLE\":1,\"REFRESH\":2}}}},\"SelfTest\":{\"fields\":{\"payload\":{\"id\":1,\"type\":\"bytes\"}}},\"SetU2FCounter\":{\"fields\":{\"u2f_counter\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint32\"}}},\"SignIdentity\":{\"fields\":{\"challenge_hidden\":{\"id\":2,\"options\":{\"default\":\"\"},\"type\":\"bytes\"},\"challenge_visual\":{\"id\":3,\"options\":{\"default\":\"\"},\"type\":\"string\"},\"ecdsa_curve_name\":{\"id\":4,\"type\":\"string\"},\"identity\":{\"id\":1,\"rule\":\"required\",\"type\":\"IdentityType\"}}},\"SignMessage\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"coin_name\":{\"id\":3,\"options\":{\"default\":\"Bitcoin\"},\"type\":\"string\"},\"message\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"},\"no_script_type\":{\"id\":5,\"type\":\"bool\"},\"script_type\":{\"id\":4,\"options\":{\"default\":\"SPENDADDRESS\"},\"type\":\"InputScriptType\"}}},\"SignTx\":{\"fields\":{\"amount_unit\":{\"id\":11,\"options\":{\"default\":\"BITCOIN\"},\"type\":\"AmountUnit\"},\"branch_id\":{\"id\":10,\"type\":\"uint32\"},\"coin_name\":{\"id\":3,\"options\":{\"default\":\"Bitcoin\"},\"type\":\"string\"},\"decred_staking_ticket\":{\"id\":12,\"options\":{\"default\":false},\"type\":\"bool\"},\"expiry\":{\"id\":6,\"type\":\"uint32\"},\"inputs_count\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint32\"},\"lock_time\":{\"id\":5,\"options\":{\"default\":0},\"type\":\"uint32\"},\"outputs_count\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint32\"},\"overwintered\":{\"id\":7,\"options\":{\"deprecated\":true},\"type\":\"bool\"},\"timestamp\":{\"id\":9,\"type\":\"uint32\"},\"version\":{\"id\":4,\"options\":{\"default\":1},\"type\":\"uint32\"},\"version_group_id\":{\"id\":8,\"type\":\"uint32\"}}},\"SignedIdentity\":{\"fields\":{\"address\":{\"id\":1,\"type\":\"string\"},\"public_key\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"},\"signature\":{\"id\":3,\"rule\":\"required\",\"type\":\"bytes\"}}},\"SolanaAddress\":{\"fields\":{\"address\":{\"id\":1,\"type\":\"string\"}}},\"SolanaGetAddress\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"show_display\":{\"id\":2,\"type\":\"bool\"}}},\"SolanaSignTx\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"raw_tx\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"SolanaSignedTx\":{\"fields\":{\"signature\":{\"id\":1,\"type\":\"bytes\"}}},\"SpiFlashData\":{\"fields\":{\"data\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"SpiFlashRead\":{\"fields\":{\"address\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint32\"},\"len\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint32\"}}},\"SpiFlashWrite\":{\"fields\":{\"address\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint32\"},\"data\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"StarcoinAddress\":{\"fields\":{\"address\":{\"id\":1,\"type\":\"string\"}}},\"StarcoinGetAddress\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"show_display\":{\"id\":2,\"type\":\"bool\"}}},\"StarcoinGetPublicKey\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"show_display\":{\"id\":2,\"type\":\"bool\"}}},\"StarcoinMessageSignature\":{\"fields\":{\"public_key\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"},\"signature\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"StarcoinPublicKey\":{\"fields\":{\"public_key\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"StarcoinSignMessage\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"message\":{\"id\":2,\"type\":\"bytes\"}}},\"StarcoinSignTx\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"raw_tx\":{\"id\":2,\"type\":\"bytes\"}}},\"StarcoinSignedTx\":{\"fields\":{\"public_key\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"},\"signature\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"StarcoinVerifyMessage\":{\"fields\":{\"message\":{\"id\":3,\"type\":\"bytes\"},\"public_key\":{\"id\":1,\"type\":\"bytes\"},\"signature\":{\"id\":2,\"type\":\"bytes\"}}},\"StellarAccountMergeOp\":{\"fields\":{\"destination_account\":{\"id\":2,\"rule\":\"required\",\"type\":\"string\"},\"source_account\":{\"id\":1,\"type\":\"string\"}}},\"StellarAddress\":{\"fields\":{\"address\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"}}},\"StellarAllowTrustOp\":{\"fields\":{\"asset_code\":{\"id\":4,\"type\":\"string\"},\"asset_type\":{\"id\":3,\"rule\":\"required\",\"type\":\"StellarAssetType\"},\"is_authorized\":{\"id\":5,\"rule\":\"required\",\"type\":\"bool\"},\"source_account\":{\"id\":1,\"type\":\"string\"},\"trusted_account\":{\"id\":2,\"rule\":\"required\",\"type\":\"string\"}}},\"StellarAsset\":{\"fields\":{\"code\":{\"id\":2,\"type\":\"string\"},\"issuer\":{\"id\":3,\"type\":\"string\"},\"type\":{\"id\":1,\"rule\":\"required\",\"type\":\"StellarAssetType\"}}},\"StellarAssetType\":{\"values\":{\"ALPHANUM12\":2,\"ALPHANUM4\":1,\"NATIVE\":0}},\"StellarBumpSequenceOp\":{\"fields\":{\"bump_to\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint64\"},\"source_account\":{\"id\":1,\"type\":\"string\"}}},\"StellarChangeTrustOp\":{\"fields\":{\"asset\":{\"id\":2,\"rule\":\"required\",\"type\":\"StellarAsset\"},\"limit\":{\"id\":3,\"rule\":\"required\",\"type\":\"uint64\"},\"source_account\":{\"id\":1,\"type\":\"string\"}}},\"StellarCreateAccountOp\":{\"fields\":{\"new_account\":{\"id\":2,\"rule\":\"required\",\"type\":\"string\"},\"source_account\":{\"id\":1,\"type\":\"string\"},\"starting_balance\":{\"id\":3,\"rule\":\"required\",\"type\":\"sint64\"}}},\"StellarCreatePassiveSellOfferOp\":{\"fields\":{\"amount\":{\"id\":4,\"rule\":\"required\",\"type\":\"sint64\"},\"buying_asset\":{\"id\":3,\"rule\":\"required\",\"type\":\"StellarAsset\"},\"price_d\":{\"id\":6,\"rule\":\"required\",\"type\":\"uint32\"},\"price_n\":{\"id\":5,\"rule\":\"required\",\"type\":\"uint32\"},\"selling_asset\":{\"id\":2,\"rule\":\"required\",\"type\":\"StellarAsset\"},\"source_account\":{\"id\":1,\"type\":\"string\"}}},\"StellarGetAddress\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"show_display\":{\"id\":2,\"type\":\"bool\"}}},\"StellarManageBuyOfferOp\":{\"fields\":{\"amount\":{\"id\":4,\"rule\":\"required\",\"type\":\"sint64\"},\"buying_asset\":{\"id\":3,\"rule\":\"required\",\"type\":\"StellarAsset\"},\"offer_id\":{\"id\":7,\"rule\":\"required\",\"type\":\"uint64\"},\"price_d\":{\"id\":6,\"rule\":\"required\",\"type\":\"uint32\"},\"price_n\":{\"id\":5,\"rule\":\"required\",\"type\":\"uint32\"},\"selling_asset\":{\"id\":2,\"rule\":\"required\",\"type\":\"StellarAsset\"},\"source_account\":{\"id\":1,\"type\":\"string\"}}},\"StellarManageDataOp\":{\"fields\":{\"key\":{\"id\":2,\"rule\":\"required\",\"type\":\"string\"},\"source_account\":{\"id\":1,\"type\":\"string\"},\"value\":{\"id\":3,\"type\":\"bytes\"}}},\"StellarManageSellOfferOp\":{\"fields\":{\"amount\":{\"id\":4,\"rule\":\"required\",\"type\":\"sint64\"},\"buying_asset\":{\"id\":3,\"rule\":\"required\",\"type\":\"StellarAsset\"},\"offer_id\":{\"id\":7,\"rule\":\"required\",\"type\":\"uint64\"},\"price_d\":{\"id\":6,\"rule\":\"required\",\"type\":\"uint32\"},\"price_n\":{\"id\":5,\"rule\":\"required\",\"type\":\"uint32\"},\"selling_asset\":{\"id\":2,\"rule\":\"required\",\"type\":\"StellarAsset\"},\"source_account\":{\"id\":1,\"type\":\"string\"}}},\"StellarPathPaymentStrictReceiveOp\":{\"fields\":{\"destination_account\":{\"id\":4,\"rule\":\"required\",\"type\":\"string\"},\"destination_amount\":{\"id\":6,\"rule\":\"required\",\"type\":\"sint64\"},\"destination_asset\":{\"id\":5,\"rule\":\"required\",\"type\":\"StellarAsset\"},\"paths\":{\"id\":7,\"rule\":\"repeated\",\"type\":\"StellarAsset\"},\"send_asset\":{\"id\":2,\"rule\":\"required\",\"type\":\"StellarAsset\"},\"send_max\":{\"id\":3,\"rule\":\"required\",\"type\":\"sint64\"},\"source_account\":{\"id\":1,\"type\":\"string\"}}},\"StellarPathPaymentStrictSendOp\":{\"fields\":{\"destination_account\":{\"id\":4,\"rule\":\"required\",\"type\":\"string\"},\"destination_asset\":{\"id\":5,\"rule\":\"required\",\"type\":\"StellarAsset\"},\"destination_min\":{\"id\":6,\"rule\":\"required\",\"type\":\"sint64\"},\"paths\":{\"id\":7,\"rule\":\"repeated\",\"type\":\"StellarAsset\"},\"send_amount\":{\"id\":3,\"rule\":\"required\",\"type\":\"sint64\"},\"send_asset\":{\"id\":2,\"rule\":\"required\",\"type\":\"StellarAsset\"},\"source_account\":{\"id\":1,\"type\":\"string\"}}},\"StellarPaymentOp\":{\"fields\":{\"amount\":{\"id\":4,\"rule\":\"required\",\"type\":\"sint64\"},\"asset\":{\"id\":3,\"rule\":\"required\",\"type\":\"StellarAsset\"},\"destination_account\":{\"id\":2,\"rule\":\"required\",\"type\":\"string\"},\"source_account\":{\"id\":1,\"type\":\"string\"}}},\"StellarSetOptionsOp\":{\"fields\":{\"clear_flags\":{\"id\":3,\"type\":\"uint32\"},\"high_threshold\":{\"id\":8,\"type\":\"uint32\"},\"home_domain\":{\"id\":9,\"type\":\"string\"},\"inflation_destination_account\":{\"id\":2,\"type\":\"string\"},\"low_threshold\":{\"id\":6,\"type\":\"uint32\"},\"master_weight\":{\"id\":5,\"type\":\"uint32\"},\"medium_threshold\":{\"id\":7,\"type\":\"uint32\"},\"set_flags\":{\"id\":4,\"type\":\"uint32\"},\"signer_key\":{\"id\":11,\"type\":\"bytes\"},\"signer_type\":{\"id\":10,\"type\":\"StellarSignerType\"},\"signer_weight\":{\"id\":12,\"type\":\"uint32\"},\"source_account\":{\"id\":1,\"type\":\"string\"}},\"nested\":{\"StellarSignerType\":{\"values\":{\"ACCOUNT\":0,\"HASH\":2,\"PRE_AUTH\":1}}}},\"StellarSignTx\":{\"fields\":{\"address_n\":{\"id\":2,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"fee\":{\"id\":5,\"rule\":\"required\",\"type\":\"uint32\"},\"memo_hash\":{\"id\":13,\"type\":\"bytes\"},\"memo_id\":{\"id\":12,\"type\":\"uint64\"},\"memo_text\":{\"id\":11,\"type\":\"string\"},\"memo_type\":{\"id\":10,\"rule\":\"required\",\"type\":\"StellarMemoType\"},\"network_passphrase\":{\"id\":3,\"rule\":\"required\",\"type\":\"string\"},\"num_operations\":{\"id\":14,\"rule\":\"required\",\"type\":\"uint32\"},\"sequence_number\":{\"id\":6,\"rule\":\"required\",\"type\":\"uint64\"},\"source_account\":{\"id\":4,\"rule\":\"required\",\"type\":\"string\"},\"timebounds_end\":{\"id\":9,\"rule\":\"required\",\"type\":\"uint32\"},\"timebounds_start\":{\"id\":8,\"rule\":\"required\",\"type\":\"uint32\"}},\"nested\":{\"StellarMemoType\":{\"values\":{\"HASH\":3,\"ID\":2,\"NONE\":0,\"RETURN\":4,\"TEXT\":1}}}},\"StellarSignedTx\":{\"fields\":{\"public_key\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"},\"signature\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"StellarTxOpRequest\":{\"fields\":{}},\"Success\":{\"fields\":{\"message\":{\"id\":1,\"options\":{\"default\":\"\"},\"type\":\"string\"}}},\"SuiAddress\":{\"fields\":{\"address\":{\"id\":1,\"type\":\"string\"}}},\"SuiGetAddress\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"show_display\":{\"id\":2,\"type\":\"bool\"}}},\"SuiSignTx\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"raw_tx\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"SuiSignedTx\":{\"fields\":{\"public_key\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"},\"signature\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"TezosAddress\":{\"fields\":{\"address\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"}}},\"TezosGetAddress\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"show_display\":{\"id\":2,\"type\":\"bool\"}}},\"TezosGetPublicKey\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"show_display\":{\"id\":2,\"type\":\"bool\"}}},\"TezosPublicKey\":{\"fields\":{\"public_key\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"}}},\"TezosSignTx\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"ballot\":{\"id\":8,\"type\":\"TezosBallotOp\"},\"branch\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"},\"delegation\":{\"id\":6,\"type\":\"TezosDelegationOp\"},\"origination\":{\"id\":5,\"type\":\"TezosOriginationOp\"},\"proposal\":{\"id\":7,\"type\":\"TezosProposalOp\"},\"reveal\":{\"id\":3,\"type\":\"TezosRevealOp\"},\"transaction\":{\"id\":4,\"type\":\"TezosTransactionOp\"}},\"nested\":{\"TezosBallotOp\":{\"fields\":{\"ballot\":{\"id\":4,\"type\":\"TezosBallotType\"},\"period\":{\"id\":2,\"type\":\"uint64\"},\"proposal\":{\"id\":3,\"type\":\"bytes\"},\"source\":{\"id\":1,\"type\":\"bytes\"}},\"nested\":{\"TezosBallotType\":{\"values\":{\"Nay\":1,\"Pass\":2,\"Yay\":0}}}},\"TezosContractID\":{\"fields\":{\"hash\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"},\"tag\":{\"id\":1,\"rule\":\"required\",\"type\":\"TezosContractType\"}},\"nested\":{\"TezosContractType\":{\"values\":{\"Implicit\":0,\"Originated\":1}}}},\"TezosDelegationOp\":{\"fields\":{\"counter\":{\"id\":3,\"rule\":\"required\",\"type\":\"uint64\"},\"delegate\":{\"id\":6,\"rule\":\"required\",\"type\":\"bytes\"},\"fee\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint64\"},\"gas_limit\":{\"id\":4,\"rule\":\"required\",\"type\":\"uint64\"},\"source\":{\"id\":7,\"rule\":\"required\",\"type\":\"bytes\"},\"storage_limit\":{\"id\":5,\"rule\":\"required\",\"type\":\"uint64\"}}},\"TezosOriginationOp\":{\"fields\":{\"balance\":{\"id\":7,\"rule\":\"required\",\"type\":\"uint64\"},\"counter\":{\"id\":3,\"rule\":\"required\",\"type\":\"uint64\"},\"delegatable\":{\"id\":9,\"type\":\"bool\"},\"delegate\":{\"id\":10,\"type\":\"bytes\"},\"fee\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint64\"},\"gas_limit\":{\"id\":4,\"rule\":\"required\",\"type\":\"uint64\"},\"manager_pubkey\":{\"id\":6,\"type\":\"bytes\"},\"script\":{\"id\":11,\"rule\":\"required\",\"type\":\"bytes\"},\"source\":{\"id\":12,\"rule\":\"required\",\"type\":\"bytes\"},\"spendable\":{\"id\":8,\"type\":\"bool\"},\"storage_limit\":{\"id\":5,\"rule\":\"required\",\"type\":\"uint64\"}}},\"TezosProposalOp\":{\"fields\":{\"period\":{\"id\":2,\"type\":\"uint64\"},\"proposals\":{\"id\":4,\"rule\":\"repeated\",\"type\":\"bytes\"},\"source\":{\"id\":1,\"type\":\"bytes\"}}},\"TezosRevealOp\":{\"fields\":{\"counter\":{\"id\":3,\"rule\":\"required\",\"type\":\"uint64\"},\"fee\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint64\"},\"gas_limit\":{\"id\":4,\"rule\":\"required\",\"type\":\"uint64\"},\"public_key\":{\"id\":6,\"rule\":\"required\",\"type\":\"bytes\"},\"source\":{\"id\":7,\"rule\":\"required\",\"type\":\"bytes\"},\"storage_limit\":{\"id\":5,\"rule\":\"required\",\"type\":\"uint64\"}}},\"TezosTransactionOp\":{\"fields\":{\"amount\":{\"id\":6,\"rule\":\"required\",\"type\":\"uint64\"},\"counter\":{\"id\":3,\"rule\":\"required\",\"type\":\"uint64\"},\"destination\":{\"id\":7,\"rule\":\"required\",\"type\":\"TezosContractID\"},\"fee\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint64\"},\"gas_limit\":{\"id\":4,\"rule\":\"required\",\"type\":\"uint64\"},\"parameters\":{\"id\":8,\"type\":\"bytes\"},\"parameters_manager\":{\"id\":10,\"type\":\"TezosParametersManager\"},\"source\":{\"id\":9,\"rule\":\"required\",\"type\":\"bytes\"},\"storage_limit\":{\"id\":5,\"rule\":\"required\",\"type\":\"uint64\"}},\"nested\":{\"TezosParametersManager\":{\"fields\":{\"cancel_delegate\":{\"id\":2,\"type\":\"bool\"},\"set_delegate\":{\"id\":1,\"type\":\"bytes\"},\"transfer\":{\"id\":3,\"type\":\"TezosManagerTransfer\"}},\"nested\":{\"TezosManagerTransfer\":{\"fields\":{\"amount\":{\"id\":2,\"type\":\"uint64\"},\"destination\":{\"id\":1,\"type\":\"TezosContractID\"}}}}}}}}},\"TezosSignedTx\":{\"fields\":{\"operation_hash\":{\"id\":3,\"rule\":\"required\",\"type\":\"string\"},\"sig_op_contents\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"},\"signature\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"}}},\"TronAddress\":{\"fields\":{\"address\":{\"id\":1,\"type\":\"string\"}}},\"TronGetAddress\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"show_display\":{\"id\":2,\"type\":\"bool\"}}},\"TronMessageSignature\":{\"fields\":{\"address\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"},\"signature\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"TronSignMessage\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"message\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"TronSignTx\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"contract\":{\"id\":6,\"rule\":\"required\",\"type\":\"TronContract\"},\"data\":{\"id\":5,\"type\":\"string\"},\"expiration\":{\"id\":4,\"rule\":\"required\",\"type\":\"uint64\"},\"fee_limit\":{\"id\":8,\"type\":\"uint64\"},\"ref_block_bytes\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"},\"ref_block_hash\":{\"id\":3,\"rule\":\"required\",\"type\":\"bytes\"},\"timestamp\":{\"id\":7,\"rule\":\"required\",\"type\":\"uint64\"}},\"nested\":{\"TronContract\":{\"fields\":{\"delegate_resource_contract\":{\"id\":57,\"type\":\"TronDelegateResourceContract\"},\"freeze_balance_contract\":{\"id\":11,\"type\":\"TronFreezeBalanceContract\"},\"freeze_balance_v2_contract\":{\"id\":54,\"type\":\"TronFreezeBalanceV2Contract\"},\"transfer_contract\":{\"id\":2,\"type\":\"TronTransferContract\"},\"trigger_smart_contract\":{\"id\":31,\"type\":\"TronTriggerSmartContract\"},\"undelegate_resource_contract\":{\"id\":58,\"type\":\"TronUnDelegateResourceContract\"},\"unfreeze_balance_contract\":{\"id\":12,\"type\":\"TronUnfreezeBalanceContract\"},\"unfreeze_balance_v2_contract\":{\"id\":55,\"type\":\"TronUnfreezeBalanceV2Contract\"},\"withdraw_balance_contract\":{\"id\":13,\"type\":\"TronWithdrawBalanceContract\"},\"withdraw_expire_unfreeze_contract\":{\"id\":56,\"type\":\"TronWithdrawExpireUnfreezeContract\"}},\"nested\":{\"TronDelegateResourceContract\":{\"fields\":{\"balance\":{\"id\":3,\"type\":\"uint64\"},\"lock\":{\"id\":5,\"type\":\"bool\"},\"receiver_address\":{\"id\":4,\"type\":\"string\"},\"resource\":{\"id\":2,\"type\":\"TronResourceCode\"}}},\"TronFreezeBalanceContract\":{\"fields\":{\"frozen_balance\":{\"id\":1,\"type\":\"uint64\"},\"frozen_duration\":{\"id\":2,\"type\":\"uint64\"},\"receiver_address\":{\"id\":4,\"type\":\"string\"},\"resource\":{\"id\":3,\"type\":\"TronResourceCode\"}}},\"TronFreezeBalanceV2Contract\":{\"fields\":{\"frozen_balance\":{\"id\":2,\"type\":\"uint64\"},\"resource\":{\"id\":3,\"type\":\"TronResourceCode\"}}},\"TronResourceCode\":{\"values\":{\"BANDWIDTH\":0,\"ENERGY\":1}},\"TronTransferContract\":{\"fields\":{\"amount\":{\"id\":3,\"type\":\"uint64\"},\"to_address\":{\"id\":2,\"type\":\"string\"}}},\"TronTriggerSmartContract\":{\"fields\":{\"asset_id\":{\"id\":6,\"type\":\"uint64\"},\"call_token_value\":{\"id\":5,\"type\":\"uint64\"},\"call_value\":{\"id\":3,\"type\":\"uint64\"},\"contract_address\":{\"id\":2,\"type\":\"string\"},\"data\":{\"id\":4,\"type\":\"bytes\"}}},\"TronUnDelegateResourceContract\":{\"fields\":{\"balance\":{\"id\":3,\"type\":\"uint64\"},\"receiver_address\":{\"id\":4,\"type\":\"string\"},\"resource\":{\"id\":2,\"type\":\"TronResourceCode\"}}},\"TronUnfreezeBalanceContract\":{\"fields\":{\"receiver_address\":{\"id\":2,\"type\":\"string\"},\"resource\":{\"id\":1,\"type\":\"TronResourceCode\"}}},\"TronUnfreezeBalanceV2Contract\":{\"fields\":{\"resource\":{\"id\":3,\"type\":\"TronResourceCode\"},\"unfreeze_balance\":{\"id\":2,\"type\":\"uint64\"}}},\"TronWithdrawBalanceContract\":{\"fields\":{\"owner_address\":{\"id\":1,\"type\":\"bytes\"}}},\"TronWithdrawExpireUnfreezeContract\":{\"fields\":{}}}}}},\"TronSignedTx\":{\"fields\":{\"serialized_tx\":{\"id\":2,\"type\":\"bytes\"},\"signature\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"TxAck\":{\"fields\":{\"tx\":{\"id\":1,\"type\":\"TransactionType\"}},\"nested\":{\"TransactionType\":{\"fields\":{\"bin_outputs\":{\"id\":3,\"rule\":\"repeated\",\"type\":\"TxOutputBinType\"},\"branch_id\":{\"id\":14,\"type\":\"uint32\"},\"expiry\":{\"id\":10,\"type\":\"uint32\"},\"extra_data\":{\"id\":8,\"type\":\"bytes\"},\"extra_data_len\":{\"id\":9,\"type\":\"uint32\"},\"inputs\":{\"id\":2,\"rule\":\"repeated\",\"type\":\"TxInputType\"},\"inputs_cnt\":{\"id\":6,\"type\":\"uint32\"},\"lock_time\":{\"id\":4,\"type\":\"uint32\"},\"outputs\":{\"id\":5,\"rule\":\"repeated\",\"type\":\"TxOutputType\"},\"outputs_cnt\":{\"id\":7,\"type\":\"uint32\"},\"overwintered\":{\"id\":11,\"options\":{\"deprecated\":true},\"type\":\"bool\"},\"timestamp\":{\"id\":13,\"type\":\"uint32\"},\"version\":{\"id\":1,\"type\":\"uint32\"},\"version_group_id\":{\"id\":12,\"type\":\"uint32\"}},\"nested\":{\"TxInputType\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"amount\":{\"id\":8,\"type\":\"uint64\"},\"commitment_data\":{\"id\":15,\"type\":\"bytes\"},\"decred_staking_spend\":{\"id\":18,\"type\":\"DecredStakingSpendType\"},\"decred_tree\":{\"id\":9,\"type\":\"uint32\"},\"multisig\":{\"id\":7,\"type\":\"MultisigRedeemScriptType\"},\"orig_hash\":{\"id\":16,\"type\":\"bytes\"},\"orig_index\":{\"id\":17,\"type\":\"uint32\"},\"ownership_proof\":{\"id\":14,\"type\":\"bytes\"},\"prev_hash\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"},\"prev_index\":{\"id\":3,\"rule\":\"required\",\"type\":\"uint32\"},\"script_pubkey\":{\"id\":19,\"type\":\"bytes\"},\"script_sig\":{\"id\":4,\"type\":\"bytes\"},\"script_type\":{\"id\":6,\"options\":{\"default\":\"SPENDADDRESS\"},\"type\":\"InputScriptType\"},\"sequence\":{\"id\":5,\"options\":{\"default\":4294967295},\"type\":\"uint32\"},\"witness\":{\"id\":13,\"type\":\"bytes\"}}},\"TxOutputBinType\":{\"fields\":{\"amount\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint64\"},\"decred_script_version\":{\"id\":3,\"type\":\"uint32\"},\"script_pubkey\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"TxOutputType\":{\"fields\":{\"address\":{\"id\":1,\"type\":\"string\"},\"address_n\":{\"id\":2,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"amount\":{\"id\":3,\"rule\":\"required\",\"type\":\"uint64\"},\"multisig\":{\"id\":5,\"type\":\"MultisigRedeemScriptType\"},\"op_return_data\":{\"id\":6,\"type\":\"bytes\"},\"orig_hash\":{\"id\":10,\"type\":\"bytes\"},\"orig_index\":{\"id\":11,\"type\":\"uint32\"},\"script_type\":{\"id\":4,\"options\":{\"default\":\"PAYTOADDRESS\"},\"type\":\"OutputScriptType\"}}}}}},\"options\":{\"deprecated\":true}},\"TxAckInput\":{\"fields\":{\"tx\":{\"id\":1,\"rule\":\"required\",\"type\":\"TxAckInputWrapper\"}},\"nested\":{\"TxAckInputWrapper\":{\"fields\":{\"input\":{\"id\":2,\"rule\":\"required\",\"type\":\"TxInput\"}}}},\"options\":{\"(wire_type)\":22}},\"TxAckOutput\":{\"fields\":{\"tx\":{\"id\":1,\"rule\":\"required\",\"type\":\"TxAckOutputWrapper\"}},\"nested\":{\"TxAckOutputWrapper\":{\"fields\":{\"output\":{\"id\":5,\"rule\":\"required\",\"type\":\"TxOutput\"}}}},\"options\":{\"(wire_type)\":22}},\"TxAckPrevExtraData\":{\"fields\":{\"tx\":{\"id\":1,\"rule\":\"required\",\"type\":\"TxAckPrevExtraDataWrapper\"}},\"nested\":{\"TxAckPrevExtraDataWrapper\":{\"fields\":{\"extra_data_chunk\":{\"id\":8,\"rule\":\"required\",\"type\":\"bytes\"}}}},\"options\":{\"(wire_type)\":22}},\"TxAckPrevInput\":{\"fields\":{\"tx\":{\"id\":1,\"rule\":\"required\",\"type\":\"TxAckPrevInputWrapper\"}},\"nested\":{\"TxAckPrevInputWrapper\":{\"fields\":{\"input\":{\"id\":2,\"rule\":\"required\",\"type\":\"PrevInput\"}}}},\"options\":{\"(wire_type)\":22}},\"TxAckPrevMeta\":{\"fields\":{\"tx\":{\"id\":1,\"rule\":\"required\",\"type\":\"PrevTx\"}},\"options\":{\"(wire_type)\":22}},\"TxAckPrevOutput\":{\"fields\":{\"tx\":{\"id\":1,\"rule\":\"required\",\"type\":\"TxAckPrevOutputWrapper\"}},\"nested\":{\"TxAckPrevOutputWrapper\":{\"fields\":{\"output\":{\"id\":3,\"rule\":\"required\",\"type\":\"PrevOutput\"}}}},\"options\":{\"(wire_type)\":22}},\"TxInput\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"amount\":{\"id\":8,\"rule\":\"required\",\"type\":\"uint64\"},\"commitment_data\":{\"id\":15,\"type\":\"bytes\"},\"decred_staking_spend\":{\"id\":18,\"type\":\"DecredStakingSpendType\"},\"decred_tree\":{\"id\":9,\"type\":\"uint32\"},\"multisig\":{\"id\":7,\"type\":\"MultisigRedeemScriptType\"},\"orig_hash\":{\"id\":16,\"type\":\"bytes\"},\"orig_index\":{\"id\":17,\"type\":\"uint32\"},\"ownership_proof\":{\"id\":14,\"type\":\"bytes\"},\"prev_hash\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"},\"prev_index\":{\"id\":3,\"rule\":\"required\",\"type\":\"uint32\"},\"script_pubkey\":{\"id\":19,\"type\":\"bytes\"},\"script_sig\":{\"id\":4,\"type\":\"bytes\"},\"script_type\":{\"id\":6,\"options\":{\"default\":\"SPENDADDRESS\"},\"type\":\"InputScriptType\"},\"sequence\":{\"id\":5,\"options\":{\"default\":4294967295},\"type\":\"uint32\"},\"witness\":{\"id\":13,\"type\":\"bytes\"}}},\"TxOutput\":{\"fields\":{\"address\":{\"id\":1,\"type\":\"string\"},\"address_n\":{\"id\":2,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"amount\":{\"id\":3,\"rule\":\"required\",\"type\":\"uint64\"},\"multisig\":{\"id\":5,\"type\":\"MultisigRedeemScriptType\"},\"op_return_data\":{\"id\":6,\"type\":\"bytes\"},\"orig_hash\":{\"id\":10,\"type\":\"bytes\"},\"orig_index\":{\"id\":11,\"type\":\"uint32\"},\"script_type\":{\"id\":4,\"options\":{\"default\":\"PAYTOADDRESS\"},\"type\":\"OutputScriptType\"}}},\"TxRequest\":{\"fields\":{\"details\":{\"id\":2,\"type\":\"TxRequestDetailsType\"},\"request_type\":{\"id\":1,\"type\":\"RequestType\"},\"serialized\":{\"id\":3,\"type\":\"TxRequestSerializedType\"}},\"nested\":{\"RequestType\":{\"values\":{\"TXEXTRADATA\":4,\"TXFINISHED\":3,\"TXINPUT\":0,\"TXMETA\":2,\"TXORIGINPUT\":5,\"TXORIGOUTPUT\":6,\"TXOUTPUT\":1}},\"TxRequestDetailsType\":{\"fields\":{\"extra_data_len\":{\"id\":3,\"type\":\"uint32\"},\"extra_data_offset\":{\"id\":4,\"type\":\"uint32\"},\"request_index\":{\"id\":1,\"type\":\"uint32\"},\"tx_hash\":{\"id\":2,\"type\":\"bytes\"}}},\"TxRequestSerializedType\":{\"fields\":{\"serialized_tx\":{\"id\":3,\"type\":\"bytes\"},\"signature\":{\"id\":2,\"type\":\"bytes\"},\"signature_index\":{\"id\":1,\"type\":\"uint32\"}}}}},\"VerifyMessage\":{\"fields\":{\"address\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"},\"coin_name\":{\"id\":4,\"options\":{\"default\":\"Bitcoin\"},\"type\":\"string\"},\"message\":{\"id\":3,\"rule\":\"required\",\"type\":\"bytes\"},\"signature\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"WebAuthnAddResidentCredential\":{\"fields\":{\"credential_id\":{\"id\":1,\"type\":\"bytes\"}}},\"WebAuthnCredentials\":{\"fields\":{\"credentials\":{\"id\":1,\"rule\":\"repeated\",\"type\":\"WebAuthnCredential\"}},\"nested\":{\"WebAuthnCredential\":{\"fields\":{\"algorithm\":{\"id\":11,\"type\":\"sint32\"},\"creation_time\":{\"id\":8,\"type\":\"uint32\"},\"curve\":{\"id\":12,\"type\":\"sint32\"},\"hmac_secret\":{\"id\":9,\"type\":\"bool\"},\"id\":{\"id\":2,\"type\":\"bytes\"},\"index\":{\"id\":1,\"type\":\"uint32\"},\"rp_id\":{\"id\":3,\"type\":\"string\"},\"rp_name\":{\"id\":4,\"type\":\"string\"},\"use_sign_count\":{\"id\":10,\"type\":\"bool\"},\"user_display_name\":{\"id\":7,\"type\":\"string\"},\"user_id\":{\"id\":5,\"type\":\"bytes\"},\"user_name\":{\"id\":6,\"type\":\"string\"}}}}},\"WebAuthnListResidentCredentials\":{\"fields\":{}},\"WebAuthnRemoveResidentCredential\":{\"fields\":{\"index\":{\"id\":1,\"type\":\"uint32\"}}},\"WipeDevice\":{\"fields\":{}},\"WordAck\":{\"fields\":{\"word\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"}}},\"WordRequest\":{\"fields\":{\"type\":{\"id\":1,\"rule\":\"required\",\"type\":\"WordRequestType\"}},\"nested\":{\"WordRequestType\":{\"values\":{\"WordRequestType_Matrix6\":2,\"WordRequestType_Matrix9\":1,\"WordRequestType_Plain\":0}}}},\"WriteSEPublicCert\":{\"fields\":{\"public_cert\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"ZoomRequest\":{\"fields\":{\"data_length\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint32\"},\"offset\":{\"id\":1,\"type\":\"uint32\"}}},\"bitcoin_only\":{\"extend\":\"google.protobuf.EnumValueOptions\",\"id\":60000,\"type\":\"bool\"},\"experimental\":{\"extend\":\"google.protobuf.FieldOptions\",\"id\":53001,\"type\":\"bool\"},\"facotry\":{\"extend\":\"google.protobuf.EnumValueOptions\",\"id\":50501,\"type\":\"bool\"},\"google\":{\"nested\":{\"protobuf\":{\"nested\":{\"DescriptorProto\":{\"fields\":{\"enum_type\":{\"id\":4,\"rule\":\"repeated\",\"type\":\"EnumDescriptorProto\"},\"extension\":{\"id\":6,\"rule\":\"repeated\",\"type\":\"FieldDescriptorProto\"},\"extension_range\":{\"id\":5,\"rule\":\"repeated\",\"type\":\"ExtensionRange\"},\"field\":{\"id\":2,\"rule\":\"repeated\",\"type\":\"FieldDescriptorProto\"},\"name\":{\"id\":1,\"type\":\"string\"},\"nested_type\":{\"id\":3,\"rule\":\"repeated\",\"type\":\"DescriptorProto\"},\"oneof_decl\":{\"id\":8,\"rule\":\"repeated\",\"type\":\"OneofDescriptorProto\"},\"options\":{\"id\":7,\"type\":\"MessageOptions\"},\"reserved_name\":{\"id\":10,\"rule\":\"repeated\",\"type\":\"string\"},\"reserved_range\":{\"id\":9,\"rule\":\"repeated\",\"type\":\"ReservedRange\"}},\"nested\":{\"ExtensionRange\":{\"fields\":{\"end\":{\"id\":2,\"type\":\"int32\"},\"start\":{\"id\":1,\"type\":\"int32\"}}},\"ReservedRange\":{\"fields\":{\"end\":{\"id\":2,\"type\":\"int32\"},\"start\":{\"id\":1,\"type\":\"int32\"}}}}},\"EnumDescriptorProto\":{\"fields\":{\"name\":{\"id\":1,\"type\":\"string\"},\"options\":{\"id\":3,\"type\":\"EnumOptions\"},\"value\":{\"id\":2,\"rule\":\"repeated\",\"type\":\"EnumValueDescriptorProto\"}}},\"EnumOptions\":{\"extensions\":[[1000,536870911]],\"fields\":{\"allow_alias\":{\"id\":2,\"type\":\"bool\"},\"deprecated\":{\"id\":3,\"type\":\"bool\"},\"uninterpreted_option\":{\"id\":999,\"rule\":\"repeated\",\"type\":\"UninterpretedOption\"}}},\"EnumValueDescriptorProto\":{\"fields\":{\"name\":{\"id\":1,\"type\":\"string\"},\"number\":{\"id\":2,\"type\":\"int32\"},\"options\":{\"id\":3,\"type\":\"EnumValueOptions\"}}},\"EnumValueOptions\":{\"extensions\":[[1000,536870911]],\"fields\":{\"deprecated\":{\"id\":1,\"type\":\"bool\"},\"uninterpreted_option\":{\"id\":999,\"rule\":\"repeated\",\"type\":\"UninterpretedOption\"}}},\"FieldDescriptorProto\":{\"fields\":{\"default_value\":{\"id\":7,\"type\":\"string\"},\"extendee\":{\"id\":2,\"type\":\"string\"},\"json_name\":{\"id\":10,\"type\":\"string\"},\"label\":{\"id\":4,\"type\":\"Label\"},\"name\":{\"id\":1,\"type\":\"string\"},\"number\":{\"id\":3,\"type\":\"int32\"},\"oneof_index\":{\"id\":9,\"type\":\"int32\"},\"options\":{\"id\":8,\"type\":\"FieldOptions\"},\"type\":{\"id\":5,\"type\":\"Type\"},\"type_name\":{\"id\":6,\"type\":\"string\"}},\"nested\":{\"Label\":{\"values\":{\"LABEL_OPTIONAL\":1,\"LABEL_REPEATED\":3,\"LABEL_REQUIRED\":2}},\"Type\":{\"values\":{\"TYPE_BOOL\":8,\"TYPE_BYTES\":12,\"TYPE_DOUBLE\":1,\"TYPE_ENUM\":14,\"TYPE_FIXED32\":7,\"TYPE_FIXED64\":6,\"TYPE_FLOAT\":2,\"TYPE_GROUP\":10,\"TYPE_INT32\":5,\"TYPE_INT64\":3,\"TYPE_MESSAGE\":11,\"TYPE_SFIXED32\":15,\"TYPE_SFIXED64\":16,\"TYPE_SINT32\":17,\"TYPE_SINT64\":18,\"TYPE_STRING\":9,\"TYPE_UINT32\":13,\"TYPE_UINT64\":4}}}},\"FieldOptions\":{\"extensions\":[[1000,536870911]],\"fields\":{\"ctype\":{\"id\":1,\"options\":{\"default\":\"STRING\"},\"type\":\"CType\"},\"deprecated\":{\"id\":3,\"type\":\"bool\"},\"jstype\":{\"id\":6,\"options\":{\"default\":\"JS_NORMAL\"},\"type\":\"JSType\"},\"lazy\":{\"id\":5,\"type\":\"bool\"},\"packed\":{\"id\":2,\"type\":\"bool\"},\"uninterpreted_option\":{\"id\":999,\"rule\":\"repeated\",\"type\":\"UninterpretedOption\"},\"weak\":{\"id\":10,\"type\":\"bool\"}},\"nested\":{\"CType\":{\"values\":{\"CORD\":1,\"STRING\":0,\"STRING_PIECE\":2}},\"JSType\":{\"values\":{\"JS_NORMAL\":0,\"JS_NUMBER\":2,\"JS_STRING\":1}}},\"reserved\":[[4,4]]},\"FileDescriptorProto\":{\"fields\":{\"dependency\":{\"id\":3,\"rule\":\"repeated\",\"type\":\"string\"},\"enum_type\":{\"id\":5,\"rule\":\"repeated\",\"type\":\"EnumDescriptorProto\"},\"extension\":{\"id\":7,\"rule\":\"repeated\",\"type\":\"FieldDescriptorProto\"},\"message_type\":{\"id\":4,\"rule\":\"repeated\",\"type\":\"DescriptorProto\"},\"name\":{\"id\":1,\"type\":\"string\"},\"options\":{\"id\":8,\"type\":\"FileOptions\"},\"package\":{\"id\":2,\"type\":\"string\"},\"public_dependency\":{\"id\":10,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"int32\"},\"service\":{\"id\":6,\"rule\":\"repeated\",\"type\":\"ServiceDescriptorProto\"},\"source_code_info\":{\"id\":9,\"type\":\"SourceCodeInfo\"},\"syntax\":{\"id\":12,\"type\":\"string\"},\"weak_dependency\":{\"id\":11,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"int32\"}}},\"FileDescriptorSet\":{\"fields\":{\"file\":{\"id\":1,\"rule\":\"repeated\",\"type\":\"FileDescriptorProto\"}}},\"FileOptions\":{\"extensions\":[[1000,536870911]],\"fields\":{\"cc_enable_arenas\":{\"id\":31,\"type\":\"bool\"},\"cc_generic_services\":{\"id\":16,\"type\":\"bool\"},\"csharp_namespace\":{\"id\":37,\"type\":\"string\"},\"deprecated\":{\"id\":23,\"type\":\"bool\"},\"go_package\":{\"id\":11,\"type\":\"string\"},\"java_generate_equals_and_hash\":{\"id\":20,\"options\":{\"deprecated\":true},\"type\":\"bool\"},\"java_generic_services\":{\"id\":17,\"type\":\"bool\"},\"java_multiple_files\":{\"id\":10,\"type\":\"bool\"},\"java_outer_classname\":{\"id\":8,\"type\":\"string\"},\"java_package\":{\"id\":1,\"type\":\"string\"},\"java_string_check_utf8\":{\"id\":27,\"type\":\"bool\"},\"objc_class_prefix\":{\"id\":36,\"type\":\"string\"},\"optimize_for\":{\"id\":9,\"options\":{\"default\":\"SPEED\"},\"type\":\"OptimizeMode\"},\"py_generic_services\":{\"id\":18,\"type\":\"bool\"},\"uninterpreted_option\":{\"id\":999,\"rule\":\"repeated\",\"type\":\"UninterpretedOption\"}},\"nested\":{\"OptimizeMode\":{\"values\":{\"CODE_SIZE\":2,\"LITE_RUNTIME\":3,\"SPEED\":1}}},\"reserved\":[[38,38]]},\"GeneratedCodeInfo\":{\"fields\":{\"annotation\":{\"id\":1,\"rule\":\"repeated\",\"type\":\"Annotation\"}},\"nested\":{\"Annotation\":{\"fields\":{\"begin\":{\"id\":3,\"type\":\"int32\"},\"end\":{\"id\":4,\"type\":\"int32\"},\"path\":{\"id\":1,\"rule\":\"repeated\",\"type\":\"int32\"},\"source_file\":{\"id\":2,\"type\":\"string\"}}}}},\"MessageOptions\":{\"extensions\":[[1000,536870911]],\"fields\":{\"deprecated\":{\"id\":3,\"type\":\"bool\"},\"map_entry\":{\"id\":7,\"type\":\"bool\"},\"message_set_wire_format\":{\"id\":1,\"type\":\"bool\"},\"no_standard_descriptor_accessor\":{\"id\":2,\"type\":\"bool\"},\"uninterpreted_option\":{\"id\":999,\"rule\":\"repeated\",\"type\":\"UninterpretedOption\"}},\"reserved\":[[8,8]]},\"MethodDescriptorProto\":{\"fields\":{\"client_streaming\":{\"id\":5,\"type\":\"bool\"},\"input_type\":{\"id\":2,\"type\":\"string\"},\"name\":{\"id\":1,\"type\":\"string\"},\"options\":{\"id\":4,\"type\":\"MethodOptions\"},\"output_type\":{\"id\":3,\"type\":\"string\"},\"server_streaming\":{\"id\":6,\"type\":\"bool\"}}},\"MethodOptions\":{\"extensions\":[[1000,536870911]],\"fields\":{\"deprecated\":{\"id\":33,\"type\":\"bool\"},\"uninterpreted_option\":{\"id\":999,\"rule\":\"repeated\",\"type\":\"UninterpretedOption\"}}},\"OneofDescriptorProto\":{\"fields\":{\"name\":{\"id\":1,\"type\":\"string\"},\"options\":{\"id\":2,\"type\":\"OneofOptions\"}}},\"OneofOptions\":{\"extensions\":[[1000,536870911]],\"fields\":{\"uninterpreted_option\":{\"id\":999,\"rule\":\"repeated\",\"type\":\"UninterpretedOption\"}}},\"ServiceDescriptorProto\":{\"fields\":{\"method\":{\"id\":2,\"rule\":\"repeated\",\"type\":\"MethodDescriptorProto\"},\"name\":{\"id\":1,\"type\":\"string\"},\"options\":{\"id\":3,\"type\":\"ServiceOptions\"}}},\"ServiceOptions\":{\"extensions\":[[1000,536870911]],\"fields\":{\"deprecated\":{\"id\":33,\"type\":\"bool\"},\"uninterpreted_option\":{\"id\":999,\"rule\":\"repeated\",\"type\":\"UninterpretedOption\"}}},\"SourceCodeInfo\":{\"fields\":{\"location\":{\"id\":1,\"rule\":\"repeated\",\"type\":\"Location\"}},\"nested\":{\"Location\":{\"fields\":{\"leading_comments\":{\"id\":3,\"type\":\"string\"},\"leading_detached_comments\":{\"id\":6,\"rule\":\"repeated\",\"type\":\"string\"},\"path\":{\"id\":1,\"rule\":\"repeated\",\"type\":\"int32\"},\"span\":{\"id\":2,\"rule\":\"repeated\",\"type\":\"int32\"},\"trailing_comments\":{\"id\":4,\"type\":\"string\"}}}}},\"UninterpretedOption\":{\"fields\":{\"aggregate_value\":{\"id\":8,\"type\":\"string\"},\"double_value\":{\"id\":6,\"type\":\"double\"},\"identifier_value\":{\"id\":3,\"type\":\"string\"},\"name\":{\"id\":2,\"rule\":\"repeated\",\"type\":\"NamePart\"},\"negative_int_value\":{\"id\":5,\"type\":\"int64\"},\"positive_int_value\":{\"id\":4,\"type\":\"uint64\"},\"string_value\":{\"id\":7,\"type\":\"bytes\"}},\"nested\":{\"NamePart\":{\"fields\":{\"is_extension\":{\"id\":2,\"rule\":\"required\",\"type\":\"bool\"},\"name_part\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"}}}}}}}}},\"has_bitcoin_only_values\":{\"extend\":\"google.protobuf.EnumOptions\",\"id\":51001,\"type\":\"bool\"},\"include_in_bitcoin_only\":{\"extend\":\"google.protobuf.FileOptions\",\"id\":60000,\"type\":\"bool\"},\"unstable\":{\"extend\":\"google.protobuf.MessageOptions\",\"id\":52001,\"type\":\"bool\"},\"wire_bootloader\":{\"extend\":\"google.protobuf.EnumValueOptions\",\"id\":50007,\"type\":\"bool\"},\"wire_debug_in\":{\"extend\":\"google.protobuf.EnumValueOptions\",\"id\":50004,\"type\":\"bool\"},\"wire_debug_out\":{\"extend\":\"google.protobuf.EnumValueOptions\",\"id\":50005,\"type\":\"bool\"},\"wire_in\":{\"extend\":\"google.protobuf.EnumValueOptions\",\"id\":50002,\"type\":\"bool\"},\"wire_no_fsm\":{\"extend\":\"google.protobuf.EnumValueOptions\",\"id\":50008,\"type\":\"bool\"},\"wire_out\":{\"extend\":\"google.protobuf.EnumValueOptions\",\"id\":50003,\"type\":\"bool\"},\"wire_tiny\":{\"extend\":\"google.protobuf.EnumValueOptions\",\"id\":50006,\"type\":\"bool\"},\"wire_type\":{\"extend\":\"google.protobuf.MessageOptions\",\"id\":52002,\"type\":\"uint32\"}}}": function () {
const $protobuf = { ...protobuf, roots: {} };
var $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

var $root = $protobuf.roots["onekey-csp-1"] || ($protobuf.roots["onekey-csp-1"] = {});

$root.AlgorandGetAddress = (function() {

    function AlgorandGetAddress(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    AlgorandGetAddress.prototype.address_n = $util.emptyArray;
    AlgorandGetAddress.prototype.show_display = false;

    AlgorandGetAddress.create = function create(properties) {
        return new AlgorandGetAddress(properties);
    };

    AlgorandGetAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(24).bool(message.show_display);
        return writer;
    };

    AlgorandGetAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    AlgorandGetAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.AlgorandGetAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 3:
                message.show_display = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    AlgorandGetAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    AlgorandGetAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        return null;
    };

    AlgorandGetAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.AlgorandGetAddress)
            return object;
        var message = new $root.AlgorandGetAddress();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".AlgorandGetAddress.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        return message;
    };

    AlgorandGetAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            object.show_display = false;
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        return object;
    };

    AlgorandGetAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return AlgorandGetAddress;
})();

$root.AlgorandAddress = (function() {

    function AlgorandAddress(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    AlgorandAddress.prototype.address = "";

    AlgorandAddress.create = function create(properties) {
        return new AlgorandAddress(properties);
    };

    AlgorandAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address != null && Object.hasOwnProperty.call(message, "address"))
            writer.uint32(10).string(message.address);
        return writer;
    };

    AlgorandAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    AlgorandAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.AlgorandAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    AlgorandAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    AlgorandAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address != null && message.hasOwnProperty("address"))
            if (!$util.isString(message.address))
                return "address: string expected";
        return null;
    };

    AlgorandAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.AlgorandAddress)
            return object;
        var message = new $root.AlgorandAddress();
        if (object.address != null)
            message.address = String(object.address);
        return message;
    };

    AlgorandAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.address = "";
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    AlgorandAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return AlgorandAddress;
})();

$root.AlgorandSignTx = (function() {

    function AlgorandSignTx(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    AlgorandSignTx.prototype.address_n = $util.emptyArray;
    AlgorandSignTx.prototype.raw_tx = $util.newBuffer([]);

    AlgorandSignTx.create = function create(properties) {
        return new AlgorandSignTx(properties);
    };

    AlgorandSignTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).bytes(message.raw_tx);
        return writer;
    };

    AlgorandSignTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    AlgorandSignTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.AlgorandSignTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.raw_tx = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("raw_tx"))
            throw $util.ProtocolError("missing required 'raw_tx'", { instance: message });
        return message;
    };

    AlgorandSignTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    AlgorandSignTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!(message.raw_tx && typeof message.raw_tx.length === "number" || $util.isString(message.raw_tx)))
            return "raw_tx: buffer expected";
        return null;
    };

    AlgorandSignTx.fromObject = function fromObject(object) {
        if (object instanceof $root.AlgorandSignTx)
            return object;
        var message = new $root.AlgorandSignTx();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".AlgorandSignTx.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.raw_tx != null)
            if (typeof object.raw_tx === "string")
                $util.base64.decode(object.raw_tx, message.raw_tx = $util.newBuffer($util.base64.length(object.raw_tx)), 0);
            else if (object.raw_tx.length)
                message.raw_tx = object.raw_tx;
        return message;
    };

    AlgorandSignTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            if (options.bytes === String)
                object.raw_tx = "";
            else {
                object.raw_tx = [];
                if (options.bytes !== Array)
                    object.raw_tx = $util.newBuffer(object.raw_tx);
            }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.raw_tx != null && message.hasOwnProperty("raw_tx"))
            object.raw_tx = options.bytes === String ? $util.base64.encode(message.raw_tx, 0, message.raw_tx.length) : options.bytes === Array ? Array.prototype.slice.call(message.raw_tx) : message.raw_tx;
        return object;
    };

    AlgorandSignTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return AlgorandSignTx;
})();

$root.AlgorandSignedTx = (function() {

    function AlgorandSignedTx(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    AlgorandSignedTx.prototype.signature = $util.newBuffer([]);

    AlgorandSignedTx.create = function create(properties) {
        return new AlgorandSignedTx(properties);
    };

    AlgorandSignedTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.signature);
        return writer;
    };

    AlgorandSignedTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    AlgorandSignedTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.AlgorandSignedTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.signature = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        return message;
    };

    AlgorandSignedTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    AlgorandSignedTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        return null;
    };

    AlgorandSignedTx.fromObject = function fromObject(object) {
        if (object instanceof $root.AlgorandSignedTx)
            return object;
        var message = new $root.AlgorandSignedTx();
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        return message;
    };

    AlgorandSignedTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        return object;
    };

    AlgorandSignedTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return AlgorandSignedTx;
})();

$root.AptosGetAddress = (function() {

    function AptosGetAddress(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    AptosGetAddress.prototype.address_n = $util.emptyArray;
    AptosGetAddress.prototype.show_display = false;

    AptosGetAddress.create = function create(properties) {
        return new AptosGetAddress(properties);
    };

    AptosGetAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(16).bool(message.show_display);
        return writer;
    };

    AptosGetAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    AptosGetAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.AptosGetAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.show_display = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    AptosGetAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    AptosGetAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        return null;
    };

    AptosGetAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.AptosGetAddress)
            return object;
        var message = new $root.AptosGetAddress();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".AptosGetAddress.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        return message;
    };

    AptosGetAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            object.show_display = false;
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        return object;
    };

    AptosGetAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return AptosGetAddress;
})();

$root.AptosAddress = (function() {

    function AptosAddress(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    AptosAddress.prototype.address = "";

    AptosAddress.create = function create(properties) {
        return new AptosAddress(properties);
    };

    AptosAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address != null && Object.hasOwnProperty.call(message, "address"))
            writer.uint32(10).string(message.address);
        return writer;
    };

    AptosAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    AptosAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.AptosAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    AptosAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    AptosAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address != null && message.hasOwnProperty("address"))
            if (!$util.isString(message.address))
                return "address: string expected";
        return null;
    };

    AptosAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.AptosAddress)
            return object;
        var message = new $root.AptosAddress();
        if (object.address != null)
            message.address = String(object.address);
        return message;
    };

    AptosAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.address = "";
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    AptosAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return AptosAddress;
})();

$root.AptosSignTx = (function() {

    function AptosSignTx(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    AptosSignTx.prototype.address_n = $util.emptyArray;
    AptosSignTx.prototype.raw_tx = $util.newBuffer([]);

    AptosSignTx.create = function create(properties) {
        return new AptosSignTx(properties);
    };

    AptosSignTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).bytes(message.raw_tx);
        return writer;
    };

    AptosSignTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    AptosSignTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.AptosSignTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.raw_tx = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("raw_tx"))
            throw $util.ProtocolError("missing required 'raw_tx'", { instance: message });
        return message;
    };

    AptosSignTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    AptosSignTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!(message.raw_tx && typeof message.raw_tx.length === "number" || $util.isString(message.raw_tx)))
            return "raw_tx: buffer expected";
        return null;
    };

    AptosSignTx.fromObject = function fromObject(object) {
        if (object instanceof $root.AptosSignTx)
            return object;
        var message = new $root.AptosSignTx();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".AptosSignTx.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.raw_tx != null)
            if (typeof object.raw_tx === "string")
                $util.base64.decode(object.raw_tx, message.raw_tx = $util.newBuffer($util.base64.length(object.raw_tx)), 0);
            else if (object.raw_tx.length)
                message.raw_tx = object.raw_tx;
        return message;
    };

    AptosSignTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            if (options.bytes === String)
                object.raw_tx = "";
            else {
                object.raw_tx = [];
                if (options.bytes !== Array)
                    object.raw_tx = $util.newBuffer(object.raw_tx);
            }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.raw_tx != null && message.hasOwnProperty("raw_tx"))
            object.raw_tx = options.bytes === String ? $util.base64.encode(message.raw_tx, 0, message.raw_tx.length) : options.bytes === Array ? Array.prototype.slice.call(message.raw_tx) : message.raw_tx;
        return object;
    };

    AptosSignTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return AptosSignTx;
})();

$root.AptosSignedTx = (function() {

    function AptosSignedTx(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    AptosSignedTx.prototype.public_key = $util.newBuffer([]);
    AptosSignedTx.prototype.signature = $util.newBuffer([]);

    AptosSignedTx.create = function create(properties) {
        return new AptosSignedTx(properties);
    };

    AptosSignedTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.public_key);
        writer.uint32(18).bytes(message.signature);
        return writer;
    };

    AptosSignedTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    AptosSignedTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.AptosSignedTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.public_key = reader.bytes();
                break;
            case 2:
                message.signature = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("public_key"))
            throw $util.ProtocolError("missing required 'public_key'", { instance: message });
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        return message;
    };

    AptosSignedTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    AptosSignedTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.public_key && typeof message.public_key.length === "number" || $util.isString(message.public_key)))
            return "public_key: buffer expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        return null;
    };

    AptosSignedTx.fromObject = function fromObject(object) {
        if (object instanceof $root.AptosSignedTx)
            return object;
        var message = new $root.AptosSignedTx();
        if (object.public_key != null)
            if (typeof object.public_key === "string")
                $util.base64.decode(object.public_key, message.public_key = $util.newBuffer($util.base64.length(object.public_key)), 0);
            else if (object.public_key.length)
                message.public_key = object.public_key;
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        return message;
    };

    AptosSignedTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.public_key = "";
            else {
                object.public_key = [];
                if (options.bytes !== Array)
                    object.public_key = $util.newBuffer(object.public_key);
            }
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
        }
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            object.public_key = options.bytes === String ? $util.base64.encode(message.public_key, 0, message.public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.public_key) : message.public_key;
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        return object;
    };

    AptosSignedTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return AptosSignedTx;
})();

$root.AptosSignMessage = (function() {

    function AptosSignMessage(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    AptosSignMessage.prototype.address_n = $util.emptyArray;
    AptosSignMessage.prototype.payload = null;

    AptosSignMessage.create = function create(properties) {
        return new AptosSignMessage(properties);
    };

    AptosSignMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        $root.AptosSignMessage.AptosMessagePayload.encode(message.payload, writer.uint32(18).fork()).ldelim();
        return writer;
    };

    AptosSignMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    AptosSignMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.AptosSignMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.payload = $root.AptosSignMessage.AptosMessagePayload.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("payload"))
            throw $util.ProtocolError("missing required 'payload'", { instance: message });
        return message;
    };

    AptosSignMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    AptosSignMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        {
            var error = $root.AptosSignMessage.AptosMessagePayload.verify(message.payload);
            if (error)
                return "payload." + error;
        }
        return null;
    };

    AptosSignMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.AptosSignMessage)
            return object;
        var message = new $root.AptosSignMessage();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".AptosSignMessage.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.payload != null) {
            if (typeof object.payload !== "object")
                throw TypeError(".AptosSignMessage.payload: object expected");
            message.payload = $root.AptosSignMessage.AptosMessagePayload.fromObject(object.payload);
        }
        return message;
    };

    AptosSignMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            object.payload = null;
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.payload != null && message.hasOwnProperty("payload"))
            object.payload = $root.AptosSignMessage.AptosMessagePayload.toObject(message.payload, options);
        return object;
    };

    AptosSignMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    AptosSignMessage.AptosMessagePayload = (function() {

        function AptosMessagePayload(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        AptosMessagePayload.prototype.address = "";
        AptosMessagePayload.prototype.chain_id = "";
        AptosMessagePayload.prototype.application = "";
        AptosMessagePayload.prototype.nonce = "";
        AptosMessagePayload.prototype.message = "";

        AptosMessagePayload.create = function create(properties) {
            return new AptosMessagePayload(properties);
        };

        AptosMessagePayload.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.address != null && Object.hasOwnProperty.call(message, "address"))
                writer.uint32(18).string(message.address);
            if (message.chain_id != null && Object.hasOwnProperty.call(message, "chain_id"))
                writer.uint32(26).string(message.chain_id);
            if (message.application != null && Object.hasOwnProperty.call(message, "application"))
                writer.uint32(34).string(message.application);
            writer.uint32(42).string(message.nonce);
            writer.uint32(50).string(message.message);
            return writer;
        };

        AptosMessagePayload.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        AptosMessagePayload.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.AptosSignMessage.AptosMessagePayload();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 2:
                    message.address = reader.string();
                    break;
                case 3:
                    message.chain_id = reader.string();
                    break;
                case 4:
                    message.application = reader.string();
                    break;
                case 5:
                    message.nonce = reader.string();
                    break;
                case 6:
                    message.message = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("nonce"))
                throw $util.ProtocolError("missing required 'nonce'", { instance: message });
            if (!message.hasOwnProperty("message"))
                throw $util.ProtocolError("missing required 'message'", { instance: message });
            return message;
        };

        AptosMessagePayload.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        AptosMessagePayload.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.address != null && message.hasOwnProperty("address"))
                if (!$util.isString(message.address))
                    return "address: string expected";
            if (message.chain_id != null && message.hasOwnProperty("chain_id"))
                if (!$util.isString(message.chain_id))
                    return "chain_id: string expected";
            if (message.application != null && message.hasOwnProperty("application"))
                if (!$util.isString(message.application))
                    return "application: string expected";
            if (!$util.isString(message.nonce))
                return "nonce: string expected";
            if (!$util.isString(message.message))
                return "message: string expected";
            return null;
        };

        AptosMessagePayload.fromObject = function fromObject(object) {
            if (object instanceof $root.AptosSignMessage.AptosMessagePayload)
                return object;
            var message = new $root.AptosSignMessage.AptosMessagePayload();
            if (object.address != null)
                message.address = String(object.address);
            if (object.chain_id != null)
                message.chain_id = String(object.chain_id);
            if (object.application != null)
                message.application = String(object.application);
            if (object.nonce != null)
                message.nonce = String(object.nonce);
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        AptosMessagePayload.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.address = "";
                object.chain_id = "";
                object.application = "";
                object.nonce = "";
                object.message = "";
            }
            if (message.address != null && message.hasOwnProperty("address"))
                object.address = message.address;
            if (message.chain_id != null && message.hasOwnProperty("chain_id"))
                object.chain_id = message.chain_id;
            if (message.application != null && message.hasOwnProperty("application"))
                object.application = message.application;
            if (message.nonce != null && message.hasOwnProperty("nonce"))
                object.nonce = message.nonce;
            if (message.message != null && message.hasOwnProperty("message"))
                object.message = message.message;
            return object;
        };

        AptosMessagePayload.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AptosMessagePayload;
    })();

    return AptosSignMessage;
})();

$root.AptosMessageSignature = (function() {

    function AptosMessageSignature(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    AptosMessageSignature.prototype.signature = $util.newBuffer([]);
    AptosMessageSignature.prototype.address = "";

    AptosMessageSignature.create = function create(properties) {
        return new AptosMessageSignature(properties);
    };

    AptosMessageSignature.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.signature);
        writer.uint32(18).string(message.address);
        return writer;
    };

    AptosMessageSignature.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    AptosMessageSignature.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.AptosMessageSignature();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.signature = reader.bytes();
                break;
            case 2:
                message.address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        if (!message.hasOwnProperty("address"))
            throw $util.ProtocolError("missing required 'address'", { instance: message });
        return message;
    };

    AptosMessageSignature.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    AptosMessageSignature.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        if (!$util.isString(message.address))
            return "address: string expected";
        return null;
    };

    AptosMessageSignature.fromObject = function fromObject(object) {
        if (object instanceof $root.AptosMessageSignature)
            return object;
        var message = new $root.AptosMessageSignature();
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        if (object.address != null)
            message.address = String(object.address);
        return message;
    };

    AptosMessageSignature.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
            object.address = "";
        }
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    AptosMessageSignature.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return AptosMessageSignature;
})();

$root.BinanceGetAddress = (function() {

    function BinanceGetAddress(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    BinanceGetAddress.prototype.address_n = $util.emptyArray;
    BinanceGetAddress.prototype.show_display = false;

    BinanceGetAddress.create = function create(properties) {
        return new BinanceGetAddress(properties);
    };

    BinanceGetAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(16).bool(message.show_display);
        return writer;
    };

    BinanceGetAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    BinanceGetAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BinanceGetAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.show_display = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    BinanceGetAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    BinanceGetAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        return null;
    };

    BinanceGetAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.BinanceGetAddress)
            return object;
        var message = new $root.BinanceGetAddress();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".BinanceGetAddress.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        return message;
    };

    BinanceGetAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            object.show_display = false;
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        return object;
    };

    BinanceGetAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return BinanceGetAddress;
})();

$root.BinanceAddress = (function() {

    function BinanceAddress(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    BinanceAddress.prototype.address = "";

    BinanceAddress.create = function create(properties) {
        return new BinanceAddress(properties);
    };

    BinanceAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.address);
        return writer;
    };

    BinanceAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    BinanceAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BinanceAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("address"))
            throw $util.ProtocolError("missing required 'address'", { instance: message });
        return message;
    };

    BinanceAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    BinanceAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.address))
            return "address: string expected";
        return null;
    };

    BinanceAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.BinanceAddress)
            return object;
        var message = new $root.BinanceAddress();
        if (object.address != null)
            message.address = String(object.address);
        return message;
    };

    BinanceAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.address = "";
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    BinanceAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return BinanceAddress;
})();

$root.BinanceGetPublicKey = (function() {

    function BinanceGetPublicKey(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    BinanceGetPublicKey.prototype.address_n = $util.emptyArray;
    BinanceGetPublicKey.prototype.show_display = false;

    BinanceGetPublicKey.create = function create(properties) {
        return new BinanceGetPublicKey(properties);
    };

    BinanceGetPublicKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(16).bool(message.show_display);
        return writer;
    };

    BinanceGetPublicKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    BinanceGetPublicKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BinanceGetPublicKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.show_display = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    BinanceGetPublicKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    BinanceGetPublicKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        return null;
    };

    BinanceGetPublicKey.fromObject = function fromObject(object) {
        if (object instanceof $root.BinanceGetPublicKey)
            return object;
        var message = new $root.BinanceGetPublicKey();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".BinanceGetPublicKey.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        return message;
    };

    BinanceGetPublicKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            object.show_display = false;
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        return object;
    };

    BinanceGetPublicKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return BinanceGetPublicKey;
})();

$root.BinancePublicKey = (function() {

    function BinancePublicKey(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    BinancePublicKey.prototype.public_key = $util.newBuffer([]);

    BinancePublicKey.create = function create(properties) {
        return new BinancePublicKey(properties);
    };

    BinancePublicKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.public_key);
        return writer;
    };

    BinancePublicKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    BinancePublicKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BinancePublicKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.public_key = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("public_key"))
            throw $util.ProtocolError("missing required 'public_key'", { instance: message });
        return message;
    };

    BinancePublicKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    BinancePublicKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.public_key && typeof message.public_key.length === "number" || $util.isString(message.public_key)))
            return "public_key: buffer expected";
        return null;
    };

    BinancePublicKey.fromObject = function fromObject(object) {
        if (object instanceof $root.BinancePublicKey)
            return object;
        var message = new $root.BinancePublicKey();
        if (object.public_key != null)
            if (typeof object.public_key === "string")
                $util.base64.decode(object.public_key, message.public_key = $util.newBuffer($util.base64.length(object.public_key)), 0);
            else if (object.public_key.length)
                message.public_key = object.public_key;
        return message;
    };

    BinancePublicKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.public_key = "";
            else {
                object.public_key = [];
                if (options.bytes !== Array)
                    object.public_key = $util.newBuffer(object.public_key);
            }
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            object.public_key = options.bytes === String ? $util.base64.encode(message.public_key, 0, message.public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.public_key) : message.public_key;
        return object;
    };

    BinancePublicKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return BinancePublicKey;
})();

$root.BinanceSignTx = (function() {

    function BinanceSignTx(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    BinanceSignTx.prototype.address_n = $util.emptyArray;
    BinanceSignTx.prototype.msg_count = 0;
    BinanceSignTx.prototype.account_number = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    BinanceSignTx.prototype.chain_id = "";
    BinanceSignTx.prototype.memo = "";
    BinanceSignTx.prototype.sequence = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    BinanceSignTx.prototype.source = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    BinanceSignTx.create = function create(properties) {
        return new BinanceSignTx(properties);
    };

    BinanceSignTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.msg_count != null && Object.hasOwnProperty.call(message, "msg_count"))
            writer.uint32(16).uint32(message.msg_count);
        if (message.account_number != null && Object.hasOwnProperty.call(message, "account_number"))
            writer.uint32(24).sint64(message.account_number);
        if (message.chain_id != null && Object.hasOwnProperty.call(message, "chain_id"))
            writer.uint32(34).string(message.chain_id);
        if (message.memo != null && Object.hasOwnProperty.call(message, "memo"))
            writer.uint32(42).string(message.memo);
        if (message.sequence != null && Object.hasOwnProperty.call(message, "sequence"))
            writer.uint32(48).sint64(message.sequence);
        if (message.source != null && Object.hasOwnProperty.call(message, "source"))
            writer.uint32(56).sint64(message.source);
        return writer;
    };

    BinanceSignTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    BinanceSignTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BinanceSignTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.msg_count = reader.uint32();
                break;
            case 3:
                message.account_number = reader.sint64();
                break;
            case 4:
                message.chain_id = reader.string();
                break;
            case 5:
                message.memo = reader.string();
                break;
            case 6:
                message.sequence = reader.sint64();
                break;
            case 7:
                message.source = reader.sint64();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    BinanceSignTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    BinanceSignTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.msg_count != null && message.hasOwnProperty("msg_count"))
            if (!$util.isInteger(message.msg_count))
                return "msg_count: integer expected";
        if (message.account_number != null && message.hasOwnProperty("account_number"))
            if (!$util.isInteger(message.account_number) && !(message.account_number && $util.isInteger(message.account_number.low) && $util.isInteger(message.account_number.high)))
                return "account_number: integer|Long expected";
        if (message.chain_id != null && message.hasOwnProperty("chain_id"))
            if (!$util.isString(message.chain_id))
                return "chain_id: string expected";
        if (message.memo != null && message.hasOwnProperty("memo"))
            if (!$util.isString(message.memo))
                return "memo: string expected";
        if (message.sequence != null && message.hasOwnProperty("sequence"))
            if (!$util.isInteger(message.sequence) && !(message.sequence && $util.isInteger(message.sequence.low) && $util.isInteger(message.sequence.high)))
                return "sequence: integer|Long expected";
        if (message.source != null && message.hasOwnProperty("source"))
            if (!$util.isInteger(message.source) && !(message.source && $util.isInteger(message.source.low) && $util.isInteger(message.source.high)))
                return "source: integer|Long expected";
        return null;
    };

    BinanceSignTx.fromObject = function fromObject(object) {
        if (object instanceof $root.BinanceSignTx)
            return object;
        var message = new $root.BinanceSignTx();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".BinanceSignTx.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.msg_count != null)
            message.msg_count = object.msg_count >>> 0;
        if (object.account_number != null)
            if ($util.Long)
                (message.account_number = $util.Long.fromValue(object.account_number)).unsigned = false;
            else if (typeof object.account_number === "string")
                message.account_number = parseInt(object.account_number, 10);
            else if (typeof object.account_number === "number")
                message.account_number = object.account_number;
            else if (typeof object.account_number === "object")
                message.account_number = new $util.LongBits(object.account_number.low >>> 0, object.account_number.high >>> 0).toNumber();
        if (object.chain_id != null)
            message.chain_id = String(object.chain_id);
        if (object.memo != null)
            message.memo = String(object.memo);
        if (object.sequence != null)
            if ($util.Long)
                (message.sequence = $util.Long.fromValue(object.sequence)).unsigned = false;
            else if (typeof object.sequence === "string")
                message.sequence = parseInt(object.sequence, 10);
            else if (typeof object.sequence === "number")
                message.sequence = object.sequence;
            else if (typeof object.sequence === "object")
                message.sequence = new $util.LongBits(object.sequence.low >>> 0, object.sequence.high >>> 0).toNumber();
        if (object.source != null)
            if ($util.Long)
                (message.source = $util.Long.fromValue(object.source)).unsigned = false;
            else if (typeof object.source === "string")
                message.source = parseInt(object.source, 10);
            else if (typeof object.source === "number")
                message.source = object.source;
            else if (typeof object.source === "object")
                message.source = new $util.LongBits(object.source.low >>> 0, object.source.high >>> 0).toNumber();
        return message;
    };

    BinanceSignTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            object.msg_count = 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.account_number = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.account_number = options.longs === String ? "0" : 0;
            object.chain_id = "";
            object.memo = "";
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.sequence = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.sequence = options.longs === String ? "0" : 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.source = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.source = options.longs === String ? "0" : 0;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.msg_count != null && message.hasOwnProperty("msg_count"))
            object.msg_count = message.msg_count;
        if (message.account_number != null && message.hasOwnProperty("account_number"))
            if (typeof message.account_number === "number")
                object.account_number = options.longs === String ? String(message.account_number) : message.account_number;
            else
                object.account_number = options.longs === String ? $util.Long.prototype.toString.call(message.account_number) : options.longs === Number ? new $util.LongBits(message.account_number.low >>> 0, message.account_number.high >>> 0).toNumber() : message.account_number;
        if (message.chain_id != null && message.hasOwnProperty("chain_id"))
            object.chain_id = message.chain_id;
        if (message.memo != null && message.hasOwnProperty("memo"))
            object.memo = message.memo;
        if (message.sequence != null && message.hasOwnProperty("sequence"))
            if (typeof message.sequence === "number")
                object.sequence = options.longs === String ? String(message.sequence) : message.sequence;
            else
                object.sequence = options.longs === String ? $util.Long.prototype.toString.call(message.sequence) : options.longs === Number ? new $util.LongBits(message.sequence.low >>> 0, message.sequence.high >>> 0).toNumber() : message.sequence;
        if (message.source != null && message.hasOwnProperty("source"))
            if (typeof message.source === "number")
                object.source = options.longs === String ? String(message.source) : message.source;
            else
                object.source = options.longs === String ? $util.Long.prototype.toString.call(message.source) : options.longs === Number ? new $util.LongBits(message.source.low >>> 0, message.source.high >>> 0).toNumber() : message.source;
        return object;
    };

    BinanceSignTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return BinanceSignTx;
})();

$root.BinanceTxRequest = (function() {

    function BinanceTxRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    BinanceTxRequest.create = function create(properties) {
        return new BinanceTxRequest(properties);
    };

    BinanceTxRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    BinanceTxRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    BinanceTxRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BinanceTxRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    BinanceTxRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    BinanceTxRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    BinanceTxRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.BinanceTxRequest)
            return object;
        return new $root.BinanceTxRequest();
    };

    BinanceTxRequest.toObject = function toObject() {
        return {};
    };

    BinanceTxRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return BinanceTxRequest;
})();

$root.BinanceTransferMsg = (function() {

    function BinanceTransferMsg(properties) {
        this.inputs = [];
        this.outputs = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    BinanceTransferMsg.prototype.inputs = $util.emptyArray;
    BinanceTransferMsg.prototype.outputs = $util.emptyArray;

    BinanceTransferMsg.create = function create(properties) {
        return new BinanceTransferMsg(properties);
    };

    BinanceTransferMsg.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.inputs != null && message.inputs.length)
            for (var i = 0; i < message.inputs.length; ++i)
                $root.BinanceTransferMsg.BinanceInputOutput.encode(message.inputs[i], writer.uint32(10).fork()).ldelim();
        if (message.outputs != null && message.outputs.length)
            for (var i = 0; i < message.outputs.length; ++i)
                $root.BinanceTransferMsg.BinanceInputOutput.encode(message.outputs[i], writer.uint32(18).fork()).ldelim();
        return writer;
    };

    BinanceTransferMsg.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    BinanceTransferMsg.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BinanceTransferMsg();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.inputs && message.inputs.length))
                    message.inputs = [];
                message.inputs.push($root.BinanceTransferMsg.BinanceInputOutput.decode(reader, reader.uint32()));
                break;
            case 2:
                if (!(message.outputs && message.outputs.length))
                    message.outputs = [];
                message.outputs.push($root.BinanceTransferMsg.BinanceInputOutput.decode(reader, reader.uint32()));
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    BinanceTransferMsg.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    BinanceTransferMsg.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.inputs != null && message.hasOwnProperty("inputs")) {
            if (!Array.isArray(message.inputs))
                return "inputs: array expected";
            for (var i = 0; i < message.inputs.length; ++i) {
                var error = $root.BinanceTransferMsg.BinanceInputOutput.verify(message.inputs[i]);
                if (error)
                    return "inputs." + error;
            }
        }
        if (message.outputs != null && message.hasOwnProperty("outputs")) {
            if (!Array.isArray(message.outputs))
                return "outputs: array expected";
            for (var i = 0; i < message.outputs.length; ++i) {
                var error = $root.BinanceTransferMsg.BinanceInputOutput.verify(message.outputs[i]);
                if (error)
                    return "outputs." + error;
            }
        }
        return null;
    };

    BinanceTransferMsg.fromObject = function fromObject(object) {
        if (object instanceof $root.BinanceTransferMsg)
            return object;
        var message = new $root.BinanceTransferMsg();
        if (object.inputs) {
            if (!Array.isArray(object.inputs))
                throw TypeError(".BinanceTransferMsg.inputs: array expected");
            message.inputs = [];
            for (var i = 0; i < object.inputs.length; ++i) {
                if (typeof object.inputs[i] !== "object")
                    throw TypeError(".BinanceTransferMsg.inputs: object expected");
                message.inputs[i] = $root.BinanceTransferMsg.BinanceInputOutput.fromObject(object.inputs[i]);
            }
        }
        if (object.outputs) {
            if (!Array.isArray(object.outputs))
                throw TypeError(".BinanceTransferMsg.outputs: array expected");
            message.outputs = [];
            for (var i = 0; i < object.outputs.length; ++i) {
                if (typeof object.outputs[i] !== "object")
                    throw TypeError(".BinanceTransferMsg.outputs: object expected");
                message.outputs[i] = $root.BinanceTransferMsg.BinanceInputOutput.fromObject(object.outputs[i]);
            }
        }
        return message;
    };

    BinanceTransferMsg.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults) {
            object.inputs = [];
            object.outputs = [];
        }
        if (message.inputs && message.inputs.length) {
            object.inputs = [];
            for (var j = 0; j < message.inputs.length; ++j)
                object.inputs[j] = $root.BinanceTransferMsg.BinanceInputOutput.toObject(message.inputs[j], options);
        }
        if (message.outputs && message.outputs.length) {
            object.outputs = [];
            for (var j = 0; j < message.outputs.length; ++j)
                object.outputs[j] = $root.BinanceTransferMsg.BinanceInputOutput.toObject(message.outputs[j], options);
        }
        return object;
    };

    BinanceTransferMsg.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    BinanceTransferMsg.BinanceInputOutput = (function() {

        function BinanceInputOutput(properties) {
            this.coins = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        BinanceInputOutput.prototype.address = "";
        BinanceInputOutput.prototype.coins = $util.emptyArray;

        BinanceInputOutput.create = function create(properties) {
            return new BinanceInputOutput(properties);
        };

        BinanceInputOutput.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.address != null && Object.hasOwnProperty.call(message, "address"))
                writer.uint32(10).string(message.address);
            if (message.coins != null && message.coins.length)
                for (var i = 0; i < message.coins.length; ++i)
                    $root.BinanceTransferMsg.BinanceCoin.encode(message.coins[i], writer.uint32(18).fork()).ldelim();
            return writer;
        };

        BinanceInputOutput.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        BinanceInputOutput.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BinanceTransferMsg.BinanceInputOutput();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    if (!(message.coins && message.coins.length))
                        message.coins = [];
                    message.coins.push($root.BinanceTransferMsg.BinanceCoin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        BinanceInputOutput.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        BinanceInputOutput.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.address != null && message.hasOwnProperty("address"))
                if (!$util.isString(message.address))
                    return "address: string expected";
            if (message.coins != null && message.hasOwnProperty("coins")) {
                if (!Array.isArray(message.coins))
                    return "coins: array expected";
                for (var i = 0; i < message.coins.length; ++i) {
                    var error = $root.BinanceTransferMsg.BinanceCoin.verify(message.coins[i]);
                    if (error)
                        return "coins." + error;
                }
            }
            return null;
        };

        BinanceInputOutput.fromObject = function fromObject(object) {
            if (object instanceof $root.BinanceTransferMsg.BinanceInputOutput)
                return object;
            var message = new $root.BinanceTransferMsg.BinanceInputOutput();
            if (object.address != null)
                message.address = String(object.address);
            if (object.coins) {
                if (!Array.isArray(object.coins))
                    throw TypeError(".BinanceTransferMsg.BinanceInputOutput.coins: array expected");
                message.coins = [];
                for (var i = 0; i < object.coins.length; ++i) {
                    if (typeof object.coins[i] !== "object")
                        throw TypeError(".BinanceTransferMsg.BinanceInputOutput.coins: object expected");
                    message.coins[i] = $root.BinanceTransferMsg.BinanceCoin.fromObject(object.coins[i]);
                }
            }
            return message;
        };

        BinanceInputOutput.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.coins = [];
            if (options.defaults)
                object.address = "";
            if (message.address != null && message.hasOwnProperty("address"))
                object.address = message.address;
            if (message.coins && message.coins.length) {
                object.coins = [];
                for (var j = 0; j < message.coins.length; ++j)
                    object.coins[j] = $root.BinanceTransferMsg.BinanceCoin.toObject(message.coins[j], options);
            }
            return object;
        };

        BinanceInputOutput.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return BinanceInputOutput;
    })();

    BinanceTransferMsg.BinanceCoin = (function() {

        function BinanceCoin(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        BinanceCoin.prototype.amount = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        BinanceCoin.prototype.denom = "";

        BinanceCoin.create = function create(properties) {
            return new BinanceCoin(properties);
        };

        BinanceCoin.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
                writer.uint32(8).sint64(message.amount);
            if (message.denom != null && Object.hasOwnProperty.call(message, "denom"))
                writer.uint32(18).string(message.denom);
            return writer;
        };

        BinanceCoin.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        BinanceCoin.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BinanceTransferMsg.BinanceCoin();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.amount = reader.sint64();
                    break;
                case 2:
                    message.denom = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        BinanceCoin.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        BinanceCoin.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.amount != null && message.hasOwnProperty("amount"))
                if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
                    return "amount: integer|Long expected";
            if (message.denom != null && message.hasOwnProperty("denom"))
                if (!$util.isString(message.denom))
                    return "denom: string expected";
            return null;
        };

        BinanceCoin.fromObject = function fromObject(object) {
            if (object instanceof $root.BinanceTransferMsg.BinanceCoin)
                return object;
            var message = new $root.BinanceTransferMsg.BinanceCoin();
            if (object.amount != null)
                if ($util.Long)
                    (message.amount = $util.Long.fromValue(object.amount)).unsigned = false;
                else if (typeof object.amount === "string")
                    message.amount = parseInt(object.amount, 10);
                else if (typeof object.amount === "number")
                    message.amount = object.amount;
                else if (typeof object.amount === "object")
                    message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber();
            if (object.denom != null)
                message.denom = String(object.denom);
            return message;
        };

        BinanceCoin.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.amount = options.longs === String ? "0" : 0;
                object.denom = "";
            }
            if (message.amount != null && message.hasOwnProperty("amount"))
                if (typeof message.amount === "number")
                    object.amount = options.longs === String ? String(message.amount) : message.amount;
                else
                    object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber() : message.amount;
            if (message.denom != null && message.hasOwnProperty("denom"))
                object.denom = message.denom;
            return object;
        };

        BinanceCoin.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return BinanceCoin;
    })();

    return BinanceTransferMsg;
})();

$root.BinanceOrderMsg = (function() {

    function BinanceOrderMsg(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    BinanceOrderMsg.prototype.id = "";
    BinanceOrderMsg.prototype.ordertype = 0;
    BinanceOrderMsg.prototype.price = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    BinanceOrderMsg.prototype.quantity = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    BinanceOrderMsg.prototype.sender = "";
    BinanceOrderMsg.prototype.side = 0;
    BinanceOrderMsg.prototype.symbol = "";
    BinanceOrderMsg.prototype.timeinforce = 0;

    BinanceOrderMsg.create = function create(properties) {
        return new BinanceOrderMsg(properties);
    };

    BinanceOrderMsg.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
            writer.uint32(10).string(message.id);
        if (message.ordertype != null && Object.hasOwnProperty.call(message, "ordertype"))
            writer.uint32(16).int32(message.ordertype);
        if (message.price != null && Object.hasOwnProperty.call(message, "price"))
            writer.uint32(24).sint64(message.price);
        if (message.quantity != null && Object.hasOwnProperty.call(message, "quantity"))
            writer.uint32(32).sint64(message.quantity);
        if (message.sender != null && Object.hasOwnProperty.call(message, "sender"))
            writer.uint32(42).string(message.sender);
        if (message.side != null && Object.hasOwnProperty.call(message, "side"))
            writer.uint32(48).int32(message.side);
        if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
            writer.uint32(58).string(message.symbol);
        if (message.timeinforce != null && Object.hasOwnProperty.call(message, "timeinforce"))
            writer.uint32(64).int32(message.timeinforce);
        return writer;
    };

    BinanceOrderMsg.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    BinanceOrderMsg.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BinanceOrderMsg();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.id = reader.string();
                break;
            case 2:
                message.ordertype = reader.int32();
                break;
            case 3:
                message.price = reader.sint64();
                break;
            case 4:
                message.quantity = reader.sint64();
                break;
            case 5:
                message.sender = reader.string();
                break;
            case 6:
                message.side = reader.int32();
                break;
            case 7:
                message.symbol = reader.string();
                break;
            case 8:
                message.timeinforce = reader.int32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    BinanceOrderMsg.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    BinanceOrderMsg.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.id != null && message.hasOwnProperty("id"))
            if (!$util.isString(message.id))
                return "id: string expected";
        if (message.ordertype != null && message.hasOwnProperty("ordertype"))
            switch (message.ordertype) {
            default:
                return "ordertype: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
                break;
            }
        if (message.price != null && message.hasOwnProperty("price"))
            if (!$util.isInteger(message.price) && !(message.price && $util.isInteger(message.price.low) && $util.isInteger(message.price.high)))
                return "price: integer|Long expected";
        if (message.quantity != null && message.hasOwnProperty("quantity"))
            if (!$util.isInteger(message.quantity) && !(message.quantity && $util.isInteger(message.quantity.low) && $util.isInteger(message.quantity.high)))
                return "quantity: integer|Long expected";
        if (message.sender != null && message.hasOwnProperty("sender"))
            if (!$util.isString(message.sender))
                return "sender: string expected";
        if (message.side != null && message.hasOwnProperty("side"))
            switch (message.side) {
            default:
                return "side: enum value expected";
            case 0:
            case 1:
            case 2:
                break;
            }
        if (message.symbol != null && message.hasOwnProperty("symbol"))
            if (!$util.isString(message.symbol))
                return "symbol: string expected";
        if (message.timeinforce != null && message.hasOwnProperty("timeinforce"))
            switch (message.timeinforce) {
            default:
                return "timeinforce: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
                break;
            }
        return null;
    };

    BinanceOrderMsg.fromObject = function fromObject(object) {
        if (object instanceof $root.BinanceOrderMsg)
            return object;
        var message = new $root.BinanceOrderMsg();
        if (object.id != null)
            message.id = String(object.id);
        switch (object.ordertype) {
        case "OT_UNKNOWN":
        case 0:
            message.ordertype = 0;
            break;
        case "MARKET":
        case 1:
            message.ordertype = 1;
            break;
        case "LIMIT":
        case 2:
            message.ordertype = 2;
            break;
        case "OT_RESERVED":
        case 3:
            message.ordertype = 3;
            break;
        }
        if (object.price != null)
            if ($util.Long)
                (message.price = $util.Long.fromValue(object.price)).unsigned = false;
            else if (typeof object.price === "string")
                message.price = parseInt(object.price, 10);
            else if (typeof object.price === "number")
                message.price = object.price;
            else if (typeof object.price === "object")
                message.price = new $util.LongBits(object.price.low >>> 0, object.price.high >>> 0).toNumber();
        if (object.quantity != null)
            if ($util.Long)
                (message.quantity = $util.Long.fromValue(object.quantity)).unsigned = false;
            else if (typeof object.quantity === "string")
                message.quantity = parseInt(object.quantity, 10);
            else if (typeof object.quantity === "number")
                message.quantity = object.quantity;
            else if (typeof object.quantity === "object")
                message.quantity = new $util.LongBits(object.quantity.low >>> 0, object.quantity.high >>> 0).toNumber();
        if (object.sender != null)
            message.sender = String(object.sender);
        switch (object.side) {
        case "SIDE_UNKNOWN":
        case 0:
            message.side = 0;
            break;
        case "BUY":
        case 1:
            message.side = 1;
            break;
        case "SELL":
        case 2:
            message.side = 2;
            break;
        }
        if (object.symbol != null)
            message.symbol = String(object.symbol);
        switch (object.timeinforce) {
        case "TIF_UNKNOWN":
        case 0:
            message.timeinforce = 0;
            break;
        case "GTE":
        case 1:
            message.timeinforce = 1;
            break;
        case "TIF_RESERVED":
        case 2:
            message.timeinforce = 2;
            break;
        case "IOC":
        case 3:
            message.timeinforce = 3;
            break;
        }
        return message;
    };

    BinanceOrderMsg.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.id = "";
            object.ordertype = options.enums === String ? "OT_UNKNOWN" : 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.price = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.price = options.longs === String ? "0" : 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.quantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.quantity = options.longs === String ? "0" : 0;
            object.sender = "";
            object.side = options.enums === String ? "SIDE_UNKNOWN" : 0;
            object.symbol = "";
            object.timeinforce = options.enums === String ? "TIF_UNKNOWN" : 0;
        }
        if (message.id != null && message.hasOwnProperty("id"))
            object.id = message.id;
        if (message.ordertype != null && message.hasOwnProperty("ordertype"))
            object.ordertype = options.enums === String ? $root.BinanceOrderMsg.BinanceOrderType[message.ordertype] : message.ordertype;
        if (message.price != null && message.hasOwnProperty("price"))
            if (typeof message.price === "number")
                object.price = options.longs === String ? String(message.price) : message.price;
            else
                object.price = options.longs === String ? $util.Long.prototype.toString.call(message.price) : options.longs === Number ? new $util.LongBits(message.price.low >>> 0, message.price.high >>> 0).toNumber() : message.price;
        if (message.quantity != null && message.hasOwnProperty("quantity"))
            if (typeof message.quantity === "number")
                object.quantity = options.longs === String ? String(message.quantity) : message.quantity;
            else
                object.quantity = options.longs === String ? $util.Long.prototype.toString.call(message.quantity) : options.longs === Number ? new $util.LongBits(message.quantity.low >>> 0, message.quantity.high >>> 0).toNumber() : message.quantity;
        if (message.sender != null && message.hasOwnProperty("sender"))
            object.sender = message.sender;
        if (message.side != null && message.hasOwnProperty("side"))
            object.side = options.enums === String ? $root.BinanceOrderMsg.BinanceOrderSide[message.side] : message.side;
        if (message.symbol != null && message.hasOwnProperty("symbol"))
            object.symbol = message.symbol;
        if (message.timeinforce != null && message.hasOwnProperty("timeinforce"))
            object.timeinforce = options.enums === String ? $root.BinanceOrderMsg.BinanceTimeInForce[message.timeinforce] : message.timeinforce;
        return object;
    };

    BinanceOrderMsg.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    BinanceOrderMsg.BinanceOrderType = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "OT_UNKNOWN"] = 0;
        values[valuesById[1] = "MARKET"] = 1;
        values[valuesById[2] = "LIMIT"] = 2;
        values[valuesById[3] = "OT_RESERVED"] = 3;
        return values;
    })();

    BinanceOrderMsg.BinanceOrderSide = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "SIDE_UNKNOWN"] = 0;
        values[valuesById[1] = "BUY"] = 1;
        values[valuesById[2] = "SELL"] = 2;
        return values;
    })();

    BinanceOrderMsg.BinanceTimeInForce = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "TIF_UNKNOWN"] = 0;
        values[valuesById[1] = "GTE"] = 1;
        values[valuesById[2] = "TIF_RESERVED"] = 2;
        values[valuesById[3] = "IOC"] = 3;
        return values;
    })();

    return BinanceOrderMsg;
})();

$root.BinanceCancelMsg = (function() {

    function BinanceCancelMsg(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    BinanceCancelMsg.prototype.refid = "";
    BinanceCancelMsg.prototype.sender = "";
    BinanceCancelMsg.prototype.symbol = "";

    BinanceCancelMsg.create = function create(properties) {
        return new BinanceCancelMsg(properties);
    };

    BinanceCancelMsg.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.refid != null && Object.hasOwnProperty.call(message, "refid"))
            writer.uint32(10).string(message.refid);
        if (message.sender != null && Object.hasOwnProperty.call(message, "sender"))
            writer.uint32(18).string(message.sender);
        if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
            writer.uint32(26).string(message.symbol);
        return writer;
    };

    BinanceCancelMsg.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    BinanceCancelMsg.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BinanceCancelMsg();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.refid = reader.string();
                break;
            case 2:
                message.sender = reader.string();
                break;
            case 3:
                message.symbol = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    BinanceCancelMsg.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    BinanceCancelMsg.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.refid != null && message.hasOwnProperty("refid"))
            if (!$util.isString(message.refid))
                return "refid: string expected";
        if (message.sender != null && message.hasOwnProperty("sender"))
            if (!$util.isString(message.sender))
                return "sender: string expected";
        if (message.symbol != null && message.hasOwnProperty("symbol"))
            if (!$util.isString(message.symbol))
                return "symbol: string expected";
        return null;
    };

    BinanceCancelMsg.fromObject = function fromObject(object) {
        if (object instanceof $root.BinanceCancelMsg)
            return object;
        var message = new $root.BinanceCancelMsg();
        if (object.refid != null)
            message.refid = String(object.refid);
        if (object.sender != null)
            message.sender = String(object.sender);
        if (object.symbol != null)
            message.symbol = String(object.symbol);
        return message;
    };

    BinanceCancelMsg.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.refid = "";
            object.sender = "";
            object.symbol = "";
        }
        if (message.refid != null && message.hasOwnProperty("refid"))
            object.refid = message.refid;
        if (message.sender != null && message.hasOwnProperty("sender"))
            object.sender = message.sender;
        if (message.symbol != null && message.hasOwnProperty("symbol"))
            object.symbol = message.symbol;
        return object;
    };

    BinanceCancelMsg.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return BinanceCancelMsg;
})();

$root.BinanceSignedTx = (function() {

    function BinanceSignedTx(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    BinanceSignedTx.prototype.signature = $util.newBuffer([]);
    BinanceSignedTx.prototype.public_key = $util.newBuffer([]);

    BinanceSignedTx.create = function create(properties) {
        return new BinanceSignedTx(properties);
    };

    BinanceSignedTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.signature);
        writer.uint32(18).bytes(message.public_key);
        return writer;
    };

    BinanceSignedTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    BinanceSignedTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BinanceSignedTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.signature = reader.bytes();
                break;
            case 2:
                message.public_key = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        if (!message.hasOwnProperty("public_key"))
            throw $util.ProtocolError("missing required 'public_key'", { instance: message });
        return message;
    };

    BinanceSignedTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    BinanceSignedTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        if (!(message.public_key && typeof message.public_key.length === "number" || $util.isString(message.public_key)))
            return "public_key: buffer expected";
        return null;
    };

    BinanceSignedTx.fromObject = function fromObject(object) {
        if (object instanceof $root.BinanceSignedTx)
            return object;
        var message = new $root.BinanceSignedTx();
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        if (object.public_key != null)
            if (typeof object.public_key === "string")
                $util.base64.decode(object.public_key, message.public_key = $util.newBuffer($util.base64.length(object.public_key)), 0);
            else if (object.public_key.length)
                message.public_key = object.public_key;
        return message;
    };

    BinanceSignedTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
            if (options.bytes === String)
                object.public_key = "";
            else {
                object.public_key = [];
                if (options.bytes !== Array)
                    object.public_key = $util.newBuffer(object.public_key);
            }
        }
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            object.public_key = options.bytes === String ? $util.base64.encode(message.public_key, 0, message.public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.public_key) : message.public_key;
        return object;
    };

    BinanceSignedTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return BinanceSignedTx;
})();

$root.InputScriptType = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "SPENDADDRESS"] = 0;
    values[valuesById[1] = "SPENDMULTISIG"] = 1;
    values[valuesById[2] = "EXTERNAL"] = 2;
    values[valuesById[3] = "SPENDWITNESS"] = 3;
    values[valuesById[4] = "SPENDP2SHWITNESS"] = 4;
    values[valuesById[5] = "SPENDTAPROOT"] = 5;
    return values;
})();

$root.OutputScriptType = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "PAYTOADDRESS"] = 0;
    values[valuesById[1] = "PAYTOSCRIPTHASH"] = 1;
    values[valuesById[2] = "PAYTOMULTISIG"] = 2;
    values[valuesById[3] = "PAYTOOPRETURN"] = 3;
    values[valuesById[4] = "PAYTOWITNESS"] = 4;
    values[valuesById[5] = "PAYTOP2SHWITNESS"] = 5;
    values[valuesById[6] = "PAYTOTAPROOT"] = 6;
    return values;
})();

$root.DecredStakingSpendType = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "SSGen"] = 0;
    values[valuesById[1] = "SSRTX"] = 1;
    return values;
})();

$root.AmountUnit = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "BITCOIN"] = 0;
    values[valuesById[1] = "MILLIBITCOIN"] = 1;
    values[valuesById[2] = "MICROBITCOIN"] = 2;
    values[valuesById[3] = "SATOSHI"] = 3;
    return values;
})();

$root.MultisigRedeemScriptType = (function() {

    function MultisigRedeemScriptType(properties) {
        this.pubkeys = [];
        this.signatures = [];
        this.nodes = [];
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MultisigRedeemScriptType.prototype.pubkeys = $util.emptyArray;
    MultisigRedeemScriptType.prototype.signatures = $util.emptyArray;
    MultisigRedeemScriptType.prototype.m = 0;
    MultisigRedeemScriptType.prototype.nodes = $util.emptyArray;
    MultisigRedeemScriptType.prototype.address_n = $util.emptyArray;

    MultisigRedeemScriptType.create = function create(properties) {
        return new MultisigRedeemScriptType(properties);
    };

    MultisigRedeemScriptType.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.pubkeys != null && message.pubkeys.length)
            for (var i = 0; i < message.pubkeys.length; ++i)
                $root.MultisigRedeemScriptType.HDNodePathType.encode(message.pubkeys[i], writer.uint32(10).fork()).ldelim();
        if (message.signatures != null && message.signatures.length)
            for (var i = 0; i < message.signatures.length; ++i)
                writer.uint32(18).bytes(message.signatures[i]);
        writer.uint32(24).uint32(message.m);
        if (message.nodes != null && message.nodes.length)
            for (var i = 0; i < message.nodes.length; ++i)
                $root.HDNodeType.encode(message.nodes[i], writer.uint32(34).fork()).ldelim();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(40).uint32(message.address_n[i]);
        return writer;
    };

    MultisigRedeemScriptType.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MultisigRedeemScriptType.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MultisigRedeemScriptType();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.pubkeys && message.pubkeys.length))
                    message.pubkeys = [];
                message.pubkeys.push($root.MultisigRedeemScriptType.HDNodePathType.decode(reader, reader.uint32()));
                break;
            case 2:
                if (!(message.signatures && message.signatures.length))
                    message.signatures = [];
                message.signatures.push(reader.bytes());
                break;
            case 3:
                message.m = reader.uint32();
                break;
            case 4:
                if (!(message.nodes && message.nodes.length))
                    message.nodes = [];
                message.nodes.push($root.HDNodeType.decode(reader, reader.uint32()));
                break;
            case 5:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("m"))
            throw $util.ProtocolError("missing required 'm'", { instance: message });
        return message;
    };

    MultisigRedeemScriptType.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MultisigRedeemScriptType.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.pubkeys != null && message.hasOwnProperty("pubkeys")) {
            if (!Array.isArray(message.pubkeys))
                return "pubkeys: array expected";
            for (var i = 0; i < message.pubkeys.length; ++i) {
                var error = $root.MultisigRedeemScriptType.HDNodePathType.verify(message.pubkeys[i]);
                if (error)
                    return "pubkeys." + error;
            }
        }
        if (message.signatures != null && message.hasOwnProperty("signatures")) {
            if (!Array.isArray(message.signatures))
                return "signatures: array expected";
            for (var i = 0; i < message.signatures.length; ++i)
                if (!(message.signatures[i] && typeof message.signatures[i].length === "number" || $util.isString(message.signatures[i])))
                    return "signatures: buffer[] expected";
        }
        if (!$util.isInteger(message.m))
            return "m: integer expected";
        if (message.nodes != null && message.hasOwnProperty("nodes")) {
            if (!Array.isArray(message.nodes))
                return "nodes: array expected";
            for (var i = 0; i < message.nodes.length; ++i) {
                var error = $root.HDNodeType.verify(message.nodes[i]);
                if (error)
                    return "nodes." + error;
            }
        }
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        return null;
    };

    MultisigRedeemScriptType.fromObject = function fromObject(object) {
        if (object instanceof $root.MultisigRedeemScriptType)
            return object;
        var message = new $root.MultisigRedeemScriptType();
        if (object.pubkeys) {
            if (!Array.isArray(object.pubkeys))
                throw TypeError(".MultisigRedeemScriptType.pubkeys: array expected");
            message.pubkeys = [];
            for (var i = 0; i < object.pubkeys.length; ++i) {
                if (typeof object.pubkeys[i] !== "object")
                    throw TypeError(".MultisigRedeemScriptType.pubkeys: object expected");
                message.pubkeys[i] = $root.MultisigRedeemScriptType.HDNodePathType.fromObject(object.pubkeys[i]);
            }
        }
        if (object.signatures) {
            if (!Array.isArray(object.signatures))
                throw TypeError(".MultisigRedeemScriptType.signatures: array expected");
            message.signatures = [];
            for (var i = 0; i < object.signatures.length; ++i)
                if (typeof object.signatures[i] === "string")
                    $util.base64.decode(object.signatures[i], message.signatures[i] = $util.newBuffer($util.base64.length(object.signatures[i])), 0);
                else if (object.signatures[i].length)
                    message.signatures[i] = object.signatures[i];
        }
        if (object.m != null)
            message.m = object.m >>> 0;
        if (object.nodes) {
            if (!Array.isArray(object.nodes))
                throw TypeError(".MultisigRedeemScriptType.nodes: array expected");
            message.nodes = [];
            for (var i = 0; i < object.nodes.length; ++i) {
                if (typeof object.nodes[i] !== "object")
                    throw TypeError(".MultisigRedeemScriptType.nodes: object expected");
                message.nodes[i] = $root.HDNodeType.fromObject(object.nodes[i]);
            }
        }
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".MultisigRedeemScriptType.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        return message;
    };

    MultisigRedeemScriptType.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults) {
            object.pubkeys = [];
            object.signatures = [];
            object.nodes = [];
            object.address_n = [];
        }
        if (options.defaults)
            object.m = 0;
        if (message.pubkeys && message.pubkeys.length) {
            object.pubkeys = [];
            for (var j = 0; j < message.pubkeys.length; ++j)
                object.pubkeys[j] = $root.MultisigRedeemScriptType.HDNodePathType.toObject(message.pubkeys[j], options);
        }
        if (message.signatures && message.signatures.length) {
            object.signatures = [];
            for (var j = 0; j < message.signatures.length; ++j)
                object.signatures[j] = options.bytes === String ? $util.base64.encode(message.signatures[j], 0, message.signatures[j].length) : options.bytes === Array ? Array.prototype.slice.call(message.signatures[j]) : message.signatures[j];
        }
        if (message.m != null && message.hasOwnProperty("m"))
            object.m = message.m;
        if (message.nodes && message.nodes.length) {
            object.nodes = [];
            for (var j = 0; j < message.nodes.length; ++j)
                object.nodes[j] = $root.HDNodeType.toObject(message.nodes[j], options);
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        return object;
    };

    MultisigRedeemScriptType.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    MultisigRedeemScriptType.HDNodePathType = (function() {

        function HDNodePathType(properties) {
            this.address_n = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        HDNodePathType.prototype.node = null;
        HDNodePathType.prototype.address_n = $util.emptyArray;

        HDNodePathType.create = function create(properties) {
            return new HDNodePathType(properties);
        };

        HDNodePathType.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            $root.HDNodeType.encode(message.node, writer.uint32(10).fork()).ldelim();
            if (message.address_n != null && message.address_n.length)
                for (var i = 0; i < message.address_n.length; ++i)
                    writer.uint32(16).uint32(message.address_n[i]);
            return writer;
        };

        HDNodePathType.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        HDNodePathType.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MultisigRedeemScriptType.HDNodePathType();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.node = $root.HDNodeType.decode(reader, reader.uint32());
                    break;
                case 2:
                    if (!(message.address_n && message.address_n.length))
                        message.address_n = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.address_n.push(reader.uint32());
                    } else
                        message.address_n.push(reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("node"))
                throw $util.ProtocolError("missing required 'node'", { instance: message });
            return message;
        };

        HDNodePathType.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        HDNodePathType.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            {
                var error = $root.HDNodeType.verify(message.node);
                if (error)
                    return "node." + error;
            }
            if (message.address_n != null && message.hasOwnProperty("address_n")) {
                if (!Array.isArray(message.address_n))
                    return "address_n: array expected";
                for (var i = 0; i < message.address_n.length; ++i)
                    if (!$util.isInteger(message.address_n[i]))
                        return "address_n: integer[] expected";
            }
            return null;
        };

        HDNodePathType.fromObject = function fromObject(object) {
            if (object instanceof $root.MultisigRedeemScriptType.HDNodePathType)
                return object;
            var message = new $root.MultisigRedeemScriptType.HDNodePathType();
            if (object.node != null) {
                if (typeof object.node !== "object")
                    throw TypeError(".MultisigRedeemScriptType.HDNodePathType.node: object expected");
                message.node = $root.HDNodeType.fromObject(object.node);
            }
            if (object.address_n) {
                if (!Array.isArray(object.address_n))
                    throw TypeError(".MultisigRedeemScriptType.HDNodePathType.address_n: array expected");
                message.address_n = [];
                for (var i = 0; i < object.address_n.length; ++i)
                    message.address_n[i] = object.address_n[i] >>> 0;
            }
            return message;
        };

        HDNodePathType.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.address_n = [];
            if (options.defaults)
                object.node = null;
            if (message.node != null && message.hasOwnProperty("node"))
                object.node = $root.HDNodeType.toObject(message.node, options);
            if (message.address_n && message.address_n.length) {
                object.address_n = [];
                for (var j = 0; j < message.address_n.length; ++j)
                    object.address_n[j] = message.address_n[j];
            }
            return object;
        };

        HDNodePathType.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return HDNodePathType;
    })();

    return MultisigRedeemScriptType;
})();

$root.GetPublicKey = (function() {

    function GetPublicKey(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    GetPublicKey.prototype.address_n = $util.emptyArray;
    GetPublicKey.prototype.ecdsa_curve_name = "";
    GetPublicKey.prototype.show_display = false;
    GetPublicKey.prototype.coin_name = "Bitcoin";
    GetPublicKey.prototype.script_type = 0;
    GetPublicKey.prototype.ignore_xpub_magic = false;

    GetPublicKey.create = function create(properties) {
        return new GetPublicKey(properties);
    };

    GetPublicKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.ecdsa_curve_name != null && Object.hasOwnProperty.call(message, "ecdsa_curve_name"))
            writer.uint32(18).string(message.ecdsa_curve_name);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(24).bool(message.show_display);
        if (message.coin_name != null && Object.hasOwnProperty.call(message, "coin_name"))
            writer.uint32(34).string(message.coin_name);
        if (message.script_type != null && Object.hasOwnProperty.call(message, "script_type"))
            writer.uint32(40).int32(message.script_type);
        if (message.ignore_xpub_magic != null && Object.hasOwnProperty.call(message, "ignore_xpub_magic"))
            writer.uint32(48).bool(message.ignore_xpub_magic);
        return writer;
    };

    GetPublicKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    GetPublicKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.GetPublicKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.ecdsa_curve_name = reader.string();
                break;
            case 3:
                message.show_display = reader.bool();
                break;
            case 4:
                message.coin_name = reader.string();
                break;
            case 5:
                message.script_type = reader.int32();
                break;
            case 6:
                message.ignore_xpub_magic = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    GetPublicKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    GetPublicKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.ecdsa_curve_name != null && message.hasOwnProperty("ecdsa_curve_name"))
            if (!$util.isString(message.ecdsa_curve_name))
                return "ecdsa_curve_name: string expected";
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        if (message.coin_name != null && message.hasOwnProperty("coin_name"))
            if (!$util.isString(message.coin_name))
                return "coin_name: string expected";
        if (message.script_type != null && message.hasOwnProperty("script_type"))
            switch (message.script_type) {
            default:
                return "script_type: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
                break;
            }
        if (message.ignore_xpub_magic != null && message.hasOwnProperty("ignore_xpub_magic"))
            if (typeof message.ignore_xpub_magic !== "boolean")
                return "ignore_xpub_magic: boolean expected";
        return null;
    };

    GetPublicKey.fromObject = function fromObject(object) {
        if (object instanceof $root.GetPublicKey)
            return object;
        var message = new $root.GetPublicKey();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".GetPublicKey.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.ecdsa_curve_name != null)
            message.ecdsa_curve_name = String(object.ecdsa_curve_name);
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        if (object.coin_name != null)
            message.coin_name = String(object.coin_name);
        switch (object.script_type) {
        case "SPENDADDRESS":
        case 0:
            message.script_type = 0;
            break;
        case "SPENDMULTISIG":
        case 1:
            message.script_type = 1;
            break;
        case "EXTERNAL":
        case 2:
            message.script_type = 2;
            break;
        case "SPENDWITNESS":
        case 3:
            message.script_type = 3;
            break;
        case "SPENDP2SHWITNESS":
        case 4:
            message.script_type = 4;
            break;
        case "SPENDTAPROOT":
        case 5:
            message.script_type = 5;
            break;
        }
        if (object.ignore_xpub_magic != null)
            message.ignore_xpub_magic = Boolean(object.ignore_xpub_magic);
        return message;
    };

    GetPublicKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            object.ecdsa_curve_name = "";
            object.show_display = false;
            object.coin_name = "Bitcoin";
            object.script_type = options.enums === String ? "SPENDADDRESS" : 0;
            object.ignore_xpub_magic = false;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.ecdsa_curve_name != null && message.hasOwnProperty("ecdsa_curve_name"))
            object.ecdsa_curve_name = message.ecdsa_curve_name;
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        if (message.coin_name != null && message.hasOwnProperty("coin_name"))
            object.coin_name = message.coin_name;
        if (message.script_type != null && message.hasOwnProperty("script_type"))
            object.script_type = options.enums === String ? $root.InputScriptType[message.script_type] : message.script_type;
        if (message.ignore_xpub_magic != null && message.hasOwnProperty("ignore_xpub_magic"))
            object.ignore_xpub_magic = message.ignore_xpub_magic;
        return object;
    };

    GetPublicKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return GetPublicKey;
})();

$root.PublicKey = (function() {

    function PublicKey(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    PublicKey.prototype.node = null;
    PublicKey.prototype.xpub = "";
    PublicKey.prototype.root_fingerprint = 0;

    PublicKey.create = function create(properties) {
        return new PublicKey(properties);
    };

    PublicKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        $root.HDNodeType.encode(message.node, writer.uint32(10).fork()).ldelim();
        writer.uint32(18).string(message.xpub);
        if (message.root_fingerprint != null && Object.hasOwnProperty.call(message, "root_fingerprint"))
            writer.uint32(24).uint32(message.root_fingerprint);
        return writer;
    };

    PublicKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    PublicKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.PublicKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.node = $root.HDNodeType.decode(reader, reader.uint32());
                break;
            case 2:
                message.xpub = reader.string();
                break;
            case 3:
                message.root_fingerprint = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("node"))
            throw $util.ProtocolError("missing required 'node'", { instance: message });
        if (!message.hasOwnProperty("xpub"))
            throw $util.ProtocolError("missing required 'xpub'", { instance: message });
        return message;
    };

    PublicKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    PublicKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        {
            var error = $root.HDNodeType.verify(message.node);
            if (error)
                return "node." + error;
        }
        if (!$util.isString(message.xpub))
            return "xpub: string expected";
        if (message.root_fingerprint != null && message.hasOwnProperty("root_fingerprint"))
            if (!$util.isInteger(message.root_fingerprint))
                return "root_fingerprint: integer expected";
        return null;
    };

    PublicKey.fromObject = function fromObject(object) {
        if (object instanceof $root.PublicKey)
            return object;
        var message = new $root.PublicKey();
        if (object.node != null) {
            if (typeof object.node !== "object")
                throw TypeError(".PublicKey.node: object expected");
            message.node = $root.HDNodeType.fromObject(object.node);
        }
        if (object.xpub != null)
            message.xpub = String(object.xpub);
        if (object.root_fingerprint != null)
            message.root_fingerprint = object.root_fingerprint >>> 0;
        return message;
    };

    PublicKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.node = null;
            object.xpub = "";
            object.root_fingerprint = 0;
        }
        if (message.node != null && message.hasOwnProperty("node"))
            object.node = $root.HDNodeType.toObject(message.node, options);
        if (message.xpub != null && message.hasOwnProperty("xpub"))
            object.xpub = message.xpub;
        if (message.root_fingerprint != null && message.hasOwnProperty("root_fingerprint"))
            object.root_fingerprint = message.root_fingerprint;
        return object;
    };

    PublicKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return PublicKey;
})();

$root.GetAddress = (function() {

    function GetAddress(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    GetAddress.prototype.address_n = $util.emptyArray;
    GetAddress.prototype.coin_name = "Bitcoin";
    GetAddress.prototype.show_display = false;
    GetAddress.prototype.multisig = null;
    GetAddress.prototype.script_type = 0;
    GetAddress.prototype.ignore_xpub_magic = false;

    GetAddress.create = function create(properties) {
        return new GetAddress(properties);
    };

    GetAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.coin_name != null && Object.hasOwnProperty.call(message, "coin_name"))
            writer.uint32(18).string(message.coin_name);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(24).bool(message.show_display);
        if (message.multisig != null && Object.hasOwnProperty.call(message, "multisig"))
            $root.MultisigRedeemScriptType.encode(message.multisig, writer.uint32(34).fork()).ldelim();
        if (message.script_type != null && Object.hasOwnProperty.call(message, "script_type"))
            writer.uint32(40).int32(message.script_type);
        if (message.ignore_xpub_magic != null && Object.hasOwnProperty.call(message, "ignore_xpub_magic"))
            writer.uint32(48).bool(message.ignore_xpub_magic);
        return writer;
    };

    GetAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    GetAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.GetAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.coin_name = reader.string();
                break;
            case 3:
                message.show_display = reader.bool();
                break;
            case 4:
                message.multisig = $root.MultisigRedeemScriptType.decode(reader, reader.uint32());
                break;
            case 5:
                message.script_type = reader.int32();
                break;
            case 6:
                message.ignore_xpub_magic = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    GetAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    GetAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.coin_name != null && message.hasOwnProperty("coin_name"))
            if (!$util.isString(message.coin_name))
                return "coin_name: string expected";
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        if (message.multisig != null && message.hasOwnProperty("multisig")) {
            var error = $root.MultisigRedeemScriptType.verify(message.multisig);
            if (error)
                return "multisig." + error;
        }
        if (message.script_type != null && message.hasOwnProperty("script_type"))
            switch (message.script_type) {
            default:
                return "script_type: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
                break;
            }
        if (message.ignore_xpub_magic != null && message.hasOwnProperty("ignore_xpub_magic"))
            if (typeof message.ignore_xpub_magic !== "boolean")
                return "ignore_xpub_magic: boolean expected";
        return null;
    };

    GetAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.GetAddress)
            return object;
        var message = new $root.GetAddress();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".GetAddress.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.coin_name != null)
            message.coin_name = String(object.coin_name);
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        if (object.multisig != null) {
            if (typeof object.multisig !== "object")
                throw TypeError(".GetAddress.multisig: object expected");
            message.multisig = $root.MultisigRedeemScriptType.fromObject(object.multisig);
        }
        switch (object.script_type) {
        case "SPENDADDRESS":
        case 0:
            message.script_type = 0;
            break;
        case "SPENDMULTISIG":
        case 1:
            message.script_type = 1;
            break;
        case "EXTERNAL":
        case 2:
            message.script_type = 2;
            break;
        case "SPENDWITNESS":
        case 3:
            message.script_type = 3;
            break;
        case "SPENDP2SHWITNESS":
        case 4:
            message.script_type = 4;
            break;
        case "SPENDTAPROOT":
        case 5:
            message.script_type = 5;
            break;
        }
        if (object.ignore_xpub_magic != null)
            message.ignore_xpub_magic = Boolean(object.ignore_xpub_magic);
        return message;
    };

    GetAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            object.coin_name = "Bitcoin";
            object.show_display = false;
            object.multisig = null;
            object.script_type = options.enums === String ? "SPENDADDRESS" : 0;
            object.ignore_xpub_magic = false;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.coin_name != null && message.hasOwnProperty("coin_name"))
            object.coin_name = message.coin_name;
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        if (message.multisig != null && message.hasOwnProperty("multisig"))
            object.multisig = $root.MultisigRedeemScriptType.toObject(message.multisig, options);
        if (message.script_type != null && message.hasOwnProperty("script_type"))
            object.script_type = options.enums === String ? $root.InputScriptType[message.script_type] : message.script_type;
        if (message.ignore_xpub_magic != null && message.hasOwnProperty("ignore_xpub_magic"))
            object.ignore_xpub_magic = message.ignore_xpub_magic;
        return object;
    };

    GetAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return GetAddress;
})();

$root.Address = (function() {

    function Address(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    Address.prototype.address = "";

    Address.create = function create(properties) {
        return new Address(properties);
    };

    Address.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.address);
        return writer;
    };

    Address.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    Address.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Address();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("address"))
            throw $util.ProtocolError("missing required 'address'", { instance: message });
        return message;
    };

    Address.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    Address.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.address))
            return "address: string expected";
        return null;
    };

    Address.fromObject = function fromObject(object) {
        if (object instanceof $root.Address)
            return object;
        var message = new $root.Address();
        if (object.address != null)
            message.address = String(object.address);
        return message;
    };

    Address.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.address = "";
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    Address.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return Address;
})();

$root.GetOwnershipId = (function() {

    function GetOwnershipId(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    GetOwnershipId.prototype.address_n = $util.emptyArray;
    GetOwnershipId.prototype.coin_name = "Bitcoin";
    GetOwnershipId.prototype.multisig = null;
    GetOwnershipId.prototype.script_type = 0;

    GetOwnershipId.create = function create(properties) {
        return new GetOwnershipId(properties);
    };

    GetOwnershipId.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.coin_name != null && Object.hasOwnProperty.call(message, "coin_name"))
            writer.uint32(18).string(message.coin_name);
        if (message.multisig != null && Object.hasOwnProperty.call(message, "multisig"))
            $root.MultisigRedeemScriptType.encode(message.multisig, writer.uint32(26).fork()).ldelim();
        if (message.script_type != null && Object.hasOwnProperty.call(message, "script_type"))
            writer.uint32(32).int32(message.script_type);
        return writer;
    };

    GetOwnershipId.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    GetOwnershipId.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.GetOwnershipId();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.coin_name = reader.string();
                break;
            case 3:
                message.multisig = $root.MultisigRedeemScriptType.decode(reader, reader.uint32());
                break;
            case 4:
                message.script_type = reader.int32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    GetOwnershipId.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    GetOwnershipId.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.coin_name != null && message.hasOwnProperty("coin_name"))
            if (!$util.isString(message.coin_name))
                return "coin_name: string expected";
        if (message.multisig != null && message.hasOwnProperty("multisig")) {
            var error = $root.MultisigRedeemScriptType.verify(message.multisig);
            if (error)
                return "multisig." + error;
        }
        if (message.script_type != null && message.hasOwnProperty("script_type"))
            switch (message.script_type) {
            default:
                return "script_type: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
                break;
            }
        return null;
    };

    GetOwnershipId.fromObject = function fromObject(object) {
        if (object instanceof $root.GetOwnershipId)
            return object;
        var message = new $root.GetOwnershipId();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".GetOwnershipId.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.coin_name != null)
            message.coin_name = String(object.coin_name);
        if (object.multisig != null) {
            if (typeof object.multisig !== "object")
                throw TypeError(".GetOwnershipId.multisig: object expected");
            message.multisig = $root.MultisigRedeemScriptType.fromObject(object.multisig);
        }
        switch (object.script_type) {
        case "SPENDADDRESS":
        case 0:
            message.script_type = 0;
            break;
        case "SPENDMULTISIG":
        case 1:
            message.script_type = 1;
            break;
        case "EXTERNAL":
        case 2:
            message.script_type = 2;
            break;
        case "SPENDWITNESS":
        case 3:
            message.script_type = 3;
            break;
        case "SPENDP2SHWITNESS":
        case 4:
            message.script_type = 4;
            break;
        case "SPENDTAPROOT":
        case 5:
            message.script_type = 5;
            break;
        }
        return message;
    };

    GetOwnershipId.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            object.coin_name = "Bitcoin";
            object.multisig = null;
            object.script_type = options.enums === String ? "SPENDADDRESS" : 0;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.coin_name != null && message.hasOwnProperty("coin_name"))
            object.coin_name = message.coin_name;
        if (message.multisig != null && message.hasOwnProperty("multisig"))
            object.multisig = $root.MultisigRedeemScriptType.toObject(message.multisig, options);
        if (message.script_type != null && message.hasOwnProperty("script_type"))
            object.script_type = options.enums === String ? $root.InputScriptType[message.script_type] : message.script_type;
        return object;
    };

    GetOwnershipId.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return GetOwnershipId;
})();

$root.OwnershipId = (function() {

    function OwnershipId(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    OwnershipId.prototype.ownership_id = $util.newBuffer([]);

    OwnershipId.create = function create(properties) {
        return new OwnershipId(properties);
    };

    OwnershipId.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.ownership_id);
        return writer;
    };

    OwnershipId.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    OwnershipId.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.OwnershipId();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.ownership_id = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("ownership_id"))
            throw $util.ProtocolError("missing required 'ownership_id'", { instance: message });
        return message;
    };

    OwnershipId.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    OwnershipId.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.ownership_id && typeof message.ownership_id.length === "number" || $util.isString(message.ownership_id)))
            return "ownership_id: buffer expected";
        return null;
    };

    OwnershipId.fromObject = function fromObject(object) {
        if (object instanceof $root.OwnershipId)
            return object;
        var message = new $root.OwnershipId();
        if (object.ownership_id != null)
            if (typeof object.ownership_id === "string")
                $util.base64.decode(object.ownership_id, message.ownership_id = $util.newBuffer($util.base64.length(object.ownership_id)), 0);
            else if (object.ownership_id.length)
                message.ownership_id = object.ownership_id;
        return message;
    };

    OwnershipId.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.ownership_id = "";
            else {
                object.ownership_id = [];
                if (options.bytes !== Array)
                    object.ownership_id = $util.newBuffer(object.ownership_id);
            }
        if (message.ownership_id != null && message.hasOwnProperty("ownership_id"))
            object.ownership_id = options.bytes === String ? $util.base64.encode(message.ownership_id, 0, message.ownership_id.length) : options.bytes === Array ? Array.prototype.slice.call(message.ownership_id) : message.ownership_id;
        return object;
    };

    OwnershipId.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return OwnershipId;
})();

$root.SignMessage = (function() {

    function SignMessage(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    SignMessage.prototype.address_n = $util.emptyArray;
    SignMessage.prototype.message = $util.newBuffer([]);
    SignMessage.prototype.coin_name = "Bitcoin";
    SignMessage.prototype.script_type = 0;
    SignMessage.prototype.no_script_type = false;

    SignMessage.create = function create(properties) {
        return new SignMessage(properties);
    };

    SignMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).bytes(message.message);
        if (message.coin_name != null && Object.hasOwnProperty.call(message, "coin_name"))
            writer.uint32(26).string(message.coin_name);
        if (message.script_type != null && Object.hasOwnProperty.call(message, "script_type"))
            writer.uint32(32).int32(message.script_type);
        if (message.no_script_type != null && Object.hasOwnProperty.call(message, "no_script_type"))
            writer.uint32(40).bool(message.no_script_type);
        return writer;
    };

    SignMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    SignMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SignMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.message = reader.bytes();
                break;
            case 3:
                message.coin_name = reader.string();
                break;
            case 4:
                message.script_type = reader.int32();
                break;
            case 5:
                message.no_script_type = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("message"))
            throw $util.ProtocolError("missing required 'message'", { instance: message });
        return message;
    };

    SignMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    SignMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!(message.message && typeof message.message.length === "number" || $util.isString(message.message)))
            return "message: buffer expected";
        if (message.coin_name != null && message.hasOwnProperty("coin_name"))
            if (!$util.isString(message.coin_name))
                return "coin_name: string expected";
        if (message.script_type != null && message.hasOwnProperty("script_type"))
            switch (message.script_type) {
            default:
                return "script_type: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
                break;
            }
        if (message.no_script_type != null && message.hasOwnProperty("no_script_type"))
            if (typeof message.no_script_type !== "boolean")
                return "no_script_type: boolean expected";
        return null;
    };

    SignMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.SignMessage)
            return object;
        var message = new $root.SignMessage();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".SignMessage.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.message != null)
            if (typeof object.message === "string")
                $util.base64.decode(object.message, message.message = $util.newBuffer($util.base64.length(object.message)), 0);
            else if (object.message.length)
                message.message = object.message;
        if (object.coin_name != null)
            message.coin_name = String(object.coin_name);
        switch (object.script_type) {
        case "SPENDADDRESS":
        case 0:
            message.script_type = 0;
            break;
        case "SPENDMULTISIG":
        case 1:
            message.script_type = 1;
            break;
        case "EXTERNAL":
        case 2:
            message.script_type = 2;
            break;
        case "SPENDWITNESS":
        case 3:
            message.script_type = 3;
            break;
        case "SPENDP2SHWITNESS":
        case 4:
            message.script_type = 4;
            break;
        case "SPENDTAPROOT":
        case 5:
            message.script_type = 5;
            break;
        }
        if (object.no_script_type != null)
            message.no_script_type = Boolean(object.no_script_type);
        return message;
    };

    SignMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            if (options.bytes === String)
                object.message = "";
            else {
                object.message = [];
                if (options.bytes !== Array)
                    object.message = $util.newBuffer(object.message);
            }
            object.coin_name = "Bitcoin";
            object.script_type = options.enums === String ? "SPENDADDRESS" : 0;
            object.no_script_type = false;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.message != null && message.hasOwnProperty("message"))
            object.message = options.bytes === String ? $util.base64.encode(message.message, 0, message.message.length) : options.bytes === Array ? Array.prototype.slice.call(message.message) : message.message;
        if (message.coin_name != null && message.hasOwnProperty("coin_name"))
            object.coin_name = message.coin_name;
        if (message.script_type != null && message.hasOwnProperty("script_type"))
            object.script_type = options.enums === String ? $root.InputScriptType[message.script_type] : message.script_type;
        if (message.no_script_type != null && message.hasOwnProperty("no_script_type"))
            object.no_script_type = message.no_script_type;
        return object;
    };

    SignMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SignMessage;
})();

$root.MessageSignature = (function() {

    function MessageSignature(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MessageSignature.prototype.address = "";
    MessageSignature.prototype.signature = $util.newBuffer([]);

    MessageSignature.create = function create(properties) {
        return new MessageSignature(properties);
    };

    MessageSignature.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.address);
        writer.uint32(18).bytes(message.signature);
        return writer;
    };

    MessageSignature.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MessageSignature.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MessageSignature();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.string();
                break;
            case 2:
                message.signature = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("address"))
            throw $util.ProtocolError("missing required 'address'", { instance: message });
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        return message;
    };

    MessageSignature.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MessageSignature.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.address))
            return "address: string expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        return null;
    };

    MessageSignature.fromObject = function fromObject(object) {
        if (object instanceof $root.MessageSignature)
            return object;
        var message = new $root.MessageSignature();
        if (object.address != null)
            message.address = String(object.address);
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        return message;
    };

    MessageSignature.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.address = "";
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
        }
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        return object;
    };

    MessageSignature.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MessageSignature;
})();

$root.VerifyMessage = (function() {

    function VerifyMessage(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    VerifyMessage.prototype.address = "";
    VerifyMessage.prototype.signature = $util.newBuffer([]);
    VerifyMessage.prototype.message = $util.newBuffer([]);
    VerifyMessage.prototype.coin_name = "Bitcoin";

    VerifyMessage.create = function create(properties) {
        return new VerifyMessage(properties);
    };

    VerifyMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.address);
        writer.uint32(18).bytes(message.signature);
        writer.uint32(26).bytes(message.message);
        if (message.coin_name != null && Object.hasOwnProperty.call(message, "coin_name"))
            writer.uint32(34).string(message.coin_name);
        return writer;
    };

    VerifyMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    VerifyMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.VerifyMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.string();
                break;
            case 2:
                message.signature = reader.bytes();
                break;
            case 3:
                message.message = reader.bytes();
                break;
            case 4:
                message.coin_name = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("address"))
            throw $util.ProtocolError("missing required 'address'", { instance: message });
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        if (!message.hasOwnProperty("message"))
            throw $util.ProtocolError("missing required 'message'", { instance: message });
        return message;
    };

    VerifyMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    VerifyMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.address))
            return "address: string expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        if (!(message.message && typeof message.message.length === "number" || $util.isString(message.message)))
            return "message: buffer expected";
        if (message.coin_name != null && message.hasOwnProperty("coin_name"))
            if (!$util.isString(message.coin_name))
                return "coin_name: string expected";
        return null;
    };

    VerifyMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.VerifyMessage)
            return object;
        var message = new $root.VerifyMessage();
        if (object.address != null)
            message.address = String(object.address);
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        if (object.message != null)
            if (typeof object.message === "string")
                $util.base64.decode(object.message, message.message = $util.newBuffer($util.base64.length(object.message)), 0);
            else if (object.message.length)
                message.message = object.message;
        if (object.coin_name != null)
            message.coin_name = String(object.coin_name);
        return message;
    };

    VerifyMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.address = "";
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
            if (options.bytes === String)
                object.message = "";
            else {
                object.message = [];
                if (options.bytes !== Array)
                    object.message = $util.newBuffer(object.message);
            }
            object.coin_name = "Bitcoin";
        }
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        if (message.message != null && message.hasOwnProperty("message"))
            object.message = options.bytes === String ? $util.base64.encode(message.message, 0, message.message.length) : options.bytes === Array ? Array.prototype.slice.call(message.message) : message.message;
        if (message.coin_name != null && message.hasOwnProperty("coin_name"))
            object.coin_name = message.coin_name;
        return object;
    };

    VerifyMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return VerifyMessage;
})();

$root.SignTx = (function() {

    function SignTx(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    SignTx.prototype.outputs_count = 0;
    SignTx.prototype.inputs_count = 0;
    SignTx.prototype.coin_name = "Bitcoin";
    SignTx.prototype.version = 1;
    SignTx.prototype.lock_time = 0;
    SignTx.prototype.expiry = 0;
    SignTx.prototype.overwintered = false;
    SignTx.prototype.version_group_id = 0;
    SignTx.prototype.timestamp = 0;
    SignTx.prototype.branch_id = 0;
    SignTx.prototype.amount_unit = 0;
    SignTx.prototype.decred_staking_ticket = false;

    SignTx.create = function create(properties) {
        return new SignTx(properties);
    };

    SignTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).uint32(message.outputs_count);
        writer.uint32(16).uint32(message.inputs_count);
        if (message.coin_name != null && Object.hasOwnProperty.call(message, "coin_name"))
            writer.uint32(26).string(message.coin_name);
        if (message.version != null && Object.hasOwnProperty.call(message, "version"))
            writer.uint32(32).uint32(message.version);
        if (message.lock_time != null && Object.hasOwnProperty.call(message, "lock_time"))
            writer.uint32(40).uint32(message.lock_time);
        if (message.expiry != null && Object.hasOwnProperty.call(message, "expiry"))
            writer.uint32(48).uint32(message.expiry);
        if (message.overwintered != null && Object.hasOwnProperty.call(message, "overwintered"))
            writer.uint32(56).bool(message.overwintered);
        if (message.version_group_id != null && Object.hasOwnProperty.call(message, "version_group_id"))
            writer.uint32(64).uint32(message.version_group_id);
        if (message.timestamp != null && Object.hasOwnProperty.call(message, "timestamp"))
            writer.uint32(72).uint32(message.timestamp);
        if (message.branch_id != null && Object.hasOwnProperty.call(message, "branch_id"))
            writer.uint32(80).uint32(message.branch_id);
        if (message.amount_unit != null && Object.hasOwnProperty.call(message, "amount_unit"))
            writer.uint32(88).int32(message.amount_unit);
        if (message.decred_staking_ticket != null && Object.hasOwnProperty.call(message, "decred_staking_ticket"))
            writer.uint32(96).bool(message.decred_staking_ticket);
        return writer;
    };

    SignTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    SignTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SignTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.outputs_count = reader.uint32();
                break;
            case 2:
                message.inputs_count = reader.uint32();
                break;
            case 3:
                message.coin_name = reader.string();
                break;
            case 4:
                message.version = reader.uint32();
                break;
            case 5:
                message.lock_time = reader.uint32();
                break;
            case 6:
                message.expiry = reader.uint32();
                break;
            case 7:
                message.overwintered = reader.bool();
                break;
            case 8:
                message.version_group_id = reader.uint32();
                break;
            case 9:
                message.timestamp = reader.uint32();
                break;
            case 10:
                message.branch_id = reader.uint32();
                break;
            case 11:
                message.amount_unit = reader.int32();
                break;
            case 12:
                message.decred_staking_ticket = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("outputs_count"))
            throw $util.ProtocolError("missing required 'outputs_count'", { instance: message });
        if (!message.hasOwnProperty("inputs_count"))
            throw $util.ProtocolError("missing required 'inputs_count'", { instance: message });
        return message;
    };

    SignTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    SignTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isInteger(message.outputs_count))
            return "outputs_count: integer expected";
        if (!$util.isInteger(message.inputs_count))
            return "inputs_count: integer expected";
        if (message.coin_name != null && message.hasOwnProperty("coin_name"))
            if (!$util.isString(message.coin_name))
                return "coin_name: string expected";
        if (message.version != null && message.hasOwnProperty("version"))
            if (!$util.isInteger(message.version))
                return "version: integer expected";
        if (message.lock_time != null && message.hasOwnProperty("lock_time"))
            if (!$util.isInteger(message.lock_time))
                return "lock_time: integer expected";
        if (message.expiry != null && message.hasOwnProperty("expiry"))
            if (!$util.isInteger(message.expiry))
                return "expiry: integer expected";
        if (message.overwintered != null && message.hasOwnProperty("overwintered"))
            if (typeof message.overwintered !== "boolean")
                return "overwintered: boolean expected";
        if (message.version_group_id != null && message.hasOwnProperty("version_group_id"))
            if (!$util.isInteger(message.version_group_id))
                return "version_group_id: integer expected";
        if (message.timestamp != null && message.hasOwnProperty("timestamp"))
            if (!$util.isInteger(message.timestamp))
                return "timestamp: integer expected";
        if (message.branch_id != null && message.hasOwnProperty("branch_id"))
            if (!$util.isInteger(message.branch_id))
                return "branch_id: integer expected";
        if (message.amount_unit != null && message.hasOwnProperty("amount_unit"))
            switch (message.amount_unit) {
            default:
                return "amount_unit: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
                break;
            }
        if (message.decred_staking_ticket != null && message.hasOwnProperty("decred_staking_ticket"))
            if (typeof message.decred_staking_ticket !== "boolean")
                return "decred_staking_ticket: boolean expected";
        return null;
    };

    SignTx.fromObject = function fromObject(object) {
        if (object instanceof $root.SignTx)
            return object;
        var message = new $root.SignTx();
        if (object.outputs_count != null)
            message.outputs_count = object.outputs_count >>> 0;
        if (object.inputs_count != null)
            message.inputs_count = object.inputs_count >>> 0;
        if (object.coin_name != null)
            message.coin_name = String(object.coin_name);
        if (object.version != null)
            message.version = object.version >>> 0;
        if (object.lock_time != null)
            message.lock_time = object.lock_time >>> 0;
        if (object.expiry != null)
            message.expiry = object.expiry >>> 0;
        if (object.overwintered != null)
            message.overwintered = Boolean(object.overwintered);
        if (object.version_group_id != null)
            message.version_group_id = object.version_group_id >>> 0;
        if (object.timestamp != null)
            message.timestamp = object.timestamp >>> 0;
        if (object.branch_id != null)
            message.branch_id = object.branch_id >>> 0;
        switch (object.amount_unit) {
        case "BITCOIN":
        case 0:
            message.amount_unit = 0;
            break;
        case "MILLIBITCOIN":
        case 1:
            message.amount_unit = 1;
            break;
        case "MICROBITCOIN":
        case 2:
            message.amount_unit = 2;
            break;
        case "SATOSHI":
        case 3:
            message.amount_unit = 3;
            break;
        }
        if (object.decred_staking_ticket != null)
            message.decred_staking_ticket = Boolean(object.decred_staking_ticket);
        return message;
    };

    SignTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.outputs_count = 0;
            object.inputs_count = 0;
            object.coin_name = "Bitcoin";
            object.version = 1;
            object.lock_time = 0;
            object.expiry = 0;
            object.overwintered = false;
            object.version_group_id = 0;
            object.timestamp = 0;
            object.branch_id = 0;
            object.amount_unit = options.enums === String ? "BITCOIN" : 0;
            object.decred_staking_ticket = false;
        }
        if (message.outputs_count != null && message.hasOwnProperty("outputs_count"))
            object.outputs_count = message.outputs_count;
        if (message.inputs_count != null && message.hasOwnProperty("inputs_count"))
            object.inputs_count = message.inputs_count;
        if (message.coin_name != null && message.hasOwnProperty("coin_name"))
            object.coin_name = message.coin_name;
        if (message.version != null && message.hasOwnProperty("version"))
            object.version = message.version;
        if (message.lock_time != null && message.hasOwnProperty("lock_time"))
            object.lock_time = message.lock_time;
        if (message.expiry != null && message.hasOwnProperty("expiry"))
            object.expiry = message.expiry;
        if (message.overwintered != null && message.hasOwnProperty("overwintered"))
            object.overwintered = message.overwintered;
        if (message.version_group_id != null && message.hasOwnProperty("version_group_id"))
            object.version_group_id = message.version_group_id;
        if (message.timestamp != null && message.hasOwnProperty("timestamp"))
            object.timestamp = message.timestamp;
        if (message.branch_id != null && message.hasOwnProperty("branch_id"))
            object.branch_id = message.branch_id;
        if (message.amount_unit != null && message.hasOwnProperty("amount_unit"))
            object.amount_unit = options.enums === String ? $root.AmountUnit[message.amount_unit] : message.amount_unit;
        if (message.decred_staking_ticket != null && message.hasOwnProperty("decred_staking_ticket"))
            object.decred_staking_ticket = message.decred_staking_ticket;
        return object;
    };

    SignTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SignTx;
})();

$root.TxRequest = (function() {

    function TxRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    TxRequest.prototype.request_type = 0;
    TxRequest.prototype.details = null;
    TxRequest.prototype.serialized = null;

    TxRequest.create = function create(properties) {
        return new TxRequest(properties);
    };

    TxRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.request_type != null && Object.hasOwnProperty.call(message, "request_type"))
            writer.uint32(8).int32(message.request_type);
        if (message.details != null && Object.hasOwnProperty.call(message, "details"))
            $root.TxRequest.TxRequestDetailsType.encode(message.details, writer.uint32(18).fork()).ldelim();
        if (message.serialized != null && Object.hasOwnProperty.call(message, "serialized"))
            $root.TxRequest.TxRequestSerializedType.encode(message.serialized, writer.uint32(26).fork()).ldelim();
        return writer;
    };

    TxRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    TxRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TxRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.request_type = reader.int32();
                break;
            case 2:
                message.details = $root.TxRequest.TxRequestDetailsType.decode(reader, reader.uint32());
                break;
            case 3:
                message.serialized = $root.TxRequest.TxRequestSerializedType.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    TxRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    TxRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.request_type != null && message.hasOwnProperty("request_type"))
            switch (message.request_type) {
            default:
                return "request_type: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
                break;
            }
        if (message.details != null && message.hasOwnProperty("details")) {
            var error = $root.TxRequest.TxRequestDetailsType.verify(message.details);
            if (error)
                return "details." + error;
        }
        if (message.serialized != null && message.hasOwnProperty("serialized")) {
            var error = $root.TxRequest.TxRequestSerializedType.verify(message.serialized);
            if (error)
                return "serialized." + error;
        }
        return null;
    };

    TxRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.TxRequest)
            return object;
        var message = new $root.TxRequest();
        switch (object.request_type) {
        case "TXINPUT":
        case 0:
            message.request_type = 0;
            break;
        case "TXOUTPUT":
        case 1:
            message.request_type = 1;
            break;
        case "TXMETA":
        case 2:
            message.request_type = 2;
            break;
        case "TXFINISHED":
        case 3:
            message.request_type = 3;
            break;
        case "TXEXTRADATA":
        case 4:
            message.request_type = 4;
            break;
        case "TXORIGINPUT":
        case 5:
            message.request_type = 5;
            break;
        case "TXORIGOUTPUT":
        case 6:
            message.request_type = 6;
            break;
        }
        if (object.details != null) {
            if (typeof object.details !== "object")
                throw TypeError(".TxRequest.details: object expected");
            message.details = $root.TxRequest.TxRequestDetailsType.fromObject(object.details);
        }
        if (object.serialized != null) {
            if (typeof object.serialized !== "object")
                throw TypeError(".TxRequest.serialized: object expected");
            message.serialized = $root.TxRequest.TxRequestSerializedType.fromObject(object.serialized);
        }
        return message;
    };

    TxRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.request_type = options.enums === String ? "TXINPUT" : 0;
            object.details = null;
            object.serialized = null;
        }
        if (message.request_type != null && message.hasOwnProperty("request_type"))
            object.request_type = options.enums === String ? $root.TxRequest.RequestType[message.request_type] : message.request_type;
        if (message.details != null && message.hasOwnProperty("details"))
            object.details = $root.TxRequest.TxRequestDetailsType.toObject(message.details, options);
        if (message.serialized != null && message.hasOwnProperty("serialized"))
            object.serialized = $root.TxRequest.TxRequestSerializedType.toObject(message.serialized, options);
        return object;
    };

    TxRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    TxRequest.RequestType = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "TXINPUT"] = 0;
        values[valuesById[1] = "TXOUTPUT"] = 1;
        values[valuesById[2] = "TXMETA"] = 2;
        values[valuesById[3] = "TXFINISHED"] = 3;
        values[valuesById[4] = "TXEXTRADATA"] = 4;
        values[valuesById[5] = "TXORIGINPUT"] = 5;
        values[valuesById[6] = "TXORIGOUTPUT"] = 6;
        return values;
    })();

    TxRequest.TxRequestDetailsType = (function() {

        function TxRequestDetailsType(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        TxRequestDetailsType.prototype.request_index = 0;
        TxRequestDetailsType.prototype.tx_hash = $util.newBuffer([]);
        TxRequestDetailsType.prototype.extra_data_len = 0;
        TxRequestDetailsType.prototype.extra_data_offset = 0;

        TxRequestDetailsType.create = function create(properties) {
            return new TxRequestDetailsType(properties);
        };

        TxRequestDetailsType.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.request_index != null && Object.hasOwnProperty.call(message, "request_index"))
                writer.uint32(8).uint32(message.request_index);
            if (message.tx_hash != null && Object.hasOwnProperty.call(message, "tx_hash"))
                writer.uint32(18).bytes(message.tx_hash);
            if (message.extra_data_len != null && Object.hasOwnProperty.call(message, "extra_data_len"))
                writer.uint32(24).uint32(message.extra_data_len);
            if (message.extra_data_offset != null && Object.hasOwnProperty.call(message, "extra_data_offset"))
                writer.uint32(32).uint32(message.extra_data_offset);
            return writer;
        };

        TxRequestDetailsType.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        TxRequestDetailsType.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TxRequest.TxRequestDetailsType();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.request_index = reader.uint32();
                    break;
                case 2:
                    message.tx_hash = reader.bytes();
                    break;
                case 3:
                    message.extra_data_len = reader.uint32();
                    break;
                case 4:
                    message.extra_data_offset = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        TxRequestDetailsType.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        TxRequestDetailsType.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.request_index != null && message.hasOwnProperty("request_index"))
                if (!$util.isInteger(message.request_index))
                    return "request_index: integer expected";
            if (message.tx_hash != null && message.hasOwnProperty("tx_hash"))
                if (!(message.tx_hash && typeof message.tx_hash.length === "number" || $util.isString(message.tx_hash)))
                    return "tx_hash: buffer expected";
            if (message.extra_data_len != null && message.hasOwnProperty("extra_data_len"))
                if (!$util.isInteger(message.extra_data_len))
                    return "extra_data_len: integer expected";
            if (message.extra_data_offset != null && message.hasOwnProperty("extra_data_offset"))
                if (!$util.isInteger(message.extra_data_offset))
                    return "extra_data_offset: integer expected";
            return null;
        };

        TxRequestDetailsType.fromObject = function fromObject(object) {
            if (object instanceof $root.TxRequest.TxRequestDetailsType)
                return object;
            var message = new $root.TxRequest.TxRequestDetailsType();
            if (object.request_index != null)
                message.request_index = object.request_index >>> 0;
            if (object.tx_hash != null)
                if (typeof object.tx_hash === "string")
                    $util.base64.decode(object.tx_hash, message.tx_hash = $util.newBuffer($util.base64.length(object.tx_hash)), 0);
                else if (object.tx_hash.length)
                    message.tx_hash = object.tx_hash;
            if (object.extra_data_len != null)
                message.extra_data_len = object.extra_data_len >>> 0;
            if (object.extra_data_offset != null)
                message.extra_data_offset = object.extra_data_offset >>> 0;
            return message;
        };

        TxRequestDetailsType.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.request_index = 0;
                if (options.bytes === String)
                    object.tx_hash = "";
                else {
                    object.tx_hash = [];
                    if (options.bytes !== Array)
                        object.tx_hash = $util.newBuffer(object.tx_hash);
                }
                object.extra_data_len = 0;
                object.extra_data_offset = 0;
            }
            if (message.request_index != null && message.hasOwnProperty("request_index"))
                object.request_index = message.request_index;
            if (message.tx_hash != null && message.hasOwnProperty("tx_hash"))
                object.tx_hash = options.bytes === String ? $util.base64.encode(message.tx_hash, 0, message.tx_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.tx_hash) : message.tx_hash;
            if (message.extra_data_len != null && message.hasOwnProperty("extra_data_len"))
                object.extra_data_len = message.extra_data_len;
            if (message.extra_data_offset != null && message.hasOwnProperty("extra_data_offset"))
                object.extra_data_offset = message.extra_data_offset;
            return object;
        };

        TxRequestDetailsType.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TxRequestDetailsType;
    })();

    TxRequest.TxRequestSerializedType = (function() {

        function TxRequestSerializedType(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        TxRequestSerializedType.prototype.signature_index = 0;
        TxRequestSerializedType.prototype.signature = $util.newBuffer([]);
        TxRequestSerializedType.prototype.serialized_tx = $util.newBuffer([]);

        TxRequestSerializedType.create = function create(properties) {
            return new TxRequestSerializedType(properties);
        };

        TxRequestSerializedType.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.signature_index != null && Object.hasOwnProperty.call(message, "signature_index"))
                writer.uint32(8).uint32(message.signature_index);
            if (message.signature != null && Object.hasOwnProperty.call(message, "signature"))
                writer.uint32(18).bytes(message.signature);
            if (message.serialized_tx != null && Object.hasOwnProperty.call(message, "serialized_tx"))
                writer.uint32(26).bytes(message.serialized_tx);
            return writer;
        };

        TxRequestSerializedType.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        TxRequestSerializedType.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TxRequest.TxRequestSerializedType();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.signature_index = reader.uint32();
                    break;
                case 2:
                    message.signature = reader.bytes();
                    break;
                case 3:
                    message.serialized_tx = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        TxRequestSerializedType.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        TxRequestSerializedType.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.signature_index != null && message.hasOwnProperty("signature_index"))
                if (!$util.isInteger(message.signature_index))
                    return "signature_index: integer expected";
            if (message.signature != null && message.hasOwnProperty("signature"))
                if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
                    return "signature: buffer expected";
            if (message.serialized_tx != null && message.hasOwnProperty("serialized_tx"))
                if (!(message.serialized_tx && typeof message.serialized_tx.length === "number" || $util.isString(message.serialized_tx)))
                    return "serialized_tx: buffer expected";
            return null;
        };

        TxRequestSerializedType.fromObject = function fromObject(object) {
            if (object instanceof $root.TxRequest.TxRequestSerializedType)
                return object;
            var message = new $root.TxRequest.TxRequestSerializedType();
            if (object.signature_index != null)
                message.signature_index = object.signature_index >>> 0;
            if (object.signature != null)
                if (typeof object.signature === "string")
                    $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
                else if (object.signature.length)
                    message.signature = object.signature;
            if (object.serialized_tx != null)
                if (typeof object.serialized_tx === "string")
                    $util.base64.decode(object.serialized_tx, message.serialized_tx = $util.newBuffer($util.base64.length(object.serialized_tx)), 0);
                else if (object.serialized_tx.length)
                    message.serialized_tx = object.serialized_tx;
            return message;
        };

        TxRequestSerializedType.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.signature_index = 0;
                if (options.bytes === String)
                    object.signature = "";
                else {
                    object.signature = [];
                    if (options.bytes !== Array)
                        object.signature = $util.newBuffer(object.signature);
                }
                if (options.bytes === String)
                    object.serialized_tx = "";
                else {
                    object.serialized_tx = [];
                    if (options.bytes !== Array)
                        object.serialized_tx = $util.newBuffer(object.serialized_tx);
                }
            }
            if (message.signature_index != null && message.hasOwnProperty("signature_index"))
                object.signature_index = message.signature_index;
            if (message.signature != null && message.hasOwnProperty("signature"))
                object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
            if (message.serialized_tx != null && message.hasOwnProperty("serialized_tx"))
                object.serialized_tx = options.bytes === String ? $util.base64.encode(message.serialized_tx, 0, message.serialized_tx.length) : options.bytes === Array ? Array.prototype.slice.call(message.serialized_tx) : message.serialized_tx;
            return object;
        };

        TxRequestSerializedType.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TxRequestSerializedType;
    })();

    return TxRequest;
})();

$root.TxAck = (function() {

    function TxAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    TxAck.prototype.tx = null;

    TxAck.create = function create(properties) {
        return new TxAck(properties);
    };

    TxAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.tx != null && Object.hasOwnProperty.call(message, "tx"))
            $root.TxAck.TransactionType.encode(message.tx, writer.uint32(10).fork()).ldelim();
        return writer;
    };

    TxAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    TxAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TxAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.tx = $root.TxAck.TransactionType.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    TxAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    TxAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.tx != null && message.hasOwnProperty("tx")) {
            var error = $root.TxAck.TransactionType.verify(message.tx);
            if (error)
                return "tx." + error;
        }
        return null;
    };

    TxAck.fromObject = function fromObject(object) {
        if (object instanceof $root.TxAck)
            return object;
        var message = new $root.TxAck();
        if (object.tx != null) {
            if (typeof object.tx !== "object")
                throw TypeError(".TxAck.tx: object expected");
            message.tx = $root.TxAck.TransactionType.fromObject(object.tx);
        }
        return message;
    };

    TxAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.tx = null;
        if (message.tx != null && message.hasOwnProperty("tx"))
            object.tx = $root.TxAck.TransactionType.toObject(message.tx, options);
        return object;
    };

    TxAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    TxAck.TransactionType = (function() {

        function TransactionType(properties) {
            this.inputs = [];
            this.bin_outputs = [];
            this.outputs = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        TransactionType.prototype.version = 0;
        TransactionType.prototype.inputs = $util.emptyArray;
        TransactionType.prototype.bin_outputs = $util.emptyArray;
        TransactionType.prototype.lock_time = 0;
        TransactionType.prototype.outputs = $util.emptyArray;
        TransactionType.prototype.inputs_cnt = 0;
        TransactionType.prototype.outputs_cnt = 0;
        TransactionType.prototype.extra_data = $util.newBuffer([]);
        TransactionType.prototype.extra_data_len = 0;
        TransactionType.prototype.expiry = 0;
        TransactionType.prototype.overwintered = false;
        TransactionType.prototype.version_group_id = 0;
        TransactionType.prototype.timestamp = 0;
        TransactionType.prototype.branch_id = 0;

        TransactionType.create = function create(properties) {
            return new TransactionType(properties);
        };

        TransactionType.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.version != null && Object.hasOwnProperty.call(message, "version"))
                writer.uint32(8).uint32(message.version);
            if (message.inputs != null && message.inputs.length)
                for (var i = 0; i < message.inputs.length; ++i)
                    $root.TxAck.TransactionType.TxInputType.encode(message.inputs[i], writer.uint32(18).fork()).ldelim();
            if (message.bin_outputs != null && message.bin_outputs.length)
                for (var i = 0; i < message.bin_outputs.length; ++i)
                    $root.TxAck.TransactionType.TxOutputBinType.encode(message.bin_outputs[i], writer.uint32(26).fork()).ldelim();
            if (message.lock_time != null && Object.hasOwnProperty.call(message, "lock_time"))
                writer.uint32(32).uint32(message.lock_time);
            if (message.outputs != null && message.outputs.length)
                for (var i = 0; i < message.outputs.length; ++i)
                    $root.TxAck.TransactionType.TxOutputType.encode(message.outputs[i], writer.uint32(42).fork()).ldelim();
            if (message.inputs_cnt != null && Object.hasOwnProperty.call(message, "inputs_cnt"))
                writer.uint32(48).uint32(message.inputs_cnt);
            if (message.outputs_cnt != null && Object.hasOwnProperty.call(message, "outputs_cnt"))
                writer.uint32(56).uint32(message.outputs_cnt);
            if (message.extra_data != null && Object.hasOwnProperty.call(message, "extra_data"))
                writer.uint32(66).bytes(message.extra_data);
            if (message.extra_data_len != null && Object.hasOwnProperty.call(message, "extra_data_len"))
                writer.uint32(72).uint32(message.extra_data_len);
            if (message.expiry != null && Object.hasOwnProperty.call(message, "expiry"))
                writer.uint32(80).uint32(message.expiry);
            if (message.overwintered != null && Object.hasOwnProperty.call(message, "overwintered"))
                writer.uint32(88).bool(message.overwintered);
            if (message.version_group_id != null && Object.hasOwnProperty.call(message, "version_group_id"))
                writer.uint32(96).uint32(message.version_group_id);
            if (message.timestamp != null && Object.hasOwnProperty.call(message, "timestamp"))
                writer.uint32(104).uint32(message.timestamp);
            if (message.branch_id != null && Object.hasOwnProperty.call(message, "branch_id"))
                writer.uint32(112).uint32(message.branch_id);
            return writer;
        };

        TransactionType.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        TransactionType.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TxAck.TransactionType();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.version = reader.uint32();
                    break;
                case 2:
                    if (!(message.inputs && message.inputs.length))
                        message.inputs = [];
                    message.inputs.push($root.TxAck.TransactionType.TxInputType.decode(reader, reader.uint32()));
                    break;
                case 3:
                    if (!(message.bin_outputs && message.bin_outputs.length))
                        message.bin_outputs = [];
                    message.bin_outputs.push($root.TxAck.TransactionType.TxOutputBinType.decode(reader, reader.uint32()));
                    break;
                case 4:
                    message.lock_time = reader.uint32();
                    break;
                case 5:
                    if (!(message.outputs && message.outputs.length))
                        message.outputs = [];
                    message.outputs.push($root.TxAck.TransactionType.TxOutputType.decode(reader, reader.uint32()));
                    break;
                case 6:
                    message.inputs_cnt = reader.uint32();
                    break;
                case 7:
                    message.outputs_cnt = reader.uint32();
                    break;
                case 8:
                    message.extra_data = reader.bytes();
                    break;
                case 9:
                    message.extra_data_len = reader.uint32();
                    break;
                case 10:
                    message.expiry = reader.uint32();
                    break;
                case 11:
                    message.overwintered = reader.bool();
                    break;
                case 12:
                    message.version_group_id = reader.uint32();
                    break;
                case 13:
                    message.timestamp = reader.uint32();
                    break;
                case 14:
                    message.branch_id = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        TransactionType.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        TransactionType.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.version != null && message.hasOwnProperty("version"))
                if (!$util.isInteger(message.version))
                    return "version: integer expected";
            if (message.inputs != null && message.hasOwnProperty("inputs")) {
                if (!Array.isArray(message.inputs))
                    return "inputs: array expected";
                for (var i = 0; i < message.inputs.length; ++i) {
                    var error = $root.TxAck.TransactionType.TxInputType.verify(message.inputs[i]);
                    if (error)
                        return "inputs." + error;
                }
            }
            if (message.bin_outputs != null && message.hasOwnProperty("bin_outputs")) {
                if (!Array.isArray(message.bin_outputs))
                    return "bin_outputs: array expected";
                for (var i = 0; i < message.bin_outputs.length; ++i) {
                    var error = $root.TxAck.TransactionType.TxOutputBinType.verify(message.bin_outputs[i]);
                    if (error)
                        return "bin_outputs." + error;
                }
            }
            if (message.lock_time != null && message.hasOwnProperty("lock_time"))
                if (!$util.isInteger(message.lock_time))
                    return "lock_time: integer expected";
            if (message.outputs != null && message.hasOwnProperty("outputs")) {
                if (!Array.isArray(message.outputs))
                    return "outputs: array expected";
                for (var i = 0; i < message.outputs.length; ++i) {
                    var error = $root.TxAck.TransactionType.TxOutputType.verify(message.outputs[i]);
                    if (error)
                        return "outputs." + error;
                }
            }
            if (message.inputs_cnt != null && message.hasOwnProperty("inputs_cnt"))
                if (!$util.isInteger(message.inputs_cnt))
                    return "inputs_cnt: integer expected";
            if (message.outputs_cnt != null && message.hasOwnProperty("outputs_cnt"))
                if (!$util.isInteger(message.outputs_cnt))
                    return "outputs_cnt: integer expected";
            if (message.extra_data != null && message.hasOwnProperty("extra_data"))
                if (!(message.extra_data && typeof message.extra_data.length === "number" || $util.isString(message.extra_data)))
                    return "extra_data: buffer expected";
            if (message.extra_data_len != null && message.hasOwnProperty("extra_data_len"))
                if (!$util.isInteger(message.extra_data_len))
                    return "extra_data_len: integer expected";
            if (message.expiry != null && message.hasOwnProperty("expiry"))
                if (!$util.isInteger(message.expiry))
                    return "expiry: integer expected";
            if (message.overwintered != null && message.hasOwnProperty("overwintered"))
                if (typeof message.overwintered !== "boolean")
                    return "overwintered: boolean expected";
            if (message.version_group_id != null && message.hasOwnProperty("version_group_id"))
                if (!$util.isInteger(message.version_group_id))
                    return "version_group_id: integer expected";
            if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                if (!$util.isInteger(message.timestamp))
                    return "timestamp: integer expected";
            if (message.branch_id != null && message.hasOwnProperty("branch_id"))
                if (!$util.isInteger(message.branch_id))
                    return "branch_id: integer expected";
            return null;
        };

        TransactionType.fromObject = function fromObject(object) {
            if (object instanceof $root.TxAck.TransactionType)
                return object;
            var message = new $root.TxAck.TransactionType();
            if (object.version != null)
                message.version = object.version >>> 0;
            if (object.inputs) {
                if (!Array.isArray(object.inputs))
                    throw TypeError(".TxAck.TransactionType.inputs: array expected");
                message.inputs = [];
                for (var i = 0; i < object.inputs.length; ++i) {
                    if (typeof object.inputs[i] !== "object")
                        throw TypeError(".TxAck.TransactionType.inputs: object expected");
                    message.inputs[i] = $root.TxAck.TransactionType.TxInputType.fromObject(object.inputs[i]);
                }
            }
            if (object.bin_outputs) {
                if (!Array.isArray(object.bin_outputs))
                    throw TypeError(".TxAck.TransactionType.bin_outputs: array expected");
                message.bin_outputs = [];
                for (var i = 0; i < object.bin_outputs.length; ++i) {
                    if (typeof object.bin_outputs[i] !== "object")
                        throw TypeError(".TxAck.TransactionType.bin_outputs: object expected");
                    message.bin_outputs[i] = $root.TxAck.TransactionType.TxOutputBinType.fromObject(object.bin_outputs[i]);
                }
            }
            if (object.lock_time != null)
                message.lock_time = object.lock_time >>> 0;
            if (object.outputs) {
                if (!Array.isArray(object.outputs))
                    throw TypeError(".TxAck.TransactionType.outputs: array expected");
                message.outputs = [];
                for (var i = 0; i < object.outputs.length; ++i) {
                    if (typeof object.outputs[i] !== "object")
                        throw TypeError(".TxAck.TransactionType.outputs: object expected");
                    message.outputs[i] = $root.TxAck.TransactionType.TxOutputType.fromObject(object.outputs[i]);
                }
            }
            if (object.inputs_cnt != null)
                message.inputs_cnt = object.inputs_cnt >>> 0;
            if (object.outputs_cnt != null)
                message.outputs_cnt = object.outputs_cnt >>> 0;
            if (object.extra_data != null)
                if (typeof object.extra_data === "string")
                    $util.base64.decode(object.extra_data, message.extra_data = $util.newBuffer($util.base64.length(object.extra_data)), 0);
                else if (object.extra_data.length)
                    message.extra_data = object.extra_data;
            if (object.extra_data_len != null)
                message.extra_data_len = object.extra_data_len >>> 0;
            if (object.expiry != null)
                message.expiry = object.expiry >>> 0;
            if (object.overwintered != null)
                message.overwintered = Boolean(object.overwintered);
            if (object.version_group_id != null)
                message.version_group_id = object.version_group_id >>> 0;
            if (object.timestamp != null)
                message.timestamp = object.timestamp >>> 0;
            if (object.branch_id != null)
                message.branch_id = object.branch_id >>> 0;
            return message;
        };

        TransactionType.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.inputs = [];
                object.bin_outputs = [];
                object.outputs = [];
            }
            if (options.defaults) {
                object.version = 0;
                object.lock_time = 0;
                object.inputs_cnt = 0;
                object.outputs_cnt = 0;
                if (options.bytes === String)
                    object.extra_data = "";
                else {
                    object.extra_data = [];
                    if (options.bytes !== Array)
                        object.extra_data = $util.newBuffer(object.extra_data);
                }
                object.extra_data_len = 0;
                object.expiry = 0;
                object.overwintered = false;
                object.version_group_id = 0;
                object.timestamp = 0;
                object.branch_id = 0;
            }
            if (message.version != null && message.hasOwnProperty("version"))
                object.version = message.version;
            if (message.inputs && message.inputs.length) {
                object.inputs = [];
                for (var j = 0; j < message.inputs.length; ++j)
                    object.inputs[j] = $root.TxAck.TransactionType.TxInputType.toObject(message.inputs[j], options);
            }
            if (message.bin_outputs && message.bin_outputs.length) {
                object.bin_outputs = [];
                for (var j = 0; j < message.bin_outputs.length; ++j)
                    object.bin_outputs[j] = $root.TxAck.TransactionType.TxOutputBinType.toObject(message.bin_outputs[j], options);
            }
            if (message.lock_time != null && message.hasOwnProperty("lock_time"))
                object.lock_time = message.lock_time;
            if (message.outputs && message.outputs.length) {
                object.outputs = [];
                for (var j = 0; j < message.outputs.length; ++j)
                    object.outputs[j] = $root.TxAck.TransactionType.TxOutputType.toObject(message.outputs[j], options);
            }
            if (message.inputs_cnt != null && message.hasOwnProperty("inputs_cnt"))
                object.inputs_cnt = message.inputs_cnt;
            if (message.outputs_cnt != null && message.hasOwnProperty("outputs_cnt"))
                object.outputs_cnt = message.outputs_cnt;
            if (message.extra_data != null && message.hasOwnProperty("extra_data"))
                object.extra_data = options.bytes === String ? $util.base64.encode(message.extra_data, 0, message.extra_data.length) : options.bytes === Array ? Array.prototype.slice.call(message.extra_data) : message.extra_data;
            if (message.extra_data_len != null && message.hasOwnProperty("extra_data_len"))
                object.extra_data_len = message.extra_data_len;
            if (message.expiry != null && message.hasOwnProperty("expiry"))
                object.expiry = message.expiry;
            if (message.overwintered != null && message.hasOwnProperty("overwintered"))
                object.overwintered = message.overwintered;
            if (message.version_group_id != null && message.hasOwnProperty("version_group_id"))
                object.version_group_id = message.version_group_id;
            if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                object.timestamp = message.timestamp;
            if (message.branch_id != null && message.hasOwnProperty("branch_id"))
                object.branch_id = message.branch_id;
            return object;
        };

        TransactionType.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        TransactionType.TxInputType = (function() {

            function TxInputType(properties) {
                this.address_n = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            TxInputType.prototype.address_n = $util.emptyArray;
            TxInputType.prototype.prev_hash = $util.newBuffer([]);
            TxInputType.prototype.prev_index = 0;
            TxInputType.prototype.script_sig = $util.newBuffer([]);
            TxInputType.prototype.sequence = 4294967295;
            TxInputType.prototype.script_type = 0;
            TxInputType.prototype.multisig = null;
            TxInputType.prototype.amount = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
            TxInputType.prototype.decred_tree = 0;
            TxInputType.prototype.witness = $util.newBuffer([]);
            TxInputType.prototype.ownership_proof = $util.newBuffer([]);
            TxInputType.prototype.commitment_data = $util.newBuffer([]);
            TxInputType.prototype.orig_hash = $util.newBuffer([]);
            TxInputType.prototype.orig_index = 0;
            TxInputType.prototype.decred_staking_spend = 0;
            TxInputType.prototype.script_pubkey = $util.newBuffer([]);

            TxInputType.create = function create(properties) {
                return new TxInputType(properties);
            };

            TxInputType.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.address_n != null && message.address_n.length)
                    for (var i = 0; i < message.address_n.length; ++i)
                        writer.uint32(8).uint32(message.address_n[i]);
                writer.uint32(18).bytes(message.prev_hash);
                writer.uint32(24).uint32(message.prev_index);
                if (message.script_sig != null && Object.hasOwnProperty.call(message, "script_sig"))
                    writer.uint32(34).bytes(message.script_sig);
                if (message.sequence != null && Object.hasOwnProperty.call(message, "sequence"))
                    writer.uint32(40).uint32(message.sequence);
                if (message.script_type != null && Object.hasOwnProperty.call(message, "script_type"))
                    writer.uint32(48).int32(message.script_type);
                if (message.multisig != null && Object.hasOwnProperty.call(message, "multisig"))
                    $root.MultisigRedeemScriptType.encode(message.multisig, writer.uint32(58).fork()).ldelim();
                if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
                    writer.uint32(64).uint64(message.amount);
                if (message.decred_tree != null && Object.hasOwnProperty.call(message, "decred_tree"))
                    writer.uint32(72).uint32(message.decred_tree);
                if (message.witness != null && Object.hasOwnProperty.call(message, "witness"))
                    writer.uint32(106).bytes(message.witness);
                if (message.ownership_proof != null && Object.hasOwnProperty.call(message, "ownership_proof"))
                    writer.uint32(114).bytes(message.ownership_proof);
                if (message.commitment_data != null && Object.hasOwnProperty.call(message, "commitment_data"))
                    writer.uint32(122).bytes(message.commitment_data);
                if (message.orig_hash != null && Object.hasOwnProperty.call(message, "orig_hash"))
                    writer.uint32(130).bytes(message.orig_hash);
                if (message.orig_index != null && Object.hasOwnProperty.call(message, "orig_index"))
                    writer.uint32(136).uint32(message.orig_index);
                if (message.decred_staking_spend != null && Object.hasOwnProperty.call(message, "decred_staking_spend"))
                    writer.uint32(144).int32(message.decred_staking_spend);
                if (message.script_pubkey != null && Object.hasOwnProperty.call(message, "script_pubkey"))
                    writer.uint32(154).bytes(message.script_pubkey);
                return writer;
            };

            TxInputType.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            TxInputType.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TxAck.TransactionType.TxInputType();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (!(message.address_n && message.address_n.length))
                            message.address_n = [];
                        if ((tag & 7) === 2) {
                            var end2 = reader.uint32() + reader.pos;
                            while (reader.pos < end2)
                                message.address_n.push(reader.uint32());
                        } else
                            message.address_n.push(reader.uint32());
                        break;
                    case 2:
                        message.prev_hash = reader.bytes();
                        break;
                    case 3:
                        message.prev_index = reader.uint32();
                        break;
                    case 4:
                        message.script_sig = reader.bytes();
                        break;
                    case 5:
                        message.sequence = reader.uint32();
                        break;
                    case 6:
                        message.script_type = reader.int32();
                        break;
                    case 7:
                        message.multisig = $root.MultisigRedeemScriptType.decode(reader, reader.uint32());
                        break;
                    case 8:
                        message.amount = reader.uint64();
                        break;
                    case 9:
                        message.decred_tree = reader.uint32();
                        break;
                    case 13:
                        message.witness = reader.bytes();
                        break;
                    case 14:
                        message.ownership_proof = reader.bytes();
                        break;
                    case 15:
                        message.commitment_data = reader.bytes();
                        break;
                    case 16:
                        message.orig_hash = reader.bytes();
                        break;
                    case 17:
                        message.orig_index = reader.uint32();
                        break;
                    case 18:
                        message.decred_staking_spend = reader.int32();
                        break;
                    case 19:
                        message.script_pubkey = reader.bytes();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                if (!message.hasOwnProperty("prev_hash"))
                    throw $util.ProtocolError("missing required 'prev_hash'", { instance: message });
                if (!message.hasOwnProperty("prev_index"))
                    throw $util.ProtocolError("missing required 'prev_index'", { instance: message });
                return message;
            };

            TxInputType.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            TxInputType.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.address_n != null && message.hasOwnProperty("address_n")) {
                    if (!Array.isArray(message.address_n))
                        return "address_n: array expected";
                    for (var i = 0; i < message.address_n.length; ++i)
                        if (!$util.isInteger(message.address_n[i]))
                            return "address_n: integer[] expected";
                }
                if (!(message.prev_hash && typeof message.prev_hash.length === "number" || $util.isString(message.prev_hash)))
                    return "prev_hash: buffer expected";
                if (!$util.isInteger(message.prev_index))
                    return "prev_index: integer expected";
                if (message.script_sig != null && message.hasOwnProperty("script_sig"))
                    if (!(message.script_sig && typeof message.script_sig.length === "number" || $util.isString(message.script_sig)))
                        return "script_sig: buffer expected";
                if (message.sequence != null && message.hasOwnProperty("sequence"))
                    if (!$util.isInteger(message.sequence))
                        return "sequence: integer expected";
                if (message.script_type != null && message.hasOwnProperty("script_type"))
                    switch (message.script_type) {
                    default:
                        return "script_type: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                        break;
                    }
                if (message.multisig != null && message.hasOwnProperty("multisig")) {
                    var error = $root.MultisigRedeemScriptType.verify(message.multisig);
                    if (error)
                        return "multisig." + error;
                }
                if (message.amount != null && message.hasOwnProperty("amount"))
                    if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
                        return "amount: integer|Long expected";
                if (message.decred_tree != null && message.hasOwnProperty("decred_tree"))
                    if (!$util.isInteger(message.decred_tree))
                        return "decred_tree: integer expected";
                if (message.witness != null && message.hasOwnProperty("witness"))
                    if (!(message.witness && typeof message.witness.length === "number" || $util.isString(message.witness)))
                        return "witness: buffer expected";
                if (message.ownership_proof != null && message.hasOwnProperty("ownership_proof"))
                    if (!(message.ownership_proof && typeof message.ownership_proof.length === "number" || $util.isString(message.ownership_proof)))
                        return "ownership_proof: buffer expected";
                if (message.commitment_data != null && message.hasOwnProperty("commitment_data"))
                    if (!(message.commitment_data && typeof message.commitment_data.length === "number" || $util.isString(message.commitment_data)))
                        return "commitment_data: buffer expected";
                if (message.orig_hash != null && message.hasOwnProperty("orig_hash"))
                    if (!(message.orig_hash && typeof message.orig_hash.length === "number" || $util.isString(message.orig_hash)))
                        return "orig_hash: buffer expected";
                if (message.orig_index != null && message.hasOwnProperty("orig_index"))
                    if (!$util.isInteger(message.orig_index))
                        return "orig_index: integer expected";
                if (message.decred_staking_spend != null && message.hasOwnProperty("decred_staking_spend"))
                    switch (message.decred_staking_spend) {
                    default:
                        return "decred_staking_spend: enum value expected";
                    case 0:
                    case 1:
                        break;
                    }
                if (message.script_pubkey != null && message.hasOwnProperty("script_pubkey"))
                    if (!(message.script_pubkey && typeof message.script_pubkey.length === "number" || $util.isString(message.script_pubkey)))
                        return "script_pubkey: buffer expected";
                return null;
            };

            TxInputType.fromObject = function fromObject(object) {
                if (object instanceof $root.TxAck.TransactionType.TxInputType)
                    return object;
                var message = new $root.TxAck.TransactionType.TxInputType();
                if (object.address_n) {
                    if (!Array.isArray(object.address_n))
                        throw TypeError(".TxAck.TransactionType.TxInputType.address_n: array expected");
                    message.address_n = [];
                    for (var i = 0; i < object.address_n.length; ++i)
                        message.address_n[i] = object.address_n[i] >>> 0;
                }
                if (object.prev_hash != null)
                    if (typeof object.prev_hash === "string")
                        $util.base64.decode(object.prev_hash, message.prev_hash = $util.newBuffer($util.base64.length(object.prev_hash)), 0);
                    else if (object.prev_hash.length)
                        message.prev_hash = object.prev_hash;
                if (object.prev_index != null)
                    message.prev_index = object.prev_index >>> 0;
                if (object.script_sig != null)
                    if (typeof object.script_sig === "string")
                        $util.base64.decode(object.script_sig, message.script_sig = $util.newBuffer($util.base64.length(object.script_sig)), 0);
                    else if (object.script_sig.length)
                        message.script_sig = object.script_sig;
                if (object.sequence != null)
                    message.sequence = object.sequence >>> 0;
                switch (object.script_type) {
                case "SPENDADDRESS":
                case 0:
                    message.script_type = 0;
                    break;
                case "SPENDMULTISIG":
                case 1:
                    message.script_type = 1;
                    break;
                case "EXTERNAL":
                case 2:
                    message.script_type = 2;
                    break;
                case "SPENDWITNESS":
                case 3:
                    message.script_type = 3;
                    break;
                case "SPENDP2SHWITNESS":
                case 4:
                    message.script_type = 4;
                    break;
                case "SPENDTAPROOT":
                case 5:
                    message.script_type = 5;
                    break;
                }
                if (object.multisig != null) {
                    if (typeof object.multisig !== "object")
                        throw TypeError(".TxAck.TransactionType.TxInputType.multisig: object expected");
                    message.multisig = $root.MultisigRedeemScriptType.fromObject(object.multisig);
                }
                if (object.amount != null)
                    if ($util.Long)
                        (message.amount = $util.Long.fromValue(object.amount)).unsigned = true;
                    else if (typeof object.amount === "string")
                        message.amount = parseInt(object.amount, 10);
                    else if (typeof object.amount === "number")
                        message.amount = object.amount;
                    else if (typeof object.amount === "object")
                        message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber(true);
                if (object.decred_tree != null)
                    message.decred_tree = object.decred_tree >>> 0;
                if (object.witness != null)
                    if (typeof object.witness === "string")
                        $util.base64.decode(object.witness, message.witness = $util.newBuffer($util.base64.length(object.witness)), 0);
                    else if (object.witness.length)
                        message.witness = object.witness;
                if (object.ownership_proof != null)
                    if (typeof object.ownership_proof === "string")
                        $util.base64.decode(object.ownership_proof, message.ownership_proof = $util.newBuffer($util.base64.length(object.ownership_proof)), 0);
                    else if (object.ownership_proof.length)
                        message.ownership_proof = object.ownership_proof;
                if (object.commitment_data != null)
                    if (typeof object.commitment_data === "string")
                        $util.base64.decode(object.commitment_data, message.commitment_data = $util.newBuffer($util.base64.length(object.commitment_data)), 0);
                    else if (object.commitment_data.length)
                        message.commitment_data = object.commitment_data;
                if (object.orig_hash != null)
                    if (typeof object.orig_hash === "string")
                        $util.base64.decode(object.orig_hash, message.orig_hash = $util.newBuffer($util.base64.length(object.orig_hash)), 0);
                    else if (object.orig_hash.length)
                        message.orig_hash = object.orig_hash;
                if (object.orig_index != null)
                    message.orig_index = object.orig_index >>> 0;
                switch (object.decred_staking_spend) {
                case "SSGen":
                case 0:
                    message.decred_staking_spend = 0;
                    break;
                case "SSRTX":
                case 1:
                    message.decred_staking_spend = 1;
                    break;
                }
                if (object.script_pubkey != null)
                    if (typeof object.script_pubkey === "string")
                        $util.base64.decode(object.script_pubkey, message.script_pubkey = $util.newBuffer($util.base64.length(object.script_pubkey)), 0);
                    else if (object.script_pubkey.length)
                        message.script_pubkey = object.script_pubkey;
                return message;
            };

            TxInputType.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.address_n = [];
                if (options.defaults) {
                    if (options.bytes === String)
                        object.prev_hash = "";
                    else {
                        object.prev_hash = [];
                        if (options.bytes !== Array)
                            object.prev_hash = $util.newBuffer(object.prev_hash);
                    }
                    object.prev_index = 0;
                    if (options.bytes === String)
                        object.script_sig = "";
                    else {
                        object.script_sig = [];
                        if (options.bytes !== Array)
                            object.script_sig = $util.newBuffer(object.script_sig);
                    }
                    object.sequence = 4294967295;
                    object.script_type = options.enums === String ? "SPENDADDRESS" : 0;
                    object.multisig = null;
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, true);
                        object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.amount = options.longs === String ? "0" : 0;
                    object.decred_tree = 0;
                    if (options.bytes === String)
                        object.witness = "";
                    else {
                        object.witness = [];
                        if (options.bytes !== Array)
                            object.witness = $util.newBuffer(object.witness);
                    }
                    if (options.bytes === String)
                        object.ownership_proof = "";
                    else {
                        object.ownership_proof = [];
                        if (options.bytes !== Array)
                            object.ownership_proof = $util.newBuffer(object.ownership_proof);
                    }
                    if (options.bytes === String)
                        object.commitment_data = "";
                    else {
                        object.commitment_data = [];
                        if (options.bytes !== Array)
                            object.commitment_data = $util.newBuffer(object.commitment_data);
                    }
                    if (options.bytes === String)
                        object.orig_hash = "";
                    else {
                        object.orig_hash = [];
                        if (options.bytes !== Array)
                            object.orig_hash = $util.newBuffer(object.orig_hash);
                    }
                    object.orig_index = 0;
                    object.decred_staking_spend = options.enums === String ? "SSGen" : 0;
                    if (options.bytes === String)
                        object.script_pubkey = "";
                    else {
                        object.script_pubkey = [];
                        if (options.bytes !== Array)
                            object.script_pubkey = $util.newBuffer(object.script_pubkey);
                    }
                }
                if (message.address_n && message.address_n.length) {
                    object.address_n = [];
                    for (var j = 0; j < message.address_n.length; ++j)
                        object.address_n[j] = message.address_n[j];
                }
                if (message.prev_hash != null && message.hasOwnProperty("prev_hash"))
                    object.prev_hash = options.bytes === String ? $util.base64.encode(message.prev_hash, 0, message.prev_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.prev_hash) : message.prev_hash;
                if (message.prev_index != null && message.hasOwnProperty("prev_index"))
                    object.prev_index = message.prev_index;
                if (message.script_sig != null && message.hasOwnProperty("script_sig"))
                    object.script_sig = options.bytes === String ? $util.base64.encode(message.script_sig, 0, message.script_sig.length) : options.bytes === Array ? Array.prototype.slice.call(message.script_sig) : message.script_sig;
                if (message.sequence != null && message.hasOwnProperty("sequence"))
                    object.sequence = message.sequence;
                if (message.script_type != null && message.hasOwnProperty("script_type"))
                    object.script_type = options.enums === String ? $root.InputScriptType[message.script_type] : message.script_type;
                if (message.multisig != null && message.hasOwnProperty("multisig"))
                    object.multisig = $root.MultisigRedeemScriptType.toObject(message.multisig, options);
                if (message.amount != null && message.hasOwnProperty("amount"))
                    if (typeof message.amount === "number")
                        object.amount = options.longs === String ? String(message.amount) : message.amount;
                    else
                        object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber(true) : message.amount;
                if (message.decred_tree != null && message.hasOwnProperty("decred_tree"))
                    object.decred_tree = message.decred_tree;
                if (message.witness != null && message.hasOwnProperty("witness"))
                    object.witness = options.bytes === String ? $util.base64.encode(message.witness, 0, message.witness.length) : options.bytes === Array ? Array.prototype.slice.call(message.witness) : message.witness;
                if (message.ownership_proof != null && message.hasOwnProperty("ownership_proof"))
                    object.ownership_proof = options.bytes === String ? $util.base64.encode(message.ownership_proof, 0, message.ownership_proof.length) : options.bytes === Array ? Array.prototype.slice.call(message.ownership_proof) : message.ownership_proof;
                if (message.commitment_data != null && message.hasOwnProperty("commitment_data"))
                    object.commitment_data = options.bytes === String ? $util.base64.encode(message.commitment_data, 0, message.commitment_data.length) : options.bytes === Array ? Array.prototype.slice.call(message.commitment_data) : message.commitment_data;
                if (message.orig_hash != null && message.hasOwnProperty("orig_hash"))
                    object.orig_hash = options.bytes === String ? $util.base64.encode(message.orig_hash, 0, message.orig_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.orig_hash) : message.orig_hash;
                if (message.orig_index != null && message.hasOwnProperty("orig_index"))
                    object.orig_index = message.orig_index;
                if (message.decred_staking_spend != null && message.hasOwnProperty("decred_staking_spend"))
                    object.decred_staking_spend = options.enums === String ? $root.DecredStakingSpendType[message.decred_staking_spend] : message.decred_staking_spend;
                if (message.script_pubkey != null && message.hasOwnProperty("script_pubkey"))
                    object.script_pubkey = options.bytes === String ? $util.base64.encode(message.script_pubkey, 0, message.script_pubkey.length) : options.bytes === Array ? Array.prototype.slice.call(message.script_pubkey) : message.script_pubkey;
                return object;
            };

            TxInputType.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return TxInputType;
        })();

        TransactionType.TxOutputBinType = (function() {

            function TxOutputBinType(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            TxOutputBinType.prototype.amount = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
            TxOutputBinType.prototype.script_pubkey = $util.newBuffer([]);
            TxOutputBinType.prototype.decred_script_version = 0;

            TxOutputBinType.create = function create(properties) {
                return new TxOutputBinType(properties);
            };

            TxOutputBinType.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                writer.uint32(8).uint64(message.amount);
                writer.uint32(18).bytes(message.script_pubkey);
                if (message.decred_script_version != null && Object.hasOwnProperty.call(message, "decred_script_version"))
                    writer.uint32(24).uint32(message.decred_script_version);
                return writer;
            };

            TxOutputBinType.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            TxOutputBinType.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TxAck.TransactionType.TxOutputBinType();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.amount = reader.uint64();
                        break;
                    case 2:
                        message.script_pubkey = reader.bytes();
                        break;
                    case 3:
                        message.decred_script_version = reader.uint32();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                if (!message.hasOwnProperty("amount"))
                    throw $util.ProtocolError("missing required 'amount'", { instance: message });
                if (!message.hasOwnProperty("script_pubkey"))
                    throw $util.ProtocolError("missing required 'script_pubkey'", { instance: message });
                return message;
            };

            TxOutputBinType.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            TxOutputBinType.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
                    return "amount: integer|Long expected";
                if (!(message.script_pubkey && typeof message.script_pubkey.length === "number" || $util.isString(message.script_pubkey)))
                    return "script_pubkey: buffer expected";
                if (message.decred_script_version != null && message.hasOwnProperty("decred_script_version"))
                    if (!$util.isInteger(message.decred_script_version))
                        return "decred_script_version: integer expected";
                return null;
            };

            TxOutputBinType.fromObject = function fromObject(object) {
                if (object instanceof $root.TxAck.TransactionType.TxOutputBinType)
                    return object;
                var message = new $root.TxAck.TransactionType.TxOutputBinType();
                if (object.amount != null)
                    if ($util.Long)
                        (message.amount = $util.Long.fromValue(object.amount)).unsigned = true;
                    else if (typeof object.amount === "string")
                        message.amount = parseInt(object.amount, 10);
                    else if (typeof object.amount === "number")
                        message.amount = object.amount;
                    else if (typeof object.amount === "object")
                        message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber(true);
                if (object.script_pubkey != null)
                    if (typeof object.script_pubkey === "string")
                        $util.base64.decode(object.script_pubkey, message.script_pubkey = $util.newBuffer($util.base64.length(object.script_pubkey)), 0);
                    else if (object.script_pubkey.length)
                        message.script_pubkey = object.script_pubkey;
                if (object.decred_script_version != null)
                    message.decred_script_version = object.decred_script_version >>> 0;
                return message;
            };

            TxOutputBinType.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, true);
                        object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.amount = options.longs === String ? "0" : 0;
                    if (options.bytes === String)
                        object.script_pubkey = "";
                    else {
                        object.script_pubkey = [];
                        if (options.bytes !== Array)
                            object.script_pubkey = $util.newBuffer(object.script_pubkey);
                    }
                    object.decred_script_version = 0;
                }
                if (message.amount != null && message.hasOwnProperty("amount"))
                    if (typeof message.amount === "number")
                        object.amount = options.longs === String ? String(message.amount) : message.amount;
                    else
                        object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber(true) : message.amount;
                if (message.script_pubkey != null && message.hasOwnProperty("script_pubkey"))
                    object.script_pubkey = options.bytes === String ? $util.base64.encode(message.script_pubkey, 0, message.script_pubkey.length) : options.bytes === Array ? Array.prototype.slice.call(message.script_pubkey) : message.script_pubkey;
                if (message.decred_script_version != null && message.hasOwnProperty("decred_script_version"))
                    object.decred_script_version = message.decred_script_version;
                return object;
            };

            TxOutputBinType.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return TxOutputBinType;
        })();

        TransactionType.TxOutputType = (function() {

            function TxOutputType(properties) {
                this.address_n = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            TxOutputType.prototype.address = "";
            TxOutputType.prototype.address_n = $util.emptyArray;
            TxOutputType.prototype.amount = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
            TxOutputType.prototype.script_type = 0;
            TxOutputType.prototype.multisig = null;
            TxOutputType.prototype.op_return_data = $util.newBuffer([]);
            TxOutputType.prototype.orig_hash = $util.newBuffer([]);
            TxOutputType.prototype.orig_index = 0;

            TxOutputType.create = function create(properties) {
                return new TxOutputType(properties);
            };

            TxOutputType.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.address != null && Object.hasOwnProperty.call(message, "address"))
                    writer.uint32(10).string(message.address);
                if (message.address_n != null && message.address_n.length)
                    for (var i = 0; i < message.address_n.length; ++i)
                        writer.uint32(16).uint32(message.address_n[i]);
                writer.uint32(24).uint64(message.amount);
                if (message.script_type != null && Object.hasOwnProperty.call(message, "script_type"))
                    writer.uint32(32).int32(message.script_type);
                if (message.multisig != null && Object.hasOwnProperty.call(message, "multisig"))
                    $root.MultisigRedeemScriptType.encode(message.multisig, writer.uint32(42).fork()).ldelim();
                if (message.op_return_data != null && Object.hasOwnProperty.call(message, "op_return_data"))
                    writer.uint32(50).bytes(message.op_return_data);
                if (message.orig_hash != null && Object.hasOwnProperty.call(message, "orig_hash"))
                    writer.uint32(82).bytes(message.orig_hash);
                if (message.orig_index != null && Object.hasOwnProperty.call(message, "orig_index"))
                    writer.uint32(88).uint32(message.orig_index);
                return writer;
            };

            TxOutputType.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            TxOutputType.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TxAck.TransactionType.TxOutputType();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.address = reader.string();
                        break;
                    case 2:
                        if (!(message.address_n && message.address_n.length))
                            message.address_n = [];
                        if ((tag & 7) === 2) {
                            var end2 = reader.uint32() + reader.pos;
                            while (reader.pos < end2)
                                message.address_n.push(reader.uint32());
                        } else
                            message.address_n.push(reader.uint32());
                        break;
                    case 3:
                        message.amount = reader.uint64();
                        break;
                    case 4:
                        message.script_type = reader.int32();
                        break;
                    case 5:
                        message.multisig = $root.MultisigRedeemScriptType.decode(reader, reader.uint32());
                        break;
                    case 6:
                        message.op_return_data = reader.bytes();
                        break;
                    case 10:
                        message.orig_hash = reader.bytes();
                        break;
                    case 11:
                        message.orig_index = reader.uint32();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                if (!message.hasOwnProperty("amount"))
                    throw $util.ProtocolError("missing required 'amount'", { instance: message });
                return message;
            };

            TxOutputType.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            TxOutputType.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.address != null && message.hasOwnProperty("address"))
                    if (!$util.isString(message.address))
                        return "address: string expected";
                if (message.address_n != null && message.hasOwnProperty("address_n")) {
                    if (!Array.isArray(message.address_n))
                        return "address_n: array expected";
                    for (var i = 0; i < message.address_n.length; ++i)
                        if (!$util.isInteger(message.address_n[i]))
                            return "address_n: integer[] expected";
                }
                if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
                    return "amount: integer|Long expected";
                if (message.script_type != null && message.hasOwnProperty("script_type"))
                    switch (message.script_type) {
                    default:
                        return "script_type: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                    case 6:
                        break;
                    }
                if (message.multisig != null && message.hasOwnProperty("multisig")) {
                    var error = $root.MultisigRedeemScriptType.verify(message.multisig);
                    if (error)
                        return "multisig." + error;
                }
                if (message.op_return_data != null && message.hasOwnProperty("op_return_data"))
                    if (!(message.op_return_data && typeof message.op_return_data.length === "number" || $util.isString(message.op_return_data)))
                        return "op_return_data: buffer expected";
                if (message.orig_hash != null && message.hasOwnProperty("orig_hash"))
                    if (!(message.orig_hash && typeof message.orig_hash.length === "number" || $util.isString(message.orig_hash)))
                        return "orig_hash: buffer expected";
                if (message.orig_index != null && message.hasOwnProperty("orig_index"))
                    if (!$util.isInteger(message.orig_index))
                        return "orig_index: integer expected";
                return null;
            };

            TxOutputType.fromObject = function fromObject(object) {
                if (object instanceof $root.TxAck.TransactionType.TxOutputType)
                    return object;
                var message = new $root.TxAck.TransactionType.TxOutputType();
                if (object.address != null)
                    message.address = String(object.address);
                if (object.address_n) {
                    if (!Array.isArray(object.address_n))
                        throw TypeError(".TxAck.TransactionType.TxOutputType.address_n: array expected");
                    message.address_n = [];
                    for (var i = 0; i < object.address_n.length; ++i)
                        message.address_n[i] = object.address_n[i] >>> 0;
                }
                if (object.amount != null)
                    if ($util.Long)
                        (message.amount = $util.Long.fromValue(object.amount)).unsigned = true;
                    else if (typeof object.amount === "string")
                        message.amount = parseInt(object.amount, 10);
                    else if (typeof object.amount === "number")
                        message.amount = object.amount;
                    else if (typeof object.amount === "object")
                        message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber(true);
                switch (object.script_type) {
                case "PAYTOADDRESS":
                case 0:
                    message.script_type = 0;
                    break;
                case "PAYTOSCRIPTHASH":
                case 1:
                    message.script_type = 1;
                    break;
                case "PAYTOMULTISIG":
                case 2:
                    message.script_type = 2;
                    break;
                case "PAYTOOPRETURN":
                case 3:
                    message.script_type = 3;
                    break;
                case "PAYTOWITNESS":
                case 4:
                    message.script_type = 4;
                    break;
                case "PAYTOP2SHWITNESS":
                case 5:
                    message.script_type = 5;
                    break;
                case "PAYTOTAPROOT":
                case 6:
                    message.script_type = 6;
                    break;
                }
                if (object.multisig != null) {
                    if (typeof object.multisig !== "object")
                        throw TypeError(".TxAck.TransactionType.TxOutputType.multisig: object expected");
                    message.multisig = $root.MultisigRedeemScriptType.fromObject(object.multisig);
                }
                if (object.op_return_data != null)
                    if (typeof object.op_return_data === "string")
                        $util.base64.decode(object.op_return_data, message.op_return_data = $util.newBuffer($util.base64.length(object.op_return_data)), 0);
                    else if (object.op_return_data.length)
                        message.op_return_data = object.op_return_data;
                if (object.orig_hash != null)
                    if (typeof object.orig_hash === "string")
                        $util.base64.decode(object.orig_hash, message.orig_hash = $util.newBuffer($util.base64.length(object.orig_hash)), 0);
                    else if (object.orig_hash.length)
                        message.orig_hash = object.orig_hash;
                if (object.orig_index != null)
                    message.orig_index = object.orig_index >>> 0;
                return message;
            };

            TxOutputType.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.address_n = [];
                if (options.defaults) {
                    object.address = "";
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, true);
                        object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.amount = options.longs === String ? "0" : 0;
                    object.script_type = options.enums === String ? "PAYTOADDRESS" : 0;
                    object.multisig = null;
                    if (options.bytes === String)
                        object.op_return_data = "";
                    else {
                        object.op_return_data = [];
                        if (options.bytes !== Array)
                            object.op_return_data = $util.newBuffer(object.op_return_data);
                    }
                    if (options.bytes === String)
                        object.orig_hash = "";
                    else {
                        object.orig_hash = [];
                        if (options.bytes !== Array)
                            object.orig_hash = $util.newBuffer(object.orig_hash);
                    }
                    object.orig_index = 0;
                }
                if (message.address != null && message.hasOwnProperty("address"))
                    object.address = message.address;
                if (message.address_n && message.address_n.length) {
                    object.address_n = [];
                    for (var j = 0; j < message.address_n.length; ++j)
                        object.address_n[j] = message.address_n[j];
                }
                if (message.amount != null && message.hasOwnProperty("amount"))
                    if (typeof message.amount === "number")
                        object.amount = options.longs === String ? String(message.amount) : message.amount;
                    else
                        object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber(true) : message.amount;
                if (message.script_type != null && message.hasOwnProperty("script_type"))
                    object.script_type = options.enums === String ? $root.OutputScriptType[message.script_type] : message.script_type;
                if (message.multisig != null && message.hasOwnProperty("multisig"))
                    object.multisig = $root.MultisigRedeemScriptType.toObject(message.multisig, options);
                if (message.op_return_data != null && message.hasOwnProperty("op_return_data"))
                    object.op_return_data = options.bytes === String ? $util.base64.encode(message.op_return_data, 0, message.op_return_data.length) : options.bytes === Array ? Array.prototype.slice.call(message.op_return_data) : message.op_return_data;
                if (message.orig_hash != null && message.hasOwnProperty("orig_hash"))
                    object.orig_hash = options.bytes === String ? $util.base64.encode(message.orig_hash, 0, message.orig_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.orig_hash) : message.orig_hash;
                if (message.orig_index != null && message.hasOwnProperty("orig_index"))
                    object.orig_index = message.orig_index;
                return object;
            };

            TxOutputType.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return TxOutputType;
        })();

        return TransactionType;
    })();

    return TxAck;
})();

$root.TxInput = (function() {

    function TxInput(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    TxInput.prototype.address_n = $util.emptyArray;
    TxInput.prototype.prev_hash = $util.newBuffer([]);
    TxInput.prototype.prev_index = 0;
    TxInput.prototype.script_sig = $util.newBuffer([]);
    TxInput.prototype.sequence = 4294967295;
    TxInput.prototype.script_type = 0;
    TxInput.prototype.multisig = null;
    TxInput.prototype.amount = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    TxInput.prototype.decred_tree = 0;
    TxInput.prototype.witness = $util.newBuffer([]);
    TxInput.prototype.ownership_proof = $util.newBuffer([]);
    TxInput.prototype.commitment_data = $util.newBuffer([]);
    TxInput.prototype.orig_hash = $util.newBuffer([]);
    TxInput.prototype.orig_index = 0;
    TxInput.prototype.decred_staking_spend = 0;
    TxInput.prototype.script_pubkey = $util.newBuffer([]);

    TxInput.create = function create(properties) {
        return new TxInput(properties);
    };

    TxInput.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).bytes(message.prev_hash);
        writer.uint32(24).uint32(message.prev_index);
        if (message.script_sig != null && Object.hasOwnProperty.call(message, "script_sig"))
            writer.uint32(34).bytes(message.script_sig);
        if (message.sequence != null && Object.hasOwnProperty.call(message, "sequence"))
            writer.uint32(40).uint32(message.sequence);
        if (message.script_type != null && Object.hasOwnProperty.call(message, "script_type"))
            writer.uint32(48).int32(message.script_type);
        if (message.multisig != null && Object.hasOwnProperty.call(message, "multisig"))
            $root.MultisigRedeemScriptType.encode(message.multisig, writer.uint32(58).fork()).ldelim();
        writer.uint32(64).uint64(message.amount);
        if (message.decred_tree != null && Object.hasOwnProperty.call(message, "decred_tree"))
            writer.uint32(72).uint32(message.decred_tree);
        if (message.witness != null && Object.hasOwnProperty.call(message, "witness"))
            writer.uint32(106).bytes(message.witness);
        if (message.ownership_proof != null && Object.hasOwnProperty.call(message, "ownership_proof"))
            writer.uint32(114).bytes(message.ownership_proof);
        if (message.commitment_data != null && Object.hasOwnProperty.call(message, "commitment_data"))
            writer.uint32(122).bytes(message.commitment_data);
        if (message.orig_hash != null && Object.hasOwnProperty.call(message, "orig_hash"))
            writer.uint32(130).bytes(message.orig_hash);
        if (message.orig_index != null && Object.hasOwnProperty.call(message, "orig_index"))
            writer.uint32(136).uint32(message.orig_index);
        if (message.decred_staking_spend != null && Object.hasOwnProperty.call(message, "decred_staking_spend"))
            writer.uint32(144).int32(message.decred_staking_spend);
        if (message.script_pubkey != null && Object.hasOwnProperty.call(message, "script_pubkey"))
            writer.uint32(154).bytes(message.script_pubkey);
        return writer;
    };

    TxInput.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    TxInput.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TxInput();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.prev_hash = reader.bytes();
                break;
            case 3:
                message.prev_index = reader.uint32();
                break;
            case 4:
                message.script_sig = reader.bytes();
                break;
            case 5:
                message.sequence = reader.uint32();
                break;
            case 6:
                message.script_type = reader.int32();
                break;
            case 7:
                message.multisig = $root.MultisigRedeemScriptType.decode(reader, reader.uint32());
                break;
            case 8:
                message.amount = reader.uint64();
                break;
            case 9:
                message.decred_tree = reader.uint32();
                break;
            case 13:
                message.witness = reader.bytes();
                break;
            case 14:
                message.ownership_proof = reader.bytes();
                break;
            case 15:
                message.commitment_data = reader.bytes();
                break;
            case 16:
                message.orig_hash = reader.bytes();
                break;
            case 17:
                message.orig_index = reader.uint32();
                break;
            case 18:
                message.decred_staking_spend = reader.int32();
                break;
            case 19:
                message.script_pubkey = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("prev_hash"))
            throw $util.ProtocolError("missing required 'prev_hash'", { instance: message });
        if (!message.hasOwnProperty("prev_index"))
            throw $util.ProtocolError("missing required 'prev_index'", { instance: message });
        if (!message.hasOwnProperty("amount"))
            throw $util.ProtocolError("missing required 'amount'", { instance: message });
        return message;
    };

    TxInput.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    TxInput.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!(message.prev_hash && typeof message.prev_hash.length === "number" || $util.isString(message.prev_hash)))
            return "prev_hash: buffer expected";
        if (!$util.isInteger(message.prev_index))
            return "prev_index: integer expected";
        if (message.script_sig != null && message.hasOwnProperty("script_sig"))
            if (!(message.script_sig && typeof message.script_sig.length === "number" || $util.isString(message.script_sig)))
                return "script_sig: buffer expected";
        if (message.sequence != null && message.hasOwnProperty("sequence"))
            if (!$util.isInteger(message.sequence))
                return "sequence: integer expected";
        if (message.script_type != null && message.hasOwnProperty("script_type"))
            switch (message.script_type) {
            default:
                return "script_type: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
                break;
            }
        if (message.multisig != null && message.hasOwnProperty("multisig")) {
            var error = $root.MultisigRedeemScriptType.verify(message.multisig);
            if (error)
                return "multisig." + error;
        }
        if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
            return "amount: integer|Long expected";
        if (message.decred_tree != null && message.hasOwnProperty("decred_tree"))
            if (!$util.isInteger(message.decred_tree))
                return "decred_tree: integer expected";
        if (message.witness != null && message.hasOwnProperty("witness"))
            if (!(message.witness && typeof message.witness.length === "number" || $util.isString(message.witness)))
                return "witness: buffer expected";
        if (message.ownership_proof != null && message.hasOwnProperty("ownership_proof"))
            if (!(message.ownership_proof && typeof message.ownership_proof.length === "number" || $util.isString(message.ownership_proof)))
                return "ownership_proof: buffer expected";
        if (message.commitment_data != null && message.hasOwnProperty("commitment_data"))
            if (!(message.commitment_data && typeof message.commitment_data.length === "number" || $util.isString(message.commitment_data)))
                return "commitment_data: buffer expected";
        if (message.orig_hash != null && message.hasOwnProperty("orig_hash"))
            if (!(message.orig_hash && typeof message.orig_hash.length === "number" || $util.isString(message.orig_hash)))
                return "orig_hash: buffer expected";
        if (message.orig_index != null && message.hasOwnProperty("orig_index"))
            if (!$util.isInteger(message.orig_index))
                return "orig_index: integer expected";
        if (message.decred_staking_spend != null && message.hasOwnProperty("decred_staking_spend"))
            switch (message.decred_staking_spend) {
            default:
                return "decred_staking_spend: enum value expected";
            case 0:
            case 1:
                break;
            }
        if (message.script_pubkey != null && message.hasOwnProperty("script_pubkey"))
            if (!(message.script_pubkey && typeof message.script_pubkey.length === "number" || $util.isString(message.script_pubkey)))
                return "script_pubkey: buffer expected";
        return null;
    };

    TxInput.fromObject = function fromObject(object) {
        if (object instanceof $root.TxInput)
            return object;
        var message = new $root.TxInput();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".TxInput.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.prev_hash != null)
            if (typeof object.prev_hash === "string")
                $util.base64.decode(object.prev_hash, message.prev_hash = $util.newBuffer($util.base64.length(object.prev_hash)), 0);
            else if (object.prev_hash.length)
                message.prev_hash = object.prev_hash;
        if (object.prev_index != null)
            message.prev_index = object.prev_index >>> 0;
        if (object.script_sig != null)
            if (typeof object.script_sig === "string")
                $util.base64.decode(object.script_sig, message.script_sig = $util.newBuffer($util.base64.length(object.script_sig)), 0);
            else if (object.script_sig.length)
                message.script_sig = object.script_sig;
        if (object.sequence != null)
            message.sequence = object.sequence >>> 0;
        switch (object.script_type) {
        case "SPENDADDRESS":
        case 0:
            message.script_type = 0;
            break;
        case "SPENDMULTISIG":
        case 1:
            message.script_type = 1;
            break;
        case "EXTERNAL":
        case 2:
            message.script_type = 2;
            break;
        case "SPENDWITNESS":
        case 3:
            message.script_type = 3;
            break;
        case "SPENDP2SHWITNESS":
        case 4:
            message.script_type = 4;
            break;
        case "SPENDTAPROOT":
        case 5:
            message.script_type = 5;
            break;
        }
        if (object.multisig != null) {
            if (typeof object.multisig !== "object")
                throw TypeError(".TxInput.multisig: object expected");
            message.multisig = $root.MultisigRedeemScriptType.fromObject(object.multisig);
        }
        if (object.amount != null)
            if ($util.Long)
                (message.amount = $util.Long.fromValue(object.amount)).unsigned = true;
            else if (typeof object.amount === "string")
                message.amount = parseInt(object.amount, 10);
            else if (typeof object.amount === "number")
                message.amount = object.amount;
            else if (typeof object.amount === "object")
                message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber(true);
        if (object.decred_tree != null)
            message.decred_tree = object.decred_tree >>> 0;
        if (object.witness != null)
            if (typeof object.witness === "string")
                $util.base64.decode(object.witness, message.witness = $util.newBuffer($util.base64.length(object.witness)), 0);
            else if (object.witness.length)
                message.witness = object.witness;
        if (object.ownership_proof != null)
            if (typeof object.ownership_proof === "string")
                $util.base64.decode(object.ownership_proof, message.ownership_proof = $util.newBuffer($util.base64.length(object.ownership_proof)), 0);
            else if (object.ownership_proof.length)
                message.ownership_proof = object.ownership_proof;
        if (object.commitment_data != null)
            if (typeof object.commitment_data === "string")
                $util.base64.decode(object.commitment_data, message.commitment_data = $util.newBuffer($util.base64.length(object.commitment_data)), 0);
            else if (object.commitment_data.length)
                message.commitment_data = object.commitment_data;
        if (object.orig_hash != null)
            if (typeof object.orig_hash === "string")
                $util.base64.decode(object.orig_hash, message.orig_hash = $util.newBuffer($util.base64.length(object.orig_hash)), 0);
            else if (object.orig_hash.length)
                message.orig_hash = object.orig_hash;
        if (object.orig_index != null)
            message.orig_index = object.orig_index >>> 0;
        switch (object.decred_staking_spend) {
        case "SSGen":
        case 0:
            message.decred_staking_spend = 0;
            break;
        case "SSRTX":
        case 1:
            message.decred_staking_spend = 1;
            break;
        }
        if (object.script_pubkey != null)
            if (typeof object.script_pubkey === "string")
                $util.base64.decode(object.script_pubkey, message.script_pubkey = $util.newBuffer($util.base64.length(object.script_pubkey)), 0);
            else if (object.script_pubkey.length)
                message.script_pubkey = object.script_pubkey;
        return message;
    };

    TxInput.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            if (options.bytes === String)
                object.prev_hash = "";
            else {
                object.prev_hash = [];
                if (options.bytes !== Array)
                    object.prev_hash = $util.newBuffer(object.prev_hash);
            }
            object.prev_index = 0;
            if (options.bytes === String)
                object.script_sig = "";
            else {
                object.script_sig = [];
                if (options.bytes !== Array)
                    object.script_sig = $util.newBuffer(object.script_sig);
            }
            object.sequence = 4294967295;
            object.script_type = options.enums === String ? "SPENDADDRESS" : 0;
            object.multisig = null;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.amount = options.longs === String ? "0" : 0;
            object.decred_tree = 0;
            if (options.bytes === String)
                object.witness = "";
            else {
                object.witness = [];
                if (options.bytes !== Array)
                    object.witness = $util.newBuffer(object.witness);
            }
            if (options.bytes === String)
                object.ownership_proof = "";
            else {
                object.ownership_proof = [];
                if (options.bytes !== Array)
                    object.ownership_proof = $util.newBuffer(object.ownership_proof);
            }
            if (options.bytes === String)
                object.commitment_data = "";
            else {
                object.commitment_data = [];
                if (options.bytes !== Array)
                    object.commitment_data = $util.newBuffer(object.commitment_data);
            }
            if (options.bytes === String)
                object.orig_hash = "";
            else {
                object.orig_hash = [];
                if (options.bytes !== Array)
                    object.orig_hash = $util.newBuffer(object.orig_hash);
            }
            object.orig_index = 0;
            object.decred_staking_spend = options.enums === String ? "SSGen" : 0;
            if (options.bytes === String)
                object.script_pubkey = "";
            else {
                object.script_pubkey = [];
                if (options.bytes !== Array)
                    object.script_pubkey = $util.newBuffer(object.script_pubkey);
            }
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.prev_hash != null && message.hasOwnProperty("prev_hash"))
            object.prev_hash = options.bytes === String ? $util.base64.encode(message.prev_hash, 0, message.prev_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.prev_hash) : message.prev_hash;
        if (message.prev_index != null && message.hasOwnProperty("prev_index"))
            object.prev_index = message.prev_index;
        if (message.script_sig != null && message.hasOwnProperty("script_sig"))
            object.script_sig = options.bytes === String ? $util.base64.encode(message.script_sig, 0, message.script_sig.length) : options.bytes === Array ? Array.prototype.slice.call(message.script_sig) : message.script_sig;
        if (message.sequence != null && message.hasOwnProperty("sequence"))
            object.sequence = message.sequence;
        if (message.script_type != null && message.hasOwnProperty("script_type"))
            object.script_type = options.enums === String ? $root.InputScriptType[message.script_type] : message.script_type;
        if (message.multisig != null && message.hasOwnProperty("multisig"))
            object.multisig = $root.MultisigRedeemScriptType.toObject(message.multisig, options);
        if (message.amount != null && message.hasOwnProperty("amount"))
            if (typeof message.amount === "number")
                object.amount = options.longs === String ? String(message.amount) : message.amount;
            else
                object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber(true) : message.amount;
        if (message.decred_tree != null && message.hasOwnProperty("decred_tree"))
            object.decred_tree = message.decred_tree;
        if (message.witness != null && message.hasOwnProperty("witness"))
            object.witness = options.bytes === String ? $util.base64.encode(message.witness, 0, message.witness.length) : options.bytes === Array ? Array.prototype.slice.call(message.witness) : message.witness;
        if (message.ownership_proof != null && message.hasOwnProperty("ownership_proof"))
            object.ownership_proof = options.bytes === String ? $util.base64.encode(message.ownership_proof, 0, message.ownership_proof.length) : options.bytes === Array ? Array.prototype.slice.call(message.ownership_proof) : message.ownership_proof;
        if (message.commitment_data != null && message.hasOwnProperty("commitment_data"))
            object.commitment_data = options.bytes === String ? $util.base64.encode(message.commitment_data, 0, message.commitment_data.length) : options.bytes === Array ? Array.prototype.slice.call(message.commitment_data) : message.commitment_data;
        if (message.orig_hash != null && message.hasOwnProperty("orig_hash"))
            object.orig_hash = options.bytes === String ? $util.base64.encode(message.orig_hash, 0, message.orig_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.orig_hash) : message.orig_hash;
        if (message.orig_index != null && message.hasOwnProperty("orig_index"))
            object.orig_index = message.orig_index;
        if (message.decred_staking_spend != null && message.hasOwnProperty("decred_staking_spend"))
            object.decred_staking_spend = options.enums === String ? $root.DecredStakingSpendType[message.decred_staking_spend] : message.decred_staking_spend;
        if (message.script_pubkey != null && message.hasOwnProperty("script_pubkey"))
            object.script_pubkey = options.bytes === String ? $util.base64.encode(message.script_pubkey, 0, message.script_pubkey.length) : options.bytes === Array ? Array.prototype.slice.call(message.script_pubkey) : message.script_pubkey;
        return object;
    };

    TxInput.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return TxInput;
})();

$root.TxOutput = (function() {

    function TxOutput(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    TxOutput.prototype.address = "";
    TxOutput.prototype.address_n = $util.emptyArray;
    TxOutput.prototype.amount = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    TxOutput.prototype.script_type = 0;
    TxOutput.prototype.multisig = null;
    TxOutput.prototype.op_return_data = $util.newBuffer([]);
    TxOutput.prototype.orig_hash = $util.newBuffer([]);
    TxOutput.prototype.orig_index = 0;

    TxOutput.create = function create(properties) {
        return new TxOutput(properties);
    };

    TxOutput.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address != null && Object.hasOwnProperty.call(message, "address"))
            writer.uint32(10).string(message.address);
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(16).uint32(message.address_n[i]);
        writer.uint32(24).uint64(message.amount);
        if (message.script_type != null && Object.hasOwnProperty.call(message, "script_type"))
            writer.uint32(32).int32(message.script_type);
        if (message.multisig != null && Object.hasOwnProperty.call(message, "multisig"))
            $root.MultisigRedeemScriptType.encode(message.multisig, writer.uint32(42).fork()).ldelim();
        if (message.op_return_data != null && Object.hasOwnProperty.call(message, "op_return_data"))
            writer.uint32(50).bytes(message.op_return_data);
        if (message.orig_hash != null && Object.hasOwnProperty.call(message, "orig_hash"))
            writer.uint32(82).bytes(message.orig_hash);
        if (message.orig_index != null && Object.hasOwnProperty.call(message, "orig_index"))
            writer.uint32(88).uint32(message.orig_index);
        return writer;
    };

    TxOutput.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    TxOutput.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TxOutput();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.string();
                break;
            case 2:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 3:
                message.amount = reader.uint64();
                break;
            case 4:
                message.script_type = reader.int32();
                break;
            case 5:
                message.multisig = $root.MultisigRedeemScriptType.decode(reader, reader.uint32());
                break;
            case 6:
                message.op_return_data = reader.bytes();
                break;
            case 10:
                message.orig_hash = reader.bytes();
                break;
            case 11:
                message.orig_index = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("amount"))
            throw $util.ProtocolError("missing required 'amount'", { instance: message });
        return message;
    };

    TxOutput.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    TxOutput.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address != null && message.hasOwnProperty("address"))
            if (!$util.isString(message.address))
                return "address: string expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
            return "amount: integer|Long expected";
        if (message.script_type != null && message.hasOwnProperty("script_type"))
            switch (message.script_type) {
            default:
                return "script_type: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
                break;
            }
        if (message.multisig != null && message.hasOwnProperty("multisig")) {
            var error = $root.MultisigRedeemScriptType.verify(message.multisig);
            if (error)
                return "multisig." + error;
        }
        if (message.op_return_data != null && message.hasOwnProperty("op_return_data"))
            if (!(message.op_return_data && typeof message.op_return_data.length === "number" || $util.isString(message.op_return_data)))
                return "op_return_data: buffer expected";
        if (message.orig_hash != null && message.hasOwnProperty("orig_hash"))
            if (!(message.orig_hash && typeof message.orig_hash.length === "number" || $util.isString(message.orig_hash)))
                return "orig_hash: buffer expected";
        if (message.orig_index != null && message.hasOwnProperty("orig_index"))
            if (!$util.isInteger(message.orig_index))
                return "orig_index: integer expected";
        return null;
    };

    TxOutput.fromObject = function fromObject(object) {
        if (object instanceof $root.TxOutput)
            return object;
        var message = new $root.TxOutput();
        if (object.address != null)
            message.address = String(object.address);
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".TxOutput.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.amount != null)
            if ($util.Long)
                (message.amount = $util.Long.fromValue(object.amount)).unsigned = true;
            else if (typeof object.amount === "string")
                message.amount = parseInt(object.amount, 10);
            else if (typeof object.amount === "number")
                message.amount = object.amount;
            else if (typeof object.amount === "object")
                message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber(true);
        switch (object.script_type) {
        case "PAYTOADDRESS":
        case 0:
            message.script_type = 0;
            break;
        case "PAYTOSCRIPTHASH":
        case 1:
            message.script_type = 1;
            break;
        case "PAYTOMULTISIG":
        case 2:
            message.script_type = 2;
            break;
        case "PAYTOOPRETURN":
        case 3:
            message.script_type = 3;
            break;
        case "PAYTOWITNESS":
        case 4:
            message.script_type = 4;
            break;
        case "PAYTOP2SHWITNESS":
        case 5:
            message.script_type = 5;
            break;
        case "PAYTOTAPROOT":
        case 6:
            message.script_type = 6;
            break;
        }
        if (object.multisig != null) {
            if (typeof object.multisig !== "object")
                throw TypeError(".TxOutput.multisig: object expected");
            message.multisig = $root.MultisigRedeemScriptType.fromObject(object.multisig);
        }
        if (object.op_return_data != null)
            if (typeof object.op_return_data === "string")
                $util.base64.decode(object.op_return_data, message.op_return_data = $util.newBuffer($util.base64.length(object.op_return_data)), 0);
            else if (object.op_return_data.length)
                message.op_return_data = object.op_return_data;
        if (object.orig_hash != null)
            if (typeof object.orig_hash === "string")
                $util.base64.decode(object.orig_hash, message.orig_hash = $util.newBuffer($util.base64.length(object.orig_hash)), 0);
            else if (object.orig_hash.length)
                message.orig_hash = object.orig_hash;
        if (object.orig_index != null)
            message.orig_index = object.orig_index >>> 0;
        return message;
    };

    TxOutput.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            object.address = "";
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.amount = options.longs === String ? "0" : 0;
            object.script_type = options.enums === String ? "PAYTOADDRESS" : 0;
            object.multisig = null;
            if (options.bytes === String)
                object.op_return_data = "";
            else {
                object.op_return_data = [];
                if (options.bytes !== Array)
                    object.op_return_data = $util.newBuffer(object.op_return_data);
            }
            if (options.bytes === String)
                object.orig_hash = "";
            else {
                object.orig_hash = [];
                if (options.bytes !== Array)
                    object.orig_hash = $util.newBuffer(object.orig_hash);
            }
            object.orig_index = 0;
        }
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.amount != null && message.hasOwnProperty("amount"))
            if (typeof message.amount === "number")
                object.amount = options.longs === String ? String(message.amount) : message.amount;
            else
                object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber(true) : message.amount;
        if (message.script_type != null && message.hasOwnProperty("script_type"))
            object.script_type = options.enums === String ? $root.OutputScriptType[message.script_type] : message.script_type;
        if (message.multisig != null && message.hasOwnProperty("multisig"))
            object.multisig = $root.MultisigRedeemScriptType.toObject(message.multisig, options);
        if (message.op_return_data != null && message.hasOwnProperty("op_return_data"))
            object.op_return_data = options.bytes === String ? $util.base64.encode(message.op_return_data, 0, message.op_return_data.length) : options.bytes === Array ? Array.prototype.slice.call(message.op_return_data) : message.op_return_data;
        if (message.orig_hash != null && message.hasOwnProperty("orig_hash"))
            object.orig_hash = options.bytes === String ? $util.base64.encode(message.orig_hash, 0, message.orig_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.orig_hash) : message.orig_hash;
        if (message.orig_index != null && message.hasOwnProperty("orig_index"))
            object.orig_index = message.orig_index;
        return object;
    };

    TxOutput.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return TxOutput;
})();

$root.PrevTx = (function() {

    function PrevTx(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    PrevTx.prototype.version = 0;
    PrevTx.prototype.lock_time = 0;
    PrevTx.prototype.inputs_count = 0;
    PrevTx.prototype.outputs_count = 0;
    PrevTx.prototype.extra_data_len = 0;
    PrevTx.prototype.expiry = 0;
    PrevTx.prototype.version_group_id = 0;
    PrevTx.prototype.timestamp = 0;
    PrevTx.prototype.branch_id = 0;

    PrevTx.create = function create(properties) {
        return new PrevTx(properties);
    };

    PrevTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).uint32(message.version);
        writer.uint32(32).uint32(message.lock_time);
        writer.uint32(48).uint32(message.inputs_count);
        writer.uint32(56).uint32(message.outputs_count);
        if (message.extra_data_len != null && Object.hasOwnProperty.call(message, "extra_data_len"))
            writer.uint32(72).uint32(message.extra_data_len);
        if (message.expiry != null && Object.hasOwnProperty.call(message, "expiry"))
            writer.uint32(80).uint32(message.expiry);
        if (message.version_group_id != null && Object.hasOwnProperty.call(message, "version_group_id"))
            writer.uint32(96).uint32(message.version_group_id);
        if (message.timestamp != null && Object.hasOwnProperty.call(message, "timestamp"))
            writer.uint32(104).uint32(message.timestamp);
        if (message.branch_id != null && Object.hasOwnProperty.call(message, "branch_id"))
            writer.uint32(112).uint32(message.branch_id);
        return writer;
    };

    PrevTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    PrevTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.PrevTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.version = reader.uint32();
                break;
            case 4:
                message.lock_time = reader.uint32();
                break;
            case 6:
                message.inputs_count = reader.uint32();
                break;
            case 7:
                message.outputs_count = reader.uint32();
                break;
            case 9:
                message.extra_data_len = reader.uint32();
                break;
            case 10:
                message.expiry = reader.uint32();
                break;
            case 12:
                message.version_group_id = reader.uint32();
                break;
            case 13:
                message.timestamp = reader.uint32();
                break;
            case 14:
                message.branch_id = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("version"))
            throw $util.ProtocolError("missing required 'version'", { instance: message });
        if (!message.hasOwnProperty("lock_time"))
            throw $util.ProtocolError("missing required 'lock_time'", { instance: message });
        if (!message.hasOwnProperty("inputs_count"))
            throw $util.ProtocolError("missing required 'inputs_count'", { instance: message });
        if (!message.hasOwnProperty("outputs_count"))
            throw $util.ProtocolError("missing required 'outputs_count'", { instance: message });
        return message;
    };

    PrevTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    PrevTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isInteger(message.version))
            return "version: integer expected";
        if (!$util.isInteger(message.lock_time))
            return "lock_time: integer expected";
        if (!$util.isInteger(message.inputs_count))
            return "inputs_count: integer expected";
        if (!$util.isInteger(message.outputs_count))
            return "outputs_count: integer expected";
        if (message.extra_data_len != null && message.hasOwnProperty("extra_data_len"))
            if (!$util.isInteger(message.extra_data_len))
                return "extra_data_len: integer expected";
        if (message.expiry != null && message.hasOwnProperty("expiry"))
            if (!$util.isInteger(message.expiry))
                return "expiry: integer expected";
        if (message.version_group_id != null && message.hasOwnProperty("version_group_id"))
            if (!$util.isInteger(message.version_group_id))
                return "version_group_id: integer expected";
        if (message.timestamp != null && message.hasOwnProperty("timestamp"))
            if (!$util.isInteger(message.timestamp))
                return "timestamp: integer expected";
        if (message.branch_id != null && message.hasOwnProperty("branch_id"))
            if (!$util.isInteger(message.branch_id))
                return "branch_id: integer expected";
        return null;
    };

    PrevTx.fromObject = function fromObject(object) {
        if (object instanceof $root.PrevTx)
            return object;
        var message = new $root.PrevTx();
        if (object.version != null)
            message.version = object.version >>> 0;
        if (object.lock_time != null)
            message.lock_time = object.lock_time >>> 0;
        if (object.inputs_count != null)
            message.inputs_count = object.inputs_count >>> 0;
        if (object.outputs_count != null)
            message.outputs_count = object.outputs_count >>> 0;
        if (object.extra_data_len != null)
            message.extra_data_len = object.extra_data_len >>> 0;
        if (object.expiry != null)
            message.expiry = object.expiry >>> 0;
        if (object.version_group_id != null)
            message.version_group_id = object.version_group_id >>> 0;
        if (object.timestamp != null)
            message.timestamp = object.timestamp >>> 0;
        if (object.branch_id != null)
            message.branch_id = object.branch_id >>> 0;
        return message;
    };

    PrevTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.version = 0;
            object.lock_time = 0;
            object.inputs_count = 0;
            object.outputs_count = 0;
            object.extra_data_len = 0;
            object.expiry = 0;
            object.version_group_id = 0;
            object.timestamp = 0;
            object.branch_id = 0;
        }
        if (message.version != null && message.hasOwnProperty("version"))
            object.version = message.version;
        if (message.lock_time != null && message.hasOwnProperty("lock_time"))
            object.lock_time = message.lock_time;
        if (message.inputs_count != null && message.hasOwnProperty("inputs_count"))
            object.inputs_count = message.inputs_count;
        if (message.outputs_count != null && message.hasOwnProperty("outputs_count"))
            object.outputs_count = message.outputs_count;
        if (message.extra_data_len != null && message.hasOwnProperty("extra_data_len"))
            object.extra_data_len = message.extra_data_len;
        if (message.expiry != null && message.hasOwnProperty("expiry"))
            object.expiry = message.expiry;
        if (message.version_group_id != null && message.hasOwnProperty("version_group_id"))
            object.version_group_id = message.version_group_id;
        if (message.timestamp != null && message.hasOwnProperty("timestamp"))
            object.timestamp = message.timestamp;
        if (message.branch_id != null && message.hasOwnProperty("branch_id"))
            object.branch_id = message.branch_id;
        return object;
    };

    PrevTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return PrevTx;
})();

$root.PrevInput = (function() {

    function PrevInput(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    PrevInput.prototype.prev_hash = $util.newBuffer([]);
    PrevInput.prototype.prev_index = 0;
    PrevInput.prototype.script_sig = $util.newBuffer([]);
    PrevInput.prototype.sequence = 0;
    PrevInput.prototype.decred_tree = 0;

    PrevInput.create = function create(properties) {
        return new PrevInput(properties);
    };

    PrevInput.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(18).bytes(message.prev_hash);
        writer.uint32(24).uint32(message.prev_index);
        writer.uint32(34).bytes(message.script_sig);
        writer.uint32(40).uint32(message.sequence);
        if (message.decred_tree != null && Object.hasOwnProperty.call(message, "decred_tree"))
            writer.uint32(72).uint32(message.decred_tree);
        return writer;
    };

    PrevInput.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    PrevInput.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.PrevInput();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 2:
                message.prev_hash = reader.bytes();
                break;
            case 3:
                message.prev_index = reader.uint32();
                break;
            case 4:
                message.script_sig = reader.bytes();
                break;
            case 5:
                message.sequence = reader.uint32();
                break;
            case 9:
                message.decred_tree = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("prev_hash"))
            throw $util.ProtocolError("missing required 'prev_hash'", { instance: message });
        if (!message.hasOwnProperty("prev_index"))
            throw $util.ProtocolError("missing required 'prev_index'", { instance: message });
        if (!message.hasOwnProperty("script_sig"))
            throw $util.ProtocolError("missing required 'script_sig'", { instance: message });
        if (!message.hasOwnProperty("sequence"))
            throw $util.ProtocolError("missing required 'sequence'", { instance: message });
        return message;
    };

    PrevInput.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    PrevInput.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.prev_hash && typeof message.prev_hash.length === "number" || $util.isString(message.prev_hash)))
            return "prev_hash: buffer expected";
        if (!$util.isInteger(message.prev_index))
            return "prev_index: integer expected";
        if (!(message.script_sig && typeof message.script_sig.length === "number" || $util.isString(message.script_sig)))
            return "script_sig: buffer expected";
        if (!$util.isInteger(message.sequence))
            return "sequence: integer expected";
        if (message.decred_tree != null && message.hasOwnProperty("decred_tree"))
            if (!$util.isInteger(message.decred_tree))
                return "decred_tree: integer expected";
        return null;
    };

    PrevInput.fromObject = function fromObject(object) {
        if (object instanceof $root.PrevInput)
            return object;
        var message = new $root.PrevInput();
        if (object.prev_hash != null)
            if (typeof object.prev_hash === "string")
                $util.base64.decode(object.prev_hash, message.prev_hash = $util.newBuffer($util.base64.length(object.prev_hash)), 0);
            else if (object.prev_hash.length)
                message.prev_hash = object.prev_hash;
        if (object.prev_index != null)
            message.prev_index = object.prev_index >>> 0;
        if (object.script_sig != null)
            if (typeof object.script_sig === "string")
                $util.base64.decode(object.script_sig, message.script_sig = $util.newBuffer($util.base64.length(object.script_sig)), 0);
            else if (object.script_sig.length)
                message.script_sig = object.script_sig;
        if (object.sequence != null)
            message.sequence = object.sequence >>> 0;
        if (object.decred_tree != null)
            message.decred_tree = object.decred_tree >>> 0;
        return message;
    };

    PrevInput.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.prev_hash = "";
            else {
                object.prev_hash = [];
                if (options.bytes !== Array)
                    object.prev_hash = $util.newBuffer(object.prev_hash);
            }
            object.prev_index = 0;
            if (options.bytes === String)
                object.script_sig = "";
            else {
                object.script_sig = [];
                if (options.bytes !== Array)
                    object.script_sig = $util.newBuffer(object.script_sig);
            }
            object.sequence = 0;
            object.decred_tree = 0;
        }
        if (message.prev_hash != null && message.hasOwnProperty("prev_hash"))
            object.prev_hash = options.bytes === String ? $util.base64.encode(message.prev_hash, 0, message.prev_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.prev_hash) : message.prev_hash;
        if (message.prev_index != null && message.hasOwnProperty("prev_index"))
            object.prev_index = message.prev_index;
        if (message.script_sig != null && message.hasOwnProperty("script_sig"))
            object.script_sig = options.bytes === String ? $util.base64.encode(message.script_sig, 0, message.script_sig.length) : options.bytes === Array ? Array.prototype.slice.call(message.script_sig) : message.script_sig;
        if (message.sequence != null && message.hasOwnProperty("sequence"))
            object.sequence = message.sequence;
        if (message.decred_tree != null && message.hasOwnProperty("decred_tree"))
            object.decred_tree = message.decred_tree;
        return object;
    };

    PrevInput.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return PrevInput;
})();

$root.PrevOutput = (function() {

    function PrevOutput(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    PrevOutput.prototype.amount = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    PrevOutput.prototype.script_pubkey = $util.newBuffer([]);
    PrevOutput.prototype.decred_script_version = 0;

    PrevOutput.create = function create(properties) {
        return new PrevOutput(properties);
    };

    PrevOutput.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).uint64(message.amount);
        writer.uint32(18).bytes(message.script_pubkey);
        if (message.decred_script_version != null && Object.hasOwnProperty.call(message, "decred_script_version"))
            writer.uint32(24).uint32(message.decred_script_version);
        return writer;
    };

    PrevOutput.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    PrevOutput.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.PrevOutput();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.amount = reader.uint64();
                break;
            case 2:
                message.script_pubkey = reader.bytes();
                break;
            case 3:
                message.decred_script_version = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("amount"))
            throw $util.ProtocolError("missing required 'amount'", { instance: message });
        if (!message.hasOwnProperty("script_pubkey"))
            throw $util.ProtocolError("missing required 'script_pubkey'", { instance: message });
        return message;
    };

    PrevOutput.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    PrevOutput.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
            return "amount: integer|Long expected";
        if (!(message.script_pubkey && typeof message.script_pubkey.length === "number" || $util.isString(message.script_pubkey)))
            return "script_pubkey: buffer expected";
        if (message.decred_script_version != null && message.hasOwnProperty("decred_script_version"))
            if (!$util.isInteger(message.decred_script_version))
                return "decred_script_version: integer expected";
        return null;
    };

    PrevOutput.fromObject = function fromObject(object) {
        if (object instanceof $root.PrevOutput)
            return object;
        var message = new $root.PrevOutput();
        if (object.amount != null)
            if ($util.Long)
                (message.amount = $util.Long.fromValue(object.amount)).unsigned = true;
            else if (typeof object.amount === "string")
                message.amount = parseInt(object.amount, 10);
            else if (typeof object.amount === "number")
                message.amount = object.amount;
            else if (typeof object.amount === "object")
                message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber(true);
        if (object.script_pubkey != null)
            if (typeof object.script_pubkey === "string")
                $util.base64.decode(object.script_pubkey, message.script_pubkey = $util.newBuffer($util.base64.length(object.script_pubkey)), 0);
            else if (object.script_pubkey.length)
                message.script_pubkey = object.script_pubkey;
        if (object.decred_script_version != null)
            message.decred_script_version = object.decred_script_version >>> 0;
        return message;
    };

    PrevOutput.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.amount = options.longs === String ? "0" : 0;
            if (options.bytes === String)
                object.script_pubkey = "";
            else {
                object.script_pubkey = [];
                if (options.bytes !== Array)
                    object.script_pubkey = $util.newBuffer(object.script_pubkey);
            }
            object.decred_script_version = 0;
        }
        if (message.amount != null && message.hasOwnProperty("amount"))
            if (typeof message.amount === "number")
                object.amount = options.longs === String ? String(message.amount) : message.amount;
            else
                object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber(true) : message.amount;
        if (message.script_pubkey != null && message.hasOwnProperty("script_pubkey"))
            object.script_pubkey = options.bytes === String ? $util.base64.encode(message.script_pubkey, 0, message.script_pubkey.length) : options.bytes === Array ? Array.prototype.slice.call(message.script_pubkey) : message.script_pubkey;
        if (message.decred_script_version != null && message.hasOwnProperty("decred_script_version"))
            object.decred_script_version = message.decred_script_version;
        return object;
    };

    PrevOutput.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return PrevOutput;
})();

$root.TxAckInput = (function() {

    function TxAckInput(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    TxAckInput.prototype.tx = null;

    TxAckInput.create = function create(properties) {
        return new TxAckInput(properties);
    };

    TxAckInput.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        $root.TxAckInput.TxAckInputWrapper.encode(message.tx, writer.uint32(10).fork()).ldelim();
        return writer;
    };

    TxAckInput.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    TxAckInput.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TxAckInput();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.tx = $root.TxAckInput.TxAckInputWrapper.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("tx"))
            throw $util.ProtocolError("missing required 'tx'", { instance: message });
        return message;
    };

    TxAckInput.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    TxAckInput.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        {
            var error = $root.TxAckInput.TxAckInputWrapper.verify(message.tx);
            if (error)
                return "tx." + error;
        }
        return null;
    };

    TxAckInput.fromObject = function fromObject(object) {
        if (object instanceof $root.TxAckInput)
            return object;
        var message = new $root.TxAckInput();
        if (object.tx != null) {
            if (typeof object.tx !== "object")
                throw TypeError(".TxAckInput.tx: object expected");
            message.tx = $root.TxAckInput.TxAckInputWrapper.fromObject(object.tx);
        }
        return message;
    };

    TxAckInput.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.tx = null;
        if (message.tx != null && message.hasOwnProperty("tx"))
            object.tx = $root.TxAckInput.TxAckInputWrapper.toObject(message.tx, options);
        return object;
    };

    TxAckInput.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    TxAckInput.TxAckInputWrapper = (function() {

        function TxAckInputWrapper(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        TxAckInputWrapper.prototype.input = null;

        TxAckInputWrapper.create = function create(properties) {
            return new TxAckInputWrapper(properties);
        };

        TxAckInputWrapper.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            $root.TxInput.encode(message.input, writer.uint32(18).fork()).ldelim();
            return writer;
        };

        TxAckInputWrapper.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        TxAckInputWrapper.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TxAckInput.TxAckInputWrapper();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 2:
                    message.input = $root.TxInput.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("input"))
                throw $util.ProtocolError("missing required 'input'", { instance: message });
            return message;
        };

        TxAckInputWrapper.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        TxAckInputWrapper.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            {
                var error = $root.TxInput.verify(message.input);
                if (error)
                    return "input." + error;
            }
            return null;
        };

        TxAckInputWrapper.fromObject = function fromObject(object) {
            if (object instanceof $root.TxAckInput.TxAckInputWrapper)
                return object;
            var message = new $root.TxAckInput.TxAckInputWrapper();
            if (object.input != null) {
                if (typeof object.input !== "object")
                    throw TypeError(".TxAckInput.TxAckInputWrapper.input: object expected");
                message.input = $root.TxInput.fromObject(object.input);
            }
            return message;
        };

        TxAckInputWrapper.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.input = null;
            if (message.input != null && message.hasOwnProperty("input"))
                object.input = $root.TxInput.toObject(message.input, options);
            return object;
        };

        TxAckInputWrapper.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TxAckInputWrapper;
    })();

    return TxAckInput;
})();

$root.TxAckOutput = (function() {

    function TxAckOutput(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    TxAckOutput.prototype.tx = null;

    TxAckOutput.create = function create(properties) {
        return new TxAckOutput(properties);
    };

    TxAckOutput.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        $root.TxAckOutput.TxAckOutputWrapper.encode(message.tx, writer.uint32(10).fork()).ldelim();
        return writer;
    };

    TxAckOutput.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    TxAckOutput.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TxAckOutput();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.tx = $root.TxAckOutput.TxAckOutputWrapper.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("tx"))
            throw $util.ProtocolError("missing required 'tx'", { instance: message });
        return message;
    };

    TxAckOutput.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    TxAckOutput.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        {
            var error = $root.TxAckOutput.TxAckOutputWrapper.verify(message.tx);
            if (error)
                return "tx." + error;
        }
        return null;
    };

    TxAckOutput.fromObject = function fromObject(object) {
        if (object instanceof $root.TxAckOutput)
            return object;
        var message = new $root.TxAckOutput();
        if (object.tx != null) {
            if (typeof object.tx !== "object")
                throw TypeError(".TxAckOutput.tx: object expected");
            message.tx = $root.TxAckOutput.TxAckOutputWrapper.fromObject(object.tx);
        }
        return message;
    };

    TxAckOutput.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.tx = null;
        if (message.tx != null && message.hasOwnProperty("tx"))
            object.tx = $root.TxAckOutput.TxAckOutputWrapper.toObject(message.tx, options);
        return object;
    };

    TxAckOutput.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    TxAckOutput.TxAckOutputWrapper = (function() {

        function TxAckOutputWrapper(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        TxAckOutputWrapper.prototype.output = null;

        TxAckOutputWrapper.create = function create(properties) {
            return new TxAckOutputWrapper(properties);
        };

        TxAckOutputWrapper.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            $root.TxOutput.encode(message.output, writer.uint32(42).fork()).ldelim();
            return writer;
        };

        TxAckOutputWrapper.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        TxAckOutputWrapper.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TxAckOutput.TxAckOutputWrapper();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 5:
                    message.output = $root.TxOutput.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("output"))
                throw $util.ProtocolError("missing required 'output'", { instance: message });
            return message;
        };

        TxAckOutputWrapper.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        TxAckOutputWrapper.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            {
                var error = $root.TxOutput.verify(message.output);
                if (error)
                    return "output." + error;
            }
            return null;
        };

        TxAckOutputWrapper.fromObject = function fromObject(object) {
            if (object instanceof $root.TxAckOutput.TxAckOutputWrapper)
                return object;
            var message = new $root.TxAckOutput.TxAckOutputWrapper();
            if (object.output != null) {
                if (typeof object.output !== "object")
                    throw TypeError(".TxAckOutput.TxAckOutputWrapper.output: object expected");
                message.output = $root.TxOutput.fromObject(object.output);
            }
            return message;
        };

        TxAckOutputWrapper.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.output = null;
            if (message.output != null && message.hasOwnProperty("output"))
                object.output = $root.TxOutput.toObject(message.output, options);
            return object;
        };

        TxAckOutputWrapper.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TxAckOutputWrapper;
    })();

    return TxAckOutput;
})();

$root.TxAckPrevMeta = (function() {

    function TxAckPrevMeta(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    TxAckPrevMeta.prototype.tx = null;

    TxAckPrevMeta.create = function create(properties) {
        return new TxAckPrevMeta(properties);
    };

    TxAckPrevMeta.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        $root.PrevTx.encode(message.tx, writer.uint32(10).fork()).ldelim();
        return writer;
    };

    TxAckPrevMeta.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    TxAckPrevMeta.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TxAckPrevMeta();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.tx = $root.PrevTx.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("tx"))
            throw $util.ProtocolError("missing required 'tx'", { instance: message });
        return message;
    };

    TxAckPrevMeta.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    TxAckPrevMeta.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        {
            var error = $root.PrevTx.verify(message.tx);
            if (error)
                return "tx." + error;
        }
        return null;
    };

    TxAckPrevMeta.fromObject = function fromObject(object) {
        if (object instanceof $root.TxAckPrevMeta)
            return object;
        var message = new $root.TxAckPrevMeta();
        if (object.tx != null) {
            if (typeof object.tx !== "object")
                throw TypeError(".TxAckPrevMeta.tx: object expected");
            message.tx = $root.PrevTx.fromObject(object.tx);
        }
        return message;
    };

    TxAckPrevMeta.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.tx = null;
        if (message.tx != null && message.hasOwnProperty("tx"))
            object.tx = $root.PrevTx.toObject(message.tx, options);
        return object;
    };

    TxAckPrevMeta.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return TxAckPrevMeta;
})();

$root.TxAckPrevInput = (function() {

    function TxAckPrevInput(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    TxAckPrevInput.prototype.tx = null;

    TxAckPrevInput.create = function create(properties) {
        return new TxAckPrevInput(properties);
    };

    TxAckPrevInput.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        $root.TxAckPrevInput.TxAckPrevInputWrapper.encode(message.tx, writer.uint32(10).fork()).ldelim();
        return writer;
    };

    TxAckPrevInput.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    TxAckPrevInput.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TxAckPrevInput();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.tx = $root.TxAckPrevInput.TxAckPrevInputWrapper.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("tx"))
            throw $util.ProtocolError("missing required 'tx'", { instance: message });
        return message;
    };

    TxAckPrevInput.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    TxAckPrevInput.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        {
            var error = $root.TxAckPrevInput.TxAckPrevInputWrapper.verify(message.tx);
            if (error)
                return "tx." + error;
        }
        return null;
    };

    TxAckPrevInput.fromObject = function fromObject(object) {
        if (object instanceof $root.TxAckPrevInput)
            return object;
        var message = new $root.TxAckPrevInput();
        if (object.tx != null) {
            if (typeof object.tx !== "object")
                throw TypeError(".TxAckPrevInput.tx: object expected");
            message.tx = $root.TxAckPrevInput.TxAckPrevInputWrapper.fromObject(object.tx);
        }
        return message;
    };

    TxAckPrevInput.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.tx = null;
        if (message.tx != null && message.hasOwnProperty("tx"))
            object.tx = $root.TxAckPrevInput.TxAckPrevInputWrapper.toObject(message.tx, options);
        return object;
    };

    TxAckPrevInput.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    TxAckPrevInput.TxAckPrevInputWrapper = (function() {

        function TxAckPrevInputWrapper(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        TxAckPrevInputWrapper.prototype.input = null;

        TxAckPrevInputWrapper.create = function create(properties) {
            return new TxAckPrevInputWrapper(properties);
        };

        TxAckPrevInputWrapper.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            $root.PrevInput.encode(message.input, writer.uint32(18).fork()).ldelim();
            return writer;
        };

        TxAckPrevInputWrapper.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        TxAckPrevInputWrapper.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TxAckPrevInput.TxAckPrevInputWrapper();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 2:
                    message.input = $root.PrevInput.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("input"))
                throw $util.ProtocolError("missing required 'input'", { instance: message });
            return message;
        };

        TxAckPrevInputWrapper.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        TxAckPrevInputWrapper.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            {
                var error = $root.PrevInput.verify(message.input);
                if (error)
                    return "input." + error;
            }
            return null;
        };

        TxAckPrevInputWrapper.fromObject = function fromObject(object) {
            if (object instanceof $root.TxAckPrevInput.TxAckPrevInputWrapper)
                return object;
            var message = new $root.TxAckPrevInput.TxAckPrevInputWrapper();
            if (object.input != null) {
                if (typeof object.input !== "object")
                    throw TypeError(".TxAckPrevInput.TxAckPrevInputWrapper.input: object expected");
                message.input = $root.PrevInput.fromObject(object.input);
            }
            return message;
        };

        TxAckPrevInputWrapper.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.input = null;
            if (message.input != null && message.hasOwnProperty("input"))
                object.input = $root.PrevInput.toObject(message.input, options);
            return object;
        };

        TxAckPrevInputWrapper.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TxAckPrevInputWrapper;
    })();

    return TxAckPrevInput;
})();

$root.TxAckPrevOutput = (function() {

    function TxAckPrevOutput(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    TxAckPrevOutput.prototype.tx = null;

    TxAckPrevOutput.create = function create(properties) {
        return new TxAckPrevOutput(properties);
    };

    TxAckPrevOutput.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        $root.TxAckPrevOutput.TxAckPrevOutputWrapper.encode(message.tx, writer.uint32(10).fork()).ldelim();
        return writer;
    };

    TxAckPrevOutput.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    TxAckPrevOutput.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TxAckPrevOutput();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.tx = $root.TxAckPrevOutput.TxAckPrevOutputWrapper.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("tx"))
            throw $util.ProtocolError("missing required 'tx'", { instance: message });
        return message;
    };

    TxAckPrevOutput.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    TxAckPrevOutput.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        {
            var error = $root.TxAckPrevOutput.TxAckPrevOutputWrapper.verify(message.tx);
            if (error)
                return "tx." + error;
        }
        return null;
    };

    TxAckPrevOutput.fromObject = function fromObject(object) {
        if (object instanceof $root.TxAckPrevOutput)
            return object;
        var message = new $root.TxAckPrevOutput();
        if (object.tx != null) {
            if (typeof object.tx !== "object")
                throw TypeError(".TxAckPrevOutput.tx: object expected");
            message.tx = $root.TxAckPrevOutput.TxAckPrevOutputWrapper.fromObject(object.tx);
        }
        return message;
    };

    TxAckPrevOutput.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.tx = null;
        if (message.tx != null && message.hasOwnProperty("tx"))
            object.tx = $root.TxAckPrevOutput.TxAckPrevOutputWrapper.toObject(message.tx, options);
        return object;
    };

    TxAckPrevOutput.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    TxAckPrevOutput.TxAckPrevOutputWrapper = (function() {

        function TxAckPrevOutputWrapper(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        TxAckPrevOutputWrapper.prototype.output = null;

        TxAckPrevOutputWrapper.create = function create(properties) {
            return new TxAckPrevOutputWrapper(properties);
        };

        TxAckPrevOutputWrapper.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            $root.PrevOutput.encode(message.output, writer.uint32(26).fork()).ldelim();
            return writer;
        };

        TxAckPrevOutputWrapper.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        TxAckPrevOutputWrapper.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TxAckPrevOutput.TxAckPrevOutputWrapper();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 3:
                    message.output = $root.PrevOutput.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("output"))
                throw $util.ProtocolError("missing required 'output'", { instance: message });
            return message;
        };

        TxAckPrevOutputWrapper.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        TxAckPrevOutputWrapper.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            {
                var error = $root.PrevOutput.verify(message.output);
                if (error)
                    return "output." + error;
            }
            return null;
        };

        TxAckPrevOutputWrapper.fromObject = function fromObject(object) {
            if (object instanceof $root.TxAckPrevOutput.TxAckPrevOutputWrapper)
                return object;
            var message = new $root.TxAckPrevOutput.TxAckPrevOutputWrapper();
            if (object.output != null) {
                if (typeof object.output !== "object")
                    throw TypeError(".TxAckPrevOutput.TxAckPrevOutputWrapper.output: object expected");
                message.output = $root.PrevOutput.fromObject(object.output);
            }
            return message;
        };

        TxAckPrevOutputWrapper.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.output = null;
            if (message.output != null && message.hasOwnProperty("output"))
                object.output = $root.PrevOutput.toObject(message.output, options);
            return object;
        };

        TxAckPrevOutputWrapper.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TxAckPrevOutputWrapper;
    })();

    return TxAckPrevOutput;
})();

$root.TxAckPrevExtraData = (function() {

    function TxAckPrevExtraData(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    TxAckPrevExtraData.prototype.tx = null;

    TxAckPrevExtraData.create = function create(properties) {
        return new TxAckPrevExtraData(properties);
    };

    TxAckPrevExtraData.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        $root.TxAckPrevExtraData.TxAckPrevExtraDataWrapper.encode(message.tx, writer.uint32(10).fork()).ldelim();
        return writer;
    };

    TxAckPrevExtraData.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    TxAckPrevExtraData.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TxAckPrevExtraData();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.tx = $root.TxAckPrevExtraData.TxAckPrevExtraDataWrapper.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("tx"))
            throw $util.ProtocolError("missing required 'tx'", { instance: message });
        return message;
    };

    TxAckPrevExtraData.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    TxAckPrevExtraData.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        {
            var error = $root.TxAckPrevExtraData.TxAckPrevExtraDataWrapper.verify(message.tx);
            if (error)
                return "tx." + error;
        }
        return null;
    };

    TxAckPrevExtraData.fromObject = function fromObject(object) {
        if (object instanceof $root.TxAckPrevExtraData)
            return object;
        var message = new $root.TxAckPrevExtraData();
        if (object.tx != null) {
            if (typeof object.tx !== "object")
                throw TypeError(".TxAckPrevExtraData.tx: object expected");
            message.tx = $root.TxAckPrevExtraData.TxAckPrevExtraDataWrapper.fromObject(object.tx);
        }
        return message;
    };

    TxAckPrevExtraData.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.tx = null;
        if (message.tx != null && message.hasOwnProperty("tx"))
            object.tx = $root.TxAckPrevExtraData.TxAckPrevExtraDataWrapper.toObject(message.tx, options);
        return object;
    };

    TxAckPrevExtraData.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    TxAckPrevExtraData.TxAckPrevExtraDataWrapper = (function() {

        function TxAckPrevExtraDataWrapper(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        TxAckPrevExtraDataWrapper.prototype.extra_data_chunk = $util.newBuffer([]);

        TxAckPrevExtraDataWrapper.create = function create(properties) {
            return new TxAckPrevExtraDataWrapper(properties);
        };

        TxAckPrevExtraDataWrapper.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(66).bytes(message.extra_data_chunk);
            return writer;
        };

        TxAckPrevExtraDataWrapper.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        TxAckPrevExtraDataWrapper.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TxAckPrevExtraData.TxAckPrevExtraDataWrapper();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 8:
                    message.extra_data_chunk = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("extra_data_chunk"))
                throw $util.ProtocolError("missing required 'extra_data_chunk'", { instance: message });
            return message;
        };

        TxAckPrevExtraDataWrapper.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        TxAckPrevExtraDataWrapper.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!(message.extra_data_chunk && typeof message.extra_data_chunk.length === "number" || $util.isString(message.extra_data_chunk)))
                return "extra_data_chunk: buffer expected";
            return null;
        };

        TxAckPrevExtraDataWrapper.fromObject = function fromObject(object) {
            if (object instanceof $root.TxAckPrevExtraData.TxAckPrevExtraDataWrapper)
                return object;
            var message = new $root.TxAckPrevExtraData.TxAckPrevExtraDataWrapper();
            if (object.extra_data_chunk != null)
                if (typeof object.extra_data_chunk === "string")
                    $util.base64.decode(object.extra_data_chunk, message.extra_data_chunk = $util.newBuffer($util.base64.length(object.extra_data_chunk)), 0);
                else if (object.extra_data_chunk.length)
                    message.extra_data_chunk = object.extra_data_chunk;
            return message;
        };

        TxAckPrevExtraDataWrapper.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                if (options.bytes === String)
                    object.extra_data_chunk = "";
                else {
                    object.extra_data_chunk = [];
                    if (options.bytes !== Array)
                        object.extra_data_chunk = $util.newBuffer(object.extra_data_chunk);
                }
            if (message.extra_data_chunk != null && message.hasOwnProperty("extra_data_chunk"))
                object.extra_data_chunk = options.bytes === String ? $util.base64.encode(message.extra_data_chunk, 0, message.extra_data_chunk.length) : options.bytes === Array ? Array.prototype.slice.call(message.extra_data_chunk) : message.extra_data_chunk;
            return object;
        };

        TxAckPrevExtraDataWrapper.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TxAckPrevExtraDataWrapper;
    })();

    return TxAckPrevExtraData;
})();

$root.GetOwnershipProof = (function() {

    function GetOwnershipProof(properties) {
        this.address_n = [];
        this.ownership_ids = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    GetOwnershipProof.prototype.address_n = $util.emptyArray;
    GetOwnershipProof.prototype.coin_name = "Bitcoin";
    GetOwnershipProof.prototype.script_type = 3;
    GetOwnershipProof.prototype.multisig = null;
    GetOwnershipProof.prototype.user_confirmation = false;
    GetOwnershipProof.prototype.ownership_ids = $util.emptyArray;
    GetOwnershipProof.prototype.commitment_data = $util.newBuffer([]);

    GetOwnershipProof.create = function create(properties) {
        return new GetOwnershipProof(properties);
    };

    GetOwnershipProof.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.coin_name != null && Object.hasOwnProperty.call(message, "coin_name"))
            writer.uint32(18).string(message.coin_name);
        if (message.script_type != null && Object.hasOwnProperty.call(message, "script_type"))
            writer.uint32(24).int32(message.script_type);
        if (message.multisig != null && Object.hasOwnProperty.call(message, "multisig"))
            $root.MultisigRedeemScriptType.encode(message.multisig, writer.uint32(34).fork()).ldelim();
        if (message.user_confirmation != null && Object.hasOwnProperty.call(message, "user_confirmation"))
            writer.uint32(40).bool(message.user_confirmation);
        if (message.ownership_ids != null && message.ownership_ids.length)
            for (var i = 0; i < message.ownership_ids.length; ++i)
                writer.uint32(50).bytes(message.ownership_ids[i]);
        if (message.commitment_data != null && Object.hasOwnProperty.call(message, "commitment_data"))
            writer.uint32(58).bytes(message.commitment_data);
        return writer;
    };

    GetOwnershipProof.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    GetOwnershipProof.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.GetOwnershipProof();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.coin_name = reader.string();
                break;
            case 3:
                message.script_type = reader.int32();
                break;
            case 4:
                message.multisig = $root.MultisigRedeemScriptType.decode(reader, reader.uint32());
                break;
            case 5:
                message.user_confirmation = reader.bool();
                break;
            case 6:
                if (!(message.ownership_ids && message.ownership_ids.length))
                    message.ownership_ids = [];
                message.ownership_ids.push(reader.bytes());
                break;
            case 7:
                message.commitment_data = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    GetOwnershipProof.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    GetOwnershipProof.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.coin_name != null && message.hasOwnProperty("coin_name"))
            if (!$util.isString(message.coin_name))
                return "coin_name: string expected";
        if (message.script_type != null && message.hasOwnProperty("script_type"))
            switch (message.script_type) {
            default:
                return "script_type: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
                break;
            }
        if (message.multisig != null && message.hasOwnProperty("multisig")) {
            var error = $root.MultisigRedeemScriptType.verify(message.multisig);
            if (error)
                return "multisig." + error;
        }
        if (message.user_confirmation != null && message.hasOwnProperty("user_confirmation"))
            if (typeof message.user_confirmation !== "boolean")
                return "user_confirmation: boolean expected";
        if (message.ownership_ids != null && message.hasOwnProperty("ownership_ids")) {
            if (!Array.isArray(message.ownership_ids))
                return "ownership_ids: array expected";
            for (var i = 0; i < message.ownership_ids.length; ++i)
                if (!(message.ownership_ids[i] && typeof message.ownership_ids[i].length === "number" || $util.isString(message.ownership_ids[i])))
                    return "ownership_ids: buffer[] expected";
        }
        if (message.commitment_data != null && message.hasOwnProperty("commitment_data"))
            if (!(message.commitment_data && typeof message.commitment_data.length === "number" || $util.isString(message.commitment_data)))
                return "commitment_data: buffer expected";
        return null;
    };

    GetOwnershipProof.fromObject = function fromObject(object) {
        if (object instanceof $root.GetOwnershipProof)
            return object;
        var message = new $root.GetOwnershipProof();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".GetOwnershipProof.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.coin_name != null)
            message.coin_name = String(object.coin_name);
        switch (object.script_type) {
        case "SPENDADDRESS":
        case 0:
            message.script_type = 0;
            break;
        case "SPENDMULTISIG":
        case 1:
            message.script_type = 1;
            break;
        case "EXTERNAL":
        case 2:
            message.script_type = 2;
            break;
        case "SPENDWITNESS":
        case 3:
            message.script_type = 3;
            break;
        case "SPENDP2SHWITNESS":
        case 4:
            message.script_type = 4;
            break;
        case "SPENDTAPROOT":
        case 5:
            message.script_type = 5;
            break;
        }
        if (object.multisig != null) {
            if (typeof object.multisig !== "object")
                throw TypeError(".GetOwnershipProof.multisig: object expected");
            message.multisig = $root.MultisigRedeemScriptType.fromObject(object.multisig);
        }
        if (object.user_confirmation != null)
            message.user_confirmation = Boolean(object.user_confirmation);
        if (object.ownership_ids) {
            if (!Array.isArray(object.ownership_ids))
                throw TypeError(".GetOwnershipProof.ownership_ids: array expected");
            message.ownership_ids = [];
            for (var i = 0; i < object.ownership_ids.length; ++i)
                if (typeof object.ownership_ids[i] === "string")
                    $util.base64.decode(object.ownership_ids[i], message.ownership_ids[i] = $util.newBuffer($util.base64.length(object.ownership_ids[i])), 0);
                else if (object.ownership_ids[i].length)
                    message.ownership_ids[i] = object.ownership_ids[i];
        }
        if (object.commitment_data != null)
            if (typeof object.commitment_data === "string")
                $util.base64.decode(object.commitment_data, message.commitment_data = $util.newBuffer($util.base64.length(object.commitment_data)), 0);
            else if (object.commitment_data.length)
                message.commitment_data = object.commitment_data;
        return message;
    };

    GetOwnershipProof.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults) {
            object.address_n = [];
            object.ownership_ids = [];
        }
        if (options.defaults) {
            object.coin_name = "Bitcoin";
            object.script_type = options.enums === String ? "SPENDWITNESS" : 3;
            object.multisig = null;
            object.user_confirmation = false;
            if (options.bytes === String)
                object.commitment_data = "";
            else {
                object.commitment_data = [];
                if (options.bytes !== Array)
                    object.commitment_data = $util.newBuffer(object.commitment_data);
            }
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.coin_name != null && message.hasOwnProperty("coin_name"))
            object.coin_name = message.coin_name;
        if (message.script_type != null && message.hasOwnProperty("script_type"))
            object.script_type = options.enums === String ? $root.InputScriptType[message.script_type] : message.script_type;
        if (message.multisig != null && message.hasOwnProperty("multisig"))
            object.multisig = $root.MultisigRedeemScriptType.toObject(message.multisig, options);
        if (message.user_confirmation != null && message.hasOwnProperty("user_confirmation"))
            object.user_confirmation = message.user_confirmation;
        if (message.ownership_ids && message.ownership_ids.length) {
            object.ownership_ids = [];
            for (var j = 0; j < message.ownership_ids.length; ++j)
                object.ownership_ids[j] = options.bytes === String ? $util.base64.encode(message.ownership_ids[j], 0, message.ownership_ids[j].length) : options.bytes === Array ? Array.prototype.slice.call(message.ownership_ids[j]) : message.ownership_ids[j];
        }
        if (message.commitment_data != null && message.hasOwnProperty("commitment_data"))
            object.commitment_data = options.bytes === String ? $util.base64.encode(message.commitment_data, 0, message.commitment_data.length) : options.bytes === Array ? Array.prototype.slice.call(message.commitment_data) : message.commitment_data;
        return object;
    };

    GetOwnershipProof.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return GetOwnershipProof;
})();

$root.OwnershipProof = (function() {

    function OwnershipProof(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    OwnershipProof.prototype.ownership_proof = $util.newBuffer([]);
    OwnershipProof.prototype.signature = $util.newBuffer([]);

    OwnershipProof.create = function create(properties) {
        return new OwnershipProof(properties);
    };

    OwnershipProof.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.ownership_proof);
        writer.uint32(18).bytes(message.signature);
        return writer;
    };

    OwnershipProof.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    OwnershipProof.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.OwnershipProof();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.ownership_proof = reader.bytes();
                break;
            case 2:
                message.signature = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("ownership_proof"))
            throw $util.ProtocolError("missing required 'ownership_proof'", { instance: message });
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        return message;
    };

    OwnershipProof.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    OwnershipProof.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.ownership_proof && typeof message.ownership_proof.length === "number" || $util.isString(message.ownership_proof)))
            return "ownership_proof: buffer expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        return null;
    };

    OwnershipProof.fromObject = function fromObject(object) {
        if (object instanceof $root.OwnershipProof)
            return object;
        var message = new $root.OwnershipProof();
        if (object.ownership_proof != null)
            if (typeof object.ownership_proof === "string")
                $util.base64.decode(object.ownership_proof, message.ownership_proof = $util.newBuffer($util.base64.length(object.ownership_proof)), 0);
            else if (object.ownership_proof.length)
                message.ownership_proof = object.ownership_proof;
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        return message;
    };

    OwnershipProof.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.ownership_proof = "";
            else {
                object.ownership_proof = [];
                if (options.bytes !== Array)
                    object.ownership_proof = $util.newBuffer(object.ownership_proof);
            }
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
        }
        if (message.ownership_proof != null && message.hasOwnProperty("ownership_proof"))
            object.ownership_proof = options.bytes === String ? $util.base64.encode(message.ownership_proof, 0, message.ownership_proof.length) : options.bytes === Array ? Array.prototype.slice.call(message.ownership_proof) : message.ownership_proof;
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        return object;
    };

    OwnershipProof.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return OwnershipProof;
})();

$root.AuthorizeCoinJoin = (function() {

    function AuthorizeCoinJoin(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    AuthorizeCoinJoin.prototype.coordinator = "";
    AuthorizeCoinJoin.prototype.max_total_fee = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    AuthorizeCoinJoin.prototype.fee_per_anonymity = 0;
    AuthorizeCoinJoin.prototype.address_n = $util.emptyArray;
    AuthorizeCoinJoin.prototype.coin_name = "Bitcoin";
    AuthorizeCoinJoin.prototype.script_type = 0;
    AuthorizeCoinJoin.prototype.amount_unit = 0;

    AuthorizeCoinJoin.create = function create(properties) {
        return new AuthorizeCoinJoin(properties);
    };

    AuthorizeCoinJoin.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.coordinator);
        writer.uint32(16).uint64(message.max_total_fee);
        if (message.fee_per_anonymity != null && Object.hasOwnProperty.call(message, "fee_per_anonymity"))
            writer.uint32(24).uint32(message.fee_per_anonymity);
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(32).uint32(message.address_n[i]);
        if (message.coin_name != null && Object.hasOwnProperty.call(message, "coin_name"))
            writer.uint32(42).string(message.coin_name);
        if (message.script_type != null && Object.hasOwnProperty.call(message, "script_type"))
            writer.uint32(48).int32(message.script_type);
        if (message.amount_unit != null && Object.hasOwnProperty.call(message, "amount_unit"))
            writer.uint32(88).int32(message.amount_unit);
        return writer;
    };

    AuthorizeCoinJoin.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    AuthorizeCoinJoin.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.AuthorizeCoinJoin();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.coordinator = reader.string();
                break;
            case 2:
                message.max_total_fee = reader.uint64();
                break;
            case 3:
                message.fee_per_anonymity = reader.uint32();
                break;
            case 4:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 5:
                message.coin_name = reader.string();
                break;
            case 6:
                message.script_type = reader.int32();
                break;
            case 11:
                message.amount_unit = reader.int32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("coordinator"))
            throw $util.ProtocolError("missing required 'coordinator'", { instance: message });
        if (!message.hasOwnProperty("max_total_fee"))
            throw $util.ProtocolError("missing required 'max_total_fee'", { instance: message });
        return message;
    };

    AuthorizeCoinJoin.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    AuthorizeCoinJoin.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.coordinator))
            return "coordinator: string expected";
        if (!$util.isInteger(message.max_total_fee) && !(message.max_total_fee && $util.isInteger(message.max_total_fee.low) && $util.isInteger(message.max_total_fee.high)))
            return "max_total_fee: integer|Long expected";
        if (message.fee_per_anonymity != null && message.hasOwnProperty("fee_per_anonymity"))
            if (!$util.isInteger(message.fee_per_anonymity))
                return "fee_per_anonymity: integer expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.coin_name != null && message.hasOwnProperty("coin_name"))
            if (!$util.isString(message.coin_name))
                return "coin_name: string expected";
        if (message.script_type != null && message.hasOwnProperty("script_type"))
            switch (message.script_type) {
            default:
                return "script_type: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
                break;
            }
        if (message.amount_unit != null && message.hasOwnProperty("amount_unit"))
            switch (message.amount_unit) {
            default:
                return "amount_unit: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
                break;
            }
        return null;
    };

    AuthorizeCoinJoin.fromObject = function fromObject(object) {
        if (object instanceof $root.AuthorizeCoinJoin)
            return object;
        var message = new $root.AuthorizeCoinJoin();
        if (object.coordinator != null)
            message.coordinator = String(object.coordinator);
        if (object.max_total_fee != null)
            if ($util.Long)
                (message.max_total_fee = $util.Long.fromValue(object.max_total_fee)).unsigned = true;
            else if (typeof object.max_total_fee === "string")
                message.max_total_fee = parseInt(object.max_total_fee, 10);
            else if (typeof object.max_total_fee === "number")
                message.max_total_fee = object.max_total_fee;
            else if (typeof object.max_total_fee === "object")
                message.max_total_fee = new $util.LongBits(object.max_total_fee.low >>> 0, object.max_total_fee.high >>> 0).toNumber(true);
        if (object.fee_per_anonymity != null)
            message.fee_per_anonymity = object.fee_per_anonymity >>> 0;
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".AuthorizeCoinJoin.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.coin_name != null)
            message.coin_name = String(object.coin_name);
        switch (object.script_type) {
        case "SPENDADDRESS":
        case 0:
            message.script_type = 0;
            break;
        case "SPENDMULTISIG":
        case 1:
            message.script_type = 1;
            break;
        case "EXTERNAL":
        case 2:
            message.script_type = 2;
            break;
        case "SPENDWITNESS":
        case 3:
            message.script_type = 3;
            break;
        case "SPENDP2SHWITNESS":
        case 4:
            message.script_type = 4;
            break;
        case "SPENDTAPROOT":
        case 5:
            message.script_type = 5;
            break;
        }
        switch (object.amount_unit) {
        case "BITCOIN":
        case 0:
            message.amount_unit = 0;
            break;
        case "MILLIBITCOIN":
        case 1:
            message.amount_unit = 1;
            break;
        case "MICROBITCOIN":
        case 2:
            message.amount_unit = 2;
            break;
        case "SATOSHI":
        case 3:
            message.amount_unit = 3;
            break;
        }
        return message;
    };

    AuthorizeCoinJoin.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            object.coordinator = "";
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.max_total_fee = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.max_total_fee = options.longs === String ? "0" : 0;
            object.fee_per_anonymity = 0;
            object.coin_name = "Bitcoin";
            object.script_type = options.enums === String ? "SPENDADDRESS" : 0;
            object.amount_unit = options.enums === String ? "BITCOIN" : 0;
        }
        if (message.coordinator != null && message.hasOwnProperty("coordinator"))
            object.coordinator = message.coordinator;
        if (message.max_total_fee != null && message.hasOwnProperty("max_total_fee"))
            if (typeof message.max_total_fee === "number")
                object.max_total_fee = options.longs === String ? String(message.max_total_fee) : message.max_total_fee;
            else
                object.max_total_fee = options.longs === String ? $util.Long.prototype.toString.call(message.max_total_fee) : options.longs === Number ? new $util.LongBits(message.max_total_fee.low >>> 0, message.max_total_fee.high >>> 0).toNumber(true) : message.max_total_fee;
        if (message.fee_per_anonymity != null && message.hasOwnProperty("fee_per_anonymity"))
            object.fee_per_anonymity = message.fee_per_anonymity;
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.coin_name != null && message.hasOwnProperty("coin_name"))
            object.coin_name = message.coin_name;
        if (message.script_type != null && message.hasOwnProperty("script_type"))
            object.script_type = options.enums === String ? $root.InputScriptType[message.script_type] : message.script_type;
        if (message.amount_unit != null && message.hasOwnProperty("amount_unit"))
            object.amount_unit = options.enums === String ? $root.AmountUnit[message.amount_unit] : message.amount_unit;
        return object;
    };

    AuthorizeCoinJoin.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return AuthorizeCoinJoin;
})();

$root.GetPublicKeyMultiple = (function() {

    function GetPublicKeyMultiple(properties) {
        this.addresses = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    GetPublicKeyMultiple.prototype.addresses = $util.emptyArray;
    GetPublicKeyMultiple.prototype.ecdsa_curve_name = "";
    GetPublicKeyMultiple.prototype.show_display = false;
    GetPublicKeyMultiple.prototype.coin_name = "Bitcoin";
    GetPublicKeyMultiple.prototype.script_type = 0;
    GetPublicKeyMultiple.prototype.ignore_xpub_magic = false;

    GetPublicKeyMultiple.create = function create(properties) {
        return new GetPublicKeyMultiple(properties);
    };

    GetPublicKeyMultiple.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.addresses != null && message.addresses.length)
            for (var i = 0; i < message.addresses.length; ++i)
                $root.GetPublicKeyMultiple.BIP32Address.encode(message.addresses[i], writer.uint32(10).fork()).ldelim();
        if (message.ecdsa_curve_name != null && Object.hasOwnProperty.call(message, "ecdsa_curve_name"))
            writer.uint32(18).string(message.ecdsa_curve_name);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(24).bool(message.show_display);
        if (message.coin_name != null && Object.hasOwnProperty.call(message, "coin_name"))
            writer.uint32(34).string(message.coin_name);
        if (message.script_type != null && Object.hasOwnProperty.call(message, "script_type"))
            writer.uint32(40).int32(message.script_type);
        if (message.ignore_xpub_magic != null && Object.hasOwnProperty.call(message, "ignore_xpub_magic"))
            writer.uint32(48).bool(message.ignore_xpub_magic);
        return writer;
    };

    GetPublicKeyMultiple.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    GetPublicKeyMultiple.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.GetPublicKeyMultiple();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.addresses && message.addresses.length))
                    message.addresses = [];
                message.addresses.push($root.GetPublicKeyMultiple.BIP32Address.decode(reader, reader.uint32()));
                break;
            case 2:
                message.ecdsa_curve_name = reader.string();
                break;
            case 3:
                message.show_display = reader.bool();
                break;
            case 4:
                message.coin_name = reader.string();
                break;
            case 5:
                message.script_type = reader.int32();
                break;
            case 6:
                message.ignore_xpub_magic = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    GetPublicKeyMultiple.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    GetPublicKeyMultiple.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.addresses != null && message.hasOwnProperty("addresses")) {
            if (!Array.isArray(message.addresses))
                return "addresses: array expected";
            for (var i = 0; i < message.addresses.length; ++i) {
                var error = $root.GetPublicKeyMultiple.BIP32Address.verify(message.addresses[i]);
                if (error)
                    return "addresses." + error;
            }
        }
        if (message.ecdsa_curve_name != null && message.hasOwnProperty("ecdsa_curve_name"))
            if (!$util.isString(message.ecdsa_curve_name))
                return "ecdsa_curve_name: string expected";
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        if (message.coin_name != null && message.hasOwnProperty("coin_name"))
            if (!$util.isString(message.coin_name))
                return "coin_name: string expected";
        if (message.script_type != null && message.hasOwnProperty("script_type"))
            switch (message.script_type) {
            default:
                return "script_type: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
                break;
            }
        if (message.ignore_xpub_magic != null && message.hasOwnProperty("ignore_xpub_magic"))
            if (typeof message.ignore_xpub_magic !== "boolean")
                return "ignore_xpub_magic: boolean expected";
        return null;
    };

    GetPublicKeyMultiple.fromObject = function fromObject(object) {
        if (object instanceof $root.GetPublicKeyMultiple)
            return object;
        var message = new $root.GetPublicKeyMultiple();
        if (object.addresses) {
            if (!Array.isArray(object.addresses))
                throw TypeError(".GetPublicKeyMultiple.addresses: array expected");
            message.addresses = [];
            for (var i = 0; i < object.addresses.length; ++i) {
                if (typeof object.addresses[i] !== "object")
                    throw TypeError(".GetPublicKeyMultiple.addresses: object expected");
                message.addresses[i] = $root.GetPublicKeyMultiple.BIP32Address.fromObject(object.addresses[i]);
            }
        }
        if (object.ecdsa_curve_name != null)
            message.ecdsa_curve_name = String(object.ecdsa_curve_name);
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        if (object.coin_name != null)
            message.coin_name = String(object.coin_name);
        switch (object.script_type) {
        case "SPENDADDRESS":
        case 0:
            message.script_type = 0;
            break;
        case "SPENDMULTISIG":
        case 1:
            message.script_type = 1;
            break;
        case "EXTERNAL":
        case 2:
            message.script_type = 2;
            break;
        case "SPENDWITNESS":
        case 3:
            message.script_type = 3;
            break;
        case "SPENDP2SHWITNESS":
        case 4:
            message.script_type = 4;
            break;
        case "SPENDTAPROOT":
        case 5:
            message.script_type = 5;
            break;
        }
        if (object.ignore_xpub_magic != null)
            message.ignore_xpub_magic = Boolean(object.ignore_xpub_magic);
        return message;
    };

    GetPublicKeyMultiple.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.addresses = [];
        if (options.defaults) {
            object.ecdsa_curve_name = "";
            object.show_display = false;
            object.coin_name = "Bitcoin";
            object.script_type = options.enums === String ? "SPENDADDRESS" : 0;
            object.ignore_xpub_magic = false;
        }
        if (message.addresses && message.addresses.length) {
            object.addresses = [];
            for (var j = 0; j < message.addresses.length; ++j)
                object.addresses[j] = $root.GetPublicKeyMultiple.BIP32Address.toObject(message.addresses[j], options);
        }
        if (message.ecdsa_curve_name != null && message.hasOwnProperty("ecdsa_curve_name"))
            object.ecdsa_curve_name = message.ecdsa_curve_name;
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        if (message.coin_name != null && message.hasOwnProperty("coin_name"))
            object.coin_name = message.coin_name;
        if (message.script_type != null && message.hasOwnProperty("script_type"))
            object.script_type = options.enums === String ? $root.InputScriptType[message.script_type] : message.script_type;
        if (message.ignore_xpub_magic != null && message.hasOwnProperty("ignore_xpub_magic"))
            object.ignore_xpub_magic = message.ignore_xpub_magic;
        return object;
    };

    GetPublicKeyMultiple.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    GetPublicKeyMultiple.BIP32Address = (function() {

        function BIP32Address(properties) {
            this.address_n = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        BIP32Address.prototype.address_n = $util.emptyArray;

        BIP32Address.create = function create(properties) {
            return new BIP32Address(properties);
        };

        BIP32Address.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.address_n != null && message.address_n.length)
                for (var i = 0; i < message.address_n.length; ++i)
                    writer.uint32(8).uint32(message.address_n[i]);
            return writer;
        };

        BIP32Address.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        BIP32Address.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.GetPublicKeyMultiple.BIP32Address();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.address_n && message.address_n.length))
                        message.address_n = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.address_n.push(reader.uint32());
                    } else
                        message.address_n.push(reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        BIP32Address.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        BIP32Address.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.address_n != null && message.hasOwnProperty("address_n")) {
                if (!Array.isArray(message.address_n))
                    return "address_n: array expected";
                for (var i = 0; i < message.address_n.length; ++i)
                    if (!$util.isInteger(message.address_n[i]))
                        return "address_n: integer[] expected";
            }
            return null;
        };

        BIP32Address.fromObject = function fromObject(object) {
            if (object instanceof $root.GetPublicKeyMultiple.BIP32Address)
                return object;
            var message = new $root.GetPublicKeyMultiple.BIP32Address();
            if (object.address_n) {
                if (!Array.isArray(object.address_n))
                    throw TypeError(".GetPublicKeyMultiple.BIP32Address.address_n: array expected");
                message.address_n = [];
                for (var i = 0; i < object.address_n.length; ++i)
                    message.address_n[i] = object.address_n[i] >>> 0;
            }
            return message;
        };

        BIP32Address.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.address_n = [];
            if (message.address_n && message.address_n.length) {
                object.address_n = [];
                for (var j = 0; j < message.address_n.length; ++j)
                    object.address_n[j] = message.address_n[j];
            }
            return object;
        };

        BIP32Address.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return BIP32Address;
    })();

    return GetPublicKeyMultiple;
})();

$root.PublicKeyMultiple = (function() {

    function PublicKeyMultiple(properties) {
        this.xpubs = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    PublicKeyMultiple.prototype.xpubs = $util.emptyArray;

    PublicKeyMultiple.create = function create(properties) {
        return new PublicKeyMultiple(properties);
    };

    PublicKeyMultiple.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.xpubs != null && message.xpubs.length)
            for (var i = 0; i < message.xpubs.length; ++i)
                writer.uint32(10).string(message.xpubs[i]);
        return writer;
    };

    PublicKeyMultiple.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    PublicKeyMultiple.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.PublicKeyMultiple();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.xpubs && message.xpubs.length))
                    message.xpubs = [];
                message.xpubs.push(reader.string());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    PublicKeyMultiple.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    PublicKeyMultiple.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.xpubs != null && message.hasOwnProperty("xpubs")) {
            if (!Array.isArray(message.xpubs))
                return "xpubs: array expected";
            for (var i = 0; i < message.xpubs.length; ++i)
                if (!$util.isString(message.xpubs[i]))
                    return "xpubs: string[] expected";
        }
        return null;
    };

    PublicKeyMultiple.fromObject = function fromObject(object) {
        if (object instanceof $root.PublicKeyMultiple)
            return object;
        var message = new $root.PublicKeyMultiple();
        if (object.xpubs) {
            if (!Array.isArray(object.xpubs))
                throw TypeError(".PublicKeyMultiple.xpubs: array expected");
            message.xpubs = [];
            for (var i = 0; i < object.xpubs.length; ++i)
                message.xpubs[i] = String(object.xpubs[i]);
        }
        return message;
    };

    PublicKeyMultiple.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.xpubs = [];
        if (message.xpubs && message.xpubs.length) {
            object.xpubs = [];
            for (var j = 0; j < message.xpubs.length; ++j)
                object.xpubs[j] = message.xpubs[j];
        }
        return object;
    };

    PublicKeyMultiple.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return PublicKeyMultiple;
})();

$root.FirmwareErase = (function() {

    function FirmwareErase(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    FirmwareErase.prototype.length = 0;

    FirmwareErase.create = function create(properties) {
        return new FirmwareErase(properties);
    };

    FirmwareErase.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.length != null && Object.hasOwnProperty.call(message, "length"))
            writer.uint32(8).uint32(message.length);
        return writer;
    };

    FirmwareErase.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    FirmwareErase.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.FirmwareErase();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.length = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    FirmwareErase.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    FirmwareErase.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.length != null && message.hasOwnProperty("length"))
            if (!$util.isInteger(message.length))
                return "length: integer expected";
        return null;
    };

    FirmwareErase.fromObject = function fromObject(object) {
        if (object instanceof $root.FirmwareErase)
            return object;
        var message = new $root.FirmwareErase();
        if (object.length != null)
            message.length = object.length >>> 0;
        return message;
    };

    FirmwareErase.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.length = 0;
        if (message.length != null && message.hasOwnProperty("length"))
            object.length = message.length;
        return object;
    };

    FirmwareErase.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return FirmwareErase;
})();

$root.FirmwareRequest = (function() {

    function FirmwareRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    FirmwareRequest.prototype.offset = 0;
    FirmwareRequest.prototype.length = 0;

    FirmwareRequest.create = function create(properties) {
        return new FirmwareRequest(properties);
    };

    FirmwareRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.offset != null && Object.hasOwnProperty.call(message, "offset"))
            writer.uint32(8).uint32(message.offset);
        if (message.length != null && Object.hasOwnProperty.call(message, "length"))
            writer.uint32(16).uint32(message.length);
        return writer;
    };

    FirmwareRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    FirmwareRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.FirmwareRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.offset = reader.uint32();
                break;
            case 2:
                message.length = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    FirmwareRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    FirmwareRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.offset != null && message.hasOwnProperty("offset"))
            if (!$util.isInteger(message.offset))
                return "offset: integer expected";
        if (message.length != null && message.hasOwnProperty("length"))
            if (!$util.isInteger(message.length))
                return "length: integer expected";
        return null;
    };

    FirmwareRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.FirmwareRequest)
            return object;
        var message = new $root.FirmwareRequest();
        if (object.offset != null)
            message.offset = object.offset >>> 0;
        if (object.length != null)
            message.length = object.length >>> 0;
        return message;
    };

    FirmwareRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.offset = 0;
            object.length = 0;
        }
        if (message.offset != null && message.hasOwnProperty("offset"))
            object.offset = message.offset;
        if (message.length != null && message.hasOwnProperty("length"))
            object.length = message.length;
        return object;
    };

    FirmwareRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return FirmwareRequest;
})();

$root.FirmwareUpload = (function() {

    function FirmwareUpload(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    FirmwareUpload.prototype.payload = $util.newBuffer([]);
    FirmwareUpload.prototype.hash = $util.newBuffer([]);

    FirmwareUpload.create = function create(properties) {
        return new FirmwareUpload(properties);
    };

    FirmwareUpload.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.payload);
        if (message.hash != null && Object.hasOwnProperty.call(message, "hash"))
            writer.uint32(18).bytes(message.hash);
        return writer;
    };

    FirmwareUpload.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    FirmwareUpload.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.FirmwareUpload();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.payload = reader.bytes();
                break;
            case 2:
                message.hash = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("payload"))
            throw $util.ProtocolError("missing required 'payload'", { instance: message });
        return message;
    };

    FirmwareUpload.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    FirmwareUpload.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.payload && typeof message.payload.length === "number" || $util.isString(message.payload)))
            return "payload: buffer expected";
        if (message.hash != null && message.hasOwnProperty("hash"))
            if (!(message.hash && typeof message.hash.length === "number" || $util.isString(message.hash)))
                return "hash: buffer expected";
        return null;
    };

    FirmwareUpload.fromObject = function fromObject(object) {
        if (object instanceof $root.FirmwareUpload)
            return object;
        var message = new $root.FirmwareUpload();
        if (object.payload != null)
            if (typeof object.payload === "string")
                $util.base64.decode(object.payload, message.payload = $util.newBuffer($util.base64.length(object.payload)), 0);
            else if (object.payload.length)
                message.payload = object.payload;
        if (object.hash != null)
            if (typeof object.hash === "string")
                $util.base64.decode(object.hash, message.hash = $util.newBuffer($util.base64.length(object.hash)), 0);
            else if (object.hash.length)
                message.hash = object.hash;
        return message;
    };

    FirmwareUpload.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.payload = "";
            else {
                object.payload = [];
                if (options.bytes !== Array)
                    object.payload = $util.newBuffer(object.payload);
            }
            if (options.bytes === String)
                object.hash = "";
            else {
                object.hash = [];
                if (options.bytes !== Array)
                    object.hash = $util.newBuffer(object.hash);
            }
        }
        if (message.payload != null && message.hasOwnProperty("payload"))
            object.payload = options.bytes === String ? $util.base64.encode(message.payload, 0, message.payload.length) : options.bytes === Array ? Array.prototype.slice.call(message.payload) : message.payload;
        if (message.hash != null && message.hasOwnProperty("hash"))
            object.hash = options.bytes === String ? $util.base64.encode(message.hash, 0, message.hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.hash) : message.hash;
        return object;
    };

    FirmwareUpload.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return FirmwareUpload;
})();

$root.SelfTest = (function() {

    function SelfTest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    SelfTest.prototype.payload = $util.newBuffer([]);

    SelfTest.create = function create(properties) {
        return new SelfTest(properties);
    };

    SelfTest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.payload != null && Object.hasOwnProperty.call(message, "payload"))
            writer.uint32(10).bytes(message.payload);
        return writer;
    };

    SelfTest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    SelfTest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SelfTest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.payload = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    SelfTest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    SelfTest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.payload != null && message.hasOwnProperty("payload"))
            if (!(message.payload && typeof message.payload.length === "number" || $util.isString(message.payload)))
                return "payload: buffer expected";
        return null;
    };

    SelfTest.fromObject = function fromObject(object) {
        if (object instanceof $root.SelfTest)
            return object;
        var message = new $root.SelfTest();
        if (object.payload != null)
            if (typeof object.payload === "string")
                $util.base64.decode(object.payload, message.payload = $util.newBuffer($util.base64.length(object.payload)), 0);
            else if (object.payload.length)
                message.payload = object.payload;
        return message;
    };

    SelfTest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.payload = "";
            else {
                object.payload = [];
                if (options.bytes !== Array)
                    object.payload = $util.newBuffer(object.payload);
            }
        if (message.payload != null && message.hasOwnProperty("payload"))
            object.payload = options.bytes === String ? $util.base64.encode(message.payload, 0, message.payload.length) : options.bytes === Array ? Array.prototype.slice.call(message.payload) : message.payload;
        return object;
    };

    SelfTest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SelfTest;
})();

$root.FirmwareErase_ex = (function() {

    function FirmwareErase_ex(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    FirmwareErase_ex.prototype.length = 0;

    FirmwareErase_ex.create = function create(properties) {
        return new FirmwareErase_ex(properties);
    };

    FirmwareErase_ex.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.length != null && Object.hasOwnProperty.call(message, "length"))
            writer.uint32(8).uint32(message.length);
        return writer;
    };

    FirmwareErase_ex.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    FirmwareErase_ex.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.FirmwareErase_ex();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.length = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    FirmwareErase_ex.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    FirmwareErase_ex.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.length != null && message.hasOwnProperty("length"))
            if (!$util.isInteger(message.length))
                return "length: integer expected";
        return null;
    };

    FirmwareErase_ex.fromObject = function fromObject(object) {
        if (object instanceof $root.FirmwareErase_ex)
            return object;
        var message = new $root.FirmwareErase_ex();
        if (object.length != null)
            message.length = object.length >>> 0;
        return message;
    };

    FirmwareErase_ex.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.length = 0;
        if (message.length != null && message.hasOwnProperty("length"))
            object.length = message.length;
        return object;
    };

    FirmwareErase_ex.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return FirmwareErase_ex;
})();

$root.RebootType = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "Normal"] = 0;
    values[valuesById[1] = "Boardloader"] = 1;
    values[valuesById[2] = "BootLoader"] = 2;
    return values;
})();

$root.Reboot = (function() {

    function Reboot(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    Reboot.prototype.reboot_type = 0;

    Reboot.create = function create(properties) {
        return new Reboot(properties);
    };

    Reboot.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).int32(message.reboot_type);
        return writer;
    };

    Reboot.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    Reboot.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Reboot();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.reboot_type = reader.int32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("reboot_type"))
            throw $util.ProtocolError("missing required 'reboot_type'", { instance: message });
        return message;
    };

    Reboot.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    Reboot.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        switch (message.reboot_type) {
        default:
            return "reboot_type: enum value expected";
        case 0:
        case 1:
        case 2:
            break;
        }
        return null;
    };

    Reboot.fromObject = function fromObject(object) {
        if (object instanceof $root.Reboot)
            return object;
        var message = new $root.Reboot();
        switch (object.reboot_type) {
        case "Normal":
        case 0:
            message.reboot_type = 0;
            break;
        case "Boardloader":
        case 1:
            message.reboot_type = 1;
            break;
        case "BootLoader":
        case 2:
            message.reboot_type = 2;
            break;
        }
        return message;
    };

    Reboot.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.reboot_type = options.enums === String ? "Normal" : 0;
        if (message.reboot_type != null && message.hasOwnProperty("reboot_type"))
            object.reboot_type = options.enums === String ? $root.RebootType[message.reboot_type] : message.reboot_type;
        return object;
    };

    Reboot.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return Reboot;
})();

$root.FirmwareUpdateEmmc = (function() {

    function FirmwareUpdateEmmc(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    FirmwareUpdateEmmc.prototype.path = "";
    FirmwareUpdateEmmc.prototype.reboot_on_success = false;

    FirmwareUpdateEmmc.create = function create(properties) {
        return new FirmwareUpdateEmmc(properties);
    };

    FirmwareUpdateEmmc.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.path);
        if (message.reboot_on_success != null && Object.hasOwnProperty.call(message, "reboot_on_success"))
            writer.uint32(16).bool(message.reboot_on_success);
        return writer;
    };

    FirmwareUpdateEmmc.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    FirmwareUpdateEmmc.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.FirmwareUpdateEmmc();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.path = reader.string();
                break;
            case 2:
                message.reboot_on_success = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("path"))
            throw $util.ProtocolError("missing required 'path'", { instance: message });
        return message;
    };

    FirmwareUpdateEmmc.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    FirmwareUpdateEmmc.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.path))
            return "path: string expected";
        if (message.reboot_on_success != null && message.hasOwnProperty("reboot_on_success"))
            if (typeof message.reboot_on_success !== "boolean")
                return "reboot_on_success: boolean expected";
        return null;
    };

    FirmwareUpdateEmmc.fromObject = function fromObject(object) {
        if (object instanceof $root.FirmwareUpdateEmmc)
            return object;
        var message = new $root.FirmwareUpdateEmmc();
        if (object.path != null)
            message.path = String(object.path);
        if (object.reboot_on_success != null)
            message.reboot_on_success = Boolean(object.reboot_on_success);
        return message;
    };

    FirmwareUpdateEmmc.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.path = "";
            object.reboot_on_success = false;
        }
        if (message.path != null && message.hasOwnProperty("path"))
            object.path = message.path;
        if (message.reboot_on_success != null && message.hasOwnProperty("reboot_on_success"))
            object.reboot_on_success = message.reboot_on_success;
        return object;
    };

    FirmwareUpdateEmmc.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return FirmwareUpdateEmmc;
})();

$root.CardanoDerivationType = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "LEDGER"] = 0;
    values[valuesById[1] = "ICARUS"] = 1;
    values[valuesById[2] = "ICARUS_TREZOR"] = 2;
    return values;
})();

$root.CardanoAddressType = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "BASE"] = 0;
    values[valuesById[1] = "BASE_SCRIPT_KEY"] = 1;
    values[valuesById[2] = "BASE_KEY_SCRIPT"] = 2;
    values[valuesById[3] = "BASE_SCRIPT_SCRIPT"] = 3;
    values[valuesById[4] = "POINTER"] = 4;
    values[valuesById[5] = "POINTER_SCRIPT"] = 5;
    values[valuesById[6] = "ENTERPRISE"] = 6;
    values[valuesById[7] = "ENTERPRISE_SCRIPT"] = 7;
    values[valuesById[8] = "BYRON"] = 8;
    values[valuesById[14] = "REWARD"] = 14;
    values[valuesById[15] = "REWARD_SCRIPT"] = 15;
    return values;
})();

$root.CardanoNativeScriptType = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "PUB_KEY"] = 0;
    values[valuesById[1] = "ALL"] = 1;
    values[valuesById[2] = "ANY"] = 2;
    values[valuesById[3] = "N_OF_K"] = 3;
    values[valuesById[4] = "INVALID_BEFORE"] = 4;
    values[valuesById[5] = "INVALID_HEREAFTER"] = 5;
    return values;
})();

$root.CardanoNativeScriptHashDisplayFormat = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "HIDE"] = 0;
    values[valuesById[1] = "BECH32"] = 1;
    values[valuesById[2] = "POLICY_ID"] = 2;
    return values;
})();

$root.CardanoTxOutputSerializationFormat = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "ARRAY_LEGACY"] = 0;
    values[valuesById[1] = "MAP_BABBAGE"] = 1;
    return values;
})();

$root.CardanoCertificateType = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "STAKE_REGISTRATION"] = 0;
    values[valuesById[1] = "STAKE_DEREGISTRATION"] = 1;
    values[valuesById[2] = "STAKE_DELEGATION"] = 2;
    values[valuesById[3] = "STAKE_POOL_REGISTRATION"] = 3;
    return values;
})();

$root.CardanoPoolRelayType = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "SINGLE_HOST_IP"] = 0;
    values[valuesById[1] = "SINGLE_HOST_NAME"] = 1;
    values[valuesById[2] = "MULTIPLE_HOST_NAME"] = 2;
    return values;
})();

$root.CardanoTxAuxiliaryDataSupplementType = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "NONE"] = 0;
    values[valuesById[1] = "GOVERNANCE_REGISTRATION_SIGNATURE"] = 1;
    return values;
})();

$root.CardanoGovernanceRegistrationFormat = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "CIP15"] = 0;
    values[valuesById[1] = "CIP36"] = 1;
    return values;
})();

$root.CardanoTxSigningMode = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "ORDINARY_TRANSACTION"] = 0;
    values[valuesById[1] = "POOL_REGISTRATION_AS_OWNER"] = 1;
    values[valuesById[2] = "MULTISIG_TRANSACTION"] = 2;
    values[valuesById[3] = "PLUTUS_TRANSACTION"] = 3;
    return values;
})();

$root.CardanoTxWitnessType = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "BYRON_WITNESS"] = 0;
    values[valuesById[1] = "SHELLEY_WITNESS"] = 1;
    return values;
})();

$root.CardanoBlockchainPointerType = (function() {

    function CardanoBlockchainPointerType(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoBlockchainPointerType.prototype.block_index = 0;
    CardanoBlockchainPointerType.prototype.tx_index = 0;
    CardanoBlockchainPointerType.prototype.certificate_index = 0;

    CardanoBlockchainPointerType.create = function create(properties) {
        return new CardanoBlockchainPointerType(properties);
    };

    CardanoBlockchainPointerType.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).uint32(message.block_index);
        writer.uint32(16).uint32(message.tx_index);
        writer.uint32(24).uint32(message.certificate_index);
        return writer;
    };

    CardanoBlockchainPointerType.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoBlockchainPointerType.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoBlockchainPointerType();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.block_index = reader.uint32();
                break;
            case 2:
                message.tx_index = reader.uint32();
                break;
            case 3:
                message.certificate_index = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("block_index"))
            throw $util.ProtocolError("missing required 'block_index'", { instance: message });
        if (!message.hasOwnProperty("tx_index"))
            throw $util.ProtocolError("missing required 'tx_index'", { instance: message });
        if (!message.hasOwnProperty("certificate_index"))
            throw $util.ProtocolError("missing required 'certificate_index'", { instance: message });
        return message;
    };

    CardanoBlockchainPointerType.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoBlockchainPointerType.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isInteger(message.block_index))
            return "block_index: integer expected";
        if (!$util.isInteger(message.tx_index))
            return "tx_index: integer expected";
        if (!$util.isInteger(message.certificate_index))
            return "certificate_index: integer expected";
        return null;
    };

    CardanoBlockchainPointerType.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoBlockchainPointerType)
            return object;
        var message = new $root.CardanoBlockchainPointerType();
        if (object.block_index != null)
            message.block_index = object.block_index >>> 0;
        if (object.tx_index != null)
            message.tx_index = object.tx_index >>> 0;
        if (object.certificate_index != null)
            message.certificate_index = object.certificate_index >>> 0;
        return message;
    };

    CardanoBlockchainPointerType.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.block_index = 0;
            object.tx_index = 0;
            object.certificate_index = 0;
        }
        if (message.block_index != null && message.hasOwnProperty("block_index"))
            object.block_index = message.block_index;
        if (message.tx_index != null && message.hasOwnProperty("tx_index"))
            object.tx_index = message.tx_index;
        if (message.certificate_index != null && message.hasOwnProperty("certificate_index"))
            object.certificate_index = message.certificate_index;
        return object;
    };

    CardanoBlockchainPointerType.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoBlockchainPointerType;
})();

$root.CardanoNativeScript = (function() {

    function CardanoNativeScript(properties) {
        this.scripts = [];
        this.key_path = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoNativeScript.prototype.type = 0;
    CardanoNativeScript.prototype.scripts = $util.emptyArray;
    CardanoNativeScript.prototype.key_hash = $util.newBuffer([]);
    CardanoNativeScript.prototype.key_path = $util.emptyArray;
    CardanoNativeScript.prototype.required_signatures_count = 0;
    CardanoNativeScript.prototype.invalid_before = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    CardanoNativeScript.prototype.invalid_hereafter = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    CardanoNativeScript.create = function create(properties) {
        return new CardanoNativeScript(properties);
    };

    CardanoNativeScript.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).int32(message.type);
        if (message.scripts != null && message.scripts.length)
            for (var i = 0; i < message.scripts.length; ++i)
                $root.CardanoNativeScript.encode(message.scripts[i], writer.uint32(18).fork()).ldelim();
        if (message.key_hash != null && Object.hasOwnProperty.call(message, "key_hash"))
            writer.uint32(26).bytes(message.key_hash);
        if (message.key_path != null && message.key_path.length)
            for (var i = 0; i < message.key_path.length; ++i)
                writer.uint32(32).uint32(message.key_path[i]);
        if (message.required_signatures_count != null && Object.hasOwnProperty.call(message, "required_signatures_count"))
            writer.uint32(40).uint32(message.required_signatures_count);
        if (message.invalid_before != null && Object.hasOwnProperty.call(message, "invalid_before"))
            writer.uint32(48).uint64(message.invalid_before);
        if (message.invalid_hereafter != null && Object.hasOwnProperty.call(message, "invalid_hereafter"))
            writer.uint32(56).uint64(message.invalid_hereafter);
        return writer;
    };

    CardanoNativeScript.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoNativeScript.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoNativeScript();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.type = reader.int32();
                break;
            case 2:
                if (!(message.scripts && message.scripts.length))
                    message.scripts = [];
                message.scripts.push($root.CardanoNativeScript.decode(reader, reader.uint32()));
                break;
            case 3:
                message.key_hash = reader.bytes();
                break;
            case 4:
                if (!(message.key_path && message.key_path.length))
                    message.key_path = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.key_path.push(reader.uint32());
                } else
                    message.key_path.push(reader.uint32());
                break;
            case 5:
                message.required_signatures_count = reader.uint32();
                break;
            case 6:
                message.invalid_before = reader.uint64();
                break;
            case 7:
                message.invalid_hereafter = reader.uint64();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("type"))
            throw $util.ProtocolError("missing required 'type'", { instance: message });
        return message;
    };

    CardanoNativeScript.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoNativeScript.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        switch (message.type) {
        default:
            return "type: enum value expected";
        case 0:
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        }
        if (message.scripts != null && message.hasOwnProperty("scripts")) {
            if (!Array.isArray(message.scripts))
                return "scripts: array expected";
            for (var i = 0; i < message.scripts.length; ++i) {
                var error = $root.CardanoNativeScript.verify(message.scripts[i]);
                if (error)
                    return "scripts." + error;
            }
        }
        if (message.key_hash != null && message.hasOwnProperty("key_hash"))
            if (!(message.key_hash && typeof message.key_hash.length === "number" || $util.isString(message.key_hash)))
                return "key_hash: buffer expected";
        if (message.key_path != null && message.hasOwnProperty("key_path")) {
            if (!Array.isArray(message.key_path))
                return "key_path: array expected";
            for (var i = 0; i < message.key_path.length; ++i)
                if (!$util.isInteger(message.key_path[i]))
                    return "key_path: integer[] expected";
        }
        if (message.required_signatures_count != null && message.hasOwnProperty("required_signatures_count"))
            if (!$util.isInteger(message.required_signatures_count))
                return "required_signatures_count: integer expected";
        if (message.invalid_before != null && message.hasOwnProperty("invalid_before"))
            if (!$util.isInteger(message.invalid_before) && !(message.invalid_before && $util.isInteger(message.invalid_before.low) && $util.isInteger(message.invalid_before.high)))
                return "invalid_before: integer|Long expected";
        if (message.invalid_hereafter != null && message.hasOwnProperty("invalid_hereafter"))
            if (!$util.isInteger(message.invalid_hereafter) && !(message.invalid_hereafter && $util.isInteger(message.invalid_hereafter.low) && $util.isInteger(message.invalid_hereafter.high)))
                return "invalid_hereafter: integer|Long expected";
        return null;
    };

    CardanoNativeScript.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoNativeScript)
            return object;
        var message = new $root.CardanoNativeScript();
        switch (object.type) {
        case "PUB_KEY":
        case 0:
            message.type = 0;
            break;
        case "ALL":
        case 1:
            message.type = 1;
            break;
        case "ANY":
        case 2:
            message.type = 2;
            break;
        case "N_OF_K":
        case 3:
            message.type = 3;
            break;
        case "INVALID_BEFORE":
        case 4:
            message.type = 4;
            break;
        case "INVALID_HEREAFTER":
        case 5:
            message.type = 5;
            break;
        }
        if (object.scripts) {
            if (!Array.isArray(object.scripts))
                throw TypeError(".CardanoNativeScript.scripts: array expected");
            message.scripts = [];
            for (var i = 0; i < object.scripts.length; ++i) {
                if (typeof object.scripts[i] !== "object")
                    throw TypeError(".CardanoNativeScript.scripts: object expected");
                message.scripts[i] = $root.CardanoNativeScript.fromObject(object.scripts[i]);
            }
        }
        if (object.key_hash != null)
            if (typeof object.key_hash === "string")
                $util.base64.decode(object.key_hash, message.key_hash = $util.newBuffer($util.base64.length(object.key_hash)), 0);
            else if (object.key_hash.length)
                message.key_hash = object.key_hash;
        if (object.key_path) {
            if (!Array.isArray(object.key_path))
                throw TypeError(".CardanoNativeScript.key_path: array expected");
            message.key_path = [];
            for (var i = 0; i < object.key_path.length; ++i)
                message.key_path[i] = object.key_path[i] >>> 0;
        }
        if (object.required_signatures_count != null)
            message.required_signatures_count = object.required_signatures_count >>> 0;
        if (object.invalid_before != null)
            if ($util.Long)
                (message.invalid_before = $util.Long.fromValue(object.invalid_before)).unsigned = true;
            else if (typeof object.invalid_before === "string")
                message.invalid_before = parseInt(object.invalid_before, 10);
            else if (typeof object.invalid_before === "number")
                message.invalid_before = object.invalid_before;
            else if (typeof object.invalid_before === "object")
                message.invalid_before = new $util.LongBits(object.invalid_before.low >>> 0, object.invalid_before.high >>> 0).toNumber(true);
        if (object.invalid_hereafter != null)
            if ($util.Long)
                (message.invalid_hereafter = $util.Long.fromValue(object.invalid_hereafter)).unsigned = true;
            else if (typeof object.invalid_hereafter === "string")
                message.invalid_hereafter = parseInt(object.invalid_hereafter, 10);
            else if (typeof object.invalid_hereafter === "number")
                message.invalid_hereafter = object.invalid_hereafter;
            else if (typeof object.invalid_hereafter === "object")
                message.invalid_hereafter = new $util.LongBits(object.invalid_hereafter.low >>> 0, object.invalid_hereafter.high >>> 0).toNumber(true);
        return message;
    };

    CardanoNativeScript.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults) {
            object.scripts = [];
            object.key_path = [];
        }
        if (options.defaults) {
            object.type = options.enums === String ? "PUB_KEY" : 0;
            if (options.bytes === String)
                object.key_hash = "";
            else {
                object.key_hash = [];
                if (options.bytes !== Array)
                    object.key_hash = $util.newBuffer(object.key_hash);
            }
            object.required_signatures_count = 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.invalid_before = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.invalid_before = options.longs === String ? "0" : 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.invalid_hereafter = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.invalid_hereafter = options.longs === String ? "0" : 0;
        }
        if (message.type != null && message.hasOwnProperty("type"))
            object.type = options.enums === String ? $root.CardanoNativeScriptType[message.type] : message.type;
        if (message.scripts && message.scripts.length) {
            object.scripts = [];
            for (var j = 0; j < message.scripts.length; ++j)
                object.scripts[j] = $root.CardanoNativeScript.toObject(message.scripts[j], options);
        }
        if (message.key_hash != null && message.hasOwnProperty("key_hash"))
            object.key_hash = options.bytes === String ? $util.base64.encode(message.key_hash, 0, message.key_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.key_hash) : message.key_hash;
        if (message.key_path && message.key_path.length) {
            object.key_path = [];
            for (var j = 0; j < message.key_path.length; ++j)
                object.key_path[j] = message.key_path[j];
        }
        if (message.required_signatures_count != null && message.hasOwnProperty("required_signatures_count"))
            object.required_signatures_count = message.required_signatures_count;
        if (message.invalid_before != null && message.hasOwnProperty("invalid_before"))
            if (typeof message.invalid_before === "number")
                object.invalid_before = options.longs === String ? String(message.invalid_before) : message.invalid_before;
            else
                object.invalid_before = options.longs === String ? $util.Long.prototype.toString.call(message.invalid_before) : options.longs === Number ? new $util.LongBits(message.invalid_before.low >>> 0, message.invalid_before.high >>> 0).toNumber(true) : message.invalid_before;
        if (message.invalid_hereafter != null && message.hasOwnProperty("invalid_hereafter"))
            if (typeof message.invalid_hereafter === "number")
                object.invalid_hereafter = options.longs === String ? String(message.invalid_hereafter) : message.invalid_hereafter;
            else
                object.invalid_hereafter = options.longs === String ? $util.Long.prototype.toString.call(message.invalid_hereafter) : options.longs === Number ? new $util.LongBits(message.invalid_hereafter.low >>> 0, message.invalid_hereafter.high >>> 0).toNumber(true) : message.invalid_hereafter;
        return object;
    };

    CardanoNativeScript.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoNativeScript;
})();

$root.CardanoGetNativeScriptHash = (function() {

    function CardanoGetNativeScriptHash(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoGetNativeScriptHash.prototype.script = null;
    CardanoGetNativeScriptHash.prototype.display_format = 0;
    CardanoGetNativeScriptHash.prototype.derivation_type = 0;

    CardanoGetNativeScriptHash.create = function create(properties) {
        return new CardanoGetNativeScriptHash(properties);
    };

    CardanoGetNativeScriptHash.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        $root.CardanoNativeScript.encode(message.script, writer.uint32(10).fork()).ldelim();
        writer.uint32(16).int32(message.display_format);
        writer.uint32(24).int32(message.derivation_type);
        return writer;
    };

    CardanoGetNativeScriptHash.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoGetNativeScriptHash.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoGetNativeScriptHash();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.script = $root.CardanoNativeScript.decode(reader, reader.uint32());
                break;
            case 2:
                message.display_format = reader.int32();
                break;
            case 3:
                message.derivation_type = reader.int32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("script"))
            throw $util.ProtocolError("missing required 'script'", { instance: message });
        if (!message.hasOwnProperty("display_format"))
            throw $util.ProtocolError("missing required 'display_format'", { instance: message });
        if (!message.hasOwnProperty("derivation_type"))
            throw $util.ProtocolError("missing required 'derivation_type'", { instance: message });
        return message;
    };

    CardanoGetNativeScriptHash.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoGetNativeScriptHash.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        {
            var error = $root.CardanoNativeScript.verify(message.script);
            if (error)
                return "script." + error;
        }
        switch (message.display_format) {
        default:
            return "display_format: enum value expected";
        case 0:
        case 1:
        case 2:
            break;
        }
        switch (message.derivation_type) {
        default:
            return "derivation_type: enum value expected";
        case 0:
        case 1:
        case 2:
            break;
        }
        return null;
    };

    CardanoGetNativeScriptHash.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoGetNativeScriptHash)
            return object;
        var message = new $root.CardanoGetNativeScriptHash();
        if (object.script != null) {
            if (typeof object.script !== "object")
                throw TypeError(".CardanoGetNativeScriptHash.script: object expected");
            message.script = $root.CardanoNativeScript.fromObject(object.script);
        }
        switch (object.display_format) {
        case "HIDE":
        case 0:
            message.display_format = 0;
            break;
        case "BECH32":
        case 1:
            message.display_format = 1;
            break;
        case "POLICY_ID":
        case 2:
            message.display_format = 2;
            break;
        }
        switch (object.derivation_type) {
        case "LEDGER":
        case 0:
            message.derivation_type = 0;
            break;
        case "ICARUS":
        case 1:
            message.derivation_type = 1;
            break;
        case "ICARUS_TREZOR":
        case 2:
            message.derivation_type = 2;
            break;
        }
        return message;
    };

    CardanoGetNativeScriptHash.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.script = null;
            object.display_format = options.enums === String ? "HIDE" : 0;
            object.derivation_type = options.enums === String ? "LEDGER" : 0;
        }
        if (message.script != null && message.hasOwnProperty("script"))
            object.script = $root.CardanoNativeScript.toObject(message.script, options);
        if (message.display_format != null && message.hasOwnProperty("display_format"))
            object.display_format = options.enums === String ? $root.CardanoNativeScriptHashDisplayFormat[message.display_format] : message.display_format;
        if (message.derivation_type != null && message.hasOwnProperty("derivation_type"))
            object.derivation_type = options.enums === String ? $root.CardanoDerivationType[message.derivation_type] : message.derivation_type;
        return object;
    };

    CardanoGetNativeScriptHash.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoGetNativeScriptHash;
})();

$root.CardanoNativeScriptHash = (function() {

    function CardanoNativeScriptHash(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoNativeScriptHash.prototype.script_hash = $util.newBuffer([]);

    CardanoNativeScriptHash.create = function create(properties) {
        return new CardanoNativeScriptHash(properties);
    };

    CardanoNativeScriptHash.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.script_hash);
        return writer;
    };

    CardanoNativeScriptHash.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoNativeScriptHash.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoNativeScriptHash();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.script_hash = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("script_hash"))
            throw $util.ProtocolError("missing required 'script_hash'", { instance: message });
        return message;
    };

    CardanoNativeScriptHash.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoNativeScriptHash.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.script_hash && typeof message.script_hash.length === "number" || $util.isString(message.script_hash)))
            return "script_hash: buffer expected";
        return null;
    };

    CardanoNativeScriptHash.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoNativeScriptHash)
            return object;
        var message = new $root.CardanoNativeScriptHash();
        if (object.script_hash != null)
            if (typeof object.script_hash === "string")
                $util.base64.decode(object.script_hash, message.script_hash = $util.newBuffer($util.base64.length(object.script_hash)), 0);
            else if (object.script_hash.length)
                message.script_hash = object.script_hash;
        return message;
    };

    CardanoNativeScriptHash.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.script_hash = "";
            else {
                object.script_hash = [];
                if (options.bytes !== Array)
                    object.script_hash = $util.newBuffer(object.script_hash);
            }
        if (message.script_hash != null && message.hasOwnProperty("script_hash"))
            object.script_hash = options.bytes === String ? $util.base64.encode(message.script_hash, 0, message.script_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.script_hash) : message.script_hash;
        return object;
    };

    CardanoNativeScriptHash.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoNativeScriptHash;
})();

$root.CardanoAddressParametersType = (function() {

    function CardanoAddressParametersType(properties) {
        this.address_n = [];
        this.address_n_staking = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoAddressParametersType.prototype.address_type = 0;
    CardanoAddressParametersType.prototype.address_n = $util.emptyArray;
    CardanoAddressParametersType.prototype.address_n_staking = $util.emptyArray;
    CardanoAddressParametersType.prototype.staking_key_hash = $util.newBuffer([]);
    CardanoAddressParametersType.prototype.certificate_pointer = null;
    CardanoAddressParametersType.prototype.script_payment_hash = $util.newBuffer([]);
    CardanoAddressParametersType.prototype.script_staking_hash = $util.newBuffer([]);

    CardanoAddressParametersType.create = function create(properties) {
        return new CardanoAddressParametersType(properties);
    };

    CardanoAddressParametersType.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).int32(message.address_type);
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(16).uint32(message.address_n[i]);
        if (message.address_n_staking != null && message.address_n_staking.length)
            for (var i = 0; i < message.address_n_staking.length; ++i)
                writer.uint32(24).uint32(message.address_n_staking[i]);
        if (message.staking_key_hash != null && Object.hasOwnProperty.call(message, "staking_key_hash"))
            writer.uint32(34).bytes(message.staking_key_hash);
        if (message.certificate_pointer != null && Object.hasOwnProperty.call(message, "certificate_pointer"))
            $root.CardanoBlockchainPointerType.encode(message.certificate_pointer, writer.uint32(42).fork()).ldelim();
        if (message.script_payment_hash != null && Object.hasOwnProperty.call(message, "script_payment_hash"))
            writer.uint32(50).bytes(message.script_payment_hash);
        if (message.script_staking_hash != null && Object.hasOwnProperty.call(message, "script_staking_hash"))
            writer.uint32(58).bytes(message.script_staking_hash);
        return writer;
    };

    CardanoAddressParametersType.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoAddressParametersType.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoAddressParametersType();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address_type = reader.int32();
                break;
            case 2:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 3:
                if (!(message.address_n_staking && message.address_n_staking.length))
                    message.address_n_staking = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n_staking.push(reader.uint32());
                } else
                    message.address_n_staking.push(reader.uint32());
                break;
            case 4:
                message.staking_key_hash = reader.bytes();
                break;
            case 5:
                message.certificate_pointer = $root.CardanoBlockchainPointerType.decode(reader, reader.uint32());
                break;
            case 6:
                message.script_payment_hash = reader.bytes();
                break;
            case 7:
                message.script_staking_hash = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("address_type"))
            throw $util.ProtocolError("missing required 'address_type'", { instance: message });
        return message;
    };

    CardanoAddressParametersType.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoAddressParametersType.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        switch (message.address_type) {
        default:
            return "address_type: enum value expected";
        case 0:
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
        case 6:
        case 7:
        case 8:
        case 14:
        case 15:
            break;
        }
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.address_n_staking != null && message.hasOwnProperty("address_n_staking")) {
            if (!Array.isArray(message.address_n_staking))
                return "address_n_staking: array expected";
            for (var i = 0; i < message.address_n_staking.length; ++i)
                if (!$util.isInteger(message.address_n_staking[i]))
                    return "address_n_staking: integer[] expected";
        }
        if (message.staking_key_hash != null && message.hasOwnProperty("staking_key_hash"))
            if (!(message.staking_key_hash && typeof message.staking_key_hash.length === "number" || $util.isString(message.staking_key_hash)))
                return "staking_key_hash: buffer expected";
        if (message.certificate_pointer != null && message.hasOwnProperty("certificate_pointer")) {
            var error = $root.CardanoBlockchainPointerType.verify(message.certificate_pointer);
            if (error)
                return "certificate_pointer." + error;
        }
        if (message.script_payment_hash != null && message.hasOwnProperty("script_payment_hash"))
            if (!(message.script_payment_hash && typeof message.script_payment_hash.length === "number" || $util.isString(message.script_payment_hash)))
                return "script_payment_hash: buffer expected";
        if (message.script_staking_hash != null && message.hasOwnProperty("script_staking_hash"))
            if (!(message.script_staking_hash && typeof message.script_staking_hash.length === "number" || $util.isString(message.script_staking_hash)))
                return "script_staking_hash: buffer expected";
        return null;
    };

    CardanoAddressParametersType.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoAddressParametersType)
            return object;
        var message = new $root.CardanoAddressParametersType();
        switch (object.address_type) {
        case "BASE":
        case 0:
            message.address_type = 0;
            break;
        case "BASE_SCRIPT_KEY":
        case 1:
            message.address_type = 1;
            break;
        case "BASE_KEY_SCRIPT":
        case 2:
            message.address_type = 2;
            break;
        case "BASE_SCRIPT_SCRIPT":
        case 3:
            message.address_type = 3;
            break;
        case "POINTER":
        case 4:
            message.address_type = 4;
            break;
        case "POINTER_SCRIPT":
        case 5:
            message.address_type = 5;
            break;
        case "ENTERPRISE":
        case 6:
            message.address_type = 6;
            break;
        case "ENTERPRISE_SCRIPT":
        case 7:
            message.address_type = 7;
            break;
        case "BYRON":
        case 8:
            message.address_type = 8;
            break;
        case "REWARD":
        case 14:
            message.address_type = 14;
            break;
        case "REWARD_SCRIPT":
        case 15:
            message.address_type = 15;
            break;
        }
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".CardanoAddressParametersType.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.address_n_staking) {
            if (!Array.isArray(object.address_n_staking))
                throw TypeError(".CardanoAddressParametersType.address_n_staking: array expected");
            message.address_n_staking = [];
            for (var i = 0; i < object.address_n_staking.length; ++i)
                message.address_n_staking[i] = object.address_n_staking[i] >>> 0;
        }
        if (object.staking_key_hash != null)
            if (typeof object.staking_key_hash === "string")
                $util.base64.decode(object.staking_key_hash, message.staking_key_hash = $util.newBuffer($util.base64.length(object.staking_key_hash)), 0);
            else if (object.staking_key_hash.length)
                message.staking_key_hash = object.staking_key_hash;
        if (object.certificate_pointer != null) {
            if (typeof object.certificate_pointer !== "object")
                throw TypeError(".CardanoAddressParametersType.certificate_pointer: object expected");
            message.certificate_pointer = $root.CardanoBlockchainPointerType.fromObject(object.certificate_pointer);
        }
        if (object.script_payment_hash != null)
            if (typeof object.script_payment_hash === "string")
                $util.base64.decode(object.script_payment_hash, message.script_payment_hash = $util.newBuffer($util.base64.length(object.script_payment_hash)), 0);
            else if (object.script_payment_hash.length)
                message.script_payment_hash = object.script_payment_hash;
        if (object.script_staking_hash != null)
            if (typeof object.script_staking_hash === "string")
                $util.base64.decode(object.script_staking_hash, message.script_staking_hash = $util.newBuffer($util.base64.length(object.script_staking_hash)), 0);
            else if (object.script_staking_hash.length)
                message.script_staking_hash = object.script_staking_hash;
        return message;
    };

    CardanoAddressParametersType.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults) {
            object.address_n = [];
            object.address_n_staking = [];
        }
        if (options.defaults) {
            object.address_type = options.enums === String ? "BASE" : 0;
            if (options.bytes === String)
                object.staking_key_hash = "";
            else {
                object.staking_key_hash = [];
                if (options.bytes !== Array)
                    object.staking_key_hash = $util.newBuffer(object.staking_key_hash);
            }
            object.certificate_pointer = null;
            if (options.bytes === String)
                object.script_payment_hash = "";
            else {
                object.script_payment_hash = [];
                if (options.bytes !== Array)
                    object.script_payment_hash = $util.newBuffer(object.script_payment_hash);
            }
            if (options.bytes === String)
                object.script_staking_hash = "";
            else {
                object.script_staking_hash = [];
                if (options.bytes !== Array)
                    object.script_staking_hash = $util.newBuffer(object.script_staking_hash);
            }
        }
        if (message.address_type != null && message.hasOwnProperty("address_type"))
            object.address_type = options.enums === String ? $root.CardanoAddressType[message.address_type] : message.address_type;
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.address_n_staking && message.address_n_staking.length) {
            object.address_n_staking = [];
            for (var j = 0; j < message.address_n_staking.length; ++j)
                object.address_n_staking[j] = message.address_n_staking[j];
        }
        if (message.staking_key_hash != null && message.hasOwnProperty("staking_key_hash"))
            object.staking_key_hash = options.bytes === String ? $util.base64.encode(message.staking_key_hash, 0, message.staking_key_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.staking_key_hash) : message.staking_key_hash;
        if (message.certificate_pointer != null && message.hasOwnProperty("certificate_pointer"))
            object.certificate_pointer = $root.CardanoBlockchainPointerType.toObject(message.certificate_pointer, options);
        if (message.script_payment_hash != null && message.hasOwnProperty("script_payment_hash"))
            object.script_payment_hash = options.bytes === String ? $util.base64.encode(message.script_payment_hash, 0, message.script_payment_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.script_payment_hash) : message.script_payment_hash;
        if (message.script_staking_hash != null && message.hasOwnProperty("script_staking_hash"))
            object.script_staking_hash = options.bytes === String ? $util.base64.encode(message.script_staking_hash, 0, message.script_staking_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.script_staking_hash) : message.script_staking_hash;
        return object;
    };

    CardanoAddressParametersType.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoAddressParametersType;
})();

$root.CardanoGetAddress = (function() {

    function CardanoGetAddress(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoGetAddress.prototype.show_display = false;
    CardanoGetAddress.prototype.protocol_magic = 0;
    CardanoGetAddress.prototype.network_id = 0;
    CardanoGetAddress.prototype.address_parameters = null;
    CardanoGetAddress.prototype.derivation_type = 0;

    CardanoGetAddress.create = function create(properties) {
        return new CardanoGetAddress(properties);
    };

    CardanoGetAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(16).bool(message.show_display);
        writer.uint32(24).uint32(message.protocol_magic);
        writer.uint32(32).uint32(message.network_id);
        $root.CardanoAddressParametersType.encode(message.address_parameters, writer.uint32(42).fork()).ldelim();
        writer.uint32(48).int32(message.derivation_type);
        return writer;
    };

    CardanoGetAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoGetAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoGetAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 2:
                message.show_display = reader.bool();
                break;
            case 3:
                message.protocol_magic = reader.uint32();
                break;
            case 4:
                message.network_id = reader.uint32();
                break;
            case 5:
                message.address_parameters = $root.CardanoAddressParametersType.decode(reader, reader.uint32());
                break;
            case 6:
                message.derivation_type = reader.int32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("protocol_magic"))
            throw $util.ProtocolError("missing required 'protocol_magic'", { instance: message });
        if (!message.hasOwnProperty("network_id"))
            throw $util.ProtocolError("missing required 'network_id'", { instance: message });
        if (!message.hasOwnProperty("address_parameters"))
            throw $util.ProtocolError("missing required 'address_parameters'", { instance: message });
        if (!message.hasOwnProperty("derivation_type"))
            throw $util.ProtocolError("missing required 'derivation_type'", { instance: message });
        return message;
    };

    CardanoGetAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoGetAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        if (!$util.isInteger(message.protocol_magic))
            return "protocol_magic: integer expected";
        if (!$util.isInteger(message.network_id))
            return "network_id: integer expected";
        {
            var error = $root.CardanoAddressParametersType.verify(message.address_parameters);
            if (error)
                return "address_parameters." + error;
        }
        switch (message.derivation_type) {
        default:
            return "derivation_type: enum value expected";
        case 0:
        case 1:
        case 2:
            break;
        }
        return null;
    };

    CardanoGetAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoGetAddress)
            return object;
        var message = new $root.CardanoGetAddress();
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        if (object.protocol_magic != null)
            message.protocol_magic = object.protocol_magic >>> 0;
        if (object.network_id != null)
            message.network_id = object.network_id >>> 0;
        if (object.address_parameters != null) {
            if (typeof object.address_parameters !== "object")
                throw TypeError(".CardanoGetAddress.address_parameters: object expected");
            message.address_parameters = $root.CardanoAddressParametersType.fromObject(object.address_parameters);
        }
        switch (object.derivation_type) {
        case "LEDGER":
        case 0:
            message.derivation_type = 0;
            break;
        case "ICARUS":
        case 1:
            message.derivation_type = 1;
            break;
        case "ICARUS_TREZOR":
        case 2:
            message.derivation_type = 2;
            break;
        }
        return message;
    };

    CardanoGetAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.show_display = false;
            object.protocol_magic = 0;
            object.network_id = 0;
            object.address_parameters = null;
            object.derivation_type = options.enums === String ? "LEDGER" : 0;
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        if (message.protocol_magic != null && message.hasOwnProperty("protocol_magic"))
            object.protocol_magic = message.protocol_magic;
        if (message.network_id != null && message.hasOwnProperty("network_id"))
            object.network_id = message.network_id;
        if (message.address_parameters != null && message.hasOwnProperty("address_parameters"))
            object.address_parameters = $root.CardanoAddressParametersType.toObject(message.address_parameters, options);
        if (message.derivation_type != null && message.hasOwnProperty("derivation_type"))
            object.derivation_type = options.enums === String ? $root.CardanoDerivationType[message.derivation_type] : message.derivation_type;
        return object;
    };

    CardanoGetAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoGetAddress;
})();

$root.CardanoAddress = (function() {

    function CardanoAddress(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoAddress.prototype.address = "";

    CardanoAddress.create = function create(properties) {
        return new CardanoAddress(properties);
    };

    CardanoAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.address);
        return writer;
    };

    CardanoAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("address"))
            throw $util.ProtocolError("missing required 'address'", { instance: message });
        return message;
    };

    CardanoAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.address))
            return "address: string expected";
        return null;
    };

    CardanoAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoAddress)
            return object;
        var message = new $root.CardanoAddress();
        if (object.address != null)
            message.address = String(object.address);
        return message;
    };

    CardanoAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.address = "";
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    CardanoAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoAddress;
})();

$root.CardanoGetPublicKey = (function() {

    function CardanoGetPublicKey(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoGetPublicKey.prototype.address_n = $util.emptyArray;
    CardanoGetPublicKey.prototype.show_display = false;
    CardanoGetPublicKey.prototype.derivation_type = 0;

    CardanoGetPublicKey.create = function create(properties) {
        return new CardanoGetPublicKey(properties);
    };

    CardanoGetPublicKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(16).bool(message.show_display);
        writer.uint32(24).int32(message.derivation_type);
        return writer;
    };

    CardanoGetPublicKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoGetPublicKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoGetPublicKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.show_display = reader.bool();
                break;
            case 3:
                message.derivation_type = reader.int32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("derivation_type"))
            throw $util.ProtocolError("missing required 'derivation_type'", { instance: message });
        return message;
    };

    CardanoGetPublicKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoGetPublicKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        switch (message.derivation_type) {
        default:
            return "derivation_type: enum value expected";
        case 0:
        case 1:
        case 2:
            break;
        }
        return null;
    };

    CardanoGetPublicKey.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoGetPublicKey)
            return object;
        var message = new $root.CardanoGetPublicKey();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".CardanoGetPublicKey.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        switch (object.derivation_type) {
        case "LEDGER":
        case 0:
            message.derivation_type = 0;
            break;
        case "ICARUS":
        case 1:
            message.derivation_type = 1;
            break;
        case "ICARUS_TREZOR":
        case 2:
            message.derivation_type = 2;
            break;
        }
        return message;
    };

    CardanoGetPublicKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            object.show_display = false;
            object.derivation_type = options.enums === String ? "LEDGER" : 0;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        if (message.derivation_type != null && message.hasOwnProperty("derivation_type"))
            object.derivation_type = options.enums === String ? $root.CardanoDerivationType[message.derivation_type] : message.derivation_type;
        return object;
    };

    CardanoGetPublicKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoGetPublicKey;
})();

$root.CardanoPublicKey = (function() {

    function CardanoPublicKey(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoPublicKey.prototype.xpub = "";
    CardanoPublicKey.prototype.node = null;

    CardanoPublicKey.create = function create(properties) {
        return new CardanoPublicKey(properties);
    };

    CardanoPublicKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.xpub);
        $root.HDNodeType.encode(message.node, writer.uint32(18).fork()).ldelim();
        return writer;
    };

    CardanoPublicKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoPublicKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoPublicKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.xpub = reader.string();
                break;
            case 2:
                message.node = $root.HDNodeType.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("xpub"))
            throw $util.ProtocolError("missing required 'xpub'", { instance: message });
        if (!message.hasOwnProperty("node"))
            throw $util.ProtocolError("missing required 'node'", { instance: message });
        return message;
    };

    CardanoPublicKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoPublicKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.xpub))
            return "xpub: string expected";
        {
            var error = $root.HDNodeType.verify(message.node);
            if (error)
                return "node." + error;
        }
        return null;
    };

    CardanoPublicKey.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoPublicKey)
            return object;
        var message = new $root.CardanoPublicKey();
        if (object.xpub != null)
            message.xpub = String(object.xpub);
        if (object.node != null) {
            if (typeof object.node !== "object")
                throw TypeError(".CardanoPublicKey.node: object expected");
            message.node = $root.HDNodeType.fromObject(object.node);
        }
        return message;
    };

    CardanoPublicKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.xpub = "";
            object.node = null;
        }
        if (message.xpub != null && message.hasOwnProperty("xpub"))
            object.xpub = message.xpub;
        if (message.node != null && message.hasOwnProperty("node"))
            object.node = $root.HDNodeType.toObject(message.node, options);
        return object;
    };

    CardanoPublicKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoPublicKey;
})();

$root.CardanoSignTxInit = (function() {

    function CardanoSignTxInit(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoSignTxInit.prototype.signing_mode = 0;
    CardanoSignTxInit.prototype.protocol_magic = 0;
    CardanoSignTxInit.prototype.network_id = 0;
    CardanoSignTxInit.prototype.inputs_count = 0;
    CardanoSignTxInit.prototype.outputs_count = 0;
    CardanoSignTxInit.prototype.fee = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    CardanoSignTxInit.prototype.ttl = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    CardanoSignTxInit.prototype.certificates_count = 0;
    CardanoSignTxInit.prototype.withdrawals_count = 0;
    CardanoSignTxInit.prototype.has_auxiliary_data = false;
    CardanoSignTxInit.prototype.validity_interval_start = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    CardanoSignTxInit.prototype.witness_requests_count = 0;
    CardanoSignTxInit.prototype.minting_asset_groups_count = 0;
    CardanoSignTxInit.prototype.derivation_type = 0;
    CardanoSignTxInit.prototype.include_network_id = false;
    CardanoSignTxInit.prototype.script_data_hash = $util.newBuffer([]);
    CardanoSignTxInit.prototype.collateral_inputs_count = 0;
    CardanoSignTxInit.prototype.required_signers_count = 0;
    CardanoSignTxInit.prototype.has_collateral_return = false;
    CardanoSignTxInit.prototype.total_collateral = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    CardanoSignTxInit.prototype.reference_inputs_count = 0;

    CardanoSignTxInit.create = function create(properties) {
        return new CardanoSignTxInit(properties);
    };

    CardanoSignTxInit.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).int32(message.signing_mode);
        writer.uint32(16).uint32(message.protocol_magic);
        writer.uint32(24).uint32(message.network_id);
        writer.uint32(32).uint32(message.inputs_count);
        writer.uint32(40).uint32(message.outputs_count);
        writer.uint32(48).uint64(message.fee);
        if (message.ttl != null && Object.hasOwnProperty.call(message, "ttl"))
            writer.uint32(56).uint64(message.ttl);
        writer.uint32(64).uint32(message.certificates_count);
        writer.uint32(72).uint32(message.withdrawals_count);
        writer.uint32(80).bool(message.has_auxiliary_data);
        if (message.validity_interval_start != null && Object.hasOwnProperty.call(message, "validity_interval_start"))
            writer.uint32(88).uint64(message.validity_interval_start);
        writer.uint32(96).uint32(message.witness_requests_count);
        writer.uint32(104).uint32(message.minting_asset_groups_count);
        writer.uint32(112).int32(message.derivation_type);
        if (message.include_network_id != null && Object.hasOwnProperty.call(message, "include_network_id"))
            writer.uint32(120).bool(message.include_network_id);
        if (message.script_data_hash != null && Object.hasOwnProperty.call(message, "script_data_hash"))
            writer.uint32(130).bytes(message.script_data_hash);
        writer.uint32(136).uint32(message.collateral_inputs_count);
        writer.uint32(144).uint32(message.required_signers_count);
        if (message.has_collateral_return != null && Object.hasOwnProperty.call(message, "has_collateral_return"))
            writer.uint32(152).bool(message.has_collateral_return);
        if (message.total_collateral != null && Object.hasOwnProperty.call(message, "total_collateral"))
            writer.uint32(160).uint64(message.total_collateral);
        if (message.reference_inputs_count != null && Object.hasOwnProperty.call(message, "reference_inputs_count"))
            writer.uint32(168).uint32(message.reference_inputs_count);
        return writer;
    };

    CardanoSignTxInit.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoSignTxInit.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoSignTxInit();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.signing_mode = reader.int32();
                break;
            case 2:
                message.protocol_magic = reader.uint32();
                break;
            case 3:
                message.network_id = reader.uint32();
                break;
            case 4:
                message.inputs_count = reader.uint32();
                break;
            case 5:
                message.outputs_count = reader.uint32();
                break;
            case 6:
                message.fee = reader.uint64();
                break;
            case 7:
                message.ttl = reader.uint64();
                break;
            case 8:
                message.certificates_count = reader.uint32();
                break;
            case 9:
                message.withdrawals_count = reader.uint32();
                break;
            case 10:
                message.has_auxiliary_data = reader.bool();
                break;
            case 11:
                message.validity_interval_start = reader.uint64();
                break;
            case 12:
                message.witness_requests_count = reader.uint32();
                break;
            case 13:
                message.minting_asset_groups_count = reader.uint32();
                break;
            case 14:
                message.derivation_type = reader.int32();
                break;
            case 15:
                message.include_network_id = reader.bool();
                break;
            case 16:
                message.script_data_hash = reader.bytes();
                break;
            case 17:
                message.collateral_inputs_count = reader.uint32();
                break;
            case 18:
                message.required_signers_count = reader.uint32();
                break;
            case 19:
                message.has_collateral_return = reader.bool();
                break;
            case 20:
                message.total_collateral = reader.uint64();
                break;
            case 21:
                message.reference_inputs_count = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("signing_mode"))
            throw $util.ProtocolError("missing required 'signing_mode'", { instance: message });
        if (!message.hasOwnProperty("protocol_magic"))
            throw $util.ProtocolError("missing required 'protocol_magic'", { instance: message });
        if (!message.hasOwnProperty("network_id"))
            throw $util.ProtocolError("missing required 'network_id'", { instance: message });
        if (!message.hasOwnProperty("inputs_count"))
            throw $util.ProtocolError("missing required 'inputs_count'", { instance: message });
        if (!message.hasOwnProperty("outputs_count"))
            throw $util.ProtocolError("missing required 'outputs_count'", { instance: message });
        if (!message.hasOwnProperty("fee"))
            throw $util.ProtocolError("missing required 'fee'", { instance: message });
        if (!message.hasOwnProperty("certificates_count"))
            throw $util.ProtocolError("missing required 'certificates_count'", { instance: message });
        if (!message.hasOwnProperty("withdrawals_count"))
            throw $util.ProtocolError("missing required 'withdrawals_count'", { instance: message });
        if (!message.hasOwnProperty("has_auxiliary_data"))
            throw $util.ProtocolError("missing required 'has_auxiliary_data'", { instance: message });
        if (!message.hasOwnProperty("witness_requests_count"))
            throw $util.ProtocolError("missing required 'witness_requests_count'", { instance: message });
        if (!message.hasOwnProperty("minting_asset_groups_count"))
            throw $util.ProtocolError("missing required 'minting_asset_groups_count'", { instance: message });
        if (!message.hasOwnProperty("derivation_type"))
            throw $util.ProtocolError("missing required 'derivation_type'", { instance: message });
        if (!message.hasOwnProperty("collateral_inputs_count"))
            throw $util.ProtocolError("missing required 'collateral_inputs_count'", { instance: message });
        if (!message.hasOwnProperty("required_signers_count"))
            throw $util.ProtocolError("missing required 'required_signers_count'", { instance: message });
        return message;
    };

    CardanoSignTxInit.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoSignTxInit.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        switch (message.signing_mode) {
        default:
            return "signing_mode: enum value expected";
        case 0:
        case 1:
        case 2:
        case 3:
            break;
        }
        if (!$util.isInteger(message.protocol_magic))
            return "protocol_magic: integer expected";
        if (!$util.isInteger(message.network_id))
            return "network_id: integer expected";
        if (!$util.isInteger(message.inputs_count))
            return "inputs_count: integer expected";
        if (!$util.isInteger(message.outputs_count))
            return "outputs_count: integer expected";
        if (!$util.isInteger(message.fee) && !(message.fee && $util.isInteger(message.fee.low) && $util.isInteger(message.fee.high)))
            return "fee: integer|Long expected";
        if (message.ttl != null && message.hasOwnProperty("ttl"))
            if (!$util.isInteger(message.ttl) && !(message.ttl && $util.isInteger(message.ttl.low) && $util.isInteger(message.ttl.high)))
                return "ttl: integer|Long expected";
        if (!$util.isInteger(message.certificates_count))
            return "certificates_count: integer expected";
        if (!$util.isInteger(message.withdrawals_count))
            return "withdrawals_count: integer expected";
        if (typeof message.has_auxiliary_data !== "boolean")
            return "has_auxiliary_data: boolean expected";
        if (message.validity_interval_start != null && message.hasOwnProperty("validity_interval_start"))
            if (!$util.isInteger(message.validity_interval_start) && !(message.validity_interval_start && $util.isInteger(message.validity_interval_start.low) && $util.isInteger(message.validity_interval_start.high)))
                return "validity_interval_start: integer|Long expected";
        if (!$util.isInteger(message.witness_requests_count))
            return "witness_requests_count: integer expected";
        if (!$util.isInteger(message.minting_asset_groups_count))
            return "minting_asset_groups_count: integer expected";
        switch (message.derivation_type) {
        default:
            return "derivation_type: enum value expected";
        case 0:
        case 1:
        case 2:
            break;
        }
        if (message.include_network_id != null && message.hasOwnProperty("include_network_id"))
            if (typeof message.include_network_id !== "boolean")
                return "include_network_id: boolean expected";
        if (message.script_data_hash != null && message.hasOwnProperty("script_data_hash"))
            if (!(message.script_data_hash && typeof message.script_data_hash.length === "number" || $util.isString(message.script_data_hash)))
                return "script_data_hash: buffer expected";
        if (!$util.isInteger(message.collateral_inputs_count))
            return "collateral_inputs_count: integer expected";
        if (!$util.isInteger(message.required_signers_count))
            return "required_signers_count: integer expected";
        if (message.has_collateral_return != null && message.hasOwnProperty("has_collateral_return"))
            if (typeof message.has_collateral_return !== "boolean")
                return "has_collateral_return: boolean expected";
        if (message.total_collateral != null && message.hasOwnProperty("total_collateral"))
            if (!$util.isInteger(message.total_collateral) && !(message.total_collateral && $util.isInteger(message.total_collateral.low) && $util.isInteger(message.total_collateral.high)))
                return "total_collateral: integer|Long expected";
        if (message.reference_inputs_count != null && message.hasOwnProperty("reference_inputs_count"))
            if (!$util.isInteger(message.reference_inputs_count))
                return "reference_inputs_count: integer expected";
        return null;
    };

    CardanoSignTxInit.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoSignTxInit)
            return object;
        var message = new $root.CardanoSignTxInit();
        switch (object.signing_mode) {
        case "ORDINARY_TRANSACTION":
        case 0:
            message.signing_mode = 0;
            break;
        case "POOL_REGISTRATION_AS_OWNER":
        case 1:
            message.signing_mode = 1;
            break;
        case "MULTISIG_TRANSACTION":
        case 2:
            message.signing_mode = 2;
            break;
        case "PLUTUS_TRANSACTION":
        case 3:
            message.signing_mode = 3;
            break;
        }
        if (object.protocol_magic != null)
            message.protocol_magic = object.protocol_magic >>> 0;
        if (object.network_id != null)
            message.network_id = object.network_id >>> 0;
        if (object.inputs_count != null)
            message.inputs_count = object.inputs_count >>> 0;
        if (object.outputs_count != null)
            message.outputs_count = object.outputs_count >>> 0;
        if (object.fee != null)
            if ($util.Long)
                (message.fee = $util.Long.fromValue(object.fee)).unsigned = true;
            else if (typeof object.fee === "string")
                message.fee = parseInt(object.fee, 10);
            else if (typeof object.fee === "number")
                message.fee = object.fee;
            else if (typeof object.fee === "object")
                message.fee = new $util.LongBits(object.fee.low >>> 0, object.fee.high >>> 0).toNumber(true);
        if (object.ttl != null)
            if ($util.Long)
                (message.ttl = $util.Long.fromValue(object.ttl)).unsigned = true;
            else if (typeof object.ttl === "string")
                message.ttl = parseInt(object.ttl, 10);
            else if (typeof object.ttl === "number")
                message.ttl = object.ttl;
            else if (typeof object.ttl === "object")
                message.ttl = new $util.LongBits(object.ttl.low >>> 0, object.ttl.high >>> 0).toNumber(true);
        if (object.certificates_count != null)
            message.certificates_count = object.certificates_count >>> 0;
        if (object.withdrawals_count != null)
            message.withdrawals_count = object.withdrawals_count >>> 0;
        if (object.has_auxiliary_data != null)
            message.has_auxiliary_data = Boolean(object.has_auxiliary_data);
        if (object.validity_interval_start != null)
            if ($util.Long)
                (message.validity_interval_start = $util.Long.fromValue(object.validity_interval_start)).unsigned = true;
            else if (typeof object.validity_interval_start === "string")
                message.validity_interval_start = parseInt(object.validity_interval_start, 10);
            else if (typeof object.validity_interval_start === "number")
                message.validity_interval_start = object.validity_interval_start;
            else if (typeof object.validity_interval_start === "object")
                message.validity_interval_start = new $util.LongBits(object.validity_interval_start.low >>> 0, object.validity_interval_start.high >>> 0).toNumber(true);
        if (object.witness_requests_count != null)
            message.witness_requests_count = object.witness_requests_count >>> 0;
        if (object.minting_asset_groups_count != null)
            message.minting_asset_groups_count = object.minting_asset_groups_count >>> 0;
        switch (object.derivation_type) {
        case "LEDGER":
        case 0:
            message.derivation_type = 0;
            break;
        case "ICARUS":
        case 1:
            message.derivation_type = 1;
            break;
        case "ICARUS_TREZOR":
        case 2:
            message.derivation_type = 2;
            break;
        }
        if (object.include_network_id != null)
            message.include_network_id = Boolean(object.include_network_id);
        if (object.script_data_hash != null)
            if (typeof object.script_data_hash === "string")
                $util.base64.decode(object.script_data_hash, message.script_data_hash = $util.newBuffer($util.base64.length(object.script_data_hash)), 0);
            else if (object.script_data_hash.length)
                message.script_data_hash = object.script_data_hash;
        if (object.collateral_inputs_count != null)
            message.collateral_inputs_count = object.collateral_inputs_count >>> 0;
        if (object.required_signers_count != null)
            message.required_signers_count = object.required_signers_count >>> 0;
        if (object.has_collateral_return != null)
            message.has_collateral_return = Boolean(object.has_collateral_return);
        if (object.total_collateral != null)
            if ($util.Long)
                (message.total_collateral = $util.Long.fromValue(object.total_collateral)).unsigned = true;
            else if (typeof object.total_collateral === "string")
                message.total_collateral = parseInt(object.total_collateral, 10);
            else if (typeof object.total_collateral === "number")
                message.total_collateral = object.total_collateral;
            else if (typeof object.total_collateral === "object")
                message.total_collateral = new $util.LongBits(object.total_collateral.low >>> 0, object.total_collateral.high >>> 0).toNumber(true);
        if (object.reference_inputs_count != null)
            message.reference_inputs_count = object.reference_inputs_count >>> 0;
        return message;
    };

    CardanoSignTxInit.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.signing_mode = options.enums === String ? "ORDINARY_TRANSACTION" : 0;
            object.protocol_magic = 0;
            object.network_id = 0;
            object.inputs_count = 0;
            object.outputs_count = 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.fee = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.fee = options.longs === String ? "0" : 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.ttl = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.ttl = options.longs === String ? "0" : 0;
            object.certificates_count = 0;
            object.withdrawals_count = 0;
            object.has_auxiliary_data = false;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.validity_interval_start = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.validity_interval_start = options.longs === String ? "0" : 0;
            object.witness_requests_count = 0;
            object.minting_asset_groups_count = 0;
            object.derivation_type = options.enums === String ? "LEDGER" : 0;
            object.include_network_id = false;
            if (options.bytes === String)
                object.script_data_hash = "";
            else {
                object.script_data_hash = [];
                if (options.bytes !== Array)
                    object.script_data_hash = $util.newBuffer(object.script_data_hash);
            }
            object.collateral_inputs_count = 0;
            object.required_signers_count = 0;
            object.has_collateral_return = false;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.total_collateral = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.total_collateral = options.longs === String ? "0" : 0;
            object.reference_inputs_count = 0;
        }
        if (message.signing_mode != null && message.hasOwnProperty("signing_mode"))
            object.signing_mode = options.enums === String ? $root.CardanoTxSigningMode[message.signing_mode] : message.signing_mode;
        if (message.protocol_magic != null && message.hasOwnProperty("protocol_magic"))
            object.protocol_magic = message.protocol_magic;
        if (message.network_id != null && message.hasOwnProperty("network_id"))
            object.network_id = message.network_id;
        if (message.inputs_count != null && message.hasOwnProperty("inputs_count"))
            object.inputs_count = message.inputs_count;
        if (message.outputs_count != null && message.hasOwnProperty("outputs_count"))
            object.outputs_count = message.outputs_count;
        if (message.fee != null && message.hasOwnProperty("fee"))
            if (typeof message.fee === "number")
                object.fee = options.longs === String ? String(message.fee) : message.fee;
            else
                object.fee = options.longs === String ? $util.Long.prototype.toString.call(message.fee) : options.longs === Number ? new $util.LongBits(message.fee.low >>> 0, message.fee.high >>> 0).toNumber(true) : message.fee;
        if (message.ttl != null && message.hasOwnProperty("ttl"))
            if (typeof message.ttl === "number")
                object.ttl = options.longs === String ? String(message.ttl) : message.ttl;
            else
                object.ttl = options.longs === String ? $util.Long.prototype.toString.call(message.ttl) : options.longs === Number ? new $util.LongBits(message.ttl.low >>> 0, message.ttl.high >>> 0).toNumber(true) : message.ttl;
        if (message.certificates_count != null && message.hasOwnProperty("certificates_count"))
            object.certificates_count = message.certificates_count;
        if (message.withdrawals_count != null && message.hasOwnProperty("withdrawals_count"))
            object.withdrawals_count = message.withdrawals_count;
        if (message.has_auxiliary_data != null && message.hasOwnProperty("has_auxiliary_data"))
            object.has_auxiliary_data = message.has_auxiliary_data;
        if (message.validity_interval_start != null && message.hasOwnProperty("validity_interval_start"))
            if (typeof message.validity_interval_start === "number")
                object.validity_interval_start = options.longs === String ? String(message.validity_interval_start) : message.validity_interval_start;
            else
                object.validity_interval_start = options.longs === String ? $util.Long.prototype.toString.call(message.validity_interval_start) : options.longs === Number ? new $util.LongBits(message.validity_interval_start.low >>> 0, message.validity_interval_start.high >>> 0).toNumber(true) : message.validity_interval_start;
        if (message.witness_requests_count != null && message.hasOwnProperty("witness_requests_count"))
            object.witness_requests_count = message.witness_requests_count;
        if (message.minting_asset_groups_count != null && message.hasOwnProperty("minting_asset_groups_count"))
            object.minting_asset_groups_count = message.minting_asset_groups_count;
        if (message.derivation_type != null && message.hasOwnProperty("derivation_type"))
            object.derivation_type = options.enums === String ? $root.CardanoDerivationType[message.derivation_type] : message.derivation_type;
        if (message.include_network_id != null && message.hasOwnProperty("include_network_id"))
            object.include_network_id = message.include_network_id;
        if (message.script_data_hash != null && message.hasOwnProperty("script_data_hash"))
            object.script_data_hash = options.bytes === String ? $util.base64.encode(message.script_data_hash, 0, message.script_data_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.script_data_hash) : message.script_data_hash;
        if (message.collateral_inputs_count != null && message.hasOwnProperty("collateral_inputs_count"))
            object.collateral_inputs_count = message.collateral_inputs_count;
        if (message.required_signers_count != null && message.hasOwnProperty("required_signers_count"))
            object.required_signers_count = message.required_signers_count;
        if (message.has_collateral_return != null && message.hasOwnProperty("has_collateral_return"))
            object.has_collateral_return = message.has_collateral_return;
        if (message.total_collateral != null && message.hasOwnProperty("total_collateral"))
            if (typeof message.total_collateral === "number")
                object.total_collateral = options.longs === String ? String(message.total_collateral) : message.total_collateral;
            else
                object.total_collateral = options.longs === String ? $util.Long.prototype.toString.call(message.total_collateral) : options.longs === Number ? new $util.LongBits(message.total_collateral.low >>> 0, message.total_collateral.high >>> 0).toNumber(true) : message.total_collateral;
        if (message.reference_inputs_count != null && message.hasOwnProperty("reference_inputs_count"))
            object.reference_inputs_count = message.reference_inputs_count;
        return object;
    };

    CardanoSignTxInit.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoSignTxInit;
})();

$root.CardanoTxInput = (function() {

    function CardanoTxInput(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoTxInput.prototype.prev_hash = $util.newBuffer([]);
    CardanoTxInput.prototype.prev_index = 0;

    CardanoTxInput.create = function create(properties) {
        return new CardanoTxInput(properties);
    };

    CardanoTxInput.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.prev_hash);
        writer.uint32(16).uint32(message.prev_index);
        return writer;
    };

    CardanoTxInput.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoTxInput.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoTxInput();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.prev_hash = reader.bytes();
                break;
            case 2:
                message.prev_index = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("prev_hash"))
            throw $util.ProtocolError("missing required 'prev_hash'", { instance: message });
        if (!message.hasOwnProperty("prev_index"))
            throw $util.ProtocolError("missing required 'prev_index'", { instance: message });
        return message;
    };

    CardanoTxInput.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoTxInput.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.prev_hash && typeof message.prev_hash.length === "number" || $util.isString(message.prev_hash)))
            return "prev_hash: buffer expected";
        if (!$util.isInteger(message.prev_index))
            return "prev_index: integer expected";
        return null;
    };

    CardanoTxInput.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoTxInput)
            return object;
        var message = new $root.CardanoTxInput();
        if (object.prev_hash != null)
            if (typeof object.prev_hash === "string")
                $util.base64.decode(object.prev_hash, message.prev_hash = $util.newBuffer($util.base64.length(object.prev_hash)), 0);
            else if (object.prev_hash.length)
                message.prev_hash = object.prev_hash;
        if (object.prev_index != null)
            message.prev_index = object.prev_index >>> 0;
        return message;
    };

    CardanoTxInput.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.prev_hash = "";
            else {
                object.prev_hash = [];
                if (options.bytes !== Array)
                    object.prev_hash = $util.newBuffer(object.prev_hash);
            }
            object.prev_index = 0;
        }
        if (message.prev_hash != null && message.hasOwnProperty("prev_hash"))
            object.prev_hash = options.bytes === String ? $util.base64.encode(message.prev_hash, 0, message.prev_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.prev_hash) : message.prev_hash;
        if (message.prev_index != null && message.hasOwnProperty("prev_index"))
            object.prev_index = message.prev_index;
        return object;
    };

    CardanoTxInput.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoTxInput;
})();

$root.CardanoTxOutput = (function() {

    function CardanoTxOutput(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoTxOutput.prototype.address = "";
    CardanoTxOutput.prototype.address_parameters = null;
    CardanoTxOutput.prototype.amount = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    CardanoTxOutput.prototype.asset_groups_count = 0;
    CardanoTxOutput.prototype.datum_hash = $util.newBuffer([]);
    CardanoTxOutput.prototype.format = 0;
    CardanoTxOutput.prototype.inline_datum_size = 0;
    CardanoTxOutput.prototype.reference_script_size = 0;

    CardanoTxOutput.create = function create(properties) {
        return new CardanoTxOutput(properties);
    };

    CardanoTxOutput.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address != null && Object.hasOwnProperty.call(message, "address"))
            writer.uint32(10).string(message.address);
        if (message.address_parameters != null && Object.hasOwnProperty.call(message, "address_parameters"))
            $root.CardanoAddressParametersType.encode(message.address_parameters, writer.uint32(18).fork()).ldelim();
        writer.uint32(24).uint64(message.amount);
        writer.uint32(32).uint32(message.asset_groups_count);
        if (message.datum_hash != null && Object.hasOwnProperty.call(message, "datum_hash"))
            writer.uint32(42).bytes(message.datum_hash);
        if (message.format != null && Object.hasOwnProperty.call(message, "format"))
            writer.uint32(48).int32(message.format);
        if (message.inline_datum_size != null && Object.hasOwnProperty.call(message, "inline_datum_size"))
            writer.uint32(56).uint32(message.inline_datum_size);
        if (message.reference_script_size != null && Object.hasOwnProperty.call(message, "reference_script_size"))
            writer.uint32(64).uint32(message.reference_script_size);
        return writer;
    };

    CardanoTxOutput.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoTxOutput.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoTxOutput();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.string();
                break;
            case 2:
                message.address_parameters = $root.CardanoAddressParametersType.decode(reader, reader.uint32());
                break;
            case 3:
                message.amount = reader.uint64();
                break;
            case 4:
                message.asset_groups_count = reader.uint32();
                break;
            case 5:
                message.datum_hash = reader.bytes();
                break;
            case 6:
                message.format = reader.int32();
                break;
            case 7:
                message.inline_datum_size = reader.uint32();
                break;
            case 8:
                message.reference_script_size = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("amount"))
            throw $util.ProtocolError("missing required 'amount'", { instance: message });
        if (!message.hasOwnProperty("asset_groups_count"))
            throw $util.ProtocolError("missing required 'asset_groups_count'", { instance: message });
        return message;
    };

    CardanoTxOutput.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoTxOutput.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address != null && message.hasOwnProperty("address"))
            if (!$util.isString(message.address))
                return "address: string expected";
        if (message.address_parameters != null && message.hasOwnProperty("address_parameters")) {
            var error = $root.CardanoAddressParametersType.verify(message.address_parameters);
            if (error)
                return "address_parameters." + error;
        }
        if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
            return "amount: integer|Long expected";
        if (!$util.isInteger(message.asset_groups_count))
            return "asset_groups_count: integer expected";
        if (message.datum_hash != null && message.hasOwnProperty("datum_hash"))
            if (!(message.datum_hash && typeof message.datum_hash.length === "number" || $util.isString(message.datum_hash)))
                return "datum_hash: buffer expected";
        if (message.format != null && message.hasOwnProperty("format"))
            switch (message.format) {
            default:
                return "format: enum value expected";
            case 0:
            case 1:
                break;
            }
        if (message.inline_datum_size != null && message.hasOwnProperty("inline_datum_size"))
            if (!$util.isInteger(message.inline_datum_size))
                return "inline_datum_size: integer expected";
        if (message.reference_script_size != null && message.hasOwnProperty("reference_script_size"))
            if (!$util.isInteger(message.reference_script_size))
                return "reference_script_size: integer expected";
        return null;
    };

    CardanoTxOutput.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoTxOutput)
            return object;
        var message = new $root.CardanoTxOutput();
        if (object.address != null)
            message.address = String(object.address);
        if (object.address_parameters != null) {
            if (typeof object.address_parameters !== "object")
                throw TypeError(".CardanoTxOutput.address_parameters: object expected");
            message.address_parameters = $root.CardanoAddressParametersType.fromObject(object.address_parameters);
        }
        if (object.amount != null)
            if ($util.Long)
                (message.amount = $util.Long.fromValue(object.amount)).unsigned = true;
            else if (typeof object.amount === "string")
                message.amount = parseInt(object.amount, 10);
            else if (typeof object.amount === "number")
                message.amount = object.amount;
            else if (typeof object.amount === "object")
                message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber(true);
        if (object.asset_groups_count != null)
            message.asset_groups_count = object.asset_groups_count >>> 0;
        if (object.datum_hash != null)
            if (typeof object.datum_hash === "string")
                $util.base64.decode(object.datum_hash, message.datum_hash = $util.newBuffer($util.base64.length(object.datum_hash)), 0);
            else if (object.datum_hash.length)
                message.datum_hash = object.datum_hash;
        switch (object.format) {
        case "ARRAY_LEGACY":
        case 0:
            message.format = 0;
            break;
        case "MAP_BABBAGE":
        case 1:
            message.format = 1;
            break;
        }
        if (object.inline_datum_size != null)
            message.inline_datum_size = object.inline_datum_size >>> 0;
        if (object.reference_script_size != null)
            message.reference_script_size = object.reference_script_size >>> 0;
        return message;
    };

    CardanoTxOutput.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.address = "";
            object.address_parameters = null;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.amount = options.longs === String ? "0" : 0;
            object.asset_groups_count = 0;
            if (options.bytes === String)
                object.datum_hash = "";
            else {
                object.datum_hash = [];
                if (options.bytes !== Array)
                    object.datum_hash = $util.newBuffer(object.datum_hash);
            }
            object.format = options.enums === String ? "ARRAY_LEGACY" : 0;
            object.inline_datum_size = 0;
            object.reference_script_size = 0;
        }
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        if (message.address_parameters != null && message.hasOwnProperty("address_parameters"))
            object.address_parameters = $root.CardanoAddressParametersType.toObject(message.address_parameters, options);
        if (message.amount != null && message.hasOwnProperty("amount"))
            if (typeof message.amount === "number")
                object.amount = options.longs === String ? String(message.amount) : message.amount;
            else
                object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber(true) : message.amount;
        if (message.asset_groups_count != null && message.hasOwnProperty("asset_groups_count"))
            object.asset_groups_count = message.asset_groups_count;
        if (message.datum_hash != null && message.hasOwnProperty("datum_hash"))
            object.datum_hash = options.bytes === String ? $util.base64.encode(message.datum_hash, 0, message.datum_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.datum_hash) : message.datum_hash;
        if (message.format != null && message.hasOwnProperty("format"))
            object.format = options.enums === String ? $root.CardanoTxOutputSerializationFormat[message.format] : message.format;
        if (message.inline_datum_size != null && message.hasOwnProperty("inline_datum_size"))
            object.inline_datum_size = message.inline_datum_size;
        if (message.reference_script_size != null && message.hasOwnProperty("reference_script_size"))
            object.reference_script_size = message.reference_script_size;
        return object;
    };

    CardanoTxOutput.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoTxOutput;
})();

$root.CardanoAssetGroup = (function() {

    function CardanoAssetGroup(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoAssetGroup.prototype.policy_id = $util.newBuffer([]);
    CardanoAssetGroup.prototype.tokens_count = 0;

    CardanoAssetGroup.create = function create(properties) {
        return new CardanoAssetGroup(properties);
    };

    CardanoAssetGroup.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.policy_id);
        writer.uint32(16).uint32(message.tokens_count);
        return writer;
    };

    CardanoAssetGroup.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoAssetGroup.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoAssetGroup();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.policy_id = reader.bytes();
                break;
            case 2:
                message.tokens_count = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("policy_id"))
            throw $util.ProtocolError("missing required 'policy_id'", { instance: message });
        if (!message.hasOwnProperty("tokens_count"))
            throw $util.ProtocolError("missing required 'tokens_count'", { instance: message });
        return message;
    };

    CardanoAssetGroup.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoAssetGroup.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.policy_id && typeof message.policy_id.length === "number" || $util.isString(message.policy_id)))
            return "policy_id: buffer expected";
        if (!$util.isInteger(message.tokens_count))
            return "tokens_count: integer expected";
        return null;
    };

    CardanoAssetGroup.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoAssetGroup)
            return object;
        var message = new $root.CardanoAssetGroup();
        if (object.policy_id != null)
            if (typeof object.policy_id === "string")
                $util.base64.decode(object.policy_id, message.policy_id = $util.newBuffer($util.base64.length(object.policy_id)), 0);
            else if (object.policy_id.length)
                message.policy_id = object.policy_id;
        if (object.tokens_count != null)
            message.tokens_count = object.tokens_count >>> 0;
        return message;
    };

    CardanoAssetGroup.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.policy_id = "";
            else {
                object.policy_id = [];
                if (options.bytes !== Array)
                    object.policy_id = $util.newBuffer(object.policy_id);
            }
            object.tokens_count = 0;
        }
        if (message.policy_id != null && message.hasOwnProperty("policy_id"))
            object.policy_id = options.bytes === String ? $util.base64.encode(message.policy_id, 0, message.policy_id.length) : options.bytes === Array ? Array.prototype.slice.call(message.policy_id) : message.policy_id;
        if (message.tokens_count != null && message.hasOwnProperty("tokens_count"))
            object.tokens_count = message.tokens_count;
        return object;
    };

    CardanoAssetGroup.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoAssetGroup;
})();

$root.CardanoToken = (function() {

    function CardanoToken(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoToken.prototype.asset_name_bytes = $util.newBuffer([]);
    CardanoToken.prototype.amount = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    CardanoToken.prototype.mint_amount = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    CardanoToken.create = function create(properties) {
        return new CardanoToken(properties);
    };

    CardanoToken.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.asset_name_bytes);
        if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
            writer.uint32(16).uint64(message.amount);
        if (message.mint_amount != null && Object.hasOwnProperty.call(message, "mint_amount"))
            writer.uint32(24).sint64(message.mint_amount);
        return writer;
    };

    CardanoToken.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoToken.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoToken();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.asset_name_bytes = reader.bytes();
                break;
            case 2:
                message.amount = reader.uint64();
                break;
            case 3:
                message.mint_amount = reader.sint64();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("asset_name_bytes"))
            throw $util.ProtocolError("missing required 'asset_name_bytes'", { instance: message });
        return message;
    };

    CardanoToken.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoToken.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.asset_name_bytes && typeof message.asset_name_bytes.length === "number" || $util.isString(message.asset_name_bytes)))
            return "asset_name_bytes: buffer expected";
        if (message.amount != null && message.hasOwnProperty("amount"))
            if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
                return "amount: integer|Long expected";
        if (message.mint_amount != null && message.hasOwnProperty("mint_amount"))
            if (!$util.isInteger(message.mint_amount) && !(message.mint_amount && $util.isInteger(message.mint_amount.low) && $util.isInteger(message.mint_amount.high)))
                return "mint_amount: integer|Long expected";
        return null;
    };

    CardanoToken.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoToken)
            return object;
        var message = new $root.CardanoToken();
        if (object.asset_name_bytes != null)
            if (typeof object.asset_name_bytes === "string")
                $util.base64.decode(object.asset_name_bytes, message.asset_name_bytes = $util.newBuffer($util.base64.length(object.asset_name_bytes)), 0);
            else if (object.asset_name_bytes.length)
                message.asset_name_bytes = object.asset_name_bytes;
        if (object.amount != null)
            if ($util.Long)
                (message.amount = $util.Long.fromValue(object.amount)).unsigned = true;
            else if (typeof object.amount === "string")
                message.amount = parseInt(object.amount, 10);
            else if (typeof object.amount === "number")
                message.amount = object.amount;
            else if (typeof object.amount === "object")
                message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber(true);
        if (object.mint_amount != null)
            if ($util.Long)
                (message.mint_amount = $util.Long.fromValue(object.mint_amount)).unsigned = false;
            else if (typeof object.mint_amount === "string")
                message.mint_amount = parseInt(object.mint_amount, 10);
            else if (typeof object.mint_amount === "number")
                message.mint_amount = object.mint_amount;
            else if (typeof object.mint_amount === "object")
                message.mint_amount = new $util.LongBits(object.mint_amount.low >>> 0, object.mint_amount.high >>> 0).toNumber();
        return message;
    };

    CardanoToken.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.asset_name_bytes = "";
            else {
                object.asset_name_bytes = [];
                if (options.bytes !== Array)
                    object.asset_name_bytes = $util.newBuffer(object.asset_name_bytes);
            }
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.amount = options.longs === String ? "0" : 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.mint_amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.mint_amount = options.longs === String ? "0" : 0;
        }
        if (message.asset_name_bytes != null && message.hasOwnProperty("asset_name_bytes"))
            object.asset_name_bytes = options.bytes === String ? $util.base64.encode(message.asset_name_bytes, 0, message.asset_name_bytes.length) : options.bytes === Array ? Array.prototype.slice.call(message.asset_name_bytes) : message.asset_name_bytes;
        if (message.amount != null && message.hasOwnProperty("amount"))
            if (typeof message.amount === "number")
                object.amount = options.longs === String ? String(message.amount) : message.amount;
            else
                object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber(true) : message.amount;
        if (message.mint_amount != null && message.hasOwnProperty("mint_amount"))
            if (typeof message.mint_amount === "number")
                object.mint_amount = options.longs === String ? String(message.mint_amount) : message.mint_amount;
            else
                object.mint_amount = options.longs === String ? $util.Long.prototype.toString.call(message.mint_amount) : options.longs === Number ? new $util.LongBits(message.mint_amount.low >>> 0, message.mint_amount.high >>> 0).toNumber() : message.mint_amount;
        return object;
    };

    CardanoToken.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoToken;
})();

$root.CardanoTxInlineDatumChunk = (function() {

    function CardanoTxInlineDatumChunk(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoTxInlineDatumChunk.prototype.data = $util.newBuffer([]);

    CardanoTxInlineDatumChunk.create = function create(properties) {
        return new CardanoTxInlineDatumChunk(properties);
    };

    CardanoTxInlineDatumChunk.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.data);
        return writer;
    };

    CardanoTxInlineDatumChunk.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoTxInlineDatumChunk.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoTxInlineDatumChunk();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.data = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("data"))
            throw $util.ProtocolError("missing required 'data'", { instance: message });
        return message;
    };

    CardanoTxInlineDatumChunk.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoTxInlineDatumChunk.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
            return "data: buffer expected";
        return null;
    };

    CardanoTxInlineDatumChunk.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoTxInlineDatumChunk)
            return object;
        var message = new $root.CardanoTxInlineDatumChunk();
        if (object.data != null)
            if (typeof object.data === "string")
                $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
            else if (object.data.length)
                message.data = object.data;
        return message;
    };

    CardanoTxInlineDatumChunk.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.data = "";
            else {
                object.data = [];
                if (options.bytes !== Array)
                    object.data = $util.newBuffer(object.data);
            }
        if (message.data != null && message.hasOwnProperty("data"))
            object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
        return object;
    };

    CardanoTxInlineDatumChunk.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoTxInlineDatumChunk;
})();

$root.CardanoTxReferenceScriptChunk = (function() {

    function CardanoTxReferenceScriptChunk(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoTxReferenceScriptChunk.prototype.data = $util.newBuffer([]);

    CardanoTxReferenceScriptChunk.create = function create(properties) {
        return new CardanoTxReferenceScriptChunk(properties);
    };

    CardanoTxReferenceScriptChunk.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.data);
        return writer;
    };

    CardanoTxReferenceScriptChunk.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoTxReferenceScriptChunk.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoTxReferenceScriptChunk();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.data = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("data"))
            throw $util.ProtocolError("missing required 'data'", { instance: message });
        return message;
    };

    CardanoTxReferenceScriptChunk.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoTxReferenceScriptChunk.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
            return "data: buffer expected";
        return null;
    };

    CardanoTxReferenceScriptChunk.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoTxReferenceScriptChunk)
            return object;
        var message = new $root.CardanoTxReferenceScriptChunk();
        if (object.data != null)
            if (typeof object.data === "string")
                $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
            else if (object.data.length)
                message.data = object.data;
        return message;
    };

    CardanoTxReferenceScriptChunk.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.data = "";
            else {
                object.data = [];
                if (options.bytes !== Array)
                    object.data = $util.newBuffer(object.data);
            }
        if (message.data != null && message.hasOwnProperty("data"))
            object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
        return object;
    };

    CardanoTxReferenceScriptChunk.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoTxReferenceScriptChunk;
})();

$root.CardanoPoolOwner = (function() {

    function CardanoPoolOwner(properties) {
        this.staking_key_path = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoPoolOwner.prototype.staking_key_path = $util.emptyArray;
    CardanoPoolOwner.prototype.staking_key_hash = $util.newBuffer([]);

    CardanoPoolOwner.create = function create(properties) {
        return new CardanoPoolOwner(properties);
    };

    CardanoPoolOwner.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.staking_key_path != null && message.staking_key_path.length)
            for (var i = 0; i < message.staking_key_path.length; ++i)
                writer.uint32(8).uint32(message.staking_key_path[i]);
        if (message.staking_key_hash != null && Object.hasOwnProperty.call(message, "staking_key_hash"))
            writer.uint32(18).bytes(message.staking_key_hash);
        return writer;
    };

    CardanoPoolOwner.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoPoolOwner.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoPoolOwner();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.staking_key_path && message.staking_key_path.length))
                    message.staking_key_path = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.staking_key_path.push(reader.uint32());
                } else
                    message.staking_key_path.push(reader.uint32());
                break;
            case 2:
                message.staking_key_hash = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    CardanoPoolOwner.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoPoolOwner.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.staking_key_path != null && message.hasOwnProperty("staking_key_path")) {
            if (!Array.isArray(message.staking_key_path))
                return "staking_key_path: array expected";
            for (var i = 0; i < message.staking_key_path.length; ++i)
                if (!$util.isInteger(message.staking_key_path[i]))
                    return "staking_key_path: integer[] expected";
        }
        if (message.staking_key_hash != null && message.hasOwnProperty("staking_key_hash"))
            if (!(message.staking_key_hash && typeof message.staking_key_hash.length === "number" || $util.isString(message.staking_key_hash)))
                return "staking_key_hash: buffer expected";
        return null;
    };

    CardanoPoolOwner.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoPoolOwner)
            return object;
        var message = new $root.CardanoPoolOwner();
        if (object.staking_key_path) {
            if (!Array.isArray(object.staking_key_path))
                throw TypeError(".CardanoPoolOwner.staking_key_path: array expected");
            message.staking_key_path = [];
            for (var i = 0; i < object.staking_key_path.length; ++i)
                message.staking_key_path[i] = object.staking_key_path[i] >>> 0;
        }
        if (object.staking_key_hash != null)
            if (typeof object.staking_key_hash === "string")
                $util.base64.decode(object.staking_key_hash, message.staking_key_hash = $util.newBuffer($util.base64.length(object.staking_key_hash)), 0);
            else if (object.staking_key_hash.length)
                message.staking_key_hash = object.staking_key_hash;
        return message;
    };

    CardanoPoolOwner.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.staking_key_path = [];
        if (options.defaults)
            if (options.bytes === String)
                object.staking_key_hash = "";
            else {
                object.staking_key_hash = [];
                if (options.bytes !== Array)
                    object.staking_key_hash = $util.newBuffer(object.staking_key_hash);
            }
        if (message.staking_key_path && message.staking_key_path.length) {
            object.staking_key_path = [];
            for (var j = 0; j < message.staking_key_path.length; ++j)
                object.staking_key_path[j] = message.staking_key_path[j];
        }
        if (message.staking_key_hash != null && message.hasOwnProperty("staking_key_hash"))
            object.staking_key_hash = options.bytes === String ? $util.base64.encode(message.staking_key_hash, 0, message.staking_key_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.staking_key_hash) : message.staking_key_hash;
        return object;
    };

    CardanoPoolOwner.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoPoolOwner;
})();

$root.CardanoPoolRelayParameters = (function() {

    function CardanoPoolRelayParameters(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoPoolRelayParameters.prototype.type = 0;
    CardanoPoolRelayParameters.prototype.ipv4_address = $util.newBuffer([]);
    CardanoPoolRelayParameters.prototype.ipv6_address = $util.newBuffer([]);
    CardanoPoolRelayParameters.prototype.host_name = "";
    CardanoPoolRelayParameters.prototype.port = 0;

    CardanoPoolRelayParameters.create = function create(properties) {
        return new CardanoPoolRelayParameters(properties);
    };

    CardanoPoolRelayParameters.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).int32(message.type);
        if (message.ipv4_address != null && Object.hasOwnProperty.call(message, "ipv4_address"))
            writer.uint32(18).bytes(message.ipv4_address);
        if (message.ipv6_address != null && Object.hasOwnProperty.call(message, "ipv6_address"))
            writer.uint32(26).bytes(message.ipv6_address);
        if (message.host_name != null && Object.hasOwnProperty.call(message, "host_name"))
            writer.uint32(34).string(message.host_name);
        if (message.port != null && Object.hasOwnProperty.call(message, "port"))
            writer.uint32(40).uint32(message.port);
        return writer;
    };

    CardanoPoolRelayParameters.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoPoolRelayParameters.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoPoolRelayParameters();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.type = reader.int32();
                break;
            case 2:
                message.ipv4_address = reader.bytes();
                break;
            case 3:
                message.ipv6_address = reader.bytes();
                break;
            case 4:
                message.host_name = reader.string();
                break;
            case 5:
                message.port = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("type"))
            throw $util.ProtocolError("missing required 'type'", { instance: message });
        return message;
    };

    CardanoPoolRelayParameters.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoPoolRelayParameters.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        switch (message.type) {
        default:
            return "type: enum value expected";
        case 0:
        case 1:
        case 2:
            break;
        }
        if (message.ipv4_address != null && message.hasOwnProperty("ipv4_address"))
            if (!(message.ipv4_address && typeof message.ipv4_address.length === "number" || $util.isString(message.ipv4_address)))
                return "ipv4_address: buffer expected";
        if (message.ipv6_address != null && message.hasOwnProperty("ipv6_address"))
            if (!(message.ipv6_address && typeof message.ipv6_address.length === "number" || $util.isString(message.ipv6_address)))
                return "ipv6_address: buffer expected";
        if (message.host_name != null && message.hasOwnProperty("host_name"))
            if (!$util.isString(message.host_name))
                return "host_name: string expected";
        if (message.port != null && message.hasOwnProperty("port"))
            if (!$util.isInteger(message.port))
                return "port: integer expected";
        return null;
    };

    CardanoPoolRelayParameters.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoPoolRelayParameters)
            return object;
        var message = new $root.CardanoPoolRelayParameters();
        switch (object.type) {
        case "SINGLE_HOST_IP":
        case 0:
            message.type = 0;
            break;
        case "SINGLE_HOST_NAME":
        case 1:
            message.type = 1;
            break;
        case "MULTIPLE_HOST_NAME":
        case 2:
            message.type = 2;
            break;
        }
        if (object.ipv4_address != null)
            if (typeof object.ipv4_address === "string")
                $util.base64.decode(object.ipv4_address, message.ipv4_address = $util.newBuffer($util.base64.length(object.ipv4_address)), 0);
            else if (object.ipv4_address.length)
                message.ipv4_address = object.ipv4_address;
        if (object.ipv6_address != null)
            if (typeof object.ipv6_address === "string")
                $util.base64.decode(object.ipv6_address, message.ipv6_address = $util.newBuffer($util.base64.length(object.ipv6_address)), 0);
            else if (object.ipv6_address.length)
                message.ipv6_address = object.ipv6_address;
        if (object.host_name != null)
            message.host_name = String(object.host_name);
        if (object.port != null)
            message.port = object.port >>> 0;
        return message;
    };

    CardanoPoolRelayParameters.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.type = options.enums === String ? "SINGLE_HOST_IP" : 0;
            if (options.bytes === String)
                object.ipv4_address = "";
            else {
                object.ipv4_address = [];
                if (options.bytes !== Array)
                    object.ipv4_address = $util.newBuffer(object.ipv4_address);
            }
            if (options.bytes === String)
                object.ipv6_address = "";
            else {
                object.ipv6_address = [];
                if (options.bytes !== Array)
                    object.ipv6_address = $util.newBuffer(object.ipv6_address);
            }
            object.host_name = "";
            object.port = 0;
        }
        if (message.type != null && message.hasOwnProperty("type"))
            object.type = options.enums === String ? $root.CardanoPoolRelayType[message.type] : message.type;
        if (message.ipv4_address != null && message.hasOwnProperty("ipv4_address"))
            object.ipv4_address = options.bytes === String ? $util.base64.encode(message.ipv4_address, 0, message.ipv4_address.length) : options.bytes === Array ? Array.prototype.slice.call(message.ipv4_address) : message.ipv4_address;
        if (message.ipv6_address != null && message.hasOwnProperty("ipv6_address"))
            object.ipv6_address = options.bytes === String ? $util.base64.encode(message.ipv6_address, 0, message.ipv6_address.length) : options.bytes === Array ? Array.prototype.slice.call(message.ipv6_address) : message.ipv6_address;
        if (message.host_name != null && message.hasOwnProperty("host_name"))
            object.host_name = message.host_name;
        if (message.port != null && message.hasOwnProperty("port"))
            object.port = message.port;
        return object;
    };

    CardanoPoolRelayParameters.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoPoolRelayParameters;
})();

$root.CardanoPoolMetadataType = (function() {

    function CardanoPoolMetadataType(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoPoolMetadataType.prototype.url = "";
    CardanoPoolMetadataType.prototype.hash = $util.newBuffer([]);

    CardanoPoolMetadataType.create = function create(properties) {
        return new CardanoPoolMetadataType(properties);
    };

    CardanoPoolMetadataType.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.url);
        writer.uint32(18).bytes(message.hash);
        return writer;
    };

    CardanoPoolMetadataType.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoPoolMetadataType.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoPoolMetadataType();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.url = reader.string();
                break;
            case 2:
                message.hash = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("url"))
            throw $util.ProtocolError("missing required 'url'", { instance: message });
        if (!message.hasOwnProperty("hash"))
            throw $util.ProtocolError("missing required 'hash'", { instance: message });
        return message;
    };

    CardanoPoolMetadataType.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoPoolMetadataType.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.url))
            return "url: string expected";
        if (!(message.hash && typeof message.hash.length === "number" || $util.isString(message.hash)))
            return "hash: buffer expected";
        return null;
    };

    CardanoPoolMetadataType.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoPoolMetadataType)
            return object;
        var message = new $root.CardanoPoolMetadataType();
        if (object.url != null)
            message.url = String(object.url);
        if (object.hash != null)
            if (typeof object.hash === "string")
                $util.base64.decode(object.hash, message.hash = $util.newBuffer($util.base64.length(object.hash)), 0);
            else if (object.hash.length)
                message.hash = object.hash;
        return message;
    };

    CardanoPoolMetadataType.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.url = "";
            if (options.bytes === String)
                object.hash = "";
            else {
                object.hash = [];
                if (options.bytes !== Array)
                    object.hash = $util.newBuffer(object.hash);
            }
        }
        if (message.url != null && message.hasOwnProperty("url"))
            object.url = message.url;
        if (message.hash != null && message.hasOwnProperty("hash"))
            object.hash = options.bytes === String ? $util.base64.encode(message.hash, 0, message.hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.hash) : message.hash;
        return object;
    };

    CardanoPoolMetadataType.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoPoolMetadataType;
})();

$root.CardanoPoolParametersType = (function() {

    function CardanoPoolParametersType(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoPoolParametersType.prototype.pool_id = $util.newBuffer([]);
    CardanoPoolParametersType.prototype.vrf_key_hash = $util.newBuffer([]);
    CardanoPoolParametersType.prototype.pledge = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    CardanoPoolParametersType.prototype.cost = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    CardanoPoolParametersType.prototype.margin_numerator = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    CardanoPoolParametersType.prototype.margin_denominator = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    CardanoPoolParametersType.prototype.reward_account = "";
    CardanoPoolParametersType.prototype.metadata = null;
    CardanoPoolParametersType.prototype.owners_count = 0;
    CardanoPoolParametersType.prototype.relays_count = 0;

    CardanoPoolParametersType.create = function create(properties) {
        return new CardanoPoolParametersType(properties);
    };

    CardanoPoolParametersType.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.pool_id);
        writer.uint32(18).bytes(message.vrf_key_hash);
        writer.uint32(24).uint64(message.pledge);
        writer.uint32(32).uint64(message.cost);
        writer.uint32(40).uint64(message.margin_numerator);
        writer.uint32(48).uint64(message.margin_denominator);
        writer.uint32(58).string(message.reward_account);
        if (message.metadata != null && Object.hasOwnProperty.call(message, "metadata"))
            $root.CardanoPoolMetadataType.encode(message.metadata, writer.uint32(82).fork()).ldelim();
        writer.uint32(88).uint32(message.owners_count);
        writer.uint32(96).uint32(message.relays_count);
        return writer;
    };

    CardanoPoolParametersType.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoPoolParametersType.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoPoolParametersType();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.pool_id = reader.bytes();
                break;
            case 2:
                message.vrf_key_hash = reader.bytes();
                break;
            case 3:
                message.pledge = reader.uint64();
                break;
            case 4:
                message.cost = reader.uint64();
                break;
            case 5:
                message.margin_numerator = reader.uint64();
                break;
            case 6:
                message.margin_denominator = reader.uint64();
                break;
            case 7:
                message.reward_account = reader.string();
                break;
            case 10:
                message.metadata = $root.CardanoPoolMetadataType.decode(reader, reader.uint32());
                break;
            case 11:
                message.owners_count = reader.uint32();
                break;
            case 12:
                message.relays_count = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("pool_id"))
            throw $util.ProtocolError("missing required 'pool_id'", { instance: message });
        if (!message.hasOwnProperty("vrf_key_hash"))
            throw $util.ProtocolError("missing required 'vrf_key_hash'", { instance: message });
        if (!message.hasOwnProperty("pledge"))
            throw $util.ProtocolError("missing required 'pledge'", { instance: message });
        if (!message.hasOwnProperty("cost"))
            throw $util.ProtocolError("missing required 'cost'", { instance: message });
        if (!message.hasOwnProperty("margin_numerator"))
            throw $util.ProtocolError("missing required 'margin_numerator'", { instance: message });
        if (!message.hasOwnProperty("margin_denominator"))
            throw $util.ProtocolError("missing required 'margin_denominator'", { instance: message });
        if (!message.hasOwnProperty("reward_account"))
            throw $util.ProtocolError("missing required 'reward_account'", { instance: message });
        if (!message.hasOwnProperty("owners_count"))
            throw $util.ProtocolError("missing required 'owners_count'", { instance: message });
        if (!message.hasOwnProperty("relays_count"))
            throw $util.ProtocolError("missing required 'relays_count'", { instance: message });
        return message;
    };

    CardanoPoolParametersType.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoPoolParametersType.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.pool_id && typeof message.pool_id.length === "number" || $util.isString(message.pool_id)))
            return "pool_id: buffer expected";
        if (!(message.vrf_key_hash && typeof message.vrf_key_hash.length === "number" || $util.isString(message.vrf_key_hash)))
            return "vrf_key_hash: buffer expected";
        if (!$util.isInteger(message.pledge) && !(message.pledge && $util.isInteger(message.pledge.low) && $util.isInteger(message.pledge.high)))
            return "pledge: integer|Long expected";
        if (!$util.isInteger(message.cost) && !(message.cost && $util.isInteger(message.cost.low) && $util.isInteger(message.cost.high)))
            return "cost: integer|Long expected";
        if (!$util.isInteger(message.margin_numerator) && !(message.margin_numerator && $util.isInteger(message.margin_numerator.low) && $util.isInteger(message.margin_numerator.high)))
            return "margin_numerator: integer|Long expected";
        if (!$util.isInteger(message.margin_denominator) && !(message.margin_denominator && $util.isInteger(message.margin_denominator.low) && $util.isInteger(message.margin_denominator.high)))
            return "margin_denominator: integer|Long expected";
        if (!$util.isString(message.reward_account))
            return "reward_account: string expected";
        if (message.metadata != null && message.hasOwnProperty("metadata")) {
            var error = $root.CardanoPoolMetadataType.verify(message.metadata);
            if (error)
                return "metadata." + error;
        }
        if (!$util.isInteger(message.owners_count))
            return "owners_count: integer expected";
        if (!$util.isInteger(message.relays_count))
            return "relays_count: integer expected";
        return null;
    };

    CardanoPoolParametersType.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoPoolParametersType)
            return object;
        var message = new $root.CardanoPoolParametersType();
        if (object.pool_id != null)
            if (typeof object.pool_id === "string")
                $util.base64.decode(object.pool_id, message.pool_id = $util.newBuffer($util.base64.length(object.pool_id)), 0);
            else if (object.pool_id.length)
                message.pool_id = object.pool_id;
        if (object.vrf_key_hash != null)
            if (typeof object.vrf_key_hash === "string")
                $util.base64.decode(object.vrf_key_hash, message.vrf_key_hash = $util.newBuffer($util.base64.length(object.vrf_key_hash)), 0);
            else if (object.vrf_key_hash.length)
                message.vrf_key_hash = object.vrf_key_hash;
        if (object.pledge != null)
            if ($util.Long)
                (message.pledge = $util.Long.fromValue(object.pledge)).unsigned = true;
            else if (typeof object.pledge === "string")
                message.pledge = parseInt(object.pledge, 10);
            else if (typeof object.pledge === "number")
                message.pledge = object.pledge;
            else if (typeof object.pledge === "object")
                message.pledge = new $util.LongBits(object.pledge.low >>> 0, object.pledge.high >>> 0).toNumber(true);
        if (object.cost != null)
            if ($util.Long)
                (message.cost = $util.Long.fromValue(object.cost)).unsigned = true;
            else if (typeof object.cost === "string")
                message.cost = parseInt(object.cost, 10);
            else if (typeof object.cost === "number")
                message.cost = object.cost;
            else if (typeof object.cost === "object")
                message.cost = new $util.LongBits(object.cost.low >>> 0, object.cost.high >>> 0).toNumber(true);
        if (object.margin_numerator != null)
            if ($util.Long)
                (message.margin_numerator = $util.Long.fromValue(object.margin_numerator)).unsigned = true;
            else if (typeof object.margin_numerator === "string")
                message.margin_numerator = parseInt(object.margin_numerator, 10);
            else if (typeof object.margin_numerator === "number")
                message.margin_numerator = object.margin_numerator;
            else if (typeof object.margin_numerator === "object")
                message.margin_numerator = new $util.LongBits(object.margin_numerator.low >>> 0, object.margin_numerator.high >>> 0).toNumber(true);
        if (object.margin_denominator != null)
            if ($util.Long)
                (message.margin_denominator = $util.Long.fromValue(object.margin_denominator)).unsigned = true;
            else if (typeof object.margin_denominator === "string")
                message.margin_denominator = parseInt(object.margin_denominator, 10);
            else if (typeof object.margin_denominator === "number")
                message.margin_denominator = object.margin_denominator;
            else if (typeof object.margin_denominator === "object")
                message.margin_denominator = new $util.LongBits(object.margin_denominator.low >>> 0, object.margin_denominator.high >>> 0).toNumber(true);
        if (object.reward_account != null)
            message.reward_account = String(object.reward_account);
        if (object.metadata != null) {
            if (typeof object.metadata !== "object")
                throw TypeError(".CardanoPoolParametersType.metadata: object expected");
            message.metadata = $root.CardanoPoolMetadataType.fromObject(object.metadata);
        }
        if (object.owners_count != null)
            message.owners_count = object.owners_count >>> 0;
        if (object.relays_count != null)
            message.relays_count = object.relays_count >>> 0;
        return message;
    };

    CardanoPoolParametersType.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.pool_id = "";
            else {
                object.pool_id = [];
                if (options.bytes !== Array)
                    object.pool_id = $util.newBuffer(object.pool_id);
            }
            if (options.bytes === String)
                object.vrf_key_hash = "";
            else {
                object.vrf_key_hash = [];
                if (options.bytes !== Array)
                    object.vrf_key_hash = $util.newBuffer(object.vrf_key_hash);
            }
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.pledge = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.pledge = options.longs === String ? "0" : 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.cost = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.cost = options.longs === String ? "0" : 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.margin_numerator = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.margin_numerator = options.longs === String ? "0" : 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.margin_denominator = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.margin_denominator = options.longs === String ? "0" : 0;
            object.reward_account = "";
            object.metadata = null;
            object.owners_count = 0;
            object.relays_count = 0;
        }
        if (message.pool_id != null && message.hasOwnProperty("pool_id"))
            object.pool_id = options.bytes === String ? $util.base64.encode(message.pool_id, 0, message.pool_id.length) : options.bytes === Array ? Array.prototype.slice.call(message.pool_id) : message.pool_id;
        if (message.vrf_key_hash != null && message.hasOwnProperty("vrf_key_hash"))
            object.vrf_key_hash = options.bytes === String ? $util.base64.encode(message.vrf_key_hash, 0, message.vrf_key_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.vrf_key_hash) : message.vrf_key_hash;
        if (message.pledge != null && message.hasOwnProperty("pledge"))
            if (typeof message.pledge === "number")
                object.pledge = options.longs === String ? String(message.pledge) : message.pledge;
            else
                object.pledge = options.longs === String ? $util.Long.prototype.toString.call(message.pledge) : options.longs === Number ? new $util.LongBits(message.pledge.low >>> 0, message.pledge.high >>> 0).toNumber(true) : message.pledge;
        if (message.cost != null && message.hasOwnProperty("cost"))
            if (typeof message.cost === "number")
                object.cost = options.longs === String ? String(message.cost) : message.cost;
            else
                object.cost = options.longs === String ? $util.Long.prototype.toString.call(message.cost) : options.longs === Number ? new $util.LongBits(message.cost.low >>> 0, message.cost.high >>> 0).toNumber(true) : message.cost;
        if (message.margin_numerator != null && message.hasOwnProperty("margin_numerator"))
            if (typeof message.margin_numerator === "number")
                object.margin_numerator = options.longs === String ? String(message.margin_numerator) : message.margin_numerator;
            else
                object.margin_numerator = options.longs === String ? $util.Long.prototype.toString.call(message.margin_numerator) : options.longs === Number ? new $util.LongBits(message.margin_numerator.low >>> 0, message.margin_numerator.high >>> 0).toNumber(true) : message.margin_numerator;
        if (message.margin_denominator != null && message.hasOwnProperty("margin_denominator"))
            if (typeof message.margin_denominator === "number")
                object.margin_denominator = options.longs === String ? String(message.margin_denominator) : message.margin_denominator;
            else
                object.margin_denominator = options.longs === String ? $util.Long.prototype.toString.call(message.margin_denominator) : options.longs === Number ? new $util.LongBits(message.margin_denominator.low >>> 0, message.margin_denominator.high >>> 0).toNumber(true) : message.margin_denominator;
        if (message.reward_account != null && message.hasOwnProperty("reward_account"))
            object.reward_account = message.reward_account;
        if (message.metadata != null && message.hasOwnProperty("metadata"))
            object.metadata = $root.CardanoPoolMetadataType.toObject(message.metadata, options);
        if (message.owners_count != null && message.hasOwnProperty("owners_count"))
            object.owners_count = message.owners_count;
        if (message.relays_count != null && message.hasOwnProperty("relays_count"))
            object.relays_count = message.relays_count;
        return object;
    };

    CardanoPoolParametersType.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoPoolParametersType;
})();

$root.CardanoTxCertificate = (function() {

    function CardanoTxCertificate(properties) {
        this.path = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoTxCertificate.prototype.type = 0;
    CardanoTxCertificate.prototype.path = $util.emptyArray;
    CardanoTxCertificate.prototype.pool = $util.newBuffer([]);
    CardanoTxCertificate.prototype.pool_parameters = null;
    CardanoTxCertificate.prototype.script_hash = $util.newBuffer([]);
    CardanoTxCertificate.prototype.key_hash = $util.newBuffer([]);

    CardanoTxCertificate.create = function create(properties) {
        return new CardanoTxCertificate(properties);
    };

    CardanoTxCertificate.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).int32(message.type);
        if (message.path != null && message.path.length)
            for (var i = 0; i < message.path.length; ++i)
                writer.uint32(16).uint32(message.path[i]);
        if (message.pool != null && Object.hasOwnProperty.call(message, "pool"))
            writer.uint32(26).bytes(message.pool);
        if (message.pool_parameters != null && Object.hasOwnProperty.call(message, "pool_parameters"))
            $root.CardanoPoolParametersType.encode(message.pool_parameters, writer.uint32(34).fork()).ldelim();
        if (message.script_hash != null && Object.hasOwnProperty.call(message, "script_hash"))
            writer.uint32(42).bytes(message.script_hash);
        if (message.key_hash != null && Object.hasOwnProperty.call(message, "key_hash"))
            writer.uint32(50).bytes(message.key_hash);
        return writer;
    };

    CardanoTxCertificate.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoTxCertificate.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoTxCertificate();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.type = reader.int32();
                break;
            case 2:
                if (!(message.path && message.path.length))
                    message.path = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.path.push(reader.uint32());
                } else
                    message.path.push(reader.uint32());
                break;
            case 3:
                message.pool = reader.bytes();
                break;
            case 4:
                message.pool_parameters = $root.CardanoPoolParametersType.decode(reader, reader.uint32());
                break;
            case 5:
                message.script_hash = reader.bytes();
                break;
            case 6:
                message.key_hash = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("type"))
            throw $util.ProtocolError("missing required 'type'", { instance: message });
        return message;
    };

    CardanoTxCertificate.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoTxCertificate.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        switch (message.type) {
        default:
            return "type: enum value expected";
        case 0:
        case 1:
        case 2:
        case 3:
            break;
        }
        if (message.path != null && message.hasOwnProperty("path")) {
            if (!Array.isArray(message.path))
                return "path: array expected";
            for (var i = 0; i < message.path.length; ++i)
                if (!$util.isInteger(message.path[i]))
                    return "path: integer[] expected";
        }
        if (message.pool != null && message.hasOwnProperty("pool"))
            if (!(message.pool && typeof message.pool.length === "number" || $util.isString(message.pool)))
                return "pool: buffer expected";
        if (message.pool_parameters != null && message.hasOwnProperty("pool_parameters")) {
            var error = $root.CardanoPoolParametersType.verify(message.pool_parameters);
            if (error)
                return "pool_parameters." + error;
        }
        if (message.script_hash != null && message.hasOwnProperty("script_hash"))
            if (!(message.script_hash && typeof message.script_hash.length === "number" || $util.isString(message.script_hash)))
                return "script_hash: buffer expected";
        if (message.key_hash != null && message.hasOwnProperty("key_hash"))
            if (!(message.key_hash && typeof message.key_hash.length === "number" || $util.isString(message.key_hash)))
                return "key_hash: buffer expected";
        return null;
    };

    CardanoTxCertificate.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoTxCertificate)
            return object;
        var message = new $root.CardanoTxCertificate();
        switch (object.type) {
        case "STAKE_REGISTRATION":
        case 0:
            message.type = 0;
            break;
        case "STAKE_DEREGISTRATION":
        case 1:
            message.type = 1;
            break;
        case "STAKE_DELEGATION":
        case 2:
            message.type = 2;
            break;
        case "STAKE_POOL_REGISTRATION":
        case 3:
            message.type = 3;
            break;
        }
        if (object.path) {
            if (!Array.isArray(object.path))
                throw TypeError(".CardanoTxCertificate.path: array expected");
            message.path = [];
            for (var i = 0; i < object.path.length; ++i)
                message.path[i] = object.path[i] >>> 0;
        }
        if (object.pool != null)
            if (typeof object.pool === "string")
                $util.base64.decode(object.pool, message.pool = $util.newBuffer($util.base64.length(object.pool)), 0);
            else if (object.pool.length)
                message.pool = object.pool;
        if (object.pool_parameters != null) {
            if (typeof object.pool_parameters !== "object")
                throw TypeError(".CardanoTxCertificate.pool_parameters: object expected");
            message.pool_parameters = $root.CardanoPoolParametersType.fromObject(object.pool_parameters);
        }
        if (object.script_hash != null)
            if (typeof object.script_hash === "string")
                $util.base64.decode(object.script_hash, message.script_hash = $util.newBuffer($util.base64.length(object.script_hash)), 0);
            else if (object.script_hash.length)
                message.script_hash = object.script_hash;
        if (object.key_hash != null)
            if (typeof object.key_hash === "string")
                $util.base64.decode(object.key_hash, message.key_hash = $util.newBuffer($util.base64.length(object.key_hash)), 0);
            else if (object.key_hash.length)
                message.key_hash = object.key_hash;
        return message;
    };

    CardanoTxCertificate.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.path = [];
        if (options.defaults) {
            object.type = options.enums === String ? "STAKE_REGISTRATION" : 0;
            if (options.bytes === String)
                object.pool = "";
            else {
                object.pool = [];
                if (options.bytes !== Array)
                    object.pool = $util.newBuffer(object.pool);
            }
            object.pool_parameters = null;
            if (options.bytes === String)
                object.script_hash = "";
            else {
                object.script_hash = [];
                if (options.bytes !== Array)
                    object.script_hash = $util.newBuffer(object.script_hash);
            }
            if (options.bytes === String)
                object.key_hash = "";
            else {
                object.key_hash = [];
                if (options.bytes !== Array)
                    object.key_hash = $util.newBuffer(object.key_hash);
            }
        }
        if (message.type != null && message.hasOwnProperty("type"))
            object.type = options.enums === String ? $root.CardanoCertificateType[message.type] : message.type;
        if (message.path && message.path.length) {
            object.path = [];
            for (var j = 0; j < message.path.length; ++j)
                object.path[j] = message.path[j];
        }
        if (message.pool != null && message.hasOwnProperty("pool"))
            object.pool = options.bytes === String ? $util.base64.encode(message.pool, 0, message.pool.length) : options.bytes === Array ? Array.prototype.slice.call(message.pool) : message.pool;
        if (message.pool_parameters != null && message.hasOwnProperty("pool_parameters"))
            object.pool_parameters = $root.CardanoPoolParametersType.toObject(message.pool_parameters, options);
        if (message.script_hash != null && message.hasOwnProperty("script_hash"))
            object.script_hash = options.bytes === String ? $util.base64.encode(message.script_hash, 0, message.script_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.script_hash) : message.script_hash;
        if (message.key_hash != null && message.hasOwnProperty("key_hash"))
            object.key_hash = options.bytes === String ? $util.base64.encode(message.key_hash, 0, message.key_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.key_hash) : message.key_hash;
        return object;
    };

    CardanoTxCertificate.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoTxCertificate;
})();

$root.CardanoTxWithdrawal = (function() {

    function CardanoTxWithdrawal(properties) {
        this.path = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoTxWithdrawal.prototype.path = $util.emptyArray;
    CardanoTxWithdrawal.prototype.amount = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    CardanoTxWithdrawal.prototype.script_hash = $util.newBuffer([]);
    CardanoTxWithdrawal.prototype.key_hash = $util.newBuffer([]);

    CardanoTxWithdrawal.create = function create(properties) {
        return new CardanoTxWithdrawal(properties);
    };

    CardanoTxWithdrawal.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.path != null && message.path.length)
            for (var i = 0; i < message.path.length; ++i)
                writer.uint32(8).uint32(message.path[i]);
        writer.uint32(16).uint64(message.amount);
        if (message.script_hash != null && Object.hasOwnProperty.call(message, "script_hash"))
            writer.uint32(26).bytes(message.script_hash);
        if (message.key_hash != null && Object.hasOwnProperty.call(message, "key_hash"))
            writer.uint32(34).bytes(message.key_hash);
        return writer;
    };

    CardanoTxWithdrawal.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoTxWithdrawal.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoTxWithdrawal();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.path && message.path.length))
                    message.path = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.path.push(reader.uint32());
                } else
                    message.path.push(reader.uint32());
                break;
            case 2:
                message.amount = reader.uint64();
                break;
            case 3:
                message.script_hash = reader.bytes();
                break;
            case 4:
                message.key_hash = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("amount"))
            throw $util.ProtocolError("missing required 'amount'", { instance: message });
        return message;
    };

    CardanoTxWithdrawal.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoTxWithdrawal.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.path != null && message.hasOwnProperty("path")) {
            if (!Array.isArray(message.path))
                return "path: array expected";
            for (var i = 0; i < message.path.length; ++i)
                if (!$util.isInteger(message.path[i]))
                    return "path: integer[] expected";
        }
        if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
            return "amount: integer|Long expected";
        if (message.script_hash != null && message.hasOwnProperty("script_hash"))
            if (!(message.script_hash && typeof message.script_hash.length === "number" || $util.isString(message.script_hash)))
                return "script_hash: buffer expected";
        if (message.key_hash != null && message.hasOwnProperty("key_hash"))
            if (!(message.key_hash && typeof message.key_hash.length === "number" || $util.isString(message.key_hash)))
                return "key_hash: buffer expected";
        return null;
    };

    CardanoTxWithdrawal.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoTxWithdrawal)
            return object;
        var message = new $root.CardanoTxWithdrawal();
        if (object.path) {
            if (!Array.isArray(object.path))
                throw TypeError(".CardanoTxWithdrawal.path: array expected");
            message.path = [];
            for (var i = 0; i < object.path.length; ++i)
                message.path[i] = object.path[i] >>> 0;
        }
        if (object.amount != null)
            if ($util.Long)
                (message.amount = $util.Long.fromValue(object.amount)).unsigned = true;
            else if (typeof object.amount === "string")
                message.amount = parseInt(object.amount, 10);
            else if (typeof object.amount === "number")
                message.amount = object.amount;
            else if (typeof object.amount === "object")
                message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber(true);
        if (object.script_hash != null)
            if (typeof object.script_hash === "string")
                $util.base64.decode(object.script_hash, message.script_hash = $util.newBuffer($util.base64.length(object.script_hash)), 0);
            else if (object.script_hash.length)
                message.script_hash = object.script_hash;
        if (object.key_hash != null)
            if (typeof object.key_hash === "string")
                $util.base64.decode(object.key_hash, message.key_hash = $util.newBuffer($util.base64.length(object.key_hash)), 0);
            else if (object.key_hash.length)
                message.key_hash = object.key_hash;
        return message;
    };

    CardanoTxWithdrawal.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.path = [];
        if (options.defaults) {
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.amount = options.longs === String ? "0" : 0;
            if (options.bytes === String)
                object.script_hash = "";
            else {
                object.script_hash = [];
                if (options.bytes !== Array)
                    object.script_hash = $util.newBuffer(object.script_hash);
            }
            if (options.bytes === String)
                object.key_hash = "";
            else {
                object.key_hash = [];
                if (options.bytes !== Array)
                    object.key_hash = $util.newBuffer(object.key_hash);
            }
        }
        if (message.path && message.path.length) {
            object.path = [];
            for (var j = 0; j < message.path.length; ++j)
                object.path[j] = message.path[j];
        }
        if (message.amount != null && message.hasOwnProperty("amount"))
            if (typeof message.amount === "number")
                object.amount = options.longs === String ? String(message.amount) : message.amount;
            else
                object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber(true) : message.amount;
        if (message.script_hash != null && message.hasOwnProperty("script_hash"))
            object.script_hash = options.bytes === String ? $util.base64.encode(message.script_hash, 0, message.script_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.script_hash) : message.script_hash;
        if (message.key_hash != null && message.hasOwnProperty("key_hash"))
            object.key_hash = options.bytes === String ? $util.base64.encode(message.key_hash, 0, message.key_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.key_hash) : message.key_hash;
        return object;
    };

    CardanoTxWithdrawal.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoTxWithdrawal;
})();

$root.CardanoGovernanceRegistrationDelegation = (function() {

    function CardanoGovernanceRegistrationDelegation(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoGovernanceRegistrationDelegation.prototype.voting_public_key = $util.newBuffer([]);
    CardanoGovernanceRegistrationDelegation.prototype.weight = 0;

    CardanoGovernanceRegistrationDelegation.create = function create(properties) {
        return new CardanoGovernanceRegistrationDelegation(properties);
    };

    CardanoGovernanceRegistrationDelegation.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.voting_public_key);
        writer.uint32(16).uint32(message.weight);
        return writer;
    };

    CardanoGovernanceRegistrationDelegation.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoGovernanceRegistrationDelegation.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoGovernanceRegistrationDelegation();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.voting_public_key = reader.bytes();
                break;
            case 2:
                message.weight = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("voting_public_key"))
            throw $util.ProtocolError("missing required 'voting_public_key'", { instance: message });
        if (!message.hasOwnProperty("weight"))
            throw $util.ProtocolError("missing required 'weight'", { instance: message });
        return message;
    };

    CardanoGovernanceRegistrationDelegation.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoGovernanceRegistrationDelegation.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.voting_public_key && typeof message.voting_public_key.length === "number" || $util.isString(message.voting_public_key)))
            return "voting_public_key: buffer expected";
        if (!$util.isInteger(message.weight))
            return "weight: integer expected";
        return null;
    };

    CardanoGovernanceRegistrationDelegation.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoGovernanceRegistrationDelegation)
            return object;
        var message = new $root.CardanoGovernanceRegistrationDelegation();
        if (object.voting_public_key != null)
            if (typeof object.voting_public_key === "string")
                $util.base64.decode(object.voting_public_key, message.voting_public_key = $util.newBuffer($util.base64.length(object.voting_public_key)), 0);
            else if (object.voting_public_key.length)
                message.voting_public_key = object.voting_public_key;
        if (object.weight != null)
            message.weight = object.weight >>> 0;
        return message;
    };

    CardanoGovernanceRegistrationDelegation.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.voting_public_key = "";
            else {
                object.voting_public_key = [];
                if (options.bytes !== Array)
                    object.voting_public_key = $util.newBuffer(object.voting_public_key);
            }
            object.weight = 0;
        }
        if (message.voting_public_key != null && message.hasOwnProperty("voting_public_key"))
            object.voting_public_key = options.bytes === String ? $util.base64.encode(message.voting_public_key, 0, message.voting_public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.voting_public_key) : message.voting_public_key;
        if (message.weight != null && message.hasOwnProperty("weight"))
            object.weight = message.weight;
        return object;
    };

    CardanoGovernanceRegistrationDelegation.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoGovernanceRegistrationDelegation;
})();

$root.CardanoGovernanceRegistrationParametersType = (function() {

    function CardanoGovernanceRegistrationParametersType(properties) {
        this.staking_path = [];
        this.delegations = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoGovernanceRegistrationParametersType.prototype.voting_public_key = $util.newBuffer([]);
    CardanoGovernanceRegistrationParametersType.prototype.staking_path = $util.emptyArray;
    CardanoGovernanceRegistrationParametersType.prototype.reward_address_parameters = null;
    CardanoGovernanceRegistrationParametersType.prototype.nonce = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    CardanoGovernanceRegistrationParametersType.prototype.format = 0;
    CardanoGovernanceRegistrationParametersType.prototype.delegations = $util.emptyArray;
    CardanoGovernanceRegistrationParametersType.prototype.voting_purpose = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    CardanoGovernanceRegistrationParametersType.create = function create(properties) {
        return new CardanoGovernanceRegistrationParametersType(properties);
    };

    CardanoGovernanceRegistrationParametersType.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.voting_public_key != null && Object.hasOwnProperty.call(message, "voting_public_key"))
            writer.uint32(10).bytes(message.voting_public_key);
        if (message.staking_path != null && message.staking_path.length)
            for (var i = 0; i < message.staking_path.length; ++i)
                writer.uint32(16).uint32(message.staking_path[i]);
        $root.CardanoAddressParametersType.encode(message.reward_address_parameters, writer.uint32(26).fork()).ldelim();
        writer.uint32(32).uint64(message.nonce);
        if (message.format != null && Object.hasOwnProperty.call(message, "format"))
            writer.uint32(40).int32(message.format);
        if (message.delegations != null && message.delegations.length)
            for (var i = 0; i < message.delegations.length; ++i)
                $root.CardanoGovernanceRegistrationDelegation.encode(message.delegations[i], writer.uint32(50).fork()).ldelim();
        if (message.voting_purpose != null && Object.hasOwnProperty.call(message, "voting_purpose"))
            writer.uint32(56).uint64(message.voting_purpose);
        return writer;
    };

    CardanoGovernanceRegistrationParametersType.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoGovernanceRegistrationParametersType.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoGovernanceRegistrationParametersType();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.voting_public_key = reader.bytes();
                break;
            case 2:
                if (!(message.staking_path && message.staking_path.length))
                    message.staking_path = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.staking_path.push(reader.uint32());
                } else
                    message.staking_path.push(reader.uint32());
                break;
            case 3:
                message.reward_address_parameters = $root.CardanoAddressParametersType.decode(reader, reader.uint32());
                break;
            case 4:
                message.nonce = reader.uint64();
                break;
            case 5:
                message.format = reader.int32();
                break;
            case 6:
                if (!(message.delegations && message.delegations.length))
                    message.delegations = [];
                message.delegations.push($root.CardanoGovernanceRegistrationDelegation.decode(reader, reader.uint32()));
                break;
            case 7:
                message.voting_purpose = reader.uint64();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("reward_address_parameters"))
            throw $util.ProtocolError("missing required 'reward_address_parameters'", { instance: message });
        if (!message.hasOwnProperty("nonce"))
            throw $util.ProtocolError("missing required 'nonce'", { instance: message });
        return message;
    };

    CardanoGovernanceRegistrationParametersType.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoGovernanceRegistrationParametersType.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.voting_public_key != null && message.hasOwnProperty("voting_public_key"))
            if (!(message.voting_public_key && typeof message.voting_public_key.length === "number" || $util.isString(message.voting_public_key)))
                return "voting_public_key: buffer expected";
        if (message.staking_path != null && message.hasOwnProperty("staking_path")) {
            if (!Array.isArray(message.staking_path))
                return "staking_path: array expected";
            for (var i = 0; i < message.staking_path.length; ++i)
                if (!$util.isInteger(message.staking_path[i]))
                    return "staking_path: integer[] expected";
        }
        {
            var error = $root.CardanoAddressParametersType.verify(message.reward_address_parameters);
            if (error)
                return "reward_address_parameters." + error;
        }
        if (!$util.isInteger(message.nonce) && !(message.nonce && $util.isInteger(message.nonce.low) && $util.isInteger(message.nonce.high)))
            return "nonce: integer|Long expected";
        if (message.format != null && message.hasOwnProperty("format"))
            switch (message.format) {
            default:
                return "format: enum value expected";
            case 0:
            case 1:
                break;
            }
        if (message.delegations != null && message.hasOwnProperty("delegations")) {
            if (!Array.isArray(message.delegations))
                return "delegations: array expected";
            for (var i = 0; i < message.delegations.length; ++i) {
                var error = $root.CardanoGovernanceRegistrationDelegation.verify(message.delegations[i]);
                if (error)
                    return "delegations." + error;
            }
        }
        if (message.voting_purpose != null && message.hasOwnProperty("voting_purpose"))
            if (!$util.isInteger(message.voting_purpose) && !(message.voting_purpose && $util.isInteger(message.voting_purpose.low) && $util.isInteger(message.voting_purpose.high)))
                return "voting_purpose: integer|Long expected";
        return null;
    };

    CardanoGovernanceRegistrationParametersType.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoGovernanceRegistrationParametersType)
            return object;
        var message = new $root.CardanoGovernanceRegistrationParametersType();
        if (object.voting_public_key != null)
            if (typeof object.voting_public_key === "string")
                $util.base64.decode(object.voting_public_key, message.voting_public_key = $util.newBuffer($util.base64.length(object.voting_public_key)), 0);
            else if (object.voting_public_key.length)
                message.voting_public_key = object.voting_public_key;
        if (object.staking_path) {
            if (!Array.isArray(object.staking_path))
                throw TypeError(".CardanoGovernanceRegistrationParametersType.staking_path: array expected");
            message.staking_path = [];
            for (var i = 0; i < object.staking_path.length; ++i)
                message.staking_path[i] = object.staking_path[i] >>> 0;
        }
        if (object.reward_address_parameters != null) {
            if (typeof object.reward_address_parameters !== "object")
                throw TypeError(".CardanoGovernanceRegistrationParametersType.reward_address_parameters: object expected");
            message.reward_address_parameters = $root.CardanoAddressParametersType.fromObject(object.reward_address_parameters);
        }
        if (object.nonce != null)
            if ($util.Long)
                (message.nonce = $util.Long.fromValue(object.nonce)).unsigned = true;
            else if (typeof object.nonce === "string")
                message.nonce = parseInt(object.nonce, 10);
            else if (typeof object.nonce === "number")
                message.nonce = object.nonce;
            else if (typeof object.nonce === "object")
                message.nonce = new $util.LongBits(object.nonce.low >>> 0, object.nonce.high >>> 0).toNumber(true);
        switch (object.format) {
        case "CIP15":
        case 0:
            message.format = 0;
            break;
        case "CIP36":
        case 1:
            message.format = 1;
            break;
        }
        if (object.delegations) {
            if (!Array.isArray(object.delegations))
                throw TypeError(".CardanoGovernanceRegistrationParametersType.delegations: array expected");
            message.delegations = [];
            for (var i = 0; i < object.delegations.length; ++i) {
                if (typeof object.delegations[i] !== "object")
                    throw TypeError(".CardanoGovernanceRegistrationParametersType.delegations: object expected");
                message.delegations[i] = $root.CardanoGovernanceRegistrationDelegation.fromObject(object.delegations[i]);
            }
        }
        if (object.voting_purpose != null)
            if ($util.Long)
                (message.voting_purpose = $util.Long.fromValue(object.voting_purpose)).unsigned = true;
            else if (typeof object.voting_purpose === "string")
                message.voting_purpose = parseInt(object.voting_purpose, 10);
            else if (typeof object.voting_purpose === "number")
                message.voting_purpose = object.voting_purpose;
            else if (typeof object.voting_purpose === "object")
                message.voting_purpose = new $util.LongBits(object.voting_purpose.low >>> 0, object.voting_purpose.high >>> 0).toNumber(true);
        return message;
    };

    CardanoGovernanceRegistrationParametersType.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults) {
            object.staking_path = [];
            object.delegations = [];
        }
        if (options.defaults) {
            if (options.bytes === String)
                object.voting_public_key = "";
            else {
                object.voting_public_key = [];
                if (options.bytes !== Array)
                    object.voting_public_key = $util.newBuffer(object.voting_public_key);
            }
            object.reward_address_parameters = null;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.nonce = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.nonce = options.longs === String ? "0" : 0;
            object.format = options.enums === String ? "CIP15" : 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.voting_purpose = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.voting_purpose = options.longs === String ? "0" : 0;
        }
        if (message.voting_public_key != null && message.hasOwnProperty("voting_public_key"))
            object.voting_public_key = options.bytes === String ? $util.base64.encode(message.voting_public_key, 0, message.voting_public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.voting_public_key) : message.voting_public_key;
        if (message.staking_path && message.staking_path.length) {
            object.staking_path = [];
            for (var j = 0; j < message.staking_path.length; ++j)
                object.staking_path[j] = message.staking_path[j];
        }
        if (message.reward_address_parameters != null && message.hasOwnProperty("reward_address_parameters"))
            object.reward_address_parameters = $root.CardanoAddressParametersType.toObject(message.reward_address_parameters, options);
        if (message.nonce != null && message.hasOwnProperty("nonce"))
            if (typeof message.nonce === "number")
                object.nonce = options.longs === String ? String(message.nonce) : message.nonce;
            else
                object.nonce = options.longs === String ? $util.Long.prototype.toString.call(message.nonce) : options.longs === Number ? new $util.LongBits(message.nonce.low >>> 0, message.nonce.high >>> 0).toNumber(true) : message.nonce;
        if (message.format != null && message.hasOwnProperty("format"))
            object.format = options.enums === String ? $root.CardanoGovernanceRegistrationFormat[message.format] : message.format;
        if (message.delegations && message.delegations.length) {
            object.delegations = [];
            for (var j = 0; j < message.delegations.length; ++j)
                object.delegations[j] = $root.CardanoGovernanceRegistrationDelegation.toObject(message.delegations[j], options);
        }
        if (message.voting_purpose != null && message.hasOwnProperty("voting_purpose"))
            if (typeof message.voting_purpose === "number")
                object.voting_purpose = options.longs === String ? String(message.voting_purpose) : message.voting_purpose;
            else
                object.voting_purpose = options.longs === String ? $util.Long.prototype.toString.call(message.voting_purpose) : options.longs === Number ? new $util.LongBits(message.voting_purpose.low >>> 0, message.voting_purpose.high >>> 0).toNumber(true) : message.voting_purpose;
        return object;
    };

    CardanoGovernanceRegistrationParametersType.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoGovernanceRegistrationParametersType;
})();

$root.CardanoTxAuxiliaryData = (function() {

    function CardanoTxAuxiliaryData(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoTxAuxiliaryData.prototype.governance_registration_parameters = null;
    CardanoTxAuxiliaryData.prototype.hash = $util.newBuffer([]);

    CardanoTxAuxiliaryData.create = function create(properties) {
        return new CardanoTxAuxiliaryData(properties);
    };

    CardanoTxAuxiliaryData.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.governance_registration_parameters != null && Object.hasOwnProperty.call(message, "governance_registration_parameters"))
            $root.CardanoGovernanceRegistrationParametersType.encode(message.governance_registration_parameters, writer.uint32(10).fork()).ldelim();
        if (message.hash != null && Object.hasOwnProperty.call(message, "hash"))
            writer.uint32(18).bytes(message.hash);
        return writer;
    };

    CardanoTxAuxiliaryData.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoTxAuxiliaryData.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoTxAuxiliaryData();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.governance_registration_parameters = $root.CardanoGovernanceRegistrationParametersType.decode(reader, reader.uint32());
                break;
            case 2:
                message.hash = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    CardanoTxAuxiliaryData.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoTxAuxiliaryData.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.governance_registration_parameters != null && message.hasOwnProperty("governance_registration_parameters")) {
            var error = $root.CardanoGovernanceRegistrationParametersType.verify(message.governance_registration_parameters);
            if (error)
                return "governance_registration_parameters." + error;
        }
        if (message.hash != null && message.hasOwnProperty("hash"))
            if (!(message.hash && typeof message.hash.length === "number" || $util.isString(message.hash)))
                return "hash: buffer expected";
        return null;
    };

    CardanoTxAuxiliaryData.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoTxAuxiliaryData)
            return object;
        var message = new $root.CardanoTxAuxiliaryData();
        if (object.governance_registration_parameters != null) {
            if (typeof object.governance_registration_parameters !== "object")
                throw TypeError(".CardanoTxAuxiliaryData.governance_registration_parameters: object expected");
            message.governance_registration_parameters = $root.CardanoGovernanceRegistrationParametersType.fromObject(object.governance_registration_parameters);
        }
        if (object.hash != null)
            if (typeof object.hash === "string")
                $util.base64.decode(object.hash, message.hash = $util.newBuffer($util.base64.length(object.hash)), 0);
            else if (object.hash.length)
                message.hash = object.hash;
        return message;
    };

    CardanoTxAuxiliaryData.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.governance_registration_parameters = null;
            if (options.bytes === String)
                object.hash = "";
            else {
                object.hash = [];
                if (options.bytes !== Array)
                    object.hash = $util.newBuffer(object.hash);
            }
        }
        if (message.governance_registration_parameters != null && message.hasOwnProperty("governance_registration_parameters"))
            object.governance_registration_parameters = $root.CardanoGovernanceRegistrationParametersType.toObject(message.governance_registration_parameters, options);
        if (message.hash != null && message.hasOwnProperty("hash"))
            object.hash = options.bytes === String ? $util.base64.encode(message.hash, 0, message.hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.hash) : message.hash;
        return object;
    };

    CardanoTxAuxiliaryData.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoTxAuxiliaryData;
})();

$root.CardanoTxMint = (function() {

    function CardanoTxMint(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoTxMint.prototype.asset_groups_count = 0;

    CardanoTxMint.create = function create(properties) {
        return new CardanoTxMint(properties);
    };

    CardanoTxMint.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).uint32(message.asset_groups_count);
        return writer;
    };

    CardanoTxMint.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoTxMint.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoTxMint();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.asset_groups_count = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("asset_groups_count"))
            throw $util.ProtocolError("missing required 'asset_groups_count'", { instance: message });
        return message;
    };

    CardanoTxMint.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoTxMint.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isInteger(message.asset_groups_count))
            return "asset_groups_count: integer expected";
        return null;
    };

    CardanoTxMint.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoTxMint)
            return object;
        var message = new $root.CardanoTxMint();
        if (object.asset_groups_count != null)
            message.asset_groups_count = object.asset_groups_count >>> 0;
        return message;
    };

    CardanoTxMint.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.asset_groups_count = 0;
        if (message.asset_groups_count != null && message.hasOwnProperty("asset_groups_count"))
            object.asset_groups_count = message.asset_groups_count;
        return object;
    };

    CardanoTxMint.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoTxMint;
})();

$root.CardanoTxCollateralInput = (function() {

    function CardanoTxCollateralInput(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoTxCollateralInput.prototype.prev_hash = $util.newBuffer([]);
    CardanoTxCollateralInput.prototype.prev_index = 0;

    CardanoTxCollateralInput.create = function create(properties) {
        return new CardanoTxCollateralInput(properties);
    };

    CardanoTxCollateralInput.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.prev_hash);
        writer.uint32(16).uint32(message.prev_index);
        return writer;
    };

    CardanoTxCollateralInput.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoTxCollateralInput.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoTxCollateralInput();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.prev_hash = reader.bytes();
                break;
            case 2:
                message.prev_index = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("prev_hash"))
            throw $util.ProtocolError("missing required 'prev_hash'", { instance: message });
        if (!message.hasOwnProperty("prev_index"))
            throw $util.ProtocolError("missing required 'prev_index'", { instance: message });
        return message;
    };

    CardanoTxCollateralInput.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoTxCollateralInput.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.prev_hash && typeof message.prev_hash.length === "number" || $util.isString(message.prev_hash)))
            return "prev_hash: buffer expected";
        if (!$util.isInteger(message.prev_index))
            return "prev_index: integer expected";
        return null;
    };

    CardanoTxCollateralInput.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoTxCollateralInput)
            return object;
        var message = new $root.CardanoTxCollateralInput();
        if (object.prev_hash != null)
            if (typeof object.prev_hash === "string")
                $util.base64.decode(object.prev_hash, message.prev_hash = $util.newBuffer($util.base64.length(object.prev_hash)), 0);
            else if (object.prev_hash.length)
                message.prev_hash = object.prev_hash;
        if (object.prev_index != null)
            message.prev_index = object.prev_index >>> 0;
        return message;
    };

    CardanoTxCollateralInput.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.prev_hash = "";
            else {
                object.prev_hash = [];
                if (options.bytes !== Array)
                    object.prev_hash = $util.newBuffer(object.prev_hash);
            }
            object.prev_index = 0;
        }
        if (message.prev_hash != null && message.hasOwnProperty("prev_hash"))
            object.prev_hash = options.bytes === String ? $util.base64.encode(message.prev_hash, 0, message.prev_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.prev_hash) : message.prev_hash;
        if (message.prev_index != null && message.hasOwnProperty("prev_index"))
            object.prev_index = message.prev_index;
        return object;
    };

    CardanoTxCollateralInput.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoTxCollateralInput;
})();

$root.CardanoTxRequiredSigner = (function() {

    function CardanoTxRequiredSigner(properties) {
        this.key_path = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoTxRequiredSigner.prototype.key_hash = $util.newBuffer([]);
    CardanoTxRequiredSigner.prototype.key_path = $util.emptyArray;

    CardanoTxRequiredSigner.create = function create(properties) {
        return new CardanoTxRequiredSigner(properties);
    };

    CardanoTxRequiredSigner.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.key_hash != null && Object.hasOwnProperty.call(message, "key_hash"))
            writer.uint32(10).bytes(message.key_hash);
        if (message.key_path != null && message.key_path.length)
            for (var i = 0; i < message.key_path.length; ++i)
                writer.uint32(16).uint32(message.key_path[i]);
        return writer;
    };

    CardanoTxRequiredSigner.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoTxRequiredSigner.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoTxRequiredSigner();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.key_hash = reader.bytes();
                break;
            case 2:
                if (!(message.key_path && message.key_path.length))
                    message.key_path = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.key_path.push(reader.uint32());
                } else
                    message.key_path.push(reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    CardanoTxRequiredSigner.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoTxRequiredSigner.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.key_hash != null && message.hasOwnProperty("key_hash"))
            if (!(message.key_hash && typeof message.key_hash.length === "number" || $util.isString(message.key_hash)))
                return "key_hash: buffer expected";
        if (message.key_path != null && message.hasOwnProperty("key_path")) {
            if (!Array.isArray(message.key_path))
                return "key_path: array expected";
            for (var i = 0; i < message.key_path.length; ++i)
                if (!$util.isInteger(message.key_path[i]))
                    return "key_path: integer[] expected";
        }
        return null;
    };

    CardanoTxRequiredSigner.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoTxRequiredSigner)
            return object;
        var message = new $root.CardanoTxRequiredSigner();
        if (object.key_hash != null)
            if (typeof object.key_hash === "string")
                $util.base64.decode(object.key_hash, message.key_hash = $util.newBuffer($util.base64.length(object.key_hash)), 0);
            else if (object.key_hash.length)
                message.key_hash = object.key_hash;
        if (object.key_path) {
            if (!Array.isArray(object.key_path))
                throw TypeError(".CardanoTxRequiredSigner.key_path: array expected");
            message.key_path = [];
            for (var i = 0; i < object.key_path.length; ++i)
                message.key_path[i] = object.key_path[i] >>> 0;
        }
        return message;
    };

    CardanoTxRequiredSigner.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.key_path = [];
        if (options.defaults)
            if (options.bytes === String)
                object.key_hash = "";
            else {
                object.key_hash = [];
                if (options.bytes !== Array)
                    object.key_hash = $util.newBuffer(object.key_hash);
            }
        if (message.key_hash != null && message.hasOwnProperty("key_hash"))
            object.key_hash = options.bytes === String ? $util.base64.encode(message.key_hash, 0, message.key_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.key_hash) : message.key_hash;
        if (message.key_path && message.key_path.length) {
            object.key_path = [];
            for (var j = 0; j < message.key_path.length; ++j)
                object.key_path[j] = message.key_path[j];
        }
        return object;
    };

    CardanoTxRequiredSigner.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoTxRequiredSigner;
})();

$root.CardanoTxReferenceInput = (function() {

    function CardanoTxReferenceInput(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoTxReferenceInput.prototype.prev_hash = $util.newBuffer([]);
    CardanoTxReferenceInput.prototype.prev_index = 0;

    CardanoTxReferenceInput.create = function create(properties) {
        return new CardanoTxReferenceInput(properties);
    };

    CardanoTxReferenceInput.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.prev_hash);
        writer.uint32(16).uint32(message.prev_index);
        return writer;
    };

    CardanoTxReferenceInput.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoTxReferenceInput.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoTxReferenceInput();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.prev_hash = reader.bytes();
                break;
            case 2:
                message.prev_index = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("prev_hash"))
            throw $util.ProtocolError("missing required 'prev_hash'", { instance: message });
        if (!message.hasOwnProperty("prev_index"))
            throw $util.ProtocolError("missing required 'prev_index'", { instance: message });
        return message;
    };

    CardanoTxReferenceInput.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoTxReferenceInput.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.prev_hash && typeof message.prev_hash.length === "number" || $util.isString(message.prev_hash)))
            return "prev_hash: buffer expected";
        if (!$util.isInteger(message.prev_index))
            return "prev_index: integer expected";
        return null;
    };

    CardanoTxReferenceInput.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoTxReferenceInput)
            return object;
        var message = new $root.CardanoTxReferenceInput();
        if (object.prev_hash != null)
            if (typeof object.prev_hash === "string")
                $util.base64.decode(object.prev_hash, message.prev_hash = $util.newBuffer($util.base64.length(object.prev_hash)), 0);
            else if (object.prev_hash.length)
                message.prev_hash = object.prev_hash;
        if (object.prev_index != null)
            message.prev_index = object.prev_index >>> 0;
        return message;
    };

    CardanoTxReferenceInput.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.prev_hash = "";
            else {
                object.prev_hash = [];
                if (options.bytes !== Array)
                    object.prev_hash = $util.newBuffer(object.prev_hash);
            }
            object.prev_index = 0;
        }
        if (message.prev_hash != null && message.hasOwnProperty("prev_hash"))
            object.prev_hash = options.bytes === String ? $util.base64.encode(message.prev_hash, 0, message.prev_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.prev_hash) : message.prev_hash;
        if (message.prev_index != null && message.hasOwnProperty("prev_index"))
            object.prev_index = message.prev_index;
        return object;
    };

    CardanoTxReferenceInput.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoTxReferenceInput;
})();

$root.CardanoTxItemAck = (function() {

    function CardanoTxItemAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoTxItemAck.create = function create(properties) {
        return new CardanoTxItemAck(properties);
    };

    CardanoTxItemAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    CardanoTxItemAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoTxItemAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoTxItemAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    CardanoTxItemAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoTxItemAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    CardanoTxItemAck.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoTxItemAck)
            return object;
        return new $root.CardanoTxItemAck();
    };

    CardanoTxItemAck.toObject = function toObject() {
        return {};
    };

    CardanoTxItemAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoTxItemAck;
})();

$root.CardanoTxAuxiliaryDataSupplement = (function() {

    function CardanoTxAuxiliaryDataSupplement(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoTxAuxiliaryDataSupplement.prototype.type = 0;
    CardanoTxAuxiliaryDataSupplement.prototype.auxiliary_data_hash = $util.newBuffer([]);
    CardanoTxAuxiliaryDataSupplement.prototype.governance_signature = $util.newBuffer([]);

    CardanoTxAuxiliaryDataSupplement.create = function create(properties) {
        return new CardanoTxAuxiliaryDataSupplement(properties);
    };

    CardanoTxAuxiliaryDataSupplement.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).int32(message.type);
        if (message.auxiliary_data_hash != null && Object.hasOwnProperty.call(message, "auxiliary_data_hash"))
            writer.uint32(18).bytes(message.auxiliary_data_hash);
        if (message.governance_signature != null && Object.hasOwnProperty.call(message, "governance_signature"))
            writer.uint32(26).bytes(message.governance_signature);
        return writer;
    };

    CardanoTxAuxiliaryDataSupplement.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoTxAuxiliaryDataSupplement.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoTxAuxiliaryDataSupplement();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.type = reader.int32();
                break;
            case 2:
                message.auxiliary_data_hash = reader.bytes();
                break;
            case 3:
                message.governance_signature = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("type"))
            throw $util.ProtocolError("missing required 'type'", { instance: message });
        return message;
    };

    CardanoTxAuxiliaryDataSupplement.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoTxAuxiliaryDataSupplement.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        switch (message.type) {
        default:
            return "type: enum value expected";
        case 0:
        case 1:
            break;
        }
        if (message.auxiliary_data_hash != null && message.hasOwnProperty("auxiliary_data_hash"))
            if (!(message.auxiliary_data_hash && typeof message.auxiliary_data_hash.length === "number" || $util.isString(message.auxiliary_data_hash)))
                return "auxiliary_data_hash: buffer expected";
        if (message.governance_signature != null && message.hasOwnProperty("governance_signature"))
            if (!(message.governance_signature && typeof message.governance_signature.length === "number" || $util.isString(message.governance_signature)))
                return "governance_signature: buffer expected";
        return null;
    };

    CardanoTxAuxiliaryDataSupplement.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoTxAuxiliaryDataSupplement)
            return object;
        var message = new $root.CardanoTxAuxiliaryDataSupplement();
        switch (object.type) {
        case "NONE":
        case 0:
            message.type = 0;
            break;
        case "GOVERNANCE_REGISTRATION_SIGNATURE":
        case 1:
            message.type = 1;
            break;
        }
        if (object.auxiliary_data_hash != null)
            if (typeof object.auxiliary_data_hash === "string")
                $util.base64.decode(object.auxiliary_data_hash, message.auxiliary_data_hash = $util.newBuffer($util.base64.length(object.auxiliary_data_hash)), 0);
            else if (object.auxiliary_data_hash.length)
                message.auxiliary_data_hash = object.auxiliary_data_hash;
        if (object.governance_signature != null)
            if (typeof object.governance_signature === "string")
                $util.base64.decode(object.governance_signature, message.governance_signature = $util.newBuffer($util.base64.length(object.governance_signature)), 0);
            else if (object.governance_signature.length)
                message.governance_signature = object.governance_signature;
        return message;
    };

    CardanoTxAuxiliaryDataSupplement.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.type = options.enums === String ? "NONE" : 0;
            if (options.bytes === String)
                object.auxiliary_data_hash = "";
            else {
                object.auxiliary_data_hash = [];
                if (options.bytes !== Array)
                    object.auxiliary_data_hash = $util.newBuffer(object.auxiliary_data_hash);
            }
            if (options.bytes === String)
                object.governance_signature = "";
            else {
                object.governance_signature = [];
                if (options.bytes !== Array)
                    object.governance_signature = $util.newBuffer(object.governance_signature);
            }
        }
        if (message.type != null && message.hasOwnProperty("type"))
            object.type = options.enums === String ? $root.CardanoTxAuxiliaryDataSupplementType[message.type] : message.type;
        if (message.auxiliary_data_hash != null && message.hasOwnProperty("auxiliary_data_hash"))
            object.auxiliary_data_hash = options.bytes === String ? $util.base64.encode(message.auxiliary_data_hash, 0, message.auxiliary_data_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.auxiliary_data_hash) : message.auxiliary_data_hash;
        if (message.governance_signature != null && message.hasOwnProperty("governance_signature"))
            object.governance_signature = options.bytes === String ? $util.base64.encode(message.governance_signature, 0, message.governance_signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.governance_signature) : message.governance_signature;
        return object;
    };

    CardanoTxAuxiliaryDataSupplement.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoTxAuxiliaryDataSupplement;
})();

$root.CardanoTxWitnessRequest = (function() {

    function CardanoTxWitnessRequest(properties) {
        this.path = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoTxWitnessRequest.prototype.path = $util.emptyArray;

    CardanoTxWitnessRequest.create = function create(properties) {
        return new CardanoTxWitnessRequest(properties);
    };

    CardanoTxWitnessRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.path != null && message.path.length)
            for (var i = 0; i < message.path.length; ++i)
                writer.uint32(8).uint32(message.path[i]);
        return writer;
    };

    CardanoTxWitnessRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoTxWitnessRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoTxWitnessRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.path && message.path.length))
                    message.path = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.path.push(reader.uint32());
                } else
                    message.path.push(reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    CardanoTxWitnessRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoTxWitnessRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.path != null && message.hasOwnProperty("path")) {
            if (!Array.isArray(message.path))
                return "path: array expected";
            for (var i = 0; i < message.path.length; ++i)
                if (!$util.isInteger(message.path[i]))
                    return "path: integer[] expected";
        }
        return null;
    };

    CardanoTxWitnessRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoTxWitnessRequest)
            return object;
        var message = new $root.CardanoTxWitnessRequest();
        if (object.path) {
            if (!Array.isArray(object.path))
                throw TypeError(".CardanoTxWitnessRequest.path: array expected");
            message.path = [];
            for (var i = 0; i < object.path.length; ++i)
                message.path[i] = object.path[i] >>> 0;
        }
        return message;
    };

    CardanoTxWitnessRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.path = [];
        if (message.path && message.path.length) {
            object.path = [];
            for (var j = 0; j < message.path.length; ++j)
                object.path[j] = message.path[j];
        }
        return object;
    };

    CardanoTxWitnessRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoTxWitnessRequest;
})();

$root.CardanoTxWitnessResponse = (function() {

    function CardanoTxWitnessResponse(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoTxWitnessResponse.prototype.type = 0;
    CardanoTxWitnessResponse.prototype.pub_key = $util.newBuffer([]);
    CardanoTxWitnessResponse.prototype.signature = $util.newBuffer([]);
    CardanoTxWitnessResponse.prototype.chain_code = $util.newBuffer([]);

    CardanoTxWitnessResponse.create = function create(properties) {
        return new CardanoTxWitnessResponse(properties);
    };

    CardanoTxWitnessResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).int32(message.type);
        writer.uint32(18).bytes(message.pub_key);
        writer.uint32(26).bytes(message.signature);
        if (message.chain_code != null && Object.hasOwnProperty.call(message, "chain_code"))
            writer.uint32(34).bytes(message.chain_code);
        return writer;
    };

    CardanoTxWitnessResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoTxWitnessResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoTxWitnessResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.type = reader.int32();
                break;
            case 2:
                message.pub_key = reader.bytes();
                break;
            case 3:
                message.signature = reader.bytes();
                break;
            case 4:
                message.chain_code = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("type"))
            throw $util.ProtocolError("missing required 'type'", { instance: message });
        if (!message.hasOwnProperty("pub_key"))
            throw $util.ProtocolError("missing required 'pub_key'", { instance: message });
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        return message;
    };

    CardanoTxWitnessResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoTxWitnessResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        switch (message.type) {
        default:
            return "type: enum value expected";
        case 0:
        case 1:
            break;
        }
        if (!(message.pub_key && typeof message.pub_key.length === "number" || $util.isString(message.pub_key)))
            return "pub_key: buffer expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        if (message.chain_code != null && message.hasOwnProperty("chain_code"))
            if (!(message.chain_code && typeof message.chain_code.length === "number" || $util.isString(message.chain_code)))
                return "chain_code: buffer expected";
        return null;
    };

    CardanoTxWitnessResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoTxWitnessResponse)
            return object;
        var message = new $root.CardanoTxWitnessResponse();
        switch (object.type) {
        case "BYRON_WITNESS":
        case 0:
            message.type = 0;
            break;
        case "SHELLEY_WITNESS":
        case 1:
            message.type = 1;
            break;
        }
        if (object.pub_key != null)
            if (typeof object.pub_key === "string")
                $util.base64.decode(object.pub_key, message.pub_key = $util.newBuffer($util.base64.length(object.pub_key)), 0);
            else if (object.pub_key.length)
                message.pub_key = object.pub_key;
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        if (object.chain_code != null)
            if (typeof object.chain_code === "string")
                $util.base64.decode(object.chain_code, message.chain_code = $util.newBuffer($util.base64.length(object.chain_code)), 0);
            else if (object.chain_code.length)
                message.chain_code = object.chain_code;
        return message;
    };

    CardanoTxWitnessResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.type = options.enums === String ? "BYRON_WITNESS" : 0;
            if (options.bytes === String)
                object.pub_key = "";
            else {
                object.pub_key = [];
                if (options.bytes !== Array)
                    object.pub_key = $util.newBuffer(object.pub_key);
            }
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
            if (options.bytes === String)
                object.chain_code = "";
            else {
                object.chain_code = [];
                if (options.bytes !== Array)
                    object.chain_code = $util.newBuffer(object.chain_code);
            }
        }
        if (message.type != null && message.hasOwnProperty("type"))
            object.type = options.enums === String ? $root.CardanoTxWitnessType[message.type] : message.type;
        if (message.pub_key != null && message.hasOwnProperty("pub_key"))
            object.pub_key = options.bytes === String ? $util.base64.encode(message.pub_key, 0, message.pub_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.pub_key) : message.pub_key;
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        if (message.chain_code != null && message.hasOwnProperty("chain_code"))
            object.chain_code = options.bytes === String ? $util.base64.encode(message.chain_code, 0, message.chain_code.length) : options.bytes === Array ? Array.prototype.slice.call(message.chain_code) : message.chain_code;
        return object;
    };

    CardanoTxWitnessResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoTxWitnessResponse;
})();

$root.CardanoTxHostAck = (function() {

    function CardanoTxHostAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoTxHostAck.create = function create(properties) {
        return new CardanoTxHostAck(properties);
    };

    CardanoTxHostAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    CardanoTxHostAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoTxHostAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoTxHostAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    CardanoTxHostAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoTxHostAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    CardanoTxHostAck.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoTxHostAck)
            return object;
        return new $root.CardanoTxHostAck();
    };

    CardanoTxHostAck.toObject = function toObject() {
        return {};
    };

    CardanoTxHostAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoTxHostAck;
})();

$root.CardanoTxBodyHash = (function() {

    function CardanoTxBodyHash(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoTxBodyHash.prototype.tx_hash = $util.newBuffer([]);

    CardanoTxBodyHash.create = function create(properties) {
        return new CardanoTxBodyHash(properties);
    };

    CardanoTxBodyHash.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.tx_hash);
        return writer;
    };

    CardanoTxBodyHash.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoTxBodyHash.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoTxBodyHash();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.tx_hash = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("tx_hash"))
            throw $util.ProtocolError("missing required 'tx_hash'", { instance: message });
        return message;
    };

    CardanoTxBodyHash.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoTxBodyHash.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.tx_hash && typeof message.tx_hash.length === "number" || $util.isString(message.tx_hash)))
            return "tx_hash: buffer expected";
        return null;
    };

    CardanoTxBodyHash.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoTxBodyHash)
            return object;
        var message = new $root.CardanoTxBodyHash();
        if (object.tx_hash != null)
            if (typeof object.tx_hash === "string")
                $util.base64.decode(object.tx_hash, message.tx_hash = $util.newBuffer($util.base64.length(object.tx_hash)), 0);
            else if (object.tx_hash.length)
                message.tx_hash = object.tx_hash;
        return message;
    };

    CardanoTxBodyHash.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.tx_hash = "";
            else {
                object.tx_hash = [];
                if (options.bytes !== Array)
                    object.tx_hash = $util.newBuffer(object.tx_hash);
            }
        if (message.tx_hash != null && message.hasOwnProperty("tx_hash"))
            object.tx_hash = options.bytes === String ? $util.base64.encode(message.tx_hash, 0, message.tx_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.tx_hash) : message.tx_hash;
        return object;
    };

    CardanoTxBodyHash.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoTxBodyHash;
})();

$root.CardanoSignTxFinished = (function() {

    function CardanoSignTxFinished(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoSignTxFinished.create = function create(properties) {
        return new CardanoSignTxFinished(properties);
    };

    CardanoSignTxFinished.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    CardanoSignTxFinished.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoSignTxFinished.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoSignTxFinished();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    CardanoSignTxFinished.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoSignTxFinished.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    CardanoSignTxFinished.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoSignTxFinished)
            return object;
        return new $root.CardanoSignTxFinished();
    };

    CardanoSignTxFinished.toObject = function toObject() {
        return {};
    };

    CardanoSignTxFinished.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoSignTxFinished;
})();

$root.CardanoSignMessage = (function() {

    function CardanoSignMessage(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoSignMessage.prototype.address_n = $util.emptyArray;
    CardanoSignMessage.prototype.message = $util.newBuffer([]);
    CardanoSignMessage.prototype.derivation_type = 0;
    CardanoSignMessage.prototype.network_id = 0;

    CardanoSignMessage.create = function create(properties) {
        return new CardanoSignMessage(properties);
    };

    CardanoSignMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).bytes(message.message);
        writer.uint32(24).int32(message.derivation_type);
        writer.uint32(32).uint32(message.network_id);
        return writer;
    };

    CardanoSignMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoSignMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoSignMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.message = reader.bytes();
                break;
            case 3:
                message.derivation_type = reader.int32();
                break;
            case 4:
                message.network_id = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("message"))
            throw $util.ProtocolError("missing required 'message'", { instance: message });
        if (!message.hasOwnProperty("derivation_type"))
            throw $util.ProtocolError("missing required 'derivation_type'", { instance: message });
        if (!message.hasOwnProperty("network_id"))
            throw $util.ProtocolError("missing required 'network_id'", { instance: message });
        return message;
    };

    CardanoSignMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoSignMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!(message.message && typeof message.message.length === "number" || $util.isString(message.message)))
            return "message: buffer expected";
        switch (message.derivation_type) {
        default:
            return "derivation_type: enum value expected";
        case 0:
        case 1:
        case 2:
            break;
        }
        if (!$util.isInteger(message.network_id))
            return "network_id: integer expected";
        return null;
    };

    CardanoSignMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoSignMessage)
            return object;
        var message = new $root.CardanoSignMessage();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".CardanoSignMessage.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.message != null)
            if (typeof object.message === "string")
                $util.base64.decode(object.message, message.message = $util.newBuffer($util.base64.length(object.message)), 0);
            else if (object.message.length)
                message.message = object.message;
        switch (object.derivation_type) {
        case "LEDGER":
        case 0:
            message.derivation_type = 0;
            break;
        case "ICARUS":
        case 1:
            message.derivation_type = 1;
            break;
        case "ICARUS_TREZOR":
        case 2:
            message.derivation_type = 2;
            break;
        }
        if (object.network_id != null)
            message.network_id = object.network_id >>> 0;
        return message;
    };

    CardanoSignMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            if (options.bytes === String)
                object.message = "";
            else {
                object.message = [];
                if (options.bytes !== Array)
                    object.message = $util.newBuffer(object.message);
            }
            object.derivation_type = options.enums === String ? "LEDGER" : 0;
            object.network_id = 0;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.message != null && message.hasOwnProperty("message"))
            object.message = options.bytes === String ? $util.base64.encode(message.message, 0, message.message.length) : options.bytes === Array ? Array.prototype.slice.call(message.message) : message.message;
        if (message.derivation_type != null && message.hasOwnProperty("derivation_type"))
            object.derivation_type = options.enums === String ? $root.CardanoDerivationType[message.derivation_type] : message.derivation_type;
        if (message.network_id != null && message.hasOwnProperty("network_id"))
            object.network_id = message.network_id;
        return object;
    };

    CardanoSignMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoSignMessage;
})();

$root.CardanoMessageSignature = (function() {

    function CardanoMessageSignature(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoMessageSignature.prototype.signature = $util.newBuffer([]);
    CardanoMessageSignature.prototype.key = $util.newBuffer([]);

    CardanoMessageSignature.create = function create(properties) {
        return new CardanoMessageSignature(properties);
    };

    CardanoMessageSignature.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.signature);
        writer.uint32(18).bytes(message.key);
        return writer;
    };

    CardanoMessageSignature.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoMessageSignature.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoMessageSignature();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.signature = reader.bytes();
                break;
            case 2:
                message.key = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        if (!message.hasOwnProperty("key"))
            throw $util.ProtocolError("missing required 'key'", { instance: message });
        return message;
    };

    CardanoMessageSignature.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoMessageSignature.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        if (!(message.key && typeof message.key.length === "number" || $util.isString(message.key)))
            return "key: buffer expected";
        return null;
    };

    CardanoMessageSignature.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoMessageSignature)
            return object;
        var message = new $root.CardanoMessageSignature();
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        if (object.key != null)
            if (typeof object.key === "string")
                $util.base64.decode(object.key, message.key = $util.newBuffer($util.base64.length(object.key)), 0);
            else if (object.key.length)
                message.key = object.key;
        return message;
    };

    CardanoMessageSignature.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
            if (options.bytes === String)
                object.key = "";
            else {
                object.key = [];
                if (options.bytes !== Array)
                    object.key = $util.newBuffer(object.key);
            }
        }
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        if (message.key != null && message.hasOwnProperty("key"))
            object.key = options.bytes === String ? $util.base64.encode(message.key, 0, message.key.length) : options.bytes === Array ? Array.prototype.slice.call(message.key) : message.key;
        return object;
    };

    CardanoMessageSignature.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoMessageSignature;
})();

$root.Success = (function() {

    function Success(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    Success.prototype.message = "";

    Success.create = function create(properties) {
        return new Success(properties);
    };

    Success.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
            writer.uint32(10).string(message.message);
        return writer;
    };

    Success.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    Success.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Success();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.message = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    Success.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    Success.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.message != null && message.hasOwnProperty("message"))
            if (!$util.isString(message.message))
                return "message: string expected";
        return null;
    };

    Success.fromObject = function fromObject(object) {
        if (object instanceof $root.Success)
            return object;
        var message = new $root.Success();
        if (object.message != null)
            message.message = String(object.message);
        return message;
    };

    Success.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.message = "";
        if (message.message != null && message.hasOwnProperty("message"))
            object.message = message.message;
        return object;
    };

    Success.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return Success;
})();

$root.Failure = (function() {

    function Failure(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    Failure.prototype.code = 1;
    Failure.prototype.message = "";

    Failure.create = function create(properties) {
        return new Failure(properties);
    };

    Failure.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.code != null && Object.hasOwnProperty.call(message, "code"))
            writer.uint32(8).int32(message.code);
        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
            writer.uint32(18).string(message.message);
        return writer;
    };

    Failure.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    Failure.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Failure();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.code = reader.int32();
                break;
            case 2:
                message.message = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    Failure.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    Failure.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.code != null && message.hasOwnProperty("code"))
            switch (message.code) {
            default:
                return "code: enum value expected";
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
            case 8:
            case 9:
            case 10:
            case 11:
            case 12:
            case 13:
            case 14:
            case 99:
                break;
            }
        if (message.message != null && message.hasOwnProperty("message"))
            if (!$util.isString(message.message))
                return "message: string expected";
        return null;
    };

    Failure.fromObject = function fromObject(object) {
        if (object instanceof $root.Failure)
            return object;
        var message = new $root.Failure();
        switch (object.code) {
        case "Failure_UnexpectedMessage":
        case 1:
            message.code = 1;
            break;
        case "Failure_ButtonExpected":
        case 2:
            message.code = 2;
            break;
        case "Failure_DataError":
        case 3:
            message.code = 3;
            break;
        case "Failure_ActionCancelled":
        case 4:
            message.code = 4;
            break;
        case "Failure_PinExpected":
        case 5:
            message.code = 5;
            break;
        case "Failure_PinCancelled":
        case 6:
            message.code = 6;
            break;
        case "Failure_PinInvalid":
        case 7:
            message.code = 7;
            break;
        case "Failure_InvalidSignature":
        case 8:
            message.code = 8;
            break;
        case "Failure_ProcessError":
        case 9:
            message.code = 9;
            break;
        case "Failure_NotEnoughFunds":
        case 10:
            message.code = 10;
            break;
        case "Failure_NotInitialized":
        case 11:
            message.code = 11;
            break;
        case "Failure_PinMismatch":
        case 12:
            message.code = 12;
            break;
        case "Failure_WipeCodeMismatch":
        case 13:
            message.code = 13;
            break;
        case "Failure_InvalidSession":
        case 14:
            message.code = 14;
            break;
        case "Failure_FirmwareError":
        case 99:
            message.code = 99;
            break;
        }
        if (object.message != null)
            message.message = String(object.message);
        return message;
    };

    Failure.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.code = options.enums === String ? "Failure_UnexpectedMessage" : 1;
            object.message = "";
        }
        if (message.code != null && message.hasOwnProperty("code"))
            object.code = options.enums === String ? $root.Failure.FailureType[message.code] : message.code;
        if (message.message != null && message.hasOwnProperty("message"))
            object.message = message.message;
        return object;
    };

    Failure.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    Failure.FailureType = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[1] = "Failure_UnexpectedMessage"] = 1;
        values[valuesById[2] = "Failure_ButtonExpected"] = 2;
        values[valuesById[3] = "Failure_DataError"] = 3;
        values[valuesById[4] = "Failure_ActionCancelled"] = 4;
        values[valuesById[5] = "Failure_PinExpected"] = 5;
        values[valuesById[6] = "Failure_PinCancelled"] = 6;
        values[valuesById[7] = "Failure_PinInvalid"] = 7;
        values[valuesById[8] = "Failure_InvalidSignature"] = 8;
        values[valuesById[9] = "Failure_ProcessError"] = 9;
        values[valuesById[10] = "Failure_NotEnoughFunds"] = 10;
        values[valuesById[11] = "Failure_NotInitialized"] = 11;
        values[valuesById[12] = "Failure_PinMismatch"] = 12;
        values[valuesById[13] = "Failure_WipeCodeMismatch"] = 13;
        values[valuesById[14] = "Failure_InvalidSession"] = 14;
        values[valuesById[99] = "Failure_FirmwareError"] = 99;
        return values;
    })();

    return Failure;
})();

$root.ButtonRequest = (function() {

    function ButtonRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ButtonRequest.prototype.code = 1;
    ButtonRequest.prototype.pages = 0;

    ButtonRequest.create = function create(properties) {
        return new ButtonRequest(properties);
    };

    ButtonRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.code != null && Object.hasOwnProperty.call(message, "code"))
            writer.uint32(8).int32(message.code);
        if (message.pages != null && Object.hasOwnProperty.call(message, "pages"))
            writer.uint32(16).uint32(message.pages);
        return writer;
    };

    ButtonRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ButtonRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ButtonRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.code = reader.int32();
                break;
            case 2:
                message.pages = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    ButtonRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ButtonRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.code != null && message.hasOwnProperty("code"))
            switch (message.code) {
            default:
                return "code: enum value expected";
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
            case 8:
            case 9:
            case 10:
            case 11:
            case 12:
            case 13:
            case 14:
            case 15:
            case 16:
            case 17:
            case 18:
            case 19:
            case 20:
                break;
            }
        if (message.pages != null && message.hasOwnProperty("pages"))
            if (!$util.isInteger(message.pages))
                return "pages: integer expected";
        return null;
    };

    ButtonRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.ButtonRequest)
            return object;
        var message = new $root.ButtonRequest();
        switch (object.code) {
        case "ButtonRequest_Other":
        case 1:
            message.code = 1;
            break;
        case "ButtonRequest_FeeOverThreshold":
        case 2:
            message.code = 2;
            break;
        case "ButtonRequest_ConfirmOutput":
        case 3:
            message.code = 3;
            break;
        case "ButtonRequest_ResetDevice":
        case 4:
            message.code = 4;
            break;
        case "ButtonRequest_ConfirmWord":
        case 5:
            message.code = 5;
            break;
        case "ButtonRequest_WipeDevice":
        case 6:
            message.code = 6;
            break;
        case "ButtonRequest_ProtectCall":
        case 7:
            message.code = 7;
            break;
        case "ButtonRequest_SignTx":
        case 8:
            message.code = 8;
            break;
        case "ButtonRequest_FirmwareCheck":
        case 9:
            message.code = 9;
            break;
        case "ButtonRequest_Address":
        case 10:
            message.code = 10;
            break;
        case "ButtonRequest_PublicKey":
        case 11:
            message.code = 11;
            break;
        case "ButtonRequest_MnemonicWordCount":
        case 12:
            message.code = 12;
            break;
        case "ButtonRequest_MnemonicInput":
        case 13:
            message.code = 13;
            break;
        case "_Deprecated_ButtonRequest_PassphraseType":
        case 14:
            message.code = 14;
            break;
        case "ButtonRequest_UnknownDerivationPath":
        case 15:
            message.code = 15;
            break;
        case "ButtonRequest_RecoveryHomepage":
        case 16:
            message.code = 16;
            break;
        case "ButtonRequest_Success":
        case 17:
            message.code = 17;
            break;
        case "ButtonRequest_Warning":
        case 18:
            message.code = 18;
            break;
        case "ButtonRequest_PassphraseEntry":
        case 19:
            message.code = 19;
            break;
        case "ButtonRequest_PinEntry":
        case 20:
            message.code = 20;
            break;
        }
        if (object.pages != null)
            message.pages = object.pages >>> 0;
        return message;
    };

    ButtonRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.code = options.enums === String ? "ButtonRequest_Other" : 1;
            object.pages = 0;
        }
        if (message.code != null && message.hasOwnProperty("code"))
            object.code = options.enums === String ? $root.ButtonRequest.ButtonRequestType[message.code] : message.code;
        if (message.pages != null && message.hasOwnProperty("pages"))
            object.pages = message.pages;
        return object;
    };

    ButtonRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    ButtonRequest.ButtonRequestType = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[1] = "ButtonRequest_Other"] = 1;
        values[valuesById[2] = "ButtonRequest_FeeOverThreshold"] = 2;
        values[valuesById[3] = "ButtonRequest_ConfirmOutput"] = 3;
        values[valuesById[4] = "ButtonRequest_ResetDevice"] = 4;
        values[valuesById[5] = "ButtonRequest_ConfirmWord"] = 5;
        values[valuesById[6] = "ButtonRequest_WipeDevice"] = 6;
        values[valuesById[7] = "ButtonRequest_ProtectCall"] = 7;
        values[valuesById[8] = "ButtonRequest_SignTx"] = 8;
        values[valuesById[9] = "ButtonRequest_FirmwareCheck"] = 9;
        values[valuesById[10] = "ButtonRequest_Address"] = 10;
        values[valuesById[11] = "ButtonRequest_PublicKey"] = 11;
        values[valuesById[12] = "ButtonRequest_MnemonicWordCount"] = 12;
        values[valuesById[13] = "ButtonRequest_MnemonicInput"] = 13;
        values[valuesById[14] = "_Deprecated_ButtonRequest_PassphraseType"] = 14;
        values[valuesById[15] = "ButtonRequest_UnknownDerivationPath"] = 15;
        values[valuesById[16] = "ButtonRequest_RecoveryHomepage"] = 16;
        values[valuesById[17] = "ButtonRequest_Success"] = 17;
        values[valuesById[18] = "ButtonRequest_Warning"] = 18;
        values[valuesById[19] = "ButtonRequest_PassphraseEntry"] = 19;
        values[valuesById[20] = "ButtonRequest_PinEntry"] = 20;
        return values;
    })();

    return ButtonRequest;
})();

$root.ButtonAck = (function() {

    function ButtonAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ButtonAck.create = function create(properties) {
        return new ButtonAck(properties);
    };

    ButtonAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    ButtonAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ButtonAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ButtonAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    ButtonAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ButtonAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    ButtonAck.fromObject = function fromObject(object) {
        if (object instanceof $root.ButtonAck)
            return object;
        return new $root.ButtonAck();
    };

    ButtonAck.toObject = function toObject() {
        return {};
    };

    ButtonAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ButtonAck;
})();

$root.PinMatrixRequest = (function() {

    function PinMatrixRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    PinMatrixRequest.prototype.type = 1;

    PinMatrixRequest.create = function create(properties) {
        return new PinMatrixRequest(properties);
    };

    PinMatrixRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.type != null && Object.hasOwnProperty.call(message, "type"))
            writer.uint32(8).int32(message.type);
        return writer;
    };

    PinMatrixRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    PinMatrixRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.PinMatrixRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.type = reader.int32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    PinMatrixRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    PinMatrixRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.type != null && message.hasOwnProperty("type"))
            switch (message.type) {
            default:
                return "type: enum value expected";
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
                break;
            }
        return null;
    };

    PinMatrixRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.PinMatrixRequest)
            return object;
        var message = new $root.PinMatrixRequest();
        switch (object.type) {
        case "PinMatrixRequestType_Current":
        case 1:
            message.type = 1;
            break;
        case "PinMatrixRequestType_NewFirst":
        case 2:
            message.type = 2;
            break;
        case "PinMatrixRequestType_NewSecond":
        case 3:
            message.type = 3;
            break;
        case "PinMatrixRequestType_WipeCodeFirst":
        case 4:
            message.type = 4;
            break;
        case "PinMatrixRequestType_WipeCodeSecond":
        case 5:
            message.type = 5;
            break;
        case "PinMatrixRequestType_BackupFirst":
        case 6:
            message.type = 6;
            break;
        case "PinMatrixRequestType_BackupSecond":
        case 7:
            message.type = 7;
            break;
        }
        return message;
    };

    PinMatrixRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.type = options.enums === String ? "PinMatrixRequestType_Current" : 1;
        if (message.type != null && message.hasOwnProperty("type"))
            object.type = options.enums === String ? $root.PinMatrixRequest.PinMatrixRequestType[message.type] : message.type;
        return object;
    };

    PinMatrixRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    PinMatrixRequest.PinMatrixRequestType = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[1] = "PinMatrixRequestType_Current"] = 1;
        values[valuesById[2] = "PinMatrixRequestType_NewFirst"] = 2;
        values[valuesById[3] = "PinMatrixRequestType_NewSecond"] = 3;
        values[valuesById[4] = "PinMatrixRequestType_WipeCodeFirst"] = 4;
        values[valuesById[5] = "PinMatrixRequestType_WipeCodeSecond"] = 5;
        values[valuesById[6] = "PinMatrixRequestType_BackupFirst"] = 6;
        values[valuesById[7] = "PinMatrixRequestType_BackupSecond"] = 7;
        return values;
    })();

    return PinMatrixRequest;
})();

$root.PinMatrixAck = (function() {

    function PinMatrixAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    PinMatrixAck.prototype.pin = "";
    PinMatrixAck.prototype.new_pin = "";

    PinMatrixAck.create = function create(properties) {
        return new PinMatrixAck(properties);
    };

    PinMatrixAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.pin);
        if (message.new_pin != null && Object.hasOwnProperty.call(message, "new_pin"))
            writer.uint32(18).string(message.new_pin);
        return writer;
    };

    PinMatrixAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    PinMatrixAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.PinMatrixAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.pin = reader.string();
                break;
            case 2:
                message.new_pin = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("pin"))
            throw $util.ProtocolError("missing required 'pin'", { instance: message });
        return message;
    };

    PinMatrixAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    PinMatrixAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.pin))
            return "pin: string expected";
        if (message.new_pin != null && message.hasOwnProperty("new_pin"))
            if (!$util.isString(message.new_pin))
                return "new_pin: string expected";
        return null;
    };

    PinMatrixAck.fromObject = function fromObject(object) {
        if (object instanceof $root.PinMatrixAck)
            return object;
        var message = new $root.PinMatrixAck();
        if (object.pin != null)
            message.pin = String(object.pin);
        if (object.new_pin != null)
            message.new_pin = String(object.new_pin);
        return message;
    };

    PinMatrixAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.pin = "";
            object.new_pin = "";
        }
        if (message.pin != null && message.hasOwnProperty("pin"))
            object.pin = message.pin;
        if (message.new_pin != null && message.hasOwnProperty("new_pin"))
            object.new_pin = message.new_pin;
        return object;
    };

    PinMatrixAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return PinMatrixAck;
})();

$root.PassphraseRequest = (function() {

    function PassphraseRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    PassphraseRequest.prototype._on_device = false;

    PassphraseRequest.create = function create(properties) {
        return new PassphraseRequest(properties);
    };

    PassphraseRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message._on_device != null && Object.hasOwnProperty.call(message, "_on_device"))
            writer.uint32(8).bool(message._on_device);
        return writer;
    };

    PassphraseRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    PassphraseRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.PassphraseRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message._on_device = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    PassphraseRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    PassphraseRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message._on_device != null && message.hasOwnProperty("_on_device"))
            if (typeof message._on_device !== "boolean")
                return "_on_device: boolean expected";
        return null;
    };

    PassphraseRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.PassphraseRequest)
            return object;
        var message = new $root.PassphraseRequest();
        if (object._on_device != null)
            message._on_device = Boolean(object._on_device);
        return message;
    };

    PassphraseRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object._on_device = false;
        if (message._on_device != null && message.hasOwnProperty("_on_device"))
            object._on_device = message._on_device;
        return object;
    };

    PassphraseRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return PassphraseRequest;
})();

$root.PassphraseAck = (function() {

    function PassphraseAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    PassphraseAck.prototype.passphrase = "";
    PassphraseAck.prototype._state = $util.newBuffer([]);
    PassphraseAck.prototype.on_device = false;

    PassphraseAck.create = function create(properties) {
        return new PassphraseAck(properties);
    };

    PassphraseAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.passphrase != null && Object.hasOwnProperty.call(message, "passphrase"))
            writer.uint32(10).string(message.passphrase);
        if (message._state != null && Object.hasOwnProperty.call(message, "_state"))
            writer.uint32(18).bytes(message._state);
        if (message.on_device != null && Object.hasOwnProperty.call(message, "on_device"))
            writer.uint32(24).bool(message.on_device);
        return writer;
    };

    PassphraseAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    PassphraseAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.PassphraseAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.passphrase = reader.string();
                break;
            case 2:
                message._state = reader.bytes();
                break;
            case 3:
                message.on_device = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    PassphraseAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    PassphraseAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.passphrase != null && message.hasOwnProperty("passphrase"))
            if (!$util.isString(message.passphrase))
                return "passphrase: string expected";
        if (message._state != null && message.hasOwnProperty("_state"))
            if (!(message._state && typeof message._state.length === "number" || $util.isString(message._state)))
                return "_state: buffer expected";
        if (message.on_device != null && message.hasOwnProperty("on_device"))
            if (typeof message.on_device !== "boolean")
                return "on_device: boolean expected";
        return null;
    };

    PassphraseAck.fromObject = function fromObject(object) {
        if (object instanceof $root.PassphraseAck)
            return object;
        var message = new $root.PassphraseAck();
        if (object.passphrase != null)
            message.passphrase = String(object.passphrase);
        if (object._state != null)
            if (typeof object._state === "string")
                $util.base64.decode(object._state, message._state = $util.newBuffer($util.base64.length(object._state)), 0);
            else if (object._state.length)
                message._state = object._state;
        if (object.on_device != null)
            message.on_device = Boolean(object.on_device);
        return message;
    };

    PassphraseAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.passphrase = "";
            if (options.bytes === String)
                object._state = "";
            else {
                object._state = [];
                if (options.bytes !== Array)
                    object._state = $util.newBuffer(object._state);
            }
            object.on_device = false;
        }
        if (message.passphrase != null && message.hasOwnProperty("passphrase"))
            object.passphrase = message.passphrase;
        if (message._state != null && message.hasOwnProperty("_state"))
            object._state = options.bytes === String ? $util.base64.encode(message._state, 0, message._state.length) : options.bytes === Array ? Array.prototype.slice.call(message._state) : message._state;
        if (message.on_device != null && message.hasOwnProperty("on_device"))
            object.on_device = message.on_device;
        return object;
    };

    PassphraseAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return PassphraseAck;
})();

$root.Deprecated_PassphraseStateRequest = (function() {

    function Deprecated_PassphraseStateRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    Deprecated_PassphraseStateRequest.prototype.state = $util.newBuffer([]);

    Deprecated_PassphraseStateRequest.create = function create(properties) {
        return new Deprecated_PassphraseStateRequest(properties);
    };

    Deprecated_PassphraseStateRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.state != null && Object.hasOwnProperty.call(message, "state"))
            writer.uint32(10).bytes(message.state);
        return writer;
    };

    Deprecated_PassphraseStateRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    Deprecated_PassphraseStateRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Deprecated_PassphraseStateRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.state = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    Deprecated_PassphraseStateRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    Deprecated_PassphraseStateRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.state != null && message.hasOwnProperty("state"))
            if (!(message.state && typeof message.state.length === "number" || $util.isString(message.state)))
                return "state: buffer expected";
        return null;
    };

    Deprecated_PassphraseStateRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.Deprecated_PassphraseStateRequest)
            return object;
        var message = new $root.Deprecated_PassphraseStateRequest();
        if (object.state != null)
            if (typeof object.state === "string")
                $util.base64.decode(object.state, message.state = $util.newBuffer($util.base64.length(object.state)), 0);
            else if (object.state.length)
                message.state = object.state;
        return message;
    };

    Deprecated_PassphraseStateRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.state = "";
            else {
                object.state = [];
                if (options.bytes !== Array)
                    object.state = $util.newBuffer(object.state);
            }
        if (message.state != null && message.hasOwnProperty("state"))
            object.state = options.bytes === String ? $util.base64.encode(message.state, 0, message.state.length) : options.bytes === Array ? Array.prototype.slice.call(message.state) : message.state;
        return object;
    };

    Deprecated_PassphraseStateRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return Deprecated_PassphraseStateRequest;
})();

$root.Deprecated_PassphraseStateAck = (function() {

    function Deprecated_PassphraseStateAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    Deprecated_PassphraseStateAck.create = function create(properties) {
        return new Deprecated_PassphraseStateAck(properties);
    };

    Deprecated_PassphraseStateAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    Deprecated_PassphraseStateAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    Deprecated_PassphraseStateAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Deprecated_PassphraseStateAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    Deprecated_PassphraseStateAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    Deprecated_PassphraseStateAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    Deprecated_PassphraseStateAck.fromObject = function fromObject(object) {
        if (object instanceof $root.Deprecated_PassphraseStateAck)
            return object;
        return new $root.Deprecated_PassphraseStateAck();
    };

    Deprecated_PassphraseStateAck.toObject = function toObject() {
        return {};
    };

    Deprecated_PassphraseStateAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return Deprecated_PassphraseStateAck;
})();

$root.HDNodeType = (function() {

    function HDNodeType(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    HDNodeType.prototype.depth = 0;
    HDNodeType.prototype.fingerprint = 0;
    HDNodeType.prototype.child_num = 0;
    HDNodeType.prototype.chain_code = $util.newBuffer([]);
    HDNodeType.prototype.private_key = $util.newBuffer([]);
    HDNodeType.prototype.public_key = $util.newBuffer([]);

    HDNodeType.create = function create(properties) {
        return new HDNodeType(properties);
    };

    HDNodeType.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).uint32(message.depth);
        writer.uint32(16).uint32(message.fingerprint);
        writer.uint32(24).uint32(message.child_num);
        writer.uint32(34).bytes(message.chain_code);
        if (message.private_key != null && Object.hasOwnProperty.call(message, "private_key"))
            writer.uint32(42).bytes(message.private_key);
        writer.uint32(50).bytes(message.public_key);
        return writer;
    };

    HDNodeType.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    HDNodeType.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.HDNodeType();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.depth = reader.uint32();
                break;
            case 2:
                message.fingerprint = reader.uint32();
                break;
            case 3:
                message.child_num = reader.uint32();
                break;
            case 4:
                message.chain_code = reader.bytes();
                break;
            case 5:
                message.private_key = reader.bytes();
                break;
            case 6:
                message.public_key = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("depth"))
            throw $util.ProtocolError("missing required 'depth'", { instance: message });
        if (!message.hasOwnProperty("fingerprint"))
            throw $util.ProtocolError("missing required 'fingerprint'", { instance: message });
        if (!message.hasOwnProperty("child_num"))
            throw $util.ProtocolError("missing required 'child_num'", { instance: message });
        if (!message.hasOwnProperty("chain_code"))
            throw $util.ProtocolError("missing required 'chain_code'", { instance: message });
        if (!message.hasOwnProperty("public_key"))
            throw $util.ProtocolError("missing required 'public_key'", { instance: message });
        return message;
    };

    HDNodeType.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    HDNodeType.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isInteger(message.depth))
            return "depth: integer expected";
        if (!$util.isInteger(message.fingerprint))
            return "fingerprint: integer expected";
        if (!$util.isInteger(message.child_num))
            return "child_num: integer expected";
        if (!(message.chain_code && typeof message.chain_code.length === "number" || $util.isString(message.chain_code)))
            return "chain_code: buffer expected";
        if (message.private_key != null && message.hasOwnProperty("private_key"))
            if (!(message.private_key && typeof message.private_key.length === "number" || $util.isString(message.private_key)))
                return "private_key: buffer expected";
        if (!(message.public_key && typeof message.public_key.length === "number" || $util.isString(message.public_key)))
            return "public_key: buffer expected";
        return null;
    };

    HDNodeType.fromObject = function fromObject(object) {
        if (object instanceof $root.HDNodeType)
            return object;
        var message = new $root.HDNodeType();
        if (object.depth != null)
            message.depth = object.depth >>> 0;
        if (object.fingerprint != null)
            message.fingerprint = object.fingerprint >>> 0;
        if (object.child_num != null)
            message.child_num = object.child_num >>> 0;
        if (object.chain_code != null)
            if (typeof object.chain_code === "string")
                $util.base64.decode(object.chain_code, message.chain_code = $util.newBuffer($util.base64.length(object.chain_code)), 0);
            else if (object.chain_code.length)
                message.chain_code = object.chain_code;
        if (object.private_key != null)
            if (typeof object.private_key === "string")
                $util.base64.decode(object.private_key, message.private_key = $util.newBuffer($util.base64.length(object.private_key)), 0);
            else if (object.private_key.length)
                message.private_key = object.private_key;
        if (object.public_key != null)
            if (typeof object.public_key === "string")
                $util.base64.decode(object.public_key, message.public_key = $util.newBuffer($util.base64.length(object.public_key)), 0);
            else if (object.public_key.length)
                message.public_key = object.public_key;
        return message;
    };

    HDNodeType.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.depth = 0;
            object.fingerprint = 0;
            object.child_num = 0;
            if (options.bytes === String)
                object.chain_code = "";
            else {
                object.chain_code = [];
                if (options.bytes !== Array)
                    object.chain_code = $util.newBuffer(object.chain_code);
            }
            if (options.bytes === String)
                object.private_key = "";
            else {
                object.private_key = [];
                if (options.bytes !== Array)
                    object.private_key = $util.newBuffer(object.private_key);
            }
            if (options.bytes === String)
                object.public_key = "";
            else {
                object.public_key = [];
                if (options.bytes !== Array)
                    object.public_key = $util.newBuffer(object.public_key);
            }
        }
        if (message.depth != null && message.hasOwnProperty("depth"))
            object.depth = message.depth;
        if (message.fingerprint != null && message.hasOwnProperty("fingerprint"))
            object.fingerprint = message.fingerprint;
        if (message.child_num != null && message.hasOwnProperty("child_num"))
            object.child_num = message.child_num;
        if (message.chain_code != null && message.hasOwnProperty("chain_code"))
            object.chain_code = options.bytes === String ? $util.base64.encode(message.chain_code, 0, message.chain_code.length) : options.bytes === Array ? Array.prototype.slice.call(message.chain_code) : message.chain_code;
        if (message.private_key != null && message.hasOwnProperty("private_key"))
            object.private_key = options.bytes === String ? $util.base64.encode(message.private_key, 0, message.private_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.private_key) : message.private_key;
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            object.public_key = options.bytes === String ? $util.base64.encode(message.public_key, 0, message.public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.public_key) : message.public_key;
        return object;
    };

    HDNodeType.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return HDNodeType;
})();

$root.BixinPinInputOnDevice = (function() {

    function BixinPinInputOnDevice(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    BixinPinInputOnDevice.create = function create(properties) {
        return new BixinPinInputOnDevice(properties);
    };

    BixinPinInputOnDevice.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    BixinPinInputOnDevice.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    BixinPinInputOnDevice.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BixinPinInputOnDevice();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    BixinPinInputOnDevice.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    BixinPinInputOnDevice.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    BixinPinInputOnDevice.fromObject = function fromObject(object) {
        if (object instanceof $root.BixinPinInputOnDevice)
            return object;
        return new $root.BixinPinInputOnDevice();
    };

    BixinPinInputOnDevice.toObject = function toObject() {
        return {};
    };

    BixinPinInputOnDevice.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return BixinPinInputOnDevice;
})();

$root.ConfluxGetAddress = (function() {

    function ConfluxGetAddress(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ConfluxGetAddress.prototype.address_n = $util.emptyArray;
    ConfluxGetAddress.prototype.show_display = false;
    ConfluxGetAddress.prototype.chain_id = 0;

    ConfluxGetAddress.create = function create(properties) {
        return new ConfluxGetAddress(properties);
    };

    ConfluxGetAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(16).bool(message.show_display);
        if (message.chain_id != null && Object.hasOwnProperty.call(message, "chain_id"))
            writer.uint32(24).uint32(message.chain_id);
        return writer;
    };

    ConfluxGetAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ConfluxGetAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ConfluxGetAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.show_display = reader.bool();
                break;
            case 3:
                message.chain_id = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    ConfluxGetAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ConfluxGetAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        if (message.chain_id != null && message.hasOwnProperty("chain_id"))
            if (!$util.isInteger(message.chain_id))
                return "chain_id: integer expected";
        return null;
    };

    ConfluxGetAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.ConfluxGetAddress)
            return object;
        var message = new $root.ConfluxGetAddress();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".ConfluxGetAddress.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        if (object.chain_id != null)
            message.chain_id = object.chain_id >>> 0;
        return message;
    };

    ConfluxGetAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            object.show_display = false;
            object.chain_id = 0;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        if (message.chain_id != null && message.hasOwnProperty("chain_id"))
            object.chain_id = message.chain_id;
        return object;
    };

    ConfluxGetAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ConfluxGetAddress;
})();

$root.ConfluxAddress = (function() {

    function ConfluxAddress(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ConfluxAddress.prototype.address = "";

    ConfluxAddress.create = function create(properties) {
        return new ConfluxAddress(properties);
    };

    ConfluxAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address != null && Object.hasOwnProperty.call(message, "address"))
            writer.uint32(10).string(message.address);
        return writer;
    };

    ConfluxAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ConfluxAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ConfluxAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    ConfluxAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ConfluxAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address != null && message.hasOwnProperty("address"))
            if (!$util.isString(message.address))
                return "address: string expected";
        return null;
    };

    ConfluxAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.ConfluxAddress)
            return object;
        var message = new $root.ConfluxAddress();
        if (object.address != null)
            message.address = String(object.address);
        return message;
    };

    ConfluxAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.address = "";
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    ConfluxAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ConfluxAddress;
})();

$root.ConfluxSignTx = (function() {

    function ConfluxSignTx(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ConfluxSignTx.prototype.address_n = $util.emptyArray;
    ConfluxSignTx.prototype.nonce = $util.newBuffer([]);
    ConfluxSignTx.prototype.gas_price = $util.newBuffer([]);
    ConfluxSignTx.prototype.gas_limit = $util.newBuffer([]);
    ConfluxSignTx.prototype.to = "";
    ConfluxSignTx.prototype.value = $util.newBuffer([]);
    ConfluxSignTx.prototype.epoch_height = $util.newBuffer([]);
    ConfluxSignTx.prototype.storage_limit = $util.newBuffer([]);
    ConfluxSignTx.prototype.data_initial_chunk = $util.newBuffer([]);
    ConfluxSignTx.prototype.data_length = 0;
    ConfluxSignTx.prototype.chain_id = 0;

    ConfluxSignTx.create = function create(properties) {
        return new ConfluxSignTx(properties);
    };

    ConfluxSignTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.nonce != null && Object.hasOwnProperty.call(message, "nonce"))
            writer.uint32(18).bytes(message.nonce);
        if (message.gas_price != null && Object.hasOwnProperty.call(message, "gas_price"))
            writer.uint32(26).bytes(message.gas_price);
        if (message.gas_limit != null && Object.hasOwnProperty.call(message, "gas_limit"))
            writer.uint32(34).bytes(message.gas_limit);
        if (message.to != null && Object.hasOwnProperty.call(message, "to"))
            writer.uint32(42).string(message.to);
        if (message.value != null && Object.hasOwnProperty.call(message, "value"))
            writer.uint32(50).bytes(message.value);
        if (message.epoch_height != null && Object.hasOwnProperty.call(message, "epoch_height"))
            writer.uint32(58).bytes(message.epoch_height);
        if (message.storage_limit != null && Object.hasOwnProperty.call(message, "storage_limit"))
            writer.uint32(66).bytes(message.storage_limit);
        if (message.data_initial_chunk != null && Object.hasOwnProperty.call(message, "data_initial_chunk"))
            writer.uint32(74).bytes(message.data_initial_chunk);
        if (message.data_length != null && Object.hasOwnProperty.call(message, "data_length"))
            writer.uint32(80).uint32(message.data_length);
        if (message.chain_id != null && Object.hasOwnProperty.call(message, "chain_id"))
            writer.uint32(88).uint32(message.chain_id);
        return writer;
    };

    ConfluxSignTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ConfluxSignTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ConfluxSignTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.nonce = reader.bytes();
                break;
            case 3:
                message.gas_price = reader.bytes();
                break;
            case 4:
                message.gas_limit = reader.bytes();
                break;
            case 5:
                message.to = reader.string();
                break;
            case 6:
                message.value = reader.bytes();
                break;
            case 7:
                message.epoch_height = reader.bytes();
                break;
            case 8:
                message.storage_limit = reader.bytes();
                break;
            case 9:
                message.data_initial_chunk = reader.bytes();
                break;
            case 10:
                message.data_length = reader.uint32();
                break;
            case 11:
                message.chain_id = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    ConfluxSignTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ConfluxSignTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.nonce != null && message.hasOwnProperty("nonce"))
            if (!(message.nonce && typeof message.nonce.length === "number" || $util.isString(message.nonce)))
                return "nonce: buffer expected";
        if (message.gas_price != null && message.hasOwnProperty("gas_price"))
            if (!(message.gas_price && typeof message.gas_price.length === "number" || $util.isString(message.gas_price)))
                return "gas_price: buffer expected";
        if (message.gas_limit != null && message.hasOwnProperty("gas_limit"))
            if (!(message.gas_limit && typeof message.gas_limit.length === "number" || $util.isString(message.gas_limit)))
                return "gas_limit: buffer expected";
        if (message.to != null && message.hasOwnProperty("to"))
            if (!$util.isString(message.to))
                return "to: string expected";
        if (message.value != null && message.hasOwnProperty("value"))
            if (!(message.value && typeof message.value.length === "number" || $util.isString(message.value)))
                return "value: buffer expected";
        if (message.epoch_height != null && message.hasOwnProperty("epoch_height"))
            if (!(message.epoch_height && typeof message.epoch_height.length === "number" || $util.isString(message.epoch_height)))
                return "epoch_height: buffer expected";
        if (message.storage_limit != null && message.hasOwnProperty("storage_limit"))
            if (!(message.storage_limit && typeof message.storage_limit.length === "number" || $util.isString(message.storage_limit)))
                return "storage_limit: buffer expected";
        if (message.data_initial_chunk != null && message.hasOwnProperty("data_initial_chunk"))
            if (!(message.data_initial_chunk && typeof message.data_initial_chunk.length === "number" || $util.isString(message.data_initial_chunk)))
                return "data_initial_chunk: buffer expected";
        if (message.data_length != null && message.hasOwnProperty("data_length"))
            if (!$util.isInteger(message.data_length))
                return "data_length: integer expected";
        if (message.chain_id != null && message.hasOwnProperty("chain_id"))
            if (!$util.isInteger(message.chain_id))
                return "chain_id: integer expected";
        return null;
    };

    ConfluxSignTx.fromObject = function fromObject(object) {
        if (object instanceof $root.ConfluxSignTx)
            return object;
        var message = new $root.ConfluxSignTx();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".ConfluxSignTx.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.nonce != null)
            if (typeof object.nonce === "string")
                $util.base64.decode(object.nonce, message.nonce = $util.newBuffer($util.base64.length(object.nonce)), 0);
            else if (object.nonce.length)
                message.nonce = object.nonce;
        if (object.gas_price != null)
            if (typeof object.gas_price === "string")
                $util.base64.decode(object.gas_price, message.gas_price = $util.newBuffer($util.base64.length(object.gas_price)), 0);
            else if (object.gas_price.length)
                message.gas_price = object.gas_price;
        if (object.gas_limit != null)
            if (typeof object.gas_limit === "string")
                $util.base64.decode(object.gas_limit, message.gas_limit = $util.newBuffer($util.base64.length(object.gas_limit)), 0);
            else if (object.gas_limit.length)
                message.gas_limit = object.gas_limit;
        if (object.to != null)
            message.to = String(object.to);
        if (object.value != null)
            if (typeof object.value === "string")
                $util.base64.decode(object.value, message.value = $util.newBuffer($util.base64.length(object.value)), 0);
            else if (object.value.length)
                message.value = object.value;
        if (object.epoch_height != null)
            if (typeof object.epoch_height === "string")
                $util.base64.decode(object.epoch_height, message.epoch_height = $util.newBuffer($util.base64.length(object.epoch_height)), 0);
            else if (object.epoch_height.length)
                message.epoch_height = object.epoch_height;
        if (object.storage_limit != null)
            if (typeof object.storage_limit === "string")
                $util.base64.decode(object.storage_limit, message.storage_limit = $util.newBuffer($util.base64.length(object.storage_limit)), 0);
            else if (object.storage_limit.length)
                message.storage_limit = object.storage_limit;
        if (object.data_initial_chunk != null)
            if (typeof object.data_initial_chunk === "string")
                $util.base64.decode(object.data_initial_chunk, message.data_initial_chunk = $util.newBuffer($util.base64.length(object.data_initial_chunk)), 0);
            else if (object.data_initial_chunk.length)
                message.data_initial_chunk = object.data_initial_chunk;
        if (object.data_length != null)
            message.data_length = object.data_length >>> 0;
        if (object.chain_id != null)
            message.chain_id = object.chain_id >>> 0;
        return message;
    };

    ConfluxSignTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            if (options.bytes === String)
                object.nonce = "";
            else {
                object.nonce = [];
                if (options.bytes !== Array)
                    object.nonce = $util.newBuffer(object.nonce);
            }
            if (options.bytes === String)
                object.gas_price = "";
            else {
                object.gas_price = [];
                if (options.bytes !== Array)
                    object.gas_price = $util.newBuffer(object.gas_price);
            }
            if (options.bytes === String)
                object.gas_limit = "";
            else {
                object.gas_limit = [];
                if (options.bytes !== Array)
                    object.gas_limit = $util.newBuffer(object.gas_limit);
            }
            object.to = "";
            if (options.bytes === String)
                object.value = "";
            else {
                object.value = [];
                if (options.bytes !== Array)
                    object.value = $util.newBuffer(object.value);
            }
            if (options.bytes === String)
                object.epoch_height = "";
            else {
                object.epoch_height = [];
                if (options.bytes !== Array)
                    object.epoch_height = $util.newBuffer(object.epoch_height);
            }
            if (options.bytes === String)
                object.storage_limit = "";
            else {
                object.storage_limit = [];
                if (options.bytes !== Array)
                    object.storage_limit = $util.newBuffer(object.storage_limit);
            }
            if (options.bytes === String)
                object.data_initial_chunk = "";
            else {
                object.data_initial_chunk = [];
                if (options.bytes !== Array)
                    object.data_initial_chunk = $util.newBuffer(object.data_initial_chunk);
            }
            object.data_length = 0;
            object.chain_id = 0;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.nonce != null && message.hasOwnProperty("nonce"))
            object.nonce = options.bytes === String ? $util.base64.encode(message.nonce, 0, message.nonce.length) : options.bytes === Array ? Array.prototype.slice.call(message.nonce) : message.nonce;
        if (message.gas_price != null && message.hasOwnProperty("gas_price"))
            object.gas_price = options.bytes === String ? $util.base64.encode(message.gas_price, 0, message.gas_price.length) : options.bytes === Array ? Array.prototype.slice.call(message.gas_price) : message.gas_price;
        if (message.gas_limit != null && message.hasOwnProperty("gas_limit"))
            object.gas_limit = options.bytes === String ? $util.base64.encode(message.gas_limit, 0, message.gas_limit.length) : options.bytes === Array ? Array.prototype.slice.call(message.gas_limit) : message.gas_limit;
        if (message.to != null && message.hasOwnProperty("to"))
            object.to = message.to;
        if (message.value != null && message.hasOwnProperty("value"))
            object.value = options.bytes === String ? $util.base64.encode(message.value, 0, message.value.length) : options.bytes === Array ? Array.prototype.slice.call(message.value) : message.value;
        if (message.epoch_height != null && message.hasOwnProperty("epoch_height"))
            object.epoch_height = options.bytes === String ? $util.base64.encode(message.epoch_height, 0, message.epoch_height.length) : options.bytes === Array ? Array.prototype.slice.call(message.epoch_height) : message.epoch_height;
        if (message.storage_limit != null && message.hasOwnProperty("storage_limit"))
            object.storage_limit = options.bytes === String ? $util.base64.encode(message.storage_limit, 0, message.storage_limit.length) : options.bytes === Array ? Array.prototype.slice.call(message.storage_limit) : message.storage_limit;
        if (message.data_initial_chunk != null && message.hasOwnProperty("data_initial_chunk"))
            object.data_initial_chunk = options.bytes === String ? $util.base64.encode(message.data_initial_chunk, 0, message.data_initial_chunk.length) : options.bytes === Array ? Array.prototype.slice.call(message.data_initial_chunk) : message.data_initial_chunk;
        if (message.data_length != null && message.hasOwnProperty("data_length"))
            object.data_length = message.data_length;
        if (message.chain_id != null && message.hasOwnProperty("chain_id"))
            object.chain_id = message.chain_id;
        return object;
    };

    ConfluxSignTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ConfluxSignTx;
})();

$root.ConfluxTxRequest = (function() {

    function ConfluxTxRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ConfluxTxRequest.prototype.data_length = 0;
    ConfluxTxRequest.prototype.signature_v = 0;
    ConfluxTxRequest.prototype.signature_r = $util.newBuffer([]);
    ConfluxTxRequest.prototype.signature_s = $util.newBuffer([]);

    ConfluxTxRequest.create = function create(properties) {
        return new ConfluxTxRequest(properties);
    };

    ConfluxTxRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.data_length != null && Object.hasOwnProperty.call(message, "data_length"))
            writer.uint32(8).uint32(message.data_length);
        if (message.signature_v != null && Object.hasOwnProperty.call(message, "signature_v"))
            writer.uint32(16).uint32(message.signature_v);
        if (message.signature_r != null && Object.hasOwnProperty.call(message, "signature_r"))
            writer.uint32(26).bytes(message.signature_r);
        if (message.signature_s != null && Object.hasOwnProperty.call(message, "signature_s"))
            writer.uint32(34).bytes(message.signature_s);
        return writer;
    };

    ConfluxTxRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ConfluxTxRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ConfluxTxRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.data_length = reader.uint32();
                break;
            case 2:
                message.signature_v = reader.uint32();
                break;
            case 3:
                message.signature_r = reader.bytes();
                break;
            case 4:
                message.signature_s = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    ConfluxTxRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ConfluxTxRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.data_length != null && message.hasOwnProperty("data_length"))
            if (!$util.isInteger(message.data_length))
                return "data_length: integer expected";
        if (message.signature_v != null && message.hasOwnProperty("signature_v"))
            if (!$util.isInteger(message.signature_v))
                return "signature_v: integer expected";
        if (message.signature_r != null && message.hasOwnProperty("signature_r"))
            if (!(message.signature_r && typeof message.signature_r.length === "number" || $util.isString(message.signature_r)))
                return "signature_r: buffer expected";
        if (message.signature_s != null && message.hasOwnProperty("signature_s"))
            if (!(message.signature_s && typeof message.signature_s.length === "number" || $util.isString(message.signature_s)))
                return "signature_s: buffer expected";
        return null;
    };

    ConfluxTxRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.ConfluxTxRequest)
            return object;
        var message = new $root.ConfluxTxRequest();
        if (object.data_length != null)
            message.data_length = object.data_length >>> 0;
        if (object.signature_v != null)
            message.signature_v = object.signature_v >>> 0;
        if (object.signature_r != null)
            if (typeof object.signature_r === "string")
                $util.base64.decode(object.signature_r, message.signature_r = $util.newBuffer($util.base64.length(object.signature_r)), 0);
            else if (object.signature_r.length)
                message.signature_r = object.signature_r;
        if (object.signature_s != null)
            if (typeof object.signature_s === "string")
                $util.base64.decode(object.signature_s, message.signature_s = $util.newBuffer($util.base64.length(object.signature_s)), 0);
            else if (object.signature_s.length)
                message.signature_s = object.signature_s;
        return message;
    };

    ConfluxTxRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.data_length = 0;
            object.signature_v = 0;
            if (options.bytes === String)
                object.signature_r = "";
            else {
                object.signature_r = [];
                if (options.bytes !== Array)
                    object.signature_r = $util.newBuffer(object.signature_r);
            }
            if (options.bytes === String)
                object.signature_s = "";
            else {
                object.signature_s = [];
                if (options.bytes !== Array)
                    object.signature_s = $util.newBuffer(object.signature_s);
            }
        }
        if (message.data_length != null && message.hasOwnProperty("data_length"))
            object.data_length = message.data_length;
        if (message.signature_v != null && message.hasOwnProperty("signature_v"))
            object.signature_v = message.signature_v;
        if (message.signature_r != null && message.hasOwnProperty("signature_r"))
            object.signature_r = options.bytes === String ? $util.base64.encode(message.signature_r, 0, message.signature_r.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature_r) : message.signature_r;
        if (message.signature_s != null && message.hasOwnProperty("signature_s"))
            object.signature_s = options.bytes === String ? $util.base64.encode(message.signature_s, 0, message.signature_s.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature_s) : message.signature_s;
        return object;
    };

    ConfluxTxRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ConfluxTxRequest;
})();

$root.ConfluxTxAck = (function() {

    function ConfluxTxAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ConfluxTxAck.prototype.data_chunk = $util.newBuffer([]);

    ConfluxTxAck.create = function create(properties) {
        return new ConfluxTxAck(properties);
    };

    ConfluxTxAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.data_chunk != null && Object.hasOwnProperty.call(message, "data_chunk"))
            writer.uint32(10).bytes(message.data_chunk);
        return writer;
    };

    ConfluxTxAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ConfluxTxAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ConfluxTxAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.data_chunk = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    ConfluxTxAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ConfluxTxAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.data_chunk != null && message.hasOwnProperty("data_chunk"))
            if (!(message.data_chunk && typeof message.data_chunk.length === "number" || $util.isString(message.data_chunk)))
                return "data_chunk: buffer expected";
        return null;
    };

    ConfluxTxAck.fromObject = function fromObject(object) {
        if (object instanceof $root.ConfluxTxAck)
            return object;
        var message = new $root.ConfluxTxAck();
        if (object.data_chunk != null)
            if (typeof object.data_chunk === "string")
                $util.base64.decode(object.data_chunk, message.data_chunk = $util.newBuffer($util.base64.length(object.data_chunk)), 0);
            else if (object.data_chunk.length)
                message.data_chunk = object.data_chunk;
        return message;
    };

    ConfluxTxAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.data_chunk = "";
            else {
                object.data_chunk = [];
                if (options.bytes !== Array)
                    object.data_chunk = $util.newBuffer(object.data_chunk);
            }
        if (message.data_chunk != null && message.hasOwnProperty("data_chunk"))
            object.data_chunk = options.bytes === String ? $util.base64.encode(message.data_chunk, 0, message.data_chunk.length) : options.bytes === Array ? Array.prototype.slice.call(message.data_chunk) : message.data_chunk;
        return object;
    };

    ConfluxTxAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ConfluxTxAck;
})();

$root.ConfluxSignMessage = (function() {

    function ConfluxSignMessage(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ConfluxSignMessage.prototype.address_n = $util.emptyArray;
    ConfluxSignMessage.prototype.message = $util.newBuffer([]);

    ConfluxSignMessage.create = function create(properties) {
        return new ConfluxSignMessage(properties);
    };

    ConfluxSignMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
            writer.uint32(18).bytes(message.message);
        return writer;
    };

    ConfluxSignMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ConfluxSignMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ConfluxSignMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.message = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    ConfluxSignMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ConfluxSignMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.message != null && message.hasOwnProperty("message"))
            if (!(message.message && typeof message.message.length === "number" || $util.isString(message.message)))
                return "message: buffer expected";
        return null;
    };

    ConfluxSignMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.ConfluxSignMessage)
            return object;
        var message = new $root.ConfluxSignMessage();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".ConfluxSignMessage.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.message != null)
            if (typeof object.message === "string")
                $util.base64.decode(object.message, message.message = $util.newBuffer($util.base64.length(object.message)), 0);
            else if (object.message.length)
                message.message = object.message;
        return message;
    };

    ConfluxSignMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            if (options.bytes === String)
                object.message = "";
            else {
                object.message = [];
                if (options.bytes !== Array)
                    object.message = $util.newBuffer(object.message);
            }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.message != null && message.hasOwnProperty("message"))
            object.message = options.bytes === String ? $util.base64.encode(message.message, 0, message.message.length) : options.bytes === Array ? Array.prototype.slice.call(message.message) : message.message;
        return object;
    };

    ConfluxSignMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ConfluxSignMessage;
})();

$root.ConfluxMessageSignature = (function() {

    function ConfluxMessageSignature(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ConfluxMessageSignature.prototype.signature = $util.newBuffer([]);
    ConfluxMessageSignature.prototype.address = "";

    ConfluxMessageSignature.create = function create(properties) {
        return new ConfluxMessageSignature(properties);
    };

    ConfluxMessageSignature.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.signature != null && Object.hasOwnProperty.call(message, "signature"))
            writer.uint32(18).bytes(message.signature);
        if (message.address != null && Object.hasOwnProperty.call(message, "address"))
            writer.uint32(26).string(message.address);
        return writer;
    };

    ConfluxMessageSignature.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ConfluxMessageSignature.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ConfluxMessageSignature();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 2:
                message.signature = reader.bytes();
                break;
            case 3:
                message.address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    ConfluxMessageSignature.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ConfluxMessageSignature.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.signature != null && message.hasOwnProperty("signature"))
            if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
                return "signature: buffer expected";
        if (message.address != null && message.hasOwnProperty("address"))
            if (!$util.isString(message.address))
                return "address: string expected";
        return null;
    };

    ConfluxMessageSignature.fromObject = function fromObject(object) {
        if (object instanceof $root.ConfluxMessageSignature)
            return object;
        var message = new $root.ConfluxMessageSignature();
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        if (object.address != null)
            message.address = String(object.address);
        return message;
    };

    ConfluxMessageSignature.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
            object.address = "";
        }
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    ConfluxMessageSignature.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ConfluxMessageSignature;
})();

$root.ConfluxSignMessageCIP23 = (function() {

    function ConfluxSignMessageCIP23(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ConfluxSignMessageCIP23.prototype.address_n = $util.emptyArray;
    ConfluxSignMessageCIP23.prototype.domain_hash = $util.newBuffer([]);
    ConfluxSignMessageCIP23.prototype.message_hash = $util.newBuffer([]);

    ConfluxSignMessageCIP23.create = function create(properties) {
        return new ConfluxSignMessageCIP23(properties);
    };

    ConfluxSignMessageCIP23.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.domain_hash != null && Object.hasOwnProperty.call(message, "domain_hash"))
            writer.uint32(18).bytes(message.domain_hash);
        if (message.message_hash != null && Object.hasOwnProperty.call(message, "message_hash"))
            writer.uint32(26).bytes(message.message_hash);
        return writer;
    };

    ConfluxSignMessageCIP23.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ConfluxSignMessageCIP23.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ConfluxSignMessageCIP23();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.domain_hash = reader.bytes();
                break;
            case 3:
                message.message_hash = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    ConfluxSignMessageCIP23.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ConfluxSignMessageCIP23.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.domain_hash != null && message.hasOwnProperty("domain_hash"))
            if (!(message.domain_hash && typeof message.domain_hash.length === "number" || $util.isString(message.domain_hash)))
                return "domain_hash: buffer expected";
        if (message.message_hash != null && message.hasOwnProperty("message_hash"))
            if (!(message.message_hash && typeof message.message_hash.length === "number" || $util.isString(message.message_hash)))
                return "message_hash: buffer expected";
        return null;
    };

    ConfluxSignMessageCIP23.fromObject = function fromObject(object) {
        if (object instanceof $root.ConfluxSignMessageCIP23)
            return object;
        var message = new $root.ConfluxSignMessageCIP23();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".ConfluxSignMessageCIP23.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.domain_hash != null)
            if (typeof object.domain_hash === "string")
                $util.base64.decode(object.domain_hash, message.domain_hash = $util.newBuffer($util.base64.length(object.domain_hash)), 0);
            else if (object.domain_hash.length)
                message.domain_hash = object.domain_hash;
        if (object.message_hash != null)
            if (typeof object.message_hash === "string")
                $util.base64.decode(object.message_hash, message.message_hash = $util.newBuffer($util.base64.length(object.message_hash)), 0);
            else if (object.message_hash.length)
                message.message_hash = object.message_hash;
        return message;
    };

    ConfluxSignMessageCIP23.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            if (options.bytes === String)
                object.domain_hash = "";
            else {
                object.domain_hash = [];
                if (options.bytes !== Array)
                    object.domain_hash = $util.newBuffer(object.domain_hash);
            }
            if (options.bytes === String)
                object.message_hash = "";
            else {
                object.message_hash = [];
                if (options.bytes !== Array)
                    object.message_hash = $util.newBuffer(object.message_hash);
            }
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.domain_hash != null && message.hasOwnProperty("domain_hash"))
            object.domain_hash = options.bytes === String ? $util.base64.encode(message.domain_hash, 0, message.domain_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.domain_hash) : message.domain_hash;
        if (message.message_hash != null && message.hasOwnProperty("message_hash"))
            object.message_hash = options.bytes === String ? $util.base64.encode(message.message_hash, 0, message.message_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.message_hash) : message.message_hash;
        return object;
    };

    ConfluxSignMessageCIP23.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ConfluxSignMessageCIP23;
})();

$root.CosmosGetAddress = (function() {

    function CosmosGetAddress(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CosmosGetAddress.prototype.address_n = $util.emptyArray;
    CosmosGetAddress.prototype.hrp = "";
    CosmosGetAddress.prototype.show_display = false;

    CosmosGetAddress.create = function create(properties) {
        return new CosmosGetAddress(properties);
    };

    CosmosGetAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.hrp != null && Object.hasOwnProperty.call(message, "hrp"))
            writer.uint32(18).string(message.hrp);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(24).bool(message.show_display);
        return writer;
    };

    CosmosGetAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CosmosGetAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CosmosGetAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.hrp = reader.string();
                break;
            case 3:
                message.show_display = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    CosmosGetAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CosmosGetAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.hrp != null && message.hasOwnProperty("hrp"))
            if (!$util.isString(message.hrp))
                return "hrp: string expected";
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        return null;
    };

    CosmosGetAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.CosmosGetAddress)
            return object;
        var message = new $root.CosmosGetAddress();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".CosmosGetAddress.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.hrp != null)
            message.hrp = String(object.hrp);
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        return message;
    };

    CosmosGetAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            object.hrp = "";
            object.show_display = false;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.hrp != null && message.hasOwnProperty("hrp"))
            object.hrp = message.hrp;
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        return object;
    };

    CosmosGetAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CosmosGetAddress;
})();

$root.CosmosAddress = (function() {

    function CosmosAddress(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CosmosAddress.prototype.address = "";

    CosmosAddress.create = function create(properties) {
        return new CosmosAddress(properties);
    };

    CosmosAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address != null && Object.hasOwnProperty.call(message, "address"))
            writer.uint32(10).string(message.address);
        return writer;
    };

    CosmosAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CosmosAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CosmosAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    CosmosAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CosmosAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address != null && message.hasOwnProperty("address"))
            if (!$util.isString(message.address))
                return "address: string expected";
        return null;
    };

    CosmosAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.CosmosAddress)
            return object;
        var message = new $root.CosmosAddress();
        if (object.address != null)
            message.address = String(object.address);
        return message;
    };

    CosmosAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.address = "";
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    CosmosAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CosmosAddress;
})();

$root.CosmosSignTx = (function() {

    function CosmosSignTx(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CosmosSignTx.prototype.address_n = $util.emptyArray;
    CosmosSignTx.prototype.raw_tx = $util.newBuffer([]);

    CosmosSignTx.create = function create(properties) {
        return new CosmosSignTx(properties);
    };

    CosmosSignTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).bytes(message.raw_tx);
        return writer;
    };

    CosmosSignTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CosmosSignTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CosmosSignTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.raw_tx = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("raw_tx"))
            throw $util.ProtocolError("missing required 'raw_tx'", { instance: message });
        return message;
    };

    CosmosSignTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CosmosSignTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!(message.raw_tx && typeof message.raw_tx.length === "number" || $util.isString(message.raw_tx)))
            return "raw_tx: buffer expected";
        return null;
    };

    CosmosSignTx.fromObject = function fromObject(object) {
        if (object instanceof $root.CosmosSignTx)
            return object;
        var message = new $root.CosmosSignTx();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".CosmosSignTx.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.raw_tx != null)
            if (typeof object.raw_tx === "string")
                $util.base64.decode(object.raw_tx, message.raw_tx = $util.newBuffer($util.base64.length(object.raw_tx)), 0);
            else if (object.raw_tx.length)
                message.raw_tx = object.raw_tx;
        return message;
    };

    CosmosSignTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            if (options.bytes === String)
                object.raw_tx = "";
            else {
                object.raw_tx = [];
                if (options.bytes !== Array)
                    object.raw_tx = $util.newBuffer(object.raw_tx);
            }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.raw_tx != null && message.hasOwnProperty("raw_tx"))
            object.raw_tx = options.bytes === String ? $util.base64.encode(message.raw_tx, 0, message.raw_tx.length) : options.bytes === Array ? Array.prototype.slice.call(message.raw_tx) : message.raw_tx;
        return object;
    };

    CosmosSignTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CosmosSignTx;
})();

$root.CosmosSignedTx = (function() {

    function CosmosSignedTx(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CosmosSignedTx.prototype.signature = $util.newBuffer([]);

    CosmosSignedTx.create = function create(properties) {
        return new CosmosSignedTx(properties);
    };

    CosmosSignedTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.signature);
        return writer;
    };

    CosmosSignedTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CosmosSignedTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CosmosSignedTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.signature = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        return message;
    };

    CosmosSignedTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CosmosSignedTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        return null;
    };

    CosmosSignedTx.fromObject = function fromObject(object) {
        if (object instanceof $root.CosmosSignedTx)
            return object;
        var message = new $root.CosmosSignedTx();
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        return message;
    };

    CosmosSignedTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        return object;
    };

    CosmosSignedTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CosmosSignedTx;
})();

$root.CipherKeyValue = (function() {

    function CipherKeyValue(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CipherKeyValue.prototype.address_n = $util.emptyArray;
    CipherKeyValue.prototype.key = "";
    CipherKeyValue.prototype.value = $util.newBuffer([]);
    CipherKeyValue.prototype.encrypt = false;
    CipherKeyValue.prototype.ask_on_encrypt = false;
    CipherKeyValue.prototype.ask_on_decrypt = false;
    CipherKeyValue.prototype.iv = $util.newBuffer([]);

    CipherKeyValue.create = function create(properties) {
        return new CipherKeyValue(properties);
    };

    CipherKeyValue.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).string(message.key);
        writer.uint32(26).bytes(message.value);
        if (message.encrypt != null && Object.hasOwnProperty.call(message, "encrypt"))
            writer.uint32(32).bool(message.encrypt);
        if (message.ask_on_encrypt != null && Object.hasOwnProperty.call(message, "ask_on_encrypt"))
            writer.uint32(40).bool(message.ask_on_encrypt);
        if (message.ask_on_decrypt != null && Object.hasOwnProperty.call(message, "ask_on_decrypt"))
            writer.uint32(48).bool(message.ask_on_decrypt);
        if (message.iv != null && Object.hasOwnProperty.call(message, "iv"))
            writer.uint32(58).bytes(message.iv);
        return writer;
    };

    CipherKeyValue.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CipherKeyValue.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CipherKeyValue();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.key = reader.string();
                break;
            case 3:
                message.value = reader.bytes();
                break;
            case 4:
                message.encrypt = reader.bool();
                break;
            case 5:
                message.ask_on_encrypt = reader.bool();
                break;
            case 6:
                message.ask_on_decrypt = reader.bool();
                break;
            case 7:
                message.iv = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("key"))
            throw $util.ProtocolError("missing required 'key'", { instance: message });
        if (!message.hasOwnProperty("value"))
            throw $util.ProtocolError("missing required 'value'", { instance: message });
        return message;
    };

    CipherKeyValue.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CipherKeyValue.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!$util.isString(message.key))
            return "key: string expected";
        if (!(message.value && typeof message.value.length === "number" || $util.isString(message.value)))
            return "value: buffer expected";
        if (message.encrypt != null && message.hasOwnProperty("encrypt"))
            if (typeof message.encrypt !== "boolean")
                return "encrypt: boolean expected";
        if (message.ask_on_encrypt != null && message.hasOwnProperty("ask_on_encrypt"))
            if (typeof message.ask_on_encrypt !== "boolean")
                return "ask_on_encrypt: boolean expected";
        if (message.ask_on_decrypt != null && message.hasOwnProperty("ask_on_decrypt"))
            if (typeof message.ask_on_decrypt !== "boolean")
                return "ask_on_decrypt: boolean expected";
        if (message.iv != null && message.hasOwnProperty("iv"))
            if (!(message.iv && typeof message.iv.length === "number" || $util.isString(message.iv)))
                return "iv: buffer expected";
        return null;
    };

    CipherKeyValue.fromObject = function fromObject(object) {
        if (object instanceof $root.CipherKeyValue)
            return object;
        var message = new $root.CipherKeyValue();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".CipherKeyValue.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.key != null)
            message.key = String(object.key);
        if (object.value != null)
            if (typeof object.value === "string")
                $util.base64.decode(object.value, message.value = $util.newBuffer($util.base64.length(object.value)), 0);
            else if (object.value.length)
                message.value = object.value;
        if (object.encrypt != null)
            message.encrypt = Boolean(object.encrypt);
        if (object.ask_on_encrypt != null)
            message.ask_on_encrypt = Boolean(object.ask_on_encrypt);
        if (object.ask_on_decrypt != null)
            message.ask_on_decrypt = Boolean(object.ask_on_decrypt);
        if (object.iv != null)
            if (typeof object.iv === "string")
                $util.base64.decode(object.iv, message.iv = $util.newBuffer($util.base64.length(object.iv)), 0);
            else if (object.iv.length)
                message.iv = object.iv;
        return message;
    };

    CipherKeyValue.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            object.key = "";
            if (options.bytes === String)
                object.value = "";
            else {
                object.value = [];
                if (options.bytes !== Array)
                    object.value = $util.newBuffer(object.value);
            }
            object.encrypt = false;
            object.ask_on_encrypt = false;
            object.ask_on_decrypt = false;
            if (options.bytes === String)
                object.iv = "";
            else {
                object.iv = [];
                if (options.bytes !== Array)
                    object.iv = $util.newBuffer(object.iv);
            }
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.key != null && message.hasOwnProperty("key"))
            object.key = message.key;
        if (message.value != null && message.hasOwnProperty("value"))
            object.value = options.bytes === String ? $util.base64.encode(message.value, 0, message.value.length) : options.bytes === Array ? Array.prototype.slice.call(message.value) : message.value;
        if (message.encrypt != null && message.hasOwnProperty("encrypt"))
            object.encrypt = message.encrypt;
        if (message.ask_on_encrypt != null && message.hasOwnProperty("ask_on_encrypt"))
            object.ask_on_encrypt = message.ask_on_encrypt;
        if (message.ask_on_decrypt != null && message.hasOwnProperty("ask_on_decrypt"))
            object.ask_on_decrypt = message.ask_on_decrypt;
        if (message.iv != null && message.hasOwnProperty("iv"))
            object.iv = options.bytes === String ? $util.base64.encode(message.iv, 0, message.iv.length) : options.bytes === Array ? Array.prototype.slice.call(message.iv) : message.iv;
        return object;
    };

    CipherKeyValue.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CipherKeyValue;
})();

$root.CipheredKeyValue = (function() {

    function CipheredKeyValue(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CipheredKeyValue.prototype.value = $util.newBuffer([]);

    CipheredKeyValue.create = function create(properties) {
        return new CipheredKeyValue(properties);
    };

    CipheredKeyValue.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.value);
        return writer;
    };

    CipheredKeyValue.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CipheredKeyValue.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CipheredKeyValue();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.value = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("value"))
            throw $util.ProtocolError("missing required 'value'", { instance: message });
        return message;
    };

    CipheredKeyValue.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CipheredKeyValue.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.value && typeof message.value.length === "number" || $util.isString(message.value)))
            return "value: buffer expected";
        return null;
    };

    CipheredKeyValue.fromObject = function fromObject(object) {
        if (object instanceof $root.CipheredKeyValue)
            return object;
        var message = new $root.CipheredKeyValue();
        if (object.value != null)
            if (typeof object.value === "string")
                $util.base64.decode(object.value, message.value = $util.newBuffer($util.base64.length(object.value)), 0);
            else if (object.value.length)
                message.value = object.value;
        return message;
    };

    CipheredKeyValue.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.value = "";
            else {
                object.value = [];
                if (options.bytes !== Array)
                    object.value = $util.newBuffer(object.value);
            }
        if (message.value != null && message.hasOwnProperty("value"))
            object.value = options.bytes === String ? $util.base64.encode(message.value, 0, message.value.length) : options.bytes === Array ? Array.prototype.slice.call(message.value) : message.value;
        return object;
    };

    CipheredKeyValue.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CipheredKeyValue;
})();

$root.IdentityType = (function() {

    function IdentityType(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    IdentityType.prototype.proto = "";
    IdentityType.prototype.user = "";
    IdentityType.prototype.host = "";
    IdentityType.prototype.port = "";
    IdentityType.prototype.path = "";
    IdentityType.prototype.index = 0;

    IdentityType.create = function create(properties) {
        return new IdentityType(properties);
    };

    IdentityType.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.proto != null && Object.hasOwnProperty.call(message, "proto"))
            writer.uint32(10).string(message.proto);
        if (message.user != null && Object.hasOwnProperty.call(message, "user"))
            writer.uint32(18).string(message.user);
        if (message.host != null && Object.hasOwnProperty.call(message, "host"))
            writer.uint32(26).string(message.host);
        if (message.port != null && Object.hasOwnProperty.call(message, "port"))
            writer.uint32(34).string(message.port);
        if (message.path != null && Object.hasOwnProperty.call(message, "path"))
            writer.uint32(42).string(message.path);
        if (message.index != null && Object.hasOwnProperty.call(message, "index"))
            writer.uint32(48).uint32(message.index);
        return writer;
    };

    IdentityType.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    IdentityType.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.IdentityType();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.proto = reader.string();
                break;
            case 2:
                message.user = reader.string();
                break;
            case 3:
                message.host = reader.string();
                break;
            case 4:
                message.port = reader.string();
                break;
            case 5:
                message.path = reader.string();
                break;
            case 6:
                message.index = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    IdentityType.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    IdentityType.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.proto != null && message.hasOwnProperty("proto"))
            if (!$util.isString(message.proto))
                return "proto: string expected";
        if (message.user != null && message.hasOwnProperty("user"))
            if (!$util.isString(message.user))
                return "user: string expected";
        if (message.host != null && message.hasOwnProperty("host"))
            if (!$util.isString(message.host))
                return "host: string expected";
        if (message.port != null && message.hasOwnProperty("port"))
            if (!$util.isString(message.port))
                return "port: string expected";
        if (message.path != null && message.hasOwnProperty("path"))
            if (!$util.isString(message.path))
                return "path: string expected";
        if (message.index != null && message.hasOwnProperty("index"))
            if (!$util.isInteger(message.index))
                return "index: integer expected";
        return null;
    };

    IdentityType.fromObject = function fromObject(object) {
        if (object instanceof $root.IdentityType)
            return object;
        var message = new $root.IdentityType();
        if (object.proto != null)
            message.proto = String(object.proto);
        if (object.user != null)
            message.user = String(object.user);
        if (object.host != null)
            message.host = String(object.host);
        if (object.port != null)
            message.port = String(object.port);
        if (object.path != null)
            message.path = String(object.path);
        if (object.index != null)
            message.index = object.index >>> 0;
        return message;
    };

    IdentityType.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.proto = "";
            object.user = "";
            object.host = "";
            object.port = "";
            object.path = "";
            object.index = 0;
        }
        if (message.proto != null && message.hasOwnProperty("proto"))
            object.proto = message.proto;
        if (message.user != null && message.hasOwnProperty("user"))
            object.user = message.user;
        if (message.host != null && message.hasOwnProperty("host"))
            object.host = message.host;
        if (message.port != null && message.hasOwnProperty("port"))
            object.port = message.port;
        if (message.path != null && message.hasOwnProperty("path"))
            object.path = message.path;
        if (message.index != null && message.hasOwnProperty("index"))
            object.index = message.index;
        return object;
    };

    IdentityType.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return IdentityType;
})();

$root.SignIdentity = (function() {

    function SignIdentity(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    SignIdentity.prototype.identity = null;
    SignIdentity.prototype.challenge_hidden = $util.newBuffer([]);
    SignIdentity.prototype.challenge_visual = "";
    SignIdentity.prototype.ecdsa_curve_name = "";

    SignIdentity.create = function create(properties) {
        return new SignIdentity(properties);
    };

    SignIdentity.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        $root.IdentityType.encode(message.identity, writer.uint32(10).fork()).ldelim();
        if (message.challenge_hidden != null && Object.hasOwnProperty.call(message, "challenge_hidden"))
            writer.uint32(18).bytes(message.challenge_hidden);
        if (message.challenge_visual != null && Object.hasOwnProperty.call(message, "challenge_visual"))
            writer.uint32(26).string(message.challenge_visual);
        if (message.ecdsa_curve_name != null && Object.hasOwnProperty.call(message, "ecdsa_curve_name"))
            writer.uint32(34).string(message.ecdsa_curve_name);
        return writer;
    };

    SignIdentity.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    SignIdentity.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SignIdentity();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.identity = $root.IdentityType.decode(reader, reader.uint32());
                break;
            case 2:
                message.challenge_hidden = reader.bytes();
                break;
            case 3:
                message.challenge_visual = reader.string();
                break;
            case 4:
                message.ecdsa_curve_name = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("identity"))
            throw $util.ProtocolError("missing required 'identity'", { instance: message });
        return message;
    };

    SignIdentity.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    SignIdentity.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        {
            var error = $root.IdentityType.verify(message.identity);
            if (error)
                return "identity." + error;
        }
        if (message.challenge_hidden != null && message.hasOwnProperty("challenge_hidden"))
            if (!(message.challenge_hidden && typeof message.challenge_hidden.length === "number" || $util.isString(message.challenge_hidden)))
                return "challenge_hidden: buffer expected";
        if (message.challenge_visual != null && message.hasOwnProperty("challenge_visual"))
            if (!$util.isString(message.challenge_visual))
                return "challenge_visual: string expected";
        if (message.ecdsa_curve_name != null && message.hasOwnProperty("ecdsa_curve_name"))
            if (!$util.isString(message.ecdsa_curve_name))
                return "ecdsa_curve_name: string expected";
        return null;
    };

    SignIdentity.fromObject = function fromObject(object) {
        if (object instanceof $root.SignIdentity)
            return object;
        var message = new $root.SignIdentity();
        if (object.identity != null) {
            if (typeof object.identity !== "object")
                throw TypeError(".SignIdentity.identity: object expected");
            message.identity = $root.IdentityType.fromObject(object.identity);
        }
        if (object.challenge_hidden != null)
            if (typeof object.challenge_hidden === "string")
                $util.base64.decode(object.challenge_hidden, message.challenge_hidden = $util.newBuffer($util.base64.length(object.challenge_hidden)), 0);
            else if (object.challenge_hidden.length)
                message.challenge_hidden = object.challenge_hidden;
        if (object.challenge_visual != null)
            message.challenge_visual = String(object.challenge_visual);
        if (object.ecdsa_curve_name != null)
            message.ecdsa_curve_name = String(object.ecdsa_curve_name);
        return message;
    };

    SignIdentity.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.identity = null;
            if (options.bytes === String)
                object.challenge_hidden = "";
            else {
                object.challenge_hidden = [];
                if (options.bytes !== Array)
                    object.challenge_hidden = $util.newBuffer(object.challenge_hidden);
            }
            object.challenge_visual = "";
            object.ecdsa_curve_name = "";
        }
        if (message.identity != null && message.hasOwnProperty("identity"))
            object.identity = $root.IdentityType.toObject(message.identity, options);
        if (message.challenge_hidden != null && message.hasOwnProperty("challenge_hidden"))
            object.challenge_hidden = options.bytes === String ? $util.base64.encode(message.challenge_hidden, 0, message.challenge_hidden.length) : options.bytes === Array ? Array.prototype.slice.call(message.challenge_hidden) : message.challenge_hidden;
        if (message.challenge_visual != null && message.hasOwnProperty("challenge_visual"))
            object.challenge_visual = message.challenge_visual;
        if (message.ecdsa_curve_name != null && message.hasOwnProperty("ecdsa_curve_name"))
            object.ecdsa_curve_name = message.ecdsa_curve_name;
        return object;
    };

    SignIdentity.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SignIdentity;
})();

$root.SignedIdentity = (function() {

    function SignedIdentity(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    SignedIdentity.prototype.address = "";
    SignedIdentity.prototype.public_key = $util.newBuffer([]);
    SignedIdentity.prototype.signature = $util.newBuffer([]);

    SignedIdentity.create = function create(properties) {
        return new SignedIdentity(properties);
    };

    SignedIdentity.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address != null && Object.hasOwnProperty.call(message, "address"))
            writer.uint32(10).string(message.address);
        writer.uint32(18).bytes(message.public_key);
        writer.uint32(26).bytes(message.signature);
        return writer;
    };

    SignedIdentity.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    SignedIdentity.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SignedIdentity();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.string();
                break;
            case 2:
                message.public_key = reader.bytes();
                break;
            case 3:
                message.signature = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("public_key"))
            throw $util.ProtocolError("missing required 'public_key'", { instance: message });
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        return message;
    };

    SignedIdentity.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    SignedIdentity.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address != null && message.hasOwnProperty("address"))
            if (!$util.isString(message.address))
                return "address: string expected";
        if (!(message.public_key && typeof message.public_key.length === "number" || $util.isString(message.public_key)))
            return "public_key: buffer expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        return null;
    };

    SignedIdentity.fromObject = function fromObject(object) {
        if (object instanceof $root.SignedIdentity)
            return object;
        var message = new $root.SignedIdentity();
        if (object.address != null)
            message.address = String(object.address);
        if (object.public_key != null)
            if (typeof object.public_key === "string")
                $util.base64.decode(object.public_key, message.public_key = $util.newBuffer($util.base64.length(object.public_key)), 0);
            else if (object.public_key.length)
                message.public_key = object.public_key;
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        return message;
    };

    SignedIdentity.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.address = "";
            if (options.bytes === String)
                object.public_key = "";
            else {
                object.public_key = [];
                if (options.bytes !== Array)
                    object.public_key = $util.newBuffer(object.public_key);
            }
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
        }
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            object.public_key = options.bytes === String ? $util.base64.encode(message.public_key, 0, message.public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.public_key) : message.public_key;
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        return object;
    };

    SignedIdentity.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SignedIdentity;
})();

$root.GetECDHSessionKey = (function() {

    function GetECDHSessionKey(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    GetECDHSessionKey.prototype.identity = null;
    GetECDHSessionKey.prototype.peer_public_key = $util.newBuffer([]);
    GetECDHSessionKey.prototype.ecdsa_curve_name = "";

    GetECDHSessionKey.create = function create(properties) {
        return new GetECDHSessionKey(properties);
    };

    GetECDHSessionKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        $root.IdentityType.encode(message.identity, writer.uint32(10).fork()).ldelim();
        writer.uint32(18).bytes(message.peer_public_key);
        if (message.ecdsa_curve_name != null && Object.hasOwnProperty.call(message, "ecdsa_curve_name"))
            writer.uint32(26).string(message.ecdsa_curve_name);
        return writer;
    };

    GetECDHSessionKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    GetECDHSessionKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.GetECDHSessionKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.identity = $root.IdentityType.decode(reader, reader.uint32());
                break;
            case 2:
                message.peer_public_key = reader.bytes();
                break;
            case 3:
                message.ecdsa_curve_name = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("identity"))
            throw $util.ProtocolError("missing required 'identity'", { instance: message });
        if (!message.hasOwnProperty("peer_public_key"))
            throw $util.ProtocolError("missing required 'peer_public_key'", { instance: message });
        return message;
    };

    GetECDHSessionKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    GetECDHSessionKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        {
            var error = $root.IdentityType.verify(message.identity);
            if (error)
                return "identity." + error;
        }
        if (!(message.peer_public_key && typeof message.peer_public_key.length === "number" || $util.isString(message.peer_public_key)))
            return "peer_public_key: buffer expected";
        if (message.ecdsa_curve_name != null && message.hasOwnProperty("ecdsa_curve_name"))
            if (!$util.isString(message.ecdsa_curve_name))
                return "ecdsa_curve_name: string expected";
        return null;
    };

    GetECDHSessionKey.fromObject = function fromObject(object) {
        if (object instanceof $root.GetECDHSessionKey)
            return object;
        var message = new $root.GetECDHSessionKey();
        if (object.identity != null) {
            if (typeof object.identity !== "object")
                throw TypeError(".GetECDHSessionKey.identity: object expected");
            message.identity = $root.IdentityType.fromObject(object.identity);
        }
        if (object.peer_public_key != null)
            if (typeof object.peer_public_key === "string")
                $util.base64.decode(object.peer_public_key, message.peer_public_key = $util.newBuffer($util.base64.length(object.peer_public_key)), 0);
            else if (object.peer_public_key.length)
                message.peer_public_key = object.peer_public_key;
        if (object.ecdsa_curve_name != null)
            message.ecdsa_curve_name = String(object.ecdsa_curve_name);
        return message;
    };

    GetECDHSessionKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.identity = null;
            if (options.bytes === String)
                object.peer_public_key = "";
            else {
                object.peer_public_key = [];
                if (options.bytes !== Array)
                    object.peer_public_key = $util.newBuffer(object.peer_public_key);
            }
            object.ecdsa_curve_name = "";
        }
        if (message.identity != null && message.hasOwnProperty("identity"))
            object.identity = $root.IdentityType.toObject(message.identity, options);
        if (message.peer_public_key != null && message.hasOwnProperty("peer_public_key"))
            object.peer_public_key = options.bytes === String ? $util.base64.encode(message.peer_public_key, 0, message.peer_public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.peer_public_key) : message.peer_public_key;
        if (message.ecdsa_curve_name != null && message.hasOwnProperty("ecdsa_curve_name"))
            object.ecdsa_curve_name = message.ecdsa_curve_name;
        return object;
    };

    GetECDHSessionKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return GetECDHSessionKey;
})();

$root.ECDHSessionKey = (function() {

    function ECDHSessionKey(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ECDHSessionKey.prototype.session_key = $util.newBuffer([]);
    ECDHSessionKey.prototype.public_key = $util.newBuffer([]);

    ECDHSessionKey.create = function create(properties) {
        return new ECDHSessionKey(properties);
    };

    ECDHSessionKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.session_key);
        if (message.public_key != null && Object.hasOwnProperty.call(message, "public_key"))
            writer.uint32(18).bytes(message.public_key);
        return writer;
    };

    ECDHSessionKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ECDHSessionKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ECDHSessionKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.session_key = reader.bytes();
                break;
            case 2:
                message.public_key = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("session_key"))
            throw $util.ProtocolError("missing required 'session_key'", { instance: message });
        return message;
    };

    ECDHSessionKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ECDHSessionKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.session_key && typeof message.session_key.length === "number" || $util.isString(message.session_key)))
            return "session_key: buffer expected";
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            if (!(message.public_key && typeof message.public_key.length === "number" || $util.isString(message.public_key)))
                return "public_key: buffer expected";
        return null;
    };

    ECDHSessionKey.fromObject = function fromObject(object) {
        if (object instanceof $root.ECDHSessionKey)
            return object;
        var message = new $root.ECDHSessionKey();
        if (object.session_key != null)
            if (typeof object.session_key === "string")
                $util.base64.decode(object.session_key, message.session_key = $util.newBuffer($util.base64.length(object.session_key)), 0);
            else if (object.session_key.length)
                message.session_key = object.session_key;
        if (object.public_key != null)
            if (typeof object.public_key === "string")
                $util.base64.decode(object.public_key, message.public_key = $util.newBuffer($util.base64.length(object.public_key)), 0);
            else if (object.public_key.length)
                message.public_key = object.public_key;
        return message;
    };

    ECDHSessionKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.session_key = "";
            else {
                object.session_key = [];
                if (options.bytes !== Array)
                    object.session_key = $util.newBuffer(object.session_key);
            }
            if (options.bytes === String)
                object.public_key = "";
            else {
                object.public_key = [];
                if (options.bytes !== Array)
                    object.public_key = $util.newBuffer(object.public_key);
            }
        }
        if (message.session_key != null && message.hasOwnProperty("session_key"))
            object.session_key = options.bytes === String ? $util.base64.encode(message.session_key, 0, message.session_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.session_key) : message.session_key;
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            object.public_key = options.bytes === String ? $util.base64.encode(message.public_key, 0, message.public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.public_key) : message.public_key;
        return object;
    };

    ECDHSessionKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ECDHSessionKey;
})();

$root.CosiCommit = (function() {

    function CosiCommit(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CosiCommit.prototype.address_n = $util.emptyArray;
    CosiCommit.prototype.data = $util.newBuffer([]);

    CosiCommit.create = function create(properties) {
        return new CosiCommit(properties);
    };

    CosiCommit.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.data != null && Object.hasOwnProperty.call(message, "data"))
            writer.uint32(18).bytes(message.data);
        return writer;
    };

    CosiCommit.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CosiCommit.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CosiCommit();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.data = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    CosiCommit.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CosiCommit.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.data != null && message.hasOwnProperty("data"))
            if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
                return "data: buffer expected";
        return null;
    };

    CosiCommit.fromObject = function fromObject(object) {
        if (object instanceof $root.CosiCommit)
            return object;
        var message = new $root.CosiCommit();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".CosiCommit.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.data != null)
            if (typeof object.data === "string")
                $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
            else if (object.data.length)
                message.data = object.data;
        return message;
    };

    CosiCommit.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            if (options.bytes === String)
                object.data = "";
            else {
                object.data = [];
                if (options.bytes !== Array)
                    object.data = $util.newBuffer(object.data);
            }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.data != null && message.hasOwnProperty("data"))
            object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
        return object;
    };

    CosiCommit.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CosiCommit;
})();

$root.CosiCommitment = (function() {

    function CosiCommitment(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CosiCommitment.prototype.commitment = $util.newBuffer([]);
    CosiCommitment.prototype.pubkey = $util.newBuffer([]);

    CosiCommitment.create = function create(properties) {
        return new CosiCommitment(properties);
    };

    CosiCommitment.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.commitment != null && Object.hasOwnProperty.call(message, "commitment"))
            writer.uint32(10).bytes(message.commitment);
        if (message.pubkey != null && Object.hasOwnProperty.call(message, "pubkey"))
            writer.uint32(18).bytes(message.pubkey);
        return writer;
    };

    CosiCommitment.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CosiCommitment.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CosiCommitment();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.commitment = reader.bytes();
                break;
            case 2:
                message.pubkey = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    CosiCommitment.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CosiCommitment.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.commitment != null && message.hasOwnProperty("commitment"))
            if (!(message.commitment && typeof message.commitment.length === "number" || $util.isString(message.commitment)))
                return "commitment: buffer expected";
        if (message.pubkey != null && message.hasOwnProperty("pubkey"))
            if (!(message.pubkey && typeof message.pubkey.length === "number" || $util.isString(message.pubkey)))
                return "pubkey: buffer expected";
        return null;
    };

    CosiCommitment.fromObject = function fromObject(object) {
        if (object instanceof $root.CosiCommitment)
            return object;
        var message = new $root.CosiCommitment();
        if (object.commitment != null)
            if (typeof object.commitment === "string")
                $util.base64.decode(object.commitment, message.commitment = $util.newBuffer($util.base64.length(object.commitment)), 0);
            else if (object.commitment.length)
                message.commitment = object.commitment;
        if (object.pubkey != null)
            if (typeof object.pubkey === "string")
                $util.base64.decode(object.pubkey, message.pubkey = $util.newBuffer($util.base64.length(object.pubkey)), 0);
            else if (object.pubkey.length)
                message.pubkey = object.pubkey;
        return message;
    };

    CosiCommitment.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.commitment = "";
            else {
                object.commitment = [];
                if (options.bytes !== Array)
                    object.commitment = $util.newBuffer(object.commitment);
            }
            if (options.bytes === String)
                object.pubkey = "";
            else {
                object.pubkey = [];
                if (options.bytes !== Array)
                    object.pubkey = $util.newBuffer(object.pubkey);
            }
        }
        if (message.commitment != null && message.hasOwnProperty("commitment"))
            object.commitment = options.bytes === String ? $util.base64.encode(message.commitment, 0, message.commitment.length) : options.bytes === Array ? Array.prototype.slice.call(message.commitment) : message.commitment;
        if (message.pubkey != null && message.hasOwnProperty("pubkey"))
            object.pubkey = options.bytes === String ? $util.base64.encode(message.pubkey, 0, message.pubkey.length) : options.bytes === Array ? Array.prototype.slice.call(message.pubkey) : message.pubkey;
        return object;
    };

    CosiCommitment.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CosiCommitment;
})();

$root.CosiSign = (function() {

    function CosiSign(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CosiSign.prototype.address_n = $util.emptyArray;
    CosiSign.prototype.data = $util.newBuffer([]);
    CosiSign.prototype.global_commitment = $util.newBuffer([]);
    CosiSign.prototype.global_pubkey = $util.newBuffer([]);

    CosiSign.create = function create(properties) {
        return new CosiSign(properties);
    };

    CosiSign.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.data != null && Object.hasOwnProperty.call(message, "data"))
            writer.uint32(18).bytes(message.data);
        if (message.global_commitment != null && Object.hasOwnProperty.call(message, "global_commitment"))
            writer.uint32(26).bytes(message.global_commitment);
        if (message.global_pubkey != null && Object.hasOwnProperty.call(message, "global_pubkey"))
            writer.uint32(34).bytes(message.global_pubkey);
        return writer;
    };

    CosiSign.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CosiSign.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CosiSign();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.data = reader.bytes();
                break;
            case 3:
                message.global_commitment = reader.bytes();
                break;
            case 4:
                message.global_pubkey = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    CosiSign.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CosiSign.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.data != null && message.hasOwnProperty("data"))
            if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
                return "data: buffer expected";
        if (message.global_commitment != null && message.hasOwnProperty("global_commitment"))
            if (!(message.global_commitment && typeof message.global_commitment.length === "number" || $util.isString(message.global_commitment)))
                return "global_commitment: buffer expected";
        if (message.global_pubkey != null && message.hasOwnProperty("global_pubkey"))
            if (!(message.global_pubkey && typeof message.global_pubkey.length === "number" || $util.isString(message.global_pubkey)))
                return "global_pubkey: buffer expected";
        return null;
    };

    CosiSign.fromObject = function fromObject(object) {
        if (object instanceof $root.CosiSign)
            return object;
        var message = new $root.CosiSign();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".CosiSign.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.data != null)
            if (typeof object.data === "string")
                $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
            else if (object.data.length)
                message.data = object.data;
        if (object.global_commitment != null)
            if (typeof object.global_commitment === "string")
                $util.base64.decode(object.global_commitment, message.global_commitment = $util.newBuffer($util.base64.length(object.global_commitment)), 0);
            else if (object.global_commitment.length)
                message.global_commitment = object.global_commitment;
        if (object.global_pubkey != null)
            if (typeof object.global_pubkey === "string")
                $util.base64.decode(object.global_pubkey, message.global_pubkey = $util.newBuffer($util.base64.length(object.global_pubkey)), 0);
            else if (object.global_pubkey.length)
                message.global_pubkey = object.global_pubkey;
        return message;
    };

    CosiSign.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            if (options.bytes === String)
                object.data = "";
            else {
                object.data = [];
                if (options.bytes !== Array)
                    object.data = $util.newBuffer(object.data);
            }
            if (options.bytes === String)
                object.global_commitment = "";
            else {
                object.global_commitment = [];
                if (options.bytes !== Array)
                    object.global_commitment = $util.newBuffer(object.global_commitment);
            }
            if (options.bytes === String)
                object.global_pubkey = "";
            else {
                object.global_pubkey = [];
                if (options.bytes !== Array)
                    object.global_pubkey = $util.newBuffer(object.global_pubkey);
            }
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.data != null && message.hasOwnProperty("data"))
            object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
        if (message.global_commitment != null && message.hasOwnProperty("global_commitment"))
            object.global_commitment = options.bytes === String ? $util.base64.encode(message.global_commitment, 0, message.global_commitment.length) : options.bytes === Array ? Array.prototype.slice.call(message.global_commitment) : message.global_commitment;
        if (message.global_pubkey != null && message.hasOwnProperty("global_pubkey"))
            object.global_pubkey = options.bytes === String ? $util.base64.encode(message.global_pubkey, 0, message.global_pubkey.length) : options.bytes === Array ? Array.prototype.slice.call(message.global_pubkey) : message.global_pubkey;
        return object;
    };

    CosiSign.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CosiSign;
})();

$root.CosiSignature = (function() {

    function CosiSignature(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CosiSignature.prototype.signature = $util.newBuffer([]);

    CosiSignature.create = function create(properties) {
        return new CosiSignature(properties);
    };

    CosiSignature.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.signature);
        return writer;
    };

    CosiSignature.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CosiSignature.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CosiSignature();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.signature = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        return message;
    };

    CosiSignature.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CosiSignature.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        return null;
    };

    CosiSignature.fromObject = function fromObject(object) {
        if (object instanceof $root.CosiSignature)
            return object;
        var message = new $root.CosiSignature();
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        return message;
    };

    CosiSignature.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        return object;
    };

    CosiSignature.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CosiSignature;
})();

$root.BatchGetPublickeys = (function() {

    function BatchGetPublickeys(properties) {
        this.paths = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    BatchGetPublickeys.prototype.ecdsa_curve_name = "ed25519";
    BatchGetPublickeys.prototype.paths = $util.emptyArray;

    BatchGetPublickeys.create = function create(properties) {
        return new BatchGetPublickeys(properties);
    };

    BatchGetPublickeys.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.ecdsa_curve_name != null && Object.hasOwnProperty.call(message, "ecdsa_curve_name"))
            writer.uint32(10).string(message.ecdsa_curve_name);
        if (message.paths != null && message.paths.length)
            for (var i = 0; i < message.paths.length; ++i)
                $root.BatchGetPublickeys.Path.encode(message.paths[i], writer.uint32(18).fork()).ldelim();
        return writer;
    };

    BatchGetPublickeys.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    BatchGetPublickeys.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BatchGetPublickeys();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.ecdsa_curve_name = reader.string();
                break;
            case 2:
                if (!(message.paths && message.paths.length))
                    message.paths = [];
                message.paths.push($root.BatchGetPublickeys.Path.decode(reader, reader.uint32()));
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    BatchGetPublickeys.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    BatchGetPublickeys.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.ecdsa_curve_name != null && message.hasOwnProperty("ecdsa_curve_name"))
            if (!$util.isString(message.ecdsa_curve_name))
                return "ecdsa_curve_name: string expected";
        if (message.paths != null && message.hasOwnProperty("paths")) {
            if (!Array.isArray(message.paths))
                return "paths: array expected";
            for (var i = 0; i < message.paths.length; ++i) {
                var error = $root.BatchGetPublickeys.Path.verify(message.paths[i]);
                if (error)
                    return "paths." + error;
            }
        }
        return null;
    };

    BatchGetPublickeys.fromObject = function fromObject(object) {
        if (object instanceof $root.BatchGetPublickeys)
            return object;
        var message = new $root.BatchGetPublickeys();
        if (object.ecdsa_curve_name != null)
            message.ecdsa_curve_name = String(object.ecdsa_curve_name);
        if (object.paths) {
            if (!Array.isArray(object.paths))
                throw TypeError(".BatchGetPublickeys.paths: array expected");
            message.paths = [];
            for (var i = 0; i < object.paths.length; ++i) {
                if (typeof object.paths[i] !== "object")
                    throw TypeError(".BatchGetPublickeys.paths: object expected");
                message.paths[i] = $root.BatchGetPublickeys.Path.fromObject(object.paths[i]);
            }
        }
        return message;
    };

    BatchGetPublickeys.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.paths = [];
        if (options.defaults)
            object.ecdsa_curve_name = "ed25519";
        if (message.ecdsa_curve_name != null && message.hasOwnProperty("ecdsa_curve_name"))
            object.ecdsa_curve_name = message.ecdsa_curve_name;
        if (message.paths && message.paths.length) {
            object.paths = [];
            for (var j = 0; j < message.paths.length; ++j)
                object.paths[j] = $root.BatchGetPublickeys.Path.toObject(message.paths[j], options);
        }
        return object;
    };

    BatchGetPublickeys.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    BatchGetPublickeys.Path = (function() {

        function Path(properties) {
            this.address_n = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        Path.prototype.address_n = $util.emptyArray;

        Path.create = function create(properties) {
            return new Path(properties);
        };

        Path.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.address_n != null && message.address_n.length)
                for (var i = 0; i < message.address_n.length; ++i)
                    writer.uint32(8).uint32(message.address_n[i]);
            return writer;
        };

        Path.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        Path.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BatchGetPublickeys.Path();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.address_n && message.address_n.length))
                        message.address_n = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.address_n.push(reader.uint32());
                    } else
                        message.address_n.push(reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        Path.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        Path.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.address_n != null && message.hasOwnProperty("address_n")) {
                if (!Array.isArray(message.address_n))
                    return "address_n: array expected";
                for (var i = 0; i < message.address_n.length; ++i)
                    if (!$util.isInteger(message.address_n[i]))
                        return "address_n: integer[] expected";
            }
            return null;
        };

        Path.fromObject = function fromObject(object) {
            if (object instanceof $root.BatchGetPublickeys.Path)
                return object;
            var message = new $root.BatchGetPublickeys.Path();
            if (object.address_n) {
                if (!Array.isArray(object.address_n))
                    throw TypeError(".BatchGetPublickeys.Path.address_n: array expected");
                message.address_n = [];
                for (var i = 0; i < object.address_n.length; ++i)
                    message.address_n[i] = object.address_n[i] >>> 0;
            }
            return message;
        };

        Path.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.address_n = [];
            if (message.address_n && message.address_n.length) {
                object.address_n = [];
                for (var j = 0; j < message.address_n.length; ++j)
                    object.address_n[j] = message.address_n[j];
            }
            return object;
        };

        Path.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Path;
    })();

    return BatchGetPublickeys;
})();

$root.EcdsaPublicKeys = (function() {

    function EcdsaPublicKeys(properties) {
        this.public_keys = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EcdsaPublicKeys.prototype.public_keys = $util.emptyArray;

    EcdsaPublicKeys.create = function create(properties) {
        return new EcdsaPublicKeys(properties);
    };

    EcdsaPublicKeys.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.public_keys != null && message.public_keys.length)
            for (var i = 0; i < message.public_keys.length; ++i)
                writer.uint32(10).bytes(message.public_keys[i]);
        return writer;
    };

    EcdsaPublicKeys.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EcdsaPublicKeys.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EcdsaPublicKeys();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.public_keys && message.public_keys.length))
                    message.public_keys = [];
                message.public_keys.push(reader.bytes());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    EcdsaPublicKeys.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EcdsaPublicKeys.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.public_keys != null && message.hasOwnProperty("public_keys")) {
            if (!Array.isArray(message.public_keys))
                return "public_keys: array expected";
            for (var i = 0; i < message.public_keys.length; ++i)
                if (!(message.public_keys[i] && typeof message.public_keys[i].length === "number" || $util.isString(message.public_keys[i])))
                    return "public_keys: buffer[] expected";
        }
        return null;
    };

    EcdsaPublicKeys.fromObject = function fromObject(object) {
        if (object instanceof $root.EcdsaPublicKeys)
            return object;
        var message = new $root.EcdsaPublicKeys();
        if (object.public_keys) {
            if (!Array.isArray(object.public_keys))
                throw TypeError(".EcdsaPublicKeys.public_keys: array expected");
            message.public_keys = [];
            for (var i = 0; i < object.public_keys.length; ++i)
                if (typeof object.public_keys[i] === "string")
                    $util.base64.decode(object.public_keys[i], message.public_keys[i] = $util.newBuffer($util.base64.length(object.public_keys[i])), 0);
                else if (object.public_keys[i].length)
                    message.public_keys[i] = object.public_keys[i];
        }
        return message;
    };

    EcdsaPublicKeys.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.public_keys = [];
        if (message.public_keys && message.public_keys.length) {
            object.public_keys = [];
            for (var j = 0; j < message.public_keys.length; ++j)
                object.public_keys[j] = options.bytes === String ? $util.base64.encode(message.public_keys[j], 0, message.public_keys[j].length) : options.bytes === Array ? Array.prototype.slice.call(message.public_keys[j]) : message.public_keys[j];
        }
        return object;
    };

    EcdsaPublicKeys.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EcdsaPublicKeys;
})();

$root.DebugLinkDecision = (function() {

    function DebugLinkDecision(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DebugLinkDecision.prototype.yes_no = false;
    DebugLinkDecision.prototype.swipe = 0;
    DebugLinkDecision.prototype.input = "";
    DebugLinkDecision.prototype.x = 0;
    DebugLinkDecision.prototype.y = 0;
    DebugLinkDecision.prototype.wait = false;
    DebugLinkDecision.prototype.hold_ms = 0;

    DebugLinkDecision.create = function create(properties) {
        return new DebugLinkDecision(properties);
    };

    DebugLinkDecision.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.yes_no != null && Object.hasOwnProperty.call(message, "yes_no"))
            writer.uint32(8).bool(message.yes_no);
        if (message.swipe != null && Object.hasOwnProperty.call(message, "swipe"))
            writer.uint32(16).int32(message.swipe);
        if (message.input != null && Object.hasOwnProperty.call(message, "input"))
            writer.uint32(26).string(message.input);
        if (message.x != null && Object.hasOwnProperty.call(message, "x"))
            writer.uint32(32).uint32(message.x);
        if (message.y != null && Object.hasOwnProperty.call(message, "y"))
            writer.uint32(40).uint32(message.y);
        if (message.wait != null && Object.hasOwnProperty.call(message, "wait"))
            writer.uint32(48).bool(message.wait);
        if (message.hold_ms != null && Object.hasOwnProperty.call(message, "hold_ms"))
            writer.uint32(56).uint32(message.hold_ms);
        return writer;
    };

    DebugLinkDecision.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DebugLinkDecision.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DebugLinkDecision();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.yes_no = reader.bool();
                break;
            case 2:
                message.swipe = reader.int32();
                break;
            case 3:
                message.input = reader.string();
                break;
            case 4:
                message.x = reader.uint32();
                break;
            case 5:
                message.y = reader.uint32();
                break;
            case 6:
                message.wait = reader.bool();
                break;
            case 7:
                message.hold_ms = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    DebugLinkDecision.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DebugLinkDecision.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.yes_no != null && message.hasOwnProperty("yes_no"))
            if (typeof message.yes_no !== "boolean")
                return "yes_no: boolean expected";
        if (message.swipe != null && message.hasOwnProperty("swipe"))
            switch (message.swipe) {
            default:
                return "swipe: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
                break;
            }
        if (message.input != null && message.hasOwnProperty("input"))
            if (!$util.isString(message.input))
                return "input: string expected";
        if (message.x != null && message.hasOwnProperty("x"))
            if (!$util.isInteger(message.x))
                return "x: integer expected";
        if (message.y != null && message.hasOwnProperty("y"))
            if (!$util.isInteger(message.y))
                return "y: integer expected";
        if (message.wait != null && message.hasOwnProperty("wait"))
            if (typeof message.wait !== "boolean")
                return "wait: boolean expected";
        if (message.hold_ms != null && message.hasOwnProperty("hold_ms"))
            if (!$util.isInteger(message.hold_ms))
                return "hold_ms: integer expected";
        return null;
    };

    DebugLinkDecision.fromObject = function fromObject(object) {
        if (object instanceof $root.DebugLinkDecision)
            return object;
        var message = new $root.DebugLinkDecision();
        if (object.yes_no != null)
            message.yes_no = Boolean(object.yes_no);
        switch (object.swipe) {
        case "UP":
        case 0:
            message.swipe = 0;
            break;
        case "DOWN":
        case 1:
            message.swipe = 1;
            break;
        case "LEFT":
        case 2:
            message.swipe = 2;
            break;
        case "RIGHT":
        case 3:
            message.swipe = 3;
            break;
        }
        if (object.input != null)
            message.input = String(object.input);
        if (object.x != null)
            message.x = object.x >>> 0;
        if (object.y != null)
            message.y = object.y >>> 0;
        if (object.wait != null)
            message.wait = Boolean(object.wait);
        if (object.hold_ms != null)
            message.hold_ms = object.hold_ms >>> 0;
        return message;
    };

    DebugLinkDecision.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.yes_no = false;
            object.swipe = options.enums === String ? "UP" : 0;
            object.input = "";
            object.x = 0;
            object.y = 0;
            object.wait = false;
            object.hold_ms = 0;
        }
        if (message.yes_no != null && message.hasOwnProperty("yes_no"))
            object.yes_no = message.yes_no;
        if (message.swipe != null && message.hasOwnProperty("swipe"))
            object.swipe = options.enums === String ? $root.DebugLinkDecision.DebugSwipeDirection[message.swipe] : message.swipe;
        if (message.input != null && message.hasOwnProperty("input"))
            object.input = message.input;
        if (message.x != null && message.hasOwnProperty("x"))
            object.x = message.x;
        if (message.y != null && message.hasOwnProperty("y"))
            object.y = message.y;
        if (message.wait != null && message.hasOwnProperty("wait"))
            object.wait = message.wait;
        if (message.hold_ms != null && message.hasOwnProperty("hold_ms"))
            object.hold_ms = message.hold_ms;
        return object;
    };

    DebugLinkDecision.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    DebugLinkDecision.DebugSwipeDirection = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UP"] = 0;
        values[valuesById[1] = "DOWN"] = 1;
        values[valuesById[2] = "LEFT"] = 2;
        values[valuesById[3] = "RIGHT"] = 3;
        return values;
    })();

    return DebugLinkDecision;
})();

$root.DebugLinkLayout = (function() {

    function DebugLinkLayout(properties) {
        this.lines = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DebugLinkLayout.prototype.lines = $util.emptyArray;

    DebugLinkLayout.create = function create(properties) {
        return new DebugLinkLayout(properties);
    };

    DebugLinkLayout.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.lines != null && message.lines.length)
            for (var i = 0; i < message.lines.length; ++i)
                writer.uint32(10).string(message.lines[i]);
        return writer;
    };

    DebugLinkLayout.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DebugLinkLayout.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DebugLinkLayout();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.lines && message.lines.length))
                    message.lines = [];
                message.lines.push(reader.string());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    DebugLinkLayout.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DebugLinkLayout.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.lines != null && message.hasOwnProperty("lines")) {
            if (!Array.isArray(message.lines))
                return "lines: array expected";
            for (var i = 0; i < message.lines.length; ++i)
                if (!$util.isString(message.lines[i]))
                    return "lines: string[] expected";
        }
        return null;
    };

    DebugLinkLayout.fromObject = function fromObject(object) {
        if (object instanceof $root.DebugLinkLayout)
            return object;
        var message = new $root.DebugLinkLayout();
        if (object.lines) {
            if (!Array.isArray(object.lines))
                throw TypeError(".DebugLinkLayout.lines: array expected");
            message.lines = [];
            for (var i = 0; i < object.lines.length; ++i)
                message.lines[i] = String(object.lines[i]);
        }
        return message;
    };

    DebugLinkLayout.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.lines = [];
        if (message.lines && message.lines.length) {
            object.lines = [];
            for (var j = 0; j < message.lines.length; ++j)
                object.lines[j] = message.lines[j];
        }
        return object;
    };

    DebugLinkLayout.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DebugLinkLayout;
})();

$root.DebugLinkReseedRandom = (function() {

    function DebugLinkReseedRandom(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DebugLinkReseedRandom.prototype.value = 0;

    DebugLinkReseedRandom.create = function create(properties) {
        return new DebugLinkReseedRandom(properties);
    };

    DebugLinkReseedRandom.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.value != null && Object.hasOwnProperty.call(message, "value"))
            writer.uint32(8).uint32(message.value);
        return writer;
    };

    DebugLinkReseedRandom.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DebugLinkReseedRandom.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DebugLinkReseedRandom();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.value = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    DebugLinkReseedRandom.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DebugLinkReseedRandom.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.value != null && message.hasOwnProperty("value"))
            if (!$util.isInteger(message.value))
                return "value: integer expected";
        return null;
    };

    DebugLinkReseedRandom.fromObject = function fromObject(object) {
        if (object instanceof $root.DebugLinkReseedRandom)
            return object;
        var message = new $root.DebugLinkReseedRandom();
        if (object.value != null)
            message.value = object.value >>> 0;
        return message;
    };

    DebugLinkReseedRandom.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.value = 0;
        if (message.value != null && message.hasOwnProperty("value"))
            object.value = message.value;
        return object;
    };

    DebugLinkReseedRandom.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DebugLinkReseedRandom;
})();

$root.DebugLinkRecordScreen = (function() {

    function DebugLinkRecordScreen(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DebugLinkRecordScreen.prototype.target_directory = "";

    DebugLinkRecordScreen.create = function create(properties) {
        return new DebugLinkRecordScreen(properties);
    };

    DebugLinkRecordScreen.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.target_directory != null && Object.hasOwnProperty.call(message, "target_directory"))
            writer.uint32(10).string(message.target_directory);
        return writer;
    };

    DebugLinkRecordScreen.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DebugLinkRecordScreen.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DebugLinkRecordScreen();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.target_directory = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    DebugLinkRecordScreen.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DebugLinkRecordScreen.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.target_directory != null && message.hasOwnProperty("target_directory"))
            if (!$util.isString(message.target_directory))
                return "target_directory: string expected";
        return null;
    };

    DebugLinkRecordScreen.fromObject = function fromObject(object) {
        if (object instanceof $root.DebugLinkRecordScreen)
            return object;
        var message = new $root.DebugLinkRecordScreen();
        if (object.target_directory != null)
            message.target_directory = String(object.target_directory);
        return message;
    };

    DebugLinkRecordScreen.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.target_directory = "";
        if (message.target_directory != null && message.hasOwnProperty("target_directory"))
            object.target_directory = message.target_directory;
        return object;
    };

    DebugLinkRecordScreen.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DebugLinkRecordScreen;
})();

$root.DebugLinkGetState = (function() {

    function DebugLinkGetState(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DebugLinkGetState.prototype.wait_word_list = false;
    DebugLinkGetState.prototype.wait_word_pos = false;
    DebugLinkGetState.prototype.wait_layout = false;

    DebugLinkGetState.create = function create(properties) {
        return new DebugLinkGetState(properties);
    };

    DebugLinkGetState.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.wait_word_list != null && Object.hasOwnProperty.call(message, "wait_word_list"))
            writer.uint32(8).bool(message.wait_word_list);
        if (message.wait_word_pos != null && Object.hasOwnProperty.call(message, "wait_word_pos"))
            writer.uint32(16).bool(message.wait_word_pos);
        if (message.wait_layout != null && Object.hasOwnProperty.call(message, "wait_layout"))
            writer.uint32(24).bool(message.wait_layout);
        return writer;
    };

    DebugLinkGetState.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DebugLinkGetState.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DebugLinkGetState();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.wait_word_list = reader.bool();
                break;
            case 2:
                message.wait_word_pos = reader.bool();
                break;
            case 3:
                message.wait_layout = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    DebugLinkGetState.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DebugLinkGetState.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.wait_word_list != null && message.hasOwnProperty("wait_word_list"))
            if (typeof message.wait_word_list !== "boolean")
                return "wait_word_list: boolean expected";
        if (message.wait_word_pos != null && message.hasOwnProperty("wait_word_pos"))
            if (typeof message.wait_word_pos !== "boolean")
                return "wait_word_pos: boolean expected";
        if (message.wait_layout != null && message.hasOwnProperty("wait_layout"))
            if (typeof message.wait_layout !== "boolean")
                return "wait_layout: boolean expected";
        return null;
    };

    DebugLinkGetState.fromObject = function fromObject(object) {
        if (object instanceof $root.DebugLinkGetState)
            return object;
        var message = new $root.DebugLinkGetState();
        if (object.wait_word_list != null)
            message.wait_word_list = Boolean(object.wait_word_list);
        if (object.wait_word_pos != null)
            message.wait_word_pos = Boolean(object.wait_word_pos);
        if (object.wait_layout != null)
            message.wait_layout = Boolean(object.wait_layout);
        return message;
    };

    DebugLinkGetState.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.wait_word_list = false;
            object.wait_word_pos = false;
            object.wait_layout = false;
        }
        if (message.wait_word_list != null && message.hasOwnProperty("wait_word_list"))
            object.wait_word_list = message.wait_word_list;
        if (message.wait_word_pos != null && message.hasOwnProperty("wait_word_pos"))
            object.wait_word_pos = message.wait_word_pos;
        if (message.wait_layout != null && message.hasOwnProperty("wait_layout"))
            object.wait_layout = message.wait_layout;
        return object;
    };

    DebugLinkGetState.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DebugLinkGetState;
})();

$root.DebugLinkState = (function() {

    function DebugLinkState(properties) {
        this.layout_lines = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DebugLinkState.prototype.layout = $util.newBuffer([]);
    DebugLinkState.prototype.pin = "";
    DebugLinkState.prototype.matrix = "";
    DebugLinkState.prototype.mnemonic_secret = $util.newBuffer([]);
    DebugLinkState.prototype.node = null;
    DebugLinkState.prototype.passphrase_protection = false;
    DebugLinkState.prototype.reset_word = "";
    DebugLinkState.prototype.reset_entropy = $util.newBuffer([]);
    DebugLinkState.prototype.recovery_fake_word = "";
    DebugLinkState.prototype.recovery_word_pos = 0;
    DebugLinkState.prototype.reset_word_pos = 0;
    DebugLinkState.prototype.mnemonic_type = 0;
    DebugLinkState.prototype.layout_lines = $util.emptyArray;

    DebugLinkState.create = function create(properties) {
        return new DebugLinkState(properties);
    };

    DebugLinkState.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.layout != null && Object.hasOwnProperty.call(message, "layout"))
            writer.uint32(10).bytes(message.layout);
        if (message.pin != null && Object.hasOwnProperty.call(message, "pin"))
            writer.uint32(18).string(message.pin);
        if (message.matrix != null && Object.hasOwnProperty.call(message, "matrix"))
            writer.uint32(26).string(message.matrix);
        if (message.mnemonic_secret != null && Object.hasOwnProperty.call(message, "mnemonic_secret"))
            writer.uint32(34).bytes(message.mnemonic_secret);
        if (message.node != null && Object.hasOwnProperty.call(message, "node"))
            $root.HDNodeType.encode(message.node, writer.uint32(42).fork()).ldelim();
        if (message.passphrase_protection != null && Object.hasOwnProperty.call(message, "passphrase_protection"))
            writer.uint32(48).bool(message.passphrase_protection);
        if (message.reset_word != null && Object.hasOwnProperty.call(message, "reset_word"))
            writer.uint32(58).string(message.reset_word);
        if (message.reset_entropy != null && Object.hasOwnProperty.call(message, "reset_entropy"))
            writer.uint32(66).bytes(message.reset_entropy);
        if (message.recovery_fake_word != null && Object.hasOwnProperty.call(message, "recovery_fake_word"))
            writer.uint32(74).string(message.recovery_fake_word);
        if (message.recovery_word_pos != null && Object.hasOwnProperty.call(message, "recovery_word_pos"))
            writer.uint32(80).uint32(message.recovery_word_pos);
        if (message.reset_word_pos != null && Object.hasOwnProperty.call(message, "reset_word_pos"))
            writer.uint32(88).uint32(message.reset_word_pos);
        if (message.mnemonic_type != null && Object.hasOwnProperty.call(message, "mnemonic_type"))
            writer.uint32(96).int32(message.mnemonic_type);
        if (message.layout_lines != null && message.layout_lines.length)
            for (var i = 0; i < message.layout_lines.length; ++i)
                writer.uint32(106).string(message.layout_lines[i]);
        return writer;
    };

    DebugLinkState.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DebugLinkState.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DebugLinkState();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.layout = reader.bytes();
                break;
            case 2:
                message.pin = reader.string();
                break;
            case 3:
                message.matrix = reader.string();
                break;
            case 4:
                message.mnemonic_secret = reader.bytes();
                break;
            case 5:
                message.node = $root.HDNodeType.decode(reader, reader.uint32());
                break;
            case 6:
                message.passphrase_protection = reader.bool();
                break;
            case 7:
                message.reset_word = reader.string();
                break;
            case 8:
                message.reset_entropy = reader.bytes();
                break;
            case 9:
                message.recovery_fake_word = reader.string();
                break;
            case 10:
                message.recovery_word_pos = reader.uint32();
                break;
            case 11:
                message.reset_word_pos = reader.uint32();
                break;
            case 12:
                message.mnemonic_type = reader.int32();
                break;
            case 13:
                if (!(message.layout_lines && message.layout_lines.length))
                    message.layout_lines = [];
                message.layout_lines.push(reader.string());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    DebugLinkState.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DebugLinkState.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.layout != null && message.hasOwnProperty("layout"))
            if (!(message.layout && typeof message.layout.length === "number" || $util.isString(message.layout)))
                return "layout: buffer expected";
        if (message.pin != null && message.hasOwnProperty("pin"))
            if (!$util.isString(message.pin))
                return "pin: string expected";
        if (message.matrix != null && message.hasOwnProperty("matrix"))
            if (!$util.isString(message.matrix))
                return "matrix: string expected";
        if (message.mnemonic_secret != null && message.hasOwnProperty("mnemonic_secret"))
            if (!(message.mnemonic_secret && typeof message.mnemonic_secret.length === "number" || $util.isString(message.mnemonic_secret)))
                return "mnemonic_secret: buffer expected";
        if (message.node != null && message.hasOwnProperty("node")) {
            var error = $root.HDNodeType.verify(message.node);
            if (error)
                return "node." + error;
        }
        if (message.passphrase_protection != null && message.hasOwnProperty("passphrase_protection"))
            if (typeof message.passphrase_protection !== "boolean")
                return "passphrase_protection: boolean expected";
        if (message.reset_word != null && message.hasOwnProperty("reset_word"))
            if (!$util.isString(message.reset_word))
                return "reset_word: string expected";
        if (message.reset_entropy != null && message.hasOwnProperty("reset_entropy"))
            if (!(message.reset_entropy && typeof message.reset_entropy.length === "number" || $util.isString(message.reset_entropy)))
                return "reset_entropy: buffer expected";
        if (message.recovery_fake_word != null && message.hasOwnProperty("recovery_fake_word"))
            if (!$util.isString(message.recovery_fake_word))
                return "recovery_fake_word: string expected";
        if (message.recovery_word_pos != null && message.hasOwnProperty("recovery_word_pos"))
            if (!$util.isInteger(message.recovery_word_pos))
                return "recovery_word_pos: integer expected";
        if (message.reset_word_pos != null && message.hasOwnProperty("reset_word_pos"))
            if (!$util.isInteger(message.reset_word_pos))
                return "reset_word_pos: integer expected";
        if (message.mnemonic_type != null && message.hasOwnProperty("mnemonic_type"))
            switch (message.mnemonic_type) {
            default:
                return "mnemonic_type: enum value expected";
            case 0:
            case 1:
            case 2:
                break;
            }
        if (message.layout_lines != null && message.hasOwnProperty("layout_lines")) {
            if (!Array.isArray(message.layout_lines))
                return "layout_lines: array expected";
            for (var i = 0; i < message.layout_lines.length; ++i)
                if (!$util.isString(message.layout_lines[i]))
                    return "layout_lines: string[] expected";
        }
        return null;
    };

    DebugLinkState.fromObject = function fromObject(object) {
        if (object instanceof $root.DebugLinkState)
            return object;
        var message = new $root.DebugLinkState();
        if (object.layout != null)
            if (typeof object.layout === "string")
                $util.base64.decode(object.layout, message.layout = $util.newBuffer($util.base64.length(object.layout)), 0);
            else if (object.layout.length)
                message.layout = object.layout;
        if (object.pin != null)
            message.pin = String(object.pin);
        if (object.matrix != null)
            message.matrix = String(object.matrix);
        if (object.mnemonic_secret != null)
            if (typeof object.mnemonic_secret === "string")
                $util.base64.decode(object.mnemonic_secret, message.mnemonic_secret = $util.newBuffer($util.base64.length(object.mnemonic_secret)), 0);
            else if (object.mnemonic_secret.length)
                message.mnemonic_secret = object.mnemonic_secret;
        if (object.node != null) {
            if (typeof object.node !== "object")
                throw TypeError(".DebugLinkState.node: object expected");
            message.node = $root.HDNodeType.fromObject(object.node);
        }
        if (object.passphrase_protection != null)
            message.passphrase_protection = Boolean(object.passphrase_protection);
        if (object.reset_word != null)
            message.reset_word = String(object.reset_word);
        if (object.reset_entropy != null)
            if (typeof object.reset_entropy === "string")
                $util.base64.decode(object.reset_entropy, message.reset_entropy = $util.newBuffer($util.base64.length(object.reset_entropy)), 0);
            else if (object.reset_entropy.length)
                message.reset_entropy = object.reset_entropy;
        if (object.recovery_fake_word != null)
            message.recovery_fake_word = String(object.recovery_fake_word);
        if (object.recovery_word_pos != null)
            message.recovery_word_pos = object.recovery_word_pos >>> 0;
        if (object.reset_word_pos != null)
            message.reset_word_pos = object.reset_word_pos >>> 0;
        switch (object.mnemonic_type) {
        case "Bip39":
        case 0:
            message.mnemonic_type = 0;
            break;
        case "Slip39_Basic":
        case 1:
            message.mnemonic_type = 1;
            break;
        case "Slip39_Advanced":
        case 2:
            message.mnemonic_type = 2;
            break;
        }
        if (object.layout_lines) {
            if (!Array.isArray(object.layout_lines))
                throw TypeError(".DebugLinkState.layout_lines: array expected");
            message.layout_lines = [];
            for (var i = 0; i < object.layout_lines.length; ++i)
                message.layout_lines[i] = String(object.layout_lines[i]);
        }
        return message;
    };

    DebugLinkState.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.layout_lines = [];
        if (options.defaults) {
            if (options.bytes === String)
                object.layout = "";
            else {
                object.layout = [];
                if (options.bytes !== Array)
                    object.layout = $util.newBuffer(object.layout);
            }
            object.pin = "";
            object.matrix = "";
            if (options.bytes === String)
                object.mnemonic_secret = "";
            else {
                object.mnemonic_secret = [];
                if (options.bytes !== Array)
                    object.mnemonic_secret = $util.newBuffer(object.mnemonic_secret);
            }
            object.node = null;
            object.passphrase_protection = false;
            object.reset_word = "";
            if (options.bytes === String)
                object.reset_entropy = "";
            else {
                object.reset_entropy = [];
                if (options.bytes !== Array)
                    object.reset_entropy = $util.newBuffer(object.reset_entropy);
            }
            object.recovery_fake_word = "";
            object.recovery_word_pos = 0;
            object.reset_word_pos = 0;
            object.mnemonic_type = options.enums === String ? "Bip39" : 0;
        }
        if (message.layout != null && message.hasOwnProperty("layout"))
            object.layout = options.bytes === String ? $util.base64.encode(message.layout, 0, message.layout.length) : options.bytes === Array ? Array.prototype.slice.call(message.layout) : message.layout;
        if (message.pin != null && message.hasOwnProperty("pin"))
            object.pin = message.pin;
        if (message.matrix != null && message.hasOwnProperty("matrix"))
            object.matrix = message.matrix;
        if (message.mnemonic_secret != null && message.hasOwnProperty("mnemonic_secret"))
            object.mnemonic_secret = options.bytes === String ? $util.base64.encode(message.mnemonic_secret, 0, message.mnemonic_secret.length) : options.bytes === Array ? Array.prototype.slice.call(message.mnemonic_secret) : message.mnemonic_secret;
        if (message.node != null && message.hasOwnProperty("node"))
            object.node = $root.HDNodeType.toObject(message.node, options);
        if (message.passphrase_protection != null && message.hasOwnProperty("passphrase_protection"))
            object.passphrase_protection = message.passphrase_protection;
        if (message.reset_word != null && message.hasOwnProperty("reset_word"))
            object.reset_word = message.reset_word;
        if (message.reset_entropy != null && message.hasOwnProperty("reset_entropy"))
            object.reset_entropy = options.bytes === String ? $util.base64.encode(message.reset_entropy, 0, message.reset_entropy.length) : options.bytes === Array ? Array.prototype.slice.call(message.reset_entropy) : message.reset_entropy;
        if (message.recovery_fake_word != null && message.hasOwnProperty("recovery_fake_word"))
            object.recovery_fake_word = message.recovery_fake_word;
        if (message.recovery_word_pos != null && message.hasOwnProperty("recovery_word_pos"))
            object.recovery_word_pos = message.recovery_word_pos;
        if (message.reset_word_pos != null && message.hasOwnProperty("reset_word_pos"))
            object.reset_word_pos = message.reset_word_pos;
        if (message.mnemonic_type != null && message.hasOwnProperty("mnemonic_type"))
            object.mnemonic_type = options.enums === String ? $root.BackupType[message.mnemonic_type] : message.mnemonic_type;
        if (message.layout_lines && message.layout_lines.length) {
            object.layout_lines = [];
            for (var j = 0; j < message.layout_lines.length; ++j)
                object.layout_lines[j] = message.layout_lines[j];
        }
        return object;
    };

    DebugLinkState.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DebugLinkState;
})();

$root.DebugLinkStop = (function() {

    function DebugLinkStop(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DebugLinkStop.create = function create(properties) {
        return new DebugLinkStop(properties);
    };

    DebugLinkStop.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    DebugLinkStop.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DebugLinkStop.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DebugLinkStop();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    DebugLinkStop.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DebugLinkStop.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    DebugLinkStop.fromObject = function fromObject(object) {
        if (object instanceof $root.DebugLinkStop)
            return object;
        return new $root.DebugLinkStop();
    };

    DebugLinkStop.toObject = function toObject() {
        return {};
    };

    DebugLinkStop.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DebugLinkStop;
})();

$root.DebugLinkLog = (function() {

    function DebugLinkLog(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DebugLinkLog.prototype.level = 0;
    DebugLinkLog.prototype.bucket = "";
    DebugLinkLog.prototype.text = "";

    DebugLinkLog.create = function create(properties) {
        return new DebugLinkLog(properties);
    };

    DebugLinkLog.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.level != null && Object.hasOwnProperty.call(message, "level"))
            writer.uint32(8).uint32(message.level);
        if (message.bucket != null && Object.hasOwnProperty.call(message, "bucket"))
            writer.uint32(18).string(message.bucket);
        if (message.text != null && Object.hasOwnProperty.call(message, "text"))
            writer.uint32(26).string(message.text);
        return writer;
    };

    DebugLinkLog.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DebugLinkLog.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DebugLinkLog();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.level = reader.uint32();
                break;
            case 2:
                message.bucket = reader.string();
                break;
            case 3:
                message.text = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    DebugLinkLog.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DebugLinkLog.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.level != null && message.hasOwnProperty("level"))
            if (!$util.isInteger(message.level))
                return "level: integer expected";
        if (message.bucket != null && message.hasOwnProperty("bucket"))
            if (!$util.isString(message.bucket))
                return "bucket: string expected";
        if (message.text != null && message.hasOwnProperty("text"))
            if (!$util.isString(message.text))
                return "text: string expected";
        return null;
    };

    DebugLinkLog.fromObject = function fromObject(object) {
        if (object instanceof $root.DebugLinkLog)
            return object;
        var message = new $root.DebugLinkLog();
        if (object.level != null)
            message.level = object.level >>> 0;
        if (object.bucket != null)
            message.bucket = String(object.bucket);
        if (object.text != null)
            message.text = String(object.text);
        return message;
    };

    DebugLinkLog.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.level = 0;
            object.bucket = "";
            object.text = "";
        }
        if (message.level != null && message.hasOwnProperty("level"))
            object.level = message.level;
        if (message.bucket != null && message.hasOwnProperty("bucket"))
            object.bucket = message.bucket;
        if (message.text != null && message.hasOwnProperty("text"))
            object.text = message.text;
        return object;
    };

    DebugLinkLog.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DebugLinkLog;
})();

$root.DebugLinkMemoryRead = (function() {

    function DebugLinkMemoryRead(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DebugLinkMemoryRead.prototype.address = 0;
    DebugLinkMemoryRead.prototype.length = 0;

    DebugLinkMemoryRead.create = function create(properties) {
        return new DebugLinkMemoryRead(properties);
    };

    DebugLinkMemoryRead.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address != null && Object.hasOwnProperty.call(message, "address"))
            writer.uint32(8).uint32(message.address);
        if (message.length != null && Object.hasOwnProperty.call(message, "length"))
            writer.uint32(16).uint32(message.length);
        return writer;
    };

    DebugLinkMemoryRead.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DebugLinkMemoryRead.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DebugLinkMemoryRead();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.uint32();
                break;
            case 2:
                message.length = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    DebugLinkMemoryRead.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DebugLinkMemoryRead.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address != null && message.hasOwnProperty("address"))
            if (!$util.isInteger(message.address))
                return "address: integer expected";
        if (message.length != null && message.hasOwnProperty("length"))
            if (!$util.isInteger(message.length))
                return "length: integer expected";
        return null;
    };

    DebugLinkMemoryRead.fromObject = function fromObject(object) {
        if (object instanceof $root.DebugLinkMemoryRead)
            return object;
        var message = new $root.DebugLinkMemoryRead();
        if (object.address != null)
            message.address = object.address >>> 0;
        if (object.length != null)
            message.length = object.length >>> 0;
        return message;
    };

    DebugLinkMemoryRead.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.address = 0;
            object.length = 0;
        }
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        if (message.length != null && message.hasOwnProperty("length"))
            object.length = message.length;
        return object;
    };

    DebugLinkMemoryRead.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DebugLinkMemoryRead;
})();

$root.DebugLinkMemory = (function() {

    function DebugLinkMemory(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DebugLinkMemory.prototype.memory = $util.newBuffer([]);

    DebugLinkMemory.create = function create(properties) {
        return new DebugLinkMemory(properties);
    };

    DebugLinkMemory.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.memory != null && Object.hasOwnProperty.call(message, "memory"))
            writer.uint32(10).bytes(message.memory);
        return writer;
    };

    DebugLinkMemory.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DebugLinkMemory.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DebugLinkMemory();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.memory = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    DebugLinkMemory.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DebugLinkMemory.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.memory != null && message.hasOwnProperty("memory"))
            if (!(message.memory && typeof message.memory.length === "number" || $util.isString(message.memory)))
                return "memory: buffer expected";
        return null;
    };

    DebugLinkMemory.fromObject = function fromObject(object) {
        if (object instanceof $root.DebugLinkMemory)
            return object;
        var message = new $root.DebugLinkMemory();
        if (object.memory != null)
            if (typeof object.memory === "string")
                $util.base64.decode(object.memory, message.memory = $util.newBuffer($util.base64.length(object.memory)), 0);
            else if (object.memory.length)
                message.memory = object.memory;
        return message;
    };

    DebugLinkMemory.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.memory = "";
            else {
                object.memory = [];
                if (options.bytes !== Array)
                    object.memory = $util.newBuffer(object.memory);
            }
        if (message.memory != null && message.hasOwnProperty("memory"))
            object.memory = options.bytes === String ? $util.base64.encode(message.memory, 0, message.memory.length) : options.bytes === Array ? Array.prototype.slice.call(message.memory) : message.memory;
        return object;
    };

    DebugLinkMemory.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DebugLinkMemory;
})();

$root.DebugLinkMemoryWrite = (function() {

    function DebugLinkMemoryWrite(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DebugLinkMemoryWrite.prototype.address = 0;
    DebugLinkMemoryWrite.prototype.memory = $util.newBuffer([]);
    DebugLinkMemoryWrite.prototype.flash = false;

    DebugLinkMemoryWrite.create = function create(properties) {
        return new DebugLinkMemoryWrite(properties);
    };

    DebugLinkMemoryWrite.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address != null && Object.hasOwnProperty.call(message, "address"))
            writer.uint32(8).uint32(message.address);
        if (message.memory != null && Object.hasOwnProperty.call(message, "memory"))
            writer.uint32(18).bytes(message.memory);
        if (message.flash != null && Object.hasOwnProperty.call(message, "flash"))
            writer.uint32(24).bool(message.flash);
        return writer;
    };

    DebugLinkMemoryWrite.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DebugLinkMemoryWrite.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DebugLinkMemoryWrite();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.uint32();
                break;
            case 2:
                message.memory = reader.bytes();
                break;
            case 3:
                message.flash = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    DebugLinkMemoryWrite.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DebugLinkMemoryWrite.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address != null && message.hasOwnProperty("address"))
            if (!$util.isInteger(message.address))
                return "address: integer expected";
        if (message.memory != null && message.hasOwnProperty("memory"))
            if (!(message.memory && typeof message.memory.length === "number" || $util.isString(message.memory)))
                return "memory: buffer expected";
        if (message.flash != null && message.hasOwnProperty("flash"))
            if (typeof message.flash !== "boolean")
                return "flash: boolean expected";
        return null;
    };

    DebugLinkMemoryWrite.fromObject = function fromObject(object) {
        if (object instanceof $root.DebugLinkMemoryWrite)
            return object;
        var message = new $root.DebugLinkMemoryWrite();
        if (object.address != null)
            message.address = object.address >>> 0;
        if (object.memory != null)
            if (typeof object.memory === "string")
                $util.base64.decode(object.memory, message.memory = $util.newBuffer($util.base64.length(object.memory)), 0);
            else if (object.memory.length)
                message.memory = object.memory;
        if (object.flash != null)
            message.flash = Boolean(object.flash);
        return message;
    };

    DebugLinkMemoryWrite.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.address = 0;
            if (options.bytes === String)
                object.memory = "";
            else {
                object.memory = [];
                if (options.bytes !== Array)
                    object.memory = $util.newBuffer(object.memory);
            }
            object.flash = false;
        }
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        if (message.memory != null && message.hasOwnProperty("memory"))
            object.memory = options.bytes === String ? $util.base64.encode(message.memory, 0, message.memory.length) : options.bytes === Array ? Array.prototype.slice.call(message.memory) : message.memory;
        if (message.flash != null && message.hasOwnProperty("flash"))
            object.flash = message.flash;
        return object;
    };

    DebugLinkMemoryWrite.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DebugLinkMemoryWrite;
})();

$root.DebugLinkFlashErase = (function() {

    function DebugLinkFlashErase(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DebugLinkFlashErase.prototype.sector = 0;

    DebugLinkFlashErase.create = function create(properties) {
        return new DebugLinkFlashErase(properties);
    };

    DebugLinkFlashErase.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.sector != null && Object.hasOwnProperty.call(message, "sector"))
            writer.uint32(8).uint32(message.sector);
        return writer;
    };

    DebugLinkFlashErase.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DebugLinkFlashErase.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DebugLinkFlashErase();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.sector = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    DebugLinkFlashErase.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DebugLinkFlashErase.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.sector != null && message.hasOwnProperty("sector"))
            if (!$util.isInteger(message.sector))
                return "sector: integer expected";
        return null;
    };

    DebugLinkFlashErase.fromObject = function fromObject(object) {
        if (object instanceof $root.DebugLinkFlashErase)
            return object;
        var message = new $root.DebugLinkFlashErase();
        if (object.sector != null)
            message.sector = object.sector >>> 0;
        return message;
    };

    DebugLinkFlashErase.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.sector = 0;
        if (message.sector != null && message.hasOwnProperty("sector"))
            object.sector = message.sector;
        return object;
    };

    DebugLinkFlashErase.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DebugLinkFlashErase;
})();

$root.DebugLinkEraseSdCard = (function() {

    function DebugLinkEraseSdCard(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DebugLinkEraseSdCard.prototype.format = false;

    DebugLinkEraseSdCard.create = function create(properties) {
        return new DebugLinkEraseSdCard(properties);
    };

    DebugLinkEraseSdCard.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.format != null && Object.hasOwnProperty.call(message, "format"))
            writer.uint32(8).bool(message.format);
        return writer;
    };

    DebugLinkEraseSdCard.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DebugLinkEraseSdCard.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DebugLinkEraseSdCard();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.format = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    DebugLinkEraseSdCard.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DebugLinkEraseSdCard.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.format != null && message.hasOwnProperty("format"))
            if (typeof message.format !== "boolean")
                return "format: boolean expected";
        return null;
    };

    DebugLinkEraseSdCard.fromObject = function fromObject(object) {
        if (object instanceof $root.DebugLinkEraseSdCard)
            return object;
        var message = new $root.DebugLinkEraseSdCard();
        if (object.format != null)
            message.format = Boolean(object.format);
        return message;
    };

    DebugLinkEraseSdCard.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.format = false;
        if (message.format != null && message.hasOwnProperty("format"))
            object.format = message.format;
        return object;
    };

    DebugLinkEraseSdCard.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DebugLinkEraseSdCard;
})();

$root.DebugLinkWatchLayout = (function() {

    function DebugLinkWatchLayout(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DebugLinkWatchLayout.prototype.watch = false;

    DebugLinkWatchLayout.create = function create(properties) {
        return new DebugLinkWatchLayout(properties);
    };

    DebugLinkWatchLayout.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.watch != null && Object.hasOwnProperty.call(message, "watch"))
            writer.uint32(8).bool(message.watch);
        return writer;
    };

    DebugLinkWatchLayout.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DebugLinkWatchLayout.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DebugLinkWatchLayout();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.watch = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    DebugLinkWatchLayout.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DebugLinkWatchLayout.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.watch != null && message.hasOwnProperty("watch"))
            if (typeof message.watch !== "boolean")
                return "watch: boolean expected";
        return null;
    };

    DebugLinkWatchLayout.fromObject = function fromObject(object) {
        if (object instanceof $root.DebugLinkWatchLayout)
            return object;
        var message = new $root.DebugLinkWatchLayout();
        if (object.watch != null)
            message.watch = Boolean(object.watch);
        return message;
    };

    DebugLinkWatchLayout.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.watch = false;
        if (message.watch != null && message.hasOwnProperty("watch"))
            object.watch = message.watch;
        return object;
    };

    DebugLinkWatchLayout.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DebugLinkWatchLayout;
})();

$root.EmmcFixPermission = (function() {

    function EmmcFixPermission(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EmmcFixPermission.create = function create(properties) {
        return new EmmcFixPermission(properties);
    };

    EmmcFixPermission.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    EmmcFixPermission.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EmmcFixPermission.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EmmcFixPermission();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    EmmcFixPermission.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EmmcFixPermission.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    EmmcFixPermission.fromObject = function fromObject(object) {
        if (object instanceof $root.EmmcFixPermission)
            return object;
        return new $root.EmmcFixPermission();
    };

    EmmcFixPermission.toObject = function toObject() {
        return {};
    };

    EmmcFixPermission.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EmmcFixPermission;
})();

$root.EmmcPath = (function() {

    function EmmcPath(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EmmcPath.prototype.exist = false;
    EmmcPath.prototype.size = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    EmmcPath.prototype.year = 0;
    EmmcPath.prototype.month = 0;
    EmmcPath.prototype.day = 0;
    EmmcPath.prototype.hour = 0;
    EmmcPath.prototype.minute = 0;
    EmmcPath.prototype.second = 0;
    EmmcPath.prototype.readonly = false;
    EmmcPath.prototype.hidden = false;
    EmmcPath.prototype.system = false;
    EmmcPath.prototype.archive = false;
    EmmcPath.prototype.directory = false;

    EmmcPath.create = function create(properties) {
        return new EmmcPath(properties);
    };

    EmmcPath.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).bool(message.exist);
        writer.uint32(16).uint64(message.size);
        writer.uint32(24).uint32(message.year);
        writer.uint32(32).uint32(message.month);
        writer.uint32(40).uint32(message.day);
        writer.uint32(48).uint32(message.hour);
        writer.uint32(56).uint32(message.minute);
        writer.uint32(64).uint32(message.second);
        writer.uint32(72).bool(message.readonly);
        writer.uint32(80).bool(message.hidden);
        writer.uint32(88).bool(message.system);
        writer.uint32(96).bool(message.archive);
        writer.uint32(104).bool(message.directory);
        return writer;
    };

    EmmcPath.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EmmcPath.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EmmcPath();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.exist = reader.bool();
                break;
            case 2:
                message.size = reader.uint64();
                break;
            case 3:
                message.year = reader.uint32();
                break;
            case 4:
                message.month = reader.uint32();
                break;
            case 5:
                message.day = reader.uint32();
                break;
            case 6:
                message.hour = reader.uint32();
                break;
            case 7:
                message.minute = reader.uint32();
                break;
            case 8:
                message.second = reader.uint32();
                break;
            case 9:
                message.readonly = reader.bool();
                break;
            case 10:
                message.hidden = reader.bool();
                break;
            case 11:
                message.system = reader.bool();
                break;
            case 12:
                message.archive = reader.bool();
                break;
            case 13:
                message.directory = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("exist"))
            throw $util.ProtocolError("missing required 'exist'", { instance: message });
        if (!message.hasOwnProperty("size"))
            throw $util.ProtocolError("missing required 'size'", { instance: message });
        if (!message.hasOwnProperty("year"))
            throw $util.ProtocolError("missing required 'year'", { instance: message });
        if (!message.hasOwnProperty("month"))
            throw $util.ProtocolError("missing required 'month'", { instance: message });
        if (!message.hasOwnProperty("day"))
            throw $util.ProtocolError("missing required 'day'", { instance: message });
        if (!message.hasOwnProperty("hour"))
            throw $util.ProtocolError("missing required 'hour'", { instance: message });
        if (!message.hasOwnProperty("minute"))
            throw $util.ProtocolError("missing required 'minute'", { instance: message });
        if (!message.hasOwnProperty("second"))
            throw $util.ProtocolError("missing required 'second'", { instance: message });
        if (!message.hasOwnProperty("readonly"))
            throw $util.ProtocolError("missing required 'readonly'", { instance: message });
        if (!message.hasOwnProperty("hidden"))
            throw $util.ProtocolError("missing required 'hidden'", { instance: message });
        if (!message.hasOwnProperty("system"))
            throw $util.ProtocolError("missing required 'system'", { instance: message });
        if (!message.hasOwnProperty("archive"))
            throw $util.ProtocolError("missing required 'archive'", { instance: message });
        if (!message.hasOwnProperty("directory"))
            throw $util.ProtocolError("missing required 'directory'", { instance: message });
        return message;
    };

    EmmcPath.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EmmcPath.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (typeof message.exist !== "boolean")
            return "exist: boolean expected";
        if (!$util.isInteger(message.size) && !(message.size && $util.isInteger(message.size.low) && $util.isInteger(message.size.high)))
            return "size: integer|Long expected";
        if (!$util.isInteger(message.year))
            return "year: integer expected";
        if (!$util.isInteger(message.month))
            return "month: integer expected";
        if (!$util.isInteger(message.day))
            return "day: integer expected";
        if (!$util.isInteger(message.hour))
            return "hour: integer expected";
        if (!$util.isInteger(message.minute))
            return "minute: integer expected";
        if (!$util.isInteger(message.second))
            return "second: integer expected";
        if (typeof message.readonly !== "boolean")
            return "readonly: boolean expected";
        if (typeof message.hidden !== "boolean")
            return "hidden: boolean expected";
        if (typeof message.system !== "boolean")
            return "system: boolean expected";
        if (typeof message.archive !== "boolean")
            return "archive: boolean expected";
        if (typeof message.directory !== "boolean")
            return "directory: boolean expected";
        return null;
    };

    EmmcPath.fromObject = function fromObject(object) {
        if (object instanceof $root.EmmcPath)
            return object;
        var message = new $root.EmmcPath();
        if (object.exist != null)
            message.exist = Boolean(object.exist);
        if (object.size != null)
            if ($util.Long)
                (message.size = $util.Long.fromValue(object.size)).unsigned = true;
            else if (typeof object.size === "string")
                message.size = parseInt(object.size, 10);
            else if (typeof object.size === "number")
                message.size = object.size;
            else if (typeof object.size === "object")
                message.size = new $util.LongBits(object.size.low >>> 0, object.size.high >>> 0).toNumber(true);
        if (object.year != null)
            message.year = object.year >>> 0;
        if (object.month != null)
            message.month = object.month >>> 0;
        if (object.day != null)
            message.day = object.day >>> 0;
        if (object.hour != null)
            message.hour = object.hour >>> 0;
        if (object.minute != null)
            message.minute = object.minute >>> 0;
        if (object.second != null)
            message.second = object.second >>> 0;
        if (object.readonly != null)
            message.readonly = Boolean(object.readonly);
        if (object.hidden != null)
            message.hidden = Boolean(object.hidden);
        if (object.system != null)
            message.system = Boolean(object.system);
        if (object.archive != null)
            message.archive = Boolean(object.archive);
        if (object.directory != null)
            message.directory = Boolean(object.directory);
        return message;
    };

    EmmcPath.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.exist = false;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.size = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.size = options.longs === String ? "0" : 0;
            object.year = 0;
            object.month = 0;
            object.day = 0;
            object.hour = 0;
            object.minute = 0;
            object.second = 0;
            object.readonly = false;
            object.hidden = false;
            object.system = false;
            object.archive = false;
            object.directory = false;
        }
        if (message.exist != null && message.hasOwnProperty("exist"))
            object.exist = message.exist;
        if (message.size != null && message.hasOwnProperty("size"))
            if (typeof message.size === "number")
                object.size = options.longs === String ? String(message.size) : message.size;
            else
                object.size = options.longs === String ? $util.Long.prototype.toString.call(message.size) : options.longs === Number ? new $util.LongBits(message.size.low >>> 0, message.size.high >>> 0).toNumber(true) : message.size;
        if (message.year != null && message.hasOwnProperty("year"))
            object.year = message.year;
        if (message.month != null && message.hasOwnProperty("month"))
            object.month = message.month;
        if (message.day != null && message.hasOwnProperty("day"))
            object.day = message.day;
        if (message.hour != null && message.hasOwnProperty("hour"))
            object.hour = message.hour;
        if (message.minute != null && message.hasOwnProperty("minute"))
            object.minute = message.minute;
        if (message.second != null && message.hasOwnProperty("second"))
            object.second = message.second;
        if (message.readonly != null && message.hasOwnProperty("readonly"))
            object.readonly = message.readonly;
        if (message.hidden != null && message.hasOwnProperty("hidden"))
            object.hidden = message.hidden;
        if (message.system != null && message.hasOwnProperty("system"))
            object.system = message.system;
        if (message.archive != null && message.hasOwnProperty("archive"))
            object.archive = message.archive;
        if (message.directory != null && message.hasOwnProperty("directory"))
            object.directory = message.directory;
        return object;
    };

    EmmcPath.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EmmcPath;
})();

$root.EmmcPathInfo = (function() {

    function EmmcPathInfo(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EmmcPathInfo.prototype.path = "";

    EmmcPathInfo.create = function create(properties) {
        return new EmmcPathInfo(properties);
    };

    EmmcPathInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.path);
        return writer;
    };

    EmmcPathInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EmmcPathInfo.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EmmcPathInfo();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.path = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("path"))
            throw $util.ProtocolError("missing required 'path'", { instance: message });
        return message;
    };

    EmmcPathInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EmmcPathInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.path))
            return "path: string expected";
        return null;
    };

    EmmcPathInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.EmmcPathInfo)
            return object;
        var message = new $root.EmmcPathInfo();
        if (object.path != null)
            message.path = String(object.path);
        return message;
    };

    EmmcPathInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.path = "";
        if (message.path != null && message.hasOwnProperty("path"))
            object.path = message.path;
        return object;
    };

    EmmcPathInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EmmcPathInfo;
})();

$root.EmmcFile = (function() {

    function EmmcFile(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EmmcFile.prototype.path = "";
    EmmcFile.prototype.offset = 0;
    EmmcFile.prototype.len = 0;
    EmmcFile.prototype.data = $util.newBuffer([]);
    EmmcFile.prototype.data_hash = 0;
    EmmcFile.prototype.processed_byte = 0;

    EmmcFile.create = function create(properties) {
        return new EmmcFile(properties);
    };

    EmmcFile.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.path);
        writer.uint32(16).uint32(message.offset);
        writer.uint32(24).uint32(message.len);
        if (message.data != null && Object.hasOwnProperty.call(message, "data"))
            writer.uint32(34).bytes(message.data);
        if (message.data_hash != null && Object.hasOwnProperty.call(message, "data_hash"))
            writer.uint32(40).uint32(message.data_hash);
        if (message.processed_byte != null && Object.hasOwnProperty.call(message, "processed_byte"))
            writer.uint32(48).uint32(message.processed_byte);
        return writer;
    };

    EmmcFile.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EmmcFile.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EmmcFile();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.path = reader.string();
                break;
            case 2:
                message.offset = reader.uint32();
                break;
            case 3:
                message.len = reader.uint32();
                break;
            case 4:
                message.data = reader.bytes();
                break;
            case 5:
                message.data_hash = reader.uint32();
                break;
            case 6:
                message.processed_byte = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("path"))
            throw $util.ProtocolError("missing required 'path'", { instance: message });
        if (!message.hasOwnProperty("offset"))
            throw $util.ProtocolError("missing required 'offset'", { instance: message });
        if (!message.hasOwnProperty("len"))
            throw $util.ProtocolError("missing required 'len'", { instance: message });
        return message;
    };

    EmmcFile.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EmmcFile.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.path))
            return "path: string expected";
        if (!$util.isInteger(message.offset))
            return "offset: integer expected";
        if (!$util.isInteger(message.len))
            return "len: integer expected";
        if (message.data != null && message.hasOwnProperty("data"))
            if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
                return "data: buffer expected";
        if (message.data_hash != null && message.hasOwnProperty("data_hash"))
            if (!$util.isInteger(message.data_hash))
                return "data_hash: integer expected";
        if (message.processed_byte != null && message.hasOwnProperty("processed_byte"))
            if (!$util.isInteger(message.processed_byte))
                return "processed_byte: integer expected";
        return null;
    };

    EmmcFile.fromObject = function fromObject(object) {
        if (object instanceof $root.EmmcFile)
            return object;
        var message = new $root.EmmcFile();
        if (object.path != null)
            message.path = String(object.path);
        if (object.offset != null)
            message.offset = object.offset >>> 0;
        if (object.len != null)
            message.len = object.len >>> 0;
        if (object.data != null)
            if (typeof object.data === "string")
                $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
            else if (object.data.length)
                message.data = object.data;
        if (object.data_hash != null)
            message.data_hash = object.data_hash >>> 0;
        if (object.processed_byte != null)
            message.processed_byte = object.processed_byte >>> 0;
        return message;
    };

    EmmcFile.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.path = "";
            object.offset = 0;
            object.len = 0;
            if (options.bytes === String)
                object.data = "";
            else {
                object.data = [];
                if (options.bytes !== Array)
                    object.data = $util.newBuffer(object.data);
            }
            object.data_hash = 0;
            object.processed_byte = 0;
        }
        if (message.path != null && message.hasOwnProperty("path"))
            object.path = message.path;
        if (message.offset != null && message.hasOwnProperty("offset"))
            object.offset = message.offset;
        if (message.len != null && message.hasOwnProperty("len"))
            object.len = message.len;
        if (message.data != null && message.hasOwnProperty("data"))
            object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
        if (message.data_hash != null && message.hasOwnProperty("data_hash"))
            object.data_hash = message.data_hash;
        if (message.processed_byte != null && message.hasOwnProperty("processed_byte"))
            object.processed_byte = message.processed_byte;
        return object;
    };

    EmmcFile.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EmmcFile;
})();

$root.EmmcFileRead = (function() {

    function EmmcFileRead(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EmmcFileRead.prototype.file = null;
    EmmcFileRead.prototype.ui_percentage = 0;

    EmmcFileRead.create = function create(properties) {
        return new EmmcFileRead(properties);
    };

    EmmcFileRead.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        $root.EmmcFile.encode(message.file, writer.uint32(10).fork()).ldelim();
        if (message.ui_percentage != null && Object.hasOwnProperty.call(message, "ui_percentage"))
            writer.uint32(16).uint32(message.ui_percentage);
        return writer;
    };

    EmmcFileRead.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EmmcFileRead.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EmmcFileRead();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.file = $root.EmmcFile.decode(reader, reader.uint32());
                break;
            case 2:
                message.ui_percentage = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("file"))
            throw $util.ProtocolError("missing required 'file'", { instance: message });
        return message;
    };

    EmmcFileRead.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EmmcFileRead.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        {
            var error = $root.EmmcFile.verify(message.file);
            if (error)
                return "file." + error;
        }
        if (message.ui_percentage != null && message.hasOwnProperty("ui_percentage"))
            if (!$util.isInteger(message.ui_percentage))
                return "ui_percentage: integer expected";
        return null;
    };

    EmmcFileRead.fromObject = function fromObject(object) {
        if (object instanceof $root.EmmcFileRead)
            return object;
        var message = new $root.EmmcFileRead();
        if (object.file != null) {
            if (typeof object.file !== "object")
                throw TypeError(".EmmcFileRead.file: object expected");
            message.file = $root.EmmcFile.fromObject(object.file);
        }
        if (object.ui_percentage != null)
            message.ui_percentage = object.ui_percentage >>> 0;
        return message;
    };

    EmmcFileRead.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.file = null;
            object.ui_percentage = 0;
        }
        if (message.file != null && message.hasOwnProperty("file"))
            object.file = $root.EmmcFile.toObject(message.file, options);
        if (message.ui_percentage != null && message.hasOwnProperty("ui_percentage"))
            object.ui_percentage = message.ui_percentage;
        return object;
    };

    EmmcFileRead.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EmmcFileRead;
})();

$root.EmmcFileWrite = (function() {

    function EmmcFileWrite(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EmmcFileWrite.prototype.file = null;
    EmmcFileWrite.prototype.overwrite = false;
    EmmcFileWrite.prototype.append = false;
    EmmcFileWrite.prototype.ui_percentage = 0;

    EmmcFileWrite.create = function create(properties) {
        return new EmmcFileWrite(properties);
    };

    EmmcFileWrite.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        $root.EmmcFile.encode(message.file, writer.uint32(10).fork()).ldelim();
        writer.uint32(16).bool(message.overwrite);
        writer.uint32(24).bool(message.append);
        if (message.ui_percentage != null && Object.hasOwnProperty.call(message, "ui_percentage"))
            writer.uint32(32).uint32(message.ui_percentage);
        return writer;
    };

    EmmcFileWrite.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EmmcFileWrite.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EmmcFileWrite();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.file = $root.EmmcFile.decode(reader, reader.uint32());
                break;
            case 2:
                message.overwrite = reader.bool();
                break;
            case 3:
                message.append = reader.bool();
                break;
            case 4:
                message.ui_percentage = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("file"))
            throw $util.ProtocolError("missing required 'file'", { instance: message });
        if (!message.hasOwnProperty("overwrite"))
            throw $util.ProtocolError("missing required 'overwrite'", { instance: message });
        if (!message.hasOwnProperty("append"))
            throw $util.ProtocolError("missing required 'append'", { instance: message });
        return message;
    };

    EmmcFileWrite.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EmmcFileWrite.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        {
            var error = $root.EmmcFile.verify(message.file);
            if (error)
                return "file." + error;
        }
        if (typeof message.overwrite !== "boolean")
            return "overwrite: boolean expected";
        if (typeof message.append !== "boolean")
            return "append: boolean expected";
        if (message.ui_percentage != null && message.hasOwnProperty("ui_percentage"))
            if (!$util.isInteger(message.ui_percentage))
                return "ui_percentage: integer expected";
        return null;
    };

    EmmcFileWrite.fromObject = function fromObject(object) {
        if (object instanceof $root.EmmcFileWrite)
            return object;
        var message = new $root.EmmcFileWrite();
        if (object.file != null) {
            if (typeof object.file !== "object")
                throw TypeError(".EmmcFileWrite.file: object expected");
            message.file = $root.EmmcFile.fromObject(object.file);
        }
        if (object.overwrite != null)
            message.overwrite = Boolean(object.overwrite);
        if (object.append != null)
            message.append = Boolean(object.append);
        if (object.ui_percentage != null)
            message.ui_percentage = object.ui_percentage >>> 0;
        return message;
    };

    EmmcFileWrite.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.file = null;
            object.overwrite = false;
            object.append = false;
            object.ui_percentage = 0;
        }
        if (message.file != null && message.hasOwnProperty("file"))
            object.file = $root.EmmcFile.toObject(message.file, options);
        if (message.overwrite != null && message.hasOwnProperty("overwrite"))
            object.overwrite = message.overwrite;
        if (message.append != null && message.hasOwnProperty("append"))
            object.append = message.append;
        if (message.ui_percentage != null && message.hasOwnProperty("ui_percentage"))
            object.ui_percentage = message.ui_percentage;
        return object;
    };

    EmmcFileWrite.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EmmcFileWrite;
})();

$root.EmmcFileDelete = (function() {

    function EmmcFileDelete(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EmmcFileDelete.prototype.path = "";

    EmmcFileDelete.create = function create(properties) {
        return new EmmcFileDelete(properties);
    };

    EmmcFileDelete.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.path);
        return writer;
    };

    EmmcFileDelete.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EmmcFileDelete.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EmmcFileDelete();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.path = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("path"))
            throw $util.ProtocolError("missing required 'path'", { instance: message });
        return message;
    };

    EmmcFileDelete.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EmmcFileDelete.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.path))
            return "path: string expected";
        return null;
    };

    EmmcFileDelete.fromObject = function fromObject(object) {
        if (object instanceof $root.EmmcFileDelete)
            return object;
        var message = new $root.EmmcFileDelete();
        if (object.path != null)
            message.path = String(object.path);
        return message;
    };

    EmmcFileDelete.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.path = "";
        if (message.path != null && message.hasOwnProperty("path"))
            object.path = message.path;
        return object;
    };

    EmmcFileDelete.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EmmcFileDelete;
})();

$root.EmmcDir = (function() {

    function EmmcDir(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EmmcDir.prototype.path = "";
    EmmcDir.prototype.child_dirs = "";
    EmmcDir.prototype.child_files = "";

    EmmcDir.create = function create(properties) {
        return new EmmcDir(properties);
    };

    EmmcDir.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.path);
        if (message.child_dirs != null && Object.hasOwnProperty.call(message, "child_dirs"))
            writer.uint32(18).string(message.child_dirs);
        if (message.child_files != null && Object.hasOwnProperty.call(message, "child_files"))
            writer.uint32(26).string(message.child_files);
        return writer;
    };

    EmmcDir.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EmmcDir.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EmmcDir();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.path = reader.string();
                break;
            case 2:
                message.child_dirs = reader.string();
                break;
            case 3:
                message.child_files = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("path"))
            throw $util.ProtocolError("missing required 'path'", { instance: message });
        return message;
    };

    EmmcDir.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EmmcDir.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.path))
            return "path: string expected";
        if (message.child_dirs != null && message.hasOwnProperty("child_dirs"))
            if (!$util.isString(message.child_dirs))
                return "child_dirs: string expected";
        if (message.child_files != null && message.hasOwnProperty("child_files"))
            if (!$util.isString(message.child_files))
                return "child_files: string expected";
        return null;
    };

    EmmcDir.fromObject = function fromObject(object) {
        if (object instanceof $root.EmmcDir)
            return object;
        var message = new $root.EmmcDir();
        if (object.path != null)
            message.path = String(object.path);
        if (object.child_dirs != null)
            message.child_dirs = String(object.child_dirs);
        if (object.child_files != null)
            message.child_files = String(object.child_files);
        return message;
    };

    EmmcDir.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.path = "";
            object.child_dirs = "";
            object.child_files = "";
        }
        if (message.path != null && message.hasOwnProperty("path"))
            object.path = message.path;
        if (message.child_dirs != null && message.hasOwnProperty("child_dirs"))
            object.child_dirs = message.child_dirs;
        if (message.child_files != null && message.hasOwnProperty("child_files"))
            object.child_files = message.child_files;
        return object;
    };

    EmmcDir.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EmmcDir;
})();

$root.EmmcDirList = (function() {

    function EmmcDirList(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EmmcDirList.prototype.path = "";

    EmmcDirList.create = function create(properties) {
        return new EmmcDirList(properties);
    };

    EmmcDirList.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.path);
        return writer;
    };

    EmmcDirList.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EmmcDirList.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EmmcDirList();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.path = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("path"))
            throw $util.ProtocolError("missing required 'path'", { instance: message });
        return message;
    };

    EmmcDirList.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EmmcDirList.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.path))
            return "path: string expected";
        return null;
    };

    EmmcDirList.fromObject = function fromObject(object) {
        if (object instanceof $root.EmmcDirList)
            return object;
        var message = new $root.EmmcDirList();
        if (object.path != null)
            message.path = String(object.path);
        return message;
    };

    EmmcDirList.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.path = "";
        if (message.path != null && message.hasOwnProperty("path"))
            object.path = message.path;
        return object;
    };

    EmmcDirList.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EmmcDirList;
})();

$root.EmmcDirMake = (function() {

    function EmmcDirMake(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EmmcDirMake.prototype.path = "";

    EmmcDirMake.create = function create(properties) {
        return new EmmcDirMake(properties);
    };

    EmmcDirMake.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.path);
        return writer;
    };

    EmmcDirMake.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EmmcDirMake.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EmmcDirMake();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.path = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("path"))
            throw $util.ProtocolError("missing required 'path'", { instance: message });
        return message;
    };

    EmmcDirMake.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EmmcDirMake.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.path))
            return "path: string expected";
        return null;
    };

    EmmcDirMake.fromObject = function fromObject(object) {
        if (object instanceof $root.EmmcDirMake)
            return object;
        var message = new $root.EmmcDirMake();
        if (object.path != null)
            message.path = String(object.path);
        return message;
    };

    EmmcDirMake.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.path = "";
        if (message.path != null && message.hasOwnProperty("path"))
            object.path = message.path;
        return object;
    };

    EmmcDirMake.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EmmcDirMake;
})();

$root.EmmcDirRemove = (function() {

    function EmmcDirRemove(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EmmcDirRemove.prototype.path = "";

    EmmcDirRemove.create = function create(properties) {
        return new EmmcDirRemove(properties);
    };

    EmmcDirRemove.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.path);
        return writer;
    };

    EmmcDirRemove.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EmmcDirRemove.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EmmcDirRemove();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.path = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("path"))
            throw $util.ProtocolError("missing required 'path'", { instance: message });
        return message;
    };

    EmmcDirRemove.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EmmcDirRemove.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.path))
            return "path: string expected";
        return null;
    };

    EmmcDirRemove.fromObject = function fromObject(object) {
        if (object instanceof $root.EmmcDirRemove)
            return object;
        var message = new $root.EmmcDirRemove();
        if (object.path != null)
            message.path = String(object.path);
        return message;
    };

    EmmcDirRemove.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.path = "";
        if (message.path != null && message.hasOwnProperty("path"))
            object.path = message.path;
        return object;
    };

    EmmcDirRemove.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EmmcDirRemove;
})();

$root.EosGetPublicKey = (function() {

    function EosGetPublicKey(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EosGetPublicKey.prototype.address_n = $util.emptyArray;
    EosGetPublicKey.prototype.show_display = false;

    EosGetPublicKey.create = function create(properties) {
        return new EosGetPublicKey(properties);
    };

    EosGetPublicKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(16).bool(message.show_display);
        return writer;
    };

    EosGetPublicKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EosGetPublicKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EosGetPublicKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.show_display = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    EosGetPublicKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EosGetPublicKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        return null;
    };

    EosGetPublicKey.fromObject = function fromObject(object) {
        if (object instanceof $root.EosGetPublicKey)
            return object;
        var message = new $root.EosGetPublicKey();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".EosGetPublicKey.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        return message;
    };

    EosGetPublicKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            object.show_display = false;
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        return object;
    };

    EosGetPublicKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EosGetPublicKey;
})();

$root.EosPublicKey = (function() {

    function EosPublicKey(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EosPublicKey.prototype.wif_public_key = "";
    EosPublicKey.prototype.raw_public_key = $util.newBuffer([]);

    EosPublicKey.create = function create(properties) {
        return new EosPublicKey(properties);
    };

    EosPublicKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.wif_public_key);
        writer.uint32(18).bytes(message.raw_public_key);
        return writer;
    };

    EosPublicKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EosPublicKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EosPublicKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.wif_public_key = reader.string();
                break;
            case 2:
                message.raw_public_key = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("wif_public_key"))
            throw $util.ProtocolError("missing required 'wif_public_key'", { instance: message });
        if (!message.hasOwnProperty("raw_public_key"))
            throw $util.ProtocolError("missing required 'raw_public_key'", { instance: message });
        return message;
    };

    EosPublicKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EosPublicKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.wif_public_key))
            return "wif_public_key: string expected";
        if (!(message.raw_public_key && typeof message.raw_public_key.length === "number" || $util.isString(message.raw_public_key)))
            return "raw_public_key: buffer expected";
        return null;
    };

    EosPublicKey.fromObject = function fromObject(object) {
        if (object instanceof $root.EosPublicKey)
            return object;
        var message = new $root.EosPublicKey();
        if (object.wif_public_key != null)
            message.wif_public_key = String(object.wif_public_key);
        if (object.raw_public_key != null)
            if (typeof object.raw_public_key === "string")
                $util.base64.decode(object.raw_public_key, message.raw_public_key = $util.newBuffer($util.base64.length(object.raw_public_key)), 0);
            else if (object.raw_public_key.length)
                message.raw_public_key = object.raw_public_key;
        return message;
    };

    EosPublicKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.wif_public_key = "";
            if (options.bytes === String)
                object.raw_public_key = "";
            else {
                object.raw_public_key = [];
                if (options.bytes !== Array)
                    object.raw_public_key = $util.newBuffer(object.raw_public_key);
            }
        }
        if (message.wif_public_key != null && message.hasOwnProperty("wif_public_key"))
            object.wif_public_key = message.wif_public_key;
        if (message.raw_public_key != null && message.hasOwnProperty("raw_public_key"))
            object.raw_public_key = options.bytes === String ? $util.base64.encode(message.raw_public_key, 0, message.raw_public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.raw_public_key) : message.raw_public_key;
        return object;
    };

    EosPublicKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EosPublicKey;
})();

$root.EosSignTx = (function() {

    function EosSignTx(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EosSignTx.prototype.address_n = $util.emptyArray;
    EosSignTx.prototype.chain_id = $util.newBuffer([]);
    EosSignTx.prototype.header = null;
    EosSignTx.prototype.num_actions = 0;

    EosSignTx.create = function create(properties) {
        return new EosSignTx(properties);
    };

    EosSignTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.chain_id != null && Object.hasOwnProperty.call(message, "chain_id"))
            writer.uint32(18).bytes(message.chain_id);
        if (message.header != null && Object.hasOwnProperty.call(message, "header"))
            $root.EosSignTx.EosTxHeader.encode(message.header, writer.uint32(26).fork()).ldelim();
        if (message.num_actions != null && Object.hasOwnProperty.call(message, "num_actions"))
            writer.uint32(32).uint32(message.num_actions);
        return writer;
    };

    EosSignTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EosSignTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EosSignTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.chain_id = reader.bytes();
                break;
            case 3:
                message.header = $root.EosSignTx.EosTxHeader.decode(reader, reader.uint32());
                break;
            case 4:
                message.num_actions = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    EosSignTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EosSignTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.chain_id != null && message.hasOwnProperty("chain_id"))
            if (!(message.chain_id && typeof message.chain_id.length === "number" || $util.isString(message.chain_id)))
                return "chain_id: buffer expected";
        if (message.header != null && message.hasOwnProperty("header")) {
            var error = $root.EosSignTx.EosTxHeader.verify(message.header);
            if (error)
                return "header." + error;
        }
        if (message.num_actions != null && message.hasOwnProperty("num_actions"))
            if (!$util.isInteger(message.num_actions))
                return "num_actions: integer expected";
        return null;
    };

    EosSignTx.fromObject = function fromObject(object) {
        if (object instanceof $root.EosSignTx)
            return object;
        var message = new $root.EosSignTx();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".EosSignTx.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.chain_id != null)
            if (typeof object.chain_id === "string")
                $util.base64.decode(object.chain_id, message.chain_id = $util.newBuffer($util.base64.length(object.chain_id)), 0);
            else if (object.chain_id.length)
                message.chain_id = object.chain_id;
        if (object.header != null) {
            if (typeof object.header !== "object")
                throw TypeError(".EosSignTx.header: object expected");
            message.header = $root.EosSignTx.EosTxHeader.fromObject(object.header);
        }
        if (object.num_actions != null)
            message.num_actions = object.num_actions >>> 0;
        return message;
    };

    EosSignTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            if (options.bytes === String)
                object.chain_id = "";
            else {
                object.chain_id = [];
                if (options.bytes !== Array)
                    object.chain_id = $util.newBuffer(object.chain_id);
            }
            object.header = null;
            object.num_actions = 0;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.chain_id != null && message.hasOwnProperty("chain_id"))
            object.chain_id = options.bytes === String ? $util.base64.encode(message.chain_id, 0, message.chain_id.length) : options.bytes === Array ? Array.prototype.slice.call(message.chain_id) : message.chain_id;
        if (message.header != null && message.hasOwnProperty("header"))
            object.header = $root.EosSignTx.EosTxHeader.toObject(message.header, options);
        if (message.num_actions != null && message.hasOwnProperty("num_actions"))
            object.num_actions = message.num_actions;
        return object;
    };

    EosSignTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    EosSignTx.EosTxHeader = (function() {

        function EosTxHeader(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        EosTxHeader.prototype.expiration = 0;
        EosTxHeader.prototype.ref_block_num = 0;
        EosTxHeader.prototype.ref_block_prefix = 0;
        EosTxHeader.prototype.max_net_usage_words = 0;
        EosTxHeader.prototype.max_cpu_usage_ms = 0;
        EosTxHeader.prototype.delay_sec = 0;

        EosTxHeader.create = function create(properties) {
            return new EosTxHeader(properties);
        };

        EosTxHeader.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(8).uint32(message.expiration);
            writer.uint32(16).uint32(message.ref_block_num);
            writer.uint32(24).uint32(message.ref_block_prefix);
            writer.uint32(32).uint32(message.max_net_usage_words);
            writer.uint32(40).uint32(message.max_cpu_usage_ms);
            writer.uint32(48).uint32(message.delay_sec);
            return writer;
        };

        EosTxHeader.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        EosTxHeader.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EosSignTx.EosTxHeader();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.expiration = reader.uint32();
                    break;
                case 2:
                    message.ref_block_num = reader.uint32();
                    break;
                case 3:
                    message.ref_block_prefix = reader.uint32();
                    break;
                case 4:
                    message.max_net_usage_words = reader.uint32();
                    break;
                case 5:
                    message.max_cpu_usage_ms = reader.uint32();
                    break;
                case 6:
                    message.delay_sec = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("expiration"))
                throw $util.ProtocolError("missing required 'expiration'", { instance: message });
            if (!message.hasOwnProperty("ref_block_num"))
                throw $util.ProtocolError("missing required 'ref_block_num'", { instance: message });
            if (!message.hasOwnProperty("ref_block_prefix"))
                throw $util.ProtocolError("missing required 'ref_block_prefix'", { instance: message });
            if (!message.hasOwnProperty("max_net_usage_words"))
                throw $util.ProtocolError("missing required 'max_net_usage_words'", { instance: message });
            if (!message.hasOwnProperty("max_cpu_usage_ms"))
                throw $util.ProtocolError("missing required 'max_cpu_usage_ms'", { instance: message });
            if (!message.hasOwnProperty("delay_sec"))
                throw $util.ProtocolError("missing required 'delay_sec'", { instance: message });
            return message;
        };

        EosTxHeader.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        EosTxHeader.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isInteger(message.expiration))
                return "expiration: integer expected";
            if (!$util.isInteger(message.ref_block_num))
                return "ref_block_num: integer expected";
            if (!$util.isInteger(message.ref_block_prefix))
                return "ref_block_prefix: integer expected";
            if (!$util.isInteger(message.max_net_usage_words))
                return "max_net_usage_words: integer expected";
            if (!$util.isInteger(message.max_cpu_usage_ms))
                return "max_cpu_usage_ms: integer expected";
            if (!$util.isInteger(message.delay_sec))
                return "delay_sec: integer expected";
            return null;
        };

        EosTxHeader.fromObject = function fromObject(object) {
            if (object instanceof $root.EosSignTx.EosTxHeader)
                return object;
            var message = new $root.EosSignTx.EosTxHeader();
            if (object.expiration != null)
                message.expiration = object.expiration >>> 0;
            if (object.ref_block_num != null)
                message.ref_block_num = object.ref_block_num >>> 0;
            if (object.ref_block_prefix != null)
                message.ref_block_prefix = object.ref_block_prefix >>> 0;
            if (object.max_net_usage_words != null)
                message.max_net_usage_words = object.max_net_usage_words >>> 0;
            if (object.max_cpu_usage_ms != null)
                message.max_cpu_usage_ms = object.max_cpu_usage_ms >>> 0;
            if (object.delay_sec != null)
                message.delay_sec = object.delay_sec >>> 0;
            return message;
        };

        EosTxHeader.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.expiration = 0;
                object.ref_block_num = 0;
                object.ref_block_prefix = 0;
                object.max_net_usage_words = 0;
                object.max_cpu_usage_ms = 0;
                object.delay_sec = 0;
            }
            if (message.expiration != null && message.hasOwnProperty("expiration"))
                object.expiration = message.expiration;
            if (message.ref_block_num != null && message.hasOwnProperty("ref_block_num"))
                object.ref_block_num = message.ref_block_num;
            if (message.ref_block_prefix != null && message.hasOwnProperty("ref_block_prefix"))
                object.ref_block_prefix = message.ref_block_prefix;
            if (message.max_net_usage_words != null && message.hasOwnProperty("max_net_usage_words"))
                object.max_net_usage_words = message.max_net_usage_words;
            if (message.max_cpu_usage_ms != null && message.hasOwnProperty("max_cpu_usage_ms"))
                object.max_cpu_usage_ms = message.max_cpu_usage_ms;
            if (message.delay_sec != null && message.hasOwnProperty("delay_sec"))
                object.delay_sec = message.delay_sec;
            return object;
        };

        EosTxHeader.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EosTxHeader;
    })();

    return EosSignTx;
})();

$root.EosTxActionRequest = (function() {

    function EosTxActionRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EosTxActionRequest.prototype.data_size = 0;

    EosTxActionRequest.create = function create(properties) {
        return new EosTxActionRequest(properties);
    };

    EosTxActionRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.data_size != null && Object.hasOwnProperty.call(message, "data_size"))
            writer.uint32(8).uint32(message.data_size);
        return writer;
    };

    EosTxActionRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EosTxActionRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EosTxActionRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.data_size = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    EosTxActionRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EosTxActionRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.data_size != null && message.hasOwnProperty("data_size"))
            if (!$util.isInteger(message.data_size))
                return "data_size: integer expected";
        return null;
    };

    EosTxActionRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.EosTxActionRequest)
            return object;
        var message = new $root.EosTxActionRequest();
        if (object.data_size != null)
            message.data_size = object.data_size >>> 0;
        return message;
    };

    EosTxActionRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.data_size = 0;
        if (message.data_size != null && message.hasOwnProperty("data_size"))
            object.data_size = message.data_size;
        return object;
    };

    EosTxActionRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EosTxActionRequest;
})();

$root.EosTxActionAck = (function() {

    function EosTxActionAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EosTxActionAck.prototype.common = null;
    EosTxActionAck.prototype.transfer = null;
    EosTxActionAck.prototype.delegate = null;
    EosTxActionAck.prototype.undelegate = null;
    EosTxActionAck.prototype.refund = null;
    EosTxActionAck.prototype.buy_ram = null;
    EosTxActionAck.prototype.buy_ram_bytes = null;
    EosTxActionAck.prototype.sell_ram = null;
    EosTxActionAck.prototype.vote_producer = null;
    EosTxActionAck.prototype.update_auth = null;
    EosTxActionAck.prototype.delete_auth = null;
    EosTxActionAck.prototype.link_auth = null;
    EosTxActionAck.prototype.unlink_auth = null;
    EosTxActionAck.prototype.new_account = null;
    EosTxActionAck.prototype.unknown = null;

    EosTxActionAck.create = function create(properties) {
        return new EosTxActionAck(properties);
    };

    EosTxActionAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.common != null && Object.hasOwnProperty.call(message, "common"))
            $root.EosTxActionAck.EosActionCommon.encode(message.common, writer.uint32(10).fork()).ldelim();
        if (message.transfer != null && Object.hasOwnProperty.call(message, "transfer"))
            $root.EosTxActionAck.EosActionTransfer.encode(message.transfer, writer.uint32(18).fork()).ldelim();
        if (message.delegate != null && Object.hasOwnProperty.call(message, "delegate"))
            $root.EosTxActionAck.EosActionDelegate.encode(message.delegate, writer.uint32(26).fork()).ldelim();
        if (message.undelegate != null && Object.hasOwnProperty.call(message, "undelegate"))
            $root.EosTxActionAck.EosActionUndelegate.encode(message.undelegate, writer.uint32(34).fork()).ldelim();
        if (message.refund != null && Object.hasOwnProperty.call(message, "refund"))
            $root.EosTxActionAck.EosActionRefund.encode(message.refund, writer.uint32(42).fork()).ldelim();
        if (message.buy_ram != null && Object.hasOwnProperty.call(message, "buy_ram"))
            $root.EosTxActionAck.EosActionBuyRam.encode(message.buy_ram, writer.uint32(50).fork()).ldelim();
        if (message.buy_ram_bytes != null && Object.hasOwnProperty.call(message, "buy_ram_bytes"))
            $root.EosTxActionAck.EosActionBuyRamBytes.encode(message.buy_ram_bytes, writer.uint32(58).fork()).ldelim();
        if (message.sell_ram != null && Object.hasOwnProperty.call(message, "sell_ram"))
            $root.EosTxActionAck.EosActionSellRam.encode(message.sell_ram, writer.uint32(66).fork()).ldelim();
        if (message.vote_producer != null && Object.hasOwnProperty.call(message, "vote_producer"))
            $root.EosTxActionAck.EosActionVoteProducer.encode(message.vote_producer, writer.uint32(74).fork()).ldelim();
        if (message.update_auth != null && Object.hasOwnProperty.call(message, "update_auth"))
            $root.EosTxActionAck.EosActionUpdateAuth.encode(message.update_auth, writer.uint32(82).fork()).ldelim();
        if (message.delete_auth != null && Object.hasOwnProperty.call(message, "delete_auth"))
            $root.EosTxActionAck.EosActionDeleteAuth.encode(message.delete_auth, writer.uint32(90).fork()).ldelim();
        if (message.link_auth != null && Object.hasOwnProperty.call(message, "link_auth"))
            $root.EosTxActionAck.EosActionLinkAuth.encode(message.link_auth, writer.uint32(98).fork()).ldelim();
        if (message.unlink_auth != null && Object.hasOwnProperty.call(message, "unlink_auth"))
            $root.EosTxActionAck.EosActionUnlinkAuth.encode(message.unlink_auth, writer.uint32(106).fork()).ldelim();
        if (message.new_account != null && Object.hasOwnProperty.call(message, "new_account"))
            $root.EosTxActionAck.EosActionNewAccount.encode(message.new_account, writer.uint32(114).fork()).ldelim();
        if (message.unknown != null && Object.hasOwnProperty.call(message, "unknown"))
            $root.EosTxActionAck.EosActionUnknown.encode(message.unknown, writer.uint32(122).fork()).ldelim();
        return writer;
    };

    EosTxActionAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EosTxActionAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EosTxActionAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.common = $root.EosTxActionAck.EosActionCommon.decode(reader, reader.uint32());
                break;
            case 2:
                message.transfer = $root.EosTxActionAck.EosActionTransfer.decode(reader, reader.uint32());
                break;
            case 3:
                message.delegate = $root.EosTxActionAck.EosActionDelegate.decode(reader, reader.uint32());
                break;
            case 4:
                message.undelegate = $root.EosTxActionAck.EosActionUndelegate.decode(reader, reader.uint32());
                break;
            case 5:
                message.refund = $root.EosTxActionAck.EosActionRefund.decode(reader, reader.uint32());
                break;
            case 6:
                message.buy_ram = $root.EosTxActionAck.EosActionBuyRam.decode(reader, reader.uint32());
                break;
            case 7:
                message.buy_ram_bytes = $root.EosTxActionAck.EosActionBuyRamBytes.decode(reader, reader.uint32());
                break;
            case 8:
                message.sell_ram = $root.EosTxActionAck.EosActionSellRam.decode(reader, reader.uint32());
                break;
            case 9:
                message.vote_producer = $root.EosTxActionAck.EosActionVoteProducer.decode(reader, reader.uint32());
                break;
            case 10:
                message.update_auth = $root.EosTxActionAck.EosActionUpdateAuth.decode(reader, reader.uint32());
                break;
            case 11:
                message.delete_auth = $root.EosTxActionAck.EosActionDeleteAuth.decode(reader, reader.uint32());
                break;
            case 12:
                message.link_auth = $root.EosTxActionAck.EosActionLinkAuth.decode(reader, reader.uint32());
                break;
            case 13:
                message.unlink_auth = $root.EosTxActionAck.EosActionUnlinkAuth.decode(reader, reader.uint32());
                break;
            case 14:
                message.new_account = $root.EosTxActionAck.EosActionNewAccount.decode(reader, reader.uint32());
                break;
            case 15:
                message.unknown = $root.EosTxActionAck.EosActionUnknown.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    EosTxActionAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EosTxActionAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.common != null && message.hasOwnProperty("common")) {
            var error = $root.EosTxActionAck.EosActionCommon.verify(message.common);
            if (error)
                return "common." + error;
        }
        if (message.transfer != null && message.hasOwnProperty("transfer")) {
            var error = $root.EosTxActionAck.EosActionTransfer.verify(message.transfer);
            if (error)
                return "transfer." + error;
        }
        if (message.delegate != null && message.hasOwnProperty("delegate")) {
            var error = $root.EosTxActionAck.EosActionDelegate.verify(message.delegate);
            if (error)
                return "delegate." + error;
        }
        if (message.undelegate != null && message.hasOwnProperty("undelegate")) {
            var error = $root.EosTxActionAck.EosActionUndelegate.verify(message.undelegate);
            if (error)
                return "undelegate." + error;
        }
        if (message.refund != null && message.hasOwnProperty("refund")) {
            var error = $root.EosTxActionAck.EosActionRefund.verify(message.refund);
            if (error)
                return "refund." + error;
        }
        if (message.buy_ram != null && message.hasOwnProperty("buy_ram")) {
            var error = $root.EosTxActionAck.EosActionBuyRam.verify(message.buy_ram);
            if (error)
                return "buy_ram." + error;
        }
        if (message.buy_ram_bytes != null && message.hasOwnProperty("buy_ram_bytes")) {
            var error = $root.EosTxActionAck.EosActionBuyRamBytes.verify(message.buy_ram_bytes);
            if (error)
                return "buy_ram_bytes." + error;
        }
        if (message.sell_ram != null && message.hasOwnProperty("sell_ram")) {
            var error = $root.EosTxActionAck.EosActionSellRam.verify(message.sell_ram);
            if (error)
                return "sell_ram." + error;
        }
        if (message.vote_producer != null && message.hasOwnProperty("vote_producer")) {
            var error = $root.EosTxActionAck.EosActionVoteProducer.verify(message.vote_producer);
            if (error)
                return "vote_producer." + error;
        }
        if (message.update_auth != null && message.hasOwnProperty("update_auth")) {
            var error = $root.EosTxActionAck.EosActionUpdateAuth.verify(message.update_auth);
            if (error)
                return "update_auth." + error;
        }
        if (message.delete_auth != null && message.hasOwnProperty("delete_auth")) {
            var error = $root.EosTxActionAck.EosActionDeleteAuth.verify(message.delete_auth);
            if (error)
                return "delete_auth." + error;
        }
        if (message.link_auth != null && message.hasOwnProperty("link_auth")) {
            var error = $root.EosTxActionAck.EosActionLinkAuth.verify(message.link_auth);
            if (error)
                return "link_auth." + error;
        }
        if (message.unlink_auth != null && message.hasOwnProperty("unlink_auth")) {
            var error = $root.EosTxActionAck.EosActionUnlinkAuth.verify(message.unlink_auth);
            if (error)
                return "unlink_auth." + error;
        }
        if (message.new_account != null && message.hasOwnProperty("new_account")) {
            var error = $root.EosTxActionAck.EosActionNewAccount.verify(message.new_account);
            if (error)
                return "new_account." + error;
        }
        if (message.unknown != null && message.hasOwnProperty("unknown")) {
            var error = $root.EosTxActionAck.EosActionUnknown.verify(message.unknown);
            if (error)
                return "unknown." + error;
        }
        return null;
    };

    EosTxActionAck.fromObject = function fromObject(object) {
        if (object instanceof $root.EosTxActionAck)
            return object;
        var message = new $root.EosTxActionAck();
        if (object.common != null) {
            if (typeof object.common !== "object")
                throw TypeError(".EosTxActionAck.common: object expected");
            message.common = $root.EosTxActionAck.EosActionCommon.fromObject(object.common);
        }
        if (object.transfer != null) {
            if (typeof object.transfer !== "object")
                throw TypeError(".EosTxActionAck.transfer: object expected");
            message.transfer = $root.EosTxActionAck.EosActionTransfer.fromObject(object.transfer);
        }
        if (object.delegate != null) {
            if (typeof object.delegate !== "object")
                throw TypeError(".EosTxActionAck.delegate: object expected");
            message.delegate = $root.EosTxActionAck.EosActionDelegate.fromObject(object.delegate);
        }
        if (object.undelegate != null) {
            if (typeof object.undelegate !== "object")
                throw TypeError(".EosTxActionAck.undelegate: object expected");
            message.undelegate = $root.EosTxActionAck.EosActionUndelegate.fromObject(object.undelegate);
        }
        if (object.refund != null) {
            if (typeof object.refund !== "object")
                throw TypeError(".EosTxActionAck.refund: object expected");
            message.refund = $root.EosTxActionAck.EosActionRefund.fromObject(object.refund);
        }
        if (object.buy_ram != null) {
            if (typeof object.buy_ram !== "object")
                throw TypeError(".EosTxActionAck.buy_ram: object expected");
            message.buy_ram = $root.EosTxActionAck.EosActionBuyRam.fromObject(object.buy_ram);
        }
        if (object.buy_ram_bytes != null) {
            if (typeof object.buy_ram_bytes !== "object")
                throw TypeError(".EosTxActionAck.buy_ram_bytes: object expected");
            message.buy_ram_bytes = $root.EosTxActionAck.EosActionBuyRamBytes.fromObject(object.buy_ram_bytes);
        }
        if (object.sell_ram != null) {
            if (typeof object.sell_ram !== "object")
                throw TypeError(".EosTxActionAck.sell_ram: object expected");
            message.sell_ram = $root.EosTxActionAck.EosActionSellRam.fromObject(object.sell_ram);
        }
        if (object.vote_producer != null) {
            if (typeof object.vote_producer !== "object")
                throw TypeError(".EosTxActionAck.vote_producer: object expected");
            message.vote_producer = $root.EosTxActionAck.EosActionVoteProducer.fromObject(object.vote_producer);
        }
        if (object.update_auth != null) {
            if (typeof object.update_auth !== "object")
                throw TypeError(".EosTxActionAck.update_auth: object expected");
            message.update_auth = $root.EosTxActionAck.EosActionUpdateAuth.fromObject(object.update_auth);
        }
        if (object.delete_auth != null) {
            if (typeof object.delete_auth !== "object")
                throw TypeError(".EosTxActionAck.delete_auth: object expected");
            message.delete_auth = $root.EosTxActionAck.EosActionDeleteAuth.fromObject(object.delete_auth);
        }
        if (object.link_auth != null) {
            if (typeof object.link_auth !== "object")
                throw TypeError(".EosTxActionAck.link_auth: object expected");
            message.link_auth = $root.EosTxActionAck.EosActionLinkAuth.fromObject(object.link_auth);
        }
        if (object.unlink_auth != null) {
            if (typeof object.unlink_auth !== "object")
                throw TypeError(".EosTxActionAck.unlink_auth: object expected");
            message.unlink_auth = $root.EosTxActionAck.EosActionUnlinkAuth.fromObject(object.unlink_auth);
        }
        if (object.new_account != null) {
            if (typeof object.new_account !== "object")
                throw TypeError(".EosTxActionAck.new_account: object expected");
            message.new_account = $root.EosTxActionAck.EosActionNewAccount.fromObject(object.new_account);
        }
        if (object.unknown != null) {
            if (typeof object.unknown !== "object")
                throw TypeError(".EosTxActionAck.unknown: object expected");
            message.unknown = $root.EosTxActionAck.EosActionUnknown.fromObject(object.unknown);
        }
        return message;
    };

    EosTxActionAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.common = null;
            object.transfer = null;
            object.delegate = null;
            object.undelegate = null;
            object.refund = null;
            object.buy_ram = null;
            object.buy_ram_bytes = null;
            object.sell_ram = null;
            object.vote_producer = null;
            object.update_auth = null;
            object.delete_auth = null;
            object.link_auth = null;
            object.unlink_auth = null;
            object.new_account = null;
            object.unknown = null;
        }
        if (message.common != null && message.hasOwnProperty("common"))
            object.common = $root.EosTxActionAck.EosActionCommon.toObject(message.common, options);
        if (message.transfer != null && message.hasOwnProperty("transfer"))
            object.transfer = $root.EosTxActionAck.EosActionTransfer.toObject(message.transfer, options);
        if (message.delegate != null && message.hasOwnProperty("delegate"))
            object.delegate = $root.EosTxActionAck.EosActionDelegate.toObject(message.delegate, options);
        if (message.undelegate != null && message.hasOwnProperty("undelegate"))
            object.undelegate = $root.EosTxActionAck.EosActionUndelegate.toObject(message.undelegate, options);
        if (message.refund != null && message.hasOwnProperty("refund"))
            object.refund = $root.EosTxActionAck.EosActionRefund.toObject(message.refund, options);
        if (message.buy_ram != null && message.hasOwnProperty("buy_ram"))
            object.buy_ram = $root.EosTxActionAck.EosActionBuyRam.toObject(message.buy_ram, options);
        if (message.buy_ram_bytes != null && message.hasOwnProperty("buy_ram_bytes"))
            object.buy_ram_bytes = $root.EosTxActionAck.EosActionBuyRamBytes.toObject(message.buy_ram_bytes, options);
        if (message.sell_ram != null && message.hasOwnProperty("sell_ram"))
            object.sell_ram = $root.EosTxActionAck.EosActionSellRam.toObject(message.sell_ram, options);
        if (message.vote_producer != null && message.hasOwnProperty("vote_producer"))
            object.vote_producer = $root.EosTxActionAck.EosActionVoteProducer.toObject(message.vote_producer, options);
        if (message.update_auth != null && message.hasOwnProperty("update_auth"))
            object.update_auth = $root.EosTxActionAck.EosActionUpdateAuth.toObject(message.update_auth, options);
        if (message.delete_auth != null && message.hasOwnProperty("delete_auth"))
            object.delete_auth = $root.EosTxActionAck.EosActionDeleteAuth.toObject(message.delete_auth, options);
        if (message.link_auth != null && message.hasOwnProperty("link_auth"))
            object.link_auth = $root.EosTxActionAck.EosActionLinkAuth.toObject(message.link_auth, options);
        if (message.unlink_auth != null && message.hasOwnProperty("unlink_auth"))
            object.unlink_auth = $root.EosTxActionAck.EosActionUnlinkAuth.toObject(message.unlink_auth, options);
        if (message.new_account != null && message.hasOwnProperty("new_account"))
            object.new_account = $root.EosTxActionAck.EosActionNewAccount.toObject(message.new_account, options);
        if (message.unknown != null && message.hasOwnProperty("unknown"))
            object.unknown = $root.EosTxActionAck.EosActionUnknown.toObject(message.unknown, options);
        return object;
    };

    EosTxActionAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    EosTxActionAck.EosAsset = (function() {

        function EosAsset(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        EosAsset.prototype.amount = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        EosAsset.prototype.symbol = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        EosAsset.create = function create(properties) {
            return new EosAsset(properties);
        };

        EosAsset.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
                writer.uint32(8).sint64(message.amount);
            if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
                writer.uint32(16).uint64(message.symbol);
            return writer;
        };

        EosAsset.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        EosAsset.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EosTxActionAck.EosAsset();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.amount = reader.sint64();
                    break;
                case 2:
                    message.symbol = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        EosAsset.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        EosAsset.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.amount != null && message.hasOwnProperty("amount"))
                if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
                    return "amount: integer|Long expected";
            if (message.symbol != null && message.hasOwnProperty("symbol"))
                if (!$util.isInteger(message.symbol) && !(message.symbol && $util.isInteger(message.symbol.low) && $util.isInteger(message.symbol.high)))
                    return "symbol: integer|Long expected";
            return null;
        };

        EosAsset.fromObject = function fromObject(object) {
            if (object instanceof $root.EosTxActionAck.EosAsset)
                return object;
            var message = new $root.EosTxActionAck.EosAsset();
            if (object.amount != null)
                if ($util.Long)
                    (message.amount = $util.Long.fromValue(object.amount)).unsigned = false;
                else if (typeof object.amount === "string")
                    message.amount = parseInt(object.amount, 10);
                else if (typeof object.amount === "number")
                    message.amount = object.amount;
                else if (typeof object.amount === "object")
                    message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber();
            if (object.symbol != null)
                if ($util.Long)
                    (message.symbol = $util.Long.fromValue(object.symbol)).unsigned = true;
                else if (typeof object.symbol === "string")
                    message.symbol = parseInt(object.symbol, 10);
                else if (typeof object.symbol === "number")
                    message.symbol = object.symbol;
                else if (typeof object.symbol === "object")
                    message.symbol = new $util.LongBits(object.symbol.low >>> 0, object.symbol.high >>> 0).toNumber(true);
            return message;
        };

        EosAsset.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.amount = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.symbol = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.symbol = options.longs === String ? "0" : 0;
            }
            if (message.amount != null && message.hasOwnProperty("amount"))
                if (typeof message.amount === "number")
                    object.amount = options.longs === String ? String(message.amount) : message.amount;
                else
                    object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber() : message.amount;
            if (message.symbol != null && message.hasOwnProperty("symbol"))
                if (typeof message.symbol === "number")
                    object.symbol = options.longs === String ? String(message.symbol) : message.symbol;
                else
                    object.symbol = options.longs === String ? $util.Long.prototype.toString.call(message.symbol) : options.longs === Number ? new $util.LongBits(message.symbol.low >>> 0, message.symbol.high >>> 0).toNumber(true) : message.symbol;
            return object;
        };

        EosAsset.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EosAsset;
    })();

    EosTxActionAck.EosPermissionLevel = (function() {

        function EosPermissionLevel(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        EosPermissionLevel.prototype.actor = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        EosPermissionLevel.prototype.permission = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        EosPermissionLevel.create = function create(properties) {
            return new EosPermissionLevel(properties);
        };

        EosPermissionLevel.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.actor != null && Object.hasOwnProperty.call(message, "actor"))
                writer.uint32(8).uint64(message.actor);
            if (message.permission != null && Object.hasOwnProperty.call(message, "permission"))
                writer.uint32(16).uint64(message.permission);
            return writer;
        };

        EosPermissionLevel.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        EosPermissionLevel.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EosTxActionAck.EosPermissionLevel();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.actor = reader.uint64();
                    break;
                case 2:
                    message.permission = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        EosPermissionLevel.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        EosPermissionLevel.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.actor != null && message.hasOwnProperty("actor"))
                if (!$util.isInteger(message.actor) && !(message.actor && $util.isInteger(message.actor.low) && $util.isInteger(message.actor.high)))
                    return "actor: integer|Long expected";
            if (message.permission != null && message.hasOwnProperty("permission"))
                if (!$util.isInteger(message.permission) && !(message.permission && $util.isInteger(message.permission.low) && $util.isInteger(message.permission.high)))
                    return "permission: integer|Long expected";
            return null;
        };

        EosPermissionLevel.fromObject = function fromObject(object) {
            if (object instanceof $root.EosTxActionAck.EosPermissionLevel)
                return object;
            var message = new $root.EosTxActionAck.EosPermissionLevel();
            if (object.actor != null)
                if ($util.Long)
                    (message.actor = $util.Long.fromValue(object.actor)).unsigned = true;
                else if (typeof object.actor === "string")
                    message.actor = parseInt(object.actor, 10);
                else if (typeof object.actor === "number")
                    message.actor = object.actor;
                else if (typeof object.actor === "object")
                    message.actor = new $util.LongBits(object.actor.low >>> 0, object.actor.high >>> 0).toNumber(true);
            if (object.permission != null)
                if ($util.Long)
                    (message.permission = $util.Long.fromValue(object.permission)).unsigned = true;
                else if (typeof object.permission === "string")
                    message.permission = parseInt(object.permission, 10);
                else if (typeof object.permission === "number")
                    message.permission = object.permission;
                else if (typeof object.permission === "object")
                    message.permission = new $util.LongBits(object.permission.low >>> 0, object.permission.high >>> 0).toNumber(true);
            return message;
        };

        EosPermissionLevel.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.actor = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.actor = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.permission = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.permission = options.longs === String ? "0" : 0;
            }
            if (message.actor != null && message.hasOwnProperty("actor"))
                if (typeof message.actor === "number")
                    object.actor = options.longs === String ? String(message.actor) : message.actor;
                else
                    object.actor = options.longs === String ? $util.Long.prototype.toString.call(message.actor) : options.longs === Number ? new $util.LongBits(message.actor.low >>> 0, message.actor.high >>> 0).toNumber(true) : message.actor;
            if (message.permission != null && message.hasOwnProperty("permission"))
                if (typeof message.permission === "number")
                    object.permission = options.longs === String ? String(message.permission) : message.permission;
                else
                    object.permission = options.longs === String ? $util.Long.prototype.toString.call(message.permission) : options.longs === Number ? new $util.LongBits(message.permission.low >>> 0, message.permission.high >>> 0).toNumber(true) : message.permission;
            return object;
        };

        EosPermissionLevel.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EosPermissionLevel;
    })();

    EosTxActionAck.EosAuthorizationKey = (function() {

        function EosAuthorizationKey(properties) {
            this.address_n = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        EosAuthorizationKey.prototype.type = 0;
        EosAuthorizationKey.prototype.key = $util.newBuffer([]);
        EosAuthorizationKey.prototype.address_n = $util.emptyArray;
        EosAuthorizationKey.prototype.weight = 0;

        EosAuthorizationKey.create = function create(properties) {
            return new EosAuthorizationKey(properties);
        };

        EosAuthorizationKey.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(8).uint32(message.type);
            if (message.key != null && Object.hasOwnProperty.call(message, "key"))
                writer.uint32(18).bytes(message.key);
            if (message.address_n != null && message.address_n.length)
                for (var i = 0; i < message.address_n.length; ++i)
                    writer.uint32(24).uint32(message.address_n[i]);
            writer.uint32(32).uint32(message.weight);
            return writer;
        };

        EosAuthorizationKey.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        EosAuthorizationKey.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EosTxActionAck.EosAuthorizationKey();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.type = reader.uint32();
                    break;
                case 2:
                    message.key = reader.bytes();
                    break;
                case 3:
                    if (!(message.address_n && message.address_n.length))
                        message.address_n = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.address_n.push(reader.uint32());
                    } else
                        message.address_n.push(reader.uint32());
                    break;
                case 4:
                    message.weight = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("type"))
                throw $util.ProtocolError("missing required 'type'", { instance: message });
            if (!message.hasOwnProperty("weight"))
                throw $util.ProtocolError("missing required 'weight'", { instance: message });
            return message;
        };

        EosAuthorizationKey.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        EosAuthorizationKey.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isInteger(message.type))
                return "type: integer expected";
            if (message.key != null && message.hasOwnProperty("key"))
                if (!(message.key && typeof message.key.length === "number" || $util.isString(message.key)))
                    return "key: buffer expected";
            if (message.address_n != null && message.hasOwnProperty("address_n")) {
                if (!Array.isArray(message.address_n))
                    return "address_n: array expected";
                for (var i = 0; i < message.address_n.length; ++i)
                    if (!$util.isInteger(message.address_n[i]))
                        return "address_n: integer[] expected";
            }
            if (!$util.isInteger(message.weight))
                return "weight: integer expected";
            return null;
        };

        EosAuthorizationKey.fromObject = function fromObject(object) {
            if (object instanceof $root.EosTxActionAck.EosAuthorizationKey)
                return object;
            var message = new $root.EosTxActionAck.EosAuthorizationKey();
            if (object.type != null)
                message.type = object.type >>> 0;
            if (object.key != null)
                if (typeof object.key === "string")
                    $util.base64.decode(object.key, message.key = $util.newBuffer($util.base64.length(object.key)), 0);
                else if (object.key.length)
                    message.key = object.key;
            if (object.address_n) {
                if (!Array.isArray(object.address_n))
                    throw TypeError(".EosTxActionAck.EosAuthorizationKey.address_n: array expected");
                message.address_n = [];
                for (var i = 0; i < object.address_n.length; ++i)
                    message.address_n[i] = object.address_n[i] >>> 0;
            }
            if (object.weight != null)
                message.weight = object.weight >>> 0;
            return message;
        };

        EosAuthorizationKey.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.address_n = [];
            if (options.defaults) {
                object.type = 0;
                if (options.bytes === String)
                    object.key = "";
                else {
                    object.key = [];
                    if (options.bytes !== Array)
                        object.key = $util.newBuffer(object.key);
                }
                object.weight = 0;
            }
            if (message.type != null && message.hasOwnProperty("type"))
                object.type = message.type;
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = options.bytes === String ? $util.base64.encode(message.key, 0, message.key.length) : options.bytes === Array ? Array.prototype.slice.call(message.key) : message.key;
            if (message.address_n && message.address_n.length) {
                object.address_n = [];
                for (var j = 0; j < message.address_n.length; ++j)
                    object.address_n[j] = message.address_n[j];
            }
            if (message.weight != null && message.hasOwnProperty("weight"))
                object.weight = message.weight;
            return object;
        };

        EosAuthorizationKey.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EosAuthorizationKey;
    })();

    EosTxActionAck.EosAuthorizationAccount = (function() {

        function EosAuthorizationAccount(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        EosAuthorizationAccount.prototype.account = null;
        EosAuthorizationAccount.prototype.weight = 0;

        EosAuthorizationAccount.create = function create(properties) {
            return new EosAuthorizationAccount(properties);
        };

        EosAuthorizationAccount.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.account != null && Object.hasOwnProperty.call(message, "account"))
                $root.EosTxActionAck.EosPermissionLevel.encode(message.account, writer.uint32(10).fork()).ldelim();
            if (message.weight != null && Object.hasOwnProperty.call(message, "weight"))
                writer.uint32(16).uint32(message.weight);
            return writer;
        };

        EosAuthorizationAccount.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        EosAuthorizationAccount.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EosTxActionAck.EosAuthorizationAccount();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.account = $root.EosTxActionAck.EosPermissionLevel.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.weight = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        EosAuthorizationAccount.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        EosAuthorizationAccount.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.account != null && message.hasOwnProperty("account")) {
                var error = $root.EosTxActionAck.EosPermissionLevel.verify(message.account);
                if (error)
                    return "account." + error;
            }
            if (message.weight != null && message.hasOwnProperty("weight"))
                if (!$util.isInteger(message.weight))
                    return "weight: integer expected";
            return null;
        };

        EosAuthorizationAccount.fromObject = function fromObject(object) {
            if (object instanceof $root.EosTxActionAck.EosAuthorizationAccount)
                return object;
            var message = new $root.EosTxActionAck.EosAuthorizationAccount();
            if (object.account != null) {
                if (typeof object.account !== "object")
                    throw TypeError(".EosTxActionAck.EosAuthorizationAccount.account: object expected");
                message.account = $root.EosTxActionAck.EosPermissionLevel.fromObject(object.account);
            }
            if (object.weight != null)
                message.weight = object.weight >>> 0;
            return message;
        };

        EosAuthorizationAccount.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.account = null;
                object.weight = 0;
            }
            if (message.account != null && message.hasOwnProperty("account"))
                object.account = $root.EosTxActionAck.EosPermissionLevel.toObject(message.account, options);
            if (message.weight != null && message.hasOwnProperty("weight"))
                object.weight = message.weight;
            return object;
        };

        EosAuthorizationAccount.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EosAuthorizationAccount;
    })();

    EosTxActionAck.EosAuthorizationWait = (function() {

        function EosAuthorizationWait(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        EosAuthorizationWait.prototype.wait_sec = 0;
        EosAuthorizationWait.prototype.weight = 0;

        EosAuthorizationWait.create = function create(properties) {
            return new EosAuthorizationWait(properties);
        };

        EosAuthorizationWait.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.wait_sec != null && Object.hasOwnProperty.call(message, "wait_sec"))
                writer.uint32(8).uint32(message.wait_sec);
            if (message.weight != null && Object.hasOwnProperty.call(message, "weight"))
                writer.uint32(16).uint32(message.weight);
            return writer;
        };

        EosAuthorizationWait.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        EosAuthorizationWait.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EosTxActionAck.EosAuthorizationWait();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.wait_sec = reader.uint32();
                    break;
                case 2:
                    message.weight = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        EosAuthorizationWait.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        EosAuthorizationWait.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.wait_sec != null && message.hasOwnProperty("wait_sec"))
                if (!$util.isInteger(message.wait_sec))
                    return "wait_sec: integer expected";
            if (message.weight != null && message.hasOwnProperty("weight"))
                if (!$util.isInteger(message.weight))
                    return "weight: integer expected";
            return null;
        };

        EosAuthorizationWait.fromObject = function fromObject(object) {
            if (object instanceof $root.EosTxActionAck.EosAuthorizationWait)
                return object;
            var message = new $root.EosTxActionAck.EosAuthorizationWait();
            if (object.wait_sec != null)
                message.wait_sec = object.wait_sec >>> 0;
            if (object.weight != null)
                message.weight = object.weight >>> 0;
            return message;
        };

        EosAuthorizationWait.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.wait_sec = 0;
                object.weight = 0;
            }
            if (message.wait_sec != null && message.hasOwnProperty("wait_sec"))
                object.wait_sec = message.wait_sec;
            if (message.weight != null && message.hasOwnProperty("weight"))
                object.weight = message.weight;
            return object;
        };

        EosAuthorizationWait.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EosAuthorizationWait;
    })();

    EosTxActionAck.EosAuthorization = (function() {

        function EosAuthorization(properties) {
            this.keys = [];
            this.accounts = [];
            this.waits = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        EosAuthorization.prototype.threshold = 0;
        EosAuthorization.prototype.keys = $util.emptyArray;
        EosAuthorization.prototype.accounts = $util.emptyArray;
        EosAuthorization.prototype.waits = $util.emptyArray;

        EosAuthorization.create = function create(properties) {
            return new EosAuthorization(properties);
        };

        EosAuthorization.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.threshold != null && Object.hasOwnProperty.call(message, "threshold"))
                writer.uint32(8).uint32(message.threshold);
            if (message.keys != null && message.keys.length)
                for (var i = 0; i < message.keys.length; ++i)
                    $root.EosTxActionAck.EosAuthorizationKey.encode(message.keys[i], writer.uint32(18).fork()).ldelim();
            if (message.accounts != null && message.accounts.length)
                for (var i = 0; i < message.accounts.length; ++i)
                    $root.EosTxActionAck.EosAuthorizationAccount.encode(message.accounts[i], writer.uint32(26).fork()).ldelim();
            if (message.waits != null && message.waits.length)
                for (var i = 0; i < message.waits.length; ++i)
                    $root.EosTxActionAck.EosAuthorizationWait.encode(message.waits[i], writer.uint32(34).fork()).ldelim();
            return writer;
        };

        EosAuthorization.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        EosAuthorization.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EosTxActionAck.EosAuthorization();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.threshold = reader.uint32();
                    break;
                case 2:
                    if (!(message.keys && message.keys.length))
                        message.keys = [];
                    message.keys.push($root.EosTxActionAck.EosAuthorizationKey.decode(reader, reader.uint32()));
                    break;
                case 3:
                    if (!(message.accounts && message.accounts.length))
                        message.accounts = [];
                    message.accounts.push($root.EosTxActionAck.EosAuthorizationAccount.decode(reader, reader.uint32()));
                    break;
                case 4:
                    if (!(message.waits && message.waits.length))
                        message.waits = [];
                    message.waits.push($root.EosTxActionAck.EosAuthorizationWait.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        EosAuthorization.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        EosAuthorization.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.threshold != null && message.hasOwnProperty("threshold"))
                if (!$util.isInteger(message.threshold))
                    return "threshold: integer expected";
            if (message.keys != null && message.hasOwnProperty("keys")) {
                if (!Array.isArray(message.keys))
                    return "keys: array expected";
                for (var i = 0; i < message.keys.length; ++i) {
                    var error = $root.EosTxActionAck.EosAuthorizationKey.verify(message.keys[i]);
                    if (error)
                        return "keys." + error;
                }
            }
            if (message.accounts != null && message.hasOwnProperty("accounts")) {
                if (!Array.isArray(message.accounts))
                    return "accounts: array expected";
                for (var i = 0; i < message.accounts.length; ++i) {
                    var error = $root.EosTxActionAck.EosAuthorizationAccount.verify(message.accounts[i]);
                    if (error)
                        return "accounts." + error;
                }
            }
            if (message.waits != null && message.hasOwnProperty("waits")) {
                if (!Array.isArray(message.waits))
                    return "waits: array expected";
                for (var i = 0; i < message.waits.length; ++i) {
                    var error = $root.EosTxActionAck.EosAuthorizationWait.verify(message.waits[i]);
                    if (error)
                        return "waits." + error;
                }
            }
            return null;
        };

        EosAuthorization.fromObject = function fromObject(object) {
            if (object instanceof $root.EosTxActionAck.EosAuthorization)
                return object;
            var message = new $root.EosTxActionAck.EosAuthorization();
            if (object.threshold != null)
                message.threshold = object.threshold >>> 0;
            if (object.keys) {
                if (!Array.isArray(object.keys))
                    throw TypeError(".EosTxActionAck.EosAuthorization.keys: array expected");
                message.keys = [];
                for (var i = 0; i < object.keys.length; ++i) {
                    if (typeof object.keys[i] !== "object")
                        throw TypeError(".EosTxActionAck.EosAuthorization.keys: object expected");
                    message.keys[i] = $root.EosTxActionAck.EosAuthorizationKey.fromObject(object.keys[i]);
                }
            }
            if (object.accounts) {
                if (!Array.isArray(object.accounts))
                    throw TypeError(".EosTxActionAck.EosAuthorization.accounts: array expected");
                message.accounts = [];
                for (var i = 0; i < object.accounts.length; ++i) {
                    if (typeof object.accounts[i] !== "object")
                        throw TypeError(".EosTxActionAck.EosAuthorization.accounts: object expected");
                    message.accounts[i] = $root.EosTxActionAck.EosAuthorizationAccount.fromObject(object.accounts[i]);
                }
            }
            if (object.waits) {
                if (!Array.isArray(object.waits))
                    throw TypeError(".EosTxActionAck.EosAuthorization.waits: array expected");
                message.waits = [];
                for (var i = 0; i < object.waits.length; ++i) {
                    if (typeof object.waits[i] !== "object")
                        throw TypeError(".EosTxActionAck.EosAuthorization.waits: object expected");
                    message.waits[i] = $root.EosTxActionAck.EosAuthorizationWait.fromObject(object.waits[i]);
                }
            }
            return message;
        };

        EosAuthorization.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.keys = [];
                object.accounts = [];
                object.waits = [];
            }
            if (options.defaults)
                object.threshold = 0;
            if (message.threshold != null && message.hasOwnProperty("threshold"))
                object.threshold = message.threshold;
            if (message.keys && message.keys.length) {
                object.keys = [];
                for (var j = 0; j < message.keys.length; ++j)
                    object.keys[j] = $root.EosTxActionAck.EosAuthorizationKey.toObject(message.keys[j], options);
            }
            if (message.accounts && message.accounts.length) {
                object.accounts = [];
                for (var j = 0; j < message.accounts.length; ++j)
                    object.accounts[j] = $root.EosTxActionAck.EosAuthorizationAccount.toObject(message.accounts[j], options);
            }
            if (message.waits && message.waits.length) {
                object.waits = [];
                for (var j = 0; j < message.waits.length; ++j)
                    object.waits[j] = $root.EosTxActionAck.EosAuthorizationWait.toObject(message.waits[j], options);
            }
            return object;
        };

        EosAuthorization.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EosAuthorization;
    })();

    EosTxActionAck.EosActionCommon = (function() {

        function EosActionCommon(properties) {
            this.authorization = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        EosActionCommon.prototype.account = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        EosActionCommon.prototype.name = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        EosActionCommon.prototype.authorization = $util.emptyArray;

        EosActionCommon.create = function create(properties) {
            return new EosActionCommon(properties);
        };

        EosActionCommon.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.account != null && Object.hasOwnProperty.call(message, "account"))
                writer.uint32(8).uint64(message.account);
            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                writer.uint32(16).uint64(message.name);
            if (message.authorization != null && message.authorization.length)
                for (var i = 0; i < message.authorization.length; ++i)
                    $root.EosTxActionAck.EosPermissionLevel.encode(message.authorization[i], writer.uint32(26).fork()).ldelim();
            return writer;
        };

        EosActionCommon.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        EosActionCommon.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EosTxActionAck.EosActionCommon();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.account = reader.uint64();
                    break;
                case 2:
                    message.name = reader.uint64();
                    break;
                case 3:
                    if (!(message.authorization && message.authorization.length))
                        message.authorization = [];
                    message.authorization.push($root.EosTxActionAck.EosPermissionLevel.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        EosActionCommon.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        EosActionCommon.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.account != null && message.hasOwnProperty("account"))
                if (!$util.isInteger(message.account) && !(message.account && $util.isInteger(message.account.low) && $util.isInteger(message.account.high)))
                    return "account: integer|Long expected";
            if (message.name != null && message.hasOwnProperty("name"))
                if (!$util.isInteger(message.name) && !(message.name && $util.isInteger(message.name.low) && $util.isInteger(message.name.high)))
                    return "name: integer|Long expected";
            if (message.authorization != null && message.hasOwnProperty("authorization")) {
                if (!Array.isArray(message.authorization))
                    return "authorization: array expected";
                for (var i = 0; i < message.authorization.length; ++i) {
                    var error = $root.EosTxActionAck.EosPermissionLevel.verify(message.authorization[i]);
                    if (error)
                        return "authorization." + error;
                }
            }
            return null;
        };

        EosActionCommon.fromObject = function fromObject(object) {
            if (object instanceof $root.EosTxActionAck.EosActionCommon)
                return object;
            var message = new $root.EosTxActionAck.EosActionCommon();
            if (object.account != null)
                if ($util.Long)
                    (message.account = $util.Long.fromValue(object.account)).unsigned = true;
                else if (typeof object.account === "string")
                    message.account = parseInt(object.account, 10);
                else if (typeof object.account === "number")
                    message.account = object.account;
                else if (typeof object.account === "object")
                    message.account = new $util.LongBits(object.account.low >>> 0, object.account.high >>> 0).toNumber(true);
            if (object.name != null)
                if ($util.Long)
                    (message.name = $util.Long.fromValue(object.name)).unsigned = true;
                else if (typeof object.name === "string")
                    message.name = parseInt(object.name, 10);
                else if (typeof object.name === "number")
                    message.name = object.name;
                else if (typeof object.name === "object")
                    message.name = new $util.LongBits(object.name.low >>> 0, object.name.high >>> 0).toNumber(true);
            if (object.authorization) {
                if (!Array.isArray(object.authorization))
                    throw TypeError(".EosTxActionAck.EosActionCommon.authorization: array expected");
                message.authorization = [];
                for (var i = 0; i < object.authorization.length; ++i) {
                    if (typeof object.authorization[i] !== "object")
                        throw TypeError(".EosTxActionAck.EosActionCommon.authorization: object expected");
                    message.authorization[i] = $root.EosTxActionAck.EosPermissionLevel.fromObject(object.authorization[i]);
                }
            }
            return message;
        };

        EosActionCommon.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.authorization = [];
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.account = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.account = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.name = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.name = options.longs === String ? "0" : 0;
            }
            if (message.account != null && message.hasOwnProperty("account"))
                if (typeof message.account === "number")
                    object.account = options.longs === String ? String(message.account) : message.account;
                else
                    object.account = options.longs === String ? $util.Long.prototype.toString.call(message.account) : options.longs === Number ? new $util.LongBits(message.account.low >>> 0, message.account.high >>> 0).toNumber(true) : message.account;
            if (message.name != null && message.hasOwnProperty("name"))
                if (typeof message.name === "number")
                    object.name = options.longs === String ? String(message.name) : message.name;
                else
                    object.name = options.longs === String ? $util.Long.prototype.toString.call(message.name) : options.longs === Number ? new $util.LongBits(message.name.low >>> 0, message.name.high >>> 0).toNumber(true) : message.name;
            if (message.authorization && message.authorization.length) {
                object.authorization = [];
                for (var j = 0; j < message.authorization.length; ++j)
                    object.authorization[j] = $root.EosTxActionAck.EosPermissionLevel.toObject(message.authorization[j], options);
            }
            return object;
        };

        EosActionCommon.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EosActionCommon;
    })();

    EosTxActionAck.EosActionTransfer = (function() {

        function EosActionTransfer(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        EosActionTransfer.prototype.sender = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        EosActionTransfer.prototype.receiver = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        EosActionTransfer.prototype.quantity = null;
        EosActionTransfer.prototype.memo = "";

        EosActionTransfer.create = function create(properties) {
            return new EosActionTransfer(properties);
        };

        EosActionTransfer.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.sender != null && Object.hasOwnProperty.call(message, "sender"))
                writer.uint32(8).uint64(message.sender);
            if (message.receiver != null && Object.hasOwnProperty.call(message, "receiver"))
                writer.uint32(16).uint64(message.receiver);
            if (message.quantity != null && Object.hasOwnProperty.call(message, "quantity"))
                $root.EosTxActionAck.EosAsset.encode(message.quantity, writer.uint32(26).fork()).ldelim();
            if (message.memo != null && Object.hasOwnProperty.call(message, "memo"))
                writer.uint32(34).string(message.memo);
            return writer;
        };

        EosActionTransfer.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        EosActionTransfer.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EosTxActionAck.EosActionTransfer();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.sender = reader.uint64();
                    break;
                case 2:
                    message.receiver = reader.uint64();
                    break;
                case 3:
                    message.quantity = $root.EosTxActionAck.EosAsset.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.memo = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        EosActionTransfer.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        EosActionTransfer.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.sender != null && message.hasOwnProperty("sender"))
                if (!$util.isInteger(message.sender) && !(message.sender && $util.isInteger(message.sender.low) && $util.isInteger(message.sender.high)))
                    return "sender: integer|Long expected";
            if (message.receiver != null && message.hasOwnProperty("receiver"))
                if (!$util.isInteger(message.receiver) && !(message.receiver && $util.isInteger(message.receiver.low) && $util.isInteger(message.receiver.high)))
                    return "receiver: integer|Long expected";
            if (message.quantity != null && message.hasOwnProperty("quantity")) {
                var error = $root.EosTxActionAck.EosAsset.verify(message.quantity);
                if (error)
                    return "quantity." + error;
            }
            if (message.memo != null && message.hasOwnProperty("memo"))
                if (!$util.isString(message.memo))
                    return "memo: string expected";
            return null;
        };

        EosActionTransfer.fromObject = function fromObject(object) {
            if (object instanceof $root.EosTxActionAck.EosActionTransfer)
                return object;
            var message = new $root.EosTxActionAck.EosActionTransfer();
            if (object.sender != null)
                if ($util.Long)
                    (message.sender = $util.Long.fromValue(object.sender)).unsigned = true;
                else if (typeof object.sender === "string")
                    message.sender = parseInt(object.sender, 10);
                else if (typeof object.sender === "number")
                    message.sender = object.sender;
                else if (typeof object.sender === "object")
                    message.sender = new $util.LongBits(object.sender.low >>> 0, object.sender.high >>> 0).toNumber(true);
            if (object.receiver != null)
                if ($util.Long)
                    (message.receiver = $util.Long.fromValue(object.receiver)).unsigned = true;
                else if (typeof object.receiver === "string")
                    message.receiver = parseInt(object.receiver, 10);
                else if (typeof object.receiver === "number")
                    message.receiver = object.receiver;
                else if (typeof object.receiver === "object")
                    message.receiver = new $util.LongBits(object.receiver.low >>> 0, object.receiver.high >>> 0).toNumber(true);
            if (object.quantity != null) {
                if (typeof object.quantity !== "object")
                    throw TypeError(".EosTxActionAck.EosActionTransfer.quantity: object expected");
                message.quantity = $root.EosTxActionAck.EosAsset.fromObject(object.quantity);
            }
            if (object.memo != null)
                message.memo = String(object.memo);
            return message;
        };

        EosActionTransfer.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.sender = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.sender = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.receiver = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.receiver = options.longs === String ? "0" : 0;
                object.quantity = null;
                object.memo = "";
            }
            if (message.sender != null && message.hasOwnProperty("sender"))
                if (typeof message.sender === "number")
                    object.sender = options.longs === String ? String(message.sender) : message.sender;
                else
                    object.sender = options.longs === String ? $util.Long.prototype.toString.call(message.sender) : options.longs === Number ? new $util.LongBits(message.sender.low >>> 0, message.sender.high >>> 0).toNumber(true) : message.sender;
            if (message.receiver != null && message.hasOwnProperty("receiver"))
                if (typeof message.receiver === "number")
                    object.receiver = options.longs === String ? String(message.receiver) : message.receiver;
                else
                    object.receiver = options.longs === String ? $util.Long.prototype.toString.call(message.receiver) : options.longs === Number ? new $util.LongBits(message.receiver.low >>> 0, message.receiver.high >>> 0).toNumber(true) : message.receiver;
            if (message.quantity != null && message.hasOwnProperty("quantity"))
                object.quantity = $root.EosTxActionAck.EosAsset.toObject(message.quantity, options);
            if (message.memo != null && message.hasOwnProperty("memo"))
                object.memo = message.memo;
            return object;
        };

        EosActionTransfer.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EosActionTransfer;
    })();

    EosTxActionAck.EosActionDelegate = (function() {

        function EosActionDelegate(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        EosActionDelegate.prototype.sender = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        EosActionDelegate.prototype.receiver = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        EosActionDelegate.prototype.net_quantity = null;
        EosActionDelegate.prototype.cpu_quantity = null;
        EosActionDelegate.prototype.transfer = false;

        EosActionDelegate.create = function create(properties) {
            return new EosActionDelegate(properties);
        };

        EosActionDelegate.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.sender != null && Object.hasOwnProperty.call(message, "sender"))
                writer.uint32(8).uint64(message.sender);
            if (message.receiver != null && Object.hasOwnProperty.call(message, "receiver"))
                writer.uint32(16).uint64(message.receiver);
            if (message.net_quantity != null && Object.hasOwnProperty.call(message, "net_quantity"))
                $root.EosTxActionAck.EosAsset.encode(message.net_quantity, writer.uint32(26).fork()).ldelim();
            if (message.cpu_quantity != null && Object.hasOwnProperty.call(message, "cpu_quantity"))
                $root.EosTxActionAck.EosAsset.encode(message.cpu_quantity, writer.uint32(34).fork()).ldelim();
            if (message.transfer != null && Object.hasOwnProperty.call(message, "transfer"))
                writer.uint32(40).bool(message.transfer);
            return writer;
        };

        EosActionDelegate.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        EosActionDelegate.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EosTxActionAck.EosActionDelegate();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.sender = reader.uint64();
                    break;
                case 2:
                    message.receiver = reader.uint64();
                    break;
                case 3:
                    message.net_quantity = $root.EosTxActionAck.EosAsset.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.cpu_quantity = $root.EosTxActionAck.EosAsset.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.transfer = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        EosActionDelegate.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        EosActionDelegate.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.sender != null && message.hasOwnProperty("sender"))
                if (!$util.isInteger(message.sender) && !(message.sender && $util.isInteger(message.sender.low) && $util.isInteger(message.sender.high)))
                    return "sender: integer|Long expected";
            if (message.receiver != null && message.hasOwnProperty("receiver"))
                if (!$util.isInteger(message.receiver) && !(message.receiver && $util.isInteger(message.receiver.low) && $util.isInteger(message.receiver.high)))
                    return "receiver: integer|Long expected";
            if (message.net_quantity != null && message.hasOwnProperty("net_quantity")) {
                var error = $root.EosTxActionAck.EosAsset.verify(message.net_quantity);
                if (error)
                    return "net_quantity." + error;
            }
            if (message.cpu_quantity != null && message.hasOwnProperty("cpu_quantity")) {
                var error = $root.EosTxActionAck.EosAsset.verify(message.cpu_quantity);
                if (error)
                    return "cpu_quantity." + error;
            }
            if (message.transfer != null && message.hasOwnProperty("transfer"))
                if (typeof message.transfer !== "boolean")
                    return "transfer: boolean expected";
            return null;
        };

        EosActionDelegate.fromObject = function fromObject(object) {
            if (object instanceof $root.EosTxActionAck.EosActionDelegate)
                return object;
            var message = new $root.EosTxActionAck.EosActionDelegate();
            if (object.sender != null)
                if ($util.Long)
                    (message.sender = $util.Long.fromValue(object.sender)).unsigned = true;
                else if (typeof object.sender === "string")
                    message.sender = parseInt(object.sender, 10);
                else if (typeof object.sender === "number")
                    message.sender = object.sender;
                else if (typeof object.sender === "object")
                    message.sender = new $util.LongBits(object.sender.low >>> 0, object.sender.high >>> 0).toNumber(true);
            if (object.receiver != null)
                if ($util.Long)
                    (message.receiver = $util.Long.fromValue(object.receiver)).unsigned = true;
                else if (typeof object.receiver === "string")
                    message.receiver = parseInt(object.receiver, 10);
                else if (typeof object.receiver === "number")
                    message.receiver = object.receiver;
                else if (typeof object.receiver === "object")
                    message.receiver = new $util.LongBits(object.receiver.low >>> 0, object.receiver.high >>> 0).toNumber(true);
            if (object.net_quantity != null) {
                if (typeof object.net_quantity !== "object")
                    throw TypeError(".EosTxActionAck.EosActionDelegate.net_quantity: object expected");
                message.net_quantity = $root.EosTxActionAck.EosAsset.fromObject(object.net_quantity);
            }
            if (object.cpu_quantity != null) {
                if (typeof object.cpu_quantity !== "object")
                    throw TypeError(".EosTxActionAck.EosActionDelegate.cpu_quantity: object expected");
                message.cpu_quantity = $root.EosTxActionAck.EosAsset.fromObject(object.cpu_quantity);
            }
            if (object.transfer != null)
                message.transfer = Boolean(object.transfer);
            return message;
        };

        EosActionDelegate.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.sender = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.sender = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.receiver = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.receiver = options.longs === String ? "0" : 0;
                object.net_quantity = null;
                object.cpu_quantity = null;
                object.transfer = false;
            }
            if (message.sender != null && message.hasOwnProperty("sender"))
                if (typeof message.sender === "number")
                    object.sender = options.longs === String ? String(message.sender) : message.sender;
                else
                    object.sender = options.longs === String ? $util.Long.prototype.toString.call(message.sender) : options.longs === Number ? new $util.LongBits(message.sender.low >>> 0, message.sender.high >>> 0).toNumber(true) : message.sender;
            if (message.receiver != null && message.hasOwnProperty("receiver"))
                if (typeof message.receiver === "number")
                    object.receiver = options.longs === String ? String(message.receiver) : message.receiver;
                else
                    object.receiver = options.longs === String ? $util.Long.prototype.toString.call(message.receiver) : options.longs === Number ? new $util.LongBits(message.receiver.low >>> 0, message.receiver.high >>> 0).toNumber(true) : message.receiver;
            if (message.net_quantity != null && message.hasOwnProperty("net_quantity"))
                object.net_quantity = $root.EosTxActionAck.EosAsset.toObject(message.net_quantity, options);
            if (message.cpu_quantity != null && message.hasOwnProperty("cpu_quantity"))
                object.cpu_quantity = $root.EosTxActionAck.EosAsset.toObject(message.cpu_quantity, options);
            if (message.transfer != null && message.hasOwnProperty("transfer"))
                object.transfer = message.transfer;
            return object;
        };

        EosActionDelegate.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EosActionDelegate;
    })();

    EosTxActionAck.EosActionUndelegate = (function() {

        function EosActionUndelegate(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        EosActionUndelegate.prototype.sender = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        EosActionUndelegate.prototype.receiver = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        EosActionUndelegate.prototype.net_quantity = null;
        EosActionUndelegate.prototype.cpu_quantity = null;

        EosActionUndelegate.create = function create(properties) {
            return new EosActionUndelegate(properties);
        };

        EosActionUndelegate.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.sender != null && Object.hasOwnProperty.call(message, "sender"))
                writer.uint32(8).uint64(message.sender);
            if (message.receiver != null && Object.hasOwnProperty.call(message, "receiver"))
                writer.uint32(16).uint64(message.receiver);
            if (message.net_quantity != null && Object.hasOwnProperty.call(message, "net_quantity"))
                $root.EosTxActionAck.EosAsset.encode(message.net_quantity, writer.uint32(26).fork()).ldelim();
            if (message.cpu_quantity != null && Object.hasOwnProperty.call(message, "cpu_quantity"))
                $root.EosTxActionAck.EosAsset.encode(message.cpu_quantity, writer.uint32(34).fork()).ldelim();
            return writer;
        };

        EosActionUndelegate.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        EosActionUndelegate.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EosTxActionAck.EosActionUndelegate();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.sender = reader.uint64();
                    break;
                case 2:
                    message.receiver = reader.uint64();
                    break;
                case 3:
                    message.net_quantity = $root.EosTxActionAck.EosAsset.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.cpu_quantity = $root.EosTxActionAck.EosAsset.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        EosActionUndelegate.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        EosActionUndelegate.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.sender != null && message.hasOwnProperty("sender"))
                if (!$util.isInteger(message.sender) && !(message.sender && $util.isInteger(message.sender.low) && $util.isInteger(message.sender.high)))
                    return "sender: integer|Long expected";
            if (message.receiver != null && message.hasOwnProperty("receiver"))
                if (!$util.isInteger(message.receiver) && !(message.receiver && $util.isInteger(message.receiver.low) && $util.isInteger(message.receiver.high)))
                    return "receiver: integer|Long expected";
            if (message.net_quantity != null && message.hasOwnProperty("net_quantity")) {
                var error = $root.EosTxActionAck.EosAsset.verify(message.net_quantity);
                if (error)
                    return "net_quantity." + error;
            }
            if (message.cpu_quantity != null && message.hasOwnProperty("cpu_quantity")) {
                var error = $root.EosTxActionAck.EosAsset.verify(message.cpu_quantity);
                if (error)
                    return "cpu_quantity." + error;
            }
            return null;
        };

        EosActionUndelegate.fromObject = function fromObject(object) {
            if (object instanceof $root.EosTxActionAck.EosActionUndelegate)
                return object;
            var message = new $root.EosTxActionAck.EosActionUndelegate();
            if (object.sender != null)
                if ($util.Long)
                    (message.sender = $util.Long.fromValue(object.sender)).unsigned = true;
                else if (typeof object.sender === "string")
                    message.sender = parseInt(object.sender, 10);
                else if (typeof object.sender === "number")
                    message.sender = object.sender;
                else if (typeof object.sender === "object")
                    message.sender = new $util.LongBits(object.sender.low >>> 0, object.sender.high >>> 0).toNumber(true);
            if (object.receiver != null)
                if ($util.Long)
                    (message.receiver = $util.Long.fromValue(object.receiver)).unsigned = true;
                else if (typeof object.receiver === "string")
                    message.receiver = parseInt(object.receiver, 10);
                else if (typeof object.receiver === "number")
                    message.receiver = object.receiver;
                else if (typeof object.receiver === "object")
                    message.receiver = new $util.LongBits(object.receiver.low >>> 0, object.receiver.high >>> 0).toNumber(true);
            if (object.net_quantity != null) {
                if (typeof object.net_quantity !== "object")
                    throw TypeError(".EosTxActionAck.EosActionUndelegate.net_quantity: object expected");
                message.net_quantity = $root.EosTxActionAck.EosAsset.fromObject(object.net_quantity);
            }
            if (object.cpu_quantity != null) {
                if (typeof object.cpu_quantity !== "object")
                    throw TypeError(".EosTxActionAck.EosActionUndelegate.cpu_quantity: object expected");
                message.cpu_quantity = $root.EosTxActionAck.EosAsset.fromObject(object.cpu_quantity);
            }
            return message;
        };

        EosActionUndelegate.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.sender = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.sender = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.receiver = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.receiver = options.longs === String ? "0" : 0;
                object.net_quantity = null;
                object.cpu_quantity = null;
            }
            if (message.sender != null && message.hasOwnProperty("sender"))
                if (typeof message.sender === "number")
                    object.sender = options.longs === String ? String(message.sender) : message.sender;
                else
                    object.sender = options.longs === String ? $util.Long.prototype.toString.call(message.sender) : options.longs === Number ? new $util.LongBits(message.sender.low >>> 0, message.sender.high >>> 0).toNumber(true) : message.sender;
            if (message.receiver != null && message.hasOwnProperty("receiver"))
                if (typeof message.receiver === "number")
                    object.receiver = options.longs === String ? String(message.receiver) : message.receiver;
                else
                    object.receiver = options.longs === String ? $util.Long.prototype.toString.call(message.receiver) : options.longs === Number ? new $util.LongBits(message.receiver.low >>> 0, message.receiver.high >>> 0).toNumber(true) : message.receiver;
            if (message.net_quantity != null && message.hasOwnProperty("net_quantity"))
                object.net_quantity = $root.EosTxActionAck.EosAsset.toObject(message.net_quantity, options);
            if (message.cpu_quantity != null && message.hasOwnProperty("cpu_quantity"))
                object.cpu_quantity = $root.EosTxActionAck.EosAsset.toObject(message.cpu_quantity, options);
            return object;
        };

        EosActionUndelegate.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EosActionUndelegate;
    })();

    EosTxActionAck.EosActionRefund = (function() {

        function EosActionRefund(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        EosActionRefund.prototype.owner = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        EosActionRefund.create = function create(properties) {
            return new EosActionRefund(properties);
        };

        EosActionRefund.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.owner != null && Object.hasOwnProperty.call(message, "owner"))
                writer.uint32(8).uint64(message.owner);
            return writer;
        };

        EosActionRefund.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        EosActionRefund.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EosTxActionAck.EosActionRefund();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.owner = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        EosActionRefund.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        EosActionRefund.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.owner != null && message.hasOwnProperty("owner"))
                if (!$util.isInteger(message.owner) && !(message.owner && $util.isInteger(message.owner.low) && $util.isInteger(message.owner.high)))
                    return "owner: integer|Long expected";
            return null;
        };

        EosActionRefund.fromObject = function fromObject(object) {
            if (object instanceof $root.EosTxActionAck.EosActionRefund)
                return object;
            var message = new $root.EosTxActionAck.EosActionRefund();
            if (object.owner != null)
                if ($util.Long)
                    (message.owner = $util.Long.fromValue(object.owner)).unsigned = true;
                else if (typeof object.owner === "string")
                    message.owner = parseInt(object.owner, 10);
                else if (typeof object.owner === "number")
                    message.owner = object.owner;
                else if (typeof object.owner === "object")
                    message.owner = new $util.LongBits(object.owner.low >>> 0, object.owner.high >>> 0).toNumber(true);
            return message;
        };

        EosActionRefund.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.owner = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.owner = options.longs === String ? "0" : 0;
            if (message.owner != null && message.hasOwnProperty("owner"))
                if (typeof message.owner === "number")
                    object.owner = options.longs === String ? String(message.owner) : message.owner;
                else
                    object.owner = options.longs === String ? $util.Long.prototype.toString.call(message.owner) : options.longs === Number ? new $util.LongBits(message.owner.low >>> 0, message.owner.high >>> 0).toNumber(true) : message.owner;
            return object;
        };

        EosActionRefund.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EosActionRefund;
    })();

    EosTxActionAck.EosActionBuyRam = (function() {

        function EosActionBuyRam(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        EosActionBuyRam.prototype.payer = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        EosActionBuyRam.prototype.receiver = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        EosActionBuyRam.prototype.quantity = null;

        EosActionBuyRam.create = function create(properties) {
            return new EosActionBuyRam(properties);
        };

        EosActionBuyRam.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.payer != null && Object.hasOwnProperty.call(message, "payer"))
                writer.uint32(8).uint64(message.payer);
            if (message.receiver != null && Object.hasOwnProperty.call(message, "receiver"))
                writer.uint32(16).uint64(message.receiver);
            if (message.quantity != null && Object.hasOwnProperty.call(message, "quantity"))
                $root.EosTxActionAck.EosAsset.encode(message.quantity, writer.uint32(26).fork()).ldelim();
            return writer;
        };

        EosActionBuyRam.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        EosActionBuyRam.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EosTxActionAck.EosActionBuyRam();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.payer = reader.uint64();
                    break;
                case 2:
                    message.receiver = reader.uint64();
                    break;
                case 3:
                    message.quantity = $root.EosTxActionAck.EosAsset.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        EosActionBuyRam.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        EosActionBuyRam.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.payer != null && message.hasOwnProperty("payer"))
                if (!$util.isInteger(message.payer) && !(message.payer && $util.isInteger(message.payer.low) && $util.isInteger(message.payer.high)))
                    return "payer: integer|Long expected";
            if (message.receiver != null && message.hasOwnProperty("receiver"))
                if (!$util.isInteger(message.receiver) && !(message.receiver && $util.isInteger(message.receiver.low) && $util.isInteger(message.receiver.high)))
                    return "receiver: integer|Long expected";
            if (message.quantity != null && message.hasOwnProperty("quantity")) {
                var error = $root.EosTxActionAck.EosAsset.verify(message.quantity);
                if (error)
                    return "quantity." + error;
            }
            return null;
        };

        EosActionBuyRam.fromObject = function fromObject(object) {
            if (object instanceof $root.EosTxActionAck.EosActionBuyRam)
                return object;
            var message = new $root.EosTxActionAck.EosActionBuyRam();
            if (object.payer != null)
                if ($util.Long)
                    (message.payer = $util.Long.fromValue(object.payer)).unsigned = true;
                else if (typeof object.payer === "string")
                    message.payer = parseInt(object.payer, 10);
                else if (typeof object.payer === "number")
                    message.payer = object.payer;
                else if (typeof object.payer === "object")
                    message.payer = new $util.LongBits(object.payer.low >>> 0, object.payer.high >>> 0).toNumber(true);
            if (object.receiver != null)
                if ($util.Long)
                    (message.receiver = $util.Long.fromValue(object.receiver)).unsigned = true;
                else if (typeof object.receiver === "string")
                    message.receiver = parseInt(object.receiver, 10);
                else if (typeof object.receiver === "number")
                    message.receiver = object.receiver;
                else if (typeof object.receiver === "object")
                    message.receiver = new $util.LongBits(object.receiver.low >>> 0, object.receiver.high >>> 0).toNumber(true);
            if (object.quantity != null) {
                if (typeof object.quantity !== "object")
                    throw TypeError(".EosTxActionAck.EosActionBuyRam.quantity: object expected");
                message.quantity = $root.EosTxActionAck.EosAsset.fromObject(object.quantity);
            }
            return message;
        };

        EosActionBuyRam.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.payer = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.payer = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.receiver = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.receiver = options.longs === String ? "0" : 0;
                object.quantity = null;
            }
            if (message.payer != null && message.hasOwnProperty("payer"))
                if (typeof message.payer === "number")
                    object.payer = options.longs === String ? String(message.payer) : message.payer;
                else
                    object.payer = options.longs === String ? $util.Long.prototype.toString.call(message.payer) : options.longs === Number ? new $util.LongBits(message.payer.low >>> 0, message.payer.high >>> 0).toNumber(true) : message.payer;
            if (message.receiver != null && message.hasOwnProperty("receiver"))
                if (typeof message.receiver === "number")
                    object.receiver = options.longs === String ? String(message.receiver) : message.receiver;
                else
                    object.receiver = options.longs === String ? $util.Long.prototype.toString.call(message.receiver) : options.longs === Number ? new $util.LongBits(message.receiver.low >>> 0, message.receiver.high >>> 0).toNumber(true) : message.receiver;
            if (message.quantity != null && message.hasOwnProperty("quantity"))
                object.quantity = $root.EosTxActionAck.EosAsset.toObject(message.quantity, options);
            return object;
        };

        EosActionBuyRam.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EosActionBuyRam;
    })();

    EosTxActionAck.EosActionBuyRamBytes = (function() {

        function EosActionBuyRamBytes(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        EosActionBuyRamBytes.prototype.payer = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        EosActionBuyRamBytes.prototype.receiver = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        EosActionBuyRamBytes.prototype.bytes = 0;

        EosActionBuyRamBytes.create = function create(properties) {
            return new EosActionBuyRamBytes(properties);
        };

        EosActionBuyRamBytes.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.payer != null && Object.hasOwnProperty.call(message, "payer"))
                writer.uint32(8).uint64(message.payer);
            if (message.receiver != null && Object.hasOwnProperty.call(message, "receiver"))
                writer.uint32(16).uint64(message.receiver);
            if (message.bytes != null && Object.hasOwnProperty.call(message, "bytes"))
                writer.uint32(24).uint32(message.bytes);
            return writer;
        };

        EosActionBuyRamBytes.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        EosActionBuyRamBytes.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EosTxActionAck.EosActionBuyRamBytes();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.payer = reader.uint64();
                    break;
                case 2:
                    message.receiver = reader.uint64();
                    break;
                case 3:
                    message.bytes = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        EosActionBuyRamBytes.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        EosActionBuyRamBytes.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.payer != null && message.hasOwnProperty("payer"))
                if (!$util.isInteger(message.payer) && !(message.payer && $util.isInteger(message.payer.low) && $util.isInteger(message.payer.high)))
                    return "payer: integer|Long expected";
            if (message.receiver != null && message.hasOwnProperty("receiver"))
                if (!$util.isInteger(message.receiver) && !(message.receiver && $util.isInteger(message.receiver.low) && $util.isInteger(message.receiver.high)))
                    return "receiver: integer|Long expected";
            if (message.bytes != null && message.hasOwnProperty("bytes"))
                if (!$util.isInteger(message.bytes))
                    return "bytes: integer expected";
            return null;
        };

        EosActionBuyRamBytes.fromObject = function fromObject(object) {
            if (object instanceof $root.EosTxActionAck.EosActionBuyRamBytes)
                return object;
            var message = new $root.EosTxActionAck.EosActionBuyRamBytes();
            if (object.payer != null)
                if ($util.Long)
                    (message.payer = $util.Long.fromValue(object.payer)).unsigned = true;
                else if (typeof object.payer === "string")
                    message.payer = parseInt(object.payer, 10);
                else if (typeof object.payer === "number")
                    message.payer = object.payer;
                else if (typeof object.payer === "object")
                    message.payer = new $util.LongBits(object.payer.low >>> 0, object.payer.high >>> 0).toNumber(true);
            if (object.receiver != null)
                if ($util.Long)
                    (message.receiver = $util.Long.fromValue(object.receiver)).unsigned = true;
                else if (typeof object.receiver === "string")
                    message.receiver = parseInt(object.receiver, 10);
                else if (typeof object.receiver === "number")
                    message.receiver = object.receiver;
                else if (typeof object.receiver === "object")
                    message.receiver = new $util.LongBits(object.receiver.low >>> 0, object.receiver.high >>> 0).toNumber(true);
            if (object.bytes != null)
                message.bytes = object.bytes >>> 0;
            return message;
        };

        EosActionBuyRamBytes.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.payer = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.payer = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.receiver = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.receiver = options.longs === String ? "0" : 0;
                object.bytes = 0;
            }
            if (message.payer != null && message.hasOwnProperty("payer"))
                if (typeof message.payer === "number")
                    object.payer = options.longs === String ? String(message.payer) : message.payer;
                else
                    object.payer = options.longs === String ? $util.Long.prototype.toString.call(message.payer) : options.longs === Number ? new $util.LongBits(message.payer.low >>> 0, message.payer.high >>> 0).toNumber(true) : message.payer;
            if (message.receiver != null && message.hasOwnProperty("receiver"))
                if (typeof message.receiver === "number")
                    object.receiver = options.longs === String ? String(message.receiver) : message.receiver;
                else
                    object.receiver = options.longs === String ? $util.Long.prototype.toString.call(message.receiver) : options.longs === Number ? new $util.LongBits(message.receiver.low >>> 0, message.receiver.high >>> 0).toNumber(true) : message.receiver;
            if (message.bytes != null && message.hasOwnProperty("bytes"))
                object.bytes = message.bytes;
            return object;
        };

        EosActionBuyRamBytes.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EosActionBuyRamBytes;
    })();

    EosTxActionAck.EosActionSellRam = (function() {

        function EosActionSellRam(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        EosActionSellRam.prototype.account = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        EosActionSellRam.prototype.bytes = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        EosActionSellRam.create = function create(properties) {
            return new EosActionSellRam(properties);
        };

        EosActionSellRam.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.account != null && Object.hasOwnProperty.call(message, "account"))
                writer.uint32(8).uint64(message.account);
            if (message.bytes != null && Object.hasOwnProperty.call(message, "bytes"))
                writer.uint32(16).uint64(message.bytes);
            return writer;
        };

        EosActionSellRam.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        EosActionSellRam.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EosTxActionAck.EosActionSellRam();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.account = reader.uint64();
                    break;
                case 2:
                    message.bytes = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        EosActionSellRam.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        EosActionSellRam.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.account != null && message.hasOwnProperty("account"))
                if (!$util.isInteger(message.account) && !(message.account && $util.isInteger(message.account.low) && $util.isInteger(message.account.high)))
                    return "account: integer|Long expected";
            if (message.bytes != null && message.hasOwnProperty("bytes"))
                if (!$util.isInteger(message.bytes) && !(message.bytes && $util.isInteger(message.bytes.low) && $util.isInteger(message.bytes.high)))
                    return "bytes: integer|Long expected";
            return null;
        };

        EosActionSellRam.fromObject = function fromObject(object) {
            if (object instanceof $root.EosTxActionAck.EosActionSellRam)
                return object;
            var message = new $root.EosTxActionAck.EosActionSellRam();
            if (object.account != null)
                if ($util.Long)
                    (message.account = $util.Long.fromValue(object.account)).unsigned = true;
                else if (typeof object.account === "string")
                    message.account = parseInt(object.account, 10);
                else if (typeof object.account === "number")
                    message.account = object.account;
                else if (typeof object.account === "object")
                    message.account = new $util.LongBits(object.account.low >>> 0, object.account.high >>> 0).toNumber(true);
            if (object.bytes != null)
                if ($util.Long)
                    (message.bytes = $util.Long.fromValue(object.bytes)).unsigned = true;
                else if (typeof object.bytes === "string")
                    message.bytes = parseInt(object.bytes, 10);
                else if (typeof object.bytes === "number")
                    message.bytes = object.bytes;
                else if (typeof object.bytes === "object")
                    message.bytes = new $util.LongBits(object.bytes.low >>> 0, object.bytes.high >>> 0).toNumber(true);
            return message;
        };

        EosActionSellRam.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.account = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.account = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.bytes = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.bytes = options.longs === String ? "0" : 0;
            }
            if (message.account != null && message.hasOwnProperty("account"))
                if (typeof message.account === "number")
                    object.account = options.longs === String ? String(message.account) : message.account;
                else
                    object.account = options.longs === String ? $util.Long.prototype.toString.call(message.account) : options.longs === Number ? new $util.LongBits(message.account.low >>> 0, message.account.high >>> 0).toNumber(true) : message.account;
            if (message.bytes != null && message.hasOwnProperty("bytes"))
                if (typeof message.bytes === "number")
                    object.bytes = options.longs === String ? String(message.bytes) : message.bytes;
                else
                    object.bytes = options.longs === String ? $util.Long.prototype.toString.call(message.bytes) : options.longs === Number ? new $util.LongBits(message.bytes.low >>> 0, message.bytes.high >>> 0).toNumber(true) : message.bytes;
            return object;
        };

        EosActionSellRam.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EosActionSellRam;
    })();

    EosTxActionAck.EosActionVoteProducer = (function() {

        function EosActionVoteProducer(properties) {
            this.producers = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        EosActionVoteProducer.prototype.voter = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        EosActionVoteProducer.prototype.proxy = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        EosActionVoteProducer.prototype.producers = $util.emptyArray;

        EosActionVoteProducer.create = function create(properties) {
            return new EosActionVoteProducer(properties);
        };

        EosActionVoteProducer.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.voter != null && Object.hasOwnProperty.call(message, "voter"))
                writer.uint32(8).uint64(message.voter);
            if (message.proxy != null && Object.hasOwnProperty.call(message, "proxy"))
                writer.uint32(16).uint64(message.proxy);
            if (message.producers != null && message.producers.length)
                for (var i = 0; i < message.producers.length; ++i)
                    writer.uint32(24).uint64(message.producers[i]);
            return writer;
        };

        EosActionVoteProducer.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        EosActionVoteProducer.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EosTxActionAck.EosActionVoteProducer();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.voter = reader.uint64();
                    break;
                case 2:
                    message.proxy = reader.uint64();
                    break;
                case 3:
                    if (!(message.producers && message.producers.length))
                        message.producers = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.producers.push(reader.uint64());
                    } else
                        message.producers.push(reader.uint64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        EosActionVoteProducer.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        EosActionVoteProducer.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.voter != null && message.hasOwnProperty("voter"))
                if (!$util.isInteger(message.voter) && !(message.voter && $util.isInteger(message.voter.low) && $util.isInteger(message.voter.high)))
                    return "voter: integer|Long expected";
            if (message.proxy != null && message.hasOwnProperty("proxy"))
                if (!$util.isInteger(message.proxy) && !(message.proxy && $util.isInteger(message.proxy.low) && $util.isInteger(message.proxy.high)))
                    return "proxy: integer|Long expected";
            if (message.producers != null && message.hasOwnProperty("producers")) {
                if (!Array.isArray(message.producers))
                    return "producers: array expected";
                for (var i = 0; i < message.producers.length; ++i)
                    if (!$util.isInteger(message.producers[i]) && !(message.producers[i] && $util.isInteger(message.producers[i].low) && $util.isInteger(message.producers[i].high)))
                        return "producers: integer|Long[] expected";
            }
            return null;
        };

        EosActionVoteProducer.fromObject = function fromObject(object) {
            if (object instanceof $root.EosTxActionAck.EosActionVoteProducer)
                return object;
            var message = new $root.EosTxActionAck.EosActionVoteProducer();
            if (object.voter != null)
                if ($util.Long)
                    (message.voter = $util.Long.fromValue(object.voter)).unsigned = true;
                else if (typeof object.voter === "string")
                    message.voter = parseInt(object.voter, 10);
                else if (typeof object.voter === "number")
                    message.voter = object.voter;
                else if (typeof object.voter === "object")
                    message.voter = new $util.LongBits(object.voter.low >>> 0, object.voter.high >>> 0).toNumber(true);
            if (object.proxy != null)
                if ($util.Long)
                    (message.proxy = $util.Long.fromValue(object.proxy)).unsigned = true;
                else if (typeof object.proxy === "string")
                    message.proxy = parseInt(object.proxy, 10);
                else if (typeof object.proxy === "number")
                    message.proxy = object.proxy;
                else if (typeof object.proxy === "object")
                    message.proxy = new $util.LongBits(object.proxy.low >>> 0, object.proxy.high >>> 0).toNumber(true);
            if (object.producers) {
                if (!Array.isArray(object.producers))
                    throw TypeError(".EosTxActionAck.EosActionVoteProducer.producers: array expected");
                message.producers = [];
                for (var i = 0; i < object.producers.length; ++i)
                    if ($util.Long)
                        (message.producers[i] = $util.Long.fromValue(object.producers[i])).unsigned = true;
                    else if (typeof object.producers[i] === "string")
                        message.producers[i] = parseInt(object.producers[i], 10);
                    else if (typeof object.producers[i] === "number")
                        message.producers[i] = object.producers[i];
                    else if (typeof object.producers[i] === "object")
                        message.producers[i] = new $util.LongBits(object.producers[i].low >>> 0, object.producers[i].high >>> 0).toNumber(true);
            }
            return message;
        };

        EosActionVoteProducer.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.producers = [];
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.voter = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.voter = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.proxy = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.proxy = options.longs === String ? "0" : 0;
            }
            if (message.voter != null && message.hasOwnProperty("voter"))
                if (typeof message.voter === "number")
                    object.voter = options.longs === String ? String(message.voter) : message.voter;
                else
                    object.voter = options.longs === String ? $util.Long.prototype.toString.call(message.voter) : options.longs === Number ? new $util.LongBits(message.voter.low >>> 0, message.voter.high >>> 0).toNumber(true) : message.voter;
            if (message.proxy != null && message.hasOwnProperty("proxy"))
                if (typeof message.proxy === "number")
                    object.proxy = options.longs === String ? String(message.proxy) : message.proxy;
                else
                    object.proxy = options.longs === String ? $util.Long.prototype.toString.call(message.proxy) : options.longs === Number ? new $util.LongBits(message.proxy.low >>> 0, message.proxy.high >>> 0).toNumber(true) : message.proxy;
            if (message.producers && message.producers.length) {
                object.producers = [];
                for (var j = 0; j < message.producers.length; ++j)
                    if (typeof message.producers[j] === "number")
                        object.producers[j] = options.longs === String ? String(message.producers[j]) : message.producers[j];
                    else
                        object.producers[j] = options.longs === String ? $util.Long.prototype.toString.call(message.producers[j]) : options.longs === Number ? new $util.LongBits(message.producers[j].low >>> 0, message.producers[j].high >>> 0).toNumber(true) : message.producers[j];
            }
            return object;
        };

        EosActionVoteProducer.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EosActionVoteProducer;
    })();

    EosTxActionAck.EosActionUpdateAuth = (function() {

        function EosActionUpdateAuth(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        EosActionUpdateAuth.prototype.account = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        EosActionUpdateAuth.prototype.permission = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        EosActionUpdateAuth.prototype.parent = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        EosActionUpdateAuth.prototype.auth = null;

        EosActionUpdateAuth.create = function create(properties) {
            return new EosActionUpdateAuth(properties);
        };

        EosActionUpdateAuth.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.account != null && Object.hasOwnProperty.call(message, "account"))
                writer.uint32(8).uint64(message.account);
            if (message.permission != null && Object.hasOwnProperty.call(message, "permission"))
                writer.uint32(16).uint64(message.permission);
            if (message.parent != null && Object.hasOwnProperty.call(message, "parent"))
                writer.uint32(24).uint64(message.parent);
            if (message.auth != null && Object.hasOwnProperty.call(message, "auth"))
                $root.EosTxActionAck.EosAuthorization.encode(message.auth, writer.uint32(34).fork()).ldelim();
            return writer;
        };

        EosActionUpdateAuth.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        EosActionUpdateAuth.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EosTxActionAck.EosActionUpdateAuth();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.account = reader.uint64();
                    break;
                case 2:
                    message.permission = reader.uint64();
                    break;
                case 3:
                    message.parent = reader.uint64();
                    break;
                case 4:
                    message.auth = $root.EosTxActionAck.EosAuthorization.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        EosActionUpdateAuth.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        EosActionUpdateAuth.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.account != null && message.hasOwnProperty("account"))
                if (!$util.isInteger(message.account) && !(message.account && $util.isInteger(message.account.low) && $util.isInteger(message.account.high)))
                    return "account: integer|Long expected";
            if (message.permission != null && message.hasOwnProperty("permission"))
                if (!$util.isInteger(message.permission) && !(message.permission && $util.isInteger(message.permission.low) && $util.isInteger(message.permission.high)))
                    return "permission: integer|Long expected";
            if (message.parent != null && message.hasOwnProperty("parent"))
                if (!$util.isInteger(message.parent) && !(message.parent && $util.isInteger(message.parent.low) && $util.isInteger(message.parent.high)))
                    return "parent: integer|Long expected";
            if (message.auth != null && message.hasOwnProperty("auth")) {
                var error = $root.EosTxActionAck.EosAuthorization.verify(message.auth);
                if (error)
                    return "auth." + error;
            }
            return null;
        };

        EosActionUpdateAuth.fromObject = function fromObject(object) {
            if (object instanceof $root.EosTxActionAck.EosActionUpdateAuth)
                return object;
            var message = new $root.EosTxActionAck.EosActionUpdateAuth();
            if (object.account != null)
                if ($util.Long)
                    (message.account = $util.Long.fromValue(object.account)).unsigned = true;
                else if (typeof object.account === "string")
                    message.account = parseInt(object.account, 10);
                else if (typeof object.account === "number")
                    message.account = object.account;
                else if (typeof object.account === "object")
                    message.account = new $util.LongBits(object.account.low >>> 0, object.account.high >>> 0).toNumber(true);
            if (object.permission != null)
                if ($util.Long)
                    (message.permission = $util.Long.fromValue(object.permission)).unsigned = true;
                else if (typeof object.permission === "string")
                    message.permission = parseInt(object.permission, 10);
                else if (typeof object.permission === "number")
                    message.permission = object.permission;
                else if (typeof object.permission === "object")
                    message.permission = new $util.LongBits(object.permission.low >>> 0, object.permission.high >>> 0).toNumber(true);
            if (object.parent != null)
                if ($util.Long)
                    (message.parent = $util.Long.fromValue(object.parent)).unsigned = true;
                else if (typeof object.parent === "string")
                    message.parent = parseInt(object.parent, 10);
                else if (typeof object.parent === "number")
                    message.parent = object.parent;
                else if (typeof object.parent === "object")
                    message.parent = new $util.LongBits(object.parent.low >>> 0, object.parent.high >>> 0).toNumber(true);
            if (object.auth != null) {
                if (typeof object.auth !== "object")
                    throw TypeError(".EosTxActionAck.EosActionUpdateAuth.auth: object expected");
                message.auth = $root.EosTxActionAck.EosAuthorization.fromObject(object.auth);
            }
            return message;
        };

        EosActionUpdateAuth.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.account = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.account = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.permission = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.permission = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.parent = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.parent = options.longs === String ? "0" : 0;
                object.auth = null;
            }
            if (message.account != null && message.hasOwnProperty("account"))
                if (typeof message.account === "number")
                    object.account = options.longs === String ? String(message.account) : message.account;
                else
                    object.account = options.longs === String ? $util.Long.prototype.toString.call(message.account) : options.longs === Number ? new $util.LongBits(message.account.low >>> 0, message.account.high >>> 0).toNumber(true) : message.account;
            if (message.permission != null && message.hasOwnProperty("permission"))
                if (typeof message.permission === "number")
                    object.permission = options.longs === String ? String(message.permission) : message.permission;
                else
                    object.permission = options.longs === String ? $util.Long.prototype.toString.call(message.permission) : options.longs === Number ? new $util.LongBits(message.permission.low >>> 0, message.permission.high >>> 0).toNumber(true) : message.permission;
            if (message.parent != null && message.hasOwnProperty("parent"))
                if (typeof message.parent === "number")
                    object.parent = options.longs === String ? String(message.parent) : message.parent;
                else
                    object.parent = options.longs === String ? $util.Long.prototype.toString.call(message.parent) : options.longs === Number ? new $util.LongBits(message.parent.low >>> 0, message.parent.high >>> 0).toNumber(true) : message.parent;
            if (message.auth != null && message.hasOwnProperty("auth"))
                object.auth = $root.EosTxActionAck.EosAuthorization.toObject(message.auth, options);
            return object;
        };

        EosActionUpdateAuth.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EosActionUpdateAuth;
    })();

    EosTxActionAck.EosActionDeleteAuth = (function() {

        function EosActionDeleteAuth(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        EosActionDeleteAuth.prototype.account = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        EosActionDeleteAuth.prototype.permission = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        EosActionDeleteAuth.create = function create(properties) {
            return new EosActionDeleteAuth(properties);
        };

        EosActionDeleteAuth.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.account != null && Object.hasOwnProperty.call(message, "account"))
                writer.uint32(8).uint64(message.account);
            if (message.permission != null && Object.hasOwnProperty.call(message, "permission"))
                writer.uint32(16).uint64(message.permission);
            return writer;
        };

        EosActionDeleteAuth.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        EosActionDeleteAuth.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EosTxActionAck.EosActionDeleteAuth();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.account = reader.uint64();
                    break;
                case 2:
                    message.permission = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        EosActionDeleteAuth.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        EosActionDeleteAuth.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.account != null && message.hasOwnProperty("account"))
                if (!$util.isInteger(message.account) && !(message.account && $util.isInteger(message.account.low) && $util.isInteger(message.account.high)))
                    return "account: integer|Long expected";
            if (message.permission != null && message.hasOwnProperty("permission"))
                if (!$util.isInteger(message.permission) && !(message.permission && $util.isInteger(message.permission.low) && $util.isInteger(message.permission.high)))
                    return "permission: integer|Long expected";
            return null;
        };

        EosActionDeleteAuth.fromObject = function fromObject(object) {
            if (object instanceof $root.EosTxActionAck.EosActionDeleteAuth)
                return object;
            var message = new $root.EosTxActionAck.EosActionDeleteAuth();
            if (object.account != null)
                if ($util.Long)
                    (message.account = $util.Long.fromValue(object.account)).unsigned = true;
                else if (typeof object.account === "string")
                    message.account = parseInt(object.account, 10);
                else if (typeof object.account === "number")
                    message.account = object.account;
                else if (typeof object.account === "object")
                    message.account = new $util.LongBits(object.account.low >>> 0, object.account.high >>> 0).toNumber(true);
            if (object.permission != null)
                if ($util.Long)
                    (message.permission = $util.Long.fromValue(object.permission)).unsigned = true;
                else if (typeof object.permission === "string")
                    message.permission = parseInt(object.permission, 10);
                else if (typeof object.permission === "number")
                    message.permission = object.permission;
                else if (typeof object.permission === "object")
                    message.permission = new $util.LongBits(object.permission.low >>> 0, object.permission.high >>> 0).toNumber(true);
            return message;
        };

        EosActionDeleteAuth.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.account = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.account = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.permission = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.permission = options.longs === String ? "0" : 0;
            }
            if (message.account != null && message.hasOwnProperty("account"))
                if (typeof message.account === "number")
                    object.account = options.longs === String ? String(message.account) : message.account;
                else
                    object.account = options.longs === String ? $util.Long.prototype.toString.call(message.account) : options.longs === Number ? new $util.LongBits(message.account.low >>> 0, message.account.high >>> 0).toNumber(true) : message.account;
            if (message.permission != null && message.hasOwnProperty("permission"))
                if (typeof message.permission === "number")
                    object.permission = options.longs === String ? String(message.permission) : message.permission;
                else
                    object.permission = options.longs === String ? $util.Long.prototype.toString.call(message.permission) : options.longs === Number ? new $util.LongBits(message.permission.low >>> 0, message.permission.high >>> 0).toNumber(true) : message.permission;
            return object;
        };

        EosActionDeleteAuth.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EosActionDeleteAuth;
    })();

    EosTxActionAck.EosActionLinkAuth = (function() {

        function EosActionLinkAuth(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        EosActionLinkAuth.prototype.account = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        EosActionLinkAuth.prototype.code = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        EosActionLinkAuth.prototype.type = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        EosActionLinkAuth.prototype.requirement = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        EosActionLinkAuth.create = function create(properties) {
            return new EosActionLinkAuth(properties);
        };

        EosActionLinkAuth.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.account != null && Object.hasOwnProperty.call(message, "account"))
                writer.uint32(8).uint64(message.account);
            if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                writer.uint32(16).uint64(message.code);
            if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                writer.uint32(24).uint64(message.type);
            if (message.requirement != null && Object.hasOwnProperty.call(message, "requirement"))
                writer.uint32(32).uint64(message.requirement);
            return writer;
        };

        EosActionLinkAuth.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        EosActionLinkAuth.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EosTxActionAck.EosActionLinkAuth();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.account = reader.uint64();
                    break;
                case 2:
                    message.code = reader.uint64();
                    break;
                case 3:
                    message.type = reader.uint64();
                    break;
                case 4:
                    message.requirement = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        EosActionLinkAuth.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        EosActionLinkAuth.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.account != null && message.hasOwnProperty("account"))
                if (!$util.isInteger(message.account) && !(message.account && $util.isInteger(message.account.low) && $util.isInteger(message.account.high)))
                    return "account: integer|Long expected";
            if (message.code != null && message.hasOwnProperty("code"))
                if (!$util.isInteger(message.code) && !(message.code && $util.isInteger(message.code.low) && $util.isInteger(message.code.high)))
                    return "code: integer|Long expected";
            if (message.type != null && message.hasOwnProperty("type"))
                if (!$util.isInteger(message.type) && !(message.type && $util.isInteger(message.type.low) && $util.isInteger(message.type.high)))
                    return "type: integer|Long expected";
            if (message.requirement != null && message.hasOwnProperty("requirement"))
                if (!$util.isInteger(message.requirement) && !(message.requirement && $util.isInteger(message.requirement.low) && $util.isInteger(message.requirement.high)))
                    return "requirement: integer|Long expected";
            return null;
        };

        EosActionLinkAuth.fromObject = function fromObject(object) {
            if (object instanceof $root.EosTxActionAck.EosActionLinkAuth)
                return object;
            var message = new $root.EosTxActionAck.EosActionLinkAuth();
            if (object.account != null)
                if ($util.Long)
                    (message.account = $util.Long.fromValue(object.account)).unsigned = true;
                else if (typeof object.account === "string")
                    message.account = parseInt(object.account, 10);
                else if (typeof object.account === "number")
                    message.account = object.account;
                else if (typeof object.account === "object")
                    message.account = new $util.LongBits(object.account.low >>> 0, object.account.high >>> 0).toNumber(true);
            if (object.code != null)
                if ($util.Long)
                    (message.code = $util.Long.fromValue(object.code)).unsigned = true;
                else if (typeof object.code === "string")
                    message.code = parseInt(object.code, 10);
                else if (typeof object.code === "number")
                    message.code = object.code;
                else if (typeof object.code === "object")
                    message.code = new $util.LongBits(object.code.low >>> 0, object.code.high >>> 0).toNumber(true);
            if (object.type != null)
                if ($util.Long)
                    (message.type = $util.Long.fromValue(object.type)).unsigned = true;
                else if (typeof object.type === "string")
                    message.type = parseInt(object.type, 10);
                else if (typeof object.type === "number")
                    message.type = object.type;
                else if (typeof object.type === "object")
                    message.type = new $util.LongBits(object.type.low >>> 0, object.type.high >>> 0).toNumber(true);
            if (object.requirement != null)
                if ($util.Long)
                    (message.requirement = $util.Long.fromValue(object.requirement)).unsigned = true;
                else if (typeof object.requirement === "string")
                    message.requirement = parseInt(object.requirement, 10);
                else if (typeof object.requirement === "number")
                    message.requirement = object.requirement;
                else if (typeof object.requirement === "object")
                    message.requirement = new $util.LongBits(object.requirement.low >>> 0, object.requirement.high >>> 0).toNumber(true);
            return message;
        };

        EosActionLinkAuth.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.account = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.account = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.code = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.code = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.type = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.type = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.requirement = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.requirement = options.longs === String ? "0" : 0;
            }
            if (message.account != null && message.hasOwnProperty("account"))
                if (typeof message.account === "number")
                    object.account = options.longs === String ? String(message.account) : message.account;
                else
                    object.account = options.longs === String ? $util.Long.prototype.toString.call(message.account) : options.longs === Number ? new $util.LongBits(message.account.low >>> 0, message.account.high >>> 0).toNumber(true) : message.account;
            if (message.code != null && message.hasOwnProperty("code"))
                if (typeof message.code === "number")
                    object.code = options.longs === String ? String(message.code) : message.code;
                else
                    object.code = options.longs === String ? $util.Long.prototype.toString.call(message.code) : options.longs === Number ? new $util.LongBits(message.code.low >>> 0, message.code.high >>> 0).toNumber(true) : message.code;
            if (message.type != null && message.hasOwnProperty("type"))
                if (typeof message.type === "number")
                    object.type = options.longs === String ? String(message.type) : message.type;
                else
                    object.type = options.longs === String ? $util.Long.prototype.toString.call(message.type) : options.longs === Number ? new $util.LongBits(message.type.low >>> 0, message.type.high >>> 0).toNumber(true) : message.type;
            if (message.requirement != null && message.hasOwnProperty("requirement"))
                if (typeof message.requirement === "number")
                    object.requirement = options.longs === String ? String(message.requirement) : message.requirement;
                else
                    object.requirement = options.longs === String ? $util.Long.prototype.toString.call(message.requirement) : options.longs === Number ? new $util.LongBits(message.requirement.low >>> 0, message.requirement.high >>> 0).toNumber(true) : message.requirement;
            return object;
        };

        EosActionLinkAuth.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EosActionLinkAuth;
    })();

    EosTxActionAck.EosActionUnlinkAuth = (function() {

        function EosActionUnlinkAuth(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        EosActionUnlinkAuth.prototype.account = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        EosActionUnlinkAuth.prototype.code = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        EosActionUnlinkAuth.prototype.type = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        EosActionUnlinkAuth.create = function create(properties) {
            return new EosActionUnlinkAuth(properties);
        };

        EosActionUnlinkAuth.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.account != null && Object.hasOwnProperty.call(message, "account"))
                writer.uint32(8).uint64(message.account);
            if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                writer.uint32(16).uint64(message.code);
            if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                writer.uint32(24).uint64(message.type);
            return writer;
        };

        EosActionUnlinkAuth.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        EosActionUnlinkAuth.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EosTxActionAck.EosActionUnlinkAuth();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.account = reader.uint64();
                    break;
                case 2:
                    message.code = reader.uint64();
                    break;
                case 3:
                    message.type = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        EosActionUnlinkAuth.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        EosActionUnlinkAuth.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.account != null && message.hasOwnProperty("account"))
                if (!$util.isInteger(message.account) && !(message.account && $util.isInteger(message.account.low) && $util.isInteger(message.account.high)))
                    return "account: integer|Long expected";
            if (message.code != null && message.hasOwnProperty("code"))
                if (!$util.isInteger(message.code) && !(message.code && $util.isInteger(message.code.low) && $util.isInteger(message.code.high)))
                    return "code: integer|Long expected";
            if (message.type != null && message.hasOwnProperty("type"))
                if (!$util.isInteger(message.type) && !(message.type && $util.isInteger(message.type.low) && $util.isInteger(message.type.high)))
                    return "type: integer|Long expected";
            return null;
        };

        EosActionUnlinkAuth.fromObject = function fromObject(object) {
            if (object instanceof $root.EosTxActionAck.EosActionUnlinkAuth)
                return object;
            var message = new $root.EosTxActionAck.EosActionUnlinkAuth();
            if (object.account != null)
                if ($util.Long)
                    (message.account = $util.Long.fromValue(object.account)).unsigned = true;
                else if (typeof object.account === "string")
                    message.account = parseInt(object.account, 10);
                else if (typeof object.account === "number")
                    message.account = object.account;
                else if (typeof object.account === "object")
                    message.account = new $util.LongBits(object.account.low >>> 0, object.account.high >>> 0).toNumber(true);
            if (object.code != null)
                if ($util.Long)
                    (message.code = $util.Long.fromValue(object.code)).unsigned = true;
                else if (typeof object.code === "string")
                    message.code = parseInt(object.code, 10);
                else if (typeof object.code === "number")
                    message.code = object.code;
                else if (typeof object.code === "object")
                    message.code = new $util.LongBits(object.code.low >>> 0, object.code.high >>> 0).toNumber(true);
            if (object.type != null)
                if ($util.Long)
                    (message.type = $util.Long.fromValue(object.type)).unsigned = true;
                else if (typeof object.type === "string")
                    message.type = parseInt(object.type, 10);
                else if (typeof object.type === "number")
                    message.type = object.type;
                else if (typeof object.type === "object")
                    message.type = new $util.LongBits(object.type.low >>> 0, object.type.high >>> 0).toNumber(true);
            return message;
        };

        EosActionUnlinkAuth.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.account = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.account = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.code = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.code = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.type = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.type = options.longs === String ? "0" : 0;
            }
            if (message.account != null && message.hasOwnProperty("account"))
                if (typeof message.account === "number")
                    object.account = options.longs === String ? String(message.account) : message.account;
                else
                    object.account = options.longs === String ? $util.Long.prototype.toString.call(message.account) : options.longs === Number ? new $util.LongBits(message.account.low >>> 0, message.account.high >>> 0).toNumber(true) : message.account;
            if (message.code != null && message.hasOwnProperty("code"))
                if (typeof message.code === "number")
                    object.code = options.longs === String ? String(message.code) : message.code;
                else
                    object.code = options.longs === String ? $util.Long.prototype.toString.call(message.code) : options.longs === Number ? new $util.LongBits(message.code.low >>> 0, message.code.high >>> 0).toNumber(true) : message.code;
            if (message.type != null && message.hasOwnProperty("type"))
                if (typeof message.type === "number")
                    object.type = options.longs === String ? String(message.type) : message.type;
                else
                    object.type = options.longs === String ? $util.Long.prototype.toString.call(message.type) : options.longs === Number ? new $util.LongBits(message.type.low >>> 0, message.type.high >>> 0).toNumber(true) : message.type;
            return object;
        };

        EosActionUnlinkAuth.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EosActionUnlinkAuth;
    })();

    EosTxActionAck.EosActionNewAccount = (function() {

        function EosActionNewAccount(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        EosActionNewAccount.prototype.creator = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        EosActionNewAccount.prototype.name = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        EosActionNewAccount.prototype.owner = null;
        EosActionNewAccount.prototype.active = null;

        EosActionNewAccount.create = function create(properties) {
            return new EosActionNewAccount(properties);
        };

        EosActionNewAccount.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.creator != null && Object.hasOwnProperty.call(message, "creator"))
                writer.uint32(8).uint64(message.creator);
            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                writer.uint32(16).uint64(message.name);
            if (message.owner != null && Object.hasOwnProperty.call(message, "owner"))
                $root.EosTxActionAck.EosAuthorization.encode(message.owner, writer.uint32(26).fork()).ldelim();
            if (message.active != null && Object.hasOwnProperty.call(message, "active"))
                $root.EosTxActionAck.EosAuthorization.encode(message.active, writer.uint32(34).fork()).ldelim();
            return writer;
        };

        EosActionNewAccount.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        EosActionNewAccount.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EosTxActionAck.EosActionNewAccount();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.creator = reader.uint64();
                    break;
                case 2:
                    message.name = reader.uint64();
                    break;
                case 3:
                    message.owner = $root.EosTxActionAck.EosAuthorization.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.active = $root.EosTxActionAck.EosAuthorization.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        EosActionNewAccount.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        EosActionNewAccount.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.creator != null && message.hasOwnProperty("creator"))
                if (!$util.isInteger(message.creator) && !(message.creator && $util.isInteger(message.creator.low) && $util.isInteger(message.creator.high)))
                    return "creator: integer|Long expected";
            if (message.name != null && message.hasOwnProperty("name"))
                if (!$util.isInteger(message.name) && !(message.name && $util.isInteger(message.name.low) && $util.isInteger(message.name.high)))
                    return "name: integer|Long expected";
            if (message.owner != null && message.hasOwnProperty("owner")) {
                var error = $root.EosTxActionAck.EosAuthorization.verify(message.owner);
                if (error)
                    return "owner." + error;
            }
            if (message.active != null && message.hasOwnProperty("active")) {
                var error = $root.EosTxActionAck.EosAuthorization.verify(message.active);
                if (error)
                    return "active." + error;
            }
            return null;
        };

        EosActionNewAccount.fromObject = function fromObject(object) {
            if (object instanceof $root.EosTxActionAck.EosActionNewAccount)
                return object;
            var message = new $root.EosTxActionAck.EosActionNewAccount();
            if (object.creator != null)
                if ($util.Long)
                    (message.creator = $util.Long.fromValue(object.creator)).unsigned = true;
                else if (typeof object.creator === "string")
                    message.creator = parseInt(object.creator, 10);
                else if (typeof object.creator === "number")
                    message.creator = object.creator;
                else if (typeof object.creator === "object")
                    message.creator = new $util.LongBits(object.creator.low >>> 0, object.creator.high >>> 0).toNumber(true);
            if (object.name != null)
                if ($util.Long)
                    (message.name = $util.Long.fromValue(object.name)).unsigned = true;
                else if (typeof object.name === "string")
                    message.name = parseInt(object.name, 10);
                else if (typeof object.name === "number")
                    message.name = object.name;
                else if (typeof object.name === "object")
                    message.name = new $util.LongBits(object.name.low >>> 0, object.name.high >>> 0).toNumber(true);
            if (object.owner != null) {
                if (typeof object.owner !== "object")
                    throw TypeError(".EosTxActionAck.EosActionNewAccount.owner: object expected");
                message.owner = $root.EosTxActionAck.EosAuthorization.fromObject(object.owner);
            }
            if (object.active != null) {
                if (typeof object.active !== "object")
                    throw TypeError(".EosTxActionAck.EosActionNewAccount.active: object expected");
                message.active = $root.EosTxActionAck.EosAuthorization.fromObject(object.active);
            }
            return message;
        };

        EosActionNewAccount.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.creator = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.creator = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.name = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.name = options.longs === String ? "0" : 0;
                object.owner = null;
                object.active = null;
            }
            if (message.creator != null && message.hasOwnProperty("creator"))
                if (typeof message.creator === "number")
                    object.creator = options.longs === String ? String(message.creator) : message.creator;
                else
                    object.creator = options.longs === String ? $util.Long.prototype.toString.call(message.creator) : options.longs === Number ? new $util.LongBits(message.creator.low >>> 0, message.creator.high >>> 0).toNumber(true) : message.creator;
            if (message.name != null && message.hasOwnProperty("name"))
                if (typeof message.name === "number")
                    object.name = options.longs === String ? String(message.name) : message.name;
                else
                    object.name = options.longs === String ? $util.Long.prototype.toString.call(message.name) : options.longs === Number ? new $util.LongBits(message.name.low >>> 0, message.name.high >>> 0).toNumber(true) : message.name;
            if (message.owner != null && message.hasOwnProperty("owner"))
                object.owner = $root.EosTxActionAck.EosAuthorization.toObject(message.owner, options);
            if (message.active != null && message.hasOwnProperty("active"))
                object.active = $root.EosTxActionAck.EosAuthorization.toObject(message.active, options);
            return object;
        };

        EosActionNewAccount.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EosActionNewAccount;
    })();

    EosTxActionAck.EosActionUnknown = (function() {

        function EosActionUnknown(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        EosActionUnknown.prototype.data_size = 0;
        EosActionUnknown.prototype.data_chunk = $util.newBuffer([]);

        EosActionUnknown.create = function create(properties) {
            return new EosActionUnknown(properties);
        };

        EosActionUnknown.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(8).uint32(message.data_size);
            if (message.data_chunk != null && Object.hasOwnProperty.call(message, "data_chunk"))
                writer.uint32(18).bytes(message.data_chunk);
            return writer;
        };

        EosActionUnknown.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        EosActionUnknown.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EosTxActionAck.EosActionUnknown();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.data_size = reader.uint32();
                    break;
                case 2:
                    message.data_chunk = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("data_size"))
                throw $util.ProtocolError("missing required 'data_size'", { instance: message });
            return message;
        };

        EosActionUnknown.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        EosActionUnknown.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isInteger(message.data_size))
                return "data_size: integer expected";
            if (message.data_chunk != null && message.hasOwnProperty("data_chunk"))
                if (!(message.data_chunk && typeof message.data_chunk.length === "number" || $util.isString(message.data_chunk)))
                    return "data_chunk: buffer expected";
            return null;
        };

        EosActionUnknown.fromObject = function fromObject(object) {
            if (object instanceof $root.EosTxActionAck.EosActionUnknown)
                return object;
            var message = new $root.EosTxActionAck.EosActionUnknown();
            if (object.data_size != null)
                message.data_size = object.data_size >>> 0;
            if (object.data_chunk != null)
                if (typeof object.data_chunk === "string")
                    $util.base64.decode(object.data_chunk, message.data_chunk = $util.newBuffer($util.base64.length(object.data_chunk)), 0);
                else if (object.data_chunk.length)
                    message.data_chunk = object.data_chunk;
            return message;
        };

        EosActionUnknown.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.data_size = 0;
                if (options.bytes === String)
                    object.data_chunk = "";
                else {
                    object.data_chunk = [];
                    if (options.bytes !== Array)
                        object.data_chunk = $util.newBuffer(object.data_chunk);
                }
            }
            if (message.data_size != null && message.hasOwnProperty("data_size"))
                object.data_size = message.data_size;
            if (message.data_chunk != null && message.hasOwnProperty("data_chunk"))
                object.data_chunk = options.bytes === String ? $util.base64.encode(message.data_chunk, 0, message.data_chunk.length) : options.bytes === Array ? Array.prototype.slice.call(message.data_chunk) : message.data_chunk;
            return object;
        };

        EosActionUnknown.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EosActionUnknown;
    })();

    return EosTxActionAck;
})();

$root.EosSignedTx = (function() {

    function EosSignedTx(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EosSignedTx.prototype.signature = "";

    EosSignedTx.create = function create(properties) {
        return new EosSignedTx(properties);
    };

    EosSignedTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.signature);
        return writer;
    };

    EosSignedTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EosSignedTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EosSignedTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.signature = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        return message;
    };

    EosSignedTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EosSignedTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.signature))
            return "signature: string expected";
        return null;
    };

    EosSignedTx.fromObject = function fromObject(object) {
        if (object instanceof $root.EosSignedTx)
            return object;
        var message = new $root.EosSignedTx();
        if (object.signature != null)
            message.signature = String(object.signature);
        return message;
    };

    EosSignedTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.signature = "";
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = message.signature;
        return object;
    };

    EosSignedTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EosSignedTx;
})();

$root.EthereumSignTypedData = (function() {

    function EthereumSignTypedData(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumSignTypedData.prototype.address_n = $util.emptyArray;
    EthereumSignTypedData.prototype.primary_type = "";
    EthereumSignTypedData.prototype.metamask_v4_compat = true;
    EthereumSignTypedData.prototype.chain_id = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    EthereumSignTypedData.create = function create(properties) {
        return new EthereumSignTypedData(properties);
    };

    EthereumSignTypedData.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).string(message.primary_type);
        if (message.metamask_v4_compat != null && Object.hasOwnProperty.call(message, "metamask_v4_compat"))
            writer.uint32(24).bool(message.metamask_v4_compat);
        if (message.chain_id != null && Object.hasOwnProperty.call(message, "chain_id"))
            writer.uint32(32).uint64(message.chain_id);
        return writer;
    };

    EthereumSignTypedData.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumSignTypedData.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumSignTypedData();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.primary_type = reader.string();
                break;
            case 3:
                message.metamask_v4_compat = reader.bool();
                break;
            case 4:
                message.chain_id = reader.uint64();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("primary_type"))
            throw $util.ProtocolError("missing required 'primary_type'", { instance: message });
        return message;
    };

    EthereumSignTypedData.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumSignTypedData.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!$util.isString(message.primary_type))
            return "primary_type: string expected";
        if (message.metamask_v4_compat != null && message.hasOwnProperty("metamask_v4_compat"))
            if (typeof message.metamask_v4_compat !== "boolean")
                return "metamask_v4_compat: boolean expected";
        if (message.chain_id != null && message.hasOwnProperty("chain_id"))
            if (!$util.isInteger(message.chain_id) && !(message.chain_id && $util.isInteger(message.chain_id.low) && $util.isInteger(message.chain_id.high)))
                return "chain_id: integer|Long expected";
        return null;
    };

    EthereumSignTypedData.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumSignTypedData)
            return object;
        var message = new $root.EthereumSignTypedData();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".EthereumSignTypedData.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.primary_type != null)
            message.primary_type = String(object.primary_type);
        if (object.metamask_v4_compat != null)
            message.metamask_v4_compat = Boolean(object.metamask_v4_compat);
        if (object.chain_id != null)
            if ($util.Long)
                (message.chain_id = $util.Long.fromValue(object.chain_id)).unsigned = true;
            else if (typeof object.chain_id === "string")
                message.chain_id = parseInt(object.chain_id, 10);
            else if (typeof object.chain_id === "number")
                message.chain_id = object.chain_id;
            else if (typeof object.chain_id === "object")
                message.chain_id = new $util.LongBits(object.chain_id.low >>> 0, object.chain_id.high >>> 0).toNumber(true);
        return message;
    };

    EthereumSignTypedData.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            object.primary_type = "";
            object.metamask_v4_compat = true;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.chain_id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.chain_id = options.longs === String ? "0" : 0;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.primary_type != null && message.hasOwnProperty("primary_type"))
            object.primary_type = message.primary_type;
        if (message.metamask_v4_compat != null && message.hasOwnProperty("metamask_v4_compat"))
            object.metamask_v4_compat = message.metamask_v4_compat;
        if (message.chain_id != null && message.hasOwnProperty("chain_id"))
            if (typeof message.chain_id === "number")
                object.chain_id = options.longs === String ? String(message.chain_id) : message.chain_id;
            else
                object.chain_id = options.longs === String ? $util.Long.prototype.toString.call(message.chain_id) : options.longs === Number ? new $util.LongBits(message.chain_id.low >>> 0, message.chain_id.high >>> 0).toNumber(true) : message.chain_id;
        return object;
    };

    EthereumSignTypedData.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumSignTypedData;
})();

$root.EthereumTypedDataStructRequest = (function() {

    function EthereumTypedDataStructRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumTypedDataStructRequest.prototype.name = "";

    EthereumTypedDataStructRequest.create = function create(properties) {
        return new EthereumTypedDataStructRequest(properties);
    };

    EthereumTypedDataStructRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.name);
        return writer;
    };

    EthereumTypedDataStructRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumTypedDataStructRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumTypedDataStructRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.name = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("name"))
            throw $util.ProtocolError("missing required 'name'", { instance: message });
        return message;
    };

    EthereumTypedDataStructRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumTypedDataStructRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.name))
            return "name: string expected";
        return null;
    };

    EthereumTypedDataStructRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumTypedDataStructRequest)
            return object;
        var message = new $root.EthereumTypedDataStructRequest();
        if (object.name != null)
            message.name = String(object.name);
        return message;
    };

    EthereumTypedDataStructRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.name = "";
        if (message.name != null && message.hasOwnProperty("name"))
            object.name = message.name;
        return object;
    };

    EthereumTypedDataStructRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumTypedDataStructRequest;
})();

$root.EthereumTypedDataStructAck = (function() {

    function EthereumTypedDataStructAck(properties) {
        this.members = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumTypedDataStructAck.prototype.members = $util.emptyArray;

    EthereumTypedDataStructAck.create = function create(properties) {
        return new EthereumTypedDataStructAck(properties);
    };

    EthereumTypedDataStructAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.members != null && message.members.length)
            for (var i = 0; i < message.members.length; ++i)
                $root.EthereumTypedDataStructAck.EthereumStructMember.encode(message.members[i], writer.uint32(10).fork()).ldelim();
        return writer;
    };

    EthereumTypedDataStructAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumTypedDataStructAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumTypedDataStructAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.members && message.members.length))
                    message.members = [];
                message.members.push($root.EthereumTypedDataStructAck.EthereumStructMember.decode(reader, reader.uint32()));
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    EthereumTypedDataStructAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumTypedDataStructAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.members != null && message.hasOwnProperty("members")) {
            if (!Array.isArray(message.members))
                return "members: array expected";
            for (var i = 0; i < message.members.length; ++i) {
                var error = $root.EthereumTypedDataStructAck.EthereumStructMember.verify(message.members[i]);
                if (error)
                    return "members." + error;
            }
        }
        return null;
    };

    EthereumTypedDataStructAck.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumTypedDataStructAck)
            return object;
        var message = new $root.EthereumTypedDataStructAck();
        if (object.members) {
            if (!Array.isArray(object.members))
                throw TypeError(".EthereumTypedDataStructAck.members: array expected");
            message.members = [];
            for (var i = 0; i < object.members.length; ++i) {
                if (typeof object.members[i] !== "object")
                    throw TypeError(".EthereumTypedDataStructAck.members: object expected");
                message.members[i] = $root.EthereumTypedDataStructAck.EthereumStructMember.fromObject(object.members[i]);
            }
        }
        return message;
    };

    EthereumTypedDataStructAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.members = [];
        if (message.members && message.members.length) {
            object.members = [];
            for (var j = 0; j < message.members.length; ++j)
                object.members[j] = $root.EthereumTypedDataStructAck.EthereumStructMember.toObject(message.members[j], options);
        }
        return object;
    };

    EthereumTypedDataStructAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    EthereumTypedDataStructAck.EthereumStructMember = (function() {

        function EthereumStructMember(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        EthereumStructMember.prototype.type = null;
        EthereumStructMember.prototype.name = "";

        EthereumStructMember.create = function create(properties) {
            return new EthereumStructMember(properties);
        };

        EthereumStructMember.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            $root.EthereumTypedDataStructAck.EthereumFieldType.encode(message.type, writer.uint32(10).fork()).ldelim();
            writer.uint32(18).string(message.name);
            return writer;
        };

        EthereumStructMember.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        EthereumStructMember.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumTypedDataStructAck.EthereumStructMember();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.type = $root.EthereumTypedDataStructAck.EthereumFieldType.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.name = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("type"))
                throw $util.ProtocolError("missing required 'type'", { instance: message });
            if (!message.hasOwnProperty("name"))
                throw $util.ProtocolError("missing required 'name'", { instance: message });
            return message;
        };

        EthereumStructMember.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        EthereumStructMember.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            {
                var error = $root.EthereumTypedDataStructAck.EthereumFieldType.verify(message.type);
                if (error)
                    return "type." + error;
            }
            if (!$util.isString(message.name))
                return "name: string expected";
            return null;
        };

        EthereumStructMember.fromObject = function fromObject(object) {
            if (object instanceof $root.EthereumTypedDataStructAck.EthereumStructMember)
                return object;
            var message = new $root.EthereumTypedDataStructAck.EthereumStructMember();
            if (object.type != null) {
                if (typeof object.type !== "object")
                    throw TypeError(".EthereumTypedDataStructAck.EthereumStructMember.type: object expected");
                message.type = $root.EthereumTypedDataStructAck.EthereumFieldType.fromObject(object.type);
            }
            if (object.name != null)
                message.name = String(object.name);
            return message;
        };

        EthereumStructMember.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.type = null;
                object.name = "";
            }
            if (message.type != null && message.hasOwnProperty("type"))
                object.type = $root.EthereumTypedDataStructAck.EthereumFieldType.toObject(message.type, options);
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            return object;
        };

        EthereumStructMember.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EthereumStructMember;
    })();

    EthereumTypedDataStructAck.EthereumFieldType = (function() {

        function EthereumFieldType(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        EthereumFieldType.prototype.data_type = 1;
        EthereumFieldType.prototype.size = 0;
        EthereumFieldType.prototype.entry_type = null;
        EthereumFieldType.prototype.struct_name = "";

        EthereumFieldType.create = function create(properties) {
            return new EthereumFieldType(properties);
        };

        EthereumFieldType.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(8).int32(message.data_type);
            if (message.size != null && Object.hasOwnProperty.call(message, "size"))
                writer.uint32(16).uint32(message.size);
            if (message.entry_type != null && Object.hasOwnProperty.call(message, "entry_type"))
                $root.EthereumTypedDataStructAck.EthereumFieldType.encode(message.entry_type, writer.uint32(26).fork()).ldelim();
            if (message.struct_name != null && Object.hasOwnProperty.call(message, "struct_name"))
                writer.uint32(34).string(message.struct_name);
            return writer;
        };

        EthereumFieldType.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        EthereumFieldType.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumTypedDataStructAck.EthereumFieldType();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.data_type = reader.int32();
                    break;
                case 2:
                    message.size = reader.uint32();
                    break;
                case 3:
                    message.entry_type = $root.EthereumTypedDataStructAck.EthereumFieldType.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.struct_name = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("data_type"))
                throw $util.ProtocolError("missing required 'data_type'", { instance: message });
            return message;
        };

        EthereumFieldType.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        EthereumFieldType.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            switch (message.data_type) {
            default:
                return "data_type: enum value expected";
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
            case 8:
                break;
            }
            if (message.size != null && message.hasOwnProperty("size"))
                if (!$util.isInteger(message.size))
                    return "size: integer expected";
            if (message.entry_type != null && message.hasOwnProperty("entry_type")) {
                var error = $root.EthereumTypedDataStructAck.EthereumFieldType.verify(message.entry_type);
                if (error)
                    return "entry_type." + error;
            }
            if (message.struct_name != null && message.hasOwnProperty("struct_name"))
                if (!$util.isString(message.struct_name))
                    return "struct_name: string expected";
            return null;
        };

        EthereumFieldType.fromObject = function fromObject(object) {
            if (object instanceof $root.EthereumTypedDataStructAck.EthereumFieldType)
                return object;
            var message = new $root.EthereumTypedDataStructAck.EthereumFieldType();
            switch (object.data_type) {
            case "UINT":
            case 1:
                message.data_type = 1;
                break;
            case "INT":
            case 2:
                message.data_type = 2;
                break;
            case "BYTES":
            case 3:
                message.data_type = 3;
                break;
            case "STRING":
            case 4:
                message.data_type = 4;
                break;
            case "BOOL":
            case 5:
                message.data_type = 5;
                break;
            case "ADDRESS":
            case 6:
                message.data_type = 6;
                break;
            case "ARRAY":
            case 7:
                message.data_type = 7;
                break;
            case "STRUCT":
            case 8:
                message.data_type = 8;
                break;
            }
            if (object.size != null)
                message.size = object.size >>> 0;
            if (object.entry_type != null) {
                if (typeof object.entry_type !== "object")
                    throw TypeError(".EthereumTypedDataStructAck.EthereumFieldType.entry_type: object expected");
                message.entry_type = $root.EthereumTypedDataStructAck.EthereumFieldType.fromObject(object.entry_type);
            }
            if (object.struct_name != null)
                message.struct_name = String(object.struct_name);
            return message;
        };

        EthereumFieldType.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.data_type = options.enums === String ? "UINT" : 1;
                object.size = 0;
                object.entry_type = null;
                object.struct_name = "";
            }
            if (message.data_type != null && message.hasOwnProperty("data_type"))
                object.data_type = options.enums === String ? $root.EthereumTypedDataStructAck.EthereumDataType[message.data_type] : message.data_type;
            if (message.size != null && message.hasOwnProperty("size"))
                object.size = message.size;
            if (message.entry_type != null && message.hasOwnProperty("entry_type"))
                object.entry_type = $root.EthereumTypedDataStructAck.EthereumFieldType.toObject(message.entry_type, options);
            if (message.struct_name != null && message.hasOwnProperty("struct_name"))
                object.struct_name = message.struct_name;
            return object;
        };

        EthereumFieldType.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EthereumFieldType;
    })();

    EthereumTypedDataStructAck.EthereumDataType = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[1] = "UINT"] = 1;
        values[valuesById[2] = "INT"] = 2;
        values[valuesById[3] = "BYTES"] = 3;
        values[valuesById[4] = "STRING"] = 4;
        values[valuesById[5] = "BOOL"] = 5;
        values[valuesById[6] = "ADDRESS"] = 6;
        values[valuesById[7] = "ARRAY"] = 7;
        values[valuesById[8] = "STRUCT"] = 8;
        return values;
    })();

    return EthereumTypedDataStructAck;
})();

$root.EthereumTypedDataValueRequest = (function() {

    function EthereumTypedDataValueRequest(properties) {
        this.member_path = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumTypedDataValueRequest.prototype.member_path = $util.emptyArray;

    EthereumTypedDataValueRequest.create = function create(properties) {
        return new EthereumTypedDataValueRequest(properties);
    };

    EthereumTypedDataValueRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.member_path != null && message.member_path.length)
            for (var i = 0; i < message.member_path.length; ++i)
                writer.uint32(8).uint32(message.member_path[i]);
        return writer;
    };

    EthereumTypedDataValueRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumTypedDataValueRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumTypedDataValueRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.member_path && message.member_path.length))
                    message.member_path = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.member_path.push(reader.uint32());
                } else
                    message.member_path.push(reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    EthereumTypedDataValueRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumTypedDataValueRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.member_path != null && message.hasOwnProperty("member_path")) {
            if (!Array.isArray(message.member_path))
                return "member_path: array expected";
            for (var i = 0; i < message.member_path.length; ++i)
                if (!$util.isInteger(message.member_path[i]))
                    return "member_path: integer[] expected";
        }
        return null;
    };

    EthereumTypedDataValueRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumTypedDataValueRequest)
            return object;
        var message = new $root.EthereumTypedDataValueRequest();
        if (object.member_path) {
            if (!Array.isArray(object.member_path))
                throw TypeError(".EthereumTypedDataValueRequest.member_path: array expected");
            message.member_path = [];
            for (var i = 0; i < object.member_path.length; ++i)
                message.member_path[i] = object.member_path[i] >>> 0;
        }
        return message;
    };

    EthereumTypedDataValueRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.member_path = [];
        if (message.member_path && message.member_path.length) {
            object.member_path = [];
            for (var j = 0; j < message.member_path.length; ++j)
                object.member_path[j] = message.member_path[j];
        }
        return object;
    };

    EthereumTypedDataValueRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumTypedDataValueRequest;
})();

$root.EthereumTypedDataValueAck = (function() {

    function EthereumTypedDataValueAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumTypedDataValueAck.prototype.value = $util.newBuffer([]);

    EthereumTypedDataValueAck.create = function create(properties) {
        return new EthereumTypedDataValueAck(properties);
    };

    EthereumTypedDataValueAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.value);
        return writer;
    };

    EthereumTypedDataValueAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumTypedDataValueAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumTypedDataValueAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.value = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("value"))
            throw $util.ProtocolError("missing required 'value'", { instance: message });
        return message;
    };

    EthereumTypedDataValueAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumTypedDataValueAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.value && typeof message.value.length === "number" || $util.isString(message.value)))
            return "value: buffer expected";
        return null;
    };

    EthereumTypedDataValueAck.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumTypedDataValueAck)
            return object;
        var message = new $root.EthereumTypedDataValueAck();
        if (object.value != null)
            if (typeof object.value === "string")
                $util.base64.decode(object.value, message.value = $util.newBuffer($util.base64.length(object.value)), 0);
            else if (object.value.length)
                message.value = object.value;
        return message;
    };

    EthereumTypedDataValueAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.value = "";
            else {
                object.value = [];
                if (options.bytes !== Array)
                    object.value = $util.newBuffer(object.value);
            }
        if (message.value != null && message.hasOwnProperty("value"))
            object.value = options.bytes === String ? $util.base64.encode(message.value, 0, message.value.length) : options.bytes === Array ? Array.prototype.slice.call(message.value) : message.value;
        return object;
    };

    EthereumTypedDataValueAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumTypedDataValueAck;
})();

$root.EthereumGetPublicKey = (function() {

    function EthereumGetPublicKey(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumGetPublicKey.prototype.address_n = $util.emptyArray;
    EthereumGetPublicKey.prototype.show_display = false;
    EthereumGetPublicKey.prototype.chain_id = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    EthereumGetPublicKey.create = function create(properties) {
        return new EthereumGetPublicKey(properties);
    };

    EthereumGetPublicKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(16).bool(message.show_display);
        if (message.chain_id != null && Object.hasOwnProperty.call(message, "chain_id"))
            writer.uint32(24).uint64(message.chain_id);
        return writer;
    };

    EthereumGetPublicKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumGetPublicKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumGetPublicKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.show_display = reader.bool();
                break;
            case 3:
                message.chain_id = reader.uint64();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    EthereumGetPublicKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumGetPublicKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        if (message.chain_id != null && message.hasOwnProperty("chain_id"))
            if (!$util.isInteger(message.chain_id) && !(message.chain_id && $util.isInteger(message.chain_id.low) && $util.isInteger(message.chain_id.high)))
                return "chain_id: integer|Long expected";
        return null;
    };

    EthereumGetPublicKey.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumGetPublicKey)
            return object;
        var message = new $root.EthereumGetPublicKey();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".EthereumGetPublicKey.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        if (object.chain_id != null)
            if ($util.Long)
                (message.chain_id = $util.Long.fromValue(object.chain_id)).unsigned = true;
            else if (typeof object.chain_id === "string")
                message.chain_id = parseInt(object.chain_id, 10);
            else if (typeof object.chain_id === "number")
                message.chain_id = object.chain_id;
            else if (typeof object.chain_id === "object")
                message.chain_id = new $util.LongBits(object.chain_id.low >>> 0, object.chain_id.high >>> 0).toNumber(true);
        return message;
    };

    EthereumGetPublicKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            object.show_display = false;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.chain_id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.chain_id = options.longs === String ? "0" : 0;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        if (message.chain_id != null && message.hasOwnProperty("chain_id"))
            if (typeof message.chain_id === "number")
                object.chain_id = options.longs === String ? String(message.chain_id) : message.chain_id;
            else
                object.chain_id = options.longs === String ? $util.Long.prototype.toString.call(message.chain_id) : options.longs === Number ? new $util.LongBits(message.chain_id.low >>> 0, message.chain_id.high >>> 0).toNumber(true) : message.chain_id;
        return object;
    };

    EthereumGetPublicKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumGetPublicKey;
})();

$root.EthereumPublicKey = (function() {

    function EthereumPublicKey(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumPublicKey.prototype.node = null;
    EthereumPublicKey.prototype.xpub = "";

    EthereumPublicKey.create = function create(properties) {
        return new EthereumPublicKey(properties);
    };

    EthereumPublicKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        $root.HDNodeType.encode(message.node, writer.uint32(10).fork()).ldelim();
        writer.uint32(18).string(message.xpub);
        return writer;
    };

    EthereumPublicKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumPublicKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumPublicKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.node = $root.HDNodeType.decode(reader, reader.uint32());
                break;
            case 2:
                message.xpub = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("node"))
            throw $util.ProtocolError("missing required 'node'", { instance: message });
        if (!message.hasOwnProperty("xpub"))
            throw $util.ProtocolError("missing required 'xpub'", { instance: message });
        return message;
    };

    EthereumPublicKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumPublicKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        {
            var error = $root.HDNodeType.verify(message.node);
            if (error)
                return "node." + error;
        }
        if (!$util.isString(message.xpub))
            return "xpub: string expected";
        return null;
    };

    EthereumPublicKey.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumPublicKey)
            return object;
        var message = new $root.EthereumPublicKey();
        if (object.node != null) {
            if (typeof object.node !== "object")
                throw TypeError(".EthereumPublicKey.node: object expected");
            message.node = $root.HDNodeType.fromObject(object.node);
        }
        if (object.xpub != null)
            message.xpub = String(object.xpub);
        return message;
    };

    EthereumPublicKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.node = null;
            object.xpub = "";
        }
        if (message.node != null && message.hasOwnProperty("node"))
            object.node = $root.HDNodeType.toObject(message.node, options);
        if (message.xpub != null && message.hasOwnProperty("xpub"))
            object.xpub = message.xpub;
        return object;
    };

    EthereumPublicKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumPublicKey;
})();

$root.EthereumGetAddress = (function() {

    function EthereumGetAddress(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumGetAddress.prototype.address_n = $util.emptyArray;
    EthereumGetAddress.prototype.show_display = false;
    EthereumGetAddress.prototype.chain_id = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    EthereumGetAddress.create = function create(properties) {
        return new EthereumGetAddress(properties);
    };

    EthereumGetAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(16).bool(message.show_display);
        if (message.chain_id != null && Object.hasOwnProperty.call(message, "chain_id"))
            writer.uint32(24).uint64(message.chain_id);
        return writer;
    };

    EthereumGetAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumGetAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumGetAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.show_display = reader.bool();
                break;
            case 3:
                message.chain_id = reader.uint64();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    EthereumGetAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumGetAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        if (message.chain_id != null && message.hasOwnProperty("chain_id"))
            if (!$util.isInteger(message.chain_id) && !(message.chain_id && $util.isInteger(message.chain_id.low) && $util.isInteger(message.chain_id.high)))
                return "chain_id: integer|Long expected";
        return null;
    };

    EthereumGetAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumGetAddress)
            return object;
        var message = new $root.EthereumGetAddress();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".EthereumGetAddress.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        if (object.chain_id != null)
            if ($util.Long)
                (message.chain_id = $util.Long.fromValue(object.chain_id)).unsigned = true;
            else if (typeof object.chain_id === "string")
                message.chain_id = parseInt(object.chain_id, 10);
            else if (typeof object.chain_id === "number")
                message.chain_id = object.chain_id;
            else if (typeof object.chain_id === "object")
                message.chain_id = new $util.LongBits(object.chain_id.low >>> 0, object.chain_id.high >>> 0).toNumber(true);
        return message;
    };

    EthereumGetAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            object.show_display = false;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.chain_id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.chain_id = options.longs === String ? "0" : 0;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        if (message.chain_id != null && message.hasOwnProperty("chain_id"))
            if (typeof message.chain_id === "number")
                object.chain_id = options.longs === String ? String(message.chain_id) : message.chain_id;
            else
                object.chain_id = options.longs === String ? $util.Long.prototype.toString.call(message.chain_id) : options.longs === Number ? new $util.LongBits(message.chain_id.low >>> 0, message.chain_id.high >>> 0).toNumber(true) : message.chain_id;
        return object;
    };

    EthereumGetAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumGetAddress;
})();

$root.EthereumAddress = (function() {

    function EthereumAddress(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumAddress.prototype._old_address = $util.newBuffer([]);
    EthereumAddress.prototype.address = "";

    EthereumAddress.create = function create(properties) {
        return new EthereumAddress(properties);
    };

    EthereumAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message._old_address != null && Object.hasOwnProperty.call(message, "_old_address"))
            writer.uint32(10).bytes(message._old_address);
        if (message.address != null && Object.hasOwnProperty.call(message, "address"))
            writer.uint32(18).string(message.address);
        return writer;
    };

    EthereumAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message._old_address = reader.bytes();
                break;
            case 2:
                message.address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    EthereumAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message._old_address != null && message.hasOwnProperty("_old_address"))
            if (!(message._old_address && typeof message._old_address.length === "number" || $util.isString(message._old_address)))
                return "_old_address: buffer expected";
        if (message.address != null && message.hasOwnProperty("address"))
            if (!$util.isString(message.address))
                return "address: string expected";
        return null;
    };

    EthereumAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumAddress)
            return object;
        var message = new $root.EthereumAddress();
        if (object._old_address != null)
            if (typeof object._old_address === "string")
                $util.base64.decode(object._old_address, message._old_address = $util.newBuffer($util.base64.length(object._old_address)), 0);
            else if (object._old_address.length)
                message._old_address = object._old_address;
        if (object.address != null)
            message.address = String(object.address);
        return message;
    };

    EthereumAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object._old_address = "";
            else {
                object._old_address = [];
                if (options.bytes !== Array)
                    object._old_address = $util.newBuffer(object._old_address);
            }
            object.address = "";
        }
        if (message._old_address != null && message.hasOwnProperty("_old_address"))
            object._old_address = options.bytes === String ? $util.base64.encode(message._old_address, 0, message._old_address.length) : options.bytes === Array ? Array.prototype.slice.call(message._old_address) : message._old_address;
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    EthereumAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumAddress;
})();

$root.EthereumSignTx = (function() {

    function EthereumSignTx(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumSignTx.prototype.address_n = $util.emptyArray;
    EthereumSignTx.prototype.nonce = $util.newBuffer([]);
    EthereumSignTx.prototype.gas_price = $util.newBuffer([]);
    EthereumSignTx.prototype.gas_limit = $util.newBuffer([]);
    EthereumSignTx.prototype.to = "";
    EthereumSignTx.prototype.value = $util.newBuffer([]);
    EthereumSignTx.prototype.data_initial_chunk = $util.newBuffer([]);
    EthereumSignTx.prototype.data_length = 0;
    EthereumSignTx.prototype.chain_id = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    EthereumSignTx.prototype.tx_type = 0;

    EthereumSignTx.create = function create(properties) {
        return new EthereumSignTx(properties);
    };

    EthereumSignTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.nonce != null && Object.hasOwnProperty.call(message, "nonce"))
            writer.uint32(18).bytes(message.nonce);
        writer.uint32(26).bytes(message.gas_price);
        writer.uint32(34).bytes(message.gas_limit);
        if (message.value != null && Object.hasOwnProperty.call(message, "value"))
            writer.uint32(50).bytes(message.value);
        if (message.data_initial_chunk != null && Object.hasOwnProperty.call(message, "data_initial_chunk"))
            writer.uint32(58).bytes(message.data_initial_chunk);
        if (message.data_length != null && Object.hasOwnProperty.call(message, "data_length"))
            writer.uint32(64).uint32(message.data_length);
        writer.uint32(72).uint64(message.chain_id);
        if (message.tx_type != null && Object.hasOwnProperty.call(message, "tx_type"))
            writer.uint32(80).uint32(message.tx_type);
        if (message.to != null && Object.hasOwnProperty.call(message, "to"))
            writer.uint32(90).string(message.to);
        return writer;
    };

    EthereumSignTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumSignTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumSignTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.nonce = reader.bytes();
                break;
            case 3:
                message.gas_price = reader.bytes();
                break;
            case 4:
                message.gas_limit = reader.bytes();
                break;
            case 11:
                message.to = reader.string();
                break;
            case 6:
                message.value = reader.bytes();
                break;
            case 7:
                message.data_initial_chunk = reader.bytes();
                break;
            case 8:
                message.data_length = reader.uint32();
                break;
            case 9:
                message.chain_id = reader.uint64();
                break;
            case 10:
                message.tx_type = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("gas_price"))
            throw $util.ProtocolError("missing required 'gas_price'", { instance: message });
        if (!message.hasOwnProperty("gas_limit"))
            throw $util.ProtocolError("missing required 'gas_limit'", { instance: message });
        if (!message.hasOwnProperty("chain_id"))
            throw $util.ProtocolError("missing required 'chain_id'", { instance: message });
        return message;
    };

    EthereumSignTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumSignTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.nonce != null && message.hasOwnProperty("nonce"))
            if (!(message.nonce && typeof message.nonce.length === "number" || $util.isString(message.nonce)))
                return "nonce: buffer expected";
        if (!(message.gas_price && typeof message.gas_price.length === "number" || $util.isString(message.gas_price)))
            return "gas_price: buffer expected";
        if (!(message.gas_limit && typeof message.gas_limit.length === "number" || $util.isString(message.gas_limit)))
            return "gas_limit: buffer expected";
        if (message.to != null && message.hasOwnProperty("to"))
            if (!$util.isString(message.to))
                return "to: string expected";
        if (message.value != null && message.hasOwnProperty("value"))
            if (!(message.value && typeof message.value.length === "number" || $util.isString(message.value)))
                return "value: buffer expected";
        if (message.data_initial_chunk != null && message.hasOwnProperty("data_initial_chunk"))
            if (!(message.data_initial_chunk && typeof message.data_initial_chunk.length === "number" || $util.isString(message.data_initial_chunk)))
                return "data_initial_chunk: buffer expected";
        if (message.data_length != null && message.hasOwnProperty("data_length"))
            if (!$util.isInteger(message.data_length))
                return "data_length: integer expected";
        if (!$util.isInteger(message.chain_id) && !(message.chain_id && $util.isInteger(message.chain_id.low) && $util.isInteger(message.chain_id.high)))
            return "chain_id: integer|Long expected";
        if (message.tx_type != null && message.hasOwnProperty("tx_type"))
            if (!$util.isInteger(message.tx_type))
                return "tx_type: integer expected";
        return null;
    };

    EthereumSignTx.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumSignTx)
            return object;
        var message = new $root.EthereumSignTx();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".EthereumSignTx.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.nonce != null)
            if (typeof object.nonce === "string")
                $util.base64.decode(object.nonce, message.nonce = $util.newBuffer($util.base64.length(object.nonce)), 0);
            else if (object.nonce.length)
                message.nonce = object.nonce;
        if (object.gas_price != null)
            if (typeof object.gas_price === "string")
                $util.base64.decode(object.gas_price, message.gas_price = $util.newBuffer($util.base64.length(object.gas_price)), 0);
            else if (object.gas_price.length)
                message.gas_price = object.gas_price;
        if (object.gas_limit != null)
            if (typeof object.gas_limit === "string")
                $util.base64.decode(object.gas_limit, message.gas_limit = $util.newBuffer($util.base64.length(object.gas_limit)), 0);
            else if (object.gas_limit.length)
                message.gas_limit = object.gas_limit;
        if (object.to != null)
            message.to = String(object.to);
        if (object.value != null)
            if (typeof object.value === "string")
                $util.base64.decode(object.value, message.value = $util.newBuffer($util.base64.length(object.value)), 0);
            else if (object.value.length)
                message.value = object.value;
        if (object.data_initial_chunk != null)
            if (typeof object.data_initial_chunk === "string")
                $util.base64.decode(object.data_initial_chunk, message.data_initial_chunk = $util.newBuffer($util.base64.length(object.data_initial_chunk)), 0);
            else if (object.data_initial_chunk.length)
                message.data_initial_chunk = object.data_initial_chunk;
        if (object.data_length != null)
            message.data_length = object.data_length >>> 0;
        if (object.chain_id != null)
            if ($util.Long)
                (message.chain_id = $util.Long.fromValue(object.chain_id)).unsigned = true;
            else if (typeof object.chain_id === "string")
                message.chain_id = parseInt(object.chain_id, 10);
            else if (typeof object.chain_id === "number")
                message.chain_id = object.chain_id;
            else if (typeof object.chain_id === "object")
                message.chain_id = new $util.LongBits(object.chain_id.low >>> 0, object.chain_id.high >>> 0).toNumber(true);
        if (object.tx_type != null)
            message.tx_type = object.tx_type >>> 0;
        return message;
    };

    EthereumSignTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            if (options.bytes === String)
                object.nonce = "";
            else {
                object.nonce = [];
                if (options.bytes !== Array)
                    object.nonce = $util.newBuffer(object.nonce);
            }
            if (options.bytes === String)
                object.gas_price = "";
            else {
                object.gas_price = [];
                if (options.bytes !== Array)
                    object.gas_price = $util.newBuffer(object.gas_price);
            }
            if (options.bytes === String)
                object.gas_limit = "";
            else {
                object.gas_limit = [];
                if (options.bytes !== Array)
                    object.gas_limit = $util.newBuffer(object.gas_limit);
            }
            if (options.bytes === String)
                object.value = "";
            else {
                object.value = [];
                if (options.bytes !== Array)
                    object.value = $util.newBuffer(object.value);
            }
            if (options.bytes === String)
                object.data_initial_chunk = "";
            else {
                object.data_initial_chunk = [];
                if (options.bytes !== Array)
                    object.data_initial_chunk = $util.newBuffer(object.data_initial_chunk);
            }
            object.data_length = 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.chain_id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.chain_id = options.longs === String ? "0" : 0;
            object.tx_type = 0;
            object.to = "";
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.nonce != null && message.hasOwnProperty("nonce"))
            object.nonce = options.bytes === String ? $util.base64.encode(message.nonce, 0, message.nonce.length) : options.bytes === Array ? Array.prototype.slice.call(message.nonce) : message.nonce;
        if (message.gas_price != null && message.hasOwnProperty("gas_price"))
            object.gas_price = options.bytes === String ? $util.base64.encode(message.gas_price, 0, message.gas_price.length) : options.bytes === Array ? Array.prototype.slice.call(message.gas_price) : message.gas_price;
        if (message.gas_limit != null && message.hasOwnProperty("gas_limit"))
            object.gas_limit = options.bytes === String ? $util.base64.encode(message.gas_limit, 0, message.gas_limit.length) : options.bytes === Array ? Array.prototype.slice.call(message.gas_limit) : message.gas_limit;
        if (message.value != null && message.hasOwnProperty("value"))
            object.value = options.bytes === String ? $util.base64.encode(message.value, 0, message.value.length) : options.bytes === Array ? Array.prototype.slice.call(message.value) : message.value;
        if (message.data_initial_chunk != null && message.hasOwnProperty("data_initial_chunk"))
            object.data_initial_chunk = options.bytes === String ? $util.base64.encode(message.data_initial_chunk, 0, message.data_initial_chunk.length) : options.bytes === Array ? Array.prototype.slice.call(message.data_initial_chunk) : message.data_initial_chunk;
        if (message.data_length != null && message.hasOwnProperty("data_length"))
            object.data_length = message.data_length;
        if (message.chain_id != null && message.hasOwnProperty("chain_id"))
            if (typeof message.chain_id === "number")
                object.chain_id = options.longs === String ? String(message.chain_id) : message.chain_id;
            else
                object.chain_id = options.longs === String ? $util.Long.prototype.toString.call(message.chain_id) : options.longs === Number ? new $util.LongBits(message.chain_id.low >>> 0, message.chain_id.high >>> 0).toNumber(true) : message.chain_id;
        if (message.tx_type != null && message.hasOwnProperty("tx_type"))
            object.tx_type = message.tx_type;
        if (message.to != null && message.hasOwnProperty("to"))
            object.to = message.to;
        return object;
    };

    EthereumSignTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumSignTx;
})();

$root.EthereumSignTxEIP1559 = (function() {

    function EthereumSignTxEIP1559(properties) {
        this.address_n = [];
        this.access_list = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumSignTxEIP1559.prototype.address_n = $util.emptyArray;
    EthereumSignTxEIP1559.prototype.nonce = $util.newBuffer([]);
    EthereumSignTxEIP1559.prototype.max_gas_fee = $util.newBuffer([]);
    EthereumSignTxEIP1559.prototype.max_priority_fee = $util.newBuffer([]);
    EthereumSignTxEIP1559.prototype.gas_limit = $util.newBuffer([]);
    EthereumSignTxEIP1559.prototype.to = "";
    EthereumSignTxEIP1559.prototype.value = $util.newBuffer([]);
    EthereumSignTxEIP1559.prototype.data_initial_chunk = $util.newBuffer([]);
    EthereumSignTxEIP1559.prototype.data_length = 0;
    EthereumSignTxEIP1559.prototype.chain_id = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    EthereumSignTxEIP1559.prototype.access_list = $util.emptyArray;

    EthereumSignTxEIP1559.create = function create(properties) {
        return new EthereumSignTxEIP1559(properties);
    };

    EthereumSignTxEIP1559.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).bytes(message.nonce);
        writer.uint32(26).bytes(message.max_gas_fee);
        writer.uint32(34).bytes(message.max_priority_fee);
        writer.uint32(42).bytes(message.gas_limit);
        if (message.to != null && Object.hasOwnProperty.call(message, "to"))
            writer.uint32(50).string(message.to);
        writer.uint32(58).bytes(message.value);
        if (message.data_initial_chunk != null && Object.hasOwnProperty.call(message, "data_initial_chunk"))
            writer.uint32(66).bytes(message.data_initial_chunk);
        writer.uint32(72).uint32(message.data_length);
        writer.uint32(80).uint64(message.chain_id);
        if (message.access_list != null && message.access_list.length)
            for (var i = 0; i < message.access_list.length; ++i)
                $root.EthereumSignTxEIP1559.EthereumAccessList.encode(message.access_list[i], writer.uint32(90).fork()).ldelim();
        return writer;
    };

    EthereumSignTxEIP1559.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumSignTxEIP1559.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumSignTxEIP1559();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.nonce = reader.bytes();
                break;
            case 3:
                message.max_gas_fee = reader.bytes();
                break;
            case 4:
                message.max_priority_fee = reader.bytes();
                break;
            case 5:
                message.gas_limit = reader.bytes();
                break;
            case 6:
                message.to = reader.string();
                break;
            case 7:
                message.value = reader.bytes();
                break;
            case 8:
                message.data_initial_chunk = reader.bytes();
                break;
            case 9:
                message.data_length = reader.uint32();
                break;
            case 10:
                message.chain_id = reader.uint64();
                break;
            case 11:
                if (!(message.access_list && message.access_list.length))
                    message.access_list = [];
                message.access_list.push($root.EthereumSignTxEIP1559.EthereumAccessList.decode(reader, reader.uint32()));
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("nonce"))
            throw $util.ProtocolError("missing required 'nonce'", { instance: message });
        if (!message.hasOwnProperty("max_gas_fee"))
            throw $util.ProtocolError("missing required 'max_gas_fee'", { instance: message });
        if (!message.hasOwnProperty("max_priority_fee"))
            throw $util.ProtocolError("missing required 'max_priority_fee'", { instance: message });
        if (!message.hasOwnProperty("gas_limit"))
            throw $util.ProtocolError("missing required 'gas_limit'", { instance: message });
        if (!message.hasOwnProperty("value"))
            throw $util.ProtocolError("missing required 'value'", { instance: message });
        if (!message.hasOwnProperty("data_length"))
            throw $util.ProtocolError("missing required 'data_length'", { instance: message });
        if (!message.hasOwnProperty("chain_id"))
            throw $util.ProtocolError("missing required 'chain_id'", { instance: message });
        return message;
    };

    EthereumSignTxEIP1559.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumSignTxEIP1559.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!(message.nonce && typeof message.nonce.length === "number" || $util.isString(message.nonce)))
            return "nonce: buffer expected";
        if (!(message.max_gas_fee && typeof message.max_gas_fee.length === "number" || $util.isString(message.max_gas_fee)))
            return "max_gas_fee: buffer expected";
        if (!(message.max_priority_fee && typeof message.max_priority_fee.length === "number" || $util.isString(message.max_priority_fee)))
            return "max_priority_fee: buffer expected";
        if (!(message.gas_limit && typeof message.gas_limit.length === "number" || $util.isString(message.gas_limit)))
            return "gas_limit: buffer expected";
        if (message.to != null && message.hasOwnProperty("to"))
            if (!$util.isString(message.to))
                return "to: string expected";
        if (!(message.value && typeof message.value.length === "number" || $util.isString(message.value)))
            return "value: buffer expected";
        if (message.data_initial_chunk != null && message.hasOwnProperty("data_initial_chunk"))
            if (!(message.data_initial_chunk && typeof message.data_initial_chunk.length === "number" || $util.isString(message.data_initial_chunk)))
                return "data_initial_chunk: buffer expected";
        if (!$util.isInteger(message.data_length))
            return "data_length: integer expected";
        if (!$util.isInteger(message.chain_id) && !(message.chain_id && $util.isInteger(message.chain_id.low) && $util.isInteger(message.chain_id.high)))
            return "chain_id: integer|Long expected";
        if (message.access_list != null && message.hasOwnProperty("access_list")) {
            if (!Array.isArray(message.access_list))
                return "access_list: array expected";
            for (var i = 0; i < message.access_list.length; ++i) {
                var error = $root.EthereumSignTxEIP1559.EthereumAccessList.verify(message.access_list[i]);
                if (error)
                    return "access_list." + error;
            }
        }
        return null;
    };

    EthereumSignTxEIP1559.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumSignTxEIP1559)
            return object;
        var message = new $root.EthereumSignTxEIP1559();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".EthereumSignTxEIP1559.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.nonce != null)
            if (typeof object.nonce === "string")
                $util.base64.decode(object.nonce, message.nonce = $util.newBuffer($util.base64.length(object.nonce)), 0);
            else if (object.nonce.length)
                message.nonce = object.nonce;
        if (object.max_gas_fee != null)
            if (typeof object.max_gas_fee === "string")
                $util.base64.decode(object.max_gas_fee, message.max_gas_fee = $util.newBuffer($util.base64.length(object.max_gas_fee)), 0);
            else if (object.max_gas_fee.length)
                message.max_gas_fee = object.max_gas_fee;
        if (object.max_priority_fee != null)
            if (typeof object.max_priority_fee === "string")
                $util.base64.decode(object.max_priority_fee, message.max_priority_fee = $util.newBuffer($util.base64.length(object.max_priority_fee)), 0);
            else if (object.max_priority_fee.length)
                message.max_priority_fee = object.max_priority_fee;
        if (object.gas_limit != null)
            if (typeof object.gas_limit === "string")
                $util.base64.decode(object.gas_limit, message.gas_limit = $util.newBuffer($util.base64.length(object.gas_limit)), 0);
            else if (object.gas_limit.length)
                message.gas_limit = object.gas_limit;
        if (object.to != null)
            message.to = String(object.to);
        if (object.value != null)
            if (typeof object.value === "string")
                $util.base64.decode(object.value, message.value = $util.newBuffer($util.base64.length(object.value)), 0);
            else if (object.value.length)
                message.value = object.value;
        if (object.data_initial_chunk != null)
            if (typeof object.data_initial_chunk === "string")
                $util.base64.decode(object.data_initial_chunk, message.data_initial_chunk = $util.newBuffer($util.base64.length(object.data_initial_chunk)), 0);
            else if (object.data_initial_chunk.length)
                message.data_initial_chunk = object.data_initial_chunk;
        if (object.data_length != null)
            message.data_length = object.data_length >>> 0;
        if (object.chain_id != null)
            if ($util.Long)
                (message.chain_id = $util.Long.fromValue(object.chain_id)).unsigned = true;
            else if (typeof object.chain_id === "string")
                message.chain_id = parseInt(object.chain_id, 10);
            else if (typeof object.chain_id === "number")
                message.chain_id = object.chain_id;
            else if (typeof object.chain_id === "object")
                message.chain_id = new $util.LongBits(object.chain_id.low >>> 0, object.chain_id.high >>> 0).toNumber(true);
        if (object.access_list) {
            if (!Array.isArray(object.access_list))
                throw TypeError(".EthereumSignTxEIP1559.access_list: array expected");
            message.access_list = [];
            for (var i = 0; i < object.access_list.length; ++i) {
                if (typeof object.access_list[i] !== "object")
                    throw TypeError(".EthereumSignTxEIP1559.access_list: object expected");
                message.access_list[i] = $root.EthereumSignTxEIP1559.EthereumAccessList.fromObject(object.access_list[i]);
            }
        }
        return message;
    };

    EthereumSignTxEIP1559.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults) {
            object.address_n = [];
            object.access_list = [];
        }
        if (options.defaults) {
            if (options.bytes === String)
                object.nonce = "";
            else {
                object.nonce = [];
                if (options.bytes !== Array)
                    object.nonce = $util.newBuffer(object.nonce);
            }
            if (options.bytes === String)
                object.max_gas_fee = "";
            else {
                object.max_gas_fee = [];
                if (options.bytes !== Array)
                    object.max_gas_fee = $util.newBuffer(object.max_gas_fee);
            }
            if (options.bytes === String)
                object.max_priority_fee = "";
            else {
                object.max_priority_fee = [];
                if (options.bytes !== Array)
                    object.max_priority_fee = $util.newBuffer(object.max_priority_fee);
            }
            if (options.bytes === String)
                object.gas_limit = "";
            else {
                object.gas_limit = [];
                if (options.bytes !== Array)
                    object.gas_limit = $util.newBuffer(object.gas_limit);
            }
            object.to = "";
            if (options.bytes === String)
                object.value = "";
            else {
                object.value = [];
                if (options.bytes !== Array)
                    object.value = $util.newBuffer(object.value);
            }
            if (options.bytes === String)
                object.data_initial_chunk = "";
            else {
                object.data_initial_chunk = [];
                if (options.bytes !== Array)
                    object.data_initial_chunk = $util.newBuffer(object.data_initial_chunk);
            }
            object.data_length = 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.chain_id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.chain_id = options.longs === String ? "0" : 0;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.nonce != null && message.hasOwnProperty("nonce"))
            object.nonce = options.bytes === String ? $util.base64.encode(message.nonce, 0, message.nonce.length) : options.bytes === Array ? Array.prototype.slice.call(message.nonce) : message.nonce;
        if (message.max_gas_fee != null && message.hasOwnProperty("max_gas_fee"))
            object.max_gas_fee = options.bytes === String ? $util.base64.encode(message.max_gas_fee, 0, message.max_gas_fee.length) : options.bytes === Array ? Array.prototype.slice.call(message.max_gas_fee) : message.max_gas_fee;
        if (message.max_priority_fee != null && message.hasOwnProperty("max_priority_fee"))
            object.max_priority_fee = options.bytes === String ? $util.base64.encode(message.max_priority_fee, 0, message.max_priority_fee.length) : options.bytes === Array ? Array.prototype.slice.call(message.max_priority_fee) : message.max_priority_fee;
        if (message.gas_limit != null && message.hasOwnProperty("gas_limit"))
            object.gas_limit = options.bytes === String ? $util.base64.encode(message.gas_limit, 0, message.gas_limit.length) : options.bytes === Array ? Array.prototype.slice.call(message.gas_limit) : message.gas_limit;
        if (message.to != null && message.hasOwnProperty("to"))
            object.to = message.to;
        if (message.value != null && message.hasOwnProperty("value"))
            object.value = options.bytes === String ? $util.base64.encode(message.value, 0, message.value.length) : options.bytes === Array ? Array.prototype.slice.call(message.value) : message.value;
        if (message.data_initial_chunk != null && message.hasOwnProperty("data_initial_chunk"))
            object.data_initial_chunk = options.bytes === String ? $util.base64.encode(message.data_initial_chunk, 0, message.data_initial_chunk.length) : options.bytes === Array ? Array.prototype.slice.call(message.data_initial_chunk) : message.data_initial_chunk;
        if (message.data_length != null && message.hasOwnProperty("data_length"))
            object.data_length = message.data_length;
        if (message.chain_id != null && message.hasOwnProperty("chain_id"))
            if (typeof message.chain_id === "number")
                object.chain_id = options.longs === String ? String(message.chain_id) : message.chain_id;
            else
                object.chain_id = options.longs === String ? $util.Long.prototype.toString.call(message.chain_id) : options.longs === Number ? new $util.LongBits(message.chain_id.low >>> 0, message.chain_id.high >>> 0).toNumber(true) : message.chain_id;
        if (message.access_list && message.access_list.length) {
            object.access_list = [];
            for (var j = 0; j < message.access_list.length; ++j)
                object.access_list[j] = $root.EthereumSignTxEIP1559.EthereumAccessList.toObject(message.access_list[j], options);
        }
        return object;
    };

    EthereumSignTxEIP1559.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    EthereumSignTxEIP1559.EthereumAccessList = (function() {

        function EthereumAccessList(properties) {
            this.storage_keys = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        EthereumAccessList.prototype.address = "";
        EthereumAccessList.prototype.storage_keys = $util.emptyArray;

        EthereumAccessList.create = function create(properties) {
            return new EthereumAccessList(properties);
        };

        EthereumAccessList.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(10).string(message.address);
            if (message.storage_keys != null && message.storage_keys.length)
                for (var i = 0; i < message.storage_keys.length; ++i)
                    writer.uint32(18).bytes(message.storage_keys[i]);
            return writer;
        };

        EthereumAccessList.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        EthereumAccessList.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumSignTxEIP1559.EthereumAccessList();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    if (!(message.storage_keys && message.storage_keys.length))
                        message.storage_keys = [];
                    message.storage_keys.push(reader.bytes());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("address"))
                throw $util.ProtocolError("missing required 'address'", { instance: message });
            return message;
        };

        EthereumAccessList.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        EthereumAccessList.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isString(message.address))
                return "address: string expected";
            if (message.storage_keys != null && message.hasOwnProperty("storage_keys")) {
                if (!Array.isArray(message.storage_keys))
                    return "storage_keys: array expected";
                for (var i = 0; i < message.storage_keys.length; ++i)
                    if (!(message.storage_keys[i] && typeof message.storage_keys[i].length === "number" || $util.isString(message.storage_keys[i])))
                        return "storage_keys: buffer[] expected";
            }
            return null;
        };

        EthereumAccessList.fromObject = function fromObject(object) {
            if (object instanceof $root.EthereumSignTxEIP1559.EthereumAccessList)
                return object;
            var message = new $root.EthereumSignTxEIP1559.EthereumAccessList();
            if (object.address != null)
                message.address = String(object.address);
            if (object.storage_keys) {
                if (!Array.isArray(object.storage_keys))
                    throw TypeError(".EthereumSignTxEIP1559.EthereumAccessList.storage_keys: array expected");
                message.storage_keys = [];
                for (var i = 0; i < object.storage_keys.length; ++i)
                    if (typeof object.storage_keys[i] === "string")
                        $util.base64.decode(object.storage_keys[i], message.storage_keys[i] = $util.newBuffer($util.base64.length(object.storage_keys[i])), 0);
                    else if (object.storage_keys[i].length)
                        message.storage_keys[i] = object.storage_keys[i];
            }
            return message;
        };

        EthereumAccessList.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.storage_keys = [];
            if (options.defaults)
                object.address = "";
            if (message.address != null && message.hasOwnProperty("address"))
                object.address = message.address;
            if (message.storage_keys && message.storage_keys.length) {
                object.storage_keys = [];
                for (var j = 0; j < message.storage_keys.length; ++j)
                    object.storage_keys[j] = options.bytes === String ? $util.base64.encode(message.storage_keys[j], 0, message.storage_keys[j].length) : options.bytes === Array ? Array.prototype.slice.call(message.storage_keys[j]) : message.storage_keys[j];
            }
            return object;
        };

        EthereumAccessList.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EthereumAccessList;
    })();

    return EthereumSignTxEIP1559;
})();

$root.EthereumTxRequest = (function() {

    function EthereumTxRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumTxRequest.prototype.data_length = 0;
    EthereumTxRequest.prototype.signature_v = 0;
    EthereumTxRequest.prototype.signature_r = $util.newBuffer([]);
    EthereumTxRequest.prototype.signature_s = $util.newBuffer([]);

    EthereumTxRequest.create = function create(properties) {
        return new EthereumTxRequest(properties);
    };

    EthereumTxRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.data_length != null && Object.hasOwnProperty.call(message, "data_length"))
            writer.uint32(8).uint32(message.data_length);
        if (message.signature_v != null && Object.hasOwnProperty.call(message, "signature_v"))
            writer.uint32(16).uint32(message.signature_v);
        if (message.signature_r != null && Object.hasOwnProperty.call(message, "signature_r"))
            writer.uint32(26).bytes(message.signature_r);
        if (message.signature_s != null && Object.hasOwnProperty.call(message, "signature_s"))
            writer.uint32(34).bytes(message.signature_s);
        return writer;
    };

    EthereumTxRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumTxRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumTxRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.data_length = reader.uint32();
                break;
            case 2:
                message.signature_v = reader.uint32();
                break;
            case 3:
                message.signature_r = reader.bytes();
                break;
            case 4:
                message.signature_s = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    EthereumTxRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumTxRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.data_length != null && message.hasOwnProperty("data_length"))
            if (!$util.isInteger(message.data_length))
                return "data_length: integer expected";
        if (message.signature_v != null && message.hasOwnProperty("signature_v"))
            if (!$util.isInteger(message.signature_v))
                return "signature_v: integer expected";
        if (message.signature_r != null && message.hasOwnProperty("signature_r"))
            if (!(message.signature_r && typeof message.signature_r.length === "number" || $util.isString(message.signature_r)))
                return "signature_r: buffer expected";
        if (message.signature_s != null && message.hasOwnProperty("signature_s"))
            if (!(message.signature_s && typeof message.signature_s.length === "number" || $util.isString(message.signature_s)))
                return "signature_s: buffer expected";
        return null;
    };

    EthereumTxRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumTxRequest)
            return object;
        var message = new $root.EthereumTxRequest();
        if (object.data_length != null)
            message.data_length = object.data_length >>> 0;
        if (object.signature_v != null)
            message.signature_v = object.signature_v >>> 0;
        if (object.signature_r != null)
            if (typeof object.signature_r === "string")
                $util.base64.decode(object.signature_r, message.signature_r = $util.newBuffer($util.base64.length(object.signature_r)), 0);
            else if (object.signature_r.length)
                message.signature_r = object.signature_r;
        if (object.signature_s != null)
            if (typeof object.signature_s === "string")
                $util.base64.decode(object.signature_s, message.signature_s = $util.newBuffer($util.base64.length(object.signature_s)), 0);
            else if (object.signature_s.length)
                message.signature_s = object.signature_s;
        return message;
    };

    EthereumTxRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.data_length = 0;
            object.signature_v = 0;
            if (options.bytes === String)
                object.signature_r = "";
            else {
                object.signature_r = [];
                if (options.bytes !== Array)
                    object.signature_r = $util.newBuffer(object.signature_r);
            }
            if (options.bytes === String)
                object.signature_s = "";
            else {
                object.signature_s = [];
                if (options.bytes !== Array)
                    object.signature_s = $util.newBuffer(object.signature_s);
            }
        }
        if (message.data_length != null && message.hasOwnProperty("data_length"))
            object.data_length = message.data_length;
        if (message.signature_v != null && message.hasOwnProperty("signature_v"))
            object.signature_v = message.signature_v;
        if (message.signature_r != null && message.hasOwnProperty("signature_r"))
            object.signature_r = options.bytes === String ? $util.base64.encode(message.signature_r, 0, message.signature_r.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature_r) : message.signature_r;
        if (message.signature_s != null && message.hasOwnProperty("signature_s"))
            object.signature_s = options.bytes === String ? $util.base64.encode(message.signature_s, 0, message.signature_s.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature_s) : message.signature_s;
        return object;
    };

    EthereumTxRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumTxRequest;
})();

$root.EthereumTxAck = (function() {

    function EthereumTxAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumTxAck.prototype.data_chunk = $util.newBuffer([]);

    EthereumTxAck.create = function create(properties) {
        return new EthereumTxAck(properties);
    };

    EthereumTxAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.data_chunk);
        return writer;
    };

    EthereumTxAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumTxAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumTxAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.data_chunk = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("data_chunk"))
            throw $util.ProtocolError("missing required 'data_chunk'", { instance: message });
        return message;
    };

    EthereumTxAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumTxAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.data_chunk && typeof message.data_chunk.length === "number" || $util.isString(message.data_chunk)))
            return "data_chunk: buffer expected";
        return null;
    };

    EthereumTxAck.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumTxAck)
            return object;
        var message = new $root.EthereumTxAck();
        if (object.data_chunk != null)
            if (typeof object.data_chunk === "string")
                $util.base64.decode(object.data_chunk, message.data_chunk = $util.newBuffer($util.base64.length(object.data_chunk)), 0);
            else if (object.data_chunk.length)
                message.data_chunk = object.data_chunk;
        return message;
    };

    EthereumTxAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.data_chunk = "";
            else {
                object.data_chunk = [];
                if (options.bytes !== Array)
                    object.data_chunk = $util.newBuffer(object.data_chunk);
            }
        if (message.data_chunk != null && message.hasOwnProperty("data_chunk"))
            object.data_chunk = options.bytes === String ? $util.base64.encode(message.data_chunk, 0, message.data_chunk.length) : options.bytes === Array ? Array.prototype.slice.call(message.data_chunk) : message.data_chunk;
        return object;
    };

    EthereumTxAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumTxAck;
})();

$root.EthereumSignMessage = (function() {

    function EthereumSignMessage(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumSignMessage.prototype.address_n = $util.emptyArray;
    EthereumSignMessage.prototype.message = $util.newBuffer([]);
    EthereumSignMessage.prototype.chain_id = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    EthereumSignMessage.create = function create(properties) {
        return new EthereumSignMessage(properties);
    };

    EthereumSignMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).bytes(message.message);
        if (message.chain_id != null && Object.hasOwnProperty.call(message, "chain_id"))
            writer.uint32(24).uint64(message.chain_id);
        return writer;
    };

    EthereumSignMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumSignMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumSignMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.message = reader.bytes();
                break;
            case 3:
                message.chain_id = reader.uint64();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("message"))
            throw $util.ProtocolError("missing required 'message'", { instance: message });
        return message;
    };

    EthereumSignMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumSignMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!(message.message && typeof message.message.length === "number" || $util.isString(message.message)))
            return "message: buffer expected";
        if (message.chain_id != null && message.hasOwnProperty("chain_id"))
            if (!$util.isInteger(message.chain_id) && !(message.chain_id && $util.isInteger(message.chain_id.low) && $util.isInteger(message.chain_id.high)))
                return "chain_id: integer|Long expected";
        return null;
    };

    EthereumSignMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumSignMessage)
            return object;
        var message = new $root.EthereumSignMessage();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".EthereumSignMessage.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.message != null)
            if (typeof object.message === "string")
                $util.base64.decode(object.message, message.message = $util.newBuffer($util.base64.length(object.message)), 0);
            else if (object.message.length)
                message.message = object.message;
        if (object.chain_id != null)
            if ($util.Long)
                (message.chain_id = $util.Long.fromValue(object.chain_id)).unsigned = true;
            else if (typeof object.chain_id === "string")
                message.chain_id = parseInt(object.chain_id, 10);
            else if (typeof object.chain_id === "number")
                message.chain_id = object.chain_id;
            else if (typeof object.chain_id === "object")
                message.chain_id = new $util.LongBits(object.chain_id.low >>> 0, object.chain_id.high >>> 0).toNumber(true);
        return message;
    };

    EthereumSignMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            if (options.bytes === String)
                object.message = "";
            else {
                object.message = [];
                if (options.bytes !== Array)
                    object.message = $util.newBuffer(object.message);
            }
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.chain_id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.chain_id = options.longs === String ? "0" : 0;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.message != null && message.hasOwnProperty("message"))
            object.message = options.bytes === String ? $util.base64.encode(message.message, 0, message.message.length) : options.bytes === Array ? Array.prototype.slice.call(message.message) : message.message;
        if (message.chain_id != null && message.hasOwnProperty("chain_id"))
            if (typeof message.chain_id === "number")
                object.chain_id = options.longs === String ? String(message.chain_id) : message.chain_id;
            else
                object.chain_id = options.longs === String ? $util.Long.prototype.toString.call(message.chain_id) : options.longs === Number ? new $util.LongBits(message.chain_id.low >>> 0, message.chain_id.high >>> 0).toNumber(true) : message.chain_id;
        return object;
    };

    EthereumSignMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumSignMessage;
})();

$root.EthereumMessageSignature = (function() {

    function EthereumMessageSignature(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumMessageSignature.prototype.signature = $util.newBuffer([]);
    EthereumMessageSignature.prototype.address = "";

    EthereumMessageSignature.create = function create(properties) {
        return new EthereumMessageSignature(properties);
    };

    EthereumMessageSignature.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(18).bytes(message.signature);
        writer.uint32(26).string(message.address);
        return writer;
    };

    EthereumMessageSignature.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumMessageSignature.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumMessageSignature();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 2:
                message.signature = reader.bytes();
                break;
            case 3:
                message.address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        if (!message.hasOwnProperty("address"))
            throw $util.ProtocolError("missing required 'address'", { instance: message });
        return message;
    };

    EthereumMessageSignature.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumMessageSignature.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        if (!$util.isString(message.address))
            return "address: string expected";
        return null;
    };

    EthereumMessageSignature.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumMessageSignature)
            return object;
        var message = new $root.EthereumMessageSignature();
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        if (object.address != null)
            message.address = String(object.address);
        return message;
    };

    EthereumMessageSignature.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
            object.address = "";
        }
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    EthereumMessageSignature.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumMessageSignature;
})();

$root.EthereumVerifyMessage = (function() {

    function EthereumVerifyMessage(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumVerifyMessage.prototype.signature = $util.newBuffer([]);
    EthereumVerifyMessage.prototype.message = $util.newBuffer([]);
    EthereumVerifyMessage.prototype.address = "";
    EthereumVerifyMessage.prototype.chain_id = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    EthereumVerifyMessage.create = function create(properties) {
        return new EthereumVerifyMessage(properties);
    };

    EthereumVerifyMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(18).bytes(message.signature);
        writer.uint32(26).bytes(message.message);
        writer.uint32(34).string(message.address);
        if (message.chain_id != null && Object.hasOwnProperty.call(message, "chain_id"))
            writer.uint32(40).uint64(message.chain_id);
        return writer;
    };

    EthereumVerifyMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumVerifyMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumVerifyMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 2:
                message.signature = reader.bytes();
                break;
            case 3:
                message.message = reader.bytes();
                break;
            case 4:
                message.address = reader.string();
                break;
            case 5:
                message.chain_id = reader.uint64();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        if (!message.hasOwnProperty("message"))
            throw $util.ProtocolError("missing required 'message'", { instance: message });
        if (!message.hasOwnProperty("address"))
            throw $util.ProtocolError("missing required 'address'", { instance: message });
        return message;
    };

    EthereumVerifyMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumVerifyMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        if (!(message.message && typeof message.message.length === "number" || $util.isString(message.message)))
            return "message: buffer expected";
        if (!$util.isString(message.address))
            return "address: string expected";
        if (message.chain_id != null && message.hasOwnProperty("chain_id"))
            if (!$util.isInteger(message.chain_id) && !(message.chain_id && $util.isInteger(message.chain_id.low) && $util.isInteger(message.chain_id.high)))
                return "chain_id: integer|Long expected";
        return null;
    };

    EthereumVerifyMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumVerifyMessage)
            return object;
        var message = new $root.EthereumVerifyMessage();
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        if (object.message != null)
            if (typeof object.message === "string")
                $util.base64.decode(object.message, message.message = $util.newBuffer($util.base64.length(object.message)), 0);
            else if (object.message.length)
                message.message = object.message;
        if (object.address != null)
            message.address = String(object.address);
        if (object.chain_id != null)
            if ($util.Long)
                (message.chain_id = $util.Long.fromValue(object.chain_id)).unsigned = true;
            else if (typeof object.chain_id === "string")
                message.chain_id = parseInt(object.chain_id, 10);
            else if (typeof object.chain_id === "number")
                message.chain_id = object.chain_id;
            else if (typeof object.chain_id === "object")
                message.chain_id = new $util.LongBits(object.chain_id.low >>> 0, object.chain_id.high >>> 0).toNumber(true);
        return message;
    };

    EthereumVerifyMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
            if (options.bytes === String)
                object.message = "";
            else {
                object.message = [];
                if (options.bytes !== Array)
                    object.message = $util.newBuffer(object.message);
            }
            object.address = "";
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.chain_id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.chain_id = options.longs === String ? "0" : 0;
        }
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        if (message.message != null && message.hasOwnProperty("message"))
            object.message = options.bytes === String ? $util.base64.encode(message.message, 0, message.message.length) : options.bytes === Array ? Array.prototype.slice.call(message.message) : message.message;
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        if (message.chain_id != null && message.hasOwnProperty("chain_id"))
            if (typeof message.chain_id === "number")
                object.chain_id = options.longs === String ? String(message.chain_id) : message.chain_id;
            else
                object.chain_id = options.longs === String ? $util.Long.prototype.toString.call(message.chain_id) : options.longs === Number ? new $util.LongBits(message.chain_id.low >>> 0, message.chain_id.high >>> 0).toNumber(true) : message.chain_id;
        return object;
    };

    EthereumVerifyMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumVerifyMessage;
})();

$root.EthereumSignMessageEIP712 = (function() {

    function EthereumSignMessageEIP712(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumSignMessageEIP712.prototype.address_n = $util.emptyArray;
    EthereumSignMessageEIP712.prototype.domain_hash = $util.newBuffer([]);
    EthereumSignMessageEIP712.prototype.message_hash = $util.newBuffer([]);

    EthereumSignMessageEIP712.create = function create(properties) {
        return new EthereumSignMessageEIP712(properties);
    };

    EthereumSignMessageEIP712.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.domain_hash != null && Object.hasOwnProperty.call(message, "domain_hash"))
            writer.uint32(18).bytes(message.domain_hash);
        if (message.message_hash != null && Object.hasOwnProperty.call(message, "message_hash"))
            writer.uint32(26).bytes(message.message_hash);
        return writer;
    };

    EthereumSignMessageEIP712.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumSignMessageEIP712.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumSignMessageEIP712();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.domain_hash = reader.bytes();
                break;
            case 3:
                message.message_hash = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    EthereumSignMessageEIP712.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumSignMessageEIP712.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.domain_hash != null && message.hasOwnProperty("domain_hash"))
            if (!(message.domain_hash && typeof message.domain_hash.length === "number" || $util.isString(message.domain_hash)))
                return "domain_hash: buffer expected";
        if (message.message_hash != null && message.hasOwnProperty("message_hash"))
            if (!(message.message_hash && typeof message.message_hash.length === "number" || $util.isString(message.message_hash)))
                return "message_hash: buffer expected";
        return null;
    };

    EthereumSignMessageEIP712.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumSignMessageEIP712)
            return object;
        var message = new $root.EthereumSignMessageEIP712();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".EthereumSignMessageEIP712.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.domain_hash != null)
            if (typeof object.domain_hash === "string")
                $util.base64.decode(object.domain_hash, message.domain_hash = $util.newBuffer($util.base64.length(object.domain_hash)), 0);
            else if (object.domain_hash.length)
                message.domain_hash = object.domain_hash;
        if (object.message_hash != null)
            if (typeof object.message_hash === "string")
                $util.base64.decode(object.message_hash, message.message_hash = $util.newBuffer($util.base64.length(object.message_hash)), 0);
            else if (object.message_hash.length)
                message.message_hash = object.message_hash;
        return message;
    };

    EthereumSignMessageEIP712.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            if (options.bytes === String)
                object.domain_hash = "";
            else {
                object.domain_hash = [];
                if (options.bytes !== Array)
                    object.domain_hash = $util.newBuffer(object.domain_hash);
            }
            if (options.bytes === String)
                object.message_hash = "";
            else {
                object.message_hash = [];
                if (options.bytes !== Array)
                    object.message_hash = $util.newBuffer(object.message_hash);
            }
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.domain_hash != null && message.hasOwnProperty("domain_hash"))
            object.domain_hash = options.bytes === String ? $util.base64.encode(message.domain_hash, 0, message.domain_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.domain_hash) : message.domain_hash;
        if (message.message_hash != null && message.hasOwnProperty("message_hash"))
            object.message_hash = options.bytes === String ? $util.base64.encode(message.message_hash, 0, message.message_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.message_hash) : message.message_hash;
        return object;
    };

    EthereumSignMessageEIP712.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumSignMessageEIP712;
})();

$root.EthereumSignTypedHash = (function() {

    function EthereumSignTypedHash(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumSignTypedHash.prototype.address_n = $util.emptyArray;
    EthereumSignTypedHash.prototype.domain_separator_hash = $util.newBuffer([]);
    EthereumSignTypedHash.prototype.message_hash = $util.newBuffer([]);
    EthereumSignTypedHash.prototype.chain_id = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    EthereumSignTypedHash.create = function create(properties) {
        return new EthereumSignTypedHash(properties);
    };

    EthereumSignTypedHash.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).bytes(message.domain_separator_hash);
        if (message.message_hash != null && Object.hasOwnProperty.call(message, "message_hash"))
            writer.uint32(26).bytes(message.message_hash);
        if (message.chain_id != null && Object.hasOwnProperty.call(message, "chain_id"))
            writer.uint32(32).uint64(message.chain_id);
        return writer;
    };

    EthereumSignTypedHash.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumSignTypedHash.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumSignTypedHash();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.domain_separator_hash = reader.bytes();
                break;
            case 3:
                message.message_hash = reader.bytes();
                break;
            case 4:
                message.chain_id = reader.uint64();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("domain_separator_hash"))
            throw $util.ProtocolError("missing required 'domain_separator_hash'", { instance: message });
        return message;
    };

    EthereumSignTypedHash.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumSignTypedHash.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!(message.domain_separator_hash && typeof message.domain_separator_hash.length === "number" || $util.isString(message.domain_separator_hash)))
            return "domain_separator_hash: buffer expected";
        if (message.message_hash != null && message.hasOwnProperty("message_hash"))
            if (!(message.message_hash && typeof message.message_hash.length === "number" || $util.isString(message.message_hash)))
                return "message_hash: buffer expected";
        if (message.chain_id != null && message.hasOwnProperty("chain_id"))
            if (!$util.isInteger(message.chain_id) && !(message.chain_id && $util.isInteger(message.chain_id.low) && $util.isInteger(message.chain_id.high)))
                return "chain_id: integer|Long expected";
        return null;
    };

    EthereumSignTypedHash.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumSignTypedHash)
            return object;
        var message = new $root.EthereumSignTypedHash();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".EthereumSignTypedHash.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.domain_separator_hash != null)
            if (typeof object.domain_separator_hash === "string")
                $util.base64.decode(object.domain_separator_hash, message.domain_separator_hash = $util.newBuffer($util.base64.length(object.domain_separator_hash)), 0);
            else if (object.domain_separator_hash.length)
                message.domain_separator_hash = object.domain_separator_hash;
        if (object.message_hash != null)
            if (typeof object.message_hash === "string")
                $util.base64.decode(object.message_hash, message.message_hash = $util.newBuffer($util.base64.length(object.message_hash)), 0);
            else if (object.message_hash.length)
                message.message_hash = object.message_hash;
        if (object.chain_id != null)
            if ($util.Long)
                (message.chain_id = $util.Long.fromValue(object.chain_id)).unsigned = true;
            else if (typeof object.chain_id === "string")
                message.chain_id = parseInt(object.chain_id, 10);
            else if (typeof object.chain_id === "number")
                message.chain_id = object.chain_id;
            else if (typeof object.chain_id === "object")
                message.chain_id = new $util.LongBits(object.chain_id.low >>> 0, object.chain_id.high >>> 0).toNumber(true);
        return message;
    };

    EthereumSignTypedHash.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            if (options.bytes === String)
                object.domain_separator_hash = "";
            else {
                object.domain_separator_hash = [];
                if (options.bytes !== Array)
                    object.domain_separator_hash = $util.newBuffer(object.domain_separator_hash);
            }
            if (options.bytes === String)
                object.message_hash = "";
            else {
                object.message_hash = [];
                if (options.bytes !== Array)
                    object.message_hash = $util.newBuffer(object.message_hash);
            }
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.chain_id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.chain_id = options.longs === String ? "0" : 0;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.domain_separator_hash != null && message.hasOwnProperty("domain_separator_hash"))
            object.domain_separator_hash = options.bytes === String ? $util.base64.encode(message.domain_separator_hash, 0, message.domain_separator_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.domain_separator_hash) : message.domain_separator_hash;
        if (message.message_hash != null && message.hasOwnProperty("message_hash"))
            object.message_hash = options.bytes === String ? $util.base64.encode(message.message_hash, 0, message.message_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.message_hash) : message.message_hash;
        if (message.chain_id != null && message.hasOwnProperty("chain_id"))
            if (typeof message.chain_id === "number")
                object.chain_id = options.longs === String ? String(message.chain_id) : message.chain_id;
            else
                object.chain_id = options.longs === String ? $util.Long.prototype.toString.call(message.chain_id) : options.longs === Number ? new $util.LongBits(message.chain_id.low >>> 0, message.chain_id.high >>> 0).toNumber(true) : message.chain_id;
        return object;
    };

    EthereumSignTypedHash.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumSignTypedHash;
})();

$root.EthereumTypedDataSignature = (function() {

    function EthereumTypedDataSignature(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumTypedDataSignature.prototype.signature = $util.newBuffer([]);
    EthereumTypedDataSignature.prototype.address = "";

    EthereumTypedDataSignature.create = function create(properties) {
        return new EthereumTypedDataSignature(properties);
    };

    EthereumTypedDataSignature.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.signature);
        writer.uint32(18).string(message.address);
        return writer;
    };

    EthereumTypedDataSignature.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumTypedDataSignature.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumTypedDataSignature();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.signature = reader.bytes();
                break;
            case 2:
                message.address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        if (!message.hasOwnProperty("address"))
            throw $util.ProtocolError("missing required 'address'", { instance: message });
        return message;
    };

    EthereumTypedDataSignature.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumTypedDataSignature.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        if (!$util.isString(message.address))
            return "address: string expected";
        return null;
    };

    EthereumTypedDataSignature.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumTypedDataSignature)
            return object;
        var message = new $root.EthereumTypedDataSignature();
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        if (object.address != null)
            message.address = String(object.address);
        return message;
    };

    EthereumTypedDataSignature.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
            object.address = "";
        }
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    EthereumTypedDataSignature.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumTypedDataSignature;
})();

$root.FilecoinGetAddress = (function() {

    function FilecoinGetAddress(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    FilecoinGetAddress.prototype.address_n = $util.emptyArray;
    FilecoinGetAddress.prototype.show_display = false;
    FilecoinGetAddress.prototype.testnet = false;

    FilecoinGetAddress.create = function create(properties) {
        return new FilecoinGetAddress(properties);
    };

    FilecoinGetAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(16).bool(message.show_display);
        if (message.testnet != null && Object.hasOwnProperty.call(message, "testnet"))
            writer.uint32(24).bool(message.testnet);
        return writer;
    };

    FilecoinGetAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    FilecoinGetAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.FilecoinGetAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.show_display = reader.bool();
                break;
            case 3:
                message.testnet = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    FilecoinGetAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    FilecoinGetAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        if (message.testnet != null && message.hasOwnProperty("testnet"))
            if (typeof message.testnet !== "boolean")
                return "testnet: boolean expected";
        return null;
    };

    FilecoinGetAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.FilecoinGetAddress)
            return object;
        var message = new $root.FilecoinGetAddress();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".FilecoinGetAddress.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        if (object.testnet != null)
            message.testnet = Boolean(object.testnet);
        return message;
    };

    FilecoinGetAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            object.show_display = false;
            object.testnet = false;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        if (message.testnet != null && message.hasOwnProperty("testnet"))
            object.testnet = message.testnet;
        return object;
    };

    FilecoinGetAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return FilecoinGetAddress;
})();

$root.FilecoinAddress = (function() {

    function FilecoinAddress(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    FilecoinAddress.prototype.address = "";

    FilecoinAddress.create = function create(properties) {
        return new FilecoinAddress(properties);
    };

    FilecoinAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address != null && Object.hasOwnProperty.call(message, "address"))
            writer.uint32(10).string(message.address);
        return writer;
    };

    FilecoinAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    FilecoinAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.FilecoinAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    FilecoinAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    FilecoinAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address != null && message.hasOwnProperty("address"))
            if (!$util.isString(message.address))
                return "address: string expected";
        return null;
    };

    FilecoinAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.FilecoinAddress)
            return object;
        var message = new $root.FilecoinAddress();
        if (object.address != null)
            message.address = String(object.address);
        return message;
    };

    FilecoinAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.address = "";
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    FilecoinAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return FilecoinAddress;
})();

$root.FilecoinSignTx = (function() {

    function FilecoinSignTx(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    FilecoinSignTx.prototype.address_n = $util.emptyArray;
    FilecoinSignTx.prototype.raw_tx = $util.newBuffer([]);
    FilecoinSignTx.prototype.testnet = false;

    FilecoinSignTx.create = function create(properties) {
        return new FilecoinSignTx(properties);
    };

    FilecoinSignTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).bytes(message.raw_tx);
        if (message.testnet != null && Object.hasOwnProperty.call(message, "testnet"))
            writer.uint32(24).bool(message.testnet);
        return writer;
    };

    FilecoinSignTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    FilecoinSignTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.FilecoinSignTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.raw_tx = reader.bytes();
                break;
            case 3:
                message.testnet = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("raw_tx"))
            throw $util.ProtocolError("missing required 'raw_tx'", { instance: message });
        return message;
    };

    FilecoinSignTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    FilecoinSignTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!(message.raw_tx && typeof message.raw_tx.length === "number" || $util.isString(message.raw_tx)))
            return "raw_tx: buffer expected";
        if (message.testnet != null && message.hasOwnProperty("testnet"))
            if (typeof message.testnet !== "boolean")
                return "testnet: boolean expected";
        return null;
    };

    FilecoinSignTx.fromObject = function fromObject(object) {
        if (object instanceof $root.FilecoinSignTx)
            return object;
        var message = new $root.FilecoinSignTx();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".FilecoinSignTx.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.raw_tx != null)
            if (typeof object.raw_tx === "string")
                $util.base64.decode(object.raw_tx, message.raw_tx = $util.newBuffer($util.base64.length(object.raw_tx)), 0);
            else if (object.raw_tx.length)
                message.raw_tx = object.raw_tx;
        if (object.testnet != null)
            message.testnet = Boolean(object.testnet);
        return message;
    };

    FilecoinSignTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            if (options.bytes === String)
                object.raw_tx = "";
            else {
                object.raw_tx = [];
                if (options.bytes !== Array)
                    object.raw_tx = $util.newBuffer(object.raw_tx);
            }
            object.testnet = false;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.raw_tx != null && message.hasOwnProperty("raw_tx"))
            object.raw_tx = options.bytes === String ? $util.base64.encode(message.raw_tx, 0, message.raw_tx.length) : options.bytes === Array ? Array.prototype.slice.call(message.raw_tx) : message.raw_tx;
        if (message.testnet != null && message.hasOwnProperty("testnet"))
            object.testnet = message.testnet;
        return object;
    };

    FilecoinSignTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return FilecoinSignTx;
})();

$root.FilecoinSignedTx = (function() {

    function FilecoinSignedTx(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    FilecoinSignedTx.prototype.signature = $util.newBuffer([]);

    FilecoinSignedTx.create = function create(properties) {
        return new FilecoinSignedTx(properties);
    };

    FilecoinSignedTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.signature);
        return writer;
    };

    FilecoinSignedTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    FilecoinSignedTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.FilecoinSignedTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.signature = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        return message;
    };

    FilecoinSignedTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    FilecoinSignedTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        return null;
    };

    FilecoinSignedTx.fromObject = function fromObject(object) {
        if (object instanceof $root.FilecoinSignedTx)
            return object;
        var message = new $root.FilecoinSignedTx();
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        return message;
    };

    FilecoinSignedTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        return object;
    };

    FilecoinSignedTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return FilecoinSignedTx;
})();

$root.KaspaGetAddress = (function() {

    function KaspaGetAddress(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    KaspaGetAddress.prototype.address_n = $util.emptyArray;
    KaspaGetAddress.prototype.show_display = false;
    KaspaGetAddress.prototype.prefix = "kaspa";
    KaspaGetAddress.prototype.scheme = "schnorr";

    KaspaGetAddress.create = function create(properties) {
        return new KaspaGetAddress(properties);
    };

    KaspaGetAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(16).bool(message.show_display);
        if (message.prefix != null && Object.hasOwnProperty.call(message, "prefix"))
            writer.uint32(26).string(message.prefix);
        if (message.scheme != null && Object.hasOwnProperty.call(message, "scheme"))
            writer.uint32(34).string(message.scheme);
        return writer;
    };

    KaspaGetAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    KaspaGetAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.KaspaGetAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.show_display = reader.bool();
                break;
            case 3:
                message.prefix = reader.string();
                break;
            case 4:
                message.scheme = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    KaspaGetAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    KaspaGetAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        if (message.prefix != null && message.hasOwnProperty("prefix"))
            if (!$util.isString(message.prefix))
                return "prefix: string expected";
        if (message.scheme != null && message.hasOwnProperty("scheme"))
            if (!$util.isString(message.scheme))
                return "scheme: string expected";
        return null;
    };

    KaspaGetAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.KaspaGetAddress)
            return object;
        var message = new $root.KaspaGetAddress();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".KaspaGetAddress.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        if (object.prefix != null)
            message.prefix = String(object.prefix);
        if (object.scheme != null)
            message.scheme = String(object.scheme);
        return message;
    };

    KaspaGetAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            object.show_display = false;
            object.prefix = "kaspa";
            object.scheme = "schnorr";
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        if (message.prefix != null && message.hasOwnProperty("prefix"))
            object.prefix = message.prefix;
        if (message.scheme != null && message.hasOwnProperty("scheme"))
            object.scheme = message.scheme;
        return object;
    };

    KaspaGetAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return KaspaGetAddress;
})();

$root.KaspaAddress = (function() {

    function KaspaAddress(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    KaspaAddress.prototype.address = "";

    KaspaAddress.create = function create(properties) {
        return new KaspaAddress(properties);
    };

    KaspaAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.address);
        return writer;
    };

    KaspaAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    KaspaAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.KaspaAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("address"))
            throw $util.ProtocolError("missing required 'address'", { instance: message });
        return message;
    };

    KaspaAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    KaspaAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.address))
            return "address: string expected";
        return null;
    };

    KaspaAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.KaspaAddress)
            return object;
        var message = new $root.KaspaAddress();
        if (object.address != null)
            message.address = String(object.address);
        return message;
    };

    KaspaAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.address = "";
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    KaspaAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return KaspaAddress;
})();

$root.KaspaSignTx = (function() {

    function KaspaSignTx(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    KaspaSignTx.prototype.address_n = $util.emptyArray;
    KaspaSignTx.prototype.raw_message = $util.newBuffer([]);
    KaspaSignTx.prototype.scheme = "schnorr";
    KaspaSignTx.prototype.prefix = "kaspa";
    KaspaSignTx.prototype.input_count = 1;

    KaspaSignTx.create = function create(properties) {
        return new KaspaSignTx(properties);
    };

    KaspaSignTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).bytes(message.raw_message);
        if (message.scheme != null && Object.hasOwnProperty.call(message, "scheme"))
            writer.uint32(26).string(message.scheme);
        if (message.prefix != null && Object.hasOwnProperty.call(message, "prefix"))
            writer.uint32(34).string(message.prefix);
        if (message.input_count != null && Object.hasOwnProperty.call(message, "input_count"))
            writer.uint32(40).uint32(message.input_count);
        return writer;
    };

    KaspaSignTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    KaspaSignTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.KaspaSignTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.raw_message = reader.bytes();
                break;
            case 3:
                message.scheme = reader.string();
                break;
            case 4:
                message.prefix = reader.string();
                break;
            case 5:
                message.input_count = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("raw_message"))
            throw $util.ProtocolError("missing required 'raw_message'", { instance: message });
        return message;
    };

    KaspaSignTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    KaspaSignTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!(message.raw_message && typeof message.raw_message.length === "number" || $util.isString(message.raw_message)))
            return "raw_message: buffer expected";
        if (message.scheme != null && message.hasOwnProperty("scheme"))
            if (!$util.isString(message.scheme))
                return "scheme: string expected";
        if (message.prefix != null && message.hasOwnProperty("prefix"))
            if (!$util.isString(message.prefix))
                return "prefix: string expected";
        if (message.input_count != null && message.hasOwnProperty("input_count"))
            if (!$util.isInteger(message.input_count))
                return "input_count: integer expected";
        return null;
    };

    KaspaSignTx.fromObject = function fromObject(object) {
        if (object instanceof $root.KaspaSignTx)
            return object;
        var message = new $root.KaspaSignTx();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".KaspaSignTx.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.raw_message != null)
            if (typeof object.raw_message === "string")
                $util.base64.decode(object.raw_message, message.raw_message = $util.newBuffer($util.base64.length(object.raw_message)), 0);
            else if (object.raw_message.length)
                message.raw_message = object.raw_message;
        if (object.scheme != null)
            message.scheme = String(object.scheme);
        if (object.prefix != null)
            message.prefix = String(object.prefix);
        if (object.input_count != null)
            message.input_count = object.input_count >>> 0;
        return message;
    };

    KaspaSignTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            if (options.bytes === String)
                object.raw_message = "";
            else {
                object.raw_message = [];
                if (options.bytes !== Array)
                    object.raw_message = $util.newBuffer(object.raw_message);
            }
            object.scheme = "schnorr";
            object.prefix = "kaspa";
            object.input_count = 1;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.raw_message != null && message.hasOwnProperty("raw_message"))
            object.raw_message = options.bytes === String ? $util.base64.encode(message.raw_message, 0, message.raw_message.length) : options.bytes === Array ? Array.prototype.slice.call(message.raw_message) : message.raw_message;
        if (message.scheme != null && message.hasOwnProperty("scheme"))
            object.scheme = message.scheme;
        if (message.prefix != null && message.hasOwnProperty("prefix"))
            object.prefix = message.prefix;
        if (message.input_count != null && message.hasOwnProperty("input_count"))
            object.input_count = message.input_count;
        return object;
    };

    KaspaSignTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return KaspaSignTx;
})();

$root.KaspaTxInputRequest = (function() {

    function KaspaTxInputRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    KaspaTxInputRequest.prototype.request_index = 0;
    KaspaTxInputRequest.prototype.signature = $util.newBuffer([]);

    KaspaTxInputRequest.create = function create(properties) {
        return new KaspaTxInputRequest(properties);
    };

    KaspaTxInputRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).uint32(message.request_index);
        if (message.signature != null && Object.hasOwnProperty.call(message, "signature"))
            writer.uint32(18).bytes(message.signature);
        return writer;
    };

    KaspaTxInputRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    KaspaTxInputRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.KaspaTxInputRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.request_index = reader.uint32();
                break;
            case 2:
                message.signature = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("request_index"))
            throw $util.ProtocolError("missing required 'request_index'", { instance: message });
        return message;
    };

    KaspaTxInputRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    KaspaTxInputRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isInteger(message.request_index))
            return "request_index: integer expected";
        if (message.signature != null && message.hasOwnProperty("signature"))
            if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
                return "signature: buffer expected";
        return null;
    };

    KaspaTxInputRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.KaspaTxInputRequest)
            return object;
        var message = new $root.KaspaTxInputRequest();
        if (object.request_index != null)
            message.request_index = object.request_index >>> 0;
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        return message;
    };

    KaspaTxInputRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.request_index = 0;
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
        }
        if (message.request_index != null && message.hasOwnProperty("request_index"))
            object.request_index = message.request_index;
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        return object;
    };

    KaspaTxInputRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return KaspaTxInputRequest;
})();

$root.KaspaTxInputAck = (function() {

    function KaspaTxInputAck(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    KaspaTxInputAck.prototype.address_n = $util.emptyArray;
    KaspaTxInputAck.prototype.raw_message = $util.newBuffer([]);

    KaspaTxInputAck.create = function create(properties) {
        return new KaspaTxInputAck(properties);
    };

    KaspaTxInputAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).bytes(message.raw_message);
        return writer;
    };

    KaspaTxInputAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    KaspaTxInputAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.KaspaTxInputAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.raw_message = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("raw_message"))
            throw $util.ProtocolError("missing required 'raw_message'", { instance: message });
        return message;
    };

    KaspaTxInputAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    KaspaTxInputAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!(message.raw_message && typeof message.raw_message.length === "number" || $util.isString(message.raw_message)))
            return "raw_message: buffer expected";
        return null;
    };

    KaspaTxInputAck.fromObject = function fromObject(object) {
        if (object instanceof $root.KaspaTxInputAck)
            return object;
        var message = new $root.KaspaTxInputAck();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".KaspaTxInputAck.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.raw_message != null)
            if (typeof object.raw_message === "string")
                $util.base64.decode(object.raw_message, message.raw_message = $util.newBuffer($util.base64.length(object.raw_message)), 0);
            else if (object.raw_message.length)
                message.raw_message = object.raw_message;
        return message;
    };

    KaspaTxInputAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            if (options.bytes === String)
                object.raw_message = "";
            else {
                object.raw_message = [];
                if (options.bytes !== Array)
                    object.raw_message = $util.newBuffer(object.raw_message);
            }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.raw_message != null && message.hasOwnProperty("raw_message"))
            object.raw_message = options.bytes === String ? $util.base64.encode(message.raw_message, 0, message.raw_message.length) : options.bytes === Array ? Array.prototype.slice.call(message.raw_message) : message.raw_message;
        return object;
    };

    KaspaTxInputAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return KaspaTxInputAck;
})();

$root.KaspaSignedTx = (function() {

    function KaspaSignedTx(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    KaspaSignedTx.prototype.signature = $util.newBuffer([]);

    KaspaSignedTx.create = function create(properties) {
        return new KaspaSignedTx(properties);
    };

    KaspaSignedTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(18).bytes(message.signature);
        return writer;
    };

    KaspaSignedTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    KaspaSignedTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.KaspaSignedTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 2:
                message.signature = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        return message;
    };

    KaspaSignedTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    KaspaSignedTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        return null;
    };

    KaspaSignedTx.fromObject = function fromObject(object) {
        if (object instanceof $root.KaspaSignedTx)
            return object;
        var message = new $root.KaspaSignedTx();
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        return message;
    };

    KaspaSignedTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        return object;
    };

    KaspaSignedTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return KaspaSignedTx;
})();

$root.BackupType = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "Bip39"] = 0;
    values[valuesById[1] = "Slip39_Basic"] = 1;
    values[valuesById[2] = "Slip39_Advanced"] = 2;
    return values;
})();

$root.SafetyCheckLevel = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "Strict"] = 0;
    values[valuesById[1] = "PromptAlways"] = 1;
    values[valuesById[2] = "PromptTemporarily"] = 2;
    return values;
})();

$root.Initialize = (function() {

    function Initialize(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    Initialize.prototype.session_id = $util.newBuffer([]);
    Initialize.prototype._skip_passphrase = false;
    Initialize.prototype.derive_cardano = false;

    Initialize.create = function create(properties) {
        return new Initialize(properties);
    };

    Initialize.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.session_id != null && Object.hasOwnProperty.call(message, "session_id"))
            writer.uint32(10).bytes(message.session_id);
        if (message._skip_passphrase != null && Object.hasOwnProperty.call(message, "_skip_passphrase"))
            writer.uint32(16).bool(message._skip_passphrase);
        if (message.derive_cardano != null && Object.hasOwnProperty.call(message, "derive_cardano"))
            writer.uint32(24).bool(message.derive_cardano);
        return writer;
    };

    Initialize.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    Initialize.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Initialize();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.session_id = reader.bytes();
                break;
            case 2:
                message._skip_passphrase = reader.bool();
                break;
            case 3:
                message.derive_cardano = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    Initialize.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    Initialize.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.session_id != null && message.hasOwnProperty("session_id"))
            if (!(message.session_id && typeof message.session_id.length === "number" || $util.isString(message.session_id)))
                return "session_id: buffer expected";
        if (message._skip_passphrase != null && message.hasOwnProperty("_skip_passphrase"))
            if (typeof message._skip_passphrase !== "boolean")
                return "_skip_passphrase: boolean expected";
        if (message.derive_cardano != null && message.hasOwnProperty("derive_cardano"))
            if (typeof message.derive_cardano !== "boolean")
                return "derive_cardano: boolean expected";
        return null;
    };

    Initialize.fromObject = function fromObject(object) {
        if (object instanceof $root.Initialize)
            return object;
        var message = new $root.Initialize();
        if (object.session_id != null)
            if (typeof object.session_id === "string")
                $util.base64.decode(object.session_id, message.session_id = $util.newBuffer($util.base64.length(object.session_id)), 0);
            else if (object.session_id.length)
                message.session_id = object.session_id;
        if (object._skip_passphrase != null)
            message._skip_passphrase = Boolean(object._skip_passphrase);
        if (object.derive_cardano != null)
            message.derive_cardano = Boolean(object.derive_cardano);
        return message;
    };

    Initialize.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.session_id = "";
            else {
                object.session_id = [];
                if (options.bytes !== Array)
                    object.session_id = $util.newBuffer(object.session_id);
            }
            object._skip_passphrase = false;
            object.derive_cardano = false;
        }
        if (message.session_id != null && message.hasOwnProperty("session_id"))
            object.session_id = options.bytes === String ? $util.base64.encode(message.session_id, 0, message.session_id.length) : options.bytes === Array ? Array.prototype.slice.call(message.session_id) : message.session_id;
        if (message._skip_passphrase != null && message.hasOwnProperty("_skip_passphrase"))
            object._skip_passphrase = message._skip_passphrase;
        if (message.derive_cardano != null && message.hasOwnProperty("derive_cardano"))
            object.derive_cardano = message.derive_cardano;
        return object;
    };

    Initialize.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return Initialize;
})();

$root.GetFeatures = (function() {

    function GetFeatures(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    GetFeatures.create = function create(properties) {
        return new GetFeatures(properties);
    };

    GetFeatures.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    GetFeatures.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    GetFeatures.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.GetFeatures();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    GetFeatures.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    GetFeatures.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    GetFeatures.fromObject = function fromObject(object) {
        if (object instanceof $root.GetFeatures)
            return object;
        return new $root.GetFeatures();
    };

    GetFeatures.toObject = function toObject() {
        return {};
    };

    GetFeatures.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return GetFeatures;
})();

$root.Features = (function() {

    function Features(properties) {
        this.capabilities = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    Features.prototype.vendor = "";
    Features.prototype.major_version = 0;
    Features.prototype.minor_version = 0;
    Features.prototype.patch_version = 0;
    Features.prototype.bootloader_mode = false;
    Features.prototype.device_id = "";
    Features.prototype.pin_protection = false;
    Features.prototype.passphrase_protection = false;
    Features.prototype.language = "";
    Features.prototype.label = "";
    Features.prototype.initialized = false;
    Features.prototype.revision = $util.newBuffer([]);
    Features.prototype.bootloader_hash = $util.newBuffer([]);
    Features.prototype.imported = false;
    Features.prototype.unlocked = false;
    Features.prototype._passphrase_cached = false;
    Features.prototype.firmware_present = false;
    Features.prototype.needs_backup = false;
    Features.prototype.flags = 0;
    Features.prototype.model = "";
    Features.prototype.fw_major = 0;
    Features.prototype.fw_minor = 0;
    Features.prototype.fw_patch = 0;
    Features.prototype.fw_vendor = "";
    Features.prototype.fw_vendor_keys = $util.newBuffer([]);
    Features.prototype.unfinished_backup = false;
    Features.prototype.no_backup = false;
    Features.prototype.recovery_mode = false;
    Features.prototype.capabilities = $util.emptyArray;
    Features.prototype.backup_type = 0;
    Features.prototype.sd_card_present = false;
    Features.prototype.sd_protection = false;
    Features.prototype.wipe_code_protection = false;
    Features.prototype.session_id = $util.newBuffer([]);
    Features.prototype.passphrase_always_on_device = false;
    Features.prototype.safety_checks = 0;
    Features.prototype.auto_lock_delay_ms = 0;
    Features.prototype.display_rotation = 0;
    Features.prototype.experimental_features = false;
    Features.prototype.offset = 0;
    Features.prototype.ble_name = "";
    Features.prototype.ble_ver = "";
    Features.prototype.ble_enable = false;
    Features.prototype.se_enable = false;
    Features.prototype.se_ver = "";
    Features.prototype.backup_only = false;
    Features.prototype.onekey_version = "";
    Features.prototype.onekey_serial = "";
    Features.prototype.bootloader_version = "";
    Features.prototype.serial_no = "";
    Features.prototype.spi_flash = "";
    Features.prototype.initstates = 0;
    Features.prototype.NFT_voucher = $util.newBuffer([]);
    Features.prototype.cpu_info = "";
    Features.prototype.pre_firmware = "";
    Features.prototype.coin_switch = 0;
    Features.prototype.build_id = "";
    Features.prototype.battery_level = 0;
    Features.prototype.brightness_prcent = 0;
    Features.prototype.haptic_feedback = false;
    Features.prototype.auto_shutdown_delay_ms = 0;

    Features.create = function create(properties) {
        return new Features(properties);
    };

    Features.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.vendor != null && Object.hasOwnProperty.call(message, "vendor"))
            writer.uint32(10).string(message.vendor);
        writer.uint32(16).uint32(message.major_version);
        writer.uint32(24).uint32(message.minor_version);
        writer.uint32(32).uint32(message.patch_version);
        if (message.bootloader_mode != null && Object.hasOwnProperty.call(message, "bootloader_mode"))
            writer.uint32(40).bool(message.bootloader_mode);
        if (message.device_id != null && Object.hasOwnProperty.call(message, "device_id"))
            writer.uint32(50).string(message.device_id);
        if (message.pin_protection != null && Object.hasOwnProperty.call(message, "pin_protection"))
            writer.uint32(56).bool(message.pin_protection);
        if (message.passphrase_protection != null && Object.hasOwnProperty.call(message, "passphrase_protection"))
            writer.uint32(64).bool(message.passphrase_protection);
        if (message.language != null && Object.hasOwnProperty.call(message, "language"))
            writer.uint32(74).string(message.language);
        if (message.label != null && Object.hasOwnProperty.call(message, "label"))
            writer.uint32(82).string(message.label);
        if (message.initialized != null && Object.hasOwnProperty.call(message, "initialized"))
            writer.uint32(96).bool(message.initialized);
        if (message.revision != null && Object.hasOwnProperty.call(message, "revision"))
            writer.uint32(106).bytes(message.revision);
        if (message.bootloader_hash != null && Object.hasOwnProperty.call(message, "bootloader_hash"))
            writer.uint32(114).bytes(message.bootloader_hash);
        if (message.imported != null && Object.hasOwnProperty.call(message, "imported"))
            writer.uint32(120).bool(message.imported);
        if (message.unlocked != null && Object.hasOwnProperty.call(message, "unlocked"))
            writer.uint32(128).bool(message.unlocked);
        if (message._passphrase_cached != null && Object.hasOwnProperty.call(message, "_passphrase_cached"))
            writer.uint32(136).bool(message._passphrase_cached);
        if (message.firmware_present != null && Object.hasOwnProperty.call(message, "firmware_present"))
            writer.uint32(144).bool(message.firmware_present);
        if (message.needs_backup != null && Object.hasOwnProperty.call(message, "needs_backup"))
            writer.uint32(152).bool(message.needs_backup);
        if (message.flags != null && Object.hasOwnProperty.call(message, "flags"))
            writer.uint32(160).uint32(message.flags);
        if (message.model != null && Object.hasOwnProperty.call(message, "model"))
            writer.uint32(170).string(message.model);
        if (message.fw_major != null && Object.hasOwnProperty.call(message, "fw_major"))
            writer.uint32(176).uint32(message.fw_major);
        if (message.fw_minor != null && Object.hasOwnProperty.call(message, "fw_minor"))
            writer.uint32(184).uint32(message.fw_minor);
        if (message.fw_patch != null && Object.hasOwnProperty.call(message, "fw_patch"))
            writer.uint32(192).uint32(message.fw_patch);
        if (message.fw_vendor != null && Object.hasOwnProperty.call(message, "fw_vendor"))
            writer.uint32(202).string(message.fw_vendor);
        if (message.fw_vendor_keys != null && Object.hasOwnProperty.call(message, "fw_vendor_keys"))
            writer.uint32(210).bytes(message.fw_vendor_keys);
        if (message.unfinished_backup != null && Object.hasOwnProperty.call(message, "unfinished_backup"))
            writer.uint32(216).bool(message.unfinished_backup);
        if (message.no_backup != null && Object.hasOwnProperty.call(message, "no_backup"))
            writer.uint32(224).bool(message.no_backup);
        if (message.recovery_mode != null && Object.hasOwnProperty.call(message, "recovery_mode"))
            writer.uint32(232).bool(message.recovery_mode);
        if (message.capabilities != null && message.capabilities.length)
            for (var i = 0; i < message.capabilities.length; ++i)
                writer.uint32(240).int32(message.capabilities[i]);
        if (message.backup_type != null && Object.hasOwnProperty.call(message, "backup_type"))
            writer.uint32(248).int32(message.backup_type);
        if (message.sd_card_present != null && Object.hasOwnProperty.call(message, "sd_card_present"))
            writer.uint32(256).bool(message.sd_card_present);
        if (message.sd_protection != null && Object.hasOwnProperty.call(message, "sd_protection"))
            writer.uint32(264).bool(message.sd_protection);
        if (message.wipe_code_protection != null && Object.hasOwnProperty.call(message, "wipe_code_protection"))
            writer.uint32(272).bool(message.wipe_code_protection);
        if (message.session_id != null && Object.hasOwnProperty.call(message, "session_id"))
            writer.uint32(282).bytes(message.session_id);
        if (message.passphrase_always_on_device != null && Object.hasOwnProperty.call(message, "passphrase_always_on_device"))
            writer.uint32(288).bool(message.passphrase_always_on_device);
        if (message.safety_checks != null && Object.hasOwnProperty.call(message, "safety_checks"))
            writer.uint32(296).int32(message.safety_checks);
        if (message.auto_lock_delay_ms != null && Object.hasOwnProperty.call(message, "auto_lock_delay_ms"))
            writer.uint32(304).uint32(message.auto_lock_delay_ms);
        if (message.display_rotation != null && Object.hasOwnProperty.call(message, "display_rotation"))
            writer.uint32(312).uint32(message.display_rotation);
        if (message.experimental_features != null && Object.hasOwnProperty.call(message, "experimental_features"))
            writer.uint32(320).bool(message.experimental_features);
        if (message.offset != null && Object.hasOwnProperty.call(message, "offset"))
            writer.uint32(4000).uint32(message.offset);
        if (message.ble_name != null && Object.hasOwnProperty.call(message, "ble_name"))
            writer.uint32(4010).string(message.ble_name);
        if (message.ble_ver != null && Object.hasOwnProperty.call(message, "ble_ver"))
            writer.uint32(4018).string(message.ble_ver);
        if (message.ble_enable != null && Object.hasOwnProperty.call(message, "ble_enable"))
            writer.uint32(4024).bool(message.ble_enable);
        if (message.se_enable != null && Object.hasOwnProperty.call(message, "se_enable"))
            writer.uint32(4032).bool(message.se_enable);
        if (message.se_ver != null && Object.hasOwnProperty.call(message, "se_ver"))
            writer.uint32(4050).string(message.se_ver);
        if (message.backup_only != null && Object.hasOwnProperty.call(message, "backup_only"))
            writer.uint32(4056).bool(message.backup_only);
        if (message.onekey_version != null && Object.hasOwnProperty.call(message, "onekey_version"))
            writer.uint32(4066).string(message.onekey_version);
        if (message.onekey_serial != null && Object.hasOwnProperty.call(message, "onekey_serial"))
            writer.uint32(4074).string(message.onekey_serial);
        if (message.bootloader_version != null && Object.hasOwnProperty.call(message, "bootloader_version"))
            writer.uint32(4082).string(message.bootloader_version);
        if (message.serial_no != null && Object.hasOwnProperty.call(message, "serial_no"))
            writer.uint32(4090).string(message.serial_no);
        if (message.spi_flash != null && Object.hasOwnProperty.call(message, "spi_flash"))
            writer.uint32(4098).string(message.spi_flash);
        if (message.initstates != null && Object.hasOwnProperty.call(message, "initstates"))
            writer.uint32(4104).uint32(message.initstates);
        if (message.NFT_voucher != null && Object.hasOwnProperty.call(message, "NFT_voucher"))
            writer.uint32(4114).bytes(message.NFT_voucher);
        if (message.cpu_info != null && Object.hasOwnProperty.call(message, "cpu_info"))
            writer.uint32(4122).string(message.cpu_info);
        if (message.pre_firmware != null && Object.hasOwnProperty.call(message, "pre_firmware"))
            writer.uint32(4130).string(message.pre_firmware);
        if (message.coin_switch != null && Object.hasOwnProperty.call(message, "coin_switch"))
            writer.uint32(4136).uint32(message.coin_switch);
        if (message.build_id != null && Object.hasOwnProperty.call(message, "build_id"))
            writer.uint32(4146).string(message.build_id);
        if (message.battery_level != null && Object.hasOwnProperty.call(message, "battery_level"))
            writer.uint32(4160).uint32(message.battery_level);
        if (message.brightness_prcent != null && Object.hasOwnProperty.call(message, "brightness_prcent"))
            writer.uint32(4168).uint32(message.brightness_prcent);
        if (message.haptic_feedback != null && Object.hasOwnProperty.call(message, "haptic_feedback"))
            writer.uint32(4176).bool(message.haptic_feedback);
        if (message.auto_shutdown_delay_ms != null && Object.hasOwnProperty.call(message, "auto_shutdown_delay_ms"))
            writer.uint32(4184).uint32(message.auto_shutdown_delay_ms);
        return writer;
    };

    Features.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    Features.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Features();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.vendor = reader.string();
                break;
            case 2:
                message.major_version = reader.uint32();
                break;
            case 3:
                message.minor_version = reader.uint32();
                break;
            case 4:
                message.patch_version = reader.uint32();
                break;
            case 5:
                message.bootloader_mode = reader.bool();
                break;
            case 6:
                message.device_id = reader.string();
                break;
            case 7:
                message.pin_protection = reader.bool();
                break;
            case 8:
                message.passphrase_protection = reader.bool();
                break;
            case 9:
                message.language = reader.string();
                break;
            case 10:
                message.label = reader.string();
                break;
            case 12:
                message.initialized = reader.bool();
                break;
            case 13:
                message.revision = reader.bytes();
                break;
            case 14:
                message.bootloader_hash = reader.bytes();
                break;
            case 15:
                message.imported = reader.bool();
                break;
            case 16:
                message.unlocked = reader.bool();
                break;
            case 17:
                message._passphrase_cached = reader.bool();
                break;
            case 18:
                message.firmware_present = reader.bool();
                break;
            case 19:
                message.needs_backup = reader.bool();
                break;
            case 20:
                message.flags = reader.uint32();
                break;
            case 21:
                message.model = reader.string();
                break;
            case 22:
                message.fw_major = reader.uint32();
                break;
            case 23:
                message.fw_minor = reader.uint32();
                break;
            case 24:
                message.fw_patch = reader.uint32();
                break;
            case 25:
                message.fw_vendor = reader.string();
                break;
            case 26:
                message.fw_vendor_keys = reader.bytes();
                break;
            case 27:
                message.unfinished_backup = reader.bool();
                break;
            case 28:
                message.no_backup = reader.bool();
                break;
            case 29:
                message.recovery_mode = reader.bool();
                break;
            case 30:
                if (!(message.capabilities && message.capabilities.length))
                    message.capabilities = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.capabilities.push(reader.int32());
                } else
                    message.capabilities.push(reader.int32());
                break;
            case 31:
                message.backup_type = reader.int32();
                break;
            case 32:
                message.sd_card_present = reader.bool();
                break;
            case 33:
                message.sd_protection = reader.bool();
                break;
            case 34:
                message.wipe_code_protection = reader.bool();
                break;
            case 35:
                message.session_id = reader.bytes();
                break;
            case 36:
                message.passphrase_always_on_device = reader.bool();
                break;
            case 37:
                message.safety_checks = reader.int32();
                break;
            case 38:
                message.auto_lock_delay_ms = reader.uint32();
                break;
            case 39:
                message.display_rotation = reader.uint32();
                break;
            case 40:
                message.experimental_features = reader.bool();
                break;
            case 500:
                message.offset = reader.uint32();
                break;
            case 501:
                message.ble_name = reader.string();
                break;
            case 502:
                message.ble_ver = reader.string();
                break;
            case 503:
                message.ble_enable = reader.bool();
                break;
            case 504:
                message.se_enable = reader.bool();
                break;
            case 506:
                message.se_ver = reader.string();
                break;
            case 507:
                message.backup_only = reader.bool();
                break;
            case 508:
                message.onekey_version = reader.string();
                break;
            case 509:
                message.onekey_serial = reader.string();
                break;
            case 510:
                message.bootloader_version = reader.string();
                break;
            case 511:
                message.serial_no = reader.string();
                break;
            case 512:
                message.spi_flash = reader.string();
                break;
            case 513:
                message.initstates = reader.uint32();
                break;
            case 514:
                message.NFT_voucher = reader.bytes();
                break;
            case 515:
                message.cpu_info = reader.string();
                break;
            case 516:
                message.pre_firmware = reader.string();
                break;
            case 517:
                message.coin_switch = reader.uint32();
                break;
            case 518:
                message.build_id = reader.string();
                break;
            case 520:
                message.battery_level = reader.uint32();
                break;
            case 521:
                message.brightness_prcent = reader.uint32();
                break;
            case 522:
                message.haptic_feedback = reader.bool();
                break;
            case 523:
                message.auto_shutdown_delay_ms = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("major_version"))
            throw $util.ProtocolError("missing required 'major_version'", { instance: message });
        if (!message.hasOwnProperty("minor_version"))
            throw $util.ProtocolError("missing required 'minor_version'", { instance: message });
        if (!message.hasOwnProperty("patch_version"))
            throw $util.ProtocolError("missing required 'patch_version'", { instance: message });
        return message;
    };

    Features.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    Features.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.vendor != null && message.hasOwnProperty("vendor"))
            if (!$util.isString(message.vendor))
                return "vendor: string expected";
        if (!$util.isInteger(message.major_version))
            return "major_version: integer expected";
        if (!$util.isInteger(message.minor_version))
            return "minor_version: integer expected";
        if (!$util.isInteger(message.patch_version))
            return "patch_version: integer expected";
        if (message.bootloader_mode != null && message.hasOwnProperty("bootloader_mode"))
            if (typeof message.bootloader_mode !== "boolean")
                return "bootloader_mode: boolean expected";
        if (message.device_id != null && message.hasOwnProperty("device_id"))
            if (!$util.isString(message.device_id))
                return "device_id: string expected";
        if (message.pin_protection != null && message.hasOwnProperty("pin_protection"))
            if (typeof message.pin_protection !== "boolean")
                return "pin_protection: boolean expected";
        if (message.passphrase_protection != null && message.hasOwnProperty("passphrase_protection"))
            if (typeof message.passphrase_protection !== "boolean")
                return "passphrase_protection: boolean expected";
        if (message.language != null && message.hasOwnProperty("language"))
            if (!$util.isString(message.language))
                return "language: string expected";
        if (message.label != null && message.hasOwnProperty("label"))
            if (!$util.isString(message.label))
                return "label: string expected";
        if (message.initialized != null && message.hasOwnProperty("initialized"))
            if (typeof message.initialized !== "boolean")
                return "initialized: boolean expected";
        if (message.revision != null && message.hasOwnProperty("revision"))
            if (!(message.revision && typeof message.revision.length === "number" || $util.isString(message.revision)))
                return "revision: buffer expected";
        if (message.bootloader_hash != null && message.hasOwnProperty("bootloader_hash"))
            if (!(message.bootloader_hash && typeof message.bootloader_hash.length === "number" || $util.isString(message.bootloader_hash)))
                return "bootloader_hash: buffer expected";
        if (message.imported != null && message.hasOwnProperty("imported"))
            if (typeof message.imported !== "boolean")
                return "imported: boolean expected";
        if (message.unlocked != null && message.hasOwnProperty("unlocked"))
            if (typeof message.unlocked !== "boolean")
                return "unlocked: boolean expected";
        if (message._passphrase_cached != null && message.hasOwnProperty("_passphrase_cached"))
            if (typeof message._passphrase_cached !== "boolean")
                return "_passphrase_cached: boolean expected";
        if (message.firmware_present != null && message.hasOwnProperty("firmware_present"))
            if (typeof message.firmware_present !== "boolean")
                return "firmware_present: boolean expected";
        if (message.needs_backup != null && message.hasOwnProperty("needs_backup"))
            if (typeof message.needs_backup !== "boolean")
                return "needs_backup: boolean expected";
        if (message.flags != null && message.hasOwnProperty("flags"))
            if (!$util.isInteger(message.flags))
                return "flags: integer expected";
        if (message.model != null && message.hasOwnProperty("model"))
            if (!$util.isString(message.model))
                return "model: string expected";
        if (message.fw_major != null && message.hasOwnProperty("fw_major"))
            if (!$util.isInteger(message.fw_major))
                return "fw_major: integer expected";
        if (message.fw_minor != null && message.hasOwnProperty("fw_minor"))
            if (!$util.isInteger(message.fw_minor))
                return "fw_minor: integer expected";
        if (message.fw_patch != null && message.hasOwnProperty("fw_patch"))
            if (!$util.isInteger(message.fw_patch))
                return "fw_patch: integer expected";
        if (message.fw_vendor != null && message.hasOwnProperty("fw_vendor"))
            if (!$util.isString(message.fw_vendor))
                return "fw_vendor: string expected";
        if (message.fw_vendor_keys != null && message.hasOwnProperty("fw_vendor_keys"))
            if (!(message.fw_vendor_keys && typeof message.fw_vendor_keys.length === "number" || $util.isString(message.fw_vendor_keys)))
                return "fw_vendor_keys: buffer expected";
        if (message.unfinished_backup != null && message.hasOwnProperty("unfinished_backup"))
            if (typeof message.unfinished_backup !== "boolean")
                return "unfinished_backup: boolean expected";
        if (message.no_backup != null && message.hasOwnProperty("no_backup"))
            if (typeof message.no_backup !== "boolean")
                return "no_backup: boolean expected";
        if (message.recovery_mode != null && message.hasOwnProperty("recovery_mode"))
            if (typeof message.recovery_mode !== "boolean")
                return "recovery_mode: boolean expected";
        if (message.capabilities != null && message.hasOwnProperty("capabilities")) {
            if (!Array.isArray(message.capabilities))
                return "capabilities: array expected";
            for (var i = 0; i < message.capabilities.length; ++i)
                switch (message.capabilities[i]) {
                default:
                    return "capabilities: enum value[] expected";
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                    break;
                }
        }
        if (message.backup_type != null && message.hasOwnProperty("backup_type"))
            switch (message.backup_type) {
            default:
                return "backup_type: enum value expected";
            case 0:
            case 1:
            case 2:
                break;
            }
        if (message.sd_card_present != null && message.hasOwnProperty("sd_card_present"))
            if (typeof message.sd_card_present !== "boolean")
                return "sd_card_present: boolean expected";
        if (message.sd_protection != null && message.hasOwnProperty("sd_protection"))
            if (typeof message.sd_protection !== "boolean")
                return "sd_protection: boolean expected";
        if (message.wipe_code_protection != null && message.hasOwnProperty("wipe_code_protection"))
            if (typeof message.wipe_code_protection !== "boolean")
                return "wipe_code_protection: boolean expected";
        if (message.session_id != null && message.hasOwnProperty("session_id"))
            if (!(message.session_id && typeof message.session_id.length === "number" || $util.isString(message.session_id)))
                return "session_id: buffer expected";
        if (message.passphrase_always_on_device != null && message.hasOwnProperty("passphrase_always_on_device"))
            if (typeof message.passphrase_always_on_device !== "boolean")
                return "passphrase_always_on_device: boolean expected";
        if (message.safety_checks != null && message.hasOwnProperty("safety_checks"))
            switch (message.safety_checks) {
            default:
                return "safety_checks: enum value expected";
            case 0:
            case 1:
            case 2:
                break;
            }
        if (message.auto_lock_delay_ms != null && message.hasOwnProperty("auto_lock_delay_ms"))
            if (!$util.isInteger(message.auto_lock_delay_ms))
                return "auto_lock_delay_ms: integer expected";
        if (message.display_rotation != null && message.hasOwnProperty("display_rotation"))
            if (!$util.isInteger(message.display_rotation))
                return "display_rotation: integer expected";
        if (message.experimental_features != null && message.hasOwnProperty("experimental_features"))
            if (typeof message.experimental_features !== "boolean")
                return "experimental_features: boolean expected";
        if (message.offset != null && message.hasOwnProperty("offset"))
            if (!$util.isInteger(message.offset))
                return "offset: integer expected";
        if (message.ble_name != null && message.hasOwnProperty("ble_name"))
            if (!$util.isString(message.ble_name))
                return "ble_name: string expected";
        if (message.ble_ver != null && message.hasOwnProperty("ble_ver"))
            if (!$util.isString(message.ble_ver))
                return "ble_ver: string expected";
        if (message.ble_enable != null && message.hasOwnProperty("ble_enable"))
            if (typeof message.ble_enable !== "boolean")
                return "ble_enable: boolean expected";
        if (message.se_enable != null && message.hasOwnProperty("se_enable"))
            if (typeof message.se_enable !== "boolean")
                return "se_enable: boolean expected";
        if (message.se_ver != null && message.hasOwnProperty("se_ver"))
            if (!$util.isString(message.se_ver))
                return "se_ver: string expected";
        if (message.backup_only != null && message.hasOwnProperty("backup_only"))
            if (typeof message.backup_only !== "boolean")
                return "backup_only: boolean expected";
        if (message.onekey_version != null && message.hasOwnProperty("onekey_version"))
            if (!$util.isString(message.onekey_version))
                return "onekey_version: string expected";
        if (message.onekey_serial != null && message.hasOwnProperty("onekey_serial"))
            if (!$util.isString(message.onekey_serial))
                return "onekey_serial: string expected";
        if (message.bootloader_version != null && message.hasOwnProperty("bootloader_version"))
            if (!$util.isString(message.bootloader_version))
                return "bootloader_version: string expected";
        if (message.serial_no != null && message.hasOwnProperty("serial_no"))
            if (!$util.isString(message.serial_no))
                return "serial_no: string expected";
        if (message.spi_flash != null && message.hasOwnProperty("spi_flash"))
            if (!$util.isString(message.spi_flash))
                return "spi_flash: string expected";
        if (message.initstates != null && message.hasOwnProperty("initstates"))
            if (!$util.isInteger(message.initstates))
                return "initstates: integer expected";
        if (message.NFT_voucher != null && message.hasOwnProperty("NFT_voucher"))
            if (!(message.NFT_voucher && typeof message.NFT_voucher.length === "number" || $util.isString(message.NFT_voucher)))
                return "NFT_voucher: buffer expected";
        if (message.cpu_info != null && message.hasOwnProperty("cpu_info"))
            if (!$util.isString(message.cpu_info))
                return "cpu_info: string expected";
        if (message.pre_firmware != null && message.hasOwnProperty("pre_firmware"))
            if (!$util.isString(message.pre_firmware))
                return "pre_firmware: string expected";
        if (message.coin_switch != null && message.hasOwnProperty("coin_switch"))
            if (!$util.isInteger(message.coin_switch))
                return "coin_switch: integer expected";
        if (message.build_id != null && message.hasOwnProperty("build_id"))
            if (!$util.isString(message.build_id))
                return "build_id: string expected";
        if (message.battery_level != null && message.hasOwnProperty("battery_level"))
            if (!$util.isInteger(message.battery_level))
                return "battery_level: integer expected";
        if (message.brightness_prcent != null && message.hasOwnProperty("brightness_prcent"))
            if (!$util.isInteger(message.brightness_prcent))
                return "brightness_prcent: integer expected";
        if (message.haptic_feedback != null && message.hasOwnProperty("haptic_feedback"))
            if (typeof message.haptic_feedback !== "boolean")
                return "haptic_feedback: boolean expected";
        if (message.auto_shutdown_delay_ms != null && message.hasOwnProperty("auto_shutdown_delay_ms"))
            if (!$util.isInteger(message.auto_shutdown_delay_ms))
                return "auto_shutdown_delay_ms: integer expected";
        return null;
    };

    Features.fromObject = function fromObject(object) {
        if (object instanceof $root.Features)
            return object;
        var message = new $root.Features();
        if (object.vendor != null)
            message.vendor = String(object.vendor);
        if (object.major_version != null)
            message.major_version = object.major_version >>> 0;
        if (object.minor_version != null)
            message.minor_version = object.minor_version >>> 0;
        if (object.patch_version != null)
            message.patch_version = object.patch_version >>> 0;
        if (object.bootloader_mode != null)
            message.bootloader_mode = Boolean(object.bootloader_mode);
        if (object.device_id != null)
            message.device_id = String(object.device_id);
        if (object.pin_protection != null)
            message.pin_protection = Boolean(object.pin_protection);
        if (object.passphrase_protection != null)
            message.passphrase_protection = Boolean(object.passphrase_protection);
        if (object.language != null)
            message.language = String(object.language);
        if (object.label != null)
            message.label = String(object.label);
        if (object.initialized != null)
            message.initialized = Boolean(object.initialized);
        if (object.revision != null)
            if (typeof object.revision === "string")
                $util.base64.decode(object.revision, message.revision = $util.newBuffer($util.base64.length(object.revision)), 0);
            else if (object.revision.length)
                message.revision = object.revision;
        if (object.bootloader_hash != null)
            if (typeof object.bootloader_hash === "string")
                $util.base64.decode(object.bootloader_hash, message.bootloader_hash = $util.newBuffer($util.base64.length(object.bootloader_hash)), 0);
            else if (object.bootloader_hash.length)
                message.bootloader_hash = object.bootloader_hash;
        if (object.imported != null)
            message.imported = Boolean(object.imported);
        if (object.unlocked != null)
            message.unlocked = Boolean(object.unlocked);
        if (object._passphrase_cached != null)
            message._passphrase_cached = Boolean(object._passphrase_cached);
        if (object.firmware_present != null)
            message.firmware_present = Boolean(object.firmware_present);
        if (object.needs_backup != null)
            message.needs_backup = Boolean(object.needs_backup);
        if (object.flags != null)
            message.flags = object.flags >>> 0;
        if (object.model != null)
            message.model = String(object.model);
        if (object.fw_major != null)
            message.fw_major = object.fw_major >>> 0;
        if (object.fw_minor != null)
            message.fw_minor = object.fw_minor >>> 0;
        if (object.fw_patch != null)
            message.fw_patch = object.fw_patch >>> 0;
        if (object.fw_vendor != null)
            message.fw_vendor = String(object.fw_vendor);
        if (object.fw_vendor_keys != null)
            if (typeof object.fw_vendor_keys === "string")
                $util.base64.decode(object.fw_vendor_keys, message.fw_vendor_keys = $util.newBuffer($util.base64.length(object.fw_vendor_keys)), 0);
            else if (object.fw_vendor_keys.length)
                message.fw_vendor_keys = object.fw_vendor_keys;
        if (object.unfinished_backup != null)
            message.unfinished_backup = Boolean(object.unfinished_backup);
        if (object.no_backup != null)
            message.no_backup = Boolean(object.no_backup);
        if (object.recovery_mode != null)
            message.recovery_mode = Boolean(object.recovery_mode);
        if (object.capabilities) {
            if (!Array.isArray(object.capabilities))
                throw TypeError(".Features.capabilities: array expected");
            message.capabilities = [];
            for (var i = 0; i < object.capabilities.length; ++i)
                switch (object.capabilities[i]) {
                default:
                case "Capability_Bitcoin":
                case 1:
                    message.capabilities[i] = 1;
                    break;
                case "Capability_Bitcoin_like":
                case 2:
                    message.capabilities[i] = 2;
                    break;
                case "Capability_Binance":
                case 3:
                    message.capabilities[i] = 3;
                    break;
                case "Capability_Cardano":
                case 4:
                    message.capabilities[i] = 4;
                    break;
                case "Capability_Crypto":
                case 5:
                    message.capabilities[i] = 5;
                    break;
                case "Capability_EOS":
                case 6:
                    message.capabilities[i] = 6;
                    break;
                case "Capability_Ethereum":
                case 7:
                    message.capabilities[i] = 7;
                    break;
                case "Capability_Lisk":
                case 8:
                    message.capabilities[i] = 8;
                    break;
                case "Capability_Monero":
                case 9:
                    message.capabilities[i] = 9;
                    break;
                case "Capability_NEM":
                case 10:
                    message.capabilities[i] = 10;
                    break;
                case "Capability_Ripple":
                case 11:
                    message.capabilities[i] = 11;
                    break;
                case "Capability_Stellar":
                case 12:
                    message.capabilities[i] = 12;
                    break;
                case "Capability_Tezos":
                case 13:
                    message.capabilities[i] = 13;
                    break;
                case "Capability_U2F":
                case 14:
                    message.capabilities[i] = 14;
                    break;
                case "Capability_Shamir":
                case 15:
                    message.capabilities[i] = 15;
                    break;
                case "Capability_ShamirGroups":
                case 16:
                    message.capabilities[i] = 16;
                    break;
                case "Capability_PassphraseEntry":
                case 17:
                    message.capabilities[i] = 17;
                    break;
                }
        }
        switch (object.backup_type) {
        case "Bip39":
        case 0:
            message.backup_type = 0;
            break;
        case "Slip39_Basic":
        case 1:
            message.backup_type = 1;
            break;
        case "Slip39_Advanced":
        case 2:
            message.backup_type = 2;
            break;
        }
        if (object.sd_card_present != null)
            message.sd_card_present = Boolean(object.sd_card_present);
        if (object.sd_protection != null)
            message.sd_protection = Boolean(object.sd_protection);
        if (object.wipe_code_protection != null)
            message.wipe_code_protection = Boolean(object.wipe_code_protection);
        if (object.session_id != null)
            if (typeof object.session_id === "string")
                $util.base64.decode(object.session_id, message.session_id = $util.newBuffer($util.base64.length(object.session_id)), 0);
            else if (object.session_id.length)
                message.session_id = object.session_id;
        if (object.passphrase_always_on_device != null)
            message.passphrase_always_on_device = Boolean(object.passphrase_always_on_device);
        switch (object.safety_checks) {
        case "Strict":
        case 0:
            message.safety_checks = 0;
            break;
        case "PromptAlways":
        case 1:
            message.safety_checks = 1;
            break;
        case "PromptTemporarily":
        case 2:
            message.safety_checks = 2;
            break;
        }
        if (object.auto_lock_delay_ms != null)
            message.auto_lock_delay_ms = object.auto_lock_delay_ms >>> 0;
        if (object.display_rotation != null)
            message.display_rotation = object.display_rotation >>> 0;
        if (object.experimental_features != null)
            message.experimental_features = Boolean(object.experimental_features);
        if (object.offset != null)
            message.offset = object.offset >>> 0;
        if (object.ble_name != null)
            message.ble_name = String(object.ble_name);
        if (object.ble_ver != null)
            message.ble_ver = String(object.ble_ver);
        if (object.ble_enable != null)
            message.ble_enable = Boolean(object.ble_enable);
        if (object.se_enable != null)
            message.se_enable = Boolean(object.se_enable);
        if (object.se_ver != null)
            message.se_ver = String(object.se_ver);
        if (object.backup_only != null)
            message.backup_only = Boolean(object.backup_only);
        if (object.onekey_version != null)
            message.onekey_version = String(object.onekey_version);
        if (object.onekey_serial != null)
            message.onekey_serial = String(object.onekey_serial);
        if (object.bootloader_version != null)
            message.bootloader_version = String(object.bootloader_version);
        if (object.serial_no != null)
            message.serial_no = String(object.serial_no);
        if (object.spi_flash != null)
            message.spi_flash = String(object.spi_flash);
        if (object.initstates != null)
            message.initstates = object.initstates >>> 0;
        if (object.NFT_voucher != null)
            if (typeof object.NFT_voucher === "string")
                $util.base64.decode(object.NFT_voucher, message.NFT_voucher = $util.newBuffer($util.base64.length(object.NFT_voucher)), 0);
            else if (object.NFT_voucher.length)
                message.NFT_voucher = object.NFT_voucher;
        if (object.cpu_info != null)
            message.cpu_info = String(object.cpu_info);
        if (object.pre_firmware != null)
            message.pre_firmware = String(object.pre_firmware);
        if (object.coin_switch != null)
            message.coin_switch = object.coin_switch >>> 0;
        if (object.build_id != null)
            message.build_id = String(object.build_id);
        if (object.battery_level != null)
            message.battery_level = object.battery_level >>> 0;
        if (object.brightness_prcent != null)
            message.brightness_prcent = object.brightness_prcent >>> 0;
        if (object.haptic_feedback != null)
            message.haptic_feedback = Boolean(object.haptic_feedback);
        if (object.auto_shutdown_delay_ms != null)
            message.auto_shutdown_delay_ms = object.auto_shutdown_delay_ms >>> 0;
        return message;
    };

    Features.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.capabilities = [];
        if (options.defaults) {
            object.vendor = "";
            object.major_version = 0;
            object.minor_version = 0;
            object.patch_version = 0;
            object.bootloader_mode = false;
            object.device_id = "";
            object.pin_protection = false;
            object.passphrase_protection = false;
            object.language = "";
            object.label = "";
            object.initialized = false;
            if (options.bytes === String)
                object.revision = "";
            else {
                object.revision = [];
                if (options.bytes !== Array)
                    object.revision = $util.newBuffer(object.revision);
            }
            if (options.bytes === String)
                object.bootloader_hash = "";
            else {
                object.bootloader_hash = [];
                if (options.bytes !== Array)
                    object.bootloader_hash = $util.newBuffer(object.bootloader_hash);
            }
            object.imported = false;
            object.unlocked = false;
            object._passphrase_cached = false;
            object.firmware_present = false;
            object.needs_backup = false;
            object.flags = 0;
            object.model = "";
            object.fw_major = 0;
            object.fw_minor = 0;
            object.fw_patch = 0;
            object.fw_vendor = "";
            if (options.bytes === String)
                object.fw_vendor_keys = "";
            else {
                object.fw_vendor_keys = [];
                if (options.bytes !== Array)
                    object.fw_vendor_keys = $util.newBuffer(object.fw_vendor_keys);
            }
            object.unfinished_backup = false;
            object.no_backup = false;
            object.recovery_mode = false;
            object.backup_type = options.enums === String ? "Bip39" : 0;
            object.sd_card_present = false;
            object.sd_protection = false;
            object.wipe_code_protection = false;
            if (options.bytes === String)
                object.session_id = "";
            else {
                object.session_id = [];
                if (options.bytes !== Array)
                    object.session_id = $util.newBuffer(object.session_id);
            }
            object.passphrase_always_on_device = false;
            object.safety_checks = options.enums === String ? "Strict" : 0;
            object.auto_lock_delay_ms = 0;
            object.display_rotation = 0;
            object.experimental_features = false;
            object.offset = 0;
            object.ble_name = "";
            object.ble_ver = "";
            object.ble_enable = false;
            object.se_enable = false;
            object.se_ver = "";
            object.backup_only = false;
            object.onekey_version = "";
            object.onekey_serial = "";
            object.bootloader_version = "";
            object.serial_no = "";
            object.spi_flash = "";
            object.initstates = 0;
            if (options.bytes === String)
                object.NFT_voucher = "";
            else {
                object.NFT_voucher = [];
                if (options.bytes !== Array)
                    object.NFT_voucher = $util.newBuffer(object.NFT_voucher);
            }
            object.cpu_info = "";
            object.pre_firmware = "";
            object.coin_switch = 0;
            object.build_id = "";
            object.battery_level = 0;
            object.brightness_prcent = 0;
            object.haptic_feedback = false;
            object.auto_shutdown_delay_ms = 0;
        }
        if (message.vendor != null && message.hasOwnProperty("vendor"))
            object.vendor = message.vendor;
        if (message.major_version != null && message.hasOwnProperty("major_version"))
            object.major_version = message.major_version;
        if (message.minor_version != null && message.hasOwnProperty("minor_version"))
            object.minor_version = message.minor_version;
        if (message.patch_version != null && message.hasOwnProperty("patch_version"))
            object.patch_version = message.patch_version;
        if (message.bootloader_mode != null && message.hasOwnProperty("bootloader_mode"))
            object.bootloader_mode = message.bootloader_mode;
        if (message.device_id != null && message.hasOwnProperty("device_id"))
            object.device_id = message.device_id;
        if (message.pin_protection != null && message.hasOwnProperty("pin_protection"))
            object.pin_protection = message.pin_protection;
        if (message.passphrase_protection != null && message.hasOwnProperty("passphrase_protection"))
            object.passphrase_protection = message.passphrase_protection;
        if (message.language != null && message.hasOwnProperty("language"))
            object.language = message.language;
        if (message.label != null && message.hasOwnProperty("label"))
            object.label = message.label;
        if (message.initialized != null && message.hasOwnProperty("initialized"))
            object.initialized = message.initialized;
        if (message.revision != null && message.hasOwnProperty("revision"))
            object.revision = options.bytes === String ? $util.base64.encode(message.revision, 0, message.revision.length) : options.bytes === Array ? Array.prototype.slice.call(message.revision) : message.revision;
        if (message.bootloader_hash != null && message.hasOwnProperty("bootloader_hash"))
            object.bootloader_hash = options.bytes === String ? $util.base64.encode(message.bootloader_hash, 0, message.bootloader_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.bootloader_hash) : message.bootloader_hash;
        if (message.imported != null && message.hasOwnProperty("imported"))
            object.imported = message.imported;
        if (message.unlocked != null && message.hasOwnProperty("unlocked"))
            object.unlocked = message.unlocked;
        if (message._passphrase_cached != null && message.hasOwnProperty("_passphrase_cached"))
            object._passphrase_cached = message._passphrase_cached;
        if (message.firmware_present != null && message.hasOwnProperty("firmware_present"))
            object.firmware_present = message.firmware_present;
        if (message.needs_backup != null && message.hasOwnProperty("needs_backup"))
            object.needs_backup = message.needs_backup;
        if (message.flags != null && message.hasOwnProperty("flags"))
            object.flags = message.flags;
        if (message.model != null && message.hasOwnProperty("model"))
            object.model = message.model;
        if (message.fw_major != null && message.hasOwnProperty("fw_major"))
            object.fw_major = message.fw_major;
        if (message.fw_minor != null && message.hasOwnProperty("fw_minor"))
            object.fw_minor = message.fw_minor;
        if (message.fw_patch != null && message.hasOwnProperty("fw_patch"))
            object.fw_patch = message.fw_patch;
        if (message.fw_vendor != null && message.hasOwnProperty("fw_vendor"))
            object.fw_vendor = message.fw_vendor;
        if (message.fw_vendor_keys != null && message.hasOwnProperty("fw_vendor_keys"))
            object.fw_vendor_keys = options.bytes === String ? $util.base64.encode(message.fw_vendor_keys, 0, message.fw_vendor_keys.length) : options.bytes === Array ? Array.prototype.slice.call(message.fw_vendor_keys) : message.fw_vendor_keys;
        if (message.unfinished_backup != null && message.hasOwnProperty("unfinished_backup"))
            object.unfinished_backup = message.unfinished_backup;
        if (message.no_backup != null && message.hasOwnProperty("no_backup"))
            object.no_backup = message.no_backup;
        if (message.recovery_mode != null && message.hasOwnProperty("recovery_mode"))
            object.recovery_mode = message.recovery_mode;
        if (message.capabilities && message.capabilities.length) {
            object.capabilities = [];
            for (var j = 0; j < message.capabilities.length; ++j)
                object.capabilities[j] = options.enums === String ? $root.Features.Capability[message.capabilities[j]] : message.capabilities[j];
        }
        if (message.backup_type != null && message.hasOwnProperty("backup_type"))
            object.backup_type = options.enums === String ? $root.BackupType[message.backup_type] : message.backup_type;
        if (message.sd_card_present != null && message.hasOwnProperty("sd_card_present"))
            object.sd_card_present = message.sd_card_present;
        if (message.sd_protection != null && message.hasOwnProperty("sd_protection"))
            object.sd_protection = message.sd_protection;
        if (message.wipe_code_protection != null && message.hasOwnProperty("wipe_code_protection"))
            object.wipe_code_protection = message.wipe_code_protection;
        if (message.session_id != null && message.hasOwnProperty("session_id"))
            object.session_id = options.bytes === String ? $util.base64.encode(message.session_id, 0, message.session_id.length) : options.bytes === Array ? Array.prototype.slice.call(message.session_id) : message.session_id;
        if (message.passphrase_always_on_device != null && message.hasOwnProperty("passphrase_always_on_device"))
            object.passphrase_always_on_device = message.passphrase_always_on_device;
        if (message.safety_checks != null && message.hasOwnProperty("safety_checks"))
            object.safety_checks = options.enums === String ? $root.SafetyCheckLevel[message.safety_checks] : message.safety_checks;
        if (message.auto_lock_delay_ms != null && message.hasOwnProperty("auto_lock_delay_ms"))
            object.auto_lock_delay_ms = message.auto_lock_delay_ms;
        if (message.display_rotation != null && message.hasOwnProperty("display_rotation"))
            object.display_rotation = message.display_rotation;
        if (message.experimental_features != null && message.hasOwnProperty("experimental_features"))
            object.experimental_features = message.experimental_features;
        if (message.offset != null && message.hasOwnProperty("offset"))
            object.offset = message.offset;
        if (message.ble_name != null && message.hasOwnProperty("ble_name"))
            object.ble_name = message.ble_name;
        if (message.ble_ver != null && message.hasOwnProperty("ble_ver"))
            object.ble_ver = message.ble_ver;
        if (message.ble_enable != null && message.hasOwnProperty("ble_enable"))
            object.ble_enable = message.ble_enable;
        if (message.se_enable != null && message.hasOwnProperty("se_enable"))
            object.se_enable = message.se_enable;
        if (message.se_ver != null && message.hasOwnProperty("se_ver"))
            object.se_ver = message.se_ver;
        if (message.backup_only != null && message.hasOwnProperty("backup_only"))
            object.backup_only = message.backup_only;
        if (message.onekey_version != null && message.hasOwnProperty("onekey_version"))
            object.onekey_version = message.onekey_version;
        if (message.onekey_serial != null && message.hasOwnProperty("onekey_serial"))
            object.onekey_serial = message.onekey_serial;
        if (message.bootloader_version != null && message.hasOwnProperty("bootloader_version"))
            object.bootloader_version = message.bootloader_version;
        if (message.serial_no != null && message.hasOwnProperty("serial_no"))
            object.serial_no = message.serial_no;
        if (message.spi_flash != null && message.hasOwnProperty("spi_flash"))
            object.spi_flash = message.spi_flash;
        if (message.initstates != null && message.hasOwnProperty("initstates"))
            object.initstates = message.initstates;
        if (message.NFT_voucher != null && message.hasOwnProperty("NFT_voucher"))
            object.NFT_voucher = options.bytes === String ? $util.base64.encode(message.NFT_voucher, 0, message.NFT_voucher.length) : options.bytes === Array ? Array.prototype.slice.call(message.NFT_voucher) : message.NFT_voucher;
        if (message.cpu_info != null && message.hasOwnProperty("cpu_info"))
            object.cpu_info = message.cpu_info;
        if (message.pre_firmware != null && message.hasOwnProperty("pre_firmware"))
            object.pre_firmware = message.pre_firmware;
        if (message.coin_switch != null && message.hasOwnProperty("coin_switch"))
            object.coin_switch = message.coin_switch;
        if (message.build_id != null && message.hasOwnProperty("build_id"))
            object.build_id = message.build_id;
        if (message.battery_level != null && message.hasOwnProperty("battery_level"))
            object.battery_level = message.battery_level;
        if (message.brightness_prcent != null && message.hasOwnProperty("brightness_prcent"))
            object.brightness_prcent = message.brightness_prcent;
        if (message.haptic_feedback != null && message.hasOwnProperty("haptic_feedback"))
            object.haptic_feedback = message.haptic_feedback;
        if (message.auto_shutdown_delay_ms != null && message.hasOwnProperty("auto_shutdown_delay_ms"))
            object.auto_shutdown_delay_ms = message.auto_shutdown_delay_ms;
        return object;
    };

    Features.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    Features.Capability = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[1] = "Capability_Bitcoin"] = 1;
        values[valuesById[2] = "Capability_Bitcoin_like"] = 2;
        values[valuesById[3] = "Capability_Binance"] = 3;
        values[valuesById[4] = "Capability_Cardano"] = 4;
        values[valuesById[5] = "Capability_Crypto"] = 5;
        values[valuesById[6] = "Capability_EOS"] = 6;
        values[valuesById[7] = "Capability_Ethereum"] = 7;
        values[valuesById[8] = "Capability_Lisk"] = 8;
        values[valuesById[9] = "Capability_Monero"] = 9;
        values[valuesById[10] = "Capability_NEM"] = 10;
        values[valuesById[11] = "Capability_Ripple"] = 11;
        values[valuesById[12] = "Capability_Stellar"] = 12;
        values[valuesById[13] = "Capability_Tezos"] = 13;
        values[valuesById[14] = "Capability_U2F"] = 14;
        values[valuesById[15] = "Capability_Shamir"] = 15;
        values[valuesById[16] = "Capability_ShamirGroups"] = 16;
        values[valuesById[17] = "Capability_PassphraseEntry"] = 17;
        return values;
    })();

    return Features;
})();

$root.LockDevice = (function() {

    function LockDevice(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    LockDevice.create = function create(properties) {
        return new LockDevice(properties);
    };

    LockDevice.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    LockDevice.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    LockDevice.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.LockDevice();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    LockDevice.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    LockDevice.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    LockDevice.fromObject = function fromObject(object) {
        if (object instanceof $root.LockDevice)
            return object;
        return new $root.LockDevice();
    };

    LockDevice.toObject = function toObject() {
        return {};
    };

    LockDevice.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return LockDevice;
})();

$root.EndSession = (function() {

    function EndSession(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EndSession.create = function create(properties) {
        return new EndSession(properties);
    };

    EndSession.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    EndSession.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EndSession.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EndSession();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    EndSession.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EndSession.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    EndSession.fromObject = function fromObject(object) {
        if (object instanceof $root.EndSession)
            return object;
        return new $root.EndSession();
    };

    EndSession.toObject = function toObject() {
        return {};
    };

    EndSession.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EndSession;
})();

$root.ApplySettings = (function() {

    function ApplySettings(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ApplySettings.prototype.language = "";
    ApplySettings.prototype.label = "";
    ApplySettings.prototype.use_passphrase = false;
    ApplySettings.prototype.homescreen = $util.newBuffer([]);
    ApplySettings.prototype._passphrase_source = 0;
    ApplySettings.prototype.auto_lock_delay_ms = 0;
    ApplySettings.prototype.display_rotation = 0;
    ApplySettings.prototype.passphrase_always_on_device = false;
    ApplySettings.prototype.safety_checks = 0;
    ApplySettings.prototype.experimental_features = false;
    ApplySettings.prototype.use_ble = false;
    ApplySettings.prototype.use_se = false;
    ApplySettings.prototype.is_bixinapp = false;
    ApplySettings.prototype.fastpay_pin = false;
    ApplySettings.prototype.fastpay_confirm = false;
    ApplySettings.prototype.fastpay_money_limit = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    ApplySettings.prototype.fastpay_times = 0;

    ApplySettings.create = function create(properties) {
        return new ApplySettings(properties);
    };

    ApplySettings.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.language != null && Object.hasOwnProperty.call(message, "language"))
            writer.uint32(10).string(message.language);
        if (message.label != null && Object.hasOwnProperty.call(message, "label"))
            writer.uint32(18).string(message.label);
        if (message.use_passphrase != null && Object.hasOwnProperty.call(message, "use_passphrase"))
            writer.uint32(24).bool(message.use_passphrase);
        if (message.homescreen != null && Object.hasOwnProperty.call(message, "homescreen"))
            writer.uint32(34).bytes(message.homescreen);
        if (message._passphrase_source != null && Object.hasOwnProperty.call(message, "_passphrase_source"))
            writer.uint32(40).uint32(message._passphrase_source);
        if (message.auto_lock_delay_ms != null && Object.hasOwnProperty.call(message, "auto_lock_delay_ms"))
            writer.uint32(48).uint32(message.auto_lock_delay_ms);
        if (message.display_rotation != null && Object.hasOwnProperty.call(message, "display_rotation"))
            writer.uint32(56).uint32(message.display_rotation);
        if (message.passphrase_always_on_device != null && Object.hasOwnProperty.call(message, "passphrase_always_on_device"))
            writer.uint32(64).bool(message.passphrase_always_on_device);
        if (message.safety_checks != null && Object.hasOwnProperty.call(message, "safety_checks"))
            writer.uint32(72).int32(message.safety_checks);
        if (message.experimental_features != null && Object.hasOwnProperty.call(message, "experimental_features"))
            writer.uint32(80).bool(message.experimental_features);
        if (message.use_ble != null && Object.hasOwnProperty.call(message, "use_ble"))
            writer.uint32(800).bool(message.use_ble);
        if (message.use_se != null && Object.hasOwnProperty.call(message, "use_se"))
            writer.uint32(808).bool(message.use_se);
        if (message.is_bixinapp != null && Object.hasOwnProperty.call(message, "is_bixinapp"))
            writer.uint32(816).bool(message.is_bixinapp);
        if (message.fastpay_pin != null && Object.hasOwnProperty.call(message, "fastpay_pin"))
            writer.uint32(824).bool(message.fastpay_pin);
        if (message.fastpay_confirm != null && Object.hasOwnProperty.call(message, "fastpay_confirm"))
            writer.uint32(832).bool(message.fastpay_confirm);
        if (message.fastpay_money_limit != null && Object.hasOwnProperty.call(message, "fastpay_money_limit"))
            writer.uint32(840).uint64(message.fastpay_money_limit);
        if (message.fastpay_times != null && Object.hasOwnProperty.call(message, "fastpay_times"))
            writer.uint32(848).uint32(message.fastpay_times);
        return writer;
    };

    ApplySettings.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ApplySettings.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ApplySettings();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.language = reader.string();
                break;
            case 2:
                message.label = reader.string();
                break;
            case 3:
                message.use_passphrase = reader.bool();
                break;
            case 4:
                message.homescreen = reader.bytes();
                break;
            case 5:
                message._passphrase_source = reader.uint32();
                break;
            case 6:
                message.auto_lock_delay_ms = reader.uint32();
                break;
            case 7:
                message.display_rotation = reader.uint32();
                break;
            case 8:
                message.passphrase_always_on_device = reader.bool();
                break;
            case 9:
                message.safety_checks = reader.int32();
                break;
            case 10:
                message.experimental_features = reader.bool();
                break;
            case 100:
                message.use_ble = reader.bool();
                break;
            case 101:
                message.use_se = reader.bool();
                break;
            case 102:
                message.is_bixinapp = reader.bool();
                break;
            case 103:
                message.fastpay_pin = reader.bool();
                break;
            case 104:
                message.fastpay_confirm = reader.bool();
                break;
            case 105:
                message.fastpay_money_limit = reader.uint64();
                break;
            case 106:
                message.fastpay_times = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    ApplySettings.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ApplySettings.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.language != null && message.hasOwnProperty("language"))
            if (!$util.isString(message.language))
                return "language: string expected";
        if (message.label != null && message.hasOwnProperty("label"))
            if (!$util.isString(message.label))
                return "label: string expected";
        if (message.use_passphrase != null && message.hasOwnProperty("use_passphrase"))
            if (typeof message.use_passphrase !== "boolean")
                return "use_passphrase: boolean expected";
        if (message.homescreen != null && message.hasOwnProperty("homescreen"))
            if (!(message.homescreen && typeof message.homescreen.length === "number" || $util.isString(message.homescreen)))
                return "homescreen: buffer expected";
        if (message._passphrase_source != null && message.hasOwnProperty("_passphrase_source"))
            if (!$util.isInteger(message._passphrase_source))
                return "_passphrase_source: integer expected";
        if (message.auto_lock_delay_ms != null && message.hasOwnProperty("auto_lock_delay_ms"))
            if (!$util.isInteger(message.auto_lock_delay_ms))
                return "auto_lock_delay_ms: integer expected";
        if (message.display_rotation != null && message.hasOwnProperty("display_rotation"))
            if (!$util.isInteger(message.display_rotation))
                return "display_rotation: integer expected";
        if (message.passphrase_always_on_device != null && message.hasOwnProperty("passphrase_always_on_device"))
            if (typeof message.passphrase_always_on_device !== "boolean")
                return "passphrase_always_on_device: boolean expected";
        if (message.safety_checks != null && message.hasOwnProperty("safety_checks"))
            switch (message.safety_checks) {
            default:
                return "safety_checks: enum value expected";
            case 0:
            case 1:
            case 2:
                break;
            }
        if (message.experimental_features != null && message.hasOwnProperty("experimental_features"))
            if (typeof message.experimental_features !== "boolean")
                return "experimental_features: boolean expected";
        if (message.use_ble != null && message.hasOwnProperty("use_ble"))
            if (typeof message.use_ble !== "boolean")
                return "use_ble: boolean expected";
        if (message.use_se != null && message.hasOwnProperty("use_se"))
            if (typeof message.use_se !== "boolean")
                return "use_se: boolean expected";
        if (message.is_bixinapp != null && message.hasOwnProperty("is_bixinapp"))
            if (typeof message.is_bixinapp !== "boolean")
                return "is_bixinapp: boolean expected";
        if (message.fastpay_pin != null && message.hasOwnProperty("fastpay_pin"))
            if (typeof message.fastpay_pin !== "boolean")
                return "fastpay_pin: boolean expected";
        if (message.fastpay_confirm != null && message.hasOwnProperty("fastpay_confirm"))
            if (typeof message.fastpay_confirm !== "boolean")
                return "fastpay_confirm: boolean expected";
        if (message.fastpay_money_limit != null && message.hasOwnProperty("fastpay_money_limit"))
            if (!$util.isInteger(message.fastpay_money_limit) && !(message.fastpay_money_limit && $util.isInteger(message.fastpay_money_limit.low) && $util.isInteger(message.fastpay_money_limit.high)))
                return "fastpay_money_limit: integer|Long expected";
        if (message.fastpay_times != null && message.hasOwnProperty("fastpay_times"))
            if (!$util.isInteger(message.fastpay_times))
                return "fastpay_times: integer expected";
        return null;
    };

    ApplySettings.fromObject = function fromObject(object) {
        if (object instanceof $root.ApplySettings)
            return object;
        var message = new $root.ApplySettings();
        if (object.language != null)
            message.language = String(object.language);
        if (object.label != null)
            message.label = String(object.label);
        if (object.use_passphrase != null)
            message.use_passphrase = Boolean(object.use_passphrase);
        if (object.homescreen != null)
            if (typeof object.homescreen === "string")
                $util.base64.decode(object.homescreen, message.homescreen = $util.newBuffer($util.base64.length(object.homescreen)), 0);
            else if (object.homescreen.length)
                message.homescreen = object.homescreen;
        if (object._passphrase_source != null)
            message._passphrase_source = object._passphrase_source >>> 0;
        if (object.auto_lock_delay_ms != null)
            message.auto_lock_delay_ms = object.auto_lock_delay_ms >>> 0;
        if (object.display_rotation != null)
            message.display_rotation = object.display_rotation >>> 0;
        if (object.passphrase_always_on_device != null)
            message.passphrase_always_on_device = Boolean(object.passphrase_always_on_device);
        switch (object.safety_checks) {
        case "Strict":
        case 0:
            message.safety_checks = 0;
            break;
        case "PromptAlways":
        case 1:
            message.safety_checks = 1;
            break;
        case "PromptTemporarily":
        case 2:
            message.safety_checks = 2;
            break;
        }
        if (object.experimental_features != null)
            message.experimental_features = Boolean(object.experimental_features);
        if (object.use_ble != null)
            message.use_ble = Boolean(object.use_ble);
        if (object.use_se != null)
            message.use_se = Boolean(object.use_se);
        if (object.is_bixinapp != null)
            message.is_bixinapp = Boolean(object.is_bixinapp);
        if (object.fastpay_pin != null)
            message.fastpay_pin = Boolean(object.fastpay_pin);
        if (object.fastpay_confirm != null)
            message.fastpay_confirm = Boolean(object.fastpay_confirm);
        if (object.fastpay_money_limit != null)
            if ($util.Long)
                (message.fastpay_money_limit = $util.Long.fromValue(object.fastpay_money_limit)).unsigned = true;
            else if (typeof object.fastpay_money_limit === "string")
                message.fastpay_money_limit = parseInt(object.fastpay_money_limit, 10);
            else if (typeof object.fastpay_money_limit === "number")
                message.fastpay_money_limit = object.fastpay_money_limit;
            else if (typeof object.fastpay_money_limit === "object")
                message.fastpay_money_limit = new $util.LongBits(object.fastpay_money_limit.low >>> 0, object.fastpay_money_limit.high >>> 0).toNumber(true);
        if (object.fastpay_times != null)
            message.fastpay_times = object.fastpay_times >>> 0;
        return message;
    };

    ApplySettings.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.language = "";
            object.label = "";
            object.use_passphrase = false;
            if (options.bytes === String)
                object.homescreen = "";
            else {
                object.homescreen = [];
                if (options.bytes !== Array)
                    object.homescreen = $util.newBuffer(object.homescreen);
            }
            object._passphrase_source = 0;
            object.auto_lock_delay_ms = 0;
            object.display_rotation = 0;
            object.passphrase_always_on_device = false;
            object.safety_checks = options.enums === String ? "Strict" : 0;
            object.experimental_features = false;
            object.use_ble = false;
            object.use_se = false;
            object.is_bixinapp = false;
            object.fastpay_pin = false;
            object.fastpay_confirm = false;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.fastpay_money_limit = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.fastpay_money_limit = options.longs === String ? "0" : 0;
            object.fastpay_times = 0;
        }
        if (message.language != null && message.hasOwnProperty("language"))
            object.language = message.language;
        if (message.label != null && message.hasOwnProperty("label"))
            object.label = message.label;
        if (message.use_passphrase != null && message.hasOwnProperty("use_passphrase"))
            object.use_passphrase = message.use_passphrase;
        if (message.homescreen != null && message.hasOwnProperty("homescreen"))
            object.homescreen = options.bytes === String ? $util.base64.encode(message.homescreen, 0, message.homescreen.length) : options.bytes === Array ? Array.prototype.slice.call(message.homescreen) : message.homescreen;
        if (message._passphrase_source != null && message.hasOwnProperty("_passphrase_source"))
            object._passphrase_source = message._passphrase_source;
        if (message.auto_lock_delay_ms != null && message.hasOwnProperty("auto_lock_delay_ms"))
            object.auto_lock_delay_ms = message.auto_lock_delay_ms;
        if (message.display_rotation != null && message.hasOwnProperty("display_rotation"))
            object.display_rotation = message.display_rotation;
        if (message.passphrase_always_on_device != null && message.hasOwnProperty("passphrase_always_on_device"))
            object.passphrase_always_on_device = message.passphrase_always_on_device;
        if (message.safety_checks != null && message.hasOwnProperty("safety_checks"))
            object.safety_checks = options.enums === String ? $root.SafetyCheckLevel[message.safety_checks] : message.safety_checks;
        if (message.experimental_features != null && message.hasOwnProperty("experimental_features"))
            object.experimental_features = message.experimental_features;
        if (message.use_ble != null && message.hasOwnProperty("use_ble"))
            object.use_ble = message.use_ble;
        if (message.use_se != null && message.hasOwnProperty("use_se"))
            object.use_se = message.use_se;
        if (message.is_bixinapp != null && message.hasOwnProperty("is_bixinapp"))
            object.is_bixinapp = message.is_bixinapp;
        if (message.fastpay_pin != null && message.hasOwnProperty("fastpay_pin"))
            object.fastpay_pin = message.fastpay_pin;
        if (message.fastpay_confirm != null && message.hasOwnProperty("fastpay_confirm"))
            object.fastpay_confirm = message.fastpay_confirm;
        if (message.fastpay_money_limit != null && message.hasOwnProperty("fastpay_money_limit"))
            if (typeof message.fastpay_money_limit === "number")
                object.fastpay_money_limit = options.longs === String ? String(message.fastpay_money_limit) : message.fastpay_money_limit;
            else
                object.fastpay_money_limit = options.longs === String ? $util.Long.prototype.toString.call(message.fastpay_money_limit) : options.longs === Number ? new $util.LongBits(message.fastpay_money_limit.low >>> 0, message.fastpay_money_limit.high >>> 0).toNumber(true) : message.fastpay_money_limit;
        if (message.fastpay_times != null && message.hasOwnProperty("fastpay_times"))
            object.fastpay_times = message.fastpay_times;
        return object;
    };

    ApplySettings.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    ApplySettings.ExportType = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "SeedEncExportType_NO"] = 0;
        values[valuesById[1] = "SeedEncExportType_YES"] = 1;
        values[valuesById[2] = "MnemonicPlainExportType_YES"] = 2;
        return values;
    })();

    return ApplySettings;
})();

$root.ApplyFlags = (function() {

    function ApplyFlags(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ApplyFlags.prototype.flags = 0;

    ApplyFlags.create = function create(properties) {
        return new ApplyFlags(properties);
    };

    ApplyFlags.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).uint32(message.flags);
        return writer;
    };

    ApplyFlags.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ApplyFlags.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ApplyFlags();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.flags = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("flags"))
            throw $util.ProtocolError("missing required 'flags'", { instance: message });
        return message;
    };

    ApplyFlags.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ApplyFlags.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isInteger(message.flags))
            return "flags: integer expected";
        return null;
    };

    ApplyFlags.fromObject = function fromObject(object) {
        if (object instanceof $root.ApplyFlags)
            return object;
        var message = new $root.ApplyFlags();
        if (object.flags != null)
            message.flags = object.flags >>> 0;
        return message;
    };

    ApplyFlags.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.flags = 0;
        if (message.flags != null && message.hasOwnProperty("flags"))
            object.flags = message.flags;
        return object;
    };

    ApplyFlags.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ApplyFlags;
})();

$root.ChangePin = (function() {

    function ChangePin(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ChangePin.prototype.remove = false;

    ChangePin.create = function create(properties) {
        return new ChangePin(properties);
    };

    ChangePin.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.remove != null && Object.hasOwnProperty.call(message, "remove"))
            writer.uint32(8).bool(message.remove);
        return writer;
    };

    ChangePin.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ChangePin.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ChangePin();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.remove = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    ChangePin.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ChangePin.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.remove != null && message.hasOwnProperty("remove"))
            if (typeof message.remove !== "boolean")
                return "remove: boolean expected";
        return null;
    };

    ChangePin.fromObject = function fromObject(object) {
        if (object instanceof $root.ChangePin)
            return object;
        var message = new $root.ChangePin();
        if (object.remove != null)
            message.remove = Boolean(object.remove);
        return message;
    };

    ChangePin.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.remove = false;
        if (message.remove != null && message.hasOwnProperty("remove"))
            object.remove = message.remove;
        return object;
    };

    ChangePin.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ChangePin;
})();

$root.ChangeWipeCode = (function() {

    function ChangeWipeCode(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ChangeWipeCode.prototype.remove = false;

    ChangeWipeCode.create = function create(properties) {
        return new ChangeWipeCode(properties);
    };

    ChangeWipeCode.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.remove != null && Object.hasOwnProperty.call(message, "remove"))
            writer.uint32(8).bool(message.remove);
        return writer;
    };

    ChangeWipeCode.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ChangeWipeCode.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ChangeWipeCode();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.remove = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    ChangeWipeCode.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ChangeWipeCode.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.remove != null && message.hasOwnProperty("remove"))
            if (typeof message.remove !== "boolean")
                return "remove: boolean expected";
        return null;
    };

    ChangeWipeCode.fromObject = function fromObject(object) {
        if (object instanceof $root.ChangeWipeCode)
            return object;
        var message = new $root.ChangeWipeCode();
        if (object.remove != null)
            message.remove = Boolean(object.remove);
        return message;
    };

    ChangeWipeCode.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.remove = false;
        if (message.remove != null && message.hasOwnProperty("remove"))
            object.remove = message.remove;
        return object;
    };

    ChangeWipeCode.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ChangeWipeCode;
})();

$root.SdProtect = (function() {

    function SdProtect(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    SdProtect.prototype.operation = 0;

    SdProtect.create = function create(properties) {
        return new SdProtect(properties);
    };

    SdProtect.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).int32(message.operation);
        return writer;
    };

    SdProtect.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    SdProtect.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SdProtect();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.operation = reader.int32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("operation"))
            throw $util.ProtocolError("missing required 'operation'", { instance: message });
        return message;
    };

    SdProtect.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    SdProtect.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        switch (message.operation) {
        default:
            return "operation: enum value expected";
        case 0:
        case 1:
        case 2:
            break;
        }
        return null;
    };

    SdProtect.fromObject = function fromObject(object) {
        if (object instanceof $root.SdProtect)
            return object;
        var message = new $root.SdProtect();
        switch (object.operation) {
        case "DISABLE":
        case 0:
            message.operation = 0;
            break;
        case "ENABLE":
        case 1:
            message.operation = 1;
            break;
        case "REFRESH":
        case 2:
            message.operation = 2;
            break;
        }
        return message;
    };

    SdProtect.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.operation = options.enums === String ? "DISABLE" : 0;
        if (message.operation != null && message.hasOwnProperty("operation"))
            object.operation = options.enums === String ? $root.SdProtect.SdProtectOperationType[message.operation] : message.operation;
        return object;
    };

    SdProtect.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    SdProtect.SdProtectOperationType = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "DISABLE"] = 0;
        values[valuesById[1] = "ENABLE"] = 1;
        values[valuesById[2] = "REFRESH"] = 2;
        return values;
    })();

    return SdProtect;
})();

$root.Ping = (function() {

    function Ping(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    Ping.prototype.message = "";
    Ping.prototype.button_protection = false;

    Ping.create = function create(properties) {
        return new Ping(properties);
    };

    Ping.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
            writer.uint32(10).string(message.message);
        if (message.button_protection != null && Object.hasOwnProperty.call(message, "button_protection"))
            writer.uint32(16).bool(message.button_protection);
        return writer;
    };

    Ping.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    Ping.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Ping();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.message = reader.string();
                break;
            case 2:
                message.button_protection = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    Ping.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    Ping.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.message != null && message.hasOwnProperty("message"))
            if (!$util.isString(message.message))
                return "message: string expected";
        if (message.button_protection != null && message.hasOwnProperty("button_protection"))
            if (typeof message.button_protection !== "boolean")
                return "button_protection: boolean expected";
        return null;
    };

    Ping.fromObject = function fromObject(object) {
        if (object instanceof $root.Ping)
            return object;
        var message = new $root.Ping();
        if (object.message != null)
            message.message = String(object.message);
        if (object.button_protection != null)
            message.button_protection = Boolean(object.button_protection);
        return message;
    };

    Ping.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.message = "";
            object.button_protection = false;
        }
        if (message.message != null && message.hasOwnProperty("message"))
            object.message = message.message;
        if (message.button_protection != null && message.hasOwnProperty("button_protection"))
            object.button_protection = message.button_protection;
        return object;
    };

    Ping.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return Ping;
})();

$root.Cancel = (function() {

    function Cancel(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    Cancel.create = function create(properties) {
        return new Cancel(properties);
    };

    Cancel.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    Cancel.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    Cancel.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Cancel();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    Cancel.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    Cancel.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    Cancel.fromObject = function fromObject(object) {
        if (object instanceof $root.Cancel)
            return object;
        return new $root.Cancel();
    };

    Cancel.toObject = function toObject() {
        return {};
    };

    Cancel.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return Cancel;
})();

$root.GetEntropy = (function() {

    function GetEntropy(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    GetEntropy.prototype.size = 0;

    GetEntropy.create = function create(properties) {
        return new GetEntropy(properties);
    };

    GetEntropy.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).uint32(message.size);
        return writer;
    };

    GetEntropy.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    GetEntropy.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.GetEntropy();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.size = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("size"))
            throw $util.ProtocolError("missing required 'size'", { instance: message });
        return message;
    };

    GetEntropy.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    GetEntropy.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isInteger(message.size))
            return "size: integer expected";
        return null;
    };

    GetEntropy.fromObject = function fromObject(object) {
        if (object instanceof $root.GetEntropy)
            return object;
        var message = new $root.GetEntropy();
        if (object.size != null)
            message.size = object.size >>> 0;
        return message;
    };

    GetEntropy.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.size = 0;
        if (message.size != null && message.hasOwnProperty("size"))
            object.size = message.size;
        return object;
    };

    GetEntropy.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return GetEntropy;
})();

$root.Entropy = (function() {

    function Entropy(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    Entropy.prototype.entropy = $util.newBuffer([]);

    Entropy.create = function create(properties) {
        return new Entropy(properties);
    };

    Entropy.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.entropy);
        return writer;
    };

    Entropy.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    Entropy.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Entropy();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.entropy = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("entropy"))
            throw $util.ProtocolError("missing required 'entropy'", { instance: message });
        return message;
    };

    Entropy.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    Entropy.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.entropy && typeof message.entropy.length === "number" || $util.isString(message.entropy)))
            return "entropy: buffer expected";
        return null;
    };

    Entropy.fromObject = function fromObject(object) {
        if (object instanceof $root.Entropy)
            return object;
        var message = new $root.Entropy();
        if (object.entropy != null)
            if (typeof object.entropy === "string")
                $util.base64.decode(object.entropy, message.entropy = $util.newBuffer($util.base64.length(object.entropy)), 0);
            else if (object.entropy.length)
                message.entropy = object.entropy;
        return message;
    };

    Entropy.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.entropy = "";
            else {
                object.entropy = [];
                if (options.bytes !== Array)
                    object.entropy = $util.newBuffer(object.entropy);
            }
        if (message.entropy != null && message.hasOwnProperty("entropy"))
            object.entropy = options.bytes === String ? $util.base64.encode(message.entropy, 0, message.entropy.length) : options.bytes === Array ? Array.prototype.slice.call(message.entropy) : message.entropy;
        return object;
    };

    Entropy.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return Entropy;
})();

$root.WipeDevice = (function() {

    function WipeDevice(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    WipeDevice.create = function create(properties) {
        return new WipeDevice(properties);
    };

    WipeDevice.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    WipeDevice.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    WipeDevice.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.WipeDevice();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    WipeDevice.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    WipeDevice.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    WipeDevice.fromObject = function fromObject(object) {
        if (object instanceof $root.WipeDevice)
            return object;
        return new $root.WipeDevice();
    };

    WipeDevice.toObject = function toObject() {
        return {};
    };

    WipeDevice.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return WipeDevice;
})();

$root.LoadDevice = (function() {

    function LoadDevice(properties) {
        this.mnemonics = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    LoadDevice.prototype.mnemonics = $util.emptyArray;
    LoadDevice.prototype.pin = "";
    LoadDevice.prototype.passphrase_protection = false;
    LoadDevice.prototype.language = "en-US";
    LoadDevice.prototype.label = "";
    LoadDevice.prototype.skip_checksum = false;
    LoadDevice.prototype.u2f_counter = 0;
    LoadDevice.prototype.needs_backup = false;
    LoadDevice.prototype.no_backup = false;

    LoadDevice.create = function create(properties) {
        return new LoadDevice(properties);
    };

    LoadDevice.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.mnemonics != null && message.mnemonics.length)
            for (var i = 0; i < message.mnemonics.length; ++i)
                writer.uint32(10).string(message.mnemonics[i]);
        if (message.pin != null && Object.hasOwnProperty.call(message, "pin"))
            writer.uint32(26).string(message.pin);
        if (message.passphrase_protection != null && Object.hasOwnProperty.call(message, "passphrase_protection"))
            writer.uint32(32).bool(message.passphrase_protection);
        if (message.language != null && Object.hasOwnProperty.call(message, "language"))
            writer.uint32(42).string(message.language);
        if (message.label != null && Object.hasOwnProperty.call(message, "label"))
            writer.uint32(50).string(message.label);
        if (message.skip_checksum != null && Object.hasOwnProperty.call(message, "skip_checksum"))
            writer.uint32(56).bool(message.skip_checksum);
        if (message.u2f_counter != null && Object.hasOwnProperty.call(message, "u2f_counter"))
            writer.uint32(64).uint32(message.u2f_counter);
        if (message.needs_backup != null && Object.hasOwnProperty.call(message, "needs_backup"))
            writer.uint32(72).bool(message.needs_backup);
        if (message.no_backup != null && Object.hasOwnProperty.call(message, "no_backup"))
            writer.uint32(80).bool(message.no_backup);
        return writer;
    };

    LoadDevice.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    LoadDevice.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.LoadDevice();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.mnemonics && message.mnemonics.length))
                    message.mnemonics = [];
                message.mnemonics.push(reader.string());
                break;
            case 3:
                message.pin = reader.string();
                break;
            case 4:
                message.passphrase_protection = reader.bool();
                break;
            case 5:
                message.language = reader.string();
                break;
            case 6:
                message.label = reader.string();
                break;
            case 7:
                message.skip_checksum = reader.bool();
                break;
            case 8:
                message.u2f_counter = reader.uint32();
                break;
            case 9:
                message.needs_backup = reader.bool();
                break;
            case 10:
                message.no_backup = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    LoadDevice.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    LoadDevice.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.mnemonics != null && message.hasOwnProperty("mnemonics")) {
            if (!Array.isArray(message.mnemonics))
                return "mnemonics: array expected";
            for (var i = 0; i < message.mnemonics.length; ++i)
                if (!$util.isString(message.mnemonics[i]))
                    return "mnemonics: string[] expected";
        }
        if (message.pin != null && message.hasOwnProperty("pin"))
            if (!$util.isString(message.pin))
                return "pin: string expected";
        if (message.passphrase_protection != null && message.hasOwnProperty("passphrase_protection"))
            if (typeof message.passphrase_protection !== "boolean")
                return "passphrase_protection: boolean expected";
        if (message.language != null && message.hasOwnProperty("language"))
            if (!$util.isString(message.language))
                return "language: string expected";
        if (message.label != null && message.hasOwnProperty("label"))
            if (!$util.isString(message.label))
                return "label: string expected";
        if (message.skip_checksum != null && message.hasOwnProperty("skip_checksum"))
            if (typeof message.skip_checksum !== "boolean")
                return "skip_checksum: boolean expected";
        if (message.u2f_counter != null && message.hasOwnProperty("u2f_counter"))
            if (!$util.isInteger(message.u2f_counter))
                return "u2f_counter: integer expected";
        if (message.needs_backup != null && message.hasOwnProperty("needs_backup"))
            if (typeof message.needs_backup !== "boolean")
                return "needs_backup: boolean expected";
        if (message.no_backup != null && message.hasOwnProperty("no_backup"))
            if (typeof message.no_backup !== "boolean")
                return "no_backup: boolean expected";
        return null;
    };

    LoadDevice.fromObject = function fromObject(object) {
        if (object instanceof $root.LoadDevice)
            return object;
        var message = new $root.LoadDevice();
        if (object.mnemonics) {
            if (!Array.isArray(object.mnemonics))
                throw TypeError(".LoadDevice.mnemonics: array expected");
            message.mnemonics = [];
            for (var i = 0; i < object.mnemonics.length; ++i)
                message.mnemonics[i] = String(object.mnemonics[i]);
        }
        if (object.pin != null)
            message.pin = String(object.pin);
        if (object.passphrase_protection != null)
            message.passphrase_protection = Boolean(object.passphrase_protection);
        if (object.language != null)
            message.language = String(object.language);
        if (object.label != null)
            message.label = String(object.label);
        if (object.skip_checksum != null)
            message.skip_checksum = Boolean(object.skip_checksum);
        if (object.u2f_counter != null)
            message.u2f_counter = object.u2f_counter >>> 0;
        if (object.needs_backup != null)
            message.needs_backup = Boolean(object.needs_backup);
        if (object.no_backup != null)
            message.no_backup = Boolean(object.no_backup);
        return message;
    };

    LoadDevice.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.mnemonics = [];
        if (options.defaults) {
            object.pin = "";
            object.passphrase_protection = false;
            object.language = "en-US";
            object.label = "";
            object.skip_checksum = false;
            object.u2f_counter = 0;
            object.needs_backup = false;
            object.no_backup = false;
        }
        if (message.mnemonics && message.mnemonics.length) {
            object.mnemonics = [];
            for (var j = 0; j < message.mnemonics.length; ++j)
                object.mnemonics[j] = message.mnemonics[j];
        }
        if (message.pin != null && message.hasOwnProperty("pin"))
            object.pin = message.pin;
        if (message.passphrase_protection != null && message.hasOwnProperty("passphrase_protection"))
            object.passphrase_protection = message.passphrase_protection;
        if (message.language != null && message.hasOwnProperty("language"))
            object.language = message.language;
        if (message.label != null && message.hasOwnProperty("label"))
            object.label = message.label;
        if (message.skip_checksum != null && message.hasOwnProperty("skip_checksum"))
            object.skip_checksum = message.skip_checksum;
        if (message.u2f_counter != null && message.hasOwnProperty("u2f_counter"))
            object.u2f_counter = message.u2f_counter;
        if (message.needs_backup != null && message.hasOwnProperty("needs_backup"))
            object.needs_backup = message.needs_backup;
        if (message.no_backup != null && message.hasOwnProperty("no_backup"))
            object.no_backup = message.no_backup;
        return object;
    };

    LoadDevice.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return LoadDevice;
})();

$root.ResetDevice = (function() {

    function ResetDevice(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ResetDevice.prototype.display_random = false;
    ResetDevice.prototype.strength = 256;
    ResetDevice.prototype.passphrase_protection = false;
    ResetDevice.prototype.pin_protection = false;
    ResetDevice.prototype.language = "en-US";
    ResetDevice.prototype.label = "";
    ResetDevice.prototype.u2f_counter = 0;
    ResetDevice.prototype.skip_backup = false;
    ResetDevice.prototype.no_backup = false;
    ResetDevice.prototype.backup_type = 0;

    ResetDevice.create = function create(properties) {
        return new ResetDevice(properties);
    };

    ResetDevice.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.display_random != null && Object.hasOwnProperty.call(message, "display_random"))
            writer.uint32(8).bool(message.display_random);
        if (message.strength != null && Object.hasOwnProperty.call(message, "strength"))
            writer.uint32(16).uint32(message.strength);
        if (message.passphrase_protection != null && Object.hasOwnProperty.call(message, "passphrase_protection"))
            writer.uint32(24).bool(message.passphrase_protection);
        if (message.pin_protection != null && Object.hasOwnProperty.call(message, "pin_protection"))
            writer.uint32(32).bool(message.pin_protection);
        if (message.language != null && Object.hasOwnProperty.call(message, "language"))
            writer.uint32(42).string(message.language);
        if (message.label != null && Object.hasOwnProperty.call(message, "label"))
            writer.uint32(50).string(message.label);
        if (message.u2f_counter != null && Object.hasOwnProperty.call(message, "u2f_counter"))
            writer.uint32(56).uint32(message.u2f_counter);
        if (message.skip_backup != null && Object.hasOwnProperty.call(message, "skip_backup"))
            writer.uint32(64).bool(message.skip_backup);
        if (message.no_backup != null && Object.hasOwnProperty.call(message, "no_backup"))
            writer.uint32(72).bool(message.no_backup);
        if (message.backup_type != null && Object.hasOwnProperty.call(message, "backup_type"))
            writer.uint32(80).int32(message.backup_type);
        return writer;
    };

    ResetDevice.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ResetDevice.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ResetDevice();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.display_random = reader.bool();
                break;
            case 2:
                message.strength = reader.uint32();
                break;
            case 3:
                message.passphrase_protection = reader.bool();
                break;
            case 4:
                message.pin_protection = reader.bool();
                break;
            case 5:
                message.language = reader.string();
                break;
            case 6:
                message.label = reader.string();
                break;
            case 7:
                message.u2f_counter = reader.uint32();
                break;
            case 8:
                message.skip_backup = reader.bool();
                break;
            case 9:
                message.no_backup = reader.bool();
                break;
            case 10:
                message.backup_type = reader.int32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    ResetDevice.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ResetDevice.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.display_random != null && message.hasOwnProperty("display_random"))
            if (typeof message.display_random !== "boolean")
                return "display_random: boolean expected";
        if (message.strength != null && message.hasOwnProperty("strength"))
            if (!$util.isInteger(message.strength))
                return "strength: integer expected";
        if (message.passphrase_protection != null && message.hasOwnProperty("passphrase_protection"))
            if (typeof message.passphrase_protection !== "boolean")
                return "passphrase_protection: boolean expected";
        if (message.pin_protection != null && message.hasOwnProperty("pin_protection"))
            if (typeof message.pin_protection !== "boolean")
                return "pin_protection: boolean expected";
        if (message.language != null && message.hasOwnProperty("language"))
            if (!$util.isString(message.language))
                return "language: string expected";
        if (message.label != null && message.hasOwnProperty("label"))
            if (!$util.isString(message.label))
                return "label: string expected";
        if (message.u2f_counter != null && message.hasOwnProperty("u2f_counter"))
            if (!$util.isInteger(message.u2f_counter))
                return "u2f_counter: integer expected";
        if (message.skip_backup != null && message.hasOwnProperty("skip_backup"))
            if (typeof message.skip_backup !== "boolean")
                return "skip_backup: boolean expected";
        if (message.no_backup != null && message.hasOwnProperty("no_backup"))
            if (typeof message.no_backup !== "boolean")
                return "no_backup: boolean expected";
        if (message.backup_type != null && message.hasOwnProperty("backup_type"))
            switch (message.backup_type) {
            default:
                return "backup_type: enum value expected";
            case 0:
            case 1:
            case 2:
                break;
            }
        return null;
    };

    ResetDevice.fromObject = function fromObject(object) {
        if (object instanceof $root.ResetDevice)
            return object;
        var message = new $root.ResetDevice();
        if (object.display_random != null)
            message.display_random = Boolean(object.display_random);
        if (object.strength != null)
            message.strength = object.strength >>> 0;
        if (object.passphrase_protection != null)
            message.passphrase_protection = Boolean(object.passphrase_protection);
        if (object.pin_protection != null)
            message.pin_protection = Boolean(object.pin_protection);
        if (object.language != null)
            message.language = String(object.language);
        if (object.label != null)
            message.label = String(object.label);
        if (object.u2f_counter != null)
            message.u2f_counter = object.u2f_counter >>> 0;
        if (object.skip_backup != null)
            message.skip_backup = Boolean(object.skip_backup);
        if (object.no_backup != null)
            message.no_backup = Boolean(object.no_backup);
        switch (object.backup_type) {
        case "Bip39":
        case 0:
            message.backup_type = 0;
            break;
        case "Slip39_Basic":
        case 1:
            message.backup_type = 1;
            break;
        case "Slip39_Advanced":
        case 2:
            message.backup_type = 2;
            break;
        }
        return message;
    };

    ResetDevice.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.display_random = false;
            object.strength = 256;
            object.passphrase_protection = false;
            object.pin_protection = false;
            object.language = "en-US";
            object.label = "";
            object.u2f_counter = 0;
            object.skip_backup = false;
            object.no_backup = false;
            object.backup_type = options.enums === String ? "Bip39" : 0;
        }
        if (message.display_random != null && message.hasOwnProperty("display_random"))
            object.display_random = message.display_random;
        if (message.strength != null && message.hasOwnProperty("strength"))
            object.strength = message.strength;
        if (message.passphrase_protection != null && message.hasOwnProperty("passphrase_protection"))
            object.passphrase_protection = message.passphrase_protection;
        if (message.pin_protection != null && message.hasOwnProperty("pin_protection"))
            object.pin_protection = message.pin_protection;
        if (message.language != null && message.hasOwnProperty("language"))
            object.language = message.language;
        if (message.label != null && message.hasOwnProperty("label"))
            object.label = message.label;
        if (message.u2f_counter != null && message.hasOwnProperty("u2f_counter"))
            object.u2f_counter = message.u2f_counter;
        if (message.skip_backup != null && message.hasOwnProperty("skip_backup"))
            object.skip_backup = message.skip_backup;
        if (message.no_backup != null && message.hasOwnProperty("no_backup"))
            object.no_backup = message.no_backup;
        if (message.backup_type != null && message.hasOwnProperty("backup_type"))
            object.backup_type = options.enums === String ? $root.BackupType[message.backup_type] : message.backup_type;
        return object;
    };

    ResetDevice.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ResetDevice;
})();

$root.BackupDevice = (function() {

    function BackupDevice(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    BackupDevice.create = function create(properties) {
        return new BackupDevice(properties);
    };

    BackupDevice.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    BackupDevice.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    BackupDevice.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BackupDevice();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    BackupDevice.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    BackupDevice.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    BackupDevice.fromObject = function fromObject(object) {
        if (object instanceof $root.BackupDevice)
            return object;
        return new $root.BackupDevice();
    };

    BackupDevice.toObject = function toObject() {
        return {};
    };

    BackupDevice.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return BackupDevice;
})();

$root.EntropyRequest = (function() {

    function EntropyRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EntropyRequest.create = function create(properties) {
        return new EntropyRequest(properties);
    };

    EntropyRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    EntropyRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EntropyRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EntropyRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    EntropyRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EntropyRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    EntropyRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.EntropyRequest)
            return object;
        return new $root.EntropyRequest();
    };

    EntropyRequest.toObject = function toObject() {
        return {};
    };

    EntropyRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EntropyRequest;
})();

$root.EntropyAck = (function() {

    function EntropyAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EntropyAck.prototype.entropy = $util.newBuffer([]);

    EntropyAck.create = function create(properties) {
        return new EntropyAck(properties);
    };

    EntropyAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.entropy);
        return writer;
    };

    EntropyAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EntropyAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EntropyAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.entropy = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("entropy"))
            throw $util.ProtocolError("missing required 'entropy'", { instance: message });
        return message;
    };

    EntropyAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EntropyAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.entropy && typeof message.entropy.length === "number" || $util.isString(message.entropy)))
            return "entropy: buffer expected";
        return null;
    };

    EntropyAck.fromObject = function fromObject(object) {
        if (object instanceof $root.EntropyAck)
            return object;
        var message = new $root.EntropyAck();
        if (object.entropy != null)
            if (typeof object.entropy === "string")
                $util.base64.decode(object.entropy, message.entropy = $util.newBuffer($util.base64.length(object.entropy)), 0);
            else if (object.entropy.length)
                message.entropy = object.entropy;
        return message;
    };

    EntropyAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.entropy = "";
            else {
                object.entropy = [];
                if (options.bytes !== Array)
                    object.entropy = $util.newBuffer(object.entropy);
            }
        if (message.entropy != null && message.hasOwnProperty("entropy"))
            object.entropy = options.bytes === String ? $util.base64.encode(message.entropy, 0, message.entropy.length) : options.bytes === Array ? Array.prototype.slice.call(message.entropy) : message.entropy;
        return object;
    };

    EntropyAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EntropyAck;
})();

$root.RecoveryDevice = (function() {

    function RecoveryDevice(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    RecoveryDevice.prototype.word_count = 0;
    RecoveryDevice.prototype.passphrase_protection = false;
    RecoveryDevice.prototype.pin_protection = false;
    RecoveryDevice.prototype.language = "";
    RecoveryDevice.prototype.label = "";
    RecoveryDevice.prototype.enforce_wordlist = false;
    RecoveryDevice.prototype.type = 0;
    RecoveryDevice.prototype.u2f_counter = 0;
    RecoveryDevice.prototype.dry_run = false;

    RecoveryDevice.create = function create(properties) {
        return new RecoveryDevice(properties);
    };

    RecoveryDevice.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.word_count != null && Object.hasOwnProperty.call(message, "word_count"))
            writer.uint32(8).uint32(message.word_count);
        if (message.passphrase_protection != null && Object.hasOwnProperty.call(message, "passphrase_protection"))
            writer.uint32(16).bool(message.passphrase_protection);
        if (message.pin_protection != null && Object.hasOwnProperty.call(message, "pin_protection"))
            writer.uint32(24).bool(message.pin_protection);
        if (message.language != null && Object.hasOwnProperty.call(message, "language"))
            writer.uint32(34).string(message.language);
        if (message.label != null && Object.hasOwnProperty.call(message, "label"))
            writer.uint32(42).string(message.label);
        if (message.enforce_wordlist != null && Object.hasOwnProperty.call(message, "enforce_wordlist"))
            writer.uint32(48).bool(message.enforce_wordlist);
        if (message.type != null && Object.hasOwnProperty.call(message, "type"))
            writer.uint32(64).int32(message.type);
        if (message.u2f_counter != null && Object.hasOwnProperty.call(message, "u2f_counter"))
            writer.uint32(72).uint32(message.u2f_counter);
        if (message.dry_run != null && Object.hasOwnProperty.call(message, "dry_run"))
            writer.uint32(80).bool(message.dry_run);
        return writer;
    };

    RecoveryDevice.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    RecoveryDevice.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.RecoveryDevice();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.word_count = reader.uint32();
                break;
            case 2:
                message.passphrase_protection = reader.bool();
                break;
            case 3:
                message.pin_protection = reader.bool();
                break;
            case 4:
                message.language = reader.string();
                break;
            case 5:
                message.label = reader.string();
                break;
            case 6:
                message.enforce_wordlist = reader.bool();
                break;
            case 8:
                message.type = reader.int32();
                break;
            case 9:
                message.u2f_counter = reader.uint32();
                break;
            case 10:
                message.dry_run = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    RecoveryDevice.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    RecoveryDevice.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.word_count != null && message.hasOwnProperty("word_count"))
            if (!$util.isInteger(message.word_count))
                return "word_count: integer expected";
        if (message.passphrase_protection != null && message.hasOwnProperty("passphrase_protection"))
            if (typeof message.passphrase_protection !== "boolean")
                return "passphrase_protection: boolean expected";
        if (message.pin_protection != null && message.hasOwnProperty("pin_protection"))
            if (typeof message.pin_protection !== "boolean")
                return "pin_protection: boolean expected";
        if (message.language != null && message.hasOwnProperty("language"))
            if (!$util.isString(message.language))
                return "language: string expected";
        if (message.label != null && message.hasOwnProperty("label"))
            if (!$util.isString(message.label))
                return "label: string expected";
        if (message.enforce_wordlist != null && message.hasOwnProperty("enforce_wordlist"))
            if (typeof message.enforce_wordlist !== "boolean")
                return "enforce_wordlist: boolean expected";
        if (message.type != null && message.hasOwnProperty("type"))
            switch (message.type) {
            default:
                return "type: enum value expected";
            case 0:
            case 1:
                break;
            }
        if (message.u2f_counter != null && message.hasOwnProperty("u2f_counter"))
            if (!$util.isInteger(message.u2f_counter))
                return "u2f_counter: integer expected";
        if (message.dry_run != null && message.hasOwnProperty("dry_run"))
            if (typeof message.dry_run !== "boolean")
                return "dry_run: boolean expected";
        return null;
    };

    RecoveryDevice.fromObject = function fromObject(object) {
        if (object instanceof $root.RecoveryDevice)
            return object;
        var message = new $root.RecoveryDevice();
        if (object.word_count != null)
            message.word_count = object.word_count >>> 0;
        if (object.passphrase_protection != null)
            message.passphrase_protection = Boolean(object.passphrase_protection);
        if (object.pin_protection != null)
            message.pin_protection = Boolean(object.pin_protection);
        if (object.language != null)
            message.language = String(object.language);
        if (object.label != null)
            message.label = String(object.label);
        if (object.enforce_wordlist != null)
            message.enforce_wordlist = Boolean(object.enforce_wordlist);
        switch (object.type) {
        case "RecoveryDeviceType_ScrambledWords":
        case 0:
            message.type = 0;
            break;
        case "RecoveryDeviceType_Matrix":
        case 1:
            message.type = 1;
            break;
        }
        if (object.u2f_counter != null)
            message.u2f_counter = object.u2f_counter >>> 0;
        if (object.dry_run != null)
            message.dry_run = Boolean(object.dry_run);
        return message;
    };

    RecoveryDevice.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.word_count = 0;
            object.passphrase_protection = false;
            object.pin_protection = false;
            object.language = "";
            object.label = "";
            object.enforce_wordlist = false;
            object.type = options.enums === String ? "RecoveryDeviceType_ScrambledWords" : 0;
            object.u2f_counter = 0;
            object.dry_run = false;
        }
        if (message.word_count != null && message.hasOwnProperty("word_count"))
            object.word_count = message.word_count;
        if (message.passphrase_protection != null && message.hasOwnProperty("passphrase_protection"))
            object.passphrase_protection = message.passphrase_protection;
        if (message.pin_protection != null && message.hasOwnProperty("pin_protection"))
            object.pin_protection = message.pin_protection;
        if (message.language != null && message.hasOwnProperty("language"))
            object.language = message.language;
        if (message.label != null && message.hasOwnProperty("label"))
            object.label = message.label;
        if (message.enforce_wordlist != null && message.hasOwnProperty("enforce_wordlist"))
            object.enforce_wordlist = message.enforce_wordlist;
        if (message.type != null && message.hasOwnProperty("type"))
            object.type = options.enums === String ? $root.RecoveryDevice.RecoveryDeviceType[message.type] : message.type;
        if (message.u2f_counter != null && message.hasOwnProperty("u2f_counter"))
            object.u2f_counter = message.u2f_counter;
        if (message.dry_run != null && message.hasOwnProperty("dry_run"))
            object.dry_run = message.dry_run;
        return object;
    };

    RecoveryDevice.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    RecoveryDevice.RecoveryDeviceType = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "RecoveryDeviceType_ScrambledWords"] = 0;
        values[valuesById[1] = "RecoveryDeviceType_Matrix"] = 1;
        return values;
    })();

    return RecoveryDevice;
})();

$root.WordRequest = (function() {

    function WordRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    WordRequest.prototype.type = 0;

    WordRequest.create = function create(properties) {
        return new WordRequest(properties);
    };

    WordRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).int32(message.type);
        return writer;
    };

    WordRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    WordRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.WordRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.type = reader.int32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("type"))
            throw $util.ProtocolError("missing required 'type'", { instance: message });
        return message;
    };

    WordRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    WordRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        switch (message.type) {
        default:
            return "type: enum value expected";
        case 0:
        case 1:
        case 2:
            break;
        }
        return null;
    };

    WordRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.WordRequest)
            return object;
        var message = new $root.WordRequest();
        switch (object.type) {
        case "WordRequestType_Plain":
        case 0:
            message.type = 0;
            break;
        case "WordRequestType_Matrix9":
        case 1:
            message.type = 1;
            break;
        case "WordRequestType_Matrix6":
        case 2:
            message.type = 2;
            break;
        }
        return message;
    };

    WordRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.type = options.enums === String ? "WordRequestType_Plain" : 0;
        if (message.type != null && message.hasOwnProperty("type"))
            object.type = options.enums === String ? $root.WordRequest.WordRequestType[message.type] : message.type;
        return object;
    };

    WordRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    WordRequest.WordRequestType = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "WordRequestType_Plain"] = 0;
        values[valuesById[1] = "WordRequestType_Matrix9"] = 1;
        values[valuesById[2] = "WordRequestType_Matrix6"] = 2;
        return values;
    })();

    return WordRequest;
})();

$root.WordAck = (function() {

    function WordAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    WordAck.prototype.word = "";

    WordAck.create = function create(properties) {
        return new WordAck(properties);
    };

    WordAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.word);
        return writer;
    };

    WordAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    WordAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.WordAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.word = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("word"))
            throw $util.ProtocolError("missing required 'word'", { instance: message });
        return message;
    };

    WordAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    WordAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.word))
            return "word: string expected";
        return null;
    };

    WordAck.fromObject = function fromObject(object) {
        if (object instanceof $root.WordAck)
            return object;
        var message = new $root.WordAck();
        if (object.word != null)
            message.word = String(object.word);
        return message;
    };

    WordAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.word = "";
        if (message.word != null && message.hasOwnProperty("word"))
            object.word = message.word;
        return object;
    };

    WordAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return WordAck;
})();

$root.SetU2FCounter = (function() {

    function SetU2FCounter(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    SetU2FCounter.prototype.u2f_counter = 0;

    SetU2FCounter.create = function create(properties) {
        return new SetU2FCounter(properties);
    };

    SetU2FCounter.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).uint32(message.u2f_counter);
        return writer;
    };

    SetU2FCounter.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    SetU2FCounter.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SetU2FCounter();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.u2f_counter = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("u2f_counter"))
            throw $util.ProtocolError("missing required 'u2f_counter'", { instance: message });
        return message;
    };

    SetU2FCounter.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    SetU2FCounter.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isInteger(message.u2f_counter))
            return "u2f_counter: integer expected";
        return null;
    };

    SetU2FCounter.fromObject = function fromObject(object) {
        if (object instanceof $root.SetU2FCounter)
            return object;
        var message = new $root.SetU2FCounter();
        if (object.u2f_counter != null)
            message.u2f_counter = object.u2f_counter >>> 0;
        return message;
    };

    SetU2FCounter.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.u2f_counter = 0;
        if (message.u2f_counter != null && message.hasOwnProperty("u2f_counter"))
            object.u2f_counter = message.u2f_counter;
        return object;
    };

    SetU2FCounter.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SetU2FCounter;
})();

$root.GetNextU2FCounter = (function() {

    function GetNextU2FCounter(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    GetNextU2FCounter.create = function create(properties) {
        return new GetNextU2FCounter(properties);
    };

    GetNextU2FCounter.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    GetNextU2FCounter.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    GetNextU2FCounter.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.GetNextU2FCounter();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    GetNextU2FCounter.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    GetNextU2FCounter.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    GetNextU2FCounter.fromObject = function fromObject(object) {
        if (object instanceof $root.GetNextU2FCounter)
            return object;
        return new $root.GetNextU2FCounter();
    };

    GetNextU2FCounter.toObject = function toObject() {
        return {};
    };

    GetNextU2FCounter.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return GetNextU2FCounter;
})();

$root.NextU2FCounter = (function() {

    function NextU2FCounter(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NextU2FCounter.prototype.u2f_counter = 0;

    NextU2FCounter.create = function create(properties) {
        return new NextU2FCounter(properties);
    };

    NextU2FCounter.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).uint32(message.u2f_counter);
        return writer;
    };

    NextU2FCounter.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NextU2FCounter.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NextU2FCounter();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.u2f_counter = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("u2f_counter"))
            throw $util.ProtocolError("missing required 'u2f_counter'", { instance: message });
        return message;
    };

    NextU2FCounter.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NextU2FCounter.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isInteger(message.u2f_counter))
            return "u2f_counter: integer expected";
        return null;
    };

    NextU2FCounter.fromObject = function fromObject(object) {
        if (object instanceof $root.NextU2FCounter)
            return object;
        var message = new $root.NextU2FCounter();
        if (object.u2f_counter != null)
            message.u2f_counter = object.u2f_counter >>> 0;
        return message;
    };

    NextU2FCounter.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.u2f_counter = 0;
        if (message.u2f_counter != null && message.hasOwnProperty("u2f_counter"))
            object.u2f_counter = message.u2f_counter;
        return object;
    };

    NextU2FCounter.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NextU2FCounter;
})();

$root.DoPreauthorized = (function() {

    function DoPreauthorized(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DoPreauthorized.create = function create(properties) {
        return new DoPreauthorized(properties);
    };

    DoPreauthorized.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    DoPreauthorized.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DoPreauthorized.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DoPreauthorized();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    DoPreauthorized.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DoPreauthorized.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    DoPreauthorized.fromObject = function fromObject(object) {
        if (object instanceof $root.DoPreauthorized)
            return object;
        return new $root.DoPreauthorized();
    };

    DoPreauthorized.toObject = function toObject() {
        return {};
    };

    DoPreauthorized.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DoPreauthorized;
})();

$root.PreauthorizedRequest = (function() {

    function PreauthorizedRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    PreauthorizedRequest.create = function create(properties) {
        return new PreauthorizedRequest(properties);
    };

    PreauthorizedRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    PreauthorizedRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    PreauthorizedRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.PreauthorizedRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    PreauthorizedRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    PreauthorizedRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    PreauthorizedRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.PreauthorizedRequest)
            return object;
        return new $root.PreauthorizedRequest();
    };

    PreauthorizedRequest.toObject = function toObject() {
        return {};
    };

    PreauthorizedRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return PreauthorizedRequest;
})();

$root.CancelAuthorization = (function() {

    function CancelAuthorization(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CancelAuthorization.create = function create(properties) {
        return new CancelAuthorization(properties);
    };

    CancelAuthorization.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    CancelAuthorization.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CancelAuthorization.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CancelAuthorization();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    CancelAuthorization.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CancelAuthorization.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    CancelAuthorization.fromObject = function fromObject(object) {
        if (object instanceof $root.CancelAuthorization)
            return object;
        return new $root.CancelAuthorization();
    };

    CancelAuthorization.toObject = function toObject() {
        return {};
    };

    CancelAuthorization.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CancelAuthorization;
})();

$root.BixinSeedOperate = (function() {

    function BixinSeedOperate(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    BixinSeedOperate.prototype.type = 0;
    BixinSeedOperate.prototype.seed_importData = $util.newBuffer([]);

    BixinSeedOperate.create = function create(properties) {
        return new BixinSeedOperate(properties);
    };

    BixinSeedOperate.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).int32(message.type);
        if (message.seed_importData != null && Object.hasOwnProperty.call(message, "seed_importData"))
            writer.uint32(18).bytes(message.seed_importData);
        return writer;
    };

    BixinSeedOperate.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    BixinSeedOperate.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BixinSeedOperate();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.type = reader.int32();
                break;
            case 2:
                message.seed_importData = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("type"))
            throw $util.ProtocolError("missing required 'type'", { instance: message });
        return message;
    };

    BixinSeedOperate.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    BixinSeedOperate.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        switch (message.type) {
        default:
            return "type: enum value expected";
        case 0:
        case 1:
        case 2:
            break;
        }
        if (message.seed_importData != null && message.hasOwnProperty("seed_importData"))
            if (!(message.seed_importData && typeof message.seed_importData.length === "number" || $util.isString(message.seed_importData)))
                return "seed_importData: buffer expected";
        return null;
    };

    BixinSeedOperate.fromObject = function fromObject(object) {
        if (object instanceof $root.BixinSeedOperate)
            return object;
        var message = new $root.BixinSeedOperate();
        switch (object.type) {
        case "SeedRequestType_Gen":
        case 0:
            message.type = 0;
            break;
        case "SeedRequestType_EncExport":
        case 1:
            message.type = 1;
            break;
        case "SeedRequestType_EncImport":
        case 2:
            message.type = 2;
            break;
        }
        if (object.seed_importData != null)
            if (typeof object.seed_importData === "string")
                $util.base64.decode(object.seed_importData, message.seed_importData = $util.newBuffer($util.base64.length(object.seed_importData)), 0);
            else if (object.seed_importData.length)
                message.seed_importData = object.seed_importData;
        return message;
    };

    BixinSeedOperate.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.type = options.enums === String ? "SeedRequestType_Gen" : 0;
            if (options.bytes === String)
                object.seed_importData = "";
            else {
                object.seed_importData = [];
                if (options.bytes !== Array)
                    object.seed_importData = $util.newBuffer(object.seed_importData);
            }
        }
        if (message.type != null && message.hasOwnProperty("type"))
            object.type = options.enums === String ? $root.BixinSeedOperate.SeedRequestType[message.type] : message.type;
        if (message.seed_importData != null && message.hasOwnProperty("seed_importData"))
            object.seed_importData = options.bytes === String ? $util.base64.encode(message.seed_importData, 0, message.seed_importData.length) : options.bytes === Array ? Array.prototype.slice.call(message.seed_importData) : message.seed_importData;
        return object;
    };

    BixinSeedOperate.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    BixinSeedOperate.SeedRequestType = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "SeedRequestType_Gen"] = 0;
        values[valuesById[1] = "SeedRequestType_EncExport"] = 1;
        values[valuesById[2] = "SeedRequestType_EncImport"] = 2;
        return values;
    })();

    return BixinSeedOperate;
})();

$root.BixinMessageSE = (function() {

    function BixinMessageSE(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    BixinMessageSE.prototype.inputmessage = $util.newBuffer([]);

    BixinMessageSE.create = function create(properties) {
        return new BixinMessageSE(properties);
    };

    BixinMessageSE.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.inputmessage);
        return writer;
    };

    BixinMessageSE.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    BixinMessageSE.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BixinMessageSE();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.inputmessage = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("inputmessage"))
            throw $util.ProtocolError("missing required 'inputmessage'", { instance: message });
        return message;
    };

    BixinMessageSE.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    BixinMessageSE.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.inputmessage && typeof message.inputmessage.length === "number" || $util.isString(message.inputmessage)))
            return "inputmessage: buffer expected";
        return null;
    };

    BixinMessageSE.fromObject = function fromObject(object) {
        if (object instanceof $root.BixinMessageSE)
            return object;
        var message = new $root.BixinMessageSE();
        if (object.inputmessage != null)
            if (typeof object.inputmessage === "string")
                $util.base64.decode(object.inputmessage, message.inputmessage = $util.newBuffer($util.base64.length(object.inputmessage)), 0);
            else if (object.inputmessage.length)
                message.inputmessage = object.inputmessage;
        return message;
    };

    BixinMessageSE.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.inputmessage = "";
            else {
                object.inputmessage = [];
                if (options.bytes !== Array)
                    object.inputmessage = $util.newBuffer(object.inputmessage);
            }
        if (message.inputmessage != null && message.hasOwnProperty("inputmessage"))
            object.inputmessage = options.bytes === String ? $util.base64.encode(message.inputmessage, 0, message.inputmessage.length) : options.bytes === Array ? Array.prototype.slice.call(message.inputmessage) : message.inputmessage;
        return object;
    };

    BixinMessageSE.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return BixinMessageSE;
})();

$root.BixinOutMessageSE = (function() {

    function BixinOutMessageSE(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    BixinOutMessageSE.prototype.outmessage = $util.newBuffer([]);

    BixinOutMessageSE.create = function create(properties) {
        return new BixinOutMessageSE(properties);
    };

    BixinOutMessageSE.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.outmessage != null && Object.hasOwnProperty.call(message, "outmessage"))
            writer.uint32(10).bytes(message.outmessage);
        return writer;
    };

    BixinOutMessageSE.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    BixinOutMessageSE.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BixinOutMessageSE();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.outmessage = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    BixinOutMessageSE.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    BixinOutMessageSE.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.outmessage != null && message.hasOwnProperty("outmessage"))
            if (!(message.outmessage && typeof message.outmessage.length === "number" || $util.isString(message.outmessage)))
                return "outmessage: buffer expected";
        return null;
    };

    BixinOutMessageSE.fromObject = function fromObject(object) {
        if (object instanceof $root.BixinOutMessageSE)
            return object;
        var message = new $root.BixinOutMessageSE();
        if (object.outmessage != null)
            if (typeof object.outmessage === "string")
                $util.base64.decode(object.outmessage, message.outmessage = $util.newBuffer($util.base64.length(object.outmessage)), 0);
            else if (object.outmessage.length)
                message.outmessage = object.outmessage;
        return message;
    };

    BixinOutMessageSE.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.outmessage = "";
            else {
                object.outmessage = [];
                if (options.bytes !== Array)
                    object.outmessage = $util.newBuffer(object.outmessage);
            }
        if (message.outmessage != null && message.hasOwnProperty("outmessage"))
            object.outmessage = options.bytes === String ? $util.base64.encode(message.outmessage, 0, message.outmessage.length) : options.bytes === Array ? Array.prototype.slice.call(message.outmessage) : message.outmessage;
        return object;
    };

    BixinOutMessageSE.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return BixinOutMessageSE;
})();

$root.DeviceBackToBoot = (function() {

    function DeviceBackToBoot(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DeviceBackToBoot.create = function create(properties) {
        return new DeviceBackToBoot(properties);
    };

    DeviceBackToBoot.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    DeviceBackToBoot.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DeviceBackToBoot.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DeviceBackToBoot();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    DeviceBackToBoot.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DeviceBackToBoot.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    DeviceBackToBoot.fromObject = function fromObject(object) {
        if (object instanceof $root.DeviceBackToBoot)
            return object;
        return new $root.DeviceBackToBoot();
    };

    DeviceBackToBoot.toObject = function toObject() {
        return {};
    };

    DeviceBackToBoot.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DeviceBackToBoot;
})();

$root.BixinBackupRequest = (function() {

    function BixinBackupRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    BixinBackupRequest.create = function create(properties) {
        return new BixinBackupRequest(properties);
    };

    BixinBackupRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    BixinBackupRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    BixinBackupRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BixinBackupRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    BixinBackupRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    BixinBackupRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    BixinBackupRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.BixinBackupRequest)
            return object;
        return new $root.BixinBackupRequest();
    };

    BixinBackupRequest.toObject = function toObject() {
        return {};
    };

    BixinBackupRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return BixinBackupRequest;
})();

$root.BixinBackupAck = (function() {

    function BixinBackupAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    BixinBackupAck.prototype.data = $util.newBuffer([]);

    BixinBackupAck.create = function create(properties) {
        return new BixinBackupAck(properties);
    };

    BixinBackupAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.data);
        return writer;
    };

    BixinBackupAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    BixinBackupAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BixinBackupAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.data = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("data"))
            throw $util.ProtocolError("missing required 'data'", { instance: message });
        return message;
    };

    BixinBackupAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    BixinBackupAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
            return "data: buffer expected";
        return null;
    };

    BixinBackupAck.fromObject = function fromObject(object) {
        if (object instanceof $root.BixinBackupAck)
            return object;
        var message = new $root.BixinBackupAck();
        if (object.data != null)
            if (typeof object.data === "string")
                $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
            else if (object.data.length)
                message.data = object.data;
        return message;
    };

    BixinBackupAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.data = "";
            else {
                object.data = [];
                if (options.bytes !== Array)
                    object.data = $util.newBuffer(object.data);
            }
        if (message.data != null && message.hasOwnProperty("data"))
            object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
        return object;
    };

    BixinBackupAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return BixinBackupAck;
})();

$root.BixinRestoreRequest = (function() {

    function BixinRestoreRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    BixinRestoreRequest.prototype.data = $util.newBuffer([]);
    BixinRestoreRequest.prototype.language = "";
    BixinRestoreRequest.prototype.label = "";
    BixinRestoreRequest.prototype.passphrase_protection = false;

    BixinRestoreRequest.create = function create(properties) {
        return new BixinRestoreRequest(properties);
    };

    BixinRestoreRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.data);
        if (message.language != null && Object.hasOwnProperty.call(message, "language"))
            writer.uint32(18).string(message.language);
        if (message.label != null && Object.hasOwnProperty.call(message, "label"))
            writer.uint32(26).string(message.label);
        if (message.passphrase_protection != null && Object.hasOwnProperty.call(message, "passphrase_protection"))
            writer.uint32(32).bool(message.passphrase_protection);
        return writer;
    };

    BixinRestoreRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    BixinRestoreRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BixinRestoreRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.data = reader.bytes();
                break;
            case 2:
                message.language = reader.string();
                break;
            case 3:
                message.label = reader.string();
                break;
            case 4:
                message.passphrase_protection = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("data"))
            throw $util.ProtocolError("missing required 'data'", { instance: message });
        return message;
    };

    BixinRestoreRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    BixinRestoreRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
            return "data: buffer expected";
        if (message.language != null && message.hasOwnProperty("language"))
            if (!$util.isString(message.language))
                return "language: string expected";
        if (message.label != null && message.hasOwnProperty("label"))
            if (!$util.isString(message.label))
                return "label: string expected";
        if (message.passphrase_protection != null && message.hasOwnProperty("passphrase_protection"))
            if (typeof message.passphrase_protection !== "boolean")
                return "passphrase_protection: boolean expected";
        return null;
    };

    BixinRestoreRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.BixinRestoreRequest)
            return object;
        var message = new $root.BixinRestoreRequest();
        if (object.data != null)
            if (typeof object.data === "string")
                $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
            else if (object.data.length)
                message.data = object.data;
        if (object.language != null)
            message.language = String(object.language);
        if (object.label != null)
            message.label = String(object.label);
        if (object.passphrase_protection != null)
            message.passphrase_protection = Boolean(object.passphrase_protection);
        return message;
    };

    BixinRestoreRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.data = "";
            else {
                object.data = [];
                if (options.bytes !== Array)
                    object.data = $util.newBuffer(object.data);
            }
            object.language = "";
            object.label = "";
            object.passphrase_protection = false;
        }
        if (message.data != null && message.hasOwnProperty("data"))
            object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
        if (message.language != null && message.hasOwnProperty("language"))
            object.language = message.language;
        if (message.label != null && message.hasOwnProperty("label"))
            object.label = message.label;
        if (message.passphrase_protection != null && message.hasOwnProperty("passphrase_protection"))
            object.passphrase_protection = message.passphrase_protection;
        return object;
    };

    BixinRestoreRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return BixinRestoreRequest;
})();

$root.BixinRestoreAck = (function() {

    function BixinRestoreAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    BixinRestoreAck.prototype.data = $util.newBuffer([]);

    BixinRestoreAck.create = function create(properties) {
        return new BixinRestoreAck(properties);
    };

    BixinRestoreAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.data);
        return writer;
    };

    BixinRestoreAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    BixinRestoreAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BixinRestoreAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.data = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("data"))
            throw $util.ProtocolError("missing required 'data'", { instance: message });
        return message;
    };

    BixinRestoreAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    BixinRestoreAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
            return "data: buffer expected";
        return null;
    };

    BixinRestoreAck.fromObject = function fromObject(object) {
        if (object instanceof $root.BixinRestoreAck)
            return object;
        var message = new $root.BixinRestoreAck();
        if (object.data != null)
            if (typeof object.data === "string")
                $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
            else if (object.data.length)
                message.data = object.data;
        return message;
    };

    BixinRestoreAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.data = "";
            else {
                object.data = [];
                if (options.bytes !== Array)
                    object.data = $util.newBuffer(object.data);
            }
        if (message.data != null && message.hasOwnProperty("data"))
            object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
        return object;
    };

    BixinRestoreAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return BixinRestoreAck;
})();

$root.BixinVerifyDeviceRequest = (function() {

    function BixinVerifyDeviceRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    BixinVerifyDeviceRequest.prototype.data = $util.newBuffer([]);

    BixinVerifyDeviceRequest.create = function create(properties) {
        return new BixinVerifyDeviceRequest(properties);
    };

    BixinVerifyDeviceRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.data);
        return writer;
    };

    BixinVerifyDeviceRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    BixinVerifyDeviceRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BixinVerifyDeviceRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.data = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("data"))
            throw $util.ProtocolError("missing required 'data'", { instance: message });
        return message;
    };

    BixinVerifyDeviceRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    BixinVerifyDeviceRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
            return "data: buffer expected";
        return null;
    };

    BixinVerifyDeviceRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.BixinVerifyDeviceRequest)
            return object;
        var message = new $root.BixinVerifyDeviceRequest();
        if (object.data != null)
            if (typeof object.data === "string")
                $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
            else if (object.data.length)
                message.data = object.data;
        return message;
    };

    BixinVerifyDeviceRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.data = "";
            else {
                object.data = [];
                if (options.bytes !== Array)
                    object.data = $util.newBuffer(object.data);
            }
        if (message.data != null && message.hasOwnProperty("data"))
            object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
        return object;
    };

    BixinVerifyDeviceRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return BixinVerifyDeviceRequest;
})();

$root.BixinVerifyDeviceAck = (function() {

    function BixinVerifyDeviceAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    BixinVerifyDeviceAck.prototype.cert = $util.newBuffer([]);
    BixinVerifyDeviceAck.prototype.signature = $util.newBuffer([]);

    BixinVerifyDeviceAck.create = function create(properties) {
        return new BixinVerifyDeviceAck(properties);
    };

    BixinVerifyDeviceAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.cert);
        writer.uint32(18).bytes(message.signature);
        return writer;
    };

    BixinVerifyDeviceAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    BixinVerifyDeviceAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BixinVerifyDeviceAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.cert = reader.bytes();
                break;
            case 2:
                message.signature = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("cert"))
            throw $util.ProtocolError("missing required 'cert'", { instance: message });
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        return message;
    };

    BixinVerifyDeviceAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    BixinVerifyDeviceAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.cert && typeof message.cert.length === "number" || $util.isString(message.cert)))
            return "cert: buffer expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        return null;
    };

    BixinVerifyDeviceAck.fromObject = function fromObject(object) {
        if (object instanceof $root.BixinVerifyDeviceAck)
            return object;
        var message = new $root.BixinVerifyDeviceAck();
        if (object.cert != null)
            if (typeof object.cert === "string")
                $util.base64.decode(object.cert, message.cert = $util.newBuffer($util.base64.length(object.cert)), 0);
            else if (object.cert.length)
                message.cert = object.cert;
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        return message;
    };

    BixinVerifyDeviceAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.cert = "";
            else {
                object.cert = [];
                if (options.bytes !== Array)
                    object.cert = $util.newBuffer(object.cert);
            }
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
        }
        if (message.cert != null && message.hasOwnProperty("cert"))
            object.cert = options.bytes === String ? $util.base64.encode(message.cert, 0, message.cert.length) : options.bytes === Array ? Array.prototype.slice.call(message.cert) : message.cert;
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        return object;
    };

    BixinVerifyDeviceAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return BixinVerifyDeviceAck;
})();

$root.BixinWhiteListRequest = (function() {

    function BixinWhiteListRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    BixinWhiteListRequest.prototype.type = 0;
    BixinWhiteListRequest.prototype.addr_in = "";

    BixinWhiteListRequest.create = function create(properties) {
        return new BixinWhiteListRequest(properties);
    };

    BixinWhiteListRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).int32(message.type);
        if (message.addr_in != null && Object.hasOwnProperty.call(message, "addr_in"))
            writer.uint32(18).string(message.addr_in);
        return writer;
    };

    BixinWhiteListRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    BixinWhiteListRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BixinWhiteListRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.type = reader.int32();
                break;
            case 2:
                message.addr_in = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("type"))
            throw $util.ProtocolError("missing required 'type'", { instance: message });
        return message;
    };

    BixinWhiteListRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    BixinWhiteListRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        switch (message.type) {
        default:
            return "type: enum value expected";
        case 0:
        case 1:
        case 2:
            break;
        }
        if (message.addr_in != null && message.hasOwnProperty("addr_in"))
            if (!$util.isString(message.addr_in))
                return "addr_in: string expected";
        return null;
    };

    BixinWhiteListRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.BixinWhiteListRequest)
            return object;
        var message = new $root.BixinWhiteListRequest();
        switch (object.type) {
        case "WL_OperationType_Add":
        case 0:
            message.type = 0;
            break;
        case "WL_OperationType_Delete":
        case 1:
            message.type = 1;
            break;
        case "WL_OperationType_Inquire":
        case 2:
            message.type = 2;
            break;
        }
        if (object.addr_in != null)
            message.addr_in = String(object.addr_in);
        return message;
    };

    BixinWhiteListRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.type = options.enums === String ? "WL_OperationType_Add" : 0;
            object.addr_in = "";
        }
        if (message.type != null && message.hasOwnProperty("type"))
            object.type = options.enums === String ? $root.BixinWhiteListRequest.WL_OperationType[message.type] : message.type;
        if (message.addr_in != null && message.hasOwnProperty("addr_in"))
            object.addr_in = message.addr_in;
        return object;
    };

    BixinWhiteListRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    BixinWhiteListRequest.WL_OperationType = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "WL_OperationType_Add"] = 0;
        values[valuesById[1] = "WL_OperationType_Delete"] = 1;
        values[valuesById[2] = "WL_OperationType_Inquire"] = 2;
        return values;
    })();

    return BixinWhiteListRequest;
})();

$root.BixinWhiteListAck = (function() {

    function BixinWhiteListAck(properties) {
        this.address = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    BixinWhiteListAck.prototype.address = $util.emptyArray;

    BixinWhiteListAck.create = function create(properties) {
        return new BixinWhiteListAck(properties);
    };

    BixinWhiteListAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address != null && message.address.length)
            for (var i = 0; i < message.address.length; ++i)
                writer.uint32(10).string(message.address[i]);
        return writer;
    };

    BixinWhiteListAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    BixinWhiteListAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BixinWhiteListAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address && message.address.length))
                    message.address = [];
                message.address.push(reader.string());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    BixinWhiteListAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    BixinWhiteListAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address != null && message.hasOwnProperty("address")) {
            if (!Array.isArray(message.address))
                return "address: array expected";
            for (var i = 0; i < message.address.length; ++i)
                if (!$util.isString(message.address[i]))
                    return "address: string[] expected";
        }
        return null;
    };

    BixinWhiteListAck.fromObject = function fromObject(object) {
        if (object instanceof $root.BixinWhiteListAck)
            return object;
        var message = new $root.BixinWhiteListAck();
        if (object.address) {
            if (!Array.isArray(object.address))
                throw TypeError(".BixinWhiteListAck.address: array expected");
            message.address = [];
            for (var i = 0; i < object.address.length; ++i)
                message.address[i] = String(object.address[i]);
        }
        return message;
    };

    BixinWhiteListAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address = [];
        if (message.address && message.address.length) {
            object.address = [];
            for (var j = 0; j < message.address.length; ++j)
                object.address[j] = message.address[j];
        }
        return object;
    };

    BixinWhiteListAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return BixinWhiteListAck;
})();

$root.BixinLoadDevice = (function() {

    function BixinLoadDevice(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    BixinLoadDevice.prototype.mnemonics = "";
    BixinLoadDevice.prototype.language = "en-US";
    BixinLoadDevice.prototype.label = "";
    BixinLoadDevice.prototype.skip_checksum = false;

    BixinLoadDevice.create = function create(properties) {
        return new BixinLoadDevice(properties);
    };

    BixinLoadDevice.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.mnemonics);
        if (message.language != null && Object.hasOwnProperty.call(message, "language"))
            writer.uint32(42).string(message.language);
        if (message.label != null && Object.hasOwnProperty.call(message, "label"))
            writer.uint32(50).string(message.label);
        if (message.skip_checksum != null && Object.hasOwnProperty.call(message, "skip_checksum"))
            writer.uint32(56).bool(message.skip_checksum);
        return writer;
    };

    BixinLoadDevice.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    BixinLoadDevice.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BixinLoadDevice();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.mnemonics = reader.string();
                break;
            case 5:
                message.language = reader.string();
                break;
            case 6:
                message.label = reader.string();
                break;
            case 7:
                message.skip_checksum = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("mnemonics"))
            throw $util.ProtocolError("missing required 'mnemonics'", { instance: message });
        return message;
    };

    BixinLoadDevice.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    BixinLoadDevice.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.mnemonics))
            return "mnemonics: string expected";
        if (message.language != null && message.hasOwnProperty("language"))
            if (!$util.isString(message.language))
                return "language: string expected";
        if (message.label != null && message.hasOwnProperty("label"))
            if (!$util.isString(message.label))
                return "label: string expected";
        if (message.skip_checksum != null && message.hasOwnProperty("skip_checksum"))
            if (typeof message.skip_checksum !== "boolean")
                return "skip_checksum: boolean expected";
        return null;
    };

    BixinLoadDevice.fromObject = function fromObject(object) {
        if (object instanceof $root.BixinLoadDevice)
            return object;
        var message = new $root.BixinLoadDevice();
        if (object.mnemonics != null)
            message.mnemonics = String(object.mnemonics);
        if (object.language != null)
            message.language = String(object.language);
        if (object.label != null)
            message.label = String(object.label);
        if (object.skip_checksum != null)
            message.skip_checksum = Boolean(object.skip_checksum);
        return message;
    };

    BixinLoadDevice.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.mnemonics = "";
            object.language = "en-US";
            object.label = "";
            object.skip_checksum = false;
        }
        if (message.mnemonics != null && message.hasOwnProperty("mnemonics"))
            object.mnemonics = message.mnemonics;
        if (message.language != null && message.hasOwnProperty("language"))
            object.language = message.language;
        if (message.label != null && message.hasOwnProperty("label"))
            object.label = message.label;
        if (message.skip_checksum != null && message.hasOwnProperty("skip_checksum"))
            object.skip_checksum = message.skip_checksum;
        return object;
    };

    BixinLoadDevice.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return BixinLoadDevice;
})();

$root.BixinBackupDevice = (function() {

    function BixinBackupDevice(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    BixinBackupDevice.create = function create(properties) {
        return new BixinBackupDevice(properties);
    };

    BixinBackupDevice.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    BixinBackupDevice.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    BixinBackupDevice.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BixinBackupDevice();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    BixinBackupDevice.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    BixinBackupDevice.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    BixinBackupDevice.fromObject = function fromObject(object) {
        if (object instanceof $root.BixinBackupDevice)
            return object;
        return new $root.BixinBackupDevice();
    };

    BixinBackupDevice.toObject = function toObject() {
        return {};
    };

    BixinBackupDevice.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return BixinBackupDevice;
})();

$root.BixinBackupDeviceAck = (function() {

    function BixinBackupDeviceAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    BixinBackupDeviceAck.prototype.mnemonics = "";

    BixinBackupDeviceAck.create = function create(properties) {
        return new BixinBackupDeviceAck(properties);
    };

    BixinBackupDeviceAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.mnemonics);
        return writer;
    };

    BixinBackupDeviceAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    BixinBackupDeviceAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BixinBackupDeviceAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.mnemonics = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("mnemonics"))
            throw $util.ProtocolError("missing required 'mnemonics'", { instance: message });
        return message;
    };

    BixinBackupDeviceAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    BixinBackupDeviceAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.mnemonics))
            return "mnemonics: string expected";
        return null;
    };

    BixinBackupDeviceAck.fromObject = function fromObject(object) {
        if (object instanceof $root.BixinBackupDeviceAck)
            return object;
        var message = new $root.BixinBackupDeviceAck();
        if (object.mnemonics != null)
            message.mnemonics = String(object.mnemonics);
        return message;
    };

    BixinBackupDeviceAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.mnemonics = "";
        if (message.mnemonics != null && message.hasOwnProperty("mnemonics"))
            object.mnemonics = message.mnemonics;
        return object;
    };

    BixinBackupDeviceAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return BixinBackupDeviceAck;
})();

$root.DeviceInfoSettings = (function() {

    function DeviceInfoSettings(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DeviceInfoSettings.prototype.serial_no = "";
    DeviceInfoSettings.prototype.cpu_info = "";
    DeviceInfoSettings.prototype.pre_firmware = "";

    DeviceInfoSettings.create = function create(properties) {
        return new DeviceInfoSettings(properties);
    };

    DeviceInfoSettings.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.serial_no != null && Object.hasOwnProperty.call(message, "serial_no"))
            writer.uint32(10).string(message.serial_no);
        if (message.cpu_info != null && Object.hasOwnProperty.call(message, "cpu_info"))
            writer.uint32(18).string(message.cpu_info);
        if (message.pre_firmware != null && Object.hasOwnProperty.call(message, "pre_firmware"))
            writer.uint32(26).string(message.pre_firmware);
        return writer;
    };

    DeviceInfoSettings.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DeviceInfoSettings.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DeviceInfoSettings();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.serial_no = reader.string();
                break;
            case 2:
                message.cpu_info = reader.string();
                break;
            case 3:
                message.pre_firmware = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    DeviceInfoSettings.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DeviceInfoSettings.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.serial_no != null && message.hasOwnProperty("serial_no"))
            if (!$util.isString(message.serial_no))
                return "serial_no: string expected";
        if (message.cpu_info != null && message.hasOwnProperty("cpu_info"))
            if (!$util.isString(message.cpu_info))
                return "cpu_info: string expected";
        if (message.pre_firmware != null && message.hasOwnProperty("pre_firmware"))
            if (!$util.isString(message.pre_firmware))
                return "pre_firmware: string expected";
        return null;
    };

    DeviceInfoSettings.fromObject = function fromObject(object) {
        if (object instanceof $root.DeviceInfoSettings)
            return object;
        var message = new $root.DeviceInfoSettings();
        if (object.serial_no != null)
            message.serial_no = String(object.serial_no);
        if (object.cpu_info != null)
            message.cpu_info = String(object.cpu_info);
        if (object.pre_firmware != null)
            message.pre_firmware = String(object.pre_firmware);
        return message;
    };

    DeviceInfoSettings.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.serial_no = "";
            object.cpu_info = "";
            object.pre_firmware = "";
        }
        if (message.serial_no != null && message.hasOwnProperty("serial_no"))
            object.serial_no = message.serial_no;
        if (message.cpu_info != null && message.hasOwnProperty("cpu_info"))
            object.cpu_info = message.cpu_info;
        if (message.pre_firmware != null && message.hasOwnProperty("pre_firmware"))
            object.pre_firmware = message.pre_firmware;
        return object;
    };

    DeviceInfoSettings.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DeviceInfoSettings;
})();

$root.GetDeviceInfo = (function() {

    function GetDeviceInfo(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    GetDeviceInfo.create = function create(properties) {
        return new GetDeviceInfo(properties);
    };

    GetDeviceInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    GetDeviceInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    GetDeviceInfo.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.GetDeviceInfo();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    GetDeviceInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    GetDeviceInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    GetDeviceInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.GetDeviceInfo)
            return object;
        return new $root.GetDeviceInfo();
    };

    GetDeviceInfo.toObject = function toObject() {
        return {};
    };

    GetDeviceInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return GetDeviceInfo;
})();

$root.DeviceInfo = (function() {

    function DeviceInfo(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DeviceInfo.prototype.serial_no = "";
    DeviceInfo.prototype.spiFlash_info = "";
    DeviceInfo.prototype.SE_info = "";
    DeviceInfo.prototype.NFT_voucher = $util.newBuffer([]);
    DeviceInfo.prototype.cpu_info = "";
    DeviceInfo.prototype.pre_firmware = "";

    DeviceInfo.create = function create(properties) {
        return new DeviceInfo(properties);
    };

    DeviceInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.serial_no != null && Object.hasOwnProperty.call(message, "serial_no"))
            writer.uint32(10).string(message.serial_no);
        if (message.spiFlash_info != null && Object.hasOwnProperty.call(message, "spiFlash_info"))
            writer.uint32(18).string(message.spiFlash_info);
        if (message.SE_info != null && Object.hasOwnProperty.call(message, "SE_info"))
            writer.uint32(26).string(message.SE_info);
        if (message.NFT_voucher != null && Object.hasOwnProperty.call(message, "NFT_voucher"))
            writer.uint32(34).bytes(message.NFT_voucher);
        if (message.cpu_info != null && Object.hasOwnProperty.call(message, "cpu_info"))
            writer.uint32(42).string(message.cpu_info);
        if (message.pre_firmware != null && Object.hasOwnProperty.call(message, "pre_firmware"))
            writer.uint32(50).string(message.pre_firmware);
        return writer;
    };

    DeviceInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DeviceInfo.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DeviceInfo();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.serial_no = reader.string();
                break;
            case 2:
                message.spiFlash_info = reader.string();
                break;
            case 3:
                message.SE_info = reader.string();
                break;
            case 4:
                message.NFT_voucher = reader.bytes();
                break;
            case 5:
                message.cpu_info = reader.string();
                break;
            case 6:
                message.pre_firmware = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    DeviceInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DeviceInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.serial_no != null && message.hasOwnProperty("serial_no"))
            if (!$util.isString(message.serial_no))
                return "serial_no: string expected";
        if (message.spiFlash_info != null && message.hasOwnProperty("spiFlash_info"))
            if (!$util.isString(message.spiFlash_info))
                return "spiFlash_info: string expected";
        if (message.SE_info != null && message.hasOwnProperty("SE_info"))
            if (!$util.isString(message.SE_info))
                return "SE_info: string expected";
        if (message.NFT_voucher != null && message.hasOwnProperty("NFT_voucher"))
            if (!(message.NFT_voucher && typeof message.NFT_voucher.length === "number" || $util.isString(message.NFT_voucher)))
                return "NFT_voucher: buffer expected";
        if (message.cpu_info != null && message.hasOwnProperty("cpu_info"))
            if (!$util.isString(message.cpu_info))
                return "cpu_info: string expected";
        if (message.pre_firmware != null && message.hasOwnProperty("pre_firmware"))
            if (!$util.isString(message.pre_firmware))
                return "pre_firmware: string expected";
        return null;
    };

    DeviceInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.DeviceInfo)
            return object;
        var message = new $root.DeviceInfo();
        if (object.serial_no != null)
            message.serial_no = String(object.serial_no);
        if (object.spiFlash_info != null)
            message.spiFlash_info = String(object.spiFlash_info);
        if (object.SE_info != null)
            message.SE_info = String(object.SE_info);
        if (object.NFT_voucher != null)
            if (typeof object.NFT_voucher === "string")
                $util.base64.decode(object.NFT_voucher, message.NFT_voucher = $util.newBuffer($util.base64.length(object.NFT_voucher)), 0);
            else if (object.NFT_voucher.length)
                message.NFT_voucher = object.NFT_voucher;
        if (object.cpu_info != null)
            message.cpu_info = String(object.cpu_info);
        if (object.pre_firmware != null)
            message.pre_firmware = String(object.pre_firmware);
        return message;
    };

    DeviceInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.serial_no = "";
            object.spiFlash_info = "";
            object.SE_info = "";
            if (options.bytes === String)
                object.NFT_voucher = "";
            else {
                object.NFT_voucher = [];
                if (options.bytes !== Array)
                    object.NFT_voucher = $util.newBuffer(object.NFT_voucher);
            }
            object.cpu_info = "";
            object.pre_firmware = "";
        }
        if (message.serial_no != null && message.hasOwnProperty("serial_no"))
            object.serial_no = message.serial_no;
        if (message.spiFlash_info != null && message.hasOwnProperty("spiFlash_info"))
            object.spiFlash_info = message.spiFlash_info;
        if (message.SE_info != null && message.hasOwnProperty("SE_info"))
            object.SE_info = message.SE_info;
        if (message.NFT_voucher != null && message.hasOwnProperty("NFT_voucher"))
            object.NFT_voucher = options.bytes === String ? $util.base64.encode(message.NFT_voucher, 0, message.NFT_voucher.length) : options.bytes === Array ? Array.prototype.slice.call(message.NFT_voucher) : message.NFT_voucher;
        if (message.cpu_info != null && message.hasOwnProperty("cpu_info"))
            object.cpu_info = message.cpu_info;
        if (message.pre_firmware != null && message.hasOwnProperty("pre_firmware"))
            object.pre_firmware = message.pre_firmware;
        return object;
    };

    DeviceInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DeviceInfo;
})();

$root.ReadSEPublicKey = (function() {

    function ReadSEPublicKey(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ReadSEPublicKey.create = function create(properties) {
        return new ReadSEPublicKey(properties);
    };

    ReadSEPublicKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    ReadSEPublicKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ReadSEPublicKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ReadSEPublicKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    ReadSEPublicKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ReadSEPublicKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    ReadSEPublicKey.fromObject = function fromObject(object) {
        if (object instanceof $root.ReadSEPublicKey)
            return object;
        return new $root.ReadSEPublicKey();
    };

    ReadSEPublicKey.toObject = function toObject() {
        return {};
    };

    ReadSEPublicKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ReadSEPublicKey;
})();

$root.SEPublicKey = (function() {

    function SEPublicKey(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    SEPublicKey.prototype.public_key = $util.newBuffer([]);

    SEPublicKey.create = function create(properties) {
        return new SEPublicKey(properties);
    };

    SEPublicKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.public_key);
        return writer;
    };

    SEPublicKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    SEPublicKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SEPublicKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.public_key = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("public_key"))
            throw $util.ProtocolError("missing required 'public_key'", { instance: message });
        return message;
    };

    SEPublicKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    SEPublicKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.public_key && typeof message.public_key.length === "number" || $util.isString(message.public_key)))
            return "public_key: buffer expected";
        return null;
    };

    SEPublicKey.fromObject = function fromObject(object) {
        if (object instanceof $root.SEPublicKey)
            return object;
        var message = new $root.SEPublicKey();
        if (object.public_key != null)
            if (typeof object.public_key === "string")
                $util.base64.decode(object.public_key, message.public_key = $util.newBuffer($util.base64.length(object.public_key)), 0);
            else if (object.public_key.length)
                message.public_key = object.public_key;
        return message;
    };

    SEPublicKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.public_key = "";
            else {
                object.public_key = [];
                if (options.bytes !== Array)
                    object.public_key = $util.newBuffer(object.public_key);
            }
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            object.public_key = options.bytes === String ? $util.base64.encode(message.public_key, 0, message.public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.public_key) : message.public_key;
        return object;
    };

    SEPublicKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SEPublicKey;
})();

$root.WriteSEPublicCert = (function() {

    function WriteSEPublicCert(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    WriteSEPublicCert.prototype.public_cert = $util.newBuffer([]);

    WriteSEPublicCert.create = function create(properties) {
        return new WriteSEPublicCert(properties);
    };

    WriteSEPublicCert.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.public_cert);
        return writer;
    };

    WriteSEPublicCert.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    WriteSEPublicCert.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.WriteSEPublicCert();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.public_cert = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("public_cert"))
            throw $util.ProtocolError("missing required 'public_cert'", { instance: message });
        return message;
    };

    WriteSEPublicCert.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    WriteSEPublicCert.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.public_cert && typeof message.public_cert.length === "number" || $util.isString(message.public_cert)))
            return "public_cert: buffer expected";
        return null;
    };

    WriteSEPublicCert.fromObject = function fromObject(object) {
        if (object instanceof $root.WriteSEPublicCert)
            return object;
        var message = new $root.WriteSEPublicCert();
        if (object.public_cert != null)
            if (typeof object.public_cert === "string")
                $util.base64.decode(object.public_cert, message.public_cert = $util.newBuffer($util.base64.length(object.public_cert)), 0);
            else if (object.public_cert.length)
                message.public_cert = object.public_cert;
        return message;
    };

    WriteSEPublicCert.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.public_cert = "";
            else {
                object.public_cert = [];
                if (options.bytes !== Array)
                    object.public_cert = $util.newBuffer(object.public_cert);
            }
        if (message.public_cert != null && message.hasOwnProperty("public_cert"))
            object.public_cert = options.bytes === String ? $util.base64.encode(message.public_cert, 0, message.public_cert.length) : options.bytes === Array ? Array.prototype.slice.call(message.public_cert) : message.public_cert;
        return object;
    };

    WriteSEPublicCert.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return WriteSEPublicCert;
})();

$root.ReadSEPublicCert = (function() {

    function ReadSEPublicCert(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ReadSEPublicCert.create = function create(properties) {
        return new ReadSEPublicCert(properties);
    };

    ReadSEPublicCert.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    ReadSEPublicCert.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ReadSEPublicCert.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ReadSEPublicCert();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    ReadSEPublicCert.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ReadSEPublicCert.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    ReadSEPublicCert.fromObject = function fromObject(object) {
        if (object instanceof $root.ReadSEPublicCert)
            return object;
        return new $root.ReadSEPublicCert();
    };

    ReadSEPublicCert.toObject = function toObject() {
        return {};
    };

    ReadSEPublicCert.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ReadSEPublicCert;
})();

$root.SEPublicCert = (function() {

    function SEPublicCert(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    SEPublicCert.prototype.public_cert = $util.newBuffer([]);

    SEPublicCert.create = function create(properties) {
        return new SEPublicCert(properties);
    };

    SEPublicCert.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.public_cert);
        return writer;
    };

    SEPublicCert.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    SEPublicCert.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SEPublicCert();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.public_cert = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("public_cert"))
            throw $util.ProtocolError("missing required 'public_cert'", { instance: message });
        return message;
    };

    SEPublicCert.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    SEPublicCert.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.public_cert && typeof message.public_cert.length === "number" || $util.isString(message.public_cert)))
            return "public_cert: buffer expected";
        return null;
    };

    SEPublicCert.fromObject = function fromObject(object) {
        if (object instanceof $root.SEPublicCert)
            return object;
        var message = new $root.SEPublicCert();
        if (object.public_cert != null)
            if (typeof object.public_cert === "string")
                $util.base64.decode(object.public_cert, message.public_cert = $util.newBuffer($util.base64.length(object.public_cert)), 0);
            else if (object.public_cert.length)
                message.public_cert = object.public_cert;
        return message;
    };

    SEPublicCert.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.public_cert = "";
            else {
                object.public_cert = [];
                if (options.bytes !== Array)
                    object.public_cert = $util.newBuffer(object.public_cert);
            }
        if (message.public_cert != null && message.hasOwnProperty("public_cert"))
            object.public_cert = options.bytes === String ? $util.base64.encode(message.public_cert, 0, message.public_cert.length) : options.bytes === Array ? Array.prototype.slice.call(message.public_cert) : message.public_cert;
        return object;
    };

    SEPublicCert.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SEPublicCert;
})();

$root.SpiFlashWrite = (function() {

    function SpiFlashWrite(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    SpiFlashWrite.prototype.address = 0;
    SpiFlashWrite.prototype.data = $util.newBuffer([]);

    SpiFlashWrite.create = function create(properties) {
        return new SpiFlashWrite(properties);
    };

    SpiFlashWrite.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).uint32(message.address);
        writer.uint32(18).bytes(message.data);
        return writer;
    };

    SpiFlashWrite.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    SpiFlashWrite.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SpiFlashWrite();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.uint32();
                break;
            case 2:
                message.data = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("address"))
            throw $util.ProtocolError("missing required 'address'", { instance: message });
        if (!message.hasOwnProperty("data"))
            throw $util.ProtocolError("missing required 'data'", { instance: message });
        return message;
    };

    SpiFlashWrite.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    SpiFlashWrite.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isInteger(message.address))
            return "address: integer expected";
        if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
            return "data: buffer expected";
        return null;
    };

    SpiFlashWrite.fromObject = function fromObject(object) {
        if (object instanceof $root.SpiFlashWrite)
            return object;
        var message = new $root.SpiFlashWrite();
        if (object.address != null)
            message.address = object.address >>> 0;
        if (object.data != null)
            if (typeof object.data === "string")
                $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
            else if (object.data.length)
                message.data = object.data;
        return message;
    };

    SpiFlashWrite.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.address = 0;
            if (options.bytes === String)
                object.data = "";
            else {
                object.data = [];
                if (options.bytes !== Array)
                    object.data = $util.newBuffer(object.data);
            }
        }
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        if (message.data != null && message.hasOwnProperty("data"))
            object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
        return object;
    };

    SpiFlashWrite.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SpiFlashWrite;
})();

$root.SpiFlashRead = (function() {

    function SpiFlashRead(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    SpiFlashRead.prototype.address = 0;
    SpiFlashRead.prototype.len = 0;

    SpiFlashRead.create = function create(properties) {
        return new SpiFlashRead(properties);
    };

    SpiFlashRead.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).uint32(message.address);
        writer.uint32(16).uint32(message.len);
        return writer;
    };

    SpiFlashRead.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    SpiFlashRead.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SpiFlashRead();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.uint32();
                break;
            case 2:
                message.len = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("address"))
            throw $util.ProtocolError("missing required 'address'", { instance: message });
        if (!message.hasOwnProperty("len"))
            throw $util.ProtocolError("missing required 'len'", { instance: message });
        return message;
    };

    SpiFlashRead.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    SpiFlashRead.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isInteger(message.address))
            return "address: integer expected";
        if (!$util.isInteger(message.len))
            return "len: integer expected";
        return null;
    };

    SpiFlashRead.fromObject = function fromObject(object) {
        if (object instanceof $root.SpiFlashRead)
            return object;
        var message = new $root.SpiFlashRead();
        if (object.address != null)
            message.address = object.address >>> 0;
        if (object.len != null)
            message.len = object.len >>> 0;
        return message;
    };

    SpiFlashRead.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.address = 0;
            object.len = 0;
        }
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        if (message.len != null && message.hasOwnProperty("len"))
            object.len = message.len;
        return object;
    };

    SpiFlashRead.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SpiFlashRead;
})();

$root.SpiFlashData = (function() {

    function SpiFlashData(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    SpiFlashData.prototype.data = $util.newBuffer([]);

    SpiFlashData.create = function create(properties) {
        return new SpiFlashData(properties);
    };

    SpiFlashData.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.data);
        return writer;
    };

    SpiFlashData.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    SpiFlashData.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SpiFlashData();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.data = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("data"))
            throw $util.ProtocolError("missing required 'data'", { instance: message });
        return message;
    };

    SpiFlashData.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    SpiFlashData.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
            return "data: buffer expected";
        return null;
    };

    SpiFlashData.fromObject = function fromObject(object) {
        if (object instanceof $root.SpiFlashData)
            return object;
        var message = new $root.SpiFlashData();
        if (object.data != null)
            if (typeof object.data === "string")
                $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
            else if (object.data.length)
                message.data = object.data;
        return message;
    };

    SpiFlashData.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.data = "";
            else {
                object.data = [];
                if (options.bytes !== Array)
                    object.data = $util.newBuffer(object.data);
            }
        if (message.data != null && message.hasOwnProperty("data"))
            object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
        return object;
    };

    SpiFlashData.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SpiFlashData;
})();

$root.SESignMessage = (function() {

    function SESignMessage(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    SESignMessage.prototype.message = $util.newBuffer([]);

    SESignMessage.create = function create(properties) {
        return new SESignMessage(properties);
    };

    SESignMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.message);
        return writer;
    };

    SESignMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    SESignMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SESignMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.message = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("message"))
            throw $util.ProtocolError("missing required 'message'", { instance: message });
        return message;
    };

    SESignMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    SESignMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.message && typeof message.message.length === "number" || $util.isString(message.message)))
            return "message: buffer expected";
        return null;
    };

    SESignMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.SESignMessage)
            return object;
        var message = new $root.SESignMessage();
        if (object.message != null)
            if (typeof object.message === "string")
                $util.base64.decode(object.message, message.message = $util.newBuffer($util.base64.length(object.message)), 0);
            else if (object.message.length)
                message.message = object.message;
        return message;
    };

    SESignMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.message = "";
            else {
                object.message = [];
                if (options.bytes !== Array)
                    object.message = $util.newBuffer(object.message);
            }
        if (message.message != null && message.hasOwnProperty("message"))
            object.message = options.bytes === String ? $util.base64.encode(message.message, 0, message.message.length) : options.bytes === Array ? Array.prototype.slice.call(message.message) : message.message;
        return object;
    };

    SESignMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SESignMessage;
})();

$root.SEMessageSignature = (function() {

    function SEMessageSignature(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    SEMessageSignature.prototype.signature = $util.newBuffer([]);

    SEMessageSignature.create = function create(properties) {
        return new SEMessageSignature(properties);
    };

    SEMessageSignature.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.signature);
        return writer;
    };

    SEMessageSignature.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    SEMessageSignature.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SEMessageSignature();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.signature = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        return message;
    };

    SEMessageSignature.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    SEMessageSignature.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        return null;
    };

    SEMessageSignature.fromObject = function fromObject(object) {
        if (object instanceof $root.SEMessageSignature)
            return object;
        var message = new $root.SEMessageSignature();
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        return message;
    };

    SEMessageSignature.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        return object;
    };

    SEMessageSignature.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SEMessageSignature;
})();

$root.ResourceUpload = (function() {

    function ResourceUpload(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ResourceUpload.prototype.extension = "";
    ResourceUpload.prototype.data_length = 0;
    ResourceUpload.prototype.res_type = 0;
    ResourceUpload.prototype.nft_meta_data = $util.newBuffer([]);
    ResourceUpload.prototype.zoom_data_length = 0;
    ResourceUpload.prototype.file_name_no_ext = "";

    ResourceUpload.create = function create(properties) {
        return new ResourceUpload(properties);
    };

    ResourceUpload.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.extension);
        writer.uint32(16).uint32(message.data_length);
        writer.uint32(24).int32(message.res_type);
        if (message.nft_meta_data != null && Object.hasOwnProperty.call(message, "nft_meta_data"))
            writer.uint32(34).bytes(message.nft_meta_data);
        writer.uint32(40).uint32(message.zoom_data_length);
        if (message.file_name_no_ext != null && Object.hasOwnProperty.call(message, "file_name_no_ext"))
            writer.uint32(50).string(message.file_name_no_ext);
        return writer;
    };

    ResourceUpload.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ResourceUpload.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ResourceUpload();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.extension = reader.string();
                break;
            case 2:
                message.data_length = reader.uint32();
                break;
            case 3:
                message.res_type = reader.int32();
                break;
            case 4:
                message.nft_meta_data = reader.bytes();
                break;
            case 5:
                message.zoom_data_length = reader.uint32();
                break;
            case 6:
                message.file_name_no_ext = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("extension"))
            throw $util.ProtocolError("missing required 'extension'", { instance: message });
        if (!message.hasOwnProperty("data_length"))
            throw $util.ProtocolError("missing required 'data_length'", { instance: message });
        if (!message.hasOwnProperty("res_type"))
            throw $util.ProtocolError("missing required 'res_type'", { instance: message });
        if (!message.hasOwnProperty("zoom_data_length"))
            throw $util.ProtocolError("missing required 'zoom_data_length'", { instance: message });
        return message;
    };

    ResourceUpload.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ResourceUpload.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.extension))
            return "extension: string expected";
        if (!$util.isInteger(message.data_length))
            return "data_length: integer expected";
        switch (message.res_type) {
        default:
            return "res_type: enum value expected";
        case 0:
        case 1:
            break;
        }
        if (message.nft_meta_data != null && message.hasOwnProperty("nft_meta_data"))
            if (!(message.nft_meta_data && typeof message.nft_meta_data.length === "number" || $util.isString(message.nft_meta_data)))
                return "nft_meta_data: buffer expected";
        if (!$util.isInteger(message.zoom_data_length))
            return "zoom_data_length: integer expected";
        if (message.file_name_no_ext != null && message.hasOwnProperty("file_name_no_ext"))
            if (!$util.isString(message.file_name_no_ext))
                return "file_name_no_ext: string expected";
        return null;
    };

    ResourceUpload.fromObject = function fromObject(object) {
        if (object instanceof $root.ResourceUpload)
            return object;
        var message = new $root.ResourceUpload();
        if (object.extension != null)
            message.extension = String(object.extension);
        if (object.data_length != null)
            message.data_length = object.data_length >>> 0;
        switch (object.res_type) {
        case "WallPaper":
        case 0:
            message.res_type = 0;
            break;
        case "Nft":
        case 1:
            message.res_type = 1;
            break;
        }
        if (object.nft_meta_data != null)
            if (typeof object.nft_meta_data === "string")
                $util.base64.decode(object.nft_meta_data, message.nft_meta_data = $util.newBuffer($util.base64.length(object.nft_meta_data)), 0);
            else if (object.nft_meta_data.length)
                message.nft_meta_data = object.nft_meta_data;
        if (object.zoom_data_length != null)
            message.zoom_data_length = object.zoom_data_length >>> 0;
        if (object.file_name_no_ext != null)
            message.file_name_no_ext = String(object.file_name_no_ext);
        return message;
    };

    ResourceUpload.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.extension = "";
            object.data_length = 0;
            object.res_type = options.enums === String ? "WallPaper" : 0;
            if (options.bytes === String)
                object.nft_meta_data = "";
            else {
                object.nft_meta_data = [];
                if (options.bytes !== Array)
                    object.nft_meta_data = $util.newBuffer(object.nft_meta_data);
            }
            object.zoom_data_length = 0;
            object.file_name_no_ext = "";
        }
        if (message.extension != null && message.hasOwnProperty("extension"))
            object.extension = message.extension;
        if (message.data_length != null && message.hasOwnProperty("data_length"))
            object.data_length = message.data_length;
        if (message.res_type != null && message.hasOwnProperty("res_type"))
            object.res_type = options.enums === String ? $root.ResourceUpload.ResourceType[message.res_type] : message.res_type;
        if (message.nft_meta_data != null && message.hasOwnProperty("nft_meta_data"))
            object.nft_meta_data = options.bytes === String ? $util.base64.encode(message.nft_meta_data, 0, message.nft_meta_data.length) : options.bytes === Array ? Array.prototype.slice.call(message.nft_meta_data) : message.nft_meta_data;
        if (message.zoom_data_length != null && message.hasOwnProperty("zoom_data_length"))
            object.zoom_data_length = message.zoom_data_length;
        if (message.file_name_no_ext != null && message.hasOwnProperty("file_name_no_ext"))
            object.file_name_no_ext = message.file_name_no_ext;
        return object;
    };

    ResourceUpload.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    ResourceUpload.ResourceType = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "WallPaper"] = 0;
        values[valuesById[1] = "Nft"] = 1;
        return values;
    })();

    return ResourceUpload;
})();

$root.ZoomRequest = (function() {

    function ZoomRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ZoomRequest.prototype.offset = 0;
    ZoomRequest.prototype.data_length = 0;

    ZoomRequest.create = function create(properties) {
        return new ZoomRequest(properties);
    };

    ZoomRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.offset != null && Object.hasOwnProperty.call(message, "offset"))
            writer.uint32(8).uint32(message.offset);
        writer.uint32(16).uint32(message.data_length);
        return writer;
    };

    ZoomRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ZoomRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ZoomRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.offset = reader.uint32();
                break;
            case 2:
                message.data_length = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("data_length"))
            throw $util.ProtocolError("missing required 'data_length'", { instance: message });
        return message;
    };

    ZoomRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ZoomRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.offset != null && message.hasOwnProperty("offset"))
            if (!$util.isInteger(message.offset))
                return "offset: integer expected";
        if (!$util.isInteger(message.data_length))
            return "data_length: integer expected";
        return null;
    };

    ZoomRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.ZoomRequest)
            return object;
        var message = new $root.ZoomRequest();
        if (object.offset != null)
            message.offset = object.offset >>> 0;
        if (object.data_length != null)
            message.data_length = object.data_length >>> 0;
        return message;
    };

    ZoomRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.offset = 0;
            object.data_length = 0;
        }
        if (message.offset != null && message.hasOwnProperty("offset"))
            object.offset = message.offset;
        if (message.data_length != null && message.hasOwnProperty("data_length"))
            object.data_length = message.data_length;
        return object;
    };

    ZoomRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ZoomRequest;
})();

$root.ResourceRequest = (function() {

    function ResourceRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ResourceRequest.prototype.offset = 0;
    ResourceRequest.prototype.data_length = 0;

    ResourceRequest.create = function create(properties) {
        return new ResourceRequest(properties);
    };

    ResourceRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.offset != null && Object.hasOwnProperty.call(message, "offset"))
            writer.uint32(8).uint32(message.offset);
        writer.uint32(16).uint32(message.data_length);
        return writer;
    };

    ResourceRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ResourceRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ResourceRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.offset = reader.uint32();
                break;
            case 2:
                message.data_length = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("data_length"))
            throw $util.ProtocolError("missing required 'data_length'", { instance: message });
        return message;
    };

    ResourceRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ResourceRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.offset != null && message.hasOwnProperty("offset"))
            if (!$util.isInteger(message.offset))
                return "offset: integer expected";
        if (!$util.isInteger(message.data_length))
            return "data_length: integer expected";
        return null;
    };

    ResourceRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.ResourceRequest)
            return object;
        var message = new $root.ResourceRequest();
        if (object.offset != null)
            message.offset = object.offset >>> 0;
        if (object.data_length != null)
            message.data_length = object.data_length >>> 0;
        return message;
    };

    ResourceRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.offset = 0;
            object.data_length = 0;
        }
        if (message.offset != null && message.hasOwnProperty("offset"))
            object.offset = message.offset;
        if (message.data_length != null && message.hasOwnProperty("data_length"))
            object.data_length = message.data_length;
        return object;
    };

    ResourceRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ResourceRequest;
})();

$root.ResourceAck = (function() {

    function ResourceAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ResourceAck.prototype.data_chunk = $util.newBuffer([]);
    ResourceAck.prototype.hash = $util.newBuffer([]);

    ResourceAck.create = function create(properties) {
        return new ResourceAck(properties);
    };

    ResourceAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.data_chunk);
        if (message.hash != null && Object.hasOwnProperty.call(message, "hash"))
            writer.uint32(18).bytes(message.hash);
        return writer;
    };

    ResourceAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ResourceAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ResourceAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.data_chunk = reader.bytes();
                break;
            case 2:
                message.hash = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("data_chunk"))
            throw $util.ProtocolError("missing required 'data_chunk'", { instance: message });
        return message;
    };

    ResourceAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ResourceAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.data_chunk && typeof message.data_chunk.length === "number" || $util.isString(message.data_chunk)))
            return "data_chunk: buffer expected";
        if (message.hash != null && message.hasOwnProperty("hash"))
            if (!(message.hash && typeof message.hash.length === "number" || $util.isString(message.hash)))
                return "hash: buffer expected";
        return null;
    };

    ResourceAck.fromObject = function fromObject(object) {
        if (object instanceof $root.ResourceAck)
            return object;
        var message = new $root.ResourceAck();
        if (object.data_chunk != null)
            if (typeof object.data_chunk === "string")
                $util.base64.decode(object.data_chunk, message.data_chunk = $util.newBuffer($util.base64.length(object.data_chunk)), 0);
            else if (object.data_chunk.length)
                message.data_chunk = object.data_chunk;
        if (object.hash != null)
            if (typeof object.hash === "string")
                $util.base64.decode(object.hash, message.hash = $util.newBuffer($util.base64.length(object.hash)), 0);
            else if (object.hash.length)
                message.hash = object.hash;
        return message;
    };

    ResourceAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.data_chunk = "";
            else {
                object.data_chunk = [];
                if (options.bytes !== Array)
                    object.data_chunk = $util.newBuffer(object.data_chunk);
            }
            if (options.bytes === String)
                object.hash = "";
            else {
                object.hash = [];
                if (options.bytes !== Array)
                    object.hash = $util.newBuffer(object.hash);
            }
        }
        if (message.data_chunk != null && message.hasOwnProperty("data_chunk"))
            object.data_chunk = options.bytes === String ? $util.base64.encode(message.data_chunk, 0, message.data_chunk.length) : options.bytes === Array ? Array.prototype.slice.call(message.data_chunk) : message.data_chunk;
        if (message.hash != null && message.hasOwnProperty("hash"))
            object.hash = options.bytes === String ? $util.base64.encode(message.hash, 0, message.hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.hash) : message.hash;
        return object;
    };

    ResourceAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ResourceAck;
})();

$root.ResourceUpdate = (function() {

    function ResourceUpdate(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ResourceUpdate.prototype.file_name = "";
    ResourceUpdate.prototype.data_length = 0;
    ResourceUpdate.prototype.initial_data_chunk = $util.newBuffer([]);
    ResourceUpdate.prototype.hash = $util.newBuffer([]);

    ResourceUpdate.create = function create(properties) {
        return new ResourceUpdate(properties);
    };

    ResourceUpdate.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.file_name);
        writer.uint32(16).uint32(message.data_length);
        writer.uint32(26).bytes(message.initial_data_chunk);
        if (message.hash != null && Object.hasOwnProperty.call(message, "hash"))
            writer.uint32(34).bytes(message.hash);
        return writer;
    };

    ResourceUpdate.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ResourceUpdate.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ResourceUpdate();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.file_name = reader.string();
                break;
            case 2:
                message.data_length = reader.uint32();
                break;
            case 3:
                message.initial_data_chunk = reader.bytes();
                break;
            case 4:
                message.hash = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("file_name"))
            throw $util.ProtocolError("missing required 'file_name'", { instance: message });
        if (!message.hasOwnProperty("data_length"))
            throw $util.ProtocolError("missing required 'data_length'", { instance: message });
        if (!message.hasOwnProperty("initial_data_chunk"))
            throw $util.ProtocolError("missing required 'initial_data_chunk'", { instance: message });
        return message;
    };

    ResourceUpdate.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ResourceUpdate.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.file_name))
            return "file_name: string expected";
        if (!$util.isInteger(message.data_length))
            return "data_length: integer expected";
        if (!(message.initial_data_chunk && typeof message.initial_data_chunk.length === "number" || $util.isString(message.initial_data_chunk)))
            return "initial_data_chunk: buffer expected";
        if (message.hash != null && message.hasOwnProperty("hash"))
            if (!(message.hash && typeof message.hash.length === "number" || $util.isString(message.hash)))
                return "hash: buffer expected";
        return null;
    };

    ResourceUpdate.fromObject = function fromObject(object) {
        if (object instanceof $root.ResourceUpdate)
            return object;
        var message = new $root.ResourceUpdate();
        if (object.file_name != null)
            message.file_name = String(object.file_name);
        if (object.data_length != null)
            message.data_length = object.data_length >>> 0;
        if (object.initial_data_chunk != null)
            if (typeof object.initial_data_chunk === "string")
                $util.base64.decode(object.initial_data_chunk, message.initial_data_chunk = $util.newBuffer($util.base64.length(object.initial_data_chunk)), 0);
            else if (object.initial_data_chunk.length)
                message.initial_data_chunk = object.initial_data_chunk;
        if (object.hash != null)
            if (typeof object.hash === "string")
                $util.base64.decode(object.hash, message.hash = $util.newBuffer($util.base64.length(object.hash)), 0);
            else if (object.hash.length)
                message.hash = object.hash;
        return message;
    };

    ResourceUpdate.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.file_name = "";
            object.data_length = 0;
            if (options.bytes === String)
                object.initial_data_chunk = "";
            else {
                object.initial_data_chunk = [];
                if (options.bytes !== Array)
                    object.initial_data_chunk = $util.newBuffer(object.initial_data_chunk);
            }
            if (options.bytes === String)
                object.hash = "";
            else {
                object.hash = [];
                if (options.bytes !== Array)
                    object.hash = $util.newBuffer(object.hash);
            }
        }
        if (message.file_name != null && message.hasOwnProperty("file_name"))
            object.file_name = message.file_name;
        if (message.data_length != null && message.hasOwnProperty("data_length"))
            object.data_length = message.data_length;
        if (message.initial_data_chunk != null && message.hasOwnProperty("initial_data_chunk"))
            object.initial_data_chunk = options.bytes === String ? $util.base64.encode(message.initial_data_chunk, 0, message.initial_data_chunk.length) : options.bytes === Array ? Array.prototype.slice.call(message.initial_data_chunk) : message.initial_data_chunk;
        if (message.hash != null && message.hasOwnProperty("hash"))
            object.hash = options.bytes === String ? $util.base64.encode(message.hash, 0, message.hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.hash) : message.hash;
        return object;
    };

    ResourceUpdate.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ResourceUpdate;
})();

$root.NFTWriteInfo = (function() {

    function NFTWriteInfo(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NFTWriteInfo.prototype.index = 0;
    NFTWriteInfo.prototype.width = 0;
    NFTWriteInfo.prototype.height = 0;
    NFTWriteInfo.prototype.name_zh = "";
    NFTWriteInfo.prototype.name_en = "";

    NFTWriteInfo.create = function create(properties) {
        return new NFTWriteInfo(properties);
    };

    NFTWriteInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).uint32(message.index);
        writer.uint32(16).uint32(message.width);
        writer.uint32(24).uint32(message.height);
        if (message.name_zh != null && Object.hasOwnProperty.call(message, "name_zh"))
            writer.uint32(34).string(message.name_zh);
        if (message.name_en != null && Object.hasOwnProperty.call(message, "name_en"))
            writer.uint32(42).string(message.name_en);
        return writer;
    };

    NFTWriteInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NFTWriteInfo.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NFTWriteInfo();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.index = reader.uint32();
                break;
            case 2:
                message.width = reader.uint32();
                break;
            case 3:
                message.height = reader.uint32();
                break;
            case 4:
                message.name_zh = reader.string();
                break;
            case 5:
                message.name_en = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("index"))
            throw $util.ProtocolError("missing required 'index'", { instance: message });
        if (!message.hasOwnProperty("width"))
            throw $util.ProtocolError("missing required 'width'", { instance: message });
        if (!message.hasOwnProperty("height"))
            throw $util.ProtocolError("missing required 'height'", { instance: message });
        return message;
    };

    NFTWriteInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NFTWriteInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isInteger(message.index))
            return "index: integer expected";
        if (!$util.isInteger(message.width))
            return "width: integer expected";
        if (!$util.isInteger(message.height))
            return "height: integer expected";
        if (message.name_zh != null && message.hasOwnProperty("name_zh"))
            if (!$util.isString(message.name_zh))
                return "name_zh: string expected";
        if (message.name_en != null && message.hasOwnProperty("name_en"))
            if (!$util.isString(message.name_en))
                return "name_en: string expected";
        return null;
    };

    NFTWriteInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.NFTWriteInfo)
            return object;
        var message = new $root.NFTWriteInfo();
        if (object.index != null)
            message.index = object.index >>> 0;
        if (object.width != null)
            message.width = object.width >>> 0;
        if (object.height != null)
            message.height = object.height >>> 0;
        if (object.name_zh != null)
            message.name_zh = String(object.name_zh);
        if (object.name_en != null)
            message.name_en = String(object.name_en);
        return message;
    };

    NFTWriteInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.index = 0;
            object.width = 0;
            object.height = 0;
            object.name_zh = "";
            object.name_en = "";
        }
        if (message.index != null && message.hasOwnProperty("index"))
            object.index = message.index;
        if (message.width != null && message.hasOwnProperty("width"))
            object.width = message.width;
        if (message.height != null && message.hasOwnProperty("height"))
            object.height = message.height;
        if (message.name_zh != null && message.hasOwnProperty("name_zh"))
            object.name_zh = message.name_zh;
        if (message.name_en != null && message.hasOwnProperty("name_en"))
            object.name_en = message.name_en;
        return object;
    };

    NFTWriteInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NFTWriteInfo;
})();

$root.NFTWriteData = (function() {

    function NFTWriteData(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NFTWriteData.prototype.index = 0;
    NFTWriteData.prototype.data = $util.newBuffer([]);
    NFTWriteData.prototype.offset = 0;

    NFTWriteData.create = function create(properties) {
        return new NFTWriteData(properties);
    };

    NFTWriteData.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).uint32(message.index);
        writer.uint32(18).bytes(message.data);
        writer.uint32(24).uint32(message.offset);
        return writer;
    };

    NFTWriteData.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NFTWriteData.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NFTWriteData();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.index = reader.uint32();
                break;
            case 2:
                message.data = reader.bytes();
                break;
            case 3:
                message.offset = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("index"))
            throw $util.ProtocolError("missing required 'index'", { instance: message });
        if (!message.hasOwnProperty("data"))
            throw $util.ProtocolError("missing required 'data'", { instance: message });
        if (!message.hasOwnProperty("offset"))
            throw $util.ProtocolError("missing required 'offset'", { instance: message });
        return message;
    };

    NFTWriteData.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NFTWriteData.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isInteger(message.index))
            return "index: integer expected";
        if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
            return "data: buffer expected";
        if (!$util.isInteger(message.offset))
            return "offset: integer expected";
        return null;
    };

    NFTWriteData.fromObject = function fromObject(object) {
        if (object instanceof $root.NFTWriteData)
            return object;
        var message = new $root.NFTWriteData();
        if (object.index != null)
            message.index = object.index >>> 0;
        if (object.data != null)
            if (typeof object.data === "string")
                $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
            else if (object.data.length)
                message.data = object.data;
        if (object.offset != null)
            message.offset = object.offset >>> 0;
        return message;
    };

    NFTWriteData.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.index = 0;
            if (options.bytes === String)
                object.data = "";
            else {
                object.data = [];
                if (options.bytes !== Array)
                    object.data = $util.newBuffer(object.data);
            }
            object.offset = 0;
        }
        if (message.index != null && message.hasOwnProperty("index"))
            object.index = message.index;
        if (message.data != null && message.hasOwnProperty("data"))
            object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
        if (message.offset != null && message.hasOwnProperty("offset"))
            object.offset = message.offset;
        return object;
    };

    NFTWriteData.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NFTWriteData;
})();

$root.RebootToBootloader = (function() {

    function RebootToBootloader(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    RebootToBootloader.create = function create(properties) {
        return new RebootToBootloader(properties);
    };

    RebootToBootloader.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    RebootToBootloader.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    RebootToBootloader.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.RebootToBootloader();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    RebootToBootloader.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    RebootToBootloader.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    RebootToBootloader.fromObject = function fromObject(object) {
        if (object instanceof $root.RebootToBootloader)
            return object;
        return new $root.RebootToBootloader();
    };

    RebootToBootloader.toObject = function toObject() {
        return {};
    };

    RebootToBootloader.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return RebootToBootloader;
})();

$root.RebootToBoardloader = (function() {

    function RebootToBoardloader(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    RebootToBoardloader.create = function create(properties) {
        return new RebootToBoardloader(properties);
    };

    RebootToBoardloader.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    RebootToBoardloader.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    RebootToBoardloader.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.RebootToBoardloader();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    RebootToBoardloader.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    RebootToBoardloader.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    RebootToBoardloader.fromObject = function fromObject(object) {
        if (object instanceof $root.RebootToBoardloader)
            return object;
        return new $root.RebootToBoardloader();
    };

    RebootToBoardloader.toObject = function toObject() {
        return {};
    };

    RebootToBoardloader.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return RebootToBoardloader;
})();

$root.ListResDir = (function() {

    function ListResDir(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ListResDir.prototype.path = "";

    ListResDir.create = function create(properties) {
        return new ListResDir(properties);
    };

    ListResDir.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.path);
        return writer;
    };

    ListResDir.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ListResDir.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ListResDir();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.path = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("path"))
            throw $util.ProtocolError("missing required 'path'", { instance: message });
        return message;
    };

    ListResDir.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ListResDir.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.path))
            return "path: string expected";
        return null;
    };

    ListResDir.fromObject = function fromObject(object) {
        if (object instanceof $root.ListResDir)
            return object;
        var message = new $root.ListResDir();
        if (object.path != null)
            message.path = String(object.path);
        return message;
    };

    ListResDir.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.path = "";
        if (message.path != null && message.hasOwnProperty("path"))
            object.path = message.path;
        return object;
    };

    ListResDir.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ListResDir;
})();

$root.FileInfoList = (function() {

    function FileInfoList(properties) {
        this.files = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    FileInfoList.prototype.files = $util.emptyArray;

    FileInfoList.create = function create(properties) {
        return new FileInfoList(properties);
    };

    FileInfoList.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.files != null && message.files.length)
            for (var i = 0; i < message.files.length; ++i)
                $root.FileInfoList.FileInfo.encode(message.files[i], writer.uint32(10).fork()).ldelim();
        return writer;
    };

    FileInfoList.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    FileInfoList.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.FileInfoList();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.files && message.files.length))
                    message.files = [];
                message.files.push($root.FileInfoList.FileInfo.decode(reader, reader.uint32()));
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    FileInfoList.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    FileInfoList.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.files != null && message.hasOwnProperty("files")) {
            if (!Array.isArray(message.files))
                return "files: array expected";
            for (var i = 0; i < message.files.length; ++i) {
                var error = $root.FileInfoList.FileInfo.verify(message.files[i]);
                if (error)
                    return "files." + error;
            }
        }
        return null;
    };

    FileInfoList.fromObject = function fromObject(object) {
        if (object instanceof $root.FileInfoList)
            return object;
        var message = new $root.FileInfoList();
        if (object.files) {
            if (!Array.isArray(object.files))
                throw TypeError(".FileInfoList.files: array expected");
            message.files = [];
            for (var i = 0; i < object.files.length; ++i) {
                if (typeof object.files[i] !== "object")
                    throw TypeError(".FileInfoList.files: object expected");
                message.files[i] = $root.FileInfoList.FileInfo.fromObject(object.files[i]);
            }
        }
        return message;
    };

    FileInfoList.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.files = [];
        if (message.files && message.files.length) {
            object.files = [];
            for (var j = 0; j < message.files.length; ++j)
                object.files[j] = $root.FileInfoList.FileInfo.toObject(message.files[j], options);
        }
        return object;
    };

    FileInfoList.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    FileInfoList.FileInfo = (function() {

        function FileInfo(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        FileInfo.prototype.name = "";
        FileInfo.prototype.size = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        FileInfo.create = function create(properties) {
            return new FileInfo(properties);
        };

        FileInfo.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(10).string(message.name);
            writer.uint32(16).uint64(message.size);
            return writer;
        };

        FileInfo.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        FileInfo.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.FileInfoList.FileInfo();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.name = reader.string();
                    break;
                case 2:
                    message.size = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("name"))
                throw $util.ProtocolError("missing required 'name'", { instance: message });
            if (!message.hasOwnProperty("size"))
                throw $util.ProtocolError("missing required 'size'", { instance: message });
            return message;
        };

        FileInfo.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        FileInfo.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isString(message.name))
                return "name: string expected";
            if (!$util.isInteger(message.size) && !(message.size && $util.isInteger(message.size.low) && $util.isInteger(message.size.high)))
                return "size: integer|Long expected";
            return null;
        };

        FileInfo.fromObject = function fromObject(object) {
            if (object instanceof $root.FileInfoList.FileInfo)
                return object;
            var message = new $root.FileInfoList.FileInfo();
            if (object.name != null)
                message.name = String(object.name);
            if (object.size != null)
                if ($util.Long)
                    (message.size = $util.Long.fromValue(object.size)).unsigned = true;
                else if (typeof object.size === "string")
                    message.size = parseInt(object.size, 10);
                else if (typeof object.size === "number")
                    message.size = object.size;
                else if (typeof object.size === "object")
                    message.size = new $util.LongBits(object.size.low >>> 0, object.size.high >>> 0).toNumber(true);
            return message;
        };

        FileInfo.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.name = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.size = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.size = options.longs === String ? "0" : 0;
            }
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.size != null && message.hasOwnProperty("size"))
                if (typeof message.size === "number")
                    object.size = options.longs === String ? String(message.size) : message.size;
                else
                    object.size = options.longs === String ? $util.Long.prototype.toString.call(message.size) : options.longs === Number ? new $util.LongBits(message.size.low >>> 0, message.size.high >>> 0).toNumber(true) : message.size;
            return object;
        };

        FileInfo.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return FileInfo;
    })();

    return FileInfoList;
})();

$root.DeviceEraseSector = (function() {

    function DeviceEraseSector(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DeviceEraseSector.prototype.sector = 0;

    DeviceEraseSector.create = function create(properties) {
        return new DeviceEraseSector(properties);
    };

    DeviceEraseSector.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).uint32(message.sector);
        return writer;
    };

    DeviceEraseSector.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DeviceEraseSector.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DeviceEraseSector();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.sector = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("sector"))
            throw $util.ProtocolError("missing required 'sector'", { instance: message });
        return message;
    };

    DeviceEraseSector.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DeviceEraseSector.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isInteger(message.sector))
            return "sector: integer expected";
        return null;
    };

    DeviceEraseSector.fromObject = function fromObject(object) {
        if (object instanceof $root.DeviceEraseSector)
            return object;
        var message = new $root.DeviceEraseSector();
        if (object.sector != null)
            message.sector = object.sector >>> 0;
        return message;
    };

    DeviceEraseSector.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.sector = 0;
        if (message.sector != null && message.hasOwnProperty("sector"))
            object.sector = message.sector;
        return object;
    };

    DeviceEraseSector.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DeviceEraseSector;
})();

$root.MoneroTransactionSourceEntry = (function() {

    function MoneroTransactionSourceEntry(properties) {
        this.outputs = [];
        this.real_out_additional_tx_keys = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroTransactionSourceEntry.prototype.outputs = $util.emptyArray;
    MoneroTransactionSourceEntry.prototype.real_output = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    MoneroTransactionSourceEntry.prototype.real_out_tx_key = $util.newBuffer([]);
    MoneroTransactionSourceEntry.prototype.real_out_additional_tx_keys = $util.emptyArray;
    MoneroTransactionSourceEntry.prototype.real_output_in_tx_index = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    MoneroTransactionSourceEntry.prototype.amount = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    MoneroTransactionSourceEntry.prototype.rct = false;
    MoneroTransactionSourceEntry.prototype.mask = $util.newBuffer([]);
    MoneroTransactionSourceEntry.prototype.multisig_kLRki = null;
    MoneroTransactionSourceEntry.prototype.subaddr_minor = 0;

    MoneroTransactionSourceEntry.create = function create(properties) {
        return new MoneroTransactionSourceEntry(properties);
    };

    MoneroTransactionSourceEntry.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.outputs != null && message.outputs.length)
            for (var i = 0; i < message.outputs.length; ++i)
                $root.MoneroTransactionSourceEntry.MoneroOutputEntry.encode(message.outputs[i], writer.uint32(10).fork()).ldelim();
        if (message.real_output != null && Object.hasOwnProperty.call(message, "real_output"))
            writer.uint32(16).uint64(message.real_output);
        if (message.real_out_tx_key != null && Object.hasOwnProperty.call(message, "real_out_tx_key"))
            writer.uint32(26).bytes(message.real_out_tx_key);
        if (message.real_out_additional_tx_keys != null && message.real_out_additional_tx_keys.length)
            for (var i = 0; i < message.real_out_additional_tx_keys.length; ++i)
                writer.uint32(34).bytes(message.real_out_additional_tx_keys[i]);
        if (message.real_output_in_tx_index != null && Object.hasOwnProperty.call(message, "real_output_in_tx_index"))
            writer.uint32(40).uint64(message.real_output_in_tx_index);
        if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
            writer.uint32(48).uint64(message.amount);
        if (message.rct != null && Object.hasOwnProperty.call(message, "rct"))
            writer.uint32(56).bool(message.rct);
        if (message.mask != null && Object.hasOwnProperty.call(message, "mask"))
            writer.uint32(66).bytes(message.mask);
        if (message.multisig_kLRki != null && Object.hasOwnProperty.call(message, "multisig_kLRki"))
            $root.MoneroTransactionSourceEntry.MoneroMultisigKLRki.encode(message.multisig_kLRki, writer.uint32(74).fork()).ldelim();
        if (message.subaddr_minor != null && Object.hasOwnProperty.call(message, "subaddr_minor"))
            writer.uint32(80).uint32(message.subaddr_minor);
        return writer;
    };

    MoneroTransactionSourceEntry.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroTransactionSourceEntry.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroTransactionSourceEntry();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.outputs && message.outputs.length))
                    message.outputs = [];
                message.outputs.push($root.MoneroTransactionSourceEntry.MoneroOutputEntry.decode(reader, reader.uint32()));
                break;
            case 2:
                message.real_output = reader.uint64();
                break;
            case 3:
                message.real_out_tx_key = reader.bytes();
                break;
            case 4:
                if (!(message.real_out_additional_tx_keys && message.real_out_additional_tx_keys.length))
                    message.real_out_additional_tx_keys = [];
                message.real_out_additional_tx_keys.push(reader.bytes());
                break;
            case 5:
                message.real_output_in_tx_index = reader.uint64();
                break;
            case 6:
                message.amount = reader.uint64();
                break;
            case 7:
                message.rct = reader.bool();
                break;
            case 8:
                message.mask = reader.bytes();
                break;
            case 9:
                message.multisig_kLRki = $root.MoneroTransactionSourceEntry.MoneroMultisigKLRki.decode(reader, reader.uint32());
                break;
            case 10:
                message.subaddr_minor = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroTransactionSourceEntry.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroTransactionSourceEntry.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.outputs != null && message.hasOwnProperty("outputs")) {
            if (!Array.isArray(message.outputs))
                return "outputs: array expected";
            for (var i = 0; i < message.outputs.length; ++i) {
                var error = $root.MoneroTransactionSourceEntry.MoneroOutputEntry.verify(message.outputs[i]);
                if (error)
                    return "outputs." + error;
            }
        }
        if (message.real_output != null && message.hasOwnProperty("real_output"))
            if (!$util.isInteger(message.real_output) && !(message.real_output && $util.isInteger(message.real_output.low) && $util.isInteger(message.real_output.high)))
                return "real_output: integer|Long expected";
        if (message.real_out_tx_key != null && message.hasOwnProperty("real_out_tx_key"))
            if (!(message.real_out_tx_key && typeof message.real_out_tx_key.length === "number" || $util.isString(message.real_out_tx_key)))
                return "real_out_tx_key: buffer expected";
        if (message.real_out_additional_tx_keys != null && message.hasOwnProperty("real_out_additional_tx_keys")) {
            if (!Array.isArray(message.real_out_additional_tx_keys))
                return "real_out_additional_tx_keys: array expected";
            for (var i = 0; i < message.real_out_additional_tx_keys.length; ++i)
                if (!(message.real_out_additional_tx_keys[i] && typeof message.real_out_additional_tx_keys[i].length === "number" || $util.isString(message.real_out_additional_tx_keys[i])))
                    return "real_out_additional_tx_keys: buffer[] expected";
        }
        if (message.real_output_in_tx_index != null && message.hasOwnProperty("real_output_in_tx_index"))
            if (!$util.isInteger(message.real_output_in_tx_index) && !(message.real_output_in_tx_index && $util.isInteger(message.real_output_in_tx_index.low) && $util.isInteger(message.real_output_in_tx_index.high)))
                return "real_output_in_tx_index: integer|Long expected";
        if (message.amount != null && message.hasOwnProperty("amount"))
            if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
                return "amount: integer|Long expected";
        if (message.rct != null && message.hasOwnProperty("rct"))
            if (typeof message.rct !== "boolean")
                return "rct: boolean expected";
        if (message.mask != null && message.hasOwnProperty("mask"))
            if (!(message.mask && typeof message.mask.length === "number" || $util.isString(message.mask)))
                return "mask: buffer expected";
        if (message.multisig_kLRki != null && message.hasOwnProperty("multisig_kLRki")) {
            var error = $root.MoneroTransactionSourceEntry.MoneroMultisigKLRki.verify(message.multisig_kLRki);
            if (error)
                return "multisig_kLRki." + error;
        }
        if (message.subaddr_minor != null && message.hasOwnProperty("subaddr_minor"))
            if (!$util.isInteger(message.subaddr_minor))
                return "subaddr_minor: integer expected";
        return null;
    };

    MoneroTransactionSourceEntry.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroTransactionSourceEntry)
            return object;
        var message = new $root.MoneroTransactionSourceEntry();
        if (object.outputs) {
            if (!Array.isArray(object.outputs))
                throw TypeError(".MoneroTransactionSourceEntry.outputs: array expected");
            message.outputs = [];
            for (var i = 0; i < object.outputs.length; ++i) {
                if (typeof object.outputs[i] !== "object")
                    throw TypeError(".MoneroTransactionSourceEntry.outputs: object expected");
                message.outputs[i] = $root.MoneroTransactionSourceEntry.MoneroOutputEntry.fromObject(object.outputs[i]);
            }
        }
        if (object.real_output != null)
            if ($util.Long)
                (message.real_output = $util.Long.fromValue(object.real_output)).unsigned = true;
            else if (typeof object.real_output === "string")
                message.real_output = parseInt(object.real_output, 10);
            else if (typeof object.real_output === "number")
                message.real_output = object.real_output;
            else if (typeof object.real_output === "object")
                message.real_output = new $util.LongBits(object.real_output.low >>> 0, object.real_output.high >>> 0).toNumber(true);
        if (object.real_out_tx_key != null)
            if (typeof object.real_out_tx_key === "string")
                $util.base64.decode(object.real_out_tx_key, message.real_out_tx_key = $util.newBuffer($util.base64.length(object.real_out_tx_key)), 0);
            else if (object.real_out_tx_key.length)
                message.real_out_tx_key = object.real_out_tx_key;
        if (object.real_out_additional_tx_keys) {
            if (!Array.isArray(object.real_out_additional_tx_keys))
                throw TypeError(".MoneroTransactionSourceEntry.real_out_additional_tx_keys: array expected");
            message.real_out_additional_tx_keys = [];
            for (var i = 0; i < object.real_out_additional_tx_keys.length; ++i)
                if (typeof object.real_out_additional_tx_keys[i] === "string")
                    $util.base64.decode(object.real_out_additional_tx_keys[i], message.real_out_additional_tx_keys[i] = $util.newBuffer($util.base64.length(object.real_out_additional_tx_keys[i])), 0);
                else if (object.real_out_additional_tx_keys[i].length)
                    message.real_out_additional_tx_keys[i] = object.real_out_additional_tx_keys[i];
        }
        if (object.real_output_in_tx_index != null)
            if ($util.Long)
                (message.real_output_in_tx_index = $util.Long.fromValue(object.real_output_in_tx_index)).unsigned = true;
            else if (typeof object.real_output_in_tx_index === "string")
                message.real_output_in_tx_index = parseInt(object.real_output_in_tx_index, 10);
            else if (typeof object.real_output_in_tx_index === "number")
                message.real_output_in_tx_index = object.real_output_in_tx_index;
            else if (typeof object.real_output_in_tx_index === "object")
                message.real_output_in_tx_index = new $util.LongBits(object.real_output_in_tx_index.low >>> 0, object.real_output_in_tx_index.high >>> 0).toNumber(true);
        if (object.amount != null)
            if ($util.Long)
                (message.amount = $util.Long.fromValue(object.amount)).unsigned = true;
            else if (typeof object.amount === "string")
                message.amount = parseInt(object.amount, 10);
            else if (typeof object.amount === "number")
                message.amount = object.amount;
            else if (typeof object.amount === "object")
                message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber(true);
        if (object.rct != null)
            message.rct = Boolean(object.rct);
        if (object.mask != null)
            if (typeof object.mask === "string")
                $util.base64.decode(object.mask, message.mask = $util.newBuffer($util.base64.length(object.mask)), 0);
            else if (object.mask.length)
                message.mask = object.mask;
        if (object.multisig_kLRki != null) {
            if (typeof object.multisig_kLRki !== "object")
                throw TypeError(".MoneroTransactionSourceEntry.multisig_kLRki: object expected");
            message.multisig_kLRki = $root.MoneroTransactionSourceEntry.MoneroMultisigKLRki.fromObject(object.multisig_kLRki);
        }
        if (object.subaddr_minor != null)
            message.subaddr_minor = object.subaddr_minor >>> 0;
        return message;
    };

    MoneroTransactionSourceEntry.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults) {
            object.outputs = [];
            object.real_out_additional_tx_keys = [];
        }
        if (options.defaults) {
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.real_output = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.real_output = options.longs === String ? "0" : 0;
            if (options.bytes === String)
                object.real_out_tx_key = "";
            else {
                object.real_out_tx_key = [];
                if (options.bytes !== Array)
                    object.real_out_tx_key = $util.newBuffer(object.real_out_tx_key);
            }
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.real_output_in_tx_index = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.real_output_in_tx_index = options.longs === String ? "0" : 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.amount = options.longs === String ? "0" : 0;
            object.rct = false;
            if (options.bytes === String)
                object.mask = "";
            else {
                object.mask = [];
                if (options.bytes !== Array)
                    object.mask = $util.newBuffer(object.mask);
            }
            object.multisig_kLRki = null;
            object.subaddr_minor = 0;
        }
        if (message.outputs && message.outputs.length) {
            object.outputs = [];
            for (var j = 0; j < message.outputs.length; ++j)
                object.outputs[j] = $root.MoneroTransactionSourceEntry.MoneroOutputEntry.toObject(message.outputs[j], options);
        }
        if (message.real_output != null && message.hasOwnProperty("real_output"))
            if (typeof message.real_output === "number")
                object.real_output = options.longs === String ? String(message.real_output) : message.real_output;
            else
                object.real_output = options.longs === String ? $util.Long.prototype.toString.call(message.real_output) : options.longs === Number ? new $util.LongBits(message.real_output.low >>> 0, message.real_output.high >>> 0).toNumber(true) : message.real_output;
        if (message.real_out_tx_key != null && message.hasOwnProperty("real_out_tx_key"))
            object.real_out_tx_key = options.bytes === String ? $util.base64.encode(message.real_out_tx_key, 0, message.real_out_tx_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.real_out_tx_key) : message.real_out_tx_key;
        if (message.real_out_additional_tx_keys && message.real_out_additional_tx_keys.length) {
            object.real_out_additional_tx_keys = [];
            for (var j = 0; j < message.real_out_additional_tx_keys.length; ++j)
                object.real_out_additional_tx_keys[j] = options.bytes === String ? $util.base64.encode(message.real_out_additional_tx_keys[j], 0, message.real_out_additional_tx_keys[j].length) : options.bytes === Array ? Array.prototype.slice.call(message.real_out_additional_tx_keys[j]) : message.real_out_additional_tx_keys[j];
        }
        if (message.real_output_in_tx_index != null && message.hasOwnProperty("real_output_in_tx_index"))
            if (typeof message.real_output_in_tx_index === "number")
                object.real_output_in_tx_index = options.longs === String ? String(message.real_output_in_tx_index) : message.real_output_in_tx_index;
            else
                object.real_output_in_tx_index = options.longs === String ? $util.Long.prototype.toString.call(message.real_output_in_tx_index) : options.longs === Number ? new $util.LongBits(message.real_output_in_tx_index.low >>> 0, message.real_output_in_tx_index.high >>> 0).toNumber(true) : message.real_output_in_tx_index;
        if (message.amount != null && message.hasOwnProperty("amount"))
            if (typeof message.amount === "number")
                object.amount = options.longs === String ? String(message.amount) : message.amount;
            else
                object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber(true) : message.amount;
        if (message.rct != null && message.hasOwnProperty("rct"))
            object.rct = message.rct;
        if (message.mask != null && message.hasOwnProperty("mask"))
            object.mask = options.bytes === String ? $util.base64.encode(message.mask, 0, message.mask.length) : options.bytes === Array ? Array.prototype.slice.call(message.mask) : message.mask;
        if (message.multisig_kLRki != null && message.hasOwnProperty("multisig_kLRki"))
            object.multisig_kLRki = $root.MoneroTransactionSourceEntry.MoneroMultisigKLRki.toObject(message.multisig_kLRki, options);
        if (message.subaddr_minor != null && message.hasOwnProperty("subaddr_minor"))
            object.subaddr_minor = message.subaddr_minor;
        return object;
    };

    MoneroTransactionSourceEntry.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    MoneroTransactionSourceEntry.MoneroOutputEntry = (function() {

        function MoneroOutputEntry(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        MoneroOutputEntry.prototype.idx = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        MoneroOutputEntry.prototype.key = null;

        MoneroOutputEntry.create = function create(properties) {
            return new MoneroOutputEntry(properties);
        };

        MoneroOutputEntry.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.idx != null && Object.hasOwnProperty.call(message, "idx"))
                writer.uint32(8).uint64(message.idx);
            if (message.key != null && Object.hasOwnProperty.call(message, "key"))
                $root.MoneroTransactionSourceEntry.MoneroOutputEntry.MoneroRctKeyPublic.encode(message.key, writer.uint32(18).fork()).ldelim();
            return writer;
        };

        MoneroOutputEntry.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        MoneroOutputEntry.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroTransactionSourceEntry.MoneroOutputEntry();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.idx = reader.uint64();
                    break;
                case 2:
                    message.key = $root.MoneroTransactionSourceEntry.MoneroOutputEntry.MoneroRctKeyPublic.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        MoneroOutputEntry.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        MoneroOutputEntry.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.idx != null && message.hasOwnProperty("idx"))
                if (!$util.isInteger(message.idx) && !(message.idx && $util.isInteger(message.idx.low) && $util.isInteger(message.idx.high)))
                    return "idx: integer|Long expected";
            if (message.key != null && message.hasOwnProperty("key")) {
                var error = $root.MoneroTransactionSourceEntry.MoneroOutputEntry.MoneroRctKeyPublic.verify(message.key);
                if (error)
                    return "key." + error;
            }
            return null;
        };

        MoneroOutputEntry.fromObject = function fromObject(object) {
            if (object instanceof $root.MoneroTransactionSourceEntry.MoneroOutputEntry)
                return object;
            var message = new $root.MoneroTransactionSourceEntry.MoneroOutputEntry();
            if (object.idx != null)
                if ($util.Long)
                    (message.idx = $util.Long.fromValue(object.idx)).unsigned = true;
                else if (typeof object.idx === "string")
                    message.idx = parseInt(object.idx, 10);
                else if (typeof object.idx === "number")
                    message.idx = object.idx;
                else if (typeof object.idx === "object")
                    message.idx = new $util.LongBits(object.idx.low >>> 0, object.idx.high >>> 0).toNumber(true);
            if (object.key != null) {
                if (typeof object.key !== "object")
                    throw TypeError(".MoneroTransactionSourceEntry.MoneroOutputEntry.key: object expected");
                message.key = $root.MoneroTransactionSourceEntry.MoneroOutputEntry.MoneroRctKeyPublic.fromObject(object.key);
            }
            return message;
        };

        MoneroOutputEntry.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.idx = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.idx = options.longs === String ? "0" : 0;
                object.key = null;
            }
            if (message.idx != null && message.hasOwnProperty("idx"))
                if (typeof message.idx === "number")
                    object.idx = options.longs === String ? String(message.idx) : message.idx;
                else
                    object.idx = options.longs === String ? $util.Long.prototype.toString.call(message.idx) : options.longs === Number ? new $util.LongBits(message.idx.low >>> 0, message.idx.high >>> 0).toNumber(true) : message.idx;
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = $root.MoneroTransactionSourceEntry.MoneroOutputEntry.MoneroRctKeyPublic.toObject(message.key, options);
            return object;
        };

        MoneroOutputEntry.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        MoneroOutputEntry.MoneroRctKeyPublic = (function() {

            function MoneroRctKeyPublic(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            MoneroRctKeyPublic.prototype.dest = $util.newBuffer([]);
            MoneroRctKeyPublic.prototype.commitment = $util.newBuffer([]);

            MoneroRctKeyPublic.create = function create(properties) {
                return new MoneroRctKeyPublic(properties);
            };

            MoneroRctKeyPublic.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.dest != null && Object.hasOwnProperty.call(message, "dest"))
                    writer.uint32(10).bytes(message.dest);
                if (message.commitment != null && Object.hasOwnProperty.call(message, "commitment"))
                    writer.uint32(18).bytes(message.commitment);
                return writer;
            };

            MoneroRctKeyPublic.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            MoneroRctKeyPublic.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroTransactionSourceEntry.MoneroOutputEntry.MoneroRctKeyPublic();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.dest = reader.bytes();
                        break;
                    case 2:
                        message.commitment = reader.bytes();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            MoneroRctKeyPublic.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            MoneroRctKeyPublic.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.dest != null && message.hasOwnProperty("dest"))
                    if (!(message.dest && typeof message.dest.length === "number" || $util.isString(message.dest)))
                        return "dest: buffer expected";
                if (message.commitment != null && message.hasOwnProperty("commitment"))
                    if (!(message.commitment && typeof message.commitment.length === "number" || $util.isString(message.commitment)))
                        return "commitment: buffer expected";
                return null;
            };

            MoneroRctKeyPublic.fromObject = function fromObject(object) {
                if (object instanceof $root.MoneroTransactionSourceEntry.MoneroOutputEntry.MoneroRctKeyPublic)
                    return object;
                var message = new $root.MoneroTransactionSourceEntry.MoneroOutputEntry.MoneroRctKeyPublic();
                if (object.dest != null)
                    if (typeof object.dest === "string")
                        $util.base64.decode(object.dest, message.dest = $util.newBuffer($util.base64.length(object.dest)), 0);
                    else if (object.dest.length)
                        message.dest = object.dest;
                if (object.commitment != null)
                    if (typeof object.commitment === "string")
                        $util.base64.decode(object.commitment, message.commitment = $util.newBuffer($util.base64.length(object.commitment)), 0);
                    else if (object.commitment.length)
                        message.commitment = object.commitment;
                return message;
            };

            MoneroRctKeyPublic.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    if (options.bytes === String)
                        object.dest = "";
                    else {
                        object.dest = [];
                        if (options.bytes !== Array)
                            object.dest = $util.newBuffer(object.dest);
                    }
                    if (options.bytes === String)
                        object.commitment = "";
                    else {
                        object.commitment = [];
                        if (options.bytes !== Array)
                            object.commitment = $util.newBuffer(object.commitment);
                    }
                }
                if (message.dest != null && message.hasOwnProperty("dest"))
                    object.dest = options.bytes === String ? $util.base64.encode(message.dest, 0, message.dest.length) : options.bytes === Array ? Array.prototype.slice.call(message.dest) : message.dest;
                if (message.commitment != null && message.hasOwnProperty("commitment"))
                    object.commitment = options.bytes === String ? $util.base64.encode(message.commitment, 0, message.commitment.length) : options.bytes === Array ? Array.prototype.slice.call(message.commitment) : message.commitment;
                return object;
            };

            MoneroRctKeyPublic.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return MoneroRctKeyPublic;
        })();

        return MoneroOutputEntry;
    })();

    MoneroTransactionSourceEntry.MoneroMultisigKLRki = (function() {

        function MoneroMultisigKLRki(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        MoneroMultisigKLRki.prototype.K = $util.newBuffer([]);
        MoneroMultisigKLRki.prototype.L = $util.newBuffer([]);
        MoneroMultisigKLRki.prototype.R = $util.newBuffer([]);
        MoneroMultisigKLRki.prototype.ki = $util.newBuffer([]);

        MoneroMultisigKLRki.create = function create(properties) {
            return new MoneroMultisigKLRki(properties);
        };

        MoneroMultisigKLRki.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.K != null && Object.hasOwnProperty.call(message, "K"))
                writer.uint32(10).bytes(message.K);
            if (message.L != null && Object.hasOwnProperty.call(message, "L"))
                writer.uint32(18).bytes(message.L);
            if (message.R != null && Object.hasOwnProperty.call(message, "R"))
                writer.uint32(26).bytes(message.R);
            if (message.ki != null && Object.hasOwnProperty.call(message, "ki"))
                writer.uint32(34).bytes(message.ki);
            return writer;
        };

        MoneroMultisigKLRki.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        MoneroMultisigKLRki.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroTransactionSourceEntry.MoneroMultisigKLRki();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.K = reader.bytes();
                    break;
                case 2:
                    message.L = reader.bytes();
                    break;
                case 3:
                    message.R = reader.bytes();
                    break;
                case 4:
                    message.ki = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        MoneroMultisigKLRki.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        MoneroMultisigKLRki.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.K != null && message.hasOwnProperty("K"))
                if (!(message.K && typeof message.K.length === "number" || $util.isString(message.K)))
                    return "K: buffer expected";
            if (message.L != null && message.hasOwnProperty("L"))
                if (!(message.L && typeof message.L.length === "number" || $util.isString(message.L)))
                    return "L: buffer expected";
            if (message.R != null && message.hasOwnProperty("R"))
                if (!(message.R && typeof message.R.length === "number" || $util.isString(message.R)))
                    return "R: buffer expected";
            if (message.ki != null && message.hasOwnProperty("ki"))
                if (!(message.ki && typeof message.ki.length === "number" || $util.isString(message.ki)))
                    return "ki: buffer expected";
            return null;
        };

        MoneroMultisigKLRki.fromObject = function fromObject(object) {
            if (object instanceof $root.MoneroTransactionSourceEntry.MoneroMultisigKLRki)
                return object;
            var message = new $root.MoneroTransactionSourceEntry.MoneroMultisigKLRki();
            if (object.K != null)
                if (typeof object.K === "string")
                    $util.base64.decode(object.K, message.K = $util.newBuffer($util.base64.length(object.K)), 0);
                else if (object.K.length)
                    message.K = object.K;
            if (object.L != null)
                if (typeof object.L === "string")
                    $util.base64.decode(object.L, message.L = $util.newBuffer($util.base64.length(object.L)), 0);
                else if (object.L.length)
                    message.L = object.L;
            if (object.R != null)
                if (typeof object.R === "string")
                    $util.base64.decode(object.R, message.R = $util.newBuffer($util.base64.length(object.R)), 0);
                else if (object.R.length)
                    message.R = object.R;
            if (object.ki != null)
                if (typeof object.ki === "string")
                    $util.base64.decode(object.ki, message.ki = $util.newBuffer($util.base64.length(object.ki)), 0);
                else if (object.ki.length)
                    message.ki = object.ki;
            return message;
        };

        MoneroMultisigKLRki.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if (options.bytes === String)
                    object.K = "";
                else {
                    object.K = [];
                    if (options.bytes !== Array)
                        object.K = $util.newBuffer(object.K);
                }
                if (options.bytes === String)
                    object.L = "";
                else {
                    object.L = [];
                    if (options.bytes !== Array)
                        object.L = $util.newBuffer(object.L);
                }
                if (options.bytes === String)
                    object.R = "";
                else {
                    object.R = [];
                    if (options.bytes !== Array)
                        object.R = $util.newBuffer(object.R);
                }
                if (options.bytes === String)
                    object.ki = "";
                else {
                    object.ki = [];
                    if (options.bytes !== Array)
                        object.ki = $util.newBuffer(object.ki);
                }
            }
            if (message.K != null && message.hasOwnProperty("K"))
                object.K = options.bytes === String ? $util.base64.encode(message.K, 0, message.K.length) : options.bytes === Array ? Array.prototype.slice.call(message.K) : message.K;
            if (message.L != null && message.hasOwnProperty("L"))
                object.L = options.bytes === String ? $util.base64.encode(message.L, 0, message.L.length) : options.bytes === Array ? Array.prototype.slice.call(message.L) : message.L;
            if (message.R != null && message.hasOwnProperty("R"))
                object.R = options.bytes === String ? $util.base64.encode(message.R, 0, message.R.length) : options.bytes === Array ? Array.prototype.slice.call(message.R) : message.R;
            if (message.ki != null && message.hasOwnProperty("ki"))
                object.ki = options.bytes === String ? $util.base64.encode(message.ki, 0, message.ki.length) : options.bytes === Array ? Array.prototype.slice.call(message.ki) : message.ki;
            return object;
        };

        MoneroMultisigKLRki.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return MoneroMultisigKLRki;
    })();

    return MoneroTransactionSourceEntry;
})();

$root.MoneroTransactionDestinationEntry = (function() {

    function MoneroTransactionDestinationEntry(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroTransactionDestinationEntry.prototype.amount = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    MoneroTransactionDestinationEntry.prototype.addr = null;
    MoneroTransactionDestinationEntry.prototype.is_subaddress = false;
    MoneroTransactionDestinationEntry.prototype.original = $util.newBuffer([]);
    MoneroTransactionDestinationEntry.prototype.is_integrated = false;

    MoneroTransactionDestinationEntry.create = function create(properties) {
        return new MoneroTransactionDestinationEntry(properties);
    };

    MoneroTransactionDestinationEntry.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
            writer.uint32(8).uint64(message.amount);
        if (message.addr != null && Object.hasOwnProperty.call(message, "addr"))
            $root.MoneroTransactionDestinationEntry.MoneroAccountPublicAddress.encode(message.addr, writer.uint32(18).fork()).ldelim();
        if (message.is_subaddress != null && Object.hasOwnProperty.call(message, "is_subaddress"))
            writer.uint32(24).bool(message.is_subaddress);
        if (message.original != null && Object.hasOwnProperty.call(message, "original"))
            writer.uint32(34).bytes(message.original);
        if (message.is_integrated != null && Object.hasOwnProperty.call(message, "is_integrated"))
            writer.uint32(40).bool(message.is_integrated);
        return writer;
    };

    MoneroTransactionDestinationEntry.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroTransactionDestinationEntry.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroTransactionDestinationEntry();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.amount = reader.uint64();
                break;
            case 2:
                message.addr = $root.MoneroTransactionDestinationEntry.MoneroAccountPublicAddress.decode(reader, reader.uint32());
                break;
            case 3:
                message.is_subaddress = reader.bool();
                break;
            case 4:
                message.original = reader.bytes();
                break;
            case 5:
                message.is_integrated = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroTransactionDestinationEntry.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroTransactionDestinationEntry.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.amount != null && message.hasOwnProperty("amount"))
            if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
                return "amount: integer|Long expected";
        if (message.addr != null && message.hasOwnProperty("addr")) {
            var error = $root.MoneroTransactionDestinationEntry.MoneroAccountPublicAddress.verify(message.addr);
            if (error)
                return "addr." + error;
        }
        if (message.is_subaddress != null && message.hasOwnProperty("is_subaddress"))
            if (typeof message.is_subaddress !== "boolean")
                return "is_subaddress: boolean expected";
        if (message.original != null && message.hasOwnProperty("original"))
            if (!(message.original && typeof message.original.length === "number" || $util.isString(message.original)))
                return "original: buffer expected";
        if (message.is_integrated != null && message.hasOwnProperty("is_integrated"))
            if (typeof message.is_integrated !== "boolean")
                return "is_integrated: boolean expected";
        return null;
    };

    MoneroTransactionDestinationEntry.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroTransactionDestinationEntry)
            return object;
        var message = new $root.MoneroTransactionDestinationEntry();
        if (object.amount != null)
            if ($util.Long)
                (message.amount = $util.Long.fromValue(object.amount)).unsigned = true;
            else if (typeof object.amount === "string")
                message.amount = parseInt(object.amount, 10);
            else if (typeof object.amount === "number")
                message.amount = object.amount;
            else if (typeof object.amount === "object")
                message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber(true);
        if (object.addr != null) {
            if (typeof object.addr !== "object")
                throw TypeError(".MoneroTransactionDestinationEntry.addr: object expected");
            message.addr = $root.MoneroTransactionDestinationEntry.MoneroAccountPublicAddress.fromObject(object.addr);
        }
        if (object.is_subaddress != null)
            message.is_subaddress = Boolean(object.is_subaddress);
        if (object.original != null)
            if (typeof object.original === "string")
                $util.base64.decode(object.original, message.original = $util.newBuffer($util.base64.length(object.original)), 0);
            else if (object.original.length)
                message.original = object.original;
        if (object.is_integrated != null)
            message.is_integrated = Boolean(object.is_integrated);
        return message;
    };

    MoneroTransactionDestinationEntry.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.amount = options.longs === String ? "0" : 0;
            object.addr = null;
            object.is_subaddress = false;
            if (options.bytes === String)
                object.original = "";
            else {
                object.original = [];
                if (options.bytes !== Array)
                    object.original = $util.newBuffer(object.original);
            }
            object.is_integrated = false;
        }
        if (message.amount != null && message.hasOwnProperty("amount"))
            if (typeof message.amount === "number")
                object.amount = options.longs === String ? String(message.amount) : message.amount;
            else
                object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber(true) : message.amount;
        if (message.addr != null && message.hasOwnProperty("addr"))
            object.addr = $root.MoneroTransactionDestinationEntry.MoneroAccountPublicAddress.toObject(message.addr, options);
        if (message.is_subaddress != null && message.hasOwnProperty("is_subaddress"))
            object.is_subaddress = message.is_subaddress;
        if (message.original != null && message.hasOwnProperty("original"))
            object.original = options.bytes === String ? $util.base64.encode(message.original, 0, message.original.length) : options.bytes === Array ? Array.prototype.slice.call(message.original) : message.original;
        if (message.is_integrated != null && message.hasOwnProperty("is_integrated"))
            object.is_integrated = message.is_integrated;
        return object;
    };

    MoneroTransactionDestinationEntry.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    MoneroTransactionDestinationEntry.MoneroAccountPublicAddress = (function() {

        function MoneroAccountPublicAddress(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        MoneroAccountPublicAddress.prototype.spend_public_key = $util.newBuffer([]);
        MoneroAccountPublicAddress.prototype.view_public_key = $util.newBuffer([]);

        MoneroAccountPublicAddress.create = function create(properties) {
            return new MoneroAccountPublicAddress(properties);
        };

        MoneroAccountPublicAddress.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.spend_public_key != null && Object.hasOwnProperty.call(message, "spend_public_key"))
                writer.uint32(10).bytes(message.spend_public_key);
            if (message.view_public_key != null && Object.hasOwnProperty.call(message, "view_public_key"))
                writer.uint32(18).bytes(message.view_public_key);
            return writer;
        };

        MoneroAccountPublicAddress.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        MoneroAccountPublicAddress.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroTransactionDestinationEntry.MoneroAccountPublicAddress();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.spend_public_key = reader.bytes();
                    break;
                case 2:
                    message.view_public_key = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        MoneroAccountPublicAddress.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        MoneroAccountPublicAddress.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.spend_public_key != null && message.hasOwnProperty("spend_public_key"))
                if (!(message.spend_public_key && typeof message.spend_public_key.length === "number" || $util.isString(message.spend_public_key)))
                    return "spend_public_key: buffer expected";
            if (message.view_public_key != null && message.hasOwnProperty("view_public_key"))
                if (!(message.view_public_key && typeof message.view_public_key.length === "number" || $util.isString(message.view_public_key)))
                    return "view_public_key: buffer expected";
            return null;
        };

        MoneroAccountPublicAddress.fromObject = function fromObject(object) {
            if (object instanceof $root.MoneroTransactionDestinationEntry.MoneroAccountPublicAddress)
                return object;
            var message = new $root.MoneroTransactionDestinationEntry.MoneroAccountPublicAddress();
            if (object.spend_public_key != null)
                if (typeof object.spend_public_key === "string")
                    $util.base64.decode(object.spend_public_key, message.spend_public_key = $util.newBuffer($util.base64.length(object.spend_public_key)), 0);
                else if (object.spend_public_key.length)
                    message.spend_public_key = object.spend_public_key;
            if (object.view_public_key != null)
                if (typeof object.view_public_key === "string")
                    $util.base64.decode(object.view_public_key, message.view_public_key = $util.newBuffer($util.base64.length(object.view_public_key)), 0);
                else if (object.view_public_key.length)
                    message.view_public_key = object.view_public_key;
            return message;
        };

        MoneroAccountPublicAddress.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if (options.bytes === String)
                    object.spend_public_key = "";
                else {
                    object.spend_public_key = [];
                    if (options.bytes !== Array)
                        object.spend_public_key = $util.newBuffer(object.spend_public_key);
                }
                if (options.bytes === String)
                    object.view_public_key = "";
                else {
                    object.view_public_key = [];
                    if (options.bytes !== Array)
                        object.view_public_key = $util.newBuffer(object.view_public_key);
                }
            }
            if (message.spend_public_key != null && message.hasOwnProperty("spend_public_key"))
                object.spend_public_key = options.bytes === String ? $util.base64.encode(message.spend_public_key, 0, message.spend_public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.spend_public_key) : message.spend_public_key;
            if (message.view_public_key != null && message.hasOwnProperty("view_public_key"))
                object.view_public_key = options.bytes === String ? $util.base64.encode(message.view_public_key, 0, message.view_public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.view_public_key) : message.view_public_key;
            return object;
        };

        MoneroAccountPublicAddress.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return MoneroAccountPublicAddress;
    })();

    return MoneroTransactionDestinationEntry;
})();

$root.MoneroTransactionRsigData = (function() {

    function MoneroTransactionRsigData(properties) {
        this.grouping = [];
        this.rsig_parts = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroTransactionRsigData.prototype.rsig_type = 0;
    MoneroTransactionRsigData.prototype.offload_type = 0;
    MoneroTransactionRsigData.prototype.grouping = $util.emptyArray;
    MoneroTransactionRsigData.prototype.mask = $util.newBuffer([]);
    MoneroTransactionRsigData.prototype.rsig = $util.newBuffer([]);
    MoneroTransactionRsigData.prototype.rsig_parts = $util.emptyArray;
    MoneroTransactionRsigData.prototype.bp_version = 0;

    MoneroTransactionRsigData.create = function create(properties) {
        return new MoneroTransactionRsigData(properties);
    };

    MoneroTransactionRsigData.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.rsig_type != null && Object.hasOwnProperty.call(message, "rsig_type"))
            writer.uint32(8).uint32(message.rsig_type);
        if (message.offload_type != null && Object.hasOwnProperty.call(message, "offload_type"))
            writer.uint32(16).uint32(message.offload_type);
        if (message.grouping != null && message.grouping.length)
            for (var i = 0; i < message.grouping.length; ++i)
                writer.uint32(24).uint64(message.grouping[i]);
        if (message.mask != null && Object.hasOwnProperty.call(message, "mask"))
            writer.uint32(34).bytes(message.mask);
        if (message.rsig != null && Object.hasOwnProperty.call(message, "rsig"))
            writer.uint32(42).bytes(message.rsig);
        if (message.rsig_parts != null && message.rsig_parts.length)
            for (var i = 0; i < message.rsig_parts.length; ++i)
                writer.uint32(50).bytes(message.rsig_parts[i]);
        if (message.bp_version != null && Object.hasOwnProperty.call(message, "bp_version"))
            writer.uint32(56).uint32(message.bp_version);
        return writer;
    };

    MoneroTransactionRsigData.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroTransactionRsigData.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroTransactionRsigData();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.rsig_type = reader.uint32();
                break;
            case 2:
                message.offload_type = reader.uint32();
                break;
            case 3:
                if (!(message.grouping && message.grouping.length))
                    message.grouping = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.grouping.push(reader.uint64());
                } else
                    message.grouping.push(reader.uint64());
                break;
            case 4:
                message.mask = reader.bytes();
                break;
            case 5:
                message.rsig = reader.bytes();
                break;
            case 6:
                if (!(message.rsig_parts && message.rsig_parts.length))
                    message.rsig_parts = [];
                message.rsig_parts.push(reader.bytes());
                break;
            case 7:
                message.bp_version = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroTransactionRsigData.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroTransactionRsigData.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.rsig_type != null && message.hasOwnProperty("rsig_type"))
            if (!$util.isInteger(message.rsig_type))
                return "rsig_type: integer expected";
        if (message.offload_type != null && message.hasOwnProperty("offload_type"))
            if (!$util.isInteger(message.offload_type))
                return "offload_type: integer expected";
        if (message.grouping != null && message.hasOwnProperty("grouping")) {
            if (!Array.isArray(message.grouping))
                return "grouping: array expected";
            for (var i = 0; i < message.grouping.length; ++i)
                if (!$util.isInteger(message.grouping[i]) && !(message.grouping[i] && $util.isInteger(message.grouping[i].low) && $util.isInteger(message.grouping[i].high)))
                    return "grouping: integer|Long[] expected";
        }
        if (message.mask != null && message.hasOwnProperty("mask"))
            if (!(message.mask && typeof message.mask.length === "number" || $util.isString(message.mask)))
                return "mask: buffer expected";
        if (message.rsig != null && message.hasOwnProperty("rsig"))
            if (!(message.rsig && typeof message.rsig.length === "number" || $util.isString(message.rsig)))
                return "rsig: buffer expected";
        if (message.rsig_parts != null && message.hasOwnProperty("rsig_parts")) {
            if (!Array.isArray(message.rsig_parts))
                return "rsig_parts: array expected";
            for (var i = 0; i < message.rsig_parts.length; ++i)
                if (!(message.rsig_parts[i] && typeof message.rsig_parts[i].length === "number" || $util.isString(message.rsig_parts[i])))
                    return "rsig_parts: buffer[] expected";
        }
        if (message.bp_version != null && message.hasOwnProperty("bp_version"))
            if (!$util.isInteger(message.bp_version))
                return "bp_version: integer expected";
        return null;
    };

    MoneroTransactionRsigData.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroTransactionRsigData)
            return object;
        var message = new $root.MoneroTransactionRsigData();
        if (object.rsig_type != null)
            message.rsig_type = object.rsig_type >>> 0;
        if (object.offload_type != null)
            message.offload_type = object.offload_type >>> 0;
        if (object.grouping) {
            if (!Array.isArray(object.grouping))
                throw TypeError(".MoneroTransactionRsigData.grouping: array expected");
            message.grouping = [];
            for (var i = 0; i < object.grouping.length; ++i)
                if ($util.Long)
                    (message.grouping[i] = $util.Long.fromValue(object.grouping[i])).unsigned = true;
                else if (typeof object.grouping[i] === "string")
                    message.grouping[i] = parseInt(object.grouping[i], 10);
                else if (typeof object.grouping[i] === "number")
                    message.grouping[i] = object.grouping[i];
                else if (typeof object.grouping[i] === "object")
                    message.grouping[i] = new $util.LongBits(object.grouping[i].low >>> 0, object.grouping[i].high >>> 0).toNumber(true);
        }
        if (object.mask != null)
            if (typeof object.mask === "string")
                $util.base64.decode(object.mask, message.mask = $util.newBuffer($util.base64.length(object.mask)), 0);
            else if (object.mask.length)
                message.mask = object.mask;
        if (object.rsig != null)
            if (typeof object.rsig === "string")
                $util.base64.decode(object.rsig, message.rsig = $util.newBuffer($util.base64.length(object.rsig)), 0);
            else if (object.rsig.length)
                message.rsig = object.rsig;
        if (object.rsig_parts) {
            if (!Array.isArray(object.rsig_parts))
                throw TypeError(".MoneroTransactionRsigData.rsig_parts: array expected");
            message.rsig_parts = [];
            for (var i = 0; i < object.rsig_parts.length; ++i)
                if (typeof object.rsig_parts[i] === "string")
                    $util.base64.decode(object.rsig_parts[i], message.rsig_parts[i] = $util.newBuffer($util.base64.length(object.rsig_parts[i])), 0);
                else if (object.rsig_parts[i].length)
                    message.rsig_parts[i] = object.rsig_parts[i];
        }
        if (object.bp_version != null)
            message.bp_version = object.bp_version >>> 0;
        return message;
    };

    MoneroTransactionRsigData.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults) {
            object.grouping = [];
            object.rsig_parts = [];
        }
        if (options.defaults) {
            object.rsig_type = 0;
            object.offload_type = 0;
            if (options.bytes === String)
                object.mask = "";
            else {
                object.mask = [];
                if (options.bytes !== Array)
                    object.mask = $util.newBuffer(object.mask);
            }
            if (options.bytes === String)
                object.rsig = "";
            else {
                object.rsig = [];
                if (options.bytes !== Array)
                    object.rsig = $util.newBuffer(object.rsig);
            }
            object.bp_version = 0;
        }
        if (message.rsig_type != null && message.hasOwnProperty("rsig_type"))
            object.rsig_type = message.rsig_type;
        if (message.offload_type != null && message.hasOwnProperty("offload_type"))
            object.offload_type = message.offload_type;
        if (message.grouping && message.grouping.length) {
            object.grouping = [];
            for (var j = 0; j < message.grouping.length; ++j)
                if (typeof message.grouping[j] === "number")
                    object.grouping[j] = options.longs === String ? String(message.grouping[j]) : message.grouping[j];
                else
                    object.grouping[j] = options.longs === String ? $util.Long.prototype.toString.call(message.grouping[j]) : options.longs === Number ? new $util.LongBits(message.grouping[j].low >>> 0, message.grouping[j].high >>> 0).toNumber(true) : message.grouping[j];
        }
        if (message.mask != null && message.hasOwnProperty("mask"))
            object.mask = options.bytes === String ? $util.base64.encode(message.mask, 0, message.mask.length) : options.bytes === Array ? Array.prototype.slice.call(message.mask) : message.mask;
        if (message.rsig != null && message.hasOwnProperty("rsig"))
            object.rsig = options.bytes === String ? $util.base64.encode(message.rsig, 0, message.rsig.length) : options.bytes === Array ? Array.prototype.slice.call(message.rsig) : message.rsig;
        if (message.rsig_parts && message.rsig_parts.length) {
            object.rsig_parts = [];
            for (var j = 0; j < message.rsig_parts.length; ++j)
                object.rsig_parts[j] = options.bytes === String ? $util.base64.encode(message.rsig_parts[j], 0, message.rsig_parts[j].length) : options.bytes === Array ? Array.prototype.slice.call(message.rsig_parts[j]) : message.rsig_parts[j];
        }
        if (message.bp_version != null && message.hasOwnProperty("bp_version"))
            object.bp_version = message.bp_version;
        return object;
    };

    MoneroTransactionRsigData.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoneroTransactionRsigData;
})();

$root.MoneroGetAddress = (function() {

    function MoneroGetAddress(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroGetAddress.prototype.address_n = $util.emptyArray;
    MoneroGetAddress.prototype.show_display = false;
    MoneroGetAddress.prototype.network_type = 0;
    MoneroGetAddress.prototype.account = 0;
    MoneroGetAddress.prototype.minor = 0;
    MoneroGetAddress.prototype.payment_id = $util.newBuffer([]);

    MoneroGetAddress.create = function create(properties) {
        return new MoneroGetAddress(properties);
    };

    MoneroGetAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(16).bool(message.show_display);
        if (message.network_type != null && Object.hasOwnProperty.call(message, "network_type"))
            writer.uint32(24).uint32(message.network_type);
        if (message.account != null && Object.hasOwnProperty.call(message, "account"))
            writer.uint32(32).uint32(message.account);
        if (message.minor != null && Object.hasOwnProperty.call(message, "minor"))
            writer.uint32(40).uint32(message.minor);
        if (message.payment_id != null && Object.hasOwnProperty.call(message, "payment_id"))
            writer.uint32(50).bytes(message.payment_id);
        return writer;
    };

    MoneroGetAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroGetAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroGetAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.show_display = reader.bool();
                break;
            case 3:
                message.network_type = reader.uint32();
                break;
            case 4:
                message.account = reader.uint32();
                break;
            case 5:
                message.minor = reader.uint32();
                break;
            case 6:
                message.payment_id = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroGetAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroGetAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        if (message.network_type != null && message.hasOwnProperty("network_type"))
            if (!$util.isInteger(message.network_type))
                return "network_type: integer expected";
        if (message.account != null && message.hasOwnProperty("account"))
            if (!$util.isInteger(message.account))
                return "account: integer expected";
        if (message.minor != null && message.hasOwnProperty("minor"))
            if (!$util.isInteger(message.minor))
                return "minor: integer expected";
        if (message.payment_id != null && message.hasOwnProperty("payment_id"))
            if (!(message.payment_id && typeof message.payment_id.length === "number" || $util.isString(message.payment_id)))
                return "payment_id: buffer expected";
        return null;
    };

    MoneroGetAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroGetAddress)
            return object;
        var message = new $root.MoneroGetAddress();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".MoneroGetAddress.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        if (object.network_type != null)
            message.network_type = object.network_type >>> 0;
        if (object.account != null)
            message.account = object.account >>> 0;
        if (object.minor != null)
            message.minor = object.minor >>> 0;
        if (object.payment_id != null)
            if (typeof object.payment_id === "string")
                $util.base64.decode(object.payment_id, message.payment_id = $util.newBuffer($util.base64.length(object.payment_id)), 0);
            else if (object.payment_id.length)
                message.payment_id = object.payment_id;
        return message;
    };

    MoneroGetAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            object.show_display = false;
            object.network_type = 0;
            object.account = 0;
            object.minor = 0;
            if (options.bytes === String)
                object.payment_id = "";
            else {
                object.payment_id = [];
                if (options.bytes !== Array)
                    object.payment_id = $util.newBuffer(object.payment_id);
            }
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        if (message.network_type != null && message.hasOwnProperty("network_type"))
            object.network_type = message.network_type;
        if (message.account != null && message.hasOwnProperty("account"))
            object.account = message.account;
        if (message.minor != null && message.hasOwnProperty("minor"))
            object.minor = message.minor;
        if (message.payment_id != null && message.hasOwnProperty("payment_id"))
            object.payment_id = options.bytes === String ? $util.base64.encode(message.payment_id, 0, message.payment_id.length) : options.bytes === Array ? Array.prototype.slice.call(message.payment_id) : message.payment_id;
        return object;
    };

    MoneroGetAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoneroGetAddress;
})();

$root.MoneroAddress = (function() {

    function MoneroAddress(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroAddress.prototype.address = $util.newBuffer([]);

    MoneroAddress.create = function create(properties) {
        return new MoneroAddress(properties);
    };

    MoneroAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address != null && Object.hasOwnProperty.call(message, "address"))
            writer.uint32(10).bytes(message.address);
        return writer;
    };

    MoneroAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address != null && message.hasOwnProperty("address"))
            if (!(message.address && typeof message.address.length === "number" || $util.isString(message.address)))
                return "address: buffer expected";
        return null;
    };

    MoneroAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroAddress)
            return object;
        var message = new $root.MoneroAddress();
        if (object.address != null)
            if (typeof object.address === "string")
                $util.base64.decode(object.address, message.address = $util.newBuffer($util.base64.length(object.address)), 0);
            else if (object.address.length)
                message.address = object.address;
        return message;
    };

    MoneroAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.address = "";
            else {
                object.address = [];
                if (options.bytes !== Array)
                    object.address = $util.newBuffer(object.address);
            }
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = options.bytes === String ? $util.base64.encode(message.address, 0, message.address.length) : options.bytes === Array ? Array.prototype.slice.call(message.address) : message.address;
        return object;
    };

    MoneroAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoneroAddress;
})();

$root.MoneroGetWatchKey = (function() {

    function MoneroGetWatchKey(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroGetWatchKey.prototype.address_n = $util.emptyArray;
    MoneroGetWatchKey.prototype.network_type = 0;

    MoneroGetWatchKey.create = function create(properties) {
        return new MoneroGetWatchKey(properties);
    };

    MoneroGetWatchKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.network_type != null && Object.hasOwnProperty.call(message, "network_type"))
            writer.uint32(16).uint32(message.network_type);
        return writer;
    };

    MoneroGetWatchKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroGetWatchKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroGetWatchKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.network_type = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroGetWatchKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroGetWatchKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.network_type != null && message.hasOwnProperty("network_type"))
            if (!$util.isInteger(message.network_type))
                return "network_type: integer expected";
        return null;
    };

    MoneroGetWatchKey.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroGetWatchKey)
            return object;
        var message = new $root.MoneroGetWatchKey();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".MoneroGetWatchKey.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.network_type != null)
            message.network_type = object.network_type >>> 0;
        return message;
    };

    MoneroGetWatchKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            object.network_type = 0;
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.network_type != null && message.hasOwnProperty("network_type"))
            object.network_type = message.network_type;
        return object;
    };

    MoneroGetWatchKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoneroGetWatchKey;
})();

$root.MoneroWatchKey = (function() {

    function MoneroWatchKey(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroWatchKey.prototype.watch_key = $util.newBuffer([]);
    MoneroWatchKey.prototype.address = $util.newBuffer([]);

    MoneroWatchKey.create = function create(properties) {
        return new MoneroWatchKey(properties);
    };

    MoneroWatchKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.watch_key != null && Object.hasOwnProperty.call(message, "watch_key"))
            writer.uint32(10).bytes(message.watch_key);
        if (message.address != null && Object.hasOwnProperty.call(message, "address"))
            writer.uint32(18).bytes(message.address);
        return writer;
    };

    MoneroWatchKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroWatchKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroWatchKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.watch_key = reader.bytes();
                break;
            case 2:
                message.address = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroWatchKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroWatchKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.watch_key != null && message.hasOwnProperty("watch_key"))
            if (!(message.watch_key && typeof message.watch_key.length === "number" || $util.isString(message.watch_key)))
                return "watch_key: buffer expected";
        if (message.address != null && message.hasOwnProperty("address"))
            if (!(message.address && typeof message.address.length === "number" || $util.isString(message.address)))
                return "address: buffer expected";
        return null;
    };

    MoneroWatchKey.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroWatchKey)
            return object;
        var message = new $root.MoneroWatchKey();
        if (object.watch_key != null)
            if (typeof object.watch_key === "string")
                $util.base64.decode(object.watch_key, message.watch_key = $util.newBuffer($util.base64.length(object.watch_key)), 0);
            else if (object.watch_key.length)
                message.watch_key = object.watch_key;
        if (object.address != null)
            if (typeof object.address === "string")
                $util.base64.decode(object.address, message.address = $util.newBuffer($util.base64.length(object.address)), 0);
            else if (object.address.length)
                message.address = object.address;
        return message;
    };

    MoneroWatchKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.watch_key = "";
            else {
                object.watch_key = [];
                if (options.bytes !== Array)
                    object.watch_key = $util.newBuffer(object.watch_key);
            }
            if (options.bytes === String)
                object.address = "";
            else {
                object.address = [];
                if (options.bytes !== Array)
                    object.address = $util.newBuffer(object.address);
            }
        }
        if (message.watch_key != null && message.hasOwnProperty("watch_key"))
            object.watch_key = options.bytes === String ? $util.base64.encode(message.watch_key, 0, message.watch_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.watch_key) : message.watch_key;
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = options.bytes === String ? $util.base64.encode(message.address, 0, message.address.length) : options.bytes === Array ? Array.prototype.slice.call(message.address) : message.address;
        return object;
    };

    MoneroWatchKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoneroWatchKey;
})();

$root.MoneroTransactionInitRequest = (function() {

    function MoneroTransactionInitRequest(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroTransactionInitRequest.prototype.version = 0;
    MoneroTransactionInitRequest.prototype.address_n = $util.emptyArray;
    MoneroTransactionInitRequest.prototype.network_type = 0;
    MoneroTransactionInitRequest.prototype.tsx_data = null;

    MoneroTransactionInitRequest.create = function create(properties) {
        return new MoneroTransactionInitRequest(properties);
    };

    MoneroTransactionInitRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.version != null && Object.hasOwnProperty.call(message, "version"))
            writer.uint32(8).uint32(message.version);
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(16).uint32(message.address_n[i]);
        if (message.network_type != null && Object.hasOwnProperty.call(message, "network_type"))
            writer.uint32(24).uint32(message.network_type);
        if (message.tsx_data != null && Object.hasOwnProperty.call(message, "tsx_data"))
            $root.MoneroTransactionInitRequest.MoneroTransactionData.encode(message.tsx_data, writer.uint32(34).fork()).ldelim();
        return writer;
    };

    MoneroTransactionInitRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroTransactionInitRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroTransactionInitRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.version = reader.uint32();
                break;
            case 2:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 3:
                message.network_type = reader.uint32();
                break;
            case 4:
                message.tsx_data = $root.MoneroTransactionInitRequest.MoneroTransactionData.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroTransactionInitRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroTransactionInitRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.version != null && message.hasOwnProperty("version"))
            if (!$util.isInteger(message.version))
                return "version: integer expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.network_type != null && message.hasOwnProperty("network_type"))
            if (!$util.isInteger(message.network_type))
                return "network_type: integer expected";
        if (message.tsx_data != null && message.hasOwnProperty("tsx_data")) {
            var error = $root.MoneroTransactionInitRequest.MoneroTransactionData.verify(message.tsx_data);
            if (error)
                return "tsx_data." + error;
        }
        return null;
    };

    MoneroTransactionInitRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroTransactionInitRequest)
            return object;
        var message = new $root.MoneroTransactionInitRequest();
        if (object.version != null)
            message.version = object.version >>> 0;
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".MoneroTransactionInitRequest.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.network_type != null)
            message.network_type = object.network_type >>> 0;
        if (object.tsx_data != null) {
            if (typeof object.tsx_data !== "object")
                throw TypeError(".MoneroTransactionInitRequest.tsx_data: object expected");
            message.tsx_data = $root.MoneroTransactionInitRequest.MoneroTransactionData.fromObject(object.tsx_data);
        }
        return message;
    };

    MoneroTransactionInitRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            object.version = 0;
            object.network_type = 0;
            object.tsx_data = null;
        }
        if (message.version != null && message.hasOwnProperty("version"))
            object.version = message.version;
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.network_type != null && message.hasOwnProperty("network_type"))
            object.network_type = message.network_type;
        if (message.tsx_data != null && message.hasOwnProperty("tsx_data"))
            object.tsx_data = $root.MoneroTransactionInitRequest.MoneroTransactionData.toObject(message.tsx_data, options);
        return object;
    };

    MoneroTransactionInitRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    MoneroTransactionInitRequest.MoneroTransactionData = (function() {

        function MoneroTransactionData(properties) {
            this.outputs = [];
            this.minor_indices = [];
            this.integrated_indices = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        MoneroTransactionData.prototype.version = 0;
        MoneroTransactionData.prototype.payment_id = $util.newBuffer([]);
        MoneroTransactionData.prototype.unlock_time = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        MoneroTransactionData.prototype.outputs = $util.emptyArray;
        MoneroTransactionData.prototype.change_dts = null;
        MoneroTransactionData.prototype.num_inputs = 0;
        MoneroTransactionData.prototype.mixin = 0;
        MoneroTransactionData.prototype.fee = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        MoneroTransactionData.prototype.account = 0;
        MoneroTransactionData.prototype.minor_indices = $util.emptyArray;
        MoneroTransactionData.prototype.rsig_data = null;
        MoneroTransactionData.prototype.integrated_indices = $util.emptyArray;
        MoneroTransactionData.prototype.client_version = 0;
        MoneroTransactionData.prototype.hard_fork = 0;
        MoneroTransactionData.prototype.monero_version = $util.newBuffer([]);

        MoneroTransactionData.create = function create(properties) {
            return new MoneroTransactionData(properties);
        };

        MoneroTransactionData.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.version != null && Object.hasOwnProperty.call(message, "version"))
                writer.uint32(8).uint32(message.version);
            if (message.payment_id != null && Object.hasOwnProperty.call(message, "payment_id"))
                writer.uint32(18).bytes(message.payment_id);
            if (message.unlock_time != null && Object.hasOwnProperty.call(message, "unlock_time"))
                writer.uint32(24).uint64(message.unlock_time);
            if (message.outputs != null && message.outputs.length)
                for (var i = 0; i < message.outputs.length; ++i)
                    $root.MoneroTransactionDestinationEntry.encode(message.outputs[i], writer.uint32(34).fork()).ldelim();
            if (message.change_dts != null && Object.hasOwnProperty.call(message, "change_dts"))
                $root.MoneroTransactionDestinationEntry.encode(message.change_dts, writer.uint32(42).fork()).ldelim();
            if (message.num_inputs != null && Object.hasOwnProperty.call(message, "num_inputs"))
                writer.uint32(48).uint32(message.num_inputs);
            if (message.mixin != null && Object.hasOwnProperty.call(message, "mixin"))
                writer.uint32(56).uint32(message.mixin);
            if (message.fee != null && Object.hasOwnProperty.call(message, "fee"))
                writer.uint32(64).uint64(message.fee);
            if (message.account != null && Object.hasOwnProperty.call(message, "account"))
                writer.uint32(72).uint32(message.account);
            if (message.minor_indices != null && message.minor_indices.length)
                for (var i = 0; i < message.minor_indices.length; ++i)
                    writer.uint32(80).uint32(message.minor_indices[i]);
            if (message.rsig_data != null && Object.hasOwnProperty.call(message, "rsig_data"))
                $root.MoneroTransactionRsigData.encode(message.rsig_data, writer.uint32(90).fork()).ldelim();
            if (message.integrated_indices != null && message.integrated_indices.length)
                for (var i = 0; i < message.integrated_indices.length; ++i)
                    writer.uint32(96).uint32(message.integrated_indices[i]);
            if (message.client_version != null && Object.hasOwnProperty.call(message, "client_version"))
                writer.uint32(104).uint32(message.client_version);
            if (message.hard_fork != null && Object.hasOwnProperty.call(message, "hard_fork"))
                writer.uint32(112).uint32(message.hard_fork);
            if (message.monero_version != null && Object.hasOwnProperty.call(message, "monero_version"))
                writer.uint32(122).bytes(message.monero_version);
            return writer;
        };

        MoneroTransactionData.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        MoneroTransactionData.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroTransactionInitRequest.MoneroTransactionData();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.version = reader.uint32();
                    break;
                case 2:
                    message.payment_id = reader.bytes();
                    break;
                case 3:
                    message.unlock_time = reader.uint64();
                    break;
                case 4:
                    if (!(message.outputs && message.outputs.length))
                        message.outputs = [];
                    message.outputs.push($root.MoneroTransactionDestinationEntry.decode(reader, reader.uint32()));
                    break;
                case 5:
                    message.change_dts = $root.MoneroTransactionDestinationEntry.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.num_inputs = reader.uint32();
                    break;
                case 7:
                    message.mixin = reader.uint32();
                    break;
                case 8:
                    message.fee = reader.uint64();
                    break;
                case 9:
                    message.account = reader.uint32();
                    break;
                case 10:
                    if (!(message.minor_indices && message.minor_indices.length))
                        message.minor_indices = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.minor_indices.push(reader.uint32());
                    } else
                        message.minor_indices.push(reader.uint32());
                    break;
                case 11:
                    message.rsig_data = $root.MoneroTransactionRsigData.decode(reader, reader.uint32());
                    break;
                case 12:
                    if (!(message.integrated_indices && message.integrated_indices.length))
                        message.integrated_indices = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.integrated_indices.push(reader.uint32());
                    } else
                        message.integrated_indices.push(reader.uint32());
                    break;
                case 13:
                    message.client_version = reader.uint32();
                    break;
                case 14:
                    message.hard_fork = reader.uint32();
                    break;
                case 15:
                    message.monero_version = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        MoneroTransactionData.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        MoneroTransactionData.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.version != null && message.hasOwnProperty("version"))
                if (!$util.isInteger(message.version))
                    return "version: integer expected";
            if (message.payment_id != null && message.hasOwnProperty("payment_id"))
                if (!(message.payment_id && typeof message.payment_id.length === "number" || $util.isString(message.payment_id)))
                    return "payment_id: buffer expected";
            if (message.unlock_time != null && message.hasOwnProperty("unlock_time"))
                if (!$util.isInteger(message.unlock_time) && !(message.unlock_time && $util.isInteger(message.unlock_time.low) && $util.isInteger(message.unlock_time.high)))
                    return "unlock_time: integer|Long expected";
            if (message.outputs != null && message.hasOwnProperty("outputs")) {
                if (!Array.isArray(message.outputs))
                    return "outputs: array expected";
                for (var i = 0; i < message.outputs.length; ++i) {
                    var error = $root.MoneroTransactionDestinationEntry.verify(message.outputs[i]);
                    if (error)
                        return "outputs." + error;
                }
            }
            if (message.change_dts != null && message.hasOwnProperty("change_dts")) {
                var error = $root.MoneroTransactionDestinationEntry.verify(message.change_dts);
                if (error)
                    return "change_dts." + error;
            }
            if (message.num_inputs != null && message.hasOwnProperty("num_inputs"))
                if (!$util.isInteger(message.num_inputs))
                    return "num_inputs: integer expected";
            if (message.mixin != null && message.hasOwnProperty("mixin"))
                if (!$util.isInteger(message.mixin))
                    return "mixin: integer expected";
            if (message.fee != null && message.hasOwnProperty("fee"))
                if (!$util.isInteger(message.fee) && !(message.fee && $util.isInteger(message.fee.low) && $util.isInteger(message.fee.high)))
                    return "fee: integer|Long expected";
            if (message.account != null && message.hasOwnProperty("account"))
                if (!$util.isInteger(message.account))
                    return "account: integer expected";
            if (message.minor_indices != null && message.hasOwnProperty("minor_indices")) {
                if (!Array.isArray(message.minor_indices))
                    return "minor_indices: array expected";
                for (var i = 0; i < message.minor_indices.length; ++i)
                    if (!$util.isInteger(message.minor_indices[i]))
                        return "minor_indices: integer[] expected";
            }
            if (message.rsig_data != null && message.hasOwnProperty("rsig_data")) {
                var error = $root.MoneroTransactionRsigData.verify(message.rsig_data);
                if (error)
                    return "rsig_data." + error;
            }
            if (message.integrated_indices != null && message.hasOwnProperty("integrated_indices")) {
                if (!Array.isArray(message.integrated_indices))
                    return "integrated_indices: array expected";
                for (var i = 0; i < message.integrated_indices.length; ++i)
                    if (!$util.isInteger(message.integrated_indices[i]))
                        return "integrated_indices: integer[] expected";
            }
            if (message.client_version != null && message.hasOwnProperty("client_version"))
                if (!$util.isInteger(message.client_version))
                    return "client_version: integer expected";
            if (message.hard_fork != null && message.hasOwnProperty("hard_fork"))
                if (!$util.isInteger(message.hard_fork))
                    return "hard_fork: integer expected";
            if (message.monero_version != null && message.hasOwnProperty("monero_version"))
                if (!(message.monero_version && typeof message.monero_version.length === "number" || $util.isString(message.monero_version)))
                    return "monero_version: buffer expected";
            return null;
        };

        MoneroTransactionData.fromObject = function fromObject(object) {
            if (object instanceof $root.MoneroTransactionInitRequest.MoneroTransactionData)
                return object;
            var message = new $root.MoneroTransactionInitRequest.MoneroTransactionData();
            if (object.version != null)
                message.version = object.version >>> 0;
            if (object.payment_id != null)
                if (typeof object.payment_id === "string")
                    $util.base64.decode(object.payment_id, message.payment_id = $util.newBuffer($util.base64.length(object.payment_id)), 0);
                else if (object.payment_id.length)
                    message.payment_id = object.payment_id;
            if (object.unlock_time != null)
                if ($util.Long)
                    (message.unlock_time = $util.Long.fromValue(object.unlock_time)).unsigned = true;
                else if (typeof object.unlock_time === "string")
                    message.unlock_time = parseInt(object.unlock_time, 10);
                else if (typeof object.unlock_time === "number")
                    message.unlock_time = object.unlock_time;
                else if (typeof object.unlock_time === "object")
                    message.unlock_time = new $util.LongBits(object.unlock_time.low >>> 0, object.unlock_time.high >>> 0).toNumber(true);
            if (object.outputs) {
                if (!Array.isArray(object.outputs))
                    throw TypeError(".MoneroTransactionInitRequest.MoneroTransactionData.outputs: array expected");
                message.outputs = [];
                for (var i = 0; i < object.outputs.length; ++i) {
                    if (typeof object.outputs[i] !== "object")
                        throw TypeError(".MoneroTransactionInitRequest.MoneroTransactionData.outputs: object expected");
                    message.outputs[i] = $root.MoneroTransactionDestinationEntry.fromObject(object.outputs[i]);
                }
            }
            if (object.change_dts != null) {
                if (typeof object.change_dts !== "object")
                    throw TypeError(".MoneroTransactionInitRequest.MoneroTransactionData.change_dts: object expected");
                message.change_dts = $root.MoneroTransactionDestinationEntry.fromObject(object.change_dts);
            }
            if (object.num_inputs != null)
                message.num_inputs = object.num_inputs >>> 0;
            if (object.mixin != null)
                message.mixin = object.mixin >>> 0;
            if (object.fee != null)
                if ($util.Long)
                    (message.fee = $util.Long.fromValue(object.fee)).unsigned = true;
                else if (typeof object.fee === "string")
                    message.fee = parseInt(object.fee, 10);
                else if (typeof object.fee === "number")
                    message.fee = object.fee;
                else if (typeof object.fee === "object")
                    message.fee = new $util.LongBits(object.fee.low >>> 0, object.fee.high >>> 0).toNumber(true);
            if (object.account != null)
                message.account = object.account >>> 0;
            if (object.minor_indices) {
                if (!Array.isArray(object.minor_indices))
                    throw TypeError(".MoneroTransactionInitRequest.MoneroTransactionData.minor_indices: array expected");
                message.minor_indices = [];
                for (var i = 0; i < object.minor_indices.length; ++i)
                    message.minor_indices[i] = object.minor_indices[i] >>> 0;
            }
            if (object.rsig_data != null) {
                if (typeof object.rsig_data !== "object")
                    throw TypeError(".MoneroTransactionInitRequest.MoneroTransactionData.rsig_data: object expected");
                message.rsig_data = $root.MoneroTransactionRsigData.fromObject(object.rsig_data);
            }
            if (object.integrated_indices) {
                if (!Array.isArray(object.integrated_indices))
                    throw TypeError(".MoneroTransactionInitRequest.MoneroTransactionData.integrated_indices: array expected");
                message.integrated_indices = [];
                for (var i = 0; i < object.integrated_indices.length; ++i)
                    message.integrated_indices[i] = object.integrated_indices[i] >>> 0;
            }
            if (object.client_version != null)
                message.client_version = object.client_version >>> 0;
            if (object.hard_fork != null)
                message.hard_fork = object.hard_fork >>> 0;
            if (object.monero_version != null)
                if (typeof object.monero_version === "string")
                    $util.base64.decode(object.monero_version, message.monero_version = $util.newBuffer($util.base64.length(object.monero_version)), 0);
                else if (object.monero_version.length)
                    message.monero_version = object.monero_version;
            return message;
        };

        MoneroTransactionData.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.outputs = [];
                object.minor_indices = [];
                object.integrated_indices = [];
            }
            if (options.defaults) {
                object.version = 0;
                if (options.bytes === String)
                    object.payment_id = "";
                else {
                    object.payment_id = [];
                    if (options.bytes !== Array)
                        object.payment_id = $util.newBuffer(object.payment_id);
                }
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.unlock_time = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.unlock_time = options.longs === String ? "0" : 0;
                object.change_dts = null;
                object.num_inputs = 0;
                object.mixin = 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.fee = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.fee = options.longs === String ? "0" : 0;
                object.account = 0;
                object.rsig_data = null;
                object.client_version = 0;
                object.hard_fork = 0;
                if (options.bytes === String)
                    object.monero_version = "";
                else {
                    object.monero_version = [];
                    if (options.bytes !== Array)
                        object.monero_version = $util.newBuffer(object.monero_version);
                }
            }
            if (message.version != null && message.hasOwnProperty("version"))
                object.version = message.version;
            if (message.payment_id != null && message.hasOwnProperty("payment_id"))
                object.payment_id = options.bytes === String ? $util.base64.encode(message.payment_id, 0, message.payment_id.length) : options.bytes === Array ? Array.prototype.slice.call(message.payment_id) : message.payment_id;
            if (message.unlock_time != null && message.hasOwnProperty("unlock_time"))
                if (typeof message.unlock_time === "number")
                    object.unlock_time = options.longs === String ? String(message.unlock_time) : message.unlock_time;
                else
                    object.unlock_time = options.longs === String ? $util.Long.prototype.toString.call(message.unlock_time) : options.longs === Number ? new $util.LongBits(message.unlock_time.low >>> 0, message.unlock_time.high >>> 0).toNumber(true) : message.unlock_time;
            if (message.outputs && message.outputs.length) {
                object.outputs = [];
                for (var j = 0; j < message.outputs.length; ++j)
                    object.outputs[j] = $root.MoneroTransactionDestinationEntry.toObject(message.outputs[j], options);
            }
            if (message.change_dts != null && message.hasOwnProperty("change_dts"))
                object.change_dts = $root.MoneroTransactionDestinationEntry.toObject(message.change_dts, options);
            if (message.num_inputs != null && message.hasOwnProperty("num_inputs"))
                object.num_inputs = message.num_inputs;
            if (message.mixin != null && message.hasOwnProperty("mixin"))
                object.mixin = message.mixin;
            if (message.fee != null && message.hasOwnProperty("fee"))
                if (typeof message.fee === "number")
                    object.fee = options.longs === String ? String(message.fee) : message.fee;
                else
                    object.fee = options.longs === String ? $util.Long.prototype.toString.call(message.fee) : options.longs === Number ? new $util.LongBits(message.fee.low >>> 0, message.fee.high >>> 0).toNumber(true) : message.fee;
            if (message.account != null && message.hasOwnProperty("account"))
                object.account = message.account;
            if (message.minor_indices && message.minor_indices.length) {
                object.minor_indices = [];
                for (var j = 0; j < message.minor_indices.length; ++j)
                    object.minor_indices[j] = message.minor_indices[j];
            }
            if (message.rsig_data != null && message.hasOwnProperty("rsig_data"))
                object.rsig_data = $root.MoneroTransactionRsigData.toObject(message.rsig_data, options);
            if (message.integrated_indices && message.integrated_indices.length) {
                object.integrated_indices = [];
                for (var j = 0; j < message.integrated_indices.length; ++j)
                    object.integrated_indices[j] = message.integrated_indices[j];
            }
            if (message.client_version != null && message.hasOwnProperty("client_version"))
                object.client_version = message.client_version;
            if (message.hard_fork != null && message.hasOwnProperty("hard_fork"))
                object.hard_fork = message.hard_fork;
            if (message.monero_version != null && message.hasOwnProperty("monero_version"))
                object.monero_version = options.bytes === String ? $util.base64.encode(message.monero_version, 0, message.monero_version.length) : options.bytes === Array ? Array.prototype.slice.call(message.monero_version) : message.monero_version;
            return object;
        };

        MoneroTransactionData.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return MoneroTransactionData;
    })();

    return MoneroTransactionInitRequest;
})();

$root.MoneroTransactionInitAck = (function() {

    function MoneroTransactionInitAck(properties) {
        this.hmacs = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroTransactionInitAck.prototype.hmacs = $util.emptyArray;
    MoneroTransactionInitAck.prototype.rsig_data = null;

    MoneroTransactionInitAck.create = function create(properties) {
        return new MoneroTransactionInitAck(properties);
    };

    MoneroTransactionInitAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.hmacs != null && message.hmacs.length)
            for (var i = 0; i < message.hmacs.length; ++i)
                writer.uint32(10).bytes(message.hmacs[i]);
        if (message.rsig_data != null && Object.hasOwnProperty.call(message, "rsig_data"))
            $root.MoneroTransactionRsigData.encode(message.rsig_data, writer.uint32(18).fork()).ldelim();
        return writer;
    };

    MoneroTransactionInitAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroTransactionInitAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroTransactionInitAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.hmacs && message.hmacs.length))
                    message.hmacs = [];
                message.hmacs.push(reader.bytes());
                break;
            case 2:
                message.rsig_data = $root.MoneroTransactionRsigData.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroTransactionInitAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroTransactionInitAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.hmacs != null && message.hasOwnProperty("hmacs")) {
            if (!Array.isArray(message.hmacs))
                return "hmacs: array expected";
            for (var i = 0; i < message.hmacs.length; ++i)
                if (!(message.hmacs[i] && typeof message.hmacs[i].length === "number" || $util.isString(message.hmacs[i])))
                    return "hmacs: buffer[] expected";
        }
        if (message.rsig_data != null && message.hasOwnProperty("rsig_data")) {
            var error = $root.MoneroTransactionRsigData.verify(message.rsig_data);
            if (error)
                return "rsig_data." + error;
        }
        return null;
    };

    MoneroTransactionInitAck.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroTransactionInitAck)
            return object;
        var message = new $root.MoneroTransactionInitAck();
        if (object.hmacs) {
            if (!Array.isArray(object.hmacs))
                throw TypeError(".MoneroTransactionInitAck.hmacs: array expected");
            message.hmacs = [];
            for (var i = 0; i < object.hmacs.length; ++i)
                if (typeof object.hmacs[i] === "string")
                    $util.base64.decode(object.hmacs[i], message.hmacs[i] = $util.newBuffer($util.base64.length(object.hmacs[i])), 0);
                else if (object.hmacs[i].length)
                    message.hmacs[i] = object.hmacs[i];
        }
        if (object.rsig_data != null) {
            if (typeof object.rsig_data !== "object")
                throw TypeError(".MoneroTransactionInitAck.rsig_data: object expected");
            message.rsig_data = $root.MoneroTransactionRsigData.fromObject(object.rsig_data);
        }
        return message;
    };

    MoneroTransactionInitAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.hmacs = [];
        if (options.defaults)
            object.rsig_data = null;
        if (message.hmacs && message.hmacs.length) {
            object.hmacs = [];
            for (var j = 0; j < message.hmacs.length; ++j)
                object.hmacs[j] = options.bytes === String ? $util.base64.encode(message.hmacs[j], 0, message.hmacs[j].length) : options.bytes === Array ? Array.prototype.slice.call(message.hmacs[j]) : message.hmacs[j];
        }
        if (message.rsig_data != null && message.hasOwnProperty("rsig_data"))
            object.rsig_data = $root.MoneroTransactionRsigData.toObject(message.rsig_data, options);
        return object;
    };

    MoneroTransactionInitAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoneroTransactionInitAck;
})();

$root.MoneroTransactionSetInputRequest = (function() {

    function MoneroTransactionSetInputRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroTransactionSetInputRequest.prototype.src_entr = null;

    MoneroTransactionSetInputRequest.create = function create(properties) {
        return new MoneroTransactionSetInputRequest(properties);
    };

    MoneroTransactionSetInputRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.src_entr != null && Object.hasOwnProperty.call(message, "src_entr"))
            $root.MoneroTransactionSourceEntry.encode(message.src_entr, writer.uint32(10).fork()).ldelim();
        return writer;
    };

    MoneroTransactionSetInputRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroTransactionSetInputRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroTransactionSetInputRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.src_entr = $root.MoneroTransactionSourceEntry.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroTransactionSetInputRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroTransactionSetInputRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.src_entr != null && message.hasOwnProperty("src_entr")) {
            var error = $root.MoneroTransactionSourceEntry.verify(message.src_entr);
            if (error)
                return "src_entr." + error;
        }
        return null;
    };

    MoneroTransactionSetInputRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroTransactionSetInputRequest)
            return object;
        var message = new $root.MoneroTransactionSetInputRequest();
        if (object.src_entr != null) {
            if (typeof object.src_entr !== "object")
                throw TypeError(".MoneroTransactionSetInputRequest.src_entr: object expected");
            message.src_entr = $root.MoneroTransactionSourceEntry.fromObject(object.src_entr);
        }
        return message;
    };

    MoneroTransactionSetInputRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.src_entr = null;
        if (message.src_entr != null && message.hasOwnProperty("src_entr"))
            object.src_entr = $root.MoneroTransactionSourceEntry.toObject(message.src_entr, options);
        return object;
    };

    MoneroTransactionSetInputRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoneroTransactionSetInputRequest;
})();

$root.MoneroTransactionSetInputAck = (function() {

    function MoneroTransactionSetInputAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroTransactionSetInputAck.prototype.vini = $util.newBuffer([]);
    MoneroTransactionSetInputAck.prototype.vini_hmac = $util.newBuffer([]);
    MoneroTransactionSetInputAck.prototype.pseudo_out = $util.newBuffer([]);
    MoneroTransactionSetInputAck.prototype.pseudo_out_hmac = $util.newBuffer([]);
    MoneroTransactionSetInputAck.prototype.pseudo_out_alpha = $util.newBuffer([]);
    MoneroTransactionSetInputAck.prototype.spend_key = $util.newBuffer([]);

    MoneroTransactionSetInputAck.create = function create(properties) {
        return new MoneroTransactionSetInputAck(properties);
    };

    MoneroTransactionSetInputAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.vini != null && Object.hasOwnProperty.call(message, "vini"))
            writer.uint32(10).bytes(message.vini);
        if (message.vini_hmac != null && Object.hasOwnProperty.call(message, "vini_hmac"))
            writer.uint32(18).bytes(message.vini_hmac);
        if (message.pseudo_out != null && Object.hasOwnProperty.call(message, "pseudo_out"))
            writer.uint32(26).bytes(message.pseudo_out);
        if (message.pseudo_out_hmac != null && Object.hasOwnProperty.call(message, "pseudo_out_hmac"))
            writer.uint32(34).bytes(message.pseudo_out_hmac);
        if (message.pseudo_out_alpha != null && Object.hasOwnProperty.call(message, "pseudo_out_alpha"))
            writer.uint32(42).bytes(message.pseudo_out_alpha);
        if (message.spend_key != null && Object.hasOwnProperty.call(message, "spend_key"))
            writer.uint32(50).bytes(message.spend_key);
        return writer;
    };

    MoneroTransactionSetInputAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroTransactionSetInputAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroTransactionSetInputAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.vini = reader.bytes();
                break;
            case 2:
                message.vini_hmac = reader.bytes();
                break;
            case 3:
                message.pseudo_out = reader.bytes();
                break;
            case 4:
                message.pseudo_out_hmac = reader.bytes();
                break;
            case 5:
                message.pseudo_out_alpha = reader.bytes();
                break;
            case 6:
                message.spend_key = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroTransactionSetInputAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroTransactionSetInputAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.vini != null && message.hasOwnProperty("vini"))
            if (!(message.vini && typeof message.vini.length === "number" || $util.isString(message.vini)))
                return "vini: buffer expected";
        if (message.vini_hmac != null && message.hasOwnProperty("vini_hmac"))
            if (!(message.vini_hmac && typeof message.vini_hmac.length === "number" || $util.isString(message.vini_hmac)))
                return "vini_hmac: buffer expected";
        if (message.pseudo_out != null && message.hasOwnProperty("pseudo_out"))
            if (!(message.pseudo_out && typeof message.pseudo_out.length === "number" || $util.isString(message.pseudo_out)))
                return "pseudo_out: buffer expected";
        if (message.pseudo_out_hmac != null && message.hasOwnProperty("pseudo_out_hmac"))
            if (!(message.pseudo_out_hmac && typeof message.pseudo_out_hmac.length === "number" || $util.isString(message.pseudo_out_hmac)))
                return "pseudo_out_hmac: buffer expected";
        if (message.pseudo_out_alpha != null && message.hasOwnProperty("pseudo_out_alpha"))
            if (!(message.pseudo_out_alpha && typeof message.pseudo_out_alpha.length === "number" || $util.isString(message.pseudo_out_alpha)))
                return "pseudo_out_alpha: buffer expected";
        if (message.spend_key != null && message.hasOwnProperty("spend_key"))
            if (!(message.spend_key && typeof message.spend_key.length === "number" || $util.isString(message.spend_key)))
                return "spend_key: buffer expected";
        return null;
    };

    MoneroTransactionSetInputAck.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroTransactionSetInputAck)
            return object;
        var message = new $root.MoneroTransactionSetInputAck();
        if (object.vini != null)
            if (typeof object.vini === "string")
                $util.base64.decode(object.vini, message.vini = $util.newBuffer($util.base64.length(object.vini)), 0);
            else if (object.vini.length)
                message.vini = object.vini;
        if (object.vini_hmac != null)
            if (typeof object.vini_hmac === "string")
                $util.base64.decode(object.vini_hmac, message.vini_hmac = $util.newBuffer($util.base64.length(object.vini_hmac)), 0);
            else if (object.vini_hmac.length)
                message.vini_hmac = object.vini_hmac;
        if (object.pseudo_out != null)
            if (typeof object.pseudo_out === "string")
                $util.base64.decode(object.pseudo_out, message.pseudo_out = $util.newBuffer($util.base64.length(object.pseudo_out)), 0);
            else if (object.pseudo_out.length)
                message.pseudo_out = object.pseudo_out;
        if (object.pseudo_out_hmac != null)
            if (typeof object.pseudo_out_hmac === "string")
                $util.base64.decode(object.pseudo_out_hmac, message.pseudo_out_hmac = $util.newBuffer($util.base64.length(object.pseudo_out_hmac)), 0);
            else if (object.pseudo_out_hmac.length)
                message.pseudo_out_hmac = object.pseudo_out_hmac;
        if (object.pseudo_out_alpha != null)
            if (typeof object.pseudo_out_alpha === "string")
                $util.base64.decode(object.pseudo_out_alpha, message.pseudo_out_alpha = $util.newBuffer($util.base64.length(object.pseudo_out_alpha)), 0);
            else if (object.pseudo_out_alpha.length)
                message.pseudo_out_alpha = object.pseudo_out_alpha;
        if (object.spend_key != null)
            if (typeof object.spend_key === "string")
                $util.base64.decode(object.spend_key, message.spend_key = $util.newBuffer($util.base64.length(object.spend_key)), 0);
            else if (object.spend_key.length)
                message.spend_key = object.spend_key;
        return message;
    };

    MoneroTransactionSetInputAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.vini = "";
            else {
                object.vini = [];
                if (options.bytes !== Array)
                    object.vini = $util.newBuffer(object.vini);
            }
            if (options.bytes === String)
                object.vini_hmac = "";
            else {
                object.vini_hmac = [];
                if (options.bytes !== Array)
                    object.vini_hmac = $util.newBuffer(object.vini_hmac);
            }
            if (options.bytes === String)
                object.pseudo_out = "";
            else {
                object.pseudo_out = [];
                if (options.bytes !== Array)
                    object.pseudo_out = $util.newBuffer(object.pseudo_out);
            }
            if (options.bytes === String)
                object.pseudo_out_hmac = "";
            else {
                object.pseudo_out_hmac = [];
                if (options.bytes !== Array)
                    object.pseudo_out_hmac = $util.newBuffer(object.pseudo_out_hmac);
            }
            if (options.bytes === String)
                object.pseudo_out_alpha = "";
            else {
                object.pseudo_out_alpha = [];
                if (options.bytes !== Array)
                    object.pseudo_out_alpha = $util.newBuffer(object.pseudo_out_alpha);
            }
            if (options.bytes === String)
                object.spend_key = "";
            else {
                object.spend_key = [];
                if (options.bytes !== Array)
                    object.spend_key = $util.newBuffer(object.spend_key);
            }
        }
        if (message.vini != null && message.hasOwnProperty("vini"))
            object.vini = options.bytes === String ? $util.base64.encode(message.vini, 0, message.vini.length) : options.bytes === Array ? Array.prototype.slice.call(message.vini) : message.vini;
        if (message.vini_hmac != null && message.hasOwnProperty("vini_hmac"))
            object.vini_hmac = options.bytes === String ? $util.base64.encode(message.vini_hmac, 0, message.vini_hmac.length) : options.bytes === Array ? Array.prototype.slice.call(message.vini_hmac) : message.vini_hmac;
        if (message.pseudo_out != null && message.hasOwnProperty("pseudo_out"))
            object.pseudo_out = options.bytes === String ? $util.base64.encode(message.pseudo_out, 0, message.pseudo_out.length) : options.bytes === Array ? Array.prototype.slice.call(message.pseudo_out) : message.pseudo_out;
        if (message.pseudo_out_hmac != null && message.hasOwnProperty("pseudo_out_hmac"))
            object.pseudo_out_hmac = options.bytes === String ? $util.base64.encode(message.pseudo_out_hmac, 0, message.pseudo_out_hmac.length) : options.bytes === Array ? Array.prototype.slice.call(message.pseudo_out_hmac) : message.pseudo_out_hmac;
        if (message.pseudo_out_alpha != null && message.hasOwnProperty("pseudo_out_alpha"))
            object.pseudo_out_alpha = options.bytes === String ? $util.base64.encode(message.pseudo_out_alpha, 0, message.pseudo_out_alpha.length) : options.bytes === Array ? Array.prototype.slice.call(message.pseudo_out_alpha) : message.pseudo_out_alpha;
        if (message.spend_key != null && message.hasOwnProperty("spend_key"))
            object.spend_key = options.bytes === String ? $util.base64.encode(message.spend_key, 0, message.spend_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.spend_key) : message.spend_key;
        return object;
    };

    MoneroTransactionSetInputAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoneroTransactionSetInputAck;
})();

$root.MoneroTransactionInputsPermutationRequest = (function() {

    function MoneroTransactionInputsPermutationRequest(properties) {
        this.perm = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroTransactionInputsPermutationRequest.prototype.perm = $util.emptyArray;

    MoneroTransactionInputsPermutationRequest.create = function create(properties) {
        return new MoneroTransactionInputsPermutationRequest(properties);
    };

    MoneroTransactionInputsPermutationRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.perm != null && message.perm.length)
            for (var i = 0; i < message.perm.length; ++i)
                writer.uint32(8).uint32(message.perm[i]);
        return writer;
    };

    MoneroTransactionInputsPermutationRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroTransactionInputsPermutationRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroTransactionInputsPermutationRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.perm && message.perm.length))
                    message.perm = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.perm.push(reader.uint32());
                } else
                    message.perm.push(reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroTransactionInputsPermutationRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroTransactionInputsPermutationRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.perm != null && message.hasOwnProperty("perm")) {
            if (!Array.isArray(message.perm))
                return "perm: array expected";
            for (var i = 0; i < message.perm.length; ++i)
                if (!$util.isInteger(message.perm[i]))
                    return "perm: integer[] expected";
        }
        return null;
    };

    MoneroTransactionInputsPermutationRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroTransactionInputsPermutationRequest)
            return object;
        var message = new $root.MoneroTransactionInputsPermutationRequest();
        if (object.perm) {
            if (!Array.isArray(object.perm))
                throw TypeError(".MoneroTransactionInputsPermutationRequest.perm: array expected");
            message.perm = [];
            for (var i = 0; i < object.perm.length; ++i)
                message.perm[i] = object.perm[i] >>> 0;
        }
        return message;
    };

    MoneroTransactionInputsPermutationRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.perm = [];
        if (message.perm && message.perm.length) {
            object.perm = [];
            for (var j = 0; j < message.perm.length; ++j)
                object.perm[j] = message.perm[j];
        }
        return object;
    };

    MoneroTransactionInputsPermutationRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoneroTransactionInputsPermutationRequest;
})();

$root.MoneroTransactionInputsPermutationAck = (function() {

    function MoneroTransactionInputsPermutationAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroTransactionInputsPermutationAck.create = function create(properties) {
        return new MoneroTransactionInputsPermutationAck(properties);
    };

    MoneroTransactionInputsPermutationAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    MoneroTransactionInputsPermutationAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroTransactionInputsPermutationAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroTransactionInputsPermutationAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroTransactionInputsPermutationAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroTransactionInputsPermutationAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    MoneroTransactionInputsPermutationAck.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroTransactionInputsPermutationAck)
            return object;
        return new $root.MoneroTransactionInputsPermutationAck();
    };

    MoneroTransactionInputsPermutationAck.toObject = function toObject() {
        return {};
    };

    MoneroTransactionInputsPermutationAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoneroTransactionInputsPermutationAck;
})();

$root.MoneroTransactionInputViniRequest = (function() {

    function MoneroTransactionInputViniRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroTransactionInputViniRequest.prototype.src_entr = null;
    MoneroTransactionInputViniRequest.prototype.vini = $util.newBuffer([]);
    MoneroTransactionInputViniRequest.prototype.vini_hmac = $util.newBuffer([]);
    MoneroTransactionInputViniRequest.prototype.pseudo_out = $util.newBuffer([]);
    MoneroTransactionInputViniRequest.prototype.pseudo_out_hmac = $util.newBuffer([]);
    MoneroTransactionInputViniRequest.prototype.orig_idx = 0;

    MoneroTransactionInputViniRequest.create = function create(properties) {
        return new MoneroTransactionInputViniRequest(properties);
    };

    MoneroTransactionInputViniRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.src_entr != null && Object.hasOwnProperty.call(message, "src_entr"))
            $root.MoneroTransactionSourceEntry.encode(message.src_entr, writer.uint32(10).fork()).ldelim();
        if (message.vini != null && Object.hasOwnProperty.call(message, "vini"))
            writer.uint32(18).bytes(message.vini);
        if (message.vini_hmac != null && Object.hasOwnProperty.call(message, "vini_hmac"))
            writer.uint32(26).bytes(message.vini_hmac);
        if (message.pseudo_out != null && Object.hasOwnProperty.call(message, "pseudo_out"))
            writer.uint32(34).bytes(message.pseudo_out);
        if (message.pseudo_out_hmac != null && Object.hasOwnProperty.call(message, "pseudo_out_hmac"))
            writer.uint32(42).bytes(message.pseudo_out_hmac);
        if (message.orig_idx != null && Object.hasOwnProperty.call(message, "orig_idx"))
            writer.uint32(48).uint32(message.orig_idx);
        return writer;
    };

    MoneroTransactionInputViniRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroTransactionInputViniRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroTransactionInputViniRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.src_entr = $root.MoneroTransactionSourceEntry.decode(reader, reader.uint32());
                break;
            case 2:
                message.vini = reader.bytes();
                break;
            case 3:
                message.vini_hmac = reader.bytes();
                break;
            case 4:
                message.pseudo_out = reader.bytes();
                break;
            case 5:
                message.pseudo_out_hmac = reader.bytes();
                break;
            case 6:
                message.orig_idx = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroTransactionInputViniRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroTransactionInputViniRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.src_entr != null && message.hasOwnProperty("src_entr")) {
            var error = $root.MoneroTransactionSourceEntry.verify(message.src_entr);
            if (error)
                return "src_entr." + error;
        }
        if (message.vini != null && message.hasOwnProperty("vini"))
            if (!(message.vini && typeof message.vini.length === "number" || $util.isString(message.vini)))
                return "vini: buffer expected";
        if (message.vini_hmac != null && message.hasOwnProperty("vini_hmac"))
            if (!(message.vini_hmac && typeof message.vini_hmac.length === "number" || $util.isString(message.vini_hmac)))
                return "vini_hmac: buffer expected";
        if (message.pseudo_out != null && message.hasOwnProperty("pseudo_out"))
            if (!(message.pseudo_out && typeof message.pseudo_out.length === "number" || $util.isString(message.pseudo_out)))
                return "pseudo_out: buffer expected";
        if (message.pseudo_out_hmac != null && message.hasOwnProperty("pseudo_out_hmac"))
            if (!(message.pseudo_out_hmac && typeof message.pseudo_out_hmac.length === "number" || $util.isString(message.pseudo_out_hmac)))
                return "pseudo_out_hmac: buffer expected";
        if (message.orig_idx != null && message.hasOwnProperty("orig_idx"))
            if (!$util.isInteger(message.orig_idx))
                return "orig_idx: integer expected";
        return null;
    };

    MoneroTransactionInputViniRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroTransactionInputViniRequest)
            return object;
        var message = new $root.MoneroTransactionInputViniRequest();
        if (object.src_entr != null) {
            if (typeof object.src_entr !== "object")
                throw TypeError(".MoneroTransactionInputViniRequest.src_entr: object expected");
            message.src_entr = $root.MoneroTransactionSourceEntry.fromObject(object.src_entr);
        }
        if (object.vini != null)
            if (typeof object.vini === "string")
                $util.base64.decode(object.vini, message.vini = $util.newBuffer($util.base64.length(object.vini)), 0);
            else if (object.vini.length)
                message.vini = object.vini;
        if (object.vini_hmac != null)
            if (typeof object.vini_hmac === "string")
                $util.base64.decode(object.vini_hmac, message.vini_hmac = $util.newBuffer($util.base64.length(object.vini_hmac)), 0);
            else if (object.vini_hmac.length)
                message.vini_hmac = object.vini_hmac;
        if (object.pseudo_out != null)
            if (typeof object.pseudo_out === "string")
                $util.base64.decode(object.pseudo_out, message.pseudo_out = $util.newBuffer($util.base64.length(object.pseudo_out)), 0);
            else if (object.pseudo_out.length)
                message.pseudo_out = object.pseudo_out;
        if (object.pseudo_out_hmac != null)
            if (typeof object.pseudo_out_hmac === "string")
                $util.base64.decode(object.pseudo_out_hmac, message.pseudo_out_hmac = $util.newBuffer($util.base64.length(object.pseudo_out_hmac)), 0);
            else if (object.pseudo_out_hmac.length)
                message.pseudo_out_hmac = object.pseudo_out_hmac;
        if (object.orig_idx != null)
            message.orig_idx = object.orig_idx >>> 0;
        return message;
    };

    MoneroTransactionInputViniRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.src_entr = null;
            if (options.bytes === String)
                object.vini = "";
            else {
                object.vini = [];
                if (options.bytes !== Array)
                    object.vini = $util.newBuffer(object.vini);
            }
            if (options.bytes === String)
                object.vini_hmac = "";
            else {
                object.vini_hmac = [];
                if (options.bytes !== Array)
                    object.vini_hmac = $util.newBuffer(object.vini_hmac);
            }
            if (options.bytes === String)
                object.pseudo_out = "";
            else {
                object.pseudo_out = [];
                if (options.bytes !== Array)
                    object.pseudo_out = $util.newBuffer(object.pseudo_out);
            }
            if (options.bytes === String)
                object.pseudo_out_hmac = "";
            else {
                object.pseudo_out_hmac = [];
                if (options.bytes !== Array)
                    object.pseudo_out_hmac = $util.newBuffer(object.pseudo_out_hmac);
            }
            object.orig_idx = 0;
        }
        if (message.src_entr != null && message.hasOwnProperty("src_entr"))
            object.src_entr = $root.MoneroTransactionSourceEntry.toObject(message.src_entr, options);
        if (message.vini != null && message.hasOwnProperty("vini"))
            object.vini = options.bytes === String ? $util.base64.encode(message.vini, 0, message.vini.length) : options.bytes === Array ? Array.prototype.slice.call(message.vini) : message.vini;
        if (message.vini_hmac != null && message.hasOwnProperty("vini_hmac"))
            object.vini_hmac = options.bytes === String ? $util.base64.encode(message.vini_hmac, 0, message.vini_hmac.length) : options.bytes === Array ? Array.prototype.slice.call(message.vini_hmac) : message.vini_hmac;
        if (message.pseudo_out != null && message.hasOwnProperty("pseudo_out"))
            object.pseudo_out = options.bytes === String ? $util.base64.encode(message.pseudo_out, 0, message.pseudo_out.length) : options.bytes === Array ? Array.prototype.slice.call(message.pseudo_out) : message.pseudo_out;
        if (message.pseudo_out_hmac != null && message.hasOwnProperty("pseudo_out_hmac"))
            object.pseudo_out_hmac = options.bytes === String ? $util.base64.encode(message.pseudo_out_hmac, 0, message.pseudo_out_hmac.length) : options.bytes === Array ? Array.prototype.slice.call(message.pseudo_out_hmac) : message.pseudo_out_hmac;
        if (message.orig_idx != null && message.hasOwnProperty("orig_idx"))
            object.orig_idx = message.orig_idx;
        return object;
    };

    MoneroTransactionInputViniRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoneroTransactionInputViniRequest;
})();

$root.MoneroTransactionInputViniAck = (function() {

    function MoneroTransactionInputViniAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroTransactionInputViniAck.create = function create(properties) {
        return new MoneroTransactionInputViniAck(properties);
    };

    MoneroTransactionInputViniAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    MoneroTransactionInputViniAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroTransactionInputViniAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroTransactionInputViniAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroTransactionInputViniAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroTransactionInputViniAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    MoneroTransactionInputViniAck.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroTransactionInputViniAck)
            return object;
        return new $root.MoneroTransactionInputViniAck();
    };

    MoneroTransactionInputViniAck.toObject = function toObject() {
        return {};
    };

    MoneroTransactionInputViniAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoneroTransactionInputViniAck;
})();

$root.MoneroTransactionAllInputsSetRequest = (function() {

    function MoneroTransactionAllInputsSetRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroTransactionAllInputsSetRequest.create = function create(properties) {
        return new MoneroTransactionAllInputsSetRequest(properties);
    };

    MoneroTransactionAllInputsSetRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    MoneroTransactionAllInputsSetRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroTransactionAllInputsSetRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroTransactionAllInputsSetRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroTransactionAllInputsSetRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroTransactionAllInputsSetRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    MoneroTransactionAllInputsSetRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroTransactionAllInputsSetRequest)
            return object;
        return new $root.MoneroTransactionAllInputsSetRequest();
    };

    MoneroTransactionAllInputsSetRequest.toObject = function toObject() {
        return {};
    };

    MoneroTransactionAllInputsSetRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoneroTransactionAllInputsSetRequest;
})();

$root.MoneroTransactionAllInputsSetAck = (function() {

    function MoneroTransactionAllInputsSetAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroTransactionAllInputsSetAck.prototype.rsig_data = null;

    MoneroTransactionAllInputsSetAck.create = function create(properties) {
        return new MoneroTransactionAllInputsSetAck(properties);
    };

    MoneroTransactionAllInputsSetAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.rsig_data != null && Object.hasOwnProperty.call(message, "rsig_data"))
            $root.MoneroTransactionRsigData.encode(message.rsig_data, writer.uint32(10).fork()).ldelim();
        return writer;
    };

    MoneroTransactionAllInputsSetAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroTransactionAllInputsSetAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroTransactionAllInputsSetAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.rsig_data = $root.MoneroTransactionRsigData.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroTransactionAllInputsSetAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroTransactionAllInputsSetAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.rsig_data != null && message.hasOwnProperty("rsig_data")) {
            var error = $root.MoneroTransactionRsigData.verify(message.rsig_data);
            if (error)
                return "rsig_data." + error;
        }
        return null;
    };

    MoneroTransactionAllInputsSetAck.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroTransactionAllInputsSetAck)
            return object;
        var message = new $root.MoneroTransactionAllInputsSetAck();
        if (object.rsig_data != null) {
            if (typeof object.rsig_data !== "object")
                throw TypeError(".MoneroTransactionAllInputsSetAck.rsig_data: object expected");
            message.rsig_data = $root.MoneroTransactionRsigData.fromObject(object.rsig_data);
        }
        return message;
    };

    MoneroTransactionAllInputsSetAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.rsig_data = null;
        if (message.rsig_data != null && message.hasOwnProperty("rsig_data"))
            object.rsig_data = $root.MoneroTransactionRsigData.toObject(message.rsig_data, options);
        return object;
    };

    MoneroTransactionAllInputsSetAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoneroTransactionAllInputsSetAck;
})();

$root.MoneroTransactionSetOutputRequest = (function() {

    function MoneroTransactionSetOutputRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroTransactionSetOutputRequest.prototype.dst_entr = null;
    MoneroTransactionSetOutputRequest.prototype.dst_entr_hmac = $util.newBuffer([]);
    MoneroTransactionSetOutputRequest.prototype.rsig_data = null;
    MoneroTransactionSetOutputRequest.prototype.is_offloaded_bp = false;

    MoneroTransactionSetOutputRequest.create = function create(properties) {
        return new MoneroTransactionSetOutputRequest(properties);
    };

    MoneroTransactionSetOutputRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.dst_entr != null && Object.hasOwnProperty.call(message, "dst_entr"))
            $root.MoneroTransactionDestinationEntry.encode(message.dst_entr, writer.uint32(10).fork()).ldelim();
        if (message.dst_entr_hmac != null && Object.hasOwnProperty.call(message, "dst_entr_hmac"))
            writer.uint32(18).bytes(message.dst_entr_hmac);
        if (message.rsig_data != null && Object.hasOwnProperty.call(message, "rsig_data"))
            $root.MoneroTransactionRsigData.encode(message.rsig_data, writer.uint32(26).fork()).ldelim();
        if (message.is_offloaded_bp != null && Object.hasOwnProperty.call(message, "is_offloaded_bp"))
            writer.uint32(32).bool(message.is_offloaded_bp);
        return writer;
    };

    MoneroTransactionSetOutputRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroTransactionSetOutputRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroTransactionSetOutputRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.dst_entr = $root.MoneroTransactionDestinationEntry.decode(reader, reader.uint32());
                break;
            case 2:
                message.dst_entr_hmac = reader.bytes();
                break;
            case 3:
                message.rsig_data = $root.MoneroTransactionRsigData.decode(reader, reader.uint32());
                break;
            case 4:
                message.is_offloaded_bp = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroTransactionSetOutputRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroTransactionSetOutputRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.dst_entr != null && message.hasOwnProperty("dst_entr")) {
            var error = $root.MoneroTransactionDestinationEntry.verify(message.dst_entr);
            if (error)
                return "dst_entr." + error;
        }
        if (message.dst_entr_hmac != null && message.hasOwnProperty("dst_entr_hmac"))
            if (!(message.dst_entr_hmac && typeof message.dst_entr_hmac.length === "number" || $util.isString(message.dst_entr_hmac)))
                return "dst_entr_hmac: buffer expected";
        if (message.rsig_data != null && message.hasOwnProperty("rsig_data")) {
            var error = $root.MoneroTransactionRsigData.verify(message.rsig_data);
            if (error)
                return "rsig_data." + error;
        }
        if (message.is_offloaded_bp != null && message.hasOwnProperty("is_offloaded_bp"))
            if (typeof message.is_offloaded_bp !== "boolean")
                return "is_offloaded_bp: boolean expected";
        return null;
    };

    MoneroTransactionSetOutputRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroTransactionSetOutputRequest)
            return object;
        var message = new $root.MoneroTransactionSetOutputRequest();
        if (object.dst_entr != null) {
            if (typeof object.dst_entr !== "object")
                throw TypeError(".MoneroTransactionSetOutputRequest.dst_entr: object expected");
            message.dst_entr = $root.MoneroTransactionDestinationEntry.fromObject(object.dst_entr);
        }
        if (object.dst_entr_hmac != null)
            if (typeof object.dst_entr_hmac === "string")
                $util.base64.decode(object.dst_entr_hmac, message.dst_entr_hmac = $util.newBuffer($util.base64.length(object.dst_entr_hmac)), 0);
            else if (object.dst_entr_hmac.length)
                message.dst_entr_hmac = object.dst_entr_hmac;
        if (object.rsig_data != null) {
            if (typeof object.rsig_data !== "object")
                throw TypeError(".MoneroTransactionSetOutputRequest.rsig_data: object expected");
            message.rsig_data = $root.MoneroTransactionRsigData.fromObject(object.rsig_data);
        }
        if (object.is_offloaded_bp != null)
            message.is_offloaded_bp = Boolean(object.is_offloaded_bp);
        return message;
    };

    MoneroTransactionSetOutputRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.dst_entr = null;
            if (options.bytes === String)
                object.dst_entr_hmac = "";
            else {
                object.dst_entr_hmac = [];
                if (options.bytes !== Array)
                    object.dst_entr_hmac = $util.newBuffer(object.dst_entr_hmac);
            }
            object.rsig_data = null;
            object.is_offloaded_bp = false;
        }
        if (message.dst_entr != null && message.hasOwnProperty("dst_entr"))
            object.dst_entr = $root.MoneroTransactionDestinationEntry.toObject(message.dst_entr, options);
        if (message.dst_entr_hmac != null && message.hasOwnProperty("dst_entr_hmac"))
            object.dst_entr_hmac = options.bytes === String ? $util.base64.encode(message.dst_entr_hmac, 0, message.dst_entr_hmac.length) : options.bytes === Array ? Array.prototype.slice.call(message.dst_entr_hmac) : message.dst_entr_hmac;
        if (message.rsig_data != null && message.hasOwnProperty("rsig_data"))
            object.rsig_data = $root.MoneroTransactionRsigData.toObject(message.rsig_data, options);
        if (message.is_offloaded_bp != null && message.hasOwnProperty("is_offloaded_bp"))
            object.is_offloaded_bp = message.is_offloaded_bp;
        return object;
    };

    MoneroTransactionSetOutputRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoneroTransactionSetOutputRequest;
})();

$root.MoneroTransactionSetOutputAck = (function() {

    function MoneroTransactionSetOutputAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroTransactionSetOutputAck.prototype.tx_out = $util.newBuffer([]);
    MoneroTransactionSetOutputAck.prototype.vouti_hmac = $util.newBuffer([]);
    MoneroTransactionSetOutputAck.prototype.rsig_data = null;
    MoneroTransactionSetOutputAck.prototype.out_pk = $util.newBuffer([]);
    MoneroTransactionSetOutputAck.prototype.ecdh_info = $util.newBuffer([]);

    MoneroTransactionSetOutputAck.create = function create(properties) {
        return new MoneroTransactionSetOutputAck(properties);
    };

    MoneroTransactionSetOutputAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.tx_out != null && Object.hasOwnProperty.call(message, "tx_out"))
            writer.uint32(10).bytes(message.tx_out);
        if (message.vouti_hmac != null && Object.hasOwnProperty.call(message, "vouti_hmac"))
            writer.uint32(18).bytes(message.vouti_hmac);
        if (message.rsig_data != null && Object.hasOwnProperty.call(message, "rsig_data"))
            $root.MoneroTransactionRsigData.encode(message.rsig_data, writer.uint32(26).fork()).ldelim();
        if (message.out_pk != null && Object.hasOwnProperty.call(message, "out_pk"))
            writer.uint32(34).bytes(message.out_pk);
        if (message.ecdh_info != null && Object.hasOwnProperty.call(message, "ecdh_info"))
            writer.uint32(42).bytes(message.ecdh_info);
        return writer;
    };

    MoneroTransactionSetOutputAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroTransactionSetOutputAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroTransactionSetOutputAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.tx_out = reader.bytes();
                break;
            case 2:
                message.vouti_hmac = reader.bytes();
                break;
            case 3:
                message.rsig_data = $root.MoneroTransactionRsigData.decode(reader, reader.uint32());
                break;
            case 4:
                message.out_pk = reader.bytes();
                break;
            case 5:
                message.ecdh_info = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroTransactionSetOutputAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroTransactionSetOutputAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.tx_out != null && message.hasOwnProperty("tx_out"))
            if (!(message.tx_out && typeof message.tx_out.length === "number" || $util.isString(message.tx_out)))
                return "tx_out: buffer expected";
        if (message.vouti_hmac != null && message.hasOwnProperty("vouti_hmac"))
            if (!(message.vouti_hmac && typeof message.vouti_hmac.length === "number" || $util.isString(message.vouti_hmac)))
                return "vouti_hmac: buffer expected";
        if (message.rsig_data != null && message.hasOwnProperty("rsig_data")) {
            var error = $root.MoneroTransactionRsigData.verify(message.rsig_data);
            if (error)
                return "rsig_data." + error;
        }
        if (message.out_pk != null && message.hasOwnProperty("out_pk"))
            if (!(message.out_pk && typeof message.out_pk.length === "number" || $util.isString(message.out_pk)))
                return "out_pk: buffer expected";
        if (message.ecdh_info != null && message.hasOwnProperty("ecdh_info"))
            if (!(message.ecdh_info && typeof message.ecdh_info.length === "number" || $util.isString(message.ecdh_info)))
                return "ecdh_info: buffer expected";
        return null;
    };

    MoneroTransactionSetOutputAck.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroTransactionSetOutputAck)
            return object;
        var message = new $root.MoneroTransactionSetOutputAck();
        if (object.tx_out != null)
            if (typeof object.tx_out === "string")
                $util.base64.decode(object.tx_out, message.tx_out = $util.newBuffer($util.base64.length(object.tx_out)), 0);
            else if (object.tx_out.length)
                message.tx_out = object.tx_out;
        if (object.vouti_hmac != null)
            if (typeof object.vouti_hmac === "string")
                $util.base64.decode(object.vouti_hmac, message.vouti_hmac = $util.newBuffer($util.base64.length(object.vouti_hmac)), 0);
            else if (object.vouti_hmac.length)
                message.vouti_hmac = object.vouti_hmac;
        if (object.rsig_data != null) {
            if (typeof object.rsig_data !== "object")
                throw TypeError(".MoneroTransactionSetOutputAck.rsig_data: object expected");
            message.rsig_data = $root.MoneroTransactionRsigData.fromObject(object.rsig_data);
        }
        if (object.out_pk != null)
            if (typeof object.out_pk === "string")
                $util.base64.decode(object.out_pk, message.out_pk = $util.newBuffer($util.base64.length(object.out_pk)), 0);
            else if (object.out_pk.length)
                message.out_pk = object.out_pk;
        if (object.ecdh_info != null)
            if (typeof object.ecdh_info === "string")
                $util.base64.decode(object.ecdh_info, message.ecdh_info = $util.newBuffer($util.base64.length(object.ecdh_info)), 0);
            else if (object.ecdh_info.length)
                message.ecdh_info = object.ecdh_info;
        return message;
    };

    MoneroTransactionSetOutputAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.tx_out = "";
            else {
                object.tx_out = [];
                if (options.bytes !== Array)
                    object.tx_out = $util.newBuffer(object.tx_out);
            }
            if (options.bytes === String)
                object.vouti_hmac = "";
            else {
                object.vouti_hmac = [];
                if (options.bytes !== Array)
                    object.vouti_hmac = $util.newBuffer(object.vouti_hmac);
            }
            object.rsig_data = null;
            if (options.bytes === String)
                object.out_pk = "";
            else {
                object.out_pk = [];
                if (options.bytes !== Array)
                    object.out_pk = $util.newBuffer(object.out_pk);
            }
            if (options.bytes === String)
                object.ecdh_info = "";
            else {
                object.ecdh_info = [];
                if (options.bytes !== Array)
                    object.ecdh_info = $util.newBuffer(object.ecdh_info);
            }
        }
        if (message.tx_out != null && message.hasOwnProperty("tx_out"))
            object.tx_out = options.bytes === String ? $util.base64.encode(message.tx_out, 0, message.tx_out.length) : options.bytes === Array ? Array.prototype.slice.call(message.tx_out) : message.tx_out;
        if (message.vouti_hmac != null && message.hasOwnProperty("vouti_hmac"))
            object.vouti_hmac = options.bytes === String ? $util.base64.encode(message.vouti_hmac, 0, message.vouti_hmac.length) : options.bytes === Array ? Array.prototype.slice.call(message.vouti_hmac) : message.vouti_hmac;
        if (message.rsig_data != null && message.hasOwnProperty("rsig_data"))
            object.rsig_data = $root.MoneroTransactionRsigData.toObject(message.rsig_data, options);
        if (message.out_pk != null && message.hasOwnProperty("out_pk"))
            object.out_pk = options.bytes === String ? $util.base64.encode(message.out_pk, 0, message.out_pk.length) : options.bytes === Array ? Array.prototype.slice.call(message.out_pk) : message.out_pk;
        if (message.ecdh_info != null && message.hasOwnProperty("ecdh_info"))
            object.ecdh_info = options.bytes === String ? $util.base64.encode(message.ecdh_info, 0, message.ecdh_info.length) : options.bytes === Array ? Array.prototype.slice.call(message.ecdh_info) : message.ecdh_info;
        return object;
    };

    MoneroTransactionSetOutputAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoneroTransactionSetOutputAck;
})();

$root.MoneroTransactionAllOutSetRequest = (function() {

    function MoneroTransactionAllOutSetRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroTransactionAllOutSetRequest.prototype.rsig_data = null;

    MoneroTransactionAllOutSetRequest.create = function create(properties) {
        return new MoneroTransactionAllOutSetRequest(properties);
    };

    MoneroTransactionAllOutSetRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.rsig_data != null && Object.hasOwnProperty.call(message, "rsig_data"))
            $root.MoneroTransactionRsigData.encode(message.rsig_data, writer.uint32(10).fork()).ldelim();
        return writer;
    };

    MoneroTransactionAllOutSetRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroTransactionAllOutSetRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroTransactionAllOutSetRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.rsig_data = $root.MoneroTransactionRsigData.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroTransactionAllOutSetRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroTransactionAllOutSetRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.rsig_data != null && message.hasOwnProperty("rsig_data")) {
            var error = $root.MoneroTransactionRsigData.verify(message.rsig_data);
            if (error)
                return "rsig_data." + error;
        }
        return null;
    };

    MoneroTransactionAllOutSetRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroTransactionAllOutSetRequest)
            return object;
        var message = new $root.MoneroTransactionAllOutSetRequest();
        if (object.rsig_data != null) {
            if (typeof object.rsig_data !== "object")
                throw TypeError(".MoneroTransactionAllOutSetRequest.rsig_data: object expected");
            message.rsig_data = $root.MoneroTransactionRsigData.fromObject(object.rsig_data);
        }
        return message;
    };

    MoneroTransactionAllOutSetRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.rsig_data = null;
        if (message.rsig_data != null && message.hasOwnProperty("rsig_data"))
            object.rsig_data = $root.MoneroTransactionRsigData.toObject(message.rsig_data, options);
        return object;
    };

    MoneroTransactionAllOutSetRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoneroTransactionAllOutSetRequest;
})();

$root.MoneroTransactionAllOutSetAck = (function() {

    function MoneroTransactionAllOutSetAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroTransactionAllOutSetAck.prototype.extra = $util.newBuffer([]);
    MoneroTransactionAllOutSetAck.prototype.tx_prefix_hash = $util.newBuffer([]);
    MoneroTransactionAllOutSetAck.prototype.rv = null;
    MoneroTransactionAllOutSetAck.prototype.full_message_hash = $util.newBuffer([]);

    MoneroTransactionAllOutSetAck.create = function create(properties) {
        return new MoneroTransactionAllOutSetAck(properties);
    };

    MoneroTransactionAllOutSetAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.extra != null && Object.hasOwnProperty.call(message, "extra"))
            writer.uint32(10).bytes(message.extra);
        if (message.tx_prefix_hash != null && Object.hasOwnProperty.call(message, "tx_prefix_hash"))
            writer.uint32(18).bytes(message.tx_prefix_hash);
        if (message.rv != null && Object.hasOwnProperty.call(message, "rv"))
            $root.MoneroTransactionAllOutSetAck.MoneroRingCtSig.encode(message.rv, writer.uint32(34).fork()).ldelim();
        if (message.full_message_hash != null && Object.hasOwnProperty.call(message, "full_message_hash"))
            writer.uint32(42).bytes(message.full_message_hash);
        return writer;
    };

    MoneroTransactionAllOutSetAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroTransactionAllOutSetAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroTransactionAllOutSetAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.extra = reader.bytes();
                break;
            case 2:
                message.tx_prefix_hash = reader.bytes();
                break;
            case 4:
                message.rv = $root.MoneroTransactionAllOutSetAck.MoneroRingCtSig.decode(reader, reader.uint32());
                break;
            case 5:
                message.full_message_hash = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroTransactionAllOutSetAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroTransactionAllOutSetAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.extra != null && message.hasOwnProperty("extra"))
            if (!(message.extra && typeof message.extra.length === "number" || $util.isString(message.extra)))
                return "extra: buffer expected";
        if (message.tx_prefix_hash != null && message.hasOwnProperty("tx_prefix_hash"))
            if (!(message.tx_prefix_hash && typeof message.tx_prefix_hash.length === "number" || $util.isString(message.tx_prefix_hash)))
                return "tx_prefix_hash: buffer expected";
        if (message.rv != null && message.hasOwnProperty("rv")) {
            var error = $root.MoneroTransactionAllOutSetAck.MoneroRingCtSig.verify(message.rv);
            if (error)
                return "rv." + error;
        }
        if (message.full_message_hash != null && message.hasOwnProperty("full_message_hash"))
            if (!(message.full_message_hash && typeof message.full_message_hash.length === "number" || $util.isString(message.full_message_hash)))
                return "full_message_hash: buffer expected";
        return null;
    };

    MoneroTransactionAllOutSetAck.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroTransactionAllOutSetAck)
            return object;
        var message = new $root.MoneroTransactionAllOutSetAck();
        if (object.extra != null)
            if (typeof object.extra === "string")
                $util.base64.decode(object.extra, message.extra = $util.newBuffer($util.base64.length(object.extra)), 0);
            else if (object.extra.length)
                message.extra = object.extra;
        if (object.tx_prefix_hash != null)
            if (typeof object.tx_prefix_hash === "string")
                $util.base64.decode(object.tx_prefix_hash, message.tx_prefix_hash = $util.newBuffer($util.base64.length(object.tx_prefix_hash)), 0);
            else if (object.tx_prefix_hash.length)
                message.tx_prefix_hash = object.tx_prefix_hash;
        if (object.rv != null) {
            if (typeof object.rv !== "object")
                throw TypeError(".MoneroTransactionAllOutSetAck.rv: object expected");
            message.rv = $root.MoneroTransactionAllOutSetAck.MoneroRingCtSig.fromObject(object.rv);
        }
        if (object.full_message_hash != null)
            if (typeof object.full_message_hash === "string")
                $util.base64.decode(object.full_message_hash, message.full_message_hash = $util.newBuffer($util.base64.length(object.full_message_hash)), 0);
            else if (object.full_message_hash.length)
                message.full_message_hash = object.full_message_hash;
        return message;
    };

    MoneroTransactionAllOutSetAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.extra = "";
            else {
                object.extra = [];
                if (options.bytes !== Array)
                    object.extra = $util.newBuffer(object.extra);
            }
            if (options.bytes === String)
                object.tx_prefix_hash = "";
            else {
                object.tx_prefix_hash = [];
                if (options.bytes !== Array)
                    object.tx_prefix_hash = $util.newBuffer(object.tx_prefix_hash);
            }
            object.rv = null;
            if (options.bytes === String)
                object.full_message_hash = "";
            else {
                object.full_message_hash = [];
                if (options.bytes !== Array)
                    object.full_message_hash = $util.newBuffer(object.full_message_hash);
            }
        }
        if (message.extra != null && message.hasOwnProperty("extra"))
            object.extra = options.bytes === String ? $util.base64.encode(message.extra, 0, message.extra.length) : options.bytes === Array ? Array.prototype.slice.call(message.extra) : message.extra;
        if (message.tx_prefix_hash != null && message.hasOwnProperty("tx_prefix_hash"))
            object.tx_prefix_hash = options.bytes === String ? $util.base64.encode(message.tx_prefix_hash, 0, message.tx_prefix_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.tx_prefix_hash) : message.tx_prefix_hash;
        if (message.rv != null && message.hasOwnProperty("rv"))
            object.rv = $root.MoneroTransactionAllOutSetAck.MoneroRingCtSig.toObject(message.rv, options);
        if (message.full_message_hash != null && message.hasOwnProperty("full_message_hash"))
            object.full_message_hash = options.bytes === String ? $util.base64.encode(message.full_message_hash, 0, message.full_message_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.full_message_hash) : message.full_message_hash;
        return object;
    };

    MoneroTransactionAllOutSetAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    MoneroTransactionAllOutSetAck.MoneroRingCtSig = (function() {

        function MoneroRingCtSig(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        MoneroRingCtSig.prototype.txn_fee = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        MoneroRingCtSig.prototype.message = $util.newBuffer([]);
        MoneroRingCtSig.prototype.rv_type = 0;

        MoneroRingCtSig.create = function create(properties) {
            return new MoneroRingCtSig(properties);
        };

        MoneroRingCtSig.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.txn_fee != null && Object.hasOwnProperty.call(message, "txn_fee"))
                writer.uint32(8).uint64(message.txn_fee);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(18).bytes(message.message);
            if (message.rv_type != null && Object.hasOwnProperty.call(message, "rv_type"))
                writer.uint32(24).uint32(message.rv_type);
            return writer;
        };

        MoneroRingCtSig.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        MoneroRingCtSig.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroTransactionAllOutSetAck.MoneroRingCtSig();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.txn_fee = reader.uint64();
                    break;
                case 2:
                    message.message = reader.bytes();
                    break;
                case 3:
                    message.rv_type = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        MoneroRingCtSig.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        MoneroRingCtSig.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.txn_fee != null && message.hasOwnProperty("txn_fee"))
                if (!$util.isInteger(message.txn_fee) && !(message.txn_fee && $util.isInteger(message.txn_fee.low) && $util.isInteger(message.txn_fee.high)))
                    return "txn_fee: integer|Long expected";
            if (message.message != null && message.hasOwnProperty("message"))
                if (!(message.message && typeof message.message.length === "number" || $util.isString(message.message)))
                    return "message: buffer expected";
            if (message.rv_type != null && message.hasOwnProperty("rv_type"))
                if (!$util.isInteger(message.rv_type))
                    return "rv_type: integer expected";
            return null;
        };

        MoneroRingCtSig.fromObject = function fromObject(object) {
            if (object instanceof $root.MoneroTransactionAllOutSetAck.MoneroRingCtSig)
                return object;
            var message = new $root.MoneroTransactionAllOutSetAck.MoneroRingCtSig();
            if (object.txn_fee != null)
                if ($util.Long)
                    (message.txn_fee = $util.Long.fromValue(object.txn_fee)).unsigned = true;
                else if (typeof object.txn_fee === "string")
                    message.txn_fee = parseInt(object.txn_fee, 10);
                else if (typeof object.txn_fee === "number")
                    message.txn_fee = object.txn_fee;
                else if (typeof object.txn_fee === "object")
                    message.txn_fee = new $util.LongBits(object.txn_fee.low >>> 0, object.txn_fee.high >>> 0).toNumber(true);
            if (object.message != null)
                if (typeof object.message === "string")
                    $util.base64.decode(object.message, message.message = $util.newBuffer($util.base64.length(object.message)), 0);
                else if (object.message.length)
                    message.message = object.message;
            if (object.rv_type != null)
                message.rv_type = object.rv_type >>> 0;
            return message;
        };

        MoneroRingCtSig.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.txn_fee = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.txn_fee = options.longs === String ? "0" : 0;
                if (options.bytes === String)
                    object.message = "";
                else {
                    object.message = [];
                    if (options.bytes !== Array)
                        object.message = $util.newBuffer(object.message);
                }
                object.rv_type = 0;
            }
            if (message.txn_fee != null && message.hasOwnProperty("txn_fee"))
                if (typeof message.txn_fee === "number")
                    object.txn_fee = options.longs === String ? String(message.txn_fee) : message.txn_fee;
                else
                    object.txn_fee = options.longs === String ? $util.Long.prototype.toString.call(message.txn_fee) : options.longs === Number ? new $util.LongBits(message.txn_fee.low >>> 0, message.txn_fee.high >>> 0).toNumber(true) : message.txn_fee;
            if (message.message != null && message.hasOwnProperty("message"))
                object.message = options.bytes === String ? $util.base64.encode(message.message, 0, message.message.length) : options.bytes === Array ? Array.prototype.slice.call(message.message) : message.message;
            if (message.rv_type != null && message.hasOwnProperty("rv_type"))
                object.rv_type = message.rv_type;
            return object;
        };

        MoneroRingCtSig.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return MoneroRingCtSig;
    })();

    return MoneroTransactionAllOutSetAck;
})();

$root.MoneroTransactionSignInputRequest = (function() {

    function MoneroTransactionSignInputRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroTransactionSignInputRequest.prototype.src_entr = null;
    MoneroTransactionSignInputRequest.prototype.vini = $util.newBuffer([]);
    MoneroTransactionSignInputRequest.prototype.vini_hmac = $util.newBuffer([]);
    MoneroTransactionSignInputRequest.prototype.pseudo_out = $util.newBuffer([]);
    MoneroTransactionSignInputRequest.prototype.pseudo_out_hmac = $util.newBuffer([]);
    MoneroTransactionSignInputRequest.prototype.pseudo_out_alpha = $util.newBuffer([]);
    MoneroTransactionSignInputRequest.prototype.spend_key = $util.newBuffer([]);
    MoneroTransactionSignInputRequest.prototype.orig_idx = 0;

    MoneroTransactionSignInputRequest.create = function create(properties) {
        return new MoneroTransactionSignInputRequest(properties);
    };

    MoneroTransactionSignInputRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.src_entr != null && Object.hasOwnProperty.call(message, "src_entr"))
            $root.MoneroTransactionSourceEntry.encode(message.src_entr, writer.uint32(10).fork()).ldelim();
        if (message.vini != null && Object.hasOwnProperty.call(message, "vini"))
            writer.uint32(18).bytes(message.vini);
        if (message.vini_hmac != null && Object.hasOwnProperty.call(message, "vini_hmac"))
            writer.uint32(26).bytes(message.vini_hmac);
        if (message.pseudo_out != null && Object.hasOwnProperty.call(message, "pseudo_out"))
            writer.uint32(34).bytes(message.pseudo_out);
        if (message.pseudo_out_hmac != null && Object.hasOwnProperty.call(message, "pseudo_out_hmac"))
            writer.uint32(42).bytes(message.pseudo_out_hmac);
        if (message.pseudo_out_alpha != null && Object.hasOwnProperty.call(message, "pseudo_out_alpha"))
            writer.uint32(50).bytes(message.pseudo_out_alpha);
        if (message.spend_key != null && Object.hasOwnProperty.call(message, "spend_key"))
            writer.uint32(58).bytes(message.spend_key);
        if (message.orig_idx != null && Object.hasOwnProperty.call(message, "orig_idx"))
            writer.uint32(64).uint32(message.orig_idx);
        return writer;
    };

    MoneroTransactionSignInputRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroTransactionSignInputRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroTransactionSignInputRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.src_entr = $root.MoneroTransactionSourceEntry.decode(reader, reader.uint32());
                break;
            case 2:
                message.vini = reader.bytes();
                break;
            case 3:
                message.vini_hmac = reader.bytes();
                break;
            case 4:
                message.pseudo_out = reader.bytes();
                break;
            case 5:
                message.pseudo_out_hmac = reader.bytes();
                break;
            case 6:
                message.pseudo_out_alpha = reader.bytes();
                break;
            case 7:
                message.spend_key = reader.bytes();
                break;
            case 8:
                message.orig_idx = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroTransactionSignInputRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroTransactionSignInputRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.src_entr != null && message.hasOwnProperty("src_entr")) {
            var error = $root.MoneroTransactionSourceEntry.verify(message.src_entr);
            if (error)
                return "src_entr." + error;
        }
        if (message.vini != null && message.hasOwnProperty("vini"))
            if (!(message.vini && typeof message.vini.length === "number" || $util.isString(message.vini)))
                return "vini: buffer expected";
        if (message.vini_hmac != null && message.hasOwnProperty("vini_hmac"))
            if (!(message.vini_hmac && typeof message.vini_hmac.length === "number" || $util.isString(message.vini_hmac)))
                return "vini_hmac: buffer expected";
        if (message.pseudo_out != null && message.hasOwnProperty("pseudo_out"))
            if (!(message.pseudo_out && typeof message.pseudo_out.length === "number" || $util.isString(message.pseudo_out)))
                return "pseudo_out: buffer expected";
        if (message.pseudo_out_hmac != null && message.hasOwnProperty("pseudo_out_hmac"))
            if (!(message.pseudo_out_hmac && typeof message.pseudo_out_hmac.length === "number" || $util.isString(message.pseudo_out_hmac)))
                return "pseudo_out_hmac: buffer expected";
        if (message.pseudo_out_alpha != null && message.hasOwnProperty("pseudo_out_alpha"))
            if (!(message.pseudo_out_alpha && typeof message.pseudo_out_alpha.length === "number" || $util.isString(message.pseudo_out_alpha)))
                return "pseudo_out_alpha: buffer expected";
        if (message.spend_key != null && message.hasOwnProperty("spend_key"))
            if (!(message.spend_key && typeof message.spend_key.length === "number" || $util.isString(message.spend_key)))
                return "spend_key: buffer expected";
        if (message.orig_idx != null && message.hasOwnProperty("orig_idx"))
            if (!$util.isInteger(message.orig_idx))
                return "orig_idx: integer expected";
        return null;
    };

    MoneroTransactionSignInputRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroTransactionSignInputRequest)
            return object;
        var message = new $root.MoneroTransactionSignInputRequest();
        if (object.src_entr != null) {
            if (typeof object.src_entr !== "object")
                throw TypeError(".MoneroTransactionSignInputRequest.src_entr: object expected");
            message.src_entr = $root.MoneroTransactionSourceEntry.fromObject(object.src_entr);
        }
        if (object.vini != null)
            if (typeof object.vini === "string")
                $util.base64.decode(object.vini, message.vini = $util.newBuffer($util.base64.length(object.vini)), 0);
            else if (object.vini.length)
                message.vini = object.vini;
        if (object.vini_hmac != null)
            if (typeof object.vini_hmac === "string")
                $util.base64.decode(object.vini_hmac, message.vini_hmac = $util.newBuffer($util.base64.length(object.vini_hmac)), 0);
            else if (object.vini_hmac.length)
                message.vini_hmac = object.vini_hmac;
        if (object.pseudo_out != null)
            if (typeof object.pseudo_out === "string")
                $util.base64.decode(object.pseudo_out, message.pseudo_out = $util.newBuffer($util.base64.length(object.pseudo_out)), 0);
            else if (object.pseudo_out.length)
                message.pseudo_out = object.pseudo_out;
        if (object.pseudo_out_hmac != null)
            if (typeof object.pseudo_out_hmac === "string")
                $util.base64.decode(object.pseudo_out_hmac, message.pseudo_out_hmac = $util.newBuffer($util.base64.length(object.pseudo_out_hmac)), 0);
            else if (object.pseudo_out_hmac.length)
                message.pseudo_out_hmac = object.pseudo_out_hmac;
        if (object.pseudo_out_alpha != null)
            if (typeof object.pseudo_out_alpha === "string")
                $util.base64.decode(object.pseudo_out_alpha, message.pseudo_out_alpha = $util.newBuffer($util.base64.length(object.pseudo_out_alpha)), 0);
            else if (object.pseudo_out_alpha.length)
                message.pseudo_out_alpha = object.pseudo_out_alpha;
        if (object.spend_key != null)
            if (typeof object.spend_key === "string")
                $util.base64.decode(object.spend_key, message.spend_key = $util.newBuffer($util.base64.length(object.spend_key)), 0);
            else if (object.spend_key.length)
                message.spend_key = object.spend_key;
        if (object.orig_idx != null)
            message.orig_idx = object.orig_idx >>> 0;
        return message;
    };

    MoneroTransactionSignInputRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.src_entr = null;
            if (options.bytes === String)
                object.vini = "";
            else {
                object.vini = [];
                if (options.bytes !== Array)
                    object.vini = $util.newBuffer(object.vini);
            }
            if (options.bytes === String)
                object.vini_hmac = "";
            else {
                object.vini_hmac = [];
                if (options.bytes !== Array)
                    object.vini_hmac = $util.newBuffer(object.vini_hmac);
            }
            if (options.bytes === String)
                object.pseudo_out = "";
            else {
                object.pseudo_out = [];
                if (options.bytes !== Array)
                    object.pseudo_out = $util.newBuffer(object.pseudo_out);
            }
            if (options.bytes === String)
                object.pseudo_out_hmac = "";
            else {
                object.pseudo_out_hmac = [];
                if (options.bytes !== Array)
                    object.pseudo_out_hmac = $util.newBuffer(object.pseudo_out_hmac);
            }
            if (options.bytes === String)
                object.pseudo_out_alpha = "";
            else {
                object.pseudo_out_alpha = [];
                if (options.bytes !== Array)
                    object.pseudo_out_alpha = $util.newBuffer(object.pseudo_out_alpha);
            }
            if (options.bytes === String)
                object.spend_key = "";
            else {
                object.spend_key = [];
                if (options.bytes !== Array)
                    object.spend_key = $util.newBuffer(object.spend_key);
            }
            object.orig_idx = 0;
        }
        if (message.src_entr != null && message.hasOwnProperty("src_entr"))
            object.src_entr = $root.MoneroTransactionSourceEntry.toObject(message.src_entr, options);
        if (message.vini != null && message.hasOwnProperty("vini"))
            object.vini = options.bytes === String ? $util.base64.encode(message.vini, 0, message.vini.length) : options.bytes === Array ? Array.prototype.slice.call(message.vini) : message.vini;
        if (message.vini_hmac != null && message.hasOwnProperty("vini_hmac"))
            object.vini_hmac = options.bytes === String ? $util.base64.encode(message.vini_hmac, 0, message.vini_hmac.length) : options.bytes === Array ? Array.prototype.slice.call(message.vini_hmac) : message.vini_hmac;
        if (message.pseudo_out != null && message.hasOwnProperty("pseudo_out"))
            object.pseudo_out = options.bytes === String ? $util.base64.encode(message.pseudo_out, 0, message.pseudo_out.length) : options.bytes === Array ? Array.prototype.slice.call(message.pseudo_out) : message.pseudo_out;
        if (message.pseudo_out_hmac != null && message.hasOwnProperty("pseudo_out_hmac"))
            object.pseudo_out_hmac = options.bytes === String ? $util.base64.encode(message.pseudo_out_hmac, 0, message.pseudo_out_hmac.length) : options.bytes === Array ? Array.prototype.slice.call(message.pseudo_out_hmac) : message.pseudo_out_hmac;
        if (message.pseudo_out_alpha != null && message.hasOwnProperty("pseudo_out_alpha"))
            object.pseudo_out_alpha = options.bytes === String ? $util.base64.encode(message.pseudo_out_alpha, 0, message.pseudo_out_alpha.length) : options.bytes === Array ? Array.prototype.slice.call(message.pseudo_out_alpha) : message.pseudo_out_alpha;
        if (message.spend_key != null && message.hasOwnProperty("spend_key"))
            object.spend_key = options.bytes === String ? $util.base64.encode(message.spend_key, 0, message.spend_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.spend_key) : message.spend_key;
        if (message.orig_idx != null && message.hasOwnProperty("orig_idx"))
            object.orig_idx = message.orig_idx;
        return object;
    };

    MoneroTransactionSignInputRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoneroTransactionSignInputRequest;
})();

$root.MoneroTransactionSignInputAck = (function() {

    function MoneroTransactionSignInputAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroTransactionSignInputAck.prototype.signature = $util.newBuffer([]);
    MoneroTransactionSignInputAck.prototype.pseudo_out = $util.newBuffer([]);

    MoneroTransactionSignInputAck.create = function create(properties) {
        return new MoneroTransactionSignInputAck(properties);
    };

    MoneroTransactionSignInputAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.signature != null && Object.hasOwnProperty.call(message, "signature"))
            writer.uint32(10).bytes(message.signature);
        if (message.pseudo_out != null && Object.hasOwnProperty.call(message, "pseudo_out"))
            writer.uint32(18).bytes(message.pseudo_out);
        return writer;
    };

    MoneroTransactionSignInputAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroTransactionSignInputAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroTransactionSignInputAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.signature = reader.bytes();
                break;
            case 2:
                message.pseudo_out = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroTransactionSignInputAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroTransactionSignInputAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.signature != null && message.hasOwnProperty("signature"))
            if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
                return "signature: buffer expected";
        if (message.pseudo_out != null && message.hasOwnProperty("pseudo_out"))
            if (!(message.pseudo_out && typeof message.pseudo_out.length === "number" || $util.isString(message.pseudo_out)))
                return "pseudo_out: buffer expected";
        return null;
    };

    MoneroTransactionSignInputAck.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroTransactionSignInputAck)
            return object;
        var message = new $root.MoneroTransactionSignInputAck();
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        if (object.pseudo_out != null)
            if (typeof object.pseudo_out === "string")
                $util.base64.decode(object.pseudo_out, message.pseudo_out = $util.newBuffer($util.base64.length(object.pseudo_out)), 0);
            else if (object.pseudo_out.length)
                message.pseudo_out = object.pseudo_out;
        return message;
    };

    MoneroTransactionSignInputAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
            if (options.bytes === String)
                object.pseudo_out = "";
            else {
                object.pseudo_out = [];
                if (options.bytes !== Array)
                    object.pseudo_out = $util.newBuffer(object.pseudo_out);
            }
        }
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        if (message.pseudo_out != null && message.hasOwnProperty("pseudo_out"))
            object.pseudo_out = options.bytes === String ? $util.base64.encode(message.pseudo_out, 0, message.pseudo_out.length) : options.bytes === Array ? Array.prototype.slice.call(message.pseudo_out) : message.pseudo_out;
        return object;
    };

    MoneroTransactionSignInputAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoneroTransactionSignInputAck;
})();

$root.MoneroTransactionFinalRequest = (function() {

    function MoneroTransactionFinalRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroTransactionFinalRequest.create = function create(properties) {
        return new MoneroTransactionFinalRequest(properties);
    };

    MoneroTransactionFinalRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    MoneroTransactionFinalRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroTransactionFinalRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroTransactionFinalRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroTransactionFinalRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroTransactionFinalRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    MoneroTransactionFinalRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroTransactionFinalRequest)
            return object;
        return new $root.MoneroTransactionFinalRequest();
    };

    MoneroTransactionFinalRequest.toObject = function toObject() {
        return {};
    };

    MoneroTransactionFinalRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoneroTransactionFinalRequest;
})();

$root.MoneroTransactionFinalAck = (function() {

    function MoneroTransactionFinalAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroTransactionFinalAck.prototype.cout_key = $util.newBuffer([]);
    MoneroTransactionFinalAck.prototype.salt = $util.newBuffer([]);
    MoneroTransactionFinalAck.prototype.rand_mult = $util.newBuffer([]);
    MoneroTransactionFinalAck.prototype.tx_enc_keys = $util.newBuffer([]);
    MoneroTransactionFinalAck.prototype.opening_key = $util.newBuffer([]);

    MoneroTransactionFinalAck.create = function create(properties) {
        return new MoneroTransactionFinalAck(properties);
    };

    MoneroTransactionFinalAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.cout_key != null && Object.hasOwnProperty.call(message, "cout_key"))
            writer.uint32(10).bytes(message.cout_key);
        if (message.salt != null && Object.hasOwnProperty.call(message, "salt"))
            writer.uint32(18).bytes(message.salt);
        if (message.rand_mult != null && Object.hasOwnProperty.call(message, "rand_mult"))
            writer.uint32(26).bytes(message.rand_mult);
        if (message.tx_enc_keys != null && Object.hasOwnProperty.call(message, "tx_enc_keys"))
            writer.uint32(34).bytes(message.tx_enc_keys);
        if (message.opening_key != null && Object.hasOwnProperty.call(message, "opening_key"))
            writer.uint32(42).bytes(message.opening_key);
        return writer;
    };

    MoneroTransactionFinalAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroTransactionFinalAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroTransactionFinalAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.cout_key = reader.bytes();
                break;
            case 2:
                message.salt = reader.bytes();
                break;
            case 3:
                message.rand_mult = reader.bytes();
                break;
            case 4:
                message.tx_enc_keys = reader.bytes();
                break;
            case 5:
                message.opening_key = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroTransactionFinalAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroTransactionFinalAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.cout_key != null && message.hasOwnProperty("cout_key"))
            if (!(message.cout_key && typeof message.cout_key.length === "number" || $util.isString(message.cout_key)))
                return "cout_key: buffer expected";
        if (message.salt != null && message.hasOwnProperty("salt"))
            if (!(message.salt && typeof message.salt.length === "number" || $util.isString(message.salt)))
                return "salt: buffer expected";
        if (message.rand_mult != null && message.hasOwnProperty("rand_mult"))
            if (!(message.rand_mult && typeof message.rand_mult.length === "number" || $util.isString(message.rand_mult)))
                return "rand_mult: buffer expected";
        if (message.tx_enc_keys != null && message.hasOwnProperty("tx_enc_keys"))
            if (!(message.tx_enc_keys && typeof message.tx_enc_keys.length === "number" || $util.isString(message.tx_enc_keys)))
                return "tx_enc_keys: buffer expected";
        if (message.opening_key != null && message.hasOwnProperty("opening_key"))
            if (!(message.opening_key && typeof message.opening_key.length === "number" || $util.isString(message.opening_key)))
                return "opening_key: buffer expected";
        return null;
    };

    MoneroTransactionFinalAck.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroTransactionFinalAck)
            return object;
        var message = new $root.MoneroTransactionFinalAck();
        if (object.cout_key != null)
            if (typeof object.cout_key === "string")
                $util.base64.decode(object.cout_key, message.cout_key = $util.newBuffer($util.base64.length(object.cout_key)), 0);
            else if (object.cout_key.length)
                message.cout_key = object.cout_key;
        if (object.salt != null)
            if (typeof object.salt === "string")
                $util.base64.decode(object.salt, message.salt = $util.newBuffer($util.base64.length(object.salt)), 0);
            else if (object.salt.length)
                message.salt = object.salt;
        if (object.rand_mult != null)
            if (typeof object.rand_mult === "string")
                $util.base64.decode(object.rand_mult, message.rand_mult = $util.newBuffer($util.base64.length(object.rand_mult)), 0);
            else if (object.rand_mult.length)
                message.rand_mult = object.rand_mult;
        if (object.tx_enc_keys != null)
            if (typeof object.tx_enc_keys === "string")
                $util.base64.decode(object.tx_enc_keys, message.tx_enc_keys = $util.newBuffer($util.base64.length(object.tx_enc_keys)), 0);
            else if (object.tx_enc_keys.length)
                message.tx_enc_keys = object.tx_enc_keys;
        if (object.opening_key != null)
            if (typeof object.opening_key === "string")
                $util.base64.decode(object.opening_key, message.opening_key = $util.newBuffer($util.base64.length(object.opening_key)), 0);
            else if (object.opening_key.length)
                message.opening_key = object.opening_key;
        return message;
    };

    MoneroTransactionFinalAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.cout_key = "";
            else {
                object.cout_key = [];
                if (options.bytes !== Array)
                    object.cout_key = $util.newBuffer(object.cout_key);
            }
            if (options.bytes === String)
                object.salt = "";
            else {
                object.salt = [];
                if (options.bytes !== Array)
                    object.salt = $util.newBuffer(object.salt);
            }
            if (options.bytes === String)
                object.rand_mult = "";
            else {
                object.rand_mult = [];
                if (options.bytes !== Array)
                    object.rand_mult = $util.newBuffer(object.rand_mult);
            }
            if (options.bytes === String)
                object.tx_enc_keys = "";
            else {
                object.tx_enc_keys = [];
                if (options.bytes !== Array)
                    object.tx_enc_keys = $util.newBuffer(object.tx_enc_keys);
            }
            if (options.bytes === String)
                object.opening_key = "";
            else {
                object.opening_key = [];
                if (options.bytes !== Array)
                    object.opening_key = $util.newBuffer(object.opening_key);
            }
        }
        if (message.cout_key != null && message.hasOwnProperty("cout_key"))
            object.cout_key = options.bytes === String ? $util.base64.encode(message.cout_key, 0, message.cout_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.cout_key) : message.cout_key;
        if (message.salt != null && message.hasOwnProperty("salt"))
            object.salt = options.bytes === String ? $util.base64.encode(message.salt, 0, message.salt.length) : options.bytes === Array ? Array.prototype.slice.call(message.salt) : message.salt;
        if (message.rand_mult != null && message.hasOwnProperty("rand_mult"))
            object.rand_mult = options.bytes === String ? $util.base64.encode(message.rand_mult, 0, message.rand_mult.length) : options.bytes === Array ? Array.prototype.slice.call(message.rand_mult) : message.rand_mult;
        if (message.tx_enc_keys != null && message.hasOwnProperty("tx_enc_keys"))
            object.tx_enc_keys = options.bytes === String ? $util.base64.encode(message.tx_enc_keys, 0, message.tx_enc_keys.length) : options.bytes === Array ? Array.prototype.slice.call(message.tx_enc_keys) : message.tx_enc_keys;
        if (message.opening_key != null && message.hasOwnProperty("opening_key"))
            object.opening_key = options.bytes === String ? $util.base64.encode(message.opening_key, 0, message.opening_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.opening_key) : message.opening_key;
        return object;
    };

    MoneroTransactionFinalAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoneroTransactionFinalAck;
})();

$root.MoneroKeyImageExportInitRequest = (function() {

    function MoneroKeyImageExportInitRequest(properties) {
        this.address_n = [];
        this.subs = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroKeyImageExportInitRequest.prototype.num = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    MoneroKeyImageExportInitRequest.prototype.hash = $util.newBuffer([]);
    MoneroKeyImageExportInitRequest.prototype.address_n = $util.emptyArray;
    MoneroKeyImageExportInitRequest.prototype.network_type = 0;
    MoneroKeyImageExportInitRequest.prototype.subs = $util.emptyArray;

    MoneroKeyImageExportInitRequest.create = function create(properties) {
        return new MoneroKeyImageExportInitRequest(properties);
    };

    MoneroKeyImageExportInitRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.num != null && Object.hasOwnProperty.call(message, "num"))
            writer.uint32(8).uint64(message.num);
        if (message.hash != null && Object.hasOwnProperty.call(message, "hash"))
            writer.uint32(18).bytes(message.hash);
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(24).uint32(message.address_n[i]);
        if (message.network_type != null && Object.hasOwnProperty.call(message, "network_type"))
            writer.uint32(32).uint32(message.network_type);
        if (message.subs != null && message.subs.length)
            for (var i = 0; i < message.subs.length; ++i)
                $root.MoneroKeyImageExportInitRequest.MoneroSubAddressIndicesList.encode(message.subs[i], writer.uint32(42).fork()).ldelim();
        return writer;
    };

    MoneroKeyImageExportInitRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroKeyImageExportInitRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroKeyImageExportInitRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.num = reader.uint64();
                break;
            case 2:
                message.hash = reader.bytes();
                break;
            case 3:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 4:
                message.network_type = reader.uint32();
                break;
            case 5:
                if (!(message.subs && message.subs.length))
                    message.subs = [];
                message.subs.push($root.MoneroKeyImageExportInitRequest.MoneroSubAddressIndicesList.decode(reader, reader.uint32()));
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroKeyImageExportInitRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroKeyImageExportInitRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.num != null && message.hasOwnProperty("num"))
            if (!$util.isInteger(message.num) && !(message.num && $util.isInteger(message.num.low) && $util.isInteger(message.num.high)))
                return "num: integer|Long expected";
        if (message.hash != null && message.hasOwnProperty("hash"))
            if (!(message.hash && typeof message.hash.length === "number" || $util.isString(message.hash)))
                return "hash: buffer expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.network_type != null && message.hasOwnProperty("network_type"))
            if (!$util.isInteger(message.network_type))
                return "network_type: integer expected";
        if (message.subs != null && message.hasOwnProperty("subs")) {
            if (!Array.isArray(message.subs))
                return "subs: array expected";
            for (var i = 0; i < message.subs.length; ++i) {
                var error = $root.MoneroKeyImageExportInitRequest.MoneroSubAddressIndicesList.verify(message.subs[i]);
                if (error)
                    return "subs." + error;
            }
        }
        return null;
    };

    MoneroKeyImageExportInitRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroKeyImageExportInitRequest)
            return object;
        var message = new $root.MoneroKeyImageExportInitRequest();
        if (object.num != null)
            if ($util.Long)
                (message.num = $util.Long.fromValue(object.num)).unsigned = true;
            else if (typeof object.num === "string")
                message.num = parseInt(object.num, 10);
            else if (typeof object.num === "number")
                message.num = object.num;
            else if (typeof object.num === "object")
                message.num = new $util.LongBits(object.num.low >>> 0, object.num.high >>> 0).toNumber(true);
        if (object.hash != null)
            if (typeof object.hash === "string")
                $util.base64.decode(object.hash, message.hash = $util.newBuffer($util.base64.length(object.hash)), 0);
            else if (object.hash.length)
                message.hash = object.hash;
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".MoneroKeyImageExportInitRequest.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.network_type != null)
            message.network_type = object.network_type >>> 0;
        if (object.subs) {
            if (!Array.isArray(object.subs))
                throw TypeError(".MoneroKeyImageExportInitRequest.subs: array expected");
            message.subs = [];
            for (var i = 0; i < object.subs.length; ++i) {
                if (typeof object.subs[i] !== "object")
                    throw TypeError(".MoneroKeyImageExportInitRequest.subs: object expected");
                message.subs[i] = $root.MoneroKeyImageExportInitRequest.MoneroSubAddressIndicesList.fromObject(object.subs[i]);
            }
        }
        return message;
    };

    MoneroKeyImageExportInitRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults) {
            object.address_n = [];
            object.subs = [];
        }
        if (options.defaults) {
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.num = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.num = options.longs === String ? "0" : 0;
            if (options.bytes === String)
                object.hash = "";
            else {
                object.hash = [];
                if (options.bytes !== Array)
                    object.hash = $util.newBuffer(object.hash);
            }
            object.network_type = 0;
        }
        if (message.num != null && message.hasOwnProperty("num"))
            if (typeof message.num === "number")
                object.num = options.longs === String ? String(message.num) : message.num;
            else
                object.num = options.longs === String ? $util.Long.prototype.toString.call(message.num) : options.longs === Number ? new $util.LongBits(message.num.low >>> 0, message.num.high >>> 0).toNumber(true) : message.num;
        if (message.hash != null && message.hasOwnProperty("hash"))
            object.hash = options.bytes === String ? $util.base64.encode(message.hash, 0, message.hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.hash) : message.hash;
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.network_type != null && message.hasOwnProperty("network_type"))
            object.network_type = message.network_type;
        if (message.subs && message.subs.length) {
            object.subs = [];
            for (var j = 0; j < message.subs.length; ++j)
                object.subs[j] = $root.MoneroKeyImageExportInitRequest.MoneroSubAddressIndicesList.toObject(message.subs[j], options);
        }
        return object;
    };

    MoneroKeyImageExportInitRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    MoneroKeyImageExportInitRequest.MoneroSubAddressIndicesList = (function() {

        function MoneroSubAddressIndicesList(properties) {
            this.minor_indices = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        MoneroSubAddressIndicesList.prototype.account = 0;
        MoneroSubAddressIndicesList.prototype.minor_indices = $util.emptyArray;

        MoneroSubAddressIndicesList.create = function create(properties) {
            return new MoneroSubAddressIndicesList(properties);
        };

        MoneroSubAddressIndicesList.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.account != null && Object.hasOwnProperty.call(message, "account"))
                writer.uint32(8).uint32(message.account);
            if (message.minor_indices != null && message.minor_indices.length)
                for (var i = 0; i < message.minor_indices.length; ++i)
                    writer.uint32(16).uint32(message.minor_indices[i]);
            return writer;
        };

        MoneroSubAddressIndicesList.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        MoneroSubAddressIndicesList.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroKeyImageExportInitRequest.MoneroSubAddressIndicesList();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.account = reader.uint32();
                    break;
                case 2:
                    if (!(message.minor_indices && message.minor_indices.length))
                        message.minor_indices = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.minor_indices.push(reader.uint32());
                    } else
                        message.minor_indices.push(reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        MoneroSubAddressIndicesList.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        MoneroSubAddressIndicesList.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.account != null && message.hasOwnProperty("account"))
                if (!$util.isInteger(message.account))
                    return "account: integer expected";
            if (message.minor_indices != null && message.hasOwnProperty("minor_indices")) {
                if (!Array.isArray(message.minor_indices))
                    return "minor_indices: array expected";
                for (var i = 0; i < message.minor_indices.length; ++i)
                    if (!$util.isInteger(message.minor_indices[i]))
                        return "minor_indices: integer[] expected";
            }
            return null;
        };

        MoneroSubAddressIndicesList.fromObject = function fromObject(object) {
            if (object instanceof $root.MoneroKeyImageExportInitRequest.MoneroSubAddressIndicesList)
                return object;
            var message = new $root.MoneroKeyImageExportInitRequest.MoneroSubAddressIndicesList();
            if (object.account != null)
                message.account = object.account >>> 0;
            if (object.minor_indices) {
                if (!Array.isArray(object.minor_indices))
                    throw TypeError(".MoneroKeyImageExportInitRequest.MoneroSubAddressIndicesList.minor_indices: array expected");
                message.minor_indices = [];
                for (var i = 0; i < object.minor_indices.length; ++i)
                    message.minor_indices[i] = object.minor_indices[i] >>> 0;
            }
            return message;
        };

        MoneroSubAddressIndicesList.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.minor_indices = [];
            if (options.defaults)
                object.account = 0;
            if (message.account != null && message.hasOwnProperty("account"))
                object.account = message.account;
            if (message.minor_indices && message.minor_indices.length) {
                object.minor_indices = [];
                for (var j = 0; j < message.minor_indices.length; ++j)
                    object.minor_indices[j] = message.minor_indices[j];
            }
            return object;
        };

        MoneroSubAddressIndicesList.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return MoneroSubAddressIndicesList;
    })();

    return MoneroKeyImageExportInitRequest;
})();

$root.MoneroKeyImageExportInitAck = (function() {

    function MoneroKeyImageExportInitAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroKeyImageExportInitAck.create = function create(properties) {
        return new MoneroKeyImageExportInitAck(properties);
    };

    MoneroKeyImageExportInitAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    MoneroKeyImageExportInitAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroKeyImageExportInitAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroKeyImageExportInitAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroKeyImageExportInitAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroKeyImageExportInitAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    MoneroKeyImageExportInitAck.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroKeyImageExportInitAck)
            return object;
        return new $root.MoneroKeyImageExportInitAck();
    };

    MoneroKeyImageExportInitAck.toObject = function toObject() {
        return {};
    };

    MoneroKeyImageExportInitAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoneroKeyImageExportInitAck;
})();

$root.MoneroKeyImageSyncStepRequest = (function() {

    function MoneroKeyImageSyncStepRequest(properties) {
        this.tdis = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroKeyImageSyncStepRequest.prototype.tdis = $util.emptyArray;

    MoneroKeyImageSyncStepRequest.create = function create(properties) {
        return new MoneroKeyImageSyncStepRequest(properties);
    };

    MoneroKeyImageSyncStepRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.tdis != null && message.tdis.length)
            for (var i = 0; i < message.tdis.length; ++i)
                $root.MoneroKeyImageSyncStepRequest.MoneroTransferDetails.encode(message.tdis[i], writer.uint32(10).fork()).ldelim();
        return writer;
    };

    MoneroKeyImageSyncStepRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroKeyImageSyncStepRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroKeyImageSyncStepRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.tdis && message.tdis.length))
                    message.tdis = [];
                message.tdis.push($root.MoneroKeyImageSyncStepRequest.MoneroTransferDetails.decode(reader, reader.uint32()));
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroKeyImageSyncStepRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroKeyImageSyncStepRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.tdis != null && message.hasOwnProperty("tdis")) {
            if (!Array.isArray(message.tdis))
                return "tdis: array expected";
            for (var i = 0; i < message.tdis.length; ++i) {
                var error = $root.MoneroKeyImageSyncStepRequest.MoneroTransferDetails.verify(message.tdis[i]);
                if (error)
                    return "tdis." + error;
            }
        }
        return null;
    };

    MoneroKeyImageSyncStepRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroKeyImageSyncStepRequest)
            return object;
        var message = new $root.MoneroKeyImageSyncStepRequest();
        if (object.tdis) {
            if (!Array.isArray(object.tdis))
                throw TypeError(".MoneroKeyImageSyncStepRequest.tdis: array expected");
            message.tdis = [];
            for (var i = 0; i < object.tdis.length; ++i) {
                if (typeof object.tdis[i] !== "object")
                    throw TypeError(".MoneroKeyImageSyncStepRequest.tdis: object expected");
                message.tdis[i] = $root.MoneroKeyImageSyncStepRequest.MoneroTransferDetails.fromObject(object.tdis[i]);
            }
        }
        return message;
    };

    MoneroKeyImageSyncStepRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.tdis = [];
        if (message.tdis && message.tdis.length) {
            object.tdis = [];
            for (var j = 0; j < message.tdis.length; ++j)
                object.tdis[j] = $root.MoneroKeyImageSyncStepRequest.MoneroTransferDetails.toObject(message.tdis[j], options);
        }
        return object;
    };

    MoneroKeyImageSyncStepRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    MoneroKeyImageSyncStepRequest.MoneroTransferDetails = (function() {

        function MoneroTransferDetails(properties) {
            this.additional_tx_pub_keys = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        MoneroTransferDetails.prototype.out_key = $util.newBuffer([]);
        MoneroTransferDetails.prototype.tx_pub_key = $util.newBuffer([]);
        MoneroTransferDetails.prototype.additional_tx_pub_keys = $util.emptyArray;
        MoneroTransferDetails.prototype.internal_output_index = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        MoneroTransferDetails.prototype.sub_addr_major = 0;
        MoneroTransferDetails.prototype.sub_addr_minor = 0;

        MoneroTransferDetails.create = function create(properties) {
            return new MoneroTransferDetails(properties);
        };

        MoneroTransferDetails.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.out_key != null && Object.hasOwnProperty.call(message, "out_key"))
                writer.uint32(10).bytes(message.out_key);
            if (message.tx_pub_key != null && Object.hasOwnProperty.call(message, "tx_pub_key"))
                writer.uint32(18).bytes(message.tx_pub_key);
            if (message.additional_tx_pub_keys != null && message.additional_tx_pub_keys.length)
                for (var i = 0; i < message.additional_tx_pub_keys.length; ++i)
                    writer.uint32(26).bytes(message.additional_tx_pub_keys[i]);
            if (message.internal_output_index != null && Object.hasOwnProperty.call(message, "internal_output_index"))
                writer.uint32(32).uint64(message.internal_output_index);
            if (message.sub_addr_major != null && Object.hasOwnProperty.call(message, "sub_addr_major"))
                writer.uint32(40).uint32(message.sub_addr_major);
            if (message.sub_addr_minor != null && Object.hasOwnProperty.call(message, "sub_addr_minor"))
                writer.uint32(48).uint32(message.sub_addr_minor);
            return writer;
        };

        MoneroTransferDetails.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        MoneroTransferDetails.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroKeyImageSyncStepRequest.MoneroTransferDetails();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.out_key = reader.bytes();
                    break;
                case 2:
                    message.tx_pub_key = reader.bytes();
                    break;
                case 3:
                    if (!(message.additional_tx_pub_keys && message.additional_tx_pub_keys.length))
                        message.additional_tx_pub_keys = [];
                    message.additional_tx_pub_keys.push(reader.bytes());
                    break;
                case 4:
                    message.internal_output_index = reader.uint64();
                    break;
                case 5:
                    message.sub_addr_major = reader.uint32();
                    break;
                case 6:
                    message.sub_addr_minor = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        MoneroTransferDetails.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        MoneroTransferDetails.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.out_key != null && message.hasOwnProperty("out_key"))
                if (!(message.out_key && typeof message.out_key.length === "number" || $util.isString(message.out_key)))
                    return "out_key: buffer expected";
            if (message.tx_pub_key != null && message.hasOwnProperty("tx_pub_key"))
                if (!(message.tx_pub_key && typeof message.tx_pub_key.length === "number" || $util.isString(message.tx_pub_key)))
                    return "tx_pub_key: buffer expected";
            if (message.additional_tx_pub_keys != null && message.hasOwnProperty("additional_tx_pub_keys")) {
                if (!Array.isArray(message.additional_tx_pub_keys))
                    return "additional_tx_pub_keys: array expected";
                for (var i = 0; i < message.additional_tx_pub_keys.length; ++i)
                    if (!(message.additional_tx_pub_keys[i] && typeof message.additional_tx_pub_keys[i].length === "number" || $util.isString(message.additional_tx_pub_keys[i])))
                        return "additional_tx_pub_keys: buffer[] expected";
            }
            if (message.internal_output_index != null && message.hasOwnProperty("internal_output_index"))
                if (!$util.isInteger(message.internal_output_index) && !(message.internal_output_index && $util.isInteger(message.internal_output_index.low) && $util.isInteger(message.internal_output_index.high)))
                    return "internal_output_index: integer|Long expected";
            if (message.sub_addr_major != null && message.hasOwnProperty("sub_addr_major"))
                if (!$util.isInteger(message.sub_addr_major))
                    return "sub_addr_major: integer expected";
            if (message.sub_addr_minor != null && message.hasOwnProperty("sub_addr_minor"))
                if (!$util.isInteger(message.sub_addr_minor))
                    return "sub_addr_minor: integer expected";
            return null;
        };

        MoneroTransferDetails.fromObject = function fromObject(object) {
            if (object instanceof $root.MoneroKeyImageSyncStepRequest.MoneroTransferDetails)
                return object;
            var message = new $root.MoneroKeyImageSyncStepRequest.MoneroTransferDetails();
            if (object.out_key != null)
                if (typeof object.out_key === "string")
                    $util.base64.decode(object.out_key, message.out_key = $util.newBuffer($util.base64.length(object.out_key)), 0);
                else if (object.out_key.length)
                    message.out_key = object.out_key;
            if (object.tx_pub_key != null)
                if (typeof object.tx_pub_key === "string")
                    $util.base64.decode(object.tx_pub_key, message.tx_pub_key = $util.newBuffer($util.base64.length(object.tx_pub_key)), 0);
                else if (object.tx_pub_key.length)
                    message.tx_pub_key = object.tx_pub_key;
            if (object.additional_tx_pub_keys) {
                if (!Array.isArray(object.additional_tx_pub_keys))
                    throw TypeError(".MoneroKeyImageSyncStepRequest.MoneroTransferDetails.additional_tx_pub_keys: array expected");
                message.additional_tx_pub_keys = [];
                for (var i = 0; i < object.additional_tx_pub_keys.length; ++i)
                    if (typeof object.additional_tx_pub_keys[i] === "string")
                        $util.base64.decode(object.additional_tx_pub_keys[i], message.additional_tx_pub_keys[i] = $util.newBuffer($util.base64.length(object.additional_tx_pub_keys[i])), 0);
                    else if (object.additional_tx_pub_keys[i].length)
                        message.additional_tx_pub_keys[i] = object.additional_tx_pub_keys[i];
            }
            if (object.internal_output_index != null)
                if ($util.Long)
                    (message.internal_output_index = $util.Long.fromValue(object.internal_output_index)).unsigned = true;
                else if (typeof object.internal_output_index === "string")
                    message.internal_output_index = parseInt(object.internal_output_index, 10);
                else if (typeof object.internal_output_index === "number")
                    message.internal_output_index = object.internal_output_index;
                else if (typeof object.internal_output_index === "object")
                    message.internal_output_index = new $util.LongBits(object.internal_output_index.low >>> 0, object.internal_output_index.high >>> 0).toNumber(true);
            if (object.sub_addr_major != null)
                message.sub_addr_major = object.sub_addr_major >>> 0;
            if (object.sub_addr_minor != null)
                message.sub_addr_minor = object.sub_addr_minor >>> 0;
            return message;
        };

        MoneroTransferDetails.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.additional_tx_pub_keys = [];
            if (options.defaults) {
                if (options.bytes === String)
                    object.out_key = "";
                else {
                    object.out_key = [];
                    if (options.bytes !== Array)
                        object.out_key = $util.newBuffer(object.out_key);
                }
                if (options.bytes === String)
                    object.tx_pub_key = "";
                else {
                    object.tx_pub_key = [];
                    if (options.bytes !== Array)
                        object.tx_pub_key = $util.newBuffer(object.tx_pub_key);
                }
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.internal_output_index = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.internal_output_index = options.longs === String ? "0" : 0;
                object.sub_addr_major = 0;
                object.sub_addr_minor = 0;
            }
            if (message.out_key != null && message.hasOwnProperty("out_key"))
                object.out_key = options.bytes === String ? $util.base64.encode(message.out_key, 0, message.out_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.out_key) : message.out_key;
            if (message.tx_pub_key != null && message.hasOwnProperty("tx_pub_key"))
                object.tx_pub_key = options.bytes === String ? $util.base64.encode(message.tx_pub_key, 0, message.tx_pub_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.tx_pub_key) : message.tx_pub_key;
            if (message.additional_tx_pub_keys && message.additional_tx_pub_keys.length) {
                object.additional_tx_pub_keys = [];
                for (var j = 0; j < message.additional_tx_pub_keys.length; ++j)
                    object.additional_tx_pub_keys[j] = options.bytes === String ? $util.base64.encode(message.additional_tx_pub_keys[j], 0, message.additional_tx_pub_keys[j].length) : options.bytes === Array ? Array.prototype.slice.call(message.additional_tx_pub_keys[j]) : message.additional_tx_pub_keys[j];
            }
            if (message.internal_output_index != null && message.hasOwnProperty("internal_output_index"))
                if (typeof message.internal_output_index === "number")
                    object.internal_output_index = options.longs === String ? String(message.internal_output_index) : message.internal_output_index;
                else
                    object.internal_output_index = options.longs === String ? $util.Long.prototype.toString.call(message.internal_output_index) : options.longs === Number ? new $util.LongBits(message.internal_output_index.low >>> 0, message.internal_output_index.high >>> 0).toNumber(true) : message.internal_output_index;
            if (message.sub_addr_major != null && message.hasOwnProperty("sub_addr_major"))
                object.sub_addr_major = message.sub_addr_major;
            if (message.sub_addr_minor != null && message.hasOwnProperty("sub_addr_minor"))
                object.sub_addr_minor = message.sub_addr_minor;
            return object;
        };

        MoneroTransferDetails.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return MoneroTransferDetails;
    })();

    return MoneroKeyImageSyncStepRequest;
})();

$root.MoneroKeyImageSyncStepAck = (function() {

    function MoneroKeyImageSyncStepAck(properties) {
        this.kis = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroKeyImageSyncStepAck.prototype.kis = $util.emptyArray;

    MoneroKeyImageSyncStepAck.create = function create(properties) {
        return new MoneroKeyImageSyncStepAck(properties);
    };

    MoneroKeyImageSyncStepAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.kis != null && message.kis.length)
            for (var i = 0; i < message.kis.length; ++i)
                $root.MoneroKeyImageSyncStepAck.MoneroExportedKeyImage.encode(message.kis[i], writer.uint32(10).fork()).ldelim();
        return writer;
    };

    MoneroKeyImageSyncStepAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroKeyImageSyncStepAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroKeyImageSyncStepAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.kis && message.kis.length))
                    message.kis = [];
                message.kis.push($root.MoneroKeyImageSyncStepAck.MoneroExportedKeyImage.decode(reader, reader.uint32()));
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroKeyImageSyncStepAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroKeyImageSyncStepAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.kis != null && message.hasOwnProperty("kis")) {
            if (!Array.isArray(message.kis))
                return "kis: array expected";
            for (var i = 0; i < message.kis.length; ++i) {
                var error = $root.MoneroKeyImageSyncStepAck.MoneroExportedKeyImage.verify(message.kis[i]);
                if (error)
                    return "kis." + error;
            }
        }
        return null;
    };

    MoneroKeyImageSyncStepAck.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroKeyImageSyncStepAck)
            return object;
        var message = new $root.MoneroKeyImageSyncStepAck();
        if (object.kis) {
            if (!Array.isArray(object.kis))
                throw TypeError(".MoneroKeyImageSyncStepAck.kis: array expected");
            message.kis = [];
            for (var i = 0; i < object.kis.length; ++i) {
                if (typeof object.kis[i] !== "object")
                    throw TypeError(".MoneroKeyImageSyncStepAck.kis: object expected");
                message.kis[i] = $root.MoneroKeyImageSyncStepAck.MoneroExportedKeyImage.fromObject(object.kis[i]);
            }
        }
        return message;
    };

    MoneroKeyImageSyncStepAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.kis = [];
        if (message.kis && message.kis.length) {
            object.kis = [];
            for (var j = 0; j < message.kis.length; ++j)
                object.kis[j] = $root.MoneroKeyImageSyncStepAck.MoneroExportedKeyImage.toObject(message.kis[j], options);
        }
        return object;
    };

    MoneroKeyImageSyncStepAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    MoneroKeyImageSyncStepAck.MoneroExportedKeyImage = (function() {

        function MoneroExportedKeyImage(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        MoneroExportedKeyImage.prototype.iv = $util.newBuffer([]);
        MoneroExportedKeyImage.prototype.blob = $util.newBuffer([]);

        MoneroExportedKeyImage.create = function create(properties) {
            return new MoneroExportedKeyImage(properties);
        };

        MoneroExportedKeyImage.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.iv != null && Object.hasOwnProperty.call(message, "iv"))
                writer.uint32(10).bytes(message.iv);
            if (message.blob != null && Object.hasOwnProperty.call(message, "blob"))
                writer.uint32(26).bytes(message.blob);
            return writer;
        };

        MoneroExportedKeyImage.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        MoneroExportedKeyImage.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroKeyImageSyncStepAck.MoneroExportedKeyImage();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.iv = reader.bytes();
                    break;
                case 3:
                    message.blob = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        MoneroExportedKeyImage.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        MoneroExportedKeyImage.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.iv != null && message.hasOwnProperty("iv"))
                if (!(message.iv && typeof message.iv.length === "number" || $util.isString(message.iv)))
                    return "iv: buffer expected";
            if (message.blob != null && message.hasOwnProperty("blob"))
                if (!(message.blob && typeof message.blob.length === "number" || $util.isString(message.blob)))
                    return "blob: buffer expected";
            return null;
        };

        MoneroExportedKeyImage.fromObject = function fromObject(object) {
            if (object instanceof $root.MoneroKeyImageSyncStepAck.MoneroExportedKeyImage)
                return object;
            var message = new $root.MoneroKeyImageSyncStepAck.MoneroExportedKeyImage();
            if (object.iv != null)
                if (typeof object.iv === "string")
                    $util.base64.decode(object.iv, message.iv = $util.newBuffer($util.base64.length(object.iv)), 0);
                else if (object.iv.length)
                    message.iv = object.iv;
            if (object.blob != null)
                if (typeof object.blob === "string")
                    $util.base64.decode(object.blob, message.blob = $util.newBuffer($util.base64.length(object.blob)), 0);
                else if (object.blob.length)
                    message.blob = object.blob;
            return message;
        };

        MoneroExportedKeyImage.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if (options.bytes === String)
                    object.iv = "";
                else {
                    object.iv = [];
                    if (options.bytes !== Array)
                        object.iv = $util.newBuffer(object.iv);
                }
                if (options.bytes === String)
                    object.blob = "";
                else {
                    object.blob = [];
                    if (options.bytes !== Array)
                        object.blob = $util.newBuffer(object.blob);
                }
            }
            if (message.iv != null && message.hasOwnProperty("iv"))
                object.iv = options.bytes === String ? $util.base64.encode(message.iv, 0, message.iv.length) : options.bytes === Array ? Array.prototype.slice.call(message.iv) : message.iv;
            if (message.blob != null && message.hasOwnProperty("blob"))
                object.blob = options.bytes === String ? $util.base64.encode(message.blob, 0, message.blob.length) : options.bytes === Array ? Array.prototype.slice.call(message.blob) : message.blob;
            return object;
        };

        MoneroExportedKeyImage.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return MoneroExportedKeyImage;
    })();

    return MoneroKeyImageSyncStepAck;
})();

$root.MoneroKeyImageSyncFinalRequest = (function() {

    function MoneroKeyImageSyncFinalRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroKeyImageSyncFinalRequest.create = function create(properties) {
        return new MoneroKeyImageSyncFinalRequest(properties);
    };

    MoneroKeyImageSyncFinalRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    MoneroKeyImageSyncFinalRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroKeyImageSyncFinalRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroKeyImageSyncFinalRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroKeyImageSyncFinalRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroKeyImageSyncFinalRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    MoneroKeyImageSyncFinalRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroKeyImageSyncFinalRequest)
            return object;
        return new $root.MoneroKeyImageSyncFinalRequest();
    };

    MoneroKeyImageSyncFinalRequest.toObject = function toObject() {
        return {};
    };

    MoneroKeyImageSyncFinalRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoneroKeyImageSyncFinalRequest;
})();

$root.MoneroKeyImageSyncFinalAck = (function() {

    function MoneroKeyImageSyncFinalAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroKeyImageSyncFinalAck.prototype.enc_key = $util.newBuffer([]);

    MoneroKeyImageSyncFinalAck.create = function create(properties) {
        return new MoneroKeyImageSyncFinalAck(properties);
    };

    MoneroKeyImageSyncFinalAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.enc_key != null && Object.hasOwnProperty.call(message, "enc_key"))
            writer.uint32(10).bytes(message.enc_key);
        return writer;
    };

    MoneroKeyImageSyncFinalAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroKeyImageSyncFinalAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroKeyImageSyncFinalAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.enc_key = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroKeyImageSyncFinalAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroKeyImageSyncFinalAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.enc_key != null && message.hasOwnProperty("enc_key"))
            if (!(message.enc_key && typeof message.enc_key.length === "number" || $util.isString(message.enc_key)))
                return "enc_key: buffer expected";
        return null;
    };

    MoneroKeyImageSyncFinalAck.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroKeyImageSyncFinalAck)
            return object;
        var message = new $root.MoneroKeyImageSyncFinalAck();
        if (object.enc_key != null)
            if (typeof object.enc_key === "string")
                $util.base64.decode(object.enc_key, message.enc_key = $util.newBuffer($util.base64.length(object.enc_key)), 0);
            else if (object.enc_key.length)
                message.enc_key = object.enc_key;
        return message;
    };

    MoneroKeyImageSyncFinalAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.enc_key = "";
            else {
                object.enc_key = [];
                if (options.bytes !== Array)
                    object.enc_key = $util.newBuffer(object.enc_key);
            }
        if (message.enc_key != null && message.hasOwnProperty("enc_key"))
            object.enc_key = options.bytes === String ? $util.base64.encode(message.enc_key, 0, message.enc_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.enc_key) : message.enc_key;
        return object;
    };

    MoneroKeyImageSyncFinalAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoneroKeyImageSyncFinalAck;
})();

$root.MoneroGetTxKeyRequest = (function() {

    function MoneroGetTxKeyRequest(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroGetTxKeyRequest.prototype.address_n = $util.emptyArray;
    MoneroGetTxKeyRequest.prototype.network_type = 0;
    MoneroGetTxKeyRequest.prototype.salt1 = $util.newBuffer([]);
    MoneroGetTxKeyRequest.prototype.salt2 = $util.newBuffer([]);
    MoneroGetTxKeyRequest.prototype.tx_enc_keys = $util.newBuffer([]);
    MoneroGetTxKeyRequest.prototype.tx_prefix_hash = $util.newBuffer([]);
    MoneroGetTxKeyRequest.prototype.reason = 0;
    MoneroGetTxKeyRequest.prototype.view_public_key = $util.newBuffer([]);

    MoneroGetTxKeyRequest.create = function create(properties) {
        return new MoneroGetTxKeyRequest(properties);
    };

    MoneroGetTxKeyRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.network_type != null && Object.hasOwnProperty.call(message, "network_type"))
            writer.uint32(16).uint32(message.network_type);
        if (message.salt1 != null && Object.hasOwnProperty.call(message, "salt1"))
            writer.uint32(26).bytes(message.salt1);
        if (message.salt2 != null && Object.hasOwnProperty.call(message, "salt2"))
            writer.uint32(34).bytes(message.salt2);
        if (message.tx_enc_keys != null && Object.hasOwnProperty.call(message, "tx_enc_keys"))
            writer.uint32(42).bytes(message.tx_enc_keys);
        if (message.tx_prefix_hash != null && Object.hasOwnProperty.call(message, "tx_prefix_hash"))
            writer.uint32(50).bytes(message.tx_prefix_hash);
        if (message.reason != null && Object.hasOwnProperty.call(message, "reason"))
            writer.uint32(56).uint32(message.reason);
        if (message.view_public_key != null && Object.hasOwnProperty.call(message, "view_public_key"))
            writer.uint32(66).bytes(message.view_public_key);
        return writer;
    };

    MoneroGetTxKeyRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroGetTxKeyRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroGetTxKeyRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.network_type = reader.uint32();
                break;
            case 3:
                message.salt1 = reader.bytes();
                break;
            case 4:
                message.salt2 = reader.bytes();
                break;
            case 5:
                message.tx_enc_keys = reader.bytes();
                break;
            case 6:
                message.tx_prefix_hash = reader.bytes();
                break;
            case 7:
                message.reason = reader.uint32();
                break;
            case 8:
                message.view_public_key = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroGetTxKeyRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroGetTxKeyRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.network_type != null && message.hasOwnProperty("network_type"))
            if (!$util.isInteger(message.network_type))
                return "network_type: integer expected";
        if (message.salt1 != null && message.hasOwnProperty("salt1"))
            if (!(message.salt1 && typeof message.salt1.length === "number" || $util.isString(message.salt1)))
                return "salt1: buffer expected";
        if (message.salt2 != null && message.hasOwnProperty("salt2"))
            if (!(message.salt2 && typeof message.salt2.length === "number" || $util.isString(message.salt2)))
                return "salt2: buffer expected";
        if (message.tx_enc_keys != null && message.hasOwnProperty("tx_enc_keys"))
            if (!(message.tx_enc_keys && typeof message.tx_enc_keys.length === "number" || $util.isString(message.tx_enc_keys)))
                return "tx_enc_keys: buffer expected";
        if (message.tx_prefix_hash != null && message.hasOwnProperty("tx_prefix_hash"))
            if (!(message.tx_prefix_hash && typeof message.tx_prefix_hash.length === "number" || $util.isString(message.tx_prefix_hash)))
                return "tx_prefix_hash: buffer expected";
        if (message.reason != null && message.hasOwnProperty("reason"))
            if (!$util.isInteger(message.reason))
                return "reason: integer expected";
        if (message.view_public_key != null && message.hasOwnProperty("view_public_key"))
            if (!(message.view_public_key && typeof message.view_public_key.length === "number" || $util.isString(message.view_public_key)))
                return "view_public_key: buffer expected";
        return null;
    };

    MoneroGetTxKeyRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroGetTxKeyRequest)
            return object;
        var message = new $root.MoneroGetTxKeyRequest();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".MoneroGetTxKeyRequest.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.network_type != null)
            message.network_type = object.network_type >>> 0;
        if (object.salt1 != null)
            if (typeof object.salt1 === "string")
                $util.base64.decode(object.salt1, message.salt1 = $util.newBuffer($util.base64.length(object.salt1)), 0);
            else if (object.salt1.length)
                message.salt1 = object.salt1;
        if (object.salt2 != null)
            if (typeof object.salt2 === "string")
                $util.base64.decode(object.salt2, message.salt2 = $util.newBuffer($util.base64.length(object.salt2)), 0);
            else if (object.salt2.length)
                message.salt2 = object.salt2;
        if (object.tx_enc_keys != null)
            if (typeof object.tx_enc_keys === "string")
                $util.base64.decode(object.tx_enc_keys, message.tx_enc_keys = $util.newBuffer($util.base64.length(object.tx_enc_keys)), 0);
            else if (object.tx_enc_keys.length)
                message.tx_enc_keys = object.tx_enc_keys;
        if (object.tx_prefix_hash != null)
            if (typeof object.tx_prefix_hash === "string")
                $util.base64.decode(object.tx_prefix_hash, message.tx_prefix_hash = $util.newBuffer($util.base64.length(object.tx_prefix_hash)), 0);
            else if (object.tx_prefix_hash.length)
                message.tx_prefix_hash = object.tx_prefix_hash;
        if (object.reason != null)
            message.reason = object.reason >>> 0;
        if (object.view_public_key != null)
            if (typeof object.view_public_key === "string")
                $util.base64.decode(object.view_public_key, message.view_public_key = $util.newBuffer($util.base64.length(object.view_public_key)), 0);
            else if (object.view_public_key.length)
                message.view_public_key = object.view_public_key;
        return message;
    };

    MoneroGetTxKeyRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            object.network_type = 0;
            if (options.bytes === String)
                object.salt1 = "";
            else {
                object.salt1 = [];
                if (options.bytes !== Array)
                    object.salt1 = $util.newBuffer(object.salt1);
            }
            if (options.bytes === String)
                object.salt2 = "";
            else {
                object.salt2 = [];
                if (options.bytes !== Array)
                    object.salt2 = $util.newBuffer(object.salt2);
            }
            if (options.bytes === String)
                object.tx_enc_keys = "";
            else {
                object.tx_enc_keys = [];
                if (options.bytes !== Array)
                    object.tx_enc_keys = $util.newBuffer(object.tx_enc_keys);
            }
            if (options.bytes === String)
                object.tx_prefix_hash = "";
            else {
                object.tx_prefix_hash = [];
                if (options.bytes !== Array)
                    object.tx_prefix_hash = $util.newBuffer(object.tx_prefix_hash);
            }
            object.reason = 0;
            if (options.bytes === String)
                object.view_public_key = "";
            else {
                object.view_public_key = [];
                if (options.bytes !== Array)
                    object.view_public_key = $util.newBuffer(object.view_public_key);
            }
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.network_type != null && message.hasOwnProperty("network_type"))
            object.network_type = message.network_type;
        if (message.salt1 != null && message.hasOwnProperty("salt1"))
            object.salt1 = options.bytes === String ? $util.base64.encode(message.salt1, 0, message.salt1.length) : options.bytes === Array ? Array.prototype.slice.call(message.salt1) : message.salt1;
        if (message.salt2 != null && message.hasOwnProperty("salt2"))
            object.salt2 = options.bytes === String ? $util.base64.encode(message.salt2, 0, message.salt2.length) : options.bytes === Array ? Array.prototype.slice.call(message.salt2) : message.salt2;
        if (message.tx_enc_keys != null && message.hasOwnProperty("tx_enc_keys"))
            object.tx_enc_keys = options.bytes === String ? $util.base64.encode(message.tx_enc_keys, 0, message.tx_enc_keys.length) : options.bytes === Array ? Array.prototype.slice.call(message.tx_enc_keys) : message.tx_enc_keys;
        if (message.tx_prefix_hash != null && message.hasOwnProperty("tx_prefix_hash"))
            object.tx_prefix_hash = options.bytes === String ? $util.base64.encode(message.tx_prefix_hash, 0, message.tx_prefix_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.tx_prefix_hash) : message.tx_prefix_hash;
        if (message.reason != null && message.hasOwnProperty("reason"))
            object.reason = message.reason;
        if (message.view_public_key != null && message.hasOwnProperty("view_public_key"))
            object.view_public_key = options.bytes === String ? $util.base64.encode(message.view_public_key, 0, message.view_public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.view_public_key) : message.view_public_key;
        return object;
    };

    MoneroGetTxKeyRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoneroGetTxKeyRequest;
})();

$root.MoneroGetTxKeyAck = (function() {

    function MoneroGetTxKeyAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroGetTxKeyAck.prototype.salt = $util.newBuffer([]);
    MoneroGetTxKeyAck.prototype.tx_keys = $util.newBuffer([]);
    MoneroGetTxKeyAck.prototype.tx_derivations = $util.newBuffer([]);

    MoneroGetTxKeyAck.create = function create(properties) {
        return new MoneroGetTxKeyAck(properties);
    };

    MoneroGetTxKeyAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.salt != null && Object.hasOwnProperty.call(message, "salt"))
            writer.uint32(10).bytes(message.salt);
        if (message.tx_keys != null && Object.hasOwnProperty.call(message, "tx_keys"))
            writer.uint32(18).bytes(message.tx_keys);
        if (message.tx_derivations != null && Object.hasOwnProperty.call(message, "tx_derivations"))
            writer.uint32(26).bytes(message.tx_derivations);
        return writer;
    };

    MoneroGetTxKeyAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroGetTxKeyAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroGetTxKeyAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.salt = reader.bytes();
                break;
            case 2:
                message.tx_keys = reader.bytes();
                break;
            case 3:
                message.tx_derivations = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroGetTxKeyAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroGetTxKeyAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.salt != null && message.hasOwnProperty("salt"))
            if (!(message.salt && typeof message.salt.length === "number" || $util.isString(message.salt)))
                return "salt: buffer expected";
        if (message.tx_keys != null && message.hasOwnProperty("tx_keys"))
            if (!(message.tx_keys && typeof message.tx_keys.length === "number" || $util.isString(message.tx_keys)))
                return "tx_keys: buffer expected";
        if (message.tx_derivations != null && message.hasOwnProperty("tx_derivations"))
            if (!(message.tx_derivations && typeof message.tx_derivations.length === "number" || $util.isString(message.tx_derivations)))
                return "tx_derivations: buffer expected";
        return null;
    };

    MoneroGetTxKeyAck.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroGetTxKeyAck)
            return object;
        var message = new $root.MoneroGetTxKeyAck();
        if (object.salt != null)
            if (typeof object.salt === "string")
                $util.base64.decode(object.salt, message.salt = $util.newBuffer($util.base64.length(object.salt)), 0);
            else if (object.salt.length)
                message.salt = object.salt;
        if (object.tx_keys != null)
            if (typeof object.tx_keys === "string")
                $util.base64.decode(object.tx_keys, message.tx_keys = $util.newBuffer($util.base64.length(object.tx_keys)), 0);
            else if (object.tx_keys.length)
                message.tx_keys = object.tx_keys;
        if (object.tx_derivations != null)
            if (typeof object.tx_derivations === "string")
                $util.base64.decode(object.tx_derivations, message.tx_derivations = $util.newBuffer($util.base64.length(object.tx_derivations)), 0);
            else if (object.tx_derivations.length)
                message.tx_derivations = object.tx_derivations;
        return message;
    };

    MoneroGetTxKeyAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.salt = "";
            else {
                object.salt = [];
                if (options.bytes !== Array)
                    object.salt = $util.newBuffer(object.salt);
            }
            if (options.bytes === String)
                object.tx_keys = "";
            else {
                object.tx_keys = [];
                if (options.bytes !== Array)
                    object.tx_keys = $util.newBuffer(object.tx_keys);
            }
            if (options.bytes === String)
                object.tx_derivations = "";
            else {
                object.tx_derivations = [];
                if (options.bytes !== Array)
                    object.tx_derivations = $util.newBuffer(object.tx_derivations);
            }
        }
        if (message.salt != null && message.hasOwnProperty("salt"))
            object.salt = options.bytes === String ? $util.base64.encode(message.salt, 0, message.salt.length) : options.bytes === Array ? Array.prototype.slice.call(message.salt) : message.salt;
        if (message.tx_keys != null && message.hasOwnProperty("tx_keys"))
            object.tx_keys = options.bytes === String ? $util.base64.encode(message.tx_keys, 0, message.tx_keys.length) : options.bytes === Array ? Array.prototype.slice.call(message.tx_keys) : message.tx_keys;
        if (message.tx_derivations != null && message.hasOwnProperty("tx_derivations"))
            object.tx_derivations = options.bytes === String ? $util.base64.encode(message.tx_derivations, 0, message.tx_derivations.length) : options.bytes === Array ? Array.prototype.slice.call(message.tx_derivations) : message.tx_derivations;
        return object;
    };

    MoneroGetTxKeyAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoneroGetTxKeyAck;
})();

$root.MoneroLiveRefreshStartRequest = (function() {

    function MoneroLiveRefreshStartRequest(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroLiveRefreshStartRequest.prototype.address_n = $util.emptyArray;
    MoneroLiveRefreshStartRequest.prototype.network_type = 0;

    MoneroLiveRefreshStartRequest.create = function create(properties) {
        return new MoneroLiveRefreshStartRequest(properties);
    };

    MoneroLiveRefreshStartRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.network_type != null && Object.hasOwnProperty.call(message, "network_type"))
            writer.uint32(16).uint32(message.network_type);
        return writer;
    };

    MoneroLiveRefreshStartRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroLiveRefreshStartRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroLiveRefreshStartRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.network_type = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroLiveRefreshStartRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroLiveRefreshStartRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.network_type != null && message.hasOwnProperty("network_type"))
            if (!$util.isInteger(message.network_type))
                return "network_type: integer expected";
        return null;
    };

    MoneroLiveRefreshStartRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroLiveRefreshStartRequest)
            return object;
        var message = new $root.MoneroLiveRefreshStartRequest();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".MoneroLiveRefreshStartRequest.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.network_type != null)
            message.network_type = object.network_type >>> 0;
        return message;
    };

    MoneroLiveRefreshStartRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            object.network_type = 0;
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.network_type != null && message.hasOwnProperty("network_type"))
            object.network_type = message.network_type;
        return object;
    };

    MoneroLiveRefreshStartRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoneroLiveRefreshStartRequest;
})();

$root.MoneroLiveRefreshStartAck = (function() {

    function MoneroLiveRefreshStartAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroLiveRefreshStartAck.create = function create(properties) {
        return new MoneroLiveRefreshStartAck(properties);
    };

    MoneroLiveRefreshStartAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    MoneroLiveRefreshStartAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroLiveRefreshStartAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroLiveRefreshStartAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroLiveRefreshStartAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroLiveRefreshStartAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    MoneroLiveRefreshStartAck.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroLiveRefreshStartAck)
            return object;
        return new $root.MoneroLiveRefreshStartAck();
    };

    MoneroLiveRefreshStartAck.toObject = function toObject() {
        return {};
    };

    MoneroLiveRefreshStartAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoneroLiveRefreshStartAck;
})();

$root.MoneroLiveRefreshStepRequest = (function() {

    function MoneroLiveRefreshStepRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroLiveRefreshStepRequest.prototype.out_key = $util.newBuffer([]);
    MoneroLiveRefreshStepRequest.prototype.recv_deriv = $util.newBuffer([]);
    MoneroLiveRefreshStepRequest.prototype.real_out_idx = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    MoneroLiveRefreshStepRequest.prototype.sub_addr_major = 0;
    MoneroLiveRefreshStepRequest.prototype.sub_addr_minor = 0;

    MoneroLiveRefreshStepRequest.create = function create(properties) {
        return new MoneroLiveRefreshStepRequest(properties);
    };

    MoneroLiveRefreshStepRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.out_key != null && Object.hasOwnProperty.call(message, "out_key"))
            writer.uint32(10).bytes(message.out_key);
        if (message.recv_deriv != null && Object.hasOwnProperty.call(message, "recv_deriv"))
            writer.uint32(18).bytes(message.recv_deriv);
        if (message.real_out_idx != null && Object.hasOwnProperty.call(message, "real_out_idx"))
            writer.uint32(24).uint64(message.real_out_idx);
        if (message.sub_addr_major != null && Object.hasOwnProperty.call(message, "sub_addr_major"))
            writer.uint32(32).uint32(message.sub_addr_major);
        if (message.sub_addr_minor != null && Object.hasOwnProperty.call(message, "sub_addr_minor"))
            writer.uint32(40).uint32(message.sub_addr_minor);
        return writer;
    };

    MoneroLiveRefreshStepRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroLiveRefreshStepRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroLiveRefreshStepRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.out_key = reader.bytes();
                break;
            case 2:
                message.recv_deriv = reader.bytes();
                break;
            case 3:
                message.real_out_idx = reader.uint64();
                break;
            case 4:
                message.sub_addr_major = reader.uint32();
                break;
            case 5:
                message.sub_addr_minor = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroLiveRefreshStepRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroLiveRefreshStepRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.out_key != null && message.hasOwnProperty("out_key"))
            if (!(message.out_key && typeof message.out_key.length === "number" || $util.isString(message.out_key)))
                return "out_key: buffer expected";
        if (message.recv_deriv != null && message.hasOwnProperty("recv_deriv"))
            if (!(message.recv_deriv && typeof message.recv_deriv.length === "number" || $util.isString(message.recv_deriv)))
                return "recv_deriv: buffer expected";
        if (message.real_out_idx != null && message.hasOwnProperty("real_out_idx"))
            if (!$util.isInteger(message.real_out_idx) && !(message.real_out_idx && $util.isInteger(message.real_out_idx.low) && $util.isInteger(message.real_out_idx.high)))
                return "real_out_idx: integer|Long expected";
        if (message.sub_addr_major != null && message.hasOwnProperty("sub_addr_major"))
            if (!$util.isInteger(message.sub_addr_major))
                return "sub_addr_major: integer expected";
        if (message.sub_addr_minor != null && message.hasOwnProperty("sub_addr_minor"))
            if (!$util.isInteger(message.sub_addr_minor))
                return "sub_addr_minor: integer expected";
        return null;
    };

    MoneroLiveRefreshStepRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroLiveRefreshStepRequest)
            return object;
        var message = new $root.MoneroLiveRefreshStepRequest();
        if (object.out_key != null)
            if (typeof object.out_key === "string")
                $util.base64.decode(object.out_key, message.out_key = $util.newBuffer($util.base64.length(object.out_key)), 0);
            else if (object.out_key.length)
                message.out_key = object.out_key;
        if (object.recv_deriv != null)
            if (typeof object.recv_deriv === "string")
                $util.base64.decode(object.recv_deriv, message.recv_deriv = $util.newBuffer($util.base64.length(object.recv_deriv)), 0);
            else if (object.recv_deriv.length)
                message.recv_deriv = object.recv_deriv;
        if (object.real_out_idx != null)
            if ($util.Long)
                (message.real_out_idx = $util.Long.fromValue(object.real_out_idx)).unsigned = true;
            else if (typeof object.real_out_idx === "string")
                message.real_out_idx = parseInt(object.real_out_idx, 10);
            else if (typeof object.real_out_idx === "number")
                message.real_out_idx = object.real_out_idx;
            else if (typeof object.real_out_idx === "object")
                message.real_out_idx = new $util.LongBits(object.real_out_idx.low >>> 0, object.real_out_idx.high >>> 0).toNumber(true);
        if (object.sub_addr_major != null)
            message.sub_addr_major = object.sub_addr_major >>> 0;
        if (object.sub_addr_minor != null)
            message.sub_addr_minor = object.sub_addr_minor >>> 0;
        return message;
    };

    MoneroLiveRefreshStepRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.out_key = "";
            else {
                object.out_key = [];
                if (options.bytes !== Array)
                    object.out_key = $util.newBuffer(object.out_key);
            }
            if (options.bytes === String)
                object.recv_deriv = "";
            else {
                object.recv_deriv = [];
                if (options.bytes !== Array)
                    object.recv_deriv = $util.newBuffer(object.recv_deriv);
            }
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.real_out_idx = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.real_out_idx = options.longs === String ? "0" : 0;
            object.sub_addr_major = 0;
            object.sub_addr_minor = 0;
        }
        if (message.out_key != null && message.hasOwnProperty("out_key"))
            object.out_key = options.bytes === String ? $util.base64.encode(message.out_key, 0, message.out_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.out_key) : message.out_key;
        if (message.recv_deriv != null && message.hasOwnProperty("recv_deriv"))
            object.recv_deriv = options.bytes === String ? $util.base64.encode(message.recv_deriv, 0, message.recv_deriv.length) : options.bytes === Array ? Array.prototype.slice.call(message.recv_deriv) : message.recv_deriv;
        if (message.real_out_idx != null && message.hasOwnProperty("real_out_idx"))
            if (typeof message.real_out_idx === "number")
                object.real_out_idx = options.longs === String ? String(message.real_out_idx) : message.real_out_idx;
            else
                object.real_out_idx = options.longs === String ? $util.Long.prototype.toString.call(message.real_out_idx) : options.longs === Number ? new $util.LongBits(message.real_out_idx.low >>> 0, message.real_out_idx.high >>> 0).toNumber(true) : message.real_out_idx;
        if (message.sub_addr_major != null && message.hasOwnProperty("sub_addr_major"))
            object.sub_addr_major = message.sub_addr_major;
        if (message.sub_addr_minor != null && message.hasOwnProperty("sub_addr_minor"))
            object.sub_addr_minor = message.sub_addr_minor;
        return object;
    };

    MoneroLiveRefreshStepRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoneroLiveRefreshStepRequest;
})();

$root.MoneroLiveRefreshStepAck = (function() {

    function MoneroLiveRefreshStepAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroLiveRefreshStepAck.prototype.salt = $util.newBuffer([]);
    MoneroLiveRefreshStepAck.prototype.key_image = $util.newBuffer([]);

    MoneroLiveRefreshStepAck.create = function create(properties) {
        return new MoneroLiveRefreshStepAck(properties);
    };

    MoneroLiveRefreshStepAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.salt != null && Object.hasOwnProperty.call(message, "salt"))
            writer.uint32(10).bytes(message.salt);
        if (message.key_image != null && Object.hasOwnProperty.call(message, "key_image"))
            writer.uint32(18).bytes(message.key_image);
        return writer;
    };

    MoneroLiveRefreshStepAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroLiveRefreshStepAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroLiveRefreshStepAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.salt = reader.bytes();
                break;
            case 2:
                message.key_image = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroLiveRefreshStepAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroLiveRefreshStepAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.salt != null && message.hasOwnProperty("salt"))
            if (!(message.salt && typeof message.salt.length === "number" || $util.isString(message.salt)))
                return "salt: buffer expected";
        if (message.key_image != null && message.hasOwnProperty("key_image"))
            if (!(message.key_image && typeof message.key_image.length === "number" || $util.isString(message.key_image)))
                return "key_image: buffer expected";
        return null;
    };

    MoneroLiveRefreshStepAck.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroLiveRefreshStepAck)
            return object;
        var message = new $root.MoneroLiveRefreshStepAck();
        if (object.salt != null)
            if (typeof object.salt === "string")
                $util.base64.decode(object.salt, message.salt = $util.newBuffer($util.base64.length(object.salt)), 0);
            else if (object.salt.length)
                message.salt = object.salt;
        if (object.key_image != null)
            if (typeof object.key_image === "string")
                $util.base64.decode(object.key_image, message.key_image = $util.newBuffer($util.base64.length(object.key_image)), 0);
            else if (object.key_image.length)
                message.key_image = object.key_image;
        return message;
    };

    MoneroLiveRefreshStepAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.salt = "";
            else {
                object.salt = [];
                if (options.bytes !== Array)
                    object.salt = $util.newBuffer(object.salt);
            }
            if (options.bytes === String)
                object.key_image = "";
            else {
                object.key_image = [];
                if (options.bytes !== Array)
                    object.key_image = $util.newBuffer(object.key_image);
            }
        }
        if (message.salt != null && message.hasOwnProperty("salt"))
            object.salt = options.bytes === String ? $util.base64.encode(message.salt, 0, message.salt.length) : options.bytes === Array ? Array.prototype.slice.call(message.salt) : message.salt;
        if (message.key_image != null && message.hasOwnProperty("key_image"))
            object.key_image = options.bytes === String ? $util.base64.encode(message.key_image, 0, message.key_image.length) : options.bytes === Array ? Array.prototype.slice.call(message.key_image) : message.key_image;
        return object;
    };

    MoneroLiveRefreshStepAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoneroLiveRefreshStepAck;
})();

$root.MoneroLiveRefreshFinalRequest = (function() {

    function MoneroLiveRefreshFinalRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroLiveRefreshFinalRequest.create = function create(properties) {
        return new MoneroLiveRefreshFinalRequest(properties);
    };

    MoneroLiveRefreshFinalRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    MoneroLiveRefreshFinalRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroLiveRefreshFinalRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroLiveRefreshFinalRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroLiveRefreshFinalRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroLiveRefreshFinalRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    MoneroLiveRefreshFinalRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroLiveRefreshFinalRequest)
            return object;
        return new $root.MoneroLiveRefreshFinalRequest();
    };

    MoneroLiveRefreshFinalRequest.toObject = function toObject() {
        return {};
    };

    MoneroLiveRefreshFinalRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoneroLiveRefreshFinalRequest;
})();

$root.MoneroLiveRefreshFinalAck = (function() {

    function MoneroLiveRefreshFinalAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroLiveRefreshFinalAck.create = function create(properties) {
        return new MoneroLiveRefreshFinalAck(properties);
    };

    MoneroLiveRefreshFinalAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    MoneroLiveRefreshFinalAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroLiveRefreshFinalAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroLiveRefreshFinalAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroLiveRefreshFinalAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroLiveRefreshFinalAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    MoneroLiveRefreshFinalAck.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroLiveRefreshFinalAck)
            return object;
        return new $root.MoneroLiveRefreshFinalAck();
    };

    MoneroLiveRefreshFinalAck.toObject = function toObject() {
        return {};
    };

    MoneroLiveRefreshFinalAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoneroLiveRefreshFinalAck;
})();

$root.DebugMoneroDiagRequest = (function() {

    function DebugMoneroDiagRequest(properties) {
        this.pd = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DebugMoneroDiagRequest.prototype.ins = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    DebugMoneroDiagRequest.prototype.p1 = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    DebugMoneroDiagRequest.prototype.p2 = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    DebugMoneroDiagRequest.prototype.pd = $util.emptyArray;
    DebugMoneroDiagRequest.prototype.data1 = $util.newBuffer([]);
    DebugMoneroDiagRequest.prototype.data2 = $util.newBuffer([]);

    DebugMoneroDiagRequest.create = function create(properties) {
        return new DebugMoneroDiagRequest(properties);
    };

    DebugMoneroDiagRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.ins != null && Object.hasOwnProperty.call(message, "ins"))
            writer.uint32(8).uint64(message.ins);
        if (message.p1 != null && Object.hasOwnProperty.call(message, "p1"))
            writer.uint32(16).uint64(message.p1);
        if (message.p2 != null && Object.hasOwnProperty.call(message, "p2"))
            writer.uint32(24).uint64(message.p2);
        if (message.pd != null && message.pd.length)
            for (var i = 0; i < message.pd.length; ++i)
                writer.uint32(32).uint64(message.pd[i]);
        if (message.data1 != null && Object.hasOwnProperty.call(message, "data1"))
            writer.uint32(42).bytes(message.data1);
        if (message.data2 != null && Object.hasOwnProperty.call(message, "data2"))
            writer.uint32(50).bytes(message.data2);
        return writer;
    };

    DebugMoneroDiagRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DebugMoneroDiagRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DebugMoneroDiagRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.ins = reader.uint64();
                break;
            case 2:
                message.p1 = reader.uint64();
                break;
            case 3:
                message.p2 = reader.uint64();
                break;
            case 4:
                if (!(message.pd && message.pd.length))
                    message.pd = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.pd.push(reader.uint64());
                } else
                    message.pd.push(reader.uint64());
                break;
            case 5:
                message.data1 = reader.bytes();
                break;
            case 6:
                message.data2 = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    DebugMoneroDiagRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DebugMoneroDiagRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.ins != null && message.hasOwnProperty("ins"))
            if (!$util.isInteger(message.ins) && !(message.ins && $util.isInteger(message.ins.low) && $util.isInteger(message.ins.high)))
                return "ins: integer|Long expected";
        if (message.p1 != null && message.hasOwnProperty("p1"))
            if (!$util.isInteger(message.p1) && !(message.p1 && $util.isInteger(message.p1.low) && $util.isInteger(message.p1.high)))
                return "p1: integer|Long expected";
        if (message.p2 != null && message.hasOwnProperty("p2"))
            if (!$util.isInteger(message.p2) && !(message.p2 && $util.isInteger(message.p2.low) && $util.isInteger(message.p2.high)))
                return "p2: integer|Long expected";
        if (message.pd != null && message.hasOwnProperty("pd")) {
            if (!Array.isArray(message.pd))
                return "pd: array expected";
            for (var i = 0; i < message.pd.length; ++i)
                if (!$util.isInteger(message.pd[i]) && !(message.pd[i] && $util.isInteger(message.pd[i].low) && $util.isInteger(message.pd[i].high)))
                    return "pd: integer|Long[] expected";
        }
        if (message.data1 != null && message.hasOwnProperty("data1"))
            if (!(message.data1 && typeof message.data1.length === "number" || $util.isString(message.data1)))
                return "data1: buffer expected";
        if (message.data2 != null && message.hasOwnProperty("data2"))
            if (!(message.data2 && typeof message.data2.length === "number" || $util.isString(message.data2)))
                return "data2: buffer expected";
        return null;
    };

    DebugMoneroDiagRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.DebugMoneroDiagRequest)
            return object;
        var message = new $root.DebugMoneroDiagRequest();
        if (object.ins != null)
            if ($util.Long)
                (message.ins = $util.Long.fromValue(object.ins)).unsigned = true;
            else if (typeof object.ins === "string")
                message.ins = parseInt(object.ins, 10);
            else if (typeof object.ins === "number")
                message.ins = object.ins;
            else if (typeof object.ins === "object")
                message.ins = new $util.LongBits(object.ins.low >>> 0, object.ins.high >>> 0).toNumber(true);
        if (object.p1 != null)
            if ($util.Long)
                (message.p1 = $util.Long.fromValue(object.p1)).unsigned = true;
            else if (typeof object.p1 === "string")
                message.p1 = parseInt(object.p1, 10);
            else if (typeof object.p1 === "number")
                message.p1 = object.p1;
            else if (typeof object.p1 === "object")
                message.p1 = new $util.LongBits(object.p1.low >>> 0, object.p1.high >>> 0).toNumber(true);
        if (object.p2 != null)
            if ($util.Long)
                (message.p2 = $util.Long.fromValue(object.p2)).unsigned = true;
            else if (typeof object.p2 === "string")
                message.p2 = parseInt(object.p2, 10);
            else if (typeof object.p2 === "number")
                message.p2 = object.p2;
            else if (typeof object.p2 === "object")
                message.p2 = new $util.LongBits(object.p2.low >>> 0, object.p2.high >>> 0).toNumber(true);
        if (object.pd) {
            if (!Array.isArray(object.pd))
                throw TypeError(".DebugMoneroDiagRequest.pd: array expected");
            message.pd = [];
            for (var i = 0; i < object.pd.length; ++i)
                if ($util.Long)
                    (message.pd[i] = $util.Long.fromValue(object.pd[i])).unsigned = true;
                else if (typeof object.pd[i] === "string")
                    message.pd[i] = parseInt(object.pd[i], 10);
                else if (typeof object.pd[i] === "number")
                    message.pd[i] = object.pd[i];
                else if (typeof object.pd[i] === "object")
                    message.pd[i] = new $util.LongBits(object.pd[i].low >>> 0, object.pd[i].high >>> 0).toNumber(true);
        }
        if (object.data1 != null)
            if (typeof object.data1 === "string")
                $util.base64.decode(object.data1, message.data1 = $util.newBuffer($util.base64.length(object.data1)), 0);
            else if (object.data1.length)
                message.data1 = object.data1;
        if (object.data2 != null)
            if (typeof object.data2 === "string")
                $util.base64.decode(object.data2, message.data2 = $util.newBuffer($util.base64.length(object.data2)), 0);
            else if (object.data2.length)
                message.data2 = object.data2;
        return message;
    };

    DebugMoneroDiagRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.pd = [];
        if (options.defaults) {
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.ins = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.ins = options.longs === String ? "0" : 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.p1 = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.p1 = options.longs === String ? "0" : 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.p2 = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.p2 = options.longs === String ? "0" : 0;
            if (options.bytes === String)
                object.data1 = "";
            else {
                object.data1 = [];
                if (options.bytes !== Array)
                    object.data1 = $util.newBuffer(object.data1);
            }
            if (options.bytes === String)
                object.data2 = "";
            else {
                object.data2 = [];
                if (options.bytes !== Array)
                    object.data2 = $util.newBuffer(object.data2);
            }
        }
        if (message.ins != null && message.hasOwnProperty("ins"))
            if (typeof message.ins === "number")
                object.ins = options.longs === String ? String(message.ins) : message.ins;
            else
                object.ins = options.longs === String ? $util.Long.prototype.toString.call(message.ins) : options.longs === Number ? new $util.LongBits(message.ins.low >>> 0, message.ins.high >>> 0).toNumber(true) : message.ins;
        if (message.p1 != null && message.hasOwnProperty("p1"))
            if (typeof message.p1 === "number")
                object.p1 = options.longs === String ? String(message.p1) : message.p1;
            else
                object.p1 = options.longs === String ? $util.Long.prototype.toString.call(message.p1) : options.longs === Number ? new $util.LongBits(message.p1.low >>> 0, message.p1.high >>> 0).toNumber(true) : message.p1;
        if (message.p2 != null && message.hasOwnProperty("p2"))
            if (typeof message.p2 === "number")
                object.p2 = options.longs === String ? String(message.p2) : message.p2;
            else
                object.p2 = options.longs === String ? $util.Long.prototype.toString.call(message.p2) : options.longs === Number ? new $util.LongBits(message.p2.low >>> 0, message.p2.high >>> 0).toNumber(true) : message.p2;
        if (message.pd && message.pd.length) {
            object.pd = [];
            for (var j = 0; j < message.pd.length; ++j)
                if (typeof message.pd[j] === "number")
                    object.pd[j] = options.longs === String ? String(message.pd[j]) : message.pd[j];
                else
                    object.pd[j] = options.longs === String ? $util.Long.prototype.toString.call(message.pd[j]) : options.longs === Number ? new $util.LongBits(message.pd[j].low >>> 0, message.pd[j].high >>> 0).toNumber(true) : message.pd[j];
        }
        if (message.data1 != null && message.hasOwnProperty("data1"))
            object.data1 = options.bytes === String ? $util.base64.encode(message.data1, 0, message.data1.length) : options.bytes === Array ? Array.prototype.slice.call(message.data1) : message.data1;
        if (message.data2 != null && message.hasOwnProperty("data2"))
            object.data2 = options.bytes === String ? $util.base64.encode(message.data2, 0, message.data2.length) : options.bytes === Array ? Array.prototype.slice.call(message.data2) : message.data2;
        return object;
    };

    DebugMoneroDiagRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DebugMoneroDiagRequest;
})();

$root.DebugMoneroDiagAck = (function() {

    function DebugMoneroDiagAck(properties) {
        this.pd = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DebugMoneroDiagAck.prototype.ins = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    DebugMoneroDiagAck.prototype.p1 = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    DebugMoneroDiagAck.prototype.p2 = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    DebugMoneroDiagAck.prototype.pd = $util.emptyArray;
    DebugMoneroDiagAck.prototype.data1 = $util.newBuffer([]);
    DebugMoneroDiagAck.prototype.data2 = $util.newBuffer([]);

    DebugMoneroDiagAck.create = function create(properties) {
        return new DebugMoneroDiagAck(properties);
    };

    DebugMoneroDiagAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.ins != null && Object.hasOwnProperty.call(message, "ins"))
            writer.uint32(8).uint64(message.ins);
        if (message.p1 != null && Object.hasOwnProperty.call(message, "p1"))
            writer.uint32(16).uint64(message.p1);
        if (message.p2 != null && Object.hasOwnProperty.call(message, "p2"))
            writer.uint32(24).uint64(message.p2);
        if (message.pd != null && message.pd.length)
            for (var i = 0; i < message.pd.length; ++i)
                writer.uint32(32).uint64(message.pd[i]);
        if (message.data1 != null && Object.hasOwnProperty.call(message, "data1"))
            writer.uint32(42).bytes(message.data1);
        if (message.data2 != null && Object.hasOwnProperty.call(message, "data2"))
            writer.uint32(50).bytes(message.data2);
        return writer;
    };

    DebugMoneroDiagAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DebugMoneroDiagAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DebugMoneroDiagAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.ins = reader.uint64();
                break;
            case 2:
                message.p1 = reader.uint64();
                break;
            case 3:
                message.p2 = reader.uint64();
                break;
            case 4:
                if (!(message.pd && message.pd.length))
                    message.pd = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.pd.push(reader.uint64());
                } else
                    message.pd.push(reader.uint64());
                break;
            case 5:
                message.data1 = reader.bytes();
                break;
            case 6:
                message.data2 = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    DebugMoneroDiagAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DebugMoneroDiagAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.ins != null && message.hasOwnProperty("ins"))
            if (!$util.isInteger(message.ins) && !(message.ins && $util.isInteger(message.ins.low) && $util.isInteger(message.ins.high)))
                return "ins: integer|Long expected";
        if (message.p1 != null && message.hasOwnProperty("p1"))
            if (!$util.isInteger(message.p1) && !(message.p1 && $util.isInteger(message.p1.low) && $util.isInteger(message.p1.high)))
                return "p1: integer|Long expected";
        if (message.p2 != null && message.hasOwnProperty("p2"))
            if (!$util.isInteger(message.p2) && !(message.p2 && $util.isInteger(message.p2.low) && $util.isInteger(message.p2.high)))
                return "p2: integer|Long expected";
        if (message.pd != null && message.hasOwnProperty("pd")) {
            if (!Array.isArray(message.pd))
                return "pd: array expected";
            for (var i = 0; i < message.pd.length; ++i)
                if (!$util.isInteger(message.pd[i]) && !(message.pd[i] && $util.isInteger(message.pd[i].low) && $util.isInteger(message.pd[i].high)))
                    return "pd: integer|Long[] expected";
        }
        if (message.data1 != null && message.hasOwnProperty("data1"))
            if (!(message.data1 && typeof message.data1.length === "number" || $util.isString(message.data1)))
                return "data1: buffer expected";
        if (message.data2 != null && message.hasOwnProperty("data2"))
            if (!(message.data2 && typeof message.data2.length === "number" || $util.isString(message.data2)))
                return "data2: buffer expected";
        return null;
    };

    DebugMoneroDiagAck.fromObject = function fromObject(object) {
        if (object instanceof $root.DebugMoneroDiagAck)
            return object;
        var message = new $root.DebugMoneroDiagAck();
        if (object.ins != null)
            if ($util.Long)
                (message.ins = $util.Long.fromValue(object.ins)).unsigned = true;
            else if (typeof object.ins === "string")
                message.ins = parseInt(object.ins, 10);
            else if (typeof object.ins === "number")
                message.ins = object.ins;
            else if (typeof object.ins === "object")
                message.ins = new $util.LongBits(object.ins.low >>> 0, object.ins.high >>> 0).toNumber(true);
        if (object.p1 != null)
            if ($util.Long)
                (message.p1 = $util.Long.fromValue(object.p1)).unsigned = true;
            else if (typeof object.p1 === "string")
                message.p1 = parseInt(object.p1, 10);
            else if (typeof object.p1 === "number")
                message.p1 = object.p1;
            else if (typeof object.p1 === "object")
                message.p1 = new $util.LongBits(object.p1.low >>> 0, object.p1.high >>> 0).toNumber(true);
        if (object.p2 != null)
            if ($util.Long)
                (message.p2 = $util.Long.fromValue(object.p2)).unsigned = true;
            else if (typeof object.p2 === "string")
                message.p2 = parseInt(object.p2, 10);
            else if (typeof object.p2 === "number")
                message.p2 = object.p2;
            else if (typeof object.p2 === "object")
                message.p2 = new $util.LongBits(object.p2.low >>> 0, object.p2.high >>> 0).toNumber(true);
        if (object.pd) {
            if (!Array.isArray(object.pd))
                throw TypeError(".DebugMoneroDiagAck.pd: array expected");
            message.pd = [];
            for (var i = 0; i < object.pd.length; ++i)
                if ($util.Long)
                    (message.pd[i] = $util.Long.fromValue(object.pd[i])).unsigned = true;
                else if (typeof object.pd[i] === "string")
                    message.pd[i] = parseInt(object.pd[i], 10);
                else if (typeof object.pd[i] === "number")
                    message.pd[i] = object.pd[i];
                else if (typeof object.pd[i] === "object")
                    message.pd[i] = new $util.LongBits(object.pd[i].low >>> 0, object.pd[i].high >>> 0).toNumber(true);
        }
        if (object.data1 != null)
            if (typeof object.data1 === "string")
                $util.base64.decode(object.data1, message.data1 = $util.newBuffer($util.base64.length(object.data1)), 0);
            else if (object.data1.length)
                message.data1 = object.data1;
        if (object.data2 != null)
            if (typeof object.data2 === "string")
                $util.base64.decode(object.data2, message.data2 = $util.newBuffer($util.base64.length(object.data2)), 0);
            else if (object.data2.length)
                message.data2 = object.data2;
        return message;
    };

    DebugMoneroDiagAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.pd = [];
        if (options.defaults) {
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.ins = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.ins = options.longs === String ? "0" : 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.p1 = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.p1 = options.longs === String ? "0" : 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.p2 = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.p2 = options.longs === String ? "0" : 0;
            if (options.bytes === String)
                object.data1 = "";
            else {
                object.data1 = [];
                if (options.bytes !== Array)
                    object.data1 = $util.newBuffer(object.data1);
            }
            if (options.bytes === String)
                object.data2 = "";
            else {
                object.data2 = [];
                if (options.bytes !== Array)
                    object.data2 = $util.newBuffer(object.data2);
            }
        }
        if (message.ins != null && message.hasOwnProperty("ins"))
            if (typeof message.ins === "number")
                object.ins = options.longs === String ? String(message.ins) : message.ins;
            else
                object.ins = options.longs === String ? $util.Long.prototype.toString.call(message.ins) : options.longs === Number ? new $util.LongBits(message.ins.low >>> 0, message.ins.high >>> 0).toNumber(true) : message.ins;
        if (message.p1 != null && message.hasOwnProperty("p1"))
            if (typeof message.p1 === "number")
                object.p1 = options.longs === String ? String(message.p1) : message.p1;
            else
                object.p1 = options.longs === String ? $util.Long.prototype.toString.call(message.p1) : options.longs === Number ? new $util.LongBits(message.p1.low >>> 0, message.p1.high >>> 0).toNumber(true) : message.p1;
        if (message.p2 != null && message.hasOwnProperty("p2"))
            if (typeof message.p2 === "number")
                object.p2 = options.longs === String ? String(message.p2) : message.p2;
            else
                object.p2 = options.longs === String ? $util.Long.prototype.toString.call(message.p2) : options.longs === Number ? new $util.LongBits(message.p2.low >>> 0, message.p2.high >>> 0).toNumber(true) : message.p2;
        if (message.pd && message.pd.length) {
            object.pd = [];
            for (var j = 0; j < message.pd.length; ++j)
                if (typeof message.pd[j] === "number")
                    object.pd[j] = options.longs === String ? String(message.pd[j]) : message.pd[j];
                else
                    object.pd[j] = options.longs === String ? $util.Long.prototype.toString.call(message.pd[j]) : options.longs === Number ? new $util.LongBits(message.pd[j].low >>> 0, message.pd[j].high >>> 0).toNumber(true) : message.pd[j];
        }
        if (message.data1 != null && message.hasOwnProperty("data1"))
            object.data1 = options.bytes === String ? $util.base64.encode(message.data1, 0, message.data1.length) : options.bytes === Array ? Array.prototype.slice.call(message.data1) : message.data1;
        if (message.data2 != null && message.hasOwnProperty("data2"))
            object.data2 = options.bytes === String ? $util.base64.encode(message.data2, 0, message.data2.length) : options.bytes === Array ? Array.prototype.slice.call(message.data2) : message.data2;
        return object;
    };

    DebugMoneroDiagAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DebugMoneroDiagAck;
})();

$root.NearGetAddress = (function() {

    function NearGetAddress(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NearGetAddress.prototype.address_n = $util.emptyArray;
    NearGetAddress.prototype.show_display = false;

    NearGetAddress.create = function create(properties) {
        return new NearGetAddress(properties);
    };

    NearGetAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(16).bool(message.show_display);
        return writer;
    };

    NearGetAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NearGetAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NearGetAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.show_display = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    NearGetAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NearGetAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        return null;
    };

    NearGetAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.NearGetAddress)
            return object;
        var message = new $root.NearGetAddress();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".NearGetAddress.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        return message;
    };

    NearGetAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            object.show_display = false;
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        return object;
    };

    NearGetAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NearGetAddress;
})();

$root.NearAddress = (function() {

    function NearAddress(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NearAddress.prototype.address = "";

    NearAddress.create = function create(properties) {
        return new NearAddress(properties);
    };

    NearAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address != null && Object.hasOwnProperty.call(message, "address"))
            writer.uint32(10).string(message.address);
        return writer;
    };

    NearAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NearAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NearAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    NearAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NearAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address != null && message.hasOwnProperty("address"))
            if (!$util.isString(message.address))
                return "address: string expected";
        return null;
    };

    NearAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.NearAddress)
            return object;
        var message = new $root.NearAddress();
        if (object.address != null)
            message.address = String(object.address);
        return message;
    };

    NearAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.address = "";
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    NearAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NearAddress;
})();

$root.NearSignTx = (function() {

    function NearSignTx(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NearSignTx.prototype.address_n = $util.emptyArray;
    NearSignTx.prototype.raw_tx = $util.newBuffer([]);

    NearSignTx.create = function create(properties) {
        return new NearSignTx(properties);
    };

    NearSignTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).bytes(message.raw_tx);
        return writer;
    };

    NearSignTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NearSignTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NearSignTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.raw_tx = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("raw_tx"))
            throw $util.ProtocolError("missing required 'raw_tx'", { instance: message });
        return message;
    };

    NearSignTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NearSignTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!(message.raw_tx && typeof message.raw_tx.length === "number" || $util.isString(message.raw_tx)))
            return "raw_tx: buffer expected";
        return null;
    };

    NearSignTx.fromObject = function fromObject(object) {
        if (object instanceof $root.NearSignTx)
            return object;
        var message = new $root.NearSignTx();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".NearSignTx.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.raw_tx != null)
            if (typeof object.raw_tx === "string")
                $util.base64.decode(object.raw_tx, message.raw_tx = $util.newBuffer($util.base64.length(object.raw_tx)), 0);
            else if (object.raw_tx.length)
                message.raw_tx = object.raw_tx;
        return message;
    };

    NearSignTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            if (options.bytes === String)
                object.raw_tx = "";
            else {
                object.raw_tx = [];
                if (options.bytes !== Array)
                    object.raw_tx = $util.newBuffer(object.raw_tx);
            }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.raw_tx != null && message.hasOwnProperty("raw_tx"))
            object.raw_tx = options.bytes === String ? $util.base64.encode(message.raw_tx, 0, message.raw_tx.length) : options.bytes === Array ? Array.prototype.slice.call(message.raw_tx) : message.raw_tx;
        return object;
    };

    NearSignTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NearSignTx;
})();

$root.NearSignedTx = (function() {

    function NearSignedTx(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NearSignedTx.prototype.signature = $util.newBuffer([]);

    NearSignedTx.create = function create(properties) {
        return new NearSignedTx(properties);
    };

    NearSignedTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.signature);
        return writer;
    };

    NearSignedTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NearSignedTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NearSignedTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.signature = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        return message;
    };

    NearSignedTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NearSignedTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        return null;
    };

    NearSignedTx.fromObject = function fromObject(object) {
        if (object instanceof $root.NearSignedTx)
            return object;
        var message = new $root.NearSignedTx();
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        return message;
    };

    NearSignedTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        return object;
    };

    NearSignedTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NearSignedTx;
})();

$root.NEMGetAddress = (function() {

    function NEMGetAddress(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NEMGetAddress.prototype.address_n = $util.emptyArray;
    NEMGetAddress.prototype.network = 0;
    NEMGetAddress.prototype.show_display = false;

    NEMGetAddress.create = function create(properties) {
        return new NEMGetAddress(properties);
    };

    NEMGetAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.network != null && Object.hasOwnProperty.call(message, "network"))
            writer.uint32(16).uint32(message.network);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(24).bool(message.show_display);
        return writer;
    };

    NEMGetAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NEMGetAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NEMGetAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.network = reader.uint32();
                break;
            case 3:
                message.show_display = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    NEMGetAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NEMGetAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.network != null && message.hasOwnProperty("network"))
            if (!$util.isInteger(message.network))
                return "network: integer expected";
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        return null;
    };

    NEMGetAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.NEMGetAddress)
            return object;
        var message = new $root.NEMGetAddress();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".NEMGetAddress.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.network != null)
            message.network = object.network >>> 0;
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        return message;
    };

    NEMGetAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            object.network = 0;
            object.show_display = false;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.network != null && message.hasOwnProperty("network"))
            object.network = message.network;
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        return object;
    };

    NEMGetAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NEMGetAddress;
})();

$root.NEMAddress = (function() {

    function NEMAddress(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NEMAddress.prototype.address = "";

    NEMAddress.create = function create(properties) {
        return new NEMAddress(properties);
    };

    NEMAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.address);
        return writer;
    };

    NEMAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NEMAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NEMAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("address"))
            throw $util.ProtocolError("missing required 'address'", { instance: message });
        return message;
    };

    NEMAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NEMAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.address))
            return "address: string expected";
        return null;
    };

    NEMAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.NEMAddress)
            return object;
        var message = new $root.NEMAddress();
        if (object.address != null)
            message.address = String(object.address);
        return message;
    };

    NEMAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.address = "";
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    NEMAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NEMAddress;
})();

$root.NEMSignTx = (function() {

    function NEMSignTx(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NEMSignTx.prototype.transaction = null;
    NEMSignTx.prototype.multisig = null;
    NEMSignTx.prototype.transfer = null;
    NEMSignTx.prototype.cosigning = false;
    NEMSignTx.prototype.provision_namespace = null;
    NEMSignTx.prototype.mosaic_creation = null;
    NEMSignTx.prototype.supply_change = null;
    NEMSignTx.prototype.aggregate_modification = null;
    NEMSignTx.prototype.importance_transfer = null;

    NEMSignTx.create = function create(properties) {
        return new NEMSignTx(properties);
    };

    NEMSignTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.transaction != null && Object.hasOwnProperty.call(message, "transaction"))
            $root.NEMSignTx.NEMTransactionCommon.encode(message.transaction, writer.uint32(10).fork()).ldelim();
        if (message.multisig != null && Object.hasOwnProperty.call(message, "multisig"))
            $root.NEMSignTx.NEMTransactionCommon.encode(message.multisig, writer.uint32(18).fork()).ldelim();
        if (message.transfer != null && Object.hasOwnProperty.call(message, "transfer"))
            $root.NEMSignTx.NEMTransfer.encode(message.transfer, writer.uint32(26).fork()).ldelim();
        if (message.cosigning != null && Object.hasOwnProperty.call(message, "cosigning"))
            writer.uint32(32).bool(message.cosigning);
        if (message.provision_namespace != null && Object.hasOwnProperty.call(message, "provision_namespace"))
            $root.NEMSignTx.NEMProvisionNamespace.encode(message.provision_namespace, writer.uint32(42).fork()).ldelim();
        if (message.mosaic_creation != null && Object.hasOwnProperty.call(message, "mosaic_creation"))
            $root.NEMSignTx.NEMMosaicCreation.encode(message.mosaic_creation, writer.uint32(50).fork()).ldelim();
        if (message.supply_change != null && Object.hasOwnProperty.call(message, "supply_change"))
            $root.NEMSignTx.NEMMosaicSupplyChange.encode(message.supply_change, writer.uint32(58).fork()).ldelim();
        if (message.aggregate_modification != null && Object.hasOwnProperty.call(message, "aggregate_modification"))
            $root.NEMSignTx.NEMAggregateModification.encode(message.aggregate_modification, writer.uint32(66).fork()).ldelim();
        if (message.importance_transfer != null && Object.hasOwnProperty.call(message, "importance_transfer"))
            $root.NEMSignTx.NEMImportanceTransfer.encode(message.importance_transfer, writer.uint32(74).fork()).ldelim();
        return writer;
    };

    NEMSignTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NEMSignTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NEMSignTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.transaction = $root.NEMSignTx.NEMTransactionCommon.decode(reader, reader.uint32());
                break;
            case 2:
                message.multisig = $root.NEMSignTx.NEMTransactionCommon.decode(reader, reader.uint32());
                break;
            case 3:
                message.transfer = $root.NEMSignTx.NEMTransfer.decode(reader, reader.uint32());
                break;
            case 4:
                message.cosigning = reader.bool();
                break;
            case 5:
                message.provision_namespace = $root.NEMSignTx.NEMProvisionNamespace.decode(reader, reader.uint32());
                break;
            case 6:
                message.mosaic_creation = $root.NEMSignTx.NEMMosaicCreation.decode(reader, reader.uint32());
                break;
            case 7:
                message.supply_change = $root.NEMSignTx.NEMMosaicSupplyChange.decode(reader, reader.uint32());
                break;
            case 8:
                message.aggregate_modification = $root.NEMSignTx.NEMAggregateModification.decode(reader, reader.uint32());
                break;
            case 9:
                message.importance_transfer = $root.NEMSignTx.NEMImportanceTransfer.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    NEMSignTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NEMSignTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.transaction != null && message.hasOwnProperty("transaction")) {
            var error = $root.NEMSignTx.NEMTransactionCommon.verify(message.transaction);
            if (error)
                return "transaction." + error;
        }
        if (message.multisig != null && message.hasOwnProperty("multisig")) {
            var error = $root.NEMSignTx.NEMTransactionCommon.verify(message.multisig);
            if (error)
                return "multisig." + error;
        }
        if (message.transfer != null && message.hasOwnProperty("transfer")) {
            var error = $root.NEMSignTx.NEMTransfer.verify(message.transfer);
            if (error)
                return "transfer." + error;
        }
        if (message.cosigning != null && message.hasOwnProperty("cosigning"))
            if (typeof message.cosigning !== "boolean")
                return "cosigning: boolean expected";
        if (message.provision_namespace != null && message.hasOwnProperty("provision_namespace")) {
            var error = $root.NEMSignTx.NEMProvisionNamespace.verify(message.provision_namespace);
            if (error)
                return "provision_namespace." + error;
        }
        if (message.mosaic_creation != null && message.hasOwnProperty("mosaic_creation")) {
            var error = $root.NEMSignTx.NEMMosaicCreation.verify(message.mosaic_creation);
            if (error)
                return "mosaic_creation." + error;
        }
        if (message.supply_change != null && message.hasOwnProperty("supply_change")) {
            var error = $root.NEMSignTx.NEMMosaicSupplyChange.verify(message.supply_change);
            if (error)
                return "supply_change." + error;
        }
        if (message.aggregate_modification != null && message.hasOwnProperty("aggregate_modification")) {
            var error = $root.NEMSignTx.NEMAggregateModification.verify(message.aggregate_modification);
            if (error)
                return "aggregate_modification." + error;
        }
        if (message.importance_transfer != null && message.hasOwnProperty("importance_transfer")) {
            var error = $root.NEMSignTx.NEMImportanceTransfer.verify(message.importance_transfer);
            if (error)
                return "importance_transfer." + error;
        }
        return null;
    };

    NEMSignTx.fromObject = function fromObject(object) {
        if (object instanceof $root.NEMSignTx)
            return object;
        var message = new $root.NEMSignTx();
        if (object.transaction != null) {
            if (typeof object.transaction !== "object")
                throw TypeError(".NEMSignTx.transaction: object expected");
            message.transaction = $root.NEMSignTx.NEMTransactionCommon.fromObject(object.transaction);
        }
        if (object.multisig != null) {
            if (typeof object.multisig !== "object")
                throw TypeError(".NEMSignTx.multisig: object expected");
            message.multisig = $root.NEMSignTx.NEMTransactionCommon.fromObject(object.multisig);
        }
        if (object.transfer != null) {
            if (typeof object.transfer !== "object")
                throw TypeError(".NEMSignTx.transfer: object expected");
            message.transfer = $root.NEMSignTx.NEMTransfer.fromObject(object.transfer);
        }
        if (object.cosigning != null)
            message.cosigning = Boolean(object.cosigning);
        if (object.provision_namespace != null) {
            if (typeof object.provision_namespace !== "object")
                throw TypeError(".NEMSignTx.provision_namespace: object expected");
            message.provision_namespace = $root.NEMSignTx.NEMProvisionNamespace.fromObject(object.provision_namespace);
        }
        if (object.mosaic_creation != null) {
            if (typeof object.mosaic_creation !== "object")
                throw TypeError(".NEMSignTx.mosaic_creation: object expected");
            message.mosaic_creation = $root.NEMSignTx.NEMMosaicCreation.fromObject(object.mosaic_creation);
        }
        if (object.supply_change != null) {
            if (typeof object.supply_change !== "object")
                throw TypeError(".NEMSignTx.supply_change: object expected");
            message.supply_change = $root.NEMSignTx.NEMMosaicSupplyChange.fromObject(object.supply_change);
        }
        if (object.aggregate_modification != null) {
            if (typeof object.aggregate_modification !== "object")
                throw TypeError(".NEMSignTx.aggregate_modification: object expected");
            message.aggregate_modification = $root.NEMSignTx.NEMAggregateModification.fromObject(object.aggregate_modification);
        }
        if (object.importance_transfer != null) {
            if (typeof object.importance_transfer !== "object")
                throw TypeError(".NEMSignTx.importance_transfer: object expected");
            message.importance_transfer = $root.NEMSignTx.NEMImportanceTransfer.fromObject(object.importance_transfer);
        }
        return message;
    };

    NEMSignTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.transaction = null;
            object.multisig = null;
            object.transfer = null;
            object.cosigning = false;
            object.provision_namespace = null;
            object.mosaic_creation = null;
            object.supply_change = null;
            object.aggregate_modification = null;
            object.importance_transfer = null;
        }
        if (message.transaction != null && message.hasOwnProperty("transaction"))
            object.transaction = $root.NEMSignTx.NEMTransactionCommon.toObject(message.transaction, options);
        if (message.multisig != null && message.hasOwnProperty("multisig"))
            object.multisig = $root.NEMSignTx.NEMTransactionCommon.toObject(message.multisig, options);
        if (message.transfer != null && message.hasOwnProperty("transfer"))
            object.transfer = $root.NEMSignTx.NEMTransfer.toObject(message.transfer, options);
        if (message.cosigning != null && message.hasOwnProperty("cosigning"))
            object.cosigning = message.cosigning;
        if (message.provision_namespace != null && message.hasOwnProperty("provision_namespace"))
            object.provision_namespace = $root.NEMSignTx.NEMProvisionNamespace.toObject(message.provision_namespace, options);
        if (message.mosaic_creation != null && message.hasOwnProperty("mosaic_creation"))
            object.mosaic_creation = $root.NEMSignTx.NEMMosaicCreation.toObject(message.mosaic_creation, options);
        if (message.supply_change != null && message.hasOwnProperty("supply_change"))
            object.supply_change = $root.NEMSignTx.NEMMosaicSupplyChange.toObject(message.supply_change, options);
        if (message.aggregate_modification != null && message.hasOwnProperty("aggregate_modification"))
            object.aggregate_modification = $root.NEMSignTx.NEMAggregateModification.toObject(message.aggregate_modification, options);
        if (message.importance_transfer != null && message.hasOwnProperty("importance_transfer"))
            object.importance_transfer = $root.NEMSignTx.NEMImportanceTransfer.toObject(message.importance_transfer, options);
        return object;
    };

    NEMSignTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    NEMSignTx.NEMTransactionCommon = (function() {

        function NEMTransactionCommon(properties) {
            this.address_n = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        NEMTransactionCommon.prototype.address_n = $util.emptyArray;
        NEMTransactionCommon.prototype.network = 0;
        NEMTransactionCommon.prototype.timestamp = 0;
        NEMTransactionCommon.prototype.fee = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        NEMTransactionCommon.prototype.deadline = 0;
        NEMTransactionCommon.prototype.signer = $util.newBuffer([]);

        NEMTransactionCommon.create = function create(properties) {
            return new NEMTransactionCommon(properties);
        };

        NEMTransactionCommon.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.address_n != null && message.address_n.length)
                for (var i = 0; i < message.address_n.length; ++i)
                    writer.uint32(8).uint32(message.address_n[i]);
            if (message.network != null && Object.hasOwnProperty.call(message, "network"))
                writer.uint32(16).uint32(message.network);
            if (message.timestamp != null && Object.hasOwnProperty.call(message, "timestamp"))
                writer.uint32(24).uint32(message.timestamp);
            if (message.fee != null && Object.hasOwnProperty.call(message, "fee"))
                writer.uint32(32).uint64(message.fee);
            if (message.deadline != null && Object.hasOwnProperty.call(message, "deadline"))
                writer.uint32(40).uint32(message.deadline);
            if (message.signer != null && Object.hasOwnProperty.call(message, "signer"))
                writer.uint32(50).bytes(message.signer);
            return writer;
        };

        NEMTransactionCommon.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        NEMTransactionCommon.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NEMSignTx.NEMTransactionCommon();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.address_n && message.address_n.length))
                        message.address_n = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.address_n.push(reader.uint32());
                    } else
                        message.address_n.push(reader.uint32());
                    break;
                case 2:
                    message.network = reader.uint32();
                    break;
                case 3:
                    message.timestamp = reader.uint32();
                    break;
                case 4:
                    message.fee = reader.uint64();
                    break;
                case 5:
                    message.deadline = reader.uint32();
                    break;
                case 6:
                    message.signer = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        NEMTransactionCommon.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        NEMTransactionCommon.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.address_n != null && message.hasOwnProperty("address_n")) {
                if (!Array.isArray(message.address_n))
                    return "address_n: array expected";
                for (var i = 0; i < message.address_n.length; ++i)
                    if (!$util.isInteger(message.address_n[i]))
                        return "address_n: integer[] expected";
            }
            if (message.network != null && message.hasOwnProperty("network"))
                if (!$util.isInteger(message.network))
                    return "network: integer expected";
            if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                if (!$util.isInteger(message.timestamp))
                    return "timestamp: integer expected";
            if (message.fee != null && message.hasOwnProperty("fee"))
                if (!$util.isInteger(message.fee) && !(message.fee && $util.isInteger(message.fee.low) && $util.isInteger(message.fee.high)))
                    return "fee: integer|Long expected";
            if (message.deadline != null && message.hasOwnProperty("deadline"))
                if (!$util.isInteger(message.deadline))
                    return "deadline: integer expected";
            if (message.signer != null && message.hasOwnProperty("signer"))
                if (!(message.signer && typeof message.signer.length === "number" || $util.isString(message.signer)))
                    return "signer: buffer expected";
            return null;
        };

        NEMTransactionCommon.fromObject = function fromObject(object) {
            if (object instanceof $root.NEMSignTx.NEMTransactionCommon)
                return object;
            var message = new $root.NEMSignTx.NEMTransactionCommon();
            if (object.address_n) {
                if (!Array.isArray(object.address_n))
                    throw TypeError(".NEMSignTx.NEMTransactionCommon.address_n: array expected");
                message.address_n = [];
                for (var i = 0; i < object.address_n.length; ++i)
                    message.address_n[i] = object.address_n[i] >>> 0;
            }
            if (object.network != null)
                message.network = object.network >>> 0;
            if (object.timestamp != null)
                message.timestamp = object.timestamp >>> 0;
            if (object.fee != null)
                if ($util.Long)
                    (message.fee = $util.Long.fromValue(object.fee)).unsigned = true;
                else if (typeof object.fee === "string")
                    message.fee = parseInt(object.fee, 10);
                else if (typeof object.fee === "number")
                    message.fee = object.fee;
                else if (typeof object.fee === "object")
                    message.fee = new $util.LongBits(object.fee.low >>> 0, object.fee.high >>> 0).toNumber(true);
            if (object.deadline != null)
                message.deadline = object.deadline >>> 0;
            if (object.signer != null)
                if (typeof object.signer === "string")
                    $util.base64.decode(object.signer, message.signer = $util.newBuffer($util.base64.length(object.signer)), 0);
                else if (object.signer.length)
                    message.signer = object.signer;
            return message;
        };

        NEMTransactionCommon.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.address_n = [];
            if (options.defaults) {
                object.network = 0;
                object.timestamp = 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.fee = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.fee = options.longs === String ? "0" : 0;
                object.deadline = 0;
                if (options.bytes === String)
                    object.signer = "";
                else {
                    object.signer = [];
                    if (options.bytes !== Array)
                        object.signer = $util.newBuffer(object.signer);
                }
            }
            if (message.address_n && message.address_n.length) {
                object.address_n = [];
                for (var j = 0; j < message.address_n.length; ++j)
                    object.address_n[j] = message.address_n[j];
            }
            if (message.network != null && message.hasOwnProperty("network"))
                object.network = message.network;
            if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                object.timestamp = message.timestamp;
            if (message.fee != null && message.hasOwnProperty("fee"))
                if (typeof message.fee === "number")
                    object.fee = options.longs === String ? String(message.fee) : message.fee;
                else
                    object.fee = options.longs === String ? $util.Long.prototype.toString.call(message.fee) : options.longs === Number ? new $util.LongBits(message.fee.low >>> 0, message.fee.high >>> 0).toNumber(true) : message.fee;
            if (message.deadline != null && message.hasOwnProperty("deadline"))
                object.deadline = message.deadline;
            if (message.signer != null && message.hasOwnProperty("signer"))
                object.signer = options.bytes === String ? $util.base64.encode(message.signer, 0, message.signer.length) : options.bytes === Array ? Array.prototype.slice.call(message.signer) : message.signer;
            return object;
        };

        NEMTransactionCommon.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return NEMTransactionCommon;
    })();

    NEMSignTx.NEMTransfer = (function() {

        function NEMTransfer(properties) {
            this.mosaics = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        NEMTransfer.prototype.recipient = "";
        NEMTransfer.prototype.amount = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        NEMTransfer.prototype.payload = $util.newBuffer([]);
        NEMTransfer.prototype.public_key = $util.newBuffer([]);
        NEMTransfer.prototype.mosaics = $util.emptyArray;

        NEMTransfer.create = function create(properties) {
            return new NEMTransfer(properties);
        };

        NEMTransfer.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.recipient != null && Object.hasOwnProperty.call(message, "recipient"))
                writer.uint32(10).string(message.recipient);
            if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
                writer.uint32(16).uint64(message.amount);
            if (message.payload != null && Object.hasOwnProperty.call(message, "payload"))
                writer.uint32(26).bytes(message.payload);
            if (message.public_key != null && Object.hasOwnProperty.call(message, "public_key"))
                writer.uint32(34).bytes(message.public_key);
            if (message.mosaics != null && message.mosaics.length)
                for (var i = 0; i < message.mosaics.length; ++i)
                    $root.NEMSignTx.NEMTransfer.NEMMosaic.encode(message.mosaics[i], writer.uint32(42).fork()).ldelim();
            return writer;
        };

        NEMTransfer.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        NEMTransfer.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NEMSignTx.NEMTransfer();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.recipient = reader.string();
                    break;
                case 2:
                    message.amount = reader.uint64();
                    break;
                case 3:
                    message.payload = reader.bytes();
                    break;
                case 4:
                    message.public_key = reader.bytes();
                    break;
                case 5:
                    if (!(message.mosaics && message.mosaics.length))
                        message.mosaics = [];
                    message.mosaics.push($root.NEMSignTx.NEMTransfer.NEMMosaic.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        NEMTransfer.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        NEMTransfer.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.recipient != null && message.hasOwnProperty("recipient"))
                if (!$util.isString(message.recipient))
                    return "recipient: string expected";
            if (message.amount != null && message.hasOwnProperty("amount"))
                if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
                    return "amount: integer|Long expected";
            if (message.payload != null && message.hasOwnProperty("payload"))
                if (!(message.payload && typeof message.payload.length === "number" || $util.isString(message.payload)))
                    return "payload: buffer expected";
            if (message.public_key != null && message.hasOwnProperty("public_key"))
                if (!(message.public_key && typeof message.public_key.length === "number" || $util.isString(message.public_key)))
                    return "public_key: buffer expected";
            if (message.mosaics != null && message.hasOwnProperty("mosaics")) {
                if (!Array.isArray(message.mosaics))
                    return "mosaics: array expected";
                for (var i = 0; i < message.mosaics.length; ++i) {
                    var error = $root.NEMSignTx.NEMTransfer.NEMMosaic.verify(message.mosaics[i]);
                    if (error)
                        return "mosaics." + error;
                }
            }
            return null;
        };

        NEMTransfer.fromObject = function fromObject(object) {
            if (object instanceof $root.NEMSignTx.NEMTransfer)
                return object;
            var message = new $root.NEMSignTx.NEMTransfer();
            if (object.recipient != null)
                message.recipient = String(object.recipient);
            if (object.amount != null)
                if ($util.Long)
                    (message.amount = $util.Long.fromValue(object.amount)).unsigned = true;
                else if (typeof object.amount === "string")
                    message.amount = parseInt(object.amount, 10);
                else if (typeof object.amount === "number")
                    message.amount = object.amount;
                else if (typeof object.amount === "object")
                    message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber(true);
            if (object.payload != null)
                if (typeof object.payload === "string")
                    $util.base64.decode(object.payload, message.payload = $util.newBuffer($util.base64.length(object.payload)), 0);
                else if (object.payload.length)
                    message.payload = object.payload;
            if (object.public_key != null)
                if (typeof object.public_key === "string")
                    $util.base64.decode(object.public_key, message.public_key = $util.newBuffer($util.base64.length(object.public_key)), 0);
                else if (object.public_key.length)
                    message.public_key = object.public_key;
            if (object.mosaics) {
                if (!Array.isArray(object.mosaics))
                    throw TypeError(".NEMSignTx.NEMTransfer.mosaics: array expected");
                message.mosaics = [];
                for (var i = 0; i < object.mosaics.length; ++i) {
                    if (typeof object.mosaics[i] !== "object")
                        throw TypeError(".NEMSignTx.NEMTransfer.mosaics: object expected");
                    message.mosaics[i] = $root.NEMSignTx.NEMTransfer.NEMMosaic.fromObject(object.mosaics[i]);
                }
            }
            return message;
        };

        NEMTransfer.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.mosaics = [];
            if (options.defaults) {
                object.recipient = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.amount = options.longs === String ? "0" : 0;
                if (options.bytes === String)
                    object.payload = "";
                else {
                    object.payload = [];
                    if (options.bytes !== Array)
                        object.payload = $util.newBuffer(object.payload);
                }
                if (options.bytes === String)
                    object.public_key = "";
                else {
                    object.public_key = [];
                    if (options.bytes !== Array)
                        object.public_key = $util.newBuffer(object.public_key);
                }
            }
            if (message.recipient != null && message.hasOwnProperty("recipient"))
                object.recipient = message.recipient;
            if (message.amount != null && message.hasOwnProperty("amount"))
                if (typeof message.amount === "number")
                    object.amount = options.longs === String ? String(message.amount) : message.amount;
                else
                    object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber(true) : message.amount;
            if (message.payload != null && message.hasOwnProperty("payload"))
                object.payload = options.bytes === String ? $util.base64.encode(message.payload, 0, message.payload.length) : options.bytes === Array ? Array.prototype.slice.call(message.payload) : message.payload;
            if (message.public_key != null && message.hasOwnProperty("public_key"))
                object.public_key = options.bytes === String ? $util.base64.encode(message.public_key, 0, message.public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.public_key) : message.public_key;
            if (message.mosaics && message.mosaics.length) {
                object.mosaics = [];
                for (var j = 0; j < message.mosaics.length; ++j)
                    object.mosaics[j] = $root.NEMSignTx.NEMTransfer.NEMMosaic.toObject(message.mosaics[j], options);
            }
            return object;
        };

        NEMTransfer.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        NEMTransfer.NEMMosaic = (function() {

            function NEMMosaic(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            NEMMosaic.prototype.namespace = "";
            NEMMosaic.prototype.mosaic = "";
            NEMMosaic.prototype.quantity = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

            NEMMosaic.create = function create(properties) {
                return new NEMMosaic(properties);
            };

            NEMMosaic.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.namespace != null && Object.hasOwnProperty.call(message, "namespace"))
                    writer.uint32(10).string(message.namespace);
                if (message.mosaic != null && Object.hasOwnProperty.call(message, "mosaic"))
                    writer.uint32(18).string(message.mosaic);
                if (message.quantity != null && Object.hasOwnProperty.call(message, "quantity"))
                    writer.uint32(24).uint64(message.quantity);
                return writer;
            };

            NEMMosaic.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            NEMMosaic.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NEMSignTx.NEMTransfer.NEMMosaic();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.namespace = reader.string();
                        break;
                    case 2:
                        message.mosaic = reader.string();
                        break;
                    case 3:
                        message.quantity = reader.uint64();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            NEMMosaic.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            NEMMosaic.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.namespace != null && message.hasOwnProperty("namespace"))
                    if (!$util.isString(message.namespace))
                        return "namespace: string expected";
                if (message.mosaic != null && message.hasOwnProperty("mosaic"))
                    if (!$util.isString(message.mosaic))
                        return "mosaic: string expected";
                if (message.quantity != null && message.hasOwnProperty("quantity"))
                    if (!$util.isInteger(message.quantity) && !(message.quantity && $util.isInteger(message.quantity.low) && $util.isInteger(message.quantity.high)))
                        return "quantity: integer|Long expected";
                return null;
            };

            NEMMosaic.fromObject = function fromObject(object) {
                if (object instanceof $root.NEMSignTx.NEMTransfer.NEMMosaic)
                    return object;
                var message = new $root.NEMSignTx.NEMTransfer.NEMMosaic();
                if (object.namespace != null)
                    message.namespace = String(object.namespace);
                if (object.mosaic != null)
                    message.mosaic = String(object.mosaic);
                if (object.quantity != null)
                    if ($util.Long)
                        (message.quantity = $util.Long.fromValue(object.quantity)).unsigned = true;
                    else if (typeof object.quantity === "string")
                        message.quantity = parseInt(object.quantity, 10);
                    else if (typeof object.quantity === "number")
                        message.quantity = object.quantity;
                    else if (typeof object.quantity === "object")
                        message.quantity = new $util.LongBits(object.quantity.low >>> 0, object.quantity.high >>> 0).toNumber(true);
                return message;
            };

            NEMMosaic.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.namespace = "";
                    object.mosaic = "";
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, true);
                        object.quantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.quantity = options.longs === String ? "0" : 0;
                }
                if (message.namespace != null && message.hasOwnProperty("namespace"))
                    object.namespace = message.namespace;
                if (message.mosaic != null && message.hasOwnProperty("mosaic"))
                    object.mosaic = message.mosaic;
                if (message.quantity != null && message.hasOwnProperty("quantity"))
                    if (typeof message.quantity === "number")
                        object.quantity = options.longs === String ? String(message.quantity) : message.quantity;
                    else
                        object.quantity = options.longs === String ? $util.Long.prototype.toString.call(message.quantity) : options.longs === Number ? new $util.LongBits(message.quantity.low >>> 0, message.quantity.high >>> 0).toNumber(true) : message.quantity;
                return object;
            };

            NEMMosaic.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return NEMMosaic;
        })();

        return NEMTransfer;
    })();

    NEMSignTx.NEMProvisionNamespace = (function() {

        function NEMProvisionNamespace(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        NEMProvisionNamespace.prototype.namespace = "";
        NEMProvisionNamespace.prototype.parent = "";
        NEMProvisionNamespace.prototype.sink = "";
        NEMProvisionNamespace.prototype.fee = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        NEMProvisionNamespace.create = function create(properties) {
            return new NEMProvisionNamespace(properties);
        };

        NEMProvisionNamespace.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.namespace != null && Object.hasOwnProperty.call(message, "namespace"))
                writer.uint32(10).string(message.namespace);
            if (message.parent != null && Object.hasOwnProperty.call(message, "parent"))
                writer.uint32(18).string(message.parent);
            if (message.sink != null && Object.hasOwnProperty.call(message, "sink"))
                writer.uint32(26).string(message.sink);
            if (message.fee != null && Object.hasOwnProperty.call(message, "fee"))
                writer.uint32(32).uint64(message.fee);
            return writer;
        };

        NEMProvisionNamespace.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        NEMProvisionNamespace.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NEMSignTx.NEMProvisionNamespace();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.namespace = reader.string();
                    break;
                case 2:
                    message.parent = reader.string();
                    break;
                case 3:
                    message.sink = reader.string();
                    break;
                case 4:
                    message.fee = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        NEMProvisionNamespace.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        NEMProvisionNamespace.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.namespace != null && message.hasOwnProperty("namespace"))
                if (!$util.isString(message.namespace))
                    return "namespace: string expected";
            if (message.parent != null && message.hasOwnProperty("parent"))
                if (!$util.isString(message.parent))
                    return "parent: string expected";
            if (message.sink != null && message.hasOwnProperty("sink"))
                if (!$util.isString(message.sink))
                    return "sink: string expected";
            if (message.fee != null && message.hasOwnProperty("fee"))
                if (!$util.isInteger(message.fee) && !(message.fee && $util.isInteger(message.fee.low) && $util.isInteger(message.fee.high)))
                    return "fee: integer|Long expected";
            return null;
        };

        NEMProvisionNamespace.fromObject = function fromObject(object) {
            if (object instanceof $root.NEMSignTx.NEMProvisionNamespace)
                return object;
            var message = new $root.NEMSignTx.NEMProvisionNamespace();
            if (object.namespace != null)
                message.namespace = String(object.namespace);
            if (object.parent != null)
                message.parent = String(object.parent);
            if (object.sink != null)
                message.sink = String(object.sink);
            if (object.fee != null)
                if ($util.Long)
                    (message.fee = $util.Long.fromValue(object.fee)).unsigned = true;
                else if (typeof object.fee === "string")
                    message.fee = parseInt(object.fee, 10);
                else if (typeof object.fee === "number")
                    message.fee = object.fee;
                else if (typeof object.fee === "object")
                    message.fee = new $util.LongBits(object.fee.low >>> 0, object.fee.high >>> 0).toNumber(true);
            return message;
        };

        NEMProvisionNamespace.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.namespace = "";
                object.parent = "";
                object.sink = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.fee = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.fee = options.longs === String ? "0" : 0;
            }
            if (message.namespace != null && message.hasOwnProperty("namespace"))
                object.namespace = message.namespace;
            if (message.parent != null && message.hasOwnProperty("parent"))
                object.parent = message.parent;
            if (message.sink != null && message.hasOwnProperty("sink"))
                object.sink = message.sink;
            if (message.fee != null && message.hasOwnProperty("fee"))
                if (typeof message.fee === "number")
                    object.fee = options.longs === String ? String(message.fee) : message.fee;
                else
                    object.fee = options.longs === String ? $util.Long.prototype.toString.call(message.fee) : options.longs === Number ? new $util.LongBits(message.fee.low >>> 0, message.fee.high >>> 0).toNumber(true) : message.fee;
            return object;
        };

        NEMProvisionNamespace.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return NEMProvisionNamespace;
    })();

    NEMSignTx.NEMMosaicCreation = (function() {

        function NEMMosaicCreation(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        NEMMosaicCreation.prototype.definition = null;
        NEMMosaicCreation.prototype.sink = "";
        NEMMosaicCreation.prototype.fee = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        NEMMosaicCreation.create = function create(properties) {
            return new NEMMosaicCreation(properties);
        };

        NEMMosaicCreation.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.definition != null && Object.hasOwnProperty.call(message, "definition"))
                $root.NEMSignTx.NEMMosaicCreation.NEMMosaicDefinition.encode(message.definition, writer.uint32(10).fork()).ldelim();
            if (message.sink != null && Object.hasOwnProperty.call(message, "sink"))
                writer.uint32(18).string(message.sink);
            if (message.fee != null && Object.hasOwnProperty.call(message, "fee"))
                writer.uint32(24).uint64(message.fee);
            return writer;
        };

        NEMMosaicCreation.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        NEMMosaicCreation.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NEMSignTx.NEMMosaicCreation();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.definition = $root.NEMSignTx.NEMMosaicCreation.NEMMosaicDefinition.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.sink = reader.string();
                    break;
                case 3:
                    message.fee = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        NEMMosaicCreation.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        NEMMosaicCreation.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.definition != null && message.hasOwnProperty("definition")) {
                var error = $root.NEMSignTx.NEMMosaicCreation.NEMMosaicDefinition.verify(message.definition);
                if (error)
                    return "definition." + error;
            }
            if (message.sink != null && message.hasOwnProperty("sink"))
                if (!$util.isString(message.sink))
                    return "sink: string expected";
            if (message.fee != null && message.hasOwnProperty("fee"))
                if (!$util.isInteger(message.fee) && !(message.fee && $util.isInteger(message.fee.low) && $util.isInteger(message.fee.high)))
                    return "fee: integer|Long expected";
            return null;
        };

        NEMMosaicCreation.fromObject = function fromObject(object) {
            if (object instanceof $root.NEMSignTx.NEMMosaicCreation)
                return object;
            var message = new $root.NEMSignTx.NEMMosaicCreation();
            if (object.definition != null) {
                if (typeof object.definition !== "object")
                    throw TypeError(".NEMSignTx.NEMMosaicCreation.definition: object expected");
                message.definition = $root.NEMSignTx.NEMMosaicCreation.NEMMosaicDefinition.fromObject(object.definition);
            }
            if (object.sink != null)
                message.sink = String(object.sink);
            if (object.fee != null)
                if ($util.Long)
                    (message.fee = $util.Long.fromValue(object.fee)).unsigned = true;
                else if (typeof object.fee === "string")
                    message.fee = parseInt(object.fee, 10);
                else if (typeof object.fee === "number")
                    message.fee = object.fee;
                else if (typeof object.fee === "object")
                    message.fee = new $util.LongBits(object.fee.low >>> 0, object.fee.high >>> 0).toNumber(true);
            return message;
        };

        NEMMosaicCreation.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.definition = null;
                object.sink = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.fee = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.fee = options.longs === String ? "0" : 0;
            }
            if (message.definition != null && message.hasOwnProperty("definition"))
                object.definition = $root.NEMSignTx.NEMMosaicCreation.NEMMosaicDefinition.toObject(message.definition, options);
            if (message.sink != null && message.hasOwnProperty("sink"))
                object.sink = message.sink;
            if (message.fee != null && message.hasOwnProperty("fee"))
                if (typeof message.fee === "number")
                    object.fee = options.longs === String ? String(message.fee) : message.fee;
                else
                    object.fee = options.longs === String ? $util.Long.prototype.toString.call(message.fee) : options.longs === Number ? new $util.LongBits(message.fee.low >>> 0, message.fee.high >>> 0).toNumber(true) : message.fee;
            return object;
        };

        NEMMosaicCreation.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        NEMMosaicCreation.NEMMosaicDefinition = (function() {

            function NEMMosaicDefinition(properties) {
                this.networks = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            NEMMosaicDefinition.prototype.name = "";
            NEMMosaicDefinition.prototype.ticker = "";
            NEMMosaicDefinition.prototype.namespace = "";
            NEMMosaicDefinition.prototype.mosaic = "";
            NEMMosaicDefinition.prototype.divisibility = 0;
            NEMMosaicDefinition.prototype.levy = 1;
            NEMMosaicDefinition.prototype.fee = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
            NEMMosaicDefinition.prototype.levy_address = "";
            NEMMosaicDefinition.prototype.levy_namespace = "";
            NEMMosaicDefinition.prototype.levy_mosaic = "";
            NEMMosaicDefinition.prototype.supply = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
            NEMMosaicDefinition.prototype.mutable_supply = false;
            NEMMosaicDefinition.prototype.transferable = false;
            NEMMosaicDefinition.prototype.description = "";
            NEMMosaicDefinition.prototype.networks = $util.emptyArray;

            NEMMosaicDefinition.create = function create(properties) {
                return new NEMMosaicDefinition(properties);
            };

            NEMMosaicDefinition.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                    writer.uint32(10).string(message.name);
                if (message.ticker != null && Object.hasOwnProperty.call(message, "ticker"))
                    writer.uint32(18).string(message.ticker);
                if (message.namespace != null && Object.hasOwnProperty.call(message, "namespace"))
                    writer.uint32(26).string(message.namespace);
                if (message.mosaic != null && Object.hasOwnProperty.call(message, "mosaic"))
                    writer.uint32(34).string(message.mosaic);
                if (message.divisibility != null && Object.hasOwnProperty.call(message, "divisibility"))
                    writer.uint32(40).uint32(message.divisibility);
                if (message.levy != null && Object.hasOwnProperty.call(message, "levy"))
                    writer.uint32(48).int32(message.levy);
                if (message.fee != null && Object.hasOwnProperty.call(message, "fee"))
                    writer.uint32(56).uint64(message.fee);
                if (message.levy_address != null && Object.hasOwnProperty.call(message, "levy_address"))
                    writer.uint32(66).string(message.levy_address);
                if (message.levy_namespace != null && Object.hasOwnProperty.call(message, "levy_namespace"))
                    writer.uint32(74).string(message.levy_namespace);
                if (message.levy_mosaic != null && Object.hasOwnProperty.call(message, "levy_mosaic"))
                    writer.uint32(82).string(message.levy_mosaic);
                if (message.supply != null && Object.hasOwnProperty.call(message, "supply"))
                    writer.uint32(88).uint64(message.supply);
                if (message.mutable_supply != null && Object.hasOwnProperty.call(message, "mutable_supply"))
                    writer.uint32(96).bool(message.mutable_supply);
                if (message.transferable != null && Object.hasOwnProperty.call(message, "transferable"))
                    writer.uint32(104).bool(message.transferable);
                if (message.description != null && Object.hasOwnProperty.call(message, "description"))
                    writer.uint32(114).string(message.description);
                if (message.networks != null && message.networks.length)
                    for (var i = 0; i < message.networks.length; ++i)
                        writer.uint32(120).uint32(message.networks[i]);
                return writer;
            };

            NEMMosaicDefinition.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            NEMMosaicDefinition.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NEMSignTx.NEMMosaicCreation.NEMMosaicDefinition();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.name = reader.string();
                        break;
                    case 2:
                        message.ticker = reader.string();
                        break;
                    case 3:
                        message.namespace = reader.string();
                        break;
                    case 4:
                        message.mosaic = reader.string();
                        break;
                    case 5:
                        message.divisibility = reader.uint32();
                        break;
                    case 6:
                        message.levy = reader.int32();
                        break;
                    case 7:
                        message.fee = reader.uint64();
                        break;
                    case 8:
                        message.levy_address = reader.string();
                        break;
                    case 9:
                        message.levy_namespace = reader.string();
                        break;
                    case 10:
                        message.levy_mosaic = reader.string();
                        break;
                    case 11:
                        message.supply = reader.uint64();
                        break;
                    case 12:
                        message.mutable_supply = reader.bool();
                        break;
                    case 13:
                        message.transferable = reader.bool();
                        break;
                    case 14:
                        message.description = reader.string();
                        break;
                    case 15:
                        if (!(message.networks && message.networks.length))
                            message.networks = [];
                        if ((tag & 7) === 2) {
                            var end2 = reader.uint32() + reader.pos;
                            while (reader.pos < end2)
                                message.networks.push(reader.uint32());
                        } else
                            message.networks.push(reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            NEMMosaicDefinition.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            NEMMosaicDefinition.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.name != null && message.hasOwnProperty("name"))
                    if (!$util.isString(message.name))
                        return "name: string expected";
                if (message.ticker != null && message.hasOwnProperty("ticker"))
                    if (!$util.isString(message.ticker))
                        return "ticker: string expected";
                if (message.namespace != null && message.hasOwnProperty("namespace"))
                    if (!$util.isString(message.namespace))
                        return "namespace: string expected";
                if (message.mosaic != null && message.hasOwnProperty("mosaic"))
                    if (!$util.isString(message.mosaic))
                        return "mosaic: string expected";
                if (message.divisibility != null && message.hasOwnProperty("divisibility"))
                    if (!$util.isInteger(message.divisibility))
                        return "divisibility: integer expected";
                if (message.levy != null && message.hasOwnProperty("levy"))
                    switch (message.levy) {
                    default:
                        return "levy: enum value expected";
                    case 1:
                    case 2:
                        break;
                    }
                if (message.fee != null && message.hasOwnProperty("fee"))
                    if (!$util.isInteger(message.fee) && !(message.fee && $util.isInteger(message.fee.low) && $util.isInteger(message.fee.high)))
                        return "fee: integer|Long expected";
                if (message.levy_address != null && message.hasOwnProperty("levy_address"))
                    if (!$util.isString(message.levy_address))
                        return "levy_address: string expected";
                if (message.levy_namespace != null && message.hasOwnProperty("levy_namespace"))
                    if (!$util.isString(message.levy_namespace))
                        return "levy_namespace: string expected";
                if (message.levy_mosaic != null && message.hasOwnProperty("levy_mosaic"))
                    if (!$util.isString(message.levy_mosaic))
                        return "levy_mosaic: string expected";
                if (message.supply != null && message.hasOwnProperty("supply"))
                    if (!$util.isInteger(message.supply) && !(message.supply && $util.isInteger(message.supply.low) && $util.isInteger(message.supply.high)))
                        return "supply: integer|Long expected";
                if (message.mutable_supply != null && message.hasOwnProperty("mutable_supply"))
                    if (typeof message.mutable_supply !== "boolean")
                        return "mutable_supply: boolean expected";
                if (message.transferable != null && message.hasOwnProperty("transferable"))
                    if (typeof message.transferable !== "boolean")
                        return "transferable: boolean expected";
                if (message.description != null && message.hasOwnProperty("description"))
                    if (!$util.isString(message.description))
                        return "description: string expected";
                if (message.networks != null && message.hasOwnProperty("networks")) {
                    if (!Array.isArray(message.networks))
                        return "networks: array expected";
                    for (var i = 0; i < message.networks.length; ++i)
                        if (!$util.isInteger(message.networks[i]))
                            return "networks: integer[] expected";
                }
                return null;
            };

            NEMMosaicDefinition.fromObject = function fromObject(object) {
                if (object instanceof $root.NEMSignTx.NEMMosaicCreation.NEMMosaicDefinition)
                    return object;
                var message = new $root.NEMSignTx.NEMMosaicCreation.NEMMosaicDefinition();
                if (object.name != null)
                    message.name = String(object.name);
                if (object.ticker != null)
                    message.ticker = String(object.ticker);
                if (object.namespace != null)
                    message.namespace = String(object.namespace);
                if (object.mosaic != null)
                    message.mosaic = String(object.mosaic);
                if (object.divisibility != null)
                    message.divisibility = object.divisibility >>> 0;
                switch (object.levy) {
                case "MosaicLevy_Absolute":
                case 1:
                    message.levy = 1;
                    break;
                case "MosaicLevy_Percentile":
                case 2:
                    message.levy = 2;
                    break;
                }
                if (object.fee != null)
                    if ($util.Long)
                        (message.fee = $util.Long.fromValue(object.fee)).unsigned = true;
                    else if (typeof object.fee === "string")
                        message.fee = parseInt(object.fee, 10);
                    else if (typeof object.fee === "number")
                        message.fee = object.fee;
                    else if (typeof object.fee === "object")
                        message.fee = new $util.LongBits(object.fee.low >>> 0, object.fee.high >>> 0).toNumber(true);
                if (object.levy_address != null)
                    message.levy_address = String(object.levy_address);
                if (object.levy_namespace != null)
                    message.levy_namespace = String(object.levy_namespace);
                if (object.levy_mosaic != null)
                    message.levy_mosaic = String(object.levy_mosaic);
                if (object.supply != null)
                    if ($util.Long)
                        (message.supply = $util.Long.fromValue(object.supply)).unsigned = true;
                    else if (typeof object.supply === "string")
                        message.supply = parseInt(object.supply, 10);
                    else if (typeof object.supply === "number")
                        message.supply = object.supply;
                    else if (typeof object.supply === "object")
                        message.supply = new $util.LongBits(object.supply.low >>> 0, object.supply.high >>> 0).toNumber(true);
                if (object.mutable_supply != null)
                    message.mutable_supply = Boolean(object.mutable_supply);
                if (object.transferable != null)
                    message.transferable = Boolean(object.transferable);
                if (object.description != null)
                    message.description = String(object.description);
                if (object.networks) {
                    if (!Array.isArray(object.networks))
                        throw TypeError(".NEMSignTx.NEMMosaicCreation.NEMMosaicDefinition.networks: array expected");
                    message.networks = [];
                    for (var i = 0; i < object.networks.length; ++i)
                        message.networks[i] = object.networks[i] >>> 0;
                }
                return message;
            };

            NEMMosaicDefinition.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.networks = [];
                if (options.defaults) {
                    object.name = "";
                    object.ticker = "";
                    object.namespace = "";
                    object.mosaic = "";
                    object.divisibility = 0;
                    object.levy = options.enums === String ? "MosaicLevy_Absolute" : 1;
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, true);
                        object.fee = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.fee = options.longs === String ? "0" : 0;
                    object.levy_address = "";
                    object.levy_namespace = "";
                    object.levy_mosaic = "";
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, true);
                        object.supply = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.supply = options.longs === String ? "0" : 0;
                    object.mutable_supply = false;
                    object.transferable = false;
                    object.description = "";
                }
                if (message.name != null && message.hasOwnProperty("name"))
                    object.name = message.name;
                if (message.ticker != null && message.hasOwnProperty("ticker"))
                    object.ticker = message.ticker;
                if (message.namespace != null && message.hasOwnProperty("namespace"))
                    object.namespace = message.namespace;
                if (message.mosaic != null && message.hasOwnProperty("mosaic"))
                    object.mosaic = message.mosaic;
                if (message.divisibility != null && message.hasOwnProperty("divisibility"))
                    object.divisibility = message.divisibility;
                if (message.levy != null && message.hasOwnProperty("levy"))
                    object.levy = options.enums === String ? $root.NEMSignTx.NEMMosaicCreation.NEMMosaicDefinition.NEMMosaicLevy[message.levy] : message.levy;
                if (message.fee != null && message.hasOwnProperty("fee"))
                    if (typeof message.fee === "number")
                        object.fee = options.longs === String ? String(message.fee) : message.fee;
                    else
                        object.fee = options.longs === String ? $util.Long.prototype.toString.call(message.fee) : options.longs === Number ? new $util.LongBits(message.fee.low >>> 0, message.fee.high >>> 0).toNumber(true) : message.fee;
                if (message.levy_address != null && message.hasOwnProperty("levy_address"))
                    object.levy_address = message.levy_address;
                if (message.levy_namespace != null && message.hasOwnProperty("levy_namespace"))
                    object.levy_namespace = message.levy_namespace;
                if (message.levy_mosaic != null && message.hasOwnProperty("levy_mosaic"))
                    object.levy_mosaic = message.levy_mosaic;
                if (message.supply != null && message.hasOwnProperty("supply"))
                    if (typeof message.supply === "number")
                        object.supply = options.longs === String ? String(message.supply) : message.supply;
                    else
                        object.supply = options.longs === String ? $util.Long.prototype.toString.call(message.supply) : options.longs === Number ? new $util.LongBits(message.supply.low >>> 0, message.supply.high >>> 0).toNumber(true) : message.supply;
                if (message.mutable_supply != null && message.hasOwnProperty("mutable_supply"))
                    object.mutable_supply = message.mutable_supply;
                if (message.transferable != null && message.hasOwnProperty("transferable"))
                    object.transferable = message.transferable;
                if (message.description != null && message.hasOwnProperty("description"))
                    object.description = message.description;
                if (message.networks && message.networks.length) {
                    object.networks = [];
                    for (var j = 0; j < message.networks.length; ++j)
                        object.networks[j] = message.networks[j];
                }
                return object;
            };

            NEMMosaicDefinition.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            NEMMosaicDefinition.NEMMosaicLevy = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[1] = "MosaicLevy_Absolute"] = 1;
                values[valuesById[2] = "MosaicLevy_Percentile"] = 2;
                return values;
            })();

            return NEMMosaicDefinition;
        })();

        return NEMMosaicCreation;
    })();

    NEMSignTx.NEMMosaicSupplyChange = (function() {

        function NEMMosaicSupplyChange(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        NEMMosaicSupplyChange.prototype.namespace = "";
        NEMMosaicSupplyChange.prototype.mosaic = "";
        NEMMosaicSupplyChange.prototype.type = 1;
        NEMMosaicSupplyChange.prototype.delta = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        NEMMosaicSupplyChange.create = function create(properties) {
            return new NEMMosaicSupplyChange(properties);
        };

        NEMMosaicSupplyChange.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.namespace != null && Object.hasOwnProperty.call(message, "namespace"))
                writer.uint32(10).string(message.namespace);
            if (message.mosaic != null && Object.hasOwnProperty.call(message, "mosaic"))
                writer.uint32(18).string(message.mosaic);
            if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                writer.uint32(24).int32(message.type);
            if (message.delta != null && Object.hasOwnProperty.call(message, "delta"))
                writer.uint32(32).uint64(message.delta);
            return writer;
        };

        NEMMosaicSupplyChange.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        NEMMosaicSupplyChange.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NEMSignTx.NEMMosaicSupplyChange();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.namespace = reader.string();
                    break;
                case 2:
                    message.mosaic = reader.string();
                    break;
                case 3:
                    message.type = reader.int32();
                    break;
                case 4:
                    message.delta = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        NEMMosaicSupplyChange.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        NEMMosaicSupplyChange.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.namespace != null && message.hasOwnProperty("namespace"))
                if (!$util.isString(message.namespace))
                    return "namespace: string expected";
            if (message.mosaic != null && message.hasOwnProperty("mosaic"))
                if (!$util.isString(message.mosaic))
                    return "mosaic: string expected";
            if (message.type != null && message.hasOwnProperty("type"))
                switch (message.type) {
                default:
                    return "type: enum value expected";
                case 1:
                case 2:
                    break;
                }
            if (message.delta != null && message.hasOwnProperty("delta"))
                if (!$util.isInteger(message.delta) && !(message.delta && $util.isInteger(message.delta.low) && $util.isInteger(message.delta.high)))
                    return "delta: integer|Long expected";
            return null;
        };

        NEMMosaicSupplyChange.fromObject = function fromObject(object) {
            if (object instanceof $root.NEMSignTx.NEMMosaicSupplyChange)
                return object;
            var message = new $root.NEMSignTx.NEMMosaicSupplyChange();
            if (object.namespace != null)
                message.namespace = String(object.namespace);
            if (object.mosaic != null)
                message.mosaic = String(object.mosaic);
            switch (object.type) {
            case "SupplyChange_Increase":
            case 1:
                message.type = 1;
                break;
            case "SupplyChange_Decrease":
            case 2:
                message.type = 2;
                break;
            }
            if (object.delta != null)
                if ($util.Long)
                    (message.delta = $util.Long.fromValue(object.delta)).unsigned = true;
                else if (typeof object.delta === "string")
                    message.delta = parseInt(object.delta, 10);
                else if (typeof object.delta === "number")
                    message.delta = object.delta;
                else if (typeof object.delta === "object")
                    message.delta = new $util.LongBits(object.delta.low >>> 0, object.delta.high >>> 0).toNumber(true);
            return message;
        };

        NEMMosaicSupplyChange.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.namespace = "";
                object.mosaic = "";
                object.type = options.enums === String ? "SupplyChange_Increase" : 1;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.delta = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.delta = options.longs === String ? "0" : 0;
            }
            if (message.namespace != null && message.hasOwnProperty("namespace"))
                object.namespace = message.namespace;
            if (message.mosaic != null && message.hasOwnProperty("mosaic"))
                object.mosaic = message.mosaic;
            if (message.type != null && message.hasOwnProperty("type"))
                object.type = options.enums === String ? $root.NEMSignTx.NEMMosaicSupplyChange.NEMSupplyChangeType[message.type] : message.type;
            if (message.delta != null && message.hasOwnProperty("delta"))
                if (typeof message.delta === "number")
                    object.delta = options.longs === String ? String(message.delta) : message.delta;
                else
                    object.delta = options.longs === String ? $util.Long.prototype.toString.call(message.delta) : options.longs === Number ? new $util.LongBits(message.delta.low >>> 0, message.delta.high >>> 0).toNumber(true) : message.delta;
            return object;
        };

        NEMMosaicSupplyChange.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        NEMMosaicSupplyChange.NEMSupplyChangeType = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[1] = "SupplyChange_Increase"] = 1;
            values[valuesById[2] = "SupplyChange_Decrease"] = 2;
            return values;
        })();

        return NEMMosaicSupplyChange;
    })();

    NEMSignTx.NEMAggregateModification = (function() {

        function NEMAggregateModification(properties) {
            this.modifications = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        NEMAggregateModification.prototype.modifications = $util.emptyArray;
        NEMAggregateModification.prototype.relative_change = 0;

        NEMAggregateModification.create = function create(properties) {
            return new NEMAggregateModification(properties);
        };

        NEMAggregateModification.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.modifications != null && message.modifications.length)
                for (var i = 0; i < message.modifications.length; ++i)
                    $root.NEMSignTx.NEMAggregateModification.NEMCosignatoryModification.encode(message.modifications[i], writer.uint32(10).fork()).ldelim();
            if (message.relative_change != null && Object.hasOwnProperty.call(message, "relative_change"))
                writer.uint32(16).sint32(message.relative_change);
            return writer;
        };

        NEMAggregateModification.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        NEMAggregateModification.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NEMSignTx.NEMAggregateModification();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.modifications && message.modifications.length))
                        message.modifications = [];
                    message.modifications.push($root.NEMSignTx.NEMAggregateModification.NEMCosignatoryModification.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.relative_change = reader.sint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        NEMAggregateModification.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        NEMAggregateModification.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.modifications != null && message.hasOwnProperty("modifications")) {
                if (!Array.isArray(message.modifications))
                    return "modifications: array expected";
                for (var i = 0; i < message.modifications.length; ++i) {
                    var error = $root.NEMSignTx.NEMAggregateModification.NEMCosignatoryModification.verify(message.modifications[i]);
                    if (error)
                        return "modifications." + error;
                }
            }
            if (message.relative_change != null && message.hasOwnProperty("relative_change"))
                if (!$util.isInteger(message.relative_change))
                    return "relative_change: integer expected";
            return null;
        };

        NEMAggregateModification.fromObject = function fromObject(object) {
            if (object instanceof $root.NEMSignTx.NEMAggregateModification)
                return object;
            var message = new $root.NEMSignTx.NEMAggregateModification();
            if (object.modifications) {
                if (!Array.isArray(object.modifications))
                    throw TypeError(".NEMSignTx.NEMAggregateModification.modifications: array expected");
                message.modifications = [];
                for (var i = 0; i < object.modifications.length; ++i) {
                    if (typeof object.modifications[i] !== "object")
                        throw TypeError(".NEMSignTx.NEMAggregateModification.modifications: object expected");
                    message.modifications[i] = $root.NEMSignTx.NEMAggregateModification.NEMCosignatoryModification.fromObject(object.modifications[i]);
                }
            }
            if (object.relative_change != null)
                message.relative_change = object.relative_change | 0;
            return message;
        };

        NEMAggregateModification.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.modifications = [];
            if (options.defaults)
                object.relative_change = 0;
            if (message.modifications && message.modifications.length) {
                object.modifications = [];
                for (var j = 0; j < message.modifications.length; ++j)
                    object.modifications[j] = $root.NEMSignTx.NEMAggregateModification.NEMCosignatoryModification.toObject(message.modifications[j], options);
            }
            if (message.relative_change != null && message.hasOwnProperty("relative_change"))
                object.relative_change = message.relative_change;
            return object;
        };

        NEMAggregateModification.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        NEMAggregateModification.NEMCosignatoryModification = (function() {

            function NEMCosignatoryModification(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            NEMCosignatoryModification.prototype.type = 1;
            NEMCosignatoryModification.prototype.public_key = $util.newBuffer([]);

            NEMCosignatoryModification.create = function create(properties) {
                return new NEMCosignatoryModification(properties);
            };

            NEMCosignatoryModification.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                    writer.uint32(8).int32(message.type);
                if (message.public_key != null && Object.hasOwnProperty.call(message, "public_key"))
                    writer.uint32(18).bytes(message.public_key);
                return writer;
            };

            NEMCosignatoryModification.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            NEMCosignatoryModification.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NEMSignTx.NEMAggregateModification.NEMCosignatoryModification();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.type = reader.int32();
                        break;
                    case 2:
                        message.public_key = reader.bytes();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            NEMCosignatoryModification.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            NEMCosignatoryModification.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.type != null && message.hasOwnProperty("type"))
                    switch (message.type) {
                    default:
                        return "type: enum value expected";
                    case 1:
                    case 2:
                        break;
                    }
                if (message.public_key != null && message.hasOwnProperty("public_key"))
                    if (!(message.public_key && typeof message.public_key.length === "number" || $util.isString(message.public_key)))
                        return "public_key: buffer expected";
                return null;
            };

            NEMCosignatoryModification.fromObject = function fromObject(object) {
                if (object instanceof $root.NEMSignTx.NEMAggregateModification.NEMCosignatoryModification)
                    return object;
                var message = new $root.NEMSignTx.NEMAggregateModification.NEMCosignatoryModification();
                switch (object.type) {
                case "CosignatoryModification_Add":
                case 1:
                    message.type = 1;
                    break;
                case "CosignatoryModification_Delete":
                case 2:
                    message.type = 2;
                    break;
                }
                if (object.public_key != null)
                    if (typeof object.public_key === "string")
                        $util.base64.decode(object.public_key, message.public_key = $util.newBuffer($util.base64.length(object.public_key)), 0);
                    else if (object.public_key.length)
                        message.public_key = object.public_key;
                return message;
            };

            NEMCosignatoryModification.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.type = options.enums === String ? "CosignatoryModification_Add" : 1;
                    if (options.bytes === String)
                        object.public_key = "";
                    else {
                        object.public_key = [];
                        if (options.bytes !== Array)
                            object.public_key = $util.newBuffer(object.public_key);
                    }
                }
                if (message.type != null && message.hasOwnProperty("type"))
                    object.type = options.enums === String ? $root.NEMSignTx.NEMAggregateModification.NEMCosignatoryModification.NEMModificationType[message.type] : message.type;
                if (message.public_key != null && message.hasOwnProperty("public_key"))
                    object.public_key = options.bytes === String ? $util.base64.encode(message.public_key, 0, message.public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.public_key) : message.public_key;
                return object;
            };

            NEMCosignatoryModification.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            NEMCosignatoryModification.NEMModificationType = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[1] = "CosignatoryModification_Add"] = 1;
                values[valuesById[2] = "CosignatoryModification_Delete"] = 2;
                return values;
            })();

            return NEMCosignatoryModification;
        })();

        return NEMAggregateModification;
    })();

    NEMSignTx.NEMImportanceTransfer = (function() {

        function NEMImportanceTransfer(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        NEMImportanceTransfer.prototype.mode = 1;
        NEMImportanceTransfer.prototype.public_key = $util.newBuffer([]);

        NEMImportanceTransfer.create = function create(properties) {
            return new NEMImportanceTransfer(properties);
        };

        NEMImportanceTransfer.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.mode != null && Object.hasOwnProperty.call(message, "mode"))
                writer.uint32(8).int32(message.mode);
            if (message.public_key != null && Object.hasOwnProperty.call(message, "public_key"))
                writer.uint32(18).bytes(message.public_key);
            return writer;
        };

        NEMImportanceTransfer.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        NEMImportanceTransfer.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NEMSignTx.NEMImportanceTransfer();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.mode = reader.int32();
                    break;
                case 2:
                    message.public_key = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        NEMImportanceTransfer.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        NEMImportanceTransfer.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.mode != null && message.hasOwnProperty("mode"))
                switch (message.mode) {
                default:
                    return "mode: enum value expected";
                case 1:
                case 2:
                    break;
                }
            if (message.public_key != null && message.hasOwnProperty("public_key"))
                if (!(message.public_key && typeof message.public_key.length === "number" || $util.isString(message.public_key)))
                    return "public_key: buffer expected";
            return null;
        };

        NEMImportanceTransfer.fromObject = function fromObject(object) {
            if (object instanceof $root.NEMSignTx.NEMImportanceTransfer)
                return object;
            var message = new $root.NEMSignTx.NEMImportanceTransfer();
            switch (object.mode) {
            case "ImportanceTransfer_Activate":
            case 1:
                message.mode = 1;
                break;
            case "ImportanceTransfer_Deactivate":
            case 2:
                message.mode = 2;
                break;
            }
            if (object.public_key != null)
                if (typeof object.public_key === "string")
                    $util.base64.decode(object.public_key, message.public_key = $util.newBuffer($util.base64.length(object.public_key)), 0);
                else if (object.public_key.length)
                    message.public_key = object.public_key;
            return message;
        };

        NEMImportanceTransfer.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.mode = options.enums === String ? "ImportanceTransfer_Activate" : 1;
                if (options.bytes === String)
                    object.public_key = "";
                else {
                    object.public_key = [];
                    if (options.bytes !== Array)
                        object.public_key = $util.newBuffer(object.public_key);
                }
            }
            if (message.mode != null && message.hasOwnProperty("mode"))
                object.mode = options.enums === String ? $root.NEMSignTx.NEMImportanceTransfer.NEMImportanceTransferMode[message.mode] : message.mode;
            if (message.public_key != null && message.hasOwnProperty("public_key"))
                object.public_key = options.bytes === String ? $util.base64.encode(message.public_key, 0, message.public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.public_key) : message.public_key;
            return object;
        };

        NEMImportanceTransfer.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        NEMImportanceTransfer.NEMImportanceTransferMode = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[1] = "ImportanceTransfer_Activate"] = 1;
            values[valuesById[2] = "ImportanceTransfer_Deactivate"] = 2;
            return values;
        })();

        return NEMImportanceTransfer;
    })();

    return NEMSignTx;
})();

$root.NEMSignedTx = (function() {

    function NEMSignedTx(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NEMSignedTx.prototype.data = $util.newBuffer([]);
    NEMSignedTx.prototype.signature = $util.newBuffer([]);

    NEMSignedTx.create = function create(properties) {
        return new NEMSignedTx(properties);
    };

    NEMSignedTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.data);
        writer.uint32(18).bytes(message.signature);
        return writer;
    };

    NEMSignedTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NEMSignedTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NEMSignedTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.data = reader.bytes();
                break;
            case 2:
                message.signature = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("data"))
            throw $util.ProtocolError("missing required 'data'", { instance: message });
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        return message;
    };

    NEMSignedTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NEMSignedTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
            return "data: buffer expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        return null;
    };

    NEMSignedTx.fromObject = function fromObject(object) {
        if (object instanceof $root.NEMSignedTx)
            return object;
        var message = new $root.NEMSignedTx();
        if (object.data != null)
            if (typeof object.data === "string")
                $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
            else if (object.data.length)
                message.data = object.data;
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        return message;
    };

    NEMSignedTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.data = "";
            else {
                object.data = [];
                if (options.bytes !== Array)
                    object.data = $util.newBuffer(object.data);
            }
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
        }
        if (message.data != null && message.hasOwnProperty("data"))
            object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        return object;
    };

    NEMSignedTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NEMSignedTx;
})();

$root.NEMDecryptMessage = (function() {

    function NEMDecryptMessage(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NEMDecryptMessage.prototype.address_n = $util.emptyArray;
    NEMDecryptMessage.prototype.network = 0;
    NEMDecryptMessage.prototype.public_key = $util.newBuffer([]);
    NEMDecryptMessage.prototype.payload = $util.newBuffer([]);

    NEMDecryptMessage.create = function create(properties) {
        return new NEMDecryptMessage(properties);
    };

    NEMDecryptMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.network != null && Object.hasOwnProperty.call(message, "network"))
            writer.uint32(16).uint32(message.network);
        if (message.public_key != null && Object.hasOwnProperty.call(message, "public_key"))
            writer.uint32(26).bytes(message.public_key);
        if (message.payload != null && Object.hasOwnProperty.call(message, "payload"))
            writer.uint32(34).bytes(message.payload);
        return writer;
    };

    NEMDecryptMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NEMDecryptMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NEMDecryptMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.network = reader.uint32();
                break;
            case 3:
                message.public_key = reader.bytes();
                break;
            case 4:
                message.payload = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    NEMDecryptMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NEMDecryptMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.network != null && message.hasOwnProperty("network"))
            if (!$util.isInteger(message.network))
                return "network: integer expected";
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            if (!(message.public_key && typeof message.public_key.length === "number" || $util.isString(message.public_key)))
                return "public_key: buffer expected";
        if (message.payload != null && message.hasOwnProperty("payload"))
            if (!(message.payload && typeof message.payload.length === "number" || $util.isString(message.payload)))
                return "payload: buffer expected";
        return null;
    };

    NEMDecryptMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.NEMDecryptMessage)
            return object;
        var message = new $root.NEMDecryptMessage();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".NEMDecryptMessage.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.network != null)
            message.network = object.network >>> 0;
        if (object.public_key != null)
            if (typeof object.public_key === "string")
                $util.base64.decode(object.public_key, message.public_key = $util.newBuffer($util.base64.length(object.public_key)), 0);
            else if (object.public_key.length)
                message.public_key = object.public_key;
        if (object.payload != null)
            if (typeof object.payload === "string")
                $util.base64.decode(object.payload, message.payload = $util.newBuffer($util.base64.length(object.payload)), 0);
            else if (object.payload.length)
                message.payload = object.payload;
        return message;
    };

    NEMDecryptMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            object.network = 0;
            if (options.bytes === String)
                object.public_key = "";
            else {
                object.public_key = [];
                if (options.bytes !== Array)
                    object.public_key = $util.newBuffer(object.public_key);
            }
            if (options.bytes === String)
                object.payload = "";
            else {
                object.payload = [];
                if (options.bytes !== Array)
                    object.payload = $util.newBuffer(object.payload);
            }
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.network != null && message.hasOwnProperty("network"))
            object.network = message.network;
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            object.public_key = options.bytes === String ? $util.base64.encode(message.public_key, 0, message.public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.public_key) : message.public_key;
        if (message.payload != null && message.hasOwnProperty("payload"))
            object.payload = options.bytes === String ? $util.base64.encode(message.payload, 0, message.payload.length) : options.bytes === Array ? Array.prototype.slice.call(message.payload) : message.payload;
        return object;
    };

    NEMDecryptMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NEMDecryptMessage;
})();

$root.NEMDecryptedMessage = (function() {

    function NEMDecryptedMessage(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NEMDecryptedMessage.prototype.payload = $util.newBuffer([]);

    NEMDecryptedMessage.create = function create(properties) {
        return new NEMDecryptedMessage(properties);
    };

    NEMDecryptedMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.payload);
        return writer;
    };

    NEMDecryptedMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NEMDecryptedMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NEMDecryptedMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.payload = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("payload"))
            throw $util.ProtocolError("missing required 'payload'", { instance: message });
        return message;
    };

    NEMDecryptedMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NEMDecryptedMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.payload && typeof message.payload.length === "number" || $util.isString(message.payload)))
            return "payload: buffer expected";
        return null;
    };

    NEMDecryptedMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.NEMDecryptedMessage)
            return object;
        var message = new $root.NEMDecryptedMessage();
        if (object.payload != null)
            if (typeof object.payload === "string")
                $util.base64.decode(object.payload, message.payload = $util.newBuffer($util.base64.length(object.payload)), 0);
            else if (object.payload.length)
                message.payload = object.payload;
        return message;
    };

    NEMDecryptedMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.payload = "";
            else {
                object.payload = [];
                if (options.bytes !== Array)
                    object.payload = $util.newBuffer(object.payload);
            }
        if (message.payload != null && message.hasOwnProperty("payload"))
            object.payload = options.bytes === String ? $util.base64.encode(message.payload, 0, message.payload.length) : options.bytes === Array ? Array.prototype.slice.call(message.payload) : message.payload;
        return object;
    };

    NEMDecryptedMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NEMDecryptedMessage;
})();

$root.NexaGetAddress = (function() {

    function NexaGetAddress(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NexaGetAddress.prototype.address_n = $util.emptyArray;
    NexaGetAddress.prototype.show_display = false;
    NexaGetAddress.prototype.prefix = "nexa";

    NexaGetAddress.create = function create(properties) {
        return new NexaGetAddress(properties);
    };

    NexaGetAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(16).bool(message.show_display);
        if (message.prefix != null && Object.hasOwnProperty.call(message, "prefix"))
            writer.uint32(26).string(message.prefix);
        return writer;
    };

    NexaGetAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NexaGetAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NexaGetAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.show_display = reader.bool();
                break;
            case 3:
                message.prefix = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    NexaGetAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NexaGetAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        if (message.prefix != null && message.hasOwnProperty("prefix"))
            if (!$util.isString(message.prefix))
                return "prefix: string expected";
        return null;
    };

    NexaGetAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.NexaGetAddress)
            return object;
        var message = new $root.NexaGetAddress();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".NexaGetAddress.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        if (object.prefix != null)
            message.prefix = String(object.prefix);
        return message;
    };

    NexaGetAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            object.show_display = false;
            object.prefix = "nexa";
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        if (message.prefix != null && message.hasOwnProperty("prefix"))
            object.prefix = message.prefix;
        return object;
    };

    NexaGetAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NexaGetAddress;
})();

$root.NexaAddress = (function() {

    function NexaAddress(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NexaAddress.prototype.address = "";
    NexaAddress.prototype.public_key = $util.newBuffer([]);

    NexaAddress.create = function create(properties) {
        return new NexaAddress(properties);
    };

    NexaAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.address);
        writer.uint32(18).bytes(message.public_key);
        return writer;
    };

    NexaAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NexaAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NexaAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.string();
                break;
            case 2:
                message.public_key = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("address"))
            throw $util.ProtocolError("missing required 'address'", { instance: message });
        if (!message.hasOwnProperty("public_key"))
            throw $util.ProtocolError("missing required 'public_key'", { instance: message });
        return message;
    };

    NexaAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NexaAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.address))
            return "address: string expected";
        if (!(message.public_key && typeof message.public_key.length === "number" || $util.isString(message.public_key)))
            return "public_key: buffer expected";
        return null;
    };

    NexaAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.NexaAddress)
            return object;
        var message = new $root.NexaAddress();
        if (object.address != null)
            message.address = String(object.address);
        if (object.public_key != null)
            if (typeof object.public_key === "string")
                $util.base64.decode(object.public_key, message.public_key = $util.newBuffer($util.base64.length(object.public_key)), 0);
            else if (object.public_key.length)
                message.public_key = object.public_key;
        return message;
    };

    NexaAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.address = "";
            if (options.bytes === String)
                object.public_key = "";
            else {
                object.public_key = [];
                if (options.bytes !== Array)
                    object.public_key = $util.newBuffer(object.public_key);
            }
        }
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            object.public_key = options.bytes === String ? $util.base64.encode(message.public_key, 0, message.public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.public_key) : message.public_key;
        return object;
    };

    NexaAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NexaAddress;
})();

$root.NexaSignTx = (function() {

    function NexaSignTx(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NexaSignTx.prototype.address_n = $util.emptyArray;
    NexaSignTx.prototype.raw_message = $util.newBuffer([]);
    NexaSignTx.prototype.prefix = "nexa";
    NexaSignTx.prototype.input_count = 1;

    NexaSignTx.create = function create(properties) {
        return new NexaSignTx(properties);
    };

    NexaSignTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).bytes(message.raw_message);
        if (message.prefix != null && Object.hasOwnProperty.call(message, "prefix"))
            writer.uint32(26).string(message.prefix);
        if (message.input_count != null && Object.hasOwnProperty.call(message, "input_count"))
            writer.uint32(32).uint32(message.input_count);
        return writer;
    };

    NexaSignTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NexaSignTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NexaSignTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.raw_message = reader.bytes();
                break;
            case 3:
                message.prefix = reader.string();
                break;
            case 4:
                message.input_count = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("raw_message"))
            throw $util.ProtocolError("missing required 'raw_message'", { instance: message });
        return message;
    };

    NexaSignTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NexaSignTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!(message.raw_message && typeof message.raw_message.length === "number" || $util.isString(message.raw_message)))
            return "raw_message: buffer expected";
        if (message.prefix != null && message.hasOwnProperty("prefix"))
            if (!$util.isString(message.prefix))
                return "prefix: string expected";
        if (message.input_count != null && message.hasOwnProperty("input_count"))
            if (!$util.isInteger(message.input_count))
                return "input_count: integer expected";
        return null;
    };

    NexaSignTx.fromObject = function fromObject(object) {
        if (object instanceof $root.NexaSignTx)
            return object;
        var message = new $root.NexaSignTx();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".NexaSignTx.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.raw_message != null)
            if (typeof object.raw_message === "string")
                $util.base64.decode(object.raw_message, message.raw_message = $util.newBuffer($util.base64.length(object.raw_message)), 0);
            else if (object.raw_message.length)
                message.raw_message = object.raw_message;
        if (object.prefix != null)
            message.prefix = String(object.prefix);
        if (object.input_count != null)
            message.input_count = object.input_count >>> 0;
        return message;
    };

    NexaSignTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            if (options.bytes === String)
                object.raw_message = "";
            else {
                object.raw_message = [];
                if (options.bytes !== Array)
                    object.raw_message = $util.newBuffer(object.raw_message);
            }
            object.prefix = "nexa";
            object.input_count = 1;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.raw_message != null && message.hasOwnProperty("raw_message"))
            object.raw_message = options.bytes === String ? $util.base64.encode(message.raw_message, 0, message.raw_message.length) : options.bytes === Array ? Array.prototype.slice.call(message.raw_message) : message.raw_message;
        if (message.prefix != null && message.hasOwnProperty("prefix"))
            object.prefix = message.prefix;
        if (message.input_count != null && message.hasOwnProperty("input_count"))
            object.input_count = message.input_count;
        return object;
    };

    NexaSignTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NexaSignTx;
})();

$root.NexaTxInputRequest = (function() {

    function NexaTxInputRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NexaTxInputRequest.prototype.request_index = 0;
    NexaTxInputRequest.prototype.signature = $util.newBuffer([]);

    NexaTxInputRequest.create = function create(properties) {
        return new NexaTxInputRequest(properties);
    };

    NexaTxInputRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).uint32(message.request_index);
        if (message.signature != null && Object.hasOwnProperty.call(message, "signature"))
            writer.uint32(18).bytes(message.signature);
        return writer;
    };

    NexaTxInputRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NexaTxInputRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NexaTxInputRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.request_index = reader.uint32();
                break;
            case 2:
                message.signature = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("request_index"))
            throw $util.ProtocolError("missing required 'request_index'", { instance: message });
        return message;
    };

    NexaTxInputRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NexaTxInputRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isInteger(message.request_index))
            return "request_index: integer expected";
        if (message.signature != null && message.hasOwnProperty("signature"))
            if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
                return "signature: buffer expected";
        return null;
    };

    NexaTxInputRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.NexaTxInputRequest)
            return object;
        var message = new $root.NexaTxInputRequest();
        if (object.request_index != null)
            message.request_index = object.request_index >>> 0;
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        return message;
    };

    NexaTxInputRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.request_index = 0;
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
        }
        if (message.request_index != null && message.hasOwnProperty("request_index"))
            object.request_index = message.request_index;
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        return object;
    };

    NexaTxInputRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NexaTxInputRequest;
})();

$root.NexaTxInputAck = (function() {

    function NexaTxInputAck(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NexaTxInputAck.prototype.address_n = $util.emptyArray;
    NexaTxInputAck.prototype.raw_message = $util.newBuffer([]);

    NexaTxInputAck.create = function create(properties) {
        return new NexaTxInputAck(properties);
    };

    NexaTxInputAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).bytes(message.raw_message);
        return writer;
    };

    NexaTxInputAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NexaTxInputAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NexaTxInputAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.raw_message = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("raw_message"))
            throw $util.ProtocolError("missing required 'raw_message'", { instance: message });
        return message;
    };

    NexaTxInputAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NexaTxInputAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!(message.raw_message && typeof message.raw_message.length === "number" || $util.isString(message.raw_message)))
            return "raw_message: buffer expected";
        return null;
    };

    NexaTxInputAck.fromObject = function fromObject(object) {
        if (object instanceof $root.NexaTxInputAck)
            return object;
        var message = new $root.NexaTxInputAck();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".NexaTxInputAck.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.raw_message != null)
            if (typeof object.raw_message === "string")
                $util.base64.decode(object.raw_message, message.raw_message = $util.newBuffer($util.base64.length(object.raw_message)), 0);
            else if (object.raw_message.length)
                message.raw_message = object.raw_message;
        return message;
    };

    NexaTxInputAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            if (options.bytes === String)
                object.raw_message = "";
            else {
                object.raw_message = [];
                if (options.bytes !== Array)
                    object.raw_message = $util.newBuffer(object.raw_message);
            }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.raw_message != null && message.hasOwnProperty("raw_message"))
            object.raw_message = options.bytes === String ? $util.base64.encode(message.raw_message, 0, message.raw_message.length) : options.bytes === Array ? Array.prototype.slice.call(message.raw_message) : message.raw_message;
        return object;
    };

    NexaTxInputAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NexaTxInputAck;
})();

$root.NexaSignedTx = (function() {

    function NexaSignedTx(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NexaSignedTx.prototype.signature = $util.newBuffer([]);

    NexaSignedTx.create = function create(properties) {
        return new NexaSignedTx(properties);
    };

    NexaSignedTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.signature);
        return writer;
    };

    NexaSignedTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NexaSignedTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NexaSignedTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.signature = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        return message;
    };

    NexaSignedTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NexaSignedTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        return null;
    };

    NexaSignedTx.fromObject = function fromObject(object) {
        if (object instanceof $root.NexaSignedTx)
            return object;
        var message = new $root.NexaSignedTx();
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        return message;
    };

    NexaSignedTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        return object;
    };

    NexaSignedTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NexaSignedTx;
})();

$root.PolkadotGetAddress = (function() {

    function PolkadotGetAddress(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    PolkadotGetAddress.prototype.address_n = $util.emptyArray;
    PolkadotGetAddress.prototype.prefix = 0;
    PolkadotGetAddress.prototype.network = "";
    PolkadotGetAddress.prototype.show_display = false;

    PolkadotGetAddress.create = function create(properties) {
        return new PolkadotGetAddress(properties);
    };

    PolkadotGetAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(16).uint32(message.prefix);
        writer.uint32(26).string(message.network);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(32).bool(message.show_display);
        return writer;
    };

    PolkadotGetAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    PolkadotGetAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.PolkadotGetAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.prefix = reader.uint32();
                break;
            case 3:
                message.network = reader.string();
                break;
            case 4:
                message.show_display = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("prefix"))
            throw $util.ProtocolError("missing required 'prefix'", { instance: message });
        if (!message.hasOwnProperty("network"))
            throw $util.ProtocolError("missing required 'network'", { instance: message });
        return message;
    };

    PolkadotGetAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    PolkadotGetAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!$util.isInteger(message.prefix))
            return "prefix: integer expected";
        if (!$util.isString(message.network))
            return "network: string expected";
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        return null;
    };

    PolkadotGetAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.PolkadotGetAddress)
            return object;
        var message = new $root.PolkadotGetAddress();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".PolkadotGetAddress.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.prefix != null)
            message.prefix = object.prefix >>> 0;
        if (object.network != null)
            message.network = String(object.network);
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        return message;
    };

    PolkadotGetAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            object.prefix = 0;
            object.network = "";
            object.show_display = false;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.prefix != null && message.hasOwnProperty("prefix"))
            object.prefix = message.prefix;
        if (message.network != null && message.hasOwnProperty("network"))
            object.network = message.network;
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        return object;
    };

    PolkadotGetAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return PolkadotGetAddress;
})();

$root.PolkadotAddress = (function() {

    function PolkadotAddress(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    PolkadotAddress.prototype.address = "";
    PolkadotAddress.prototype.public_key = "";

    PolkadotAddress.create = function create(properties) {
        return new PolkadotAddress(properties);
    };

    PolkadotAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address != null && Object.hasOwnProperty.call(message, "address"))
            writer.uint32(10).string(message.address);
        if (message.public_key != null && Object.hasOwnProperty.call(message, "public_key"))
            writer.uint32(18).string(message.public_key);
        return writer;
    };

    PolkadotAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    PolkadotAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.PolkadotAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.string();
                break;
            case 2:
                message.public_key = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    PolkadotAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    PolkadotAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address != null && message.hasOwnProperty("address"))
            if (!$util.isString(message.address))
                return "address: string expected";
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            if (!$util.isString(message.public_key))
                return "public_key: string expected";
        return null;
    };

    PolkadotAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.PolkadotAddress)
            return object;
        var message = new $root.PolkadotAddress();
        if (object.address != null)
            message.address = String(object.address);
        if (object.public_key != null)
            message.public_key = String(object.public_key);
        return message;
    };

    PolkadotAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.address = "";
            object.public_key = "";
        }
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            object.public_key = message.public_key;
        return object;
    };

    PolkadotAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return PolkadotAddress;
})();

$root.PolkadotSignTx = (function() {

    function PolkadotSignTx(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    PolkadotSignTx.prototype.address_n = $util.emptyArray;
    PolkadotSignTx.prototype.raw_tx = $util.newBuffer([]);
    PolkadotSignTx.prototype.network = "";

    PolkadotSignTx.create = function create(properties) {
        return new PolkadotSignTx(properties);
    };

    PolkadotSignTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).bytes(message.raw_tx);
        writer.uint32(26).string(message.network);
        return writer;
    };

    PolkadotSignTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    PolkadotSignTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.PolkadotSignTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.raw_tx = reader.bytes();
                break;
            case 3:
                message.network = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("raw_tx"))
            throw $util.ProtocolError("missing required 'raw_tx'", { instance: message });
        if (!message.hasOwnProperty("network"))
            throw $util.ProtocolError("missing required 'network'", { instance: message });
        return message;
    };

    PolkadotSignTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    PolkadotSignTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!(message.raw_tx && typeof message.raw_tx.length === "number" || $util.isString(message.raw_tx)))
            return "raw_tx: buffer expected";
        if (!$util.isString(message.network))
            return "network: string expected";
        return null;
    };

    PolkadotSignTx.fromObject = function fromObject(object) {
        if (object instanceof $root.PolkadotSignTx)
            return object;
        var message = new $root.PolkadotSignTx();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".PolkadotSignTx.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.raw_tx != null)
            if (typeof object.raw_tx === "string")
                $util.base64.decode(object.raw_tx, message.raw_tx = $util.newBuffer($util.base64.length(object.raw_tx)), 0);
            else if (object.raw_tx.length)
                message.raw_tx = object.raw_tx;
        if (object.network != null)
            message.network = String(object.network);
        return message;
    };

    PolkadotSignTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            if (options.bytes === String)
                object.raw_tx = "";
            else {
                object.raw_tx = [];
                if (options.bytes !== Array)
                    object.raw_tx = $util.newBuffer(object.raw_tx);
            }
            object.network = "";
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.raw_tx != null && message.hasOwnProperty("raw_tx"))
            object.raw_tx = options.bytes === String ? $util.base64.encode(message.raw_tx, 0, message.raw_tx.length) : options.bytes === Array ? Array.prototype.slice.call(message.raw_tx) : message.raw_tx;
        if (message.network != null && message.hasOwnProperty("network"))
            object.network = message.network;
        return object;
    };

    PolkadotSignTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return PolkadotSignTx;
})();

$root.PolkadotSignedTx = (function() {

    function PolkadotSignedTx(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    PolkadotSignedTx.prototype.signature = $util.newBuffer([]);

    PolkadotSignedTx.create = function create(properties) {
        return new PolkadotSignedTx(properties);
    };

    PolkadotSignedTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.signature);
        return writer;
    };

    PolkadotSignedTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    PolkadotSignedTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.PolkadotSignedTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.signature = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        return message;
    };

    PolkadotSignedTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    PolkadotSignedTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        return null;
    };

    PolkadotSignedTx.fromObject = function fromObject(object) {
        if (object instanceof $root.PolkadotSignedTx)
            return object;
        var message = new $root.PolkadotSignedTx();
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        return message;
    };

    PolkadotSignedTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        return object;
    };

    PolkadotSignedTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return PolkadotSignedTx;
})();

$root.RippleGetAddress = (function() {

    function RippleGetAddress(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    RippleGetAddress.prototype.address_n = $util.emptyArray;
    RippleGetAddress.prototype.show_display = false;

    RippleGetAddress.create = function create(properties) {
        return new RippleGetAddress(properties);
    };

    RippleGetAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(16).bool(message.show_display);
        return writer;
    };

    RippleGetAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    RippleGetAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.RippleGetAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.show_display = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    RippleGetAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    RippleGetAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        return null;
    };

    RippleGetAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.RippleGetAddress)
            return object;
        var message = new $root.RippleGetAddress();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".RippleGetAddress.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        return message;
    };

    RippleGetAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            object.show_display = false;
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        return object;
    };

    RippleGetAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return RippleGetAddress;
})();

$root.RippleAddress = (function() {

    function RippleAddress(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    RippleAddress.prototype.address = "";

    RippleAddress.create = function create(properties) {
        return new RippleAddress(properties);
    };

    RippleAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.address);
        return writer;
    };

    RippleAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    RippleAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.RippleAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("address"))
            throw $util.ProtocolError("missing required 'address'", { instance: message });
        return message;
    };

    RippleAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    RippleAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.address))
            return "address: string expected";
        return null;
    };

    RippleAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.RippleAddress)
            return object;
        var message = new $root.RippleAddress();
        if (object.address != null)
            message.address = String(object.address);
        return message;
    };

    RippleAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.address = "";
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    RippleAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return RippleAddress;
})();

$root.RippleSignTx = (function() {

    function RippleSignTx(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    RippleSignTx.prototype.address_n = $util.emptyArray;
    RippleSignTx.prototype.fee = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    RippleSignTx.prototype.flags = 0;
    RippleSignTx.prototype.sequence = 0;
    RippleSignTx.prototype.last_ledger_sequence = 0;
    RippleSignTx.prototype.payment = null;

    RippleSignTx.create = function create(properties) {
        return new RippleSignTx(properties);
    };

    RippleSignTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.fee != null && Object.hasOwnProperty.call(message, "fee"))
            writer.uint32(16).uint64(message.fee);
        if (message.flags != null && Object.hasOwnProperty.call(message, "flags"))
            writer.uint32(24).uint32(message.flags);
        if (message.sequence != null && Object.hasOwnProperty.call(message, "sequence"))
            writer.uint32(32).uint32(message.sequence);
        if (message.last_ledger_sequence != null && Object.hasOwnProperty.call(message, "last_ledger_sequence"))
            writer.uint32(40).uint32(message.last_ledger_sequence);
        if (message.payment != null && Object.hasOwnProperty.call(message, "payment"))
            $root.RippleSignTx.RipplePayment.encode(message.payment, writer.uint32(50).fork()).ldelim();
        return writer;
    };

    RippleSignTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    RippleSignTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.RippleSignTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.fee = reader.uint64();
                break;
            case 3:
                message.flags = reader.uint32();
                break;
            case 4:
                message.sequence = reader.uint32();
                break;
            case 5:
                message.last_ledger_sequence = reader.uint32();
                break;
            case 6:
                message.payment = $root.RippleSignTx.RipplePayment.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    RippleSignTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    RippleSignTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.fee != null && message.hasOwnProperty("fee"))
            if (!$util.isInteger(message.fee) && !(message.fee && $util.isInteger(message.fee.low) && $util.isInteger(message.fee.high)))
                return "fee: integer|Long expected";
        if (message.flags != null && message.hasOwnProperty("flags"))
            if (!$util.isInteger(message.flags))
                return "flags: integer expected";
        if (message.sequence != null && message.hasOwnProperty("sequence"))
            if (!$util.isInteger(message.sequence))
                return "sequence: integer expected";
        if (message.last_ledger_sequence != null && message.hasOwnProperty("last_ledger_sequence"))
            if (!$util.isInteger(message.last_ledger_sequence))
                return "last_ledger_sequence: integer expected";
        if (message.payment != null && message.hasOwnProperty("payment")) {
            var error = $root.RippleSignTx.RipplePayment.verify(message.payment);
            if (error)
                return "payment." + error;
        }
        return null;
    };

    RippleSignTx.fromObject = function fromObject(object) {
        if (object instanceof $root.RippleSignTx)
            return object;
        var message = new $root.RippleSignTx();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".RippleSignTx.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.fee != null)
            if ($util.Long)
                (message.fee = $util.Long.fromValue(object.fee)).unsigned = true;
            else if (typeof object.fee === "string")
                message.fee = parseInt(object.fee, 10);
            else if (typeof object.fee === "number")
                message.fee = object.fee;
            else if (typeof object.fee === "object")
                message.fee = new $util.LongBits(object.fee.low >>> 0, object.fee.high >>> 0).toNumber(true);
        if (object.flags != null)
            message.flags = object.flags >>> 0;
        if (object.sequence != null)
            message.sequence = object.sequence >>> 0;
        if (object.last_ledger_sequence != null)
            message.last_ledger_sequence = object.last_ledger_sequence >>> 0;
        if (object.payment != null) {
            if (typeof object.payment !== "object")
                throw TypeError(".RippleSignTx.payment: object expected");
            message.payment = $root.RippleSignTx.RipplePayment.fromObject(object.payment);
        }
        return message;
    };

    RippleSignTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.fee = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.fee = options.longs === String ? "0" : 0;
            object.flags = 0;
            object.sequence = 0;
            object.last_ledger_sequence = 0;
            object.payment = null;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.fee != null && message.hasOwnProperty("fee"))
            if (typeof message.fee === "number")
                object.fee = options.longs === String ? String(message.fee) : message.fee;
            else
                object.fee = options.longs === String ? $util.Long.prototype.toString.call(message.fee) : options.longs === Number ? new $util.LongBits(message.fee.low >>> 0, message.fee.high >>> 0).toNumber(true) : message.fee;
        if (message.flags != null && message.hasOwnProperty("flags"))
            object.flags = message.flags;
        if (message.sequence != null && message.hasOwnProperty("sequence"))
            object.sequence = message.sequence;
        if (message.last_ledger_sequence != null && message.hasOwnProperty("last_ledger_sequence"))
            object.last_ledger_sequence = message.last_ledger_sequence;
        if (message.payment != null && message.hasOwnProperty("payment"))
            object.payment = $root.RippleSignTx.RipplePayment.toObject(message.payment, options);
        return object;
    };

    RippleSignTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    RippleSignTx.RipplePayment = (function() {

        function RipplePayment(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        RipplePayment.prototype.amount = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        RipplePayment.prototype.destination = "";
        RipplePayment.prototype.destination_tag = 0;

        RipplePayment.create = function create(properties) {
            return new RipplePayment(properties);
        };

        RipplePayment.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(8).uint64(message.amount);
            writer.uint32(18).string(message.destination);
            if (message.destination_tag != null && Object.hasOwnProperty.call(message, "destination_tag"))
                writer.uint32(24).uint32(message.destination_tag);
            return writer;
        };

        RipplePayment.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        RipplePayment.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.RippleSignTx.RipplePayment();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.amount = reader.uint64();
                    break;
                case 2:
                    message.destination = reader.string();
                    break;
                case 3:
                    message.destination_tag = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("amount"))
                throw $util.ProtocolError("missing required 'amount'", { instance: message });
            if (!message.hasOwnProperty("destination"))
                throw $util.ProtocolError("missing required 'destination'", { instance: message });
            return message;
        };

        RipplePayment.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        RipplePayment.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
                return "amount: integer|Long expected";
            if (!$util.isString(message.destination))
                return "destination: string expected";
            if (message.destination_tag != null && message.hasOwnProperty("destination_tag"))
                if (!$util.isInteger(message.destination_tag))
                    return "destination_tag: integer expected";
            return null;
        };

        RipplePayment.fromObject = function fromObject(object) {
            if (object instanceof $root.RippleSignTx.RipplePayment)
                return object;
            var message = new $root.RippleSignTx.RipplePayment();
            if (object.amount != null)
                if ($util.Long)
                    (message.amount = $util.Long.fromValue(object.amount)).unsigned = true;
                else if (typeof object.amount === "string")
                    message.amount = parseInt(object.amount, 10);
                else if (typeof object.amount === "number")
                    message.amount = object.amount;
                else if (typeof object.amount === "object")
                    message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber(true);
            if (object.destination != null)
                message.destination = String(object.destination);
            if (object.destination_tag != null)
                message.destination_tag = object.destination_tag >>> 0;
            return message;
        };

        RipplePayment.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.amount = options.longs === String ? "0" : 0;
                object.destination = "";
                object.destination_tag = 0;
            }
            if (message.amount != null && message.hasOwnProperty("amount"))
                if (typeof message.amount === "number")
                    object.amount = options.longs === String ? String(message.amount) : message.amount;
                else
                    object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber(true) : message.amount;
            if (message.destination != null && message.hasOwnProperty("destination"))
                object.destination = message.destination;
            if (message.destination_tag != null && message.hasOwnProperty("destination_tag"))
                object.destination_tag = message.destination_tag;
            return object;
        };

        RipplePayment.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RipplePayment;
    })();

    return RippleSignTx;
})();

$root.RippleSignedTx = (function() {

    function RippleSignedTx(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    RippleSignedTx.prototype.signature = $util.newBuffer([]);
    RippleSignedTx.prototype.serialized_tx = $util.newBuffer([]);

    RippleSignedTx.create = function create(properties) {
        return new RippleSignedTx(properties);
    };

    RippleSignedTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.signature);
        writer.uint32(18).bytes(message.serialized_tx);
        return writer;
    };

    RippleSignedTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    RippleSignedTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.RippleSignedTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.signature = reader.bytes();
                break;
            case 2:
                message.serialized_tx = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        if (!message.hasOwnProperty("serialized_tx"))
            throw $util.ProtocolError("missing required 'serialized_tx'", { instance: message });
        return message;
    };

    RippleSignedTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    RippleSignedTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        if (!(message.serialized_tx && typeof message.serialized_tx.length === "number" || $util.isString(message.serialized_tx)))
            return "serialized_tx: buffer expected";
        return null;
    };

    RippleSignedTx.fromObject = function fromObject(object) {
        if (object instanceof $root.RippleSignedTx)
            return object;
        var message = new $root.RippleSignedTx();
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        if (object.serialized_tx != null)
            if (typeof object.serialized_tx === "string")
                $util.base64.decode(object.serialized_tx, message.serialized_tx = $util.newBuffer($util.base64.length(object.serialized_tx)), 0);
            else if (object.serialized_tx.length)
                message.serialized_tx = object.serialized_tx;
        return message;
    };

    RippleSignedTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
            if (options.bytes === String)
                object.serialized_tx = "";
            else {
                object.serialized_tx = [];
                if (options.bytes !== Array)
                    object.serialized_tx = $util.newBuffer(object.serialized_tx);
            }
        }
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        if (message.serialized_tx != null && message.hasOwnProperty("serialized_tx"))
            object.serialized_tx = options.bytes === String ? $util.base64.encode(message.serialized_tx, 0, message.serialized_tx.length) : options.bytes === Array ? Array.prototype.slice.call(message.serialized_tx) : message.serialized_tx;
        return object;
    };

    RippleSignedTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return RippleSignedTx;
})();

$root.SolanaGetAddress = (function() {

    function SolanaGetAddress(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    SolanaGetAddress.prototype.address_n = $util.emptyArray;
    SolanaGetAddress.prototype.show_display = false;

    SolanaGetAddress.create = function create(properties) {
        return new SolanaGetAddress(properties);
    };

    SolanaGetAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(16).bool(message.show_display);
        return writer;
    };

    SolanaGetAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    SolanaGetAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SolanaGetAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.show_display = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    SolanaGetAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    SolanaGetAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        return null;
    };

    SolanaGetAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.SolanaGetAddress)
            return object;
        var message = new $root.SolanaGetAddress();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".SolanaGetAddress.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        return message;
    };

    SolanaGetAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            object.show_display = false;
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        return object;
    };

    SolanaGetAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SolanaGetAddress;
})();

$root.SolanaAddress = (function() {

    function SolanaAddress(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    SolanaAddress.prototype.address = "";

    SolanaAddress.create = function create(properties) {
        return new SolanaAddress(properties);
    };

    SolanaAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address != null && Object.hasOwnProperty.call(message, "address"))
            writer.uint32(10).string(message.address);
        return writer;
    };

    SolanaAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    SolanaAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SolanaAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    SolanaAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    SolanaAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address != null && message.hasOwnProperty("address"))
            if (!$util.isString(message.address))
                return "address: string expected";
        return null;
    };

    SolanaAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.SolanaAddress)
            return object;
        var message = new $root.SolanaAddress();
        if (object.address != null)
            message.address = String(object.address);
        return message;
    };

    SolanaAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.address = "";
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    SolanaAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SolanaAddress;
})();

$root.SolanaSignTx = (function() {

    function SolanaSignTx(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    SolanaSignTx.prototype.address_n = $util.emptyArray;
    SolanaSignTx.prototype.raw_tx = $util.newBuffer([]);

    SolanaSignTx.create = function create(properties) {
        return new SolanaSignTx(properties);
    };

    SolanaSignTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).bytes(message.raw_tx);
        return writer;
    };

    SolanaSignTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    SolanaSignTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SolanaSignTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.raw_tx = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("raw_tx"))
            throw $util.ProtocolError("missing required 'raw_tx'", { instance: message });
        return message;
    };

    SolanaSignTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    SolanaSignTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!(message.raw_tx && typeof message.raw_tx.length === "number" || $util.isString(message.raw_tx)))
            return "raw_tx: buffer expected";
        return null;
    };

    SolanaSignTx.fromObject = function fromObject(object) {
        if (object instanceof $root.SolanaSignTx)
            return object;
        var message = new $root.SolanaSignTx();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".SolanaSignTx.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.raw_tx != null)
            if (typeof object.raw_tx === "string")
                $util.base64.decode(object.raw_tx, message.raw_tx = $util.newBuffer($util.base64.length(object.raw_tx)), 0);
            else if (object.raw_tx.length)
                message.raw_tx = object.raw_tx;
        return message;
    };

    SolanaSignTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            if (options.bytes === String)
                object.raw_tx = "";
            else {
                object.raw_tx = [];
                if (options.bytes !== Array)
                    object.raw_tx = $util.newBuffer(object.raw_tx);
            }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.raw_tx != null && message.hasOwnProperty("raw_tx"))
            object.raw_tx = options.bytes === String ? $util.base64.encode(message.raw_tx, 0, message.raw_tx.length) : options.bytes === Array ? Array.prototype.slice.call(message.raw_tx) : message.raw_tx;
        return object;
    };

    SolanaSignTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SolanaSignTx;
})();

$root.SolanaSignedTx = (function() {

    function SolanaSignedTx(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    SolanaSignedTx.prototype.signature = $util.newBuffer([]);

    SolanaSignedTx.create = function create(properties) {
        return new SolanaSignedTx(properties);
    };

    SolanaSignedTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.signature != null && Object.hasOwnProperty.call(message, "signature"))
            writer.uint32(10).bytes(message.signature);
        return writer;
    };

    SolanaSignedTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    SolanaSignedTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SolanaSignedTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.signature = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    SolanaSignedTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    SolanaSignedTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.signature != null && message.hasOwnProperty("signature"))
            if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
                return "signature: buffer expected";
        return null;
    };

    SolanaSignedTx.fromObject = function fromObject(object) {
        if (object instanceof $root.SolanaSignedTx)
            return object;
        var message = new $root.SolanaSignedTx();
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        return message;
    };

    SolanaSignedTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        return object;
    };

    SolanaSignedTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SolanaSignedTx;
})();

$root.StarcoinGetAddress = (function() {

    function StarcoinGetAddress(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    StarcoinGetAddress.prototype.address_n = $util.emptyArray;
    StarcoinGetAddress.prototype.show_display = false;

    StarcoinGetAddress.create = function create(properties) {
        return new StarcoinGetAddress(properties);
    };

    StarcoinGetAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(16).bool(message.show_display);
        return writer;
    };

    StarcoinGetAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    StarcoinGetAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.StarcoinGetAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.show_display = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    StarcoinGetAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    StarcoinGetAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        return null;
    };

    StarcoinGetAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.StarcoinGetAddress)
            return object;
        var message = new $root.StarcoinGetAddress();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".StarcoinGetAddress.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        return message;
    };

    StarcoinGetAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            object.show_display = false;
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        return object;
    };

    StarcoinGetAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return StarcoinGetAddress;
})();

$root.StarcoinAddress = (function() {

    function StarcoinAddress(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    StarcoinAddress.prototype.address = "";

    StarcoinAddress.create = function create(properties) {
        return new StarcoinAddress(properties);
    };

    StarcoinAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address != null && Object.hasOwnProperty.call(message, "address"))
            writer.uint32(10).string(message.address);
        return writer;
    };

    StarcoinAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    StarcoinAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.StarcoinAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    StarcoinAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    StarcoinAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address != null && message.hasOwnProperty("address"))
            if (!$util.isString(message.address))
                return "address: string expected";
        return null;
    };

    StarcoinAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.StarcoinAddress)
            return object;
        var message = new $root.StarcoinAddress();
        if (object.address != null)
            message.address = String(object.address);
        return message;
    };

    StarcoinAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.address = "";
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    StarcoinAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return StarcoinAddress;
})();

$root.StarcoinGetPublicKey = (function() {

    function StarcoinGetPublicKey(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    StarcoinGetPublicKey.prototype.address_n = $util.emptyArray;
    StarcoinGetPublicKey.prototype.show_display = false;

    StarcoinGetPublicKey.create = function create(properties) {
        return new StarcoinGetPublicKey(properties);
    };

    StarcoinGetPublicKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(16).bool(message.show_display);
        return writer;
    };

    StarcoinGetPublicKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    StarcoinGetPublicKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.StarcoinGetPublicKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.show_display = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    StarcoinGetPublicKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    StarcoinGetPublicKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        return null;
    };

    StarcoinGetPublicKey.fromObject = function fromObject(object) {
        if (object instanceof $root.StarcoinGetPublicKey)
            return object;
        var message = new $root.StarcoinGetPublicKey();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".StarcoinGetPublicKey.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        return message;
    };

    StarcoinGetPublicKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            object.show_display = false;
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        return object;
    };

    StarcoinGetPublicKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return StarcoinGetPublicKey;
})();

$root.StarcoinPublicKey = (function() {

    function StarcoinPublicKey(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    StarcoinPublicKey.prototype.public_key = $util.newBuffer([]);

    StarcoinPublicKey.create = function create(properties) {
        return new StarcoinPublicKey(properties);
    };

    StarcoinPublicKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.public_key);
        return writer;
    };

    StarcoinPublicKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    StarcoinPublicKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.StarcoinPublicKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.public_key = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("public_key"))
            throw $util.ProtocolError("missing required 'public_key'", { instance: message });
        return message;
    };

    StarcoinPublicKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    StarcoinPublicKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.public_key && typeof message.public_key.length === "number" || $util.isString(message.public_key)))
            return "public_key: buffer expected";
        return null;
    };

    StarcoinPublicKey.fromObject = function fromObject(object) {
        if (object instanceof $root.StarcoinPublicKey)
            return object;
        var message = new $root.StarcoinPublicKey();
        if (object.public_key != null)
            if (typeof object.public_key === "string")
                $util.base64.decode(object.public_key, message.public_key = $util.newBuffer($util.base64.length(object.public_key)), 0);
            else if (object.public_key.length)
                message.public_key = object.public_key;
        return message;
    };

    StarcoinPublicKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.public_key = "";
            else {
                object.public_key = [];
                if (options.bytes !== Array)
                    object.public_key = $util.newBuffer(object.public_key);
            }
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            object.public_key = options.bytes === String ? $util.base64.encode(message.public_key, 0, message.public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.public_key) : message.public_key;
        return object;
    };

    StarcoinPublicKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return StarcoinPublicKey;
})();

$root.StarcoinSignTx = (function() {

    function StarcoinSignTx(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    StarcoinSignTx.prototype.address_n = $util.emptyArray;
    StarcoinSignTx.prototype.raw_tx = $util.newBuffer([]);

    StarcoinSignTx.create = function create(properties) {
        return new StarcoinSignTx(properties);
    };

    StarcoinSignTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.raw_tx != null && Object.hasOwnProperty.call(message, "raw_tx"))
            writer.uint32(18).bytes(message.raw_tx);
        return writer;
    };

    StarcoinSignTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    StarcoinSignTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.StarcoinSignTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.raw_tx = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    StarcoinSignTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    StarcoinSignTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.raw_tx != null && message.hasOwnProperty("raw_tx"))
            if (!(message.raw_tx && typeof message.raw_tx.length === "number" || $util.isString(message.raw_tx)))
                return "raw_tx: buffer expected";
        return null;
    };

    StarcoinSignTx.fromObject = function fromObject(object) {
        if (object instanceof $root.StarcoinSignTx)
            return object;
        var message = new $root.StarcoinSignTx();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".StarcoinSignTx.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.raw_tx != null)
            if (typeof object.raw_tx === "string")
                $util.base64.decode(object.raw_tx, message.raw_tx = $util.newBuffer($util.base64.length(object.raw_tx)), 0);
            else if (object.raw_tx.length)
                message.raw_tx = object.raw_tx;
        return message;
    };

    StarcoinSignTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            if (options.bytes === String)
                object.raw_tx = "";
            else {
                object.raw_tx = [];
                if (options.bytes !== Array)
                    object.raw_tx = $util.newBuffer(object.raw_tx);
            }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.raw_tx != null && message.hasOwnProperty("raw_tx"))
            object.raw_tx = options.bytes === String ? $util.base64.encode(message.raw_tx, 0, message.raw_tx.length) : options.bytes === Array ? Array.prototype.slice.call(message.raw_tx) : message.raw_tx;
        return object;
    };

    StarcoinSignTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return StarcoinSignTx;
})();

$root.StarcoinSignedTx = (function() {

    function StarcoinSignedTx(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    StarcoinSignedTx.prototype.public_key = $util.newBuffer([]);
    StarcoinSignedTx.prototype.signature = $util.newBuffer([]);

    StarcoinSignedTx.create = function create(properties) {
        return new StarcoinSignedTx(properties);
    };

    StarcoinSignedTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.public_key);
        writer.uint32(18).bytes(message.signature);
        return writer;
    };

    StarcoinSignedTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    StarcoinSignedTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.StarcoinSignedTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.public_key = reader.bytes();
                break;
            case 2:
                message.signature = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("public_key"))
            throw $util.ProtocolError("missing required 'public_key'", { instance: message });
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        return message;
    };

    StarcoinSignedTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    StarcoinSignedTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.public_key && typeof message.public_key.length === "number" || $util.isString(message.public_key)))
            return "public_key: buffer expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        return null;
    };

    StarcoinSignedTx.fromObject = function fromObject(object) {
        if (object instanceof $root.StarcoinSignedTx)
            return object;
        var message = new $root.StarcoinSignedTx();
        if (object.public_key != null)
            if (typeof object.public_key === "string")
                $util.base64.decode(object.public_key, message.public_key = $util.newBuffer($util.base64.length(object.public_key)), 0);
            else if (object.public_key.length)
                message.public_key = object.public_key;
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        return message;
    };

    StarcoinSignedTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.public_key = "";
            else {
                object.public_key = [];
                if (options.bytes !== Array)
                    object.public_key = $util.newBuffer(object.public_key);
            }
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
        }
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            object.public_key = options.bytes === String ? $util.base64.encode(message.public_key, 0, message.public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.public_key) : message.public_key;
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        return object;
    };

    StarcoinSignedTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return StarcoinSignedTx;
})();

$root.StarcoinSignMessage = (function() {

    function StarcoinSignMessage(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    StarcoinSignMessage.prototype.address_n = $util.emptyArray;
    StarcoinSignMessage.prototype.message = $util.newBuffer([]);

    StarcoinSignMessage.create = function create(properties) {
        return new StarcoinSignMessage(properties);
    };

    StarcoinSignMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
            writer.uint32(18).bytes(message.message);
        return writer;
    };

    StarcoinSignMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    StarcoinSignMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.StarcoinSignMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.message = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    StarcoinSignMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    StarcoinSignMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.message != null && message.hasOwnProperty("message"))
            if (!(message.message && typeof message.message.length === "number" || $util.isString(message.message)))
                return "message: buffer expected";
        return null;
    };

    StarcoinSignMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.StarcoinSignMessage)
            return object;
        var message = new $root.StarcoinSignMessage();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".StarcoinSignMessage.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.message != null)
            if (typeof object.message === "string")
                $util.base64.decode(object.message, message.message = $util.newBuffer($util.base64.length(object.message)), 0);
            else if (object.message.length)
                message.message = object.message;
        return message;
    };

    StarcoinSignMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            if (options.bytes === String)
                object.message = "";
            else {
                object.message = [];
                if (options.bytes !== Array)
                    object.message = $util.newBuffer(object.message);
            }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.message != null && message.hasOwnProperty("message"))
            object.message = options.bytes === String ? $util.base64.encode(message.message, 0, message.message.length) : options.bytes === Array ? Array.prototype.slice.call(message.message) : message.message;
        return object;
    };

    StarcoinSignMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return StarcoinSignMessage;
})();

$root.StarcoinMessageSignature = (function() {

    function StarcoinMessageSignature(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    StarcoinMessageSignature.prototype.public_key = $util.newBuffer([]);
    StarcoinMessageSignature.prototype.signature = $util.newBuffer([]);

    StarcoinMessageSignature.create = function create(properties) {
        return new StarcoinMessageSignature(properties);
    };

    StarcoinMessageSignature.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.public_key);
        writer.uint32(18).bytes(message.signature);
        return writer;
    };

    StarcoinMessageSignature.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    StarcoinMessageSignature.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.StarcoinMessageSignature();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.public_key = reader.bytes();
                break;
            case 2:
                message.signature = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("public_key"))
            throw $util.ProtocolError("missing required 'public_key'", { instance: message });
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        return message;
    };

    StarcoinMessageSignature.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    StarcoinMessageSignature.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.public_key && typeof message.public_key.length === "number" || $util.isString(message.public_key)))
            return "public_key: buffer expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        return null;
    };

    StarcoinMessageSignature.fromObject = function fromObject(object) {
        if (object instanceof $root.StarcoinMessageSignature)
            return object;
        var message = new $root.StarcoinMessageSignature();
        if (object.public_key != null)
            if (typeof object.public_key === "string")
                $util.base64.decode(object.public_key, message.public_key = $util.newBuffer($util.base64.length(object.public_key)), 0);
            else if (object.public_key.length)
                message.public_key = object.public_key;
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        return message;
    };

    StarcoinMessageSignature.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.public_key = "";
            else {
                object.public_key = [];
                if (options.bytes !== Array)
                    object.public_key = $util.newBuffer(object.public_key);
            }
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
        }
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            object.public_key = options.bytes === String ? $util.base64.encode(message.public_key, 0, message.public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.public_key) : message.public_key;
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        return object;
    };

    StarcoinMessageSignature.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return StarcoinMessageSignature;
})();

$root.StarcoinVerifyMessage = (function() {

    function StarcoinVerifyMessage(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    StarcoinVerifyMessage.prototype.public_key = $util.newBuffer([]);
    StarcoinVerifyMessage.prototype.signature = $util.newBuffer([]);
    StarcoinVerifyMessage.prototype.message = $util.newBuffer([]);

    StarcoinVerifyMessage.create = function create(properties) {
        return new StarcoinVerifyMessage(properties);
    };

    StarcoinVerifyMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.public_key != null && Object.hasOwnProperty.call(message, "public_key"))
            writer.uint32(10).bytes(message.public_key);
        if (message.signature != null && Object.hasOwnProperty.call(message, "signature"))
            writer.uint32(18).bytes(message.signature);
        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
            writer.uint32(26).bytes(message.message);
        return writer;
    };

    StarcoinVerifyMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    StarcoinVerifyMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.StarcoinVerifyMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.public_key = reader.bytes();
                break;
            case 2:
                message.signature = reader.bytes();
                break;
            case 3:
                message.message = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    StarcoinVerifyMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    StarcoinVerifyMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            if (!(message.public_key && typeof message.public_key.length === "number" || $util.isString(message.public_key)))
                return "public_key: buffer expected";
        if (message.signature != null && message.hasOwnProperty("signature"))
            if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
                return "signature: buffer expected";
        if (message.message != null && message.hasOwnProperty("message"))
            if (!(message.message && typeof message.message.length === "number" || $util.isString(message.message)))
                return "message: buffer expected";
        return null;
    };

    StarcoinVerifyMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.StarcoinVerifyMessage)
            return object;
        var message = new $root.StarcoinVerifyMessage();
        if (object.public_key != null)
            if (typeof object.public_key === "string")
                $util.base64.decode(object.public_key, message.public_key = $util.newBuffer($util.base64.length(object.public_key)), 0);
            else if (object.public_key.length)
                message.public_key = object.public_key;
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        if (object.message != null)
            if (typeof object.message === "string")
                $util.base64.decode(object.message, message.message = $util.newBuffer($util.base64.length(object.message)), 0);
            else if (object.message.length)
                message.message = object.message;
        return message;
    };

    StarcoinVerifyMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.public_key = "";
            else {
                object.public_key = [];
                if (options.bytes !== Array)
                    object.public_key = $util.newBuffer(object.public_key);
            }
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
            if (options.bytes === String)
                object.message = "";
            else {
                object.message = [];
                if (options.bytes !== Array)
                    object.message = $util.newBuffer(object.message);
            }
        }
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            object.public_key = options.bytes === String ? $util.base64.encode(message.public_key, 0, message.public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.public_key) : message.public_key;
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        if (message.message != null && message.hasOwnProperty("message"))
            object.message = options.bytes === String ? $util.base64.encode(message.message, 0, message.message.length) : options.bytes === Array ? Array.prototype.slice.call(message.message) : message.message;
        return object;
    };

    StarcoinVerifyMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return StarcoinVerifyMessage;
})();

$root.StellarAssetType = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "NATIVE"] = 0;
    values[valuesById[1] = "ALPHANUM4"] = 1;
    values[valuesById[2] = "ALPHANUM12"] = 2;
    return values;
})();

$root.StellarAsset = (function() {

    function StellarAsset(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    StellarAsset.prototype.type = 0;
    StellarAsset.prototype.code = "";
    StellarAsset.prototype.issuer = "";

    StellarAsset.create = function create(properties) {
        return new StellarAsset(properties);
    };

    StellarAsset.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).int32(message.type);
        if (message.code != null && Object.hasOwnProperty.call(message, "code"))
            writer.uint32(18).string(message.code);
        if (message.issuer != null && Object.hasOwnProperty.call(message, "issuer"))
            writer.uint32(26).string(message.issuer);
        return writer;
    };

    StellarAsset.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    StellarAsset.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.StellarAsset();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.type = reader.int32();
                break;
            case 2:
                message.code = reader.string();
                break;
            case 3:
                message.issuer = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("type"))
            throw $util.ProtocolError("missing required 'type'", { instance: message });
        return message;
    };

    StellarAsset.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    StellarAsset.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        switch (message.type) {
        default:
            return "type: enum value expected";
        case 0:
        case 1:
        case 2:
            break;
        }
        if (message.code != null && message.hasOwnProperty("code"))
            if (!$util.isString(message.code))
                return "code: string expected";
        if (message.issuer != null && message.hasOwnProperty("issuer"))
            if (!$util.isString(message.issuer))
                return "issuer: string expected";
        return null;
    };

    StellarAsset.fromObject = function fromObject(object) {
        if (object instanceof $root.StellarAsset)
            return object;
        var message = new $root.StellarAsset();
        switch (object.type) {
        case "NATIVE":
        case 0:
            message.type = 0;
            break;
        case "ALPHANUM4":
        case 1:
            message.type = 1;
            break;
        case "ALPHANUM12":
        case 2:
            message.type = 2;
            break;
        }
        if (object.code != null)
            message.code = String(object.code);
        if (object.issuer != null)
            message.issuer = String(object.issuer);
        return message;
    };

    StellarAsset.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.type = options.enums === String ? "NATIVE" : 0;
            object.code = "";
            object.issuer = "";
        }
        if (message.type != null && message.hasOwnProperty("type"))
            object.type = options.enums === String ? $root.StellarAssetType[message.type] : message.type;
        if (message.code != null && message.hasOwnProperty("code"))
            object.code = message.code;
        if (message.issuer != null && message.hasOwnProperty("issuer"))
            object.issuer = message.issuer;
        return object;
    };

    StellarAsset.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return StellarAsset;
})();

$root.StellarGetAddress = (function() {

    function StellarGetAddress(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    StellarGetAddress.prototype.address_n = $util.emptyArray;
    StellarGetAddress.prototype.show_display = false;

    StellarGetAddress.create = function create(properties) {
        return new StellarGetAddress(properties);
    };

    StellarGetAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(16).bool(message.show_display);
        return writer;
    };

    StellarGetAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    StellarGetAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.StellarGetAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.show_display = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    StellarGetAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    StellarGetAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        return null;
    };

    StellarGetAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.StellarGetAddress)
            return object;
        var message = new $root.StellarGetAddress();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".StellarGetAddress.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        return message;
    };

    StellarGetAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            object.show_display = false;
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        return object;
    };

    StellarGetAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return StellarGetAddress;
})();

$root.StellarAddress = (function() {

    function StellarAddress(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    StellarAddress.prototype.address = "";

    StellarAddress.create = function create(properties) {
        return new StellarAddress(properties);
    };

    StellarAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.address);
        return writer;
    };

    StellarAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    StellarAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.StellarAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("address"))
            throw $util.ProtocolError("missing required 'address'", { instance: message });
        return message;
    };

    StellarAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    StellarAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.address))
            return "address: string expected";
        return null;
    };

    StellarAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.StellarAddress)
            return object;
        var message = new $root.StellarAddress();
        if (object.address != null)
            message.address = String(object.address);
        return message;
    };

    StellarAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.address = "";
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    StellarAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return StellarAddress;
})();

$root.StellarSignTx = (function() {

    function StellarSignTx(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    StellarSignTx.prototype.address_n = $util.emptyArray;
    StellarSignTx.prototype.network_passphrase = "";
    StellarSignTx.prototype.source_account = "";
    StellarSignTx.prototype.fee = 0;
    StellarSignTx.prototype.sequence_number = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    StellarSignTx.prototype.timebounds_start = 0;
    StellarSignTx.prototype.timebounds_end = 0;
    StellarSignTx.prototype.memo_type = 0;
    StellarSignTx.prototype.memo_text = "";
    StellarSignTx.prototype.memo_id = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    StellarSignTx.prototype.memo_hash = $util.newBuffer([]);
    StellarSignTx.prototype.num_operations = 0;

    StellarSignTx.create = function create(properties) {
        return new StellarSignTx(properties);
    };

    StellarSignTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(16).uint32(message.address_n[i]);
        writer.uint32(26).string(message.network_passphrase);
        writer.uint32(34).string(message.source_account);
        writer.uint32(40).uint32(message.fee);
        writer.uint32(48).uint64(message.sequence_number);
        writer.uint32(64).uint32(message.timebounds_start);
        writer.uint32(72).uint32(message.timebounds_end);
        writer.uint32(80).int32(message.memo_type);
        if (message.memo_text != null && Object.hasOwnProperty.call(message, "memo_text"))
            writer.uint32(90).string(message.memo_text);
        if (message.memo_id != null && Object.hasOwnProperty.call(message, "memo_id"))
            writer.uint32(96).uint64(message.memo_id);
        if (message.memo_hash != null && Object.hasOwnProperty.call(message, "memo_hash"))
            writer.uint32(106).bytes(message.memo_hash);
        writer.uint32(112).uint32(message.num_operations);
        return writer;
    };

    StellarSignTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    StellarSignTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.StellarSignTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 2:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 3:
                message.network_passphrase = reader.string();
                break;
            case 4:
                message.source_account = reader.string();
                break;
            case 5:
                message.fee = reader.uint32();
                break;
            case 6:
                message.sequence_number = reader.uint64();
                break;
            case 8:
                message.timebounds_start = reader.uint32();
                break;
            case 9:
                message.timebounds_end = reader.uint32();
                break;
            case 10:
                message.memo_type = reader.int32();
                break;
            case 11:
                message.memo_text = reader.string();
                break;
            case 12:
                message.memo_id = reader.uint64();
                break;
            case 13:
                message.memo_hash = reader.bytes();
                break;
            case 14:
                message.num_operations = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("network_passphrase"))
            throw $util.ProtocolError("missing required 'network_passphrase'", { instance: message });
        if (!message.hasOwnProperty("source_account"))
            throw $util.ProtocolError("missing required 'source_account'", { instance: message });
        if (!message.hasOwnProperty("fee"))
            throw $util.ProtocolError("missing required 'fee'", { instance: message });
        if (!message.hasOwnProperty("sequence_number"))
            throw $util.ProtocolError("missing required 'sequence_number'", { instance: message });
        if (!message.hasOwnProperty("timebounds_start"))
            throw $util.ProtocolError("missing required 'timebounds_start'", { instance: message });
        if (!message.hasOwnProperty("timebounds_end"))
            throw $util.ProtocolError("missing required 'timebounds_end'", { instance: message });
        if (!message.hasOwnProperty("memo_type"))
            throw $util.ProtocolError("missing required 'memo_type'", { instance: message });
        if (!message.hasOwnProperty("num_operations"))
            throw $util.ProtocolError("missing required 'num_operations'", { instance: message });
        return message;
    };

    StellarSignTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    StellarSignTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!$util.isString(message.network_passphrase))
            return "network_passphrase: string expected";
        if (!$util.isString(message.source_account))
            return "source_account: string expected";
        if (!$util.isInteger(message.fee))
            return "fee: integer expected";
        if (!$util.isInteger(message.sequence_number) && !(message.sequence_number && $util.isInteger(message.sequence_number.low) && $util.isInteger(message.sequence_number.high)))
            return "sequence_number: integer|Long expected";
        if (!$util.isInteger(message.timebounds_start))
            return "timebounds_start: integer expected";
        if (!$util.isInteger(message.timebounds_end))
            return "timebounds_end: integer expected";
        switch (message.memo_type) {
        default:
            return "memo_type: enum value expected";
        case 0:
        case 1:
        case 2:
        case 3:
        case 4:
            break;
        }
        if (message.memo_text != null && message.hasOwnProperty("memo_text"))
            if (!$util.isString(message.memo_text))
                return "memo_text: string expected";
        if (message.memo_id != null && message.hasOwnProperty("memo_id"))
            if (!$util.isInteger(message.memo_id) && !(message.memo_id && $util.isInteger(message.memo_id.low) && $util.isInteger(message.memo_id.high)))
                return "memo_id: integer|Long expected";
        if (message.memo_hash != null && message.hasOwnProperty("memo_hash"))
            if (!(message.memo_hash && typeof message.memo_hash.length === "number" || $util.isString(message.memo_hash)))
                return "memo_hash: buffer expected";
        if (!$util.isInteger(message.num_operations))
            return "num_operations: integer expected";
        return null;
    };

    StellarSignTx.fromObject = function fromObject(object) {
        if (object instanceof $root.StellarSignTx)
            return object;
        var message = new $root.StellarSignTx();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".StellarSignTx.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.network_passphrase != null)
            message.network_passphrase = String(object.network_passphrase);
        if (object.source_account != null)
            message.source_account = String(object.source_account);
        if (object.fee != null)
            message.fee = object.fee >>> 0;
        if (object.sequence_number != null)
            if ($util.Long)
                (message.sequence_number = $util.Long.fromValue(object.sequence_number)).unsigned = true;
            else if (typeof object.sequence_number === "string")
                message.sequence_number = parseInt(object.sequence_number, 10);
            else if (typeof object.sequence_number === "number")
                message.sequence_number = object.sequence_number;
            else if (typeof object.sequence_number === "object")
                message.sequence_number = new $util.LongBits(object.sequence_number.low >>> 0, object.sequence_number.high >>> 0).toNumber(true);
        if (object.timebounds_start != null)
            message.timebounds_start = object.timebounds_start >>> 0;
        if (object.timebounds_end != null)
            message.timebounds_end = object.timebounds_end >>> 0;
        switch (object.memo_type) {
        case "NONE":
        case 0:
            message.memo_type = 0;
            break;
        case "TEXT":
        case 1:
            message.memo_type = 1;
            break;
        case "ID":
        case 2:
            message.memo_type = 2;
            break;
        case "HASH":
        case 3:
            message.memo_type = 3;
            break;
        case "RETURN":
        case 4:
            message.memo_type = 4;
            break;
        }
        if (object.memo_text != null)
            message.memo_text = String(object.memo_text);
        if (object.memo_id != null)
            if ($util.Long)
                (message.memo_id = $util.Long.fromValue(object.memo_id)).unsigned = true;
            else if (typeof object.memo_id === "string")
                message.memo_id = parseInt(object.memo_id, 10);
            else if (typeof object.memo_id === "number")
                message.memo_id = object.memo_id;
            else if (typeof object.memo_id === "object")
                message.memo_id = new $util.LongBits(object.memo_id.low >>> 0, object.memo_id.high >>> 0).toNumber(true);
        if (object.memo_hash != null)
            if (typeof object.memo_hash === "string")
                $util.base64.decode(object.memo_hash, message.memo_hash = $util.newBuffer($util.base64.length(object.memo_hash)), 0);
            else if (object.memo_hash.length)
                message.memo_hash = object.memo_hash;
        if (object.num_operations != null)
            message.num_operations = object.num_operations >>> 0;
        return message;
    };

    StellarSignTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            object.network_passphrase = "";
            object.source_account = "";
            object.fee = 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.sequence_number = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.sequence_number = options.longs === String ? "0" : 0;
            object.timebounds_start = 0;
            object.timebounds_end = 0;
            object.memo_type = options.enums === String ? "NONE" : 0;
            object.memo_text = "";
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.memo_id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.memo_id = options.longs === String ? "0" : 0;
            if (options.bytes === String)
                object.memo_hash = "";
            else {
                object.memo_hash = [];
                if (options.bytes !== Array)
                    object.memo_hash = $util.newBuffer(object.memo_hash);
            }
            object.num_operations = 0;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.network_passphrase != null && message.hasOwnProperty("network_passphrase"))
            object.network_passphrase = message.network_passphrase;
        if (message.source_account != null && message.hasOwnProperty("source_account"))
            object.source_account = message.source_account;
        if (message.fee != null && message.hasOwnProperty("fee"))
            object.fee = message.fee;
        if (message.sequence_number != null && message.hasOwnProperty("sequence_number"))
            if (typeof message.sequence_number === "number")
                object.sequence_number = options.longs === String ? String(message.sequence_number) : message.sequence_number;
            else
                object.sequence_number = options.longs === String ? $util.Long.prototype.toString.call(message.sequence_number) : options.longs === Number ? new $util.LongBits(message.sequence_number.low >>> 0, message.sequence_number.high >>> 0).toNumber(true) : message.sequence_number;
        if (message.timebounds_start != null && message.hasOwnProperty("timebounds_start"))
            object.timebounds_start = message.timebounds_start;
        if (message.timebounds_end != null && message.hasOwnProperty("timebounds_end"))
            object.timebounds_end = message.timebounds_end;
        if (message.memo_type != null && message.hasOwnProperty("memo_type"))
            object.memo_type = options.enums === String ? $root.StellarSignTx.StellarMemoType[message.memo_type] : message.memo_type;
        if (message.memo_text != null && message.hasOwnProperty("memo_text"))
            object.memo_text = message.memo_text;
        if (message.memo_id != null && message.hasOwnProperty("memo_id"))
            if (typeof message.memo_id === "number")
                object.memo_id = options.longs === String ? String(message.memo_id) : message.memo_id;
            else
                object.memo_id = options.longs === String ? $util.Long.prototype.toString.call(message.memo_id) : options.longs === Number ? new $util.LongBits(message.memo_id.low >>> 0, message.memo_id.high >>> 0).toNumber(true) : message.memo_id;
        if (message.memo_hash != null && message.hasOwnProperty("memo_hash"))
            object.memo_hash = options.bytes === String ? $util.base64.encode(message.memo_hash, 0, message.memo_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.memo_hash) : message.memo_hash;
        if (message.num_operations != null && message.hasOwnProperty("num_operations"))
            object.num_operations = message.num_operations;
        return object;
    };

    StellarSignTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    StellarSignTx.StellarMemoType = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "NONE"] = 0;
        values[valuesById[1] = "TEXT"] = 1;
        values[valuesById[2] = "ID"] = 2;
        values[valuesById[3] = "HASH"] = 3;
        values[valuesById[4] = "RETURN"] = 4;
        return values;
    })();

    return StellarSignTx;
})();

$root.StellarTxOpRequest = (function() {

    function StellarTxOpRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    StellarTxOpRequest.create = function create(properties) {
        return new StellarTxOpRequest(properties);
    };

    StellarTxOpRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    StellarTxOpRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    StellarTxOpRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.StellarTxOpRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    StellarTxOpRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    StellarTxOpRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    StellarTxOpRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.StellarTxOpRequest)
            return object;
        return new $root.StellarTxOpRequest();
    };

    StellarTxOpRequest.toObject = function toObject() {
        return {};
    };

    StellarTxOpRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return StellarTxOpRequest;
})();

$root.StellarPaymentOp = (function() {

    function StellarPaymentOp(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    StellarPaymentOp.prototype.source_account = "";
    StellarPaymentOp.prototype.destination_account = "";
    StellarPaymentOp.prototype.asset = null;
    StellarPaymentOp.prototype.amount = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    StellarPaymentOp.create = function create(properties) {
        return new StellarPaymentOp(properties);
    };

    StellarPaymentOp.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.source_account != null && Object.hasOwnProperty.call(message, "source_account"))
            writer.uint32(10).string(message.source_account);
        writer.uint32(18).string(message.destination_account);
        $root.StellarAsset.encode(message.asset, writer.uint32(26).fork()).ldelim();
        writer.uint32(32).sint64(message.amount);
        return writer;
    };

    StellarPaymentOp.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    StellarPaymentOp.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.StellarPaymentOp();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.source_account = reader.string();
                break;
            case 2:
                message.destination_account = reader.string();
                break;
            case 3:
                message.asset = $root.StellarAsset.decode(reader, reader.uint32());
                break;
            case 4:
                message.amount = reader.sint64();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("destination_account"))
            throw $util.ProtocolError("missing required 'destination_account'", { instance: message });
        if (!message.hasOwnProperty("asset"))
            throw $util.ProtocolError("missing required 'asset'", { instance: message });
        if (!message.hasOwnProperty("amount"))
            throw $util.ProtocolError("missing required 'amount'", { instance: message });
        return message;
    };

    StellarPaymentOp.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    StellarPaymentOp.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.source_account != null && message.hasOwnProperty("source_account"))
            if (!$util.isString(message.source_account))
                return "source_account: string expected";
        if (!$util.isString(message.destination_account))
            return "destination_account: string expected";
        {
            var error = $root.StellarAsset.verify(message.asset);
            if (error)
                return "asset." + error;
        }
        if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
            return "amount: integer|Long expected";
        return null;
    };

    StellarPaymentOp.fromObject = function fromObject(object) {
        if (object instanceof $root.StellarPaymentOp)
            return object;
        var message = new $root.StellarPaymentOp();
        if (object.source_account != null)
            message.source_account = String(object.source_account);
        if (object.destination_account != null)
            message.destination_account = String(object.destination_account);
        if (object.asset != null) {
            if (typeof object.asset !== "object")
                throw TypeError(".StellarPaymentOp.asset: object expected");
            message.asset = $root.StellarAsset.fromObject(object.asset);
        }
        if (object.amount != null)
            if ($util.Long)
                (message.amount = $util.Long.fromValue(object.amount)).unsigned = false;
            else if (typeof object.amount === "string")
                message.amount = parseInt(object.amount, 10);
            else if (typeof object.amount === "number")
                message.amount = object.amount;
            else if (typeof object.amount === "object")
                message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber();
        return message;
    };

    StellarPaymentOp.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.source_account = "";
            object.destination_account = "";
            object.asset = null;
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.amount = options.longs === String ? "0" : 0;
        }
        if (message.source_account != null && message.hasOwnProperty("source_account"))
            object.source_account = message.source_account;
        if (message.destination_account != null && message.hasOwnProperty("destination_account"))
            object.destination_account = message.destination_account;
        if (message.asset != null && message.hasOwnProperty("asset"))
            object.asset = $root.StellarAsset.toObject(message.asset, options);
        if (message.amount != null && message.hasOwnProperty("amount"))
            if (typeof message.amount === "number")
                object.amount = options.longs === String ? String(message.amount) : message.amount;
            else
                object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber() : message.amount;
        return object;
    };

    StellarPaymentOp.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return StellarPaymentOp;
})();

$root.StellarCreateAccountOp = (function() {

    function StellarCreateAccountOp(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    StellarCreateAccountOp.prototype.source_account = "";
    StellarCreateAccountOp.prototype.new_account = "";
    StellarCreateAccountOp.prototype.starting_balance = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    StellarCreateAccountOp.create = function create(properties) {
        return new StellarCreateAccountOp(properties);
    };

    StellarCreateAccountOp.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.source_account != null && Object.hasOwnProperty.call(message, "source_account"))
            writer.uint32(10).string(message.source_account);
        writer.uint32(18).string(message.new_account);
        writer.uint32(24).sint64(message.starting_balance);
        return writer;
    };

    StellarCreateAccountOp.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    StellarCreateAccountOp.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.StellarCreateAccountOp();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.source_account = reader.string();
                break;
            case 2:
                message.new_account = reader.string();
                break;
            case 3:
                message.starting_balance = reader.sint64();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("new_account"))
            throw $util.ProtocolError("missing required 'new_account'", { instance: message });
        if (!message.hasOwnProperty("starting_balance"))
            throw $util.ProtocolError("missing required 'starting_balance'", { instance: message });
        return message;
    };

    StellarCreateAccountOp.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    StellarCreateAccountOp.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.source_account != null && message.hasOwnProperty("source_account"))
            if (!$util.isString(message.source_account))
                return "source_account: string expected";
        if (!$util.isString(message.new_account))
            return "new_account: string expected";
        if (!$util.isInteger(message.starting_balance) && !(message.starting_balance && $util.isInteger(message.starting_balance.low) && $util.isInteger(message.starting_balance.high)))
            return "starting_balance: integer|Long expected";
        return null;
    };

    StellarCreateAccountOp.fromObject = function fromObject(object) {
        if (object instanceof $root.StellarCreateAccountOp)
            return object;
        var message = new $root.StellarCreateAccountOp();
        if (object.source_account != null)
            message.source_account = String(object.source_account);
        if (object.new_account != null)
            message.new_account = String(object.new_account);
        if (object.starting_balance != null)
            if ($util.Long)
                (message.starting_balance = $util.Long.fromValue(object.starting_balance)).unsigned = false;
            else if (typeof object.starting_balance === "string")
                message.starting_balance = parseInt(object.starting_balance, 10);
            else if (typeof object.starting_balance === "number")
                message.starting_balance = object.starting_balance;
            else if (typeof object.starting_balance === "object")
                message.starting_balance = new $util.LongBits(object.starting_balance.low >>> 0, object.starting_balance.high >>> 0).toNumber();
        return message;
    };

    StellarCreateAccountOp.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.source_account = "";
            object.new_account = "";
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.starting_balance = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.starting_balance = options.longs === String ? "0" : 0;
        }
        if (message.source_account != null && message.hasOwnProperty("source_account"))
            object.source_account = message.source_account;
        if (message.new_account != null && message.hasOwnProperty("new_account"))
            object.new_account = message.new_account;
        if (message.starting_balance != null && message.hasOwnProperty("starting_balance"))
            if (typeof message.starting_balance === "number")
                object.starting_balance = options.longs === String ? String(message.starting_balance) : message.starting_balance;
            else
                object.starting_balance = options.longs === String ? $util.Long.prototype.toString.call(message.starting_balance) : options.longs === Number ? new $util.LongBits(message.starting_balance.low >>> 0, message.starting_balance.high >>> 0).toNumber() : message.starting_balance;
        return object;
    };

    StellarCreateAccountOp.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return StellarCreateAccountOp;
})();

$root.StellarPathPaymentStrictReceiveOp = (function() {

    function StellarPathPaymentStrictReceiveOp(properties) {
        this.paths = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    StellarPathPaymentStrictReceiveOp.prototype.source_account = "";
    StellarPathPaymentStrictReceiveOp.prototype.send_asset = null;
    StellarPathPaymentStrictReceiveOp.prototype.send_max = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    StellarPathPaymentStrictReceiveOp.prototype.destination_account = "";
    StellarPathPaymentStrictReceiveOp.prototype.destination_asset = null;
    StellarPathPaymentStrictReceiveOp.prototype.destination_amount = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    StellarPathPaymentStrictReceiveOp.prototype.paths = $util.emptyArray;

    StellarPathPaymentStrictReceiveOp.create = function create(properties) {
        return new StellarPathPaymentStrictReceiveOp(properties);
    };

    StellarPathPaymentStrictReceiveOp.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.source_account != null && Object.hasOwnProperty.call(message, "source_account"))
            writer.uint32(10).string(message.source_account);
        $root.StellarAsset.encode(message.send_asset, writer.uint32(18).fork()).ldelim();
        writer.uint32(24).sint64(message.send_max);
        writer.uint32(34).string(message.destination_account);
        $root.StellarAsset.encode(message.destination_asset, writer.uint32(42).fork()).ldelim();
        writer.uint32(48).sint64(message.destination_amount);
        if (message.paths != null && message.paths.length)
            for (var i = 0; i < message.paths.length; ++i)
                $root.StellarAsset.encode(message.paths[i], writer.uint32(58).fork()).ldelim();
        return writer;
    };

    StellarPathPaymentStrictReceiveOp.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    StellarPathPaymentStrictReceiveOp.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.StellarPathPaymentStrictReceiveOp();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.source_account = reader.string();
                break;
            case 2:
                message.send_asset = $root.StellarAsset.decode(reader, reader.uint32());
                break;
            case 3:
                message.send_max = reader.sint64();
                break;
            case 4:
                message.destination_account = reader.string();
                break;
            case 5:
                message.destination_asset = $root.StellarAsset.decode(reader, reader.uint32());
                break;
            case 6:
                message.destination_amount = reader.sint64();
                break;
            case 7:
                if (!(message.paths && message.paths.length))
                    message.paths = [];
                message.paths.push($root.StellarAsset.decode(reader, reader.uint32()));
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("send_asset"))
            throw $util.ProtocolError("missing required 'send_asset'", { instance: message });
        if (!message.hasOwnProperty("send_max"))
            throw $util.ProtocolError("missing required 'send_max'", { instance: message });
        if (!message.hasOwnProperty("destination_account"))
            throw $util.ProtocolError("missing required 'destination_account'", { instance: message });
        if (!message.hasOwnProperty("destination_asset"))
            throw $util.ProtocolError("missing required 'destination_asset'", { instance: message });
        if (!message.hasOwnProperty("destination_amount"))
            throw $util.ProtocolError("missing required 'destination_amount'", { instance: message });
        return message;
    };

    StellarPathPaymentStrictReceiveOp.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    StellarPathPaymentStrictReceiveOp.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.source_account != null && message.hasOwnProperty("source_account"))
            if (!$util.isString(message.source_account))
                return "source_account: string expected";
        {
            var error = $root.StellarAsset.verify(message.send_asset);
            if (error)
                return "send_asset." + error;
        }
        if (!$util.isInteger(message.send_max) && !(message.send_max && $util.isInteger(message.send_max.low) && $util.isInteger(message.send_max.high)))
            return "send_max: integer|Long expected";
        if (!$util.isString(message.destination_account))
            return "destination_account: string expected";
        {
            var error = $root.StellarAsset.verify(message.destination_asset);
            if (error)
                return "destination_asset." + error;
        }
        if (!$util.isInteger(message.destination_amount) && !(message.destination_amount && $util.isInteger(message.destination_amount.low) && $util.isInteger(message.destination_amount.high)))
            return "destination_amount: integer|Long expected";
        if (message.paths != null && message.hasOwnProperty("paths")) {
            if (!Array.isArray(message.paths))
                return "paths: array expected";
            for (var i = 0; i < message.paths.length; ++i) {
                var error = $root.StellarAsset.verify(message.paths[i]);
                if (error)
                    return "paths." + error;
            }
        }
        return null;
    };

    StellarPathPaymentStrictReceiveOp.fromObject = function fromObject(object) {
        if (object instanceof $root.StellarPathPaymentStrictReceiveOp)
            return object;
        var message = new $root.StellarPathPaymentStrictReceiveOp();
        if (object.source_account != null)
            message.source_account = String(object.source_account);
        if (object.send_asset != null) {
            if (typeof object.send_asset !== "object")
                throw TypeError(".StellarPathPaymentStrictReceiveOp.send_asset: object expected");
            message.send_asset = $root.StellarAsset.fromObject(object.send_asset);
        }
        if (object.send_max != null)
            if ($util.Long)
                (message.send_max = $util.Long.fromValue(object.send_max)).unsigned = false;
            else if (typeof object.send_max === "string")
                message.send_max = parseInt(object.send_max, 10);
            else if (typeof object.send_max === "number")
                message.send_max = object.send_max;
            else if (typeof object.send_max === "object")
                message.send_max = new $util.LongBits(object.send_max.low >>> 0, object.send_max.high >>> 0).toNumber();
        if (object.destination_account != null)
            message.destination_account = String(object.destination_account);
        if (object.destination_asset != null) {
            if (typeof object.destination_asset !== "object")
                throw TypeError(".StellarPathPaymentStrictReceiveOp.destination_asset: object expected");
            message.destination_asset = $root.StellarAsset.fromObject(object.destination_asset);
        }
        if (object.destination_amount != null)
            if ($util.Long)
                (message.destination_amount = $util.Long.fromValue(object.destination_amount)).unsigned = false;
            else if (typeof object.destination_amount === "string")
                message.destination_amount = parseInt(object.destination_amount, 10);
            else if (typeof object.destination_amount === "number")
                message.destination_amount = object.destination_amount;
            else if (typeof object.destination_amount === "object")
                message.destination_amount = new $util.LongBits(object.destination_amount.low >>> 0, object.destination_amount.high >>> 0).toNumber();
        if (object.paths) {
            if (!Array.isArray(object.paths))
                throw TypeError(".StellarPathPaymentStrictReceiveOp.paths: array expected");
            message.paths = [];
            for (var i = 0; i < object.paths.length; ++i) {
                if (typeof object.paths[i] !== "object")
                    throw TypeError(".StellarPathPaymentStrictReceiveOp.paths: object expected");
                message.paths[i] = $root.StellarAsset.fromObject(object.paths[i]);
            }
        }
        return message;
    };

    StellarPathPaymentStrictReceiveOp.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.paths = [];
        if (options.defaults) {
            object.source_account = "";
            object.send_asset = null;
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.send_max = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.send_max = options.longs === String ? "0" : 0;
            object.destination_account = "";
            object.destination_asset = null;
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.destination_amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.destination_amount = options.longs === String ? "0" : 0;
        }
        if (message.source_account != null && message.hasOwnProperty("source_account"))
            object.source_account = message.source_account;
        if (message.send_asset != null && message.hasOwnProperty("send_asset"))
            object.send_asset = $root.StellarAsset.toObject(message.send_asset, options);
        if (message.send_max != null && message.hasOwnProperty("send_max"))
            if (typeof message.send_max === "number")
                object.send_max = options.longs === String ? String(message.send_max) : message.send_max;
            else
                object.send_max = options.longs === String ? $util.Long.prototype.toString.call(message.send_max) : options.longs === Number ? new $util.LongBits(message.send_max.low >>> 0, message.send_max.high >>> 0).toNumber() : message.send_max;
        if (message.destination_account != null && message.hasOwnProperty("destination_account"))
            object.destination_account = message.destination_account;
        if (message.destination_asset != null && message.hasOwnProperty("destination_asset"))
            object.destination_asset = $root.StellarAsset.toObject(message.destination_asset, options);
        if (message.destination_amount != null && message.hasOwnProperty("destination_amount"))
            if (typeof message.destination_amount === "number")
                object.destination_amount = options.longs === String ? String(message.destination_amount) : message.destination_amount;
            else
                object.destination_amount = options.longs === String ? $util.Long.prototype.toString.call(message.destination_amount) : options.longs === Number ? new $util.LongBits(message.destination_amount.low >>> 0, message.destination_amount.high >>> 0).toNumber() : message.destination_amount;
        if (message.paths && message.paths.length) {
            object.paths = [];
            for (var j = 0; j < message.paths.length; ++j)
                object.paths[j] = $root.StellarAsset.toObject(message.paths[j], options);
        }
        return object;
    };

    StellarPathPaymentStrictReceiveOp.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return StellarPathPaymentStrictReceiveOp;
})();

$root.StellarPathPaymentStrictSendOp = (function() {

    function StellarPathPaymentStrictSendOp(properties) {
        this.paths = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    StellarPathPaymentStrictSendOp.prototype.source_account = "";
    StellarPathPaymentStrictSendOp.prototype.send_asset = null;
    StellarPathPaymentStrictSendOp.prototype.send_amount = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    StellarPathPaymentStrictSendOp.prototype.destination_account = "";
    StellarPathPaymentStrictSendOp.prototype.destination_asset = null;
    StellarPathPaymentStrictSendOp.prototype.destination_min = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    StellarPathPaymentStrictSendOp.prototype.paths = $util.emptyArray;

    StellarPathPaymentStrictSendOp.create = function create(properties) {
        return new StellarPathPaymentStrictSendOp(properties);
    };

    StellarPathPaymentStrictSendOp.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.source_account != null && Object.hasOwnProperty.call(message, "source_account"))
            writer.uint32(10).string(message.source_account);
        $root.StellarAsset.encode(message.send_asset, writer.uint32(18).fork()).ldelim();
        writer.uint32(24).sint64(message.send_amount);
        writer.uint32(34).string(message.destination_account);
        $root.StellarAsset.encode(message.destination_asset, writer.uint32(42).fork()).ldelim();
        writer.uint32(48).sint64(message.destination_min);
        if (message.paths != null && message.paths.length)
            for (var i = 0; i < message.paths.length; ++i)
                $root.StellarAsset.encode(message.paths[i], writer.uint32(58).fork()).ldelim();
        return writer;
    };

    StellarPathPaymentStrictSendOp.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    StellarPathPaymentStrictSendOp.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.StellarPathPaymentStrictSendOp();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.source_account = reader.string();
                break;
            case 2:
                message.send_asset = $root.StellarAsset.decode(reader, reader.uint32());
                break;
            case 3:
                message.send_amount = reader.sint64();
                break;
            case 4:
                message.destination_account = reader.string();
                break;
            case 5:
                message.destination_asset = $root.StellarAsset.decode(reader, reader.uint32());
                break;
            case 6:
                message.destination_min = reader.sint64();
                break;
            case 7:
                if (!(message.paths && message.paths.length))
                    message.paths = [];
                message.paths.push($root.StellarAsset.decode(reader, reader.uint32()));
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("send_asset"))
            throw $util.ProtocolError("missing required 'send_asset'", { instance: message });
        if (!message.hasOwnProperty("send_amount"))
            throw $util.ProtocolError("missing required 'send_amount'", { instance: message });
        if (!message.hasOwnProperty("destination_account"))
            throw $util.ProtocolError("missing required 'destination_account'", { instance: message });
        if (!message.hasOwnProperty("destination_asset"))
            throw $util.ProtocolError("missing required 'destination_asset'", { instance: message });
        if (!message.hasOwnProperty("destination_min"))
            throw $util.ProtocolError("missing required 'destination_min'", { instance: message });
        return message;
    };

    StellarPathPaymentStrictSendOp.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    StellarPathPaymentStrictSendOp.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.source_account != null && message.hasOwnProperty("source_account"))
            if (!$util.isString(message.source_account))
                return "source_account: string expected";
        {
            var error = $root.StellarAsset.verify(message.send_asset);
            if (error)
                return "send_asset." + error;
        }
        if (!$util.isInteger(message.send_amount) && !(message.send_amount && $util.isInteger(message.send_amount.low) && $util.isInteger(message.send_amount.high)))
            return "send_amount: integer|Long expected";
        if (!$util.isString(message.destination_account))
            return "destination_account: string expected";
        {
            var error = $root.StellarAsset.verify(message.destination_asset);
            if (error)
                return "destination_asset." + error;
        }
        if (!$util.isInteger(message.destination_min) && !(message.destination_min && $util.isInteger(message.destination_min.low) && $util.isInteger(message.destination_min.high)))
            return "destination_min: integer|Long expected";
        if (message.paths != null && message.hasOwnProperty("paths")) {
            if (!Array.isArray(message.paths))
                return "paths: array expected";
            for (var i = 0; i < message.paths.length; ++i) {
                var error = $root.StellarAsset.verify(message.paths[i]);
                if (error)
                    return "paths." + error;
            }
        }
        return null;
    };

    StellarPathPaymentStrictSendOp.fromObject = function fromObject(object) {
        if (object instanceof $root.StellarPathPaymentStrictSendOp)
            return object;
        var message = new $root.StellarPathPaymentStrictSendOp();
        if (object.source_account != null)
            message.source_account = String(object.source_account);
        if (object.send_asset != null) {
            if (typeof object.send_asset !== "object")
                throw TypeError(".StellarPathPaymentStrictSendOp.send_asset: object expected");
            message.send_asset = $root.StellarAsset.fromObject(object.send_asset);
        }
        if (object.send_amount != null)
            if ($util.Long)
                (message.send_amount = $util.Long.fromValue(object.send_amount)).unsigned = false;
            else if (typeof object.send_amount === "string")
                message.send_amount = parseInt(object.send_amount, 10);
            else if (typeof object.send_amount === "number")
                message.send_amount = object.send_amount;
            else if (typeof object.send_amount === "object")
                message.send_amount = new $util.LongBits(object.send_amount.low >>> 0, object.send_amount.high >>> 0).toNumber();
        if (object.destination_account != null)
            message.destination_account = String(object.destination_account);
        if (object.destination_asset != null) {
            if (typeof object.destination_asset !== "object")
                throw TypeError(".StellarPathPaymentStrictSendOp.destination_asset: object expected");
            message.destination_asset = $root.StellarAsset.fromObject(object.destination_asset);
        }
        if (object.destination_min != null)
            if ($util.Long)
                (message.destination_min = $util.Long.fromValue(object.destination_min)).unsigned = false;
            else if (typeof object.destination_min === "string")
                message.destination_min = parseInt(object.destination_min, 10);
            else if (typeof object.destination_min === "number")
                message.destination_min = object.destination_min;
            else if (typeof object.destination_min === "object")
                message.destination_min = new $util.LongBits(object.destination_min.low >>> 0, object.destination_min.high >>> 0).toNumber();
        if (object.paths) {
            if (!Array.isArray(object.paths))
                throw TypeError(".StellarPathPaymentStrictSendOp.paths: array expected");
            message.paths = [];
            for (var i = 0; i < object.paths.length; ++i) {
                if (typeof object.paths[i] !== "object")
                    throw TypeError(".StellarPathPaymentStrictSendOp.paths: object expected");
                message.paths[i] = $root.StellarAsset.fromObject(object.paths[i]);
            }
        }
        return message;
    };

    StellarPathPaymentStrictSendOp.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.paths = [];
        if (options.defaults) {
            object.source_account = "";
            object.send_asset = null;
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.send_amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.send_amount = options.longs === String ? "0" : 0;
            object.destination_account = "";
            object.destination_asset = null;
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.destination_min = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.destination_min = options.longs === String ? "0" : 0;
        }
        if (message.source_account != null && message.hasOwnProperty("source_account"))
            object.source_account = message.source_account;
        if (message.send_asset != null && message.hasOwnProperty("send_asset"))
            object.send_asset = $root.StellarAsset.toObject(message.send_asset, options);
        if (message.send_amount != null && message.hasOwnProperty("send_amount"))
            if (typeof message.send_amount === "number")
                object.send_amount = options.longs === String ? String(message.send_amount) : message.send_amount;
            else
                object.send_amount = options.longs === String ? $util.Long.prototype.toString.call(message.send_amount) : options.longs === Number ? new $util.LongBits(message.send_amount.low >>> 0, message.send_amount.high >>> 0).toNumber() : message.send_amount;
        if (message.destination_account != null && message.hasOwnProperty("destination_account"))
            object.destination_account = message.destination_account;
        if (message.destination_asset != null && message.hasOwnProperty("destination_asset"))
            object.destination_asset = $root.StellarAsset.toObject(message.destination_asset, options);
        if (message.destination_min != null && message.hasOwnProperty("destination_min"))
            if (typeof message.destination_min === "number")
                object.destination_min = options.longs === String ? String(message.destination_min) : message.destination_min;
            else
                object.destination_min = options.longs === String ? $util.Long.prototype.toString.call(message.destination_min) : options.longs === Number ? new $util.LongBits(message.destination_min.low >>> 0, message.destination_min.high >>> 0).toNumber() : message.destination_min;
        if (message.paths && message.paths.length) {
            object.paths = [];
            for (var j = 0; j < message.paths.length; ++j)
                object.paths[j] = $root.StellarAsset.toObject(message.paths[j], options);
        }
        return object;
    };

    StellarPathPaymentStrictSendOp.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return StellarPathPaymentStrictSendOp;
})();

$root.StellarManageSellOfferOp = (function() {

    function StellarManageSellOfferOp(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    StellarManageSellOfferOp.prototype.source_account = "";
    StellarManageSellOfferOp.prototype.selling_asset = null;
    StellarManageSellOfferOp.prototype.buying_asset = null;
    StellarManageSellOfferOp.prototype.amount = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    StellarManageSellOfferOp.prototype.price_n = 0;
    StellarManageSellOfferOp.prototype.price_d = 0;
    StellarManageSellOfferOp.prototype.offer_id = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    StellarManageSellOfferOp.create = function create(properties) {
        return new StellarManageSellOfferOp(properties);
    };

    StellarManageSellOfferOp.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.source_account != null && Object.hasOwnProperty.call(message, "source_account"))
            writer.uint32(10).string(message.source_account);
        $root.StellarAsset.encode(message.selling_asset, writer.uint32(18).fork()).ldelim();
        $root.StellarAsset.encode(message.buying_asset, writer.uint32(26).fork()).ldelim();
        writer.uint32(32).sint64(message.amount);
        writer.uint32(40).uint32(message.price_n);
        writer.uint32(48).uint32(message.price_d);
        writer.uint32(56).uint64(message.offer_id);
        return writer;
    };

    StellarManageSellOfferOp.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    StellarManageSellOfferOp.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.StellarManageSellOfferOp();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.source_account = reader.string();
                break;
            case 2:
                message.selling_asset = $root.StellarAsset.decode(reader, reader.uint32());
                break;
            case 3:
                message.buying_asset = $root.StellarAsset.decode(reader, reader.uint32());
                break;
            case 4:
                message.amount = reader.sint64();
                break;
            case 5:
                message.price_n = reader.uint32();
                break;
            case 6:
                message.price_d = reader.uint32();
                break;
            case 7:
                message.offer_id = reader.uint64();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("selling_asset"))
            throw $util.ProtocolError("missing required 'selling_asset'", { instance: message });
        if (!message.hasOwnProperty("buying_asset"))
            throw $util.ProtocolError("missing required 'buying_asset'", { instance: message });
        if (!message.hasOwnProperty("amount"))
            throw $util.ProtocolError("missing required 'amount'", { instance: message });
        if (!message.hasOwnProperty("price_n"))
            throw $util.ProtocolError("missing required 'price_n'", { instance: message });
        if (!message.hasOwnProperty("price_d"))
            throw $util.ProtocolError("missing required 'price_d'", { instance: message });
        if (!message.hasOwnProperty("offer_id"))
            throw $util.ProtocolError("missing required 'offer_id'", { instance: message });
        return message;
    };

    StellarManageSellOfferOp.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    StellarManageSellOfferOp.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.source_account != null && message.hasOwnProperty("source_account"))
            if (!$util.isString(message.source_account))
                return "source_account: string expected";
        {
            var error = $root.StellarAsset.verify(message.selling_asset);
            if (error)
                return "selling_asset." + error;
        }
        {
            var error = $root.StellarAsset.verify(message.buying_asset);
            if (error)
                return "buying_asset." + error;
        }
        if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
            return "amount: integer|Long expected";
        if (!$util.isInteger(message.price_n))
            return "price_n: integer expected";
        if (!$util.isInteger(message.price_d))
            return "price_d: integer expected";
        if (!$util.isInteger(message.offer_id) && !(message.offer_id && $util.isInteger(message.offer_id.low) && $util.isInteger(message.offer_id.high)))
            return "offer_id: integer|Long expected";
        return null;
    };

    StellarManageSellOfferOp.fromObject = function fromObject(object) {
        if (object instanceof $root.StellarManageSellOfferOp)
            return object;
        var message = new $root.StellarManageSellOfferOp();
        if (object.source_account != null)
            message.source_account = String(object.source_account);
        if (object.selling_asset != null) {
            if (typeof object.selling_asset !== "object")
                throw TypeError(".StellarManageSellOfferOp.selling_asset: object expected");
            message.selling_asset = $root.StellarAsset.fromObject(object.selling_asset);
        }
        if (object.buying_asset != null) {
            if (typeof object.buying_asset !== "object")
                throw TypeError(".StellarManageSellOfferOp.buying_asset: object expected");
            message.buying_asset = $root.StellarAsset.fromObject(object.buying_asset);
        }
        if (object.amount != null)
            if ($util.Long)
                (message.amount = $util.Long.fromValue(object.amount)).unsigned = false;
            else if (typeof object.amount === "string")
                message.amount = parseInt(object.amount, 10);
            else if (typeof object.amount === "number")
                message.amount = object.amount;
            else if (typeof object.amount === "object")
                message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber();
        if (object.price_n != null)
            message.price_n = object.price_n >>> 0;
        if (object.price_d != null)
            message.price_d = object.price_d >>> 0;
        if (object.offer_id != null)
            if ($util.Long)
                (message.offer_id = $util.Long.fromValue(object.offer_id)).unsigned = true;
            else if (typeof object.offer_id === "string")
                message.offer_id = parseInt(object.offer_id, 10);
            else if (typeof object.offer_id === "number")
                message.offer_id = object.offer_id;
            else if (typeof object.offer_id === "object")
                message.offer_id = new $util.LongBits(object.offer_id.low >>> 0, object.offer_id.high >>> 0).toNumber(true);
        return message;
    };

    StellarManageSellOfferOp.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.source_account = "";
            object.selling_asset = null;
            object.buying_asset = null;
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.amount = options.longs === String ? "0" : 0;
            object.price_n = 0;
            object.price_d = 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.offer_id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.offer_id = options.longs === String ? "0" : 0;
        }
        if (message.source_account != null && message.hasOwnProperty("source_account"))
            object.source_account = message.source_account;
        if (message.selling_asset != null && message.hasOwnProperty("selling_asset"))
            object.selling_asset = $root.StellarAsset.toObject(message.selling_asset, options);
        if (message.buying_asset != null && message.hasOwnProperty("buying_asset"))
            object.buying_asset = $root.StellarAsset.toObject(message.buying_asset, options);
        if (message.amount != null && message.hasOwnProperty("amount"))
            if (typeof message.amount === "number")
                object.amount = options.longs === String ? String(message.amount) : message.amount;
            else
                object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber() : message.amount;
        if (message.price_n != null && message.hasOwnProperty("price_n"))
            object.price_n = message.price_n;
        if (message.price_d != null && message.hasOwnProperty("price_d"))
            object.price_d = message.price_d;
        if (message.offer_id != null && message.hasOwnProperty("offer_id"))
            if (typeof message.offer_id === "number")
                object.offer_id = options.longs === String ? String(message.offer_id) : message.offer_id;
            else
                object.offer_id = options.longs === String ? $util.Long.prototype.toString.call(message.offer_id) : options.longs === Number ? new $util.LongBits(message.offer_id.low >>> 0, message.offer_id.high >>> 0).toNumber(true) : message.offer_id;
        return object;
    };

    StellarManageSellOfferOp.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return StellarManageSellOfferOp;
})();

$root.StellarManageBuyOfferOp = (function() {

    function StellarManageBuyOfferOp(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    StellarManageBuyOfferOp.prototype.source_account = "";
    StellarManageBuyOfferOp.prototype.selling_asset = null;
    StellarManageBuyOfferOp.prototype.buying_asset = null;
    StellarManageBuyOfferOp.prototype.amount = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    StellarManageBuyOfferOp.prototype.price_n = 0;
    StellarManageBuyOfferOp.prototype.price_d = 0;
    StellarManageBuyOfferOp.prototype.offer_id = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    StellarManageBuyOfferOp.create = function create(properties) {
        return new StellarManageBuyOfferOp(properties);
    };

    StellarManageBuyOfferOp.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.source_account != null && Object.hasOwnProperty.call(message, "source_account"))
            writer.uint32(10).string(message.source_account);
        $root.StellarAsset.encode(message.selling_asset, writer.uint32(18).fork()).ldelim();
        $root.StellarAsset.encode(message.buying_asset, writer.uint32(26).fork()).ldelim();
        writer.uint32(32).sint64(message.amount);
        writer.uint32(40).uint32(message.price_n);
        writer.uint32(48).uint32(message.price_d);
        writer.uint32(56).uint64(message.offer_id);
        return writer;
    };

    StellarManageBuyOfferOp.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    StellarManageBuyOfferOp.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.StellarManageBuyOfferOp();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.source_account = reader.string();
                break;
            case 2:
                message.selling_asset = $root.StellarAsset.decode(reader, reader.uint32());
                break;
            case 3:
                message.buying_asset = $root.StellarAsset.decode(reader, reader.uint32());
                break;
            case 4:
                message.amount = reader.sint64();
                break;
            case 5:
                message.price_n = reader.uint32();
                break;
            case 6:
                message.price_d = reader.uint32();
                break;
            case 7:
                message.offer_id = reader.uint64();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("selling_asset"))
            throw $util.ProtocolError("missing required 'selling_asset'", { instance: message });
        if (!message.hasOwnProperty("buying_asset"))
            throw $util.ProtocolError("missing required 'buying_asset'", { instance: message });
        if (!message.hasOwnProperty("amount"))
            throw $util.ProtocolError("missing required 'amount'", { instance: message });
        if (!message.hasOwnProperty("price_n"))
            throw $util.ProtocolError("missing required 'price_n'", { instance: message });
        if (!message.hasOwnProperty("price_d"))
            throw $util.ProtocolError("missing required 'price_d'", { instance: message });
        if (!message.hasOwnProperty("offer_id"))
            throw $util.ProtocolError("missing required 'offer_id'", { instance: message });
        return message;
    };

    StellarManageBuyOfferOp.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    StellarManageBuyOfferOp.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.source_account != null && message.hasOwnProperty("source_account"))
            if (!$util.isString(message.source_account))
                return "source_account: string expected";
        {
            var error = $root.StellarAsset.verify(message.selling_asset);
            if (error)
                return "selling_asset." + error;
        }
        {
            var error = $root.StellarAsset.verify(message.buying_asset);
            if (error)
                return "buying_asset." + error;
        }
        if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
            return "amount: integer|Long expected";
        if (!$util.isInteger(message.price_n))
            return "price_n: integer expected";
        if (!$util.isInteger(message.price_d))
            return "price_d: integer expected";
        if (!$util.isInteger(message.offer_id) && !(message.offer_id && $util.isInteger(message.offer_id.low) && $util.isInteger(message.offer_id.high)))
            return "offer_id: integer|Long expected";
        return null;
    };

    StellarManageBuyOfferOp.fromObject = function fromObject(object) {
        if (object instanceof $root.StellarManageBuyOfferOp)
            return object;
        var message = new $root.StellarManageBuyOfferOp();
        if (object.source_account != null)
            message.source_account = String(object.source_account);
        if (object.selling_asset != null) {
            if (typeof object.selling_asset !== "object")
                throw TypeError(".StellarManageBuyOfferOp.selling_asset: object expected");
            message.selling_asset = $root.StellarAsset.fromObject(object.selling_asset);
        }
        if (object.buying_asset != null) {
            if (typeof object.buying_asset !== "object")
                throw TypeError(".StellarManageBuyOfferOp.buying_asset: object expected");
            message.buying_asset = $root.StellarAsset.fromObject(object.buying_asset);
        }
        if (object.amount != null)
            if ($util.Long)
                (message.amount = $util.Long.fromValue(object.amount)).unsigned = false;
            else if (typeof object.amount === "string")
                message.amount = parseInt(object.amount, 10);
            else if (typeof object.amount === "number")
                message.amount = object.amount;
            else if (typeof object.amount === "object")
                message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber();
        if (object.price_n != null)
            message.price_n = object.price_n >>> 0;
        if (object.price_d != null)
            message.price_d = object.price_d >>> 0;
        if (object.offer_id != null)
            if ($util.Long)
                (message.offer_id = $util.Long.fromValue(object.offer_id)).unsigned = true;
            else if (typeof object.offer_id === "string")
                message.offer_id = parseInt(object.offer_id, 10);
            else if (typeof object.offer_id === "number")
                message.offer_id = object.offer_id;
            else if (typeof object.offer_id === "object")
                message.offer_id = new $util.LongBits(object.offer_id.low >>> 0, object.offer_id.high >>> 0).toNumber(true);
        return message;
    };

    StellarManageBuyOfferOp.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.source_account = "";
            object.selling_asset = null;
            object.buying_asset = null;
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.amount = options.longs === String ? "0" : 0;
            object.price_n = 0;
            object.price_d = 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.offer_id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.offer_id = options.longs === String ? "0" : 0;
        }
        if (message.source_account != null && message.hasOwnProperty("source_account"))
            object.source_account = message.source_account;
        if (message.selling_asset != null && message.hasOwnProperty("selling_asset"))
            object.selling_asset = $root.StellarAsset.toObject(message.selling_asset, options);
        if (message.buying_asset != null && message.hasOwnProperty("buying_asset"))
            object.buying_asset = $root.StellarAsset.toObject(message.buying_asset, options);
        if (message.amount != null && message.hasOwnProperty("amount"))
            if (typeof message.amount === "number")
                object.amount = options.longs === String ? String(message.amount) : message.amount;
            else
                object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber() : message.amount;
        if (message.price_n != null && message.hasOwnProperty("price_n"))
            object.price_n = message.price_n;
        if (message.price_d != null && message.hasOwnProperty("price_d"))
            object.price_d = message.price_d;
        if (message.offer_id != null && message.hasOwnProperty("offer_id"))
            if (typeof message.offer_id === "number")
                object.offer_id = options.longs === String ? String(message.offer_id) : message.offer_id;
            else
                object.offer_id = options.longs === String ? $util.Long.prototype.toString.call(message.offer_id) : options.longs === Number ? new $util.LongBits(message.offer_id.low >>> 0, message.offer_id.high >>> 0).toNumber(true) : message.offer_id;
        return object;
    };

    StellarManageBuyOfferOp.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return StellarManageBuyOfferOp;
})();

$root.StellarCreatePassiveSellOfferOp = (function() {

    function StellarCreatePassiveSellOfferOp(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    StellarCreatePassiveSellOfferOp.prototype.source_account = "";
    StellarCreatePassiveSellOfferOp.prototype.selling_asset = null;
    StellarCreatePassiveSellOfferOp.prototype.buying_asset = null;
    StellarCreatePassiveSellOfferOp.prototype.amount = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    StellarCreatePassiveSellOfferOp.prototype.price_n = 0;
    StellarCreatePassiveSellOfferOp.prototype.price_d = 0;

    StellarCreatePassiveSellOfferOp.create = function create(properties) {
        return new StellarCreatePassiveSellOfferOp(properties);
    };

    StellarCreatePassiveSellOfferOp.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.source_account != null && Object.hasOwnProperty.call(message, "source_account"))
            writer.uint32(10).string(message.source_account);
        $root.StellarAsset.encode(message.selling_asset, writer.uint32(18).fork()).ldelim();
        $root.StellarAsset.encode(message.buying_asset, writer.uint32(26).fork()).ldelim();
        writer.uint32(32).sint64(message.amount);
        writer.uint32(40).uint32(message.price_n);
        writer.uint32(48).uint32(message.price_d);
        return writer;
    };

    StellarCreatePassiveSellOfferOp.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    StellarCreatePassiveSellOfferOp.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.StellarCreatePassiveSellOfferOp();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.source_account = reader.string();
                break;
            case 2:
                message.selling_asset = $root.StellarAsset.decode(reader, reader.uint32());
                break;
            case 3:
                message.buying_asset = $root.StellarAsset.decode(reader, reader.uint32());
                break;
            case 4:
                message.amount = reader.sint64();
                break;
            case 5:
                message.price_n = reader.uint32();
                break;
            case 6:
                message.price_d = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("selling_asset"))
            throw $util.ProtocolError("missing required 'selling_asset'", { instance: message });
        if (!message.hasOwnProperty("buying_asset"))
            throw $util.ProtocolError("missing required 'buying_asset'", { instance: message });
        if (!message.hasOwnProperty("amount"))
            throw $util.ProtocolError("missing required 'amount'", { instance: message });
        if (!message.hasOwnProperty("price_n"))
            throw $util.ProtocolError("missing required 'price_n'", { instance: message });
        if (!message.hasOwnProperty("price_d"))
            throw $util.ProtocolError("missing required 'price_d'", { instance: message });
        return message;
    };

    StellarCreatePassiveSellOfferOp.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    StellarCreatePassiveSellOfferOp.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.source_account != null && message.hasOwnProperty("source_account"))
            if (!$util.isString(message.source_account))
                return "source_account: string expected";
        {
            var error = $root.StellarAsset.verify(message.selling_asset);
            if (error)
                return "selling_asset." + error;
        }
        {
            var error = $root.StellarAsset.verify(message.buying_asset);
            if (error)
                return "buying_asset." + error;
        }
        if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
            return "amount: integer|Long expected";
        if (!$util.isInteger(message.price_n))
            return "price_n: integer expected";
        if (!$util.isInteger(message.price_d))
            return "price_d: integer expected";
        return null;
    };

    StellarCreatePassiveSellOfferOp.fromObject = function fromObject(object) {
        if (object instanceof $root.StellarCreatePassiveSellOfferOp)
            return object;
        var message = new $root.StellarCreatePassiveSellOfferOp();
        if (object.source_account != null)
            message.source_account = String(object.source_account);
        if (object.selling_asset != null) {
            if (typeof object.selling_asset !== "object")
                throw TypeError(".StellarCreatePassiveSellOfferOp.selling_asset: object expected");
            message.selling_asset = $root.StellarAsset.fromObject(object.selling_asset);
        }
        if (object.buying_asset != null) {
            if (typeof object.buying_asset !== "object")
                throw TypeError(".StellarCreatePassiveSellOfferOp.buying_asset: object expected");
            message.buying_asset = $root.StellarAsset.fromObject(object.buying_asset);
        }
        if (object.amount != null)
            if ($util.Long)
                (message.amount = $util.Long.fromValue(object.amount)).unsigned = false;
            else if (typeof object.amount === "string")
                message.amount = parseInt(object.amount, 10);
            else if (typeof object.amount === "number")
                message.amount = object.amount;
            else if (typeof object.amount === "object")
                message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber();
        if (object.price_n != null)
            message.price_n = object.price_n >>> 0;
        if (object.price_d != null)
            message.price_d = object.price_d >>> 0;
        return message;
    };

    StellarCreatePassiveSellOfferOp.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.source_account = "";
            object.selling_asset = null;
            object.buying_asset = null;
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.amount = options.longs === String ? "0" : 0;
            object.price_n = 0;
            object.price_d = 0;
        }
        if (message.source_account != null && message.hasOwnProperty("source_account"))
            object.source_account = message.source_account;
        if (message.selling_asset != null && message.hasOwnProperty("selling_asset"))
            object.selling_asset = $root.StellarAsset.toObject(message.selling_asset, options);
        if (message.buying_asset != null && message.hasOwnProperty("buying_asset"))
            object.buying_asset = $root.StellarAsset.toObject(message.buying_asset, options);
        if (message.amount != null && message.hasOwnProperty("amount"))
            if (typeof message.amount === "number")
                object.amount = options.longs === String ? String(message.amount) : message.amount;
            else
                object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber() : message.amount;
        if (message.price_n != null && message.hasOwnProperty("price_n"))
            object.price_n = message.price_n;
        if (message.price_d != null && message.hasOwnProperty("price_d"))
            object.price_d = message.price_d;
        return object;
    };

    StellarCreatePassiveSellOfferOp.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return StellarCreatePassiveSellOfferOp;
})();

$root.StellarSetOptionsOp = (function() {

    function StellarSetOptionsOp(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    StellarSetOptionsOp.prototype.source_account = "";
    StellarSetOptionsOp.prototype.inflation_destination_account = "";
    StellarSetOptionsOp.prototype.clear_flags = 0;
    StellarSetOptionsOp.prototype.set_flags = 0;
    StellarSetOptionsOp.prototype.master_weight = 0;
    StellarSetOptionsOp.prototype.low_threshold = 0;
    StellarSetOptionsOp.prototype.medium_threshold = 0;
    StellarSetOptionsOp.prototype.high_threshold = 0;
    StellarSetOptionsOp.prototype.home_domain = "";
    StellarSetOptionsOp.prototype.signer_type = 0;
    StellarSetOptionsOp.prototype.signer_key = $util.newBuffer([]);
    StellarSetOptionsOp.prototype.signer_weight = 0;

    StellarSetOptionsOp.create = function create(properties) {
        return new StellarSetOptionsOp(properties);
    };

    StellarSetOptionsOp.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.source_account != null && Object.hasOwnProperty.call(message, "source_account"))
            writer.uint32(10).string(message.source_account);
        if (message.inflation_destination_account != null && Object.hasOwnProperty.call(message, "inflation_destination_account"))
            writer.uint32(18).string(message.inflation_destination_account);
        if (message.clear_flags != null && Object.hasOwnProperty.call(message, "clear_flags"))
            writer.uint32(24).uint32(message.clear_flags);
        if (message.set_flags != null && Object.hasOwnProperty.call(message, "set_flags"))
            writer.uint32(32).uint32(message.set_flags);
        if (message.master_weight != null && Object.hasOwnProperty.call(message, "master_weight"))
            writer.uint32(40).uint32(message.master_weight);
        if (message.low_threshold != null && Object.hasOwnProperty.call(message, "low_threshold"))
            writer.uint32(48).uint32(message.low_threshold);
        if (message.medium_threshold != null && Object.hasOwnProperty.call(message, "medium_threshold"))
            writer.uint32(56).uint32(message.medium_threshold);
        if (message.high_threshold != null && Object.hasOwnProperty.call(message, "high_threshold"))
            writer.uint32(64).uint32(message.high_threshold);
        if (message.home_domain != null && Object.hasOwnProperty.call(message, "home_domain"))
            writer.uint32(74).string(message.home_domain);
        if (message.signer_type != null && Object.hasOwnProperty.call(message, "signer_type"))
            writer.uint32(80).int32(message.signer_type);
        if (message.signer_key != null && Object.hasOwnProperty.call(message, "signer_key"))
            writer.uint32(90).bytes(message.signer_key);
        if (message.signer_weight != null && Object.hasOwnProperty.call(message, "signer_weight"))
            writer.uint32(96).uint32(message.signer_weight);
        return writer;
    };

    StellarSetOptionsOp.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    StellarSetOptionsOp.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.StellarSetOptionsOp();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.source_account = reader.string();
                break;
            case 2:
                message.inflation_destination_account = reader.string();
                break;
            case 3:
                message.clear_flags = reader.uint32();
                break;
            case 4:
                message.set_flags = reader.uint32();
                break;
            case 5:
                message.master_weight = reader.uint32();
                break;
            case 6:
                message.low_threshold = reader.uint32();
                break;
            case 7:
                message.medium_threshold = reader.uint32();
                break;
            case 8:
                message.high_threshold = reader.uint32();
                break;
            case 9:
                message.home_domain = reader.string();
                break;
            case 10:
                message.signer_type = reader.int32();
                break;
            case 11:
                message.signer_key = reader.bytes();
                break;
            case 12:
                message.signer_weight = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    StellarSetOptionsOp.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    StellarSetOptionsOp.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.source_account != null && message.hasOwnProperty("source_account"))
            if (!$util.isString(message.source_account))
                return "source_account: string expected";
        if (message.inflation_destination_account != null && message.hasOwnProperty("inflation_destination_account"))
            if (!$util.isString(message.inflation_destination_account))
                return "inflation_destination_account: string expected";
        if (message.clear_flags != null && message.hasOwnProperty("clear_flags"))
            if (!$util.isInteger(message.clear_flags))
                return "clear_flags: integer expected";
        if (message.set_flags != null && message.hasOwnProperty("set_flags"))
            if (!$util.isInteger(message.set_flags))
                return "set_flags: integer expected";
        if (message.master_weight != null && message.hasOwnProperty("master_weight"))
            if (!$util.isInteger(message.master_weight))
                return "master_weight: integer expected";
        if (message.low_threshold != null && message.hasOwnProperty("low_threshold"))
            if (!$util.isInteger(message.low_threshold))
                return "low_threshold: integer expected";
        if (message.medium_threshold != null && message.hasOwnProperty("medium_threshold"))
            if (!$util.isInteger(message.medium_threshold))
                return "medium_threshold: integer expected";
        if (message.high_threshold != null && message.hasOwnProperty("high_threshold"))
            if (!$util.isInteger(message.high_threshold))
                return "high_threshold: integer expected";
        if (message.home_domain != null && message.hasOwnProperty("home_domain"))
            if (!$util.isString(message.home_domain))
                return "home_domain: string expected";
        if (message.signer_type != null && message.hasOwnProperty("signer_type"))
            switch (message.signer_type) {
            default:
                return "signer_type: enum value expected";
            case 0:
            case 1:
            case 2:
                break;
            }
        if (message.signer_key != null && message.hasOwnProperty("signer_key"))
            if (!(message.signer_key && typeof message.signer_key.length === "number" || $util.isString(message.signer_key)))
                return "signer_key: buffer expected";
        if (message.signer_weight != null && message.hasOwnProperty("signer_weight"))
            if (!$util.isInteger(message.signer_weight))
                return "signer_weight: integer expected";
        return null;
    };

    StellarSetOptionsOp.fromObject = function fromObject(object) {
        if (object instanceof $root.StellarSetOptionsOp)
            return object;
        var message = new $root.StellarSetOptionsOp();
        if (object.source_account != null)
            message.source_account = String(object.source_account);
        if (object.inflation_destination_account != null)
            message.inflation_destination_account = String(object.inflation_destination_account);
        if (object.clear_flags != null)
            message.clear_flags = object.clear_flags >>> 0;
        if (object.set_flags != null)
            message.set_flags = object.set_flags >>> 0;
        if (object.master_weight != null)
            message.master_weight = object.master_weight >>> 0;
        if (object.low_threshold != null)
            message.low_threshold = object.low_threshold >>> 0;
        if (object.medium_threshold != null)
            message.medium_threshold = object.medium_threshold >>> 0;
        if (object.high_threshold != null)
            message.high_threshold = object.high_threshold >>> 0;
        if (object.home_domain != null)
            message.home_domain = String(object.home_domain);
        switch (object.signer_type) {
        case "ACCOUNT":
        case 0:
            message.signer_type = 0;
            break;
        case "PRE_AUTH":
        case 1:
            message.signer_type = 1;
            break;
        case "HASH":
        case 2:
            message.signer_type = 2;
            break;
        }
        if (object.signer_key != null)
            if (typeof object.signer_key === "string")
                $util.base64.decode(object.signer_key, message.signer_key = $util.newBuffer($util.base64.length(object.signer_key)), 0);
            else if (object.signer_key.length)
                message.signer_key = object.signer_key;
        if (object.signer_weight != null)
            message.signer_weight = object.signer_weight >>> 0;
        return message;
    };

    StellarSetOptionsOp.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.source_account = "";
            object.inflation_destination_account = "";
            object.clear_flags = 0;
            object.set_flags = 0;
            object.master_weight = 0;
            object.low_threshold = 0;
            object.medium_threshold = 0;
            object.high_threshold = 0;
            object.home_domain = "";
            object.signer_type = options.enums === String ? "ACCOUNT" : 0;
            if (options.bytes === String)
                object.signer_key = "";
            else {
                object.signer_key = [];
                if (options.bytes !== Array)
                    object.signer_key = $util.newBuffer(object.signer_key);
            }
            object.signer_weight = 0;
        }
        if (message.source_account != null && message.hasOwnProperty("source_account"))
            object.source_account = message.source_account;
        if (message.inflation_destination_account != null && message.hasOwnProperty("inflation_destination_account"))
            object.inflation_destination_account = message.inflation_destination_account;
        if (message.clear_flags != null && message.hasOwnProperty("clear_flags"))
            object.clear_flags = message.clear_flags;
        if (message.set_flags != null && message.hasOwnProperty("set_flags"))
            object.set_flags = message.set_flags;
        if (message.master_weight != null && message.hasOwnProperty("master_weight"))
            object.master_weight = message.master_weight;
        if (message.low_threshold != null && message.hasOwnProperty("low_threshold"))
            object.low_threshold = message.low_threshold;
        if (message.medium_threshold != null && message.hasOwnProperty("medium_threshold"))
            object.medium_threshold = message.medium_threshold;
        if (message.high_threshold != null && message.hasOwnProperty("high_threshold"))
            object.high_threshold = message.high_threshold;
        if (message.home_domain != null && message.hasOwnProperty("home_domain"))
            object.home_domain = message.home_domain;
        if (message.signer_type != null && message.hasOwnProperty("signer_type"))
            object.signer_type = options.enums === String ? $root.StellarSetOptionsOp.StellarSignerType[message.signer_type] : message.signer_type;
        if (message.signer_key != null && message.hasOwnProperty("signer_key"))
            object.signer_key = options.bytes === String ? $util.base64.encode(message.signer_key, 0, message.signer_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.signer_key) : message.signer_key;
        if (message.signer_weight != null && message.hasOwnProperty("signer_weight"))
            object.signer_weight = message.signer_weight;
        return object;
    };

    StellarSetOptionsOp.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    StellarSetOptionsOp.StellarSignerType = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "ACCOUNT"] = 0;
        values[valuesById[1] = "PRE_AUTH"] = 1;
        values[valuesById[2] = "HASH"] = 2;
        return values;
    })();

    return StellarSetOptionsOp;
})();

$root.StellarChangeTrustOp = (function() {

    function StellarChangeTrustOp(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    StellarChangeTrustOp.prototype.source_account = "";
    StellarChangeTrustOp.prototype.asset = null;
    StellarChangeTrustOp.prototype.limit = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    StellarChangeTrustOp.create = function create(properties) {
        return new StellarChangeTrustOp(properties);
    };

    StellarChangeTrustOp.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.source_account != null && Object.hasOwnProperty.call(message, "source_account"))
            writer.uint32(10).string(message.source_account);
        $root.StellarAsset.encode(message.asset, writer.uint32(18).fork()).ldelim();
        writer.uint32(24).uint64(message.limit);
        return writer;
    };

    StellarChangeTrustOp.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    StellarChangeTrustOp.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.StellarChangeTrustOp();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.source_account = reader.string();
                break;
            case 2:
                message.asset = $root.StellarAsset.decode(reader, reader.uint32());
                break;
            case 3:
                message.limit = reader.uint64();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("asset"))
            throw $util.ProtocolError("missing required 'asset'", { instance: message });
        if (!message.hasOwnProperty("limit"))
            throw $util.ProtocolError("missing required 'limit'", { instance: message });
        return message;
    };

    StellarChangeTrustOp.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    StellarChangeTrustOp.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.source_account != null && message.hasOwnProperty("source_account"))
            if (!$util.isString(message.source_account))
                return "source_account: string expected";
        {
            var error = $root.StellarAsset.verify(message.asset);
            if (error)
                return "asset." + error;
        }
        if (!$util.isInteger(message.limit) && !(message.limit && $util.isInteger(message.limit.low) && $util.isInteger(message.limit.high)))
            return "limit: integer|Long expected";
        return null;
    };

    StellarChangeTrustOp.fromObject = function fromObject(object) {
        if (object instanceof $root.StellarChangeTrustOp)
            return object;
        var message = new $root.StellarChangeTrustOp();
        if (object.source_account != null)
            message.source_account = String(object.source_account);
        if (object.asset != null) {
            if (typeof object.asset !== "object")
                throw TypeError(".StellarChangeTrustOp.asset: object expected");
            message.asset = $root.StellarAsset.fromObject(object.asset);
        }
        if (object.limit != null)
            if ($util.Long)
                (message.limit = $util.Long.fromValue(object.limit)).unsigned = true;
            else if (typeof object.limit === "string")
                message.limit = parseInt(object.limit, 10);
            else if (typeof object.limit === "number")
                message.limit = object.limit;
            else if (typeof object.limit === "object")
                message.limit = new $util.LongBits(object.limit.low >>> 0, object.limit.high >>> 0).toNumber(true);
        return message;
    };

    StellarChangeTrustOp.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.source_account = "";
            object.asset = null;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.limit = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.limit = options.longs === String ? "0" : 0;
        }
        if (message.source_account != null && message.hasOwnProperty("source_account"))
            object.source_account = message.source_account;
        if (message.asset != null && message.hasOwnProperty("asset"))
            object.asset = $root.StellarAsset.toObject(message.asset, options);
        if (message.limit != null && message.hasOwnProperty("limit"))
            if (typeof message.limit === "number")
                object.limit = options.longs === String ? String(message.limit) : message.limit;
            else
                object.limit = options.longs === String ? $util.Long.prototype.toString.call(message.limit) : options.longs === Number ? new $util.LongBits(message.limit.low >>> 0, message.limit.high >>> 0).toNumber(true) : message.limit;
        return object;
    };

    StellarChangeTrustOp.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return StellarChangeTrustOp;
})();

$root.StellarAllowTrustOp = (function() {

    function StellarAllowTrustOp(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    StellarAllowTrustOp.prototype.source_account = "";
    StellarAllowTrustOp.prototype.trusted_account = "";
    StellarAllowTrustOp.prototype.asset_type = 0;
    StellarAllowTrustOp.prototype.asset_code = "";
    StellarAllowTrustOp.prototype.is_authorized = false;

    StellarAllowTrustOp.create = function create(properties) {
        return new StellarAllowTrustOp(properties);
    };

    StellarAllowTrustOp.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.source_account != null && Object.hasOwnProperty.call(message, "source_account"))
            writer.uint32(10).string(message.source_account);
        writer.uint32(18).string(message.trusted_account);
        writer.uint32(24).int32(message.asset_type);
        if (message.asset_code != null && Object.hasOwnProperty.call(message, "asset_code"))
            writer.uint32(34).string(message.asset_code);
        writer.uint32(40).bool(message.is_authorized);
        return writer;
    };

    StellarAllowTrustOp.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    StellarAllowTrustOp.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.StellarAllowTrustOp();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.source_account = reader.string();
                break;
            case 2:
                message.trusted_account = reader.string();
                break;
            case 3:
                message.asset_type = reader.int32();
                break;
            case 4:
                message.asset_code = reader.string();
                break;
            case 5:
                message.is_authorized = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("trusted_account"))
            throw $util.ProtocolError("missing required 'trusted_account'", { instance: message });
        if (!message.hasOwnProperty("asset_type"))
            throw $util.ProtocolError("missing required 'asset_type'", { instance: message });
        if (!message.hasOwnProperty("is_authorized"))
            throw $util.ProtocolError("missing required 'is_authorized'", { instance: message });
        return message;
    };

    StellarAllowTrustOp.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    StellarAllowTrustOp.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.source_account != null && message.hasOwnProperty("source_account"))
            if (!$util.isString(message.source_account))
                return "source_account: string expected";
        if (!$util.isString(message.trusted_account))
            return "trusted_account: string expected";
        switch (message.asset_type) {
        default:
            return "asset_type: enum value expected";
        case 0:
        case 1:
        case 2:
            break;
        }
        if (message.asset_code != null && message.hasOwnProperty("asset_code"))
            if (!$util.isString(message.asset_code))
                return "asset_code: string expected";
        if (typeof message.is_authorized !== "boolean")
            return "is_authorized: boolean expected";
        return null;
    };

    StellarAllowTrustOp.fromObject = function fromObject(object) {
        if (object instanceof $root.StellarAllowTrustOp)
            return object;
        var message = new $root.StellarAllowTrustOp();
        if (object.source_account != null)
            message.source_account = String(object.source_account);
        if (object.trusted_account != null)
            message.trusted_account = String(object.trusted_account);
        switch (object.asset_type) {
        case "NATIVE":
        case 0:
            message.asset_type = 0;
            break;
        case "ALPHANUM4":
        case 1:
            message.asset_type = 1;
            break;
        case "ALPHANUM12":
        case 2:
            message.asset_type = 2;
            break;
        }
        if (object.asset_code != null)
            message.asset_code = String(object.asset_code);
        if (object.is_authorized != null)
            message.is_authorized = Boolean(object.is_authorized);
        return message;
    };

    StellarAllowTrustOp.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.source_account = "";
            object.trusted_account = "";
            object.asset_type = options.enums === String ? "NATIVE" : 0;
            object.asset_code = "";
            object.is_authorized = false;
        }
        if (message.source_account != null && message.hasOwnProperty("source_account"))
            object.source_account = message.source_account;
        if (message.trusted_account != null && message.hasOwnProperty("trusted_account"))
            object.trusted_account = message.trusted_account;
        if (message.asset_type != null && message.hasOwnProperty("asset_type"))
            object.asset_type = options.enums === String ? $root.StellarAssetType[message.asset_type] : message.asset_type;
        if (message.asset_code != null && message.hasOwnProperty("asset_code"))
            object.asset_code = message.asset_code;
        if (message.is_authorized != null && message.hasOwnProperty("is_authorized"))
            object.is_authorized = message.is_authorized;
        return object;
    };

    StellarAllowTrustOp.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return StellarAllowTrustOp;
})();

$root.StellarAccountMergeOp = (function() {

    function StellarAccountMergeOp(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    StellarAccountMergeOp.prototype.source_account = "";
    StellarAccountMergeOp.prototype.destination_account = "";

    StellarAccountMergeOp.create = function create(properties) {
        return new StellarAccountMergeOp(properties);
    };

    StellarAccountMergeOp.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.source_account != null && Object.hasOwnProperty.call(message, "source_account"))
            writer.uint32(10).string(message.source_account);
        writer.uint32(18).string(message.destination_account);
        return writer;
    };

    StellarAccountMergeOp.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    StellarAccountMergeOp.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.StellarAccountMergeOp();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.source_account = reader.string();
                break;
            case 2:
                message.destination_account = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("destination_account"))
            throw $util.ProtocolError("missing required 'destination_account'", { instance: message });
        return message;
    };

    StellarAccountMergeOp.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    StellarAccountMergeOp.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.source_account != null && message.hasOwnProperty("source_account"))
            if (!$util.isString(message.source_account))
                return "source_account: string expected";
        if (!$util.isString(message.destination_account))
            return "destination_account: string expected";
        return null;
    };

    StellarAccountMergeOp.fromObject = function fromObject(object) {
        if (object instanceof $root.StellarAccountMergeOp)
            return object;
        var message = new $root.StellarAccountMergeOp();
        if (object.source_account != null)
            message.source_account = String(object.source_account);
        if (object.destination_account != null)
            message.destination_account = String(object.destination_account);
        return message;
    };

    StellarAccountMergeOp.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.source_account = "";
            object.destination_account = "";
        }
        if (message.source_account != null && message.hasOwnProperty("source_account"))
            object.source_account = message.source_account;
        if (message.destination_account != null && message.hasOwnProperty("destination_account"))
            object.destination_account = message.destination_account;
        return object;
    };

    StellarAccountMergeOp.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return StellarAccountMergeOp;
})();

$root.StellarManageDataOp = (function() {

    function StellarManageDataOp(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    StellarManageDataOp.prototype.source_account = "";
    StellarManageDataOp.prototype.key = "";
    StellarManageDataOp.prototype.value = $util.newBuffer([]);

    StellarManageDataOp.create = function create(properties) {
        return new StellarManageDataOp(properties);
    };

    StellarManageDataOp.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.source_account != null && Object.hasOwnProperty.call(message, "source_account"))
            writer.uint32(10).string(message.source_account);
        writer.uint32(18).string(message.key);
        if (message.value != null && Object.hasOwnProperty.call(message, "value"))
            writer.uint32(26).bytes(message.value);
        return writer;
    };

    StellarManageDataOp.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    StellarManageDataOp.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.StellarManageDataOp();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.source_account = reader.string();
                break;
            case 2:
                message.key = reader.string();
                break;
            case 3:
                message.value = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("key"))
            throw $util.ProtocolError("missing required 'key'", { instance: message });
        return message;
    };

    StellarManageDataOp.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    StellarManageDataOp.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.source_account != null && message.hasOwnProperty("source_account"))
            if (!$util.isString(message.source_account))
                return "source_account: string expected";
        if (!$util.isString(message.key))
            return "key: string expected";
        if (message.value != null && message.hasOwnProperty("value"))
            if (!(message.value && typeof message.value.length === "number" || $util.isString(message.value)))
                return "value: buffer expected";
        return null;
    };

    StellarManageDataOp.fromObject = function fromObject(object) {
        if (object instanceof $root.StellarManageDataOp)
            return object;
        var message = new $root.StellarManageDataOp();
        if (object.source_account != null)
            message.source_account = String(object.source_account);
        if (object.key != null)
            message.key = String(object.key);
        if (object.value != null)
            if (typeof object.value === "string")
                $util.base64.decode(object.value, message.value = $util.newBuffer($util.base64.length(object.value)), 0);
            else if (object.value.length)
                message.value = object.value;
        return message;
    };

    StellarManageDataOp.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.source_account = "";
            object.key = "";
            if (options.bytes === String)
                object.value = "";
            else {
                object.value = [];
                if (options.bytes !== Array)
                    object.value = $util.newBuffer(object.value);
            }
        }
        if (message.source_account != null && message.hasOwnProperty("source_account"))
            object.source_account = message.source_account;
        if (message.key != null && message.hasOwnProperty("key"))
            object.key = message.key;
        if (message.value != null && message.hasOwnProperty("value"))
            object.value = options.bytes === String ? $util.base64.encode(message.value, 0, message.value.length) : options.bytes === Array ? Array.prototype.slice.call(message.value) : message.value;
        return object;
    };

    StellarManageDataOp.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return StellarManageDataOp;
})();

$root.StellarBumpSequenceOp = (function() {

    function StellarBumpSequenceOp(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    StellarBumpSequenceOp.prototype.source_account = "";
    StellarBumpSequenceOp.prototype.bump_to = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    StellarBumpSequenceOp.create = function create(properties) {
        return new StellarBumpSequenceOp(properties);
    };

    StellarBumpSequenceOp.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.source_account != null && Object.hasOwnProperty.call(message, "source_account"))
            writer.uint32(10).string(message.source_account);
        writer.uint32(16).uint64(message.bump_to);
        return writer;
    };

    StellarBumpSequenceOp.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    StellarBumpSequenceOp.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.StellarBumpSequenceOp();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.source_account = reader.string();
                break;
            case 2:
                message.bump_to = reader.uint64();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("bump_to"))
            throw $util.ProtocolError("missing required 'bump_to'", { instance: message });
        return message;
    };

    StellarBumpSequenceOp.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    StellarBumpSequenceOp.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.source_account != null && message.hasOwnProperty("source_account"))
            if (!$util.isString(message.source_account))
                return "source_account: string expected";
        if (!$util.isInteger(message.bump_to) && !(message.bump_to && $util.isInteger(message.bump_to.low) && $util.isInteger(message.bump_to.high)))
            return "bump_to: integer|Long expected";
        return null;
    };

    StellarBumpSequenceOp.fromObject = function fromObject(object) {
        if (object instanceof $root.StellarBumpSequenceOp)
            return object;
        var message = new $root.StellarBumpSequenceOp();
        if (object.source_account != null)
            message.source_account = String(object.source_account);
        if (object.bump_to != null)
            if ($util.Long)
                (message.bump_to = $util.Long.fromValue(object.bump_to)).unsigned = true;
            else if (typeof object.bump_to === "string")
                message.bump_to = parseInt(object.bump_to, 10);
            else if (typeof object.bump_to === "number")
                message.bump_to = object.bump_to;
            else if (typeof object.bump_to === "object")
                message.bump_to = new $util.LongBits(object.bump_to.low >>> 0, object.bump_to.high >>> 0).toNumber(true);
        return message;
    };

    StellarBumpSequenceOp.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.source_account = "";
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.bump_to = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.bump_to = options.longs === String ? "0" : 0;
        }
        if (message.source_account != null && message.hasOwnProperty("source_account"))
            object.source_account = message.source_account;
        if (message.bump_to != null && message.hasOwnProperty("bump_to"))
            if (typeof message.bump_to === "number")
                object.bump_to = options.longs === String ? String(message.bump_to) : message.bump_to;
            else
                object.bump_to = options.longs === String ? $util.Long.prototype.toString.call(message.bump_to) : options.longs === Number ? new $util.LongBits(message.bump_to.low >>> 0, message.bump_to.high >>> 0).toNumber(true) : message.bump_to;
        return object;
    };

    StellarBumpSequenceOp.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return StellarBumpSequenceOp;
})();

$root.StellarSignedTx = (function() {

    function StellarSignedTx(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    StellarSignedTx.prototype.public_key = $util.newBuffer([]);
    StellarSignedTx.prototype.signature = $util.newBuffer([]);

    StellarSignedTx.create = function create(properties) {
        return new StellarSignedTx(properties);
    };

    StellarSignedTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.public_key);
        writer.uint32(18).bytes(message.signature);
        return writer;
    };

    StellarSignedTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    StellarSignedTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.StellarSignedTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.public_key = reader.bytes();
                break;
            case 2:
                message.signature = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("public_key"))
            throw $util.ProtocolError("missing required 'public_key'", { instance: message });
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        return message;
    };

    StellarSignedTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    StellarSignedTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.public_key && typeof message.public_key.length === "number" || $util.isString(message.public_key)))
            return "public_key: buffer expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        return null;
    };

    StellarSignedTx.fromObject = function fromObject(object) {
        if (object instanceof $root.StellarSignedTx)
            return object;
        var message = new $root.StellarSignedTx();
        if (object.public_key != null)
            if (typeof object.public_key === "string")
                $util.base64.decode(object.public_key, message.public_key = $util.newBuffer($util.base64.length(object.public_key)), 0);
            else if (object.public_key.length)
                message.public_key = object.public_key;
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        return message;
    };

    StellarSignedTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.public_key = "";
            else {
                object.public_key = [];
                if (options.bytes !== Array)
                    object.public_key = $util.newBuffer(object.public_key);
            }
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
        }
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            object.public_key = options.bytes === String ? $util.base64.encode(message.public_key, 0, message.public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.public_key) : message.public_key;
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        return object;
    };

    StellarSignedTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return StellarSignedTx;
})();

$root.SuiGetAddress = (function() {

    function SuiGetAddress(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    SuiGetAddress.prototype.address_n = $util.emptyArray;
    SuiGetAddress.prototype.show_display = false;

    SuiGetAddress.create = function create(properties) {
        return new SuiGetAddress(properties);
    };

    SuiGetAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(16).bool(message.show_display);
        return writer;
    };

    SuiGetAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    SuiGetAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SuiGetAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.show_display = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    SuiGetAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    SuiGetAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        return null;
    };

    SuiGetAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.SuiGetAddress)
            return object;
        var message = new $root.SuiGetAddress();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".SuiGetAddress.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        return message;
    };

    SuiGetAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            object.show_display = false;
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        return object;
    };

    SuiGetAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SuiGetAddress;
})();

$root.SuiAddress = (function() {

    function SuiAddress(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    SuiAddress.prototype.address = "";

    SuiAddress.create = function create(properties) {
        return new SuiAddress(properties);
    };

    SuiAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address != null && Object.hasOwnProperty.call(message, "address"))
            writer.uint32(10).string(message.address);
        return writer;
    };

    SuiAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    SuiAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SuiAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    SuiAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    SuiAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address != null && message.hasOwnProperty("address"))
            if (!$util.isString(message.address))
                return "address: string expected";
        return null;
    };

    SuiAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.SuiAddress)
            return object;
        var message = new $root.SuiAddress();
        if (object.address != null)
            message.address = String(object.address);
        return message;
    };

    SuiAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.address = "";
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    SuiAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SuiAddress;
})();

$root.SuiSignTx = (function() {

    function SuiSignTx(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    SuiSignTx.prototype.address_n = $util.emptyArray;
    SuiSignTx.prototype.raw_tx = $util.newBuffer([]);

    SuiSignTx.create = function create(properties) {
        return new SuiSignTx(properties);
    };

    SuiSignTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).bytes(message.raw_tx);
        return writer;
    };

    SuiSignTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    SuiSignTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SuiSignTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.raw_tx = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("raw_tx"))
            throw $util.ProtocolError("missing required 'raw_tx'", { instance: message });
        return message;
    };

    SuiSignTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    SuiSignTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!(message.raw_tx && typeof message.raw_tx.length === "number" || $util.isString(message.raw_tx)))
            return "raw_tx: buffer expected";
        return null;
    };

    SuiSignTx.fromObject = function fromObject(object) {
        if (object instanceof $root.SuiSignTx)
            return object;
        var message = new $root.SuiSignTx();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".SuiSignTx.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.raw_tx != null)
            if (typeof object.raw_tx === "string")
                $util.base64.decode(object.raw_tx, message.raw_tx = $util.newBuffer($util.base64.length(object.raw_tx)), 0);
            else if (object.raw_tx.length)
                message.raw_tx = object.raw_tx;
        return message;
    };

    SuiSignTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            if (options.bytes === String)
                object.raw_tx = "";
            else {
                object.raw_tx = [];
                if (options.bytes !== Array)
                    object.raw_tx = $util.newBuffer(object.raw_tx);
            }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.raw_tx != null && message.hasOwnProperty("raw_tx"))
            object.raw_tx = options.bytes === String ? $util.base64.encode(message.raw_tx, 0, message.raw_tx.length) : options.bytes === Array ? Array.prototype.slice.call(message.raw_tx) : message.raw_tx;
        return object;
    };

    SuiSignTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SuiSignTx;
})();

$root.SuiSignedTx = (function() {

    function SuiSignedTx(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    SuiSignedTx.prototype.public_key = $util.newBuffer([]);
    SuiSignedTx.prototype.signature = $util.newBuffer([]);

    SuiSignedTx.create = function create(properties) {
        return new SuiSignedTx(properties);
    };

    SuiSignedTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.public_key);
        writer.uint32(18).bytes(message.signature);
        return writer;
    };

    SuiSignedTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    SuiSignedTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SuiSignedTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.public_key = reader.bytes();
                break;
            case 2:
                message.signature = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("public_key"))
            throw $util.ProtocolError("missing required 'public_key'", { instance: message });
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        return message;
    };

    SuiSignedTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    SuiSignedTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.public_key && typeof message.public_key.length === "number" || $util.isString(message.public_key)))
            return "public_key: buffer expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        return null;
    };

    SuiSignedTx.fromObject = function fromObject(object) {
        if (object instanceof $root.SuiSignedTx)
            return object;
        var message = new $root.SuiSignedTx();
        if (object.public_key != null)
            if (typeof object.public_key === "string")
                $util.base64.decode(object.public_key, message.public_key = $util.newBuffer($util.base64.length(object.public_key)), 0);
            else if (object.public_key.length)
                message.public_key = object.public_key;
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        return message;
    };

    SuiSignedTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.public_key = "";
            else {
                object.public_key = [];
                if (options.bytes !== Array)
                    object.public_key = $util.newBuffer(object.public_key);
            }
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
        }
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            object.public_key = options.bytes === String ? $util.base64.encode(message.public_key, 0, message.public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.public_key) : message.public_key;
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        return object;
    };

    SuiSignedTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SuiSignedTx;
})();

$root.TezosGetAddress = (function() {

    function TezosGetAddress(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    TezosGetAddress.prototype.address_n = $util.emptyArray;
    TezosGetAddress.prototype.show_display = false;

    TezosGetAddress.create = function create(properties) {
        return new TezosGetAddress(properties);
    };

    TezosGetAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(16).bool(message.show_display);
        return writer;
    };

    TezosGetAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    TezosGetAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TezosGetAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.show_display = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    TezosGetAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    TezosGetAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        return null;
    };

    TezosGetAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.TezosGetAddress)
            return object;
        var message = new $root.TezosGetAddress();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".TezosGetAddress.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        return message;
    };

    TezosGetAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            object.show_display = false;
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        return object;
    };

    TezosGetAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return TezosGetAddress;
})();

$root.TezosAddress = (function() {

    function TezosAddress(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    TezosAddress.prototype.address = "";

    TezosAddress.create = function create(properties) {
        return new TezosAddress(properties);
    };

    TezosAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.address);
        return writer;
    };

    TezosAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    TezosAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TezosAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("address"))
            throw $util.ProtocolError("missing required 'address'", { instance: message });
        return message;
    };

    TezosAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    TezosAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.address))
            return "address: string expected";
        return null;
    };

    TezosAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.TezosAddress)
            return object;
        var message = new $root.TezosAddress();
        if (object.address != null)
            message.address = String(object.address);
        return message;
    };

    TezosAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.address = "";
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    TezosAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return TezosAddress;
})();

$root.TezosGetPublicKey = (function() {

    function TezosGetPublicKey(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    TezosGetPublicKey.prototype.address_n = $util.emptyArray;
    TezosGetPublicKey.prototype.show_display = false;

    TezosGetPublicKey.create = function create(properties) {
        return new TezosGetPublicKey(properties);
    };

    TezosGetPublicKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(16).bool(message.show_display);
        return writer;
    };

    TezosGetPublicKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    TezosGetPublicKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TezosGetPublicKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.show_display = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    TezosGetPublicKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    TezosGetPublicKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        return null;
    };

    TezosGetPublicKey.fromObject = function fromObject(object) {
        if (object instanceof $root.TezosGetPublicKey)
            return object;
        var message = new $root.TezosGetPublicKey();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".TezosGetPublicKey.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        return message;
    };

    TezosGetPublicKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            object.show_display = false;
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        return object;
    };

    TezosGetPublicKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return TezosGetPublicKey;
})();

$root.TezosPublicKey = (function() {

    function TezosPublicKey(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    TezosPublicKey.prototype.public_key = "";

    TezosPublicKey.create = function create(properties) {
        return new TezosPublicKey(properties);
    };

    TezosPublicKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.public_key);
        return writer;
    };

    TezosPublicKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    TezosPublicKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TezosPublicKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.public_key = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("public_key"))
            throw $util.ProtocolError("missing required 'public_key'", { instance: message });
        return message;
    };

    TezosPublicKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    TezosPublicKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.public_key))
            return "public_key: string expected";
        return null;
    };

    TezosPublicKey.fromObject = function fromObject(object) {
        if (object instanceof $root.TezosPublicKey)
            return object;
        var message = new $root.TezosPublicKey();
        if (object.public_key != null)
            message.public_key = String(object.public_key);
        return message;
    };

    TezosPublicKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.public_key = "";
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            object.public_key = message.public_key;
        return object;
    };

    TezosPublicKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return TezosPublicKey;
})();

$root.TezosSignTx = (function() {

    function TezosSignTx(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    TezosSignTx.prototype.address_n = $util.emptyArray;
    TezosSignTx.prototype.branch = $util.newBuffer([]);
    TezosSignTx.prototype.reveal = null;
    TezosSignTx.prototype.transaction = null;
    TezosSignTx.prototype.origination = null;
    TezosSignTx.prototype.delegation = null;
    TezosSignTx.prototype.proposal = null;
    TezosSignTx.prototype.ballot = null;

    TezosSignTx.create = function create(properties) {
        return new TezosSignTx(properties);
    };

    TezosSignTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).bytes(message.branch);
        if (message.reveal != null && Object.hasOwnProperty.call(message, "reveal"))
            $root.TezosSignTx.TezosRevealOp.encode(message.reveal, writer.uint32(26).fork()).ldelim();
        if (message.transaction != null && Object.hasOwnProperty.call(message, "transaction"))
            $root.TezosSignTx.TezosTransactionOp.encode(message.transaction, writer.uint32(34).fork()).ldelim();
        if (message.origination != null && Object.hasOwnProperty.call(message, "origination"))
            $root.TezosSignTx.TezosOriginationOp.encode(message.origination, writer.uint32(42).fork()).ldelim();
        if (message.delegation != null && Object.hasOwnProperty.call(message, "delegation"))
            $root.TezosSignTx.TezosDelegationOp.encode(message.delegation, writer.uint32(50).fork()).ldelim();
        if (message.proposal != null && Object.hasOwnProperty.call(message, "proposal"))
            $root.TezosSignTx.TezosProposalOp.encode(message.proposal, writer.uint32(58).fork()).ldelim();
        if (message.ballot != null && Object.hasOwnProperty.call(message, "ballot"))
            $root.TezosSignTx.TezosBallotOp.encode(message.ballot, writer.uint32(66).fork()).ldelim();
        return writer;
    };

    TezosSignTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    TezosSignTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TezosSignTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.branch = reader.bytes();
                break;
            case 3:
                message.reveal = $root.TezosSignTx.TezosRevealOp.decode(reader, reader.uint32());
                break;
            case 4:
                message.transaction = $root.TezosSignTx.TezosTransactionOp.decode(reader, reader.uint32());
                break;
            case 5:
                message.origination = $root.TezosSignTx.TezosOriginationOp.decode(reader, reader.uint32());
                break;
            case 6:
                message.delegation = $root.TezosSignTx.TezosDelegationOp.decode(reader, reader.uint32());
                break;
            case 7:
                message.proposal = $root.TezosSignTx.TezosProposalOp.decode(reader, reader.uint32());
                break;
            case 8:
                message.ballot = $root.TezosSignTx.TezosBallotOp.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("branch"))
            throw $util.ProtocolError("missing required 'branch'", { instance: message });
        return message;
    };

    TezosSignTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    TezosSignTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!(message.branch && typeof message.branch.length === "number" || $util.isString(message.branch)))
            return "branch: buffer expected";
        if (message.reveal != null && message.hasOwnProperty("reveal")) {
            var error = $root.TezosSignTx.TezosRevealOp.verify(message.reveal);
            if (error)
                return "reveal." + error;
        }
        if (message.transaction != null && message.hasOwnProperty("transaction")) {
            var error = $root.TezosSignTx.TezosTransactionOp.verify(message.transaction);
            if (error)
                return "transaction." + error;
        }
        if (message.origination != null && message.hasOwnProperty("origination")) {
            var error = $root.TezosSignTx.TezosOriginationOp.verify(message.origination);
            if (error)
                return "origination." + error;
        }
        if (message.delegation != null && message.hasOwnProperty("delegation")) {
            var error = $root.TezosSignTx.TezosDelegationOp.verify(message.delegation);
            if (error)
                return "delegation." + error;
        }
        if (message.proposal != null && message.hasOwnProperty("proposal")) {
            var error = $root.TezosSignTx.TezosProposalOp.verify(message.proposal);
            if (error)
                return "proposal." + error;
        }
        if (message.ballot != null && message.hasOwnProperty("ballot")) {
            var error = $root.TezosSignTx.TezosBallotOp.verify(message.ballot);
            if (error)
                return "ballot." + error;
        }
        return null;
    };

    TezosSignTx.fromObject = function fromObject(object) {
        if (object instanceof $root.TezosSignTx)
            return object;
        var message = new $root.TezosSignTx();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".TezosSignTx.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.branch != null)
            if (typeof object.branch === "string")
                $util.base64.decode(object.branch, message.branch = $util.newBuffer($util.base64.length(object.branch)), 0);
            else if (object.branch.length)
                message.branch = object.branch;
        if (object.reveal != null) {
            if (typeof object.reveal !== "object")
                throw TypeError(".TezosSignTx.reveal: object expected");
            message.reveal = $root.TezosSignTx.TezosRevealOp.fromObject(object.reveal);
        }
        if (object.transaction != null) {
            if (typeof object.transaction !== "object")
                throw TypeError(".TezosSignTx.transaction: object expected");
            message.transaction = $root.TezosSignTx.TezosTransactionOp.fromObject(object.transaction);
        }
        if (object.origination != null) {
            if (typeof object.origination !== "object")
                throw TypeError(".TezosSignTx.origination: object expected");
            message.origination = $root.TezosSignTx.TezosOriginationOp.fromObject(object.origination);
        }
        if (object.delegation != null) {
            if (typeof object.delegation !== "object")
                throw TypeError(".TezosSignTx.delegation: object expected");
            message.delegation = $root.TezosSignTx.TezosDelegationOp.fromObject(object.delegation);
        }
        if (object.proposal != null) {
            if (typeof object.proposal !== "object")
                throw TypeError(".TezosSignTx.proposal: object expected");
            message.proposal = $root.TezosSignTx.TezosProposalOp.fromObject(object.proposal);
        }
        if (object.ballot != null) {
            if (typeof object.ballot !== "object")
                throw TypeError(".TezosSignTx.ballot: object expected");
            message.ballot = $root.TezosSignTx.TezosBallotOp.fromObject(object.ballot);
        }
        return message;
    };

    TezosSignTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            if (options.bytes === String)
                object.branch = "";
            else {
                object.branch = [];
                if (options.bytes !== Array)
                    object.branch = $util.newBuffer(object.branch);
            }
            object.reveal = null;
            object.transaction = null;
            object.origination = null;
            object.delegation = null;
            object.proposal = null;
            object.ballot = null;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.branch != null && message.hasOwnProperty("branch"))
            object.branch = options.bytes === String ? $util.base64.encode(message.branch, 0, message.branch.length) : options.bytes === Array ? Array.prototype.slice.call(message.branch) : message.branch;
        if (message.reveal != null && message.hasOwnProperty("reveal"))
            object.reveal = $root.TezosSignTx.TezosRevealOp.toObject(message.reveal, options);
        if (message.transaction != null && message.hasOwnProperty("transaction"))
            object.transaction = $root.TezosSignTx.TezosTransactionOp.toObject(message.transaction, options);
        if (message.origination != null && message.hasOwnProperty("origination"))
            object.origination = $root.TezosSignTx.TezosOriginationOp.toObject(message.origination, options);
        if (message.delegation != null && message.hasOwnProperty("delegation"))
            object.delegation = $root.TezosSignTx.TezosDelegationOp.toObject(message.delegation, options);
        if (message.proposal != null && message.hasOwnProperty("proposal"))
            object.proposal = $root.TezosSignTx.TezosProposalOp.toObject(message.proposal, options);
        if (message.ballot != null && message.hasOwnProperty("ballot"))
            object.ballot = $root.TezosSignTx.TezosBallotOp.toObject(message.ballot, options);
        return object;
    };

    TezosSignTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    TezosSignTx.TezosContractID = (function() {

        function TezosContractID(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        TezosContractID.prototype.tag = 0;
        TezosContractID.prototype.hash = $util.newBuffer([]);

        TezosContractID.create = function create(properties) {
            return new TezosContractID(properties);
        };

        TezosContractID.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(8).int32(message.tag);
            writer.uint32(18).bytes(message.hash);
            return writer;
        };

        TezosContractID.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        TezosContractID.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TezosSignTx.TezosContractID();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.tag = reader.int32();
                    break;
                case 2:
                    message.hash = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("tag"))
                throw $util.ProtocolError("missing required 'tag'", { instance: message });
            if (!message.hasOwnProperty("hash"))
                throw $util.ProtocolError("missing required 'hash'", { instance: message });
            return message;
        };

        TezosContractID.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        TezosContractID.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            switch (message.tag) {
            default:
                return "tag: enum value expected";
            case 0:
            case 1:
                break;
            }
            if (!(message.hash && typeof message.hash.length === "number" || $util.isString(message.hash)))
                return "hash: buffer expected";
            return null;
        };

        TezosContractID.fromObject = function fromObject(object) {
            if (object instanceof $root.TezosSignTx.TezosContractID)
                return object;
            var message = new $root.TezosSignTx.TezosContractID();
            switch (object.tag) {
            case "Implicit":
            case 0:
                message.tag = 0;
                break;
            case "Originated":
            case 1:
                message.tag = 1;
                break;
            }
            if (object.hash != null)
                if (typeof object.hash === "string")
                    $util.base64.decode(object.hash, message.hash = $util.newBuffer($util.base64.length(object.hash)), 0);
                else if (object.hash.length)
                    message.hash = object.hash;
            return message;
        };

        TezosContractID.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.tag = options.enums === String ? "Implicit" : 0;
                if (options.bytes === String)
                    object.hash = "";
                else {
                    object.hash = [];
                    if (options.bytes !== Array)
                        object.hash = $util.newBuffer(object.hash);
                }
            }
            if (message.tag != null && message.hasOwnProperty("tag"))
                object.tag = options.enums === String ? $root.TezosSignTx.TezosContractID.TezosContractType[message.tag] : message.tag;
            if (message.hash != null && message.hasOwnProperty("hash"))
                object.hash = options.bytes === String ? $util.base64.encode(message.hash, 0, message.hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.hash) : message.hash;
            return object;
        };

        TezosContractID.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        TezosContractID.TezosContractType = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "Implicit"] = 0;
            values[valuesById[1] = "Originated"] = 1;
            return values;
        })();

        return TezosContractID;
    })();

    TezosSignTx.TezosRevealOp = (function() {

        function TezosRevealOp(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        TezosRevealOp.prototype.source = $util.newBuffer([]);
        TezosRevealOp.prototype.fee = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        TezosRevealOp.prototype.counter = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        TezosRevealOp.prototype.gas_limit = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        TezosRevealOp.prototype.storage_limit = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        TezosRevealOp.prototype.public_key = $util.newBuffer([]);

        TezosRevealOp.create = function create(properties) {
            return new TezosRevealOp(properties);
        };

        TezosRevealOp.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(16).uint64(message.fee);
            writer.uint32(24).uint64(message.counter);
            writer.uint32(32).uint64(message.gas_limit);
            writer.uint32(40).uint64(message.storage_limit);
            writer.uint32(50).bytes(message.public_key);
            writer.uint32(58).bytes(message.source);
            return writer;
        };

        TezosRevealOp.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        TezosRevealOp.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TezosSignTx.TezosRevealOp();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 7:
                    message.source = reader.bytes();
                    break;
                case 2:
                    message.fee = reader.uint64();
                    break;
                case 3:
                    message.counter = reader.uint64();
                    break;
                case 4:
                    message.gas_limit = reader.uint64();
                    break;
                case 5:
                    message.storage_limit = reader.uint64();
                    break;
                case 6:
                    message.public_key = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("source"))
                throw $util.ProtocolError("missing required 'source'", { instance: message });
            if (!message.hasOwnProperty("fee"))
                throw $util.ProtocolError("missing required 'fee'", { instance: message });
            if (!message.hasOwnProperty("counter"))
                throw $util.ProtocolError("missing required 'counter'", { instance: message });
            if (!message.hasOwnProperty("gas_limit"))
                throw $util.ProtocolError("missing required 'gas_limit'", { instance: message });
            if (!message.hasOwnProperty("storage_limit"))
                throw $util.ProtocolError("missing required 'storage_limit'", { instance: message });
            if (!message.hasOwnProperty("public_key"))
                throw $util.ProtocolError("missing required 'public_key'", { instance: message });
            return message;
        };

        TezosRevealOp.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        TezosRevealOp.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!(message.source && typeof message.source.length === "number" || $util.isString(message.source)))
                return "source: buffer expected";
            if (!$util.isInteger(message.fee) && !(message.fee && $util.isInteger(message.fee.low) && $util.isInteger(message.fee.high)))
                return "fee: integer|Long expected";
            if (!$util.isInteger(message.counter) && !(message.counter && $util.isInteger(message.counter.low) && $util.isInteger(message.counter.high)))
                return "counter: integer|Long expected";
            if (!$util.isInteger(message.gas_limit) && !(message.gas_limit && $util.isInteger(message.gas_limit.low) && $util.isInteger(message.gas_limit.high)))
                return "gas_limit: integer|Long expected";
            if (!$util.isInteger(message.storage_limit) && !(message.storage_limit && $util.isInteger(message.storage_limit.low) && $util.isInteger(message.storage_limit.high)))
                return "storage_limit: integer|Long expected";
            if (!(message.public_key && typeof message.public_key.length === "number" || $util.isString(message.public_key)))
                return "public_key: buffer expected";
            return null;
        };

        TezosRevealOp.fromObject = function fromObject(object) {
            if (object instanceof $root.TezosSignTx.TezosRevealOp)
                return object;
            var message = new $root.TezosSignTx.TezosRevealOp();
            if (object.source != null)
                if (typeof object.source === "string")
                    $util.base64.decode(object.source, message.source = $util.newBuffer($util.base64.length(object.source)), 0);
                else if (object.source.length)
                    message.source = object.source;
            if (object.fee != null)
                if ($util.Long)
                    (message.fee = $util.Long.fromValue(object.fee)).unsigned = true;
                else if (typeof object.fee === "string")
                    message.fee = parseInt(object.fee, 10);
                else if (typeof object.fee === "number")
                    message.fee = object.fee;
                else if (typeof object.fee === "object")
                    message.fee = new $util.LongBits(object.fee.low >>> 0, object.fee.high >>> 0).toNumber(true);
            if (object.counter != null)
                if ($util.Long)
                    (message.counter = $util.Long.fromValue(object.counter)).unsigned = true;
                else if (typeof object.counter === "string")
                    message.counter = parseInt(object.counter, 10);
                else if (typeof object.counter === "number")
                    message.counter = object.counter;
                else if (typeof object.counter === "object")
                    message.counter = new $util.LongBits(object.counter.low >>> 0, object.counter.high >>> 0).toNumber(true);
            if (object.gas_limit != null)
                if ($util.Long)
                    (message.gas_limit = $util.Long.fromValue(object.gas_limit)).unsigned = true;
                else if (typeof object.gas_limit === "string")
                    message.gas_limit = parseInt(object.gas_limit, 10);
                else if (typeof object.gas_limit === "number")
                    message.gas_limit = object.gas_limit;
                else if (typeof object.gas_limit === "object")
                    message.gas_limit = new $util.LongBits(object.gas_limit.low >>> 0, object.gas_limit.high >>> 0).toNumber(true);
            if (object.storage_limit != null)
                if ($util.Long)
                    (message.storage_limit = $util.Long.fromValue(object.storage_limit)).unsigned = true;
                else if (typeof object.storage_limit === "string")
                    message.storage_limit = parseInt(object.storage_limit, 10);
                else if (typeof object.storage_limit === "number")
                    message.storage_limit = object.storage_limit;
                else if (typeof object.storage_limit === "object")
                    message.storage_limit = new $util.LongBits(object.storage_limit.low >>> 0, object.storage_limit.high >>> 0).toNumber(true);
            if (object.public_key != null)
                if (typeof object.public_key === "string")
                    $util.base64.decode(object.public_key, message.public_key = $util.newBuffer($util.base64.length(object.public_key)), 0);
                else if (object.public_key.length)
                    message.public_key = object.public_key;
            return message;
        };

        TezosRevealOp.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.fee = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.fee = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.counter = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.counter = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.gas_limit = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.gas_limit = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.storage_limit = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.storage_limit = options.longs === String ? "0" : 0;
                if (options.bytes === String)
                    object.public_key = "";
                else {
                    object.public_key = [];
                    if (options.bytes !== Array)
                        object.public_key = $util.newBuffer(object.public_key);
                }
                if (options.bytes === String)
                    object.source = "";
                else {
                    object.source = [];
                    if (options.bytes !== Array)
                        object.source = $util.newBuffer(object.source);
                }
            }
            if (message.fee != null && message.hasOwnProperty("fee"))
                if (typeof message.fee === "number")
                    object.fee = options.longs === String ? String(message.fee) : message.fee;
                else
                    object.fee = options.longs === String ? $util.Long.prototype.toString.call(message.fee) : options.longs === Number ? new $util.LongBits(message.fee.low >>> 0, message.fee.high >>> 0).toNumber(true) : message.fee;
            if (message.counter != null && message.hasOwnProperty("counter"))
                if (typeof message.counter === "number")
                    object.counter = options.longs === String ? String(message.counter) : message.counter;
                else
                    object.counter = options.longs === String ? $util.Long.prototype.toString.call(message.counter) : options.longs === Number ? new $util.LongBits(message.counter.low >>> 0, message.counter.high >>> 0).toNumber(true) : message.counter;
            if (message.gas_limit != null && message.hasOwnProperty("gas_limit"))
                if (typeof message.gas_limit === "number")
                    object.gas_limit = options.longs === String ? String(message.gas_limit) : message.gas_limit;
                else
                    object.gas_limit = options.longs === String ? $util.Long.prototype.toString.call(message.gas_limit) : options.longs === Number ? new $util.LongBits(message.gas_limit.low >>> 0, message.gas_limit.high >>> 0).toNumber(true) : message.gas_limit;
            if (message.storage_limit != null && message.hasOwnProperty("storage_limit"))
                if (typeof message.storage_limit === "number")
                    object.storage_limit = options.longs === String ? String(message.storage_limit) : message.storage_limit;
                else
                    object.storage_limit = options.longs === String ? $util.Long.prototype.toString.call(message.storage_limit) : options.longs === Number ? new $util.LongBits(message.storage_limit.low >>> 0, message.storage_limit.high >>> 0).toNumber(true) : message.storage_limit;
            if (message.public_key != null && message.hasOwnProperty("public_key"))
                object.public_key = options.bytes === String ? $util.base64.encode(message.public_key, 0, message.public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.public_key) : message.public_key;
            if (message.source != null && message.hasOwnProperty("source"))
                object.source = options.bytes === String ? $util.base64.encode(message.source, 0, message.source.length) : options.bytes === Array ? Array.prototype.slice.call(message.source) : message.source;
            return object;
        };

        TezosRevealOp.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TezosRevealOp;
    })();

    TezosSignTx.TezosTransactionOp = (function() {

        function TezosTransactionOp(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        TezosTransactionOp.prototype.source = $util.newBuffer([]);
        TezosTransactionOp.prototype.fee = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        TezosTransactionOp.prototype.counter = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        TezosTransactionOp.prototype.gas_limit = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        TezosTransactionOp.prototype.storage_limit = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        TezosTransactionOp.prototype.amount = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        TezosTransactionOp.prototype.destination = null;
        TezosTransactionOp.prototype.parameters = $util.newBuffer([]);
        TezosTransactionOp.prototype.parameters_manager = null;

        TezosTransactionOp.create = function create(properties) {
            return new TezosTransactionOp(properties);
        };

        TezosTransactionOp.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(16).uint64(message.fee);
            writer.uint32(24).uint64(message.counter);
            writer.uint32(32).uint64(message.gas_limit);
            writer.uint32(40).uint64(message.storage_limit);
            writer.uint32(48).uint64(message.amount);
            $root.TezosSignTx.TezosContractID.encode(message.destination, writer.uint32(58).fork()).ldelim();
            if (message.parameters != null && Object.hasOwnProperty.call(message, "parameters"))
                writer.uint32(66).bytes(message.parameters);
            writer.uint32(74).bytes(message.source);
            if (message.parameters_manager != null && Object.hasOwnProperty.call(message, "parameters_manager"))
                $root.TezosSignTx.TezosTransactionOp.TezosParametersManager.encode(message.parameters_manager, writer.uint32(82).fork()).ldelim();
            return writer;
        };

        TezosTransactionOp.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        TezosTransactionOp.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TezosSignTx.TezosTransactionOp();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 9:
                    message.source = reader.bytes();
                    break;
                case 2:
                    message.fee = reader.uint64();
                    break;
                case 3:
                    message.counter = reader.uint64();
                    break;
                case 4:
                    message.gas_limit = reader.uint64();
                    break;
                case 5:
                    message.storage_limit = reader.uint64();
                    break;
                case 6:
                    message.amount = reader.uint64();
                    break;
                case 7:
                    message.destination = $root.TezosSignTx.TezosContractID.decode(reader, reader.uint32());
                    break;
                case 8:
                    message.parameters = reader.bytes();
                    break;
                case 10:
                    message.parameters_manager = $root.TezosSignTx.TezosTransactionOp.TezosParametersManager.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("source"))
                throw $util.ProtocolError("missing required 'source'", { instance: message });
            if (!message.hasOwnProperty("fee"))
                throw $util.ProtocolError("missing required 'fee'", { instance: message });
            if (!message.hasOwnProperty("counter"))
                throw $util.ProtocolError("missing required 'counter'", { instance: message });
            if (!message.hasOwnProperty("gas_limit"))
                throw $util.ProtocolError("missing required 'gas_limit'", { instance: message });
            if (!message.hasOwnProperty("storage_limit"))
                throw $util.ProtocolError("missing required 'storage_limit'", { instance: message });
            if (!message.hasOwnProperty("amount"))
                throw $util.ProtocolError("missing required 'amount'", { instance: message });
            if (!message.hasOwnProperty("destination"))
                throw $util.ProtocolError("missing required 'destination'", { instance: message });
            return message;
        };

        TezosTransactionOp.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        TezosTransactionOp.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!(message.source && typeof message.source.length === "number" || $util.isString(message.source)))
                return "source: buffer expected";
            if (!$util.isInteger(message.fee) && !(message.fee && $util.isInteger(message.fee.low) && $util.isInteger(message.fee.high)))
                return "fee: integer|Long expected";
            if (!$util.isInteger(message.counter) && !(message.counter && $util.isInteger(message.counter.low) && $util.isInteger(message.counter.high)))
                return "counter: integer|Long expected";
            if (!$util.isInteger(message.gas_limit) && !(message.gas_limit && $util.isInteger(message.gas_limit.low) && $util.isInteger(message.gas_limit.high)))
                return "gas_limit: integer|Long expected";
            if (!$util.isInteger(message.storage_limit) && !(message.storage_limit && $util.isInteger(message.storage_limit.low) && $util.isInteger(message.storage_limit.high)))
                return "storage_limit: integer|Long expected";
            if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
                return "amount: integer|Long expected";
            {
                var error = $root.TezosSignTx.TezosContractID.verify(message.destination);
                if (error)
                    return "destination." + error;
            }
            if (message.parameters != null && message.hasOwnProperty("parameters"))
                if (!(message.parameters && typeof message.parameters.length === "number" || $util.isString(message.parameters)))
                    return "parameters: buffer expected";
            if (message.parameters_manager != null && message.hasOwnProperty("parameters_manager")) {
                var error = $root.TezosSignTx.TezosTransactionOp.TezosParametersManager.verify(message.parameters_manager);
                if (error)
                    return "parameters_manager." + error;
            }
            return null;
        };

        TezosTransactionOp.fromObject = function fromObject(object) {
            if (object instanceof $root.TezosSignTx.TezosTransactionOp)
                return object;
            var message = new $root.TezosSignTx.TezosTransactionOp();
            if (object.source != null)
                if (typeof object.source === "string")
                    $util.base64.decode(object.source, message.source = $util.newBuffer($util.base64.length(object.source)), 0);
                else if (object.source.length)
                    message.source = object.source;
            if (object.fee != null)
                if ($util.Long)
                    (message.fee = $util.Long.fromValue(object.fee)).unsigned = true;
                else if (typeof object.fee === "string")
                    message.fee = parseInt(object.fee, 10);
                else if (typeof object.fee === "number")
                    message.fee = object.fee;
                else if (typeof object.fee === "object")
                    message.fee = new $util.LongBits(object.fee.low >>> 0, object.fee.high >>> 0).toNumber(true);
            if (object.counter != null)
                if ($util.Long)
                    (message.counter = $util.Long.fromValue(object.counter)).unsigned = true;
                else if (typeof object.counter === "string")
                    message.counter = parseInt(object.counter, 10);
                else if (typeof object.counter === "number")
                    message.counter = object.counter;
                else if (typeof object.counter === "object")
                    message.counter = new $util.LongBits(object.counter.low >>> 0, object.counter.high >>> 0).toNumber(true);
            if (object.gas_limit != null)
                if ($util.Long)
                    (message.gas_limit = $util.Long.fromValue(object.gas_limit)).unsigned = true;
                else if (typeof object.gas_limit === "string")
                    message.gas_limit = parseInt(object.gas_limit, 10);
                else if (typeof object.gas_limit === "number")
                    message.gas_limit = object.gas_limit;
                else if (typeof object.gas_limit === "object")
                    message.gas_limit = new $util.LongBits(object.gas_limit.low >>> 0, object.gas_limit.high >>> 0).toNumber(true);
            if (object.storage_limit != null)
                if ($util.Long)
                    (message.storage_limit = $util.Long.fromValue(object.storage_limit)).unsigned = true;
                else if (typeof object.storage_limit === "string")
                    message.storage_limit = parseInt(object.storage_limit, 10);
                else if (typeof object.storage_limit === "number")
                    message.storage_limit = object.storage_limit;
                else if (typeof object.storage_limit === "object")
                    message.storage_limit = new $util.LongBits(object.storage_limit.low >>> 0, object.storage_limit.high >>> 0).toNumber(true);
            if (object.amount != null)
                if ($util.Long)
                    (message.amount = $util.Long.fromValue(object.amount)).unsigned = true;
                else if (typeof object.amount === "string")
                    message.amount = parseInt(object.amount, 10);
                else if (typeof object.amount === "number")
                    message.amount = object.amount;
                else if (typeof object.amount === "object")
                    message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber(true);
            if (object.destination != null) {
                if (typeof object.destination !== "object")
                    throw TypeError(".TezosSignTx.TezosTransactionOp.destination: object expected");
                message.destination = $root.TezosSignTx.TezosContractID.fromObject(object.destination);
            }
            if (object.parameters != null)
                if (typeof object.parameters === "string")
                    $util.base64.decode(object.parameters, message.parameters = $util.newBuffer($util.base64.length(object.parameters)), 0);
                else if (object.parameters.length)
                    message.parameters = object.parameters;
            if (object.parameters_manager != null) {
                if (typeof object.parameters_manager !== "object")
                    throw TypeError(".TezosSignTx.TezosTransactionOp.parameters_manager: object expected");
                message.parameters_manager = $root.TezosSignTx.TezosTransactionOp.TezosParametersManager.fromObject(object.parameters_manager);
            }
            return message;
        };

        TezosTransactionOp.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.fee = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.fee = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.counter = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.counter = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.gas_limit = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.gas_limit = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.storage_limit = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.storage_limit = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.amount = options.longs === String ? "0" : 0;
                object.destination = null;
                if (options.bytes === String)
                    object.parameters = "";
                else {
                    object.parameters = [];
                    if (options.bytes !== Array)
                        object.parameters = $util.newBuffer(object.parameters);
                }
                if (options.bytes === String)
                    object.source = "";
                else {
                    object.source = [];
                    if (options.bytes !== Array)
                        object.source = $util.newBuffer(object.source);
                }
                object.parameters_manager = null;
            }
            if (message.fee != null && message.hasOwnProperty("fee"))
                if (typeof message.fee === "number")
                    object.fee = options.longs === String ? String(message.fee) : message.fee;
                else
                    object.fee = options.longs === String ? $util.Long.prototype.toString.call(message.fee) : options.longs === Number ? new $util.LongBits(message.fee.low >>> 0, message.fee.high >>> 0).toNumber(true) : message.fee;
            if (message.counter != null && message.hasOwnProperty("counter"))
                if (typeof message.counter === "number")
                    object.counter = options.longs === String ? String(message.counter) : message.counter;
                else
                    object.counter = options.longs === String ? $util.Long.prototype.toString.call(message.counter) : options.longs === Number ? new $util.LongBits(message.counter.low >>> 0, message.counter.high >>> 0).toNumber(true) : message.counter;
            if (message.gas_limit != null && message.hasOwnProperty("gas_limit"))
                if (typeof message.gas_limit === "number")
                    object.gas_limit = options.longs === String ? String(message.gas_limit) : message.gas_limit;
                else
                    object.gas_limit = options.longs === String ? $util.Long.prototype.toString.call(message.gas_limit) : options.longs === Number ? new $util.LongBits(message.gas_limit.low >>> 0, message.gas_limit.high >>> 0).toNumber(true) : message.gas_limit;
            if (message.storage_limit != null && message.hasOwnProperty("storage_limit"))
                if (typeof message.storage_limit === "number")
                    object.storage_limit = options.longs === String ? String(message.storage_limit) : message.storage_limit;
                else
                    object.storage_limit = options.longs === String ? $util.Long.prototype.toString.call(message.storage_limit) : options.longs === Number ? new $util.LongBits(message.storage_limit.low >>> 0, message.storage_limit.high >>> 0).toNumber(true) : message.storage_limit;
            if (message.amount != null && message.hasOwnProperty("amount"))
                if (typeof message.amount === "number")
                    object.amount = options.longs === String ? String(message.amount) : message.amount;
                else
                    object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber(true) : message.amount;
            if (message.destination != null && message.hasOwnProperty("destination"))
                object.destination = $root.TezosSignTx.TezosContractID.toObject(message.destination, options);
            if (message.parameters != null && message.hasOwnProperty("parameters"))
                object.parameters = options.bytes === String ? $util.base64.encode(message.parameters, 0, message.parameters.length) : options.bytes === Array ? Array.prototype.slice.call(message.parameters) : message.parameters;
            if (message.source != null && message.hasOwnProperty("source"))
                object.source = options.bytes === String ? $util.base64.encode(message.source, 0, message.source.length) : options.bytes === Array ? Array.prototype.slice.call(message.source) : message.source;
            if (message.parameters_manager != null && message.hasOwnProperty("parameters_manager"))
                object.parameters_manager = $root.TezosSignTx.TezosTransactionOp.TezosParametersManager.toObject(message.parameters_manager, options);
            return object;
        };

        TezosTransactionOp.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        TezosTransactionOp.TezosParametersManager = (function() {

            function TezosParametersManager(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            TezosParametersManager.prototype.set_delegate = $util.newBuffer([]);
            TezosParametersManager.prototype.cancel_delegate = false;
            TezosParametersManager.prototype.transfer = null;

            TezosParametersManager.create = function create(properties) {
                return new TezosParametersManager(properties);
            };

            TezosParametersManager.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.set_delegate != null && Object.hasOwnProperty.call(message, "set_delegate"))
                    writer.uint32(10).bytes(message.set_delegate);
                if (message.cancel_delegate != null && Object.hasOwnProperty.call(message, "cancel_delegate"))
                    writer.uint32(16).bool(message.cancel_delegate);
                if (message.transfer != null && Object.hasOwnProperty.call(message, "transfer"))
                    $root.TezosSignTx.TezosTransactionOp.TezosParametersManager.TezosManagerTransfer.encode(message.transfer, writer.uint32(26).fork()).ldelim();
                return writer;
            };

            TezosParametersManager.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            TezosParametersManager.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TezosSignTx.TezosTransactionOp.TezosParametersManager();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.set_delegate = reader.bytes();
                        break;
                    case 2:
                        message.cancel_delegate = reader.bool();
                        break;
                    case 3:
                        message.transfer = $root.TezosSignTx.TezosTransactionOp.TezosParametersManager.TezosManagerTransfer.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            TezosParametersManager.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            TezosParametersManager.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.set_delegate != null && message.hasOwnProperty("set_delegate"))
                    if (!(message.set_delegate && typeof message.set_delegate.length === "number" || $util.isString(message.set_delegate)))
                        return "set_delegate: buffer expected";
                if (message.cancel_delegate != null && message.hasOwnProperty("cancel_delegate"))
                    if (typeof message.cancel_delegate !== "boolean")
                        return "cancel_delegate: boolean expected";
                if (message.transfer != null && message.hasOwnProperty("transfer")) {
                    var error = $root.TezosSignTx.TezosTransactionOp.TezosParametersManager.TezosManagerTransfer.verify(message.transfer);
                    if (error)
                        return "transfer." + error;
                }
                return null;
            };

            TezosParametersManager.fromObject = function fromObject(object) {
                if (object instanceof $root.TezosSignTx.TezosTransactionOp.TezosParametersManager)
                    return object;
                var message = new $root.TezosSignTx.TezosTransactionOp.TezosParametersManager();
                if (object.set_delegate != null)
                    if (typeof object.set_delegate === "string")
                        $util.base64.decode(object.set_delegate, message.set_delegate = $util.newBuffer($util.base64.length(object.set_delegate)), 0);
                    else if (object.set_delegate.length)
                        message.set_delegate = object.set_delegate;
                if (object.cancel_delegate != null)
                    message.cancel_delegate = Boolean(object.cancel_delegate);
                if (object.transfer != null) {
                    if (typeof object.transfer !== "object")
                        throw TypeError(".TezosSignTx.TezosTransactionOp.TezosParametersManager.transfer: object expected");
                    message.transfer = $root.TezosSignTx.TezosTransactionOp.TezosParametersManager.TezosManagerTransfer.fromObject(object.transfer);
                }
                return message;
            };

            TezosParametersManager.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    if (options.bytes === String)
                        object.set_delegate = "";
                    else {
                        object.set_delegate = [];
                        if (options.bytes !== Array)
                            object.set_delegate = $util.newBuffer(object.set_delegate);
                    }
                    object.cancel_delegate = false;
                    object.transfer = null;
                }
                if (message.set_delegate != null && message.hasOwnProperty("set_delegate"))
                    object.set_delegate = options.bytes === String ? $util.base64.encode(message.set_delegate, 0, message.set_delegate.length) : options.bytes === Array ? Array.prototype.slice.call(message.set_delegate) : message.set_delegate;
                if (message.cancel_delegate != null && message.hasOwnProperty("cancel_delegate"))
                    object.cancel_delegate = message.cancel_delegate;
                if (message.transfer != null && message.hasOwnProperty("transfer"))
                    object.transfer = $root.TezosSignTx.TezosTransactionOp.TezosParametersManager.TezosManagerTransfer.toObject(message.transfer, options);
                return object;
            };

            TezosParametersManager.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            TezosParametersManager.TezosManagerTransfer = (function() {

                function TezosManagerTransfer(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                TezosManagerTransfer.prototype.destination = null;
                TezosManagerTransfer.prototype.amount = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

                TezosManagerTransfer.create = function create(properties) {
                    return new TezosManagerTransfer(properties);
                };

                TezosManagerTransfer.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.destination != null && Object.hasOwnProperty.call(message, "destination"))
                        $root.TezosSignTx.TezosContractID.encode(message.destination, writer.uint32(10).fork()).ldelim();
                    if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
                        writer.uint32(16).uint64(message.amount);
                    return writer;
                };

                TezosManagerTransfer.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                TezosManagerTransfer.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TezosSignTx.TezosTransactionOp.TezosParametersManager.TezosManagerTransfer();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.destination = $root.TezosSignTx.TezosContractID.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.amount = reader.uint64();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                TezosManagerTransfer.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                TezosManagerTransfer.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.destination != null && message.hasOwnProperty("destination")) {
                        var error = $root.TezosSignTx.TezosContractID.verify(message.destination);
                        if (error)
                            return "destination." + error;
                    }
                    if (message.amount != null && message.hasOwnProperty("amount"))
                        if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
                            return "amount: integer|Long expected";
                    return null;
                };

                TezosManagerTransfer.fromObject = function fromObject(object) {
                    if (object instanceof $root.TezosSignTx.TezosTransactionOp.TezosParametersManager.TezosManagerTransfer)
                        return object;
                    var message = new $root.TezosSignTx.TezosTransactionOp.TezosParametersManager.TezosManagerTransfer();
                    if (object.destination != null) {
                        if (typeof object.destination !== "object")
                            throw TypeError(".TezosSignTx.TezosTransactionOp.TezosParametersManager.TezosManagerTransfer.destination: object expected");
                        message.destination = $root.TezosSignTx.TezosContractID.fromObject(object.destination);
                    }
                    if (object.amount != null)
                        if ($util.Long)
                            (message.amount = $util.Long.fromValue(object.amount)).unsigned = true;
                        else if (typeof object.amount === "string")
                            message.amount = parseInt(object.amount, 10);
                        else if (typeof object.amount === "number")
                            message.amount = object.amount;
                        else if (typeof object.amount === "object")
                            message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber(true);
                    return message;
                };

                TezosManagerTransfer.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.destination = null;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, true);
                            object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.amount = options.longs === String ? "0" : 0;
                    }
                    if (message.destination != null && message.hasOwnProperty("destination"))
                        object.destination = $root.TezosSignTx.TezosContractID.toObject(message.destination, options);
                    if (message.amount != null && message.hasOwnProperty("amount"))
                        if (typeof message.amount === "number")
                            object.amount = options.longs === String ? String(message.amount) : message.amount;
                        else
                            object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber(true) : message.amount;
                    return object;
                };

                TezosManagerTransfer.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return TezosManagerTransfer;
            })();

            return TezosParametersManager;
        })();

        return TezosTransactionOp;
    })();

    TezosSignTx.TezosOriginationOp = (function() {

        function TezosOriginationOp(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        TezosOriginationOp.prototype.source = $util.newBuffer([]);
        TezosOriginationOp.prototype.fee = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        TezosOriginationOp.prototype.counter = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        TezosOriginationOp.prototype.gas_limit = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        TezosOriginationOp.prototype.storage_limit = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        TezosOriginationOp.prototype.manager_pubkey = $util.newBuffer([]);
        TezosOriginationOp.prototype.balance = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        TezosOriginationOp.prototype.spendable = false;
        TezosOriginationOp.prototype.delegatable = false;
        TezosOriginationOp.prototype.delegate = $util.newBuffer([]);
        TezosOriginationOp.prototype.script = $util.newBuffer([]);

        TezosOriginationOp.create = function create(properties) {
            return new TezosOriginationOp(properties);
        };

        TezosOriginationOp.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(16).uint64(message.fee);
            writer.uint32(24).uint64(message.counter);
            writer.uint32(32).uint64(message.gas_limit);
            writer.uint32(40).uint64(message.storage_limit);
            if (message.manager_pubkey != null && Object.hasOwnProperty.call(message, "manager_pubkey"))
                writer.uint32(50).bytes(message.manager_pubkey);
            writer.uint32(56).uint64(message.balance);
            if (message.spendable != null && Object.hasOwnProperty.call(message, "spendable"))
                writer.uint32(64).bool(message.spendable);
            if (message.delegatable != null && Object.hasOwnProperty.call(message, "delegatable"))
                writer.uint32(72).bool(message.delegatable);
            if (message.delegate != null && Object.hasOwnProperty.call(message, "delegate"))
                writer.uint32(82).bytes(message.delegate);
            writer.uint32(90).bytes(message.script);
            writer.uint32(98).bytes(message.source);
            return writer;
        };

        TezosOriginationOp.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        TezosOriginationOp.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TezosSignTx.TezosOriginationOp();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 12:
                    message.source = reader.bytes();
                    break;
                case 2:
                    message.fee = reader.uint64();
                    break;
                case 3:
                    message.counter = reader.uint64();
                    break;
                case 4:
                    message.gas_limit = reader.uint64();
                    break;
                case 5:
                    message.storage_limit = reader.uint64();
                    break;
                case 6:
                    message.manager_pubkey = reader.bytes();
                    break;
                case 7:
                    message.balance = reader.uint64();
                    break;
                case 8:
                    message.spendable = reader.bool();
                    break;
                case 9:
                    message.delegatable = reader.bool();
                    break;
                case 10:
                    message.delegate = reader.bytes();
                    break;
                case 11:
                    message.script = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("source"))
                throw $util.ProtocolError("missing required 'source'", { instance: message });
            if (!message.hasOwnProperty("fee"))
                throw $util.ProtocolError("missing required 'fee'", { instance: message });
            if (!message.hasOwnProperty("counter"))
                throw $util.ProtocolError("missing required 'counter'", { instance: message });
            if (!message.hasOwnProperty("gas_limit"))
                throw $util.ProtocolError("missing required 'gas_limit'", { instance: message });
            if (!message.hasOwnProperty("storage_limit"))
                throw $util.ProtocolError("missing required 'storage_limit'", { instance: message });
            if (!message.hasOwnProperty("balance"))
                throw $util.ProtocolError("missing required 'balance'", { instance: message });
            if (!message.hasOwnProperty("script"))
                throw $util.ProtocolError("missing required 'script'", { instance: message });
            return message;
        };

        TezosOriginationOp.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        TezosOriginationOp.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!(message.source && typeof message.source.length === "number" || $util.isString(message.source)))
                return "source: buffer expected";
            if (!$util.isInteger(message.fee) && !(message.fee && $util.isInteger(message.fee.low) && $util.isInteger(message.fee.high)))
                return "fee: integer|Long expected";
            if (!$util.isInteger(message.counter) && !(message.counter && $util.isInteger(message.counter.low) && $util.isInteger(message.counter.high)))
                return "counter: integer|Long expected";
            if (!$util.isInteger(message.gas_limit) && !(message.gas_limit && $util.isInteger(message.gas_limit.low) && $util.isInteger(message.gas_limit.high)))
                return "gas_limit: integer|Long expected";
            if (!$util.isInteger(message.storage_limit) && !(message.storage_limit && $util.isInteger(message.storage_limit.low) && $util.isInteger(message.storage_limit.high)))
                return "storage_limit: integer|Long expected";
            if (message.manager_pubkey != null && message.hasOwnProperty("manager_pubkey"))
                if (!(message.manager_pubkey && typeof message.manager_pubkey.length === "number" || $util.isString(message.manager_pubkey)))
                    return "manager_pubkey: buffer expected";
            if (!$util.isInteger(message.balance) && !(message.balance && $util.isInteger(message.balance.low) && $util.isInteger(message.balance.high)))
                return "balance: integer|Long expected";
            if (message.spendable != null && message.hasOwnProperty("spendable"))
                if (typeof message.spendable !== "boolean")
                    return "spendable: boolean expected";
            if (message.delegatable != null && message.hasOwnProperty("delegatable"))
                if (typeof message.delegatable !== "boolean")
                    return "delegatable: boolean expected";
            if (message.delegate != null && message.hasOwnProperty("delegate"))
                if (!(message.delegate && typeof message.delegate.length === "number" || $util.isString(message.delegate)))
                    return "delegate: buffer expected";
            if (!(message.script && typeof message.script.length === "number" || $util.isString(message.script)))
                return "script: buffer expected";
            return null;
        };

        TezosOriginationOp.fromObject = function fromObject(object) {
            if (object instanceof $root.TezosSignTx.TezosOriginationOp)
                return object;
            var message = new $root.TezosSignTx.TezosOriginationOp();
            if (object.source != null)
                if (typeof object.source === "string")
                    $util.base64.decode(object.source, message.source = $util.newBuffer($util.base64.length(object.source)), 0);
                else if (object.source.length)
                    message.source = object.source;
            if (object.fee != null)
                if ($util.Long)
                    (message.fee = $util.Long.fromValue(object.fee)).unsigned = true;
                else if (typeof object.fee === "string")
                    message.fee = parseInt(object.fee, 10);
                else if (typeof object.fee === "number")
                    message.fee = object.fee;
                else if (typeof object.fee === "object")
                    message.fee = new $util.LongBits(object.fee.low >>> 0, object.fee.high >>> 0).toNumber(true);
            if (object.counter != null)
                if ($util.Long)
                    (message.counter = $util.Long.fromValue(object.counter)).unsigned = true;
                else if (typeof object.counter === "string")
                    message.counter = parseInt(object.counter, 10);
                else if (typeof object.counter === "number")
                    message.counter = object.counter;
                else if (typeof object.counter === "object")
                    message.counter = new $util.LongBits(object.counter.low >>> 0, object.counter.high >>> 0).toNumber(true);
            if (object.gas_limit != null)
                if ($util.Long)
                    (message.gas_limit = $util.Long.fromValue(object.gas_limit)).unsigned = true;
                else if (typeof object.gas_limit === "string")
                    message.gas_limit = parseInt(object.gas_limit, 10);
                else if (typeof object.gas_limit === "number")
                    message.gas_limit = object.gas_limit;
                else if (typeof object.gas_limit === "object")
                    message.gas_limit = new $util.LongBits(object.gas_limit.low >>> 0, object.gas_limit.high >>> 0).toNumber(true);
            if (object.storage_limit != null)
                if ($util.Long)
                    (message.storage_limit = $util.Long.fromValue(object.storage_limit)).unsigned = true;
                else if (typeof object.storage_limit === "string")
                    message.storage_limit = parseInt(object.storage_limit, 10);
                else if (typeof object.storage_limit === "number")
                    message.storage_limit = object.storage_limit;
                else if (typeof object.storage_limit === "object")
                    message.storage_limit = new $util.LongBits(object.storage_limit.low >>> 0, object.storage_limit.high >>> 0).toNumber(true);
            if (object.manager_pubkey != null)
                if (typeof object.manager_pubkey === "string")
                    $util.base64.decode(object.manager_pubkey, message.manager_pubkey = $util.newBuffer($util.base64.length(object.manager_pubkey)), 0);
                else if (object.manager_pubkey.length)
                    message.manager_pubkey = object.manager_pubkey;
            if (object.balance != null)
                if ($util.Long)
                    (message.balance = $util.Long.fromValue(object.balance)).unsigned = true;
                else if (typeof object.balance === "string")
                    message.balance = parseInt(object.balance, 10);
                else if (typeof object.balance === "number")
                    message.balance = object.balance;
                else if (typeof object.balance === "object")
                    message.balance = new $util.LongBits(object.balance.low >>> 0, object.balance.high >>> 0).toNumber(true);
            if (object.spendable != null)
                message.spendable = Boolean(object.spendable);
            if (object.delegatable != null)
                message.delegatable = Boolean(object.delegatable);
            if (object.delegate != null)
                if (typeof object.delegate === "string")
                    $util.base64.decode(object.delegate, message.delegate = $util.newBuffer($util.base64.length(object.delegate)), 0);
                else if (object.delegate.length)
                    message.delegate = object.delegate;
            if (object.script != null)
                if (typeof object.script === "string")
                    $util.base64.decode(object.script, message.script = $util.newBuffer($util.base64.length(object.script)), 0);
                else if (object.script.length)
                    message.script = object.script;
            return message;
        };

        TezosOriginationOp.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.fee = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.fee = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.counter = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.counter = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.gas_limit = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.gas_limit = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.storage_limit = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.storage_limit = options.longs === String ? "0" : 0;
                if (options.bytes === String)
                    object.manager_pubkey = "";
                else {
                    object.manager_pubkey = [];
                    if (options.bytes !== Array)
                        object.manager_pubkey = $util.newBuffer(object.manager_pubkey);
                }
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.balance = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.balance = options.longs === String ? "0" : 0;
                object.spendable = false;
                object.delegatable = false;
                if (options.bytes === String)
                    object.delegate = "";
                else {
                    object.delegate = [];
                    if (options.bytes !== Array)
                        object.delegate = $util.newBuffer(object.delegate);
                }
                if (options.bytes === String)
                    object.script = "";
                else {
                    object.script = [];
                    if (options.bytes !== Array)
                        object.script = $util.newBuffer(object.script);
                }
                if (options.bytes === String)
                    object.source = "";
                else {
                    object.source = [];
                    if (options.bytes !== Array)
                        object.source = $util.newBuffer(object.source);
                }
            }
            if (message.fee != null && message.hasOwnProperty("fee"))
                if (typeof message.fee === "number")
                    object.fee = options.longs === String ? String(message.fee) : message.fee;
                else
                    object.fee = options.longs === String ? $util.Long.prototype.toString.call(message.fee) : options.longs === Number ? new $util.LongBits(message.fee.low >>> 0, message.fee.high >>> 0).toNumber(true) : message.fee;
            if (message.counter != null && message.hasOwnProperty("counter"))
                if (typeof message.counter === "number")
                    object.counter = options.longs === String ? String(message.counter) : message.counter;
                else
                    object.counter = options.longs === String ? $util.Long.prototype.toString.call(message.counter) : options.longs === Number ? new $util.LongBits(message.counter.low >>> 0, message.counter.high >>> 0).toNumber(true) : message.counter;
            if (message.gas_limit != null && message.hasOwnProperty("gas_limit"))
                if (typeof message.gas_limit === "number")
                    object.gas_limit = options.longs === String ? String(message.gas_limit) : message.gas_limit;
                else
                    object.gas_limit = options.longs === String ? $util.Long.prototype.toString.call(message.gas_limit) : options.longs === Number ? new $util.LongBits(message.gas_limit.low >>> 0, message.gas_limit.high >>> 0).toNumber(true) : message.gas_limit;
            if (message.storage_limit != null && message.hasOwnProperty("storage_limit"))
                if (typeof message.storage_limit === "number")
                    object.storage_limit = options.longs === String ? String(message.storage_limit) : message.storage_limit;
                else
                    object.storage_limit = options.longs === String ? $util.Long.prototype.toString.call(message.storage_limit) : options.longs === Number ? new $util.LongBits(message.storage_limit.low >>> 0, message.storage_limit.high >>> 0).toNumber(true) : message.storage_limit;
            if (message.manager_pubkey != null && message.hasOwnProperty("manager_pubkey"))
                object.manager_pubkey = options.bytes === String ? $util.base64.encode(message.manager_pubkey, 0, message.manager_pubkey.length) : options.bytes === Array ? Array.prototype.slice.call(message.manager_pubkey) : message.manager_pubkey;
            if (message.balance != null && message.hasOwnProperty("balance"))
                if (typeof message.balance === "number")
                    object.balance = options.longs === String ? String(message.balance) : message.balance;
                else
                    object.balance = options.longs === String ? $util.Long.prototype.toString.call(message.balance) : options.longs === Number ? new $util.LongBits(message.balance.low >>> 0, message.balance.high >>> 0).toNumber(true) : message.balance;
            if (message.spendable != null && message.hasOwnProperty("spendable"))
                object.spendable = message.spendable;
            if (message.delegatable != null && message.hasOwnProperty("delegatable"))
                object.delegatable = message.delegatable;
            if (message.delegate != null && message.hasOwnProperty("delegate"))
                object.delegate = options.bytes === String ? $util.base64.encode(message.delegate, 0, message.delegate.length) : options.bytes === Array ? Array.prototype.slice.call(message.delegate) : message.delegate;
            if (message.script != null && message.hasOwnProperty("script"))
                object.script = options.bytes === String ? $util.base64.encode(message.script, 0, message.script.length) : options.bytes === Array ? Array.prototype.slice.call(message.script) : message.script;
            if (message.source != null && message.hasOwnProperty("source"))
                object.source = options.bytes === String ? $util.base64.encode(message.source, 0, message.source.length) : options.bytes === Array ? Array.prototype.slice.call(message.source) : message.source;
            return object;
        };

        TezosOriginationOp.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TezosOriginationOp;
    })();

    TezosSignTx.TezosDelegationOp = (function() {

        function TezosDelegationOp(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        TezosDelegationOp.prototype.source = $util.newBuffer([]);
        TezosDelegationOp.prototype.fee = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        TezosDelegationOp.prototype.counter = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        TezosDelegationOp.prototype.gas_limit = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        TezosDelegationOp.prototype.storage_limit = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        TezosDelegationOp.prototype.delegate = $util.newBuffer([]);

        TezosDelegationOp.create = function create(properties) {
            return new TezosDelegationOp(properties);
        };

        TezosDelegationOp.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(16).uint64(message.fee);
            writer.uint32(24).uint64(message.counter);
            writer.uint32(32).uint64(message.gas_limit);
            writer.uint32(40).uint64(message.storage_limit);
            writer.uint32(50).bytes(message.delegate);
            writer.uint32(58).bytes(message.source);
            return writer;
        };

        TezosDelegationOp.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        TezosDelegationOp.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TezosSignTx.TezosDelegationOp();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 7:
                    message.source = reader.bytes();
                    break;
                case 2:
                    message.fee = reader.uint64();
                    break;
                case 3:
                    message.counter = reader.uint64();
                    break;
                case 4:
                    message.gas_limit = reader.uint64();
                    break;
                case 5:
                    message.storage_limit = reader.uint64();
                    break;
                case 6:
                    message.delegate = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("source"))
                throw $util.ProtocolError("missing required 'source'", { instance: message });
            if (!message.hasOwnProperty("fee"))
                throw $util.ProtocolError("missing required 'fee'", { instance: message });
            if (!message.hasOwnProperty("counter"))
                throw $util.ProtocolError("missing required 'counter'", { instance: message });
            if (!message.hasOwnProperty("gas_limit"))
                throw $util.ProtocolError("missing required 'gas_limit'", { instance: message });
            if (!message.hasOwnProperty("storage_limit"))
                throw $util.ProtocolError("missing required 'storage_limit'", { instance: message });
            if (!message.hasOwnProperty("delegate"))
                throw $util.ProtocolError("missing required 'delegate'", { instance: message });
            return message;
        };

        TezosDelegationOp.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        TezosDelegationOp.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!(message.source && typeof message.source.length === "number" || $util.isString(message.source)))
                return "source: buffer expected";
            if (!$util.isInteger(message.fee) && !(message.fee && $util.isInteger(message.fee.low) && $util.isInteger(message.fee.high)))
                return "fee: integer|Long expected";
            if (!$util.isInteger(message.counter) && !(message.counter && $util.isInteger(message.counter.low) && $util.isInteger(message.counter.high)))
                return "counter: integer|Long expected";
            if (!$util.isInteger(message.gas_limit) && !(message.gas_limit && $util.isInteger(message.gas_limit.low) && $util.isInteger(message.gas_limit.high)))
                return "gas_limit: integer|Long expected";
            if (!$util.isInteger(message.storage_limit) && !(message.storage_limit && $util.isInteger(message.storage_limit.low) && $util.isInteger(message.storage_limit.high)))
                return "storage_limit: integer|Long expected";
            if (!(message.delegate && typeof message.delegate.length === "number" || $util.isString(message.delegate)))
                return "delegate: buffer expected";
            return null;
        };

        TezosDelegationOp.fromObject = function fromObject(object) {
            if (object instanceof $root.TezosSignTx.TezosDelegationOp)
                return object;
            var message = new $root.TezosSignTx.TezosDelegationOp();
            if (object.source != null)
                if (typeof object.source === "string")
                    $util.base64.decode(object.source, message.source = $util.newBuffer($util.base64.length(object.source)), 0);
                else if (object.source.length)
                    message.source = object.source;
            if (object.fee != null)
                if ($util.Long)
                    (message.fee = $util.Long.fromValue(object.fee)).unsigned = true;
                else if (typeof object.fee === "string")
                    message.fee = parseInt(object.fee, 10);
                else if (typeof object.fee === "number")
                    message.fee = object.fee;
                else if (typeof object.fee === "object")
                    message.fee = new $util.LongBits(object.fee.low >>> 0, object.fee.high >>> 0).toNumber(true);
            if (object.counter != null)
                if ($util.Long)
                    (message.counter = $util.Long.fromValue(object.counter)).unsigned = true;
                else if (typeof object.counter === "string")
                    message.counter = parseInt(object.counter, 10);
                else if (typeof object.counter === "number")
                    message.counter = object.counter;
                else if (typeof object.counter === "object")
                    message.counter = new $util.LongBits(object.counter.low >>> 0, object.counter.high >>> 0).toNumber(true);
            if (object.gas_limit != null)
                if ($util.Long)
                    (message.gas_limit = $util.Long.fromValue(object.gas_limit)).unsigned = true;
                else if (typeof object.gas_limit === "string")
                    message.gas_limit = parseInt(object.gas_limit, 10);
                else if (typeof object.gas_limit === "number")
                    message.gas_limit = object.gas_limit;
                else if (typeof object.gas_limit === "object")
                    message.gas_limit = new $util.LongBits(object.gas_limit.low >>> 0, object.gas_limit.high >>> 0).toNumber(true);
            if (object.storage_limit != null)
                if ($util.Long)
                    (message.storage_limit = $util.Long.fromValue(object.storage_limit)).unsigned = true;
                else if (typeof object.storage_limit === "string")
                    message.storage_limit = parseInt(object.storage_limit, 10);
                else if (typeof object.storage_limit === "number")
                    message.storage_limit = object.storage_limit;
                else if (typeof object.storage_limit === "object")
                    message.storage_limit = new $util.LongBits(object.storage_limit.low >>> 0, object.storage_limit.high >>> 0).toNumber(true);
            if (object.delegate != null)
                if (typeof object.delegate === "string")
                    $util.base64.decode(object.delegate, message.delegate = $util.newBuffer($util.base64.length(object.delegate)), 0);
                else if (object.delegate.length)
                    message.delegate = object.delegate;
            return message;
        };

        TezosDelegationOp.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.fee = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.fee = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.counter = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.counter = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.gas_limit = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.gas_limit = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.storage_limit = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.storage_limit = options.longs === String ? "0" : 0;
                if (options.bytes === String)
                    object.delegate = "";
                else {
                    object.delegate = [];
                    if (options.bytes !== Array)
                        object.delegate = $util.newBuffer(object.delegate);
                }
                if (options.bytes === String)
                    object.source = "";
                else {
                    object.source = [];
                    if (options.bytes !== Array)
                        object.source = $util.newBuffer(object.source);
                }
            }
            if (message.fee != null && message.hasOwnProperty("fee"))
                if (typeof message.fee === "number")
                    object.fee = options.longs === String ? String(message.fee) : message.fee;
                else
                    object.fee = options.longs === String ? $util.Long.prototype.toString.call(message.fee) : options.longs === Number ? new $util.LongBits(message.fee.low >>> 0, message.fee.high >>> 0).toNumber(true) : message.fee;
            if (message.counter != null && message.hasOwnProperty("counter"))
                if (typeof message.counter === "number")
                    object.counter = options.longs === String ? String(message.counter) : message.counter;
                else
                    object.counter = options.longs === String ? $util.Long.prototype.toString.call(message.counter) : options.longs === Number ? new $util.LongBits(message.counter.low >>> 0, message.counter.high >>> 0).toNumber(true) : message.counter;
            if (message.gas_limit != null && message.hasOwnProperty("gas_limit"))
                if (typeof message.gas_limit === "number")
                    object.gas_limit = options.longs === String ? String(message.gas_limit) : message.gas_limit;
                else
                    object.gas_limit = options.longs === String ? $util.Long.prototype.toString.call(message.gas_limit) : options.longs === Number ? new $util.LongBits(message.gas_limit.low >>> 0, message.gas_limit.high >>> 0).toNumber(true) : message.gas_limit;
            if (message.storage_limit != null && message.hasOwnProperty("storage_limit"))
                if (typeof message.storage_limit === "number")
                    object.storage_limit = options.longs === String ? String(message.storage_limit) : message.storage_limit;
                else
                    object.storage_limit = options.longs === String ? $util.Long.prototype.toString.call(message.storage_limit) : options.longs === Number ? new $util.LongBits(message.storage_limit.low >>> 0, message.storage_limit.high >>> 0).toNumber(true) : message.storage_limit;
            if (message.delegate != null && message.hasOwnProperty("delegate"))
                object.delegate = options.bytes === String ? $util.base64.encode(message.delegate, 0, message.delegate.length) : options.bytes === Array ? Array.prototype.slice.call(message.delegate) : message.delegate;
            if (message.source != null && message.hasOwnProperty("source"))
                object.source = options.bytes === String ? $util.base64.encode(message.source, 0, message.source.length) : options.bytes === Array ? Array.prototype.slice.call(message.source) : message.source;
            return object;
        };

        TezosDelegationOp.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TezosDelegationOp;
    })();

    TezosSignTx.TezosProposalOp = (function() {

        function TezosProposalOp(properties) {
            this.proposals = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        TezosProposalOp.prototype.source = $util.newBuffer([]);
        TezosProposalOp.prototype.period = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        TezosProposalOp.prototype.proposals = $util.emptyArray;

        TezosProposalOp.create = function create(properties) {
            return new TezosProposalOp(properties);
        };

        TezosProposalOp.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.source != null && Object.hasOwnProperty.call(message, "source"))
                writer.uint32(10).bytes(message.source);
            if (message.period != null && Object.hasOwnProperty.call(message, "period"))
                writer.uint32(16).uint64(message.period);
            if (message.proposals != null && message.proposals.length)
                for (var i = 0; i < message.proposals.length; ++i)
                    writer.uint32(34).bytes(message.proposals[i]);
            return writer;
        };

        TezosProposalOp.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        TezosProposalOp.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TezosSignTx.TezosProposalOp();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.source = reader.bytes();
                    break;
                case 2:
                    message.period = reader.uint64();
                    break;
                case 4:
                    if (!(message.proposals && message.proposals.length))
                        message.proposals = [];
                    message.proposals.push(reader.bytes());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        TezosProposalOp.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        TezosProposalOp.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.source != null && message.hasOwnProperty("source"))
                if (!(message.source && typeof message.source.length === "number" || $util.isString(message.source)))
                    return "source: buffer expected";
            if (message.period != null && message.hasOwnProperty("period"))
                if (!$util.isInteger(message.period) && !(message.period && $util.isInteger(message.period.low) && $util.isInteger(message.period.high)))
                    return "period: integer|Long expected";
            if (message.proposals != null && message.hasOwnProperty("proposals")) {
                if (!Array.isArray(message.proposals))
                    return "proposals: array expected";
                for (var i = 0; i < message.proposals.length; ++i)
                    if (!(message.proposals[i] && typeof message.proposals[i].length === "number" || $util.isString(message.proposals[i])))
                        return "proposals: buffer[] expected";
            }
            return null;
        };

        TezosProposalOp.fromObject = function fromObject(object) {
            if (object instanceof $root.TezosSignTx.TezosProposalOp)
                return object;
            var message = new $root.TezosSignTx.TezosProposalOp();
            if (object.source != null)
                if (typeof object.source === "string")
                    $util.base64.decode(object.source, message.source = $util.newBuffer($util.base64.length(object.source)), 0);
                else if (object.source.length)
                    message.source = object.source;
            if (object.period != null)
                if ($util.Long)
                    (message.period = $util.Long.fromValue(object.period)).unsigned = true;
                else if (typeof object.period === "string")
                    message.period = parseInt(object.period, 10);
                else if (typeof object.period === "number")
                    message.period = object.period;
                else if (typeof object.period === "object")
                    message.period = new $util.LongBits(object.period.low >>> 0, object.period.high >>> 0).toNumber(true);
            if (object.proposals) {
                if (!Array.isArray(object.proposals))
                    throw TypeError(".TezosSignTx.TezosProposalOp.proposals: array expected");
                message.proposals = [];
                for (var i = 0; i < object.proposals.length; ++i)
                    if (typeof object.proposals[i] === "string")
                        $util.base64.decode(object.proposals[i], message.proposals[i] = $util.newBuffer($util.base64.length(object.proposals[i])), 0);
                    else if (object.proposals[i].length)
                        message.proposals[i] = object.proposals[i];
            }
            return message;
        };

        TezosProposalOp.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.proposals = [];
            if (options.defaults) {
                if (options.bytes === String)
                    object.source = "";
                else {
                    object.source = [];
                    if (options.bytes !== Array)
                        object.source = $util.newBuffer(object.source);
                }
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.period = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.period = options.longs === String ? "0" : 0;
            }
            if (message.source != null && message.hasOwnProperty("source"))
                object.source = options.bytes === String ? $util.base64.encode(message.source, 0, message.source.length) : options.bytes === Array ? Array.prototype.slice.call(message.source) : message.source;
            if (message.period != null && message.hasOwnProperty("period"))
                if (typeof message.period === "number")
                    object.period = options.longs === String ? String(message.period) : message.period;
                else
                    object.period = options.longs === String ? $util.Long.prototype.toString.call(message.period) : options.longs === Number ? new $util.LongBits(message.period.low >>> 0, message.period.high >>> 0).toNumber(true) : message.period;
            if (message.proposals && message.proposals.length) {
                object.proposals = [];
                for (var j = 0; j < message.proposals.length; ++j)
                    object.proposals[j] = options.bytes === String ? $util.base64.encode(message.proposals[j], 0, message.proposals[j].length) : options.bytes === Array ? Array.prototype.slice.call(message.proposals[j]) : message.proposals[j];
            }
            return object;
        };

        TezosProposalOp.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TezosProposalOp;
    })();

    TezosSignTx.TezosBallotOp = (function() {

        function TezosBallotOp(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        TezosBallotOp.prototype.source = $util.newBuffer([]);
        TezosBallotOp.prototype.period = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        TezosBallotOp.prototype.proposal = $util.newBuffer([]);
        TezosBallotOp.prototype.ballot = 0;

        TezosBallotOp.create = function create(properties) {
            return new TezosBallotOp(properties);
        };

        TezosBallotOp.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.source != null && Object.hasOwnProperty.call(message, "source"))
                writer.uint32(10).bytes(message.source);
            if (message.period != null && Object.hasOwnProperty.call(message, "period"))
                writer.uint32(16).uint64(message.period);
            if (message.proposal != null && Object.hasOwnProperty.call(message, "proposal"))
                writer.uint32(26).bytes(message.proposal);
            if (message.ballot != null && Object.hasOwnProperty.call(message, "ballot"))
                writer.uint32(32).int32(message.ballot);
            return writer;
        };

        TezosBallotOp.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        TezosBallotOp.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TezosSignTx.TezosBallotOp();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.source = reader.bytes();
                    break;
                case 2:
                    message.period = reader.uint64();
                    break;
                case 3:
                    message.proposal = reader.bytes();
                    break;
                case 4:
                    message.ballot = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        TezosBallotOp.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        TezosBallotOp.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.source != null && message.hasOwnProperty("source"))
                if (!(message.source && typeof message.source.length === "number" || $util.isString(message.source)))
                    return "source: buffer expected";
            if (message.period != null && message.hasOwnProperty("period"))
                if (!$util.isInteger(message.period) && !(message.period && $util.isInteger(message.period.low) && $util.isInteger(message.period.high)))
                    return "period: integer|Long expected";
            if (message.proposal != null && message.hasOwnProperty("proposal"))
                if (!(message.proposal && typeof message.proposal.length === "number" || $util.isString(message.proposal)))
                    return "proposal: buffer expected";
            if (message.ballot != null && message.hasOwnProperty("ballot"))
                switch (message.ballot) {
                default:
                    return "ballot: enum value expected";
                case 0:
                case 1:
                case 2:
                    break;
                }
            return null;
        };

        TezosBallotOp.fromObject = function fromObject(object) {
            if (object instanceof $root.TezosSignTx.TezosBallotOp)
                return object;
            var message = new $root.TezosSignTx.TezosBallotOp();
            if (object.source != null)
                if (typeof object.source === "string")
                    $util.base64.decode(object.source, message.source = $util.newBuffer($util.base64.length(object.source)), 0);
                else if (object.source.length)
                    message.source = object.source;
            if (object.period != null)
                if ($util.Long)
                    (message.period = $util.Long.fromValue(object.period)).unsigned = true;
                else if (typeof object.period === "string")
                    message.period = parseInt(object.period, 10);
                else if (typeof object.period === "number")
                    message.period = object.period;
                else if (typeof object.period === "object")
                    message.period = new $util.LongBits(object.period.low >>> 0, object.period.high >>> 0).toNumber(true);
            if (object.proposal != null)
                if (typeof object.proposal === "string")
                    $util.base64.decode(object.proposal, message.proposal = $util.newBuffer($util.base64.length(object.proposal)), 0);
                else if (object.proposal.length)
                    message.proposal = object.proposal;
            switch (object.ballot) {
            case "Yay":
            case 0:
                message.ballot = 0;
                break;
            case "Nay":
            case 1:
                message.ballot = 1;
                break;
            case "Pass":
            case 2:
                message.ballot = 2;
                break;
            }
            return message;
        };

        TezosBallotOp.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if (options.bytes === String)
                    object.source = "";
                else {
                    object.source = [];
                    if (options.bytes !== Array)
                        object.source = $util.newBuffer(object.source);
                }
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.period = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.period = options.longs === String ? "0" : 0;
                if (options.bytes === String)
                    object.proposal = "";
                else {
                    object.proposal = [];
                    if (options.bytes !== Array)
                        object.proposal = $util.newBuffer(object.proposal);
                }
                object.ballot = options.enums === String ? "Yay" : 0;
            }
            if (message.source != null && message.hasOwnProperty("source"))
                object.source = options.bytes === String ? $util.base64.encode(message.source, 0, message.source.length) : options.bytes === Array ? Array.prototype.slice.call(message.source) : message.source;
            if (message.period != null && message.hasOwnProperty("period"))
                if (typeof message.period === "number")
                    object.period = options.longs === String ? String(message.period) : message.period;
                else
                    object.period = options.longs === String ? $util.Long.prototype.toString.call(message.period) : options.longs === Number ? new $util.LongBits(message.period.low >>> 0, message.period.high >>> 0).toNumber(true) : message.period;
            if (message.proposal != null && message.hasOwnProperty("proposal"))
                object.proposal = options.bytes === String ? $util.base64.encode(message.proposal, 0, message.proposal.length) : options.bytes === Array ? Array.prototype.slice.call(message.proposal) : message.proposal;
            if (message.ballot != null && message.hasOwnProperty("ballot"))
                object.ballot = options.enums === String ? $root.TezosSignTx.TezosBallotOp.TezosBallotType[message.ballot] : message.ballot;
            return object;
        };

        TezosBallotOp.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        TezosBallotOp.TezosBallotType = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "Yay"] = 0;
            values[valuesById[1] = "Nay"] = 1;
            values[valuesById[2] = "Pass"] = 2;
            return values;
        })();

        return TezosBallotOp;
    })();

    return TezosSignTx;
})();

$root.TezosSignedTx = (function() {

    function TezosSignedTx(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    TezosSignedTx.prototype.signature = "";
    TezosSignedTx.prototype.sig_op_contents = $util.newBuffer([]);
    TezosSignedTx.prototype.operation_hash = "";

    TezosSignedTx.create = function create(properties) {
        return new TezosSignedTx(properties);
    };

    TezosSignedTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.signature);
        writer.uint32(18).bytes(message.sig_op_contents);
        writer.uint32(26).string(message.operation_hash);
        return writer;
    };

    TezosSignedTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    TezosSignedTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TezosSignedTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.signature = reader.string();
                break;
            case 2:
                message.sig_op_contents = reader.bytes();
                break;
            case 3:
                message.operation_hash = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        if (!message.hasOwnProperty("sig_op_contents"))
            throw $util.ProtocolError("missing required 'sig_op_contents'", { instance: message });
        if (!message.hasOwnProperty("operation_hash"))
            throw $util.ProtocolError("missing required 'operation_hash'", { instance: message });
        return message;
    };

    TezosSignedTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    TezosSignedTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.signature))
            return "signature: string expected";
        if (!(message.sig_op_contents && typeof message.sig_op_contents.length === "number" || $util.isString(message.sig_op_contents)))
            return "sig_op_contents: buffer expected";
        if (!$util.isString(message.operation_hash))
            return "operation_hash: string expected";
        return null;
    };

    TezosSignedTx.fromObject = function fromObject(object) {
        if (object instanceof $root.TezosSignedTx)
            return object;
        var message = new $root.TezosSignedTx();
        if (object.signature != null)
            message.signature = String(object.signature);
        if (object.sig_op_contents != null)
            if (typeof object.sig_op_contents === "string")
                $util.base64.decode(object.sig_op_contents, message.sig_op_contents = $util.newBuffer($util.base64.length(object.sig_op_contents)), 0);
            else if (object.sig_op_contents.length)
                message.sig_op_contents = object.sig_op_contents;
        if (object.operation_hash != null)
            message.operation_hash = String(object.operation_hash);
        return message;
    };

    TezosSignedTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.signature = "";
            if (options.bytes === String)
                object.sig_op_contents = "";
            else {
                object.sig_op_contents = [];
                if (options.bytes !== Array)
                    object.sig_op_contents = $util.newBuffer(object.sig_op_contents);
            }
            object.operation_hash = "";
        }
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = message.signature;
        if (message.sig_op_contents != null && message.hasOwnProperty("sig_op_contents"))
            object.sig_op_contents = options.bytes === String ? $util.base64.encode(message.sig_op_contents, 0, message.sig_op_contents.length) : options.bytes === Array ? Array.prototype.slice.call(message.sig_op_contents) : message.sig_op_contents;
        if (message.operation_hash != null && message.hasOwnProperty("operation_hash"))
            object.operation_hash = message.operation_hash;
        return object;
    };

    TezosSignedTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return TezosSignedTx;
})();

$root.TronGetAddress = (function() {

    function TronGetAddress(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    TronGetAddress.prototype.address_n = $util.emptyArray;
    TronGetAddress.prototype.show_display = false;

    TronGetAddress.create = function create(properties) {
        return new TronGetAddress(properties);
    };

    TronGetAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(16).bool(message.show_display);
        return writer;
    };

    TronGetAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    TronGetAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TronGetAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.show_display = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    TronGetAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    TronGetAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        return null;
    };

    TronGetAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.TronGetAddress)
            return object;
        var message = new $root.TronGetAddress();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".TronGetAddress.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        return message;
    };

    TronGetAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            object.show_display = false;
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        return object;
    };

    TronGetAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return TronGetAddress;
})();

$root.TronAddress = (function() {

    function TronAddress(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    TronAddress.prototype.address = "";

    TronAddress.create = function create(properties) {
        return new TronAddress(properties);
    };

    TronAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address != null && Object.hasOwnProperty.call(message, "address"))
            writer.uint32(10).string(message.address);
        return writer;
    };

    TronAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    TronAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TronAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    TronAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    TronAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address != null && message.hasOwnProperty("address"))
            if (!$util.isString(message.address))
                return "address: string expected";
        return null;
    };

    TronAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.TronAddress)
            return object;
        var message = new $root.TronAddress();
        if (object.address != null)
            message.address = String(object.address);
        return message;
    };

    TronAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.address = "";
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    TronAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return TronAddress;
})();

$root.TronSignTx = (function() {

    function TronSignTx(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    TronSignTx.prototype.address_n = $util.emptyArray;
    TronSignTx.prototype.ref_block_bytes = $util.newBuffer([]);
    TronSignTx.prototype.ref_block_hash = $util.newBuffer([]);
    TronSignTx.prototype.expiration = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    TronSignTx.prototype.data = "";
    TronSignTx.prototype.contract = null;
    TronSignTx.prototype.timestamp = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    TronSignTx.prototype.fee_limit = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    TronSignTx.create = function create(properties) {
        return new TronSignTx(properties);
    };

    TronSignTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).bytes(message.ref_block_bytes);
        writer.uint32(26).bytes(message.ref_block_hash);
        writer.uint32(32).uint64(message.expiration);
        if (message.data != null && Object.hasOwnProperty.call(message, "data"))
            writer.uint32(42).string(message.data);
        $root.TronSignTx.TronContract.encode(message.contract, writer.uint32(50).fork()).ldelim();
        writer.uint32(56).uint64(message.timestamp);
        if (message.fee_limit != null && Object.hasOwnProperty.call(message, "fee_limit"))
            writer.uint32(64).uint64(message.fee_limit);
        return writer;
    };

    TronSignTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    TronSignTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TronSignTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.ref_block_bytes = reader.bytes();
                break;
            case 3:
                message.ref_block_hash = reader.bytes();
                break;
            case 4:
                message.expiration = reader.uint64();
                break;
            case 5:
                message.data = reader.string();
                break;
            case 6:
                message.contract = $root.TronSignTx.TronContract.decode(reader, reader.uint32());
                break;
            case 7:
                message.timestamp = reader.uint64();
                break;
            case 8:
                message.fee_limit = reader.uint64();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("ref_block_bytes"))
            throw $util.ProtocolError("missing required 'ref_block_bytes'", { instance: message });
        if (!message.hasOwnProperty("ref_block_hash"))
            throw $util.ProtocolError("missing required 'ref_block_hash'", { instance: message });
        if (!message.hasOwnProperty("expiration"))
            throw $util.ProtocolError("missing required 'expiration'", { instance: message });
        if (!message.hasOwnProperty("contract"))
            throw $util.ProtocolError("missing required 'contract'", { instance: message });
        if (!message.hasOwnProperty("timestamp"))
            throw $util.ProtocolError("missing required 'timestamp'", { instance: message });
        return message;
    };

    TronSignTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    TronSignTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!(message.ref_block_bytes && typeof message.ref_block_bytes.length === "number" || $util.isString(message.ref_block_bytes)))
            return "ref_block_bytes: buffer expected";
        if (!(message.ref_block_hash && typeof message.ref_block_hash.length === "number" || $util.isString(message.ref_block_hash)))
            return "ref_block_hash: buffer expected";
        if (!$util.isInteger(message.expiration) && !(message.expiration && $util.isInteger(message.expiration.low) && $util.isInteger(message.expiration.high)))
            return "expiration: integer|Long expected";
        if (message.data != null && message.hasOwnProperty("data"))
            if (!$util.isString(message.data))
                return "data: string expected";
        {
            var error = $root.TronSignTx.TronContract.verify(message.contract);
            if (error)
                return "contract." + error;
        }
        if (!$util.isInteger(message.timestamp) && !(message.timestamp && $util.isInteger(message.timestamp.low) && $util.isInteger(message.timestamp.high)))
            return "timestamp: integer|Long expected";
        if (message.fee_limit != null && message.hasOwnProperty("fee_limit"))
            if (!$util.isInteger(message.fee_limit) && !(message.fee_limit && $util.isInteger(message.fee_limit.low) && $util.isInteger(message.fee_limit.high)))
                return "fee_limit: integer|Long expected";
        return null;
    };

    TronSignTx.fromObject = function fromObject(object) {
        if (object instanceof $root.TronSignTx)
            return object;
        var message = new $root.TronSignTx();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".TronSignTx.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.ref_block_bytes != null)
            if (typeof object.ref_block_bytes === "string")
                $util.base64.decode(object.ref_block_bytes, message.ref_block_bytes = $util.newBuffer($util.base64.length(object.ref_block_bytes)), 0);
            else if (object.ref_block_bytes.length)
                message.ref_block_bytes = object.ref_block_bytes;
        if (object.ref_block_hash != null)
            if (typeof object.ref_block_hash === "string")
                $util.base64.decode(object.ref_block_hash, message.ref_block_hash = $util.newBuffer($util.base64.length(object.ref_block_hash)), 0);
            else if (object.ref_block_hash.length)
                message.ref_block_hash = object.ref_block_hash;
        if (object.expiration != null)
            if ($util.Long)
                (message.expiration = $util.Long.fromValue(object.expiration)).unsigned = true;
            else if (typeof object.expiration === "string")
                message.expiration = parseInt(object.expiration, 10);
            else if (typeof object.expiration === "number")
                message.expiration = object.expiration;
            else if (typeof object.expiration === "object")
                message.expiration = new $util.LongBits(object.expiration.low >>> 0, object.expiration.high >>> 0).toNumber(true);
        if (object.data != null)
            message.data = String(object.data);
        if (object.contract != null) {
            if (typeof object.contract !== "object")
                throw TypeError(".TronSignTx.contract: object expected");
            message.contract = $root.TronSignTx.TronContract.fromObject(object.contract);
        }
        if (object.timestamp != null)
            if ($util.Long)
                (message.timestamp = $util.Long.fromValue(object.timestamp)).unsigned = true;
            else if (typeof object.timestamp === "string")
                message.timestamp = parseInt(object.timestamp, 10);
            else if (typeof object.timestamp === "number")
                message.timestamp = object.timestamp;
            else if (typeof object.timestamp === "object")
                message.timestamp = new $util.LongBits(object.timestamp.low >>> 0, object.timestamp.high >>> 0).toNumber(true);
        if (object.fee_limit != null)
            if ($util.Long)
                (message.fee_limit = $util.Long.fromValue(object.fee_limit)).unsigned = true;
            else if (typeof object.fee_limit === "string")
                message.fee_limit = parseInt(object.fee_limit, 10);
            else if (typeof object.fee_limit === "number")
                message.fee_limit = object.fee_limit;
            else if (typeof object.fee_limit === "object")
                message.fee_limit = new $util.LongBits(object.fee_limit.low >>> 0, object.fee_limit.high >>> 0).toNumber(true);
        return message;
    };

    TronSignTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            if (options.bytes === String)
                object.ref_block_bytes = "";
            else {
                object.ref_block_bytes = [];
                if (options.bytes !== Array)
                    object.ref_block_bytes = $util.newBuffer(object.ref_block_bytes);
            }
            if (options.bytes === String)
                object.ref_block_hash = "";
            else {
                object.ref_block_hash = [];
                if (options.bytes !== Array)
                    object.ref_block_hash = $util.newBuffer(object.ref_block_hash);
            }
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.expiration = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.expiration = options.longs === String ? "0" : 0;
            object.data = "";
            object.contract = null;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.timestamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.timestamp = options.longs === String ? "0" : 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.fee_limit = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.fee_limit = options.longs === String ? "0" : 0;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.ref_block_bytes != null && message.hasOwnProperty("ref_block_bytes"))
            object.ref_block_bytes = options.bytes === String ? $util.base64.encode(message.ref_block_bytes, 0, message.ref_block_bytes.length) : options.bytes === Array ? Array.prototype.slice.call(message.ref_block_bytes) : message.ref_block_bytes;
        if (message.ref_block_hash != null && message.hasOwnProperty("ref_block_hash"))
            object.ref_block_hash = options.bytes === String ? $util.base64.encode(message.ref_block_hash, 0, message.ref_block_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.ref_block_hash) : message.ref_block_hash;
        if (message.expiration != null && message.hasOwnProperty("expiration"))
            if (typeof message.expiration === "number")
                object.expiration = options.longs === String ? String(message.expiration) : message.expiration;
            else
                object.expiration = options.longs === String ? $util.Long.prototype.toString.call(message.expiration) : options.longs === Number ? new $util.LongBits(message.expiration.low >>> 0, message.expiration.high >>> 0).toNumber(true) : message.expiration;
        if (message.data != null && message.hasOwnProperty("data"))
            object.data = message.data;
        if (message.contract != null && message.hasOwnProperty("contract"))
            object.contract = $root.TronSignTx.TronContract.toObject(message.contract, options);
        if (message.timestamp != null && message.hasOwnProperty("timestamp"))
            if (typeof message.timestamp === "number")
                object.timestamp = options.longs === String ? String(message.timestamp) : message.timestamp;
            else
                object.timestamp = options.longs === String ? $util.Long.prototype.toString.call(message.timestamp) : options.longs === Number ? new $util.LongBits(message.timestamp.low >>> 0, message.timestamp.high >>> 0).toNumber(true) : message.timestamp;
        if (message.fee_limit != null && message.hasOwnProperty("fee_limit"))
            if (typeof message.fee_limit === "number")
                object.fee_limit = options.longs === String ? String(message.fee_limit) : message.fee_limit;
            else
                object.fee_limit = options.longs === String ? $util.Long.prototype.toString.call(message.fee_limit) : options.longs === Number ? new $util.LongBits(message.fee_limit.low >>> 0, message.fee_limit.high >>> 0).toNumber(true) : message.fee_limit;
        return object;
    };

    TronSignTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    TronSignTx.TronContract = (function() {

        function TronContract(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        TronContract.prototype.transfer_contract = null;
        TronContract.prototype.freeze_balance_contract = null;
        TronContract.prototype.unfreeze_balance_contract = null;
        TronContract.prototype.withdraw_balance_contract = null;
        TronContract.prototype.trigger_smart_contract = null;
        TronContract.prototype.freeze_balance_v2_contract = null;
        TronContract.prototype.unfreeze_balance_v2_contract = null;
        TronContract.prototype.withdraw_expire_unfreeze_contract = null;
        TronContract.prototype.delegate_resource_contract = null;
        TronContract.prototype.undelegate_resource_contract = null;

        TronContract.create = function create(properties) {
            return new TronContract(properties);
        };

        TronContract.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.transfer_contract != null && Object.hasOwnProperty.call(message, "transfer_contract"))
                $root.TronSignTx.TronContract.TronTransferContract.encode(message.transfer_contract, writer.uint32(18).fork()).ldelim();
            if (message.freeze_balance_contract != null && Object.hasOwnProperty.call(message, "freeze_balance_contract"))
                $root.TronSignTx.TronContract.TronFreezeBalanceContract.encode(message.freeze_balance_contract, writer.uint32(90).fork()).ldelim();
            if (message.unfreeze_balance_contract != null && Object.hasOwnProperty.call(message, "unfreeze_balance_contract"))
                $root.TronSignTx.TronContract.TronUnfreezeBalanceContract.encode(message.unfreeze_balance_contract, writer.uint32(98).fork()).ldelim();
            if (message.withdraw_balance_contract != null && Object.hasOwnProperty.call(message, "withdraw_balance_contract"))
                $root.TronSignTx.TronContract.TronWithdrawBalanceContract.encode(message.withdraw_balance_contract, writer.uint32(106).fork()).ldelim();
            if (message.trigger_smart_contract != null && Object.hasOwnProperty.call(message, "trigger_smart_contract"))
                $root.TronSignTx.TronContract.TronTriggerSmartContract.encode(message.trigger_smart_contract, writer.uint32(250).fork()).ldelim();
            if (message.freeze_balance_v2_contract != null && Object.hasOwnProperty.call(message, "freeze_balance_v2_contract"))
                $root.TronSignTx.TronContract.TronFreezeBalanceV2Contract.encode(message.freeze_balance_v2_contract, writer.uint32(434).fork()).ldelim();
            if (message.unfreeze_balance_v2_contract != null && Object.hasOwnProperty.call(message, "unfreeze_balance_v2_contract"))
                $root.TronSignTx.TronContract.TronUnfreezeBalanceV2Contract.encode(message.unfreeze_balance_v2_contract, writer.uint32(442).fork()).ldelim();
            if (message.withdraw_expire_unfreeze_contract != null && Object.hasOwnProperty.call(message, "withdraw_expire_unfreeze_contract"))
                $root.TronSignTx.TronContract.TronWithdrawExpireUnfreezeContract.encode(message.withdraw_expire_unfreeze_contract, writer.uint32(450).fork()).ldelim();
            if (message.delegate_resource_contract != null && Object.hasOwnProperty.call(message, "delegate_resource_contract"))
                $root.TronSignTx.TronContract.TronDelegateResourceContract.encode(message.delegate_resource_contract, writer.uint32(458).fork()).ldelim();
            if (message.undelegate_resource_contract != null && Object.hasOwnProperty.call(message, "undelegate_resource_contract"))
                $root.TronSignTx.TronContract.TronUnDelegateResourceContract.encode(message.undelegate_resource_contract, writer.uint32(466).fork()).ldelim();
            return writer;
        };

        TronContract.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        TronContract.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TronSignTx.TronContract();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 2:
                    message.transfer_contract = $root.TronSignTx.TronContract.TronTransferContract.decode(reader, reader.uint32());
                    break;
                case 11:
                    message.freeze_balance_contract = $root.TronSignTx.TronContract.TronFreezeBalanceContract.decode(reader, reader.uint32());
                    break;
                case 12:
                    message.unfreeze_balance_contract = $root.TronSignTx.TronContract.TronUnfreezeBalanceContract.decode(reader, reader.uint32());
                    break;
                case 13:
                    message.withdraw_balance_contract = $root.TronSignTx.TronContract.TronWithdrawBalanceContract.decode(reader, reader.uint32());
                    break;
                case 31:
                    message.trigger_smart_contract = $root.TronSignTx.TronContract.TronTriggerSmartContract.decode(reader, reader.uint32());
                    break;
                case 54:
                    message.freeze_balance_v2_contract = $root.TronSignTx.TronContract.TronFreezeBalanceV2Contract.decode(reader, reader.uint32());
                    break;
                case 55:
                    message.unfreeze_balance_v2_contract = $root.TronSignTx.TronContract.TronUnfreezeBalanceV2Contract.decode(reader, reader.uint32());
                    break;
                case 56:
                    message.withdraw_expire_unfreeze_contract = $root.TronSignTx.TronContract.TronWithdrawExpireUnfreezeContract.decode(reader, reader.uint32());
                    break;
                case 57:
                    message.delegate_resource_contract = $root.TronSignTx.TronContract.TronDelegateResourceContract.decode(reader, reader.uint32());
                    break;
                case 58:
                    message.undelegate_resource_contract = $root.TronSignTx.TronContract.TronUnDelegateResourceContract.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        TronContract.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        TronContract.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.transfer_contract != null && message.hasOwnProperty("transfer_contract")) {
                var error = $root.TronSignTx.TronContract.TronTransferContract.verify(message.transfer_contract);
                if (error)
                    return "transfer_contract." + error;
            }
            if (message.freeze_balance_contract != null && message.hasOwnProperty("freeze_balance_contract")) {
                var error = $root.TronSignTx.TronContract.TronFreezeBalanceContract.verify(message.freeze_balance_contract);
                if (error)
                    return "freeze_balance_contract." + error;
            }
            if (message.unfreeze_balance_contract != null && message.hasOwnProperty("unfreeze_balance_contract")) {
                var error = $root.TronSignTx.TronContract.TronUnfreezeBalanceContract.verify(message.unfreeze_balance_contract);
                if (error)
                    return "unfreeze_balance_contract." + error;
            }
            if (message.withdraw_balance_contract != null && message.hasOwnProperty("withdraw_balance_contract")) {
                var error = $root.TronSignTx.TronContract.TronWithdrawBalanceContract.verify(message.withdraw_balance_contract);
                if (error)
                    return "withdraw_balance_contract." + error;
            }
            if (message.trigger_smart_contract != null && message.hasOwnProperty("trigger_smart_contract")) {
                var error = $root.TronSignTx.TronContract.TronTriggerSmartContract.verify(message.trigger_smart_contract);
                if (error)
                    return "trigger_smart_contract." + error;
            }
            if (message.freeze_balance_v2_contract != null && message.hasOwnProperty("freeze_balance_v2_contract")) {
                var error = $root.TronSignTx.TronContract.TronFreezeBalanceV2Contract.verify(message.freeze_balance_v2_contract);
                if (error)
                    return "freeze_balance_v2_contract." + error;
            }
            if (message.unfreeze_balance_v2_contract != null && message.hasOwnProperty("unfreeze_balance_v2_contract")) {
                var error = $root.TronSignTx.TronContract.TronUnfreezeBalanceV2Contract.verify(message.unfreeze_balance_v2_contract);
                if (error)
                    return "unfreeze_balance_v2_contract." + error;
            }
            if (message.withdraw_expire_unfreeze_contract != null && message.hasOwnProperty("withdraw_expire_unfreeze_contract")) {
                var error = $root.TronSignTx.TronContract.TronWithdrawExpireUnfreezeContract.verify(message.withdraw_expire_unfreeze_contract);
                if (error)
                    return "withdraw_expire_unfreeze_contract." + error;
            }
            if (message.delegate_resource_contract != null && message.hasOwnProperty("delegate_resource_contract")) {
                var error = $root.TronSignTx.TronContract.TronDelegateResourceContract.verify(message.delegate_resource_contract);
                if (error)
                    return "delegate_resource_contract." + error;
            }
            if (message.undelegate_resource_contract != null && message.hasOwnProperty("undelegate_resource_contract")) {
                var error = $root.TronSignTx.TronContract.TronUnDelegateResourceContract.verify(message.undelegate_resource_contract);
                if (error)
                    return "undelegate_resource_contract." + error;
            }
            return null;
        };

        TronContract.fromObject = function fromObject(object) {
            if (object instanceof $root.TronSignTx.TronContract)
                return object;
            var message = new $root.TronSignTx.TronContract();
            if (object.transfer_contract != null) {
                if (typeof object.transfer_contract !== "object")
                    throw TypeError(".TronSignTx.TronContract.transfer_contract: object expected");
                message.transfer_contract = $root.TronSignTx.TronContract.TronTransferContract.fromObject(object.transfer_contract);
            }
            if (object.freeze_balance_contract != null) {
                if (typeof object.freeze_balance_contract !== "object")
                    throw TypeError(".TronSignTx.TronContract.freeze_balance_contract: object expected");
                message.freeze_balance_contract = $root.TronSignTx.TronContract.TronFreezeBalanceContract.fromObject(object.freeze_balance_contract);
            }
            if (object.unfreeze_balance_contract != null) {
                if (typeof object.unfreeze_balance_contract !== "object")
                    throw TypeError(".TronSignTx.TronContract.unfreeze_balance_contract: object expected");
                message.unfreeze_balance_contract = $root.TronSignTx.TronContract.TronUnfreezeBalanceContract.fromObject(object.unfreeze_balance_contract);
            }
            if (object.withdraw_balance_contract != null) {
                if (typeof object.withdraw_balance_contract !== "object")
                    throw TypeError(".TronSignTx.TronContract.withdraw_balance_contract: object expected");
                message.withdraw_balance_contract = $root.TronSignTx.TronContract.TronWithdrawBalanceContract.fromObject(object.withdraw_balance_contract);
            }
            if (object.trigger_smart_contract != null) {
                if (typeof object.trigger_smart_contract !== "object")
                    throw TypeError(".TronSignTx.TronContract.trigger_smart_contract: object expected");
                message.trigger_smart_contract = $root.TronSignTx.TronContract.TronTriggerSmartContract.fromObject(object.trigger_smart_contract);
            }
            if (object.freeze_balance_v2_contract != null) {
                if (typeof object.freeze_balance_v2_contract !== "object")
                    throw TypeError(".TronSignTx.TronContract.freeze_balance_v2_contract: object expected");
                message.freeze_balance_v2_contract = $root.TronSignTx.TronContract.TronFreezeBalanceV2Contract.fromObject(object.freeze_balance_v2_contract);
            }
            if (object.unfreeze_balance_v2_contract != null) {
                if (typeof object.unfreeze_balance_v2_contract !== "object")
                    throw TypeError(".TronSignTx.TronContract.unfreeze_balance_v2_contract: object expected");
                message.unfreeze_balance_v2_contract = $root.TronSignTx.TronContract.TronUnfreezeBalanceV2Contract.fromObject(object.unfreeze_balance_v2_contract);
            }
            if (object.withdraw_expire_unfreeze_contract != null) {
                if (typeof object.withdraw_expire_unfreeze_contract !== "object")
                    throw TypeError(".TronSignTx.TronContract.withdraw_expire_unfreeze_contract: object expected");
                message.withdraw_expire_unfreeze_contract = $root.TronSignTx.TronContract.TronWithdrawExpireUnfreezeContract.fromObject(object.withdraw_expire_unfreeze_contract);
            }
            if (object.delegate_resource_contract != null) {
                if (typeof object.delegate_resource_contract !== "object")
                    throw TypeError(".TronSignTx.TronContract.delegate_resource_contract: object expected");
                message.delegate_resource_contract = $root.TronSignTx.TronContract.TronDelegateResourceContract.fromObject(object.delegate_resource_contract);
            }
            if (object.undelegate_resource_contract != null) {
                if (typeof object.undelegate_resource_contract !== "object")
                    throw TypeError(".TronSignTx.TronContract.undelegate_resource_contract: object expected");
                message.undelegate_resource_contract = $root.TronSignTx.TronContract.TronUnDelegateResourceContract.fromObject(object.undelegate_resource_contract);
            }
            return message;
        };

        TronContract.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.transfer_contract = null;
                object.freeze_balance_contract = null;
                object.unfreeze_balance_contract = null;
                object.withdraw_balance_contract = null;
                object.trigger_smart_contract = null;
                object.freeze_balance_v2_contract = null;
                object.unfreeze_balance_v2_contract = null;
                object.withdraw_expire_unfreeze_contract = null;
                object.delegate_resource_contract = null;
                object.undelegate_resource_contract = null;
            }
            if (message.transfer_contract != null && message.hasOwnProperty("transfer_contract"))
                object.transfer_contract = $root.TronSignTx.TronContract.TronTransferContract.toObject(message.transfer_contract, options);
            if (message.freeze_balance_contract != null && message.hasOwnProperty("freeze_balance_contract"))
                object.freeze_balance_contract = $root.TronSignTx.TronContract.TronFreezeBalanceContract.toObject(message.freeze_balance_contract, options);
            if (message.unfreeze_balance_contract != null && message.hasOwnProperty("unfreeze_balance_contract"))
                object.unfreeze_balance_contract = $root.TronSignTx.TronContract.TronUnfreezeBalanceContract.toObject(message.unfreeze_balance_contract, options);
            if (message.withdraw_balance_contract != null && message.hasOwnProperty("withdraw_balance_contract"))
                object.withdraw_balance_contract = $root.TronSignTx.TronContract.TronWithdrawBalanceContract.toObject(message.withdraw_balance_contract, options);
            if (message.trigger_smart_contract != null && message.hasOwnProperty("trigger_smart_contract"))
                object.trigger_smart_contract = $root.TronSignTx.TronContract.TronTriggerSmartContract.toObject(message.trigger_smart_contract, options);
            if (message.freeze_balance_v2_contract != null && message.hasOwnProperty("freeze_balance_v2_contract"))
                object.freeze_balance_v2_contract = $root.TronSignTx.TronContract.TronFreezeBalanceV2Contract.toObject(message.freeze_balance_v2_contract, options);
            if (message.unfreeze_balance_v2_contract != null && message.hasOwnProperty("unfreeze_balance_v2_contract"))
                object.unfreeze_balance_v2_contract = $root.TronSignTx.TronContract.TronUnfreezeBalanceV2Contract.toObject(message.unfreeze_balance_v2_contract, options);
            if (message.withdraw_expire_unfreeze_contract != null && message.hasOwnProperty("withdraw_expire_unfreeze_contract"))
                object.withdraw_expire_unfreeze_contract = $root.TronSignTx.TronContract.TronWithdrawExpireUnfreezeContract.toObject(message.withdraw_expire_unfreeze_contract, options);
            if (message.delegate_resource_contract != null && message.hasOwnProperty("delegate_resource_contract"))
                object.delegate_resource_contract = $root.TronSignTx.TronContract.TronDelegateResourceContract.toObject(message.delegate_resource_contract, options);
            if (message.undelegate_resource_contract != null && message.hasOwnProperty("undelegate_resource_contract"))
                object.undelegate_resource_contract = $root.TronSignTx.TronContract.TronUnDelegateResourceContract.toObject(message.undelegate_resource_contract, options);
            return object;
        };

        TronContract.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        TronContract.TronTransferContract = (function() {

            function TronTransferContract(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            TronTransferContract.prototype.to_address = "";
            TronTransferContract.prototype.amount = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

            TronTransferContract.create = function create(properties) {
                return new TronTransferContract(properties);
            };

            TronTransferContract.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.to_address != null && Object.hasOwnProperty.call(message, "to_address"))
                    writer.uint32(18).string(message.to_address);
                if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
                    writer.uint32(24).uint64(message.amount);
                return writer;
            };

            TronTransferContract.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            TronTransferContract.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TronSignTx.TronContract.TronTransferContract();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 2:
                        message.to_address = reader.string();
                        break;
                    case 3:
                        message.amount = reader.uint64();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            TronTransferContract.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            TronTransferContract.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.to_address != null && message.hasOwnProperty("to_address"))
                    if (!$util.isString(message.to_address))
                        return "to_address: string expected";
                if (message.amount != null && message.hasOwnProperty("amount"))
                    if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
                        return "amount: integer|Long expected";
                return null;
            };

            TronTransferContract.fromObject = function fromObject(object) {
                if (object instanceof $root.TronSignTx.TronContract.TronTransferContract)
                    return object;
                var message = new $root.TronSignTx.TronContract.TronTransferContract();
                if (object.to_address != null)
                    message.to_address = String(object.to_address);
                if (object.amount != null)
                    if ($util.Long)
                        (message.amount = $util.Long.fromValue(object.amount)).unsigned = true;
                    else if (typeof object.amount === "string")
                        message.amount = parseInt(object.amount, 10);
                    else if (typeof object.amount === "number")
                        message.amount = object.amount;
                    else if (typeof object.amount === "object")
                        message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber(true);
                return message;
            };

            TronTransferContract.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.to_address = "";
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, true);
                        object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.amount = options.longs === String ? "0" : 0;
                }
                if (message.to_address != null && message.hasOwnProperty("to_address"))
                    object.to_address = message.to_address;
                if (message.amount != null && message.hasOwnProperty("amount"))
                    if (typeof message.amount === "number")
                        object.amount = options.longs === String ? String(message.amount) : message.amount;
                    else
                        object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber(true) : message.amount;
                return object;
            };

            TronTransferContract.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return TronTransferContract;
        })();

        TronContract.TronTriggerSmartContract = (function() {

            function TronTriggerSmartContract(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            TronTriggerSmartContract.prototype.contract_address = "";
            TronTriggerSmartContract.prototype.call_value = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
            TronTriggerSmartContract.prototype.data = $util.newBuffer([]);
            TronTriggerSmartContract.prototype.call_token_value = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
            TronTriggerSmartContract.prototype.asset_id = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

            TronTriggerSmartContract.create = function create(properties) {
                return new TronTriggerSmartContract(properties);
            };

            TronTriggerSmartContract.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.contract_address != null && Object.hasOwnProperty.call(message, "contract_address"))
                    writer.uint32(18).string(message.contract_address);
                if (message.call_value != null && Object.hasOwnProperty.call(message, "call_value"))
                    writer.uint32(24).uint64(message.call_value);
                if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                    writer.uint32(34).bytes(message.data);
                if (message.call_token_value != null && Object.hasOwnProperty.call(message, "call_token_value"))
                    writer.uint32(40).uint64(message.call_token_value);
                if (message.asset_id != null && Object.hasOwnProperty.call(message, "asset_id"))
                    writer.uint32(48).uint64(message.asset_id);
                return writer;
            };

            TronTriggerSmartContract.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            TronTriggerSmartContract.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TronSignTx.TronContract.TronTriggerSmartContract();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 2:
                        message.contract_address = reader.string();
                        break;
                    case 3:
                        message.call_value = reader.uint64();
                        break;
                    case 4:
                        message.data = reader.bytes();
                        break;
                    case 5:
                        message.call_token_value = reader.uint64();
                        break;
                    case 6:
                        message.asset_id = reader.uint64();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            TronTriggerSmartContract.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            TronTriggerSmartContract.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.contract_address != null && message.hasOwnProperty("contract_address"))
                    if (!$util.isString(message.contract_address))
                        return "contract_address: string expected";
                if (message.call_value != null && message.hasOwnProperty("call_value"))
                    if (!$util.isInteger(message.call_value) && !(message.call_value && $util.isInteger(message.call_value.low) && $util.isInteger(message.call_value.high)))
                        return "call_value: integer|Long expected";
                if (message.data != null && message.hasOwnProperty("data"))
                    if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
                        return "data: buffer expected";
                if (message.call_token_value != null && message.hasOwnProperty("call_token_value"))
                    if (!$util.isInteger(message.call_token_value) && !(message.call_token_value && $util.isInteger(message.call_token_value.low) && $util.isInteger(message.call_token_value.high)))
                        return "call_token_value: integer|Long expected";
                if (message.asset_id != null && message.hasOwnProperty("asset_id"))
                    if (!$util.isInteger(message.asset_id) && !(message.asset_id && $util.isInteger(message.asset_id.low) && $util.isInteger(message.asset_id.high)))
                        return "asset_id: integer|Long expected";
                return null;
            };

            TronTriggerSmartContract.fromObject = function fromObject(object) {
                if (object instanceof $root.TronSignTx.TronContract.TronTriggerSmartContract)
                    return object;
                var message = new $root.TronSignTx.TronContract.TronTriggerSmartContract();
                if (object.contract_address != null)
                    message.contract_address = String(object.contract_address);
                if (object.call_value != null)
                    if ($util.Long)
                        (message.call_value = $util.Long.fromValue(object.call_value)).unsigned = true;
                    else if (typeof object.call_value === "string")
                        message.call_value = parseInt(object.call_value, 10);
                    else if (typeof object.call_value === "number")
                        message.call_value = object.call_value;
                    else if (typeof object.call_value === "object")
                        message.call_value = new $util.LongBits(object.call_value.low >>> 0, object.call_value.high >>> 0).toNumber(true);
                if (object.data != null)
                    if (typeof object.data === "string")
                        $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
                    else if (object.data.length)
                        message.data = object.data;
                if (object.call_token_value != null)
                    if ($util.Long)
                        (message.call_token_value = $util.Long.fromValue(object.call_token_value)).unsigned = true;
                    else if (typeof object.call_token_value === "string")
                        message.call_token_value = parseInt(object.call_token_value, 10);
                    else if (typeof object.call_token_value === "number")
                        message.call_token_value = object.call_token_value;
                    else if (typeof object.call_token_value === "object")
                        message.call_token_value = new $util.LongBits(object.call_token_value.low >>> 0, object.call_token_value.high >>> 0).toNumber(true);
                if (object.asset_id != null)
                    if ($util.Long)
                        (message.asset_id = $util.Long.fromValue(object.asset_id)).unsigned = true;
                    else if (typeof object.asset_id === "string")
                        message.asset_id = parseInt(object.asset_id, 10);
                    else if (typeof object.asset_id === "number")
                        message.asset_id = object.asset_id;
                    else if (typeof object.asset_id === "object")
                        message.asset_id = new $util.LongBits(object.asset_id.low >>> 0, object.asset_id.high >>> 0).toNumber(true);
                return message;
            };

            TronTriggerSmartContract.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.contract_address = "";
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, true);
                        object.call_value = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.call_value = options.longs === String ? "0" : 0;
                    if (options.bytes === String)
                        object.data = "";
                    else {
                        object.data = [];
                        if (options.bytes !== Array)
                            object.data = $util.newBuffer(object.data);
                    }
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, true);
                        object.call_token_value = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.call_token_value = options.longs === String ? "0" : 0;
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, true);
                        object.asset_id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.asset_id = options.longs === String ? "0" : 0;
                }
                if (message.contract_address != null && message.hasOwnProperty("contract_address"))
                    object.contract_address = message.contract_address;
                if (message.call_value != null && message.hasOwnProperty("call_value"))
                    if (typeof message.call_value === "number")
                        object.call_value = options.longs === String ? String(message.call_value) : message.call_value;
                    else
                        object.call_value = options.longs === String ? $util.Long.prototype.toString.call(message.call_value) : options.longs === Number ? new $util.LongBits(message.call_value.low >>> 0, message.call_value.high >>> 0).toNumber(true) : message.call_value;
                if (message.data != null && message.hasOwnProperty("data"))
                    object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
                if (message.call_token_value != null && message.hasOwnProperty("call_token_value"))
                    if (typeof message.call_token_value === "number")
                        object.call_token_value = options.longs === String ? String(message.call_token_value) : message.call_token_value;
                    else
                        object.call_token_value = options.longs === String ? $util.Long.prototype.toString.call(message.call_token_value) : options.longs === Number ? new $util.LongBits(message.call_token_value.low >>> 0, message.call_token_value.high >>> 0).toNumber(true) : message.call_token_value;
                if (message.asset_id != null && message.hasOwnProperty("asset_id"))
                    if (typeof message.asset_id === "number")
                        object.asset_id = options.longs === String ? String(message.asset_id) : message.asset_id;
                    else
                        object.asset_id = options.longs === String ? $util.Long.prototype.toString.call(message.asset_id) : options.longs === Number ? new $util.LongBits(message.asset_id.low >>> 0, message.asset_id.high >>> 0).toNumber(true) : message.asset_id;
                return object;
            };

            TronTriggerSmartContract.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return TronTriggerSmartContract;
        })();

        TronContract.TronResourceCode = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "BANDWIDTH"] = 0;
            values[valuesById[1] = "ENERGY"] = 1;
            return values;
        })();

        TronContract.TronFreezeBalanceContract = (function() {

            function TronFreezeBalanceContract(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            TronFreezeBalanceContract.prototype.frozen_balance = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
            TronFreezeBalanceContract.prototype.frozen_duration = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
            TronFreezeBalanceContract.prototype.resource = 0;
            TronFreezeBalanceContract.prototype.receiver_address = "";

            TronFreezeBalanceContract.create = function create(properties) {
                return new TronFreezeBalanceContract(properties);
            };

            TronFreezeBalanceContract.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.frozen_balance != null && Object.hasOwnProperty.call(message, "frozen_balance"))
                    writer.uint32(8).uint64(message.frozen_balance);
                if (message.frozen_duration != null && Object.hasOwnProperty.call(message, "frozen_duration"))
                    writer.uint32(16).uint64(message.frozen_duration);
                if (message.resource != null && Object.hasOwnProperty.call(message, "resource"))
                    writer.uint32(24).int32(message.resource);
                if (message.receiver_address != null && Object.hasOwnProperty.call(message, "receiver_address"))
                    writer.uint32(34).string(message.receiver_address);
                return writer;
            };

            TronFreezeBalanceContract.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            TronFreezeBalanceContract.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TronSignTx.TronContract.TronFreezeBalanceContract();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.frozen_balance = reader.uint64();
                        break;
                    case 2:
                        message.frozen_duration = reader.uint64();
                        break;
                    case 3:
                        message.resource = reader.int32();
                        break;
                    case 4:
                        message.receiver_address = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            TronFreezeBalanceContract.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            TronFreezeBalanceContract.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.frozen_balance != null && message.hasOwnProperty("frozen_balance"))
                    if (!$util.isInteger(message.frozen_balance) && !(message.frozen_balance && $util.isInteger(message.frozen_balance.low) && $util.isInteger(message.frozen_balance.high)))
                        return "frozen_balance: integer|Long expected";
                if (message.frozen_duration != null && message.hasOwnProperty("frozen_duration"))
                    if (!$util.isInteger(message.frozen_duration) && !(message.frozen_duration && $util.isInteger(message.frozen_duration.low) && $util.isInteger(message.frozen_duration.high)))
                        return "frozen_duration: integer|Long expected";
                if (message.resource != null && message.hasOwnProperty("resource"))
                    switch (message.resource) {
                    default:
                        return "resource: enum value expected";
                    case 0:
                    case 1:
                        break;
                    }
                if (message.receiver_address != null && message.hasOwnProperty("receiver_address"))
                    if (!$util.isString(message.receiver_address))
                        return "receiver_address: string expected";
                return null;
            };

            TronFreezeBalanceContract.fromObject = function fromObject(object) {
                if (object instanceof $root.TronSignTx.TronContract.TronFreezeBalanceContract)
                    return object;
                var message = new $root.TronSignTx.TronContract.TronFreezeBalanceContract();
                if (object.frozen_balance != null)
                    if ($util.Long)
                        (message.frozen_balance = $util.Long.fromValue(object.frozen_balance)).unsigned = true;
                    else if (typeof object.frozen_balance === "string")
                        message.frozen_balance = parseInt(object.frozen_balance, 10);
                    else if (typeof object.frozen_balance === "number")
                        message.frozen_balance = object.frozen_balance;
                    else if (typeof object.frozen_balance === "object")
                        message.frozen_balance = new $util.LongBits(object.frozen_balance.low >>> 0, object.frozen_balance.high >>> 0).toNumber(true);
                if (object.frozen_duration != null)
                    if ($util.Long)
                        (message.frozen_duration = $util.Long.fromValue(object.frozen_duration)).unsigned = true;
                    else if (typeof object.frozen_duration === "string")
                        message.frozen_duration = parseInt(object.frozen_duration, 10);
                    else if (typeof object.frozen_duration === "number")
                        message.frozen_duration = object.frozen_duration;
                    else if (typeof object.frozen_duration === "object")
                        message.frozen_duration = new $util.LongBits(object.frozen_duration.low >>> 0, object.frozen_duration.high >>> 0).toNumber(true);
                switch (object.resource) {
                case "BANDWIDTH":
                case 0:
                    message.resource = 0;
                    break;
                case "ENERGY":
                case 1:
                    message.resource = 1;
                    break;
                }
                if (object.receiver_address != null)
                    message.receiver_address = String(object.receiver_address);
                return message;
            };

            TronFreezeBalanceContract.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, true);
                        object.frozen_balance = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.frozen_balance = options.longs === String ? "0" : 0;
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, true);
                        object.frozen_duration = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.frozen_duration = options.longs === String ? "0" : 0;
                    object.resource = options.enums === String ? "BANDWIDTH" : 0;
                    object.receiver_address = "";
                }
                if (message.frozen_balance != null && message.hasOwnProperty("frozen_balance"))
                    if (typeof message.frozen_balance === "number")
                        object.frozen_balance = options.longs === String ? String(message.frozen_balance) : message.frozen_balance;
                    else
                        object.frozen_balance = options.longs === String ? $util.Long.prototype.toString.call(message.frozen_balance) : options.longs === Number ? new $util.LongBits(message.frozen_balance.low >>> 0, message.frozen_balance.high >>> 0).toNumber(true) : message.frozen_balance;
                if (message.frozen_duration != null && message.hasOwnProperty("frozen_duration"))
                    if (typeof message.frozen_duration === "number")
                        object.frozen_duration = options.longs === String ? String(message.frozen_duration) : message.frozen_duration;
                    else
                        object.frozen_duration = options.longs === String ? $util.Long.prototype.toString.call(message.frozen_duration) : options.longs === Number ? new $util.LongBits(message.frozen_duration.low >>> 0, message.frozen_duration.high >>> 0).toNumber(true) : message.frozen_duration;
                if (message.resource != null && message.hasOwnProperty("resource"))
                    object.resource = options.enums === String ? $root.TronSignTx.TronContract.TronResourceCode[message.resource] : message.resource;
                if (message.receiver_address != null && message.hasOwnProperty("receiver_address"))
                    object.receiver_address = message.receiver_address;
                return object;
            };

            TronFreezeBalanceContract.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return TronFreezeBalanceContract;
        })();

        TronContract.TronUnfreezeBalanceContract = (function() {

            function TronUnfreezeBalanceContract(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            TronUnfreezeBalanceContract.prototype.resource = 0;
            TronUnfreezeBalanceContract.prototype.receiver_address = "";

            TronUnfreezeBalanceContract.create = function create(properties) {
                return new TronUnfreezeBalanceContract(properties);
            };

            TronUnfreezeBalanceContract.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.resource != null && Object.hasOwnProperty.call(message, "resource"))
                    writer.uint32(8).int32(message.resource);
                if (message.receiver_address != null && Object.hasOwnProperty.call(message, "receiver_address"))
                    writer.uint32(18).string(message.receiver_address);
                return writer;
            };

            TronUnfreezeBalanceContract.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            TronUnfreezeBalanceContract.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TronSignTx.TronContract.TronUnfreezeBalanceContract();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.resource = reader.int32();
                        break;
                    case 2:
                        message.receiver_address = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            TronUnfreezeBalanceContract.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            TronUnfreezeBalanceContract.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.resource != null && message.hasOwnProperty("resource"))
                    switch (message.resource) {
                    default:
                        return "resource: enum value expected";
                    case 0:
                    case 1:
                        break;
                    }
                if (message.receiver_address != null && message.hasOwnProperty("receiver_address"))
                    if (!$util.isString(message.receiver_address))
                        return "receiver_address: string expected";
                return null;
            };

            TronUnfreezeBalanceContract.fromObject = function fromObject(object) {
                if (object instanceof $root.TronSignTx.TronContract.TronUnfreezeBalanceContract)
                    return object;
                var message = new $root.TronSignTx.TronContract.TronUnfreezeBalanceContract();
                switch (object.resource) {
                case "BANDWIDTH":
                case 0:
                    message.resource = 0;
                    break;
                case "ENERGY":
                case 1:
                    message.resource = 1;
                    break;
                }
                if (object.receiver_address != null)
                    message.receiver_address = String(object.receiver_address);
                return message;
            };

            TronUnfreezeBalanceContract.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.resource = options.enums === String ? "BANDWIDTH" : 0;
                    object.receiver_address = "";
                }
                if (message.resource != null && message.hasOwnProperty("resource"))
                    object.resource = options.enums === String ? $root.TronSignTx.TronContract.TronResourceCode[message.resource] : message.resource;
                if (message.receiver_address != null && message.hasOwnProperty("receiver_address"))
                    object.receiver_address = message.receiver_address;
                return object;
            };

            TronUnfreezeBalanceContract.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return TronUnfreezeBalanceContract;
        })();

        TronContract.TronWithdrawBalanceContract = (function() {

            function TronWithdrawBalanceContract(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            TronWithdrawBalanceContract.prototype.owner_address = $util.newBuffer([]);

            TronWithdrawBalanceContract.create = function create(properties) {
                return new TronWithdrawBalanceContract(properties);
            };

            TronWithdrawBalanceContract.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.owner_address != null && Object.hasOwnProperty.call(message, "owner_address"))
                    writer.uint32(10).bytes(message.owner_address);
                return writer;
            };

            TronWithdrawBalanceContract.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            TronWithdrawBalanceContract.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TronSignTx.TronContract.TronWithdrawBalanceContract();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.owner_address = reader.bytes();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            TronWithdrawBalanceContract.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            TronWithdrawBalanceContract.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.owner_address != null && message.hasOwnProperty("owner_address"))
                    if (!(message.owner_address && typeof message.owner_address.length === "number" || $util.isString(message.owner_address)))
                        return "owner_address: buffer expected";
                return null;
            };

            TronWithdrawBalanceContract.fromObject = function fromObject(object) {
                if (object instanceof $root.TronSignTx.TronContract.TronWithdrawBalanceContract)
                    return object;
                var message = new $root.TronSignTx.TronContract.TronWithdrawBalanceContract();
                if (object.owner_address != null)
                    if (typeof object.owner_address === "string")
                        $util.base64.decode(object.owner_address, message.owner_address = $util.newBuffer($util.base64.length(object.owner_address)), 0);
                    else if (object.owner_address.length)
                        message.owner_address = object.owner_address;
                return message;
            };

            TronWithdrawBalanceContract.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults)
                    if (options.bytes === String)
                        object.owner_address = "";
                    else {
                        object.owner_address = [];
                        if (options.bytes !== Array)
                            object.owner_address = $util.newBuffer(object.owner_address);
                    }
                if (message.owner_address != null && message.hasOwnProperty("owner_address"))
                    object.owner_address = options.bytes === String ? $util.base64.encode(message.owner_address, 0, message.owner_address.length) : options.bytes === Array ? Array.prototype.slice.call(message.owner_address) : message.owner_address;
                return object;
            };

            TronWithdrawBalanceContract.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return TronWithdrawBalanceContract;
        })();

        TronContract.TronFreezeBalanceV2Contract = (function() {

            function TronFreezeBalanceV2Contract(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            TronFreezeBalanceV2Contract.prototype.frozen_balance = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
            TronFreezeBalanceV2Contract.prototype.resource = 0;

            TronFreezeBalanceV2Contract.create = function create(properties) {
                return new TronFreezeBalanceV2Contract(properties);
            };

            TronFreezeBalanceV2Contract.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.frozen_balance != null && Object.hasOwnProperty.call(message, "frozen_balance"))
                    writer.uint32(16).uint64(message.frozen_balance);
                if (message.resource != null && Object.hasOwnProperty.call(message, "resource"))
                    writer.uint32(24).int32(message.resource);
                return writer;
            };

            TronFreezeBalanceV2Contract.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            TronFreezeBalanceV2Contract.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TronSignTx.TronContract.TronFreezeBalanceV2Contract();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 2:
                        message.frozen_balance = reader.uint64();
                        break;
                    case 3:
                        message.resource = reader.int32();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            TronFreezeBalanceV2Contract.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            TronFreezeBalanceV2Contract.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.frozen_balance != null && message.hasOwnProperty("frozen_balance"))
                    if (!$util.isInteger(message.frozen_balance) && !(message.frozen_balance && $util.isInteger(message.frozen_balance.low) && $util.isInteger(message.frozen_balance.high)))
                        return "frozen_balance: integer|Long expected";
                if (message.resource != null && message.hasOwnProperty("resource"))
                    switch (message.resource) {
                    default:
                        return "resource: enum value expected";
                    case 0:
                    case 1:
                        break;
                    }
                return null;
            };

            TronFreezeBalanceV2Contract.fromObject = function fromObject(object) {
                if (object instanceof $root.TronSignTx.TronContract.TronFreezeBalanceV2Contract)
                    return object;
                var message = new $root.TronSignTx.TronContract.TronFreezeBalanceV2Contract();
                if (object.frozen_balance != null)
                    if ($util.Long)
                        (message.frozen_balance = $util.Long.fromValue(object.frozen_balance)).unsigned = true;
                    else if (typeof object.frozen_balance === "string")
                        message.frozen_balance = parseInt(object.frozen_balance, 10);
                    else if (typeof object.frozen_balance === "number")
                        message.frozen_balance = object.frozen_balance;
                    else if (typeof object.frozen_balance === "object")
                        message.frozen_balance = new $util.LongBits(object.frozen_balance.low >>> 0, object.frozen_balance.high >>> 0).toNumber(true);
                switch (object.resource) {
                case "BANDWIDTH":
                case 0:
                    message.resource = 0;
                    break;
                case "ENERGY":
                case 1:
                    message.resource = 1;
                    break;
                }
                return message;
            };

            TronFreezeBalanceV2Contract.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, true);
                        object.frozen_balance = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.frozen_balance = options.longs === String ? "0" : 0;
                    object.resource = options.enums === String ? "BANDWIDTH" : 0;
                }
                if (message.frozen_balance != null && message.hasOwnProperty("frozen_balance"))
                    if (typeof message.frozen_balance === "number")
                        object.frozen_balance = options.longs === String ? String(message.frozen_balance) : message.frozen_balance;
                    else
                        object.frozen_balance = options.longs === String ? $util.Long.prototype.toString.call(message.frozen_balance) : options.longs === Number ? new $util.LongBits(message.frozen_balance.low >>> 0, message.frozen_balance.high >>> 0).toNumber(true) : message.frozen_balance;
                if (message.resource != null && message.hasOwnProperty("resource"))
                    object.resource = options.enums === String ? $root.TronSignTx.TronContract.TronResourceCode[message.resource] : message.resource;
                return object;
            };

            TronFreezeBalanceV2Contract.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return TronFreezeBalanceV2Contract;
        })();

        TronContract.TronUnfreezeBalanceV2Contract = (function() {

            function TronUnfreezeBalanceV2Contract(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            TronUnfreezeBalanceV2Contract.prototype.unfreeze_balance = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
            TronUnfreezeBalanceV2Contract.prototype.resource = 0;

            TronUnfreezeBalanceV2Contract.create = function create(properties) {
                return new TronUnfreezeBalanceV2Contract(properties);
            };

            TronUnfreezeBalanceV2Contract.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.unfreeze_balance != null && Object.hasOwnProperty.call(message, "unfreeze_balance"))
                    writer.uint32(16).uint64(message.unfreeze_balance);
                if (message.resource != null && Object.hasOwnProperty.call(message, "resource"))
                    writer.uint32(24).int32(message.resource);
                return writer;
            };

            TronUnfreezeBalanceV2Contract.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            TronUnfreezeBalanceV2Contract.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TronSignTx.TronContract.TronUnfreezeBalanceV2Contract();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 2:
                        message.unfreeze_balance = reader.uint64();
                        break;
                    case 3:
                        message.resource = reader.int32();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            TronUnfreezeBalanceV2Contract.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            TronUnfreezeBalanceV2Contract.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.unfreeze_balance != null && message.hasOwnProperty("unfreeze_balance"))
                    if (!$util.isInteger(message.unfreeze_balance) && !(message.unfreeze_balance && $util.isInteger(message.unfreeze_balance.low) && $util.isInteger(message.unfreeze_balance.high)))
                        return "unfreeze_balance: integer|Long expected";
                if (message.resource != null && message.hasOwnProperty("resource"))
                    switch (message.resource) {
                    default:
                        return "resource: enum value expected";
                    case 0:
                    case 1:
                        break;
                    }
                return null;
            };

            TronUnfreezeBalanceV2Contract.fromObject = function fromObject(object) {
                if (object instanceof $root.TronSignTx.TronContract.TronUnfreezeBalanceV2Contract)
                    return object;
                var message = new $root.TronSignTx.TronContract.TronUnfreezeBalanceV2Contract();
                if (object.unfreeze_balance != null)
                    if ($util.Long)
                        (message.unfreeze_balance = $util.Long.fromValue(object.unfreeze_balance)).unsigned = true;
                    else if (typeof object.unfreeze_balance === "string")
                        message.unfreeze_balance = parseInt(object.unfreeze_balance, 10);
                    else if (typeof object.unfreeze_balance === "number")
                        message.unfreeze_balance = object.unfreeze_balance;
                    else if (typeof object.unfreeze_balance === "object")
                        message.unfreeze_balance = new $util.LongBits(object.unfreeze_balance.low >>> 0, object.unfreeze_balance.high >>> 0).toNumber(true);
                switch (object.resource) {
                case "BANDWIDTH":
                case 0:
                    message.resource = 0;
                    break;
                case "ENERGY":
                case 1:
                    message.resource = 1;
                    break;
                }
                return message;
            };

            TronUnfreezeBalanceV2Contract.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, true);
                        object.unfreeze_balance = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.unfreeze_balance = options.longs === String ? "0" : 0;
                    object.resource = options.enums === String ? "BANDWIDTH" : 0;
                }
                if (message.unfreeze_balance != null && message.hasOwnProperty("unfreeze_balance"))
                    if (typeof message.unfreeze_balance === "number")
                        object.unfreeze_balance = options.longs === String ? String(message.unfreeze_balance) : message.unfreeze_balance;
                    else
                        object.unfreeze_balance = options.longs === String ? $util.Long.prototype.toString.call(message.unfreeze_balance) : options.longs === Number ? new $util.LongBits(message.unfreeze_balance.low >>> 0, message.unfreeze_balance.high >>> 0).toNumber(true) : message.unfreeze_balance;
                if (message.resource != null && message.hasOwnProperty("resource"))
                    object.resource = options.enums === String ? $root.TronSignTx.TronContract.TronResourceCode[message.resource] : message.resource;
                return object;
            };

            TronUnfreezeBalanceV2Contract.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return TronUnfreezeBalanceV2Contract;
        })();

        TronContract.TronWithdrawExpireUnfreezeContract = (function() {

            function TronWithdrawExpireUnfreezeContract(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            TronWithdrawExpireUnfreezeContract.create = function create(properties) {
                return new TronWithdrawExpireUnfreezeContract(properties);
            };

            TronWithdrawExpireUnfreezeContract.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            TronWithdrawExpireUnfreezeContract.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            TronWithdrawExpireUnfreezeContract.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TronSignTx.TronContract.TronWithdrawExpireUnfreezeContract();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            TronWithdrawExpireUnfreezeContract.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            TronWithdrawExpireUnfreezeContract.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            TronWithdrawExpireUnfreezeContract.fromObject = function fromObject(object) {
                if (object instanceof $root.TronSignTx.TronContract.TronWithdrawExpireUnfreezeContract)
                    return object;
                return new $root.TronSignTx.TronContract.TronWithdrawExpireUnfreezeContract();
            };

            TronWithdrawExpireUnfreezeContract.toObject = function toObject() {
                return {};
            };

            TronWithdrawExpireUnfreezeContract.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return TronWithdrawExpireUnfreezeContract;
        })();

        TronContract.TronDelegateResourceContract = (function() {

            function TronDelegateResourceContract(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            TronDelegateResourceContract.prototype.resource = 0;
            TronDelegateResourceContract.prototype.balance = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
            TronDelegateResourceContract.prototype.receiver_address = "";
            TronDelegateResourceContract.prototype.lock = false;

            TronDelegateResourceContract.create = function create(properties) {
                return new TronDelegateResourceContract(properties);
            };

            TronDelegateResourceContract.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.resource != null && Object.hasOwnProperty.call(message, "resource"))
                    writer.uint32(16).int32(message.resource);
                if (message.balance != null && Object.hasOwnProperty.call(message, "balance"))
                    writer.uint32(24).uint64(message.balance);
                if (message.receiver_address != null && Object.hasOwnProperty.call(message, "receiver_address"))
                    writer.uint32(34).string(message.receiver_address);
                if (message.lock != null && Object.hasOwnProperty.call(message, "lock"))
                    writer.uint32(40).bool(message.lock);
                return writer;
            };

            TronDelegateResourceContract.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            TronDelegateResourceContract.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TronSignTx.TronContract.TronDelegateResourceContract();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 2:
                        message.resource = reader.int32();
                        break;
                    case 3:
                        message.balance = reader.uint64();
                        break;
                    case 4:
                        message.receiver_address = reader.string();
                        break;
                    case 5:
                        message.lock = reader.bool();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            TronDelegateResourceContract.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            TronDelegateResourceContract.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.resource != null && message.hasOwnProperty("resource"))
                    switch (message.resource) {
                    default:
                        return "resource: enum value expected";
                    case 0:
                    case 1:
                        break;
                    }
                if (message.balance != null && message.hasOwnProperty("balance"))
                    if (!$util.isInteger(message.balance) && !(message.balance && $util.isInteger(message.balance.low) && $util.isInteger(message.balance.high)))
                        return "balance: integer|Long expected";
                if (message.receiver_address != null && message.hasOwnProperty("receiver_address"))
                    if (!$util.isString(message.receiver_address))
                        return "receiver_address: string expected";
                if (message.lock != null && message.hasOwnProperty("lock"))
                    if (typeof message.lock !== "boolean")
                        return "lock: boolean expected";
                return null;
            };

            TronDelegateResourceContract.fromObject = function fromObject(object) {
                if (object instanceof $root.TronSignTx.TronContract.TronDelegateResourceContract)
                    return object;
                var message = new $root.TronSignTx.TronContract.TronDelegateResourceContract();
                switch (object.resource) {
                case "BANDWIDTH":
                case 0:
                    message.resource = 0;
                    break;
                case "ENERGY":
                case 1:
                    message.resource = 1;
                    break;
                }
                if (object.balance != null)
                    if ($util.Long)
                        (message.balance = $util.Long.fromValue(object.balance)).unsigned = true;
                    else if (typeof object.balance === "string")
                        message.balance = parseInt(object.balance, 10);
                    else if (typeof object.balance === "number")
                        message.balance = object.balance;
                    else if (typeof object.balance === "object")
                        message.balance = new $util.LongBits(object.balance.low >>> 0, object.balance.high >>> 0).toNumber(true);
                if (object.receiver_address != null)
                    message.receiver_address = String(object.receiver_address);
                if (object.lock != null)
                    message.lock = Boolean(object.lock);
                return message;
            };

            TronDelegateResourceContract.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.resource = options.enums === String ? "BANDWIDTH" : 0;
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, true);
                        object.balance = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.balance = options.longs === String ? "0" : 0;
                    object.receiver_address = "";
                    object.lock = false;
                }
                if (message.resource != null && message.hasOwnProperty("resource"))
                    object.resource = options.enums === String ? $root.TronSignTx.TronContract.TronResourceCode[message.resource] : message.resource;
                if (message.balance != null && message.hasOwnProperty("balance"))
                    if (typeof message.balance === "number")
                        object.balance = options.longs === String ? String(message.balance) : message.balance;
                    else
                        object.balance = options.longs === String ? $util.Long.prototype.toString.call(message.balance) : options.longs === Number ? new $util.LongBits(message.balance.low >>> 0, message.balance.high >>> 0).toNumber(true) : message.balance;
                if (message.receiver_address != null && message.hasOwnProperty("receiver_address"))
                    object.receiver_address = message.receiver_address;
                if (message.lock != null && message.hasOwnProperty("lock"))
                    object.lock = message.lock;
                return object;
            };

            TronDelegateResourceContract.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return TronDelegateResourceContract;
        })();

        TronContract.TronUnDelegateResourceContract = (function() {

            function TronUnDelegateResourceContract(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            TronUnDelegateResourceContract.prototype.resource = 0;
            TronUnDelegateResourceContract.prototype.balance = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
            TronUnDelegateResourceContract.prototype.receiver_address = "";

            TronUnDelegateResourceContract.create = function create(properties) {
                return new TronUnDelegateResourceContract(properties);
            };

            TronUnDelegateResourceContract.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.resource != null && Object.hasOwnProperty.call(message, "resource"))
                    writer.uint32(16).int32(message.resource);
                if (message.balance != null && Object.hasOwnProperty.call(message, "balance"))
                    writer.uint32(24).uint64(message.balance);
                if (message.receiver_address != null && Object.hasOwnProperty.call(message, "receiver_address"))
                    writer.uint32(34).string(message.receiver_address);
                return writer;
            };

            TronUnDelegateResourceContract.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            TronUnDelegateResourceContract.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TronSignTx.TronContract.TronUnDelegateResourceContract();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 2:
                        message.resource = reader.int32();
                        break;
                    case 3:
                        message.balance = reader.uint64();
                        break;
                    case 4:
                        message.receiver_address = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            TronUnDelegateResourceContract.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            TronUnDelegateResourceContract.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.resource != null && message.hasOwnProperty("resource"))
                    switch (message.resource) {
                    default:
                        return "resource: enum value expected";
                    case 0:
                    case 1:
                        break;
                    }
                if (message.balance != null && message.hasOwnProperty("balance"))
                    if (!$util.isInteger(message.balance) && !(message.balance && $util.isInteger(message.balance.low) && $util.isInteger(message.balance.high)))
                        return "balance: integer|Long expected";
                if (message.receiver_address != null && message.hasOwnProperty("receiver_address"))
                    if (!$util.isString(message.receiver_address))
                        return "receiver_address: string expected";
                return null;
            };

            TronUnDelegateResourceContract.fromObject = function fromObject(object) {
                if (object instanceof $root.TronSignTx.TronContract.TronUnDelegateResourceContract)
                    return object;
                var message = new $root.TronSignTx.TronContract.TronUnDelegateResourceContract();
                switch (object.resource) {
                case "BANDWIDTH":
                case 0:
                    message.resource = 0;
                    break;
                case "ENERGY":
                case 1:
                    message.resource = 1;
                    break;
                }
                if (object.balance != null)
                    if ($util.Long)
                        (message.balance = $util.Long.fromValue(object.balance)).unsigned = true;
                    else if (typeof object.balance === "string")
                        message.balance = parseInt(object.balance, 10);
                    else if (typeof object.balance === "number")
                        message.balance = object.balance;
                    else if (typeof object.balance === "object")
                        message.balance = new $util.LongBits(object.balance.low >>> 0, object.balance.high >>> 0).toNumber(true);
                if (object.receiver_address != null)
                    message.receiver_address = String(object.receiver_address);
                return message;
            };

            TronUnDelegateResourceContract.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.resource = options.enums === String ? "BANDWIDTH" : 0;
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, true);
                        object.balance = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.balance = options.longs === String ? "0" : 0;
                    object.receiver_address = "";
                }
                if (message.resource != null && message.hasOwnProperty("resource"))
                    object.resource = options.enums === String ? $root.TronSignTx.TronContract.TronResourceCode[message.resource] : message.resource;
                if (message.balance != null && message.hasOwnProperty("balance"))
                    if (typeof message.balance === "number")
                        object.balance = options.longs === String ? String(message.balance) : message.balance;
                    else
                        object.balance = options.longs === String ? $util.Long.prototype.toString.call(message.balance) : options.longs === Number ? new $util.LongBits(message.balance.low >>> 0, message.balance.high >>> 0).toNumber(true) : message.balance;
                if (message.receiver_address != null && message.hasOwnProperty("receiver_address"))
                    object.receiver_address = message.receiver_address;
                return object;
            };

            TronUnDelegateResourceContract.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return TronUnDelegateResourceContract;
        })();

        return TronContract;
    })();

    return TronSignTx;
})();

$root.TronSignedTx = (function() {

    function TronSignedTx(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    TronSignedTx.prototype.signature = $util.newBuffer([]);
    TronSignedTx.prototype.serialized_tx = $util.newBuffer([]);

    TronSignedTx.create = function create(properties) {
        return new TronSignedTx(properties);
    };

    TronSignedTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.signature);
        if (message.serialized_tx != null && Object.hasOwnProperty.call(message, "serialized_tx"))
            writer.uint32(18).bytes(message.serialized_tx);
        return writer;
    };

    TronSignedTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    TronSignedTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TronSignedTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.signature = reader.bytes();
                break;
            case 2:
                message.serialized_tx = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        return message;
    };

    TronSignedTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    TronSignedTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        if (message.serialized_tx != null && message.hasOwnProperty("serialized_tx"))
            if (!(message.serialized_tx && typeof message.serialized_tx.length === "number" || $util.isString(message.serialized_tx)))
                return "serialized_tx: buffer expected";
        return null;
    };

    TronSignedTx.fromObject = function fromObject(object) {
        if (object instanceof $root.TronSignedTx)
            return object;
        var message = new $root.TronSignedTx();
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        if (object.serialized_tx != null)
            if (typeof object.serialized_tx === "string")
                $util.base64.decode(object.serialized_tx, message.serialized_tx = $util.newBuffer($util.base64.length(object.serialized_tx)), 0);
            else if (object.serialized_tx.length)
                message.serialized_tx = object.serialized_tx;
        return message;
    };

    TronSignedTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
            if (options.bytes === String)
                object.serialized_tx = "";
            else {
                object.serialized_tx = [];
                if (options.bytes !== Array)
                    object.serialized_tx = $util.newBuffer(object.serialized_tx);
            }
        }
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        if (message.serialized_tx != null && message.hasOwnProperty("serialized_tx"))
            object.serialized_tx = options.bytes === String ? $util.base64.encode(message.serialized_tx, 0, message.serialized_tx.length) : options.bytes === Array ? Array.prototype.slice.call(message.serialized_tx) : message.serialized_tx;
        return object;
    };

    TronSignedTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return TronSignedTx;
})();

$root.TronSignMessage = (function() {

    function TronSignMessage(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    TronSignMessage.prototype.address_n = $util.emptyArray;
    TronSignMessage.prototype.message = $util.newBuffer([]);

    TronSignMessage.create = function create(properties) {
        return new TronSignMessage(properties);
    };

    TronSignMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).bytes(message.message);
        return writer;
    };

    TronSignMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    TronSignMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TronSignMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.message = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("message"))
            throw $util.ProtocolError("missing required 'message'", { instance: message });
        return message;
    };

    TronSignMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    TronSignMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!(message.message && typeof message.message.length === "number" || $util.isString(message.message)))
            return "message: buffer expected";
        return null;
    };

    TronSignMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.TronSignMessage)
            return object;
        var message = new $root.TronSignMessage();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".TronSignMessage.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.message != null)
            if (typeof object.message === "string")
                $util.base64.decode(object.message, message.message = $util.newBuffer($util.base64.length(object.message)), 0);
            else if (object.message.length)
                message.message = object.message;
        return message;
    };

    TronSignMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            if (options.bytes === String)
                object.message = "";
            else {
                object.message = [];
                if (options.bytes !== Array)
                    object.message = $util.newBuffer(object.message);
            }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.message != null && message.hasOwnProperty("message"))
            object.message = options.bytes === String ? $util.base64.encode(message.message, 0, message.message.length) : options.bytes === Array ? Array.prototype.slice.call(message.message) : message.message;
        return object;
    };

    TronSignMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return TronSignMessage;
})();

$root.TronMessageSignature = (function() {

    function TronMessageSignature(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    TronMessageSignature.prototype.address = $util.newBuffer([]);
    TronMessageSignature.prototype.signature = $util.newBuffer([]);

    TronMessageSignature.create = function create(properties) {
        return new TronMessageSignature(properties);
    };

    TronMessageSignature.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.address);
        writer.uint32(18).bytes(message.signature);
        return writer;
    };

    TronMessageSignature.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    TronMessageSignature.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TronMessageSignature();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.bytes();
                break;
            case 2:
                message.signature = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("address"))
            throw $util.ProtocolError("missing required 'address'", { instance: message });
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        return message;
    };

    TronMessageSignature.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    TronMessageSignature.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.address && typeof message.address.length === "number" || $util.isString(message.address)))
            return "address: buffer expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        return null;
    };

    TronMessageSignature.fromObject = function fromObject(object) {
        if (object instanceof $root.TronMessageSignature)
            return object;
        var message = new $root.TronMessageSignature();
        if (object.address != null)
            if (typeof object.address === "string")
                $util.base64.decode(object.address, message.address = $util.newBuffer($util.base64.length(object.address)), 0);
            else if (object.address.length)
                message.address = object.address;
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        return message;
    };

    TronMessageSignature.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.address = "";
            else {
                object.address = [];
                if (options.bytes !== Array)
                    object.address = $util.newBuffer(object.address);
            }
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
        }
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = options.bytes === String ? $util.base64.encode(message.address, 0, message.address.length) : options.bytes === Array ? Array.prototype.slice.call(message.address) : message.address;
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        return object;
    };

    TronMessageSignature.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return TronMessageSignature;
})();

$root.WebAuthnListResidentCredentials = (function() {

    function WebAuthnListResidentCredentials(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    WebAuthnListResidentCredentials.create = function create(properties) {
        return new WebAuthnListResidentCredentials(properties);
    };

    WebAuthnListResidentCredentials.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    WebAuthnListResidentCredentials.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    WebAuthnListResidentCredentials.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.WebAuthnListResidentCredentials();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    WebAuthnListResidentCredentials.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    WebAuthnListResidentCredentials.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    WebAuthnListResidentCredentials.fromObject = function fromObject(object) {
        if (object instanceof $root.WebAuthnListResidentCredentials)
            return object;
        return new $root.WebAuthnListResidentCredentials();
    };

    WebAuthnListResidentCredentials.toObject = function toObject() {
        return {};
    };

    WebAuthnListResidentCredentials.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return WebAuthnListResidentCredentials;
})();

$root.WebAuthnAddResidentCredential = (function() {

    function WebAuthnAddResidentCredential(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    WebAuthnAddResidentCredential.prototype.credential_id = $util.newBuffer([]);

    WebAuthnAddResidentCredential.create = function create(properties) {
        return new WebAuthnAddResidentCredential(properties);
    };

    WebAuthnAddResidentCredential.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.credential_id != null && Object.hasOwnProperty.call(message, "credential_id"))
            writer.uint32(10).bytes(message.credential_id);
        return writer;
    };

    WebAuthnAddResidentCredential.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    WebAuthnAddResidentCredential.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.WebAuthnAddResidentCredential();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.credential_id = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    WebAuthnAddResidentCredential.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    WebAuthnAddResidentCredential.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.credential_id != null && message.hasOwnProperty("credential_id"))
            if (!(message.credential_id && typeof message.credential_id.length === "number" || $util.isString(message.credential_id)))
                return "credential_id: buffer expected";
        return null;
    };

    WebAuthnAddResidentCredential.fromObject = function fromObject(object) {
        if (object instanceof $root.WebAuthnAddResidentCredential)
            return object;
        var message = new $root.WebAuthnAddResidentCredential();
        if (object.credential_id != null)
            if (typeof object.credential_id === "string")
                $util.base64.decode(object.credential_id, message.credential_id = $util.newBuffer($util.base64.length(object.credential_id)), 0);
            else if (object.credential_id.length)
                message.credential_id = object.credential_id;
        return message;
    };

    WebAuthnAddResidentCredential.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.credential_id = "";
            else {
                object.credential_id = [];
                if (options.bytes !== Array)
                    object.credential_id = $util.newBuffer(object.credential_id);
            }
        if (message.credential_id != null && message.hasOwnProperty("credential_id"))
            object.credential_id = options.bytes === String ? $util.base64.encode(message.credential_id, 0, message.credential_id.length) : options.bytes === Array ? Array.prototype.slice.call(message.credential_id) : message.credential_id;
        return object;
    };

    WebAuthnAddResidentCredential.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return WebAuthnAddResidentCredential;
})();

$root.WebAuthnRemoveResidentCredential = (function() {

    function WebAuthnRemoveResidentCredential(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    WebAuthnRemoveResidentCredential.prototype.index = 0;

    WebAuthnRemoveResidentCredential.create = function create(properties) {
        return new WebAuthnRemoveResidentCredential(properties);
    };

    WebAuthnRemoveResidentCredential.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.index != null && Object.hasOwnProperty.call(message, "index"))
            writer.uint32(8).uint32(message.index);
        return writer;
    };

    WebAuthnRemoveResidentCredential.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    WebAuthnRemoveResidentCredential.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.WebAuthnRemoveResidentCredential();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.index = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    WebAuthnRemoveResidentCredential.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    WebAuthnRemoveResidentCredential.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.index != null && message.hasOwnProperty("index"))
            if (!$util.isInteger(message.index))
                return "index: integer expected";
        return null;
    };

    WebAuthnRemoveResidentCredential.fromObject = function fromObject(object) {
        if (object instanceof $root.WebAuthnRemoveResidentCredential)
            return object;
        var message = new $root.WebAuthnRemoveResidentCredential();
        if (object.index != null)
            message.index = object.index >>> 0;
        return message;
    };

    WebAuthnRemoveResidentCredential.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.index = 0;
        if (message.index != null && message.hasOwnProperty("index"))
            object.index = message.index;
        return object;
    };

    WebAuthnRemoveResidentCredential.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return WebAuthnRemoveResidentCredential;
})();

$root.WebAuthnCredentials = (function() {

    function WebAuthnCredentials(properties) {
        this.credentials = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    WebAuthnCredentials.prototype.credentials = $util.emptyArray;

    WebAuthnCredentials.create = function create(properties) {
        return new WebAuthnCredentials(properties);
    };

    WebAuthnCredentials.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.credentials != null && message.credentials.length)
            for (var i = 0; i < message.credentials.length; ++i)
                $root.WebAuthnCredentials.WebAuthnCredential.encode(message.credentials[i], writer.uint32(10).fork()).ldelim();
        return writer;
    };

    WebAuthnCredentials.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    WebAuthnCredentials.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.WebAuthnCredentials();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.credentials && message.credentials.length))
                    message.credentials = [];
                message.credentials.push($root.WebAuthnCredentials.WebAuthnCredential.decode(reader, reader.uint32()));
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    WebAuthnCredentials.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    WebAuthnCredentials.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.credentials != null && message.hasOwnProperty("credentials")) {
            if (!Array.isArray(message.credentials))
                return "credentials: array expected";
            for (var i = 0; i < message.credentials.length; ++i) {
                var error = $root.WebAuthnCredentials.WebAuthnCredential.verify(message.credentials[i]);
                if (error)
                    return "credentials." + error;
            }
        }
        return null;
    };

    WebAuthnCredentials.fromObject = function fromObject(object) {
        if (object instanceof $root.WebAuthnCredentials)
            return object;
        var message = new $root.WebAuthnCredentials();
        if (object.credentials) {
            if (!Array.isArray(object.credentials))
                throw TypeError(".WebAuthnCredentials.credentials: array expected");
            message.credentials = [];
            for (var i = 0; i < object.credentials.length; ++i) {
                if (typeof object.credentials[i] !== "object")
                    throw TypeError(".WebAuthnCredentials.credentials: object expected");
                message.credentials[i] = $root.WebAuthnCredentials.WebAuthnCredential.fromObject(object.credentials[i]);
            }
        }
        return message;
    };

    WebAuthnCredentials.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.credentials = [];
        if (message.credentials && message.credentials.length) {
            object.credentials = [];
            for (var j = 0; j < message.credentials.length; ++j)
                object.credentials[j] = $root.WebAuthnCredentials.WebAuthnCredential.toObject(message.credentials[j], options);
        }
        return object;
    };

    WebAuthnCredentials.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    WebAuthnCredentials.WebAuthnCredential = (function() {

        function WebAuthnCredential(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        WebAuthnCredential.prototype.index = 0;
        WebAuthnCredential.prototype.id = $util.newBuffer([]);
        WebAuthnCredential.prototype.rp_id = "";
        WebAuthnCredential.prototype.rp_name = "";
        WebAuthnCredential.prototype.user_id = $util.newBuffer([]);
        WebAuthnCredential.prototype.user_name = "";
        WebAuthnCredential.prototype.user_display_name = "";
        WebAuthnCredential.prototype.creation_time = 0;
        WebAuthnCredential.prototype.hmac_secret = false;
        WebAuthnCredential.prototype.use_sign_count = false;
        WebAuthnCredential.prototype.algorithm = 0;
        WebAuthnCredential.prototype.curve = 0;

        WebAuthnCredential.create = function create(properties) {
            return new WebAuthnCredential(properties);
        };

        WebAuthnCredential.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.index != null && Object.hasOwnProperty.call(message, "index"))
                writer.uint32(8).uint32(message.index);
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(18).bytes(message.id);
            if (message.rp_id != null && Object.hasOwnProperty.call(message, "rp_id"))
                writer.uint32(26).string(message.rp_id);
            if (message.rp_name != null && Object.hasOwnProperty.call(message, "rp_name"))
                writer.uint32(34).string(message.rp_name);
            if (message.user_id != null && Object.hasOwnProperty.call(message, "user_id"))
                writer.uint32(42).bytes(message.user_id);
            if (message.user_name != null && Object.hasOwnProperty.call(message, "user_name"))
                writer.uint32(50).string(message.user_name);
            if (message.user_display_name != null && Object.hasOwnProperty.call(message, "user_display_name"))
                writer.uint32(58).string(message.user_display_name);
            if (message.creation_time != null && Object.hasOwnProperty.call(message, "creation_time"))
                writer.uint32(64).uint32(message.creation_time);
            if (message.hmac_secret != null && Object.hasOwnProperty.call(message, "hmac_secret"))
                writer.uint32(72).bool(message.hmac_secret);
            if (message.use_sign_count != null && Object.hasOwnProperty.call(message, "use_sign_count"))
                writer.uint32(80).bool(message.use_sign_count);
            if (message.algorithm != null && Object.hasOwnProperty.call(message, "algorithm"))
                writer.uint32(88).sint32(message.algorithm);
            if (message.curve != null && Object.hasOwnProperty.call(message, "curve"))
                writer.uint32(96).sint32(message.curve);
            return writer;
        };

        WebAuthnCredential.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        WebAuthnCredential.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.WebAuthnCredentials.WebAuthnCredential();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.index = reader.uint32();
                    break;
                case 2:
                    message.id = reader.bytes();
                    break;
                case 3:
                    message.rp_id = reader.string();
                    break;
                case 4:
                    message.rp_name = reader.string();
                    break;
                case 5:
                    message.user_id = reader.bytes();
                    break;
                case 6:
                    message.user_name = reader.string();
                    break;
                case 7:
                    message.user_display_name = reader.string();
                    break;
                case 8:
                    message.creation_time = reader.uint32();
                    break;
                case 9:
                    message.hmac_secret = reader.bool();
                    break;
                case 10:
                    message.use_sign_count = reader.bool();
                    break;
                case 11:
                    message.algorithm = reader.sint32();
                    break;
                case 12:
                    message.curve = reader.sint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        WebAuthnCredential.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        WebAuthnCredential.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.index != null && message.hasOwnProperty("index"))
                if (!$util.isInteger(message.index))
                    return "index: integer expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!(message.id && typeof message.id.length === "number" || $util.isString(message.id)))
                    return "id: buffer expected";
            if (message.rp_id != null && message.hasOwnProperty("rp_id"))
                if (!$util.isString(message.rp_id))
                    return "rp_id: string expected";
            if (message.rp_name != null && message.hasOwnProperty("rp_name"))
                if (!$util.isString(message.rp_name))
                    return "rp_name: string expected";
            if (message.user_id != null && message.hasOwnProperty("user_id"))
                if (!(message.user_id && typeof message.user_id.length === "number" || $util.isString(message.user_id)))
                    return "user_id: buffer expected";
            if (message.user_name != null && message.hasOwnProperty("user_name"))
                if (!$util.isString(message.user_name))
                    return "user_name: string expected";
            if (message.user_display_name != null && message.hasOwnProperty("user_display_name"))
                if (!$util.isString(message.user_display_name))
                    return "user_display_name: string expected";
            if (message.creation_time != null && message.hasOwnProperty("creation_time"))
                if (!$util.isInteger(message.creation_time))
                    return "creation_time: integer expected";
            if (message.hmac_secret != null && message.hasOwnProperty("hmac_secret"))
                if (typeof message.hmac_secret !== "boolean")
                    return "hmac_secret: boolean expected";
            if (message.use_sign_count != null && message.hasOwnProperty("use_sign_count"))
                if (typeof message.use_sign_count !== "boolean")
                    return "use_sign_count: boolean expected";
            if (message.algorithm != null && message.hasOwnProperty("algorithm"))
                if (!$util.isInteger(message.algorithm))
                    return "algorithm: integer expected";
            if (message.curve != null && message.hasOwnProperty("curve"))
                if (!$util.isInteger(message.curve))
                    return "curve: integer expected";
            return null;
        };

        WebAuthnCredential.fromObject = function fromObject(object) {
            if (object instanceof $root.WebAuthnCredentials.WebAuthnCredential)
                return object;
            var message = new $root.WebAuthnCredentials.WebAuthnCredential();
            if (object.index != null)
                message.index = object.index >>> 0;
            if (object.id != null)
                if (typeof object.id === "string")
                    $util.base64.decode(object.id, message.id = $util.newBuffer($util.base64.length(object.id)), 0);
                else if (object.id.length)
                    message.id = object.id;
            if (object.rp_id != null)
                message.rp_id = String(object.rp_id);
            if (object.rp_name != null)
                message.rp_name = String(object.rp_name);
            if (object.user_id != null)
                if (typeof object.user_id === "string")
                    $util.base64.decode(object.user_id, message.user_id = $util.newBuffer($util.base64.length(object.user_id)), 0);
                else if (object.user_id.length)
                    message.user_id = object.user_id;
            if (object.user_name != null)
                message.user_name = String(object.user_name);
            if (object.user_display_name != null)
                message.user_display_name = String(object.user_display_name);
            if (object.creation_time != null)
                message.creation_time = object.creation_time >>> 0;
            if (object.hmac_secret != null)
                message.hmac_secret = Boolean(object.hmac_secret);
            if (object.use_sign_count != null)
                message.use_sign_count = Boolean(object.use_sign_count);
            if (object.algorithm != null)
                message.algorithm = object.algorithm | 0;
            if (object.curve != null)
                message.curve = object.curve | 0;
            return message;
        };

        WebAuthnCredential.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.index = 0;
                if (options.bytes === String)
                    object.id = "";
                else {
                    object.id = [];
                    if (options.bytes !== Array)
                        object.id = $util.newBuffer(object.id);
                }
                object.rp_id = "";
                object.rp_name = "";
                if (options.bytes === String)
                    object.user_id = "";
                else {
                    object.user_id = [];
                    if (options.bytes !== Array)
                        object.user_id = $util.newBuffer(object.user_id);
                }
                object.user_name = "";
                object.user_display_name = "";
                object.creation_time = 0;
                object.hmac_secret = false;
                object.use_sign_count = false;
                object.algorithm = 0;
                object.curve = 0;
            }
            if (message.index != null && message.hasOwnProperty("index"))
                object.index = message.index;
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = options.bytes === String ? $util.base64.encode(message.id, 0, message.id.length) : options.bytes === Array ? Array.prototype.slice.call(message.id) : message.id;
            if (message.rp_id != null && message.hasOwnProperty("rp_id"))
                object.rp_id = message.rp_id;
            if (message.rp_name != null && message.hasOwnProperty("rp_name"))
                object.rp_name = message.rp_name;
            if (message.user_id != null && message.hasOwnProperty("user_id"))
                object.user_id = options.bytes === String ? $util.base64.encode(message.user_id, 0, message.user_id.length) : options.bytes === Array ? Array.prototype.slice.call(message.user_id) : message.user_id;
            if (message.user_name != null && message.hasOwnProperty("user_name"))
                object.user_name = message.user_name;
            if (message.user_display_name != null && message.hasOwnProperty("user_display_name"))
                object.user_display_name = message.user_display_name;
            if (message.creation_time != null && message.hasOwnProperty("creation_time"))
                object.creation_time = message.creation_time;
            if (message.hmac_secret != null && message.hasOwnProperty("hmac_secret"))
                object.hmac_secret = message.hmac_secret;
            if (message.use_sign_count != null && message.hasOwnProperty("use_sign_count"))
                object.use_sign_count = message.use_sign_count;
            if (message.algorithm != null && message.hasOwnProperty("algorithm"))
                object.algorithm = message.algorithm;
            if (message.curve != null && message.hasOwnProperty("curve"))
                object.curve = message.curve;
            return object;
        };

        WebAuthnCredential.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return WebAuthnCredential;
    })();

    return WebAuthnCredentials;
})();

$root.CommandFlags = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "Default"] = 0;
    values[valuesById[1] = "Factory_Only"] = 1;
    return values;
})();

$root.MessageType = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "MessageType_Initialize"] = 0;
    values[valuesById[1] = "MessageType_Ping"] = 1;
    values[valuesById[2] = "MessageType_Success"] = 2;
    values[valuesById[3] = "MessageType_Failure"] = 3;
    values[valuesById[4] = "MessageType_ChangePin"] = 4;
    values[valuesById[5] = "MessageType_WipeDevice"] = 5;
    values[valuesById[9] = "MessageType_GetEntropy"] = 9;
    values[valuesById[10] = "MessageType_Entropy"] = 10;
    values[valuesById[13] = "MessageType_LoadDevice"] = 13;
    values[valuesById[14] = "MessageType_ResetDevice"] = 14;
    values[valuesById[17] = "MessageType_Features"] = 17;
    values[valuesById[18] = "MessageType_PinMatrixRequest"] = 18;
    values[valuesById[19] = "MessageType_PinMatrixAck"] = 19;
    values[valuesById[20] = "MessageType_Cancel"] = 20;
    values[valuesById[24] = "MessageType_LockDevice"] = 24;
    values[valuesById[25] = "MessageType_ApplySettings"] = 25;
    values[valuesById[26] = "MessageType_ButtonRequest"] = 26;
    values[valuesById[27] = "MessageType_ButtonAck"] = 27;
    values[valuesById[28] = "MessageType_ApplyFlags"] = 28;
    values[valuesById[34] = "MessageType_BackupDevice"] = 34;
    values[valuesById[35] = "MessageType_EntropyRequest"] = 35;
    values[valuesById[36] = "MessageType_EntropyAck"] = 36;
    values[valuesById[41] = "MessageType_PassphraseRequest"] = 41;
    values[valuesById[42] = "MessageType_PassphraseAck"] = 42;
    values[valuesById[45] = "MessageType_RecoveryDevice"] = 45;
    values[valuesById[46] = "MessageType_WordRequest"] = 46;
    values[valuesById[47] = "MessageType_WordAck"] = 47;
    values[valuesById[55] = "MessageType_GetFeatures"] = 55;
    values[valuesById[79] = "MessageType_SdProtect"] = 79;
    values[valuesById[82] = "MessageType_ChangeWipeCode"] = 82;
    values[valuesById[83] = "MessageType_EndSession"] = 83;
    values[valuesById[84] = "MessageType_DoPreauthorized"] = 84;
    values[valuesById[85] = "MessageType_PreauthorizedRequest"] = 85;
    values[valuesById[86] = "MessageType_CancelAuthorization"] = 86;
    values[valuesById[87] = "MessageType_RebootToBootloader"] = 87;
    values[valuesById[63] = "MessageType_SetU2FCounter"] = 63;
    values[valuesById[80] = "MessageType_GetNextU2FCounter"] = 80;
    values[valuesById[81] = "MessageType_NextU2FCounter"] = 81;
    values[valuesById[77] = "MessageType_Deprecated_PassphraseStateRequest"] = 77;
    values[valuesById[78] = "MessageType_Deprecated_PassphraseStateAck"] = 78;
    values[valuesById[6] = "MessageType_FirmwareErase"] = 6;
    values[valuesById[16] = "MessageType_FirmwareErase_ex"] = 16;
    values[valuesById[7] = "MessageType_FirmwareUpload"] = 7;
    values[valuesById[8] = "MessageType_FirmwareRequest"] = 8;
    values[valuesById[32] = "MessageType_SelfTest"] = 32;
    values[valuesById[30000] = "MessageType_Reboot"] = 30000;
    values[valuesById[30001] = "MessageType_FirmwareUpdateEmmc"] = 30001;
    values[valuesById[11] = "MessageType_GetPublicKey"] = 11;
    values[valuesById[12] = "MessageType_PublicKey"] = 12;
    values[valuesById[15] = "MessageType_SignTx"] = 15;
    values[valuesById[21] = "MessageType_TxRequest"] = 21;
    values[valuesById[22] = "MessageType_TxAck"] = 22;
    values[valuesById[29] = "MessageType_GetAddress"] = 29;
    values[valuesById[30] = "MessageType_Address"] = 30;
    values[valuesById[38] = "MessageType_SignMessage"] = 38;
    values[valuesById[39] = "MessageType_VerifyMessage"] = 39;
    values[valuesById[40] = "MessageType_MessageSignature"] = 40;
    values[valuesById[43] = "MessageType_GetOwnershipId"] = 43;
    values[valuesById[44] = "MessageType_OwnershipId"] = 44;
    values[valuesById[49] = "MessageType_GetOwnershipProof"] = 49;
    values[valuesById[50] = "MessageType_OwnershipProof"] = 50;
    values[valuesById[51] = "MessageType_AuthorizeCoinJoin"] = 51;
    values[valuesById[23] = "MessageType_CipherKeyValue"] = 23;
    values[valuesById[48] = "MessageType_CipheredKeyValue"] = 48;
    values[valuesById[53] = "MessageType_SignIdentity"] = 53;
    values[valuesById[54] = "MessageType_SignedIdentity"] = 54;
    values[valuesById[61] = "MessageType_GetECDHSessionKey"] = 61;
    values[valuesById[62] = "MessageType_ECDHSessionKey"] = 62;
    values[valuesById[71] = "MessageType_CosiCommit"] = 71;
    values[valuesById[72] = "MessageType_CosiCommitment"] = 72;
    values[valuesById[73] = "MessageType_CosiSign"] = 73;
    values[valuesById[74] = "MessageType_CosiSignature"] = 74;
    values[valuesById[10016] = "MessageType_BatchGetPublickeys"] = 10016;
    values[valuesById[10017] = "MessageType_EcdsaPublicKeys"] = 10017;
    values[valuesById[100] = "MessageType_DebugLinkDecision"] = 100;
    values[valuesById[101] = "MessageType_DebugLinkGetState"] = 101;
    values[valuesById[102] = "MessageType_DebugLinkState"] = 102;
    values[valuesById[103] = "MessageType_DebugLinkStop"] = 103;
    values[valuesById[104] = "MessageType_DebugLinkLog"] = 104;
    values[valuesById[110] = "MessageType_DebugLinkMemoryRead"] = 110;
    values[valuesById[111] = "MessageType_DebugLinkMemory"] = 111;
    values[valuesById[112] = "MessageType_DebugLinkMemoryWrite"] = 112;
    values[valuesById[113] = "MessageType_DebugLinkFlashErase"] = 113;
    values[valuesById[9001] = "MessageType_DebugLinkLayout"] = 9001;
    values[valuesById[9002] = "MessageType_DebugLinkReseedRandom"] = 9002;
    values[valuesById[9003] = "MessageType_DebugLinkRecordScreen"] = 9003;
    values[valuesById[9005] = "MessageType_DebugLinkEraseSdCard"] = 9005;
    values[valuesById[9006] = "MessageType_DebugLinkWatchLayout"] = 9006;
    values[valuesById[30100] = "MessageType_EmmcFixPermission"] = 30100;
    values[valuesById[30101] = "MessageType_EmmcPath"] = 30101;
    values[valuesById[30102] = "MessageType_EmmcPathInfo"] = 30102;
    values[valuesById[30103] = "MessageType_EmmcFile"] = 30103;
    values[valuesById[30104] = "MessageType_EmmcFileRead"] = 30104;
    values[valuesById[30105] = "MessageType_EmmcFileWrite"] = 30105;
    values[valuesById[30106] = "MessageType_EmmcFileDelete"] = 30106;
    values[valuesById[30107] = "MessageType_EmmcDir"] = 30107;
    values[valuesById[30108] = "MessageType_EmmcDirList"] = 30108;
    values[valuesById[30109] = "MessageType_EmmcDirMake"] = 30109;
    values[valuesById[30110] = "MessageType_EmmcDirRemove"] = 30110;
    values[valuesById[450] = "MessageType_EthereumGetPublicKey"] = 450;
    values[valuesById[451] = "MessageType_EthereumPublicKey"] = 451;
    values[valuesById[56] = "MessageType_EthereumGetAddress"] = 56;
    values[valuesById[57] = "MessageType_EthereumAddress"] = 57;
    values[valuesById[58] = "MessageType_EthereumSignTx"] = 58;
    values[valuesById[452] = "MessageType_EthereumSignTxEIP1559"] = 452;
    values[valuesById[59] = "MessageType_EthereumTxRequest"] = 59;
    values[valuesById[60] = "MessageType_EthereumTxAck"] = 60;
    values[valuesById[64] = "MessageType_EthereumSignMessage"] = 64;
    values[valuesById[65] = "MessageType_EthereumVerifyMessage"] = 65;
    values[valuesById[66] = "MessageType_EthereumMessageSignature"] = 66;
    values[valuesById[464] = "MessageType_EthereumSignTypedData"] = 464;
    values[valuesById[465] = "MessageType_EthereumTypedDataStructRequest"] = 465;
    values[valuesById[466] = "MessageType_EthereumTypedDataStructAck"] = 466;
    values[valuesById[467] = "MessageType_EthereumTypedDataValueRequest"] = 467;
    values[valuesById[468] = "MessageType_EthereumTypedDataValueAck"] = 468;
    values[valuesById[469] = "MessageType_EthereumTypedDataSignature"] = 469;
    values[valuesById[470] = "MessageType_EthereumSignTypedHash"] = 470;
    values[valuesById[67] = "MessageType_NEMGetAddress"] = 67;
    values[valuesById[68] = "MessageType_NEMAddress"] = 68;
    values[valuesById[69] = "MessageType_NEMSignTx"] = 69;
    values[valuesById[70] = "MessageType_NEMSignedTx"] = 70;
    values[valuesById[75] = "MessageType_NEMDecryptMessage"] = 75;
    values[valuesById[76] = "MessageType_NEMDecryptedMessage"] = 76;
    values[valuesById[150] = "MessageType_TezosGetAddress"] = 150;
    values[valuesById[151] = "MessageType_TezosAddress"] = 151;
    values[valuesById[152] = "MessageType_TezosSignTx"] = 152;
    values[valuesById[153] = "MessageType_TezosSignedTx"] = 153;
    values[valuesById[154] = "MessageType_TezosGetPublicKey"] = 154;
    values[valuesById[155] = "MessageType_TezosPublicKey"] = 155;
    values[valuesById[202] = "MessageType_StellarSignTx"] = 202;
    values[valuesById[203] = "MessageType_StellarTxOpRequest"] = 203;
    values[valuesById[207] = "MessageType_StellarGetAddress"] = 207;
    values[valuesById[208] = "MessageType_StellarAddress"] = 208;
    values[valuesById[210] = "MessageType_StellarCreateAccountOp"] = 210;
    values[valuesById[211] = "MessageType_StellarPaymentOp"] = 211;
    values[valuesById[212] = "MessageType_StellarPathPaymentStrictReceiveOp"] = 212;
    values[valuesById[213] = "MessageType_StellarManageSellOfferOp"] = 213;
    values[valuesById[214] = "MessageType_StellarCreatePassiveSellOfferOp"] = 214;
    values[valuesById[215] = "MessageType_StellarSetOptionsOp"] = 215;
    values[valuesById[216] = "MessageType_StellarChangeTrustOp"] = 216;
    values[valuesById[217] = "MessageType_StellarAllowTrustOp"] = 217;
    values[valuesById[218] = "MessageType_StellarAccountMergeOp"] = 218;
    values[valuesById[220] = "MessageType_StellarManageDataOp"] = 220;
    values[valuesById[221] = "MessageType_StellarBumpSequenceOp"] = 221;
    values[valuesById[222] = "MessageType_StellarManageBuyOfferOp"] = 222;
    values[valuesById[223] = "MessageType_StellarPathPaymentStrictSendOp"] = 223;
    values[valuesById[230] = "MessageType_StellarSignedTx"] = 230;
    values[valuesById[305] = "MessageType_CardanoGetPublicKey"] = 305;
    values[valuesById[306] = "MessageType_CardanoPublicKey"] = 306;
    values[valuesById[307] = "MessageType_CardanoGetAddress"] = 307;
    values[valuesById[308] = "MessageType_CardanoAddress"] = 308;
    values[valuesById[313] = "MessageType_CardanoTxItemAck"] = 313;
    values[valuesById[314] = "MessageType_CardanoTxAuxiliaryDataSupplement"] = 314;
    values[valuesById[315] = "MessageType_CardanoTxWitnessRequest"] = 315;
    values[valuesById[316] = "MessageType_CardanoTxWitnessResponse"] = 316;
    values[valuesById[317] = "MessageType_CardanoTxHostAck"] = 317;
    values[valuesById[318] = "MessageType_CardanoTxBodyHash"] = 318;
    values[valuesById[319] = "MessageType_CardanoSignTxFinished"] = 319;
    values[valuesById[320] = "MessageType_CardanoSignTxInit"] = 320;
    values[valuesById[321] = "MessageType_CardanoTxInput"] = 321;
    values[valuesById[322] = "MessageType_CardanoTxOutput"] = 322;
    values[valuesById[323] = "MessageType_CardanoAssetGroup"] = 323;
    values[valuesById[324] = "MessageType_CardanoToken"] = 324;
    values[valuesById[325] = "MessageType_CardanoTxCertificate"] = 325;
    values[valuesById[326] = "MessageType_CardanoTxWithdrawal"] = 326;
    values[valuesById[327] = "MessageType_CardanoTxAuxiliaryData"] = 327;
    values[valuesById[328] = "MessageType_CardanoPoolOwner"] = 328;
    values[valuesById[329] = "MessageType_CardanoPoolRelayParameters"] = 329;
    values[valuesById[330] = "MessageType_CardanoGetNativeScriptHash"] = 330;
    values[valuesById[331] = "MessageType_CardanoNativeScriptHash"] = 331;
    values[valuesById[332] = "MessageType_CardanoTxMint"] = 332;
    values[valuesById[333] = "MessageType_CardanoTxCollateralInput"] = 333;
    values[valuesById[334] = "MessageType_CardanoTxRequiredSigner"] = 334;
    values[valuesById[335] = "MessageType_CardanoTxInlineDatumChunk"] = 335;
    values[valuesById[336] = "MessageType_CardanoTxReferenceScriptChunk"] = 336;
    values[valuesById[337] = "MessageType_CardanoTxReferenceInput"] = 337;
    values[valuesById[350] = "MessageType_CardanoSignMessage"] = 350;
    values[valuesById[351] = "MessageType_CardanoMessageSignature"] = 351;
    values[valuesById[400] = "MessageType_RippleGetAddress"] = 400;
    values[valuesById[401] = "MessageType_RippleAddress"] = 401;
    values[valuesById[402] = "MessageType_RippleSignTx"] = 402;
    values[valuesById[403] = "MessageType_RippleSignedTx"] = 403;
    values[valuesById[501] = "MessageType_MoneroTransactionInitRequest"] = 501;
    values[valuesById[502] = "MessageType_MoneroTransactionInitAck"] = 502;
    values[valuesById[503] = "MessageType_MoneroTransactionSetInputRequest"] = 503;
    values[valuesById[504] = "MessageType_MoneroTransactionSetInputAck"] = 504;
    values[valuesById[505] = "MessageType_MoneroTransactionInputsPermutationRequest"] = 505;
    values[valuesById[506] = "MessageType_MoneroTransactionInputsPermutationAck"] = 506;
    values[valuesById[507] = "MessageType_MoneroTransactionInputViniRequest"] = 507;
    values[valuesById[508] = "MessageType_MoneroTransactionInputViniAck"] = 508;
    values[valuesById[509] = "MessageType_MoneroTransactionAllInputsSetRequest"] = 509;
    values[valuesById[510] = "MessageType_MoneroTransactionAllInputsSetAck"] = 510;
    values[valuesById[511] = "MessageType_MoneroTransactionSetOutputRequest"] = 511;
    values[valuesById[512] = "MessageType_MoneroTransactionSetOutputAck"] = 512;
    values[valuesById[513] = "MessageType_MoneroTransactionAllOutSetRequest"] = 513;
    values[valuesById[514] = "MessageType_MoneroTransactionAllOutSetAck"] = 514;
    values[valuesById[515] = "MessageType_MoneroTransactionSignInputRequest"] = 515;
    values[valuesById[516] = "MessageType_MoneroTransactionSignInputAck"] = 516;
    values[valuesById[517] = "MessageType_MoneroTransactionFinalRequest"] = 517;
    values[valuesById[518] = "MessageType_MoneroTransactionFinalAck"] = 518;
    values[valuesById[530] = "MessageType_MoneroKeyImageExportInitRequest"] = 530;
    values[valuesById[531] = "MessageType_MoneroKeyImageExportInitAck"] = 531;
    values[valuesById[532] = "MessageType_MoneroKeyImageSyncStepRequest"] = 532;
    values[valuesById[533] = "MessageType_MoneroKeyImageSyncStepAck"] = 533;
    values[valuesById[534] = "MessageType_MoneroKeyImageSyncFinalRequest"] = 534;
    values[valuesById[535] = "MessageType_MoneroKeyImageSyncFinalAck"] = 535;
    values[valuesById[540] = "MessageType_MoneroGetAddress"] = 540;
    values[valuesById[541] = "MessageType_MoneroAddress"] = 541;
    values[valuesById[542] = "MessageType_MoneroGetWatchKey"] = 542;
    values[valuesById[543] = "MessageType_MoneroWatchKey"] = 543;
    values[valuesById[546] = "MessageType_DebugMoneroDiagRequest"] = 546;
    values[valuesById[547] = "MessageType_DebugMoneroDiagAck"] = 547;
    values[valuesById[550] = "MessageType_MoneroGetTxKeyRequest"] = 550;
    values[valuesById[551] = "MessageType_MoneroGetTxKeyAck"] = 551;
    values[valuesById[552] = "MessageType_MoneroLiveRefreshStartRequest"] = 552;
    values[valuesById[553] = "MessageType_MoneroLiveRefreshStartAck"] = 553;
    values[valuesById[554] = "MessageType_MoneroLiveRefreshStepRequest"] = 554;
    values[valuesById[555] = "MessageType_MoneroLiveRefreshStepAck"] = 555;
    values[valuesById[556] = "MessageType_MoneroLiveRefreshFinalRequest"] = 556;
    values[valuesById[557] = "MessageType_MoneroLiveRefreshFinalAck"] = 557;
    values[valuesById[600] = "MessageType_EosGetPublicKey"] = 600;
    values[valuesById[601] = "MessageType_EosPublicKey"] = 601;
    values[valuesById[602] = "MessageType_EosSignTx"] = 602;
    values[valuesById[603] = "MessageType_EosTxActionRequest"] = 603;
    values[valuesById[604] = "MessageType_EosTxActionAck"] = 604;
    values[valuesById[605] = "MessageType_EosSignedTx"] = 605;
    values[valuesById[700] = "MessageType_BinanceGetAddress"] = 700;
    values[valuesById[701] = "MessageType_BinanceAddress"] = 701;
    values[valuesById[702] = "MessageType_BinanceGetPublicKey"] = 702;
    values[valuesById[703] = "MessageType_BinancePublicKey"] = 703;
    values[valuesById[704] = "MessageType_BinanceSignTx"] = 704;
    values[valuesById[705] = "MessageType_BinanceTxRequest"] = 705;
    values[valuesById[706] = "MessageType_BinanceTransferMsg"] = 706;
    values[valuesById[707] = "MessageType_BinanceOrderMsg"] = 707;
    values[valuesById[708] = "MessageType_BinanceCancelMsg"] = 708;
    values[valuesById[709] = "MessageType_BinanceSignedTx"] = 709;
    values[valuesById[10100] = "MessageType_SolanaGetAddress"] = 10100;
    values[valuesById[10101] = "MessageType_SolanaAddress"] = 10101;
    values[valuesById[10102] = "MessageType_SolanaSignTx"] = 10102;
    values[valuesById[10103] = "MessageType_SolanaSignedTx"] = 10103;
    values[valuesById[10300] = "MessageType_StarcoinGetAddress"] = 10300;
    values[valuesById[10301] = "MessageType_StarcoinAddress"] = 10301;
    values[valuesById[10302] = "MessageType_StarcoinGetPublicKey"] = 10302;
    values[valuesById[10303] = "MessageType_StarcoinPublicKey"] = 10303;
    values[valuesById[10304] = "MessageType_StarcoinSignTx"] = 10304;
    values[valuesById[10305] = "MessageType_StarcoinSignedTx"] = 10305;
    values[valuesById[10306] = "MessageType_StarcoinSignMessage"] = 10306;
    values[valuesById[10307] = "MessageType_StarcoinMessageSignature"] = 10307;
    values[valuesById[10308] = "MessageType_StarcoinVerifyMessage"] = 10308;
    values[valuesById[10600] = "MessageType_AptosGetAddress"] = 10600;
    values[valuesById[10601] = "MessageType_AptosAddress"] = 10601;
    values[valuesById[10602] = "MessageType_AptosSignTx"] = 10602;
    values[valuesById[10603] = "MessageType_AptosSignedTx"] = 10603;
    values[valuesById[10604] = "MessageType_AptosSignMessage"] = 10604;
    values[valuesById[10605] = "MessageType_AptosMessageSignature"] = 10605;
    values[valuesById[800] = "MessageType_WebAuthnListResidentCredentials"] = 800;
    values[valuesById[801] = "MessageType_WebAuthnCredentials"] = 801;
    values[valuesById[802] = "MessageType_WebAuthnAddResidentCredential"] = 802;
    values[valuesById[803] = "MessageType_WebAuthnRemoveResidentCredential"] = 803;
    values[valuesById[901] = "MessageType_BixinSeedOperate"] = 901;
    values[valuesById[902] = "MessageType_BixinMessageSE"] = 902;
    values[valuesById[904] = "MessageType_BixinOutMessageSE"] = 904;
    values[valuesById[905] = "MessageType_BixinBackupRequest"] = 905;
    values[valuesById[906] = "MessageType_BixinBackupAck"] = 906;
    values[valuesById[907] = "MessageType_BixinRestoreRequest"] = 907;
    values[valuesById[908] = "MessageType_BixinRestoreAck"] = 908;
    values[valuesById[909] = "MessageType_BixinVerifyDeviceRequest"] = 909;
    values[valuesById[910] = "MessageType_BixinVerifyDeviceAck"] = 910;
    values[valuesById[911] = "MessageType_BixinWhiteListRequest"] = 911;
    values[valuesById[912] = "MessageType_BixinWhiteListAck"] = 912;
    values[valuesById[913] = "MessageType_BixinLoadDevice"] = 913;
    values[valuesById[914] = "MessageType_BixinBackupDevice"] = 914;
    values[valuesById[915] = "MessageType_BixinBackupDeviceAck"] = 915;
    values[valuesById[10000] = "MessageType_BixinPinInputOnDevice"] = 10000;
    values[valuesById[10200] = "MessageType_EthereumSignMessageEIP712"] = 10200;
    values[valuesById[10210] = "MessageType_GetPublicKeyMultiple"] = 10210;
    values[valuesById[10211] = "MessageType_PublicKeyMultiple"] = 10211;
    values[valuesById[10112] = "MessageType_ConfluxGetAddress"] = 10112;
    values[valuesById[10113] = "MessageType_ConfluxAddress"] = 10113;
    values[valuesById[10114] = "MessageType_ConfluxSignTx"] = 10114;
    values[valuesById[10115] = "MessageType_ConfluxTxRequest"] = 10115;
    values[valuesById[10116] = "MessageType_ConfluxTxAck"] = 10116;
    values[valuesById[10117] = "MessageType_ConfluxSignMessage"] = 10117;
    values[valuesById[10118] = "MessageType_ConfluxSignMessageCIP23"] = 10118;
    values[valuesById[10119] = "MessageType_ConfluxMessageSignature"] = 10119;
    values[valuesById[10501] = "MessageType_TronGetAddress"] = 10501;
    values[valuesById[10502] = "MessageType_TronAddress"] = 10502;
    values[valuesById[10503] = "MessageType_TronSignTx"] = 10503;
    values[valuesById[10504] = "MessageType_TronSignedTx"] = 10504;
    values[valuesById[10505] = "MessageType_TronSignMessage"] = 10505;
    values[valuesById[10506] = "MessageType_TronMessageSignature"] = 10506;
    values[valuesById[10701] = "MessageType_NearGetAddress"] = 10701;
    values[valuesById[10702] = "MessageType_NearAddress"] = 10702;
    values[valuesById[10703] = "MessageType_NearSignTx"] = 10703;
    values[valuesById[10704] = "MessageType_NearSignedTx"] = 10704;
    values[valuesById[10800] = "MessageType_CosmosGetAddress"] = 10800;
    values[valuesById[10801] = "MessageType_CosmosAddress"] = 10801;
    values[valuesById[10802] = "MessageType_CosmosSignTx"] = 10802;
    values[valuesById[10803] = "MessageType_CosmosSignedTx"] = 10803;
    values[valuesById[10900] = "MessageType_AlgorandGetAddress"] = 10900;
    values[valuesById[10901] = "MessageType_AlgorandAddress"] = 10901;
    values[valuesById[10902] = "MessageType_AlgorandSignTx"] = 10902;
    values[valuesById[10903] = "MessageType_AlgorandSignedTx"] = 10903;
    values[valuesById[11000] = "MessageType_PolkadotGetAddress"] = 11000;
    values[valuesById[11001] = "MessageType_PolkadotAddress"] = 11001;
    values[valuesById[11002] = "MessageType_PolkadotSignTx"] = 11002;
    values[valuesById[11003] = "MessageType_PolkadotSignedTx"] = 11003;
    values[valuesById[11100] = "MessageType_SuiGetAddress"] = 11100;
    values[valuesById[11101] = "MessageType_SuiAddress"] = 11101;
    values[valuesById[11102] = "MessageType_SuiSignTx"] = 11102;
    values[valuesById[11103] = "MessageType_SuiSignedTx"] = 11103;
    values[valuesById[11200] = "MessageType_FilecoinGetAddress"] = 11200;
    values[valuesById[11201] = "MessageType_FilecoinAddress"] = 11201;
    values[valuesById[11202] = "MessageType_FilecoinSignTx"] = 11202;
    values[valuesById[11203] = "MessageType_FilecoinSignedTx"] = 11203;
    values[valuesById[11300] = "MessageType_KaspaGetAddress"] = 11300;
    values[valuesById[11301] = "MessageType_KaspaAddress"] = 11301;
    values[valuesById[11302] = "MessageType_KaspaSignTx"] = 11302;
    values[valuesById[11303] = "MessageType_KaspaSignedTx"] = 11303;
    values[valuesById[11304] = "MessageType_KaspaTxInputRequest"] = 11304;
    values[valuesById[11305] = "MessageType_KaspaTxInputAck"] = 11305;
    values[valuesById[11400] = "MessageType_NexaGetAddress"] = 11400;
    values[valuesById[11401] = "MessageType_NexaAddress"] = 11401;
    values[valuesById[11402] = "MessageType_NexaSignTx"] = 11402;
    values[valuesById[11403] = "MessageType_NexaSignedTx"] = 11403;
    values[valuesById[11404] = "MessageType_NexaTxInputRequest"] = 11404;
    values[valuesById[11405] = "MessageType_NexaTxInputAck"] = 11405;
    values[valuesById[903] = "MessageType_DeviceBackToBoot"] = 903;
    values[valuesById[10001] = "MessageType_DeviceInfoSettings"] = 10001;
    values[valuesById[10002] = "MessageType_GetDeviceInfo"] = 10002;
    values[valuesById[10003] = "MessageType_DeviceInfo"] = 10003;
    values[valuesById[10004] = "MessageType_ReadSEPublicKey"] = 10004;
    values[valuesById[10005] = "MessageType_SEPublicKey"] = 10005;
    values[valuesById[10006] = "MessageType_WriteSEPublicCert"] = 10006;
    values[valuesById[10007] = "MessageType_ReadSEPublicCert"] = 10007;
    values[valuesById[10008] = "MessageType_SEPublicCert"] = 10008;
    values[valuesById[10009] = "MessageType_SpiFlashWrite"] = 10009;
    values[valuesById[10010] = "MessageType_SpiFlashRead"] = 10010;
    values[valuesById[10011] = "MessageType_SpiFlashData"] = 10011;
    values[valuesById[10012] = "MessageType_SESignMessage"] = 10012;
    values[valuesById[10013] = "MessageType_SEMessageSignature"] = 10013;
    values[valuesById[10014] = "MessageType_NFTWriteInfo"] = 10014;
    values[valuesById[10015] = "MessageType_NFTWriteData"] = 10015;
    values[valuesById[10018] = "MessageType_ResourceUpload"] = 10018;
    values[valuesById[10019] = "MessageType_ZoomRequest"] = 10019;
    values[valuesById[10020] = "MessageType_ResourceRequest"] = 10020;
    values[valuesById[10021] = "MessageType_ResourceAck"] = 10021;
    values[valuesById[10022] = "MessageType_ResourceUpdate"] = 10022;
    values[valuesById[10023] = "MessageType_ListResDir"] = 10023;
    values[valuesById[10024] = "MessageType_FileInfoList"] = 10024;
    values[valuesById[10025] = "MessageType_RebootToBoardloader"] = 10025;
    values[valuesById[10026] = "MessageType_DeviceEraseSector"] = 10026;
    return values;
})();

$root.google = (function() {

    var google = {};

    google.protobuf = (function() {

        var protobuf = {};

        protobuf.FileDescriptorSet = (function() {

            function FileDescriptorSet(properties) {
                this.file = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            FileDescriptorSet.prototype.file = $util.emptyArray;

            FileDescriptorSet.create = function create(properties) {
                return new FileDescriptorSet(properties);
            };

            FileDescriptorSet.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.file != null && message.file.length)
                    for (var i = 0; i < message.file.length; ++i)
                        $root.google.protobuf.FileDescriptorProto.encode(message.file[i], writer.uint32(10).fork()).ldelim();
                return writer;
            };

            FileDescriptorSet.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            FileDescriptorSet.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.FileDescriptorSet();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (!(message.file && message.file.length))
                            message.file = [];
                        message.file.push($root.google.protobuf.FileDescriptorProto.decode(reader, reader.uint32()));
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            FileDescriptorSet.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            FileDescriptorSet.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.file != null && message.hasOwnProperty("file")) {
                    if (!Array.isArray(message.file))
                        return "file: array expected";
                    for (var i = 0; i < message.file.length; ++i) {
                        var error = $root.google.protobuf.FileDescriptorProto.verify(message.file[i]);
                        if (error)
                            return "file." + error;
                    }
                }
                return null;
            };

            FileDescriptorSet.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.FileDescriptorSet)
                    return object;
                var message = new $root.google.protobuf.FileDescriptorSet();
                if (object.file) {
                    if (!Array.isArray(object.file))
                        throw TypeError(".google.protobuf.FileDescriptorSet.file: array expected");
                    message.file = [];
                    for (var i = 0; i < object.file.length; ++i) {
                        if (typeof object.file[i] !== "object")
                            throw TypeError(".google.protobuf.FileDescriptorSet.file: object expected");
                        message.file[i] = $root.google.protobuf.FileDescriptorProto.fromObject(object.file[i]);
                    }
                }
                return message;
            };

            FileDescriptorSet.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.file = [];
                if (message.file && message.file.length) {
                    object.file = [];
                    for (var j = 0; j < message.file.length; ++j)
                        object.file[j] = $root.google.protobuf.FileDescriptorProto.toObject(message.file[j], options);
                }
                return object;
            };

            FileDescriptorSet.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return FileDescriptorSet;
        })();

        protobuf.FileDescriptorProto = (function() {

            function FileDescriptorProto(properties) {
                this.dependency = [];
                this.public_dependency = [];
                this.weak_dependency = [];
                this.message_type = [];
                this.enum_type = [];
                this.service = [];
                this.extension = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            FileDescriptorProto.prototype.name = "";
            FileDescriptorProto.prototype["package"] = "";
            FileDescriptorProto.prototype.dependency = $util.emptyArray;
            FileDescriptorProto.prototype.public_dependency = $util.emptyArray;
            FileDescriptorProto.prototype.weak_dependency = $util.emptyArray;
            FileDescriptorProto.prototype.message_type = $util.emptyArray;
            FileDescriptorProto.prototype.enum_type = $util.emptyArray;
            FileDescriptorProto.prototype.service = $util.emptyArray;
            FileDescriptorProto.prototype.extension = $util.emptyArray;
            FileDescriptorProto.prototype.options = null;
            FileDescriptorProto.prototype.source_code_info = null;
            FileDescriptorProto.prototype.syntax = "";

            FileDescriptorProto.create = function create(properties) {
                return new FileDescriptorProto(properties);
            };

            FileDescriptorProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                    writer.uint32(10).string(message.name);
                if (message["package"] != null && Object.hasOwnProperty.call(message, "package"))
                    writer.uint32(18).string(message["package"]);
                if (message.dependency != null && message.dependency.length)
                    for (var i = 0; i < message.dependency.length; ++i)
                        writer.uint32(26).string(message.dependency[i]);
                if (message.message_type != null && message.message_type.length)
                    for (var i = 0; i < message.message_type.length; ++i)
                        $root.google.protobuf.DescriptorProto.encode(message.message_type[i], writer.uint32(34).fork()).ldelim();
                if (message.enum_type != null && message.enum_type.length)
                    for (var i = 0; i < message.enum_type.length; ++i)
                        $root.google.protobuf.EnumDescriptorProto.encode(message.enum_type[i], writer.uint32(42).fork()).ldelim();
                if (message.service != null && message.service.length)
                    for (var i = 0; i < message.service.length; ++i)
                        $root.google.protobuf.ServiceDescriptorProto.encode(message.service[i], writer.uint32(50).fork()).ldelim();
                if (message.extension != null && message.extension.length)
                    for (var i = 0; i < message.extension.length; ++i)
                        $root.google.protobuf.FieldDescriptorProto.encode(message.extension[i], writer.uint32(58).fork()).ldelim();
                if (message.options != null && Object.hasOwnProperty.call(message, "options"))
                    $root.google.protobuf.FileOptions.encode(message.options, writer.uint32(66).fork()).ldelim();
                if (message.source_code_info != null && Object.hasOwnProperty.call(message, "source_code_info"))
                    $root.google.protobuf.SourceCodeInfo.encode(message.source_code_info, writer.uint32(74).fork()).ldelim();
                if (message.public_dependency != null && message.public_dependency.length)
                    for (var i = 0; i < message.public_dependency.length; ++i)
                        writer.uint32(80).int32(message.public_dependency[i]);
                if (message.weak_dependency != null && message.weak_dependency.length)
                    for (var i = 0; i < message.weak_dependency.length; ++i)
                        writer.uint32(88).int32(message.weak_dependency[i]);
                if (message.syntax != null && Object.hasOwnProperty.call(message, "syntax"))
                    writer.uint32(98).string(message.syntax);
                return writer;
            };

            FileDescriptorProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            FileDescriptorProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.FileDescriptorProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.name = reader.string();
                        break;
                    case 2:
                        message["package"] = reader.string();
                        break;
                    case 3:
                        if (!(message.dependency && message.dependency.length))
                            message.dependency = [];
                        message.dependency.push(reader.string());
                        break;
                    case 10:
                        if (!(message.public_dependency && message.public_dependency.length))
                            message.public_dependency = [];
                        if ((tag & 7) === 2) {
                            var end2 = reader.uint32() + reader.pos;
                            while (reader.pos < end2)
                                message.public_dependency.push(reader.int32());
                        } else
                            message.public_dependency.push(reader.int32());
                        break;
                    case 11:
                        if (!(message.weak_dependency && message.weak_dependency.length))
                            message.weak_dependency = [];
                        if ((tag & 7) === 2) {
                            var end2 = reader.uint32() + reader.pos;
                            while (reader.pos < end2)
                                message.weak_dependency.push(reader.int32());
                        } else
                            message.weak_dependency.push(reader.int32());
                        break;
                    case 4:
                        if (!(message.message_type && message.message_type.length))
                            message.message_type = [];
                        message.message_type.push($root.google.protobuf.DescriptorProto.decode(reader, reader.uint32()));
                        break;
                    case 5:
                        if (!(message.enum_type && message.enum_type.length))
                            message.enum_type = [];
                        message.enum_type.push($root.google.protobuf.EnumDescriptorProto.decode(reader, reader.uint32()));
                        break;
                    case 6:
                        if (!(message.service && message.service.length))
                            message.service = [];
                        message.service.push($root.google.protobuf.ServiceDescriptorProto.decode(reader, reader.uint32()));
                        break;
                    case 7:
                        if (!(message.extension && message.extension.length))
                            message.extension = [];
                        message.extension.push($root.google.protobuf.FieldDescriptorProto.decode(reader, reader.uint32()));
                        break;
                    case 8:
                        message.options = $root.google.protobuf.FileOptions.decode(reader, reader.uint32());
                        break;
                    case 9:
                        message.source_code_info = $root.google.protobuf.SourceCodeInfo.decode(reader, reader.uint32());
                        break;
                    case 12:
                        message.syntax = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            FileDescriptorProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            FileDescriptorProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.name != null && message.hasOwnProperty("name"))
                    if (!$util.isString(message.name))
                        return "name: string expected";
                if (message["package"] != null && message.hasOwnProperty("package"))
                    if (!$util.isString(message["package"]))
                        return "package: string expected";
                if (message.dependency != null && message.hasOwnProperty("dependency")) {
                    if (!Array.isArray(message.dependency))
                        return "dependency: array expected";
                    for (var i = 0; i < message.dependency.length; ++i)
                        if (!$util.isString(message.dependency[i]))
                            return "dependency: string[] expected";
                }
                if (message.public_dependency != null && message.hasOwnProperty("public_dependency")) {
                    if (!Array.isArray(message.public_dependency))
                        return "public_dependency: array expected";
                    for (var i = 0; i < message.public_dependency.length; ++i)
                        if (!$util.isInteger(message.public_dependency[i]))
                            return "public_dependency: integer[] expected";
                }
                if (message.weak_dependency != null && message.hasOwnProperty("weak_dependency")) {
                    if (!Array.isArray(message.weak_dependency))
                        return "weak_dependency: array expected";
                    for (var i = 0; i < message.weak_dependency.length; ++i)
                        if (!$util.isInteger(message.weak_dependency[i]))
                            return "weak_dependency: integer[] expected";
                }
                if (message.message_type != null && message.hasOwnProperty("message_type")) {
                    if (!Array.isArray(message.message_type))
                        return "message_type: array expected";
                    for (var i = 0; i < message.message_type.length; ++i) {
                        var error = $root.google.protobuf.DescriptorProto.verify(message.message_type[i]);
                        if (error)
                            return "message_type." + error;
                    }
                }
                if (message.enum_type != null && message.hasOwnProperty("enum_type")) {
                    if (!Array.isArray(message.enum_type))
                        return "enum_type: array expected";
                    for (var i = 0; i < message.enum_type.length; ++i) {
                        var error = $root.google.protobuf.EnumDescriptorProto.verify(message.enum_type[i]);
                        if (error)
                            return "enum_type." + error;
                    }
                }
                if (message.service != null && message.hasOwnProperty("service")) {
                    if (!Array.isArray(message.service))
                        return "service: array expected";
                    for (var i = 0; i < message.service.length; ++i) {
                        var error = $root.google.protobuf.ServiceDescriptorProto.verify(message.service[i]);
                        if (error)
                            return "service." + error;
                    }
                }
                if (message.extension != null && message.hasOwnProperty("extension")) {
                    if (!Array.isArray(message.extension))
                        return "extension: array expected";
                    for (var i = 0; i < message.extension.length; ++i) {
                        var error = $root.google.protobuf.FieldDescriptorProto.verify(message.extension[i]);
                        if (error)
                            return "extension." + error;
                    }
                }
                if (message.options != null && message.hasOwnProperty("options")) {
                    var error = $root.google.protobuf.FileOptions.verify(message.options);
                    if (error)
                        return "options." + error;
                }
                if (message.source_code_info != null && message.hasOwnProperty("source_code_info")) {
                    var error = $root.google.protobuf.SourceCodeInfo.verify(message.source_code_info);
                    if (error)
                        return "source_code_info." + error;
                }
                if (message.syntax != null && message.hasOwnProperty("syntax"))
                    if (!$util.isString(message.syntax))
                        return "syntax: string expected";
                return null;
            };

            FileDescriptorProto.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.FileDescriptorProto)
                    return object;
                var message = new $root.google.protobuf.FileDescriptorProto();
                if (object.name != null)
                    message.name = String(object.name);
                if (object["package"] != null)
                    message["package"] = String(object["package"]);
                if (object.dependency) {
                    if (!Array.isArray(object.dependency))
                        throw TypeError(".google.protobuf.FileDescriptorProto.dependency: array expected");
                    message.dependency = [];
                    for (var i = 0; i < object.dependency.length; ++i)
                        message.dependency[i] = String(object.dependency[i]);
                }
                if (object.public_dependency) {
                    if (!Array.isArray(object.public_dependency))
                        throw TypeError(".google.protobuf.FileDescriptorProto.public_dependency: array expected");
                    message.public_dependency = [];
                    for (var i = 0; i < object.public_dependency.length; ++i)
                        message.public_dependency[i] = object.public_dependency[i] | 0;
                }
                if (object.weak_dependency) {
                    if (!Array.isArray(object.weak_dependency))
                        throw TypeError(".google.protobuf.FileDescriptorProto.weak_dependency: array expected");
                    message.weak_dependency = [];
                    for (var i = 0; i < object.weak_dependency.length; ++i)
                        message.weak_dependency[i] = object.weak_dependency[i] | 0;
                }
                if (object.message_type) {
                    if (!Array.isArray(object.message_type))
                        throw TypeError(".google.protobuf.FileDescriptorProto.message_type: array expected");
                    message.message_type = [];
                    for (var i = 0; i < object.message_type.length; ++i) {
                        if (typeof object.message_type[i] !== "object")
                            throw TypeError(".google.protobuf.FileDescriptorProto.message_type: object expected");
                        message.message_type[i] = $root.google.protobuf.DescriptorProto.fromObject(object.message_type[i]);
                    }
                }
                if (object.enum_type) {
                    if (!Array.isArray(object.enum_type))
                        throw TypeError(".google.protobuf.FileDescriptorProto.enum_type: array expected");
                    message.enum_type = [];
                    for (var i = 0; i < object.enum_type.length; ++i) {
                        if (typeof object.enum_type[i] !== "object")
                            throw TypeError(".google.protobuf.FileDescriptorProto.enum_type: object expected");
                        message.enum_type[i] = $root.google.protobuf.EnumDescriptorProto.fromObject(object.enum_type[i]);
                    }
                }
                if (object.service) {
                    if (!Array.isArray(object.service))
                        throw TypeError(".google.protobuf.FileDescriptorProto.service: array expected");
                    message.service = [];
                    for (var i = 0; i < object.service.length; ++i) {
                        if (typeof object.service[i] !== "object")
                            throw TypeError(".google.protobuf.FileDescriptorProto.service: object expected");
                        message.service[i] = $root.google.protobuf.ServiceDescriptorProto.fromObject(object.service[i]);
                    }
                }
                if (object.extension) {
                    if (!Array.isArray(object.extension))
                        throw TypeError(".google.protobuf.FileDescriptorProto.extension: array expected");
                    message.extension = [];
                    for (var i = 0; i < object.extension.length; ++i) {
                        if (typeof object.extension[i] !== "object")
                            throw TypeError(".google.protobuf.FileDescriptorProto.extension: object expected");
                        message.extension[i] = $root.google.protobuf.FieldDescriptorProto.fromObject(object.extension[i]);
                    }
                }
                if (object.options != null) {
                    if (typeof object.options !== "object")
                        throw TypeError(".google.protobuf.FileDescriptorProto.options: object expected");
                    message.options = $root.google.protobuf.FileOptions.fromObject(object.options);
                }
                if (object.source_code_info != null) {
                    if (typeof object.source_code_info !== "object")
                        throw TypeError(".google.protobuf.FileDescriptorProto.source_code_info: object expected");
                    message.source_code_info = $root.google.protobuf.SourceCodeInfo.fromObject(object.source_code_info);
                }
                if (object.syntax != null)
                    message.syntax = String(object.syntax);
                return message;
            };

            FileDescriptorProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults) {
                    object.dependency = [];
                    object.message_type = [];
                    object.enum_type = [];
                    object.service = [];
                    object.extension = [];
                    object.public_dependency = [];
                    object.weak_dependency = [];
                }
                if (options.defaults) {
                    object.name = "";
                    object["package"] = "";
                    object.options = null;
                    object.source_code_info = null;
                    object.syntax = "";
                }
                if (message.name != null && message.hasOwnProperty("name"))
                    object.name = message.name;
                if (message["package"] != null && message.hasOwnProperty("package"))
                    object["package"] = message["package"];
                if (message.dependency && message.dependency.length) {
                    object.dependency = [];
                    for (var j = 0; j < message.dependency.length; ++j)
                        object.dependency[j] = message.dependency[j];
                }
                if (message.message_type && message.message_type.length) {
                    object.message_type = [];
                    for (var j = 0; j < message.message_type.length; ++j)
                        object.message_type[j] = $root.google.protobuf.DescriptorProto.toObject(message.message_type[j], options);
                }
                if (message.enum_type && message.enum_type.length) {
                    object.enum_type = [];
                    for (var j = 0; j < message.enum_type.length; ++j)
                        object.enum_type[j] = $root.google.protobuf.EnumDescriptorProto.toObject(message.enum_type[j], options);
                }
                if (message.service && message.service.length) {
                    object.service = [];
                    for (var j = 0; j < message.service.length; ++j)
                        object.service[j] = $root.google.protobuf.ServiceDescriptorProto.toObject(message.service[j], options);
                }
                if (message.extension && message.extension.length) {
                    object.extension = [];
                    for (var j = 0; j < message.extension.length; ++j)
                        object.extension[j] = $root.google.protobuf.FieldDescriptorProto.toObject(message.extension[j], options);
                }
                if (message.options != null && message.hasOwnProperty("options"))
                    object.options = $root.google.protobuf.FileOptions.toObject(message.options, options);
                if (message.source_code_info != null && message.hasOwnProperty("source_code_info"))
                    object.source_code_info = $root.google.protobuf.SourceCodeInfo.toObject(message.source_code_info, options);
                if (message.public_dependency && message.public_dependency.length) {
                    object.public_dependency = [];
                    for (var j = 0; j < message.public_dependency.length; ++j)
                        object.public_dependency[j] = message.public_dependency[j];
                }
                if (message.weak_dependency && message.weak_dependency.length) {
                    object.weak_dependency = [];
                    for (var j = 0; j < message.weak_dependency.length; ++j)
                        object.weak_dependency[j] = message.weak_dependency[j];
                }
                if (message.syntax != null && message.hasOwnProperty("syntax"))
                    object.syntax = message.syntax;
                return object;
            };

            FileDescriptorProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return FileDescriptorProto;
        })();

        protobuf.DescriptorProto = (function() {

            function DescriptorProto(properties) {
                this.field = [];
                this.extension = [];
                this.nested_type = [];
                this.enum_type = [];
                this.extension_range = [];
                this.oneof_decl = [];
                this.reserved_range = [];
                this.reserved_name = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            DescriptorProto.prototype.name = "";
            DescriptorProto.prototype.field = $util.emptyArray;
            DescriptorProto.prototype.extension = $util.emptyArray;
            DescriptorProto.prototype.nested_type = $util.emptyArray;
            DescriptorProto.prototype.enum_type = $util.emptyArray;
            DescriptorProto.prototype.extension_range = $util.emptyArray;
            DescriptorProto.prototype.oneof_decl = $util.emptyArray;
            DescriptorProto.prototype.options = null;
            DescriptorProto.prototype.reserved_range = $util.emptyArray;
            DescriptorProto.prototype.reserved_name = $util.emptyArray;

            DescriptorProto.create = function create(properties) {
                return new DescriptorProto(properties);
            };

            DescriptorProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                    writer.uint32(10).string(message.name);
                if (message.field != null && message.field.length)
                    for (var i = 0; i < message.field.length; ++i)
                        $root.google.protobuf.FieldDescriptorProto.encode(message.field[i], writer.uint32(18).fork()).ldelim();
                if (message.nested_type != null && message.nested_type.length)
                    for (var i = 0; i < message.nested_type.length; ++i)
                        $root.google.protobuf.DescriptorProto.encode(message.nested_type[i], writer.uint32(26).fork()).ldelim();
                if (message.enum_type != null && message.enum_type.length)
                    for (var i = 0; i < message.enum_type.length; ++i)
                        $root.google.protobuf.EnumDescriptorProto.encode(message.enum_type[i], writer.uint32(34).fork()).ldelim();
                if (message.extension_range != null && message.extension_range.length)
                    for (var i = 0; i < message.extension_range.length; ++i)
                        $root.google.protobuf.DescriptorProto.ExtensionRange.encode(message.extension_range[i], writer.uint32(42).fork()).ldelim();
                if (message.extension != null && message.extension.length)
                    for (var i = 0; i < message.extension.length; ++i)
                        $root.google.protobuf.FieldDescriptorProto.encode(message.extension[i], writer.uint32(50).fork()).ldelim();
                if (message.options != null && Object.hasOwnProperty.call(message, "options"))
                    $root.google.protobuf.MessageOptions.encode(message.options, writer.uint32(58).fork()).ldelim();
                if (message.oneof_decl != null && message.oneof_decl.length)
                    for (var i = 0; i < message.oneof_decl.length; ++i)
                        $root.google.protobuf.OneofDescriptorProto.encode(message.oneof_decl[i], writer.uint32(66).fork()).ldelim();
                if (message.reserved_range != null && message.reserved_range.length)
                    for (var i = 0; i < message.reserved_range.length; ++i)
                        $root.google.protobuf.DescriptorProto.ReservedRange.encode(message.reserved_range[i], writer.uint32(74).fork()).ldelim();
                if (message.reserved_name != null && message.reserved_name.length)
                    for (var i = 0; i < message.reserved_name.length; ++i)
                        writer.uint32(82).string(message.reserved_name[i]);
                return writer;
            };

            DescriptorProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            DescriptorProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.DescriptorProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.name = reader.string();
                        break;
                    case 2:
                        if (!(message.field && message.field.length))
                            message.field = [];
                        message.field.push($root.google.protobuf.FieldDescriptorProto.decode(reader, reader.uint32()));
                        break;
                    case 6:
                        if (!(message.extension && message.extension.length))
                            message.extension = [];
                        message.extension.push($root.google.protobuf.FieldDescriptorProto.decode(reader, reader.uint32()));
                        break;
                    case 3:
                        if (!(message.nested_type && message.nested_type.length))
                            message.nested_type = [];
                        message.nested_type.push($root.google.protobuf.DescriptorProto.decode(reader, reader.uint32()));
                        break;
                    case 4:
                        if (!(message.enum_type && message.enum_type.length))
                            message.enum_type = [];
                        message.enum_type.push($root.google.protobuf.EnumDescriptorProto.decode(reader, reader.uint32()));
                        break;
                    case 5:
                        if (!(message.extension_range && message.extension_range.length))
                            message.extension_range = [];
                        message.extension_range.push($root.google.protobuf.DescriptorProto.ExtensionRange.decode(reader, reader.uint32()));
                        break;
                    case 8:
                        if (!(message.oneof_decl && message.oneof_decl.length))
                            message.oneof_decl = [];
                        message.oneof_decl.push($root.google.protobuf.OneofDescriptorProto.decode(reader, reader.uint32()));
                        break;
                    case 7:
                        message.options = $root.google.protobuf.MessageOptions.decode(reader, reader.uint32());
                        break;
                    case 9:
                        if (!(message.reserved_range && message.reserved_range.length))
                            message.reserved_range = [];
                        message.reserved_range.push($root.google.protobuf.DescriptorProto.ReservedRange.decode(reader, reader.uint32()));
                        break;
                    case 10:
                        if (!(message.reserved_name && message.reserved_name.length))
                            message.reserved_name = [];
                        message.reserved_name.push(reader.string());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            DescriptorProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            DescriptorProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.name != null && message.hasOwnProperty("name"))
                    if (!$util.isString(message.name))
                        return "name: string expected";
                if (message.field != null && message.hasOwnProperty("field")) {
                    if (!Array.isArray(message.field))
                        return "field: array expected";
                    for (var i = 0; i < message.field.length; ++i) {
                        var error = $root.google.protobuf.FieldDescriptorProto.verify(message.field[i]);
                        if (error)
                            return "field." + error;
                    }
                }
                if (message.extension != null && message.hasOwnProperty("extension")) {
                    if (!Array.isArray(message.extension))
                        return "extension: array expected";
                    for (var i = 0; i < message.extension.length; ++i) {
                        var error = $root.google.protobuf.FieldDescriptorProto.verify(message.extension[i]);
                        if (error)
                            return "extension." + error;
                    }
                }
                if (message.nested_type != null && message.hasOwnProperty("nested_type")) {
                    if (!Array.isArray(message.nested_type))
                        return "nested_type: array expected";
                    for (var i = 0; i < message.nested_type.length; ++i) {
                        var error = $root.google.protobuf.DescriptorProto.verify(message.nested_type[i]);
                        if (error)
                            return "nested_type." + error;
                    }
                }
                if (message.enum_type != null && message.hasOwnProperty("enum_type")) {
                    if (!Array.isArray(message.enum_type))
                        return "enum_type: array expected";
                    for (var i = 0; i < message.enum_type.length; ++i) {
                        var error = $root.google.protobuf.EnumDescriptorProto.verify(message.enum_type[i]);
                        if (error)
                            return "enum_type." + error;
                    }
                }
                if (message.extension_range != null && message.hasOwnProperty("extension_range")) {
                    if (!Array.isArray(message.extension_range))
                        return "extension_range: array expected";
                    for (var i = 0; i < message.extension_range.length; ++i) {
                        var error = $root.google.protobuf.DescriptorProto.ExtensionRange.verify(message.extension_range[i]);
                        if (error)
                            return "extension_range." + error;
                    }
                }
                if (message.oneof_decl != null && message.hasOwnProperty("oneof_decl")) {
                    if (!Array.isArray(message.oneof_decl))
                        return "oneof_decl: array expected";
                    for (var i = 0; i < message.oneof_decl.length; ++i) {
                        var error = $root.google.protobuf.OneofDescriptorProto.verify(message.oneof_decl[i]);
                        if (error)
                            return "oneof_decl." + error;
                    }
                }
                if (message.options != null && message.hasOwnProperty("options")) {
                    var error = $root.google.protobuf.MessageOptions.verify(message.options);
                    if (error)
                        return "options." + error;
                }
                if (message.reserved_range != null && message.hasOwnProperty("reserved_range")) {
                    if (!Array.isArray(message.reserved_range))
                        return "reserved_range: array expected";
                    for (var i = 0; i < message.reserved_range.length; ++i) {
                        var error = $root.google.protobuf.DescriptorProto.ReservedRange.verify(message.reserved_range[i]);
                        if (error)
                            return "reserved_range." + error;
                    }
                }
                if (message.reserved_name != null && message.hasOwnProperty("reserved_name")) {
                    if (!Array.isArray(message.reserved_name))
                        return "reserved_name: array expected";
                    for (var i = 0; i < message.reserved_name.length; ++i)
                        if (!$util.isString(message.reserved_name[i]))
                            return "reserved_name: string[] expected";
                }
                return null;
            };

            DescriptorProto.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.DescriptorProto)
                    return object;
                var message = new $root.google.protobuf.DescriptorProto();
                if (object.name != null)
                    message.name = String(object.name);
                if (object.field) {
                    if (!Array.isArray(object.field))
                        throw TypeError(".google.protobuf.DescriptorProto.field: array expected");
                    message.field = [];
                    for (var i = 0; i < object.field.length; ++i) {
                        if (typeof object.field[i] !== "object")
                            throw TypeError(".google.protobuf.DescriptorProto.field: object expected");
                        message.field[i] = $root.google.protobuf.FieldDescriptorProto.fromObject(object.field[i]);
                    }
                }
                if (object.extension) {
                    if (!Array.isArray(object.extension))
                        throw TypeError(".google.protobuf.DescriptorProto.extension: array expected");
                    message.extension = [];
                    for (var i = 0; i < object.extension.length; ++i) {
                        if (typeof object.extension[i] !== "object")
                            throw TypeError(".google.protobuf.DescriptorProto.extension: object expected");
                        message.extension[i] = $root.google.protobuf.FieldDescriptorProto.fromObject(object.extension[i]);
                    }
                }
                if (object.nested_type) {
                    if (!Array.isArray(object.nested_type))
                        throw TypeError(".google.protobuf.DescriptorProto.nested_type: array expected");
                    message.nested_type = [];
                    for (var i = 0; i < object.nested_type.length; ++i) {
                        if (typeof object.nested_type[i] !== "object")
                            throw TypeError(".google.protobuf.DescriptorProto.nested_type: object expected");
                        message.nested_type[i] = $root.google.protobuf.DescriptorProto.fromObject(object.nested_type[i]);
                    }
                }
                if (object.enum_type) {
                    if (!Array.isArray(object.enum_type))
                        throw TypeError(".google.protobuf.DescriptorProto.enum_type: array expected");
                    message.enum_type = [];
                    for (var i = 0; i < object.enum_type.length; ++i) {
                        if (typeof object.enum_type[i] !== "object")
                            throw TypeError(".google.protobuf.DescriptorProto.enum_type: object expected");
                        message.enum_type[i] = $root.google.protobuf.EnumDescriptorProto.fromObject(object.enum_type[i]);
                    }
                }
                if (object.extension_range) {
                    if (!Array.isArray(object.extension_range))
                        throw TypeError(".google.protobuf.DescriptorProto.extension_range: array expected");
                    message.extension_range = [];
                    for (var i = 0; i < object.extension_range.length; ++i) {
                        if (typeof object.extension_range[i] !== "object")
                            throw TypeError(".google.protobuf.DescriptorProto.extension_range: object expected");
                        message.extension_range[i] = $root.google.protobuf.DescriptorProto.ExtensionRange.fromObject(object.extension_range[i]);
                    }
                }
                if (object.oneof_decl) {
                    if (!Array.isArray(object.oneof_decl))
                        throw TypeError(".google.protobuf.DescriptorProto.oneof_decl: array expected");
                    message.oneof_decl = [];
                    for (var i = 0; i < object.oneof_decl.length; ++i) {
                        if (typeof object.oneof_decl[i] !== "object")
                            throw TypeError(".google.protobuf.DescriptorProto.oneof_decl: object expected");
                        message.oneof_decl[i] = $root.google.protobuf.OneofDescriptorProto.fromObject(object.oneof_decl[i]);
                    }
                }
                if (object.options != null) {
                    if (typeof object.options !== "object")
                        throw TypeError(".google.protobuf.DescriptorProto.options: object expected");
                    message.options = $root.google.protobuf.MessageOptions.fromObject(object.options);
                }
                if (object.reserved_range) {
                    if (!Array.isArray(object.reserved_range))
                        throw TypeError(".google.protobuf.DescriptorProto.reserved_range: array expected");
                    message.reserved_range = [];
                    for (var i = 0; i < object.reserved_range.length; ++i) {
                        if (typeof object.reserved_range[i] !== "object")
                            throw TypeError(".google.protobuf.DescriptorProto.reserved_range: object expected");
                        message.reserved_range[i] = $root.google.protobuf.DescriptorProto.ReservedRange.fromObject(object.reserved_range[i]);
                    }
                }
                if (object.reserved_name) {
                    if (!Array.isArray(object.reserved_name))
                        throw TypeError(".google.protobuf.DescriptorProto.reserved_name: array expected");
                    message.reserved_name = [];
                    for (var i = 0; i < object.reserved_name.length; ++i)
                        message.reserved_name[i] = String(object.reserved_name[i]);
                }
                return message;
            };

            DescriptorProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults) {
                    object.field = [];
                    object.nested_type = [];
                    object.enum_type = [];
                    object.extension_range = [];
                    object.extension = [];
                    object.oneof_decl = [];
                    object.reserved_range = [];
                    object.reserved_name = [];
                }
                if (options.defaults) {
                    object.name = "";
                    object.options = null;
                }
                if (message.name != null && message.hasOwnProperty("name"))
                    object.name = message.name;
                if (message.field && message.field.length) {
                    object.field = [];
                    for (var j = 0; j < message.field.length; ++j)
                        object.field[j] = $root.google.protobuf.FieldDescriptorProto.toObject(message.field[j], options);
                }
                if (message.nested_type && message.nested_type.length) {
                    object.nested_type = [];
                    for (var j = 0; j < message.nested_type.length; ++j)
                        object.nested_type[j] = $root.google.protobuf.DescriptorProto.toObject(message.nested_type[j], options);
                }
                if (message.enum_type && message.enum_type.length) {
                    object.enum_type = [];
                    for (var j = 0; j < message.enum_type.length; ++j)
                        object.enum_type[j] = $root.google.protobuf.EnumDescriptorProto.toObject(message.enum_type[j], options);
                }
                if (message.extension_range && message.extension_range.length) {
                    object.extension_range = [];
                    for (var j = 0; j < message.extension_range.length; ++j)
                        object.extension_range[j] = $root.google.protobuf.DescriptorProto.ExtensionRange.toObject(message.extension_range[j], options);
                }
                if (message.extension && message.extension.length) {
                    object.extension = [];
                    for (var j = 0; j < message.extension.length; ++j)
                        object.extension[j] = $root.google.protobuf.FieldDescriptorProto.toObject(message.extension[j], options);
                }
                if (message.options != null && message.hasOwnProperty("options"))
                    object.options = $root.google.protobuf.MessageOptions.toObject(message.options, options);
                if (message.oneof_decl && message.oneof_decl.length) {
                    object.oneof_decl = [];
                    for (var j = 0; j < message.oneof_decl.length; ++j)
                        object.oneof_decl[j] = $root.google.protobuf.OneofDescriptorProto.toObject(message.oneof_decl[j], options);
                }
                if (message.reserved_range && message.reserved_range.length) {
                    object.reserved_range = [];
                    for (var j = 0; j < message.reserved_range.length; ++j)
                        object.reserved_range[j] = $root.google.protobuf.DescriptorProto.ReservedRange.toObject(message.reserved_range[j], options);
                }
                if (message.reserved_name && message.reserved_name.length) {
                    object.reserved_name = [];
                    for (var j = 0; j < message.reserved_name.length; ++j)
                        object.reserved_name[j] = message.reserved_name[j];
                }
                return object;
            };

            DescriptorProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            DescriptorProto.ExtensionRange = (function() {

                function ExtensionRange(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                ExtensionRange.prototype.start = 0;
                ExtensionRange.prototype.end = 0;

                ExtensionRange.create = function create(properties) {
                    return new ExtensionRange(properties);
                };

                ExtensionRange.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.start != null && Object.hasOwnProperty.call(message, "start"))
                        writer.uint32(8).int32(message.start);
                    if (message.end != null && Object.hasOwnProperty.call(message, "end"))
                        writer.uint32(16).int32(message.end);
                    return writer;
                };

                ExtensionRange.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                ExtensionRange.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.DescriptorProto.ExtensionRange();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.start = reader.int32();
                            break;
                        case 2:
                            message.end = reader.int32();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                ExtensionRange.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                ExtensionRange.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.start != null && message.hasOwnProperty("start"))
                        if (!$util.isInteger(message.start))
                            return "start: integer expected";
                    if (message.end != null && message.hasOwnProperty("end"))
                        if (!$util.isInteger(message.end))
                            return "end: integer expected";
                    return null;
                };

                ExtensionRange.fromObject = function fromObject(object) {
                    if (object instanceof $root.google.protobuf.DescriptorProto.ExtensionRange)
                        return object;
                    var message = new $root.google.protobuf.DescriptorProto.ExtensionRange();
                    if (object.start != null)
                        message.start = object.start | 0;
                    if (object.end != null)
                        message.end = object.end | 0;
                    return message;
                };

                ExtensionRange.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.start = 0;
                        object.end = 0;
                    }
                    if (message.start != null && message.hasOwnProperty("start"))
                        object.start = message.start;
                    if (message.end != null && message.hasOwnProperty("end"))
                        object.end = message.end;
                    return object;
                };

                ExtensionRange.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return ExtensionRange;
            })();

            DescriptorProto.ReservedRange = (function() {

                function ReservedRange(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                ReservedRange.prototype.start = 0;
                ReservedRange.prototype.end = 0;

                ReservedRange.create = function create(properties) {
                    return new ReservedRange(properties);
                };

                ReservedRange.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.start != null && Object.hasOwnProperty.call(message, "start"))
                        writer.uint32(8).int32(message.start);
                    if (message.end != null && Object.hasOwnProperty.call(message, "end"))
                        writer.uint32(16).int32(message.end);
                    return writer;
                };

                ReservedRange.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                ReservedRange.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.DescriptorProto.ReservedRange();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.start = reader.int32();
                            break;
                        case 2:
                            message.end = reader.int32();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                ReservedRange.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                ReservedRange.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.start != null && message.hasOwnProperty("start"))
                        if (!$util.isInteger(message.start))
                            return "start: integer expected";
                    if (message.end != null && message.hasOwnProperty("end"))
                        if (!$util.isInteger(message.end))
                            return "end: integer expected";
                    return null;
                };

                ReservedRange.fromObject = function fromObject(object) {
                    if (object instanceof $root.google.protobuf.DescriptorProto.ReservedRange)
                        return object;
                    var message = new $root.google.protobuf.DescriptorProto.ReservedRange();
                    if (object.start != null)
                        message.start = object.start | 0;
                    if (object.end != null)
                        message.end = object.end | 0;
                    return message;
                };

                ReservedRange.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.start = 0;
                        object.end = 0;
                    }
                    if (message.start != null && message.hasOwnProperty("start"))
                        object.start = message.start;
                    if (message.end != null && message.hasOwnProperty("end"))
                        object.end = message.end;
                    return object;
                };

                ReservedRange.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return ReservedRange;
            })();

            return DescriptorProto;
        })();

        protobuf.FieldDescriptorProto = (function() {

            function FieldDescriptorProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            FieldDescriptorProto.prototype.name = "";
            FieldDescriptorProto.prototype.number = 0;
            FieldDescriptorProto.prototype.label = 1;
            FieldDescriptorProto.prototype.type = 1;
            FieldDescriptorProto.prototype.type_name = "";
            FieldDescriptorProto.prototype.extendee = "";
            FieldDescriptorProto.prototype.default_value = "";
            FieldDescriptorProto.prototype.oneof_index = 0;
            FieldDescriptorProto.prototype.json_name = "";
            FieldDescriptorProto.prototype.options = null;

            FieldDescriptorProto.create = function create(properties) {
                return new FieldDescriptorProto(properties);
            };

            FieldDescriptorProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                    writer.uint32(10).string(message.name);
                if (message.extendee != null && Object.hasOwnProperty.call(message, "extendee"))
                    writer.uint32(18).string(message.extendee);
                if (message.number != null && Object.hasOwnProperty.call(message, "number"))
                    writer.uint32(24).int32(message.number);
                if (message.label != null && Object.hasOwnProperty.call(message, "label"))
                    writer.uint32(32).int32(message.label);
                if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                    writer.uint32(40).int32(message.type);
                if (message.type_name != null && Object.hasOwnProperty.call(message, "type_name"))
                    writer.uint32(50).string(message.type_name);
                if (message.default_value != null && Object.hasOwnProperty.call(message, "default_value"))
                    writer.uint32(58).string(message.default_value);
                if (message.options != null && Object.hasOwnProperty.call(message, "options"))
                    $root.google.protobuf.FieldOptions.encode(message.options, writer.uint32(66).fork()).ldelim();
                if (message.oneof_index != null && Object.hasOwnProperty.call(message, "oneof_index"))
                    writer.uint32(72).int32(message.oneof_index);
                if (message.json_name != null && Object.hasOwnProperty.call(message, "json_name"))
                    writer.uint32(82).string(message.json_name);
                return writer;
            };

            FieldDescriptorProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            FieldDescriptorProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.FieldDescriptorProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.name = reader.string();
                        break;
                    case 3:
                        message.number = reader.int32();
                        break;
                    case 4:
                        message.label = reader.int32();
                        break;
                    case 5:
                        message.type = reader.int32();
                        break;
                    case 6:
                        message.type_name = reader.string();
                        break;
                    case 2:
                        message.extendee = reader.string();
                        break;
                    case 7:
                        message.default_value = reader.string();
                        break;
                    case 9:
                        message.oneof_index = reader.int32();
                        break;
                    case 10:
                        message.json_name = reader.string();
                        break;
                    case 8:
                        message.options = $root.google.protobuf.FieldOptions.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            FieldDescriptorProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            FieldDescriptorProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.name != null && message.hasOwnProperty("name"))
                    if (!$util.isString(message.name))
                        return "name: string expected";
                if (message.number != null && message.hasOwnProperty("number"))
                    if (!$util.isInteger(message.number))
                        return "number: integer expected";
                if (message.label != null && message.hasOwnProperty("label"))
                    switch (message.label) {
                    default:
                        return "label: enum value expected";
                    case 1:
                    case 2:
                    case 3:
                        break;
                    }
                if (message.type != null && message.hasOwnProperty("type"))
                    switch (message.type) {
                    default:
                        return "type: enum value expected";
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                    case 6:
                    case 7:
                    case 8:
                    case 9:
                    case 10:
                    case 11:
                    case 12:
                    case 13:
                    case 14:
                    case 15:
                    case 16:
                    case 17:
                    case 18:
                        break;
                    }
                if (message.type_name != null && message.hasOwnProperty("type_name"))
                    if (!$util.isString(message.type_name))
                        return "type_name: string expected";
                if (message.extendee != null && message.hasOwnProperty("extendee"))
                    if (!$util.isString(message.extendee))
                        return "extendee: string expected";
                if (message.default_value != null && message.hasOwnProperty("default_value"))
                    if (!$util.isString(message.default_value))
                        return "default_value: string expected";
                if (message.oneof_index != null && message.hasOwnProperty("oneof_index"))
                    if (!$util.isInteger(message.oneof_index))
                        return "oneof_index: integer expected";
                if (message.json_name != null && message.hasOwnProperty("json_name"))
                    if (!$util.isString(message.json_name))
                        return "json_name: string expected";
                if (message.options != null && message.hasOwnProperty("options")) {
                    var error = $root.google.protobuf.FieldOptions.verify(message.options);
                    if (error)
                        return "options." + error;
                }
                return null;
            };

            FieldDescriptorProto.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.FieldDescriptorProto)
                    return object;
                var message = new $root.google.protobuf.FieldDescriptorProto();
                if (object.name != null)
                    message.name = String(object.name);
                if (object.number != null)
                    message.number = object.number | 0;
                switch (object.label) {
                case "LABEL_OPTIONAL":
                case 1:
                    message.label = 1;
                    break;
                case "LABEL_REQUIRED":
                case 2:
                    message.label = 2;
                    break;
                case "LABEL_REPEATED":
                case 3:
                    message.label = 3;
                    break;
                }
                switch (object.type) {
                case "TYPE_DOUBLE":
                case 1:
                    message.type = 1;
                    break;
                case "TYPE_FLOAT":
                case 2:
                    message.type = 2;
                    break;
                case "TYPE_INT64":
                case 3:
                    message.type = 3;
                    break;
                case "TYPE_UINT64":
                case 4:
                    message.type = 4;
                    break;
                case "TYPE_INT32":
                case 5:
                    message.type = 5;
                    break;
                case "TYPE_FIXED64":
                case 6:
                    message.type = 6;
                    break;
                case "TYPE_FIXED32":
                case 7:
                    message.type = 7;
                    break;
                case "TYPE_BOOL":
                case 8:
                    message.type = 8;
                    break;
                case "TYPE_STRING":
                case 9:
                    message.type = 9;
                    break;
                case "TYPE_GROUP":
                case 10:
                    message.type = 10;
                    break;
                case "TYPE_MESSAGE":
                case 11:
                    message.type = 11;
                    break;
                case "TYPE_BYTES":
                case 12:
                    message.type = 12;
                    break;
                case "TYPE_UINT32":
                case 13:
                    message.type = 13;
                    break;
                case "TYPE_ENUM":
                case 14:
                    message.type = 14;
                    break;
                case "TYPE_SFIXED32":
                case 15:
                    message.type = 15;
                    break;
                case "TYPE_SFIXED64":
                case 16:
                    message.type = 16;
                    break;
                case "TYPE_SINT32":
                case 17:
                    message.type = 17;
                    break;
                case "TYPE_SINT64":
                case 18:
                    message.type = 18;
                    break;
                }
                if (object.type_name != null)
                    message.type_name = String(object.type_name);
                if (object.extendee != null)
                    message.extendee = String(object.extendee);
                if (object.default_value != null)
                    message.default_value = String(object.default_value);
                if (object.oneof_index != null)
                    message.oneof_index = object.oneof_index | 0;
                if (object.json_name != null)
                    message.json_name = String(object.json_name);
                if (object.options != null) {
                    if (typeof object.options !== "object")
                        throw TypeError(".google.protobuf.FieldDescriptorProto.options: object expected");
                    message.options = $root.google.protobuf.FieldOptions.fromObject(object.options);
                }
                return message;
            };

            FieldDescriptorProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.name = "";
                    object.extendee = "";
                    object.number = 0;
                    object.label = options.enums === String ? "LABEL_OPTIONAL" : 1;
                    object.type = options.enums === String ? "TYPE_DOUBLE" : 1;
                    object.type_name = "";
                    object.default_value = "";
                    object.options = null;
                    object.oneof_index = 0;
                    object.json_name = "";
                }
                if (message.name != null && message.hasOwnProperty("name"))
                    object.name = message.name;
                if (message.extendee != null && message.hasOwnProperty("extendee"))
                    object.extendee = message.extendee;
                if (message.number != null && message.hasOwnProperty("number"))
                    object.number = message.number;
                if (message.label != null && message.hasOwnProperty("label"))
                    object.label = options.enums === String ? $root.google.protobuf.FieldDescriptorProto.Label[message.label] : message.label;
                if (message.type != null && message.hasOwnProperty("type"))
                    object.type = options.enums === String ? $root.google.protobuf.FieldDescriptorProto.Type[message.type] : message.type;
                if (message.type_name != null && message.hasOwnProperty("type_name"))
                    object.type_name = message.type_name;
                if (message.default_value != null && message.hasOwnProperty("default_value"))
                    object.default_value = message.default_value;
                if (message.options != null && message.hasOwnProperty("options"))
                    object.options = $root.google.protobuf.FieldOptions.toObject(message.options, options);
                if (message.oneof_index != null && message.hasOwnProperty("oneof_index"))
                    object.oneof_index = message.oneof_index;
                if (message.json_name != null && message.hasOwnProperty("json_name"))
                    object.json_name = message.json_name;
                return object;
            };

            FieldDescriptorProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            FieldDescriptorProto.Type = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[1] = "TYPE_DOUBLE"] = 1;
                values[valuesById[2] = "TYPE_FLOAT"] = 2;
                values[valuesById[3] = "TYPE_INT64"] = 3;
                values[valuesById[4] = "TYPE_UINT64"] = 4;
                values[valuesById[5] = "TYPE_INT32"] = 5;
                values[valuesById[6] = "TYPE_FIXED64"] = 6;
                values[valuesById[7] = "TYPE_FIXED32"] = 7;
                values[valuesById[8] = "TYPE_BOOL"] = 8;
                values[valuesById[9] = "TYPE_STRING"] = 9;
                values[valuesById[10] = "TYPE_GROUP"] = 10;
                values[valuesById[11] = "TYPE_MESSAGE"] = 11;
                values[valuesById[12] = "TYPE_BYTES"] = 12;
                values[valuesById[13] = "TYPE_UINT32"] = 13;
                values[valuesById[14] = "TYPE_ENUM"] = 14;
                values[valuesById[15] = "TYPE_SFIXED32"] = 15;
                values[valuesById[16] = "TYPE_SFIXED64"] = 16;
                values[valuesById[17] = "TYPE_SINT32"] = 17;
                values[valuesById[18] = "TYPE_SINT64"] = 18;
                return values;
            })();

            FieldDescriptorProto.Label = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[1] = "LABEL_OPTIONAL"] = 1;
                values[valuesById[2] = "LABEL_REQUIRED"] = 2;
                values[valuesById[3] = "LABEL_REPEATED"] = 3;
                return values;
            })();

            return FieldDescriptorProto;
        })();

        protobuf.OneofDescriptorProto = (function() {

            function OneofDescriptorProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            OneofDescriptorProto.prototype.name = "";
            OneofDescriptorProto.prototype.options = null;

            OneofDescriptorProto.create = function create(properties) {
                return new OneofDescriptorProto(properties);
            };

            OneofDescriptorProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                    writer.uint32(10).string(message.name);
                if (message.options != null && Object.hasOwnProperty.call(message, "options"))
                    $root.google.protobuf.OneofOptions.encode(message.options, writer.uint32(18).fork()).ldelim();
                return writer;
            };

            OneofDescriptorProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            OneofDescriptorProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.OneofDescriptorProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.name = reader.string();
                        break;
                    case 2:
                        message.options = $root.google.protobuf.OneofOptions.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            OneofDescriptorProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            OneofDescriptorProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.name != null && message.hasOwnProperty("name"))
                    if (!$util.isString(message.name))
                        return "name: string expected";
                if (message.options != null && message.hasOwnProperty("options")) {
                    var error = $root.google.protobuf.OneofOptions.verify(message.options);
                    if (error)
                        return "options." + error;
                }
                return null;
            };

            OneofDescriptorProto.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.OneofDescriptorProto)
                    return object;
                var message = new $root.google.protobuf.OneofDescriptorProto();
                if (object.name != null)
                    message.name = String(object.name);
                if (object.options != null) {
                    if (typeof object.options !== "object")
                        throw TypeError(".google.protobuf.OneofDescriptorProto.options: object expected");
                    message.options = $root.google.protobuf.OneofOptions.fromObject(object.options);
                }
                return message;
            };

            OneofDescriptorProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.name = "";
                    object.options = null;
                }
                if (message.name != null && message.hasOwnProperty("name"))
                    object.name = message.name;
                if (message.options != null && message.hasOwnProperty("options"))
                    object.options = $root.google.protobuf.OneofOptions.toObject(message.options, options);
                return object;
            };

            OneofDescriptorProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return OneofDescriptorProto;
        })();

        protobuf.EnumDescriptorProto = (function() {

            function EnumDescriptorProto(properties) {
                this.value = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            EnumDescriptorProto.prototype.name = "";
            EnumDescriptorProto.prototype.value = $util.emptyArray;
            EnumDescriptorProto.prototype.options = null;

            EnumDescriptorProto.create = function create(properties) {
                return new EnumDescriptorProto(properties);
            };

            EnumDescriptorProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                    writer.uint32(10).string(message.name);
                if (message.value != null && message.value.length)
                    for (var i = 0; i < message.value.length; ++i)
                        $root.google.protobuf.EnumValueDescriptorProto.encode(message.value[i], writer.uint32(18).fork()).ldelim();
                if (message.options != null && Object.hasOwnProperty.call(message, "options"))
                    $root.google.protobuf.EnumOptions.encode(message.options, writer.uint32(26).fork()).ldelim();
                return writer;
            };

            EnumDescriptorProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            EnumDescriptorProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.EnumDescriptorProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.name = reader.string();
                        break;
                    case 2:
                        if (!(message.value && message.value.length))
                            message.value = [];
                        message.value.push($root.google.protobuf.EnumValueDescriptorProto.decode(reader, reader.uint32()));
                        break;
                    case 3:
                        message.options = $root.google.protobuf.EnumOptions.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            EnumDescriptorProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            EnumDescriptorProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.name != null && message.hasOwnProperty("name"))
                    if (!$util.isString(message.name))
                        return "name: string expected";
                if (message.value != null && message.hasOwnProperty("value")) {
                    if (!Array.isArray(message.value))
                        return "value: array expected";
                    for (var i = 0; i < message.value.length; ++i) {
                        var error = $root.google.protobuf.EnumValueDescriptorProto.verify(message.value[i]);
                        if (error)
                            return "value." + error;
                    }
                }
                if (message.options != null && message.hasOwnProperty("options")) {
                    var error = $root.google.protobuf.EnumOptions.verify(message.options);
                    if (error)
                        return "options." + error;
                }
                return null;
            };

            EnumDescriptorProto.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.EnumDescriptorProto)
                    return object;
                var message = new $root.google.protobuf.EnumDescriptorProto();
                if (object.name != null)
                    message.name = String(object.name);
                if (object.value) {
                    if (!Array.isArray(object.value))
                        throw TypeError(".google.protobuf.EnumDescriptorProto.value: array expected");
                    message.value = [];
                    for (var i = 0; i < object.value.length; ++i) {
                        if (typeof object.value[i] !== "object")
                            throw TypeError(".google.protobuf.EnumDescriptorProto.value: object expected");
                        message.value[i] = $root.google.protobuf.EnumValueDescriptorProto.fromObject(object.value[i]);
                    }
                }
                if (object.options != null) {
                    if (typeof object.options !== "object")
                        throw TypeError(".google.protobuf.EnumDescriptorProto.options: object expected");
                    message.options = $root.google.protobuf.EnumOptions.fromObject(object.options);
                }
                return message;
            };

            EnumDescriptorProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.value = [];
                if (options.defaults) {
                    object.name = "";
                    object.options = null;
                }
                if (message.name != null && message.hasOwnProperty("name"))
                    object.name = message.name;
                if (message.value && message.value.length) {
                    object.value = [];
                    for (var j = 0; j < message.value.length; ++j)
                        object.value[j] = $root.google.protobuf.EnumValueDescriptorProto.toObject(message.value[j], options);
                }
                if (message.options != null && message.hasOwnProperty("options"))
                    object.options = $root.google.protobuf.EnumOptions.toObject(message.options, options);
                return object;
            };

            EnumDescriptorProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return EnumDescriptorProto;
        })();

        protobuf.EnumValueDescriptorProto = (function() {

            function EnumValueDescriptorProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            EnumValueDescriptorProto.prototype.name = "";
            EnumValueDescriptorProto.prototype.number = 0;
            EnumValueDescriptorProto.prototype.options = null;

            EnumValueDescriptorProto.create = function create(properties) {
                return new EnumValueDescriptorProto(properties);
            };

            EnumValueDescriptorProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                    writer.uint32(10).string(message.name);
                if (message.number != null && Object.hasOwnProperty.call(message, "number"))
                    writer.uint32(16).int32(message.number);
                if (message.options != null && Object.hasOwnProperty.call(message, "options"))
                    $root.google.protobuf.EnumValueOptions.encode(message.options, writer.uint32(26).fork()).ldelim();
                return writer;
            };

            EnumValueDescriptorProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            EnumValueDescriptorProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.EnumValueDescriptorProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.name = reader.string();
                        break;
                    case 2:
                        message.number = reader.int32();
                        break;
                    case 3:
                        message.options = $root.google.protobuf.EnumValueOptions.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            EnumValueDescriptorProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            EnumValueDescriptorProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.name != null && message.hasOwnProperty("name"))
                    if (!$util.isString(message.name))
                        return "name: string expected";
                if (message.number != null && message.hasOwnProperty("number"))
                    if (!$util.isInteger(message.number))
                        return "number: integer expected";
                if (message.options != null && message.hasOwnProperty("options")) {
                    var error = $root.google.protobuf.EnumValueOptions.verify(message.options);
                    if (error)
                        return "options." + error;
                }
                return null;
            };

            EnumValueDescriptorProto.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.EnumValueDescriptorProto)
                    return object;
                var message = new $root.google.protobuf.EnumValueDescriptorProto();
                if (object.name != null)
                    message.name = String(object.name);
                if (object.number != null)
                    message.number = object.number | 0;
                if (object.options != null) {
                    if (typeof object.options !== "object")
                        throw TypeError(".google.protobuf.EnumValueDescriptorProto.options: object expected");
                    message.options = $root.google.protobuf.EnumValueOptions.fromObject(object.options);
                }
                return message;
            };

            EnumValueDescriptorProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.name = "";
                    object.number = 0;
                    object.options = null;
                }
                if (message.name != null && message.hasOwnProperty("name"))
                    object.name = message.name;
                if (message.number != null && message.hasOwnProperty("number"))
                    object.number = message.number;
                if (message.options != null && message.hasOwnProperty("options"))
                    object.options = $root.google.protobuf.EnumValueOptions.toObject(message.options, options);
                return object;
            };

            EnumValueDescriptorProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return EnumValueDescriptorProto;
        })();

        protobuf.ServiceDescriptorProto = (function() {

            function ServiceDescriptorProto(properties) {
                this.method = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            ServiceDescriptorProto.prototype.name = "";
            ServiceDescriptorProto.prototype.method = $util.emptyArray;
            ServiceDescriptorProto.prototype.options = null;

            ServiceDescriptorProto.create = function create(properties) {
                return new ServiceDescriptorProto(properties);
            };

            ServiceDescriptorProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                    writer.uint32(10).string(message.name);
                if (message.method != null && message.method.length)
                    for (var i = 0; i < message.method.length; ++i)
                        $root.google.protobuf.MethodDescriptorProto.encode(message.method[i], writer.uint32(18).fork()).ldelim();
                if (message.options != null && Object.hasOwnProperty.call(message, "options"))
                    $root.google.protobuf.ServiceOptions.encode(message.options, writer.uint32(26).fork()).ldelim();
                return writer;
            };

            ServiceDescriptorProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            ServiceDescriptorProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.ServiceDescriptorProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.name = reader.string();
                        break;
                    case 2:
                        if (!(message.method && message.method.length))
                            message.method = [];
                        message.method.push($root.google.protobuf.MethodDescriptorProto.decode(reader, reader.uint32()));
                        break;
                    case 3:
                        message.options = $root.google.protobuf.ServiceOptions.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            ServiceDescriptorProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            ServiceDescriptorProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.name != null && message.hasOwnProperty("name"))
                    if (!$util.isString(message.name))
                        return "name: string expected";
                if (message.method != null && message.hasOwnProperty("method")) {
                    if (!Array.isArray(message.method))
                        return "method: array expected";
                    for (var i = 0; i < message.method.length; ++i) {
                        var error = $root.google.protobuf.MethodDescriptorProto.verify(message.method[i]);
                        if (error)
                            return "method." + error;
                    }
                }
                if (message.options != null && message.hasOwnProperty("options")) {
                    var error = $root.google.protobuf.ServiceOptions.verify(message.options);
                    if (error)
                        return "options." + error;
                }
                return null;
            };

            ServiceDescriptorProto.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.ServiceDescriptorProto)
                    return object;
                var message = new $root.google.protobuf.ServiceDescriptorProto();
                if (object.name != null)
                    message.name = String(object.name);
                if (object.method) {
                    if (!Array.isArray(object.method))
                        throw TypeError(".google.protobuf.ServiceDescriptorProto.method: array expected");
                    message.method = [];
                    for (var i = 0; i < object.method.length; ++i) {
                        if (typeof object.method[i] !== "object")
                            throw TypeError(".google.protobuf.ServiceDescriptorProto.method: object expected");
                        message.method[i] = $root.google.protobuf.MethodDescriptorProto.fromObject(object.method[i]);
                    }
                }
                if (object.options != null) {
                    if (typeof object.options !== "object")
                        throw TypeError(".google.protobuf.ServiceDescriptorProto.options: object expected");
                    message.options = $root.google.protobuf.ServiceOptions.fromObject(object.options);
                }
                return message;
            };

            ServiceDescriptorProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.method = [];
                if (options.defaults) {
                    object.name = "";
                    object.options = null;
                }
                if (message.name != null && message.hasOwnProperty("name"))
                    object.name = message.name;
                if (message.method && message.method.length) {
                    object.method = [];
                    for (var j = 0; j < message.method.length; ++j)
                        object.method[j] = $root.google.protobuf.MethodDescriptorProto.toObject(message.method[j], options);
                }
                if (message.options != null && message.hasOwnProperty("options"))
                    object.options = $root.google.protobuf.ServiceOptions.toObject(message.options, options);
                return object;
            };

            ServiceDescriptorProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return ServiceDescriptorProto;
        })();

        protobuf.MethodDescriptorProto = (function() {

            function MethodDescriptorProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            MethodDescriptorProto.prototype.name = "";
            MethodDescriptorProto.prototype.input_type = "";
            MethodDescriptorProto.prototype.output_type = "";
            MethodDescriptorProto.prototype.options = null;
            MethodDescriptorProto.prototype.client_streaming = false;
            MethodDescriptorProto.prototype.server_streaming = false;

            MethodDescriptorProto.create = function create(properties) {
                return new MethodDescriptorProto(properties);
            };

            MethodDescriptorProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                    writer.uint32(10).string(message.name);
                if (message.input_type != null && Object.hasOwnProperty.call(message, "input_type"))
                    writer.uint32(18).string(message.input_type);
                if (message.output_type != null && Object.hasOwnProperty.call(message, "output_type"))
                    writer.uint32(26).string(message.output_type);
                if (message.options != null && Object.hasOwnProperty.call(message, "options"))
                    $root.google.protobuf.MethodOptions.encode(message.options, writer.uint32(34).fork()).ldelim();
                if (message.client_streaming != null && Object.hasOwnProperty.call(message, "client_streaming"))
                    writer.uint32(40).bool(message.client_streaming);
                if (message.server_streaming != null && Object.hasOwnProperty.call(message, "server_streaming"))
                    writer.uint32(48).bool(message.server_streaming);
                return writer;
            };

            MethodDescriptorProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            MethodDescriptorProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.MethodDescriptorProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.name = reader.string();
                        break;
                    case 2:
                        message.input_type = reader.string();
                        break;
                    case 3:
                        message.output_type = reader.string();
                        break;
                    case 4:
                        message.options = $root.google.protobuf.MethodOptions.decode(reader, reader.uint32());
                        break;
                    case 5:
                        message.client_streaming = reader.bool();
                        break;
                    case 6:
                        message.server_streaming = reader.bool();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            MethodDescriptorProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            MethodDescriptorProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.name != null && message.hasOwnProperty("name"))
                    if (!$util.isString(message.name))
                        return "name: string expected";
                if (message.input_type != null && message.hasOwnProperty("input_type"))
                    if (!$util.isString(message.input_type))
                        return "input_type: string expected";
                if (message.output_type != null && message.hasOwnProperty("output_type"))
                    if (!$util.isString(message.output_type))
                        return "output_type: string expected";
                if (message.options != null && message.hasOwnProperty("options")) {
                    var error = $root.google.protobuf.MethodOptions.verify(message.options);
                    if (error)
                        return "options." + error;
                }
                if (message.client_streaming != null && message.hasOwnProperty("client_streaming"))
                    if (typeof message.client_streaming !== "boolean")
                        return "client_streaming: boolean expected";
                if (message.server_streaming != null && message.hasOwnProperty("server_streaming"))
                    if (typeof message.server_streaming !== "boolean")
                        return "server_streaming: boolean expected";
                return null;
            };

            MethodDescriptorProto.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.MethodDescriptorProto)
                    return object;
                var message = new $root.google.protobuf.MethodDescriptorProto();
                if (object.name != null)
                    message.name = String(object.name);
                if (object.input_type != null)
                    message.input_type = String(object.input_type);
                if (object.output_type != null)
                    message.output_type = String(object.output_type);
                if (object.options != null) {
                    if (typeof object.options !== "object")
                        throw TypeError(".google.protobuf.MethodDescriptorProto.options: object expected");
                    message.options = $root.google.protobuf.MethodOptions.fromObject(object.options);
                }
                if (object.client_streaming != null)
                    message.client_streaming = Boolean(object.client_streaming);
                if (object.server_streaming != null)
                    message.server_streaming = Boolean(object.server_streaming);
                return message;
            };

            MethodDescriptorProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.name = "";
                    object.input_type = "";
                    object.output_type = "";
                    object.options = null;
                    object.client_streaming = false;
                    object.server_streaming = false;
                }
                if (message.name != null && message.hasOwnProperty("name"))
                    object.name = message.name;
                if (message.input_type != null && message.hasOwnProperty("input_type"))
                    object.input_type = message.input_type;
                if (message.output_type != null && message.hasOwnProperty("output_type"))
                    object.output_type = message.output_type;
                if (message.options != null && message.hasOwnProperty("options"))
                    object.options = $root.google.protobuf.MethodOptions.toObject(message.options, options);
                if (message.client_streaming != null && message.hasOwnProperty("client_streaming"))
                    object.client_streaming = message.client_streaming;
                if (message.server_streaming != null && message.hasOwnProperty("server_streaming"))
                    object.server_streaming = message.server_streaming;
                return object;
            };

            MethodDescriptorProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return MethodDescriptorProto;
        })();

        protobuf.FileOptions = (function() {

            function FileOptions(properties) {
                this.uninterpreted_option = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            FileOptions.prototype.java_package = "";
            FileOptions.prototype.java_outer_classname = "";
            FileOptions.prototype.java_multiple_files = false;
            FileOptions.prototype.java_generate_equals_and_hash = false;
            FileOptions.prototype.java_string_check_utf8 = false;
            FileOptions.prototype.optimize_for = 1;
            FileOptions.prototype.go_package = "";
            FileOptions.prototype.cc_generic_services = false;
            FileOptions.prototype.java_generic_services = false;
            FileOptions.prototype.py_generic_services = false;
            FileOptions.prototype.deprecated = false;
            FileOptions.prototype.cc_enable_arenas = false;
            FileOptions.prototype.objc_class_prefix = "";
            FileOptions.prototype.csharp_namespace = "";
            FileOptions.prototype.uninterpreted_option = $util.emptyArray;
            FileOptions.prototype[".include_in_bitcoin_only"] = false;

            FileOptions.create = function create(properties) {
                return new FileOptions(properties);
            };

            FileOptions.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.java_package != null && Object.hasOwnProperty.call(message, "java_package"))
                    writer.uint32(10).string(message.java_package);
                if (message.java_outer_classname != null && Object.hasOwnProperty.call(message, "java_outer_classname"))
                    writer.uint32(66).string(message.java_outer_classname);
                if (message.optimize_for != null && Object.hasOwnProperty.call(message, "optimize_for"))
                    writer.uint32(72).int32(message.optimize_for);
                if (message.java_multiple_files != null && Object.hasOwnProperty.call(message, "java_multiple_files"))
                    writer.uint32(80).bool(message.java_multiple_files);
                if (message.go_package != null && Object.hasOwnProperty.call(message, "go_package"))
                    writer.uint32(90).string(message.go_package);
                if (message.cc_generic_services != null && Object.hasOwnProperty.call(message, "cc_generic_services"))
                    writer.uint32(128).bool(message.cc_generic_services);
                if (message.java_generic_services != null && Object.hasOwnProperty.call(message, "java_generic_services"))
                    writer.uint32(136).bool(message.java_generic_services);
                if (message.py_generic_services != null && Object.hasOwnProperty.call(message, "py_generic_services"))
                    writer.uint32(144).bool(message.py_generic_services);
                if (message.java_generate_equals_and_hash != null && Object.hasOwnProperty.call(message, "java_generate_equals_and_hash"))
                    writer.uint32(160).bool(message.java_generate_equals_and_hash);
                if (message.deprecated != null && Object.hasOwnProperty.call(message, "deprecated"))
                    writer.uint32(184).bool(message.deprecated);
                if (message.java_string_check_utf8 != null && Object.hasOwnProperty.call(message, "java_string_check_utf8"))
                    writer.uint32(216).bool(message.java_string_check_utf8);
                if (message.cc_enable_arenas != null && Object.hasOwnProperty.call(message, "cc_enable_arenas"))
                    writer.uint32(248).bool(message.cc_enable_arenas);
                if (message.objc_class_prefix != null && Object.hasOwnProperty.call(message, "objc_class_prefix"))
                    writer.uint32(290).string(message.objc_class_prefix);
                if (message.csharp_namespace != null && Object.hasOwnProperty.call(message, "csharp_namespace"))
                    writer.uint32(298).string(message.csharp_namespace);
                if (message.uninterpreted_option != null && message.uninterpreted_option.length)
                    for (var i = 0; i < message.uninterpreted_option.length; ++i)
                        $root.google.protobuf.UninterpretedOption.encode(message.uninterpreted_option[i], writer.uint32(7994).fork()).ldelim();
                if (message[".include_in_bitcoin_only"] != null && Object.hasOwnProperty.call(message, ".include_in_bitcoin_only"))
                    writer.uint32(480000).bool(message[".include_in_bitcoin_only"]);
                return writer;
            };

            FileOptions.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            FileOptions.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.FileOptions();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.java_package = reader.string();
                        break;
                    case 8:
                        message.java_outer_classname = reader.string();
                        break;
                    case 10:
                        message.java_multiple_files = reader.bool();
                        break;
                    case 20:
                        message.java_generate_equals_and_hash = reader.bool();
                        break;
                    case 27:
                        message.java_string_check_utf8 = reader.bool();
                        break;
                    case 9:
                        message.optimize_for = reader.int32();
                        break;
                    case 11:
                        message.go_package = reader.string();
                        break;
                    case 16:
                        message.cc_generic_services = reader.bool();
                        break;
                    case 17:
                        message.java_generic_services = reader.bool();
                        break;
                    case 18:
                        message.py_generic_services = reader.bool();
                        break;
                    case 23:
                        message.deprecated = reader.bool();
                        break;
                    case 31:
                        message.cc_enable_arenas = reader.bool();
                        break;
                    case 36:
                        message.objc_class_prefix = reader.string();
                        break;
                    case 37:
                        message.csharp_namespace = reader.string();
                        break;
                    case 999:
                        if (!(message.uninterpreted_option && message.uninterpreted_option.length))
                            message.uninterpreted_option = [];
                        message.uninterpreted_option.push($root.google.protobuf.UninterpretedOption.decode(reader, reader.uint32()));
                        break;
                    case 60000:
                        message[".include_in_bitcoin_only"] = reader.bool();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            FileOptions.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            FileOptions.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.java_package != null && message.hasOwnProperty("java_package"))
                    if (!$util.isString(message.java_package))
                        return "java_package: string expected";
                if (message.java_outer_classname != null && message.hasOwnProperty("java_outer_classname"))
                    if (!$util.isString(message.java_outer_classname))
                        return "java_outer_classname: string expected";
                if (message.java_multiple_files != null && message.hasOwnProperty("java_multiple_files"))
                    if (typeof message.java_multiple_files !== "boolean")
                        return "java_multiple_files: boolean expected";
                if (message.java_generate_equals_and_hash != null && message.hasOwnProperty("java_generate_equals_and_hash"))
                    if (typeof message.java_generate_equals_and_hash !== "boolean")
                        return "java_generate_equals_and_hash: boolean expected";
                if (message.java_string_check_utf8 != null && message.hasOwnProperty("java_string_check_utf8"))
                    if (typeof message.java_string_check_utf8 !== "boolean")
                        return "java_string_check_utf8: boolean expected";
                if (message.optimize_for != null && message.hasOwnProperty("optimize_for"))
                    switch (message.optimize_for) {
                    default:
                        return "optimize_for: enum value expected";
                    case 1:
                    case 2:
                    case 3:
                        break;
                    }
                if (message.go_package != null && message.hasOwnProperty("go_package"))
                    if (!$util.isString(message.go_package))
                        return "go_package: string expected";
                if (message.cc_generic_services != null && message.hasOwnProperty("cc_generic_services"))
                    if (typeof message.cc_generic_services !== "boolean")
                        return "cc_generic_services: boolean expected";
                if (message.java_generic_services != null && message.hasOwnProperty("java_generic_services"))
                    if (typeof message.java_generic_services !== "boolean")
                        return "java_generic_services: boolean expected";
                if (message.py_generic_services != null && message.hasOwnProperty("py_generic_services"))
                    if (typeof message.py_generic_services !== "boolean")
                        return "py_generic_services: boolean expected";
                if (message.deprecated != null && message.hasOwnProperty("deprecated"))
                    if (typeof message.deprecated !== "boolean")
                        return "deprecated: boolean expected";
                if (message.cc_enable_arenas != null && message.hasOwnProperty("cc_enable_arenas"))
                    if (typeof message.cc_enable_arenas !== "boolean")
                        return "cc_enable_arenas: boolean expected";
                if (message.objc_class_prefix != null && message.hasOwnProperty("objc_class_prefix"))
                    if (!$util.isString(message.objc_class_prefix))
                        return "objc_class_prefix: string expected";
                if (message.csharp_namespace != null && message.hasOwnProperty("csharp_namespace"))
                    if (!$util.isString(message.csharp_namespace))
                        return "csharp_namespace: string expected";
                if (message.uninterpreted_option != null && message.hasOwnProperty("uninterpreted_option")) {
                    if (!Array.isArray(message.uninterpreted_option))
                        return "uninterpreted_option: array expected";
                    for (var i = 0; i < message.uninterpreted_option.length; ++i) {
                        var error = $root.google.protobuf.UninterpretedOption.verify(message.uninterpreted_option[i]);
                        if (error)
                            return "uninterpreted_option." + error;
                    }
                }
                if (message[".include_in_bitcoin_only"] != null && message.hasOwnProperty(".include_in_bitcoin_only"))
                    if (typeof message[".include_in_bitcoin_only"] !== "boolean")
                        return ".include_in_bitcoin_only: boolean expected";
                return null;
            };

            FileOptions.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.FileOptions)
                    return object;
                var message = new $root.google.protobuf.FileOptions();
                if (object.java_package != null)
                    message.java_package = String(object.java_package);
                if (object.java_outer_classname != null)
                    message.java_outer_classname = String(object.java_outer_classname);
                if (object.java_multiple_files != null)
                    message.java_multiple_files = Boolean(object.java_multiple_files);
                if (object.java_generate_equals_and_hash != null)
                    message.java_generate_equals_and_hash = Boolean(object.java_generate_equals_and_hash);
                if (object.java_string_check_utf8 != null)
                    message.java_string_check_utf8 = Boolean(object.java_string_check_utf8);
                switch (object.optimize_for) {
                case "SPEED":
                case 1:
                    message.optimize_for = 1;
                    break;
                case "CODE_SIZE":
                case 2:
                    message.optimize_for = 2;
                    break;
                case "LITE_RUNTIME":
                case 3:
                    message.optimize_for = 3;
                    break;
                }
                if (object.go_package != null)
                    message.go_package = String(object.go_package);
                if (object.cc_generic_services != null)
                    message.cc_generic_services = Boolean(object.cc_generic_services);
                if (object.java_generic_services != null)
                    message.java_generic_services = Boolean(object.java_generic_services);
                if (object.py_generic_services != null)
                    message.py_generic_services = Boolean(object.py_generic_services);
                if (object.deprecated != null)
                    message.deprecated = Boolean(object.deprecated);
                if (object.cc_enable_arenas != null)
                    message.cc_enable_arenas = Boolean(object.cc_enable_arenas);
                if (object.objc_class_prefix != null)
                    message.objc_class_prefix = String(object.objc_class_prefix);
                if (object.csharp_namespace != null)
                    message.csharp_namespace = String(object.csharp_namespace);
                if (object.uninterpreted_option) {
                    if (!Array.isArray(object.uninterpreted_option))
                        throw TypeError(".google.protobuf.FileOptions.uninterpreted_option: array expected");
                    message.uninterpreted_option = [];
                    for (var i = 0; i < object.uninterpreted_option.length; ++i) {
                        if (typeof object.uninterpreted_option[i] !== "object")
                            throw TypeError(".google.protobuf.FileOptions.uninterpreted_option: object expected");
                        message.uninterpreted_option[i] = $root.google.protobuf.UninterpretedOption.fromObject(object.uninterpreted_option[i]);
                    }
                }
                if (object[".include_in_bitcoin_only"] != null)
                    message[".include_in_bitcoin_only"] = Boolean(object[".include_in_bitcoin_only"]);
                return message;
            };

            FileOptions.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.uninterpreted_option = [];
                if (options.defaults) {
                    object.java_package = "";
                    object.java_outer_classname = "";
                    object.optimize_for = options.enums === String ? "SPEED" : 1;
                    object.java_multiple_files = false;
                    object.go_package = "";
                    object.cc_generic_services = false;
                    object.java_generic_services = false;
                    object.py_generic_services = false;
                    object.java_generate_equals_and_hash = false;
                    object.deprecated = false;
                    object.java_string_check_utf8 = false;
                    object.cc_enable_arenas = false;
                    object.objc_class_prefix = "";
                    object.csharp_namespace = "";
                    object[".include_in_bitcoin_only"] = false;
                }
                if (message.java_package != null && message.hasOwnProperty("java_package"))
                    object.java_package = message.java_package;
                if (message.java_outer_classname != null && message.hasOwnProperty("java_outer_classname"))
                    object.java_outer_classname = message.java_outer_classname;
                if (message.optimize_for != null && message.hasOwnProperty("optimize_for"))
                    object.optimize_for = options.enums === String ? $root.google.protobuf.FileOptions.OptimizeMode[message.optimize_for] : message.optimize_for;
                if (message.java_multiple_files != null && message.hasOwnProperty("java_multiple_files"))
                    object.java_multiple_files = message.java_multiple_files;
                if (message.go_package != null && message.hasOwnProperty("go_package"))
                    object.go_package = message.go_package;
                if (message.cc_generic_services != null && message.hasOwnProperty("cc_generic_services"))
                    object.cc_generic_services = message.cc_generic_services;
                if (message.java_generic_services != null && message.hasOwnProperty("java_generic_services"))
                    object.java_generic_services = message.java_generic_services;
                if (message.py_generic_services != null && message.hasOwnProperty("py_generic_services"))
                    object.py_generic_services = message.py_generic_services;
                if (message.java_generate_equals_and_hash != null && message.hasOwnProperty("java_generate_equals_and_hash"))
                    object.java_generate_equals_and_hash = message.java_generate_equals_and_hash;
                if (message.deprecated != null && message.hasOwnProperty("deprecated"))
                    object.deprecated = message.deprecated;
                if (message.java_string_check_utf8 != null && message.hasOwnProperty("java_string_check_utf8"))
                    object.java_string_check_utf8 = message.java_string_check_utf8;
                if (message.cc_enable_arenas != null && message.hasOwnProperty("cc_enable_arenas"))
                    object.cc_enable_arenas = message.cc_enable_arenas;
                if (message.objc_class_prefix != null && message.hasOwnProperty("objc_class_prefix"))
                    object.objc_class_prefix = message.objc_class_prefix;
                if (message.csharp_namespace != null && message.hasOwnProperty("csharp_namespace"))
                    object.csharp_namespace = message.csharp_namespace;
                if (message.uninterpreted_option && message.uninterpreted_option.length) {
                    object.uninterpreted_option = [];
                    for (var j = 0; j < message.uninterpreted_option.length; ++j)
                        object.uninterpreted_option[j] = $root.google.protobuf.UninterpretedOption.toObject(message.uninterpreted_option[j], options);
                }
                if (message[".include_in_bitcoin_only"] != null && message.hasOwnProperty(".include_in_bitcoin_only"))
                    object[".include_in_bitcoin_only"] = message[".include_in_bitcoin_only"];
                return object;
            };

            FileOptions.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            FileOptions.OptimizeMode = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[1] = "SPEED"] = 1;
                values[valuesById[2] = "CODE_SIZE"] = 2;
                values[valuesById[3] = "LITE_RUNTIME"] = 3;
                return values;
            })();

            return FileOptions;
        })();

        protobuf.MessageOptions = (function() {

            function MessageOptions(properties) {
                this.uninterpreted_option = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            MessageOptions.prototype.message_set_wire_format = false;
            MessageOptions.prototype.no_standard_descriptor_accessor = false;
            MessageOptions.prototype.deprecated = false;
            MessageOptions.prototype.map_entry = false;
            MessageOptions.prototype.uninterpreted_option = $util.emptyArray;
            MessageOptions.prototype[".unstable"] = false;
            MessageOptions.prototype[".wire_type"] = 0;

            MessageOptions.create = function create(properties) {
                return new MessageOptions(properties);
            };

            MessageOptions.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.message_set_wire_format != null && Object.hasOwnProperty.call(message, "message_set_wire_format"))
                    writer.uint32(8).bool(message.message_set_wire_format);
                if (message.no_standard_descriptor_accessor != null && Object.hasOwnProperty.call(message, "no_standard_descriptor_accessor"))
                    writer.uint32(16).bool(message.no_standard_descriptor_accessor);
                if (message.deprecated != null && Object.hasOwnProperty.call(message, "deprecated"))
                    writer.uint32(24).bool(message.deprecated);
                if (message.map_entry != null && Object.hasOwnProperty.call(message, "map_entry"))
                    writer.uint32(56).bool(message.map_entry);
                if (message.uninterpreted_option != null && message.uninterpreted_option.length)
                    for (var i = 0; i < message.uninterpreted_option.length; ++i)
                        $root.google.protobuf.UninterpretedOption.encode(message.uninterpreted_option[i], writer.uint32(7994).fork()).ldelim();
                if (message[".unstable"] != null && Object.hasOwnProperty.call(message, ".unstable"))
                    writer.uint32(416008).bool(message[".unstable"]);
                if (message[".wire_type"] != null && Object.hasOwnProperty.call(message, ".wire_type"))
                    writer.uint32(416016).uint32(message[".wire_type"]);
                return writer;
            };

            MessageOptions.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            MessageOptions.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.MessageOptions();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.message_set_wire_format = reader.bool();
                        break;
                    case 2:
                        message.no_standard_descriptor_accessor = reader.bool();
                        break;
                    case 3:
                        message.deprecated = reader.bool();
                        break;
                    case 7:
                        message.map_entry = reader.bool();
                        break;
                    case 999:
                        if (!(message.uninterpreted_option && message.uninterpreted_option.length))
                            message.uninterpreted_option = [];
                        message.uninterpreted_option.push($root.google.protobuf.UninterpretedOption.decode(reader, reader.uint32()));
                        break;
                    case 52001:
                        message[".unstable"] = reader.bool();
                        break;
                    case 52002:
                        message[".wire_type"] = reader.uint32();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            MessageOptions.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            MessageOptions.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.message_set_wire_format != null && message.hasOwnProperty("message_set_wire_format"))
                    if (typeof message.message_set_wire_format !== "boolean")
                        return "message_set_wire_format: boolean expected";
                if (message.no_standard_descriptor_accessor != null && message.hasOwnProperty("no_standard_descriptor_accessor"))
                    if (typeof message.no_standard_descriptor_accessor !== "boolean")
                        return "no_standard_descriptor_accessor: boolean expected";
                if (message.deprecated != null && message.hasOwnProperty("deprecated"))
                    if (typeof message.deprecated !== "boolean")
                        return "deprecated: boolean expected";
                if (message.map_entry != null && message.hasOwnProperty("map_entry"))
                    if (typeof message.map_entry !== "boolean")
                        return "map_entry: boolean expected";
                if (message.uninterpreted_option != null && message.hasOwnProperty("uninterpreted_option")) {
                    if (!Array.isArray(message.uninterpreted_option))
                        return "uninterpreted_option: array expected";
                    for (var i = 0; i < message.uninterpreted_option.length; ++i) {
                        var error = $root.google.protobuf.UninterpretedOption.verify(message.uninterpreted_option[i]);
                        if (error)
                            return "uninterpreted_option." + error;
                    }
                }
                if (message[".unstable"] != null && message.hasOwnProperty(".unstable"))
                    if (typeof message[".unstable"] !== "boolean")
                        return ".unstable: boolean expected";
                if (message[".wire_type"] != null && message.hasOwnProperty(".wire_type"))
                    if (!$util.isInteger(message[".wire_type"]))
                        return ".wire_type: integer expected";
                return null;
            };

            MessageOptions.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.MessageOptions)
                    return object;
                var message = new $root.google.protobuf.MessageOptions();
                if (object.message_set_wire_format != null)
                    message.message_set_wire_format = Boolean(object.message_set_wire_format);
                if (object.no_standard_descriptor_accessor != null)
                    message.no_standard_descriptor_accessor = Boolean(object.no_standard_descriptor_accessor);
                if (object.deprecated != null)
                    message.deprecated = Boolean(object.deprecated);
                if (object.map_entry != null)
                    message.map_entry = Boolean(object.map_entry);
                if (object.uninterpreted_option) {
                    if (!Array.isArray(object.uninterpreted_option))
                        throw TypeError(".google.protobuf.MessageOptions.uninterpreted_option: array expected");
                    message.uninterpreted_option = [];
                    for (var i = 0; i < object.uninterpreted_option.length; ++i) {
                        if (typeof object.uninterpreted_option[i] !== "object")
                            throw TypeError(".google.protobuf.MessageOptions.uninterpreted_option: object expected");
                        message.uninterpreted_option[i] = $root.google.protobuf.UninterpretedOption.fromObject(object.uninterpreted_option[i]);
                    }
                }
                if (object[".unstable"] != null)
                    message[".unstable"] = Boolean(object[".unstable"]);
                if (object[".wire_type"] != null)
                    message[".wire_type"] = object[".wire_type"] >>> 0;
                return message;
            };

            MessageOptions.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.uninterpreted_option = [];
                if (options.defaults) {
                    object.message_set_wire_format = false;
                    object.no_standard_descriptor_accessor = false;
                    object.deprecated = false;
                    object.map_entry = false;
                    object[".unstable"] = false;
                    object[".wire_type"] = 0;
                }
                if (message.message_set_wire_format != null && message.hasOwnProperty("message_set_wire_format"))
                    object.message_set_wire_format = message.message_set_wire_format;
                if (message.no_standard_descriptor_accessor != null && message.hasOwnProperty("no_standard_descriptor_accessor"))
                    object.no_standard_descriptor_accessor = message.no_standard_descriptor_accessor;
                if (message.deprecated != null && message.hasOwnProperty("deprecated"))
                    object.deprecated = message.deprecated;
                if (message.map_entry != null && message.hasOwnProperty("map_entry"))
                    object.map_entry = message.map_entry;
                if (message.uninterpreted_option && message.uninterpreted_option.length) {
                    object.uninterpreted_option = [];
                    for (var j = 0; j < message.uninterpreted_option.length; ++j)
                        object.uninterpreted_option[j] = $root.google.protobuf.UninterpretedOption.toObject(message.uninterpreted_option[j], options);
                }
                if (message[".unstable"] != null && message.hasOwnProperty(".unstable"))
                    object[".unstable"] = message[".unstable"];
                if (message[".wire_type"] != null && message.hasOwnProperty(".wire_type"))
                    object[".wire_type"] = message[".wire_type"];
                return object;
            };

            MessageOptions.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return MessageOptions;
        })();

        protobuf.FieldOptions = (function() {

            function FieldOptions(properties) {
                this.uninterpreted_option = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            FieldOptions.prototype.ctype = 0;
            FieldOptions.prototype.packed = false;
            FieldOptions.prototype.jstype = 0;
            FieldOptions.prototype.lazy = false;
            FieldOptions.prototype.deprecated = false;
            FieldOptions.prototype.weak = false;
            FieldOptions.prototype.uninterpreted_option = $util.emptyArray;
            FieldOptions.prototype[".experimental"] = false;

            FieldOptions.create = function create(properties) {
                return new FieldOptions(properties);
            };

            FieldOptions.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.ctype != null && Object.hasOwnProperty.call(message, "ctype"))
                    writer.uint32(8).int32(message.ctype);
                if (message.packed != null && Object.hasOwnProperty.call(message, "packed"))
                    writer.uint32(16).bool(message.packed);
                if (message.deprecated != null && Object.hasOwnProperty.call(message, "deprecated"))
                    writer.uint32(24).bool(message.deprecated);
                if (message.lazy != null && Object.hasOwnProperty.call(message, "lazy"))
                    writer.uint32(40).bool(message.lazy);
                if (message.jstype != null && Object.hasOwnProperty.call(message, "jstype"))
                    writer.uint32(48).int32(message.jstype);
                if (message.weak != null && Object.hasOwnProperty.call(message, "weak"))
                    writer.uint32(80).bool(message.weak);
                if (message.uninterpreted_option != null && message.uninterpreted_option.length)
                    for (var i = 0; i < message.uninterpreted_option.length; ++i)
                        $root.google.protobuf.UninterpretedOption.encode(message.uninterpreted_option[i], writer.uint32(7994).fork()).ldelim();
                if (message[".experimental"] != null && Object.hasOwnProperty.call(message, ".experimental"))
                    writer.uint32(424008).bool(message[".experimental"]);
                return writer;
            };

            FieldOptions.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            FieldOptions.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.FieldOptions();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.ctype = reader.int32();
                        break;
                    case 2:
                        message.packed = reader.bool();
                        break;
                    case 6:
                        message.jstype = reader.int32();
                        break;
                    case 5:
                        message.lazy = reader.bool();
                        break;
                    case 3:
                        message.deprecated = reader.bool();
                        break;
                    case 10:
                        message.weak = reader.bool();
                        break;
                    case 999:
                        if (!(message.uninterpreted_option && message.uninterpreted_option.length))
                            message.uninterpreted_option = [];
                        message.uninterpreted_option.push($root.google.protobuf.UninterpretedOption.decode(reader, reader.uint32()));
                        break;
                    case 53001:
                        message[".experimental"] = reader.bool();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            FieldOptions.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            FieldOptions.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.ctype != null && message.hasOwnProperty("ctype"))
                    switch (message.ctype) {
                    default:
                        return "ctype: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                        break;
                    }
                if (message.packed != null && message.hasOwnProperty("packed"))
                    if (typeof message.packed !== "boolean")
                        return "packed: boolean expected";
                if (message.jstype != null && message.hasOwnProperty("jstype"))
                    switch (message.jstype) {
                    default:
                        return "jstype: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                        break;
                    }
                if (message.lazy != null && message.hasOwnProperty("lazy"))
                    if (typeof message.lazy !== "boolean")
                        return "lazy: boolean expected";
                if (message.deprecated != null && message.hasOwnProperty("deprecated"))
                    if (typeof message.deprecated !== "boolean")
                        return "deprecated: boolean expected";
                if (message.weak != null && message.hasOwnProperty("weak"))
                    if (typeof message.weak !== "boolean")
                        return "weak: boolean expected";
                if (message.uninterpreted_option != null && message.hasOwnProperty("uninterpreted_option")) {
                    if (!Array.isArray(message.uninterpreted_option))
                        return "uninterpreted_option: array expected";
                    for (var i = 0; i < message.uninterpreted_option.length; ++i) {
                        var error = $root.google.protobuf.UninterpretedOption.verify(message.uninterpreted_option[i]);
                        if (error)
                            return "uninterpreted_option." + error;
                    }
                }
                if (message[".experimental"] != null && message.hasOwnProperty(".experimental"))
                    if (typeof message[".experimental"] !== "boolean")
                        return ".experimental: boolean expected";
                return null;
            };

            FieldOptions.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.FieldOptions)
                    return object;
                var message = new $root.google.protobuf.FieldOptions();
                switch (object.ctype) {
                case "STRING":
                case 0:
                    message.ctype = 0;
                    break;
                case "CORD":
                case 1:
                    message.ctype = 1;
                    break;
                case "STRING_PIECE":
                case 2:
                    message.ctype = 2;
                    break;
                }
                if (object.packed != null)
                    message.packed = Boolean(object.packed);
                switch (object.jstype) {
                case "JS_NORMAL":
                case 0:
                    message.jstype = 0;
                    break;
                case "JS_STRING":
                case 1:
                    message.jstype = 1;
                    break;
                case "JS_NUMBER":
                case 2:
                    message.jstype = 2;
                    break;
                }
                if (object.lazy != null)
                    message.lazy = Boolean(object.lazy);
                if (object.deprecated != null)
                    message.deprecated = Boolean(object.deprecated);
                if (object.weak != null)
                    message.weak = Boolean(object.weak);
                if (object.uninterpreted_option) {
                    if (!Array.isArray(object.uninterpreted_option))
                        throw TypeError(".google.protobuf.FieldOptions.uninterpreted_option: array expected");
                    message.uninterpreted_option = [];
                    for (var i = 0; i < object.uninterpreted_option.length; ++i) {
                        if (typeof object.uninterpreted_option[i] !== "object")
                            throw TypeError(".google.protobuf.FieldOptions.uninterpreted_option: object expected");
                        message.uninterpreted_option[i] = $root.google.protobuf.UninterpretedOption.fromObject(object.uninterpreted_option[i]);
                    }
                }
                if (object[".experimental"] != null)
                    message[".experimental"] = Boolean(object[".experimental"]);
                return message;
            };

            FieldOptions.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.uninterpreted_option = [];
                if (options.defaults) {
                    object.ctype = options.enums === String ? "STRING" : 0;
                    object.packed = false;
                    object.deprecated = false;
                    object.lazy = false;
                    object.jstype = options.enums === String ? "JS_NORMAL" : 0;
                    object.weak = false;
                    object[".experimental"] = false;
                }
                if (message.ctype != null && message.hasOwnProperty("ctype"))
                    object.ctype = options.enums === String ? $root.google.protobuf.FieldOptions.CType[message.ctype] : message.ctype;
                if (message.packed != null && message.hasOwnProperty("packed"))
                    object.packed = message.packed;
                if (message.deprecated != null && message.hasOwnProperty("deprecated"))
                    object.deprecated = message.deprecated;
                if (message.lazy != null && message.hasOwnProperty("lazy"))
                    object.lazy = message.lazy;
                if (message.jstype != null && message.hasOwnProperty("jstype"))
                    object.jstype = options.enums === String ? $root.google.protobuf.FieldOptions.JSType[message.jstype] : message.jstype;
                if (message.weak != null && message.hasOwnProperty("weak"))
                    object.weak = message.weak;
                if (message.uninterpreted_option && message.uninterpreted_option.length) {
                    object.uninterpreted_option = [];
                    for (var j = 0; j < message.uninterpreted_option.length; ++j)
                        object.uninterpreted_option[j] = $root.google.protobuf.UninterpretedOption.toObject(message.uninterpreted_option[j], options);
                }
                if (message[".experimental"] != null && message.hasOwnProperty(".experimental"))
                    object[".experimental"] = message[".experimental"];
                return object;
            };

            FieldOptions.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            FieldOptions.CType = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "STRING"] = 0;
                values[valuesById[1] = "CORD"] = 1;
                values[valuesById[2] = "STRING_PIECE"] = 2;
                return values;
            })();

            FieldOptions.JSType = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "JS_NORMAL"] = 0;
                values[valuesById[1] = "JS_STRING"] = 1;
                values[valuesById[2] = "JS_NUMBER"] = 2;
                return values;
            })();

            return FieldOptions;
        })();

        protobuf.OneofOptions = (function() {

            function OneofOptions(properties) {
                this.uninterpreted_option = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            OneofOptions.prototype.uninterpreted_option = $util.emptyArray;

            OneofOptions.create = function create(properties) {
                return new OneofOptions(properties);
            };

            OneofOptions.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.uninterpreted_option != null && message.uninterpreted_option.length)
                    for (var i = 0; i < message.uninterpreted_option.length; ++i)
                        $root.google.protobuf.UninterpretedOption.encode(message.uninterpreted_option[i], writer.uint32(7994).fork()).ldelim();
                return writer;
            };

            OneofOptions.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            OneofOptions.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.OneofOptions();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 999:
                        if (!(message.uninterpreted_option && message.uninterpreted_option.length))
                            message.uninterpreted_option = [];
                        message.uninterpreted_option.push($root.google.protobuf.UninterpretedOption.decode(reader, reader.uint32()));
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            OneofOptions.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            OneofOptions.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.uninterpreted_option != null && message.hasOwnProperty("uninterpreted_option")) {
                    if (!Array.isArray(message.uninterpreted_option))
                        return "uninterpreted_option: array expected";
                    for (var i = 0; i < message.uninterpreted_option.length; ++i) {
                        var error = $root.google.protobuf.UninterpretedOption.verify(message.uninterpreted_option[i]);
                        if (error)
                            return "uninterpreted_option." + error;
                    }
                }
                return null;
            };

            OneofOptions.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.OneofOptions)
                    return object;
                var message = new $root.google.protobuf.OneofOptions();
                if (object.uninterpreted_option) {
                    if (!Array.isArray(object.uninterpreted_option))
                        throw TypeError(".google.protobuf.OneofOptions.uninterpreted_option: array expected");
                    message.uninterpreted_option = [];
                    for (var i = 0; i < object.uninterpreted_option.length; ++i) {
                        if (typeof object.uninterpreted_option[i] !== "object")
                            throw TypeError(".google.protobuf.OneofOptions.uninterpreted_option: object expected");
                        message.uninterpreted_option[i] = $root.google.protobuf.UninterpretedOption.fromObject(object.uninterpreted_option[i]);
                    }
                }
                return message;
            };

            OneofOptions.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.uninterpreted_option = [];
                if (message.uninterpreted_option && message.uninterpreted_option.length) {
                    object.uninterpreted_option = [];
                    for (var j = 0; j < message.uninterpreted_option.length; ++j)
                        object.uninterpreted_option[j] = $root.google.protobuf.UninterpretedOption.toObject(message.uninterpreted_option[j], options);
                }
                return object;
            };

            OneofOptions.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return OneofOptions;
        })();

        protobuf.EnumOptions = (function() {

            function EnumOptions(properties) {
                this.uninterpreted_option = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            EnumOptions.prototype.allow_alias = false;
            EnumOptions.prototype.deprecated = false;
            EnumOptions.prototype.uninterpreted_option = $util.emptyArray;
            EnumOptions.prototype[".has_bitcoin_only_values"] = false;

            EnumOptions.create = function create(properties) {
                return new EnumOptions(properties);
            };

            EnumOptions.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.allow_alias != null && Object.hasOwnProperty.call(message, "allow_alias"))
                    writer.uint32(16).bool(message.allow_alias);
                if (message.deprecated != null && Object.hasOwnProperty.call(message, "deprecated"))
                    writer.uint32(24).bool(message.deprecated);
                if (message.uninterpreted_option != null && message.uninterpreted_option.length)
                    for (var i = 0; i < message.uninterpreted_option.length; ++i)
                        $root.google.protobuf.UninterpretedOption.encode(message.uninterpreted_option[i], writer.uint32(7994).fork()).ldelim();
                if (message[".has_bitcoin_only_values"] != null && Object.hasOwnProperty.call(message, ".has_bitcoin_only_values"))
                    writer.uint32(408008).bool(message[".has_bitcoin_only_values"]);
                return writer;
            };

            EnumOptions.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            EnumOptions.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.EnumOptions();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 2:
                        message.allow_alias = reader.bool();
                        break;
                    case 3:
                        message.deprecated = reader.bool();
                        break;
                    case 999:
                        if (!(message.uninterpreted_option && message.uninterpreted_option.length))
                            message.uninterpreted_option = [];
                        message.uninterpreted_option.push($root.google.protobuf.UninterpretedOption.decode(reader, reader.uint32()));
                        break;
                    case 51001:
                        message[".has_bitcoin_only_values"] = reader.bool();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            EnumOptions.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            EnumOptions.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.allow_alias != null && message.hasOwnProperty("allow_alias"))
                    if (typeof message.allow_alias !== "boolean")
                        return "allow_alias: boolean expected";
                if (message.deprecated != null && message.hasOwnProperty("deprecated"))
                    if (typeof message.deprecated !== "boolean")
                        return "deprecated: boolean expected";
                if (message.uninterpreted_option != null && message.hasOwnProperty("uninterpreted_option")) {
                    if (!Array.isArray(message.uninterpreted_option))
                        return "uninterpreted_option: array expected";
                    for (var i = 0; i < message.uninterpreted_option.length; ++i) {
                        var error = $root.google.protobuf.UninterpretedOption.verify(message.uninterpreted_option[i]);
                        if (error)
                            return "uninterpreted_option." + error;
                    }
                }
                if (message[".has_bitcoin_only_values"] != null && message.hasOwnProperty(".has_bitcoin_only_values"))
                    if (typeof message[".has_bitcoin_only_values"] !== "boolean")
                        return ".has_bitcoin_only_values: boolean expected";
                return null;
            };

            EnumOptions.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.EnumOptions)
                    return object;
                var message = new $root.google.protobuf.EnumOptions();
                if (object.allow_alias != null)
                    message.allow_alias = Boolean(object.allow_alias);
                if (object.deprecated != null)
                    message.deprecated = Boolean(object.deprecated);
                if (object.uninterpreted_option) {
                    if (!Array.isArray(object.uninterpreted_option))
                        throw TypeError(".google.protobuf.EnumOptions.uninterpreted_option: array expected");
                    message.uninterpreted_option = [];
                    for (var i = 0; i < object.uninterpreted_option.length; ++i) {
                        if (typeof object.uninterpreted_option[i] !== "object")
                            throw TypeError(".google.protobuf.EnumOptions.uninterpreted_option: object expected");
                        message.uninterpreted_option[i] = $root.google.protobuf.UninterpretedOption.fromObject(object.uninterpreted_option[i]);
                    }
                }
                if (object[".has_bitcoin_only_values"] != null)
                    message[".has_bitcoin_only_values"] = Boolean(object[".has_bitcoin_only_values"]);
                return message;
            };

            EnumOptions.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.uninterpreted_option = [];
                if (options.defaults) {
                    object.allow_alias = false;
                    object.deprecated = false;
                    object[".has_bitcoin_only_values"] = false;
                }
                if (message.allow_alias != null && message.hasOwnProperty("allow_alias"))
                    object.allow_alias = message.allow_alias;
                if (message.deprecated != null && message.hasOwnProperty("deprecated"))
                    object.deprecated = message.deprecated;
                if (message.uninterpreted_option && message.uninterpreted_option.length) {
                    object.uninterpreted_option = [];
                    for (var j = 0; j < message.uninterpreted_option.length; ++j)
                        object.uninterpreted_option[j] = $root.google.protobuf.UninterpretedOption.toObject(message.uninterpreted_option[j], options);
                }
                if (message[".has_bitcoin_only_values"] != null && message.hasOwnProperty(".has_bitcoin_only_values"))
                    object[".has_bitcoin_only_values"] = message[".has_bitcoin_only_values"];
                return object;
            };

            EnumOptions.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return EnumOptions;
        })();

        protobuf.EnumValueOptions = (function() {

            function EnumValueOptions(properties) {
                this.uninterpreted_option = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            EnumValueOptions.prototype.deprecated = false;
            EnumValueOptions.prototype.uninterpreted_option = $util.emptyArray;
            EnumValueOptions.prototype[".wire_in"] = false;
            EnumValueOptions.prototype[".wire_out"] = false;
            EnumValueOptions.prototype[".wire_debug_in"] = false;
            EnumValueOptions.prototype[".wire_debug_out"] = false;
            EnumValueOptions.prototype[".wire_tiny"] = false;
            EnumValueOptions.prototype[".wire_bootloader"] = false;
            EnumValueOptions.prototype[".wire_no_fsm"] = false;
            EnumValueOptions.prototype[".facotry"] = false;
            EnumValueOptions.prototype[".bitcoin_only"] = false;

            EnumValueOptions.create = function create(properties) {
                return new EnumValueOptions(properties);
            };

            EnumValueOptions.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.deprecated != null && Object.hasOwnProperty.call(message, "deprecated"))
                    writer.uint32(8).bool(message.deprecated);
                if (message.uninterpreted_option != null && message.uninterpreted_option.length)
                    for (var i = 0; i < message.uninterpreted_option.length; ++i)
                        $root.google.protobuf.UninterpretedOption.encode(message.uninterpreted_option[i], writer.uint32(7994).fork()).ldelim();
                if (message[".wire_in"] != null && Object.hasOwnProperty.call(message, ".wire_in"))
                    writer.uint32(400016).bool(message[".wire_in"]);
                if (message[".wire_out"] != null && Object.hasOwnProperty.call(message, ".wire_out"))
                    writer.uint32(400024).bool(message[".wire_out"]);
                if (message[".wire_debug_in"] != null && Object.hasOwnProperty.call(message, ".wire_debug_in"))
                    writer.uint32(400032).bool(message[".wire_debug_in"]);
                if (message[".wire_debug_out"] != null && Object.hasOwnProperty.call(message, ".wire_debug_out"))
                    writer.uint32(400040).bool(message[".wire_debug_out"]);
                if (message[".wire_tiny"] != null && Object.hasOwnProperty.call(message, ".wire_tiny"))
                    writer.uint32(400048).bool(message[".wire_tiny"]);
                if (message[".wire_bootloader"] != null && Object.hasOwnProperty.call(message, ".wire_bootloader"))
                    writer.uint32(400056).bool(message[".wire_bootloader"]);
                if (message[".wire_no_fsm"] != null && Object.hasOwnProperty.call(message, ".wire_no_fsm"))
                    writer.uint32(400064).bool(message[".wire_no_fsm"]);
                if (message[".facotry"] != null && Object.hasOwnProperty.call(message, ".facotry"))
                    writer.uint32(404008).bool(message[".facotry"]);
                if (message[".bitcoin_only"] != null && Object.hasOwnProperty.call(message, ".bitcoin_only"))
                    writer.uint32(480000).bool(message[".bitcoin_only"]);
                return writer;
            };

            EnumValueOptions.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            EnumValueOptions.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.EnumValueOptions();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.deprecated = reader.bool();
                        break;
                    case 999:
                        if (!(message.uninterpreted_option && message.uninterpreted_option.length))
                            message.uninterpreted_option = [];
                        message.uninterpreted_option.push($root.google.protobuf.UninterpretedOption.decode(reader, reader.uint32()));
                        break;
                    case 50002:
                        message[".wire_in"] = reader.bool();
                        break;
                    case 50003:
                        message[".wire_out"] = reader.bool();
                        break;
                    case 50004:
                        message[".wire_debug_in"] = reader.bool();
                        break;
                    case 50005:
                        message[".wire_debug_out"] = reader.bool();
                        break;
                    case 50006:
                        message[".wire_tiny"] = reader.bool();
                        break;
                    case 50007:
                        message[".wire_bootloader"] = reader.bool();
                        break;
                    case 50008:
                        message[".wire_no_fsm"] = reader.bool();
                        break;
                    case 50501:
                        message[".facotry"] = reader.bool();
                        break;
                    case 60000:
                        message[".bitcoin_only"] = reader.bool();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            EnumValueOptions.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            EnumValueOptions.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.deprecated != null && message.hasOwnProperty("deprecated"))
                    if (typeof message.deprecated !== "boolean")
                        return "deprecated: boolean expected";
                if (message.uninterpreted_option != null && message.hasOwnProperty("uninterpreted_option")) {
                    if (!Array.isArray(message.uninterpreted_option))
                        return "uninterpreted_option: array expected";
                    for (var i = 0; i < message.uninterpreted_option.length; ++i) {
                        var error = $root.google.protobuf.UninterpretedOption.verify(message.uninterpreted_option[i]);
                        if (error)
                            return "uninterpreted_option." + error;
                    }
                }
                if (message[".wire_in"] != null && message.hasOwnProperty(".wire_in"))
                    if (typeof message[".wire_in"] !== "boolean")
                        return ".wire_in: boolean expected";
                if (message[".wire_out"] != null && message.hasOwnProperty(".wire_out"))
                    if (typeof message[".wire_out"] !== "boolean")
                        return ".wire_out: boolean expected";
                if (message[".wire_debug_in"] != null && message.hasOwnProperty(".wire_debug_in"))
                    if (typeof message[".wire_debug_in"] !== "boolean")
                        return ".wire_debug_in: boolean expected";
                if (message[".wire_debug_out"] != null && message.hasOwnProperty(".wire_debug_out"))
                    if (typeof message[".wire_debug_out"] !== "boolean")
                        return ".wire_debug_out: boolean expected";
                if (message[".wire_tiny"] != null && message.hasOwnProperty(".wire_tiny"))
                    if (typeof message[".wire_tiny"] !== "boolean")
                        return ".wire_tiny: boolean expected";
                if (message[".wire_bootloader"] != null && message.hasOwnProperty(".wire_bootloader"))
                    if (typeof message[".wire_bootloader"] !== "boolean")
                        return ".wire_bootloader: boolean expected";
                if (message[".wire_no_fsm"] != null && message.hasOwnProperty(".wire_no_fsm"))
                    if (typeof message[".wire_no_fsm"] !== "boolean")
                        return ".wire_no_fsm: boolean expected";
                if (message[".facotry"] != null && message.hasOwnProperty(".facotry"))
                    if (typeof message[".facotry"] !== "boolean")
                        return ".facotry: boolean expected";
                if (message[".bitcoin_only"] != null && message.hasOwnProperty(".bitcoin_only"))
                    if (typeof message[".bitcoin_only"] !== "boolean")
                        return ".bitcoin_only: boolean expected";
                return null;
            };

            EnumValueOptions.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.EnumValueOptions)
                    return object;
                var message = new $root.google.protobuf.EnumValueOptions();
                if (object.deprecated != null)
                    message.deprecated = Boolean(object.deprecated);
                if (object.uninterpreted_option) {
                    if (!Array.isArray(object.uninterpreted_option))
                        throw TypeError(".google.protobuf.EnumValueOptions.uninterpreted_option: array expected");
                    message.uninterpreted_option = [];
                    for (var i = 0; i < object.uninterpreted_option.length; ++i) {
                        if (typeof object.uninterpreted_option[i] !== "object")
                            throw TypeError(".google.protobuf.EnumValueOptions.uninterpreted_option: object expected");
                        message.uninterpreted_option[i] = $root.google.protobuf.UninterpretedOption.fromObject(object.uninterpreted_option[i]);
                    }
                }
                if (object[".wire_in"] != null)
                    message[".wire_in"] = Boolean(object[".wire_in"]);
                if (object[".wire_out"] != null)
                    message[".wire_out"] = Boolean(object[".wire_out"]);
                if (object[".wire_debug_in"] != null)
                    message[".wire_debug_in"] = Boolean(object[".wire_debug_in"]);
                if (object[".wire_debug_out"] != null)
                    message[".wire_debug_out"] = Boolean(object[".wire_debug_out"]);
                if (object[".wire_tiny"] != null)
                    message[".wire_tiny"] = Boolean(object[".wire_tiny"]);
                if (object[".wire_bootloader"] != null)
                    message[".wire_bootloader"] = Boolean(object[".wire_bootloader"]);
                if (object[".wire_no_fsm"] != null)
                    message[".wire_no_fsm"] = Boolean(object[".wire_no_fsm"]);
                if (object[".facotry"] != null)
                    message[".facotry"] = Boolean(object[".facotry"]);
                if (object[".bitcoin_only"] != null)
                    message[".bitcoin_only"] = Boolean(object[".bitcoin_only"]);
                return message;
            };

            EnumValueOptions.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.uninterpreted_option = [];
                if (options.defaults) {
                    object.deprecated = false;
                    object[".wire_in"] = false;
                    object[".wire_out"] = false;
                    object[".wire_debug_in"] = false;
                    object[".wire_debug_out"] = false;
                    object[".wire_tiny"] = false;
                    object[".wire_bootloader"] = false;
                    object[".wire_no_fsm"] = false;
                    object[".facotry"] = false;
                    object[".bitcoin_only"] = false;
                }
                if (message.deprecated != null && message.hasOwnProperty("deprecated"))
                    object.deprecated = message.deprecated;
                if (message.uninterpreted_option && message.uninterpreted_option.length) {
                    object.uninterpreted_option = [];
                    for (var j = 0; j < message.uninterpreted_option.length; ++j)
                        object.uninterpreted_option[j] = $root.google.protobuf.UninterpretedOption.toObject(message.uninterpreted_option[j], options);
                }
                if (message[".wire_in"] != null && message.hasOwnProperty(".wire_in"))
                    object[".wire_in"] = message[".wire_in"];
                if (message[".wire_out"] != null && message.hasOwnProperty(".wire_out"))
                    object[".wire_out"] = message[".wire_out"];
                if (message[".wire_debug_in"] != null && message.hasOwnProperty(".wire_debug_in"))
                    object[".wire_debug_in"] = message[".wire_debug_in"];
                if (message[".wire_debug_out"] != null && message.hasOwnProperty(".wire_debug_out"))
                    object[".wire_debug_out"] = message[".wire_debug_out"];
                if (message[".wire_tiny"] != null && message.hasOwnProperty(".wire_tiny"))
                    object[".wire_tiny"] = message[".wire_tiny"];
                if (message[".wire_bootloader"] != null && message.hasOwnProperty(".wire_bootloader"))
                    object[".wire_bootloader"] = message[".wire_bootloader"];
                if (message[".wire_no_fsm"] != null && message.hasOwnProperty(".wire_no_fsm"))
                    object[".wire_no_fsm"] = message[".wire_no_fsm"];
                if (message[".facotry"] != null && message.hasOwnProperty(".facotry"))
                    object[".facotry"] = message[".facotry"];
                if (message[".bitcoin_only"] != null && message.hasOwnProperty(".bitcoin_only"))
                    object[".bitcoin_only"] = message[".bitcoin_only"];
                return object;
            };

            EnumValueOptions.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return EnumValueOptions;
        })();

        protobuf.ServiceOptions = (function() {

            function ServiceOptions(properties) {
                this.uninterpreted_option = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            ServiceOptions.prototype.deprecated = false;
            ServiceOptions.prototype.uninterpreted_option = $util.emptyArray;

            ServiceOptions.create = function create(properties) {
                return new ServiceOptions(properties);
            };

            ServiceOptions.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.deprecated != null && Object.hasOwnProperty.call(message, "deprecated"))
                    writer.uint32(264).bool(message.deprecated);
                if (message.uninterpreted_option != null && message.uninterpreted_option.length)
                    for (var i = 0; i < message.uninterpreted_option.length; ++i)
                        $root.google.protobuf.UninterpretedOption.encode(message.uninterpreted_option[i], writer.uint32(7994).fork()).ldelim();
                return writer;
            };

            ServiceOptions.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            ServiceOptions.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.ServiceOptions();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 33:
                        message.deprecated = reader.bool();
                        break;
                    case 999:
                        if (!(message.uninterpreted_option && message.uninterpreted_option.length))
                            message.uninterpreted_option = [];
                        message.uninterpreted_option.push($root.google.protobuf.UninterpretedOption.decode(reader, reader.uint32()));
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            ServiceOptions.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            ServiceOptions.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.deprecated != null && message.hasOwnProperty("deprecated"))
                    if (typeof message.deprecated !== "boolean")
                        return "deprecated: boolean expected";
                if (message.uninterpreted_option != null && message.hasOwnProperty("uninterpreted_option")) {
                    if (!Array.isArray(message.uninterpreted_option))
                        return "uninterpreted_option: array expected";
                    for (var i = 0; i < message.uninterpreted_option.length; ++i) {
                        var error = $root.google.protobuf.UninterpretedOption.verify(message.uninterpreted_option[i]);
                        if (error)
                            return "uninterpreted_option." + error;
                    }
                }
                return null;
            };

            ServiceOptions.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.ServiceOptions)
                    return object;
                var message = new $root.google.protobuf.ServiceOptions();
                if (object.deprecated != null)
                    message.deprecated = Boolean(object.deprecated);
                if (object.uninterpreted_option) {
                    if (!Array.isArray(object.uninterpreted_option))
                        throw TypeError(".google.protobuf.ServiceOptions.uninterpreted_option: array expected");
                    message.uninterpreted_option = [];
                    for (var i = 0; i < object.uninterpreted_option.length; ++i) {
                        if (typeof object.uninterpreted_option[i] !== "object")
                            throw TypeError(".google.protobuf.ServiceOptions.uninterpreted_option: object expected");
                        message.uninterpreted_option[i] = $root.google.protobuf.UninterpretedOption.fromObject(object.uninterpreted_option[i]);
                    }
                }
                return message;
            };

            ServiceOptions.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.uninterpreted_option = [];
                if (options.defaults)
                    object.deprecated = false;
                if (message.deprecated != null && message.hasOwnProperty("deprecated"))
                    object.deprecated = message.deprecated;
                if (message.uninterpreted_option && message.uninterpreted_option.length) {
                    object.uninterpreted_option = [];
                    for (var j = 0; j < message.uninterpreted_option.length; ++j)
                        object.uninterpreted_option[j] = $root.google.protobuf.UninterpretedOption.toObject(message.uninterpreted_option[j], options);
                }
                return object;
            };

            ServiceOptions.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return ServiceOptions;
        })();

        protobuf.MethodOptions = (function() {

            function MethodOptions(properties) {
                this.uninterpreted_option = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            MethodOptions.prototype.deprecated = false;
            MethodOptions.prototype.uninterpreted_option = $util.emptyArray;

            MethodOptions.create = function create(properties) {
                return new MethodOptions(properties);
            };

            MethodOptions.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.deprecated != null && Object.hasOwnProperty.call(message, "deprecated"))
                    writer.uint32(264).bool(message.deprecated);
                if (message.uninterpreted_option != null && message.uninterpreted_option.length)
                    for (var i = 0; i < message.uninterpreted_option.length; ++i)
                        $root.google.protobuf.UninterpretedOption.encode(message.uninterpreted_option[i], writer.uint32(7994).fork()).ldelim();
                return writer;
            };

            MethodOptions.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            MethodOptions.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.MethodOptions();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 33:
                        message.deprecated = reader.bool();
                        break;
                    case 999:
                        if (!(message.uninterpreted_option && message.uninterpreted_option.length))
                            message.uninterpreted_option = [];
                        message.uninterpreted_option.push($root.google.protobuf.UninterpretedOption.decode(reader, reader.uint32()));
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            MethodOptions.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            MethodOptions.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.deprecated != null && message.hasOwnProperty("deprecated"))
                    if (typeof message.deprecated !== "boolean")
                        return "deprecated: boolean expected";
                if (message.uninterpreted_option != null && message.hasOwnProperty("uninterpreted_option")) {
                    if (!Array.isArray(message.uninterpreted_option))
                        return "uninterpreted_option: array expected";
                    for (var i = 0; i < message.uninterpreted_option.length; ++i) {
                        var error = $root.google.protobuf.UninterpretedOption.verify(message.uninterpreted_option[i]);
                        if (error)
                            return "uninterpreted_option." + error;
                    }
                }
                return null;
            };

            MethodOptions.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.MethodOptions)
                    return object;
                var message = new $root.google.protobuf.MethodOptions();
                if (object.deprecated != null)
                    message.deprecated = Boolean(object.deprecated);
                if (object.uninterpreted_option) {
                    if (!Array.isArray(object.uninterpreted_option))
                        throw TypeError(".google.protobuf.MethodOptions.uninterpreted_option: array expected");
                    message.uninterpreted_option = [];
                    for (var i = 0; i < object.uninterpreted_option.length; ++i) {
                        if (typeof object.uninterpreted_option[i] !== "object")
                            throw TypeError(".google.protobuf.MethodOptions.uninterpreted_option: object expected");
                        message.uninterpreted_option[i] = $root.google.protobuf.UninterpretedOption.fromObject(object.uninterpreted_option[i]);
                    }
                }
                return message;
            };

            MethodOptions.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.uninterpreted_option = [];
                if (options.defaults)
                    object.deprecated = false;
                if (message.deprecated != null && message.hasOwnProperty("deprecated"))
                    object.deprecated = message.deprecated;
                if (message.uninterpreted_option && message.uninterpreted_option.length) {
                    object.uninterpreted_option = [];
                    for (var j = 0; j < message.uninterpreted_option.length; ++j)
                        object.uninterpreted_option[j] = $root.google.protobuf.UninterpretedOption.toObject(message.uninterpreted_option[j], options);
                }
                return object;
            };

            MethodOptions.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return MethodOptions;
        })();

        protobuf.UninterpretedOption = (function() {

            function UninterpretedOption(properties) {
                this.name = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            UninterpretedOption.prototype.name = $util.emptyArray;
            UninterpretedOption.prototype.identifier_value = "";
            UninterpretedOption.prototype.positive_int_value = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
            UninterpretedOption.prototype.negative_int_value = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
            UninterpretedOption.prototype.double_value = 0;
            UninterpretedOption.prototype.string_value = $util.newBuffer([]);
            UninterpretedOption.prototype.aggregate_value = "";

            UninterpretedOption.create = function create(properties) {
                return new UninterpretedOption(properties);
            };

            UninterpretedOption.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.name != null && message.name.length)
                    for (var i = 0; i < message.name.length; ++i)
                        $root.google.protobuf.UninterpretedOption.NamePart.encode(message.name[i], writer.uint32(18).fork()).ldelim();
                if (message.identifier_value != null && Object.hasOwnProperty.call(message, "identifier_value"))
                    writer.uint32(26).string(message.identifier_value);
                if (message.positive_int_value != null && Object.hasOwnProperty.call(message, "positive_int_value"))
                    writer.uint32(32).uint64(message.positive_int_value);
                if (message.negative_int_value != null && Object.hasOwnProperty.call(message, "negative_int_value"))
                    writer.uint32(40).int64(message.negative_int_value);
                if (message.double_value != null && Object.hasOwnProperty.call(message, "double_value"))
                    writer.uint32(49).double(message.double_value);
                if (message.string_value != null && Object.hasOwnProperty.call(message, "string_value"))
                    writer.uint32(58).bytes(message.string_value);
                if (message.aggregate_value != null && Object.hasOwnProperty.call(message, "aggregate_value"))
                    writer.uint32(66).string(message.aggregate_value);
                return writer;
            };

            UninterpretedOption.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            UninterpretedOption.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.UninterpretedOption();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 2:
                        if (!(message.name && message.name.length))
                            message.name = [];
                        message.name.push($root.google.protobuf.UninterpretedOption.NamePart.decode(reader, reader.uint32()));
                        break;
                    case 3:
                        message.identifier_value = reader.string();
                        break;
                    case 4:
                        message.positive_int_value = reader.uint64();
                        break;
                    case 5:
                        message.negative_int_value = reader.int64();
                        break;
                    case 6:
                        message.double_value = reader.double();
                        break;
                    case 7:
                        message.string_value = reader.bytes();
                        break;
                    case 8:
                        message.aggregate_value = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            UninterpretedOption.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            UninterpretedOption.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.name != null && message.hasOwnProperty("name")) {
                    if (!Array.isArray(message.name))
                        return "name: array expected";
                    for (var i = 0; i < message.name.length; ++i) {
                        var error = $root.google.protobuf.UninterpretedOption.NamePart.verify(message.name[i]);
                        if (error)
                            return "name." + error;
                    }
                }
                if (message.identifier_value != null && message.hasOwnProperty("identifier_value"))
                    if (!$util.isString(message.identifier_value))
                        return "identifier_value: string expected";
                if (message.positive_int_value != null && message.hasOwnProperty("positive_int_value"))
                    if (!$util.isInteger(message.positive_int_value) && !(message.positive_int_value && $util.isInteger(message.positive_int_value.low) && $util.isInteger(message.positive_int_value.high)))
                        return "positive_int_value: integer|Long expected";
                if (message.negative_int_value != null && message.hasOwnProperty("negative_int_value"))
                    if (!$util.isInteger(message.negative_int_value) && !(message.negative_int_value && $util.isInteger(message.negative_int_value.low) && $util.isInteger(message.negative_int_value.high)))
                        return "negative_int_value: integer|Long expected";
                if (message.double_value != null && message.hasOwnProperty("double_value"))
                    if (typeof message.double_value !== "number")
                        return "double_value: number expected";
                if (message.string_value != null && message.hasOwnProperty("string_value"))
                    if (!(message.string_value && typeof message.string_value.length === "number" || $util.isString(message.string_value)))
                        return "string_value: buffer expected";
                if (message.aggregate_value != null && message.hasOwnProperty("aggregate_value"))
                    if (!$util.isString(message.aggregate_value))
                        return "aggregate_value: string expected";
                return null;
            };

            UninterpretedOption.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.UninterpretedOption)
                    return object;
                var message = new $root.google.protobuf.UninterpretedOption();
                if (object.name) {
                    if (!Array.isArray(object.name))
                        throw TypeError(".google.protobuf.UninterpretedOption.name: array expected");
                    message.name = [];
                    for (var i = 0; i < object.name.length; ++i) {
                        if (typeof object.name[i] !== "object")
                            throw TypeError(".google.protobuf.UninterpretedOption.name: object expected");
                        message.name[i] = $root.google.protobuf.UninterpretedOption.NamePart.fromObject(object.name[i]);
                    }
                }
                if (object.identifier_value != null)
                    message.identifier_value = String(object.identifier_value);
                if (object.positive_int_value != null)
                    if ($util.Long)
                        (message.positive_int_value = $util.Long.fromValue(object.positive_int_value)).unsigned = true;
                    else if (typeof object.positive_int_value === "string")
                        message.positive_int_value = parseInt(object.positive_int_value, 10);
                    else if (typeof object.positive_int_value === "number")
                        message.positive_int_value = object.positive_int_value;
                    else if (typeof object.positive_int_value === "object")
                        message.positive_int_value = new $util.LongBits(object.positive_int_value.low >>> 0, object.positive_int_value.high >>> 0).toNumber(true);
                if (object.negative_int_value != null)
                    if ($util.Long)
                        (message.negative_int_value = $util.Long.fromValue(object.negative_int_value)).unsigned = false;
                    else if (typeof object.negative_int_value === "string")
                        message.negative_int_value = parseInt(object.negative_int_value, 10);
                    else if (typeof object.negative_int_value === "number")
                        message.negative_int_value = object.negative_int_value;
                    else if (typeof object.negative_int_value === "object")
                        message.negative_int_value = new $util.LongBits(object.negative_int_value.low >>> 0, object.negative_int_value.high >>> 0).toNumber();
                if (object.double_value != null)
                    message.double_value = Number(object.double_value);
                if (object.string_value != null)
                    if (typeof object.string_value === "string")
                        $util.base64.decode(object.string_value, message.string_value = $util.newBuffer($util.base64.length(object.string_value)), 0);
                    else if (object.string_value.length)
                        message.string_value = object.string_value;
                if (object.aggregate_value != null)
                    message.aggregate_value = String(object.aggregate_value);
                return message;
            };

            UninterpretedOption.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.name = [];
                if (options.defaults) {
                    object.identifier_value = "";
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, true);
                        object.positive_int_value = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.positive_int_value = options.longs === String ? "0" : 0;
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.negative_int_value = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.negative_int_value = options.longs === String ? "0" : 0;
                    object.double_value = 0;
                    if (options.bytes === String)
                        object.string_value = "";
                    else {
                        object.string_value = [];
                        if (options.bytes !== Array)
                            object.string_value = $util.newBuffer(object.string_value);
                    }
                    object.aggregate_value = "";
                }
                if (message.name && message.name.length) {
                    object.name = [];
                    for (var j = 0; j < message.name.length; ++j)
                        object.name[j] = $root.google.protobuf.UninterpretedOption.NamePart.toObject(message.name[j], options);
                }
                if (message.identifier_value != null && message.hasOwnProperty("identifier_value"))
                    object.identifier_value = message.identifier_value;
                if (message.positive_int_value != null && message.hasOwnProperty("positive_int_value"))
                    if (typeof message.positive_int_value === "number")
                        object.positive_int_value = options.longs === String ? String(message.positive_int_value) : message.positive_int_value;
                    else
                        object.positive_int_value = options.longs === String ? $util.Long.prototype.toString.call(message.positive_int_value) : options.longs === Number ? new $util.LongBits(message.positive_int_value.low >>> 0, message.positive_int_value.high >>> 0).toNumber(true) : message.positive_int_value;
                if (message.negative_int_value != null && message.hasOwnProperty("negative_int_value"))
                    if (typeof message.negative_int_value === "number")
                        object.negative_int_value = options.longs === String ? String(message.negative_int_value) : message.negative_int_value;
                    else
                        object.negative_int_value = options.longs === String ? $util.Long.prototype.toString.call(message.negative_int_value) : options.longs === Number ? new $util.LongBits(message.negative_int_value.low >>> 0, message.negative_int_value.high >>> 0).toNumber() : message.negative_int_value;
                if (message.double_value != null && message.hasOwnProperty("double_value"))
                    object.double_value = options.json && !isFinite(message.double_value) ? String(message.double_value) : message.double_value;
                if (message.string_value != null && message.hasOwnProperty("string_value"))
                    object.string_value = options.bytes === String ? $util.base64.encode(message.string_value, 0, message.string_value.length) : options.bytes === Array ? Array.prototype.slice.call(message.string_value) : message.string_value;
                if (message.aggregate_value != null && message.hasOwnProperty("aggregate_value"))
                    object.aggregate_value = message.aggregate_value;
                return object;
            };

            UninterpretedOption.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            UninterpretedOption.NamePart = (function() {

                function NamePart(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                NamePart.prototype.name_part = "";
                NamePart.prototype.is_extension = false;

                NamePart.create = function create(properties) {
                    return new NamePart(properties);
                };

                NamePart.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    writer.uint32(10).string(message.name_part);
                    writer.uint32(16).bool(message.is_extension);
                    return writer;
                };

                NamePart.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                NamePart.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.UninterpretedOption.NamePart();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.name_part = reader.string();
                            break;
                        case 2:
                            message.is_extension = reader.bool();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    if (!message.hasOwnProperty("name_part"))
                        throw $util.ProtocolError("missing required 'name_part'", { instance: message });
                    if (!message.hasOwnProperty("is_extension"))
                        throw $util.ProtocolError("missing required 'is_extension'", { instance: message });
                    return message;
                };

                NamePart.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                NamePart.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (!$util.isString(message.name_part))
                        return "name_part: string expected";
                    if (typeof message.is_extension !== "boolean")
                        return "is_extension: boolean expected";
                    return null;
                };

                NamePart.fromObject = function fromObject(object) {
                    if (object instanceof $root.google.protobuf.UninterpretedOption.NamePart)
                        return object;
                    var message = new $root.google.protobuf.UninterpretedOption.NamePart();
                    if (object.name_part != null)
                        message.name_part = String(object.name_part);
                    if (object.is_extension != null)
                        message.is_extension = Boolean(object.is_extension);
                    return message;
                };

                NamePart.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.name_part = "";
                        object.is_extension = false;
                    }
                    if (message.name_part != null && message.hasOwnProperty("name_part"))
                        object.name_part = message.name_part;
                    if (message.is_extension != null && message.hasOwnProperty("is_extension"))
                        object.is_extension = message.is_extension;
                    return object;
                };

                NamePart.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return NamePart;
            })();

            return UninterpretedOption;
        })();

        protobuf.SourceCodeInfo = (function() {

            function SourceCodeInfo(properties) {
                this.location = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            SourceCodeInfo.prototype.location = $util.emptyArray;

            SourceCodeInfo.create = function create(properties) {
                return new SourceCodeInfo(properties);
            };

            SourceCodeInfo.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.location != null && message.location.length)
                    for (var i = 0; i < message.location.length; ++i)
                        $root.google.protobuf.SourceCodeInfo.Location.encode(message.location[i], writer.uint32(10).fork()).ldelim();
                return writer;
            };

            SourceCodeInfo.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            SourceCodeInfo.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.SourceCodeInfo();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (!(message.location && message.location.length))
                            message.location = [];
                        message.location.push($root.google.protobuf.SourceCodeInfo.Location.decode(reader, reader.uint32()));
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            SourceCodeInfo.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            SourceCodeInfo.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.location != null && message.hasOwnProperty("location")) {
                    if (!Array.isArray(message.location))
                        return "location: array expected";
                    for (var i = 0; i < message.location.length; ++i) {
                        var error = $root.google.protobuf.SourceCodeInfo.Location.verify(message.location[i]);
                        if (error)
                            return "location." + error;
                    }
                }
                return null;
            };

            SourceCodeInfo.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.SourceCodeInfo)
                    return object;
                var message = new $root.google.protobuf.SourceCodeInfo();
                if (object.location) {
                    if (!Array.isArray(object.location))
                        throw TypeError(".google.protobuf.SourceCodeInfo.location: array expected");
                    message.location = [];
                    for (var i = 0; i < object.location.length; ++i) {
                        if (typeof object.location[i] !== "object")
                            throw TypeError(".google.protobuf.SourceCodeInfo.location: object expected");
                        message.location[i] = $root.google.protobuf.SourceCodeInfo.Location.fromObject(object.location[i]);
                    }
                }
                return message;
            };

            SourceCodeInfo.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.location = [];
                if (message.location && message.location.length) {
                    object.location = [];
                    for (var j = 0; j < message.location.length; ++j)
                        object.location[j] = $root.google.protobuf.SourceCodeInfo.Location.toObject(message.location[j], options);
                }
                return object;
            };

            SourceCodeInfo.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            SourceCodeInfo.Location = (function() {

                function Location(properties) {
                    this.path = [];
                    this.span = [];
                    this.leading_detached_comments = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                Location.prototype.path = $util.emptyArray;
                Location.prototype.span = $util.emptyArray;
                Location.prototype.leading_comments = "";
                Location.prototype.trailing_comments = "";
                Location.prototype.leading_detached_comments = $util.emptyArray;

                Location.create = function create(properties) {
                    return new Location(properties);
                };

                Location.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.path != null && message.path.length) {
                        writer.uint32(10).fork();
                        for (var i = 0; i < message.path.length; ++i)
                            writer.int32(message.path[i]);
                        writer.ldelim();
                    }
                    if (message.span != null && message.span.length) {
                        writer.uint32(18).fork();
                        for (var i = 0; i < message.span.length; ++i)
                            writer.int32(message.span[i]);
                        writer.ldelim();
                    }
                    if (message.leading_comments != null && Object.hasOwnProperty.call(message, "leading_comments"))
                        writer.uint32(26).string(message.leading_comments);
                    if (message.trailing_comments != null && Object.hasOwnProperty.call(message, "trailing_comments"))
                        writer.uint32(34).string(message.trailing_comments);
                    if (message.leading_detached_comments != null && message.leading_detached_comments.length)
                        for (var i = 0; i < message.leading_detached_comments.length; ++i)
                            writer.uint32(50).string(message.leading_detached_comments[i]);
                    return writer;
                };

                Location.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                Location.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.SourceCodeInfo.Location();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            if (!(message.path && message.path.length))
                                message.path = [];
                            if ((tag & 7) === 2) {
                                var end2 = reader.uint32() + reader.pos;
                                while (reader.pos < end2)
                                    message.path.push(reader.int32());
                            } else
                                message.path.push(reader.int32());
                            break;
                        case 2:
                            if (!(message.span && message.span.length))
                                message.span = [];
                            if ((tag & 7) === 2) {
                                var end2 = reader.uint32() + reader.pos;
                                while (reader.pos < end2)
                                    message.span.push(reader.int32());
                            } else
                                message.span.push(reader.int32());
                            break;
                        case 3:
                            message.leading_comments = reader.string();
                            break;
                        case 4:
                            message.trailing_comments = reader.string();
                            break;
                        case 6:
                            if (!(message.leading_detached_comments && message.leading_detached_comments.length))
                                message.leading_detached_comments = [];
                            message.leading_detached_comments.push(reader.string());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                Location.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                Location.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.path != null && message.hasOwnProperty("path")) {
                        if (!Array.isArray(message.path))
                            return "path: array expected";
                        for (var i = 0; i < message.path.length; ++i)
                            if (!$util.isInteger(message.path[i]))
                                return "path: integer[] expected";
                    }
                    if (message.span != null && message.hasOwnProperty("span")) {
                        if (!Array.isArray(message.span))
                            return "span: array expected";
                        for (var i = 0; i < message.span.length; ++i)
                            if (!$util.isInteger(message.span[i]))
                                return "span: integer[] expected";
                    }
                    if (message.leading_comments != null && message.hasOwnProperty("leading_comments"))
                        if (!$util.isString(message.leading_comments))
                            return "leading_comments: string expected";
                    if (message.trailing_comments != null && message.hasOwnProperty("trailing_comments"))
                        if (!$util.isString(message.trailing_comments))
                            return "trailing_comments: string expected";
                    if (message.leading_detached_comments != null && message.hasOwnProperty("leading_detached_comments")) {
                        if (!Array.isArray(message.leading_detached_comments))
                            return "leading_detached_comments: array expected";
                        for (var i = 0; i < message.leading_detached_comments.length; ++i)
                            if (!$util.isString(message.leading_detached_comments[i]))
                                return "leading_detached_comments: string[] expected";
                    }
                    return null;
                };

                Location.fromObject = function fromObject(object) {
                    if (object instanceof $root.google.protobuf.SourceCodeInfo.Location)
                        return object;
                    var message = new $root.google.protobuf.SourceCodeInfo.Location();
                    if (object.path) {
                        if (!Array.isArray(object.path))
                            throw TypeError(".google.protobuf.SourceCodeInfo.Location.path: array expected");
                        message.path = [];
                        for (var i = 0; i < object.path.length; ++i)
                            message.path[i] = object.path[i] | 0;
                    }
                    if (object.span) {
                        if (!Array.isArray(object.span))
                            throw TypeError(".google.protobuf.SourceCodeInfo.Location.span: array expected");
                        message.span = [];
                        for (var i = 0; i < object.span.length; ++i)
                            message.span[i] = object.span[i] | 0;
                    }
                    if (object.leading_comments != null)
                        message.leading_comments = String(object.leading_comments);
                    if (object.trailing_comments != null)
                        message.trailing_comments = String(object.trailing_comments);
                    if (object.leading_detached_comments) {
                        if (!Array.isArray(object.leading_detached_comments))
                            throw TypeError(".google.protobuf.SourceCodeInfo.Location.leading_detached_comments: array expected");
                        message.leading_detached_comments = [];
                        for (var i = 0; i < object.leading_detached_comments.length; ++i)
                            message.leading_detached_comments[i] = String(object.leading_detached_comments[i]);
                    }
                    return message;
                };

                Location.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults) {
                        object.path = [];
                        object.span = [];
                        object.leading_detached_comments = [];
                    }
                    if (options.defaults) {
                        object.leading_comments = "";
                        object.trailing_comments = "";
                    }
                    if (message.path && message.path.length) {
                        object.path = [];
                        for (var j = 0; j < message.path.length; ++j)
                            object.path[j] = message.path[j];
                    }
                    if (message.span && message.span.length) {
                        object.span = [];
                        for (var j = 0; j < message.span.length; ++j)
                            object.span[j] = message.span[j];
                    }
                    if (message.leading_comments != null && message.hasOwnProperty("leading_comments"))
                        object.leading_comments = message.leading_comments;
                    if (message.trailing_comments != null && message.hasOwnProperty("trailing_comments"))
                        object.trailing_comments = message.trailing_comments;
                    if (message.leading_detached_comments && message.leading_detached_comments.length) {
                        object.leading_detached_comments = [];
                        for (var j = 0; j < message.leading_detached_comments.length; ++j)
                            object.leading_detached_comments[j] = message.leading_detached_comments[j];
                    }
                    return object;
                };

                Location.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return Location;
            })();

            return SourceCodeInfo;
        })();

        protobuf.GeneratedCodeInfo = (function() {

            function GeneratedCodeInfo(properties) {
                this.annotation = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            GeneratedCodeInfo.prototype.annotation = $util.emptyArray;

            GeneratedCodeInfo.create = function create(properties) {
                return new GeneratedCodeInfo(properties);
            };

            GeneratedCodeInfo.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.annotation != null && message.annotation.length)
                    for (var i = 0; i < message.annotation.length; ++i)
                        $root.google.protobuf.GeneratedCodeInfo.Annotation.encode(message.annotation[i], writer.uint32(10).fork()).ldelim();
                return writer;
            };

            GeneratedCodeInfo.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            GeneratedCodeInfo.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.GeneratedCodeInfo();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (!(message.annotation && message.annotation.length))
                            message.annotation = [];
                        message.annotation.push($root.google.protobuf.GeneratedCodeInfo.Annotation.decode(reader, reader.uint32()));
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            GeneratedCodeInfo.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            GeneratedCodeInfo.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.annotation != null && message.hasOwnProperty("annotation")) {
                    if (!Array.isArray(message.annotation))
                        return "annotation: array expected";
                    for (var i = 0; i < message.annotation.length; ++i) {
                        var error = $root.google.protobuf.GeneratedCodeInfo.Annotation.verify(message.annotation[i]);
                        if (error)
                            return "annotation." + error;
                    }
                }
                return null;
            };

            GeneratedCodeInfo.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.GeneratedCodeInfo)
                    return object;
                var message = new $root.google.protobuf.GeneratedCodeInfo();
                if (object.annotation) {
                    if (!Array.isArray(object.annotation))
                        throw TypeError(".google.protobuf.GeneratedCodeInfo.annotation: array expected");
                    message.annotation = [];
                    for (var i = 0; i < object.annotation.length; ++i) {
                        if (typeof object.annotation[i] !== "object")
                            throw TypeError(".google.protobuf.GeneratedCodeInfo.annotation: object expected");
                        message.annotation[i] = $root.google.protobuf.GeneratedCodeInfo.Annotation.fromObject(object.annotation[i]);
                    }
                }
                return message;
            };

            GeneratedCodeInfo.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.annotation = [];
                if (message.annotation && message.annotation.length) {
                    object.annotation = [];
                    for (var j = 0; j < message.annotation.length; ++j)
                        object.annotation[j] = $root.google.protobuf.GeneratedCodeInfo.Annotation.toObject(message.annotation[j], options);
                }
                return object;
            };

            GeneratedCodeInfo.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            GeneratedCodeInfo.Annotation = (function() {

                function Annotation(properties) {
                    this.path = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                Annotation.prototype.path = $util.emptyArray;
                Annotation.prototype.source_file = "";
                Annotation.prototype.begin = 0;
                Annotation.prototype.end = 0;

                Annotation.create = function create(properties) {
                    return new Annotation(properties);
                };

                Annotation.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.path != null && message.path.length) {
                        writer.uint32(10).fork();
                        for (var i = 0; i < message.path.length; ++i)
                            writer.int32(message.path[i]);
                        writer.ldelim();
                    }
                    if (message.source_file != null && Object.hasOwnProperty.call(message, "source_file"))
                        writer.uint32(18).string(message.source_file);
                    if (message.begin != null && Object.hasOwnProperty.call(message, "begin"))
                        writer.uint32(24).int32(message.begin);
                    if (message.end != null && Object.hasOwnProperty.call(message, "end"))
                        writer.uint32(32).int32(message.end);
                    return writer;
                };

                Annotation.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                Annotation.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.GeneratedCodeInfo.Annotation();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            if (!(message.path && message.path.length))
                                message.path = [];
                            if ((tag & 7) === 2) {
                                var end2 = reader.uint32() + reader.pos;
                                while (reader.pos < end2)
                                    message.path.push(reader.int32());
                            } else
                                message.path.push(reader.int32());
                            break;
                        case 2:
                            message.source_file = reader.string();
                            break;
                        case 3:
                            message.begin = reader.int32();
                            break;
                        case 4:
                            message.end = reader.int32();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                Annotation.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                Annotation.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.path != null && message.hasOwnProperty("path")) {
                        if (!Array.isArray(message.path))
                            return "path: array expected";
                        for (var i = 0; i < message.path.length; ++i)
                            if (!$util.isInteger(message.path[i]))
                                return "path: integer[] expected";
                    }
                    if (message.source_file != null && message.hasOwnProperty("source_file"))
                        if (!$util.isString(message.source_file))
                            return "source_file: string expected";
                    if (message.begin != null && message.hasOwnProperty("begin"))
                        if (!$util.isInteger(message.begin))
                            return "begin: integer expected";
                    if (message.end != null && message.hasOwnProperty("end"))
                        if (!$util.isInteger(message.end))
                            return "end: integer expected";
                    return null;
                };

                Annotation.fromObject = function fromObject(object) {
                    if (object instanceof $root.google.protobuf.GeneratedCodeInfo.Annotation)
                        return object;
                    var message = new $root.google.protobuf.GeneratedCodeInfo.Annotation();
                    if (object.path) {
                        if (!Array.isArray(object.path))
                            throw TypeError(".google.protobuf.GeneratedCodeInfo.Annotation.path: array expected");
                        message.path = [];
                        for (var i = 0; i < object.path.length; ++i)
                            message.path[i] = object.path[i] | 0;
                    }
                    if (object.source_file != null)
                        message.source_file = String(object.source_file);
                    if (object.begin != null)
                        message.begin = object.begin | 0;
                    if (object.end != null)
                        message.end = object.end | 0;
                    return message;
                };

                Annotation.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.path = [];
                    if (options.defaults) {
                        object.source_file = "";
                        object.begin = 0;
                        object.end = 0;
                    }
                    if (message.path && message.path.length) {
                        object.path = [];
                        for (var j = 0; j < message.path.length; ++j)
                            object.path[j] = message.path[j];
                    }
                    if (message.source_file != null && message.hasOwnProperty("source_file"))
                        object.source_file = message.source_file;
                    if (message.begin != null && message.hasOwnProperty("begin"))
                        object.begin = message.begin;
                    if (message.end != null && message.hasOwnProperty("end"))
                        object.end = message.end;
                    return object;
                };

                Annotation.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return Annotation;
            })();

            return GeneratedCodeInfo;
        })();

        return protobuf;
    })();

    return google;
})();
return {".AlgorandGetAddress": $root["AlgorandGetAddress"],
".AlgorandAddress": $root["AlgorandAddress"],
".AlgorandSignTx": $root["AlgorandSignTx"],
".AlgorandSignedTx": $root["AlgorandSignedTx"],
".AptosGetAddress": $root["AptosGetAddress"],
".AptosAddress": $root["AptosAddress"],
".AptosSignTx": $root["AptosSignTx"],
".AptosSignedTx": $root["AptosSignedTx"],
".AptosSignMessage": $root["AptosSignMessage"],
".AptosSignMessage.AptosMessagePayload": $root["AptosSignMessage"]["AptosMessagePayload"],
".AptosMessageSignature": $root["AptosMessageSignature"],
".BinanceGetAddress": $root["BinanceGetAddress"],
".BinanceAddress": $root["BinanceAddress"],
".BinanceGetPublicKey": $root["BinanceGetPublicKey"],
".BinancePublicKey": $root["BinancePublicKey"],
".BinanceSignTx": $root["BinanceSignTx"],
".BinanceTxRequest": $root["BinanceTxRequest"],
".BinanceTransferMsg": $root["BinanceTransferMsg"],
".BinanceTransferMsg.BinanceInputOutput": $root["BinanceTransferMsg"]["BinanceInputOutput"],
".BinanceTransferMsg.BinanceCoin": $root["BinanceTransferMsg"]["BinanceCoin"],
".BinanceOrderMsg": $root["BinanceOrderMsg"],
".BinanceCancelMsg": $root["BinanceCancelMsg"],
".BinanceSignedTx": $root["BinanceSignedTx"],
".MultisigRedeemScriptType": $root["MultisigRedeemScriptType"],
".MultisigRedeemScriptType.HDNodePathType": $root["MultisigRedeemScriptType"]["HDNodePathType"],
".GetPublicKey": $root["GetPublicKey"],
".PublicKey": $root["PublicKey"],
".GetAddress": $root["GetAddress"],
".Address": $root["Address"],
".GetOwnershipId": $root["GetOwnershipId"],
".OwnershipId": $root["OwnershipId"],
".SignMessage": $root["SignMessage"],
".MessageSignature": $root["MessageSignature"],
".VerifyMessage": $root["VerifyMessage"],
".SignTx": $root["SignTx"],
".TxRequest": $root["TxRequest"],
".TxRequest.TxRequestDetailsType": $root["TxRequest"]["TxRequestDetailsType"],
".TxRequest.TxRequestSerializedType": $root["TxRequest"]["TxRequestSerializedType"],
".TxAck": $root["TxAck"],
".TxAck.TransactionType": $root["TxAck"]["TransactionType"],
".TxAck.TransactionType.TxInputType": $root["TxAck"]["TransactionType"]["TxInputType"],
".TxAck.TransactionType.TxOutputBinType": $root["TxAck"]["TransactionType"]["TxOutputBinType"],
".TxAck.TransactionType.TxOutputType": $root["TxAck"]["TransactionType"]["TxOutputType"],
".TxInput": $root["TxInput"],
".TxOutput": $root["TxOutput"],
".PrevTx": $root["PrevTx"],
".PrevInput": $root["PrevInput"],
".PrevOutput": $root["PrevOutput"],
".TxAckInput": $root["TxAckInput"],
".TxAckInput.TxAckInputWrapper": $root["TxAckInput"]["TxAckInputWrapper"],
".TxAckOutput": $root["TxAckOutput"],
".TxAckOutput.TxAckOutputWrapper": $root["TxAckOutput"]["TxAckOutputWrapper"],
".TxAckPrevMeta": $root["TxAckPrevMeta"],
".TxAckPrevInput": $root["TxAckPrevInput"],
".TxAckPrevInput.TxAckPrevInputWrapper": $root["TxAckPrevInput"]["TxAckPrevInputWrapper"],
".TxAckPrevOutput": $root["TxAckPrevOutput"],
".TxAckPrevOutput.TxAckPrevOutputWrapper": $root["TxAckPrevOutput"]["TxAckPrevOutputWrapper"],
".TxAckPrevExtraData": $root["TxAckPrevExtraData"],
".TxAckPrevExtraData.TxAckPrevExtraDataWrapper": $root["TxAckPrevExtraData"]["TxAckPrevExtraDataWrapper"],
".GetOwnershipProof": $root["GetOwnershipProof"],
".OwnershipProof": $root["OwnershipProof"],
".AuthorizeCoinJoin": $root["AuthorizeCoinJoin"],
".GetPublicKeyMultiple": $root["GetPublicKeyMultiple"],
".GetPublicKeyMultiple.BIP32Address": $root["GetPublicKeyMultiple"]["BIP32Address"],
".PublicKeyMultiple": $root["PublicKeyMultiple"],
".FirmwareErase": $root["FirmwareErase"],
".FirmwareRequest": $root["FirmwareRequest"],
".FirmwareUpload": $root["FirmwareUpload"],
".SelfTest": $root["SelfTest"],
".FirmwareErase_ex": $root["FirmwareErase_ex"],
".Reboot": $root["Reboot"],
".FirmwareUpdateEmmc": $root["FirmwareUpdateEmmc"],
".CardanoBlockchainPointerType": $root["CardanoBlockchainPointerType"],
".CardanoNativeScript": $root["CardanoNativeScript"],
".CardanoGetNativeScriptHash": $root["CardanoGetNativeScriptHash"],
".CardanoNativeScriptHash": $root["CardanoNativeScriptHash"],
".CardanoAddressParametersType": $root["CardanoAddressParametersType"],
".CardanoGetAddress": $root["CardanoGetAddress"],
".CardanoAddress": $root["CardanoAddress"],
".CardanoGetPublicKey": $root["CardanoGetPublicKey"],
".CardanoPublicKey": $root["CardanoPublicKey"],
".CardanoSignTxInit": $root["CardanoSignTxInit"],
".CardanoTxInput": $root["CardanoTxInput"],
".CardanoTxOutput": $root["CardanoTxOutput"],
".CardanoAssetGroup": $root["CardanoAssetGroup"],
".CardanoToken": $root["CardanoToken"],
".CardanoTxInlineDatumChunk": $root["CardanoTxInlineDatumChunk"],
".CardanoTxReferenceScriptChunk": $root["CardanoTxReferenceScriptChunk"],
".CardanoPoolOwner": $root["CardanoPoolOwner"],
".CardanoPoolRelayParameters": $root["CardanoPoolRelayParameters"],
".CardanoPoolMetadataType": $root["CardanoPoolMetadataType"],
".CardanoPoolParametersType": $root["CardanoPoolParametersType"],
".CardanoTxCertificate": $root["CardanoTxCertificate"],
".CardanoTxWithdrawal": $root["CardanoTxWithdrawal"],
".CardanoGovernanceRegistrationDelegation": $root["CardanoGovernanceRegistrationDelegation"],
".CardanoGovernanceRegistrationParametersType": $root["CardanoGovernanceRegistrationParametersType"],
".CardanoTxAuxiliaryData": $root["CardanoTxAuxiliaryData"],
".CardanoTxMint": $root["CardanoTxMint"],
".CardanoTxCollateralInput": $root["CardanoTxCollateralInput"],
".CardanoTxRequiredSigner": $root["CardanoTxRequiredSigner"],
".CardanoTxReferenceInput": $root["CardanoTxReferenceInput"],
".CardanoTxItemAck": $root["CardanoTxItemAck"],
".CardanoTxAuxiliaryDataSupplement": $root["CardanoTxAuxiliaryDataSupplement"],
".CardanoTxWitnessRequest": $root["CardanoTxWitnessRequest"],
".CardanoTxWitnessResponse": $root["CardanoTxWitnessResponse"],
".CardanoTxHostAck": $root["CardanoTxHostAck"],
".CardanoTxBodyHash": $root["CardanoTxBodyHash"],
".CardanoSignTxFinished": $root["CardanoSignTxFinished"],
".CardanoSignMessage": $root["CardanoSignMessage"],
".CardanoMessageSignature": $root["CardanoMessageSignature"],
".Success": $root["Success"],
".Failure": $root["Failure"],
".ButtonRequest": $root["ButtonRequest"],
".ButtonAck": $root["ButtonAck"],
".PinMatrixRequest": $root["PinMatrixRequest"],
".PinMatrixAck": $root["PinMatrixAck"],
".PassphraseRequest": $root["PassphraseRequest"],
".PassphraseAck": $root["PassphraseAck"],
".Deprecated_PassphraseStateRequest": $root["Deprecated_PassphraseStateRequest"],
".Deprecated_PassphraseStateAck": $root["Deprecated_PassphraseStateAck"],
".HDNodeType": $root["HDNodeType"],
".BixinPinInputOnDevice": $root["BixinPinInputOnDevice"],
".ConfluxGetAddress": $root["ConfluxGetAddress"],
".ConfluxAddress": $root["ConfluxAddress"],
".ConfluxSignTx": $root["ConfluxSignTx"],
".ConfluxTxRequest": $root["ConfluxTxRequest"],
".ConfluxTxAck": $root["ConfluxTxAck"],
".ConfluxSignMessage": $root["ConfluxSignMessage"],
".ConfluxMessageSignature": $root["ConfluxMessageSignature"],
".ConfluxSignMessageCIP23": $root["ConfluxSignMessageCIP23"],
".CosmosGetAddress": $root["CosmosGetAddress"],
".CosmosAddress": $root["CosmosAddress"],
".CosmosSignTx": $root["CosmosSignTx"],
".CosmosSignedTx": $root["CosmosSignedTx"],
".CipherKeyValue": $root["CipherKeyValue"],
".CipheredKeyValue": $root["CipheredKeyValue"],
".IdentityType": $root["IdentityType"],
".SignIdentity": $root["SignIdentity"],
".SignedIdentity": $root["SignedIdentity"],
".GetECDHSessionKey": $root["GetECDHSessionKey"],
".ECDHSessionKey": $root["ECDHSessionKey"],
".CosiCommit": $root["CosiCommit"],
".CosiCommitment": $root["CosiCommitment"],
".CosiSign": $root["CosiSign"],
".CosiSignature": $root["CosiSignature"],
".BatchGetPublickeys": $root["BatchGetPublickeys"],
".BatchGetPublickeys.Path": $root["BatchGetPublickeys"]["Path"],
".EcdsaPublicKeys": $root["EcdsaPublicKeys"],
".DebugLinkDecision": $root["DebugLinkDecision"],
".DebugLinkLayout": $root["DebugLinkLayout"],
".DebugLinkReseedRandom": $root["DebugLinkReseedRandom"],
".DebugLinkRecordScreen": $root["DebugLinkRecordScreen"],
".DebugLinkGetState": $root["DebugLinkGetState"],
".DebugLinkState": $root["DebugLinkState"],
".DebugLinkStop": $root["DebugLinkStop"],
".DebugLinkLog": $root["DebugLinkLog"],
".DebugLinkMemoryRead": $root["DebugLinkMemoryRead"],
".DebugLinkMemory": $root["DebugLinkMemory"],
".DebugLinkMemoryWrite": $root["DebugLinkMemoryWrite"],
".DebugLinkFlashErase": $root["DebugLinkFlashErase"],
".DebugLinkEraseSdCard": $root["DebugLinkEraseSdCard"],
".DebugLinkWatchLayout": $root["DebugLinkWatchLayout"],
".EmmcFixPermission": $root["EmmcFixPermission"],
".EmmcPath": $root["EmmcPath"],
".EmmcPathInfo": $root["EmmcPathInfo"],
".EmmcFile": $root["EmmcFile"],
".EmmcFileRead": $root["EmmcFileRead"],
".EmmcFileWrite": $root["EmmcFileWrite"],
".EmmcFileDelete": $root["EmmcFileDelete"],
".EmmcDir": $root["EmmcDir"],
".EmmcDirList": $root["EmmcDirList"],
".EmmcDirMake": $root["EmmcDirMake"],
".EmmcDirRemove": $root["EmmcDirRemove"],
".EosGetPublicKey": $root["EosGetPublicKey"],
".EosPublicKey": $root["EosPublicKey"],
".EosSignTx": $root["EosSignTx"],
".EosSignTx.EosTxHeader": $root["EosSignTx"]["EosTxHeader"],
".EosTxActionRequest": $root["EosTxActionRequest"],
".EosTxActionAck": $root["EosTxActionAck"],
".EosTxActionAck.EosAsset": $root["EosTxActionAck"]["EosAsset"],
".EosTxActionAck.EosPermissionLevel": $root["EosTxActionAck"]["EosPermissionLevel"],
".EosTxActionAck.EosAuthorizationKey": $root["EosTxActionAck"]["EosAuthorizationKey"],
".EosTxActionAck.EosAuthorizationAccount": $root["EosTxActionAck"]["EosAuthorizationAccount"],
".EosTxActionAck.EosAuthorizationWait": $root["EosTxActionAck"]["EosAuthorizationWait"],
".EosTxActionAck.EosAuthorization": $root["EosTxActionAck"]["EosAuthorization"],
".EosTxActionAck.EosActionCommon": $root["EosTxActionAck"]["EosActionCommon"],
".EosTxActionAck.EosActionTransfer": $root["EosTxActionAck"]["EosActionTransfer"],
".EosTxActionAck.EosActionDelegate": $root["EosTxActionAck"]["EosActionDelegate"],
".EosTxActionAck.EosActionUndelegate": $root["EosTxActionAck"]["EosActionUndelegate"],
".EosTxActionAck.EosActionRefund": $root["EosTxActionAck"]["EosActionRefund"],
".EosTxActionAck.EosActionBuyRam": $root["EosTxActionAck"]["EosActionBuyRam"],
".EosTxActionAck.EosActionBuyRamBytes": $root["EosTxActionAck"]["EosActionBuyRamBytes"],
".EosTxActionAck.EosActionSellRam": $root["EosTxActionAck"]["EosActionSellRam"],
".EosTxActionAck.EosActionVoteProducer": $root["EosTxActionAck"]["EosActionVoteProducer"],
".EosTxActionAck.EosActionUpdateAuth": $root["EosTxActionAck"]["EosActionUpdateAuth"],
".EosTxActionAck.EosActionDeleteAuth": $root["EosTxActionAck"]["EosActionDeleteAuth"],
".EosTxActionAck.EosActionLinkAuth": $root["EosTxActionAck"]["EosActionLinkAuth"],
".EosTxActionAck.EosActionUnlinkAuth": $root["EosTxActionAck"]["EosActionUnlinkAuth"],
".EosTxActionAck.EosActionNewAccount": $root["EosTxActionAck"]["EosActionNewAccount"],
".EosTxActionAck.EosActionUnknown": $root["EosTxActionAck"]["EosActionUnknown"],
".EosSignedTx": $root["EosSignedTx"],
".EthereumSignTypedData": $root["EthereumSignTypedData"],
".EthereumTypedDataStructRequest": $root["EthereumTypedDataStructRequest"],
".EthereumTypedDataStructAck": $root["EthereumTypedDataStructAck"],
".EthereumTypedDataStructAck.EthereumStructMember": $root["EthereumTypedDataStructAck"]["EthereumStructMember"],
".EthereumTypedDataStructAck.EthereumFieldType": $root["EthereumTypedDataStructAck"]["EthereumFieldType"],
".EthereumTypedDataValueRequest": $root["EthereumTypedDataValueRequest"],
".EthereumTypedDataValueAck": $root["EthereumTypedDataValueAck"],
".EthereumGetPublicKey": $root["EthereumGetPublicKey"],
".EthereumPublicKey": $root["EthereumPublicKey"],
".EthereumGetAddress": $root["EthereumGetAddress"],
".EthereumAddress": $root["EthereumAddress"],
".EthereumSignTx": $root["EthereumSignTx"],
".EthereumSignTxEIP1559": $root["EthereumSignTxEIP1559"],
".EthereumSignTxEIP1559.EthereumAccessList": $root["EthereumSignTxEIP1559"]["EthereumAccessList"],
".EthereumTxRequest": $root["EthereumTxRequest"],
".EthereumTxAck": $root["EthereumTxAck"],
".EthereumSignMessage": $root["EthereumSignMessage"],
".EthereumMessageSignature": $root["EthereumMessageSignature"],
".EthereumVerifyMessage": $root["EthereumVerifyMessage"],
".EthereumSignMessageEIP712": $root["EthereumSignMessageEIP712"],
".EthereumSignTypedHash": $root["EthereumSignTypedHash"],
".EthereumTypedDataSignature": $root["EthereumTypedDataSignature"],
".FilecoinGetAddress": $root["FilecoinGetAddress"],
".FilecoinAddress": $root["FilecoinAddress"],
".FilecoinSignTx": $root["FilecoinSignTx"],
".FilecoinSignedTx": $root["FilecoinSignedTx"],
".KaspaGetAddress": $root["KaspaGetAddress"],
".KaspaAddress": $root["KaspaAddress"],
".KaspaSignTx": $root["KaspaSignTx"],
".KaspaTxInputRequest": $root["KaspaTxInputRequest"],
".KaspaTxInputAck": $root["KaspaTxInputAck"],
".KaspaSignedTx": $root["KaspaSignedTx"],
".Initialize": $root["Initialize"],
".GetFeatures": $root["GetFeatures"],
".Features": $root["Features"],
".LockDevice": $root["LockDevice"],
".EndSession": $root["EndSession"],
".ApplySettings": $root["ApplySettings"],
".ApplyFlags": $root["ApplyFlags"],
".ChangePin": $root["ChangePin"],
".ChangeWipeCode": $root["ChangeWipeCode"],
".SdProtect": $root["SdProtect"],
".Ping": $root["Ping"],
".Cancel": $root["Cancel"],
".GetEntropy": $root["GetEntropy"],
".Entropy": $root["Entropy"],
".WipeDevice": $root["WipeDevice"],
".LoadDevice": $root["LoadDevice"],
".ResetDevice": $root["ResetDevice"],
".BackupDevice": $root["BackupDevice"],
".EntropyRequest": $root["EntropyRequest"],
".EntropyAck": $root["EntropyAck"],
".RecoveryDevice": $root["RecoveryDevice"],
".WordRequest": $root["WordRequest"],
".WordAck": $root["WordAck"],
".SetU2FCounter": $root["SetU2FCounter"],
".GetNextU2FCounter": $root["GetNextU2FCounter"],
".NextU2FCounter": $root["NextU2FCounter"],
".DoPreauthorized": $root["DoPreauthorized"],
".PreauthorizedRequest": $root["PreauthorizedRequest"],
".CancelAuthorization": $root["CancelAuthorization"],
".BixinSeedOperate": $root["BixinSeedOperate"],
".BixinMessageSE": $root["BixinMessageSE"],
".BixinOutMessageSE": $root["BixinOutMessageSE"],
".DeviceBackToBoot": $root["DeviceBackToBoot"],
".BixinBackupRequest": $root["BixinBackupRequest"],
".BixinBackupAck": $root["BixinBackupAck"],
".BixinRestoreRequest": $root["BixinRestoreRequest"],
".BixinRestoreAck": $root["BixinRestoreAck"],
".BixinVerifyDeviceRequest": $root["BixinVerifyDeviceRequest"],
".BixinVerifyDeviceAck": $root["BixinVerifyDeviceAck"],
".BixinWhiteListRequest": $root["BixinWhiteListRequest"],
".BixinWhiteListAck": $root["BixinWhiteListAck"],
".BixinLoadDevice": $root["BixinLoadDevice"],
".BixinBackupDevice": $root["BixinBackupDevice"],
".BixinBackupDeviceAck": $root["BixinBackupDeviceAck"],
".DeviceInfoSettings": $root["DeviceInfoSettings"],
".GetDeviceInfo": $root["GetDeviceInfo"],
".DeviceInfo": $root["DeviceInfo"],
".ReadSEPublicKey": $root["ReadSEPublicKey"],
".SEPublicKey": $root["SEPublicKey"],
".WriteSEPublicCert": $root["WriteSEPublicCert"],
".ReadSEPublicCert": $root["ReadSEPublicCert"],
".SEPublicCert": $root["SEPublicCert"],
".SpiFlashWrite": $root["SpiFlashWrite"],
".SpiFlashRead": $root["SpiFlashRead"],
".SpiFlashData": $root["SpiFlashData"],
".SESignMessage": $root["SESignMessage"],
".SEMessageSignature": $root["SEMessageSignature"],
".ResourceUpload": $root["ResourceUpload"],
".ZoomRequest": $root["ZoomRequest"],
".ResourceRequest": $root["ResourceRequest"],
".ResourceAck": $root["ResourceAck"],
".ResourceUpdate": $root["ResourceUpdate"],
".NFTWriteInfo": $root["NFTWriteInfo"],
".NFTWriteData": $root["NFTWriteData"],
".RebootToBootloader": $root["RebootToBootloader"],
".RebootToBoardloader": $root["RebootToBoardloader"],
".ListResDir": $root["ListResDir"],
".FileInfoList": $root["FileInfoList"],
".FileInfoList.FileInfo": $root["FileInfoList"]["FileInfo"],
".DeviceEraseSector": $root["DeviceEraseSector"],
".MoneroTransactionSourceEntry": $root["MoneroTransactionSourceEntry"],
".MoneroTransactionSourceEntry.MoneroOutputEntry": $root["MoneroTransactionSourceEntry"]["MoneroOutputEntry"],
".MoneroTransactionSourceEntry.MoneroOutputEntry.MoneroRctKeyPublic": $root["MoneroTransactionSourceEntry"]["MoneroOutputEntry"]["MoneroRctKeyPublic"],
".MoneroTransactionSourceEntry.MoneroMultisigKLRki": $root["MoneroTransactionSourceEntry"]["MoneroMultisigKLRki"],
".MoneroTransactionDestinationEntry": $root["MoneroTransactionDestinationEntry"],
".MoneroTransactionDestinationEntry.MoneroAccountPublicAddress": $root["MoneroTransactionDestinationEntry"]["MoneroAccountPublicAddress"],
".MoneroTransactionRsigData": $root["MoneroTransactionRsigData"],
".MoneroGetAddress": $root["MoneroGetAddress"],
".MoneroAddress": $root["MoneroAddress"],
".MoneroGetWatchKey": $root["MoneroGetWatchKey"],
".MoneroWatchKey": $root["MoneroWatchKey"],
".MoneroTransactionInitRequest": $root["MoneroTransactionInitRequest"],
".MoneroTransactionInitRequest.MoneroTransactionData": $root["MoneroTransactionInitRequest"]["MoneroTransactionData"],
".MoneroTransactionInitAck": $root["MoneroTransactionInitAck"],
".MoneroTransactionSetInputRequest": $root["MoneroTransactionSetInputRequest"],
".MoneroTransactionSetInputAck": $root["MoneroTransactionSetInputAck"],
".MoneroTransactionInputsPermutationRequest": $root["MoneroTransactionInputsPermutationRequest"],
".MoneroTransactionInputsPermutationAck": $root["MoneroTransactionInputsPermutationAck"],
".MoneroTransactionInputViniRequest": $root["MoneroTransactionInputViniRequest"],
".MoneroTransactionInputViniAck": $root["MoneroTransactionInputViniAck"],
".MoneroTransactionAllInputsSetRequest": $root["MoneroTransactionAllInputsSetRequest"],
".MoneroTransactionAllInputsSetAck": $root["MoneroTransactionAllInputsSetAck"],
".MoneroTransactionSetOutputRequest": $root["MoneroTransactionSetOutputRequest"],
".MoneroTransactionSetOutputAck": $root["MoneroTransactionSetOutputAck"],
".MoneroTransactionAllOutSetRequest": $root["MoneroTransactionAllOutSetRequest"],
".MoneroTransactionAllOutSetAck": $root["MoneroTransactionAllOutSetAck"],
".MoneroTransactionAllOutSetAck.MoneroRingCtSig": $root["MoneroTransactionAllOutSetAck"]["MoneroRingCtSig"],
".MoneroTransactionSignInputRequest": $root["MoneroTransactionSignInputRequest"],
".MoneroTransactionSignInputAck": $root["MoneroTransactionSignInputAck"],
".MoneroTransactionFinalRequest": $root["MoneroTransactionFinalRequest"],
".MoneroTransactionFinalAck": $root["MoneroTransactionFinalAck"],
".MoneroKeyImageExportInitRequest": $root["MoneroKeyImageExportInitRequest"],
".MoneroKeyImageExportInitRequest.MoneroSubAddressIndicesList": $root["MoneroKeyImageExportInitRequest"]["MoneroSubAddressIndicesList"],
".MoneroKeyImageExportInitAck": $root["MoneroKeyImageExportInitAck"],
".MoneroKeyImageSyncStepRequest": $root["MoneroKeyImageSyncStepRequest"],
".MoneroKeyImageSyncStepRequest.MoneroTransferDetails": $root["MoneroKeyImageSyncStepRequest"]["MoneroTransferDetails"],
".MoneroKeyImageSyncStepAck": $root["MoneroKeyImageSyncStepAck"],
".MoneroKeyImageSyncStepAck.MoneroExportedKeyImage": $root["MoneroKeyImageSyncStepAck"]["MoneroExportedKeyImage"],
".MoneroKeyImageSyncFinalRequest": $root["MoneroKeyImageSyncFinalRequest"],
".MoneroKeyImageSyncFinalAck": $root["MoneroKeyImageSyncFinalAck"],
".MoneroGetTxKeyRequest": $root["MoneroGetTxKeyRequest"],
".MoneroGetTxKeyAck": $root["MoneroGetTxKeyAck"],
".MoneroLiveRefreshStartRequest": $root["MoneroLiveRefreshStartRequest"],
".MoneroLiveRefreshStartAck": $root["MoneroLiveRefreshStartAck"],
".MoneroLiveRefreshStepRequest": $root["MoneroLiveRefreshStepRequest"],
".MoneroLiveRefreshStepAck": $root["MoneroLiveRefreshStepAck"],
".MoneroLiveRefreshFinalRequest": $root["MoneroLiveRefreshFinalRequest"],
".MoneroLiveRefreshFinalAck": $root["MoneroLiveRefreshFinalAck"],
".DebugMoneroDiagRequest": $root["DebugMoneroDiagRequest"],
".DebugMoneroDiagAck": $root["DebugMoneroDiagAck"],
".NearGetAddress": $root["NearGetAddress"],
".NearAddress": $root["NearAddress"],
".NearSignTx": $root["NearSignTx"],
".NearSignedTx": $root["NearSignedTx"],
".NEMGetAddress": $root["NEMGetAddress"],
".NEMAddress": $root["NEMAddress"],
".NEMSignTx": $root["NEMSignTx"],
".NEMSignTx.NEMTransactionCommon": $root["NEMSignTx"]["NEMTransactionCommon"],
".NEMSignTx.NEMTransfer": $root["NEMSignTx"]["NEMTransfer"],
".NEMSignTx.NEMTransfer.NEMMosaic": $root["NEMSignTx"]["NEMTransfer"]["NEMMosaic"],
".NEMSignTx.NEMProvisionNamespace": $root["NEMSignTx"]["NEMProvisionNamespace"],
".NEMSignTx.NEMMosaicCreation": $root["NEMSignTx"]["NEMMosaicCreation"],
".NEMSignTx.NEMMosaicCreation.NEMMosaicDefinition": $root["NEMSignTx"]["NEMMosaicCreation"]["NEMMosaicDefinition"],
".NEMSignTx.NEMMosaicSupplyChange": $root["NEMSignTx"]["NEMMosaicSupplyChange"],
".NEMSignTx.NEMAggregateModification": $root["NEMSignTx"]["NEMAggregateModification"],
".NEMSignTx.NEMAggregateModification.NEMCosignatoryModification": $root["NEMSignTx"]["NEMAggregateModification"]["NEMCosignatoryModification"],
".NEMSignTx.NEMImportanceTransfer": $root["NEMSignTx"]["NEMImportanceTransfer"],
".NEMSignedTx": $root["NEMSignedTx"],
".NEMDecryptMessage": $root["NEMDecryptMessage"],
".NEMDecryptedMessage": $root["NEMDecryptedMessage"],
".NexaGetAddress": $root["NexaGetAddress"],
".NexaAddress": $root["NexaAddress"],
".NexaSignTx": $root["NexaSignTx"],
".NexaTxInputRequest": $root["NexaTxInputRequest"],
".NexaTxInputAck": $root["NexaTxInputAck"],
".NexaSignedTx": $root["NexaSignedTx"],
".PolkadotGetAddress": $root["PolkadotGetAddress"],
".PolkadotAddress": $root["PolkadotAddress"],
".PolkadotSignTx": $root["PolkadotSignTx"],
".PolkadotSignedTx": $root["PolkadotSignedTx"],
".RippleGetAddress": $root["RippleGetAddress"],
".RippleAddress": $root["RippleAddress"],
".RippleSignTx": $root["RippleSignTx"],
".RippleSignTx.RipplePayment": $root["RippleSignTx"]["RipplePayment"],
".RippleSignedTx": $root["RippleSignedTx"],
".SolanaGetAddress": $root["SolanaGetAddress"],
".SolanaAddress": $root["SolanaAddress"],
".SolanaSignTx": $root["SolanaSignTx"],
".SolanaSignedTx": $root["SolanaSignedTx"],
".StarcoinGetAddress": $root["StarcoinGetAddress"],
".StarcoinAddress": $root["StarcoinAddress"],
".StarcoinGetPublicKey": $root["StarcoinGetPublicKey"],
".StarcoinPublicKey": $root["StarcoinPublicKey"],
".StarcoinSignTx": $root["StarcoinSignTx"],
".StarcoinSignedTx": $root["StarcoinSignedTx"],
".StarcoinSignMessage": $root["StarcoinSignMessage"],
".StarcoinMessageSignature": $root["StarcoinMessageSignature"],
".StarcoinVerifyMessage": $root["StarcoinVerifyMessage"],
".StellarAsset": $root["StellarAsset"],
".StellarGetAddress": $root["StellarGetAddress"],
".StellarAddress": $root["StellarAddress"],
".StellarSignTx": $root["StellarSignTx"],
".StellarTxOpRequest": $root["StellarTxOpRequest"],
".StellarPaymentOp": $root["StellarPaymentOp"],
".StellarCreateAccountOp": $root["StellarCreateAccountOp"],
".StellarPathPaymentStrictReceiveOp": $root["StellarPathPaymentStrictReceiveOp"],
".StellarPathPaymentStrictSendOp": $root["StellarPathPaymentStrictSendOp"],
".StellarManageSellOfferOp": $root["StellarManageSellOfferOp"],
".StellarManageBuyOfferOp": $root["StellarManageBuyOfferOp"],
".StellarCreatePassiveSellOfferOp": $root["StellarCreatePassiveSellOfferOp"],
".StellarSetOptionsOp": $root["StellarSetOptionsOp"],
".StellarChangeTrustOp": $root["StellarChangeTrustOp"],
".StellarAllowTrustOp": $root["StellarAllowTrustOp"],
".StellarAccountMergeOp": $root["StellarAccountMergeOp"],
".StellarManageDataOp": $root["StellarManageDataOp"],
".StellarBumpSequenceOp": $root["StellarBumpSequenceOp"],
".StellarSignedTx": $root["StellarSignedTx"],
".SuiGetAddress": $root["SuiGetAddress"],
".SuiAddress": $root["SuiAddress"],
".SuiSignTx": $root["SuiSignTx"],
".SuiSignedTx": $root["SuiSignedTx"],
".TezosGetAddress": $root["TezosGetAddress"],
".TezosAddress": $root["TezosAddress"],
".TezosGetPublicKey": $root["TezosGetPublicKey"],
".TezosPublicKey": $root["TezosPublicKey"],
".TezosSignTx": $root["TezosSignTx"],
".TezosSignTx.TezosContractID": $root["TezosSignTx"]["TezosContractID"],
".TezosSignTx.TezosRevealOp": $root["TezosSignTx"]["TezosRevealOp"],
".TezosSignTx.TezosTransactionOp": $root["TezosSignTx"]["TezosTransactionOp"],
".TezosSignTx.TezosTransactionOp.TezosParametersManager": $root["TezosSignTx"]["TezosTransactionOp"]["TezosParametersManager"],
".TezosSignTx.TezosTransactionOp.TezosParametersManager.TezosManagerTransfer": $root["TezosSignTx"]["TezosTransactionOp"]["TezosParametersManager"]["TezosManagerTransfer"],
".TezosSignTx.TezosOriginationOp": $root["TezosSignTx"]["TezosOriginationOp"],
".TezosSignTx.TezosDelegationOp": $root["TezosSignTx"]["TezosDelegationOp"],
".TezosSignTx.TezosProposalOp": $root["TezosSignTx"]["TezosProposalOp"],
".TezosSignTx.TezosBallotOp": $root["TezosSignTx"]["TezosBallotOp"],
".TezosSignedTx": $root["TezosSignedTx"],
".TronGetAddress": $root["TronGetAddress"],
".TronAddress": $root["TronAddress"],
".TronSignTx": $root["TronSignTx"],
".TronSignTx.TronContract": $root["TronSignTx"]["TronContract"],
".TronSignTx.TronContract.TronTransferContract": $root["TronSignTx"]["TronContract"]["TronTransferContract"],
".TronSignTx.TronContract.TronTriggerSmartContract": $root["TronSignTx"]["TronContract"]["TronTriggerSmartContract"],
".TronSignTx.TronContract.TronFreezeBalanceContract": $root["TronSignTx"]["TronContract"]["TronFreezeBalanceContract"],
".TronSignTx.TronContract.TronUnfreezeBalanceContract": $root["TronSignTx"]["TronContract"]["TronUnfreezeBalanceContract"],
".TronSignTx.TronContract.TronWithdrawBalanceContract": $root["TronSignTx"]["TronContract"]["TronWithdrawBalanceContract"],
".TronSignTx.TronContract.TronFreezeBalanceV2Contract": $root["TronSignTx"]["TronContract"]["TronFreezeBalanceV2Contract"],
".TronSignTx.TronContract.TronUnfreezeBalanceV2Contract": $root["TronSignTx"]["TronContract"]["TronUnfreezeBalanceV2Contract"],
".TronSignTx.TronContract.TronWithdrawExpireUnfreezeContract": $root["TronSignTx"]["TronContract"]["TronWithdrawExpireUnfreezeContract"],
".TronSignTx.TronContract.TronDelegateResourceContract": $root["TronSignTx"]["TronContract"]["TronDelegateResourceContract"],
".TronSignTx.TronContract.TronUnDelegateResourceContract": $root["TronSignTx"]["TronContract"]["TronUnDelegateResourceContract"],
".TronSignedTx": $root["TronSignedTx"],
".TronSignMessage": $root["TronSignMessage"],
".TronMessageSignature": $root["TronMessageSignature"],
".WebAuthnListResidentCredentials": $root["WebAuthnListResidentCredentials"],
".WebAuthnAddResidentCredential": $root["WebAuthnAddResidentCredential"],
".WebAuthnRemoveResidentCredential": $root["WebAuthnRemoveResidentCredential"],
".WebAuthnCredentials": $root["WebAuthnCredentials"],
".WebAuthnCredentials.WebAuthnCredential": $root["WebAuthnCredentials"]["WebAuthnCredential"],
".google.protobuf.FileDescriptorSet": $root["google"]["protobuf"]["FileDescriptorSet"],
".google.protobuf.FileDescriptorProto": $root["google"]["protobuf"]["FileDescriptorProto"],
".google.protobuf.DescriptorProto": $root["google"]["protobuf"]["DescriptorProto"],
".google.protobuf.DescriptorProto.ExtensionRange": $root["google"]["protobuf"]["DescriptorProto"]["ExtensionRange"],
".google.protobuf.DescriptorProto.ReservedRange": $root["google"]["protobuf"]["DescriptorProto"]["ReservedRange"],
".google.protobuf.FieldDescriptorProto": $root["google"]["protobuf"]["FieldDescriptorProto"],
".google.protobuf.OneofDescriptorProto": $root["google"]["protobuf"]["OneofDescriptorProto"],
".google.protobuf.EnumDescriptorProto": $root["google"]["protobuf"]["EnumDescriptorProto"],
".google.protobuf.EnumValueDescriptorProto": $root["google"]["protobuf"]["EnumValueDescriptorProto"],
".google.protobuf.ServiceDescriptorProto": $root["google"]["protobuf"]["ServiceDescriptorProto"],
".google.protobuf.MethodDescriptorProto": $root["google"]["protobuf"]["MethodDescriptorProto"],
".google.protobuf.FileOptions": $root["google"]["protobuf"]["FileOptions"],
".google.protobuf.MessageOptions": $root["google"]["protobuf"]["MessageOptions"],
".google.protobuf.FieldOptions": $root["google"]["protobuf"]["FieldOptions"],
".google.protobuf.OneofOptions": $root["google"]["protobuf"]["OneofOptions"],
".google.protobuf.EnumOptions": $root["google"]["protobuf"]["EnumOptions"],
".google.protobuf.EnumValueOptions": $root["google"]["protobuf"]["EnumValueOptions"],
".google.protobuf.ServiceOptions": $root["google"]["protobuf"]["ServiceOptions"],
".google.protobuf.MethodOptions": $root["google"]["protobuf"]["MethodOptions"],
".google.protobuf.UninterpretedOption": $root["google"]["protobuf"]["UninterpretedOption"],
".google.protobuf.UninterpretedOption.NamePart": $root["google"]["protobuf"]["UninterpretedOption"]["NamePart"],
".google.protobuf.SourceCodeInfo": $root["google"]["protobuf"]["SourceCodeInfo"],
".google.protobuf.SourceCodeInfo.Location": $root["google"]["protobuf"]["SourceCodeInfo"]["Location"],
".google.protobuf.GeneratedCodeInfo": $root["google"]["protobuf"]["GeneratedCodeInfo"],
".google.protobuf.GeneratedCodeInfo.Annotation": $root["google"]["protobuf"]["GeneratedCodeInfo"]["Annotation"]};
},
"{\"nested\":{\"Address\":{\"fields\":{\"address\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"},\"mac\":{\"id\":2,\"type\":\"bytes\"}}},\"AlephiumAddress\":{\"fields\":{\"address\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"},\"derived_path\":{\"id\":3,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"public_key\":{\"id\":2,\"type\":\"bytes\"}}},\"AlephiumBytecodeAck\":{\"fields\":{\"bytecode_data\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"AlephiumBytecodeRequest\":{\"fields\":{\"data_length\":{\"id\":1,\"type\":\"uint32\"},\"public_key\":{\"id\":2,\"type\":\"bytes\"},\"signature\":{\"id\":3,\"type\":\"bytes\"}}},\"AlephiumGetAddress\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"include_public_key\":{\"id\":3,\"type\":\"bool\"},\"show_display\":{\"id\":2,\"type\":\"bool\"},\"target_group\":{\"id\":4,\"type\":\"uint32\"}}},\"AlephiumMessageSignature\":{\"fields\":{\"address\":{\"id\":2,\"type\":\"string\"},\"signature\":{\"id\":1,\"type\":\"bytes\"}}},\"AlephiumSignMessage\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"message\":{\"id\":2,\"type\":\"bytes\"},\"message_type\":{\"id\":3,\"type\":\"bytes\"}}},\"AlephiumSignTx\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"data_initial_chunk\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"},\"data_length\":{\"id\":3,\"type\":\"uint32\"}}},\"AlephiumSignedTx\":{\"fields\":{\"address\":{\"id\":2,\"rule\":\"required\",\"type\":\"string\"},\"signature\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"AlephiumTxAck\":{\"fields\":{\"data_chunk\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"AlephiumTxRequest\":{\"fields\":{\"data_length\":{\"id\":1,\"type\":\"uint32\"},\"public_key\":{\"id\":2,\"type\":\"bytes\"},\"signature\":{\"id\":3,\"type\":\"bytes\"}}},\"AlgorandAddress\":{\"fields\":{\"address\":{\"id\":1,\"type\":\"string\"}}},\"AlgorandGetAddress\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"show_display\":{\"id\":3,\"type\":\"bool\"}}},\"AlgorandSignTx\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"raw_tx\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"AlgorandSignedTx\":{\"fields\":{\"signature\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"AmountUnit\":{\"values\":{\"BITCOIN\":0,\"MICROBITCOIN\":2,\"MILLIBITCOIN\":1,\"SATOSHI\":3}},\"ApplyFlags\":{\"fields\":{\"flags\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint32\"}}},\"ApplySettings\":{\"fields\":{\"_passphrase_source\":{\"id\":5,\"options\":{\"deprecated\":true},\"type\":\"uint32\"},\"auto_lock_delay_ms\":{\"id\":6,\"type\":\"uint32\"},\"display_rotation\":{\"id\":7,\"type\":\"uint32\"},\"experimental_features\":{\"id\":10,\"type\":\"bool\"},\"homescreen\":{\"id\":4,\"type\":\"bytes\"},\"label\":{\"id\":2,\"type\":\"string\"},\"language\":{\"id\":1,\"type\":\"string\"},\"passphrase_always_on_device\":{\"id\":8,\"type\":\"bool\"},\"safety_checks\":{\"id\":9,\"type\":\"SafetyCheckLevel\"},\"use_passphrase\":{\"id\":3,\"type\":\"bool\"}}},\"AptosAddress\":{\"fields\":{\"address\":{\"id\":1,\"type\":\"string\"}}},\"AptosGetAddress\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"show_display\":{\"id\":2,\"type\":\"bool\"}}},\"AptosMessageSignature\":{\"fields\":{\"address\":{\"id\":2,\"rule\":\"required\",\"type\":\"string\"},\"signature\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"AptosSignMessage\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"payload\":{\"id\":2,\"rule\":\"required\",\"type\":\"AptosMessagePayload\"}},\"nested\":{\"AptosMessagePayload\":{\"fields\":{\"address\":{\"id\":2,\"type\":\"string\"},\"application\":{\"id\":4,\"type\":\"string\"},\"chain_id\":{\"id\":3,\"type\":\"string\"},\"message\":{\"id\":6,\"rule\":\"required\",\"type\":\"string\"},\"nonce\":{\"id\":5,\"rule\":\"required\",\"type\":\"string\"}}}}},\"AptosSignSIWAMessage\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"siwa_payload\":{\"id\":2,\"rule\":\"required\",\"type\":\"string\"}}},\"AptosSignTx\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"raw_tx\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"},\"tx_type\":{\"id\":3,\"options\":{\"default\":\"STANDARD\"},\"type\":\"AptosTransactionType\"}}},\"AptosSignedTx\":{\"fields\":{\"public_key\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"},\"signature\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"AptosTransactionType\":{\"values\":{\"STANDARD\":0,\"WITH_DATA\":1}},\"AuthorizeCoinJoin\":{\"fields\":{\"address_n\":{\"id\":5,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"amount_unit\":{\"id\":8,\"options\":{\"default\":\"BITCOIN\"},\"type\":\"AmountUnit\"},\"coin_name\":{\"id\":6,\"options\":{\"default\":\"Bitcoin\"},\"type\":\"string\"},\"coordinator\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"},\"max_coordinator_fee_rate\":{\"id\":3,\"rule\":\"required\",\"type\":\"uint32\"},\"max_fee_per_kvbyte\":{\"id\":4,\"rule\":\"required\",\"type\":\"uint32\"},\"max_rounds\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint64\"},\"script_type\":{\"id\":7,\"options\":{\"default\":\"SPENDADDRESS\"},\"type\":\"InputScriptType\"}}},\"BackupDevice\":{\"fields\":{}},\"BackupType\":{\"values\":{\"Bip39\":0,\"Slip39_Advanced\":2,\"Slip39_Advanced_Extendable\":5,\"Slip39_Basic\":1,\"Slip39_Basic_Extendable\":4,\"Slip39_Single_Extendable\":3}},\"BatchGetPublickeys\":{\"fields\":{\"ecdsa_curve_name\":{\"id\":1,\"options\":{\"default\":\"ed25519\"},\"type\":\"string\"},\"include_node\":{\"id\":3,\"options\":{\"default\":false},\"type\":\"bool\"},\"paths\":{\"id\":2,\"rule\":\"repeated\",\"type\":\"Path\"}},\"nested\":{\"Path\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"}}}}},\"BenfenAddress\":{\"fields\":{\"address\":{\"id\":1,\"type\":\"string\"}}},\"BenfenGetAddress\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"show_display\":{\"id\":2,\"type\":\"bool\"}}},\"BenfenMessageSignature\":{\"fields\":{\"address\":{\"id\":2,\"rule\":\"required\",\"type\":\"string\"},\"signature\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"BenfenSignMessage\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"message\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"BenfenSignTx\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"coin_type\":{\"id\":4,\"type\":\"bytes\"},\"data_initial_chunk\":{\"id\":3,\"options\":{\"default\":\"\"},\"type\":\"bytes\"},\"data_length\":{\"id\":5,\"type\":\"uint32\"},\"raw_tx\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"BenfenSignedTx\":{\"fields\":{\"public_key\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"},\"signature\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"BenfenTxAck\":{\"fields\":{\"data_chunk\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"BenfenTxRequest\":{\"fields\":{\"data_length\":{\"id\":1,\"type\":\"uint32\"},\"public_key\":{\"id\":2,\"type\":\"bytes\"},\"signature\":{\"id\":3,\"type\":\"bytes\"}}},\"BinanceAddress\":{\"fields\":{\"address\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"}}},\"BinanceCancelMsg\":{\"fields\":{\"refid\":{\"id\":1,\"type\":\"string\"},\"sender\":{\"id\":2,\"type\":\"string\"},\"symbol\":{\"id\":3,\"type\":\"string\"}}},\"BinanceGetAddress\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"show_display\":{\"id\":2,\"type\":\"bool\"}}},\"BinanceGetPublicKey\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"show_display\":{\"id\":2,\"type\":\"bool\"}}},\"BinanceOrderMsg\":{\"fields\":{\"id\":{\"id\":1,\"type\":\"string\"},\"ordertype\":{\"id\":2,\"rule\":\"required\",\"type\":\"BinanceOrderType\"},\"price\":{\"id\":3,\"rule\":\"required\",\"type\":\"sint64\"},\"quantity\":{\"id\":4,\"rule\":\"required\",\"type\":\"sint64\"},\"sender\":{\"id\":5,\"type\":\"string\"},\"side\":{\"id\":6,\"rule\":\"required\",\"type\":\"BinanceOrderSide\"},\"symbol\":{\"id\":7,\"type\":\"string\"},\"timeinforce\":{\"id\":8,\"rule\":\"required\",\"type\":\"BinanceTimeInForce\"}},\"nested\":{\"BinanceOrderSide\":{\"values\":{\"BUY\":1,\"SELL\":2,\"SIDE_UNKNOWN\":0}},\"BinanceOrderType\":{\"values\":{\"LIMIT\":2,\"MARKET\":1,\"OT_RESERVED\":3,\"OT_UNKNOWN\":0}},\"BinanceTimeInForce\":{\"values\":{\"GTE\":1,\"IOC\":3,\"TIF_RESERVED\":2,\"TIF_UNKNOWN\":0}}}},\"BinancePublicKey\":{\"fields\":{\"public_key\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"BinanceSignTx\":{\"fields\":{\"account_number\":{\"id\":3,\"rule\":\"required\",\"type\":\"sint64\"},\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"chain_id\":{\"id\":4,\"type\":\"string\"},\"memo\":{\"id\":5,\"type\":\"string\"},\"msg_count\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint32\"},\"sequence\":{\"id\":6,\"rule\":\"required\",\"type\":\"sint64\"},\"source\":{\"id\":7,\"rule\":\"required\",\"type\":\"sint64\"}}},\"BinanceSignedTx\":{\"fields\":{\"public_key\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"},\"signature\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"BinanceTransferMsg\":{\"fields\":{\"inputs\":{\"id\":1,\"rule\":\"repeated\",\"type\":\"BinanceInputOutput\"},\"outputs\":{\"id\":2,\"rule\":\"repeated\",\"type\":\"BinanceInputOutput\"}},\"nested\":{\"BinanceCoin\":{\"fields\":{\"amount\":{\"id\":1,\"rule\":\"required\",\"type\":\"sint64\"},\"denom\":{\"id\":2,\"rule\":\"required\",\"type\":\"string\"}}},\"BinanceInputOutput\":{\"fields\":{\"address\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"},\"coins\":{\"id\":2,\"rule\":\"repeated\",\"type\":\"BinanceCoin\"}}}}},\"BinanceTxRequest\":{\"fields\":{}},\"BlurRequest\":{\"fields\":{\"data_length\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint32\"},\"offset\":{\"id\":1,\"type\":\"uint32\"}}},\"ButtonAck\":{\"fields\":{}},\"ButtonRequest\":{\"fields\":{\"code\":{\"id\":1,\"type\":\"ButtonRequestType\"},\"pages\":{\"id\":2,\"type\":\"uint32\"}},\"nested\":{\"ButtonRequestType\":{\"values\":{\"ButtonRequest_Address\":10,\"ButtonRequest_AttachPin\":8000,\"ButtonRequest_ConfirmOutput\":3,\"ButtonRequest_ConfirmWord\":5,\"ButtonRequest_FeeOverThreshold\":2,\"ButtonRequest_FirmwareCheck\":9,\"ButtonRequest_MnemonicInput\":13,\"ButtonRequest_MnemonicWordCount\":12,\"ButtonRequest_Other\":1,\"ButtonRequest_PassphraseEntry\":19,\"ButtonRequest_PinEntry\":20,\"ButtonRequest_ProtectCall\":7,\"ButtonRequest_PublicKey\":11,\"ButtonRequest_RecoveryHomepage\":16,\"ButtonRequest_ResetDevice\":4,\"ButtonRequest_SignTx\":8,\"ButtonRequest_Success\":17,\"ButtonRequest_UnknownDerivationPath\":15,\"ButtonRequest_Warning\":18,\"ButtonRequest_WipeDevice\":6,\"_Deprecated_ButtonRequest_PassphraseType\":14}}}},\"Cancel\":{\"fields\":{}},\"CancelAuthorization\":{\"fields\":{}},\"CardanoAddress\":{\"fields\":{\"address\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"}}},\"CardanoAddressParametersType\":{\"fields\":{\"address_n\":{\"id\":2,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"address_n_staking\":{\"id\":3,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"address_type\":{\"id\":1,\"rule\":\"required\",\"type\":\"CardanoAddressType\"},\"certificate_pointer\":{\"id\":5,\"type\":\"CardanoBlockchainPointerType\"},\"script_payment_hash\":{\"id\":6,\"type\":\"bytes\"},\"script_staking_hash\":{\"id\":7,\"type\":\"bytes\"},\"staking_key_hash\":{\"id\":4,\"type\":\"bytes\"}}},\"CardanoAddressType\":{\"values\":{\"BASE\":0,\"BASE_KEY_SCRIPT\":2,\"BASE_SCRIPT_KEY\":1,\"BASE_SCRIPT_SCRIPT\":3,\"BYRON\":8,\"ENTERPRISE\":6,\"ENTERPRISE_SCRIPT\":7,\"POINTER\":4,\"POINTER_SCRIPT\":5,\"REWARD\":14,\"REWARD_SCRIPT\":15}},\"CardanoAssetGroup\":{\"fields\":{\"policy_id\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"},\"tokens_count\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint32\"}}},\"CardanoBlockchainPointerType\":{\"fields\":{\"block_index\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint32\"},\"certificate_index\":{\"id\":3,\"rule\":\"required\",\"type\":\"uint32\"},\"tx_index\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint32\"}}},\"CardanoCVoteRegistrationDelegation\":{\"fields\":{\"vote_public_key\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"},\"weight\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint32\"}}},\"CardanoCVoteRegistrationFormat\":{\"values\":{\"CIP15\":0,\"CIP36\":1}},\"CardanoCVoteRegistrationParametersType\":{\"fields\":{\"delegations\":{\"id\":6,\"rule\":\"repeated\",\"type\":\"CardanoCVoteRegistrationDelegation\"},\"format\":{\"id\":5,\"options\":{\"default\":\"CIP15\"},\"type\":\"CardanoCVoteRegistrationFormat\"},\"nonce\":{\"id\":4,\"rule\":\"required\",\"type\":\"uint64\"},\"payment_address\":{\"id\":8,\"type\":\"string\"},\"payment_address_parameters\":{\"id\":3,\"type\":\"CardanoAddressParametersType\"},\"staking_path\":{\"id\":2,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"vote_public_key\":{\"id\":1,\"type\":\"bytes\"},\"voting_purpose\":{\"id\":7,\"type\":\"uint64\"}}},\"CardanoCertificateType\":{\"values\":{\"STAKE_DELEGATION\":2,\"STAKE_DEREGISTRATION\":1,\"STAKE_DEREGISTRATION_CONWAY\":8,\"STAKE_POOL_REGISTRATION\":3,\"STAKE_REGISTRATION\":0,\"STAKE_REGISTRATION_CONWAY\":7,\"VOTE_DELEGATION\":9}},\"CardanoDRep\":{\"fields\":{\"key_hash\":{\"id\":2,\"type\":\"bytes\"},\"script_hash\":{\"id\":3,\"type\":\"bytes\"},\"type\":{\"id\":1,\"rule\":\"required\",\"type\":\"CardanoDRepType\"}}},\"CardanoDRepType\":{\"values\":{\"ABSTAIN\":2,\"KEY_HASH\":0,\"NO_CONFIDENCE\":3,\"SCRIPT_HASH\":1}},\"CardanoDerivationType\":{\"values\":{\"ICARUS\":1,\"ICARUS_TREZOR\":2,\"LEDGER\":0}},\"CardanoGetAddress\":{\"fields\":{\"address_parameters\":{\"id\":5,\"rule\":\"required\",\"type\":\"CardanoAddressParametersType\"},\"chunkify\":{\"id\":7,\"type\":\"bool\"},\"derivation_type\":{\"id\":6,\"rule\":\"required\",\"type\":\"CardanoDerivationType\"},\"network_id\":{\"id\":4,\"rule\":\"required\",\"type\":\"uint32\"},\"protocol_magic\":{\"id\":3,\"rule\":\"required\",\"type\":\"uint32\"},\"show_display\":{\"id\":2,\"options\":{\"default\":false},\"type\":\"bool\"}}},\"CardanoGetNativeScriptHash\":{\"fields\":{\"derivation_type\":{\"id\":3,\"rule\":\"required\",\"type\":\"CardanoDerivationType\"},\"display_format\":{\"id\":2,\"rule\":\"required\",\"type\":\"CardanoNativeScriptHashDisplayFormat\"},\"script\":{\"id\":1,\"rule\":\"required\",\"type\":\"CardanoNativeScript\"}}},\"CardanoGetPublicKey\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"derivation_type\":{\"id\":3,\"rule\":\"required\",\"type\":\"CardanoDerivationType\"},\"show_display\":{\"id\":2,\"type\":\"bool\"}}},\"CardanoMessageSignature\":{\"fields\":{\"key\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"},\"signature\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"CardanoNativeScript\":{\"fields\":{\"invalid_before\":{\"id\":6,\"type\":\"uint64\"},\"invalid_hereafter\":{\"id\":7,\"type\":\"uint64\"},\"key_hash\":{\"id\":3,\"type\":\"bytes\"},\"key_path\":{\"id\":4,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"required_signatures_count\":{\"id\":5,\"type\":\"uint32\"},\"scripts\":{\"id\":2,\"rule\":\"repeated\",\"type\":\"CardanoNativeScript\"},\"type\":{\"id\":1,\"rule\":\"required\",\"type\":\"CardanoNativeScriptType\"}}},\"CardanoNativeScriptHash\":{\"fields\":{\"script_hash\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"CardanoNativeScriptHashDisplayFormat\":{\"values\":{\"BECH32\":1,\"HIDE\":0,\"POLICY_ID\":2}},\"CardanoNativeScriptType\":{\"values\":{\"ALL\":1,\"ANY\":2,\"INVALID_BEFORE\":4,\"INVALID_HEREAFTER\":5,\"N_OF_K\":3,\"PUB_KEY\":0}},\"CardanoPoolMetadataType\":{\"fields\":{\"hash\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"},\"url\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"}}},\"CardanoPoolOwner\":{\"fields\":{\"staking_key_hash\":{\"id\":2,\"type\":\"bytes\"},\"staking_key_path\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"}}},\"CardanoPoolParametersType\":{\"fields\":{\"cost\":{\"id\":4,\"rule\":\"required\",\"type\":\"uint64\"},\"margin_denominator\":{\"id\":6,\"rule\":\"required\",\"type\":\"uint64\"},\"margin_numerator\":{\"id\":5,\"rule\":\"required\",\"type\":\"uint64\"},\"metadata\":{\"id\":10,\"type\":\"CardanoPoolMetadataType\"},\"owners_count\":{\"id\":11,\"rule\":\"required\",\"type\":\"uint32\"},\"pledge\":{\"id\":3,\"rule\":\"required\",\"type\":\"uint64\"},\"pool_id\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"},\"relays_count\":{\"id\":12,\"rule\":\"required\",\"type\":\"uint32\"},\"reward_account\":{\"id\":7,\"rule\":\"required\",\"type\":\"string\"},\"vrf_key_hash\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"CardanoPoolRelayParameters\":{\"fields\":{\"host_name\":{\"id\":4,\"type\":\"string\"},\"ipv4_address\":{\"id\":2,\"type\":\"bytes\"},\"ipv6_address\":{\"id\":3,\"type\":\"bytes\"},\"port\":{\"id\":5,\"type\":\"uint32\"},\"type\":{\"id\":1,\"rule\":\"required\",\"type\":\"CardanoPoolRelayType\"}}},\"CardanoPoolRelayType\":{\"values\":{\"MULTIPLE_HOST_NAME\":2,\"SINGLE_HOST_IP\":0,\"SINGLE_HOST_NAME\":1}},\"CardanoPublicKey\":{\"fields\":{\"node\":{\"id\":2,\"rule\":\"required\",\"type\":\"HDNodeType\"},\"xpub\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"}}},\"CardanoSignMessage\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"address_type\":{\"id\":5,\"type\":\"CardanoAddressType\"},\"derivation_type\":{\"id\":3,\"rule\":\"required\",\"type\":\"CardanoDerivationType\"},\"message\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"},\"network_id\":{\"id\":4,\"rule\":\"required\",\"type\":\"uint32\"}}},\"CardanoSignTxFinished\":{\"fields\":{}},\"CardanoSignTxInit\":{\"fields\":{\"certificates_count\":{\"id\":8,\"rule\":\"required\",\"type\":\"uint32\"},\"chunkify\":{\"id\":22,\"type\":\"bool\"},\"collateral_inputs_count\":{\"id\":17,\"rule\":\"required\",\"type\":\"uint32\"},\"derivation_type\":{\"id\":14,\"rule\":\"required\",\"type\":\"CardanoDerivationType\"},\"fee\":{\"id\":6,\"rule\":\"required\",\"type\":\"uint64\"},\"has_auxiliary_data\":{\"id\":10,\"rule\":\"required\",\"type\":\"bool\"},\"has_collateral_return\":{\"id\":19,\"options\":{\"default\":false},\"type\":\"bool\"},\"include_network_id\":{\"id\":15,\"options\":{\"default\":false},\"type\":\"bool\"},\"inputs_count\":{\"id\":4,\"rule\":\"required\",\"type\":\"uint32\"},\"minting_asset_groups_count\":{\"id\":13,\"rule\":\"required\",\"type\":\"uint32\"},\"network_id\":{\"id\":3,\"rule\":\"required\",\"type\":\"uint32\"},\"outputs_count\":{\"id\":5,\"rule\":\"required\",\"type\":\"uint32\"},\"protocol_magic\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint32\"},\"reference_inputs_count\":{\"id\":21,\"options\":{\"default\":0},\"type\":\"uint32\"},\"required_signers_count\":{\"id\":18,\"rule\":\"required\",\"type\":\"uint32\"},\"script_data_hash\":{\"id\":16,\"type\":\"bytes\"},\"signing_mode\":{\"id\":1,\"rule\":\"required\",\"type\":\"CardanoTxSigningMode\"},\"tag_cbor_sets\":{\"id\":23,\"options\":{\"default\":false},\"type\":\"bool\"},\"total_collateral\":{\"id\":20,\"type\":\"uint64\"},\"ttl\":{\"id\":7,\"type\":\"uint64\"},\"validity_interval_start\":{\"id\":11,\"type\":\"uint64\"},\"withdrawals_count\":{\"id\":9,\"rule\":\"required\",\"type\":\"uint32\"},\"witness_requests_count\":{\"id\":12,\"rule\":\"required\",\"type\":\"uint32\"}}},\"CardanoToken\":{\"fields\":{\"amount\":{\"id\":2,\"type\":\"uint64\"},\"asset_name_bytes\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"},\"mint_amount\":{\"id\":3,\"type\":\"sint64\"}}},\"CardanoTxAuxiliaryData\":{\"fields\":{\"cvote_registration_parameters\":{\"id\":1,\"type\":\"CardanoCVoteRegistrationParametersType\"},\"hash\":{\"id\":2,\"type\":\"bytes\"}}},\"CardanoTxAuxiliaryDataSupplement\":{\"fields\":{\"auxiliary_data_hash\":{\"id\":2,\"type\":\"bytes\"},\"cvote_registration_signature\":{\"id\":3,\"type\":\"bytes\"},\"type\":{\"id\":1,\"rule\":\"required\",\"type\":\"CardanoTxAuxiliaryDataSupplementType\"}}},\"CardanoTxAuxiliaryDataSupplementType\":{\"values\":{\"CVOTE_REGISTRATION_SIGNATURE\":1,\"NONE\":0}},\"CardanoTxBodyHash\":{\"fields\":{\"tx_hash\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"CardanoTxCertificate\":{\"fields\":{\"deposit\":{\"id\":7,\"type\":\"uint64\"},\"drep\":{\"id\":8,\"type\":\"CardanoDRep\"},\"key_hash\":{\"id\":6,\"type\":\"bytes\"},\"path\":{\"id\":2,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"pool\":{\"id\":3,\"type\":\"bytes\"},\"pool_parameters\":{\"id\":4,\"type\":\"CardanoPoolParametersType\"},\"script_hash\":{\"id\":5,\"type\":\"bytes\"},\"type\":{\"id\":1,\"rule\":\"required\",\"type\":\"CardanoCertificateType\"}}},\"CardanoTxCollateralInput\":{\"fields\":{\"prev_hash\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"},\"prev_index\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint32\"}}},\"CardanoTxHostAck\":{\"fields\":{}},\"CardanoTxInlineDatumChunk\":{\"fields\":{\"data\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"CardanoTxInput\":{\"fields\":{\"prev_hash\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"},\"prev_index\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint32\"}}},\"CardanoTxItemAck\":{\"fields\":{}},\"CardanoTxMint\":{\"fields\":{\"asset_groups_count\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint32\"}}},\"CardanoTxOutput\":{\"fields\":{\"address\":{\"id\":1,\"type\":\"string\"},\"address_parameters\":{\"id\":2,\"type\":\"CardanoAddressParametersType\"},\"amount\":{\"id\":3,\"rule\":\"required\",\"type\":\"uint64\"},\"asset_groups_count\":{\"id\":4,\"rule\":\"required\",\"type\":\"uint32\"},\"datum_hash\":{\"id\":5,\"type\":\"bytes\"},\"format\":{\"id\":6,\"options\":{\"default\":\"ARRAY_LEGACY\"},\"type\":\"CardanoTxOutputSerializationFormat\"},\"inline_datum_size\":{\"id\":7,\"options\":{\"default\":0},\"type\":\"uint32\"},\"reference_script_size\":{\"id\":8,\"options\":{\"default\":0},\"type\":\"uint32\"}}},\"CardanoTxOutputSerializationFormat\":{\"values\":{\"ARRAY_LEGACY\":0,\"MAP_BABBAGE\":1}},\"CardanoTxReferenceInput\":{\"fields\":{\"prev_hash\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"},\"prev_index\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint32\"}}},\"CardanoTxReferenceScriptChunk\":{\"fields\":{\"data\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"CardanoTxRequiredSigner\":{\"fields\":{\"key_hash\":{\"id\":1,\"type\":\"bytes\"},\"key_path\":{\"id\":2,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"}}},\"CardanoTxSigningMode\":{\"values\":{\"MULTISIG_TRANSACTION\":2,\"ORDINARY_TRANSACTION\":0,\"PLUTUS_TRANSACTION\":3,\"POOL_REGISTRATION_AS_OWNER\":1}},\"CardanoTxWithdrawal\":{\"fields\":{\"amount\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint64\"},\"key_hash\":{\"id\":4,\"type\":\"bytes\"},\"path\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"script_hash\":{\"id\":3,\"type\":\"bytes\"}}},\"CardanoTxWitnessRequest\":{\"fields\":{\"path\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"}}},\"CardanoTxWitnessResponse\":{\"fields\":{\"chain_code\":{\"id\":4,\"type\":\"bytes\"},\"pub_key\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"},\"signature\":{\"id\":3,\"rule\":\"required\",\"type\":\"bytes\"},\"type\":{\"id\":1,\"rule\":\"required\",\"type\":\"CardanoTxWitnessType\"}}},\"CardanoTxWitnessType\":{\"values\":{\"BYRON_WITNESS\":0,\"SHELLEY_WITNESS\":1}},\"ChangePin\":{\"fields\":{\"remove\":{\"id\":1,\"type\":\"bool\"}}},\"ChangeWipeCode\":{\"fields\":{\"remove\":{\"id\":1,\"type\":\"bool\"}}},\"CipherKeyValue\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"ask_on_decrypt\":{\"id\":6,\"type\":\"bool\"},\"ask_on_encrypt\":{\"id\":5,\"type\":\"bool\"},\"encrypt\":{\"id\":4,\"type\":\"bool\"},\"iv\":{\"id\":7,\"type\":\"bytes\"},\"key\":{\"id\":2,\"rule\":\"required\",\"type\":\"string\"},\"value\":{\"id\":3,\"rule\":\"required\",\"type\":\"bytes\"}}},\"CipheredKeyValue\":{\"fields\":{\"value\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"ConfluxAddress\":{\"fields\":{\"address\":{\"id\":1,\"type\":\"string\"}}},\"ConfluxGetAddress\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"chain_id\":{\"id\":3,\"type\":\"uint32\"},\"show_display\":{\"id\":2,\"type\":\"bool\"}}},\"ConfluxMessageSignature\":{\"fields\":{\"address\":{\"id\":3,\"type\":\"string\"},\"signature\":{\"id\":2,\"type\":\"bytes\"}}},\"ConfluxSignMessage\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"message\":{\"id\":2,\"type\":\"bytes\"}}},\"ConfluxSignMessageCIP23\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"domain_hash\":{\"id\":2,\"type\":\"bytes\"},\"message_hash\":{\"id\":3,\"type\":\"bytes\"}}},\"ConfluxSignTx\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"chain_id\":{\"id\":11,\"options\":{\"default\":1029},\"type\":\"uint32\"},\"data_initial_chunk\":{\"id\":9,\"options\":{\"default\":\"\"},\"type\":\"bytes\"},\"data_length\":{\"id\":10,\"options\":{\"default\":0},\"type\":\"uint32\"},\"epoch_height\":{\"id\":7,\"options\":{\"default\":\"\"},\"type\":\"bytes\"},\"gas_limit\":{\"id\":4,\"rule\":\"required\",\"type\":\"bytes\"},\"gas_price\":{\"id\":3,\"rule\":\"required\",\"type\":\"bytes\"},\"nonce\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"},\"storage_limit\":{\"id\":8,\"options\":{\"default\":\"\"},\"type\":\"bytes\"},\"to\":{\"id\":5,\"options\":{\"default\":\"\"},\"type\":\"string\"},\"value\":{\"id\":6,\"options\":{\"default\":\"\"},\"type\":\"bytes\"}}},\"ConfluxTxAck\":{\"fields\":{\"data_chunk\":{\"id\":1,\"type\":\"bytes\"}}},\"ConfluxTxRequest\":{\"fields\":{\"data_length\":{\"id\":1,\"type\":\"uint32\"},\"signature_r\":{\"id\":3,\"type\":\"bytes\"},\"signature_s\":{\"id\":4,\"type\":\"bytes\"},\"signature_v\":{\"id\":2,\"type\":\"uint32\"}}},\"CosiCommit\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"data\":{\"id\":2,\"options\":{\"deprecated\":true},\"type\":\"bytes\"}}},\"CosiCommitment\":{\"fields\":{\"commitment\":{\"id\":1,\"type\":\"bytes\"},\"pubkey\":{\"id\":2,\"type\":\"bytes\"}}},\"CosiSign\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"data\":{\"id\":2,\"type\":\"bytes\"},\"global_commitment\":{\"id\":3,\"type\":\"bytes\"},\"global_pubkey\":{\"id\":4,\"type\":\"bytes\"}}},\"CosiSignature\":{\"fields\":{\"signature\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"CosmosAddress\":{\"fields\":{\"address\":{\"id\":1,\"type\":\"string\"}}},\"CosmosGetAddress\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"hrp\":{\"id\":2,\"type\":\"string\"},\"show_display\":{\"id\":3,\"type\":\"bool\"}}},\"CosmosSignTx\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"raw_tx\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"CosmosSignedTx\":{\"fields\":{\"signature\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"DebugMoneroDiagAck\":{\"fields\":{\"data1\":{\"id\":5,\"type\":\"bytes\"},\"data2\":{\"id\":6,\"type\":\"bytes\"},\"ins\":{\"id\":1,\"type\":\"uint64\"},\"p1\":{\"id\":2,\"type\":\"uint64\"},\"p2\":{\"id\":3,\"type\":\"uint64\"},\"pd\":{\"id\":4,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint64\"}}},\"DebugMoneroDiagRequest\":{\"fields\":{\"data1\":{\"id\":5,\"type\":\"bytes\"},\"data2\":{\"id\":6,\"type\":\"bytes\"},\"ins\":{\"id\":1,\"type\":\"uint64\"},\"p1\":{\"id\":2,\"type\":\"uint64\"},\"p2\":{\"id\":3,\"type\":\"uint64\"},\"pd\":{\"id\":4,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint64\"}}},\"DecredStakingSpendType\":{\"values\":{\"SSGen\":0,\"SSRTX\":1}},\"DeviceAnimationAction\":{\"values\":{\"AnimationAction_Start\":1,\"AnimationAction_Stop\":2,\"AnimationAction_Unknown\":0}},\"DeviceAnimationControl\":{\"fields\":{\"action\":{\"id\":1,\"rule\":\"required\",\"type\":\"DeviceAnimationAction\"},\"timeout_ms\":{\"id\":2,\"type\":\"uint32\"}}},\"DeviceCertificate\":{\"fields\":{\"cert_and_pubkey\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"},\"private_key\":{\"id\":2,\"type\":\"bytes\"}}},\"DeviceCertificateRead\":{\"fields\":{}},\"DeviceCertificateSign\":{\"fields\":{\"data\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"DeviceCertificateSignature\":{\"fields\":{\"data\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"DeviceCertificateWrite\":{\"fields\":{\"cert\":{\"id\":1,\"rule\":\"required\",\"type\":\"DeviceCertificate\"}}},\"DeviceCoprocessorInfo\":{\"fields\":{\"application\":{\"id\":30,\"type\":\"DeviceFirmwareImageInfo\"},\"bootloader\":{\"id\":20,\"type\":\"DeviceFirmwareImageInfo\"},\"bt_adv_name\":{\"id\":100,\"type\":\"string\"},\"bt_mac\":{\"id\":110,\"type\":\"bytes\"}}},\"DeviceErrorCode\":{\"values\":{\"DeviceError_ActionCancelled\":3,\"DeviceError_Busy\":1,\"DeviceError_DeviceLocked\":9,\"DeviceError_InvalidLanguage\":7,\"DeviceError_None\":0,\"DeviceError_NotInitialized\":2,\"DeviceError_PersistFailed\":5,\"DeviceError_PinAlreadyUsed\":4,\"DeviceError_SeError\":6,\"DeviceError_WallpaperNotUsable\":8}},\"DeviceFactoryAck\":{\"values\":{\"FACTORY_ACK_FAIL\":1,\"FACTORY_ACK_SUCCESS\":0}},\"DeviceFactoryInfo\":{\"fields\":{\"data\":{\"id\":100,\"type\":\"bytes\"},\"factory_burn_in_completed\":{\"id\":3,\"type\":\"bool\"},\"factory_test_completed\":{\"id\":4,\"type\":\"bool\"},\"manufacture_time\":{\"id\":5,\"type\":\"DeviceFactoryInfoManufactureTime\"},\"serial_number\":{\"id\":2,\"type\":\"string\"},\"version\":{\"id\":1,\"type\":\"uint32\"}}},\"DeviceFactoryInfoGet\":{\"fields\":{\"full_data\":{\"id\":1,\"type\":\"bool\"}}},\"DeviceFactoryInfoManufactureTime\":{\"fields\":{\"day\":{\"id\":3,\"rule\":\"required\",\"type\":\"uint32\"},\"hour\":{\"id\":4,\"rule\":\"required\",\"type\":\"uint32\"},\"minute\":{\"id\":5,\"rule\":\"required\",\"type\":\"uint32\"},\"month\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint32\"},\"second\":{\"id\":6,\"rule\":\"required\",\"type\":\"uint32\"},\"year\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint32\"}}},\"DeviceFactoryInfoSet\":{\"fields\":{\"full_data\":{\"id\":2,\"type\":\"bool\"},\"info\":{\"id\":1,\"rule\":\"required\",\"type\":\"DeviceFactoryInfo\"}}},\"DeviceFactoryPermanentLock\":{\"fields\":{\"check_a\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"},\"check_b\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"DeviceFactoryTest\":{\"fields\":{\"burn_in_test\":{\"id\":1,\"rule\":\"required\",\"type\":\"bool\"}}},\"DeviceFindMyTokenState\":{\"fields\":{\"burned\":{\"id\":1,\"rule\":\"required\",\"type\":\"bool\"}}},\"DeviceFindMyTokenStateGet\":{\"fields\":{}},\"DeviceFindMyTokenUpdate\":{\"fields\":{\"token\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"DeviceFirmwareImageInfo\":{\"fields\":{\"build_id\":{\"id\":20,\"type\":\"string\"},\"hash\":{\"id\":30,\"type\":\"bytes\"},\"version\":{\"id\":10,\"type\":\"string\"}}},\"DeviceFirmwareTarget\":{\"fields\":{\"path\":{\"id\":2,\"rule\":\"required\",\"type\":\"string\"},\"target_id\":{\"id\":1,\"rule\":\"required\",\"type\":\"DeviceFirmwareTargetType\"}}},\"DeviceFirmwareTargetType\":{\"values\":{\"FW_MGMT_TARGET_APPLICATION_P1\":4,\"FW_MGMT_TARGET_APPLICATION_P2\":5,\"FW_MGMT_TARGET_BOOTLOADER\":3,\"FW_MGMT_TARGET_COPROCESSOR\":6,\"FW_MGMT_TARGET_CRATE\":1,\"FW_MGMT_TARGET_INVALID\":0,\"FW_MGMT_TARGET_ROMLOADER\":2,\"FW_MGMT_TARGET_SE01\":7,\"FW_MGMT_TARGET_SE02\":8,\"FW_MGMT_TARGET_SE03\":9,\"FW_MGMT_TARGET_SE04\":10}},\"DeviceFirmwareUpdatePhase\":{\"values\":{\"FW_MGMT_UPDATER_PHASE_INSTALL\":1,\"FW_MGMT_UPDATER_PHASE_PREPARE\":0,\"FW_MGMT_UPDATER_PHASE_VERIFY\":2}},\"DeviceFirmwareUpdatePhaseInfo\":{\"fields\":{\"phase\":{\"id\":1,\"rule\":\"required\",\"type\":\"DeviceFirmwareUpdatePhase\"},\"progress_percent\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint32\"}}},\"DeviceFirmwareUpdateRecord\":{\"fields\":{\"path\":{\"id\":30,\"type\":\"string\"},\"payload_version\":{\"id\":20,\"type\":\"uint32\"},\"phase_info\":{\"id\":12,\"type\":\"DeviceFirmwareUpdatePhaseInfo\"},\"progress_percent\":{\"id\":11,\"type\":\"uint32\"},\"status\":{\"id\":10,\"type\":\"DeviceFirmwareUpdateTaskStatus\"},\"target_id\":{\"id\":1,\"rule\":\"required\",\"type\":\"DeviceFirmwareTargetType\"}}},\"DeviceFirmwareUpdateRecordFields\":{\"fields\":{\"path\":{\"id\":30,\"type\":\"bool\"},\"payload_version\":{\"id\":20,\"type\":\"bool\"},\"phase_info\":{\"id\":12,\"type\":\"bool\"},\"progress_percent\":{\"id\":11,\"type\":\"bool\"},\"status\":{\"id\":10,\"type\":\"bool\"}}},\"DeviceFirmwareUpdateRequest\":{\"fields\":{\"reboot_after_update\":{\"id\":1,\"type\":\"bool\"}}},\"DeviceFirmwareUpdateStage\":{\"fields\":{\"targets\":{\"id\":1,\"rule\":\"repeated\",\"type\":\"DeviceFirmwareTarget\"}}},\"DeviceFirmwareUpdateStatus\":{\"fields\":{\"records\":{\"id\":1,\"rule\":\"repeated\",\"type\":\"DeviceFirmwareUpdateRecord\"}}},\"DeviceFirmwareUpdateStatusGet\":{\"fields\":{\"fields\":{\"id\":1,\"type\":\"DeviceFirmwareUpdateRecordFields\"}}},\"DeviceFirmwareUpdateTaskStatus\":{\"values\":{\"FW_MGMT_UPDATER_TASK_STATUS_FAILED_ABORT\":8,\"FW_MGMT_UPDATER_TASK_STATUS_FAILED_BUSY\":9,\"FW_MGMT_UPDATER_TASK_STATUS_FAILED_ENTRY_OUT_OF_BOUNDS\":10,\"FW_MGMT_UPDATER_TASK_STATUS_FAILED_FILE_NOT_FOUND\":3,\"FW_MGMT_UPDATER_TASK_STATUS_FAILED_FILE_READ\":4,\"FW_MGMT_UPDATER_TASK_STATUS_FAILED_FILE_WRITE\":5,\"FW_MGMT_UPDATER_TASK_STATUS_FAILED_INSTALL\":7,\"FW_MGMT_UPDATER_TASK_STATUS_FAILED_VERIFY\":6,\"FW_MGMT_UPDATER_TASK_STATUS_FINISHED\":2,\"FW_MGMT_UPDATER_TASK_STATUS_IN_PROGRESS\":1,\"FW_MGMT_UPDATER_TASK_STATUS_PENDING\":0}},\"DeviceHardwareInfo\":{\"fields\":{\"Device_type\":{\"id\":10,\"type\":\"DeviceType\"},\"hardware_version\":{\"id\":100,\"type\":\"string\"},\"hardware_version_raw_adc\":{\"id\":110,\"type\":\"uint32\"},\"serial_no\":{\"id\":20,\"type\":\"string\"}}},\"DeviceInfo\":{\"fields\":{\"coprocessor\":{\"id\":300,\"type\":\"DeviceCoprocessorInfo\"},\"hw\":{\"id\":100,\"type\":\"DeviceHardwareInfo\"},\"main_mcu\":{\"id\":200,\"type\":\"DeviceMainMcuInfo\"},\"protocol_version\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint32\"},\"se1\":{\"id\":400,\"type\":\"DeviceSEInfo\"},\"se2\":{\"id\":410,\"type\":\"DeviceSEInfo\"},\"se3\":{\"id\":420,\"type\":\"DeviceSEInfo\"},\"se4\":{\"id\":430,\"type\":\"DeviceSEInfo\"}}},\"DeviceInfoGet\":{\"fields\":{\"targets\":{\"id\":1,\"type\":\"DeviceInfoTargets\"},\"types\":{\"id\":2,\"type\":\"DeviceInfoTypes\"}}},\"DeviceInfoTargets\":{\"fields\":{\"coprocessor\":{\"id\":300,\"type\":\"bool\"},\"hw\":{\"id\":100,\"type\":\"bool\"},\"main_mcu\":{\"id\":200,\"type\":\"bool\"},\"se1\":{\"id\":400,\"type\":\"bool\"},\"se2\":{\"id\":410,\"type\":\"bool\"},\"se3\":{\"id\":420,\"type\":\"bool\"},\"se4\":{\"id\":430,\"type\":\"bool\"}}},\"DeviceInfoTypes\":{\"fields\":{\"build_id\":{\"id\":20,\"type\":\"bool\"},\"hash\":{\"id\":30,\"type\":\"bool\"},\"specific\":{\"id\":40,\"type\":\"bool\"},\"version\":{\"id\":10,\"type\":\"bool\"}}},\"DeviceMainMcuInfo\":{\"fields\":{\"application\":{\"id\":30,\"type\":\"DeviceFirmwareImageInfo\"},\"application_data\":{\"id\":40,\"type\":\"DeviceFirmwareImageInfo\"},\"bootloader\":{\"id\":20,\"type\":\"DeviceFirmwareImageInfo\"},\"romloader\":{\"id\":10,\"type\":\"DeviceFirmwareImageInfo\"}}},\"DeviceMiscUsbMscControl\":{\"fields\":{\"enable\":{\"id\":1,\"rule\":\"required\",\"type\":\"bool\"}}},\"DeviceReboot\":{\"fields\":{\"reboot_type\":{\"id\":1,\"rule\":\"required\",\"type\":\"DeviceRebootType\"}}},\"DeviceRebootType\":{\"values\":{\"Bootloader\":2,\"Normal\":0,\"Romloader\":1}},\"DeviceSEInfo\":{\"fields\":{\"application\":{\"id\":30,\"type\":\"DeviceFirmwareImageInfo\"},\"bootloader\":{\"id\":20,\"type\":\"DeviceFirmwareImageInfo\"},\"state\":{\"id\":110,\"type\":\"DeviceSEState\"},\"type\":{\"id\":100,\"type\":\"DeviceSeType\"}}},\"DeviceSEState\":{\"values\":{\"APP\":85,\"APP_FACTORY\":51,\"BOOT\":0}},\"DeviceSeType\":{\"values\":{\"SE608A\":1,\"THD89\":0}},\"DeviceSession\":{\"fields\":{\"btc_test_address\":{\"id\":2,\"type\":\"string\"},\"seed_domains\":{\"id\":3,\"rule\":\"repeated\",\"type\":\"DeviceSessionSeedDomain\"},\"session_id\":{\"id\":1,\"type\":\"bytes\"}}},\"DeviceSessionAskPassphrase\":{\"fields\":{\"on_device\":{\"id\":2,\"rule\":\"required\",\"type\":\"bool\"},\"passphrase\":{\"id\":1,\"type\":\"string\"},\"seed_domains\":{\"id\":3,\"rule\":\"repeated\",\"type\":\"DeviceSessionSeedDomain\"}}},\"DeviceSessionAskPin\":{\"fields\":{\"type\":{\"id\":1,\"type\":\"DeviceSessionPinType\"}}},\"DeviceSessionAskPin_FailureSubCodes\":{\"values\":{\"UserCancel\":1}},\"DeviceSessionErrorCode\":{\"values\":{\"DeviceSessionError_AttachPinUnavailable\":3,\"DeviceSessionError_Busy\":5,\"DeviceSessionError_InvalidSession\":2,\"DeviceSessionError_None\":0,\"DeviceSessionError_PassphraseDisabled\":4,\"DeviceSessionError_UserCancelled\":1}},\"DeviceSessionGet\":{\"fields\":{\"btc_test_address\":{\"id\":2,\"type\":\"string\"},\"session_id\":{\"id\":1,\"type\":\"bytes\"}}},\"DeviceSessionPinType\":{\"values\":{\"Any\":1,\"AttachToPin\":3,\"Main\":2}},\"DeviceSessionSeedDomain\":{\"values\":{\"SeedDomain_Cardano\":2,\"SeedDomain_Standard\":1}},\"DeviceSettings\":{\"fields\":{\"airgap_mode\":{\"id\":9,\"type\":\"bool\"},\"animation_enable\":{\"id\":5,\"type\":\"bool\"},\"autolock_delay_ms\":{\"id\":102,\"type\":\"uint32\"},\"autoshutdown_delay_ms\":{\"id\":103,\"type\":\"uint32\"},\"brightness\":{\"id\":4,\"type\":\"uint32\"},\"bt_enable\":{\"id\":1,\"type\":\"bool\"},\"device_name_display_enabled\":{\"id\":8,\"type\":\"bool\"},\"fido_enabled\":{\"id\":101,\"type\":\"bool\"},\"haptic_feedback\":{\"id\":7,\"type\":\"bool\"},\"label\":{\"id\":104,\"type\":\"string\"},\"language\":{\"id\":2,\"type\":\"string\"},\"passphrase_enable\":{\"id\":100,\"type\":\"bool\"},\"random_keypad\":{\"id\":11,\"type\":\"bool\"},\"tap_to_wake\":{\"id\":6,\"type\":\"bool\"},\"usb_lock_enable\":{\"id\":10,\"type\":\"bool\"},\"wallpaper_path\":{\"id\":3,\"type\":\"string\"}}},\"DeviceSettingsGet\":{\"fields\":{}},\"DeviceSettingsPage\":{\"values\":{\"DeviceAirgap\":3,\"DevicePassphrase\":2,\"DevicePinChange\":1,\"DeviceReset\":0}},\"DeviceSettingsPageShow\":{\"fields\":{\"field_name\":{\"id\":2,\"type\":\"string\"},\"page\":{\"id\":1,\"rule\":\"required\",\"type\":\"DeviceSettingsPage\"}}},\"DeviceSettingsSet\":{\"fields\":{\"settings\":{\"id\":1,\"rule\":\"required\",\"type\":\"DeviceSettings\"}}},\"DeviceStatus\":{\"fields\":{\"attach_to_pin_enabled\":{\"id\":11,\"type\":\"bool\"},\"backup_required\":{\"id\":4,\"type\":\"bool\"},\"device_id\":{\"id\":1,\"type\":\"string\"},\"init_states\":{\"id\":3,\"type\":\"bool\"},\"passphrase_enabled\":{\"id\":10,\"type\":\"bool\"},\"unlocked\":{\"id\":2,\"type\":\"bool\"},\"unlocked_by_attach_to_pin\":{\"id\":12,\"type\":\"bool\"}}},\"DeviceStatusGet\":{\"fields\":{}},\"DeviceType\":{\"values\":{\"CLASSIC1\":0,\"CLASSIC1S\":1,\"CLASSIC1S_PURE\":6,\"MINI\":2,\"NEO\":8,\"PRO\":5,\"PRO2\":7,\"TOUCH\":3}},\"DoPreauthorized\":{\"fields\":{}},\"ECDHSessionKey\":{\"fields\":{\"public_key\":{\"id\":2,\"type\":\"bytes\"},\"session_key\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"EcdsaPublicKeys\":{\"fields\":{\"hd_nodes\":{\"id\":2,\"rule\":\"repeated\",\"type\":\"HDNodeType\"},\"public_keys\":{\"id\":1,\"rule\":\"repeated\",\"type\":\"bytes\"},\"root_fingerprint\":{\"id\":3,\"type\":\"uint32\"}}},\"Entropy\":{\"fields\":{\"entropy\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"EntropyAck\":{\"fields\":{\"entropy\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"EntropyRequest\":{\"fields\":{}},\"EosGetPublicKey\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"show_display\":{\"id\":2,\"type\":\"bool\"}}},\"EosPublicKey\":{\"fields\":{\"raw_public_key\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"},\"wif_public_key\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"}}},\"EosSignTx\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"chain_id\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"},\"header\":{\"id\":3,\"rule\":\"required\",\"type\":\"EosTxHeader\"},\"num_actions\":{\"id\":4,\"rule\":\"required\",\"type\":\"uint32\"}},\"nested\":{\"EosTxHeader\":{\"fields\":{\"delay_sec\":{\"id\":6,\"rule\":\"required\",\"type\":\"uint32\"},\"expiration\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint32\"},\"max_cpu_usage_ms\":{\"id\":5,\"rule\":\"required\",\"type\":\"uint32\"},\"max_net_usage_words\":{\"id\":4,\"rule\":\"required\",\"type\":\"uint32\"},\"ref_block_num\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint32\"},\"ref_block_prefix\":{\"id\":3,\"rule\":\"required\",\"type\":\"uint32\"}}}}},\"EosSignedTx\":{\"fields\":{\"signature\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"}}},\"EosTxActionAck\":{\"fields\":{\"buy_ram\":{\"id\":6,\"type\":\"EosActionBuyRam\"},\"buy_ram_bytes\":{\"id\":7,\"type\":\"EosActionBuyRamBytes\"},\"common\":{\"id\":1,\"rule\":\"required\",\"type\":\"EosActionCommon\"},\"delegate\":{\"id\":3,\"type\":\"EosActionDelegate\"},\"delete_auth\":{\"id\":11,\"type\":\"EosActionDeleteAuth\"},\"link_auth\":{\"id\":12,\"type\":\"EosActionLinkAuth\"},\"new_account\":{\"id\":14,\"type\":\"EosActionNewAccount\"},\"refund\":{\"id\":5,\"type\":\"EosActionRefund\"},\"sell_ram\":{\"id\":8,\"type\":\"EosActionSellRam\"},\"transfer\":{\"id\":2,\"type\":\"EosActionTransfer\"},\"undelegate\":{\"id\":4,\"type\":\"EosActionUndelegate\"},\"unknown\":{\"id\":15,\"type\":\"EosActionUnknown\"},\"unlink_auth\":{\"id\":13,\"type\":\"EosActionUnlinkAuth\"},\"update_auth\":{\"id\":10,\"type\":\"EosActionUpdateAuth\"},\"vote_producer\":{\"id\":9,\"type\":\"EosActionVoteProducer\"}},\"nested\":{\"EosActionBuyRam\":{\"fields\":{\"payer\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint64\"},\"quantity\":{\"id\":3,\"rule\":\"required\",\"type\":\"EosAsset\"},\"receiver\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint64\"}}},\"EosActionBuyRamBytes\":{\"fields\":{\"bytes\":{\"id\":3,\"rule\":\"required\",\"type\":\"uint32\"},\"payer\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint64\"},\"receiver\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint64\"}}},\"EosActionCommon\":{\"fields\":{\"account\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint64\"},\"authorization\":{\"id\":3,\"rule\":\"repeated\",\"type\":\"EosPermissionLevel\"},\"name\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint64\"}}},\"EosActionDelegate\":{\"fields\":{\"cpu_quantity\":{\"id\":4,\"rule\":\"required\",\"type\":\"EosAsset\"},\"net_quantity\":{\"id\":3,\"rule\":\"required\",\"type\":\"EosAsset\"},\"receiver\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint64\"},\"sender\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint64\"},\"transfer\":{\"id\":5,\"rule\":\"required\",\"type\":\"bool\"}}},\"EosActionDeleteAuth\":{\"fields\":{\"account\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint64\"},\"permission\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint64\"}}},\"EosActionLinkAuth\":{\"fields\":{\"account\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint64\"},\"code\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint64\"},\"requirement\":{\"id\":4,\"rule\":\"required\",\"type\":\"uint64\"},\"type\":{\"id\":3,\"rule\":\"required\",\"type\":\"uint64\"}}},\"EosActionNewAccount\":{\"fields\":{\"active\":{\"id\":4,\"rule\":\"required\",\"type\":\"EosAuthorization\"},\"creator\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint64\"},\"name\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint64\"},\"owner\":{\"id\":3,\"rule\":\"required\",\"type\":\"EosAuthorization\"}}},\"EosActionRefund\":{\"fields\":{\"owner\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint64\"}}},\"EosActionSellRam\":{\"fields\":{\"account\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint64\"},\"bytes\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint64\"}}},\"EosActionTransfer\":{\"fields\":{\"memo\":{\"id\":4,\"rule\":\"required\",\"type\":\"string\"},\"quantity\":{\"id\":3,\"rule\":\"required\",\"type\":\"EosAsset\"},\"receiver\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint64\"},\"sender\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint64\"}}},\"EosActionUndelegate\":{\"fields\":{\"cpu_quantity\":{\"id\":4,\"rule\":\"required\",\"type\":\"EosAsset\"},\"net_quantity\":{\"id\":3,\"rule\":\"required\",\"type\":\"EosAsset\"},\"receiver\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint64\"},\"sender\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint64\"}}},\"EosActionUnknown\":{\"fields\":{\"data_chunk\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"},\"data_size\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint32\"}}},\"EosActionUnlinkAuth\":{\"fields\":{\"account\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint64\"},\"code\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint64\"},\"type\":{\"id\":3,\"rule\":\"required\",\"type\":\"uint64\"}}},\"EosActionUpdateAuth\":{\"fields\":{\"account\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint64\"},\"auth\":{\"id\":4,\"rule\":\"required\",\"type\":\"EosAuthorization\"},\"parent\":{\"id\":3,\"rule\":\"required\",\"type\":\"uint64\"},\"permission\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint64\"}}},\"EosActionVoteProducer\":{\"fields\":{\"producers\":{\"id\":3,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint64\"},\"proxy\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint64\"},\"voter\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint64\"}}},\"EosAsset\":{\"fields\":{\"amount\":{\"id\":1,\"rule\":\"required\",\"type\":\"sint64\"},\"symbol\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint64\"}}},\"EosAuthorization\":{\"fields\":{\"accounts\":{\"id\":3,\"rule\":\"repeated\",\"type\":\"EosAuthorizationAccount\"},\"keys\":{\"id\":2,\"rule\":\"repeated\",\"type\":\"EosAuthorizationKey\"},\"threshold\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint32\"},\"waits\":{\"id\":4,\"rule\":\"repeated\",\"type\":\"EosAuthorizationWait\"}}},\"EosAuthorizationAccount\":{\"fields\":{\"account\":{\"id\":1,\"rule\":\"required\",\"type\":\"EosPermissionLevel\"},\"weight\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint32\"}}},\"EosAuthorizationKey\":{\"fields\":{\"address_n\":{\"id\":3,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"key\":{\"id\":2,\"type\":\"bytes\"},\"type\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint32\"},\"weight\":{\"id\":4,\"rule\":\"required\",\"type\":\"uint32\"}}},\"EosAuthorizationWait\":{\"fields\":{\"wait_sec\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint32\"},\"weight\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint32\"}}},\"EosPermissionLevel\":{\"fields\":{\"actor\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint64\"},\"permission\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint64\"}}}}},\"EosTxActionRequest\":{\"fields\":{\"data_size\":{\"id\":1,\"type\":\"uint32\"}}},\"EthereumAccessListOneKey\":{\"fields\":{\"address\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"},\"storage_keys\":{\"id\":2,\"rule\":\"repeated\",\"type\":\"bytes\"}}},\"EthereumAddress\":{\"fields\":{\"_old_address\":{\"id\":1,\"options\":{\"deprecated\":true},\"type\":\"bytes\"},\"address\":{\"id\":2,\"type\":\"string\"}}},\"EthereumAddressOneKey\":{\"fields\":{\"_old_address\":{\"id\":1,\"options\":{\"deprecated\":true},\"type\":\"bytes\"},\"address\":{\"id\":2,\"type\":\"string\"}}},\"EthereumAuthorizationSignature\":{\"fields\":{\"r\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"},\"s\":{\"id\":3,\"rule\":\"required\",\"type\":\"bytes\"},\"y_parity\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint32\"}}},\"EthereumDefinitionType\":{\"values\":{\"NETWORK\":0,\"TOKEN\":1}},\"EthereumDefinitions\":{\"fields\":{\"encoded_network\":{\"id\":1,\"type\":\"bytes\"},\"encoded_token\":{\"id\":2,\"type\":\"bytes\"}}},\"EthereumGetAddress\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"encoded_network\":{\"id\":3,\"type\":\"bytes\"},\"show_display\":{\"id\":2,\"type\":\"bool\"}}},\"EthereumGetAddressOneKey\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"chain_id\":{\"id\":3,\"type\":\"uint64\"},\"show_display\":{\"id\":2,\"type\":\"bool\"}}},\"EthereumGetPublicKey\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"show_display\":{\"id\":2,\"type\":\"bool\"}}},\"EthereumGetPublicKeyOneKey\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"chain_id\":{\"id\":3,\"type\":\"uint64\"},\"show_display\":{\"id\":2,\"type\":\"bool\"}}},\"EthereumGnosisSafeTxAck\":{\"fields\":{\"baseGas\":{\"id\":6,\"rule\":\"required\",\"type\":\"bytes\"},\"chain_id\":{\"id\":11,\"rule\":\"required\",\"type\":\"uint64\"},\"data\":{\"id\":3,\"type\":\"bytes\"},\"gasPrice\":{\"id\":7,\"rule\":\"required\",\"type\":\"bytes\"},\"gasToken\":{\"id\":8,\"rule\":\"required\",\"type\":\"string\"},\"nonce\":{\"id\":10,\"rule\":\"required\",\"type\":\"bytes\"},\"operation\":{\"id\":4,\"rule\":\"required\",\"type\":\"EthereumGnosisSafeTxOperation\"},\"refundReceiver\":{\"id\":9,\"rule\":\"required\",\"type\":\"string\"},\"safeTxGas\":{\"id\":5,\"rule\":\"required\",\"type\":\"bytes\"},\"to\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"},\"value\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"},\"verifyingContract\":{\"id\":12,\"rule\":\"required\",\"type\":\"string\"}}},\"EthereumGnosisSafeTxOperation\":{\"values\":{\"CALL\":0,\"DELEGATE_CALL\":1}},\"EthereumGnosisSafeTxRequest\":{\"fields\":{}},\"EthereumMessageSignature\":{\"fields\":{\"address\":{\"id\":3,\"rule\":\"required\",\"type\":\"string\"},\"signature\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"EthereumMessageSignatureOneKey\":{\"fields\":{\"address\":{\"id\":3,\"rule\":\"required\",\"type\":\"string\"},\"signature\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"EthereumNetworkInfo\":{\"fields\":{\"chain_id\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint64\"},\"icon\":{\"id\":101,\"type\":\"string\"},\"name\":{\"id\":4,\"rule\":\"required\",\"type\":\"string\"},\"primary_color\":{\"id\":102,\"type\":\"uint64\"},\"slip44\":{\"id\":3,\"rule\":\"required\",\"type\":\"uint32\"},\"symbol\":{\"id\":2,\"rule\":\"required\",\"type\":\"string\"}}},\"EthereumPublicKey\":{\"fields\":{\"node\":{\"id\":1,\"rule\":\"required\",\"type\":\"HDNodeType\"},\"xpub\":{\"id\":2,\"rule\":\"required\",\"type\":\"string\"}}},\"EthereumPublicKeyOneKey\":{\"fields\":{\"node\":{\"id\":1,\"rule\":\"required\",\"type\":\"HDNodeType\"},\"xpub\":{\"id\":2,\"rule\":\"required\",\"type\":\"string\"}}},\"EthereumSignMessage\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"encoded_network\":{\"id\":3,\"type\":\"bytes\"},\"message\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"EthereumSignMessageOneKey\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"chain_id\":{\"id\":3,\"type\":\"uint64\"},\"message\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"EthereumSignTx\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"chain_id\":{\"id\":9,\"rule\":\"required\",\"type\":\"uint64\"},\"data_initial_chunk\":{\"id\":7,\"options\":{\"default\":\"\"},\"type\":\"bytes\"},\"data_length\":{\"id\":8,\"options\":{\"default\":0},\"type\":\"uint32\"},\"definitions\":{\"id\":12,\"type\":\"EthereumDefinitions\"},\"gas_limit\":{\"id\":4,\"rule\":\"required\",\"type\":\"bytes\"},\"gas_price\":{\"id\":3,\"rule\":\"required\",\"type\":\"bytes\"},\"nonce\":{\"id\":2,\"options\":{\"default\":\"\"},\"type\":\"bytes\"},\"to\":{\"id\":11,\"options\":{\"default\":\"\"},\"type\":\"string\"},\"tx_type\":{\"id\":10,\"type\":\"uint32\"},\"value\":{\"id\":6,\"options\":{\"default\":\"\"},\"type\":\"bytes\"}}},\"EthereumSignTxEIP1559\":{\"fields\":{\"access_list\":{\"id\":11,\"rule\":\"repeated\",\"type\":\"EthereumAccessList\"},\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"chain_id\":{\"id\":10,\"rule\":\"required\",\"type\":\"uint64\"},\"data_initial_chunk\":{\"id\":8,\"options\":{\"default\":\"\"},\"type\":\"bytes\"},\"data_length\":{\"id\":9,\"rule\":\"required\",\"type\":\"uint32\"},\"definitions\":{\"id\":12,\"type\":\"EthereumDefinitions\"},\"gas_limit\":{\"id\":5,\"rule\":\"required\",\"type\":\"bytes\"},\"max_gas_fee\":{\"id\":3,\"rule\":\"required\",\"type\":\"bytes\"},\"max_priority_fee\":{\"id\":4,\"rule\":\"required\",\"type\":\"bytes\"},\"nonce\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"},\"to\":{\"id\":6,\"options\":{\"default\":\"\"},\"type\":\"string\"},\"value\":{\"id\":7,\"rule\":\"required\",\"type\":\"bytes\"}},\"nested\":{\"EthereumAccessList\":{\"fields\":{\"address\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"},\"storage_keys\":{\"id\":2,\"rule\":\"repeated\",\"type\":\"bytes\"}}}}},\"EthereumSignTxEIP1559OneKey\":{\"fields\":{\"access_list\":{\"id\":11,\"rule\":\"repeated\",\"type\":\"EthereumAccessListOneKey\"},\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"chain_id\":{\"id\":10,\"rule\":\"required\",\"type\":\"uint64\"},\"data_initial_chunk\":{\"id\":8,\"options\":{\"default\":\"\"},\"type\":\"bytes\"},\"data_length\":{\"id\":9,\"rule\":\"required\",\"type\":\"uint32\"},\"expected_address\":{\"id\":12,\"type\":\"bytes\"},\"gas_limit\":{\"id\":5,\"rule\":\"required\",\"type\":\"bytes\"},\"max_gas_fee\":{\"id\":3,\"rule\":\"required\",\"type\":\"bytes\"},\"max_priority_fee\":{\"id\":4,\"rule\":\"required\",\"type\":\"bytes\"},\"nonce\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"},\"to\":{\"id\":6,\"options\":{\"default\":\"\"},\"type\":\"string\"},\"value\":{\"id\":7,\"rule\":\"required\",\"type\":\"bytes\"}}},\"EthereumSignTxEIP7702OneKey\":{\"fields\":{\"access_list\":{\"id\":11,\"rule\":\"repeated\",\"type\":\"EthereumAccessListOneKey\"},\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"authorization_list\":{\"id\":12,\"rule\":\"repeated\",\"type\":\"EthereumAuthorizationOneKey\"},\"chain_id\":{\"id\":10,\"rule\":\"required\",\"type\":\"uint64\"},\"data_initial_chunk\":{\"id\":8,\"options\":{\"default\":\"\"},\"type\":\"bytes\"},\"data_length\":{\"id\":9,\"rule\":\"required\",\"type\":\"uint32\"},\"gas_limit\":{\"id\":5,\"rule\":\"required\",\"type\":\"bytes\"},\"max_gas_fee\":{\"id\":3,\"rule\":\"required\",\"type\":\"bytes\"},\"max_priority_fee\":{\"id\":4,\"rule\":\"required\",\"type\":\"bytes\"},\"nonce\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"},\"to\":{\"id\":6,\"rule\":\"required\",\"type\":\"string\"},\"value\":{\"id\":7,\"rule\":\"required\",\"type\":\"bytes\"}},\"nested\":{\"EthereumAuthorizationOneKey\":{\"fields\":{\"address\":{\"id\":3,\"rule\":\"required\",\"type\":\"string\"},\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"chain_id\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint64\"},\"nonce\":{\"id\":4,\"rule\":\"required\",\"type\":\"bytes\"},\"signature\":{\"id\":5,\"type\":\"EthereumAuthorizationSignature\"}}}}},\"EthereumSignTxOneKey\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"chain_id\":{\"id\":9,\"rule\":\"required\",\"type\":\"uint64\"},\"data_initial_chunk\":{\"id\":7,\"options\":{\"default\":\"\"},\"type\":\"bytes\"},\"data_length\":{\"id\":8,\"options\":{\"default\":0},\"type\":\"uint32\"},\"expected_address\":{\"id\":12,\"type\":\"bytes\"},\"gas_limit\":{\"id\":4,\"rule\":\"required\",\"type\":\"bytes\"},\"gas_price\":{\"id\":3,\"rule\":\"required\",\"type\":\"bytes\"},\"nonce\":{\"id\":2,\"options\":{\"default\":\"\"},\"type\":\"bytes\"},\"to\":{\"id\":11,\"options\":{\"default\":\"\"},\"type\":\"string\"},\"tx_type\":{\"id\":10,\"type\":\"uint32\"},\"value\":{\"id\":6,\"options\":{\"default\":\"\"},\"type\":\"bytes\"}}},\"EthereumSignTypedData\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"definitions\":{\"id\":4,\"type\":\"EthereumDefinitions\"},\"metamask_v4_compat\":{\"id\":3,\"options\":{\"default\":true},\"type\":\"bool\"},\"primary_type\":{\"id\":2,\"rule\":\"required\",\"type\":\"string\"}}},\"EthereumSignTypedDataOneKey\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"chain_id\":{\"id\":4,\"type\":\"uint64\"},\"metamask_v4_compat\":{\"id\":3,\"options\":{\"default\":true},\"type\":\"bool\"},\"primary_type\":{\"id\":2,\"rule\":\"required\",\"type\":\"string\"}}},\"EthereumSignTypedDataQR\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"chain_id\":{\"id\":3,\"type\":\"uint64\"},\"json_data\":{\"id\":2,\"type\":\"bytes\"},\"metamask_v4_compat\":{\"id\":4,\"options\":{\"default\":true},\"type\":\"bool\"},\"request_id\":{\"id\":5,\"type\":\"bytes\"}}},\"EthereumSignTypedHash\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"domain_separator_hash\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"},\"encoded_network\":{\"id\":4,\"type\":\"bytes\"},\"message_hash\":{\"id\":3,\"type\":\"bytes\"}}},\"EthereumSignTypedHashOneKey\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"chain_id\":{\"id\":4,\"type\":\"uint64\"},\"domain_separator_hash\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"},\"message_hash\":{\"id\":3,\"type\":\"bytes\"}}},\"EthereumTokenInfo\":{\"fields\":{\"address\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"},\"chain_id\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint64\"},\"decimals\":{\"id\":4,\"rule\":\"required\",\"type\":\"uint32\"},\"name\":{\"id\":5,\"rule\":\"required\",\"type\":\"string\"},\"symbol\":{\"id\":3,\"rule\":\"required\",\"type\":\"string\"}}},\"EthereumTxAck\":{\"fields\":{\"data_chunk\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"EthereumTxAckOneKey\":{\"fields\":{\"data_chunk\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"EthereumTxRequest\":{\"fields\":{\"data_length\":{\"id\":1,\"type\":\"uint32\"},\"signature_r\":{\"id\":3,\"type\":\"bytes\"},\"signature_s\":{\"id\":4,\"type\":\"bytes\"},\"signature_v\":{\"id\":2,\"type\":\"uint32\"}}},\"EthereumTxRequestOneKey\":{\"fields\":{\"authorization_signatures\":{\"id\":10,\"rule\":\"repeated\",\"type\":\"EthereumAuthorizationSignature\"},\"data_length\":{\"id\":1,\"type\":\"uint32\"},\"signature_r\":{\"id\":3,\"type\":\"bytes\"},\"signature_s\":{\"id\":4,\"type\":\"bytes\"},\"signature_v\":{\"id\":2,\"type\":\"uint32\"}},\"reserved\":[[5,5],[6,6],[7,7],[8,8],[9,9]]},\"EthereumTypedDataSignature\":{\"fields\":{\"address\":{\"id\":2,\"rule\":\"required\",\"type\":\"string\"},\"signature\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"EthereumTypedDataSignatureOneKey\":{\"fields\":{\"address\":{\"id\":2,\"rule\":\"required\",\"type\":\"string\"},\"signature\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"EthereumTypedDataStructAck\":{\"fields\":{\"members\":{\"id\":1,\"rule\":\"repeated\",\"type\":\"EthereumStructMember\"}},\"nested\":{\"EthereumDataType\":{\"values\":{\"ADDRESS\":6,\"ARRAY\":7,\"BOOL\":5,\"BYTES\":3,\"INT\":2,\"STRING\":4,\"STRUCT\":8,\"UINT\":1}},\"EthereumFieldType\":{\"fields\":{\"data_type\":{\"id\":1,\"rule\":\"required\",\"type\":\"EthereumDataType\"},\"entry_type\":{\"id\":3,\"type\":\"EthereumFieldType\"},\"size\":{\"id\":2,\"type\":\"uint32\"},\"struct_name\":{\"id\":4,\"type\":\"string\"}}},\"EthereumStructMember\":{\"fields\":{\"name\":{\"id\":2,\"rule\":\"required\",\"type\":\"string\"},\"type\":{\"id\":1,\"rule\":\"required\",\"type\":\"EthereumFieldType\"}}}}},\"EthereumTypedDataStructAckOneKey\":{\"fields\":{\"members\":{\"id\":1,\"rule\":\"repeated\",\"type\":\"EthereumStructMemberOneKey\"}},\"nested\":{\"EthereumDataTypeOneKey\":{\"values\":{\"ADDRESS\":6,\"ARRAY\":7,\"BOOL\":5,\"BYTES\":3,\"INT\":2,\"STRING\":4,\"STRUCT\":8,\"UINT\":1}},\"EthereumFieldTypeOneKey\":{\"fields\":{\"data_type\":{\"id\":1,\"rule\":\"required\",\"type\":\"EthereumDataTypeOneKey\"},\"entry_type\":{\"id\":3,\"type\":\"EthereumFieldTypeOneKey\"},\"size\":{\"id\":2,\"type\":\"uint32\"},\"struct_name\":{\"id\":4,\"type\":\"string\"}}},\"EthereumStructMemberOneKey\":{\"fields\":{\"name\":{\"id\":2,\"rule\":\"required\",\"type\":\"string\"},\"type\":{\"id\":1,\"rule\":\"required\",\"type\":\"EthereumFieldTypeOneKey\"}}}}},\"EthereumTypedDataStructRequest\":{\"fields\":{\"name\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"}}},\"EthereumTypedDataStructRequestOneKey\":{\"fields\":{\"name\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"}}},\"EthereumTypedDataValueAck\":{\"fields\":{\"value\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"EthereumTypedDataValueAckOneKey\":{\"fields\":{\"value\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"EthereumTypedDataValueRequest\":{\"fields\":{\"member_path\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"}}},\"EthereumTypedDataValueRequestOneKey\":{\"fields\":{\"member_path\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"}}},\"EthereumVerifyMessage\":{\"fields\":{\"address\":{\"id\":4,\"rule\":\"required\",\"type\":\"string\"},\"message\":{\"id\":3,\"rule\":\"required\",\"type\":\"bytes\"},\"signature\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"EthereumVerifyMessageOneKey\":{\"fields\":{\"address\":{\"id\":4,\"rule\":\"required\",\"type\":\"string\"},\"chain_id\":{\"id\":5,\"type\":\"uint64\"},\"message\":{\"id\":3,\"rule\":\"required\",\"type\":\"bytes\"},\"signature\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"Failure\":{\"fields\":{\"code\":{\"id\":1,\"rule\":\"required\",\"type\":\"FailureType\"},\"message\":{\"id\":3,\"type\":\"string\"},\"subcode\":{\"id\":2,\"type\":\"uint32\"}},\"nested\":{\"FailureType\":{\"values\":{\"Failure_DataError\":4,\"Failure_InvalidMessage\":1,\"Failure_ProcessError\":5,\"Failure_UndefinedError\":2,\"Failure_UsageError\":3}}}},\"Features\":{\"fields\":{\"NFT_voucher\":{\"id\":514,\"type\":\"bytes\"},\"_passphrase_cached\":{\"id\":17,\"options\":{\"deprecated\":true},\"type\":\"bool\"},\"attach_to_pin_user\":{\"id\":625,\"type\":\"bool\"},\"auto_lock_delay_ms\":{\"id\":38,\"type\":\"uint32\"},\"backup_only\":{\"id\":507,\"type\":\"bool\"},\"backup_type\":{\"id\":31,\"type\":\"BackupType\"},\"bootloader_hash\":{\"id\":14,\"type\":\"bytes\"},\"bootloader_mode\":{\"id\":5,\"type\":\"bool\"},\"bootloader_version\":{\"id\":510,\"type\":\"string\"},\"build_id\":{\"id\":518,\"type\":\"bytes\"},\"busy\":{\"id\":41,\"type\":\"bool\"},\"capabilities\":{\"id\":30,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"Capability\"},\"coin_switch\":{\"id\":517,\"type\":\"uint32\"},\"coprocessor_bt_enable\":{\"id\":503,\"type\":\"bool\"},\"coprocessor_bt_name\":{\"id\":501,\"type\":\"string\"},\"coprocessor_version\":{\"id\":502,\"type\":\"string\"},\"cpu_info\":{\"id\":515,\"type\":\"string\"},\"device_id\":{\"id\":6,\"type\":\"string\"},\"display_rotation\":{\"id\":39,\"type\":\"uint32\"},\"experimental_features\":{\"id\":40,\"type\":\"bool\"},\"firmware_present\":{\"id\":18,\"type\":\"bool\"},\"flags\":{\"id\":20,\"type\":\"uint32\"},\"fw_major\":{\"id\":22,\"type\":\"uint32\"},\"fw_minor\":{\"id\":23,\"type\":\"uint32\"},\"fw_patch\":{\"id\":24,\"type\":\"uint32\"},\"fw_vendor\":{\"id\":25,\"type\":\"string\"},\"imported\":{\"id\":15,\"type\":\"bool\"},\"initialized\":{\"id\":12,\"type\":\"bool\"},\"initstates\":{\"id\":513,\"type\":\"uint32\"},\"label\":{\"id\":10,\"type\":\"string\"},\"language\":{\"id\":9,\"type\":\"string\"},\"major_version\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint32\"},\"minor_version\":{\"id\":3,\"rule\":\"required\",\"type\":\"uint32\"},\"model\":{\"id\":21,\"type\":\"string\"},\"needs_backup\":{\"id\":19,\"type\":\"bool\"},\"no_backup\":{\"id\":28,\"type\":\"bool\"},\"offset\":{\"id\":500,\"type\":\"uint32\"},\"onekey_bootloader_build_id\":{\"id\":613,\"type\":\"string\"},\"onekey_bootloader_hash\":{\"id\":605,\"type\":\"bytes\"},\"onekey_bootloader_version\":{\"id\":604,\"type\":\"string\"},\"onekey_coprocessor_bt_name\":{\"id\":614,\"type\":\"string\"},\"onekey_coprocessor_build_id\":{\"id\":616,\"type\":\"string\"},\"onekey_coprocessor_hash\":{\"id\":617,\"type\":\"bytes\"},\"onekey_coprocessor_version\":{\"id\":615,\"type\":\"string\"},\"onekey_device_type\":{\"id\":600,\"type\":\"OneKeyDeviceType\"},\"onekey_firmware_build_id\":{\"id\":611,\"type\":\"string\"},\"onekey_firmware_hash\":{\"id\":610,\"type\":\"bytes\"},\"onekey_firmware_version\":{\"id\":609,\"type\":\"string\"},\"onekey_romloader_hash\":{\"id\":603,\"type\":\"bytes\"},\"onekey_romloader_version\":{\"id\":602,\"type\":\"string\"},\"onekey_se01_build_id\":{\"id\":608,\"type\":\"string\"},\"onekey_se01_hash\":{\"id\":607,\"type\":\"bytes\"},\"onekey_se01_state\":{\"id\":621,\"type\":\"OneKeySEState\"},\"onekey_se01_version\":{\"id\":606,\"type\":\"string\"},\"onekey_se02_state\":{\"id\":622,\"type\":\"OneKeySEState\"},\"onekey_se02_version\":{\"id\":618,\"type\":\"string\"},\"onekey_se03_state\":{\"id\":623,\"type\":\"OneKeySEState\"},\"onekey_se03_version\":{\"id\":619,\"type\":\"string\"},\"onekey_se04_state\":{\"id\":624,\"type\":\"OneKeySEState\"},\"onekey_se04_version\":{\"id\":620,\"type\":\"string\"},\"onekey_se_type\":{\"id\":601,\"type\":\"OneKeySeType\"},\"onekey_serial\":{\"id\":509,\"type\":\"string\"},\"onekey_serial_no\":{\"id\":612,\"type\":\"string\"},\"onekey_version\":{\"id\":508,\"type\":\"string\"},\"passphrase_always_on_device\":{\"id\":36,\"type\":\"bool\"},\"passphrase_protection\":{\"id\":8,\"type\":\"bool\"},\"patch_version\":{\"id\":4,\"rule\":\"required\",\"type\":\"uint32\"},\"pin_protection\":{\"id\":7,\"type\":\"bool\"},\"pre_firmware\":{\"id\":516,\"type\":\"string\"},\"recovery_mode\":{\"id\":29,\"type\":\"bool\"},\"revision\":{\"id\":13,\"type\":\"bytes\"},\"romloader_version\":{\"id\":519,\"type\":\"string\"},\"safety_checks\":{\"id\":37,\"type\":\"SafetyCheckLevel\"},\"sd_card_present\":{\"id\":32,\"type\":\"bool\"},\"sd_protection\":{\"id\":33,\"type\":\"bool\"},\"se_enable\":{\"id\":504,\"type\":\"bool\"},\"se_ver\":{\"id\":506,\"type\":\"string\"},\"serial_no\":{\"id\":511,\"type\":\"string\"},\"session_id\":{\"id\":35,\"type\":\"bytes\"},\"spi_flash\":{\"id\":512,\"type\":\"string\"},\"unfinished_backup\":{\"id\":27,\"type\":\"bool\"},\"unlocked\":{\"id\":16,\"type\":\"bool\"},\"unlocked_attach_pin\":{\"id\":626,\"type\":\"bool\"},\"vendor\":{\"id\":1,\"type\":\"string\"},\"wipe_code_protection\":{\"id\":34,\"type\":\"bool\"}},\"nested\":{\"Capability\":{\"options\":{\"(has_bitcoin_only_values)\":true},\"values\":{\"Capability_AttachToPin\":18,\"Capability_Binance\":3,\"Capability_Bitcoin\":1,\"Capability_Bitcoin_like\":2,\"Capability_Cardano\":4,\"Capability_Crypto\":5,\"Capability_EOS\":6,\"Capability_Ethereum\":7,\"Capability_EthereumTypedData\":1000,\"Capability_Lisk\":8,\"Capability_Monero\":9,\"Capability_NEM\":10,\"Capability_PassphraseEntry\":17,\"Capability_Ripple\":11,\"Capability_Shamir\":15,\"Capability_ShamirGroups\":16,\"Capability_Stellar\":12,\"Capability_Tezos\":13,\"Capability_U2F\":14}}}},\"FileInfoList\":{\"fields\":{\"files\":{\"id\":1,\"rule\":\"repeated\",\"type\":\"FileInfo\"}},\"nested\":{\"FileInfo\":{\"fields\":{\"name\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"},\"size\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint64\"}}}}},\"FilecoinAddress\":{\"fields\":{\"address\":{\"id\":1,\"type\":\"string\"}}},\"FilecoinGetAddress\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"show_display\":{\"id\":2,\"type\":\"bool\"},\"testnet\":{\"id\":3,\"type\":\"bool\"}}},\"FilecoinSignTx\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"raw_tx\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"},\"testnet\":{\"id\":3,\"type\":\"bool\"}}},\"FilecoinSignedTx\":{\"fields\":{\"signature\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"FilesystemDir\":{\"fields\":{\"child_dirs\":{\"id\":2,\"type\":\"string\"},\"child_files\":{\"id\":3,\"type\":\"string\"},\"path\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"}}},\"FilesystemDirList\":{\"fields\":{\"depth\":{\"id\":2,\"options\":{\"default\":0},\"type\":\"uint32\"},\"path\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"}}},\"FilesystemDirMake\":{\"fields\":{\"path\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"}}},\"FilesystemDirRemove\":{\"fields\":{\"path\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"}}},\"FilesystemFile\":{\"fields\":{\"data\":{\"id\":4,\"type\":\"bytes\"},\"data_hash\":{\"id\":5,\"type\":\"uint32\"},\"offset\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint32\"},\"path\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"},\"processed_byte\":{\"id\":6,\"type\":\"uint32\"},\"total_size\":{\"id\":3,\"rule\":\"required\",\"type\":\"uint32\"}}},\"FilesystemFileDelete\":{\"fields\":{\"path\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"}}},\"FilesystemFileRead\":{\"fields\":{\"chunk_len\":{\"id\":2,\"type\":\"uint32\"},\"file\":{\"id\":1,\"rule\":\"required\",\"type\":\"FilesystemFile\"},\"ui_percentage\":{\"id\":3,\"type\":\"uint32\"}}},\"FilesystemFileWrite\":{\"fields\":{\"append\":{\"id\":3,\"rule\":\"required\",\"type\":\"bool\"},\"file\":{\"id\":1,\"rule\":\"required\",\"type\":\"FilesystemFile\"},\"overwrite\":{\"id\":2,\"rule\":\"required\",\"type\":\"bool\"},\"ui_percentage\":{\"id\":4,\"type\":\"uint32\"}}},\"FilesystemFormat\":{\"fields\":{\"data\":{\"id\":1,\"rule\":\"required\",\"type\":\"bool\"},\"user\":{\"id\":2,\"rule\":\"required\",\"type\":\"bool\"}}},\"FilesystemPathInfo\":{\"fields\":{\"archive\":{\"id\":12,\"rule\":\"required\",\"type\":\"bool\"},\"day\":{\"id\":5,\"rule\":\"required\",\"type\":\"uint32\"},\"directory\":{\"id\":13,\"rule\":\"required\",\"type\":\"bool\"},\"exist\":{\"id\":1,\"rule\":\"required\",\"type\":\"bool\"},\"hidden\":{\"id\":10,\"rule\":\"required\",\"type\":\"bool\"},\"hour\":{\"id\":6,\"rule\":\"required\",\"type\":\"uint32\"},\"minute\":{\"id\":7,\"rule\":\"required\",\"type\":\"uint32\"},\"month\":{\"id\":4,\"rule\":\"required\",\"type\":\"uint32\"},\"readonly\":{\"id\":9,\"rule\":\"required\",\"type\":\"bool\"},\"second\":{\"id\":8,\"rule\":\"required\",\"type\":\"uint32\"},\"size\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint64\"},\"system\":{\"id\":11,\"rule\":\"required\",\"type\":\"bool\"},\"year\":{\"id\":3,\"rule\":\"required\",\"type\":\"uint32\"}}},\"FilesystemPathInfoQuery\":{\"fields\":{\"path\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"}}},\"FilesystemPermissionFix\":{\"fields\":{}},\"FirmwareHash\":{\"fields\":{\"hash\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"GetAddress\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"coin_name\":{\"id\":2,\"options\":{\"default\":\"Bitcoin\"},\"type\":\"string\"},\"ignore_xpub_magic\":{\"id\":6,\"type\":\"bool\"},\"multisig\":{\"id\":4,\"type\":\"MultisigRedeemScriptType\"},\"script_type\":{\"id\":5,\"options\":{\"default\":\"SPENDADDRESS\"},\"type\":\"InputScriptType\"},\"show_display\":{\"id\":3,\"type\":\"bool\"}}},\"GetECDHSessionKey\":{\"fields\":{\"ecdsa_curve_name\":{\"id\":3,\"type\":\"string\"},\"identity\":{\"id\":1,\"rule\":\"required\",\"type\":\"IdentityType\"},\"peer_public_key\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"GetEntropy\":{\"fields\":{\"size\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint32\"}}},\"GetFeatures\":{\"fields\":{}},\"GetFirmwareHash\":{\"fields\":{\"challenge\":{\"id\":1,\"type\":\"bytes\"}}},\"GetNextU2FCounter\":{\"fields\":{}},\"GetNonce\":{\"fields\":{},\"options\":{\"(experimental_message)\":true}},\"GetOwnershipId\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"coin_name\":{\"id\":2,\"options\":{\"default\":\"Bitcoin\"},\"type\":\"string\"},\"multisig\":{\"id\":3,\"type\":\"MultisigRedeemScriptType\"},\"script_type\":{\"id\":4,\"options\":{\"default\":\"SPENDADDRESS\"},\"type\":\"InputScriptType\"}}},\"GetOwnershipProof\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"coin_name\":{\"id\":2,\"options\":{\"default\":\"Bitcoin\"},\"type\":\"string\"},\"commitment_data\":{\"id\":7,\"options\":{\"default\":\"\"},\"type\":\"bytes\"},\"multisig\":{\"id\":4,\"type\":\"MultisigRedeemScriptType\"},\"ownership_ids\":{\"id\":6,\"rule\":\"repeated\",\"type\":\"bytes\"},\"script_type\":{\"id\":3,\"options\":{\"default\":\"SPENDWITNESS\"},\"type\":\"InputScriptType\"},\"user_confirmation\":{\"id\":5,\"options\":{\"default\":false},\"type\":\"bool\"}}},\"GetPassphraseState\":{\"fields\":{\"passphrase_state\":{\"id\":1,\"type\":\"string\"}}},\"GetPublicKey\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"coin_name\":{\"id\":4,\"options\":{\"default\":\"Bitcoin\"},\"type\":\"string\"},\"ecdsa_curve_name\":{\"id\":2,\"type\":\"string\"},\"ignore_xpub_magic\":{\"id\":6,\"type\":\"bool\"},\"script_type\":{\"id\":5,\"options\":{\"default\":\"SPENDADDRESS\"},\"type\":\"InputScriptType\"},\"show_display\":{\"id\":3,\"type\":\"bool\"}}},\"HDNodeType\":{\"fields\":{\"chain_code\":{\"id\":4,\"rule\":\"required\",\"type\":\"bytes\"},\"child_num\":{\"id\":3,\"rule\":\"required\",\"type\":\"uint32\"},\"depth\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint32\"},\"fingerprint\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint32\"},\"private_key\":{\"id\":5,\"type\":\"bytes\"},\"public_key\":{\"id\":6,\"rule\":\"required\",\"type\":\"bytes\"}}},\"IdentityType\":{\"fields\":{\"host\":{\"id\":3,\"type\":\"string\"},\"index\":{\"id\":6,\"options\":{\"default\":0},\"type\":\"uint32\"},\"path\":{\"id\":5,\"type\":\"string\"},\"port\":{\"id\":4,\"type\":\"string\"},\"proto\":{\"id\":1,\"type\":\"string\"},\"user\":{\"id\":2,\"type\":\"string\"}}},\"Initialize\":{\"fields\":{\"_skip_passphrase\":{\"id\":2,\"options\":{\"deprecated\":true},\"type\":\"bool\"},\"derive_cardano\":{\"id\":3,\"type\":\"bool\"},\"is_contains_attach\":{\"id\":8001,\"type\":\"bool\"},\"passphrase_state\":{\"id\":8000,\"type\":\"string\"},\"session_id\":{\"id\":1,\"type\":\"bytes\"}}},\"InputScriptType\":{\"values\":{\"EXTERNAL\":2,\"SPENDADDRESS\":0,\"SPENDMULTISIG\":1,\"SPENDP2SHWITNESS\":4,\"SPENDTAPROOT\":5,\"SPENDWITNESS\":3}},\"InternalMyAddressRequest\":{\"fields\":{\"account_index\":{\"id\":3,\"rule\":\"required\",\"type\":\"uint32\"},\"chain_id\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint32\"},\"coin_type\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint32\"},\"derive_type\":{\"id\":4,\"rule\":\"required\",\"type\":\"uint32\"}}},\"KaspaAddress\":{\"fields\":{\"address\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"}}},\"KaspaGetAddress\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"prefix\":{\"id\":3,\"options\":{\"default\":\"kaspa\"},\"type\":\"string\"},\"scheme\":{\"id\":4,\"options\":{\"default\":\"schnorr\"},\"type\":\"string\"},\"show_display\":{\"id\":2,\"type\":\"bool\"},\"use_tweak\":{\"id\":5,\"options\":{\"default\":true},\"type\":\"bool\"}}},\"KaspaSignTx\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"input_count\":{\"id\":5,\"options\":{\"default\":1},\"type\":\"uint32\"},\"prefix\":{\"id\":4,\"options\":{\"default\":\"kaspa\"},\"type\":\"string\"},\"raw_message\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"},\"scheme\":{\"id\":3,\"options\":{\"default\":\"schnorr\"},\"type\":\"string\"},\"use_tweak\":{\"id\":6,\"options\":{\"default\":true},\"type\":\"bool\"}}},\"KaspaSignedTx\":{\"fields\":{\"signature\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"KaspaTxInputAck\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"raw_message\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"KaspaTxInputRequest\":{\"fields\":{\"request_index\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint32\"},\"signature\":{\"id\":2,\"type\":\"bytes\"}}},\"ListResDir\":{\"fields\":{\"path\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"}}},\"LnurlAuth\":{\"fields\":{\"data\":{\"id\":3,\"rule\":\"required\",\"type\":\"bytes\"},\"domain\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"LnurlAuthResp\":{\"fields\":{\"path\":{\"id\":2,\"type\":\"string\"},\"publickey\":{\"id\":1,\"type\":\"string\"},\"signature\":{\"id\":3,\"type\":\"bytes\"}}},\"LoadDevice\":{\"fields\":{\"label\":{\"id\":6,\"type\":\"string\"},\"language\":{\"id\":5,\"options\":{\"default\":\"en-US\"},\"type\":\"string\"},\"mnemonics\":{\"id\":1,\"rule\":\"repeated\",\"type\":\"string\"},\"needs_backup\":{\"id\":9,\"type\":\"bool\"},\"no_backup\":{\"id\":10,\"type\":\"bool\"},\"passphrase_protection\":{\"id\":4,\"type\":\"bool\"},\"pin\":{\"id\":3,\"type\":\"string\"},\"skip_checksum\":{\"id\":7,\"type\":\"bool\"},\"u2f_counter\":{\"id\":8,\"type\":\"uint32\"}}},\"LockDevice\":{\"fields\":{}},\"MessageSignature\":{\"fields\":{\"address\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"},\"signature\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"MessageType\":{\"options\":{\"(has_bitcoin_only_values)\":true},\"reserved\":[[90,92],[114,122],[300,304],[309,312]],\"values\":{\"MessageType_Address\":30,\"MessageType_AlephiumAddress\":12102,\"MessageType_AlephiumBytecodeAck\":12108,\"MessageType_AlephiumBytecodeRequest\":12107,\"MessageType_AlephiumGetAddress\":12101,\"MessageType_AlephiumMessageSignature\":12110,\"MessageType_AlephiumSignMessage\":12109,\"MessageType_AlephiumSignTx\":12103,\"MessageType_AlephiumSignedTx\":12104,\"MessageType_AlephiumTxAck\":12106,\"MessageType_AlephiumTxRequest\":12105,\"MessageType_AlgorandAddress\":10901,\"MessageType_AlgorandGetAddress\":10900,\"MessageType_AlgorandSignTx\":10902,\"MessageType_AlgorandSignedTx\":10903,\"MessageType_ApplyFlags\":28,\"MessageType_ApplySettings\":25,\"MessageType_AptosAddress\":10601,\"MessageType_AptosGetAddress\":10600,\"MessageType_AptosMessageSignature\":10605,\"MessageType_AptosSignMessage\":10604,\"MessageType_AptosSignSIWAMessage\":10606,\"MessageType_AptosSignTx\":10602,\"MessageType_AptosSignedTx\":10603,\"MessageType_AuthorizeCoinJoin\":51,\"MessageType_BackupDevice\":34,\"MessageType_BatchGetPublickeys\":10016,\"MessageType_BenfenAddress\":12202,\"MessageType_BenfenGetAddress\":12201,\"MessageType_BenfenMessageSignature\":12206,\"MessageType_BenfenSignMessage\":12205,\"MessageType_BenfenSignTx\":12203,\"MessageType_BenfenSignedTx\":12204,\"MessageType_BenfenTxAck\":12208,\"MessageType_BenfenTxRequest\":12207,\"MessageType_BinanceAddress\":701,\"MessageType_BinanceCancelMsg\":708,\"MessageType_BinanceGetAddress\":700,\"MessageType_BinanceGetPublicKey\":702,\"MessageType_BinanceOrderMsg\":707,\"MessageType_BinancePublicKey\":703,\"MessageType_BinanceSignTx\":704,\"MessageType_BinanceSignedTx\":709,\"MessageType_BinanceTransferMsg\":706,\"MessageType_BinanceTxRequest\":705,\"MessageType_ButtonAck\":27,\"MessageType_ButtonRequest\":26,\"MessageType_Cancel\":20,\"MessageType_CancelAuthorization\":86,\"MessageType_CardanoAddress\":308,\"MessageType_CardanoAssetGroup\":323,\"MessageType_CardanoGetAddress\":307,\"MessageType_CardanoGetNativeScriptHash\":330,\"MessageType_CardanoGetPublicKey\":305,\"MessageType_CardanoMessageSignature\":351,\"MessageType_CardanoNativeScriptHash\":331,\"MessageType_CardanoPoolOwner\":328,\"MessageType_CardanoPoolRelayParameters\":329,\"MessageType_CardanoPublicKey\":306,\"MessageType_CardanoSignMessage\":350,\"MessageType_CardanoSignTxFinished\":319,\"MessageType_CardanoSignTxInit\":320,\"MessageType_CardanoToken\":324,\"MessageType_CardanoTxAuxiliaryData\":327,\"MessageType_CardanoTxAuxiliaryDataSupplement\":314,\"MessageType_CardanoTxBodyHash\":318,\"MessageType_CardanoTxCertificate\":325,\"MessageType_CardanoTxCollateralInput\":333,\"MessageType_CardanoTxHostAck\":317,\"MessageType_CardanoTxInlineDatumChunk\":335,\"MessageType_CardanoTxInput\":321,\"MessageType_CardanoTxItemAck\":313,\"MessageType_CardanoTxMint\":332,\"MessageType_CardanoTxOutput\":322,\"MessageType_CardanoTxReferenceInput\":337,\"MessageType_CardanoTxReferenceScriptChunk\":336,\"MessageType_CardanoTxRequiredSigner\":334,\"MessageType_CardanoTxWithdrawal\":326,\"MessageType_CardanoTxWitnessRequest\":315,\"MessageType_CardanoTxWitnessResponse\":316,\"MessageType_ChangePin\":4,\"MessageType_ChangeWipeCode\":82,\"MessageType_CipherKeyValue\":23,\"MessageType_CipheredKeyValue\":48,\"MessageType_ConfluxAddress\":10113,\"MessageType_ConfluxGetAddress\":10112,\"MessageType_ConfluxMessageSignature\":10119,\"MessageType_ConfluxSignMessage\":10117,\"MessageType_ConfluxSignMessageCIP23\":10118,\"MessageType_ConfluxSignTx\":10114,\"MessageType_ConfluxTxAck\":10116,\"MessageType_ConfluxTxRequest\":10115,\"MessageType_CosiCommit\":71,\"MessageType_CosiCommitment\":72,\"MessageType_CosiSign\":73,\"MessageType_CosiSignature\":74,\"MessageType_CosmosAddress\":10801,\"MessageType_CosmosGetAddress\":10800,\"MessageType_CosmosSignTx\":10802,\"MessageType_CosmosSignedTx\":10803,\"MessageType_DebugMoneroDiagAck\":547,\"MessageType_DebugMoneroDiagRequest\":546,\"MessageType_Deprecated_PassphraseStateAck\":78,\"MessageType_Deprecated_PassphraseStateRequest\":77,\"MessageType_DeviceAnimationControl\":60461,\"MessageType_DeviceCertificate\":60420,\"MessageType_DeviceCertificateRead\":60422,\"MessageType_DeviceCertificateSign\":60424,\"MessageType_DeviceCertificateSignature\":60423,\"MessageType_DeviceCertificateWrite\":60421,\"MessageType_DeviceFactoryInfo\":60002,\"MessageType_DeviceFactoryInfoGet\":60001,\"MessageType_DeviceFactoryInfoSet\":60000,\"MessageType_DeviceFactoryPermanentLock\":60003,\"MessageType_DeviceFactoryTest\":60004,\"MessageType_DeviceFindMyTokenState\":60450,\"MessageType_DeviceFindMyTokenStateGet\":60452,\"MessageType_DeviceFindMyTokenUpdate\":60451,\"MessageType_DeviceFirmwareUpdateRequest\":61001,\"MessageType_DeviceFirmwareUpdateStage\":61000,\"MessageType_DeviceFirmwareUpdateStatus\":61003,\"MessageType_DeviceFirmwareUpdateStatusGet\":61002,\"MessageType_DeviceInfo\":60601,\"MessageType_DeviceInfoGet\":60600,\"MessageType_DeviceMiscUsbMscControl\":60440,\"MessageType_DeviceReboot\":60400,\"MessageType_DeviceSession\":61201,\"MessageType_DeviceSessionAskPassphrase\":61203,\"MessageType_DeviceSessionAskPin\":61202,\"MessageType_DeviceSessionGet\":61200,\"MessageType_DeviceSettings\":60410,\"MessageType_DeviceSettingsGet\":60411,\"MessageType_DeviceSettingsPageShow\":60413,\"MessageType_DeviceSettingsSet\":60412,\"MessageType_DeviceStatus\":60603,\"MessageType_DeviceStatusGet\":60602,\"MessageType_DoPreauthorized\":84,\"MessageType_ECDHSessionKey\":62,\"MessageType_EcdsaPublicKeys\":10017,\"MessageType_Entropy\":10,\"MessageType_EntropyAck\":36,\"MessageType_EntropyRequest\":35,\"MessageType_EosGetPublicKey\":600,\"MessageType_EosPublicKey\":601,\"MessageType_EosSignTx\":602,\"MessageType_EosSignedTx\":605,\"MessageType_EosTxActionAck\":604,\"MessageType_EosTxActionRequest\":603,\"MessageType_EthereumAddress\":57,\"MessageType_EthereumAddressOneKey\":20103,\"MessageType_EthereumGetAddress\":56,\"MessageType_EthereumGetAddressOneKey\":20102,\"MessageType_EthereumGetPublicKey\":450,\"MessageType_EthereumGetPublicKeyOneKey\":20100,\"MessageType_EthereumGnosisSafeTxAck\":20118,\"MessageType_EthereumGnosisSafeTxRequest\":20119,\"MessageType_EthereumMessageSignature\":66,\"MessageType_EthereumMessageSignatureOneKey\":20110,\"MessageType_EthereumPublicKey\":451,\"MessageType_EthereumPublicKeyOneKey\":20101,\"MessageType_EthereumSignMessage\":64,\"MessageType_EthereumSignMessageOneKey\":20108,\"MessageType_EthereumSignTx\":58,\"MessageType_EthereumSignTxEIP1559\":452,\"MessageType_EthereumSignTxEIP1559OneKey\":20105,\"MessageType_EthereumSignTxEIP7702OneKey\":20120,\"MessageType_EthereumSignTxOneKey\":20104,\"MessageType_EthereumSignTypedData\":464,\"MessageType_EthereumSignTypedDataOneKey\":20111,\"MessageType_EthereumSignTypedDataQR\":20121,\"MessageType_EthereumSignTypedHash\":470,\"MessageType_EthereumSignTypedHashOneKey\":20117,\"MessageType_EthereumTxAck\":60,\"MessageType_EthereumTxAckOneKey\":20107,\"MessageType_EthereumTxRequest\":59,\"MessageType_EthereumTxRequestOneKey\":20106,\"MessageType_EthereumTypedDataSignature\":469,\"MessageType_EthereumTypedDataSignatureOneKey\":20116,\"MessageType_EthereumTypedDataStructAck\":466,\"MessageType_EthereumTypedDataStructAckOneKey\":20113,\"MessageType_EthereumTypedDataStructRequest\":465,\"MessageType_EthereumTypedDataStructRequestOneKey\":20112,\"MessageType_EthereumTypedDataValueAck\":468,\"MessageType_EthereumTypedDataValueAckOneKey\":20115,\"MessageType_EthereumTypedDataValueRequest\":467,\"MessageType_EthereumTypedDataValueRequestOneKey\":20114,\"MessageType_EthereumVerifyMessage\":65,\"MessageType_EthereumVerifyMessageOneKey\":20109,\"MessageType_Failure\":60208,\"MessageType_Features\":17,\"MessageType_FilecoinAddress\":11201,\"MessageType_FilecoinGetAddress\":11200,\"MessageType_FilecoinSignTx\":11202,\"MessageType_FilecoinSignedTx\":11203,\"MessageType_FilesystemDir\":60807,\"MessageType_FilesystemDirList\":60808,\"MessageType_FilesystemDirMake\":60809,\"MessageType_FilesystemDirRemove\":60810,\"MessageType_FilesystemFile\":60803,\"MessageType_FilesystemFileDelete\":60806,\"MessageType_FilesystemFileRead\":60804,\"MessageType_FilesystemFileWrite\":60805,\"MessageType_FilesystemFormat\":60811,\"MessageType_FilesystemPathInfo\":60801,\"MessageType_FilesystemPathInfoQuery\":60802,\"MessageType_FilesystemPermissionFix\":60800,\"MessageType_FirmwareHash\":89,\"MessageType_GetAddress\":29,\"MessageType_GetECDHSessionKey\":61,\"MessageType_GetEntropy\":9,\"MessageType_GetFeatures\":55,\"MessageType_GetFirmwareHash\":88,\"MessageType_GetNextU2FCounter\":80,\"MessageType_GetNonce\":31,\"MessageType_GetOwnershipId\":43,\"MessageType_GetOwnershipProof\":49,\"MessageType_GetPublicKey\":11,\"MessageType_Initialize\":0,\"MessageType_KaspaAddress\":11301,\"MessageType_KaspaGetAddress\":11300,\"MessageType_KaspaSignTx\":11302,\"MessageType_KaspaSignedTx\":11303,\"MessageType_KaspaTxInputAck\":11305,\"MessageType_KaspaTxInputRequest\":11304,\"MessageType_LnurlAuth\":11600,\"MessageType_LnurlAuthResp\":11601,\"MessageType_LoadDevice\":13,\"MessageType_LockDevice\":24,\"MessageType_MessageSignature\":40,\"MessageType_MoneroAddress\":541,\"MessageType_MoneroGetAddress\":540,\"MessageType_MoneroGetTxKeyAck\":551,\"MessageType_MoneroGetTxKeyRequest\":550,\"MessageType_MoneroGetWatchKey\":542,\"MessageType_MoneroKeyImageExportInitAck\":531,\"MessageType_MoneroKeyImageExportInitRequest\":530,\"MessageType_MoneroKeyImageSyncFinalAck\":535,\"MessageType_MoneroKeyImageSyncFinalRequest\":534,\"MessageType_MoneroKeyImageSyncStepAck\":533,\"MessageType_MoneroKeyImageSyncStepRequest\":532,\"MessageType_MoneroLiveRefreshFinalAck\":557,\"MessageType_MoneroLiveRefreshFinalRequest\":556,\"MessageType_MoneroLiveRefreshStartAck\":553,\"MessageType_MoneroLiveRefreshStartRequest\":552,\"MessageType_MoneroLiveRefreshStepAck\":555,\"MessageType_MoneroLiveRefreshStepRequest\":554,\"MessageType_MoneroTransactionAllInputsSetAck\":510,\"MessageType_MoneroTransactionAllInputsSetRequest\":509,\"MessageType_MoneroTransactionAllOutSetAck\":514,\"MessageType_MoneroTransactionAllOutSetRequest\":513,\"MessageType_MoneroTransactionFinalAck\":518,\"MessageType_MoneroTransactionFinalRequest\":517,\"MessageType_MoneroTransactionInitAck\":502,\"MessageType_MoneroTransactionInitRequest\":501,\"MessageType_MoneroTransactionInputViniAck\":508,\"MessageType_MoneroTransactionInputViniRequest\":507,\"MessageType_MoneroTransactionSetInputAck\":504,\"MessageType_MoneroTransactionSetInputRequest\":503,\"MessageType_MoneroTransactionSetOutputAck\":512,\"MessageType_MoneroTransactionSetOutputRequest\":511,\"MessageType_MoneroTransactionSignInputAck\":516,\"MessageType_MoneroTransactionSignInputRequest\":515,\"MessageType_MoneroWatchKey\":543,\"MessageType_NEMAddress\":68,\"MessageType_NEMDecryptMessage\":75,\"MessageType_NEMDecryptedMessage\":76,\"MessageType_NEMGetAddress\":67,\"MessageType_NEMSignTx\":69,\"MessageType_NEMSignedTx\":70,\"MessageType_NearAddress\":10702,\"MessageType_NearGetAddress\":10701,\"MessageType_NearSignTx\":10703,\"MessageType_NearSignedTx\":10704,\"MessageType_NeoAddress\":12302,\"MessageType_NeoGetAddress\":12301,\"MessageType_NeoSignTx\":12303,\"MessageType_NeoSignedTx\":12304,\"MessageType_NervosAddress\":11702,\"MessageType_NervosGetAddress\":11701,\"MessageType_NervosSignTx\":11703,\"MessageType_NervosSignedTx\":11704,\"MessageType_NervosTxAck\":11706,\"MessageType_NervosTxRequest\":11705,\"MessageType_NexaAddress\":11401,\"MessageType_NexaGetAddress\":11400,\"MessageType_NexaSignTx\":11402,\"MessageType_NexaSignedTx\":11403,\"MessageType_NexaTxInputAck\":11405,\"MessageType_NexaTxInputRequest\":11404,\"MessageType_NextU2FCounter\":81,\"MessageType_NftUpdate\":61500,\"MessageType_Nonce\":33,\"MessageType_NostrDecryptMessage\":11506,\"MessageType_NostrDecryptedMessage\":11507,\"MessageType_NostrEncryptMessage\":11504,\"MessageType_NostrEncryptedMessage\":11505,\"MessageType_NostrGetPublicKey\":11500,\"MessageType_NostrPublicKey\":11501,\"MessageType_NostrSignEvent\":11502,\"MessageType_NostrSignSchnorr\":11508,\"MessageType_NostrSignedEvent\":11503,\"MessageType_NostrSignedSchnorr\":11509,\"MessageType_OnboardingStatus\":61601,\"MessageType_OnboardingStatusGet\":61600,\"MessageType_OwnershipId\":44,\"MessageType_OwnershipProof\":50,\"MessageType_PassphraseAck\":42,\"MessageType_PassphraseRequest\":41,\"MessageType_Ping\":60206,\"MessageType_PolkadotAddress\":11001,\"MessageType_PolkadotGetAddress\":11000,\"MessageType_PolkadotSignTx\":11002,\"MessageType_PolkadotSignedTx\":11003,\"MessageType_PortfolioUpdate\":61400,\"MessageType_PreauthorizedRequest\":85,\"MessageType_ProtocolInfo\":60201,\"MessageType_ProtocolInfoRequest\":60200,\"MessageType_PublicKey\":12,\"MessageType_RecoveryDevice\":45,\"MessageType_ResetDevice\":14,\"MessageType_RippleAddress\":401,\"MessageType_RippleGetAddress\":400,\"MessageType_RippleSignTx\":402,\"MessageType_RippleSignedTx\":403,\"MessageType_SdProtect\":79,\"MessageType_SetBusy\":16,\"MessageType_SetU2FCounter\":63,\"MessageType_SignIdentity\":53,\"MessageType_SignMessage\":38,\"MessageType_SignPsbt\":10052,\"MessageType_SignTx\":15,\"MessageType_SignedIdentity\":54,\"MessageType_SignedPsbt\":10053,\"MessageType_SolanaAddress\":10101,\"MessageType_SolanaGetAddress\":10100,\"MessageType_SolanaMessageSignature\":10105,\"MessageType_SolanaSignOffChainMessage\":10104,\"MessageType_SolanaSignTx\":10102,\"MessageType_SolanaSignUnsafeMessage\":10106,\"MessageType_SolanaSignedTx\":10103,\"MessageType_StarcoinAddress\":10301,\"MessageType_StarcoinGetAddress\":10300,\"MessageType_StarcoinGetPublicKey\":10302,\"MessageType_StarcoinMessageSignature\":10307,\"MessageType_StarcoinPublicKey\":10303,\"MessageType_StarcoinSignMessage\":10306,\"MessageType_StarcoinSignTx\":10304,\"MessageType_StarcoinSignedTx\":10305,\"MessageType_StarcoinVerifyMessage\":10308,\"MessageType_StellarAccountMergeOp\":218,\"MessageType_StellarAddress\":208,\"MessageType_StellarAllowTrustOp\":217,\"MessageType_StellarBumpSequenceOp\":221,\"MessageType_StellarChangeTrustOp\":216,\"MessageType_StellarCreateAccountOp\":210,\"MessageType_StellarCreatePassiveSellOfferOp\":214,\"MessageType_StellarGetAddress\":207,\"MessageType_StellarManageBuyOfferOp\":222,\"MessageType_StellarManageDataOp\":220,\"MessageType_StellarManageSellOfferOp\":213,\"MessageType_StellarPathPaymentStrictReceiveOp\":212,\"MessageType_StellarPathPaymentStrictSendOp\":223,\"MessageType_StellarPaymentOp\":211,\"MessageType_StellarSetOptionsOp\":215,\"MessageType_StellarSignTx\":202,\"MessageType_StellarSignedTx\":230,\"MessageType_StellarTxOpRequest\":203,\"MessageType_Success\":60207,\"MessageType_SuiAddress\":11101,\"MessageType_SuiGetAddress\":11100,\"MessageType_SuiMessageSignature\":11105,\"MessageType_SuiSignMessage\":11104,\"MessageType_SuiSignTx\":11102,\"MessageType_SuiSignedTx\":11103,\"MessageType_SuiTxAck\":11107,\"MessageType_SuiTxRequest\":11106,\"MessageType_TezosAddress\":151,\"MessageType_TezosGetAddress\":150,\"MessageType_TezosGetPublicKey\":154,\"MessageType_TezosPublicKey\":155,\"MessageType_TezosSignTx\":152,\"MessageType_TezosSignedTx\":153,\"MessageType_TonAddress\":11902,\"MessageType_TonGetAddress\":11901,\"MessageType_TonSignMessage\":11903,\"MessageType_TonSignProof\":11905,\"MessageType_TonSignedMessage\":11904,\"MessageType_TonSignedProof\":11906,\"MessageType_TonTxAck\":11907,\"MessageType_TronAddress\":10502,\"MessageType_TronGetAddress\":10501,\"MessageType_TronMessageSignature\":10506,\"MessageType_TronSignMessage\":10505,\"MessageType_TronSignTx\":10503,\"MessageType_TronSignedTx\":10504,\"MessageType_TxAck\":22,\"MessageType_TxAckPaymentRequest\":37,\"MessageType_TxRequest\":21,\"MessageType_UnlockPath\":93,\"MessageType_UnlockedPathRequest\":94,\"MessageType_VerifyMessage\":39,\"MessageType_WebAuthnAddResidentCredential\":802,\"MessageType_WebAuthnCredentials\":801,\"MessageType_WebAuthnListResidentCredentials\":800,\"MessageType_WebAuthnRemoveResidentCredential\":803,\"MessageType_WipeDevice\":5,\"MessageType_WordAck\":47,\"MessageType_WordRequest\":46}},\"MoneroAddress\":{\"fields\":{\"address\":{\"id\":1,\"type\":\"bytes\"}}},\"MoneroGetAddress\":{\"fields\":{\"account\":{\"id\":4,\"type\":\"uint32\"},\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"minor\":{\"id\":5,\"type\":\"uint32\"},\"network_type\":{\"id\":3,\"options\":{\"default\":\"MAINNET\"},\"type\":\"MoneroNetworkType\"},\"payment_id\":{\"id\":6,\"type\":\"bytes\"},\"show_display\":{\"id\":2,\"type\":\"bool\"}}},\"MoneroGetTxKeyAck\":{\"fields\":{\"salt\":{\"id\":1,\"type\":\"bytes\"},\"tx_derivations\":{\"id\":3,\"type\":\"bytes\"},\"tx_keys\":{\"id\":2,\"type\":\"bytes\"}}},\"MoneroGetTxKeyRequest\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"network_type\":{\"id\":2,\"options\":{\"default\":\"MAINNET\"},\"type\":\"MoneroNetworkType\"},\"reason\":{\"id\":7,\"type\":\"uint32\"},\"salt1\":{\"id\":3,\"rule\":\"required\",\"type\":\"bytes\"},\"salt2\":{\"id\":4,\"rule\":\"required\",\"type\":\"bytes\"},\"tx_enc_keys\":{\"id\":5,\"rule\":\"required\",\"type\":\"bytes\"},\"tx_prefix_hash\":{\"id\":6,\"rule\":\"required\",\"type\":\"bytes\"},\"view_public_key\":{\"id\":8,\"type\":\"bytes\"}}},\"MoneroGetWatchKey\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"network_type\":{\"id\":2,\"options\":{\"default\":\"MAINNET\"},\"type\":\"MoneroNetworkType\"}}},\"MoneroKeyImageExportInitAck\":{\"fields\":{}},\"MoneroKeyImageExportInitRequest\":{\"fields\":{\"address_n\":{\"id\":3,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"hash\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"},\"network_type\":{\"id\":4,\"options\":{\"default\":\"MAINNET\"},\"type\":\"MoneroNetworkType\"},\"num\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint64\"},\"subs\":{\"id\":5,\"rule\":\"repeated\",\"type\":\"MoneroSubAddressIndicesList\"}},\"nested\":{\"MoneroSubAddressIndicesList\":{\"fields\":{\"account\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint32\"},\"minor_indices\":{\"id\":2,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"}}}}},\"MoneroKeyImageSyncFinalAck\":{\"fields\":{\"enc_key\":{\"id\":1,\"type\":\"bytes\"}}},\"MoneroKeyImageSyncFinalRequest\":{\"fields\":{}},\"MoneroKeyImageSyncStepAck\":{\"fields\":{\"kis\":{\"id\":1,\"rule\":\"repeated\",\"type\":\"MoneroExportedKeyImage\"}},\"nested\":{\"MoneroExportedKeyImage\":{\"fields\":{\"blob\":{\"id\":3,\"type\":\"bytes\"},\"iv\":{\"id\":1,\"type\":\"bytes\"}}}}},\"MoneroKeyImageSyncStepRequest\":{\"fields\":{\"tdis\":{\"id\":1,\"rule\":\"repeated\",\"type\":\"MoneroTransferDetails\"}},\"nested\":{\"MoneroTransferDetails\":{\"fields\":{\"additional_tx_pub_keys\":{\"id\":3,\"rule\":\"repeated\",\"type\":\"bytes\"},\"internal_output_index\":{\"id\":4,\"rule\":\"required\",\"type\":\"uint64\"},\"out_key\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"},\"sub_addr_major\":{\"id\":5,\"type\":\"uint32\"},\"sub_addr_minor\":{\"id\":6,\"type\":\"uint32\"},\"tx_pub_key\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}}}},\"MoneroLiveRefreshFinalAck\":{\"fields\":{}},\"MoneroLiveRefreshFinalRequest\":{\"fields\":{}},\"MoneroLiveRefreshStartAck\":{\"fields\":{}},\"MoneroLiveRefreshStartRequest\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"network_type\":{\"id\":2,\"options\":{\"default\":\"MAINNET\"},\"type\":\"MoneroNetworkType\"}}},\"MoneroLiveRefreshStepAck\":{\"fields\":{\"key_image\":{\"id\":2,\"type\":\"bytes\"},\"salt\":{\"id\":1,\"type\":\"bytes\"}}},\"MoneroLiveRefreshStepRequest\":{\"fields\":{\"out_key\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"},\"real_out_idx\":{\"id\":3,\"rule\":\"required\",\"type\":\"uint64\"},\"recv_deriv\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"},\"sub_addr_major\":{\"id\":4,\"rule\":\"required\",\"type\":\"uint32\"},\"sub_addr_minor\":{\"id\":5,\"rule\":\"required\",\"type\":\"uint32\"}}},\"MoneroNetworkType\":{\"values\":{\"FAKECHAIN\":3,\"MAINNET\":0,\"STAGENET\":2,\"TESTNET\":1}},\"MoneroTransactionAllInputsSetAck\":{\"fields\":{\"rsig_data\":{\"id\":1,\"type\":\"MoneroTransactionRsigData\"}}},\"MoneroTransactionAllInputsSetRequest\":{\"fields\":{}},\"MoneroTransactionAllOutSetAck\":{\"fields\":{\"extra\":{\"id\":1,\"type\":\"bytes\"},\"full_message_hash\":{\"id\":5,\"type\":\"bytes\"},\"rv\":{\"id\":4,\"type\":\"MoneroRingCtSig\"},\"tx_prefix_hash\":{\"id\":2,\"type\":\"bytes\"}},\"nested\":{\"MoneroRingCtSig\":{\"fields\":{\"message\":{\"id\":2,\"type\":\"bytes\"},\"rv_type\":{\"id\":3,\"type\":\"uint32\"},\"txn_fee\":{\"id\":1,\"type\":\"uint64\"}}}}},\"MoneroTransactionAllOutSetRequest\":{\"fields\":{\"rsig_data\":{\"id\":1,\"type\":\"MoneroTransactionRsigData\"}}},\"MoneroTransactionDestinationEntry\":{\"fields\":{\"addr\":{\"id\":2,\"type\":\"MoneroAccountPublicAddress\"},\"amount\":{\"id\":1,\"type\":\"uint64\"},\"is_integrated\":{\"id\":5,\"type\":\"bool\"},\"is_subaddress\":{\"id\":3,\"type\":\"bool\"},\"original\":{\"id\":4,\"type\":\"bytes\"}},\"nested\":{\"MoneroAccountPublicAddress\":{\"fields\":{\"spend_public_key\":{\"id\":1,\"type\":\"bytes\"},\"view_public_key\":{\"id\":2,\"type\":\"bytes\"}}}}},\"MoneroTransactionFinalAck\":{\"fields\":{\"cout_key\":{\"id\":1,\"type\":\"bytes\"},\"opening_key\":{\"id\":5,\"type\":\"bytes\"},\"rand_mult\":{\"id\":3,\"type\":\"bytes\"},\"salt\":{\"id\":2,\"type\":\"bytes\"},\"tx_enc_keys\":{\"id\":4,\"type\":\"bytes\"}}},\"MoneroTransactionFinalRequest\":{\"fields\":{}},\"MoneroTransactionInitAck\":{\"fields\":{\"hmacs\":{\"id\":1,\"rule\":\"repeated\",\"type\":\"bytes\"},\"rsig_data\":{\"id\":2,\"type\":\"MoneroTransactionRsigData\"}}},\"MoneroTransactionInitRequest\":{\"fields\":{\"address_n\":{\"id\":2,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"network_type\":{\"id\":3,\"options\":{\"default\":\"MAINNET\"},\"type\":\"MoneroNetworkType\"},\"tsx_data\":{\"id\":4,\"type\":\"MoneroTransactionData\"},\"version\":{\"id\":1,\"type\":\"uint32\"}},\"nested\":{\"MoneroTransactionData\":{\"fields\":{\"account\":{\"id\":9,\"type\":\"uint32\"},\"change_dts\":{\"id\":5,\"type\":\"MoneroTransactionDestinationEntry\"},\"client_version\":{\"id\":13,\"type\":\"uint32\"},\"fee\":{\"id\":8,\"type\":\"uint64\"},\"hard_fork\":{\"id\":14,\"type\":\"uint32\"},\"integrated_indices\":{\"id\":12,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"minor_indices\":{\"id\":10,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"mixin\":{\"id\":7,\"type\":\"uint32\"},\"monero_version\":{\"id\":15,\"type\":\"bytes\"},\"num_inputs\":{\"id\":6,\"type\":\"uint32\"},\"outputs\":{\"id\":4,\"rule\":\"repeated\",\"type\":\"MoneroTransactionDestinationEntry\"},\"payment_id\":{\"id\":2,\"type\":\"bytes\"},\"rsig_data\":{\"id\":11,\"type\":\"MoneroTransactionRsigData\"},\"unlock_time\":{\"id\":3,\"type\":\"uint64\"},\"version\":{\"id\":1,\"type\":\"uint32\"}}}}},\"MoneroTransactionInputViniAck\":{\"fields\":{}},\"MoneroTransactionInputViniRequest\":{\"fields\":{\"orig_idx\":{\"id\":6,\"type\":\"uint32\"},\"pseudo_out\":{\"id\":4,\"type\":\"bytes\"},\"pseudo_out_hmac\":{\"id\":5,\"type\":\"bytes\"},\"src_entr\":{\"id\":1,\"type\":\"MoneroTransactionSourceEntry\"},\"vini\":{\"id\":2,\"type\":\"bytes\"},\"vini_hmac\":{\"id\":3,\"type\":\"bytes\"}}},\"MoneroTransactionRsigData\":{\"fields\":{\"bp_version\":{\"id\":7,\"type\":\"uint32\"},\"grouping\":{\"id\":3,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint64\"},\"mask\":{\"id\":4,\"type\":\"bytes\"},\"offload_type\":{\"id\":2,\"type\":\"uint32\"},\"rsig\":{\"id\":5,\"type\":\"bytes\"},\"rsig_parts\":{\"id\":6,\"rule\":\"repeated\",\"type\":\"bytes\"},\"rsig_type\":{\"id\":1,\"type\":\"uint32\"}}},\"MoneroTransactionSetInputAck\":{\"fields\":{\"pseudo_out\":{\"id\":3,\"type\":\"bytes\"},\"pseudo_out_alpha\":{\"id\":5,\"type\":\"bytes\"},\"pseudo_out_hmac\":{\"id\":4,\"type\":\"bytes\"},\"spend_key\":{\"id\":6,\"type\":\"bytes\"},\"vini\":{\"id\":1,\"type\":\"bytes\"},\"vini_hmac\":{\"id\":2,\"type\":\"bytes\"}}},\"MoneroTransactionSetInputRequest\":{\"fields\":{\"src_entr\":{\"id\":1,\"type\":\"MoneroTransactionSourceEntry\"}}},\"MoneroTransactionSetOutputAck\":{\"fields\":{\"ecdh_info\":{\"id\":5,\"type\":\"bytes\"},\"out_pk\":{\"id\":4,\"type\":\"bytes\"},\"rsig_data\":{\"id\":3,\"type\":\"MoneroTransactionRsigData\"},\"tx_out\":{\"id\":1,\"type\":\"bytes\"},\"vouti_hmac\":{\"id\":2,\"type\":\"bytes\"}}},\"MoneroTransactionSetOutputRequest\":{\"fields\":{\"dst_entr\":{\"id\":1,\"type\":\"MoneroTransactionDestinationEntry\"},\"dst_entr_hmac\":{\"id\":2,\"type\":\"bytes\"},\"is_offloaded_bp\":{\"id\":4,\"type\":\"bool\"},\"rsig_data\":{\"id\":3,\"type\":\"MoneroTransactionRsigData\"}}},\"MoneroTransactionSignInputAck\":{\"fields\":{\"pseudo_out\":{\"id\":2,\"type\":\"bytes\"},\"signature\":{\"id\":1,\"type\":\"bytes\"}}},\"MoneroTransactionSignInputRequest\":{\"fields\":{\"orig_idx\":{\"id\":8,\"type\":\"uint32\"},\"pseudo_out\":{\"id\":4,\"type\":\"bytes\"},\"pseudo_out_alpha\":{\"id\":6,\"type\":\"bytes\"},\"pseudo_out_hmac\":{\"id\":5,\"type\":\"bytes\"},\"spend_key\":{\"id\":7,\"type\":\"bytes\"},\"src_entr\":{\"id\":1,\"type\":\"MoneroTransactionSourceEntry\"},\"vini\":{\"id\":2,\"type\":\"bytes\"},\"vini_hmac\":{\"id\":3,\"type\":\"bytes\"}}},\"MoneroTransactionSourceEntry\":{\"fields\":{\"amount\":{\"id\":6,\"type\":\"uint64\"},\"mask\":{\"id\":8,\"type\":\"bytes\"},\"multisig_kLRki\":{\"id\":9,\"type\":\"MoneroMultisigKLRki\"},\"outputs\":{\"id\":1,\"rule\":\"repeated\",\"type\":\"MoneroOutputEntry\"},\"rct\":{\"id\":7,\"type\":\"bool\"},\"real_out_additional_tx_keys\":{\"id\":4,\"rule\":\"repeated\",\"type\":\"bytes\"},\"real_out_tx_key\":{\"id\":3,\"type\":\"bytes\"},\"real_output\":{\"id\":2,\"type\":\"uint64\"},\"real_output_in_tx_index\":{\"id\":5,\"type\":\"uint64\"},\"subaddr_minor\":{\"id\":10,\"type\":\"uint32\"}},\"nested\":{\"MoneroMultisigKLRki\":{\"fields\":{\"K\":{\"id\":1,\"type\":\"bytes\"},\"L\":{\"id\":2,\"type\":\"bytes\"},\"R\":{\"id\":3,\"type\":\"bytes\"},\"ki\":{\"id\":4,\"type\":\"bytes\"}}},\"MoneroOutputEntry\":{\"fields\":{\"idx\":{\"id\":1,\"type\":\"uint64\"},\"key\":{\"id\":2,\"type\":\"MoneroRctKeyPublic\"}},\"nested\":{\"MoneroRctKeyPublic\":{\"fields\":{\"commitment\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"},\"dest\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}}}}}},\"MoneroWatchKey\":{\"fields\":{\"address\":{\"id\":2,\"type\":\"bytes\"},\"watch_key\":{\"id\":1,\"type\":\"bytes\"}}},\"MultisigRedeemScriptType\":{\"fields\":{\"address_n\":{\"id\":5,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"m\":{\"id\":3,\"rule\":\"required\",\"type\":\"uint32\"},\"nodes\":{\"id\":4,\"rule\":\"repeated\",\"type\":\"HDNodeType\"},\"pubkeys\":{\"id\":1,\"rule\":\"repeated\",\"type\":\"HDNodePathType\"},\"signatures\":{\"id\":2,\"rule\":\"repeated\",\"type\":\"bytes\"}},\"nested\":{\"HDNodePathType\":{\"fields\":{\"address_n\":{\"id\":2,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"node\":{\"id\":1,\"rule\":\"required\",\"type\":\"HDNodeType\"}}}}},\"NEMAddress\":{\"fields\":{\"address\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"}}},\"NEMDecryptMessage\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"network\":{\"id\":2,\"type\":\"uint32\"},\"payload\":{\"id\":4,\"type\":\"bytes\"},\"public_key\":{\"id\":3,\"type\":\"bytes\"}}},\"NEMDecryptedMessage\":{\"fields\":{\"payload\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"NEMGetAddress\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"network\":{\"id\":2,\"options\":{\"default\":104},\"type\":\"uint32\"},\"show_display\":{\"id\":3,\"type\":\"bool\"}}},\"NEMSignTx\":{\"fields\":{\"aggregate_modification\":{\"id\":8,\"type\":\"NEMAggregateModification\"},\"cosigning\":{\"id\":4,\"type\":\"bool\"},\"importance_transfer\":{\"id\":9,\"type\":\"NEMImportanceTransfer\"},\"mosaic_creation\":{\"id\":6,\"type\":\"NEMMosaicCreation\"},\"multisig\":{\"id\":2,\"type\":\"NEMTransactionCommon\"},\"provision_namespace\":{\"id\":5,\"type\":\"NEMProvisionNamespace\"},\"supply_change\":{\"id\":7,\"type\":\"NEMMosaicSupplyChange\"},\"transaction\":{\"id\":1,\"rule\":\"required\",\"type\":\"NEMTransactionCommon\"},\"transfer\":{\"id\":3,\"type\":\"NEMTransfer\"}},\"nested\":{\"NEMAggregateModification\":{\"fields\":{\"modifications\":{\"id\":1,\"rule\":\"repeated\",\"type\":\"NEMCosignatoryModification\"},\"relative_change\":{\"id\":2,\"type\":\"sint32\"}},\"nested\":{\"NEMCosignatoryModification\":{\"fields\":{\"public_key\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"},\"type\":{\"id\":1,\"rule\":\"required\",\"type\":\"NEMModificationType\"}},\"nested\":{\"NEMModificationType\":{\"values\":{\"CosignatoryModification_Add\":1,\"CosignatoryModification_Delete\":2}}}}}},\"NEMImportanceTransfer\":{\"fields\":{\"mode\":{\"id\":1,\"rule\":\"required\",\"type\":\"NEMImportanceTransferMode\"},\"public_key\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}},\"nested\":{\"NEMImportanceTransferMode\":{\"values\":{\"ImportanceTransfer_Activate\":1,\"ImportanceTransfer_Deactivate\":2}}}},\"NEMMosaicCreation\":{\"fields\":{\"definition\":{\"id\":1,\"rule\":\"required\",\"type\":\"NEMMosaicDefinition\"},\"fee\":{\"id\":3,\"rule\":\"required\",\"type\":\"uint64\"},\"sink\":{\"id\":2,\"rule\":\"required\",\"type\":\"string\"}},\"nested\":{\"NEMMosaicDefinition\":{\"fields\":{\"description\":{\"id\":14,\"rule\":\"required\",\"type\":\"string\"},\"divisibility\":{\"id\":5,\"type\":\"uint32\"},\"fee\":{\"id\":7,\"type\":\"uint64\"},\"levy\":{\"id\":6,\"type\":\"NEMMosaicLevy\"},\"levy_address\":{\"id\":8,\"type\":\"string\"},\"levy_mosaic\":{\"id\":10,\"type\":\"string\"},\"levy_namespace\":{\"id\":9,\"type\":\"string\"},\"mosaic\":{\"id\":4,\"rule\":\"required\",\"type\":\"string\"},\"mutable_supply\":{\"id\":12,\"type\":\"bool\"},\"name\":{\"id\":1,\"type\":\"string\"},\"namespace\":{\"id\":3,\"rule\":\"required\",\"type\":\"string\"},\"networks\":{\"id\":15,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"supply\":{\"id\":11,\"type\":\"uint64\"},\"ticker\":{\"id\":2,\"type\":\"string\"},\"transferable\":{\"id\":13,\"type\":\"bool\"}},\"nested\":{\"NEMMosaicLevy\":{\"values\":{\"MosaicLevy_Absolute\":1,\"MosaicLevy_Percentile\":2}}}}}},\"NEMMosaicSupplyChange\":{\"fields\":{\"delta\":{\"id\":4,\"rule\":\"required\",\"type\":\"uint64\"},\"mosaic\":{\"id\":2,\"rule\":\"required\",\"type\":\"string\"},\"namespace\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"},\"type\":{\"id\":3,\"rule\":\"required\",\"type\":\"NEMSupplyChangeType\"}},\"nested\":{\"NEMSupplyChangeType\":{\"values\":{\"SupplyChange_Decrease\":2,\"SupplyChange_Increase\":1}}}},\"NEMProvisionNamespace\":{\"fields\":{\"fee\":{\"id\":4,\"rule\":\"required\",\"type\":\"uint64\"},\"namespace\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"},\"parent\":{\"id\":2,\"type\":\"string\"},\"sink\":{\"id\":3,\"rule\":\"required\",\"type\":\"string\"}}},\"NEMTransactionCommon\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"deadline\":{\"id\":5,\"rule\":\"required\",\"type\":\"uint32\"},\"fee\":{\"id\":4,\"rule\":\"required\",\"type\":\"uint64\"},\"network\":{\"id\":2,\"options\":{\"default\":104},\"type\":\"uint32\"},\"signer\":{\"id\":6,\"type\":\"bytes\"},\"timestamp\":{\"id\":3,\"rule\":\"required\",\"type\":\"uint32\"}}},\"NEMTransfer\":{\"fields\":{\"amount\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint64\"},\"mosaics\":{\"id\":5,\"rule\":\"repeated\",\"type\":\"NEMMosaic\"},\"payload\":{\"id\":3,\"options\":{\"default\":\"\"},\"type\":\"bytes\"},\"public_key\":{\"id\":4,\"type\":\"bytes\"},\"recipient\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"}},\"nested\":{\"NEMMosaic\":{\"fields\":{\"mosaic\":{\"id\":2,\"rule\":\"required\",\"type\":\"string\"},\"namespace\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"},\"quantity\":{\"id\":3,\"rule\":\"required\",\"type\":\"uint64\"}}}}}}},\"NEMSignedTx\":{\"fields\":{\"data\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"},\"signature\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"NearAddress\":{\"fields\":{\"address\":{\"id\":1,\"type\":\"string\"}}},\"NearGetAddress\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"show_display\":{\"id\":2,\"type\":\"bool\"}}},\"NearSignTx\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"raw_tx\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"NearSignedTx\":{\"fields\":{\"signature\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"NeoAddress\":{\"fields\":{\"address\":{\"id\":1,\"type\":\"string\"},\"public_key\":{\"id\":2,\"type\":\"bytes\"}}},\"NeoGetAddress\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"show_display\":{\"id\":2,\"type\":\"bool\"}}},\"NeoSignTx\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"network_magic\":{\"id\":3,\"options\":{\"default\":860833102},\"type\":\"uint32\"},\"raw_tx\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"NeoSignedTx\":{\"fields\":{\"public_key\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"},\"signature\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"NervosAddress\":{\"fields\":{\"address\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"}}},\"NervosGetAddress\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"network\":{\"id\":2,\"rule\":\"required\",\"type\":\"string\"},\"show_display\":{\"id\":3,\"type\":\"bool\"}}},\"NervosSignTx\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"data_initial_chunk\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"},\"data_length\":{\"id\":5,\"type\":\"uint32\"},\"network\":{\"id\":4,\"rule\":\"required\",\"type\":\"string\"},\"witness_buffer\":{\"id\":3,\"rule\":\"required\",\"type\":\"bytes\"}}},\"NervosSignedTx\":{\"fields\":{\"address\":{\"id\":2,\"rule\":\"required\",\"type\":\"string\"},\"signature\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"NervosTxAck\":{\"fields\":{\"data_chunk\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"NervosTxRequest\":{\"fields\":{\"data_length\":{\"id\":1,\"type\":\"uint32\"},\"public_key\":{\"id\":2,\"type\":\"bytes\"},\"signature\":{\"id\":3,\"type\":\"bytes\"}}},\"NexaAddress\":{\"fields\":{\"address\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"},\"public_key\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"NexaGetAddress\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"prefix\":{\"id\":3,\"options\":{\"default\":\"nexa\"},\"type\":\"string\"},\"show_display\":{\"id\":2,\"type\":\"bool\"}}},\"NexaSignTx\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"input_count\":{\"id\":4,\"options\":{\"default\":1},\"type\":\"uint32\"},\"prefix\":{\"id\":3,\"options\":{\"default\":\"nexa\"},\"type\":\"string\"},\"raw_message\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"NexaSignedTx\":{\"fields\":{\"signature\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"NexaTxInputAck\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"raw_message\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"NexaTxInputRequest\":{\"fields\":{\"request_index\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint32\"},\"signature\":{\"id\":2,\"type\":\"bytes\"}}},\"NextU2FCounter\":{\"fields\":{\"u2f_counter\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint32\"}}},\"NftUpdate\":{\"fields\":{\"file_name_no_ext\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"}}},\"Nonce\":{\"fields\":{\"nonce\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}},\"options\":{\"(experimental_message)\":true}},\"NostrDecryptMessage\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"msg\":{\"id\":3,\"rule\":\"required\",\"type\":\"string\"},\"pubkey\":{\"id\":2,\"rule\":\"required\",\"type\":\"string\"},\"show_display\":{\"id\":4,\"type\":\"bool\"}}},\"NostrDecryptedMessage\":{\"fields\":{\"msg\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"}}},\"NostrEncryptMessage\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"msg\":{\"id\":3,\"rule\":\"required\",\"type\":\"string\"},\"pubkey\":{\"id\":2,\"rule\":\"required\",\"type\":\"string\"},\"show_display\":{\"id\":4,\"type\":\"bool\"}}},\"NostrEncryptedMessage\":{\"fields\":{\"msg\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"}}},\"NostrGetPublicKey\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"show_display\":{\"id\":2,\"type\":\"bool\"}}},\"NostrPublicKey\":{\"fields\":{\"npub\":{\"id\":2,\"type\":\"string\"},\"publickey\":{\"id\":1,\"type\":\"string\"}}},\"NostrSignEvent\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"event\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"NostrSignSchnorr\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"hash\":{\"id\":2,\"rule\":\"required\",\"type\":\"string\"}}},\"NostrSignedEvent\":{\"fields\":{\"event\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"NostrSignedSchnorr\":{\"fields\":{\"signature\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"OnboardingPhase\":{\"values\":{\"ONBOARDING_PHASE_FINGERPRINT_SETUP\":3,\"ONBOARDING_PHASE_PIN_SETUP\":2,\"ONBOARDING_PHASE_RECOVERY_PHRASE_CONFIRM\":7,\"ONBOARDING_PHASE_RECOVERY_PHRASE_RESTORE\":9,\"ONBOARDING_PHASE_RECOVERY_PHRASE_VIEW\":6,\"ONBOARDING_PHASE_RESTORE_METHOD_CHOICE\":8,\"ONBOARDING_PHASE_SAFETY_CHECK\":1,\"ONBOARDING_PHASE_SEEDCARD_BACKUP\":13,\"ONBOARDING_PHASE_SEEDCARD_BACKUP_PROMPT\":12,\"ONBOARDING_PHASE_SEEDCARD_RESTORE\":10,\"ONBOARDING_PHASE_SETUP_CHOICE\":4,\"ONBOARDING_PHASE_UNKNOWN\":0,\"ONBOARDING_PHASE_WALLET_CREATE_START\":5,\"ONBOARDING_PHASE_WALLET_READY\":11}},\"OnboardingSetupKind\":{\"values\":{\"ONBOARDING_SETUP_KIND_CHOICE\":1,\"ONBOARDING_SETUP_KIND_CREATE\":2,\"ONBOARDING_SETUP_KIND_RESTORE\":3,\"ONBOARDING_SETUP_KIND_UNKNOWN\":0}},\"OnboardingSetupMethod\":{\"values\":{\"ONBOARDING_SETUP_METHOD_RECOVERY_PHRASE\":1,\"ONBOARDING_SETUP_METHOD_SEEDCARD\":2,\"ONBOARDING_SETUP_METHOD_UNKNOWN\":0}},\"OnboardingSetupStatus\":{\"fields\":{\"kind\":{\"id\":1,\"type\":\"OnboardingSetupKind\"},\"method\":{\"id\":2,\"type\":\"OnboardingSetupMethod\"}}},\"OnboardingStatus\":{\"fields\":{\"phase\":{\"id\":2,\"type\":\"OnboardingPhase\"},\"pin_set\":{\"id\":4,\"type\":\"bool\"},\"setup\":{\"id\":3,\"type\":\"OnboardingSetupStatus\"},\"step\":{\"id\":1,\"type\":\"OnboardingStep\"},\"wallet_initialized\":{\"id\":5,\"type\":\"bool\"}}},\"OnboardingStatusGet\":{\"fields\":{}},\"OnboardingStep\":{\"values\":{\"ONBOARDING_STEP_CHECKING\":1,\"ONBOARDING_STEP_DONE\":5,\"ONBOARDING_STEP_PERSONALIZATION\":2,\"ONBOARDING_STEP_PIN\":3,\"ONBOARDING_STEP_SETUP\":4,\"ONBOARDING_STEP_UNKNOWN\":0}},\"OneKeyDeviceType\":{\"values\":{\"CLASSIC\":0,\"CLASSIC1S\":1,\"MINI\":2,\"PRO\":5,\"TOUCH\":3}},\"OneKeySEState\":{\"values\":{\"APP\":1,\"BOOT\":0}},\"OneKeySeType\":{\"values\":{\"SE608A\":1,\"THD89\":0}},\"OnekeyFeatures\":{\"fields\":{\"onekey_bootloader_build_id\":{\"id\":9,\"type\":\"string\"},\"onekey_bootloader_hash\":{\"id\":6,\"type\":\"bytes\"},\"onekey_bootloader_version\":{\"id\":3,\"type\":\"string\"},\"onekey_coprocessor_bt_name\":{\"id\":12,\"type\":\"string\"},\"onekey_coprocessor_build_id\":{\"id\":14,\"type\":\"string\"},\"onekey_coprocessor_hash\":{\"id\":15,\"type\":\"bytes\"},\"onekey_coprocessor_version\":{\"id\":13,\"type\":\"string\"},\"onekey_device_type\":{\"id\":1,\"type\":\"OneKeyDeviceType\"},\"onekey_firmware_build_id\":{\"id\":10,\"type\":\"string\"},\"onekey_firmware_hash\":{\"id\":7,\"type\":\"bytes\"},\"onekey_firmware_version\":{\"id\":4,\"type\":\"string\"},\"onekey_romloader_build_id\":{\"id\":8,\"type\":\"string\"},\"onekey_romloader_hash\":{\"id\":5,\"type\":\"bytes\"},\"onekey_romloader_version\":{\"id\":2,\"type\":\"string\"},\"onekey_se01_bootloader_build_id\":{\"id\":41,\"type\":\"string\"},\"onekey_se01_bootloader_hash\":{\"id\":37,\"type\":\"bytes\"},\"onekey_se01_bootloader_version\":{\"id\":33,\"type\":\"string\"},\"onekey_se01_build_id\":{\"id\":29,\"type\":\"string\"},\"onekey_se01_hash\":{\"id\":25,\"type\":\"bytes\"},\"onekey_se01_state\":{\"id\":17,\"type\":\"OneKeySEState\"},\"onekey_se01_version\":{\"id\":21,\"type\":\"string\"},\"onekey_se02_bootloader_build_id\":{\"id\":42,\"type\":\"string\"},\"onekey_se02_bootloader_hash\":{\"id\":38,\"type\":\"bytes\"},\"onekey_se02_bootloader_version\":{\"id\":34,\"type\":\"string\"},\"onekey_se02_build_id\":{\"id\":30,\"type\":\"string\"},\"onekey_se02_hash\":{\"id\":26,\"type\":\"bytes\"},\"onekey_se02_state\":{\"id\":18,\"type\":\"OneKeySEState\"},\"onekey_se02_version\":{\"id\":22,\"type\":\"string\"},\"onekey_se03_bootloader_build_id\":{\"id\":43,\"type\":\"string\"},\"onekey_se03_bootloader_hash\":{\"id\":39,\"type\":\"bytes\"},\"onekey_se03_bootloader_version\":{\"id\":35,\"type\":\"string\"},\"onekey_se03_build_id\":{\"id\":31,\"type\":\"string\"},\"onekey_se03_hash\":{\"id\":27,\"type\":\"bytes\"},\"onekey_se03_state\":{\"id\":19,\"type\":\"OneKeySEState\"},\"onekey_se03_version\":{\"id\":23,\"type\":\"string\"},\"onekey_se04_bootloader_build_id\":{\"id\":44,\"type\":\"string\"},\"onekey_se04_bootloader_hash\":{\"id\":40,\"type\":\"bytes\"},\"onekey_se04_bootloader_version\":{\"id\":36,\"type\":\"string\"},\"onekey_se04_build_id\":{\"id\":32,\"type\":\"string\"},\"onekey_se04_hash\":{\"id\":28,\"type\":\"bytes\"},\"onekey_se04_state\":{\"id\":20,\"type\":\"OneKeySEState\"},\"onekey_se04_version\":{\"id\":24,\"type\":\"string\"},\"onekey_se_type\":{\"id\":16,\"type\":\"OneKeySeType\"},\"onekey_serial_no\":{\"id\":11,\"type\":\"string\"}}},\"OnekeyGetFeatures\":{\"fields\":{}},\"OutputScriptType\":{\"values\":{\"PAYTOADDRESS\":0,\"PAYTOMULTISIG\":2,\"PAYTOOPRETURN\":3,\"PAYTOP2SHWITNESS\":5,\"PAYTOSCRIPTHASH\":1,\"PAYTOTAPROOT\":6,\"PAYTOWITNESS\":4}},\"OwnershipId\":{\"fields\":{\"ownership_id\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"OwnershipProof\":{\"fields\":{\"ownership_proof\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"},\"signature\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"PassphraseAck\":{\"fields\":{\"_state\":{\"id\":2,\"options\":{\"deprecated\":true},\"type\":\"bytes\"},\"on_device\":{\"id\":3,\"type\":\"bool\"},\"on_device_attach_pin\":{\"id\":8000,\"type\":\"bool\"},\"passphrase\":{\"id\":1,\"type\":\"string\"}}},\"PassphraseRequest\":{\"fields\":{\"_on_device\":{\"id\":1,\"options\":{\"deprecated\":true},\"type\":\"bool\"},\"exists_attach_pin_user\":{\"id\":8000,\"type\":\"bool\"}}},\"PassphraseState\":{\"fields\":{\"passphrase_state\":{\"id\":1,\"type\":\"string\"},\"session_id\":{\"id\":2,\"type\":\"bytes\"},\"unlocked_attach_pin\":{\"id\":3,\"type\":\"bool\"}}},\"Ping\":{\"fields\":{\"message\":{\"id\":1,\"options\":{\"default\":\"\"},\"type\":\"string\"}}},\"PolkadotAddress\":{\"fields\":{\"address\":{\"id\":1,\"type\":\"string\"},\"public_key\":{\"id\":2,\"type\":\"string\"}}},\"PolkadotGetAddress\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"network\":{\"id\":3,\"rule\":\"required\",\"type\":\"string\"},\"prefix\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint32\"},\"show_display\":{\"id\":4,\"type\":\"bool\"}}},\"PolkadotSignTx\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"network\":{\"id\":3,\"rule\":\"required\",\"type\":\"string\"},\"raw_tx\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"PolkadotSignedTx\":{\"fields\":{\"signature\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"PortfolioUpdate\":{\"fields\":{}},\"PreauthorizedRequest\":{\"fields\":{}},\"PrevInput\":{\"fields\":{\"decred_tree\":{\"id\":9,\"type\":\"uint32\"},\"prev_hash\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"},\"prev_index\":{\"id\":3,\"rule\":\"required\",\"type\":\"uint32\"},\"script_sig\":{\"id\":4,\"rule\":\"required\",\"type\":\"bytes\"},\"sequence\":{\"id\":5,\"rule\":\"required\",\"type\":\"uint32\"}}},\"PrevOutput\":{\"fields\":{\"amount\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint64\"},\"decred_script_version\":{\"id\":3,\"type\":\"uint32\"},\"script_pubkey\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"PrevTx\":{\"fields\":{\"branch_id\":{\"id\":14,\"type\":\"uint32\"},\"expiry\":{\"id\":10,\"type\":\"uint32\"},\"extra_data_len\":{\"id\":9,\"options\":{\"default\":0},\"type\":\"uint32\"},\"inputs_count\":{\"id\":6,\"rule\":\"required\",\"type\":\"uint32\"},\"lock_time\":{\"id\":4,\"rule\":\"required\",\"type\":\"uint32\"},\"outputs_count\":{\"id\":7,\"rule\":\"required\",\"type\":\"uint32\"},\"timestamp\":{\"id\":13,\"type\":\"uint32\"},\"version\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint32\"},\"version_group_id\":{\"id\":12,\"type\":\"uint32\"}}},\"ProtocolInfo\":{\"fields\":{\"build_fingerprint\":{\"id\":2,\"rule\":\"required\",\"type\":\"string\"},\"supported_messages\":{\"id\":3,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"version\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint32\"}}},\"ProtocolInfoRequest\":{\"fields\":{\"eventless_wallet_session\":{\"id\":1,\"options\":{\"default\":false},\"type\":\"bool\"}}},\"PublicKey\":{\"fields\":{\"node\":{\"id\":1,\"rule\":\"required\",\"type\":\"HDNodeType\"},\"root_fingerprint\":{\"id\":3,\"type\":\"uint32\"},\"xpub\":{\"id\":2,\"rule\":\"required\",\"type\":\"string\"}}},\"ReadSEPublicCert\":{\"fields\":{}},\"ReadSEPublicKey\":{\"fields\":{}},\"RecoveryDevice\":{\"fields\":{\"dry_run\":{\"id\":10,\"type\":\"bool\"},\"enforce_wordlist\":{\"id\":6,\"type\":\"bool\"},\"label\":{\"id\":5,\"type\":\"string\"},\"language\":{\"id\":4,\"type\":\"string\"},\"passphrase_protection\":{\"id\":2,\"type\":\"bool\"},\"pin_protection\":{\"id\":3,\"type\":\"bool\"},\"type\":{\"id\":8,\"type\":\"RecoveryDeviceType\"},\"u2f_counter\":{\"id\":9,\"type\":\"uint32\"},\"word_count\":{\"id\":1,\"type\":\"uint32\"}},\"nested\":{\"RecoveryDeviceType\":{\"values\":{\"RecoveryDeviceType_Matrix\":1,\"RecoveryDeviceType_ScrambledWords\":0}}}},\"ResetDevice\":{\"fields\":{\"backup_type\":{\"id\":10,\"options\":{\"default\":\"Bip39\"},\"type\":\"BackupType\"},\"display_random\":{\"id\":1,\"type\":\"bool\"},\"label\":{\"id\":6,\"type\":\"string\"},\"language\":{\"id\":5,\"options\":{\"default\":\"en-US\"},\"type\":\"string\"},\"no_backup\":{\"id\":9,\"type\":\"bool\"},\"passphrase_protection\":{\"id\":3,\"type\":\"bool\"},\"pin_protection\":{\"id\":4,\"type\":\"bool\"},\"skip_backup\":{\"id\":8,\"type\":\"bool\"},\"strength\":{\"id\":2,\"options\":{\"default\":256},\"type\":\"uint32\"},\"u2f_counter\":{\"id\":7,\"type\":\"uint32\"}}},\"ResourceAck\":{\"fields\":{\"data_chunk\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"},\"hash\":{\"id\":2,\"type\":\"bytes\"}}},\"ResourceRequest\":{\"fields\":{\"data_length\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint32\"},\"offset\":{\"id\":1,\"type\":\"uint32\"}}},\"ResourceUpdate\":{\"fields\":{\"data_length\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint32\"},\"file_name\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"},\"hash\":{\"id\":4,\"type\":\"bytes\"},\"initial_data_chunk\":{\"id\":3,\"rule\":\"required\",\"type\":\"bytes\"}}},\"ResourceUpload\":{\"fields\":{\"blur_data_length\":{\"id\":7,\"type\":\"uint32\"},\"data_length\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint32\"},\"extension\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"},\"file_name_no_ext\":{\"id\":6,\"type\":\"string\"},\"nft_meta_data\":{\"id\":4,\"type\":\"bytes\"},\"res_type\":{\"id\":3,\"rule\":\"required\",\"type\":\"ResourceType\"},\"zoom_data_length\":{\"id\":5,\"rule\":\"required\",\"type\":\"uint32\"}},\"nested\":{\"ResourceType\":{\"values\":{\"Nft\":1,\"WallPaper\":0}}}},\"RippleAddress\":{\"fields\":{\"address\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"}}},\"RippleGetAddress\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"show_display\":{\"id\":2,\"type\":\"bool\"}}},\"RippleSignTx\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"fee\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint64\"},\"flags\":{\"id\":3,\"options\":{\"default\":0},\"type\":\"uint32\"},\"last_ledger_sequence\":{\"id\":5,\"type\":\"uint32\"},\"payment\":{\"id\":6,\"rule\":\"required\",\"type\":\"RipplePayment\"},\"sequence\":{\"id\":4,\"rule\":\"required\",\"type\":\"uint32\"}},\"nested\":{\"RipplePayment\":{\"fields\":{\"amount\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint64\"},\"destination\":{\"id\":2,\"rule\":\"required\",\"type\":\"string\"},\"destination_tag\":{\"id\":3,\"type\":\"uint32\"}}}}},\"RippleSignedTx\":{\"fields\":{\"serialized_tx\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"},\"signature\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"SEMessageSignature\":{\"fields\":{\"signature\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"SEPublicCert\":{\"fields\":{\"public_cert\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"SEPublicKey\":{\"fields\":{\"public_key\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"SESignMessage\":{\"fields\":{\"message\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"SafetyCheckLevel\":{\"values\":{\"PromptAlways\":1,\"PromptTemporarily\":2,\"Strict\":0}},\"SdProtect\":{\"fields\":{\"operation\":{\"id\":1,\"rule\":\"required\",\"type\":\"SdProtectOperationType\"}},\"nested\":{\"SdProtectOperationType\":{\"values\":{\"DISABLE\":0,\"ENABLE\":1,\"REFRESH\":2}}}},\"SetBusy\":{\"fields\":{\"expiry_ms\":{\"id\":1,\"type\":\"uint32\"}}},\"SetU2FCounter\":{\"fields\":{\"u2f_counter\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint32\"}}},\"SignIdentity\":{\"fields\":{\"challenge_hidden\":{\"id\":2,\"options\":{\"default\":\"\"},\"type\":\"bytes\"},\"challenge_visual\":{\"id\":3,\"options\":{\"default\":\"\"},\"type\":\"string\"},\"ecdsa_curve_name\":{\"id\":4,\"type\":\"string\"},\"identity\":{\"id\":1,\"rule\":\"required\",\"type\":\"IdentityType\"}}},\"SignMessage\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"coin_name\":{\"id\":3,\"options\":{\"default\":\"Bitcoin\"},\"type\":\"string\"},\"is_bip322_simple\":{\"id\":10,\"options\":{\"default\":false},\"type\":\"bool\"},\"message\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"},\"no_script_type\":{\"id\":5,\"type\":\"bool\"},\"script_type\":{\"id\":4,\"options\":{\"default\":\"SPENDADDRESS\"},\"type\":\"InputScriptType\"}}},\"SignPsbt\":{\"fields\":{\"coin_name\":{\"id\":2,\"options\":{\"default\":\"Bitcoin\"},\"type\":\"string\"},\"psbt\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"SignTx\":{\"fields\":{\"amount_unit\":{\"id\":11,\"options\":{\"default\":\"BITCOIN\"},\"type\":\"AmountUnit\"},\"branch_id\":{\"id\":10,\"type\":\"uint32\"},\"coin_name\":{\"id\":3,\"options\":{\"default\":\"Bitcoin\"},\"type\":\"string\"},\"coinjoin_request\":{\"id\":14,\"type\":\"CoinJoinRequest\"},\"decred_staking_ticket\":{\"id\":12,\"options\":{\"default\":false},\"type\":\"bool\"},\"expiry\":{\"id\":6,\"type\":\"uint32\"},\"inputs_count\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint32\"},\"lock_time\":{\"id\":5,\"options\":{\"default\":0},\"type\":\"uint32\"},\"outputs_count\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint32\"},\"overwintered\":{\"id\":7,\"options\":{\"deprecated\":true},\"type\":\"bool\"},\"serialize\":{\"id\":13,\"options\":{\"default\":true},\"type\":\"bool\"},\"timestamp\":{\"id\":9,\"type\":\"uint32\"},\"version\":{\"id\":4,\"options\":{\"default\":1},\"type\":\"uint32\"},\"version_group_id\":{\"id\":8,\"type\":\"uint32\"}},\"nested\":{\"CoinJoinRequest\":{\"fields\":{\"fee_rate\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint32\"},\"mask_public_key\":{\"id\":4,\"rule\":\"required\",\"type\":\"bytes\"},\"min_registrable_amount\":{\"id\":3,\"rule\":\"required\",\"type\":\"uint64\"},\"no_fee_threshold\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint64\"},\"signature\":{\"id\":5,\"rule\":\"required\",\"type\":\"bytes\"}}}}},\"SignedIdentity\":{\"fields\":{\"address\":{\"id\":1,\"type\":\"string\"},\"public_key\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"},\"signature\":{\"id\":3,\"rule\":\"required\",\"type\":\"bytes\"}}},\"SignedPsbt\":{\"fields\":{\"psbt\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"SolanaAddress\":{\"fields\":{\"address\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"}}},\"SolanaGetAddress\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"show_display\":{\"id\":2,\"type\":\"bool\"}}},\"SolanaMessageSignature\":{\"fields\":{\"public_key\":{\"id\":2,\"type\":\"bytes\"},\"signature\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"SolanaOffChainMessageFormat\":{\"values\":{\"V0_LIMITED_UTF8\":1,\"V0_RESTRICTED_ASCII\":0}},\"SolanaOffChainMessageVersion\":{\"values\":{\"MESSAGE_VERSION_0\":0,\"MESSAGE_VERSION_1\":1}},\"SolanaSignOffChainMessage\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"application_domain\":{\"id\":5,\"type\":\"bytes\"},\"message\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"},\"message_format\":{\"id\":4,\"type\":\"SolanaOffChainMessageFormat\"},\"message_version\":{\"id\":3,\"options\":{\"default\":\"MESSAGE_VERSION_0\"},\"type\":\"SolanaOffChainMessageVersion\"},\"required_signers\":{\"id\":6,\"rule\":\"repeated\",\"type\":\"bytes\"}}},\"SolanaSignTx\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"raw_tx\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"SolanaSignUnsafeMessage\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"message\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"SolanaSignedTx\":{\"fields\":{\"signature\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"StarcoinAddress\":{\"fields\":{\"address\":{\"id\":1,\"type\":\"string\"}}},\"StarcoinGetAddress\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"show_display\":{\"id\":2,\"type\":\"bool\"}}},\"StarcoinGetPublicKey\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"show_display\":{\"id\":2,\"type\":\"bool\"}}},\"StarcoinMessageSignature\":{\"fields\":{\"public_key\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"},\"signature\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"StarcoinPublicKey\":{\"fields\":{\"public_key\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"StarcoinSignMessage\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"message\":{\"id\":2,\"type\":\"bytes\"}}},\"StarcoinSignTx\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"raw_tx\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"StarcoinSignedTx\":{\"fields\":{\"public_key\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"},\"signature\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"StarcoinVerifyMessage\":{\"fields\":{\"message\":{\"id\":3,\"type\":\"bytes\"},\"public_key\":{\"id\":1,\"type\":\"bytes\"},\"signature\":{\"id\":2,\"type\":\"bytes\"}}},\"StellarAccountMergeOp\":{\"fields\":{\"destination_account\":{\"id\":2,\"rule\":\"required\",\"type\":\"string\"},\"source_account\":{\"id\":1,\"type\":\"string\"}}},\"StellarAddress\":{\"fields\":{\"address\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"}}},\"StellarAllowTrustOp\":{\"fields\":{\"asset_code\":{\"id\":4,\"type\":\"string\"},\"asset_type\":{\"id\":3,\"rule\":\"required\",\"type\":\"StellarAssetType\"},\"is_authorized\":{\"id\":5,\"rule\":\"required\",\"type\":\"bool\"},\"source_account\":{\"id\":1,\"type\":\"string\"},\"trusted_account\":{\"id\":2,\"rule\":\"required\",\"type\":\"string\"}}},\"StellarAsset\":{\"fields\":{\"code\":{\"id\":2,\"type\":\"string\"},\"issuer\":{\"id\":3,\"type\":\"string\"},\"type\":{\"id\":1,\"rule\":\"required\",\"type\":\"StellarAssetType\"}}},\"StellarAssetType\":{\"values\":{\"ALPHANUM12\":2,\"ALPHANUM4\":1,\"NATIVE\":0}},\"StellarBumpSequenceOp\":{\"fields\":{\"bump_to\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint64\"},\"source_account\":{\"id\":1,\"type\":\"string\"}}},\"StellarChangeTrustOp\":{\"fields\":{\"asset\":{\"id\":2,\"rule\":\"required\",\"type\":\"StellarAsset\"},\"limit\":{\"id\":3,\"rule\":\"required\",\"type\":\"uint64\"},\"source_account\":{\"id\":1,\"type\":\"string\"}}},\"StellarCreateAccountOp\":{\"fields\":{\"new_account\":{\"id\":2,\"rule\":\"required\",\"type\":\"string\"},\"source_account\":{\"id\":1,\"type\":\"string\"},\"starting_balance\":{\"id\":3,\"rule\":\"required\",\"type\":\"sint64\"}}},\"StellarCreatePassiveSellOfferOp\":{\"fields\":{\"amount\":{\"id\":4,\"rule\":\"required\",\"type\":\"sint64\"},\"buying_asset\":{\"id\":3,\"rule\":\"required\",\"type\":\"StellarAsset\"},\"price_d\":{\"id\":6,\"rule\":\"required\",\"type\":\"uint32\"},\"price_n\":{\"id\":5,\"rule\":\"required\",\"type\":\"uint32\"},\"selling_asset\":{\"id\":2,\"rule\":\"required\",\"type\":\"StellarAsset\"},\"source_account\":{\"id\":1,\"type\":\"string\"}}},\"StellarGetAddress\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"show_display\":{\"id\":2,\"type\":\"bool\"}}},\"StellarManageBuyOfferOp\":{\"fields\":{\"amount\":{\"id\":4,\"rule\":\"required\",\"type\":\"sint64\"},\"buying_asset\":{\"id\":3,\"rule\":\"required\",\"type\":\"StellarAsset\"},\"offer_id\":{\"id\":7,\"rule\":\"required\",\"type\":\"uint64\"},\"price_d\":{\"id\":6,\"rule\":\"required\",\"type\":\"uint32\"},\"price_n\":{\"id\":5,\"rule\":\"required\",\"type\":\"uint32\"},\"selling_asset\":{\"id\":2,\"rule\":\"required\",\"type\":\"StellarAsset\"},\"source_account\":{\"id\":1,\"type\":\"string\"}}},\"StellarManageDataOp\":{\"fields\":{\"key\":{\"id\":2,\"rule\":\"required\",\"type\":\"string\"},\"source_account\":{\"id\":1,\"type\":\"string\"},\"value\":{\"id\":3,\"type\":\"bytes\"}}},\"StellarManageSellOfferOp\":{\"fields\":{\"amount\":{\"id\":4,\"rule\":\"required\",\"type\":\"sint64\"},\"buying_asset\":{\"id\":3,\"rule\":\"required\",\"type\":\"StellarAsset\"},\"offer_id\":{\"id\":7,\"rule\":\"required\",\"type\":\"uint64\"},\"price_d\":{\"id\":6,\"rule\":\"required\",\"type\":\"uint32\"},\"price_n\":{\"id\":5,\"rule\":\"required\",\"type\":\"uint32\"},\"selling_asset\":{\"id\":2,\"rule\":\"required\",\"type\":\"StellarAsset\"},\"source_account\":{\"id\":1,\"type\":\"string\"}}},\"StellarPathPaymentStrictReceiveOp\":{\"fields\":{\"destination_account\":{\"id\":4,\"rule\":\"required\",\"type\":\"string\"},\"destination_amount\":{\"id\":6,\"rule\":\"required\",\"type\":\"sint64\"},\"destination_asset\":{\"id\":5,\"rule\":\"required\",\"type\":\"StellarAsset\"},\"paths\":{\"id\":7,\"rule\":\"repeated\",\"type\":\"StellarAsset\"},\"send_asset\":{\"id\":2,\"rule\":\"required\",\"type\":\"StellarAsset\"},\"send_max\":{\"id\":3,\"rule\":\"required\",\"type\":\"sint64\"},\"source_account\":{\"id\":1,\"type\":\"string\"}}},\"StellarPathPaymentStrictSendOp\":{\"fields\":{\"destination_account\":{\"id\":4,\"rule\":\"required\",\"type\":\"string\"},\"destination_asset\":{\"id\":5,\"rule\":\"required\",\"type\":\"StellarAsset\"},\"destination_min\":{\"id\":6,\"rule\":\"required\",\"type\":\"sint64\"},\"paths\":{\"id\":7,\"rule\":\"repeated\",\"type\":\"StellarAsset\"},\"send_amount\":{\"id\":3,\"rule\":\"required\",\"type\":\"sint64\"},\"send_asset\":{\"id\":2,\"rule\":\"required\",\"type\":\"StellarAsset\"},\"source_account\":{\"id\":1,\"type\":\"string\"}}},\"StellarPaymentOp\":{\"fields\":{\"amount\":{\"id\":4,\"rule\":\"required\",\"type\":\"sint64\"},\"asset\":{\"id\":3,\"rule\":\"required\",\"type\":\"StellarAsset\"},\"destination_account\":{\"id\":2,\"rule\":\"required\",\"type\":\"string\"},\"source_account\":{\"id\":1,\"type\":\"string\"}}},\"StellarSetOptionsOp\":{\"fields\":{\"clear_flags\":{\"id\":3,\"type\":\"uint32\"},\"high_threshold\":{\"id\":8,\"type\":\"uint32\"},\"home_domain\":{\"id\":9,\"type\":\"string\"},\"inflation_destination_account\":{\"id\":2,\"type\":\"string\"},\"low_threshold\":{\"id\":6,\"type\":\"uint32\"},\"master_weight\":{\"id\":5,\"type\":\"uint32\"},\"medium_threshold\":{\"id\":7,\"type\":\"uint32\"},\"set_flags\":{\"id\":4,\"type\":\"uint32\"},\"signer_key\":{\"id\":11,\"type\":\"bytes\"},\"signer_type\":{\"id\":10,\"type\":\"StellarSignerType\"},\"signer_weight\":{\"id\":12,\"type\":\"uint32\"},\"source_account\":{\"id\":1,\"type\":\"string\"}},\"nested\":{\"StellarSignerType\":{\"values\":{\"ACCOUNT\":0,\"HASH\":2,\"PRE_AUTH\":1}}}},\"StellarSignTx\":{\"fields\":{\"address_n\":{\"id\":2,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"fee\":{\"id\":5,\"rule\":\"required\",\"type\":\"uint32\"},\"memo_hash\":{\"id\":13,\"type\":\"bytes\"},\"memo_id\":{\"id\":12,\"type\":\"uint64\"},\"memo_text\":{\"id\":11,\"type\":\"string\"},\"memo_type\":{\"id\":10,\"rule\":\"required\",\"type\":\"StellarMemoType\"},\"network_passphrase\":{\"id\":3,\"rule\":\"required\",\"type\":\"string\"},\"num_operations\":{\"id\":14,\"rule\":\"required\",\"type\":\"uint32\"},\"sequence_number\":{\"id\":6,\"rule\":\"required\",\"type\":\"uint64\"},\"source_account\":{\"id\":4,\"rule\":\"required\",\"type\":\"string\"},\"timebounds_end\":{\"id\":9,\"rule\":\"required\",\"type\":\"uint32\"},\"timebounds_start\":{\"id\":8,\"rule\":\"required\",\"type\":\"uint32\"}},\"nested\":{\"StellarMemoType\":{\"values\":{\"HASH\":3,\"ID\":2,\"NONE\":0,\"RETURN\":4,\"TEXT\":1}}}},\"StellarSignedTx\":{\"fields\":{\"public_key\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"},\"signature\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"StellarTxOpRequest\":{\"fields\":{}},\"Success\":{\"fields\":{\"message\":{\"id\":1,\"options\":{\"default\":\"\"},\"type\":\"string\"}}},\"SuiAddress\":{\"fields\":{\"address\":{\"id\":1,\"type\":\"string\"}}},\"SuiGetAddress\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"show_display\":{\"id\":2,\"type\":\"bool\"}}},\"SuiMessageSignature\":{\"fields\":{\"address\":{\"id\":2,\"rule\":\"required\",\"type\":\"string\"},\"signature\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"SuiSignMessage\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"message\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"SuiSignTx\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"data_initial_chunk\":{\"id\":3,\"options\":{\"default\":\"\"},\"type\":\"bytes\"},\"data_length\":{\"id\":4,\"type\":\"uint32\"},\"raw_tx\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"SuiSignedTx\":{\"fields\":{\"public_key\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"},\"signature\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"SuiTxAck\":{\"fields\":{\"data_chunk\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"SuiTxRequest\":{\"fields\":{\"data_length\":{\"id\":1,\"type\":\"uint32\"},\"public_key\":{\"id\":2,\"type\":\"bytes\"},\"signature\":{\"id\":3,\"type\":\"bytes\"}}},\"TezosAddress\":{\"fields\":{\"address\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"}}},\"TezosGetAddress\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"show_display\":{\"id\":2,\"type\":\"bool\"}}},\"TezosGetPublicKey\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"show_display\":{\"id\":2,\"type\":\"bool\"}}},\"TezosPublicKey\":{\"fields\":{\"public_key\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"}}},\"TezosSignTx\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"ballot\":{\"id\":8,\"type\":\"TezosBallotOp\"},\"branch\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"},\"delegation\":{\"id\":6,\"type\":\"TezosDelegationOp\"},\"origination\":{\"id\":5,\"type\":\"TezosOriginationOp\"},\"proposal\":{\"id\":7,\"type\":\"TezosProposalOp\"},\"reveal\":{\"id\":3,\"type\":\"TezosRevealOp\"},\"transaction\":{\"id\":4,\"type\":\"TezosTransactionOp\"}},\"nested\":{\"TezosBallotOp\":{\"fields\":{\"ballot\":{\"id\":4,\"rule\":\"required\",\"type\":\"TezosBallotType\"},\"period\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint64\"},\"proposal\":{\"id\":3,\"rule\":\"required\",\"type\":\"bytes\"},\"source\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}},\"nested\":{\"TezosBallotType\":{\"values\":{\"Nay\":1,\"Pass\":2,\"Yay\":0}}}},\"TezosContractID\":{\"fields\":{\"hash\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"},\"tag\":{\"id\":1,\"rule\":\"required\",\"type\":\"TezosContractType\"}},\"nested\":{\"TezosContractType\":{\"values\":{\"Implicit\":0,\"Originated\":1}}}},\"TezosDelegationOp\":{\"fields\":{\"counter\":{\"id\":3,\"rule\":\"required\",\"type\":\"uint64\"},\"delegate\":{\"id\":6,\"rule\":\"required\",\"type\":\"bytes\"},\"fee\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint64\"},\"gas_limit\":{\"id\":4,\"rule\":\"required\",\"type\":\"uint64\"},\"source\":{\"id\":7,\"rule\":\"required\",\"type\":\"bytes\"},\"storage_limit\":{\"id\":5,\"rule\":\"required\",\"type\":\"uint64\"}}},\"TezosOriginationOp\":{\"fields\":{\"balance\":{\"id\":7,\"rule\":\"required\",\"type\":\"uint64\"},\"counter\":{\"id\":3,\"rule\":\"required\",\"type\":\"uint64\"},\"delegatable\":{\"id\":9,\"type\":\"bool\"},\"delegate\":{\"id\":10,\"type\":\"bytes\"},\"fee\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint64\"},\"gas_limit\":{\"id\":4,\"rule\":\"required\",\"type\":\"uint64\"},\"manager_pubkey\":{\"id\":6,\"type\":\"bytes\"},\"script\":{\"id\":11,\"rule\":\"required\",\"type\":\"bytes\"},\"source\":{\"id\":12,\"rule\":\"required\",\"type\":\"bytes\"},\"spendable\":{\"id\":8,\"type\":\"bool\"},\"storage_limit\":{\"id\":5,\"rule\":\"required\",\"type\":\"uint64\"}}},\"TezosProposalOp\":{\"fields\":{\"period\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint64\"},\"proposals\":{\"id\":4,\"rule\":\"repeated\",\"type\":\"bytes\"},\"source\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"TezosRevealOp\":{\"fields\":{\"counter\":{\"id\":3,\"rule\":\"required\",\"type\":\"uint64\"},\"fee\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint64\"},\"gas_limit\":{\"id\":4,\"rule\":\"required\",\"type\":\"uint64\"},\"public_key\":{\"id\":6,\"rule\":\"required\",\"type\":\"bytes\"},\"source\":{\"id\":7,\"rule\":\"required\",\"type\":\"bytes\"},\"storage_limit\":{\"id\":5,\"rule\":\"required\",\"type\":\"uint64\"}}},\"TezosTransactionOp\":{\"fields\":{\"amount\":{\"id\":6,\"rule\":\"required\",\"type\":\"uint64\"},\"counter\":{\"id\":3,\"rule\":\"required\",\"type\":\"uint64\"},\"destination\":{\"id\":7,\"rule\":\"required\",\"type\":\"TezosContractID\"},\"fee\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint64\"},\"gas_limit\":{\"id\":4,\"rule\":\"required\",\"type\":\"uint64\"},\"parameters\":{\"id\":8,\"type\":\"bytes\"},\"parameters_manager\":{\"id\":10,\"type\":\"TezosParametersManager\"},\"source\":{\"id\":9,\"rule\":\"required\",\"type\":\"bytes\"},\"storage_limit\":{\"id\":5,\"rule\":\"required\",\"type\":\"uint64\"}},\"nested\":{\"TezosParametersManager\":{\"fields\":{\"cancel_delegate\":{\"id\":2,\"type\":\"bool\"},\"set_delegate\":{\"id\":1,\"type\":\"bytes\"},\"transfer\":{\"id\":3,\"type\":\"TezosManagerTransfer\"}},\"nested\":{\"TezosManagerTransfer\":{\"fields\":{\"amount\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint64\"},\"destination\":{\"id\":1,\"rule\":\"required\",\"type\":\"TezosContractID\"}}}}}}}}},\"TezosSignedTx\":{\"fields\":{\"operation_hash\":{\"id\":3,\"rule\":\"required\",\"type\":\"string\"},\"sig_op_contents\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"},\"signature\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"}}},\"TonAddress\":{\"fields\":{\"address\":{\"id\":2,\"rule\":\"required\",\"type\":\"string\"},\"public_key\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"TonGetAddress\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"is_bounceable\":{\"id\":4,\"options\":{\"default\":false},\"type\":\"bool\"},\"is_testnet_only\":{\"id\":5,\"options\":{\"default\":false},\"type\":\"bool\"},\"show_display\":{\"id\":2,\"type\":\"bool\"},\"wallet_id\":{\"id\":7,\"options\":{\"default\":698983191},\"type\":\"uint32\"},\"wallet_version\":{\"id\":3,\"options\":{\"default\":\"V4R2\"},\"type\":\"TonWalletVersion\"},\"workchain\":{\"id\":6,\"options\":{\"default\":\"BASECHAIN\"},\"type\":\"TonWorkChain\"}}},\"TonSignMessage\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"comment\":{\"id\":8,\"type\":\"string\"},\"destination\":{\"id\":2,\"rule\":\"required\",\"type\":\"string\"},\"expire_at\":{\"id\":12,\"rule\":\"required\",\"type\":\"uint64\"},\"ext_destination\":{\"id\":18,\"rule\":\"repeated\",\"type\":\"string\"},\"ext_payload\":{\"id\":20,\"rule\":\"repeated\",\"type\":\"string\"},\"ext_ton_amount\":{\"id\":19,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint64\"},\"fwd_fee\":{\"id\":7,\"options\":{\"default\":0},\"type\":\"uint64\"},\"init_data_initial_chunk\":{\"id\":22,\"type\":\"bytes\"},\"init_data_length\":{\"id\":23,\"type\":\"uint32\"},\"is_bounceable\":{\"id\":16,\"options\":{\"default\":false},\"type\":\"bool\"},\"is_raw_data\":{\"id\":9,\"options\":{\"default\":false},\"type\":\"bool\"},\"is_testnet_only\":{\"id\":17,\"options\":{\"default\":false},\"type\":\"bool\"},\"jetton_amount\":{\"id\":6,\"type\":\"uint64\"},\"jetton_amount_bytes\":{\"id\":21,\"type\":\"bytes\"},\"jetton_master_address\":{\"id\":3,\"type\":\"string\"},\"jetton_wallet_address\":{\"id\":4,\"type\":\"string\"},\"mode\":{\"id\":10,\"options\":{\"default\":3},\"type\":\"uint32\"},\"seqno\":{\"id\":11,\"rule\":\"required\",\"type\":\"uint32\"},\"signing_message_repr\":{\"id\":24,\"type\":\"bytes\"},\"ton_amount\":{\"id\":5,\"rule\":\"required\",\"type\":\"uint64\"},\"wallet_id\":{\"id\":14,\"options\":{\"default\":698983191},\"type\":\"uint32\"},\"wallet_version\":{\"id\":13,\"options\":{\"default\":\"V4R2\"},\"type\":\"TonWalletVersion\"},\"workchain\":{\"id\":15,\"options\":{\"default\":\"BASECHAIN\"},\"type\":\"TonWorkChain\"}}},\"TonSignProof\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"appdomain\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"},\"comment\":{\"id\":3,\"type\":\"bytes\"},\"expire_at\":{\"id\":4,\"rule\":\"required\",\"type\":\"uint64\"},\"is_bounceable\":{\"id\":8,\"options\":{\"default\":false},\"type\":\"bool\"},\"is_testnet_only\":{\"id\":9,\"options\":{\"default\":false},\"type\":\"bool\"},\"wallet_id\":{\"id\":6,\"options\":{\"default\":698983191},\"type\":\"uint32\"},\"wallet_version\":{\"id\":5,\"options\":{\"default\":\"V4R2\"},\"type\":\"TonWalletVersion\"},\"workchain\":{\"id\":7,\"options\":{\"default\":\"BASECHAIN\"},\"type\":\"TonWorkChain\"}}},\"TonSignedMessage\":{\"fields\":{\"init_data_length\":{\"id\":3,\"type\":\"uint32\"},\"signature\":{\"id\":1,\"type\":\"bytes\"},\"signing_message\":{\"id\":2,\"type\":\"bytes\"}}},\"TonSignedProof\":{\"fields\":{\"signature\":{\"id\":1,\"type\":\"bytes\"}}},\"TonTxAck\":{\"fields\":{\"init_data_chunk\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"TonWalletVersion\":{\"values\":{\"V4R2\":3}},\"TonWorkChain\":{\"values\":{\"BASECHAIN\":0,\"MASTERCHAIN\":1}},\"TronAddress\":{\"fields\":{\"address\":{\"id\":1,\"type\":\"string\"}}},\"TronGetAddress\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"show_display\":{\"id\":2,\"type\":\"bool\"}}},\"TronMessageSignature\":{\"fields\":{\"address\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"},\"signature\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"TronMessageType\":{\"values\":{\"V1\":1,\"V2\":2}},\"TronSignMessage\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"message\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"},\"message_type\":{\"id\":3,\"options\":{\"default\":\"V1\"},\"type\":\"TronMessageType\"}}},\"TronSignTx\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"contract\":{\"id\":6,\"rule\":\"required\",\"type\":\"TronContract\"},\"data\":{\"id\":5,\"type\":\"bytes\"},\"expiration\":{\"id\":4,\"rule\":\"required\",\"type\":\"uint64\"},\"fee_limit\":{\"id\":8,\"type\":\"uint64\"},\"ref_block_bytes\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"},\"ref_block_hash\":{\"id\":3,\"rule\":\"required\",\"type\":\"bytes\"},\"timestamp\":{\"id\":7,\"rule\":\"required\",\"type\":\"uint64\"}},\"nested\":{\"TronContract\":{\"fields\":{\"cancel_all_unfreeze_v2_contract\":{\"id\":59,\"type\":\"TronCancelAllUnfreezeV2Contract\"},\"contract_name\":{\"id\":5,\"type\":\"bytes\"},\"delegate_resource_contract\":{\"id\":57,\"type\":\"TronDelegateResourceContract\"},\"freeze_balance_contract\":{\"id\":11,\"type\":\"TronFreezeBalanceContract\"},\"freeze_balance_v2_contract\":{\"id\":54,\"type\":\"TronFreezeBalanceV2Contract\"},\"permission_id\":{\"id\":6,\"type\":\"uint32\"},\"provider\":{\"id\":3,\"type\":\"bytes\"},\"transfer_contract\":{\"id\":2,\"type\":\"TronTransferContract\"},\"trigger_smart_contract\":{\"id\":31,\"type\":\"TronTriggerSmartContract\"},\"undelegate_resource_contract\":{\"id\":58,\"type\":\"TronUnDelegateResourceContract\"},\"unfreeze_balance_contract\":{\"id\":12,\"type\":\"TronUnfreezeBalanceContract\"},\"unfreeze_balance_v2_contract\":{\"id\":55,\"type\":\"TronUnfreezeBalanceV2Contract\"},\"vote_witness_contract\":{\"id\":4,\"type\":\"TronVoteWitnessContract\"},\"withdraw_balance_contract\":{\"id\":13,\"type\":\"TronWithdrawBalanceContract\"},\"withdraw_expire_unfreeze_contract\":{\"id\":56,\"type\":\"TronWithdrawExpireUnfreezeContract\"}},\"nested\":{\"TronCancelAllUnfreezeV2Contract\":{\"fields\":{}},\"TronDelegateResourceContract\":{\"fields\":{\"balance\":{\"id\":3,\"type\":\"uint64\"},\"lock\":{\"id\":5,\"type\":\"bool\"},\"lock_period\":{\"id\":6,\"type\":\"uint64\"},\"receiver_address\":{\"id\":4,\"type\":\"string\"},\"resource\":{\"id\":2,\"type\":\"TronResourceCode\"}}},\"TronFreezeBalanceContract\":{\"fields\":{\"frozen_balance\":{\"id\":1,\"type\":\"uint64\"},\"frozen_duration\":{\"id\":2,\"type\":\"uint64\"},\"receiver_address\":{\"id\":4,\"type\":\"string\"},\"resource\":{\"id\":3,\"type\":\"TronResourceCode\"}}},\"TronFreezeBalanceV2Contract\":{\"fields\":{\"frozen_balance\":{\"id\":2,\"type\":\"uint64\"},\"resource\":{\"id\":3,\"type\":\"TronResourceCode\"}}},\"TronResourceCode\":{\"values\":{\"BANDWIDTH\":0,\"ENERGY\":1,\"TRON_POWER\":2}},\"TronTransferContract\":{\"fields\":{\"amount\":{\"id\":3,\"type\":\"uint64\"},\"to_address\":{\"id\":2,\"type\":\"string\"}}},\"TronTriggerSmartContract\":{\"fields\":{\"asset_id\":{\"id\":6,\"type\":\"uint64\"},\"call_token_value\":{\"id\":5,\"type\":\"uint64\"},\"call_value\":{\"id\":3,\"type\":\"uint64\"},\"contract_address\":{\"id\":2,\"type\":\"string\"},\"data\":{\"id\":4,\"type\":\"bytes\"}}},\"TronUnDelegateResourceContract\":{\"fields\":{\"balance\":{\"id\":3,\"type\":\"uint64\"},\"receiver_address\":{\"id\":4,\"type\":\"string\"},\"resource\":{\"id\":2,\"type\":\"TronResourceCode\"}}},\"TronUnfreezeBalanceContract\":{\"fields\":{\"receiver_address\":{\"id\":2,\"type\":\"string\"},\"resource\":{\"id\":1,\"type\":\"TronResourceCode\"}}},\"TronUnfreezeBalanceV2Contract\":{\"fields\":{\"resource\":{\"id\":3,\"type\":\"TronResourceCode\"},\"unfreeze_balance\":{\"id\":2,\"type\":\"uint64\"}}},\"TronVoteWitnessContract\":{\"fields\":{\"support\":{\"id\":3,\"type\":\"bool\"},\"votes\":{\"id\":2,\"rule\":\"repeated\",\"type\":\"Vote\"}},\"nested\":{\"Vote\":{\"fields\":{\"vote_address\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"},\"vote_count\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint32\"}}}}},\"TronWithdrawBalanceContract\":{\"fields\":{\"owner_address\":{\"id\":1,\"type\":\"bytes\"}}},\"TronWithdrawExpireUnfreezeContract\":{\"fields\":{}}}}}},\"TronSignedTx\":{\"fields\":{\"serialized_tx\":{\"id\":2,\"type\":\"bytes\"},\"signature\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"TxAck\":{\"fields\":{\"tx\":{\"id\":1,\"type\":\"TransactionType\"}},\"nested\":{\"TransactionType\":{\"fields\":{\"bin_outputs\":{\"id\":3,\"rule\":\"repeated\",\"type\":\"TxOutputBinType\"},\"branch_id\":{\"id\":14,\"type\":\"uint32\"},\"expiry\":{\"id\":10,\"type\":\"uint32\"},\"extra_data\":{\"id\":8,\"type\":\"bytes\"},\"extra_data_len\":{\"id\":9,\"type\":\"uint32\"},\"inputs\":{\"id\":2,\"rule\":\"repeated\",\"type\":\"TxInputType\"},\"inputs_cnt\":{\"id\":6,\"type\":\"uint32\"},\"lock_time\":{\"id\":4,\"type\":\"uint32\"},\"outputs\":{\"id\":5,\"rule\":\"repeated\",\"type\":\"TxOutputType\"},\"outputs_cnt\":{\"id\":7,\"type\":\"uint32\"},\"overwintered\":{\"id\":11,\"options\":{\"deprecated\":true},\"type\":\"bool\"},\"timestamp\":{\"id\":13,\"type\":\"uint32\"},\"version\":{\"id\":1,\"type\":\"uint32\"},\"version_group_id\":{\"id\":12,\"type\":\"uint32\"}},\"nested\":{\"TxInputType\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"amount\":{\"id\":8,\"type\":\"uint64\"},\"coinjoin_flags\":{\"id\":20,\"options\":{\"default\":0},\"type\":\"uint32\"},\"commitment_data\":{\"id\":15,\"type\":\"bytes\"},\"decred_staking_spend\":{\"id\":18,\"type\":\"DecredStakingSpendType\"},\"decred_tree\":{\"id\":9,\"type\":\"uint32\"},\"multisig\":{\"id\":7,\"type\":\"MultisigRedeemScriptType\"},\"orig_hash\":{\"id\":16,\"type\":\"bytes\"},\"orig_index\":{\"id\":17,\"type\":\"uint32\"},\"ownership_proof\":{\"id\":14,\"type\":\"bytes\"},\"prev_hash\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"},\"prev_index\":{\"id\":3,\"rule\":\"required\",\"type\":\"uint32\"},\"script_pubkey\":{\"id\":19,\"type\":\"bytes\"},\"script_sig\":{\"id\":4,\"type\":\"bytes\"},\"script_type\":{\"id\":6,\"options\":{\"default\":\"SPENDADDRESS\"},\"type\":\"InputScriptType\"},\"sequence\":{\"id\":5,\"options\":{\"default\":4294967295},\"type\":\"uint32\"},\"witness\":{\"id\":13,\"type\":\"bytes\"}}},\"TxOutputBinType\":{\"fields\":{\"amount\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint64\"},\"decred_script_version\":{\"id\":3,\"type\":\"uint32\"},\"script_pubkey\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"TxOutputType\":{\"fields\":{\"address\":{\"id\":1,\"type\":\"string\"},\"address_n\":{\"id\":2,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"amount\":{\"id\":3,\"rule\":\"required\",\"type\":\"uint64\"},\"multisig\":{\"id\":5,\"type\":\"MultisigRedeemScriptType\"},\"op_return_data\":{\"id\":6,\"type\":\"bytes\"},\"orig_hash\":{\"id\":10,\"type\":\"bytes\"},\"orig_index\":{\"id\":11,\"type\":\"uint32\"},\"payment_req_index\":{\"id\":12,\"options\":{\"(experimental_field)\":true},\"type\":\"uint32\"},\"script_type\":{\"id\":4,\"options\":{\"default\":\"PAYTOADDRESS\"},\"type\":\"OutputScriptType\"}}}}}},\"options\":{\"deprecated\":true}},\"TxAckInput\":{\"fields\":{\"tx\":{\"id\":1,\"rule\":\"required\",\"type\":\"TxAckInputWrapper\"}},\"nested\":{\"TxAckInputWrapper\":{\"fields\":{\"input\":{\"id\":2,\"rule\":\"required\",\"type\":\"TxInput\"}}}},\"options\":{\"(wire_type)\":22}},\"TxAckOutput\":{\"fields\":{\"tx\":{\"id\":1,\"rule\":\"required\",\"type\":\"TxAckOutputWrapper\"}},\"nested\":{\"TxAckOutputWrapper\":{\"fields\":{\"output\":{\"id\":5,\"rule\":\"required\",\"type\":\"TxOutput\"}}}},\"options\":{\"(wire_type)\":22}},\"TxAckPaymentRequest\":{\"fields\":{\"amount\":{\"id\":4,\"type\":\"uint64\"},\"memos\":{\"id\":3,\"rule\":\"repeated\",\"type\":\"PaymentRequestMemo\"},\"nonce\":{\"id\":1,\"type\":\"bytes\"},\"recipient_name\":{\"id\":2,\"rule\":\"required\",\"type\":\"string\"},\"signature\":{\"id\":5,\"rule\":\"required\",\"type\":\"bytes\"}},\"nested\":{\"CoinPurchaseMemo\":{\"fields\":{\"address\":{\"id\":3,\"rule\":\"required\",\"type\":\"string\"},\"amount\":{\"id\":2,\"rule\":\"required\",\"type\":\"string\"},\"coin_type\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint32\"},\"mac\":{\"id\":4,\"rule\":\"required\",\"type\":\"bytes\"}}},\"PaymentRequestMemo\":{\"fields\":{\"coin_purchase_memo\":{\"id\":3,\"type\":\"CoinPurchaseMemo\"},\"refund_memo\":{\"id\":2,\"type\":\"RefundMemo\"},\"text_memo\":{\"id\":1,\"type\":\"TextMemo\"}}},\"RefundMemo\":{\"fields\":{\"address\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"},\"mac\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"TextMemo\":{\"fields\":{\"text\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"}}}},\"options\":{\"(experimental_message)\":true}},\"TxAckPrevExtraData\":{\"fields\":{\"tx\":{\"id\":1,\"rule\":\"required\",\"type\":\"TxAckPrevExtraDataWrapper\"}},\"nested\":{\"TxAckPrevExtraDataWrapper\":{\"fields\":{\"extra_data_chunk\":{\"id\":8,\"rule\":\"required\",\"type\":\"bytes\"}}}},\"options\":{\"(wire_type)\":22}},\"TxAckPrevInput\":{\"fields\":{\"tx\":{\"id\":1,\"rule\":\"required\",\"type\":\"TxAckPrevInputWrapper\"}},\"nested\":{\"TxAckPrevInputWrapper\":{\"fields\":{\"input\":{\"id\":2,\"rule\":\"required\",\"type\":\"PrevInput\"}}}},\"options\":{\"(wire_type)\":22}},\"TxAckPrevMeta\":{\"fields\":{\"tx\":{\"id\":1,\"rule\":\"required\",\"type\":\"PrevTx\"}},\"options\":{\"(wire_type)\":22}},\"TxAckPrevOutput\":{\"fields\":{\"tx\":{\"id\":1,\"rule\":\"required\",\"type\":\"TxAckPrevOutputWrapper\"}},\"nested\":{\"TxAckPrevOutputWrapper\":{\"fields\":{\"output\":{\"id\":3,\"rule\":\"required\",\"type\":\"PrevOutput\"}}}},\"options\":{\"(wire_type)\":22}},\"TxInput\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"amount\":{\"id\":8,\"rule\":\"required\",\"type\":\"uint64\"},\"coinjoin_flags\":{\"id\":20,\"options\":{\"default\":0},\"type\":\"uint32\"},\"commitment_data\":{\"id\":15,\"type\":\"bytes\"},\"decred_staking_spend\":{\"id\":18,\"type\":\"DecredStakingSpendType\"},\"decred_tree\":{\"id\":9,\"type\":\"uint32\"},\"multisig\":{\"id\":7,\"type\":\"MultisigRedeemScriptType\"},\"orig_hash\":{\"id\":16,\"type\":\"bytes\"},\"orig_index\":{\"id\":17,\"type\":\"uint32\"},\"ownership_proof\":{\"id\":14,\"type\":\"bytes\"},\"prev_hash\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"},\"prev_index\":{\"id\":3,\"rule\":\"required\",\"type\":\"uint32\"},\"script_pubkey\":{\"id\":19,\"type\":\"bytes\"},\"script_sig\":{\"id\":4,\"type\":\"bytes\"},\"script_type\":{\"id\":6,\"options\":{\"default\":\"SPENDADDRESS\"},\"type\":\"InputScriptType\"},\"sequence\":{\"id\":5,\"options\":{\"default\":4294967295},\"type\":\"uint32\"},\"witness\":{\"id\":13,\"type\":\"bytes\"}}},\"TxOutput\":{\"fields\":{\"address\":{\"id\":1,\"type\":\"string\"},\"address_n\":{\"id\":2,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"amount\":{\"id\":3,\"rule\":\"required\",\"type\":\"uint64\"},\"multisig\":{\"id\":5,\"type\":\"MultisigRedeemScriptType\"},\"op_return_data\":{\"id\":6,\"type\":\"bytes\"},\"orig_hash\":{\"id\":10,\"type\":\"bytes\"},\"orig_index\":{\"id\":11,\"type\":\"uint32\"},\"payment_req_index\":{\"id\":12,\"options\":{\"(experimental_field)\":true},\"type\":\"uint32\"},\"script_type\":{\"id\":4,\"options\":{\"default\":\"PAYTOADDRESS\"},\"type\":\"OutputScriptType\"}}},\"TxRequest\":{\"fields\":{\"details\":{\"id\":2,\"type\":\"TxRequestDetailsType\"},\"request_type\":{\"id\":1,\"type\":\"RequestType\"},\"serialized\":{\"id\":3,\"type\":\"TxRequestSerializedType\"}},\"nested\":{\"RequestType\":{\"values\":{\"TXEXTRADATA\":4,\"TXFINISHED\":3,\"TXINPUT\":0,\"TXMETA\":2,\"TXORIGINPUT\":5,\"TXORIGOUTPUT\":6,\"TXOUTPUT\":1,\"TXPAYMENTREQ\":7}},\"TxRequestDetailsType\":{\"fields\":{\"extra_data_len\":{\"id\":3,\"type\":\"uint32\"},\"extra_data_offset\":{\"id\":4,\"type\":\"uint32\"},\"request_index\":{\"id\":1,\"type\":\"uint32\"},\"tx_hash\":{\"id\":2,\"type\":\"bytes\"}}},\"TxRequestSerializedType\":{\"fields\":{\"serialized_tx\":{\"id\":3,\"type\":\"bytes\"},\"signature\":{\"id\":2,\"type\":\"bytes\"},\"signature_index\":{\"id\":1,\"type\":\"uint32\"}}}}},\"UiAnimationCommand\":{\"values\":{\"CommandUnknown\":0,\"Refresh\":3,\"Start\":1,\"Stop\":2}},\"UiAnimationRequest\":{\"fields\":{\"command\":{\"id\":1,\"rule\":\"required\",\"type\":\"UiAnimationCommand\"},\"type\":{\"id\":2,\"type\":\"UiAnimationType\"}}},\"UiAnimationType\":{\"values\":{\"Signing\":1,\"Unknown\":0}},\"UnLockDevice\":{\"fields\":{}},\"UnLockDeviceResponse\":{\"fields\":{\"passphrase_protection\":{\"id\":3,\"type\":\"bool\"},\"unlocked\":{\"id\":1,\"type\":\"bool\"},\"unlocked_attach_pin\":{\"id\":2,\"type\":\"bool\"}}},\"UnlockPath\":{\"fields\":{\"address_n\":{\"id\":1,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"mac\":{\"id\":2,\"type\":\"bytes\"}}},\"UnlockedPathRequest\":{\"fields\":{\"mac\":{\"id\":1,\"type\":\"bytes\"}}},\"VerifyMessage\":{\"fields\":{\"address\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"},\"coin_name\":{\"id\":4,\"options\":{\"default\":\"Bitcoin\"},\"type\":\"string\"},\"message\":{\"id\":3,\"rule\":\"required\",\"type\":\"bytes\"},\"signature\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"ViewActionCard\":{\"fields\":{\"initial_data\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"}},\"reserved\":[[2,2],\"placeholder\"]},\"ViewAmount\":{\"fields\":{\"is_unlimited\":{\"id\":1,\"rule\":\"required\",\"type\":\"bool\"},\"num\":{\"id\":2,\"rule\":\"required\",\"type\":\"string\"}},\"reserved\":[[3,3],\"symbol\"]},\"ViewContentEntry\":{\"fields\":{\"entry_key\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint32\"},\"value\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"}}},\"ViewContentPage\":{\"fields\":{\"chunk\":{\"id\":3,\"type\":\"bytes\"},\"entry\":{\"id\":4,\"type\":\"ViewContentEntry\"},\"page_count\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint32\"},\"page_index\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint32\"}}},\"ViewContentPreview\":{\"fields\":{\"content_key\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint32\"},\"preview\":{\"id\":2,\"rule\":\"required\",\"type\":\"bytes\"},\"total_bytes\":{\"id\":3,\"type\":\"uint32\"}}},\"ViewCustomField\":{\"fields\":{\"key\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"},\"value\":{\"id\":2,\"rule\":\"required\",\"type\":\"string\"}}},\"ViewDetail\":{\"fields\":{\"has_icon\":{\"id\":4,\"rule\":\"required\",\"type\":\"bool\"},\"is_overview\":{\"id\":3,\"rule\":\"required\",\"type\":\"bool\"},\"key\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint32\"},\"value\":{\"id\":2,\"rule\":\"required\",\"type\":\"string\"}}},\"ViewSignLayout\":{\"values\":{\"Layout7702\":3,\"LayoutDefault\":0,\"LayoutEthApprove\":5,\"LayoutFinalConfirm\":2,\"LayoutFlat\":4,\"LayoutSafeTxCreate\":1}},\"ViewSignPage\":{\"fields\":{\"action_card\":{\"id\":5,\"type\":\"ViewActionCard\"},\"amount\":{\"id\":2,\"type\":\"ViewAmount\"},\"content\":{\"id\":10,\"type\":\"ViewContentPreview\"},\"custom_field\":{\"id\":11,\"type\":\"ViewCustomField\"},\"general\":{\"id\":3,\"rule\":\"repeated\",\"type\":\"ViewDetail\"},\"layout\":{\"id\":7,\"options\":{\"default\":\"LayoutDefault\"},\"type\":\"ViewSignLayout\"},\"slide_to_confirm\":{\"id\":6,\"options\":{\"default\":true},\"type\":\"bool\"},\"tip\":{\"id\":4,\"type\":\"ViewTip\"},\"title\":{\"id\":1,\"type\":\"string\"},\"title_arg\":{\"id\":9,\"type\":\"string\"},\"title_id\":{\"id\":8,\"type\":\"uint32\"}}},\"ViewTip\":{\"fields\":{\"text\":{\"id\":2,\"type\":\"string\"},\"text_arg\":{\"id\":4,\"type\":\"string\"},\"text_id\":{\"id\":3,\"type\":\"uint32\"},\"type\":{\"id\":1,\"rule\":\"required\",\"type\":\"ViewTipType\"}}},\"ViewTipType\":{\"values\":{\"Danger\":4,\"Default\":0,\"Highlight\":1,\"Recommend\":2,\"Warning\":3}},\"ViewVerifyPage\":{\"fields\":{\"address\":{\"id\":2,\"rule\":\"required\",\"type\":\"string\"},\"chain_id\":{\"id\":8,\"type\":\"uint32\"},\"content\":{\"id\":9,\"type\":\"ViewContentPreview\"},\"derive_type\":{\"id\":5,\"type\":\"string\"},\"network\":{\"id\":4,\"type\":\"string\"},\"path\":{\"id\":3,\"rule\":\"required\",\"type\":\"string\"},\"title\":{\"id\":1,\"type\":\"string\"},\"title_id\":{\"id\":7,\"type\":\"uint32\"},\"value_key\":{\"id\":6,\"type\":\"uint32\"}}},\"ViewWarningPage\":{\"fields\":{\"cancellable\":{\"id\":4,\"type\":\"bool\"},\"text_arg\":{\"id\":3,\"type\":\"string\"},\"text_id\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint32\"},\"title_id\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint32\"}}},\"WebAuthnAddResidentCredential\":{\"fields\":{\"credential_id\":{\"id\":1,\"type\":\"bytes\"}}},\"WebAuthnCredentials\":{\"fields\":{\"credentials\":{\"id\":1,\"rule\":\"repeated\",\"type\":\"WebAuthnCredential\"}},\"nested\":{\"WebAuthnCredential\":{\"fields\":{\"algorithm\":{\"id\":11,\"type\":\"sint32\"},\"creation_time\":{\"id\":8,\"type\":\"uint32\"},\"curve\":{\"id\":12,\"type\":\"sint32\"},\"hmac_secret\":{\"id\":9,\"type\":\"bool\"},\"id\":{\"id\":2,\"type\":\"bytes\"},\"index\":{\"id\":1,\"type\":\"uint32\"},\"rp_id\":{\"id\":3,\"type\":\"string\"},\"rp_name\":{\"id\":4,\"type\":\"string\"},\"use_sign_count\":{\"id\":10,\"type\":\"bool\"},\"user_display_name\":{\"id\":7,\"type\":\"string\"},\"user_id\":{\"id\":5,\"type\":\"bytes\"},\"user_name\":{\"id\":6,\"type\":\"string\"}}}}},\"WebAuthnListResidentCredentials\":{\"fields\":{}},\"WebAuthnRemoveResidentCredential\":{\"fields\":{\"index\":{\"id\":1,\"type\":\"uint32\"}}},\"WipeDevice\":{\"fields\":{}},\"WordAck\":{\"fields\":{\"word\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"}}},\"WordRequest\":{\"fields\":{\"type\":{\"id\":1,\"rule\":\"required\",\"type\":\"WordRequestType\"}},\"nested\":{\"WordRequestType\":{\"values\":{\"WordRequestType_Matrix6\":2,\"WordRequestType_Matrix9\":1,\"WordRequestType_Plain\":0}}}},\"WriteSEPrivateKey\":{\"fields\":{\"private_key\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"WriteSEPublicCert\":{\"fields\":{\"public_cert\":{\"id\":1,\"rule\":\"required\",\"type\":\"bytes\"}}},\"ZoomRequest\":{\"fields\":{\"data_length\":{\"id\":2,\"rule\":\"required\",\"type\":\"uint32\"},\"offset\":{\"id\":1,\"type\":\"uint32\"}}},\"bitcoin_only\":{\"extend\":\"google.protobuf.EnumValueOptions\",\"id\":60000,\"type\":\"bool\"},\"experimental_field\":{\"extend\":\"google.protobuf.FieldOptions\",\"id\":53001,\"type\":\"bool\"},\"experimental_message\":{\"extend\":\"google.protobuf.MessageOptions\",\"id\":52001,\"type\":\"bool\"},\"google\":{\"nested\":{\"protobuf\":{\"nested\":{\"DescriptorProto\":{\"fields\":{\"enum_type\":{\"id\":4,\"rule\":\"repeated\",\"type\":\"EnumDescriptorProto\"},\"extension\":{\"id\":6,\"rule\":\"repeated\",\"type\":\"FieldDescriptorProto\"},\"extension_range\":{\"id\":5,\"rule\":\"repeated\",\"type\":\"ExtensionRange\"},\"field\":{\"id\":2,\"rule\":\"repeated\",\"type\":\"FieldDescriptorProto\"},\"name\":{\"id\":1,\"type\":\"string\"},\"nested_type\":{\"id\":3,\"rule\":\"repeated\",\"type\":\"DescriptorProto\"},\"oneof_decl\":{\"id\":8,\"rule\":\"repeated\",\"type\":\"OneofDescriptorProto\"},\"options\":{\"id\":7,\"type\":\"MessageOptions\"},\"reserved_name\":{\"id\":10,\"rule\":\"repeated\",\"type\":\"string\"},\"reserved_range\":{\"id\":9,\"rule\":\"repeated\",\"type\":\"ReservedRange\"}},\"nested\":{\"ExtensionRange\":{\"fields\":{\"end\":{\"id\":2,\"type\":\"int32\"},\"start\":{\"id\":1,\"type\":\"int32\"}}},\"ReservedRange\":{\"fields\":{\"end\":{\"id\":2,\"type\":\"int32\"},\"start\":{\"id\":1,\"type\":\"int32\"}}}}},\"EnumDescriptorProto\":{\"fields\":{\"name\":{\"id\":1,\"type\":\"string\"},\"options\":{\"id\":3,\"type\":\"EnumOptions\"},\"value\":{\"id\":2,\"rule\":\"repeated\",\"type\":\"EnumValueDescriptorProto\"}}},\"EnumOptions\":{\"extensions\":[[1000,536870911]],\"fields\":{\"allow_alias\":{\"id\":2,\"type\":\"bool\"},\"deprecated\":{\"id\":3,\"type\":\"bool\"},\"uninterpreted_option\":{\"id\":999,\"rule\":\"repeated\",\"type\":\"UninterpretedOption\"}}},\"EnumValueDescriptorProto\":{\"fields\":{\"name\":{\"id\":1,\"type\":\"string\"},\"number\":{\"id\":2,\"type\":\"int32\"},\"options\":{\"id\":3,\"type\":\"EnumValueOptions\"}}},\"EnumValueOptions\":{\"extensions\":[[1000,536870911]],\"fields\":{\"deprecated\":{\"id\":1,\"type\":\"bool\"},\"uninterpreted_option\":{\"id\":999,\"rule\":\"repeated\",\"type\":\"UninterpretedOption\"}}},\"FieldDescriptorProto\":{\"fields\":{\"default_value\":{\"id\":7,\"type\":\"string\"},\"extendee\":{\"id\":2,\"type\":\"string\"},\"json_name\":{\"id\":10,\"type\":\"string\"},\"label\":{\"id\":4,\"type\":\"Label\"},\"name\":{\"id\":1,\"type\":\"string\"},\"number\":{\"id\":3,\"type\":\"int32\"},\"oneof_index\":{\"id\":9,\"type\":\"int32\"},\"options\":{\"id\":8,\"type\":\"FieldOptions\"},\"type\":{\"id\":5,\"type\":\"Type\"},\"type_name\":{\"id\":6,\"type\":\"string\"}},\"nested\":{\"Label\":{\"values\":{\"LABEL_OPTIONAL\":1,\"LABEL_REPEATED\":3,\"LABEL_REQUIRED\":2}},\"Type\":{\"values\":{\"TYPE_BOOL\":8,\"TYPE_BYTES\":12,\"TYPE_DOUBLE\":1,\"TYPE_ENUM\":14,\"TYPE_FIXED32\":7,\"TYPE_FIXED64\":6,\"TYPE_FLOAT\":2,\"TYPE_GROUP\":10,\"TYPE_INT32\":5,\"TYPE_INT64\":3,\"TYPE_MESSAGE\":11,\"TYPE_SFIXED32\":15,\"TYPE_SFIXED64\":16,\"TYPE_SINT32\":17,\"TYPE_SINT64\":18,\"TYPE_STRING\":9,\"TYPE_UINT32\":13,\"TYPE_UINT64\":4}}}},\"FieldOptions\":{\"extensions\":[[1000,536870911]],\"fields\":{\"ctype\":{\"id\":1,\"options\":{\"default\":\"STRING\"},\"type\":\"CType\"},\"deprecated\":{\"id\":3,\"type\":\"bool\"},\"jstype\":{\"id\":6,\"options\":{\"default\":\"JS_NORMAL\"},\"type\":\"JSType\"},\"lazy\":{\"id\":5,\"type\":\"bool\"},\"packed\":{\"id\":2,\"type\":\"bool\"},\"uninterpreted_option\":{\"id\":999,\"rule\":\"repeated\",\"type\":\"UninterpretedOption\"},\"weak\":{\"id\":10,\"type\":\"bool\"}},\"nested\":{\"CType\":{\"values\":{\"CORD\":1,\"STRING\":0,\"STRING_PIECE\":2}},\"JSType\":{\"values\":{\"JS_NORMAL\":0,\"JS_NUMBER\":2,\"JS_STRING\":1}}},\"reserved\":[[4,4]]},\"FileDescriptorProto\":{\"fields\":{\"dependency\":{\"id\":3,\"rule\":\"repeated\",\"type\":\"string\"},\"enum_type\":{\"id\":5,\"rule\":\"repeated\",\"type\":\"EnumDescriptorProto\"},\"extension\":{\"id\":7,\"rule\":\"repeated\",\"type\":\"FieldDescriptorProto\"},\"message_type\":{\"id\":4,\"rule\":\"repeated\",\"type\":\"DescriptorProto\"},\"name\":{\"id\":1,\"type\":\"string\"},\"options\":{\"id\":8,\"type\":\"FileOptions\"},\"package\":{\"id\":2,\"type\":\"string\"},\"public_dependency\":{\"id\":10,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"int32\"},\"service\":{\"id\":6,\"rule\":\"repeated\",\"type\":\"ServiceDescriptorProto\"},\"source_code_info\":{\"id\":9,\"type\":\"SourceCodeInfo\"},\"syntax\":{\"id\":12,\"type\":\"string\"},\"weak_dependency\":{\"id\":11,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"int32\"}}},\"FileDescriptorSet\":{\"fields\":{\"file\":{\"id\":1,\"rule\":\"repeated\",\"type\":\"FileDescriptorProto\"}}},\"FileOptions\":{\"extensions\":[[1000,536870911]],\"fields\":{\"cc_enable_arenas\":{\"id\":31,\"type\":\"bool\"},\"cc_generic_services\":{\"id\":16,\"type\":\"bool\"},\"csharp_namespace\":{\"id\":37,\"type\":\"string\"},\"deprecated\":{\"id\":23,\"type\":\"bool\"},\"go_package\":{\"id\":11,\"type\":\"string\"},\"java_generate_equals_and_hash\":{\"id\":20,\"options\":{\"deprecated\":true},\"type\":\"bool\"},\"java_generic_services\":{\"id\":17,\"type\":\"bool\"},\"java_multiple_files\":{\"id\":10,\"type\":\"bool\"},\"java_outer_classname\":{\"id\":8,\"type\":\"string\"},\"java_package\":{\"id\":1,\"type\":\"string\"},\"java_string_check_utf8\":{\"id\":27,\"type\":\"bool\"},\"objc_class_prefix\":{\"id\":36,\"type\":\"string\"},\"optimize_for\":{\"id\":9,\"options\":{\"default\":\"SPEED\"},\"type\":\"OptimizeMode\"},\"py_generic_services\":{\"id\":18,\"type\":\"bool\"},\"uninterpreted_option\":{\"id\":999,\"rule\":\"repeated\",\"type\":\"UninterpretedOption\"}},\"nested\":{\"OptimizeMode\":{\"values\":{\"CODE_SIZE\":2,\"LITE_RUNTIME\":3,\"SPEED\":1}}},\"reserved\":[[38,38]]},\"GeneratedCodeInfo\":{\"fields\":{\"annotation\":{\"id\":1,\"rule\":\"repeated\",\"type\":\"Annotation\"}},\"nested\":{\"Annotation\":{\"fields\":{\"begin\":{\"id\":3,\"type\":\"int32\"},\"end\":{\"id\":4,\"type\":\"int32\"},\"path\":{\"id\":1,\"rule\":\"repeated\",\"type\":\"int32\"},\"source_file\":{\"id\":2,\"type\":\"string\"}}}}},\"MessageOptions\":{\"extensions\":[[1000,536870911]],\"fields\":{\"deprecated\":{\"id\":3,\"type\":\"bool\"},\"map_entry\":{\"id\":7,\"type\":\"bool\"},\"message_set_wire_format\":{\"id\":1,\"type\":\"bool\"},\"no_standard_descriptor_accessor\":{\"id\":2,\"type\":\"bool\"},\"uninterpreted_option\":{\"id\":999,\"rule\":\"repeated\",\"type\":\"UninterpretedOption\"}},\"reserved\":[[8,8]]},\"MethodDescriptorProto\":{\"fields\":{\"client_streaming\":{\"id\":5,\"type\":\"bool\"},\"input_type\":{\"id\":2,\"type\":\"string\"},\"name\":{\"id\":1,\"type\":\"string\"},\"options\":{\"id\":4,\"type\":\"MethodOptions\"},\"output_type\":{\"id\":3,\"type\":\"string\"},\"server_streaming\":{\"id\":6,\"type\":\"bool\"}}},\"MethodOptions\":{\"extensions\":[[1000,536870911]],\"fields\":{\"deprecated\":{\"id\":33,\"type\":\"bool\"},\"uninterpreted_option\":{\"id\":999,\"rule\":\"repeated\",\"type\":\"UninterpretedOption\"}}},\"OneofDescriptorProto\":{\"fields\":{\"name\":{\"id\":1,\"type\":\"string\"},\"options\":{\"id\":2,\"type\":\"OneofOptions\"}}},\"OneofOptions\":{\"extensions\":[[1000,536870911]],\"fields\":{\"uninterpreted_option\":{\"id\":999,\"rule\":\"repeated\",\"type\":\"UninterpretedOption\"}}},\"ServiceDescriptorProto\":{\"fields\":{\"method\":{\"id\":2,\"rule\":\"repeated\",\"type\":\"MethodDescriptorProto\"},\"name\":{\"id\":1,\"type\":\"string\"},\"options\":{\"id\":3,\"type\":\"ServiceOptions\"}}},\"ServiceOptions\":{\"extensions\":[[1000,536870911]],\"fields\":{\"deprecated\":{\"id\":33,\"type\":\"bool\"},\"uninterpreted_option\":{\"id\":999,\"rule\":\"repeated\",\"type\":\"UninterpretedOption\"}}},\"SourceCodeInfo\":{\"fields\":{\"location\":{\"id\":1,\"rule\":\"repeated\",\"type\":\"Location\"}},\"nested\":{\"Location\":{\"fields\":{\"leading_comments\":{\"id\":3,\"type\":\"string\"},\"leading_detached_comments\":{\"id\":6,\"rule\":\"repeated\",\"type\":\"string\"},\"path\":{\"id\":1,\"rule\":\"repeated\",\"type\":\"int32\"},\"span\":{\"id\":2,\"rule\":\"repeated\",\"type\":\"int32\"},\"trailing_comments\":{\"id\":4,\"type\":\"string\"}}}}},\"UninterpretedOption\":{\"fields\":{\"aggregate_value\":{\"id\":8,\"type\":\"string\"},\"double_value\":{\"id\":6,\"type\":\"double\"},\"identifier_value\":{\"id\":3,\"type\":\"string\"},\"name\":{\"id\":2,\"rule\":\"repeated\",\"type\":\"NamePart\"},\"negative_int_value\":{\"id\":5,\"type\":\"int64\"},\"positive_int_value\":{\"id\":4,\"type\":\"uint64\"},\"string_value\":{\"id\":7,\"type\":\"bytes\"}},\"nested\":{\"NamePart\":{\"fields\":{\"is_extension\":{\"id\":2,\"rule\":\"required\",\"type\":\"bool\"},\"name_part\":{\"id\":1,\"rule\":\"required\",\"type\":\"string\"}}}}}}}}},\"has_bitcoin_only_values\":{\"extend\":\"google.protobuf.EnumOptions\",\"id\":51001,\"type\":\"bool\"},\"include_in_bitcoin_only\":{\"extend\":\"google.protobuf.FileOptions\",\"id\":60000,\"type\":\"bool\"},\"wire_bootloader\":{\"extend\":\"google.protobuf.EnumValueOptions\",\"id\":50007,\"type\":\"bool\"},\"wire_debug_in\":{\"extend\":\"google.protobuf.EnumValueOptions\",\"id\":50004,\"type\":\"bool\"},\"wire_debug_out\":{\"extend\":\"google.protobuf.EnumValueOptions\",\"id\":50005,\"type\":\"bool\"},\"wire_in\":{\"extend\":\"google.protobuf.EnumValueOptions\",\"id\":50002,\"type\":\"bool\"},\"wire_no_fsm\":{\"extend\":\"google.protobuf.EnumValueOptions\",\"id\":50008,\"type\":\"bool\"},\"wire_out\":{\"extend\":\"google.protobuf.EnumValueOptions\",\"id\":50003,\"type\":\"bool\"},\"wire_tiny\":{\"extend\":\"google.protobuf.EnumValueOptions\",\"id\":50006,\"type\":\"bool\"},\"wire_type\":{\"extend\":\"google.protobuf.MessageOptions\",\"id\":52002,\"type\":\"uint32\"}}}": function () {
const $protobuf = { ...protobuf, roots: {} };
var $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

var $root = $protobuf.roots["onekey-csp-2"] || ($protobuf.roots["onekey-csp-2"] = {});

$root.AlephiumGetAddress = (function() {

    function AlephiumGetAddress(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    AlephiumGetAddress.prototype.address_n = $util.emptyArray;
    AlephiumGetAddress.prototype.show_display = false;
    AlephiumGetAddress.prototype.include_public_key = false;
    AlephiumGetAddress.prototype.target_group = 0;

    AlephiumGetAddress.create = function create(properties) {
        return new AlephiumGetAddress(properties);
    };

    AlephiumGetAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(16).bool(message.show_display);
        if (message.include_public_key != null && Object.hasOwnProperty.call(message, "include_public_key"))
            writer.uint32(24).bool(message.include_public_key);
        if (message.target_group != null && Object.hasOwnProperty.call(message, "target_group"))
            writer.uint32(32).uint32(message.target_group);
        return writer;
    };

    AlephiumGetAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    AlephiumGetAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.AlephiumGetAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.show_display = reader.bool();
                break;
            case 3:
                message.include_public_key = reader.bool();
                break;
            case 4:
                message.target_group = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    AlephiumGetAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    AlephiumGetAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        if (message.include_public_key != null && message.hasOwnProperty("include_public_key"))
            if (typeof message.include_public_key !== "boolean")
                return "include_public_key: boolean expected";
        if (message.target_group != null && message.hasOwnProperty("target_group"))
            if (!$util.isInteger(message.target_group))
                return "target_group: integer expected";
        return null;
    };

    AlephiumGetAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.AlephiumGetAddress)
            return object;
        var message = new $root.AlephiumGetAddress();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".AlephiumGetAddress.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        if (object.include_public_key != null)
            message.include_public_key = Boolean(object.include_public_key);
        if (object.target_group != null)
            message.target_group = object.target_group >>> 0;
        return message;
    };

    AlephiumGetAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            object.show_display = false;
            object.include_public_key = false;
            object.target_group = 0;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        if (message.include_public_key != null && message.hasOwnProperty("include_public_key"))
            object.include_public_key = message.include_public_key;
        if (message.target_group != null && message.hasOwnProperty("target_group"))
            object.target_group = message.target_group;
        return object;
    };

    AlephiumGetAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return AlephiumGetAddress;
})();

$root.AlephiumAddress = (function() {

    function AlephiumAddress(properties) {
        this.derived_path = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    AlephiumAddress.prototype.address = "";
    AlephiumAddress.prototype.public_key = $util.newBuffer([]);
    AlephiumAddress.prototype.derived_path = $util.emptyArray;

    AlephiumAddress.create = function create(properties) {
        return new AlephiumAddress(properties);
    };

    AlephiumAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.address);
        if (message.public_key != null && Object.hasOwnProperty.call(message, "public_key"))
            writer.uint32(18).bytes(message.public_key);
        if (message.derived_path != null && message.derived_path.length)
            for (var i = 0; i < message.derived_path.length; ++i)
                writer.uint32(24).uint32(message.derived_path[i]);
        return writer;
    };

    AlephiumAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    AlephiumAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.AlephiumAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.string();
                break;
            case 2:
                message.public_key = reader.bytes();
                break;
            case 3:
                if (!(message.derived_path && message.derived_path.length))
                    message.derived_path = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.derived_path.push(reader.uint32());
                } else
                    message.derived_path.push(reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("address"))
            throw $util.ProtocolError("missing required 'address'", { instance: message });
        return message;
    };

    AlephiumAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    AlephiumAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.address))
            return "address: string expected";
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            if (!(message.public_key && typeof message.public_key.length === "number" || $util.isString(message.public_key)))
                return "public_key: buffer expected";
        if (message.derived_path != null && message.hasOwnProperty("derived_path")) {
            if (!Array.isArray(message.derived_path))
                return "derived_path: array expected";
            for (var i = 0; i < message.derived_path.length; ++i)
                if (!$util.isInteger(message.derived_path[i]))
                    return "derived_path: integer[] expected";
        }
        return null;
    };

    AlephiumAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.AlephiumAddress)
            return object;
        var message = new $root.AlephiumAddress();
        if (object.address != null)
            message.address = String(object.address);
        if (object.public_key != null)
            if (typeof object.public_key === "string")
                $util.base64.decode(object.public_key, message.public_key = $util.newBuffer($util.base64.length(object.public_key)), 0);
            else if (object.public_key.length)
                message.public_key = object.public_key;
        if (object.derived_path) {
            if (!Array.isArray(object.derived_path))
                throw TypeError(".AlephiumAddress.derived_path: array expected");
            message.derived_path = [];
            for (var i = 0; i < object.derived_path.length; ++i)
                message.derived_path[i] = object.derived_path[i] >>> 0;
        }
        return message;
    };

    AlephiumAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.derived_path = [];
        if (options.defaults) {
            object.address = "";
            if (options.bytes === String)
                object.public_key = "";
            else {
                object.public_key = [];
                if (options.bytes !== Array)
                    object.public_key = $util.newBuffer(object.public_key);
            }
        }
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            object.public_key = options.bytes === String ? $util.base64.encode(message.public_key, 0, message.public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.public_key) : message.public_key;
        if (message.derived_path && message.derived_path.length) {
            object.derived_path = [];
            for (var j = 0; j < message.derived_path.length; ++j)
                object.derived_path[j] = message.derived_path[j];
        }
        return object;
    };

    AlephiumAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return AlephiumAddress;
})();

$root.AlephiumSignTx = (function() {

    function AlephiumSignTx(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    AlephiumSignTx.prototype.address_n = $util.emptyArray;
    AlephiumSignTx.prototype.data_initial_chunk = $util.newBuffer([]);
    AlephiumSignTx.prototype.data_length = 0;

    AlephiumSignTx.create = function create(properties) {
        return new AlephiumSignTx(properties);
    };

    AlephiumSignTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).bytes(message.data_initial_chunk);
        if (message.data_length != null && Object.hasOwnProperty.call(message, "data_length"))
            writer.uint32(24).uint32(message.data_length);
        return writer;
    };

    AlephiumSignTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    AlephiumSignTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.AlephiumSignTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.data_initial_chunk = reader.bytes();
                break;
            case 3:
                message.data_length = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("data_initial_chunk"))
            throw $util.ProtocolError("missing required 'data_initial_chunk'", { instance: message });
        return message;
    };

    AlephiumSignTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    AlephiumSignTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!(message.data_initial_chunk && typeof message.data_initial_chunk.length === "number" || $util.isString(message.data_initial_chunk)))
            return "data_initial_chunk: buffer expected";
        if (message.data_length != null && message.hasOwnProperty("data_length"))
            if (!$util.isInteger(message.data_length))
                return "data_length: integer expected";
        return null;
    };

    AlephiumSignTx.fromObject = function fromObject(object) {
        if (object instanceof $root.AlephiumSignTx)
            return object;
        var message = new $root.AlephiumSignTx();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".AlephiumSignTx.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.data_initial_chunk != null)
            if (typeof object.data_initial_chunk === "string")
                $util.base64.decode(object.data_initial_chunk, message.data_initial_chunk = $util.newBuffer($util.base64.length(object.data_initial_chunk)), 0);
            else if (object.data_initial_chunk.length)
                message.data_initial_chunk = object.data_initial_chunk;
        if (object.data_length != null)
            message.data_length = object.data_length >>> 0;
        return message;
    };

    AlephiumSignTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            if (options.bytes === String)
                object.data_initial_chunk = "";
            else {
                object.data_initial_chunk = [];
                if (options.bytes !== Array)
                    object.data_initial_chunk = $util.newBuffer(object.data_initial_chunk);
            }
            object.data_length = 0;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.data_initial_chunk != null && message.hasOwnProperty("data_initial_chunk"))
            object.data_initial_chunk = options.bytes === String ? $util.base64.encode(message.data_initial_chunk, 0, message.data_initial_chunk.length) : options.bytes === Array ? Array.prototype.slice.call(message.data_initial_chunk) : message.data_initial_chunk;
        if (message.data_length != null && message.hasOwnProperty("data_length"))
            object.data_length = message.data_length;
        return object;
    };

    AlephiumSignTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return AlephiumSignTx;
})();

$root.AlephiumSignedTx = (function() {

    function AlephiumSignedTx(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    AlephiumSignedTx.prototype.signature = $util.newBuffer([]);
    AlephiumSignedTx.prototype.address = "";

    AlephiumSignedTx.create = function create(properties) {
        return new AlephiumSignedTx(properties);
    };

    AlephiumSignedTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.signature);
        writer.uint32(18).string(message.address);
        return writer;
    };

    AlephiumSignedTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    AlephiumSignedTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.AlephiumSignedTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.signature = reader.bytes();
                break;
            case 2:
                message.address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        if (!message.hasOwnProperty("address"))
            throw $util.ProtocolError("missing required 'address'", { instance: message });
        return message;
    };

    AlephiumSignedTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    AlephiumSignedTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        if (!$util.isString(message.address))
            return "address: string expected";
        return null;
    };

    AlephiumSignedTx.fromObject = function fromObject(object) {
        if (object instanceof $root.AlephiumSignedTx)
            return object;
        var message = new $root.AlephiumSignedTx();
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        if (object.address != null)
            message.address = String(object.address);
        return message;
    };

    AlephiumSignedTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
            object.address = "";
        }
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    AlephiumSignedTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return AlephiumSignedTx;
})();

$root.AlephiumTxRequest = (function() {

    function AlephiumTxRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    AlephiumTxRequest.prototype.data_length = 0;
    AlephiumTxRequest.prototype.public_key = $util.newBuffer([]);
    AlephiumTxRequest.prototype.signature = $util.newBuffer([]);

    AlephiumTxRequest.create = function create(properties) {
        return new AlephiumTxRequest(properties);
    };

    AlephiumTxRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.data_length != null && Object.hasOwnProperty.call(message, "data_length"))
            writer.uint32(8).uint32(message.data_length);
        if (message.public_key != null && Object.hasOwnProperty.call(message, "public_key"))
            writer.uint32(18).bytes(message.public_key);
        if (message.signature != null && Object.hasOwnProperty.call(message, "signature"))
            writer.uint32(26).bytes(message.signature);
        return writer;
    };

    AlephiumTxRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    AlephiumTxRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.AlephiumTxRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.data_length = reader.uint32();
                break;
            case 2:
                message.public_key = reader.bytes();
                break;
            case 3:
                message.signature = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    AlephiumTxRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    AlephiumTxRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.data_length != null && message.hasOwnProperty("data_length"))
            if (!$util.isInteger(message.data_length))
                return "data_length: integer expected";
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            if (!(message.public_key && typeof message.public_key.length === "number" || $util.isString(message.public_key)))
                return "public_key: buffer expected";
        if (message.signature != null && message.hasOwnProperty("signature"))
            if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
                return "signature: buffer expected";
        return null;
    };

    AlephiumTxRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.AlephiumTxRequest)
            return object;
        var message = new $root.AlephiumTxRequest();
        if (object.data_length != null)
            message.data_length = object.data_length >>> 0;
        if (object.public_key != null)
            if (typeof object.public_key === "string")
                $util.base64.decode(object.public_key, message.public_key = $util.newBuffer($util.base64.length(object.public_key)), 0);
            else if (object.public_key.length)
                message.public_key = object.public_key;
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        return message;
    };

    AlephiumTxRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.data_length = 0;
            if (options.bytes === String)
                object.public_key = "";
            else {
                object.public_key = [];
                if (options.bytes !== Array)
                    object.public_key = $util.newBuffer(object.public_key);
            }
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
        }
        if (message.data_length != null && message.hasOwnProperty("data_length"))
            object.data_length = message.data_length;
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            object.public_key = options.bytes === String ? $util.base64.encode(message.public_key, 0, message.public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.public_key) : message.public_key;
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        return object;
    };

    AlephiumTxRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return AlephiumTxRequest;
})();

$root.AlephiumTxAck = (function() {

    function AlephiumTxAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    AlephiumTxAck.prototype.data_chunk = $util.newBuffer([]);

    AlephiumTxAck.create = function create(properties) {
        return new AlephiumTxAck(properties);
    };

    AlephiumTxAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.data_chunk);
        return writer;
    };

    AlephiumTxAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    AlephiumTxAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.AlephiumTxAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.data_chunk = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("data_chunk"))
            throw $util.ProtocolError("missing required 'data_chunk'", { instance: message });
        return message;
    };

    AlephiumTxAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    AlephiumTxAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.data_chunk && typeof message.data_chunk.length === "number" || $util.isString(message.data_chunk)))
            return "data_chunk: buffer expected";
        return null;
    };

    AlephiumTxAck.fromObject = function fromObject(object) {
        if (object instanceof $root.AlephiumTxAck)
            return object;
        var message = new $root.AlephiumTxAck();
        if (object.data_chunk != null)
            if (typeof object.data_chunk === "string")
                $util.base64.decode(object.data_chunk, message.data_chunk = $util.newBuffer($util.base64.length(object.data_chunk)), 0);
            else if (object.data_chunk.length)
                message.data_chunk = object.data_chunk;
        return message;
    };

    AlephiumTxAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.data_chunk = "";
            else {
                object.data_chunk = [];
                if (options.bytes !== Array)
                    object.data_chunk = $util.newBuffer(object.data_chunk);
            }
        if (message.data_chunk != null && message.hasOwnProperty("data_chunk"))
            object.data_chunk = options.bytes === String ? $util.base64.encode(message.data_chunk, 0, message.data_chunk.length) : options.bytes === Array ? Array.prototype.slice.call(message.data_chunk) : message.data_chunk;
        return object;
    };

    AlephiumTxAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return AlephiumTxAck;
})();

$root.AlephiumBytecodeRequest = (function() {

    function AlephiumBytecodeRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    AlephiumBytecodeRequest.prototype.data_length = 0;
    AlephiumBytecodeRequest.prototype.public_key = $util.newBuffer([]);
    AlephiumBytecodeRequest.prototype.signature = $util.newBuffer([]);

    AlephiumBytecodeRequest.create = function create(properties) {
        return new AlephiumBytecodeRequest(properties);
    };

    AlephiumBytecodeRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.data_length != null && Object.hasOwnProperty.call(message, "data_length"))
            writer.uint32(8).uint32(message.data_length);
        if (message.public_key != null && Object.hasOwnProperty.call(message, "public_key"))
            writer.uint32(18).bytes(message.public_key);
        if (message.signature != null && Object.hasOwnProperty.call(message, "signature"))
            writer.uint32(26).bytes(message.signature);
        return writer;
    };

    AlephiumBytecodeRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    AlephiumBytecodeRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.AlephiumBytecodeRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.data_length = reader.uint32();
                break;
            case 2:
                message.public_key = reader.bytes();
                break;
            case 3:
                message.signature = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    AlephiumBytecodeRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    AlephiumBytecodeRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.data_length != null && message.hasOwnProperty("data_length"))
            if (!$util.isInteger(message.data_length))
                return "data_length: integer expected";
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            if (!(message.public_key && typeof message.public_key.length === "number" || $util.isString(message.public_key)))
                return "public_key: buffer expected";
        if (message.signature != null && message.hasOwnProperty("signature"))
            if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
                return "signature: buffer expected";
        return null;
    };

    AlephiumBytecodeRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.AlephiumBytecodeRequest)
            return object;
        var message = new $root.AlephiumBytecodeRequest();
        if (object.data_length != null)
            message.data_length = object.data_length >>> 0;
        if (object.public_key != null)
            if (typeof object.public_key === "string")
                $util.base64.decode(object.public_key, message.public_key = $util.newBuffer($util.base64.length(object.public_key)), 0);
            else if (object.public_key.length)
                message.public_key = object.public_key;
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        return message;
    };

    AlephiumBytecodeRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.data_length = 0;
            if (options.bytes === String)
                object.public_key = "";
            else {
                object.public_key = [];
                if (options.bytes !== Array)
                    object.public_key = $util.newBuffer(object.public_key);
            }
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
        }
        if (message.data_length != null && message.hasOwnProperty("data_length"))
            object.data_length = message.data_length;
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            object.public_key = options.bytes === String ? $util.base64.encode(message.public_key, 0, message.public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.public_key) : message.public_key;
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        return object;
    };

    AlephiumBytecodeRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return AlephiumBytecodeRequest;
})();

$root.AlephiumBytecodeAck = (function() {

    function AlephiumBytecodeAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    AlephiumBytecodeAck.prototype.bytecode_data = $util.newBuffer([]);

    AlephiumBytecodeAck.create = function create(properties) {
        return new AlephiumBytecodeAck(properties);
    };

    AlephiumBytecodeAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.bytecode_data);
        return writer;
    };

    AlephiumBytecodeAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    AlephiumBytecodeAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.AlephiumBytecodeAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.bytecode_data = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("bytecode_data"))
            throw $util.ProtocolError("missing required 'bytecode_data'", { instance: message });
        return message;
    };

    AlephiumBytecodeAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    AlephiumBytecodeAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.bytecode_data && typeof message.bytecode_data.length === "number" || $util.isString(message.bytecode_data)))
            return "bytecode_data: buffer expected";
        return null;
    };

    AlephiumBytecodeAck.fromObject = function fromObject(object) {
        if (object instanceof $root.AlephiumBytecodeAck)
            return object;
        var message = new $root.AlephiumBytecodeAck();
        if (object.bytecode_data != null)
            if (typeof object.bytecode_data === "string")
                $util.base64.decode(object.bytecode_data, message.bytecode_data = $util.newBuffer($util.base64.length(object.bytecode_data)), 0);
            else if (object.bytecode_data.length)
                message.bytecode_data = object.bytecode_data;
        return message;
    };

    AlephiumBytecodeAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.bytecode_data = "";
            else {
                object.bytecode_data = [];
                if (options.bytes !== Array)
                    object.bytecode_data = $util.newBuffer(object.bytecode_data);
            }
        if (message.bytecode_data != null && message.hasOwnProperty("bytecode_data"))
            object.bytecode_data = options.bytes === String ? $util.base64.encode(message.bytecode_data, 0, message.bytecode_data.length) : options.bytes === Array ? Array.prototype.slice.call(message.bytecode_data) : message.bytecode_data;
        return object;
    };

    AlephiumBytecodeAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return AlephiumBytecodeAck;
})();

$root.AlephiumSignMessage = (function() {

    function AlephiumSignMessage(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    AlephiumSignMessage.prototype.address_n = $util.emptyArray;
    AlephiumSignMessage.prototype.message = $util.newBuffer([]);
    AlephiumSignMessage.prototype.message_type = $util.newBuffer([]);

    AlephiumSignMessage.create = function create(properties) {
        return new AlephiumSignMessage(properties);
    };

    AlephiumSignMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
            writer.uint32(18).bytes(message.message);
        if (message.message_type != null && Object.hasOwnProperty.call(message, "message_type"))
            writer.uint32(26).bytes(message.message_type);
        return writer;
    };

    AlephiumSignMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    AlephiumSignMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.AlephiumSignMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.message = reader.bytes();
                break;
            case 3:
                message.message_type = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    AlephiumSignMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    AlephiumSignMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.message != null && message.hasOwnProperty("message"))
            if (!(message.message && typeof message.message.length === "number" || $util.isString(message.message)))
                return "message: buffer expected";
        if (message.message_type != null && message.hasOwnProperty("message_type"))
            if (!(message.message_type && typeof message.message_type.length === "number" || $util.isString(message.message_type)))
                return "message_type: buffer expected";
        return null;
    };

    AlephiumSignMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.AlephiumSignMessage)
            return object;
        var message = new $root.AlephiumSignMessage();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".AlephiumSignMessage.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.message != null)
            if (typeof object.message === "string")
                $util.base64.decode(object.message, message.message = $util.newBuffer($util.base64.length(object.message)), 0);
            else if (object.message.length)
                message.message = object.message;
        if (object.message_type != null)
            if (typeof object.message_type === "string")
                $util.base64.decode(object.message_type, message.message_type = $util.newBuffer($util.base64.length(object.message_type)), 0);
            else if (object.message_type.length)
                message.message_type = object.message_type;
        return message;
    };

    AlephiumSignMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            if (options.bytes === String)
                object.message = "";
            else {
                object.message = [];
                if (options.bytes !== Array)
                    object.message = $util.newBuffer(object.message);
            }
            if (options.bytes === String)
                object.message_type = "";
            else {
                object.message_type = [];
                if (options.bytes !== Array)
                    object.message_type = $util.newBuffer(object.message_type);
            }
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.message != null && message.hasOwnProperty("message"))
            object.message = options.bytes === String ? $util.base64.encode(message.message, 0, message.message.length) : options.bytes === Array ? Array.prototype.slice.call(message.message) : message.message;
        if (message.message_type != null && message.hasOwnProperty("message_type"))
            object.message_type = options.bytes === String ? $util.base64.encode(message.message_type, 0, message.message_type.length) : options.bytes === Array ? Array.prototype.slice.call(message.message_type) : message.message_type;
        return object;
    };

    AlephiumSignMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return AlephiumSignMessage;
})();

$root.AlephiumMessageSignature = (function() {

    function AlephiumMessageSignature(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    AlephiumMessageSignature.prototype.signature = $util.newBuffer([]);
    AlephiumMessageSignature.prototype.address = "";

    AlephiumMessageSignature.create = function create(properties) {
        return new AlephiumMessageSignature(properties);
    };

    AlephiumMessageSignature.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.signature != null && Object.hasOwnProperty.call(message, "signature"))
            writer.uint32(10).bytes(message.signature);
        if (message.address != null && Object.hasOwnProperty.call(message, "address"))
            writer.uint32(18).string(message.address);
        return writer;
    };

    AlephiumMessageSignature.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    AlephiumMessageSignature.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.AlephiumMessageSignature();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.signature = reader.bytes();
                break;
            case 2:
                message.address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    AlephiumMessageSignature.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    AlephiumMessageSignature.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.signature != null && message.hasOwnProperty("signature"))
            if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
                return "signature: buffer expected";
        if (message.address != null && message.hasOwnProperty("address"))
            if (!$util.isString(message.address))
                return "address: string expected";
        return null;
    };

    AlephiumMessageSignature.fromObject = function fromObject(object) {
        if (object instanceof $root.AlephiumMessageSignature)
            return object;
        var message = new $root.AlephiumMessageSignature();
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        if (object.address != null)
            message.address = String(object.address);
        return message;
    };

    AlephiumMessageSignature.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
            object.address = "";
        }
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    AlephiumMessageSignature.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return AlephiumMessageSignature;
})();

$root.AlgorandGetAddress = (function() {

    function AlgorandGetAddress(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    AlgorandGetAddress.prototype.address_n = $util.emptyArray;
    AlgorandGetAddress.prototype.show_display = false;

    AlgorandGetAddress.create = function create(properties) {
        return new AlgorandGetAddress(properties);
    };

    AlgorandGetAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(24).bool(message.show_display);
        return writer;
    };

    AlgorandGetAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    AlgorandGetAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.AlgorandGetAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 3:
                message.show_display = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    AlgorandGetAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    AlgorandGetAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        return null;
    };

    AlgorandGetAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.AlgorandGetAddress)
            return object;
        var message = new $root.AlgorandGetAddress();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".AlgorandGetAddress.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        return message;
    };

    AlgorandGetAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            object.show_display = false;
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        return object;
    };

    AlgorandGetAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return AlgorandGetAddress;
})();

$root.AlgorandAddress = (function() {

    function AlgorandAddress(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    AlgorandAddress.prototype.address = "";

    AlgorandAddress.create = function create(properties) {
        return new AlgorandAddress(properties);
    };

    AlgorandAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address != null && Object.hasOwnProperty.call(message, "address"))
            writer.uint32(10).string(message.address);
        return writer;
    };

    AlgorandAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    AlgorandAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.AlgorandAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    AlgorandAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    AlgorandAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address != null && message.hasOwnProperty("address"))
            if (!$util.isString(message.address))
                return "address: string expected";
        return null;
    };

    AlgorandAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.AlgorandAddress)
            return object;
        var message = new $root.AlgorandAddress();
        if (object.address != null)
            message.address = String(object.address);
        return message;
    };

    AlgorandAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.address = "";
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    AlgorandAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return AlgorandAddress;
})();

$root.AlgorandSignTx = (function() {

    function AlgorandSignTx(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    AlgorandSignTx.prototype.address_n = $util.emptyArray;
    AlgorandSignTx.prototype.raw_tx = $util.newBuffer([]);

    AlgorandSignTx.create = function create(properties) {
        return new AlgorandSignTx(properties);
    };

    AlgorandSignTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).bytes(message.raw_tx);
        return writer;
    };

    AlgorandSignTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    AlgorandSignTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.AlgorandSignTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.raw_tx = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("raw_tx"))
            throw $util.ProtocolError("missing required 'raw_tx'", { instance: message });
        return message;
    };

    AlgorandSignTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    AlgorandSignTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!(message.raw_tx && typeof message.raw_tx.length === "number" || $util.isString(message.raw_tx)))
            return "raw_tx: buffer expected";
        return null;
    };

    AlgorandSignTx.fromObject = function fromObject(object) {
        if (object instanceof $root.AlgorandSignTx)
            return object;
        var message = new $root.AlgorandSignTx();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".AlgorandSignTx.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.raw_tx != null)
            if (typeof object.raw_tx === "string")
                $util.base64.decode(object.raw_tx, message.raw_tx = $util.newBuffer($util.base64.length(object.raw_tx)), 0);
            else if (object.raw_tx.length)
                message.raw_tx = object.raw_tx;
        return message;
    };

    AlgorandSignTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            if (options.bytes === String)
                object.raw_tx = "";
            else {
                object.raw_tx = [];
                if (options.bytes !== Array)
                    object.raw_tx = $util.newBuffer(object.raw_tx);
            }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.raw_tx != null && message.hasOwnProperty("raw_tx"))
            object.raw_tx = options.bytes === String ? $util.base64.encode(message.raw_tx, 0, message.raw_tx.length) : options.bytes === Array ? Array.prototype.slice.call(message.raw_tx) : message.raw_tx;
        return object;
    };

    AlgorandSignTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return AlgorandSignTx;
})();

$root.AlgorandSignedTx = (function() {

    function AlgorandSignedTx(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    AlgorandSignedTx.prototype.signature = $util.newBuffer([]);

    AlgorandSignedTx.create = function create(properties) {
        return new AlgorandSignedTx(properties);
    };

    AlgorandSignedTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.signature);
        return writer;
    };

    AlgorandSignedTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    AlgorandSignedTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.AlgorandSignedTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.signature = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        return message;
    };

    AlgorandSignedTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    AlgorandSignedTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        return null;
    };

    AlgorandSignedTx.fromObject = function fromObject(object) {
        if (object instanceof $root.AlgorandSignedTx)
            return object;
        var message = new $root.AlgorandSignedTx();
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        return message;
    };

    AlgorandSignedTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        return object;
    };

    AlgorandSignedTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return AlgorandSignedTx;
})();

$root.AptosTransactionType = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "STANDARD"] = 0;
    values[valuesById[1] = "WITH_DATA"] = 1;
    return values;
})();

$root.AptosGetAddress = (function() {

    function AptosGetAddress(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    AptosGetAddress.prototype.address_n = $util.emptyArray;
    AptosGetAddress.prototype.show_display = false;

    AptosGetAddress.create = function create(properties) {
        return new AptosGetAddress(properties);
    };

    AptosGetAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(16).bool(message.show_display);
        return writer;
    };

    AptosGetAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    AptosGetAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.AptosGetAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.show_display = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    AptosGetAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    AptosGetAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        return null;
    };

    AptosGetAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.AptosGetAddress)
            return object;
        var message = new $root.AptosGetAddress();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".AptosGetAddress.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        return message;
    };

    AptosGetAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            object.show_display = false;
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        return object;
    };

    AptosGetAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return AptosGetAddress;
})();

$root.AptosAddress = (function() {

    function AptosAddress(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    AptosAddress.prototype.address = "";

    AptosAddress.create = function create(properties) {
        return new AptosAddress(properties);
    };

    AptosAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address != null && Object.hasOwnProperty.call(message, "address"))
            writer.uint32(10).string(message.address);
        return writer;
    };

    AptosAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    AptosAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.AptosAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    AptosAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    AptosAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address != null && message.hasOwnProperty("address"))
            if (!$util.isString(message.address))
                return "address: string expected";
        return null;
    };

    AptosAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.AptosAddress)
            return object;
        var message = new $root.AptosAddress();
        if (object.address != null)
            message.address = String(object.address);
        return message;
    };

    AptosAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.address = "";
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    AptosAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return AptosAddress;
})();

$root.AptosSignTx = (function() {

    function AptosSignTx(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    AptosSignTx.prototype.address_n = $util.emptyArray;
    AptosSignTx.prototype.raw_tx = $util.newBuffer([]);
    AptosSignTx.prototype.tx_type = 0;

    AptosSignTx.create = function create(properties) {
        return new AptosSignTx(properties);
    };

    AptosSignTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).bytes(message.raw_tx);
        if (message.tx_type != null && Object.hasOwnProperty.call(message, "tx_type"))
            writer.uint32(24).int32(message.tx_type);
        return writer;
    };

    AptosSignTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    AptosSignTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.AptosSignTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.raw_tx = reader.bytes();
                break;
            case 3:
                message.tx_type = reader.int32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("raw_tx"))
            throw $util.ProtocolError("missing required 'raw_tx'", { instance: message });
        return message;
    };

    AptosSignTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    AptosSignTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!(message.raw_tx && typeof message.raw_tx.length === "number" || $util.isString(message.raw_tx)))
            return "raw_tx: buffer expected";
        if (message.tx_type != null && message.hasOwnProperty("tx_type"))
            switch (message.tx_type) {
            default:
                return "tx_type: enum value expected";
            case 0:
            case 1:
                break;
            }
        return null;
    };

    AptosSignTx.fromObject = function fromObject(object) {
        if (object instanceof $root.AptosSignTx)
            return object;
        var message = new $root.AptosSignTx();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".AptosSignTx.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.raw_tx != null)
            if (typeof object.raw_tx === "string")
                $util.base64.decode(object.raw_tx, message.raw_tx = $util.newBuffer($util.base64.length(object.raw_tx)), 0);
            else if (object.raw_tx.length)
                message.raw_tx = object.raw_tx;
        switch (object.tx_type) {
        case "STANDARD":
        case 0:
            message.tx_type = 0;
            break;
        case "WITH_DATA":
        case 1:
            message.tx_type = 1;
            break;
        }
        return message;
    };

    AptosSignTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            if (options.bytes === String)
                object.raw_tx = "";
            else {
                object.raw_tx = [];
                if (options.bytes !== Array)
                    object.raw_tx = $util.newBuffer(object.raw_tx);
            }
            object.tx_type = options.enums === String ? "STANDARD" : 0;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.raw_tx != null && message.hasOwnProperty("raw_tx"))
            object.raw_tx = options.bytes === String ? $util.base64.encode(message.raw_tx, 0, message.raw_tx.length) : options.bytes === Array ? Array.prototype.slice.call(message.raw_tx) : message.raw_tx;
        if (message.tx_type != null && message.hasOwnProperty("tx_type"))
            object.tx_type = options.enums === String ? $root.AptosTransactionType[message.tx_type] : message.tx_type;
        return object;
    };

    AptosSignTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return AptosSignTx;
})();

$root.AptosSignedTx = (function() {

    function AptosSignedTx(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    AptosSignedTx.prototype.public_key = $util.newBuffer([]);
    AptosSignedTx.prototype.signature = $util.newBuffer([]);

    AptosSignedTx.create = function create(properties) {
        return new AptosSignedTx(properties);
    };

    AptosSignedTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.public_key);
        writer.uint32(18).bytes(message.signature);
        return writer;
    };

    AptosSignedTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    AptosSignedTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.AptosSignedTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.public_key = reader.bytes();
                break;
            case 2:
                message.signature = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("public_key"))
            throw $util.ProtocolError("missing required 'public_key'", { instance: message });
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        return message;
    };

    AptosSignedTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    AptosSignedTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.public_key && typeof message.public_key.length === "number" || $util.isString(message.public_key)))
            return "public_key: buffer expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        return null;
    };

    AptosSignedTx.fromObject = function fromObject(object) {
        if (object instanceof $root.AptosSignedTx)
            return object;
        var message = new $root.AptosSignedTx();
        if (object.public_key != null)
            if (typeof object.public_key === "string")
                $util.base64.decode(object.public_key, message.public_key = $util.newBuffer($util.base64.length(object.public_key)), 0);
            else if (object.public_key.length)
                message.public_key = object.public_key;
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        return message;
    };

    AptosSignedTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.public_key = "";
            else {
                object.public_key = [];
                if (options.bytes !== Array)
                    object.public_key = $util.newBuffer(object.public_key);
            }
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
        }
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            object.public_key = options.bytes === String ? $util.base64.encode(message.public_key, 0, message.public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.public_key) : message.public_key;
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        return object;
    };

    AptosSignedTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return AptosSignedTx;
})();

$root.AptosSignMessage = (function() {

    function AptosSignMessage(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    AptosSignMessage.prototype.address_n = $util.emptyArray;
    AptosSignMessage.prototype.payload = null;

    AptosSignMessage.create = function create(properties) {
        return new AptosSignMessage(properties);
    };

    AptosSignMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        $root.AptosSignMessage.AptosMessagePayload.encode(message.payload, writer.uint32(18).fork()).ldelim();
        return writer;
    };

    AptosSignMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    AptosSignMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.AptosSignMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.payload = $root.AptosSignMessage.AptosMessagePayload.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("payload"))
            throw $util.ProtocolError("missing required 'payload'", { instance: message });
        return message;
    };

    AptosSignMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    AptosSignMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        {
            var error = $root.AptosSignMessage.AptosMessagePayload.verify(message.payload);
            if (error)
                return "payload." + error;
        }
        return null;
    };

    AptosSignMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.AptosSignMessage)
            return object;
        var message = new $root.AptosSignMessage();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".AptosSignMessage.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.payload != null) {
            if (typeof object.payload !== "object")
                throw TypeError(".AptosSignMessage.payload: object expected");
            message.payload = $root.AptosSignMessage.AptosMessagePayload.fromObject(object.payload);
        }
        return message;
    };

    AptosSignMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            object.payload = null;
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.payload != null && message.hasOwnProperty("payload"))
            object.payload = $root.AptosSignMessage.AptosMessagePayload.toObject(message.payload, options);
        return object;
    };

    AptosSignMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    AptosSignMessage.AptosMessagePayload = (function() {

        function AptosMessagePayload(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        AptosMessagePayload.prototype.address = "";
        AptosMessagePayload.prototype.chain_id = "";
        AptosMessagePayload.prototype.application = "";
        AptosMessagePayload.prototype.nonce = "";
        AptosMessagePayload.prototype.message = "";

        AptosMessagePayload.create = function create(properties) {
            return new AptosMessagePayload(properties);
        };

        AptosMessagePayload.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.address != null && Object.hasOwnProperty.call(message, "address"))
                writer.uint32(18).string(message.address);
            if (message.chain_id != null && Object.hasOwnProperty.call(message, "chain_id"))
                writer.uint32(26).string(message.chain_id);
            if (message.application != null && Object.hasOwnProperty.call(message, "application"))
                writer.uint32(34).string(message.application);
            writer.uint32(42).string(message.nonce);
            writer.uint32(50).string(message.message);
            return writer;
        };

        AptosMessagePayload.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        AptosMessagePayload.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.AptosSignMessage.AptosMessagePayload();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 2:
                    message.address = reader.string();
                    break;
                case 3:
                    message.chain_id = reader.string();
                    break;
                case 4:
                    message.application = reader.string();
                    break;
                case 5:
                    message.nonce = reader.string();
                    break;
                case 6:
                    message.message = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("nonce"))
                throw $util.ProtocolError("missing required 'nonce'", { instance: message });
            if (!message.hasOwnProperty("message"))
                throw $util.ProtocolError("missing required 'message'", { instance: message });
            return message;
        };

        AptosMessagePayload.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        AptosMessagePayload.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.address != null && message.hasOwnProperty("address"))
                if (!$util.isString(message.address))
                    return "address: string expected";
            if (message.chain_id != null && message.hasOwnProperty("chain_id"))
                if (!$util.isString(message.chain_id))
                    return "chain_id: string expected";
            if (message.application != null && message.hasOwnProperty("application"))
                if (!$util.isString(message.application))
                    return "application: string expected";
            if (!$util.isString(message.nonce))
                return "nonce: string expected";
            if (!$util.isString(message.message))
                return "message: string expected";
            return null;
        };

        AptosMessagePayload.fromObject = function fromObject(object) {
            if (object instanceof $root.AptosSignMessage.AptosMessagePayload)
                return object;
            var message = new $root.AptosSignMessage.AptosMessagePayload();
            if (object.address != null)
                message.address = String(object.address);
            if (object.chain_id != null)
                message.chain_id = String(object.chain_id);
            if (object.application != null)
                message.application = String(object.application);
            if (object.nonce != null)
                message.nonce = String(object.nonce);
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        AptosMessagePayload.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.address = "";
                object.chain_id = "";
                object.application = "";
                object.nonce = "";
                object.message = "";
            }
            if (message.address != null && message.hasOwnProperty("address"))
                object.address = message.address;
            if (message.chain_id != null && message.hasOwnProperty("chain_id"))
                object.chain_id = message.chain_id;
            if (message.application != null && message.hasOwnProperty("application"))
                object.application = message.application;
            if (message.nonce != null && message.hasOwnProperty("nonce"))
                object.nonce = message.nonce;
            if (message.message != null && message.hasOwnProperty("message"))
                object.message = message.message;
            return object;
        };

        AptosMessagePayload.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AptosMessagePayload;
    })();

    return AptosSignMessage;
})();

$root.AptosSignSIWAMessage = (function() {

    function AptosSignSIWAMessage(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    AptosSignSIWAMessage.prototype.address_n = $util.emptyArray;
    AptosSignSIWAMessage.prototype.siwa_payload = "";

    AptosSignSIWAMessage.create = function create(properties) {
        return new AptosSignSIWAMessage(properties);
    };

    AptosSignSIWAMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).string(message.siwa_payload);
        return writer;
    };

    AptosSignSIWAMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    AptosSignSIWAMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.AptosSignSIWAMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.siwa_payload = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("siwa_payload"))
            throw $util.ProtocolError("missing required 'siwa_payload'", { instance: message });
        return message;
    };

    AptosSignSIWAMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    AptosSignSIWAMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!$util.isString(message.siwa_payload))
            return "siwa_payload: string expected";
        return null;
    };

    AptosSignSIWAMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.AptosSignSIWAMessage)
            return object;
        var message = new $root.AptosSignSIWAMessage();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".AptosSignSIWAMessage.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.siwa_payload != null)
            message.siwa_payload = String(object.siwa_payload);
        return message;
    };

    AptosSignSIWAMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            object.siwa_payload = "";
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.siwa_payload != null && message.hasOwnProperty("siwa_payload"))
            object.siwa_payload = message.siwa_payload;
        return object;
    };

    AptosSignSIWAMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return AptosSignSIWAMessage;
})();

$root.AptosMessageSignature = (function() {

    function AptosMessageSignature(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    AptosMessageSignature.prototype.signature = $util.newBuffer([]);
    AptosMessageSignature.prototype.address = "";

    AptosMessageSignature.create = function create(properties) {
        return new AptosMessageSignature(properties);
    };

    AptosMessageSignature.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.signature);
        writer.uint32(18).string(message.address);
        return writer;
    };

    AptosMessageSignature.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    AptosMessageSignature.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.AptosMessageSignature();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.signature = reader.bytes();
                break;
            case 2:
                message.address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        if (!message.hasOwnProperty("address"))
            throw $util.ProtocolError("missing required 'address'", { instance: message });
        return message;
    };

    AptosMessageSignature.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    AptosMessageSignature.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        if (!$util.isString(message.address))
            return "address: string expected";
        return null;
    };

    AptosMessageSignature.fromObject = function fromObject(object) {
        if (object instanceof $root.AptosMessageSignature)
            return object;
        var message = new $root.AptosMessageSignature();
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        if (object.address != null)
            message.address = String(object.address);
        return message;
    };

    AptosMessageSignature.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
            object.address = "";
        }
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    AptosMessageSignature.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return AptosMessageSignature;
})();

$root.BenfenGetAddress = (function() {

    function BenfenGetAddress(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    BenfenGetAddress.prototype.address_n = $util.emptyArray;
    BenfenGetAddress.prototype.show_display = false;

    BenfenGetAddress.create = function create(properties) {
        return new BenfenGetAddress(properties);
    };

    BenfenGetAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(16).bool(message.show_display);
        return writer;
    };

    BenfenGetAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    BenfenGetAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BenfenGetAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.show_display = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    BenfenGetAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    BenfenGetAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        return null;
    };

    BenfenGetAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.BenfenGetAddress)
            return object;
        var message = new $root.BenfenGetAddress();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".BenfenGetAddress.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        return message;
    };

    BenfenGetAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            object.show_display = false;
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        return object;
    };

    BenfenGetAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return BenfenGetAddress;
})();

$root.BenfenAddress = (function() {

    function BenfenAddress(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    BenfenAddress.prototype.address = "";

    BenfenAddress.create = function create(properties) {
        return new BenfenAddress(properties);
    };

    BenfenAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address != null && Object.hasOwnProperty.call(message, "address"))
            writer.uint32(10).string(message.address);
        return writer;
    };

    BenfenAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    BenfenAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BenfenAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    BenfenAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    BenfenAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address != null && message.hasOwnProperty("address"))
            if (!$util.isString(message.address))
                return "address: string expected";
        return null;
    };

    BenfenAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.BenfenAddress)
            return object;
        var message = new $root.BenfenAddress();
        if (object.address != null)
            message.address = String(object.address);
        return message;
    };

    BenfenAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.address = "";
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    BenfenAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return BenfenAddress;
})();

$root.BenfenSignTx = (function() {

    function BenfenSignTx(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    BenfenSignTx.prototype.address_n = $util.emptyArray;
    BenfenSignTx.prototype.raw_tx = $util.newBuffer([]);
    BenfenSignTx.prototype.data_initial_chunk = $util.newBuffer([]);
    BenfenSignTx.prototype.coin_type = $util.newBuffer([]);
    BenfenSignTx.prototype.data_length = 0;

    BenfenSignTx.create = function create(properties) {
        return new BenfenSignTx(properties);
    };

    BenfenSignTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).bytes(message.raw_tx);
        if (message.data_initial_chunk != null && Object.hasOwnProperty.call(message, "data_initial_chunk"))
            writer.uint32(26).bytes(message.data_initial_chunk);
        if (message.coin_type != null && Object.hasOwnProperty.call(message, "coin_type"))
            writer.uint32(34).bytes(message.coin_type);
        if (message.data_length != null && Object.hasOwnProperty.call(message, "data_length"))
            writer.uint32(40).uint32(message.data_length);
        return writer;
    };

    BenfenSignTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    BenfenSignTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BenfenSignTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.raw_tx = reader.bytes();
                break;
            case 3:
                message.data_initial_chunk = reader.bytes();
                break;
            case 4:
                message.coin_type = reader.bytes();
                break;
            case 5:
                message.data_length = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("raw_tx"))
            throw $util.ProtocolError("missing required 'raw_tx'", { instance: message });
        return message;
    };

    BenfenSignTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    BenfenSignTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!(message.raw_tx && typeof message.raw_tx.length === "number" || $util.isString(message.raw_tx)))
            return "raw_tx: buffer expected";
        if (message.data_initial_chunk != null && message.hasOwnProperty("data_initial_chunk"))
            if (!(message.data_initial_chunk && typeof message.data_initial_chunk.length === "number" || $util.isString(message.data_initial_chunk)))
                return "data_initial_chunk: buffer expected";
        if (message.coin_type != null && message.hasOwnProperty("coin_type"))
            if (!(message.coin_type && typeof message.coin_type.length === "number" || $util.isString(message.coin_type)))
                return "coin_type: buffer expected";
        if (message.data_length != null && message.hasOwnProperty("data_length"))
            if (!$util.isInteger(message.data_length))
                return "data_length: integer expected";
        return null;
    };

    BenfenSignTx.fromObject = function fromObject(object) {
        if (object instanceof $root.BenfenSignTx)
            return object;
        var message = new $root.BenfenSignTx();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".BenfenSignTx.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.raw_tx != null)
            if (typeof object.raw_tx === "string")
                $util.base64.decode(object.raw_tx, message.raw_tx = $util.newBuffer($util.base64.length(object.raw_tx)), 0);
            else if (object.raw_tx.length)
                message.raw_tx = object.raw_tx;
        if (object.data_initial_chunk != null)
            if (typeof object.data_initial_chunk === "string")
                $util.base64.decode(object.data_initial_chunk, message.data_initial_chunk = $util.newBuffer($util.base64.length(object.data_initial_chunk)), 0);
            else if (object.data_initial_chunk.length)
                message.data_initial_chunk = object.data_initial_chunk;
        if (object.coin_type != null)
            if (typeof object.coin_type === "string")
                $util.base64.decode(object.coin_type, message.coin_type = $util.newBuffer($util.base64.length(object.coin_type)), 0);
            else if (object.coin_type.length)
                message.coin_type = object.coin_type;
        if (object.data_length != null)
            message.data_length = object.data_length >>> 0;
        return message;
    };

    BenfenSignTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            if (options.bytes === String)
                object.raw_tx = "";
            else {
                object.raw_tx = [];
                if (options.bytes !== Array)
                    object.raw_tx = $util.newBuffer(object.raw_tx);
            }
            if (options.bytes === String)
                object.data_initial_chunk = "";
            else {
                object.data_initial_chunk = [];
                if (options.bytes !== Array)
                    object.data_initial_chunk = $util.newBuffer(object.data_initial_chunk);
            }
            if (options.bytes === String)
                object.coin_type = "";
            else {
                object.coin_type = [];
                if (options.bytes !== Array)
                    object.coin_type = $util.newBuffer(object.coin_type);
            }
            object.data_length = 0;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.raw_tx != null && message.hasOwnProperty("raw_tx"))
            object.raw_tx = options.bytes === String ? $util.base64.encode(message.raw_tx, 0, message.raw_tx.length) : options.bytes === Array ? Array.prototype.slice.call(message.raw_tx) : message.raw_tx;
        if (message.data_initial_chunk != null && message.hasOwnProperty("data_initial_chunk"))
            object.data_initial_chunk = options.bytes === String ? $util.base64.encode(message.data_initial_chunk, 0, message.data_initial_chunk.length) : options.bytes === Array ? Array.prototype.slice.call(message.data_initial_chunk) : message.data_initial_chunk;
        if (message.coin_type != null && message.hasOwnProperty("coin_type"))
            object.coin_type = options.bytes === String ? $util.base64.encode(message.coin_type, 0, message.coin_type.length) : options.bytes === Array ? Array.prototype.slice.call(message.coin_type) : message.coin_type;
        if (message.data_length != null && message.hasOwnProperty("data_length"))
            object.data_length = message.data_length;
        return object;
    };

    BenfenSignTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return BenfenSignTx;
})();

$root.BenfenSignedTx = (function() {

    function BenfenSignedTx(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    BenfenSignedTx.prototype.public_key = $util.newBuffer([]);
    BenfenSignedTx.prototype.signature = $util.newBuffer([]);

    BenfenSignedTx.create = function create(properties) {
        return new BenfenSignedTx(properties);
    };

    BenfenSignedTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.public_key);
        writer.uint32(18).bytes(message.signature);
        return writer;
    };

    BenfenSignedTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    BenfenSignedTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BenfenSignedTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.public_key = reader.bytes();
                break;
            case 2:
                message.signature = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("public_key"))
            throw $util.ProtocolError("missing required 'public_key'", { instance: message });
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        return message;
    };

    BenfenSignedTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    BenfenSignedTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.public_key && typeof message.public_key.length === "number" || $util.isString(message.public_key)))
            return "public_key: buffer expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        return null;
    };

    BenfenSignedTx.fromObject = function fromObject(object) {
        if (object instanceof $root.BenfenSignedTx)
            return object;
        var message = new $root.BenfenSignedTx();
        if (object.public_key != null)
            if (typeof object.public_key === "string")
                $util.base64.decode(object.public_key, message.public_key = $util.newBuffer($util.base64.length(object.public_key)), 0);
            else if (object.public_key.length)
                message.public_key = object.public_key;
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        return message;
    };

    BenfenSignedTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.public_key = "";
            else {
                object.public_key = [];
                if (options.bytes !== Array)
                    object.public_key = $util.newBuffer(object.public_key);
            }
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
        }
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            object.public_key = options.bytes === String ? $util.base64.encode(message.public_key, 0, message.public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.public_key) : message.public_key;
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        return object;
    };

    BenfenSignedTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return BenfenSignedTx;
})();

$root.BenfenTxRequest = (function() {

    function BenfenTxRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    BenfenTxRequest.prototype.data_length = 0;
    BenfenTxRequest.prototype.public_key = $util.newBuffer([]);
    BenfenTxRequest.prototype.signature = $util.newBuffer([]);

    BenfenTxRequest.create = function create(properties) {
        return new BenfenTxRequest(properties);
    };

    BenfenTxRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.data_length != null && Object.hasOwnProperty.call(message, "data_length"))
            writer.uint32(8).uint32(message.data_length);
        if (message.public_key != null && Object.hasOwnProperty.call(message, "public_key"))
            writer.uint32(18).bytes(message.public_key);
        if (message.signature != null && Object.hasOwnProperty.call(message, "signature"))
            writer.uint32(26).bytes(message.signature);
        return writer;
    };

    BenfenTxRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    BenfenTxRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BenfenTxRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.data_length = reader.uint32();
                break;
            case 2:
                message.public_key = reader.bytes();
                break;
            case 3:
                message.signature = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    BenfenTxRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    BenfenTxRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.data_length != null && message.hasOwnProperty("data_length"))
            if (!$util.isInteger(message.data_length))
                return "data_length: integer expected";
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            if (!(message.public_key && typeof message.public_key.length === "number" || $util.isString(message.public_key)))
                return "public_key: buffer expected";
        if (message.signature != null && message.hasOwnProperty("signature"))
            if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
                return "signature: buffer expected";
        return null;
    };

    BenfenTxRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.BenfenTxRequest)
            return object;
        var message = new $root.BenfenTxRequest();
        if (object.data_length != null)
            message.data_length = object.data_length >>> 0;
        if (object.public_key != null)
            if (typeof object.public_key === "string")
                $util.base64.decode(object.public_key, message.public_key = $util.newBuffer($util.base64.length(object.public_key)), 0);
            else if (object.public_key.length)
                message.public_key = object.public_key;
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        return message;
    };

    BenfenTxRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.data_length = 0;
            if (options.bytes === String)
                object.public_key = "";
            else {
                object.public_key = [];
                if (options.bytes !== Array)
                    object.public_key = $util.newBuffer(object.public_key);
            }
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
        }
        if (message.data_length != null && message.hasOwnProperty("data_length"))
            object.data_length = message.data_length;
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            object.public_key = options.bytes === String ? $util.base64.encode(message.public_key, 0, message.public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.public_key) : message.public_key;
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        return object;
    };

    BenfenTxRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return BenfenTxRequest;
})();

$root.BenfenTxAck = (function() {

    function BenfenTxAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    BenfenTxAck.prototype.data_chunk = $util.newBuffer([]);

    BenfenTxAck.create = function create(properties) {
        return new BenfenTxAck(properties);
    };

    BenfenTxAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.data_chunk);
        return writer;
    };

    BenfenTxAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    BenfenTxAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BenfenTxAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.data_chunk = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("data_chunk"))
            throw $util.ProtocolError("missing required 'data_chunk'", { instance: message });
        return message;
    };

    BenfenTxAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    BenfenTxAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.data_chunk && typeof message.data_chunk.length === "number" || $util.isString(message.data_chunk)))
            return "data_chunk: buffer expected";
        return null;
    };

    BenfenTxAck.fromObject = function fromObject(object) {
        if (object instanceof $root.BenfenTxAck)
            return object;
        var message = new $root.BenfenTxAck();
        if (object.data_chunk != null)
            if (typeof object.data_chunk === "string")
                $util.base64.decode(object.data_chunk, message.data_chunk = $util.newBuffer($util.base64.length(object.data_chunk)), 0);
            else if (object.data_chunk.length)
                message.data_chunk = object.data_chunk;
        return message;
    };

    BenfenTxAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.data_chunk = "";
            else {
                object.data_chunk = [];
                if (options.bytes !== Array)
                    object.data_chunk = $util.newBuffer(object.data_chunk);
            }
        if (message.data_chunk != null && message.hasOwnProperty("data_chunk"))
            object.data_chunk = options.bytes === String ? $util.base64.encode(message.data_chunk, 0, message.data_chunk.length) : options.bytes === Array ? Array.prototype.slice.call(message.data_chunk) : message.data_chunk;
        return object;
    };

    BenfenTxAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return BenfenTxAck;
})();

$root.BenfenSignMessage = (function() {

    function BenfenSignMessage(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    BenfenSignMessage.prototype.address_n = $util.emptyArray;
    BenfenSignMessage.prototype.message = $util.newBuffer([]);

    BenfenSignMessage.create = function create(properties) {
        return new BenfenSignMessage(properties);
    };

    BenfenSignMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).bytes(message.message);
        return writer;
    };

    BenfenSignMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    BenfenSignMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BenfenSignMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.message = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("message"))
            throw $util.ProtocolError("missing required 'message'", { instance: message });
        return message;
    };

    BenfenSignMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    BenfenSignMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!(message.message && typeof message.message.length === "number" || $util.isString(message.message)))
            return "message: buffer expected";
        return null;
    };

    BenfenSignMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.BenfenSignMessage)
            return object;
        var message = new $root.BenfenSignMessage();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".BenfenSignMessage.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.message != null)
            if (typeof object.message === "string")
                $util.base64.decode(object.message, message.message = $util.newBuffer($util.base64.length(object.message)), 0);
            else if (object.message.length)
                message.message = object.message;
        return message;
    };

    BenfenSignMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            if (options.bytes === String)
                object.message = "";
            else {
                object.message = [];
                if (options.bytes !== Array)
                    object.message = $util.newBuffer(object.message);
            }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.message != null && message.hasOwnProperty("message"))
            object.message = options.bytes === String ? $util.base64.encode(message.message, 0, message.message.length) : options.bytes === Array ? Array.prototype.slice.call(message.message) : message.message;
        return object;
    };

    BenfenSignMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return BenfenSignMessage;
})();

$root.BenfenMessageSignature = (function() {

    function BenfenMessageSignature(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    BenfenMessageSignature.prototype.signature = $util.newBuffer([]);
    BenfenMessageSignature.prototype.address = "";

    BenfenMessageSignature.create = function create(properties) {
        return new BenfenMessageSignature(properties);
    };

    BenfenMessageSignature.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.signature);
        writer.uint32(18).string(message.address);
        return writer;
    };

    BenfenMessageSignature.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    BenfenMessageSignature.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BenfenMessageSignature();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.signature = reader.bytes();
                break;
            case 2:
                message.address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        if (!message.hasOwnProperty("address"))
            throw $util.ProtocolError("missing required 'address'", { instance: message });
        return message;
    };

    BenfenMessageSignature.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    BenfenMessageSignature.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        if (!$util.isString(message.address))
            return "address: string expected";
        return null;
    };

    BenfenMessageSignature.fromObject = function fromObject(object) {
        if (object instanceof $root.BenfenMessageSignature)
            return object;
        var message = new $root.BenfenMessageSignature();
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        if (object.address != null)
            message.address = String(object.address);
        return message;
    };

    BenfenMessageSignature.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
            object.address = "";
        }
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    BenfenMessageSignature.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return BenfenMessageSignature;
})();

$root.BinanceGetAddress = (function() {

    function BinanceGetAddress(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    BinanceGetAddress.prototype.address_n = $util.emptyArray;
    BinanceGetAddress.prototype.show_display = false;

    BinanceGetAddress.create = function create(properties) {
        return new BinanceGetAddress(properties);
    };

    BinanceGetAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(16).bool(message.show_display);
        return writer;
    };

    BinanceGetAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    BinanceGetAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BinanceGetAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.show_display = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    BinanceGetAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    BinanceGetAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        return null;
    };

    BinanceGetAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.BinanceGetAddress)
            return object;
        var message = new $root.BinanceGetAddress();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".BinanceGetAddress.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        return message;
    };

    BinanceGetAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            object.show_display = false;
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        return object;
    };

    BinanceGetAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return BinanceGetAddress;
})();

$root.BinanceAddress = (function() {

    function BinanceAddress(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    BinanceAddress.prototype.address = "";

    BinanceAddress.create = function create(properties) {
        return new BinanceAddress(properties);
    };

    BinanceAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.address);
        return writer;
    };

    BinanceAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    BinanceAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BinanceAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("address"))
            throw $util.ProtocolError("missing required 'address'", { instance: message });
        return message;
    };

    BinanceAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    BinanceAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.address))
            return "address: string expected";
        return null;
    };

    BinanceAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.BinanceAddress)
            return object;
        var message = new $root.BinanceAddress();
        if (object.address != null)
            message.address = String(object.address);
        return message;
    };

    BinanceAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.address = "";
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    BinanceAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return BinanceAddress;
})();

$root.BinanceGetPublicKey = (function() {

    function BinanceGetPublicKey(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    BinanceGetPublicKey.prototype.address_n = $util.emptyArray;
    BinanceGetPublicKey.prototype.show_display = false;

    BinanceGetPublicKey.create = function create(properties) {
        return new BinanceGetPublicKey(properties);
    };

    BinanceGetPublicKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(16).bool(message.show_display);
        return writer;
    };

    BinanceGetPublicKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    BinanceGetPublicKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BinanceGetPublicKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.show_display = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    BinanceGetPublicKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    BinanceGetPublicKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        return null;
    };

    BinanceGetPublicKey.fromObject = function fromObject(object) {
        if (object instanceof $root.BinanceGetPublicKey)
            return object;
        var message = new $root.BinanceGetPublicKey();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".BinanceGetPublicKey.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        return message;
    };

    BinanceGetPublicKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            object.show_display = false;
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        return object;
    };

    BinanceGetPublicKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return BinanceGetPublicKey;
})();

$root.BinancePublicKey = (function() {

    function BinancePublicKey(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    BinancePublicKey.prototype.public_key = $util.newBuffer([]);

    BinancePublicKey.create = function create(properties) {
        return new BinancePublicKey(properties);
    };

    BinancePublicKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.public_key);
        return writer;
    };

    BinancePublicKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    BinancePublicKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BinancePublicKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.public_key = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("public_key"))
            throw $util.ProtocolError("missing required 'public_key'", { instance: message });
        return message;
    };

    BinancePublicKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    BinancePublicKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.public_key && typeof message.public_key.length === "number" || $util.isString(message.public_key)))
            return "public_key: buffer expected";
        return null;
    };

    BinancePublicKey.fromObject = function fromObject(object) {
        if (object instanceof $root.BinancePublicKey)
            return object;
        var message = new $root.BinancePublicKey();
        if (object.public_key != null)
            if (typeof object.public_key === "string")
                $util.base64.decode(object.public_key, message.public_key = $util.newBuffer($util.base64.length(object.public_key)), 0);
            else if (object.public_key.length)
                message.public_key = object.public_key;
        return message;
    };

    BinancePublicKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.public_key = "";
            else {
                object.public_key = [];
                if (options.bytes !== Array)
                    object.public_key = $util.newBuffer(object.public_key);
            }
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            object.public_key = options.bytes === String ? $util.base64.encode(message.public_key, 0, message.public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.public_key) : message.public_key;
        return object;
    };

    BinancePublicKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return BinancePublicKey;
})();

$root.BinanceSignTx = (function() {

    function BinanceSignTx(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    BinanceSignTx.prototype.address_n = $util.emptyArray;
    BinanceSignTx.prototype.msg_count = 0;
    BinanceSignTx.prototype.account_number = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    BinanceSignTx.prototype.chain_id = "";
    BinanceSignTx.prototype.memo = "";
    BinanceSignTx.prototype.sequence = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    BinanceSignTx.prototype.source = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    BinanceSignTx.create = function create(properties) {
        return new BinanceSignTx(properties);
    };

    BinanceSignTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(16).uint32(message.msg_count);
        writer.uint32(24).sint64(message.account_number);
        if (message.chain_id != null && Object.hasOwnProperty.call(message, "chain_id"))
            writer.uint32(34).string(message.chain_id);
        if (message.memo != null && Object.hasOwnProperty.call(message, "memo"))
            writer.uint32(42).string(message.memo);
        writer.uint32(48).sint64(message.sequence);
        writer.uint32(56).sint64(message.source);
        return writer;
    };

    BinanceSignTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    BinanceSignTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BinanceSignTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.msg_count = reader.uint32();
                break;
            case 3:
                message.account_number = reader.sint64();
                break;
            case 4:
                message.chain_id = reader.string();
                break;
            case 5:
                message.memo = reader.string();
                break;
            case 6:
                message.sequence = reader.sint64();
                break;
            case 7:
                message.source = reader.sint64();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("msg_count"))
            throw $util.ProtocolError("missing required 'msg_count'", { instance: message });
        if (!message.hasOwnProperty("account_number"))
            throw $util.ProtocolError("missing required 'account_number'", { instance: message });
        if (!message.hasOwnProperty("sequence"))
            throw $util.ProtocolError("missing required 'sequence'", { instance: message });
        if (!message.hasOwnProperty("source"))
            throw $util.ProtocolError("missing required 'source'", { instance: message });
        return message;
    };

    BinanceSignTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    BinanceSignTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!$util.isInteger(message.msg_count))
            return "msg_count: integer expected";
        if (!$util.isInteger(message.account_number) && !(message.account_number && $util.isInteger(message.account_number.low) && $util.isInteger(message.account_number.high)))
            return "account_number: integer|Long expected";
        if (message.chain_id != null && message.hasOwnProperty("chain_id"))
            if (!$util.isString(message.chain_id))
                return "chain_id: string expected";
        if (message.memo != null && message.hasOwnProperty("memo"))
            if (!$util.isString(message.memo))
                return "memo: string expected";
        if (!$util.isInteger(message.sequence) && !(message.sequence && $util.isInteger(message.sequence.low) && $util.isInteger(message.sequence.high)))
            return "sequence: integer|Long expected";
        if (!$util.isInteger(message.source) && !(message.source && $util.isInteger(message.source.low) && $util.isInteger(message.source.high)))
            return "source: integer|Long expected";
        return null;
    };

    BinanceSignTx.fromObject = function fromObject(object) {
        if (object instanceof $root.BinanceSignTx)
            return object;
        var message = new $root.BinanceSignTx();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".BinanceSignTx.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.msg_count != null)
            message.msg_count = object.msg_count >>> 0;
        if (object.account_number != null)
            if ($util.Long)
                (message.account_number = $util.Long.fromValue(object.account_number)).unsigned = false;
            else if (typeof object.account_number === "string")
                message.account_number = parseInt(object.account_number, 10);
            else if (typeof object.account_number === "number")
                message.account_number = object.account_number;
            else if (typeof object.account_number === "object")
                message.account_number = new $util.LongBits(object.account_number.low >>> 0, object.account_number.high >>> 0).toNumber();
        if (object.chain_id != null)
            message.chain_id = String(object.chain_id);
        if (object.memo != null)
            message.memo = String(object.memo);
        if (object.sequence != null)
            if ($util.Long)
                (message.sequence = $util.Long.fromValue(object.sequence)).unsigned = false;
            else if (typeof object.sequence === "string")
                message.sequence = parseInt(object.sequence, 10);
            else if (typeof object.sequence === "number")
                message.sequence = object.sequence;
            else if (typeof object.sequence === "object")
                message.sequence = new $util.LongBits(object.sequence.low >>> 0, object.sequence.high >>> 0).toNumber();
        if (object.source != null)
            if ($util.Long)
                (message.source = $util.Long.fromValue(object.source)).unsigned = false;
            else if (typeof object.source === "string")
                message.source = parseInt(object.source, 10);
            else if (typeof object.source === "number")
                message.source = object.source;
            else if (typeof object.source === "object")
                message.source = new $util.LongBits(object.source.low >>> 0, object.source.high >>> 0).toNumber();
        return message;
    };

    BinanceSignTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            object.msg_count = 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.account_number = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.account_number = options.longs === String ? "0" : 0;
            object.chain_id = "";
            object.memo = "";
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.sequence = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.sequence = options.longs === String ? "0" : 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.source = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.source = options.longs === String ? "0" : 0;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.msg_count != null && message.hasOwnProperty("msg_count"))
            object.msg_count = message.msg_count;
        if (message.account_number != null && message.hasOwnProperty("account_number"))
            if (typeof message.account_number === "number")
                object.account_number = options.longs === String ? String(message.account_number) : message.account_number;
            else
                object.account_number = options.longs === String ? $util.Long.prototype.toString.call(message.account_number) : options.longs === Number ? new $util.LongBits(message.account_number.low >>> 0, message.account_number.high >>> 0).toNumber() : message.account_number;
        if (message.chain_id != null && message.hasOwnProperty("chain_id"))
            object.chain_id = message.chain_id;
        if (message.memo != null && message.hasOwnProperty("memo"))
            object.memo = message.memo;
        if (message.sequence != null && message.hasOwnProperty("sequence"))
            if (typeof message.sequence === "number")
                object.sequence = options.longs === String ? String(message.sequence) : message.sequence;
            else
                object.sequence = options.longs === String ? $util.Long.prototype.toString.call(message.sequence) : options.longs === Number ? new $util.LongBits(message.sequence.low >>> 0, message.sequence.high >>> 0).toNumber() : message.sequence;
        if (message.source != null && message.hasOwnProperty("source"))
            if (typeof message.source === "number")
                object.source = options.longs === String ? String(message.source) : message.source;
            else
                object.source = options.longs === String ? $util.Long.prototype.toString.call(message.source) : options.longs === Number ? new $util.LongBits(message.source.low >>> 0, message.source.high >>> 0).toNumber() : message.source;
        return object;
    };

    BinanceSignTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return BinanceSignTx;
})();

$root.BinanceTxRequest = (function() {

    function BinanceTxRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    BinanceTxRequest.create = function create(properties) {
        return new BinanceTxRequest(properties);
    };

    BinanceTxRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    BinanceTxRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    BinanceTxRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BinanceTxRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    BinanceTxRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    BinanceTxRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    BinanceTxRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.BinanceTxRequest)
            return object;
        return new $root.BinanceTxRequest();
    };

    BinanceTxRequest.toObject = function toObject() {
        return {};
    };

    BinanceTxRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return BinanceTxRequest;
})();

$root.BinanceTransferMsg = (function() {

    function BinanceTransferMsg(properties) {
        this.inputs = [];
        this.outputs = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    BinanceTransferMsg.prototype.inputs = $util.emptyArray;
    BinanceTransferMsg.prototype.outputs = $util.emptyArray;

    BinanceTransferMsg.create = function create(properties) {
        return new BinanceTransferMsg(properties);
    };

    BinanceTransferMsg.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.inputs != null && message.inputs.length)
            for (var i = 0; i < message.inputs.length; ++i)
                $root.BinanceTransferMsg.BinanceInputOutput.encode(message.inputs[i], writer.uint32(10).fork()).ldelim();
        if (message.outputs != null && message.outputs.length)
            for (var i = 0; i < message.outputs.length; ++i)
                $root.BinanceTransferMsg.BinanceInputOutput.encode(message.outputs[i], writer.uint32(18).fork()).ldelim();
        return writer;
    };

    BinanceTransferMsg.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    BinanceTransferMsg.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BinanceTransferMsg();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.inputs && message.inputs.length))
                    message.inputs = [];
                message.inputs.push($root.BinanceTransferMsg.BinanceInputOutput.decode(reader, reader.uint32()));
                break;
            case 2:
                if (!(message.outputs && message.outputs.length))
                    message.outputs = [];
                message.outputs.push($root.BinanceTransferMsg.BinanceInputOutput.decode(reader, reader.uint32()));
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    BinanceTransferMsg.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    BinanceTransferMsg.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.inputs != null && message.hasOwnProperty("inputs")) {
            if (!Array.isArray(message.inputs))
                return "inputs: array expected";
            for (var i = 0; i < message.inputs.length; ++i) {
                var error = $root.BinanceTransferMsg.BinanceInputOutput.verify(message.inputs[i]);
                if (error)
                    return "inputs." + error;
            }
        }
        if (message.outputs != null && message.hasOwnProperty("outputs")) {
            if (!Array.isArray(message.outputs))
                return "outputs: array expected";
            for (var i = 0; i < message.outputs.length; ++i) {
                var error = $root.BinanceTransferMsg.BinanceInputOutput.verify(message.outputs[i]);
                if (error)
                    return "outputs." + error;
            }
        }
        return null;
    };

    BinanceTransferMsg.fromObject = function fromObject(object) {
        if (object instanceof $root.BinanceTransferMsg)
            return object;
        var message = new $root.BinanceTransferMsg();
        if (object.inputs) {
            if (!Array.isArray(object.inputs))
                throw TypeError(".BinanceTransferMsg.inputs: array expected");
            message.inputs = [];
            for (var i = 0; i < object.inputs.length; ++i) {
                if (typeof object.inputs[i] !== "object")
                    throw TypeError(".BinanceTransferMsg.inputs: object expected");
                message.inputs[i] = $root.BinanceTransferMsg.BinanceInputOutput.fromObject(object.inputs[i]);
            }
        }
        if (object.outputs) {
            if (!Array.isArray(object.outputs))
                throw TypeError(".BinanceTransferMsg.outputs: array expected");
            message.outputs = [];
            for (var i = 0; i < object.outputs.length; ++i) {
                if (typeof object.outputs[i] !== "object")
                    throw TypeError(".BinanceTransferMsg.outputs: object expected");
                message.outputs[i] = $root.BinanceTransferMsg.BinanceInputOutput.fromObject(object.outputs[i]);
            }
        }
        return message;
    };

    BinanceTransferMsg.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults) {
            object.inputs = [];
            object.outputs = [];
        }
        if (message.inputs && message.inputs.length) {
            object.inputs = [];
            for (var j = 0; j < message.inputs.length; ++j)
                object.inputs[j] = $root.BinanceTransferMsg.BinanceInputOutput.toObject(message.inputs[j], options);
        }
        if (message.outputs && message.outputs.length) {
            object.outputs = [];
            for (var j = 0; j < message.outputs.length; ++j)
                object.outputs[j] = $root.BinanceTransferMsg.BinanceInputOutput.toObject(message.outputs[j], options);
        }
        return object;
    };

    BinanceTransferMsg.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    BinanceTransferMsg.BinanceInputOutput = (function() {

        function BinanceInputOutput(properties) {
            this.coins = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        BinanceInputOutput.prototype.address = "";
        BinanceInputOutput.prototype.coins = $util.emptyArray;

        BinanceInputOutput.create = function create(properties) {
            return new BinanceInputOutput(properties);
        };

        BinanceInputOutput.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(10).string(message.address);
            if (message.coins != null && message.coins.length)
                for (var i = 0; i < message.coins.length; ++i)
                    $root.BinanceTransferMsg.BinanceCoin.encode(message.coins[i], writer.uint32(18).fork()).ldelim();
            return writer;
        };

        BinanceInputOutput.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        BinanceInputOutput.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BinanceTransferMsg.BinanceInputOutput();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    if (!(message.coins && message.coins.length))
                        message.coins = [];
                    message.coins.push($root.BinanceTransferMsg.BinanceCoin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("address"))
                throw $util.ProtocolError("missing required 'address'", { instance: message });
            return message;
        };

        BinanceInputOutput.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        BinanceInputOutput.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isString(message.address))
                return "address: string expected";
            if (message.coins != null && message.hasOwnProperty("coins")) {
                if (!Array.isArray(message.coins))
                    return "coins: array expected";
                for (var i = 0; i < message.coins.length; ++i) {
                    var error = $root.BinanceTransferMsg.BinanceCoin.verify(message.coins[i]);
                    if (error)
                        return "coins." + error;
                }
            }
            return null;
        };

        BinanceInputOutput.fromObject = function fromObject(object) {
            if (object instanceof $root.BinanceTransferMsg.BinanceInputOutput)
                return object;
            var message = new $root.BinanceTransferMsg.BinanceInputOutput();
            if (object.address != null)
                message.address = String(object.address);
            if (object.coins) {
                if (!Array.isArray(object.coins))
                    throw TypeError(".BinanceTransferMsg.BinanceInputOutput.coins: array expected");
                message.coins = [];
                for (var i = 0; i < object.coins.length; ++i) {
                    if (typeof object.coins[i] !== "object")
                        throw TypeError(".BinanceTransferMsg.BinanceInputOutput.coins: object expected");
                    message.coins[i] = $root.BinanceTransferMsg.BinanceCoin.fromObject(object.coins[i]);
                }
            }
            return message;
        };

        BinanceInputOutput.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.coins = [];
            if (options.defaults)
                object.address = "";
            if (message.address != null && message.hasOwnProperty("address"))
                object.address = message.address;
            if (message.coins && message.coins.length) {
                object.coins = [];
                for (var j = 0; j < message.coins.length; ++j)
                    object.coins[j] = $root.BinanceTransferMsg.BinanceCoin.toObject(message.coins[j], options);
            }
            return object;
        };

        BinanceInputOutput.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return BinanceInputOutput;
    })();

    BinanceTransferMsg.BinanceCoin = (function() {

        function BinanceCoin(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        BinanceCoin.prototype.amount = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        BinanceCoin.prototype.denom = "";

        BinanceCoin.create = function create(properties) {
            return new BinanceCoin(properties);
        };

        BinanceCoin.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(8).sint64(message.amount);
            writer.uint32(18).string(message.denom);
            return writer;
        };

        BinanceCoin.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        BinanceCoin.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BinanceTransferMsg.BinanceCoin();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.amount = reader.sint64();
                    break;
                case 2:
                    message.denom = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("amount"))
                throw $util.ProtocolError("missing required 'amount'", { instance: message });
            if (!message.hasOwnProperty("denom"))
                throw $util.ProtocolError("missing required 'denom'", { instance: message });
            return message;
        };

        BinanceCoin.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        BinanceCoin.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
                return "amount: integer|Long expected";
            if (!$util.isString(message.denom))
                return "denom: string expected";
            return null;
        };

        BinanceCoin.fromObject = function fromObject(object) {
            if (object instanceof $root.BinanceTransferMsg.BinanceCoin)
                return object;
            var message = new $root.BinanceTransferMsg.BinanceCoin();
            if (object.amount != null)
                if ($util.Long)
                    (message.amount = $util.Long.fromValue(object.amount)).unsigned = false;
                else if (typeof object.amount === "string")
                    message.amount = parseInt(object.amount, 10);
                else if (typeof object.amount === "number")
                    message.amount = object.amount;
                else if (typeof object.amount === "object")
                    message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber();
            if (object.denom != null)
                message.denom = String(object.denom);
            return message;
        };

        BinanceCoin.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.amount = options.longs === String ? "0" : 0;
                object.denom = "";
            }
            if (message.amount != null && message.hasOwnProperty("amount"))
                if (typeof message.amount === "number")
                    object.amount = options.longs === String ? String(message.amount) : message.amount;
                else
                    object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber() : message.amount;
            if (message.denom != null && message.hasOwnProperty("denom"))
                object.denom = message.denom;
            return object;
        };

        BinanceCoin.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return BinanceCoin;
    })();

    return BinanceTransferMsg;
})();

$root.BinanceOrderMsg = (function() {

    function BinanceOrderMsg(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    BinanceOrderMsg.prototype.id = "";
    BinanceOrderMsg.prototype.ordertype = 0;
    BinanceOrderMsg.prototype.price = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    BinanceOrderMsg.prototype.quantity = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    BinanceOrderMsg.prototype.sender = "";
    BinanceOrderMsg.prototype.side = 0;
    BinanceOrderMsg.prototype.symbol = "";
    BinanceOrderMsg.prototype.timeinforce = 0;

    BinanceOrderMsg.create = function create(properties) {
        return new BinanceOrderMsg(properties);
    };

    BinanceOrderMsg.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
            writer.uint32(10).string(message.id);
        writer.uint32(16).int32(message.ordertype);
        writer.uint32(24).sint64(message.price);
        writer.uint32(32).sint64(message.quantity);
        if (message.sender != null && Object.hasOwnProperty.call(message, "sender"))
            writer.uint32(42).string(message.sender);
        writer.uint32(48).int32(message.side);
        if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
            writer.uint32(58).string(message.symbol);
        writer.uint32(64).int32(message.timeinforce);
        return writer;
    };

    BinanceOrderMsg.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    BinanceOrderMsg.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BinanceOrderMsg();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.id = reader.string();
                break;
            case 2:
                message.ordertype = reader.int32();
                break;
            case 3:
                message.price = reader.sint64();
                break;
            case 4:
                message.quantity = reader.sint64();
                break;
            case 5:
                message.sender = reader.string();
                break;
            case 6:
                message.side = reader.int32();
                break;
            case 7:
                message.symbol = reader.string();
                break;
            case 8:
                message.timeinforce = reader.int32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("ordertype"))
            throw $util.ProtocolError("missing required 'ordertype'", { instance: message });
        if (!message.hasOwnProperty("price"))
            throw $util.ProtocolError("missing required 'price'", { instance: message });
        if (!message.hasOwnProperty("quantity"))
            throw $util.ProtocolError("missing required 'quantity'", { instance: message });
        if (!message.hasOwnProperty("side"))
            throw $util.ProtocolError("missing required 'side'", { instance: message });
        if (!message.hasOwnProperty("timeinforce"))
            throw $util.ProtocolError("missing required 'timeinforce'", { instance: message });
        return message;
    };

    BinanceOrderMsg.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    BinanceOrderMsg.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.id != null && message.hasOwnProperty("id"))
            if (!$util.isString(message.id))
                return "id: string expected";
        switch (message.ordertype) {
        default:
            return "ordertype: enum value expected";
        case 0:
        case 1:
        case 2:
        case 3:
            break;
        }
        if (!$util.isInteger(message.price) && !(message.price && $util.isInteger(message.price.low) && $util.isInteger(message.price.high)))
            return "price: integer|Long expected";
        if (!$util.isInteger(message.quantity) && !(message.quantity && $util.isInteger(message.quantity.low) && $util.isInteger(message.quantity.high)))
            return "quantity: integer|Long expected";
        if (message.sender != null && message.hasOwnProperty("sender"))
            if (!$util.isString(message.sender))
                return "sender: string expected";
        switch (message.side) {
        default:
            return "side: enum value expected";
        case 0:
        case 1:
        case 2:
            break;
        }
        if (message.symbol != null && message.hasOwnProperty("symbol"))
            if (!$util.isString(message.symbol))
                return "symbol: string expected";
        switch (message.timeinforce) {
        default:
            return "timeinforce: enum value expected";
        case 0:
        case 1:
        case 2:
        case 3:
            break;
        }
        return null;
    };

    BinanceOrderMsg.fromObject = function fromObject(object) {
        if (object instanceof $root.BinanceOrderMsg)
            return object;
        var message = new $root.BinanceOrderMsg();
        if (object.id != null)
            message.id = String(object.id);
        switch (object.ordertype) {
        case "OT_UNKNOWN":
        case 0:
            message.ordertype = 0;
            break;
        case "MARKET":
        case 1:
            message.ordertype = 1;
            break;
        case "LIMIT":
        case 2:
            message.ordertype = 2;
            break;
        case "OT_RESERVED":
        case 3:
            message.ordertype = 3;
            break;
        }
        if (object.price != null)
            if ($util.Long)
                (message.price = $util.Long.fromValue(object.price)).unsigned = false;
            else if (typeof object.price === "string")
                message.price = parseInt(object.price, 10);
            else if (typeof object.price === "number")
                message.price = object.price;
            else if (typeof object.price === "object")
                message.price = new $util.LongBits(object.price.low >>> 0, object.price.high >>> 0).toNumber();
        if (object.quantity != null)
            if ($util.Long)
                (message.quantity = $util.Long.fromValue(object.quantity)).unsigned = false;
            else if (typeof object.quantity === "string")
                message.quantity = parseInt(object.quantity, 10);
            else if (typeof object.quantity === "number")
                message.quantity = object.quantity;
            else if (typeof object.quantity === "object")
                message.quantity = new $util.LongBits(object.quantity.low >>> 0, object.quantity.high >>> 0).toNumber();
        if (object.sender != null)
            message.sender = String(object.sender);
        switch (object.side) {
        case "SIDE_UNKNOWN":
        case 0:
            message.side = 0;
            break;
        case "BUY":
        case 1:
            message.side = 1;
            break;
        case "SELL":
        case 2:
            message.side = 2;
            break;
        }
        if (object.symbol != null)
            message.symbol = String(object.symbol);
        switch (object.timeinforce) {
        case "TIF_UNKNOWN":
        case 0:
            message.timeinforce = 0;
            break;
        case "GTE":
        case 1:
            message.timeinforce = 1;
            break;
        case "TIF_RESERVED":
        case 2:
            message.timeinforce = 2;
            break;
        case "IOC":
        case 3:
            message.timeinforce = 3;
            break;
        }
        return message;
    };

    BinanceOrderMsg.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.id = "";
            object.ordertype = options.enums === String ? "OT_UNKNOWN" : 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.price = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.price = options.longs === String ? "0" : 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.quantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.quantity = options.longs === String ? "0" : 0;
            object.sender = "";
            object.side = options.enums === String ? "SIDE_UNKNOWN" : 0;
            object.symbol = "";
            object.timeinforce = options.enums === String ? "TIF_UNKNOWN" : 0;
        }
        if (message.id != null && message.hasOwnProperty("id"))
            object.id = message.id;
        if (message.ordertype != null && message.hasOwnProperty("ordertype"))
            object.ordertype = options.enums === String ? $root.BinanceOrderMsg.BinanceOrderType[message.ordertype] : message.ordertype;
        if (message.price != null && message.hasOwnProperty("price"))
            if (typeof message.price === "number")
                object.price = options.longs === String ? String(message.price) : message.price;
            else
                object.price = options.longs === String ? $util.Long.prototype.toString.call(message.price) : options.longs === Number ? new $util.LongBits(message.price.low >>> 0, message.price.high >>> 0).toNumber() : message.price;
        if (message.quantity != null && message.hasOwnProperty("quantity"))
            if (typeof message.quantity === "number")
                object.quantity = options.longs === String ? String(message.quantity) : message.quantity;
            else
                object.quantity = options.longs === String ? $util.Long.prototype.toString.call(message.quantity) : options.longs === Number ? new $util.LongBits(message.quantity.low >>> 0, message.quantity.high >>> 0).toNumber() : message.quantity;
        if (message.sender != null && message.hasOwnProperty("sender"))
            object.sender = message.sender;
        if (message.side != null && message.hasOwnProperty("side"))
            object.side = options.enums === String ? $root.BinanceOrderMsg.BinanceOrderSide[message.side] : message.side;
        if (message.symbol != null && message.hasOwnProperty("symbol"))
            object.symbol = message.symbol;
        if (message.timeinforce != null && message.hasOwnProperty("timeinforce"))
            object.timeinforce = options.enums === String ? $root.BinanceOrderMsg.BinanceTimeInForce[message.timeinforce] : message.timeinforce;
        return object;
    };

    BinanceOrderMsg.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    BinanceOrderMsg.BinanceOrderType = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "OT_UNKNOWN"] = 0;
        values[valuesById[1] = "MARKET"] = 1;
        values[valuesById[2] = "LIMIT"] = 2;
        values[valuesById[3] = "OT_RESERVED"] = 3;
        return values;
    })();

    BinanceOrderMsg.BinanceOrderSide = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "SIDE_UNKNOWN"] = 0;
        values[valuesById[1] = "BUY"] = 1;
        values[valuesById[2] = "SELL"] = 2;
        return values;
    })();

    BinanceOrderMsg.BinanceTimeInForce = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "TIF_UNKNOWN"] = 0;
        values[valuesById[1] = "GTE"] = 1;
        values[valuesById[2] = "TIF_RESERVED"] = 2;
        values[valuesById[3] = "IOC"] = 3;
        return values;
    })();

    return BinanceOrderMsg;
})();

$root.BinanceCancelMsg = (function() {

    function BinanceCancelMsg(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    BinanceCancelMsg.prototype.refid = "";
    BinanceCancelMsg.prototype.sender = "";
    BinanceCancelMsg.prototype.symbol = "";

    BinanceCancelMsg.create = function create(properties) {
        return new BinanceCancelMsg(properties);
    };

    BinanceCancelMsg.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.refid != null && Object.hasOwnProperty.call(message, "refid"))
            writer.uint32(10).string(message.refid);
        if (message.sender != null && Object.hasOwnProperty.call(message, "sender"))
            writer.uint32(18).string(message.sender);
        if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
            writer.uint32(26).string(message.symbol);
        return writer;
    };

    BinanceCancelMsg.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    BinanceCancelMsg.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BinanceCancelMsg();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.refid = reader.string();
                break;
            case 2:
                message.sender = reader.string();
                break;
            case 3:
                message.symbol = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    BinanceCancelMsg.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    BinanceCancelMsg.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.refid != null && message.hasOwnProperty("refid"))
            if (!$util.isString(message.refid))
                return "refid: string expected";
        if (message.sender != null && message.hasOwnProperty("sender"))
            if (!$util.isString(message.sender))
                return "sender: string expected";
        if (message.symbol != null && message.hasOwnProperty("symbol"))
            if (!$util.isString(message.symbol))
                return "symbol: string expected";
        return null;
    };

    BinanceCancelMsg.fromObject = function fromObject(object) {
        if (object instanceof $root.BinanceCancelMsg)
            return object;
        var message = new $root.BinanceCancelMsg();
        if (object.refid != null)
            message.refid = String(object.refid);
        if (object.sender != null)
            message.sender = String(object.sender);
        if (object.symbol != null)
            message.symbol = String(object.symbol);
        return message;
    };

    BinanceCancelMsg.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.refid = "";
            object.sender = "";
            object.symbol = "";
        }
        if (message.refid != null && message.hasOwnProperty("refid"))
            object.refid = message.refid;
        if (message.sender != null && message.hasOwnProperty("sender"))
            object.sender = message.sender;
        if (message.symbol != null && message.hasOwnProperty("symbol"))
            object.symbol = message.symbol;
        return object;
    };

    BinanceCancelMsg.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return BinanceCancelMsg;
})();

$root.BinanceSignedTx = (function() {

    function BinanceSignedTx(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    BinanceSignedTx.prototype.signature = $util.newBuffer([]);
    BinanceSignedTx.prototype.public_key = $util.newBuffer([]);

    BinanceSignedTx.create = function create(properties) {
        return new BinanceSignedTx(properties);
    };

    BinanceSignedTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.signature);
        writer.uint32(18).bytes(message.public_key);
        return writer;
    };

    BinanceSignedTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    BinanceSignedTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BinanceSignedTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.signature = reader.bytes();
                break;
            case 2:
                message.public_key = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        if (!message.hasOwnProperty("public_key"))
            throw $util.ProtocolError("missing required 'public_key'", { instance: message });
        return message;
    };

    BinanceSignedTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    BinanceSignedTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        if (!(message.public_key && typeof message.public_key.length === "number" || $util.isString(message.public_key)))
            return "public_key: buffer expected";
        return null;
    };

    BinanceSignedTx.fromObject = function fromObject(object) {
        if (object instanceof $root.BinanceSignedTx)
            return object;
        var message = new $root.BinanceSignedTx();
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        if (object.public_key != null)
            if (typeof object.public_key === "string")
                $util.base64.decode(object.public_key, message.public_key = $util.newBuffer($util.base64.length(object.public_key)), 0);
            else if (object.public_key.length)
                message.public_key = object.public_key;
        return message;
    };

    BinanceSignedTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
            if (options.bytes === String)
                object.public_key = "";
            else {
                object.public_key = [];
                if (options.bytes !== Array)
                    object.public_key = $util.newBuffer(object.public_key);
            }
        }
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            object.public_key = options.bytes === String ? $util.base64.encode(message.public_key, 0, message.public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.public_key) : message.public_key;
        return object;
    };

    BinanceSignedTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return BinanceSignedTx;
})();

$root.InputScriptType = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "SPENDADDRESS"] = 0;
    values[valuesById[1] = "SPENDMULTISIG"] = 1;
    values[valuesById[2] = "EXTERNAL"] = 2;
    values[valuesById[3] = "SPENDWITNESS"] = 3;
    values[valuesById[4] = "SPENDP2SHWITNESS"] = 4;
    values[valuesById[5] = "SPENDTAPROOT"] = 5;
    return values;
})();

$root.OutputScriptType = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "PAYTOADDRESS"] = 0;
    values[valuesById[1] = "PAYTOSCRIPTHASH"] = 1;
    values[valuesById[2] = "PAYTOMULTISIG"] = 2;
    values[valuesById[3] = "PAYTOOPRETURN"] = 3;
    values[valuesById[4] = "PAYTOWITNESS"] = 4;
    values[valuesById[5] = "PAYTOP2SHWITNESS"] = 5;
    values[valuesById[6] = "PAYTOTAPROOT"] = 6;
    return values;
})();

$root.DecredStakingSpendType = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "SSGen"] = 0;
    values[valuesById[1] = "SSRTX"] = 1;
    return values;
})();

$root.AmountUnit = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "BITCOIN"] = 0;
    values[valuesById[1] = "MILLIBITCOIN"] = 1;
    values[valuesById[2] = "MICROBITCOIN"] = 2;
    values[valuesById[3] = "SATOSHI"] = 3;
    return values;
})();

$root.MultisigRedeemScriptType = (function() {

    function MultisigRedeemScriptType(properties) {
        this.pubkeys = [];
        this.signatures = [];
        this.nodes = [];
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MultisigRedeemScriptType.prototype.pubkeys = $util.emptyArray;
    MultisigRedeemScriptType.prototype.signatures = $util.emptyArray;
    MultisigRedeemScriptType.prototype.m = 0;
    MultisigRedeemScriptType.prototype.nodes = $util.emptyArray;
    MultisigRedeemScriptType.prototype.address_n = $util.emptyArray;

    MultisigRedeemScriptType.create = function create(properties) {
        return new MultisigRedeemScriptType(properties);
    };

    MultisigRedeemScriptType.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.pubkeys != null && message.pubkeys.length)
            for (var i = 0; i < message.pubkeys.length; ++i)
                $root.MultisigRedeemScriptType.HDNodePathType.encode(message.pubkeys[i], writer.uint32(10).fork()).ldelim();
        if (message.signatures != null && message.signatures.length)
            for (var i = 0; i < message.signatures.length; ++i)
                writer.uint32(18).bytes(message.signatures[i]);
        writer.uint32(24).uint32(message.m);
        if (message.nodes != null && message.nodes.length)
            for (var i = 0; i < message.nodes.length; ++i)
                $root.HDNodeType.encode(message.nodes[i], writer.uint32(34).fork()).ldelim();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(40).uint32(message.address_n[i]);
        return writer;
    };

    MultisigRedeemScriptType.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MultisigRedeemScriptType.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MultisigRedeemScriptType();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.pubkeys && message.pubkeys.length))
                    message.pubkeys = [];
                message.pubkeys.push($root.MultisigRedeemScriptType.HDNodePathType.decode(reader, reader.uint32()));
                break;
            case 2:
                if (!(message.signatures && message.signatures.length))
                    message.signatures = [];
                message.signatures.push(reader.bytes());
                break;
            case 3:
                message.m = reader.uint32();
                break;
            case 4:
                if (!(message.nodes && message.nodes.length))
                    message.nodes = [];
                message.nodes.push($root.HDNodeType.decode(reader, reader.uint32()));
                break;
            case 5:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("m"))
            throw $util.ProtocolError("missing required 'm'", { instance: message });
        return message;
    };

    MultisigRedeemScriptType.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MultisigRedeemScriptType.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.pubkeys != null && message.hasOwnProperty("pubkeys")) {
            if (!Array.isArray(message.pubkeys))
                return "pubkeys: array expected";
            for (var i = 0; i < message.pubkeys.length; ++i) {
                var error = $root.MultisigRedeemScriptType.HDNodePathType.verify(message.pubkeys[i]);
                if (error)
                    return "pubkeys." + error;
            }
        }
        if (message.signatures != null && message.hasOwnProperty("signatures")) {
            if (!Array.isArray(message.signatures))
                return "signatures: array expected";
            for (var i = 0; i < message.signatures.length; ++i)
                if (!(message.signatures[i] && typeof message.signatures[i].length === "number" || $util.isString(message.signatures[i])))
                    return "signatures: buffer[] expected";
        }
        if (!$util.isInteger(message.m))
            return "m: integer expected";
        if (message.nodes != null && message.hasOwnProperty("nodes")) {
            if (!Array.isArray(message.nodes))
                return "nodes: array expected";
            for (var i = 0; i < message.nodes.length; ++i) {
                var error = $root.HDNodeType.verify(message.nodes[i]);
                if (error)
                    return "nodes." + error;
            }
        }
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        return null;
    };

    MultisigRedeemScriptType.fromObject = function fromObject(object) {
        if (object instanceof $root.MultisigRedeemScriptType)
            return object;
        var message = new $root.MultisigRedeemScriptType();
        if (object.pubkeys) {
            if (!Array.isArray(object.pubkeys))
                throw TypeError(".MultisigRedeemScriptType.pubkeys: array expected");
            message.pubkeys = [];
            for (var i = 0; i < object.pubkeys.length; ++i) {
                if (typeof object.pubkeys[i] !== "object")
                    throw TypeError(".MultisigRedeemScriptType.pubkeys: object expected");
                message.pubkeys[i] = $root.MultisigRedeemScriptType.HDNodePathType.fromObject(object.pubkeys[i]);
            }
        }
        if (object.signatures) {
            if (!Array.isArray(object.signatures))
                throw TypeError(".MultisigRedeemScriptType.signatures: array expected");
            message.signatures = [];
            for (var i = 0; i < object.signatures.length; ++i)
                if (typeof object.signatures[i] === "string")
                    $util.base64.decode(object.signatures[i], message.signatures[i] = $util.newBuffer($util.base64.length(object.signatures[i])), 0);
                else if (object.signatures[i].length)
                    message.signatures[i] = object.signatures[i];
        }
        if (object.m != null)
            message.m = object.m >>> 0;
        if (object.nodes) {
            if (!Array.isArray(object.nodes))
                throw TypeError(".MultisigRedeemScriptType.nodes: array expected");
            message.nodes = [];
            for (var i = 0; i < object.nodes.length; ++i) {
                if (typeof object.nodes[i] !== "object")
                    throw TypeError(".MultisigRedeemScriptType.nodes: object expected");
                message.nodes[i] = $root.HDNodeType.fromObject(object.nodes[i]);
            }
        }
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".MultisigRedeemScriptType.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        return message;
    };

    MultisigRedeemScriptType.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults) {
            object.pubkeys = [];
            object.signatures = [];
            object.nodes = [];
            object.address_n = [];
        }
        if (options.defaults)
            object.m = 0;
        if (message.pubkeys && message.pubkeys.length) {
            object.pubkeys = [];
            for (var j = 0; j < message.pubkeys.length; ++j)
                object.pubkeys[j] = $root.MultisigRedeemScriptType.HDNodePathType.toObject(message.pubkeys[j], options);
        }
        if (message.signatures && message.signatures.length) {
            object.signatures = [];
            for (var j = 0; j < message.signatures.length; ++j)
                object.signatures[j] = options.bytes === String ? $util.base64.encode(message.signatures[j], 0, message.signatures[j].length) : options.bytes === Array ? Array.prototype.slice.call(message.signatures[j]) : message.signatures[j];
        }
        if (message.m != null && message.hasOwnProperty("m"))
            object.m = message.m;
        if (message.nodes && message.nodes.length) {
            object.nodes = [];
            for (var j = 0; j < message.nodes.length; ++j)
                object.nodes[j] = $root.HDNodeType.toObject(message.nodes[j], options);
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        return object;
    };

    MultisigRedeemScriptType.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    MultisigRedeemScriptType.HDNodePathType = (function() {

        function HDNodePathType(properties) {
            this.address_n = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        HDNodePathType.prototype.node = null;
        HDNodePathType.prototype.address_n = $util.emptyArray;

        HDNodePathType.create = function create(properties) {
            return new HDNodePathType(properties);
        };

        HDNodePathType.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            $root.HDNodeType.encode(message.node, writer.uint32(10).fork()).ldelim();
            if (message.address_n != null && message.address_n.length)
                for (var i = 0; i < message.address_n.length; ++i)
                    writer.uint32(16).uint32(message.address_n[i]);
            return writer;
        };

        HDNodePathType.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        HDNodePathType.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MultisigRedeemScriptType.HDNodePathType();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.node = $root.HDNodeType.decode(reader, reader.uint32());
                    break;
                case 2:
                    if (!(message.address_n && message.address_n.length))
                        message.address_n = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.address_n.push(reader.uint32());
                    } else
                        message.address_n.push(reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("node"))
                throw $util.ProtocolError("missing required 'node'", { instance: message });
            return message;
        };

        HDNodePathType.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        HDNodePathType.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            {
                var error = $root.HDNodeType.verify(message.node);
                if (error)
                    return "node." + error;
            }
            if (message.address_n != null && message.hasOwnProperty("address_n")) {
                if (!Array.isArray(message.address_n))
                    return "address_n: array expected";
                for (var i = 0; i < message.address_n.length; ++i)
                    if (!$util.isInteger(message.address_n[i]))
                        return "address_n: integer[] expected";
            }
            return null;
        };

        HDNodePathType.fromObject = function fromObject(object) {
            if (object instanceof $root.MultisigRedeemScriptType.HDNodePathType)
                return object;
            var message = new $root.MultisigRedeemScriptType.HDNodePathType();
            if (object.node != null) {
                if (typeof object.node !== "object")
                    throw TypeError(".MultisigRedeemScriptType.HDNodePathType.node: object expected");
                message.node = $root.HDNodeType.fromObject(object.node);
            }
            if (object.address_n) {
                if (!Array.isArray(object.address_n))
                    throw TypeError(".MultisigRedeemScriptType.HDNodePathType.address_n: array expected");
                message.address_n = [];
                for (var i = 0; i < object.address_n.length; ++i)
                    message.address_n[i] = object.address_n[i] >>> 0;
            }
            return message;
        };

        HDNodePathType.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.address_n = [];
            if (options.defaults)
                object.node = null;
            if (message.node != null && message.hasOwnProperty("node"))
                object.node = $root.HDNodeType.toObject(message.node, options);
            if (message.address_n && message.address_n.length) {
                object.address_n = [];
                for (var j = 0; j < message.address_n.length; ++j)
                    object.address_n[j] = message.address_n[j];
            }
            return object;
        };

        HDNodePathType.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return HDNodePathType;
    })();

    return MultisigRedeemScriptType;
})();

$root.GetPublicKey = (function() {

    function GetPublicKey(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    GetPublicKey.prototype.address_n = $util.emptyArray;
    GetPublicKey.prototype.ecdsa_curve_name = "";
    GetPublicKey.prototype.show_display = false;
    GetPublicKey.prototype.coin_name = "Bitcoin";
    GetPublicKey.prototype.script_type = 0;
    GetPublicKey.prototype.ignore_xpub_magic = false;

    GetPublicKey.create = function create(properties) {
        return new GetPublicKey(properties);
    };

    GetPublicKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.ecdsa_curve_name != null && Object.hasOwnProperty.call(message, "ecdsa_curve_name"))
            writer.uint32(18).string(message.ecdsa_curve_name);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(24).bool(message.show_display);
        if (message.coin_name != null && Object.hasOwnProperty.call(message, "coin_name"))
            writer.uint32(34).string(message.coin_name);
        if (message.script_type != null && Object.hasOwnProperty.call(message, "script_type"))
            writer.uint32(40).int32(message.script_type);
        if (message.ignore_xpub_magic != null && Object.hasOwnProperty.call(message, "ignore_xpub_magic"))
            writer.uint32(48).bool(message.ignore_xpub_magic);
        return writer;
    };

    GetPublicKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    GetPublicKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.GetPublicKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.ecdsa_curve_name = reader.string();
                break;
            case 3:
                message.show_display = reader.bool();
                break;
            case 4:
                message.coin_name = reader.string();
                break;
            case 5:
                message.script_type = reader.int32();
                break;
            case 6:
                message.ignore_xpub_magic = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    GetPublicKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    GetPublicKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.ecdsa_curve_name != null && message.hasOwnProperty("ecdsa_curve_name"))
            if (!$util.isString(message.ecdsa_curve_name))
                return "ecdsa_curve_name: string expected";
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        if (message.coin_name != null && message.hasOwnProperty("coin_name"))
            if (!$util.isString(message.coin_name))
                return "coin_name: string expected";
        if (message.script_type != null && message.hasOwnProperty("script_type"))
            switch (message.script_type) {
            default:
                return "script_type: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
                break;
            }
        if (message.ignore_xpub_magic != null && message.hasOwnProperty("ignore_xpub_magic"))
            if (typeof message.ignore_xpub_magic !== "boolean")
                return "ignore_xpub_magic: boolean expected";
        return null;
    };

    GetPublicKey.fromObject = function fromObject(object) {
        if (object instanceof $root.GetPublicKey)
            return object;
        var message = new $root.GetPublicKey();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".GetPublicKey.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.ecdsa_curve_name != null)
            message.ecdsa_curve_name = String(object.ecdsa_curve_name);
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        if (object.coin_name != null)
            message.coin_name = String(object.coin_name);
        switch (object.script_type) {
        case "SPENDADDRESS":
        case 0:
            message.script_type = 0;
            break;
        case "SPENDMULTISIG":
        case 1:
            message.script_type = 1;
            break;
        case "EXTERNAL":
        case 2:
            message.script_type = 2;
            break;
        case "SPENDWITNESS":
        case 3:
            message.script_type = 3;
            break;
        case "SPENDP2SHWITNESS":
        case 4:
            message.script_type = 4;
            break;
        case "SPENDTAPROOT":
        case 5:
            message.script_type = 5;
            break;
        }
        if (object.ignore_xpub_magic != null)
            message.ignore_xpub_magic = Boolean(object.ignore_xpub_magic);
        return message;
    };

    GetPublicKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            object.ecdsa_curve_name = "";
            object.show_display = false;
            object.coin_name = "Bitcoin";
            object.script_type = options.enums === String ? "SPENDADDRESS" : 0;
            object.ignore_xpub_magic = false;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.ecdsa_curve_name != null && message.hasOwnProperty("ecdsa_curve_name"))
            object.ecdsa_curve_name = message.ecdsa_curve_name;
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        if (message.coin_name != null && message.hasOwnProperty("coin_name"))
            object.coin_name = message.coin_name;
        if (message.script_type != null && message.hasOwnProperty("script_type"))
            object.script_type = options.enums === String ? $root.InputScriptType[message.script_type] : message.script_type;
        if (message.ignore_xpub_magic != null && message.hasOwnProperty("ignore_xpub_magic"))
            object.ignore_xpub_magic = message.ignore_xpub_magic;
        return object;
    };

    GetPublicKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return GetPublicKey;
})();

$root.PublicKey = (function() {

    function PublicKey(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    PublicKey.prototype.node = null;
    PublicKey.prototype.xpub = "";
    PublicKey.prototype.root_fingerprint = 0;

    PublicKey.create = function create(properties) {
        return new PublicKey(properties);
    };

    PublicKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        $root.HDNodeType.encode(message.node, writer.uint32(10).fork()).ldelim();
        writer.uint32(18).string(message.xpub);
        if (message.root_fingerprint != null && Object.hasOwnProperty.call(message, "root_fingerprint"))
            writer.uint32(24).uint32(message.root_fingerprint);
        return writer;
    };

    PublicKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    PublicKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.PublicKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.node = $root.HDNodeType.decode(reader, reader.uint32());
                break;
            case 2:
                message.xpub = reader.string();
                break;
            case 3:
                message.root_fingerprint = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("node"))
            throw $util.ProtocolError("missing required 'node'", { instance: message });
        if (!message.hasOwnProperty("xpub"))
            throw $util.ProtocolError("missing required 'xpub'", { instance: message });
        return message;
    };

    PublicKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    PublicKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        {
            var error = $root.HDNodeType.verify(message.node);
            if (error)
                return "node." + error;
        }
        if (!$util.isString(message.xpub))
            return "xpub: string expected";
        if (message.root_fingerprint != null && message.hasOwnProperty("root_fingerprint"))
            if (!$util.isInteger(message.root_fingerprint))
                return "root_fingerprint: integer expected";
        return null;
    };

    PublicKey.fromObject = function fromObject(object) {
        if (object instanceof $root.PublicKey)
            return object;
        var message = new $root.PublicKey();
        if (object.node != null) {
            if (typeof object.node !== "object")
                throw TypeError(".PublicKey.node: object expected");
            message.node = $root.HDNodeType.fromObject(object.node);
        }
        if (object.xpub != null)
            message.xpub = String(object.xpub);
        if (object.root_fingerprint != null)
            message.root_fingerprint = object.root_fingerprint >>> 0;
        return message;
    };

    PublicKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.node = null;
            object.xpub = "";
            object.root_fingerprint = 0;
        }
        if (message.node != null && message.hasOwnProperty("node"))
            object.node = $root.HDNodeType.toObject(message.node, options);
        if (message.xpub != null && message.hasOwnProperty("xpub"))
            object.xpub = message.xpub;
        if (message.root_fingerprint != null && message.hasOwnProperty("root_fingerprint"))
            object.root_fingerprint = message.root_fingerprint;
        return object;
    };

    PublicKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return PublicKey;
})();

$root.GetAddress = (function() {

    function GetAddress(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    GetAddress.prototype.address_n = $util.emptyArray;
    GetAddress.prototype.coin_name = "Bitcoin";
    GetAddress.prototype.show_display = false;
    GetAddress.prototype.multisig = null;
    GetAddress.prototype.script_type = 0;
    GetAddress.prototype.ignore_xpub_magic = false;

    GetAddress.create = function create(properties) {
        return new GetAddress(properties);
    };

    GetAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.coin_name != null && Object.hasOwnProperty.call(message, "coin_name"))
            writer.uint32(18).string(message.coin_name);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(24).bool(message.show_display);
        if (message.multisig != null && Object.hasOwnProperty.call(message, "multisig"))
            $root.MultisigRedeemScriptType.encode(message.multisig, writer.uint32(34).fork()).ldelim();
        if (message.script_type != null && Object.hasOwnProperty.call(message, "script_type"))
            writer.uint32(40).int32(message.script_type);
        if (message.ignore_xpub_magic != null && Object.hasOwnProperty.call(message, "ignore_xpub_magic"))
            writer.uint32(48).bool(message.ignore_xpub_magic);
        return writer;
    };

    GetAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    GetAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.GetAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.coin_name = reader.string();
                break;
            case 3:
                message.show_display = reader.bool();
                break;
            case 4:
                message.multisig = $root.MultisigRedeemScriptType.decode(reader, reader.uint32());
                break;
            case 5:
                message.script_type = reader.int32();
                break;
            case 6:
                message.ignore_xpub_magic = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    GetAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    GetAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.coin_name != null && message.hasOwnProperty("coin_name"))
            if (!$util.isString(message.coin_name))
                return "coin_name: string expected";
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        if (message.multisig != null && message.hasOwnProperty("multisig")) {
            var error = $root.MultisigRedeemScriptType.verify(message.multisig);
            if (error)
                return "multisig." + error;
        }
        if (message.script_type != null && message.hasOwnProperty("script_type"))
            switch (message.script_type) {
            default:
                return "script_type: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
                break;
            }
        if (message.ignore_xpub_magic != null && message.hasOwnProperty("ignore_xpub_magic"))
            if (typeof message.ignore_xpub_magic !== "boolean")
                return "ignore_xpub_magic: boolean expected";
        return null;
    };

    GetAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.GetAddress)
            return object;
        var message = new $root.GetAddress();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".GetAddress.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.coin_name != null)
            message.coin_name = String(object.coin_name);
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        if (object.multisig != null) {
            if (typeof object.multisig !== "object")
                throw TypeError(".GetAddress.multisig: object expected");
            message.multisig = $root.MultisigRedeemScriptType.fromObject(object.multisig);
        }
        switch (object.script_type) {
        case "SPENDADDRESS":
        case 0:
            message.script_type = 0;
            break;
        case "SPENDMULTISIG":
        case 1:
            message.script_type = 1;
            break;
        case "EXTERNAL":
        case 2:
            message.script_type = 2;
            break;
        case "SPENDWITNESS":
        case 3:
            message.script_type = 3;
            break;
        case "SPENDP2SHWITNESS":
        case 4:
            message.script_type = 4;
            break;
        case "SPENDTAPROOT":
        case 5:
            message.script_type = 5;
            break;
        }
        if (object.ignore_xpub_magic != null)
            message.ignore_xpub_magic = Boolean(object.ignore_xpub_magic);
        return message;
    };

    GetAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            object.coin_name = "Bitcoin";
            object.show_display = false;
            object.multisig = null;
            object.script_type = options.enums === String ? "SPENDADDRESS" : 0;
            object.ignore_xpub_magic = false;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.coin_name != null && message.hasOwnProperty("coin_name"))
            object.coin_name = message.coin_name;
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        if (message.multisig != null && message.hasOwnProperty("multisig"))
            object.multisig = $root.MultisigRedeemScriptType.toObject(message.multisig, options);
        if (message.script_type != null && message.hasOwnProperty("script_type"))
            object.script_type = options.enums === String ? $root.InputScriptType[message.script_type] : message.script_type;
        if (message.ignore_xpub_magic != null && message.hasOwnProperty("ignore_xpub_magic"))
            object.ignore_xpub_magic = message.ignore_xpub_magic;
        return object;
    };

    GetAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return GetAddress;
})();

$root.Address = (function() {

    function Address(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    Address.prototype.address = "";
    Address.prototype.mac = $util.newBuffer([]);

    Address.create = function create(properties) {
        return new Address(properties);
    };

    Address.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.address);
        if (message.mac != null && Object.hasOwnProperty.call(message, "mac"))
            writer.uint32(18).bytes(message.mac);
        return writer;
    };

    Address.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    Address.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Address();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.string();
                break;
            case 2:
                message.mac = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("address"))
            throw $util.ProtocolError("missing required 'address'", { instance: message });
        return message;
    };

    Address.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    Address.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.address))
            return "address: string expected";
        if (message.mac != null && message.hasOwnProperty("mac"))
            if (!(message.mac && typeof message.mac.length === "number" || $util.isString(message.mac)))
                return "mac: buffer expected";
        return null;
    };

    Address.fromObject = function fromObject(object) {
        if (object instanceof $root.Address)
            return object;
        var message = new $root.Address();
        if (object.address != null)
            message.address = String(object.address);
        if (object.mac != null)
            if (typeof object.mac === "string")
                $util.base64.decode(object.mac, message.mac = $util.newBuffer($util.base64.length(object.mac)), 0);
            else if (object.mac.length)
                message.mac = object.mac;
        return message;
    };

    Address.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.address = "";
            if (options.bytes === String)
                object.mac = "";
            else {
                object.mac = [];
                if (options.bytes !== Array)
                    object.mac = $util.newBuffer(object.mac);
            }
        }
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        if (message.mac != null && message.hasOwnProperty("mac"))
            object.mac = options.bytes === String ? $util.base64.encode(message.mac, 0, message.mac.length) : options.bytes === Array ? Array.prototype.slice.call(message.mac) : message.mac;
        return object;
    };

    Address.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return Address;
})();

$root.GetOwnershipId = (function() {

    function GetOwnershipId(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    GetOwnershipId.prototype.address_n = $util.emptyArray;
    GetOwnershipId.prototype.coin_name = "Bitcoin";
    GetOwnershipId.prototype.multisig = null;
    GetOwnershipId.prototype.script_type = 0;

    GetOwnershipId.create = function create(properties) {
        return new GetOwnershipId(properties);
    };

    GetOwnershipId.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.coin_name != null && Object.hasOwnProperty.call(message, "coin_name"))
            writer.uint32(18).string(message.coin_name);
        if (message.multisig != null && Object.hasOwnProperty.call(message, "multisig"))
            $root.MultisigRedeemScriptType.encode(message.multisig, writer.uint32(26).fork()).ldelim();
        if (message.script_type != null && Object.hasOwnProperty.call(message, "script_type"))
            writer.uint32(32).int32(message.script_type);
        return writer;
    };

    GetOwnershipId.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    GetOwnershipId.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.GetOwnershipId();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.coin_name = reader.string();
                break;
            case 3:
                message.multisig = $root.MultisigRedeemScriptType.decode(reader, reader.uint32());
                break;
            case 4:
                message.script_type = reader.int32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    GetOwnershipId.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    GetOwnershipId.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.coin_name != null && message.hasOwnProperty("coin_name"))
            if (!$util.isString(message.coin_name))
                return "coin_name: string expected";
        if (message.multisig != null && message.hasOwnProperty("multisig")) {
            var error = $root.MultisigRedeemScriptType.verify(message.multisig);
            if (error)
                return "multisig." + error;
        }
        if (message.script_type != null && message.hasOwnProperty("script_type"))
            switch (message.script_type) {
            default:
                return "script_type: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
                break;
            }
        return null;
    };

    GetOwnershipId.fromObject = function fromObject(object) {
        if (object instanceof $root.GetOwnershipId)
            return object;
        var message = new $root.GetOwnershipId();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".GetOwnershipId.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.coin_name != null)
            message.coin_name = String(object.coin_name);
        if (object.multisig != null) {
            if (typeof object.multisig !== "object")
                throw TypeError(".GetOwnershipId.multisig: object expected");
            message.multisig = $root.MultisigRedeemScriptType.fromObject(object.multisig);
        }
        switch (object.script_type) {
        case "SPENDADDRESS":
        case 0:
            message.script_type = 0;
            break;
        case "SPENDMULTISIG":
        case 1:
            message.script_type = 1;
            break;
        case "EXTERNAL":
        case 2:
            message.script_type = 2;
            break;
        case "SPENDWITNESS":
        case 3:
            message.script_type = 3;
            break;
        case "SPENDP2SHWITNESS":
        case 4:
            message.script_type = 4;
            break;
        case "SPENDTAPROOT":
        case 5:
            message.script_type = 5;
            break;
        }
        return message;
    };

    GetOwnershipId.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            object.coin_name = "Bitcoin";
            object.multisig = null;
            object.script_type = options.enums === String ? "SPENDADDRESS" : 0;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.coin_name != null && message.hasOwnProperty("coin_name"))
            object.coin_name = message.coin_name;
        if (message.multisig != null && message.hasOwnProperty("multisig"))
            object.multisig = $root.MultisigRedeemScriptType.toObject(message.multisig, options);
        if (message.script_type != null && message.hasOwnProperty("script_type"))
            object.script_type = options.enums === String ? $root.InputScriptType[message.script_type] : message.script_type;
        return object;
    };

    GetOwnershipId.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return GetOwnershipId;
})();

$root.OwnershipId = (function() {

    function OwnershipId(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    OwnershipId.prototype.ownership_id = $util.newBuffer([]);

    OwnershipId.create = function create(properties) {
        return new OwnershipId(properties);
    };

    OwnershipId.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.ownership_id);
        return writer;
    };

    OwnershipId.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    OwnershipId.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.OwnershipId();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.ownership_id = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("ownership_id"))
            throw $util.ProtocolError("missing required 'ownership_id'", { instance: message });
        return message;
    };

    OwnershipId.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    OwnershipId.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.ownership_id && typeof message.ownership_id.length === "number" || $util.isString(message.ownership_id)))
            return "ownership_id: buffer expected";
        return null;
    };

    OwnershipId.fromObject = function fromObject(object) {
        if (object instanceof $root.OwnershipId)
            return object;
        var message = new $root.OwnershipId();
        if (object.ownership_id != null)
            if (typeof object.ownership_id === "string")
                $util.base64.decode(object.ownership_id, message.ownership_id = $util.newBuffer($util.base64.length(object.ownership_id)), 0);
            else if (object.ownership_id.length)
                message.ownership_id = object.ownership_id;
        return message;
    };

    OwnershipId.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.ownership_id = "";
            else {
                object.ownership_id = [];
                if (options.bytes !== Array)
                    object.ownership_id = $util.newBuffer(object.ownership_id);
            }
        if (message.ownership_id != null && message.hasOwnProperty("ownership_id"))
            object.ownership_id = options.bytes === String ? $util.base64.encode(message.ownership_id, 0, message.ownership_id.length) : options.bytes === Array ? Array.prototype.slice.call(message.ownership_id) : message.ownership_id;
        return object;
    };

    OwnershipId.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return OwnershipId;
})();

$root.SignMessage = (function() {

    function SignMessage(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    SignMessage.prototype.address_n = $util.emptyArray;
    SignMessage.prototype.message = $util.newBuffer([]);
    SignMessage.prototype.coin_name = "Bitcoin";
    SignMessage.prototype.script_type = 0;
    SignMessage.prototype.no_script_type = false;
    SignMessage.prototype.is_bip322_simple = false;

    SignMessage.create = function create(properties) {
        return new SignMessage(properties);
    };

    SignMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).bytes(message.message);
        if (message.coin_name != null && Object.hasOwnProperty.call(message, "coin_name"))
            writer.uint32(26).string(message.coin_name);
        if (message.script_type != null && Object.hasOwnProperty.call(message, "script_type"))
            writer.uint32(32).int32(message.script_type);
        if (message.no_script_type != null && Object.hasOwnProperty.call(message, "no_script_type"))
            writer.uint32(40).bool(message.no_script_type);
        if (message.is_bip322_simple != null && Object.hasOwnProperty.call(message, "is_bip322_simple"))
            writer.uint32(80).bool(message.is_bip322_simple);
        return writer;
    };

    SignMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    SignMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SignMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.message = reader.bytes();
                break;
            case 3:
                message.coin_name = reader.string();
                break;
            case 4:
                message.script_type = reader.int32();
                break;
            case 5:
                message.no_script_type = reader.bool();
                break;
            case 10:
                message.is_bip322_simple = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("message"))
            throw $util.ProtocolError("missing required 'message'", { instance: message });
        return message;
    };

    SignMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    SignMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!(message.message && typeof message.message.length === "number" || $util.isString(message.message)))
            return "message: buffer expected";
        if (message.coin_name != null && message.hasOwnProperty("coin_name"))
            if (!$util.isString(message.coin_name))
                return "coin_name: string expected";
        if (message.script_type != null && message.hasOwnProperty("script_type"))
            switch (message.script_type) {
            default:
                return "script_type: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
                break;
            }
        if (message.no_script_type != null && message.hasOwnProperty("no_script_type"))
            if (typeof message.no_script_type !== "boolean")
                return "no_script_type: boolean expected";
        if (message.is_bip322_simple != null && message.hasOwnProperty("is_bip322_simple"))
            if (typeof message.is_bip322_simple !== "boolean")
                return "is_bip322_simple: boolean expected";
        return null;
    };

    SignMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.SignMessage)
            return object;
        var message = new $root.SignMessage();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".SignMessage.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.message != null)
            if (typeof object.message === "string")
                $util.base64.decode(object.message, message.message = $util.newBuffer($util.base64.length(object.message)), 0);
            else if (object.message.length)
                message.message = object.message;
        if (object.coin_name != null)
            message.coin_name = String(object.coin_name);
        switch (object.script_type) {
        case "SPENDADDRESS":
        case 0:
            message.script_type = 0;
            break;
        case "SPENDMULTISIG":
        case 1:
            message.script_type = 1;
            break;
        case "EXTERNAL":
        case 2:
            message.script_type = 2;
            break;
        case "SPENDWITNESS":
        case 3:
            message.script_type = 3;
            break;
        case "SPENDP2SHWITNESS":
        case 4:
            message.script_type = 4;
            break;
        case "SPENDTAPROOT":
        case 5:
            message.script_type = 5;
            break;
        }
        if (object.no_script_type != null)
            message.no_script_type = Boolean(object.no_script_type);
        if (object.is_bip322_simple != null)
            message.is_bip322_simple = Boolean(object.is_bip322_simple);
        return message;
    };

    SignMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            if (options.bytes === String)
                object.message = "";
            else {
                object.message = [];
                if (options.bytes !== Array)
                    object.message = $util.newBuffer(object.message);
            }
            object.coin_name = "Bitcoin";
            object.script_type = options.enums === String ? "SPENDADDRESS" : 0;
            object.no_script_type = false;
            object.is_bip322_simple = false;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.message != null && message.hasOwnProperty("message"))
            object.message = options.bytes === String ? $util.base64.encode(message.message, 0, message.message.length) : options.bytes === Array ? Array.prototype.slice.call(message.message) : message.message;
        if (message.coin_name != null && message.hasOwnProperty("coin_name"))
            object.coin_name = message.coin_name;
        if (message.script_type != null && message.hasOwnProperty("script_type"))
            object.script_type = options.enums === String ? $root.InputScriptType[message.script_type] : message.script_type;
        if (message.no_script_type != null && message.hasOwnProperty("no_script_type"))
            object.no_script_type = message.no_script_type;
        if (message.is_bip322_simple != null && message.hasOwnProperty("is_bip322_simple"))
            object.is_bip322_simple = message.is_bip322_simple;
        return object;
    };

    SignMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SignMessage;
})();

$root.MessageSignature = (function() {

    function MessageSignature(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MessageSignature.prototype.address = "";
    MessageSignature.prototype.signature = $util.newBuffer([]);

    MessageSignature.create = function create(properties) {
        return new MessageSignature(properties);
    };

    MessageSignature.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.address);
        writer.uint32(18).bytes(message.signature);
        return writer;
    };

    MessageSignature.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MessageSignature.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MessageSignature();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.string();
                break;
            case 2:
                message.signature = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("address"))
            throw $util.ProtocolError("missing required 'address'", { instance: message });
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        return message;
    };

    MessageSignature.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MessageSignature.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.address))
            return "address: string expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        return null;
    };

    MessageSignature.fromObject = function fromObject(object) {
        if (object instanceof $root.MessageSignature)
            return object;
        var message = new $root.MessageSignature();
        if (object.address != null)
            message.address = String(object.address);
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        return message;
    };

    MessageSignature.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.address = "";
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
        }
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        return object;
    };

    MessageSignature.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MessageSignature;
})();

$root.VerifyMessage = (function() {

    function VerifyMessage(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    VerifyMessage.prototype.address = "";
    VerifyMessage.prototype.signature = $util.newBuffer([]);
    VerifyMessage.prototype.message = $util.newBuffer([]);
    VerifyMessage.prototype.coin_name = "Bitcoin";

    VerifyMessage.create = function create(properties) {
        return new VerifyMessage(properties);
    };

    VerifyMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.address);
        writer.uint32(18).bytes(message.signature);
        writer.uint32(26).bytes(message.message);
        if (message.coin_name != null && Object.hasOwnProperty.call(message, "coin_name"))
            writer.uint32(34).string(message.coin_name);
        return writer;
    };

    VerifyMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    VerifyMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.VerifyMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.string();
                break;
            case 2:
                message.signature = reader.bytes();
                break;
            case 3:
                message.message = reader.bytes();
                break;
            case 4:
                message.coin_name = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("address"))
            throw $util.ProtocolError("missing required 'address'", { instance: message });
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        if (!message.hasOwnProperty("message"))
            throw $util.ProtocolError("missing required 'message'", { instance: message });
        return message;
    };

    VerifyMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    VerifyMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.address))
            return "address: string expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        if (!(message.message && typeof message.message.length === "number" || $util.isString(message.message)))
            return "message: buffer expected";
        if (message.coin_name != null && message.hasOwnProperty("coin_name"))
            if (!$util.isString(message.coin_name))
                return "coin_name: string expected";
        return null;
    };

    VerifyMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.VerifyMessage)
            return object;
        var message = new $root.VerifyMessage();
        if (object.address != null)
            message.address = String(object.address);
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        if (object.message != null)
            if (typeof object.message === "string")
                $util.base64.decode(object.message, message.message = $util.newBuffer($util.base64.length(object.message)), 0);
            else if (object.message.length)
                message.message = object.message;
        if (object.coin_name != null)
            message.coin_name = String(object.coin_name);
        return message;
    };

    VerifyMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.address = "";
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
            if (options.bytes === String)
                object.message = "";
            else {
                object.message = [];
                if (options.bytes !== Array)
                    object.message = $util.newBuffer(object.message);
            }
            object.coin_name = "Bitcoin";
        }
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        if (message.message != null && message.hasOwnProperty("message"))
            object.message = options.bytes === String ? $util.base64.encode(message.message, 0, message.message.length) : options.bytes === Array ? Array.prototype.slice.call(message.message) : message.message;
        if (message.coin_name != null && message.hasOwnProperty("coin_name"))
            object.coin_name = message.coin_name;
        return object;
    };

    VerifyMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return VerifyMessage;
})();

$root.SignTx = (function() {

    function SignTx(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    SignTx.prototype.outputs_count = 0;
    SignTx.prototype.inputs_count = 0;
    SignTx.prototype.coin_name = "Bitcoin";
    SignTx.prototype.version = 1;
    SignTx.prototype.lock_time = 0;
    SignTx.prototype.expiry = 0;
    SignTx.prototype.overwintered = false;
    SignTx.prototype.version_group_id = 0;
    SignTx.prototype.timestamp = 0;
    SignTx.prototype.branch_id = 0;
    SignTx.prototype.amount_unit = 0;
    SignTx.prototype.decred_staking_ticket = false;
    SignTx.prototype.serialize = true;
    SignTx.prototype.coinjoin_request = null;

    SignTx.create = function create(properties) {
        return new SignTx(properties);
    };

    SignTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).uint32(message.outputs_count);
        writer.uint32(16).uint32(message.inputs_count);
        if (message.coin_name != null && Object.hasOwnProperty.call(message, "coin_name"))
            writer.uint32(26).string(message.coin_name);
        if (message.version != null && Object.hasOwnProperty.call(message, "version"))
            writer.uint32(32).uint32(message.version);
        if (message.lock_time != null && Object.hasOwnProperty.call(message, "lock_time"))
            writer.uint32(40).uint32(message.lock_time);
        if (message.expiry != null && Object.hasOwnProperty.call(message, "expiry"))
            writer.uint32(48).uint32(message.expiry);
        if (message.overwintered != null && Object.hasOwnProperty.call(message, "overwintered"))
            writer.uint32(56).bool(message.overwintered);
        if (message.version_group_id != null && Object.hasOwnProperty.call(message, "version_group_id"))
            writer.uint32(64).uint32(message.version_group_id);
        if (message.timestamp != null && Object.hasOwnProperty.call(message, "timestamp"))
            writer.uint32(72).uint32(message.timestamp);
        if (message.branch_id != null && Object.hasOwnProperty.call(message, "branch_id"))
            writer.uint32(80).uint32(message.branch_id);
        if (message.amount_unit != null && Object.hasOwnProperty.call(message, "amount_unit"))
            writer.uint32(88).int32(message.amount_unit);
        if (message.decred_staking_ticket != null && Object.hasOwnProperty.call(message, "decred_staking_ticket"))
            writer.uint32(96).bool(message.decred_staking_ticket);
        if (message.serialize != null && Object.hasOwnProperty.call(message, "serialize"))
            writer.uint32(104).bool(message.serialize);
        if (message.coinjoin_request != null && Object.hasOwnProperty.call(message, "coinjoin_request"))
            $root.SignTx.CoinJoinRequest.encode(message.coinjoin_request, writer.uint32(114).fork()).ldelim();
        return writer;
    };

    SignTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    SignTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SignTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.outputs_count = reader.uint32();
                break;
            case 2:
                message.inputs_count = reader.uint32();
                break;
            case 3:
                message.coin_name = reader.string();
                break;
            case 4:
                message.version = reader.uint32();
                break;
            case 5:
                message.lock_time = reader.uint32();
                break;
            case 6:
                message.expiry = reader.uint32();
                break;
            case 7:
                message.overwintered = reader.bool();
                break;
            case 8:
                message.version_group_id = reader.uint32();
                break;
            case 9:
                message.timestamp = reader.uint32();
                break;
            case 10:
                message.branch_id = reader.uint32();
                break;
            case 11:
                message.amount_unit = reader.int32();
                break;
            case 12:
                message.decred_staking_ticket = reader.bool();
                break;
            case 13:
                message.serialize = reader.bool();
                break;
            case 14:
                message.coinjoin_request = $root.SignTx.CoinJoinRequest.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("outputs_count"))
            throw $util.ProtocolError("missing required 'outputs_count'", { instance: message });
        if (!message.hasOwnProperty("inputs_count"))
            throw $util.ProtocolError("missing required 'inputs_count'", { instance: message });
        return message;
    };

    SignTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    SignTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isInteger(message.outputs_count))
            return "outputs_count: integer expected";
        if (!$util.isInteger(message.inputs_count))
            return "inputs_count: integer expected";
        if (message.coin_name != null && message.hasOwnProperty("coin_name"))
            if (!$util.isString(message.coin_name))
                return "coin_name: string expected";
        if (message.version != null && message.hasOwnProperty("version"))
            if (!$util.isInteger(message.version))
                return "version: integer expected";
        if (message.lock_time != null && message.hasOwnProperty("lock_time"))
            if (!$util.isInteger(message.lock_time))
                return "lock_time: integer expected";
        if (message.expiry != null && message.hasOwnProperty("expiry"))
            if (!$util.isInteger(message.expiry))
                return "expiry: integer expected";
        if (message.overwintered != null && message.hasOwnProperty("overwintered"))
            if (typeof message.overwintered !== "boolean")
                return "overwintered: boolean expected";
        if (message.version_group_id != null && message.hasOwnProperty("version_group_id"))
            if (!$util.isInteger(message.version_group_id))
                return "version_group_id: integer expected";
        if (message.timestamp != null && message.hasOwnProperty("timestamp"))
            if (!$util.isInteger(message.timestamp))
                return "timestamp: integer expected";
        if (message.branch_id != null && message.hasOwnProperty("branch_id"))
            if (!$util.isInteger(message.branch_id))
                return "branch_id: integer expected";
        if (message.amount_unit != null && message.hasOwnProperty("amount_unit"))
            switch (message.amount_unit) {
            default:
                return "amount_unit: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
                break;
            }
        if (message.decred_staking_ticket != null && message.hasOwnProperty("decred_staking_ticket"))
            if (typeof message.decred_staking_ticket !== "boolean")
                return "decred_staking_ticket: boolean expected";
        if (message.serialize != null && message.hasOwnProperty("serialize"))
            if (typeof message.serialize !== "boolean")
                return "serialize: boolean expected";
        if (message.coinjoin_request != null && message.hasOwnProperty("coinjoin_request")) {
            var error = $root.SignTx.CoinJoinRequest.verify(message.coinjoin_request);
            if (error)
                return "coinjoin_request." + error;
        }
        return null;
    };

    SignTx.fromObject = function fromObject(object) {
        if (object instanceof $root.SignTx)
            return object;
        var message = new $root.SignTx();
        if (object.outputs_count != null)
            message.outputs_count = object.outputs_count >>> 0;
        if (object.inputs_count != null)
            message.inputs_count = object.inputs_count >>> 0;
        if (object.coin_name != null)
            message.coin_name = String(object.coin_name);
        if (object.version != null)
            message.version = object.version >>> 0;
        if (object.lock_time != null)
            message.lock_time = object.lock_time >>> 0;
        if (object.expiry != null)
            message.expiry = object.expiry >>> 0;
        if (object.overwintered != null)
            message.overwintered = Boolean(object.overwintered);
        if (object.version_group_id != null)
            message.version_group_id = object.version_group_id >>> 0;
        if (object.timestamp != null)
            message.timestamp = object.timestamp >>> 0;
        if (object.branch_id != null)
            message.branch_id = object.branch_id >>> 0;
        switch (object.amount_unit) {
        case "BITCOIN":
        case 0:
            message.amount_unit = 0;
            break;
        case "MILLIBITCOIN":
        case 1:
            message.amount_unit = 1;
            break;
        case "MICROBITCOIN":
        case 2:
            message.amount_unit = 2;
            break;
        case "SATOSHI":
        case 3:
            message.amount_unit = 3;
            break;
        }
        if (object.decred_staking_ticket != null)
            message.decred_staking_ticket = Boolean(object.decred_staking_ticket);
        if (object.serialize != null)
            message.serialize = Boolean(object.serialize);
        if (object.coinjoin_request != null) {
            if (typeof object.coinjoin_request !== "object")
                throw TypeError(".SignTx.coinjoin_request: object expected");
            message.coinjoin_request = $root.SignTx.CoinJoinRequest.fromObject(object.coinjoin_request);
        }
        return message;
    };

    SignTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.outputs_count = 0;
            object.inputs_count = 0;
            object.coin_name = "Bitcoin";
            object.version = 1;
            object.lock_time = 0;
            object.expiry = 0;
            object.overwintered = false;
            object.version_group_id = 0;
            object.timestamp = 0;
            object.branch_id = 0;
            object.amount_unit = options.enums === String ? "BITCOIN" : 0;
            object.decred_staking_ticket = false;
            object.serialize = true;
            object.coinjoin_request = null;
        }
        if (message.outputs_count != null && message.hasOwnProperty("outputs_count"))
            object.outputs_count = message.outputs_count;
        if (message.inputs_count != null && message.hasOwnProperty("inputs_count"))
            object.inputs_count = message.inputs_count;
        if (message.coin_name != null && message.hasOwnProperty("coin_name"))
            object.coin_name = message.coin_name;
        if (message.version != null && message.hasOwnProperty("version"))
            object.version = message.version;
        if (message.lock_time != null && message.hasOwnProperty("lock_time"))
            object.lock_time = message.lock_time;
        if (message.expiry != null && message.hasOwnProperty("expiry"))
            object.expiry = message.expiry;
        if (message.overwintered != null && message.hasOwnProperty("overwintered"))
            object.overwintered = message.overwintered;
        if (message.version_group_id != null && message.hasOwnProperty("version_group_id"))
            object.version_group_id = message.version_group_id;
        if (message.timestamp != null && message.hasOwnProperty("timestamp"))
            object.timestamp = message.timestamp;
        if (message.branch_id != null && message.hasOwnProperty("branch_id"))
            object.branch_id = message.branch_id;
        if (message.amount_unit != null && message.hasOwnProperty("amount_unit"))
            object.amount_unit = options.enums === String ? $root.AmountUnit[message.amount_unit] : message.amount_unit;
        if (message.decred_staking_ticket != null && message.hasOwnProperty("decred_staking_ticket"))
            object.decred_staking_ticket = message.decred_staking_ticket;
        if (message.serialize != null && message.hasOwnProperty("serialize"))
            object.serialize = message.serialize;
        if (message.coinjoin_request != null && message.hasOwnProperty("coinjoin_request"))
            object.coinjoin_request = $root.SignTx.CoinJoinRequest.toObject(message.coinjoin_request, options);
        return object;
    };

    SignTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    SignTx.CoinJoinRequest = (function() {

        function CoinJoinRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        CoinJoinRequest.prototype.fee_rate = 0;
        CoinJoinRequest.prototype.no_fee_threshold = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        CoinJoinRequest.prototype.min_registrable_amount = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        CoinJoinRequest.prototype.mask_public_key = $util.newBuffer([]);
        CoinJoinRequest.prototype.signature = $util.newBuffer([]);

        CoinJoinRequest.create = function create(properties) {
            return new CoinJoinRequest(properties);
        };

        CoinJoinRequest.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(8).uint32(message.fee_rate);
            writer.uint32(16).uint64(message.no_fee_threshold);
            writer.uint32(24).uint64(message.min_registrable_amount);
            writer.uint32(34).bytes(message.mask_public_key);
            writer.uint32(42).bytes(message.signature);
            return writer;
        };

        CoinJoinRequest.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        CoinJoinRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SignTx.CoinJoinRequest();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.fee_rate = reader.uint32();
                    break;
                case 2:
                    message.no_fee_threshold = reader.uint64();
                    break;
                case 3:
                    message.min_registrable_amount = reader.uint64();
                    break;
                case 4:
                    message.mask_public_key = reader.bytes();
                    break;
                case 5:
                    message.signature = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("fee_rate"))
                throw $util.ProtocolError("missing required 'fee_rate'", { instance: message });
            if (!message.hasOwnProperty("no_fee_threshold"))
                throw $util.ProtocolError("missing required 'no_fee_threshold'", { instance: message });
            if (!message.hasOwnProperty("min_registrable_amount"))
                throw $util.ProtocolError("missing required 'min_registrable_amount'", { instance: message });
            if (!message.hasOwnProperty("mask_public_key"))
                throw $util.ProtocolError("missing required 'mask_public_key'", { instance: message });
            if (!message.hasOwnProperty("signature"))
                throw $util.ProtocolError("missing required 'signature'", { instance: message });
            return message;
        };

        CoinJoinRequest.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        CoinJoinRequest.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isInteger(message.fee_rate))
                return "fee_rate: integer expected";
            if (!$util.isInteger(message.no_fee_threshold) && !(message.no_fee_threshold && $util.isInteger(message.no_fee_threshold.low) && $util.isInteger(message.no_fee_threshold.high)))
                return "no_fee_threshold: integer|Long expected";
            if (!$util.isInteger(message.min_registrable_amount) && !(message.min_registrable_amount && $util.isInteger(message.min_registrable_amount.low) && $util.isInteger(message.min_registrable_amount.high)))
                return "min_registrable_amount: integer|Long expected";
            if (!(message.mask_public_key && typeof message.mask_public_key.length === "number" || $util.isString(message.mask_public_key)))
                return "mask_public_key: buffer expected";
            if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
                return "signature: buffer expected";
            return null;
        };

        CoinJoinRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.SignTx.CoinJoinRequest)
                return object;
            var message = new $root.SignTx.CoinJoinRequest();
            if (object.fee_rate != null)
                message.fee_rate = object.fee_rate >>> 0;
            if (object.no_fee_threshold != null)
                if ($util.Long)
                    (message.no_fee_threshold = $util.Long.fromValue(object.no_fee_threshold)).unsigned = true;
                else if (typeof object.no_fee_threshold === "string")
                    message.no_fee_threshold = parseInt(object.no_fee_threshold, 10);
                else if (typeof object.no_fee_threshold === "number")
                    message.no_fee_threshold = object.no_fee_threshold;
                else if (typeof object.no_fee_threshold === "object")
                    message.no_fee_threshold = new $util.LongBits(object.no_fee_threshold.low >>> 0, object.no_fee_threshold.high >>> 0).toNumber(true);
            if (object.min_registrable_amount != null)
                if ($util.Long)
                    (message.min_registrable_amount = $util.Long.fromValue(object.min_registrable_amount)).unsigned = true;
                else if (typeof object.min_registrable_amount === "string")
                    message.min_registrable_amount = parseInt(object.min_registrable_amount, 10);
                else if (typeof object.min_registrable_amount === "number")
                    message.min_registrable_amount = object.min_registrable_amount;
                else if (typeof object.min_registrable_amount === "object")
                    message.min_registrable_amount = new $util.LongBits(object.min_registrable_amount.low >>> 0, object.min_registrable_amount.high >>> 0).toNumber(true);
            if (object.mask_public_key != null)
                if (typeof object.mask_public_key === "string")
                    $util.base64.decode(object.mask_public_key, message.mask_public_key = $util.newBuffer($util.base64.length(object.mask_public_key)), 0);
                else if (object.mask_public_key.length)
                    message.mask_public_key = object.mask_public_key;
            if (object.signature != null)
                if (typeof object.signature === "string")
                    $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
                else if (object.signature.length)
                    message.signature = object.signature;
            return message;
        };

        CoinJoinRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.fee_rate = 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.no_fee_threshold = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.no_fee_threshold = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.min_registrable_amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.min_registrable_amount = options.longs === String ? "0" : 0;
                if (options.bytes === String)
                    object.mask_public_key = "";
                else {
                    object.mask_public_key = [];
                    if (options.bytes !== Array)
                        object.mask_public_key = $util.newBuffer(object.mask_public_key);
                }
                if (options.bytes === String)
                    object.signature = "";
                else {
                    object.signature = [];
                    if (options.bytes !== Array)
                        object.signature = $util.newBuffer(object.signature);
                }
            }
            if (message.fee_rate != null && message.hasOwnProperty("fee_rate"))
                object.fee_rate = message.fee_rate;
            if (message.no_fee_threshold != null && message.hasOwnProperty("no_fee_threshold"))
                if (typeof message.no_fee_threshold === "number")
                    object.no_fee_threshold = options.longs === String ? String(message.no_fee_threshold) : message.no_fee_threshold;
                else
                    object.no_fee_threshold = options.longs === String ? $util.Long.prototype.toString.call(message.no_fee_threshold) : options.longs === Number ? new $util.LongBits(message.no_fee_threshold.low >>> 0, message.no_fee_threshold.high >>> 0).toNumber(true) : message.no_fee_threshold;
            if (message.min_registrable_amount != null && message.hasOwnProperty("min_registrable_amount"))
                if (typeof message.min_registrable_amount === "number")
                    object.min_registrable_amount = options.longs === String ? String(message.min_registrable_amount) : message.min_registrable_amount;
                else
                    object.min_registrable_amount = options.longs === String ? $util.Long.prototype.toString.call(message.min_registrable_amount) : options.longs === Number ? new $util.LongBits(message.min_registrable_amount.low >>> 0, message.min_registrable_amount.high >>> 0).toNumber(true) : message.min_registrable_amount;
            if (message.mask_public_key != null && message.hasOwnProperty("mask_public_key"))
                object.mask_public_key = options.bytes === String ? $util.base64.encode(message.mask_public_key, 0, message.mask_public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.mask_public_key) : message.mask_public_key;
            if (message.signature != null && message.hasOwnProperty("signature"))
                object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
            return object;
        };

        CoinJoinRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CoinJoinRequest;
    })();

    return SignTx;
})();

$root.TxRequest = (function() {

    function TxRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    TxRequest.prototype.request_type = 0;
    TxRequest.prototype.details = null;
    TxRequest.prototype.serialized = null;

    TxRequest.create = function create(properties) {
        return new TxRequest(properties);
    };

    TxRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.request_type != null && Object.hasOwnProperty.call(message, "request_type"))
            writer.uint32(8).int32(message.request_type);
        if (message.details != null && Object.hasOwnProperty.call(message, "details"))
            $root.TxRequest.TxRequestDetailsType.encode(message.details, writer.uint32(18).fork()).ldelim();
        if (message.serialized != null && Object.hasOwnProperty.call(message, "serialized"))
            $root.TxRequest.TxRequestSerializedType.encode(message.serialized, writer.uint32(26).fork()).ldelim();
        return writer;
    };

    TxRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    TxRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TxRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.request_type = reader.int32();
                break;
            case 2:
                message.details = $root.TxRequest.TxRequestDetailsType.decode(reader, reader.uint32());
                break;
            case 3:
                message.serialized = $root.TxRequest.TxRequestSerializedType.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    TxRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    TxRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.request_type != null && message.hasOwnProperty("request_type"))
            switch (message.request_type) {
            default:
                return "request_type: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
                break;
            }
        if (message.details != null && message.hasOwnProperty("details")) {
            var error = $root.TxRequest.TxRequestDetailsType.verify(message.details);
            if (error)
                return "details." + error;
        }
        if (message.serialized != null && message.hasOwnProperty("serialized")) {
            var error = $root.TxRequest.TxRequestSerializedType.verify(message.serialized);
            if (error)
                return "serialized." + error;
        }
        return null;
    };

    TxRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.TxRequest)
            return object;
        var message = new $root.TxRequest();
        switch (object.request_type) {
        case "TXINPUT":
        case 0:
            message.request_type = 0;
            break;
        case "TXOUTPUT":
        case 1:
            message.request_type = 1;
            break;
        case "TXMETA":
        case 2:
            message.request_type = 2;
            break;
        case "TXFINISHED":
        case 3:
            message.request_type = 3;
            break;
        case "TXEXTRADATA":
        case 4:
            message.request_type = 4;
            break;
        case "TXORIGINPUT":
        case 5:
            message.request_type = 5;
            break;
        case "TXORIGOUTPUT":
        case 6:
            message.request_type = 6;
            break;
        case "TXPAYMENTREQ":
        case 7:
            message.request_type = 7;
            break;
        }
        if (object.details != null) {
            if (typeof object.details !== "object")
                throw TypeError(".TxRequest.details: object expected");
            message.details = $root.TxRequest.TxRequestDetailsType.fromObject(object.details);
        }
        if (object.serialized != null) {
            if (typeof object.serialized !== "object")
                throw TypeError(".TxRequest.serialized: object expected");
            message.serialized = $root.TxRequest.TxRequestSerializedType.fromObject(object.serialized);
        }
        return message;
    };

    TxRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.request_type = options.enums === String ? "TXINPUT" : 0;
            object.details = null;
            object.serialized = null;
        }
        if (message.request_type != null && message.hasOwnProperty("request_type"))
            object.request_type = options.enums === String ? $root.TxRequest.RequestType[message.request_type] : message.request_type;
        if (message.details != null && message.hasOwnProperty("details"))
            object.details = $root.TxRequest.TxRequestDetailsType.toObject(message.details, options);
        if (message.serialized != null && message.hasOwnProperty("serialized"))
            object.serialized = $root.TxRequest.TxRequestSerializedType.toObject(message.serialized, options);
        return object;
    };

    TxRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    TxRequest.RequestType = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "TXINPUT"] = 0;
        values[valuesById[1] = "TXOUTPUT"] = 1;
        values[valuesById[2] = "TXMETA"] = 2;
        values[valuesById[3] = "TXFINISHED"] = 3;
        values[valuesById[4] = "TXEXTRADATA"] = 4;
        values[valuesById[5] = "TXORIGINPUT"] = 5;
        values[valuesById[6] = "TXORIGOUTPUT"] = 6;
        values[valuesById[7] = "TXPAYMENTREQ"] = 7;
        return values;
    })();

    TxRequest.TxRequestDetailsType = (function() {

        function TxRequestDetailsType(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        TxRequestDetailsType.prototype.request_index = 0;
        TxRequestDetailsType.prototype.tx_hash = $util.newBuffer([]);
        TxRequestDetailsType.prototype.extra_data_len = 0;
        TxRequestDetailsType.prototype.extra_data_offset = 0;

        TxRequestDetailsType.create = function create(properties) {
            return new TxRequestDetailsType(properties);
        };

        TxRequestDetailsType.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.request_index != null && Object.hasOwnProperty.call(message, "request_index"))
                writer.uint32(8).uint32(message.request_index);
            if (message.tx_hash != null && Object.hasOwnProperty.call(message, "tx_hash"))
                writer.uint32(18).bytes(message.tx_hash);
            if (message.extra_data_len != null && Object.hasOwnProperty.call(message, "extra_data_len"))
                writer.uint32(24).uint32(message.extra_data_len);
            if (message.extra_data_offset != null && Object.hasOwnProperty.call(message, "extra_data_offset"))
                writer.uint32(32).uint32(message.extra_data_offset);
            return writer;
        };

        TxRequestDetailsType.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        TxRequestDetailsType.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TxRequest.TxRequestDetailsType();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.request_index = reader.uint32();
                    break;
                case 2:
                    message.tx_hash = reader.bytes();
                    break;
                case 3:
                    message.extra_data_len = reader.uint32();
                    break;
                case 4:
                    message.extra_data_offset = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        TxRequestDetailsType.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        TxRequestDetailsType.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.request_index != null && message.hasOwnProperty("request_index"))
                if (!$util.isInteger(message.request_index))
                    return "request_index: integer expected";
            if (message.tx_hash != null && message.hasOwnProperty("tx_hash"))
                if (!(message.tx_hash && typeof message.tx_hash.length === "number" || $util.isString(message.tx_hash)))
                    return "tx_hash: buffer expected";
            if (message.extra_data_len != null && message.hasOwnProperty("extra_data_len"))
                if (!$util.isInteger(message.extra_data_len))
                    return "extra_data_len: integer expected";
            if (message.extra_data_offset != null && message.hasOwnProperty("extra_data_offset"))
                if (!$util.isInteger(message.extra_data_offset))
                    return "extra_data_offset: integer expected";
            return null;
        };

        TxRequestDetailsType.fromObject = function fromObject(object) {
            if (object instanceof $root.TxRequest.TxRequestDetailsType)
                return object;
            var message = new $root.TxRequest.TxRequestDetailsType();
            if (object.request_index != null)
                message.request_index = object.request_index >>> 0;
            if (object.tx_hash != null)
                if (typeof object.tx_hash === "string")
                    $util.base64.decode(object.tx_hash, message.tx_hash = $util.newBuffer($util.base64.length(object.tx_hash)), 0);
                else if (object.tx_hash.length)
                    message.tx_hash = object.tx_hash;
            if (object.extra_data_len != null)
                message.extra_data_len = object.extra_data_len >>> 0;
            if (object.extra_data_offset != null)
                message.extra_data_offset = object.extra_data_offset >>> 0;
            return message;
        };

        TxRequestDetailsType.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.request_index = 0;
                if (options.bytes === String)
                    object.tx_hash = "";
                else {
                    object.tx_hash = [];
                    if (options.bytes !== Array)
                        object.tx_hash = $util.newBuffer(object.tx_hash);
                }
                object.extra_data_len = 0;
                object.extra_data_offset = 0;
            }
            if (message.request_index != null && message.hasOwnProperty("request_index"))
                object.request_index = message.request_index;
            if (message.tx_hash != null && message.hasOwnProperty("tx_hash"))
                object.tx_hash = options.bytes === String ? $util.base64.encode(message.tx_hash, 0, message.tx_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.tx_hash) : message.tx_hash;
            if (message.extra_data_len != null && message.hasOwnProperty("extra_data_len"))
                object.extra_data_len = message.extra_data_len;
            if (message.extra_data_offset != null && message.hasOwnProperty("extra_data_offset"))
                object.extra_data_offset = message.extra_data_offset;
            return object;
        };

        TxRequestDetailsType.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TxRequestDetailsType;
    })();

    TxRequest.TxRequestSerializedType = (function() {

        function TxRequestSerializedType(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        TxRequestSerializedType.prototype.signature_index = 0;
        TxRequestSerializedType.prototype.signature = $util.newBuffer([]);
        TxRequestSerializedType.prototype.serialized_tx = $util.newBuffer([]);

        TxRequestSerializedType.create = function create(properties) {
            return new TxRequestSerializedType(properties);
        };

        TxRequestSerializedType.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.signature_index != null && Object.hasOwnProperty.call(message, "signature_index"))
                writer.uint32(8).uint32(message.signature_index);
            if (message.signature != null && Object.hasOwnProperty.call(message, "signature"))
                writer.uint32(18).bytes(message.signature);
            if (message.serialized_tx != null && Object.hasOwnProperty.call(message, "serialized_tx"))
                writer.uint32(26).bytes(message.serialized_tx);
            return writer;
        };

        TxRequestSerializedType.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        TxRequestSerializedType.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TxRequest.TxRequestSerializedType();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.signature_index = reader.uint32();
                    break;
                case 2:
                    message.signature = reader.bytes();
                    break;
                case 3:
                    message.serialized_tx = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        TxRequestSerializedType.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        TxRequestSerializedType.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.signature_index != null && message.hasOwnProperty("signature_index"))
                if (!$util.isInteger(message.signature_index))
                    return "signature_index: integer expected";
            if (message.signature != null && message.hasOwnProperty("signature"))
                if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
                    return "signature: buffer expected";
            if (message.serialized_tx != null && message.hasOwnProperty("serialized_tx"))
                if (!(message.serialized_tx && typeof message.serialized_tx.length === "number" || $util.isString(message.serialized_tx)))
                    return "serialized_tx: buffer expected";
            return null;
        };

        TxRequestSerializedType.fromObject = function fromObject(object) {
            if (object instanceof $root.TxRequest.TxRequestSerializedType)
                return object;
            var message = new $root.TxRequest.TxRequestSerializedType();
            if (object.signature_index != null)
                message.signature_index = object.signature_index >>> 0;
            if (object.signature != null)
                if (typeof object.signature === "string")
                    $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
                else if (object.signature.length)
                    message.signature = object.signature;
            if (object.serialized_tx != null)
                if (typeof object.serialized_tx === "string")
                    $util.base64.decode(object.serialized_tx, message.serialized_tx = $util.newBuffer($util.base64.length(object.serialized_tx)), 0);
                else if (object.serialized_tx.length)
                    message.serialized_tx = object.serialized_tx;
            return message;
        };

        TxRequestSerializedType.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.signature_index = 0;
                if (options.bytes === String)
                    object.signature = "";
                else {
                    object.signature = [];
                    if (options.bytes !== Array)
                        object.signature = $util.newBuffer(object.signature);
                }
                if (options.bytes === String)
                    object.serialized_tx = "";
                else {
                    object.serialized_tx = [];
                    if (options.bytes !== Array)
                        object.serialized_tx = $util.newBuffer(object.serialized_tx);
                }
            }
            if (message.signature_index != null && message.hasOwnProperty("signature_index"))
                object.signature_index = message.signature_index;
            if (message.signature != null && message.hasOwnProperty("signature"))
                object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
            if (message.serialized_tx != null && message.hasOwnProperty("serialized_tx"))
                object.serialized_tx = options.bytes === String ? $util.base64.encode(message.serialized_tx, 0, message.serialized_tx.length) : options.bytes === Array ? Array.prototype.slice.call(message.serialized_tx) : message.serialized_tx;
            return object;
        };

        TxRequestSerializedType.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TxRequestSerializedType;
    })();

    return TxRequest;
})();

$root.TxAck = (function() {

    function TxAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    TxAck.prototype.tx = null;

    TxAck.create = function create(properties) {
        return new TxAck(properties);
    };

    TxAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.tx != null && Object.hasOwnProperty.call(message, "tx"))
            $root.TxAck.TransactionType.encode(message.tx, writer.uint32(10).fork()).ldelim();
        return writer;
    };

    TxAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    TxAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TxAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.tx = $root.TxAck.TransactionType.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    TxAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    TxAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.tx != null && message.hasOwnProperty("tx")) {
            var error = $root.TxAck.TransactionType.verify(message.tx);
            if (error)
                return "tx." + error;
        }
        return null;
    };

    TxAck.fromObject = function fromObject(object) {
        if (object instanceof $root.TxAck)
            return object;
        var message = new $root.TxAck();
        if (object.tx != null) {
            if (typeof object.tx !== "object")
                throw TypeError(".TxAck.tx: object expected");
            message.tx = $root.TxAck.TransactionType.fromObject(object.tx);
        }
        return message;
    };

    TxAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.tx = null;
        if (message.tx != null && message.hasOwnProperty("tx"))
            object.tx = $root.TxAck.TransactionType.toObject(message.tx, options);
        return object;
    };

    TxAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    TxAck.TransactionType = (function() {

        function TransactionType(properties) {
            this.inputs = [];
            this.bin_outputs = [];
            this.outputs = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        TransactionType.prototype.version = 0;
        TransactionType.prototype.inputs = $util.emptyArray;
        TransactionType.prototype.bin_outputs = $util.emptyArray;
        TransactionType.prototype.lock_time = 0;
        TransactionType.prototype.outputs = $util.emptyArray;
        TransactionType.prototype.inputs_cnt = 0;
        TransactionType.prototype.outputs_cnt = 0;
        TransactionType.prototype.extra_data = $util.newBuffer([]);
        TransactionType.prototype.extra_data_len = 0;
        TransactionType.prototype.expiry = 0;
        TransactionType.prototype.overwintered = false;
        TransactionType.prototype.version_group_id = 0;
        TransactionType.prototype.timestamp = 0;
        TransactionType.prototype.branch_id = 0;

        TransactionType.create = function create(properties) {
            return new TransactionType(properties);
        };

        TransactionType.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.version != null && Object.hasOwnProperty.call(message, "version"))
                writer.uint32(8).uint32(message.version);
            if (message.inputs != null && message.inputs.length)
                for (var i = 0; i < message.inputs.length; ++i)
                    $root.TxAck.TransactionType.TxInputType.encode(message.inputs[i], writer.uint32(18).fork()).ldelim();
            if (message.bin_outputs != null && message.bin_outputs.length)
                for (var i = 0; i < message.bin_outputs.length; ++i)
                    $root.TxAck.TransactionType.TxOutputBinType.encode(message.bin_outputs[i], writer.uint32(26).fork()).ldelim();
            if (message.lock_time != null && Object.hasOwnProperty.call(message, "lock_time"))
                writer.uint32(32).uint32(message.lock_time);
            if (message.outputs != null && message.outputs.length)
                for (var i = 0; i < message.outputs.length; ++i)
                    $root.TxAck.TransactionType.TxOutputType.encode(message.outputs[i], writer.uint32(42).fork()).ldelim();
            if (message.inputs_cnt != null && Object.hasOwnProperty.call(message, "inputs_cnt"))
                writer.uint32(48).uint32(message.inputs_cnt);
            if (message.outputs_cnt != null && Object.hasOwnProperty.call(message, "outputs_cnt"))
                writer.uint32(56).uint32(message.outputs_cnt);
            if (message.extra_data != null && Object.hasOwnProperty.call(message, "extra_data"))
                writer.uint32(66).bytes(message.extra_data);
            if (message.extra_data_len != null && Object.hasOwnProperty.call(message, "extra_data_len"))
                writer.uint32(72).uint32(message.extra_data_len);
            if (message.expiry != null && Object.hasOwnProperty.call(message, "expiry"))
                writer.uint32(80).uint32(message.expiry);
            if (message.overwintered != null && Object.hasOwnProperty.call(message, "overwintered"))
                writer.uint32(88).bool(message.overwintered);
            if (message.version_group_id != null && Object.hasOwnProperty.call(message, "version_group_id"))
                writer.uint32(96).uint32(message.version_group_id);
            if (message.timestamp != null && Object.hasOwnProperty.call(message, "timestamp"))
                writer.uint32(104).uint32(message.timestamp);
            if (message.branch_id != null && Object.hasOwnProperty.call(message, "branch_id"))
                writer.uint32(112).uint32(message.branch_id);
            return writer;
        };

        TransactionType.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        TransactionType.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TxAck.TransactionType();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.version = reader.uint32();
                    break;
                case 2:
                    if (!(message.inputs && message.inputs.length))
                        message.inputs = [];
                    message.inputs.push($root.TxAck.TransactionType.TxInputType.decode(reader, reader.uint32()));
                    break;
                case 3:
                    if (!(message.bin_outputs && message.bin_outputs.length))
                        message.bin_outputs = [];
                    message.bin_outputs.push($root.TxAck.TransactionType.TxOutputBinType.decode(reader, reader.uint32()));
                    break;
                case 4:
                    message.lock_time = reader.uint32();
                    break;
                case 5:
                    if (!(message.outputs && message.outputs.length))
                        message.outputs = [];
                    message.outputs.push($root.TxAck.TransactionType.TxOutputType.decode(reader, reader.uint32()));
                    break;
                case 6:
                    message.inputs_cnt = reader.uint32();
                    break;
                case 7:
                    message.outputs_cnt = reader.uint32();
                    break;
                case 8:
                    message.extra_data = reader.bytes();
                    break;
                case 9:
                    message.extra_data_len = reader.uint32();
                    break;
                case 10:
                    message.expiry = reader.uint32();
                    break;
                case 11:
                    message.overwintered = reader.bool();
                    break;
                case 12:
                    message.version_group_id = reader.uint32();
                    break;
                case 13:
                    message.timestamp = reader.uint32();
                    break;
                case 14:
                    message.branch_id = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        TransactionType.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        TransactionType.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.version != null && message.hasOwnProperty("version"))
                if (!$util.isInteger(message.version))
                    return "version: integer expected";
            if (message.inputs != null && message.hasOwnProperty("inputs")) {
                if (!Array.isArray(message.inputs))
                    return "inputs: array expected";
                for (var i = 0; i < message.inputs.length; ++i) {
                    var error = $root.TxAck.TransactionType.TxInputType.verify(message.inputs[i]);
                    if (error)
                        return "inputs." + error;
                }
            }
            if (message.bin_outputs != null && message.hasOwnProperty("bin_outputs")) {
                if (!Array.isArray(message.bin_outputs))
                    return "bin_outputs: array expected";
                for (var i = 0; i < message.bin_outputs.length; ++i) {
                    var error = $root.TxAck.TransactionType.TxOutputBinType.verify(message.bin_outputs[i]);
                    if (error)
                        return "bin_outputs." + error;
                }
            }
            if (message.lock_time != null && message.hasOwnProperty("lock_time"))
                if (!$util.isInteger(message.lock_time))
                    return "lock_time: integer expected";
            if (message.outputs != null && message.hasOwnProperty("outputs")) {
                if (!Array.isArray(message.outputs))
                    return "outputs: array expected";
                for (var i = 0; i < message.outputs.length; ++i) {
                    var error = $root.TxAck.TransactionType.TxOutputType.verify(message.outputs[i]);
                    if (error)
                        return "outputs." + error;
                }
            }
            if (message.inputs_cnt != null && message.hasOwnProperty("inputs_cnt"))
                if (!$util.isInteger(message.inputs_cnt))
                    return "inputs_cnt: integer expected";
            if (message.outputs_cnt != null && message.hasOwnProperty("outputs_cnt"))
                if (!$util.isInteger(message.outputs_cnt))
                    return "outputs_cnt: integer expected";
            if (message.extra_data != null && message.hasOwnProperty("extra_data"))
                if (!(message.extra_data && typeof message.extra_data.length === "number" || $util.isString(message.extra_data)))
                    return "extra_data: buffer expected";
            if (message.extra_data_len != null && message.hasOwnProperty("extra_data_len"))
                if (!$util.isInteger(message.extra_data_len))
                    return "extra_data_len: integer expected";
            if (message.expiry != null && message.hasOwnProperty("expiry"))
                if (!$util.isInteger(message.expiry))
                    return "expiry: integer expected";
            if (message.overwintered != null && message.hasOwnProperty("overwintered"))
                if (typeof message.overwintered !== "boolean")
                    return "overwintered: boolean expected";
            if (message.version_group_id != null && message.hasOwnProperty("version_group_id"))
                if (!$util.isInteger(message.version_group_id))
                    return "version_group_id: integer expected";
            if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                if (!$util.isInteger(message.timestamp))
                    return "timestamp: integer expected";
            if (message.branch_id != null && message.hasOwnProperty("branch_id"))
                if (!$util.isInteger(message.branch_id))
                    return "branch_id: integer expected";
            return null;
        };

        TransactionType.fromObject = function fromObject(object) {
            if (object instanceof $root.TxAck.TransactionType)
                return object;
            var message = new $root.TxAck.TransactionType();
            if (object.version != null)
                message.version = object.version >>> 0;
            if (object.inputs) {
                if (!Array.isArray(object.inputs))
                    throw TypeError(".TxAck.TransactionType.inputs: array expected");
                message.inputs = [];
                for (var i = 0; i < object.inputs.length; ++i) {
                    if (typeof object.inputs[i] !== "object")
                        throw TypeError(".TxAck.TransactionType.inputs: object expected");
                    message.inputs[i] = $root.TxAck.TransactionType.TxInputType.fromObject(object.inputs[i]);
                }
            }
            if (object.bin_outputs) {
                if (!Array.isArray(object.bin_outputs))
                    throw TypeError(".TxAck.TransactionType.bin_outputs: array expected");
                message.bin_outputs = [];
                for (var i = 0; i < object.bin_outputs.length; ++i) {
                    if (typeof object.bin_outputs[i] !== "object")
                        throw TypeError(".TxAck.TransactionType.bin_outputs: object expected");
                    message.bin_outputs[i] = $root.TxAck.TransactionType.TxOutputBinType.fromObject(object.bin_outputs[i]);
                }
            }
            if (object.lock_time != null)
                message.lock_time = object.lock_time >>> 0;
            if (object.outputs) {
                if (!Array.isArray(object.outputs))
                    throw TypeError(".TxAck.TransactionType.outputs: array expected");
                message.outputs = [];
                for (var i = 0; i < object.outputs.length; ++i) {
                    if (typeof object.outputs[i] !== "object")
                        throw TypeError(".TxAck.TransactionType.outputs: object expected");
                    message.outputs[i] = $root.TxAck.TransactionType.TxOutputType.fromObject(object.outputs[i]);
                }
            }
            if (object.inputs_cnt != null)
                message.inputs_cnt = object.inputs_cnt >>> 0;
            if (object.outputs_cnt != null)
                message.outputs_cnt = object.outputs_cnt >>> 0;
            if (object.extra_data != null)
                if (typeof object.extra_data === "string")
                    $util.base64.decode(object.extra_data, message.extra_data = $util.newBuffer($util.base64.length(object.extra_data)), 0);
                else if (object.extra_data.length)
                    message.extra_data = object.extra_data;
            if (object.extra_data_len != null)
                message.extra_data_len = object.extra_data_len >>> 0;
            if (object.expiry != null)
                message.expiry = object.expiry >>> 0;
            if (object.overwintered != null)
                message.overwintered = Boolean(object.overwintered);
            if (object.version_group_id != null)
                message.version_group_id = object.version_group_id >>> 0;
            if (object.timestamp != null)
                message.timestamp = object.timestamp >>> 0;
            if (object.branch_id != null)
                message.branch_id = object.branch_id >>> 0;
            return message;
        };

        TransactionType.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.inputs = [];
                object.bin_outputs = [];
                object.outputs = [];
            }
            if (options.defaults) {
                object.version = 0;
                object.lock_time = 0;
                object.inputs_cnt = 0;
                object.outputs_cnt = 0;
                if (options.bytes === String)
                    object.extra_data = "";
                else {
                    object.extra_data = [];
                    if (options.bytes !== Array)
                        object.extra_data = $util.newBuffer(object.extra_data);
                }
                object.extra_data_len = 0;
                object.expiry = 0;
                object.overwintered = false;
                object.version_group_id = 0;
                object.timestamp = 0;
                object.branch_id = 0;
            }
            if (message.version != null && message.hasOwnProperty("version"))
                object.version = message.version;
            if (message.inputs && message.inputs.length) {
                object.inputs = [];
                for (var j = 0; j < message.inputs.length; ++j)
                    object.inputs[j] = $root.TxAck.TransactionType.TxInputType.toObject(message.inputs[j], options);
            }
            if (message.bin_outputs && message.bin_outputs.length) {
                object.bin_outputs = [];
                for (var j = 0; j < message.bin_outputs.length; ++j)
                    object.bin_outputs[j] = $root.TxAck.TransactionType.TxOutputBinType.toObject(message.bin_outputs[j], options);
            }
            if (message.lock_time != null && message.hasOwnProperty("lock_time"))
                object.lock_time = message.lock_time;
            if (message.outputs && message.outputs.length) {
                object.outputs = [];
                for (var j = 0; j < message.outputs.length; ++j)
                    object.outputs[j] = $root.TxAck.TransactionType.TxOutputType.toObject(message.outputs[j], options);
            }
            if (message.inputs_cnt != null && message.hasOwnProperty("inputs_cnt"))
                object.inputs_cnt = message.inputs_cnt;
            if (message.outputs_cnt != null && message.hasOwnProperty("outputs_cnt"))
                object.outputs_cnt = message.outputs_cnt;
            if (message.extra_data != null && message.hasOwnProperty("extra_data"))
                object.extra_data = options.bytes === String ? $util.base64.encode(message.extra_data, 0, message.extra_data.length) : options.bytes === Array ? Array.prototype.slice.call(message.extra_data) : message.extra_data;
            if (message.extra_data_len != null && message.hasOwnProperty("extra_data_len"))
                object.extra_data_len = message.extra_data_len;
            if (message.expiry != null && message.hasOwnProperty("expiry"))
                object.expiry = message.expiry;
            if (message.overwintered != null && message.hasOwnProperty("overwintered"))
                object.overwintered = message.overwintered;
            if (message.version_group_id != null && message.hasOwnProperty("version_group_id"))
                object.version_group_id = message.version_group_id;
            if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                object.timestamp = message.timestamp;
            if (message.branch_id != null && message.hasOwnProperty("branch_id"))
                object.branch_id = message.branch_id;
            return object;
        };

        TransactionType.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        TransactionType.TxInputType = (function() {

            function TxInputType(properties) {
                this.address_n = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            TxInputType.prototype.address_n = $util.emptyArray;
            TxInputType.prototype.prev_hash = $util.newBuffer([]);
            TxInputType.prototype.prev_index = 0;
            TxInputType.prototype.script_sig = $util.newBuffer([]);
            TxInputType.prototype.sequence = 4294967295;
            TxInputType.prototype.script_type = 0;
            TxInputType.prototype.multisig = null;
            TxInputType.prototype.amount = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
            TxInputType.prototype.decred_tree = 0;
            TxInputType.prototype.witness = $util.newBuffer([]);
            TxInputType.prototype.ownership_proof = $util.newBuffer([]);
            TxInputType.prototype.commitment_data = $util.newBuffer([]);
            TxInputType.prototype.orig_hash = $util.newBuffer([]);
            TxInputType.prototype.orig_index = 0;
            TxInputType.prototype.decred_staking_spend = 0;
            TxInputType.prototype.script_pubkey = $util.newBuffer([]);
            TxInputType.prototype.coinjoin_flags = 0;

            TxInputType.create = function create(properties) {
                return new TxInputType(properties);
            };

            TxInputType.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.address_n != null && message.address_n.length)
                    for (var i = 0; i < message.address_n.length; ++i)
                        writer.uint32(8).uint32(message.address_n[i]);
                writer.uint32(18).bytes(message.prev_hash);
                writer.uint32(24).uint32(message.prev_index);
                if (message.script_sig != null && Object.hasOwnProperty.call(message, "script_sig"))
                    writer.uint32(34).bytes(message.script_sig);
                if (message.sequence != null && Object.hasOwnProperty.call(message, "sequence"))
                    writer.uint32(40).uint32(message.sequence);
                if (message.script_type != null && Object.hasOwnProperty.call(message, "script_type"))
                    writer.uint32(48).int32(message.script_type);
                if (message.multisig != null && Object.hasOwnProperty.call(message, "multisig"))
                    $root.MultisigRedeemScriptType.encode(message.multisig, writer.uint32(58).fork()).ldelim();
                if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
                    writer.uint32(64).uint64(message.amount);
                if (message.decred_tree != null && Object.hasOwnProperty.call(message, "decred_tree"))
                    writer.uint32(72).uint32(message.decred_tree);
                if (message.witness != null && Object.hasOwnProperty.call(message, "witness"))
                    writer.uint32(106).bytes(message.witness);
                if (message.ownership_proof != null && Object.hasOwnProperty.call(message, "ownership_proof"))
                    writer.uint32(114).bytes(message.ownership_proof);
                if (message.commitment_data != null && Object.hasOwnProperty.call(message, "commitment_data"))
                    writer.uint32(122).bytes(message.commitment_data);
                if (message.orig_hash != null && Object.hasOwnProperty.call(message, "orig_hash"))
                    writer.uint32(130).bytes(message.orig_hash);
                if (message.orig_index != null && Object.hasOwnProperty.call(message, "orig_index"))
                    writer.uint32(136).uint32(message.orig_index);
                if (message.decred_staking_spend != null && Object.hasOwnProperty.call(message, "decred_staking_spend"))
                    writer.uint32(144).int32(message.decred_staking_spend);
                if (message.script_pubkey != null && Object.hasOwnProperty.call(message, "script_pubkey"))
                    writer.uint32(154).bytes(message.script_pubkey);
                if (message.coinjoin_flags != null && Object.hasOwnProperty.call(message, "coinjoin_flags"))
                    writer.uint32(160).uint32(message.coinjoin_flags);
                return writer;
            };

            TxInputType.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            TxInputType.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TxAck.TransactionType.TxInputType();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (!(message.address_n && message.address_n.length))
                            message.address_n = [];
                        if ((tag & 7) === 2) {
                            var end2 = reader.uint32() + reader.pos;
                            while (reader.pos < end2)
                                message.address_n.push(reader.uint32());
                        } else
                            message.address_n.push(reader.uint32());
                        break;
                    case 2:
                        message.prev_hash = reader.bytes();
                        break;
                    case 3:
                        message.prev_index = reader.uint32();
                        break;
                    case 4:
                        message.script_sig = reader.bytes();
                        break;
                    case 5:
                        message.sequence = reader.uint32();
                        break;
                    case 6:
                        message.script_type = reader.int32();
                        break;
                    case 7:
                        message.multisig = $root.MultisigRedeemScriptType.decode(reader, reader.uint32());
                        break;
                    case 8:
                        message.amount = reader.uint64();
                        break;
                    case 9:
                        message.decred_tree = reader.uint32();
                        break;
                    case 13:
                        message.witness = reader.bytes();
                        break;
                    case 14:
                        message.ownership_proof = reader.bytes();
                        break;
                    case 15:
                        message.commitment_data = reader.bytes();
                        break;
                    case 16:
                        message.orig_hash = reader.bytes();
                        break;
                    case 17:
                        message.orig_index = reader.uint32();
                        break;
                    case 18:
                        message.decred_staking_spend = reader.int32();
                        break;
                    case 19:
                        message.script_pubkey = reader.bytes();
                        break;
                    case 20:
                        message.coinjoin_flags = reader.uint32();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                if (!message.hasOwnProperty("prev_hash"))
                    throw $util.ProtocolError("missing required 'prev_hash'", { instance: message });
                if (!message.hasOwnProperty("prev_index"))
                    throw $util.ProtocolError("missing required 'prev_index'", { instance: message });
                return message;
            };

            TxInputType.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            TxInputType.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.address_n != null && message.hasOwnProperty("address_n")) {
                    if (!Array.isArray(message.address_n))
                        return "address_n: array expected";
                    for (var i = 0; i < message.address_n.length; ++i)
                        if (!$util.isInteger(message.address_n[i]))
                            return "address_n: integer[] expected";
                }
                if (!(message.prev_hash && typeof message.prev_hash.length === "number" || $util.isString(message.prev_hash)))
                    return "prev_hash: buffer expected";
                if (!$util.isInteger(message.prev_index))
                    return "prev_index: integer expected";
                if (message.script_sig != null && message.hasOwnProperty("script_sig"))
                    if (!(message.script_sig && typeof message.script_sig.length === "number" || $util.isString(message.script_sig)))
                        return "script_sig: buffer expected";
                if (message.sequence != null && message.hasOwnProperty("sequence"))
                    if (!$util.isInteger(message.sequence))
                        return "sequence: integer expected";
                if (message.script_type != null && message.hasOwnProperty("script_type"))
                    switch (message.script_type) {
                    default:
                        return "script_type: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                        break;
                    }
                if (message.multisig != null && message.hasOwnProperty("multisig")) {
                    var error = $root.MultisigRedeemScriptType.verify(message.multisig);
                    if (error)
                        return "multisig." + error;
                }
                if (message.amount != null && message.hasOwnProperty("amount"))
                    if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
                        return "amount: integer|Long expected";
                if (message.decred_tree != null && message.hasOwnProperty("decred_tree"))
                    if (!$util.isInteger(message.decred_tree))
                        return "decred_tree: integer expected";
                if (message.witness != null && message.hasOwnProperty("witness"))
                    if (!(message.witness && typeof message.witness.length === "number" || $util.isString(message.witness)))
                        return "witness: buffer expected";
                if (message.ownership_proof != null && message.hasOwnProperty("ownership_proof"))
                    if (!(message.ownership_proof && typeof message.ownership_proof.length === "number" || $util.isString(message.ownership_proof)))
                        return "ownership_proof: buffer expected";
                if (message.commitment_data != null && message.hasOwnProperty("commitment_data"))
                    if (!(message.commitment_data && typeof message.commitment_data.length === "number" || $util.isString(message.commitment_data)))
                        return "commitment_data: buffer expected";
                if (message.orig_hash != null && message.hasOwnProperty("orig_hash"))
                    if (!(message.orig_hash && typeof message.orig_hash.length === "number" || $util.isString(message.orig_hash)))
                        return "orig_hash: buffer expected";
                if (message.orig_index != null && message.hasOwnProperty("orig_index"))
                    if (!$util.isInteger(message.orig_index))
                        return "orig_index: integer expected";
                if (message.decred_staking_spend != null && message.hasOwnProperty("decred_staking_spend"))
                    switch (message.decred_staking_spend) {
                    default:
                        return "decred_staking_spend: enum value expected";
                    case 0:
                    case 1:
                        break;
                    }
                if (message.script_pubkey != null && message.hasOwnProperty("script_pubkey"))
                    if (!(message.script_pubkey && typeof message.script_pubkey.length === "number" || $util.isString(message.script_pubkey)))
                        return "script_pubkey: buffer expected";
                if (message.coinjoin_flags != null && message.hasOwnProperty("coinjoin_flags"))
                    if (!$util.isInteger(message.coinjoin_flags))
                        return "coinjoin_flags: integer expected";
                return null;
            };

            TxInputType.fromObject = function fromObject(object) {
                if (object instanceof $root.TxAck.TransactionType.TxInputType)
                    return object;
                var message = new $root.TxAck.TransactionType.TxInputType();
                if (object.address_n) {
                    if (!Array.isArray(object.address_n))
                        throw TypeError(".TxAck.TransactionType.TxInputType.address_n: array expected");
                    message.address_n = [];
                    for (var i = 0; i < object.address_n.length; ++i)
                        message.address_n[i] = object.address_n[i] >>> 0;
                }
                if (object.prev_hash != null)
                    if (typeof object.prev_hash === "string")
                        $util.base64.decode(object.prev_hash, message.prev_hash = $util.newBuffer($util.base64.length(object.prev_hash)), 0);
                    else if (object.prev_hash.length)
                        message.prev_hash = object.prev_hash;
                if (object.prev_index != null)
                    message.prev_index = object.prev_index >>> 0;
                if (object.script_sig != null)
                    if (typeof object.script_sig === "string")
                        $util.base64.decode(object.script_sig, message.script_sig = $util.newBuffer($util.base64.length(object.script_sig)), 0);
                    else if (object.script_sig.length)
                        message.script_sig = object.script_sig;
                if (object.sequence != null)
                    message.sequence = object.sequence >>> 0;
                switch (object.script_type) {
                case "SPENDADDRESS":
                case 0:
                    message.script_type = 0;
                    break;
                case "SPENDMULTISIG":
                case 1:
                    message.script_type = 1;
                    break;
                case "EXTERNAL":
                case 2:
                    message.script_type = 2;
                    break;
                case "SPENDWITNESS":
                case 3:
                    message.script_type = 3;
                    break;
                case "SPENDP2SHWITNESS":
                case 4:
                    message.script_type = 4;
                    break;
                case "SPENDTAPROOT":
                case 5:
                    message.script_type = 5;
                    break;
                }
                if (object.multisig != null) {
                    if (typeof object.multisig !== "object")
                        throw TypeError(".TxAck.TransactionType.TxInputType.multisig: object expected");
                    message.multisig = $root.MultisigRedeemScriptType.fromObject(object.multisig);
                }
                if (object.amount != null)
                    if ($util.Long)
                        (message.amount = $util.Long.fromValue(object.amount)).unsigned = true;
                    else if (typeof object.amount === "string")
                        message.amount = parseInt(object.amount, 10);
                    else if (typeof object.amount === "number")
                        message.amount = object.amount;
                    else if (typeof object.amount === "object")
                        message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber(true);
                if (object.decred_tree != null)
                    message.decred_tree = object.decred_tree >>> 0;
                if (object.witness != null)
                    if (typeof object.witness === "string")
                        $util.base64.decode(object.witness, message.witness = $util.newBuffer($util.base64.length(object.witness)), 0);
                    else if (object.witness.length)
                        message.witness = object.witness;
                if (object.ownership_proof != null)
                    if (typeof object.ownership_proof === "string")
                        $util.base64.decode(object.ownership_proof, message.ownership_proof = $util.newBuffer($util.base64.length(object.ownership_proof)), 0);
                    else if (object.ownership_proof.length)
                        message.ownership_proof = object.ownership_proof;
                if (object.commitment_data != null)
                    if (typeof object.commitment_data === "string")
                        $util.base64.decode(object.commitment_data, message.commitment_data = $util.newBuffer($util.base64.length(object.commitment_data)), 0);
                    else if (object.commitment_data.length)
                        message.commitment_data = object.commitment_data;
                if (object.orig_hash != null)
                    if (typeof object.orig_hash === "string")
                        $util.base64.decode(object.orig_hash, message.orig_hash = $util.newBuffer($util.base64.length(object.orig_hash)), 0);
                    else if (object.orig_hash.length)
                        message.orig_hash = object.orig_hash;
                if (object.orig_index != null)
                    message.orig_index = object.orig_index >>> 0;
                switch (object.decred_staking_spend) {
                case "SSGen":
                case 0:
                    message.decred_staking_spend = 0;
                    break;
                case "SSRTX":
                case 1:
                    message.decred_staking_spend = 1;
                    break;
                }
                if (object.script_pubkey != null)
                    if (typeof object.script_pubkey === "string")
                        $util.base64.decode(object.script_pubkey, message.script_pubkey = $util.newBuffer($util.base64.length(object.script_pubkey)), 0);
                    else if (object.script_pubkey.length)
                        message.script_pubkey = object.script_pubkey;
                if (object.coinjoin_flags != null)
                    message.coinjoin_flags = object.coinjoin_flags >>> 0;
                return message;
            };

            TxInputType.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.address_n = [];
                if (options.defaults) {
                    if (options.bytes === String)
                        object.prev_hash = "";
                    else {
                        object.prev_hash = [];
                        if (options.bytes !== Array)
                            object.prev_hash = $util.newBuffer(object.prev_hash);
                    }
                    object.prev_index = 0;
                    if (options.bytes === String)
                        object.script_sig = "";
                    else {
                        object.script_sig = [];
                        if (options.bytes !== Array)
                            object.script_sig = $util.newBuffer(object.script_sig);
                    }
                    object.sequence = 4294967295;
                    object.script_type = options.enums === String ? "SPENDADDRESS" : 0;
                    object.multisig = null;
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, true);
                        object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.amount = options.longs === String ? "0" : 0;
                    object.decred_tree = 0;
                    if (options.bytes === String)
                        object.witness = "";
                    else {
                        object.witness = [];
                        if (options.bytes !== Array)
                            object.witness = $util.newBuffer(object.witness);
                    }
                    if (options.bytes === String)
                        object.ownership_proof = "";
                    else {
                        object.ownership_proof = [];
                        if (options.bytes !== Array)
                            object.ownership_proof = $util.newBuffer(object.ownership_proof);
                    }
                    if (options.bytes === String)
                        object.commitment_data = "";
                    else {
                        object.commitment_data = [];
                        if (options.bytes !== Array)
                            object.commitment_data = $util.newBuffer(object.commitment_data);
                    }
                    if (options.bytes === String)
                        object.orig_hash = "";
                    else {
                        object.orig_hash = [];
                        if (options.bytes !== Array)
                            object.orig_hash = $util.newBuffer(object.orig_hash);
                    }
                    object.orig_index = 0;
                    object.decred_staking_spend = options.enums === String ? "SSGen" : 0;
                    if (options.bytes === String)
                        object.script_pubkey = "";
                    else {
                        object.script_pubkey = [];
                        if (options.bytes !== Array)
                            object.script_pubkey = $util.newBuffer(object.script_pubkey);
                    }
                    object.coinjoin_flags = 0;
                }
                if (message.address_n && message.address_n.length) {
                    object.address_n = [];
                    for (var j = 0; j < message.address_n.length; ++j)
                        object.address_n[j] = message.address_n[j];
                }
                if (message.prev_hash != null && message.hasOwnProperty("prev_hash"))
                    object.prev_hash = options.bytes === String ? $util.base64.encode(message.prev_hash, 0, message.prev_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.prev_hash) : message.prev_hash;
                if (message.prev_index != null && message.hasOwnProperty("prev_index"))
                    object.prev_index = message.prev_index;
                if (message.script_sig != null && message.hasOwnProperty("script_sig"))
                    object.script_sig = options.bytes === String ? $util.base64.encode(message.script_sig, 0, message.script_sig.length) : options.bytes === Array ? Array.prototype.slice.call(message.script_sig) : message.script_sig;
                if (message.sequence != null && message.hasOwnProperty("sequence"))
                    object.sequence = message.sequence;
                if (message.script_type != null && message.hasOwnProperty("script_type"))
                    object.script_type = options.enums === String ? $root.InputScriptType[message.script_type] : message.script_type;
                if (message.multisig != null && message.hasOwnProperty("multisig"))
                    object.multisig = $root.MultisigRedeemScriptType.toObject(message.multisig, options);
                if (message.amount != null && message.hasOwnProperty("amount"))
                    if (typeof message.amount === "number")
                        object.amount = options.longs === String ? String(message.amount) : message.amount;
                    else
                        object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber(true) : message.amount;
                if (message.decred_tree != null && message.hasOwnProperty("decred_tree"))
                    object.decred_tree = message.decred_tree;
                if (message.witness != null && message.hasOwnProperty("witness"))
                    object.witness = options.bytes === String ? $util.base64.encode(message.witness, 0, message.witness.length) : options.bytes === Array ? Array.prototype.slice.call(message.witness) : message.witness;
                if (message.ownership_proof != null && message.hasOwnProperty("ownership_proof"))
                    object.ownership_proof = options.bytes === String ? $util.base64.encode(message.ownership_proof, 0, message.ownership_proof.length) : options.bytes === Array ? Array.prototype.slice.call(message.ownership_proof) : message.ownership_proof;
                if (message.commitment_data != null && message.hasOwnProperty("commitment_data"))
                    object.commitment_data = options.bytes === String ? $util.base64.encode(message.commitment_data, 0, message.commitment_data.length) : options.bytes === Array ? Array.prototype.slice.call(message.commitment_data) : message.commitment_data;
                if (message.orig_hash != null && message.hasOwnProperty("orig_hash"))
                    object.orig_hash = options.bytes === String ? $util.base64.encode(message.orig_hash, 0, message.orig_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.orig_hash) : message.orig_hash;
                if (message.orig_index != null && message.hasOwnProperty("orig_index"))
                    object.orig_index = message.orig_index;
                if (message.decred_staking_spend != null && message.hasOwnProperty("decred_staking_spend"))
                    object.decred_staking_spend = options.enums === String ? $root.DecredStakingSpendType[message.decred_staking_spend] : message.decred_staking_spend;
                if (message.script_pubkey != null && message.hasOwnProperty("script_pubkey"))
                    object.script_pubkey = options.bytes === String ? $util.base64.encode(message.script_pubkey, 0, message.script_pubkey.length) : options.bytes === Array ? Array.prototype.slice.call(message.script_pubkey) : message.script_pubkey;
                if (message.coinjoin_flags != null && message.hasOwnProperty("coinjoin_flags"))
                    object.coinjoin_flags = message.coinjoin_flags;
                return object;
            };

            TxInputType.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return TxInputType;
        })();

        TransactionType.TxOutputBinType = (function() {

            function TxOutputBinType(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            TxOutputBinType.prototype.amount = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
            TxOutputBinType.prototype.script_pubkey = $util.newBuffer([]);
            TxOutputBinType.prototype.decred_script_version = 0;

            TxOutputBinType.create = function create(properties) {
                return new TxOutputBinType(properties);
            };

            TxOutputBinType.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                writer.uint32(8).uint64(message.amount);
                writer.uint32(18).bytes(message.script_pubkey);
                if (message.decred_script_version != null && Object.hasOwnProperty.call(message, "decred_script_version"))
                    writer.uint32(24).uint32(message.decred_script_version);
                return writer;
            };

            TxOutputBinType.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            TxOutputBinType.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TxAck.TransactionType.TxOutputBinType();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.amount = reader.uint64();
                        break;
                    case 2:
                        message.script_pubkey = reader.bytes();
                        break;
                    case 3:
                        message.decred_script_version = reader.uint32();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                if (!message.hasOwnProperty("amount"))
                    throw $util.ProtocolError("missing required 'amount'", { instance: message });
                if (!message.hasOwnProperty("script_pubkey"))
                    throw $util.ProtocolError("missing required 'script_pubkey'", { instance: message });
                return message;
            };

            TxOutputBinType.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            TxOutputBinType.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
                    return "amount: integer|Long expected";
                if (!(message.script_pubkey && typeof message.script_pubkey.length === "number" || $util.isString(message.script_pubkey)))
                    return "script_pubkey: buffer expected";
                if (message.decred_script_version != null && message.hasOwnProperty("decred_script_version"))
                    if (!$util.isInteger(message.decred_script_version))
                        return "decred_script_version: integer expected";
                return null;
            };

            TxOutputBinType.fromObject = function fromObject(object) {
                if (object instanceof $root.TxAck.TransactionType.TxOutputBinType)
                    return object;
                var message = new $root.TxAck.TransactionType.TxOutputBinType();
                if (object.amount != null)
                    if ($util.Long)
                        (message.amount = $util.Long.fromValue(object.amount)).unsigned = true;
                    else if (typeof object.amount === "string")
                        message.amount = parseInt(object.amount, 10);
                    else if (typeof object.amount === "number")
                        message.amount = object.amount;
                    else if (typeof object.amount === "object")
                        message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber(true);
                if (object.script_pubkey != null)
                    if (typeof object.script_pubkey === "string")
                        $util.base64.decode(object.script_pubkey, message.script_pubkey = $util.newBuffer($util.base64.length(object.script_pubkey)), 0);
                    else if (object.script_pubkey.length)
                        message.script_pubkey = object.script_pubkey;
                if (object.decred_script_version != null)
                    message.decred_script_version = object.decred_script_version >>> 0;
                return message;
            };

            TxOutputBinType.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, true);
                        object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.amount = options.longs === String ? "0" : 0;
                    if (options.bytes === String)
                        object.script_pubkey = "";
                    else {
                        object.script_pubkey = [];
                        if (options.bytes !== Array)
                            object.script_pubkey = $util.newBuffer(object.script_pubkey);
                    }
                    object.decred_script_version = 0;
                }
                if (message.amount != null && message.hasOwnProperty("amount"))
                    if (typeof message.amount === "number")
                        object.amount = options.longs === String ? String(message.amount) : message.amount;
                    else
                        object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber(true) : message.amount;
                if (message.script_pubkey != null && message.hasOwnProperty("script_pubkey"))
                    object.script_pubkey = options.bytes === String ? $util.base64.encode(message.script_pubkey, 0, message.script_pubkey.length) : options.bytes === Array ? Array.prototype.slice.call(message.script_pubkey) : message.script_pubkey;
                if (message.decred_script_version != null && message.hasOwnProperty("decred_script_version"))
                    object.decred_script_version = message.decred_script_version;
                return object;
            };

            TxOutputBinType.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return TxOutputBinType;
        })();

        TransactionType.TxOutputType = (function() {

            function TxOutputType(properties) {
                this.address_n = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            TxOutputType.prototype.address = "";
            TxOutputType.prototype.address_n = $util.emptyArray;
            TxOutputType.prototype.amount = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
            TxOutputType.prototype.script_type = 0;
            TxOutputType.prototype.multisig = null;
            TxOutputType.prototype.op_return_data = $util.newBuffer([]);
            TxOutputType.prototype.orig_hash = $util.newBuffer([]);
            TxOutputType.prototype.orig_index = 0;
            TxOutputType.prototype.payment_req_index = 0;

            TxOutputType.create = function create(properties) {
                return new TxOutputType(properties);
            };

            TxOutputType.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.address != null && Object.hasOwnProperty.call(message, "address"))
                    writer.uint32(10).string(message.address);
                if (message.address_n != null && message.address_n.length)
                    for (var i = 0; i < message.address_n.length; ++i)
                        writer.uint32(16).uint32(message.address_n[i]);
                writer.uint32(24).uint64(message.amount);
                if (message.script_type != null && Object.hasOwnProperty.call(message, "script_type"))
                    writer.uint32(32).int32(message.script_type);
                if (message.multisig != null && Object.hasOwnProperty.call(message, "multisig"))
                    $root.MultisigRedeemScriptType.encode(message.multisig, writer.uint32(42).fork()).ldelim();
                if (message.op_return_data != null && Object.hasOwnProperty.call(message, "op_return_data"))
                    writer.uint32(50).bytes(message.op_return_data);
                if (message.orig_hash != null && Object.hasOwnProperty.call(message, "orig_hash"))
                    writer.uint32(82).bytes(message.orig_hash);
                if (message.orig_index != null && Object.hasOwnProperty.call(message, "orig_index"))
                    writer.uint32(88).uint32(message.orig_index);
                if (message.payment_req_index != null && Object.hasOwnProperty.call(message, "payment_req_index"))
                    writer.uint32(96).uint32(message.payment_req_index);
                return writer;
            };

            TxOutputType.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            TxOutputType.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TxAck.TransactionType.TxOutputType();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.address = reader.string();
                        break;
                    case 2:
                        if (!(message.address_n && message.address_n.length))
                            message.address_n = [];
                        if ((tag & 7) === 2) {
                            var end2 = reader.uint32() + reader.pos;
                            while (reader.pos < end2)
                                message.address_n.push(reader.uint32());
                        } else
                            message.address_n.push(reader.uint32());
                        break;
                    case 3:
                        message.amount = reader.uint64();
                        break;
                    case 4:
                        message.script_type = reader.int32();
                        break;
                    case 5:
                        message.multisig = $root.MultisigRedeemScriptType.decode(reader, reader.uint32());
                        break;
                    case 6:
                        message.op_return_data = reader.bytes();
                        break;
                    case 10:
                        message.orig_hash = reader.bytes();
                        break;
                    case 11:
                        message.orig_index = reader.uint32();
                        break;
                    case 12:
                        message.payment_req_index = reader.uint32();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                if (!message.hasOwnProperty("amount"))
                    throw $util.ProtocolError("missing required 'amount'", { instance: message });
                return message;
            };

            TxOutputType.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            TxOutputType.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.address != null && message.hasOwnProperty("address"))
                    if (!$util.isString(message.address))
                        return "address: string expected";
                if (message.address_n != null && message.hasOwnProperty("address_n")) {
                    if (!Array.isArray(message.address_n))
                        return "address_n: array expected";
                    for (var i = 0; i < message.address_n.length; ++i)
                        if (!$util.isInteger(message.address_n[i]))
                            return "address_n: integer[] expected";
                }
                if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
                    return "amount: integer|Long expected";
                if (message.script_type != null && message.hasOwnProperty("script_type"))
                    switch (message.script_type) {
                    default:
                        return "script_type: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                    case 6:
                        break;
                    }
                if (message.multisig != null && message.hasOwnProperty("multisig")) {
                    var error = $root.MultisigRedeemScriptType.verify(message.multisig);
                    if (error)
                        return "multisig." + error;
                }
                if (message.op_return_data != null && message.hasOwnProperty("op_return_data"))
                    if (!(message.op_return_data && typeof message.op_return_data.length === "number" || $util.isString(message.op_return_data)))
                        return "op_return_data: buffer expected";
                if (message.orig_hash != null && message.hasOwnProperty("orig_hash"))
                    if (!(message.orig_hash && typeof message.orig_hash.length === "number" || $util.isString(message.orig_hash)))
                        return "orig_hash: buffer expected";
                if (message.orig_index != null && message.hasOwnProperty("orig_index"))
                    if (!$util.isInteger(message.orig_index))
                        return "orig_index: integer expected";
                if (message.payment_req_index != null && message.hasOwnProperty("payment_req_index"))
                    if (!$util.isInteger(message.payment_req_index))
                        return "payment_req_index: integer expected";
                return null;
            };

            TxOutputType.fromObject = function fromObject(object) {
                if (object instanceof $root.TxAck.TransactionType.TxOutputType)
                    return object;
                var message = new $root.TxAck.TransactionType.TxOutputType();
                if (object.address != null)
                    message.address = String(object.address);
                if (object.address_n) {
                    if (!Array.isArray(object.address_n))
                        throw TypeError(".TxAck.TransactionType.TxOutputType.address_n: array expected");
                    message.address_n = [];
                    for (var i = 0; i < object.address_n.length; ++i)
                        message.address_n[i] = object.address_n[i] >>> 0;
                }
                if (object.amount != null)
                    if ($util.Long)
                        (message.amount = $util.Long.fromValue(object.amount)).unsigned = true;
                    else if (typeof object.amount === "string")
                        message.amount = parseInt(object.amount, 10);
                    else if (typeof object.amount === "number")
                        message.amount = object.amount;
                    else if (typeof object.amount === "object")
                        message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber(true);
                switch (object.script_type) {
                case "PAYTOADDRESS":
                case 0:
                    message.script_type = 0;
                    break;
                case "PAYTOSCRIPTHASH":
                case 1:
                    message.script_type = 1;
                    break;
                case "PAYTOMULTISIG":
                case 2:
                    message.script_type = 2;
                    break;
                case "PAYTOOPRETURN":
                case 3:
                    message.script_type = 3;
                    break;
                case "PAYTOWITNESS":
                case 4:
                    message.script_type = 4;
                    break;
                case "PAYTOP2SHWITNESS":
                case 5:
                    message.script_type = 5;
                    break;
                case "PAYTOTAPROOT":
                case 6:
                    message.script_type = 6;
                    break;
                }
                if (object.multisig != null) {
                    if (typeof object.multisig !== "object")
                        throw TypeError(".TxAck.TransactionType.TxOutputType.multisig: object expected");
                    message.multisig = $root.MultisigRedeemScriptType.fromObject(object.multisig);
                }
                if (object.op_return_data != null)
                    if (typeof object.op_return_data === "string")
                        $util.base64.decode(object.op_return_data, message.op_return_data = $util.newBuffer($util.base64.length(object.op_return_data)), 0);
                    else if (object.op_return_data.length)
                        message.op_return_data = object.op_return_data;
                if (object.orig_hash != null)
                    if (typeof object.orig_hash === "string")
                        $util.base64.decode(object.orig_hash, message.orig_hash = $util.newBuffer($util.base64.length(object.orig_hash)), 0);
                    else if (object.orig_hash.length)
                        message.orig_hash = object.orig_hash;
                if (object.orig_index != null)
                    message.orig_index = object.orig_index >>> 0;
                if (object.payment_req_index != null)
                    message.payment_req_index = object.payment_req_index >>> 0;
                return message;
            };

            TxOutputType.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.address_n = [];
                if (options.defaults) {
                    object.address = "";
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, true);
                        object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.amount = options.longs === String ? "0" : 0;
                    object.script_type = options.enums === String ? "PAYTOADDRESS" : 0;
                    object.multisig = null;
                    if (options.bytes === String)
                        object.op_return_data = "";
                    else {
                        object.op_return_data = [];
                        if (options.bytes !== Array)
                            object.op_return_data = $util.newBuffer(object.op_return_data);
                    }
                    if (options.bytes === String)
                        object.orig_hash = "";
                    else {
                        object.orig_hash = [];
                        if (options.bytes !== Array)
                            object.orig_hash = $util.newBuffer(object.orig_hash);
                    }
                    object.orig_index = 0;
                    object.payment_req_index = 0;
                }
                if (message.address != null && message.hasOwnProperty("address"))
                    object.address = message.address;
                if (message.address_n && message.address_n.length) {
                    object.address_n = [];
                    for (var j = 0; j < message.address_n.length; ++j)
                        object.address_n[j] = message.address_n[j];
                }
                if (message.amount != null && message.hasOwnProperty("amount"))
                    if (typeof message.amount === "number")
                        object.amount = options.longs === String ? String(message.amount) : message.amount;
                    else
                        object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber(true) : message.amount;
                if (message.script_type != null && message.hasOwnProperty("script_type"))
                    object.script_type = options.enums === String ? $root.OutputScriptType[message.script_type] : message.script_type;
                if (message.multisig != null && message.hasOwnProperty("multisig"))
                    object.multisig = $root.MultisigRedeemScriptType.toObject(message.multisig, options);
                if (message.op_return_data != null && message.hasOwnProperty("op_return_data"))
                    object.op_return_data = options.bytes === String ? $util.base64.encode(message.op_return_data, 0, message.op_return_data.length) : options.bytes === Array ? Array.prototype.slice.call(message.op_return_data) : message.op_return_data;
                if (message.orig_hash != null && message.hasOwnProperty("orig_hash"))
                    object.orig_hash = options.bytes === String ? $util.base64.encode(message.orig_hash, 0, message.orig_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.orig_hash) : message.orig_hash;
                if (message.orig_index != null && message.hasOwnProperty("orig_index"))
                    object.orig_index = message.orig_index;
                if (message.payment_req_index != null && message.hasOwnProperty("payment_req_index"))
                    object.payment_req_index = message.payment_req_index;
                return object;
            };

            TxOutputType.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return TxOutputType;
        })();

        return TransactionType;
    })();

    return TxAck;
})();

$root.TxInput = (function() {

    function TxInput(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    TxInput.prototype.address_n = $util.emptyArray;
    TxInput.prototype.prev_hash = $util.newBuffer([]);
    TxInput.prototype.prev_index = 0;
    TxInput.prototype.script_sig = $util.newBuffer([]);
    TxInput.prototype.sequence = 4294967295;
    TxInput.prototype.script_type = 0;
    TxInput.prototype.multisig = null;
    TxInput.prototype.amount = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    TxInput.prototype.decred_tree = 0;
    TxInput.prototype.witness = $util.newBuffer([]);
    TxInput.prototype.ownership_proof = $util.newBuffer([]);
    TxInput.prototype.commitment_data = $util.newBuffer([]);
    TxInput.prototype.orig_hash = $util.newBuffer([]);
    TxInput.prototype.orig_index = 0;
    TxInput.prototype.decred_staking_spend = 0;
    TxInput.prototype.script_pubkey = $util.newBuffer([]);
    TxInput.prototype.coinjoin_flags = 0;

    TxInput.create = function create(properties) {
        return new TxInput(properties);
    };

    TxInput.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).bytes(message.prev_hash);
        writer.uint32(24).uint32(message.prev_index);
        if (message.script_sig != null && Object.hasOwnProperty.call(message, "script_sig"))
            writer.uint32(34).bytes(message.script_sig);
        if (message.sequence != null && Object.hasOwnProperty.call(message, "sequence"))
            writer.uint32(40).uint32(message.sequence);
        if (message.script_type != null && Object.hasOwnProperty.call(message, "script_type"))
            writer.uint32(48).int32(message.script_type);
        if (message.multisig != null && Object.hasOwnProperty.call(message, "multisig"))
            $root.MultisigRedeemScriptType.encode(message.multisig, writer.uint32(58).fork()).ldelim();
        writer.uint32(64).uint64(message.amount);
        if (message.decred_tree != null && Object.hasOwnProperty.call(message, "decred_tree"))
            writer.uint32(72).uint32(message.decred_tree);
        if (message.witness != null && Object.hasOwnProperty.call(message, "witness"))
            writer.uint32(106).bytes(message.witness);
        if (message.ownership_proof != null && Object.hasOwnProperty.call(message, "ownership_proof"))
            writer.uint32(114).bytes(message.ownership_proof);
        if (message.commitment_data != null && Object.hasOwnProperty.call(message, "commitment_data"))
            writer.uint32(122).bytes(message.commitment_data);
        if (message.orig_hash != null && Object.hasOwnProperty.call(message, "orig_hash"))
            writer.uint32(130).bytes(message.orig_hash);
        if (message.orig_index != null && Object.hasOwnProperty.call(message, "orig_index"))
            writer.uint32(136).uint32(message.orig_index);
        if (message.decred_staking_spend != null && Object.hasOwnProperty.call(message, "decred_staking_spend"))
            writer.uint32(144).int32(message.decred_staking_spend);
        if (message.script_pubkey != null && Object.hasOwnProperty.call(message, "script_pubkey"))
            writer.uint32(154).bytes(message.script_pubkey);
        if (message.coinjoin_flags != null && Object.hasOwnProperty.call(message, "coinjoin_flags"))
            writer.uint32(160).uint32(message.coinjoin_flags);
        return writer;
    };

    TxInput.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    TxInput.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TxInput();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.prev_hash = reader.bytes();
                break;
            case 3:
                message.prev_index = reader.uint32();
                break;
            case 4:
                message.script_sig = reader.bytes();
                break;
            case 5:
                message.sequence = reader.uint32();
                break;
            case 6:
                message.script_type = reader.int32();
                break;
            case 7:
                message.multisig = $root.MultisigRedeemScriptType.decode(reader, reader.uint32());
                break;
            case 8:
                message.amount = reader.uint64();
                break;
            case 9:
                message.decred_tree = reader.uint32();
                break;
            case 13:
                message.witness = reader.bytes();
                break;
            case 14:
                message.ownership_proof = reader.bytes();
                break;
            case 15:
                message.commitment_data = reader.bytes();
                break;
            case 16:
                message.orig_hash = reader.bytes();
                break;
            case 17:
                message.orig_index = reader.uint32();
                break;
            case 18:
                message.decred_staking_spend = reader.int32();
                break;
            case 19:
                message.script_pubkey = reader.bytes();
                break;
            case 20:
                message.coinjoin_flags = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("prev_hash"))
            throw $util.ProtocolError("missing required 'prev_hash'", { instance: message });
        if (!message.hasOwnProperty("prev_index"))
            throw $util.ProtocolError("missing required 'prev_index'", { instance: message });
        if (!message.hasOwnProperty("amount"))
            throw $util.ProtocolError("missing required 'amount'", { instance: message });
        return message;
    };

    TxInput.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    TxInput.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!(message.prev_hash && typeof message.prev_hash.length === "number" || $util.isString(message.prev_hash)))
            return "prev_hash: buffer expected";
        if (!$util.isInteger(message.prev_index))
            return "prev_index: integer expected";
        if (message.script_sig != null && message.hasOwnProperty("script_sig"))
            if (!(message.script_sig && typeof message.script_sig.length === "number" || $util.isString(message.script_sig)))
                return "script_sig: buffer expected";
        if (message.sequence != null && message.hasOwnProperty("sequence"))
            if (!$util.isInteger(message.sequence))
                return "sequence: integer expected";
        if (message.script_type != null && message.hasOwnProperty("script_type"))
            switch (message.script_type) {
            default:
                return "script_type: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
                break;
            }
        if (message.multisig != null && message.hasOwnProperty("multisig")) {
            var error = $root.MultisigRedeemScriptType.verify(message.multisig);
            if (error)
                return "multisig." + error;
        }
        if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
            return "amount: integer|Long expected";
        if (message.decred_tree != null && message.hasOwnProperty("decred_tree"))
            if (!$util.isInteger(message.decred_tree))
                return "decred_tree: integer expected";
        if (message.witness != null && message.hasOwnProperty("witness"))
            if (!(message.witness && typeof message.witness.length === "number" || $util.isString(message.witness)))
                return "witness: buffer expected";
        if (message.ownership_proof != null && message.hasOwnProperty("ownership_proof"))
            if (!(message.ownership_proof && typeof message.ownership_proof.length === "number" || $util.isString(message.ownership_proof)))
                return "ownership_proof: buffer expected";
        if (message.commitment_data != null && message.hasOwnProperty("commitment_data"))
            if (!(message.commitment_data && typeof message.commitment_data.length === "number" || $util.isString(message.commitment_data)))
                return "commitment_data: buffer expected";
        if (message.orig_hash != null && message.hasOwnProperty("orig_hash"))
            if (!(message.orig_hash && typeof message.orig_hash.length === "number" || $util.isString(message.orig_hash)))
                return "orig_hash: buffer expected";
        if (message.orig_index != null && message.hasOwnProperty("orig_index"))
            if (!$util.isInteger(message.orig_index))
                return "orig_index: integer expected";
        if (message.decred_staking_spend != null && message.hasOwnProperty("decred_staking_spend"))
            switch (message.decred_staking_spend) {
            default:
                return "decred_staking_spend: enum value expected";
            case 0:
            case 1:
                break;
            }
        if (message.script_pubkey != null && message.hasOwnProperty("script_pubkey"))
            if (!(message.script_pubkey && typeof message.script_pubkey.length === "number" || $util.isString(message.script_pubkey)))
                return "script_pubkey: buffer expected";
        if (message.coinjoin_flags != null && message.hasOwnProperty("coinjoin_flags"))
            if (!$util.isInteger(message.coinjoin_flags))
                return "coinjoin_flags: integer expected";
        return null;
    };

    TxInput.fromObject = function fromObject(object) {
        if (object instanceof $root.TxInput)
            return object;
        var message = new $root.TxInput();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".TxInput.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.prev_hash != null)
            if (typeof object.prev_hash === "string")
                $util.base64.decode(object.prev_hash, message.prev_hash = $util.newBuffer($util.base64.length(object.prev_hash)), 0);
            else if (object.prev_hash.length)
                message.prev_hash = object.prev_hash;
        if (object.prev_index != null)
            message.prev_index = object.prev_index >>> 0;
        if (object.script_sig != null)
            if (typeof object.script_sig === "string")
                $util.base64.decode(object.script_sig, message.script_sig = $util.newBuffer($util.base64.length(object.script_sig)), 0);
            else if (object.script_sig.length)
                message.script_sig = object.script_sig;
        if (object.sequence != null)
            message.sequence = object.sequence >>> 0;
        switch (object.script_type) {
        case "SPENDADDRESS":
        case 0:
            message.script_type = 0;
            break;
        case "SPENDMULTISIG":
        case 1:
            message.script_type = 1;
            break;
        case "EXTERNAL":
        case 2:
            message.script_type = 2;
            break;
        case "SPENDWITNESS":
        case 3:
            message.script_type = 3;
            break;
        case "SPENDP2SHWITNESS":
        case 4:
            message.script_type = 4;
            break;
        case "SPENDTAPROOT":
        case 5:
            message.script_type = 5;
            break;
        }
        if (object.multisig != null) {
            if (typeof object.multisig !== "object")
                throw TypeError(".TxInput.multisig: object expected");
            message.multisig = $root.MultisigRedeemScriptType.fromObject(object.multisig);
        }
        if (object.amount != null)
            if ($util.Long)
                (message.amount = $util.Long.fromValue(object.amount)).unsigned = true;
            else if (typeof object.amount === "string")
                message.amount = parseInt(object.amount, 10);
            else if (typeof object.amount === "number")
                message.amount = object.amount;
            else if (typeof object.amount === "object")
                message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber(true);
        if (object.decred_tree != null)
            message.decred_tree = object.decred_tree >>> 0;
        if (object.witness != null)
            if (typeof object.witness === "string")
                $util.base64.decode(object.witness, message.witness = $util.newBuffer($util.base64.length(object.witness)), 0);
            else if (object.witness.length)
                message.witness = object.witness;
        if (object.ownership_proof != null)
            if (typeof object.ownership_proof === "string")
                $util.base64.decode(object.ownership_proof, message.ownership_proof = $util.newBuffer($util.base64.length(object.ownership_proof)), 0);
            else if (object.ownership_proof.length)
                message.ownership_proof = object.ownership_proof;
        if (object.commitment_data != null)
            if (typeof object.commitment_data === "string")
                $util.base64.decode(object.commitment_data, message.commitment_data = $util.newBuffer($util.base64.length(object.commitment_data)), 0);
            else if (object.commitment_data.length)
                message.commitment_data = object.commitment_data;
        if (object.orig_hash != null)
            if (typeof object.orig_hash === "string")
                $util.base64.decode(object.orig_hash, message.orig_hash = $util.newBuffer($util.base64.length(object.orig_hash)), 0);
            else if (object.orig_hash.length)
                message.orig_hash = object.orig_hash;
        if (object.orig_index != null)
            message.orig_index = object.orig_index >>> 0;
        switch (object.decred_staking_spend) {
        case "SSGen":
        case 0:
            message.decred_staking_spend = 0;
            break;
        case "SSRTX":
        case 1:
            message.decred_staking_spend = 1;
            break;
        }
        if (object.script_pubkey != null)
            if (typeof object.script_pubkey === "string")
                $util.base64.decode(object.script_pubkey, message.script_pubkey = $util.newBuffer($util.base64.length(object.script_pubkey)), 0);
            else if (object.script_pubkey.length)
                message.script_pubkey = object.script_pubkey;
        if (object.coinjoin_flags != null)
            message.coinjoin_flags = object.coinjoin_flags >>> 0;
        return message;
    };

    TxInput.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            if (options.bytes === String)
                object.prev_hash = "";
            else {
                object.prev_hash = [];
                if (options.bytes !== Array)
                    object.prev_hash = $util.newBuffer(object.prev_hash);
            }
            object.prev_index = 0;
            if (options.bytes === String)
                object.script_sig = "";
            else {
                object.script_sig = [];
                if (options.bytes !== Array)
                    object.script_sig = $util.newBuffer(object.script_sig);
            }
            object.sequence = 4294967295;
            object.script_type = options.enums === String ? "SPENDADDRESS" : 0;
            object.multisig = null;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.amount = options.longs === String ? "0" : 0;
            object.decred_tree = 0;
            if (options.bytes === String)
                object.witness = "";
            else {
                object.witness = [];
                if (options.bytes !== Array)
                    object.witness = $util.newBuffer(object.witness);
            }
            if (options.bytes === String)
                object.ownership_proof = "";
            else {
                object.ownership_proof = [];
                if (options.bytes !== Array)
                    object.ownership_proof = $util.newBuffer(object.ownership_proof);
            }
            if (options.bytes === String)
                object.commitment_data = "";
            else {
                object.commitment_data = [];
                if (options.bytes !== Array)
                    object.commitment_data = $util.newBuffer(object.commitment_data);
            }
            if (options.bytes === String)
                object.orig_hash = "";
            else {
                object.orig_hash = [];
                if (options.bytes !== Array)
                    object.orig_hash = $util.newBuffer(object.orig_hash);
            }
            object.orig_index = 0;
            object.decred_staking_spend = options.enums === String ? "SSGen" : 0;
            if (options.bytes === String)
                object.script_pubkey = "";
            else {
                object.script_pubkey = [];
                if (options.bytes !== Array)
                    object.script_pubkey = $util.newBuffer(object.script_pubkey);
            }
            object.coinjoin_flags = 0;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.prev_hash != null && message.hasOwnProperty("prev_hash"))
            object.prev_hash = options.bytes === String ? $util.base64.encode(message.prev_hash, 0, message.prev_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.prev_hash) : message.prev_hash;
        if (message.prev_index != null && message.hasOwnProperty("prev_index"))
            object.prev_index = message.prev_index;
        if (message.script_sig != null && message.hasOwnProperty("script_sig"))
            object.script_sig = options.bytes === String ? $util.base64.encode(message.script_sig, 0, message.script_sig.length) : options.bytes === Array ? Array.prototype.slice.call(message.script_sig) : message.script_sig;
        if (message.sequence != null && message.hasOwnProperty("sequence"))
            object.sequence = message.sequence;
        if (message.script_type != null && message.hasOwnProperty("script_type"))
            object.script_type = options.enums === String ? $root.InputScriptType[message.script_type] : message.script_type;
        if (message.multisig != null && message.hasOwnProperty("multisig"))
            object.multisig = $root.MultisigRedeemScriptType.toObject(message.multisig, options);
        if (message.amount != null && message.hasOwnProperty("amount"))
            if (typeof message.amount === "number")
                object.amount = options.longs === String ? String(message.amount) : message.amount;
            else
                object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber(true) : message.amount;
        if (message.decred_tree != null && message.hasOwnProperty("decred_tree"))
            object.decred_tree = message.decred_tree;
        if (message.witness != null && message.hasOwnProperty("witness"))
            object.witness = options.bytes === String ? $util.base64.encode(message.witness, 0, message.witness.length) : options.bytes === Array ? Array.prototype.slice.call(message.witness) : message.witness;
        if (message.ownership_proof != null && message.hasOwnProperty("ownership_proof"))
            object.ownership_proof = options.bytes === String ? $util.base64.encode(message.ownership_proof, 0, message.ownership_proof.length) : options.bytes === Array ? Array.prototype.slice.call(message.ownership_proof) : message.ownership_proof;
        if (message.commitment_data != null && message.hasOwnProperty("commitment_data"))
            object.commitment_data = options.bytes === String ? $util.base64.encode(message.commitment_data, 0, message.commitment_data.length) : options.bytes === Array ? Array.prototype.slice.call(message.commitment_data) : message.commitment_data;
        if (message.orig_hash != null && message.hasOwnProperty("orig_hash"))
            object.orig_hash = options.bytes === String ? $util.base64.encode(message.orig_hash, 0, message.orig_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.orig_hash) : message.orig_hash;
        if (message.orig_index != null && message.hasOwnProperty("orig_index"))
            object.orig_index = message.orig_index;
        if (message.decred_staking_spend != null && message.hasOwnProperty("decred_staking_spend"))
            object.decred_staking_spend = options.enums === String ? $root.DecredStakingSpendType[message.decred_staking_spend] : message.decred_staking_spend;
        if (message.script_pubkey != null && message.hasOwnProperty("script_pubkey"))
            object.script_pubkey = options.bytes === String ? $util.base64.encode(message.script_pubkey, 0, message.script_pubkey.length) : options.bytes === Array ? Array.prototype.slice.call(message.script_pubkey) : message.script_pubkey;
        if (message.coinjoin_flags != null && message.hasOwnProperty("coinjoin_flags"))
            object.coinjoin_flags = message.coinjoin_flags;
        return object;
    };

    TxInput.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return TxInput;
})();

$root.TxOutput = (function() {

    function TxOutput(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    TxOutput.prototype.address = "";
    TxOutput.prototype.address_n = $util.emptyArray;
    TxOutput.prototype.amount = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    TxOutput.prototype.script_type = 0;
    TxOutput.prototype.multisig = null;
    TxOutput.prototype.op_return_data = $util.newBuffer([]);
    TxOutput.prototype.orig_hash = $util.newBuffer([]);
    TxOutput.prototype.orig_index = 0;
    TxOutput.prototype.payment_req_index = 0;

    TxOutput.create = function create(properties) {
        return new TxOutput(properties);
    };

    TxOutput.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address != null && Object.hasOwnProperty.call(message, "address"))
            writer.uint32(10).string(message.address);
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(16).uint32(message.address_n[i]);
        writer.uint32(24).uint64(message.amount);
        if (message.script_type != null && Object.hasOwnProperty.call(message, "script_type"))
            writer.uint32(32).int32(message.script_type);
        if (message.multisig != null && Object.hasOwnProperty.call(message, "multisig"))
            $root.MultisigRedeemScriptType.encode(message.multisig, writer.uint32(42).fork()).ldelim();
        if (message.op_return_data != null && Object.hasOwnProperty.call(message, "op_return_data"))
            writer.uint32(50).bytes(message.op_return_data);
        if (message.orig_hash != null && Object.hasOwnProperty.call(message, "orig_hash"))
            writer.uint32(82).bytes(message.orig_hash);
        if (message.orig_index != null && Object.hasOwnProperty.call(message, "orig_index"))
            writer.uint32(88).uint32(message.orig_index);
        if (message.payment_req_index != null && Object.hasOwnProperty.call(message, "payment_req_index"))
            writer.uint32(96).uint32(message.payment_req_index);
        return writer;
    };

    TxOutput.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    TxOutput.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TxOutput();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.string();
                break;
            case 2:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 3:
                message.amount = reader.uint64();
                break;
            case 4:
                message.script_type = reader.int32();
                break;
            case 5:
                message.multisig = $root.MultisigRedeemScriptType.decode(reader, reader.uint32());
                break;
            case 6:
                message.op_return_data = reader.bytes();
                break;
            case 10:
                message.orig_hash = reader.bytes();
                break;
            case 11:
                message.orig_index = reader.uint32();
                break;
            case 12:
                message.payment_req_index = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("amount"))
            throw $util.ProtocolError("missing required 'amount'", { instance: message });
        return message;
    };

    TxOutput.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    TxOutput.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address != null && message.hasOwnProperty("address"))
            if (!$util.isString(message.address))
                return "address: string expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
            return "amount: integer|Long expected";
        if (message.script_type != null && message.hasOwnProperty("script_type"))
            switch (message.script_type) {
            default:
                return "script_type: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
                break;
            }
        if (message.multisig != null && message.hasOwnProperty("multisig")) {
            var error = $root.MultisigRedeemScriptType.verify(message.multisig);
            if (error)
                return "multisig." + error;
        }
        if (message.op_return_data != null && message.hasOwnProperty("op_return_data"))
            if (!(message.op_return_data && typeof message.op_return_data.length === "number" || $util.isString(message.op_return_data)))
                return "op_return_data: buffer expected";
        if (message.orig_hash != null && message.hasOwnProperty("orig_hash"))
            if (!(message.orig_hash && typeof message.orig_hash.length === "number" || $util.isString(message.orig_hash)))
                return "orig_hash: buffer expected";
        if (message.orig_index != null && message.hasOwnProperty("orig_index"))
            if (!$util.isInteger(message.orig_index))
                return "orig_index: integer expected";
        if (message.payment_req_index != null && message.hasOwnProperty("payment_req_index"))
            if (!$util.isInteger(message.payment_req_index))
                return "payment_req_index: integer expected";
        return null;
    };

    TxOutput.fromObject = function fromObject(object) {
        if (object instanceof $root.TxOutput)
            return object;
        var message = new $root.TxOutput();
        if (object.address != null)
            message.address = String(object.address);
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".TxOutput.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.amount != null)
            if ($util.Long)
                (message.amount = $util.Long.fromValue(object.amount)).unsigned = true;
            else if (typeof object.amount === "string")
                message.amount = parseInt(object.amount, 10);
            else if (typeof object.amount === "number")
                message.amount = object.amount;
            else if (typeof object.amount === "object")
                message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber(true);
        switch (object.script_type) {
        case "PAYTOADDRESS":
        case 0:
            message.script_type = 0;
            break;
        case "PAYTOSCRIPTHASH":
        case 1:
            message.script_type = 1;
            break;
        case "PAYTOMULTISIG":
        case 2:
            message.script_type = 2;
            break;
        case "PAYTOOPRETURN":
        case 3:
            message.script_type = 3;
            break;
        case "PAYTOWITNESS":
        case 4:
            message.script_type = 4;
            break;
        case "PAYTOP2SHWITNESS":
        case 5:
            message.script_type = 5;
            break;
        case "PAYTOTAPROOT":
        case 6:
            message.script_type = 6;
            break;
        }
        if (object.multisig != null) {
            if (typeof object.multisig !== "object")
                throw TypeError(".TxOutput.multisig: object expected");
            message.multisig = $root.MultisigRedeemScriptType.fromObject(object.multisig);
        }
        if (object.op_return_data != null)
            if (typeof object.op_return_data === "string")
                $util.base64.decode(object.op_return_data, message.op_return_data = $util.newBuffer($util.base64.length(object.op_return_data)), 0);
            else if (object.op_return_data.length)
                message.op_return_data = object.op_return_data;
        if (object.orig_hash != null)
            if (typeof object.orig_hash === "string")
                $util.base64.decode(object.orig_hash, message.orig_hash = $util.newBuffer($util.base64.length(object.orig_hash)), 0);
            else if (object.orig_hash.length)
                message.orig_hash = object.orig_hash;
        if (object.orig_index != null)
            message.orig_index = object.orig_index >>> 0;
        if (object.payment_req_index != null)
            message.payment_req_index = object.payment_req_index >>> 0;
        return message;
    };

    TxOutput.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            object.address = "";
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.amount = options.longs === String ? "0" : 0;
            object.script_type = options.enums === String ? "PAYTOADDRESS" : 0;
            object.multisig = null;
            if (options.bytes === String)
                object.op_return_data = "";
            else {
                object.op_return_data = [];
                if (options.bytes !== Array)
                    object.op_return_data = $util.newBuffer(object.op_return_data);
            }
            if (options.bytes === String)
                object.orig_hash = "";
            else {
                object.orig_hash = [];
                if (options.bytes !== Array)
                    object.orig_hash = $util.newBuffer(object.orig_hash);
            }
            object.orig_index = 0;
            object.payment_req_index = 0;
        }
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.amount != null && message.hasOwnProperty("amount"))
            if (typeof message.amount === "number")
                object.amount = options.longs === String ? String(message.amount) : message.amount;
            else
                object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber(true) : message.amount;
        if (message.script_type != null && message.hasOwnProperty("script_type"))
            object.script_type = options.enums === String ? $root.OutputScriptType[message.script_type] : message.script_type;
        if (message.multisig != null && message.hasOwnProperty("multisig"))
            object.multisig = $root.MultisigRedeemScriptType.toObject(message.multisig, options);
        if (message.op_return_data != null && message.hasOwnProperty("op_return_data"))
            object.op_return_data = options.bytes === String ? $util.base64.encode(message.op_return_data, 0, message.op_return_data.length) : options.bytes === Array ? Array.prototype.slice.call(message.op_return_data) : message.op_return_data;
        if (message.orig_hash != null && message.hasOwnProperty("orig_hash"))
            object.orig_hash = options.bytes === String ? $util.base64.encode(message.orig_hash, 0, message.orig_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.orig_hash) : message.orig_hash;
        if (message.orig_index != null && message.hasOwnProperty("orig_index"))
            object.orig_index = message.orig_index;
        if (message.payment_req_index != null && message.hasOwnProperty("payment_req_index"))
            object.payment_req_index = message.payment_req_index;
        return object;
    };

    TxOutput.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return TxOutput;
})();

$root.PrevTx = (function() {

    function PrevTx(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    PrevTx.prototype.version = 0;
    PrevTx.prototype.lock_time = 0;
    PrevTx.prototype.inputs_count = 0;
    PrevTx.prototype.outputs_count = 0;
    PrevTx.prototype.extra_data_len = 0;
    PrevTx.prototype.expiry = 0;
    PrevTx.prototype.version_group_id = 0;
    PrevTx.prototype.timestamp = 0;
    PrevTx.prototype.branch_id = 0;

    PrevTx.create = function create(properties) {
        return new PrevTx(properties);
    };

    PrevTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).uint32(message.version);
        writer.uint32(32).uint32(message.lock_time);
        writer.uint32(48).uint32(message.inputs_count);
        writer.uint32(56).uint32(message.outputs_count);
        if (message.extra_data_len != null && Object.hasOwnProperty.call(message, "extra_data_len"))
            writer.uint32(72).uint32(message.extra_data_len);
        if (message.expiry != null && Object.hasOwnProperty.call(message, "expiry"))
            writer.uint32(80).uint32(message.expiry);
        if (message.version_group_id != null && Object.hasOwnProperty.call(message, "version_group_id"))
            writer.uint32(96).uint32(message.version_group_id);
        if (message.timestamp != null && Object.hasOwnProperty.call(message, "timestamp"))
            writer.uint32(104).uint32(message.timestamp);
        if (message.branch_id != null && Object.hasOwnProperty.call(message, "branch_id"))
            writer.uint32(112).uint32(message.branch_id);
        return writer;
    };

    PrevTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    PrevTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.PrevTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.version = reader.uint32();
                break;
            case 4:
                message.lock_time = reader.uint32();
                break;
            case 6:
                message.inputs_count = reader.uint32();
                break;
            case 7:
                message.outputs_count = reader.uint32();
                break;
            case 9:
                message.extra_data_len = reader.uint32();
                break;
            case 10:
                message.expiry = reader.uint32();
                break;
            case 12:
                message.version_group_id = reader.uint32();
                break;
            case 13:
                message.timestamp = reader.uint32();
                break;
            case 14:
                message.branch_id = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("version"))
            throw $util.ProtocolError("missing required 'version'", { instance: message });
        if (!message.hasOwnProperty("lock_time"))
            throw $util.ProtocolError("missing required 'lock_time'", { instance: message });
        if (!message.hasOwnProperty("inputs_count"))
            throw $util.ProtocolError("missing required 'inputs_count'", { instance: message });
        if (!message.hasOwnProperty("outputs_count"))
            throw $util.ProtocolError("missing required 'outputs_count'", { instance: message });
        return message;
    };

    PrevTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    PrevTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isInteger(message.version))
            return "version: integer expected";
        if (!$util.isInteger(message.lock_time))
            return "lock_time: integer expected";
        if (!$util.isInteger(message.inputs_count))
            return "inputs_count: integer expected";
        if (!$util.isInteger(message.outputs_count))
            return "outputs_count: integer expected";
        if (message.extra_data_len != null && message.hasOwnProperty("extra_data_len"))
            if (!$util.isInteger(message.extra_data_len))
                return "extra_data_len: integer expected";
        if (message.expiry != null && message.hasOwnProperty("expiry"))
            if (!$util.isInteger(message.expiry))
                return "expiry: integer expected";
        if (message.version_group_id != null && message.hasOwnProperty("version_group_id"))
            if (!$util.isInteger(message.version_group_id))
                return "version_group_id: integer expected";
        if (message.timestamp != null && message.hasOwnProperty("timestamp"))
            if (!$util.isInteger(message.timestamp))
                return "timestamp: integer expected";
        if (message.branch_id != null && message.hasOwnProperty("branch_id"))
            if (!$util.isInteger(message.branch_id))
                return "branch_id: integer expected";
        return null;
    };

    PrevTx.fromObject = function fromObject(object) {
        if (object instanceof $root.PrevTx)
            return object;
        var message = new $root.PrevTx();
        if (object.version != null)
            message.version = object.version >>> 0;
        if (object.lock_time != null)
            message.lock_time = object.lock_time >>> 0;
        if (object.inputs_count != null)
            message.inputs_count = object.inputs_count >>> 0;
        if (object.outputs_count != null)
            message.outputs_count = object.outputs_count >>> 0;
        if (object.extra_data_len != null)
            message.extra_data_len = object.extra_data_len >>> 0;
        if (object.expiry != null)
            message.expiry = object.expiry >>> 0;
        if (object.version_group_id != null)
            message.version_group_id = object.version_group_id >>> 0;
        if (object.timestamp != null)
            message.timestamp = object.timestamp >>> 0;
        if (object.branch_id != null)
            message.branch_id = object.branch_id >>> 0;
        return message;
    };

    PrevTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.version = 0;
            object.lock_time = 0;
            object.inputs_count = 0;
            object.outputs_count = 0;
            object.extra_data_len = 0;
            object.expiry = 0;
            object.version_group_id = 0;
            object.timestamp = 0;
            object.branch_id = 0;
        }
        if (message.version != null && message.hasOwnProperty("version"))
            object.version = message.version;
        if (message.lock_time != null && message.hasOwnProperty("lock_time"))
            object.lock_time = message.lock_time;
        if (message.inputs_count != null && message.hasOwnProperty("inputs_count"))
            object.inputs_count = message.inputs_count;
        if (message.outputs_count != null && message.hasOwnProperty("outputs_count"))
            object.outputs_count = message.outputs_count;
        if (message.extra_data_len != null && message.hasOwnProperty("extra_data_len"))
            object.extra_data_len = message.extra_data_len;
        if (message.expiry != null && message.hasOwnProperty("expiry"))
            object.expiry = message.expiry;
        if (message.version_group_id != null && message.hasOwnProperty("version_group_id"))
            object.version_group_id = message.version_group_id;
        if (message.timestamp != null && message.hasOwnProperty("timestamp"))
            object.timestamp = message.timestamp;
        if (message.branch_id != null && message.hasOwnProperty("branch_id"))
            object.branch_id = message.branch_id;
        return object;
    };

    PrevTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return PrevTx;
})();

$root.PrevInput = (function() {

    function PrevInput(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    PrevInput.prototype.prev_hash = $util.newBuffer([]);
    PrevInput.prototype.prev_index = 0;
    PrevInput.prototype.script_sig = $util.newBuffer([]);
    PrevInput.prototype.sequence = 0;
    PrevInput.prototype.decred_tree = 0;

    PrevInput.create = function create(properties) {
        return new PrevInput(properties);
    };

    PrevInput.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(18).bytes(message.prev_hash);
        writer.uint32(24).uint32(message.prev_index);
        writer.uint32(34).bytes(message.script_sig);
        writer.uint32(40).uint32(message.sequence);
        if (message.decred_tree != null && Object.hasOwnProperty.call(message, "decred_tree"))
            writer.uint32(72).uint32(message.decred_tree);
        return writer;
    };

    PrevInput.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    PrevInput.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.PrevInput();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 2:
                message.prev_hash = reader.bytes();
                break;
            case 3:
                message.prev_index = reader.uint32();
                break;
            case 4:
                message.script_sig = reader.bytes();
                break;
            case 5:
                message.sequence = reader.uint32();
                break;
            case 9:
                message.decred_tree = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("prev_hash"))
            throw $util.ProtocolError("missing required 'prev_hash'", { instance: message });
        if (!message.hasOwnProperty("prev_index"))
            throw $util.ProtocolError("missing required 'prev_index'", { instance: message });
        if (!message.hasOwnProperty("script_sig"))
            throw $util.ProtocolError("missing required 'script_sig'", { instance: message });
        if (!message.hasOwnProperty("sequence"))
            throw $util.ProtocolError("missing required 'sequence'", { instance: message });
        return message;
    };

    PrevInput.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    PrevInput.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.prev_hash && typeof message.prev_hash.length === "number" || $util.isString(message.prev_hash)))
            return "prev_hash: buffer expected";
        if (!$util.isInteger(message.prev_index))
            return "prev_index: integer expected";
        if (!(message.script_sig && typeof message.script_sig.length === "number" || $util.isString(message.script_sig)))
            return "script_sig: buffer expected";
        if (!$util.isInteger(message.sequence))
            return "sequence: integer expected";
        if (message.decred_tree != null && message.hasOwnProperty("decred_tree"))
            if (!$util.isInteger(message.decred_tree))
                return "decred_tree: integer expected";
        return null;
    };

    PrevInput.fromObject = function fromObject(object) {
        if (object instanceof $root.PrevInput)
            return object;
        var message = new $root.PrevInput();
        if (object.prev_hash != null)
            if (typeof object.prev_hash === "string")
                $util.base64.decode(object.prev_hash, message.prev_hash = $util.newBuffer($util.base64.length(object.prev_hash)), 0);
            else if (object.prev_hash.length)
                message.prev_hash = object.prev_hash;
        if (object.prev_index != null)
            message.prev_index = object.prev_index >>> 0;
        if (object.script_sig != null)
            if (typeof object.script_sig === "string")
                $util.base64.decode(object.script_sig, message.script_sig = $util.newBuffer($util.base64.length(object.script_sig)), 0);
            else if (object.script_sig.length)
                message.script_sig = object.script_sig;
        if (object.sequence != null)
            message.sequence = object.sequence >>> 0;
        if (object.decred_tree != null)
            message.decred_tree = object.decred_tree >>> 0;
        return message;
    };

    PrevInput.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.prev_hash = "";
            else {
                object.prev_hash = [];
                if (options.bytes !== Array)
                    object.prev_hash = $util.newBuffer(object.prev_hash);
            }
            object.prev_index = 0;
            if (options.bytes === String)
                object.script_sig = "";
            else {
                object.script_sig = [];
                if (options.bytes !== Array)
                    object.script_sig = $util.newBuffer(object.script_sig);
            }
            object.sequence = 0;
            object.decred_tree = 0;
        }
        if (message.prev_hash != null && message.hasOwnProperty("prev_hash"))
            object.prev_hash = options.bytes === String ? $util.base64.encode(message.prev_hash, 0, message.prev_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.prev_hash) : message.prev_hash;
        if (message.prev_index != null && message.hasOwnProperty("prev_index"))
            object.prev_index = message.prev_index;
        if (message.script_sig != null && message.hasOwnProperty("script_sig"))
            object.script_sig = options.bytes === String ? $util.base64.encode(message.script_sig, 0, message.script_sig.length) : options.bytes === Array ? Array.prototype.slice.call(message.script_sig) : message.script_sig;
        if (message.sequence != null && message.hasOwnProperty("sequence"))
            object.sequence = message.sequence;
        if (message.decred_tree != null && message.hasOwnProperty("decred_tree"))
            object.decred_tree = message.decred_tree;
        return object;
    };

    PrevInput.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return PrevInput;
})();

$root.PrevOutput = (function() {

    function PrevOutput(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    PrevOutput.prototype.amount = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    PrevOutput.prototype.script_pubkey = $util.newBuffer([]);
    PrevOutput.prototype.decred_script_version = 0;

    PrevOutput.create = function create(properties) {
        return new PrevOutput(properties);
    };

    PrevOutput.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).uint64(message.amount);
        writer.uint32(18).bytes(message.script_pubkey);
        if (message.decred_script_version != null && Object.hasOwnProperty.call(message, "decred_script_version"))
            writer.uint32(24).uint32(message.decred_script_version);
        return writer;
    };

    PrevOutput.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    PrevOutput.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.PrevOutput();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.amount = reader.uint64();
                break;
            case 2:
                message.script_pubkey = reader.bytes();
                break;
            case 3:
                message.decred_script_version = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("amount"))
            throw $util.ProtocolError("missing required 'amount'", { instance: message });
        if (!message.hasOwnProperty("script_pubkey"))
            throw $util.ProtocolError("missing required 'script_pubkey'", { instance: message });
        return message;
    };

    PrevOutput.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    PrevOutput.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
            return "amount: integer|Long expected";
        if (!(message.script_pubkey && typeof message.script_pubkey.length === "number" || $util.isString(message.script_pubkey)))
            return "script_pubkey: buffer expected";
        if (message.decred_script_version != null && message.hasOwnProperty("decred_script_version"))
            if (!$util.isInteger(message.decred_script_version))
                return "decred_script_version: integer expected";
        return null;
    };

    PrevOutput.fromObject = function fromObject(object) {
        if (object instanceof $root.PrevOutput)
            return object;
        var message = new $root.PrevOutput();
        if (object.amount != null)
            if ($util.Long)
                (message.amount = $util.Long.fromValue(object.amount)).unsigned = true;
            else if (typeof object.amount === "string")
                message.amount = parseInt(object.amount, 10);
            else if (typeof object.amount === "number")
                message.amount = object.amount;
            else if (typeof object.amount === "object")
                message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber(true);
        if (object.script_pubkey != null)
            if (typeof object.script_pubkey === "string")
                $util.base64.decode(object.script_pubkey, message.script_pubkey = $util.newBuffer($util.base64.length(object.script_pubkey)), 0);
            else if (object.script_pubkey.length)
                message.script_pubkey = object.script_pubkey;
        if (object.decred_script_version != null)
            message.decred_script_version = object.decred_script_version >>> 0;
        return message;
    };

    PrevOutput.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.amount = options.longs === String ? "0" : 0;
            if (options.bytes === String)
                object.script_pubkey = "";
            else {
                object.script_pubkey = [];
                if (options.bytes !== Array)
                    object.script_pubkey = $util.newBuffer(object.script_pubkey);
            }
            object.decred_script_version = 0;
        }
        if (message.amount != null && message.hasOwnProperty("amount"))
            if (typeof message.amount === "number")
                object.amount = options.longs === String ? String(message.amount) : message.amount;
            else
                object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber(true) : message.amount;
        if (message.script_pubkey != null && message.hasOwnProperty("script_pubkey"))
            object.script_pubkey = options.bytes === String ? $util.base64.encode(message.script_pubkey, 0, message.script_pubkey.length) : options.bytes === Array ? Array.prototype.slice.call(message.script_pubkey) : message.script_pubkey;
        if (message.decred_script_version != null && message.hasOwnProperty("decred_script_version"))
            object.decred_script_version = message.decred_script_version;
        return object;
    };

    PrevOutput.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return PrevOutput;
})();

$root.TxAckPaymentRequest = (function() {

    function TxAckPaymentRequest(properties) {
        this.memos = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    TxAckPaymentRequest.prototype.nonce = $util.newBuffer([]);
    TxAckPaymentRequest.prototype.recipient_name = "";
    TxAckPaymentRequest.prototype.memos = $util.emptyArray;
    TxAckPaymentRequest.prototype.amount = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    TxAckPaymentRequest.prototype.signature = $util.newBuffer([]);

    TxAckPaymentRequest.create = function create(properties) {
        return new TxAckPaymentRequest(properties);
    };

    TxAckPaymentRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.nonce != null && Object.hasOwnProperty.call(message, "nonce"))
            writer.uint32(10).bytes(message.nonce);
        writer.uint32(18).string(message.recipient_name);
        if (message.memos != null && message.memos.length)
            for (var i = 0; i < message.memos.length; ++i)
                $root.TxAckPaymentRequest.PaymentRequestMemo.encode(message.memos[i], writer.uint32(26).fork()).ldelim();
        if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
            writer.uint32(32).uint64(message.amount);
        writer.uint32(42).bytes(message.signature);
        return writer;
    };

    TxAckPaymentRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    TxAckPaymentRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TxAckPaymentRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.nonce = reader.bytes();
                break;
            case 2:
                message.recipient_name = reader.string();
                break;
            case 3:
                if (!(message.memos && message.memos.length))
                    message.memos = [];
                message.memos.push($root.TxAckPaymentRequest.PaymentRequestMemo.decode(reader, reader.uint32()));
                break;
            case 4:
                message.amount = reader.uint64();
                break;
            case 5:
                message.signature = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("recipient_name"))
            throw $util.ProtocolError("missing required 'recipient_name'", { instance: message });
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        return message;
    };

    TxAckPaymentRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    TxAckPaymentRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.nonce != null && message.hasOwnProperty("nonce"))
            if (!(message.nonce && typeof message.nonce.length === "number" || $util.isString(message.nonce)))
                return "nonce: buffer expected";
        if (!$util.isString(message.recipient_name))
            return "recipient_name: string expected";
        if (message.memos != null && message.hasOwnProperty("memos")) {
            if (!Array.isArray(message.memos))
                return "memos: array expected";
            for (var i = 0; i < message.memos.length; ++i) {
                var error = $root.TxAckPaymentRequest.PaymentRequestMemo.verify(message.memos[i]);
                if (error)
                    return "memos." + error;
            }
        }
        if (message.amount != null && message.hasOwnProperty("amount"))
            if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
                return "amount: integer|Long expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        return null;
    };

    TxAckPaymentRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.TxAckPaymentRequest)
            return object;
        var message = new $root.TxAckPaymentRequest();
        if (object.nonce != null)
            if (typeof object.nonce === "string")
                $util.base64.decode(object.nonce, message.nonce = $util.newBuffer($util.base64.length(object.nonce)), 0);
            else if (object.nonce.length)
                message.nonce = object.nonce;
        if (object.recipient_name != null)
            message.recipient_name = String(object.recipient_name);
        if (object.memos) {
            if (!Array.isArray(object.memos))
                throw TypeError(".TxAckPaymentRequest.memos: array expected");
            message.memos = [];
            for (var i = 0; i < object.memos.length; ++i) {
                if (typeof object.memos[i] !== "object")
                    throw TypeError(".TxAckPaymentRequest.memos: object expected");
                message.memos[i] = $root.TxAckPaymentRequest.PaymentRequestMemo.fromObject(object.memos[i]);
            }
        }
        if (object.amount != null)
            if ($util.Long)
                (message.amount = $util.Long.fromValue(object.amount)).unsigned = true;
            else if (typeof object.amount === "string")
                message.amount = parseInt(object.amount, 10);
            else if (typeof object.amount === "number")
                message.amount = object.amount;
            else if (typeof object.amount === "object")
                message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber(true);
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        return message;
    };

    TxAckPaymentRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.memos = [];
        if (options.defaults) {
            if (options.bytes === String)
                object.nonce = "";
            else {
                object.nonce = [];
                if (options.bytes !== Array)
                    object.nonce = $util.newBuffer(object.nonce);
            }
            object.recipient_name = "";
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.amount = options.longs === String ? "0" : 0;
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
        }
        if (message.nonce != null && message.hasOwnProperty("nonce"))
            object.nonce = options.bytes === String ? $util.base64.encode(message.nonce, 0, message.nonce.length) : options.bytes === Array ? Array.prototype.slice.call(message.nonce) : message.nonce;
        if (message.recipient_name != null && message.hasOwnProperty("recipient_name"))
            object.recipient_name = message.recipient_name;
        if (message.memos && message.memos.length) {
            object.memos = [];
            for (var j = 0; j < message.memos.length; ++j)
                object.memos[j] = $root.TxAckPaymentRequest.PaymentRequestMemo.toObject(message.memos[j], options);
        }
        if (message.amount != null && message.hasOwnProperty("amount"))
            if (typeof message.amount === "number")
                object.amount = options.longs === String ? String(message.amount) : message.amount;
            else
                object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber(true) : message.amount;
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        return object;
    };

    TxAckPaymentRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    TxAckPaymentRequest.PaymentRequestMemo = (function() {

        function PaymentRequestMemo(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        PaymentRequestMemo.prototype.text_memo = null;
        PaymentRequestMemo.prototype.refund_memo = null;
        PaymentRequestMemo.prototype.coin_purchase_memo = null;

        PaymentRequestMemo.create = function create(properties) {
            return new PaymentRequestMemo(properties);
        };

        PaymentRequestMemo.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.text_memo != null && Object.hasOwnProperty.call(message, "text_memo"))
                $root.TxAckPaymentRequest.TextMemo.encode(message.text_memo, writer.uint32(10).fork()).ldelim();
            if (message.refund_memo != null && Object.hasOwnProperty.call(message, "refund_memo"))
                $root.TxAckPaymentRequest.RefundMemo.encode(message.refund_memo, writer.uint32(18).fork()).ldelim();
            if (message.coin_purchase_memo != null && Object.hasOwnProperty.call(message, "coin_purchase_memo"))
                $root.TxAckPaymentRequest.CoinPurchaseMemo.encode(message.coin_purchase_memo, writer.uint32(26).fork()).ldelim();
            return writer;
        };

        PaymentRequestMemo.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        PaymentRequestMemo.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TxAckPaymentRequest.PaymentRequestMemo();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.text_memo = $root.TxAckPaymentRequest.TextMemo.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.refund_memo = $root.TxAckPaymentRequest.RefundMemo.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.coin_purchase_memo = $root.TxAckPaymentRequest.CoinPurchaseMemo.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        PaymentRequestMemo.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        PaymentRequestMemo.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.text_memo != null && message.hasOwnProperty("text_memo")) {
                var error = $root.TxAckPaymentRequest.TextMemo.verify(message.text_memo);
                if (error)
                    return "text_memo." + error;
            }
            if (message.refund_memo != null && message.hasOwnProperty("refund_memo")) {
                var error = $root.TxAckPaymentRequest.RefundMemo.verify(message.refund_memo);
                if (error)
                    return "refund_memo." + error;
            }
            if (message.coin_purchase_memo != null && message.hasOwnProperty("coin_purchase_memo")) {
                var error = $root.TxAckPaymentRequest.CoinPurchaseMemo.verify(message.coin_purchase_memo);
                if (error)
                    return "coin_purchase_memo." + error;
            }
            return null;
        };

        PaymentRequestMemo.fromObject = function fromObject(object) {
            if (object instanceof $root.TxAckPaymentRequest.PaymentRequestMemo)
                return object;
            var message = new $root.TxAckPaymentRequest.PaymentRequestMemo();
            if (object.text_memo != null) {
                if (typeof object.text_memo !== "object")
                    throw TypeError(".TxAckPaymentRequest.PaymentRequestMemo.text_memo: object expected");
                message.text_memo = $root.TxAckPaymentRequest.TextMemo.fromObject(object.text_memo);
            }
            if (object.refund_memo != null) {
                if (typeof object.refund_memo !== "object")
                    throw TypeError(".TxAckPaymentRequest.PaymentRequestMemo.refund_memo: object expected");
                message.refund_memo = $root.TxAckPaymentRequest.RefundMemo.fromObject(object.refund_memo);
            }
            if (object.coin_purchase_memo != null) {
                if (typeof object.coin_purchase_memo !== "object")
                    throw TypeError(".TxAckPaymentRequest.PaymentRequestMemo.coin_purchase_memo: object expected");
                message.coin_purchase_memo = $root.TxAckPaymentRequest.CoinPurchaseMemo.fromObject(object.coin_purchase_memo);
            }
            return message;
        };

        PaymentRequestMemo.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.text_memo = null;
                object.refund_memo = null;
                object.coin_purchase_memo = null;
            }
            if (message.text_memo != null && message.hasOwnProperty("text_memo"))
                object.text_memo = $root.TxAckPaymentRequest.TextMemo.toObject(message.text_memo, options);
            if (message.refund_memo != null && message.hasOwnProperty("refund_memo"))
                object.refund_memo = $root.TxAckPaymentRequest.RefundMemo.toObject(message.refund_memo, options);
            if (message.coin_purchase_memo != null && message.hasOwnProperty("coin_purchase_memo"))
                object.coin_purchase_memo = $root.TxAckPaymentRequest.CoinPurchaseMemo.toObject(message.coin_purchase_memo, options);
            return object;
        };

        PaymentRequestMemo.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return PaymentRequestMemo;
    })();

    TxAckPaymentRequest.TextMemo = (function() {

        function TextMemo(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        TextMemo.prototype.text = "";

        TextMemo.create = function create(properties) {
            return new TextMemo(properties);
        };

        TextMemo.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(10).string(message.text);
            return writer;
        };

        TextMemo.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        TextMemo.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TxAckPaymentRequest.TextMemo();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.text = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("text"))
                throw $util.ProtocolError("missing required 'text'", { instance: message });
            return message;
        };

        TextMemo.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        TextMemo.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isString(message.text))
                return "text: string expected";
            return null;
        };

        TextMemo.fromObject = function fromObject(object) {
            if (object instanceof $root.TxAckPaymentRequest.TextMemo)
                return object;
            var message = new $root.TxAckPaymentRequest.TextMemo();
            if (object.text != null)
                message.text = String(object.text);
            return message;
        };

        TextMemo.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.text = "";
            if (message.text != null && message.hasOwnProperty("text"))
                object.text = message.text;
            return object;
        };

        TextMemo.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TextMemo;
    })();

    TxAckPaymentRequest.RefundMemo = (function() {

        function RefundMemo(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        RefundMemo.prototype.address = "";
        RefundMemo.prototype.mac = $util.newBuffer([]);

        RefundMemo.create = function create(properties) {
            return new RefundMemo(properties);
        };

        RefundMemo.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(10).string(message.address);
            writer.uint32(18).bytes(message.mac);
            return writer;
        };

        RefundMemo.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        RefundMemo.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TxAckPaymentRequest.RefundMemo();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.mac = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("address"))
                throw $util.ProtocolError("missing required 'address'", { instance: message });
            if (!message.hasOwnProperty("mac"))
                throw $util.ProtocolError("missing required 'mac'", { instance: message });
            return message;
        };

        RefundMemo.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        RefundMemo.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isString(message.address))
                return "address: string expected";
            if (!(message.mac && typeof message.mac.length === "number" || $util.isString(message.mac)))
                return "mac: buffer expected";
            return null;
        };

        RefundMemo.fromObject = function fromObject(object) {
            if (object instanceof $root.TxAckPaymentRequest.RefundMemo)
                return object;
            var message = new $root.TxAckPaymentRequest.RefundMemo();
            if (object.address != null)
                message.address = String(object.address);
            if (object.mac != null)
                if (typeof object.mac === "string")
                    $util.base64.decode(object.mac, message.mac = $util.newBuffer($util.base64.length(object.mac)), 0);
                else if (object.mac.length)
                    message.mac = object.mac;
            return message;
        };

        RefundMemo.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.address = "";
                if (options.bytes === String)
                    object.mac = "";
                else {
                    object.mac = [];
                    if (options.bytes !== Array)
                        object.mac = $util.newBuffer(object.mac);
                }
            }
            if (message.address != null && message.hasOwnProperty("address"))
                object.address = message.address;
            if (message.mac != null && message.hasOwnProperty("mac"))
                object.mac = options.bytes === String ? $util.base64.encode(message.mac, 0, message.mac.length) : options.bytes === Array ? Array.prototype.slice.call(message.mac) : message.mac;
            return object;
        };

        RefundMemo.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RefundMemo;
    })();

    TxAckPaymentRequest.CoinPurchaseMemo = (function() {

        function CoinPurchaseMemo(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        CoinPurchaseMemo.prototype.coin_type = 0;
        CoinPurchaseMemo.prototype.amount = "";
        CoinPurchaseMemo.prototype.address = "";
        CoinPurchaseMemo.prototype.mac = $util.newBuffer([]);

        CoinPurchaseMemo.create = function create(properties) {
            return new CoinPurchaseMemo(properties);
        };

        CoinPurchaseMemo.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(8).uint32(message.coin_type);
            writer.uint32(18).string(message.amount);
            writer.uint32(26).string(message.address);
            writer.uint32(34).bytes(message.mac);
            return writer;
        };

        CoinPurchaseMemo.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        CoinPurchaseMemo.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TxAckPaymentRequest.CoinPurchaseMemo();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.coin_type = reader.uint32();
                    break;
                case 2:
                    message.amount = reader.string();
                    break;
                case 3:
                    message.address = reader.string();
                    break;
                case 4:
                    message.mac = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("coin_type"))
                throw $util.ProtocolError("missing required 'coin_type'", { instance: message });
            if (!message.hasOwnProperty("amount"))
                throw $util.ProtocolError("missing required 'amount'", { instance: message });
            if (!message.hasOwnProperty("address"))
                throw $util.ProtocolError("missing required 'address'", { instance: message });
            if (!message.hasOwnProperty("mac"))
                throw $util.ProtocolError("missing required 'mac'", { instance: message });
            return message;
        };

        CoinPurchaseMemo.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        CoinPurchaseMemo.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isInteger(message.coin_type))
                return "coin_type: integer expected";
            if (!$util.isString(message.amount))
                return "amount: string expected";
            if (!$util.isString(message.address))
                return "address: string expected";
            if (!(message.mac && typeof message.mac.length === "number" || $util.isString(message.mac)))
                return "mac: buffer expected";
            return null;
        };

        CoinPurchaseMemo.fromObject = function fromObject(object) {
            if (object instanceof $root.TxAckPaymentRequest.CoinPurchaseMemo)
                return object;
            var message = new $root.TxAckPaymentRequest.CoinPurchaseMemo();
            if (object.coin_type != null)
                message.coin_type = object.coin_type >>> 0;
            if (object.amount != null)
                message.amount = String(object.amount);
            if (object.address != null)
                message.address = String(object.address);
            if (object.mac != null)
                if (typeof object.mac === "string")
                    $util.base64.decode(object.mac, message.mac = $util.newBuffer($util.base64.length(object.mac)), 0);
                else if (object.mac.length)
                    message.mac = object.mac;
            return message;
        };

        CoinPurchaseMemo.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.coin_type = 0;
                object.amount = "";
                object.address = "";
                if (options.bytes === String)
                    object.mac = "";
                else {
                    object.mac = [];
                    if (options.bytes !== Array)
                        object.mac = $util.newBuffer(object.mac);
                }
            }
            if (message.coin_type != null && message.hasOwnProperty("coin_type"))
                object.coin_type = message.coin_type;
            if (message.amount != null && message.hasOwnProperty("amount"))
                object.amount = message.amount;
            if (message.address != null && message.hasOwnProperty("address"))
                object.address = message.address;
            if (message.mac != null && message.hasOwnProperty("mac"))
                object.mac = options.bytes === String ? $util.base64.encode(message.mac, 0, message.mac.length) : options.bytes === Array ? Array.prototype.slice.call(message.mac) : message.mac;
            return object;
        };

        CoinPurchaseMemo.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CoinPurchaseMemo;
    })();

    return TxAckPaymentRequest;
})();

$root.TxAckInput = (function() {

    function TxAckInput(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    TxAckInput.prototype.tx = null;

    TxAckInput.create = function create(properties) {
        return new TxAckInput(properties);
    };

    TxAckInput.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        $root.TxAckInput.TxAckInputWrapper.encode(message.tx, writer.uint32(10).fork()).ldelim();
        return writer;
    };

    TxAckInput.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    TxAckInput.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TxAckInput();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.tx = $root.TxAckInput.TxAckInputWrapper.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("tx"))
            throw $util.ProtocolError("missing required 'tx'", { instance: message });
        return message;
    };

    TxAckInput.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    TxAckInput.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        {
            var error = $root.TxAckInput.TxAckInputWrapper.verify(message.tx);
            if (error)
                return "tx." + error;
        }
        return null;
    };

    TxAckInput.fromObject = function fromObject(object) {
        if (object instanceof $root.TxAckInput)
            return object;
        var message = new $root.TxAckInput();
        if (object.tx != null) {
            if (typeof object.tx !== "object")
                throw TypeError(".TxAckInput.tx: object expected");
            message.tx = $root.TxAckInput.TxAckInputWrapper.fromObject(object.tx);
        }
        return message;
    };

    TxAckInput.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.tx = null;
        if (message.tx != null && message.hasOwnProperty("tx"))
            object.tx = $root.TxAckInput.TxAckInputWrapper.toObject(message.tx, options);
        return object;
    };

    TxAckInput.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    TxAckInput.TxAckInputWrapper = (function() {

        function TxAckInputWrapper(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        TxAckInputWrapper.prototype.input = null;

        TxAckInputWrapper.create = function create(properties) {
            return new TxAckInputWrapper(properties);
        };

        TxAckInputWrapper.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            $root.TxInput.encode(message.input, writer.uint32(18).fork()).ldelim();
            return writer;
        };

        TxAckInputWrapper.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        TxAckInputWrapper.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TxAckInput.TxAckInputWrapper();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 2:
                    message.input = $root.TxInput.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("input"))
                throw $util.ProtocolError("missing required 'input'", { instance: message });
            return message;
        };

        TxAckInputWrapper.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        TxAckInputWrapper.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            {
                var error = $root.TxInput.verify(message.input);
                if (error)
                    return "input." + error;
            }
            return null;
        };

        TxAckInputWrapper.fromObject = function fromObject(object) {
            if (object instanceof $root.TxAckInput.TxAckInputWrapper)
                return object;
            var message = new $root.TxAckInput.TxAckInputWrapper();
            if (object.input != null) {
                if (typeof object.input !== "object")
                    throw TypeError(".TxAckInput.TxAckInputWrapper.input: object expected");
                message.input = $root.TxInput.fromObject(object.input);
            }
            return message;
        };

        TxAckInputWrapper.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.input = null;
            if (message.input != null && message.hasOwnProperty("input"))
                object.input = $root.TxInput.toObject(message.input, options);
            return object;
        };

        TxAckInputWrapper.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TxAckInputWrapper;
    })();

    return TxAckInput;
})();

$root.TxAckOutput = (function() {

    function TxAckOutput(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    TxAckOutput.prototype.tx = null;

    TxAckOutput.create = function create(properties) {
        return new TxAckOutput(properties);
    };

    TxAckOutput.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        $root.TxAckOutput.TxAckOutputWrapper.encode(message.tx, writer.uint32(10).fork()).ldelim();
        return writer;
    };

    TxAckOutput.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    TxAckOutput.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TxAckOutput();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.tx = $root.TxAckOutput.TxAckOutputWrapper.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("tx"))
            throw $util.ProtocolError("missing required 'tx'", { instance: message });
        return message;
    };

    TxAckOutput.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    TxAckOutput.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        {
            var error = $root.TxAckOutput.TxAckOutputWrapper.verify(message.tx);
            if (error)
                return "tx." + error;
        }
        return null;
    };

    TxAckOutput.fromObject = function fromObject(object) {
        if (object instanceof $root.TxAckOutput)
            return object;
        var message = new $root.TxAckOutput();
        if (object.tx != null) {
            if (typeof object.tx !== "object")
                throw TypeError(".TxAckOutput.tx: object expected");
            message.tx = $root.TxAckOutput.TxAckOutputWrapper.fromObject(object.tx);
        }
        return message;
    };

    TxAckOutput.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.tx = null;
        if (message.tx != null && message.hasOwnProperty("tx"))
            object.tx = $root.TxAckOutput.TxAckOutputWrapper.toObject(message.tx, options);
        return object;
    };

    TxAckOutput.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    TxAckOutput.TxAckOutputWrapper = (function() {

        function TxAckOutputWrapper(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        TxAckOutputWrapper.prototype.output = null;

        TxAckOutputWrapper.create = function create(properties) {
            return new TxAckOutputWrapper(properties);
        };

        TxAckOutputWrapper.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            $root.TxOutput.encode(message.output, writer.uint32(42).fork()).ldelim();
            return writer;
        };

        TxAckOutputWrapper.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        TxAckOutputWrapper.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TxAckOutput.TxAckOutputWrapper();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 5:
                    message.output = $root.TxOutput.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("output"))
                throw $util.ProtocolError("missing required 'output'", { instance: message });
            return message;
        };

        TxAckOutputWrapper.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        TxAckOutputWrapper.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            {
                var error = $root.TxOutput.verify(message.output);
                if (error)
                    return "output." + error;
            }
            return null;
        };

        TxAckOutputWrapper.fromObject = function fromObject(object) {
            if (object instanceof $root.TxAckOutput.TxAckOutputWrapper)
                return object;
            var message = new $root.TxAckOutput.TxAckOutputWrapper();
            if (object.output != null) {
                if (typeof object.output !== "object")
                    throw TypeError(".TxAckOutput.TxAckOutputWrapper.output: object expected");
                message.output = $root.TxOutput.fromObject(object.output);
            }
            return message;
        };

        TxAckOutputWrapper.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.output = null;
            if (message.output != null && message.hasOwnProperty("output"))
                object.output = $root.TxOutput.toObject(message.output, options);
            return object;
        };

        TxAckOutputWrapper.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TxAckOutputWrapper;
    })();

    return TxAckOutput;
})();

$root.TxAckPrevMeta = (function() {

    function TxAckPrevMeta(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    TxAckPrevMeta.prototype.tx = null;

    TxAckPrevMeta.create = function create(properties) {
        return new TxAckPrevMeta(properties);
    };

    TxAckPrevMeta.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        $root.PrevTx.encode(message.tx, writer.uint32(10).fork()).ldelim();
        return writer;
    };

    TxAckPrevMeta.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    TxAckPrevMeta.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TxAckPrevMeta();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.tx = $root.PrevTx.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("tx"))
            throw $util.ProtocolError("missing required 'tx'", { instance: message });
        return message;
    };

    TxAckPrevMeta.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    TxAckPrevMeta.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        {
            var error = $root.PrevTx.verify(message.tx);
            if (error)
                return "tx." + error;
        }
        return null;
    };

    TxAckPrevMeta.fromObject = function fromObject(object) {
        if (object instanceof $root.TxAckPrevMeta)
            return object;
        var message = new $root.TxAckPrevMeta();
        if (object.tx != null) {
            if (typeof object.tx !== "object")
                throw TypeError(".TxAckPrevMeta.tx: object expected");
            message.tx = $root.PrevTx.fromObject(object.tx);
        }
        return message;
    };

    TxAckPrevMeta.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.tx = null;
        if (message.tx != null && message.hasOwnProperty("tx"))
            object.tx = $root.PrevTx.toObject(message.tx, options);
        return object;
    };

    TxAckPrevMeta.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return TxAckPrevMeta;
})();

$root.TxAckPrevInput = (function() {

    function TxAckPrevInput(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    TxAckPrevInput.prototype.tx = null;

    TxAckPrevInput.create = function create(properties) {
        return new TxAckPrevInput(properties);
    };

    TxAckPrevInput.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        $root.TxAckPrevInput.TxAckPrevInputWrapper.encode(message.tx, writer.uint32(10).fork()).ldelim();
        return writer;
    };

    TxAckPrevInput.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    TxAckPrevInput.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TxAckPrevInput();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.tx = $root.TxAckPrevInput.TxAckPrevInputWrapper.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("tx"))
            throw $util.ProtocolError("missing required 'tx'", { instance: message });
        return message;
    };

    TxAckPrevInput.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    TxAckPrevInput.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        {
            var error = $root.TxAckPrevInput.TxAckPrevInputWrapper.verify(message.tx);
            if (error)
                return "tx." + error;
        }
        return null;
    };

    TxAckPrevInput.fromObject = function fromObject(object) {
        if (object instanceof $root.TxAckPrevInput)
            return object;
        var message = new $root.TxAckPrevInput();
        if (object.tx != null) {
            if (typeof object.tx !== "object")
                throw TypeError(".TxAckPrevInput.tx: object expected");
            message.tx = $root.TxAckPrevInput.TxAckPrevInputWrapper.fromObject(object.tx);
        }
        return message;
    };

    TxAckPrevInput.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.tx = null;
        if (message.tx != null && message.hasOwnProperty("tx"))
            object.tx = $root.TxAckPrevInput.TxAckPrevInputWrapper.toObject(message.tx, options);
        return object;
    };

    TxAckPrevInput.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    TxAckPrevInput.TxAckPrevInputWrapper = (function() {

        function TxAckPrevInputWrapper(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        TxAckPrevInputWrapper.prototype.input = null;

        TxAckPrevInputWrapper.create = function create(properties) {
            return new TxAckPrevInputWrapper(properties);
        };

        TxAckPrevInputWrapper.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            $root.PrevInput.encode(message.input, writer.uint32(18).fork()).ldelim();
            return writer;
        };

        TxAckPrevInputWrapper.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        TxAckPrevInputWrapper.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TxAckPrevInput.TxAckPrevInputWrapper();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 2:
                    message.input = $root.PrevInput.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("input"))
                throw $util.ProtocolError("missing required 'input'", { instance: message });
            return message;
        };

        TxAckPrevInputWrapper.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        TxAckPrevInputWrapper.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            {
                var error = $root.PrevInput.verify(message.input);
                if (error)
                    return "input." + error;
            }
            return null;
        };

        TxAckPrevInputWrapper.fromObject = function fromObject(object) {
            if (object instanceof $root.TxAckPrevInput.TxAckPrevInputWrapper)
                return object;
            var message = new $root.TxAckPrevInput.TxAckPrevInputWrapper();
            if (object.input != null) {
                if (typeof object.input !== "object")
                    throw TypeError(".TxAckPrevInput.TxAckPrevInputWrapper.input: object expected");
                message.input = $root.PrevInput.fromObject(object.input);
            }
            return message;
        };

        TxAckPrevInputWrapper.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.input = null;
            if (message.input != null && message.hasOwnProperty("input"))
                object.input = $root.PrevInput.toObject(message.input, options);
            return object;
        };

        TxAckPrevInputWrapper.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TxAckPrevInputWrapper;
    })();

    return TxAckPrevInput;
})();

$root.TxAckPrevOutput = (function() {

    function TxAckPrevOutput(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    TxAckPrevOutput.prototype.tx = null;

    TxAckPrevOutput.create = function create(properties) {
        return new TxAckPrevOutput(properties);
    };

    TxAckPrevOutput.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        $root.TxAckPrevOutput.TxAckPrevOutputWrapper.encode(message.tx, writer.uint32(10).fork()).ldelim();
        return writer;
    };

    TxAckPrevOutput.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    TxAckPrevOutput.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TxAckPrevOutput();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.tx = $root.TxAckPrevOutput.TxAckPrevOutputWrapper.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("tx"))
            throw $util.ProtocolError("missing required 'tx'", { instance: message });
        return message;
    };

    TxAckPrevOutput.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    TxAckPrevOutput.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        {
            var error = $root.TxAckPrevOutput.TxAckPrevOutputWrapper.verify(message.tx);
            if (error)
                return "tx." + error;
        }
        return null;
    };

    TxAckPrevOutput.fromObject = function fromObject(object) {
        if (object instanceof $root.TxAckPrevOutput)
            return object;
        var message = new $root.TxAckPrevOutput();
        if (object.tx != null) {
            if (typeof object.tx !== "object")
                throw TypeError(".TxAckPrevOutput.tx: object expected");
            message.tx = $root.TxAckPrevOutput.TxAckPrevOutputWrapper.fromObject(object.tx);
        }
        return message;
    };

    TxAckPrevOutput.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.tx = null;
        if (message.tx != null && message.hasOwnProperty("tx"))
            object.tx = $root.TxAckPrevOutput.TxAckPrevOutputWrapper.toObject(message.tx, options);
        return object;
    };

    TxAckPrevOutput.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    TxAckPrevOutput.TxAckPrevOutputWrapper = (function() {

        function TxAckPrevOutputWrapper(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        TxAckPrevOutputWrapper.prototype.output = null;

        TxAckPrevOutputWrapper.create = function create(properties) {
            return new TxAckPrevOutputWrapper(properties);
        };

        TxAckPrevOutputWrapper.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            $root.PrevOutput.encode(message.output, writer.uint32(26).fork()).ldelim();
            return writer;
        };

        TxAckPrevOutputWrapper.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        TxAckPrevOutputWrapper.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TxAckPrevOutput.TxAckPrevOutputWrapper();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 3:
                    message.output = $root.PrevOutput.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("output"))
                throw $util.ProtocolError("missing required 'output'", { instance: message });
            return message;
        };

        TxAckPrevOutputWrapper.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        TxAckPrevOutputWrapper.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            {
                var error = $root.PrevOutput.verify(message.output);
                if (error)
                    return "output." + error;
            }
            return null;
        };

        TxAckPrevOutputWrapper.fromObject = function fromObject(object) {
            if (object instanceof $root.TxAckPrevOutput.TxAckPrevOutputWrapper)
                return object;
            var message = new $root.TxAckPrevOutput.TxAckPrevOutputWrapper();
            if (object.output != null) {
                if (typeof object.output !== "object")
                    throw TypeError(".TxAckPrevOutput.TxAckPrevOutputWrapper.output: object expected");
                message.output = $root.PrevOutput.fromObject(object.output);
            }
            return message;
        };

        TxAckPrevOutputWrapper.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.output = null;
            if (message.output != null && message.hasOwnProperty("output"))
                object.output = $root.PrevOutput.toObject(message.output, options);
            return object;
        };

        TxAckPrevOutputWrapper.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TxAckPrevOutputWrapper;
    })();

    return TxAckPrevOutput;
})();

$root.TxAckPrevExtraData = (function() {

    function TxAckPrevExtraData(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    TxAckPrevExtraData.prototype.tx = null;

    TxAckPrevExtraData.create = function create(properties) {
        return new TxAckPrevExtraData(properties);
    };

    TxAckPrevExtraData.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        $root.TxAckPrevExtraData.TxAckPrevExtraDataWrapper.encode(message.tx, writer.uint32(10).fork()).ldelim();
        return writer;
    };

    TxAckPrevExtraData.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    TxAckPrevExtraData.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TxAckPrevExtraData();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.tx = $root.TxAckPrevExtraData.TxAckPrevExtraDataWrapper.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("tx"))
            throw $util.ProtocolError("missing required 'tx'", { instance: message });
        return message;
    };

    TxAckPrevExtraData.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    TxAckPrevExtraData.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        {
            var error = $root.TxAckPrevExtraData.TxAckPrevExtraDataWrapper.verify(message.tx);
            if (error)
                return "tx." + error;
        }
        return null;
    };

    TxAckPrevExtraData.fromObject = function fromObject(object) {
        if (object instanceof $root.TxAckPrevExtraData)
            return object;
        var message = new $root.TxAckPrevExtraData();
        if (object.tx != null) {
            if (typeof object.tx !== "object")
                throw TypeError(".TxAckPrevExtraData.tx: object expected");
            message.tx = $root.TxAckPrevExtraData.TxAckPrevExtraDataWrapper.fromObject(object.tx);
        }
        return message;
    };

    TxAckPrevExtraData.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.tx = null;
        if (message.tx != null && message.hasOwnProperty("tx"))
            object.tx = $root.TxAckPrevExtraData.TxAckPrevExtraDataWrapper.toObject(message.tx, options);
        return object;
    };

    TxAckPrevExtraData.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    TxAckPrevExtraData.TxAckPrevExtraDataWrapper = (function() {

        function TxAckPrevExtraDataWrapper(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        TxAckPrevExtraDataWrapper.prototype.extra_data_chunk = $util.newBuffer([]);

        TxAckPrevExtraDataWrapper.create = function create(properties) {
            return new TxAckPrevExtraDataWrapper(properties);
        };

        TxAckPrevExtraDataWrapper.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(66).bytes(message.extra_data_chunk);
            return writer;
        };

        TxAckPrevExtraDataWrapper.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        TxAckPrevExtraDataWrapper.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TxAckPrevExtraData.TxAckPrevExtraDataWrapper();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 8:
                    message.extra_data_chunk = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("extra_data_chunk"))
                throw $util.ProtocolError("missing required 'extra_data_chunk'", { instance: message });
            return message;
        };

        TxAckPrevExtraDataWrapper.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        TxAckPrevExtraDataWrapper.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!(message.extra_data_chunk && typeof message.extra_data_chunk.length === "number" || $util.isString(message.extra_data_chunk)))
                return "extra_data_chunk: buffer expected";
            return null;
        };

        TxAckPrevExtraDataWrapper.fromObject = function fromObject(object) {
            if (object instanceof $root.TxAckPrevExtraData.TxAckPrevExtraDataWrapper)
                return object;
            var message = new $root.TxAckPrevExtraData.TxAckPrevExtraDataWrapper();
            if (object.extra_data_chunk != null)
                if (typeof object.extra_data_chunk === "string")
                    $util.base64.decode(object.extra_data_chunk, message.extra_data_chunk = $util.newBuffer($util.base64.length(object.extra_data_chunk)), 0);
                else if (object.extra_data_chunk.length)
                    message.extra_data_chunk = object.extra_data_chunk;
            return message;
        };

        TxAckPrevExtraDataWrapper.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                if (options.bytes === String)
                    object.extra_data_chunk = "";
                else {
                    object.extra_data_chunk = [];
                    if (options.bytes !== Array)
                        object.extra_data_chunk = $util.newBuffer(object.extra_data_chunk);
                }
            if (message.extra_data_chunk != null && message.hasOwnProperty("extra_data_chunk"))
                object.extra_data_chunk = options.bytes === String ? $util.base64.encode(message.extra_data_chunk, 0, message.extra_data_chunk.length) : options.bytes === Array ? Array.prototype.slice.call(message.extra_data_chunk) : message.extra_data_chunk;
            return object;
        };

        TxAckPrevExtraDataWrapper.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TxAckPrevExtraDataWrapper;
    })();

    return TxAckPrevExtraData;
})();

$root.GetOwnershipProof = (function() {

    function GetOwnershipProof(properties) {
        this.address_n = [];
        this.ownership_ids = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    GetOwnershipProof.prototype.address_n = $util.emptyArray;
    GetOwnershipProof.prototype.coin_name = "Bitcoin";
    GetOwnershipProof.prototype.script_type = 3;
    GetOwnershipProof.prototype.multisig = null;
    GetOwnershipProof.prototype.user_confirmation = false;
    GetOwnershipProof.prototype.ownership_ids = $util.emptyArray;
    GetOwnershipProof.prototype.commitment_data = $util.newBuffer([]);

    GetOwnershipProof.create = function create(properties) {
        return new GetOwnershipProof(properties);
    };

    GetOwnershipProof.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.coin_name != null && Object.hasOwnProperty.call(message, "coin_name"))
            writer.uint32(18).string(message.coin_name);
        if (message.script_type != null && Object.hasOwnProperty.call(message, "script_type"))
            writer.uint32(24).int32(message.script_type);
        if (message.multisig != null && Object.hasOwnProperty.call(message, "multisig"))
            $root.MultisigRedeemScriptType.encode(message.multisig, writer.uint32(34).fork()).ldelim();
        if (message.user_confirmation != null && Object.hasOwnProperty.call(message, "user_confirmation"))
            writer.uint32(40).bool(message.user_confirmation);
        if (message.ownership_ids != null && message.ownership_ids.length)
            for (var i = 0; i < message.ownership_ids.length; ++i)
                writer.uint32(50).bytes(message.ownership_ids[i]);
        if (message.commitment_data != null && Object.hasOwnProperty.call(message, "commitment_data"))
            writer.uint32(58).bytes(message.commitment_data);
        return writer;
    };

    GetOwnershipProof.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    GetOwnershipProof.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.GetOwnershipProof();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.coin_name = reader.string();
                break;
            case 3:
                message.script_type = reader.int32();
                break;
            case 4:
                message.multisig = $root.MultisigRedeemScriptType.decode(reader, reader.uint32());
                break;
            case 5:
                message.user_confirmation = reader.bool();
                break;
            case 6:
                if (!(message.ownership_ids && message.ownership_ids.length))
                    message.ownership_ids = [];
                message.ownership_ids.push(reader.bytes());
                break;
            case 7:
                message.commitment_data = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    GetOwnershipProof.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    GetOwnershipProof.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.coin_name != null && message.hasOwnProperty("coin_name"))
            if (!$util.isString(message.coin_name))
                return "coin_name: string expected";
        if (message.script_type != null && message.hasOwnProperty("script_type"))
            switch (message.script_type) {
            default:
                return "script_type: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
                break;
            }
        if (message.multisig != null && message.hasOwnProperty("multisig")) {
            var error = $root.MultisigRedeemScriptType.verify(message.multisig);
            if (error)
                return "multisig." + error;
        }
        if (message.user_confirmation != null && message.hasOwnProperty("user_confirmation"))
            if (typeof message.user_confirmation !== "boolean")
                return "user_confirmation: boolean expected";
        if (message.ownership_ids != null && message.hasOwnProperty("ownership_ids")) {
            if (!Array.isArray(message.ownership_ids))
                return "ownership_ids: array expected";
            for (var i = 0; i < message.ownership_ids.length; ++i)
                if (!(message.ownership_ids[i] && typeof message.ownership_ids[i].length === "number" || $util.isString(message.ownership_ids[i])))
                    return "ownership_ids: buffer[] expected";
        }
        if (message.commitment_data != null && message.hasOwnProperty("commitment_data"))
            if (!(message.commitment_data && typeof message.commitment_data.length === "number" || $util.isString(message.commitment_data)))
                return "commitment_data: buffer expected";
        return null;
    };

    GetOwnershipProof.fromObject = function fromObject(object) {
        if (object instanceof $root.GetOwnershipProof)
            return object;
        var message = new $root.GetOwnershipProof();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".GetOwnershipProof.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.coin_name != null)
            message.coin_name = String(object.coin_name);
        switch (object.script_type) {
        case "SPENDADDRESS":
        case 0:
            message.script_type = 0;
            break;
        case "SPENDMULTISIG":
        case 1:
            message.script_type = 1;
            break;
        case "EXTERNAL":
        case 2:
            message.script_type = 2;
            break;
        case "SPENDWITNESS":
        case 3:
            message.script_type = 3;
            break;
        case "SPENDP2SHWITNESS":
        case 4:
            message.script_type = 4;
            break;
        case "SPENDTAPROOT":
        case 5:
            message.script_type = 5;
            break;
        }
        if (object.multisig != null) {
            if (typeof object.multisig !== "object")
                throw TypeError(".GetOwnershipProof.multisig: object expected");
            message.multisig = $root.MultisigRedeemScriptType.fromObject(object.multisig);
        }
        if (object.user_confirmation != null)
            message.user_confirmation = Boolean(object.user_confirmation);
        if (object.ownership_ids) {
            if (!Array.isArray(object.ownership_ids))
                throw TypeError(".GetOwnershipProof.ownership_ids: array expected");
            message.ownership_ids = [];
            for (var i = 0; i < object.ownership_ids.length; ++i)
                if (typeof object.ownership_ids[i] === "string")
                    $util.base64.decode(object.ownership_ids[i], message.ownership_ids[i] = $util.newBuffer($util.base64.length(object.ownership_ids[i])), 0);
                else if (object.ownership_ids[i].length)
                    message.ownership_ids[i] = object.ownership_ids[i];
        }
        if (object.commitment_data != null)
            if (typeof object.commitment_data === "string")
                $util.base64.decode(object.commitment_data, message.commitment_data = $util.newBuffer($util.base64.length(object.commitment_data)), 0);
            else if (object.commitment_data.length)
                message.commitment_data = object.commitment_data;
        return message;
    };

    GetOwnershipProof.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults) {
            object.address_n = [];
            object.ownership_ids = [];
        }
        if (options.defaults) {
            object.coin_name = "Bitcoin";
            object.script_type = options.enums === String ? "SPENDWITNESS" : 3;
            object.multisig = null;
            object.user_confirmation = false;
            if (options.bytes === String)
                object.commitment_data = "";
            else {
                object.commitment_data = [];
                if (options.bytes !== Array)
                    object.commitment_data = $util.newBuffer(object.commitment_data);
            }
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.coin_name != null && message.hasOwnProperty("coin_name"))
            object.coin_name = message.coin_name;
        if (message.script_type != null && message.hasOwnProperty("script_type"))
            object.script_type = options.enums === String ? $root.InputScriptType[message.script_type] : message.script_type;
        if (message.multisig != null && message.hasOwnProperty("multisig"))
            object.multisig = $root.MultisigRedeemScriptType.toObject(message.multisig, options);
        if (message.user_confirmation != null && message.hasOwnProperty("user_confirmation"))
            object.user_confirmation = message.user_confirmation;
        if (message.ownership_ids && message.ownership_ids.length) {
            object.ownership_ids = [];
            for (var j = 0; j < message.ownership_ids.length; ++j)
                object.ownership_ids[j] = options.bytes === String ? $util.base64.encode(message.ownership_ids[j], 0, message.ownership_ids[j].length) : options.bytes === Array ? Array.prototype.slice.call(message.ownership_ids[j]) : message.ownership_ids[j];
        }
        if (message.commitment_data != null && message.hasOwnProperty("commitment_data"))
            object.commitment_data = options.bytes === String ? $util.base64.encode(message.commitment_data, 0, message.commitment_data.length) : options.bytes === Array ? Array.prototype.slice.call(message.commitment_data) : message.commitment_data;
        return object;
    };

    GetOwnershipProof.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return GetOwnershipProof;
})();

$root.OwnershipProof = (function() {

    function OwnershipProof(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    OwnershipProof.prototype.ownership_proof = $util.newBuffer([]);
    OwnershipProof.prototype.signature = $util.newBuffer([]);

    OwnershipProof.create = function create(properties) {
        return new OwnershipProof(properties);
    };

    OwnershipProof.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.ownership_proof);
        writer.uint32(18).bytes(message.signature);
        return writer;
    };

    OwnershipProof.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    OwnershipProof.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.OwnershipProof();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.ownership_proof = reader.bytes();
                break;
            case 2:
                message.signature = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("ownership_proof"))
            throw $util.ProtocolError("missing required 'ownership_proof'", { instance: message });
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        return message;
    };

    OwnershipProof.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    OwnershipProof.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.ownership_proof && typeof message.ownership_proof.length === "number" || $util.isString(message.ownership_proof)))
            return "ownership_proof: buffer expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        return null;
    };

    OwnershipProof.fromObject = function fromObject(object) {
        if (object instanceof $root.OwnershipProof)
            return object;
        var message = new $root.OwnershipProof();
        if (object.ownership_proof != null)
            if (typeof object.ownership_proof === "string")
                $util.base64.decode(object.ownership_proof, message.ownership_proof = $util.newBuffer($util.base64.length(object.ownership_proof)), 0);
            else if (object.ownership_proof.length)
                message.ownership_proof = object.ownership_proof;
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        return message;
    };

    OwnershipProof.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.ownership_proof = "";
            else {
                object.ownership_proof = [];
                if (options.bytes !== Array)
                    object.ownership_proof = $util.newBuffer(object.ownership_proof);
            }
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
        }
        if (message.ownership_proof != null && message.hasOwnProperty("ownership_proof"))
            object.ownership_proof = options.bytes === String ? $util.base64.encode(message.ownership_proof, 0, message.ownership_proof.length) : options.bytes === Array ? Array.prototype.slice.call(message.ownership_proof) : message.ownership_proof;
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        return object;
    };

    OwnershipProof.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return OwnershipProof;
})();

$root.AuthorizeCoinJoin = (function() {

    function AuthorizeCoinJoin(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    AuthorizeCoinJoin.prototype.coordinator = "";
    AuthorizeCoinJoin.prototype.max_rounds = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    AuthorizeCoinJoin.prototype.max_coordinator_fee_rate = 0;
    AuthorizeCoinJoin.prototype.max_fee_per_kvbyte = 0;
    AuthorizeCoinJoin.prototype.address_n = $util.emptyArray;
    AuthorizeCoinJoin.prototype.coin_name = "Bitcoin";
    AuthorizeCoinJoin.prototype.script_type = 0;
    AuthorizeCoinJoin.prototype.amount_unit = 0;

    AuthorizeCoinJoin.create = function create(properties) {
        return new AuthorizeCoinJoin(properties);
    };

    AuthorizeCoinJoin.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.coordinator);
        writer.uint32(16).uint64(message.max_rounds);
        writer.uint32(24).uint32(message.max_coordinator_fee_rate);
        writer.uint32(32).uint32(message.max_fee_per_kvbyte);
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(40).uint32(message.address_n[i]);
        if (message.coin_name != null && Object.hasOwnProperty.call(message, "coin_name"))
            writer.uint32(50).string(message.coin_name);
        if (message.script_type != null && Object.hasOwnProperty.call(message, "script_type"))
            writer.uint32(56).int32(message.script_type);
        if (message.amount_unit != null && Object.hasOwnProperty.call(message, "amount_unit"))
            writer.uint32(64).int32(message.amount_unit);
        return writer;
    };

    AuthorizeCoinJoin.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    AuthorizeCoinJoin.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.AuthorizeCoinJoin();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.coordinator = reader.string();
                break;
            case 2:
                message.max_rounds = reader.uint64();
                break;
            case 3:
                message.max_coordinator_fee_rate = reader.uint32();
                break;
            case 4:
                message.max_fee_per_kvbyte = reader.uint32();
                break;
            case 5:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 6:
                message.coin_name = reader.string();
                break;
            case 7:
                message.script_type = reader.int32();
                break;
            case 8:
                message.amount_unit = reader.int32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("coordinator"))
            throw $util.ProtocolError("missing required 'coordinator'", { instance: message });
        if (!message.hasOwnProperty("max_rounds"))
            throw $util.ProtocolError("missing required 'max_rounds'", { instance: message });
        if (!message.hasOwnProperty("max_coordinator_fee_rate"))
            throw $util.ProtocolError("missing required 'max_coordinator_fee_rate'", { instance: message });
        if (!message.hasOwnProperty("max_fee_per_kvbyte"))
            throw $util.ProtocolError("missing required 'max_fee_per_kvbyte'", { instance: message });
        return message;
    };

    AuthorizeCoinJoin.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    AuthorizeCoinJoin.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.coordinator))
            return "coordinator: string expected";
        if (!$util.isInteger(message.max_rounds) && !(message.max_rounds && $util.isInteger(message.max_rounds.low) && $util.isInteger(message.max_rounds.high)))
            return "max_rounds: integer|Long expected";
        if (!$util.isInteger(message.max_coordinator_fee_rate))
            return "max_coordinator_fee_rate: integer expected";
        if (!$util.isInteger(message.max_fee_per_kvbyte))
            return "max_fee_per_kvbyte: integer expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.coin_name != null && message.hasOwnProperty("coin_name"))
            if (!$util.isString(message.coin_name))
                return "coin_name: string expected";
        if (message.script_type != null && message.hasOwnProperty("script_type"))
            switch (message.script_type) {
            default:
                return "script_type: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
                break;
            }
        if (message.amount_unit != null && message.hasOwnProperty("amount_unit"))
            switch (message.amount_unit) {
            default:
                return "amount_unit: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
                break;
            }
        return null;
    };

    AuthorizeCoinJoin.fromObject = function fromObject(object) {
        if (object instanceof $root.AuthorizeCoinJoin)
            return object;
        var message = new $root.AuthorizeCoinJoin();
        if (object.coordinator != null)
            message.coordinator = String(object.coordinator);
        if (object.max_rounds != null)
            if ($util.Long)
                (message.max_rounds = $util.Long.fromValue(object.max_rounds)).unsigned = true;
            else if (typeof object.max_rounds === "string")
                message.max_rounds = parseInt(object.max_rounds, 10);
            else if (typeof object.max_rounds === "number")
                message.max_rounds = object.max_rounds;
            else if (typeof object.max_rounds === "object")
                message.max_rounds = new $util.LongBits(object.max_rounds.low >>> 0, object.max_rounds.high >>> 0).toNumber(true);
        if (object.max_coordinator_fee_rate != null)
            message.max_coordinator_fee_rate = object.max_coordinator_fee_rate >>> 0;
        if (object.max_fee_per_kvbyte != null)
            message.max_fee_per_kvbyte = object.max_fee_per_kvbyte >>> 0;
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".AuthorizeCoinJoin.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.coin_name != null)
            message.coin_name = String(object.coin_name);
        switch (object.script_type) {
        case "SPENDADDRESS":
        case 0:
            message.script_type = 0;
            break;
        case "SPENDMULTISIG":
        case 1:
            message.script_type = 1;
            break;
        case "EXTERNAL":
        case 2:
            message.script_type = 2;
            break;
        case "SPENDWITNESS":
        case 3:
            message.script_type = 3;
            break;
        case "SPENDP2SHWITNESS":
        case 4:
            message.script_type = 4;
            break;
        case "SPENDTAPROOT":
        case 5:
            message.script_type = 5;
            break;
        }
        switch (object.amount_unit) {
        case "BITCOIN":
        case 0:
            message.amount_unit = 0;
            break;
        case "MILLIBITCOIN":
        case 1:
            message.amount_unit = 1;
            break;
        case "MICROBITCOIN":
        case 2:
            message.amount_unit = 2;
            break;
        case "SATOSHI":
        case 3:
            message.amount_unit = 3;
            break;
        }
        return message;
    };

    AuthorizeCoinJoin.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            object.coordinator = "";
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.max_rounds = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.max_rounds = options.longs === String ? "0" : 0;
            object.max_coordinator_fee_rate = 0;
            object.max_fee_per_kvbyte = 0;
            object.coin_name = "Bitcoin";
            object.script_type = options.enums === String ? "SPENDADDRESS" : 0;
            object.amount_unit = options.enums === String ? "BITCOIN" : 0;
        }
        if (message.coordinator != null && message.hasOwnProperty("coordinator"))
            object.coordinator = message.coordinator;
        if (message.max_rounds != null && message.hasOwnProperty("max_rounds"))
            if (typeof message.max_rounds === "number")
                object.max_rounds = options.longs === String ? String(message.max_rounds) : message.max_rounds;
            else
                object.max_rounds = options.longs === String ? $util.Long.prototype.toString.call(message.max_rounds) : options.longs === Number ? new $util.LongBits(message.max_rounds.low >>> 0, message.max_rounds.high >>> 0).toNumber(true) : message.max_rounds;
        if (message.max_coordinator_fee_rate != null && message.hasOwnProperty("max_coordinator_fee_rate"))
            object.max_coordinator_fee_rate = message.max_coordinator_fee_rate;
        if (message.max_fee_per_kvbyte != null && message.hasOwnProperty("max_fee_per_kvbyte"))
            object.max_fee_per_kvbyte = message.max_fee_per_kvbyte;
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.coin_name != null && message.hasOwnProperty("coin_name"))
            object.coin_name = message.coin_name;
        if (message.script_type != null && message.hasOwnProperty("script_type"))
            object.script_type = options.enums === String ? $root.InputScriptType[message.script_type] : message.script_type;
        if (message.amount_unit != null && message.hasOwnProperty("amount_unit"))
            object.amount_unit = options.enums === String ? $root.AmountUnit[message.amount_unit] : message.amount_unit;
        return object;
    };

    AuthorizeCoinJoin.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return AuthorizeCoinJoin;
})();

$root.SignPsbt = (function() {

    function SignPsbt(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    SignPsbt.prototype.psbt = $util.newBuffer([]);
    SignPsbt.prototype.coin_name = "Bitcoin";

    SignPsbt.create = function create(properties) {
        return new SignPsbt(properties);
    };

    SignPsbt.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.psbt);
        if (message.coin_name != null && Object.hasOwnProperty.call(message, "coin_name"))
            writer.uint32(18).string(message.coin_name);
        return writer;
    };

    SignPsbt.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    SignPsbt.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SignPsbt();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.psbt = reader.bytes();
                break;
            case 2:
                message.coin_name = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("psbt"))
            throw $util.ProtocolError("missing required 'psbt'", { instance: message });
        return message;
    };

    SignPsbt.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    SignPsbt.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.psbt && typeof message.psbt.length === "number" || $util.isString(message.psbt)))
            return "psbt: buffer expected";
        if (message.coin_name != null && message.hasOwnProperty("coin_name"))
            if (!$util.isString(message.coin_name))
                return "coin_name: string expected";
        return null;
    };

    SignPsbt.fromObject = function fromObject(object) {
        if (object instanceof $root.SignPsbt)
            return object;
        var message = new $root.SignPsbt();
        if (object.psbt != null)
            if (typeof object.psbt === "string")
                $util.base64.decode(object.psbt, message.psbt = $util.newBuffer($util.base64.length(object.psbt)), 0);
            else if (object.psbt.length)
                message.psbt = object.psbt;
        if (object.coin_name != null)
            message.coin_name = String(object.coin_name);
        return message;
    };

    SignPsbt.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.psbt = "";
            else {
                object.psbt = [];
                if (options.bytes !== Array)
                    object.psbt = $util.newBuffer(object.psbt);
            }
            object.coin_name = "Bitcoin";
        }
        if (message.psbt != null && message.hasOwnProperty("psbt"))
            object.psbt = options.bytes === String ? $util.base64.encode(message.psbt, 0, message.psbt.length) : options.bytes === Array ? Array.prototype.slice.call(message.psbt) : message.psbt;
        if (message.coin_name != null && message.hasOwnProperty("coin_name"))
            object.coin_name = message.coin_name;
        return object;
    };

    SignPsbt.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SignPsbt;
})();

$root.SignedPsbt = (function() {

    function SignedPsbt(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    SignedPsbt.prototype.psbt = $util.newBuffer([]);

    SignedPsbt.create = function create(properties) {
        return new SignedPsbt(properties);
    };

    SignedPsbt.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.psbt);
        return writer;
    };

    SignedPsbt.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    SignedPsbt.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SignedPsbt();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.psbt = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("psbt"))
            throw $util.ProtocolError("missing required 'psbt'", { instance: message });
        return message;
    };

    SignedPsbt.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    SignedPsbt.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.psbt && typeof message.psbt.length === "number" || $util.isString(message.psbt)))
            return "psbt: buffer expected";
        return null;
    };

    SignedPsbt.fromObject = function fromObject(object) {
        if (object instanceof $root.SignedPsbt)
            return object;
        var message = new $root.SignedPsbt();
        if (object.psbt != null)
            if (typeof object.psbt === "string")
                $util.base64.decode(object.psbt, message.psbt = $util.newBuffer($util.base64.length(object.psbt)), 0);
            else if (object.psbt.length)
                message.psbt = object.psbt;
        return message;
    };

    SignedPsbt.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.psbt = "";
            else {
                object.psbt = [];
                if (options.bytes !== Array)
                    object.psbt = $util.newBuffer(object.psbt);
            }
        if (message.psbt != null && message.hasOwnProperty("psbt"))
            object.psbt = options.bytes === String ? $util.base64.encode(message.psbt, 0, message.psbt.length) : options.bytes === Array ? Array.prototype.slice.call(message.psbt) : message.psbt;
        return object;
    };

    SignedPsbt.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SignedPsbt;
})();

$root.ButtonRequest = (function() {

    function ButtonRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ButtonRequest.prototype.code = 1;
    ButtonRequest.prototype.pages = 0;

    ButtonRequest.create = function create(properties) {
        return new ButtonRequest(properties);
    };

    ButtonRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.code != null && Object.hasOwnProperty.call(message, "code"))
            writer.uint32(8).int32(message.code);
        if (message.pages != null && Object.hasOwnProperty.call(message, "pages"))
            writer.uint32(16).uint32(message.pages);
        return writer;
    };

    ButtonRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ButtonRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ButtonRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.code = reader.int32();
                break;
            case 2:
                message.pages = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    ButtonRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ButtonRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.code != null && message.hasOwnProperty("code"))
            switch (message.code) {
            default:
                return "code: enum value expected";
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
            case 8:
            case 9:
            case 10:
            case 11:
            case 12:
            case 13:
            case 14:
            case 15:
            case 16:
            case 17:
            case 18:
            case 19:
            case 20:
            case 8000:
                break;
            }
        if (message.pages != null && message.hasOwnProperty("pages"))
            if (!$util.isInteger(message.pages))
                return "pages: integer expected";
        return null;
    };

    ButtonRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.ButtonRequest)
            return object;
        var message = new $root.ButtonRequest();
        switch (object.code) {
        case "ButtonRequest_Other":
        case 1:
            message.code = 1;
            break;
        case "ButtonRequest_FeeOverThreshold":
        case 2:
            message.code = 2;
            break;
        case "ButtonRequest_ConfirmOutput":
        case 3:
            message.code = 3;
            break;
        case "ButtonRequest_ResetDevice":
        case 4:
            message.code = 4;
            break;
        case "ButtonRequest_ConfirmWord":
        case 5:
            message.code = 5;
            break;
        case "ButtonRequest_WipeDevice":
        case 6:
            message.code = 6;
            break;
        case "ButtonRequest_ProtectCall":
        case 7:
            message.code = 7;
            break;
        case "ButtonRequest_SignTx":
        case 8:
            message.code = 8;
            break;
        case "ButtonRequest_FirmwareCheck":
        case 9:
            message.code = 9;
            break;
        case "ButtonRequest_Address":
        case 10:
            message.code = 10;
            break;
        case "ButtonRequest_PublicKey":
        case 11:
            message.code = 11;
            break;
        case "ButtonRequest_MnemonicWordCount":
        case 12:
            message.code = 12;
            break;
        case "ButtonRequest_MnemonicInput":
        case 13:
            message.code = 13;
            break;
        case "_Deprecated_ButtonRequest_PassphraseType":
        case 14:
            message.code = 14;
            break;
        case "ButtonRequest_UnknownDerivationPath":
        case 15:
            message.code = 15;
            break;
        case "ButtonRequest_RecoveryHomepage":
        case 16:
            message.code = 16;
            break;
        case "ButtonRequest_Success":
        case 17:
            message.code = 17;
            break;
        case "ButtonRequest_Warning":
        case 18:
            message.code = 18;
            break;
        case "ButtonRequest_PassphraseEntry":
        case 19:
            message.code = 19;
            break;
        case "ButtonRequest_PinEntry":
        case 20:
            message.code = 20;
            break;
        case "ButtonRequest_AttachPin":
        case 8000:
            message.code = 8000;
            break;
        }
        if (object.pages != null)
            message.pages = object.pages >>> 0;
        return message;
    };

    ButtonRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.code = options.enums === String ? "ButtonRequest_Other" : 1;
            object.pages = 0;
        }
        if (message.code != null && message.hasOwnProperty("code"))
            object.code = options.enums === String ? $root.ButtonRequest.ButtonRequestType[message.code] : message.code;
        if (message.pages != null && message.hasOwnProperty("pages"))
            object.pages = message.pages;
        return object;
    };

    ButtonRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    ButtonRequest.ButtonRequestType = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[1] = "ButtonRequest_Other"] = 1;
        values[valuesById[2] = "ButtonRequest_FeeOverThreshold"] = 2;
        values[valuesById[3] = "ButtonRequest_ConfirmOutput"] = 3;
        values[valuesById[4] = "ButtonRequest_ResetDevice"] = 4;
        values[valuesById[5] = "ButtonRequest_ConfirmWord"] = 5;
        values[valuesById[6] = "ButtonRequest_WipeDevice"] = 6;
        values[valuesById[7] = "ButtonRequest_ProtectCall"] = 7;
        values[valuesById[8] = "ButtonRequest_SignTx"] = 8;
        values[valuesById[9] = "ButtonRequest_FirmwareCheck"] = 9;
        values[valuesById[10] = "ButtonRequest_Address"] = 10;
        values[valuesById[11] = "ButtonRequest_PublicKey"] = 11;
        values[valuesById[12] = "ButtonRequest_MnemonicWordCount"] = 12;
        values[valuesById[13] = "ButtonRequest_MnemonicInput"] = 13;
        values[valuesById[14] = "_Deprecated_ButtonRequest_PassphraseType"] = 14;
        values[valuesById[15] = "ButtonRequest_UnknownDerivationPath"] = 15;
        values[valuesById[16] = "ButtonRequest_RecoveryHomepage"] = 16;
        values[valuesById[17] = "ButtonRequest_Success"] = 17;
        values[valuesById[18] = "ButtonRequest_Warning"] = 18;
        values[valuesById[19] = "ButtonRequest_PassphraseEntry"] = 19;
        values[valuesById[20] = "ButtonRequest_PinEntry"] = 20;
        values[valuesById[8000] = "ButtonRequest_AttachPin"] = 8000;
        return values;
    })();

    return ButtonRequest;
})();

$root.ButtonAck = (function() {

    function ButtonAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ButtonAck.create = function create(properties) {
        return new ButtonAck(properties);
    };

    ButtonAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    ButtonAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ButtonAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ButtonAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    ButtonAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ButtonAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    ButtonAck.fromObject = function fromObject(object) {
        if (object instanceof $root.ButtonAck)
            return object;
        return new $root.ButtonAck();
    };

    ButtonAck.toObject = function toObject() {
        return {};
    };

    ButtonAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ButtonAck;
})();

$root.CardanoDerivationType = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "LEDGER"] = 0;
    values[valuesById[1] = "ICARUS"] = 1;
    values[valuesById[2] = "ICARUS_TREZOR"] = 2;
    return values;
})();

$root.CardanoAddressType = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "BASE"] = 0;
    values[valuesById[1] = "BASE_SCRIPT_KEY"] = 1;
    values[valuesById[2] = "BASE_KEY_SCRIPT"] = 2;
    values[valuesById[3] = "BASE_SCRIPT_SCRIPT"] = 3;
    values[valuesById[4] = "POINTER"] = 4;
    values[valuesById[5] = "POINTER_SCRIPT"] = 5;
    values[valuesById[6] = "ENTERPRISE"] = 6;
    values[valuesById[7] = "ENTERPRISE_SCRIPT"] = 7;
    values[valuesById[8] = "BYRON"] = 8;
    values[valuesById[14] = "REWARD"] = 14;
    values[valuesById[15] = "REWARD_SCRIPT"] = 15;
    return values;
})();

$root.CardanoNativeScriptType = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "PUB_KEY"] = 0;
    values[valuesById[1] = "ALL"] = 1;
    values[valuesById[2] = "ANY"] = 2;
    values[valuesById[3] = "N_OF_K"] = 3;
    values[valuesById[4] = "INVALID_BEFORE"] = 4;
    values[valuesById[5] = "INVALID_HEREAFTER"] = 5;
    return values;
})();

$root.CardanoNativeScriptHashDisplayFormat = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "HIDE"] = 0;
    values[valuesById[1] = "BECH32"] = 1;
    values[valuesById[2] = "POLICY_ID"] = 2;
    return values;
})();

$root.CardanoTxOutputSerializationFormat = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "ARRAY_LEGACY"] = 0;
    values[valuesById[1] = "MAP_BABBAGE"] = 1;
    return values;
})();

$root.CardanoCertificateType = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "STAKE_REGISTRATION"] = 0;
    values[valuesById[1] = "STAKE_DEREGISTRATION"] = 1;
    values[valuesById[2] = "STAKE_DELEGATION"] = 2;
    values[valuesById[3] = "STAKE_POOL_REGISTRATION"] = 3;
    values[valuesById[7] = "STAKE_REGISTRATION_CONWAY"] = 7;
    values[valuesById[8] = "STAKE_DEREGISTRATION_CONWAY"] = 8;
    values[valuesById[9] = "VOTE_DELEGATION"] = 9;
    return values;
})();

$root.CardanoDRepType = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "KEY_HASH"] = 0;
    values[valuesById[1] = "SCRIPT_HASH"] = 1;
    values[valuesById[2] = "ABSTAIN"] = 2;
    values[valuesById[3] = "NO_CONFIDENCE"] = 3;
    return values;
})();

$root.CardanoPoolRelayType = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "SINGLE_HOST_IP"] = 0;
    values[valuesById[1] = "SINGLE_HOST_NAME"] = 1;
    values[valuesById[2] = "MULTIPLE_HOST_NAME"] = 2;
    return values;
})();

$root.CardanoTxAuxiliaryDataSupplementType = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "NONE"] = 0;
    values[valuesById[1] = "CVOTE_REGISTRATION_SIGNATURE"] = 1;
    return values;
})();

$root.CardanoCVoteRegistrationFormat = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "CIP15"] = 0;
    values[valuesById[1] = "CIP36"] = 1;
    return values;
})();

$root.CardanoTxSigningMode = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "ORDINARY_TRANSACTION"] = 0;
    values[valuesById[1] = "POOL_REGISTRATION_AS_OWNER"] = 1;
    values[valuesById[2] = "MULTISIG_TRANSACTION"] = 2;
    values[valuesById[3] = "PLUTUS_TRANSACTION"] = 3;
    return values;
})();

$root.CardanoTxWitnessType = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "BYRON_WITNESS"] = 0;
    values[valuesById[1] = "SHELLEY_WITNESS"] = 1;
    return values;
})();

$root.CardanoBlockchainPointerType = (function() {

    function CardanoBlockchainPointerType(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoBlockchainPointerType.prototype.block_index = 0;
    CardanoBlockchainPointerType.prototype.tx_index = 0;
    CardanoBlockchainPointerType.prototype.certificate_index = 0;

    CardanoBlockchainPointerType.create = function create(properties) {
        return new CardanoBlockchainPointerType(properties);
    };

    CardanoBlockchainPointerType.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).uint32(message.block_index);
        writer.uint32(16).uint32(message.tx_index);
        writer.uint32(24).uint32(message.certificate_index);
        return writer;
    };

    CardanoBlockchainPointerType.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoBlockchainPointerType.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoBlockchainPointerType();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.block_index = reader.uint32();
                break;
            case 2:
                message.tx_index = reader.uint32();
                break;
            case 3:
                message.certificate_index = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("block_index"))
            throw $util.ProtocolError("missing required 'block_index'", { instance: message });
        if (!message.hasOwnProperty("tx_index"))
            throw $util.ProtocolError("missing required 'tx_index'", { instance: message });
        if (!message.hasOwnProperty("certificate_index"))
            throw $util.ProtocolError("missing required 'certificate_index'", { instance: message });
        return message;
    };

    CardanoBlockchainPointerType.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoBlockchainPointerType.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isInteger(message.block_index))
            return "block_index: integer expected";
        if (!$util.isInteger(message.tx_index))
            return "tx_index: integer expected";
        if (!$util.isInteger(message.certificate_index))
            return "certificate_index: integer expected";
        return null;
    };

    CardanoBlockchainPointerType.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoBlockchainPointerType)
            return object;
        var message = new $root.CardanoBlockchainPointerType();
        if (object.block_index != null)
            message.block_index = object.block_index >>> 0;
        if (object.tx_index != null)
            message.tx_index = object.tx_index >>> 0;
        if (object.certificate_index != null)
            message.certificate_index = object.certificate_index >>> 0;
        return message;
    };

    CardanoBlockchainPointerType.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.block_index = 0;
            object.tx_index = 0;
            object.certificate_index = 0;
        }
        if (message.block_index != null && message.hasOwnProperty("block_index"))
            object.block_index = message.block_index;
        if (message.tx_index != null && message.hasOwnProperty("tx_index"))
            object.tx_index = message.tx_index;
        if (message.certificate_index != null && message.hasOwnProperty("certificate_index"))
            object.certificate_index = message.certificate_index;
        return object;
    };

    CardanoBlockchainPointerType.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoBlockchainPointerType;
})();

$root.CardanoNativeScript = (function() {

    function CardanoNativeScript(properties) {
        this.scripts = [];
        this.key_path = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoNativeScript.prototype.type = 0;
    CardanoNativeScript.prototype.scripts = $util.emptyArray;
    CardanoNativeScript.prototype.key_hash = $util.newBuffer([]);
    CardanoNativeScript.prototype.key_path = $util.emptyArray;
    CardanoNativeScript.prototype.required_signatures_count = 0;
    CardanoNativeScript.prototype.invalid_before = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    CardanoNativeScript.prototype.invalid_hereafter = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    CardanoNativeScript.create = function create(properties) {
        return new CardanoNativeScript(properties);
    };

    CardanoNativeScript.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).int32(message.type);
        if (message.scripts != null && message.scripts.length)
            for (var i = 0; i < message.scripts.length; ++i)
                $root.CardanoNativeScript.encode(message.scripts[i], writer.uint32(18).fork()).ldelim();
        if (message.key_hash != null && Object.hasOwnProperty.call(message, "key_hash"))
            writer.uint32(26).bytes(message.key_hash);
        if (message.key_path != null && message.key_path.length)
            for (var i = 0; i < message.key_path.length; ++i)
                writer.uint32(32).uint32(message.key_path[i]);
        if (message.required_signatures_count != null && Object.hasOwnProperty.call(message, "required_signatures_count"))
            writer.uint32(40).uint32(message.required_signatures_count);
        if (message.invalid_before != null && Object.hasOwnProperty.call(message, "invalid_before"))
            writer.uint32(48).uint64(message.invalid_before);
        if (message.invalid_hereafter != null && Object.hasOwnProperty.call(message, "invalid_hereafter"))
            writer.uint32(56).uint64(message.invalid_hereafter);
        return writer;
    };

    CardanoNativeScript.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoNativeScript.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoNativeScript();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.type = reader.int32();
                break;
            case 2:
                if (!(message.scripts && message.scripts.length))
                    message.scripts = [];
                message.scripts.push($root.CardanoNativeScript.decode(reader, reader.uint32()));
                break;
            case 3:
                message.key_hash = reader.bytes();
                break;
            case 4:
                if (!(message.key_path && message.key_path.length))
                    message.key_path = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.key_path.push(reader.uint32());
                } else
                    message.key_path.push(reader.uint32());
                break;
            case 5:
                message.required_signatures_count = reader.uint32();
                break;
            case 6:
                message.invalid_before = reader.uint64();
                break;
            case 7:
                message.invalid_hereafter = reader.uint64();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("type"))
            throw $util.ProtocolError("missing required 'type'", { instance: message });
        return message;
    };

    CardanoNativeScript.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoNativeScript.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        switch (message.type) {
        default:
            return "type: enum value expected";
        case 0:
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        }
        if (message.scripts != null && message.hasOwnProperty("scripts")) {
            if (!Array.isArray(message.scripts))
                return "scripts: array expected";
            for (var i = 0; i < message.scripts.length; ++i) {
                var error = $root.CardanoNativeScript.verify(message.scripts[i]);
                if (error)
                    return "scripts." + error;
            }
        }
        if (message.key_hash != null && message.hasOwnProperty("key_hash"))
            if (!(message.key_hash && typeof message.key_hash.length === "number" || $util.isString(message.key_hash)))
                return "key_hash: buffer expected";
        if (message.key_path != null && message.hasOwnProperty("key_path")) {
            if (!Array.isArray(message.key_path))
                return "key_path: array expected";
            for (var i = 0; i < message.key_path.length; ++i)
                if (!$util.isInteger(message.key_path[i]))
                    return "key_path: integer[] expected";
        }
        if (message.required_signatures_count != null && message.hasOwnProperty("required_signatures_count"))
            if (!$util.isInteger(message.required_signatures_count))
                return "required_signatures_count: integer expected";
        if (message.invalid_before != null && message.hasOwnProperty("invalid_before"))
            if (!$util.isInteger(message.invalid_before) && !(message.invalid_before && $util.isInteger(message.invalid_before.low) && $util.isInteger(message.invalid_before.high)))
                return "invalid_before: integer|Long expected";
        if (message.invalid_hereafter != null && message.hasOwnProperty("invalid_hereafter"))
            if (!$util.isInteger(message.invalid_hereafter) && !(message.invalid_hereafter && $util.isInteger(message.invalid_hereafter.low) && $util.isInteger(message.invalid_hereafter.high)))
                return "invalid_hereafter: integer|Long expected";
        return null;
    };

    CardanoNativeScript.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoNativeScript)
            return object;
        var message = new $root.CardanoNativeScript();
        switch (object.type) {
        case "PUB_KEY":
        case 0:
            message.type = 0;
            break;
        case "ALL":
        case 1:
            message.type = 1;
            break;
        case "ANY":
        case 2:
            message.type = 2;
            break;
        case "N_OF_K":
        case 3:
            message.type = 3;
            break;
        case "INVALID_BEFORE":
        case 4:
            message.type = 4;
            break;
        case "INVALID_HEREAFTER":
        case 5:
            message.type = 5;
            break;
        }
        if (object.scripts) {
            if (!Array.isArray(object.scripts))
                throw TypeError(".CardanoNativeScript.scripts: array expected");
            message.scripts = [];
            for (var i = 0; i < object.scripts.length; ++i) {
                if (typeof object.scripts[i] !== "object")
                    throw TypeError(".CardanoNativeScript.scripts: object expected");
                message.scripts[i] = $root.CardanoNativeScript.fromObject(object.scripts[i]);
            }
        }
        if (object.key_hash != null)
            if (typeof object.key_hash === "string")
                $util.base64.decode(object.key_hash, message.key_hash = $util.newBuffer($util.base64.length(object.key_hash)), 0);
            else if (object.key_hash.length)
                message.key_hash = object.key_hash;
        if (object.key_path) {
            if (!Array.isArray(object.key_path))
                throw TypeError(".CardanoNativeScript.key_path: array expected");
            message.key_path = [];
            for (var i = 0; i < object.key_path.length; ++i)
                message.key_path[i] = object.key_path[i] >>> 0;
        }
        if (object.required_signatures_count != null)
            message.required_signatures_count = object.required_signatures_count >>> 0;
        if (object.invalid_before != null)
            if ($util.Long)
                (message.invalid_before = $util.Long.fromValue(object.invalid_before)).unsigned = true;
            else if (typeof object.invalid_before === "string")
                message.invalid_before = parseInt(object.invalid_before, 10);
            else if (typeof object.invalid_before === "number")
                message.invalid_before = object.invalid_before;
            else if (typeof object.invalid_before === "object")
                message.invalid_before = new $util.LongBits(object.invalid_before.low >>> 0, object.invalid_before.high >>> 0).toNumber(true);
        if (object.invalid_hereafter != null)
            if ($util.Long)
                (message.invalid_hereafter = $util.Long.fromValue(object.invalid_hereafter)).unsigned = true;
            else if (typeof object.invalid_hereafter === "string")
                message.invalid_hereafter = parseInt(object.invalid_hereafter, 10);
            else if (typeof object.invalid_hereafter === "number")
                message.invalid_hereafter = object.invalid_hereafter;
            else if (typeof object.invalid_hereafter === "object")
                message.invalid_hereafter = new $util.LongBits(object.invalid_hereafter.low >>> 0, object.invalid_hereafter.high >>> 0).toNumber(true);
        return message;
    };

    CardanoNativeScript.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults) {
            object.scripts = [];
            object.key_path = [];
        }
        if (options.defaults) {
            object.type = options.enums === String ? "PUB_KEY" : 0;
            if (options.bytes === String)
                object.key_hash = "";
            else {
                object.key_hash = [];
                if (options.bytes !== Array)
                    object.key_hash = $util.newBuffer(object.key_hash);
            }
            object.required_signatures_count = 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.invalid_before = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.invalid_before = options.longs === String ? "0" : 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.invalid_hereafter = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.invalid_hereafter = options.longs === String ? "0" : 0;
        }
        if (message.type != null && message.hasOwnProperty("type"))
            object.type = options.enums === String ? $root.CardanoNativeScriptType[message.type] : message.type;
        if (message.scripts && message.scripts.length) {
            object.scripts = [];
            for (var j = 0; j < message.scripts.length; ++j)
                object.scripts[j] = $root.CardanoNativeScript.toObject(message.scripts[j], options);
        }
        if (message.key_hash != null && message.hasOwnProperty("key_hash"))
            object.key_hash = options.bytes === String ? $util.base64.encode(message.key_hash, 0, message.key_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.key_hash) : message.key_hash;
        if (message.key_path && message.key_path.length) {
            object.key_path = [];
            for (var j = 0; j < message.key_path.length; ++j)
                object.key_path[j] = message.key_path[j];
        }
        if (message.required_signatures_count != null && message.hasOwnProperty("required_signatures_count"))
            object.required_signatures_count = message.required_signatures_count;
        if (message.invalid_before != null && message.hasOwnProperty("invalid_before"))
            if (typeof message.invalid_before === "number")
                object.invalid_before = options.longs === String ? String(message.invalid_before) : message.invalid_before;
            else
                object.invalid_before = options.longs === String ? $util.Long.prototype.toString.call(message.invalid_before) : options.longs === Number ? new $util.LongBits(message.invalid_before.low >>> 0, message.invalid_before.high >>> 0).toNumber(true) : message.invalid_before;
        if (message.invalid_hereafter != null && message.hasOwnProperty("invalid_hereafter"))
            if (typeof message.invalid_hereafter === "number")
                object.invalid_hereafter = options.longs === String ? String(message.invalid_hereafter) : message.invalid_hereafter;
            else
                object.invalid_hereafter = options.longs === String ? $util.Long.prototype.toString.call(message.invalid_hereafter) : options.longs === Number ? new $util.LongBits(message.invalid_hereafter.low >>> 0, message.invalid_hereafter.high >>> 0).toNumber(true) : message.invalid_hereafter;
        return object;
    };

    CardanoNativeScript.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoNativeScript;
})();

$root.CardanoGetNativeScriptHash = (function() {

    function CardanoGetNativeScriptHash(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoGetNativeScriptHash.prototype.script = null;
    CardanoGetNativeScriptHash.prototype.display_format = 0;
    CardanoGetNativeScriptHash.prototype.derivation_type = 0;

    CardanoGetNativeScriptHash.create = function create(properties) {
        return new CardanoGetNativeScriptHash(properties);
    };

    CardanoGetNativeScriptHash.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        $root.CardanoNativeScript.encode(message.script, writer.uint32(10).fork()).ldelim();
        writer.uint32(16).int32(message.display_format);
        writer.uint32(24).int32(message.derivation_type);
        return writer;
    };

    CardanoGetNativeScriptHash.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoGetNativeScriptHash.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoGetNativeScriptHash();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.script = $root.CardanoNativeScript.decode(reader, reader.uint32());
                break;
            case 2:
                message.display_format = reader.int32();
                break;
            case 3:
                message.derivation_type = reader.int32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("script"))
            throw $util.ProtocolError("missing required 'script'", { instance: message });
        if (!message.hasOwnProperty("display_format"))
            throw $util.ProtocolError("missing required 'display_format'", { instance: message });
        if (!message.hasOwnProperty("derivation_type"))
            throw $util.ProtocolError("missing required 'derivation_type'", { instance: message });
        return message;
    };

    CardanoGetNativeScriptHash.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoGetNativeScriptHash.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        {
            var error = $root.CardanoNativeScript.verify(message.script);
            if (error)
                return "script." + error;
        }
        switch (message.display_format) {
        default:
            return "display_format: enum value expected";
        case 0:
        case 1:
        case 2:
            break;
        }
        switch (message.derivation_type) {
        default:
            return "derivation_type: enum value expected";
        case 0:
        case 1:
        case 2:
            break;
        }
        return null;
    };

    CardanoGetNativeScriptHash.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoGetNativeScriptHash)
            return object;
        var message = new $root.CardanoGetNativeScriptHash();
        if (object.script != null) {
            if (typeof object.script !== "object")
                throw TypeError(".CardanoGetNativeScriptHash.script: object expected");
            message.script = $root.CardanoNativeScript.fromObject(object.script);
        }
        switch (object.display_format) {
        case "HIDE":
        case 0:
            message.display_format = 0;
            break;
        case "BECH32":
        case 1:
            message.display_format = 1;
            break;
        case "POLICY_ID":
        case 2:
            message.display_format = 2;
            break;
        }
        switch (object.derivation_type) {
        case "LEDGER":
        case 0:
            message.derivation_type = 0;
            break;
        case "ICARUS":
        case 1:
            message.derivation_type = 1;
            break;
        case "ICARUS_TREZOR":
        case 2:
            message.derivation_type = 2;
            break;
        }
        return message;
    };

    CardanoGetNativeScriptHash.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.script = null;
            object.display_format = options.enums === String ? "HIDE" : 0;
            object.derivation_type = options.enums === String ? "LEDGER" : 0;
        }
        if (message.script != null && message.hasOwnProperty("script"))
            object.script = $root.CardanoNativeScript.toObject(message.script, options);
        if (message.display_format != null && message.hasOwnProperty("display_format"))
            object.display_format = options.enums === String ? $root.CardanoNativeScriptHashDisplayFormat[message.display_format] : message.display_format;
        if (message.derivation_type != null && message.hasOwnProperty("derivation_type"))
            object.derivation_type = options.enums === String ? $root.CardanoDerivationType[message.derivation_type] : message.derivation_type;
        return object;
    };

    CardanoGetNativeScriptHash.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoGetNativeScriptHash;
})();

$root.CardanoNativeScriptHash = (function() {

    function CardanoNativeScriptHash(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoNativeScriptHash.prototype.script_hash = $util.newBuffer([]);

    CardanoNativeScriptHash.create = function create(properties) {
        return new CardanoNativeScriptHash(properties);
    };

    CardanoNativeScriptHash.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.script_hash);
        return writer;
    };

    CardanoNativeScriptHash.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoNativeScriptHash.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoNativeScriptHash();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.script_hash = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("script_hash"))
            throw $util.ProtocolError("missing required 'script_hash'", { instance: message });
        return message;
    };

    CardanoNativeScriptHash.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoNativeScriptHash.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.script_hash && typeof message.script_hash.length === "number" || $util.isString(message.script_hash)))
            return "script_hash: buffer expected";
        return null;
    };

    CardanoNativeScriptHash.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoNativeScriptHash)
            return object;
        var message = new $root.CardanoNativeScriptHash();
        if (object.script_hash != null)
            if (typeof object.script_hash === "string")
                $util.base64.decode(object.script_hash, message.script_hash = $util.newBuffer($util.base64.length(object.script_hash)), 0);
            else if (object.script_hash.length)
                message.script_hash = object.script_hash;
        return message;
    };

    CardanoNativeScriptHash.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.script_hash = "";
            else {
                object.script_hash = [];
                if (options.bytes !== Array)
                    object.script_hash = $util.newBuffer(object.script_hash);
            }
        if (message.script_hash != null && message.hasOwnProperty("script_hash"))
            object.script_hash = options.bytes === String ? $util.base64.encode(message.script_hash, 0, message.script_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.script_hash) : message.script_hash;
        return object;
    };

    CardanoNativeScriptHash.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoNativeScriptHash;
})();

$root.CardanoAddressParametersType = (function() {

    function CardanoAddressParametersType(properties) {
        this.address_n = [];
        this.address_n_staking = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoAddressParametersType.prototype.address_type = 0;
    CardanoAddressParametersType.prototype.address_n = $util.emptyArray;
    CardanoAddressParametersType.prototype.address_n_staking = $util.emptyArray;
    CardanoAddressParametersType.prototype.staking_key_hash = $util.newBuffer([]);
    CardanoAddressParametersType.prototype.certificate_pointer = null;
    CardanoAddressParametersType.prototype.script_payment_hash = $util.newBuffer([]);
    CardanoAddressParametersType.prototype.script_staking_hash = $util.newBuffer([]);

    CardanoAddressParametersType.create = function create(properties) {
        return new CardanoAddressParametersType(properties);
    };

    CardanoAddressParametersType.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).int32(message.address_type);
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(16).uint32(message.address_n[i]);
        if (message.address_n_staking != null && message.address_n_staking.length)
            for (var i = 0; i < message.address_n_staking.length; ++i)
                writer.uint32(24).uint32(message.address_n_staking[i]);
        if (message.staking_key_hash != null && Object.hasOwnProperty.call(message, "staking_key_hash"))
            writer.uint32(34).bytes(message.staking_key_hash);
        if (message.certificate_pointer != null && Object.hasOwnProperty.call(message, "certificate_pointer"))
            $root.CardanoBlockchainPointerType.encode(message.certificate_pointer, writer.uint32(42).fork()).ldelim();
        if (message.script_payment_hash != null && Object.hasOwnProperty.call(message, "script_payment_hash"))
            writer.uint32(50).bytes(message.script_payment_hash);
        if (message.script_staking_hash != null && Object.hasOwnProperty.call(message, "script_staking_hash"))
            writer.uint32(58).bytes(message.script_staking_hash);
        return writer;
    };

    CardanoAddressParametersType.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoAddressParametersType.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoAddressParametersType();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address_type = reader.int32();
                break;
            case 2:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 3:
                if (!(message.address_n_staking && message.address_n_staking.length))
                    message.address_n_staking = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n_staking.push(reader.uint32());
                } else
                    message.address_n_staking.push(reader.uint32());
                break;
            case 4:
                message.staking_key_hash = reader.bytes();
                break;
            case 5:
                message.certificate_pointer = $root.CardanoBlockchainPointerType.decode(reader, reader.uint32());
                break;
            case 6:
                message.script_payment_hash = reader.bytes();
                break;
            case 7:
                message.script_staking_hash = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("address_type"))
            throw $util.ProtocolError("missing required 'address_type'", { instance: message });
        return message;
    };

    CardanoAddressParametersType.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoAddressParametersType.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        switch (message.address_type) {
        default:
            return "address_type: enum value expected";
        case 0:
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
        case 6:
        case 7:
        case 8:
        case 14:
        case 15:
            break;
        }
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.address_n_staking != null && message.hasOwnProperty("address_n_staking")) {
            if (!Array.isArray(message.address_n_staking))
                return "address_n_staking: array expected";
            for (var i = 0; i < message.address_n_staking.length; ++i)
                if (!$util.isInteger(message.address_n_staking[i]))
                    return "address_n_staking: integer[] expected";
        }
        if (message.staking_key_hash != null && message.hasOwnProperty("staking_key_hash"))
            if (!(message.staking_key_hash && typeof message.staking_key_hash.length === "number" || $util.isString(message.staking_key_hash)))
                return "staking_key_hash: buffer expected";
        if (message.certificate_pointer != null && message.hasOwnProperty("certificate_pointer")) {
            var error = $root.CardanoBlockchainPointerType.verify(message.certificate_pointer);
            if (error)
                return "certificate_pointer." + error;
        }
        if (message.script_payment_hash != null && message.hasOwnProperty("script_payment_hash"))
            if (!(message.script_payment_hash && typeof message.script_payment_hash.length === "number" || $util.isString(message.script_payment_hash)))
                return "script_payment_hash: buffer expected";
        if (message.script_staking_hash != null && message.hasOwnProperty("script_staking_hash"))
            if (!(message.script_staking_hash && typeof message.script_staking_hash.length === "number" || $util.isString(message.script_staking_hash)))
                return "script_staking_hash: buffer expected";
        return null;
    };

    CardanoAddressParametersType.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoAddressParametersType)
            return object;
        var message = new $root.CardanoAddressParametersType();
        switch (object.address_type) {
        case "BASE":
        case 0:
            message.address_type = 0;
            break;
        case "BASE_SCRIPT_KEY":
        case 1:
            message.address_type = 1;
            break;
        case "BASE_KEY_SCRIPT":
        case 2:
            message.address_type = 2;
            break;
        case "BASE_SCRIPT_SCRIPT":
        case 3:
            message.address_type = 3;
            break;
        case "POINTER":
        case 4:
            message.address_type = 4;
            break;
        case "POINTER_SCRIPT":
        case 5:
            message.address_type = 5;
            break;
        case "ENTERPRISE":
        case 6:
            message.address_type = 6;
            break;
        case "ENTERPRISE_SCRIPT":
        case 7:
            message.address_type = 7;
            break;
        case "BYRON":
        case 8:
            message.address_type = 8;
            break;
        case "REWARD":
        case 14:
            message.address_type = 14;
            break;
        case "REWARD_SCRIPT":
        case 15:
            message.address_type = 15;
            break;
        }
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".CardanoAddressParametersType.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.address_n_staking) {
            if (!Array.isArray(object.address_n_staking))
                throw TypeError(".CardanoAddressParametersType.address_n_staking: array expected");
            message.address_n_staking = [];
            for (var i = 0; i < object.address_n_staking.length; ++i)
                message.address_n_staking[i] = object.address_n_staking[i] >>> 0;
        }
        if (object.staking_key_hash != null)
            if (typeof object.staking_key_hash === "string")
                $util.base64.decode(object.staking_key_hash, message.staking_key_hash = $util.newBuffer($util.base64.length(object.staking_key_hash)), 0);
            else if (object.staking_key_hash.length)
                message.staking_key_hash = object.staking_key_hash;
        if (object.certificate_pointer != null) {
            if (typeof object.certificate_pointer !== "object")
                throw TypeError(".CardanoAddressParametersType.certificate_pointer: object expected");
            message.certificate_pointer = $root.CardanoBlockchainPointerType.fromObject(object.certificate_pointer);
        }
        if (object.script_payment_hash != null)
            if (typeof object.script_payment_hash === "string")
                $util.base64.decode(object.script_payment_hash, message.script_payment_hash = $util.newBuffer($util.base64.length(object.script_payment_hash)), 0);
            else if (object.script_payment_hash.length)
                message.script_payment_hash = object.script_payment_hash;
        if (object.script_staking_hash != null)
            if (typeof object.script_staking_hash === "string")
                $util.base64.decode(object.script_staking_hash, message.script_staking_hash = $util.newBuffer($util.base64.length(object.script_staking_hash)), 0);
            else if (object.script_staking_hash.length)
                message.script_staking_hash = object.script_staking_hash;
        return message;
    };

    CardanoAddressParametersType.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults) {
            object.address_n = [];
            object.address_n_staking = [];
        }
        if (options.defaults) {
            object.address_type = options.enums === String ? "BASE" : 0;
            if (options.bytes === String)
                object.staking_key_hash = "";
            else {
                object.staking_key_hash = [];
                if (options.bytes !== Array)
                    object.staking_key_hash = $util.newBuffer(object.staking_key_hash);
            }
            object.certificate_pointer = null;
            if (options.bytes === String)
                object.script_payment_hash = "";
            else {
                object.script_payment_hash = [];
                if (options.bytes !== Array)
                    object.script_payment_hash = $util.newBuffer(object.script_payment_hash);
            }
            if (options.bytes === String)
                object.script_staking_hash = "";
            else {
                object.script_staking_hash = [];
                if (options.bytes !== Array)
                    object.script_staking_hash = $util.newBuffer(object.script_staking_hash);
            }
        }
        if (message.address_type != null && message.hasOwnProperty("address_type"))
            object.address_type = options.enums === String ? $root.CardanoAddressType[message.address_type] : message.address_type;
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.address_n_staking && message.address_n_staking.length) {
            object.address_n_staking = [];
            for (var j = 0; j < message.address_n_staking.length; ++j)
                object.address_n_staking[j] = message.address_n_staking[j];
        }
        if (message.staking_key_hash != null && message.hasOwnProperty("staking_key_hash"))
            object.staking_key_hash = options.bytes === String ? $util.base64.encode(message.staking_key_hash, 0, message.staking_key_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.staking_key_hash) : message.staking_key_hash;
        if (message.certificate_pointer != null && message.hasOwnProperty("certificate_pointer"))
            object.certificate_pointer = $root.CardanoBlockchainPointerType.toObject(message.certificate_pointer, options);
        if (message.script_payment_hash != null && message.hasOwnProperty("script_payment_hash"))
            object.script_payment_hash = options.bytes === String ? $util.base64.encode(message.script_payment_hash, 0, message.script_payment_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.script_payment_hash) : message.script_payment_hash;
        if (message.script_staking_hash != null && message.hasOwnProperty("script_staking_hash"))
            object.script_staking_hash = options.bytes === String ? $util.base64.encode(message.script_staking_hash, 0, message.script_staking_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.script_staking_hash) : message.script_staking_hash;
        return object;
    };

    CardanoAddressParametersType.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoAddressParametersType;
})();

$root.CardanoGetAddress = (function() {

    function CardanoGetAddress(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoGetAddress.prototype.show_display = false;
    CardanoGetAddress.prototype.protocol_magic = 0;
    CardanoGetAddress.prototype.network_id = 0;
    CardanoGetAddress.prototype.address_parameters = null;
    CardanoGetAddress.prototype.derivation_type = 0;
    CardanoGetAddress.prototype.chunkify = false;

    CardanoGetAddress.create = function create(properties) {
        return new CardanoGetAddress(properties);
    };

    CardanoGetAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(16).bool(message.show_display);
        writer.uint32(24).uint32(message.protocol_magic);
        writer.uint32(32).uint32(message.network_id);
        $root.CardanoAddressParametersType.encode(message.address_parameters, writer.uint32(42).fork()).ldelim();
        writer.uint32(48).int32(message.derivation_type);
        if (message.chunkify != null && Object.hasOwnProperty.call(message, "chunkify"))
            writer.uint32(56).bool(message.chunkify);
        return writer;
    };

    CardanoGetAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoGetAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoGetAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 2:
                message.show_display = reader.bool();
                break;
            case 3:
                message.protocol_magic = reader.uint32();
                break;
            case 4:
                message.network_id = reader.uint32();
                break;
            case 5:
                message.address_parameters = $root.CardanoAddressParametersType.decode(reader, reader.uint32());
                break;
            case 6:
                message.derivation_type = reader.int32();
                break;
            case 7:
                message.chunkify = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("protocol_magic"))
            throw $util.ProtocolError("missing required 'protocol_magic'", { instance: message });
        if (!message.hasOwnProperty("network_id"))
            throw $util.ProtocolError("missing required 'network_id'", { instance: message });
        if (!message.hasOwnProperty("address_parameters"))
            throw $util.ProtocolError("missing required 'address_parameters'", { instance: message });
        if (!message.hasOwnProperty("derivation_type"))
            throw $util.ProtocolError("missing required 'derivation_type'", { instance: message });
        return message;
    };

    CardanoGetAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoGetAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        if (!$util.isInteger(message.protocol_magic))
            return "protocol_magic: integer expected";
        if (!$util.isInteger(message.network_id))
            return "network_id: integer expected";
        {
            var error = $root.CardanoAddressParametersType.verify(message.address_parameters);
            if (error)
                return "address_parameters." + error;
        }
        switch (message.derivation_type) {
        default:
            return "derivation_type: enum value expected";
        case 0:
        case 1:
        case 2:
            break;
        }
        if (message.chunkify != null && message.hasOwnProperty("chunkify"))
            if (typeof message.chunkify !== "boolean")
                return "chunkify: boolean expected";
        return null;
    };

    CardanoGetAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoGetAddress)
            return object;
        var message = new $root.CardanoGetAddress();
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        if (object.protocol_magic != null)
            message.protocol_magic = object.protocol_magic >>> 0;
        if (object.network_id != null)
            message.network_id = object.network_id >>> 0;
        if (object.address_parameters != null) {
            if (typeof object.address_parameters !== "object")
                throw TypeError(".CardanoGetAddress.address_parameters: object expected");
            message.address_parameters = $root.CardanoAddressParametersType.fromObject(object.address_parameters);
        }
        switch (object.derivation_type) {
        case "LEDGER":
        case 0:
            message.derivation_type = 0;
            break;
        case "ICARUS":
        case 1:
            message.derivation_type = 1;
            break;
        case "ICARUS_TREZOR":
        case 2:
            message.derivation_type = 2;
            break;
        }
        if (object.chunkify != null)
            message.chunkify = Boolean(object.chunkify);
        return message;
    };

    CardanoGetAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.show_display = false;
            object.protocol_magic = 0;
            object.network_id = 0;
            object.address_parameters = null;
            object.derivation_type = options.enums === String ? "LEDGER" : 0;
            object.chunkify = false;
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        if (message.protocol_magic != null && message.hasOwnProperty("protocol_magic"))
            object.protocol_magic = message.protocol_magic;
        if (message.network_id != null && message.hasOwnProperty("network_id"))
            object.network_id = message.network_id;
        if (message.address_parameters != null && message.hasOwnProperty("address_parameters"))
            object.address_parameters = $root.CardanoAddressParametersType.toObject(message.address_parameters, options);
        if (message.derivation_type != null && message.hasOwnProperty("derivation_type"))
            object.derivation_type = options.enums === String ? $root.CardanoDerivationType[message.derivation_type] : message.derivation_type;
        if (message.chunkify != null && message.hasOwnProperty("chunkify"))
            object.chunkify = message.chunkify;
        return object;
    };

    CardanoGetAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoGetAddress;
})();

$root.CardanoAddress = (function() {

    function CardanoAddress(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoAddress.prototype.address = "";

    CardanoAddress.create = function create(properties) {
        return new CardanoAddress(properties);
    };

    CardanoAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.address);
        return writer;
    };

    CardanoAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("address"))
            throw $util.ProtocolError("missing required 'address'", { instance: message });
        return message;
    };

    CardanoAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.address))
            return "address: string expected";
        return null;
    };

    CardanoAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoAddress)
            return object;
        var message = new $root.CardanoAddress();
        if (object.address != null)
            message.address = String(object.address);
        return message;
    };

    CardanoAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.address = "";
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    CardanoAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoAddress;
})();

$root.CardanoGetPublicKey = (function() {

    function CardanoGetPublicKey(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoGetPublicKey.prototype.address_n = $util.emptyArray;
    CardanoGetPublicKey.prototype.show_display = false;
    CardanoGetPublicKey.prototype.derivation_type = 0;

    CardanoGetPublicKey.create = function create(properties) {
        return new CardanoGetPublicKey(properties);
    };

    CardanoGetPublicKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(16).bool(message.show_display);
        writer.uint32(24).int32(message.derivation_type);
        return writer;
    };

    CardanoGetPublicKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoGetPublicKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoGetPublicKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.show_display = reader.bool();
                break;
            case 3:
                message.derivation_type = reader.int32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("derivation_type"))
            throw $util.ProtocolError("missing required 'derivation_type'", { instance: message });
        return message;
    };

    CardanoGetPublicKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoGetPublicKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        switch (message.derivation_type) {
        default:
            return "derivation_type: enum value expected";
        case 0:
        case 1:
        case 2:
            break;
        }
        return null;
    };

    CardanoGetPublicKey.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoGetPublicKey)
            return object;
        var message = new $root.CardanoGetPublicKey();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".CardanoGetPublicKey.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        switch (object.derivation_type) {
        case "LEDGER":
        case 0:
            message.derivation_type = 0;
            break;
        case "ICARUS":
        case 1:
            message.derivation_type = 1;
            break;
        case "ICARUS_TREZOR":
        case 2:
            message.derivation_type = 2;
            break;
        }
        return message;
    };

    CardanoGetPublicKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            object.show_display = false;
            object.derivation_type = options.enums === String ? "LEDGER" : 0;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        if (message.derivation_type != null && message.hasOwnProperty("derivation_type"))
            object.derivation_type = options.enums === String ? $root.CardanoDerivationType[message.derivation_type] : message.derivation_type;
        return object;
    };

    CardanoGetPublicKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoGetPublicKey;
})();

$root.CardanoPublicKey = (function() {

    function CardanoPublicKey(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoPublicKey.prototype.xpub = "";
    CardanoPublicKey.prototype.node = null;

    CardanoPublicKey.create = function create(properties) {
        return new CardanoPublicKey(properties);
    };

    CardanoPublicKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.xpub);
        $root.HDNodeType.encode(message.node, writer.uint32(18).fork()).ldelim();
        return writer;
    };

    CardanoPublicKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoPublicKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoPublicKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.xpub = reader.string();
                break;
            case 2:
                message.node = $root.HDNodeType.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("xpub"))
            throw $util.ProtocolError("missing required 'xpub'", { instance: message });
        if (!message.hasOwnProperty("node"))
            throw $util.ProtocolError("missing required 'node'", { instance: message });
        return message;
    };

    CardanoPublicKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoPublicKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.xpub))
            return "xpub: string expected";
        {
            var error = $root.HDNodeType.verify(message.node);
            if (error)
                return "node." + error;
        }
        return null;
    };

    CardanoPublicKey.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoPublicKey)
            return object;
        var message = new $root.CardanoPublicKey();
        if (object.xpub != null)
            message.xpub = String(object.xpub);
        if (object.node != null) {
            if (typeof object.node !== "object")
                throw TypeError(".CardanoPublicKey.node: object expected");
            message.node = $root.HDNodeType.fromObject(object.node);
        }
        return message;
    };

    CardanoPublicKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.xpub = "";
            object.node = null;
        }
        if (message.xpub != null && message.hasOwnProperty("xpub"))
            object.xpub = message.xpub;
        if (message.node != null && message.hasOwnProperty("node"))
            object.node = $root.HDNodeType.toObject(message.node, options);
        return object;
    };

    CardanoPublicKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoPublicKey;
})();

$root.CardanoSignTxInit = (function() {

    function CardanoSignTxInit(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoSignTxInit.prototype.signing_mode = 0;
    CardanoSignTxInit.prototype.protocol_magic = 0;
    CardanoSignTxInit.prototype.network_id = 0;
    CardanoSignTxInit.prototype.inputs_count = 0;
    CardanoSignTxInit.prototype.outputs_count = 0;
    CardanoSignTxInit.prototype.fee = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    CardanoSignTxInit.prototype.ttl = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    CardanoSignTxInit.prototype.certificates_count = 0;
    CardanoSignTxInit.prototype.withdrawals_count = 0;
    CardanoSignTxInit.prototype.has_auxiliary_data = false;
    CardanoSignTxInit.prototype.validity_interval_start = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    CardanoSignTxInit.prototype.witness_requests_count = 0;
    CardanoSignTxInit.prototype.minting_asset_groups_count = 0;
    CardanoSignTxInit.prototype.derivation_type = 0;
    CardanoSignTxInit.prototype.include_network_id = false;
    CardanoSignTxInit.prototype.script_data_hash = $util.newBuffer([]);
    CardanoSignTxInit.prototype.collateral_inputs_count = 0;
    CardanoSignTxInit.prototype.required_signers_count = 0;
    CardanoSignTxInit.prototype.has_collateral_return = false;
    CardanoSignTxInit.prototype.total_collateral = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    CardanoSignTxInit.prototype.reference_inputs_count = 0;
    CardanoSignTxInit.prototype.chunkify = false;
    CardanoSignTxInit.prototype.tag_cbor_sets = false;

    CardanoSignTxInit.create = function create(properties) {
        return new CardanoSignTxInit(properties);
    };

    CardanoSignTxInit.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).int32(message.signing_mode);
        writer.uint32(16).uint32(message.protocol_magic);
        writer.uint32(24).uint32(message.network_id);
        writer.uint32(32).uint32(message.inputs_count);
        writer.uint32(40).uint32(message.outputs_count);
        writer.uint32(48).uint64(message.fee);
        if (message.ttl != null && Object.hasOwnProperty.call(message, "ttl"))
            writer.uint32(56).uint64(message.ttl);
        writer.uint32(64).uint32(message.certificates_count);
        writer.uint32(72).uint32(message.withdrawals_count);
        writer.uint32(80).bool(message.has_auxiliary_data);
        if (message.validity_interval_start != null && Object.hasOwnProperty.call(message, "validity_interval_start"))
            writer.uint32(88).uint64(message.validity_interval_start);
        writer.uint32(96).uint32(message.witness_requests_count);
        writer.uint32(104).uint32(message.minting_asset_groups_count);
        writer.uint32(112).int32(message.derivation_type);
        if (message.include_network_id != null && Object.hasOwnProperty.call(message, "include_network_id"))
            writer.uint32(120).bool(message.include_network_id);
        if (message.script_data_hash != null && Object.hasOwnProperty.call(message, "script_data_hash"))
            writer.uint32(130).bytes(message.script_data_hash);
        writer.uint32(136).uint32(message.collateral_inputs_count);
        writer.uint32(144).uint32(message.required_signers_count);
        if (message.has_collateral_return != null && Object.hasOwnProperty.call(message, "has_collateral_return"))
            writer.uint32(152).bool(message.has_collateral_return);
        if (message.total_collateral != null && Object.hasOwnProperty.call(message, "total_collateral"))
            writer.uint32(160).uint64(message.total_collateral);
        if (message.reference_inputs_count != null && Object.hasOwnProperty.call(message, "reference_inputs_count"))
            writer.uint32(168).uint32(message.reference_inputs_count);
        if (message.chunkify != null && Object.hasOwnProperty.call(message, "chunkify"))
            writer.uint32(176).bool(message.chunkify);
        if (message.tag_cbor_sets != null && Object.hasOwnProperty.call(message, "tag_cbor_sets"))
            writer.uint32(184).bool(message.tag_cbor_sets);
        return writer;
    };

    CardanoSignTxInit.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoSignTxInit.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoSignTxInit();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.signing_mode = reader.int32();
                break;
            case 2:
                message.protocol_magic = reader.uint32();
                break;
            case 3:
                message.network_id = reader.uint32();
                break;
            case 4:
                message.inputs_count = reader.uint32();
                break;
            case 5:
                message.outputs_count = reader.uint32();
                break;
            case 6:
                message.fee = reader.uint64();
                break;
            case 7:
                message.ttl = reader.uint64();
                break;
            case 8:
                message.certificates_count = reader.uint32();
                break;
            case 9:
                message.withdrawals_count = reader.uint32();
                break;
            case 10:
                message.has_auxiliary_data = reader.bool();
                break;
            case 11:
                message.validity_interval_start = reader.uint64();
                break;
            case 12:
                message.witness_requests_count = reader.uint32();
                break;
            case 13:
                message.minting_asset_groups_count = reader.uint32();
                break;
            case 14:
                message.derivation_type = reader.int32();
                break;
            case 15:
                message.include_network_id = reader.bool();
                break;
            case 16:
                message.script_data_hash = reader.bytes();
                break;
            case 17:
                message.collateral_inputs_count = reader.uint32();
                break;
            case 18:
                message.required_signers_count = reader.uint32();
                break;
            case 19:
                message.has_collateral_return = reader.bool();
                break;
            case 20:
                message.total_collateral = reader.uint64();
                break;
            case 21:
                message.reference_inputs_count = reader.uint32();
                break;
            case 22:
                message.chunkify = reader.bool();
                break;
            case 23:
                message.tag_cbor_sets = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("signing_mode"))
            throw $util.ProtocolError("missing required 'signing_mode'", { instance: message });
        if (!message.hasOwnProperty("protocol_magic"))
            throw $util.ProtocolError("missing required 'protocol_magic'", { instance: message });
        if (!message.hasOwnProperty("network_id"))
            throw $util.ProtocolError("missing required 'network_id'", { instance: message });
        if (!message.hasOwnProperty("inputs_count"))
            throw $util.ProtocolError("missing required 'inputs_count'", { instance: message });
        if (!message.hasOwnProperty("outputs_count"))
            throw $util.ProtocolError("missing required 'outputs_count'", { instance: message });
        if (!message.hasOwnProperty("fee"))
            throw $util.ProtocolError("missing required 'fee'", { instance: message });
        if (!message.hasOwnProperty("certificates_count"))
            throw $util.ProtocolError("missing required 'certificates_count'", { instance: message });
        if (!message.hasOwnProperty("withdrawals_count"))
            throw $util.ProtocolError("missing required 'withdrawals_count'", { instance: message });
        if (!message.hasOwnProperty("has_auxiliary_data"))
            throw $util.ProtocolError("missing required 'has_auxiliary_data'", { instance: message });
        if (!message.hasOwnProperty("witness_requests_count"))
            throw $util.ProtocolError("missing required 'witness_requests_count'", { instance: message });
        if (!message.hasOwnProperty("minting_asset_groups_count"))
            throw $util.ProtocolError("missing required 'minting_asset_groups_count'", { instance: message });
        if (!message.hasOwnProperty("derivation_type"))
            throw $util.ProtocolError("missing required 'derivation_type'", { instance: message });
        if (!message.hasOwnProperty("collateral_inputs_count"))
            throw $util.ProtocolError("missing required 'collateral_inputs_count'", { instance: message });
        if (!message.hasOwnProperty("required_signers_count"))
            throw $util.ProtocolError("missing required 'required_signers_count'", { instance: message });
        return message;
    };

    CardanoSignTxInit.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoSignTxInit.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        switch (message.signing_mode) {
        default:
            return "signing_mode: enum value expected";
        case 0:
        case 1:
        case 2:
        case 3:
            break;
        }
        if (!$util.isInteger(message.protocol_magic))
            return "protocol_magic: integer expected";
        if (!$util.isInteger(message.network_id))
            return "network_id: integer expected";
        if (!$util.isInteger(message.inputs_count))
            return "inputs_count: integer expected";
        if (!$util.isInteger(message.outputs_count))
            return "outputs_count: integer expected";
        if (!$util.isInteger(message.fee) && !(message.fee && $util.isInteger(message.fee.low) && $util.isInteger(message.fee.high)))
            return "fee: integer|Long expected";
        if (message.ttl != null && message.hasOwnProperty("ttl"))
            if (!$util.isInteger(message.ttl) && !(message.ttl && $util.isInteger(message.ttl.low) && $util.isInteger(message.ttl.high)))
                return "ttl: integer|Long expected";
        if (!$util.isInteger(message.certificates_count))
            return "certificates_count: integer expected";
        if (!$util.isInteger(message.withdrawals_count))
            return "withdrawals_count: integer expected";
        if (typeof message.has_auxiliary_data !== "boolean")
            return "has_auxiliary_data: boolean expected";
        if (message.validity_interval_start != null && message.hasOwnProperty("validity_interval_start"))
            if (!$util.isInteger(message.validity_interval_start) && !(message.validity_interval_start && $util.isInteger(message.validity_interval_start.low) && $util.isInteger(message.validity_interval_start.high)))
                return "validity_interval_start: integer|Long expected";
        if (!$util.isInteger(message.witness_requests_count))
            return "witness_requests_count: integer expected";
        if (!$util.isInteger(message.minting_asset_groups_count))
            return "minting_asset_groups_count: integer expected";
        switch (message.derivation_type) {
        default:
            return "derivation_type: enum value expected";
        case 0:
        case 1:
        case 2:
            break;
        }
        if (message.include_network_id != null && message.hasOwnProperty("include_network_id"))
            if (typeof message.include_network_id !== "boolean")
                return "include_network_id: boolean expected";
        if (message.script_data_hash != null && message.hasOwnProperty("script_data_hash"))
            if (!(message.script_data_hash && typeof message.script_data_hash.length === "number" || $util.isString(message.script_data_hash)))
                return "script_data_hash: buffer expected";
        if (!$util.isInteger(message.collateral_inputs_count))
            return "collateral_inputs_count: integer expected";
        if (!$util.isInteger(message.required_signers_count))
            return "required_signers_count: integer expected";
        if (message.has_collateral_return != null && message.hasOwnProperty("has_collateral_return"))
            if (typeof message.has_collateral_return !== "boolean")
                return "has_collateral_return: boolean expected";
        if (message.total_collateral != null && message.hasOwnProperty("total_collateral"))
            if (!$util.isInteger(message.total_collateral) && !(message.total_collateral && $util.isInteger(message.total_collateral.low) && $util.isInteger(message.total_collateral.high)))
                return "total_collateral: integer|Long expected";
        if (message.reference_inputs_count != null && message.hasOwnProperty("reference_inputs_count"))
            if (!$util.isInteger(message.reference_inputs_count))
                return "reference_inputs_count: integer expected";
        if (message.chunkify != null && message.hasOwnProperty("chunkify"))
            if (typeof message.chunkify !== "boolean")
                return "chunkify: boolean expected";
        if (message.tag_cbor_sets != null && message.hasOwnProperty("tag_cbor_sets"))
            if (typeof message.tag_cbor_sets !== "boolean")
                return "tag_cbor_sets: boolean expected";
        return null;
    };

    CardanoSignTxInit.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoSignTxInit)
            return object;
        var message = new $root.CardanoSignTxInit();
        switch (object.signing_mode) {
        case "ORDINARY_TRANSACTION":
        case 0:
            message.signing_mode = 0;
            break;
        case "POOL_REGISTRATION_AS_OWNER":
        case 1:
            message.signing_mode = 1;
            break;
        case "MULTISIG_TRANSACTION":
        case 2:
            message.signing_mode = 2;
            break;
        case "PLUTUS_TRANSACTION":
        case 3:
            message.signing_mode = 3;
            break;
        }
        if (object.protocol_magic != null)
            message.protocol_magic = object.protocol_magic >>> 0;
        if (object.network_id != null)
            message.network_id = object.network_id >>> 0;
        if (object.inputs_count != null)
            message.inputs_count = object.inputs_count >>> 0;
        if (object.outputs_count != null)
            message.outputs_count = object.outputs_count >>> 0;
        if (object.fee != null)
            if ($util.Long)
                (message.fee = $util.Long.fromValue(object.fee)).unsigned = true;
            else if (typeof object.fee === "string")
                message.fee = parseInt(object.fee, 10);
            else if (typeof object.fee === "number")
                message.fee = object.fee;
            else if (typeof object.fee === "object")
                message.fee = new $util.LongBits(object.fee.low >>> 0, object.fee.high >>> 0).toNumber(true);
        if (object.ttl != null)
            if ($util.Long)
                (message.ttl = $util.Long.fromValue(object.ttl)).unsigned = true;
            else if (typeof object.ttl === "string")
                message.ttl = parseInt(object.ttl, 10);
            else if (typeof object.ttl === "number")
                message.ttl = object.ttl;
            else if (typeof object.ttl === "object")
                message.ttl = new $util.LongBits(object.ttl.low >>> 0, object.ttl.high >>> 0).toNumber(true);
        if (object.certificates_count != null)
            message.certificates_count = object.certificates_count >>> 0;
        if (object.withdrawals_count != null)
            message.withdrawals_count = object.withdrawals_count >>> 0;
        if (object.has_auxiliary_data != null)
            message.has_auxiliary_data = Boolean(object.has_auxiliary_data);
        if (object.validity_interval_start != null)
            if ($util.Long)
                (message.validity_interval_start = $util.Long.fromValue(object.validity_interval_start)).unsigned = true;
            else if (typeof object.validity_interval_start === "string")
                message.validity_interval_start = parseInt(object.validity_interval_start, 10);
            else if (typeof object.validity_interval_start === "number")
                message.validity_interval_start = object.validity_interval_start;
            else if (typeof object.validity_interval_start === "object")
                message.validity_interval_start = new $util.LongBits(object.validity_interval_start.low >>> 0, object.validity_interval_start.high >>> 0).toNumber(true);
        if (object.witness_requests_count != null)
            message.witness_requests_count = object.witness_requests_count >>> 0;
        if (object.minting_asset_groups_count != null)
            message.minting_asset_groups_count = object.minting_asset_groups_count >>> 0;
        switch (object.derivation_type) {
        case "LEDGER":
        case 0:
            message.derivation_type = 0;
            break;
        case "ICARUS":
        case 1:
            message.derivation_type = 1;
            break;
        case "ICARUS_TREZOR":
        case 2:
            message.derivation_type = 2;
            break;
        }
        if (object.include_network_id != null)
            message.include_network_id = Boolean(object.include_network_id);
        if (object.script_data_hash != null)
            if (typeof object.script_data_hash === "string")
                $util.base64.decode(object.script_data_hash, message.script_data_hash = $util.newBuffer($util.base64.length(object.script_data_hash)), 0);
            else if (object.script_data_hash.length)
                message.script_data_hash = object.script_data_hash;
        if (object.collateral_inputs_count != null)
            message.collateral_inputs_count = object.collateral_inputs_count >>> 0;
        if (object.required_signers_count != null)
            message.required_signers_count = object.required_signers_count >>> 0;
        if (object.has_collateral_return != null)
            message.has_collateral_return = Boolean(object.has_collateral_return);
        if (object.total_collateral != null)
            if ($util.Long)
                (message.total_collateral = $util.Long.fromValue(object.total_collateral)).unsigned = true;
            else if (typeof object.total_collateral === "string")
                message.total_collateral = parseInt(object.total_collateral, 10);
            else if (typeof object.total_collateral === "number")
                message.total_collateral = object.total_collateral;
            else if (typeof object.total_collateral === "object")
                message.total_collateral = new $util.LongBits(object.total_collateral.low >>> 0, object.total_collateral.high >>> 0).toNumber(true);
        if (object.reference_inputs_count != null)
            message.reference_inputs_count = object.reference_inputs_count >>> 0;
        if (object.chunkify != null)
            message.chunkify = Boolean(object.chunkify);
        if (object.tag_cbor_sets != null)
            message.tag_cbor_sets = Boolean(object.tag_cbor_sets);
        return message;
    };

    CardanoSignTxInit.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.signing_mode = options.enums === String ? "ORDINARY_TRANSACTION" : 0;
            object.protocol_magic = 0;
            object.network_id = 0;
            object.inputs_count = 0;
            object.outputs_count = 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.fee = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.fee = options.longs === String ? "0" : 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.ttl = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.ttl = options.longs === String ? "0" : 0;
            object.certificates_count = 0;
            object.withdrawals_count = 0;
            object.has_auxiliary_data = false;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.validity_interval_start = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.validity_interval_start = options.longs === String ? "0" : 0;
            object.witness_requests_count = 0;
            object.minting_asset_groups_count = 0;
            object.derivation_type = options.enums === String ? "LEDGER" : 0;
            object.include_network_id = false;
            if (options.bytes === String)
                object.script_data_hash = "";
            else {
                object.script_data_hash = [];
                if (options.bytes !== Array)
                    object.script_data_hash = $util.newBuffer(object.script_data_hash);
            }
            object.collateral_inputs_count = 0;
            object.required_signers_count = 0;
            object.has_collateral_return = false;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.total_collateral = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.total_collateral = options.longs === String ? "0" : 0;
            object.reference_inputs_count = 0;
            object.chunkify = false;
            object.tag_cbor_sets = false;
        }
        if (message.signing_mode != null && message.hasOwnProperty("signing_mode"))
            object.signing_mode = options.enums === String ? $root.CardanoTxSigningMode[message.signing_mode] : message.signing_mode;
        if (message.protocol_magic != null && message.hasOwnProperty("protocol_magic"))
            object.protocol_magic = message.protocol_magic;
        if (message.network_id != null && message.hasOwnProperty("network_id"))
            object.network_id = message.network_id;
        if (message.inputs_count != null && message.hasOwnProperty("inputs_count"))
            object.inputs_count = message.inputs_count;
        if (message.outputs_count != null && message.hasOwnProperty("outputs_count"))
            object.outputs_count = message.outputs_count;
        if (message.fee != null && message.hasOwnProperty("fee"))
            if (typeof message.fee === "number")
                object.fee = options.longs === String ? String(message.fee) : message.fee;
            else
                object.fee = options.longs === String ? $util.Long.prototype.toString.call(message.fee) : options.longs === Number ? new $util.LongBits(message.fee.low >>> 0, message.fee.high >>> 0).toNumber(true) : message.fee;
        if (message.ttl != null && message.hasOwnProperty("ttl"))
            if (typeof message.ttl === "number")
                object.ttl = options.longs === String ? String(message.ttl) : message.ttl;
            else
                object.ttl = options.longs === String ? $util.Long.prototype.toString.call(message.ttl) : options.longs === Number ? new $util.LongBits(message.ttl.low >>> 0, message.ttl.high >>> 0).toNumber(true) : message.ttl;
        if (message.certificates_count != null && message.hasOwnProperty("certificates_count"))
            object.certificates_count = message.certificates_count;
        if (message.withdrawals_count != null && message.hasOwnProperty("withdrawals_count"))
            object.withdrawals_count = message.withdrawals_count;
        if (message.has_auxiliary_data != null && message.hasOwnProperty("has_auxiliary_data"))
            object.has_auxiliary_data = message.has_auxiliary_data;
        if (message.validity_interval_start != null && message.hasOwnProperty("validity_interval_start"))
            if (typeof message.validity_interval_start === "number")
                object.validity_interval_start = options.longs === String ? String(message.validity_interval_start) : message.validity_interval_start;
            else
                object.validity_interval_start = options.longs === String ? $util.Long.prototype.toString.call(message.validity_interval_start) : options.longs === Number ? new $util.LongBits(message.validity_interval_start.low >>> 0, message.validity_interval_start.high >>> 0).toNumber(true) : message.validity_interval_start;
        if (message.witness_requests_count != null && message.hasOwnProperty("witness_requests_count"))
            object.witness_requests_count = message.witness_requests_count;
        if (message.minting_asset_groups_count != null && message.hasOwnProperty("minting_asset_groups_count"))
            object.minting_asset_groups_count = message.minting_asset_groups_count;
        if (message.derivation_type != null && message.hasOwnProperty("derivation_type"))
            object.derivation_type = options.enums === String ? $root.CardanoDerivationType[message.derivation_type] : message.derivation_type;
        if (message.include_network_id != null && message.hasOwnProperty("include_network_id"))
            object.include_network_id = message.include_network_id;
        if (message.script_data_hash != null && message.hasOwnProperty("script_data_hash"))
            object.script_data_hash = options.bytes === String ? $util.base64.encode(message.script_data_hash, 0, message.script_data_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.script_data_hash) : message.script_data_hash;
        if (message.collateral_inputs_count != null && message.hasOwnProperty("collateral_inputs_count"))
            object.collateral_inputs_count = message.collateral_inputs_count;
        if (message.required_signers_count != null && message.hasOwnProperty("required_signers_count"))
            object.required_signers_count = message.required_signers_count;
        if (message.has_collateral_return != null && message.hasOwnProperty("has_collateral_return"))
            object.has_collateral_return = message.has_collateral_return;
        if (message.total_collateral != null && message.hasOwnProperty("total_collateral"))
            if (typeof message.total_collateral === "number")
                object.total_collateral = options.longs === String ? String(message.total_collateral) : message.total_collateral;
            else
                object.total_collateral = options.longs === String ? $util.Long.prototype.toString.call(message.total_collateral) : options.longs === Number ? new $util.LongBits(message.total_collateral.low >>> 0, message.total_collateral.high >>> 0).toNumber(true) : message.total_collateral;
        if (message.reference_inputs_count != null && message.hasOwnProperty("reference_inputs_count"))
            object.reference_inputs_count = message.reference_inputs_count;
        if (message.chunkify != null && message.hasOwnProperty("chunkify"))
            object.chunkify = message.chunkify;
        if (message.tag_cbor_sets != null && message.hasOwnProperty("tag_cbor_sets"))
            object.tag_cbor_sets = message.tag_cbor_sets;
        return object;
    };

    CardanoSignTxInit.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoSignTxInit;
})();

$root.CardanoTxInput = (function() {

    function CardanoTxInput(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoTxInput.prototype.prev_hash = $util.newBuffer([]);
    CardanoTxInput.prototype.prev_index = 0;

    CardanoTxInput.create = function create(properties) {
        return new CardanoTxInput(properties);
    };

    CardanoTxInput.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.prev_hash);
        writer.uint32(16).uint32(message.prev_index);
        return writer;
    };

    CardanoTxInput.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoTxInput.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoTxInput();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.prev_hash = reader.bytes();
                break;
            case 2:
                message.prev_index = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("prev_hash"))
            throw $util.ProtocolError("missing required 'prev_hash'", { instance: message });
        if (!message.hasOwnProperty("prev_index"))
            throw $util.ProtocolError("missing required 'prev_index'", { instance: message });
        return message;
    };

    CardanoTxInput.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoTxInput.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.prev_hash && typeof message.prev_hash.length === "number" || $util.isString(message.prev_hash)))
            return "prev_hash: buffer expected";
        if (!$util.isInteger(message.prev_index))
            return "prev_index: integer expected";
        return null;
    };

    CardanoTxInput.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoTxInput)
            return object;
        var message = new $root.CardanoTxInput();
        if (object.prev_hash != null)
            if (typeof object.prev_hash === "string")
                $util.base64.decode(object.prev_hash, message.prev_hash = $util.newBuffer($util.base64.length(object.prev_hash)), 0);
            else if (object.prev_hash.length)
                message.prev_hash = object.prev_hash;
        if (object.prev_index != null)
            message.prev_index = object.prev_index >>> 0;
        return message;
    };

    CardanoTxInput.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.prev_hash = "";
            else {
                object.prev_hash = [];
                if (options.bytes !== Array)
                    object.prev_hash = $util.newBuffer(object.prev_hash);
            }
            object.prev_index = 0;
        }
        if (message.prev_hash != null && message.hasOwnProperty("prev_hash"))
            object.prev_hash = options.bytes === String ? $util.base64.encode(message.prev_hash, 0, message.prev_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.prev_hash) : message.prev_hash;
        if (message.prev_index != null && message.hasOwnProperty("prev_index"))
            object.prev_index = message.prev_index;
        return object;
    };

    CardanoTxInput.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoTxInput;
})();

$root.CardanoTxOutput = (function() {

    function CardanoTxOutput(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoTxOutput.prototype.address = "";
    CardanoTxOutput.prototype.address_parameters = null;
    CardanoTxOutput.prototype.amount = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    CardanoTxOutput.prototype.asset_groups_count = 0;
    CardanoTxOutput.prototype.datum_hash = $util.newBuffer([]);
    CardanoTxOutput.prototype.format = 0;
    CardanoTxOutput.prototype.inline_datum_size = 0;
    CardanoTxOutput.prototype.reference_script_size = 0;

    CardanoTxOutput.create = function create(properties) {
        return new CardanoTxOutput(properties);
    };

    CardanoTxOutput.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address != null && Object.hasOwnProperty.call(message, "address"))
            writer.uint32(10).string(message.address);
        if (message.address_parameters != null && Object.hasOwnProperty.call(message, "address_parameters"))
            $root.CardanoAddressParametersType.encode(message.address_parameters, writer.uint32(18).fork()).ldelim();
        writer.uint32(24).uint64(message.amount);
        writer.uint32(32).uint32(message.asset_groups_count);
        if (message.datum_hash != null && Object.hasOwnProperty.call(message, "datum_hash"))
            writer.uint32(42).bytes(message.datum_hash);
        if (message.format != null && Object.hasOwnProperty.call(message, "format"))
            writer.uint32(48).int32(message.format);
        if (message.inline_datum_size != null && Object.hasOwnProperty.call(message, "inline_datum_size"))
            writer.uint32(56).uint32(message.inline_datum_size);
        if (message.reference_script_size != null && Object.hasOwnProperty.call(message, "reference_script_size"))
            writer.uint32(64).uint32(message.reference_script_size);
        return writer;
    };

    CardanoTxOutput.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoTxOutput.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoTxOutput();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.string();
                break;
            case 2:
                message.address_parameters = $root.CardanoAddressParametersType.decode(reader, reader.uint32());
                break;
            case 3:
                message.amount = reader.uint64();
                break;
            case 4:
                message.asset_groups_count = reader.uint32();
                break;
            case 5:
                message.datum_hash = reader.bytes();
                break;
            case 6:
                message.format = reader.int32();
                break;
            case 7:
                message.inline_datum_size = reader.uint32();
                break;
            case 8:
                message.reference_script_size = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("amount"))
            throw $util.ProtocolError("missing required 'amount'", { instance: message });
        if (!message.hasOwnProperty("asset_groups_count"))
            throw $util.ProtocolError("missing required 'asset_groups_count'", { instance: message });
        return message;
    };

    CardanoTxOutput.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoTxOutput.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address != null && message.hasOwnProperty("address"))
            if (!$util.isString(message.address))
                return "address: string expected";
        if (message.address_parameters != null && message.hasOwnProperty("address_parameters")) {
            var error = $root.CardanoAddressParametersType.verify(message.address_parameters);
            if (error)
                return "address_parameters." + error;
        }
        if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
            return "amount: integer|Long expected";
        if (!$util.isInteger(message.asset_groups_count))
            return "asset_groups_count: integer expected";
        if (message.datum_hash != null && message.hasOwnProperty("datum_hash"))
            if (!(message.datum_hash && typeof message.datum_hash.length === "number" || $util.isString(message.datum_hash)))
                return "datum_hash: buffer expected";
        if (message.format != null && message.hasOwnProperty("format"))
            switch (message.format) {
            default:
                return "format: enum value expected";
            case 0:
            case 1:
                break;
            }
        if (message.inline_datum_size != null && message.hasOwnProperty("inline_datum_size"))
            if (!$util.isInteger(message.inline_datum_size))
                return "inline_datum_size: integer expected";
        if (message.reference_script_size != null && message.hasOwnProperty("reference_script_size"))
            if (!$util.isInteger(message.reference_script_size))
                return "reference_script_size: integer expected";
        return null;
    };

    CardanoTxOutput.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoTxOutput)
            return object;
        var message = new $root.CardanoTxOutput();
        if (object.address != null)
            message.address = String(object.address);
        if (object.address_parameters != null) {
            if (typeof object.address_parameters !== "object")
                throw TypeError(".CardanoTxOutput.address_parameters: object expected");
            message.address_parameters = $root.CardanoAddressParametersType.fromObject(object.address_parameters);
        }
        if (object.amount != null)
            if ($util.Long)
                (message.amount = $util.Long.fromValue(object.amount)).unsigned = true;
            else if (typeof object.amount === "string")
                message.amount = parseInt(object.amount, 10);
            else if (typeof object.amount === "number")
                message.amount = object.amount;
            else if (typeof object.amount === "object")
                message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber(true);
        if (object.asset_groups_count != null)
            message.asset_groups_count = object.asset_groups_count >>> 0;
        if (object.datum_hash != null)
            if (typeof object.datum_hash === "string")
                $util.base64.decode(object.datum_hash, message.datum_hash = $util.newBuffer($util.base64.length(object.datum_hash)), 0);
            else if (object.datum_hash.length)
                message.datum_hash = object.datum_hash;
        switch (object.format) {
        case "ARRAY_LEGACY":
        case 0:
            message.format = 0;
            break;
        case "MAP_BABBAGE":
        case 1:
            message.format = 1;
            break;
        }
        if (object.inline_datum_size != null)
            message.inline_datum_size = object.inline_datum_size >>> 0;
        if (object.reference_script_size != null)
            message.reference_script_size = object.reference_script_size >>> 0;
        return message;
    };

    CardanoTxOutput.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.address = "";
            object.address_parameters = null;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.amount = options.longs === String ? "0" : 0;
            object.asset_groups_count = 0;
            if (options.bytes === String)
                object.datum_hash = "";
            else {
                object.datum_hash = [];
                if (options.bytes !== Array)
                    object.datum_hash = $util.newBuffer(object.datum_hash);
            }
            object.format = options.enums === String ? "ARRAY_LEGACY" : 0;
            object.inline_datum_size = 0;
            object.reference_script_size = 0;
        }
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        if (message.address_parameters != null && message.hasOwnProperty("address_parameters"))
            object.address_parameters = $root.CardanoAddressParametersType.toObject(message.address_parameters, options);
        if (message.amount != null && message.hasOwnProperty("amount"))
            if (typeof message.amount === "number")
                object.amount = options.longs === String ? String(message.amount) : message.amount;
            else
                object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber(true) : message.amount;
        if (message.asset_groups_count != null && message.hasOwnProperty("asset_groups_count"))
            object.asset_groups_count = message.asset_groups_count;
        if (message.datum_hash != null && message.hasOwnProperty("datum_hash"))
            object.datum_hash = options.bytes === String ? $util.base64.encode(message.datum_hash, 0, message.datum_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.datum_hash) : message.datum_hash;
        if (message.format != null && message.hasOwnProperty("format"))
            object.format = options.enums === String ? $root.CardanoTxOutputSerializationFormat[message.format] : message.format;
        if (message.inline_datum_size != null && message.hasOwnProperty("inline_datum_size"))
            object.inline_datum_size = message.inline_datum_size;
        if (message.reference_script_size != null && message.hasOwnProperty("reference_script_size"))
            object.reference_script_size = message.reference_script_size;
        return object;
    };

    CardanoTxOutput.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoTxOutput;
})();

$root.CardanoAssetGroup = (function() {

    function CardanoAssetGroup(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoAssetGroup.prototype.policy_id = $util.newBuffer([]);
    CardanoAssetGroup.prototype.tokens_count = 0;

    CardanoAssetGroup.create = function create(properties) {
        return new CardanoAssetGroup(properties);
    };

    CardanoAssetGroup.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.policy_id);
        writer.uint32(16).uint32(message.tokens_count);
        return writer;
    };

    CardanoAssetGroup.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoAssetGroup.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoAssetGroup();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.policy_id = reader.bytes();
                break;
            case 2:
                message.tokens_count = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("policy_id"))
            throw $util.ProtocolError("missing required 'policy_id'", { instance: message });
        if (!message.hasOwnProperty("tokens_count"))
            throw $util.ProtocolError("missing required 'tokens_count'", { instance: message });
        return message;
    };

    CardanoAssetGroup.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoAssetGroup.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.policy_id && typeof message.policy_id.length === "number" || $util.isString(message.policy_id)))
            return "policy_id: buffer expected";
        if (!$util.isInteger(message.tokens_count))
            return "tokens_count: integer expected";
        return null;
    };

    CardanoAssetGroup.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoAssetGroup)
            return object;
        var message = new $root.CardanoAssetGroup();
        if (object.policy_id != null)
            if (typeof object.policy_id === "string")
                $util.base64.decode(object.policy_id, message.policy_id = $util.newBuffer($util.base64.length(object.policy_id)), 0);
            else if (object.policy_id.length)
                message.policy_id = object.policy_id;
        if (object.tokens_count != null)
            message.tokens_count = object.tokens_count >>> 0;
        return message;
    };

    CardanoAssetGroup.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.policy_id = "";
            else {
                object.policy_id = [];
                if (options.bytes !== Array)
                    object.policy_id = $util.newBuffer(object.policy_id);
            }
            object.tokens_count = 0;
        }
        if (message.policy_id != null && message.hasOwnProperty("policy_id"))
            object.policy_id = options.bytes === String ? $util.base64.encode(message.policy_id, 0, message.policy_id.length) : options.bytes === Array ? Array.prototype.slice.call(message.policy_id) : message.policy_id;
        if (message.tokens_count != null && message.hasOwnProperty("tokens_count"))
            object.tokens_count = message.tokens_count;
        return object;
    };

    CardanoAssetGroup.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoAssetGroup;
})();

$root.CardanoToken = (function() {

    function CardanoToken(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoToken.prototype.asset_name_bytes = $util.newBuffer([]);
    CardanoToken.prototype.amount = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    CardanoToken.prototype.mint_amount = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    CardanoToken.create = function create(properties) {
        return new CardanoToken(properties);
    };

    CardanoToken.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.asset_name_bytes);
        if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
            writer.uint32(16).uint64(message.amount);
        if (message.mint_amount != null && Object.hasOwnProperty.call(message, "mint_amount"))
            writer.uint32(24).sint64(message.mint_amount);
        return writer;
    };

    CardanoToken.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoToken.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoToken();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.asset_name_bytes = reader.bytes();
                break;
            case 2:
                message.amount = reader.uint64();
                break;
            case 3:
                message.mint_amount = reader.sint64();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("asset_name_bytes"))
            throw $util.ProtocolError("missing required 'asset_name_bytes'", { instance: message });
        return message;
    };

    CardanoToken.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoToken.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.asset_name_bytes && typeof message.asset_name_bytes.length === "number" || $util.isString(message.asset_name_bytes)))
            return "asset_name_bytes: buffer expected";
        if (message.amount != null && message.hasOwnProperty("amount"))
            if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
                return "amount: integer|Long expected";
        if (message.mint_amount != null && message.hasOwnProperty("mint_amount"))
            if (!$util.isInteger(message.mint_amount) && !(message.mint_amount && $util.isInteger(message.mint_amount.low) && $util.isInteger(message.mint_amount.high)))
                return "mint_amount: integer|Long expected";
        return null;
    };

    CardanoToken.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoToken)
            return object;
        var message = new $root.CardanoToken();
        if (object.asset_name_bytes != null)
            if (typeof object.asset_name_bytes === "string")
                $util.base64.decode(object.asset_name_bytes, message.asset_name_bytes = $util.newBuffer($util.base64.length(object.asset_name_bytes)), 0);
            else if (object.asset_name_bytes.length)
                message.asset_name_bytes = object.asset_name_bytes;
        if (object.amount != null)
            if ($util.Long)
                (message.amount = $util.Long.fromValue(object.amount)).unsigned = true;
            else if (typeof object.amount === "string")
                message.amount = parseInt(object.amount, 10);
            else if (typeof object.amount === "number")
                message.amount = object.amount;
            else if (typeof object.amount === "object")
                message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber(true);
        if (object.mint_amount != null)
            if ($util.Long)
                (message.mint_amount = $util.Long.fromValue(object.mint_amount)).unsigned = false;
            else if (typeof object.mint_amount === "string")
                message.mint_amount = parseInt(object.mint_amount, 10);
            else if (typeof object.mint_amount === "number")
                message.mint_amount = object.mint_amount;
            else if (typeof object.mint_amount === "object")
                message.mint_amount = new $util.LongBits(object.mint_amount.low >>> 0, object.mint_amount.high >>> 0).toNumber();
        return message;
    };

    CardanoToken.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.asset_name_bytes = "";
            else {
                object.asset_name_bytes = [];
                if (options.bytes !== Array)
                    object.asset_name_bytes = $util.newBuffer(object.asset_name_bytes);
            }
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.amount = options.longs === String ? "0" : 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.mint_amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.mint_amount = options.longs === String ? "0" : 0;
        }
        if (message.asset_name_bytes != null && message.hasOwnProperty("asset_name_bytes"))
            object.asset_name_bytes = options.bytes === String ? $util.base64.encode(message.asset_name_bytes, 0, message.asset_name_bytes.length) : options.bytes === Array ? Array.prototype.slice.call(message.asset_name_bytes) : message.asset_name_bytes;
        if (message.amount != null && message.hasOwnProperty("amount"))
            if (typeof message.amount === "number")
                object.amount = options.longs === String ? String(message.amount) : message.amount;
            else
                object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber(true) : message.amount;
        if (message.mint_amount != null && message.hasOwnProperty("mint_amount"))
            if (typeof message.mint_amount === "number")
                object.mint_amount = options.longs === String ? String(message.mint_amount) : message.mint_amount;
            else
                object.mint_amount = options.longs === String ? $util.Long.prototype.toString.call(message.mint_amount) : options.longs === Number ? new $util.LongBits(message.mint_amount.low >>> 0, message.mint_amount.high >>> 0).toNumber() : message.mint_amount;
        return object;
    };

    CardanoToken.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoToken;
})();

$root.CardanoTxInlineDatumChunk = (function() {

    function CardanoTxInlineDatumChunk(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoTxInlineDatumChunk.prototype.data = $util.newBuffer([]);

    CardanoTxInlineDatumChunk.create = function create(properties) {
        return new CardanoTxInlineDatumChunk(properties);
    };

    CardanoTxInlineDatumChunk.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.data);
        return writer;
    };

    CardanoTxInlineDatumChunk.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoTxInlineDatumChunk.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoTxInlineDatumChunk();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.data = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("data"))
            throw $util.ProtocolError("missing required 'data'", { instance: message });
        return message;
    };

    CardanoTxInlineDatumChunk.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoTxInlineDatumChunk.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
            return "data: buffer expected";
        return null;
    };

    CardanoTxInlineDatumChunk.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoTxInlineDatumChunk)
            return object;
        var message = new $root.CardanoTxInlineDatumChunk();
        if (object.data != null)
            if (typeof object.data === "string")
                $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
            else if (object.data.length)
                message.data = object.data;
        return message;
    };

    CardanoTxInlineDatumChunk.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.data = "";
            else {
                object.data = [];
                if (options.bytes !== Array)
                    object.data = $util.newBuffer(object.data);
            }
        if (message.data != null && message.hasOwnProperty("data"))
            object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
        return object;
    };

    CardanoTxInlineDatumChunk.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoTxInlineDatumChunk;
})();

$root.CardanoTxReferenceScriptChunk = (function() {

    function CardanoTxReferenceScriptChunk(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoTxReferenceScriptChunk.prototype.data = $util.newBuffer([]);

    CardanoTxReferenceScriptChunk.create = function create(properties) {
        return new CardanoTxReferenceScriptChunk(properties);
    };

    CardanoTxReferenceScriptChunk.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.data);
        return writer;
    };

    CardanoTxReferenceScriptChunk.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoTxReferenceScriptChunk.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoTxReferenceScriptChunk();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.data = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("data"))
            throw $util.ProtocolError("missing required 'data'", { instance: message });
        return message;
    };

    CardanoTxReferenceScriptChunk.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoTxReferenceScriptChunk.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
            return "data: buffer expected";
        return null;
    };

    CardanoTxReferenceScriptChunk.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoTxReferenceScriptChunk)
            return object;
        var message = new $root.CardanoTxReferenceScriptChunk();
        if (object.data != null)
            if (typeof object.data === "string")
                $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
            else if (object.data.length)
                message.data = object.data;
        return message;
    };

    CardanoTxReferenceScriptChunk.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.data = "";
            else {
                object.data = [];
                if (options.bytes !== Array)
                    object.data = $util.newBuffer(object.data);
            }
        if (message.data != null && message.hasOwnProperty("data"))
            object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
        return object;
    };

    CardanoTxReferenceScriptChunk.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoTxReferenceScriptChunk;
})();

$root.CardanoPoolOwner = (function() {

    function CardanoPoolOwner(properties) {
        this.staking_key_path = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoPoolOwner.prototype.staking_key_path = $util.emptyArray;
    CardanoPoolOwner.prototype.staking_key_hash = $util.newBuffer([]);

    CardanoPoolOwner.create = function create(properties) {
        return new CardanoPoolOwner(properties);
    };

    CardanoPoolOwner.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.staking_key_path != null && message.staking_key_path.length)
            for (var i = 0; i < message.staking_key_path.length; ++i)
                writer.uint32(8).uint32(message.staking_key_path[i]);
        if (message.staking_key_hash != null && Object.hasOwnProperty.call(message, "staking_key_hash"))
            writer.uint32(18).bytes(message.staking_key_hash);
        return writer;
    };

    CardanoPoolOwner.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoPoolOwner.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoPoolOwner();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.staking_key_path && message.staking_key_path.length))
                    message.staking_key_path = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.staking_key_path.push(reader.uint32());
                } else
                    message.staking_key_path.push(reader.uint32());
                break;
            case 2:
                message.staking_key_hash = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    CardanoPoolOwner.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoPoolOwner.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.staking_key_path != null && message.hasOwnProperty("staking_key_path")) {
            if (!Array.isArray(message.staking_key_path))
                return "staking_key_path: array expected";
            for (var i = 0; i < message.staking_key_path.length; ++i)
                if (!$util.isInteger(message.staking_key_path[i]))
                    return "staking_key_path: integer[] expected";
        }
        if (message.staking_key_hash != null && message.hasOwnProperty("staking_key_hash"))
            if (!(message.staking_key_hash && typeof message.staking_key_hash.length === "number" || $util.isString(message.staking_key_hash)))
                return "staking_key_hash: buffer expected";
        return null;
    };

    CardanoPoolOwner.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoPoolOwner)
            return object;
        var message = new $root.CardanoPoolOwner();
        if (object.staking_key_path) {
            if (!Array.isArray(object.staking_key_path))
                throw TypeError(".CardanoPoolOwner.staking_key_path: array expected");
            message.staking_key_path = [];
            for (var i = 0; i < object.staking_key_path.length; ++i)
                message.staking_key_path[i] = object.staking_key_path[i] >>> 0;
        }
        if (object.staking_key_hash != null)
            if (typeof object.staking_key_hash === "string")
                $util.base64.decode(object.staking_key_hash, message.staking_key_hash = $util.newBuffer($util.base64.length(object.staking_key_hash)), 0);
            else if (object.staking_key_hash.length)
                message.staking_key_hash = object.staking_key_hash;
        return message;
    };

    CardanoPoolOwner.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.staking_key_path = [];
        if (options.defaults)
            if (options.bytes === String)
                object.staking_key_hash = "";
            else {
                object.staking_key_hash = [];
                if (options.bytes !== Array)
                    object.staking_key_hash = $util.newBuffer(object.staking_key_hash);
            }
        if (message.staking_key_path && message.staking_key_path.length) {
            object.staking_key_path = [];
            for (var j = 0; j < message.staking_key_path.length; ++j)
                object.staking_key_path[j] = message.staking_key_path[j];
        }
        if (message.staking_key_hash != null && message.hasOwnProperty("staking_key_hash"))
            object.staking_key_hash = options.bytes === String ? $util.base64.encode(message.staking_key_hash, 0, message.staking_key_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.staking_key_hash) : message.staking_key_hash;
        return object;
    };

    CardanoPoolOwner.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoPoolOwner;
})();

$root.CardanoPoolRelayParameters = (function() {

    function CardanoPoolRelayParameters(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoPoolRelayParameters.prototype.type = 0;
    CardanoPoolRelayParameters.prototype.ipv4_address = $util.newBuffer([]);
    CardanoPoolRelayParameters.prototype.ipv6_address = $util.newBuffer([]);
    CardanoPoolRelayParameters.prototype.host_name = "";
    CardanoPoolRelayParameters.prototype.port = 0;

    CardanoPoolRelayParameters.create = function create(properties) {
        return new CardanoPoolRelayParameters(properties);
    };

    CardanoPoolRelayParameters.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).int32(message.type);
        if (message.ipv4_address != null && Object.hasOwnProperty.call(message, "ipv4_address"))
            writer.uint32(18).bytes(message.ipv4_address);
        if (message.ipv6_address != null && Object.hasOwnProperty.call(message, "ipv6_address"))
            writer.uint32(26).bytes(message.ipv6_address);
        if (message.host_name != null && Object.hasOwnProperty.call(message, "host_name"))
            writer.uint32(34).string(message.host_name);
        if (message.port != null && Object.hasOwnProperty.call(message, "port"))
            writer.uint32(40).uint32(message.port);
        return writer;
    };

    CardanoPoolRelayParameters.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoPoolRelayParameters.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoPoolRelayParameters();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.type = reader.int32();
                break;
            case 2:
                message.ipv4_address = reader.bytes();
                break;
            case 3:
                message.ipv6_address = reader.bytes();
                break;
            case 4:
                message.host_name = reader.string();
                break;
            case 5:
                message.port = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("type"))
            throw $util.ProtocolError("missing required 'type'", { instance: message });
        return message;
    };

    CardanoPoolRelayParameters.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoPoolRelayParameters.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        switch (message.type) {
        default:
            return "type: enum value expected";
        case 0:
        case 1:
        case 2:
            break;
        }
        if (message.ipv4_address != null && message.hasOwnProperty("ipv4_address"))
            if (!(message.ipv4_address && typeof message.ipv4_address.length === "number" || $util.isString(message.ipv4_address)))
                return "ipv4_address: buffer expected";
        if (message.ipv6_address != null && message.hasOwnProperty("ipv6_address"))
            if (!(message.ipv6_address && typeof message.ipv6_address.length === "number" || $util.isString(message.ipv6_address)))
                return "ipv6_address: buffer expected";
        if (message.host_name != null && message.hasOwnProperty("host_name"))
            if (!$util.isString(message.host_name))
                return "host_name: string expected";
        if (message.port != null && message.hasOwnProperty("port"))
            if (!$util.isInteger(message.port))
                return "port: integer expected";
        return null;
    };

    CardanoPoolRelayParameters.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoPoolRelayParameters)
            return object;
        var message = new $root.CardanoPoolRelayParameters();
        switch (object.type) {
        case "SINGLE_HOST_IP":
        case 0:
            message.type = 0;
            break;
        case "SINGLE_HOST_NAME":
        case 1:
            message.type = 1;
            break;
        case "MULTIPLE_HOST_NAME":
        case 2:
            message.type = 2;
            break;
        }
        if (object.ipv4_address != null)
            if (typeof object.ipv4_address === "string")
                $util.base64.decode(object.ipv4_address, message.ipv4_address = $util.newBuffer($util.base64.length(object.ipv4_address)), 0);
            else if (object.ipv4_address.length)
                message.ipv4_address = object.ipv4_address;
        if (object.ipv6_address != null)
            if (typeof object.ipv6_address === "string")
                $util.base64.decode(object.ipv6_address, message.ipv6_address = $util.newBuffer($util.base64.length(object.ipv6_address)), 0);
            else if (object.ipv6_address.length)
                message.ipv6_address = object.ipv6_address;
        if (object.host_name != null)
            message.host_name = String(object.host_name);
        if (object.port != null)
            message.port = object.port >>> 0;
        return message;
    };

    CardanoPoolRelayParameters.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.type = options.enums === String ? "SINGLE_HOST_IP" : 0;
            if (options.bytes === String)
                object.ipv4_address = "";
            else {
                object.ipv4_address = [];
                if (options.bytes !== Array)
                    object.ipv4_address = $util.newBuffer(object.ipv4_address);
            }
            if (options.bytes === String)
                object.ipv6_address = "";
            else {
                object.ipv6_address = [];
                if (options.bytes !== Array)
                    object.ipv6_address = $util.newBuffer(object.ipv6_address);
            }
            object.host_name = "";
            object.port = 0;
        }
        if (message.type != null && message.hasOwnProperty("type"))
            object.type = options.enums === String ? $root.CardanoPoolRelayType[message.type] : message.type;
        if (message.ipv4_address != null && message.hasOwnProperty("ipv4_address"))
            object.ipv4_address = options.bytes === String ? $util.base64.encode(message.ipv4_address, 0, message.ipv4_address.length) : options.bytes === Array ? Array.prototype.slice.call(message.ipv4_address) : message.ipv4_address;
        if (message.ipv6_address != null && message.hasOwnProperty("ipv6_address"))
            object.ipv6_address = options.bytes === String ? $util.base64.encode(message.ipv6_address, 0, message.ipv6_address.length) : options.bytes === Array ? Array.prototype.slice.call(message.ipv6_address) : message.ipv6_address;
        if (message.host_name != null && message.hasOwnProperty("host_name"))
            object.host_name = message.host_name;
        if (message.port != null && message.hasOwnProperty("port"))
            object.port = message.port;
        return object;
    };

    CardanoPoolRelayParameters.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoPoolRelayParameters;
})();

$root.CardanoPoolMetadataType = (function() {

    function CardanoPoolMetadataType(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoPoolMetadataType.prototype.url = "";
    CardanoPoolMetadataType.prototype.hash = $util.newBuffer([]);

    CardanoPoolMetadataType.create = function create(properties) {
        return new CardanoPoolMetadataType(properties);
    };

    CardanoPoolMetadataType.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.url);
        writer.uint32(18).bytes(message.hash);
        return writer;
    };

    CardanoPoolMetadataType.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoPoolMetadataType.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoPoolMetadataType();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.url = reader.string();
                break;
            case 2:
                message.hash = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("url"))
            throw $util.ProtocolError("missing required 'url'", { instance: message });
        if (!message.hasOwnProperty("hash"))
            throw $util.ProtocolError("missing required 'hash'", { instance: message });
        return message;
    };

    CardanoPoolMetadataType.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoPoolMetadataType.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.url))
            return "url: string expected";
        if (!(message.hash && typeof message.hash.length === "number" || $util.isString(message.hash)))
            return "hash: buffer expected";
        return null;
    };

    CardanoPoolMetadataType.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoPoolMetadataType)
            return object;
        var message = new $root.CardanoPoolMetadataType();
        if (object.url != null)
            message.url = String(object.url);
        if (object.hash != null)
            if (typeof object.hash === "string")
                $util.base64.decode(object.hash, message.hash = $util.newBuffer($util.base64.length(object.hash)), 0);
            else if (object.hash.length)
                message.hash = object.hash;
        return message;
    };

    CardanoPoolMetadataType.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.url = "";
            if (options.bytes === String)
                object.hash = "";
            else {
                object.hash = [];
                if (options.bytes !== Array)
                    object.hash = $util.newBuffer(object.hash);
            }
        }
        if (message.url != null && message.hasOwnProperty("url"))
            object.url = message.url;
        if (message.hash != null && message.hasOwnProperty("hash"))
            object.hash = options.bytes === String ? $util.base64.encode(message.hash, 0, message.hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.hash) : message.hash;
        return object;
    };

    CardanoPoolMetadataType.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoPoolMetadataType;
})();

$root.CardanoPoolParametersType = (function() {

    function CardanoPoolParametersType(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoPoolParametersType.prototype.pool_id = $util.newBuffer([]);
    CardanoPoolParametersType.prototype.vrf_key_hash = $util.newBuffer([]);
    CardanoPoolParametersType.prototype.pledge = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    CardanoPoolParametersType.prototype.cost = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    CardanoPoolParametersType.prototype.margin_numerator = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    CardanoPoolParametersType.prototype.margin_denominator = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    CardanoPoolParametersType.prototype.reward_account = "";
    CardanoPoolParametersType.prototype.metadata = null;
    CardanoPoolParametersType.prototype.owners_count = 0;
    CardanoPoolParametersType.prototype.relays_count = 0;

    CardanoPoolParametersType.create = function create(properties) {
        return new CardanoPoolParametersType(properties);
    };

    CardanoPoolParametersType.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.pool_id);
        writer.uint32(18).bytes(message.vrf_key_hash);
        writer.uint32(24).uint64(message.pledge);
        writer.uint32(32).uint64(message.cost);
        writer.uint32(40).uint64(message.margin_numerator);
        writer.uint32(48).uint64(message.margin_denominator);
        writer.uint32(58).string(message.reward_account);
        if (message.metadata != null && Object.hasOwnProperty.call(message, "metadata"))
            $root.CardanoPoolMetadataType.encode(message.metadata, writer.uint32(82).fork()).ldelim();
        writer.uint32(88).uint32(message.owners_count);
        writer.uint32(96).uint32(message.relays_count);
        return writer;
    };

    CardanoPoolParametersType.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoPoolParametersType.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoPoolParametersType();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.pool_id = reader.bytes();
                break;
            case 2:
                message.vrf_key_hash = reader.bytes();
                break;
            case 3:
                message.pledge = reader.uint64();
                break;
            case 4:
                message.cost = reader.uint64();
                break;
            case 5:
                message.margin_numerator = reader.uint64();
                break;
            case 6:
                message.margin_denominator = reader.uint64();
                break;
            case 7:
                message.reward_account = reader.string();
                break;
            case 10:
                message.metadata = $root.CardanoPoolMetadataType.decode(reader, reader.uint32());
                break;
            case 11:
                message.owners_count = reader.uint32();
                break;
            case 12:
                message.relays_count = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("pool_id"))
            throw $util.ProtocolError("missing required 'pool_id'", { instance: message });
        if (!message.hasOwnProperty("vrf_key_hash"))
            throw $util.ProtocolError("missing required 'vrf_key_hash'", { instance: message });
        if (!message.hasOwnProperty("pledge"))
            throw $util.ProtocolError("missing required 'pledge'", { instance: message });
        if (!message.hasOwnProperty("cost"))
            throw $util.ProtocolError("missing required 'cost'", { instance: message });
        if (!message.hasOwnProperty("margin_numerator"))
            throw $util.ProtocolError("missing required 'margin_numerator'", { instance: message });
        if (!message.hasOwnProperty("margin_denominator"))
            throw $util.ProtocolError("missing required 'margin_denominator'", { instance: message });
        if (!message.hasOwnProperty("reward_account"))
            throw $util.ProtocolError("missing required 'reward_account'", { instance: message });
        if (!message.hasOwnProperty("owners_count"))
            throw $util.ProtocolError("missing required 'owners_count'", { instance: message });
        if (!message.hasOwnProperty("relays_count"))
            throw $util.ProtocolError("missing required 'relays_count'", { instance: message });
        return message;
    };

    CardanoPoolParametersType.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoPoolParametersType.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.pool_id && typeof message.pool_id.length === "number" || $util.isString(message.pool_id)))
            return "pool_id: buffer expected";
        if (!(message.vrf_key_hash && typeof message.vrf_key_hash.length === "number" || $util.isString(message.vrf_key_hash)))
            return "vrf_key_hash: buffer expected";
        if (!$util.isInteger(message.pledge) && !(message.pledge && $util.isInteger(message.pledge.low) && $util.isInteger(message.pledge.high)))
            return "pledge: integer|Long expected";
        if (!$util.isInteger(message.cost) && !(message.cost && $util.isInteger(message.cost.low) && $util.isInteger(message.cost.high)))
            return "cost: integer|Long expected";
        if (!$util.isInteger(message.margin_numerator) && !(message.margin_numerator && $util.isInteger(message.margin_numerator.low) && $util.isInteger(message.margin_numerator.high)))
            return "margin_numerator: integer|Long expected";
        if (!$util.isInteger(message.margin_denominator) && !(message.margin_denominator && $util.isInteger(message.margin_denominator.low) && $util.isInteger(message.margin_denominator.high)))
            return "margin_denominator: integer|Long expected";
        if (!$util.isString(message.reward_account))
            return "reward_account: string expected";
        if (message.metadata != null && message.hasOwnProperty("metadata")) {
            var error = $root.CardanoPoolMetadataType.verify(message.metadata);
            if (error)
                return "metadata." + error;
        }
        if (!$util.isInteger(message.owners_count))
            return "owners_count: integer expected";
        if (!$util.isInteger(message.relays_count))
            return "relays_count: integer expected";
        return null;
    };

    CardanoPoolParametersType.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoPoolParametersType)
            return object;
        var message = new $root.CardanoPoolParametersType();
        if (object.pool_id != null)
            if (typeof object.pool_id === "string")
                $util.base64.decode(object.pool_id, message.pool_id = $util.newBuffer($util.base64.length(object.pool_id)), 0);
            else if (object.pool_id.length)
                message.pool_id = object.pool_id;
        if (object.vrf_key_hash != null)
            if (typeof object.vrf_key_hash === "string")
                $util.base64.decode(object.vrf_key_hash, message.vrf_key_hash = $util.newBuffer($util.base64.length(object.vrf_key_hash)), 0);
            else if (object.vrf_key_hash.length)
                message.vrf_key_hash = object.vrf_key_hash;
        if (object.pledge != null)
            if ($util.Long)
                (message.pledge = $util.Long.fromValue(object.pledge)).unsigned = true;
            else if (typeof object.pledge === "string")
                message.pledge = parseInt(object.pledge, 10);
            else if (typeof object.pledge === "number")
                message.pledge = object.pledge;
            else if (typeof object.pledge === "object")
                message.pledge = new $util.LongBits(object.pledge.low >>> 0, object.pledge.high >>> 0).toNumber(true);
        if (object.cost != null)
            if ($util.Long)
                (message.cost = $util.Long.fromValue(object.cost)).unsigned = true;
            else if (typeof object.cost === "string")
                message.cost = parseInt(object.cost, 10);
            else if (typeof object.cost === "number")
                message.cost = object.cost;
            else if (typeof object.cost === "object")
                message.cost = new $util.LongBits(object.cost.low >>> 0, object.cost.high >>> 0).toNumber(true);
        if (object.margin_numerator != null)
            if ($util.Long)
                (message.margin_numerator = $util.Long.fromValue(object.margin_numerator)).unsigned = true;
            else if (typeof object.margin_numerator === "string")
                message.margin_numerator = parseInt(object.margin_numerator, 10);
            else if (typeof object.margin_numerator === "number")
                message.margin_numerator = object.margin_numerator;
            else if (typeof object.margin_numerator === "object")
                message.margin_numerator = new $util.LongBits(object.margin_numerator.low >>> 0, object.margin_numerator.high >>> 0).toNumber(true);
        if (object.margin_denominator != null)
            if ($util.Long)
                (message.margin_denominator = $util.Long.fromValue(object.margin_denominator)).unsigned = true;
            else if (typeof object.margin_denominator === "string")
                message.margin_denominator = parseInt(object.margin_denominator, 10);
            else if (typeof object.margin_denominator === "number")
                message.margin_denominator = object.margin_denominator;
            else if (typeof object.margin_denominator === "object")
                message.margin_denominator = new $util.LongBits(object.margin_denominator.low >>> 0, object.margin_denominator.high >>> 0).toNumber(true);
        if (object.reward_account != null)
            message.reward_account = String(object.reward_account);
        if (object.metadata != null) {
            if (typeof object.metadata !== "object")
                throw TypeError(".CardanoPoolParametersType.metadata: object expected");
            message.metadata = $root.CardanoPoolMetadataType.fromObject(object.metadata);
        }
        if (object.owners_count != null)
            message.owners_count = object.owners_count >>> 0;
        if (object.relays_count != null)
            message.relays_count = object.relays_count >>> 0;
        return message;
    };

    CardanoPoolParametersType.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.pool_id = "";
            else {
                object.pool_id = [];
                if (options.bytes !== Array)
                    object.pool_id = $util.newBuffer(object.pool_id);
            }
            if (options.bytes === String)
                object.vrf_key_hash = "";
            else {
                object.vrf_key_hash = [];
                if (options.bytes !== Array)
                    object.vrf_key_hash = $util.newBuffer(object.vrf_key_hash);
            }
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.pledge = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.pledge = options.longs === String ? "0" : 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.cost = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.cost = options.longs === String ? "0" : 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.margin_numerator = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.margin_numerator = options.longs === String ? "0" : 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.margin_denominator = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.margin_denominator = options.longs === String ? "0" : 0;
            object.reward_account = "";
            object.metadata = null;
            object.owners_count = 0;
            object.relays_count = 0;
        }
        if (message.pool_id != null && message.hasOwnProperty("pool_id"))
            object.pool_id = options.bytes === String ? $util.base64.encode(message.pool_id, 0, message.pool_id.length) : options.bytes === Array ? Array.prototype.slice.call(message.pool_id) : message.pool_id;
        if (message.vrf_key_hash != null && message.hasOwnProperty("vrf_key_hash"))
            object.vrf_key_hash = options.bytes === String ? $util.base64.encode(message.vrf_key_hash, 0, message.vrf_key_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.vrf_key_hash) : message.vrf_key_hash;
        if (message.pledge != null && message.hasOwnProperty("pledge"))
            if (typeof message.pledge === "number")
                object.pledge = options.longs === String ? String(message.pledge) : message.pledge;
            else
                object.pledge = options.longs === String ? $util.Long.prototype.toString.call(message.pledge) : options.longs === Number ? new $util.LongBits(message.pledge.low >>> 0, message.pledge.high >>> 0).toNumber(true) : message.pledge;
        if (message.cost != null && message.hasOwnProperty("cost"))
            if (typeof message.cost === "number")
                object.cost = options.longs === String ? String(message.cost) : message.cost;
            else
                object.cost = options.longs === String ? $util.Long.prototype.toString.call(message.cost) : options.longs === Number ? new $util.LongBits(message.cost.low >>> 0, message.cost.high >>> 0).toNumber(true) : message.cost;
        if (message.margin_numerator != null && message.hasOwnProperty("margin_numerator"))
            if (typeof message.margin_numerator === "number")
                object.margin_numerator = options.longs === String ? String(message.margin_numerator) : message.margin_numerator;
            else
                object.margin_numerator = options.longs === String ? $util.Long.prototype.toString.call(message.margin_numerator) : options.longs === Number ? new $util.LongBits(message.margin_numerator.low >>> 0, message.margin_numerator.high >>> 0).toNumber(true) : message.margin_numerator;
        if (message.margin_denominator != null && message.hasOwnProperty("margin_denominator"))
            if (typeof message.margin_denominator === "number")
                object.margin_denominator = options.longs === String ? String(message.margin_denominator) : message.margin_denominator;
            else
                object.margin_denominator = options.longs === String ? $util.Long.prototype.toString.call(message.margin_denominator) : options.longs === Number ? new $util.LongBits(message.margin_denominator.low >>> 0, message.margin_denominator.high >>> 0).toNumber(true) : message.margin_denominator;
        if (message.reward_account != null && message.hasOwnProperty("reward_account"))
            object.reward_account = message.reward_account;
        if (message.metadata != null && message.hasOwnProperty("metadata"))
            object.metadata = $root.CardanoPoolMetadataType.toObject(message.metadata, options);
        if (message.owners_count != null && message.hasOwnProperty("owners_count"))
            object.owners_count = message.owners_count;
        if (message.relays_count != null && message.hasOwnProperty("relays_count"))
            object.relays_count = message.relays_count;
        return object;
    };

    CardanoPoolParametersType.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoPoolParametersType;
})();

$root.CardanoDRep = (function() {

    function CardanoDRep(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoDRep.prototype.type = 0;
    CardanoDRep.prototype.key_hash = $util.newBuffer([]);
    CardanoDRep.prototype.script_hash = $util.newBuffer([]);

    CardanoDRep.create = function create(properties) {
        return new CardanoDRep(properties);
    };

    CardanoDRep.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).int32(message.type);
        if (message.key_hash != null && Object.hasOwnProperty.call(message, "key_hash"))
            writer.uint32(18).bytes(message.key_hash);
        if (message.script_hash != null && Object.hasOwnProperty.call(message, "script_hash"))
            writer.uint32(26).bytes(message.script_hash);
        return writer;
    };

    CardanoDRep.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoDRep.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoDRep();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.type = reader.int32();
                break;
            case 2:
                message.key_hash = reader.bytes();
                break;
            case 3:
                message.script_hash = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("type"))
            throw $util.ProtocolError("missing required 'type'", { instance: message });
        return message;
    };

    CardanoDRep.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoDRep.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        switch (message.type) {
        default:
            return "type: enum value expected";
        case 0:
        case 1:
        case 2:
        case 3:
            break;
        }
        if (message.key_hash != null && message.hasOwnProperty("key_hash"))
            if (!(message.key_hash && typeof message.key_hash.length === "number" || $util.isString(message.key_hash)))
                return "key_hash: buffer expected";
        if (message.script_hash != null && message.hasOwnProperty("script_hash"))
            if (!(message.script_hash && typeof message.script_hash.length === "number" || $util.isString(message.script_hash)))
                return "script_hash: buffer expected";
        return null;
    };

    CardanoDRep.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoDRep)
            return object;
        var message = new $root.CardanoDRep();
        switch (object.type) {
        case "KEY_HASH":
        case 0:
            message.type = 0;
            break;
        case "SCRIPT_HASH":
        case 1:
            message.type = 1;
            break;
        case "ABSTAIN":
        case 2:
            message.type = 2;
            break;
        case "NO_CONFIDENCE":
        case 3:
            message.type = 3;
            break;
        }
        if (object.key_hash != null)
            if (typeof object.key_hash === "string")
                $util.base64.decode(object.key_hash, message.key_hash = $util.newBuffer($util.base64.length(object.key_hash)), 0);
            else if (object.key_hash.length)
                message.key_hash = object.key_hash;
        if (object.script_hash != null)
            if (typeof object.script_hash === "string")
                $util.base64.decode(object.script_hash, message.script_hash = $util.newBuffer($util.base64.length(object.script_hash)), 0);
            else if (object.script_hash.length)
                message.script_hash = object.script_hash;
        return message;
    };

    CardanoDRep.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.type = options.enums === String ? "KEY_HASH" : 0;
            if (options.bytes === String)
                object.key_hash = "";
            else {
                object.key_hash = [];
                if (options.bytes !== Array)
                    object.key_hash = $util.newBuffer(object.key_hash);
            }
            if (options.bytes === String)
                object.script_hash = "";
            else {
                object.script_hash = [];
                if (options.bytes !== Array)
                    object.script_hash = $util.newBuffer(object.script_hash);
            }
        }
        if (message.type != null && message.hasOwnProperty("type"))
            object.type = options.enums === String ? $root.CardanoDRepType[message.type] : message.type;
        if (message.key_hash != null && message.hasOwnProperty("key_hash"))
            object.key_hash = options.bytes === String ? $util.base64.encode(message.key_hash, 0, message.key_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.key_hash) : message.key_hash;
        if (message.script_hash != null && message.hasOwnProperty("script_hash"))
            object.script_hash = options.bytes === String ? $util.base64.encode(message.script_hash, 0, message.script_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.script_hash) : message.script_hash;
        return object;
    };

    CardanoDRep.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoDRep;
})();

$root.CardanoTxCertificate = (function() {

    function CardanoTxCertificate(properties) {
        this.path = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoTxCertificate.prototype.type = 0;
    CardanoTxCertificate.prototype.path = $util.emptyArray;
    CardanoTxCertificate.prototype.pool = $util.newBuffer([]);
    CardanoTxCertificate.prototype.pool_parameters = null;
    CardanoTxCertificate.prototype.script_hash = $util.newBuffer([]);
    CardanoTxCertificate.prototype.key_hash = $util.newBuffer([]);
    CardanoTxCertificate.prototype.deposit = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    CardanoTxCertificate.prototype.drep = null;

    CardanoTxCertificate.create = function create(properties) {
        return new CardanoTxCertificate(properties);
    };

    CardanoTxCertificate.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).int32(message.type);
        if (message.path != null && message.path.length)
            for (var i = 0; i < message.path.length; ++i)
                writer.uint32(16).uint32(message.path[i]);
        if (message.pool != null && Object.hasOwnProperty.call(message, "pool"))
            writer.uint32(26).bytes(message.pool);
        if (message.pool_parameters != null && Object.hasOwnProperty.call(message, "pool_parameters"))
            $root.CardanoPoolParametersType.encode(message.pool_parameters, writer.uint32(34).fork()).ldelim();
        if (message.script_hash != null && Object.hasOwnProperty.call(message, "script_hash"))
            writer.uint32(42).bytes(message.script_hash);
        if (message.key_hash != null && Object.hasOwnProperty.call(message, "key_hash"))
            writer.uint32(50).bytes(message.key_hash);
        if (message.deposit != null && Object.hasOwnProperty.call(message, "deposit"))
            writer.uint32(56).uint64(message.deposit);
        if (message.drep != null && Object.hasOwnProperty.call(message, "drep"))
            $root.CardanoDRep.encode(message.drep, writer.uint32(66).fork()).ldelim();
        return writer;
    };

    CardanoTxCertificate.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoTxCertificate.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoTxCertificate();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.type = reader.int32();
                break;
            case 2:
                if (!(message.path && message.path.length))
                    message.path = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.path.push(reader.uint32());
                } else
                    message.path.push(reader.uint32());
                break;
            case 3:
                message.pool = reader.bytes();
                break;
            case 4:
                message.pool_parameters = $root.CardanoPoolParametersType.decode(reader, reader.uint32());
                break;
            case 5:
                message.script_hash = reader.bytes();
                break;
            case 6:
                message.key_hash = reader.bytes();
                break;
            case 7:
                message.deposit = reader.uint64();
                break;
            case 8:
                message.drep = $root.CardanoDRep.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("type"))
            throw $util.ProtocolError("missing required 'type'", { instance: message });
        return message;
    };

    CardanoTxCertificate.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoTxCertificate.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        switch (message.type) {
        default:
            return "type: enum value expected";
        case 0:
        case 1:
        case 2:
        case 3:
        case 7:
        case 8:
        case 9:
            break;
        }
        if (message.path != null && message.hasOwnProperty("path")) {
            if (!Array.isArray(message.path))
                return "path: array expected";
            for (var i = 0; i < message.path.length; ++i)
                if (!$util.isInteger(message.path[i]))
                    return "path: integer[] expected";
        }
        if (message.pool != null && message.hasOwnProperty("pool"))
            if (!(message.pool && typeof message.pool.length === "number" || $util.isString(message.pool)))
                return "pool: buffer expected";
        if (message.pool_parameters != null && message.hasOwnProperty("pool_parameters")) {
            var error = $root.CardanoPoolParametersType.verify(message.pool_parameters);
            if (error)
                return "pool_parameters." + error;
        }
        if (message.script_hash != null && message.hasOwnProperty("script_hash"))
            if (!(message.script_hash && typeof message.script_hash.length === "number" || $util.isString(message.script_hash)))
                return "script_hash: buffer expected";
        if (message.key_hash != null && message.hasOwnProperty("key_hash"))
            if (!(message.key_hash && typeof message.key_hash.length === "number" || $util.isString(message.key_hash)))
                return "key_hash: buffer expected";
        if (message.deposit != null && message.hasOwnProperty("deposit"))
            if (!$util.isInteger(message.deposit) && !(message.deposit && $util.isInteger(message.deposit.low) && $util.isInteger(message.deposit.high)))
                return "deposit: integer|Long expected";
        if (message.drep != null && message.hasOwnProperty("drep")) {
            var error = $root.CardanoDRep.verify(message.drep);
            if (error)
                return "drep." + error;
        }
        return null;
    };

    CardanoTxCertificate.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoTxCertificate)
            return object;
        var message = new $root.CardanoTxCertificate();
        switch (object.type) {
        case "STAKE_REGISTRATION":
        case 0:
            message.type = 0;
            break;
        case "STAKE_DEREGISTRATION":
        case 1:
            message.type = 1;
            break;
        case "STAKE_DELEGATION":
        case 2:
            message.type = 2;
            break;
        case "STAKE_POOL_REGISTRATION":
        case 3:
            message.type = 3;
            break;
        case "STAKE_REGISTRATION_CONWAY":
        case 7:
            message.type = 7;
            break;
        case "STAKE_DEREGISTRATION_CONWAY":
        case 8:
            message.type = 8;
            break;
        case "VOTE_DELEGATION":
        case 9:
            message.type = 9;
            break;
        }
        if (object.path) {
            if (!Array.isArray(object.path))
                throw TypeError(".CardanoTxCertificate.path: array expected");
            message.path = [];
            for (var i = 0; i < object.path.length; ++i)
                message.path[i] = object.path[i] >>> 0;
        }
        if (object.pool != null)
            if (typeof object.pool === "string")
                $util.base64.decode(object.pool, message.pool = $util.newBuffer($util.base64.length(object.pool)), 0);
            else if (object.pool.length)
                message.pool = object.pool;
        if (object.pool_parameters != null) {
            if (typeof object.pool_parameters !== "object")
                throw TypeError(".CardanoTxCertificate.pool_parameters: object expected");
            message.pool_parameters = $root.CardanoPoolParametersType.fromObject(object.pool_parameters);
        }
        if (object.script_hash != null)
            if (typeof object.script_hash === "string")
                $util.base64.decode(object.script_hash, message.script_hash = $util.newBuffer($util.base64.length(object.script_hash)), 0);
            else if (object.script_hash.length)
                message.script_hash = object.script_hash;
        if (object.key_hash != null)
            if (typeof object.key_hash === "string")
                $util.base64.decode(object.key_hash, message.key_hash = $util.newBuffer($util.base64.length(object.key_hash)), 0);
            else if (object.key_hash.length)
                message.key_hash = object.key_hash;
        if (object.deposit != null)
            if ($util.Long)
                (message.deposit = $util.Long.fromValue(object.deposit)).unsigned = true;
            else if (typeof object.deposit === "string")
                message.deposit = parseInt(object.deposit, 10);
            else if (typeof object.deposit === "number")
                message.deposit = object.deposit;
            else if (typeof object.deposit === "object")
                message.deposit = new $util.LongBits(object.deposit.low >>> 0, object.deposit.high >>> 0).toNumber(true);
        if (object.drep != null) {
            if (typeof object.drep !== "object")
                throw TypeError(".CardanoTxCertificate.drep: object expected");
            message.drep = $root.CardanoDRep.fromObject(object.drep);
        }
        return message;
    };

    CardanoTxCertificate.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.path = [];
        if (options.defaults) {
            object.type = options.enums === String ? "STAKE_REGISTRATION" : 0;
            if (options.bytes === String)
                object.pool = "";
            else {
                object.pool = [];
                if (options.bytes !== Array)
                    object.pool = $util.newBuffer(object.pool);
            }
            object.pool_parameters = null;
            if (options.bytes === String)
                object.script_hash = "";
            else {
                object.script_hash = [];
                if (options.bytes !== Array)
                    object.script_hash = $util.newBuffer(object.script_hash);
            }
            if (options.bytes === String)
                object.key_hash = "";
            else {
                object.key_hash = [];
                if (options.bytes !== Array)
                    object.key_hash = $util.newBuffer(object.key_hash);
            }
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.deposit = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.deposit = options.longs === String ? "0" : 0;
            object.drep = null;
        }
        if (message.type != null && message.hasOwnProperty("type"))
            object.type = options.enums === String ? $root.CardanoCertificateType[message.type] : message.type;
        if (message.path && message.path.length) {
            object.path = [];
            for (var j = 0; j < message.path.length; ++j)
                object.path[j] = message.path[j];
        }
        if (message.pool != null && message.hasOwnProperty("pool"))
            object.pool = options.bytes === String ? $util.base64.encode(message.pool, 0, message.pool.length) : options.bytes === Array ? Array.prototype.slice.call(message.pool) : message.pool;
        if (message.pool_parameters != null && message.hasOwnProperty("pool_parameters"))
            object.pool_parameters = $root.CardanoPoolParametersType.toObject(message.pool_parameters, options);
        if (message.script_hash != null && message.hasOwnProperty("script_hash"))
            object.script_hash = options.bytes === String ? $util.base64.encode(message.script_hash, 0, message.script_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.script_hash) : message.script_hash;
        if (message.key_hash != null && message.hasOwnProperty("key_hash"))
            object.key_hash = options.bytes === String ? $util.base64.encode(message.key_hash, 0, message.key_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.key_hash) : message.key_hash;
        if (message.deposit != null && message.hasOwnProperty("deposit"))
            if (typeof message.deposit === "number")
                object.deposit = options.longs === String ? String(message.deposit) : message.deposit;
            else
                object.deposit = options.longs === String ? $util.Long.prototype.toString.call(message.deposit) : options.longs === Number ? new $util.LongBits(message.deposit.low >>> 0, message.deposit.high >>> 0).toNumber(true) : message.deposit;
        if (message.drep != null && message.hasOwnProperty("drep"))
            object.drep = $root.CardanoDRep.toObject(message.drep, options);
        return object;
    };

    CardanoTxCertificate.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoTxCertificate;
})();

$root.CardanoTxWithdrawal = (function() {

    function CardanoTxWithdrawal(properties) {
        this.path = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoTxWithdrawal.prototype.path = $util.emptyArray;
    CardanoTxWithdrawal.prototype.amount = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    CardanoTxWithdrawal.prototype.script_hash = $util.newBuffer([]);
    CardanoTxWithdrawal.prototype.key_hash = $util.newBuffer([]);

    CardanoTxWithdrawal.create = function create(properties) {
        return new CardanoTxWithdrawal(properties);
    };

    CardanoTxWithdrawal.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.path != null && message.path.length)
            for (var i = 0; i < message.path.length; ++i)
                writer.uint32(8).uint32(message.path[i]);
        writer.uint32(16).uint64(message.amount);
        if (message.script_hash != null && Object.hasOwnProperty.call(message, "script_hash"))
            writer.uint32(26).bytes(message.script_hash);
        if (message.key_hash != null && Object.hasOwnProperty.call(message, "key_hash"))
            writer.uint32(34).bytes(message.key_hash);
        return writer;
    };

    CardanoTxWithdrawal.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoTxWithdrawal.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoTxWithdrawal();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.path && message.path.length))
                    message.path = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.path.push(reader.uint32());
                } else
                    message.path.push(reader.uint32());
                break;
            case 2:
                message.amount = reader.uint64();
                break;
            case 3:
                message.script_hash = reader.bytes();
                break;
            case 4:
                message.key_hash = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("amount"))
            throw $util.ProtocolError("missing required 'amount'", { instance: message });
        return message;
    };

    CardanoTxWithdrawal.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoTxWithdrawal.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.path != null && message.hasOwnProperty("path")) {
            if (!Array.isArray(message.path))
                return "path: array expected";
            for (var i = 0; i < message.path.length; ++i)
                if (!$util.isInteger(message.path[i]))
                    return "path: integer[] expected";
        }
        if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
            return "amount: integer|Long expected";
        if (message.script_hash != null && message.hasOwnProperty("script_hash"))
            if (!(message.script_hash && typeof message.script_hash.length === "number" || $util.isString(message.script_hash)))
                return "script_hash: buffer expected";
        if (message.key_hash != null && message.hasOwnProperty("key_hash"))
            if (!(message.key_hash && typeof message.key_hash.length === "number" || $util.isString(message.key_hash)))
                return "key_hash: buffer expected";
        return null;
    };

    CardanoTxWithdrawal.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoTxWithdrawal)
            return object;
        var message = new $root.CardanoTxWithdrawal();
        if (object.path) {
            if (!Array.isArray(object.path))
                throw TypeError(".CardanoTxWithdrawal.path: array expected");
            message.path = [];
            for (var i = 0; i < object.path.length; ++i)
                message.path[i] = object.path[i] >>> 0;
        }
        if (object.amount != null)
            if ($util.Long)
                (message.amount = $util.Long.fromValue(object.amount)).unsigned = true;
            else if (typeof object.amount === "string")
                message.amount = parseInt(object.amount, 10);
            else if (typeof object.amount === "number")
                message.amount = object.amount;
            else if (typeof object.amount === "object")
                message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber(true);
        if (object.script_hash != null)
            if (typeof object.script_hash === "string")
                $util.base64.decode(object.script_hash, message.script_hash = $util.newBuffer($util.base64.length(object.script_hash)), 0);
            else if (object.script_hash.length)
                message.script_hash = object.script_hash;
        if (object.key_hash != null)
            if (typeof object.key_hash === "string")
                $util.base64.decode(object.key_hash, message.key_hash = $util.newBuffer($util.base64.length(object.key_hash)), 0);
            else if (object.key_hash.length)
                message.key_hash = object.key_hash;
        return message;
    };

    CardanoTxWithdrawal.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.path = [];
        if (options.defaults) {
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.amount = options.longs === String ? "0" : 0;
            if (options.bytes === String)
                object.script_hash = "";
            else {
                object.script_hash = [];
                if (options.bytes !== Array)
                    object.script_hash = $util.newBuffer(object.script_hash);
            }
            if (options.bytes === String)
                object.key_hash = "";
            else {
                object.key_hash = [];
                if (options.bytes !== Array)
                    object.key_hash = $util.newBuffer(object.key_hash);
            }
        }
        if (message.path && message.path.length) {
            object.path = [];
            for (var j = 0; j < message.path.length; ++j)
                object.path[j] = message.path[j];
        }
        if (message.amount != null && message.hasOwnProperty("amount"))
            if (typeof message.amount === "number")
                object.amount = options.longs === String ? String(message.amount) : message.amount;
            else
                object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber(true) : message.amount;
        if (message.script_hash != null && message.hasOwnProperty("script_hash"))
            object.script_hash = options.bytes === String ? $util.base64.encode(message.script_hash, 0, message.script_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.script_hash) : message.script_hash;
        if (message.key_hash != null && message.hasOwnProperty("key_hash"))
            object.key_hash = options.bytes === String ? $util.base64.encode(message.key_hash, 0, message.key_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.key_hash) : message.key_hash;
        return object;
    };

    CardanoTxWithdrawal.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoTxWithdrawal;
})();

$root.CardanoCVoteRegistrationDelegation = (function() {

    function CardanoCVoteRegistrationDelegation(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoCVoteRegistrationDelegation.prototype.vote_public_key = $util.newBuffer([]);
    CardanoCVoteRegistrationDelegation.prototype.weight = 0;

    CardanoCVoteRegistrationDelegation.create = function create(properties) {
        return new CardanoCVoteRegistrationDelegation(properties);
    };

    CardanoCVoteRegistrationDelegation.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.vote_public_key);
        writer.uint32(16).uint32(message.weight);
        return writer;
    };

    CardanoCVoteRegistrationDelegation.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoCVoteRegistrationDelegation.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoCVoteRegistrationDelegation();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.vote_public_key = reader.bytes();
                break;
            case 2:
                message.weight = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("vote_public_key"))
            throw $util.ProtocolError("missing required 'vote_public_key'", { instance: message });
        if (!message.hasOwnProperty("weight"))
            throw $util.ProtocolError("missing required 'weight'", { instance: message });
        return message;
    };

    CardanoCVoteRegistrationDelegation.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoCVoteRegistrationDelegation.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.vote_public_key && typeof message.vote_public_key.length === "number" || $util.isString(message.vote_public_key)))
            return "vote_public_key: buffer expected";
        if (!$util.isInteger(message.weight))
            return "weight: integer expected";
        return null;
    };

    CardanoCVoteRegistrationDelegation.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoCVoteRegistrationDelegation)
            return object;
        var message = new $root.CardanoCVoteRegistrationDelegation();
        if (object.vote_public_key != null)
            if (typeof object.vote_public_key === "string")
                $util.base64.decode(object.vote_public_key, message.vote_public_key = $util.newBuffer($util.base64.length(object.vote_public_key)), 0);
            else if (object.vote_public_key.length)
                message.vote_public_key = object.vote_public_key;
        if (object.weight != null)
            message.weight = object.weight >>> 0;
        return message;
    };

    CardanoCVoteRegistrationDelegation.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.vote_public_key = "";
            else {
                object.vote_public_key = [];
                if (options.bytes !== Array)
                    object.vote_public_key = $util.newBuffer(object.vote_public_key);
            }
            object.weight = 0;
        }
        if (message.vote_public_key != null && message.hasOwnProperty("vote_public_key"))
            object.vote_public_key = options.bytes === String ? $util.base64.encode(message.vote_public_key, 0, message.vote_public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.vote_public_key) : message.vote_public_key;
        if (message.weight != null && message.hasOwnProperty("weight"))
            object.weight = message.weight;
        return object;
    };

    CardanoCVoteRegistrationDelegation.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoCVoteRegistrationDelegation;
})();

$root.CardanoCVoteRegistrationParametersType = (function() {

    function CardanoCVoteRegistrationParametersType(properties) {
        this.staking_path = [];
        this.delegations = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoCVoteRegistrationParametersType.prototype.vote_public_key = $util.newBuffer([]);
    CardanoCVoteRegistrationParametersType.prototype.staking_path = $util.emptyArray;
    CardanoCVoteRegistrationParametersType.prototype.payment_address_parameters = null;
    CardanoCVoteRegistrationParametersType.prototype.nonce = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    CardanoCVoteRegistrationParametersType.prototype.format = 0;
    CardanoCVoteRegistrationParametersType.prototype.delegations = $util.emptyArray;
    CardanoCVoteRegistrationParametersType.prototype.voting_purpose = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    CardanoCVoteRegistrationParametersType.prototype.payment_address = "";

    CardanoCVoteRegistrationParametersType.create = function create(properties) {
        return new CardanoCVoteRegistrationParametersType(properties);
    };

    CardanoCVoteRegistrationParametersType.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.vote_public_key != null && Object.hasOwnProperty.call(message, "vote_public_key"))
            writer.uint32(10).bytes(message.vote_public_key);
        if (message.staking_path != null && message.staking_path.length)
            for (var i = 0; i < message.staking_path.length; ++i)
                writer.uint32(16).uint32(message.staking_path[i]);
        if (message.payment_address_parameters != null && Object.hasOwnProperty.call(message, "payment_address_parameters"))
            $root.CardanoAddressParametersType.encode(message.payment_address_parameters, writer.uint32(26).fork()).ldelim();
        writer.uint32(32).uint64(message.nonce);
        if (message.format != null && Object.hasOwnProperty.call(message, "format"))
            writer.uint32(40).int32(message.format);
        if (message.delegations != null && message.delegations.length)
            for (var i = 0; i < message.delegations.length; ++i)
                $root.CardanoCVoteRegistrationDelegation.encode(message.delegations[i], writer.uint32(50).fork()).ldelim();
        if (message.voting_purpose != null && Object.hasOwnProperty.call(message, "voting_purpose"))
            writer.uint32(56).uint64(message.voting_purpose);
        if (message.payment_address != null && Object.hasOwnProperty.call(message, "payment_address"))
            writer.uint32(66).string(message.payment_address);
        return writer;
    };

    CardanoCVoteRegistrationParametersType.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoCVoteRegistrationParametersType.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoCVoteRegistrationParametersType();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.vote_public_key = reader.bytes();
                break;
            case 2:
                if (!(message.staking_path && message.staking_path.length))
                    message.staking_path = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.staking_path.push(reader.uint32());
                } else
                    message.staking_path.push(reader.uint32());
                break;
            case 3:
                message.payment_address_parameters = $root.CardanoAddressParametersType.decode(reader, reader.uint32());
                break;
            case 4:
                message.nonce = reader.uint64();
                break;
            case 5:
                message.format = reader.int32();
                break;
            case 6:
                if (!(message.delegations && message.delegations.length))
                    message.delegations = [];
                message.delegations.push($root.CardanoCVoteRegistrationDelegation.decode(reader, reader.uint32()));
                break;
            case 7:
                message.voting_purpose = reader.uint64();
                break;
            case 8:
                message.payment_address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("nonce"))
            throw $util.ProtocolError("missing required 'nonce'", { instance: message });
        return message;
    };

    CardanoCVoteRegistrationParametersType.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoCVoteRegistrationParametersType.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.vote_public_key != null && message.hasOwnProperty("vote_public_key"))
            if (!(message.vote_public_key && typeof message.vote_public_key.length === "number" || $util.isString(message.vote_public_key)))
                return "vote_public_key: buffer expected";
        if (message.staking_path != null && message.hasOwnProperty("staking_path")) {
            if (!Array.isArray(message.staking_path))
                return "staking_path: array expected";
            for (var i = 0; i < message.staking_path.length; ++i)
                if (!$util.isInteger(message.staking_path[i]))
                    return "staking_path: integer[] expected";
        }
        if (message.payment_address_parameters != null && message.hasOwnProperty("payment_address_parameters")) {
            var error = $root.CardanoAddressParametersType.verify(message.payment_address_parameters);
            if (error)
                return "payment_address_parameters." + error;
        }
        if (!$util.isInteger(message.nonce) && !(message.nonce && $util.isInteger(message.nonce.low) && $util.isInteger(message.nonce.high)))
            return "nonce: integer|Long expected";
        if (message.format != null && message.hasOwnProperty("format"))
            switch (message.format) {
            default:
                return "format: enum value expected";
            case 0:
            case 1:
                break;
            }
        if (message.delegations != null && message.hasOwnProperty("delegations")) {
            if (!Array.isArray(message.delegations))
                return "delegations: array expected";
            for (var i = 0; i < message.delegations.length; ++i) {
                var error = $root.CardanoCVoteRegistrationDelegation.verify(message.delegations[i]);
                if (error)
                    return "delegations." + error;
            }
        }
        if (message.voting_purpose != null && message.hasOwnProperty("voting_purpose"))
            if (!$util.isInteger(message.voting_purpose) && !(message.voting_purpose && $util.isInteger(message.voting_purpose.low) && $util.isInteger(message.voting_purpose.high)))
                return "voting_purpose: integer|Long expected";
        if (message.payment_address != null && message.hasOwnProperty("payment_address"))
            if (!$util.isString(message.payment_address))
                return "payment_address: string expected";
        return null;
    };

    CardanoCVoteRegistrationParametersType.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoCVoteRegistrationParametersType)
            return object;
        var message = new $root.CardanoCVoteRegistrationParametersType();
        if (object.vote_public_key != null)
            if (typeof object.vote_public_key === "string")
                $util.base64.decode(object.vote_public_key, message.vote_public_key = $util.newBuffer($util.base64.length(object.vote_public_key)), 0);
            else if (object.vote_public_key.length)
                message.vote_public_key = object.vote_public_key;
        if (object.staking_path) {
            if (!Array.isArray(object.staking_path))
                throw TypeError(".CardanoCVoteRegistrationParametersType.staking_path: array expected");
            message.staking_path = [];
            for (var i = 0; i < object.staking_path.length; ++i)
                message.staking_path[i] = object.staking_path[i] >>> 0;
        }
        if (object.payment_address_parameters != null) {
            if (typeof object.payment_address_parameters !== "object")
                throw TypeError(".CardanoCVoteRegistrationParametersType.payment_address_parameters: object expected");
            message.payment_address_parameters = $root.CardanoAddressParametersType.fromObject(object.payment_address_parameters);
        }
        if (object.nonce != null)
            if ($util.Long)
                (message.nonce = $util.Long.fromValue(object.nonce)).unsigned = true;
            else if (typeof object.nonce === "string")
                message.nonce = parseInt(object.nonce, 10);
            else if (typeof object.nonce === "number")
                message.nonce = object.nonce;
            else if (typeof object.nonce === "object")
                message.nonce = new $util.LongBits(object.nonce.low >>> 0, object.nonce.high >>> 0).toNumber(true);
        switch (object.format) {
        case "CIP15":
        case 0:
            message.format = 0;
            break;
        case "CIP36":
        case 1:
            message.format = 1;
            break;
        }
        if (object.delegations) {
            if (!Array.isArray(object.delegations))
                throw TypeError(".CardanoCVoteRegistrationParametersType.delegations: array expected");
            message.delegations = [];
            for (var i = 0; i < object.delegations.length; ++i) {
                if (typeof object.delegations[i] !== "object")
                    throw TypeError(".CardanoCVoteRegistrationParametersType.delegations: object expected");
                message.delegations[i] = $root.CardanoCVoteRegistrationDelegation.fromObject(object.delegations[i]);
            }
        }
        if (object.voting_purpose != null)
            if ($util.Long)
                (message.voting_purpose = $util.Long.fromValue(object.voting_purpose)).unsigned = true;
            else if (typeof object.voting_purpose === "string")
                message.voting_purpose = parseInt(object.voting_purpose, 10);
            else if (typeof object.voting_purpose === "number")
                message.voting_purpose = object.voting_purpose;
            else if (typeof object.voting_purpose === "object")
                message.voting_purpose = new $util.LongBits(object.voting_purpose.low >>> 0, object.voting_purpose.high >>> 0).toNumber(true);
        if (object.payment_address != null)
            message.payment_address = String(object.payment_address);
        return message;
    };

    CardanoCVoteRegistrationParametersType.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults) {
            object.staking_path = [];
            object.delegations = [];
        }
        if (options.defaults) {
            if (options.bytes === String)
                object.vote_public_key = "";
            else {
                object.vote_public_key = [];
                if (options.bytes !== Array)
                    object.vote_public_key = $util.newBuffer(object.vote_public_key);
            }
            object.payment_address_parameters = null;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.nonce = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.nonce = options.longs === String ? "0" : 0;
            object.format = options.enums === String ? "CIP15" : 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.voting_purpose = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.voting_purpose = options.longs === String ? "0" : 0;
            object.payment_address = "";
        }
        if (message.vote_public_key != null && message.hasOwnProperty("vote_public_key"))
            object.vote_public_key = options.bytes === String ? $util.base64.encode(message.vote_public_key, 0, message.vote_public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.vote_public_key) : message.vote_public_key;
        if (message.staking_path && message.staking_path.length) {
            object.staking_path = [];
            for (var j = 0; j < message.staking_path.length; ++j)
                object.staking_path[j] = message.staking_path[j];
        }
        if (message.payment_address_parameters != null && message.hasOwnProperty("payment_address_parameters"))
            object.payment_address_parameters = $root.CardanoAddressParametersType.toObject(message.payment_address_parameters, options);
        if (message.nonce != null && message.hasOwnProperty("nonce"))
            if (typeof message.nonce === "number")
                object.nonce = options.longs === String ? String(message.nonce) : message.nonce;
            else
                object.nonce = options.longs === String ? $util.Long.prototype.toString.call(message.nonce) : options.longs === Number ? new $util.LongBits(message.nonce.low >>> 0, message.nonce.high >>> 0).toNumber(true) : message.nonce;
        if (message.format != null && message.hasOwnProperty("format"))
            object.format = options.enums === String ? $root.CardanoCVoteRegistrationFormat[message.format] : message.format;
        if (message.delegations && message.delegations.length) {
            object.delegations = [];
            for (var j = 0; j < message.delegations.length; ++j)
                object.delegations[j] = $root.CardanoCVoteRegistrationDelegation.toObject(message.delegations[j], options);
        }
        if (message.voting_purpose != null && message.hasOwnProperty("voting_purpose"))
            if (typeof message.voting_purpose === "number")
                object.voting_purpose = options.longs === String ? String(message.voting_purpose) : message.voting_purpose;
            else
                object.voting_purpose = options.longs === String ? $util.Long.prototype.toString.call(message.voting_purpose) : options.longs === Number ? new $util.LongBits(message.voting_purpose.low >>> 0, message.voting_purpose.high >>> 0).toNumber(true) : message.voting_purpose;
        if (message.payment_address != null && message.hasOwnProperty("payment_address"))
            object.payment_address = message.payment_address;
        return object;
    };

    CardanoCVoteRegistrationParametersType.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoCVoteRegistrationParametersType;
})();

$root.CardanoTxAuxiliaryData = (function() {

    function CardanoTxAuxiliaryData(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoTxAuxiliaryData.prototype.cvote_registration_parameters = null;
    CardanoTxAuxiliaryData.prototype.hash = $util.newBuffer([]);

    CardanoTxAuxiliaryData.create = function create(properties) {
        return new CardanoTxAuxiliaryData(properties);
    };

    CardanoTxAuxiliaryData.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.cvote_registration_parameters != null && Object.hasOwnProperty.call(message, "cvote_registration_parameters"))
            $root.CardanoCVoteRegistrationParametersType.encode(message.cvote_registration_parameters, writer.uint32(10).fork()).ldelim();
        if (message.hash != null && Object.hasOwnProperty.call(message, "hash"))
            writer.uint32(18).bytes(message.hash);
        return writer;
    };

    CardanoTxAuxiliaryData.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoTxAuxiliaryData.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoTxAuxiliaryData();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.cvote_registration_parameters = $root.CardanoCVoteRegistrationParametersType.decode(reader, reader.uint32());
                break;
            case 2:
                message.hash = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    CardanoTxAuxiliaryData.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoTxAuxiliaryData.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.cvote_registration_parameters != null && message.hasOwnProperty("cvote_registration_parameters")) {
            var error = $root.CardanoCVoteRegistrationParametersType.verify(message.cvote_registration_parameters);
            if (error)
                return "cvote_registration_parameters." + error;
        }
        if (message.hash != null && message.hasOwnProperty("hash"))
            if (!(message.hash && typeof message.hash.length === "number" || $util.isString(message.hash)))
                return "hash: buffer expected";
        return null;
    };

    CardanoTxAuxiliaryData.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoTxAuxiliaryData)
            return object;
        var message = new $root.CardanoTxAuxiliaryData();
        if (object.cvote_registration_parameters != null) {
            if (typeof object.cvote_registration_parameters !== "object")
                throw TypeError(".CardanoTxAuxiliaryData.cvote_registration_parameters: object expected");
            message.cvote_registration_parameters = $root.CardanoCVoteRegistrationParametersType.fromObject(object.cvote_registration_parameters);
        }
        if (object.hash != null)
            if (typeof object.hash === "string")
                $util.base64.decode(object.hash, message.hash = $util.newBuffer($util.base64.length(object.hash)), 0);
            else if (object.hash.length)
                message.hash = object.hash;
        return message;
    };

    CardanoTxAuxiliaryData.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.cvote_registration_parameters = null;
            if (options.bytes === String)
                object.hash = "";
            else {
                object.hash = [];
                if (options.bytes !== Array)
                    object.hash = $util.newBuffer(object.hash);
            }
        }
        if (message.cvote_registration_parameters != null && message.hasOwnProperty("cvote_registration_parameters"))
            object.cvote_registration_parameters = $root.CardanoCVoteRegistrationParametersType.toObject(message.cvote_registration_parameters, options);
        if (message.hash != null && message.hasOwnProperty("hash"))
            object.hash = options.bytes === String ? $util.base64.encode(message.hash, 0, message.hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.hash) : message.hash;
        return object;
    };

    CardanoTxAuxiliaryData.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoTxAuxiliaryData;
})();

$root.CardanoTxMint = (function() {

    function CardanoTxMint(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoTxMint.prototype.asset_groups_count = 0;

    CardanoTxMint.create = function create(properties) {
        return new CardanoTxMint(properties);
    };

    CardanoTxMint.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).uint32(message.asset_groups_count);
        return writer;
    };

    CardanoTxMint.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoTxMint.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoTxMint();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.asset_groups_count = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("asset_groups_count"))
            throw $util.ProtocolError("missing required 'asset_groups_count'", { instance: message });
        return message;
    };

    CardanoTxMint.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoTxMint.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isInteger(message.asset_groups_count))
            return "asset_groups_count: integer expected";
        return null;
    };

    CardanoTxMint.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoTxMint)
            return object;
        var message = new $root.CardanoTxMint();
        if (object.asset_groups_count != null)
            message.asset_groups_count = object.asset_groups_count >>> 0;
        return message;
    };

    CardanoTxMint.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.asset_groups_count = 0;
        if (message.asset_groups_count != null && message.hasOwnProperty("asset_groups_count"))
            object.asset_groups_count = message.asset_groups_count;
        return object;
    };

    CardanoTxMint.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoTxMint;
})();

$root.CardanoTxCollateralInput = (function() {

    function CardanoTxCollateralInput(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoTxCollateralInput.prototype.prev_hash = $util.newBuffer([]);
    CardanoTxCollateralInput.prototype.prev_index = 0;

    CardanoTxCollateralInput.create = function create(properties) {
        return new CardanoTxCollateralInput(properties);
    };

    CardanoTxCollateralInput.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.prev_hash);
        writer.uint32(16).uint32(message.prev_index);
        return writer;
    };

    CardanoTxCollateralInput.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoTxCollateralInput.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoTxCollateralInput();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.prev_hash = reader.bytes();
                break;
            case 2:
                message.prev_index = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("prev_hash"))
            throw $util.ProtocolError("missing required 'prev_hash'", { instance: message });
        if (!message.hasOwnProperty("prev_index"))
            throw $util.ProtocolError("missing required 'prev_index'", { instance: message });
        return message;
    };

    CardanoTxCollateralInput.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoTxCollateralInput.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.prev_hash && typeof message.prev_hash.length === "number" || $util.isString(message.prev_hash)))
            return "prev_hash: buffer expected";
        if (!$util.isInteger(message.prev_index))
            return "prev_index: integer expected";
        return null;
    };

    CardanoTxCollateralInput.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoTxCollateralInput)
            return object;
        var message = new $root.CardanoTxCollateralInput();
        if (object.prev_hash != null)
            if (typeof object.prev_hash === "string")
                $util.base64.decode(object.prev_hash, message.prev_hash = $util.newBuffer($util.base64.length(object.prev_hash)), 0);
            else if (object.prev_hash.length)
                message.prev_hash = object.prev_hash;
        if (object.prev_index != null)
            message.prev_index = object.prev_index >>> 0;
        return message;
    };

    CardanoTxCollateralInput.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.prev_hash = "";
            else {
                object.prev_hash = [];
                if (options.bytes !== Array)
                    object.prev_hash = $util.newBuffer(object.prev_hash);
            }
            object.prev_index = 0;
        }
        if (message.prev_hash != null && message.hasOwnProperty("prev_hash"))
            object.prev_hash = options.bytes === String ? $util.base64.encode(message.prev_hash, 0, message.prev_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.prev_hash) : message.prev_hash;
        if (message.prev_index != null && message.hasOwnProperty("prev_index"))
            object.prev_index = message.prev_index;
        return object;
    };

    CardanoTxCollateralInput.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoTxCollateralInput;
})();

$root.CardanoTxRequiredSigner = (function() {

    function CardanoTxRequiredSigner(properties) {
        this.key_path = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoTxRequiredSigner.prototype.key_hash = $util.newBuffer([]);
    CardanoTxRequiredSigner.prototype.key_path = $util.emptyArray;

    CardanoTxRequiredSigner.create = function create(properties) {
        return new CardanoTxRequiredSigner(properties);
    };

    CardanoTxRequiredSigner.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.key_hash != null && Object.hasOwnProperty.call(message, "key_hash"))
            writer.uint32(10).bytes(message.key_hash);
        if (message.key_path != null && message.key_path.length)
            for (var i = 0; i < message.key_path.length; ++i)
                writer.uint32(16).uint32(message.key_path[i]);
        return writer;
    };

    CardanoTxRequiredSigner.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoTxRequiredSigner.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoTxRequiredSigner();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.key_hash = reader.bytes();
                break;
            case 2:
                if (!(message.key_path && message.key_path.length))
                    message.key_path = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.key_path.push(reader.uint32());
                } else
                    message.key_path.push(reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    CardanoTxRequiredSigner.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoTxRequiredSigner.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.key_hash != null && message.hasOwnProperty("key_hash"))
            if (!(message.key_hash && typeof message.key_hash.length === "number" || $util.isString(message.key_hash)))
                return "key_hash: buffer expected";
        if (message.key_path != null && message.hasOwnProperty("key_path")) {
            if (!Array.isArray(message.key_path))
                return "key_path: array expected";
            for (var i = 0; i < message.key_path.length; ++i)
                if (!$util.isInteger(message.key_path[i]))
                    return "key_path: integer[] expected";
        }
        return null;
    };

    CardanoTxRequiredSigner.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoTxRequiredSigner)
            return object;
        var message = new $root.CardanoTxRequiredSigner();
        if (object.key_hash != null)
            if (typeof object.key_hash === "string")
                $util.base64.decode(object.key_hash, message.key_hash = $util.newBuffer($util.base64.length(object.key_hash)), 0);
            else if (object.key_hash.length)
                message.key_hash = object.key_hash;
        if (object.key_path) {
            if (!Array.isArray(object.key_path))
                throw TypeError(".CardanoTxRequiredSigner.key_path: array expected");
            message.key_path = [];
            for (var i = 0; i < object.key_path.length; ++i)
                message.key_path[i] = object.key_path[i] >>> 0;
        }
        return message;
    };

    CardanoTxRequiredSigner.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.key_path = [];
        if (options.defaults)
            if (options.bytes === String)
                object.key_hash = "";
            else {
                object.key_hash = [];
                if (options.bytes !== Array)
                    object.key_hash = $util.newBuffer(object.key_hash);
            }
        if (message.key_hash != null && message.hasOwnProperty("key_hash"))
            object.key_hash = options.bytes === String ? $util.base64.encode(message.key_hash, 0, message.key_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.key_hash) : message.key_hash;
        if (message.key_path && message.key_path.length) {
            object.key_path = [];
            for (var j = 0; j < message.key_path.length; ++j)
                object.key_path[j] = message.key_path[j];
        }
        return object;
    };

    CardanoTxRequiredSigner.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoTxRequiredSigner;
})();

$root.CardanoTxReferenceInput = (function() {

    function CardanoTxReferenceInput(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoTxReferenceInput.prototype.prev_hash = $util.newBuffer([]);
    CardanoTxReferenceInput.prototype.prev_index = 0;

    CardanoTxReferenceInput.create = function create(properties) {
        return new CardanoTxReferenceInput(properties);
    };

    CardanoTxReferenceInput.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.prev_hash);
        writer.uint32(16).uint32(message.prev_index);
        return writer;
    };

    CardanoTxReferenceInput.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoTxReferenceInput.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoTxReferenceInput();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.prev_hash = reader.bytes();
                break;
            case 2:
                message.prev_index = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("prev_hash"))
            throw $util.ProtocolError("missing required 'prev_hash'", { instance: message });
        if (!message.hasOwnProperty("prev_index"))
            throw $util.ProtocolError("missing required 'prev_index'", { instance: message });
        return message;
    };

    CardanoTxReferenceInput.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoTxReferenceInput.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.prev_hash && typeof message.prev_hash.length === "number" || $util.isString(message.prev_hash)))
            return "prev_hash: buffer expected";
        if (!$util.isInteger(message.prev_index))
            return "prev_index: integer expected";
        return null;
    };

    CardanoTxReferenceInput.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoTxReferenceInput)
            return object;
        var message = new $root.CardanoTxReferenceInput();
        if (object.prev_hash != null)
            if (typeof object.prev_hash === "string")
                $util.base64.decode(object.prev_hash, message.prev_hash = $util.newBuffer($util.base64.length(object.prev_hash)), 0);
            else if (object.prev_hash.length)
                message.prev_hash = object.prev_hash;
        if (object.prev_index != null)
            message.prev_index = object.prev_index >>> 0;
        return message;
    };

    CardanoTxReferenceInput.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.prev_hash = "";
            else {
                object.prev_hash = [];
                if (options.bytes !== Array)
                    object.prev_hash = $util.newBuffer(object.prev_hash);
            }
            object.prev_index = 0;
        }
        if (message.prev_hash != null && message.hasOwnProperty("prev_hash"))
            object.prev_hash = options.bytes === String ? $util.base64.encode(message.prev_hash, 0, message.prev_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.prev_hash) : message.prev_hash;
        if (message.prev_index != null && message.hasOwnProperty("prev_index"))
            object.prev_index = message.prev_index;
        return object;
    };

    CardanoTxReferenceInput.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoTxReferenceInput;
})();

$root.CardanoTxItemAck = (function() {

    function CardanoTxItemAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoTxItemAck.create = function create(properties) {
        return new CardanoTxItemAck(properties);
    };

    CardanoTxItemAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    CardanoTxItemAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoTxItemAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoTxItemAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    CardanoTxItemAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoTxItemAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    CardanoTxItemAck.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoTxItemAck)
            return object;
        return new $root.CardanoTxItemAck();
    };

    CardanoTxItemAck.toObject = function toObject() {
        return {};
    };

    CardanoTxItemAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoTxItemAck;
})();

$root.CardanoTxAuxiliaryDataSupplement = (function() {

    function CardanoTxAuxiliaryDataSupplement(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoTxAuxiliaryDataSupplement.prototype.type = 0;
    CardanoTxAuxiliaryDataSupplement.prototype.auxiliary_data_hash = $util.newBuffer([]);
    CardanoTxAuxiliaryDataSupplement.prototype.cvote_registration_signature = $util.newBuffer([]);

    CardanoTxAuxiliaryDataSupplement.create = function create(properties) {
        return new CardanoTxAuxiliaryDataSupplement(properties);
    };

    CardanoTxAuxiliaryDataSupplement.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).int32(message.type);
        if (message.auxiliary_data_hash != null && Object.hasOwnProperty.call(message, "auxiliary_data_hash"))
            writer.uint32(18).bytes(message.auxiliary_data_hash);
        if (message.cvote_registration_signature != null && Object.hasOwnProperty.call(message, "cvote_registration_signature"))
            writer.uint32(26).bytes(message.cvote_registration_signature);
        return writer;
    };

    CardanoTxAuxiliaryDataSupplement.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoTxAuxiliaryDataSupplement.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoTxAuxiliaryDataSupplement();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.type = reader.int32();
                break;
            case 2:
                message.auxiliary_data_hash = reader.bytes();
                break;
            case 3:
                message.cvote_registration_signature = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("type"))
            throw $util.ProtocolError("missing required 'type'", { instance: message });
        return message;
    };

    CardanoTxAuxiliaryDataSupplement.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoTxAuxiliaryDataSupplement.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        switch (message.type) {
        default:
            return "type: enum value expected";
        case 0:
        case 1:
            break;
        }
        if (message.auxiliary_data_hash != null && message.hasOwnProperty("auxiliary_data_hash"))
            if (!(message.auxiliary_data_hash && typeof message.auxiliary_data_hash.length === "number" || $util.isString(message.auxiliary_data_hash)))
                return "auxiliary_data_hash: buffer expected";
        if (message.cvote_registration_signature != null && message.hasOwnProperty("cvote_registration_signature"))
            if (!(message.cvote_registration_signature && typeof message.cvote_registration_signature.length === "number" || $util.isString(message.cvote_registration_signature)))
                return "cvote_registration_signature: buffer expected";
        return null;
    };

    CardanoTxAuxiliaryDataSupplement.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoTxAuxiliaryDataSupplement)
            return object;
        var message = new $root.CardanoTxAuxiliaryDataSupplement();
        switch (object.type) {
        case "NONE":
        case 0:
            message.type = 0;
            break;
        case "CVOTE_REGISTRATION_SIGNATURE":
        case 1:
            message.type = 1;
            break;
        }
        if (object.auxiliary_data_hash != null)
            if (typeof object.auxiliary_data_hash === "string")
                $util.base64.decode(object.auxiliary_data_hash, message.auxiliary_data_hash = $util.newBuffer($util.base64.length(object.auxiliary_data_hash)), 0);
            else if (object.auxiliary_data_hash.length)
                message.auxiliary_data_hash = object.auxiliary_data_hash;
        if (object.cvote_registration_signature != null)
            if (typeof object.cvote_registration_signature === "string")
                $util.base64.decode(object.cvote_registration_signature, message.cvote_registration_signature = $util.newBuffer($util.base64.length(object.cvote_registration_signature)), 0);
            else if (object.cvote_registration_signature.length)
                message.cvote_registration_signature = object.cvote_registration_signature;
        return message;
    };

    CardanoTxAuxiliaryDataSupplement.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.type = options.enums === String ? "NONE" : 0;
            if (options.bytes === String)
                object.auxiliary_data_hash = "";
            else {
                object.auxiliary_data_hash = [];
                if (options.bytes !== Array)
                    object.auxiliary_data_hash = $util.newBuffer(object.auxiliary_data_hash);
            }
            if (options.bytes === String)
                object.cvote_registration_signature = "";
            else {
                object.cvote_registration_signature = [];
                if (options.bytes !== Array)
                    object.cvote_registration_signature = $util.newBuffer(object.cvote_registration_signature);
            }
        }
        if (message.type != null && message.hasOwnProperty("type"))
            object.type = options.enums === String ? $root.CardanoTxAuxiliaryDataSupplementType[message.type] : message.type;
        if (message.auxiliary_data_hash != null && message.hasOwnProperty("auxiliary_data_hash"))
            object.auxiliary_data_hash = options.bytes === String ? $util.base64.encode(message.auxiliary_data_hash, 0, message.auxiliary_data_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.auxiliary_data_hash) : message.auxiliary_data_hash;
        if (message.cvote_registration_signature != null && message.hasOwnProperty("cvote_registration_signature"))
            object.cvote_registration_signature = options.bytes === String ? $util.base64.encode(message.cvote_registration_signature, 0, message.cvote_registration_signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.cvote_registration_signature) : message.cvote_registration_signature;
        return object;
    };

    CardanoTxAuxiliaryDataSupplement.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoTxAuxiliaryDataSupplement;
})();

$root.CardanoTxWitnessRequest = (function() {

    function CardanoTxWitnessRequest(properties) {
        this.path = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoTxWitnessRequest.prototype.path = $util.emptyArray;

    CardanoTxWitnessRequest.create = function create(properties) {
        return new CardanoTxWitnessRequest(properties);
    };

    CardanoTxWitnessRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.path != null && message.path.length)
            for (var i = 0; i < message.path.length; ++i)
                writer.uint32(8).uint32(message.path[i]);
        return writer;
    };

    CardanoTxWitnessRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoTxWitnessRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoTxWitnessRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.path && message.path.length))
                    message.path = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.path.push(reader.uint32());
                } else
                    message.path.push(reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    CardanoTxWitnessRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoTxWitnessRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.path != null && message.hasOwnProperty("path")) {
            if (!Array.isArray(message.path))
                return "path: array expected";
            for (var i = 0; i < message.path.length; ++i)
                if (!$util.isInteger(message.path[i]))
                    return "path: integer[] expected";
        }
        return null;
    };

    CardanoTxWitnessRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoTxWitnessRequest)
            return object;
        var message = new $root.CardanoTxWitnessRequest();
        if (object.path) {
            if (!Array.isArray(object.path))
                throw TypeError(".CardanoTxWitnessRequest.path: array expected");
            message.path = [];
            for (var i = 0; i < object.path.length; ++i)
                message.path[i] = object.path[i] >>> 0;
        }
        return message;
    };

    CardanoTxWitnessRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.path = [];
        if (message.path && message.path.length) {
            object.path = [];
            for (var j = 0; j < message.path.length; ++j)
                object.path[j] = message.path[j];
        }
        return object;
    };

    CardanoTxWitnessRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoTxWitnessRequest;
})();

$root.CardanoTxWitnessResponse = (function() {

    function CardanoTxWitnessResponse(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoTxWitnessResponse.prototype.type = 0;
    CardanoTxWitnessResponse.prototype.pub_key = $util.newBuffer([]);
    CardanoTxWitnessResponse.prototype.signature = $util.newBuffer([]);
    CardanoTxWitnessResponse.prototype.chain_code = $util.newBuffer([]);

    CardanoTxWitnessResponse.create = function create(properties) {
        return new CardanoTxWitnessResponse(properties);
    };

    CardanoTxWitnessResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).int32(message.type);
        writer.uint32(18).bytes(message.pub_key);
        writer.uint32(26).bytes(message.signature);
        if (message.chain_code != null && Object.hasOwnProperty.call(message, "chain_code"))
            writer.uint32(34).bytes(message.chain_code);
        return writer;
    };

    CardanoTxWitnessResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoTxWitnessResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoTxWitnessResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.type = reader.int32();
                break;
            case 2:
                message.pub_key = reader.bytes();
                break;
            case 3:
                message.signature = reader.bytes();
                break;
            case 4:
                message.chain_code = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("type"))
            throw $util.ProtocolError("missing required 'type'", { instance: message });
        if (!message.hasOwnProperty("pub_key"))
            throw $util.ProtocolError("missing required 'pub_key'", { instance: message });
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        return message;
    };

    CardanoTxWitnessResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoTxWitnessResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        switch (message.type) {
        default:
            return "type: enum value expected";
        case 0:
        case 1:
            break;
        }
        if (!(message.pub_key && typeof message.pub_key.length === "number" || $util.isString(message.pub_key)))
            return "pub_key: buffer expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        if (message.chain_code != null && message.hasOwnProperty("chain_code"))
            if (!(message.chain_code && typeof message.chain_code.length === "number" || $util.isString(message.chain_code)))
                return "chain_code: buffer expected";
        return null;
    };

    CardanoTxWitnessResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoTxWitnessResponse)
            return object;
        var message = new $root.CardanoTxWitnessResponse();
        switch (object.type) {
        case "BYRON_WITNESS":
        case 0:
            message.type = 0;
            break;
        case "SHELLEY_WITNESS":
        case 1:
            message.type = 1;
            break;
        }
        if (object.pub_key != null)
            if (typeof object.pub_key === "string")
                $util.base64.decode(object.pub_key, message.pub_key = $util.newBuffer($util.base64.length(object.pub_key)), 0);
            else if (object.pub_key.length)
                message.pub_key = object.pub_key;
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        if (object.chain_code != null)
            if (typeof object.chain_code === "string")
                $util.base64.decode(object.chain_code, message.chain_code = $util.newBuffer($util.base64.length(object.chain_code)), 0);
            else if (object.chain_code.length)
                message.chain_code = object.chain_code;
        return message;
    };

    CardanoTxWitnessResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.type = options.enums === String ? "BYRON_WITNESS" : 0;
            if (options.bytes === String)
                object.pub_key = "";
            else {
                object.pub_key = [];
                if (options.bytes !== Array)
                    object.pub_key = $util.newBuffer(object.pub_key);
            }
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
            if (options.bytes === String)
                object.chain_code = "";
            else {
                object.chain_code = [];
                if (options.bytes !== Array)
                    object.chain_code = $util.newBuffer(object.chain_code);
            }
        }
        if (message.type != null && message.hasOwnProperty("type"))
            object.type = options.enums === String ? $root.CardanoTxWitnessType[message.type] : message.type;
        if (message.pub_key != null && message.hasOwnProperty("pub_key"))
            object.pub_key = options.bytes === String ? $util.base64.encode(message.pub_key, 0, message.pub_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.pub_key) : message.pub_key;
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        if (message.chain_code != null && message.hasOwnProperty("chain_code"))
            object.chain_code = options.bytes === String ? $util.base64.encode(message.chain_code, 0, message.chain_code.length) : options.bytes === Array ? Array.prototype.slice.call(message.chain_code) : message.chain_code;
        return object;
    };

    CardanoTxWitnessResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoTxWitnessResponse;
})();

$root.CardanoTxHostAck = (function() {

    function CardanoTxHostAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoTxHostAck.create = function create(properties) {
        return new CardanoTxHostAck(properties);
    };

    CardanoTxHostAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    CardanoTxHostAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoTxHostAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoTxHostAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    CardanoTxHostAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoTxHostAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    CardanoTxHostAck.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoTxHostAck)
            return object;
        return new $root.CardanoTxHostAck();
    };

    CardanoTxHostAck.toObject = function toObject() {
        return {};
    };

    CardanoTxHostAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoTxHostAck;
})();

$root.CardanoTxBodyHash = (function() {

    function CardanoTxBodyHash(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoTxBodyHash.prototype.tx_hash = $util.newBuffer([]);

    CardanoTxBodyHash.create = function create(properties) {
        return new CardanoTxBodyHash(properties);
    };

    CardanoTxBodyHash.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.tx_hash);
        return writer;
    };

    CardanoTxBodyHash.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoTxBodyHash.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoTxBodyHash();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.tx_hash = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("tx_hash"))
            throw $util.ProtocolError("missing required 'tx_hash'", { instance: message });
        return message;
    };

    CardanoTxBodyHash.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoTxBodyHash.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.tx_hash && typeof message.tx_hash.length === "number" || $util.isString(message.tx_hash)))
            return "tx_hash: buffer expected";
        return null;
    };

    CardanoTxBodyHash.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoTxBodyHash)
            return object;
        var message = new $root.CardanoTxBodyHash();
        if (object.tx_hash != null)
            if (typeof object.tx_hash === "string")
                $util.base64.decode(object.tx_hash, message.tx_hash = $util.newBuffer($util.base64.length(object.tx_hash)), 0);
            else if (object.tx_hash.length)
                message.tx_hash = object.tx_hash;
        return message;
    };

    CardanoTxBodyHash.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.tx_hash = "";
            else {
                object.tx_hash = [];
                if (options.bytes !== Array)
                    object.tx_hash = $util.newBuffer(object.tx_hash);
            }
        if (message.tx_hash != null && message.hasOwnProperty("tx_hash"))
            object.tx_hash = options.bytes === String ? $util.base64.encode(message.tx_hash, 0, message.tx_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.tx_hash) : message.tx_hash;
        return object;
    };

    CardanoTxBodyHash.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoTxBodyHash;
})();

$root.CardanoSignTxFinished = (function() {

    function CardanoSignTxFinished(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoSignTxFinished.create = function create(properties) {
        return new CardanoSignTxFinished(properties);
    };

    CardanoSignTxFinished.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    CardanoSignTxFinished.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoSignTxFinished.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoSignTxFinished();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    CardanoSignTxFinished.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoSignTxFinished.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    CardanoSignTxFinished.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoSignTxFinished)
            return object;
        return new $root.CardanoSignTxFinished();
    };

    CardanoSignTxFinished.toObject = function toObject() {
        return {};
    };

    CardanoSignTxFinished.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoSignTxFinished;
})();

$root.CardanoSignMessage = (function() {

    function CardanoSignMessage(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoSignMessage.prototype.address_n = $util.emptyArray;
    CardanoSignMessage.prototype.message = $util.newBuffer([]);
    CardanoSignMessage.prototype.derivation_type = 0;
    CardanoSignMessage.prototype.network_id = 0;
    CardanoSignMessage.prototype.address_type = 0;

    CardanoSignMessage.create = function create(properties) {
        return new CardanoSignMessage(properties);
    };

    CardanoSignMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).bytes(message.message);
        writer.uint32(24).int32(message.derivation_type);
        writer.uint32(32).uint32(message.network_id);
        if (message.address_type != null && Object.hasOwnProperty.call(message, "address_type"))
            writer.uint32(40).int32(message.address_type);
        return writer;
    };

    CardanoSignMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoSignMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoSignMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.message = reader.bytes();
                break;
            case 3:
                message.derivation_type = reader.int32();
                break;
            case 4:
                message.network_id = reader.uint32();
                break;
            case 5:
                message.address_type = reader.int32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("message"))
            throw $util.ProtocolError("missing required 'message'", { instance: message });
        if (!message.hasOwnProperty("derivation_type"))
            throw $util.ProtocolError("missing required 'derivation_type'", { instance: message });
        if (!message.hasOwnProperty("network_id"))
            throw $util.ProtocolError("missing required 'network_id'", { instance: message });
        return message;
    };

    CardanoSignMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoSignMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!(message.message && typeof message.message.length === "number" || $util.isString(message.message)))
            return "message: buffer expected";
        switch (message.derivation_type) {
        default:
            return "derivation_type: enum value expected";
        case 0:
        case 1:
        case 2:
            break;
        }
        if (!$util.isInteger(message.network_id))
            return "network_id: integer expected";
        if (message.address_type != null && message.hasOwnProperty("address_type"))
            switch (message.address_type) {
            default:
                return "address_type: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
            case 8:
            case 14:
            case 15:
                break;
            }
        return null;
    };

    CardanoSignMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoSignMessage)
            return object;
        var message = new $root.CardanoSignMessage();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".CardanoSignMessage.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.message != null)
            if (typeof object.message === "string")
                $util.base64.decode(object.message, message.message = $util.newBuffer($util.base64.length(object.message)), 0);
            else if (object.message.length)
                message.message = object.message;
        switch (object.derivation_type) {
        case "LEDGER":
        case 0:
            message.derivation_type = 0;
            break;
        case "ICARUS":
        case 1:
            message.derivation_type = 1;
            break;
        case "ICARUS_TREZOR":
        case 2:
            message.derivation_type = 2;
            break;
        }
        if (object.network_id != null)
            message.network_id = object.network_id >>> 0;
        switch (object.address_type) {
        case "BASE":
        case 0:
            message.address_type = 0;
            break;
        case "BASE_SCRIPT_KEY":
        case 1:
            message.address_type = 1;
            break;
        case "BASE_KEY_SCRIPT":
        case 2:
            message.address_type = 2;
            break;
        case "BASE_SCRIPT_SCRIPT":
        case 3:
            message.address_type = 3;
            break;
        case "POINTER":
        case 4:
            message.address_type = 4;
            break;
        case "POINTER_SCRIPT":
        case 5:
            message.address_type = 5;
            break;
        case "ENTERPRISE":
        case 6:
            message.address_type = 6;
            break;
        case "ENTERPRISE_SCRIPT":
        case 7:
            message.address_type = 7;
            break;
        case "BYRON":
        case 8:
            message.address_type = 8;
            break;
        case "REWARD":
        case 14:
            message.address_type = 14;
            break;
        case "REWARD_SCRIPT":
        case 15:
            message.address_type = 15;
            break;
        }
        return message;
    };

    CardanoSignMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            if (options.bytes === String)
                object.message = "";
            else {
                object.message = [];
                if (options.bytes !== Array)
                    object.message = $util.newBuffer(object.message);
            }
            object.derivation_type = options.enums === String ? "LEDGER" : 0;
            object.network_id = 0;
            object.address_type = options.enums === String ? "BASE" : 0;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.message != null && message.hasOwnProperty("message"))
            object.message = options.bytes === String ? $util.base64.encode(message.message, 0, message.message.length) : options.bytes === Array ? Array.prototype.slice.call(message.message) : message.message;
        if (message.derivation_type != null && message.hasOwnProperty("derivation_type"))
            object.derivation_type = options.enums === String ? $root.CardanoDerivationType[message.derivation_type] : message.derivation_type;
        if (message.network_id != null && message.hasOwnProperty("network_id"))
            object.network_id = message.network_id;
        if (message.address_type != null && message.hasOwnProperty("address_type"))
            object.address_type = options.enums === String ? $root.CardanoAddressType[message.address_type] : message.address_type;
        return object;
    };

    CardanoSignMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoSignMessage;
})();

$root.CardanoMessageSignature = (function() {

    function CardanoMessageSignature(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CardanoMessageSignature.prototype.signature = $util.newBuffer([]);
    CardanoMessageSignature.prototype.key = $util.newBuffer([]);

    CardanoMessageSignature.create = function create(properties) {
        return new CardanoMessageSignature(properties);
    };

    CardanoMessageSignature.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.signature);
        writer.uint32(18).bytes(message.key);
        return writer;
    };

    CardanoMessageSignature.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CardanoMessageSignature.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CardanoMessageSignature();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.signature = reader.bytes();
                break;
            case 2:
                message.key = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        if (!message.hasOwnProperty("key"))
            throw $util.ProtocolError("missing required 'key'", { instance: message });
        return message;
    };

    CardanoMessageSignature.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CardanoMessageSignature.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        if (!(message.key && typeof message.key.length === "number" || $util.isString(message.key)))
            return "key: buffer expected";
        return null;
    };

    CardanoMessageSignature.fromObject = function fromObject(object) {
        if (object instanceof $root.CardanoMessageSignature)
            return object;
        var message = new $root.CardanoMessageSignature();
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        if (object.key != null)
            if (typeof object.key === "string")
                $util.base64.decode(object.key, message.key = $util.newBuffer($util.base64.length(object.key)), 0);
            else if (object.key.length)
                message.key = object.key;
        return message;
    };

    CardanoMessageSignature.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
            if (options.bytes === String)
                object.key = "";
            else {
                object.key = [];
                if (options.bytes !== Array)
                    object.key = $util.newBuffer(object.key);
            }
        }
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        if (message.key != null && message.hasOwnProperty("key"))
            object.key = options.bytes === String ? $util.base64.encode(message.key, 0, message.key.length) : options.bytes === Array ? Array.prototype.slice.call(message.key) : message.key;
        return object;
    };

    CardanoMessageSignature.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CardanoMessageSignature;
})();

$root.ConfluxGetAddress = (function() {

    function ConfluxGetAddress(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ConfluxGetAddress.prototype.address_n = $util.emptyArray;
    ConfluxGetAddress.prototype.show_display = false;
    ConfluxGetAddress.prototype.chain_id = 0;

    ConfluxGetAddress.create = function create(properties) {
        return new ConfluxGetAddress(properties);
    };

    ConfluxGetAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(16).bool(message.show_display);
        if (message.chain_id != null && Object.hasOwnProperty.call(message, "chain_id"))
            writer.uint32(24).uint32(message.chain_id);
        return writer;
    };

    ConfluxGetAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ConfluxGetAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ConfluxGetAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.show_display = reader.bool();
                break;
            case 3:
                message.chain_id = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    ConfluxGetAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ConfluxGetAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        if (message.chain_id != null && message.hasOwnProperty("chain_id"))
            if (!$util.isInteger(message.chain_id))
                return "chain_id: integer expected";
        return null;
    };

    ConfluxGetAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.ConfluxGetAddress)
            return object;
        var message = new $root.ConfluxGetAddress();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".ConfluxGetAddress.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        if (object.chain_id != null)
            message.chain_id = object.chain_id >>> 0;
        return message;
    };

    ConfluxGetAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            object.show_display = false;
            object.chain_id = 0;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        if (message.chain_id != null && message.hasOwnProperty("chain_id"))
            object.chain_id = message.chain_id;
        return object;
    };

    ConfluxGetAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ConfluxGetAddress;
})();

$root.ConfluxAddress = (function() {

    function ConfluxAddress(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ConfluxAddress.prototype.address = "";

    ConfluxAddress.create = function create(properties) {
        return new ConfluxAddress(properties);
    };

    ConfluxAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address != null && Object.hasOwnProperty.call(message, "address"))
            writer.uint32(10).string(message.address);
        return writer;
    };

    ConfluxAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ConfluxAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ConfluxAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    ConfluxAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ConfluxAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address != null && message.hasOwnProperty("address"))
            if (!$util.isString(message.address))
                return "address: string expected";
        return null;
    };

    ConfluxAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.ConfluxAddress)
            return object;
        var message = new $root.ConfluxAddress();
        if (object.address != null)
            message.address = String(object.address);
        return message;
    };

    ConfluxAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.address = "";
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    ConfluxAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ConfluxAddress;
})();

$root.ConfluxSignTx = (function() {

    function ConfluxSignTx(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ConfluxSignTx.prototype.address_n = $util.emptyArray;
    ConfluxSignTx.prototype.nonce = $util.newBuffer([]);
    ConfluxSignTx.prototype.gas_price = $util.newBuffer([]);
    ConfluxSignTx.prototype.gas_limit = $util.newBuffer([]);
    ConfluxSignTx.prototype.to = "";
    ConfluxSignTx.prototype.value = $util.newBuffer([]);
    ConfluxSignTx.prototype.epoch_height = $util.newBuffer([]);
    ConfluxSignTx.prototype.storage_limit = $util.newBuffer([]);
    ConfluxSignTx.prototype.data_initial_chunk = $util.newBuffer([]);
    ConfluxSignTx.prototype.data_length = 0;
    ConfluxSignTx.prototype.chain_id = 1029;

    ConfluxSignTx.create = function create(properties) {
        return new ConfluxSignTx(properties);
    };

    ConfluxSignTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).bytes(message.nonce);
        writer.uint32(26).bytes(message.gas_price);
        writer.uint32(34).bytes(message.gas_limit);
        if (message.to != null && Object.hasOwnProperty.call(message, "to"))
            writer.uint32(42).string(message.to);
        if (message.value != null && Object.hasOwnProperty.call(message, "value"))
            writer.uint32(50).bytes(message.value);
        if (message.epoch_height != null && Object.hasOwnProperty.call(message, "epoch_height"))
            writer.uint32(58).bytes(message.epoch_height);
        if (message.storage_limit != null && Object.hasOwnProperty.call(message, "storage_limit"))
            writer.uint32(66).bytes(message.storage_limit);
        if (message.data_initial_chunk != null && Object.hasOwnProperty.call(message, "data_initial_chunk"))
            writer.uint32(74).bytes(message.data_initial_chunk);
        if (message.data_length != null && Object.hasOwnProperty.call(message, "data_length"))
            writer.uint32(80).uint32(message.data_length);
        if (message.chain_id != null && Object.hasOwnProperty.call(message, "chain_id"))
            writer.uint32(88).uint32(message.chain_id);
        return writer;
    };

    ConfluxSignTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ConfluxSignTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ConfluxSignTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.nonce = reader.bytes();
                break;
            case 3:
                message.gas_price = reader.bytes();
                break;
            case 4:
                message.gas_limit = reader.bytes();
                break;
            case 5:
                message.to = reader.string();
                break;
            case 6:
                message.value = reader.bytes();
                break;
            case 7:
                message.epoch_height = reader.bytes();
                break;
            case 8:
                message.storage_limit = reader.bytes();
                break;
            case 9:
                message.data_initial_chunk = reader.bytes();
                break;
            case 10:
                message.data_length = reader.uint32();
                break;
            case 11:
                message.chain_id = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("nonce"))
            throw $util.ProtocolError("missing required 'nonce'", { instance: message });
        if (!message.hasOwnProperty("gas_price"))
            throw $util.ProtocolError("missing required 'gas_price'", { instance: message });
        if (!message.hasOwnProperty("gas_limit"))
            throw $util.ProtocolError("missing required 'gas_limit'", { instance: message });
        return message;
    };

    ConfluxSignTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ConfluxSignTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!(message.nonce && typeof message.nonce.length === "number" || $util.isString(message.nonce)))
            return "nonce: buffer expected";
        if (!(message.gas_price && typeof message.gas_price.length === "number" || $util.isString(message.gas_price)))
            return "gas_price: buffer expected";
        if (!(message.gas_limit && typeof message.gas_limit.length === "number" || $util.isString(message.gas_limit)))
            return "gas_limit: buffer expected";
        if (message.to != null && message.hasOwnProperty("to"))
            if (!$util.isString(message.to))
                return "to: string expected";
        if (message.value != null && message.hasOwnProperty("value"))
            if (!(message.value && typeof message.value.length === "number" || $util.isString(message.value)))
                return "value: buffer expected";
        if (message.epoch_height != null && message.hasOwnProperty("epoch_height"))
            if (!(message.epoch_height && typeof message.epoch_height.length === "number" || $util.isString(message.epoch_height)))
                return "epoch_height: buffer expected";
        if (message.storage_limit != null && message.hasOwnProperty("storage_limit"))
            if (!(message.storage_limit && typeof message.storage_limit.length === "number" || $util.isString(message.storage_limit)))
                return "storage_limit: buffer expected";
        if (message.data_initial_chunk != null && message.hasOwnProperty("data_initial_chunk"))
            if (!(message.data_initial_chunk && typeof message.data_initial_chunk.length === "number" || $util.isString(message.data_initial_chunk)))
                return "data_initial_chunk: buffer expected";
        if (message.data_length != null && message.hasOwnProperty("data_length"))
            if (!$util.isInteger(message.data_length))
                return "data_length: integer expected";
        if (message.chain_id != null && message.hasOwnProperty("chain_id"))
            if (!$util.isInteger(message.chain_id))
                return "chain_id: integer expected";
        return null;
    };

    ConfluxSignTx.fromObject = function fromObject(object) {
        if (object instanceof $root.ConfluxSignTx)
            return object;
        var message = new $root.ConfluxSignTx();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".ConfluxSignTx.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.nonce != null)
            if (typeof object.nonce === "string")
                $util.base64.decode(object.nonce, message.nonce = $util.newBuffer($util.base64.length(object.nonce)), 0);
            else if (object.nonce.length)
                message.nonce = object.nonce;
        if (object.gas_price != null)
            if (typeof object.gas_price === "string")
                $util.base64.decode(object.gas_price, message.gas_price = $util.newBuffer($util.base64.length(object.gas_price)), 0);
            else if (object.gas_price.length)
                message.gas_price = object.gas_price;
        if (object.gas_limit != null)
            if (typeof object.gas_limit === "string")
                $util.base64.decode(object.gas_limit, message.gas_limit = $util.newBuffer($util.base64.length(object.gas_limit)), 0);
            else if (object.gas_limit.length)
                message.gas_limit = object.gas_limit;
        if (object.to != null)
            message.to = String(object.to);
        if (object.value != null)
            if (typeof object.value === "string")
                $util.base64.decode(object.value, message.value = $util.newBuffer($util.base64.length(object.value)), 0);
            else if (object.value.length)
                message.value = object.value;
        if (object.epoch_height != null)
            if (typeof object.epoch_height === "string")
                $util.base64.decode(object.epoch_height, message.epoch_height = $util.newBuffer($util.base64.length(object.epoch_height)), 0);
            else if (object.epoch_height.length)
                message.epoch_height = object.epoch_height;
        if (object.storage_limit != null)
            if (typeof object.storage_limit === "string")
                $util.base64.decode(object.storage_limit, message.storage_limit = $util.newBuffer($util.base64.length(object.storage_limit)), 0);
            else if (object.storage_limit.length)
                message.storage_limit = object.storage_limit;
        if (object.data_initial_chunk != null)
            if (typeof object.data_initial_chunk === "string")
                $util.base64.decode(object.data_initial_chunk, message.data_initial_chunk = $util.newBuffer($util.base64.length(object.data_initial_chunk)), 0);
            else if (object.data_initial_chunk.length)
                message.data_initial_chunk = object.data_initial_chunk;
        if (object.data_length != null)
            message.data_length = object.data_length >>> 0;
        if (object.chain_id != null)
            message.chain_id = object.chain_id >>> 0;
        return message;
    };

    ConfluxSignTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            if (options.bytes === String)
                object.nonce = "";
            else {
                object.nonce = [];
                if (options.bytes !== Array)
                    object.nonce = $util.newBuffer(object.nonce);
            }
            if (options.bytes === String)
                object.gas_price = "";
            else {
                object.gas_price = [];
                if (options.bytes !== Array)
                    object.gas_price = $util.newBuffer(object.gas_price);
            }
            if (options.bytes === String)
                object.gas_limit = "";
            else {
                object.gas_limit = [];
                if (options.bytes !== Array)
                    object.gas_limit = $util.newBuffer(object.gas_limit);
            }
            object.to = "";
            if (options.bytes === String)
                object.value = "";
            else {
                object.value = [];
                if (options.bytes !== Array)
                    object.value = $util.newBuffer(object.value);
            }
            if (options.bytes === String)
                object.epoch_height = "";
            else {
                object.epoch_height = [];
                if (options.bytes !== Array)
                    object.epoch_height = $util.newBuffer(object.epoch_height);
            }
            if (options.bytes === String)
                object.storage_limit = "";
            else {
                object.storage_limit = [];
                if (options.bytes !== Array)
                    object.storage_limit = $util.newBuffer(object.storage_limit);
            }
            if (options.bytes === String)
                object.data_initial_chunk = "";
            else {
                object.data_initial_chunk = [];
                if (options.bytes !== Array)
                    object.data_initial_chunk = $util.newBuffer(object.data_initial_chunk);
            }
            object.data_length = 0;
            object.chain_id = 1029;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.nonce != null && message.hasOwnProperty("nonce"))
            object.nonce = options.bytes === String ? $util.base64.encode(message.nonce, 0, message.nonce.length) : options.bytes === Array ? Array.prototype.slice.call(message.nonce) : message.nonce;
        if (message.gas_price != null && message.hasOwnProperty("gas_price"))
            object.gas_price = options.bytes === String ? $util.base64.encode(message.gas_price, 0, message.gas_price.length) : options.bytes === Array ? Array.prototype.slice.call(message.gas_price) : message.gas_price;
        if (message.gas_limit != null && message.hasOwnProperty("gas_limit"))
            object.gas_limit = options.bytes === String ? $util.base64.encode(message.gas_limit, 0, message.gas_limit.length) : options.bytes === Array ? Array.prototype.slice.call(message.gas_limit) : message.gas_limit;
        if (message.to != null && message.hasOwnProperty("to"))
            object.to = message.to;
        if (message.value != null && message.hasOwnProperty("value"))
            object.value = options.bytes === String ? $util.base64.encode(message.value, 0, message.value.length) : options.bytes === Array ? Array.prototype.slice.call(message.value) : message.value;
        if (message.epoch_height != null && message.hasOwnProperty("epoch_height"))
            object.epoch_height = options.bytes === String ? $util.base64.encode(message.epoch_height, 0, message.epoch_height.length) : options.bytes === Array ? Array.prototype.slice.call(message.epoch_height) : message.epoch_height;
        if (message.storage_limit != null && message.hasOwnProperty("storage_limit"))
            object.storage_limit = options.bytes === String ? $util.base64.encode(message.storage_limit, 0, message.storage_limit.length) : options.bytes === Array ? Array.prototype.slice.call(message.storage_limit) : message.storage_limit;
        if (message.data_initial_chunk != null && message.hasOwnProperty("data_initial_chunk"))
            object.data_initial_chunk = options.bytes === String ? $util.base64.encode(message.data_initial_chunk, 0, message.data_initial_chunk.length) : options.bytes === Array ? Array.prototype.slice.call(message.data_initial_chunk) : message.data_initial_chunk;
        if (message.data_length != null && message.hasOwnProperty("data_length"))
            object.data_length = message.data_length;
        if (message.chain_id != null && message.hasOwnProperty("chain_id"))
            object.chain_id = message.chain_id;
        return object;
    };

    ConfluxSignTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ConfluxSignTx;
})();

$root.ConfluxTxRequest = (function() {

    function ConfluxTxRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ConfluxTxRequest.prototype.data_length = 0;
    ConfluxTxRequest.prototype.signature_v = 0;
    ConfluxTxRequest.prototype.signature_r = $util.newBuffer([]);
    ConfluxTxRequest.prototype.signature_s = $util.newBuffer([]);

    ConfluxTxRequest.create = function create(properties) {
        return new ConfluxTxRequest(properties);
    };

    ConfluxTxRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.data_length != null && Object.hasOwnProperty.call(message, "data_length"))
            writer.uint32(8).uint32(message.data_length);
        if (message.signature_v != null && Object.hasOwnProperty.call(message, "signature_v"))
            writer.uint32(16).uint32(message.signature_v);
        if (message.signature_r != null && Object.hasOwnProperty.call(message, "signature_r"))
            writer.uint32(26).bytes(message.signature_r);
        if (message.signature_s != null && Object.hasOwnProperty.call(message, "signature_s"))
            writer.uint32(34).bytes(message.signature_s);
        return writer;
    };

    ConfluxTxRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ConfluxTxRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ConfluxTxRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.data_length = reader.uint32();
                break;
            case 2:
                message.signature_v = reader.uint32();
                break;
            case 3:
                message.signature_r = reader.bytes();
                break;
            case 4:
                message.signature_s = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    ConfluxTxRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ConfluxTxRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.data_length != null && message.hasOwnProperty("data_length"))
            if (!$util.isInteger(message.data_length))
                return "data_length: integer expected";
        if (message.signature_v != null && message.hasOwnProperty("signature_v"))
            if (!$util.isInteger(message.signature_v))
                return "signature_v: integer expected";
        if (message.signature_r != null && message.hasOwnProperty("signature_r"))
            if (!(message.signature_r && typeof message.signature_r.length === "number" || $util.isString(message.signature_r)))
                return "signature_r: buffer expected";
        if (message.signature_s != null && message.hasOwnProperty("signature_s"))
            if (!(message.signature_s && typeof message.signature_s.length === "number" || $util.isString(message.signature_s)))
                return "signature_s: buffer expected";
        return null;
    };

    ConfluxTxRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.ConfluxTxRequest)
            return object;
        var message = new $root.ConfluxTxRequest();
        if (object.data_length != null)
            message.data_length = object.data_length >>> 0;
        if (object.signature_v != null)
            message.signature_v = object.signature_v >>> 0;
        if (object.signature_r != null)
            if (typeof object.signature_r === "string")
                $util.base64.decode(object.signature_r, message.signature_r = $util.newBuffer($util.base64.length(object.signature_r)), 0);
            else if (object.signature_r.length)
                message.signature_r = object.signature_r;
        if (object.signature_s != null)
            if (typeof object.signature_s === "string")
                $util.base64.decode(object.signature_s, message.signature_s = $util.newBuffer($util.base64.length(object.signature_s)), 0);
            else if (object.signature_s.length)
                message.signature_s = object.signature_s;
        return message;
    };

    ConfluxTxRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.data_length = 0;
            object.signature_v = 0;
            if (options.bytes === String)
                object.signature_r = "";
            else {
                object.signature_r = [];
                if (options.bytes !== Array)
                    object.signature_r = $util.newBuffer(object.signature_r);
            }
            if (options.bytes === String)
                object.signature_s = "";
            else {
                object.signature_s = [];
                if (options.bytes !== Array)
                    object.signature_s = $util.newBuffer(object.signature_s);
            }
        }
        if (message.data_length != null && message.hasOwnProperty("data_length"))
            object.data_length = message.data_length;
        if (message.signature_v != null && message.hasOwnProperty("signature_v"))
            object.signature_v = message.signature_v;
        if (message.signature_r != null && message.hasOwnProperty("signature_r"))
            object.signature_r = options.bytes === String ? $util.base64.encode(message.signature_r, 0, message.signature_r.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature_r) : message.signature_r;
        if (message.signature_s != null && message.hasOwnProperty("signature_s"))
            object.signature_s = options.bytes === String ? $util.base64.encode(message.signature_s, 0, message.signature_s.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature_s) : message.signature_s;
        return object;
    };

    ConfluxTxRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ConfluxTxRequest;
})();

$root.ConfluxTxAck = (function() {

    function ConfluxTxAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ConfluxTxAck.prototype.data_chunk = $util.newBuffer([]);

    ConfluxTxAck.create = function create(properties) {
        return new ConfluxTxAck(properties);
    };

    ConfluxTxAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.data_chunk != null && Object.hasOwnProperty.call(message, "data_chunk"))
            writer.uint32(10).bytes(message.data_chunk);
        return writer;
    };

    ConfluxTxAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ConfluxTxAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ConfluxTxAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.data_chunk = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    ConfluxTxAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ConfluxTxAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.data_chunk != null && message.hasOwnProperty("data_chunk"))
            if (!(message.data_chunk && typeof message.data_chunk.length === "number" || $util.isString(message.data_chunk)))
                return "data_chunk: buffer expected";
        return null;
    };

    ConfluxTxAck.fromObject = function fromObject(object) {
        if (object instanceof $root.ConfluxTxAck)
            return object;
        var message = new $root.ConfluxTxAck();
        if (object.data_chunk != null)
            if (typeof object.data_chunk === "string")
                $util.base64.decode(object.data_chunk, message.data_chunk = $util.newBuffer($util.base64.length(object.data_chunk)), 0);
            else if (object.data_chunk.length)
                message.data_chunk = object.data_chunk;
        return message;
    };

    ConfluxTxAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.data_chunk = "";
            else {
                object.data_chunk = [];
                if (options.bytes !== Array)
                    object.data_chunk = $util.newBuffer(object.data_chunk);
            }
        if (message.data_chunk != null && message.hasOwnProperty("data_chunk"))
            object.data_chunk = options.bytes === String ? $util.base64.encode(message.data_chunk, 0, message.data_chunk.length) : options.bytes === Array ? Array.prototype.slice.call(message.data_chunk) : message.data_chunk;
        return object;
    };

    ConfluxTxAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ConfluxTxAck;
})();

$root.ConfluxSignMessage = (function() {

    function ConfluxSignMessage(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ConfluxSignMessage.prototype.address_n = $util.emptyArray;
    ConfluxSignMessage.prototype.message = $util.newBuffer([]);

    ConfluxSignMessage.create = function create(properties) {
        return new ConfluxSignMessage(properties);
    };

    ConfluxSignMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
            writer.uint32(18).bytes(message.message);
        return writer;
    };

    ConfluxSignMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ConfluxSignMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ConfluxSignMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.message = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    ConfluxSignMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ConfluxSignMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.message != null && message.hasOwnProperty("message"))
            if (!(message.message && typeof message.message.length === "number" || $util.isString(message.message)))
                return "message: buffer expected";
        return null;
    };

    ConfluxSignMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.ConfluxSignMessage)
            return object;
        var message = new $root.ConfluxSignMessage();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".ConfluxSignMessage.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.message != null)
            if (typeof object.message === "string")
                $util.base64.decode(object.message, message.message = $util.newBuffer($util.base64.length(object.message)), 0);
            else if (object.message.length)
                message.message = object.message;
        return message;
    };

    ConfluxSignMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            if (options.bytes === String)
                object.message = "";
            else {
                object.message = [];
                if (options.bytes !== Array)
                    object.message = $util.newBuffer(object.message);
            }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.message != null && message.hasOwnProperty("message"))
            object.message = options.bytes === String ? $util.base64.encode(message.message, 0, message.message.length) : options.bytes === Array ? Array.prototype.slice.call(message.message) : message.message;
        return object;
    };

    ConfluxSignMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ConfluxSignMessage;
})();

$root.ConfluxMessageSignature = (function() {

    function ConfluxMessageSignature(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ConfluxMessageSignature.prototype.signature = $util.newBuffer([]);
    ConfluxMessageSignature.prototype.address = "";

    ConfluxMessageSignature.create = function create(properties) {
        return new ConfluxMessageSignature(properties);
    };

    ConfluxMessageSignature.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.signature != null && Object.hasOwnProperty.call(message, "signature"))
            writer.uint32(18).bytes(message.signature);
        if (message.address != null && Object.hasOwnProperty.call(message, "address"))
            writer.uint32(26).string(message.address);
        return writer;
    };

    ConfluxMessageSignature.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ConfluxMessageSignature.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ConfluxMessageSignature();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 2:
                message.signature = reader.bytes();
                break;
            case 3:
                message.address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    ConfluxMessageSignature.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ConfluxMessageSignature.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.signature != null && message.hasOwnProperty("signature"))
            if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
                return "signature: buffer expected";
        if (message.address != null && message.hasOwnProperty("address"))
            if (!$util.isString(message.address))
                return "address: string expected";
        return null;
    };

    ConfluxMessageSignature.fromObject = function fromObject(object) {
        if (object instanceof $root.ConfluxMessageSignature)
            return object;
        var message = new $root.ConfluxMessageSignature();
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        if (object.address != null)
            message.address = String(object.address);
        return message;
    };

    ConfluxMessageSignature.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
            object.address = "";
        }
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    ConfluxMessageSignature.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ConfluxMessageSignature;
})();

$root.ConfluxSignMessageCIP23 = (function() {

    function ConfluxSignMessageCIP23(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ConfluxSignMessageCIP23.prototype.address_n = $util.emptyArray;
    ConfluxSignMessageCIP23.prototype.domain_hash = $util.newBuffer([]);
    ConfluxSignMessageCIP23.prototype.message_hash = $util.newBuffer([]);

    ConfluxSignMessageCIP23.create = function create(properties) {
        return new ConfluxSignMessageCIP23(properties);
    };

    ConfluxSignMessageCIP23.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.domain_hash != null && Object.hasOwnProperty.call(message, "domain_hash"))
            writer.uint32(18).bytes(message.domain_hash);
        if (message.message_hash != null && Object.hasOwnProperty.call(message, "message_hash"))
            writer.uint32(26).bytes(message.message_hash);
        return writer;
    };

    ConfluxSignMessageCIP23.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ConfluxSignMessageCIP23.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ConfluxSignMessageCIP23();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.domain_hash = reader.bytes();
                break;
            case 3:
                message.message_hash = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    ConfluxSignMessageCIP23.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ConfluxSignMessageCIP23.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.domain_hash != null && message.hasOwnProperty("domain_hash"))
            if (!(message.domain_hash && typeof message.domain_hash.length === "number" || $util.isString(message.domain_hash)))
                return "domain_hash: buffer expected";
        if (message.message_hash != null && message.hasOwnProperty("message_hash"))
            if (!(message.message_hash && typeof message.message_hash.length === "number" || $util.isString(message.message_hash)))
                return "message_hash: buffer expected";
        return null;
    };

    ConfluxSignMessageCIP23.fromObject = function fromObject(object) {
        if (object instanceof $root.ConfluxSignMessageCIP23)
            return object;
        var message = new $root.ConfluxSignMessageCIP23();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".ConfluxSignMessageCIP23.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.domain_hash != null)
            if (typeof object.domain_hash === "string")
                $util.base64.decode(object.domain_hash, message.domain_hash = $util.newBuffer($util.base64.length(object.domain_hash)), 0);
            else if (object.domain_hash.length)
                message.domain_hash = object.domain_hash;
        if (object.message_hash != null)
            if (typeof object.message_hash === "string")
                $util.base64.decode(object.message_hash, message.message_hash = $util.newBuffer($util.base64.length(object.message_hash)), 0);
            else if (object.message_hash.length)
                message.message_hash = object.message_hash;
        return message;
    };

    ConfluxSignMessageCIP23.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            if (options.bytes === String)
                object.domain_hash = "";
            else {
                object.domain_hash = [];
                if (options.bytes !== Array)
                    object.domain_hash = $util.newBuffer(object.domain_hash);
            }
            if (options.bytes === String)
                object.message_hash = "";
            else {
                object.message_hash = [];
                if (options.bytes !== Array)
                    object.message_hash = $util.newBuffer(object.message_hash);
            }
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.domain_hash != null && message.hasOwnProperty("domain_hash"))
            object.domain_hash = options.bytes === String ? $util.base64.encode(message.domain_hash, 0, message.domain_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.domain_hash) : message.domain_hash;
        if (message.message_hash != null && message.hasOwnProperty("message_hash"))
            object.message_hash = options.bytes === String ? $util.base64.encode(message.message_hash, 0, message.message_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.message_hash) : message.message_hash;
        return object;
    };

    ConfluxSignMessageCIP23.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ConfluxSignMessageCIP23;
})();

$root.CosmosGetAddress = (function() {

    function CosmosGetAddress(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CosmosGetAddress.prototype.address_n = $util.emptyArray;
    CosmosGetAddress.prototype.hrp = "";
    CosmosGetAddress.prototype.show_display = false;

    CosmosGetAddress.create = function create(properties) {
        return new CosmosGetAddress(properties);
    };

    CosmosGetAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.hrp != null && Object.hasOwnProperty.call(message, "hrp"))
            writer.uint32(18).string(message.hrp);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(24).bool(message.show_display);
        return writer;
    };

    CosmosGetAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CosmosGetAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CosmosGetAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.hrp = reader.string();
                break;
            case 3:
                message.show_display = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    CosmosGetAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CosmosGetAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.hrp != null && message.hasOwnProperty("hrp"))
            if (!$util.isString(message.hrp))
                return "hrp: string expected";
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        return null;
    };

    CosmosGetAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.CosmosGetAddress)
            return object;
        var message = new $root.CosmosGetAddress();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".CosmosGetAddress.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.hrp != null)
            message.hrp = String(object.hrp);
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        return message;
    };

    CosmosGetAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            object.hrp = "";
            object.show_display = false;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.hrp != null && message.hasOwnProperty("hrp"))
            object.hrp = message.hrp;
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        return object;
    };

    CosmosGetAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CosmosGetAddress;
})();

$root.CosmosAddress = (function() {

    function CosmosAddress(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CosmosAddress.prototype.address = "";

    CosmosAddress.create = function create(properties) {
        return new CosmosAddress(properties);
    };

    CosmosAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address != null && Object.hasOwnProperty.call(message, "address"))
            writer.uint32(10).string(message.address);
        return writer;
    };

    CosmosAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CosmosAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CosmosAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    CosmosAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CosmosAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address != null && message.hasOwnProperty("address"))
            if (!$util.isString(message.address))
                return "address: string expected";
        return null;
    };

    CosmosAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.CosmosAddress)
            return object;
        var message = new $root.CosmosAddress();
        if (object.address != null)
            message.address = String(object.address);
        return message;
    };

    CosmosAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.address = "";
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    CosmosAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CosmosAddress;
})();

$root.CosmosSignTx = (function() {

    function CosmosSignTx(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CosmosSignTx.prototype.address_n = $util.emptyArray;
    CosmosSignTx.prototype.raw_tx = $util.newBuffer([]);

    CosmosSignTx.create = function create(properties) {
        return new CosmosSignTx(properties);
    };

    CosmosSignTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).bytes(message.raw_tx);
        return writer;
    };

    CosmosSignTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CosmosSignTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CosmosSignTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.raw_tx = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("raw_tx"))
            throw $util.ProtocolError("missing required 'raw_tx'", { instance: message });
        return message;
    };

    CosmosSignTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CosmosSignTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!(message.raw_tx && typeof message.raw_tx.length === "number" || $util.isString(message.raw_tx)))
            return "raw_tx: buffer expected";
        return null;
    };

    CosmosSignTx.fromObject = function fromObject(object) {
        if (object instanceof $root.CosmosSignTx)
            return object;
        var message = new $root.CosmosSignTx();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".CosmosSignTx.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.raw_tx != null)
            if (typeof object.raw_tx === "string")
                $util.base64.decode(object.raw_tx, message.raw_tx = $util.newBuffer($util.base64.length(object.raw_tx)), 0);
            else if (object.raw_tx.length)
                message.raw_tx = object.raw_tx;
        return message;
    };

    CosmosSignTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            if (options.bytes === String)
                object.raw_tx = "";
            else {
                object.raw_tx = [];
                if (options.bytes !== Array)
                    object.raw_tx = $util.newBuffer(object.raw_tx);
            }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.raw_tx != null && message.hasOwnProperty("raw_tx"))
            object.raw_tx = options.bytes === String ? $util.base64.encode(message.raw_tx, 0, message.raw_tx.length) : options.bytes === Array ? Array.prototype.slice.call(message.raw_tx) : message.raw_tx;
        return object;
    };

    CosmosSignTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CosmosSignTx;
})();

$root.CosmosSignedTx = (function() {

    function CosmosSignedTx(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CosmosSignedTx.prototype.signature = $util.newBuffer([]);

    CosmosSignedTx.create = function create(properties) {
        return new CosmosSignedTx(properties);
    };

    CosmosSignedTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.signature);
        return writer;
    };

    CosmosSignedTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CosmosSignedTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CosmosSignedTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.signature = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        return message;
    };

    CosmosSignedTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CosmosSignedTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        return null;
    };

    CosmosSignedTx.fromObject = function fromObject(object) {
        if (object instanceof $root.CosmosSignedTx)
            return object;
        var message = new $root.CosmosSignedTx();
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        return message;
    };

    CosmosSignedTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        return object;
    };

    CosmosSignedTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CosmosSignedTx;
})();

$root.HDNodeType = (function() {

    function HDNodeType(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    HDNodeType.prototype.depth = 0;
    HDNodeType.prototype.fingerprint = 0;
    HDNodeType.prototype.child_num = 0;
    HDNodeType.prototype.chain_code = $util.newBuffer([]);
    HDNodeType.prototype.private_key = $util.newBuffer([]);
    HDNodeType.prototype.public_key = $util.newBuffer([]);

    HDNodeType.create = function create(properties) {
        return new HDNodeType(properties);
    };

    HDNodeType.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).uint32(message.depth);
        writer.uint32(16).uint32(message.fingerprint);
        writer.uint32(24).uint32(message.child_num);
        writer.uint32(34).bytes(message.chain_code);
        if (message.private_key != null && Object.hasOwnProperty.call(message, "private_key"))
            writer.uint32(42).bytes(message.private_key);
        writer.uint32(50).bytes(message.public_key);
        return writer;
    };

    HDNodeType.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    HDNodeType.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.HDNodeType();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.depth = reader.uint32();
                break;
            case 2:
                message.fingerprint = reader.uint32();
                break;
            case 3:
                message.child_num = reader.uint32();
                break;
            case 4:
                message.chain_code = reader.bytes();
                break;
            case 5:
                message.private_key = reader.bytes();
                break;
            case 6:
                message.public_key = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("depth"))
            throw $util.ProtocolError("missing required 'depth'", { instance: message });
        if (!message.hasOwnProperty("fingerprint"))
            throw $util.ProtocolError("missing required 'fingerprint'", { instance: message });
        if (!message.hasOwnProperty("child_num"))
            throw $util.ProtocolError("missing required 'child_num'", { instance: message });
        if (!message.hasOwnProperty("chain_code"))
            throw $util.ProtocolError("missing required 'chain_code'", { instance: message });
        if (!message.hasOwnProperty("public_key"))
            throw $util.ProtocolError("missing required 'public_key'", { instance: message });
        return message;
    };

    HDNodeType.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    HDNodeType.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isInteger(message.depth))
            return "depth: integer expected";
        if (!$util.isInteger(message.fingerprint))
            return "fingerprint: integer expected";
        if (!$util.isInteger(message.child_num))
            return "child_num: integer expected";
        if (!(message.chain_code && typeof message.chain_code.length === "number" || $util.isString(message.chain_code)))
            return "chain_code: buffer expected";
        if (message.private_key != null && message.hasOwnProperty("private_key"))
            if (!(message.private_key && typeof message.private_key.length === "number" || $util.isString(message.private_key)))
                return "private_key: buffer expected";
        if (!(message.public_key && typeof message.public_key.length === "number" || $util.isString(message.public_key)))
            return "public_key: buffer expected";
        return null;
    };

    HDNodeType.fromObject = function fromObject(object) {
        if (object instanceof $root.HDNodeType)
            return object;
        var message = new $root.HDNodeType();
        if (object.depth != null)
            message.depth = object.depth >>> 0;
        if (object.fingerprint != null)
            message.fingerprint = object.fingerprint >>> 0;
        if (object.child_num != null)
            message.child_num = object.child_num >>> 0;
        if (object.chain_code != null)
            if (typeof object.chain_code === "string")
                $util.base64.decode(object.chain_code, message.chain_code = $util.newBuffer($util.base64.length(object.chain_code)), 0);
            else if (object.chain_code.length)
                message.chain_code = object.chain_code;
        if (object.private_key != null)
            if (typeof object.private_key === "string")
                $util.base64.decode(object.private_key, message.private_key = $util.newBuffer($util.base64.length(object.private_key)), 0);
            else if (object.private_key.length)
                message.private_key = object.private_key;
        if (object.public_key != null)
            if (typeof object.public_key === "string")
                $util.base64.decode(object.public_key, message.public_key = $util.newBuffer($util.base64.length(object.public_key)), 0);
            else if (object.public_key.length)
                message.public_key = object.public_key;
        return message;
    };

    HDNodeType.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.depth = 0;
            object.fingerprint = 0;
            object.child_num = 0;
            if (options.bytes === String)
                object.chain_code = "";
            else {
                object.chain_code = [];
                if (options.bytes !== Array)
                    object.chain_code = $util.newBuffer(object.chain_code);
            }
            if (options.bytes === String)
                object.private_key = "";
            else {
                object.private_key = [];
                if (options.bytes !== Array)
                    object.private_key = $util.newBuffer(object.private_key);
            }
            if (options.bytes === String)
                object.public_key = "";
            else {
                object.public_key = [];
                if (options.bytes !== Array)
                    object.public_key = $util.newBuffer(object.public_key);
            }
        }
        if (message.depth != null && message.hasOwnProperty("depth"))
            object.depth = message.depth;
        if (message.fingerprint != null && message.hasOwnProperty("fingerprint"))
            object.fingerprint = message.fingerprint;
        if (message.child_num != null && message.hasOwnProperty("child_num"))
            object.child_num = message.child_num;
        if (message.chain_code != null && message.hasOwnProperty("chain_code"))
            object.chain_code = options.bytes === String ? $util.base64.encode(message.chain_code, 0, message.chain_code.length) : options.bytes === Array ? Array.prototype.slice.call(message.chain_code) : message.chain_code;
        if (message.private_key != null && message.hasOwnProperty("private_key"))
            object.private_key = options.bytes === String ? $util.base64.encode(message.private_key, 0, message.private_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.private_key) : message.private_key;
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            object.public_key = options.bytes === String ? $util.base64.encode(message.public_key, 0, message.public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.public_key) : message.public_key;
        return object;
    };

    HDNodeType.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return HDNodeType;
})();

$root.CipherKeyValue = (function() {

    function CipherKeyValue(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CipherKeyValue.prototype.address_n = $util.emptyArray;
    CipherKeyValue.prototype.key = "";
    CipherKeyValue.prototype.value = $util.newBuffer([]);
    CipherKeyValue.prototype.encrypt = false;
    CipherKeyValue.prototype.ask_on_encrypt = false;
    CipherKeyValue.prototype.ask_on_decrypt = false;
    CipherKeyValue.prototype.iv = $util.newBuffer([]);

    CipherKeyValue.create = function create(properties) {
        return new CipherKeyValue(properties);
    };

    CipherKeyValue.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).string(message.key);
        writer.uint32(26).bytes(message.value);
        if (message.encrypt != null && Object.hasOwnProperty.call(message, "encrypt"))
            writer.uint32(32).bool(message.encrypt);
        if (message.ask_on_encrypt != null && Object.hasOwnProperty.call(message, "ask_on_encrypt"))
            writer.uint32(40).bool(message.ask_on_encrypt);
        if (message.ask_on_decrypt != null && Object.hasOwnProperty.call(message, "ask_on_decrypt"))
            writer.uint32(48).bool(message.ask_on_decrypt);
        if (message.iv != null && Object.hasOwnProperty.call(message, "iv"))
            writer.uint32(58).bytes(message.iv);
        return writer;
    };

    CipherKeyValue.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CipherKeyValue.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CipherKeyValue();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.key = reader.string();
                break;
            case 3:
                message.value = reader.bytes();
                break;
            case 4:
                message.encrypt = reader.bool();
                break;
            case 5:
                message.ask_on_encrypt = reader.bool();
                break;
            case 6:
                message.ask_on_decrypt = reader.bool();
                break;
            case 7:
                message.iv = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("key"))
            throw $util.ProtocolError("missing required 'key'", { instance: message });
        if (!message.hasOwnProperty("value"))
            throw $util.ProtocolError("missing required 'value'", { instance: message });
        return message;
    };

    CipherKeyValue.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CipherKeyValue.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!$util.isString(message.key))
            return "key: string expected";
        if (!(message.value && typeof message.value.length === "number" || $util.isString(message.value)))
            return "value: buffer expected";
        if (message.encrypt != null && message.hasOwnProperty("encrypt"))
            if (typeof message.encrypt !== "boolean")
                return "encrypt: boolean expected";
        if (message.ask_on_encrypt != null && message.hasOwnProperty("ask_on_encrypt"))
            if (typeof message.ask_on_encrypt !== "boolean")
                return "ask_on_encrypt: boolean expected";
        if (message.ask_on_decrypt != null && message.hasOwnProperty("ask_on_decrypt"))
            if (typeof message.ask_on_decrypt !== "boolean")
                return "ask_on_decrypt: boolean expected";
        if (message.iv != null && message.hasOwnProperty("iv"))
            if (!(message.iv && typeof message.iv.length === "number" || $util.isString(message.iv)))
                return "iv: buffer expected";
        return null;
    };

    CipherKeyValue.fromObject = function fromObject(object) {
        if (object instanceof $root.CipherKeyValue)
            return object;
        var message = new $root.CipherKeyValue();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".CipherKeyValue.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.key != null)
            message.key = String(object.key);
        if (object.value != null)
            if (typeof object.value === "string")
                $util.base64.decode(object.value, message.value = $util.newBuffer($util.base64.length(object.value)), 0);
            else if (object.value.length)
                message.value = object.value;
        if (object.encrypt != null)
            message.encrypt = Boolean(object.encrypt);
        if (object.ask_on_encrypt != null)
            message.ask_on_encrypt = Boolean(object.ask_on_encrypt);
        if (object.ask_on_decrypt != null)
            message.ask_on_decrypt = Boolean(object.ask_on_decrypt);
        if (object.iv != null)
            if (typeof object.iv === "string")
                $util.base64.decode(object.iv, message.iv = $util.newBuffer($util.base64.length(object.iv)), 0);
            else if (object.iv.length)
                message.iv = object.iv;
        return message;
    };

    CipherKeyValue.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            object.key = "";
            if (options.bytes === String)
                object.value = "";
            else {
                object.value = [];
                if (options.bytes !== Array)
                    object.value = $util.newBuffer(object.value);
            }
            object.encrypt = false;
            object.ask_on_encrypt = false;
            object.ask_on_decrypt = false;
            if (options.bytes === String)
                object.iv = "";
            else {
                object.iv = [];
                if (options.bytes !== Array)
                    object.iv = $util.newBuffer(object.iv);
            }
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.key != null && message.hasOwnProperty("key"))
            object.key = message.key;
        if (message.value != null && message.hasOwnProperty("value"))
            object.value = options.bytes === String ? $util.base64.encode(message.value, 0, message.value.length) : options.bytes === Array ? Array.prototype.slice.call(message.value) : message.value;
        if (message.encrypt != null && message.hasOwnProperty("encrypt"))
            object.encrypt = message.encrypt;
        if (message.ask_on_encrypt != null && message.hasOwnProperty("ask_on_encrypt"))
            object.ask_on_encrypt = message.ask_on_encrypt;
        if (message.ask_on_decrypt != null && message.hasOwnProperty("ask_on_decrypt"))
            object.ask_on_decrypt = message.ask_on_decrypt;
        if (message.iv != null && message.hasOwnProperty("iv"))
            object.iv = options.bytes === String ? $util.base64.encode(message.iv, 0, message.iv.length) : options.bytes === Array ? Array.prototype.slice.call(message.iv) : message.iv;
        return object;
    };

    CipherKeyValue.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CipherKeyValue;
})();

$root.CipheredKeyValue = (function() {

    function CipheredKeyValue(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CipheredKeyValue.prototype.value = $util.newBuffer([]);

    CipheredKeyValue.create = function create(properties) {
        return new CipheredKeyValue(properties);
    };

    CipheredKeyValue.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.value);
        return writer;
    };

    CipheredKeyValue.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CipheredKeyValue.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CipheredKeyValue();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.value = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("value"))
            throw $util.ProtocolError("missing required 'value'", { instance: message });
        return message;
    };

    CipheredKeyValue.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CipheredKeyValue.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.value && typeof message.value.length === "number" || $util.isString(message.value)))
            return "value: buffer expected";
        return null;
    };

    CipheredKeyValue.fromObject = function fromObject(object) {
        if (object instanceof $root.CipheredKeyValue)
            return object;
        var message = new $root.CipheredKeyValue();
        if (object.value != null)
            if (typeof object.value === "string")
                $util.base64.decode(object.value, message.value = $util.newBuffer($util.base64.length(object.value)), 0);
            else if (object.value.length)
                message.value = object.value;
        return message;
    };

    CipheredKeyValue.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.value = "";
            else {
                object.value = [];
                if (options.bytes !== Array)
                    object.value = $util.newBuffer(object.value);
            }
        if (message.value != null && message.hasOwnProperty("value"))
            object.value = options.bytes === String ? $util.base64.encode(message.value, 0, message.value.length) : options.bytes === Array ? Array.prototype.slice.call(message.value) : message.value;
        return object;
    };

    CipheredKeyValue.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CipheredKeyValue;
})();

$root.IdentityType = (function() {

    function IdentityType(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    IdentityType.prototype.proto = "";
    IdentityType.prototype.user = "";
    IdentityType.prototype.host = "";
    IdentityType.prototype.port = "";
    IdentityType.prototype.path = "";
    IdentityType.prototype.index = 0;

    IdentityType.create = function create(properties) {
        return new IdentityType(properties);
    };

    IdentityType.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.proto != null && Object.hasOwnProperty.call(message, "proto"))
            writer.uint32(10).string(message.proto);
        if (message.user != null && Object.hasOwnProperty.call(message, "user"))
            writer.uint32(18).string(message.user);
        if (message.host != null && Object.hasOwnProperty.call(message, "host"))
            writer.uint32(26).string(message.host);
        if (message.port != null && Object.hasOwnProperty.call(message, "port"))
            writer.uint32(34).string(message.port);
        if (message.path != null && Object.hasOwnProperty.call(message, "path"))
            writer.uint32(42).string(message.path);
        if (message.index != null && Object.hasOwnProperty.call(message, "index"))
            writer.uint32(48).uint32(message.index);
        return writer;
    };

    IdentityType.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    IdentityType.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.IdentityType();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.proto = reader.string();
                break;
            case 2:
                message.user = reader.string();
                break;
            case 3:
                message.host = reader.string();
                break;
            case 4:
                message.port = reader.string();
                break;
            case 5:
                message.path = reader.string();
                break;
            case 6:
                message.index = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    IdentityType.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    IdentityType.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.proto != null && message.hasOwnProperty("proto"))
            if (!$util.isString(message.proto))
                return "proto: string expected";
        if (message.user != null && message.hasOwnProperty("user"))
            if (!$util.isString(message.user))
                return "user: string expected";
        if (message.host != null && message.hasOwnProperty("host"))
            if (!$util.isString(message.host))
                return "host: string expected";
        if (message.port != null && message.hasOwnProperty("port"))
            if (!$util.isString(message.port))
                return "port: string expected";
        if (message.path != null && message.hasOwnProperty("path"))
            if (!$util.isString(message.path))
                return "path: string expected";
        if (message.index != null && message.hasOwnProperty("index"))
            if (!$util.isInteger(message.index))
                return "index: integer expected";
        return null;
    };

    IdentityType.fromObject = function fromObject(object) {
        if (object instanceof $root.IdentityType)
            return object;
        var message = new $root.IdentityType();
        if (object.proto != null)
            message.proto = String(object.proto);
        if (object.user != null)
            message.user = String(object.user);
        if (object.host != null)
            message.host = String(object.host);
        if (object.port != null)
            message.port = String(object.port);
        if (object.path != null)
            message.path = String(object.path);
        if (object.index != null)
            message.index = object.index >>> 0;
        return message;
    };

    IdentityType.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.proto = "";
            object.user = "";
            object.host = "";
            object.port = "";
            object.path = "";
            object.index = 0;
        }
        if (message.proto != null && message.hasOwnProperty("proto"))
            object.proto = message.proto;
        if (message.user != null && message.hasOwnProperty("user"))
            object.user = message.user;
        if (message.host != null && message.hasOwnProperty("host"))
            object.host = message.host;
        if (message.port != null && message.hasOwnProperty("port"))
            object.port = message.port;
        if (message.path != null && message.hasOwnProperty("path"))
            object.path = message.path;
        if (message.index != null && message.hasOwnProperty("index"))
            object.index = message.index;
        return object;
    };

    IdentityType.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return IdentityType;
})();

$root.SignIdentity = (function() {

    function SignIdentity(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    SignIdentity.prototype.identity = null;
    SignIdentity.prototype.challenge_hidden = $util.newBuffer([]);
    SignIdentity.prototype.challenge_visual = "";
    SignIdentity.prototype.ecdsa_curve_name = "";

    SignIdentity.create = function create(properties) {
        return new SignIdentity(properties);
    };

    SignIdentity.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        $root.IdentityType.encode(message.identity, writer.uint32(10).fork()).ldelim();
        if (message.challenge_hidden != null && Object.hasOwnProperty.call(message, "challenge_hidden"))
            writer.uint32(18).bytes(message.challenge_hidden);
        if (message.challenge_visual != null && Object.hasOwnProperty.call(message, "challenge_visual"))
            writer.uint32(26).string(message.challenge_visual);
        if (message.ecdsa_curve_name != null && Object.hasOwnProperty.call(message, "ecdsa_curve_name"))
            writer.uint32(34).string(message.ecdsa_curve_name);
        return writer;
    };

    SignIdentity.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    SignIdentity.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SignIdentity();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.identity = $root.IdentityType.decode(reader, reader.uint32());
                break;
            case 2:
                message.challenge_hidden = reader.bytes();
                break;
            case 3:
                message.challenge_visual = reader.string();
                break;
            case 4:
                message.ecdsa_curve_name = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("identity"))
            throw $util.ProtocolError("missing required 'identity'", { instance: message });
        return message;
    };

    SignIdentity.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    SignIdentity.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        {
            var error = $root.IdentityType.verify(message.identity);
            if (error)
                return "identity." + error;
        }
        if (message.challenge_hidden != null && message.hasOwnProperty("challenge_hidden"))
            if (!(message.challenge_hidden && typeof message.challenge_hidden.length === "number" || $util.isString(message.challenge_hidden)))
                return "challenge_hidden: buffer expected";
        if (message.challenge_visual != null && message.hasOwnProperty("challenge_visual"))
            if (!$util.isString(message.challenge_visual))
                return "challenge_visual: string expected";
        if (message.ecdsa_curve_name != null && message.hasOwnProperty("ecdsa_curve_name"))
            if (!$util.isString(message.ecdsa_curve_name))
                return "ecdsa_curve_name: string expected";
        return null;
    };

    SignIdentity.fromObject = function fromObject(object) {
        if (object instanceof $root.SignIdentity)
            return object;
        var message = new $root.SignIdentity();
        if (object.identity != null) {
            if (typeof object.identity !== "object")
                throw TypeError(".SignIdentity.identity: object expected");
            message.identity = $root.IdentityType.fromObject(object.identity);
        }
        if (object.challenge_hidden != null)
            if (typeof object.challenge_hidden === "string")
                $util.base64.decode(object.challenge_hidden, message.challenge_hidden = $util.newBuffer($util.base64.length(object.challenge_hidden)), 0);
            else if (object.challenge_hidden.length)
                message.challenge_hidden = object.challenge_hidden;
        if (object.challenge_visual != null)
            message.challenge_visual = String(object.challenge_visual);
        if (object.ecdsa_curve_name != null)
            message.ecdsa_curve_name = String(object.ecdsa_curve_name);
        return message;
    };

    SignIdentity.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.identity = null;
            if (options.bytes === String)
                object.challenge_hidden = "";
            else {
                object.challenge_hidden = [];
                if (options.bytes !== Array)
                    object.challenge_hidden = $util.newBuffer(object.challenge_hidden);
            }
            object.challenge_visual = "";
            object.ecdsa_curve_name = "";
        }
        if (message.identity != null && message.hasOwnProperty("identity"))
            object.identity = $root.IdentityType.toObject(message.identity, options);
        if (message.challenge_hidden != null && message.hasOwnProperty("challenge_hidden"))
            object.challenge_hidden = options.bytes === String ? $util.base64.encode(message.challenge_hidden, 0, message.challenge_hidden.length) : options.bytes === Array ? Array.prototype.slice.call(message.challenge_hidden) : message.challenge_hidden;
        if (message.challenge_visual != null && message.hasOwnProperty("challenge_visual"))
            object.challenge_visual = message.challenge_visual;
        if (message.ecdsa_curve_name != null && message.hasOwnProperty("ecdsa_curve_name"))
            object.ecdsa_curve_name = message.ecdsa_curve_name;
        return object;
    };

    SignIdentity.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SignIdentity;
})();

$root.SignedIdentity = (function() {

    function SignedIdentity(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    SignedIdentity.prototype.address = "";
    SignedIdentity.prototype.public_key = $util.newBuffer([]);
    SignedIdentity.prototype.signature = $util.newBuffer([]);

    SignedIdentity.create = function create(properties) {
        return new SignedIdentity(properties);
    };

    SignedIdentity.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address != null && Object.hasOwnProperty.call(message, "address"))
            writer.uint32(10).string(message.address);
        writer.uint32(18).bytes(message.public_key);
        writer.uint32(26).bytes(message.signature);
        return writer;
    };

    SignedIdentity.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    SignedIdentity.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SignedIdentity();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.string();
                break;
            case 2:
                message.public_key = reader.bytes();
                break;
            case 3:
                message.signature = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("public_key"))
            throw $util.ProtocolError("missing required 'public_key'", { instance: message });
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        return message;
    };

    SignedIdentity.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    SignedIdentity.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address != null && message.hasOwnProperty("address"))
            if (!$util.isString(message.address))
                return "address: string expected";
        if (!(message.public_key && typeof message.public_key.length === "number" || $util.isString(message.public_key)))
            return "public_key: buffer expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        return null;
    };

    SignedIdentity.fromObject = function fromObject(object) {
        if (object instanceof $root.SignedIdentity)
            return object;
        var message = new $root.SignedIdentity();
        if (object.address != null)
            message.address = String(object.address);
        if (object.public_key != null)
            if (typeof object.public_key === "string")
                $util.base64.decode(object.public_key, message.public_key = $util.newBuffer($util.base64.length(object.public_key)), 0);
            else if (object.public_key.length)
                message.public_key = object.public_key;
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        return message;
    };

    SignedIdentity.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.address = "";
            if (options.bytes === String)
                object.public_key = "";
            else {
                object.public_key = [];
                if (options.bytes !== Array)
                    object.public_key = $util.newBuffer(object.public_key);
            }
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
        }
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            object.public_key = options.bytes === String ? $util.base64.encode(message.public_key, 0, message.public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.public_key) : message.public_key;
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        return object;
    };

    SignedIdentity.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SignedIdentity;
})();

$root.GetECDHSessionKey = (function() {

    function GetECDHSessionKey(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    GetECDHSessionKey.prototype.identity = null;
    GetECDHSessionKey.prototype.peer_public_key = $util.newBuffer([]);
    GetECDHSessionKey.prototype.ecdsa_curve_name = "";

    GetECDHSessionKey.create = function create(properties) {
        return new GetECDHSessionKey(properties);
    };

    GetECDHSessionKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        $root.IdentityType.encode(message.identity, writer.uint32(10).fork()).ldelim();
        writer.uint32(18).bytes(message.peer_public_key);
        if (message.ecdsa_curve_name != null && Object.hasOwnProperty.call(message, "ecdsa_curve_name"))
            writer.uint32(26).string(message.ecdsa_curve_name);
        return writer;
    };

    GetECDHSessionKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    GetECDHSessionKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.GetECDHSessionKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.identity = $root.IdentityType.decode(reader, reader.uint32());
                break;
            case 2:
                message.peer_public_key = reader.bytes();
                break;
            case 3:
                message.ecdsa_curve_name = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("identity"))
            throw $util.ProtocolError("missing required 'identity'", { instance: message });
        if (!message.hasOwnProperty("peer_public_key"))
            throw $util.ProtocolError("missing required 'peer_public_key'", { instance: message });
        return message;
    };

    GetECDHSessionKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    GetECDHSessionKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        {
            var error = $root.IdentityType.verify(message.identity);
            if (error)
                return "identity." + error;
        }
        if (!(message.peer_public_key && typeof message.peer_public_key.length === "number" || $util.isString(message.peer_public_key)))
            return "peer_public_key: buffer expected";
        if (message.ecdsa_curve_name != null && message.hasOwnProperty("ecdsa_curve_name"))
            if (!$util.isString(message.ecdsa_curve_name))
                return "ecdsa_curve_name: string expected";
        return null;
    };

    GetECDHSessionKey.fromObject = function fromObject(object) {
        if (object instanceof $root.GetECDHSessionKey)
            return object;
        var message = new $root.GetECDHSessionKey();
        if (object.identity != null) {
            if (typeof object.identity !== "object")
                throw TypeError(".GetECDHSessionKey.identity: object expected");
            message.identity = $root.IdentityType.fromObject(object.identity);
        }
        if (object.peer_public_key != null)
            if (typeof object.peer_public_key === "string")
                $util.base64.decode(object.peer_public_key, message.peer_public_key = $util.newBuffer($util.base64.length(object.peer_public_key)), 0);
            else if (object.peer_public_key.length)
                message.peer_public_key = object.peer_public_key;
        if (object.ecdsa_curve_name != null)
            message.ecdsa_curve_name = String(object.ecdsa_curve_name);
        return message;
    };

    GetECDHSessionKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.identity = null;
            if (options.bytes === String)
                object.peer_public_key = "";
            else {
                object.peer_public_key = [];
                if (options.bytes !== Array)
                    object.peer_public_key = $util.newBuffer(object.peer_public_key);
            }
            object.ecdsa_curve_name = "";
        }
        if (message.identity != null && message.hasOwnProperty("identity"))
            object.identity = $root.IdentityType.toObject(message.identity, options);
        if (message.peer_public_key != null && message.hasOwnProperty("peer_public_key"))
            object.peer_public_key = options.bytes === String ? $util.base64.encode(message.peer_public_key, 0, message.peer_public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.peer_public_key) : message.peer_public_key;
        if (message.ecdsa_curve_name != null && message.hasOwnProperty("ecdsa_curve_name"))
            object.ecdsa_curve_name = message.ecdsa_curve_name;
        return object;
    };

    GetECDHSessionKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return GetECDHSessionKey;
})();

$root.ECDHSessionKey = (function() {

    function ECDHSessionKey(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ECDHSessionKey.prototype.session_key = $util.newBuffer([]);
    ECDHSessionKey.prototype.public_key = $util.newBuffer([]);

    ECDHSessionKey.create = function create(properties) {
        return new ECDHSessionKey(properties);
    };

    ECDHSessionKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.session_key);
        if (message.public_key != null && Object.hasOwnProperty.call(message, "public_key"))
            writer.uint32(18).bytes(message.public_key);
        return writer;
    };

    ECDHSessionKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ECDHSessionKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ECDHSessionKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.session_key = reader.bytes();
                break;
            case 2:
                message.public_key = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("session_key"))
            throw $util.ProtocolError("missing required 'session_key'", { instance: message });
        return message;
    };

    ECDHSessionKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ECDHSessionKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.session_key && typeof message.session_key.length === "number" || $util.isString(message.session_key)))
            return "session_key: buffer expected";
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            if (!(message.public_key && typeof message.public_key.length === "number" || $util.isString(message.public_key)))
                return "public_key: buffer expected";
        return null;
    };

    ECDHSessionKey.fromObject = function fromObject(object) {
        if (object instanceof $root.ECDHSessionKey)
            return object;
        var message = new $root.ECDHSessionKey();
        if (object.session_key != null)
            if (typeof object.session_key === "string")
                $util.base64.decode(object.session_key, message.session_key = $util.newBuffer($util.base64.length(object.session_key)), 0);
            else if (object.session_key.length)
                message.session_key = object.session_key;
        if (object.public_key != null)
            if (typeof object.public_key === "string")
                $util.base64.decode(object.public_key, message.public_key = $util.newBuffer($util.base64.length(object.public_key)), 0);
            else if (object.public_key.length)
                message.public_key = object.public_key;
        return message;
    };

    ECDHSessionKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.session_key = "";
            else {
                object.session_key = [];
                if (options.bytes !== Array)
                    object.session_key = $util.newBuffer(object.session_key);
            }
            if (options.bytes === String)
                object.public_key = "";
            else {
                object.public_key = [];
                if (options.bytes !== Array)
                    object.public_key = $util.newBuffer(object.public_key);
            }
        }
        if (message.session_key != null && message.hasOwnProperty("session_key"))
            object.session_key = options.bytes === String ? $util.base64.encode(message.session_key, 0, message.session_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.session_key) : message.session_key;
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            object.public_key = options.bytes === String ? $util.base64.encode(message.public_key, 0, message.public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.public_key) : message.public_key;
        return object;
    };

    ECDHSessionKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ECDHSessionKey;
})();

$root.CosiCommit = (function() {

    function CosiCommit(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CosiCommit.prototype.address_n = $util.emptyArray;
    CosiCommit.prototype.data = $util.newBuffer([]);

    CosiCommit.create = function create(properties) {
        return new CosiCommit(properties);
    };

    CosiCommit.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.data != null && Object.hasOwnProperty.call(message, "data"))
            writer.uint32(18).bytes(message.data);
        return writer;
    };

    CosiCommit.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CosiCommit.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CosiCommit();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.data = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    CosiCommit.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CosiCommit.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.data != null && message.hasOwnProperty("data"))
            if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
                return "data: buffer expected";
        return null;
    };

    CosiCommit.fromObject = function fromObject(object) {
        if (object instanceof $root.CosiCommit)
            return object;
        var message = new $root.CosiCommit();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".CosiCommit.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.data != null)
            if (typeof object.data === "string")
                $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
            else if (object.data.length)
                message.data = object.data;
        return message;
    };

    CosiCommit.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            if (options.bytes === String)
                object.data = "";
            else {
                object.data = [];
                if (options.bytes !== Array)
                    object.data = $util.newBuffer(object.data);
            }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.data != null && message.hasOwnProperty("data"))
            object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
        return object;
    };

    CosiCommit.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CosiCommit;
})();

$root.CosiCommitment = (function() {

    function CosiCommitment(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CosiCommitment.prototype.commitment = $util.newBuffer([]);
    CosiCommitment.prototype.pubkey = $util.newBuffer([]);

    CosiCommitment.create = function create(properties) {
        return new CosiCommitment(properties);
    };

    CosiCommitment.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.commitment != null && Object.hasOwnProperty.call(message, "commitment"))
            writer.uint32(10).bytes(message.commitment);
        if (message.pubkey != null && Object.hasOwnProperty.call(message, "pubkey"))
            writer.uint32(18).bytes(message.pubkey);
        return writer;
    };

    CosiCommitment.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CosiCommitment.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CosiCommitment();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.commitment = reader.bytes();
                break;
            case 2:
                message.pubkey = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    CosiCommitment.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CosiCommitment.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.commitment != null && message.hasOwnProperty("commitment"))
            if (!(message.commitment && typeof message.commitment.length === "number" || $util.isString(message.commitment)))
                return "commitment: buffer expected";
        if (message.pubkey != null && message.hasOwnProperty("pubkey"))
            if (!(message.pubkey && typeof message.pubkey.length === "number" || $util.isString(message.pubkey)))
                return "pubkey: buffer expected";
        return null;
    };

    CosiCommitment.fromObject = function fromObject(object) {
        if (object instanceof $root.CosiCommitment)
            return object;
        var message = new $root.CosiCommitment();
        if (object.commitment != null)
            if (typeof object.commitment === "string")
                $util.base64.decode(object.commitment, message.commitment = $util.newBuffer($util.base64.length(object.commitment)), 0);
            else if (object.commitment.length)
                message.commitment = object.commitment;
        if (object.pubkey != null)
            if (typeof object.pubkey === "string")
                $util.base64.decode(object.pubkey, message.pubkey = $util.newBuffer($util.base64.length(object.pubkey)), 0);
            else if (object.pubkey.length)
                message.pubkey = object.pubkey;
        return message;
    };

    CosiCommitment.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.commitment = "";
            else {
                object.commitment = [];
                if (options.bytes !== Array)
                    object.commitment = $util.newBuffer(object.commitment);
            }
            if (options.bytes === String)
                object.pubkey = "";
            else {
                object.pubkey = [];
                if (options.bytes !== Array)
                    object.pubkey = $util.newBuffer(object.pubkey);
            }
        }
        if (message.commitment != null && message.hasOwnProperty("commitment"))
            object.commitment = options.bytes === String ? $util.base64.encode(message.commitment, 0, message.commitment.length) : options.bytes === Array ? Array.prototype.slice.call(message.commitment) : message.commitment;
        if (message.pubkey != null && message.hasOwnProperty("pubkey"))
            object.pubkey = options.bytes === String ? $util.base64.encode(message.pubkey, 0, message.pubkey.length) : options.bytes === Array ? Array.prototype.slice.call(message.pubkey) : message.pubkey;
        return object;
    };

    CosiCommitment.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CosiCommitment;
})();

$root.CosiSign = (function() {

    function CosiSign(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CosiSign.prototype.address_n = $util.emptyArray;
    CosiSign.prototype.data = $util.newBuffer([]);
    CosiSign.prototype.global_commitment = $util.newBuffer([]);
    CosiSign.prototype.global_pubkey = $util.newBuffer([]);

    CosiSign.create = function create(properties) {
        return new CosiSign(properties);
    };

    CosiSign.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.data != null && Object.hasOwnProperty.call(message, "data"))
            writer.uint32(18).bytes(message.data);
        if (message.global_commitment != null && Object.hasOwnProperty.call(message, "global_commitment"))
            writer.uint32(26).bytes(message.global_commitment);
        if (message.global_pubkey != null && Object.hasOwnProperty.call(message, "global_pubkey"))
            writer.uint32(34).bytes(message.global_pubkey);
        return writer;
    };

    CosiSign.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CosiSign.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CosiSign();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.data = reader.bytes();
                break;
            case 3:
                message.global_commitment = reader.bytes();
                break;
            case 4:
                message.global_pubkey = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    CosiSign.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CosiSign.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.data != null && message.hasOwnProperty("data"))
            if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
                return "data: buffer expected";
        if (message.global_commitment != null && message.hasOwnProperty("global_commitment"))
            if (!(message.global_commitment && typeof message.global_commitment.length === "number" || $util.isString(message.global_commitment)))
                return "global_commitment: buffer expected";
        if (message.global_pubkey != null && message.hasOwnProperty("global_pubkey"))
            if (!(message.global_pubkey && typeof message.global_pubkey.length === "number" || $util.isString(message.global_pubkey)))
                return "global_pubkey: buffer expected";
        return null;
    };

    CosiSign.fromObject = function fromObject(object) {
        if (object instanceof $root.CosiSign)
            return object;
        var message = new $root.CosiSign();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".CosiSign.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.data != null)
            if (typeof object.data === "string")
                $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
            else if (object.data.length)
                message.data = object.data;
        if (object.global_commitment != null)
            if (typeof object.global_commitment === "string")
                $util.base64.decode(object.global_commitment, message.global_commitment = $util.newBuffer($util.base64.length(object.global_commitment)), 0);
            else if (object.global_commitment.length)
                message.global_commitment = object.global_commitment;
        if (object.global_pubkey != null)
            if (typeof object.global_pubkey === "string")
                $util.base64.decode(object.global_pubkey, message.global_pubkey = $util.newBuffer($util.base64.length(object.global_pubkey)), 0);
            else if (object.global_pubkey.length)
                message.global_pubkey = object.global_pubkey;
        return message;
    };

    CosiSign.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            if (options.bytes === String)
                object.data = "";
            else {
                object.data = [];
                if (options.bytes !== Array)
                    object.data = $util.newBuffer(object.data);
            }
            if (options.bytes === String)
                object.global_commitment = "";
            else {
                object.global_commitment = [];
                if (options.bytes !== Array)
                    object.global_commitment = $util.newBuffer(object.global_commitment);
            }
            if (options.bytes === String)
                object.global_pubkey = "";
            else {
                object.global_pubkey = [];
                if (options.bytes !== Array)
                    object.global_pubkey = $util.newBuffer(object.global_pubkey);
            }
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.data != null && message.hasOwnProperty("data"))
            object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
        if (message.global_commitment != null && message.hasOwnProperty("global_commitment"))
            object.global_commitment = options.bytes === String ? $util.base64.encode(message.global_commitment, 0, message.global_commitment.length) : options.bytes === Array ? Array.prototype.slice.call(message.global_commitment) : message.global_commitment;
        if (message.global_pubkey != null && message.hasOwnProperty("global_pubkey"))
            object.global_pubkey = options.bytes === String ? $util.base64.encode(message.global_pubkey, 0, message.global_pubkey.length) : options.bytes === Array ? Array.prototype.slice.call(message.global_pubkey) : message.global_pubkey;
        return object;
    };

    CosiSign.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CosiSign;
})();

$root.CosiSignature = (function() {

    function CosiSignature(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CosiSignature.prototype.signature = $util.newBuffer([]);

    CosiSignature.create = function create(properties) {
        return new CosiSignature(properties);
    };

    CosiSignature.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.signature);
        return writer;
    };

    CosiSignature.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CosiSignature.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CosiSignature();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.signature = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        return message;
    };

    CosiSignature.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CosiSignature.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        return null;
    };

    CosiSignature.fromObject = function fromObject(object) {
        if (object instanceof $root.CosiSignature)
            return object;
        var message = new $root.CosiSignature();
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        return message;
    };

    CosiSignature.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        return object;
    };

    CosiSignature.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CosiSignature;
})();

$root.BatchGetPublickeys = (function() {

    function BatchGetPublickeys(properties) {
        this.paths = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    BatchGetPublickeys.prototype.ecdsa_curve_name = "ed25519";
    BatchGetPublickeys.prototype.paths = $util.emptyArray;
    BatchGetPublickeys.prototype.include_node = false;

    BatchGetPublickeys.create = function create(properties) {
        return new BatchGetPublickeys(properties);
    };

    BatchGetPublickeys.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.ecdsa_curve_name != null && Object.hasOwnProperty.call(message, "ecdsa_curve_name"))
            writer.uint32(10).string(message.ecdsa_curve_name);
        if (message.paths != null && message.paths.length)
            for (var i = 0; i < message.paths.length; ++i)
                $root.BatchGetPublickeys.Path.encode(message.paths[i], writer.uint32(18).fork()).ldelim();
        if (message.include_node != null && Object.hasOwnProperty.call(message, "include_node"))
            writer.uint32(24).bool(message.include_node);
        return writer;
    };

    BatchGetPublickeys.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    BatchGetPublickeys.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BatchGetPublickeys();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.ecdsa_curve_name = reader.string();
                break;
            case 2:
                if (!(message.paths && message.paths.length))
                    message.paths = [];
                message.paths.push($root.BatchGetPublickeys.Path.decode(reader, reader.uint32()));
                break;
            case 3:
                message.include_node = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    BatchGetPublickeys.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    BatchGetPublickeys.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.ecdsa_curve_name != null && message.hasOwnProperty("ecdsa_curve_name"))
            if (!$util.isString(message.ecdsa_curve_name))
                return "ecdsa_curve_name: string expected";
        if (message.paths != null && message.hasOwnProperty("paths")) {
            if (!Array.isArray(message.paths))
                return "paths: array expected";
            for (var i = 0; i < message.paths.length; ++i) {
                var error = $root.BatchGetPublickeys.Path.verify(message.paths[i]);
                if (error)
                    return "paths." + error;
            }
        }
        if (message.include_node != null && message.hasOwnProperty("include_node"))
            if (typeof message.include_node !== "boolean")
                return "include_node: boolean expected";
        return null;
    };

    BatchGetPublickeys.fromObject = function fromObject(object) {
        if (object instanceof $root.BatchGetPublickeys)
            return object;
        var message = new $root.BatchGetPublickeys();
        if (object.ecdsa_curve_name != null)
            message.ecdsa_curve_name = String(object.ecdsa_curve_name);
        if (object.paths) {
            if (!Array.isArray(object.paths))
                throw TypeError(".BatchGetPublickeys.paths: array expected");
            message.paths = [];
            for (var i = 0; i < object.paths.length; ++i) {
                if (typeof object.paths[i] !== "object")
                    throw TypeError(".BatchGetPublickeys.paths: object expected");
                message.paths[i] = $root.BatchGetPublickeys.Path.fromObject(object.paths[i]);
            }
        }
        if (object.include_node != null)
            message.include_node = Boolean(object.include_node);
        return message;
    };

    BatchGetPublickeys.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.paths = [];
        if (options.defaults) {
            object.ecdsa_curve_name = "ed25519";
            object.include_node = false;
        }
        if (message.ecdsa_curve_name != null && message.hasOwnProperty("ecdsa_curve_name"))
            object.ecdsa_curve_name = message.ecdsa_curve_name;
        if (message.paths && message.paths.length) {
            object.paths = [];
            for (var j = 0; j < message.paths.length; ++j)
                object.paths[j] = $root.BatchGetPublickeys.Path.toObject(message.paths[j], options);
        }
        if (message.include_node != null && message.hasOwnProperty("include_node"))
            object.include_node = message.include_node;
        return object;
    };

    BatchGetPublickeys.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    BatchGetPublickeys.Path = (function() {

        function Path(properties) {
            this.address_n = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        Path.prototype.address_n = $util.emptyArray;

        Path.create = function create(properties) {
            return new Path(properties);
        };

        Path.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.address_n != null && message.address_n.length)
                for (var i = 0; i < message.address_n.length; ++i)
                    writer.uint32(8).uint32(message.address_n[i]);
            return writer;
        };

        Path.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        Path.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BatchGetPublickeys.Path();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.address_n && message.address_n.length))
                        message.address_n = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.address_n.push(reader.uint32());
                    } else
                        message.address_n.push(reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        Path.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        Path.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.address_n != null && message.hasOwnProperty("address_n")) {
                if (!Array.isArray(message.address_n))
                    return "address_n: array expected";
                for (var i = 0; i < message.address_n.length; ++i)
                    if (!$util.isInteger(message.address_n[i]))
                        return "address_n: integer[] expected";
            }
            return null;
        };

        Path.fromObject = function fromObject(object) {
            if (object instanceof $root.BatchGetPublickeys.Path)
                return object;
            var message = new $root.BatchGetPublickeys.Path();
            if (object.address_n) {
                if (!Array.isArray(object.address_n))
                    throw TypeError(".BatchGetPublickeys.Path.address_n: array expected");
                message.address_n = [];
                for (var i = 0; i < object.address_n.length; ++i)
                    message.address_n[i] = object.address_n[i] >>> 0;
            }
            return message;
        };

        Path.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.address_n = [];
            if (message.address_n && message.address_n.length) {
                object.address_n = [];
                for (var j = 0; j < message.address_n.length; ++j)
                    object.address_n[j] = message.address_n[j];
            }
            return object;
        };

        Path.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Path;
    })();

    return BatchGetPublickeys;
})();

$root.EcdsaPublicKeys = (function() {

    function EcdsaPublicKeys(properties) {
        this.public_keys = [];
        this.hd_nodes = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EcdsaPublicKeys.prototype.public_keys = $util.emptyArray;
    EcdsaPublicKeys.prototype.hd_nodes = $util.emptyArray;
    EcdsaPublicKeys.prototype.root_fingerprint = 0;

    EcdsaPublicKeys.create = function create(properties) {
        return new EcdsaPublicKeys(properties);
    };

    EcdsaPublicKeys.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.public_keys != null && message.public_keys.length)
            for (var i = 0; i < message.public_keys.length; ++i)
                writer.uint32(10).bytes(message.public_keys[i]);
        if (message.hd_nodes != null && message.hd_nodes.length)
            for (var i = 0; i < message.hd_nodes.length; ++i)
                $root.HDNodeType.encode(message.hd_nodes[i], writer.uint32(18).fork()).ldelim();
        if (message.root_fingerprint != null && Object.hasOwnProperty.call(message, "root_fingerprint"))
            writer.uint32(24).uint32(message.root_fingerprint);
        return writer;
    };

    EcdsaPublicKeys.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EcdsaPublicKeys.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EcdsaPublicKeys();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.public_keys && message.public_keys.length))
                    message.public_keys = [];
                message.public_keys.push(reader.bytes());
                break;
            case 2:
                if (!(message.hd_nodes && message.hd_nodes.length))
                    message.hd_nodes = [];
                message.hd_nodes.push($root.HDNodeType.decode(reader, reader.uint32()));
                break;
            case 3:
                message.root_fingerprint = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    EcdsaPublicKeys.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EcdsaPublicKeys.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.public_keys != null && message.hasOwnProperty("public_keys")) {
            if (!Array.isArray(message.public_keys))
                return "public_keys: array expected";
            for (var i = 0; i < message.public_keys.length; ++i)
                if (!(message.public_keys[i] && typeof message.public_keys[i].length === "number" || $util.isString(message.public_keys[i])))
                    return "public_keys: buffer[] expected";
        }
        if (message.hd_nodes != null && message.hasOwnProperty("hd_nodes")) {
            if (!Array.isArray(message.hd_nodes))
                return "hd_nodes: array expected";
            for (var i = 0; i < message.hd_nodes.length; ++i) {
                var error = $root.HDNodeType.verify(message.hd_nodes[i]);
                if (error)
                    return "hd_nodes." + error;
            }
        }
        if (message.root_fingerprint != null && message.hasOwnProperty("root_fingerprint"))
            if (!$util.isInteger(message.root_fingerprint))
                return "root_fingerprint: integer expected";
        return null;
    };

    EcdsaPublicKeys.fromObject = function fromObject(object) {
        if (object instanceof $root.EcdsaPublicKeys)
            return object;
        var message = new $root.EcdsaPublicKeys();
        if (object.public_keys) {
            if (!Array.isArray(object.public_keys))
                throw TypeError(".EcdsaPublicKeys.public_keys: array expected");
            message.public_keys = [];
            for (var i = 0; i < object.public_keys.length; ++i)
                if (typeof object.public_keys[i] === "string")
                    $util.base64.decode(object.public_keys[i], message.public_keys[i] = $util.newBuffer($util.base64.length(object.public_keys[i])), 0);
                else if (object.public_keys[i].length)
                    message.public_keys[i] = object.public_keys[i];
        }
        if (object.hd_nodes) {
            if (!Array.isArray(object.hd_nodes))
                throw TypeError(".EcdsaPublicKeys.hd_nodes: array expected");
            message.hd_nodes = [];
            for (var i = 0; i < object.hd_nodes.length; ++i) {
                if (typeof object.hd_nodes[i] !== "object")
                    throw TypeError(".EcdsaPublicKeys.hd_nodes: object expected");
                message.hd_nodes[i] = $root.HDNodeType.fromObject(object.hd_nodes[i]);
            }
        }
        if (object.root_fingerprint != null)
            message.root_fingerprint = object.root_fingerprint >>> 0;
        return message;
    };

    EcdsaPublicKeys.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults) {
            object.public_keys = [];
            object.hd_nodes = [];
        }
        if (options.defaults)
            object.root_fingerprint = 0;
        if (message.public_keys && message.public_keys.length) {
            object.public_keys = [];
            for (var j = 0; j < message.public_keys.length; ++j)
                object.public_keys[j] = options.bytes === String ? $util.base64.encode(message.public_keys[j], 0, message.public_keys[j].length) : options.bytes === Array ? Array.prototype.slice.call(message.public_keys[j]) : message.public_keys[j];
        }
        if (message.hd_nodes && message.hd_nodes.length) {
            object.hd_nodes = [];
            for (var j = 0; j < message.hd_nodes.length; ++j)
                object.hd_nodes[j] = $root.HDNodeType.toObject(message.hd_nodes[j], options);
        }
        if (message.root_fingerprint != null && message.hasOwnProperty("root_fingerprint"))
            object.root_fingerprint = message.root_fingerprint;
        return object;
    };

    EcdsaPublicKeys.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EcdsaPublicKeys;
})();

$root.EosGetPublicKey = (function() {

    function EosGetPublicKey(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EosGetPublicKey.prototype.address_n = $util.emptyArray;
    EosGetPublicKey.prototype.show_display = false;

    EosGetPublicKey.create = function create(properties) {
        return new EosGetPublicKey(properties);
    };

    EosGetPublicKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(16).bool(message.show_display);
        return writer;
    };

    EosGetPublicKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EosGetPublicKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EosGetPublicKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.show_display = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    EosGetPublicKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EosGetPublicKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        return null;
    };

    EosGetPublicKey.fromObject = function fromObject(object) {
        if (object instanceof $root.EosGetPublicKey)
            return object;
        var message = new $root.EosGetPublicKey();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".EosGetPublicKey.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        return message;
    };

    EosGetPublicKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            object.show_display = false;
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        return object;
    };

    EosGetPublicKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EosGetPublicKey;
})();

$root.EosPublicKey = (function() {

    function EosPublicKey(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EosPublicKey.prototype.wif_public_key = "";
    EosPublicKey.prototype.raw_public_key = $util.newBuffer([]);

    EosPublicKey.create = function create(properties) {
        return new EosPublicKey(properties);
    };

    EosPublicKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.wif_public_key);
        writer.uint32(18).bytes(message.raw_public_key);
        return writer;
    };

    EosPublicKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EosPublicKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EosPublicKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.wif_public_key = reader.string();
                break;
            case 2:
                message.raw_public_key = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("wif_public_key"))
            throw $util.ProtocolError("missing required 'wif_public_key'", { instance: message });
        if (!message.hasOwnProperty("raw_public_key"))
            throw $util.ProtocolError("missing required 'raw_public_key'", { instance: message });
        return message;
    };

    EosPublicKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EosPublicKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.wif_public_key))
            return "wif_public_key: string expected";
        if (!(message.raw_public_key && typeof message.raw_public_key.length === "number" || $util.isString(message.raw_public_key)))
            return "raw_public_key: buffer expected";
        return null;
    };

    EosPublicKey.fromObject = function fromObject(object) {
        if (object instanceof $root.EosPublicKey)
            return object;
        var message = new $root.EosPublicKey();
        if (object.wif_public_key != null)
            message.wif_public_key = String(object.wif_public_key);
        if (object.raw_public_key != null)
            if (typeof object.raw_public_key === "string")
                $util.base64.decode(object.raw_public_key, message.raw_public_key = $util.newBuffer($util.base64.length(object.raw_public_key)), 0);
            else if (object.raw_public_key.length)
                message.raw_public_key = object.raw_public_key;
        return message;
    };

    EosPublicKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.wif_public_key = "";
            if (options.bytes === String)
                object.raw_public_key = "";
            else {
                object.raw_public_key = [];
                if (options.bytes !== Array)
                    object.raw_public_key = $util.newBuffer(object.raw_public_key);
            }
        }
        if (message.wif_public_key != null && message.hasOwnProperty("wif_public_key"))
            object.wif_public_key = message.wif_public_key;
        if (message.raw_public_key != null && message.hasOwnProperty("raw_public_key"))
            object.raw_public_key = options.bytes === String ? $util.base64.encode(message.raw_public_key, 0, message.raw_public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.raw_public_key) : message.raw_public_key;
        return object;
    };

    EosPublicKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EosPublicKey;
})();

$root.EosSignTx = (function() {

    function EosSignTx(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EosSignTx.prototype.address_n = $util.emptyArray;
    EosSignTx.prototype.chain_id = $util.newBuffer([]);
    EosSignTx.prototype.header = null;
    EosSignTx.prototype.num_actions = 0;

    EosSignTx.create = function create(properties) {
        return new EosSignTx(properties);
    };

    EosSignTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).bytes(message.chain_id);
        $root.EosSignTx.EosTxHeader.encode(message.header, writer.uint32(26).fork()).ldelim();
        writer.uint32(32).uint32(message.num_actions);
        return writer;
    };

    EosSignTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EosSignTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EosSignTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.chain_id = reader.bytes();
                break;
            case 3:
                message.header = $root.EosSignTx.EosTxHeader.decode(reader, reader.uint32());
                break;
            case 4:
                message.num_actions = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("chain_id"))
            throw $util.ProtocolError("missing required 'chain_id'", { instance: message });
        if (!message.hasOwnProperty("header"))
            throw $util.ProtocolError("missing required 'header'", { instance: message });
        if (!message.hasOwnProperty("num_actions"))
            throw $util.ProtocolError("missing required 'num_actions'", { instance: message });
        return message;
    };

    EosSignTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EosSignTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!(message.chain_id && typeof message.chain_id.length === "number" || $util.isString(message.chain_id)))
            return "chain_id: buffer expected";
        {
            var error = $root.EosSignTx.EosTxHeader.verify(message.header);
            if (error)
                return "header." + error;
        }
        if (!$util.isInteger(message.num_actions))
            return "num_actions: integer expected";
        return null;
    };

    EosSignTx.fromObject = function fromObject(object) {
        if (object instanceof $root.EosSignTx)
            return object;
        var message = new $root.EosSignTx();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".EosSignTx.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.chain_id != null)
            if (typeof object.chain_id === "string")
                $util.base64.decode(object.chain_id, message.chain_id = $util.newBuffer($util.base64.length(object.chain_id)), 0);
            else if (object.chain_id.length)
                message.chain_id = object.chain_id;
        if (object.header != null) {
            if (typeof object.header !== "object")
                throw TypeError(".EosSignTx.header: object expected");
            message.header = $root.EosSignTx.EosTxHeader.fromObject(object.header);
        }
        if (object.num_actions != null)
            message.num_actions = object.num_actions >>> 0;
        return message;
    };

    EosSignTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            if (options.bytes === String)
                object.chain_id = "";
            else {
                object.chain_id = [];
                if (options.bytes !== Array)
                    object.chain_id = $util.newBuffer(object.chain_id);
            }
            object.header = null;
            object.num_actions = 0;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.chain_id != null && message.hasOwnProperty("chain_id"))
            object.chain_id = options.bytes === String ? $util.base64.encode(message.chain_id, 0, message.chain_id.length) : options.bytes === Array ? Array.prototype.slice.call(message.chain_id) : message.chain_id;
        if (message.header != null && message.hasOwnProperty("header"))
            object.header = $root.EosSignTx.EosTxHeader.toObject(message.header, options);
        if (message.num_actions != null && message.hasOwnProperty("num_actions"))
            object.num_actions = message.num_actions;
        return object;
    };

    EosSignTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    EosSignTx.EosTxHeader = (function() {

        function EosTxHeader(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        EosTxHeader.prototype.expiration = 0;
        EosTxHeader.prototype.ref_block_num = 0;
        EosTxHeader.prototype.ref_block_prefix = 0;
        EosTxHeader.prototype.max_net_usage_words = 0;
        EosTxHeader.prototype.max_cpu_usage_ms = 0;
        EosTxHeader.prototype.delay_sec = 0;

        EosTxHeader.create = function create(properties) {
            return new EosTxHeader(properties);
        };

        EosTxHeader.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(8).uint32(message.expiration);
            writer.uint32(16).uint32(message.ref_block_num);
            writer.uint32(24).uint32(message.ref_block_prefix);
            writer.uint32(32).uint32(message.max_net_usage_words);
            writer.uint32(40).uint32(message.max_cpu_usage_ms);
            writer.uint32(48).uint32(message.delay_sec);
            return writer;
        };

        EosTxHeader.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        EosTxHeader.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EosSignTx.EosTxHeader();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.expiration = reader.uint32();
                    break;
                case 2:
                    message.ref_block_num = reader.uint32();
                    break;
                case 3:
                    message.ref_block_prefix = reader.uint32();
                    break;
                case 4:
                    message.max_net_usage_words = reader.uint32();
                    break;
                case 5:
                    message.max_cpu_usage_ms = reader.uint32();
                    break;
                case 6:
                    message.delay_sec = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("expiration"))
                throw $util.ProtocolError("missing required 'expiration'", { instance: message });
            if (!message.hasOwnProperty("ref_block_num"))
                throw $util.ProtocolError("missing required 'ref_block_num'", { instance: message });
            if (!message.hasOwnProperty("ref_block_prefix"))
                throw $util.ProtocolError("missing required 'ref_block_prefix'", { instance: message });
            if (!message.hasOwnProperty("max_net_usage_words"))
                throw $util.ProtocolError("missing required 'max_net_usage_words'", { instance: message });
            if (!message.hasOwnProperty("max_cpu_usage_ms"))
                throw $util.ProtocolError("missing required 'max_cpu_usage_ms'", { instance: message });
            if (!message.hasOwnProperty("delay_sec"))
                throw $util.ProtocolError("missing required 'delay_sec'", { instance: message });
            return message;
        };

        EosTxHeader.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        EosTxHeader.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isInteger(message.expiration))
                return "expiration: integer expected";
            if (!$util.isInteger(message.ref_block_num))
                return "ref_block_num: integer expected";
            if (!$util.isInteger(message.ref_block_prefix))
                return "ref_block_prefix: integer expected";
            if (!$util.isInteger(message.max_net_usage_words))
                return "max_net_usage_words: integer expected";
            if (!$util.isInteger(message.max_cpu_usage_ms))
                return "max_cpu_usage_ms: integer expected";
            if (!$util.isInteger(message.delay_sec))
                return "delay_sec: integer expected";
            return null;
        };

        EosTxHeader.fromObject = function fromObject(object) {
            if (object instanceof $root.EosSignTx.EosTxHeader)
                return object;
            var message = new $root.EosSignTx.EosTxHeader();
            if (object.expiration != null)
                message.expiration = object.expiration >>> 0;
            if (object.ref_block_num != null)
                message.ref_block_num = object.ref_block_num >>> 0;
            if (object.ref_block_prefix != null)
                message.ref_block_prefix = object.ref_block_prefix >>> 0;
            if (object.max_net_usage_words != null)
                message.max_net_usage_words = object.max_net_usage_words >>> 0;
            if (object.max_cpu_usage_ms != null)
                message.max_cpu_usage_ms = object.max_cpu_usage_ms >>> 0;
            if (object.delay_sec != null)
                message.delay_sec = object.delay_sec >>> 0;
            return message;
        };

        EosTxHeader.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.expiration = 0;
                object.ref_block_num = 0;
                object.ref_block_prefix = 0;
                object.max_net_usage_words = 0;
                object.max_cpu_usage_ms = 0;
                object.delay_sec = 0;
            }
            if (message.expiration != null && message.hasOwnProperty("expiration"))
                object.expiration = message.expiration;
            if (message.ref_block_num != null && message.hasOwnProperty("ref_block_num"))
                object.ref_block_num = message.ref_block_num;
            if (message.ref_block_prefix != null && message.hasOwnProperty("ref_block_prefix"))
                object.ref_block_prefix = message.ref_block_prefix;
            if (message.max_net_usage_words != null && message.hasOwnProperty("max_net_usage_words"))
                object.max_net_usage_words = message.max_net_usage_words;
            if (message.max_cpu_usage_ms != null && message.hasOwnProperty("max_cpu_usage_ms"))
                object.max_cpu_usage_ms = message.max_cpu_usage_ms;
            if (message.delay_sec != null && message.hasOwnProperty("delay_sec"))
                object.delay_sec = message.delay_sec;
            return object;
        };

        EosTxHeader.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EosTxHeader;
    })();

    return EosSignTx;
})();

$root.EosTxActionRequest = (function() {

    function EosTxActionRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EosTxActionRequest.prototype.data_size = 0;

    EosTxActionRequest.create = function create(properties) {
        return new EosTxActionRequest(properties);
    };

    EosTxActionRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.data_size != null && Object.hasOwnProperty.call(message, "data_size"))
            writer.uint32(8).uint32(message.data_size);
        return writer;
    };

    EosTxActionRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EosTxActionRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EosTxActionRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.data_size = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    EosTxActionRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EosTxActionRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.data_size != null && message.hasOwnProperty("data_size"))
            if (!$util.isInteger(message.data_size))
                return "data_size: integer expected";
        return null;
    };

    EosTxActionRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.EosTxActionRequest)
            return object;
        var message = new $root.EosTxActionRequest();
        if (object.data_size != null)
            message.data_size = object.data_size >>> 0;
        return message;
    };

    EosTxActionRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.data_size = 0;
        if (message.data_size != null && message.hasOwnProperty("data_size"))
            object.data_size = message.data_size;
        return object;
    };

    EosTxActionRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EosTxActionRequest;
})();

$root.EosTxActionAck = (function() {

    function EosTxActionAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EosTxActionAck.prototype.common = null;
    EosTxActionAck.prototype.transfer = null;
    EosTxActionAck.prototype.delegate = null;
    EosTxActionAck.prototype.undelegate = null;
    EosTxActionAck.prototype.refund = null;
    EosTxActionAck.prototype.buy_ram = null;
    EosTxActionAck.prototype.buy_ram_bytes = null;
    EosTxActionAck.prototype.sell_ram = null;
    EosTxActionAck.prototype.vote_producer = null;
    EosTxActionAck.prototype.update_auth = null;
    EosTxActionAck.prototype.delete_auth = null;
    EosTxActionAck.prototype.link_auth = null;
    EosTxActionAck.prototype.unlink_auth = null;
    EosTxActionAck.prototype.new_account = null;
    EosTxActionAck.prototype.unknown = null;

    EosTxActionAck.create = function create(properties) {
        return new EosTxActionAck(properties);
    };

    EosTxActionAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        $root.EosTxActionAck.EosActionCommon.encode(message.common, writer.uint32(10).fork()).ldelim();
        if (message.transfer != null && Object.hasOwnProperty.call(message, "transfer"))
            $root.EosTxActionAck.EosActionTransfer.encode(message.transfer, writer.uint32(18).fork()).ldelim();
        if (message.delegate != null && Object.hasOwnProperty.call(message, "delegate"))
            $root.EosTxActionAck.EosActionDelegate.encode(message.delegate, writer.uint32(26).fork()).ldelim();
        if (message.undelegate != null && Object.hasOwnProperty.call(message, "undelegate"))
            $root.EosTxActionAck.EosActionUndelegate.encode(message.undelegate, writer.uint32(34).fork()).ldelim();
        if (message.refund != null && Object.hasOwnProperty.call(message, "refund"))
            $root.EosTxActionAck.EosActionRefund.encode(message.refund, writer.uint32(42).fork()).ldelim();
        if (message.buy_ram != null && Object.hasOwnProperty.call(message, "buy_ram"))
            $root.EosTxActionAck.EosActionBuyRam.encode(message.buy_ram, writer.uint32(50).fork()).ldelim();
        if (message.buy_ram_bytes != null && Object.hasOwnProperty.call(message, "buy_ram_bytes"))
            $root.EosTxActionAck.EosActionBuyRamBytes.encode(message.buy_ram_bytes, writer.uint32(58).fork()).ldelim();
        if (message.sell_ram != null && Object.hasOwnProperty.call(message, "sell_ram"))
            $root.EosTxActionAck.EosActionSellRam.encode(message.sell_ram, writer.uint32(66).fork()).ldelim();
        if (message.vote_producer != null && Object.hasOwnProperty.call(message, "vote_producer"))
            $root.EosTxActionAck.EosActionVoteProducer.encode(message.vote_producer, writer.uint32(74).fork()).ldelim();
        if (message.update_auth != null && Object.hasOwnProperty.call(message, "update_auth"))
            $root.EosTxActionAck.EosActionUpdateAuth.encode(message.update_auth, writer.uint32(82).fork()).ldelim();
        if (message.delete_auth != null && Object.hasOwnProperty.call(message, "delete_auth"))
            $root.EosTxActionAck.EosActionDeleteAuth.encode(message.delete_auth, writer.uint32(90).fork()).ldelim();
        if (message.link_auth != null && Object.hasOwnProperty.call(message, "link_auth"))
            $root.EosTxActionAck.EosActionLinkAuth.encode(message.link_auth, writer.uint32(98).fork()).ldelim();
        if (message.unlink_auth != null && Object.hasOwnProperty.call(message, "unlink_auth"))
            $root.EosTxActionAck.EosActionUnlinkAuth.encode(message.unlink_auth, writer.uint32(106).fork()).ldelim();
        if (message.new_account != null && Object.hasOwnProperty.call(message, "new_account"))
            $root.EosTxActionAck.EosActionNewAccount.encode(message.new_account, writer.uint32(114).fork()).ldelim();
        if (message.unknown != null && Object.hasOwnProperty.call(message, "unknown"))
            $root.EosTxActionAck.EosActionUnknown.encode(message.unknown, writer.uint32(122).fork()).ldelim();
        return writer;
    };

    EosTxActionAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EosTxActionAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EosTxActionAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.common = $root.EosTxActionAck.EosActionCommon.decode(reader, reader.uint32());
                break;
            case 2:
                message.transfer = $root.EosTxActionAck.EosActionTransfer.decode(reader, reader.uint32());
                break;
            case 3:
                message.delegate = $root.EosTxActionAck.EosActionDelegate.decode(reader, reader.uint32());
                break;
            case 4:
                message.undelegate = $root.EosTxActionAck.EosActionUndelegate.decode(reader, reader.uint32());
                break;
            case 5:
                message.refund = $root.EosTxActionAck.EosActionRefund.decode(reader, reader.uint32());
                break;
            case 6:
                message.buy_ram = $root.EosTxActionAck.EosActionBuyRam.decode(reader, reader.uint32());
                break;
            case 7:
                message.buy_ram_bytes = $root.EosTxActionAck.EosActionBuyRamBytes.decode(reader, reader.uint32());
                break;
            case 8:
                message.sell_ram = $root.EosTxActionAck.EosActionSellRam.decode(reader, reader.uint32());
                break;
            case 9:
                message.vote_producer = $root.EosTxActionAck.EosActionVoteProducer.decode(reader, reader.uint32());
                break;
            case 10:
                message.update_auth = $root.EosTxActionAck.EosActionUpdateAuth.decode(reader, reader.uint32());
                break;
            case 11:
                message.delete_auth = $root.EosTxActionAck.EosActionDeleteAuth.decode(reader, reader.uint32());
                break;
            case 12:
                message.link_auth = $root.EosTxActionAck.EosActionLinkAuth.decode(reader, reader.uint32());
                break;
            case 13:
                message.unlink_auth = $root.EosTxActionAck.EosActionUnlinkAuth.decode(reader, reader.uint32());
                break;
            case 14:
                message.new_account = $root.EosTxActionAck.EosActionNewAccount.decode(reader, reader.uint32());
                break;
            case 15:
                message.unknown = $root.EosTxActionAck.EosActionUnknown.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("common"))
            throw $util.ProtocolError("missing required 'common'", { instance: message });
        return message;
    };

    EosTxActionAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EosTxActionAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        {
            var error = $root.EosTxActionAck.EosActionCommon.verify(message.common);
            if (error)
                return "common." + error;
        }
        if (message.transfer != null && message.hasOwnProperty("transfer")) {
            var error = $root.EosTxActionAck.EosActionTransfer.verify(message.transfer);
            if (error)
                return "transfer." + error;
        }
        if (message.delegate != null && message.hasOwnProperty("delegate")) {
            var error = $root.EosTxActionAck.EosActionDelegate.verify(message.delegate);
            if (error)
                return "delegate." + error;
        }
        if (message.undelegate != null && message.hasOwnProperty("undelegate")) {
            var error = $root.EosTxActionAck.EosActionUndelegate.verify(message.undelegate);
            if (error)
                return "undelegate." + error;
        }
        if (message.refund != null && message.hasOwnProperty("refund")) {
            var error = $root.EosTxActionAck.EosActionRefund.verify(message.refund);
            if (error)
                return "refund." + error;
        }
        if (message.buy_ram != null && message.hasOwnProperty("buy_ram")) {
            var error = $root.EosTxActionAck.EosActionBuyRam.verify(message.buy_ram);
            if (error)
                return "buy_ram." + error;
        }
        if (message.buy_ram_bytes != null && message.hasOwnProperty("buy_ram_bytes")) {
            var error = $root.EosTxActionAck.EosActionBuyRamBytes.verify(message.buy_ram_bytes);
            if (error)
                return "buy_ram_bytes." + error;
        }
        if (message.sell_ram != null && message.hasOwnProperty("sell_ram")) {
            var error = $root.EosTxActionAck.EosActionSellRam.verify(message.sell_ram);
            if (error)
                return "sell_ram." + error;
        }
        if (message.vote_producer != null && message.hasOwnProperty("vote_producer")) {
            var error = $root.EosTxActionAck.EosActionVoteProducer.verify(message.vote_producer);
            if (error)
                return "vote_producer." + error;
        }
        if (message.update_auth != null && message.hasOwnProperty("update_auth")) {
            var error = $root.EosTxActionAck.EosActionUpdateAuth.verify(message.update_auth);
            if (error)
                return "update_auth." + error;
        }
        if (message.delete_auth != null && message.hasOwnProperty("delete_auth")) {
            var error = $root.EosTxActionAck.EosActionDeleteAuth.verify(message.delete_auth);
            if (error)
                return "delete_auth." + error;
        }
        if (message.link_auth != null && message.hasOwnProperty("link_auth")) {
            var error = $root.EosTxActionAck.EosActionLinkAuth.verify(message.link_auth);
            if (error)
                return "link_auth." + error;
        }
        if (message.unlink_auth != null && message.hasOwnProperty("unlink_auth")) {
            var error = $root.EosTxActionAck.EosActionUnlinkAuth.verify(message.unlink_auth);
            if (error)
                return "unlink_auth." + error;
        }
        if (message.new_account != null && message.hasOwnProperty("new_account")) {
            var error = $root.EosTxActionAck.EosActionNewAccount.verify(message.new_account);
            if (error)
                return "new_account." + error;
        }
        if (message.unknown != null && message.hasOwnProperty("unknown")) {
            var error = $root.EosTxActionAck.EosActionUnknown.verify(message.unknown);
            if (error)
                return "unknown." + error;
        }
        return null;
    };

    EosTxActionAck.fromObject = function fromObject(object) {
        if (object instanceof $root.EosTxActionAck)
            return object;
        var message = new $root.EosTxActionAck();
        if (object.common != null) {
            if (typeof object.common !== "object")
                throw TypeError(".EosTxActionAck.common: object expected");
            message.common = $root.EosTxActionAck.EosActionCommon.fromObject(object.common);
        }
        if (object.transfer != null) {
            if (typeof object.transfer !== "object")
                throw TypeError(".EosTxActionAck.transfer: object expected");
            message.transfer = $root.EosTxActionAck.EosActionTransfer.fromObject(object.transfer);
        }
        if (object.delegate != null) {
            if (typeof object.delegate !== "object")
                throw TypeError(".EosTxActionAck.delegate: object expected");
            message.delegate = $root.EosTxActionAck.EosActionDelegate.fromObject(object.delegate);
        }
        if (object.undelegate != null) {
            if (typeof object.undelegate !== "object")
                throw TypeError(".EosTxActionAck.undelegate: object expected");
            message.undelegate = $root.EosTxActionAck.EosActionUndelegate.fromObject(object.undelegate);
        }
        if (object.refund != null) {
            if (typeof object.refund !== "object")
                throw TypeError(".EosTxActionAck.refund: object expected");
            message.refund = $root.EosTxActionAck.EosActionRefund.fromObject(object.refund);
        }
        if (object.buy_ram != null) {
            if (typeof object.buy_ram !== "object")
                throw TypeError(".EosTxActionAck.buy_ram: object expected");
            message.buy_ram = $root.EosTxActionAck.EosActionBuyRam.fromObject(object.buy_ram);
        }
        if (object.buy_ram_bytes != null) {
            if (typeof object.buy_ram_bytes !== "object")
                throw TypeError(".EosTxActionAck.buy_ram_bytes: object expected");
            message.buy_ram_bytes = $root.EosTxActionAck.EosActionBuyRamBytes.fromObject(object.buy_ram_bytes);
        }
        if (object.sell_ram != null) {
            if (typeof object.sell_ram !== "object")
                throw TypeError(".EosTxActionAck.sell_ram: object expected");
            message.sell_ram = $root.EosTxActionAck.EosActionSellRam.fromObject(object.sell_ram);
        }
        if (object.vote_producer != null) {
            if (typeof object.vote_producer !== "object")
                throw TypeError(".EosTxActionAck.vote_producer: object expected");
            message.vote_producer = $root.EosTxActionAck.EosActionVoteProducer.fromObject(object.vote_producer);
        }
        if (object.update_auth != null) {
            if (typeof object.update_auth !== "object")
                throw TypeError(".EosTxActionAck.update_auth: object expected");
            message.update_auth = $root.EosTxActionAck.EosActionUpdateAuth.fromObject(object.update_auth);
        }
        if (object.delete_auth != null) {
            if (typeof object.delete_auth !== "object")
                throw TypeError(".EosTxActionAck.delete_auth: object expected");
            message.delete_auth = $root.EosTxActionAck.EosActionDeleteAuth.fromObject(object.delete_auth);
        }
        if (object.link_auth != null) {
            if (typeof object.link_auth !== "object")
                throw TypeError(".EosTxActionAck.link_auth: object expected");
            message.link_auth = $root.EosTxActionAck.EosActionLinkAuth.fromObject(object.link_auth);
        }
        if (object.unlink_auth != null) {
            if (typeof object.unlink_auth !== "object")
                throw TypeError(".EosTxActionAck.unlink_auth: object expected");
            message.unlink_auth = $root.EosTxActionAck.EosActionUnlinkAuth.fromObject(object.unlink_auth);
        }
        if (object.new_account != null) {
            if (typeof object.new_account !== "object")
                throw TypeError(".EosTxActionAck.new_account: object expected");
            message.new_account = $root.EosTxActionAck.EosActionNewAccount.fromObject(object.new_account);
        }
        if (object.unknown != null) {
            if (typeof object.unknown !== "object")
                throw TypeError(".EosTxActionAck.unknown: object expected");
            message.unknown = $root.EosTxActionAck.EosActionUnknown.fromObject(object.unknown);
        }
        return message;
    };

    EosTxActionAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.common = null;
            object.transfer = null;
            object.delegate = null;
            object.undelegate = null;
            object.refund = null;
            object.buy_ram = null;
            object.buy_ram_bytes = null;
            object.sell_ram = null;
            object.vote_producer = null;
            object.update_auth = null;
            object.delete_auth = null;
            object.link_auth = null;
            object.unlink_auth = null;
            object.new_account = null;
            object.unknown = null;
        }
        if (message.common != null && message.hasOwnProperty("common"))
            object.common = $root.EosTxActionAck.EosActionCommon.toObject(message.common, options);
        if (message.transfer != null && message.hasOwnProperty("transfer"))
            object.transfer = $root.EosTxActionAck.EosActionTransfer.toObject(message.transfer, options);
        if (message.delegate != null && message.hasOwnProperty("delegate"))
            object.delegate = $root.EosTxActionAck.EosActionDelegate.toObject(message.delegate, options);
        if (message.undelegate != null && message.hasOwnProperty("undelegate"))
            object.undelegate = $root.EosTxActionAck.EosActionUndelegate.toObject(message.undelegate, options);
        if (message.refund != null && message.hasOwnProperty("refund"))
            object.refund = $root.EosTxActionAck.EosActionRefund.toObject(message.refund, options);
        if (message.buy_ram != null && message.hasOwnProperty("buy_ram"))
            object.buy_ram = $root.EosTxActionAck.EosActionBuyRam.toObject(message.buy_ram, options);
        if (message.buy_ram_bytes != null && message.hasOwnProperty("buy_ram_bytes"))
            object.buy_ram_bytes = $root.EosTxActionAck.EosActionBuyRamBytes.toObject(message.buy_ram_bytes, options);
        if (message.sell_ram != null && message.hasOwnProperty("sell_ram"))
            object.sell_ram = $root.EosTxActionAck.EosActionSellRam.toObject(message.sell_ram, options);
        if (message.vote_producer != null && message.hasOwnProperty("vote_producer"))
            object.vote_producer = $root.EosTxActionAck.EosActionVoteProducer.toObject(message.vote_producer, options);
        if (message.update_auth != null && message.hasOwnProperty("update_auth"))
            object.update_auth = $root.EosTxActionAck.EosActionUpdateAuth.toObject(message.update_auth, options);
        if (message.delete_auth != null && message.hasOwnProperty("delete_auth"))
            object.delete_auth = $root.EosTxActionAck.EosActionDeleteAuth.toObject(message.delete_auth, options);
        if (message.link_auth != null && message.hasOwnProperty("link_auth"))
            object.link_auth = $root.EosTxActionAck.EosActionLinkAuth.toObject(message.link_auth, options);
        if (message.unlink_auth != null && message.hasOwnProperty("unlink_auth"))
            object.unlink_auth = $root.EosTxActionAck.EosActionUnlinkAuth.toObject(message.unlink_auth, options);
        if (message.new_account != null && message.hasOwnProperty("new_account"))
            object.new_account = $root.EosTxActionAck.EosActionNewAccount.toObject(message.new_account, options);
        if (message.unknown != null && message.hasOwnProperty("unknown"))
            object.unknown = $root.EosTxActionAck.EosActionUnknown.toObject(message.unknown, options);
        return object;
    };

    EosTxActionAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    EosTxActionAck.EosAsset = (function() {

        function EosAsset(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        EosAsset.prototype.amount = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        EosAsset.prototype.symbol = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        EosAsset.create = function create(properties) {
            return new EosAsset(properties);
        };

        EosAsset.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(8).sint64(message.amount);
            writer.uint32(16).uint64(message.symbol);
            return writer;
        };

        EosAsset.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        EosAsset.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EosTxActionAck.EosAsset();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.amount = reader.sint64();
                    break;
                case 2:
                    message.symbol = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("amount"))
                throw $util.ProtocolError("missing required 'amount'", { instance: message });
            if (!message.hasOwnProperty("symbol"))
                throw $util.ProtocolError("missing required 'symbol'", { instance: message });
            return message;
        };

        EosAsset.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        EosAsset.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
                return "amount: integer|Long expected";
            if (!$util.isInteger(message.symbol) && !(message.symbol && $util.isInteger(message.symbol.low) && $util.isInteger(message.symbol.high)))
                return "symbol: integer|Long expected";
            return null;
        };

        EosAsset.fromObject = function fromObject(object) {
            if (object instanceof $root.EosTxActionAck.EosAsset)
                return object;
            var message = new $root.EosTxActionAck.EosAsset();
            if (object.amount != null)
                if ($util.Long)
                    (message.amount = $util.Long.fromValue(object.amount)).unsigned = false;
                else if (typeof object.amount === "string")
                    message.amount = parseInt(object.amount, 10);
                else if (typeof object.amount === "number")
                    message.amount = object.amount;
                else if (typeof object.amount === "object")
                    message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber();
            if (object.symbol != null)
                if ($util.Long)
                    (message.symbol = $util.Long.fromValue(object.symbol)).unsigned = true;
                else if (typeof object.symbol === "string")
                    message.symbol = parseInt(object.symbol, 10);
                else if (typeof object.symbol === "number")
                    message.symbol = object.symbol;
                else if (typeof object.symbol === "object")
                    message.symbol = new $util.LongBits(object.symbol.low >>> 0, object.symbol.high >>> 0).toNumber(true);
            return message;
        };

        EosAsset.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.amount = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.symbol = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.symbol = options.longs === String ? "0" : 0;
            }
            if (message.amount != null && message.hasOwnProperty("amount"))
                if (typeof message.amount === "number")
                    object.amount = options.longs === String ? String(message.amount) : message.amount;
                else
                    object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber() : message.amount;
            if (message.symbol != null && message.hasOwnProperty("symbol"))
                if (typeof message.symbol === "number")
                    object.symbol = options.longs === String ? String(message.symbol) : message.symbol;
                else
                    object.symbol = options.longs === String ? $util.Long.prototype.toString.call(message.symbol) : options.longs === Number ? new $util.LongBits(message.symbol.low >>> 0, message.symbol.high >>> 0).toNumber(true) : message.symbol;
            return object;
        };

        EosAsset.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EosAsset;
    })();

    EosTxActionAck.EosPermissionLevel = (function() {

        function EosPermissionLevel(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        EosPermissionLevel.prototype.actor = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        EosPermissionLevel.prototype.permission = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        EosPermissionLevel.create = function create(properties) {
            return new EosPermissionLevel(properties);
        };

        EosPermissionLevel.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(8).uint64(message.actor);
            writer.uint32(16).uint64(message.permission);
            return writer;
        };

        EosPermissionLevel.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        EosPermissionLevel.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EosTxActionAck.EosPermissionLevel();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.actor = reader.uint64();
                    break;
                case 2:
                    message.permission = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("actor"))
                throw $util.ProtocolError("missing required 'actor'", { instance: message });
            if (!message.hasOwnProperty("permission"))
                throw $util.ProtocolError("missing required 'permission'", { instance: message });
            return message;
        };

        EosPermissionLevel.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        EosPermissionLevel.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isInteger(message.actor) && !(message.actor && $util.isInteger(message.actor.low) && $util.isInteger(message.actor.high)))
                return "actor: integer|Long expected";
            if (!$util.isInteger(message.permission) && !(message.permission && $util.isInteger(message.permission.low) && $util.isInteger(message.permission.high)))
                return "permission: integer|Long expected";
            return null;
        };

        EosPermissionLevel.fromObject = function fromObject(object) {
            if (object instanceof $root.EosTxActionAck.EosPermissionLevel)
                return object;
            var message = new $root.EosTxActionAck.EosPermissionLevel();
            if (object.actor != null)
                if ($util.Long)
                    (message.actor = $util.Long.fromValue(object.actor)).unsigned = true;
                else if (typeof object.actor === "string")
                    message.actor = parseInt(object.actor, 10);
                else if (typeof object.actor === "number")
                    message.actor = object.actor;
                else if (typeof object.actor === "object")
                    message.actor = new $util.LongBits(object.actor.low >>> 0, object.actor.high >>> 0).toNumber(true);
            if (object.permission != null)
                if ($util.Long)
                    (message.permission = $util.Long.fromValue(object.permission)).unsigned = true;
                else if (typeof object.permission === "string")
                    message.permission = parseInt(object.permission, 10);
                else if (typeof object.permission === "number")
                    message.permission = object.permission;
                else if (typeof object.permission === "object")
                    message.permission = new $util.LongBits(object.permission.low >>> 0, object.permission.high >>> 0).toNumber(true);
            return message;
        };

        EosPermissionLevel.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.actor = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.actor = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.permission = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.permission = options.longs === String ? "0" : 0;
            }
            if (message.actor != null && message.hasOwnProperty("actor"))
                if (typeof message.actor === "number")
                    object.actor = options.longs === String ? String(message.actor) : message.actor;
                else
                    object.actor = options.longs === String ? $util.Long.prototype.toString.call(message.actor) : options.longs === Number ? new $util.LongBits(message.actor.low >>> 0, message.actor.high >>> 0).toNumber(true) : message.actor;
            if (message.permission != null && message.hasOwnProperty("permission"))
                if (typeof message.permission === "number")
                    object.permission = options.longs === String ? String(message.permission) : message.permission;
                else
                    object.permission = options.longs === String ? $util.Long.prototype.toString.call(message.permission) : options.longs === Number ? new $util.LongBits(message.permission.low >>> 0, message.permission.high >>> 0).toNumber(true) : message.permission;
            return object;
        };

        EosPermissionLevel.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EosPermissionLevel;
    })();

    EosTxActionAck.EosAuthorizationKey = (function() {

        function EosAuthorizationKey(properties) {
            this.address_n = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        EosAuthorizationKey.prototype.type = 0;
        EosAuthorizationKey.prototype.key = $util.newBuffer([]);
        EosAuthorizationKey.prototype.address_n = $util.emptyArray;
        EosAuthorizationKey.prototype.weight = 0;

        EosAuthorizationKey.create = function create(properties) {
            return new EosAuthorizationKey(properties);
        };

        EosAuthorizationKey.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(8).uint32(message.type);
            if (message.key != null && Object.hasOwnProperty.call(message, "key"))
                writer.uint32(18).bytes(message.key);
            if (message.address_n != null && message.address_n.length)
                for (var i = 0; i < message.address_n.length; ++i)
                    writer.uint32(24).uint32(message.address_n[i]);
            writer.uint32(32).uint32(message.weight);
            return writer;
        };

        EosAuthorizationKey.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        EosAuthorizationKey.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EosTxActionAck.EosAuthorizationKey();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.type = reader.uint32();
                    break;
                case 2:
                    message.key = reader.bytes();
                    break;
                case 3:
                    if (!(message.address_n && message.address_n.length))
                        message.address_n = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.address_n.push(reader.uint32());
                    } else
                        message.address_n.push(reader.uint32());
                    break;
                case 4:
                    message.weight = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("type"))
                throw $util.ProtocolError("missing required 'type'", { instance: message });
            if (!message.hasOwnProperty("weight"))
                throw $util.ProtocolError("missing required 'weight'", { instance: message });
            return message;
        };

        EosAuthorizationKey.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        EosAuthorizationKey.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isInteger(message.type))
                return "type: integer expected";
            if (message.key != null && message.hasOwnProperty("key"))
                if (!(message.key && typeof message.key.length === "number" || $util.isString(message.key)))
                    return "key: buffer expected";
            if (message.address_n != null && message.hasOwnProperty("address_n")) {
                if (!Array.isArray(message.address_n))
                    return "address_n: array expected";
                for (var i = 0; i < message.address_n.length; ++i)
                    if (!$util.isInteger(message.address_n[i]))
                        return "address_n: integer[] expected";
            }
            if (!$util.isInteger(message.weight))
                return "weight: integer expected";
            return null;
        };

        EosAuthorizationKey.fromObject = function fromObject(object) {
            if (object instanceof $root.EosTxActionAck.EosAuthorizationKey)
                return object;
            var message = new $root.EosTxActionAck.EosAuthorizationKey();
            if (object.type != null)
                message.type = object.type >>> 0;
            if (object.key != null)
                if (typeof object.key === "string")
                    $util.base64.decode(object.key, message.key = $util.newBuffer($util.base64.length(object.key)), 0);
                else if (object.key.length)
                    message.key = object.key;
            if (object.address_n) {
                if (!Array.isArray(object.address_n))
                    throw TypeError(".EosTxActionAck.EosAuthorizationKey.address_n: array expected");
                message.address_n = [];
                for (var i = 0; i < object.address_n.length; ++i)
                    message.address_n[i] = object.address_n[i] >>> 0;
            }
            if (object.weight != null)
                message.weight = object.weight >>> 0;
            return message;
        };

        EosAuthorizationKey.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.address_n = [];
            if (options.defaults) {
                object.type = 0;
                if (options.bytes === String)
                    object.key = "";
                else {
                    object.key = [];
                    if (options.bytes !== Array)
                        object.key = $util.newBuffer(object.key);
                }
                object.weight = 0;
            }
            if (message.type != null && message.hasOwnProperty("type"))
                object.type = message.type;
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = options.bytes === String ? $util.base64.encode(message.key, 0, message.key.length) : options.bytes === Array ? Array.prototype.slice.call(message.key) : message.key;
            if (message.address_n && message.address_n.length) {
                object.address_n = [];
                for (var j = 0; j < message.address_n.length; ++j)
                    object.address_n[j] = message.address_n[j];
            }
            if (message.weight != null && message.hasOwnProperty("weight"))
                object.weight = message.weight;
            return object;
        };

        EosAuthorizationKey.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EosAuthorizationKey;
    })();

    EosTxActionAck.EosAuthorizationAccount = (function() {

        function EosAuthorizationAccount(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        EosAuthorizationAccount.prototype.account = null;
        EosAuthorizationAccount.prototype.weight = 0;

        EosAuthorizationAccount.create = function create(properties) {
            return new EosAuthorizationAccount(properties);
        };

        EosAuthorizationAccount.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            $root.EosTxActionAck.EosPermissionLevel.encode(message.account, writer.uint32(10).fork()).ldelim();
            writer.uint32(16).uint32(message.weight);
            return writer;
        };

        EosAuthorizationAccount.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        EosAuthorizationAccount.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EosTxActionAck.EosAuthorizationAccount();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.account = $root.EosTxActionAck.EosPermissionLevel.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.weight = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("account"))
                throw $util.ProtocolError("missing required 'account'", { instance: message });
            if (!message.hasOwnProperty("weight"))
                throw $util.ProtocolError("missing required 'weight'", { instance: message });
            return message;
        };

        EosAuthorizationAccount.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        EosAuthorizationAccount.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            {
                var error = $root.EosTxActionAck.EosPermissionLevel.verify(message.account);
                if (error)
                    return "account." + error;
            }
            if (!$util.isInteger(message.weight))
                return "weight: integer expected";
            return null;
        };

        EosAuthorizationAccount.fromObject = function fromObject(object) {
            if (object instanceof $root.EosTxActionAck.EosAuthorizationAccount)
                return object;
            var message = new $root.EosTxActionAck.EosAuthorizationAccount();
            if (object.account != null) {
                if (typeof object.account !== "object")
                    throw TypeError(".EosTxActionAck.EosAuthorizationAccount.account: object expected");
                message.account = $root.EosTxActionAck.EosPermissionLevel.fromObject(object.account);
            }
            if (object.weight != null)
                message.weight = object.weight >>> 0;
            return message;
        };

        EosAuthorizationAccount.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.account = null;
                object.weight = 0;
            }
            if (message.account != null && message.hasOwnProperty("account"))
                object.account = $root.EosTxActionAck.EosPermissionLevel.toObject(message.account, options);
            if (message.weight != null && message.hasOwnProperty("weight"))
                object.weight = message.weight;
            return object;
        };

        EosAuthorizationAccount.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EosAuthorizationAccount;
    })();

    EosTxActionAck.EosAuthorizationWait = (function() {

        function EosAuthorizationWait(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        EosAuthorizationWait.prototype.wait_sec = 0;
        EosAuthorizationWait.prototype.weight = 0;

        EosAuthorizationWait.create = function create(properties) {
            return new EosAuthorizationWait(properties);
        };

        EosAuthorizationWait.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(8).uint32(message.wait_sec);
            writer.uint32(16).uint32(message.weight);
            return writer;
        };

        EosAuthorizationWait.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        EosAuthorizationWait.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EosTxActionAck.EosAuthorizationWait();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.wait_sec = reader.uint32();
                    break;
                case 2:
                    message.weight = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("wait_sec"))
                throw $util.ProtocolError("missing required 'wait_sec'", { instance: message });
            if (!message.hasOwnProperty("weight"))
                throw $util.ProtocolError("missing required 'weight'", { instance: message });
            return message;
        };

        EosAuthorizationWait.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        EosAuthorizationWait.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isInteger(message.wait_sec))
                return "wait_sec: integer expected";
            if (!$util.isInteger(message.weight))
                return "weight: integer expected";
            return null;
        };

        EosAuthorizationWait.fromObject = function fromObject(object) {
            if (object instanceof $root.EosTxActionAck.EosAuthorizationWait)
                return object;
            var message = new $root.EosTxActionAck.EosAuthorizationWait();
            if (object.wait_sec != null)
                message.wait_sec = object.wait_sec >>> 0;
            if (object.weight != null)
                message.weight = object.weight >>> 0;
            return message;
        };

        EosAuthorizationWait.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.wait_sec = 0;
                object.weight = 0;
            }
            if (message.wait_sec != null && message.hasOwnProperty("wait_sec"))
                object.wait_sec = message.wait_sec;
            if (message.weight != null && message.hasOwnProperty("weight"))
                object.weight = message.weight;
            return object;
        };

        EosAuthorizationWait.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EosAuthorizationWait;
    })();

    EosTxActionAck.EosAuthorization = (function() {

        function EosAuthorization(properties) {
            this.keys = [];
            this.accounts = [];
            this.waits = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        EosAuthorization.prototype.threshold = 0;
        EosAuthorization.prototype.keys = $util.emptyArray;
        EosAuthorization.prototype.accounts = $util.emptyArray;
        EosAuthorization.prototype.waits = $util.emptyArray;

        EosAuthorization.create = function create(properties) {
            return new EosAuthorization(properties);
        };

        EosAuthorization.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(8).uint32(message.threshold);
            if (message.keys != null && message.keys.length)
                for (var i = 0; i < message.keys.length; ++i)
                    $root.EosTxActionAck.EosAuthorizationKey.encode(message.keys[i], writer.uint32(18).fork()).ldelim();
            if (message.accounts != null && message.accounts.length)
                for (var i = 0; i < message.accounts.length; ++i)
                    $root.EosTxActionAck.EosAuthorizationAccount.encode(message.accounts[i], writer.uint32(26).fork()).ldelim();
            if (message.waits != null && message.waits.length)
                for (var i = 0; i < message.waits.length; ++i)
                    $root.EosTxActionAck.EosAuthorizationWait.encode(message.waits[i], writer.uint32(34).fork()).ldelim();
            return writer;
        };

        EosAuthorization.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        EosAuthorization.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EosTxActionAck.EosAuthorization();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.threshold = reader.uint32();
                    break;
                case 2:
                    if (!(message.keys && message.keys.length))
                        message.keys = [];
                    message.keys.push($root.EosTxActionAck.EosAuthorizationKey.decode(reader, reader.uint32()));
                    break;
                case 3:
                    if (!(message.accounts && message.accounts.length))
                        message.accounts = [];
                    message.accounts.push($root.EosTxActionAck.EosAuthorizationAccount.decode(reader, reader.uint32()));
                    break;
                case 4:
                    if (!(message.waits && message.waits.length))
                        message.waits = [];
                    message.waits.push($root.EosTxActionAck.EosAuthorizationWait.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("threshold"))
                throw $util.ProtocolError("missing required 'threshold'", { instance: message });
            return message;
        };

        EosAuthorization.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        EosAuthorization.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isInteger(message.threshold))
                return "threshold: integer expected";
            if (message.keys != null && message.hasOwnProperty("keys")) {
                if (!Array.isArray(message.keys))
                    return "keys: array expected";
                for (var i = 0; i < message.keys.length; ++i) {
                    var error = $root.EosTxActionAck.EosAuthorizationKey.verify(message.keys[i]);
                    if (error)
                        return "keys." + error;
                }
            }
            if (message.accounts != null && message.hasOwnProperty("accounts")) {
                if (!Array.isArray(message.accounts))
                    return "accounts: array expected";
                for (var i = 0; i < message.accounts.length; ++i) {
                    var error = $root.EosTxActionAck.EosAuthorizationAccount.verify(message.accounts[i]);
                    if (error)
                        return "accounts." + error;
                }
            }
            if (message.waits != null && message.hasOwnProperty("waits")) {
                if (!Array.isArray(message.waits))
                    return "waits: array expected";
                for (var i = 0; i < message.waits.length; ++i) {
                    var error = $root.EosTxActionAck.EosAuthorizationWait.verify(message.waits[i]);
                    if (error)
                        return "waits." + error;
                }
            }
            return null;
        };

        EosAuthorization.fromObject = function fromObject(object) {
            if (object instanceof $root.EosTxActionAck.EosAuthorization)
                return object;
            var message = new $root.EosTxActionAck.EosAuthorization();
            if (object.threshold != null)
                message.threshold = object.threshold >>> 0;
            if (object.keys) {
                if (!Array.isArray(object.keys))
                    throw TypeError(".EosTxActionAck.EosAuthorization.keys: array expected");
                message.keys = [];
                for (var i = 0; i < object.keys.length; ++i) {
                    if (typeof object.keys[i] !== "object")
                        throw TypeError(".EosTxActionAck.EosAuthorization.keys: object expected");
                    message.keys[i] = $root.EosTxActionAck.EosAuthorizationKey.fromObject(object.keys[i]);
                }
            }
            if (object.accounts) {
                if (!Array.isArray(object.accounts))
                    throw TypeError(".EosTxActionAck.EosAuthorization.accounts: array expected");
                message.accounts = [];
                for (var i = 0; i < object.accounts.length; ++i) {
                    if (typeof object.accounts[i] !== "object")
                        throw TypeError(".EosTxActionAck.EosAuthorization.accounts: object expected");
                    message.accounts[i] = $root.EosTxActionAck.EosAuthorizationAccount.fromObject(object.accounts[i]);
                }
            }
            if (object.waits) {
                if (!Array.isArray(object.waits))
                    throw TypeError(".EosTxActionAck.EosAuthorization.waits: array expected");
                message.waits = [];
                for (var i = 0; i < object.waits.length; ++i) {
                    if (typeof object.waits[i] !== "object")
                        throw TypeError(".EosTxActionAck.EosAuthorization.waits: object expected");
                    message.waits[i] = $root.EosTxActionAck.EosAuthorizationWait.fromObject(object.waits[i]);
                }
            }
            return message;
        };

        EosAuthorization.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.keys = [];
                object.accounts = [];
                object.waits = [];
            }
            if (options.defaults)
                object.threshold = 0;
            if (message.threshold != null && message.hasOwnProperty("threshold"))
                object.threshold = message.threshold;
            if (message.keys && message.keys.length) {
                object.keys = [];
                for (var j = 0; j < message.keys.length; ++j)
                    object.keys[j] = $root.EosTxActionAck.EosAuthorizationKey.toObject(message.keys[j], options);
            }
            if (message.accounts && message.accounts.length) {
                object.accounts = [];
                for (var j = 0; j < message.accounts.length; ++j)
                    object.accounts[j] = $root.EosTxActionAck.EosAuthorizationAccount.toObject(message.accounts[j], options);
            }
            if (message.waits && message.waits.length) {
                object.waits = [];
                for (var j = 0; j < message.waits.length; ++j)
                    object.waits[j] = $root.EosTxActionAck.EosAuthorizationWait.toObject(message.waits[j], options);
            }
            return object;
        };

        EosAuthorization.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EosAuthorization;
    })();

    EosTxActionAck.EosActionCommon = (function() {

        function EosActionCommon(properties) {
            this.authorization = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        EosActionCommon.prototype.account = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        EosActionCommon.prototype.name = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        EosActionCommon.prototype.authorization = $util.emptyArray;

        EosActionCommon.create = function create(properties) {
            return new EosActionCommon(properties);
        };

        EosActionCommon.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(8).uint64(message.account);
            writer.uint32(16).uint64(message.name);
            if (message.authorization != null && message.authorization.length)
                for (var i = 0; i < message.authorization.length; ++i)
                    $root.EosTxActionAck.EosPermissionLevel.encode(message.authorization[i], writer.uint32(26).fork()).ldelim();
            return writer;
        };

        EosActionCommon.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        EosActionCommon.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EosTxActionAck.EosActionCommon();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.account = reader.uint64();
                    break;
                case 2:
                    message.name = reader.uint64();
                    break;
                case 3:
                    if (!(message.authorization && message.authorization.length))
                        message.authorization = [];
                    message.authorization.push($root.EosTxActionAck.EosPermissionLevel.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("account"))
                throw $util.ProtocolError("missing required 'account'", { instance: message });
            if (!message.hasOwnProperty("name"))
                throw $util.ProtocolError("missing required 'name'", { instance: message });
            return message;
        };

        EosActionCommon.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        EosActionCommon.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isInteger(message.account) && !(message.account && $util.isInteger(message.account.low) && $util.isInteger(message.account.high)))
                return "account: integer|Long expected";
            if (!$util.isInteger(message.name) && !(message.name && $util.isInteger(message.name.low) && $util.isInteger(message.name.high)))
                return "name: integer|Long expected";
            if (message.authorization != null && message.hasOwnProperty("authorization")) {
                if (!Array.isArray(message.authorization))
                    return "authorization: array expected";
                for (var i = 0; i < message.authorization.length; ++i) {
                    var error = $root.EosTxActionAck.EosPermissionLevel.verify(message.authorization[i]);
                    if (error)
                        return "authorization." + error;
                }
            }
            return null;
        };

        EosActionCommon.fromObject = function fromObject(object) {
            if (object instanceof $root.EosTxActionAck.EosActionCommon)
                return object;
            var message = new $root.EosTxActionAck.EosActionCommon();
            if (object.account != null)
                if ($util.Long)
                    (message.account = $util.Long.fromValue(object.account)).unsigned = true;
                else if (typeof object.account === "string")
                    message.account = parseInt(object.account, 10);
                else if (typeof object.account === "number")
                    message.account = object.account;
                else if (typeof object.account === "object")
                    message.account = new $util.LongBits(object.account.low >>> 0, object.account.high >>> 0).toNumber(true);
            if (object.name != null)
                if ($util.Long)
                    (message.name = $util.Long.fromValue(object.name)).unsigned = true;
                else if (typeof object.name === "string")
                    message.name = parseInt(object.name, 10);
                else if (typeof object.name === "number")
                    message.name = object.name;
                else if (typeof object.name === "object")
                    message.name = new $util.LongBits(object.name.low >>> 0, object.name.high >>> 0).toNumber(true);
            if (object.authorization) {
                if (!Array.isArray(object.authorization))
                    throw TypeError(".EosTxActionAck.EosActionCommon.authorization: array expected");
                message.authorization = [];
                for (var i = 0; i < object.authorization.length; ++i) {
                    if (typeof object.authorization[i] !== "object")
                        throw TypeError(".EosTxActionAck.EosActionCommon.authorization: object expected");
                    message.authorization[i] = $root.EosTxActionAck.EosPermissionLevel.fromObject(object.authorization[i]);
                }
            }
            return message;
        };

        EosActionCommon.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.authorization = [];
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.account = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.account = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.name = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.name = options.longs === String ? "0" : 0;
            }
            if (message.account != null && message.hasOwnProperty("account"))
                if (typeof message.account === "number")
                    object.account = options.longs === String ? String(message.account) : message.account;
                else
                    object.account = options.longs === String ? $util.Long.prototype.toString.call(message.account) : options.longs === Number ? new $util.LongBits(message.account.low >>> 0, message.account.high >>> 0).toNumber(true) : message.account;
            if (message.name != null && message.hasOwnProperty("name"))
                if (typeof message.name === "number")
                    object.name = options.longs === String ? String(message.name) : message.name;
                else
                    object.name = options.longs === String ? $util.Long.prototype.toString.call(message.name) : options.longs === Number ? new $util.LongBits(message.name.low >>> 0, message.name.high >>> 0).toNumber(true) : message.name;
            if (message.authorization && message.authorization.length) {
                object.authorization = [];
                for (var j = 0; j < message.authorization.length; ++j)
                    object.authorization[j] = $root.EosTxActionAck.EosPermissionLevel.toObject(message.authorization[j], options);
            }
            return object;
        };

        EosActionCommon.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EosActionCommon;
    })();

    EosTxActionAck.EosActionTransfer = (function() {

        function EosActionTransfer(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        EosActionTransfer.prototype.sender = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        EosActionTransfer.prototype.receiver = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        EosActionTransfer.prototype.quantity = null;
        EosActionTransfer.prototype.memo = "";

        EosActionTransfer.create = function create(properties) {
            return new EosActionTransfer(properties);
        };

        EosActionTransfer.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(8).uint64(message.sender);
            writer.uint32(16).uint64(message.receiver);
            $root.EosTxActionAck.EosAsset.encode(message.quantity, writer.uint32(26).fork()).ldelim();
            writer.uint32(34).string(message.memo);
            return writer;
        };

        EosActionTransfer.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        EosActionTransfer.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EosTxActionAck.EosActionTransfer();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.sender = reader.uint64();
                    break;
                case 2:
                    message.receiver = reader.uint64();
                    break;
                case 3:
                    message.quantity = $root.EosTxActionAck.EosAsset.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.memo = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("sender"))
                throw $util.ProtocolError("missing required 'sender'", { instance: message });
            if (!message.hasOwnProperty("receiver"))
                throw $util.ProtocolError("missing required 'receiver'", { instance: message });
            if (!message.hasOwnProperty("quantity"))
                throw $util.ProtocolError("missing required 'quantity'", { instance: message });
            if (!message.hasOwnProperty("memo"))
                throw $util.ProtocolError("missing required 'memo'", { instance: message });
            return message;
        };

        EosActionTransfer.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        EosActionTransfer.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isInteger(message.sender) && !(message.sender && $util.isInteger(message.sender.low) && $util.isInteger(message.sender.high)))
                return "sender: integer|Long expected";
            if (!$util.isInteger(message.receiver) && !(message.receiver && $util.isInteger(message.receiver.low) && $util.isInteger(message.receiver.high)))
                return "receiver: integer|Long expected";
            {
                var error = $root.EosTxActionAck.EosAsset.verify(message.quantity);
                if (error)
                    return "quantity." + error;
            }
            if (!$util.isString(message.memo))
                return "memo: string expected";
            return null;
        };

        EosActionTransfer.fromObject = function fromObject(object) {
            if (object instanceof $root.EosTxActionAck.EosActionTransfer)
                return object;
            var message = new $root.EosTxActionAck.EosActionTransfer();
            if (object.sender != null)
                if ($util.Long)
                    (message.sender = $util.Long.fromValue(object.sender)).unsigned = true;
                else if (typeof object.sender === "string")
                    message.sender = parseInt(object.sender, 10);
                else if (typeof object.sender === "number")
                    message.sender = object.sender;
                else if (typeof object.sender === "object")
                    message.sender = new $util.LongBits(object.sender.low >>> 0, object.sender.high >>> 0).toNumber(true);
            if (object.receiver != null)
                if ($util.Long)
                    (message.receiver = $util.Long.fromValue(object.receiver)).unsigned = true;
                else if (typeof object.receiver === "string")
                    message.receiver = parseInt(object.receiver, 10);
                else if (typeof object.receiver === "number")
                    message.receiver = object.receiver;
                else if (typeof object.receiver === "object")
                    message.receiver = new $util.LongBits(object.receiver.low >>> 0, object.receiver.high >>> 0).toNumber(true);
            if (object.quantity != null) {
                if (typeof object.quantity !== "object")
                    throw TypeError(".EosTxActionAck.EosActionTransfer.quantity: object expected");
                message.quantity = $root.EosTxActionAck.EosAsset.fromObject(object.quantity);
            }
            if (object.memo != null)
                message.memo = String(object.memo);
            return message;
        };

        EosActionTransfer.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.sender = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.sender = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.receiver = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.receiver = options.longs === String ? "0" : 0;
                object.quantity = null;
                object.memo = "";
            }
            if (message.sender != null && message.hasOwnProperty("sender"))
                if (typeof message.sender === "number")
                    object.sender = options.longs === String ? String(message.sender) : message.sender;
                else
                    object.sender = options.longs === String ? $util.Long.prototype.toString.call(message.sender) : options.longs === Number ? new $util.LongBits(message.sender.low >>> 0, message.sender.high >>> 0).toNumber(true) : message.sender;
            if (message.receiver != null && message.hasOwnProperty("receiver"))
                if (typeof message.receiver === "number")
                    object.receiver = options.longs === String ? String(message.receiver) : message.receiver;
                else
                    object.receiver = options.longs === String ? $util.Long.prototype.toString.call(message.receiver) : options.longs === Number ? new $util.LongBits(message.receiver.low >>> 0, message.receiver.high >>> 0).toNumber(true) : message.receiver;
            if (message.quantity != null && message.hasOwnProperty("quantity"))
                object.quantity = $root.EosTxActionAck.EosAsset.toObject(message.quantity, options);
            if (message.memo != null && message.hasOwnProperty("memo"))
                object.memo = message.memo;
            return object;
        };

        EosActionTransfer.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EosActionTransfer;
    })();

    EosTxActionAck.EosActionDelegate = (function() {

        function EosActionDelegate(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        EosActionDelegate.prototype.sender = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        EosActionDelegate.prototype.receiver = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        EosActionDelegate.prototype.net_quantity = null;
        EosActionDelegate.prototype.cpu_quantity = null;
        EosActionDelegate.prototype.transfer = false;

        EosActionDelegate.create = function create(properties) {
            return new EosActionDelegate(properties);
        };

        EosActionDelegate.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(8).uint64(message.sender);
            writer.uint32(16).uint64(message.receiver);
            $root.EosTxActionAck.EosAsset.encode(message.net_quantity, writer.uint32(26).fork()).ldelim();
            $root.EosTxActionAck.EosAsset.encode(message.cpu_quantity, writer.uint32(34).fork()).ldelim();
            writer.uint32(40).bool(message.transfer);
            return writer;
        };

        EosActionDelegate.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        EosActionDelegate.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EosTxActionAck.EosActionDelegate();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.sender = reader.uint64();
                    break;
                case 2:
                    message.receiver = reader.uint64();
                    break;
                case 3:
                    message.net_quantity = $root.EosTxActionAck.EosAsset.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.cpu_quantity = $root.EosTxActionAck.EosAsset.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.transfer = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("sender"))
                throw $util.ProtocolError("missing required 'sender'", { instance: message });
            if (!message.hasOwnProperty("receiver"))
                throw $util.ProtocolError("missing required 'receiver'", { instance: message });
            if (!message.hasOwnProperty("net_quantity"))
                throw $util.ProtocolError("missing required 'net_quantity'", { instance: message });
            if (!message.hasOwnProperty("cpu_quantity"))
                throw $util.ProtocolError("missing required 'cpu_quantity'", { instance: message });
            if (!message.hasOwnProperty("transfer"))
                throw $util.ProtocolError("missing required 'transfer'", { instance: message });
            return message;
        };

        EosActionDelegate.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        EosActionDelegate.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isInteger(message.sender) && !(message.sender && $util.isInteger(message.sender.low) && $util.isInteger(message.sender.high)))
                return "sender: integer|Long expected";
            if (!$util.isInteger(message.receiver) && !(message.receiver && $util.isInteger(message.receiver.low) && $util.isInteger(message.receiver.high)))
                return "receiver: integer|Long expected";
            {
                var error = $root.EosTxActionAck.EosAsset.verify(message.net_quantity);
                if (error)
                    return "net_quantity." + error;
            }
            {
                var error = $root.EosTxActionAck.EosAsset.verify(message.cpu_quantity);
                if (error)
                    return "cpu_quantity." + error;
            }
            if (typeof message.transfer !== "boolean")
                return "transfer: boolean expected";
            return null;
        };

        EosActionDelegate.fromObject = function fromObject(object) {
            if (object instanceof $root.EosTxActionAck.EosActionDelegate)
                return object;
            var message = new $root.EosTxActionAck.EosActionDelegate();
            if (object.sender != null)
                if ($util.Long)
                    (message.sender = $util.Long.fromValue(object.sender)).unsigned = true;
                else if (typeof object.sender === "string")
                    message.sender = parseInt(object.sender, 10);
                else if (typeof object.sender === "number")
                    message.sender = object.sender;
                else if (typeof object.sender === "object")
                    message.sender = new $util.LongBits(object.sender.low >>> 0, object.sender.high >>> 0).toNumber(true);
            if (object.receiver != null)
                if ($util.Long)
                    (message.receiver = $util.Long.fromValue(object.receiver)).unsigned = true;
                else if (typeof object.receiver === "string")
                    message.receiver = parseInt(object.receiver, 10);
                else if (typeof object.receiver === "number")
                    message.receiver = object.receiver;
                else if (typeof object.receiver === "object")
                    message.receiver = new $util.LongBits(object.receiver.low >>> 0, object.receiver.high >>> 0).toNumber(true);
            if (object.net_quantity != null) {
                if (typeof object.net_quantity !== "object")
                    throw TypeError(".EosTxActionAck.EosActionDelegate.net_quantity: object expected");
                message.net_quantity = $root.EosTxActionAck.EosAsset.fromObject(object.net_quantity);
            }
            if (object.cpu_quantity != null) {
                if (typeof object.cpu_quantity !== "object")
                    throw TypeError(".EosTxActionAck.EosActionDelegate.cpu_quantity: object expected");
                message.cpu_quantity = $root.EosTxActionAck.EosAsset.fromObject(object.cpu_quantity);
            }
            if (object.transfer != null)
                message.transfer = Boolean(object.transfer);
            return message;
        };

        EosActionDelegate.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.sender = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.sender = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.receiver = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.receiver = options.longs === String ? "0" : 0;
                object.net_quantity = null;
                object.cpu_quantity = null;
                object.transfer = false;
            }
            if (message.sender != null && message.hasOwnProperty("sender"))
                if (typeof message.sender === "number")
                    object.sender = options.longs === String ? String(message.sender) : message.sender;
                else
                    object.sender = options.longs === String ? $util.Long.prototype.toString.call(message.sender) : options.longs === Number ? new $util.LongBits(message.sender.low >>> 0, message.sender.high >>> 0).toNumber(true) : message.sender;
            if (message.receiver != null && message.hasOwnProperty("receiver"))
                if (typeof message.receiver === "number")
                    object.receiver = options.longs === String ? String(message.receiver) : message.receiver;
                else
                    object.receiver = options.longs === String ? $util.Long.prototype.toString.call(message.receiver) : options.longs === Number ? new $util.LongBits(message.receiver.low >>> 0, message.receiver.high >>> 0).toNumber(true) : message.receiver;
            if (message.net_quantity != null && message.hasOwnProperty("net_quantity"))
                object.net_quantity = $root.EosTxActionAck.EosAsset.toObject(message.net_quantity, options);
            if (message.cpu_quantity != null && message.hasOwnProperty("cpu_quantity"))
                object.cpu_quantity = $root.EosTxActionAck.EosAsset.toObject(message.cpu_quantity, options);
            if (message.transfer != null && message.hasOwnProperty("transfer"))
                object.transfer = message.transfer;
            return object;
        };

        EosActionDelegate.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EosActionDelegate;
    })();

    EosTxActionAck.EosActionUndelegate = (function() {

        function EosActionUndelegate(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        EosActionUndelegate.prototype.sender = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        EosActionUndelegate.prototype.receiver = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        EosActionUndelegate.prototype.net_quantity = null;
        EosActionUndelegate.prototype.cpu_quantity = null;

        EosActionUndelegate.create = function create(properties) {
            return new EosActionUndelegate(properties);
        };

        EosActionUndelegate.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(8).uint64(message.sender);
            writer.uint32(16).uint64(message.receiver);
            $root.EosTxActionAck.EosAsset.encode(message.net_quantity, writer.uint32(26).fork()).ldelim();
            $root.EosTxActionAck.EosAsset.encode(message.cpu_quantity, writer.uint32(34).fork()).ldelim();
            return writer;
        };

        EosActionUndelegate.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        EosActionUndelegate.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EosTxActionAck.EosActionUndelegate();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.sender = reader.uint64();
                    break;
                case 2:
                    message.receiver = reader.uint64();
                    break;
                case 3:
                    message.net_quantity = $root.EosTxActionAck.EosAsset.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.cpu_quantity = $root.EosTxActionAck.EosAsset.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("sender"))
                throw $util.ProtocolError("missing required 'sender'", { instance: message });
            if (!message.hasOwnProperty("receiver"))
                throw $util.ProtocolError("missing required 'receiver'", { instance: message });
            if (!message.hasOwnProperty("net_quantity"))
                throw $util.ProtocolError("missing required 'net_quantity'", { instance: message });
            if (!message.hasOwnProperty("cpu_quantity"))
                throw $util.ProtocolError("missing required 'cpu_quantity'", { instance: message });
            return message;
        };

        EosActionUndelegate.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        EosActionUndelegate.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isInteger(message.sender) && !(message.sender && $util.isInteger(message.sender.low) && $util.isInteger(message.sender.high)))
                return "sender: integer|Long expected";
            if (!$util.isInteger(message.receiver) && !(message.receiver && $util.isInteger(message.receiver.low) && $util.isInteger(message.receiver.high)))
                return "receiver: integer|Long expected";
            {
                var error = $root.EosTxActionAck.EosAsset.verify(message.net_quantity);
                if (error)
                    return "net_quantity." + error;
            }
            {
                var error = $root.EosTxActionAck.EosAsset.verify(message.cpu_quantity);
                if (error)
                    return "cpu_quantity." + error;
            }
            return null;
        };

        EosActionUndelegate.fromObject = function fromObject(object) {
            if (object instanceof $root.EosTxActionAck.EosActionUndelegate)
                return object;
            var message = new $root.EosTxActionAck.EosActionUndelegate();
            if (object.sender != null)
                if ($util.Long)
                    (message.sender = $util.Long.fromValue(object.sender)).unsigned = true;
                else if (typeof object.sender === "string")
                    message.sender = parseInt(object.sender, 10);
                else if (typeof object.sender === "number")
                    message.sender = object.sender;
                else if (typeof object.sender === "object")
                    message.sender = new $util.LongBits(object.sender.low >>> 0, object.sender.high >>> 0).toNumber(true);
            if (object.receiver != null)
                if ($util.Long)
                    (message.receiver = $util.Long.fromValue(object.receiver)).unsigned = true;
                else if (typeof object.receiver === "string")
                    message.receiver = parseInt(object.receiver, 10);
                else if (typeof object.receiver === "number")
                    message.receiver = object.receiver;
                else if (typeof object.receiver === "object")
                    message.receiver = new $util.LongBits(object.receiver.low >>> 0, object.receiver.high >>> 0).toNumber(true);
            if (object.net_quantity != null) {
                if (typeof object.net_quantity !== "object")
                    throw TypeError(".EosTxActionAck.EosActionUndelegate.net_quantity: object expected");
                message.net_quantity = $root.EosTxActionAck.EosAsset.fromObject(object.net_quantity);
            }
            if (object.cpu_quantity != null) {
                if (typeof object.cpu_quantity !== "object")
                    throw TypeError(".EosTxActionAck.EosActionUndelegate.cpu_quantity: object expected");
                message.cpu_quantity = $root.EosTxActionAck.EosAsset.fromObject(object.cpu_quantity);
            }
            return message;
        };

        EosActionUndelegate.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.sender = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.sender = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.receiver = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.receiver = options.longs === String ? "0" : 0;
                object.net_quantity = null;
                object.cpu_quantity = null;
            }
            if (message.sender != null && message.hasOwnProperty("sender"))
                if (typeof message.sender === "number")
                    object.sender = options.longs === String ? String(message.sender) : message.sender;
                else
                    object.sender = options.longs === String ? $util.Long.prototype.toString.call(message.sender) : options.longs === Number ? new $util.LongBits(message.sender.low >>> 0, message.sender.high >>> 0).toNumber(true) : message.sender;
            if (message.receiver != null && message.hasOwnProperty("receiver"))
                if (typeof message.receiver === "number")
                    object.receiver = options.longs === String ? String(message.receiver) : message.receiver;
                else
                    object.receiver = options.longs === String ? $util.Long.prototype.toString.call(message.receiver) : options.longs === Number ? new $util.LongBits(message.receiver.low >>> 0, message.receiver.high >>> 0).toNumber(true) : message.receiver;
            if (message.net_quantity != null && message.hasOwnProperty("net_quantity"))
                object.net_quantity = $root.EosTxActionAck.EosAsset.toObject(message.net_quantity, options);
            if (message.cpu_quantity != null && message.hasOwnProperty("cpu_quantity"))
                object.cpu_quantity = $root.EosTxActionAck.EosAsset.toObject(message.cpu_quantity, options);
            return object;
        };

        EosActionUndelegate.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EosActionUndelegate;
    })();

    EosTxActionAck.EosActionRefund = (function() {

        function EosActionRefund(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        EosActionRefund.prototype.owner = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        EosActionRefund.create = function create(properties) {
            return new EosActionRefund(properties);
        };

        EosActionRefund.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(8).uint64(message.owner);
            return writer;
        };

        EosActionRefund.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        EosActionRefund.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EosTxActionAck.EosActionRefund();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.owner = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("owner"))
                throw $util.ProtocolError("missing required 'owner'", { instance: message });
            return message;
        };

        EosActionRefund.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        EosActionRefund.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isInteger(message.owner) && !(message.owner && $util.isInteger(message.owner.low) && $util.isInteger(message.owner.high)))
                return "owner: integer|Long expected";
            return null;
        };

        EosActionRefund.fromObject = function fromObject(object) {
            if (object instanceof $root.EosTxActionAck.EosActionRefund)
                return object;
            var message = new $root.EosTxActionAck.EosActionRefund();
            if (object.owner != null)
                if ($util.Long)
                    (message.owner = $util.Long.fromValue(object.owner)).unsigned = true;
                else if (typeof object.owner === "string")
                    message.owner = parseInt(object.owner, 10);
                else if (typeof object.owner === "number")
                    message.owner = object.owner;
                else if (typeof object.owner === "object")
                    message.owner = new $util.LongBits(object.owner.low >>> 0, object.owner.high >>> 0).toNumber(true);
            return message;
        };

        EosActionRefund.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.owner = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.owner = options.longs === String ? "0" : 0;
            if (message.owner != null && message.hasOwnProperty("owner"))
                if (typeof message.owner === "number")
                    object.owner = options.longs === String ? String(message.owner) : message.owner;
                else
                    object.owner = options.longs === String ? $util.Long.prototype.toString.call(message.owner) : options.longs === Number ? new $util.LongBits(message.owner.low >>> 0, message.owner.high >>> 0).toNumber(true) : message.owner;
            return object;
        };

        EosActionRefund.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EosActionRefund;
    })();

    EosTxActionAck.EosActionBuyRam = (function() {

        function EosActionBuyRam(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        EosActionBuyRam.prototype.payer = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        EosActionBuyRam.prototype.receiver = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        EosActionBuyRam.prototype.quantity = null;

        EosActionBuyRam.create = function create(properties) {
            return new EosActionBuyRam(properties);
        };

        EosActionBuyRam.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(8).uint64(message.payer);
            writer.uint32(16).uint64(message.receiver);
            $root.EosTxActionAck.EosAsset.encode(message.quantity, writer.uint32(26).fork()).ldelim();
            return writer;
        };

        EosActionBuyRam.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        EosActionBuyRam.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EosTxActionAck.EosActionBuyRam();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.payer = reader.uint64();
                    break;
                case 2:
                    message.receiver = reader.uint64();
                    break;
                case 3:
                    message.quantity = $root.EosTxActionAck.EosAsset.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("payer"))
                throw $util.ProtocolError("missing required 'payer'", { instance: message });
            if (!message.hasOwnProperty("receiver"))
                throw $util.ProtocolError("missing required 'receiver'", { instance: message });
            if (!message.hasOwnProperty("quantity"))
                throw $util.ProtocolError("missing required 'quantity'", { instance: message });
            return message;
        };

        EosActionBuyRam.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        EosActionBuyRam.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isInteger(message.payer) && !(message.payer && $util.isInteger(message.payer.low) && $util.isInteger(message.payer.high)))
                return "payer: integer|Long expected";
            if (!$util.isInteger(message.receiver) && !(message.receiver && $util.isInteger(message.receiver.low) && $util.isInteger(message.receiver.high)))
                return "receiver: integer|Long expected";
            {
                var error = $root.EosTxActionAck.EosAsset.verify(message.quantity);
                if (error)
                    return "quantity." + error;
            }
            return null;
        };

        EosActionBuyRam.fromObject = function fromObject(object) {
            if (object instanceof $root.EosTxActionAck.EosActionBuyRam)
                return object;
            var message = new $root.EosTxActionAck.EosActionBuyRam();
            if (object.payer != null)
                if ($util.Long)
                    (message.payer = $util.Long.fromValue(object.payer)).unsigned = true;
                else if (typeof object.payer === "string")
                    message.payer = parseInt(object.payer, 10);
                else if (typeof object.payer === "number")
                    message.payer = object.payer;
                else if (typeof object.payer === "object")
                    message.payer = new $util.LongBits(object.payer.low >>> 0, object.payer.high >>> 0).toNumber(true);
            if (object.receiver != null)
                if ($util.Long)
                    (message.receiver = $util.Long.fromValue(object.receiver)).unsigned = true;
                else if (typeof object.receiver === "string")
                    message.receiver = parseInt(object.receiver, 10);
                else if (typeof object.receiver === "number")
                    message.receiver = object.receiver;
                else if (typeof object.receiver === "object")
                    message.receiver = new $util.LongBits(object.receiver.low >>> 0, object.receiver.high >>> 0).toNumber(true);
            if (object.quantity != null) {
                if (typeof object.quantity !== "object")
                    throw TypeError(".EosTxActionAck.EosActionBuyRam.quantity: object expected");
                message.quantity = $root.EosTxActionAck.EosAsset.fromObject(object.quantity);
            }
            return message;
        };

        EosActionBuyRam.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.payer = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.payer = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.receiver = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.receiver = options.longs === String ? "0" : 0;
                object.quantity = null;
            }
            if (message.payer != null && message.hasOwnProperty("payer"))
                if (typeof message.payer === "number")
                    object.payer = options.longs === String ? String(message.payer) : message.payer;
                else
                    object.payer = options.longs === String ? $util.Long.prototype.toString.call(message.payer) : options.longs === Number ? new $util.LongBits(message.payer.low >>> 0, message.payer.high >>> 0).toNumber(true) : message.payer;
            if (message.receiver != null && message.hasOwnProperty("receiver"))
                if (typeof message.receiver === "number")
                    object.receiver = options.longs === String ? String(message.receiver) : message.receiver;
                else
                    object.receiver = options.longs === String ? $util.Long.prototype.toString.call(message.receiver) : options.longs === Number ? new $util.LongBits(message.receiver.low >>> 0, message.receiver.high >>> 0).toNumber(true) : message.receiver;
            if (message.quantity != null && message.hasOwnProperty("quantity"))
                object.quantity = $root.EosTxActionAck.EosAsset.toObject(message.quantity, options);
            return object;
        };

        EosActionBuyRam.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EosActionBuyRam;
    })();

    EosTxActionAck.EosActionBuyRamBytes = (function() {

        function EosActionBuyRamBytes(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        EosActionBuyRamBytes.prototype.payer = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        EosActionBuyRamBytes.prototype.receiver = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        EosActionBuyRamBytes.prototype.bytes = 0;

        EosActionBuyRamBytes.create = function create(properties) {
            return new EosActionBuyRamBytes(properties);
        };

        EosActionBuyRamBytes.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(8).uint64(message.payer);
            writer.uint32(16).uint64(message.receiver);
            writer.uint32(24).uint32(message.bytes);
            return writer;
        };

        EosActionBuyRamBytes.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        EosActionBuyRamBytes.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EosTxActionAck.EosActionBuyRamBytes();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.payer = reader.uint64();
                    break;
                case 2:
                    message.receiver = reader.uint64();
                    break;
                case 3:
                    message.bytes = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("payer"))
                throw $util.ProtocolError("missing required 'payer'", { instance: message });
            if (!message.hasOwnProperty("receiver"))
                throw $util.ProtocolError("missing required 'receiver'", { instance: message });
            if (!message.hasOwnProperty("bytes"))
                throw $util.ProtocolError("missing required 'bytes'", { instance: message });
            return message;
        };

        EosActionBuyRamBytes.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        EosActionBuyRamBytes.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isInteger(message.payer) && !(message.payer && $util.isInteger(message.payer.low) && $util.isInteger(message.payer.high)))
                return "payer: integer|Long expected";
            if (!$util.isInteger(message.receiver) && !(message.receiver && $util.isInteger(message.receiver.low) && $util.isInteger(message.receiver.high)))
                return "receiver: integer|Long expected";
            if (!$util.isInteger(message.bytes))
                return "bytes: integer expected";
            return null;
        };

        EosActionBuyRamBytes.fromObject = function fromObject(object) {
            if (object instanceof $root.EosTxActionAck.EosActionBuyRamBytes)
                return object;
            var message = new $root.EosTxActionAck.EosActionBuyRamBytes();
            if (object.payer != null)
                if ($util.Long)
                    (message.payer = $util.Long.fromValue(object.payer)).unsigned = true;
                else if (typeof object.payer === "string")
                    message.payer = parseInt(object.payer, 10);
                else if (typeof object.payer === "number")
                    message.payer = object.payer;
                else if (typeof object.payer === "object")
                    message.payer = new $util.LongBits(object.payer.low >>> 0, object.payer.high >>> 0).toNumber(true);
            if (object.receiver != null)
                if ($util.Long)
                    (message.receiver = $util.Long.fromValue(object.receiver)).unsigned = true;
                else if (typeof object.receiver === "string")
                    message.receiver = parseInt(object.receiver, 10);
                else if (typeof object.receiver === "number")
                    message.receiver = object.receiver;
                else if (typeof object.receiver === "object")
                    message.receiver = new $util.LongBits(object.receiver.low >>> 0, object.receiver.high >>> 0).toNumber(true);
            if (object.bytes != null)
                message.bytes = object.bytes >>> 0;
            return message;
        };

        EosActionBuyRamBytes.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.payer = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.payer = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.receiver = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.receiver = options.longs === String ? "0" : 0;
                object.bytes = 0;
            }
            if (message.payer != null && message.hasOwnProperty("payer"))
                if (typeof message.payer === "number")
                    object.payer = options.longs === String ? String(message.payer) : message.payer;
                else
                    object.payer = options.longs === String ? $util.Long.prototype.toString.call(message.payer) : options.longs === Number ? new $util.LongBits(message.payer.low >>> 0, message.payer.high >>> 0).toNumber(true) : message.payer;
            if (message.receiver != null && message.hasOwnProperty("receiver"))
                if (typeof message.receiver === "number")
                    object.receiver = options.longs === String ? String(message.receiver) : message.receiver;
                else
                    object.receiver = options.longs === String ? $util.Long.prototype.toString.call(message.receiver) : options.longs === Number ? new $util.LongBits(message.receiver.low >>> 0, message.receiver.high >>> 0).toNumber(true) : message.receiver;
            if (message.bytes != null && message.hasOwnProperty("bytes"))
                object.bytes = message.bytes;
            return object;
        };

        EosActionBuyRamBytes.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EosActionBuyRamBytes;
    })();

    EosTxActionAck.EosActionSellRam = (function() {

        function EosActionSellRam(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        EosActionSellRam.prototype.account = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        EosActionSellRam.prototype.bytes = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        EosActionSellRam.create = function create(properties) {
            return new EosActionSellRam(properties);
        };

        EosActionSellRam.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(8).uint64(message.account);
            writer.uint32(16).uint64(message.bytes);
            return writer;
        };

        EosActionSellRam.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        EosActionSellRam.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EosTxActionAck.EosActionSellRam();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.account = reader.uint64();
                    break;
                case 2:
                    message.bytes = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("account"))
                throw $util.ProtocolError("missing required 'account'", { instance: message });
            if (!message.hasOwnProperty("bytes"))
                throw $util.ProtocolError("missing required 'bytes'", { instance: message });
            return message;
        };

        EosActionSellRam.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        EosActionSellRam.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isInteger(message.account) && !(message.account && $util.isInteger(message.account.low) && $util.isInteger(message.account.high)))
                return "account: integer|Long expected";
            if (!$util.isInteger(message.bytes) && !(message.bytes && $util.isInteger(message.bytes.low) && $util.isInteger(message.bytes.high)))
                return "bytes: integer|Long expected";
            return null;
        };

        EosActionSellRam.fromObject = function fromObject(object) {
            if (object instanceof $root.EosTxActionAck.EosActionSellRam)
                return object;
            var message = new $root.EosTxActionAck.EosActionSellRam();
            if (object.account != null)
                if ($util.Long)
                    (message.account = $util.Long.fromValue(object.account)).unsigned = true;
                else if (typeof object.account === "string")
                    message.account = parseInt(object.account, 10);
                else if (typeof object.account === "number")
                    message.account = object.account;
                else if (typeof object.account === "object")
                    message.account = new $util.LongBits(object.account.low >>> 0, object.account.high >>> 0).toNumber(true);
            if (object.bytes != null)
                if ($util.Long)
                    (message.bytes = $util.Long.fromValue(object.bytes)).unsigned = true;
                else if (typeof object.bytes === "string")
                    message.bytes = parseInt(object.bytes, 10);
                else if (typeof object.bytes === "number")
                    message.bytes = object.bytes;
                else if (typeof object.bytes === "object")
                    message.bytes = new $util.LongBits(object.bytes.low >>> 0, object.bytes.high >>> 0).toNumber(true);
            return message;
        };

        EosActionSellRam.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.account = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.account = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.bytes = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.bytes = options.longs === String ? "0" : 0;
            }
            if (message.account != null && message.hasOwnProperty("account"))
                if (typeof message.account === "number")
                    object.account = options.longs === String ? String(message.account) : message.account;
                else
                    object.account = options.longs === String ? $util.Long.prototype.toString.call(message.account) : options.longs === Number ? new $util.LongBits(message.account.low >>> 0, message.account.high >>> 0).toNumber(true) : message.account;
            if (message.bytes != null && message.hasOwnProperty("bytes"))
                if (typeof message.bytes === "number")
                    object.bytes = options.longs === String ? String(message.bytes) : message.bytes;
                else
                    object.bytes = options.longs === String ? $util.Long.prototype.toString.call(message.bytes) : options.longs === Number ? new $util.LongBits(message.bytes.low >>> 0, message.bytes.high >>> 0).toNumber(true) : message.bytes;
            return object;
        };

        EosActionSellRam.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EosActionSellRam;
    })();

    EosTxActionAck.EosActionVoteProducer = (function() {

        function EosActionVoteProducer(properties) {
            this.producers = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        EosActionVoteProducer.prototype.voter = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        EosActionVoteProducer.prototype.proxy = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        EosActionVoteProducer.prototype.producers = $util.emptyArray;

        EosActionVoteProducer.create = function create(properties) {
            return new EosActionVoteProducer(properties);
        };

        EosActionVoteProducer.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(8).uint64(message.voter);
            writer.uint32(16).uint64(message.proxy);
            if (message.producers != null && message.producers.length)
                for (var i = 0; i < message.producers.length; ++i)
                    writer.uint32(24).uint64(message.producers[i]);
            return writer;
        };

        EosActionVoteProducer.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        EosActionVoteProducer.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EosTxActionAck.EosActionVoteProducer();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.voter = reader.uint64();
                    break;
                case 2:
                    message.proxy = reader.uint64();
                    break;
                case 3:
                    if (!(message.producers && message.producers.length))
                        message.producers = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.producers.push(reader.uint64());
                    } else
                        message.producers.push(reader.uint64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("voter"))
                throw $util.ProtocolError("missing required 'voter'", { instance: message });
            if (!message.hasOwnProperty("proxy"))
                throw $util.ProtocolError("missing required 'proxy'", { instance: message });
            return message;
        };

        EosActionVoteProducer.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        EosActionVoteProducer.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isInteger(message.voter) && !(message.voter && $util.isInteger(message.voter.low) && $util.isInteger(message.voter.high)))
                return "voter: integer|Long expected";
            if (!$util.isInteger(message.proxy) && !(message.proxy && $util.isInteger(message.proxy.low) && $util.isInteger(message.proxy.high)))
                return "proxy: integer|Long expected";
            if (message.producers != null && message.hasOwnProperty("producers")) {
                if (!Array.isArray(message.producers))
                    return "producers: array expected";
                for (var i = 0; i < message.producers.length; ++i)
                    if (!$util.isInteger(message.producers[i]) && !(message.producers[i] && $util.isInteger(message.producers[i].low) && $util.isInteger(message.producers[i].high)))
                        return "producers: integer|Long[] expected";
            }
            return null;
        };

        EosActionVoteProducer.fromObject = function fromObject(object) {
            if (object instanceof $root.EosTxActionAck.EosActionVoteProducer)
                return object;
            var message = new $root.EosTxActionAck.EosActionVoteProducer();
            if (object.voter != null)
                if ($util.Long)
                    (message.voter = $util.Long.fromValue(object.voter)).unsigned = true;
                else if (typeof object.voter === "string")
                    message.voter = parseInt(object.voter, 10);
                else if (typeof object.voter === "number")
                    message.voter = object.voter;
                else if (typeof object.voter === "object")
                    message.voter = new $util.LongBits(object.voter.low >>> 0, object.voter.high >>> 0).toNumber(true);
            if (object.proxy != null)
                if ($util.Long)
                    (message.proxy = $util.Long.fromValue(object.proxy)).unsigned = true;
                else if (typeof object.proxy === "string")
                    message.proxy = parseInt(object.proxy, 10);
                else if (typeof object.proxy === "number")
                    message.proxy = object.proxy;
                else if (typeof object.proxy === "object")
                    message.proxy = new $util.LongBits(object.proxy.low >>> 0, object.proxy.high >>> 0).toNumber(true);
            if (object.producers) {
                if (!Array.isArray(object.producers))
                    throw TypeError(".EosTxActionAck.EosActionVoteProducer.producers: array expected");
                message.producers = [];
                for (var i = 0; i < object.producers.length; ++i)
                    if ($util.Long)
                        (message.producers[i] = $util.Long.fromValue(object.producers[i])).unsigned = true;
                    else if (typeof object.producers[i] === "string")
                        message.producers[i] = parseInt(object.producers[i], 10);
                    else if (typeof object.producers[i] === "number")
                        message.producers[i] = object.producers[i];
                    else if (typeof object.producers[i] === "object")
                        message.producers[i] = new $util.LongBits(object.producers[i].low >>> 0, object.producers[i].high >>> 0).toNumber(true);
            }
            return message;
        };

        EosActionVoteProducer.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.producers = [];
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.voter = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.voter = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.proxy = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.proxy = options.longs === String ? "0" : 0;
            }
            if (message.voter != null && message.hasOwnProperty("voter"))
                if (typeof message.voter === "number")
                    object.voter = options.longs === String ? String(message.voter) : message.voter;
                else
                    object.voter = options.longs === String ? $util.Long.prototype.toString.call(message.voter) : options.longs === Number ? new $util.LongBits(message.voter.low >>> 0, message.voter.high >>> 0).toNumber(true) : message.voter;
            if (message.proxy != null && message.hasOwnProperty("proxy"))
                if (typeof message.proxy === "number")
                    object.proxy = options.longs === String ? String(message.proxy) : message.proxy;
                else
                    object.proxy = options.longs === String ? $util.Long.prototype.toString.call(message.proxy) : options.longs === Number ? new $util.LongBits(message.proxy.low >>> 0, message.proxy.high >>> 0).toNumber(true) : message.proxy;
            if (message.producers && message.producers.length) {
                object.producers = [];
                for (var j = 0; j < message.producers.length; ++j)
                    if (typeof message.producers[j] === "number")
                        object.producers[j] = options.longs === String ? String(message.producers[j]) : message.producers[j];
                    else
                        object.producers[j] = options.longs === String ? $util.Long.prototype.toString.call(message.producers[j]) : options.longs === Number ? new $util.LongBits(message.producers[j].low >>> 0, message.producers[j].high >>> 0).toNumber(true) : message.producers[j];
            }
            return object;
        };

        EosActionVoteProducer.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EosActionVoteProducer;
    })();

    EosTxActionAck.EosActionUpdateAuth = (function() {

        function EosActionUpdateAuth(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        EosActionUpdateAuth.prototype.account = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        EosActionUpdateAuth.prototype.permission = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        EosActionUpdateAuth.prototype.parent = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        EosActionUpdateAuth.prototype.auth = null;

        EosActionUpdateAuth.create = function create(properties) {
            return new EosActionUpdateAuth(properties);
        };

        EosActionUpdateAuth.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(8).uint64(message.account);
            writer.uint32(16).uint64(message.permission);
            writer.uint32(24).uint64(message.parent);
            $root.EosTxActionAck.EosAuthorization.encode(message.auth, writer.uint32(34).fork()).ldelim();
            return writer;
        };

        EosActionUpdateAuth.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        EosActionUpdateAuth.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EosTxActionAck.EosActionUpdateAuth();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.account = reader.uint64();
                    break;
                case 2:
                    message.permission = reader.uint64();
                    break;
                case 3:
                    message.parent = reader.uint64();
                    break;
                case 4:
                    message.auth = $root.EosTxActionAck.EosAuthorization.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("account"))
                throw $util.ProtocolError("missing required 'account'", { instance: message });
            if (!message.hasOwnProperty("permission"))
                throw $util.ProtocolError("missing required 'permission'", { instance: message });
            if (!message.hasOwnProperty("parent"))
                throw $util.ProtocolError("missing required 'parent'", { instance: message });
            if (!message.hasOwnProperty("auth"))
                throw $util.ProtocolError("missing required 'auth'", { instance: message });
            return message;
        };

        EosActionUpdateAuth.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        EosActionUpdateAuth.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isInteger(message.account) && !(message.account && $util.isInteger(message.account.low) && $util.isInteger(message.account.high)))
                return "account: integer|Long expected";
            if (!$util.isInteger(message.permission) && !(message.permission && $util.isInteger(message.permission.low) && $util.isInteger(message.permission.high)))
                return "permission: integer|Long expected";
            if (!$util.isInteger(message.parent) && !(message.parent && $util.isInteger(message.parent.low) && $util.isInteger(message.parent.high)))
                return "parent: integer|Long expected";
            {
                var error = $root.EosTxActionAck.EosAuthorization.verify(message.auth);
                if (error)
                    return "auth." + error;
            }
            return null;
        };

        EosActionUpdateAuth.fromObject = function fromObject(object) {
            if (object instanceof $root.EosTxActionAck.EosActionUpdateAuth)
                return object;
            var message = new $root.EosTxActionAck.EosActionUpdateAuth();
            if (object.account != null)
                if ($util.Long)
                    (message.account = $util.Long.fromValue(object.account)).unsigned = true;
                else if (typeof object.account === "string")
                    message.account = parseInt(object.account, 10);
                else if (typeof object.account === "number")
                    message.account = object.account;
                else if (typeof object.account === "object")
                    message.account = new $util.LongBits(object.account.low >>> 0, object.account.high >>> 0).toNumber(true);
            if (object.permission != null)
                if ($util.Long)
                    (message.permission = $util.Long.fromValue(object.permission)).unsigned = true;
                else if (typeof object.permission === "string")
                    message.permission = parseInt(object.permission, 10);
                else if (typeof object.permission === "number")
                    message.permission = object.permission;
                else if (typeof object.permission === "object")
                    message.permission = new $util.LongBits(object.permission.low >>> 0, object.permission.high >>> 0).toNumber(true);
            if (object.parent != null)
                if ($util.Long)
                    (message.parent = $util.Long.fromValue(object.parent)).unsigned = true;
                else if (typeof object.parent === "string")
                    message.parent = parseInt(object.parent, 10);
                else if (typeof object.parent === "number")
                    message.parent = object.parent;
                else if (typeof object.parent === "object")
                    message.parent = new $util.LongBits(object.parent.low >>> 0, object.parent.high >>> 0).toNumber(true);
            if (object.auth != null) {
                if (typeof object.auth !== "object")
                    throw TypeError(".EosTxActionAck.EosActionUpdateAuth.auth: object expected");
                message.auth = $root.EosTxActionAck.EosAuthorization.fromObject(object.auth);
            }
            return message;
        };

        EosActionUpdateAuth.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.account = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.account = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.permission = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.permission = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.parent = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.parent = options.longs === String ? "0" : 0;
                object.auth = null;
            }
            if (message.account != null && message.hasOwnProperty("account"))
                if (typeof message.account === "number")
                    object.account = options.longs === String ? String(message.account) : message.account;
                else
                    object.account = options.longs === String ? $util.Long.prototype.toString.call(message.account) : options.longs === Number ? new $util.LongBits(message.account.low >>> 0, message.account.high >>> 0).toNumber(true) : message.account;
            if (message.permission != null && message.hasOwnProperty("permission"))
                if (typeof message.permission === "number")
                    object.permission = options.longs === String ? String(message.permission) : message.permission;
                else
                    object.permission = options.longs === String ? $util.Long.prototype.toString.call(message.permission) : options.longs === Number ? new $util.LongBits(message.permission.low >>> 0, message.permission.high >>> 0).toNumber(true) : message.permission;
            if (message.parent != null && message.hasOwnProperty("parent"))
                if (typeof message.parent === "number")
                    object.parent = options.longs === String ? String(message.parent) : message.parent;
                else
                    object.parent = options.longs === String ? $util.Long.prototype.toString.call(message.parent) : options.longs === Number ? new $util.LongBits(message.parent.low >>> 0, message.parent.high >>> 0).toNumber(true) : message.parent;
            if (message.auth != null && message.hasOwnProperty("auth"))
                object.auth = $root.EosTxActionAck.EosAuthorization.toObject(message.auth, options);
            return object;
        };

        EosActionUpdateAuth.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EosActionUpdateAuth;
    })();

    EosTxActionAck.EosActionDeleteAuth = (function() {

        function EosActionDeleteAuth(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        EosActionDeleteAuth.prototype.account = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        EosActionDeleteAuth.prototype.permission = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        EosActionDeleteAuth.create = function create(properties) {
            return new EosActionDeleteAuth(properties);
        };

        EosActionDeleteAuth.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(8).uint64(message.account);
            writer.uint32(16).uint64(message.permission);
            return writer;
        };

        EosActionDeleteAuth.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        EosActionDeleteAuth.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EosTxActionAck.EosActionDeleteAuth();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.account = reader.uint64();
                    break;
                case 2:
                    message.permission = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("account"))
                throw $util.ProtocolError("missing required 'account'", { instance: message });
            if (!message.hasOwnProperty("permission"))
                throw $util.ProtocolError("missing required 'permission'", { instance: message });
            return message;
        };

        EosActionDeleteAuth.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        EosActionDeleteAuth.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isInteger(message.account) && !(message.account && $util.isInteger(message.account.low) && $util.isInteger(message.account.high)))
                return "account: integer|Long expected";
            if (!$util.isInteger(message.permission) && !(message.permission && $util.isInteger(message.permission.low) && $util.isInteger(message.permission.high)))
                return "permission: integer|Long expected";
            return null;
        };

        EosActionDeleteAuth.fromObject = function fromObject(object) {
            if (object instanceof $root.EosTxActionAck.EosActionDeleteAuth)
                return object;
            var message = new $root.EosTxActionAck.EosActionDeleteAuth();
            if (object.account != null)
                if ($util.Long)
                    (message.account = $util.Long.fromValue(object.account)).unsigned = true;
                else if (typeof object.account === "string")
                    message.account = parseInt(object.account, 10);
                else if (typeof object.account === "number")
                    message.account = object.account;
                else if (typeof object.account === "object")
                    message.account = new $util.LongBits(object.account.low >>> 0, object.account.high >>> 0).toNumber(true);
            if (object.permission != null)
                if ($util.Long)
                    (message.permission = $util.Long.fromValue(object.permission)).unsigned = true;
                else if (typeof object.permission === "string")
                    message.permission = parseInt(object.permission, 10);
                else if (typeof object.permission === "number")
                    message.permission = object.permission;
                else if (typeof object.permission === "object")
                    message.permission = new $util.LongBits(object.permission.low >>> 0, object.permission.high >>> 0).toNumber(true);
            return message;
        };

        EosActionDeleteAuth.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.account = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.account = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.permission = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.permission = options.longs === String ? "0" : 0;
            }
            if (message.account != null && message.hasOwnProperty("account"))
                if (typeof message.account === "number")
                    object.account = options.longs === String ? String(message.account) : message.account;
                else
                    object.account = options.longs === String ? $util.Long.prototype.toString.call(message.account) : options.longs === Number ? new $util.LongBits(message.account.low >>> 0, message.account.high >>> 0).toNumber(true) : message.account;
            if (message.permission != null && message.hasOwnProperty("permission"))
                if (typeof message.permission === "number")
                    object.permission = options.longs === String ? String(message.permission) : message.permission;
                else
                    object.permission = options.longs === String ? $util.Long.prototype.toString.call(message.permission) : options.longs === Number ? new $util.LongBits(message.permission.low >>> 0, message.permission.high >>> 0).toNumber(true) : message.permission;
            return object;
        };

        EosActionDeleteAuth.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EosActionDeleteAuth;
    })();

    EosTxActionAck.EosActionLinkAuth = (function() {

        function EosActionLinkAuth(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        EosActionLinkAuth.prototype.account = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        EosActionLinkAuth.prototype.code = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        EosActionLinkAuth.prototype.type = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        EosActionLinkAuth.prototype.requirement = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        EosActionLinkAuth.create = function create(properties) {
            return new EosActionLinkAuth(properties);
        };

        EosActionLinkAuth.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(8).uint64(message.account);
            writer.uint32(16).uint64(message.code);
            writer.uint32(24).uint64(message.type);
            writer.uint32(32).uint64(message.requirement);
            return writer;
        };

        EosActionLinkAuth.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        EosActionLinkAuth.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EosTxActionAck.EosActionLinkAuth();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.account = reader.uint64();
                    break;
                case 2:
                    message.code = reader.uint64();
                    break;
                case 3:
                    message.type = reader.uint64();
                    break;
                case 4:
                    message.requirement = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("account"))
                throw $util.ProtocolError("missing required 'account'", { instance: message });
            if (!message.hasOwnProperty("code"))
                throw $util.ProtocolError("missing required 'code'", { instance: message });
            if (!message.hasOwnProperty("type"))
                throw $util.ProtocolError("missing required 'type'", { instance: message });
            if (!message.hasOwnProperty("requirement"))
                throw $util.ProtocolError("missing required 'requirement'", { instance: message });
            return message;
        };

        EosActionLinkAuth.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        EosActionLinkAuth.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isInteger(message.account) && !(message.account && $util.isInteger(message.account.low) && $util.isInteger(message.account.high)))
                return "account: integer|Long expected";
            if (!$util.isInteger(message.code) && !(message.code && $util.isInteger(message.code.low) && $util.isInteger(message.code.high)))
                return "code: integer|Long expected";
            if (!$util.isInteger(message.type) && !(message.type && $util.isInteger(message.type.low) && $util.isInteger(message.type.high)))
                return "type: integer|Long expected";
            if (!$util.isInteger(message.requirement) && !(message.requirement && $util.isInteger(message.requirement.low) && $util.isInteger(message.requirement.high)))
                return "requirement: integer|Long expected";
            return null;
        };

        EosActionLinkAuth.fromObject = function fromObject(object) {
            if (object instanceof $root.EosTxActionAck.EosActionLinkAuth)
                return object;
            var message = new $root.EosTxActionAck.EosActionLinkAuth();
            if (object.account != null)
                if ($util.Long)
                    (message.account = $util.Long.fromValue(object.account)).unsigned = true;
                else if (typeof object.account === "string")
                    message.account = parseInt(object.account, 10);
                else if (typeof object.account === "number")
                    message.account = object.account;
                else if (typeof object.account === "object")
                    message.account = new $util.LongBits(object.account.low >>> 0, object.account.high >>> 0).toNumber(true);
            if (object.code != null)
                if ($util.Long)
                    (message.code = $util.Long.fromValue(object.code)).unsigned = true;
                else if (typeof object.code === "string")
                    message.code = parseInt(object.code, 10);
                else if (typeof object.code === "number")
                    message.code = object.code;
                else if (typeof object.code === "object")
                    message.code = new $util.LongBits(object.code.low >>> 0, object.code.high >>> 0).toNumber(true);
            if (object.type != null)
                if ($util.Long)
                    (message.type = $util.Long.fromValue(object.type)).unsigned = true;
                else if (typeof object.type === "string")
                    message.type = parseInt(object.type, 10);
                else if (typeof object.type === "number")
                    message.type = object.type;
                else if (typeof object.type === "object")
                    message.type = new $util.LongBits(object.type.low >>> 0, object.type.high >>> 0).toNumber(true);
            if (object.requirement != null)
                if ($util.Long)
                    (message.requirement = $util.Long.fromValue(object.requirement)).unsigned = true;
                else if (typeof object.requirement === "string")
                    message.requirement = parseInt(object.requirement, 10);
                else if (typeof object.requirement === "number")
                    message.requirement = object.requirement;
                else if (typeof object.requirement === "object")
                    message.requirement = new $util.LongBits(object.requirement.low >>> 0, object.requirement.high >>> 0).toNumber(true);
            return message;
        };

        EosActionLinkAuth.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.account = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.account = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.code = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.code = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.type = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.type = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.requirement = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.requirement = options.longs === String ? "0" : 0;
            }
            if (message.account != null && message.hasOwnProperty("account"))
                if (typeof message.account === "number")
                    object.account = options.longs === String ? String(message.account) : message.account;
                else
                    object.account = options.longs === String ? $util.Long.prototype.toString.call(message.account) : options.longs === Number ? new $util.LongBits(message.account.low >>> 0, message.account.high >>> 0).toNumber(true) : message.account;
            if (message.code != null && message.hasOwnProperty("code"))
                if (typeof message.code === "number")
                    object.code = options.longs === String ? String(message.code) : message.code;
                else
                    object.code = options.longs === String ? $util.Long.prototype.toString.call(message.code) : options.longs === Number ? new $util.LongBits(message.code.low >>> 0, message.code.high >>> 0).toNumber(true) : message.code;
            if (message.type != null && message.hasOwnProperty("type"))
                if (typeof message.type === "number")
                    object.type = options.longs === String ? String(message.type) : message.type;
                else
                    object.type = options.longs === String ? $util.Long.prototype.toString.call(message.type) : options.longs === Number ? new $util.LongBits(message.type.low >>> 0, message.type.high >>> 0).toNumber(true) : message.type;
            if (message.requirement != null && message.hasOwnProperty("requirement"))
                if (typeof message.requirement === "number")
                    object.requirement = options.longs === String ? String(message.requirement) : message.requirement;
                else
                    object.requirement = options.longs === String ? $util.Long.prototype.toString.call(message.requirement) : options.longs === Number ? new $util.LongBits(message.requirement.low >>> 0, message.requirement.high >>> 0).toNumber(true) : message.requirement;
            return object;
        };

        EosActionLinkAuth.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EosActionLinkAuth;
    })();

    EosTxActionAck.EosActionUnlinkAuth = (function() {

        function EosActionUnlinkAuth(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        EosActionUnlinkAuth.prototype.account = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        EosActionUnlinkAuth.prototype.code = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        EosActionUnlinkAuth.prototype.type = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        EosActionUnlinkAuth.create = function create(properties) {
            return new EosActionUnlinkAuth(properties);
        };

        EosActionUnlinkAuth.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(8).uint64(message.account);
            writer.uint32(16).uint64(message.code);
            writer.uint32(24).uint64(message.type);
            return writer;
        };

        EosActionUnlinkAuth.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        EosActionUnlinkAuth.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EosTxActionAck.EosActionUnlinkAuth();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.account = reader.uint64();
                    break;
                case 2:
                    message.code = reader.uint64();
                    break;
                case 3:
                    message.type = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("account"))
                throw $util.ProtocolError("missing required 'account'", { instance: message });
            if (!message.hasOwnProperty("code"))
                throw $util.ProtocolError("missing required 'code'", { instance: message });
            if (!message.hasOwnProperty("type"))
                throw $util.ProtocolError("missing required 'type'", { instance: message });
            return message;
        };

        EosActionUnlinkAuth.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        EosActionUnlinkAuth.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isInteger(message.account) && !(message.account && $util.isInteger(message.account.low) && $util.isInteger(message.account.high)))
                return "account: integer|Long expected";
            if (!$util.isInteger(message.code) && !(message.code && $util.isInteger(message.code.low) && $util.isInteger(message.code.high)))
                return "code: integer|Long expected";
            if (!$util.isInteger(message.type) && !(message.type && $util.isInteger(message.type.low) && $util.isInteger(message.type.high)))
                return "type: integer|Long expected";
            return null;
        };

        EosActionUnlinkAuth.fromObject = function fromObject(object) {
            if (object instanceof $root.EosTxActionAck.EosActionUnlinkAuth)
                return object;
            var message = new $root.EosTxActionAck.EosActionUnlinkAuth();
            if (object.account != null)
                if ($util.Long)
                    (message.account = $util.Long.fromValue(object.account)).unsigned = true;
                else if (typeof object.account === "string")
                    message.account = parseInt(object.account, 10);
                else if (typeof object.account === "number")
                    message.account = object.account;
                else if (typeof object.account === "object")
                    message.account = new $util.LongBits(object.account.low >>> 0, object.account.high >>> 0).toNumber(true);
            if (object.code != null)
                if ($util.Long)
                    (message.code = $util.Long.fromValue(object.code)).unsigned = true;
                else if (typeof object.code === "string")
                    message.code = parseInt(object.code, 10);
                else if (typeof object.code === "number")
                    message.code = object.code;
                else if (typeof object.code === "object")
                    message.code = new $util.LongBits(object.code.low >>> 0, object.code.high >>> 0).toNumber(true);
            if (object.type != null)
                if ($util.Long)
                    (message.type = $util.Long.fromValue(object.type)).unsigned = true;
                else if (typeof object.type === "string")
                    message.type = parseInt(object.type, 10);
                else if (typeof object.type === "number")
                    message.type = object.type;
                else if (typeof object.type === "object")
                    message.type = new $util.LongBits(object.type.low >>> 0, object.type.high >>> 0).toNumber(true);
            return message;
        };

        EosActionUnlinkAuth.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.account = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.account = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.code = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.code = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.type = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.type = options.longs === String ? "0" : 0;
            }
            if (message.account != null && message.hasOwnProperty("account"))
                if (typeof message.account === "number")
                    object.account = options.longs === String ? String(message.account) : message.account;
                else
                    object.account = options.longs === String ? $util.Long.prototype.toString.call(message.account) : options.longs === Number ? new $util.LongBits(message.account.low >>> 0, message.account.high >>> 0).toNumber(true) : message.account;
            if (message.code != null && message.hasOwnProperty("code"))
                if (typeof message.code === "number")
                    object.code = options.longs === String ? String(message.code) : message.code;
                else
                    object.code = options.longs === String ? $util.Long.prototype.toString.call(message.code) : options.longs === Number ? new $util.LongBits(message.code.low >>> 0, message.code.high >>> 0).toNumber(true) : message.code;
            if (message.type != null && message.hasOwnProperty("type"))
                if (typeof message.type === "number")
                    object.type = options.longs === String ? String(message.type) : message.type;
                else
                    object.type = options.longs === String ? $util.Long.prototype.toString.call(message.type) : options.longs === Number ? new $util.LongBits(message.type.low >>> 0, message.type.high >>> 0).toNumber(true) : message.type;
            return object;
        };

        EosActionUnlinkAuth.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EosActionUnlinkAuth;
    })();

    EosTxActionAck.EosActionNewAccount = (function() {

        function EosActionNewAccount(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        EosActionNewAccount.prototype.creator = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        EosActionNewAccount.prototype.name = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        EosActionNewAccount.prototype.owner = null;
        EosActionNewAccount.prototype.active = null;

        EosActionNewAccount.create = function create(properties) {
            return new EosActionNewAccount(properties);
        };

        EosActionNewAccount.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(8).uint64(message.creator);
            writer.uint32(16).uint64(message.name);
            $root.EosTxActionAck.EosAuthorization.encode(message.owner, writer.uint32(26).fork()).ldelim();
            $root.EosTxActionAck.EosAuthorization.encode(message.active, writer.uint32(34).fork()).ldelim();
            return writer;
        };

        EosActionNewAccount.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        EosActionNewAccount.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EosTxActionAck.EosActionNewAccount();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.creator = reader.uint64();
                    break;
                case 2:
                    message.name = reader.uint64();
                    break;
                case 3:
                    message.owner = $root.EosTxActionAck.EosAuthorization.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.active = $root.EosTxActionAck.EosAuthorization.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("creator"))
                throw $util.ProtocolError("missing required 'creator'", { instance: message });
            if (!message.hasOwnProperty("name"))
                throw $util.ProtocolError("missing required 'name'", { instance: message });
            if (!message.hasOwnProperty("owner"))
                throw $util.ProtocolError("missing required 'owner'", { instance: message });
            if (!message.hasOwnProperty("active"))
                throw $util.ProtocolError("missing required 'active'", { instance: message });
            return message;
        };

        EosActionNewAccount.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        EosActionNewAccount.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isInteger(message.creator) && !(message.creator && $util.isInteger(message.creator.low) && $util.isInteger(message.creator.high)))
                return "creator: integer|Long expected";
            if (!$util.isInteger(message.name) && !(message.name && $util.isInteger(message.name.low) && $util.isInteger(message.name.high)))
                return "name: integer|Long expected";
            {
                var error = $root.EosTxActionAck.EosAuthorization.verify(message.owner);
                if (error)
                    return "owner." + error;
            }
            {
                var error = $root.EosTxActionAck.EosAuthorization.verify(message.active);
                if (error)
                    return "active." + error;
            }
            return null;
        };

        EosActionNewAccount.fromObject = function fromObject(object) {
            if (object instanceof $root.EosTxActionAck.EosActionNewAccount)
                return object;
            var message = new $root.EosTxActionAck.EosActionNewAccount();
            if (object.creator != null)
                if ($util.Long)
                    (message.creator = $util.Long.fromValue(object.creator)).unsigned = true;
                else if (typeof object.creator === "string")
                    message.creator = parseInt(object.creator, 10);
                else if (typeof object.creator === "number")
                    message.creator = object.creator;
                else if (typeof object.creator === "object")
                    message.creator = new $util.LongBits(object.creator.low >>> 0, object.creator.high >>> 0).toNumber(true);
            if (object.name != null)
                if ($util.Long)
                    (message.name = $util.Long.fromValue(object.name)).unsigned = true;
                else if (typeof object.name === "string")
                    message.name = parseInt(object.name, 10);
                else if (typeof object.name === "number")
                    message.name = object.name;
                else if (typeof object.name === "object")
                    message.name = new $util.LongBits(object.name.low >>> 0, object.name.high >>> 0).toNumber(true);
            if (object.owner != null) {
                if (typeof object.owner !== "object")
                    throw TypeError(".EosTxActionAck.EosActionNewAccount.owner: object expected");
                message.owner = $root.EosTxActionAck.EosAuthorization.fromObject(object.owner);
            }
            if (object.active != null) {
                if (typeof object.active !== "object")
                    throw TypeError(".EosTxActionAck.EosActionNewAccount.active: object expected");
                message.active = $root.EosTxActionAck.EosAuthorization.fromObject(object.active);
            }
            return message;
        };

        EosActionNewAccount.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.creator = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.creator = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.name = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.name = options.longs === String ? "0" : 0;
                object.owner = null;
                object.active = null;
            }
            if (message.creator != null && message.hasOwnProperty("creator"))
                if (typeof message.creator === "number")
                    object.creator = options.longs === String ? String(message.creator) : message.creator;
                else
                    object.creator = options.longs === String ? $util.Long.prototype.toString.call(message.creator) : options.longs === Number ? new $util.LongBits(message.creator.low >>> 0, message.creator.high >>> 0).toNumber(true) : message.creator;
            if (message.name != null && message.hasOwnProperty("name"))
                if (typeof message.name === "number")
                    object.name = options.longs === String ? String(message.name) : message.name;
                else
                    object.name = options.longs === String ? $util.Long.prototype.toString.call(message.name) : options.longs === Number ? new $util.LongBits(message.name.low >>> 0, message.name.high >>> 0).toNumber(true) : message.name;
            if (message.owner != null && message.hasOwnProperty("owner"))
                object.owner = $root.EosTxActionAck.EosAuthorization.toObject(message.owner, options);
            if (message.active != null && message.hasOwnProperty("active"))
                object.active = $root.EosTxActionAck.EosAuthorization.toObject(message.active, options);
            return object;
        };

        EosActionNewAccount.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EosActionNewAccount;
    })();

    EosTxActionAck.EosActionUnknown = (function() {

        function EosActionUnknown(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        EosActionUnknown.prototype.data_size = 0;
        EosActionUnknown.prototype.data_chunk = $util.newBuffer([]);

        EosActionUnknown.create = function create(properties) {
            return new EosActionUnknown(properties);
        };

        EosActionUnknown.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(8).uint32(message.data_size);
            writer.uint32(18).bytes(message.data_chunk);
            return writer;
        };

        EosActionUnknown.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        EosActionUnknown.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EosTxActionAck.EosActionUnknown();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.data_size = reader.uint32();
                    break;
                case 2:
                    message.data_chunk = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("data_size"))
                throw $util.ProtocolError("missing required 'data_size'", { instance: message });
            if (!message.hasOwnProperty("data_chunk"))
                throw $util.ProtocolError("missing required 'data_chunk'", { instance: message });
            return message;
        };

        EosActionUnknown.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        EosActionUnknown.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isInteger(message.data_size))
                return "data_size: integer expected";
            if (!(message.data_chunk && typeof message.data_chunk.length === "number" || $util.isString(message.data_chunk)))
                return "data_chunk: buffer expected";
            return null;
        };

        EosActionUnknown.fromObject = function fromObject(object) {
            if (object instanceof $root.EosTxActionAck.EosActionUnknown)
                return object;
            var message = new $root.EosTxActionAck.EosActionUnknown();
            if (object.data_size != null)
                message.data_size = object.data_size >>> 0;
            if (object.data_chunk != null)
                if (typeof object.data_chunk === "string")
                    $util.base64.decode(object.data_chunk, message.data_chunk = $util.newBuffer($util.base64.length(object.data_chunk)), 0);
                else if (object.data_chunk.length)
                    message.data_chunk = object.data_chunk;
            return message;
        };

        EosActionUnknown.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.data_size = 0;
                if (options.bytes === String)
                    object.data_chunk = "";
                else {
                    object.data_chunk = [];
                    if (options.bytes !== Array)
                        object.data_chunk = $util.newBuffer(object.data_chunk);
                }
            }
            if (message.data_size != null && message.hasOwnProperty("data_size"))
                object.data_size = message.data_size;
            if (message.data_chunk != null && message.hasOwnProperty("data_chunk"))
                object.data_chunk = options.bytes === String ? $util.base64.encode(message.data_chunk, 0, message.data_chunk.length) : options.bytes === Array ? Array.prototype.slice.call(message.data_chunk) : message.data_chunk;
            return object;
        };

        EosActionUnknown.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EosActionUnknown;
    })();

    return EosTxActionAck;
})();

$root.EosSignedTx = (function() {

    function EosSignedTx(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EosSignedTx.prototype.signature = "";

    EosSignedTx.create = function create(properties) {
        return new EosSignedTx(properties);
    };

    EosSignedTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.signature);
        return writer;
    };

    EosSignedTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EosSignedTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EosSignedTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.signature = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        return message;
    };

    EosSignedTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EosSignedTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.signature))
            return "signature: string expected";
        return null;
    };

    EosSignedTx.fromObject = function fromObject(object) {
        if (object instanceof $root.EosSignedTx)
            return object;
        var message = new $root.EosSignedTx();
        if (object.signature != null)
            message.signature = String(object.signature);
        return message;
    };

    EosSignedTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.signature = "";
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = message.signature;
        return object;
    };

    EosSignedTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EosSignedTx;
})();

$root.EthereumDefinitionType = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "NETWORK"] = 0;
    values[valuesById[1] = "TOKEN"] = 1;
    return values;
})();

$root.EthereumNetworkInfo = (function() {

    function EthereumNetworkInfo(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumNetworkInfo.prototype.chain_id = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    EthereumNetworkInfo.prototype.symbol = "";
    EthereumNetworkInfo.prototype.slip44 = 0;
    EthereumNetworkInfo.prototype.name = "";
    EthereumNetworkInfo.prototype.icon = "";
    EthereumNetworkInfo.prototype.primary_color = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    EthereumNetworkInfo.create = function create(properties) {
        return new EthereumNetworkInfo(properties);
    };

    EthereumNetworkInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).uint64(message.chain_id);
        writer.uint32(18).string(message.symbol);
        writer.uint32(24).uint32(message.slip44);
        writer.uint32(34).string(message.name);
        if (message.icon != null && Object.hasOwnProperty.call(message, "icon"))
            writer.uint32(810).string(message.icon);
        if (message.primary_color != null && Object.hasOwnProperty.call(message, "primary_color"))
            writer.uint32(816).uint64(message.primary_color);
        return writer;
    };

    EthereumNetworkInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumNetworkInfo.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumNetworkInfo();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.chain_id = reader.uint64();
                break;
            case 2:
                message.symbol = reader.string();
                break;
            case 3:
                message.slip44 = reader.uint32();
                break;
            case 4:
                message.name = reader.string();
                break;
            case 101:
                message.icon = reader.string();
                break;
            case 102:
                message.primary_color = reader.uint64();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("chain_id"))
            throw $util.ProtocolError("missing required 'chain_id'", { instance: message });
        if (!message.hasOwnProperty("symbol"))
            throw $util.ProtocolError("missing required 'symbol'", { instance: message });
        if (!message.hasOwnProperty("slip44"))
            throw $util.ProtocolError("missing required 'slip44'", { instance: message });
        if (!message.hasOwnProperty("name"))
            throw $util.ProtocolError("missing required 'name'", { instance: message });
        return message;
    };

    EthereumNetworkInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumNetworkInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isInteger(message.chain_id) && !(message.chain_id && $util.isInteger(message.chain_id.low) && $util.isInteger(message.chain_id.high)))
            return "chain_id: integer|Long expected";
        if (!$util.isString(message.symbol))
            return "symbol: string expected";
        if (!$util.isInteger(message.slip44))
            return "slip44: integer expected";
        if (!$util.isString(message.name))
            return "name: string expected";
        if (message.icon != null && message.hasOwnProperty("icon"))
            if (!$util.isString(message.icon))
                return "icon: string expected";
        if (message.primary_color != null && message.hasOwnProperty("primary_color"))
            if (!$util.isInteger(message.primary_color) && !(message.primary_color && $util.isInteger(message.primary_color.low) && $util.isInteger(message.primary_color.high)))
                return "primary_color: integer|Long expected";
        return null;
    };

    EthereumNetworkInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumNetworkInfo)
            return object;
        var message = new $root.EthereumNetworkInfo();
        if (object.chain_id != null)
            if ($util.Long)
                (message.chain_id = $util.Long.fromValue(object.chain_id)).unsigned = true;
            else if (typeof object.chain_id === "string")
                message.chain_id = parseInt(object.chain_id, 10);
            else if (typeof object.chain_id === "number")
                message.chain_id = object.chain_id;
            else if (typeof object.chain_id === "object")
                message.chain_id = new $util.LongBits(object.chain_id.low >>> 0, object.chain_id.high >>> 0).toNumber(true);
        if (object.symbol != null)
            message.symbol = String(object.symbol);
        if (object.slip44 != null)
            message.slip44 = object.slip44 >>> 0;
        if (object.name != null)
            message.name = String(object.name);
        if (object.icon != null)
            message.icon = String(object.icon);
        if (object.primary_color != null)
            if ($util.Long)
                (message.primary_color = $util.Long.fromValue(object.primary_color)).unsigned = true;
            else if (typeof object.primary_color === "string")
                message.primary_color = parseInt(object.primary_color, 10);
            else if (typeof object.primary_color === "number")
                message.primary_color = object.primary_color;
            else if (typeof object.primary_color === "object")
                message.primary_color = new $util.LongBits(object.primary_color.low >>> 0, object.primary_color.high >>> 0).toNumber(true);
        return message;
    };

    EthereumNetworkInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.chain_id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.chain_id = options.longs === String ? "0" : 0;
            object.symbol = "";
            object.slip44 = 0;
            object.name = "";
            object.icon = "";
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.primary_color = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.primary_color = options.longs === String ? "0" : 0;
        }
        if (message.chain_id != null && message.hasOwnProperty("chain_id"))
            if (typeof message.chain_id === "number")
                object.chain_id = options.longs === String ? String(message.chain_id) : message.chain_id;
            else
                object.chain_id = options.longs === String ? $util.Long.prototype.toString.call(message.chain_id) : options.longs === Number ? new $util.LongBits(message.chain_id.low >>> 0, message.chain_id.high >>> 0).toNumber(true) : message.chain_id;
        if (message.symbol != null && message.hasOwnProperty("symbol"))
            object.symbol = message.symbol;
        if (message.slip44 != null && message.hasOwnProperty("slip44"))
            object.slip44 = message.slip44;
        if (message.name != null && message.hasOwnProperty("name"))
            object.name = message.name;
        if (message.icon != null && message.hasOwnProperty("icon"))
            object.icon = message.icon;
        if (message.primary_color != null && message.hasOwnProperty("primary_color"))
            if (typeof message.primary_color === "number")
                object.primary_color = options.longs === String ? String(message.primary_color) : message.primary_color;
            else
                object.primary_color = options.longs === String ? $util.Long.prototype.toString.call(message.primary_color) : options.longs === Number ? new $util.LongBits(message.primary_color.low >>> 0, message.primary_color.high >>> 0).toNumber(true) : message.primary_color;
        return object;
    };

    EthereumNetworkInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumNetworkInfo;
})();

$root.EthereumTokenInfo = (function() {

    function EthereumTokenInfo(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumTokenInfo.prototype.address = $util.newBuffer([]);
    EthereumTokenInfo.prototype.chain_id = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    EthereumTokenInfo.prototype.symbol = "";
    EthereumTokenInfo.prototype.decimals = 0;
    EthereumTokenInfo.prototype.name = "";

    EthereumTokenInfo.create = function create(properties) {
        return new EthereumTokenInfo(properties);
    };

    EthereumTokenInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.address);
        writer.uint32(16).uint64(message.chain_id);
        writer.uint32(26).string(message.symbol);
        writer.uint32(32).uint32(message.decimals);
        writer.uint32(42).string(message.name);
        return writer;
    };

    EthereumTokenInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumTokenInfo.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumTokenInfo();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.bytes();
                break;
            case 2:
                message.chain_id = reader.uint64();
                break;
            case 3:
                message.symbol = reader.string();
                break;
            case 4:
                message.decimals = reader.uint32();
                break;
            case 5:
                message.name = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("address"))
            throw $util.ProtocolError("missing required 'address'", { instance: message });
        if (!message.hasOwnProperty("chain_id"))
            throw $util.ProtocolError("missing required 'chain_id'", { instance: message });
        if (!message.hasOwnProperty("symbol"))
            throw $util.ProtocolError("missing required 'symbol'", { instance: message });
        if (!message.hasOwnProperty("decimals"))
            throw $util.ProtocolError("missing required 'decimals'", { instance: message });
        if (!message.hasOwnProperty("name"))
            throw $util.ProtocolError("missing required 'name'", { instance: message });
        return message;
    };

    EthereumTokenInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumTokenInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.address && typeof message.address.length === "number" || $util.isString(message.address)))
            return "address: buffer expected";
        if (!$util.isInteger(message.chain_id) && !(message.chain_id && $util.isInteger(message.chain_id.low) && $util.isInteger(message.chain_id.high)))
            return "chain_id: integer|Long expected";
        if (!$util.isString(message.symbol))
            return "symbol: string expected";
        if (!$util.isInteger(message.decimals))
            return "decimals: integer expected";
        if (!$util.isString(message.name))
            return "name: string expected";
        return null;
    };

    EthereumTokenInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumTokenInfo)
            return object;
        var message = new $root.EthereumTokenInfo();
        if (object.address != null)
            if (typeof object.address === "string")
                $util.base64.decode(object.address, message.address = $util.newBuffer($util.base64.length(object.address)), 0);
            else if (object.address.length)
                message.address = object.address;
        if (object.chain_id != null)
            if ($util.Long)
                (message.chain_id = $util.Long.fromValue(object.chain_id)).unsigned = true;
            else if (typeof object.chain_id === "string")
                message.chain_id = parseInt(object.chain_id, 10);
            else if (typeof object.chain_id === "number")
                message.chain_id = object.chain_id;
            else if (typeof object.chain_id === "object")
                message.chain_id = new $util.LongBits(object.chain_id.low >>> 0, object.chain_id.high >>> 0).toNumber(true);
        if (object.symbol != null)
            message.symbol = String(object.symbol);
        if (object.decimals != null)
            message.decimals = object.decimals >>> 0;
        if (object.name != null)
            message.name = String(object.name);
        return message;
    };

    EthereumTokenInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.address = "";
            else {
                object.address = [];
                if (options.bytes !== Array)
                    object.address = $util.newBuffer(object.address);
            }
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.chain_id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.chain_id = options.longs === String ? "0" : 0;
            object.symbol = "";
            object.decimals = 0;
            object.name = "";
        }
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = options.bytes === String ? $util.base64.encode(message.address, 0, message.address.length) : options.bytes === Array ? Array.prototype.slice.call(message.address) : message.address;
        if (message.chain_id != null && message.hasOwnProperty("chain_id"))
            if (typeof message.chain_id === "number")
                object.chain_id = options.longs === String ? String(message.chain_id) : message.chain_id;
            else
                object.chain_id = options.longs === String ? $util.Long.prototype.toString.call(message.chain_id) : options.longs === Number ? new $util.LongBits(message.chain_id.low >>> 0, message.chain_id.high >>> 0).toNumber(true) : message.chain_id;
        if (message.symbol != null && message.hasOwnProperty("symbol"))
            object.symbol = message.symbol;
        if (message.decimals != null && message.hasOwnProperty("decimals"))
            object.decimals = message.decimals;
        if (message.name != null && message.hasOwnProperty("name"))
            object.name = message.name;
        return object;
    };

    EthereumTokenInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumTokenInfo;
})();

$root.EthereumDefinitions = (function() {

    function EthereumDefinitions(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumDefinitions.prototype.encoded_network = $util.newBuffer([]);
    EthereumDefinitions.prototype.encoded_token = $util.newBuffer([]);

    EthereumDefinitions.create = function create(properties) {
        return new EthereumDefinitions(properties);
    };

    EthereumDefinitions.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.encoded_network != null && Object.hasOwnProperty.call(message, "encoded_network"))
            writer.uint32(10).bytes(message.encoded_network);
        if (message.encoded_token != null && Object.hasOwnProperty.call(message, "encoded_token"))
            writer.uint32(18).bytes(message.encoded_token);
        return writer;
    };

    EthereumDefinitions.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumDefinitions.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumDefinitions();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.encoded_network = reader.bytes();
                break;
            case 2:
                message.encoded_token = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    EthereumDefinitions.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumDefinitions.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.encoded_network != null && message.hasOwnProperty("encoded_network"))
            if (!(message.encoded_network && typeof message.encoded_network.length === "number" || $util.isString(message.encoded_network)))
                return "encoded_network: buffer expected";
        if (message.encoded_token != null && message.hasOwnProperty("encoded_token"))
            if (!(message.encoded_token && typeof message.encoded_token.length === "number" || $util.isString(message.encoded_token)))
                return "encoded_token: buffer expected";
        return null;
    };

    EthereumDefinitions.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumDefinitions)
            return object;
        var message = new $root.EthereumDefinitions();
        if (object.encoded_network != null)
            if (typeof object.encoded_network === "string")
                $util.base64.decode(object.encoded_network, message.encoded_network = $util.newBuffer($util.base64.length(object.encoded_network)), 0);
            else if (object.encoded_network.length)
                message.encoded_network = object.encoded_network;
        if (object.encoded_token != null)
            if (typeof object.encoded_token === "string")
                $util.base64.decode(object.encoded_token, message.encoded_token = $util.newBuffer($util.base64.length(object.encoded_token)), 0);
            else if (object.encoded_token.length)
                message.encoded_token = object.encoded_token;
        return message;
    };

    EthereumDefinitions.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.encoded_network = "";
            else {
                object.encoded_network = [];
                if (options.bytes !== Array)
                    object.encoded_network = $util.newBuffer(object.encoded_network);
            }
            if (options.bytes === String)
                object.encoded_token = "";
            else {
                object.encoded_token = [];
                if (options.bytes !== Array)
                    object.encoded_token = $util.newBuffer(object.encoded_token);
            }
        }
        if (message.encoded_network != null && message.hasOwnProperty("encoded_network"))
            object.encoded_network = options.bytes === String ? $util.base64.encode(message.encoded_network, 0, message.encoded_network.length) : options.bytes === Array ? Array.prototype.slice.call(message.encoded_network) : message.encoded_network;
        if (message.encoded_token != null && message.hasOwnProperty("encoded_token"))
            object.encoded_token = options.bytes === String ? $util.base64.encode(message.encoded_token, 0, message.encoded_token.length) : options.bytes === Array ? Array.prototype.slice.call(message.encoded_token) : message.encoded_token;
        return object;
    };

    EthereumDefinitions.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumDefinitions;
})();

$root.EthereumSignTypedDataOneKey = (function() {

    function EthereumSignTypedDataOneKey(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumSignTypedDataOneKey.prototype.address_n = $util.emptyArray;
    EthereumSignTypedDataOneKey.prototype.primary_type = "";
    EthereumSignTypedDataOneKey.prototype.metamask_v4_compat = true;
    EthereumSignTypedDataOneKey.prototype.chain_id = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    EthereumSignTypedDataOneKey.create = function create(properties) {
        return new EthereumSignTypedDataOneKey(properties);
    };

    EthereumSignTypedDataOneKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).string(message.primary_type);
        if (message.metamask_v4_compat != null && Object.hasOwnProperty.call(message, "metamask_v4_compat"))
            writer.uint32(24).bool(message.metamask_v4_compat);
        if (message.chain_id != null && Object.hasOwnProperty.call(message, "chain_id"))
            writer.uint32(32).uint64(message.chain_id);
        return writer;
    };

    EthereumSignTypedDataOneKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumSignTypedDataOneKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumSignTypedDataOneKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.primary_type = reader.string();
                break;
            case 3:
                message.metamask_v4_compat = reader.bool();
                break;
            case 4:
                message.chain_id = reader.uint64();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("primary_type"))
            throw $util.ProtocolError("missing required 'primary_type'", { instance: message });
        return message;
    };

    EthereumSignTypedDataOneKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumSignTypedDataOneKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!$util.isString(message.primary_type))
            return "primary_type: string expected";
        if (message.metamask_v4_compat != null && message.hasOwnProperty("metamask_v4_compat"))
            if (typeof message.metamask_v4_compat !== "boolean")
                return "metamask_v4_compat: boolean expected";
        if (message.chain_id != null && message.hasOwnProperty("chain_id"))
            if (!$util.isInteger(message.chain_id) && !(message.chain_id && $util.isInteger(message.chain_id.low) && $util.isInteger(message.chain_id.high)))
                return "chain_id: integer|Long expected";
        return null;
    };

    EthereumSignTypedDataOneKey.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumSignTypedDataOneKey)
            return object;
        var message = new $root.EthereumSignTypedDataOneKey();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".EthereumSignTypedDataOneKey.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.primary_type != null)
            message.primary_type = String(object.primary_type);
        if (object.metamask_v4_compat != null)
            message.metamask_v4_compat = Boolean(object.metamask_v4_compat);
        if (object.chain_id != null)
            if ($util.Long)
                (message.chain_id = $util.Long.fromValue(object.chain_id)).unsigned = true;
            else if (typeof object.chain_id === "string")
                message.chain_id = parseInt(object.chain_id, 10);
            else if (typeof object.chain_id === "number")
                message.chain_id = object.chain_id;
            else if (typeof object.chain_id === "object")
                message.chain_id = new $util.LongBits(object.chain_id.low >>> 0, object.chain_id.high >>> 0).toNumber(true);
        return message;
    };

    EthereumSignTypedDataOneKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            object.primary_type = "";
            object.metamask_v4_compat = true;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.chain_id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.chain_id = options.longs === String ? "0" : 0;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.primary_type != null && message.hasOwnProperty("primary_type"))
            object.primary_type = message.primary_type;
        if (message.metamask_v4_compat != null && message.hasOwnProperty("metamask_v4_compat"))
            object.metamask_v4_compat = message.metamask_v4_compat;
        if (message.chain_id != null && message.hasOwnProperty("chain_id"))
            if (typeof message.chain_id === "number")
                object.chain_id = options.longs === String ? String(message.chain_id) : message.chain_id;
            else
                object.chain_id = options.longs === String ? $util.Long.prototype.toString.call(message.chain_id) : options.longs === Number ? new $util.LongBits(message.chain_id.low >>> 0, message.chain_id.high >>> 0).toNumber(true) : message.chain_id;
        return object;
    };

    EthereumSignTypedDataOneKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumSignTypedDataOneKey;
})();

$root.EthereumTypedDataStructRequestOneKey = (function() {

    function EthereumTypedDataStructRequestOneKey(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumTypedDataStructRequestOneKey.prototype.name = "";

    EthereumTypedDataStructRequestOneKey.create = function create(properties) {
        return new EthereumTypedDataStructRequestOneKey(properties);
    };

    EthereumTypedDataStructRequestOneKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.name);
        return writer;
    };

    EthereumTypedDataStructRequestOneKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumTypedDataStructRequestOneKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumTypedDataStructRequestOneKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.name = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("name"))
            throw $util.ProtocolError("missing required 'name'", { instance: message });
        return message;
    };

    EthereumTypedDataStructRequestOneKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumTypedDataStructRequestOneKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.name))
            return "name: string expected";
        return null;
    };

    EthereumTypedDataStructRequestOneKey.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumTypedDataStructRequestOneKey)
            return object;
        var message = new $root.EthereumTypedDataStructRequestOneKey();
        if (object.name != null)
            message.name = String(object.name);
        return message;
    };

    EthereumTypedDataStructRequestOneKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.name = "";
        if (message.name != null && message.hasOwnProperty("name"))
            object.name = message.name;
        return object;
    };

    EthereumTypedDataStructRequestOneKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumTypedDataStructRequestOneKey;
})();

$root.EthereumTypedDataStructAckOneKey = (function() {

    function EthereumTypedDataStructAckOneKey(properties) {
        this.members = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumTypedDataStructAckOneKey.prototype.members = $util.emptyArray;

    EthereumTypedDataStructAckOneKey.create = function create(properties) {
        return new EthereumTypedDataStructAckOneKey(properties);
    };

    EthereumTypedDataStructAckOneKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.members != null && message.members.length)
            for (var i = 0; i < message.members.length; ++i)
                $root.EthereumTypedDataStructAckOneKey.EthereumStructMemberOneKey.encode(message.members[i], writer.uint32(10).fork()).ldelim();
        return writer;
    };

    EthereumTypedDataStructAckOneKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumTypedDataStructAckOneKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumTypedDataStructAckOneKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.members && message.members.length))
                    message.members = [];
                message.members.push($root.EthereumTypedDataStructAckOneKey.EthereumStructMemberOneKey.decode(reader, reader.uint32()));
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    EthereumTypedDataStructAckOneKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumTypedDataStructAckOneKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.members != null && message.hasOwnProperty("members")) {
            if (!Array.isArray(message.members))
                return "members: array expected";
            for (var i = 0; i < message.members.length; ++i) {
                var error = $root.EthereumTypedDataStructAckOneKey.EthereumStructMemberOneKey.verify(message.members[i]);
                if (error)
                    return "members." + error;
            }
        }
        return null;
    };

    EthereumTypedDataStructAckOneKey.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumTypedDataStructAckOneKey)
            return object;
        var message = new $root.EthereumTypedDataStructAckOneKey();
        if (object.members) {
            if (!Array.isArray(object.members))
                throw TypeError(".EthereumTypedDataStructAckOneKey.members: array expected");
            message.members = [];
            for (var i = 0; i < object.members.length; ++i) {
                if (typeof object.members[i] !== "object")
                    throw TypeError(".EthereumTypedDataStructAckOneKey.members: object expected");
                message.members[i] = $root.EthereumTypedDataStructAckOneKey.EthereumStructMemberOneKey.fromObject(object.members[i]);
            }
        }
        return message;
    };

    EthereumTypedDataStructAckOneKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.members = [];
        if (message.members && message.members.length) {
            object.members = [];
            for (var j = 0; j < message.members.length; ++j)
                object.members[j] = $root.EthereumTypedDataStructAckOneKey.EthereumStructMemberOneKey.toObject(message.members[j], options);
        }
        return object;
    };

    EthereumTypedDataStructAckOneKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    EthereumTypedDataStructAckOneKey.EthereumStructMemberOneKey = (function() {

        function EthereumStructMemberOneKey(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        EthereumStructMemberOneKey.prototype.type = null;
        EthereumStructMemberOneKey.prototype.name = "";

        EthereumStructMemberOneKey.create = function create(properties) {
            return new EthereumStructMemberOneKey(properties);
        };

        EthereumStructMemberOneKey.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            $root.EthereumTypedDataStructAckOneKey.EthereumFieldTypeOneKey.encode(message.type, writer.uint32(10).fork()).ldelim();
            writer.uint32(18).string(message.name);
            return writer;
        };

        EthereumStructMemberOneKey.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        EthereumStructMemberOneKey.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumTypedDataStructAckOneKey.EthereumStructMemberOneKey();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.type = $root.EthereumTypedDataStructAckOneKey.EthereumFieldTypeOneKey.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.name = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("type"))
                throw $util.ProtocolError("missing required 'type'", { instance: message });
            if (!message.hasOwnProperty("name"))
                throw $util.ProtocolError("missing required 'name'", { instance: message });
            return message;
        };

        EthereumStructMemberOneKey.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        EthereumStructMemberOneKey.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            {
                var error = $root.EthereumTypedDataStructAckOneKey.EthereumFieldTypeOneKey.verify(message.type);
                if (error)
                    return "type." + error;
            }
            if (!$util.isString(message.name))
                return "name: string expected";
            return null;
        };

        EthereumStructMemberOneKey.fromObject = function fromObject(object) {
            if (object instanceof $root.EthereumTypedDataStructAckOneKey.EthereumStructMemberOneKey)
                return object;
            var message = new $root.EthereumTypedDataStructAckOneKey.EthereumStructMemberOneKey();
            if (object.type != null) {
                if (typeof object.type !== "object")
                    throw TypeError(".EthereumTypedDataStructAckOneKey.EthereumStructMemberOneKey.type: object expected");
                message.type = $root.EthereumTypedDataStructAckOneKey.EthereumFieldTypeOneKey.fromObject(object.type);
            }
            if (object.name != null)
                message.name = String(object.name);
            return message;
        };

        EthereumStructMemberOneKey.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.type = null;
                object.name = "";
            }
            if (message.type != null && message.hasOwnProperty("type"))
                object.type = $root.EthereumTypedDataStructAckOneKey.EthereumFieldTypeOneKey.toObject(message.type, options);
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            return object;
        };

        EthereumStructMemberOneKey.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EthereumStructMemberOneKey;
    })();

    EthereumTypedDataStructAckOneKey.EthereumFieldTypeOneKey = (function() {

        function EthereumFieldTypeOneKey(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        EthereumFieldTypeOneKey.prototype.data_type = 1;
        EthereumFieldTypeOneKey.prototype.size = 0;
        EthereumFieldTypeOneKey.prototype.entry_type = null;
        EthereumFieldTypeOneKey.prototype.struct_name = "";

        EthereumFieldTypeOneKey.create = function create(properties) {
            return new EthereumFieldTypeOneKey(properties);
        };

        EthereumFieldTypeOneKey.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(8).int32(message.data_type);
            if (message.size != null && Object.hasOwnProperty.call(message, "size"))
                writer.uint32(16).uint32(message.size);
            if (message.entry_type != null && Object.hasOwnProperty.call(message, "entry_type"))
                $root.EthereumTypedDataStructAckOneKey.EthereumFieldTypeOneKey.encode(message.entry_type, writer.uint32(26).fork()).ldelim();
            if (message.struct_name != null && Object.hasOwnProperty.call(message, "struct_name"))
                writer.uint32(34).string(message.struct_name);
            return writer;
        };

        EthereumFieldTypeOneKey.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        EthereumFieldTypeOneKey.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumTypedDataStructAckOneKey.EthereumFieldTypeOneKey();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.data_type = reader.int32();
                    break;
                case 2:
                    message.size = reader.uint32();
                    break;
                case 3:
                    message.entry_type = $root.EthereumTypedDataStructAckOneKey.EthereumFieldTypeOneKey.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.struct_name = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("data_type"))
                throw $util.ProtocolError("missing required 'data_type'", { instance: message });
            return message;
        };

        EthereumFieldTypeOneKey.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        EthereumFieldTypeOneKey.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            switch (message.data_type) {
            default:
                return "data_type: enum value expected";
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
            case 8:
                break;
            }
            if (message.size != null && message.hasOwnProperty("size"))
                if (!$util.isInteger(message.size))
                    return "size: integer expected";
            if (message.entry_type != null && message.hasOwnProperty("entry_type")) {
                var error = $root.EthereumTypedDataStructAckOneKey.EthereumFieldTypeOneKey.verify(message.entry_type);
                if (error)
                    return "entry_type." + error;
            }
            if (message.struct_name != null && message.hasOwnProperty("struct_name"))
                if (!$util.isString(message.struct_name))
                    return "struct_name: string expected";
            return null;
        };

        EthereumFieldTypeOneKey.fromObject = function fromObject(object) {
            if (object instanceof $root.EthereumTypedDataStructAckOneKey.EthereumFieldTypeOneKey)
                return object;
            var message = new $root.EthereumTypedDataStructAckOneKey.EthereumFieldTypeOneKey();
            switch (object.data_type) {
            case "UINT":
            case 1:
                message.data_type = 1;
                break;
            case "INT":
            case 2:
                message.data_type = 2;
                break;
            case "BYTES":
            case 3:
                message.data_type = 3;
                break;
            case "STRING":
            case 4:
                message.data_type = 4;
                break;
            case "BOOL":
            case 5:
                message.data_type = 5;
                break;
            case "ADDRESS":
            case 6:
                message.data_type = 6;
                break;
            case "ARRAY":
            case 7:
                message.data_type = 7;
                break;
            case "STRUCT":
            case 8:
                message.data_type = 8;
                break;
            }
            if (object.size != null)
                message.size = object.size >>> 0;
            if (object.entry_type != null) {
                if (typeof object.entry_type !== "object")
                    throw TypeError(".EthereumTypedDataStructAckOneKey.EthereumFieldTypeOneKey.entry_type: object expected");
                message.entry_type = $root.EthereumTypedDataStructAckOneKey.EthereumFieldTypeOneKey.fromObject(object.entry_type);
            }
            if (object.struct_name != null)
                message.struct_name = String(object.struct_name);
            return message;
        };

        EthereumFieldTypeOneKey.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.data_type = options.enums === String ? "UINT" : 1;
                object.size = 0;
                object.entry_type = null;
                object.struct_name = "";
            }
            if (message.data_type != null && message.hasOwnProperty("data_type"))
                object.data_type = options.enums === String ? $root.EthereumTypedDataStructAckOneKey.EthereumDataTypeOneKey[message.data_type] : message.data_type;
            if (message.size != null && message.hasOwnProperty("size"))
                object.size = message.size;
            if (message.entry_type != null && message.hasOwnProperty("entry_type"))
                object.entry_type = $root.EthereumTypedDataStructAckOneKey.EthereumFieldTypeOneKey.toObject(message.entry_type, options);
            if (message.struct_name != null && message.hasOwnProperty("struct_name"))
                object.struct_name = message.struct_name;
            return object;
        };

        EthereumFieldTypeOneKey.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EthereumFieldTypeOneKey;
    })();

    EthereumTypedDataStructAckOneKey.EthereumDataTypeOneKey = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[1] = "UINT"] = 1;
        values[valuesById[2] = "INT"] = 2;
        values[valuesById[3] = "BYTES"] = 3;
        values[valuesById[4] = "STRING"] = 4;
        values[valuesById[5] = "BOOL"] = 5;
        values[valuesById[6] = "ADDRESS"] = 6;
        values[valuesById[7] = "ARRAY"] = 7;
        values[valuesById[8] = "STRUCT"] = 8;
        return values;
    })();

    return EthereumTypedDataStructAckOneKey;
})();

$root.EthereumTypedDataValueRequestOneKey = (function() {

    function EthereumTypedDataValueRequestOneKey(properties) {
        this.member_path = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumTypedDataValueRequestOneKey.prototype.member_path = $util.emptyArray;

    EthereumTypedDataValueRequestOneKey.create = function create(properties) {
        return new EthereumTypedDataValueRequestOneKey(properties);
    };

    EthereumTypedDataValueRequestOneKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.member_path != null && message.member_path.length)
            for (var i = 0; i < message.member_path.length; ++i)
                writer.uint32(8).uint32(message.member_path[i]);
        return writer;
    };

    EthereumTypedDataValueRequestOneKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumTypedDataValueRequestOneKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumTypedDataValueRequestOneKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.member_path && message.member_path.length))
                    message.member_path = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.member_path.push(reader.uint32());
                } else
                    message.member_path.push(reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    EthereumTypedDataValueRequestOneKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumTypedDataValueRequestOneKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.member_path != null && message.hasOwnProperty("member_path")) {
            if (!Array.isArray(message.member_path))
                return "member_path: array expected";
            for (var i = 0; i < message.member_path.length; ++i)
                if (!$util.isInteger(message.member_path[i]))
                    return "member_path: integer[] expected";
        }
        return null;
    };

    EthereumTypedDataValueRequestOneKey.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumTypedDataValueRequestOneKey)
            return object;
        var message = new $root.EthereumTypedDataValueRequestOneKey();
        if (object.member_path) {
            if (!Array.isArray(object.member_path))
                throw TypeError(".EthereumTypedDataValueRequestOneKey.member_path: array expected");
            message.member_path = [];
            for (var i = 0; i < object.member_path.length; ++i)
                message.member_path[i] = object.member_path[i] >>> 0;
        }
        return message;
    };

    EthereumTypedDataValueRequestOneKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.member_path = [];
        if (message.member_path && message.member_path.length) {
            object.member_path = [];
            for (var j = 0; j < message.member_path.length; ++j)
                object.member_path[j] = message.member_path[j];
        }
        return object;
    };

    EthereumTypedDataValueRequestOneKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumTypedDataValueRequestOneKey;
})();

$root.EthereumTypedDataValueAckOneKey = (function() {

    function EthereumTypedDataValueAckOneKey(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumTypedDataValueAckOneKey.prototype.value = $util.newBuffer([]);

    EthereumTypedDataValueAckOneKey.create = function create(properties) {
        return new EthereumTypedDataValueAckOneKey(properties);
    };

    EthereumTypedDataValueAckOneKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.value);
        return writer;
    };

    EthereumTypedDataValueAckOneKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumTypedDataValueAckOneKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumTypedDataValueAckOneKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.value = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("value"))
            throw $util.ProtocolError("missing required 'value'", { instance: message });
        return message;
    };

    EthereumTypedDataValueAckOneKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumTypedDataValueAckOneKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.value && typeof message.value.length === "number" || $util.isString(message.value)))
            return "value: buffer expected";
        return null;
    };

    EthereumTypedDataValueAckOneKey.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumTypedDataValueAckOneKey)
            return object;
        var message = new $root.EthereumTypedDataValueAckOneKey();
        if (object.value != null)
            if (typeof object.value === "string")
                $util.base64.decode(object.value, message.value = $util.newBuffer($util.base64.length(object.value)), 0);
            else if (object.value.length)
                message.value = object.value;
        return message;
    };

    EthereumTypedDataValueAckOneKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.value = "";
            else {
                object.value = [];
                if (options.bytes !== Array)
                    object.value = $util.newBuffer(object.value);
            }
        if (message.value != null && message.hasOwnProperty("value"))
            object.value = options.bytes === String ? $util.base64.encode(message.value, 0, message.value.length) : options.bytes === Array ? Array.prototype.slice.call(message.value) : message.value;
        return object;
    };

    EthereumTypedDataValueAckOneKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumTypedDataValueAckOneKey;
})();

$root.EthereumGnosisSafeTxOperation = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "CALL"] = 0;
    values[valuesById[1] = "DELEGATE_CALL"] = 1;
    return values;
})();

$root.EthereumGnosisSafeTxRequest = (function() {

    function EthereumGnosisSafeTxRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumGnosisSafeTxRequest.create = function create(properties) {
        return new EthereumGnosisSafeTxRequest(properties);
    };

    EthereumGnosisSafeTxRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    EthereumGnosisSafeTxRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumGnosisSafeTxRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumGnosisSafeTxRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    EthereumGnosisSafeTxRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumGnosisSafeTxRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    EthereumGnosisSafeTxRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumGnosisSafeTxRequest)
            return object;
        return new $root.EthereumGnosisSafeTxRequest();
    };

    EthereumGnosisSafeTxRequest.toObject = function toObject() {
        return {};
    };

    EthereumGnosisSafeTxRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumGnosisSafeTxRequest;
})();

$root.EthereumGnosisSafeTxAck = (function() {

    function EthereumGnosisSafeTxAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumGnosisSafeTxAck.prototype.to = "";
    EthereumGnosisSafeTxAck.prototype.value = $util.newBuffer([]);
    EthereumGnosisSafeTxAck.prototype.data = $util.newBuffer([]);
    EthereumGnosisSafeTxAck.prototype.operation = 0;
    EthereumGnosisSafeTxAck.prototype.safeTxGas = $util.newBuffer([]);
    EthereumGnosisSafeTxAck.prototype.baseGas = $util.newBuffer([]);
    EthereumGnosisSafeTxAck.prototype.gasPrice = $util.newBuffer([]);
    EthereumGnosisSafeTxAck.prototype.gasToken = "";
    EthereumGnosisSafeTxAck.prototype.refundReceiver = "";
    EthereumGnosisSafeTxAck.prototype.nonce = $util.newBuffer([]);
    EthereumGnosisSafeTxAck.prototype.chain_id = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    EthereumGnosisSafeTxAck.prototype.verifyingContract = "";

    EthereumGnosisSafeTxAck.create = function create(properties) {
        return new EthereumGnosisSafeTxAck(properties);
    };

    EthereumGnosisSafeTxAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.to);
        writer.uint32(18).bytes(message.value);
        if (message.data != null && Object.hasOwnProperty.call(message, "data"))
            writer.uint32(26).bytes(message.data);
        writer.uint32(32).int32(message.operation);
        writer.uint32(42).bytes(message.safeTxGas);
        writer.uint32(50).bytes(message.baseGas);
        writer.uint32(58).bytes(message.gasPrice);
        writer.uint32(66).string(message.gasToken);
        writer.uint32(74).string(message.refundReceiver);
        writer.uint32(82).bytes(message.nonce);
        writer.uint32(88).uint64(message.chain_id);
        writer.uint32(98).string(message.verifyingContract);
        return writer;
    };

    EthereumGnosisSafeTxAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumGnosisSafeTxAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumGnosisSafeTxAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.to = reader.string();
                break;
            case 2:
                message.value = reader.bytes();
                break;
            case 3:
                message.data = reader.bytes();
                break;
            case 4:
                message.operation = reader.int32();
                break;
            case 5:
                message.safeTxGas = reader.bytes();
                break;
            case 6:
                message.baseGas = reader.bytes();
                break;
            case 7:
                message.gasPrice = reader.bytes();
                break;
            case 8:
                message.gasToken = reader.string();
                break;
            case 9:
                message.refundReceiver = reader.string();
                break;
            case 10:
                message.nonce = reader.bytes();
                break;
            case 11:
                message.chain_id = reader.uint64();
                break;
            case 12:
                message.verifyingContract = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("to"))
            throw $util.ProtocolError("missing required 'to'", { instance: message });
        if (!message.hasOwnProperty("value"))
            throw $util.ProtocolError("missing required 'value'", { instance: message });
        if (!message.hasOwnProperty("operation"))
            throw $util.ProtocolError("missing required 'operation'", { instance: message });
        if (!message.hasOwnProperty("safeTxGas"))
            throw $util.ProtocolError("missing required 'safeTxGas'", { instance: message });
        if (!message.hasOwnProperty("baseGas"))
            throw $util.ProtocolError("missing required 'baseGas'", { instance: message });
        if (!message.hasOwnProperty("gasPrice"))
            throw $util.ProtocolError("missing required 'gasPrice'", { instance: message });
        if (!message.hasOwnProperty("gasToken"))
            throw $util.ProtocolError("missing required 'gasToken'", { instance: message });
        if (!message.hasOwnProperty("refundReceiver"))
            throw $util.ProtocolError("missing required 'refundReceiver'", { instance: message });
        if (!message.hasOwnProperty("nonce"))
            throw $util.ProtocolError("missing required 'nonce'", { instance: message });
        if (!message.hasOwnProperty("chain_id"))
            throw $util.ProtocolError("missing required 'chain_id'", { instance: message });
        if (!message.hasOwnProperty("verifyingContract"))
            throw $util.ProtocolError("missing required 'verifyingContract'", { instance: message });
        return message;
    };

    EthereumGnosisSafeTxAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumGnosisSafeTxAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.to))
            return "to: string expected";
        if (!(message.value && typeof message.value.length === "number" || $util.isString(message.value)))
            return "value: buffer expected";
        if (message.data != null && message.hasOwnProperty("data"))
            if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
                return "data: buffer expected";
        switch (message.operation) {
        default:
            return "operation: enum value expected";
        case 0:
        case 1:
            break;
        }
        if (!(message.safeTxGas && typeof message.safeTxGas.length === "number" || $util.isString(message.safeTxGas)))
            return "safeTxGas: buffer expected";
        if (!(message.baseGas && typeof message.baseGas.length === "number" || $util.isString(message.baseGas)))
            return "baseGas: buffer expected";
        if (!(message.gasPrice && typeof message.gasPrice.length === "number" || $util.isString(message.gasPrice)))
            return "gasPrice: buffer expected";
        if (!$util.isString(message.gasToken))
            return "gasToken: string expected";
        if (!$util.isString(message.refundReceiver))
            return "refundReceiver: string expected";
        if (!(message.nonce && typeof message.nonce.length === "number" || $util.isString(message.nonce)))
            return "nonce: buffer expected";
        if (!$util.isInteger(message.chain_id) && !(message.chain_id && $util.isInteger(message.chain_id.low) && $util.isInteger(message.chain_id.high)))
            return "chain_id: integer|Long expected";
        if (!$util.isString(message.verifyingContract))
            return "verifyingContract: string expected";
        return null;
    };

    EthereumGnosisSafeTxAck.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumGnosisSafeTxAck)
            return object;
        var message = new $root.EthereumGnosisSafeTxAck();
        if (object.to != null)
            message.to = String(object.to);
        if (object.value != null)
            if (typeof object.value === "string")
                $util.base64.decode(object.value, message.value = $util.newBuffer($util.base64.length(object.value)), 0);
            else if (object.value.length)
                message.value = object.value;
        if (object.data != null)
            if (typeof object.data === "string")
                $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
            else if (object.data.length)
                message.data = object.data;
        switch (object.operation) {
        case "CALL":
        case 0:
            message.operation = 0;
            break;
        case "DELEGATE_CALL":
        case 1:
            message.operation = 1;
            break;
        }
        if (object.safeTxGas != null)
            if (typeof object.safeTxGas === "string")
                $util.base64.decode(object.safeTxGas, message.safeTxGas = $util.newBuffer($util.base64.length(object.safeTxGas)), 0);
            else if (object.safeTxGas.length)
                message.safeTxGas = object.safeTxGas;
        if (object.baseGas != null)
            if (typeof object.baseGas === "string")
                $util.base64.decode(object.baseGas, message.baseGas = $util.newBuffer($util.base64.length(object.baseGas)), 0);
            else if (object.baseGas.length)
                message.baseGas = object.baseGas;
        if (object.gasPrice != null)
            if (typeof object.gasPrice === "string")
                $util.base64.decode(object.gasPrice, message.gasPrice = $util.newBuffer($util.base64.length(object.gasPrice)), 0);
            else if (object.gasPrice.length)
                message.gasPrice = object.gasPrice;
        if (object.gasToken != null)
            message.gasToken = String(object.gasToken);
        if (object.refundReceiver != null)
            message.refundReceiver = String(object.refundReceiver);
        if (object.nonce != null)
            if (typeof object.nonce === "string")
                $util.base64.decode(object.nonce, message.nonce = $util.newBuffer($util.base64.length(object.nonce)), 0);
            else if (object.nonce.length)
                message.nonce = object.nonce;
        if (object.chain_id != null)
            if ($util.Long)
                (message.chain_id = $util.Long.fromValue(object.chain_id)).unsigned = true;
            else if (typeof object.chain_id === "string")
                message.chain_id = parseInt(object.chain_id, 10);
            else if (typeof object.chain_id === "number")
                message.chain_id = object.chain_id;
            else if (typeof object.chain_id === "object")
                message.chain_id = new $util.LongBits(object.chain_id.low >>> 0, object.chain_id.high >>> 0).toNumber(true);
        if (object.verifyingContract != null)
            message.verifyingContract = String(object.verifyingContract);
        return message;
    };

    EthereumGnosisSafeTxAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.to = "";
            if (options.bytes === String)
                object.value = "";
            else {
                object.value = [];
                if (options.bytes !== Array)
                    object.value = $util.newBuffer(object.value);
            }
            if (options.bytes === String)
                object.data = "";
            else {
                object.data = [];
                if (options.bytes !== Array)
                    object.data = $util.newBuffer(object.data);
            }
            object.operation = options.enums === String ? "CALL" : 0;
            if (options.bytes === String)
                object.safeTxGas = "";
            else {
                object.safeTxGas = [];
                if (options.bytes !== Array)
                    object.safeTxGas = $util.newBuffer(object.safeTxGas);
            }
            if (options.bytes === String)
                object.baseGas = "";
            else {
                object.baseGas = [];
                if (options.bytes !== Array)
                    object.baseGas = $util.newBuffer(object.baseGas);
            }
            if (options.bytes === String)
                object.gasPrice = "";
            else {
                object.gasPrice = [];
                if (options.bytes !== Array)
                    object.gasPrice = $util.newBuffer(object.gasPrice);
            }
            object.gasToken = "";
            object.refundReceiver = "";
            if (options.bytes === String)
                object.nonce = "";
            else {
                object.nonce = [];
                if (options.bytes !== Array)
                    object.nonce = $util.newBuffer(object.nonce);
            }
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.chain_id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.chain_id = options.longs === String ? "0" : 0;
            object.verifyingContract = "";
        }
        if (message.to != null && message.hasOwnProperty("to"))
            object.to = message.to;
        if (message.value != null && message.hasOwnProperty("value"))
            object.value = options.bytes === String ? $util.base64.encode(message.value, 0, message.value.length) : options.bytes === Array ? Array.prototype.slice.call(message.value) : message.value;
        if (message.data != null && message.hasOwnProperty("data"))
            object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
        if (message.operation != null && message.hasOwnProperty("operation"))
            object.operation = options.enums === String ? $root.EthereumGnosisSafeTxOperation[message.operation] : message.operation;
        if (message.safeTxGas != null && message.hasOwnProperty("safeTxGas"))
            object.safeTxGas = options.bytes === String ? $util.base64.encode(message.safeTxGas, 0, message.safeTxGas.length) : options.bytes === Array ? Array.prototype.slice.call(message.safeTxGas) : message.safeTxGas;
        if (message.baseGas != null && message.hasOwnProperty("baseGas"))
            object.baseGas = options.bytes === String ? $util.base64.encode(message.baseGas, 0, message.baseGas.length) : options.bytes === Array ? Array.prototype.slice.call(message.baseGas) : message.baseGas;
        if (message.gasPrice != null && message.hasOwnProperty("gasPrice"))
            object.gasPrice = options.bytes === String ? $util.base64.encode(message.gasPrice, 0, message.gasPrice.length) : options.bytes === Array ? Array.prototype.slice.call(message.gasPrice) : message.gasPrice;
        if (message.gasToken != null && message.hasOwnProperty("gasToken"))
            object.gasToken = message.gasToken;
        if (message.refundReceiver != null && message.hasOwnProperty("refundReceiver"))
            object.refundReceiver = message.refundReceiver;
        if (message.nonce != null && message.hasOwnProperty("nonce"))
            object.nonce = options.bytes === String ? $util.base64.encode(message.nonce, 0, message.nonce.length) : options.bytes === Array ? Array.prototype.slice.call(message.nonce) : message.nonce;
        if (message.chain_id != null && message.hasOwnProperty("chain_id"))
            if (typeof message.chain_id === "number")
                object.chain_id = options.longs === String ? String(message.chain_id) : message.chain_id;
            else
                object.chain_id = options.longs === String ? $util.Long.prototype.toString.call(message.chain_id) : options.longs === Number ? new $util.LongBits(message.chain_id.low >>> 0, message.chain_id.high >>> 0).toNumber(true) : message.chain_id;
        if (message.verifyingContract != null && message.hasOwnProperty("verifyingContract"))
            object.verifyingContract = message.verifyingContract;
        return object;
    };

    EthereumGnosisSafeTxAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumGnosisSafeTxAck;
})();

$root.EthereumSignTypedDataQR = (function() {

    function EthereumSignTypedDataQR(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumSignTypedDataQR.prototype.address_n = $util.emptyArray;
    EthereumSignTypedDataQR.prototype.json_data = $util.newBuffer([]);
    EthereumSignTypedDataQR.prototype.chain_id = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    EthereumSignTypedDataQR.prototype.metamask_v4_compat = true;
    EthereumSignTypedDataQR.prototype.request_id = $util.newBuffer([]);

    EthereumSignTypedDataQR.create = function create(properties) {
        return new EthereumSignTypedDataQR(properties);
    };

    EthereumSignTypedDataQR.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.json_data != null && Object.hasOwnProperty.call(message, "json_data"))
            writer.uint32(18).bytes(message.json_data);
        if (message.chain_id != null && Object.hasOwnProperty.call(message, "chain_id"))
            writer.uint32(24).uint64(message.chain_id);
        if (message.metamask_v4_compat != null && Object.hasOwnProperty.call(message, "metamask_v4_compat"))
            writer.uint32(32).bool(message.metamask_v4_compat);
        if (message.request_id != null && Object.hasOwnProperty.call(message, "request_id"))
            writer.uint32(42).bytes(message.request_id);
        return writer;
    };

    EthereumSignTypedDataQR.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumSignTypedDataQR.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumSignTypedDataQR();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.json_data = reader.bytes();
                break;
            case 3:
                message.chain_id = reader.uint64();
                break;
            case 4:
                message.metamask_v4_compat = reader.bool();
                break;
            case 5:
                message.request_id = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    EthereumSignTypedDataQR.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumSignTypedDataQR.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.json_data != null && message.hasOwnProperty("json_data"))
            if (!(message.json_data && typeof message.json_data.length === "number" || $util.isString(message.json_data)))
                return "json_data: buffer expected";
        if (message.chain_id != null && message.hasOwnProperty("chain_id"))
            if (!$util.isInteger(message.chain_id) && !(message.chain_id && $util.isInteger(message.chain_id.low) && $util.isInteger(message.chain_id.high)))
                return "chain_id: integer|Long expected";
        if (message.metamask_v4_compat != null && message.hasOwnProperty("metamask_v4_compat"))
            if (typeof message.metamask_v4_compat !== "boolean")
                return "metamask_v4_compat: boolean expected";
        if (message.request_id != null && message.hasOwnProperty("request_id"))
            if (!(message.request_id && typeof message.request_id.length === "number" || $util.isString(message.request_id)))
                return "request_id: buffer expected";
        return null;
    };

    EthereumSignTypedDataQR.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumSignTypedDataQR)
            return object;
        var message = new $root.EthereumSignTypedDataQR();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".EthereumSignTypedDataQR.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.json_data != null)
            if (typeof object.json_data === "string")
                $util.base64.decode(object.json_data, message.json_data = $util.newBuffer($util.base64.length(object.json_data)), 0);
            else if (object.json_data.length)
                message.json_data = object.json_data;
        if (object.chain_id != null)
            if ($util.Long)
                (message.chain_id = $util.Long.fromValue(object.chain_id)).unsigned = true;
            else if (typeof object.chain_id === "string")
                message.chain_id = parseInt(object.chain_id, 10);
            else if (typeof object.chain_id === "number")
                message.chain_id = object.chain_id;
            else if (typeof object.chain_id === "object")
                message.chain_id = new $util.LongBits(object.chain_id.low >>> 0, object.chain_id.high >>> 0).toNumber(true);
        if (object.metamask_v4_compat != null)
            message.metamask_v4_compat = Boolean(object.metamask_v4_compat);
        if (object.request_id != null)
            if (typeof object.request_id === "string")
                $util.base64.decode(object.request_id, message.request_id = $util.newBuffer($util.base64.length(object.request_id)), 0);
            else if (object.request_id.length)
                message.request_id = object.request_id;
        return message;
    };

    EthereumSignTypedDataQR.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            if (options.bytes === String)
                object.json_data = "";
            else {
                object.json_data = [];
                if (options.bytes !== Array)
                    object.json_data = $util.newBuffer(object.json_data);
            }
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.chain_id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.chain_id = options.longs === String ? "0" : 0;
            object.metamask_v4_compat = true;
            if (options.bytes === String)
                object.request_id = "";
            else {
                object.request_id = [];
                if (options.bytes !== Array)
                    object.request_id = $util.newBuffer(object.request_id);
            }
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.json_data != null && message.hasOwnProperty("json_data"))
            object.json_data = options.bytes === String ? $util.base64.encode(message.json_data, 0, message.json_data.length) : options.bytes === Array ? Array.prototype.slice.call(message.json_data) : message.json_data;
        if (message.chain_id != null && message.hasOwnProperty("chain_id"))
            if (typeof message.chain_id === "number")
                object.chain_id = options.longs === String ? String(message.chain_id) : message.chain_id;
            else
                object.chain_id = options.longs === String ? $util.Long.prototype.toString.call(message.chain_id) : options.longs === Number ? new $util.LongBits(message.chain_id.low >>> 0, message.chain_id.high >>> 0).toNumber(true) : message.chain_id;
        if (message.metamask_v4_compat != null && message.hasOwnProperty("metamask_v4_compat"))
            object.metamask_v4_compat = message.metamask_v4_compat;
        if (message.request_id != null && message.hasOwnProperty("request_id"))
            object.request_id = options.bytes === String ? $util.base64.encode(message.request_id, 0, message.request_id.length) : options.bytes === Array ? Array.prototype.slice.call(message.request_id) : message.request_id;
        return object;
    };

    EthereumSignTypedDataQR.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumSignTypedDataQR;
})();

$root.EthereumSignTypedData = (function() {

    function EthereumSignTypedData(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumSignTypedData.prototype.address_n = $util.emptyArray;
    EthereumSignTypedData.prototype.primary_type = "";
    EthereumSignTypedData.prototype.metamask_v4_compat = true;
    EthereumSignTypedData.prototype.definitions = null;

    EthereumSignTypedData.create = function create(properties) {
        return new EthereumSignTypedData(properties);
    };

    EthereumSignTypedData.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).string(message.primary_type);
        if (message.metamask_v4_compat != null && Object.hasOwnProperty.call(message, "metamask_v4_compat"))
            writer.uint32(24).bool(message.metamask_v4_compat);
        if (message.definitions != null && Object.hasOwnProperty.call(message, "definitions"))
            $root.EthereumDefinitions.encode(message.definitions, writer.uint32(34).fork()).ldelim();
        return writer;
    };

    EthereumSignTypedData.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumSignTypedData.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumSignTypedData();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.primary_type = reader.string();
                break;
            case 3:
                message.metamask_v4_compat = reader.bool();
                break;
            case 4:
                message.definitions = $root.EthereumDefinitions.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("primary_type"))
            throw $util.ProtocolError("missing required 'primary_type'", { instance: message });
        return message;
    };

    EthereumSignTypedData.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumSignTypedData.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!$util.isString(message.primary_type))
            return "primary_type: string expected";
        if (message.metamask_v4_compat != null && message.hasOwnProperty("metamask_v4_compat"))
            if (typeof message.metamask_v4_compat !== "boolean")
                return "metamask_v4_compat: boolean expected";
        if (message.definitions != null && message.hasOwnProperty("definitions")) {
            var error = $root.EthereumDefinitions.verify(message.definitions);
            if (error)
                return "definitions." + error;
        }
        return null;
    };

    EthereumSignTypedData.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumSignTypedData)
            return object;
        var message = new $root.EthereumSignTypedData();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".EthereumSignTypedData.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.primary_type != null)
            message.primary_type = String(object.primary_type);
        if (object.metamask_v4_compat != null)
            message.metamask_v4_compat = Boolean(object.metamask_v4_compat);
        if (object.definitions != null) {
            if (typeof object.definitions !== "object")
                throw TypeError(".EthereumSignTypedData.definitions: object expected");
            message.definitions = $root.EthereumDefinitions.fromObject(object.definitions);
        }
        return message;
    };

    EthereumSignTypedData.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            object.primary_type = "";
            object.metamask_v4_compat = true;
            object.definitions = null;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.primary_type != null && message.hasOwnProperty("primary_type"))
            object.primary_type = message.primary_type;
        if (message.metamask_v4_compat != null && message.hasOwnProperty("metamask_v4_compat"))
            object.metamask_v4_compat = message.metamask_v4_compat;
        if (message.definitions != null && message.hasOwnProperty("definitions"))
            object.definitions = $root.EthereumDefinitions.toObject(message.definitions, options);
        return object;
    };

    EthereumSignTypedData.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumSignTypedData;
})();

$root.EthereumTypedDataStructRequest = (function() {

    function EthereumTypedDataStructRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumTypedDataStructRequest.prototype.name = "";

    EthereumTypedDataStructRequest.create = function create(properties) {
        return new EthereumTypedDataStructRequest(properties);
    };

    EthereumTypedDataStructRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.name);
        return writer;
    };

    EthereumTypedDataStructRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumTypedDataStructRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumTypedDataStructRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.name = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("name"))
            throw $util.ProtocolError("missing required 'name'", { instance: message });
        return message;
    };

    EthereumTypedDataStructRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumTypedDataStructRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.name))
            return "name: string expected";
        return null;
    };

    EthereumTypedDataStructRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumTypedDataStructRequest)
            return object;
        var message = new $root.EthereumTypedDataStructRequest();
        if (object.name != null)
            message.name = String(object.name);
        return message;
    };

    EthereumTypedDataStructRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.name = "";
        if (message.name != null && message.hasOwnProperty("name"))
            object.name = message.name;
        return object;
    };

    EthereumTypedDataStructRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumTypedDataStructRequest;
})();

$root.EthereumTypedDataStructAck = (function() {

    function EthereumTypedDataStructAck(properties) {
        this.members = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumTypedDataStructAck.prototype.members = $util.emptyArray;

    EthereumTypedDataStructAck.create = function create(properties) {
        return new EthereumTypedDataStructAck(properties);
    };

    EthereumTypedDataStructAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.members != null && message.members.length)
            for (var i = 0; i < message.members.length; ++i)
                $root.EthereumTypedDataStructAck.EthereumStructMember.encode(message.members[i], writer.uint32(10).fork()).ldelim();
        return writer;
    };

    EthereumTypedDataStructAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumTypedDataStructAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumTypedDataStructAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.members && message.members.length))
                    message.members = [];
                message.members.push($root.EthereumTypedDataStructAck.EthereumStructMember.decode(reader, reader.uint32()));
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    EthereumTypedDataStructAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumTypedDataStructAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.members != null && message.hasOwnProperty("members")) {
            if (!Array.isArray(message.members))
                return "members: array expected";
            for (var i = 0; i < message.members.length; ++i) {
                var error = $root.EthereumTypedDataStructAck.EthereumStructMember.verify(message.members[i]);
                if (error)
                    return "members." + error;
            }
        }
        return null;
    };

    EthereumTypedDataStructAck.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumTypedDataStructAck)
            return object;
        var message = new $root.EthereumTypedDataStructAck();
        if (object.members) {
            if (!Array.isArray(object.members))
                throw TypeError(".EthereumTypedDataStructAck.members: array expected");
            message.members = [];
            for (var i = 0; i < object.members.length; ++i) {
                if (typeof object.members[i] !== "object")
                    throw TypeError(".EthereumTypedDataStructAck.members: object expected");
                message.members[i] = $root.EthereumTypedDataStructAck.EthereumStructMember.fromObject(object.members[i]);
            }
        }
        return message;
    };

    EthereumTypedDataStructAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.members = [];
        if (message.members && message.members.length) {
            object.members = [];
            for (var j = 0; j < message.members.length; ++j)
                object.members[j] = $root.EthereumTypedDataStructAck.EthereumStructMember.toObject(message.members[j], options);
        }
        return object;
    };

    EthereumTypedDataStructAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    EthereumTypedDataStructAck.EthereumStructMember = (function() {

        function EthereumStructMember(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        EthereumStructMember.prototype.type = null;
        EthereumStructMember.prototype.name = "";

        EthereumStructMember.create = function create(properties) {
            return new EthereumStructMember(properties);
        };

        EthereumStructMember.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            $root.EthereumTypedDataStructAck.EthereumFieldType.encode(message.type, writer.uint32(10).fork()).ldelim();
            writer.uint32(18).string(message.name);
            return writer;
        };

        EthereumStructMember.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        EthereumStructMember.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumTypedDataStructAck.EthereumStructMember();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.type = $root.EthereumTypedDataStructAck.EthereumFieldType.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.name = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("type"))
                throw $util.ProtocolError("missing required 'type'", { instance: message });
            if (!message.hasOwnProperty("name"))
                throw $util.ProtocolError("missing required 'name'", { instance: message });
            return message;
        };

        EthereumStructMember.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        EthereumStructMember.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            {
                var error = $root.EthereumTypedDataStructAck.EthereumFieldType.verify(message.type);
                if (error)
                    return "type." + error;
            }
            if (!$util.isString(message.name))
                return "name: string expected";
            return null;
        };

        EthereumStructMember.fromObject = function fromObject(object) {
            if (object instanceof $root.EthereumTypedDataStructAck.EthereumStructMember)
                return object;
            var message = new $root.EthereumTypedDataStructAck.EthereumStructMember();
            if (object.type != null) {
                if (typeof object.type !== "object")
                    throw TypeError(".EthereumTypedDataStructAck.EthereumStructMember.type: object expected");
                message.type = $root.EthereumTypedDataStructAck.EthereumFieldType.fromObject(object.type);
            }
            if (object.name != null)
                message.name = String(object.name);
            return message;
        };

        EthereumStructMember.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.type = null;
                object.name = "";
            }
            if (message.type != null && message.hasOwnProperty("type"))
                object.type = $root.EthereumTypedDataStructAck.EthereumFieldType.toObject(message.type, options);
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            return object;
        };

        EthereumStructMember.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EthereumStructMember;
    })();

    EthereumTypedDataStructAck.EthereumFieldType = (function() {

        function EthereumFieldType(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        EthereumFieldType.prototype.data_type = 1;
        EthereumFieldType.prototype.size = 0;
        EthereumFieldType.prototype.entry_type = null;
        EthereumFieldType.prototype.struct_name = "";

        EthereumFieldType.create = function create(properties) {
            return new EthereumFieldType(properties);
        };

        EthereumFieldType.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(8).int32(message.data_type);
            if (message.size != null && Object.hasOwnProperty.call(message, "size"))
                writer.uint32(16).uint32(message.size);
            if (message.entry_type != null && Object.hasOwnProperty.call(message, "entry_type"))
                $root.EthereumTypedDataStructAck.EthereumFieldType.encode(message.entry_type, writer.uint32(26).fork()).ldelim();
            if (message.struct_name != null && Object.hasOwnProperty.call(message, "struct_name"))
                writer.uint32(34).string(message.struct_name);
            return writer;
        };

        EthereumFieldType.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        EthereumFieldType.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumTypedDataStructAck.EthereumFieldType();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.data_type = reader.int32();
                    break;
                case 2:
                    message.size = reader.uint32();
                    break;
                case 3:
                    message.entry_type = $root.EthereumTypedDataStructAck.EthereumFieldType.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.struct_name = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("data_type"))
                throw $util.ProtocolError("missing required 'data_type'", { instance: message });
            return message;
        };

        EthereumFieldType.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        EthereumFieldType.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            switch (message.data_type) {
            default:
                return "data_type: enum value expected";
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
            case 8:
                break;
            }
            if (message.size != null && message.hasOwnProperty("size"))
                if (!$util.isInteger(message.size))
                    return "size: integer expected";
            if (message.entry_type != null && message.hasOwnProperty("entry_type")) {
                var error = $root.EthereumTypedDataStructAck.EthereumFieldType.verify(message.entry_type);
                if (error)
                    return "entry_type." + error;
            }
            if (message.struct_name != null && message.hasOwnProperty("struct_name"))
                if (!$util.isString(message.struct_name))
                    return "struct_name: string expected";
            return null;
        };

        EthereumFieldType.fromObject = function fromObject(object) {
            if (object instanceof $root.EthereumTypedDataStructAck.EthereumFieldType)
                return object;
            var message = new $root.EthereumTypedDataStructAck.EthereumFieldType();
            switch (object.data_type) {
            case "UINT":
            case 1:
                message.data_type = 1;
                break;
            case "INT":
            case 2:
                message.data_type = 2;
                break;
            case "BYTES":
            case 3:
                message.data_type = 3;
                break;
            case "STRING":
            case 4:
                message.data_type = 4;
                break;
            case "BOOL":
            case 5:
                message.data_type = 5;
                break;
            case "ADDRESS":
            case 6:
                message.data_type = 6;
                break;
            case "ARRAY":
            case 7:
                message.data_type = 7;
                break;
            case "STRUCT":
            case 8:
                message.data_type = 8;
                break;
            }
            if (object.size != null)
                message.size = object.size >>> 0;
            if (object.entry_type != null) {
                if (typeof object.entry_type !== "object")
                    throw TypeError(".EthereumTypedDataStructAck.EthereumFieldType.entry_type: object expected");
                message.entry_type = $root.EthereumTypedDataStructAck.EthereumFieldType.fromObject(object.entry_type);
            }
            if (object.struct_name != null)
                message.struct_name = String(object.struct_name);
            return message;
        };

        EthereumFieldType.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.data_type = options.enums === String ? "UINT" : 1;
                object.size = 0;
                object.entry_type = null;
                object.struct_name = "";
            }
            if (message.data_type != null && message.hasOwnProperty("data_type"))
                object.data_type = options.enums === String ? $root.EthereumTypedDataStructAck.EthereumDataType[message.data_type] : message.data_type;
            if (message.size != null && message.hasOwnProperty("size"))
                object.size = message.size;
            if (message.entry_type != null && message.hasOwnProperty("entry_type"))
                object.entry_type = $root.EthereumTypedDataStructAck.EthereumFieldType.toObject(message.entry_type, options);
            if (message.struct_name != null && message.hasOwnProperty("struct_name"))
                object.struct_name = message.struct_name;
            return object;
        };

        EthereumFieldType.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EthereumFieldType;
    })();

    EthereumTypedDataStructAck.EthereumDataType = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[1] = "UINT"] = 1;
        values[valuesById[2] = "INT"] = 2;
        values[valuesById[3] = "BYTES"] = 3;
        values[valuesById[4] = "STRING"] = 4;
        values[valuesById[5] = "BOOL"] = 5;
        values[valuesById[6] = "ADDRESS"] = 6;
        values[valuesById[7] = "ARRAY"] = 7;
        values[valuesById[8] = "STRUCT"] = 8;
        return values;
    })();

    return EthereumTypedDataStructAck;
})();

$root.EthereumTypedDataValueRequest = (function() {

    function EthereumTypedDataValueRequest(properties) {
        this.member_path = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumTypedDataValueRequest.prototype.member_path = $util.emptyArray;

    EthereumTypedDataValueRequest.create = function create(properties) {
        return new EthereumTypedDataValueRequest(properties);
    };

    EthereumTypedDataValueRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.member_path != null && message.member_path.length)
            for (var i = 0; i < message.member_path.length; ++i)
                writer.uint32(8).uint32(message.member_path[i]);
        return writer;
    };

    EthereumTypedDataValueRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumTypedDataValueRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumTypedDataValueRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.member_path && message.member_path.length))
                    message.member_path = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.member_path.push(reader.uint32());
                } else
                    message.member_path.push(reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    EthereumTypedDataValueRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumTypedDataValueRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.member_path != null && message.hasOwnProperty("member_path")) {
            if (!Array.isArray(message.member_path))
                return "member_path: array expected";
            for (var i = 0; i < message.member_path.length; ++i)
                if (!$util.isInteger(message.member_path[i]))
                    return "member_path: integer[] expected";
        }
        return null;
    };

    EthereumTypedDataValueRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumTypedDataValueRequest)
            return object;
        var message = new $root.EthereumTypedDataValueRequest();
        if (object.member_path) {
            if (!Array.isArray(object.member_path))
                throw TypeError(".EthereumTypedDataValueRequest.member_path: array expected");
            message.member_path = [];
            for (var i = 0; i < object.member_path.length; ++i)
                message.member_path[i] = object.member_path[i] >>> 0;
        }
        return message;
    };

    EthereumTypedDataValueRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.member_path = [];
        if (message.member_path && message.member_path.length) {
            object.member_path = [];
            for (var j = 0; j < message.member_path.length; ++j)
                object.member_path[j] = message.member_path[j];
        }
        return object;
    };

    EthereumTypedDataValueRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumTypedDataValueRequest;
})();

$root.EthereumTypedDataValueAck = (function() {

    function EthereumTypedDataValueAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumTypedDataValueAck.prototype.value = $util.newBuffer([]);

    EthereumTypedDataValueAck.create = function create(properties) {
        return new EthereumTypedDataValueAck(properties);
    };

    EthereumTypedDataValueAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.value);
        return writer;
    };

    EthereumTypedDataValueAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumTypedDataValueAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumTypedDataValueAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.value = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("value"))
            throw $util.ProtocolError("missing required 'value'", { instance: message });
        return message;
    };

    EthereumTypedDataValueAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumTypedDataValueAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.value && typeof message.value.length === "number" || $util.isString(message.value)))
            return "value: buffer expected";
        return null;
    };

    EthereumTypedDataValueAck.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumTypedDataValueAck)
            return object;
        var message = new $root.EthereumTypedDataValueAck();
        if (object.value != null)
            if (typeof object.value === "string")
                $util.base64.decode(object.value, message.value = $util.newBuffer($util.base64.length(object.value)), 0);
            else if (object.value.length)
                message.value = object.value;
        return message;
    };

    EthereumTypedDataValueAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.value = "";
            else {
                object.value = [];
                if (options.bytes !== Array)
                    object.value = $util.newBuffer(object.value);
            }
        if (message.value != null && message.hasOwnProperty("value"))
            object.value = options.bytes === String ? $util.base64.encode(message.value, 0, message.value.length) : options.bytes === Array ? Array.prototype.slice.call(message.value) : message.value;
        return object;
    };

    EthereumTypedDataValueAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumTypedDataValueAck;
})();

$root.EthereumGetPublicKeyOneKey = (function() {

    function EthereumGetPublicKeyOneKey(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumGetPublicKeyOneKey.prototype.address_n = $util.emptyArray;
    EthereumGetPublicKeyOneKey.prototype.show_display = false;
    EthereumGetPublicKeyOneKey.prototype.chain_id = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    EthereumGetPublicKeyOneKey.create = function create(properties) {
        return new EthereumGetPublicKeyOneKey(properties);
    };

    EthereumGetPublicKeyOneKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(16).bool(message.show_display);
        if (message.chain_id != null && Object.hasOwnProperty.call(message, "chain_id"))
            writer.uint32(24).uint64(message.chain_id);
        return writer;
    };

    EthereumGetPublicKeyOneKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumGetPublicKeyOneKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumGetPublicKeyOneKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.show_display = reader.bool();
                break;
            case 3:
                message.chain_id = reader.uint64();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    EthereumGetPublicKeyOneKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumGetPublicKeyOneKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        if (message.chain_id != null && message.hasOwnProperty("chain_id"))
            if (!$util.isInteger(message.chain_id) && !(message.chain_id && $util.isInteger(message.chain_id.low) && $util.isInteger(message.chain_id.high)))
                return "chain_id: integer|Long expected";
        return null;
    };

    EthereumGetPublicKeyOneKey.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumGetPublicKeyOneKey)
            return object;
        var message = new $root.EthereumGetPublicKeyOneKey();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".EthereumGetPublicKeyOneKey.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        if (object.chain_id != null)
            if ($util.Long)
                (message.chain_id = $util.Long.fromValue(object.chain_id)).unsigned = true;
            else if (typeof object.chain_id === "string")
                message.chain_id = parseInt(object.chain_id, 10);
            else if (typeof object.chain_id === "number")
                message.chain_id = object.chain_id;
            else if (typeof object.chain_id === "object")
                message.chain_id = new $util.LongBits(object.chain_id.low >>> 0, object.chain_id.high >>> 0).toNumber(true);
        return message;
    };

    EthereumGetPublicKeyOneKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            object.show_display = false;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.chain_id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.chain_id = options.longs === String ? "0" : 0;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        if (message.chain_id != null && message.hasOwnProperty("chain_id"))
            if (typeof message.chain_id === "number")
                object.chain_id = options.longs === String ? String(message.chain_id) : message.chain_id;
            else
                object.chain_id = options.longs === String ? $util.Long.prototype.toString.call(message.chain_id) : options.longs === Number ? new $util.LongBits(message.chain_id.low >>> 0, message.chain_id.high >>> 0).toNumber(true) : message.chain_id;
        return object;
    };

    EthereumGetPublicKeyOneKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumGetPublicKeyOneKey;
})();

$root.EthereumPublicKeyOneKey = (function() {

    function EthereumPublicKeyOneKey(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumPublicKeyOneKey.prototype.node = null;
    EthereumPublicKeyOneKey.prototype.xpub = "";

    EthereumPublicKeyOneKey.create = function create(properties) {
        return new EthereumPublicKeyOneKey(properties);
    };

    EthereumPublicKeyOneKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        $root.HDNodeType.encode(message.node, writer.uint32(10).fork()).ldelim();
        writer.uint32(18).string(message.xpub);
        return writer;
    };

    EthereumPublicKeyOneKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumPublicKeyOneKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumPublicKeyOneKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.node = $root.HDNodeType.decode(reader, reader.uint32());
                break;
            case 2:
                message.xpub = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("node"))
            throw $util.ProtocolError("missing required 'node'", { instance: message });
        if (!message.hasOwnProperty("xpub"))
            throw $util.ProtocolError("missing required 'xpub'", { instance: message });
        return message;
    };

    EthereumPublicKeyOneKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumPublicKeyOneKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        {
            var error = $root.HDNodeType.verify(message.node);
            if (error)
                return "node." + error;
        }
        if (!$util.isString(message.xpub))
            return "xpub: string expected";
        return null;
    };

    EthereumPublicKeyOneKey.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumPublicKeyOneKey)
            return object;
        var message = new $root.EthereumPublicKeyOneKey();
        if (object.node != null) {
            if (typeof object.node !== "object")
                throw TypeError(".EthereumPublicKeyOneKey.node: object expected");
            message.node = $root.HDNodeType.fromObject(object.node);
        }
        if (object.xpub != null)
            message.xpub = String(object.xpub);
        return message;
    };

    EthereumPublicKeyOneKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.node = null;
            object.xpub = "";
        }
        if (message.node != null && message.hasOwnProperty("node"))
            object.node = $root.HDNodeType.toObject(message.node, options);
        if (message.xpub != null && message.hasOwnProperty("xpub"))
            object.xpub = message.xpub;
        return object;
    };

    EthereumPublicKeyOneKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumPublicKeyOneKey;
})();

$root.EthereumGetAddressOneKey = (function() {

    function EthereumGetAddressOneKey(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumGetAddressOneKey.prototype.address_n = $util.emptyArray;
    EthereumGetAddressOneKey.prototype.show_display = false;
    EthereumGetAddressOneKey.prototype.chain_id = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    EthereumGetAddressOneKey.create = function create(properties) {
        return new EthereumGetAddressOneKey(properties);
    };

    EthereumGetAddressOneKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(16).bool(message.show_display);
        if (message.chain_id != null && Object.hasOwnProperty.call(message, "chain_id"))
            writer.uint32(24).uint64(message.chain_id);
        return writer;
    };

    EthereumGetAddressOneKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumGetAddressOneKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumGetAddressOneKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.show_display = reader.bool();
                break;
            case 3:
                message.chain_id = reader.uint64();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    EthereumGetAddressOneKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumGetAddressOneKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        if (message.chain_id != null && message.hasOwnProperty("chain_id"))
            if (!$util.isInteger(message.chain_id) && !(message.chain_id && $util.isInteger(message.chain_id.low) && $util.isInteger(message.chain_id.high)))
                return "chain_id: integer|Long expected";
        return null;
    };

    EthereumGetAddressOneKey.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumGetAddressOneKey)
            return object;
        var message = new $root.EthereumGetAddressOneKey();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".EthereumGetAddressOneKey.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        if (object.chain_id != null)
            if ($util.Long)
                (message.chain_id = $util.Long.fromValue(object.chain_id)).unsigned = true;
            else if (typeof object.chain_id === "string")
                message.chain_id = parseInt(object.chain_id, 10);
            else if (typeof object.chain_id === "number")
                message.chain_id = object.chain_id;
            else if (typeof object.chain_id === "object")
                message.chain_id = new $util.LongBits(object.chain_id.low >>> 0, object.chain_id.high >>> 0).toNumber(true);
        return message;
    };

    EthereumGetAddressOneKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            object.show_display = false;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.chain_id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.chain_id = options.longs === String ? "0" : 0;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        if (message.chain_id != null && message.hasOwnProperty("chain_id"))
            if (typeof message.chain_id === "number")
                object.chain_id = options.longs === String ? String(message.chain_id) : message.chain_id;
            else
                object.chain_id = options.longs === String ? $util.Long.prototype.toString.call(message.chain_id) : options.longs === Number ? new $util.LongBits(message.chain_id.low >>> 0, message.chain_id.high >>> 0).toNumber(true) : message.chain_id;
        return object;
    };

    EthereumGetAddressOneKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumGetAddressOneKey;
})();

$root.EthereumAddressOneKey = (function() {

    function EthereumAddressOneKey(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumAddressOneKey.prototype._old_address = $util.newBuffer([]);
    EthereumAddressOneKey.prototype.address = "";

    EthereumAddressOneKey.create = function create(properties) {
        return new EthereumAddressOneKey(properties);
    };

    EthereumAddressOneKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message._old_address != null && Object.hasOwnProperty.call(message, "_old_address"))
            writer.uint32(10).bytes(message._old_address);
        if (message.address != null && Object.hasOwnProperty.call(message, "address"))
            writer.uint32(18).string(message.address);
        return writer;
    };

    EthereumAddressOneKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumAddressOneKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumAddressOneKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message._old_address = reader.bytes();
                break;
            case 2:
                message.address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    EthereumAddressOneKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumAddressOneKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message._old_address != null && message.hasOwnProperty("_old_address"))
            if (!(message._old_address && typeof message._old_address.length === "number" || $util.isString(message._old_address)))
                return "_old_address: buffer expected";
        if (message.address != null && message.hasOwnProperty("address"))
            if (!$util.isString(message.address))
                return "address: string expected";
        return null;
    };

    EthereumAddressOneKey.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumAddressOneKey)
            return object;
        var message = new $root.EthereumAddressOneKey();
        if (object._old_address != null)
            if (typeof object._old_address === "string")
                $util.base64.decode(object._old_address, message._old_address = $util.newBuffer($util.base64.length(object._old_address)), 0);
            else if (object._old_address.length)
                message._old_address = object._old_address;
        if (object.address != null)
            message.address = String(object.address);
        return message;
    };

    EthereumAddressOneKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object._old_address = "";
            else {
                object._old_address = [];
                if (options.bytes !== Array)
                    object._old_address = $util.newBuffer(object._old_address);
            }
            object.address = "";
        }
        if (message._old_address != null && message.hasOwnProperty("_old_address"))
            object._old_address = options.bytes === String ? $util.base64.encode(message._old_address, 0, message._old_address.length) : options.bytes === Array ? Array.prototype.slice.call(message._old_address) : message._old_address;
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    EthereumAddressOneKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumAddressOneKey;
})();

$root.EthereumSignTxOneKey = (function() {

    function EthereumSignTxOneKey(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumSignTxOneKey.prototype.address_n = $util.emptyArray;
    EthereumSignTxOneKey.prototype.nonce = $util.newBuffer([]);
    EthereumSignTxOneKey.prototype.gas_price = $util.newBuffer([]);
    EthereumSignTxOneKey.prototype.gas_limit = $util.newBuffer([]);
    EthereumSignTxOneKey.prototype.to = "";
    EthereumSignTxOneKey.prototype.value = $util.newBuffer([]);
    EthereumSignTxOneKey.prototype.data_initial_chunk = $util.newBuffer([]);
    EthereumSignTxOneKey.prototype.data_length = 0;
    EthereumSignTxOneKey.prototype.chain_id = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    EthereumSignTxOneKey.prototype.tx_type = 0;
    EthereumSignTxOneKey.prototype.expected_address = $util.newBuffer([]);

    EthereumSignTxOneKey.create = function create(properties) {
        return new EthereumSignTxOneKey(properties);
    };

    EthereumSignTxOneKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.nonce != null && Object.hasOwnProperty.call(message, "nonce"))
            writer.uint32(18).bytes(message.nonce);
        writer.uint32(26).bytes(message.gas_price);
        writer.uint32(34).bytes(message.gas_limit);
        if (message.value != null && Object.hasOwnProperty.call(message, "value"))
            writer.uint32(50).bytes(message.value);
        if (message.data_initial_chunk != null && Object.hasOwnProperty.call(message, "data_initial_chunk"))
            writer.uint32(58).bytes(message.data_initial_chunk);
        if (message.data_length != null && Object.hasOwnProperty.call(message, "data_length"))
            writer.uint32(64).uint32(message.data_length);
        writer.uint32(72).uint64(message.chain_id);
        if (message.tx_type != null && Object.hasOwnProperty.call(message, "tx_type"))
            writer.uint32(80).uint32(message.tx_type);
        if (message.to != null && Object.hasOwnProperty.call(message, "to"))
            writer.uint32(90).string(message.to);
        if (message.expected_address != null && Object.hasOwnProperty.call(message, "expected_address"))
            writer.uint32(98).bytes(message.expected_address);
        return writer;
    };

    EthereumSignTxOneKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumSignTxOneKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumSignTxOneKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.nonce = reader.bytes();
                break;
            case 3:
                message.gas_price = reader.bytes();
                break;
            case 4:
                message.gas_limit = reader.bytes();
                break;
            case 11:
                message.to = reader.string();
                break;
            case 6:
                message.value = reader.bytes();
                break;
            case 7:
                message.data_initial_chunk = reader.bytes();
                break;
            case 8:
                message.data_length = reader.uint32();
                break;
            case 9:
                message.chain_id = reader.uint64();
                break;
            case 10:
                message.tx_type = reader.uint32();
                break;
            case 12:
                message.expected_address = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("gas_price"))
            throw $util.ProtocolError("missing required 'gas_price'", { instance: message });
        if (!message.hasOwnProperty("gas_limit"))
            throw $util.ProtocolError("missing required 'gas_limit'", { instance: message });
        if (!message.hasOwnProperty("chain_id"))
            throw $util.ProtocolError("missing required 'chain_id'", { instance: message });
        return message;
    };

    EthereumSignTxOneKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumSignTxOneKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.nonce != null && message.hasOwnProperty("nonce"))
            if (!(message.nonce && typeof message.nonce.length === "number" || $util.isString(message.nonce)))
                return "nonce: buffer expected";
        if (!(message.gas_price && typeof message.gas_price.length === "number" || $util.isString(message.gas_price)))
            return "gas_price: buffer expected";
        if (!(message.gas_limit && typeof message.gas_limit.length === "number" || $util.isString(message.gas_limit)))
            return "gas_limit: buffer expected";
        if (message.to != null && message.hasOwnProperty("to"))
            if (!$util.isString(message.to))
                return "to: string expected";
        if (message.value != null && message.hasOwnProperty("value"))
            if (!(message.value && typeof message.value.length === "number" || $util.isString(message.value)))
                return "value: buffer expected";
        if (message.data_initial_chunk != null && message.hasOwnProperty("data_initial_chunk"))
            if (!(message.data_initial_chunk && typeof message.data_initial_chunk.length === "number" || $util.isString(message.data_initial_chunk)))
                return "data_initial_chunk: buffer expected";
        if (message.data_length != null && message.hasOwnProperty("data_length"))
            if (!$util.isInteger(message.data_length))
                return "data_length: integer expected";
        if (!$util.isInteger(message.chain_id) && !(message.chain_id && $util.isInteger(message.chain_id.low) && $util.isInteger(message.chain_id.high)))
            return "chain_id: integer|Long expected";
        if (message.tx_type != null && message.hasOwnProperty("tx_type"))
            if (!$util.isInteger(message.tx_type))
                return "tx_type: integer expected";
        if (message.expected_address != null && message.hasOwnProperty("expected_address"))
            if (!(message.expected_address && typeof message.expected_address.length === "number" || $util.isString(message.expected_address)))
                return "expected_address: buffer expected";
        return null;
    };

    EthereumSignTxOneKey.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumSignTxOneKey)
            return object;
        var message = new $root.EthereumSignTxOneKey();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".EthereumSignTxOneKey.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.nonce != null)
            if (typeof object.nonce === "string")
                $util.base64.decode(object.nonce, message.nonce = $util.newBuffer($util.base64.length(object.nonce)), 0);
            else if (object.nonce.length)
                message.nonce = object.nonce;
        if (object.gas_price != null)
            if (typeof object.gas_price === "string")
                $util.base64.decode(object.gas_price, message.gas_price = $util.newBuffer($util.base64.length(object.gas_price)), 0);
            else if (object.gas_price.length)
                message.gas_price = object.gas_price;
        if (object.gas_limit != null)
            if (typeof object.gas_limit === "string")
                $util.base64.decode(object.gas_limit, message.gas_limit = $util.newBuffer($util.base64.length(object.gas_limit)), 0);
            else if (object.gas_limit.length)
                message.gas_limit = object.gas_limit;
        if (object.to != null)
            message.to = String(object.to);
        if (object.value != null)
            if (typeof object.value === "string")
                $util.base64.decode(object.value, message.value = $util.newBuffer($util.base64.length(object.value)), 0);
            else if (object.value.length)
                message.value = object.value;
        if (object.data_initial_chunk != null)
            if (typeof object.data_initial_chunk === "string")
                $util.base64.decode(object.data_initial_chunk, message.data_initial_chunk = $util.newBuffer($util.base64.length(object.data_initial_chunk)), 0);
            else if (object.data_initial_chunk.length)
                message.data_initial_chunk = object.data_initial_chunk;
        if (object.data_length != null)
            message.data_length = object.data_length >>> 0;
        if (object.chain_id != null)
            if ($util.Long)
                (message.chain_id = $util.Long.fromValue(object.chain_id)).unsigned = true;
            else if (typeof object.chain_id === "string")
                message.chain_id = parseInt(object.chain_id, 10);
            else if (typeof object.chain_id === "number")
                message.chain_id = object.chain_id;
            else if (typeof object.chain_id === "object")
                message.chain_id = new $util.LongBits(object.chain_id.low >>> 0, object.chain_id.high >>> 0).toNumber(true);
        if (object.tx_type != null)
            message.tx_type = object.tx_type >>> 0;
        if (object.expected_address != null)
            if (typeof object.expected_address === "string")
                $util.base64.decode(object.expected_address, message.expected_address = $util.newBuffer($util.base64.length(object.expected_address)), 0);
            else if (object.expected_address.length)
                message.expected_address = object.expected_address;
        return message;
    };

    EthereumSignTxOneKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            if (options.bytes === String)
                object.nonce = "";
            else {
                object.nonce = [];
                if (options.bytes !== Array)
                    object.nonce = $util.newBuffer(object.nonce);
            }
            if (options.bytes === String)
                object.gas_price = "";
            else {
                object.gas_price = [];
                if (options.bytes !== Array)
                    object.gas_price = $util.newBuffer(object.gas_price);
            }
            if (options.bytes === String)
                object.gas_limit = "";
            else {
                object.gas_limit = [];
                if (options.bytes !== Array)
                    object.gas_limit = $util.newBuffer(object.gas_limit);
            }
            if (options.bytes === String)
                object.value = "";
            else {
                object.value = [];
                if (options.bytes !== Array)
                    object.value = $util.newBuffer(object.value);
            }
            if (options.bytes === String)
                object.data_initial_chunk = "";
            else {
                object.data_initial_chunk = [];
                if (options.bytes !== Array)
                    object.data_initial_chunk = $util.newBuffer(object.data_initial_chunk);
            }
            object.data_length = 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.chain_id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.chain_id = options.longs === String ? "0" : 0;
            object.tx_type = 0;
            object.to = "";
            if (options.bytes === String)
                object.expected_address = "";
            else {
                object.expected_address = [];
                if (options.bytes !== Array)
                    object.expected_address = $util.newBuffer(object.expected_address);
            }
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.nonce != null && message.hasOwnProperty("nonce"))
            object.nonce = options.bytes === String ? $util.base64.encode(message.nonce, 0, message.nonce.length) : options.bytes === Array ? Array.prototype.slice.call(message.nonce) : message.nonce;
        if (message.gas_price != null && message.hasOwnProperty("gas_price"))
            object.gas_price = options.bytes === String ? $util.base64.encode(message.gas_price, 0, message.gas_price.length) : options.bytes === Array ? Array.prototype.slice.call(message.gas_price) : message.gas_price;
        if (message.gas_limit != null && message.hasOwnProperty("gas_limit"))
            object.gas_limit = options.bytes === String ? $util.base64.encode(message.gas_limit, 0, message.gas_limit.length) : options.bytes === Array ? Array.prototype.slice.call(message.gas_limit) : message.gas_limit;
        if (message.value != null && message.hasOwnProperty("value"))
            object.value = options.bytes === String ? $util.base64.encode(message.value, 0, message.value.length) : options.bytes === Array ? Array.prototype.slice.call(message.value) : message.value;
        if (message.data_initial_chunk != null && message.hasOwnProperty("data_initial_chunk"))
            object.data_initial_chunk = options.bytes === String ? $util.base64.encode(message.data_initial_chunk, 0, message.data_initial_chunk.length) : options.bytes === Array ? Array.prototype.slice.call(message.data_initial_chunk) : message.data_initial_chunk;
        if (message.data_length != null && message.hasOwnProperty("data_length"))
            object.data_length = message.data_length;
        if (message.chain_id != null && message.hasOwnProperty("chain_id"))
            if (typeof message.chain_id === "number")
                object.chain_id = options.longs === String ? String(message.chain_id) : message.chain_id;
            else
                object.chain_id = options.longs === String ? $util.Long.prototype.toString.call(message.chain_id) : options.longs === Number ? new $util.LongBits(message.chain_id.low >>> 0, message.chain_id.high >>> 0).toNumber(true) : message.chain_id;
        if (message.tx_type != null && message.hasOwnProperty("tx_type"))
            object.tx_type = message.tx_type;
        if (message.to != null && message.hasOwnProperty("to"))
            object.to = message.to;
        if (message.expected_address != null && message.hasOwnProperty("expected_address"))
            object.expected_address = options.bytes === String ? $util.base64.encode(message.expected_address, 0, message.expected_address.length) : options.bytes === Array ? Array.prototype.slice.call(message.expected_address) : message.expected_address;
        return object;
    };

    EthereumSignTxOneKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumSignTxOneKey;
})();

$root.EthereumAccessListOneKey = (function() {

    function EthereumAccessListOneKey(properties) {
        this.storage_keys = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumAccessListOneKey.prototype.address = "";
    EthereumAccessListOneKey.prototype.storage_keys = $util.emptyArray;

    EthereumAccessListOneKey.create = function create(properties) {
        return new EthereumAccessListOneKey(properties);
    };

    EthereumAccessListOneKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.address);
        if (message.storage_keys != null && message.storage_keys.length)
            for (var i = 0; i < message.storage_keys.length; ++i)
                writer.uint32(18).bytes(message.storage_keys[i]);
        return writer;
    };

    EthereumAccessListOneKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumAccessListOneKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumAccessListOneKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.string();
                break;
            case 2:
                if (!(message.storage_keys && message.storage_keys.length))
                    message.storage_keys = [];
                message.storage_keys.push(reader.bytes());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("address"))
            throw $util.ProtocolError("missing required 'address'", { instance: message });
        return message;
    };

    EthereumAccessListOneKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumAccessListOneKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.address))
            return "address: string expected";
        if (message.storage_keys != null && message.hasOwnProperty("storage_keys")) {
            if (!Array.isArray(message.storage_keys))
                return "storage_keys: array expected";
            for (var i = 0; i < message.storage_keys.length; ++i)
                if (!(message.storage_keys[i] && typeof message.storage_keys[i].length === "number" || $util.isString(message.storage_keys[i])))
                    return "storage_keys: buffer[] expected";
        }
        return null;
    };

    EthereumAccessListOneKey.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumAccessListOneKey)
            return object;
        var message = new $root.EthereumAccessListOneKey();
        if (object.address != null)
            message.address = String(object.address);
        if (object.storage_keys) {
            if (!Array.isArray(object.storage_keys))
                throw TypeError(".EthereumAccessListOneKey.storage_keys: array expected");
            message.storage_keys = [];
            for (var i = 0; i < object.storage_keys.length; ++i)
                if (typeof object.storage_keys[i] === "string")
                    $util.base64.decode(object.storage_keys[i], message.storage_keys[i] = $util.newBuffer($util.base64.length(object.storage_keys[i])), 0);
                else if (object.storage_keys[i].length)
                    message.storage_keys[i] = object.storage_keys[i];
        }
        return message;
    };

    EthereumAccessListOneKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.storage_keys = [];
        if (options.defaults)
            object.address = "";
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        if (message.storage_keys && message.storage_keys.length) {
            object.storage_keys = [];
            for (var j = 0; j < message.storage_keys.length; ++j)
                object.storage_keys[j] = options.bytes === String ? $util.base64.encode(message.storage_keys[j], 0, message.storage_keys[j].length) : options.bytes === Array ? Array.prototype.slice.call(message.storage_keys[j]) : message.storage_keys[j];
        }
        return object;
    };

    EthereumAccessListOneKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumAccessListOneKey;
})();

$root.EthereumSignTxEIP1559OneKey = (function() {

    function EthereumSignTxEIP1559OneKey(properties) {
        this.address_n = [];
        this.access_list = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumSignTxEIP1559OneKey.prototype.address_n = $util.emptyArray;
    EthereumSignTxEIP1559OneKey.prototype.nonce = $util.newBuffer([]);
    EthereumSignTxEIP1559OneKey.prototype.max_gas_fee = $util.newBuffer([]);
    EthereumSignTxEIP1559OneKey.prototype.max_priority_fee = $util.newBuffer([]);
    EthereumSignTxEIP1559OneKey.prototype.gas_limit = $util.newBuffer([]);
    EthereumSignTxEIP1559OneKey.prototype.to = "";
    EthereumSignTxEIP1559OneKey.prototype.value = $util.newBuffer([]);
    EthereumSignTxEIP1559OneKey.prototype.data_initial_chunk = $util.newBuffer([]);
    EthereumSignTxEIP1559OneKey.prototype.data_length = 0;
    EthereumSignTxEIP1559OneKey.prototype.chain_id = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    EthereumSignTxEIP1559OneKey.prototype.access_list = $util.emptyArray;
    EthereumSignTxEIP1559OneKey.prototype.expected_address = $util.newBuffer([]);

    EthereumSignTxEIP1559OneKey.create = function create(properties) {
        return new EthereumSignTxEIP1559OneKey(properties);
    };

    EthereumSignTxEIP1559OneKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).bytes(message.nonce);
        writer.uint32(26).bytes(message.max_gas_fee);
        writer.uint32(34).bytes(message.max_priority_fee);
        writer.uint32(42).bytes(message.gas_limit);
        if (message.to != null && Object.hasOwnProperty.call(message, "to"))
            writer.uint32(50).string(message.to);
        writer.uint32(58).bytes(message.value);
        if (message.data_initial_chunk != null && Object.hasOwnProperty.call(message, "data_initial_chunk"))
            writer.uint32(66).bytes(message.data_initial_chunk);
        writer.uint32(72).uint32(message.data_length);
        writer.uint32(80).uint64(message.chain_id);
        if (message.access_list != null && message.access_list.length)
            for (var i = 0; i < message.access_list.length; ++i)
                $root.EthereumAccessListOneKey.encode(message.access_list[i], writer.uint32(90).fork()).ldelim();
        if (message.expected_address != null && Object.hasOwnProperty.call(message, "expected_address"))
            writer.uint32(98).bytes(message.expected_address);
        return writer;
    };

    EthereumSignTxEIP1559OneKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumSignTxEIP1559OneKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumSignTxEIP1559OneKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.nonce = reader.bytes();
                break;
            case 3:
                message.max_gas_fee = reader.bytes();
                break;
            case 4:
                message.max_priority_fee = reader.bytes();
                break;
            case 5:
                message.gas_limit = reader.bytes();
                break;
            case 6:
                message.to = reader.string();
                break;
            case 7:
                message.value = reader.bytes();
                break;
            case 8:
                message.data_initial_chunk = reader.bytes();
                break;
            case 9:
                message.data_length = reader.uint32();
                break;
            case 10:
                message.chain_id = reader.uint64();
                break;
            case 11:
                if (!(message.access_list && message.access_list.length))
                    message.access_list = [];
                message.access_list.push($root.EthereumAccessListOneKey.decode(reader, reader.uint32()));
                break;
            case 12:
                message.expected_address = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("nonce"))
            throw $util.ProtocolError("missing required 'nonce'", { instance: message });
        if (!message.hasOwnProperty("max_gas_fee"))
            throw $util.ProtocolError("missing required 'max_gas_fee'", { instance: message });
        if (!message.hasOwnProperty("max_priority_fee"))
            throw $util.ProtocolError("missing required 'max_priority_fee'", { instance: message });
        if (!message.hasOwnProperty("gas_limit"))
            throw $util.ProtocolError("missing required 'gas_limit'", { instance: message });
        if (!message.hasOwnProperty("value"))
            throw $util.ProtocolError("missing required 'value'", { instance: message });
        if (!message.hasOwnProperty("data_length"))
            throw $util.ProtocolError("missing required 'data_length'", { instance: message });
        if (!message.hasOwnProperty("chain_id"))
            throw $util.ProtocolError("missing required 'chain_id'", { instance: message });
        return message;
    };

    EthereumSignTxEIP1559OneKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumSignTxEIP1559OneKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!(message.nonce && typeof message.nonce.length === "number" || $util.isString(message.nonce)))
            return "nonce: buffer expected";
        if (!(message.max_gas_fee && typeof message.max_gas_fee.length === "number" || $util.isString(message.max_gas_fee)))
            return "max_gas_fee: buffer expected";
        if (!(message.max_priority_fee && typeof message.max_priority_fee.length === "number" || $util.isString(message.max_priority_fee)))
            return "max_priority_fee: buffer expected";
        if (!(message.gas_limit && typeof message.gas_limit.length === "number" || $util.isString(message.gas_limit)))
            return "gas_limit: buffer expected";
        if (message.to != null && message.hasOwnProperty("to"))
            if (!$util.isString(message.to))
                return "to: string expected";
        if (!(message.value && typeof message.value.length === "number" || $util.isString(message.value)))
            return "value: buffer expected";
        if (message.data_initial_chunk != null && message.hasOwnProperty("data_initial_chunk"))
            if (!(message.data_initial_chunk && typeof message.data_initial_chunk.length === "number" || $util.isString(message.data_initial_chunk)))
                return "data_initial_chunk: buffer expected";
        if (!$util.isInteger(message.data_length))
            return "data_length: integer expected";
        if (!$util.isInteger(message.chain_id) && !(message.chain_id && $util.isInteger(message.chain_id.low) && $util.isInteger(message.chain_id.high)))
            return "chain_id: integer|Long expected";
        if (message.access_list != null && message.hasOwnProperty("access_list")) {
            if (!Array.isArray(message.access_list))
                return "access_list: array expected";
            for (var i = 0; i < message.access_list.length; ++i) {
                var error = $root.EthereumAccessListOneKey.verify(message.access_list[i]);
                if (error)
                    return "access_list." + error;
            }
        }
        if (message.expected_address != null && message.hasOwnProperty("expected_address"))
            if (!(message.expected_address && typeof message.expected_address.length === "number" || $util.isString(message.expected_address)))
                return "expected_address: buffer expected";
        return null;
    };

    EthereumSignTxEIP1559OneKey.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumSignTxEIP1559OneKey)
            return object;
        var message = new $root.EthereumSignTxEIP1559OneKey();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".EthereumSignTxEIP1559OneKey.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.nonce != null)
            if (typeof object.nonce === "string")
                $util.base64.decode(object.nonce, message.nonce = $util.newBuffer($util.base64.length(object.nonce)), 0);
            else if (object.nonce.length)
                message.nonce = object.nonce;
        if (object.max_gas_fee != null)
            if (typeof object.max_gas_fee === "string")
                $util.base64.decode(object.max_gas_fee, message.max_gas_fee = $util.newBuffer($util.base64.length(object.max_gas_fee)), 0);
            else if (object.max_gas_fee.length)
                message.max_gas_fee = object.max_gas_fee;
        if (object.max_priority_fee != null)
            if (typeof object.max_priority_fee === "string")
                $util.base64.decode(object.max_priority_fee, message.max_priority_fee = $util.newBuffer($util.base64.length(object.max_priority_fee)), 0);
            else if (object.max_priority_fee.length)
                message.max_priority_fee = object.max_priority_fee;
        if (object.gas_limit != null)
            if (typeof object.gas_limit === "string")
                $util.base64.decode(object.gas_limit, message.gas_limit = $util.newBuffer($util.base64.length(object.gas_limit)), 0);
            else if (object.gas_limit.length)
                message.gas_limit = object.gas_limit;
        if (object.to != null)
            message.to = String(object.to);
        if (object.value != null)
            if (typeof object.value === "string")
                $util.base64.decode(object.value, message.value = $util.newBuffer($util.base64.length(object.value)), 0);
            else if (object.value.length)
                message.value = object.value;
        if (object.data_initial_chunk != null)
            if (typeof object.data_initial_chunk === "string")
                $util.base64.decode(object.data_initial_chunk, message.data_initial_chunk = $util.newBuffer($util.base64.length(object.data_initial_chunk)), 0);
            else if (object.data_initial_chunk.length)
                message.data_initial_chunk = object.data_initial_chunk;
        if (object.data_length != null)
            message.data_length = object.data_length >>> 0;
        if (object.chain_id != null)
            if ($util.Long)
                (message.chain_id = $util.Long.fromValue(object.chain_id)).unsigned = true;
            else if (typeof object.chain_id === "string")
                message.chain_id = parseInt(object.chain_id, 10);
            else if (typeof object.chain_id === "number")
                message.chain_id = object.chain_id;
            else if (typeof object.chain_id === "object")
                message.chain_id = new $util.LongBits(object.chain_id.low >>> 0, object.chain_id.high >>> 0).toNumber(true);
        if (object.access_list) {
            if (!Array.isArray(object.access_list))
                throw TypeError(".EthereumSignTxEIP1559OneKey.access_list: array expected");
            message.access_list = [];
            for (var i = 0; i < object.access_list.length; ++i) {
                if (typeof object.access_list[i] !== "object")
                    throw TypeError(".EthereumSignTxEIP1559OneKey.access_list: object expected");
                message.access_list[i] = $root.EthereumAccessListOneKey.fromObject(object.access_list[i]);
            }
        }
        if (object.expected_address != null)
            if (typeof object.expected_address === "string")
                $util.base64.decode(object.expected_address, message.expected_address = $util.newBuffer($util.base64.length(object.expected_address)), 0);
            else if (object.expected_address.length)
                message.expected_address = object.expected_address;
        return message;
    };

    EthereumSignTxEIP1559OneKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults) {
            object.address_n = [];
            object.access_list = [];
        }
        if (options.defaults) {
            if (options.bytes === String)
                object.nonce = "";
            else {
                object.nonce = [];
                if (options.bytes !== Array)
                    object.nonce = $util.newBuffer(object.nonce);
            }
            if (options.bytes === String)
                object.max_gas_fee = "";
            else {
                object.max_gas_fee = [];
                if (options.bytes !== Array)
                    object.max_gas_fee = $util.newBuffer(object.max_gas_fee);
            }
            if (options.bytes === String)
                object.max_priority_fee = "";
            else {
                object.max_priority_fee = [];
                if (options.bytes !== Array)
                    object.max_priority_fee = $util.newBuffer(object.max_priority_fee);
            }
            if (options.bytes === String)
                object.gas_limit = "";
            else {
                object.gas_limit = [];
                if (options.bytes !== Array)
                    object.gas_limit = $util.newBuffer(object.gas_limit);
            }
            object.to = "";
            if (options.bytes === String)
                object.value = "";
            else {
                object.value = [];
                if (options.bytes !== Array)
                    object.value = $util.newBuffer(object.value);
            }
            if (options.bytes === String)
                object.data_initial_chunk = "";
            else {
                object.data_initial_chunk = [];
                if (options.bytes !== Array)
                    object.data_initial_chunk = $util.newBuffer(object.data_initial_chunk);
            }
            object.data_length = 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.chain_id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.chain_id = options.longs === String ? "0" : 0;
            if (options.bytes === String)
                object.expected_address = "";
            else {
                object.expected_address = [];
                if (options.bytes !== Array)
                    object.expected_address = $util.newBuffer(object.expected_address);
            }
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.nonce != null && message.hasOwnProperty("nonce"))
            object.nonce = options.bytes === String ? $util.base64.encode(message.nonce, 0, message.nonce.length) : options.bytes === Array ? Array.prototype.slice.call(message.nonce) : message.nonce;
        if (message.max_gas_fee != null && message.hasOwnProperty("max_gas_fee"))
            object.max_gas_fee = options.bytes === String ? $util.base64.encode(message.max_gas_fee, 0, message.max_gas_fee.length) : options.bytes === Array ? Array.prototype.slice.call(message.max_gas_fee) : message.max_gas_fee;
        if (message.max_priority_fee != null && message.hasOwnProperty("max_priority_fee"))
            object.max_priority_fee = options.bytes === String ? $util.base64.encode(message.max_priority_fee, 0, message.max_priority_fee.length) : options.bytes === Array ? Array.prototype.slice.call(message.max_priority_fee) : message.max_priority_fee;
        if (message.gas_limit != null && message.hasOwnProperty("gas_limit"))
            object.gas_limit = options.bytes === String ? $util.base64.encode(message.gas_limit, 0, message.gas_limit.length) : options.bytes === Array ? Array.prototype.slice.call(message.gas_limit) : message.gas_limit;
        if (message.to != null && message.hasOwnProperty("to"))
            object.to = message.to;
        if (message.value != null && message.hasOwnProperty("value"))
            object.value = options.bytes === String ? $util.base64.encode(message.value, 0, message.value.length) : options.bytes === Array ? Array.prototype.slice.call(message.value) : message.value;
        if (message.data_initial_chunk != null && message.hasOwnProperty("data_initial_chunk"))
            object.data_initial_chunk = options.bytes === String ? $util.base64.encode(message.data_initial_chunk, 0, message.data_initial_chunk.length) : options.bytes === Array ? Array.prototype.slice.call(message.data_initial_chunk) : message.data_initial_chunk;
        if (message.data_length != null && message.hasOwnProperty("data_length"))
            object.data_length = message.data_length;
        if (message.chain_id != null && message.hasOwnProperty("chain_id"))
            if (typeof message.chain_id === "number")
                object.chain_id = options.longs === String ? String(message.chain_id) : message.chain_id;
            else
                object.chain_id = options.longs === String ? $util.Long.prototype.toString.call(message.chain_id) : options.longs === Number ? new $util.LongBits(message.chain_id.low >>> 0, message.chain_id.high >>> 0).toNumber(true) : message.chain_id;
        if (message.access_list && message.access_list.length) {
            object.access_list = [];
            for (var j = 0; j < message.access_list.length; ++j)
                object.access_list[j] = $root.EthereumAccessListOneKey.toObject(message.access_list[j], options);
        }
        if (message.expected_address != null && message.hasOwnProperty("expected_address"))
            object.expected_address = options.bytes === String ? $util.base64.encode(message.expected_address, 0, message.expected_address.length) : options.bytes === Array ? Array.prototype.slice.call(message.expected_address) : message.expected_address;
        return object;
    };

    EthereumSignTxEIP1559OneKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumSignTxEIP1559OneKey;
})();

$root.EthereumAuthorizationSignature = (function() {

    function EthereumAuthorizationSignature(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumAuthorizationSignature.prototype.y_parity = 0;
    EthereumAuthorizationSignature.prototype.r = $util.newBuffer([]);
    EthereumAuthorizationSignature.prototype.s = $util.newBuffer([]);

    EthereumAuthorizationSignature.create = function create(properties) {
        return new EthereumAuthorizationSignature(properties);
    };

    EthereumAuthorizationSignature.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).uint32(message.y_parity);
        writer.uint32(18).bytes(message.r);
        writer.uint32(26).bytes(message.s);
        return writer;
    };

    EthereumAuthorizationSignature.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumAuthorizationSignature.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumAuthorizationSignature();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.y_parity = reader.uint32();
                break;
            case 2:
                message.r = reader.bytes();
                break;
            case 3:
                message.s = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("y_parity"))
            throw $util.ProtocolError("missing required 'y_parity'", { instance: message });
        if (!message.hasOwnProperty("r"))
            throw $util.ProtocolError("missing required 'r'", { instance: message });
        if (!message.hasOwnProperty("s"))
            throw $util.ProtocolError("missing required 's'", { instance: message });
        return message;
    };

    EthereumAuthorizationSignature.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumAuthorizationSignature.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isInteger(message.y_parity))
            return "y_parity: integer expected";
        if (!(message.r && typeof message.r.length === "number" || $util.isString(message.r)))
            return "r: buffer expected";
        if (!(message.s && typeof message.s.length === "number" || $util.isString(message.s)))
            return "s: buffer expected";
        return null;
    };

    EthereumAuthorizationSignature.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumAuthorizationSignature)
            return object;
        var message = new $root.EthereumAuthorizationSignature();
        if (object.y_parity != null)
            message.y_parity = object.y_parity >>> 0;
        if (object.r != null)
            if (typeof object.r === "string")
                $util.base64.decode(object.r, message.r = $util.newBuffer($util.base64.length(object.r)), 0);
            else if (object.r.length)
                message.r = object.r;
        if (object.s != null)
            if (typeof object.s === "string")
                $util.base64.decode(object.s, message.s = $util.newBuffer($util.base64.length(object.s)), 0);
            else if (object.s.length)
                message.s = object.s;
        return message;
    };

    EthereumAuthorizationSignature.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.y_parity = 0;
            if (options.bytes === String)
                object.r = "";
            else {
                object.r = [];
                if (options.bytes !== Array)
                    object.r = $util.newBuffer(object.r);
            }
            if (options.bytes === String)
                object.s = "";
            else {
                object.s = [];
                if (options.bytes !== Array)
                    object.s = $util.newBuffer(object.s);
            }
        }
        if (message.y_parity != null && message.hasOwnProperty("y_parity"))
            object.y_parity = message.y_parity;
        if (message.r != null && message.hasOwnProperty("r"))
            object.r = options.bytes === String ? $util.base64.encode(message.r, 0, message.r.length) : options.bytes === Array ? Array.prototype.slice.call(message.r) : message.r;
        if (message.s != null && message.hasOwnProperty("s"))
            object.s = options.bytes === String ? $util.base64.encode(message.s, 0, message.s.length) : options.bytes === Array ? Array.prototype.slice.call(message.s) : message.s;
        return object;
    };

    EthereumAuthorizationSignature.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumAuthorizationSignature;
})();

$root.EthereumSignTxEIP7702OneKey = (function() {

    function EthereumSignTxEIP7702OneKey(properties) {
        this.address_n = [];
        this.access_list = [];
        this.authorization_list = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumSignTxEIP7702OneKey.prototype.address_n = $util.emptyArray;
    EthereumSignTxEIP7702OneKey.prototype.nonce = $util.newBuffer([]);
    EthereumSignTxEIP7702OneKey.prototype.max_gas_fee = $util.newBuffer([]);
    EthereumSignTxEIP7702OneKey.prototype.max_priority_fee = $util.newBuffer([]);
    EthereumSignTxEIP7702OneKey.prototype.gas_limit = $util.newBuffer([]);
    EthereumSignTxEIP7702OneKey.prototype.to = "";
    EthereumSignTxEIP7702OneKey.prototype.value = $util.newBuffer([]);
    EthereumSignTxEIP7702OneKey.prototype.data_initial_chunk = $util.newBuffer([]);
    EthereumSignTxEIP7702OneKey.prototype.data_length = 0;
    EthereumSignTxEIP7702OneKey.prototype.chain_id = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    EthereumSignTxEIP7702OneKey.prototype.access_list = $util.emptyArray;
    EthereumSignTxEIP7702OneKey.prototype.authorization_list = $util.emptyArray;

    EthereumSignTxEIP7702OneKey.create = function create(properties) {
        return new EthereumSignTxEIP7702OneKey(properties);
    };

    EthereumSignTxEIP7702OneKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).bytes(message.nonce);
        writer.uint32(26).bytes(message.max_gas_fee);
        writer.uint32(34).bytes(message.max_priority_fee);
        writer.uint32(42).bytes(message.gas_limit);
        writer.uint32(50).string(message.to);
        writer.uint32(58).bytes(message.value);
        if (message.data_initial_chunk != null && Object.hasOwnProperty.call(message, "data_initial_chunk"))
            writer.uint32(66).bytes(message.data_initial_chunk);
        writer.uint32(72).uint32(message.data_length);
        writer.uint32(80).uint64(message.chain_id);
        if (message.access_list != null && message.access_list.length)
            for (var i = 0; i < message.access_list.length; ++i)
                $root.EthereumAccessListOneKey.encode(message.access_list[i], writer.uint32(90).fork()).ldelim();
        if (message.authorization_list != null && message.authorization_list.length)
            for (var i = 0; i < message.authorization_list.length; ++i)
                $root.EthereumSignTxEIP7702OneKey.EthereumAuthorizationOneKey.encode(message.authorization_list[i], writer.uint32(98).fork()).ldelim();
        return writer;
    };

    EthereumSignTxEIP7702OneKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumSignTxEIP7702OneKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumSignTxEIP7702OneKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.nonce = reader.bytes();
                break;
            case 3:
                message.max_gas_fee = reader.bytes();
                break;
            case 4:
                message.max_priority_fee = reader.bytes();
                break;
            case 5:
                message.gas_limit = reader.bytes();
                break;
            case 6:
                message.to = reader.string();
                break;
            case 7:
                message.value = reader.bytes();
                break;
            case 8:
                message.data_initial_chunk = reader.bytes();
                break;
            case 9:
                message.data_length = reader.uint32();
                break;
            case 10:
                message.chain_id = reader.uint64();
                break;
            case 11:
                if (!(message.access_list && message.access_list.length))
                    message.access_list = [];
                message.access_list.push($root.EthereumAccessListOneKey.decode(reader, reader.uint32()));
                break;
            case 12:
                if (!(message.authorization_list && message.authorization_list.length))
                    message.authorization_list = [];
                message.authorization_list.push($root.EthereumSignTxEIP7702OneKey.EthereumAuthorizationOneKey.decode(reader, reader.uint32()));
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("nonce"))
            throw $util.ProtocolError("missing required 'nonce'", { instance: message });
        if (!message.hasOwnProperty("max_gas_fee"))
            throw $util.ProtocolError("missing required 'max_gas_fee'", { instance: message });
        if (!message.hasOwnProperty("max_priority_fee"))
            throw $util.ProtocolError("missing required 'max_priority_fee'", { instance: message });
        if (!message.hasOwnProperty("gas_limit"))
            throw $util.ProtocolError("missing required 'gas_limit'", { instance: message });
        if (!message.hasOwnProperty("to"))
            throw $util.ProtocolError("missing required 'to'", { instance: message });
        if (!message.hasOwnProperty("value"))
            throw $util.ProtocolError("missing required 'value'", { instance: message });
        if (!message.hasOwnProperty("data_length"))
            throw $util.ProtocolError("missing required 'data_length'", { instance: message });
        if (!message.hasOwnProperty("chain_id"))
            throw $util.ProtocolError("missing required 'chain_id'", { instance: message });
        return message;
    };

    EthereumSignTxEIP7702OneKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumSignTxEIP7702OneKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!(message.nonce && typeof message.nonce.length === "number" || $util.isString(message.nonce)))
            return "nonce: buffer expected";
        if (!(message.max_gas_fee && typeof message.max_gas_fee.length === "number" || $util.isString(message.max_gas_fee)))
            return "max_gas_fee: buffer expected";
        if (!(message.max_priority_fee && typeof message.max_priority_fee.length === "number" || $util.isString(message.max_priority_fee)))
            return "max_priority_fee: buffer expected";
        if (!(message.gas_limit && typeof message.gas_limit.length === "number" || $util.isString(message.gas_limit)))
            return "gas_limit: buffer expected";
        if (!$util.isString(message.to))
            return "to: string expected";
        if (!(message.value && typeof message.value.length === "number" || $util.isString(message.value)))
            return "value: buffer expected";
        if (message.data_initial_chunk != null && message.hasOwnProperty("data_initial_chunk"))
            if (!(message.data_initial_chunk && typeof message.data_initial_chunk.length === "number" || $util.isString(message.data_initial_chunk)))
                return "data_initial_chunk: buffer expected";
        if (!$util.isInteger(message.data_length))
            return "data_length: integer expected";
        if (!$util.isInteger(message.chain_id) && !(message.chain_id && $util.isInteger(message.chain_id.low) && $util.isInteger(message.chain_id.high)))
            return "chain_id: integer|Long expected";
        if (message.access_list != null && message.hasOwnProperty("access_list")) {
            if (!Array.isArray(message.access_list))
                return "access_list: array expected";
            for (var i = 0; i < message.access_list.length; ++i) {
                var error = $root.EthereumAccessListOneKey.verify(message.access_list[i]);
                if (error)
                    return "access_list." + error;
            }
        }
        if (message.authorization_list != null && message.hasOwnProperty("authorization_list")) {
            if (!Array.isArray(message.authorization_list))
                return "authorization_list: array expected";
            for (var i = 0; i < message.authorization_list.length; ++i) {
                var error = $root.EthereumSignTxEIP7702OneKey.EthereumAuthorizationOneKey.verify(message.authorization_list[i]);
                if (error)
                    return "authorization_list." + error;
            }
        }
        return null;
    };

    EthereumSignTxEIP7702OneKey.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumSignTxEIP7702OneKey)
            return object;
        var message = new $root.EthereumSignTxEIP7702OneKey();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".EthereumSignTxEIP7702OneKey.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.nonce != null)
            if (typeof object.nonce === "string")
                $util.base64.decode(object.nonce, message.nonce = $util.newBuffer($util.base64.length(object.nonce)), 0);
            else if (object.nonce.length)
                message.nonce = object.nonce;
        if (object.max_gas_fee != null)
            if (typeof object.max_gas_fee === "string")
                $util.base64.decode(object.max_gas_fee, message.max_gas_fee = $util.newBuffer($util.base64.length(object.max_gas_fee)), 0);
            else if (object.max_gas_fee.length)
                message.max_gas_fee = object.max_gas_fee;
        if (object.max_priority_fee != null)
            if (typeof object.max_priority_fee === "string")
                $util.base64.decode(object.max_priority_fee, message.max_priority_fee = $util.newBuffer($util.base64.length(object.max_priority_fee)), 0);
            else if (object.max_priority_fee.length)
                message.max_priority_fee = object.max_priority_fee;
        if (object.gas_limit != null)
            if (typeof object.gas_limit === "string")
                $util.base64.decode(object.gas_limit, message.gas_limit = $util.newBuffer($util.base64.length(object.gas_limit)), 0);
            else if (object.gas_limit.length)
                message.gas_limit = object.gas_limit;
        if (object.to != null)
            message.to = String(object.to);
        if (object.value != null)
            if (typeof object.value === "string")
                $util.base64.decode(object.value, message.value = $util.newBuffer($util.base64.length(object.value)), 0);
            else if (object.value.length)
                message.value = object.value;
        if (object.data_initial_chunk != null)
            if (typeof object.data_initial_chunk === "string")
                $util.base64.decode(object.data_initial_chunk, message.data_initial_chunk = $util.newBuffer($util.base64.length(object.data_initial_chunk)), 0);
            else if (object.data_initial_chunk.length)
                message.data_initial_chunk = object.data_initial_chunk;
        if (object.data_length != null)
            message.data_length = object.data_length >>> 0;
        if (object.chain_id != null)
            if ($util.Long)
                (message.chain_id = $util.Long.fromValue(object.chain_id)).unsigned = true;
            else if (typeof object.chain_id === "string")
                message.chain_id = parseInt(object.chain_id, 10);
            else if (typeof object.chain_id === "number")
                message.chain_id = object.chain_id;
            else if (typeof object.chain_id === "object")
                message.chain_id = new $util.LongBits(object.chain_id.low >>> 0, object.chain_id.high >>> 0).toNumber(true);
        if (object.access_list) {
            if (!Array.isArray(object.access_list))
                throw TypeError(".EthereumSignTxEIP7702OneKey.access_list: array expected");
            message.access_list = [];
            for (var i = 0; i < object.access_list.length; ++i) {
                if (typeof object.access_list[i] !== "object")
                    throw TypeError(".EthereumSignTxEIP7702OneKey.access_list: object expected");
                message.access_list[i] = $root.EthereumAccessListOneKey.fromObject(object.access_list[i]);
            }
        }
        if (object.authorization_list) {
            if (!Array.isArray(object.authorization_list))
                throw TypeError(".EthereumSignTxEIP7702OneKey.authorization_list: array expected");
            message.authorization_list = [];
            for (var i = 0; i < object.authorization_list.length; ++i) {
                if (typeof object.authorization_list[i] !== "object")
                    throw TypeError(".EthereumSignTxEIP7702OneKey.authorization_list: object expected");
                message.authorization_list[i] = $root.EthereumSignTxEIP7702OneKey.EthereumAuthorizationOneKey.fromObject(object.authorization_list[i]);
            }
        }
        return message;
    };

    EthereumSignTxEIP7702OneKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults) {
            object.address_n = [];
            object.access_list = [];
            object.authorization_list = [];
        }
        if (options.defaults) {
            if (options.bytes === String)
                object.nonce = "";
            else {
                object.nonce = [];
                if (options.bytes !== Array)
                    object.nonce = $util.newBuffer(object.nonce);
            }
            if (options.bytes === String)
                object.max_gas_fee = "";
            else {
                object.max_gas_fee = [];
                if (options.bytes !== Array)
                    object.max_gas_fee = $util.newBuffer(object.max_gas_fee);
            }
            if (options.bytes === String)
                object.max_priority_fee = "";
            else {
                object.max_priority_fee = [];
                if (options.bytes !== Array)
                    object.max_priority_fee = $util.newBuffer(object.max_priority_fee);
            }
            if (options.bytes === String)
                object.gas_limit = "";
            else {
                object.gas_limit = [];
                if (options.bytes !== Array)
                    object.gas_limit = $util.newBuffer(object.gas_limit);
            }
            object.to = "";
            if (options.bytes === String)
                object.value = "";
            else {
                object.value = [];
                if (options.bytes !== Array)
                    object.value = $util.newBuffer(object.value);
            }
            if (options.bytes === String)
                object.data_initial_chunk = "";
            else {
                object.data_initial_chunk = [];
                if (options.bytes !== Array)
                    object.data_initial_chunk = $util.newBuffer(object.data_initial_chunk);
            }
            object.data_length = 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.chain_id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.chain_id = options.longs === String ? "0" : 0;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.nonce != null && message.hasOwnProperty("nonce"))
            object.nonce = options.bytes === String ? $util.base64.encode(message.nonce, 0, message.nonce.length) : options.bytes === Array ? Array.prototype.slice.call(message.nonce) : message.nonce;
        if (message.max_gas_fee != null && message.hasOwnProperty("max_gas_fee"))
            object.max_gas_fee = options.bytes === String ? $util.base64.encode(message.max_gas_fee, 0, message.max_gas_fee.length) : options.bytes === Array ? Array.prototype.slice.call(message.max_gas_fee) : message.max_gas_fee;
        if (message.max_priority_fee != null && message.hasOwnProperty("max_priority_fee"))
            object.max_priority_fee = options.bytes === String ? $util.base64.encode(message.max_priority_fee, 0, message.max_priority_fee.length) : options.bytes === Array ? Array.prototype.slice.call(message.max_priority_fee) : message.max_priority_fee;
        if (message.gas_limit != null && message.hasOwnProperty("gas_limit"))
            object.gas_limit = options.bytes === String ? $util.base64.encode(message.gas_limit, 0, message.gas_limit.length) : options.bytes === Array ? Array.prototype.slice.call(message.gas_limit) : message.gas_limit;
        if (message.to != null && message.hasOwnProperty("to"))
            object.to = message.to;
        if (message.value != null && message.hasOwnProperty("value"))
            object.value = options.bytes === String ? $util.base64.encode(message.value, 0, message.value.length) : options.bytes === Array ? Array.prototype.slice.call(message.value) : message.value;
        if (message.data_initial_chunk != null && message.hasOwnProperty("data_initial_chunk"))
            object.data_initial_chunk = options.bytes === String ? $util.base64.encode(message.data_initial_chunk, 0, message.data_initial_chunk.length) : options.bytes === Array ? Array.prototype.slice.call(message.data_initial_chunk) : message.data_initial_chunk;
        if (message.data_length != null && message.hasOwnProperty("data_length"))
            object.data_length = message.data_length;
        if (message.chain_id != null && message.hasOwnProperty("chain_id"))
            if (typeof message.chain_id === "number")
                object.chain_id = options.longs === String ? String(message.chain_id) : message.chain_id;
            else
                object.chain_id = options.longs === String ? $util.Long.prototype.toString.call(message.chain_id) : options.longs === Number ? new $util.LongBits(message.chain_id.low >>> 0, message.chain_id.high >>> 0).toNumber(true) : message.chain_id;
        if (message.access_list && message.access_list.length) {
            object.access_list = [];
            for (var j = 0; j < message.access_list.length; ++j)
                object.access_list[j] = $root.EthereumAccessListOneKey.toObject(message.access_list[j], options);
        }
        if (message.authorization_list && message.authorization_list.length) {
            object.authorization_list = [];
            for (var j = 0; j < message.authorization_list.length; ++j)
                object.authorization_list[j] = $root.EthereumSignTxEIP7702OneKey.EthereumAuthorizationOneKey.toObject(message.authorization_list[j], options);
        }
        return object;
    };

    EthereumSignTxEIP7702OneKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    EthereumSignTxEIP7702OneKey.EthereumAuthorizationOneKey = (function() {

        function EthereumAuthorizationOneKey(properties) {
            this.address_n = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        EthereumAuthorizationOneKey.prototype.address_n = $util.emptyArray;
        EthereumAuthorizationOneKey.prototype.chain_id = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        EthereumAuthorizationOneKey.prototype.address = "";
        EthereumAuthorizationOneKey.prototype.nonce = $util.newBuffer([]);
        EthereumAuthorizationOneKey.prototype.signature = null;

        EthereumAuthorizationOneKey.create = function create(properties) {
            return new EthereumAuthorizationOneKey(properties);
        };

        EthereumAuthorizationOneKey.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.address_n != null && message.address_n.length)
                for (var i = 0; i < message.address_n.length; ++i)
                    writer.uint32(8).uint32(message.address_n[i]);
            writer.uint32(16).uint64(message.chain_id);
            writer.uint32(26).string(message.address);
            writer.uint32(34).bytes(message.nonce);
            if (message.signature != null && Object.hasOwnProperty.call(message, "signature"))
                $root.EthereumAuthorizationSignature.encode(message.signature, writer.uint32(42).fork()).ldelim();
            return writer;
        };

        EthereumAuthorizationOneKey.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        EthereumAuthorizationOneKey.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumSignTxEIP7702OneKey.EthereumAuthorizationOneKey();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.address_n && message.address_n.length))
                        message.address_n = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.address_n.push(reader.uint32());
                    } else
                        message.address_n.push(reader.uint32());
                    break;
                case 2:
                    message.chain_id = reader.uint64();
                    break;
                case 3:
                    message.address = reader.string();
                    break;
                case 4:
                    message.nonce = reader.bytes();
                    break;
                case 5:
                    message.signature = $root.EthereumAuthorizationSignature.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("chain_id"))
                throw $util.ProtocolError("missing required 'chain_id'", { instance: message });
            if (!message.hasOwnProperty("address"))
                throw $util.ProtocolError("missing required 'address'", { instance: message });
            if (!message.hasOwnProperty("nonce"))
                throw $util.ProtocolError("missing required 'nonce'", { instance: message });
            return message;
        };

        EthereumAuthorizationOneKey.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        EthereumAuthorizationOneKey.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.address_n != null && message.hasOwnProperty("address_n")) {
                if (!Array.isArray(message.address_n))
                    return "address_n: array expected";
                for (var i = 0; i < message.address_n.length; ++i)
                    if (!$util.isInteger(message.address_n[i]))
                        return "address_n: integer[] expected";
            }
            if (!$util.isInteger(message.chain_id) && !(message.chain_id && $util.isInteger(message.chain_id.low) && $util.isInteger(message.chain_id.high)))
                return "chain_id: integer|Long expected";
            if (!$util.isString(message.address))
                return "address: string expected";
            if (!(message.nonce && typeof message.nonce.length === "number" || $util.isString(message.nonce)))
                return "nonce: buffer expected";
            if (message.signature != null && message.hasOwnProperty("signature")) {
                var error = $root.EthereumAuthorizationSignature.verify(message.signature);
                if (error)
                    return "signature." + error;
            }
            return null;
        };

        EthereumAuthorizationOneKey.fromObject = function fromObject(object) {
            if (object instanceof $root.EthereumSignTxEIP7702OneKey.EthereumAuthorizationOneKey)
                return object;
            var message = new $root.EthereumSignTxEIP7702OneKey.EthereumAuthorizationOneKey();
            if (object.address_n) {
                if (!Array.isArray(object.address_n))
                    throw TypeError(".EthereumSignTxEIP7702OneKey.EthereumAuthorizationOneKey.address_n: array expected");
                message.address_n = [];
                for (var i = 0; i < object.address_n.length; ++i)
                    message.address_n[i] = object.address_n[i] >>> 0;
            }
            if (object.chain_id != null)
                if ($util.Long)
                    (message.chain_id = $util.Long.fromValue(object.chain_id)).unsigned = true;
                else if (typeof object.chain_id === "string")
                    message.chain_id = parseInt(object.chain_id, 10);
                else if (typeof object.chain_id === "number")
                    message.chain_id = object.chain_id;
                else if (typeof object.chain_id === "object")
                    message.chain_id = new $util.LongBits(object.chain_id.low >>> 0, object.chain_id.high >>> 0).toNumber(true);
            if (object.address != null)
                message.address = String(object.address);
            if (object.nonce != null)
                if (typeof object.nonce === "string")
                    $util.base64.decode(object.nonce, message.nonce = $util.newBuffer($util.base64.length(object.nonce)), 0);
                else if (object.nonce.length)
                    message.nonce = object.nonce;
            if (object.signature != null) {
                if (typeof object.signature !== "object")
                    throw TypeError(".EthereumSignTxEIP7702OneKey.EthereumAuthorizationOneKey.signature: object expected");
                message.signature = $root.EthereumAuthorizationSignature.fromObject(object.signature);
            }
            return message;
        };

        EthereumAuthorizationOneKey.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.address_n = [];
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.chain_id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.chain_id = options.longs === String ? "0" : 0;
                object.address = "";
                if (options.bytes === String)
                    object.nonce = "";
                else {
                    object.nonce = [];
                    if (options.bytes !== Array)
                        object.nonce = $util.newBuffer(object.nonce);
                }
                object.signature = null;
            }
            if (message.address_n && message.address_n.length) {
                object.address_n = [];
                for (var j = 0; j < message.address_n.length; ++j)
                    object.address_n[j] = message.address_n[j];
            }
            if (message.chain_id != null && message.hasOwnProperty("chain_id"))
                if (typeof message.chain_id === "number")
                    object.chain_id = options.longs === String ? String(message.chain_id) : message.chain_id;
                else
                    object.chain_id = options.longs === String ? $util.Long.prototype.toString.call(message.chain_id) : options.longs === Number ? new $util.LongBits(message.chain_id.low >>> 0, message.chain_id.high >>> 0).toNumber(true) : message.chain_id;
            if (message.address != null && message.hasOwnProperty("address"))
                object.address = message.address;
            if (message.nonce != null && message.hasOwnProperty("nonce"))
                object.nonce = options.bytes === String ? $util.base64.encode(message.nonce, 0, message.nonce.length) : options.bytes === Array ? Array.prototype.slice.call(message.nonce) : message.nonce;
            if (message.signature != null && message.hasOwnProperty("signature"))
                object.signature = $root.EthereumAuthorizationSignature.toObject(message.signature, options);
            return object;
        };

        EthereumAuthorizationOneKey.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EthereumAuthorizationOneKey;
    })();

    return EthereumSignTxEIP7702OneKey;
})();

$root.EthereumTxRequestOneKey = (function() {

    function EthereumTxRequestOneKey(properties) {
        this.authorization_signatures = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumTxRequestOneKey.prototype.data_length = 0;
    EthereumTxRequestOneKey.prototype.signature_v = 0;
    EthereumTxRequestOneKey.prototype.signature_r = $util.newBuffer([]);
    EthereumTxRequestOneKey.prototype.signature_s = $util.newBuffer([]);
    EthereumTxRequestOneKey.prototype.authorization_signatures = $util.emptyArray;

    EthereumTxRequestOneKey.create = function create(properties) {
        return new EthereumTxRequestOneKey(properties);
    };

    EthereumTxRequestOneKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.data_length != null && Object.hasOwnProperty.call(message, "data_length"))
            writer.uint32(8).uint32(message.data_length);
        if (message.signature_v != null && Object.hasOwnProperty.call(message, "signature_v"))
            writer.uint32(16).uint32(message.signature_v);
        if (message.signature_r != null && Object.hasOwnProperty.call(message, "signature_r"))
            writer.uint32(26).bytes(message.signature_r);
        if (message.signature_s != null && Object.hasOwnProperty.call(message, "signature_s"))
            writer.uint32(34).bytes(message.signature_s);
        if (message.authorization_signatures != null && message.authorization_signatures.length)
            for (var i = 0; i < message.authorization_signatures.length; ++i)
                $root.EthereumAuthorizationSignature.encode(message.authorization_signatures[i], writer.uint32(82).fork()).ldelim();
        return writer;
    };

    EthereumTxRequestOneKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumTxRequestOneKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumTxRequestOneKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.data_length = reader.uint32();
                break;
            case 2:
                message.signature_v = reader.uint32();
                break;
            case 3:
                message.signature_r = reader.bytes();
                break;
            case 4:
                message.signature_s = reader.bytes();
                break;
            case 10:
                if (!(message.authorization_signatures && message.authorization_signatures.length))
                    message.authorization_signatures = [];
                message.authorization_signatures.push($root.EthereumAuthorizationSignature.decode(reader, reader.uint32()));
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    EthereumTxRequestOneKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumTxRequestOneKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.data_length != null && message.hasOwnProperty("data_length"))
            if (!$util.isInteger(message.data_length))
                return "data_length: integer expected";
        if (message.signature_v != null && message.hasOwnProperty("signature_v"))
            if (!$util.isInteger(message.signature_v))
                return "signature_v: integer expected";
        if (message.signature_r != null && message.hasOwnProperty("signature_r"))
            if (!(message.signature_r && typeof message.signature_r.length === "number" || $util.isString(message.signature_r)))
                return "signature_r: buffer expected";
        if (message.signature_s != null && message.hasOwnProperty("signature_s"))
            if (!(message.signature_s && typeof message.signature_s.length === "number" || $util.isString(message.signature_s)))
                return "signature_s: buffer expected";
        if (message.authorization_signatures != null && message.hasOwnProperty("authorization_signatures")) {
            if (!Array.isArray(message.authorization_signatures))
                return "authorization_signatures: array expected";
            for (var i = 0; i < message.authorization_signatures.length; ++i) {
                var error = $root.EthereumAuthorizationSignature.verify(message.authorization_signatures[i]);
                if (error)
                    return "authorization_signatures." + error;
            }
        }
        return null;
    };

    EthereumTxRequestOneKey.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumTxRequestOneKey)
            return object;
        var message = new $root.EthereumTxRequestOneKey();
        if (object.data_length != null)
            message.data_length = object.data_length >>> 0;
        if (object.signature_v != null)
            message.signature_v = object.signature_v >>> 0;
        if (object.signature_r != null)
            if (typeof object.signature_r === "string")
                $util.base64.decode(object.signature_r, message.signature_r = $util.newBuffer($util.base64.length(object.signature_r)), 0);
            else if (object.signature_r.length)
                message.signature_r = object.signature_r;
        if (object.signature_s != null)
            if (typeof object.signature_s === "string")
                $util.base64.decode(object.signature_s, message.signature_s = $util.newBuffer($util.base64.length(object.signature_s)), 0);
            else if (object.signature_s.length)
                message.signature_s = object.signature_s;
        if (object.authorization_signatures) {
            if (!Array.isArray(object.authorization_signatures))
                throw TypeError(".EthereumTxRequestOneKey.authorization_signatures: array expected");
            message.authorization_signatures = [];
            for (var i = 0; i < object.authorization_signatures.length; ++i) {
                if (typeof object.authorization_signatures[i] !== "object")
                    throw TypeError(".EthereumTxRequestOneKey.authorization_signatures: object expected");
                message.authorization_signatures[i] = $root.EthereumAuthorizationSignature.fromObject(object.authorization_signatures[i]);
            }
        }
        return message;
    };

    EthereumTxRequestOneKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.authorization_signatures = [];
        if (options.defaults) {
            object.data_length = 0;
            object.signature_v = 0;
            if (options.bytes === String)
                object.signature_r = "";
            else {
                object.signature_r = [];
                if (options.bytes !== Array)
                    object.signature_r = $util.newBuffer(object.signature_r);
            }
            if (options.bytes === String)
                object.signature_s = "";
            else {
                object.signature_s = [];
                if (options.bytes !== Array)
                    object.signature_s = $util.newBuffer(object.signature_s);
            }
        }
        if (message.data_length != null && message.hasOwnProperty("data_length"))
            object.data_length = message.data_length;
        if (message.signature_v != null && message.hasOwnProperty("signature_v"))
            object.signature_v = message.signature_v;
        if (message.signature_r != null && message.hasOwnProperty("signature_r"))
            object.signature_r = options.bytes === String ? $util.base64.encode(message.signature_r, 0, message.signature_r.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature_r) : message.signature_r;
        if (message.signature_s != null && message.hasOwnProperty("signature_s"))
            object.signature_s = options.bytes === String ? $util.base64.encode(message.signature_s, 0, message.signature_s.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature_s) : message.signature_s;
        if (message.authorization_signatures && message.authorization_signatures.length) {
            object.authorization_signatures = [];
            for (var j = 0; j < message.authorization_signatures.length; ++j)
                object.authorization_signatures[j] = $root.EthereumAuthorizationSignature.toObject(message.authorization_signatures[j], options);
        }
        return object;
    };

    EthereumTxRequestOneKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumTxRequestOneKey;
})();

$root.EthereumTxAckOneKey = (function() {

    function EthereumTxAckOneKey(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumTxAckOneKey.prototype.data_chunk = $util.newBuffer([]);

    EthereumTxAckOneKey.create = function create(properties) {
        return new EthereumTxAckOneKey(properties);
    };

    EthereumTxAckOneKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.data_chunk);
        return writer;
    };

    EthereumTxAckOneKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumTxAckOneKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumTxAckOneKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.data_chunk = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("data_chunk"))
            throw $util.ProtocolError("missing required 'data_chunk'", { instance: message });
        return message;
    };

    EthereumTxAckOneKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumTxAckOneKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.data_chunk && typeof message.data_chunk.length === "number" || $util.isString(message.data_chunk)))
            return "data_chunk: buffer expected";
        return null;
    };

    EthereumTxAckOneKey.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumTxAckOneKey)
            return object;
        var message = new $root.EthereumTxAckOneKey();
        if (object.data_chunk != null)
            if (typeof object.data_chunk === "string")
                $util.base64.decode(object.data_chunk, message.data_chunk = $util.newBuffer($util.base64.length(object.data_chunk)), 0);
            else if (object.data_chunk.length)
                message.data_chunk = object.data_chunk;
        return message;
    };

    EthereumTxAckOneKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.data_chunk = "";
            else {
                object.data_chunk = [];
                if (options.bytes !== Array)
                    object.data_chunk = $util.newBuffer(object.data_chunk);
            }
        if (message.data_chunk != null && message.hasOwnProperty("data_chunk"))
            object.data_chunk = options.bytes === String ? $util.base64.encode(message.data_chunk, 0, message.data_chunk.length) : options.bytes === Array ? Array.prototype.slice.call(message.data_chunk) : message.data_chunk;
        return object;
    };

    EthereumTxAckOneKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumTxAckOneKey;
})();

$root.EthereumSignMessageOneKey = (function() {

    function EthereumSignMessageOneKey(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumSignMessageOneKey.prototype.address_n = $util.emptyArray;
    EthereumSignMessageOneKey.prototype.message = $util.newBuffer([]);
    EthereumSignMessageOneKey.prototype.chain_id = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    EthereumSignMessageOneKey.create = function create(properties) {
        return new EthereumSignMessageOneKey(properties);
    };

    EthereumSignMessageOneKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).bytes(message.message);
        if (message.chain_id != null && Object.hasOwnProperty.call(message, "chain_id"))
            writer.uint32(24).uint64(message.chain_id);
        return writer;
    };

    EthereumSignMessageOneKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumSignMessageOneKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumSignMessageOneKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.message = reader.bytes();
                break;
            case 3:
                message.chain_id = reader.uint64();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("message"))
            throw $util.ProtocolError("missing required 'message'", { instance: message });
        return message;
    };

    EthereumSignMessageOneKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumSignMessageOneKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!(message.message && typeof message.message.length === "number" || $util.isString(message.message)))
            return "message: buffer expected";
        if (message.chain_id != null && message.hasOwnProperty("chain_id"))
            if (!$util.isInteger(message.chain_id) && !(message.chain_id && $util.isInteger(message.chain_id.low) && $util.isInteger(message.chain_id.high)))
                return "chain_id: integer|Long expected";
        return null;
    };

    EthereumSignMessageOneKey.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumSignMessageOneKey)
            return object;
        var message = new $root.EthereumSignMessageOneKey();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".EthereumSignMessageOneKey.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.message != null)
            if (typeof object.message === "string")
                $util.base64.decode(object.message, message.message = $util.newBuffer($util.base64.length(object.message)), 0);
            else if (object.message.length)
                message.message = object.message;
        if (object.chain_id != null)
            if ($util.Long)
                (message.chain_id = $util.Long.fromValue(object.chain_id)).unsigned = true;
            else if (typeof object.chain_id === "string")
                message.chain_id = parseInt(object.chain_id, 10);
            else if (typeof object.chain_id === "number")
                message.chain_id = object.chain_id;
            else if (typeof object.chain_id === "object")
                message.chain_id = new $util.LongBits(object.chain_id.low >>> 0, object.chain_id.high >>> 0).toNumber(true);
        return message;
    };

    EthereumSignMessageOneKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            if (options.bytes === String)
                object.message = "";
            else {
                object.message = [];
                if (options.bytes !== Array)
                    object.message = $util.newBuffer(object.message);
            }
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.chain_id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.chain_id = options.longs === String ? "0" : 0;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.message != null && message.hasOwnProperty("message"))
            object.message = options.bytes === String ? $util.base64.encode(message.message, 0, message.message.length) : options.bytes === Array ? Array.prototype.slice.call(message.message) : message.message;
        if (message.chain_id != null && message.hasOwnProperty("chain_id"))
            if (typeof message.chain_id === "number")
                object.chain_id = options.longs === String ? String(message.chain_id) : message.chain_id;
            else
                object.chain_id = options.longs === String ? $util.Long.prototype.toString.call(message.chain_id) : options.longs === Number ? new $util.LongBits(message.chain_id.low >>> 0, message.chain_id.high >>> 0).toNumber(true) : message.chain_id;
        return object;
    };

    EthereumSignMessageOneKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumSignMessageOneKey;
})();

$root.EthereumMessageSignatureOneKey = (function() {

    function EthereumMessageSignatureOneKey(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumMessageSignatureOneKey.prototype.signature = $util.newBuffer([]);
    EthereumMessageSignatureOneKey.prototype.address = "";

    EthereumMessageSignatureOneKey.create = function create(properties) {
        return new EthereumMessageSignatureOneKey(properties);
    };

    EthereumMessageSignatureOneKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(18).bytes(message.signature);
        writer.uint32(26).string(message.address);
        return writer;
    };

    EthereumMessageSignatureOneKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumMessageSignatureOneKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumMessageSignatureOneKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 2:
                message.signature = reader.bytes();
                break;
            case 3:
                message.address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        if (!message.hasOwnProperty("address"))
            throw $util.ProtocolError("missing required 'address'", { instance: message });
        return message;
    };

    EthereumMessageSignatureOneKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumMessageSignatureOneKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        if (!$util.isString(message.address))
            return "address: string expected";
        return null;
    };

    EthereumMessageSignatureOneKey.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumMessageSignatureOneKey)
            return object;
        var message = new $root.EthereumMessageSignatureOneKey();
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        if (object.address != null)
            message.address = String(object.address);
        return message;
    };

    EthereumMessageSignatureOneKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
            object.address = "";
        }
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    EthereumMessageSignatureOneKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumMessageSignatureOneKey;
})();

$root.EthereumVerifyMessageOneKey = (function() {

    function EthereumVerifyMessageOneKey(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumVerifyMessageOneKey.prototype.signature = $util.newBuffer([]);
    EthereumVerifyMessageOneKey.prototype.message = $util.newBuffer([]);
    EthereumVerifyMessageOneKey.prototype.address = "";
    EthereumVerifyMessageOneKey.prototype.chain_id = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    EthereumVerifyMessageOneKey.create = function create(properties) {
        return new EthereumVerifyMessageOneKey(properties);
    };

    EthereumVerifyMessageOneKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(18).bytes(message.signature);
        writer.uint32(26).bytes(message.message);
        writer.uint32(34).string(message.address);
        if (message.chain_id != null && Object.hasOwnProperty.call(message, "chain_id"))
            writer.uint32(40).uint64(message.chain_id);
        return writer;
    };

    EthereumVerifyMessageOneKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumVerifyMessageOneKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumVerifyMessageOneKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 2:
                message.signature = reader.bytes();
                break;
            case 3:
                message.message = reader.bytes();
                break;
            case 4:
                message.address = reader.string();
                break;
            case 5:
                message.chain_id = reader.uint64();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        if (!message.hasOwnProperty("message"))
            throw $util.ProtocolError("missing required 'message'", { instance: message });
        if (!message.hasOwnProperty("address"))
            throw $util.ProtocolError("missing required 'address'", { instance: message });
        return message;
    };

    EthereumVerifyMessageOneKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumVerifyMessageOneKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        if (!(message.message && typeof message.message.length === "number" || $util.isString(message.message)))
            return "message: buffer expected";
        if (!$util.isString(message.address))
            return "address: string expected";
        if (message.chain_id != null && message.hasOwnProperty("chain_id"))
            if (!$util.isInteger(message.chain_id) && !(message.chain_id && $util.isInteger(message.chain_id.low) && $util.isInteger(message.chain_id.high)))
                return "chain_id: integer|Long expected";
        return null;
    };

    EthereumVerifyMessageOneKey.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumVerifyMessageOneKey)
            return object;
        var message = new $root.EthereumVerifyMessageOneKey();
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        if (object.message != null)
            if (typeof object.message === "string")
                $util.base64.decode(object.message, message.message = $util.newBuffer($util.base64.length(object.message)), 0);
            else if (object.message.length)
                message.message = object.message;
        if (object.address != null)
            message.address = String(object.address);
        if (object.chain_id != null)
            if ($util.Long)
                (message.chain_id = $util.Long.fromValue(object.chain_id)).unsigned = true;
            else if (typeof object.chain_id === "string")
                message.chain_id = parseInt(object.chain_id, 10);
            else if (typeof object.chain_id === "number")
                message.chain_id = object.chain_id;
            else if (typeof object.chain_id === "object")
                message.chain_id = new $util.LongBits(object.chain_id.low >>> 0, object.chain_id.high >>> 0).toNumber(true);
        return message;
    };

    EthereumVerifyMessageOneKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
            if (options.bytes === String)
                object.message = "";
            else {
                object.message = [];
                if (options.bytes !== Array)
                    object.message = $util.newBuffer(object.message);
            }
            object.address = "";
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.chain_id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.chain_id = options.longs === String ? "0" : 0;
        }
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        if (message.message != null && message.hasOwnProperty("message"))
            object.message = options.bytes === String ? $util.base64.encode(message.message, 0, message.message.length) : options.bytes === Array ? Array.prototype.slice.call(message.message) : message.message;
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        if (message.chain_id != null && message.hasOwnProperty("chain_id"))
            if (typeof message.chain_id === "number")
                object.chain_id = options.longs === String ? String(message.chain_id) : message.chain_id;
            else
                object.chain_id = options.longs === String ? $util.Long.prototype.toString.call(message.chain_id) : options.longs === Number ? new $util.LongBits(message.chain_id.low >>> 0, message.chain_id.high >>> 0).toNumber(true) : message.chain_id;
        return object;
    };

    EthereumVerifyMessageOneKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumVerifyMessageOneKey;
})();

$root.EthereumSignTypedHashOneKey = (function() {

    function EthereumSignTypedHashOneKey(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumSignTypedHashOneKey.prototype.address_n = $util.emptyArray;
    EthereumSignTypedHashOneKey.prototype.domain_separator_hash = $util.newBuffer([]);
    EthereumSignTypedHashOneKey.prototype.message_hash = $util.newBuffer([]);
    EthereumSignTypedHashOneKey.prototype.chain_id = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    EthereumSignTypedHashOneKey.create = function create(properties) {
        return new EthereumSignTypedHashOneKey(properties);
    };

    EthereumSignTypedHashOneKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).bytes(message.domain_separator_hash);
        if (message.message_hash != null && Object.hasOwnProperty.call(message, "message_hash"))
            writer.uint32(26).bytes(message.message_hash);
        if (message.chain_id != null && Object.hasOwnProperty.call(message, "chain_id"))
            writer.uint32(32).uint64(message.chain_id);
        return writer;
    };

    EthereumSignTypedHashOneKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumSignTypedHashOneKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumSignTypedHashOneKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.domain_separator_hash = reader.bytes();
                break;
            case 3:
                message.message_hash = reader.bytes();
                break;
            case 4:
                message.chain_id = reader.uint64();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("domain_separator_hash"))
            throw $util.ProtocolError("missing required 'domain_separator_hash'", { instance: message });
        return message;
    };

    EthereumSignTypedHashOneKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumSignTypedHashOneKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!(message.domain_separator_hash && typeof message.domain_separator_hash.length === "number" || $util.isString(message.domain_separator_hash)))
            return "domain_separator_hash: buffer expected";
        if (message.message_hash != null && message.hasOwnProperty("message_hash"))
            if (!(message.message_hash && typeof message.message_hash.length === "number" || $util.isString(message.message_hash)))
                return "message_hash: buffer expected";
        if (message.chain_id != null && message.hasOwnProperty("chain_id"))
            if (!$util.isInteger(message.chain_id) && !(message.chain_id && $util.isInteger(message.chain_id.low) && $util.isInteger(message.chain_id.high)))
                return "chain_id: integer|Long expected";
        return null;
    };

    EthereumSignTypedHashOneKey.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumSignTypedHashOneKey)
            return object;
        var message = new $root.EthereumSignTypedHashOneKey();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".EthereumSignTypedHashOneKey.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.domain_separator_hash != null)
            if (typeof object.domain_separator_hash === "string")
                $util.base64.decode(object.domain_separator_hash, message.domain_separator_hash = $util.newBuffer($util.base64.length(object.domain_separator_hash)), 0);
            else if (object.domain_separator_hash.length)
                message.domain_separator_hash = object.domain_separator_hash;
        if (object.message_hash != null)
            if (typeof object.message_hash === "string")
                $util.base64.decode(object.message_hash, message.message_hash = $util.newBuffer($util.base64.length(object.message_hash)), 0);
            else if (object.message_hash.length)
                message.message_hash = object.message_hash;
        if (object.chain_id != null)
            if ($util.Long)
                (message.chain_id = $util.Long.fromValue(object.chain_id)).unsigned = true;
            else if (typeof object.chain_id === "string")
                message.chain_id = parseInt(object.chain_id, 10);
            else if (typeof object.chain_id === "number")
                message.chain_id = object.chain_id;
            else if (typeof object.chain_id === "object")
                message.chain_id = new $util.LongBits(object.chain_id.low >>> 0, object.chain_id.high >>> 0).toNumber(true);
        return message;
    };

    EthereumSignTypedHashOneKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            if (options.bytes === String)
                object.domain_separator_hash = "";
            else {
                object.domain_separator_hash = [];
                if (options.bytes !== Array)
                    object.domain_separator_hash = $util.newBuffer(object.domain_separator_hash);
            }
            if (options.bytes === String)
                object.message_hash = "";
            else {
                object.message_hash = [];
                if (options.bytes !== Array)
                    object.message_hash = $util.newBuffer(object.message_hash);
            }
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.chain_id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.chain_id = options.longs === String ? "0" : 0;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.domain_separator_hash != null && message.hasOwnProperty("domain_separator_hash"))
            object.domain_separator_hash = options.bytes === String ? $util.base64.encode(message.domain_separator_hash, 0, message.domain_separator_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.domain_separator_hash) : message.domain_separator_hash;
        if (message.message_hash != null && message.hasOwnProperty("message_hash"))
            object.message_hash = options.bytes === String ? $util.base64.encode(message.message_hash, 0, message.message_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.message_hash) : message.message_hash;
        if (message.chain_id != null && message.hasOwnProperty("chain_id"))
            if (typeof message.chain_id === "number")
                object.chain_id = options.longs === String ? String(message.chain_id) : message.chain_id;
            else
                object.chain_id = options.longs === String ? $util.Long.prototype.toString.call(message.chain_id) : options.longs === Number ? new $util.LongBits(message.chain_id.low >>> 0, message.chain_id.high >>> 0).toNumber(true) : message.chain_id;
        return object;
    };

    EthereumSignTypedHashOneKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumSignTypedHashOneKey;
})();

$root.EthereumTypedDataSignatureOneKey = (function() {

    function EthereumTypedDataSignatureOneKey(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumTypedDataSignatureOneKey.prototype.signature = $util.newBuffer([]);
    EthereumTypedDataSignatureOneKey.prototype.address = "";

    EthereumTypedDataSignatureOneKey.create = function create(properties) {
        return new EthereumTypedDataSignatureOneKey(properties);
    };

    EthereumTypedDataSignatureOneKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.signature);
        writer.uint32(18).string(message.address);
        return writer;
    };

    EthereumTypedDataSignatureOneKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumTypedDataSignatureOneKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumTypedDataSignatureOneKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.signature = reader.bytes();
                break;
            case 2:
                message.address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        if (!message.hasOwnProperty("address"))
            throw $util.ProtocolError("missing required 'address'", { instance: message });
        return message;
    };

    EthereumTypedDataSignatureOneKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumTypedDataSignatureOneKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        if (!$util.isString(message.address))
            return "address: string expected";
        return null;
    };

    EthereumTypedDataSignatureOneKey.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumTypedDataSignatureOneKey)
            return object;
        var message = new $root.EthereumTypedDataSignatureOneKey();
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        if (object.address != null)
            message.address = String(object.address);
        return message;
    };

    EthereumTypedDataSignatureOneKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
            object.address = "";
        }
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    EthereumTypedDataSignatureOneKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumTypedDataSignatureOneKey;
})();

$root.EthereumGetPublicKey = (function() {

    function EthereumGetPublicKey(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumGetPublicKey.prototype.address_n = $util.emptyArray;
    EthereumGetPublicKey.prototype.show_display = false;

    EthereumGetPublicKey.create = function create(properties) {
        return new EthereumGetPublicKey(properties);
    };

    EthereumGetPublicKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(16).bool(message.show_display);
        return writer;
    };

    EthereumGetPublicKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumGetPublicKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumGetPublicKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.show_display = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    EthereumGetPublicKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumGetPublicKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        return null;
    };

    EthereumGetPublicKey.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumGetPublicKey)
            return object;
        var message = new $root.EthereumGetPublicKey();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".EthereumGetPublicKey.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        return message;
    };

    EthereumGetPublicKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            object.show_display = false;
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        return object;
    };

    EthereumGetPublicKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumGetPublicKey;
})();

$root.EthereumPublicKey = (function() {

    function EthereumPublicKey(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumPublicKey.prototype.node = null;
    EthereumPublicKey.prototype.xpub = "";

    EthereumPublicKey.create = function create(properties) {
        return new EthereumPublicKey(properties);
    };

    EthereumPublicKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        $root.HDNodeType.encode(message.node, writer.uint32(10).fork()).ldelim();
        writer.uint32(18).string(message.xpub);
        return writer;
    };

    EthereumPublicKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumPublicKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumPublicKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.node = $root.HDNodeType.decode(reader, reader.uint32());
                break;
            case 2:
                message.xpub = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("node"))
            throw $util.ProtocolError("missing required 'node'", { instance: message });
        if (!message.hasOwnProperty("xpub"))
            throw $util.ProtocolError("missing required 'xpub'", { instance: message });
        return message;
    };

    EthereumPublicKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumPublicKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        {
            var error = $root.HDNodeType.verify(message.node);
            if (error)
                return "node." + error;
        }
        if (!$util.isString(message.xpub))
            return "xpub: string expected";
        return null;
    };

    EthereumPublicKey.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumPublicKey)
            return object;
        var message = new $root.EthereumPublicKey();
        if (object.node != null) {
            if (typeof object.node !== "object")
                throw TypeError(".EthereumPublicKey.node: object expected");
            message.node = $root.HDNodeType.fromObject(object.node);
        }
        if (object.xpub != null)
            message.xpub = String(object.xpub);
        return message;
    };

    EthereumPublicKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.node = null;
            object.xpub = "";
        }
        if (message.node != null && message.hasOwnProperty("node"))
            object.node = $root.HDNodeType.toObject(message.node, options);
        if (message.xpub != null && message.hasOwnProperty("xpub"))
            object.xpub = message.xpub;
        return object;
    };

    EthereumPublicKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumPublicKey;
})();

$root.EthereumGetAddress = (function() {

    function EthereumGetAddress(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumGetAddress.prototype.address_n = $util.emptyArray;
    EthereumGetAddress.prototype.show_display = false;
    EthereumGetAddress.prototype.encoded_network = $util.newBuffer([]);

    EthereumGetAddress.create = function create(properties) {
        return new EthereumGetAddress(properties);
    };

    EthereumGetAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(16).bool(message.show_display);
        if (message.encoded_network != null && Object.hasOwnProperty.call(message, "encoded_network"))
            writer.uint32(26).bytes(message.encoded_network);
        return writer;
    };

    EthereumGetAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumGetAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumGetAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.show_display = reader.bool();
                break;
            case 3:
                message.encoded_network = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    EthereumGetAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumGetAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        if (message.encoded_network != null && message.hasOwnProperty("encoded_network"))
            if (!(message.encoded_network && typeof message.encoded_network.length === "number" || $util.isString(message.encoded_network)))
                return "encoded_network: buffer expected";
        return null;
    };

    EthereumGetAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumGetAddress)
            return object;
        var message = new $root.EthereumGetAddress();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".EthereumGetAddress.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        if (object.encoded_network != null)
            if (typeof object.encoded_network === "string")
                $util.base64.decode(object.encoded_network, message.encoded_network = $util.newBuffer($util.base64.length(object.encoded_network)), 0);
            else if (object.encoded_network.length)
                message.encoded_network = object.encoded_network;
        return message;
    };

    EthereumGetAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            object.show_display = false;
            if (options.bytes === String)
                object.encoded_network = "";
            else {
                object.encoded_network = [];
                if (options.bytes !== Array)
                    object.encoded_network = $util.newBuffer(object.encoded_network);
            }
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        if (message.encoded_network != null && message.hasOwnProperty("encoded_network"))
            object.encoded_network = options.bytes === String ? $util.base64.encode(message.encoded_network, 0, message.encoded_network.length) : options.bytes === Array ? Array.prototype.slice.call(message.encoded_network) : message.encoded_network;
        return object;
    };

    EthereumGetAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumGetAddress;
})();

$root.EthereumAddress = (function() {

    function EthereumAddress(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumAddress.prototype._old_address = $util.newBuffer([]);
    EthereumAddress.prototype.address = "";

    EthereumAddress.create = function create(properties) {
        return new EthereumAddress(properties);
    };

    EthereumAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message._old_address != null && Object.hasOwnProperty.call(message, "_old_address"))
            writer.uint32(10).bytes(message._old_address);
        if (message.address != null && Object.hasOwnProperty.call(message, "address"))
            writer.uint32(18).string(message.address);
        return writer;
    };

    EthereumAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message._old_address = reader.bytes();
                break;
            case 2:
                message.address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    EthereumAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message._old_address != null && message.hasOwnProperty("_old_address"))
            if (!(message._old_address && typeof message._old_address.length === "number" || $util.isString(message._old_address)))
                return "_old_address: buffer expected";
        if (message.address != null && message.hasOwnProperty("address"))
            if (!$util.isString(message.address))
                return "address: string expected";
        return null;
    };

    EthereumAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumAddress)
            return object;
        var message = new $root.EthereumAddress();
        if (object._old_address != null)
            if (typeof object._old_address === "string")
                $util.base64.decode(object._old_address, message._old_address = $util.newBuffer($util.base64.length(object._old_address)), 0);
            else if (object._old_address.length)
                message._old_address = object._old_address;
        if (object.address != null)
            message.address = String(object.address);
        return message;
    };

    EthereumAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object._old_address = "";
            else {
                object._old_address = [];
                if (options.bytes !== Array)
                    object._old_address = $util.newBuffer(object._old_address);
            }
            object.address = "";
        }
        if (message._old_address != null && message.hasOwnProperty("_old_address"))
            object._old_address = options.bytes === String ? $util.base64.encode(message._old_address, 0, message._old_address.length) : options.bytes === Array ? Array.prototype.slice.call(message._old_address) : message._old_address;
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    EthereumAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumAddress;
})();

$root.EthereumSignTx = (function() {

    function EthereumSignTx(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumSignTx.prototype.address_n = $util.emptyArray;
    EthereumSignTx.prototype.nonce = $util.newBuffer([]);
    EthereumSignTx.prototype.gas_price = $util.newBuffer([]);
    EthereumSignTx.prototype.gas_limit = $util.newBuffer([]);
    EthereumSignTx.prototype.to = "";
    EthereumSignTx.prototype.value = $util.newBuffer([]);
    EthereumSignTx.prototype.data_initial_chunk = $util.newBuffer([]);
    EthereumSignTx.prototype.data_length = 0;
    EthereumSignTx.prototype.chain_id = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    EthereumSignTx.prototype.tx_type = 0;
    EthereumSignTx.prototype.definitions = null;

    EthereumSignTx.create = function create(properties) {
        return new EthereumSignTx(properties);
    };

    EthereumSignTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.nonce != null && Object.hasOwnProperty.call(message, "nonce"))
            writer.uint32(18).bytes(message.nonce);
        writer.uint32(26).bytes(message.gas_price);
        writer.uint32(34).bytes(message.gas_limit);
        if (message.value != null && Object.hasOwnProperty.call(message, "value"))
            writer.uint32(50).bytes(message.value);
        if (message.data_initial_chunk != null && Object.hasOwnProperty.call(message, "data_initial_chunk"))
            writer.uint32(58).bytes(message.data_initial_chunk);
        if (message.data_length != null && Object.hasOwnProperty.call(message, "data_length"))
            writer.uint32(64).uint32(message.data_length);
        writer.uint32(72).uint64(message.chain_id);
        if (message.tx_type != null && Object.hasOwnProperty.call(message, "tx_type"))
            writer.uint32(80).uint32(message.tx_type);
        if (message.to != null && Object.hasOwnProperty.call(message, "to"))
            writer.uint32(90).string(message.to);
        if (message.definitions != null && Object.hasOwnProperty.call(message, "definitions"))
            $root.EthereumDefinitions.encode(message.definitions, writer.uint32(98).fork()).ldelim();
        return writer;
    };

    EthereumSignTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumSignTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumSignTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.nonce = reader.bytes();
                break;
            case 3:
                message.gas_price = reader.bytes();
                break;
            case 4:
                message.gas_limit = reader.bytes();
                break;
            case 11:
                message.to = reader.string();
                break;
            case 6:
                message.value = reader.bytes();
                break;
            case 7:
                message.data_initial_chunk = reader.bytes();
                break;
            case 8:
                message.data_length = reader.uint32();
                break;
            case 9:
                message.chain_id = reader.uint64();
                break;
            case 10:
                message.tx_type = reader.uint32();
                break;
            case 12:
                message.definitions = $root.EthereumDefinitions.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("gas_price"))
            throw $util.ProtocolError("missing required 'gas_price'", { instance: message });
        if (!message.hasOwnProperty("gas_limit"))
            throw $util.ProtocolError("missing required 'gas_limit'", { instance: message });
        if (!message.hasOwnProperty("chain_id"))
            throw $util.ProtocolError("missing required 'chain_id'", { instance: message });
        return message;
    };

    EthereumSignTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumSignTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.nonce != null && message.hasOwnProperty("nonce"))
            if (!(message.nonce && typeof message.nonce.length === "number" || $util.isString(message.nonce)))
                return "nonce: buffer expected";
        if (!(message.gas_price && typeof message.gas_price.length === "number" || $util.isString(message.gas_price)))
            return "gas_price: buffer expected";
        if (!(message.gas_limit && typeof message.gas_limit.length === "number" || $util.isString(message.gas_limit)))
            return "gas_limit: buffer expected";
        if (message.to != null && message.hasOwnProperty("to"))
            if (!$util.isString(message.to))
                return "to: string expected";
        if (message.value != null && message.hasOwnProperty("value"))
            if (!(message.value && typeof message.value.length === "number" || $util.isString(message.value)))
                return "value: buffer expected";
        if (message.data_initial_chunk != null && message.hasOwnProperty("data_initial_chunk"))
            if (!(message.data_initial_chunk && typeof message.data_initial_chunk.length === "number" || $util.isString(message.data_initial_chunk)))
                return "data_initial_chunk: buffer expected";
        if (message.data_length != null && message.hasOwnProperty("data_length"))
            if (!$util.isInteger(message.data_length))
                return "data_length: integer expected";
        if (!$util.isInteger(message.chain_id) && !(message.chain_id && $util.isInteger(message.chain_id.low) && $util.isInteger(message.chain_id.high)))
            return "chain_id: integer|Long expected";
        if (message.tx_type != null && message.hasOwnProperty("tx_type"))
            if (!$util.isInteger(message.tx_type))
                return "tx_type: integer expected";
        if (message.definitions != null && message.hasOwnProperty("definitions")) {
            var error = $root.EthereumDefinitions.verify(message.definitions);
            if (error)
                return "definitions." + error;
        }
        return null;
    };

    EthereumSignTx.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumSignTx)
            return object;
        var message = new $root.EthereumSignTx();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".EthereumSignTx.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.nonce != null)
            if (typeof object.nonce === "string")
                $util.base64.decode(object.nonce, message.nonce = $util.newBuffer($util.base64.length(object.nonce)), 0);
            else if (object.nonce.length)
                message.nonce = object.nonce;
        if (object.gas_price != null)
            if (typeof object.gas_price === "string")
                $util.base64.decode(object.gas_price, message.gas_price = $util.newBuffer($util.base64.length(object.gas_price)), 0);
            else if (object.gas_price.length)
                message.gas_price = object.gas_price;
        if (object.gas_limit != null)
            if (typeof object.gas_limit === "string")
                $util.base64.decode(object.gas_limit, message.gas_limit = $util.newBuffer($util.base64.length(object.gas_limit)), 0);
            else if (object.gas_limit.length)
                message.gas_limit = object.gas_limit;
        if (object.to != null)
            message.to = String(object.to);
        if (object.value != null)
            if (typeof object.value === "string")
                $util.base64.decode(object.value, message.value = $util.newBuffer($util.base64.length(object.value)), 0);
            else if (object.value.length)
                message.value = object.value;
        if (object.data_initial_chunk != null)
            if (typeof object.data_initial_chunk === "string")
                $util.base64.decode(object.data_initial_chunk, message.data_initial_chunk = $util.newBuffer($util.base64.length(object.data_initial_chunk)), 0);
            else if (object.data_initial_chunk.length)
                message.data_initial_chunk = object.data_initial_chunk;
        if (object.data_length != null)
            message.data_length = object.data_length >>> 0;
        if (object.chain_id != null)
            if ($util.Long)
                (message.chain_id = $util.Long.fromValue(object.chain_id)).unsigned = true;
            else if (typeof object.chain_id === "string")
                message.chain_id = parseInt(object.chain_id, 10);
            else if (typeof object.chain_id === "number")
                message.chain_id = object.chain_id;
            else if (typeof object.chain_id === "object")
                message.chain_id = new $util.LongBits(object.chain_id.low >>> 0, object.chain_id.high >>> 0).toNumber(true);
        if (object.tx_type != null)
            message.tx_type = object.tx_type >>> 0;
        if (object.definitions != null) {
            if (typeof object.definitions !== "object")
                throw TypeError(".EthereumSignTx.definitions: object expected");
            message.definitions = $root.EthereumDefinitions.fromObject(object.definitions);
        }
        return message;
    };

    EthereumSignTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            if (options.bytes === String)
                object.nonce = "";
            else {
                object.nonce = [];
                if (options.bytes !== Array)
                    object.nonce = $util.newBuffer(object.nonce);
            }
            if (options.bytes === String)
                object.gas_price = "";
            else {
                object.gas_price = [];
                if (options.bytes !== Array)
                    object.gas_price = $util.newBuffer(object.gas_price);
            }
            if (options.bytes === String)
                object.gas_limit = "";
            else {
                object.gas_limit = [];
                if (options.bytes !== Array)
                    object.gas_limit = $util.newBuffer(object.gas_limit);
            }
            if (options.bytes === String)
                object.value = "";
            else {
                object.value = [];
                if (options.bytes !== Array)
                    object.value = $util.newBuffer(object.value);
            }
            if (options.bytes === String)
                object.data_initial_chunk = "";
            else {
                object.data_initial_chunk = [];
                if (options.bytes !== Array)
                    object.data_initial_chunk = $util.newBuffer(object.data_initial_chunk);
            }
            object.data_length = 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.chain_id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.chain_id = options.longs === String ? "0" : 0;
            object.tx_type = 0;
            object.to = "";
            object.definitions = null;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.nonce != null && message.hasOwnProperty("nonce"))
            object.nonce = options.bytes === String ? $util.base64.encode(message.nonce, 0, message.nonce.length) : options.bytes === Array ? Array.prototype.slice.call(message.nonce) : message.nonce;
        if (message.gas_price != null && message.hasOwnProperty("gas_price"))
            object.gas_price = options.bytes === String ? $util.base64.encode(message.gas_price, 0, message.gas_price.length) : options.bytes === Array ? Array.prototype.slice.call(message.gas_price) : message.gas_price;
        if (message.gas_limit != null && message.hasOwnProperty("gas_limit"))
            object.gas_limit = options.bytes === String ? $util.base64.encode(message.gas_limit, 0, message.gas_limit.length) : options.bytes === Array ? Array.prototype.slice.call(message.gas_limit) : message.gas_limit;
        if (message.value != null && message.hasOwnProperty("value"))
            object.value = options.bytes === String ? $util.base64.encode(message.value, 0, message.value.length) : options.bytes === Array ? Array.prototype.slice.call(message.value) : message.value;
        if (message.data_initial_chunk != null && message.hasOwnProperty("data_initial_chunk"))
            object.data_initial_chunk = options.bytes === String ? $util.base64.encode(message.data_initial_chunk, 0, message.data_initial_chunk.length) : options.bytes === Array ? Array.prototype.slice.call(message.data_initial_chunk) : message.data_initial_chunk;
        if (message.data_length != null && message.hasOwnProperty("data_length"))
            object.data_length = message.data_length;
        if (message.chain_id != null && message.hasOwnProperty("chain_id"))
            if (typeof message.chain_id === "number")
                object.chain_id = options.longs === String ? String(message.chain_id) : message.chain_id;
            else
                object.chain_id = options.longs === String ? $util.Long.prototype.toString.call(message.chain_id) : options.longs === Number ? new $util.LongBits(message.chain_id.low >>> 0, message.chain_id.high >>> 0).toNumber(true) : message.chain_id;
        if (message.tx_type != null && message.hasOwnProperty("tx_type"))
            object.tx_type = message.tx_type;
        if (message.to != null && message.hasOwnProperty("to"))
            object.to = message.to;
        if (message.definitions != null && message.hasOwnProperty("definitions"))
            object.definitions = $root.EthereumDefinitions.toObject(message.definitions, options);
        return object;
    };

    EthereumSignTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumSignTx;
})();

$root.EthereumSignTxEIP1559 = (function() {

    function EthereumSignTxEIP1559(properties) {
        this.address_n = [];
        this.access_list = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumSignTxEIP1559.prototype.address_n = $util.emptyArray;
    EthereumSignTxEIP1559.prototype.nonce = $util.newBuffer([]);
    EthereumSignTxEIP1559.prototype.max_gas_fee = $util.newBuffer([]);
    EthereumSignTxEIP1559.prototype.max_priority_fee = $util.newBuffer([]);
    EthereumSignTxEIP1559.prototype.gas_limit = $util.newBuffer([]);
    EthereumSignTxEIP1559.prototype.to = "";
    EthereumSignTxEIP1559.prototype.value = $util.newBuffer([]);
    EthereumSignTxEIP1559.prototype.data_initial_chunk = $util.newBuffer([]);
    EthereumSignTxEIP1559.prototype.data_length = 0;
    EthereumSignTxEIP1559.prototype.chain_id = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    EthereumSignTxEIP1559.prototype.access_list = $util.emptyArray;
    EthereumSignTxEIP1559.prototype.definitions = null;

    EthereumSignTxEIP1559.create = function create(properties) {
        return new EthereumSignTxEIP1559(properties);
    };

    EthereumSignTxEIP1559.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).bytes(message.nonce);
        writer.uint32(26).bytes(message.max_gas_fee);
        writer.uint32(34).bytes(message.max_priority_fee);
        writer.uint32(42).bytes(message.gas_limit);
        if (message.to != null && Object.hasOwnProperty.call(message, "to"))
            writer.uint32(50).string(message.to);
        writer.uint32(58).bytes(message.value);
        if (message.data_initial_chunk != null && Object.hasOwnProperty.call(message, "data_initial_chunk"))
            writer.uint32(66).bytes(message.data_initial_chunk);
        writer.uint32(72).uint32(message.data_length);
        writer.uint32(80).uint64(message.chain_id);
        if (message.access_list != null && message.access_list.length)
            for (var i = 0; i < message.access_list.length; ++i)
                $root.EthereumSignTxEIP1559.EthereumAccessList.encode(message.access_list[i], writer.uint32(90).fork()).ldelim();
        if (message.definitions != null && Object.hasOwnProperty.call(message, "definitions"))
            $root.EthereumDefinitions.encode(message.definitions, writer.uint32(98).fork()).ldelim();
        return writer;
    };

    EthereumSignTxEIP1559.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumSignTxEIP1559.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumSignTxEIP1559();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.nonce = reader.bytes();
                break;
            case 3:
                message.max_gas_fee = reader.bytes();
                break;
            case 4:
                message.max_priority_fee = reader.bytes();
                break;
            case 5:
                message.gas_limit = reader.bytes();
                break;
            case 6:
                message.to = reader.string();
                break;
            case 7:
                message.value = reader.bytes();
                break;
            case 8:
                message.data_initial_chunk = reader.bytes();
                break;
            case 9:
                message.data_length = reader.uint32();
                break;
            case 10:
                message.chain_id = reader.uint64();
                break;
            case 11:
                if (!(message.access_list && message.access_list.length))
                    message.access_list = [];
                message.access_list.push($root.EthereumSignTxEIP1559.EthereumAccessList.decode(reader, reader.uint32()));
                break;
            case 12:
                message.definitions = $root.EthereumDefinitions.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("nonce"))
            throw $util.ProtocolError("missing required 'nonce'", { instance: message });
        if (!message.hasOwnProperty("max_gas_fee"))
            throw $util.ProtocolError("missing required 'max_gas_fee'", { instance: message });
        if (!message.hasOwnProperty("max_priority_fee"))
            throw $util.ProtocolError("missing required 'max_priority_fee'", { instance: message });
        if (!message.hasOwnProperty("gas_limit"))
            throw $util.ProtocolError("missing required 'gas_limit'", { instance: message });
        if (!message.hasOwnProperty("value"))
            throw $util.ProtocolError("missing required 'value'", { instance: message });
        if (!message.hasOwnProperty("data_length"))
            throw $util.ProtocolError("missing required 'data_length'", { instance: message });
        if (!message.hasOwnProperty("chain_id"))
            throw $util.ProtocolError("missing required 'chain_id'", { instance: message });
        return message;
    };

    EthereumSignTxEIP1559.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumSignTxEIP1559.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!(message.nonce && typeof message.nonce.length === "number" || $util.isString(message.nonce)))
            return "nonce: buffer expected";
        if (!(message.max_gas_fee && typeof message.max_gas_fee.length === "number" || $util.isString(message.max_gas_fee)))
            return "max_gas_fee: buffer expected";
        if (!(message.max_priority_fee && typeof message.max_priority_fee.length === "number" || $util.isString(message.max_priority_fee)))
            return "max_priority_fee: buffer expected";
        if (!(message.gas_limit && typeof message.gas_limit.length === "number" || $util.isString(message.gas_limit)))
            return "gas_limit: buffer expected";
        if (message.to != null && message.hasOwnProperty("to"))
            if (!$util.isString(message.to))
                return "to: string expected";
        if (!(message.value && typeof message.value.length === "number" || $util.isString(message.value)))
            return "value: buffer expected";
        if (message.data_initial_chunk != null && message.hasOwnProperty("data_initial_chunk"))
            if (!(message.data_initial_chunk && typeof message.data_initial_chunk.length === "number" || $util.isString(message.data_initial_chunk)))
                return "data_initial_chunk: buffer expected";
        if (!$util.isInteger(message.data_length))
            return "data_length: integer expected";
        if (!$util.isInteger(message.chain_id) && !(message.chain_id && $util.isInteger(message.chain_id.low) && $util.isInteger(message.chain_id.high)))
            return "chain_id: integer|Long expected";
        if (message.access_list != null && message.hasOwnProperty("access_list")) {
            if (!Array.isArray(message.access_list))
                return "access_list: array expected";
            for (var i = 0; i < message.access_list.length; ++i) {
                var error = $root.EthereumSignTxEIP1559.EthereumAccessList.verify(message.access_list[i]);
                if (error)
                    return "access_list." + error;
            }
        }
        if (message.definitions != null && message.hasOwnProperty("definitions")) {
            var error = $root.EthereumDefinitions.verify(message.definitions);
            if (error)
                return "definitions." + error;
        }
        return null;
    };

    EthereumSignTxEIP1559.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumSignTxEIP1559)
            return object;
        var message = new $root.EthereumSignTxEIP1559();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".EthereumSignTxEIP1559.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.nonce != null)
            if (typeof object.nonce === "string")
                $util.base64.decode(object.nonce, message.nonce = $util.newBuffer($util.base64.length(object.nonce)), 0);
            else if (object.nonce.length)
                message.nonce = object.nonce;
        if (object.max_gas_fee != null)
            if (typeof object.max_gas_fee === "string")
                $util.base64.decode(object.max_gas_fee, message.max_gas_fee = $util.newBuffer($util.base64.length(object.max_gas_fee)), 0);
            else if (object.max_gas_fee.length)
                message.max_gas_fee = object.max_gas_fee;
        if (object.max_priority_fee != null)
            if (typeof object.max_priority_fee === "string")
                $util.base64.decode(object.max_priority_fee, message.max_priority_fee = $util.newBuffer($util.base64.length(object.max_priority_fee)), 0);
            else if (object.max_priority_fee.length)
                message.max_priority_fee = object.max_priority_fee;
        if (object.gas_limit != null)
            if (typeof object.gas_limit === "string")
                $util.base64.decode(object.gas_limit, message.gas_limit = $util.newBuffer($util.base64.length(object.gas_limit)), 0);
            else if (object.gas_limit.length)
                message.gas_limit = object.gas_limit;
        if (object.to != null)
            message.to = String(object.to);
        if (object.value != null)
            if (typeof object.value === "string")
                $util.base64.decode(object.value, message.value = $util.newBuffer($util.base64.length(object.value)), 0);
            else if (object.value.length)
                message.value = object.value;
        if (object.data_initial_chunk != null)
            if (typeof object.data_initial_chunk === "string")
                $util.base64.decode(object.data_initial_chunk, message.data_initial_chunk = $util.newBuffer($util.base64.length(object.data_initial_chunk)), 0);
            else if (object.data_initial_chunk.length)
                message.data_initial_chunk = object.data_initial_chunk;
        if (object.data_length != null)
            message.data_length = object.data_length >>> 0;
        if (object.chain_id != null)
            if ($util.Long)
                (message.chain_id = $util.Long.fromValue(object.chain_id)).unsigned = true;
            else if (typeof object.chain_id === "string")
                message.chain_id = parseInt(object.chain_id, 10);
            else if (typeof object.chain_id === "number")
                message.chain_id = object.chain_id;
            else if (typeof object.chain_id === "object")
                message.chain_id = new $util.LongBits(object.chain_id.low >>> 0, object.chain_id.high >>> 0).toNumber(true);
        if (object.access_list) {
            if (!Array.isArray(object.access_list))
                throw TypeError(".EthereumSignTxEIP1559.access_list: array expected");
            message.access_list = [];
            for (var i = 0; i < object.access_list.length; ++i) {
                if (typeof object.access_list[i] !== "object")
                    throw TypeError(".EthereumSignTxEIP1559.access_list: object expected");
                message.access_list[i] = $root.EthereumSignTxEIP1559.EthereumAccessList.fromObject(object.access_list[i]);
            }
        }
        if (object.definitions != null) {
            if (typeof object.definitions !== "object")
                throw TypeError(".EthereumSignTxEIP1559.definitions: object expected");
            message.definitions = $root.EthereumDefinitions.fromObject(object.definitions);
        }
        return message;
    };

    EthereumSignTxEIP1559.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults) {
            object.address_n = [];
            object.access_list = [];
        }
        if (options.defaults) {
            if (options.bytes === String)
                object.nonce = "";
            else {
                object.nonce = [];
                if (options.bytes !== Array)
                    object.nonce = $util.newBuffer(object.nonce);
            }
            if (options.bytes === String)
                object.max_gas_fee = "";
            else {
                object.max_gas_fee = [];
                if (options.bytes !== Array)
                    object.max_gas_fee = $util.newBuffer(object.max_gas_fee);
            }
            if (options.bytes === String)
                object.max_priority_fee = "";
            else {
                object.max_priority_fee = [];
                if (options.bytes !== Array)
                    object.max_priority_fee = $util.newBuffer(object.max_priority_fee);
            }
            if (options.bytes === String)
                object.gas_limit = "";
            else {
                object.gas_limit = [];
                if (options.bytes !== Array)
                    object.gas_limit = $util.newBuffer(object.gas_limit);
            }
            object.to = "";
            if (options.bytes === String)
                object.value = "";
            else {
                object.value = [];
                if (options.bytes !== Array)
                    object.value = $util.newBuffer(object.value);
            }
            if (options.bytes === String)
                object.data_initial_chunk = "";
            else {
                object.data_initial_chunk = [];
                if (options.bytes !== Array)
                    object.data_initial_chunk = $util.newBuffer(object.data_initial_chunk);
            }
            object.data_length = 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.chain_id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.chain_id = options.longs === String ? "0" : 0;
            object.definitions = null;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.nonce != null && message.hasOwnProperty("nonce"))
            object.nonce = options.bytes === String ? $util.base64.encode(message.nonce, 0, message.nonce.length) : options.bytes === Array ? Array.prototype.slice.call(message.nonce) : message.nonce;
        if (message.max_gas_fee != null && message.hasOwnProperty("max_gas_fee"))
            object.max_gas_fee = options.bytes === String ? $util.base64.encode(message.max_gas_fee, 0, message.max_gas_fee.length) : options.bytes === Array ? Array.prototype.slice.call(message.max_gas_fee) : message.max_gas_fee;
        if (message.max_priority_fee != null && message.hasOwnProperty("max_priority_fee"))
            object.max_priority_fee = options.bytes === String ? $util.base64.encode(message.max_priority_fee, 0, message.max_priority_fee.length) : options.bytes === Array ? Array.prototype.slice.call(message.max_priority_fee) : message.max_priority_fee;
        if (message.gas_limit != null && message.hasOwnProperty("gas_limit"))
            object.gas_limit = options.bytes === String ? $util.base64.encode(message.gas_limit, 0, message.gas_limit.length) : options.bytes === Array ? Array.prototype.slice.call(message.gas_limit) : message.gas_limit;
        if (message.to != null && message.hasOwnProperty("to"))
            object.to = message.to;
        if (message.value != null && message.hasOwnProperty("value"))
            object.value = options.bytes === String ? $util.base64.encode(message.value, 0, message.value.length) : options.bytes === Array ? Array.prototype.slice.call(message.value) : message.value;
        if (message.data_initial_chunk != null && message.hasOwnProperty("data_initial_chunk"))
            object.data_initial_chunk = options.bytes === String ? $util.base64.encode(message.data_initial_chunk, 0, message.data_initial_chunk.length) : options.bytes === Array ? Array.prototype.slice.call(message.data_initial_chunk) : message.data_initial_chunk;
        if (message.data_length != null && message.hasOwnProperty("data_length"))
            object.data_length = message.data_length;
        if (message.chain_id != null && message.hasOwnProperty("chain_id"))
            if (typeof message.chain_id === "number")
                object.chain_id = options.longs === String ? String(message.chain_id) : message.chain_id;
            else
                object.chain_id = options.longs === String ? $util.Long.prototype.toString.call(message.chain_id) : options.longs === Number ? new $util.LongBits(message.chain_id.low >>> 0, message.chain_id.high >>> 0).toNumber(true) : message.chain_id;
        if (message.access_list && message.access_list.length) {
            object.access_list = [];
            for (var j = 0; j < message.access_list.length; ++j)
                object.access_list[j] = $root.EthereumSignTxEIP1559.EthereumAccessList.toObject(message.access_list[j], options);
        }
        if (message.definitions != null && message.hasOwnProperty("definitions"))
            object.definitions = $root.EthereumDefinitions.toObject(message.definitions, options);
        return object;
    };

    EthereumSignTxEIP1559.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    EthereumSignTxEIP1559.EthereumAccessList = (function() {

        function EthereumAccessList(properties) {
            this.storage_keys = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        EthereumAccessList.prototype.address = "";
        EthereumAccessList.prototype.storage_keys = $util.emptyArray;

        EthereumAccessList.create = function create(properties) {
            return new EthereumAccessList(properties);
        };

        EthereumAccessList.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(10).string(message.address);
            if (message.storage_keys != null && message.storage_keys.length)
                for (var i = 0; i < message.storage_keys.length; ++i)
                    writer.uint32(18).bytes(message.storage_keys[i]);
            return writer;
        };

        EthereumAccessList.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        EthereumAccessList.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumSignTxEIP1559.EthereumAccessList();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    if (!(message.storage_keys && message.storage_keys.length))
                        message.storage_keys = [];
                    message.storage_keys.push(reader.bytes());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("address"))
                throw $util.ProtocolError("missing required 'address'", { instance: message });
            return message;
        };

        EthereumAccessList.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        EthereumAccessList.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isString(message.address))
                return "address: string expected";
            if (message.storage_keys != null && message.hasOwnProperty("storage_keys")) {
                if (!Array.isArray(message.storage_keys))
                    return "storage_keys: array expected";
                for (var i = 0; i < message.storage_keys.length; ++i)
                    if (!(message.storage_keys[i] && typeof message.storage_keys[i].length === "number" || $util.isString(message.storage_keys[i])))
                        return "storage_keys: buffer[] expected";
            }
            return null;
        };

        EthereumAccessList.fromObject = function fromObject(object) {
            if (object instanceof $root.EthereumSignTxEIP1559.EthereumAccessList)
                return object;
            var message = new $root.EthereumSignTxEIP1559.EthereumAccessList();
            if (object.address != null)
                message.address = String(object.address);
            if (object.storage_keys) {
                if (!Array.isArray(object.storage_keys))
                    throw TypeError(".EthereumSignTxEIP1559.EthereumAccessList.storage_keys: array expected");
                message.storage_keys = [];
                for (var i = 0; i < object.storage_keys.length; ++i)
                    if (typeof object.storage_keys[i] === "string")
                        $util.base64.decode(object.storage_keys[i], message.storage_keys[i] = $util.newBuffer($util.base64.length(object.storage_keys[i])), 0);
                    else if (object.storage_keys[i].length)
                        message.storage_keys[i] = object.storage_keys[i];
            }
            return message;
        };

        EthereumAccessList.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.storage_keys = [];
            if (options.defaults)
                object.address = "";
            if (message.address != null && message.hasOwnProperty("address"))
                object.address = message.address;
            if (message.storage_keys && message.storage_keys.length) {
                object.storage_keys = [];
                for (var j = 0; j < message.storage_keys.length; ++j)
                    object.storage_keys[j] = options.bytes === String ? $util.base64.encode(message.storage_keys[j], 0, message.storage_keys[j].length) : options.bytes === Array ? Array.prototype.slice.call(message.storage_keys[j]) : message.storage_keys[j];
            }
            return object;
        };

        EthereumAccessList.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EthereumAccessList;
    })();

    return EthereumSignTxEIP1559;
})();

$root.EthereumTxRequest = (function() {

    function EthereumTxRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumTxRequest.prototype.data_length = 0;
    EthereumTxRequest.prototype.signature_v = 0;
    EthereumTxRequest.prototype.signature_r = $util.newBuffer([]);
    EthereumTxRequest.prototype.signature_s = $util.newBuffer([]);

    EthereumTxRequest.create = function create(properties) {
        return new EthereumTxRequest(properties);
    };

    EthereumTxRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.data_length != null && Object.hasOwnProperty.call(message, "data_length"))
            writer.uint32(8).uint32(message.data_length);
        if (message.signature_v != null && Object.hasOwnProperty.call(message, "signature_v"))
            writer.uint32(16).uint32(message.signature_v);
        if (message.signature_r != null && Object.hasOwnProperty.call(message, "signature_r"))
            writer.uint32(26).bytes(message.signature_r);
        if (message.signature_s != null && Object.hasOwnProperty.call(message, "signature_s"))
            writer.uint32(34).bytes(message.signature_s);
        return writer;
    };

    EthereumTxRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumTxRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumTxRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.data_length = reader.uint32();
                break;
            case 2:
                message.signature_v = reader.uint32();
                break;
            case 3:
                message.signature_r = reader.bytes();
                break;
            case 4:
                message.signature_s = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    EthereumTxRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumTxRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.data_length != null && message.hasOwnProperty("data_length"))
            if (!$util.isInteger(message.data_length))
                return "data_length: integer expected";
        if (message.signature_v != null && message.hasOwnProperty("signature_v"))
            if (!$util.isInteger(message.signature_v))
                return "signature_v: integer expected";
        if (message.signature_r != null && message.hasOwnProperty("signature_r"))
            if (!(message.signature_r && typeof message.signature_r.length === "number" || $util.isString(message.signature_r)))
                return "signature_r: buffer expected";
        if (message.signature_s != null && message.hasOwnProperty("signature_s"))
            if (!(message.signature_s && typeof message.signature_s.length === "number" || $util.isString(message.signature_s)))
                return "signature_s: buffer expected";
        return null;
    };

    EthereumTxRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumTxRequest)
            return object;
        var message = new $root.EthereumTxRequest();
        if (object.data_length != null)
            message.data_length = object.data_length >>> 0;
        if (object.signature_v != null)
            message.signature_v = object.signature_v >>> 0;
        if (object.signature_r != null)
            if (typeof object.signature_r === "string")
                $util.base64.decode(object.signature_r, message.signature_r = $util.newBuffer($util.base64.length(object.signature_r)), 0);
            else if (object.signature_r.length)
                message.signature_r = object.signature_r;
        if (object.signature_s != null)
            if (typeof object.signature_s === "string")
                $util.base64.decode(object.signature_s, message.signature_s = $util.newBuffer($util.base64.length(object.signature_s)), 0);
            else if (object.signature_s.length)
                message.signature_s = object.signature_s;
        return message;
    };

    EthereumTxRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.data_length = 0;
            object.signature_v = 0;
            if (options.bytes === String)
                object.signature_r = "";
            else {
                object.signature_r = [];
                if (options.bytes !== Array)
                    object.signature_r = $util.newBuffer(object.signature_r);
            }
            if (options.bytes === String)
                object.signature_s = "";
            else {
                object.signature_s = [];
                if (options.bytes !== Array)
                    object.signature_s = $util.newBuffer(object.signature_s);
            }
        }
        if (message.data_length != null && message.hasOwnProperty("data_length"))
            object.data_length = message.data_length;
        if (message.signature_v != null && message.hasOwnProperty("signature_v"))
            object.signature_v = message.signature_v;
        if (message.signature_r != null && message.hasOwnProperty("signature_r"))
            object.signature_r = options.bytes === String ? $util.base64.encode(message.signature_r, 0, message.signature_r.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature_r) : message.signature_r;
        if (message.signature_s != null && message.hasOwnProperty("signature_s"))
            object.signature_s = options.bytes === String ? $util.base64.encode(message.signature_s, 0, message.signature_s.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature_s) : message.signature_s;
        return object;
    };

    EthereumTxRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumTxRequest;
})();

$root.EthereumTxAck = (function() {

    function EthereumTxAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumTxAck.prototype.data_chunk = $util.newBuffer([]);

    EthereumTxAck.create = function create(properties) {
        return new EthereumTxAck(properties);
    };

    EthereumTxAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.data_chunk);
        return writer;
    };

    EthereumTxAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumTxAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumTxAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.data_chunk = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("data_chunk"))
            throw $util.ProtocolError("missing required 'data_chunk'", { instance: message });
        return message;
    };

    EthereumTxAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumTxAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.data_chunk && typeof message.data_chunk.length === "number" || $util.isString(message.data_chunk)))
            return "data_chunk: buffer expected";
        return null;
    };

    EthereumTxAck.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumTxAck)
            return object;
        var message = new $root.EthereumTxAck();
        if (object.data_chunk != null)
            if (typeof object.data_chunk === "string")
                $util.base64.decode(object.data_chunk, message.data_chunk = $util.newBuffer($util.base64.length(object.data_chunk)), 0);
            else if (object.data_chunk.length)
                message.data_chunk = object.data_chunk;
        return message;
    };

    EthereumTxAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.data_chunk = "";
            else {
                object.data_chunk = [];
                if (options.bytes !== Array)
                    object.data_chunk = $util.newBuffer(object.data_chunk);
            }
        if (message.data_chunk != null && message.hasOwnProperty("data_chunk"))
            object.data_chunk = options.bytes === String ? $util.base64.encode(message.data_chunk, 0, message.data_chunk.length) : options.bytes === Array ? Array.prototype.slice.call(message.data_chunk) : message.data_chunk;
        return object;
    };

    EthereumTxAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumTxAck;
})();

$root.EthereumSignMessage = (function() {

    function EthereumSignMessage(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumSignMessage.prototype.address_n = $util.emptyArray;
    EthereumSignMessage.prototype.message = $util.newBuffer([]);
    EthereumSignMessage.prototype.encoded_network = $util.newBuffer([]);

    EthereumSignMessage.create = function create(properties) {
        return new EthereumSignMessage(properties);
    };

    EthereumSignMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).bytes(message.message);
        if (message.encoded_network != null && Object.hasOwnProperty.call(message, "encoded_network"))
            writer.uint32(26).bytes(message.encoded_network);
        return writer;
    };

    EthereumSignMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumSignMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumSignMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.message = reader.bytes();
                break;
            case 3:
                message.encoded_network = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("message"))
            throw $util.ProtocolError("missing required 'message'", { instance: message });
        return message;
    };

    EthereumSignMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumSignMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!(message.message && typeof message.message.length === "number" || $util.isString(message.message)))
            return "message: buffer expected";
        if (message.encoded_network != null && message.hasOwnProperty("encoded_network"))
            if (!(message.encoded_network && typeof message.encoded_network.length === "number" || $util.isString(message.encoded_network)))
                return "encoded_network: buffer expected";
        return null;
    };

    EthereumSignMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumSignMessage)
            return object;
        var message = new $root.EthereumSignMessage();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".EthereumSignMessage.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.message != null)
            if (typeof object.message === "string")
                $util.base64.decode(object.message, message.message = $util.newBuffer($util.base64.length(object.message)), 0);
            else if (object.message.length)
                message.message = object.message;
        if (object.encoded_network != null)
            if (typeof object.encoded_network === "string")
                $util.base64.decode(object.encoded_network, message.encoded_network = $util.newBuffer($util.base64.length(object.encoded_network)), 0);
            else if (object.encoded_network.length)
                message.encoded_network = object.encoded_network;
        return message;
    };

    EthereumSignMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            if (options.bytes === String)
                object.message = "";
            else {
                object.message = [];
                if (options.bytes !== Array)
                    object.message = $util.newBuffer(object.message);
            }
            if (options.bytes === String)
                object.encoded_network = "";
            else {
                object.encoded_network = [];
                if (options.bytes !== Array)
                    object.encoded_network = $util.newBuffer(object.encoded_network);
            }
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.message != null && message.hasOwnProperty("message"))
            object.message = options.bytes === String ? $util.base64.encode(message.message, 0, message.message.length) : options.bytes === Array ? Array.prototype.slice.call(message.message) : message.message;
        if (message.encoded_network != null && message.hasOwnProperty("encoded_network"))
            object.encoded_network = options.bytes === String ? $util.base64.encode(message.encoded_network, 0, message.encoded_network.length) : options.bytes === Array ? Array.prototype.slice.call(message.encoded_network) : message.encoded_network;
        return object;
    };

    EthereumSignMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumSignMessage;
})();

$root.EthereumMessageSignature = (function() {

    function EthereumMessageSignature(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumMessageSignature.prototype.signature = $util.newBuffer([]);
    EthereumMessageSignature.prototype.address = "";

    EthereumMessageSignature.create = function create(properties) {
        return new EthereumMessageSignature(properties);
    };

    EthereumMessageSignature.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(18).bytes(message.signature);
        writer.uint32(26).string(message.address);
        return writer;
    };

    EthereumMessageSignature.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumMessageSignature.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumMessageSignature();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 2:
                message.signature = reader.bytes();
                break;
            case 3:
                message.address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        if (!message.hasOwnProperty("address"))
            throw $util.ProtocolError("missing required 'address'", { instance: message });
        return message;
    };

    EthereumMessageSignature.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumMessageSignature.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        if (!$util.isString(message.address))
            return "address: string expected";
        return null;
    };

    EthereumMessageSignature.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumMessageSignature)
            return object;
        var message = new $root.EthereumMessageSignature();
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        if (object.address != null)
            message.address = String(object.address);
        return message;
    };

    EthereumMessageSignature.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
            object.address = "";
        }
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    EthereumMessageSignature.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumMessageSignature;
})();

$root.EthereumVerifyMessage = (function() {

    function EthereumVerifyMessage(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumVerifyMessage.prototype.signature = $util.newBuffer([]);
    EthereumVerifyMessage.prototype.message = $util.newBuffer([]);
    EthereumVerifyMessage.prototype.address = "";

    EthereumVerifyMessage.create = function create(properties) {
        return new EthereumVerifyMessage(properties);
    };

    EthereumVerifyMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(18).bytes(message.signature);
        writer.uint32(26).bytes(message.message);
        writer.uint32(34).string(message.address);
        return writer;
    };

    EthereumVerifyMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumVerifyMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumVerifyMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 2:
                message.signature = reader.bytes();
                break;
            case 3:
                message.message = reader.bytes();
                break;
            case 4:
                message.address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        if (!message.hasOwnProperty("message"))
            throw $util.ProtocolError("missing required 'message'", { instance: message });
        if (!message.hasOwnProperty("address"))
            throw $util.ProtocolError("missing required 'address'", { instance: message });
        return message;
    };

    EthereumVerifyMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumVerifyMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        if (!(message.message && typeof message.message.length === "number" || $util.isString(message.message)))
            return "message: buffer expected";
        if (!$util.isString(message.address))
            return "address: string expected";
        return null;
    };

    EthereumVerifyMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumVerifyMessage)
            return object;
        var message = new $root.EthereumVerifyMessage();
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        if (object.message != null)
            if (typeof object.message === "string")
                $util.base64.decode(object.message, message.message = $util.newBuffer($util.base64.length(object.message)), 0);
            else if (object.message.length)
                message.message = object.message;
        if (object.address != null)
            message.address = String(object.address);
        return message;
    };

    EthereumVerifyMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
            if (options.bytes === String)
                object.message = "";
            else {
                object.message = [];
                if (options.bytes !== Array)
                    object.message = $util.newBuffer(object.message);
            }
            object.address = "";
        }
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        if (message.message != null && message.hasOwnProperty("message"))
            object.message = options.bytes === String ? $util.base64.encode(message.message, 0, message.message.length) : options.bytes === Array ? Array.prototype.slice.call(message.message) : message.message;
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    EthereumVerifyMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumVerifyMessage;
})();

$root.EthereumSignTypedHash = (function() {

    function EthereumSignTypedHash(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumSignTypedHash.prototype.address_n = $util.emptyArray;
    EthereumSignTypedHash.prototype.domain_separator_hash = $util.newBuffer([]);
    EthereumSignTypedHash.prototype.message_hash = $util.newBuffer([]);
    EthereumSignTypedHash.prototype.encoded_network = $util.newBuffer([]);

    EthereumSignTypedHash.create = function create(properties) {
        return new EthereumSignTypedHash(properties);
    };

    EthereumSignTypedHash.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).bytes(message.domain_separator_hash);
        if (message.message_hash != null && Object.hasOwnProperty.call(message, "message_hash"))
            writer.uint32(26).bytes(message.message_hash);
        if (message.encoded_network != null && Object.hasOwnProperty.call(message, "encoded_network"))
            writer.uint32(34).bytes(message.encoded_network);
        return writer;
    };

    EthereumSignTypedHash.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumSignTypedHash.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumSignTypedHash();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.domain_separator_hash = reader.bytes();
                break;
            case 3:
                message.message_hash = reader.bytes();
                break;
            case 4:
                message.encoded_network = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("domain_separator_hash"))
            throw $util.ProtocolError("missing required 'domain_separator_hash'", { instance: message });
        return message;
    };

    EthereumSignTypedHash.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumSignTypedHash.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!(message.domain_separator_hash && typeof message.domain_separator_hash.length === "number" || $util.isString(message.domain_separator_hash)))
            return "domain_separator_hash: buffer expected";
        if (message.message_hash != null && message.hasOwnProperty("message_hash"))
            if (!(message.message_hash && typeof message.message_hash.length === "number" || $util.isString(message.message_hash)))
                return "message_hash: buffer expected";
        if (message.encoded_network != null && message.hasOwnProperty("encoded_network"))
            if (!(message.encoded_network && typeof message.encoded_network.length === "number" || $util.isString(message.encoded_network)))
                return "encoded_network: buffer expected";
        return null;
    };

    EthereumSignTypedHash.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumSignTypedHash)
            return object;
        var message = new $root.EthereumSignTypedHash();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".EthereumSignTypedHash.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.domain_separator_hash != null)
            if (typeof object.domain_separator_hash === "string")
                $util.base64.decode(object.domain_separator_hash, message.domain_separator_hash = $util.newBuffer($util.base64.length(object.domain_separator_hash)), 0);
            else if (object.domain_separator_hash.length)
                message.domain_separator_hash = object.domain_separator_hash;
        if (object.message_hash != null)
            if (typeof object.message_hash === "string")
                $util.base64.decode(object.message_hash, message.message_hash = $util.newBuffer($util.base64.length(object.message_hash)), 0);
            else if (object.message_hash.length)
                message.message_hash = object.message_hash;
        if (object.encoded_network != null)
            if (typeof object.encoded_network === "string")
                $util.base64.decode(object.encoded_network, message.encoded_network = $util.newBuffer($util.base64.length(object.encoded_network)), 0);
            else if (object.encoded_network.length)
                message.encoded_network = object.encoded_network;
        return message;
    };

    EthereumSignTypedHash.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            if (options.bytes === String)
                object.domain_separator_hash = "";
            else {
                object.domain_separator_hash = [];
                if (options.bytes !== Array)
                    object.domain_separator_hash = $util.newBuffer(object.domain_separator_hash);
            }
            if (options.bytes === String)
                object.message_hash = "";
            else {
                object.message_hash = [];
                if (options.bytes !== Array)
                    object.message_hash = $util.newBuffer(object.message_hash);
            }
            if (options.bytes === String)
                object.encoded_network = "";
            else {
                object.encoded_network = [];
                if (options.bytes !== Array)
                    object.encoded_network = $util.newBuffer(object.encoded_network);
            }
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.domain_separator_hash != null && message.hasOwnProperty("domain_separator_hash"))
            object.domain_separator_hash = options.bytes === String ? $util.base64.encode(message.domain_separator_hash, 0, message.domain_separator_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.domain_separator_hash) : message.domain_separator_hash;
        if (message.message_hash != null && message.hasOwnProperty("message_hash"))
            object.message_hash = options.bytes === String ? $util.base64.encode(message.message_hash, 0, message.message_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.message_hash) : message.message_hash;
        if (message.encoded_network != null && message.hasOwnProperty("encoded_network"))
            object.encoded_network = options.bytes === String ? $util.base64.encode(message.encoded_network, 0, message.encoded_network.length) : options.bytes === Array ? Array.prototype.slice.call(message.encoded_network) : message.encoded_network;
        return object;
    };

    EthereumSignTypedHash.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumSignTypedHash;
})();

$root.EthereumTypedDataSignature = (function() {

    function EthereumTypedDataSignature(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EthereumTypedDataSignature.prototype.signature = $util.newBuffer([]);
    EthereumTypedDataSignature.prototype.address = "";

    EthereumTypedDataSignature.create = function create(properties) {
        return new EthereumTypedDataSignature(properties);
    };

    EthereumTypedDataSignature.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.signature);
        writer.uint32(18).string(message.address);
        return writer;
    };

    EthereumTypedDataSignature.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EthereumTypedDataSignature.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EthereumTypedDataSignature();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.signature = reader.bytes();
                break;
            case 2:
                message.address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        if (!message.hasOwnProperty("address"))
            throw $util.ProtocolError("missing required 'address'", { instance: message });
        return message;
    };

    EthereumTypedDataSignature.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EthereumTypedDataSignature.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        if (!$util.isString(message.address))
            return "address: string expected";
        return null;
    };

    EthereumTypedDataSignature.fromObject = function fromObject(object) {
        if (object instanceof $root.EthereumTypedDataSignature)
            return object;
        var message = new $root.EthereumTypedDataSignature();
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        if (object.address != null)
            message.address = String(object.address);
        return message;
    };

    EthereumTypedDataSignature.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
            object.address = "";
        }
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    EthereumTypedDataSignature.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EthereumTypedDataSignature;
})();

$root.FilecoinGetAddress = (function() {

    function FilecoinGetAddress(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    FilecoinGetAddress.prototype.address_n = $util.emptyArray;
    FilecoinGetAddress.prototype.show_display = false;
    FilecoinGetAddress.prototype.testnet = false;

    FilecoinGetAddress.create = function create(properties) {
        return new FilecoinGetAddress(properties);
    };

    FilecoinGetAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(16).bool(message.show_display);
        if (message.testnet != null && Object.hasOwnProperty.call(message, "testnet"))
            writer.uint32(24).bool(message.testnet);
        return writer;
    };

    FilecoinGetAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    FilecoinGetAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.FilecoinGetAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.show_display = reader.bool();
                break;
            case 3:
                message.testnet = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    FilecoinGetAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    FilecoinGetAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        if (message.testnet != null && message.hasOwnProperty("testnet"))
            if (typeof message.testnet !== "boolean")
                return "testnet: boolean expected";
        return null;
    };

    FilecoinGetAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.FilecoinGetAddress)
            return object;
        var message = new $root.FilecoinGetAddress();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".FilecoinGetAddress.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        if (object.testnet != null)
            message.testnet = Boolean(object.testnet);
        return message;
    };

    FilecoinGetAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            object.show_display = false;
            object.testnet = false;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        if (message.testnet != null && message.hasOwnProperty("testnet"))
            object.testnet = message.testnet;
        return object;
    };

    FilecoinGetAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return FilecoinGetAddress;
})();

$root.FilecoinAddress = (function() {

    function FilecoinAddress(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    FilecoinAddress.prototype.address = "";

    FilecoinAddress.create = function create(properties) {
        return new FilecoinAddress(properties);
    };

    FilecoinAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address != null && Object.hasOwnProperty.call(message, "address"))
            writer.uint32(10).string(message.address);
        return writer;
    };

    FilecoinAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    FilecoinAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.FilecoinAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    FilecoinAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    FilecoinAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address != null && message.hasOwnProperty("address"))
            if (!$util.isString(message.address))
                return "address: string expected";
        return null;
    };

    FilecoinAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.FilecoinAddress)
            return object;
        var message = new $root.FilecoinAddress();
        if (object.address != null)
            message.address = String(object.address);
        return message;
    };

    FilecoinAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.address = "";
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    FilecoinAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return FilecoinAddress;
})();

$root.FilecoinSignTx = (function() {

    function FilecoinSignTx(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    FilecoinSignTx.prototype.address_n = $util.emptyArray;
    FilecoinSignTx.prototype.raw_tx = $util.newBuffer([]);
    FilecoinSignTx.prototype.testnet = false;

    FilecoinSignTx.create = function create(properties) {
        return new FilecoinSignTx(properties);
    };

    FilecoinSignTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).bytes(message.raw_tx);
        if (message.testnet != null && Object.hasOwnProperty.call(message, "testnet"))
            writer.uint32(24).bool(message.testnet);
        return writer;
    };

    FilecoinSignTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    FilecoinSignTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.FilecoinSignTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.raw_tx = reader.bytes();
                break;
            case 3:
                message.testnet = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("raw_tx"))
            throw $util.ProtocolError("missing required 'raw_tx'", { instance: message });
        return message;
    };

    FilecoinSignTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    FilecoinSignTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!(message.raw_tx && typeof message.raw_tx.length === "number" || $util.isString(message.raw_tx)))
            return "raw_tx: buffer expected";
        if (message.testnet != null && message.hasOwnProperty("testnet"))
            if (typeof message.testnet !== "boolean")
                return "testnet: boolean expected";
        return null;
    };

    FilecoinSignTx.fromObject = function fromObject(object) {
        if (object instanceof $root.FilecoinSignTx)
            return object;
        var message = new $root.FilecoinSignTx();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".FilecoinSignTx.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.raw_tx != null)
            if (typeof object.raw_tx === "string")
                $util.base64.decode(object.raw_tx, message.raw_tx = $util.newBuffer($util.base64.length(object.raw_tx)), 0);
            else if (object.raw_tx.length)
                message.raw_tx = object.raw_tx;
        if (object.testnet != null)
            message.testnet = Boolean(object.testnet);
        return message;
    };

    FilecoinSignTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            if (options.bytes === String)
                object.raw_tx = "";
            else {
                object.raw_tx = [];
                if (options.bytes !== Array)
                    object.raw_tx = $util.newBuffer(object.raw_tx);
            }
            object.testnet = false;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.raw_tx != null && message.hasOwnProperty("raw_tx"))
            object.raw_tx = options.bytes === String ? $util.base64.encode(message.raw_tx, 0, message.raw_tx.length) : options.bytes === Array ? Array.prototype.slice.call(message.raw_tx) : message.raw_tx;
        if (message.testnet != null && message.hasOwnProperty("testnet"))
            object.testnet = message.testnet;
        return object;
    };

    FilecoinSignTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return FilecoinSignTx;
})();

$root.FilecoinSignedTx = (function() {

    function FilecoinSignedTx(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    FilecoinSignedTx.prototype.signature = $util.newBuffer([]);

    FilecoinSignedTx.create = function create(properties) {
        return new FilecoinSignedTx(properties);
    };

    FilecoinSignedTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.signature);
        return writer;
    };

    FilecoinSignedTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    FilecoinSignedTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.FilecoinSignedTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.signature = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        return message;
    };

    FilecoinSignedTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    FilecoinSignedTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        return null;
    };

    FilecoinSignedTx.fromObject = function fromObject(object) {
        if (object instanceof $root.FilecoinSignedTx)
            return object;
        var message = new $root.FilecoinSignedTx();
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        return message;
    };

    FilecoinSignedTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        return object;
    };

    FilecoinSignedTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return FilecoinSignedTx;
})();

$root.KaspaGetAddress = (function() {

    function KaspaGetAddress(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    KaspaGetAddress.prototype.address_n = $util.emptyArray;
    KaspaGetAddress.prototype.show_display = false;
    KaspaGetAddress.prototype.prefix = "kaspa";
    KaspaGetAddress.prototype.scheme = "schnorr";
    KaspaGetAddress.prototype.use_tweak = true;

    KaspaGetAddress.create = function create(properties) {
        return new KaspaGetAddress(properties);
    };

    KaspaGetAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(16).bool(message.show_display);
        if (message.prefix != null && Object.hasOwnProperty.call(message, "prefix"))
            writer.uint32(26).string(message.prefix);
        if (message.scheme != null && Object.hasOwnProperty.call(message, "scheme"))
            writer.uint32(34).string(message.scheme);
        if (message.use_tweak != null && Object.hasOwnProperty.call(message, "use_tweak"))
            writer.uint32(40).bool(message.use_tweak);
        return writer;
    };

    KaspaGetAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    KaspaGetAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.KaspaGetAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.show_display = reader.bool();
                break;
            case 3:
                message.prefix = reader.string();
                break;
            case 4:
                message.scheme = reader.string();
                break;
            case 5:
                message.use_tweak = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    KaspaGetAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    KaspaGetAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        if (message.prefix != null && message.hasOwnProperty("prefix"))
            if (!$util.isString(message.prefix))
                return "prefix: string expected";
        if (message.scheme != null && message.hasOwnProperty("scheme"))
            if (!$util.isString(message.scheme))
                return "scheme: string expected";
        if (message.use_tweak != null && message.hasOwnProperty("use_tweak"))
            if (typeof message.use_tweak !== "boolean")
                return "use_tweak: boolean expected";
        return null;
    };

    KaspaGetAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.KaspaGetAddress)
            return object;
        var message = new $root.KaspaGetAddress();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".KaspaGetAddress.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        if (object.prefix != null)
            message.prefix = String(object.prefix);
        if (object.scheme != null)
            message.scheme = String(object.scheme);
        if (object.use_tweak != null)
            message.use_tweak = Boolean(object.use_tweak);
        return message;
    };

    KaspaGetAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            object.show_display = false;
            object.prefix = "kaspa";
            object.scheme = "schnorr";
            object.use_tweak = true;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        if (message.prefix != null && message.hasOwnProperty("prefix"))
            object.prefix = message.prefix;
        if (message.scheme != null && message.hasOwnProperty("scheme"))
            object.scheme = message.scheme;
        if (message.use_tweak != null && message.hasOwnProperty("use_tweak"))
            object.use_tweak = message.use_tweak;
        return object;
    };

    KaspaGetAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return KaspaGetAddress;
})();

$root.KaspaAddress = (function() {

    function KaspaAddress(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    KaspaAddress.prototype.address = "";

    KaspaAddress.create = function create(properties) {
        return new KaspaAddress(properties);
    };

    KaspaAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.address);
        return writer;
    };

    KaspaAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    KaspaAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.KaspaAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("address"))
            throw $util.ProtocolError("missing required 'address'", { instance: message });
        return message;
    };

    KaspaAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    KaspaAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.address))
            return "address: string expected";
        return null;
    };

    KaspaAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.KaspaAddress)
            return object;
        var message = new $root.KaspaAddress();
        if (object.address != null)
            message.address = String(object.address);
        return message;
    };

    KaspaAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.address = "";
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    KaspaAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return KaspaAddress;
})();

$root.KaspaSignTx = (function() {

    function KaspaSignTx(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    KaspaSignTx.prototype.address_n = $util.emptyArray;
    KaspaSignTx.prototype.raw_message = $util.newBuffer([]);
    KaspaSignTx.prototype.scheme = "schnorr";
    KaspaSignTx.prototype.prefix = "kaspa";
    KaspaSignTx.prototype.input_count = 1;
    KaspaSignTx.prototype.use_tweak = true;

    KaspaSignTx.create = function create(properties) {
        return new KaspaSignTx(properties);
    };

    KaspaSignTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).bytes(message.raw_message);
        if (message.scheme != null && Object.hasOwnProperty.call(message, "scheme"))
            writer.uint32(26).string(message.scheme);
        if (message.prefix != null && Object.hasOwnProperty.call(message, "prefix"))
            writer.uint32(34).string(message.prefix);
        if (message.input_count != null && Object.hasOwnProperty.call(message, "input_count"))
            writer.uint32(40).uint32(message.input_count);
        if (message.use_tweak != null && Object.hasOwnProperty.call(message, "use_tweak"))
            writer.uint32(48).bool(message.use_tweak);
        return writer;
    };

    KaspaSignTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    KaspaSignTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.KaspaSignTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.raw_message = reader.bytes();
                break;
            case 3:
                message.scheme = reader.string();
                break;
            case 4:
                message.prefix = reader.string();
                break;
            case 5:
                message.input_count = reader.uint32();
                break;
            case 6:
                message.use_tweak = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("raw_message"))
            throw $util.ProtocolError("missing required 'raw_message'", { instance: message });
        return message;
    };

    KaspaSignTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    KaspaSignTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!(message.raw_message && typeof message.raw_message.length === "number" || $util.isString(message.raw_message)))
            return "raw_message: buffer expected";
        if (message.scheme != null && message.hasOwnProperty("scheme"))
            if (!$util.isString(message.scheme))
                return "scheme: string expected";
        if (message.prefix != null && message.hasOwnProperty("prefix"))
            if (!$util.isString(message.prefix))
                return "prefix: string expected";
        if (message.input_count != null && message.hasOwnProperty("input_count"))
            if (!$util.isInteger(message.input_count))
                return "input_count: integer expected";
        if (message.use_tweak != null && message.hasOwnProperty("use_tweak"))
            if (typeof message.use_tweak !== "boolean")
                return "use_tweak: boolean expected";
        return null;
    };

    KaspaSignTx.fromObject = function fromObject(object) {
        if (object instanceof $root.KaspaSignTx)
            return object;
        var message = new $root.KaspaSignTx();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".KaspaSignTx.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.raw_message != null)
            if (typeof object.raw_message === "string")
                $util.base64.decode(object.raw_message, message.raw_message = $util.newBuffer($util.base64.length(object.raw_message)), 0);
            else if (object.raw_message.length)
                message.raw_message = object.raw_message;
        if (object.scheme != null)
            message.scheme = String(object.scheme);
        if (object.prefix != null)
            message.prefix = String(object.prefix);
        if (object.input_count != null)
            message.input_count = object.input_count >>> 0;
        if (object.use_tweak != null)
            message.use_tweak = Boolean(object.use_tweak);
        return message;
    };

    KaspaSignTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            if (options.bytes === String)
                object.raw_message = "";
            else {
                object.raw_message = [];
                if (options.bytes !== Array)
                    object.raw_message = $util.newBuffer(object.raw_message);
            }
            object.scheme = "schnorr";
            object.prefix = "kaspa";
            object.input_count = 1;
            object.use_tweak = true;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.raw_message != null && message.hasOwnProperty("raw_message"))
            object.raw_message = options.bytes === String ? $util.base64.encode(message.raw_message, 0, message.raw_message.length) : options.bytes === Array ? Array.prototype.slice.call(message.raw_message) : message.raw_message;
        if (message.scheme != null && message.hasOwnProperty("scheme"))
            object.scheme = message.scheme;
        if (message.prefix != null && message.hasOwnProperty("prefix"))
            object.prefix = message.prefix;
        if (message.input_count != null && message.hasOwnProperty("input_count"))
            object.input_count = message.input_count;
        if (message.use_tweak != null && message.hasOwnProperty("use_tweak"))
            object.use_tweak = message.use_tweak;
        return object;
    };

    KaspaSignTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return KaspaSignTx;
})();

$root.KaspaTxInputRequest = (function() {

    function KaspaTxInputRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    KaspaTxInputRequest.prototype.request_index = 0;
    KaspaTxInputRequest.prototype.signature = $util.newBuffer([]);

    KaspaTxInputRequest.create = function create(properties) {
        return new KaspaTxInputRequest(properties);
    };

    KaspaTxInputRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).uint32(message.request_index);
        if (message.signature != null && Object.hasOwnProperty.call(message, "signature"))
            writer.uint32(18).bytes(message.signature);
        return writer;
    };

    KaspaTxInputRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    KaspaTxInputRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.KaspaTxInputRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.request_index = reader.uint32();
                break;
            case 2:
                message.signature = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("request_index"))
            throw $util.ProtocolError("missing required 'request_index'", { instance: message });
        return message;
    };

    KaspaTxInputRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    KaspaTxInputRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isInteger(message.request_index))
            return "request_index: integer expected";
        if (message.signature != null && message.hasOwnProperty("signature"))
            if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
                return "signature: buffer expected";
        return null;
    };

    KaspaTxInputRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.KaspaTxInputRequest)
            return object;
        var message = new $root.KaspaTxInputRequest();
        if (object.request_index != null)
            message.request_index = object.request_index >>> 0;
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        return message;
    };

    KaspaTxInputRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.request_index = 0;
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
        }
        if (message.request_index != null && message.hasOwnProperty("request_index"))
            object.request_index = message.request_index;
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        return object;
    };

    KaspaTxInputRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return KaspaTxInputRequest;
})();

$root.KaspaTxInputAck = (function() {

    function KaspaTxInputAck(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    KaspaTxInputAck.prototype.address_n = $util.emptyArray;
    KaspaTxInputAck.prototype.raw_message = $util.newBuffer([]);

    KaspaTxInputAck.create = function create(properties) {
        return new KaspaTxInputAck(properties);
    };

    KaspaTxInputAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).bytes(message.raw_message);
        return writer;
    };

    KaspaTxInputAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    KaspaTxInputAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.KaspaTxInputAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.raw_message = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("raw_message"))
            throw $util.ProtocolError("missing required 'raw_message'", { instance: message });
        return message;
    };

    KaspaTxInputAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    KaspaTxInputAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!(message.raw_message && typeof message.raw_message.length === "number" || $util.isString(message.raw_message)))
            return "raw_message: buffer expected";
        return null;
    };

    KaspaTxInputAck.fromObject = function fromObject(object) {
        if (object instanceof $root.KaspaTxInputAck)
            return object;
        var message = new $root.KaspaTxInputAck();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".KaspaTxInputAck.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.raw_message != null)
            if (typeof object.raw_message === "string")
                $util.base64.decode(object.raw_message, message.raw_message = $util.newBuffer($util.base64.length(object.raw_message)), 0);
            else if (object.raw_message.length)
                message.raw_message = object.raw_message;
        return message;
    };

    KaspaTxInputAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            if (options.bytes === String)
                object.raw_message = "";
            else {
                object.raw_message = [];
                if (options.bytes !== Array)
                    object.raw_message = $util.newBuffer(object.raw_message);
            }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.raw_message != null && message.hasOwnProperty("raw_message"))
            object.raw_message = options.bytes === String ? $util.base64.encode(message.raw_message, 0, message.raw_message.length) : options.bytes === Array ? Array.prototype.slice.call(message.raw_message) : message.raw_message;
        return object;
    };

    KaspaTxInputAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return KaspaTxInputAck;
})();

$root.KaspaSignedTx = (function() {

    function KaspaSignedTx(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    KaspaSignedTx.prototype.signature = $util.newBuffer([]);

    KaspaSignedTx.create = function create(properties) {
        return new KaspaSignedTx(properties);
    };

    KaspaSignedTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(18).bytes(message.signature);
        return writer;
    };

    KaspaSignedTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    KaspaSignedTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.KaspaSignedTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 2:
                message.signature = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        return message;
    };

    KaspaSignedTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    KaspaSignedTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        return null;
    };

    KaspaSignedTx.fromObject = function fromObject(object) {
        if (object instanceof $root.KaspaSignedTx)
            return object;
        var message = new $root.KaspaSignedTx();
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        return message;
    };

    KaspaSignedTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        return object;
    };

    KaspaSignedTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return KaspaSignedTx;
})();

$root.LnurlAuth = (function() {

    function LnurlAuth(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    LnurlAuth.prototype.domain = $util.newBuffer([]);
    LnurlAuth.prototype.data = $util.newBuffer([]);

    LnurlAuth.create = function create(properties) {
        return new LnurlAuth(properties);
    };

    LnurlAuth.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(18).bytes(message.domain);
        writer.uint32(26).bytes(message.data);
        return writer;
    };

    LnurlAuth.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    LnurlAuth.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.LnurlAuth();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 2:
                message.domain = reader.bytes();
                break;
            case 3:
                message.data = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("domain"))
            throw $util.ProtocolError("missing required 'domain'", { instance: message });
        if (!message.hasOwnProperty("data"))
            throw $util.ProtocolError("missing required 'data'", { instance: message });
        return message;
    };

    LnurlAuth.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    LnurlAuth.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.domain && typeof message.domain.length === "number" || $util.isString(message.domain)))
            return "domain: buffer expected";
        if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
            return "data: buffer expected";
        return null;
    };

    LnurlAuth.fromObject = function fromObject(object) {
        if (object instanceof $root.LnurlAuth)
            return object;
        var message = new $root.LnurlAuth();
        if (object.domain != null)
            if (typeof object.domain === "string")
                $util.base64.decode(object.domain, message.domain = $util.newBuffer($util.base64.length(object.domain)), 0);
            else if (object.domain.length)
                message.domain = object.domain;
        if (object.data != null)
            if (typeof object.data === "string")
                $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
            else if (object.data.length)
                message.data = object.data;
        return message;
    };

    LnurlAuth.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.domain = "";
            else {
                object.domain = [];
                if (options.bytes !== Array)
                    object.domain = $util.newBuffer(object.domain);
            }
            if (options.bytes === String)
                object.data = "";
            else {
                object.data = [];
                if (options.bytes !== Array)
                    object.data = $util.newBuffer(object.data);
            }
        }
        if (message.domain != null && message.hasOwnProperty("domain"))
            object.domain = options.bytes === String ? $util.base64.encode(message.domain, 0, message.domain.length) : options.bytes === Array ? Array.prototype.slice.call(message.domain) : message.domain;
        if (message.data != null && message.hasOwnProperty("data"))
            object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
        return object;
    };

    LnurlAuth.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return LnurlAuth;
})();

$root.LnurlAuthResp = (function() {

    function LnurlAuthResp(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    LnurlAuthResp.prototype.publickey = "";
    LnurlAuthResp.prototype.path = "";
    LnurlAuthResp.prototype.signature = $util.newBuffer([]);

    LnurlAuthResp.create = function create(properties) {
        return new LnurlAuthResp(properties);
    };

    LnurlAuthResp.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.publickey != null && Object.hasOwnProperty.call(message, "publickey"))
            writer.uint32(10).string(message.publickey);
        if (message.path != null && Object.hasOwnProperty.call(message, "path"))
            writer.uint32(18).string(message.path);
        if (message.signature != null && Object.hasOwnProperty.call(message, "signature"))
            writer.uint32(26).bytes(message.signature);
        return writer;
    };

    LnurlAuthResp.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    LnurlAuthResp.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.LnurlAuthResp();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.publickey = reader.string();
                break;
            case 2:
                message.path = reader.string();
                break;
            case 3:
                message.signature = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    LnurlAuthResp.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    LnurlAuthResp.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.publickey != null && message.hasOwnProperty("publickey"))
            if (!$util.isString(message.publickey))
                return "publickey: string expected";
        if (message.path != null && message.hasOwnProperty("path"))
            if (!$util.isString(message.path))
                return "path: string expected";
        if (message.signature != null && message.hasOwnProperty("signature"))
            if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
                return "signature: buffer expected";
        return null;
    };

    LnurlAuthResp.fromObject = function fromObject(object) {
        if (object instanceof $root.LnurlAuthResp)
            return object;
        var message = new $root.LnurlAuthResp();
        if (object.publickey != null)
            message.publickey = String(object.publickey);
        if (object.path != null)
            message.path = String(object.path);
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        return message;
    };

    LnurlAuthResp.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.publickey = "";
            object.path = "";
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
        }
        if (message.publickey != null && message.hasOwnProperty("publickey"))
            object.publickey = message.publickey;
        if (message.path != null && message.hasOwnProperty("path"))
            object.path = message.path;
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        return object;
    };

    LnurlAuthResp.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return LnurlAuthResp;
})();

$root.BackupType = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "Bip39"] = 0;
    values[valuesById[1] = "Slip39_Basic"] = 1;
    values[valuesById[2] = "Slip39_Advanced"] = 2;
    values[valuesById[3] = "Slip39_Single_Extendable"] = 3;
    values[valuesById[4] = "Slip39_Basic_Extendable"] = 4;
    values[valuesById[5] = "Slip39_Advanced_Extendable"] = 5;
    return values;
})();

$root.SafetyCheckLevel = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "Strict"] = 0;
    values[valuesById[1] = "PromptAlways"] = 1;
    values[valuesById[2] = "PromptTemporarily"] = 2;
    return values;
})();

$root.Initialize = (function() {

    function Initialize(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    Initialize.prototype.session_id = $util.newBuffer([]);
    Initialize.prototype._skip_passphrase = false;
    Initialize.prototype.derive_cardano = false;
    Initialize.prototype.passphrase_state = "";
    Initialize.prototype.is_contains_attach = false;

    Initialize.create = function create(properties) {
        return new Initialize(properties);
    };

    Initialize.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.session_id != null && Object.hasOwnProperty.call(message, "session_id"))
            writer.uint32(10).bytes(message.session_id);
        if (message._skip_passphrase != null && Object.hasOwnProperty.call(message, "_skip_passphrase"))
            writer.uint32(16).bool(message._skip_passphrase);
        if (message.derive_cardano != null && Object.hasOwnProperty.call(message, "derive_cardano"))
            writer.uint32(24).bool(message.derive_cardano);
        if (message.passphrase_state != null && Object.hasOwnProperty.call(message, "passphrase_state"))
            writer.uint32(64002).string(message.passphrase_state);
        if (message.is_contains_attach != null && Object.hasOwnProperty.call(message, "is_contains_attach"))
            writer.uint32(64008).bool(message.is_contains_attach);
        return writer;
    };

    Initialize.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    Initialize.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Initialize();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.session_id = reader.bytes();
                break;
            case 2:
                message._skip_passphrase = reader.bool();
                break;
            case 3:
                message.derive_cardano = reader.bool();
                break;
            case 8000:
                message.passphrase_state = reader.string();
                break;
            case 8001:
                message.is_contains_attach = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    Initialize.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    Initialize.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.session_id != null && message.hasOwnProperty("session_id"))
            if (!(message.session_id && typeof message.session_id.length === "number" || $util.isString(message.session_id)))
                return "session_id: buffer expected";
        if (message._skip_passphrase != null && message.hasOwnProperty("_skip_passphrase"))
            if (typeof message._skip_passphrase !== "boolean")
                return "_skip_passphrase: boolean expected";
        if (message.derive_cardano != null && message.hasOwnProperty("derive_cardano"))
            if (typeof message.derive_cardano !== "boolean")
                return "derive_cardano: boolean expected";
        if (message.passphrase_state != null && message.hasOwnProperty("passphrase_state"))
            if (!$util.isString(message.passphrase_state))
                return "passphrase_state: string expected";
        if (message.is_contains_attach != null && message.hasOwnProperty("is_contains_attach"))
            if (typeof message.is_contains_attach !== "boolean")
                return "is_contains_attach: boolean expected";
        return null;
    };

    Initialize.fromObject = function fromObject(object) {
        if (object instanceof $root.Initialize)
            return object;
        var message = new $root.Initialize();
        if (object.session_id != null)
            if (typeof object.session_id === "string")
                $util.base64.decode(object.session_id, message.session_id = $util.newBuffer($util.base64.length(object.session_id)), 0);
            else if (object.session_id.length)
                message.session_id = object.session_id;
        if (object._skip_passphrase != null)
            message._skip_passphrase = Boolean(object._skip_passphrase);
        if (object.derive_cardano != null)
            message.derive_cardano = Boolean(object.derive_cardano);
        if (object.passphrase_state != null)
            message.passphrase_state = String(object.passphrase_state);
        if (object.is_contains_attach != null)
            message.is_contains_attach = Boolean(object.is_contains_attach);
        return message;
    };

    Initialize.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.session_id = "";
            else {
                object.session_id = [];
                if (options.bytes !== Array)
                    object.session_id = $util.newBuffer(object.session_id);
            }
            object._skip_passphrase = false;
            object.derive_cardano = false;
            object.passphrase_state = "";
            object.is_contains_attach = false;
        }
        if (message.session_id != null && message.hasOwnProperty("session_id"))
            object.session_id = options.bytes === String ? $util.base64.encode(message.session_id, 0, message.session_id.length) : options.bytes === Array ? Array.prototype.slice.call(message.session_id) : message.session_id;
        if (message._skip_passphrase != null && message.hasOwnProperty("_skip_passphrase"))
            object._skip_passphrase = message._skip_passphrase;
        if (message.derive_cardano != null && message.hasOwnProperty("derive_cardano"))
            object.derive_cardano = message.derive_cardano;
        if (message.passphrase_state != null && message.hasOwnProperty("passphrase_state"))
            object.passphrase_state = message.passphrase_state;
        if (message.is_contains_attach != null && message.hasOwnProperty("is_contains_attach"))
            object.is_contains_attach = message.is_contains_attach;
        return object;
    };

    Initialize.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return Initialize;
})();

$root.GetFeatures = (function() {

    function GetFeatures(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    GetFeatures.create = function create(properties) {
        return new GetFeatures(properties);
    };

    GetFeatures.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    GetFeatures.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    GetFeatures.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.GetFeatures();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    GetFeatures.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    GetFeatures.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    GetFeatures.fromObject = function fromObject(object) {
        if (object instanceof $root.GetFeatures)
            return object;
        return new $root.GetFeatures();
    };

    GetFeatures.toObject = function toObject() {
        return {};
    };

    GetFeatures.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return GetFeatures;
})();

$root.OnekeyGetFeatures = (function() {

    function OnekeyGetFeatures(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    OnekeyGetFeatures.create = function create(properties) {
        return new OnekeyGetFeatures(properties);
    };

    OnekeyGetFeatures.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    OnekeyGetFeatures.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    OnekeyGetFeatures.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.OnekeyGetFeatures();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    OnekeyGetFeatures.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    OnekeyGetFeatures.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    OnekeyGetFeatures.fromObject = function fromObject(object) {
        if (object instanceof $root.OnekeyGetFeatures)
            return object;
        return new $root.OnekeyGetFeatures();
    };

    OnekeyGetFeatures.toObject = function toObject() {
        return {};
    };

    OnekeyGetFeatures.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return OnekeyGetFeatures;
})();

$root.OneKeyDeviceType = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "CLASSIC"] = 0;
    values[valuesById[1] = "CLASSIC1S"] = 1;
    values[valuesById[2] = "MINI"] = 2;
    values[valuesById[3] = "TOUCH"] = 3;
    values[valuesById[5] = "PRO"] = 5;
    return values;
})();

$root.OneKeySeType = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "THD89"] = 0;
    values[valuesById[1] = "SE608A"] = 1;
    return values;
})();

$root.OneKeySEState = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "BOOT"] = 0;
    values[valuesById[1] = "APP"] = 1;
    return values;
})();

$root.Features = (function() {

    function Features(properties) {
        this.capabilities = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    Features.prototype.vendor = "";
    Features.prototype.major_version = 0;
    Features.prototype.minor_version = 0;
    Features.prototype.patch_version = 0;
    Features.prototype.bootloader_mode = false;
    Features.prototype.device_id = "";
    Features.prototype.pin_protection = false;
    Features.prototype.passphrase_protection = false;
    Features.prototype.language = "";
    Features.prototype.label = "";
    Features.prototype.initialized = false;
    Features.prototype.revision = $util.newBuffer([]);
    Features.prototype.bootloader_hash = $util.newBuffer([]);
    Features.prototype.imported = false;
    Features.prototype.unlocked = false;
    Features.prototype._passphrase_cached = false;
    Features.prototype.firmware_present = false;
    Features.prototype.needs_backup = false;
    Features.prototype.flags = 0;
    Features.prototype.model = "";
    Features.prototype.fw_major = 0;
    Features.prototype.fw_minor = 0;
    Features.prototype.fw_patch = 0;
    Features.prototype.fw_vendor = "";
    Features.prototype.unfinished_backup = false;
    Features.prototype.no_backup = false;
    Features.prototype.recovery_mode = false;
    Features.prototype.capabilities = $util.emptyArray;
    Features.prototype.backup_type = 0;
    Features.prototype.sd_card_present = false;
    Features.prototype.sd_protection = false;
    Features.prototype.wipe_code_protection = false;
    Features.prototype.session_id = $util.newBuffer([]);
    Features.prototype.passphrase_always_on_device = false;
    Features.prototype.safety_checks = 0;
    Features.prototype.auto_lock_delay_ms = 0;
    Features.prototype.display_rotation = 0;
    Features.prototype.experimental_features = false;
    Features.prototype.offset = 0;
    Features.prototype.coprocessor_bt_name = "";
    Features.prototype.coprocessor_version = "";
    Features.prototype.coprocessor_bt_enable = false;
    Features.prototype.se_enable = false;
    Features.prototype.se_ver = "";
    Features.prototype.backup_only = false;
    Features.prototype.onekey_version = "";
    Features.prototype.onekey_serial = "";
    Features.prototype.bootloader_version = "";
    Features.prototype.serial_no = "";
    Features.prototype.spi_flash = "";
    Features.prototype.initstates = 0;
    Features.prototype.NFT_voucher = $util.newBuffer([]);
    Features.prototype.cpu_info = "";
    Features.prototype.pre_firmware = "";
    Features.prototype.coin_switch = 0;
    Features.prototype.build_id = $util.newBuffer([]);
    Features.prototype.romloader_version = "";
    Features.prototype.busy = false;
    Features.prototype.onekey_device_type = 0;
    Features.prototype.onekey_se_type = 0;
    Features.prototype.onekey_romloader_version = "";
    Features.prototype.onekey_romloader_hash = $util.newBuffer([]);
    Features.prototype.onekey_bootloader_version = "";
    Features.prototype.onekey_bootloader_hash = $util.newBuffer([]);
    Features.prototype.onekey_se01_version = "";
    Features.prototype.onekey_se01_hash = $util.newBuffer([]);
    Features.prototype.onekey_se01_build_id = "";
    Features.prototype.onekey_firmware_version = "";
    Features.prototype.onekey_firmware_hash = $util.newBuffer([]);
    Features.prototype.onekey_firmware_build_id = "";
    Features.prototype.onekey_serial_no = "";
    Features.prototype.onekey_bootloader_build_id = "";
    Features.prototype.onekey_coprocessor_bt_name = "";
    Features.prototype.onekey_coprocessor_version = "";
    Features.prototype.onekey_coprocessor_build_id = "";
    Features.prototype.onekey_coprocessor_hash = $util.newBuffer([]);
    Features.prototype.onekey_se02_version = "";
    Features.prototype.onekey_se03_version = "";
    Features.prototype.onekey_se04_version = "";
    Features.prototype.onekey_se01_state = 0;
    Features.prototype.onekey_se02_state = 0;
    Features.prototype.onekey_se03_state = 0;
    Features.prototype.onekey_se04_state = 0;
    Features.prototype.attach_to_pin_user = false;
    Features.prototype.unlocked_attach_pin = false;

    Features.create = function create(properties) {
        return new Features(properties);
    };

    Features.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.vendor != null && Object.hasOwnProperty.call(message, "vendor"))
            writer.uint32(10).string(message.vendor);
        writer.uint32(16).uint32(message.major_version);
        writer.uint32(24).uint32(message.minor_version);
        writer.uint32(32).uint32(message.patch_version);
        if (message.bootloader_mode != null && Object.hasOwnProperty.call(message, "bootloader_mode"))
            writer.uint32(40).bool(message.bootloader_mode);
        if (message.device_id != null && Object.hasOwnProperty.call(message, "device_id"))
            writer.uint32(50).string(message.device_id);
        if (message.pin_protection != null && Object.hasOwnProperty.call(message, "pin_protection"))
            writer.uint32(56).bool(message.pin_protection);
        if (message.passphrase_protection != null && Object.hasOwnProperty.call(message, "passphrase_protection"))
            writer.uint32(64).bool(message.passphrase_protection);
        if (message.language != null && Object.hasOwnProperty.call(message, "language"))
            writer.uint32(74).string(message.language);
        if (message.label != null && Object.hasOwnProperty.call(message, "label"))
            writer.uint32(82).string(message.label);
        if (message.initialized != null && Object.hasOwnProperty.call(message, "initialized"))
            writer.uint32(96).bool(message.initialized);
        if (message.revision != null && Object.hasOwnProperty.call(message, "revision"))
            writer.uint32(106).bytes(message.revision);
        if (message.bootloader_hash != null && Object.hasOwnProperty.call(message, "bootloader_hash"))
            writer.uint32(114).bytes(message.bootloader_hash);
        if (message.imported != null && Object.hasOwnProperty.call(message, "imported"))
            writer.uint32(120).bool(message.imported);
        if (message.unlocked != null && Object.hasOwnProperty.call(message, "unlocked"))
            writer.uint32(128).bool(message.unlocked);
        if (message._passphrase_cached != null && Object.hasOwnProperty.call(message, "_passphrase_cached"))
            writer.uint32(136).bool(message._passphrase_cached);
        if (message.firmware_present != null && Object.hasOwnProperty.call(message, "firmware_present"))
            writer.uint32(144).bool(message.firmware_present);
        if (message.needs_backup != null && Object.hasOwnProperty.call(message, "needs_backup"))
            writer.uint32(152).bool(message.needs_backup);
        if (message.flags != null && Object.hasOwnProperty.call(message, "flags"))
            writer.uint32(160).uint32(message.flags);
        if (message.model != null && Object.hasOwnProperty.call(message, "model"))
            writer.uint32(170).string(message.model);
        if (message.fw_major != null && Object.hasOwnProperty.call(message, "fw_major"))
            writer.uint32(176).uint32(message.fw_major);
        if (message.fw_minor != null && Object.hasOwnProperty.call(message, "fw_minor"))
            writer.uint32(184).uint32(message.fw_minor);
        if (message.fw_patch != null && Object.hasOwnProperty.call(message, "fw_patch"))
            writer.uint32(192).uint32(message.fw_patch);
        if (message.fw_vendor != null && Object.hasOwnProperty.call(message, "fw_vendor"))
            writer.uint32(202).string(message.fw_vendor);
        if (message.unfinished_backup != null && Object.hasOwnProperty.call(message, "unfinished_backup"))
            writer.uint32(216).bool(message.unfinished_backup);
        if (message.no_backup != null && Object.hasOwnProperty.call(message, "no_backup"))
            writer.uint32(224).bool(message.no_backup);
        if (message.recovery_mode != null && Object.hasOwnProperty.call(message, "recovery_mode"))
            writer.uint32(232).bool(message.recovery_mode);
        if (message.capabilities != null && message.capabilities.length)
            for (var i = 0; i < message.capabilities.length; ++i)
                writer.uint32(240).int32(message.capabilities[i]);
        if (message.backup_type != null && Object.hasOwnProperty.call(message, "backup_type"))
            writer.uint32(248).int32(message.backup_type);
        if (message.sd_card_present != null && Object.hasOwnProperty.call(message, "sd_card_present"))
            writer.uint32(256).bool(message.sd_card_present);
        if (message.sd_protection != null && Object.hasOwnProperty.call(message, "sd_protection"))
            writer.uint32(264).bool(message.sd_protection);
        if (message.wipe_code_protection != null && Object.hasOwnProperty.call(message, "wipe_code_protection"))
            writer.uint32(272).bool(message.wipe_code_protection);
        if (message.session_id != null && Object.hasOwnProperty.call(message, "session_id"))
            writer.uint32(282).bytes(message.session_id);
        if (message.passphrase_always_on_device != null && Object.hasOwnProperty.call(message, "passphrase_always_on_device"))
            writer.uint32(288).bool(message.passphrase_always_on_device);
        if (message.safety_checks != null && Object.hasOwnProperty.call(message, "safety_checks"))
            writer.uint32(296).int32(message.safety_checks);
        if (message.auto_lock_delay_ms != null && Object.hasOwnProperty.call(message, "auto_lock_delay_ms"))
            writer.uint32(304).uint32(message.auto_lock_delay_ms);
        if (message.display_rotation != null && Object.hasOwnProperty.call(message, "display_rotation"))
            writer.uint32(312).uint32(message.display_rotation);
        if (message.experimental_features != null && Object.hasOwnProperty.call(message, "experimental_features"))
            writer.uint32(320).bool(message.experimental_features);
        if (message.busy != null && Object.hasOwnProperty.call(message, "busy"))
            writer.uint32(328).bool(message.busy);
        if (message.offset != null && Object.hasOwnProperty.call(message, "offset"))
            writer.uint32(4000).uint32(message.offset);
        if (message.coprocessor_bt_name != null && Object.hasOwnProperty.call(message, "coprocessor_bt_name"))
            writer.uint32(4010).string(message.coprocessor_bt_name);
        if (message.coprocessor_version != null && Object.hasOwnProperty.call(message, "coprocessor_version"))
            writer.uint32(4018).string(message.coprocessor_version);
        if (message.coprocessor_bt_enable != null && Object.hasOwnProperty.call(message, "coprocessor_bt_enable"))
            writer.uint32(4024).bool(message.coprocessor_bt_enable);
        if (message.se_enable != null && Object.hasOwnProperty.call(message, "se_enable"))
            writer.uint32(4032).bool(message.se_enable);
        if (message.se_ver != null && Object.hasOwnProperty.call(message, "se_ver"))
            writer.uint32(4050).string(message.se_ver);
        if (message.backup_only != null && Object.hasOwnProperty.call(message, "backup_only"))
            writer.uint32(4056).bool(message.backup_only);
        if (message.onekey_version != null && Object.hasOwnProperty.call(message, "onekey_version"))
            writer.uint32(4066).string(message.onekey_version);
        if (message.onekey_serial != null && Object.hasOwnProperty.call(message, "onekey_serial"))
            writer.uint32(4074).string(message.onekey_serial);
        if (message.bootloader_version != null && Object.hasOwnProperty.call(message, "bootloader_version"))
            writer.uint32(4082).string(message.bootloader_version);
        if (message.serial_no != null && Object.hasOwnProperty.call(message, "serial_no"))
            writer.uint32(4090).string(message.serial_no);
        if (message.spi_flash != null && Object.hasOwnProperty.call(message, "spi_flash"))
            writer.uint32(4098).string(message.spi_flash);
        if (message.initstates != null && Object.hasOwnProperty.call(message, "initstates"))
            writer.uint32(4104).uint32(message.initstates);
        if (message.NFT_voucher != null && Object.hasOwnProperty.call(message, "NFT_voucher"))
            writer.uint32(4114).bytes(message.NFT_voucher);
        if (message.cpu_info != null && Object.hasOwnProperty.call(message, "cpu_info"))
            writer.uint32(4122).string(message.cpu_info);
        if (message.pre_firmware != null && Object.hasOwnProperty.call(message, "pre_firmware"))
            writer.uint32(4130).string(message.pre_firmware);
        if (message.coin_switch != null && Object.hasOwnProperty.call(message, "coin_switch"))
            writer.uint32(4136).uint32(message.coin_switch);
        if (message.build_id != null && Object.hasOwnProperty.call(message, "build_id"))
            writer.uint32(4146).bytes(message.build_id);
        if (message.romloader_version != null && Object.hasOwnProperty.call(message, "romloader_version"))
            writer.uint32(4154).string(message.romloader_version);
        if (message.onekey_device_type != null && Object.hasOwnProperty.call(message, "onekey_device_type"))
            writer.uint32(4800).int32(message.onekey_device_type);
        if (message.onekey_se_type != null && Object.hasOwnProperty.call(message, "onekey_se_type"))
            writer.uint32(4808).int32(message.onekey_se_type);
        if (message.onekey_romloader_version != null && Object.hasOwnProperty.call(message, "onekey_romloader_version"))
            writer.uint32(4818).string(message.onekey_romloader_version);
        if (message.onekey_romloader_hash != null && Object.hasOwnProperty.call(message, "onekey_romloader_hash"))
            writer.uint32(4826).bytes(message.onekey_romloader_hash);
        if (message.onekey_bootloader_version != null && Object.hasOwnProperty.call(message, "onekey_bootloader_version"))
            writer.uint32(4834).string(message.onekey_bootloader_version);
        if (message.onekey_bootloader_hash != null && Object.hasOwnProperty.call(message, "onekey_bootloader_hash"))
            writer.uint32(4842).bytes(message.onekey_bootloader_hash);
        if (message.onekey_se01_version != null && Object.hasOwnProperty.call(message, "onekey_se01_version"))
            writer.uint32(4850).string(message.onekey_se01_version);
        if (message.onekey_se01_hash != null && Object.hasOwnProperty.call(message, "onekey_se01_hash"))
            writer.uint32(4858).bytes(message.onekey_se01_hash);
        if (message.onekey_se01_build_id != null && Object.hasOwnProperty.call(message, "onekey_se01_build_id"))
            writer.uint32(4866).string(message.onekey_se01_build_id);
        if (message.onekey_firmware_version != null && Object.hasOwnProperty.call(message, "onekey_firmware_version"))
            writer.uint32(4874).string(message.onekey_firmware_version);
        if (message.onekey_firmware_hash != null && Object.hasOwnProperty.call(message, "onekey_firmware_hash"))
            writer.uint32(4882).bytes(message.onekey_firmware_hash);
        if (message.onekey_firmware_build_id != null && Object.hasOwnProperty.call(message, "onekey_firmware_build_id"))
            writer.uint32(4890).string(message.onekey_firmware_build_id);
        if (message.onekey_serial_no != null && Object.hasOwnProperty.call(message, "onekey_serial_no"))
            writer.uint32(4898).string(message.onekey_serial_no);
        if (message.onekey_bootloader_build_id != null && Object.hasOwnProperty.call(message, "onekey_bootloader_build_id"))
            writer.uint32(4906).string(message.onekey_bootloader_build_id);
        if (message.onekey_coprocessor_bt_name != null && Object.hasOwnProperty.call(message, "onekey_coprocessor_bt_name"))
            writer.uint32(4914).string(message.onekey_coprocessor_bt_name);
        if (message.onekey_coprocessor_version != null && Object.hasOwnProperty.call(message, "onekey_coprocessor_version"))
            writer.uint32(4922).string(message.onekey_coprocessor_version);
        if (message.onekey_coprocessor_build_id != null && Object.hasOwnProperty.call(message, "onekey_coprocessor_build_id"))
            writer.uint32(4930).string(message.onekey_coprocessor_build_id);
        if (message.onekey_coprocessor_hash != null && Object.hasOwnProperty.call(message, "onekey_coprocessor_hash"))
            writer.uint32(4938).bytes(message.onekey_coprocessor_hash);
        if (message.onekey_se02_version != null && Object.hasOwnProperty.call(message, "onekey_se02_version"))
            writer.uint32(4946).string(message.onekey_se02_version);
        if (message.onekey_se03_version != null && Object.hasOwnProperty.call(message, "onekey_se03_version"))
            writer.uint32(4954).string(message.onekey_se03_version);
        if (message.onekey_se04_version != null && Object.hasOwnProperty.call(message, "onekey_se04_version"))
            writer.uint32(4962).string(message.onekey_se04_version);
        if (message.onekey_se01_state != null && Object.hasOwnProperty.call(message, "onekey_se01_state"))
            writer.uint32(4968).int32(message.onekey_se01_state);
        if (message.onekey_se02_state != null && Object.hasOwnProperty.call(message, "onekey_se02_state"))
            writer.uint32(4976).int32(message.onekey_se02_state);
        if (message.onekey_se03_state != null && Object.hasOwnProperty.call(message, "onekey_se03_state"))
            writer.uint32(4984).int32(message.onekey_se03_state);
        if (message.onekey_se04_state != null && Object.hasOwnProperty.call(message, "onekey_se04_state"))
            writer.uint32(4992).int32(message.onekey_se04_state);
        if (message.attach_to_pin_user != null && Object.hasOwnProperty.call(message, "attach_to_pin_user"))
            writer.uint32(5000).bool(message.attach_to_pin_user);
        if (message.unlocked_attach_pin != null && Object.hasOwnProperty.call(message, "unlocked_attach_pin"))
            writer.uint32(5008).bool(message.unlocked_attach_pin);
        return writer;
    };

    Features.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    Features.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Features();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.vendor = reader.string();
                break;
            case 2:
                message.major_version = reader.uint32();
                break;
            case 3:
                message.minor_version = reader.uint32();
                break;
            case 4:
                message.patch_version = reader.uint32();
                break;
            case 5:
                message.bootloader_mode = reader.bool();
                break;
            case 6:
                message.device_id = reader.string();
                break;
            case 7:
                message.pin_protection = reader.bool();
                break;
            case 8:
                message.passphrase_protection = reader.bool();
                break;
            case 9:
                message.language = reader.string();
                break;
            case 10:
                message.label = reader.string();
                break;
            case 12:
                message.initialized = reader.bool();
                break;
            case 13:
                message.revision = reader.bytes();
                break;
            case 14:
                message.bootloader_hash = reader.bytes();
                break;
            case 15:
                message.imported = reader.bool();
                break;
            case 16:
                message.unlocked = reader.bool();
                break;
            case 17:
                message._passphrase_cached = reader.bool();
                break;
            case 18:
                message.firmware_present = reader.bool();
                break;
            case 19:
                message.needs_backup = reader.bool();
                break;
            case 20:
                message.flags = reader.uint32();
                break;
            case 21:
                message.model = reader.string();
                break;
            case 22:
                message.fw_major = reader.uint32();
                break;
            case 23:
                message.fw_minor = reader.uint32();
                break;
            case 24:
                message.fw_patch = reader.uint32();
                break;
            case 25:
                message.fw_vendor = reader.string();
                break;
            case 27:
                message.unfinished_backup = reader.bool();
                break;
            case 28:
                message.no_backup = reader.bool();
                break;
            case 29:
                message.recovery_mode = reader.bool();
                break;
            case 30:
                if (!(message.capabilities && message.capabilities.length))
                    message.capabilities = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.capabilities.push(reader.int32());
                } else
                    message.capabilities.push(reader.int32());
                break;
            case 31:
                message.backup_type = reader.int32();
                break;
            case 32:
                message.sd_card_present = reader.bool();
                break;
            case 33:
                message.sd_protection = reader.bool();
                break;
            case 34:
                message.wipe_code_protection = reader.bool();
                break;
            case 35:
                message.session_id = reader.bytes();
                break;
            case 36:
                message.passphrase_always_on_device = reader.bool();
                break;
            case 37:
                message.safety_checks = reader.int32();
                break;
            case 38:
                message.auto_lock_delay_ms = reader.uint32();
                break;
            case 39:
                message.display_rotation = reader.uint32();
                break;
            case 40:
                message.experimental_features = reader.bool();
                break;
            case 500:
                message.offset = reader.uint32();
                break;
            case 501:
                message.coprocessor_bt_name = reader.string();
                break;
            case 502:
                message.coprocessor_version = reader.string();
                break;
            case 503:
                message.coprocessor_bt_enable = reader.bool();
                break;
            case 504:
                message.se_enable = reader.bool();
                break;
            case 506:
                message.se_ver = reader.string();
                break;
            case 507:
                message.backup_only = reader.bool();
                break;
            case 508:
                message.onekey_version = reader.string();
                break;
            case 509:
                message.onekey_serial = reader.string();
                break;
            case 510:
                message.bootloader_version = reader.string();
                break;
            case 511:
                message.serial_no = reader.string();
                break;
            case 512:
                message.spi_flash = reader.string();
                break;
            case 513:
                message.initstates = reader.uint32();
                break;
            case 514:
                message.NFT_voucher = reader.bytes();
                break;
            case 515:
                message.cpu_info = reader.string();
                break;
            case 516:
                message.pre_firmware = reader.string();
                break;
            case 517:
                message.coin_switch = reader.uint32();
                break;
            case 518:
                message.build_id = reader.bytes();
                break;
            case 519:
                message.romloader_version = reader.string();
                break;
            case 41:
                message.busy = reader.bool();
                break;
            case 600:
                message.onekey_device_type = reader.int32();
                break;
            case 601:
                message.onekey_se_type = reader.int32();
                break;
            case 602:
                message.onekey_romloader_version = reader.string();
                break;
            case 603:
                message.onekey_romloader_hash = reader.bytes();
                break;
            case 604:
                message.onekey_bootloader_version = reader.string();
                break;
            case 605:
                message.onekey_bootloader_hash = reader.bytes();
                break;
            case 606:
                message.onekey_se01_version = reader.string();
                break;
            case 607:
                message.onekey_se01_hash = reader.bytes();
                break;
            case 608:
                message.onekey_se01_build_id = reader.string();
                break;
            case 609:
                message.onekey_firmware_version = reader.string();
                break;
            case 610:
                message.onekey_firmware_hash = reader.bytes();
                break;
            case 611:
                message.onekey_firmware_build_id = reader.string();
                break;
            case 612:
                message.onekey_serial_no = reader.string();
                break;
            case 613:
                message.onekey_bootloader_build_id = reader.string();
                break;
            case 614:
                message.onekey_coprocessor_bt_name = reader.string();
                break;
            case 615:
                message.onekey_coprocessor_version = reader.string();
                break;
            case 616:
                message.onekey_coprocessor_build_id = reader.string();
                break;
            case 617:
                message.onekey_coprocessor_hash = reader.bytes();
                break;
            case 618:
                message.onekey_se02_version = reader.string();
                break;
            case 619:
                message.onekey_se03_version = reader.string();
                break;
            case 620:
                message.onekey_se04_version = reader.string();
                break;
            case 621:
                message.onekey_se01_state = reader.int32();
                break;
            case 622:
                message.onekey_se02_state = reader.int32();
                break;
            case 623:
                message.onekey_se03_state = reader.int32();
                break;
            case 624:
                message.onekey_se04_state = reader.int32();
                break;
            case 625:
                message.attach_to_pin_user = reader.bool();
                break;
            case 626:
                message.unlocked_attach_pin = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("major_version"))
            throw $util.ProtocolError("missing required 'major_version'", { instance: message });
        if (!message.hasOwnProperty("minor_version"))
            throw $util.ProtocolError("missing required 'minor_version'", { instance: message });
        if (!message.hasOwnProperty("patch_version"))
            throw $util.ProtocolError("missing required 'patch_version'", { instance: message });
        return message;
    };

    Features.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    Features.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.vendor != null && message.hasOwnProperty("vendor"))
            if (!$util.isString(message.vendor))
                return "vendor: string expected";
        if (!$util.isInteger(message.major_version))
            return "major_version: integer expected";
        if (!$util.isInteger(message.minor_version))
            return "minor_version: integer expected";
        if (!$util.isInteger(message.patch_version))
            return "patch_version: integer expected";
        if (message.bootloader_mode != null && message.hasOwnProperty("bootloader_mode"))
            if (typeof message.bootloader_mode !== "boolean")
                return "bootloader_mode: boolean expected";
        if (message.device_id != null && message.hasOwnProperty("device_id"))
            if (!$util.isString(message.device_id))
                return "device_id: string expected";
        if (message.pin_protection != null && message.hasOwnProperty("pin_protection"))
            if (typeof message.pin_protection !== "boolean")
                return "pin_protection: boolean expected";
        if (message.passphrase_protection != null && message.hasOwnProperty("passphrase_protection"))
            if (typeof message.passphrase_protection !== "boolean")
                return "passphrase_protection: boolean expected";
        if (message.language != null && message.hasOwnProperty("language"))
            if (!$util.isString(message.language))
                return "language: string expected";
        if (message.label != null && message.hasOwnProperty("label"))
            if (!$util.isString(message.label))
                return "label: string expected";
        if (message.initialized != null && message.hasOwnProperty("initialized"))
            if (typeof message.initialized !== "boolean")
                return "initialized: boolean expected";
        if (message.revision != null && message.hasOwnProperty("revision"))
            if (!(message.revision && typeof message.revision.length === "number" || $util.isString(message.revision)))
                return "revision: buffer expected";
        if (message.bootloader_hash != null && message.hasOwnProperty("bootloader_hash"))
            if (!(message.bootloader_hash && typeof message.bootloader_hash.length === "number" || $util.isString(message.bootloader_hash)))
                return "bootloader_hash: buffer expected";
        if (message.imported != null && message.hasOwnProperty("imported"))
            if (typeof message.imported !== "boolean")
                return "imported: boolean expected";
        if (message.unlocked != null && message.hasOwnProperty("unlocked"))
            if (typeof message.unlocked !== "boolean")
                return "unlocked: boolean expected";
        if (message._passphrase_cached != null && message.hasOwnProperty("_passphrase_cached"))
            if (typeof message._passphrase_cached !== "boolean")
                return "_passphrase_cached: boolean expected";
        if (message.firmware_present != null && message.hasOwnProperty("firmware_present"))
            if (typeof message.firmware_present !== "boolean")
                return "firmware_present: boolean expected";
        if (message.needs_backup != null && message.hasOwnProperty("needs_backup"))
            if (typeof message.needs_backup !== "boolean")
                return "needs_backup: boolean expected";
        if (message.flags != null && message.hasOwnProperty("flags"))
            if (!$util.isInteger(message.flags))
                return "flags: integer expected";
        if (message.model != null && message.hasOwnProperty("model"))
            if (!$util.isString(message.model))
                return "model: string expected";
        if (message.fw_major != null && message.hasOwnProperty("fw_major"))
            if (!$util.isInteger(message.fw_major))
                return "fw_major: integer expected";
        if (message.fw_minor != null && message.hasOwnProperty("fw_minor"))
            if (!$util.isInteger(message.fw_minor))
                return "fw_minor: integer expected";
        if (message.fw_patch != null && message.hasOwnProperty("fw_patch"))
            if (!$util.isInteger(message.fw_patch))
                return "fw_patch: integer expected";
        if (message.fw_vendor != null && message.hasOwnProperty("fw_vendor"))
            if (!$util.isString(message.fw_vendor))
                return "fw_vendor: string expected";
        if (message.unfinished_backup != null && message.hasOwnProperty("unfinished_backup"))
            if (typeof message.unfinished_backup !== "boolean")
                return "unfinished_backup: boolean expected";
        if (message.no_backup != null && message.hasOwnProperty("no_backup"))
            if (typeof message.no_backup !== "boolean")
                return "no_backup: boolean expected";
        if (message.recovery_mode != null && message.hasOwnProperty("recovery_mode"))
            if (typeof message.recovery_mode !== "boolean")
                return "recovery_mode: boolean expected";
        if (message.capabilities != null && message.hasOwnProperty("capabilities")) {
            if (!Array.isArray(message.capabilities))
                return "capabilities: array expected";
            for (var i = 0; i < message.capabilities.length; ++i)
                switch (message.capabilities[i]) {
                default:
                    return "capabilities: enum value[] expected";
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 1000:
                    break;
                }
        }
        if (message.backup_type != null && message.hasOwnProperty("backup_type"))
            switch (message.backup_type) {
            default:
                return "backup_type: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
                break;
            }
        if (message.sd_card_present != null && message.hasOwnProperty("sd_card_present"))
            if (typeof message.sd_card_present !== "boolean")
                return "sd_card_present: boolean expected";
        if (message.sd_protection != null && message.hasOwnProperty("sd_protection"))
            if (typeof message.sd_protection !== "boolean")
                return "sd_protection: boolean expected";
        if (message.wipe_code_protection != null && message.hasOwnProperty("wipe_code_protection"))
            if (typeof message.wipe_code_protection !== "boolean")
                return "wipe_code_protection: boolean expected";
        if (message.session_id != null && message.hasOwnProperty("session_id"))
            if (!(message.session_id && typeof message.session_id.length === "number" || $util.isString(message.session_id)))
                return "session_id: buffer expected";
        if (message.passphrase_always_on_device != null && message.hasOwnProperty("passphrase_always_on_device"))
            if (typeof message.passphrase_always_on_device !== "boolean")
                return "passphrase_always_on_device: boolean expected";
        if (message.safety_checks != null && message.hasOwnProperty("safety_checks"))
            switch (message.safety_checks) {
            default:
                return "safety_checks: enum value expected";
            case 0:
            case 1:
            case 2:
                break;
            }
        if (message.auto_lock_delay_ms != null && message.hasOwnProperty("auto_lock_delay_ms"))
            if (!$util.isInteger(message.auto_lock_delay_ms))
                return "auto_lock_delay_ms: integer expected";
        if (message.display_rotation != null && message.hasOwnProperty("display_rotation"))
            if (!$util.isInteger(message.display_rotation))
                return "display_rotation: integer expected";
        if (message.experimental_features != null && message.hasOwnProperty("experimental_features"))
            if (typeof message.experimental_features !== "boolean")
                return "experimental_features: boolean expected";
        if (message.offset != null && message.hasOwnProperty("offset"))
            if (!$util.isInteger(message.offset))
                return "offset: integer expected";
        if (message.coprocessor_bt_name != null && message.hasOwnProperty("coprocessor_bt_name"))
            if (!$util.isString(message.coprocessor_bt_name))
                return "coprocessor_bt_name: string expected";
        if (message.coprocessor_version != null && message.hasOwnProperty("coprocessor_version"))
            if (!$util.isString(message.coprocessor_version))
                return "coprocessor_version: string expected";
        if (message.coprocessor_bt_enable != null && message.hasOwnProperty("coprocessor_bt_enable"))
            if (typeof message.coprocessor_bt_enable !== "boolean")
                return "coprocessor_bt_enable: boolean expected";
        if (message.se_enable != null && message.hasOwnProperty("se_enable"))
            if (typeof message.se_enable !== "boolean")
                return "se_enable: boolean expected";
        if (message.se_ver != null && message.hasOwnProperty("se_ver"))
            if (!$util.isString(message.se_ver))
                return "se_ver: string expected";
        if (message.backup_only != null && message.hasOwnProperty("backup_only"))
            if (typeof message.backup_only !== "boolean")
                return "backup_only: boolean expected";
        if (message.onekey_version != null && message.hasOwnProperty("onekey_version"))
            if (!$util.isString(message.onekey_version))
                return "onekey_version: string expected";
        if (message.onekey_serial != null && message.hasOwnProperty("onekey_serial"))
            if (!$util.isString(message.onekey_serial))
                return "onekey_serial: string expected";
        if (message.bootloader_version != null && message.hasOwnProperty("bootloader_version"))
            if (!$util.isString(message.bootloader_version))
                return "bootloader_version: string expected";
        if (message.serial_no != null && message.hasOwnProperty("serial_no"))
            if (!$util.isString(message.serial_no))
                return "serial_no: string expected";
        if (message.spi_flash != null && message.hasOwnProperty("spi_flash"))
            if (!$util.isString(message.spi_flash))
                return "spi_flash: string expected";
        if (message.initstates != null && message.hasOwnProperty("initstates"))
            if (!$util.isInteger(message.initstates))
                return "initstates: integer expected";
        if (message.NFT_voucher != null && message.hasOwnProperty("NFT_voucher"))
            if (!(message.NFT_voucher && typeof message.NFT_voucher.length === "number" || $util.isString(message.NFT_voucher)))
                return "NFT_voucher: buffer expected";
        if (message.cpu_info != null && message.hasOwnProperty("cpu_info"))
            if (!$util.isString(message.cpu_info))
                return "cpu_info: string expected";
        if (message.pre_firmware != null && message.hasOwnProperty("pre_firmware"))
            if (!$util.isString(message.pre_firmware))
                return "pre_firmware: string expected";
        if (message.coin_switch != null && message.hasOwnProperty("coin_switch"))
            if (!$util.isInteger(message.coin_switch))
                return "coin_switch: integer expected";
        if (message.build_id != null && message.hasOwnProperty("build_id"))
            if (!(message.build_id && typeof message.build_id.length === "number" || $util.isString(message.build_id)))
                return "build_id: buffer expected";
        if (message.romloader_version != null && message.hasOwnProperty("romloader_version"))
            if (!$util.isString(message.romloader_version))
                return "romloader_version: string expected";
        if (message.busy != null && message.hasOwnProperty("busy"))
            if (typeof message.busy !== "boolean")
                return "busy: boolean expected";
        if (message.onekey_device_type != null && message.hasOwnProperty("onekey_device_type"))
            switch (message.onekey_device_type) {
            default:
                return "onekey_device_type: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 5:
                break;
            }
        if (message.onekey_se_type != null && message.hasOwnProperty("onekey_se_type"))
            switch (message.onekey_se_type) {
            default:
                return "onekey_se_type: enum value expected";
            case 0:
            case 1:
                break;
            }
        if (message.onekey_romloader_version != null && message.hasOwnProperty("onekey_romloader_version"))
            if (!$util.isString(message.onekey_romloader_version))
                return "onekey_romloader_version: string expected";
        if (message.onekey_romloader_hash != null && message.hasOwnProperty("onekey_romloader_hash"))
            if (!(message.onekey_romloader_hash && typeof message.onekey_romloader_hash.length === "number" || $util.isString(message.onekey_romloader_hash)))
                return "onekey_romloader_hash: buffer expected";
        if (message.onekey_bootloader_version != null && message.hasOwnProperty("onekey_bootloader_version"))
            if (!$util.isString(message.onekey_bootloader_version))
                return "onekey_bootloader_version: string expected";
        if (message.onekey_bootloader_hash != null && message.hasOwnProperty("onekey_bootloader_hash"))
            if (!(message.onekey_bootloader_hash && typeof message.onekey_bootloader_hash.length === "number" || $util.isString(message.onekey_bootloader_hash)))
                return "onekey_bootloader_hash: buffer expected";
        if (message.onekey_se01_version != null && message.hasOwnProperty("onekey_se01_version"))
            if (!$util.isString(message.onekey_se01_version))
                return "onekey_se01_version: string expected";
        if (message.onekey_se01_hash != null && message.hasOwnProperty("onekey_se01_hash"))
            if (!(message.onekey_se01_hash && typeof message.onekey_se01_hash.length === "number" || $util.isString(message.onekey_se01_hash)))
                return "onekey_se01_hash: buffer expected";
        if (message.onekey_se01_build_id != null && message.hasOwnProperty("onekey_se01_build_id"))
            if (!$util.isString(message.onekey_se01_build_id))
                return "onekey_se01_build_id: string expected";
        if (message.onekey_firmware_version != null && message.hasOwnProperty("onekey_firmware_version"))
            if (!$util.isString(message.onekey_firmware_version))
                return "onekey_firmware_version: string expected";
        if (message.onekey_firmware_hash != null && message.hasOwnProperty("onekey_firmware_hash"))
            if (!(message.onekey_firmware_hash && typeof message.onekey_firmware_hash.length === "number" || $util.isString(message.onekey_firmware_hash)))
                return "onekey_firmware_hash: buffer expected";
        if (message.onekey_firmware_build_id != null && message.hasOwnProperty("onekey_firmware_build_id"))
            if (!$util.isString(message.onekey_firmware_build_id))
                return "onekey_firmware_build_id: string expected";
        if (message.onekey_serial_no != null && message.hasOwnProperty("onekey_serial_no"))
            if (!$util.isString(message.onekey_serial_no))
                return "onekey_serial_no: string expected";
        if (message.onekey_bootloader_build_id != null && message.hasOwnProperty("onekey_bootloader_build_id"))
            if (!$util.isString(message.onekey_bootloader_build_id))
                return "onekey_bootloader_build_id: string expected";
        if (message.onekey_coprocessor_bt_name != null && message.hasOwnProperty("onekey_coprocessor_bt_name"))
            if (!$util.isString(message.onekey_coprocessor_bt_name))
                return "onekey_coprocessor_bt_name: string expected";
        if (message.onekey_coprocessor_version != null && message.hasOwnProperty("onekey_coprocessor_version"))
            if (!$util.isString(message.onekey_coprocessor_version))
                return "onekey_coprocessor_version: string expected";
        if (message.onekey_coprocessor_build_id != null && message.hasOwnProperty("onekey_coprocessor_build_id"))
            if (!$util.isString(message.onekey_coprocessor_build_id))
                return "onekey_coprocessor_build_id: string expected";
        if (message.onekey_coprocessor_hash != null && message.hasOwnProperty("onekey_coprocessor_hash"))
            if (!(message.onekey_coprocessor_hash && typeof message.onekey_coprocessor_hash.length === "number" || $util.isString(message.onekey_coprocessor_hash)))
                return "onekey_coprocessor_hash: buffer expected";
        if (message.onekey_se02_version != null && message.hasOwnProperty("onekey_se02_version"))
            if (!$util.isString(message.onekey_se02_version))
                return "onekey_se02_version: string expected";
        if (message.onekey_se03_version != null && message.hasOwnProperty("onekey_se03_version"))
            if (!$util.isString(message.onekey_se03_version))
                return "onekey_se03_version: string expected";
        if (message.onekey_se04_version != null && message.hasOwnProperty("onekey_se04_version"))
            if (!$util.isString(message.onekey_se04_version))
                return "onekey_se04_version: string expected";
        if (message.onekey_se01_state != null && message.hasOwnProperty("onekey_se01_state"))
            switch (message.onekey_se01_state) {
            default:
                return "onekey_se01_state: enum value expected";
            case 0:
            case 1:
                break;
            }
        if (message.onekey_se02_state != null && message.hasOwnProperty("onekey_se02_state"))
            switch (message.onekey_se02_state) {
            default:
                return "onekey_se02_state: enum value expected";
            case 0:
            case 1:
                break;
            }
        if (message.onekey_se03_state != null && message.hasOwnProperty("onekey_se03_state"))
            switch (message.onekey_se03_state) {
            default:
                return "onekey_se03_state: enum value expected";
            case 0:
            case 1:
                break;
            }
        if (message.onekey_se04_state != null && message.hasOwnProperty("onekey_se04_state"))
            switch (message.onekey_se04_state) {
            default:
                return "onekey_se04_state: enum value expected";
            case 0:
            case 1:
                break;
            }
        if (message.attach_to_pin_user != null && message.hasOwnProperty("attach_to_pin_user"))
            if (typeof message.attach_to_pin_user !== "boolean")
                return "attach_to_pin_user: boolean expected";
        if (message.unlocked_attach_pin != null && message.hasOwnProperty("unlocked_attach_pin"))
            if (typeof message.unlocked_attach_pin !== "boolean")
                return "unlocked_attach_pin: boolean expected";
        return null;
    };

    Features.fromObject = function fromObject(object) {
        if (object instanceof $root.Features)
            return object;
        var message = new $root.Features();
        if (object.vendor != null)
            message.vendor = String(object.vendor);
        if (object.major_version != null)
            message.major_version = object.major_version >>> 0;
        if (object.minor_version != null)
            message.minor_version = object.minor_version >>> 0;
        if (object.patch_version != null)
            message.patch_version = object.patch_version >>> 0;
        if (object.bootloader_mode != null)
            message.bootloader_mode = Boolean(object.bootloader_mode);
        if (object.device_id != null)
            message.device_id = String(object.device_id);
        if (object.pin_protection != null)
            message.pin_protection = Boolean(object.pin_protection);
        if (object.passphrase_protection != null)
            message.passphrase_protection = Boolean(object.passphrase_protection);
        if (object.language != null)
            message.language = String(object.language);
        if (object.label != null)
            message.label = String(object.label);
        if (object.initialized != null)
            message.initialized = Boolean(object.initialized);
        if (object.revision != null)
            if (typeof object.revision === "string")
                $util.base64.decode(object.revision, message.revision = $util.newBuffer($util.base64.length(object.revision)), 0);
            else if (object.revision.length)
                message.revision = object.revision;
        if (object.bootloader_hash != null)
            if (typeof object.bootloader_hash === "string")
                $util.base64.decode(object.bootloader_hash, message.bootloader_hash = $util.newBuffer($util.base64.length(object.bootloader_hash)), 0);
            else if (object.bootloader_hash.length)
                message.bootloader_hash = object.bootloader_hash;
        if (object.imported != null)
            message.imported = Boolean(object.imported);
        if (object.unlocked != null)
            message.unlocked = Boolean(object.unlocked);
        if (object._passphrase_cached != null)
            message._passphrase_cached = Boolean(object._passphrase_cached);
        if (object.firmware_present != null)
            message.firmware_present = Boolean(object.firmware_present);
        if (object.needs_backup != null)
            message.needs_backup = Boolean(object.needs_backup);
        if (object.flags != null)
            message.flags = object.flags >>> 0;
        if (object.model != null)
            message.model = String(object.model);
        if (object.fw_major != null)
            message.fw_major = object.fw_major >>> 0;
        if (object.fw_minor != null)
            message.fw_minor = object.fw_minor >>> 0;
        if (object.fw_patch != null)
            message.fw_patch = object.fw_patch >>> 0;
        if (object.fw_vendor != null)
            message.fw_vendor = String(object.fw_vendor);
        if (object.unfinished_backup != null)
            message.unfinished_backup = Boolean(object.unfinished_backup);
        if (object.no_backup != null)
            message.no_backup = Boolean(object.no_backup);
        if (object.recovery_mode != null)
            message.recovery_mode = Boolean(object.recovery_mode);
        if (object.capabilities) {
            if (!Array.isArray(object.capabilities))
                throw TypeError(".Features.capabilities: array expected");
            message.capabilities = [];
            for (var i = 0; i < object.capabilities.length; ++i)
                switch (object.capabilities[i]) {
                default:
                case "Capability_Bitcoin":
                case 1:
                    message.capabilities[i] = 1;
                    break;
                case "Capability_Bitcoin_like":
                case 2:
                    message.capabilities[i] = 2;
                    break;
                case "Capability_Binance":
                case 3:
                    message.capabilities[i] = 3;
                    break;
                case "Capability_Cardano":
                case 4:
                    message.capabilities[i] = 4;
                    break;
                case "Capability_Crypto":
                case 5:
                    message.capabilities[i] = 5;
                    break;
                case "Capability_EOS":
                case 6:
                    message.capabilities[i] = 6;
                    break;
                case "Capability_Ethereum":
                case 7:
                    message.capabilities[i] = 7;
                    break;
                case "Capability_Lisk":
                case 8:
                    message.capabilities[i] = 8;
                    break;
                case "Capability_Monero":
                case 9:
                    message.capabilities[i] = 9;
                    break;
                case "Capability_NEM":
                case 10:
                    message.capabilities[i] = 10;
                    break;
                case "Capability_Ripple":
                case 11:
                    message.capabilities[i] = 11;
                    break;
                case "Capability_Stellar":
                case 12:
                    message.capabilities[i] = 12;
                    break;
                case "Capability_Tezos":
                case 13:
                    message.capabilities[i] = 13;
                    break;
                case "Capability_U2F":
                case 14:
                    message.capabilities[i] = 14;
                    break;
                case "Capability_Shamir":
                case 15:
                    message.capabilities[i] = 15;
                    break;
                case "Capability_ShamirGroups":
                case 16:
                    message.capabilities[i] = 16;
                    break;
                case "Capability_PassphraseEntry":
                case 17:
                    message.capabilities[i] = 17;
                    break;
                case "Capability_AttachToPin":
                case 18:
                    message.capabilities[i] = 18;
                    break;
                case "Capability_EthereumTypedData":
                case 1000:
                    message.capabilities[i] = 1000;
                    break;
                }
        }
        switch (object.backup_type) {
        case "Bip39":
        case 0:
            message.backup_type = 0;
            break;
        case "Slip39_Basic":
        case 1:
            message.backup_type = 1;
            break;
        case "Slip39_Advanced":
        case 2:
            message.backup_type = 2;
            break;
        case "Slip39_Single_Extendable":
        case 3:
            message.backup_type = 3;
            break;
        case "Slip39_Basic_Extendable":
        case 4:
            message.backup_type = 4;
            break;
        case "Slip39_Advanced_Extendable":
        case 5:
            message.backup_type = 5;
            break;
        }
        if (object.sd_card_present != null)
            message.sd_card_present = Boolean(object.sd_card_present);
        if (object.sd_protection != null)
            message.sd_protection = Boolean(object.sd_protection);
        if (object.wipe_code_protection != null)
            message.wipe_code_protection = Boolean(object.wipe_code_protection);
        if (object.session_id != null)
            if (typeof object.session_id === "string")
                $util.base64.decode(object.session_id, message.session_id = $util.newBuffer($util.base64.length(object.session_id)), 0);
            else if (object.session_id.length)
                message.session_id = object.session_id;
        if (object.passphrase_always_on_device != null)
            message.passphrase_always_on_device = Boolean(object.passphrase_always_on_device);
        switch (object.safety_checks) {
        case "Strict":
        case 0:
            message.safety_checks = 0;
            break;
        case "PromptAlways":
        case 1:
            message.safety_checks = 1;
            break;
        case "PromptTemporarily":
        case 2:
            message.safety_checks = 2;
            break;
        }
        if (object.auto_lock_delay_ms != null)
            message.auto_lock_delay_ms = object.auto_lock_delay_ms >>> 0;
        if (object.display_rotation != null)
            message.display_rotation = object.display_rotation >>> 0;
        if (object.experimental_features != null)
            message.experimental_features = Boolean(object.experimental_features);
        if (object.offset != null)
            message.offset = object.offset >>> 0;
        if (object.coprocessor_bt_name != null)
            message.coprocessor_bt_name = String(object.coprocessor_bt_name);
        if (object.coprocessor_version != null)
            message.coprocessor_version = String(object.coprocessor_version);
        if (object.coprocessor_bt_enable != null)
            message.coprocessor_bt_enable = Boolean(object.coprocessor_bt_enable);
        if (object.se_enable != null)
            message.se_enable = Boolean(object.se_enable);
        if (object.se_ver != null)
            message.se_ver = String(object.se_ver);
        if (object.backup_only != null)
            message.backup_only = Boolean(object.backup_only);
        if (object.onekey_version != null)
            message.onekey_version = String(object.onekey_version);
        if (object.onekey_serial != null)
            message.onekey_serial = String(object.onekey_serial);
        if (object.bootloader_version != null)
            message.bootloader_version = String(object.bootloader_version);
        if (object.serial_no != null)
            message.serial_no = String(object.serial_no);
        if (object.spi_flash != null)
            message.spi_flash = String(object.spi_flash);
        if (object.initstates != null)
            message.initstates = object.initstates >>> 0;
        if (object.NFT_voucher != null)
            if (typeof object.NFT_voucher === "string")
                $util.base64.decode(object.NFT_voucher, message.NFT_voucher = $util.newBuffer($util.base64.length(object.NFT_voucher)), 0);
            else if (object.NFT_voucher.length)
                message.NFT_voucher = object.NFT_voucher;
        if (object.cpu_info != null)
            message.cpu_info = String(object.cpu_info);
        if (object.pre_firmware != null)
            message.pre_firmware = String(object.pre_firmware);
        if (object.coin_switch != null)
            message.coin_switch = object.coin_switch >>> 0;
        if (object.build_id != null)
            if (typeof object.build_id === "string")
                $util.base64.decode(object.build_id, message.build_id = $util.newBuffer($util.base64.length(object.build_id)), 0);
            else if (object.build_id.length)
                message.build_id = object.build_id;
        if (object.romloader_version != null)
            message.romloader_version = String(object.romloader_version);
        if (object.busy != null)
            message.busy = Boolean(object.busy);
        switch (object.onekey_device_type) {
        case "CLASSIC":
        case 0:
            message.onekey_device_type = 0;
            break;
        case "CLASSIC1S":
        case 1:
            message.onekey_device_type = 1;
            break;
        case "MINI":
        case 2:
            message.onekey_device_type = 2;
            break;
        case "TOUCH":
        case 3:
            message.onekey_device_type = 3;
            break;
        case "PRO":
        case 5:
            message.onekey_device_type = 5;
            break;
        }
        switch (object.onekey_se_type) {
        case "THD89":
        case 0:
            message.onekey_se_type = 0;
            break;
        case "SE608A":
        case 1:
            message.onekey_se_type = 1;
            break;
        }
        if (object.onekey_romloader_version != null)
            message.onekey_romloader_version = String(object.onekey_romloader_version);
        if (object.onekey_romloader_hash != null)
            if (typeof object.onekey_romloader_hash === "string")
                $util.base64.decode(object.onekey_romloader_hash, message.onekey_romloader_hash = $util.newBuffer($util.base64.length(object.onekey_romloader_hash)), 0);
            else if (object.onekey_romloader_hash.length)
                message.onekey_romloader_hash = object.onekey_romloader_hash;
        if (object.onekey_bootloader_version != null)
            message.onekey_bootloader_version = String(object.onekey_bootloader_version);
        if (object.onekey_bootloader_hash != null)
            if (typeof object.onekey_bootloader_hash === "string")
                $util.base64.decode(object.onekey_bootloader_hash, message.onekey_bootloader_hash = $util.newBuffer($util.base64.length(object.onekey_bootloader_hash)), 0);
            else if (object.onekey_bootloader_hash.length)
                message.onekey_bootloader_hash = object.onekey_bootloader_hash;
        if (object.onekey_se01_version != null)
            message.onekey_se01_version = String(object.onekey_se01_version);
        if (object.onekey_se01_hash != null)
            if (typeof object.onekey_se01_hash === "string")
                $util.base64.decode(object.onekey_se01_hash, message.onekey_se01_hash = $util.newBuffer($util.base64.length(object.onekey_se01_hash)), 0);
            else if (object.onekey_se01_hash.length)
                message.onekey_se01_hash = object.onekey_se01_hash;
        if (object.onekey_se01_build_id != null)
            message.onekey_se01_build_id = String(object.onekey_se01_build_id);
        if (object.onekey_firmware_version != null)
            message.onekey_firmware_version = String(object.onekey_firmware_version);
        if (object.onekey_firmware_hash != null)
            if (typeof object.onekey_firmware_hash === "string")
                $util.base64.decode(object.onekey_firmware_hash, message.onekey_firmware_hash = $util.newBuffer($util.base64.length(object.onekey_firmware_hash)), 0);
            else if (object.onekey_firmware_hash.length)
                message.onekey_firmware_hash = object.onekey_firmware_hash;
        if (object.onekey_firmware_build_id != null)
            message.onekey_firmware_build_id = String(object.onekey_firmware_build_id);
        if (object.onekey_serial_no != null)
            message.onekey_serial_no = String(object.onekey_serial_no);
        if (object.onekey_bootloader_build_id != null)
            message.onekey_bootloader_build_id = String(object.onekey_bootloader_build_id);
        if (object.onekey_coprocessor_bt_name != null)
            message.onekey_coprocessor_bt_name = String(object.onekey_coprocessor_bt_name);
        if (object.onekey_coprocessor_version != null)
            message.onekey_coprocessor_version = String(object.onekey_coprocessor_version);
        if (object.onekey_coprocessor_build_id != null)
            message.onekey_coprocessor_build_id = String(object.onekey_coprocessor_build_id);
        if (object.onekey_coprocessor_hash != null)
            if (typeof object.onekey_coprocessor_hash === "string")
                $util.base64.decode(object.onekey_coprocessor_hash, message.onekey_coprocessor_hash = $util.newBuffer($util.base64.length(object.onekey_coprocessor_hash)), 0);
            else if (object.onekey_coprocessor_hash.length)
                message.onekey_coprocessor_hash = object.onekey_coprocessor_hash;
        if (object.onekey_se02_version != null)
            message.onekey_se02_version = String(object.onekey_se02_version);
        if (object.onekey_se03_version != null)
            message.onekey_se03_version = String(object.onekey_se03_version);
        if (object.onekey_se04_version != null)
            message.onekey_se04_version = String(object.onekey_se04_version);
        switch (object.onekey_se01_state) {
        case "BOOT":
        case 0:
            message.onekey_se01_state = 0;
            break;
        case "APP":
        case 1:
            message.onekey_se01_state = 1;
            break;
        }
        switch (object.onekey_se02_state) {
        case "BOOT":
        case 0:
            message.onekey_se02_state = 0;
            break;
        case "APP":
        case 1:
            message.onekey_se02_state = 1;
            break;
        }
        switch (object.onekey_se03_state) {
        case "BOOT":
        case 0:
            message.onekey_se03_state = 0;
            break;
        case "APP":
        case 1:
            message.onekey_se03_state = 1;
            break;
        }
        switch (object.onekey_se04_state) {
        case "BOOT":
        case 0:
            message.onekey_se04_state = 0;
            break;
        case "APP":
        case 1:
            message.onekey_se04_state = 1;
            break;
        }
        if (object.attach_to_pin_user != null)
            message.attach_to_pin_user = Boolean(object.attach_to_pin_user);
        if (object.unlocked_attach_pin != null)
            message.unlocked_attach_pin = Boolean(object.unlocked_attach_pin);
        return message;
    };

    Features.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.capabilities = [];
        if (options.defaults) {
            object.vendor = "";
            object.major_version = 0;
            object.minor_version = 0;
            object.patch_version = 0;
            object.bootloader_mode = false;
            object.device_id = "";
            object.pin_protection = false;
            object.passphrase_protection = false;
            object.language = "";
            object.label = "";
            object.initialized = false;
            if (options.bytes === String)
                object.revision = "";
            else {
                object.revision = [];
                if (options.bytes !== Array)
                    object.revision = $util.newBuffer(object.revision);
            }
            if (options.bytes === String)
                object.bootloader_hash = "";
            else {
                object.bootloader_hash = [];
                if (options.bytes !== Array)
                    object.bootloader_hash = $util.newBuffer(object.bootloader_hash);
            }
            object.imported = false;
            object.unlocked = false;
            object._passphrase_cached = false;
            object.firmware_present = false;
            object.needs_backup = false;
            object.flags = 0;
            object.model = "";
            object.fw_major = 0;
            object.fw_minor = 0;
            object.fw_patch = 0;
            object.fw_vendor = "";
            object.unfinished_backup = false;
            object.no_backup = false;
            object.recovery_mode = false;
            object.backup_type = options.enums === String ? "Bip39" : 0;
            object.sd_card_present = false;
            object.sd_protection = false;
            object.wipe_code_protection = false;
            if (options.bytes === String)
                object.session_id = "";
            else {
                object.session_id = [];
                if (options.bytes !== Array)
                    object.session_id = $util.newBuffer(object.session_id);
            }
            object.passphrase_always_on_device = false;
            object.safety_checks = options.enums === String ? "Strict" : 0;
            object.auto_lock_delay_ms = 0;
            object.display_rotation = 0;
            object.experimental_features = false;
            object.busy = false;
            object.offset = 0;
            object.coprocessor_bt_name = "";
            object.coprocessor_version = "";
            object.coprocessor_bt_enable = false;
            object.se_enable = false;
            object.se_ver = "";
            object.backup_only = false;
            object.onekey_version = "";
            object.onekey_serial = "";
            object.bootloader_version = "";
            object.serial_no = "";
            object.spi_flash = "";
            object.initstates = 0;
            if (options.bytes === String)
                object.NFT_voucher = "";
            else {
                object.NFT_voucher = [];
                if (options.bytes !== Array)
                    object.NFT_voucher = $util.newBuffer(object.NFT_voucher);
            }
            object.cpu_info = "";
            object.pre_firmware = "";
            object.coin_switch = 0;
            if (options.bytes === String)
                object.build_id = "";
            else {
                object.build_id = [];
                if (options.bytes !== Array)
                    object.build_id = $util.newBuffer(object.build_id);
            }
            object.romloader_version = "";
            object.onekey_device_type = options.enums === String ? "CLASSIC" : 0;
            object.onekey_se_type = options.enums === String ? "THD89" : 0;
            object.onekey_romloader_version = "";
            if (options.bytes === String)
                object.onekey_romloader_hash = "";
            else {
                object.onekey_romloader_hash = [];
                if (options.bytes !== Array)
                    object.onekey_romloader_hash = $util.newBuffer(object.onekey_romloader_hash);
            }
            object.onekey_bootloader_version = "";
            if (options.bytes === String)
                object.onekey_bootloader_hash = "";
            else {
                object.onekey_bootloader_hash = [];
                if (options.bytes !== Array)
                    object.onekey_bootloader_hash = $util.newBuffer(object.onekey_bootloader_hash);
            }
            object.onekey_se01_version = "";
            if (options.bytes === String)
                object.onekey_se01_hash = "";
            else {
                object.onekey_se01_hash = [];
                if (options.bytes !== Array)
                    object.onekey_se01_hash = $util.newBuffer(object.onekey_se01_hash);
            }
            object.onekey_se01_build_id = "";
            object.onekey_firmware_version = "";
            if (options.bytes === String)
                object.onekey_firmware_hash = "";
            else {
                object.onekey_firmware_hash = [];
                if (options.bytes !== Array)
                    object.onekey_firmware_hash = $util.newBuffer(object.onekey_firmware_hash);
            }
            object.onekey_firmware_build_id = "";
            object.onekey_serial_no = "";
            object.onekey_bootloader_build_id = "";
            object.onekey_coprocessor_bt_name = "";
            object.onekey_coprocessor_version = "";
            object.onekey_coprocessor_build_id = "";
            if (options.bytes === String)
                object.onekey_coprocessor_hash = "";
            else {
                object.onekey_coprocessor_hash = [];
                if (options.bytes !== Array)
                    object.onekey_coprocessor_hash = $util.newBuffer(object.onekey_coprocessor_hash);
            }
            object.onekey_se02_version = "";
            object.onekey_se03_version = "";
            object.onekey_se04_version = "";
            object.onekey_se01_state = options.enums === String ? "BOOT" : 0;
            object.onekey_se02_state = options.enums === String ? "BOOT" : 0;
            object.onekey_se03_state = options.enums === String ? "BOOT" : 0;
            object.onekey_se04_state = options.enums === String ? "BOOT" : 0;
            object.attach_to_pin_user = false;
            object.unlocked_attach_pin = false;
        }
        if (message.vendor != null && message.hasOwnProperty("vendor"))
            object.vendor = message.vendor;
        if (message.major_version != null && message.hasOwnProperty("major_version"))
            object.major_version = message.major_version;
        if (message.minor_version != null && message.hasOwnProperty("minor_version"))
            object.minor_version = message.minor_version;
        if (message.patch_version != null && message.hasOwnProperty("patch_version"))
            object.patch_version = message.patch_version;
        if (message.bootloader_mode != null && message.hasOwnProperty("bootloader_mode"))
            object.bootloader_mode = message.bootloader_mode;
        if (message.device_id != null && message.hasOwnProperty("device_id"))
            object.device_id = message.device_id;
        if (message.pin_protection != null && message.hasOwnProperty("pin_protection"))
            object.pin_protection = message.pin_protection;
        if (message.passphrase_protection != null && message.hasOwnProperty("passphrase_protection"))
            object.passphrase_protection = message.passphrase_protection;
        if (message.language != null && message.hasOwnProperty("language"))
            object.language = message.language;
        if (message.label != null && message.hasOwnProperty("label"))
            object.label = message.label;
        if (message.initialized != null && message.hasOwnProperty("initialized"))
            object.initialized = message.initialized;
        if (message.revision != null && message.hasOwnProperty("revision"))
            object.revision = options.bytes === String ? $util.base64.encode(message.revision, 0, message.revision.length) : options.bytes === Array ? Array.prototype.slice.call(message.revision) : message.revision;
        if (message.bootloader_hash != null && message.hasOwnProperty("bootloader_hash"))
            object.bootloader_hash = options.bytes === String ? $util.base64.encode(message.bootloader_hash, 0, message.bootloader_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.bootloader_hash) : message.bootloader_hash;
        if (message.imported != null && message.hasOwnProperty("imported"))
            object.imported = message.imported;
        if (message.unlocked != null && message.hasOwnProperty("unlocked"))
            object.unlocked = message.unlocked;
        if (message._passphrase_cached != null && message.hasOwnProperty("_passphrase_cached"))
            object._passphrase_cached = message._passphrase_cached;
        if (message.firmware_present != null && message.hasOwnProperty("firmware_present"))
            object.firmware_present = message.firmware_present;
        if (message.needs_backup != null && message.hasOwnProperty("needs_backup"))
            object.needs_backup = message.needs_backup;
        if (message.flags != null && message.hasOwnProperty("flags"))
            object.flags = message.flags;
        if (message.model != null && message.hasOwnProperty("model"))
            object.model = message.model;
        if (message.fw_major != null && message.hasOwnProperty("fw_major"))
            object.fw_major = message.fw_major;
        if (message.fw_minor != null && message.hasOwnProperty("fw_minor"))
            object.fw_minor = message.fw_minor;
        if (message.fw_patch != null && message.hasOwnProperty("fw_patch"))
            object.fw_patch = message.fw_patch;
        if (message.fw_vendor != null && message.hasOwnProperty("fw_vendor"))
            object.fw_vendor = message.fw_vendor;
        if (message.unfinished_backup != null && message.hasOwnProperty("unfinished_backup"))
            object.unfinished_backup = message.unfinished_backup;
        if (message.no_backup != null && message.hasOwnProperty("no_backup"))
            object.no_backup = message.no_backup;
        if (message.recovery_mode != null && message.hasOwnProperty("recovery_mode"))
            object.recovery_mode = message.recovery_mode;
        if (message.capabilities && message.capabilities.length) {
            object.capabilities = [];
            for (var j = 0; j < message.capabilities.length; ++j)
                object.capabilities[j] = options.enums === String ? $root.Features.Capability[message.capabilities[j]] : message.capabilities[j];
        }
        if (message.backup_type != null && message.hasOwnProperty("backup_type"))
            object.backup_type = options.enums === String ? $root.BackupType[message.backup_type] : message.backup_type;
        if (message.sd_card_present != null && message.hasOwnProperty("sd_card_present"))
            object.sd_card_present = message.sd_card_present;
        if (message.sd_protection != null && message.hasOwnProperty("sd_protection"))
            object.sd_protection = message.sd_protection;
        if (message.wipe_code_protection != null && message.hasOwnProperty("wipe_code_protection"))
            object.wipe_code_protection = message.wipe_code_protection;
        if (message.session_id != null && message.hasOwnProperty("session_id"))
            object.session_id = options.bytes === String ? $util.base64.encode(message.session_id, 0, message.session_id.length) : options.bytes === Array ? Array.prototype.slice.call(message.session_id) : message.session_id;
        if (message.passphrase_always_on_device != null && message.hasOwnProperty("passphrase_always_on_device"))
            object.passphrase_always_on_device = message.passphrase_always_on_device;
        if (message.safety_checks != null && message.hasOwnProperty("safety_checks"))
            object.safety_checks = options.enums === String ? $root.SafetyCheckLevel[message.safety_checks] : message.safety_checks;
        if (message.auto_lock_delay_ms != null && message.hasOwnProperty("auto_lock_delay_ms"))
            object.auto_lock_delay_ms = message.auto_lock_delay_ms;
        if (message.display_rotation != null && message.hasOwnProperty("display_rotation"))
            object.display_rotation = message.display_rotation;
        if (message.experimental_features != null && message.hasOwnProperty("experimental_features"))
            object.experimental_features = message.experimental_features;
        if (message.busy != null && message.hasOwnProperty("busy"))
            object.busy = message.busy;
        if (message.offset != null && message.hasOwnProperty("offset"))
            object.offset = message.offset;
        if (message.coprocessor_bt_name != null && message.hasOwnProperty("coprocessor_bt_name"))
            object.coprocessor_bt_name = message.coprocessor_bt_name;
        if (message.coprocessor_version != null && message.hasOwnProperty("coprocessor_version"))
            object.coprocessor_version = message.coprocessor_version;
        if (message.coprocessor_bt_enable != null && message.hasOwnProperty("coprocessor_bt_enable"))
            object.coprocessor_bt_enable = message.coprocessor_bt_enable;
        if (message.se_enable != null && message.hasOwnProperty("se_enable"))
            object.se_enable = message.se_enable;
        if (message.se_ver != null && message.hasOwnProperty("se_ver"))
            object.se_ver = message.se_ver;
        if (message.backup_only != null && message.hasOwnProperty("backup_only"))
            object.backup_only = message.backup_only;
        if (message.onekey_version != null && message.hasOwnProperty("onekey_version"))
            object.onekey_version = message.onekey_version;
        if (message.onekey_serial != null && message.hasOwnProperty("onekey_serial"))
            object.onekey_serial = message.onekey_serial;
        if (message.bootloader_version != null && message.hasOwnProperty("bootloader_version"))
            object.bootloader_version = message.bootloader_version;
        if (message.serial_no != null && message.hasOwnProperty("serial_no"))
            object.serial_no = message.serial_no;
        if (message.spi_flash != null && message.hasOwnProperty("spi_flash"))
            object.spi_flash = message.spi_flash;
        if (message.initstates != null && message.hasOwnProperty("initstates"))
            object.initstates = message.initstates;
        if (message.NFT_voucher != null && message.hasOwnProperty("NFT_voucher"))
            object.NFT_voucher = options.bytes === String ? $util.base64.encode(message.NFT_voucher, 0, message.NFT_voucher.length) : options.bytes === Array ? Array.prototype.slice.call(message.NFT_voucher) : message.NFT_voucher;
        if (message.cpu_info != null && message.hasOwnProperty("cpu_info"))
            object.cpu_info = message.cpu_info;
        if (message.pre_firmware != null && message.hasOwnProperty("pre_firmware"))
            object.pre_firmware = message.pre_firmware;
        if (message.coin_switch != null && message.hasOwnProperty("coin_switch"))
            object.coin_switch = message.coin_switch;
        if (message.build_id != null && message.hasOwnProperty("build_id"))
            object.build_id = options.bytes === String ? $util.base64.encode(message.build_id, 0, message.build_id.length) : options.bytes === Array ? Array.prototype.slice.call(message.build_id) : message.build_id;
        if (message.romloader_version != null && message.hasOwnProperty("romloader_version"))
            object.romloader_version = message.romloader_version;
        if (message.onekey_device_type != null && message.hasOwnProperty("onekey_device_type"))
            object.onekey_device_type = options.enums === String ? $root.OneKeyDeviceType[message.onekey_device_type] : message.onekey_device_type;
        if (message.onekey_se_type != null && message.hasOwnProperty("onekey_se_type"))
            object.onekey_se_type = options.enums === String ? $root.OneKeySeType[message.onekey_se_type] : message.onekey_se_type;
        if (message.onekey_romloader_version != null && message.hasOwnProperty("onekey_romloader_version"))
            object.onekey_romloader_version = message.onekey_romloader_version;
        if (message.onekey_romloader_hash != null && message.hasOwnProperty("onekey_romloader_hash"))
            object.onekey_romloader_hash = options.bytes === String ? $util.base64.encode(message.onekey_romloader_hash, 0, message.onekey_romloader_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.onekey_romloader_hash) : message.onekey_romloader_hash;
        if (message.onekey_bootloader_version != null && message.hasOwnProperty("onekey_bootloader_version"))
            object.onekey_bootloader_version = message.onekey_bootloader_version;
        if (message.onekey_bootloader_hash != null && message.hasOwnProperty("onekey_bootloader_hash"))
            object.onekey_bootloader_hash = options.bytes === String ? $util.base64.encode(message.onekey_bootloader_hash, 0, message.onekey_bootloader_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.onekey_bootloader_hash) : message.onekey_bootloader_hash;
        if (message.onekey_se01_version != null && message.hasOwnProperty("onekey_se01_version"))
            object.onekey_se01_version = message.onekey_se01_version;
        if (message.onekey_se01_hash != null && message.hasOwnProperty("onekey_se01_hash"))
            object.onekey_se01_hash = options.bytes === String ? $util.base64.encode(message.onekey_se01_hash, 0, message.onekey_se01_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.onekey_se01_hash) : message.onekey_se01_hash;
        if (message.onekey_se01_build_id != null && message.hasOwnProperty("onekey_se01_build_id"))
            object.onekey_se01_build_id = message.onekey_se01_build_id;
        if (message.onekey_firmware_version != null && message.hasOwnProperty("onekey_firmware_version"))
            object.onekey_firmware_version = message.onekey_firmware_version;
        if (message.onekey_firmware_hash != null && message.hasOwnProperty("onekey_firmware_hash"))
            object.onekey_firmware_hash = options.bytes === String ? $util.base64.encode(message.onekey_firmware_hash, 0, message.onekey_firmware_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.onekey_firmware_hash) : message.onekey_firmware_hash;
        if (message.onekey_firmware_build_id != null && message.hasOwnProperty("onekey_firmware_build_id"))
            object.onekey_firmware_build_id = message.onekey_firmware_build_id;
        if (message.onekey_serial_no != null && message.hasOwnProperty("onekey_serial_no"))
            object.onekey_serial_no = message.onekey_serial_no;
        if (message.onekey_bootloader_build_id != null && message.hasOwnProperty("onekey_bootloader_build_id"))
            object.onekey_bootloader_build_id = message.onekey_bootloader_build_id;
        if (message.onekey_coprocessor_bt_name != null && message.hasOwnProperty("onekey_coprocessor_bt_name"))
            object.onekey_coprocessor_bt_name = message.onekey_coprocessor_bt_name;
        if (message.onekey_coprocessor_version != null && message.hasOwnProperty("onekey_coprocessor_version"))
            object.onekey_coprocessor_version = message.onekey_coprocessor_version;
        if (message.onekey_coprocessor_build_id != null && message.hasOwnProperty("onekey_coprocessor_build_id"))
            object.onekey_coprocessor_build_id = message.onekey_coprocessor_build_id;
        if (message.onekey_coprocessor_hash != null && message.hasOwnProperty("onekey_coprocessor_hash"))
            object.onekey_coprocessor_hash = options.bytes === String ? $util.base64.encode(message.onekey_coprocessor_hash, 0, message.onekey_coprocessor_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.onekey_coprocessor_hash) : message.onekey_coprocessor_hash;
        if (message.onekey_se02_version != null && message.hasOwnProperty("onekey_se02_version"))
            object.onekey_se02_version = message.onekey_se02_version;
        if (message.onekey_se03_version != null && message.hasOwnProperty("onekey_se03_version"))
            object.onekey_se03_version = message.onekey_se03_version;
        if (message.onekey_se04_version != null && message.hasOwnProperty("onekey_se04_version"))
            object.onekey_se04_version = message.onekey_se04_version;
        if (message.onekey_se01_state != null && message.hasOwnProperty("onekey_se01_state"))
            object.onekey_se01_state = options.enums === String ? $root.OneKeySEState[message.onekey_se01_state] : message.onekey_se01_state;
        if (message.onekey_se02_state != null && message.hasOwnProperty("onekey_se02_state"))
            object.onekey_se02_state = options.enums === String ? $root.OneKeySEState[message.onekey_se02_state] : message.onekey_se02_state;
        if (message.onekey_se03_state != null && message.hasOwnProperty("onekey_se03_state"))
            object.onekey_se03_state = options.enums === String ? $root.OneKeySEState[message.onekey_se03_state] : message.onekey_se03_state;
        if (message.onekey_se04_state != null && message.hasOwnProperty("onekey_se04_state"))
            object.onekey_se04_state = options.enums === String ? $root.OneKeySEState[message.onekey_se04_state] : message.onekey_se04_state;
        if (message.attach_to_pin_user != null && message.hasOwnProperty("attach_to_pin_user"))
            object.attach_to_pin_user = message.attach_to_pin_user;
        if (message.unlocked_attach_pin != null && message.hasOwnProperty("unlocked_attach_pin"))
            object.unlocked_attach_pin = message.unlocked_attach_pin;
        return object;
    };

    Features.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    Features.Capability = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[1] = "Capability_Bitcoin"] = 1;
        values[valuesById[2] = "Capability_Bitcoin_like"] = 2;
        values[valuesById[3] = "Capability_Binance"] = 3;
        values[valuesById[4] = "Capability_Cardano"] = 4;
        values[valuesById[5] = "Capability_Crypto"] = 5;
        values[valuesById[6] = "Capability_EOS"] = 6;
        values[valuesById[7] = "Capability_Ethereum"] = 7;
        values[valuesById[8] = "Capability_Lisk"] = 8;
        values[valuesById[9] = "Capability_Monero"] = 9;
        values[valuesById[10] = "Capability_NEM"] = 10;
        values[valuesById[11] = "Capability_Ripple"] = 11;
        values[valuesById[12] = "Capability_Stellar"] = 12;
        values[valuesById[13] = "Capability_Tezos"] = 13;
        values[valuesById[14] = "Capability_U2F"] = 14;
        values[valuesById[15] = "Capability_Shamir"] = 15;
        values[valuesById[16] = "Capability_ShamirGroups"] = 16;
        values[valuesById[17] = "Capability_PassphraseEntry"] = 17;
        values[valuesById[18] = "Capability_AttachToPin"] = 18;
        values[valuesById[1000] = "Capability_EthereumTypedData"] = 1000;
        return values;
    })();

    return Features;
})();

$root.OnekeyFeatures = (function() {

    function OnekeyFeatures(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    OnekeyFeatures.prototype.onekey_device_type = 0;
    OnekeyFeatures.prototype.onekey_romloader_version = "";
    OnekeyFeatures.prototype.onekey_bootloader_version = "";
    OnekeyFeatures.prototype.onekey_firmware_version = "";
    OnekeyFeatures.prototype.onekey_romloader_hash = $util.newBuffer([]);
    OnekeyFeatures.prototype.onekey_bootloader_hash = $util.newBuffer([]);
    OnekeyFeatures.prototype.onekey_firmware_hash = $util.newBuffer([]);
    OnekeyFeatures.prototype.onekey_romloader_build_id = "";
    OnekeyFeatures.prototype.onekey_bootloader_build_id = "";
    OnekeyFeatures.prototype.onekey_firmware_build_id = "";
    OnekeyFeatures.prototype.onekey_serial_no = "";
    OnekeyFeatures.prototype.onekey_coprocessor_bt_name = "";
    OnekeyFeatures.prototype.onekey_coprocessor_version = "";
    OnekeyFeatures.prototype.onekey_coprocessor_build_id = "";
    OnekeyFeatures.prototype.onekey_coprocessor_hash = $util.newBuffer([]);
    OnekeyFeatures.prototype.onekey_se_type = 0;
    OnekeyFeatures.prototype.onekey_se01_state = 0;
    OnekeyFeatures.prototype.onekey_se02_state = 0;
    OnekeyFeatures.prototype.onekey_se03_state = 0;
    OnekeyFeatures.prototype.onekey_se04_state = 0;
    OnekeyFeatures.prototype.onekey_se01_version = "";
    OnekeyFeatures.prototype.onekey_se02_version = "";
    OnekeyFeatures.prototype.onekey_se03_version = "";
    OnekeyFeatures.prototype.onekey_se04_version = "";
    OnekeyFeatures.prototype.onekey_se01_hash = $util.newBuffer([]);
    OnekeyFeatures.prototype.onekey_se02_hash = $util.newBuffer([]);
    OnekeyFeatures.prototype.onekey_se03_hash = $util.newBuffer([]);
    OnekeyFeatures.prototype.onekey_se04_hash = $util.newBuffer([]);
    OnekeyFeatures.prototype.onekey_se01_build_id = "";
    OnekeyFeatures.prototype.onekey_se02_build_id = "";
    OnekeyFeatures.prototype.onekey_se03_build_id = "";
    OnekeyFeatures.prototype.onekey_se04_build_id = "";
    OnekeyFeatures.prototype.onekey_se01_bootloader_version = "";
    OnekeyFeatures.prototype.onekey_se02_bootloader_version = "";
    OnekeyFeatures.prototype.onekey_se03_bootloader_version = "";
    OnekeyFeatures.prototype.onekey_se04_bootloader_version = "";
    OnekeyFeatures.prototype.onekey_se01_bootloader_hash = $util.newBuffer([]);
    OnekeyFeatures.prototype.onekey_se02_bootloader_hash = $util.newBuffer([]);
    OnekeyFeatures.prototype.onekey_se03_bootloader_hash = $util.newBuffer([]);
    OnekeyFeatures.prototype.onekey_se04_bootloader_hash = $util.newBuffer([]);
    OnekeyFeatures.prototype.onekey_se01_bootloader_build_id = "";
    OnekeyFeatures.prototype.onekey_se02_bootloader_build_id = "";
    OnekeyFeatures.prototype.onekey_se03_bootloader_build_id = "";
    OnekeyFeatures.prototype.onekey_se04_bootloader_build_id = "";

    OnekeyFeatures.create = function create(properties) {
        return new OnekeyFeatures(properties);
    };

    OnekeyFeatures.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.onekey_device_type != null && Object.hasOwnProperty.call(message, "onekey_device_type"))
            writer.uint32(8).int32(message.onekey_device_type);
        if (message.onekey_romloader_version != null && Object.hasOwnProperty.call(message, "onekey_romloader_version"))
            writer.uint32(18).string(message.onekey_romloader_version);
        if (message.onekey_bootloader_version != null && Object.hasOwnProperty.call(message, "onekey_bootloader_version"))
            writer.uint32(26).string(message.onekey_bootloader_version);
        if (message.onekey_firmware_version != null && Object.hasOwnProperty.call(message, "onekey_firmware_version"))
            writer.uint32(34).string(message.onekey_firmware_version);
        if (message.onekey_romloader_hash != null && Object.hasOwnProperty.call(message, "onekey_romloader_hash"))
            writer.uint32(42).bytes(message.onekey_romloader_hash);
        if (message.onekey_bootloader_hash != null && Object.hasOwnProperty.call(message, "onekey_bootloader_hash"))
            writer.uint32(50).bytes(message.onekey_bootloader_hash);
        if (message.onekey_firmware_hash != null && Object.hasOwnProperty.call(message, "onekey_firmware_hash"))
            writer.uint32(58).bytes(message.onekey_firmware_hash);
        if (message.onekey_romloader_build_id != null && Object.hasOwnProperty.call(message, "onekey_romloader_build_id"))
            writer.uint32(66).string(message.onekey_romloader_build_id);
        if (message.onekey_bootloader_build_id != null && Object.hasOwnProperty.call(message, "onekey_bootloader_build_id"))
            writer.uint32(74).string(message.onekey_bootloader_build_id);
        if (message.onekey_firmware_build_id != null && Object.hasOwnProperty.call(message, "onekey_firmware_build_id"))
            writer.uint32(82).string(message.onekey_firmware_build_id);
        if (message.onekey_serial_no != null && Object.hasOwnProperty.call(message, "onekey_serial_no"))
            writer.uint32(90).string(message.onekey_serial_no);
        if (message.onekey_coprocessor_bt_name != null && Object.hasOwnProperty.call(message, "onekey_coprocessor_bt_name"))
            writer.uint32(98).string(message.onekey_coprocessor_bt_name);
        if (message.onekey_coprocessor_version != null && Object.hasOwnProperty.call(message, "onekey_coprocessor_version"))
            writer.uint32(106).string(message.onekey_coprocessor_version);
        if (message.onekey_coprocessor_build_id != null && Object.hasOwnProperty.call(message, "onekey_coprocessor_build_id"))
            writer.uint32(114).string(message.onekey_coprocessor_build_id);
        if (message.onekey_coprocessor_hash != null && Object.hasOwnProperty.call(message, "onekey_coprocessor_hash"))
            writer.uint32(122).bytes(message.onekey_coprocessor_hash);
        if (message.onekey_se_type != null && Object.hasOwnProperty.call(message, "onekey_se_type"))
            writer.uint32(128).int32(message.onekey_se_type);
        if (message.onekey_se01_state != null && Object.hasOwnProperty.call(message, "onekey_se01_state"))
            writer.uint32(136).int32(message.onekey_se01_state);
        if (message.onekey_se02_state != null && Object.hasOwnProperty.call(message, "onekey_se02_state"))
            writer.uint32(144).int32(message.onekey_se02_state);
        if (message.onekey_se03_state != null && Object.hasOwnProperty.call(message, "onekey_se03_state"))
            writer.uint32(152).int32(message.onekey_se03_state);
        if (message.onekey_se04_state != null && Object.hasOwnProperty.call(message, "onekey_se04_state"))
            writer.uint32(160).int32(message.onekey_se04_state);
        if (message.onekey_se01_version != null && Object.hasOwnProperty.call(message, "onekey_se01_version"))
            writer.uint32(170).string(message.onekey_se01_version);
        if (message.onekey_se02_version != null && Object.hasOwnProperty.call(message, "onekey_se02_version"))
            writer.uint32(178).string(message.onekey_se02_version);
        if (message.onekey_se03_version != null && Object.hasOwnProperty.call(message, "onekey_se03_version"))
            writer.uint32(186).string(message.onekey_se03_version);
        if (message.onekey_se04_version != null && Object.hasOwnProperty.call(message, "onekey_se04_version"))
            writer.uint32(194).string(message.onekey_se04_version);
        if (message.onekey_se01_hash != null && Object.hasOwnProperty.call(message, "onekey_se01_hash"))
            writer.uint32(202).bytes(message.onekey_se01_hash);
        if (message.onekey_se02_hash != null && Object.hasOwnProperty.call(message, "onekey_se02_hash"))
            writer.uint32(210).bytes(message.onekey_se02_hash);
        if (message.onekey_se03_hash != null && Object.hasOwnProperty.call(message, "onekey_se03_hash"))
            writer.uint32(218).bytes(message.onekey_se03_hash);
        if (message.onekey_se04_hash != null && Object.hasOwnProperty.call(message, "onekey_se04_hash"))
            writer.uint32(226).bytes(message.onekey_se04_hash);
        if (message.onekey_se01_build_id != null && Object.hasOwnProperty.call(message, "onekey_se01_build_id"))
            writer.uint32(234).string(message.onekey_se01_build_id);
        if (message.onekey_se02_build_id != null && Object.hasOwnProperty.call(message, "onekey_se02_build_id"))
            writer.uint32(242).string(message.onekey_se02_build_id);
        if (message.onekey_se03_build_id != null && Object.hasOwnProperty.call(message, "onekey_se03_build_id"))
            writer.uint32(250).string(message.onekey_se03_build_id);
        if (message.onekey_se04_build_id != null && Object.hasOwnProperty.call(message, "onekey_se04_build_id"))
            writer.uint32(258).string(message.onekey_se04_build_id);
        if (message.onekey_se01_bootloader_version != null && Object.hasOwnProperty.call(message, "onekey_se01_bootloader_version"))
            writer.uint32(266).string(message.onekey_se01_bootloader_version);
        if (message.onekey_se02_bootloader_version != null && Object.hasOwnProperty.call(message, "onekey_se02_bootloader_version"))
            writer.uint32(274).string(message.onekey_se02_bootloader_version);
        if (message.onekey_se03_bootloader_version != null && Object.hasOwnProperty.call(message, "onekey_se03_bootloader_version"))
            writer.uint32(282).string(message.onekey_se03_bootloader_version);
        if (message.onekey_se04_bootloader_version != null && Object.hasOwnProperty.call(message, "onekey_se04_bootloader_version"))
            writer.uint32(290).string(message.onekey_se04_bootloader_version);
        if (message.onekey_se01_bootloader_hash != null && Object.hasOwnProperty.call(message, "onekey_se01_bootloader_hash"))
            writer.uint32(298).bytes(message.onekey_se01_bootloader_hash);
        if (message.onekey_se02_bootloader_hash != null && Object.hasOwnProperty.call(message, "onekey_se02_bootloader_hash"))
            writer.uint32(306).bytes(message.onekey_se02_bootloader_hash);
        if (message.onekey_se03_bootloader_hash != null && Object.hasOwnProperty.call(message, "onekey_se03_bootloader_hash"))
            writer.uint32(314).bytes(message.onekey_se03_bootloader_hash);
        if (message.onekey_se04_bootloader_hash != null && Object.hasOwnProperty.call(message, "onekey_se04_bootloader_hash"))
            writer.uint32(322).bytes(message.onekey_se04_bootloader_hash);
        if (message.onekey_se01_bootloader_build_id != null && Object.hasOwnProperty.call(message, "onekey_se01_bootloader_build_id"))
            writer.uint32(330).string(message.onekey_se01_bootloader_build_id);
        if (message.onekey_se02_bootloader_build_id != null && Object.hasOwnProperty.call(message, "onekey_se02_bootloader_build_id"))
            writer.uint32(338).string(message.onekey_se02_bootloader_build_id);
        if (message.onekey_se03_bootloader_build_id != null && Object.hasOwnProperty.call(message, "onekey_se03_bootloader_build_id"))
            writer.uint32(346).string(message.onekey_se03_bootloader_build_id);
        if (message.onekey_se04_bootloader_build_id != null && Object.hasOwnProperty.call(message, "onekey_se04_bootloader_build_id"))
            writer.uint32(354).string(message.onekey_se04_bootloader_build_id);
        return writer;
    };

    OnekeyFeatures.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    OnekeyFeatures.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.OnekeyFeatures();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.onekey_device_type = reader.int32();
                break;
            case 2:
                message.onekey_romloader_version = reader.string();
                break;
            case 3:
                message.onekey_bootloader_version = reader.string();
                break;
            case 4:
                message.onekey_firmware_version = reader.string();
                break;
            case 5:
                message.onekey_romloader_hash = reader.bytes();
                break;
            case 6:
                message.onekey_bootloader_hash = reader.bytes();
                break;
            case 7:
                message.onekey_firmware_hash = reader.bytes();
                break;
            case 8:
                message.onekey_romloader_build_id = reader.string();
                break;
            case 9:
                message.onekey_bootloader_build_id = reader.string();
                break;
            case 10:
                message.onekey_firmware_build_id = reader.string();
                break;
            case 11:
                message.onekey_serial_no = reader.string();
                break;
            case 12:
                message.onekey_coprocessor_bt_name = reader.string();
                break;
            case 13:
                message.onekey_coprocessor_version = reader.string();
                break;
            case 14:
                message.onekey_coprocessor_build_id = reader.string();
                break;
            case 15:
                message.onekey_coprocessor_hash = reader.bytes();
                break;
            case 16:
                message.onekey_se_type = reader.int32();
                break;
            case 17:
                message.onekey_se01_state = reader.int32();
                break;
            case 18:
                message.onekey_se02_state = reader.int32();
                break;
            case 19:
                message.onekey_se03_state = reader.int32();
                break;
            case 20:
                message.onekey_se04_state = reader.int32();
                break;
            case 21:
                message.onekey_se01_version = reader.string();
                break;
            case 22:
                message.onekey_se02_version = reader.string();
                break;
            case 23:
                message.onekey_se03_version = reader.string();
                break;
            case 24:
                message.onekey_se04_version = reader.string();
                break;
            case 25:
                message.onekey_se01_hash = reader.bytes();
                break;
            case 26:
                message.onekey_se02_hash = reader.bytes();
                break;
            case 27:
                message.onekey_se03_hash = reader.bytes();
                break;
            case 28:
                message.onekey_se04_hash = reader.bytes();
                break;
            case 29:
                message.onekey_se01_build_id = reader.string();
                break;
            case 30:
                message.onekey_se02_build_id = reader.string();
                break;
            case 31:
                message.onekey_se03_build_id = reader.string();
                break;
            case 32:
                message.onekey_se04_build_id = reader.string();
                break;
            case 33:
                message.onekey_se01_bootloader_version = reader.string();
                break;
            case 34:
                message.onekey_se02_bootloader_version = reader.string();
                break;
            case 35:
                message.onekey_se03_bootloader_version = reader.string();
                break;
            case 36:
                message.onekey_se04_bootloader_version = reader.string();
                break;
            case 37:
                message.onekey_se01_bootloader_hash = reader.bytes();
                break;
            case 38:
                message.onekey_se02_bootloader_hash = reader.bytes();
                break;
            case 39:
                message.onekey_se03_bootloader_hash = reader.bytes();
                break;
            case 40:
                message.onekey_se04_bootloader_hash = reader.bytes();
                break;
            case 41:
                message.onekey_se01_bootloader_build_id = reader.string();
                break;
            case 42:
                message.onekey_se02_bootloader_build_id = reader.string();
                break;
            case 43:
                message.onekey_se03_bootloader_build_id = reader.string();
                break;
            case 44:
                message.onekey_se04_bootloader_build_id = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    OnekeyFeatures.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    OnekeyFeatures.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.onekey_device_type != null && message.hasOwnProperty("onekey_device_type"))
            switch (message.onekey_device_type) {
            default:
                return "onekey_device_type: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 5:
                break;
            }
        if (message.onekey_romloader_version != null && message.hasOwnProperty("onekey_romloader_version"))
            if (!$util.isString(message.onekey_romloader_version))
                return "onekey_romloader_version: string expected";
        if (message.onekey_bootloader_version != null && message.hasOwnProperty("onekey_bootloader_version"))
            if (!$util.isString(message.onekey_bootloader_version))
                return "onekey_bootloader_version: string expected";
        if (message.onekey_firmware_version != null && message.hasOwnProperty("onekey_firmware_version"))
            if (!$util.isString(message.onekey_firmware_version))
                return "onekey_firmware_version: string expected";
        if (message.onekey_romloader_hash != null && message.hasOwnProperty("onekey_romloader_hash"))
            if (!(message.onekey_romloader_hash && typeof message.onekey_romloader_hash.length === "number" || $util.isString(message.onekey_romloader_hash)))
                return "onekey_romloader_hash: buffer expected";
        if (message.onekey_bootloader_hash != null && message.hasOwnProperty("onekey_bootloader_hash"))
            if (!(message.onekey_bootloader_hash && typeof message.onekey_bootloader_hash.length === "number" || $util.isString(message.onekey_bootloader_hash)))
                return "onekey_bootloader_hash: buffer expected";
        if (message.onekey_firmware_hash != null && message.hasOwnProperty("onekey_firmware_hash"))
            if (!(message.onekey_firmware_hash && typeof message.onekey_firmware_hash.length === "number" || $util.isString(message.onekey_firmware_hash)))
                return "onekey_firmware_hash: buffer expected";
        if (message.onekey_romloader_build_id != null && message.hasOwnProperty("onekey_romloader_build_id"))
            if (!$util.isString(message.onekey_romloader_build_id))
                return "onekey_romloader_build_id: string expected";
        if (message.onekey_bootloader_build_id != null && message.hasOwnProperty("onekey_bootloader_build_id"))
            if (!$util.isString(message.onekey_bootloader_build_id))
                return "onekey_bootloader_build_id: string expected";
        if (message.onekey_firmware_build_id != null && message.hasOwnProperty("onekey_firmware_build_id"))
            if (!$util.isString(message.onekey_firmware_build_id))
                return "onekey_firmware_build_id: string expected";
        if (message.onekey_serial_no != null && message.hasOwnProperty("onekey_serial_no"))
            if (!$util.isString(message.onekey_serial_no))
                return "onekey_serial_no: string expected";
        if (message.onekey_coprocessor_bt_name != null && message.hasOwnProperty("onekey_coprocessor_bt_name"))
            if (!$util.isString(message.onekey_coprocessor_bt_name))
                return "onekey_coprocessor_bt_name: string expected";
        if (message.onekey_coprocessor_version != null && message.hasOwnProperty("onekey_coprocessor_version"))
            if (!$util.isString(message.onekey_coprocessor_version))
                return "onekey_coprocessor_version: string expected";
        if (message.onekey_coprocessor_build_id != null && message.hasOwnProperty("onekey_coprocessor_build_id"))
            if (!$util.isString(message.onekey_coprocessor_build_id))
                return "onekey_coprocessor_build_id: string expected";
        if (message.onekey_coprocessor_hash != null && message.hasOwnProperty("onekey_coprocessor_hash"))
            if (!(message.onekey_coprocessor_hash && typeof message.onekey_coprocessor_hash.length === "number" || $util.isString(message.onekey_coprocessor_hash)))
                return "onekey_coprocessor_hash: buffer expected";
        if (message.onekey_se_type != null && message.hasOwnProperty("onekey_se_type"))
            switch (message.onekey_se_type) {
            default:
                return "onekey_se_type: enum value expected";
            case 0:
            case 1:
                break;
            }
        if (message.onekey_se01_state != null && message.hasOwnProperty("onekey_se01_state"))
            switch (message.onekey_se01_state) {
            default:
                return "onekey_se01_state: enum value expected";
            case 0:
            case 1:
                break;
            }
        if (message.onekey_se02_state != null && message.hasOwnProperty("onekey_se02_state"))
            switch (message.onekey_se02_state) {
            default:
                return "onekey_se02_state: enum value expected";
            case 0:
            case 1:
                break;
            }
        if (message.onekey_se03_state != null && message.hasOwnProperty("onekey_se03_state"))
            switch (message.onekey_se03_state) {
            default:
                return "onekey_se03_state: enum value expected";
            case 0:
            case 1:
                break;
            }
        if (message.onekey_se04_state != null && message.hasOwnProperty("onekey_se04_state"))
            switch (message.onekey_se04_state) {
            default:
                return "onekey_se04_state: enum value expected";
            case 0:
            case 1:
                break;
            }
        if (message.onekey_se01_version != null && message.hasOwnProperty("onekey_se01_version"))
            if (!$util.isString(message.onekey_se01_version))
                return "onekey_se01_version: string expected";
        if (message.onekey_se02_version != null && message.hasOwnProperty("onekey_se02_version"))
            if (!$util.isString(message.onekey_se02_version))
                return "onekey_se02_version: string expected";
        if (message.onekey_se03_version != null && message.hasOwnProperty("onekey_se03_version"))
            if (!$util.isString(message.onekey_se03_version))
                return "onekey_se03_version: string expected";
        if (message.onekey_se04_version != null && message.hasOwnProperty("onekey_se04_version"))
            if (!$util.isString(message.onekey_se04_version))
                return "onekey_se04_version: string expected";
        if (message.onekey_se01_hash != null && message.hasOwnProperty("onekey_se01_hash"))
            if (!(message.onekey_se01_hash && typeof message.onekey_se01_hash.length === "number" || $util.isString(message.onekey_se01_hash)))
                return "onekey_se01_hash: buffer expected";
        if (message.onekey_se02_hash != null && message.hasOwnProperty("onekey_se02_hash"))
            if (!(message.onekey_se02_hash && typeof message.onekey_se02_hash.length === "number" || $util.isString(message.onekey_se02_hash)))
                return "onekey_se02_hash: buffer expected";
        if (message.onekey_se03_hash != null && message.hasOwnProperty("onekey_se03_hash"))
            if (!(message.onekey_se03_hash && typeof message.onekey_se03_hash.length === "number" || $util.isString(message.onekey_se03_hash)))
                return "onekey_se03_hash: buffer expected";
        if (message.onekey_se04_hash != null && message.hasOwnProperty("onekey_se04_hash"))
            if (!(message.onekey_se04_hash && typeof message.onekey_se04_hash.length === "number" || $util.isString(message.onekey_se04_hash)))
                return "onekey_se04_hash: buffer expected";
        if (message.onekey_se01_build_id != null && message.hasOwnProperty("onekey_se01_build_id"))
            if (!$util.isString(message.onekey_se01_build_id))
                return "onekey_se01_build_id: string expected";
        if (message.onekey_se02_build_id != null && message.hasOwnProperty("onekey_se02_build_id"))
            if (!$util.isString(message.onekey_se02_build_id))
                return "onekey_se02_build_id: string expected";
        if (message.onekey_se03_build_id != null && message.hasOwnProperty("onekey_se03_build_id"))
            if (!$util.isString(message.onekey_se03_build_id))
                return "onekey_se03_build_id: string expected";
        if (message.onekey_se04_build_id != null && message.hasOwnProperty("onekey_se04_build_id"))
            if (!$util.isString(message.onekey_se04_build_id))
                return "onekey_se04_build_id: string expected";
        if (message.onekey_se01_bootloader_version != null && message.hasOwnProperty("onekey_se01_bootloader_version"))
            if (!$util.isString(message.onekey_se01_bootloader_version))
                return "onekey_se01_bootloader_version: string expected";
        if (message.onekey_se02_bootloader_version != null && message.hasOwnProperty("onekey_se02_bootloader_version"))
            if (!$util.isString(message.onekey_se02_bootloader_version))
                return "onekey_se02_bootloader_version: string expected";
        if (message.onekey_se03_bootloader_version != null && message.hasOwnProperty("onekey_se03_bootloader_version"))
            if (!$util.isString(message.onekey_se03_bootloader_version))
                return "onekey_se03_bootloader_version: string expected";
        if (message.onekey_se04_bootloader_version != null && message.hasOwnProperty("onekey_se04_bootloader_version"))
            if (!$util.isString(message.onekey_se04_bootloader_version))
                return "onekey_se04_bootloader_version: string expected";
        if (message.onekey_se01_bootloader_hash != null && message.hasOwnProperty("onekey_se01_bootloader_hash"))
            if (!(message.onekey_se01_bootloader_hash && typeof message.onekey_se01_bootloader_hash.length === "number" || $util.isString(message.onekey_se01_bootloader_hash)))
                return "onekey_se01_bootloader_hash: buffer expected";
        if (message.onekey_se02_bootloader_hash != null && message.hasOwnProperty("onekey_se02_bootloader_hash"))
            if (!(message.onekey_se02_bootloader_hash && typeof message.onekey_se02_bootloader_hash.length === "number" || $util.isString(message.onekey_se02_bootloader_hash)))
                return "onekey_se02_bootloader_hash: buffer expected";
        if (message.onekey_se03_bootloader_hash != null && message.hasOwnProperty("onekey_se03_bootloader_hash"))
            if (!(message.onekey_se03_bootloader_hash && typeof message.onekey_se03_bootloader_hash.length === "number" || $util.isString(message.onekey_se03_bootloader_hash)))
                return "onekey_se03_bootloader_hash: buffer expected";
        if (message.onekey_se04_bootloader_hash != null && message.hasOwnProperty("onekey_se04_bootloader_hash"))
            if (!(message.onekey_se04_bootloader_hash && typeof message.onekey_se04_bootloader_hash.length === "number" || $util.isString(message.onekey_se04_bootloader_hash)))
                return "onekey_se04_bootloader_hash: buffer expected";
        if (message.onekey_se01_bootloader_build_id != null && message.hasOwnProperty("onekey_se01_bootloader_build_id"))
            if (!$util.isString(message.onekey_se01_bootloader_build_id))
                return "onekey_se01_bootloader_build_id: string expected";
        if (message.onekey_se02_bootloader_build_id != null && message.hasOwnProperty("onekey_se02_bootloader_build_id"))
            if (!$util.isString(message.onekey_se02_bootloader_build_id))
                return "onekey_se02_bootloader_build_id: string expected";
        if (message.onekey_se03_bootloader_build_id != null && message.hasOwnProperty("onekey_se03_bootloader_build_id"))
            if (!$util.isString(message.onekey_se03_bootloader_build_id))
                return "onekey_se03_bootloader_build_id: string expected";
        if (message.onekey_se04_bootloader_build_id != null && message.hasOwnProperty("onekey_se04_bootloader_build_id"))
            if (!$util.isString(message.onekey_se04_bootloader_build_id))
                return "onekey_se04_bootloader_build_id: string expected";
        return null;
    };

    OnekeyFeatures.fromObject = function fromObject(object) {
        if (object instanceof $root.OnekeyFeatures)
            return object;
        var message = new $root.OnekeyFeatures();
        switch (object.onekey_device_type) {
        case "CLASSIC":
        case 0:
            message.onekey_device_type = 0;
            break;
        case "CLASSIC1S":
        case 1:
            message.onekey_device_type = 1;
            break;
        case "MINI":
        case 2:
            message.onekey_device_type = 2;
            break;
        case "TOUCH":
        case 3:
            message.onekey_device_type = 3;
            break;
        case "PRO":
        case 5:
            message.onekey_device_type = 5;
            break;
        }
        if (object.onekey_romloader_version != null)
            message.onekey_romloader_version = String(object.onekey_romloader_version);
        if (object.onekey_bootloader_version != null)
            message.onekey_bootloader_version = String(object.onekey_bootloader_version);
        if (object.onekey_firmware_version != null)
            message.onekey_firmware_version = String(object.onekey_firmware_version);
        if (object.onekey_romloader_hash != null)
            if (typeof object.onekey_romloader_hash === "string")
                $util.base64.decode(object.onekey_romloader_hash, message.onekey_romloader_hash = $util.newBuffer($util.base64.length(object.onekey_romloader_hash)), 0);
            else if (object.onekey_romloader_hash.length)
                message.onekey_romloader_hash = object.onekey_romloader_hash;
        if (object.onekey_bootloader_hash != null)
            if (typeof object.onekey_bootloader_hash === "string")
                $util.base64.decode(object.onekey_bootloader_hash, message.onekey_bootloader_hash = $util.newBuffer($util.base64.length(object.onekey_bootloader_hash)), 0);
            else if (object.onekey_bootloader_hash.length)
                message.onekey_bootloader_hash = object.onekey_bootloader_hash;
        if (object.onekey_firmware_hash != null)
            if (typeof object.onekey_firmware_hash === "string")
                $util.base64.decode(object.onekey_firmware_hash, message.onekey_firmware_hash = $util.newBuffer($util.base64.length(object.onekey_firmware_hash)), 0);
            else if (object.onekey_firmware_hash.length)
                message.onekey_firmware_hash = object.onekey_firmware_hash;
        if (object.onekey_romloader_build_id != null)
            message.onekey_romloader_build_id = String(object.onekey_romloader_build_id);
        if (object.onekey_bootloader_build_id != null)
            message.onekey_bootloader_build_id = String(object.onekey_bootloader_build_id);
        if (object.onekey_firmware_build_id != null)
            message.onekey_firmware_build_id = String(object.onekey_firmware_build_id);
        if (object.onekey_serial_no != null)
            message.onekey_serial_no = String(object.onekey_serial_no);
        if (object.onekey_coprocessor_bt_name != null)
            message.onekey_coprocessor_bt_name = String(object.onekey_coprocessor_bt_name);
        if (object.onekey_coprocessor_version != null)
            message.onekey_coprocessor_version = String(object.onekey_coprocessor_version);
        if (object.onekey_coprocessor_build_id != null)
            message.onekey_coprocessor_build_id = String(object.onekey_coprocessor_build_id);
        if (object.onekey_coprocessor_hash != null)
            if (typeof object.onekey_coprocessor_hash === "string")
                $util.base64.decode(object.onekey_coprocessor_hash, message.onekey_coprocessor_hash = $util.newBuffer($util.base64.length(object.onekey_coprocessor_hash)), 0);
            else if (object.onekey_coprocessor_hash.length)
                message.onekey_coprocessor_hash = object.onekey_coprocessor_hash;
        switch (object.onekey_se_type) {
        case "THD89":
        case 0:
            message.onekey_se_type = 0;
            break;
        case "SE608A":
        case 1:
            message.onekey_se_type = 1;
            break;
        }
        switch (object.onekey_se01_state) {
        case "BOOT":
        case 0:
            message.onekey_se01_state = 0;
            break;
        case "APP":
        case 1:
            message.onekey_se01_state = 1;
            break;
        }
        switch (object.onekey_se02_state) {
        case "BOOT":
        case 0:
            message.onekey_se02_state = 0;
            break;
        case "APP":
        case 1:
            message.onekey_se02_state = 1;
            break;
        }
        switch (object.onekey_se03_state) {
        case "BOOT":
        case 0:
            message.onekey_se03_state = 0;
            break;
        case "APP":
        case 1:
            message.onekey_se03_state = 1;
            break;
        }
        switch (object.onekey_se04_state) {
        case "BOOT":
        case 0:
            message.onekey_se04_state = 0;
            break;
        case "APP":
        case 1:
            message.onekey_se04_state = 1;
            break;
        }
        if (object.onekey_se01_version != null)
            message.onekey_se01_version = String(object.onekey_se01_version);
        if (object.onekey_se02_version != null)
            message.onekey_se02_version = String(object.onekey_se02_version);
        if (object.onekey_se03_version != null)
            message.onekey_se03_version = String(object.onekey_se03_version);
        if (object.onekey_se04_version != null)
            message.onekey_se04_version = String(object.onekey_se04_version);
        if (object.onekey_se01_hash != null)
            if (typeof object.onekey_se01_hash === "string")
                $util.base64.decode(object.onekey_se01_hash, message.onekey_se01_hash = $util.newBuffer($util.base64.length(object.onekey_se01_hash)), 0);
            else if (object.onekey_se01_hash.length)
                message.onekey_se01_hash = object.onekey_se01_hash;
        if (object.onekey_se02_hash != null)
            if (typeof object.onekey_se02_hash === "string")
                $util.base64.decode(object.onekey_se02_hash, message.onekey_se02_hash = $util.newBuffer($util.base64.length(object.onekey_se02_hash)), 0);
            else if (object.onekey_se02_hash.length)
                message.onekey_se02_hash = object.onekey_se02_hash;
        if (object.onekey_se03_hash != null)
            if (typeof object.onekey_se03_hash === "string")
                $util.base64.decode(object.onekey_se03_hash, message.onekey_se03_hash = $util.newBuffer($util.base64.length(object.onekey_se03_hash)), 0);
            else if (object.onekey_se03_hash.length)
                message.onekey_se03_hash = object.onekey_se03_hash;
        if (object.onekey_se04_hash != null)
            if (typeof object.onekey_se04_hash === "string")
                $util.base64.decode(object.onekey_se04_hash, message.onekey_se04_hash = $util.newBuffer($util.base64.length(object.onekey_se04_hash)), 0);
            else if (object.onekey_se04_hash.length)
                message.onekey_se04_hash = object.onekey_se04_hash;
        if (object.onekey_se01_build_id != null)
            message.onekey_se01_build_id = String(object.onekey_se01_build_id);
        if (object.onekey_se02_build_id != null)
            message.onekey_se02_build_id = String(object.onekey_se02_build_id);
        if (object.onekey_se03_build_id != null)
            message.onekey_se03_build_id = String(object.onekey_se03_build_id);
        if (object.onekey_se04_build_id != null)
            message.onekey_se04_build_id = String(object.onekey_se04_build_id);
        if (object.onekey_se01_bootloader_version != null)
            message.onekey_se01_bootloader_version = String(object.onekey_se01_bootloader_version);
        if (object.onekey_se02_bootloader_version != null)
            message.onekey_se02_bootloader_version = String(object.onekey_se02_bootloader_version);
        if (object.onekey_se03_bootloader_version != null)
            message.onekey_se03_bootloader_version = String(object.onekey_se03_bootloader_version);
        if (object.onekey_se04_bootloader_version != null)
            message.onekey_se04_bootloader_version = String(object.onekey_se04_bootloader_version);
        if (object.onekey_se01_bootloader_hash != null)
            if (typeof object.onekey_se01_bootloader_hash === "string")
                $util.base64.decode(object.onekey_se01_bootloader_hash, message.onekey_se01_bootloader_hash = $util.newBuffer($util.base64.length(object.onekey_se01_bootloader_hash)), 0);
            else if (object.onekey_se01_bootloader_hash.length)
                message.onekey_se01_bootloader_hash = object.onekey_se01_bootloader_hash;
        if (object.onekey_se02_bootloader_hash != null)
            if (typeof object.onekey_se02_bootloader_hash === "string")
                $util.base64.decode(object.onekey_se02_bootloader_hash, message.onekey_se02_bootloader_hash = $util.newBuffer($util.base64.length(object.onekey_se02_bootloader_hash)), 0);
            else if (object.onekey_se02_bootloader_hash.length)
                message.onekey_se02_bootloader_hash = object.onekey_se02_bootloader_hash;
        if (object.onekey_se03_bootloader_hash != null)
            if (typeof object.onekey_se03_bootloader_hash === "string")
                $util.base64.decode(object.onekey_se03_bootloader_hash, message.onekey_se03_bootloader_hash = $util.newBuffer($util.base64.length(object.onekey_se03_bootloader_hash)), 0);
            else if (object.onekey_se03_bootloader_hash.length)
                message.onekey_se03_bootloader_hash = object.onekey_se03_bootloader_hash;
        if (object.onekey_se04_bootloader_hash != null)
            if (typeof object.onekey_se04_bootloader_hash === "string")
                $util.base64.decode(object.onekey_se04_bootloader_hash, message.onekey_se04_bootloader_hash = $util.newBuffer($util.base64.length(object.onekey_se04_bootloader_hash)), 0);
            else if (object.onekey_se04_bootloader_hash.length)
                message.onekey_se04_bootloader_hash = object.onekey_se04_bootloader_hash;
        if (object.onekey_se01_bootloader_build_id != null)
            message.onekey_se01_bootloader_build_id = String(object.onekey_se01_bootloader_build_id);
        if (object.onekey_se02_bootloader_build_id != null)
            message.onekey_se02_bootloader_build_id = String(object.onekey_se02_bootloader_build_id);
        if (object.onekey_se03_bootloader_build_id != null)
            message.onekey_se03_bootloader_build_id = String(object.onekey_se03_bootloader_build_id);
        if (object.onekey_se04_bootloader_build_id != null)
            message.onekey_se04_bootloader_build_id = String(object.onekey_se04_bootloader_build_id);
        return message;
    };

    OnekeyFeatures.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.onekey_device_type = options.enums === String ? "CLASSIC" : 0;
            object.onekey_romloader_version = "";
            object.onekey_bootloader_version = "";
            object.onekey_firmware_version = "";
            if (options.bytes === String)
                object.onekey_romloader_hash = "";
            else {
                object.onekey_romloader_hash = [];
                if (options.bytes !== Array)
                    object.onekey_romloader_hash = $util.newBuffer(object.onekey_romloader_hash);
            }
            if (options.bytes === String)
                object.onekey_bootloader_hash = "";
            else {
                object.onekey_bootloader_hash = [];
                if (options.bytes !== Array)
                    object.onekey_bootloader_hash = $util.newBuffer(object.onekey_bootloader_hash);
            }
            if (options.bytes === String)
                object.onekey_firmware_hash = "";
            else {
                object.onekey_firmware_hash = [];
                if (options.bytes !== Array)
                    object.onekey_firmware_hash = $util.newBuffer(object.onekey_firmware_hash);
            }
            object.onekey_romloader_build_id = "";
            object.onekey_bootloader_build_id = "";
            object.onekey_firmware_build_id = "";
            object.onekey_serial_no = "";
            object.onekey_coprocessor_bt_name = "";
            object.onekey_coprocessor_version = "";
            object.onekey_coprocessor_build_id = "";
            if (options.bytes === String)
                object.onekey_coprocessor_hash = "";
            else {
                object.onekey_coprocessor_hash = [];
                if (options.bytes !== Array)
                    object.onekey_coprocessor_hash = $util.newBuffer(object.onekey_coprocessor_hash);
            }
            object.onekey_se_type = options.enums === String ? "THD89" : 0;
            object.onekey_se01_state = options.enums === String ? "BOOT" : 0;
            object.onekey_se02_state = options.enums === String ? "BOOT" : 0;
            object.onekey_se03_state = options.enums === String ? "BOOT" : 0;
            object.onekey_se04_state = options.enums === String ? "BOOT" : 0;
            object.onekey_se01_version = "";
            object.onekey_se02_version = "";
            object.onekey_se03_version = "";
            object.onekey_se04_version = "";
            if (options.bytes === String)
                object.onekey_se01_hash = "";
            else {
                object.onekey_se01_hash = [];
                if (options.bytes !== Array)
                    object.onekey_se01_hash = $util.newBuffer(object.onekey_se01_hash);
            }
            if (options.bytes === String)
                object.onekey_se02_hash = "";
            else {
                object.onekey_se02_hash = [];
                if (options.bytes !== Array)
                    object.onekey_se02_hash = $util.newBuffer(object.onekey_se02_hash);
            }
            if (options.bytes === String)
                object.onekey_se03_hash = "";
            else {
                object.onekey_se03_hash = [];
                if (options.bytes !== Array)
                    object.onekey_se03_hash = $util.newBuffer(object.onekey_se03_hash);
            }
            if (options.bytes === String)
                object.onekey_se04_hash = "";
            else {
                object.onekey_se04_hash = [];
                if (options.bytes !== Array)
                    object.onekey_se04_hash = $util.newBuffer(object.onekey_se04_hash);
            }
            object.onekey_se01_build_id = "";
            object.onekey_se02_build_id = "";
            object.onekey_se03_build_id = "";
            object.onekey_se04_build_id = "";
            object.onekey_se01_bootloader_version = "";
            object.onekey_se02_bootloader_version = "";
            object.onekey_se03_bootloader_version = "";
            object.onekey_se04_bootloader_version = "";
            if (options.bytes === String)
                object.onekey_se01_bootloader_hash = "";
            else {
                object.onekey_se01_bootloader_hash = [];
                if (options.bytes !== Array)
                    object.onekey_se01_bootloader_hash = $util.newBuffer(object.onekey_se01_bootloader_hash);
            }
            if (options.bytes === String)
                object.onekey_se02_bootloader_hash = "";
            else {
                object.onekey_se02_bootloader_hash = [];
                if (options.bytes !== Array)
                    object.onekey_se02_bootloader_hash = $util.newBuffer(object.onekey_se02_bootloader_hash);
            }
            if (options.bytes === String)
                object.onekey_se03_bootloader_hash = "";
            else {
                object.onekey_se03_bootloader_hash = [];
                if (options.bytes !== Array)
                    object.onekey_se03_bootloader_hash = $util.newBuffer(object.onekey_se03_bootloader_hash);
            }
            if (options.bytes === String)
                object.onekey_se04_bootloader_hash = "";
            else {
                object.onekey_se04_bootloader_hash = [];
                if (options.bytes !== Array)
                    object.onekey_se04_bootloader_hash = $util.newBuffer(object.onekey_se04_bootloader_hash);
            }
            object.onekey_se01_bootloader_build_id = "";
            object.onekey_se02_bootloader_build_id = "";
            object.onekey_se03_bootloader_build_id = "";
            object.onekey_se04_bootloader_build_id = "";
        }
        if (message.onekey_device_type != null && message.hasOwnProperty("onekey_device_type"))
            object.onekey_device_type = options.enums === String ? $root.OneKeyDeviceType[message.onekey_device_type] : message.onekey_device_type;
        if (message.onekey_romloader_version != null && message.hasOwnProperty("onekey_romloader_version"))
            object.onekey_romloader_version = message.onekey_romloader_version;
        if (message.onekey_bootloader_version != null && message.hasOwnProperty("onekey_bootloader_version"))
            object.onekey_bootloader_version = message.onekey_bootloader_version;
        if (message.onekey_firmware_version != null && message.hasOwnProperty("onekey_firmware_version"))
            object.onekey_firmware_version = message.onekey_firmware_version;
        if (message.onekey_romloader_hash != null && message.hasOwnProperty("onekey_romloader_hash"))
            object.onekey_romloader_hash = options.bytes === String ? $util.base64.encode(message.onekey_romloader_hash, 0, message.onekey_romloader_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.onekey_romloader_hash) : message.onekey_romloader_hash;
        if (message.onekey_bootloader_hash != null && message.hasOwnProperty("onekey_bootloader_hash"))
            object.onekey_bootloader_hash = options.bytes === String ? $util.base64.encode(message.onekey_bootloader_hash, 0, message.onekey_bootloader_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.onekey_bootloader_hash) : message.onekey_bootloader_hash;
        if (message.onekey_firmware_hash != null && message.hasOwnProperty("onekey_firmware_hash"))
            object.onekey_firmware_hash = options.bytes === String ? $util.base64.encode(message.onekey_firmware_hash, 0, message.onekey_firmware_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.onekey_firmware_hash) : message.onekey_firmware_hash;
        if (message.onekey_romloader_build_id != null && message.hasOwnProperty("onekey_romloader_build_id"))
            object.onekey_romloader_build_id = message.onekey_romloader_build_id;
        if (message.onekey_bootloader_build_id != null && message.hasOwnProperty("onekey_bootloader_build_id"))
            object.onekey_bootloader_build_id = message.onekey_bootloader_build_id;
        if (message.onekey_firmware_build_id != null && message.hasOwnProperty("onekey_firmware_build_id"))
            object.onekey_firmware_build_id = message.onekey_firmware_build_id;
        if (message.onekey_serial_no != null && message.hasOwnProperty("onekey_serial_no"))
            object.onekey_serial_no = message.onekey_serial_no;
        if (message.onekey_coprocessor_bt_name != null && message.hasOwnProperty("onekey_coprocessor_bt_name"))
            object.onekey_coprocessor_bt_name = message.onekey_coprocessor_bt_name;
        if (message.onekey_coprocessor_version != null && message.hasOwnProperty("onekey_coprocessor_version"))
            object.onekey_coprocessor_version = message.onekey_coprocessor_version;
        if (message.onekey_coprocessor_build_id != null && message.hasOwnProperty("onekey_coprocessor_build_id"))
            object.onekey_coprocessor_build_id = message.onekey_coprocessor_build_id;
        if (message.onekey_coprocessor_hash != null && message.hasOwnProperty("onekey_coprocessor_hash"))
            object.onekey_coprocessor_hash = options.bytes === String ? $util.base64.encode(message.onekey_coprocessor_hash, 0, message.onekey_coprocessor_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.onekey_coprocessor_hash) : message.onekey_coprocessor_hash;
        if (message.onekey_se_type != null && message.hasOwnProperty("onekey_se_type"))
            object.onekey_se_type = options.enums === String ? $root.OneKeySeType[message.onekey_se_type] : message.onekey_se_type;
        if (message.onekey_se01_state != null && message.hasOwnProperty("onekey_se01_state"))
            object.onekey_se01_state = options.enums === String ? $root.OneKeySEState[message.onekey_se01_state] : message.onekey_se01_state;
        if (message.onekey_se02_state != null && message.hasOwnProperty("onekey_se02_state"))
            object.onekey_se02_state = options.enums === String ? $root.OneKeySEState[message.onekey_se02_state] : message.onekey_se02_state;
        if (message.onekey_se03_state != null && message.hasOwnProperty("onekey_se03_state"))
            object.onekey_se03_state = options.enums === String ? $root.OneKeySEState[message.onekey_se03_state] : message.onekey_se03_state;
        if (message.onekey_se04_state != null && message.hasOwnProperty("onekey_se04_state"))
            object.onekey_se04_state = options.enums === String ? $root.OneKeySEState[message.onekey_se04_state] : message.onekey_se04_state;
        if (message.onekey_se01_version != null && message.hasOwnProperty("onekey_se01_version"))
            object.onekey_se01_version = message.onekey_se01_version;
        if (message.onekey_se02_version != null && message.hasOwnProperty("onekey_se02_version"))
            object.onekey_se02_version = message.onekey_se02_version;
        if (message.onekey_se03_version != null && message.hasOwnProperty("onekey_se03_version"))
            object.onekey_se03_version = message.onekey_se03_version;
        if (message.onekey_se04_version != null && message.hasOwnProperty("onekey_se04_version"))
            object.onekey_se04_version = message.onekey_se04_version;
        if (message.onekey_se01_hash != null && message.hasOwnProperty("onekey_se01_hash"))
            object.onekey_se01_hash = options.bytes === String ? $util.base64.encode(message.onekey_se01_hash, 0, message.onekey_se01_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.onekey_se01_hash) : message.onekey_se01_hash;
        if (message.onekey_se02_hash != null && message.hasOwnProperty("onekey_se02_hash"))
            object.onekey_se02_hash = options.bytes === String ? $util.base64.encode(message.onekey_se02_hash, 0, message.onekey_se02_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.onekey_se02_hash) : message.onekey_se02_hash;
        if (message.onekey_se03_hash != null && message.hasOwnProperty("onekey_se03_hash"))
            object.onekey_se03_hash = options.bytes === String ? $util.base64.encode(message.onekey_se03_hash, 0, message.onekey_se03_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.onekey_se03_hash) : message.onekey_se03_hash;
        if (message.onekey_se04_hash != null && message.hasOwnProperty("onekey_se04_hash"))
            object.onekey_se04_hash = options.bytes === String ? $util.base64.encode(message.onekey_se04_hash, 0, message.onekey_se04_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.onekey_se04_hash) : message.onekey_se04_hash;
        if (message.onekey_se01_build_id != null && message.hasOwnProperty("onekey_se01_build_id"))
            object.onekey_se01_build_id = message.onekey_se01_build_id;
        if (message.onekey_se02_build_id != null && message.hasOwnProperty("onekey_se02_build_id"))
            object.onekey_se02_build_id = message.onekey_se02_build_id;
        if (message.onekey_se03_build_id != null && message.hasOwnProperty("onekey_se03_build_id"))
            object.onekey_se03_build_id = message.onekey_se03_build_id;
        if (message.onekey_se04_build_id != null && message.hasOwnProperty("onekey_se04_build_id"))
            object.onekey_se04_build_id = message.onekey_se04_build_id;
        if (message.onekey_se01_bootloader_version != null && message.hasOwnProperty("onekey_se01_bootloader_version"))
            object.onekey_se01_bootloader_version = message.onekey_se01_bootloader_version;
        if (message.onekey_se02_bootloader_version != null && message.hasOwnProperty("onekey_se02_bootloader_version"))
            object.onekey_se02_bootloader_version = message.onekey_se02_bootloader_version;
        if (message.onekey_se03_bootloader_version != null && message.hasOwnProperty("onekey_se03_bootloader_version"))
            object.onekey_se03_bootloader_version = message.onekey_se03_bootloader_version;
        if (message.onekey_se04_bootloader_version != null && message.hasOwnProperty("onekey_se04_bootloader_version"))
            object.onekey_se04_bootloader_version = message.onekey_se04_bootloader_version;
        if (message.onekey_se01_bootloader_hash != null && message.hasOwnProperty("onekey_se01_bootloader_hash"))
            object.onekey_se01_bootloader_hash = options.bytes === String ? $util.base64.encode(message.onekey_se01_bootloader_hash, 0, message.onekey_se01_bootloader_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.onekey_se01_bootloader_hash) : message.onekey_se01_bootloader_hash;
        if (message.onekey_se02_bootloader_hash != null && message.hasOwnProperty("onekey_se02_bootloader_hash"))
            object.onekey_se02_bootloader_hash = options.bytes === String ? $util.base64.encode(message.onekey_se02_bootloader_hash, 0, message.onekey_se02_bootloader_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.onekey_se02_bootloader_hash) : message.onekey_se02_bootloader_hash;
        if (message.onekey_se03_bootloader_hash != null && message.hasOwnProperty("onekey_se03_bootloader_hash"))
            object.onekey_se03_bootloader_hash = options.bytes === String ? $util.base64.encode(message.onekey_se03_bootloader_hash, 0, message.onekey_se03_bootloader_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.onekey_se03_bootloader_hash) : message.onekey_se03_bootloader_hash;
        if (message.onekey_se04_bootloader_hash != null && message.hasOwnProperty("onekey_se04_bootloader_hash"))
            object.onekey_se04_bootloader_hash = options.bytes === String ? $util.base64.encode(message.onekey_se04_bootloader_hash, 0, message.onekey_se04_bootloader_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.onekey_se04_bootloader_hash) : message.onekey_se04_bootloader_hash;
        if (message.onekey_se01_bootloader_build_id != null && message.hasOwnProperty("onekey_se01_bootloader_build_id"))
            object.onekey_se01_bootloader_build_id = message.onekey_se01_bootloader_build_id;
        if (message.onekey_se02_bootloader_build_id != null && message.hasOwnProperty("onekey_se02_bootloader_build_id"))
            object.onekey_se02_bootloader_build_id = message.onekey_se02_bootloader_build_id;
        if (message.onekey_se03_bootloader_build_id != null && message.hasOwnProperty("onekey_se03_bootloader_build_id"))
            object.onekey_se03_bootloader_build_id = message.onekey_se03_bootloader_build_id;
        if (message.onekey_se04_bootloader_build_id != null && message.hasOwnProperty("onekey_se04_bootloader_build_id"))
            object.onekey_se04_bootloader_build_id = message.onekey_se04_bootloader_build_id;
        return object;
    };

    OnekeyFeatures.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return OnekeyFeatures;
})();

$root.LockDevice = (function() {

    function LockDevice(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    LockDevice.create = function create(properties) {
        return new LockDevice(properties);
    };

    LockDevice.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    LockDevice.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    LockDevice.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.LockDevice();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    LockDevice.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    LockDevice.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    LockDevice.fromObject = function fromObject(object) {
        if (object instanceof $root.LockDevice)
            return object;
        return new $root.LockDevice();
    };

    LockDevice.toObject = function toObject() {
        return {};
    };

    LockDevice.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return LockDevice;
})();

$root.SetBusy = (function() {

    function SetBusy(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    SetBusy.prototype.expiry_ms = 0;

    SetBusy.create = function create(properties) {
        return new SetBusy(properties);
    };

    SetBusy.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.expiry_ms != null && Object.hasOwnProperty.call(message, "expiry_ms"))
            writer.uint32(8).uint32(message.expiry_ms);
        return writer;
    };

    SetBusy.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    SetBusy.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SetBusy();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.expiry_ms = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    SetBusy.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    SetBusy.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.expiry_ms != null && message.hasOwnProperty("expiry_ms"))
            if (!$util.isInteger(message.expiry_ms))
                return "expiry_ms: integer expected";
        return null;
    };

    SetBusy.fromObject = function fromObject(object) {
        if (object instanceof $root.SetBusy)
            return object;
        var message = new $root.SetBusy();
        if (object.expiry_ms != null)
            message.expiry_ms = object.expiry_ms >>> 0;
        return message;
    };

    SetBusy.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.expiry_ms = 0;
        if (message.expiry_ms != null && message.hasOwnProperty("expiry_ms"))
            object.expiry_ms = message.expiry_ms;
        return object;
    };

    SetBusy.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SetBusy;
})();

$root.ApplySettings = (function() {

    function ApplySettings(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ApplySettings.prototype.language = "";
    ApplySettings.prototype.label = "";
    ApplySettings.prototype.use_passphrase = false;
    ApplySettings.prototype.homescreen = $util.newBuffer([]);
    ApplySettings.prototype._passphrase_source = 0;
    ApplySettings.prototype.auto_lock_delay_ms = 0;
    ApplySettings.prototype.display_rotation = 0;
    ApplySettings.prototype.passphrase_always_on_device = false;
    ApplySettings.prototype.safety_checks = 0;
    ApplySettings.prototype.experimental_features = false;

    ApplySettings.create = function create(properties) {
        return new ApplySettings(properties);
    };

    ApplySettings.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.language != null && Object.hasOwnProperty.call(message, "language"))
            writer.uint32(10).string(message.language);
        if (message.label != null && Object.hasOwnProperty.call(message, "label"))
            writer.uint32(18).string(message.label);
        if (message.use_passphrase != null && Object.hasOwnProperty.call(message, "use_passphrase"))
            writer.uint32(24).bool(message.use_passphrase);
        if (message.homescreen != null && Object.hasOwnProperty.call(message, "homescreen"))
            writer.uint32(34).bytes(message.homescreen);
        if (message._passphrase_source != null && Object.hasOwnProperty.call(message, "_passphrase_source"))
            writer.uint32(40).uint32(message._passphrase_source);
        if (message.auto_lock_delay_ms != null && Object.hasOwnProperty.call(message, "auto_lock_delay_ms"))
            writer.uint32(48).uint32(message.auto_lock_delay_ms);
        if (message.display_rotation != null && Object.hasOwnProperty.call(message, "display_rotation"))
            writer.uint32(56).uint32(message.display_rotation);
        if (message.passphrase_always_on_device != null && Object.hasOwnProperty.call(message, "passphrase_always_on_device"))
            writer.uint32(64).bool(message.passphrase_always_on_device);
        if (message.safety_checks != null && Object.hasOwnProperty.call(message, "safety_checks"))
            writer.uint32(72).int32(message.safety_checks);
        if (message.experimental_features != null && Object.hasOwnProperty.call(message, "experimental_features"))
            writer.uint32(80).bool(message.experimental_features);
        return writer;
    };

    ApplySettings.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ApplySettings.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ApplySettings();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.language = reader.string();
                break;
            case 2:
                message.label = reader.string();
                break;
            case 3:
                message.use_passphrase = reader.bool();
                break;
            case 4:
                message.homescreen = reader.bytes();
                break;
            case 5:
                message._passphrase_source = reader.uint32();
                break;
            case 6:
                message.auto_lock_delay_ms = reader.uint32();
                break;
            case 7:
                message.display_rotation = reader.uint32();
                break;
            case 8:
                message.passphrase_always_on_device = reader.bool();
                break;
            case 9:
                message.safety_checks = reader.int32();
                break;
            case 10:
                message.experimental_features = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    ApplySettings.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ApplySettings.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.language != null && message.hasOwnProperty("language"))
            if (!$util.isString(message.language))
                return "language: string expected";
        if (message.label != null && message.hasOwnProperty("label"))
            if (!$util.isString(message.label))
                return "label: string expected";
        if (message.use_passphrase != null && message.hasOwnProperty("use_passphrase"))
            if (typeof message.use_passphrase !== "boolean")
                return "use_passphrase: boolean expected";
        if (message.homescreen != null && message.hasOwnProperty("homescreen"))
            if (!(message.homescreen && typeof message.homescreen.length === "number" || $util.isString(message.homescreen)))
                return "homescreen: buffer expected";
        if (message._passphrase_source != null && message.hasOwnProperty("_passphrase_source"))
            if (!$util.isInteger(message._passphrase_source))
                return "_passphrase_source: integer expected";
        if (message.auto_lock_delay_ms != null && message.hasOwnProperty("auto_lock_delay_ms"))
            if (!$util.isInteger(message.auto_lock_delay_ms))
                return "auto_lock_delay_ms: integer expected";
        if (message.display_rotation != null && message.hasOwnProperty("display_rotation"))
            if (!$util.isInteger(message.display_rotation))
                return "display_rotation: integer expected";
        if (message.passphrase_always_on_device != null && message.hasOwnProperty("passphrase_always_on_device"))
            if (typeof message.passphrase_always_on_device !== "boolean")
                return "passphrase_always_on_device: boolean expected";
        if (message.safety_checks != null && message.hasOwnProperty("safety_checks"))
            switch (message.safety_checks) {
            default:
                return "safety_checks: enum value expected";
            case 0:
            case 1:
            case 2:
                break;
            }
        if (message.experimental_features != null && message.hasOwnProperty("experimental_features"))
            if (typeof message.experimental_features !== "boolean")
                return "experimental_features: boolean expected";
        return null;
    };

    ApplySettings.fromObject = function fromObject(object) {
        if (object instanceof $root.ApplySettings)
            return object;
        var message = new $root.ApplySettings();
        if (object.language != null)
            message.language = String(object.language);
        if (object.label != null)
            message.label = String(object.label);
        if (object.use_passphrase != null)
            message.use_passphrase = Boolean(object.use_passphrase);
        if (object.homescreen != null)
            if (typeof object.homescreen === "string")
                $util.base64.decode(object.homescreen, message.homescreen = $util.newBuffer($util.base64.length(object.homescreen)), 0);
            else if (object.homescreen.length)
                message.homescreen = object.homescreen;
        if (object._passphrase_source != null)
            message._passphrase_source = object._passphrase_source >>> 0;
        if (object.auto_lock_delay_ms != null)
            message.auto_lock_delay_ms = object.auto_lock_delay_ms >>> 0;
        if (object.display_rotation != null)
            message.display_rotation = object.display_rotation >>> 0;
        if (object.passphrase_always_on_device != null)
            message.passphrase_always_on_device = Boolean(object.passphrase_always_on_device);
        switch (object.safety_checks) {
        case "Strict":
        case 0:
            message.safety_checks = 0;
            break;
        case "PromptAlways":
        case 1:
            message.safety_checks = 1;
            break;
        case "PromptTemporarily":
        case 2:
            message.safety_checks = 2;
            break;
        }
        if (object.experimental_features != null)
            message.experimental_features = Boolean(object.experimental_features);
        return message;
    };

    ApplySettings.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.language = "";
            object.label = "";
            object.use_passphrase = false;
            if (options.bytes === String)
                object.homescreen = "";
            else {
                object.homescreen = [];
                if (options.bytes !== Array)
                    object.homescreen = $util.newBuffer(object.homescreen);
            }
            object._passphrase_source = 0;
            object.auto_lock_delay_ms = 0;
            object.display_rotation = 0;
            object.passphrase_always_on_device = false;
            object.safety_checks = options.enums === String ? "Strict" : 0;
            object.experimental_features = false;
        }
        if (message.language != null && message.hasOwnProperty("language"))
            object.language = message.language;
        if (message.label != null && message.hasOwnProperty("label"))
            object.label = message.label;
        if (message.use_passphrase != null && message.hasOwnProperty("use_passphrase"))
            object.use_passphrase = message.use_passphrase;
        if (message.homescreen != null && message.hasOwnProperty("homescreen"))
            object.homescreen = options.bytes === String ? $util.base64.encode(message.homescreen, 0, message.homescreen.length) : options.bytes === Array ? Array.prototype.slice.call(message.homescreen) : message.homescreen;
        if (message._passphrase_source != null && message.hasOwnProperty("_passphrase_source"))
            object._passphrase_source = message._passphrase_source;
        if (message.auto_lock_delay_ms != null && message.hasOwnProperty("auto_lock_delay_ms"))
            object.auto_lock_delay_ms = message.auto_lock_delay_ms;
        if (message.display_rotation != null && message.hasOwnProperty("display_rotation"))
            object.display_rotation = message.display_rotation;
        if (message.passphrase_always_on_device != null && message.hasOwnProperty("passphrase_always_on_device"))
            object.passphrase_always_on_device = message.passphrase_always_on_device;
        if (message.safety_checks != null && message.hasOwnProperty("safety_checks"))
            object.safety_checks = options.enums === String ? $root.SafetyCheckLevel[message.safety_checks] : message.safety_checks;
        if (message.experimental_features != null && message.hasOwnProperty("experimental_features"))
            object.experimental_features = message.experimental_features;
        return object;
    };

    ApplySettings.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ApplySettings;
})();

$root.ApplyFlags = (function() {

    function ApplyFlags(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ApplyFlags.prototype.flags = 0;

    ApplyFlags.create = function create(properties) {
        return new ApplyFlags(properties);
    };

    ApplyFlags.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).uint32(message.flags);
        return writer;
    };

    ApplyFlags.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ApplyFlags.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ApplyFlags();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.flags = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("flags"))
            throw $util.ProtocolError("missing required 'flags'", { instance: message });
        return message;
    };

    ApplyFlags.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ApplyFlags.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isInteger(message.flags))
            return "flags: integer expected";
        return null;
    };

    ApplyFlags.fromObject = function fromObject(object) {
        if (object instanceof $root.ApplyFlags)
            return object;
        var message = new $root.ApplyFlags();
        if (object.flags != null)
            message.flags = object.flags >>> 0;
        return message;
    };

    ApplyFlags.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.flags = 0;
        if (message.flags != null && message.hasOwnProperty("flags"))
            object.flags = message.flags;
        return object;
    };

    ApplyFlags.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ApplyFlags;
})();

$root.ChangePin = (function() {

    function ChangePin(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ChangePin.prototype.remove = false;

    ChangePin.create = function create(properties) {
        return new ChangePin(properties);
    };

    ChangePin.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.remove != null && Object.hasOwnProperty.call(message, "remove"))
            writer.uint32(8).bool(message.remove);
        return writer;
    };

    ChangePin.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ChangePin.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ChangePin();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.remove = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    ChangePin.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ChangePin.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.remove != null && message.hasOwnProperty("remove"))
            if (typeof message.remove !== "boolean")
                return "remove: boolean expected";
        return null;
    };

    ChangePin.fromObject = function fromObject(object) {
        if (object instanceof $root.ChangePin)
            return object;
        var message = new $root.ChangePin();
        if (object.remove != null)
            message.remove = Boolean(object.remove);
        return message;
    };

    ChangePin.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.remove = false;
        if (message.remove != null && message.hasOwnProperty("remove"))
            object.remove = message.remove;
        return object;
    };

    ChangePin.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ChangePin;
})();

$root.ChangeWipeCode = (function() {

    function ChangeWipeCode(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ChangeWipeCode.prototype.remove = false;

    ChangeWipeCode.create = function create(properties) {
        return new ChangeWipeCode(properties);
    };

    ChangeWipeCode.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.remove != null && Object.hasOwnProperty.call(message, "remove"))
            writer.uint32(8).bool(message.remove);
        return writer;
    };

    ChangeWipeCode.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ChangeWipeCode.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ChangeWipeCode();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.remove = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    ChangeWipeCode.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ChangeWipeCode.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.remove != null && message.hasOwnProperty("remove"))
            if (typeof message.remove !== "boolean")
                return "remove: boolean expected";
        return null;
    };

    ChangeWipeCode.fromObject = function fromObject(object) {
        if (object instanceof $root.ChangeWipeCode)
            return object;
        var message = new $root.ChangeWipeCode();
        if (object.remove != null)
            message.remove = Boolean(object.remove);
        return message;
    };

    ChangeWipeCode.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.remove = false;
        if (message.remove != null && message.hasOwnProperty("remove"))
            object.remove = message.remove;
        return object;
    };

    ChangeWipeCode.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ChangeWipeCode;
})();

$root.SdProtect = (function() {

    function SdProtect(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    SdProtect.prototype.operation = 0;

    SdProtect.create = function create(properties) {
        return new SdProtect(properties);
    };

    SdProtect.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).int32(message.operation);
        return writer;
    };

    SdProtect.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    SdProtect.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SdProtect();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.operation = reader.int32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("operation"))
            throw $util.ProtocolError("missing required 'operation'", { instance: message });
        return message;
    };

    SdProtect.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    SdProtect.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        switch (message.operation) {
        default:
            return "operation: enum value expected";
        case 0:
        case 1:
        case 2:
            break;
        }
        return null;
    };

    SdProtect.fromObject = function fromObject(object) {
        if (object instanceof $root.SdProtect)
            return object;
        var message = new $root.SdProtect();
        switch (object.operation) {
        case "DISABLE":
        case 0:
            message.operation = 0;
            break;
        case "ENABLE":
        case 1:
            message.operation = 1;
            break;
        case "REFRESH":
        case 2:
            message.operation = 2;
            break;
        }
        return message;
    };

    SdProtect.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.operation = options.enums === String ? "DISABLE" : 0;
        if (message.operation != null && message.hasOwnProperty("operation"))
            object.operation = options.enums === String ? $root.SdProtect.SdProtectOperationType[message.operation] : message.operation;
        return object;
    };

    SdProtect.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    SdProtect.SdProtectOperationType = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "DISABLE"] = 0;
        values[valuesById[1] = "ENABLE"] = 1;
        values[valuesById[2] = "REFRESH"] = 2;
        return values;
    })();

    return SdProtect;
})();

$root.Cancel = (function() {

    function Cancel(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    Cancel.create = function create(properties) {
        return new Cancel(properties);
    };

    Cancel.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    Cancel.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    Cancel.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Cancel();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    Cancel.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    Cancel.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    Cancel.fromObject = function fromObject(object) {
        if (object instanceof $root.Cancel)
            return object;
        return new $root.Cancel();
    };

    Cancel.toObject = function toObject() {
        return {};
    };

    Cancel.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return Cancel;
})();

$root.GetEntropy = (function() {

    function GetEntropy(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    GetEntropy.prototype.size = 0;

    GetEntropy.create = function create(properties) {
        return new GetEntropy(properties);
    };

    GetEntropy.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).uint32(message.size);
        return writer;
    };

    GetEntropy.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    GetEntropy.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.GetEntropy();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.size = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("size"))
            throw $util.ProtocolError("missing required 'size'", { instance: message });
        return message;
    };

    GetEntropy.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    GetEntropy.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isInteger(message.size))
            return "size: integer expected";
        return null;
    };

    GetEntropy.fromObject = function fromObject(object) {
        if (object instanceof $root.GetEntropy)
            return object;
        var message = new $root.GetEntropy();
        if (object.size != null)
            message.size = object.size >>> 0;
        return message;
    };

    GetEntropy.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.size = 0;
        if (message.size != null && message.hasOwnProperty("size"))
            object.size = message.size;
        return object;
    };

    GetEntropy.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return GetEntropy;
})();

$root.Entropy = (function() {

    function Entropy(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    Entropy.prototype.entropy = $util.newBuffer([]);

    Entropy.create = function create(properties) {
        return new Entropy(properties);
    };

    Entropy.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.entropy);
        return writer;
    };

    Entropy.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    Entropy.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Entropy();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.entropy = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("entropy"))
            throw $util.ProtocolError("missing required 'entropy'", { instance: message });
        return message;
    };

    Entropy.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    Entropy.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.entropy && typeof message.entropy.length === "number" || $util.isString(message.entropy)))
            return "entropy: buffer expected";
        return null;
    };

    Entropy.fromObject = function fromObject(object) {
        if (object instanceof $root.Entropy)
            return object;
        var message = new $root.Entropy();
        if (object.entropy != null)
            if (typeof object.entropy === "string")
                $util.base64.decode(object.entropy, message.entropy = $util.newBuffer($util.base64.length(object.entropy)), 0);
            else if (object.entropy.length)
                message.entropy = object.entropy;
        return message;
    };

    Entropy.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.entropy = "";
            else {
                object.entropy = [];
                if (options.bytes !== Array)
                    object.entropy = $util.newBuffer(object.entropy);
            }
        if (message.entropy != null && message.hasOwnProperty("entropy"))
            object.entropy = options.bytes === String ? $util.base64.encode(message.entropy, 0, message.entropy.length) : options.bytes === Array ? Array.prototype.slice.call(message.entropy) : message.entropy;
        return object;
    };

    Entropy.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return Entropy;
})();

$root.GetFirmwareHash = (function() {

    function GetFirmwareHash(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    GetFirmwareHash.prototype.challenge = $util.newBuffer([]);

    GetFirmwareHash.create = function create(properties) {
        return new GetFirmwareHash(properties);
    };

    GetFirmwareHash.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.challenge != null && Object.hasOwnProperty.call(message, "challenge"))
            writer.uint32(10).bytes(message.challenge);
        return writer;
    };

    GetFirmwareHash.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    GetFirmwareHash.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.GetFirmwareHash();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.challenge = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    GetFirmwareHash.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    GetFirmwareHash.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.challenge != null && message.hasOwnProperty("challenge"))
            if (!(message.challenge && typeof message.challenge.length === "number" || $util.isString(message.challenge)))
                return "challenge: buffer expected";
        return null;
    };

    GetFirmwareHash.fromObject = function fromObject(object) {
        if (object instanceof $root.GetFirmwareHash)
            return object;
        var message = new $root.GetFirmwareHash();
        if (object.challenge != null)
            if (typeof object.challenge === "string")
                $util.base64.decode(object.challenge, message.challenge = $util.newBuffer($util.base64.length(object.challenge)), 0);
            else if (object.challenge.length)
                message.challenge = object.challenge;
        return message;
    };

    GetFirmwareHash.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.challenge = "";
            else {
                object.challenge = [];
                if (options.bytes !== Array)
                    object.challenge = $util.newBuffer(object.challenge);
            }
        if (message.challenge != null && message.hasOwnProperty("challenge"))
            object.challenge = options.bytes === String ? $util.base64.encode(message.challenge, 0, message.challenge.length) : options.bytes === Array ? Array.prototype.slice.call(message.challenge) : message.challenge;
        return object;
    };

    GetFirmwareHash.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return GetFirmwareHash;
})();

$root.FirmwareHash = (function() {

    function FirmwareHash(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    FirmwareHash.prototype.hash = $util.newBuffer([]);

    FirmwareHash.create = function create(properties) {
        return new FirmwareHash(properties);
    };

    FirmwareHash.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.hash);
        return writer;
    };

    FirmwareHash.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    FirmwareHash.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.FirmwareHash();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.hash = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("hash"))
            throw $util.ProtocolError("missing required 'hash'", { instance: message });
        return message;
    };

    FirmwareHash.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    FirmwareHash.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.hash && typeof message.hash.length === "number" || $util.isString(message.hash)))
            return "hash: buffer expected";
        return null;
    };

    FirmwareHash.fromObject = function fromObject(object) {
        if (object instanceof $root.FirmwareHash)
            return object;
        var message = new $root.FirmwareHash();
        if (object.hash != null)
            if (typeof object.hash === "string")
                $util.base64.decode(object.hash, message.hash = $util.newBuffer($util.base64.length(object.hash)), 0);
            else if (object.hash.length)
                message.hash = object.hash;
        return message;
    };

    FirmwareHash.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.hash = "";
            else {
                object.hash = [];
                if (options.bytes !== Array)
                    object.hash = $util.newBuffer(object.hash);
            }
        if (message.hash != null && message.hasOwnProperty("hash"))
            object.hash = options.bytes === String ? $util.base64.encode(message.hash, 0, message.hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.hash) : message.hash;
        return object;
    };

    FirmwareHash.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return FirmwareHash;
})();

$root.WipeDevice = (function() {

    function WipeDevice(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    WipeDevice.create = function create(properties) {
        return new WipeDevice(properties);
    };

    WipeDevice.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    WipeDevice.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    WipeDevice.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.WipeDevice();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    WipeDevice.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    WipeDevice.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    WipeDevice.fromObject = function fromObject(object) {
        if (object instanceof $root.WipeDevice)
            return object;
        return new $root.WipeDevice();
    };

    WipeDevice.toObject = function toObject() {
        return {};
    };

    WipeDevice.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return WipeDevice;
})();

$root.LoadDevice = (function() {

    function LoadDevice(properties) {
        this.mnemonics = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    LoadDevice.prototype.mnemonics = $util.emptyArray;
    LoadDevice.prototype.pin = "";
    LoadDevice.prototype.passphrase_protection = false;
    LoadDevice.prototype.language = "en-US";
    LoadDevice.prototype.label = "";
    LoadDevice.prototype.skip_checksum = false;
    LoadDevice.prototype.u2f_counter = 0;
    LoadDevice.prototype.needs_backup = false;
    LoadDevice.prototype.no_backup = false;

    LoadDevice.create = function create(properties) {
        return new LoadDevice(properties);
    };

    LoadDevice.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.mnemonics != null && message.mnemonics.length)
            for (var i = 0; i < message.mnemonics.length; ++i)
                writer.uint32(10).string(message.mnemonics[i]);
        if (message.pin != null && Object.hasOwnProperty.call(message, "pin"))
            writer.uint32(26).string(message.pin);
        if (message.passphrase_protection != null && Object.hasOwnProperty.call(message, "passphrase_protection"))
            writer.uint32(32).bool(message.passphrase_protection);
        if (message.language != null && Object.hasOwnProperty.call(message, "language"))
            writer.uint32(42).string(message.language);
        if (message.label != null && Object.hasOwnProperty.call(message, "label"))
            writer.uint32(50).string(message.label);
        if (message.skip_checksum != null && Object.hasOwnProperty.call(message, "skip_checksum"))
            writer.uint32(56).bool(message.skip_checksum);
        if (message.u2f_counter != null && Object.hasOwnProperty.call(message, "u2f_counter"))
            writer.uint32(64).uint32(message.u2f_counter);
        if (message.needs_backup != null && Object.hasOwnProperty.call(message, "needs_backup"))
            writer.uint32(72).bool(message.needs_backup);
        if (message.no_backup != null && Object.hasOwnProperty.call(message, "no_backup"))
            writer.uint32(80).bool(message.no_backup);
        return writer;
    };

    LoadDevice.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    LoadDevice.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.LoadDevice();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.mnemonics && message.mnemonics.length))
                    message.mnemonics = [];
                message.mnemonics.push(reader.string());
                break;
            case 3:
                message.pin = reader.string();
                break;
            case 4:
                message.passphrase_protection = reader.bool();
                break;
            case 5:
                message.language = reader.string();
                break;
            case 6:
                message.label = reader.string();
                break;
            case 7:
                message.skip_checksum = reader.bool();
                break;
            case 8:
                message.u2f_counter = reader.uint32();
                break;
            case 9:
                message.needs_backup = reader.bool();
                break;
            case 10:
                message.no_backup = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    LoadDevice.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    LoadDevice.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.mnemonics != null && message.hasOwnProperty("mnemonics")) {
            if (!Array.isArray(message.mnemonics))
                return "mnemonics: array expected";
            for (var i = 0; i < message.mnemonics.length; ++i)
                if (!$util.isString(message.mnemonics[i]))
                    return "mnemonics: string[] expected";
        }
        if (message.pin != null && message.hasOwnProperty("pin"))
            if (!$util.isString(message.pin))
                return "pin: string expected";
        if (message.passphrase_protection != null && message.hasOwnProperty("passphrase_protection"))
            if (typeof message.passphrase_protection !== "boolean")
                return "passphrase_protection: boolean expected";
        if (message.language != null && message.hasOwnProperty("language"))
            if (!$util.isString(message.language))
                return "language: string expected";
        if (message.label != null && message.hasOwnProperty("label"))
            if (!$util.isString(message.label))
                return "label: string expected";
        if (message.skip_checksum != null && message.hasOwnProperty("skip_checksum"))
            if (typeof message.skip_checksum !== "boolean")
                return "skip_checksum: boolean expected";
        if (message.u2f_counter != null && message.hasOwnProperty("u2f_counter"))
            if (!$util.isInteger(message.u2f_counter))
                return "u2f_counter: integer expected";
        if (message.needs_backup != null && message.hasOwnProperty("needs_backup"))
            if (typeof message.needs_backup !== "boolean")
                return "needs_backup: boolean expected";
        if (message.no_backup != null && message.hasOwnProperty("no_backup"))
            if (typeof message.no_backup !== "boolean")
                return "no_backup: boolean expected";
        return null;
    };

    LoadDevice.fromObject = function fromObject(object) {
        if (object instanceof $root.LoadDevice)
            return object;
        var message = new $root.LoadDevice();
        if (object.mnemonics) {
            if (!Array.isArray(object.mnemonics))
                throw TypeError(".LoadDevice.mnemonics: array expected");
            message.mnemonics = [];
            for (var i = 0; i < object.mnemonics.length; ++i)
                message.mnemonics[i] = String(object.mnemonics[i]);
        }
        if (object.pin != null)
            message.pin = String(object.pin);
        if (object.passphrase_protection != null)
            message.passphrase_protection = Boolean(object.passphrase_protection);
        if (object.language != null)
            message.language = String(object.language);
        if (object.label != null)
            message.label = String(object.label);
        if (object.skip_checksum != null)
            message.skip_checksum = Boolean(object.skip_checksum);
        if (object.u2f_counter != null)
            message.u2f_counter = object.u2f_counter >>> 0;
        if (object.needs_backup != null)
            message.needs_backup = Boolean(object.needs_backup);
        if (object.no_backup != null)
            message.no_backup = Boolean(object.no_backup);
        return message;
    };

    LoadDevice.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.mnemonics = [];
        if (options.defaults) {
            object.pin = "";
            object.passphrase_protection = false;
            object.language = "en-US";
            object.label = "";
            object.skip_checksum = false;
            object.u2f_counter = 0;
            object.needs_backup = false;
            object.no_backup = false;
        }
        if (message.mnemonics && message.mnemonics.length) {
            object.mnemonics = [];
            for (var j = 0; j < message.mnemonics.length; ++j)
                object.mnemonics[j] = message.mnemonics[j];
        }
        if (message.pin != null && message.hasOwnProperty("pin"))
            object.pin = message.pin;
        if (message.passphrase_protection != null && message.hasOwnProperty("passphrase_protection"))
            object.passphrase_protection = message.passphrase_protection;
        if (message.language != null && message.hasOwnProperty("language"))
            object.language = message.language;
        if (message.label != null && message.hasOwnProperty("label"))
            object.label = message.label;
        if (message.skip_checksum != null && message.hasOwnProperty("skip_checksum"))
            object.skip_checksum = message.skip_checksum;
        if (message.u2f_counter != null && message.hasOwnProperty("u2f_counter"))
            object.u2f_counter = message.u2f_counter;
        if (message.needs_backup != null && message.hasOwnProperty("needs_backup"))
            object.needs_backup = message.needs_backup;
        if (message.no_backup != null && message.hasOwnProperty("no_backup"))
            object.no_backup = message.no_backup;
        return object;
    };

    LoadDevice.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return LoadDevice;
})();

$root.ResetDevice = (function() {

    function ResetDevice(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ResetDevice.prototype.display_random = false;
    ResetDevice.prototype.strength = 256;
    ResetDevice.prototype.passphrase_protection = false;
    ResetDevice.prototype.pin_protection = false;
    ResetDevice.prototype.language = "en-US";
    ResetDevice.prototype.label = "";
    ResetDevice.prototype.u2f_counter = 0;
    ResetDevice.prototype.skip_backup = false;
    ResetDevice.prototype.no_backup = false;
    ResetDevice.prototype.backup_type = 0;

    ResetDevice.create = function create(properties) {
        return new ResetDevice(properties);
    };

    ResetDevice.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.display_random != null && Object.hasOwnProperty.call(message, "display_random"))
            writer.uint32(8).bool(message.display_random);
        if (message.strength != null && Object.hasOwnProperty.call(message, "strength"))
            writer.uint32(16).uint32(message.strength);
        if (message.passphrase_protection != null && Object.hasOwnProperty.call(message, "passphrase_protection"))
            writer.uint32(24).bool(message.passphrase_protection);
        if (message.pin_protection != null && Object.hasOwnProperty.call(message, "pin_protection"))
            writer.uint32(32).bool(message.pin_protection);
        if (message.language != null && Object.hasOwnProperty.call(message, "language"))
            writer.uint32(42).string(message.language);
        if (message.label != null && Object.hasOwnProperty.call(message, "label"))
            writer.uint32(50).string(message.label);
        if (message.u2f_counter != null && Object.hasOwnProperty.call(message, "u2f_counter"))
            writer.uint32(56).uint32(message.u2f_counter);
        if (message.skip_backup != null && Object.hasOwnProperty.call(message, "skip_backup"))
            writer.uint32(64).bool(message.skip_backup);
        if (message.no_backup != null && Object.hasOwnProperty.call(message, "no_backup"))
            writer.uint32(72).bool(message.no_backup);
        if (message.backup_type != null && Object.hasOwnProperty.call(message, "backup_type"))
            writer.uint32(80).int32(message.backup_type);
        return writer;
    };

    ResetDevice.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ResetDevice.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ResetDevice();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.display_random = reader.bool();
                break;
            case 2:
                message.strength = reader.uint32();
                break;
            case 3:
                message.passphrase_protection = reader.bool();
                break;
            case 4:
                message.pin_protection = reader.bool();
                break;
            case 5:
                message.language = reader.string();
                break;
            case 6:
                message.label = reader.string();
                break;
            case 7:
                message.u2f_counter = reader.uint32();
                break;
            case 8:
                message.skip_backup = reader.bool();
                break;
            case 9:
                message.no_backup = reader.bool();
                break;
            case 10:
                message.backup_type = reader.int32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    ResetDevice.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ResetDevice.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.display_random != null && message.hasOwnProperty("display_random"))
            if (typeof message.display_random !== "boolean")
                return "display_random: boolean expected";
        if (message.strength != null && message.hasOwnProperty("strength"))
            if (!$util.isInteger(message.strength))
                return "strength: integer expected";
        if (message.passphrase_protection != null && message.hasOwnProperty("passphrase_protection"))
            if (typeof message.passphrase_protection !== "boolean")
                return "passphrase_protection: boolean expected";
        if (message.pin_protection != null && message.hasOwnProperty("pin_protection"))
            if (typeof message.pin_protection !== "boolean")
                return "pin_protection: boolean expected";
        if (message.language != null && message.hasOwnProperty("language"))
            if (!$util.isString(message.language))
                return "language: string expected";
        if (message.label != null && message.hasOwnProperty("label"))
            if (!$util.isString(message.label))
                return "label: string expected";
        if (message.u2f_counter != null && message.hasOwnProperty("u2f_counter"))
            if (!$util.isInteger(message.u2f_counter))
                return "u2f_counter: integer expected";
        if (message.skip_backup != null && message.hasOwnProperty("skip_backup"))
            if (typeof message.skip_backup !== "boolean")
                return "skip_backup: boolean expected";
        if (message.no_backup != null && message.hasOwnProperty("no_backup"))
            if (typeof message.no_backup !== "boolean")
                return "no_backup: boolean expected";
        if (message.backup_type != null && message.hasOwnProperty("backup_type"))
            switch (message.backup_type) {
            default:
                return "backup_type: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
                break;
            }
        return null;
    };

    ResetDevice.fromObject = function fromObject(object) {
        if (object instanceof $root.ResetDevice)
            return object;
        var message = new $root.ResetDevice();
        if (object.display_random != null)
            message.display_random = Boolean(object.display_random);
        if (object.strength != null)
            message.strength = object.strength >>> 0;
        if (object.passphrase_protection != null)
            message.passphrase_protection = Boolean(object.passphrase_protection);
        if (object.pin_protection != null)
            message.pin_protection = Boolean(object.pin_protection);
        if (object.language != null)
            message.language = String(object.language);
        if (object.label != null)
            message.label = String(object.label);
        if (object.u2f_counter != null)
            message.u2f_counter = object.u2f_counter >>> 0;
        if (object.skip_backup != null)
            message.skip_backup = Boolean(object.skip_backup);
        if (object.no_backup != null)
            message.no_backup = Boolean(object.no_backup);
        switch (object.backup_type) {
        case "Bip39":
        case 0:
            message.backup_type = 0;
            break;
        case "Slip39_Basic":
        case 1:
            message.backup_type = 1;
            break;
        case "Slip39_Advanced":
        case 2:
            message.backup_type = 2;
            break;
        case "Slip39_Single_Extendable":
        case 3:
            message.backup_type = 3;
            break;
        case "Slip39_Basic_Extendable":
        case 4:
            message.backup_type = 4;
            break;
        case "Slip39_Advanced_Extendable":
        case 5:
            message.backup_type = 5;
            break;
        }
        return message;
    };

    ResetDevice.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.display_random = false;
            object.strength = 256;
            object.passphrase_protection = false;
            object.pin_protection = false;
            object.language = "en-US";
            object.label = "";
            object.u2f_counter = 0;
            object.skip_backup = false;
            object.no_backup = false;
            object.backup_type = options.enums === String ? "Bip39" : 0;
        }
        if (message.display_random != null && message.hasOwnProperty("display_random"))
            object.display_random = message.display_random;
        if (message.strength != null && message.hasOwnProperty("strength"))
            object.strength = message.strength;
        if (message.passphrase_protection != null && message.hasOwnProperty("passphrase_protection"))
            object.passphrase_protection = message.passphrase_protection;
        if (message.pin_protection != null && message.hasOwnProperty("pin_protection"))
            object.pin_protection = message.pin_protection;
        if (message.language != null && message.hasOwnProperty("language"))
            object.language = message.language;
        if (message.label != null && message.hasOwnProperty("label"))
            object.label = message.label;
        if (message.u2f_counter != null && message.hasOwnProperty("u2f_counter"))
            object.u2f_counter = message.u2f_counter;
        if (message.skip_backup != null && message.hasOwnProperty("skip_backup"))
            object.skip_backup = message.skip_backup;
        if (message.no_backup != null && message.hasOwnProperty("no_backup"))
            object.no_backup = message.no_backup;
        if (message.backup_type != null && message.hasOwnProperty("backup_type"))
            object.backup_type = options.enums === String ? $root.BackupType[message.backup_type] : message.backup_type;
        return object;
    };

    ResetDevice.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ResetDevice;
})();

$root.BackupDevice = (function() {

    function BackupDevice(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    BackupDevice.create = function create(properties) {
        return new BackupDevice(properties);
    };

    BackupDevice.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    BackupDevice.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    BackupDevice.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BackupDevice();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    BackupDevice.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    BackupDevice.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    BackupDevice.fromObject = function fromObject(object) {
        if (object instanceof $root.BackupDevice)
            return object;
        return new $root.BackupDevice();
    };

    BackupDevice.toObject = function toObject() {
        return {};
    };

    BackupDevice.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return BackupDevice;
})();

$root.EntropyRequest = (function() {

    function EntropyRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EntropyRequest.create = function create(properties) {
        return new EntropyRequest(properties);
    };

    EntropyRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    EntropyRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EntropyRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EntropyRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    EntropyRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EntropyRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    EntropyRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.EntropyRequest)
            return object;
        return new $root.EntropyRequest();
    };

    EntropyRequest.toObject = function toObject() {
        return {};
    };

    EntropyRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EntropyRequest;
})();

$root.EntropyAck = (function() {

    function EntropyAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    EntropyAck.prototype.entropy = $util.newBuffer([]);

    EntropyAck.create = function create(properties) {
        return new EntropyAck(properties);
    };

    EntropyAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.entropy);
        return writer;
    };

    EntropyAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    EntropyAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EntropyAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.entropy = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("entropy"))
            throw $util.ProtocolError("missing required 'entropy'", { instance: message });
        return message;
    };

    EntropyAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    EntropyAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.entropy && typeof message.entropy.length === "number" || $util.isString(message.entropy)))
            return "entropy: buffer expected";
        return null;
    };

    EntropyAck.fromObject = function fromObject(object) {
        if (object instanceof $root.EntropyAck)
            return object;
        var message = new $root.EntropyAck();
        if (object.entropy != null)
            if (typeof object.entropy === "string")
                $util.base64.decode(object.entropy, message.entropy = $util.newBuffer($util.base64.length(object.entropy)), 0);
            else if (object.entropy.length)
                message.entropy = object.entropy;
        return message;
    };

    EntropyAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.entropy = "";
            else {
                object.entropy = [];
                if (options.bytes !== Array)
                    object.entropy = $util.newBuffer(object.entropy);
            }
        if (message.entropy != null && message.hasOwnProperty("entropy"))
            object.entropy = options.bytes === String ? $util.base64.encode(message.entropy, 0, message.entropy.length) : options.bytes === Array ? Array.prototype.slice.call(message.entropy) : message.entropy;
        return object;
    };

    EntropyAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EntropyAck;
})();

$root.RecoveryDevice = (function() {

    function RecoveryDevice(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    RecoveryDevice.prototype.word_count = 0;
    RecoveryDevice.prototype.passphrase_protection = false;
    RecoveryDevice.prototype.pin_protection = false;
    RecoveryDevice.prototype.language = "";
    RecoveryDevice.prototype.label = "";
    RecoveryDevice.prototype.enforce_wordlist = false;
    RecoveryDevice.prototype.type = 0;
    RecoveryDevice.prototype.u2f_counter = 0;
    RecoveryDevice.prototype.dry_run = false;

    RecoveryDevice.create = function create(properties) {
        return new RecoveryDevice(properties);
    };

    RecoveryDevice.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.word_count != null && Object.hasOwnProperty.call(message, "word_count"))
            writer.uint32(8).uint32(message.word_count);
        if (message.passphrase_protection != null && Object.hasOwnProperty.call(message, "passphrase_protection"))
            writer.uint32(16).bool(message.passphrase_protection);
        if (message.pin_protection != null && Object.hasOwnProperty.call(message, "pin_protection"))
            writer.uint32(24).bool(message.pin_protection);
        if (message.language != null && Object.hasOwnProperty.call(message, "language"))
            writer.uint32(34).string(message.language);
        if (message.label != null && Object.hasOwnProperty.call(message, "label"))
            writer.uint32(42).string(message.label);
        if (message.enforce_wordlist != null && Object.hasOwnProperty.call(message, "enforce_wordlist"))
            writer.uint32(48).bool(message.enforce_wordlist);
        if (message.type != null && Object.hasOwnProperty.call(message, "type"))
            writer.uint32(64).int32(message.type);
        if (message.u2f_counter != null && Object.hasOwnProperty.call(message, "u2f_counter"))
            writer.uint32(72).uint32(message.u2f_counter);
        if (message.dry_run != null && Object.hasOwnProperty.call(message, "dry_run"))
            writer.uint32(80).bool(message.dry_run);
        return writer;
    };

    RecoveryDevice.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    RecoveryDevice.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.RecoveryDevice();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.word_count = reader.uint32();
                break;
            case 2:
                message.passphrase_protection = reader.bool();
                break;
            case 3:
                message.pin_protection = reader.bool();
                break;
            case 4:
                message.language = reader.string();
                break;
            case 5:
                message.label = reader.string();
                break;
            case 6:
                message.enforce_wordlist = reader.bool();
                break;
            case 8:
                message.type = reader.int32();
                break;
            case 9:
                message.u2f_counter = reader.uint32();
                break;
            case 10:
                message.dry_run = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    RecoveryDevice.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    RecoveryDevice.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.word_count != null && message.hasOwnProperty("word_count"))
            if (!$util.isInteger(message.word_count))
                return "word_count: integer expected";
        if (message.passphrase_protection != null && message.hasOwnProperty("passphrase_protection"))
            if (typeof message.passphrase_protection !== "boolean")
                return "passphrase_protection: boolean expected";
        if (message.pin_protection != null && message.hasOwnProperty("pin_protection"))
            if (typeof message.pin_protection !== "boolean")
                return "pin_protection: boolean expected";
        if (message.language != null && message.hasOwnProperty("language"))
            if (!$util.isString(message.language))
                return "language: string expected";
        if (message.label != null && message.hasOwnProperty("label"))
            if (!$util.isString(message.label))
                return "label: string expected";
        if (message.enforce_wordlist != null && message.hasOwnProperty("enforce_wordlist"))
            if (typeof message.enforce_wordlist !== "boolean")
                return "enforce_wordlist: boolean expected";
        if (message.type != null && message.hasOwnProperty("type"))
            switch (message.type) {
            default:
                return "type: enum value expected";
            case 0:
            case 1:
                break;
            }
        if (message.u2f_counter != null && message.hasOwnProperty("u2f_counter"))
            if (!$util.isInteger(message.u2f_counter))
                return "u2f_counter: integer expected";
        if (message.dry_run != null && message.hasOwnProperty("dry_run"))
            if (typeof message.dry_run !== "boolean")
                return "dry_run: boolean expected";
        return null;
    };

    RecoveryDevice.fromObject = function fromObject(object) {
        if (object instanceof $root.RecoveryDevice)
            return object;
        var message = new $root.RecoveryDevice();
        if (object.word_count != null)
            message.word_count = object.word_count >>> 0;
        if (object.passphrase_protection != null)
            message.passphrase_protection = Boolean(object.passphrase_protection);
        if (object.pin_protection != null)
            message.pin_protection = Boolean(object.pin_protection);
        if (object.language != null)
            message.language = String(object.language);
        if (object.label != null)
            message.label = String(object.label);
        if (object.enforce_wordlist != null)
            message.enforce_wordlist = Boolean(object.enforce_wordlist);
        switch (object.type) {
        case "RecoveryDeviceType_ScrambledWords":
        case 0:
            message.type = 0;
            break;
        case "RecoveryDeviceType_Matrix":
        case 1:
            message.type = 1;
            break;
        }
        if (object.u2f_counter != null)
            message.u2f_counter = object.u2f_counter >>> 0;
        if (object.dry_run != null)
            message.dry_run = Boolean(object.dry_run);
        return message;
    };

    RecoveryDevice.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.word_count = 0;
            object.passphrase_protection = false;
            object.pin_protection = false;
            object.language = "";
            object.label = "";
            object.enforce_wordlist = false;
            object.type = options.enums === String ? "RecoveryDeviceType_ScrambledWords" : 0;
            object.u2f_counter = 0;
            object.dry_run = false;
        }
        if (message.word_count != null && message.hasOwnProperty("word_count"))
            object.word_count = message.word_count;
        if (message.passphrase_protection != null && message.hasOwnProperty("passphrase_protection"))
            object.passphrase_protection = message.passphrase_protection;
        if (message.pin_protection != null && message.hasOwnProperty("pin_protection"))
            object.pin_protection = message.pin_protection;
        if (message.language != null && message.hasOwnProperty("language"))
            object.language = message.language;
        if (message.label != null && message.hasOwnProperty("label"))
            object.label = message.label;
        if (message.enforce_wordlist != null && message.hasOwnProperty("enforce_wordlist"))
            object.enforce_wordlist = message.enforce_wordlist;
        if (message.type != null && message.hasOwnProperty("type"))
            object.type = options.enums === String ? $root.RecoveryDevice.RecoveryDeviceType[message.type] : message.type;
        if (message.u2f_counter != null && message.hasOwnProperty("u2f_counter"))
            object.u2f_counter = message.u2f_counter;
        if (message.dry_run != null && message.hasOwnProperty("dry_run"))
            object.dry_run = message.dry_run;
        return object;
    };

    RecoveryDevice.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    RecoveryDevice.RecoveryDeviceType = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "RecoveryDeviceType_ScrambledWords"] = 0;
        values[valuesById[1] = "RecoveryDeviceType_Matrix"] = 1;
        return values;
    })();

    return RecoveryDevice;
})();

$root.WordRequest = (function() {

    function WordRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    WordRequest.prototype.type = 0;

    WordRequest.create = function create(properties) {
        return new WordRequest(properties);
    };

    WordRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).int32(message.type);
        return writer;
    };

    WordRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    WordRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.WordRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.type = reader.int32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("type"))
            throw $util.ProtocolError("missing required 'type'", { instance: message });
        return message;
    };

    WordRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    WordRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        switch (message.type) {
        default:
            return "type: enum value expected";
        case 0:
        case 1:
        case 2:
            break;
        }
        return null;
    };

    WordRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.WordRequest)
            return object;
        var message = new $root.WordRequest();
        switch (object.type) {
        case "WordRequestType_Plain":
        case 0:
            message.type = 0;
            break;
        case "WordRequestType_Matrix9":
        case 1:
            message.type = 1;
            break;
        case "WordRequestType_Matrix6":
        case 2:
            message.type = 2;
            break;
        }
        return message;
    };

    WordRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.type = options.enums === String ? "WordRequestType_Plain" : 0;
        if (message.type != null && message.hasOwnProperty("type"))
            object.type = options.enums === String ? $root.WordRequest.WordRequestType[message.type] : message.type;
        return object;
    };

    WordRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    WordRequest.WordRequestType = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "WordRequestType_Plain"] = 0;
        values[valuesById[1] = "WordRequestType_Matrix9"] = 1;
        values[valuesById[2] = "WordRequestType_Matrix6"] = 2;
        return values;
    })();

    return WordRequest;
})();

$root.WordAck = (function() {

    function WordAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    WordAck.prototype.word = "";

    WordAck.create = function create(properties) {
        return new WordAck(properties);
    };

    WordAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.word);
        return writer;
    };

    WordAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    WordAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.WordAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.word = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("word"))
            throw $util.ProtocolError("missing required 'word'", { instance: message });
        return message;
    };

    WordAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    WordAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.word))
            return "word: string expected";
        return null;
    };

    WordAck.fromObject = function fromObject(object) {
        if (object instanceof $root.WordAck)
            return object;
        var message = new $root.WordAck();
        if (object.word != null)
            message.word = String(object.word);
        return message;
    };

    WordAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.word = "";
        if (message.word != null && message.hasOwnProperty("word"))
            object.word = message.word;
        return object;
    };

    WordAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return WordAck;
})();

$root.SetU2FCounter = (function() {

    function SetU2FCounter(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    SetU2FCounter.prototype.u2f_counter = 0;

    SetU2FCounter.create = function create(properties) {
        return new SetU2FCounter(properties);
    };

    SetU2FCounter.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).uint32(message.u2f_counter);
        return writer;
    };

    SetU2FCounter.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    SetU2FCounter.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SetU2FCounter();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.u2f_counter = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("u2f_counter"))
            throw $util.ProtocolError("missing required 'u2f_counter'", { instance: message });
        return message;
    };

    SetU2FCounter.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    SetU2FCounter.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isInteger(message.u2f_counter))
            return "u2f_counter: integer expected";
        return null;
    };

    SetU2FCounter.fromObject = function fromObject(object) {
        if (object instanceof $root.SetU2FCounter)
            return object;
        var message = new $root.SetU2FCounter();
        if (object.u2f_counter != null)
            message.u2f_counter = object.u2f_counter >>> 0;
        return message;
    };

    SetU2FCounter.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.u2f_counter = 0;
        if (message.u2f_counter != null && message.hasOwnProperty("u2f_counter"))
            object.u2f_counter = message.u2f_counter;
        return object;
    };

    SetU2FCounter.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SetU2FCounter;
})();

$root.GetNextU2FCounter = (function() {

    function GetNextU2FCounter(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    GetNextU2FCounter.create = function create(properties) {
        return new GetNextU2FCounter(properties);
    };

    GetNextU2FCounter.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    GetNextU2FCounter.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    GetNextU2FCounter.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.GetNextU2FCounter();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    GetNextU2FCounter.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    GetNextU2FCounter.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    GetNextU2FCounter.fromObject = function fromObject(object) {
        if (object instanceof $root.GetNextU2FCounter)
            return object;
        return new $root.GetNextU2FCounter();
    };

    GetNextU2FCounter.toObject = function toObject() {
        return {};
    };

    GetNextU2FCounter.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return GetNextU2FCounter;
})();

$root.NextU2FCounter = (function() {

    function NextU2FCounter(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NextU2FCounter.prototype.u2f_counter = 0;

    NextU2FCounter.create = function create(properties) {
        return new NextU2FCounter(properties);
    };

    NextU2FCounter.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).uint32(message.u2f_counter);
        return writer;
    };

    NextU2FCounter.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NextU2FCounter.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NextU2FCounter();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.u2f_counter = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("u2f_counter"))
            throw $util.ProtocolError("missing required 'u2f_counter'", { instance: message });
        return message;
    };

    NextU2FCounter.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NextU2FCounter.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isInteger(message.u2f_counter))
            return "u2f_counter: integer expected";
        return null;
    };

    NextU2FCounter.fromObject = function fromObject(object) {
        if (object instanceof $root.NextU2FCounter)
            return object;
        var message = new $root.NextU2FCounter();
        if (object.u2f_counter != null)
            message.u2f_counter = object.u2f_counter >>> 0;
        return message;
    };

    NextU2FCounter.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.u2f_counter = 0;
        if (message.u2f_counter != null && message.hasOwnProperty("u2f_counter"))
            object.u2f_counter = message.u2f_counter;
        return object;
    };

    NextU2FCounter.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NextU2FCounter;
})();

$root.DoPreauthorized = (function() {

    function DoPreauthorized(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DoPreauthorized.create = function create(properties) {
        return new DoPreauthorized(properties);
    };

    DoPreauthorized.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    DoPreauthorized.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DoPreauthorized.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DoPreauthorized();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    DoPreauthorized.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DoPreauthorized.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    DoPreauthorized.fromObject = function fromObject(object) {
        if (object instanceof $root.DoPreauthorized)
            return object;
        return new $root.DoPreauthorized();
    };

    DoPreauthorized.toObject = function toObject() {
        return {};
    };

    DoPreauthorized.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DoPreauthorized;
})();

$root.PreauthorizedRequest = (function() {

    function PreauthorizedRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    PreauthorizedRequest.create = function create(properties) {
        return new PreauthorizedRequest(properties);
    };

    PreauthorizedRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    PreauthorizedRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    PreauthorizedRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.PreauthorizedRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    PreauthorizedRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    PreauthorizedRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    PreauthorizedRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.PreauthorizedRequest)
            return object;
        return new $root.PreauthorizedRequest();
    };

    PreauthorizedRequest.toObject = function toObject() {
        return {};
    };

    PreauthorizedRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return PreauthorizedRequest;
})();

$root.CancelAuthorization = (function() {

    function CancelAuthorization(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CancelAuthorization.create = function create(properties) {
        return new CancelAuthorization(properties);
    };

    CancelAuthorization.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    CancelAuthorization.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CancelAuthorization.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CancelAuthorization();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    CancelAuthorization.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CancelAuthorization.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    CancelAuthorization.fromObject = function fromObject(object) {
        if (object instanceof $root.CancelAuthorization)
            return object;
        return new $root.CancelAuthorization();
    };

    CancelAuthorization.toObject = function toObject() {
        return {};
    };

    CancelAuthorization.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CancelAuthorization;
})();

$root.GetNonce = (function() {

    function GetNonce(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    GetNonce.create = function create(properties) {
        return new GetNonce(properties);
    };

    GetNonce.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    GetNonce.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    GetNonce.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.GetNonce();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    GetNonce.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    GetNonce.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    GetNonce.fromObject = function fromObject(object) {
        if (object instanceof $root.GetNonce)
            return object;
        return new $root.GetNonce();
    };

    GetNonce.toObject = function toObject() {
        return {};
    };

    GetNonce.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return GetNonce;
})();

$root.Nonce = (function() {

    function Nonce(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    Nonce.prototype.nonce = $util.newBuffer([]);

    Nonce.create = function create(properties) {
        return new Nonce(properties);
    };

    Nonce.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.nonce);
        return writer;
    };

    Nonce.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    Nonce.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Nonce();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.nonce = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("nonce"))
            throw $util.ProtocolError("missing required 'nonce'", { instance: message });
        return message;
    };

    Nonce.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    Nonce.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.nonce && typeof message.nonce.length === "number" || $util.isString(message.nonce)))
            return "nonce: buffer expected";
        return null;
    };

    Nonce.fromObject = function fromObject(object) {
        if (object instanceof $root.Nonce)
            return object;
        var message = new $root.Nonce();
        if (object.nonce != null)
            if (typeof object.nonce === "string")
                $util.base64.decode(object.nonce, message.nonce = $util.newBuffer($util.base64.length(object.nonce)), 0);
            else if (object.nonce.length)
                message.nonce = object.nonce;
        return message;
    };

    Nonce.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.nonce = "";
            else {
                object.nonce = [];
                if (options.bytes !== Array)
                    object.nonce = $util.newBuffer(object.nonce);
            }
        if (message.nonce != null && message.hasOwnProperty("nonce"))
            object.nonce = options.bytes === String ? $util.base64.encode(message.nonce, 0, message.nonce.length) : options.bytes === Array ? Array.prototype.slice.call(message.nonce) : message.nonce;
        return object;
    };

    Nonce.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return Nonce;
})();

$root.WriteSEPrivateKey = (function() {

    function WriteSEPrivateKey(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    WriteSEPrivateKey.prototype.private_key = $util.newBuffer([]);

    WriteSEPrivateKey.create = function create(properties) {
        return new WriteSEPrivateKey(properties);
    };

    WriteSEPrivateKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.private_key);
        return writer;
    };

    WriteSEPrivateKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    WriteSEPrivateKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.WriteSEPrivateKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.private_key = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("private_key"))
            throw $util.ProtocolError("missing required 'private_key'", { instance: message });
        return message;
    };

    WriteSEPrivateKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    WriteSEPrivateKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.private_key && typeof message.private_key.length === "number" || $util.isString(message.private_key)))
            return "private_key: buffer expected";
        return null;
    };

    WriteSEPrivateKey.fromObject = function fromObject(object) {
        if (object instanceof $root.WriteSEPrivateKey)
            return object;
        var message = new $root.WriteSEPrivateKey();
        if (object.private_key != null)
            if (typeof object.private_key === "string")
                $util.base64.decode(object.private_key, message.private_key = $util.newBuffer($util.base64.length(object.private_key)), 0);
            else if (object.private_key.length)
                message.private_key = object.private_key;
        return message;
    };

    WriteSEPrivateKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.private_key = "";
            else {
                object.private_key = [];
                if (options.bytes !== Array)
                    object.private_key = $util.newBuffer(object.private_key);
            }
        if (message.private_key != null && message.hasOwnProperty("private_key"))
            object.private_key = options.bytes === String ? $util.base64.encode(message.private_key, 0, message.private_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.private_key) : message.private_key;
        return object;
    };

    WriteSEPrivateKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return WriteSEPrivateKey;
})();

$root.ReadSEPublicKey = (function() {

    function ReadSEPublicKey(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ReadSEPublicKey.create = function create(properties) {
        return new ReadSEPublicKey(properties);
    };

    ReadSEPublicKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    ReadSEPublicKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ReadSEPublicKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ReadSEPublicKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    ReadSEPublicKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ReadSEPublicKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    ReadSEPublicKey.fromObject = function fromObject(object) {
        if (object instanceof $root.ReadSEPublicKey)
            return object;
        return new $root.ReadSEPublicKey();
    };

    ReadSEPublicKey.toObject = function toObject() {
        return {};
    };

    ReadSEPublicKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ReadSEPublicKey;
})();

$root.SEPublicKey = (function() {

    function SEPublicKey(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    SEPublicKey.prototype.public_key = $util.newBuffer([]);

    SEPublicKey.create = function create(properties) {
        return new SEPublicKey(properties);
    };

    SEPublicKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.public_key);
        return writer;
    };

    SEPublicKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    SEPublicKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SEPublicKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.public_key = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("public_key"))
            throw $util.ProtocolError("missing required 'public_key'", { instance: message });
        return message;
    };

    SEPublicKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    SEPublicKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.public_key && typeof message.public_key.length === "number" || $util.isString(message.public_key)))
            return "public_key: buffer expected";
        return null;
    };

    SEPublicKey.fromObject = function fromObject(object) {
        if (object instanceof $root.SEPublicKey)
            return object;
        var message = new $root.SEPublicKey();
        if (object.public_key != null)
            if (typeof object.public_key === "string")
                $util.base64.decode(object.public_key, message.public_key = $util.newBuffer($util.base64.length(object.public_key)), 0);
            else if (object.public_key.length)
                message.public_key = object.public_key;
        return message;
    };

    SEPublicKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.public_key = "";
            else {
                object.public_key = [];
                if (options.bytes !== Array)
                    object.public_key = $util.newBuffer(object.public_key);
            }
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            object.public_key = options.bytes === String ? $util.base64.encode(message.public_key, 0, message.public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.public_key) : message.public_key;
        return object;
    };

    SEPublicKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SEPublicKey;
})();

$root.WriteSEPublicCert = (function() {

    function WriteSEPublicCert(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    WriteSEPublicCert.prototype.public_cert = $util.newBuffer([]);

    WriteSEPublicCert.create = function create(properties) {
        return new WriteSEPublicCert(properties);
    };

    WriteSEPublicCert.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.public_cert);
        return writer;
    };

    WriteSEPublicCert.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    WriteSEPublicCert.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.WriteSEPublicCert();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.public_cert = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("public_cert"))
            throw $util.ProtocolError("missing required 'public_cert'", { instance: message });
        return message;
    };

    WriteSEPublicCert.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    WriteSEPublicCert.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.public_cert && typeof message.public_cert.length === "number" || $util.isString(message.public_cert)))
            return "public_cert: buffer expected";
        return null;
    };

    WriteSEPublicCert.fromObject = function fromObject(object) {
        if (object instanceof $root.WriteSEPublicCert)
            return object;
        var message = new $root.WriteSEPublicCert();
        if (object.public_cert != null)
            if (typeof object.public_cert === "string")
                $util.base64.decode(object.public_cert, message.public_cert = $util.newBuffer($util.base64.length(object.public_cert)), 0);
            else if (object.public_cert.length)
                message.public_cert = object.public_cert;
        return message;
    };

    WriteSEPublicCert.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.public_cert = "";
            else {
                object.public_cert = [];
                if (options.bytes !== Array)
                    object.public_cert = $util.newBuffer(object.public_cert);
            }
        if (message.public_cert != null && message.hasOwnProperty("public_cert"))
            object.public_cert = options.bytes === String ? $util.base64.encode(message.public_cert, 0, message.public_cert.length) : options.bytes === Array ? Array.prototype.slice.call(message.public_cert) : message.public_cert;
        return object;
    };

    WriteSEPublicCert.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return WriteSEPublicCert;
})();

$root.ReadSEPublicCert = (function() {

    function ReadSEPublicCert(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ReadSEPublicCert.create = function create(properties) {
        return new ReadSEPublicCert(properties);
    };

    ReadSEPublicCert.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    ReadSEPublicCert.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ReadSEPublicCert.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ReadSEPublicCert();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    ReadSEPublicCert.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ReadSEPublicCert.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    ReadSEPublicCert.fromObject = function fromObject(object) {
        if (object instanceof $root.ReadSEPublicCert)
            return object;
        return new $root.ReadSEPublicCert();
    };

    ReadSEPublicCert.toObject = function toObject() {
        return {};
    };

    ReadSEPublicCert.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ReadSEPublicCert;
})();

$root.SEPublicCert = (function() {

    function SEPublicCert(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    SEPublicCert.prototype.public_cert = $util.newBuffer([]);

    SEPublicCert.create = function create(properties) {
        return new SEPublicCert(properties);
    };

    SEPublicCert.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.public_cert);
        return writer;
    };

    SEPublicCert.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    SEPublicCert.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SEPublicCert();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.public_cert = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("public_cert"))
            throw $util.ProtocolError("missing required 'public_cert'", { instance: message });
        return message;
    };

    SEPublicCert.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    SEPublicCert.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.public_cert && typeof message.public_cert.length === "number" || $util.isString(message.public_cert)))
            return "public_cert: buffer expected";
        return null;
    };

    SEPublicCert.fromObject = function fromObject(object) {
        if (object instanceof $root.SEPublicCert)
            return object;
        var message = new $root.SEPublicCert();
        if (object.public_cert != null)
            if (typeof object.public_cert === "string")
                $util.base64.decode(object.public_cert, message.public_cert = $util.newBuffer($util.base64.length(object.public_cert)), 0);
            else if (object.public_cert.length)
                message.public_cert = object.public_cert;
        return message;
    };

    SEPublicCert.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.public_cert = "";
            else {
                object.public_cert = [];
                if (options.bytes !== Array)
                    object.public_cert = $util.newBuffer(object.public_cert);
            }
        if (message.public_cert != null && message.hasOwnProperty("public_cert"))
            object.public_cert = options.bytes === String ? $util.base64.encode(message.public_cert, 0, message.public_cert.length) : options.bytes === Array ? Array.prototype.slice.call(message.public_cert) : message.public_cert;
        return object;
    };

    SEPublicCert.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SEPublicCert;
})();

$root.SESignMessage = (function() {

    function SESignMessage(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    SESignMessage.prototype.message = $util.newBuffer([]);

    SESignMessage.create = function create(properties) {
        return new SESignMessage(properties);
    };

    SESignMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.message);
        return writer;
    };

    SESignMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    SESignMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SESignMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.message = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("message"))
            throw $util.ProtocolError("missing required 'message'", { instance: message });
        return message;
    };

    SESignMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    SESignMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.message && typeof message.message.length === "number" || $util.isString(message.message)))
            return "message: buffer expected";
        return null;
    };

    SESignMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.SESignMessage)
            return object;
        var message = new $root.SESignMessage();
        if (object.message != null)
            if (typeof object.message === "string")
                $util.base64.decode(object.message, message.message = $util.newBuffer($util.base64.length(object.message)), 0);
            else if (object.message.length)
                message.message = object.message;
        return message;
    };

    SESignMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.message = "";
            else {
                object.message = [];
                if (options.bytes !== Array)
                    object.message = $util.newBuffer(object.message);
            }
        if (message.message != null && message.hasOwnProperty("message"))
            object.message = options.bytes === String ? $util.base64.encode(message.message, 0, message.message.length) : options.bytes === Array ? Array.prototype.slice.call(message.message) : message.message;
        return object;
    };

    SESignMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SESignMessage;
})();

$root.SEMessageSignature = (function() {

    function SEMessageSignature(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    SEMessageSignature.prototype.signature = $util.newBuffer([]);

    SEMessageSignature.create = function create(properties) {
        return new SEMessageSignature(properties);
    };

    SEMessageSignature.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.signature);
        return writer;
    };

    SEMessageSignature.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    SEMessageSignature.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SEMessageSignature();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.signature = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        return message;
    };

    SEMessageSignature.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    SEMessageSignature.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        return null;
    };

    SEMessageSignature.fromObject = function fromObject(object) {
        if (object instanceof $root.SEMessageSignature)
            return object;
        var message = new $root.SEMessageSignature();
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        return message;
    };

    SEMessageSignature.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        return object;
    };

    SEMessageSignature.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SEMessageSignature;
})();

$root.ResourceUpload = (function() {

    function ResourceUpload(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ResourceUpload.prototype.extension = "";
    ResourceUpload.prototype.data_length = 0;
    ResourceUpload.prototype.res_type = 0;
    ResourceUpload.prototype.nft_meta_data = $util.newBuffer([]);
    ResourceUpload.prototype.zoom_data_length = 0;
    ResourceUpload.prototype.file_name_no_ext = "";
    ResourceUpload.prototype.blur_data_length = 0;

    ResourceUpload.create = function create(properties) {
        return new ResourceUpload(properties);
    };

    ResourceUpload.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.extension);
        writer.uint32(16).uint32(message.data_length);
        writer.uint32(24).int32(message.res_type);
        if (message.nft_meta_data != null && Object.hasOwnProperty.call(message, "nft_meta_data"))
            writer.uint32(34).bytes(message.nft_meta_data);
        writer.uint32(40).uint32(message.zoom_data_length);
        if (message.file_name_no_ext != null && Object.hasOwnProperty.call(message, "file_name_no_ext"))
            writer.uint32(50).string(message.file_name_no_ext);
        if (message.blur_data_length != null && Object.hasOwnProperty.call(message, "blur_data_length"))
            writer.uint32(56).uint32(message.blur_data_length);
        return writer;
    };

    ResourceUpload.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ResourceUpload.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ResourceUpload();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.extension = reader.string();
                break;
            case 2:
                message.data_length = reader.uint32();
                break;
            case 3:
                message.res_type = reader.int32();
                break;
            case 4:
                message.nft_meta_data = reader.bytes();
                break;
            case 5:
                message.zoom_data_length = reader.uint32();
                break;
            case 6:
                message.file_name_no_ext = reader.string();
                break;
            case 7:
                message.blur_data_length = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("extension"))
            throw $util.ProtocolError("missing required 'extension'", { instance: message });
        if (!message.hasOwnProperty("data_length"))
            throw $util.ProtocolError("missing required 'data_length'", { instance: message });
        if (!message.hasOwnProperty("res_type"))
            throw $util.ProtocolError("missing required 'res_type'", { instance: message });
        if (!message.hasOwnProperty("zoom_data_length"))
            throw $util.ProtocolError("missing required 'zoom_data_length'", { instance: message });
        return message;
    };

    ResourceUpload.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ResourceUpload.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.extension))
            return "extension: string expected";
        if (!$util.isInteger(message.data_length))
            return "data_length: integer expected";
        switch (message.res_type) {
        default:
            return "res_type: enum value expected";
        case 0:
        case 1:
            break;
        }
        if (message.nft_meta_data != null && message.hasOwnProperty("nft_meta_data"))
            if (!(message.nft_meta_data && typeof message.nft_meta_data.length === "number" || $util.isString(message.nft_meta_data)))
                return "nft_meta_data: buffer expected";
        if (!$util.isInteger(message.zoom_data_length))
            return "zoom_data_length: integer expected";
        if (message.file_name_no_ext != null && message.hasOwnProperty("file_name_no_ext"))
            if (!$util.isString(message.file_name_no_ext))
                return "file_name_no_ext: string expected";
        if (message.blur_data_length != null && message.hasOwnProperty("blur_data_length"))
            if (!$util.isInteger(message.blur_data_length))
                return "blur_data_length: integer expected";
        return null;
    };

    ResourceUpload.fromObject = function fromObject(object) {
        if (object instanceof $root.ResourceUpload)
            return object;
        var message = new $root.ResourceUpload();
        if (object.extension != null)
            message.extension = String(object.extension);
        if (object.data_length != null)
            message.data_length = object.data_length >>> 0;
        switch (object.res_type) {
        case "WallPaper":
        case 0:
            message.res_type = 0;
            break;
        case "Nft":
        case 1:
            message.res_type = 1;
            break;
        }
        if (object.nft_meta_data != null)
            if (typeof object.nft_meta_data === "string")
                $util.base64.decode(object.nft_meta_data, message.nft_meta_data = $util.newBuffer($util.base64.length(object.nft_meta_data)), 0);
            else if (object.nft_meta_data.length)
                message.nft_meta_data = object.nft_meta_data;
        if (object.zoom_data_length != null)
            message.zoom_data_length = object.zoom_data_length >>> 0;
        if (object.file_name_no_ext != null)
            message.file_name_no_ext = String(object.file_name_no_ext);
        if (object.blur_data_length != null)
            message.blur_data_length = object.blur_data_length >>> 0;
        return message;
    };

    ResourceUpload.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.extension = "";
            object.data_length = 0;
            object.res_type = options.enums === String ? "WallPaper" : 0;
            if (options.bytes === String)
                object.nft_meta_data = "";
            else {
                object.nft_meta_data = [];
                if (options.bytes !== Array)
                    object.nft_meta_data = $util.newBuffer(object.nft_meta_data);
            }
            object.zoom_data_length = 0;
            object.file_name_no_ext = "";
            object.blur_data_length = 0;
        }
        if (message.extension != null && message.hasOwnProperty("extension"))
            object.extension = message.extension;
        if (message.data_length != null && message.hasOwnProperty("data_length"))
            object.data_length = message.data_length;
        if (message.res_type != null && message.hasOwnProperty("res_type"))
            object.res_type = options.enums === String ? $root.ResourceUpload.ResourceType[message.res_type] : message.res_type;
        if (message.nft_meta_data != null && message.hasOwnProperty("nft_meta_data"))
            object.nft_meta_data = options.bytes === String ? $util.base64.encode(message.nft_meta_data, 0, message.nft_meta_data.length) : options.bytes === Array ? Array.prototype.slice.call(message.nft_meta_data) : message.nft_meta_data;
        if (message.zoom_data_length != null && message.hasOwnProperty("zoom_data_length"))
            object.zoom_data_length = message.zoom_data_length;
        if (message.file_name_no_ext != null && message.hasOwnProperty("file_name_no_ext"))
            object.file_name_no_ext = message.file_name_no_ext;
        if (message.blur_data_length != null && message.hasOwnProperty("blur_data_length"))
            object.blur_data_length = message.blur_data_length;
        return object;
    };

    ResourceUpload.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    ResourceUpload.ResourceType = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "WallPaper"] = 0;
        values[valuesById[1] = "Nft"] = 1;
        return values;
    })();

    return ResourceUpload;
})();

$root.ZoomRequest = (function() {

    function ZoomRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ZoomRequest.prototype.offset = 0;
    ZoomRequest.prototype.data_length = 0;

    ZoomRequest.create = function create(properties) {
        return new ZoomRequest(properties);
    };

    ZoomRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.offset != null && Object.hasOwnProperty.call(message, "offset"))
            writer.uint32(8).uint32(message.offset);
        writer.uint32(16).uint32(message.data_length);
        return writer;
    };

    ZoomRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ZoomRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ZoomRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.offset = reader.uint32();
                break;
            case 2:
                message.data_length = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("data_length"))
            throw $util.ProtocolError("missing required 'data_length'", { instance: message });
        return message;
    };

    ZoomRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ZoomRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.offset != null && message.hasOwnProperty("offset"))
            if (!$util.isInteger(message.offset))
                return "offset: integer expected";
        if (!$util.isInteger(message.data_length))
            return "data_length: integer expected";
        return null;
    };

    ZoomRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.ZoomRequest)
            return object;
        var message = new $root.ZoomRequest();
        if (object.offset != null)
            message.offset = object.offset >>> 0;
        if (object.data_length != null)
            message.data_length = object.data_length >>> 0;
        return message;
    };

    ZoomRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.offset = 0;
            object.data_length = 0;
        }
        if (message.offset != null && message.hasOwnProperty("offset"))
            object.offset = message.offset;
        if (message.data_length != null && message.hasOwnProperty("data_length"))
            object.data_length = message.data_length;
        return object;
    };

    ZoomRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ZoomRequest;
})();

$root.BlurRequest = (function() {

    function BlurRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    BlurRequest.prototype.offset = 0;
    BlurRequest.prototype.data_length = 0;

    BlurRequest.create = function create(properties) {
        return new BlurRequest(properties);
    };

    BlurRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.offset != null && Object.hasOwnProperty.call(message, "offset"))
            writer.uint32(8).uint32(message.offset);
        writer.uint32(16).uint32(message.data_length);
        return writer;
    };

    BlurRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    BlurRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BlurRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.offset = reader.uint32();
                break;
            case 2:
                message.data_length = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("data_length"))
            throw $util.ProtocolError("missing required 'data_length'", { instance: message });
        return message;
    };

    BlurRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    BlurRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.offset != null && message.hasOwnProperty("offset"))
            if (!$util.isInteger(message.offset))
                return "offset: integer expected";
        if (!$util.isInteger(message.data_length))
            return "data_length: integer expected";
        return null;
    };

    BlurRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.BlurRequest)
            return object;
        var message = new $root.BlurRequest();
        if (object.offset != null)
            message.offset = object.offset >>> 0;
        if (object.data_length != null)
            message.data_length = object.data_length >>> 0;
        return message;
    };

    BlurRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.offset = 0;
            object.data_length = 0;
        }
        if (message.offset != null && message.hasOwnProperty("offset"))
            object.offset = message.offset;
        if (message.data_length != null && message.hasOwnProperty("data_length"))
            object.data_length = message.data_length;
        return object;
    };

    BlurRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return BlurRequest;
})();

$root.ResourceRequest = (function() {

    function ResourceRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ResourceRequest.prototype.offset = 0;
    ResourceRequest.prototype.data_length = 0;

    ResourceRequest.create = function create(properties) {
        return new ResourceRequest(properties);
    };

    ResourceRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.offset != null && Object.hasOwnProperty.call(message, "offset"))
            writer.uint32(8).uint32(message.offset);
        writer.uint32(16).uint32(message.data_length);
        return writer;
    };

    ResourceRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ResourceRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ResourceRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.offset = reader.uint32();
                break;
            case 2:
                message.data_length = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("data_length"))
            throw $util.ProtocolError("missing required 'data_length'", { instance: message });
        return message;
    };

    ResourceRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ResourceRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.offset != null && message.hasOwnProperty("offset"))
            if (!$util.isInteger(message.offset))
                return "offset: integer expected";
        if (!$util.isInteger(message.data_length))
            return "data_length: integer expected";
        return null;
    };

    ResourceRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.ResourceRequest)
            return object;
        var message = new $root.ResourceRequest();
        if (object.offset != null)
            message.offset = object.offset >>> 0;
        if (object.data_length != null)
            message.data_length = object.data_length >>> 0;
        return message;
    };

    ResourceRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.offset = 0;
            object.data_length = 0;
        }
        if (message.offset != null && message.hasOwnProperty("offset"))
            object.offset = message.offset;
        if (message.data_length != null && message.hasOwnProperty("data_length"))
            object.data_length = message.data_length;
        return object;
    };

    ResourceRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ResourceRequest;
})();

$root.ResourceAck = (function() {

    function ResourceAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ResourceAck.prototype.data_chunk = $util.newBuffer([]);
    ResourceAck.prototype.hash = $util.newBuffer([]);

    ResourceAck.create = function create(properties) {
        return new ResourceAck(properties);
    };

    ResourceAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.data_chunk);
        if (message.hash != null && Object.hasOwnProperty.call(message, "hash"))
            writer.uint32(18).bytes(message.hash);
        return writer;
    };

    ResourceAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ResourceAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ResourceAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.data_chunk = reader.bytes();
                break;
            case 2:
                message.hash = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("data_chunk"))
            throw $util.ProtocolError("missing required 'data_chunk'", { instance: message });
        return message;
    };

    ResourceAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ResourceAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.data_chunk && typeof message.data_chunk.length === "number" || $util.isString(message.data_chunk)))
            return "data_chunk: buffer expected";
        if (message.hash != null && message.hasOwnProperty("hash"))
            if (!(message.hash && typeof message.hash.length === "number" || $util.isString(message.hash)))
                return "hash: buffer expected";
        return null;
    };

    ResourceAck.fromObject = function fromObject(object) {
        if (object instanceof $root.ResourceAck)
            return object;
        var message = new $root.ResourceAck();
        if (object.data_chunk != null)
            if (typeof object.data_chunk === "string")
                $util.base64.decode(object.data_chunk, message.data_chunk = $util.newBuffer($util.base64.length(object.data_chunk)), 0);
            else if (object.data_chunk.length)
                message.data_chunk = object.data_chunk;
        if (object.hash != null)
            if (typeof object.hash === "string")
                $util.base64.decode(object.hash, message.hash = $util.newBuffer($util.base64.length(object.hash)), 0);
            else if (object.hash.length)
                message.hash = object.hash;
        return message;
    };

    ResourceAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.data_chunk = "";
            else {
                object.data_chunk = [];
                if (options.bytes !== Array)
                    object.data_chunk = $util.newBuffer(object.data_chunk);
            }
            if (options.bytes === String)
                object.hash = "";
            else {
                object.hash = [];
                if (options.bytes !== Array)
                    object.hash = $util.newBuffer(object.hash);
            }
        }
        if (message.data_chunk != null && message.hasOwnProperty("data_chunk"))
            object.data_chunk = options.bytes === String ? $util.base64.encode(message.data_chunk, 0, message.data_chunk.length) : options.bytes === Array ? Array.prototype.slice.call(message.data_chunk) : message.data_chunk;
        if (message.hash != null && message.hasOwnProperty("hash"))
            object.hash = options.bytes === String ? $util.base64.encode(message.hash, 0, message.hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.hash) : message.hash;
        return object;
    };

    ResourceAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ResourceAck;
})();

$root.ResourceUpdate = (function() {

    function ResourceUpdate(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ResourceUpdate.prototype.file_name = "";
    ResourceUpdate.prototype.data_length = 0;
    ResourceUpdate.prototype.initial_data_chunk = $util.newBuffer([]);
    ResourceUpdate.prototype.hash = $util.newBuffer([]);

    ResourceUpdate.create = function create(properties) {
        return new ResourceUpdate(properties);
    };

    ResourceUpdate.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.file_name);
        writer.uint32(16).uint32(message.data_length);
        writer.uint32(26).bytes(message.initial_data_chunk);
        if (message.hash != null && Object.hasOwnProperty.call(message, "hash"))
            writer.uint32(34).bytes(message.hash);
        return writer;
    };

    ResourceUpdate.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ResourceUpdate.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ResourceUpdate();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.file_name = reader.string();
                break;
            case 2:
                message.data_length = reader.uint32();
                break;
            case 3:
                message.initial_data_chunk = reader.bytes();
                break;
            case 4:
                message.hash = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("file_name"))
            throw $util.ProtocolError("missing required 'file_name'", { instance: message });
        if (!message.hasOwnProperty("data_length"))
            throw $util.ProtocolError("missing required 'data_length'", { instance: message });
        if (!message.hasOwnProperty("initial_data_chunk"))
            throw $util.ProtocolError("missing required 'initial_data_chunk'", { instance: message });
        return message;
    };

    ResourceUpdate.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ResourceUpdate.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.file_name))
            return "file_name: string expected";
        if (!$util.isInteger(message.data_length))
            return "data_length: integer expected";
        if (!(message.initial_data_chunk && typeof message.initial_data_chunk.length === "number" || $util.isString(message.initial_data_chunk)))
            return "initial_data_chunk: buffer expected";
        if (message.hash != null && message.hasOwnProperty("hash"))
            if (!(message.hash && typeof message.hash.length === "number" || $util.isString(message.hash)))
                return "hash: buffer expected";
        return null;
    };

    ResourceUpdate.fromObject = function fromObject(object) {
        if (object instanceof $root.ResourceUpdate)
            return object;
        var message = new $root.ResourceUpdate();
        if (object.file_name != null)
            message.file_name = String(object.file_name);
        if (object.data_length != null)
            message.data_length = object.data_length >>> 0;
        if (object.initial_data_chunk != null)
            if (typeof object.initial_data_chunk === "string")
                $util.base64.decode(object.initial_data_chunk, message.initial_data_chunk = $util.newBuffer($util.base64.length(object.initial_data_chunk)), 0);
            else if (object.initial_data_chunk.length)
                message.initial_data_chunk = object.initial_data_chunk;
        if (object.hash != null)
            if (typeof object.hash === "string")
                $util.base64.decode(object.hash, message.hash = $util.newBuffer($util.base64.length(object.hash)), 0);
            else if (object.hash.length)
                message.hash = object.hash;
        return message;
    };

    ResourceUpdate.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.file_name = "";
            object.data_length = 0;
            if (options.bytes === String)
                object.initial_data_chunk = "";
            else {
                object.initial_data_chunk = [];
                if (options.bytes !== Array)
                    object.initial_data_chunk = $util.newBuffer(object.initial_data_chunk);
            }
            if (options.bytes === String)
                object.hash = "";
            else {
                object.hash = [];
                if (options.bytes !== Array)
                    object.hash = $util.newBuffer(object.hash);
            }
        }
        if (message.file_name != null && message.hasOwnProperty("file_name"))
            object.file_name = message.file_name;
        if (message.data_length != null && message.hasOwnProperty("data_length"))
            object.data_length = message.data_length;
        if (message.initial_data_chunk != null && message.hasOwnProperty("initial_data_chunk"))
            object.initial_data_chunk = options.bytes === String ? $util.base64.encode(message.initial_data_chunk, 0, message.initial_data_chunk.length) : options.bytes === Array ? Array.prototype.slice.call(message.initial_data_chunk) : message.initial_data_chunk;
        if (message.hash != null && message.hasOwnProperty("hash"))
            object.hash = options.bytes === String ? $util.base64.encode(message.hash, 0, message.hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.hash) : message.hash;
        return object;
    };

    ResourceUpdate.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ResourceUpdate;
})();

$root.ListResDir = (function() {

    function ListResDir(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ListResDir.prototype.path = "";

    ListResDir.create = function create(properties) {
        return new ListResDir(properties);
    };

    ListResDir.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.path);
        return writer;
    };

    ListResDir.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ListResDir.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ListResDir();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.path = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("path"))
            throw $util.ProtocolError("missing required 'path'", { instance: message });
        return message;
    };

    ListResDir.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ListResDir.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.path))
            return "path: string expected";
        return null;
    };

    ListResDir.fromObject = function fromObject(object) {
        if (object instanceof $root.ListResDir)
            return object;
        var message = new $root.ListResDir();
        if (object.path != null)
            message.path = String(object.path);
        return message;
    };

    ListResDir.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.path = "";
        if (message.path != null && message.hasOwnProperty("path"))
            object.path = message.path;
        return object;
    };

    ListResDir.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ListResDir;
})();

$root.FileInfoList = (function() {

    function FileInfoList(properties) {
        this.files = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    FileInfoList.prototype.files = $util.emptyArray;

    FileInfoList.create = function create(properties) {
        return new FileInfoList(properties);
    };

    FileInfoList.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.files != null && message.files.length)
            for (var i = 0; i < message.files.length; ++i)
                $root.FileInfoList.FileInfo.encode(message.files[i], writer.uint32(10).fork()).ldelim();
        return writer;
    };

    FileInfoList.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    FileInfoList.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.FileInfoList();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.files && message.files.length))
                    message.files = [];
                message.files.push($root.FileInfoList.FileInfo.decode(reader, reader.uint32()));
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    FileInfoList.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    FileInfoList.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.files != null && message.hasOwnProperty("files")) {
            if (!Array.isArray(message.files))
                return "files: array expected";
            for (var i = 0; i < message.files.length; ++i) {
                var error = $root.FileInfoList.FileInfo.verify(message.files[i]);
                if (error)
                    return "files." + error;
            }
        }
        return null;
    };

    FileInfoList.fromObject = function fromObject(object) {
        if (object instanceof $root.FileInfoList)
            return object;
        var message = new $root.FileInfoList();
        if (object.files) {
            if (!Array.isArray(object.files))
                throw TypeError(".FileInfoList.files: array expected");
            message.files = [];
            for (var i = 0; i < object.files.length; ++i) {
                if (typeof object.files[i] !== "object")
                    throw TypeError(".FileInfoList.files: object expected");
                message.files[i] = $root.FileInfoList.FileInfo.fromObject(object.files[i]);
            }
        }
        return message;
    };

    FileInfoList.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.files = [];
        if (message.files && message.files.length) {
            object.files = [];
            for (var j = 0; j < message.files.length; ++j)
                object.files[j] = $root.FileInfoList.FileInfo.toObject(message.files[j], options);
        }
        return object;
    };

    FileInfoList.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    FileInfoList.FileInfo = (function() {

        function FileInfo(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        FileInfo.prototype.name = "";
        FileInfo.prototype.size = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        FileInfo.create = function create(properties) {
            return new FileInfo(properties);
        };

        FileInfo.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(10).string(message.name);
            writer.uint32(16).uint64(message.size);
            return writer;
        };

        FileInfo.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        FileInfo.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.FileInfoList.FileInfo();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.name = reader.string();
                    break;
                case 2:
                    message.size = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("name"))
                throw $util.ProtocolError("missing required 'name'", { instance: message });
            if (!message.hasOwnProperty("size"))
                throw $util.ProtocolError("missing required 'size'", { instance: message });
            return message;
        };

        FileInfo.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        FileInfo.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isString(message.name))
                return "name: string expected";
            if (!$util.isInteger(message.size) && !(message.size && $util.isInteger(message.size.low) && $util.isInteger(message.size.high)))
                return "size: integer|Long expected";
            return null;
        };

        FileInfo.fromObject = function fromObject(object) {
            if (object instanceof $root.FileInfoList.FileInfo)
                return object;
            var message = new $root.FileInfoList.FileInfo();
            if (object.name != null)
                message.name = String(object.name);
            if (object.size != null)
                if ($util.Long)
                    (message.size = $util.Long.fromValue(object.size)).unsigned = true;
                else if (typeof object.size === "string")
                    message.size = parseInt(object.size, 10);
                else if (typeof object.size === "number")
                    message.size = object.size;
                else if (typeof object.size === "object")
                    message.size = new $util.LongBits(object.size.low >>> 0, object.size.high >>> 0).toNumber(true);
            return message;
        };

        FileInfo.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.name = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.size = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.size = options.longs === String ? "0" : 0;
            }
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.size != null && message.hasOwnProperty("size"))
                if (typeof message.size === "number")
                    object.size = options.longs === String ? String(message.size) : message.size;
                else
                    object.size = options.longs === String ? $util.Long.prototype.toString.call(message.size) : options.longs === Number ? new $util.LongBits(message.size.low >>> 0, message.size.high >>> 0).toNumber(true) : message.size;
            return object;
        };

        FileInfo.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return FileInfo;
    })();

    return FileInfoList;
})();

$root.UnlockPath = (function() {

    function UnlockPath(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    UnlockPath.prototype.address_n = $util.emptyArray;
    UnlockPath.prototype.mac = $util.newBuffer([]);

    UnlockPath.create = function create(properties) {
        return new UnlockPath(properties);
    };

    UnlockPath.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.mac != null && Object.hasOwnProperty.call(message, "mac"))
            writer.uint32(18).bytes(message.mac);
        return writer;
    };

    UnlockPath.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    UnlockPath.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.UnlockPath();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.mac = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    UnlockPath.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    UnlockPath.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.mac != null && message.hasOwnProperty("mac"))
            if (!(message.mac && typeof message.mac.length === "number" || $util.isString(message.mac)))
                return "mac: buffer expected";
        return null;
    };

    UnlockPath.fromObject = function fromObject(object) {
        if (object instanceof $root.UnlockPath)
            return object;
        var message = new $root.UnlockPath();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".UnlockPath.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.mac != null)
            if (typeof object.mac === "string")
                $util.base64.decode(object.mac, message.mac = $util.newBuffer($util.base64.length(object.mac)), 0);
            else if (object.mac.length)
                message.mac = object.mac;
        return message;
    };

    UnlockPath.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            if (options.bytes === String)
                object.mac = "";
            else {
                object.mac = [];
                if (options.bytes !== Array)
                    object.mac = $util.newBuffer(object.mac);
            }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.mac != null && message.hasOwnProperty("mac"))
            object.mac = options.bytes === String ? $util.base64.encode(message.mac, 0, message.mac.length) : options.bytes === Array ? Array.prototype.slice.call(message.mac) : message.mac;
        return object;
    };

    UnlockPath.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return UnlockPath;
})();

$root.UnlockedPathRequest = (function() {

    function UnlockedPathRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    UnlockedPathRequest.prototype.mac = $util.newBuffer([]);

    UnlockedPathRequest.create = function create(properties) {
        return new UnlockedPathRequest(properties);
    };

    UnlockedPathRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.mac != null && Object.hasOwnProperty.call(message, "mac"))
            writer.uint32(10).bytes(message.mac);
        return writer;
    };

    UnlockedPathRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    UnlockedPathRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.UnlockedPathRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.mac = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    UnlockedPathRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    UnlockedPathRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.mac != null && message.hasOwnProperty("mac"))
            if (!(message.mac && typeof message.mac.length === "number" || $util.isString(message.mac)))
                return "mac: buffer expected";
        return null;
    };

    UnlockedPathRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.UnlockedPathRequest)
            return object;
        var message = new $root.UnlockedPathRequest();
        if (object.mac != null)
            if (typeof object.mac === "string")
                $util.base64.decode(object.mac, message.mac = $util.newBuffer($util.base64.length(object.mac)), 0);
            else if (object.mac.length)
                message.mac = object.mac;
        return message;
    };

    UnlockedPathRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.mac = "";
            else {
                object.mac = [];
                if (options.bytes !== Array)
                    object.mac = $util.newBuffer(object.mac);
            }
        if (message.mac != null && message.hasOwnProperty("mac"))
            object.mac = options.bytes === String ? $util.base64.encode(message.mac, 0, message.mac.length) : options.bytes === Array ? Array.prototype.slice.call(message.mac) : message.mac;
        return object;
    };

    UnlockedPathRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return UnlockedPathRequest;
})();

$root.GetPassphraseState = (function() {

    function GetPassphraseState(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    GetPassphraseState.prototype.passphrase_state = "";

    GetPassphraseState.create = function create(properties) {
        return new GetPassphraseState(properties);
    };

    GetPassphraseState.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.passphrase_state != null && Object.hasOwnProperty.call(message, "passphrase_state"))
            writer.uint32(10).string(message.passphrase_state);
        return writer;
    };

    GetPassphraseState.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    GetPassphraseState.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.GetPassphraseState();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.passphrase_state = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    GetPassphraseState.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    GetPassphraseState.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.passphrase_state != null && message.hasOwnProperty("passphrase_state"))
            if (!$util.isString(message.passphrase_state))
                return "passphrase_state: string expected";
        return null;
    };

    GetPassphraseState.fromObject = function fromObject(object) {
        if (object instanceof $root.GetPassphraseState)
            return object;
        var message = new $root.GetPassphraseState();
        if (object.passphrase_state != null)
            message.passphrase_state = String(object.passphrase_state);
        return message;
    };

    GetPassphraseState.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.passphrase_state = "";
        if (message.passphrase_state != null && message.hasOwnProperty("passphrase_state"))
            object.passphrase_state = message.passphrase_state;
        return object;
    };

    GetPassphraseState.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return GetPassphraseState;
})();

$root.PassphraseState = (function() {

    function PassphraseState(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    PassphraseState.prototype.passphrase_state = "";
    PassphraseState.prototype.session_id = $util.newBuffer([]);
    PassphraseState.prototype.unlocked_attach_pin = false;

    PassphraseState.create = function create(properties) {
        return new PassphraseState(properties);
    };

    PassphraseState.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.passphrase_state != null && Object.hasOwnProperty.call(message, "passphrase_state"))
            writer.uint32(10).string(message.passphrase_state);
        if (message.session_id != null && Object.hasOwnProperty.call(message, "session_id"))
            writer.uint32(18).bytes(message.session_id);
        if (message.unlocked_attach_pin != null && Object.hasOwnProperty.call(message, "unlocked_attach_pin"))
            writer.uint32(24).bool(message.unlocked_attach_pin);
        return writer;
    };

    PassphraseState.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    PassphraseState.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.PassphraseState();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.passphrase_state = reader.string();
                break;
            case 2:
                message.session_id = reader.bytes();
                break;
            case 3:
                message.unlocked_attach_pin = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    PassphraseState.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    PassphraseState.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.passphrase_state != null && message.hasOwnProperty("passphrase_state"))
            if (!$util.isString(message.passphrase_state))
                return "passphrase_state: string expected";
        if (message.session_id != null && message.hasOwnProperty("session_id"))
            if (!(message.session_id && typeof message.session_id.length === "number" || $util.isString(message.session_id)))
                return "session_id: buffer expected";
        if (message.unlocked_attach_pin != null && message.hasOwnProperty("unlocked_attach_pin"))
            if (typeof message.unlocked_attach_pin !== "boolean")
                return "unlocked_attach_pin: boolean expected";
        return null;
    };

    PassphraseState.fromObject = function fromObject(object) {
        if (object instanceof $root.PassphraseState)
            return object;
        var message = new $root.PassphraseState();
        if (object.passphrase_state != null)
            message.passphrase_state = String(object.passphrase_state);
        if (object.session_id != null)
            if (typeof object.session_id === "string")
                $util.base64.decode(object.session_id, message.session_id = $util.newBuffer($util.base64.length(object.session_id)), 0);
            else if (object.session_id.length)
                message.session_id = object.session_id;
        if (object.unlocked_attach_pin != null)
            message.unlocked_attach_pin = Boolean(object.unlocked_attach_pin);
        return message;
    };

    PassphraseState.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.passphrase_state = "";
            if (options.bytes === String)
                object.session_id = "";
            else {
                object.session_id = [];
                if (options.bytes !== Array)
                    object.session_id = $util.newBuffer(object.session_id);
            }
            object.unlocked_attach_pin = false;
        }
        if (message.passphrase_state != null && message.hasOwnProperty("passphrase_state"))
            object.passphrase_state = message.passphrase_state;
        if (message.session_id != null && message.hasOwnProperty("session_id"))
            object.session_id = options.bytes === String ? $util.base64.encode(message.session_id, 0, message.session_id.length) : options.bytes === Array ? Array.prototype.slice.call(message.session_id) : message.session_id;
        if (message.unlocked_attach_pin != null && message.hasOwnProperty("unlocked_attach_pin"))
            object.unlocked_attach_pin = message.unlocked_attach_pin;
        return object;
    };

    PassphraseState.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return PassphraseState;
})();

$root.UnLockDevice = (function() {

    function UnLockDevice(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    UnLockDevice.create = function create(properties) {
        return new UnLockDevice(properties);
    };

    UnLockDevice.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    UnLockDevice.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    UnLockDevice.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.UnLockDevice();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    UnLockDevice.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    UnLockDevice.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    UnLockDevice.fromObject = function fromObject(object) {
        if (object instanceof $root.UnLockDevice)
            return object;
        return new $root.UnLockDevice();
    };

    UnLockDevice.toObject = function toObject() {
        return {};
    };

    UnLockDevice.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return UnLockDevice;
})();

$root.UnLockDeviceResponse = (function() {

    function UnLockDeviceResponse(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    UnLockDeviceResponse.prototype.unlocked = false;
    UnLockDeviceResponse.prototype.unlocked_attach_pin = false;
    UnLockDeviceResponse.prototype.passphrase_protection = false;

    UnLockDeviceResponse.create = function create(properties) {
        return new UnLockDeviceResponse(properties);
    };

    UnLockDeviceResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.unlocked != null && Object.hasOwnProperty.call(message, "unlocked"))
            writer.uint32(8).bool(message.unlocked);
        if (message.unlocked_attach_pin != null && Object.hasOwnProperty.call(message, "unlocked_attach_pin"))
            writer.uint32(16).bool(message.unlocked_attach_pin);
        if (message.passphrase_protection != null && Object.hasOwnProperty.call(message, "passphrase_protection"))
            writer.uint32(24).bool(message.passphrase_protection);
        return writer;
    };

    UnLockDeviceResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    UnLockDeviceResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.UnLockDeviceResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.unlocked = reader.bool();
                break;
            case 2:
                message.unlocked_attach_pin = reader.bool();
                break;
            case 3:
                message.passphrase_protection = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    UnLockDeviceResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    UnLockDeviceResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.unlocked != null && message.hasOwnProperty("unlocked"))
            if (typeof message.unlocked !== "boolean")
                return "unlocked: boolean expected";
        if (message.unlocked_attach_pin != null && message.hasOwnProperty("unlocked_attach_pin"))
            if (typeof message.unlocked_attach_pin !== "boolean")
                return "unlocked_attach_pin: boolean expected";
        if (message.passphrase_protection != null && message.hasOwnProperty("passphrase_protection"))
            if (typeof message.passphrase_protection !== "boolean")
                return "passphrase_protection: boolean expected";
        return null;
    };

    UnLockDeviceResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.UnLockDeviceResponse)
            return object;
        var message = new $root.UnLockDeviceResponse();
        if (object.unlocked != null)
            message.unlocked = Boolean(object.unlocked);
        if (object.unlocked_attach_pin != null)
            message.unlocked_attach_pin = Boolean(object.unlocked_attach_pin);
        if (object.passphrase_protection != null)
            message.passphrase_protection = Boolean(object.passphrase_protection);
        return message;
    };

    UnLockDeviceResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.unlocked = false;
            object.unlocked_attach_pin = false;
            object.passphrase_protection = false;
        }
        if (message.unlocked != null && message.hasOwnProperty("unlocked"))
            object.unlocked = message.unlocked;
        if (message.unlocked_attach_pin != null && message.hasOwnProperty("unlocked_attach_pin"))
            object.unlocked_attach_pin = message.unlocked_attach_pin;
        if (message.passphrase_protection != null && message.hasOwnProperty("passphrase_protection"))
            object.passphrase_protection = message.passphrase_protection;
        return object;
    };

    UnLockDeviceResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return UnLockDeviceResponse;
})();

$root.MoneroNetworkType = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "MAINNET"] = 0;
    values[valuesById[1] = "TESTNET"] = 1;
    values[valuesById[2] = "STAGENET"] = 2;
    values[valuesById[3] = "FAKECHAIN"] = 3;
    return values;
})();

$root.MoneroTransactionSourceEntry = (function() {

    function MoneroTransactionSourceEntry(properties) {
        this.outputs = [];
        this.real_out_additional_tx_keys = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroTransactionSourceEntry.prototype.outputs = $util.emptyArray;
    MoneroTransactionSourceEntry.prototype.real_output = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    MoneroTransactionSourceEntry.prototype.real_out_tx_key = $util.newBuffer([]);
    MoneroTransactionSourceEntry.prototype.real_out_additional_tx_keys = $util.emptyArray;
    MoneroTransactionSourceEntry.prototype.real_output_in_tx_index = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    MoneroTransactionSourceEntry.prototype.amount = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    MoneroTransactionSourceEntry.prototype.rct = false;
    MoneroTransactionSourceEntry.prototype.mask = $util.newBuffer([]);
    MoneroTransactionSourceEntry.prototype.multisig_kLRki = null;
    MoneroTransactionSourceEntry.prototype.subaddr_minor = 0;

    MoneroTransactionSourceEntry.create = function create(properties) {
        return new MoneroTransactionSourceEntry(properties);
    };

    MoneroTransactionSourceEntry.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.outputs != null && message.outputs.length)
            for (var i = 0; i < message.outputs.length; ++i)
                $root.MoneroTransactionSourceEntry.MoneroOutputEntry.encode(message.outputs[i], writer.uint32(10).fork()).ldelim();
        if (message.real_output != null && Object.hasOwnProperty.call(message, "real_output"))
            writer.uint32(16).uint64(message.real_output);
        if (message.real_out_tx_key != null && Object.hasOwnProperty.call(message, "real_out_tx_key"))
            writer.uint32(26).bytes(message.real_out_tx_key);
        if (message.real_out_additional_tx_keys != null && message.real_out_additional_tx_keys.length)
            for (var i = 0; i < message.real_out_additional_tx_keys.length; ++i)
                writer.uint32(34).bytes(message.real_out_additional_tx_keys[i]);
        if (message.real_output_in_tx_index != null && Object.hasOwnProperty.call(message, "real_output_in_tx_index"))
            writer.uint32(40).uint64(message.real_output_in_tx_index);
        if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
            writer.uint32(48).uint64(message.amount);
        if (message.rct != null && Object.hasOwnProperty.call(message, "rct"))
            writer.uint32(56).bool(message.rct);
        if (message.mask != null && Object.hasOwnProperty.call(message, "mask"))
            writer.uint32(66).bytes(message.mask);
        if (message.multisig_kLRki != null && Object.hasOwnProperty.call(message, "multisig_kLRki"))
            $root.MoneroTransactionSourceEntry.MoneroMultisigKLRki.encode(message.multisig_kLRki, writer.uint32(74).fork()).ldelim();
        if (message.subaddr_minor != null && Object.hasOwnProperty.call(message, "subaddr_minor"))
            writer.uint32(80).uint32(message.subaddr_minor);
        return writer;
    };

    MoneroTransactionSourceEntry.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroTransactionSourceEntry.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroTransactionSourceEntry();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.outputs && message.outputs.length))
                    message.outputs = [];
                message.outputs.push($root.MoneroTransactionSourceEntry.MoneroOutputEntry.decode(reader, reader.uint32()));
                break;
            case 2:
                message.real_output = reader.uint64();
                break;
            case 3:
                message.real_out_tx_key = reader.bytes();
                break;
            case 4:
                if (!(message.real_out_additional_tx_keys && message.real_out_additional_tx_keys.length))
                    message.real_out_additional_tx_keys = [];
                message.real_out_additional_tx_keys.push(reader.bytes());
                break;
            case 5:
                message.real_output_in_tx_index = reader.uint64();
                break;
            case 6:
                message.amount = reader.uint64();
                break;
            case 7:
                message.rct = reader.bool();
                break;
            case 8:
                message.mask = reader.bytes();
                break;
            case 9:
                message.multisig_kLRki = $root.MoneroTransactionSourceEntry.MoneroMultisigKLRki.decode(reader, reader.uint32());
                break;
            case 10:
                message.subaddr_minor = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroTransactionSourceEntry.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroTransactionSourceEntry.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.outputs != null && message.hasOwnProperty("outputs")) {
            if (!Array.isArray(message.outputs))
                return "outputs: array expected";
            for (var i = 0; i < message.outputs.length; ++i) {
                var error = $root.MoneroTransactionSourceEntry.MoneroOutputEntry.verify(message.outputs[i]);
                if (error)
                    return "outputs." + error;
            }
        }
        if (message.real_output != null && message.hasOwnProperty("real_output"))
            if (!$util.isInteger(message.real_output) && !(message.real_output && $util.isInteger(message.real_output.low) && $util.isInteger(message.real_output.high)))
                return "real_output: integer|Long expected";
        if (message.real_out_tx_key != null && message.hasOwnProperty("real_out_tx_key"))
            if (!(message.real_out_tx_key && typeof message.real_out_tx_key.length === "number" || $util.isString(message.real_out_tx_key)))
                return "real_out_tx_key: buffer expected";
        if (message.real_out_additional_tx_keys != null && message.hasOwnProperty("real_out_additional_tx_keys")) {
            if (!Array.isArray(message.real_out_additional_tx_keys))
                return "real_out_additional_tx_keys: array expected";
            for (var i = 0; i < message.real_out_additional_tx_keys.length; ++i)
                if (!(message.real_out_additional_tx_keys[i] && typeof message.real_out_additional_tx_keys[i].length === "number" || $util.isString(message.real_out_additional_tx_keys[i])))
                    return "real_out_additional_tx_keys: buffer[] expected";
        }
        if (message.real_output_in_tx_index != null && message.hasOwnProperty("real_output_in_tx_index"))
            if (!$util.isInteger(message.real_output_in_tx_index) && !(message.real_output_in_tx_index && $util.isInteger(message.real_output_in_tx_index.low) && $util.isInteger(message.real_output_in_tx_index.high)))
                return "real_output_in_tx_index: integer|Long expected";
        if (message.amount != null && message.hasOwnProperty("amount"))
            if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
                return "amount: integer|Long expected";
        if (message.rct != null && message.hasOwnProperty("rct"))
            if (typeof message.rct !== "boolean")
                return "rct: boolean expected";
        if (message.mask != null && message.hasOwnProperty("mask"))
            if (!(message.mask && typeof message.mask.length === "number" || $util.isString(message.mask)))
                return "mask: buffer expected";
        if (message.multisig_kLRki != null && message.hasOwnProperty("multisig_kLRki")) {
            var error = $root.MoneroTransactionSourceEntry.MoneroMultisigKLRki.verify(message.multisig_kLRki);
            if (error)
                return "multisig_kLRki." + error;
        }
        if (message.subaddr_minor != null && message.hasOwnProperty("subaddr_minor"))
            if (!$util.isInteger(message.subaddr_minor))
                return "subaddr_minor: integer expected";
        return null;
    };

    MoneroTransactionSourceEntry.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroTransactionSourceEntry)
            return object;
        var message = new $root.MoneroTransactionSourceEntry();
        if (object.outputs) {
            if (!Array.isArray(object.outputs))
                throw TypeError(".MoneroTransactionSourceEntry.outputs: array expected");
            message.outputs = [];
            for (var i = 0; i < object.outputs.length; ++i) {
                if (typeof object.outputs[i] !== "object")
                    throw TypeError(".MoneroTransactionSourceEntry.outputs: object expected");
                message.outputs[i] = $root.MoneroTransactionSourceEntry.MoneroOutputEntry.fromObject(object.outputs[i]);
            }
        }
        if (object.real_output != null)
            if ($util.Long)
                (message.real_output = $util.Long.fromValue(object.real_output)).unsigned = true;
            else if (typeof object.real_output === "string")
                message.real_output = parseInt(object.real_output, 10);
            else if (typeof object.real_output === "number")
                message.real_output = object.real_output;
            else if (typeof object.real_output === "object")
                message.real_output = new $util.LongBits(object.real_output.low >>> 0, object.real_output.high >>> 0).toNumber(true);
        if (object.real_out_tx_key != null)
            if (typeof object.real_out_tx_key === "string")
                $util.base64.decode(object.real_out_tx_key, message.real_out_tx_key = $util.newBuffer($util.base64.length(object.real_out_tx_key)), 0);
            else if (object.real_out_tx_key.length)
                message.real_out_tx_key = object.real_out_tx_key;
        if (object.real_out_additional_tx_keys) {
            if (!Array.isArray(object.real_out_additional_tx_keys))
                throw TypeError(".MoneroTransactionSourceEntry.real_out_additional_tx_keys: array expected");
            message.real_out_additional_tx_keys = [];
            for (var i = 0; i < object.real_out_additional_tx_keys.length; ++i)
                if (typeof object.real_out_additional_tx_keys[i] === "string")
                    $util.base64.decode(object.real_out_additional_tx_keys[i], message.real_out_additional_tx_keys[i] = $util.newBuffer($util.base64.length(object.real_out_additional_tx_keys[i])), 0);
                else if (object.real_out_additional_tx_keys[i].length)
                    message.real_out_additional_tx_keys[i] = object.real_out_additional_tx_keys[i];
        }
        if (object.real_output_in_tx_index != null)
            if ($util.Long)
                (message.real_output_in_tx_index = $util.Long.fromValue(object.real_output_in_tx_index)).unsigned = true;
            else if (typeof object.real_output_in_tx_index === "string")
                message.real_output_in_tx_index = parseInt(object.real_output_in_tx_index, 10);
            else if (typeof object.real_output_in_tx_index === "number")
                message.real_output_in_tx_index = object.real_output_in_tx_index;
            else if (typeof object.real_output_in_tx_index === "object")
                message.real_output_in_tx_index = new $util.LongBits(object.real_output_in_tx_index.low >>> 0, object.real_output_in_tx_index.high >>> 0).toNumber(true);
        if (object.amount != null)
            if ($util.Long)
                (message.amount = $util.Long.fromValue(object.amount)).unsigned = true;
            else if (typeof object.amount === "string")
                message.amount = parseInt(object.amount, 10);
            else if (typeof object.amount === "number")
                message.amount = object.amount;
            else if (typeof object.amount === "object")
                message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber(true);
        if (object.rct != null)
            message.rct = Boolean(object.rct);
        if (object.mask != null)
            if (typeof object.mask === "string")
                $util.base64.decode(object.mask, message.mask = $util.newBuffer($util.base64.length(object.mask)), 0);
            else if (object.mask.length)
                message.mask = object.mask;
        if (object.multisig_kLRki != null) {
            if (typeof object.multisig_kLRki !== "object")
                throw TypeError(".MoneroTransactionSourceEntry.multisig_kLRki: object expected");
            message.multisig_kLRki = $root.MoneroTransactionSourceEntry.MoneroMultisigKLRki.fromObject(object.multisig_kLRki);
        }
        if (object.subaddr_minor != null)
            message.subaddr_minor = object.subaddr_minor >>> 0;
        return message;
    };

    MoneroTransactionSourceEntry.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults) {
            object.outputs = [];
            object.real_out_additional_tx_keys = [];
        }
        if (options.defaults) {
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.real_output = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.real_output = options.longs === String ? "0" : 0;
            if (options.bytes === String)
                object.real_out_tx_key = "";
            else {
                object.real_out_tx_key = [];
                if (options.bytes !== Array)
                    object.real_out_tx_key = $util.newBuffer(object.real_out_tx_key);
            }
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.real_output_in_tx_index = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.real_output_in_tx_index = options.longs === String ? "0" : 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.amount = options.longs === String ? "0" : 0;
            object.rct = false;
            if (options.bytes === String)
                object.mask = "";
            else {
                object.mask = [];
                if (options.bytes !== Array)
                    object.mask = $util.newBuffer(object.mask);
            }
            object.multisig_kLRki = null;
            object.subaddr_minor = 0;
        }
        if (message.outputs && message.outputs.length) {
            object.outputs = [];
            for (var j = 0; j < message.outputs.length; ++j)
                object.outputs[j] = $root.MoneroTransactionSourceEntry.MoneroOutputEntry.toObject(message.outputs[j], options);
        }
        if (message.real_output != null && message.hasOwnProperty("real_output"))
            if (typeof message.real_output === "number")
                object.real_output = options.longs === String ? String(message.real_output) : message.real_output;
            else
                object.real_output = options.longs === String ? $util.Long.prototype.toString.call(message.real_output) : options.longs === Number ? new $util.LongBits(message.real_output.low >>> 0, message.real_output.high >>> 0).toNumber(true) : message.real_output;
        if (message.real_out_tx_key != null && message.hasOwnProperty("real_out_tx_key"))
            object.real_out_tx_key = options.bytes === String ? $util.base64.encode(message.real_out_tx_key, 0, message.real_out_tx_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.real_out_tx_key) : message.real_out_tx_key;
        if (message.real_out_additional_tx_keys && message.real_out_additional_tx_keys.length) {
            object.real_out_additional_tx_keys = [];
            for (var j = 0; j < message.real_out_additional_tx_keys.length; ++j)
                object.real_out_additional_tx_keys[j] = options.bytes === String ? $util.base64.encode(message.real_out_additional_tx_keys[j], 0, message.real_out_additional_tx_keys[j].length) : options.bytes === Array ? Array.prototype.slice.call(message.real_out_additional_tx_keys[j]) : message.real_out_additional_tx_keys[j];
        }
        if (message.real_output_in_tx_index != null && message.hasOwnProperty("real_output_in_tx_index"))
            if (typeof message.real_output_in_tx_index === "number")
                object.real_output_in_tx_index = options.longs === String ? String(message.real_output_in_tx_index) : message.real_output_in_tx_index;
            else
                object.real_output_in_tx_index = options.longs === String ? $util.Long.prototype.toString.call(message.real_output_in_tx_index) : options.longs === Number ? new $util.LongBits(message.real_output_in_tx_index.low >>> 0, message.real_output_in_tx_index.high >>> 0).toNumber(true) : message.real_output_in_tx_index;
        if (message.amount != null && message.hasOwnProperty("amount"))
            if (typeof message.amount === "number")
                object.amount = options.longs === String ? String(message.amount) : message.amount;
            else
                object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber(true) : message.amount;
        if (message.rct != null && message.hasOwnProperty("rct"))
            object.rct = message.rct;
        if (message.mask != null && message.hasOwnProperty("mask"))
            object.mask = options.bytes === String ? $util.base64.encode(message.mask, 0, message.mask.length) : options.bytes === Array ? Array.prototype.slice.call(message.mask) : message.mask;
        if (message.multisig_kLRki != null && message.hasOwnProperty("multisig_kLRki"))
            object.multisig_kLRki = $root.MoneroTransactionSourceEntry.MoneroMultisigKLRki.toObject(message.multisig_kLRki, options);
        if (message.subaddr_minor != null && message.hasOwnProperty("subaddr_minor"))
            object.subaddr_minor = message.subaddr_minor;
        return object;
    };

    MoneroTransactionSourceEntry.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    MoneroTransactionSourceEntry.MoneroOutputEntry = (function() {

        function MoneroOutputEntry(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        MoneroOutputEntry.prototype.idx = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        MoneroOutputEntry.prototype.key = null;

        MoneroOutputEntry.create = function create(properties) {
            return new MoneroOutputEntry(properties);
        };

        MoneroOutputEntry.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.idx != null && Object.hasOwnProperty.call(message, "idx"))
                writer.uint32(8).uint64(message.idx);
            if (message.key != null && Object.hasOwnProperty.call(message, "key"))
                $root.MoneroTransactionSourceEntry.MoneroOutputEntry.MoneroRctKeyPublic.encode(message.key, writer.uint32(18).fork()).ldelim();
            return writer;
        };

        MoneroOutputEntry.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        MoneroOutputEntry.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroTransactionSourceEntry.MoneroOutputEntry();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.idx = reader.uint64();
                    break;
                case 2:
                    message.key = $root.MoneroTransactionSourceEntry.MoneroOutputEntry.MoneroRctKeyPublic.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        MoneroOutputEntry.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        MoneroOutputEntry.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.idx != null && message.hasOwnProperty("idx"))
                if (!$util.isInteger(message.idx) && !(message.idx && $util.isInteger(message.idx.low) && $util.isInteger(message.idx.high)))
                    return "idx: integer|Long expected";
            if (message.key != null && message.hasOwnProperty("key")) {
                var error = $root.MoneroTransactionSourceEntry.MoneroOutputEntry.MoneroRctKeyPublic.verify(message.key);
                if (error)
                    return "key." + error;
            }
            return null;
        };

        MoneroOutputEntry.fromObject = function fromObject(object) {
            if (object instanceof $root.MoneroTransactionSourceEntry.MoneroOutputEntry)
                return object;
            var message = new $root.MoneroTransactionSourceEntry.MoneroOutputEntry();
            if (object.idx != null)
                if ($util.Long)
                    (message.idx = $util.Long.fromValue(object.idx)).unsigned = true;
                else if (typeof object.idx === "string")
                    message.idx = parseInt(object.idx, 10);
                else if (typeof object.idx === "number")
                    message.idx = object.idx;
                else if (typeof object.idx === "object")
                    message.idx = new $util.LongBits(object.idx.low >>> 0, object.idx.high >>> 0).toNumber(true);
            if (object.key != null) {
                if (typeof object.key !== "object")
                    throw TypeError(".MoneroTransactionSourceEntry.MoneroOutputEntry.key: object expected");
                message.key = $root.MoneroTransactionSourceEntry.MoneroOutputEntry.MoneroRctKeyPublic.fromObject(object.key);
            }
            return message;
        };

        MoneroOutputEntry.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.idx = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.idx = options.longs === String ? "0" : 0;
                object.key = null;
            }
            if (message.idx != null && message.hasOwnProperty("idx"))
                if (typeof message.idx === "number")
                    object.idx = options.longs === String ? String(message.idx) : message.idx;
                else
                    object.idx = options.longs === String ? $util.Long.prototype.toString.call(message.idx) : options.longs === Number ? new $util.LongBits(message.idx.low >>> 0, message.idx.high >>> 0).toNumber(true) : message.idx;
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = $root.MoneroTransactionSourceEntry.MoneroOutputEntry.MoneroRctKeyPublic.toObject(message.key, options);
            return object;
        };

        MoneroOutputEntry.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        MoneroOutputEntry.MoneroRctKeyPublic = (function() {

            function MoneroRctKeyPublic(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            MoneroRctKeyPublic.prototype.dest = $util.newBuffer([]);
            MoneroRctKeyPublic.prototype.commitment = $util.newBuffer([]);

            MoneroRctKeyPublic.create = function create(properties) {
                return new MoneroRctKeyPublic(properties);
            };

            MoneroRctKeyPublic.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                writer.uint32(10).bytes(message.dest);
                writer.uint32(18).bytes(message.commitment);
                return writer;
            };

            MoneroRctKeyPublic.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            MoneroRctKeyPublic.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroTransactionSourceEntry.MoneroOutputEntry.MoneroRctKeyPublic();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.dest = reader.bytes();
                        break;
                    case 2:
                        message.commitment = reader.bytes();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                if (!message.hasOwnProperty("dest"))
                    throw $util.ProtocolError("missing required 'dest'", { instance: message });
                if (!message.hasOwnProperty("commitment"))
                    throw $util.ProtocolError("missing required 'commitment'", { instance: message });
                return message;
            };

            MoneroRctKeyPublic.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            MoneroRctKeyPublic.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (!(message.dest && typeof message.dest.length === "number" || $util.isString(message.dest)))
                    return "dest: buffer expected";
                if (!(message.commitment && typeof message.commitment.length === "number" || $util.isString(message.commitment)))
                    return "commitment: buffer expected";
                return null;
            };

            MoneroRctKeyPublic.fromObject = function fromObject(object) {
                if (object instanceof $root.MoneroTransactionSourceEntry.MoneroOutputEntry.MoneroRctKeyPublic)
                    return object;
                var message = new $root.MoneroTransactionSourceEntry.MoneroOutputEntry.MoneroRctKeyPublic();
                if (object.dest != null)
                    if (typeof object.dest === "string")
                        $util.base64.decode(object.dest, message.dest = $util.newBuffer($util.base64.length(object.dest)), 0);
                    else if (object.dest.length)
                        message.dest = object.dest;
                if (object.commitment != null)
                    if (typeof object.commitment === "string")
                        $util.base64.decode(object.commitment, message.commitment = $util.newBuffer($util.base64.length(object.commitment)), 0);
                    else if (object.commitment.length)
                        message.commitment = object.commitment;
                return message;
            };

            MoneroRctKeyPublic.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    if (options.bytes === String)
                        object.dest = "";
                    else {
                        object.dest = [];
                        if (options.bytes !== Array)
                            object.dest = $util.newBuffer(object.dest);
                    }
                    if (options.bytes === String)
                        object.commitment = "";
                    else {
                        object.commitment = [];
                        if (options.bytes !== Array)
                            object.commitment = $util.newBuffer(object.commitment);
                    }
                }
                if (message.dest != null && message.hasOwnProperty("dest"))
                    object.dest = options.bytes === String ? $util.base64.encode(message.dest, 0, message.dest.length) : options.bytes === Array ? Array.prototype.slice.call(message.dest) : message.dest;
                if (message.commitment != null && message.hasOwnProperty("commitment"))
                    object.commitment = options.bytes === String ? $util.base64.encode(message.commitment, 0, message.commitment.length) : options.bytes === Array ? Array.prototype.slice.call(message.commitment) : message.commitment;
                return object;
            };

            MoneroRctKeyPublic.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return MoneroRctKeyPublic;
        })();

        return MoneroOutputEntry;
    })();

    MoneroTransactionSourceEntry.MoneroMultisigKLRki = (function() {

        function MoneroMultisigKLRki(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        MoneroMultisigKLRki.prototype.K = $util.newBuffer([]);
        MoneroMultisigKLRki.prototype.L = $util.newBuffer([]);
        MoneroMultisigKLRki.prototype.R = $util.newBuffer([]);
        MoneroMultisigKLRki.prototype.ki = $util.newBuffer([]);

        MoneroMultisigKLRki.create = function create(properties) {
            return new MoneroMultisigKLRki(properties);
        };

        MoneroMultisigKLRki.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.K != null && Object.hasOwnProperty.call(message, "K"))
                writer.uint32(10).bytes(message.K);
            if (message.L != null && Object.hasOwnProperty.call(message, "L"))
                writer.uint32(18).bytes(message.L);
            if (message.R != null && Object.hasOwnProperty.call(message, "R"))
                writer.uint32(26).bytes(message.R);
            if (message.ki != null && Object.hasOwnProperty.call(message, "ki"))
                writer.uint32(34).bytes(message.ki);
            return writer;
        };

        MoneroMultisigKLRki.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        MoneroMultisigKLRki.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroTransactionSourceEntry.MoneroMultisigKLRki();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.K = reader.bytes();
                    break;
                case 2:
                    message.L = reader.bytes();
                    break;
                case 3:
                    message.R = reader.bytes();
                    break;
                case 4:
                    message.ki = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        MoneroMultisigKLRki.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        MoneroMultisigKLRki.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.K != null && message.hasOwnProperty("K"))
                if (!(message.K && typeof message.K.length === "number" || $util.isString(message.K)))
                    return "K: buffer expected";
            if (message.L != null && message.hasOwnProperty("L"))
                if (!(message.L && typeof message.L.length === "number" || $util.isString(message.L)))
                    return "L: buffer expected";
            if (message.R != null && message.hasOwnProperty("R"))
                if (!(message.R && typeof message.R.length === "number" || $util.isString(message.R)))
                    return "R: buffer expected";
            if (message.ki != null && message.hasOwnProperty("ki"))
                if (!(message.ki && typeof message.ki.length === "number" || $util.isString(message.ki)))
                    return "ki: buffer expected";
            return null;
        };

        MoneroMultisigKLRki.fromObject = function fromObject(object) {
            if (object instanceof $root.MoneroTransactionSourceEntry.MoneroMultisigKLRki)
                return object;
            var message = new $root.MoneroTransactionSourceEntry.MoneroMultisigKLRki();
            if (object.K != null)
                if (typeof object.K === "string")
                    $util.base64.decode(object.K, message.K = $util.newBuffer($util.base64.length(object.K)), 0);
                else if (object.K.length)
                    message.K = object.K;
            if (object.L != null)
                if (typeof object.L === "string")
                    $util.base64.decode(object.L, message.L = $util.newBuffer($util.base64.length(object.L)), 0);
                else if (object.L.length)
                    message.L = object.L;
            if (object.R != null)
                if (typeof object.R === "string")
                    $util.base64.decode(object.R, message.R = $util.newBuffer($util.base64.length(object.R)), 0);
                else if (object.R.length)
                    message.R = object.R;
            if (object.ki != null)
                if (typeof object.ki === "string")
                    $util.base64.decode(object.ki, message.ki = $util.newBuffer($util.base64.length(object.ki)), 0);
                else if (object.ki.length)
                    message.ki = object.ki;
            return message;
        };

        MoneroMultisigKLRki.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if (options.bytes === String)
                    object.K = "";
                else {
                    object.K = [];
                    if (options.bytes !== Array)
                        object.K = $util.newBuffer(object.K);
                }
                if (options.bytes === String)
                    object.L = "";
                else {
                    object.L = [];
                    if (options.bytes !== Array)
                        object.L = $util.newBuffer(object.L);
                }
                if (options.bytes === String)
                    object.R = "";
                else {
                    object.R = [];
                    if (options.bytes !== Array)
                        object.R = $util.newBuffer(object.R);
                }
                if (options.bytes === String)
                    object.ki = "";
                else {
                    object.ki = [];
                    if (options.bytes !== Array)
                        object.ki = $util.newBuffer(object.ki);
                }
            }
            if (message.K != null && message.hasOwnProperty("K"))
                object.K = options.bytes === String ? $util.base64.encode(message.K, 0, message.K.length) : options.bytes === Array ? Array.prototype.slice.call(message.K) : message.K;
            if (message.L != null && message.hasOwnProperty("L"))
                object.L = options.bytes === String ? $util.base64.encode(message.L, 0, message.L.length) : options.bytes === Array ? Array.prototype.slice.call(message.L) : message.L;
            if (message.R != null && message.hasOwnProperty("R"))
                object.R = options.bytes === String ? $util.base64.encode(message.R, 0, message.R.length) : options.bytes === Array ? Array.prototype.slice.call(message.R) : message.R;
            if (message.ki != null && message.hasOwnProperty("ki"))
                object.ki = options.bytes === String ? $util.base64.encode(message.ki, 0, message.ki.length) : options.bytes === Array ? Array.prototype.slice.call(message.ki) : message.ki;
            return object;
        };

        MoneroMultisigKLRki.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return MoneroMultisigKLRki;
    })();

    return MoneroTransactionSourceEntry;
})();

$root.MoneroTransactionDestinationEntry = (function() {

    function MoneroTransactionDestinationEntry(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroTransactionDestinationEntry.prototype.amount = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    MoneroTransactionDestinationEntry.prototype.addr = null;
    MoneroTransactionDestinationEntry.prototype.is_subaddress = false;
    MoneroTransactionDestinationEntry.prototype.original = $util.newBuffer([]);
    MoneroTransactionDestinationEntry.prototype.is_integrated = false;

    MoneroTransactionDestinationEntry.create = function create(properties) {
        return new MoneroTransactionDestinationEntry(properties);
    };

    MoneroTransactionDestinationEntry.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
            writer.uint32(8).uint64(message.amount);
        if (message.addr != null && Object.hasOwnProperty.call(message, "addr"))
            $root.MoneroTransactionDestinationEntry.MoneroAccountPublicAddress.encode(message.addr, writer.uint32(18).fork()).ldelim();
        if (message.is_subaddress != null && Object.hasOwnProperty.call(message, "is_subaddress"))
            writer.uint32(24).bool(message.is_subaddress);
        if (message.original != null && Object.hasOwnProperty.call(message, "original"))
            writer.uint32(34).bytes(message.original);
        if (message.is_integrated != null && Object.hasOwnProperty.call(message, "is_integrated"))
            writer.uint32(40).bool(message.is_integrated);
        return writer;
    };

    MoneroTransactionDestinationEntry.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroTransactionDestinationEntry.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroTransactionDestinationEntry();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.amount = reader.uint64();
                break;
            case 2:
                message.addr = $root.MoneroTransactionDestinationEntry.MoneroAccountPublicAddress.decode(reader, reader.uint32());
                break;
            case 3:
                message.is_subaddress = reader.bool();
                break;
            case 4:
                message.original = reader.bytes();
                break;
            case 5:
                message.is_integrated = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroTransactionDestinationEntry.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroTransactionDestinationEntry.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.amount != null && message.hasOwnProperty("amount"))
            if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
                return "amount: integer|Long expected";
        if (message.addr != null && message.hasOwnProperty("addr")) {
            var error = $root.MoneroTransactionDestinationEntry.MoneroAccountPublicAddress.verify(message.addr);
            if (error)
                return "addr." + error;
        }
        if (message.is_subaddress != null && message.hasOwnProperty("is_subaddress"))
            if (typeof message.is_subaddress !== "boolean")
                return "is_subaddress: boolean expected";
        if (message.original != null && message.hasOwnProperty("original"))
            if (!(message.original && typeof message.original.length === "number" || $util.isString(message.original)))
                return "original: buffer expected";
        if (message.is_integrated != null && message.hasOwnProperty("is_integrated"))
            if (typeof message.is_integrated !== "boolean")
                return "is_integrated: boolean expected";
        return null;
    };

    MoneroTransactionDestinationEntry.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroTransactionDestinationEntry)
            return object;
        var message = new $root.MoneroTransactionDestinationEntry();
        if (object.amount != null)
            if ($util.Long)
                (message.amount = $util.Long.fromValue(object.amount)).unsigned = true;
            else if (typeof object.amount === "string")
                message.amount = parseInt(object.amount, 10);
            else if (typeof object.amount === "number")
                message.amount = object.amount;
            else if (typeof object.amount === "object")
                message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber(true);
        if (object.addr != null) {
            if (typeof object.addr !== "object")
                throw TypeError(".MoneroTransactionDestinationEntry.addr: object expected");
            message.addr = $root.MoneroTransactionDestinationEntry.MoneroAccountPublicAddress.fromObject(object.addr);
        }
        if (object.is_subaddress != null)
            message.is_subaddress = Boolean(object.is_subaddress);
        if (object.original != null)
            if (typeof object.original === "string")
                $util.base64.decode(object.original, message.original = $util.newBuffer($util.base64.length(object.original)), 0);
            else if (object.original.length)
                message.original = object.original;
        if (object.is_integrated != null)
            message.is_integrated = Boolean(object.is_integrated);
        return message;
    };

    MoneroTransactionDestinationEntry.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.amount = options.longs === String ? "0" : 0;
            object.addr = null;
            object.is_subaddress = false;
            if (options.bytes === String)
                object.original = "";
            else {
                object.original = [];
                if (options.bytes !== Array)
                    object.original = $util.newBuffer(object.original);
            }
            object.is_integrated = false;
        }
        if (message.amount != null && message.hasOwnProperty("amount"))
            if (typeof message.amount === "number")
                object.amount = options.longs === String ? String(message.amount) : message.amount;
            else
                object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber(true) : message.amount;
        if (message.addr != null && message.hasOwnProperty("addr"))
            object.addr = $root.MoneroTransactionDestinationEntry.MoneroAccountPublicAddress.toObject(message.addr, options);
        if (message.is_subaddress != null && message.hasOwnProperty("is_subaddress"))
            object.is_subaddress = message.is_subaddress;
        if (message.original != null && message.hasOwnProperty("original"))
            object.original = options.bytes === String ? $util.base64.encode(message.original, 0, message.original.length) : options.bytes === Array ? Array.prototype.slice.call(message.original) : message.original;
        if (message.is_integrated != null && message.hasOwnProperty("is_integrated"))
            object.is_integrated = message.is_integrated;
        return object;
    };

    MoneroTransactionDestinationEntry.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    MoneroTransactionDestinationEntry.MoneroAccountPublicAddress = (function() {

        function MoneroAccountPublicAddress(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        MoneroAccountPublicAddress.prototype.spend_public_key = $util.newBuffer([]);
        MoneroAccountPublicAddress.prototype.view_public_key = $util.newBuffer([]);

        MoneroAccountPublicAddress.create = function create(properties) {
            return new MoneroAccountPublicAddress(properties);
        };

        MoneroAccountPublicAddress.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.spend_public_key != null && Object.hasOwnProperty.call(message, "spend_public_key"))
                writer.uint32(10).bytes(message.spend_public_key);
            if (message.view_public_key != null && Object.hasOwnProperty.call(message, "view_public_key"))
                writer.uint32(18).bytes(message.view_public_key);
            return writer;
        };

        MoneroAccountPublicAddress.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        MoneroAccountPublicAddress.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroTransactionDestinationEntry.MoneroAccountPublicAddress();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.spend_public_key = reader.bytes();
                    break;
                case 2:
                    message.view_public_key = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        MoneroAccountPublicAddress.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        MoneroAccountPublicAddress.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.spend_public_key != null && message.hasOwnProperty("spend_public_key"))
                if (!(message.spend_public_key && typeof message.spend_public_key.length === "number" || $util.isString(message.spend_public_key)))
                    return "spend_public_key: buffer expected";
            if (message.view_public_key != null && message.hasOwnProperty("view_public_key"))
                if (!(message.view_public_key && typeof message.view_public_key.length === "number" || $util.isString(message.view_public_key)))
                    return "view_public_key: buffer expected";
            return null;
        };

        MoneroAccountPublicAddress.fromObject = function fromObject(object) {
            if (object instanceof $root.MoneroTransactionDestinationEntry.MoneroAccountPublicAddress)
                return object;
            var message = new $root.MoneroTransactionDestinationEntry.MoneroAccountPublicAddress();
            if (object.spend_public_key != null)
                if (typeof object.spend_public_key === "string")
                    $util.base64.decode(object.spend_public_key, message.spend_public_key = $util.newBuffer($util.base64.length(object.spend_public_key)), 0);
                else if (object.spend_public_key.length)
                    message.spend_public_key = object.spend_public_key;
            if (object.view_public_key != null)
                if (typeof object.view_public_key === "string")
                    $util.base64.decode(object.view_public_key, message.view_public_key = $util.newBuffer($util.base64.length(object.view_public_key)), 0);
                else if (object.view_public_key.length)
                    message.view_public_key = object.view_public_key;
            return message;
        };

        MoneroAccountPublicAddress.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if (options.bytes === String)
                    object.spend_public_key = "";
                else {
                    object.spend_public_key = [];
                    if (options.bytes !== Array)
                        object.spend_public_key = $util.newBuffer(object.spend_public_key);
                }
                if (options.bytes === String)
                    object.view_public_key = "";
                else {
                    object.view_public_key = [];
                    if (options.bytes !== Array)
                        object.view_public_key = $util.newBuffer(object.view_public_key);
                }
            }
            if (message.spend_public_key != null && message.hasOwnProperty("spend_public_key"))
                object.spend_public_key = options.bytes === String ? $util.base64.encode(message.spend_public_key, 0, message.spend_public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.spend_public_key) : message.spend_public_key;
            if (message.view_public_key != null && message.hasOwnProperty("view_public_key"))
                object.view_public_key = options.bytes === String ? $util.base64.encode(message.view_public_key, 0, message.view_public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.view_public_key) : message.view_public_key;
            return object;
        };

        MoneroAccountPublicAddress.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return MoneroAccountPublicAddress;
    })();

    return MoneroTransactionDestinationEntry;
})();

$root.MoneroTransactionRsigData = (function() {

    function MoneroTransactionRsigData(properties) {
        this.grouping = [];
        this.rsig_parts = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroTransactionRsigData.prototype.rsig_type = 0;
    MoneroTransactionRsigData.prototype.offload_type = 0;
    MoneroTransactionRsigData.prototype.grouping = $util.emptyArray;
    MoneroTransactionRsigData.prototype.mask = $util.newBuffer([]);
    MoneroTransactionRsigData.prototype.rsig = $util.newBuffer([]);
    MoneroTransactionRsigData.prototype.rsig_parts = $util.emptyArray;
    MoneroTransactionRsigData.prototype.bp_version = 0;

    MoneroTransactionRsigData.create = function create(properties) {
        return new MoneroTransactionRsigData(properties);
    };

    MoneroTransactionRsigData.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.rsig_type != null && Object.hasOwnProperty.call(message, "rsig_type"))
            writer.uint32(8).uint32(message.rsig_type);
        if (message.offload_type != null && Object.hasOwnProperty.call(message, "offload_type"))
            writer.uint32(16).uint32(message.offload_type);
        if (message.grouping != null && message.grouping.length)
            for (var i = 0; i < message.grouping.length; ++i)
                writer.uint32(24).uint64(message.grouping[i]);
        if (message.mask != null && Object.hasOwnProperty.call(message, "mask"))
            writer.uint32(34).bytes(message.mask);
        if (message.rsig != null && Object.hasOwnProperty.call(message, "rsig"))
            writer.uint32(42).bytes(message.rsig);
        if (message.rsig_parts != null && message.rsig_parts.length)
            for (var i = 0; i < message.rsig_parts.length; ++i)
                writer.uint32(50).bytes(message.rsig_parts[i]);
        if (message.bp_version != null && Object.hasOwnProperty.call(message, "bp_version"))
            writer.uint32(56).uint32(message.bp_version);
        return writer;
    };

    MoneroTransactionRsigData.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroTransactionRsigData.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroTransactionRsigData();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.rsig_type = reader.uint32();
                break;
            case 2:
                message.offload_type = reader.uint32();
                break;
            case 3:
                if (!(message.grouping && message.grouping.length))
                    message.grouping = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.grouping.push(reader.uint64());
                } else
                    message.grouping.push(reader.uint64());
                break;
            case 4:
                message.mask = reader.bytes();
                break;
            case 5:
                message.rsig = reader.bytes();
                break;
            case 6:
                if (!(message.rsig_parts && message.rsig_parts.length))
                    message.rsig_parts = [];
                message.rsig_parts.push(reader.bytes());
                break;
            case 7:
                message.bp_version = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroTransactionRsigData.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroTransactionRsigData.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.rsig_type != null && message.hasOwnProperty("rsig_type"))
            if (!$util.isInteger(message.rsig_type))
                return "rsig_type: integer expected";
        if (message.offload_type != null && message.hasOwnProperty("offload_type"))
            if (!$util.isInteger(message.offload_type))
                return "offload_type: integer expected";
        if (message.grouping != null && message.hasOwnProperty("grouping")) {
            if (!Array.isArray(message.grouping))
                return "grouping: array expected";
            for (var i = 0; i < message.grouping.length; ++i)
                if (!$util.isInteger(message.grouping[i]) && !(message.grouping[i] && $util.isInteger(message.grouping[i].low) && $util.isInteger(message.grouping[i].high)))
                    return "grouping: integer|Long[] expected";
        }
        if (message.mask != null && message.hasOwnProperty("mask"))
            if (!(message.mask && typeof message.mask.length === "number" || $util.isString(message.mask)))
                return "mask: buffer expected";
        if (message.rsig != null && message.hasOwnProperty("rsig"))
            if (!(message.rsig && typeof message.rsig.length === "number" || $util.isString(message.rsig)))
                return "rsig: buffer expected";
        if (message.rsig_parts != null && message.hasOwnProperty("rsig_parts")) {
            if (!Array.isArray(message.rsig_parts))
                return "rsig_parts: array expected";
            for (var i = 0; i < message.rsig_parts.length; ++i)
                if (!(message.rsig_parts[i] && typeof message.rsig_parts[i].length === "number" || $util.isString(message.rsig_parts[i])))
                    return "rsig_parts: buffer[] expected";
        }
        if (message.bp_version != null && message.hasOwnProperty("bp_version"))
            if (!$util.isInteger(message.bp_version))
                return "bp_version: integer expected";
        return null;
    };

    MoneroTransactionRsigData.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroTransactionRsigData)
            return object;
        var message = new $root.MoneroTransactionRsigData();
        if (object.rsig_type != null)
            message.rsig_type = object.rsig_type >>> 0;
        if (object.offload_type != null)
            message.offload_type = object.offload_type >>> 0;
        if (object.grouping) {
            if (!Array.isArray(object.grouping))
                throw TypeError(".MoneroTransactionRsigData.grouping: array expected");
            message.grouping = [];
            for (var i = 0; i < object.grouping.length; ++i)
                if ($util.Long)
                    (message.grouping[i] = $util.Long.fromValue(object.grouping[i])).unsigned = true;
                else if (typeof object.grouping[i] === "string")
                    message.grouping[i] = parseInt(object.grouping[i], 10);
                else if (typeof object.grouping[i] === "number")
                    message.grouping[i] = object.grouping[i];
                else if (typeof object.grouping[i] === "object")
                    message.grouping[i] = new $util.LongBits(object.grouping[i].low >>> 0, object.grouping[i].high >>> 0).toNumber(true);
        }
        if (object.mask != null)
            if (typeof object.mask === "string")
                $util.base64.decode(object.mask, message.mask = $util.newBuffer($util.base64.length(object.mask)), 0);
            else if (object.mask.length)
                message.mask = object.mask;
        if (object.rsig != null)
            if (typeof object.rsig === "string")
                $util.base64.decode(object.rsig, message.rsig = $util.newBuffer($util.base64.length(object.rsig)), 0);
            else if (object.rsig.length)
                message.rsig = object.rsig;
        if (object.rsig_parts) {
            if (!Array.isArray(object.rsig_parts))
                throw TypeError(".MoneroTransactionRsigData.rsig_parts: array expected");
            message.rsig_parts = [];
            for (var i = 0; i < object.rsig_parts.length; ++i)
                if (typeof object.rsig_parts[i] === "string")
                    $util.base64.decode(object.rsig_parts[i], message.rsig_parts[i] = $util.newBuffer($util.base64.length(object.rsig_parts[i])), 0);
                else if (object.rsig_parts[i].length)
                    message.rsig_parts[i] = object.rsig_parts[i];
        }
        if (object.bp_version != null)
            message.bp_version = object.bp_version >>> 0;
        return message;
    };

    MoneroTransactionRsigData.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults) {
            object.grouping = [];
            object.rsig_parts = [];
        }
        if (options.defaults) {
            object.rsig_type = 0;
            object.offload_type = 0;
            if (options.bytes === String)
                object.mask = "";
            else {
                object.mask = [];
                if (options.bytes !== Array)
                    object.mask = $util.newBuffer(object.mask);
            }
            if (options.bytes === String)
                object.rsig = "";
            else {
                object.rsig = [];
                if (options.bytes !== Array)
                    object.rsig = $util.newBuffer(object.rsig);
            }
            object.bp_version = 0;
        }
        if (message.rsig_type != null && message.hasOwnProperty("rsig_type"))
            object.rsig_type = message.rsig_type;
        if (message.offload_type != null && message.hasOwnProperty("offload_type"))
            object.offload_type = message.offload_type;
        if (message.grouping && message.grouping.length) {
            object.grouping = [];
            for (var j = 0; j < message.grouping.length; ++j)
                if (typeof message.grouping[j] === "number")
                    object.grouping[j] = options.longs === String ? String(message.grouping[j]) : message.grouping[j];
                else
                    object.grouping[j] = options.longs === String ? $util.Long.prototype.toString.call(message.grouping[j]) : options.longs === Number ? new $util.LongBits(message.grouping[j].low >>> 0, message.grouping[j].high >>> 0).toNumber(true) : message.grouping[j];
        }
        if (message.mask != null && message.hasOwnProperty("mask"))
            object.mask = options.bytes === String ? $util.base64.encode(message.mask, 0, message.mask.length) : options.bytes === Array ? Array.prototype.slice.call(message.mask) : message.mask;
        if (message.rsig != null && message.hasOwnProperty("rsig"))
            object.rsig = options.bytes === String ? $util.base64.encode(message.rsig, 0, message.rsig.length) : options.bytes === Array ? Array.prototype.slice.call(message.rsig) : message.rsig;
        if (message.rsig_parts && message.rsig_parts.length) {
            object.rsig_parts = [];
            for (var j = 0; j < message.rsig_parts.length; ++j)
                object.rsig_parts[j] = options.bytes === String ? $util.base64.encode(message.rsig_parts[j], 0, message.rsig_parts[j].length) : options.bytes === Array ? Array.prototype.slice.call(message.rsig_parts[j]) : message.rsig_parts[j];
        }
        if (message.bp_version != null && message.hasOwnProperty("bp_version"))
            object.bp_version = message.bp_version;
        return object;
    };

    MoneroTransactionRsigData.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoneroTransactionRsigData;
})();

$root.MoneroGetAddress = (function() {

    function MoneroGetAddress(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroGetAddress.prototype.address_n = $util.emptyArray;
    MoneroGetAddress.prototype.show_display = false;
    MoneroGetAddress.prototype.network_type = 0;
    MoneroGetAddress.prototype.account = 0;
    MoneroGetAddress.prototype.minor = 0;
    MoneroGetAddress.prototype.payment_id = $util.newBuffer([]);

    MoneroGetAddress.create = function create(properties) {
        return new MoneroGetAddress(properties);
    };

    MoneroGetAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(16).bool(message.show_display);
        if (message.network_type != null && Object.hasOwnProperty.call(message, "network_type"))
            writer.uint32(24).int32(message.network_type);
        if (message.account != null && Object.hasOwnProperty.call(message, "account"))
            writer.uint32(32).uint32(message.account);
        if (message.minor != null && Object.hasOwnProperty.call(message, "minor"))
            writer.uint32(40).uint32(message.minor);
        if (message.payment_id != null && Object.hasOwnProperty.call(message, "payment_id"))
            writer.uint32(50).bytes(message.payment_id);
        return writer;
    };

    MoneroGetAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroGetAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroGetAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.show_display = reader.bool();
                break;
            case 3:
                message.network_type = reader.int32();
                break;
            case 4:
                message.account = reader.uint32();
                break;
            case 5:
                message.minor = reader.uint32();
                break;
            case 6:
                message.payment_id = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroGetAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroGetAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        if (message.network_type != null && message.hasOwnProperty("network_type"))
            switch (message.network_type) {
            default:
                return "network_type: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
                break;
            }
        if (message.account != null && message.hasOwnProperty("account"))
            if (!$util.isInteger(message.account))
                return "account: integer expected";
        if (message.minor != null && message.hasOwnProperty("minor"))
            if (!$util.isInteger(message.minor))
                return "minor: integer expected";
        if (message.payment_id != null && message.hasOwnProperty("payment_id"))
            if (!(message.payment_id && typeof message.payment_id.length === "number" || $util.isString(message.payment_id)))
                return "payment_id: buffer expected";
        return null;
    };

    MoneroGetAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroGetAddress)
            return object;
        var message = new $root.MoneroGetAddress();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".MoneroGetAddress.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        switch (object.network_type) {
        case "MAINNET":
        case 0:
            message.network_type = 0;
            break;
        case "TESTNET":
        case 1:
            message.network_type = 1;
            break;
        case "STAGENET":
        case 2:
            message.network_type = 2;
            break;
        case "FAKECHAIN":
        case 3:
            message.network_type = 3;
            break;
        }
        if (object.account != null)
            message.account = object.account >>> 0;
        if (object.minor != null)
            message.minor = object.minor >>> 0;
        if (object.payment_id != null)
            if (typeof object.payment_id === "string")
                $util.base64.decode(object.payment_id, message.payment_id = $util.newBuffer($util.base64.length(object.payment_id)), 0);
            else if (object.payment_id.length)
                message.payment_id = object.payment_id;
        return message;
    };

    MoneroGetAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            object.show_display = false;
            object.network_type = options.enums === String ? "MAINNET" : 0;
            object.account = 0;
            object.minor = 0;
            if (options.bytes === String)
                object.payment_id = "";
            else {
                object.payment_id = [];
                if (options.bytes !== Array)
                    object.payment_id = $util.newBuffer(object.payment_id);
            }
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        if (message.network_type != null && message.hasOwnProperty("network_type"))
            object.network_type = options.enums === String ? $root.MoneroNetworkType[message.network_type] : message.network_type;
        if (message.account != null && message.hasOwnProperty("account"))
            object.account = message.account;
        if (message.minor != null && message.hasOwnProperty("minor"))
            object.minor = message.minor;
        if (message.payment_id != null && message.hasOwnProperty("payment_id"))
            object.payment_id = options.bytes === String ? $util.base64.encode(message.payment_id, 0, message.payment_id.length) : options.bytes === Array ? Array.prototype.slice.call(message.payment_id) : message.payment_id;
        return object;
    };

    MoneroGetAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoneroGetAddress;
})();

$root.MoneroAddress = (function() {

    function MoneroAddress(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroAddress.prototype.address = $util.newBuffer([]);

    MoneroAddress.create = function create(properties) {
        return new MoneroAddress(properties);
    };

    MoneroAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address != null && Object.hasOwnProperty.call(message, "address"))
            writer.uint32(10).bytes(message.address);
        return writer;
    };

    MoneroAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address != null && message.hasOwnProperty("address"))
            if (!(message.address && typeof message.address.length === "number" || $util.isString(message.address)))
                return "address: buffer expected";
        return null;
    };

    MoneroAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroAddress)
            return object;
        var message = new $root.MoneroAddress();
        if (object.address != null)
            if (typeof object.address === "string")
                $util.base64.decode(object.address, message.address = $util.newBuffer($util.base64.length(object.address)), 0);
            else if (object.address.length)
                message.address = object.address;
        return message;
    };

    MoneroAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.address = "";
            else {
                object.address = [];
                if (options.bytes !== Array)
                    object.address = $util.newBuffer(object.address);
            }
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = options.bytes === String ? $util.base64.encode(message.address, 0, message.address.length) : options.bytes === Array ? Array.prototype.slice.call(message.address) : message.address;
        return object;
    };

    MoneroAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoneroAddress;
})();

$root.MoneroGetWatchKey = (function() {

    function MoneroGetWatchKey(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroGetWatchKey.prototype.address_n = $util.emptyArray;
    MoneroGetWatchKey.prototype.network_type = 0;

    MoneroGetWatchKey.create = function create(properties) {
        return new MoneroGetWatchKey(properties);
    };

    MoneroGetWatchKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.network_type != null && Object.hasOwnProperty.call(message, "network_type"))
            writer.uint32(16).int32(message.network_type);
        return writer;
    };

    MoneroGetWatchKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroGetWatchKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroGetWatchKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.network_type = reader.int32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroGetWatchKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroGetWatchKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.network_type != null && message.hasOwnProperty("network_type"))
            switch (message.network_type) {
            default:
                return "network_type: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
                break;
            }
        return null;
    };

    MoneroGetWatchKey.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroGetWatchKey)
            return object;
        var message = new $root.MoneroGetWatchKey();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".MoneroGetWatchKey.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        switch (object.network_type) {
        case "MAINNET":
        case 0:
            message.network_type = 0;
            break;
        case "TESTNET":
        case 1:
            message.network_type = 1;
            break;
        case "STAGENET":
        case 2:
            message.network_type = 2;
            break;
        case "FAKECHAIN":
        case 3:
            message.network_type = 3;
            break;
        }
        return message;
    };

    MoneroGetWatchKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            object.network_type = options.enums === String ? "MAINNET" : 0;
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.network_type != null && message.hasOwnProperty("network_type"))
            object.network_type = options.enums === String ? $root.MoneroNetworkType[message.network_type] : message.network_type;
        return object;
    };

    MoneroGetWatchKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoneroGetWatchKey;
})();

$root.MoneroWatchKey = (function() {

    function MoneroWatchKey(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroWatchKey.prototype.watch_key = $util.newBuffer([]);
    MoneroWatchKey.prototype.address = $util.newBuffer([]);

    MoneroWatchKey.create = function create(properties) {
        return new MoneroWatchKey(properties);
    };

    MoneroWatchKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.watch_key != null && Object.hasOwnProperty.call(message, "watch_key"))
            writer.uint32(10).bytes(message.watch_key);
        if (message.address != null && Object.hasOwnProperty.call(message, "address"))
            writer.uint32(18).bytes(message.address);
        return writer;
    };

    MoneroWatchKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroWatchKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroWatchKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.watch_key = reader.bytes();
                break;
            case 2:
                message.address = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroWatchKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroWatchKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.watch_key != null && message.hasOwnProperty("watch_key"))
            if (!(message.watch_key && typeof message.watch_key.length === "number" || $util.isString(message.watch_key)))
                return "watch_key: buffer expected";
        if (message.address != null && message.hasOwnProperty("address"))
            if (!(message.address && typeof message.address.length === "number" || $util.isString(message.address)))
                return "address: buffer expected";
        return null;
    };

    MoneroWatchKey.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroWatchKey)
            return object;
        var message = new $root.MoneroWatchKey();
        if (object.watch_key != null)
            if (typeof object.watch_key === "string")
                $util.base64.decode(object.watch_key, message.watch_key = $util.newBuffer($util.base64.length(object.watch_key)), 0);
            else if (object.watch_key.length)
                message.watch_key = object.watch_key;
        if (object.address != null)
            if (typeof object.address === "string")
                $util.base64.decode(object.address, message.address = $util.newBuffer($util.base64.length(object.address)), 0);
            else if (object.address.length)
                message.address = object.address;
        return message;
    };

    MoneroWatchKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.watch_key = "";
            else {
                object.watch_key = [];
                if (options.bytes !== Array)
                    object.watch_key = $util.newBuffer(object.watch_key);
            }
            if (options.bytes === String)
                object.address = "";
            else {
                object.address = [];
                if (options.bytes !== Array)
                    object.address = $util.newBuffer(object.address);
            }
        }
        if (message.watch_key != null && message.hasOwnProperty("watch_key"))
            object.watch_key = options.bytes === String ? $util.base64.encode(message.watch_key, 0, message.watch_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.watch_key) : message.watch_key;
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = options.bytes === String ? $util.base64.encode(message.address, 0, message.address.length) : options.bytes === Array ? Array.prototype.slice.call(message.address) : message.address;
        return object;
    };

    MoneroWatchKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoneroWatchKey;
})();

$root.MoneroTransactionInitRequest = (function() {

    function MoneroTransactionInitRequest(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroTransactionInitRequest.prototype.version = 0;
    MoneroTransactionInitRequest.prototype.address_n = $util.emptyArray;
    MoneroTransactionInitRequest.prototype.network_type = 0;
    MoneroTransactionInitRequest.prototype.tsx_data = null;

    MoneroTransactionInitRequest.create = function create(properties) {
        return new MoneroTransactionInitRequest(properties);
    };

    MoneroTransactionInitRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.version != null && Object.hasOwnProperty.call(message, "version"))
            writer.uint32(8).uint32(message.version);
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(16).uint32(message.address_n[i]);
        if (message.network_type != null && Object.hasOwnProperty.call(message, "network_type"))
            writer.uint32(24).int32(message.network_type);
        if (message.tsx_data != null && Object.hasOwnProperty.call(message, "tsx_data"))
            $root.MoneroTransactionInitRequest.MoneroTransactionData.encode(message.tsx_data, writer.uint32(34).fork()).ldelim();
        return writer;
    };

    MoneroTransactionInitRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroTransactionInitRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroTransactionInitRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.version = reader.uint32();
                break;
            case 2:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 3:
                message.network_type = reader.int32();
                break;
            case 4:
                message.tsx_data = $root.MoneroTransactionInitRequest.MoneroTransactionData.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroTransactionInitRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroTransactionInitRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.version != null && message.hasOwnProperty("version"))
            if (!$util.isInteger(message.version))
                return "version: integer expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.network_type != null && message.hasOwnProperty("network_type"))
            switch (message.network_type) {
            default:
                return "network_type: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
                break;
            }
        if (message.tsx_data != null && message.hasOwnProperty("tsx_data")) {
            var error = $root.MoneroTransactionInitRequest.MoneroTransactionData.verify(message.tsx_data);
            if (error)
                return "tsx_data." + error;
        }
        return null;
    };

    MoneroTransactionInitRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroTransactionInitRequest)
            return object;
        var message = new $root.MoneroTransactionInitRequest();
        if (object.version != null)
            message.version = object.version >>> 0;
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".MoneroTransactionInitRequest.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        switch (object.network_type) {
        case "MAINNET":
        case 0:
            message.network_type = 0;
            break;
        case "TESTNET":
        case 1:
            message.network_type = 1;
            break;
        case "STAGENET":
        case 2:
            message.network_type = 2;
            break;
        case "FAKECHAIN":
        case 3:
            message.network_type = 3;
            break;
        }
        if (object.tsx_data != null) {
            if (typeof object.tsx_data !== "object")
                throw TypeError(".MoneroTransactionInitRequest.tsx_data: object expected");
            message.tsx_data = $root.MoneroTransactionInitRequest.MoneroTransactionData.fromObject(object.tsx_data);
        }
        return message;
    };

    MoneroTransactionInitRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            object.version = 0;
            object.network_type = options.enums === String ? "MAINNET" : 0;
            object.tsx_data = null;
        }
        if (message.version != null && message.hasOwnProperty("version"))
            object.version = message.version;
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.network_type != null && message.hasOwnProperty("network_type"))
            object.network_type = options.enums === String ? $root.MoneroNetworkType[message.network_type] : message.network_type;
        if (message.tsx_data != null && message.hasOwnProperty("tsx_data"))
            object.tsx_data = $root.MoneroTransactionInitRequest.MoneroTransactionData.toObject(message.tsx_data, options);
        return object;
    };

    MoneroTransactionInitRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    MoneroTransactionInitRequest.MoneroTransactionData = (function() {

        function MoneroTransactionData(properties) {
            this.outputs = [];
            this.minor_indices = [];
            this.integrated_indices = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        MoneroTransactionData.prototype.version = 0;
        MoneroTransactionData.prototype.payment_id = $util.newBuffer([]);
        MoneroTransactionData.prototype.unlock_time = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        MoneroTransactionData.prototype.outputs = $util.emptyArray;
        MoneroTransactionData.prototype.change_dts = null;
        MoneroTransactionData.prototype.num_inputs = 0;
        MoneroTransactionData.prototype.mixin = 0;
        MoneroTransactionData.prototype.fee = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        MoneroTransactionData.prototype.account = 0;
        MoneroTransactionData.prototype.minor_indices = $util.emptyArray;
        MoneroTransactionData.prototype.rsig_data = null;
        MoneroTransactionData.prototype.integrated_indices = $util.emptyArray;
        MoneroTransactionData.prototype.client_version = 0;
        MoneroTransactionData.prototype.hard_fork = 0;
        MoneroTransactionData.prototype.monero_version = $util.newBuffer([]);

        MoneroTransactionData.create = function create(properties) {
            return new MoneroTransactionData(properties);
        };

        MoneroTransactionData.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.version != null && Object.hasOwnProperty.call(message, "version"))
                writer.uint32(8).uint32(message.version);
            if (message.payment_id != null && Object.hasOwnProperty.call(message, "payment_id"))
                writer.uint32(18).bytes(message.payment_id);
            if (message.unlock_time != null && Object.hasOwnProperty.call(message, "unlock_time"))
                writer.uint32(24).uint64(message.unlock_time);
            if (message.outputs != null && message.outputs.length)
                for (var i = 0; i < message.outputs.length; ++i)
                    $root.MoneroTransactionDestinationEntry.encode(message.outputs[i], writer.uint32(34).fork()).ldelim();
            if (message.change_dts != null && Object.hasOwnProperty.call(message, "change_dts"))
                $root.MoneroTransactionDestinationEntry.encode(message.change_dts, writer.uint32(42).fork()).ldelim();
            if (message.num_inputs != null && Object.hasOwnProperty.call(message, "num_inputs"))
                writer.uint32(48).uint32(message.num_inputs);
            if (message.mixin != null && Object.hasOwnProperty.call(message, "mixin"))
                writer.uint32(56).uint32(message.mixin);
            if (message.fee != null && Object.hasOwnProperty.call(message, "fee"))
                writer.uint32(64).uint64(message.fee);
            if (message.account != null && Object.hasOwnProperty.call(message, "account"))
                writer.uint32(72).uint32(message.account);
            if (message.minor_indices != null && message.minor_indices.length)
                for (var i = 0; i < message.minor_indices.length; ++i)
                    writer.uint32(80).uint32(message.minor_indices[i]);
            if (message.rsig_data != null && Object.hasOwnProperty.call(message, "rsig_data"))
                $root.MoneroTransactionRsigData.encode(message.rsig_data, writer.uint32(90).fork()).ldelim();
            if (message.integrated_indices != null && message.integrated_indices.length)
                for (var i = 0; i < message.integrated_indices.length; ++i)
                    writer.uint32(96).uint32(message.integrated_indices[i]);
            if (message.client_version != null && Object.hasOwnProperty.call(message, "client_version"))
                writer.uint32(104).uint32(message.client_version);
            if (message.hard_fork != null && Object.hasOwnProperty.call(message, "hard_fork"))
                writer.uint32(112).uint32(message.hard_fork);
            if (message.monero_version != null && Object.hasOwnProperty.call(message, "monero_version"))
                writer.uint32(122).bytes(message.monero_version);
            return writer;
        };

        MoneroTransactionData.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        MoneroTransactionData.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroTransactionInitRequest.MoneroTransactionData();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.version = reader.uint32();
                    break;
                case 2:
                    message.payment_id = reader.bytes();
                    break;
                case 3:
                    message.unlock_time = reader.uint64();
                    break;
                case 4:
                    if (!(message.outputs && message.outputs.length))
                        message.outputs = [];
                    message.outputs.push($root.MoneroTransactionDestinationEntry.decode(reader, reader.uint32()));
                    break;
                case 5:
                    message.change_dts = $root.MoneroTransactionDestinationEntry.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.num_inputs = reader.uint32();
                    break;
                case 7:
                    message.mixin = reader.uint32();
                    break;
                case 8:
                    message.fee = reader.uint64();
                    break;
                case 9:
                    message.account = reader.uint32();
                    break;
                case 10:
                    if (!(message.minor_indices && message.minor_indices.length))
                        message.minor_indices = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.minor_indices.push(reader.uint32());
                    } else
                        message.minor_indices.push(reader.uint32());
                    break;
                case 11:
                    message.rsig_data = $root.MoneroTransactionRsigData.decode(reader, reader.uint32());
                    break;
                case 12:
                    if (!(message.integrated_indices && message.integrated_indices.length))
                        message.integrated_indices = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.integrated_indices.push(reader.uint32());
                    } else
                        message.integrated_indices.push(reader.uint32());
                    break;
                case 13:
                    message.client_version = reader.uint32();
                    break;
                case 14:
                    message.hard_fork = reader.uint32();
                    break;
                case 15:
                    message.monero_version = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        MoneroTransactionData.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        MoneroTransactionData.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.version != null && message.hasOwnProperty("version"))
                if (!$util.isInteger(message.version))
                    return "version: integer expected";
            if (message.payment_id != null && message.hasOwnProperty("payment_id"))
                if (!(message.payment_id && typeof message.payment_id.length === "number" || $util.isString(message.payment_id)))
                    return "payment_id: buffer expected";
            if (message.unlock_time != null && message.hasOwnProperty("unlock_time"))
                if (!$util.isInteger(message.unlock_time) && !(message.unlock_time && $util.isInteger(message.unlock_time.low) && $util.isInteger(message.unlock_time.high)))
                    return "unlock_time: integer|Long expected";
            if (message.outputs != null && message.hasOwnProperty("outputs")) {
                if (!Array.isArray(message.outputs))
                    return "outputs: array expected";
                for (var i = 0; i < message.outputs.length; ++i) {
                    var error = $root.MoneroTransactionDestinationEntry.verify(message.outputs[i]);
                    if (error)
                        return "outputs." + error;
                }
            }
            if (message.change_dts != null && message.hasOwnProperty("change_dts")) {
                var error = $root.MoneroTransactionDestinationEntry.verify(message.change_dts);
                if (error)
                    return "change_dts." + error;
            }
            if (message.num_inputs != null && message.hasOwnProperty("num_inputs"))
                if (!$util.isInteger(message.num_inputs))
                    return "num_inputs: integer expected";
            if (message.mixin != null && message.hasOwnProperty("mixin"))
                if (!$util.isInteger(message.mixin))
                    return "mixin: integer expected";
            if (message.fee != null && message.hasOwnProperty("fee"))
                if (!$util.isInteger(message.fee) && !(message.fee && $util.isInteger(message.fee.low) && $util.isInteger(message.fee.high)))
                    return "fee: integer|Long expected";
            if (message.account != null && message.hasOwnProperty("account"))
                if (!$util.isInteger(message.account))
                    return "account: integer expected";
            if (message.minor_indices != null && message.hasOwnProperty("minor_indices")) {
                if (!Array.isArray(message.minor_indices))
                    return "minor_indices: array expected";
                for (var i = 0; i < message.minor_indices.length; ++i)
                    if (!$util.isInteger(message.minor_indices[i]))
                        return "minor_indices: integer[] expected";
            }
            if (message.rsig_data != null && message.hasOwnProperty("rsig_data")) {
                var error = $root.MoneroTransactionRsigData.verify(message.rsig_data);
                if (error)
                    return "rsig_data." + error;
            }
            if (message.integrated_indices != null && message.hasOwnProperty("integrated_indices")) {
                if (!Array.isArray(message.integrated_indices))
                    return "integrated_indices: array expected";
                for (var i = 0; i < message.integrated_indices.length; ++i)
                    if (!$util.isInteger(message.integrated_indices[i]))
                        return "integrated_indices: integer[] expected";
            }
            if (message.client_version != null && message.hasOwnProperty("client_version"))
                if (!$util.isInteger(message.client_version))
                    return "client_version: integer expected";
            if (message.hard_fork != null && message.hasOwnProperty("hard_fork"))
                if (!$util.isInteger(message.hard_fork))
                    return "hard_fork: integer expected";
            if (message.monero_version != null && message.hasOwnProperty("monero_version"))
                if (!(message.monero_version && typeof message.monero_version.length === "number" || $util.isString(message.monero_version)))
                    return "monero_version: buffer expected";
            return null;
        };

        MoneroTransactionData.fromObject = function fromObject(object) {
            if (object instanceof $root.MoneroTransactionInitRequest.MoneroTransactionData)
                return object;
            var message = new $root.MoneroTransactionInitRequest.MoneroTransactionData();
            if (object.version != null)
                message.version = object.version >>> 0;
            if (object.payment_id != null)
                if (typeof object.payment_id === "string")
                    $util.base64.decode(object.payment_id, message.payment_id = $util.newBuffer($util.base64.length(object.payment_id)), 0);
                else if (object.payment_id.length)
                    message.payment_id = object.payment_id;
            if (object.unlock_time != null)
                if ($util.Long)
                    (message.unlock_time = $util.Long.fromValue(object.unlock_time)).unsigned = true;
                else if (typeof object.unlock_time === "string")
                    message.unlock_time = parseInt(object.unlock_time, 10);
                else if (typeof object.unlock_time === "number")
                    message.unlock_time = object.unlock_time;
                else if (typeof object.unlock_time === "object")
                    message.unlock_time = new $util.LongBits(object.unlock_time.low >>> 0, object.unlock_time.high >>> 0).toNumber(true);
            if (object.outputs) {
                if (!Array.isArray(object.outputs))
                    throw TypeError(".MoneroTransactionInitRequest.MoneroTransactionData.outputs: array expected");
                message.outputs = [];
                for (var i = 0; i < object.outputs.length; ++i) {
                    if (typeof object.outputs[i] !== "object")
                        throw TypeError(".MoneroTransactionInitRequest.MoneroTransactionData.outputs: object expected");
                    message.outputs[i] = $root.MoneroTransactionDestinationEntry.fromObject(object.outputs[i]);
                }
            }
            if (object.change_dts != null) {
                if (typeof object.change_dts !== "object")
                    throw TypeError(".MoneroTransactionInitRequest.MoneroTransactionData.change_dts: object expected");
                message.change_dts = $root.MoneroTransactionDestinationEntry.fromObject(object.change_dts);
            }
            if (object.num_inputs != null)
                message.num_inputs = object.num_inputs >>> 0;
            if (object.mixin != null)
                message.mixin = object.mixin >>> 0;
            if (object.fee != null)
                if ($util.Long)
                    (message.fee = $util.Long.fromValue(object.fee)).unsigned = true;
                else if (typeof object.fee === "string")
                    message.fee = parseInt(object.fee, 10);
                else if (typeof object.fee === "number")
                    message.fee = object.fee;
                else if (typeof object.fee === "object")
                    message.fee = new $util.LongBits(object.fee.low >>> 0, object.fee.high >>> 0).toNumber(true);
            if (object.account != null)
                message.account = object.account >>> 0;
            if (object.minor_indices) {
                if (!Array.isArray(object.minor_indices))
                    throw TypeError(".MoneroTransactionInitRequest.MoneroTransactionData.minor_indices: array expected");
                message.minor_indices = [];
                for (var i = 0; i < object.minor_indices.length; ++i)
                    message.minor_indices[i] = object.minor_indices[i] >>> 0;
            }
            if (object.rsig_data != null) {
                if (typeof object.rsig_data !== "object")
                    throw TypeError(".MoneroTransactionInitRequest.MoneroTransactionData.rsig_data: object expected");
                message.rsig_data = $root.MoneroTransactionRsigData.fromObject(object.rsig_data);
            }
            if (object.integrated_indices) {
                if (!Array.isArray(object.integrated_indices))
                    throw TypeError(".MoneroTransactionInitRequest.MoneroTransactionData.integrated_indices: array expected");
                message.integrated_indices = [];
                for (var i = 0; i < object.integrated_indices.length; ++i)
                    message.integrated_indices[i] = object.integrated_indices[i] >>> 0;
            }
            if (object.client_version != null)
                message.client_version = object.client_version >>> 0;
            if (object.hard_fork != null)
                message.hard_fork = object.hard_fork >>> 0;
            if (object.monero_version != null)
                if (typeof object.monero_version === "string")
                    $util.base64.decode(object.monero_version, message.monero_version = $util.newBuffer($util.base64.length(object.monero_version)), 0);
                else if (object.monero_version.length)
                    message.monero_version = object.monero_version;
            return message;
        };

        MoneroTransactionData.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.outputs = [];
                object.minor_indices = [];
                object.integrated_indices = [];
            }
            if (options.defaults) {
                object.version = 0;
                if (options.bytes === String)
                    object.payment_id = "";
                else {
                    object.payment_id = [];
                    if (options.bytes !== Array)
                        object.payment_id = $util.newBuffer(object.payment_id);
                }
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.unlock_time = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.unlock_time = options.longs === String ? "0" : 0;
                object.change_dts = null;
                object.num_inputs = 0;
                object.mixin = 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.fee = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.fee = options.longs === String ? "0" : 0;
                object.account = 0;
                object.rsig_data = null;
                object.client_version = 0;
                object.hard_fork = 0;
                if (options.bytes === String)
                    object.monero_version = "";
                else {
                    object.monero_version = [];
                    if (options.bytes !== Array)
                        object.monero_version = $util.newBuffer(object.monero_version);
                }
            }
            if (message.version != null && message.hasOwnProperty("version"))
                object.version = message.version;
            if (message.payment_id != null && message.hasOwnProperty("payment_id"))
                object.payment_id = options.bytes === String ? $util.base64.encode(message.payment_id, 0, message.payment_id.length) : options.bytes === Array ? Array.prototype.slice.call(message.payment_id) : message.payment_id;
            if (message.unlock_time != null && message.hasOwnProperty("unlock_time"))
                if (typeof message.unlock_time === "number")
                    object.unlock_time = options.longs === String ? String(message.unlock_time) : message.unlock_time;
                else
                    object.unlock_time = options.longs === String ? $util.Long.prototype.toString.call(message.unlock_time) : options.longs === Number ? new $util.LongBits(message.unlock_time.low >>> 0, message.unlock_time.high >>> 0).toNumber(true) : message.unlock_time;
            if (message.outputs && message.outputs.length) {
                object.outputs = [];
                for (var j = 0; j < message.outputs.length; ++j)
                    object.outputs[j] = $root.MoneroTransactionDestinationEntry.toObject(message.outputs[j], options);
            }
            if (message.change_dts != null && message.hasOwnProperty("change_dts"))
                object.change_dts = $root.MoneroTransactionDestinationEntry.toObject(message.change_dts, options);
            if (message.num_inputs != null && message.hasOwnProperty("num_inputs"))
                object.num_inputs = message.num_inputs;
            if (message.mixin != null && message.hasOwnProperty("mixin"))
                object.mixin = message.mixin;
            if (message.fee != null && message.hasOwnProperty("fee"))
                if (typeof message.fee === "number")
                    object.fee = options.longs === String ? String(message.fee) : message.fee;
                else
                    object.fee = options.longs === String ? $util.Long.prototype.toString.call(message.fee) : options.longs === Number ? new $util.LongBits(message.fee.low >>> 0, message.fee.high >>> 0).toNumber(true) : message.fee;
            if (message.account != null && message.hasOwnProperty("account"))
                object.account = message.account;
            if (message.minor_indices && message.minor_indices.length) {
                object.minor_indices = [];
                for (var j = 0; j < message.minor_indices.length; ++j)
                    object.minor_indices[j] = message.minor_indices[j];
            }
            if (message.rsig_data != null && message.hasOwnProperty("rsig_data"))
                object.rsig_data = $root.MoneroTransactionRsigData.toObject(message.rsig_data, options);
            if (message.integrated_indices && message.integrated_indices.length) {
                object.integrated_indices = [];
                for (var j = 0; j < message.integrated_indices.length; ++j)
                    object.integrated_indices[j] = message.integrated_indices[j];
            }
            if (message.client_version != null && message.hasOwnProperty("client_version"))
                object.client_version = message.client_version;
            if (message.hard_fork != null && message.hasOwnProperty("hard_fork"))
                object.hard_fork = message.hard_fork;
            if (message.monero_version != null && message.hasOwnProperty("monero_version"))
                object.monero_version = options.bytes === String ? $util.base64.encode(message.monero_version, 0, message.monero_version.length) : options.bytes === Array ? Array.prototype.slice.call(message.monero_version) : message.monero_version;
            return object;
        };

        MoneroTransactionData.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return MoneroTransactionData;
    })();

    return MoneroTransactionInitRequest;
})();

$root.MoneroTransactionInitAck = (function() {

    function MoneroTransactionInitAck(properties) {
        this.hmacs = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroTransactionInitAck.prototype.hmacs = $util.emptyArray;
    MoneroTransactionInitAck.prototype.rsig_data = null;

    MoneroTransactionInitAck.create = function create(properties) {
        return new MoneroTransactionInitAck(properties);
    };

    MoneroTransactionInitAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.hmacs != null && message.hmacs.length)
            for (var i = 0; i < message.hmacs.length; ++i)
                writer.uint32(10).bytes(message.hmacs[i]);
        if (message.rsig_data != null && Object.hasOwnProperty.call(message, "rsig_data"))
            $root.MoneroTransactionRsigData.encode(message.rsig_data, writer.uint32(18).fork()).ldelim();
        return writer;
    };

    MoneroTransactionInitAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroTransactionInitAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroTransactionInitAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.hmacs && message.hmacs.length))
                    message.hmacs = [];
                message.hmacs.push(reader.bytes());
                break;
            case 2:
                message.rsig_data = $root.MoneroTransactionRsigData.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroTransactionInitAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroTransactionInitAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.hmacs != null && message.hasOwnProperty("hmacs")) {
            if (!Array.isArray(message.hmacs))
                return "hmacs: array expected";
            for (var i = 0; i < message.hmacs.length; ++i)
                if (!(message.hmacs[i] && typeof message.hmacs[i].length === "number" || $util.isString(message.hmacs[i])))
                    return "hmacs: buffer[] expected";
        }
        if (message.rsig_data != null && message.hasOwnProperty("rsig_data")) {
            var error = $root.MoneroTransactionRsigData.verify(message.rsig_data);
            if (error)
                return "rsig_data." + error;
        }
        return null;
    };

    MoneroTransactionInitAck.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroTransactionInitAck)
            return object;
        var message = new $root.MoneroTransactionInitAck();
        if (object.hmacs) {
            if (!Array.isArray(object.hmacs))
                throw TypeError(".MoneroTransactionInitAck.hmacs: array expected");
            message.hmacs = [];
            for (var i = 0; i < object.hmacs.length; ++i)
                if (typeof object.hmacs[i] === "string")
                    $util.base64.decode(object.hmacs[i], message.hmacs[i] = $util.newBuffer($util.base64.length(object.hmacs[i])), 0);
                else if (object.hmacs[i].length)
                    message.hmacs[i] = object.hmacs[i];
        }
        if (object.rsig_data != null) {
            if (typeof object.rsig_data !== "object")
                throw TypeError(".MoneroTransactionInitAck.rsig_data: object expected");
            message.rsig_data = $root.MoneroTransactionRsigData.fromObject(object.rsig_data);
        }
        return message;
    };

    MoneroTransactionInitAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.hmacs = [];
        if (options.defaults)
            object.rsig_data = null;
        if (message.hmacs && message.hmacs.length) {
            object.hmacs = [];
            for (var j = 0; j < message.hmacs.length; ++j)
                object.hmacs[j] = options.bytes === String ? $util.base64.encode(message.hmacs[j], 0, message.hmacs[j].length) : options.bytes === Array ? Array.prototype.slice.call(message.hmacs[j]) : message.hmacs[j];
        }
        if (message.rsig_data != null && message.hasOwnProperty("rsig_data"))
            object.rsig_data = $root.MoneroTransactionRsigData.toObject(message.rsig_data, options);
        return object;
    };

    MoneroTransactionInitAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoneroTransactionInitAck;
})();

$root.MoneroTransactionSetInputRequest = (function() {

    function MoneroTransactionSetInputRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroTransactionSetInputRequest.prototype.src_entr = null;

    MoneroTransactionSetInputRequest.create = function create(properties) {
        return new MoneroTransactionSetInputRequest(properties);
    };

    MoneroTransactionSetInputRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.src_entr != null && Object.hasOwnProperty.call(message, "src_entr"))
            $root.MoneroTransactionSourceEntry.encode(message.src_entr, writer.uint32(10).fork()).ldelim();
        return writer;
    };

    MoneroTransactionSetInputRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroTransactionSetInputRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroTransactionSetInputRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.src_entr = $root.MoneroTransactionSourceEntry.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroTransactionSetInputRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroTransactionSetInputRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.src_entr != null && message.hasOwnProperty("src_entr")) {
            var error = $root.MoneroTransactionSourceEntry.verify(message.src_entr);
            if (error)
                return "src_entr." + error;
        }
        return null;
    };

    MoneroTransactionSetInputRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroTransactionSetInputRequest)
            return object;
        var message = new $root.MoneroTransactionSetInputRequest();
        if (object.src_entr != null) {
            if (typeof object.src_entr !== "object")
                throw TypeError(".MoneroTransactionSetInputRequest.src_entr: object expected");
            message.src_entr = $root.MoneroTransactionSourceEntry.fromObject(object.src_entr);
        }
        return message;
    };

    MoneroTransactionSetInputRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.src_entr = null;
        if (message.src_entr != null && message.hasOwnProperty("src_entr"))
            object.src_entr = $root.MoneroTransactionSourceEntry.toObject(message.src_entr, options);
        return object;
    };

    MoneroTransactionSetInputRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoneroTransactionSetInputRequest;
})();

$root.MoneroTransactionSetInputAck = (function() {

    function MoneroTransactionSetInputAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroTransactionSetInputAck.prototype.vini = $util.newBuffer([]);
    MoneroTransactionSetInputAck.prototype.vini_hmac = $util.newBuffer([]);
    MoneroTransactionSetInputAck.prototype.pseudo_out = $util.newBuffer([]);
    MoneroTransactionSetInputAck.prototype.pseudo_out_hmac = $util.newBuffer([]);
    MoneroTransactionSetInputAck.prototype.pseudo_out_alpha = $util.newBuffer([]);
    MoneroTransactionSetInputAck.prototype.spend_key = $util.newBuffer([]);

    MoneroTransactionSetInputAck.create = function create(properties) {
        return new MoneroTransactionSetInputAck(properties);
    };

    MoneroTransactionSetInputAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.vini != null && Object.hasOwnProperty.call(message, "vini"))
            writer.uint32(10).bytes(message.vini);
        if (message.vini_hmac != null && Object.hasOwnProperty.call(message, "vini_hmac"))
            writer.uint32(18).bytes(message.vini_hmac);
        if (message.pseudo_out != null && Object.hasOwnProperty.call(message, "pseudo_out"))
            writer.uint32(26).bytes(message.pseudo_out);
        if (message.pseudo_out_hmac != null && Object.hasOwnProperty.call(message, "pseudo_out_hmac"))
            writer.uint32(34).bytes(message.pseudo_out_hmac);
        if (message.pseudo_out_alpha != null && Object.hasOwnProperty.call(message, "pseudo_out_alpha"))
            writer.uint32(42).bytes(message.pseudo_out_alpha);
        if (message.spend_key != null && Object.hasOwnProperty.call(message, "spend_key"))
            writer.uint32(50).bytes(message.spend_key);
        return writer;
    };

    MoneroTransactionSetInputAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroTransactionSetInputAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroTransactionSetInputAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.vini = reader.bytes();
                break;
            case 2:
                message.vini_hmac = reader.bytes();
                break;
            case 3:
                message.pseudo_out = reader.bytes();
                break;
            case 4:
                message.pseudo_out_hmac = reader.bytes();
                break;
            case 5:
                message.pseudo_out_alpha = reader.bytes();
                break;
            case 6:
                message.spend_key = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroTransactionSetInputAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroTransactionSetInputAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.vini != null && message.hasOwnProperty("vini"))
            if (!(message.vini && typeof message.vini.length === "number" || $util.isString(message.vini)))
                return "vini: buffer expected";
        if (message.vini_hmac != null && message.hasOwnProperty("vini_hmac"))
            if (!(message.vini_hmac && typeof message.vini_hmac.length === "number" || $util.isString(message.vini_hmac)))
                return "vini_hmac: buffer expected";
        if (message.pseudo_out != null && message.hasOwnProperty("pseudo_out"))
            if (!(message.pseudo_out && typeof message.pseudo_out.length === "number" || $util.isString(message.pseudo_out)))
                return "pseudo_out: buffer expected";
        if (message.pseudo_out_hmac != null && message.hasOwnProperty("pseudo_out_hmac"))
            if (!(message.pseudo_out_hmac && typeof message.pseudo_out_hmac.length === "number" || $util.isString(message.pseudo_out_hmac)))
                return "pseudo_out_hmac: buffer expected";
        if (message.pseudo_out_alpha != null && message.hasOwnProperty("pseudo_out_alpha"))
            if (!(message.pseudo_out_alpha && typeof message.pseudo_out_alpha.length === "number" || $util.isString(message.pseudo_out_alpha)))
                return "pseudo_out_alpha: buffer expected";
        if (message.spend_key != null && message.hasOwnProperty("spend_key"))
            if (!(message.spend_key && typeof message.spend_key.length === "number" || $util.isString(message.spend_key)))
                return "spend_key: buffer expected";
        return null;
    };

    MoneroTransactionSetInputAck.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroTransactionSetInputAck)
            return object;
        var message = new $root.MoneroTransactionSetInputAck();
        if (object.vini != null)
            if (typeof object.vini === "string")
                $util.base64.decode(object.vini, message.vini = $util.newBuffer($util.base64.length(object.vini)), 0);
            else if (object.vini.length)
                message.vini = object.vini;
        if (object.vini_hmac != null)
            if (typeof object.vini_hmac === "string")
                $util.base64.decode(object.vini_hmac, message.vini_hmac = $util.newBuffer($util.base64.length(object.vini_hmac)), 0);
            else if (object.vini_hmac.length)
                message.vini_hmac = object.vini_hmac;
        if (object.pseudo_out != null)
            if (typeof object.pseudo_out === "string")
                $util.base64.decode(object.pseudo_out, message.pseudo_out = $util.newBuffer($util.base64.length(object.pseudo_out)), 0);
            else if (object.pseudo_out.length)
                message.pseudo_out = object.pseudo_out;
        if (object.pseudo_out_hmac != null)
            if (typeof object.pseudo_out_hmac === "string")
                $util.base64.decode(object.pseudo_out_hmac, message.pseudo_out_hmac = $util.newBuffer($util.base64.length(object.pseudo_out_hmac)), 0);
            else if (object.pseudo_out_hmac.length)
                message.pseudo_out_hmac = object.pseudo_out_hmac;
        if (object.pseudo_out_alpha != null)
            if (typeof object.pseudo_out_alpha === "string")
                $util.base64.decode(object.pseudo_out_alpha, message.pseudo_out_alpha = $util.newBuffer($util.base64.length(object.pseudo_out_alpha)), 0);
            else if (object.pseudo_out_alpha.length)
                message.pseudo_out_alpha = object.pseudo_out_alpha;
        if (object.spend_key != null)
            if (typeof object.spend_key === "string")
                $util.base64.decode(object.spend_key, message.spend_key = $util.newBuffer($util.base64.length(object.spend_key)), 0);
            else if (object.spend_key.length)
                message.spend_key = object.spend_key;
        return message;
    };

    MoneroTransactionSetInputAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.vini = "";
            else {
                object.vini = [];
                if (options.bytes !== Array)
                    object.vini = $util.newBuffer(object.vini);
            }
            if (options.bytes === String)
                object.vini_hmac = "";
            else {
                object.vini_hmac = [];
                if (options.bytes !== Array)
                    object.vini_hmac = $util.newBuffer(object.vini_hmac);
            }
            if (options.bytes === String)
                object.pseudo_out = "";
            else {
                object.pseudo_out = [];
                if (options.bytes !== Array)
                    object.pseudo_out = $util.newBuffer(object.pseudo_out);
            }
            if (options.bytes === String)
                object.pseudo_out_hmac = "";
            else {
                object.pseudo_out_hmac = [];
                if (options.bytes !== Array)
                    object.pseudo_out_hmac = $util.newBuffer(object.pseudo_out_hmac);
            }
            if (options.bytes === String)
                object.pseudo_out_alpha = "";
            else {
                object.pseudo_out_alpha = [];
                if (options.bytes !== Array)
                    object.pseudo_out_alpha = $util.newBuffer(object.pseudo_out_alpha);
            }
            if (options.bytes === String)
                object.spend_key = "";
            else {
                object.spend_key = [];
                if (options.bytes !== Array)
                    object.spend_key = $util.newBuffer(object.spend_key);
            }
        }
        if (message.vini != null && message.hasOwnProperty("vini"))
            object.vini = options.bytes === String ? $util.base64.encode(message.vini, 0, message.vini.length) : options.bytes === Array ? Array.prototype.slice.call(message.vini) : message.vini;
        if (message.vini_hmac != null && message.hasOwnProperty("vini_hmac"))
            object.vini_hmac = options.bytes === String ? $util.base64.encode(message.vini_hmac, 0, message.vini_hmac.length) : options.bytes === Array ? Array.prototype.slice.call(message.vini_hmac) : message.vini_hmac;
        if (message.pseudo_out != null && message.hasOwnProperty("pseudo_out"))
            object.pseudo_out = options.bytes === String ? $util.base64.encode(message.pseudo_out, 0, message.pseudo_out.length) : options.bytes === Array ? Array.prototype.slice.call(message.pseudo_out) : message.pseudo_out;
        if (message.pseudo_out_hmac != null && message.hasOwnProperty("pseudo_out_hmac"))
            object.pseudo_out_hmac = options.bytes === String ? $util.base64.encode(message.pseudo_out_hmac, 0, message.pseudo_out_hmac.length) : options.bytes === Array ? Array.prototype.slice.call(message.pseudo_out_hmac) : message.pseudo_out_hmac;
        if (message.pseudo_out_alpha != null && message.hasOwnProperty("pseudo_out_alpha"))
            object.pseudo_out_alpha = options.bytes === String ? $util.base64.encode(message.pseudo_out_alpha, 0, message.pseudo_out_alpha.length) : options.bytes === Array ? Array.prototype.slice.call(message.pseudo_out_alpha) : message.pseudo_out_alpha;
        if (message.spend_key != null && message.hasOwnProperty("spend_key"))
            object.spend_key = options.bytes === String ? $util.base64.encode(message.spend_key, 0, message.spend_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.spend_key) : message.spend_key;
        return object;
    };

    MoneroTransactionSetInputAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoneroTransactionSetInputAck;
})();

$root.MoneroTransactionInputViniRequest = (function() {

    function MoneroTransactionInputViniRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroTransactionInputViniRequest.prototype.src_entr = null;
    MoneroTransactionInputViniRequest.prototype.vini = $util.newBuffer([]);
    MoneroTransactionInputViniRequest.prototype.vini_hmac = $util.newBuffer([]);
    MoneroTransactionInputViniRequest.prototype.pseudo_out = $util.newBuffer([]);
    MoneroTransactionInputViniRequest.prototype.pseudo_out_hmac = $util.newBuffer([]);
    MoneroTransactionInputViniRequest.prototype.orig_idx = 0;

    MoneroTransactionInputViniRequest.create = function create(properties) {
        return new MoneroTransactionInputViniRequest(properties);
    };

    MoneroTransactionInputViniRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.src_entr != null && Object.hasOwnProperty.call(message, "src_entr"))
            $root.MoneroTransactionSourceEntry.encode(message.src_entr, writer.uint32(10).fork()).ldelim();
        if (message.vini != null && Object.hasOwnProperty.call(message, "vini"))
            writer.uint32(18).bytes(message.vini);
        if (message.vini_hmac != null && Object.hasOwnProperty.call(message, "vini_hmac"))
            writer.uint32(26).bytes(message.vini_hmac);
        if (message.pseudo_out != null && Object.hasOwnProperty.call(message, "pseudo_out"))
            writer.uint32(34).bytes(message.pseudo_out);
        if (message.pseudo_out_hmac != null && Object.hasOwnProperty.call(message, "pseudo_out_hmac"))
            writer.uint32(42).bytes(message.pseudo_out_hmac);
        if (message.orig_idx != null && Object.hasOwnProperty.call(message, "orig_idx"))
            writer.uint32(48).uint32(message.orig_idx);
        return writer;
    };

    MoneroTransactionInputViniRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroTransactionInputViniRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroTransactionInputViniRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.src_entr = $root.MoneroTransactionSourceEntry.decode(reader, reader.uint32());
                break;
            case 2:
                message.vini = reader.bytes();
                break;
            case 3:
                message.vini_hmac = reader.bytes();
                break;
            case 4:
                message.pseudo_out = reader.bytes();
                break;
            case 5:
                message.pseudo_out_hmac = reader.bytes();
                break;
            case 6:
                message.orig_idx = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroTransactionInputViniRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroTransactionInputViniRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.src_entr != null && message.hasOwnProperty("src_entr")) {
            var error = $root.MoneroTransactionSourceEntry.verify(message.src_entr);
            if (error)
                return "src_entr." + error;
        }
        if (message.vini != null && message.hasOwnProperty("vini"))
            if (!(message.vini && typeof message.vini.length === "number" || $util.isString(message.vini)))
                return "vini: buffer expected";
        if (message.vini_hmac != null && message.hasOwnProperty("vini_hmac"))
            if (!(message.vini_hmac && typeof message.vini_hmac.length === "number" || $util.isString(message.vini_hmac)))
                return "vini_hmac: buffer expected";
        if (message.pseudo_out != null && message.hasOwnProperty("pseudo_out"))
            if (!(message.pseudo_out && typeof message.pseudo_out.length === "number" || $util.isString(message.pseudo_out)))
                return "pseudo_out: buffer expected";
        if (message.pseudo_out_hmac != null && message.hasOwnProperty("pseudo_out_hmac"))
            if (!(message.pseudo_out_hmac && typeof message.pseudo_out_hmac.length === "number" || $util.isString(message.pseudo_out_hmac)))
                return "pseudo_out_hmac: buffer expected";
        if (message.orig_idx != null && message.hasOwnProperty("orig_idx"))
            if (!$util.isInteger(message.orig_idx))
                return "orig_idx: integer expected";
        return null;
    };

    MoneroTransactionInputViniRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroTransactionInputViniRequest)
            return object;
        var message = new $root.MoneroTransactionInputViniRequest();
        if (object.src_entr != null) {
            if (typeof object.src_entr !== "object")
                throw TypeError(".MoneroTransactionInputViniRequest.src_entr: object expected");
            message.src_entr = $root.MoneroTransactionSourceEntry.fromObject(object.src_entr);
        }
        if (object.vini != null)
            if (typeof object.vini === "string")
                $util.base64.decode(object.vini, message.vini = $util.newBuffer($util.base64.length(object.vini)), 0);
            else if (object.vini.length)
                message.vini = object.vini;
        if (object.vini_hmac != null)
            if (typeof object.vini_hmac === "string")
                $util.base64.decode(object.vini_hmac, message.vini_hmac = $util.newBuffer($util.base64.length(object.vini_hmac)), 0);
            else if (object.vini_hmac.length)
                message.vini_hmac = object.vini_hmac;
        if (object.pseudo_out != null)
            if (typeof object.pseudo_out === "string")
                $util.base64.decode(object.pseudo_out, message.pseudo_out = $util.newBuffer($util.base64.length(object.pseudo_out)), 0);
            else if (object.pseudo_out.length)
                message.pseudo_out = object.pseudo_out;
        if (object.pseudo_out_hmac != null)
            if (typeof object.pseudo_out_hmac === "string")
                $util.base64.decode(object.pseudo_out_hmac, message.pseudo_out_hmac = $util.newBuffer($util.base64.length(object.pseudo_out_hmac)), 0);
            else if (object.pseudo_out_hmac.length)
                message.pseudo_out_hmac = object.pseudo_out_hmac;
        if (object.orig_idx != null)
            message.orig_idx = object.orig_idx >>> 0;
        return message;
    };

    MoneroTransactionInputViniRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.src_entr = null;
            if (options.bytes === String)
                object.vini = "";
            else {
                object.vini = [];
                if (options.bytes !== Array)
                    object.vini = $util.newBuffer(object.vini);
            }
            if (options.bytes === String)
                object.vini_hmac = "";
            else {
                object.vini_hmac = [];
                if (options.bytes !== Array)
                    object.vini_hmac = $util.newBuffer(object.vini_hmac);
            }
            if (options.bytes === String)
                object.pseudo_out = "";
            else {
                object.pseudo_out = [];
                if (options.bytes !== Array)
                    object.pseudo_out = $util.newBuffer(object.pseudo_out);
            }
            if (options.bytes === String)
                object.pseudo_out_hmac = "";
            else {
                object.pseudo_out_hmac = [];
                if (options.bytes !== Array)
                    object.pseudo_out_hmac = $util.newBuffer(object.pseudo_out_hmac);
            }
            object.orig_idx = 0;
        }
        if (message.src_entr != null && message.hasOwnProperty("src_entr"))
            object.src_entr = $root.MoneroTransactionSourceEntry.toObject(message.src_entr, options);
        if (message.vini != null && message.hasOwnProperty("vini"))
            object.vini = options.bytes === String ? $util.base64.encode(message.vini, 0, message.vini.length) : options.bytes === Array ? Array.prototype.slice.call(message.vini) : message.vini;
        if (message.vini_hmac != null && message.hasOwnProperty("vini_hmac"))
            object.vini_hmac = options.bytes === String ? $util.base64.encode(message.vini_hmac, 0, message.vini_hmac.length) : options.bytes === Array ? Array.prototype.slice.call(message.vini_hmac) : message.vini_hmac;
        if (message.pseudo_out != null && message.hasOwnProperty("pseudo_out"))
            object.pseudo_out = options.bytes === String ? $util.base64.encode(message.pseudo_out, 0, message.pseudo_out.length) : options.bytes === Array ? Array.prototype.slice.call(message.pseudo_out) : message.pseudo_out;
        if (message.pseudo_out_hmac != null && message.hasOwnProperty("pseudo_out_hmac"))
            object.pseudo_out_hmac = options.bytes === String ? $util.base64.encode(message.pseudo_out_hmac, 0, message.pseudo_out_hmac.length) : options.bytes === Array ? Array.prototype.slice.call(message.pseudo_out_hmac) : message.pseudo_out_hmac;
        if (message.orig_idx != null && message.hasOwnProperty("orig_idx"))
            object.orig_idx = message.orig_idx;
        return object;
    };

    MoneroTransactionInputViniRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoneroTransactionInputViniRequest;
})();

$root.MoneroTransactionInputViniAck = (function() {

    function MoneroTransactionInputViniAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroTransactionInputViniAck.create = function create(properties) {
        return new MoneroTransactionInputViniAck(properties);
    };

    MoneroTransactionInputViniAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    MoneroTransactionInputViniAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroTransactionInputViniAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroTransactionInputViniAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroTransactionInputViniAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroTransactionInputViniAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    MoneroTransactionInputViniAck.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroTransactionInputViniAck)
            return object;
        return new $root.MoneroTransactionInputViniAck();
    };

    MoneroTransactionInputViniAck.toObject = function toObject() {
        return {};
    };

    MoneroTransactionInputViniAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoneroTransactionInputViniAck;
})();

$root.MoneroTransactionAllInputsSetRequest = (function() {

    function MoneroTransactionAllInputsSetRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroTransactionAllInputsSetRequest.create = function create(properties) {
        return new MoneroTransactionAllInputsSetRequest(properties);
    };

    MoneroTransactionAllInputsSetRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    MoneroTransactionAllInputsSetRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroTransactionAllInputsSetRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroTransactionAllInputsSetRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroTransactionAllInputsSetRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroTransactionAllInputsSetRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    MoneroTransactionAllInputsSetRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroTransactionAllInputsSetRequest)
            return object;
        return new $root.MoneroTransactionAllInputsSetRequest();
    };

    MoneroTransactionAllInputsSetRequest.toObject = function toObject() {
        return {};
    };

    MoneroTransactionAllInputsSetRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoneroTransactionAllInputsSetRequest;
})();

$root.MoneroTransactionAllInputsSetAck = (function() {

    function MoneroTransactionAllInputsSetAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroTransactionAllInputsSetAck.prototype.rsig_data = null;

    MoneroTransactionAllInputsSetAck.create = function create(properties) {
        return new MoneroTransactionAllInputsSetAck(properties);
    };

    MoneroTransactionAllInputsSetAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.rsig_data != null && Object.hasOwnProperty.call(message, "rsig_data"))
            $root.MoneroTransactionRsigData.encode(message.rsig_data, writer.uint32(10).fork()).ldelim();
        return writer;
    };

    MoneroTransactionAllInputsSetAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroTransactionAllInputsSetAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroTransactionAllInputsSetAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.rsig_data = $root.MoneroTransactionRsigData.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroTransactionAllInputsSetAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroTransactionAllInputsSetAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.rsig_data != null && message.hasOwnProperty("rsig_data")) {
            var error = $root.MoneroTransactionRsigData.verify(message.rsig_data);
            if (error)
                return "rsig_data." + error;
        }
        return null;
    };

    MoneroTransactionAllInputsSetAck.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroTransactionAllInputsSetAck)
            return object;
        var message = new $root.MoneroTransactionAllInputsSetAck();
        if (object.rsig_data != null) {
            if (typeof object.rsig_data !== "object")
                throw TypeError(".MoneroTransactionAllInputsSetAck.rsig_data: object expected");
            message.rsig_data = $root.MoneroTransactionRsigData.fromObject(object.rsig_data);
        }
        return message;
    };

    MoneroTransactionAllInputsSetAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.rsig_data = null;
        if (message.rsig_data != null && message.hasOwnProperty("rsig_data"))
            object.rsig_data = $root.MoneroTransactionRsigData.toObject(message.rsig_data, options);
        return object;
    };

    MoneroTransactionAllInputsSetAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoneroTransactionAllInputsSetAck;
})();

$root.MoneroTransactionSetOutputRequest = (function() {

    function MoneroTransactionSetOutputRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroTransactionSetOutputRequest.prototype.dst_entr = null;
    MoneroTransactionSetOutputRequest.prototype.dst_entr_hmac = $util.newBuffer([]);
    MoneroTransactionSetOutputRequest.prototype.rsig_data = null;
    MoneroTransactionSetOutputRequest.prototype.is_offloaded_bp = false;

    MoneroTransactionSetOutputRequest.create = function create(properties) {
        return new MoneroTransactionSetOutputRequest(properties);
    };

    MoneroTransactionSetOutputRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.dst_entr != null && Object.hasOwnProperty.call(message, "dst_entr"))
            $root.MoneroTransactionDestinationEntry.encode(message.dst_entr, writer.uint32(10).fork()).ldelim();
        if (message.dst_entr_hmac != null && Object.hasOwnProperty.call(message, "dst_entr_hmac"))
            writer.uint32(18).bytes(message.dst_entr_hmac);
        if (message.rsig_data != null && Object.hasOwnProperty.call(message, "rsig_data"))
            $root.MoneroTransactionRsigData.encode(message.rsig_data, writer.uint32(26).fork()).ldelim();
        if (message.is_offloaded_bp != null && Object.hasOwnProperty.call(message, "is_offloaded_bp"))
            writer.uint32(32).bool(message.is_offloaded_bp);
        return writer;
    };

    MoneroTransactionSetOutputRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroTransactionSetOutputRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroTransactionSetOutputRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.dst_entr = $root.MoneroTransactionDestinationEntry.decode(reader, reader.uint32());
                break;
            case 2:
                message.dst_entr_hmac = reader.bytes();
                break;
            case 3:
                message.rsig_data = $root.MoneroTransactionRsigData.decode(reader, reader.uint32());
                break;
            case 4:
                message.is_offloaded_bp = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroTransactionSetOutputRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroTransactionSetOutputRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.dst_entr != null && message.hasOwnProperty("dst_entr")) {
            var error = $root.MoneroTransactionDestinationEntry.verify(message.dst_entr);
            if (error)
                return "dst_entr." + error;
        }
        if (message.dst_entr_hmac != null && message.hasOwnProperty("dst_entr_hmac"))
            if (!(message.dst_entr_hmac && typeof message.dst_entr_hmac.length === "number" || $util.isString(message.dst_entr_hmac)))
                return "dst_entr_hmac: buffer expected";
        if (message.rsig_data != null && message.hasOwnProperty("rsig_data")) {
            var error = $root.MoneroTransactionRsigData.verify(message.rsig_data);
            if (error)
                return "rsig_data." + error;
        }
        if (message.is_offloaded_bp != null && message.hasOwnProperty("is_offloaded_bp"))
            if (typeof message.is_offloaded_bp !== "boolean")
                return "is_offloaded_bp: boolean expected";
        return null;
    };

    MoneroTransactionSetOutputRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroTransactionSetOutputRequest)
            return object;
        var message = new $root.MoneroTransactionSetOutputRequest();
        if (object.dst_entr != null) {
            if (typeof object.dst_entr !== "object")
                throw TypeError(".MoneroTransactionSetOutputRequest.dst_entr: object expected");
            message.dst_entr = $root.MoneroTransactionDestinationEntry.fromObject(object.dst_entr);
        }
        if (object.dst_entr_hmac != null)
            if (typeof object.dst_entr_hmac === "string")
                $util.base64.decode(object.dst_entr_hmac, message.dst_entr_hmac = $util.newBuffer($util.base64.length(object.dst_entr_hmac)), 0);
            else if (object.dst_entr_hmac.length)
                message.dst_entr_hmac = object.dst_entr_hmac;
        if (object.rsig_data != null) {
            if (typeof object.rsig_data !== "object")
                throw TypeError(".MoneroTransactionSetOutputRequest.rsig_data: object expected");
            message.rsig_data = $root.MoneroTransactionRsigData.fromObject(object.rsig_data);
        }
        if (object.is_offloaded_bp != null)
            message.is_offloaded_bp = Boolean(object.is_offloaded_bp);
        return message;
    };

    MoneroTransactionSetOutputRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.dst_entr = null;
            if (options.bytes === String)
                object.dst_entr_hmac = "";
            else {
                object.dst_entr_hmac = [];
                if (options.bytes !== Array)
                    object.dst_entr_hmac = $util.newBuffer(object.dst_entr_hmac);
            }
            object.rsig_data = null;
            object.is_offloaded_bp = false;
        }
        if (message.dst_entr != null && message.hasOwnProperty("dst_entr"))
            object.dst_entr = $root.MoneroTransactionDestinationEntry.toObject(message.dst_entr, options);
        if (message.dst_entr_hmac != null && message.hasOwnProperty("dst_entr_hmac"))
            object.dst_entr_hmac = options.bytes === String ? $util.base64.encode(message.dst_entr_hmac, 0, message.dst_entr_hmac.length) : options.bytes === Array ? Array.prototype.slice.call(message.dst_entr_hmac) : message.dst_entr_hmac;
        if (message.rsig_data != null && message.hasOwnProperty("rsig_data"))
            object.rsig_data = $root.MoneroTransactionRsigData.toObject(message.rsig_data, options);
        if (message.is_offloaded_bp != null && message.hasOwnProperty("is_offloaded_bp"))
            object.is_offloaded_bp = message.is_offloaded_bp;
        return object;
    };

    MoneroTransactionSetOutputRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoneroTransactionSetOutputRequest;
})();

$root.MoneroTransactionSetOutputAck = (function() {

    function MoneroTransactionSetOutputAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroTransactionSetOutputAck.prototype.tx_out = $util.newBuffer([]);
    MoneroTransactionSetOutputAck.prototype.vouti_hmac = $util.newBuffer([]);
    MoneroTransactionSetOutputAck.prototype.rsig_data = null;
    MoneroTransactionSetOutputAck.prototype.out_pk = $util.newBuffer([]);
    MoneroTransactionSetOutputAck.prototype.ecdh_info = $util.newBuffer([]);

    MoneroTransactionSetOutputAck.create = function create(properties) {
        return new MoneroTransactionSetOutputAck(properties);
    };

    MoneroTransactionSetOutputAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.tx_out != null && Object.hasOwnProperty.call(message, "tx_out"))
            writer.uint32(10).bytes(message.tx_out);
        if (message.vouti_hmac != null && Object.hasOwnProperty.call(message, "vouti_hmac"))
            writer.uint32(18).bytes(message.vouti_hmac);
        if (message.rsig_data != null && Object.hasOwnProperty.call(message, "rsig_data"))
            $root.MoneroTransactionRsigData.encode(message.rsig_data, writer.uint32(26).fork()).ldelim();
        if (message.out_pk != null && Object.hasOwnProperty.call(message, "out_pk"))
            writer.uint32(34).bytes(message.out_pk);
        if (message.ecdh_info != null && Object.hasOwnProperty.call(message, "ecdh_info"))
            writer.uint32(42).bytes(message.ecdh_info);
        return writer;
    };

    MoneroTransactionSetOutputAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroTransactionSetOutputAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroTransactionSetOutputAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.tx_out = reader.bytes();
                break;
            case 2:
                message.vouti_hmac = reader.bytes();
                break;
            case 3:
                message.rsig_data = $root.MoneroTransactionRsigData.decode(reader, reader.uint32());
                break;
            case 4:
                message.out_pk = reader.bytes();
                break;
            case 5:
                message.ecdh_info = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroTransactionSetOutputAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroTransactionSetOutputAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.tx_out != null && message.hasOwnProperty("tx_out"))
            if (!(message.tx_out && typeof message.tx_out.length === "number" || $util.isString(message.tx_out)))
                return "tx_out: buffer expected";
        if (message.vouti_hmac != null && message.hasOwnProperty("vouti_hmac"))
            if (!(message.vouti_hmac && typeof message.vouti_hmac.length === "number" || $util.isString(message.vouti_hmac)))
                return "vouti_hmac: buffer expected";
        if (message.rsig_data != null && message.hasOwnProperty("rsig_data")) {
            var error = $root.MoneroTransactionRsigData.verify(message.rsig_data);
            if (error)
                return "rsig_data." + error;
        }
        if (message.out_pk != null && message.hasOwnProperty("out_pk"))
            if (!(message.out_pk && typeof message.out_pk.length === "number" || $util.isString(message.out_pk)))
                return "out_pk: buffer expected";
        if (message.ecdh_info != null && message.hasOwnProperty("ecdh_info"))
            if (!(message.ecdh_info && typeof message.ecdh_info.length === "number" || $util.isString(message.ecdh_info)))
                return "ecdh_info: buffer expected";
        return null;
    };

    MoneroTransactionSetOutputAck.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroTransactionSetOutputAck)
            return object;
        var message = new $root.MoneroTransactionSetOutputAck();
        if (object.tx_out != null)
            if (typeof object.tx_out === "string")
                $util.base64.decode(object.tx_out, message.tx_out = $util.newBuffer($util.base64.length(object.tx_out)), 0);
            else if (object.tx_out.length)
                message.tx_out = object.tx_out;
        if (object.vouti_hmac != null)
            if (typeof object.vouti_hmac === "string")
                $util.base64.decode(object.vouti_hmac, message.vouti_hmac = $util.newBuffer($util.base64.length(object.vouti_hmac)), 0);
            else if (object.vouti_hmac.length)
                message.vouti_hmac = object.vouti_hmac;
        if (object.rsig_data != null) {
            if (typeof object.rsig_data !== "object")
                throw TypeError(".MoneroTransactionSetOutputAck.rsig_data: object expected");
            message.rsig_data = $root.MoneroTransactionRsigData.fromObject(object.rsig_data);
        }
        if (object.out_pk != null)
            if (typeof object.out_pk === "string")
                $util.base64.decode(object.out_pk, message.out_pk = $util.newBuffer($util.base64.length(object.out_pk)), 0);
            else if (object.out_pk.length)
                message.out_pk = object.out_pk;
        if (object.ecdh_info != null)
            if (typeof object.ecdh_info === "string")
                $util.base64.decode(object.ecdh_info, message.ecdh_info = $util.newBuffer($util.base64.length(object.ecdh_info)), 0);
            else if (object.ecdh_info.length)
                message.ecdh_info = object.ecdh_info;
        return message;
    };

    MoneroTransactionSetOutputAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.tx_out = "";
            else {
                object.tx_out = [];
                if (options.bytes !== Array)
                    object.tx_out = $util.newBuffer(object.tx_out);
            }
            if (options.bytes === String)
                object.vouti_hmac = "";
            else {
                object.vouti_hmac = [];
                if (options.bytes !== Array)
                    object.vouti_hmac = $util.newBuffer(object.vouti_hmac);
            }
            object.rsig_data = null;
            if (options.bytes === String)
                object.out_pk = "";
            else {
                object.out_pk = [];
                if (options.bytes !== Array)
                    object.out_pk = $util.newBuffer(object.out_pk);
            }
            if (options.bytes === String)
                object.ecdh_info = "";
            else {
                object.ecdh_info = [];
                if (options.bytes !== Array)
                    object.ecdh_info = $util.newBuffer(object.ecdh_info);
            }
        }
        if (message.tx_out != null && message.hasOwnProperty("tx_out"))
            object.tx_out = options.bytes === String ? $util.base64.encode(message.tx_out, 0, message.tx_out.length) : options.bytes === Array ? Array.prototype.slice.call(message.tx_out) : message.tx_out;
        if (message.vouti_hmac != null && message.hasOwnProperty("vouti_hmac"))
            object.vouti_hmac = options.bytes === String ? $util.base64.encode(message.vouti_hmac, 0, message.vouti_hmac.length) : options.bytes === Array ? Array.prototype.slice.call(message.vouti_hmac) : message.vouti_hmac;
        if (message.rsig_data != null && message.hasOwnProperty("rsig_data"))
            object.rsig_data = $root.MoneroTransactionRsigData.toObject(message.rsig_data, options);
        if (message.out_pk != null && message.hasOwnProperty("out_pk"))
            object.out_pk = options.bytes === String ? $util.base64.encode(message.out_pk, 0, message.out_pk.length) : options.bytes === Array ? Array.prototype.slice.call(message.out_pk) : message.out_pk;
        if (message.ecdh_info != null && message.hasOwnProperty("ecdh_info"))
            object.ecdh_info = options.bytes === String ? $util.base64.encode(message.ecdh_info, 0, message.ecdh_info.length) : options.bytes === Array ? Array.prototype.slice.call(message.ecdh_info) : message.ecdh_info;
        return object;
    };

    MoneroTransactionSetOutputAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoneroTransactionSetOutputAck;
})();

$root.MoneroTransactionAllOutSetRequest = (function() {

    function MoneroTransactionAllOutSetRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroTransactionAllOutSetRequest.prototype.rsig_data = null;

    MoneroTransactionAllOutSetRequest.create = function create(properties) {
        return new MoneroTransactionAllOutSetRequest(properties);
    };

    MoneroTransactionAllOutSetRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.rsig_data != null && Object.hasOwnProperty.call(message, "rsig_data"))
            $root.MoneroTransactionRsigData.encode(message.rsig_data, writer.uint32(10).fork()).ldelim();
        return writer;
    };

    MoneroTransactionAllOutSetRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroTransactionAllOutSetRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroTransactionAllOutSetRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.rsig_data = $root.MoneroTransactionRsigData.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroTransactionAllOutSetRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroTransactionAllOutSetRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.rsig_data != null && message.hasOwnProperty("rsig_data")) {
            var error = $root.MoneroTransactionRsigData.verify(message.rsig_data);
            if (error)
                return "rsig_data." + error;
        }
        return null;
    };

    MoneroTransactionAllOutSetRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroTransactionAllOutSetRequest)
            return object;
        var message = new $root.MoneroTransactionAllOutSetRequest();
        if (object.rsig_data != null) {
            if (typeof object.rsig_data !== "object")
                throw TypeError(".MoneroTransactionAllOutSetRequest.rsig_data: object expected");
            message.rsig_data = $root.MoneroTransactionRsigData.fromObject(object.rsig_data);
        }
        return message;
    };

    MoneroTransactionAllOutSetRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.rsig_data = null;
        if (message.rsig_data != null && message.hasOwnProperty("rsig_data"))
            object.rsig_data = $root.MoneroTransactionRsigData.toObject(message.rsig_data, options);
        return object;
    };

    MoneroTransactionAllOutSetRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoneroTransactionAllOutSetRequest;
})();

$root.MoneroTransactionAllOutSetAck = (function() {

    function MoneroTransactionAllOutSetAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroTransactionAllOutSetAck.prototype.extra = $util.newBuffer([]);
    MoneroTransactionAllOutSetAck.prototype.tx_prefix_hash = $util.newBuffer([]);
    MoneroTransactionAllOutSetAck.prototype.rv = null;
    MoneroTransactionAllOutSetAck.prototype.full_message_hash = $util.newBuffer([]);

    MoneroTransactionAllOutSetAck.create = function create(properties) {
        return new MoneroTransactionAllOutSetAck(properties);
    };

    MoneroTransactionAllOutSetAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.extra != null && Object.hasOwnProperty.call(message, "extra"))
            writer.uint32(10).bytes(message.extra);
        if (message.tx_prefix_hash != null && Object.hasOwnProperty.call(message, "tx_prefix_hash"))
            writer.uint32(18).bytes(message.tx_prefix_hash);
        if (message.rv != null && Object.hasOwnProperty.call(message, "rv"))
            $root.MoneroTransactionAllOutSetAck.MoneroRingCtSig.encode(message.rv, writer.uint32(34).fork()).ldelim();
        if (message.full_message_hash != null && Object.hasOwnProperty.call(message, "full_message_hash"))
            writer.uint32(42).bytes(message.full_message_hash);
        return writer;
    };

    MoneroTransactionAllOutSetAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroTransactionAllOutSetAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroTransactionAllOutSetAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.extra = reader.bytes();
                break;
            case 2:
                message.tx_prefix_hash = reader.bytes();
                break;
            case 4:
                message.rv = $root.MoneroTransactionAllOutSetAck.MoneroRingCtSig.decode(reader, reader.uint32());
                break;
            case 5:
                message.full_message_hash = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroTransactionAllOutSetAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroTransactionAllOutSetAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.extra != null && message.hasOwnProperty("extra"))
            if (!(message.extra && typeof message.extra.length === "number" || $util.isString(message.extra)))
                return "extra: buffer expected";
        if (message.tx_prefix_hash != null && message.hasOwnProperty("tx_prefix_hash"))
            if (!(message.tx_prefix_hash && typeof message.tx_prefix_hash.length === "number" || $util.isString(message.tx_prefix_hash)))
                return "tx_prefix_hash: buffer expected";
        if (message.rv != null && message.hasOwnProperty("rv")) {
            var error = $root.MoneroTransactionAllOutSetAck.MoneroRingCtSig.verify(message.rv);
            if (error)
                return "rv." + error;
        }
        if (message.full_message_hash != null && message.hasOwnProperty("full_message_hash"))
            if (!(message.full_message_hash && typeof message.full_message_hash.length === "number" || $util.isString(message.full_message_hash)))
                return "full_message_hash: buffer expected";
        return null;
    };

    MoneroTransactionAllOutSetAck.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroTransactionAllOutSetAck)
            return object;
        var message = new $root.MoneroTransactionAllOutSetAck();
        if (object.extra != null)
            if (typeof object.extra === "string")
                $util.base64.decode(object.extra, message.extra = $util.newBuffer($util.base64.length(object.extra)), 0);
            else if (object.extra.length)
                message.extra = object.extra;
        if (object.tx_prefix_hash != null)
            if (typeof object.tx_prefix_hash === "string")
                $util.base64.decode(object.tx_prefix_hash, message.tx_prefix_hash = $util.newBuffer($util.base64.length(object.tx_prefix_hash)), 0);
            else if (object.tx_prefix_hash.length)
                message.tx_prefix_hash = object.tx_prefix_hash;
        if (object.rv != null) {
            if (typeof object.rv !== "object")
                throw TypeError(".MoneroTransactionAllOutSetAck.rv: object expected");
            message.rv = $root.MoneroTransactionAllOutSetAck.MoneroRingCtSig.fromObject(object.rv);
        }
        if (object.full_message_hash != null)
            if (typeof object.full_message_hash === "string")
                $util.base64.decode(object.full_message_hash, message.full_message_hash = $util.newBuffer($util.base64.length(object.full_message_hash)), 0);
            else if (object.full_message_hash.length)
                message.full_message_hash = object.full_message_hash;
        return message;
    };

    MoneroTransactionAllOutSetAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.extra = "";
            else {
                object.extra = [];
                if (options.bytes !== Array)
                    object.extra = $util.newBuffer(object.extra);
            }
            if (options.bytes === String)
                object.tx_prefix_hash = "";
            else {
                object.tx_prefix_hash = [];
                if (options.bytes !== Array)
                    object.tx_prefix_hash = $util.newBuffer(object.tx_prefix_hash);
            }
            object.rv = null;
            if (options.bytes === String)
                object.full_message_hash = "";
            else {
                object.full_message_hash = [];
                if (options.bytes !== Array)
                    object.full_message_hash = $util.newBuffer(object.full_message_hash);
            }
        }
        if (message.extra != null && message.hasOwnProperty("extra"))
            object.extra = options.bytes === String ? $util.base64.encode(message.extra, 0, message.extra.length) : options.bytes === Array ? Array.prototype.slice.call(message.extra) : message.extra;
        if (message.tx_prefix_hash != null && message.hasOwnProperty("tx_prefix_hash"))
            object.tx_prefix_hash = options.bytes === String ? $util.base64.encode(message.tx_prefix_hash, 0, message.tx_prefix_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.tx_prefix_hash) : message.tx_prefix_hash;
        if (message.rv != null && message.hasOwnProperty("rv"))
            object.rv = $root.MoneroTransactionAllOutSetAck.MoneroRingCtSig.toObject(message.rv, options);
        if (message.full_message_hash != null && message.hasOwnProperty("full_message_hash"))
            object.full_message_hash = options.bytes === String ? $util.base64.encode(message.full_message_hash, 0, message.full_message_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.full_message_hash) : message.full_message_hash;
        return object;
    };

    MoneroTransactionAllOutSetAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    MoneroTransactionAllOutSetAck.MoneroRingCtSig = (function() {

        function MoneroRingCtSig(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        MoneroRingCtSig.prototype.txn_fee = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        MoneroRingCtSig.prototype.message = $util.newBuffer([]);
        MoneroRingCtSig.prototype.rv_type = 0;

        MoneroRingCtSig.create = function create(properties) {
            return new MoneroRingCtSig(properties);
        };

        MoneroRingCtSig.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.txn_fee != null && Object.hasOwnProperty.call(message, "txn_fee"))
                writer.uint32(8).uint64(message.txn_fee);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(18).bytes(message.message);
            if (message.rv_type != null && Object.hasOwnProperty.call(message, "rv_type"))
                writer.uint32(24).uint32(message.rv_type);
            return writer;
        };

        MoneroRingCtSig.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        MoneroRingCtSig.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroTransactionAllOutSetAck.MoneroRingCtSig();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.txn_fee = reader.uint64();
                    break;
                case 2:
                    message.message = reader.bytes();
                    break;
                case 3:
                    message.rv_type = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        MoneroRingCtSig.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        MoneroRingCtSig.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.txn_fee != null && message.hasOwnProperty("txn_fee"))
                if (!$util.isInteger(message.txn_fee) && !(message.txn_fee && $util.isInteger(message.txn_fee.low) && $util.isInteger(message.txn_fee.high)))
                    return "txn_fee: integer|Long expected";
            if (message.message != null && message.hasOwnProperty("message"))
                if (!(message.message && typeof message.message.length === "number" || $util.isString(message.message)))
                    return "message: buffer expected";
            if (message.rv_type != null && message.hasOwnProperty("rv_type"))
                if (!$util.isInteger(message.rv_type))
                    return "rv_type: integer expected";
            return null;
        };

        MoneroRingCtSig.fromObject = function fromObject(object) {
            if (object instanceof $root.MoneroTransactionAllOutSetAck.MoneroRingCtSig)
                return object;
            var message = new $root.MoneroTransactionAllOutSetAck.MoneroRingCtSig();
            if (object.txn_fee != null)
                if ($util.Long)
                    (message.txn_fee = $util.Long.fromValue(object.txn_fee)).unsigned = true;
                else if (typeof object.txn_fee === "string")
                    message.txn_fee = parseInt(object.txn_fee, 10);
                else if (typeof object.txn_fee === "number")
                    message.txn_fee = object.txn_fee;
                else if (typeof object.txn_fee === "object")
                    message.txn_fee = new $util.LongBits(object.txn_fee.low >>> 0, object.txn_fee.high >>> 0).toNumber(true);
            if (object.message != null)
                if (typeof object.message === "string")
                    $util.base64.decode(object.message, message.message = $util.newBuffer($util.base64.length(object.message)), 0);
                else if (object.message.length)
                    message.message = object.message;
            if (object.rv_type != null)
                message.rv_type = object.rv_type >>> 0;
            return message;
        };

        MoneroRingCtSig.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.txn_fee = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.txn_fee = options.longs === String ? "0" : 0;
                if (options.bytes === String)
                    object.message = "";
                else {
                    object.message = [];
                    if (options.bytes !== Array)
                        object.message = $util.newBuffer(object.message);
                }
                object.rv_type = 0;
            }
            if (message.txn_fee != null && message.hasOwnProperty("txn_fee"))
                if (typeof message.txn_fee === "number")
                    object.txn_fee = options.longs === String ? String(message.txn_fee) : message.txn_fee;
                else
                    object.txn_fee = options.longs === String ? $util.Long.prototype.toString.call(message.txn_fee) : options.longs === Number ? new $util.LongBits(message.txn_fee.low >>> 0, message.txn_fee.high >>> 0).toNumber(true) : message.txn_fee;
            if (message.message != null && message.hasOwnProperty("message"))
                object.message = options.bytes === String ? $util.base64.encode(message.message, 0, message.message.length) : options.bytes === Array ? Array.prototype.slice.call(message.message) : message.message;
            if (message.rv_type != null && message.hasOwnProperty("rv_type"))
                object.rv_type = message.rv_type;
            return object;
        };

        MoneroRingCtSig.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return MoneroRingCtSig;
    })();

    return MoneroTransactionAllOutSetAck;
})();

$root.MoneroTransactionSignInputRequest = (function() {

    function MoneroTransactionSignInputRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroTransactionSignInputRequest.prototype.src_entr = null;
    MoneroTransactionSignInputRequest.prototype.vini = $util.newBuffer([]);
    MoneroTransactionSignInputRequest.prototype.vini_hmac = $util.newBuffer([]);
    MoneroTransactionSignInputRequest.prototype.pseudo_out = $util.newBuffer([]);
    MoneroTransactionSignInputRequest.prototype.pseudo_out_hmac = $util.newBuffer([]);
    MoneroTransactionSignInputRequest.prototype.pseudo_out_alpha = $util.newBuffer([]);
    MoneroTransactionSignInputRequest.prototype.spend_key = $util.newBuffer([]);
    MoneroTransactionSignInputRequest.prototype.orig_idx = 0;

    MoneroTransactionSignInputRequest.create = function create(properties) {
        return new MoneroTransactionSignInputRequest(properties);
    };

    MoneroTransactionSignInputRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.src_entr != null && Object.hasOwnProperty.call(message, "src_entr"))
            $root.MoneroTransactionSourceEntry.encode(message.src_entr, writer.uint32(10).fork()).ldelim();
        if (message.vini != null && Object.hasOwnProperty.call(message, "vini"))
            writer.uint32(18).bytes(message.vini);
        if (message.vini_hmac != null && Object.hasOwnProperty.call(message, "vini_hmac"))
            writer.uint32(26).bytes(message.vini_hmac);
        if (message.pseudo_out != null && Object.hasOwnProperty.call(message, "pseudo_out"))
            writer.uint32(34).bytes(message.pseudo_out);
        if (message.pseudo_out_hmac != null && Object.hasOwnProperty.call(message, "pseudo_out_hmac"))
            writer.uint32(42).bytes(message.pseudo_out_hmac);
        if (message.pseudo_out_alpha != null && Object.hasOwnProperty.call(message, "pseudo_out_alpha"))
            writer.uint32(50).bytes(message.pseudo_out_alpha);
        if (message.spend_key != null && Object.hasOwnProperty.call(message, "spend_key"))
            writer.uint32(58).bytes(message.spend_key);
        if (message.orig_idx != null && Object.hasOwnProperty.call(message, "orig_idx"))
            writer.uint32(64).uint32(message.orig_idx);
        return writer;
    };

    MoneroTransactionSignInputRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroTransactionSignInputRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroTransactionSignInputRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.src_entr = $root.MoneroTransactionSourceEntry.decode(reader, reader.uint32());
                break;
            case 2:
                message.vini = reader.bytes();
                break;
            case 3:
                message.vini_hmac = reader.bytes();
                break;
            case 4:
                message.pseudo_out = reader.bytes();
                break;
            case 5:
                message.pseudo_out_hmac = reader.bytes();
                break;
            case 6:
                message.pseudo_out_alpha = reader.bytes();
                break;
            case 7:
                message.spend_key = reader.bytes();
                break;
            case 8:
                message.orig_idx = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroTransactionSignInputRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroTransactionSignInputRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.src_entr != null && message.hasOwnProperty("src_entr")) {
            var error = $root.MoneroTransactionSourceEntry.verify(message.src_entr);
            if (error)
                return "src_entr." + error;
        }
        if (message.vini != null && message.hasOwnProperty("vini"))
            if (!(message.vini && typeof message.vini.length === "number" || $util.isString(message.vini)))
                return "vini: buffer expected";
        if (message.vini_hmac != null && message.hasOwnProperty("vini_hmac"))
            if (!(message.vini_hmac && typeof message.vini_hmac.length === "number" || $util.isString(message.vini_hmac)))
                return "vini_hmac: buffer expected";
        if (message.pseudo_out != null && message.hasOwnProperty("pseudo_out"))
            if (!(message.pseudo_out && typeof message.pseudo_out.length === "number" || $util.isString(message.pseudo_out)))
                return "pseudo_out: buffer expected";
        if (message.pseudo_out_hmac != null && message.hasOwnProperty("pseudo_out_hmac"))
            if (!(message.pseudo_out_hmac && typeof message.pseudo_out_hmac.length === "number" || $util.isString(message.pseudo_out_hmac)))
                return "pseudo_out_hmac: buffer expected";
        if (message.pseudo_out_alpha != null && message.hasOwnProperty("pseudo_out_alpha"))
            if (!(message.pseudo_out_alpha && typeof message.pseudo_out_alpha.length === "number" || $util.isString(message.pseudo_out_alpha)))
                return "pseudo_out_alpha: buffer expected";
        if (message.spend_key != null && message.hasOwnProperty("spend_key"))
            if (!(message.spend_key && typeof message.spend_key.length === "number" || $util.isString(message.spend_key)))
                return "spend_key: buffer expected";
        if (message.orig_idx != null && message.hasOwnProperty("orig_idx"))
            if (!$util.isInteger(message.orig_idx))
                return "orig_idx: integer expected";
        return null;
    };

    MoneroTransactionSignInputRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroTransactionSignInputRequest)
            return object;
        var message = new $root.MoneroTransactionSignInputRequest();
        if (object.src_entr != null) {
            if (typeof object.src_entr !== "object")
                throw TypeError(".MoneroTransactionSignInputRequest.src_entr: object expected");
            message.src_entr = $root.MoneroTransactionSourceEntry.fromObject(object.src_entr);
        }
        if (object.vini != null)
            if (typeof object.vini === "string")
                $util.base64.decode(object.vini, message.vini = $util.newBuffer($util.base64.length(object.vini)), 0);
            else if (object.vini.length)
                message.vini = object.vini;
        if (object.vini_hmac != null)
            if (typeof object.vini_hmac === "string")
                $util.base64.decode(object.vini_hmac, message.vini_hmac = $util.newBuffer($util.base64.length(object.vini_hmac)), 0);
            else if (object.vini_hmac.length)
                message.vini_hmac = object.vini_hmac;
        if (object.pseudo_out != null)
            if (typeof object.pseudo_out === "string")
                $util.base64.decode(object.pseudo_out, message.pseudo_out = $util.newBuffer($util.base64.length(object.pseudo_out)), 0);
            else if (object.pseudo_out.length)
                message.pseudo_out = object.pseudo_out;
        if (object.pseudo_out_hmac != null)
            if (typeof object.pseudo_out_hmac === "string")
                $util.base64.decode(object.pseudo_out_hmac, message.pseudo_out_hmac = $util.newBuffer($util.base64.length(object.pseudo_out_hmac)), 0);
            else if (object.pseudo_out_hmac.length)
                message.pseudo_out_hmac = object.pseudo_out_hmac;
        if (object.pseudo_out_alpha != null)
            if (typeof object.pseudo_out_alpha === "string")
                $util.base64.decode(object.pseudo_out_alpha, message.pseudo_out_alpha = $util.newBuffer($util.base64.length(object.pseudo_out_alpha)), 0);
            else if (object.pseudo_out_alpha.length)
                message.pseudo_out_alpha = object.pseudo_out_alpha;
        if (object.spend_key != null)
            if (typeof object.spend_key === "string")
                $util.base64.decode(object.spend_key, message.spend_key = $util.newBuffer($util.base64.length(object.spend_key)), 0);
            else if (object.spend_key.length)
                message.spend_key = object.spend_key;
        if (object.orig_idx != null)
            message.orig_idx = object.orig_idx >>> 0;
        return message;
    };

    MoneroTransactionSignInputRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.src_entr = null;
            if (options.bytes === String)
                object.vini = "";
            else {
                object.vini = [];
                if (options.bytes !== Array)
                    object.vini = $util.newBuffer(object.vini);
            }
            if (options.bytes === String)
                object.vini_hmac = "";
            else {
                object.vini_hmac = [];
                if (options.bytes !== Array)
                    object.vini_hmac = $util.newBuffer(object.vini_hmac);
            }
            if (options.bytes === String)
                object.pseudo_out = "";
            else {
                object.pseudo_out = [];
                if (options.bytes !== Array)
                    object.pseudo_out = $util.newBuffer(object.pseudo_out);
            }
            if (options.bytes === String)
                object.pseudo_out_hmac = "";
            else {
                object.pseudo_out_hmac = [];
                if (options.bytes !== Array)
                    object.pseudo_out_hmac = $util.newBuffer(object.pseudo_out_hmac);
            }
            if (options.bytes === String)
                object.pseudo_out_alpha = "";
            else {
                object.pseudo_out_alpha = [];
                if (options.bytes !== Array)
                    object.pseudo_out_alpha = $util.newBuffer(object.pseudo_out_alpha);
            }
            if (options.bytes === String)
                object.spend_key = "";
            else {
                object.spend_key = [];
                if (options.bytes !== Array)
                    object.spend_key = $util.newBuffer(object.spend_key);
            }
            object.orig_idx = 0;
        }
        if (message.src_entr != null && message.hasOwnProperty("src_entr"))
            object.src_entr = $root.MoneroTransactionSourceEntry.toObject(message.src_entr, options);
        if (message.vini != null && message.hasOwnProperty("vini"))
            object.vini = options.bytes === String ? $util.base64.encode(message.vini, 0, message.vini.length) : options.bytes === Array ? Array.prototype.slice.call(message.vini) : message.vini;
        if (message.vini_hmac != null && message.hasOwnProperty("vini_hmac"))
            object.vini_hmac = options.bytes === String ? $util.base64.encode(message.vini_hmac, 0, message.vini_hmac.length) : options.bytes === Array ? Array.prototype.slice.call(message.vini_hmac) : message.vini_hmac;
        if (message.pseudo_out != null && message.hasOwnProperty("pseudo_out"))
            object.pseudo_out = options.bytes === String ? $util.base64.encode(message.pseudo_out, 0, message.pseudo_out.length) : options.bytes === Array ? Array.prototype.slice.call(message.pseudo_out) : message.pseudo_out;
        if (message.pseudo_out_hmac != null && message.hasOwnProperty("pseudo_out_hmac"))
            object.pseudo_out_hmac = options.bytes === String ? $util.base64.encode(message.pseudo_out_hmac, 0, message.pseudo_out_hmac.length) : options.bytes === Array ? Array.prototype.slice.call(message.pseudo_out_hmac) : message.pseudo_out_hmac;
        if (message.pseudo_out_alpha != null && message.hasOwnProperty("pseudo_out_alpha"))
            object.pseudo_out_alpha = options.bytes === String ? $util.base64.encode(message.pseudo_out_alpha, 0, message.pseudo_out_alpha.length) : options.bytes === Array ? Array.prototype.slice.call(message.pseudo_out_alpha) : message.pseudo_out_alpha;
        if (message.spend_key != null && message.hasOwnProperty("spend_key"))
            object.spend_key = options.bytes === String ? $util.base64.encode(message.spend_key, 0, message.spend_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.spend_key) : message.spend_key;
        if (message.orig_idx != null && message.hasOwnProperty("orig_idx"))
            object.orig_idx = message.orig_idx;
        return object;
    };

    MoneroTransactionSignInputRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoneroTransactionSignInputRequest;
})();

$root.MoneroTransactionSignInputAck = (function() {

    function MoneroTransactionSignInputAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroTransactionSignInputAck.prototype.signature = $util.newBuffer([]);
    MoneroTransactionSignInputAck.prototype.pseudo_out = $util.newBuffer([]);

    MoneroTransactionSignInputAck.create = function create(properties) {
        return new MoneroTransactionSignInputAck(properties);
    };

    MoneroTransactionSignInputAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.signature != null && Object.hasOwnProperty.call(message, "signature"))
            writer.uint32(10).bytes(message.signature);
        if (message.pseudo_out != null && Object.hasOwnProperty.call(message, "pseudo_out"))
            writer.uint32(18).bytes(message.pseudo_out);
        return writer;
    };

    MoneroTransactionSignInputAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroTransactionSignInputAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroTransactionSignInputAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.signature = reader.bytes();
                break;
            case 2:
                message.pseudo_out = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroTransactionSignInputAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroTransactionSignInputAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.signature != null && message.hasOwnProperty("signature"))
            if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
                return "signature: buffer expected";
        if (message.pseudo_out != null && message.hasOwnProperty("pseudo_out"))
            if (!(message.pseudo_out && typeof message.pseudo_out.length === "number" || $util.isString(message.pseudo_out)))
                return "pseudo_out: buffer expected";
        return null;
    };

    MoneroTransactionSignInputAck.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroTransactionSignInputAck)
            return object;
        var message = new $root.MoneroTransactionSignInputAck();
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        if (object.pseudo_out != null)
            if (typeof object.pseudo_out === "string")
                $util.base64.decode(object.pseudo_out, message.pseudo_out = $util.newBuffer($util.base64.length(object.pseudo_out)), 0);
            else if (object.pseudo_out.length)
                message.pseudo_out = object.pseudo_out;
        return message;
    };

    MoneroTransactionSignInputAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
            if (options.bytes === String)
                object.pseudo_out = "";
            else {
                object.pseudo_out = [];
                if (options.bytes !== Array)
                    object.pseudo_out = $util.newBuffer(object.pseudo_out);
            }
        }
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        if (message.pseudo_out != null && message.hasOwnProperty("pseudo_out"))
            object.pseudo_out = options.bytes === String ? $util.base64.encode(message.pseudo_out, 0, message.pseudo_out.length) : options.bytes === Array ? Array.prototype.slice.call(message.pseudo_out) : message.pseudo_out;
        return object;
    };

    MoneroTransactionSignInputAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoneroTransactionSignInputAck;
})();

$root.MoneroTransactionFinalRequest = (function() {

    function MoneroTransactionFinalRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroTransactionFinalRequest.create = function create(properties) {
        return new MoneroTransactionFinalRequest(properties);
    };

    MoneroTransactionFinalRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    MoneroTransactionFinalRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroTransactionFinalRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroTransactionFinalRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroTransactionFinalRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroTransactionFinalRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    MoneroTransactionFinalRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroTransactionFinalRequest)
            return object;
        return new $root.MoneroTransactionFinalRequest();
    };

    MoneroTransactionFinalRequest.toObject = function toObject() {
        return {};
    };

    MoneroTransactionFinalRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoneroTransactionFinalRequest;
})();

$root.MoneroTransactionFinalAck = (function() {

    function MoneroTransactionFinalAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroTransactionFinalAck.prototype.cout_key = $util.newBuffer([]);
    MoneroTransactionFinalAck.prototype.salt = $util.newBuffer([]);
    MoneroTransactionFinalAck.prototype.rand_mult = $util.newBuffer([]);
    MoneroTransactionFinalAck.prototype.tx_enc_keys = $util.newBuffer([]);
    MoneroTransactionFinalAck.prototype.opening_key = $util.newBuffer([]);

    MoneroTransactionFinalAck.create = function create(properties) {
        return new MoneroTransactionFinalAck(properties);
    };

    MoneroTransactionFinalAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.cout_key != null && Object.hasOwnProperty.call(message, "cout_key"))
            writer.uint32(10).bytes(message.cout_key);
        if (message.salt != null && Object.hasOwnProperty.call(message, "salt"))
            writer.uint32(18).bytes(message.salt);
        if (message.rand_mult != null && Object.hasOwnProperty.call(message, "rand_mult"))
            writer.uint32(26).bytes(message.rand_mult);
        if (message.tx_enc_keys != null && Object.hasOwnProperty.call(message, "tx_enc_keys"))
            writer.uint32(34).bytes(message.tx_enc_keys);
        if (message.opening_key != null && Object.hasOwnProperty.call(message, "opening_key"))
            writer.uint32(42).bytes(message.opening_key);
        return writer;
    };

    MoneroTransactionFinalAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroTransactionFinalAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroTransactionFinalAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.cout_key = reader.bytes();
                break;
            case 2:
                message.salt = reader.bytes();
                break;
            case 3:
                message.rand_mult = reader.bytes();
                break;
            case 4:
                message.tx_enc_keys = reader.bytes();
                break;
            case 5:
                message.opening_key = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroTransactionFinalAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroTransactionFinalAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.cout_key != null && message.hasOwnProperty("cout_key"))
            if (!(message.cout_key && typeof message.cout_key.length === "number" || $util.isString(message.cout_key)))
                return "cout_key: buffer expected";
        if (message.salt != null && message.hasOwnProperty("salt"))
            if (!(message.salt && typeof message.salt.length === "number" || $util.isString(message.salt)))
                return "salt: buffer expected";
        if (message.rand_mult != null && message.hasOwnProperty("rand_mult"))
            if (!(message.rand_mult && typeof message.rand_mult.length === "number" || $util.isString(message.rand_mult)))
                return "rand_mult: buffer expected";
        if (message.tx_enc_keys != null && message.hasOwnProperty("tx_enc_keys"))
            if (!(message.tx_enc_keys && typeof message.tx_enc_keys.length === "number" || $util.isString(message.tx_enc_keys)))
                return "tx_enc_keys: buffer expected";
        if (message.opening_key != null && message.hasOwnProperty("opening_key"))
            if (!(message.opening_key && typeof message.opening_key.length === "number" || $util.isString(message.opening_key)))
                return "opening_key: buffer expected";
        return null;
    };

    MoneroTransactionFinalAck.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroTransactionFinalAck)
            return object;
        var message = new $root.MoneroTransactionFinalAck();
        if (object.cout_key != null)
            if (typeof object.cout_key === "string")
                $util.base64.decode(object.cout_key, message.cout_key = $util.newBuffer($util.base64.length(object.cout_key)), 0);
            else if (object.cout_key.length)
                message.cout_key = object.cout_key;
        if (object.salt != null)
            if (typeof object.salt === "string")
                $util.base64.decode(object.salt, message.salt = $util.newBuffer($util.base64.length(object.salt)), 0);
            else if (object.salt.length)
                message.salt = object.salt;
        if (object.rand_mult != null)
            if (typeof object.rand_mult === "string")
                $util.base64.decode(object.rand_mult, message.rand_mult = $util.newBuffer($util.base64.length(object.rand_mult)), 0);
            else if (object.rand_mult.length)
                message.rand_mult = object.rand_mult;
        if (object.tx_enc_keys != null)
            if (typeof object.tx_enc_keys === "string")
                $util.base64.decode(object.tx_enc_keys, message.tx_enc_keys = $util.newBuffer($util.base64.length(object.tx_enc_keys)), 0);
            else if (object.tx_enc_keys.length)
                message.tx_enc_keys = object.tx_enc_keys;
        if (object.opening_key != null)
            if (typeof object.opening_key === "string")
                $util.base64.decode(object.opening_key, message.opening_key = $util.newBuffer($util.base64.length(object.opening_key)), 0);
            else if (object.opening_key.length)
                message.opening_key = object.opening_key;
        return message;
    };

    MoneroTransactionFinalAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.cout_key = "";
            else {
                object.cout_key = [];
                if (options.bytes !== Array)
                    object.cout_key = $util.newBuffer(object.cout_key);
            }
            if (options.bytes === String)
                object.salt = "";
            else {
                object.salt = [];
                if (options.bytes !== Array)
                    object.salt = $util.newBuffer(object.salt);
            }
            if (options.bytes === String)
                object.rand_mult = "";
            else {
                object.rand_mult = [];
                if (options.bytes !== Array)
                    object.rand_mult = $util.newBuffer(object.rand_mult);
            }
            if (options.bytes === String)
                object.tx_enc_keys = "";
            else {
                object.tx_enc_keys = [];
                if (options.bytes !== Array)
                    object.tx_enc_keys = $util.newBuffer(object.tx_enc_keys);
            }
            if (options.bytes === String)
                object.opening_key = "";
            else {
                object.opening_key = [];
                if (options.bytes !== Array)
                    object.opening_key = $util.newBuffer(object.opening_key);
            }
        }
        if (message.cout_key != null && message.hasOwnProperty("cout_key"))
            object.cout_key = options.bytes === String ? $util.base64.encode(message.cout_key, 0, message.cout_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.cout_key) : message.cout_key;
        if (message.salt != null && message.hasOwnProperty("salt"))
            object.salt = options.bytes === String ? $util.base64.encode(message.salt, 0, message.salt.length) : options.bytes === Array ? Array.prototype.slice.call(message.salt) : message.salt;
        if (message.rand_mult != null && message.hasOwnProperty("rand_mult"))
            object.rand_mult = options.bytes === String ? $util.base64.encode(message.rand_mult, 0, message.rand_mult.length) : options.bytes === Array ? Array.prototype.slice.call(message.rand_mult) : message.rand_mult;
        if (message.tx_enc_keys != null && message.hasOwnProperty("tx_enc_keys"))
            object.tx_enc_keys = options.bytes === String ? $util.base64.encode(message.tx_enc_keys, 0, message.tx_enc_keys.length) : options.bytes === Array ? Array.prototype.slice.call(message.tx_enc_keys) : message.tx_enc_keys;
        if (message.opening_key != null && message.hasOwnProperty("opening_key"))
            object.opening_key = options.bytes === String ? $util.base64.encode(message.opening_key, 0, message.opening_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.opening_key) : message.opening_key;
        return object;
    };

    MoneroTransactionFinalAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoneroTransactionFinalAck;
})();

$root.MoneroKeyImageExportInitRequest = (function() {

    function MoneroKeyImageExportInitRequest(properties) {
        this.address_n = [];
        this.subs = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroKeyImageExportInitRequest.prototype.num = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    MoneroKeyImageExportInitRequest.prototype.hash = $util.newBuffer([]);
    MoneroKeyImageExportInitRequest.prototype.address_n = $util.emptyArray;
    MoneroKeyImageExportInitRequest.prototype.network_type = 0;
    MoneroKeyImageExportInitRequest.prototype.subs = $util.emptyArray;

    MoneroKeyImageExportInitRequest.create = function create(properties) {
        return new MoneroKeyImageExportInitRequest(properties);
    };

    MoneroKeyImageExportInitRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).uint64(message.num);
        writer.uint32(18).bytes(message.hash);
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(24).uint32(message.address_n[i]);
        if (message.network_type != null && Object.hasOwnProperty.call(message, "network_type"))
            writer.uint32(32).int32(message.network_type);
        if (message.subs != null && message.subs.length)
            for (var i = 0; i < message.subs.length; ++i)
                $root.MoneroKeyImageExportInitRequest.MoneroSubAddressIndicesList.encode(message.subs[i], writer.uint32(42).fork()).ldelim();
        return writer;
    };

    MoneroKeyImageExportInitRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroKeyImageExportInitRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroKeyImageExportInitRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.num = reader.uint64();
                break;
            case 2:
                message.hash = reader.bytes();
                break;
            case 3:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 4:
                message.network_type = reader.int32();
                break;
            case 5:
                if (!(message.subs && message.subs.length))
                    message.subs = [];
                message.subs.push($root.MoneroKeyImageExportInitRequest.MoneroSubAddressIndicesList.decode(reader, reader.uint32()));
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("num"))
            throw $util.ProtocolError("missing required 'num'", { instance: message });
        if (!message.hasOwnProperty("hash"))
            throw $util.ProtocolError("missing required 'hash'", { instance: message });
        return message;
    };

    MoneroKeyImageExportInitRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroKeyImageExportInitRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isInteger(message.num) && !(message.num && $util.isInteger(message.num.low) && $util.isInteger(message.num.high)))
            return "num: integer|Long expected";
        if (!(message.hash && typeof message.hash.length === "number" || $util.isString(message.hash)))
            return "hash: buffer expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.network_type != null && message.hasOwnProperty("network_type"))
            switch (message.network_type) {
            default:
                return "network_type: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
                break;
            }
        if (message.subs != null && message.hasOwnProperty("subs")) {
            if (!Array.isArray(message.subs))
                return "subs: array expected";
            for (var i = 0; i < message.subs.length; ++i) {
                var error = $root.MoneroKeyImageExportInitRequest.MoneroSubAddressIndicesList.verify(message.subs[i]);
                if (error)
                    return "subs." + error;
            }
        }
        return null;
    };

    MoneroKeyImageExportInitRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroKeyImageExportInitRequest)
            return object;
        var message = new $root.MoneroKeyImageExportInitRequest();
        if (object.num != null)
            if ($util.Long)
                (message.num = $util.Long.fromValue(object.num)).unsigned = true;
            else if (typeof object.num === "string")
                message.num = parseInt(object.num, 10);
            else if (typeof object.num === "number")
                message.num = object.num;
            else if (typeof object.num === "object")
                message.num = new $util.LongBits(object.num.low >>> 0, object.num.high >>> 0).toNumber(true);
        if (object.hash != null)
            if (typeof object.hash === "string")
                $util.base64.decode(object.hash, message.hash = $util.newBuffer($util.base64.length(object.hash)), 0);
            else if (object.hash.length)
                message.hash = object.hash;
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".MoneroKeyImageExportInitRequest.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        switch (object.network_type) {
        case "MAINNET":
        case 0:
            message.network_type = 0;
            break;
        case "TESTNET":
        case 1:
            message.network_type = 1;
            break;
        case "STAGENET":
        case 2:
            message.network_type = 2;
            break;
        case "FAKECHAIN":
        case 3:
            message.network_type = 3;
            break;
        }
        if (object.subs) {
            if (!Array.isArray(object.subs))
                throw TypeError(".MoneroKeyImageExportInitRequest.subs: array expected");
            message.subs = [];
            for (var i = 0; i < object.subs.length; ++i) {
                if (typeof object.subs[i] !== "object")
                    throw TypeError(".MoneroKeyImageExportInitRequest.subs: object expected");
                message.subs[i] = $root.MoneroKeyImageExportInitRequest.MoneroSubAddressIndicesList.fromObject(object.subs[i]);
            }
        }
        return message;
    };

    MoneroKeyImageExportInitRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults) {
            object.address_n = [];
            object.subs = [];
        }
        if (options.defaults) {
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.num = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.num = options.longs === String ? "0" : 0;
            if (options.bytes === String)
                object.hash = "";
            else {
                object.hash = [];
                if (options.bytes !== Array)
                    object.hash = $util.newBuffer(object.hash);
            }
            object.network_type = options.enums === String ? "MAINNET" : 0;
        }
        if (message.num != null && message.hasOwnProperty("num"))
            if (typeof message.num === "number")
                object.num = options.longs === String ? String(message.num) : message.num;
            else
                object.num = options.longs === String ? $util.Long.prototype.toString.call(message.num) : options.longs === Number ? new $util.LongBits(message.num.low >>> 0, message.num.high >>> 0).toNumber(true) : message.num;
        if (message.hash != null && message.hasOwnProperty("hash"))
            object.hash = options.bytes === String ? $util.base64.encode(message.hash, 0, message.hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.hash) : message.hash;
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.network_type != null && message.hasOwnProperty("network_type"))
            object.network_type = options.enums === String ? $root.MoneroNetworkType[message.network_type] : message.network_type;
        if (message.subs && message.subs.length) {
            object.subs = [];
            for (var j = 0; j < message.subs.length; ++j)
                object.subs[j] = $root.MoneroKeyImageExportInitRequest.MoneroSubAddressIndicesList.toObject(message.subs[j], options);
        }
        return object;
    };

    MoneroKeyImageExportInitRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    MoneroKeyImageExportInitRequest.MoneroSubAddressIndicesList = (function() {

        function MoneroSubAddressIndicesList(properties) {
            this.minor_indices = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        MoneroSubAddressIndicesList.prototype.account = 0;
        MoneroSubAddressIndicesList.prototype.minor_indices = $util.emptyArray;

        MoneroSubAddressIndicesList.create = function create(properties) {
            return new MoneroSubAddressIndicesList(properties);
        };

        MoneroSubAddressIndicesList.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(8).uint32(message.account);
            if (message.minor_indices != null && message.minor_indices.length)
                for (var i = 0; i < message.minor_indices.length; ++i)
                    writer.uint32(16).uint32(message.minor_indices[i]);
            return writer;
        };

        MoneroSubAddressIndicesList.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        MoneroSubAddressIndicesList.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroKeyImageExportInitRequest.MoneroSubAddressIndicesList();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.account = reader.uint32();
                    break;
                case 2:
                    if (!(message.minor_indices && message.minor_indices.length))
                        message.minor_indices = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.minor_indices.push(reader.uint32());
                    } else
                        message.minor_indices.push(reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("account"))
                throw $util.ProtocolError("missing required 'account'", { instance: message });
            return message;
        };

        MoneroSubAddressIndicesList.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        MoneroSubAddressIndicesList.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isInteger(message.account))
                return "account: integer expected";
            if (message.minor_indices != null && message.hasOwnProperty("minor_indices")) {
                if (!Array.isArray(message.minor_indices))
                    return "minor_indices: array expected";
                for (var i = 0; i < message.minor_indices.length; ++i)
                    if (!$util.isInteger(message.minor_indices[i]))
                        return "minor_indices: integer[] expected";
            }
            return null;
        };

        MoneroSubAddressIndicesList.fromObject = function fromObject(object) {
            if (object instanceof $root.MoneroKeyImageExportInitRequest.MoneroSubAddressIndicesList)
                return object;
            var message = new $root.MoneroKeyImageExportInitRequest.MoneroSubAddressIndicesList();
            if (object.account != null)
                message.account = object.account >>> 0;
            if (object.minor_indices) {
                if (!Array.isArray(object.minor_indices))
                    throw TypeError(".MoneroKeyImageExportInitRequest.MoneroSubAddressIndicesList.minor_indices: array expected");
                message.minor_indices = [];
                for (var i = 0; i < object.minor_indices.length; ++i)
                    message.minor_indices[i] = object.minor_indices[i] >>> 0;
            }
            return message;
        };

        MoneroSubAddressIndicesList.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.minor_indices = [];
            if (options.defaults)
                object.account = 0;
            if (message.account != null && message.hasOwnProperty("account"))
                object.account = message.account;
            if (message.minor_indices && message.minor_indices.length) {
                object.minor_indices = [];
                for (var j = 0; j < message.minor_indices.length; ++j)
                    object.minor_indices[j] = message.minor_indices[j];
            }
            return object;
        };

        MoneroSubAddressIndicesList.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return MoneroSubAddressIndicesList;
    })();

    return MoneroKeyImageExportInitRequest;
})();

$root.MoneroKeyImageExportInitAck = (function() {

    function MoneroKeyImageExportInitAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroKeyImageExportInitAck.create = function create(properties) {
        return new MoneroKeyImageExportInitAck(properties);
    };

    MoneroKeyImageExportInitAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    MoneroKeyImageExportInitAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroKeyImageExportInitAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroKeyImageExportInitAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroKeyImageExportInitAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroKeyImageExportInitAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    MoneroKeyImageExportInitAck.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroKeyImageExportInitAck)
            return object;
        return new $root.MoneroKeyImageExportInitAck();
    };

    MoneroKeyImageExportInitAck.toObject = function toObject() {
        return {};
    };

    MoneroKeyImageExportInitAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoneroKeyImageExportInitAck;
})();

$root.MoneroKeyImageSyncStepRequest = (function() {

    function MoneroKeyImageSyncStepRequest(properties) {
        this.tdis = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroKeyImageSyncStepRequest.prototype.tdis = $util.emptyArray;

    MoneroKeyImageSyncStepRequest.create = function create(properties) {
        return new MoneroKeyImageSyncStepRequest(properties);
    };

    MoneroKeyImageSyncStepRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.tdis != null && message.tdis.length)
            for (var i = 0; i < message.tdis.length; ++i)
                $root.MoneroKeyImageSyncStepRequest.MoneroTransferDetails.encode(message.tdis[i], writer.uint32(10).fork()).ldelim();
        return writer;
    };

    MoneroKeyImageSyncStepRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroKeyImageSyncStepRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroKeyImageSyncStepRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.tdis && message.tdis.length))
                    message.tdis = [];
                message.tdis.push($root.MoneroKeyImageSyncStepRequest.MoneroTransferDetails.decode(reader, reader.uint32()));
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroKeyImageSyncStepRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroKeyImageSyncStepRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.tdis != null && message.hasOwnProperty("tdis")) {
            if (!Array.isArray(message.tdis))
                return "tdis: array expected";
            for (var i = 0; i < message.tdis.length; ++i) {
                var error = $root.MoneroKeyImageSyncStepRequest.MoneroTransferDetails.verify(message.tdis[i]);
                if (error)
                    return "tdis." + error;
            }
        }
        return null;
    };

    MoneroKeyImageSyncStepRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroKeyImageSyncStepRequest)
            return object;
        var message = new $root.MoneroKeyImageSyncStepRequest();
        if (object.tdis) {
            if (!Array.isArray(object.tdis))
                throw TypeError(".MoneroKeyImageSyncStepRequest.tdis: array expected");
            message.tdis = [];
            for (var i = 0; i < object.tdis.length; ++i) {
                if (typeof object.tdis[i] !== "object")
                    throw TypeError(".MoneroKeyImageSyncStepRequest.tdis: object expected");
                message.tdis[i] = $root.MoneroKeyImageSyncStepRequest.MoneroTransferDetails.fromObject(object.tdis[i]);
            }
        }
        return message;
    };

    MoneroKeyImageSyncStepRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.tdis = [];
        if (message.tdis && message.tdis.length) {
            object.tdis = [];
            for (var j = 0; j < message.tdis.length; ++j)
                object.tdis[j] = $root.MoneroKeyImageSyncStepRequest.MoneroTransferDetails.toObject(message.tdis[j], options);
        }
        return object;
    };

    MoneroKeyImageSyncStepRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    MoneroKeyImageSyncStepRequest.MoneroTransferDetails = (function() {

        function MoneroTransferDetails(properties) {
            this.additional_tx_pub_keys = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        MoneroTransferDetails.prototype.out_key = $util.newBuffer([]);
        MoneroTransferDetails.prototype.tx_pub_key = $util.newBuffer([]);
        MoneroTransferDetails.prototype.additional_tx_pub_keys = $util.emptyArray;
        MoneroTransferDetails.prototype.internal_output_index = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        MoneroTransferDetails.prototype.sub_addr_major = 0;
        MoneroTransferDetails.prototype.sub_addr_minor = 0;

        MoneroTransferDetails.create = function create(properties) {
            return new MoneroTransferDetails(properties);
        };

        MoneroTransferDetails.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(10).bytes(message.out_key);
            writer.uint32(18).bytes(message.tx_pub_key);
            if (message.additional_tx_pub_keys != null && message.additional_tx_pub_keys.length)
                for (var i = 0; i < message.additional_tx_pub_keys.length; ++i)
                    writer.uint32(26).bytes(message.additional_tx_pub_keys[i]);
            writer.uint32(32).uint64(message.internal_output_index);
            if (message.sub_addr_major != null && Object.hasOwnProperty.call(message, "sub_addr_major"))
                writer.uint32(40).uint32(message.sub_addr_major);
            if (message.sub_addr_minor != null && Object.hasOwnProperty.call(message, "sub_addr_minor"))
                writer.uint32(48).uint32(message.sub_addr_minor);
            return writer;
        };

        MoneroTransferDetails.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        MoneroTransferDetails.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroKeyImageSyncStepRequest.MoneroTransferDetails();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.out_key = reader.bytes();
                    break;
                case 2:
                    message.tx_pub_key = reader.bytes();
                    break;
                case 3:
                    if (!(message.additional_tx_pub_keys && message.additional_tx_pub_keys.length))
                        message.additional_tx_pub_keys = [];
                    message.additional_tx_pub_keys.push(reader.bytes());
                    break;
                case 4:
                    message.internal_output_index = reader.uint64();
                    break;
                case 5:
                    message.sub_addr_major = reader.uint32();
                    break;
                case 6:
                    message.sub_addr_minor = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("out_key"))
                throw $util.ProtocolError("missing required 'out_key'", { instance: message });
            if (!message.hasOwnProperty("tx_pub_key"))
                throw $util.ProtocolError("missing required 'tx_pub_key'", { instance: message });
            if (!message.hasOwnProperty("internal_output_index"))
                throw $util.ProtocolError("missing required 'internal_output_index'", { instance: message });
            return message;
        };

        MoneroTransferDetails.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        MoneroTransferDetails.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!(message.out_key && typeof message.out_key.length === "number" || $util.isString(message.out_key)))
                return "out_key: buffer expected";
            if (!(message.tx_pub_key && typeof message.tx_pub_key.length === "number" || $util.isString(message.tx_pub_key)))
                return "tx_pub_key: buffer expected";
            if (message.additional_tx_pub_keys != null && message.hasOwnProperty("additional_tx_pub_keys")) {
                if (!Array.isArray(message.additional_tx_pub_keys))
                    return "additional_tx_pub_keys: array expected";
                for (var i = 0; i < message.additional_tx_pub_keys.length; ++i)
                    if (!(message.additional_tx_pub_keys[i] && typeof message.additional_tx_pub_keys[i].length === "number" || $util.isString(message.additional_tx_pub_keys[i])))
                        return "additional_tx_pub_keys: buffer[] expected";
            }
            if (!$util.isInteger(message.internal_output_index) && !(message.internal_output_index && $util.isInteger(message.internal_output_index.low) && $util.isInteger(message.internal_output_index.high)))
                return "internal_output_index: integer|Long expected";
            if (message.sub_addr_major != null && message.hasOwnProperty("sub_addr_major"))
                if (!$util.isInteger(message.sub_addr_major))
                    return "sub_addr_major: integer expected";
            if (message.sub_addr_minor != null && message.hasOwnProperty("sub_addr_minor"))
                if (!$util.isInteger(message.sub_addr_minor))
                    return "sub_addr_minor: integer expected";
            return null;
        };

        MoneroTransferDetails.fromObject = function fromObject(object) {
            if (object instanceof $root.MoneroKeyImageSyncStepRequest.MoneroTransferDetails)
                return object;
            var message = new $root.MoneroKeyImageSyncStepRequest.MoneroTransferDetails();
            if (object.out_key != null)
                if (typeof object.out_key === "string")
                    $util.base64.decode(object.out_key, message.out_key = $util.newBuffer($util.base64.length(object.out_key)), 0);
                else if (object.out_key.length)
                    message.out_key = object.out_key;
            if (object.tx_pub_key != null)
                if (typeof object.tx_pub_key === "string")
                    $util.base64.decode(object.tx_pub_key, message.tx_pub_key = $util.newBuffer($util.base64.length(object.tx_pub_key)), 0);
                else if (object.tx_pub_key.length)
                    message.tx_pub_key = object.tx_pub_key;
            if (object.additional_tx_pub_keys) {
                if (!Array.isArray(object.additional_tx_pub_keys))
                    throw TypeError(".MoneroKeyImageSyncStepRequest.MoneroTransferDetails.additional_tx_pub_keys: array expected");
                message.additional_tx_pub_keys = [];
                for (var i = 0; i < object.additional_tx_pub_keys.length; ++i)
                    if (typeof object.additional_tx_pub_keys[i] === "string")
                        $util.base64.decode(object.additional_tx_pub_keys[i], message.additional_tx_pub_keys[i] = $util.newBuffer($util.base64.length(object.additional_tx_pub_keys[i])), 0);
                    else if (object.additional_tx_pub_keys[i].length)
                        message.additional_tx_pub_keys[i] = object.additional_tx_pub_keys[i];
            }
            if (object.internal_output_index != null)
                if ($util.Long)
                    (message.internal_output_index = $util.Long.fromValue(object.internal_output_index)).unsigned = true;
                else if (typeof object.internal_output_index === "string")
                    message.internal_output_index = parseInt(object.internal_output_index, 10);
                else if (typeof object.internal_output_index === "number")
                    message.internal_output_index = object.internal_output_index;
                else if (typeof object.internal_output_index === "object")
                    message.internal_output_index = new $util.LongBits(object.internal_output_index.low >>> 0, object.internal_output_index.high >>> 0).toNumber(true);
            if (object.sub_addr_major != null)
                message.sub_addr_major = object.sub_addr_major >>> 0;
            if (object.sub_addr_minor != null)
                message.sub_addr_minor = object.sub_addr_minor >>> 0;
            return message;
        };

        MoneroTransferDetails.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.additional_tx_pub_keys = [];
            if (options.defaults) {
                if (options.bytes === String)
                    object.out_key = "";
                else {
                    object.out_key = [];
                    if (options.bytes !== Array)
                        object.out_key = $util.newBuffer(object.out_key);
                }
                if (options.bytes === String)
                    object.tx_pub_key = "";
                else {
                    object.tx_pub_key = [];
                    if (options.bytes !== Array)
                        object.tx_pub_key = $util.newBuffer(object.tx_pub_key);
                }
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.internal_output_index = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.internal_output_index = options.longs === String ? "0" : 0;
                object.sub_addr_major = 0;
                object.sub_addr_minor = 0;
            }
            if (message.out_key != null && message.hasOwnProperty("out_key"))
                object.out_key = options.bytes === String ? $util.base64.encode(message.out_key, 0, message.out_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.out_key) : message.out_key;
            if (message.tx_pub_key != null && message.hasOwnProperty("tx_pub_key"))
                object.tx_pub_key = options.bytes === String ? $util.base64.encode(message.tx_pub_key, 0, message.tx_pub_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.tx_pub_key) : message.tx_pub_key;
            if (message.additional_tx_pub_keys && message.additional_tx_pub_keys.length) {
                object.additional_tx_pub_keys = [];
                for (var j = 0; j < message.additional_tx_pub_keys.length; ++j)
                    object.additional_tx_pub_keys[j] = options.bytes === String ? $util.base64.encode(message.additional_tx_pub_keys[j], 0, message.additional_tx_pub_keys[j].length) : options.bytes === Array ? Array.prototype.slice.call(message.additional_tx_pub_keys[j]) : message.additional_tx_pub_keys[j];
            }
            if (message.internal_output_index != null && message.hasOwnProperty("internal_output_index"))
                if (typeof message.internal_output_index === "number")
                    object.internal_output_index = options.longs === String ? String(message.internal_output_index) : message.internal_output_index;
                else
                    object.internal_output_index = options.longs === String ? $util.Long.prototype.toString.call(message.internal_output_index) : options.longs === Number ? new $util.LongBits(message.internal_output_index.low >>> 0, message.internal_output_index.high >>> 0).toNumber(true) : message.internal_output_index;
            if (message.sub_addr_major != null && message.hasOwnProperty("sub_addr_major"))
                object.sub_addr_major = message.sub_addr_major;
            if (message.sub_addr_minor != null && message.hasOwnProperty("sub_addr_minor"))
                object.sub_addr_minor = message.sub_addr_minor;
            return object;
        };

        MoneroTransferDetails.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return MoneroTransferDetails;
    })();

    return MoneroKeyImageSyncStepRequest;
})();

$root.MoneroKeyImageSyncStepAck = (function() {

    function MoneroKeyImageSyncStepAck(properties) {
        this.kis = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroKeyImageSyncStepAck.prototype.kis = $util.emptyArray;

    MoneroKeyImageSyncStepAck.create = function create(properties) {
        return new MoneroKeyImageSyncStepAck(properties);
    };

    MoneroKeyImageSyncStepAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.kis != null && message.kis.length)
            for (var i = 0; i < message.kis.length; ++i)
                $root.MoneroKeyImageSyncStepAck.MoneroExportedKeyImage.encode(message.kis[i], writer.uint32(10).fork()).ldelim();
        return writer;
    };

    MoneroKeyImageSyncStepAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroKeyImageSyncStepAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroKeyImageSyncStepAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.kis && message.kis.length))
                    message.kis = [];
                message.kis.push($root.MoneroKeyImageSyncStepAck.MoneroExportedKeyImage.decode(reader, reader.uint32()));
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroKeyImageSyncStepAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroKeyImageSyncStepAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.kis != null && message.hasOwnProperty("kis")) {
            if (!Array.isArray(message.kis))
                return "kis: array expected";
            for (var i = 0; i < message.kis.length; ++i) {
                var error = $root.MoneroKeyImageSyncStepAck.MoneroExportedKeyImage.verify(message.kis[i]);
                if (error)
                    return "kis." + error;
            }
        }
        return null;
    };

    MoneroKeyImageSyncStepAck.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroKeyImageSyncStepAck)
            return object;
        var message = new $root.MoneroKeyImageSyncStepAck();
        if (object.kis) {
            if (!Array.isArray(object.kis))
                throw TypeError(".MoneroKeyImageSyncStepAck.kis: array expected");
            message.kis = [];
            for (var i = 0; i < object.kis.length; ++i) {
                if (typeof object.kis[i] !== "object")
                    throw TypeError(".MoneroKeyImageSyncStepAck.kis: object expected");
                message.kis[i] = $root.MoneroKeyImageSyncStepAck.MoneroExportedKeyImage.fromObject(object.kis[i]);
            }
        }
        return message;
    };

    MoneroKeyImageSyncStepAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.kis = [];
        if (message.kis && message.kis.length) {
            object.kis = [];
            for (var j = 0; j < message.kis.length; ++j)
                object.kis[j] = $root.MoneroKeyImageSyncStepAck.MoneroExportedKeyImage.toObject(message.kis[j], options);
        }
        return object;
    };

    MoneroKeyImageSyncStepAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    MoneroKeyImageSyncStepAck.MoneroExportedKeyImage = (function() {

        function MoneroExportedKeyImage(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        MoneroExportedKeyImage.prototype.iv = $util.newBuffer([]);
        MoneroExportedKeyImage.prototype.blob = $util.newBuffer([]);

        MoneroExportedKeyImage.create = function create(properties) {
            return new MoneroExportedKeyImage(properties);
        };

        MoneroExportedKeyImage.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.iv != null && Object.hasOwnProperty.call(message, "iv"))
                writer.uint32(10).bytes(message.iv);
            if (message.blob != null && Object.hasOwnProperty.call(message, "blob"))
                writer.uint32(26).bytes(message.blob);
            return writer;
        };

        MoneroExportedKeyImage.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        MoneroExportedKeyImage.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroKeyImageSyncStepAck.MoneroExportedKeyImage();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.iv = reader.bytes();
                    break;
                case 3:
                    message.blob = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        MoneroExportedKeyImage.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        MoneroExportedKeyImage.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.iv != null && message.hasOwnProperty("iv"))
                if (!(message.iv && typeof message.iv.length === "number" || $util.isString(message.iv)))
                    return "iv: buffer expected";
            if (message.blob != null && message.hasOwnProperty("blob"))
                if (!(message.blob && typeof message.blob.length === "number" || $util.isString(message.blob)))
                    return "blob: buffer expected";
            return null;
        };

        MoneroExportedKeyImage.fromObject = function fromObject(object) {
            if (object instanceof $root.MoneroKeyImageSyncStepAck.MoneroExportedKeyImage)
                return object;
            var message = new $root.MoneroKeyImageSyncStepAck.MoneroExportedKeyImage();
            if (object.iv != null)
                if (typeof object.iv === "string")
                    $util.base64.decode(object.iv, message.iv = $util.newBuffer($util.base64.length(object.iv)), 0);
                else if (object.iv.length)
                    message.iv = object.iv;
            if (object.blob != null)
                if (typeof object.blob === "string")
                    $util.base64.decode(object.blob, message.blob = $util.newBuffer($util.base64.length(object.blob)), 0);
                else if (object.blob.length)
                    message.blob = object.blob;
            return message;
        };

        MoneroExportedKeyImage.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if (options.bytes === String)
                    object.iv = "";
                else {
                    object.iv = [];
                    if (options.bytes !== Array)
                        object.iv = $util.newBuffer(object.iv);
                }
                if (options.bytes === String)
                    object.blob = "";
                else {
                    object.blob = [];
                    if (options.bytes !== Array)
                        object.blob = $util.newBuffer(object.blob);
                }
            }
            if (message.iv != null && message.hasOwnProperty("iv"))
                object.iv = options.bytes === String ? $util.base64.encode(message.iv, 0, message.iv.length) : options.bytes === Array ? Array.prototype.slice.call(message.iv) : message.iv;
            if (message.blob != null && message.hasOwnProperty("blob"))
                object.blob = options.bytes === String ? $util.base64.encode(message.blob, 0, message.blob.length) : options.bytes === Array ? Array.prototype.slice.call(message.blob) : message.blob;
            return object;
        };

        MoneroExportedKeyImage.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return MoneroExportedKeyImage;
    })();

    return MoneroKeyImageSyncStepAck;
})();

$root.MoneroKeyImageSyncFinalRequest = (function() {

    function MoneroKeyImageSyncFinalRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroKeyImageSyncFinalRequest.create = function create(properties) {
        return new MoneroKeyImageSyncFinalRequest(properties);
    };

    MoneroKeyImageSyncFinalRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    MoneroKeyImageSyncFinalRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroKeyImageSyncFinalRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroKeyImageSyncFinalRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroKeyImageSyncFinalRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroKeyImageSyncFinalRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    MoneroKeyImageSyncFinalRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroKeyImageSyncFinalRequest)
            return object;
        return new $root.MoneroKeyImageSyncFinalRequest();
    };

    MoneroKeyImageSyncFinalRequest.toObject = function toObject() {
        return {};
    };

    MoneroKeyImageSyncFinalRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoneroKeyImageSyncFinalRequest;
})();

$root.MoneroKeyImageSyncFinalAck = (function() {

    function MoneroKeyImageSyncFinalAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroKeyImageSyncFinalAck.prototype.enc_key = $util.newBuffer([]);

    MoneroKeyImageSyncFinalAck.create = function create(properties) {
        return new MoneroKeyImageSyncFinalAck(properties);
    };

    MoneroKeyImageSyncFinalAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.enc_key != null && Object.hasOwnProperty.call(message, "enc_key"))
            writer.uint32(10).bytes(message.enc_key);
        return writer;
    };

    MoneroKeyImageSyncFinalAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroKeyImageSyncFinalAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroKeyImageSyncFinalAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.enc_key = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroKeyImageSyncFinalAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroKeyImageSyncFinalAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.enc_key != null && message.hasOwnProperty("enc_key"))
            if (!(message.enc_key && typeof message.enc_key.length === "number" || $util.isString(message.enc_key)))
                return "enc_key: buffer expected";
        return null;
    };

    MoneroKeyImageSyncFinalAck.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroKeyImageSyncFinalAck)
            return object;
        var message = new $root.MoneroKeyImageSyncFinalAck();
        if (object.enc_key != null)
            if (typeof object.enc_key === "string")
                $util.base64.decode(object.enc_key, message.enc_key = $util.newBuffer($util.base64.length(object.enc_key)), 0);
            else if (object.enc_key.length)
                message.enc_key = object.enc_key;
        return message;
    };

    MoneroKeyImageSyncFinalAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.enc_key = "";
            else {
                object.enc_key = [];
                if (options.bytes !== Array)
                    object.enc_key = $util.newBuffer(object.enc_key);
            }
        if (message.enc_key != null && message.hasOwnProperty("enc_key"))
            object.enc_key = options.bytes === String ? $util.base64.encode(message.enc_key, 0, message.enc_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.enc_key) : message.enc_key;
        return object;
    };

    MoneroKeyImageSyncFinalAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoneroKeyImageSyncFinalAck;
})();

$root.MoneroGetTxKeyRequest = (function() {

    function MoneroGetTxKeyRequest(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroGetTxKeyRequest.prototype.address_n = $util.emptyArray;
    MoneroGetTxKeyRequest.prototype.network_type = 0;
    MoneroGetTxKeyRequest.prototype.salt1 = $util.newBuffer([]);
    MoneroGetTxKeyRequest.prototype.salt2 = $util.newBuffer([]);
    MoneroGetTxKeyRequest.prototype.tx_enc_keys = $util.newBuffer([]);
    MoneroGetTxKeyRequest.prototype.tx_prefix_hash = $util.newBuffer([]);
    MoneroGetTxKeyRequest.prototype.reason = 0;
    MoneroGetTxKeyRequest.prototype.view_public_key = $util.newBuffer([]);

    MoneroGetTxKeyRequest.create = function create(properties) {
        return new MoneroGetTxKeyRequest(properties);
    };

    MoneroGetTxKeyRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.network_type != null && Object.hasOwnProperty.call(message, "network_type"))
            writer.uint32(16).int32(message.network_type);
        writer.uint32(26).bytes(message.salt1);
        writer.uint32(34).bytes(message.salt2);
        writer.uint32(42).bytes(message.tx_enc_keys);
        writer.uint32(50).bytes(message.tx_prefix_hash);
        if (message.reason != null && Object.hasOwnProperty.call(message, "reason"))
            writer.uint32(56).uint32(message.reason);
        if (message.view_public_key != null && Object.hasOwnProperty.call(message, "view_public_key"))
            writer.uint32(66).bytes(message.view_public_key);
        return writer;
    };

    MoneroGetTxKeyRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroGetTxKeyRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroGetTxKeyRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.network_type = reader.int32();
                break;
            case 3:
                message.salt1 = reader.bytes();
                break;
            case 4:
                message.salt2 = reader.bytes();
                break;
            case 5:
                message.tx_enc_keys = reader.bytes();
                break;
            case 6:
                message.tx_prefix_hash = reader.bytes();
                break;
            case 7:
                message.reason = reader.uint32();
                break;
            case 8:
                message.view_public_key = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("salt1"))
            throw $util.ProtocolError("missing required 'salt1'", { instance: message });
        if (!message.hasOwnProperty("salt2"))
            throw $util.ProtocolError("missing required 'salt2'", { instance: message });
        if (!message.hasOwnProperty("tx_enc_keys"))
            throw $util.ProtocolError("missing required 'tx_enc_keys'", { instance: message });
        if (!message.hasOwnProperty("tx_prefix_hash"))
            throw $util.ProtocolError("missing required 'tx_prefix_hash'", { instance: message });
        return message;
    };

    MoneroGetTxKeyRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroGetTxKeyRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.network_type != null && message.hasOwnProperty("network_type"))
            switch (message.network_type) {
            default:
                return "network_type: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
                break;
            }
        if (!(message.salt1 && typeof message.salt1.length === "number" || $util.isString(message.salt1)))
            return "salt1: buffer expected";
        if (!(message.salt2 && typeof message.salt2.length === "number" || $util.isString(message.salt2)))
            return "salt2: buffer expected";
        if (!(message.tx_enc_keys && typeof message.tx_enc_keys.length === "number" || $util.isString(message.tx_enc_keys)))
            return "tx_enc_keys: buffer expected";
        if (!(message.tx_prefix_hash && typeof message.tx_prefix_hash.length === "number" || $util.isString(message.tx_prefix_hash)))
            return "tx_prefix_hash: buffer expected";
        if (message.reason != null && message.hasOwnProperty("reason"))
            if (!$util.isInteger(message.reason))
                return "reason: integer expected";
        if (message.view_public_key != null && message.hasOwnProperty("view_public_key"))
            if (!(message.view_public_key && typeof message.view_public_key.length === "number" || $util.isString(message.view_public_key)))
                return "view_public_key: buffer expected";
        return null;
    };

    MoneroGetTxKeyRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroGetTxKeyRequest)
            return object;
        var message = new $root.MoneroGetTxKeyRequest();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".MoneroGetTxKeyRequest.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        switch (object.network_type) {
        case "MAINNET":
        case 0:
            message.network_type = 0;
            break;
        case "TESTNET":
        case 1:
            message.network_type = 1;
            break;
        case "STAGENET":
        case 2:
            message.network_type = 2;
            break;
        case "FAKECHAIN":
        case 3:
            message.network_type = 3;
            break;
        }
        if (object.salt1 != null)
            if (typeof object.salt1 === "string")
                $util.base64.decode(object.salt1, message.salt1 = $util.newBuffer($util.base64.length(object.salt1)), 0);
            else if (object.salt1.length)
                message.salt1 = object.salt1;
        if (object.salt2 != null)
            if (typeof object.salt2 === "string")
                $util.base64.decode(object.salt2, message.salt2 = $util.newBuffer($util.base64.length(object.salt2)), 0);
            else if (object.salt2.length)
                message.salt2 = object.salt2;
        if (object.tx_enc_keys != null)
            if (typeof object.tx_enc_keys === "string")
                $util.base64.decode(object.tx_enc_keys, message.tx_enc_keys = $util.newBuffer($util.base64.length(object.tx_enc_keys)), 0);
            else if (object.tx_enc_keys.length)
                message.tx_enc_keys = object.tx_enc_keys;
        if (object.tx_prefix_hash != null)
            if (typeof object.tx_prefix_hash === "string")
                $util.base64.decode(object.tx_prefix_hash, message.tx_prefix_hash = $util.newBuffer($util.base64.length(object.tx_prefix_hash)), 0);
            else if (object.tx_prefix_hash.length)
                message.tx_prefix_hash = object.tx_prefix_hash;
        if (object.reason != null)
            message.reason = object.reason >>> 0;
        if (object.view_public_key != null)
            if (typeof object.view_public_key === "string")
                $util.base64.decode(object.view_public_key, message.view_public_key = $util.newBuffer($util.base64.length(object.view_public_key)), 0);
            else if (object.view_public_key.length)
                message.view_public_key = object.view_public_key;
        return message;
    };

    MoneroGetTxKeyRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            object.network_type = options.enums === String ? "MAINNET" : 0;
            if (options.bytes === String)
                object.salt1 = "";
            else {
                object.salt1 = [];
                if (options.bytes !== Array)
                    object.salt1 = $util.newBuffer(object.salt1);
            }
            if (options.bytes === String)
                object.salt2 = "";
            else {
                object.salt2 = [];
                if (options.bytes !== Array)
                    object.salt2 = $util.newBuffer(object.salt2);
            }
            if (options.bytes === String)
                object.tx_enc_keys = "";
            else {
                object.tx_enc_keys = [];
                if (options.bytes !== Array)
                    object.tx_enc_keys = $util.newBuffer(object.tx_enc_keys);
            }
            if (options.bytes === String)
                object.tx_prefix_hash = "";
            else {
                object.tx_prefix_hash = [];
                if (options.bytes !== Array)
                    object.tx_prefix_hash = $util.newBuffer(object.tx_prefix_hash);
            }
            object.reason = 0;
            if (options.bytes === String)
                object.view_public_key = "";
            else {
                object.view_public_key = [];
                if (options.bytes !== Array)
                    object.view_public_key = $util.newBuffer(object.view_public_key);
            }
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.network_type != null && message.hasOwnProperty("network_type"))
            object.network_type = options.enums === String ? $root.MoneroNetworkType[message.network_type] : message.network_type;
        if (message.salt1 != null && message.hasOwnProperty("salt1"))
            object.salt1 = options.bytes === String ? $util.base64.encode(message.salt1, 0, message.salt1.length) : options.bytes === Array ? Array.prototype.slice.call(message.salt1) : message.salt1;
        if (message.salt2 != null && message.hasOwnProperty("salt2"))
            object.salt2 = options.bytes === String ? $util.base64.encode(message.salt2, 0, message.salt2.length) : options.bytes === Array ? Array.prototype.slice.call(message.salt2) : message.salt2;
        if (message.tx_enc_keys != null && message.hasOwnProperty("tx_enc_keys"))
            object.tx_enc_keys = options.bytes === String ? $util.base64.encode(message.tx_enc_keys, 0, message.tx_enc_keys.length) : options.bytes === Array ? Array.prototype.slice.call(message.tx_enc_keys) : message.tx_enc_keys;
        if (message.tx_prefix_hash != null && message.hasOwnProperty("tx_prefix_hash"))
            object.tx_prefix_hash = options.bytes === String ? $util.base64.encode(message.tx_prefix_hash, 0, message.tx_prefix_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.tx_prefix_hash) : message.tx_prefix_hash;
        if (message.reason != null && message.hasOwnProperty("reason"))
            object.reason = message.reason;
        if (message.view_public_key != null && message.hasOwnProperty("view_public_key"))
            object.view_public_key = options.bytes === String ? $util.base64.encode(message.view_public_key, 0, message.view_public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.view_public_key) : message.view_public_key;
        return object;
    };

    MoneroGetTxKeyRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoneroGetTxKeyRequest;
})();

$root.MoneroGetTxKeyAck = (function() {

    function MoneroGetTxKeyAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroGetTxKeyAck.prototype.salt = $util.newBuffer([]);
    MoneroGetTxKeyAck.prototype.tx_keys = $util.newBuffer([]);
    MoneroGetTxKeyAck.prototype.tx_derivations = $util.newBuffer([]);

    MoneroGetTxKeyAck.create = function create(properties) {
        return new MoneroGetTxKeyAck(properties);
    };

    MoneroGetTxKeyAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.salt != null && Object.hasOwnProperty.call(message, "salt"))
            writer.uint32(10).bytes(message.salt);
        if (message.tx_keys != null && Object.hasOwnProperty.call(message, "tx_keys"))
            writer.uint32(18).bytes(message.tx_keys);
        if (message.tx_derivations != null && Object.hasOwnProperty.call(message, "tx_derivations"))
            writer.uint32(26).bytes(message.tx_derivations);
        return writer;
    };

    MoneroGetTxKeyAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroGetTxKeyAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroGetTxKeyAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.salt = reader.bytes();
                break;
            case 2:
                message.tx_keys = reader.bytes();
                break;
            case 3:
                message.tx_derivations = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroGetTxKeyAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroGetTxKeyAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.salt != null && message.hasOwnProperty("salt"))
            if (!(message.salt && typeof message.salt.length === "number" || $util.isString(message.salt)))
                return "salt: buffer expected";
        if (message.tx_keys != null && message.hasOwnProperty("tx_keys"))
            if (!(message.tx_keys && typeof message.tx_keys.length === "number" || $util.isString(message.tx_keys)))
                return "tx_keys: buffer expected";
        if (message.tx_derivations != null && message.hasOwnProperty("tx_derivations"))
            if (!(message.tx_derivations && typeof message.tx_derivations.length === "number" || $util.isString(message.tx_derivations)))
                return "tx_derivations: buffer expected";
        return null;
    };

    MoneroGetTxKeyAck.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroGetTxKeyAck)
            return object;
        var message = new $root.MoneroGetTxKeyAck();
        if (object.salt != null)
            if (typeof object.salt === "string")
                $util.base64.decode(object.salt, message.salt = $util.newBuffer($util.base64.length(object.salt)), 0);
            else if (object.salt.length)
                message.salt = object.salt;
        if (object.tx_keys != null)
            if (typeof object.tx_keys === "string")
                $util.base64.decode(object.tx_keys, message.tx_keys = $util.newBuffer($util.base64.length(object.tx_keys)), 0);
            else if (object.tx_keys.length)
                message.tx_keys = object.tx_keys;
        if (object.tx_derivations != null)
            if (typeof object.tx_derivations === "string")
                $util.base64.decode(object.tx_derivations, message.tx_derivations = $util.newBuffer($util.base64.length(object.tx_derivations)), 0);
            else if (object.tx_derivations.length)
                message.tx_derivations = object.tx_derivations;
        return message;
    };

    MoneroGetTxKeyAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.salt = "";
            else {
                object.salt = [];
                if (options.bytes !== Array)
                    object.salt = $util.newBuffer(object.salt);
            }
            if (options.bytes === String)
                object.tx_keys = "";
            else {
                object.tx_keys = [];
                if (options.bytes !== Array)
                    object.tx_keys = $util.newBuffer(object.tx_keys);
            }
            if (options.bytes === String)
                object.tx_derivations = "";
            else {
                object.tx_derivations = [];
                if (options.bytes !== Array)
                    object.tx_derivations = $util.newBuffer(object.tx_derivations);
            }
        }
        if (message.salt != null && message.hasOwnProperty("salt"))
            object.salt = options.bytes === String ? $util.base64.encode(message.salt, 0, message.salt.length) : options.bytes === Array ? Array.prototype.slice.call(message.salt) : message.salt;
        if (message.tx_keys != null && message.hasOwnProperty("tx_keys"))
            object.tx_keys = options.bytes === String ? $util.base64.encode(message.tx_keys, 0, message.tx_keys.length) : options.bytes === Array ? Array.prototype.slice.call(message.tx_keys) : message.tx_keys;
        if (message.tx_derivations != null && message.hasOwnProperty("tx_derivations"))
            object.tx_derivations = options.bytes === String ? $util.base64.encode(message.tx_derivations, 0, message.tx_derivations.length) : options.bytes === Array ? Array.prototype.slice.call(message.tx_derivations) : message.tx_derivations;
        return object;
    };

    MoneroGetTxKeyAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoneroGetTxKeyAck;
})();

$root.MoneroLiveRefreshStartRequest = (function() {

    function MoneroLiveRefreshStartRequest(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroLiveRefreshStartRequest.prototype.address_n = $util.emptyArray;
    MoneroLiveRefreshStartRequest.prototype.network_type = 0;

    MoneroLiveRefreshStartRequest.create = function create(properties) {
        return new MoneroLiveRefreshStartRequest(properties);
    };

    MoneroLiveRefreshStartRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.network_type != null && Object.hasOwnProperty.call(message, "network_type"))
            writer.uint32(16).int32(message.network_type);
        return writer;
    };

    MoneroLiveRefreshStartRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroLiveRefreshStartRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroLiveRefreshStartRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.network_type = reader.int32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroLiveRefreshStartRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroLiveRefreshStartRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.network_type != null && message.hasOwnProperty("network_type"))
            switch (message.network_type) {
            default:
                return "network_type: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
                break;
            }
        return null;
    };

    MoneroLiveRefreshStartRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroLiveRefreshStartRequest)
            return object;
        var message = new $root.MoneroLiveRefreshStartRequest();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".MoneroLiveRefreshStartRequest.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        switch (object.network_type) {
        case "MAINNET":
        case 0:
            message.network_type = 0;
            break;
        case "TESTNET":
        case 1:
            message.network_type = 1;
            break;
        case "STAGENET":
        case 2:
            message.network_type = 2;
            break;
        case "FAKECHAIN":
        case 3:
            message.network_type = 3;
            break;
        }
        return message;
    };

    MoneroLiveRefreshStartRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            object.network_type = options.enums === String ? "MAINNET" : 0;
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.network_type != null && message.hasOwnProperty("network_type"))
            object.network_type = options.enums === String ? $root.MoneroNetworkType[message.network_type] : message.network_type;
        return object;
    };

    MoneroLiveRefreshStartRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoneroLiveRefreshStartRequest;
})();

$root.MoneroLiveRefreshStartAck = (function() {

    function MoneroLiveRefreshStartAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroLiveRefreshStartAck.create = function create(properties) {
        return new MoneroLiveRefreshStartAck(properties);
    };

    MoneroLiveRefreshStartAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    MoneroLiveRefreshStartAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroLiveRefreshStartAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroLiveRefreshStartAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroLiveRefreshStartAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroLiveRefreshStartAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    MoneroLiveRefreshStartAck.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroLiveRefreshStartAck)
            return object;
        return new $root.MoneroLiveRefreshStartAck();
    };

    MoneroLiveRefreshStartAck.toObject = function toObject() {
        return {};
    };

    MoneroLiveRefreshStartAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoneroLiveRefreshStartAck;
})();

$root.MoneroLiveRefreshStepRequest = (function() {

    function MoneroLiveRefreshStepRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroLiveRefreshStepRequest.prototype.out_key = $util.newBuffer([]);
    MoneroLiveRefreshStepRequest.prototype.recv_deriv = $util.newBuffer([]);
    MoneroLiveRefreshStepRequest.prototype.real_out_idx = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    MoneroLiveRefreshStepRequest.prototype.sub_addr_major = 0;
    MoneroLiveRefreshStepRequest.prototype.sub_addr_minor = 0;

    MoneroLiveRefreshStepRequest.create = function create(properties) {
        return new MoneroLiveRefreshStepRequest(properties);
    };

    MoneroLiveRefreshStepRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.out_key);
        writer.uint32(18).bytes(message.recv_deriv);
        writer.uint32(24).uint64(message.real_out_idx);
        writer.uint32(32).uint32(message.sub_addr_major);
        writer.uint32(40).uint32(message.sub_addr_minor);
        return writer;
    };

    MoneroLiveRefreshStepRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroLiveRefreshStepRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroLiveRefreshStepRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.out_key = reader.bytes();
                break;
            case 2:
                message.recv_deriv = reader.bytes();
                break;
            case 3:
                message.real_out_idx = reader.uint64();
                break;
            case 4:
                message.sub_addr_major = reader.uint32();
                break;
            case 5:
                message.sub_addr_minor = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("out_key"))
            throw $util.ProtocolError("missing required 'out_key'", { instance: message });
        if (!message.hasOwnProperty("recv_deriv"))
            throw $util.ProtocolError("missing required 'recv_deriv'", { instance: message });
        if (!message.hasOwnProperty("real_out_idx"))
            throw $util.ProtocolError("missing required 'real_out_idx'", { instance: message });
        if (!message.hasOwnProperty("sub_addr_major"))
            throw $util.ProtocolError("missing required 'sub_addr_major'", { instance: message });
        if (!message.hasOwnProperty("sub_addr_minor"))
            throw $util.ProtocolError("missing required 'sub_addr_minor'", { instance: message });
        return message;
    };

    MoneroLiveRefreshStepRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroLiveRefreshStepRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.out_key && typeof message.out_key.length === "number" || $util.isString(message.out_key)))
            return "out_key: buffer expected";
        if (!(message.recv_deriv && typeof message.recv_deriv.length === "number" || $util.isString(message.recv_deriv)))
            return "recv_deriv: buffer expected";
        if (!$util.isInteger(message.real_out_idx) && !(message.real_out_idx && $util.isInteger(message.real_out_idx.low) && $util.isInteger(message.real_out_idx.high)))
            return "real_out_idx: integer|Long expected";
        if (!$util.isInteger(message.sub_addr_major))
            return "sub_addr_major: integer expected";
        if (!$util.isInteger(message.sub_addr_minor))
            return "sub_addr_minor: integer expected";
        return null;
    };

    MoneroLiveRefreshStepRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroLiveRefreshStepRequest)
            return object;
        var message = new $root.MoneroLiveRefreshStepRequest();
        if (object.out_key != null)
            if (typeof object.out_key === "string")
                $util.base64.decode(object.out_key, message.out_key = $util.newBuffer($util.base64.length(object.out_key)), 0);
            else if (object.out_key.length)
                message.out_key = object.out_key;
        if (object.recv_deriv != null)
            if (typeof object.recv_deriv === "string")
                $util.base64.decode(object.recv_deriv, message.recv_deriv = $util.newBuffer($util.base64.length(object.recv_deriv)), 0);
            else if (object.recv_deriv.length)
                message.recv_deriv = object.recv_deriv;
        if (object.real_out_idx != null)
            if ($util.Long)
                (message.real_out_idx = $util.Long.fromValue(object.real_out_idx)).unsigned = true;
            else if (typeof object.real_out_idx === "string")
                message.real_out_idx = parseInt(object.real_out_idx, 10);
            else if (typeof object.real_out_idx === "number")
                message.real_out_idx = object.real_out_idx;
            else if (typeof object.real_out_idx === "object")
                message.real_out_idx = new $util.LongBits(object.real_out_idx.low >>> 0, object.real_out_idx.high >>> 0).toNumber(true);
        if (object.sub_addr_major != null)
            message.sub_addr_major = object.sub_addr_major >>> 0;
        if (object.sub_addr_minor != null)
            message.sub_addr_minor = object.sub_addr_minor >>> 0;
        return message;
    };

    MoneroLiveRefreshStepRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.out_key = "";
            else {
                object.out_key = [];
                if (options.bytes !== Array)
                    object.out_key = $util.newBuffer(object.out_key);
            }
            if (options.bytes === String)
                object.recv_deriv = "";
            else {
                object.recv_deriv = [];
                if (options.bytes !== Array)
                    object.recv_deriv = $util.newBuffer(object.recv_deriv);
            }
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.real_out_idx = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.real_out_idx = options.longs === String ? "0" : 0;
            object.sub_addr_major = 0;
            object.sub_addr_minor = 0;
        }
        if (message.out_key != null && message.hasOwnProperty("out_key"))
            object.out_key = options.bytes === String ? $util.base64.encode(message.out_key, 0, message.out_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.out_key) : message.out_key;
        if (message.recv_deriv != null && message.hasOwnProperty("recv_deriv"))
            object.recv_deriv = options.bytes === String ? $util.base64.encode(message.recv_deriv, 0, message.recv_deriv.length) : options.bytes === Array ? Array.prototype.slice.call(message.recv_deriv) : message.recv_deriv;
        if (message.real_out_idx != null && message.hasOwnProperty("real_out_idx"))
            if (typeof message.real_out_idx === "number")
                object.real_out_idx = options.longs === String ? String(message.real_out_idx) : message.real_out_idx;
            else
                object.real_out_idx = options.longs === String ? $util.Long.prototype.toString.call(message.real_out_idx) : options.longs === Number ? new $util.LongBits(message.real_out_idx.low >>> 0, message.real_out_idx.high >>> 0).toNumber(true) : message.real_out_idx;
        if (message.sub_addr_major != null && message.hasOwnProperty("sub_addr_major"))
            object.sub_addr_major = message.sub_addr_major;
        if (message.sub_addr_minor != null && message.hasOwnProperty("sub_addr_minor"))
            object.sub_addr_minor = message.sub_addr_minor;
        return object;
    };

    MoneroLiveRefreshStepRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoneroLiveRefreshStepRequest;
})();

$root.MoneroLiveRefreshStepAck = (function() {

    function MoneroLiveRefreshStepAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroLiveRefreshStepAck.prototype.salt = $util.newBuffer([]);
    MoneroLiveRefreshStepAck.prototype.key_image = $util.newBuffer([]);

    MoneroLiveRefreshStepAck.create = function create(properties) {
        return new MoneroLiveRefreshStepAck(properties);
    };

    MoneroLiveRefreshStepAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.salt != null && Object.hasOwnProperty.call(message, "salt"))
            writer.uint32(10).bytes(message.salt);
        if (message.key_image != null && Object.hasOwnProperty.call(message, "key_image"))
            writer.uint32(18).bytes(message.key_image);
        return writer;
    };

    MoneroLiveRefreshStepAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroLiveRefreshStepAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroLiveRefreshStepAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.salt = reader.bytes();
                break;
            case 2:
                message.key_image = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroLiveRefreshStepAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroLiveRefreshStepAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.salt != null && message.hasOwnProperty("salt"))
            if (!(message.salt && typeof message.salt.length === "number" || $util.isString(message.salt)))
                return "salt: buffer expected";
        if (message.key_image != null && message.hasOwnProperty("key_image"))
            if (!(message.key_image && typeof message.key_image.length === "number" || $util.isString(message.key_image)))
                return "key_image: buffer expected";
        return null;
    };

    MoneroLiveRefreshStepAck.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroLiveRefreshStepAck)
            return object;
        var message = new $root.MoneroLiveRefreshStepAck();
        if (object.salt != null)
            if (typeof object.salt === "string")
                $util.base64.decode(object.salt, message.salt = $util.newBuffer($util.base64.length(object.salt)), 0);
            else if (object.salt.length)
                message.salt = object.salt;
        if (object.key_image != null)
            if (typeof object.key_image === "string")
                $util.base64.decode(object.key_image, message.key_image = $util.newBuffer($util.base64.length(object.key_image)), 0);
            else if (object.key_image.length)
                message.key_image = object.key_image;
        return message;
    };

    MoneroLiveRefreshStepAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.salt = "";
            else {
                object.salt = [];
                if (options.bytes !== Array)
                    object.salt = $util.newBuffer(object.salt);
            }
            if (options.bytes === String)
                object.key_image = "";
            else {
                object.key_image = [];
                if (options.bytes !== Array)
                    object.key_image = $util.newBuffer(object.key_image);
            }
        }
        if (message.salt != null && message.hasOwnProperty("salt"))
            object.salt = options.bytes === String ? $util.base64.encode(message.salt, 0, message.salt.length) : options.bytes === Array ? Array.prototype.slice.call(message.salt) : message.salt;
        if (message.key_image != null && message.hasOwnProperty("key_image"))
            object.key_image = options.bytes === String ? $util.base64.encode(message.key_image, 0, message.key_image.length) : options.bytes === Array ? Array.prototype.slice.call(message.key_image) : message.key_image;
        return object;
    };

    MoneroLiveRefreshStepAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoneroLiveRefreshStepAck;
})();

$root.MoneroLiveRefreshFinalRequest = (function() {

    function MoneroLiveRefreshFinalRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroLiveRefreshFinalRequest.create = function create(properties) {
        return new MoneroLiveRefreshFinalRequest(properties);
    };

    MoneroLiveRefreshFinalRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    MoneroLiveRefreshFinalRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroLiveRefreshFinalRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroLiveRefreshFinalRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroLiveRefreshFinalRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroLiveRefreshFinalRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    MoneroLiveRefreshFinalRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroLiveRefreshFinalRequest)
            return object;
        return new $root.MoneroLiveRefreshFinalRequest();
    };

    MoneroLiveRefreshFinalRequest.toObject = function toObject() {
        return {};
    };

    MoneroLiveRefreshFinalRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoneroLiveRefreshFinalRequest;
})();

$root.MoneroLiveRefreshFinalAck = (function() {

    function MoneroLiveRefreshFinalAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    MoneroLiveRefreshFinalAck.create = function create(properties) {
        return new MoneroLiveRefreshFinalAck(properties);
    };

    MoneroLiveRefreshFinalAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    MoneroLiveRefreshFinalAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    MoneroLiveRefreshFinalAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneroLiveRefreshFinalAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    MoneroLiveRefreshFinalAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    MoneroLiveRefreshFinalAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    MoneroLiveRefreshFinalAck.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneroLiveRefreshFinalAck)
            return object;
        return new $root.MoneroLiveRefreshFinalAck();
    };

    MoneroLiveRefreshFinalAck.toObject = function toObject() {
        return {};
    };

    MoneroLiveRefreshFinalAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoneroLiveRefreshFinalAck;
})();

$root.DebugMoneroDiagRequest = (function() {

    function DebugMoneroDiagRequest(properties) {
        this.pd = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DebugMoneroDiagRequest.prototype.ins = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    DebugMoneroDiagRequest.prototype.p1 = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    DebugMoneroDiagRequest.prototype.p2 = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    DebugMoneroDiagRequest.prototype.pd = $util.emptyArray;
    DebugMoneroDiagRequest.prototype.data1 = $util.newBuffer([]);
    DebugMoneroDiagRequest.prototype.data2 = $util.newBuffer([]);

    DebugMoneroDiagRequest.create = function create(properties) {
        return new DebugMoneroDiagRequest(properties);
    };

    DebugMoneroDiagRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.ins != null && Object.hasOwnProperty.call(message, "ins"))
            writer.uint32(8).uint64(message.ins);
        if (message.p1 != null && Object.hasOwnProperty.call(message, "p1"))
            writer.uint32(16).uint64(message.p1);
        if (message.p2 != null && Object.hasOwnProperty.call(message, "p2"))
            writer.uint32(24).uint64(message.p2);
        if (message.pd != null && message.pd.length)
            for (var i = 0; i < message.pd.length; ++i)
                writer.uint32(32).uint64(message.pd[i]);
        if (message.data1 != null && Object.hasOwnProperty.call(message, "data1"))
            writer.uint32(42).bytes(message.data1);
        if (message.data2 != null && Object.hasOwnProperty.call(message, "data2"))
            writer.uint32(50).bytes(message.data2);
        return writer;
    };

    DebugMoneroDiagRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DebugMoneroDiagRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DebugMoneroDiagRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.ins = reader.uint64();
                break;
            case 2:
                message.p1 = reader.uint64();
                break;
            case 3:
                message.p2 = reader.uint64();
                break;
            case 4:
                if (!(message.pd && message.pd.length))
                    message.pd = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.pd.push(reader.uint64());
                } else
                    message.pd.push(reader.uint64());
                break;
            case 5:
                message.data1 = reader.bytes();
                break;
            case 6:
                message.data2 = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    DebugMoneroDiagRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DebugMoneroDiagRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.ins != null && message.hasOwnProperty("ins"))
            if (!$util.isInteger(message.ins) && !(message.ins && $util.isInteger(message.ins.low) && $util.isInteger(message.ins.high)))
                return "ins: integer|Long expected";
        if (message.p1 != null && message.hasOwnProperty("p1"))
            if (!$util.isInteger(message.p1) && !(message.p1 && $util.isInteger(message.p1.low) && $util.isInteger(message.p1.high)))
                return "p1: integer|Long expected";
        if (message.p2 != null && message.hasOwnProperty("p2"))
            if (!$util.isInteger(message.p2) && !(message.p2 && $util.isInteger(message.p2.low) && $util.isInteger(message.p2.high)))
                return "p2: integer|Long expected";
        if (message.pd != null && message.hasOwnProperty("pd")) {
            if (!Array.isArray(message.pd))
                return "pd: array expected";
            for (var i = 0; i < message.pd.length; ++i)
                if (!$util.isInteger(message.pd[i]) && !(message.pd[i] && $util.isInteger(message.pd[i].low) && $util.isInteger(message.pd[i].high)))
                    return "pd: integer|Long[] expected";
        }
        if (message.data1 != null && message.hasOwnProperty("data1"))
            if (!(message.data1 && typeof message.data1.length === "number" || $util.isString(message.data1)))
                return "data1: buffer expected";
        if (message.data2 != null && message.hasOwnProperty("data2"))
            if (!(message.data2 && typeof message.data2.length === "number" || $util.isString(message.data2)))
                return "data2: buffer expected";
        return null;
    };

    DebugMoneroDiagRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.DebugMoneroDiagRequest)
            return object;
        var message = new $root.DebugMoneroDiagRequest();
        if (object.ins != null)
            if ($util.Long)
                (message.ins = $util.Long.fromValue(object.ins)).unsigned = true;
            else if (typeof object.ins === "string")
                message.ins = parseInt(object.ins, 10);
            else if (typeof object.ins === "number")
                message.ins = object.ins;
            else if (typeof object.ins === "object")
                message.ins = new $util.LongBits(object.ins.low >>> 0, object.ins.high >>> 0).toNumber(true);
        if (object.p1 != null)
            if ($util.Long)
                (message.p1 = $util.Long.fromValue(object.p1)).unsigned = true;
            else if (typeof object.p1 === "string")
                message.p1 = parseInt(object.p1, 10);
            else if (typeof object.p1 === "number")
                message.p1 = object.p1;
            else if (typeof object.p1 === "object")
                message.p1 = new $util.LongBits(object.p1.low >>> 0, object.p1.high >>> 0).toNumber(true);
        if (object.p2 != null)
            if ($util.Long)
                (message.p2 = $util.Long.fromValue(object.p2)).unsigned = true;
            else if (typeof object.p2 === "string")
                message.p2 = parseInt(object.p2, 10);
            else if (typeof object.p2 === "number")
                message.p2 = object.p2;
            else if (typeof object.p2 === "object")
                message.p2 = new $util.LongBits(object.p2.low >>> 0, object.p2.high >>> 0).toNumber(true);
        if (object.pd) {
            if (!Array.isArray(object.pd))
                throw TypeError(".DebugMoneroDiagRequest.pd: array expected");
            message.pd = [];
            for (var i = 0; i < object.pd.length; ++i)
                if ($util.Long)
                    (message.pd[i] = $util.Long.fromValue(object.pd[i])).unsigned = true;
                else if (typeof object.pd[i] === "string")
                    message.pd[i] = parseInt(object.pd[i], 10);
                else if (typeof object.pd[i] === "number")
                    message.pd[i] = object.pd[i];
                else if (typeof object.pd[i] === "object")
                    message.pd[i] = new $util.LongBits(object.pd[i].low >>> 0, object.pd[i].high >>> 0).toNumber(true);
        }
        if (object.data1 != null)
            if (typeof object.data1 === "string")
                $util.base64.decode(object.data1, message.data1 = $util.newBuffer($util.base64.length(object.data1)), 0);
            else if (object.data1.length)
                message.data1 = object.data1;
        if (object.data2 != null)
            if (typeof object.data2 === "string")
                $util.base64.decode(object.data2, message.data2 = $util.newBuffer($util.base64.length(object.data2)), 0);
            else if (object.data2.length)
                message.data2 = object.data2;
        return message;
    };

    DebugMoneroDiagRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.pd = [];
        if (options.defaults) {
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.ins = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.ins = options.longs === String ? "0" : 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.p1 = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.p1 = options.longs === String ? "0" : 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.p2 = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.p2 = options.longs === String ? "0" : 0;
            if (options.bytes === String)
                object.data1 = "";
            else {
                object.data1 = [];
                if (options.bytes !== Array)
                    object.data1 = $util.newBuffer(object.data1);
            }
            if (options.bytes === String)
                object.data2 = "";
            else {
                object.data2 = [];
                if (options.bytes !== Array)
                    object.data2 = $util.newBuffer(object.data2);
            }
        }
        if (message.ins != null && message.hasOwnProperty("ins"))
            if (typeof message.ins === "number")
                object.ins = options.longs === String ? String(message.ins) : message.ins;
            else
                object.ins = options.longs === String ? $util.Long.prototype.toString.call(message.ins) : options.longs === Number ? new $util.LongBits(message.ins.low >>> 0, message.ins.high >>> 0).toNumber(true) : message.ins;
        if (message.p1 != null && message.hasOwnProperty("p1"))
            if (typeof message.p1 === "number")
                object.p1 = options.longs === String ? String(message.p1) : message.p1;
            else
                object.p1 = options.longs === String ? $util.Long.prototype.toString.call(message.p1) : options.longs === Number ? new $util.LongBits(message.p1.low >>> 0, message.p1.high >>> 0).toNumber(true) : message.p1;
        if (message.p2 != null && message.hasOwnProperty("p2"))
            if (typeof message.p2 === "number")
                object.p2 = options.longs === String ? String(message.p2) : message.p2;
            else
                object.p2 = options.longs === String ? $util.Long.prototype.toString.call(message.p2) : options.longs === Number ? new $util.LongBits(message.p2.low >>> 0, message.p2.high >>> 0).toNumber(true) : message.p2;
        if (message.pd && message.pd.length) {
            object.pd = [];
            for (var j = 0; j < message.pd.length; ++j)
                if (typeof message.pd[j] === "number")
                    object.pd[j] = options.longs === String ? String(message.pd[j]) : message.pd[j];
                else
                    object.pd[j] = options.longs === String ? $util.Long.prototype.toString.call(message.pd[j]) : options.longs === Number ? new $util.LongBits(message.pd[j].low >>> 0, message.pd[j].high >>> 0).toNumber(true) : message.pd[j];
        }
        if (message.data1 != null && message.hasOwnProperty("data1"))
            object.data1 = options.bytes === String ? $util.base64.encode(message.data1, 0, message.data1.length) : options.bytes === Array ? Array.prototype.slice.call(message.data1) : message.data1;
        if (message.data2 != null && message.hasOwnProperty("data2"))
            object.data2 = options.bytes === String ? $util.base64.encode(message.data2, 0, message.data2.length) : options.bytes === Array ? Array.prototype.slice.call(message.data2) : message.data2;
        return object;
    };

    DebugMoneroDiagRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DebugMoneroDiagRequest;
})();

$root.DebugMoneroDiagAck = (function() {

    function DebugMoneroDiagAck(properties) {
        this.pd = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DebugMoneroDiagAck.prototype.ins = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    DebugMoneroDiagAck.prototype.p1 = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    DebugMoneroDiagAck.prototype.p2 = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    DebugMoneroDiagAck.prototype.pd = $util.emptyArray;
    DebugMoneroDiagAck.prototype.data1 = $util.newBuffer([]);
    DebugMoneroDiagAck.prototype.data2 = $util.newBuffer([]);

    DebugMoneroDiagAck.create = function create(properties) {
        return new DebugMoneroDiagAck(properties);
    };

    DebugMoneroDiagAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.ins != null && Object.hasOwnProperty.call(message, "ins"))
            writer.uint32(8).uint64(message.ins);
        if (message.p1 != null && Object.hasOwnProperty.call(message, "p1"))
            writer.uint32(16).uint64(message.p1);
        if (message.p2 != null && Object.hasOwnProperty.call(message, "p2"))
            writer.uint32(24).uint64(message.p2);
        if (message.pd != null && message.pd.length)
            for (var i = 0; i < message.pd.length; ++i)
                writer.uint32(32).uint64(message.pd[i]);
        if (message.data1 != null && Object.hasOwnProperty.call(message, "data1"))
            writer.uint32(42).bytes(message.data1);
        if (message.data2 != null && Object.hasOwnProperty.call(message, "data2"))
            writer.uint32(50).bytes(message.data2);
        return writer;
    };

    DebugMoneroDiagAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DebugMoneroDiagAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DebugMoneroDiagAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.ins = reader.uint64();
                break;
            case 2:
                message.p1 = reader.uint64();
                break;
            case 3:
                message.p2 = reader.uint64();
                break;
            case 4:
                if (!(message.pd && message.pd.length))
                    message.pd = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.pd.push(reader.uint64());
                } else
                    message.pd.push(reader.uint64());
                break;
            case 5:
                message.data1 = reader.bytes();
                break;
            case 6:
                message.data2 = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    DebugMoneroDiagAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DebugMoneroDiagAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.ins != null && message.hasOwnProperty("ins"))
            if (!$util.isInteger(message.ins) && !(message.ins && $util.isInteger(message.ins.low) && $util.isInteger(message.ins.high)))
                return "ins: integer|Long expected";
        if (message.p1 != null && message.hasOwnProperty("p1"))
            if (!$util.isInteger(message.p1) && !(message.p1 && $util.isInteger(message.p1.low) && $util.isInteger(message.p1.high)))
                return "p1: integer|Long expected";
        if (message.p2 != null && message.hasOwnProperty("p2"))
            if (!$util.isInteger(message.p2) && !(message.p2 && $util.isInteger(message.p2.low) && $util.isInteger(message.p2.high)))
                return "p2: integer|Long expected";
        if (message.pd != null && message.hasOwnProperty("pd")) {
            if (!Array.isArray(message.pd))
                return "pd: array expected";
            for (var i = 0; i < message.pd.length; ++i)
                if (!$util.isInteger(message.pd[i]) && !(message.pd[i] && $util.isInteger(message.pd[i].low) && $util.isInteger(message.pd[i].high)))
                    return "pd: integer|Long[] expected";
        }
        if (message.data1 != null && message.hasOwnProperty("data1"))
            if (!(message.data1 && typeof message.data1.length === "number" || $util.isString(message.data1)))
                return "data1: buffer expected";
        if (message.data2 != null && message.hasOwnProperty("data2"))
            if (!(message.data2 && typeof message.data2.length === "number" || $util.isString(message.data2)))
                return "data2: buffer expected";
        return null;
    };

    DebugMoneroDiagAck.fromObject = function fromObject(object) {
        if (object instanceof $root.DebugMoneroDiagAck)
            return object;
        var message = new $root.DebugMoneroDiagAck();
        if (object.ins != null)
            if ($util.Long)
                (message.ins = $util.Long.fromValue(object.ins)).unsigned = true;
            else if (typeof object.ins === "string")
                message.ins = parseInt(object.ins, 10);
            else if (typeof object.ins === "number")
                message.ins = object.ins;
            else if (typeof object.ins === "object")
                message.ins = new $util.LongBits(object.ins.low >>> 0, object.ins.high >>> 0).toNumber(true);
        if (object.p1 != null)
            if ($util.Long)
                (message.p1 = $util.Long.fromValue(object.p1)).unsigned = true;
            else if (typeof object.p1 === "string")
                message.p1 = parseInt(object.p1, 10);
            else if (typeof object.p1 === "number")
                message.p1 = object.p1;
            else if (typeof object.p1 === "object")
                message.p1 = new $util.LongBits(object.p1.low >>> 0, object.p1.high >>> 0).toNumber(true);
        if (object.p2 != null)
            if ($util.Long)
                (message.p2 = $util.Long.fromValue(object.p2)).unsigned = true;
            else if (typeof object.p2 === "string")
                message.p2 = parseInt(object.p2, 10);
            else if (typeof object.p2 === "number")
                message.p2 = object.p2;
            else if (typeof object.p2 === "object")
                message.p2 = new $util.LongBits(object.p2.low >>> 0, object.p2.high >>> 0).toNumber(true);
        if (object.pd) {
            if (!Array.isArray(object.pd))
                throw TypeError(".DebugMoneroDiagAck.pd: array expected");
            message.pd = [];
            for (var i = 0; i < object.pd.length; ++i)
                if ($util.Long)
                    (message.pd[i] = $util.Long.fromValue(object.pd[i])).unsigned = true;
                else if (typeof object.pd[i] === "string")
                    message.pd[i] = parseInt(object.pd[i], 10);
                else if (typeof object.pd[i] === "number")
                    message.pd[i] = object.pd[i];
                else if (typeof object.pd[i] === "object")
                    message.pd[i] = new $util.LongBits(object.pd[i].low >>> 0, object.pd[i].high >>> 0).toNumber(true);
        }
        if (object.data1 != null)
            if (typeof object.data1 === "string")
                $util.base64.decode(object.data1, message.data1 = $util.newBuffer($util.base64.length(object.data1)), 0);
            else if (object.data1.length)
                message.data1 = object.data1;
        if (object.data2 != null)
            if (typeof object.data2 === "string")
                $util.base64.decode(object.data2, message.data2 = $util.newBuffer($util.base64.length(object.data2)), 0);
            else if (object.data2.length)
                message.data2 = object.data2;
        return message;
    };

    DebugMoneroDiagAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.pd = [];
        if (options.defaults) {
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.ins = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.ins = options.longs === String ? "0" : 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.p1 = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.p1 = options.longs === String ? "0" : 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.p2 = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.p2 = options.longs === String ? "0" : 0;
            if (options.bytes === String)
                object.data1 = "";
            else {
                object.data1 = [];
                if (options.bytes !== Array)
                    object.data1 = $util.newBuffer(object.data1);
            }
            if (options.bytes === String)
                object.data2 = "";
            else {
                object.data2 = [];
                if (options.bytes !== Array)
                    object.data2 = $util.newBuffer(object.data2);
            }
        }
        if (message.ins != null && message.hasOwnProperty("ins"))
            if (typeof message.ins === "number")
                object.ins = options.longs === String ? String(message.ins) : message.ins;
            else
                object.ins = options.longs === String ? $util.Long.prototype.toString.call(message.ins) : options.longs === Number ? new $util.LongBits(message.ins.low >>> 0, message.ins.high >>> 0).toNumber(true) : message.ins;
        if (message.p1 != null && message.hasOwnProperty("p1"))
            if (typeof message.p1 === "number")
                object.p1 = options.longs === String ? String(message.p1) : message.p1;
            else
                object.p1 = options.longs === String ? $util.Long.prototype.toString.call(message.p1) : options.longs === Number ? new $util.LongBits(message.p1.low >>> 0, message.p1.high >>> 0).toNumber(true) : message.p1;
        if (message.p2 != null && message.hasOwnProperty("p2"))
            if (typeof message.p2 === "number")
                object.p2 = options.longs === String ? String(message.p2) : message.p2;
            else
                object.p2 = options.longs === String ? $util.Long.prototype.toString.call(message.p2) : options.longs === Number ? new $util.LongBits(message.p2.low >>> 0, message.p2.high >>> 0).toNumber(true) : message.p2;
        if (message.pd && message.pd.length) {
            object.pd = [];
            for (var j = 0; j < message.pd.length; ++j)
                if (typeof message.pd[j] === "number")
                    object.pd[j] = options.longs === String ? String(message.pd[j]) : message.pd[j];
                else
                    object.pd[j] = options.longs === String ? $util.Long.prototype.toString.call(message.pd[j]) : options.longs === Number ? new $util.LongBits(message.pd[j].low >>> 0, message.pd[j].high >>> 0).toNumber(true) : message.pd[j];
        }
        if (message.data1 != null && message.hasOwnProperty("data1"))
            object.data1 = options.bytes === String ? $util.base64.encode(message.data1, 0, message.data1.length) : options.bytes === Array ? Array.prototype.slice.call(message.data1) : message.data1;
        if (message.data2 != null && message.hasOwnProperty("data2"))
            object.data2 = options.bytes === String ? $util.base64.encode(message.data2, 0, message.data2.length) : options.bytes === Array ? Array.prototype.slice.call(message.data2) : message.data2;
        return object;
    };

    DebugMoneroDiagAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DebugMoneroDiagAck;
})();

$root.NearGetAddress = (function() {

    function NearGetAddress(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NearGetAddress.prototype.address_n = $util.emptyArray;
    NearGetAddress.prototype.show_display = false;

    NearGetAddress.create = function create(properties) {
        return new NearGetAddress(properties);
    };

    NearGetAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(16).bool(message.show_display);
        return writer;
    };

    NearGetAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NearGetAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NearGetAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.show_display = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    NearGetAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NearGetAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        return null;
    };

    NearGetAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.NearGetAddress)
            return object;
        var message = new $root.NearGetAddress();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".NearGetAddress.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        return message;
    };

    NearGetAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            object.show_display = false;
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        return object;
    };

    NearGetAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NearGetAddress;
})();

$root.NearAddress = (function() {

    function NearAddress(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NearAddress.prototype.address = "";

    NearAddress.create = function create(properties) {
        return new NearAddress(properties);
    };

    NearAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address != null && Object.hasOwnProperty.call(message, "address"))
            writer.uint32(10).string(message.address);
        return writer;
    };

    NearAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NearAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NearAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    NearAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NearAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address != null && message.hasOwnProperty("address"))
            if (!$util.isString(message.address))
                return "address: string expected";
        return null;
    };

    NearAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.NearAddress)
            return object;
        var message = new $root.NearAddress();
        if (object.address != null)
            message.address = String(object.address);
        return message;
    };

    NearAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.address = "";
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    NearAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NearAddress;
})();

$root.NearSignTx = (function() {

    function NearSignTx(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NearSignTx.prototype.address_n = $util.emptyArray;
    NearSignTx.prototype.raw_tx = $util.newBuffer([]);

    NearSignTx.create = function create(properties) {
        return new NearSignTx(properties);
    };

    NearSignTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).bytes(message.raw_tx);
        return writer;
    };

    NearSignTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NearSignTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NearSignTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.raw_tx = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("raw_tx"))
            throw $util.ProtocolError("missing required 'raw_tx'", { instance: message });
        return message;
    };

    NearSignTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NearSignTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!(message.raw_tx && typeof message.raw_tx.length === "number" || $util.isString(message.raw_tx)))
            return "raw_tx: buffer expected";
        return null;
    };

    NearSignTx.fromObject = function fromObject(object) {
        if (object instanceof $root.NearSignTx)
            return object;
        var message = new $root.NearSignTx();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".NearSignTx.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.raw_tx != null)
            if (typeof object.raw_tx === "string")
                $util.base64.decode(object.raw_tx, message.raw_tx = $util.newBuffer($util.base64.length(object.raw_tx)), 0);
            else if (object.raw_tx.length)
                message.raw_tx = object.raw_tx;
        return message;
    };

    NearSignTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            if (options.bytes === String)
                object.raw_tx = "";
            else {
                object.raw_tx = [];
                if (options.bytes !== Array)
                    object.raw_tx = $util.newBuffer(object.raw_tx);
            }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.raw_tx != null && message.hasOwnProperty("raw_tx"))
            object.raw_tx = options.bytes === String ? $util.base64.encode(message.raw_tx, 0, message.raw_tx.length) : options.bytes === Array ? Array.prototype.slice.call(message.raw_tx) : message.raw_tx;
        return object;
    };

    NearSignTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NearSignTx;
})();

$root.NearSignedTx = (function() {

    function NearSignedTx(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NearSignedTx.prototype.signature = $util.newBuffer([]);

    NearSignedTx.create = function create(properties) {
        return new NearSignedTx(properties);
    };

    NearSignedTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.signature);
        return writer;
    };

    NearSignedTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NearSignedTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NearSignedTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.signature = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        return message;
    };

    NearSignedTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NearSignedTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        return null;
    };

    NearSignedTx.fromObject = function fromObject(object) {
        if (object instanceof $root.NearSignedTx)
            return object;
        var message = new $root.NearSignedTx();
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        return message;
    };

    NearSignedTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        return object;
    };

    NearSignedTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NearSignedTx;
})();

$root.NEMGetAddress = (function() {

    function NEMGetAddress(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NEMGetAddress.prototype.address_n = $util.emptyArray;
    NEMGetAddress.prototype.network = 104;
    NEMGetAddress.prototype.show_display = false;

    NEMGetAddress.create = function create(properties) {
        return new NEMGetAddress(properties);
    };

    NEMGetAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.network != null && Object.hasOwnProperty.call(message, "network"))
            writer.uint32(16).uint32(message.network);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(24).bool(message.show_display);
        return writer;
    };

    NEMGetAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NEMGetAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NEMGetAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.network = reader.uint32();
                break;
            case 3:
                message.show_display = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    NEMGetAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NEMGetAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.network != null && message.hasOwnProperty("network"))
            if (!$util.isInteger(message.network))
                return "network: integer expected";
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        return null;
    };

    NEMGetAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.NEMGetAddress)
            return object;
        var message = new $root.NEMGetAddress();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".NEMGetAddress.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.network != null)
            message.network = object.network >>> 0;
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        return message;
    };

    NEMGetAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            object.network = 104;
            object.show_display = false;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.network != null && message.hasOwnProperty("network"))
            object.network = message.network;
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        return object;
    };

    NEMGetAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NEMGetAddress;
})();

$root.NEMAddress = (function() {

    function NEMAddress(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NEMAddress.prototype.address = "";

    NEMAddress.create = function create(properties) {
        return new NEMAddress(properties);
    };

    NEMAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.address);
        return writer;
    };

    NEMAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NEMAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NEMAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("address"))
            throw $util.ProtocolError("missing required 'address'", { instance: message });
        return message;
    };

    NEMAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NEMAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.address))
            return "address: string expected";
        return null;
    };

    NEMAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.NEMAddress)
            return object;
        var message = new $root.NEMAddress();
        if (object.address != null)
            message.address = String(object.address);
        return message;
    };

    NEMAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.address = "";
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    NEMAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NEMAddress;
})();

$root.NEMSignTx = (function() {

    function NEMSignTx(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NEMSignTx.prototype.transaction = null;
    NEMSignTx.prototype.multisig = null;
    NEMSignTx.prototype.transfer = null;
    NEMSignTx.prototype.cosigning = false;
    NEMSignTx.prototype.provision_namespace = null;
    NEMSignTx.prototype.mosaic_creation = null;
    NEMSignTx.prototype.supply_change = null;
    NEMSignTx.prototype.aggregate_modification = null;
    NEMSignTx.prototype.importance_transfer = null;

    NEMSignTx.create = function create(properties) {
        return new NEMSignTx(properties);
    };

    NEMSignTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        $root.NEMSignTx.NEMTransactionCommon.encode(message.transaction, writer.uint32(10).fork()).ldelim();
        if (message.multisig != null && Object.hasOwnProperty.call(message, "multisig"))
            $root.NEMSignTx.NEMTransactionCommon.encode(message.multisig, writer.uint32(18).fork()).ldelim();
        if (message.transfer != null && Object.hasOwnProperty.call(message, "transfer"))
            $root.NEMSignTx.NEMTransfer.encode(message.transfer, writer.uint32(26).fork()).ldelim();
        if (message.cosigning != null && Object.hasOwnProperty.call(message, "cosigning"))
            writer.uint32(32).bool(message.cosigning);
        if (message.provision_namespace != null && Object.hasOwnProperty.call(message, "provision_namespace"))
            $root.NEMSignTx.NEMProvisionNamespace.encode(message.provision_namespace, writer.uint32(42).fork()).ldelim();
        if (message.mosaic_creation != null && Object.hasOwnProperty.call(message, "mosaic_creation"))
            $root.NEMSignTx.NEMMosaicCreation.encode(message.mosaic_creation, writer.uint32(50).fork()).ldelim();
        if (message.supply_change != null && Object.hasOwnProperty.call(message, "supply_change"))
            $root.NEMSignTx.NEMMosaicSupplyChange.encode(message.supply_change, writer.uint32(58).fork()).ldelim();
        if (message.aggregate_modification != null && Object.hasOwnProperty.call(message, "aggregate_modification"))
            $root.NEMSignTx.NEMAggregateModification.encode(message.aggregate_modification, writer.uint32(66).fork()).ldelim();
        if (message.importance_transfer != null && Object.hasOwnProperty.call(message, "importance_transfer"))
            $root.NEMSignTx.NEMImportanceTransfer.encode(message.importance_transfer, writer.uint32(74).fork()).ldelim();
        return writer;
    };

    NEMSignTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NEMSignTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NEMSignTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.transaction = $root.NEMSignTx.NEMTransactionCommon.decode(reader, reader.uint32());
                break;
            case 2:
                message.multisig = $root.NEMSignTx.NEMTransactionCommon.decode(reader, reader.uint32());
                break;
            case 3:
                message.transfer = $root.NEMSignTx.NEMTransfer.decode(reader, reader.uint32());
                break;
            case 4:
                message.cosigning = reader.bool();
                break;
            case 5:
                message.provision_namespace = $root.NEMSignTx.NEMProvisionNamespace.decode(reader, reader.uint32());
                break;
            case 6:
                message.mosaic_creation = $root.NEMSignTx.NEMMosaicCreation.decode(reader, reader.uint32());
                break;
            case 7:
                message.supply_change = $root.NEMSignTx.NEMMosaicSupplyChange.decode(reader, reader.uint32());
                break;
            case 8:
                message.aggregate_modification = $root.NEMSignTx.NEMAggregateModification.decode(reader, reader.uint32());
                break;
            case 9:
                message.importance_transfer = $root.NEMSignTx.NEMImportanceTransfer.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("transaction"))
            throw $util.ProtocolError("missing required 'transaction'", { instance: message });
        return message;
    };

    NEMSignTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NEMSignTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        {
            var error = $root.NEMSignTx.NEMTransactionCommon.verify(message.transaction);
            if (error)
                return "transaction." + error;
        }
        if (message.multisig != null && message.hasOwnProperty("multisig")) {
            var error = $root.NEMSignTx.NEMTransactionCommon.verify(message.multisig);
            if (error)
                return "multisig." + error;
        }
        if (message.transfer != null && message.hasOwnProperty("transfer")) {
            var error = $root.NEMSignTx.NEMTransfer.verify(message.transfer);
            if (error)
                return "transfer." + error;
        }
        if (message.cosigning != null && message.hasOwnProperty("cosigning"))
            if (typeof message.cosigning !== "boolean")
                return "cosigning: boolean expected";
        if (message.provision_namespace != null && message.hasOwnProperty("provision_namespace")) {
            var error = $root.NEMSignTx.NEMProvisionNamespace.verify(message.provision_namespace);
            if (error)
                return "provision_namespace." + error;
        }
        if (message.mosaic_creation != null && message.hasOwnProperty("mosaic_creation")) {
            var error = $root.NEMSignTx.NEMMosaicCreation.verify(message.mosaic_creation);
            if (error)
                return "mosaic_creation." + error;
        }
        if (message.supply_change != null && message.hasOwnProperty("supply_change")) {
            var error = $root.NEMSignTx.NEMMosaicSupplyChange.verify(message.supply_change);
            if (error)
                return "supply_change." + error;
        }
        if (message.aggregate_modification != null && message.hasOwnProperty("aggregate_modification")) {
            var error = $root.NEMSignTx.NEMAggregateModification.verify(message.aggregate_modification);
            if (error)
                return "aggregate_modification." + error;
        }
        if (message.importance_transfer != null && message.hasOwnProperty("importance_transfer")) {
            var error = $root.NEMSignTx.NEMImportanceTransfer.verify(message.importance_transfer);
            if (error)
                return "importance_transfer." + error;
        }
        return null;
    };

    NEMSignTx.fromObject = function fromObject(object) {
        if (object instanceof $root.NEMSignTx)
            return object;
        var message = new $root.NEMSignTx();
        if (object.transaction != null) {
            if (typeof object.transaction !== "object")
                throw TypeError(".NEMSignTx.transaction: object expected");
            message.transaction = $root.NEMSignTx.NEMTransactionCommon.fromObject(object.transaction);
        }
        if (object.multisig != null) {
            if (typeof object.multisig !== "object")
                throw TypeError(".NEMSignTx.multisig: object expected");
            message.multisig = $root.NEMSignTx.NEMTransactionCommon.fromObject(object.multisig);
        }
        if (object.transfer != null) {
            if (typeof object.transfer !== "object")
                throw TypeError(".NEMSignTx.transfer: object expected");
            message.transfer = $root.NEMSignTx.NEMTransfer.fromObject(object.transfer);
        }
        if (object.cosigning != null)
            message.cosigning = Boolean(object.cosigning);
        if (object.provision_namespace != null) {
            if (typeof object.provision_namespace !== "object")
                throw TypeError(".NEMSignTx.provision_namespace: object expected");
            message.provision_namespace = $root.NEMSignTx.NEMProvisionNamespace.fromObject(object.provision_namespace);
        }
        if (object.mosaic_creation != null) {
            if (typeof object.mosaic_creation !== "object")
                throw TypeError(".NEMSignTx.mosaic_creation: object expected");
            message.mosaic_creation = $root.NEMSignTx.NEMMosaicCreation.fromObject(object.mosaic_creation);
        }
        if (object.supply_change != null) {
            if (typeof object.supply_change !== "object")
                throw TypeError(".NEMSignTx.supply_change: object expected");
            message.supply_change = $root.NEMSignTx.NEMMosaicSupplyChange.fromObject(object.supply_change);
        }
        if (object.aggregate_modification != null) {
            if (typeof object.aggregate_modification !== "object")
                throw TypeError(".NEMSignTx.aggregate_modification: object expected");
            message.aggregate_modification = $root.NEMSignTx.NEMAggregateModification.fromObject(object.aggregate_modification);
        }
        if (object.importance_transfer != null) {
            if (typeof object.importance_transfer !== "object")
                throw TypeError(".NEMSignTx.importance_transfer: object expected");
            message.importance_transfer = $root.NEMSignTx.NEMImportanceTransfer.fromObject(object.importance_transfer);
        }
        return message;
    };

    NEMSignTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.transaction = null;
            object.multisig = null;
            object.transfer = null;
            object.cosigning = false;
            object.provision_namespace = null;
            object.mosaic_creation = null;
            object.supply_change = null;
            object.aggregate_modification = null;
            object.importance_transfer = null;
        }
        if (message.transaction != null && message.hasOwnProperty("transaction"))
            object.transaction = $root.NEMSignTx.NEMTransactionCommon.toObject(message.transaction, options);
        if (message.multisig != null && message.hasOwnProperty("multisig"))
            object.multisig = $root.NEMSignTx.NEMTransactionCommon.toObject(message.multisig, options);
        if (message.transfer != null && message.hasOwnProperty("transfer"))
            object.transfer = $root.NEMSignTx.NEMTransfer.toObject(message.transfer, options);
        if (message.cosigning != null && message.hasOwnProperty("cosigning"))
            object.cosigning = message.cosigning;
        if (message.provision_namespace != null && message.hasOwnProperty("provision_namespace"))
            object.provision_namespace = $root.NEMSignTx.NEMProvisionNamespace.toObject(message.provision_namespace, options);
        if (message.mosaic_creation != null && message.hasOwnProperty("mosaic_creation"))
            object.mosaic_creation = $root.NEMSignTx.NEMMosaicCreation.toObject(message.mosaic_creation, options);
        if (message.supply_change != null && message.hasOwnProperty("supply_change"))
            object.supply_change = $root.NEMSignTx.NEMMosaicSupplyChange.toObject(message.supply_change, options);
        if (message.aggregate_modification != null && message.hasOwnProperty("aggregate_modification"))
            object.aggregate_modification = $root.NEMSignTx.NEMAggregateModification.toObject(message.aggregate_modification, options);
        if (message.importance_transfer != null && message.hasOwnProperty("importance_transfer"))
            object.importance_transfer = $root.NEMSignTx.NEMImportanceTransfer.toObject(message.importance_transfer, options);
        return object;
    };

    NEMSignTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    NEMSignTx.NEMTransactionCommon = (function() {

        function NEMTransactionCommon(properties) {
            this.address_n = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        NEMTransactionCommon.prototype.address_n = $util.emptyArray;
        NEMTransactionCommon.prototype.network = 104;
        NEMTransactionCommon.prototype.timestamp = 0;
        NEMTransactionCommon.prototype.fee = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        NEMTransactionCommon.prototype.deadline = 0;
        NEMTransactionCommon.prototype.signer = $util.newBuffer([]);

        NEMTransactionCommon.create = function create(properties) {
            return new NEMTransactionCommon(properties);
        };

        NEMTransactionCommon.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.address_n != null && message.address_n.length)
                for (var i = 0; i < message.address_n.length; ++i)
                    writer.uint32(8).uint32(message.address_n[i]);
            if (message.network != null && Object.hasOwnProperty.call(message, "network"))
                writer.uint32(16).uint32(message.network);
            writer.uint32(24).uint32(message.timestamp);
            writer.uint32(32).uint64(message.fee);
            writer.uint32(40).uint32(message.deadline);
            if (message.signer != null && Object.hasOwnProperty.call(message, "signer"))
                writer.uint32(50).bytes(message.signer);
            return writer;
        };

        NEMTransactionCommon.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        NEMTransactionCommon.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NEMSignTx.NEMTransactionCommon();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.address_n && message.address_n.length))
                        message.address_n = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.address_n.push(reader.uint32());
                    } else
                        message.address_n.push(reader.uint32());
                    break;
                case 2:
                    message.network = reader.uint32();
                    break;
                case 3:
                    message.timestamp = reader.uint32();
                    break;
                case 4:
                    message.fee = reader.uint64();
                    break;
                case 5:
                    message.deadline = reader.uint32();
                    break;
                case 6:
                    message.signer = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("timestamp"))
                throw $util.ProtocolError("missing required 'timestamp'", { instance: message });
            if (!message.hasOwnProperty("fee"))
                throw $util.ProtocolError("missing required 'fee'", { instance: message });
            if (!message.hasOwnProperty("deadline"))
                throw $util.ProtocolError("missing required 'deadline'", { instance: message });
            return message;
        };

        NEMTransactionCommon.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        NEMTransactionCommon.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.address_n != null && message.hasOwnProperty("address_n")) {
                if (!Array.isArray(message.address_n))
                    return "address_n: array expected";
                for (var i = 0; i < message.address_n.length; ++i)
                    if (!$util.isInteger(message.address_n[i]))
                        return "address_n: integer[] expected";
            }
            if (message.network != null && message.hasOwnProperty("network"))
                if (!$util.isInteger(message.network))
                    return "network: integer expected";
            if (!$util.isInteger(message.timestamp))
                return "timestamp: integer expected";
            if (!$util.isInteger(message.fee) && !(message.fee && $util.isInteger(message.fee.low) && $util.isInteger(message.fee.high)))
                return "fee: integer|Long expected";
            if (!$util.isInteger(message.deadline))
                return "deadline: integer expected";
            if (message.signer != null && message.hasOwnProperty("signer"))
                if (!(message.signer && typeof message.signer.length === "number" || $util.isString(message.signer)))
                    return "signer: buffer expected";
            return null;
        };

        NEMTransactionCommon.fromObject = function fromObject(object) {
            if (object instanceof $root.NEMSignTx.NEMTransactionCommon)
                return object;
            var message = new $root.NEMSignTx.NEMTransactionCommon();
            if (object.address_n) {
                if (!Array.isArray(object.address_n))
                    throw TypeError(".NEMSignTx.NEMTransactionCommon.address_n: array expected");
                message.address_n = [];
                for (var i = 0; i < object.address_n.length; ++i)
                    message.address_n[i] = object.address_n[i] >>> 0;
            }
            if (object.network != null)
                message.network = object.network >>> 0;
            if (object.timestamp != null)
                message.timestamp = object.timestamp >>> 0;
            if (object.fee != null)
                if ($util.Long)
                    (message.fee = $util.Long.fromValue(object.fee)).unsigned = true;
                else if (typeof object.fee === "string")
                    message.fee = parseInt(object.fee, 10);
                else if (typeof object.fee === "number")
                    message.fee = object.fee;
                else if (typeof object.fee === "object")
                    message.fee = new $util.LongBits(object.fee.low >>> 0, object.fee.high >>> 0).toNumber(true);
            if (object.deadline != null)
                message.deadline = object.deadline >>> 0;
            if (object.signer != null)
                if (typeof object.signer === "string")
                    $util.base64.decode(object.signer, message.signer = $util.newBuffer($util.base64.length(object.signer)), 0);
                else if (object.signer.length)
                    message.signer = object.signer;
            return message;
        };

        NEMTransactionCommon.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.address_n = [];
            if (options.defaults) {
                object.network = 104;
                object.timestamp = 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.fee = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.fee = options.longs === String ? "0" : 0;
                object.deadline = 0;
                if (options.bytes === String)
                    object.signer = "";
                else {
                    object.signer = [];
                    if (options.bytes !== Array)
                        object.signer = $util.newBuffer(object.signer);
                }
            }
            if (message.address_n && message.address_n.length) {
                object.address_n = [];
                for (var j = 0; j < message.address_n.length; ++j)
                    object.address_n[j] = message.address_n[j];
            }
            if (message.network != null && message.hasOwnProperty("network"))
                object.network = message.network;
            if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                object.timestamp = message.timestamp;
            if (message.fee != null && message.hasOwnProperty("fee"))
                if (typeof message.fee === "number")
                    object.fee = options.longs === String ? String(message.fee) : message.fee;
                else
                    object.fee = options.longs === String ? $util.Long.prototype.toString.call(message.fee) : options.longs === Number ? new $util.LongBits(message.fee.low >>> 0, message.fee.high >>> 0).toNumber(true) : message.fee;
            if (message.deadline != null && message.hasOwnProperty("deadline"))
                object.deadline = message.deadline;
            if (message.signer != null && message.hasOwnProperty("signer"))
                object.signer = options.bytes === String ? $util.base64.encode(message.signer, 0, message.signer.length) : options.bytes === Array ? Array.prototype.slice.call(message.signer) : message.signer;
            return object;
        };

        NEMTransactionCommon.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return NEMTransactionCommon;
    })();

    NEMSignTx.NEMTransfer = (function() {

        function NEMTransfer(properties) {
            this.mosaics = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        NEMTransfer.prototype.recipient = "";
        NEMTransfer.prototype.amount = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        NEMTransfer.prototype.payload = $util.newBuffer([]);
        NEMTransfer.prototype.public_key = $util.newBuffer([]);
        NEMTransfer.prototype.mosaics = $util.emptyArray;

        NEMTransfer.create = function create(properties) {
            return new NEMTransfer(properties);
        };

        NEMTransfer.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(10).string(message.recipient);
            writer.uint32(16).uint64(message.amount);
            if (message.payload != null && Object.hasOwnProperty.call(message, "payload"))
                writer.uint32(26).bytes(message.payload);
            if (message.public_key != null && Object.hasOwnProperty.call(message, "public_key"))
                writer.uint32(34).bytes(message.public_key);
            if (message.mosaics != null && message.mosaics.length)
                for (var i = 0; i < message.mosaics.length; ++i)
                    $root.NEMSignTx.NEMTransfer.NEMMosaic.encode(message.mosaics[i], writer.uint32(42).fork()).ldelim();
            return writer;
        };

        NEMTransfer.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        NEMTransfer.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NEMSignTx.NEMTransfer();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.recipient = reader.string();
                    break;
                case 2:
                    message.amount = reader.uint64();
                    break;
                case 3:
                    message.payload = reader.bytes();
                    break;
                case 4:
                    message.public_key = reader.bytes();
                    break;
                case 5:
                    if (!(message.mosaics && message.mosaics.length))
                        message.mosaics = [];
                    message.mosaics.push($root.NEMSignTx.NEMTransfer.NEMMosaic.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("recipient"))
                throw $util.ProtocolError("missing required 'recipient'", { instance: message });
            if (!message.hasOwnProperty("amount"))
                throw $util.ProtocolError("missing required 'amount'", { instance: message });
            return message;
        };

        NEMTransfer.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        NEMTransfer.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isString(message.recipient))
                return "recipient: string expected";
            if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
                return "amount: integer|Long expected";
            if (message.payload != null && message.hasOwnProperty("payload"))
                if (!(message.payload && typeof message.payload.length === "number" || $util.isString(message.payload)))
                    return "payload: buffer expected";
            if (message.public_key != null && message.hasOwnProperty("public_key"))
                if (!(message.public_key && typeof message.public_key.length === "number" || $util.isString(message.public_key)))
                    return "public_key: buffer expected";
            if (message.mosaics != null && message.hasOwnProperty("mosaics")) {
                if (!Array.isArray(message.mosaics))
                    return "mosaics: array expected";
                for (var i = 0; i < message.mosaics.length; ++i) {
                    var error = $root.NEMSignTx.NEMTransfer.NEMMosaic.verify(message.mosaics[i]);
                    if (error)
                        return "mosaics." + error;
                }
            }
            return null;
        };

        NEMTransfer.fromObject = function fromObject(object) {
            if (object instanceof $root.NEMSignTx.NEMTransfer)
                return object;
            var message = new $root.NEMSignTx.NEMTransfer();
            if (object.recipient != null)
                message.recipient = String(object.recipient);
            if (object.amount != null)
                if ($util.Long)
                    (message.amount = $util.Long.fromValue(object.amount)).unsigned = true;
                else if (typeof object.amount === "string")
                    message.amount = parseInt(object.amount, 10);
                else if (typeof object.amount === "number")
                    message.amount = object.amount;
                else if (typeof object.amount === "object")
                    message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber(true);
            if (object.payload != null)
                if (typeof object.payload === "string")
                    $util.base64.decode(object.payload, message.payload = $util.newBuffer($util.base64.length(object.payload)), 0);
                else if (object.payload.length)
                    message.payload = object.payload;
            if (object.public_key != null)
                if (typeof object.public_key === "string")
                    $util.base64.decode(object.public_key, message.public_key = $util.newBuffer($util.base64.length(object.public_key)), 0);
                else if (object.public_key.length)
                    message.public_key = object.public_key;
            if (object.mosaics) {
                if (!Array.isArray(object.mosaics))
                    throw TypeError(".NEMSignTx.NEMTransfer.mosaics: array expected");
                message.mosaics = [];
                for (var i = 0; i < object.mosaics.length; ++i) {
                    if (typeof object.mosaics[i] !== "object")
                        throw TypeError(".NEMSignTx.NEMTransfer.mosaics: object expected");
                    message.mosaics[i] = $root.NEMSignTx.NEMTransfer.NEMMosaic.fromObject(object.mosaics[i]);
                }
            }
            return message;
        };

        NEMTransfer.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.mosaics = [];
            if (options.defaults) {
                object.recipient = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.amount = options.longs === String ? "0" : 0;
                if (options.bytes === String)
                    object.payload = "";
                else {
                    object.payload = [];
                    if (options.bytes !== Array)
                        object.payload = $util.newBuffer(object.payload);
                }
                if (options.bytes === String)
                    object.public_key = "";
                else {
                    object.public_key = [];
                    if (options.bytes !== Array)
                        object.public_key = $util.newBuffer(object.public_key);
                }
            }
            if (message.recipient != null && message.hasOwnProperty("recipient"))
                object.recipient = message.recipient;
            if (message.amount != null && message.hasOwnProperty("amount"))
                if (typeof message.amount === "number")
                    object.amount = options.longs === String ? String(message.amount) : message.amount;
                else
                    object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber(true) : message.amount;
            if (message.payload != null && message.hasOwnProperty("payload"))
                object.payload = options.bytes === String ? $util.base64.encode(message.payload, 0, message.payload.length) : options.bytes === Array ? Array.prototype.slice.call(message.payload) : message.payload;
            if (message.public_key != null && message.hasOwnProperty("public_key"))
                object.public_key = options.bytes === String ? $util.base64.encode(message.public_key, 0, message.public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.public_key) : message.public_key;
            if (message.mosaics && message.mosaics.length) {
                object.mosaics = [];
                for (var j = 0; j < message.mosaics.length; ++j)
                    object.mosaics[j] = $root.NEMSignTx.NEMTransfer.NEMMosaic.toObject(message.mosaics[j], options);
            }
            return object;
        };

        NEMTransfer.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        NEMTransfer.NEMMosaic = (function() {

            function NEMMosaic(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            NEMMosaic.prototype.namespace = "";
            NEMMosaic.prototype.mosaic = "";
            NEMMosaic.prototype.quantity = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

            NEMMosaic.create = function create(properties) {
                return new NEMMosaic(properties);
            };

            NEMMosaic.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                writer.uint32(10).string(message.namespace);
                writer.uint32(18).string(message.mosaic);
                writer.uint32(24).uint64(message.quantity);
                return writer;
            };

            NEMMosaic.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            NEMMosaic.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NEMSignTx.NEMTransfer.NEMMosaic();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.namespace = reader.string();
                        break;
                    case 2:
                        message.mosaic = reader.string();
                        break;
                    case 3:
                        message.quantity = reader.uint64();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                if (!message.hasOwnProperty("namespace"))
                    throw $util.ProtocolError("missing required 'namespace'", { instance: message });
                if (!message.hasOwnProperty("mosaic"))
                    throw $util.ProtocolError("missing required 'mosaic'", { instance: message });
                if (!message.hasOwnProperty("quantity"))
                    throw $util.ProtocolError("missing required 'quantity'", { instance: message });
                return message;
            };

            NEMMosaic.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            NEMMosaic.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (!$util.isString(message.namespace))
                    return "namespace: string expected";
                if (!$util.isString(message.mosaic))
                    return "mosaic: string expected";
                if (!$util.isInteger(message.quantity) && !(message.quantity && $util.isInteger(message.quantity.low) && $util.isInteger(message.quantity.high)))
                    return "quantity: integer|Long expected";
                return null;
            };

            NEMMosaic.fromObject = function fromObject(object) {
                if (object instanceof $root.NEMSignTx.NEMTransfer.NEMMosaic)
                    return object;
                var message = new $root.NEMSignTx.NEMTransfer.NEMMosaic();
                if (object.namespace != null)
                    message.namespace = String(object.namespace);
                if (object.mosaic != null)
                    message.mosaic = String(object.mosaic);
                if (object.quantity != null)
                    if ($util.Long)
                        (message.quantity = $util.Long.fromValue(object.quantity)).unsigned = true;
                    else if (typeof object.quantity === "string")
                        message.quantity = parseInt(object.quantity, 10);
                    else if (typeof object.quantity === "number")
                        message.quantity = object.quantity;
                    else if (typeof object.quantity === "object")
                        message.quantity = new $util.LongBits(object.quantity.low >>> 0, object.quantity.high >>> 0).toNumber(true);
                return message;
            };

            NEMMosaic.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.namespace = "";
                    object.mosaic = "";
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, true);
                        object.quantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.quantity = options.longs === String ? "0" : 0;
                }
                if (message.namespace != null && message.hasOwnProperty("namespace"))
                    object.namespace = message.namespace;
                if (message.mosaic != null && message.hasOwnProperty("mosaic"))
                    object.mosaic = message.mosaic;
                if (message.quantity != null && message.hasOwnProperty("quantity"))
                    if (typeof message.quantity === "number")
                        object.quantity = options.longs === String ? String(message.quantity) : message.quantity;
                    else
                        object.quantity = options.longs === String ? $util.Long.prototype.toString.call(message.quantity) : options.longs === Number ? new $util.LongBits(message.quantity.low >>> 0, message.quantity.high >>> 0).toNumber(true) : message.quantity;
                return object;
            };

            NEMMosaic.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return NEMMosaic;
        })();

        return NEMTransfer;
    })();

    NEMSignTx.NEMProvisionNamespace = (function() {

        function NEMProvisionNamespace(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        NEMProvisionNamespace.prototype.namespace = "";
        NEMProvisionNamespace.prototype.parent = "";
        NEMProvisionNamespace.prototype.sink = "";
        NEMProvisionNamespace.prototype.fee = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        NEMProvisionNamespace.create = function create(properties) {
            return new NEMProvisionNamespace(properties);
        };

        NEMProvisionNamespace.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(10).string(message.namespace);
            if (message.parent != null && Object.hasOwnProperty.call(message, "parent"))
                writer.uint32(18).string(message.parent);
            writer.uint32(26).string(message.sink);
            writer.uint32(32).uint64(message.fee);
            return writer;
        };

        NEMProvisionNamespace.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        NEMProvisionNamespace.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NEMSignTx.NEMProvisionNamespace();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.namespace = reader.string();
                    break;
                case 2:
                    message.parent = reader.string();
                    break;
                case 3:
                    message.sink = reader.string();
                    break;
                case 4:
                    message.fee = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("namespace"))
                throw $util.ProtocolError("missing required 'namespace'", { instance: message });
            if (!message.hasOwnProperty("sink"))
                throw $util.ProtocolError("missing required 'sink'", { instance: message });
            if (!message.hasOwnProperty("fee"))
                throw $util.ProtocolError("missing required 'fee'", { instance: message });
            return message;
        };

        NEMProvisionNamespace.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        NEMProvisionNamespace.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isString(message.namespace))
                return "namespace: string expected";
            if (message.parent != null && message.hasOwnProperty("parent"))
                if (!$util.isString(message.parent))
                    return "parent: string expected";
            if (!$util.isString(message.sink))
                return "sink: string expected";
            if (!$util.isInteger(message.fee) && !(message.fee && $util.isInteger(message.fee.low) && $util.isInteger(message.fee.high)))
                return "fee: integer|Long expected";
            return null;
        };

        NEMProvisionNamespace.fromObject = function fromObject(object) {
            if (object instanceof $root.NEMSignTx.NEMProvisionNamespace)
                return object;
            var message = new $root.NEMSignTx.NEMProvisionNamespace();
            if (object.namespace != null)
                message.namespace = String(object.namespace);
            if (object.parent != null)
                message.parent = String(object.parent);
            if (object.sink != null)
                message.sink = String(object.sink);
            if (object.fee != null)
                if ($util.Long)
                    (message.fee = $util.Long.fromValue(object.fee)).unsigned = true;
                else if (typeof object.fee === "string")
                    message.fee = parseInt(object.fee, 10);
                else if (typeof object.fee === "number")
                    message.fee = object.fee;
                else if (typeof object.fee === "object")
                    message.fee = new $util.LongBits(object.fee.low >>> 0, object.fee.high >>> 0).toNumber(true);
            return message;
        };

        NEMProvisionNamespace.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.namespace = "";
                object.parent = "";
                object.sink = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.fee = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.fee = options.longs === String ? "0" : 0;
            }
            if (message.namespace != null && message.hasOwnProperty("namespace"))
                object.namespace = message.namespace;
            if (message.parent != null && message.hasOwnProperty("parent"))
                object.parent = message.parent;
            if (message.sink != null && message.hasOwnProperty("sink"))
                object.sink = message.sink;
            if (message.fee != null && message.hasOwnProperty("fee"))
                if (typeof message.fee === "number")
                    object.fee = options.longs === String ? String(message.fee) : message.fee;
                else
                    object.fee = options.longs === String ? $util.Long.prototype.toString.call(message.fee) : options.longs === Number ? new $util.LongBits(message.fee.low >>> 0, message.fee.high >>> 0).toNumber(true) : message.fee;
            return object;
        };

        NEMProvisionNamespace.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return NEMProvisionNamespace;
    })();

    NEMSignTx.NEMMosaicCreation = (function() {

        function NEMMosaicCreation(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        NEMMosaicCreation.prototype.definition = null;
        NEMMosaicCreation.prototype.sink = "";
        NEMMosaicCreation.prototype.fee = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        NEMMosaicCreation.create = function create(properties) {
            return new NEMMosaicCreation(properties);
        };

        NEMMosaicCreation.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            $root.NEMSignTx.NEMMosaicCreation.NEMMosaicDefinition.encode(message.definition, writer.uint32(10).fork()).ldelim();
            writer.uint32(18).string(message.sink);
            writer.uint32(24).uint64(message.fee);
            return writer;
        };

        NEMMosaicCreation.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        NEMMosaicCreation.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NEMSignTx.NEMMosaicCreation();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.definition = $root.NEMSignTx.NEMMosaicCreation.NEMMosaicDefinition.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.sink = reader.string();
                    break;
                case 3:
                    message.fee = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("definition"))
                throw $util.ProtocolError("missing required 'definition'", { instance: message });
            if (!message.hasOwnProperty("sink"))
                throw $util.ProtocolError("missing required 'sink'", { instance: message });
            if (!message.hasOwnProperty("fee"))
                throw $util.ProtocolError("missing required 'fee'", { instance: message });
            return message;
        };

        NEMMosaicCreation.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        NEMMosaicCreation.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            {
                var error = $root.NEMSignTx.NEMMosaicCreation.NEMMosaicDefinition.verify(message.definition);
                if (error)
                    return "definition." + error;
            }
            if (!$util.isString(message.sink))
                return "sink: string expected";
            if (!$util.isInteger(message.fee) && !(message.fee && $util.isInteger(message.fee.low) && $util.isInteger(message.fee.high)))
                return "fee: integer|Long expected";
            return null;
        };

        NEMMosaicCreation.fromObject = function fromObject(object) {
            if (object instanceof $root.NEMSignTx.NEMMosaicCreation)
                return object;
            var message = new $root.NEMSignTx.NEMMosaicCreation();
            if (object.definition != null) {
                if (typeof object.definition !== "object")
                    throw TypeError(".NEMSignTx.NEMMosaicCreation.definition: object expected");
                message.definition = $root.NEMSignTx.NEMMosaicCreation.NEMMosaicDefinition.fromObject(object.definition);
            }
            if (object.sink != null)
                message.sink = String(object.sink);
            if (object.fee != null)
                if ($util.Long)
                    (message.fee = $util.Long.fromValue(object.fee)).unsigned = true;
                else if (typeof object.fee === "string")
                    message.fee = parseInt(object.fee, 10);
                else if (typeof object.fee === "number")
                    message.fee = object.fee;
                else if (typeof object.fee === "object")
                    message.fee = new $util.LongBits(object.fee.low >>> 0, object.fee.high >>> 0).toNumber(true);
            return message;
        };

        NEMMosaicCreation.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.definition = null;
                object.sink = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.fee = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.fee = options.longs === String ? "0" : 0;
            }
            if (message.definition != null && message.hasOwnProperty("definition"))
                object.definition = $root.NEMSignTx.NEMMosaicCreation.NEMMosaicDefinition.toObject(message.definition, options);
            if (message.sink != null && message.hasOwnProperty("sink"))
                object.sink = message.sink;
            if (message.fee != null && message.hasOwnProperty("fee"))
                if (typeof message.fee === "number")
                    object.fee = options.longs === String ? String(message.fee) : message.fee;
                else
                    object.fee = options.longs === String ? $util.Long.prototype.toString.call(message.fee) : options.longs === Number ? new $util.LongBits(message.fee.low >>> 0, message.fee.high >>> 0).toNumber(true) : message.fee;
            return object;
        };

        NEMMosaicCreation.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        NEMMosaicCreation.NEMMosaicDefinition = (function() {

            function NEMMosaicDefinition(properties) {
                this.networks = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            NEMMosaicDefinition.prototype.name = "";
            NEMMosaicDefinition.prototype.ticker = "";
            NEMMosaicDefinition.prototype.namespace = "";
            NEMMosaicDefinition.prototype.mosaic = "";
            NEMMosaicDefinition.prototype.divisibility = 0;
            NEMMosaicDefinition.prototype.levy = 1;
            NEMMosaicDefinition.prototype.fee = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
            NEMMosaicDefinition.prototype.levy_address = "";
            NEMMosaicDefinition.prototype.levy_namespace = "";
            NEMMosaicDefinition.prototype.levy_mosaic = "";
            NEMMosaicDefinition.prototype.supply = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
            NEMMosaicDefinition.prototype.mutable_supply = false;
            NEMMosaicDefinition.prototype.transferable = false;
            NEMMosaicDefinition.prototype.description = "";
            NEMMosaicDefinition.prototype.networks = $util.emptyArray;

            NEMMosaicDefinition.create = function create(properties) {
                return new NEMMosaicDefinition(properties);
            };

            NEMMosaicDefinition.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                    writer.uint32(10).string(message.name);
                if (message.ticker != null && Object.hasOwnProperty.call(message, "ticker"))
                    writer.uint32(18).string(message.ticker);
                writer.uint32(26).string(message.namespace);
                writer.uint32(34).string(message.mosaic);
                if (message.divisibility != null && Object.hasOwnProperty.call(message, "divisibility"))
                    writer.uint32(40).uint32(message.divisibility);
                if (message.levy != null && Object.hasOwnProperty.call(message, "levy"))
                    writer.uint32(48).int32(message.levy);
                if (message.fee != null && Object.hasOwnProperty.call(message, "fee"))
                    writer.uint32(56).uint64(message.fee);
                if (message.levy_address != null && Object.hasOwnProperty.call(message, "levy_address"))
                    writer.uint32(66).string(message.levy_address);
                if (message.levy_namespace != null && Object.hasOwnProperty.call(message, "levy_namespace"))
                    writer.uint32(74).string(message.levy_namespace);
                if (message.levy_mosaic != null && Object.hasOwnProperty.call(message, "levy_mosaic"))
                    writer.uint32(82).string(message.levy_mosaic);
                if (message.supply != null && Object.hasOwnProperty.call(message, "supply"))
                    writer.uint32(88).uint64(message.supply);
                if (message.mutable_supply != null && Object.hasOwnProperty.call(message, "mutable_supply"))
                    writer.uint32(96).bool(message.mutable_supply);
                if (message.transferable != null && Object.hasOwnProperty.call(message, "transferable"))
                    writer.uint32(104).bool(message.transferable);
                writer.uint32(114).string(message.description);
                if (message.networks != null && message.networks.length)
                    for (var i = 0; i < message.networks.length; ++i)
                        writer.uint32(120).uint32(message.networks[i]);
                return writer;
            };

            NEMMosaicDefinition.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            NEMMosaicDefinition.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NEMSignTx.NEMMosaicCreation.NEMMosaicDefinition();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.name = reader.string();
                        break;
                    case 2:
                        message.ticker = reader.string();
                        break;
                    case 3:
                        message.namespace = reader.string();
                        break;
                    case 4:
                        message.mosaic = reader.string();
                        break;
                    case 5:
                        message.divisibility = reader.uint32();
                        break;
                    case 6:
                        message.levy = reader.int32();
                        break;
                    case 7:
                        message.fee = reader.uint64();
                        break;
                    case 8:
                        message.levy_address = reader.string();
                        break;
                    case 9:
                        message.levy_namespace = reader.string();
                        break;
                    case 10:
                        message.levy_mosaic = reader.string();
                        break;
                    case 11:
                        message.supply = reader.uint64();
                        break;
                    case 12:
                        message.mutable_supply = reader.bool();
                        break;
                    case 13:
                        message.transferable = reader.bool();
                        break;
                    case 14:
                        message.description = reader.string();
                        break;
                    case 15:
                        if (!(message.networks && message.networks.length))
                            message.networks = [];
                        if ((tag & 7) === 2) {
                            var end2 = reader.uint32() + reader.pos;
                            while (reader.pos < end2)
                                message.networks.push(reader.uint32());
                        } else
                            message.networks.push(reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                if (!message.hasOwnProperty("namespace"))
                    throw $util.ProtocolError("missing required 'namespace'", { instance: message });
                if (!message.hasOwnProperty("mosaic"))
                    throw $util.ProtocolError("missing required 'mosaic'", { instance: message });
                if (!message.hasOwnProperty("description"))
                    throw $util.ProtocolError("missing required 'description'", { instance: message });
                return message;
            };

            NEMMosaicDefinition.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            NEMMosaicDefinition.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.name != null && message.hasOwnProperty("name"))
                    if (!$util.isString(message.name))
                        return "name: string expected";
                if (message.ticker != null && message.hasOwnProperty("ticker"))
                    if (!$util.isString(message.ticker))
                        return "ticker: string expected";
                if (!$util.isString(message.namespace))
                    return "namespace: string expected";
                if (!$util.isString(message.mosaic))
                    return "mosaic: string expected";
                if (message.divisibility != null && message.hasOwnProperty("divisibility"))
                    if (!$util.isInteger(message.divisibility))
                        return "divisibility: integer expected";
                if (message.levy != null && message.hasOwnProperty("levy"))
                    switch (message.levy) {
                    default:
                        return "levy: enum value expected";
                    case 1:
                    case 2:
                        break;
                    }
                if (message.fee != null && message.hasOwnProperty("fee"))
                    if (!$util.isInteger(message.fee) && !(message.fee && $util.isInteger(message.fee.low) && $util.isInteger(message.fee.high)))
                        return "fee: integer|Long expected";
                if (message.levy_address != null && message.hasOwnProperty("levy_address"))
                    if (!$util.isString(message.levy_address))
                        return "levy_address: string expected";
                if (message.levy_namespace != null && message.hasOwnProperty("levy_namespace"))
                    if (!$util.isString(message.levy_namespace))
                        return "levy_namespace: string expected";
                if (message.levy_mosaic != null && message.hasOwnProperty("levy_mosaic"))
                    if (!$util.isString(message.levy_mosaic))
                        return "levy_mosaic: string expected";
                if (message.supply != null && message.hasOwnProperty("supply"))
                    if (!$util.isInteger(message.supply) && !(message.supply && $util.isInteger(message.supply.low) && $util.isInteger(message.supply.high)))
                        return "supply: integer|Long expected";
                if (message.mutable_supply != null && message.hasOwnProperty("mutable_supply"))
                    if (typeof message.mutable_supply !== "boolean")
                        return "mutable_supply: boolean expected";
                if (message.transferable != null && message.hasOwnProperty("transferable"))
                    if (typeof message.transferable !== "boolean")
                        return "transferable: boolean expected";
                if (!$util.isString(message.description))
                    return "description: string expected";
                if (message.networks != null && message.hasOwnProperty("networks")) {
                    if (!Array.isArray(message.networks))
                        return "networks: array expected";
                    for (var i = 0; i < message.networks.length; ++i)
                        if (!$util.isInteger(message.networks[i]))
                            return "networks: integer[] expected";
                }
                return null;
            };

            NEMMosaicDefinition.fromObject = function fromObject(object) {
                if (object instanceof $root.NEMSignTx.NEMMosaicCreation.NEMMosaicDefinition)
                    return object;
                var message = new $root.NEMSignTx.NEMMosaicCreation.NEMMosaicDefinition();
                if (object.name != null)
                    message.name = String(object.name);
                if (object.ticker != null)
                    message.ticker = String(object.ticker);
                if (object.namespace != null)
                    message.namespace = String(object.namespace);
                if (object.mosaic != null)
                    message.mosaic = String(object.mosaic);
                if (object.divisibility != null)
                    message.divisibility = object.divisibility >>> 0;
                switch (object.levy) {
                case "MosaicLevy_Absolute":
                case 1:
                    message.levy = 1;
                    break;
                case "MosaicLevy_Percentile":
                case 2:
                    message.levy = 2;
                    break;
                }
                if (object.fee != null)
                    if ($util.Long)
                        (message.fee = $util.Long.fromValue(object.fee)).unsigned = true;
                    else if (typeof object.fee === "string")
                        message.fee = parseInt(object.fee, 10);
                    else if (typeof object.fee === "number")
                        message.fee = object.fee;
                    else if (typeof object.fee === "object")
                        message.fee = new $util.LongBits(object.fee.low >>> 0, object.fee.high >>> 0).toNumber(true);
                if (object.levy_address != null)
                    message.levy_address = String(object.levy_address);
                if (object.levy_namespace != null)
                    message.levy_namespace = String(object.levy_namespace);
                if (object.levy_mosaic != null)
                    message.levy_mosaic = String(object.levy_mosaic);
                if (object.supply != null)
                    if ($util.Long)
                        (message.supply = $util.Long.fromValue(object.supply)).unsigned = true;
                    else if (typeof object.supply === "string")
                        message.supply = parseInt(object.supply, 10);
                    else if (typeof object.supply === "number")
                        message.supply = object.supply;
                    else if (typeof object.supply === "object")
                        message.supply = new $util.LongBits(object.supply.low >>> 0, object.supply.high >>> 0).toNumber(true);
                if (object.mutable_supply != null)
                    message.mutable_supply = Boolean(object.mutable_supply);
                if (object.transferable != null)
                    message.transferable = Boolean(object.transferable);
                if (object.description != null)
                    message.description = String(object.description);
                if (object.networks) {
                    if (!Array.isArray(object.networks))
                        throw TypeError(".NEMSignTx.NEMMosaicCreation.NEMMosaicDefinition.networks: array expected");
                    message.networks = [];
                    for (var i = 0; i < object.networks.length; ++i)
                        message.networks[i] = object.networks[i] >>> 0;
                }
                return message;
            };

            NEMMosaicDefinition.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.networks = [];
                if (options.defaults) {
                    object.name = "";
                    object.ticker = "";
                    object.namespace = "";
                    object.mosaic = "";
                    object.divisibility = 0;
                    object.levy = options.enums === String ? "MosaicLevy_Absolute" : 1;
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, true);
                        object.fee = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.fee = options.longs === String ? "0" : 0;
                    object.levy_address = "";
                    object.levy_namespace = "";
                    object.levy_mosaic = "";
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, true);
                        object.supply = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.supply = options.longs === String ? "0" : 0;
                    object.mutable_supply = false;
                    object.transferable = false;
                    object.description = "";
                }
                if (message.name != null && message.hasOwnProperty("name"))
                    object.name = message.name;
                if (message.ticker != null && message.hasOwnProperty("ticker"))
                    object.ticker = message.ticker;
                if (message.namespace != null && message.hasOwnProperty("namespace"))
                    object.namespace = message.namespace;
                if (message.mosaic != null && message.hasOwnProperty("mosaic"))
                    object.mosaic = message.mosaic;
                if (message.divisibility != null && message.hasOwnProperty("divisibility"))
                    object.divisibility = message.divisibility;
                if (message.levy != null && message.hasOwnProperty("levy"))
                    object.levy = options.enums === String ? $root.NEMSignTx.NEMMosaicCreation.NEMMosaicDefinition.NEMMosaicLevy[message.levy] : message.levy;
                if (message.fee != null && message.hasOwnProperty("fee"))
                    if (typeof message.fee === "number")
                        object.fee = options.longs === String ? String(message.fee) : message.fee;
                    else
                        object.fee = options.longs === String ? $util.Long.prototype.toString.call(message.fee) : options.longs === Number ? new $util.LongBits(message.fee.low >>> 0, message.fee.high >>> 0).toNumber(true) : message.fee;
                if (message.levy_address != null && message.hasOwnProperty("levy_address"))
                    object.levy_address = message.levy_address;
                if (message.levy_namespace != null && message.hasOwnProperty("levy_namespace"))
                    object.levy_namespace = message.levy_namespace;
                if (message.levy_mosaic != null && message.hasOwnProperty("levy_mosaic"))
                    object.levy_mosaic = message.levy_mosaic;
                if (message.supply != null && message.hasOwnProperty("supply"))
                    if (typeof message.supply === "number")
                        object.supply = options.longs === String ? String(message.supply) : message.supply;
                    else
                        object.supply = options.longs === String ? $util.Long.prototype.toString.call(message.supply) : options.longs === Number ? new $util.LongBits(message.supply.low >>> 0, message.supply.high >>> 0).toNumber(true) : message.supply;
                if (message.mutable_supply != null && message.hasOwnProperty("mutable_supply"))
                    object.mutable_supply = message.mutable_supply;
                if (message.transferable != null && message.hasOwnProperty("transferable"))
                    object.transferable = message.transferable;
                if (message.description != null && message.hasOwnProperty("description"))
                    object.description = message.description;
                if (message.networks && message.networks.length) {
                    object.networks = [];
                    for (var j = 0; j < message.networks.length; ++j)
                        object.networks[j] = message.networks[j];
                }
                return object;
            };

            NEMMosaicDefinition.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            NEMMosaicDefinition.NEMMosaicLevy = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[1] = "MosaicLevy_Absolute"] = 1;
                values[valuesById[2] = "MosaicLevy_Percentile"] = 2;
                return values;
            })();

            return NEMMosaicDefinition;
        })();

        return NEMMosaicCreation;
    })();

    NEMSignTx.NEMMosaicSupplyChange = (function() {

        function NEMMosaicSupplyChange(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        NEMMosaicSupplyChange.prototype.namespace = "";
        NEMMosaicSupplyChange.prototype.mosaic = "";
        NEMMosaicSupplyChange.prototype.type = 1;
        NEMMosaicSupplyChange.prototype.delta = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        NEMMosaicSupplyChange.create = function create(properties) {
            return new NEMMosaicSupplyChange(properties);
        };

        NEMMosaicSupplyChange.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(10).string(message.namespace);
            writer.uint32(18).string(message.mosaic);
            writer.uint32(24).int32(message.type);
            writer.uint32(32).uint64(message.delta);
            return writer;
        };

        NEMMosaicSupplyChange.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        NEMMosaicSupplyChange.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NEMSignTx.NEMMosaicSupplyChange();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.namespace = reader.string();
                    break;
                case 2:
                    message.mosaic = reader.string();
                    break;
                case 3:
                    message.type = reader.int32();
                    break;
                case 4:
                    message.delta = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("namespace"))
                throw $util.ProtocolError("missing required 'namespace'", { instance: message });
            if (!message.hasOwnProperty("mosaic"))
                throw $util.ProtocolError("missing required 'mosaic'", { instance: message });
            if (!message.hasOwnProperty("type"))
                throw $util.ProtocolError("missing required 'type'", { instance: message });
            if (!message.hasOwnProperty("delta"))
                throw $util.ProtocolError("missing required 'delta'", { instance: message });
            return message;
        };

        NEMMosaicSupplyChange.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        NEMMosaicSupplyChange.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isString(message.namespace))
                return "namespace: string expected";
            if (!$util.isString(message.mosaic))
                return "mosaic: string expected";
            switch (message.type) {
            default:
                return "type: enum value expected";
            case 1:
            case 2:
                break;
            }
            if (!$util.isInteger(message.delta) && !(message.delta && $util.isInteger(message.delta.low) && $util.isInteger(message.delta.high)))
                return "delta: integer|Long expected";
            return null;
        };

        NEMMosaicSupplyChange.fromObject = function fromObject(object) {
            if (object instanceof $root.NEMSignTx.NEMMosaicSupplyChange)
                return object;
            var message = new $root.NEMSignTx.NEMMosaicSupplyChange();
            if (object.namespace != null)
                message.namespace = String(object.namespace);
            if (object.mosaic != null)
                message.mosaic = String(object.mosaic);
            switch (object.type) {
            case "SupplyChange_Increase":
            case 1:
                message.type = 1;
                break;
            case "SupplyChange_Decrease":
            case 2:
                message.type = 2;
                break;
            }
            if (object.delta != null)
                if ($util.Long)
                    (message.delta = $util.Long.fromValue(object.delta)).unsigned = true;
                else if (typeof object.delta === "string")
                    message.delta = parseInt(object.delta, 10);
                else if (typeof object.delta === "number")
                    message.delta = object.delta;
                else if (typeof object.delta === "object")
                    message.delta = new $util.LongBits(object.delta.low >>> 0, object.delta.high >>> 0).toNumber(true);
            return message;
        };

        NEMMosaicSupplyChange.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.namespace = "";
                object.mosaic = "";
                object.type = options.enums === String ? "SupplyChange_Increase" : 1;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.delta = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.delta = options.longs === String ? "0" : 0;
            }
            if (message.namespace != null && message.hasOwnProperty("namespace"))
                object.namespace = message.namespace;
            if (message.mosaic != null && message.hasOwnProperty("mosaic"))
                object.mosaic = message.mosaic;
            if (message.type != null && message.hasOwnProperty("type"))
                object.type = options.enums === String ? $root.NEMSignTx.NEMMosaicSupplyChange.NEMSupplyChangeType[message.type] : message.type;
            if (message.delta != null && message.hasOwnProperty("delta"))
                if (typeof message.delta === "number")
                    object.delta = options.longs === String ? String(message.delta) : message.delta;
                else
                    object.delta = options.longs === String ? $util.Long.prototype.toString.call(message.delta) : options.longs === Number ? new $util.LongBits(message.delta.low >>> 0, message.delta.high >>> 0).toNumber(true) : message.delta;
            return object;
        };

        NEMMosaicSupplyChange.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        NEMMosaicSupplyChange.NEMSupplyChangeType = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[1] = "SupplyChange_Increase"] = 1;
            values[valuesById[2] = "SupplyChange_Decrease"] = 2;
            return values;
        })();

        return NEMMosaicSupplyChange;
    })();

    NEMSignTx.NEMAggregateModification = (function() {

        function NEMAggregateModification(properties) {
            this.modifications = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        NEMAggregateModification.prototype.modifications = $util.emptyArray;
        NEMAggregateModification.prototype.relative_change = 0;

        NEMAggregateModification.create = function create(properties) {
            return new NEMAggregateModification(properties);
        };

        NEMAggregateModification.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.modifications != null && message.modifications.length)
                for (var i = 0; i < message.modifications.length; ++i)
                    $root.NEMSignTx.NEMAggregateModification.NEMCosignatoryModification.encode(message.modifications[i], writer.uint32(10).fork()).ldelim();
            if (message.relative_change != null && Object.hasOwnProperty.call(message, "relative_change"))
                writer.uint32(16).sint32(message.relative_change);
            return writer;
        };

        NEMAggregateModification.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        NEMAggregateModification.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NEMSignTx.NEMAggregateModification();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.modifications && message.modifications.length))
                        message.modifications = [];
                    message.modifications.push($root.NEMSignTx.NEMAggregateModification.NEMCosignatoryModification.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.relative_change = reader.sint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        NEMAggregateModification.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        NEMAggregateModification.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.modifications != null && message.hasOwnProperty("modifications")) {
                if (!Array.isArray(message.modifications))
                    return "modifications: array expected";
                for (var i = 0; i < message.modifications.length; ++i) {
                    var error = $root.NEMSignTx.NEMAggregateModification.NEMCosignatoryModification.verify(message.modifications[i]);
                    if (error)
                        return "modifications." + error;
                }
            }
            if (message.relative_change != null && message.hasOwnProperty("relative_change"))
                if (!$util.isInteger(message.relative_change))
                    return "relative_change: integer expected";
            return null;
        };

        NEMAggregateModification.fromObject = function fromObject(object) {
            if (object instanceof $root.NEMSignTx.NEMAggregateModification)
                return object;
            var message = new $root.NEMSignTx.NEMAggregateModification();
            if (object.modifications) {
                if (!Array.isArray(object.modifications))
                    throw TypeError(".NEMSignTx.NEMAggregateModification.modifications: array expected");
                message.modifications = [];
                for (var i = 0; i < object.modifications.length; ++i) {
                    if (typeof object.modifications[i] !== "object")
                        throw TypeError(".NEMSignTx.NEMAggregateModification.modifications: object expected");
                    message.modifications[i] = $root.NEMSignTx.NEMAggregateModification.NEMCosignatoryModification.fromObject(object.modifications[i]);
                }
            }
            if (object.relative_change != null)
                message.relative_change = object.relative_change | 0;
            return message;
        };

        NEMAggregateModification.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.modifications = [];
            if (options.defaults)
                object.relative_change = 0;
            if (message.modifications && message.modifications.length) {
                object.modifications = [];
                for (var j = 0; j < message.modifications.length; ++j)
                    object.modifications[j] = $root.NEMSignTx.NEMAggregateModification.NEMCosignatoryModification.toObject(message.modifications[j], options);
            }
            if (message.relative_change != null && message.hasOwnProperty("relative_change"))
                object.relative_change = message.relative_change;
            return object;
        };

        NEMAggregateModification.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        NEMAggregateModification.NEMCosignatoryModification = (function() {

            function NEMCosignatoryModification(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            NEMCosignatoryModification.prototype.type = 1;
            NEMCosignatoryModification.prototype.public_key = $util.newBuffer([]);

            NEMCosignatoryModification.create = function create(properties) {
                return new NEMCosignatoryModification(properties);
            };

            NEMCosignatoryModification.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                writer.uint32(8).int32(message.type);
                writer.uint32(18).bytes(message.public_key);
                return writer;
            };

            NEMCosignatoryModification.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            NEMCosignatoryModification.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NEMSignTx.NEMAggregateModification.NEMCosignatoryModification();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.type = reader.int32();
                        break;
                    case 2:
                        message.public_key = reader.bytes();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                if (!message.hasOwnProperty("type"))
                    throw $util.ProtocolError("missing required 'type'", { instance: message });
                if (!message.hasOwnProperty("public_key"))
                    throw $util.ProtocolError("missing required 'public_key'", { instance: message });
                return message;
            };

            NEMCosignatoryModification.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            NEMCosignatoryModification.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                switch (message.type) {
                default:
                    return "type: enum value expected";
                case 1:
                case 2:
                    break;
                }
                if (!(message.public_key && typeof message.public_key.length === "number" || $util.isString(message.public_key)))
                    return "public_key: buffer expected";
                return null;
            };

            NEMCosignatoryModification.fromObject = function fromObject(object) {
                if (object instanceof $root.NEMSignTx.NEMAggregateModification.NEMCosignatoryModification)
                    return object;
                var message = new $root.NEMSignTx.NEMAggregateModification.NEMCosignatoryModification();
                switch (object.type) {
                case "CosignatoryModification_Add":
                case 1:
                    message.type = 1;
                    break;
                case "CosignatoryModification_Delete":
                case 2:
                    message.type = 2;
                    break;
                }
                if (object.public_key != null)
                    if (typeof object.public_key === "string")
                        $util.base64.decode(object.public_key, message.public_key = $util.newBuffer($util.base64.length(object.public_key)), 0);
                    else if (object.public_key.length)
                        message.public_key = object.public_key;
                return message;
            };

            NEMCosignatoryModification.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.type = options.enums === String ? "CosignatoryModification_Add" : 1;
                    if (options.bytes === String)
                        object.public_key = "";
                    else {
                        object.public_key = [];
                        if (options.bytes !== Array)
                            object.public_key = $util.newBuffer(object.public_key);
                    }
                }
                if (message.type != null && message.hasOwnProperty("type"))
                    object.type = options.enums === String ? $root.NEMSignTx.NEMAggregateModification.NEMCosignatoryModification.NEMModificationType[message.type] : message.type;
                if (message.public_key != null && message.hasOwnProperty("public_key"))
                    object.public_key = options.bytes === String ? $util.base64.encode(message.public_key, 0, message.public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.public_key) : message.public_key;
                return object;
            };

            NEMCosignatoryModification.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            NEMCosignatoryModification.NEMModificationType = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[1] = "CosignatoryModification_Add"] = 1;
                values[valuesById[2] = "CosignatoryModification_Delete"] = 2;
                return values;
            })();

            return NEMCosignatoryModification;
        })();

        return NEMAggregateModification;
    })();

    NEMSignTx.NEMImportanceTransfer = (function() {

        function NEMImportanceTransfer(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        NEMImportanceTransfer.prototype.mode = 1;
        NEMImportanceTransfer.prototype.public_key = $util.newBuffer([]);

        NEMImportanceTransfer.create = function create(properties) {
            return new NEMImportanceTransfer(properties);
        };

        NEMImportanceTransfer.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(8).int32(message.mode);
            writer.uint32(18).bytes(message.public_key);
            return writer;
        };

        NEMImportanceTransfer.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        NEMImportanceTransfer.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NEMSignTx.NEMImportanceTransfer();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.mode = reader.int32();
                    break;
                case 2:
                    message.public_key = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("mode"))
                throw $util.ProtocolError("missing required 'mode'", { instance: message });
            if (!message.hasOwnProperty("public_key"))
                throw $util.ProtocolError("missing required 'public_key'", { instance: message });
            return message;
        };

        NEMImportanceTransfer.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        NEMImportanceTransfer.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            switch (message.mode) {
            default:
                return "mode: enum value expected";
            case 1:
            case 2:
                break;
            }
            if (!(message.public_key && typeof message.public_key.length === "number" || $util.isString(message.public_key)))
                return "public_key: buffer expected";
            return null;
        };

        NEMImportanceTransfer.fromObject = function fromObject(object) {
            if (object instanceof $root.NEMSignTx.NEMImportanceTransfer)
                return object;
            var message = new $root.NEMSignTx.NEMImportanceTransfer();
            switch (object.mode) {
            case "ImportanceTransfer_Activate":
            case 1:
                message.mode = 1;
                break;
            case "ImportanceTransfer_Deactivate":
            case 2:
                message.mode = 2;
                break;
            }
            if (object.public_key != null)
                if (typeof object.public_key === "string")
                    $util.base64.decode(object.public_key, message.public_key = $util.newBuffer($util.base64.length(object.public_key)), 0);
                else if (object.public_key.length)
                    message.public_key = object.public_key;
            return message;
        };

        NEMImportanceTransfer.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.mode = options.enums === String ? "ImportanceTransfer_Activate" : 1;
                if (options.bytes === String)
                    object.public_key = "";
                else {
                    object.public_key = [];
                    if (options.bytes !== Array)
                        object.public_key = $util.newBuffer(object.public_key);
                }
            }
            if (message.mode != null && message.hasOwnProperty("mode"))
                object.mode = options.enums === String ? $root.NEMSignTx.NEMImportanceTransfer.NEMImportanceTransferMode[message.mode] : message.mode;
            if (message.public_key != null && message.hasOwnProperty("public_key"))
                object.public_key = options.bytes === String ? $util.base64.encode(message.public_key, 0, message.public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.public_key) : message.public_key;
            return object;
        };

        NEMImportanceTransfer.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        NEMImportanceTransfer.NEMImportanceTransferMode = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[1] = "ImportanceTransfer_Activate"] = 1;
            values[valuesById[2] = "ImportanceTransfer_Deactivate"] = 2;
            return values;
        })();

        return NEMImportanceTransfer;
    })();

    return NEMSignTx;
})();

$root.NEMSignedTx = (function() {

    function NEMSignedTx(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NEMSignedTx.prototype.data = $util.newBuffer([]);
    NEMSignedTx.prototype.signature = $util.newBuffer([]);

    NEMSignedTx.create = function create(properties) {
        return new NEMSignedTx(properties);
    };

    NEMSignedTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.data);
        writer.uint32(18).bytes(message.signature);
        return writer;
    };

    NEMSignedTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NEMSignedTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NEMSignedTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.data = reader.bytes();
                break;
            case 2:
                message.signature = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("data"))
            throw $util.ProtocolError("missing required 'data'", { instance: message });
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        return message;
    };

    NEMSignedTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NEMSignedTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
            return "data: buffer expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        return null;
    };

    NEMSignedTx.fromObject = function fromObject(object) {
        if (object instanceof $root.NEMSignedTx)
            return object;
        var message = new $root.NEMSignedTx();
        if (object.data != null)
            if (typeof object.data === "string")
                $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
            else if (object.data.length)
                message.data = object.data;
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        return message;
    };

    NEMSignedTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.data = "";
            else {
                object.data = [];
                if (options.bytes !== Array)
                    object.data = $util.newBuffer(object.data);
            }
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
        }
        if (message.data != null && message.hasOwnProperty("data"))
            object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        return object;
    };

    NEMSignedTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NEMSignedTx;
})();

$root.NEMDecryptMessage = (function() {

    function NEMDecryptMessage(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NEMDecryptMessage.prototype.address_n = $util.emptyArray;
    NEMDecryptMessage.prototype.network = 0;
    NEMDecryptMessage.prototype.public_key = $util.newBuffer([]);
    NEMDecryptMessage.prototype.payload = $util.newBuffer([]);

    NEMDecryptMessage.create = function create(properties) {
        return new NEMDecryptMessage(properties);
    };

    NEMDecryptMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.network != null && Object.hasOwnProperty.call(message, "network"))
            writer.uint32(16).uint32(message.network);
        if (message.public_key != null && Object.hasOwnProperty.call(message, "public_key"))
            writer.uint32(26).bytes(message.public_key);
        if (message.payload != null && Object.hasOwnProperty.call(message, "payload"))
            writer.uint32(34).bytes(message.payload);
        return writer;
    };

    NEMDecryptMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NEMDecryptMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NEMDecryptMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.network = reader.uint32();
                break;
            case 3:
                message.public_key = reader.bytes();
                break;
            case 4:
                message.payload = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    NEMDecryptMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NEMDecryptMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.network != null && message.hasOwnProperty("network"))
            if (!$util.isInteger(message.network))
                return "network: integer expected";
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            if (!(message.public_key && typeof message.public_key.length === "number" || $util.isString(message.public_key)))
                return "public_key: buffer expected";
        if (message.payload != null && message.hasOwnProperty("payload"))
            if (!(message.payload && typeof message.payload.length === "number" || $util.isString(message.payload)))
                return "payload: buffer expected";
        return null;
    };

    NEMDecryptMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.NEMDecryptMessage)
            return object;
        var message = new $root.NEMDecryptMessage();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".NEMDecryptMessage.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.network != null)
            message.network = object.network >>> 0;
        if (object.public_key != null)
            if (typeof object.public_key === "string")
                $util.base64.decode(object.public_key, message.public_key = $util.newBuffer($util.base64.length(object.public_key)), 0);
            else if (object.public_key.length)
                message.public_key = object.public_key;
        if (object.payload != null)
            if (typeof object.payload === "string")
                $util.base64.decode(object.payload, message.payload = $util.newBuffer($util.base64.length(object.payload)), 0);
            else if (object.payload.length)
                message.payload = object.payload;
        return message;
    };

    NEMDecryptMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            object.network = 0;
            if (options.bytes === String)
                object.public_key = "";
            else {
                object.public_key = [];
                if (options.bytes !== Array)
                    object.public_key = $util.newBuffer(object.public_key);
            }
            if (options.bytes === String)
                object.payload = "";
            else {
                object.payload = [];
                if (options.bytes !== Array)
                    object.payload = $util.newBuffer(object.payload);
            }
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.network != null && message.hasOwnProperty("network"))
            object.network = message.network;
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            object.public_key = options.bytes === String ? $util.base64.encode(message.public_key, 0, message.public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.public_key) : message.public_key;
        if (message.payload != null && message.hasOwnProperty("payload"))
            object.payload = options.bytes === String ? $util.base64.encode(message.payload, 0, message.payload.length) : options.bytes === Array ? Array.prototype.slice.call(message.payload) : message.payload;
        return object;
    };

    NEMDecryptMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NEMDecryptMessage;
})();

$root.NEMDecryptedMessage = (function() {

    function NEMDecryptedMessage(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NEMDecryptedMessage.prototype.payload = $util.newBuffer([]);

    NEMDecryptedMessage.create = function create(properties) {
        return new NEMDecryptedMessage(properties);
    };

    NEMDecryptedMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.payload);
        return writer;
    };

    NEMDecryptedMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NEMDecryptedMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NEMDecryptedMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.payload = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("payload"))
            throw $util.ProtocolError("missing required 'payload'", { instance: message });
        return message;
    };

    NEMDecryptedMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NEMDecryptedMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.payload && typeof message.payload.length === "number" || $util.isString(message.payload)))
            return "payload: buffer expected";
        return null;
    };

    NEMDecryptedMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.NEMDecryptedMessage)
            return object;
        var message = new $root.NEMDecryptedMessage();
        if (object.payload != null)
            if (typeof object.payload === "string")
                $util.base64.decode(object.payload, message.payload = $util.newBuffer($util.base64.length(object.payload)), 0);
            else if (object.payload.length)
                message.payload = object.payload;
        return message;
    };

    NEMDecryptedMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.payload = "";
            else {
                object.payload = [];
                if (options.bytes !== Array)
                    object.payload = $util.newBuffer(object.payload);
            }
        if (message.payload != null && message.hasOwnProperty("payload"))
            object.payload = options.bytes === String ? $util.base64.encode(message.payload, 0, message.payload.length) : options.bytes === Array ? Array.prototype.slice.call(message.payload) : message.payload;
        return object;
    };

    NEMDecryptedMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NEMDecryptedMessage;
})();

$root.NeoGetAddress = (function() {

    function NeoGetAddress(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NeoGetAddress.prototype.address_n = $util.emptyArray;
    NeoGetAddress.prototype.show_display = false;

    NeoGetAddress.create = function create(properties) {
        return new NeoGetAddress(properties);
    };

    NeoGetAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(16).bool(message.show_display);
        return writer;
    };

    NeoGetAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NeoGetAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NeoGetAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.show_display = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    NeoGetAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NeoGetAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        return null;
    };

    NeoGetAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.NeoGetAddress)
            return object;
        var message = new $root.NeoGetAddress();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".NeoGetAddress.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        return message;
    };

    NeoGetAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            object.show_display = false;
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        return object;
    };

    NeoGetAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NeoGetAddress;
})();

$root.NeoAddress = (function() {

    function NeoAddress(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NeoAddress.prototype.address = "";
    NeoAddress.prototype.public_key = $util.newBuffer([]);

    NeoAddress.create = function create(properties) {
        return new NeoAddress(properties);
    };

    NeoAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address != null && Object.hasOwnProperty.call(message, "address"))
            writer.uint32(10).string(message.address);
        if (message.public_key != null && Object.hasOwnProperty.call(message, "public_key"))
            writer.uint32(18).bytes(message.public_key);
        return writer;
    };

    NeoAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NeoAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NeoAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.string();
                break;
            case 2:
                message.public_key = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    NeoAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NeoAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address != null && message.hasOwnProperty("address"))
            if (!$util.isString(message.address))
                return "address: string expected";
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            if (!(message.public_key && typeof message.public_key.length === "number" || $util.isString(message.public_key)))
                return "public_key: buffer expected";
        return null;
    };

    NeoAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.NeoAddress)
            return object;
        var message = new $root.NeoAddress();
        if (object.address != null)
            message.address = String(object.address);
        if (object.public_key != null)
            if (typeof object.public_key === "string")
                $util.base64.decode(object.public_key, message.public_key = $util.newBuffer($util.base64.length(object.public_key)), 0);
            else if (object.public_key.length)
                message.public_key = object.public_key;
        return message;
    };

    NeoAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.address = "";
            if (options.bytes === String)
                object.public_key = "";
            else {
                object.public_key = [];
                if (options.bytes !== Array)
                    object.public_key = $util.newBuffer(object.public_key);
            }
        }
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            object.public_key = options.bytes === String ? $util.base64.encode(message.public_key, 0, message.public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.public_key) : message.public_key;
        return object;
    };

    NeoAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NeoAddress;
})();

$root.NeoSignTx = (function() {

    function NeoSignTx(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NeoSignTx.prototype.address_n = $util.emptyArray;
    NeoSignTx.prototype.raw_tx = $util.newBuffer([]);
    NeoSignTx.prototype.network_magic = 860833102;

    NeoSignTx.create = function create(properties) {
        return new NeoSignTx(properties);
    };

    NeoSignTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).bytes(message.raw_tx);
        if (message.network_magic != null && Object.hasOwnProperty.call(message, "network_magic"))
            writer.uint32(24).uint32(message.network_magic);
        return writer;
    };

    NeoSignTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NeoSignTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NeoSignTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.raw_tx = reader.bytes();
                break;
            case 3:
                message.network_magic = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("raw_tx"))
            throw $util.ProtocolError("missing required 'raw_tx'", { instance: message });
        return message;
    };

    NeoSignTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NeoSignTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!(message.raw_tx && typeof message.raw_tx.length === "number" || $util.isString(message.raw_tx)))
            return "raw_tx: buffer expected";
        if (message.network_magic != null && message.hasOwnProperty("network_magic"))
            if (!$util.isInteger(message.network_magic))
                return "network_magic: integer expected";
        return null;
    };

    NeoSignTx.fromObject = function fromObject(object) {
        if (object instanceof $root.NeoSignTx)
            return object;
        var message = new $root.NeoSignTx();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".NeoSignTx.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.raw_tx != null)
            if (typeof object.raw_tx === "string")
                $util.base64.decode(object.raw_tx, message.raw_tx = $util.newBuffer($util.base64.length(object.raw_tx)), 0);
            else if (object.raw_tx.length)
                message.raw_tx = object.raw_tx;
        if (object.network_magic != null)
            message.network_magic = object.network_magic >>> 0;
        return message;
    };

    NeoSignTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            if (options.bytes === String)
                object.raw_tx = "";
            else {
                object.raw_tx = [];
                if (options.bytes !== Array)
                    object.raw_tx = $util.newBuffer(object.raw_tx);
            }
            object.network_magic = 860833102;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.raw_tx != null && message.hasOwnProperty("raw_tx"))
            object.raw_tx = options.bytes === String ? $util.base64.encode(message.raw_tx, 0, message.raw_tx.length) : options.bytes === Array ? Array.prototype.slice.call(message.raw_tx) : message.raw_tx;
        if (message.network_magic != null && message.hasOwnProperty("network_magic"))
            object.network_magic = message.network_magic;
        return object;
    };

    NeoSignTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NeoSignTx;
})();

$root.NeoSignedTx = (function() {

    function NeoSignedTx(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NeoSignedTx.prototype.public_key = $util.newBuffer([]);
    NeoSignedTx.prototype.signature = $util.newBuffer([]);

    NeoSignedTx.create = function create(properties) {
        return new NeoSignedTx(properties);
    };

    NeoSignedTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.public_key);
        writer.uint32(18).bytes(message.signature);
        return writer;
    };

    NeoSignedTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NeoSignedTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NeoSignedTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.public_key = reader.bytes();
                break;
            case 2:
                message.signature = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("public_key"))
            throw $util.ProtocolError("missing required 'public_key'", { instance: message });
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        return message;
    };

    NeoSignedTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NeoSignedTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.public_key && typeof message.public_key.length === "number" || $util.isString(message.public_key)))
            return "public_key: buffer expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        return null;
    };

    NeoSignedTx.fromObject = function fromObject(object) {
        if (object instanceof $root.NeoSignedTx)
            return object;
        var message = new $root.NeoSignedTx();
        if (object.public_key != null)
            if (typeof object.public_key === "string")
                $util.base64.decode(object.public_key, message.public_key = $util.newBuffer($util.base64.length(object.public_key)), 0);
            else if (object.public_key.length)
                message.public_key = object.public_key;
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        return message;
    };

    NeoSignedTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.public_key = "";
            else {
                object.public_key = [];
                if (options.bytes !== Array)
                    object.public_key = $util.newBuffer(object.public_key);
            }
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
        }
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            object.public_key = options.bytes === String ? $util.base64.encode(message.public_key, 0, message.public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.public_key) : message.public_key;
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        return object;
    };

    NeoSignedTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NeoSignedTx;
})();

$root.NervosGetAddress = (function() {

    function NervosGetAddress(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NervosGetAddress.prototype.address_n = $util.emptyArray;
    NervosGetAddress.prototype.network = "";
    NervosGetAddress.prototype.show_display = false;

    NervosGetAddress.create = function create(properties) {
        return new NervosGetAddress(properties);
    };

    NervosGetAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).string(message.network);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(24).bool(message.show_display);
        return writer;
    };

    NervosGetAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NervosGetAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NervosGetAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.network = reader.string();
                break;
            case 3:
                message.show_display = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("network"))
            throw $util.ProtocolError("missing required 'network'", { instance: message });
        return message;
    };

    NervosGetAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NervosGetAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!$util.isString(message.network))
            return "network: string expected";
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        return null;
    };

    NervosGetAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.NervosGetAddress)
            return object;
        var message = new $root.NervosGetAddress();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".NervosGetAddress.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.network != null)
            message.network = String(object.network);
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        return message;
    };

    NervosGetAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            object.network = "";
            object.show_display = false;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.network != null && message.hasOwnProperty("network"))
            object.network = message.network;
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        return object;
    };

    NervosGetAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NervosGetAddress;
})();

$root.NervosAddress = (function() {

    function NervosAddress(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NervosAddress.prototype.address = "";

    NervosAddress.create = function create(properties) {
        return new NervosAddress(properties);
    };

    NervosAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.address);
        return writer;
    };

    NervosAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NervosAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NervosAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("address"))
            throw $util.ProtocolError("missing required 'address'", { instance: message });
        return message;
    };

    NervosAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NervosAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.address))
            return "address: string expected";
        return null;
    };

    NervosAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.NervosAddress)
            return object;
        var message = new $root.NervosAddress();
        if (object.address != null)
            message.address = String(object.address);
        return message;
    };

    NervosAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.address = "";
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    NervosAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NervosAddress;
})();

$root.NervosSignTx = (function() {

    function NervosSignTx(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NervosSignTx.prototype.address_n = $util.emptyArray;
    NervosSignTx.prototype.data_initial_chunk = $util.newBuffer([]);
    NervosSignTx.prototype.witness_buffer = $util.newBuffer([]);
    NervosSignTx.prototype.network = "";
    NervosSignTx.prototype.data_length = 0;

    NervosSignTx.create = function create(properties) {
        return new NervosSignTx(properties);
    };

    NervosSignTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).bytes(message.data_initial_chunk);
        writer.uint32(26).bytes(message.witness_buffer);
        writer.uint32(34).string(message.network);
        if (message.data_length != null && Object.hasOwnProperty.call(message, "data_length"))
            writer.uint32(40).uint32(message.data_length);
        return writer;
    };

    NervosSignTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NervosSignTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NervosSignTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.data_initial_chunk = reader.bytes();
                break;
            case 3:
                message.witness_buffer = reader.bytes();
                break;
            case 4:
                message.network = reader.string();
                break;
            case 5:
                message.data_length = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("data_initial_chunk"))
            throw $util.ProtocolError("missing required 'data_initial_chunk'", { instance: message });
        if (!message.hasOwnProperty("witness_buffer"))
            throw $util.ProtocolError("missing required 'witness_buffer'", { instance: message });
        if (!message.hasOwnProperty("network"))
            throw $util.ProtocolError("missing required 'network'", { instance: message });
        return message;
    };

    NervosSignTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NervosSignTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!(message.data_initial_chunk && typeof message.data_initial_chunk.length === "number" || $util.isString(message.data_initial_chunk)))
            return "data_initial_chunk: buffer expected";
        if (!(message.witness_buffer && typeof message.witness_buffer.length === "number" || $util.isString(message.witness_buffer)))
            return "witness_buffer: buffer expected";
        if (!$util.isString(message.network))
            return "network: string expected";
        if (message.data_length != null && message.hasOwnProperty("data_length"))
            if (!$util.isInteger(message.data_length))
                return "data_length: integer expected";
        return null;
    };

    NervosSignTx.fromObject = function fromObject(object) {
        if (object instanceof $root.NervosSignTx)
            return object;
        var message = new $root.NervosSignTx();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".NervosSignTx.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.data_initial_chunk != null)
            if (typeof object.data_initial_chunk === "string")
                $util.base64.decode(object.data_initial_chunk, message.data_initial_chunk = $util.newBuffer($util.base64.length(object.data_initial_chunk)), 0);
            else if (object.data_initial_chunk.length)
                message.data_initial_chunk = object.data_initial_chunk;
        if (object.witness_buffer != null)
            if (typeof object.witness_buffer === "string")
                $util.base64.decode(object.witness_buffer, message.witness_buffer = $util.newBuffer($util.base64.length(object.witness_buffer)), 0);
            else if (object.witness_buffer.length)
                message.witness_buffer = object.witness_buffer;
        if (object.network != null)
            message.network = String(object.network);
        if (object.data_length != null)
            message.data_length = object.data_length >>> 0;
        return message;
    };

    NervosSignTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            if (options.bytes === String)
                object.data_initial_chunk = "";
            else {
                object.data_initial_chunk = [];
                if (options.bytes !== Array)
                    object.data_initial_chunk = $util.newBuffer(object.data_initial_chunk);
            }
            if (options.bytes === String)
                object.witness_buffer = "";
            else {
                object.witness_buffer = [];
                if (options.bytes !== Array)
                    object.witness_buffer = $util.newBuffer(object.witness_buffer);
            }
            object.network = "";
            object.data_length = 0;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.data_initial_chunk != null && message.hasOwnProperty("data_initial_chunk"))
            object.data_initial_chunk = options.bytes === String ? $util.base64.encode(message.data_initial_chunk, 0, message.data_initial_chunk.length) : options.bytes === Array ? Array.prototype.slice.call(message.data_initial_chunk) : message.data_initial_chunk;
        if (message.witness_buffer != null && message.hasOwnProperty("witness_buffer"))
            object.witness_buffer = options.bytes === String ? $util.base64.encode(message.witness_buffer, 0, message.witness_buffer.length) : options.bytes === Array ? Array.prototype.slice.call(message.witness_buffer) : message.witness_buffer;
        if (message.network != null && message.hasOwnProperty("network"))
            object.network = message.network;
        if (message.data_length != null && message.hasOwnProperty("data_length"))
            object.data_length = message.data_length;
        return object;
    };

    NervosSignTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NervosSignTx;
})();

$root.NervosSignedTx = (function() {

    function NervosSignedTx(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NervosSignedTx.prototype.signature = $util.newBuffer([]);
    NervosSignedTx.prototype.address = "";

    NervosSignedTx.create = function create(properties) {
        return new NervosSignedTx(properties);
    };

    NervosSignedTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.signature);
        writer.uint32(18).string(message.address);
        return writer;
    };

    NervosSignedTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NervosSignedTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NervosSignedTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.signature = reader.bytes();
                break;
            case 2:
                message.address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        if (!message.hasOwnProperty("address"))
            throw $util.ProtocolError("missing required 'address'", { instance: message });
        return message;
    };

    NervosSignedTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NervosSignedTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        if (!$util.isString(message.address))
            return "address: string expected";
        return null;
    };

    NervosSignedTx.fromObject = function fromObject(object) {
        if (object instanceof $root.NervosSignedTx)
            return object;
        var message = new $root.NervosSignedTx();
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        if (object.address != null)
            message.address = String(object.address);
        return message;
    };

    NervosSignedTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
            object.address = "";
        }
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    NervosSignedTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NervosSignedTx;
})();

$root.NervosTxRequest = (function() {

    function NervosTxRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NervosTxRequest.prototype.data_length = 0;
    NervosTxRequest.prototype.public_key = $util.newBuffer([]);
    NervosTxRequest.prototype.signature = $util.newBuffer([]);

    NervosTxRequest.create = function create(properties) {
        return new NervosTxRequest(properties);
    };

    NervosTxRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.data_length != null && Object.hasOwnProperty.call(message, "data_length"))
            writer.uint32(8).uint32(message.data_length);
        if (message.public_key != null && Object.hasOwnProperty.call(message, "public_key"))
            writer.uint32(18).bytes(message.public_key);
        if (message.signature != null && Object.hasOwnProperty.call(message, "signature"))
            writer.uint32(26).bytes(message.signature);
        return writer;
    };

    NervosTxRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NervosTxRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NervosTxRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.data_length = reader.uint32();
                break;
            case 2:
                message.public_key = reader.bytes();
                break;
            case 3:
                message.signature = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    NervosTxRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NervosTxRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.data_length != null && message.hasOwnProperty("data_length"))
            if (!$util.isInteger(message.data_length))
                return "data_length: integer expected";
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            if (!(message.public_key && typeof message.public_key.length === "number" || $util.isString(message.public_key)))
                return "public_key: buffer expected";
        if (message.signature != null && message.hasOwnProperty("signature"))
            if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
                return "signature: buffer expected";
        return null;
    };

    NervosTxRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.NervosTxRequest)
            return object;
        var message = new $root.NervosTxRequest();
        if (object.data_length != null)
            message.data_length = object.data_length >>> 0;
        if (object.public_key != null)
            if (typeof object.public_key === "string")
                $util.base64.decode(object.public_key, message.public_key = $util.newBuffer($util.base64.length(object.public_key)), 0);
            else if (object.public_key.length)
                message.public_key = object.public_key;
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        return message;
    };

    NervosTxRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.data_length = 0;
            if (options.bytes === String)
                object.public_key = "";
            else {
                object.public_key = [];
                if (options.bytes !== Array)
                    object.public_key = $util.newBuffer(object.public_key);
            }
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
        }
        if (message.data_length != null && message.hasOwnProperty("data_length"))
            object.data_length = message.data_length;
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            object.public_key = options.bytes === String ? $util.base64.encode(message.public_key, 0, message.public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.public_key) : message.public_key;
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        return object;
    };

    NervosTxRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NervosTxRequest;
})();

$root.NervosTxAck = (function() {

    function NervosTxAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NervosTxAck.prototype.data_chunk = $util.newBuffer([]);

    NervosTxAck.create = function create(properties) {
        return new NervosTxAck(properties);
    };

    NervosTxAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.data_chunk);
        return writer;
    };

    NervosTxAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NervosTxAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NervosTxAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.data_chunk = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("data_chunk"))
            throw $util.ProtocolError("missing required 'data_chunk'", { instance: message });
        return message;
    };

    NervosTxAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NervosTxAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.data_chunk && typeof message.data_chunk.length === "number" || $util.isString(message.data_chunk)))
            return "data_chunk: buffer expected";
        return null;
    };

    NervosTxAck.fromObject = function fromObject(object) {
        if (object instanceof $root.NervosTxAck)
            return object;
        var message = new $root.NervosTxAck();
        if (object.data_chunk != null)
            if (typeof object.data_chunk === "string")
                $util.base64.decode(object.data_chunk, message.data_chunk = $util.newBuffer($util.base64.length(object.data_chunk)), 0);
            else if (object.data_chunk.length)
                message.data_chunk = object.data_chunk;
        return message;
    };

    NervosTxAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.data_chunk = "";
            else {
                object.data_chunk = [];
                if (options.bytes !== Array)
                    object.data_chunk = $util.newBuffer(object.data_chunk);
            }
        if (message.data_chunk != null && message.hasOwnProperty("data_chunk"))
            object.data_chunk = options.bytes === String ? $util.base64.encode(message.data_chunk, 0, message.data_chunk.length) : options.bytes === Array ? Array.prototype.slice.call(message.data_chunk) : message.data_chunk;
        return object;
    };

    NervosTxAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NervosTxAck;
})();

$root.NexaGetAddress = (function() {

    function NexaGetAddress(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NexaGetAddress.prototype.address_n = $util.emptyArray;
    NexaGetAddress.prototype.show_display = false;
    NexaGetAddress.prototype.prefix = "nexa";

    NexaGetAddress.create = function create(properties) {
        return new NexaGetAddress(properties);
    };

    NexaGetAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(16).bool(message.show_display);
        if (message.prefix != null && Object.hasOwnProperty.call(message, "prefix"))
            writer.uint32(26).string(message.prefix);
        return writer;
    };

    NexaGetAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NexaGetAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NexaGetAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.show_display = reader.bool();
                break;
            case 3:
                message.prefix = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    NexaGetAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NexaGetAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        if (message.prefix != null && message.hasOwnProperty("prefix"))
            if (!$util.isString(message.prefix))
                return "prefix: string expected";
        return null;
    };

    NexaGetAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.NexaGetAddress)
            return object;
        var message = new $root.NexaGetAddress();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".NexaGetAddress.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        if (object.prefix != null)
            message.prefix = String(object.prefix);
        return message;
    };

    NexaGetAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            object.show_display = false;
            object.prefix = "nexa";
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        if (message.prefix != null && message.hasOwnProperty("prefix"))
            object.prefix = message.prefix;
        return object;
    };

    NexaGetAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NexaGetAddress;
})();

$root.NexaAddress = (function() {

    function NexaAddress(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NexaAddress.prototype.address = "";
    NexaAddress.prototype.public_key = $util.newBuffer([]);

    NexaAddress.create = function create(properties) {
        return new NexaAddress(properties);
    };

    NexaAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.address);
        writer.uint32(18).bytes(message.public_key);
        return writer;
    };

    NexaAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NexaAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NexaAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.string();
                break;
            case 2:
                message.public_key = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("address"))
            throw $util.ProtocolError("missing required 'address'", { instance: message });
        if (!message.hasOwnProperty("public_key"))
            throw $util.ProtocolError("missing required 'public_key'", { instance: message });
        return message;
    };

    NexaAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NexaAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.address))
            return "address: string expected";
        if (!(message.public_key && typeof message.public_key.length === "number" || $util.isString(message.public_key)))
            return "public_key: buffer expected";
        return null;
    };

    NexaAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.NexaAddress)
            return object;
        var message = new $root.NexaAddress();
        if (object.address != null)
            message.address = String(object.address);
        if (object.public_key != null)
            if (typeof object.public_key === "string")
                $util.base64.decode(object.public_key, message.public_key = $util.newBuffer($util.base64.length(object.public_key)), 0);
            else if (object.public_key.length)
                message.public_key = object.public_key;
        return message;
    };

    NexaAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.address = "";
            if (options.bytes === String)
                object.public_key = "";
            else {
                object.public_key = [];
                if (options.bytes !== Array)
                    object.public_key = $util.newBuffer(object.public_key);
            }
        }
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            object.public_key = options.bytes === String ? $util.base64.encode(message.public_key, 0, message.public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.public_key) : message.public_key;
        return object;
    };

    NexaAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NexaAddress;
})();

$root.NexaSignTx = (function() {

    function NexaSignTx(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NexaSignTx.prototype.address_n = $util.emptyArray;
    NexaSignTx.prototype.raw_message = $util.newBuffer([]);
    NexaSignTx.prototype.prefix = "nexa";
    NexaSignTx.prototype.input_count = 1;

    NexaSignTx.create = function create(properties) {
        return new NexaSignTx(properties);
    };

    NexaSignTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).bytes(message.raw_message);
        if (message.prefix != null && Object.hasOwnProperty.call(message, "prefix"))
            writer.uint32(26).string(message.prefix);
        if (message.input_count != null && Object.hasOwnProperty.call(message, "input_count"))
            writer.uint32(32).uint32(message.input_count);
        return writer;
    };

    NexaSignTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NexaSignTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NexaSignTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.raw_message = reader.bytes();
                break;
            case 3:
                message.prefix = reader.string();
                break;
            case 4:
                message.input_count = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("raw_message"))
            throw $util.ProtocolError("missing required 'raw_message'", { instance: message });
        return message;
    };

    NexaSignTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NexaSignTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!(message.raw_message && typeof message.raw_message.length === "number" || $util.isString(message.raw_message)))
            return "raw_message: buffer expected";
        if (message.prefix != null && message.hasOwnProperty("prefix"))
            if (!$util.isString(message.prefix))
                return "prefix: string expected";
        if (message.input_count != null && message.hasOwnProperty("input_count"))
            if (!$util.isInteger(message.input_count))
                return "input_count: integer expected";
        return null;
    };

    NexaSignTx.fromObject = function fromObject(object) {
        if (object instanceof $root.NexaSignTx)
            return object;
        var message = new $root.NexaSignTx();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".NexaSignTx.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.raw_message != null)
            if (typeof object.raw_message === "string")
                $util.base64.decode(object.raw_message, message.raw_message = $util.newBuffer($util.base64.length(object.raw_message)), 0);
            else if (object.raw_message.length)
                message.raw_message = object.raw_message;
        if (object.prefix != null)
            message.prefix = String(object.prefix);
        if (object.input_count != null)
            message.input_count = object.input_count >>> 0;
        return message;
    };

    NexaSignTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            if (options.bytes === String)
                object.raw_message = "";
            else {
                object.raw_message = [];
                if (options.bytes !== Array)
                    object.raw_message = $util.newBuffer(object.raw_message);
            }
            object.prefix = "nexa";
            object.input_count = 1;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.raw_message != null && message.hasOwnProperty("raw_message"))
            object.raw_message = options.bytes === String ? $util.base64.encode(message.raw_message, 0, message.raw_message.length) : options.bytes === Array ? Array.prototype.slice.call(message.raw_message) : message.raw_message;
        if (message.prefix != null && message.hasOwnProperty("prefix"))
            object.prefix = message.prefix;
        if (message.input_count != null && message.hasOwnProperty("input_count"))
            object.input_count = message.input_count;
        return object;
    };

    NexaSignTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NexaSignTx;
})();

$root.NexaTxInputRequest = (function() {

    function NexaTxInputRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NexaTxInputRequest.prototype.request_index = 0;
    NexaTxInputRequest.prototype.signature = $util.newBuffer([]);

    NexaTxInputRequest.create = function create(properties) {
        return new NexaTxInputRequest(properties);
    };

    NexaTxInputRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).uint32(message.request_index);
        if (message.signature != null && Object.hasOwnProperty.call(message, "signature"))
            writer.uint32(18).bytes(message.signature);
        return writer;
    };

    NexaTxInputRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NexaTxInputRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NexaTxInputRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.request_index = reader.uint32();
                break;
            case 2:
                message.signature = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("request_index"))
            throw $util.ProtocolError("missing required 'request_index'", { instance: message });
        return message;
    };

    NexaTxInputRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NexaTxInputRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isInteger(message.request_index))
            return "request_index: integer expected";
        if (message.signature != null && message.hasOwnProperty("signature"))
            if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
                return "signature: buffer expected";
        return null;
    };

    NexaTxInputRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.NexaTxInputRequest)
            return object;
        var message = new $root.NexaTxInputRequest();
        if (object.request_index != null)
            message.request_index = object.request_index >>> 0;
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        return message;
    };

    NexaTxInputRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.request_index = 0;
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
        }
        if (message.request_index != null && message.hasOwnProperty("request_index"))
            object.request_index = message.request_index;
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        return object;
    };

    NexaTxInputRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NexaTxInputRequest;
})();

$root.NexaTxInputAck = (function() {

    function NexaTxInputAck(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NexaTxInputAck.prototype.address_n = $util.emptyArray;
    NexaTxInputAck.prototype.raw_message = $util.newBuffer([]);

    NexaTxInputAck.create = function create(properties) {
        return new NexaTxInputAck(properties);
    };

    NexaTxInputAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).bytes(message.raw_message);
        return writer;
    };

    NexaTxInputAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NexaTxInputAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NexaTxInputAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.raw_message = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("raw_message"))
            throw $util.ProtocolError("missing required 'raw_message'", { instance: message });
        return message;
    };

    NexaTxInputAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NexaTxInputAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!(message.raw_message && typeof message.raw_message.length === "number" || $util.isString(message.raw_message)))
            return "raw_message: buffer expected";
        return null;
    };

    NexaTxInputAck.fromObject = function fromObject(object) {
        if (object instanceof $root.NexaTxInputAck)
            return object;
        var message = new $root.NexaTxInputAck();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".NexaTxInputAck.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.raw_message != null)
            if (typeof object.raw_message === "string")
                $util.base64.decode(object.raw_message, message.raw_message = $util.newBuffer($util.base64.length(object.raw_message)), 0);
            else if (object.raw_message.length)
                message.raw_message = object.raw_message;
        return message;
    };

    NexaTxInputAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            if (options.bytes === String)
                object.raw_message = "";
            else {
                object.raw_message = [];
                if (options.bytes !== Array)
                    object.raw_message = $util.newBuffer(object.raw_message);
            }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.raw_message != null && message.hasOwnProperty("raw_message"))
            object.raw_message = options.bytes === String ? $util.base64.encode(message.raw_message, 0, message.raw_message.length) : options.bytes === Array ? Array.prototype.slice.call(message.raw_message) : message.raw_message;
        return object;
    };

    NexaTxInputAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NexaTxInputAck;
})();

$root.NexaSignedTx = (function() {

    function NexaSignedTx(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NexaSignedTx.prototype.signature = $util.newBuffer([]);

    NexaSignedTx.create = function create(properties) {
        return new NexaSignedTx(properties);
    };

    NexaSignedTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.signature);
        return writer;
    };

    NexaSignedTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NexaSignedTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NexaSignedTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.signature = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        return message;
    };

    NexaSignedTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NexaSignedTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        return null;
    };

    NexaSignedTx.fromObject = function fromObject(object) {
        if (object instanceof $root.NexaSignedTx)
            return object;
        var message = new $root.NexaSignedTx();
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        return message;
    };

    NexaSignedTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        return object;
    };

    NexaSignedTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NexaSignedTx;
})();

$root.NostrGetPublicKey = (function() {

    function NostrGetPublicKey(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NostrGetPublicKey.prototype.address_n = $util.emptyArray;
    NostrGetPublicKey.prototype.show_display = false;

    NostrGetPublicKey.create = function create(properties) {
        return new NostrGetPublicKey(properties);
    };

    NostrGetPublicKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(16).bool(message.show_display);
        return writer;
    };

    NostrGetPublicKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NostrGetPublicKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NostrGetPublicKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.show_display = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    NostrGetPublicKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NostrGetPublicKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        return null;
    };

    NostrGetPublicKey.fromObject = function fromObject(object) {
        if (object instanceof $root.NostrGetPublicKey)
            return object;
        var message = new $root.NostrGetPublicKey();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".NostrGetPublicKey.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        return message;
    };

    NostrGetPublicKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            object.show_display = false;
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        return object;
    };

    NostrGetPublicKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NostrGetPublicKey;
})();

$root.NostrPublicKey = (function() {

    function NostrPublicKey(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NostrPublicKey.prototype.publickey = "";
    NostrPublicKey.prototype.npub = "";

    NostrPublicKey.create = function create(properties) {
        return new NostrPublicKey(properties);
    };

    NostrPublicKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.publickey != null && Object.hasOwnProperty.call(message, "publickey"))
            writer.uint32(10).string(message.publickey);
        if (message.npub != null && Object.hasOwnProperty.call(message, "npub"))
            writer.uint32(18).string(message.npub);
        return writer;
    };

    NostrPublicKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NostrPublicKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NostrPublicKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.publickey = reader.string();
                break;
            case 2:
                message.npub = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    NostrPublicKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NostrPublicKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.publickey != null && message.hasOwnProperty("publickey"))
            if (!$util.isString(message.publickey))
                return "publickey: string expected";
        if (message.npub != null && message.hasOwnProperty("npub"))
            if (!$util.isString(message.npub))
                return "npub: string expected";
        return null;
    };

    NostrPublicKey.fromObject = function fromObject(object) {
        if (object instanceof $root.NostrPublicKey)
            return object;
        var message = new $root.NostrPublicKey();
        if (object.publickey != null)
            message.publickey = String(object.publickey);
        if (object.npub != null)
            message.npub = String(object.npub);
        return message;
    };

    NostrPublicKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.publickey = "";
            object.npub = "";
        }
        if (message.publickey != null && message.hasOwnProperty("publickey"))
            object.publickey = message.publickey;
        if (message.npub != null && message.hasOwnProperty("npub"))
            object.npub = message.npub;
        return object;
    };

    NostrPublicKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NostrPublicKey;
})();

$root.NostrSignEvent = (function() {

    function NostrSignEvent(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NostrSignEvent.prototype.address_n = $util.emptyArray;
    NostrSignEvent.prototype.event = $util.newBuffer([]);

    NostrSignEvent.create = function create(properties) {
        return new NostrSignEvent(properties);
    };

    NostrSignEvent.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).bytes(message.event);
        return writer;
    };

    NostrSignEvent.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NostrSignEvent.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NostrSignEvent();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.event = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("event"))
            throw $util.ProtocolError("missing required 'event'", { instance: message });
        return message;
    };

    NostrSignEvent.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NostrSignEvent.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!(message.event && typeof message.event.length === "number" || $util.isString(message.event)))
            return "event: buffer expected";
        return null;
    };

    NostrSignEvent.fromObject = function fromObject(object) {
        if (object instanceof $root.NostrSignEvent)
            return object;
        var message = new $root.NostrSignEvent();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".NostrSignEvent.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.event != null)
            if (typeof object.event === "string")
                $util.base64.decode(object.event, message.event = $util.newBuffer($util.base64.length(object.event)), 0);
            else if (object.event.length)
                message.event = object.event;
        return message;
    };

    NostrSignEvent.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            if (options.bytes === String)
                object.event = "";
            else {
                object.event = [];
                if (options.bytes !== Array)
                    object.event = $util.newBuffer(object.event);
            }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.event != null && message.hasOwnProperty("event"))
            object.event = options.bytes === String ? $util.base64.encode(message.event, 0, message.event.length) : options.bytes === Array ? Array.prototype.slice.call(message.event) : message.event;
        return object;
    };

    NostrSignEvent.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NostrSignEvent;
})();

$root.NostrSignedEvent = (function() {

    function NostrSignedEvent(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NostrSignedEvent.prototype.event = $util.newBuffer([]);

    NostrSignedEvent.create = function create(properties) {
        return new NostrSignedEvent(properties);
    };

    NostrSignedEvent.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.event);
        return writer;
    };

    NostrSignedEvent.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NostrSignedEvent.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NostrSignedEvent();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.event = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("event"))
            throw $util.ProtocolError("missing required 'event'", { instance: message });
        return message;
    };

    NostrSignedEvent.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NostrSignedEvent.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.event && typeof message.event.length === "number" || $util.isString(message.event)))
            return "event: buffer expected";
        return null;
    };

    NostrSignedEvent.fromObject = function fromObject(object) {
        if (object instanceof $root.NostrSignedEvent)
            return object;
        var message = new $root.NostrSignedEvent();
        if (object.event != null)
            if (typeof object.event === "string")
                $util.base64.decode(object.event, message.event = $util.newBuffer($util.base64.length(object.event)), 0);
            else if (object.event.length)
                message.event = object.event;
        return message;
    };

    NostrSignedEvent.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.event = "";
            else {
                object.event = [];
                if (options.bytes !== Array)
                    object.event = $util.newBuffer(object.event);
            }
        if (message.event != null && message.hasOwnProperty("event"))
            object.event = options.bytes === String ? $util.base64.encode(message.event, 0, message.event.length) : options.bytes === Array ? Array.prototype.slice.call(message.event) : message.event;
        return object;
    };

    NostrSignedEvent.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NostrSignedEvent;
})();

$root.NostrSignSchnorr = (function() {

    function NostrSignSchnorr(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NostrSignSchnorr.prototype.address_n = $util.emptyArray;
    NostrSignSchnorr.prototype.hash = "";

    NostrSignSchnorr.create = function create(properties) {
        return new NostrSignSchnorr(properties);
    };

    NostrSignSchnorr.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).string(message.hash);
        return writer;
    };

    NostrSignSchnorr.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NostrSignSchnorr.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NostrSignSchnorr();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.hash = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("hash"))
            throw $util.ProtocolError("missing required 'hash'", { instance: message });
        return message;
    };

    NostrSignSchnorr.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NostrSignSchnorr.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!$util.isString(message.hash))
            return "hash: string expected";
        return null;
    };

    NostrSignSchnorr.fromObject = function fromObject(object) {
        if (object instanceof $root.NostrSignSchnorr)
            return object;
        var message = new $root.NostrSignSchnorr();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".NostrSignSchnorr.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.hash != null)
            message.hash = String(object.hash);
        return message;
    };

    NostrSignSchnorr.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            object.hash = "";
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.hash != null && message.hasOwnProperty("hash"))
            object.hash = message.hash;
        return object;
    };

    NostrSignSchnorr.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NostrSignSchnorr;
})();

$root.NostrSignedSchnorr = (function() {

    function NostrSignedSchnorr(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NostrSignedSchnorr.prototype.signature = $util.newBuffer([]);

    NostrSignedSchnorr.create = function create(properties) {
        return new NostrSignedSchnorr(properties);
    };

    NostrSignedSchnorr.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.signature);
        return writer;
    };

    NostrSignedSchnorr.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NostrSignedSchnorr.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NostrSignedSchnorr();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.signature = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        return message;
    };

    NostrSignedSchnorr.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NostrSignedSchnorr.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        return null;
    };

    NostrSignedSchnorr.fromObject = function fromObject(object) {
        if (object instanceof $root.NostrSignedSchnorr)
            return object;
        var message = new $root.NostrSignedSchnorr();
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        return message;
    };

    NostrSignedSchnorr.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        return object;
    };

    NostrSignedSchnorr.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NostrSignedSchnorr;
})();

$root.NostrEncryptMessage = (function() {

    function NostrEncryptMessage(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NostrEncryptMessage.prototype.address_n = $util.emptyArray;
    NostrEncryptMessage.prototype.pubkey = "";
    NostrEncryptMessage.prototype.msg = "";
    NostrEncryptMessage.prototype.show_display = false;

    NostrEncryptMessage.create = function create(properties) {
        return new NostrEncryptMessage(properties);
    };

    NostrEncryptMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).string(message.pubkey);
        writer.uint32(26).string(message.msg);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(32).bool(message.show_display);
        return writer;
    };

    NostrEncryptMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NostrEncryptMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NostrEncryptMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.pubkey = reader.string();
                break;
            case 3:
                message.msg = reader.string();
                break;
            case 4:
                message.show_display = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("pubkey"))
            throw $util.ProtocolError("missing required 'pubkey'", { instance: message });
        if (!message.hasOwnProperty("msg"))
            throw $util.ProtocolError("missing required 'msg'", { instance: message });
        return message;
    };

    NostrEncryptMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NostrEncryptMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!$util.isString(message.pubkey))
            return "pubkey: string expected";
        if (!$util.isString(message.msg))
            return "msg: string expected";
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        return null;
    };

    NostrEncryptMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.NostrEncryptMessage)
            return object;
        var message = new $root.NostrEncryptMessage();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".NostrEncryptMessage.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.pubkey != null)
            message.pubkey = String(object.pubkey);
        if (object.msg != null)
            message.msg = String(object.msg);
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        return message;
    };

    NostrEncryptMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            object.pubkey = "";
            object.msg = "";
            object.show_display = false;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.pubkey != null && message.hasOwnProperty("pubkey"))
            object.pubkey = message.pubkey;
        if (message.msg != null && message.hasOwnProperty("msg"))
            object.msg = message.msg;
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        return object;
    };

    NostrEncryptMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NostrEncryptMessage;
})();

$root.NostrEncryptedMessage = (function() {

    function NostrEncryptedMessage(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NostrEncryptedMessage.prototype.msg = "";

    NostrEncryptedMessage.create = function create(properties) {
        return new NostrEncryptedMessage(properties);
    };

    NostrEncryptedMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.msg);
        return writer;
    };

    NostrEncryptedMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NostrEncryptedMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NostrEncryptedMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.msg = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("msg"))
            throw $util.ProtocolError("missing required 'msg'", { instance: message });
        return message;
    };

    NostrEncryptedMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NostrEncryptedMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.msg))
            return "msg: string expected";
        return null;
    };

    NostrEncryptedMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.NostrEncryptedMessage)
            return object;
        var message = new $root.NostrEncryptedMessage();
        if (object.msg != null)
            message.msg = String(object.msg);
        return message;
    };

    NostrEncryptedMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.msg = "";
        if (message.msg != null && message.hasOwnProperty("msg"))
            object.msg = message.msg;
        return object;
    };

    NostrEncryptedMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NostrEncryptedMessage;
})();

$root.NostrDecryptMessage = (function() {

    function NostrDecryptMessage(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NostrDecryptMessage.prototype.address_n = $util.emptyArray;
    NostrDecryptMessage.prototype.pubkey = "";
    NostrDecryptMessage.prototype.msg = "";
    NostrDecryptMessage.prototype.show_display = false;

    NostrDecryptMessage.create = function create(properties) {
        return new NostrDecryptMessage(properties);
    };

    NostrDecryptMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).string(message.pubkey);
        writer.uint32(26).string(message.msg);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(32).bool(message.show_display);
        return writer;
    };

    NostrDecryptMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NostrDecryptMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NostrDecryptMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.pubkey = reader.string();
                break;
            case 3:
                message.msg = reader.string();
                break;
            case 4:
                message.show_display = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("pubkey"))
            throw $util.ProtocolError("missing required 'pubkey'", { instance: message });
        if (!message.hasOwnProperty("msg"))
            throw $util.ProtocolError("missing required 'msg'", { instance: message });
        return message;
    };

    NostrDecryptMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NostrDecryptMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!$util.isString(message.pubkey))
            return "pubkey: string expected";
        if (!$util.isString(message.msg))
            return "msg: string expected";
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        return null;
    };

    NostrDecryptMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.NostrDecryptMessage)
            return object;
        var message = new $root.NostrDecryptMessage();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".NostrDecryptMessage.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.pubkey != null)
            message.pubkey = String(object.pubkey);
        if (object.msg != null)
            message.msg = String(object.msg);
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        return message;
    };

    NostrDecryptMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            object.pubkey = "";
            object.msg = "";
            object.show_display = false;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.pubkey != null && message.hasOwnProperty("pubkey"))
            object.pubkey = message.pubkey;
        if (message.msg != null && message.hasOwnProperty("msg"))
            object.msg = message.msg;
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        return object;
    };

    NostrDecryptMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NostrDecryptMessage;
})();

$root.NostrDecryptedMessage = (function() {

    function NostrDecryptedMessage(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NostrDecryptedMessage.prototype.msg = "";

    NostrDecryptedMessage.create = function create(properties) {
        return new NostrDecryptedMessage(properties);
    };

    NostrDecryptedMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.msg);
        return writer;
    };

    NostrDecryptedMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NostrDecryptedMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NostrDecryptedMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.msg = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("msg"))
            throw $util.ProtocolError("missing required 'msg'", { instance: message });
        return message;
    };

    NostrDecryptedMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NostrDecryptedMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.msg))
            return "msg: string expected";
        return null;
    };

    NostrDecryptedMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.NostrDecryptedMessage)
            return object;
        var message = new $root.NostrDecryptedMessage();
        if (object.msg != null)
            message.msg = String(object.msg);
        return message;
    };

    NostrDecryptedMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.msg = "";
        if (message.msg != null && message.hasOwnProperty("msg"))
            object.msg = message.msg;
        return object;
    };

    NostrDecryptedMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NostrDecryptedMessage;
})();

$root.PassphraseRequest = (function() {

    function PassphraseRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    PassphraseRequest.prototype._on_device = false;
    PassphraseRequest.prototype.exists_attach_pin_user = false;

    PassphraseRequest.create = function create(properties) {
        return new PassphraseRequest(properties);
    };

    PassphraseRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message._on_device != null && Object.hasOwnProperty.call(message, "_on_device"))
            writer.uint32(8).bool(message._on_device);
        if (message.exists_attach_pin_user != null && Object.hasOwnProperty.call(message, "exists_attach_pin_user"))
            writer.uint32(64000).bool(message.exists_attach_pin_user);
        return writer;
    };

    PassphraseRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    PassphraseRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.PassphraseRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message._on_device = reader.bool();
                break;
            case 8000:
                message.exists_attach_pin_user = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    PassphraseRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    PassphraseRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message._on_device != null && message.hasOwnProperty("_on_device"))
            if (typeof message._on_device !== "boolean")
                return "_on_device: boolean expected";
        if (message.exists_attach_pin_user != null && message.hasOwnProperty("exists_attach_pin_user"))
            if (typeof message.exists_attach_pin_user !== "boolean")
                return "exists_attach_pin_user: boolean expected";
        return null;
    };

    PassphraseRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.PassphraseRequest)
            return object;
        var message = new $root.PassphraseRequest();
        if (object._on_device != null)
            message._on_device = Boolean(object._on_device);
        if (object.exists_attach_pin_user != null)
            message.exists_attach_pin_user = Boolean(object.exists_attach_pin_user);
        return message;
    };

    PassphraseRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object._on_device = false;
            object.exists_attach_pin_user = false;
        }
        if (message._on_device != null && message.hasOwnProperty("_on_device"))
            object._on_device = message._on_device;
        if (message.exists_attach_pin_user != null && message.hasOwnProperty("exists_attach_pin_user"))
            object.exists_attach_pin_user = message.exists_attach_pin_user;
        return object;
    };

    PassphraseRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return PassphraseRequest;
})();

$root.PassphraseAck = (function() {

    function PassphraseAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    PassphraseAck.prototype.passphrase = "";
    PassphraseAck.prototype._state = $util.newBuffer([]);
    PassphraseAck.prototype.on_device = false;
    PassphraseAck.prototype.on_device_attach_pin = false;

    PassphraseAck.create = function create(properties) {
        return new PassphraseAck(properties);
    };

    PassphraseAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.passphrase != null && Object.hasOwnProperty.call(message, "passphrase"))
            writer.uint32(10).string(message.passphrase);
        if (message._state != null && Object.hasOwnProperty.call(message, "_state"))
            writer.uint32(18).bytes(message._state);
        if (message.on_device != null && Object.hasOwnProperty.call(message, "on_device"))
            writer.uint32(24).bool(message.on_device);
        if (message.on_device_attach_pin != null && Object.hasOwnProperty.call(message, "on_device_attach_pin"))
            writer.uint32(64000).bool(message.on_device_attach_pin);
        return writer;
    };

    PassphraseAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    PassphraseAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.PassphraseAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.passphrase = reader.string();
                break;
            case 2:
                message._state = reader.bytes();
                break;
            case 3:
                message.on_device = reader.bool();
                break;
            case 8000:
                message.on_device_attach_pin = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    PassphraseAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    PassphraseAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.passphrase != null && message.hasOwnProperty("passphrase"))
            if (!$util.isString(message.passphrase))
                return "passphrase: string expected";
        if (message._state != null && message.hasOwnProperty("_state"))
            if (!(message._state && typeof message._state.length === "number" || $util.isString(message._state)))
                return "_state: buffer expected";
        if (message.on_device != null && message.hasOwnProperty("on_device"))
            if (typeof message.on_device !== "boolean")
                return "on_device: boolean expected";
        if (message.on_device_attach_pin != null && message.hasOwnProperty("on_device_attach_pin"))
            if (typeof message.on_device_attach_pin !== "boolean")
                return "on_device_attach_pin: boolean expected";
        return null;
    };

    PassphraseAck.fromObject = function fromObject(object) {
        if (object instanceof $root.PassphraseAck)
            return object;
        var message = new $root.PassphraseAck();
        if (object.passphrase != null)
            message.passphrase = String(object.passphrase);
        if (object._state != null)
            if (typeof object._state === "string")
                $util.base64.decode(object._state, message._state = $util.newBuffer($util.base64.length(object._state)), 0);
            else if (object._state.length)
                message._state = object._state;
        if (object.on_device != null)
            message.on_device = Boolean(object.on_device);
        if (object.on_device_attach_pin != null)
            message.on_device_attach_pin = Boolean(object.on_device_attach_pin);
        return message;
    };

    PassphraseAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.passphrase = "";
            if (options.bytes === String)
                object._state = "";
            else {
                object._state = [];
                if (options.bytes !== Array)
                    object._state = $util.newBuffer(object._state);
            }
            object.on_device = false;
            object.on_device_attach_pin = false;
        }
        if (message.passphrase != null && message.hasOwnProperty("passphrase"))
            object.passphrase = message.passphrase;
        if (message._state != null && message.hasOwnProperty("_state"))
            object._state = options.bytes === String ? $util.base64.encode(message._state, 0, message._state.length) : options.bytes === Array ? Array.prototype.slice.call(message._state) : message._state;
        if (message.on_device != null && message.hasOwnProperty("on_device"))
            object.on_device = message.on_device;
        if (message.on_device_attach_pin != null && message.hasOwnProperty("on_device_attach_pin"))
            object.on_device_attach_pin = message.on_device_attach_pin;
        return object;
    };

    PassphraseAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return PassphraseAck;
})();

$root.PolkadotGetAddress = (function() {

    function PolkadotGetAddress(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    PolkadotGetAddress.prototype.address_n = $util.emptyArray;
    PolkadotGetAddress.prototype.prefix = 0;
    PolkadotGetAddress.prototype.network = "";
    PolkadotGetAddress.prototype.show_display = false;

    PolkadotGetAddress.create = function create(properties) {
        return new PolkadotGetAddress(properties);
    };

    PolkadotGetAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(16).uint32(message.prefix);
        writer.uint32(26).string(message.network);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(32).bool(message.show_display);
        return writer;
    };

    PolkadotGetAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    PolkadotGetAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.PolkadotGetAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.prefix = reader.uint32();
                break;
            case 3:
                message.network = reader.string();
                break;
            case 4:
                message.show_display = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("prefix"))
            throw $util.ProtocolError("missing required 'prefix'", { instance: message });
        if (!message.hasOwnProperty("network"))
            throw $util.ProtocolError("missing required 'network'", { instance: message });
        return message;
    };

    PolkadotGetAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    PolkadotGetAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!$util.isInteger(message.prefix))
            return "prefix: integer expected";
        if (!$util.isString(message.network))
            return "network: string expected";
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        return null;
    };

    PolkadotGetAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.PolkadotGetAddress)
            return object;
        var message = new $root.PolkadotGetAddress();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".PolkadotGetAddress.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.prefix != null)
            message.prefix = object.prefix >>> 0;
        if (object.network != null)
            message.network = String(object.network);
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        return message;
    };

    PolkadotGetAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            object.prefix = 0;
            object.network = "";
            object.show_display = false;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.prefix != null && message.hasOwnProperty("prefix"))
            object.prefix = message.prefix;
        if (message.network != null && message.hasOwnProperty("network"))
            object.network = message.network;
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        return object;
    };

    PolkadotGetAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return PolkadotGetAddress;
})();

$root.PolkadotAddress = (function() {

    function PolkadotAddress(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    PolkadotAddress.prototype.address = "";
    PolkadotAddress.prototype.public_key = "";

    PolkadotAddress.create = function create(properties) {
        return new PolkadotAddress(properties);
    };

    PolkadotAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address != null && Object.hasOwnProperty.call(message, "address"))
            writer.uint32(10).string(message.address);
        if (message.public_key != null && Object.hasOwnProperty.call(message, "public_key"))
            writer.uint32(18).string(message.public_key);
        return writer;
    };

    PolkadotAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    PolkadotAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.PolkadotAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.string();
                break;
            case 2:
                message.public_key = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    PolkadotAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    PolkadotAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address != null && message.hasOwnProperty("address"))
            if (!$util.isString(message.address))
                return "address: string expected";
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            if (!$util.isString(message.public_key))
                return "public_key: string expected";
        return null;
    };

    PolkadotAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.PolkadotAddress)
            return object;
        var message = new $root.PolkadotAddress();
        if (object.address != null)
            message.address = String(object.address);
        if (object.public_key != null)
            message.public_key = String(object.public_key);
        return message;
    };

    PolkadotAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.address = "";
            object.public_key = "";
        }
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            object.public_key = message.public_key;
        return object;
    };

    PolkadotAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return PolkadotAddress;
})();

$root.PolkadotSignTx = (function() {

    function PolkadotSignTx(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    PolkadotSignTx.prototype.address_n = $util.emptyArray;
    PolkadotSignTx.prototype.raw_tx = $util.newBuffer([]);
    PolkadotSignTx.prototype.network = "";

    PolkadotSignTx.create = function create(properties) {
        return new PolkadotSignTx(properties);
    };

    PolkadotSignTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).bytes(message.raw_tx);
        writer.uint32(26).string(message.network);
        return writer;
    };

    PolkadotSignTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    PolkadotSignTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.PolkadotSignTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.raw_tx = reader.bytes();
                break;
            case 3:
                message.network = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("raw_tx"))
            throw $util.ProtocolError("missing required 'raw_tx'", { instance: message });
        if (!message.hasOwnProperty("network"))
            throw $util.ProtocolError("missing required 'network'", { instance: message });
        return message;
    };

    PolkadotSignTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    PolkadotSignTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!(message.raw_tx && typeof message.raw_tx.length === "number" || $util.isString(message.raw_tx)))
            return "raw_tx: buffer expected";
        if (!$util.isString(message.network))
            return "network: string expected";
        return null;
    };

    PolkadotSignTx.fromObject = function fromObject(object) {
        if (object instanceof $root.PolkadotSignTx)
            return object;
        var message = new $root.PolkadotSignTx();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".PolkadotSignTx.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.raw_tx != null)
            if (typeof object.raw_tx === "string")
                $util.base64.decode(object.raw_tx, message.raw_tx = $util.newBuffer($util.base64.length(object.raw_tx)), 0);
            else if (object.raw_tx.length)
                message.raw_tx = object.raw_tx;
        if (object.network != null)
            message.network = String(object.network);
        return message;
    };

    PolkadotSignTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            if (options.bytes === String)
                object.raw_tx = "";
            else {
                object.raw_tx = [];
                if (options.bytes !== Array)
                    object.raw_tx = $util.newBuffer(object.raw_tx);
            }
            object.network = "";
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.raw_tx != null && message.hasOwnProperty("raw_tx"))
            object.raw_tx = options.bytes === String ? $util.base64.encode(message.raw_tx, 0, message.raw_tx.length) : options.bytes === Array ? Array.prototype.slice.call(message.raw_tx) : message.raw_tx;
        if (message.network != null && message.hasOwnProperty("network"))
            object.network = message.network;
        return object;
    };

    PolkadotSignTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return PolkadotSignTx;
})();

$root.PolkadotSignedTx = (function() {

    function PolkadotSignedTx(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    PolkadotSignedTx.prototype.signature = $util.newBuffer([]);

    PolkadotSignedTx.create = function create(properties) {
        return new PolkadotSignedTx(properties);
    };

    PolkadotSignedTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.signature);
        return writer;
    };

    PolkadotSignedTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    PolkadotSignedTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.PolkadotSignedTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.signature = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        return message;
    };

    PolkadotSignedTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    PolkadotSignedTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        return null;
    };

    PolkadotSignedTx.fromObject = function fromObject(object) {
        if (object instanceof $root.PolkadotSignedTx)
            return object;
        var message = new $root.PolkadotSignedTx();
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        return message;
    };

    PolkadotSignedTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        return object;
    };

    PolkadotSignedTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return PolkadotSignedTx;
})();

$root.RippleGetAddress = (function() {

    function RippleGetAddress(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    RippleGetAddress.prototype.address_n = $util.emptyArray;
    RippleGetAddress.prototype.show_display = false;

    RippleGetAddress.create = function create(properties) {
        return new RippleGetAddress(properties);
    };

    RippleGetAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(16).bool(message.show_display);
        return writer;
    };

    RippleGetAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    RippleGetAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.RippleGetAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.show_display = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    RippleGetAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    RippleGetAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        return null;
    };

    RippleGetAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.RippleGetAddress)
            return object;
        var message = new $root.RippleGetAddress();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".RippleGetAddress.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        return message;
    };

    RippleGetAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            object.show_display = false;
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        return object;
    };

    RippleGetAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return RippleGetAddress;
})();

$root.RippleAddress = (function() {

    function RippleAddress(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    RippleAddress.prototype.address = "";

    RippleAddress.create = function create(properties) {
        return new RippleAddress(properties);
    };

    RippleAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.address);
        return writer;
    };

    RippleAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    RippleAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.RippleAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("address"))
            throw $util.ProtocolError("missing required 'address'", { instance: message });
        return message;
    };

    RippleAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    RippleAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.address))
            return "address: string expected";
        return null;
    };

    RippleAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.RippleAddress)
            return object;
        var message = new $root.RippleAddress();
        if (object.address != null)
            message.address = String(object.address);
        return message;
    };

    RippleAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.address = "";
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    RippleAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return RippleAddress;
})();

$root.RippleSignTx = (function() {

    function RippleSignTx(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    RippleSignTx.prototype.address_n = $util.emptyArray;
    RippleSignTx.prototype.fee = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    RippleSignTx.prototype.flags = 0;
    RippleSignTx.prototype.sequence = 0;
    RippleSignTx.prototype.last_ledger_sequence = 0;
    RippleSignTx.prototype.payment = null;

    RippleSignTx.create = function create(properties) {
        return new RippleSignTx(properties);
    };

    RippleSignTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(16).uint64(message.fee);
        if (message.flags != null && Object.hasOwnProperty.call(message, "flags"))
            writer.uint32(24).uint32(message.flags);
        writer.uint32(32).uint32(message.sequence);
        if (message.last_ledger_sequence != null && Object.hasOwnProperty.call(message, "last_ledger_sequence"))
            writer.uint32(40).uint32(message.last_ledger_sequence);
        $root.RippleSignTx.RipplePayment.encode(message.payment, writer.uint32(50).fork()).ldelim();
        return writer;
    };

    RippleSignTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    RippleSignTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.RippleSignTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.fee = reader.uint64();
                break;
            case 3:
                message.flags = reader.uint32();
                break;
            case 4:
                message.sequence = reader.uint32();
                break;
            case 5:
                message.last_ledger_sequence = reader.uint32();
                break;
            case 6:
                message.payment = $root.RippleSignTx.RipplePayment.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("fee"))
            throw $util.ProtocolError("missing required 'fee'", { instance: message });
        if (!message.hasOwnProperty("sequence"))
            throw $util.ProtocolError("missing required 'sequence'", { instance: message });
        if (!message.hasOwnProperty("payment"))
            throw $util.ProtocolError("missing required 'payment'", { instance: message });
        return message;
    };

    RippleSignTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    RippleSignTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!$util.isInteger(message.fee) && !(message.fee && $util.isInteger(message.fee.low) && $util.isInteger(message.fee.high)))
            return "fee: integer|Long expected";
        if (message.flags != null && message.hasOwnProperty("flags"))
            if (!$util.isInteger(message.flags))
                return "flags: integer expected";
        if (!$util.isInteger(message.sequence))
            return "sequence: integer expected";
        if (message.last_ledger_sequence != null && message.hasOwnProperty("last_ledger_sequence"))
            if (!$util.isInteger(message.last_ledger_sequence))
                return "last_ledger_sequence: integer expected";
        {
            var error = $root.RippleSignTx.RipplePayment.verify(message.payment);
            if (error)
                return "payment." + error;
        }
        return null;
    };

    RippleSignTx.fromObject = function fromObject(object) {
        if (object instanceof $root.RippleSignTx)
            return object;
        var message = new $root.RippleSignTx();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".RippleSignTx.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.fee != null)
            if ($util.Long)
                (message.fee = $util.Long.fromValue(object.fee)).unsigned = true;
            else if (typeof object.fee === "string")
                message.fee = parseInt(object.fee, 10);
            else if (typeof object.fee === "number")
                message.fee = object.fee;
            else if (typeof object.fee === "object")
                message.fee = new $util.LongBits(object.fee.low >>> 0, object.fee.high >>> 0).toNumber(true);
        if (object.flags != null)
            message.flags = object.flags >>> 0;
        if (object.sequence != null)
            message.sequence = object.sequence >>> 0;
        if (object.last_ledger_sequence != null)
            message.last_ledger_sequence = object.last_ledger_sequence >>> 0;
        if (object.payment != null) {
            if (typeof object.payment !== "object")
                throw TypeError(".RippleSignTx.payment: object expected");
            message.payment = $root.RippleSignTx.RipplePayment.fromObject(object.payment);
        }
        return message;
    };

    RippleSignTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.fee = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.fee = options.longs === String ? "0" : 0;
            object.flags = 0;
            object.sequence = 0;
            object.last_ledger_sequence = 0;
            object.payment = null;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.fee != null && message.hasOwnProperty("fee"))
            if (typeof message.fee === "number")
                object.fee = options.longs === String ? String(message.fee) : message.fee;
            else
                object.fee = options.longs === String ? $util.Long.prototype.toString.call(message.fee) : options.longs === Number ? new $util.LongBits(message.fee.low >>> 0, message.fee.high >>> 0).toNumber(true) : message.fee;
        if (message.flags != null && message.hasOwnProperty("flags"))
            object.flags = message.flags;
        if (message.sequence != null && message.hasOwnProperty("sequence"))
            object.sequence = message.sequence;
        if (message.last_ledger_sequence != null && message.hasOwnProperty("last_ledger_sequence"))
            object.last_ledger_sequence = message.last_ledger_sequence;
        if (message.payment != null && message.hasOwnProperty("payment"))
            object.payment = $root.RippleSignTx.RipplePayment.toObject(message.payment, options);
        return object;
    };

    RippleSignTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    RippleSignTx.RipplePayment = (function() {

        function RipplePayment(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        RipplePayment.prototype.amount = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        RipplePayment.prototype.destination = "";
        RipplePayment.prototype.destination_tag = 0;

        RipplePayment.create = function create(properties) {
            return new RipplePayment(properties);
        };

        RipplePayment.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(8).uint64(message.amount);
            writer.uint32(18).string(message.destination);
            if (message.destination_tag != null && Object.hasOwnProperty.call(message, "destination_tag"))
                writer.uint32(24).uint32(message.destination_tag);
            return writer;
        };

        RipplePayment.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        RipplePayment.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.RippleSignTx.RipplePayment();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.amount = reader.uint64();
                    break;
                case 2:
                    message.destination = reader.string();
                    break;
                case 3:
                    message.destination_tag = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("amount"))
                throw $util.ProtocolError("missing required 'amount'", { instance: message });
            if (!message.hasOwnProperty("destination"))
                throw $util.ProtocolError("missing required 'destination'", { instance: message });
            return message;
        };

        RipplePayment.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        RipplePayment.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
                return "amount: integer|Long expected";
            if (!$util.isString(message.destination))
                return "destination: string expected";
            if (message.destination_tag != null && message.hasOwnProperty("destination_tag"))
                if (!$util.isInteger(message.destination_tag))
                    return "destination_tag: integer expected";
            return null;
        };

        RipplePayment.fromObject = function fromObject(object) {
            if (object instanceof $root.RippleSignTx.RipplePayment)
                return object;
            var message = new $root.RippleSignTx.RipplePayment();
            if (object.amount != null)
                if ($util.Long)
                    (message.amount = $util.Long.fromValue(object.amount)).unsigned = true;
                else if (typeof object.amount === "string")
                    message.amount = parseInt(object.amount, 10);
                else if (typeof object.amount === "number")
                    message.amount = object.amount;
                else if (typeof object.amount === "object")
                    message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber(true);
            if (object.destination != null)
                message.destination = String(object.destination);
            if (object.destination_tag != null)
                message.destination_tag = object.destination_tag >>> 0;
            return message;
        };

        RipplePayment.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.amount = options.longs === String ? "0" : 0;
                object.destination = "";
                object.destination_tag = 0;
            }
            if (message.amount != null && message.hasOwnProperty("amount"))
                if (typeof message.amount === "number")
                    object.amount = options.longs === String ? String(message.amount) : message.amount;
                else
                    object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber(true) : message.amount;
            if (message.destination != null && message.hasOwnProperty("destination"))
                object.destination = message.destination;
            if (message.destination_tag != null && message.hasOwnProperty("destination_tag"))
                object.destination_tag = message.destination_tag;
            return object;
        };

        RipplePayment.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RipplePayment;
    })();

    return RippleSignTx;
})();

$root.RippleSignedTx = (function() {

    function RippleSignedTx(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    RippleSignedTx.prototype.signature = $util.newBuffer([]);
    RippleSignedTx.prototype.serialized_tx = $util.newBuffer([]);

    RippleSignedTx.create = function create(properties) {
        return new RippleSignedTx(properties);
    };

    RippleSignedTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.signature);
        writer.uint32(18).bytes(message.serialized_tx);
        return writer;
    };

    RippleSignedTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    RippleSignedTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.RippleSignedTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.signature = reader.bytes();
                break;
            case 2:
                message.serialized_tx = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        if (!message.hasOwnProperty("serialized_tx"))
            throw $util.ProtocolError("missing required 'serialized_tx'", { instance: message });
        return message;
    };

    RippleSignedTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    RippleSignedTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        if (!(message.serialized_tx && typeof message.serialized_tx.length === "number" || $util.isString(message.serialized_tx)))
            return "serialized_tx: buffer expected";
        return null;
    };

    RippleSignedTx.fromObject = function fromObject(object) {
        if (object instanceof $root.RippleSignedTx)
            return object;
        var message = new $root.RippleSignedTx();
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        if (object.serialized_tx != null)
            if (typeof object.serialized_tx === "string")
                $util.base64.decode(object.serialized_tx, message.serialized_tx = $util.newBuffer($util.base64.length(object.serialized_tx)), 0);
            else if (object.serialized_tx.length)
                message.serialized_tx = object.serialized_tx;
        return message;
    };

    RippleSignedTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
            if (options.bytes === String)
                object.serialized_tx = "";
            else {
                object.serialized_tx = [];
                if (options.bytes !== Array)
                    object.serialized_tx = $util.newBuffer(object.serialized_tx);
            }
        }
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        if (message.serialized_tx != null && message.hasOwnProperty("serialized_tx"))
            object.serialized_tx = options.bytes === String ? $util.base64.encode(message.serialized_tx, 0, message.serialized_tx.length) : options.bytes === Array ? Array.prototype.slice.call(message.serialized_tx) : message.serialized_tx;
        return object;
    };

    RippleSignedTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return RippleSignedTx;
})();

$root.SolanaOffChainMessageVersion = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "MESSAGE_VERSION_0"] = 0;
    values[valuesById[1] = "MESSAGE_VERSION_1"] = 1;
    return values;
})();

$root.SolanaOffChainMessageFormat = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "V0_RESTRICTED_ASCII"] = 0;
    values[valuesById[1] = "V0_LIMITED_UTF8"] = 1;
    return values;
})();

$root.SolanaGetAddress = (function() {

    function SolanaGetAddress(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    SolanaGetAddress.prototype.address_n = $util.emptyArray;
    SolanaGetAddress.prototype.show_display = false;

    SolanaGetAddress.create = function create(properties) {
        return new SolanaGetAddress(properties);
    };

    SolanaGetAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(16).bool(message.show_display);
        return writer;
    };

    SolanaGetAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    SolanaGetAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SolanaGetAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.show_display = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    SolanaGetAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    SolanaGetAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        return null;
    };

    SolanaGetAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.SolanaGetAddress)
            return object;
        var message = new $root.SolanaGetAddress();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".SolanaGetAddress.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        return message;
    };

    SolanaGetAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            object.show_display = false;
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        return object;
    };

    SolanaGetAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SolanaGetAddress;
})();

$root.SolanaAddress = (function() {

    function SolanaAddress(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    SolanaAddress.prototype.address = "";

    SolanaAddress.create = function create(properties) {
        return new SolanaAddress(properties);
    };

    SolanaAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.address);
        return writer;
    };

    SolanaAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    SolanaAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SolanaAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("address"))
            throw $util.ProtocolError("missing required 'address'", { instance: message });
        return message;
    };

    SolanaAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    SolanaAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.address))
            return "address: string expected";
        return null;
    };

    SolanaAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.SolanaAddress)
            return object;
        var message = new $root.SolanaAddress();
        if (object.address != null)
            message.address = String(object.address);
        return message;
    };

    SolanaAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.address = "";
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    SolanaAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SolanaAddress;
})();

$root.SolanaSignTx = (function() {

    function SolanaSignTx(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    SolanaSignTx.prototype.address_n = $util.emptyArray;
    SolanaSignTx.prototype.raw_tx = $util.newBuffer([]);

    SolanaSignTx.create = function create(properties) {
        return new SolanaSignTx(properties);
    };

    SolanaSignTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).bytes(message.raw_tx);
        return writer;
    };

    SolanaSignTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    SolanaSignTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SolanaSignTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.raw_tx = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("raw_tx"))
            throw $util.ProtocolError("missing required 'raw_tx'", { instance: message });
        return message;
    };

    SolanaSignTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    SolanaSignTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!(message.raw_tx && typeof message.raw_tx.length === "number" || $util.isString(message.raw_tx)))
            return "raw_tx: buffer expected";
        return null;
    };

    SolanaSignTx.fromObject = function fromObject(object) {
        if (object instanceof $root.SolanaSignTx)
            return object;
        var message = new $root.SolanaSignTx();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".SolanaSignTx.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.raw_tx != null)
            if (typeof object.raw_tx === "string")
                $util.base64.decode(object.raw_tx, message.raw_tx = $util.newBuffer($util.base64.length(object.raw_tx)), 0);
            else if (object.raw_tx.length)
                message.raw_tx = object.raw_tx;
        return message;
    };

    SolanaSignTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            if (options.bytes === String)
                object.raw_tx = "";
            else {
                object.raw_tx = [];
                if (options.bytes !== Array)
                    object.raw_tx = $util.newBuffer(object.raw_tx);
            }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.raw_tx != null && message.hasOwnProperty("raw_tx"))
            object.raw_tx = options.bytes === String ? $util.base64.encode(message.raw_tx, 0, message.raw_tx.length) : options.bytes === Array ? Array.prototype.slice.call(message.raw_tx) : message.raw_tx;
        return object;
    };

    SolanaSignTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SolanaSignTx;
})();

$root.SolanaSignedTx = (function() {

    function SolanaSignedTx(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    SolanaSignedTx.prototype.signature = $util.newBuffer([]);

    SolanaSignedTx.create = function create(properties) {
        return new SolanaSignedTx(properties);
    };

    SolanaSignedTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.signature);
        return writer;
    };

    SolanaSignedTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    SolanaSignedTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SolanaSignedTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.signature = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        return message;
    };

    SolanaSignedTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    SolanaSignedTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        return null;
    };

    SolanaSignedTx.fromObject = function fromObject(object) {
        if (object instanceof $root.SolanaSignedTx)
            return object;
        var message = new $root.SolanaSignedTx();
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        return message;
    };

    SolanaSignedTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        return object;
    };

    SolanaSignedTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SolanaSignedTx;
})();

$root.SolanaSignOffChainMessage = (function() {

    function SolanaSignOffChainMessage(properties) {
        this.address_n = [];
        this.required_signers = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    SolanaSignOffChainMessage.prototype.address_n = $util.emptyArray;
    SolanaSignOffChainMessage.prototype.message = $util.newBuffer([]);
    SolanaSignOffChainMessage.prototype.message_version = 0;
    SolanaSignOffChainMessage.prototype.message_format = 0;
    SolanaSignOffChainMessage.prototype.application_domain = $util.newBuffer([]);
    SolanaSignOffChainMessage.prototype.required_signers = $util.emptyArray;

    SolanaSignOffChainMessage.create = function create(properties) {
        return new SolanaSignOffChainMessage(properties);
    };

    SolanaSignOffChainMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).bytes(message.message);
        if (message.message_version != null && Object.hasOwnProperty.call(message, "message_version"))
            writer.uint32(24).int32(message.message_version);
        if (message.message_format != null && Object.hasOwnProperty.call(message, "message_format"))
            writer.uint32(32).int32(message.message_format);
        if (message.application_domain != null && Object.hasOwnProperty.call(message, "application_domain"))
            writer.uint32(42).bytes(message.application_domain);
        if (message.required_signers != null && message.required_signers.length)
            for (var i = 0; i < message.required_signers.length; ++i)
                writer.uint32(50).bytes(message.required_signers[i]);
        return writer;
    };

    SolanaSignOffChainMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    SolanaSignOffChainMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SolanaSignOffChainMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.message = reader.bytes();
                break;
            case 3:
                message.message_version = reader.int32();
                break;
            case 4:
                message.message_format = reader.int32();
                break;
            case 5:
                message.application_domain = reader.bytes();
                break;
            case 6:
                if (!(message.required_signers && message.required_signers.length))
                    message.required_signers = [];
                message.required_signers.push(reader.bytes());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("message"))
            throw $util.ProtocolError("missing required 'message'", { instance: message });
        return message;
    };

    SolanaSignOffChainMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    SolanaSignOffChainMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!(message.message && typeof message.message.length === "number" || $util.isString(message.message)))
            return "message: buffer expected";
        if (message.message_version != null && message.hasOwnProperty("message_version"))
            switch (message.message_version) {
            default:
                return "message_version: enum value expected";
            case 0:
            case 1:
                break;
            }
        if (message.message_format != null && message.hasOwnProperty("message_format"))
            switch (message.message_format) {
            default:
                return "message_format: enum value expected";
            case 0:
            case 1:
                break;
            }
        if (message.application_domain != null && message.hasOwnProperty("application_domain"))
            if (!(message.application_domain && typeof message.application_domain.length === "number" || $util.isString(message.application_domain)))
                return "application_domain: buffer expected";
        if (message.required_signers != null && message.hasOwnProperty("required_signers")) {
            if (!Array.isArray(message.required_signers))
                return "required_signers: array expected";
            for (var i = 0; i < message.required_signers.length; ++i)
                if (!(message.required_signers[i] && typeof message.required_signers[i].length === "number" || $util.isString(message.required_signers[i])))
                    return "required_signers: buffer[] expected";
        }
        return null;
    };

    SolanaSignOffChainMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.SolanaSignOffChainMessage)
            return object;
        var message = new $root.SolanaSignOffChainMessage();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".SolanaSignOffChainMessage.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.message != null)
            if (typeof object.message === "string")
                $util.base64.decode(object.message, message.message = $util.newBuffer($util.base64.length(object.message)), 0);
            else if (object.message.length)
                message.message = object.message;
        switch (object.message_version) {
        case "MESSAGE_VERSION_0":
        case 0:
            message.message_version = 0;
            break;
        case "MESSAGE_VERSION_1":
        case 1:
            message.message_version = 1;
            break;
        }
        switch (object.message_format) {
        case "V0_RESTRICTED_ASCII":
        case 0:
            message.message_format = 0;
            break;
        case "V0_LIMITED_UTF8":
        case 1:
            message.message_format = 1;
            break;
        }
        if (object.application_domain != null)
            if (typeof object.application_domain === "string")
                $util.base64.decode(object.application_domain, message.application_domain = $util.newBuffer($util.base64.length(object.application_domain)), 0);
            else if (object.application_domain.length)
                message.application_domain = object.application_domain;
        if (object.required_signers) {
            if (!Array.isArray(object.required_signers))
                throw TypeError(".SolanaSignOffChainMessage.required_signers: array expected");
            message.required_signers = [];
            for (var i = 0; i < object.required_signers.length; ++i)
                if (typeof object.required_signers[i] === "string")
                    $util.base64.decode(object.required_signers[i], message.required_signers[i] = $util.newBuffer($util.base64.length(object.required_signers[i])), 0);
                else if (object.required_signers[i].length)
                    message.required_signers[i] = object.required_signers[i];
        }
        return message;
    };

    SolanaSignOffChainMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults) {
            object.address_n = [];
            object.required_signers = [];
        }
        if (options.defaults) {
            if (options.bytes === String)
                object.message = "";
            else {
                object.message = [];
                if (options.bytes !== Array)
                    object.message = $util.newBuffer(object.message);
            }
            object.message_version = options.enums === String ? "MESSAGE_VERSION_0" : 0;
            object.message_format = options.enums === String ? "V0_RESTRICTED_ASCII" : 0;
            if (options.bytes === String)
                object.application_domain = "";
            else {
                object.application_domain = [];
                if (options.bytes !== Array)
                    object.application_domain = $util.newBuffer(object.application_domain);
            }
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.message != null && message.hasOwnProperty("message"))
            object.message = options.bytes === String ? $util.base64.encode(message.message, 0, message.message.length) : options.bytes === Array ? Array.prototype.slice.call(message.message) : message.message;
        if (message.message_version != null && message.hasOwnProperty("message_version"))
            object.message_version = options.enums === String ? $root.SolanaOffChainMessageVersion[message.message_version] : message.message_version;
        if (message.message_format != null && message.hasOwnProperty("message_format"))
            object.message_format = options.enums === String ? $root.SolanaOffChainMessageFormat[message.message_format] : message.message_format;
        if (message.application_domain != null && message.hasOwnProperty("application_domain"))
            object.application_domain = options.bytes === String ? $util.base64.encode(message.application_domain, 0, message.application_domain.length) : options.bytes === Array ? Array.prototype.slice.call(message.application_domain) : message.application_domain;
        if (message.required_signers && message.required_signers.length) {
            object.required_signers = [];
            for (var j = 0; j < message.required_signers.length; ++j)
                object.required_signers[j] = options.bytes === String ? $util.base64.encode(message.required_signers[j], 0, message.required_signers[j].length) : options.bytes === Array ? Array.prototype.slice.call(message.required_signers[j]) : message.required_signers[j];
        }
        return object;
    };

    SolanaSignOffChainMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SolanaSignOffChainMessage;
})();

$root.SolanaSignUnsafeMessage = (function() {

    function SolanaSignUnsafeMessage(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    SolanaSignUnsafeMessage.prototype.address_n = $util.emptyArray;
    SolanaSignUnsafeMessage.prototype.message = $util.newBuffer([]);

    SolanaSignUnsafeMessage.create = function create(properties) {
        return new SolanaSignUnsafeMessage(properties);
    };

    SolanaSignUnsafeMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).bytes(message.message);
        return writer;
    };

    SolanaSignUnsafeMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    SolanaSignUnsafeMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SolanaSignUnsafeMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.message = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("message"))
            throw $util.ProtocolError("missing required 'message'", { instance: message });
        return message;
    };

    SolanaSignUnsafeMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    SolanaSignUnsafeMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!(message.message && typeof message.message.length === "number" || $util.isString(message.message)))
            return "message: buffer expected";
        return null;
    };

    SolanaSignUnsafeMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.SolanaSignUnsafeMessage)
            return object;
        var message = new $root.SolanaSignUnsafeMessage();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".SolanaSignUnsafeMessage.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.message != null)
            if (typeof object.message === "string")
                $util.base64.decode(object.message, message.message = $util.newBuffer($util.base64.length(object.message)), 0);
            else if (object.message.length)
                message.message = object.message;
        return message;
    };

    SolanaSignUnsafeMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            if (options.bytes === String)
                object.message = "";
            else {
                object.message = [];
                if (options.bytes !== Array)
                    object.message = $util.newBuffer(object.message);
            }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.message != null && message.hasOwnProperty("message"))
            object.message = options.bytes === String ? $util.base64.encode(message.message, 0, message.message.length) : options.bytes === Array ? Array.prototype.slice.call(message.message) : message.message;
        return object;
    };

    SolanaSignUnsafeMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SolanaSignUnsafeMessage;
})();

$root.SolanaMessageSignature = (function() {

    function SolanaMessageSignature(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    SolanaMessageSignature.prototype.signature = $util.newBuffer([]);
    SolanaMessageSignature.prototype.public_key = $util.newBuffer([]);

    SolanaMessageSignature.create = function create(properties) {
        return new SolanaMessageSignature(properties);
    };

    SolanaMessageSignature.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.signature);
        if (message.public_key != null && Object.hasOwnProperty.call(message, "public_key"))
            writer.uint32(18).bytes(message.public_key);
        return writer;
    };

    SolanaMessageSignature.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    SolanaMessageSignature.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SolanaMessageSignature();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.signature = reader.bytes();
                break;
            case 2:
                message.public_key = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        return message;
    };

    SolanaMessageSignature.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    SolanaMessageSignature.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            if (!(message.public_key && typeof message.public_key.length === "number" || $util.isString(message.public_key)))
                return "public_key: buffer expected";
        return null;
    };

    SolanaMessageSignature.fromObject = function fromObject(object) {
        if (object instanceof $root.SolanaMessageSignature)
            return object;
        var message = new $root.SolanaMessageSignature();
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        if (object.public_key != null)
            if (typeof object.public_key === "string")
                $util.base64.decode(object.public_key, message.public_key = $util.newBuffer($util.base64.length(object.public_key)), 0);
            else if (object.public_key.length)
                message.public_key = object.public_key;
        return message;
    };

    SolanaMessageSignature.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
            if (options.bytes === String)
                object.public_key = "";
            else {
                object.public_key = [];
                if (options.bytes !== Array)
                    object.public_key = $util.newBuffer(object.public_key);
            }
        }
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            object.public_key = options.bytes === String ? $util.base64.encode(message.public_key, 0, message.public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.public_key) : message.public_key;
        return object;
    };

    SolanaMessageSignature.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SolanaMessageSignature;
})();

$root.StarcoinGetAddress = (function() {

    function StarcoinGetAddress(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    StarcoinGetAddress.prototype.address_n = $util.emptyArray;
    StarcoinGetAddress.prototype.show_display = false;

    StarcoinGetAddress.create = function create(properties) {
        return new StarcoinGetAddress(properties);
    };

    StarcoinGetAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(16).bool(message.show_display);
        return writer;
    };

    StarcoinGetAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    StarcoinGetAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.StarcoinGetAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.show_display = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    StarcoinGetAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    StarcoinGetAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        return null;
    };

    StarcoinGetAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.StarcoinGetAddress)
            return object;
        var message = new $root.StarcoinGetAddress();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".StarcoinGetAddress.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        return message;
    };

    StarcoinGetAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            object.show_display = false;
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        return object;
    };

    StarcoinGetAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return StarcoinGetAddress;
})();

$root.StarcoinAddress = (function() {

    function StarcoinAddress(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    StarcoinAddress.prototype.address = "";

    StarcoinAddress.create = function create(properties) {
        return new StarcoinAddress(properties);
    };

    StarcoinAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address != null && Object.hasOwnProperty.call(message, "address"))
            writer.uint32(10).string(message.address);
        return writer;
    };

    StarcoinAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    StarcoinAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.StarcoinAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    StarcoinAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    StarcoinAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address != null && message.hasOwnProperty("address"))
            if (!$util.isString(message.address))
                return "address: string expected";
        return null;
    };

    StarcoinAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.StarcoinAddress)
            return object;
        var message = new $root.StarcoinAddress();
        if (object.address != null)
            message.address = String(object.address);
        return message;
    };

    StarcoinAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.address = "";
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    StarcoinAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return StarcoinAddress;
})();

$root.StarcoinGetPublicKey = (function() {

    function StarcoinGetPublicKey(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    StarcoinGetPublicKey.prototype.address_n = $util.emptyArray;
    StarcoinGetPublicKey.prototype.show_display = false;

    StarcoinGetPublicKey.create = function create(properties) {
        return new StarcoinGetPublicKey(properties);
    };

    StarcoinGetPublicKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(16).bool(message.show_display);
        return writer;
    };

    StarcoinGetPublicKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    StarcoinGetPublicKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.StarcoinGetPublicKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.show_display = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    StarcoinGetPublicKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    StarcoinGetPublicKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        return null;
    };

    StarcoinGetPublicKey.fromObject = function fromObject(object) {
        if (object instanceof $root.StarcoinGetPublicKey)
            return object;
        var message = new $root.StarcoinGetPublicKey();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".StarcoinGetPublicKey.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        return message;
    };

    StarcoinGetPublicKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            object.show_display = false;
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        return object;
    };

    StarcoinGetPublicKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return StarcoinGetPublicKey;
})();

$root.StarcoinPublicKey = (function() {

    function StarcoinPublicKey(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    StarcoinPublicKey.prototype.public_key = $util.newBuffer([]);

    StarcoinPublicKey.create = function create(properties) {
        return new StarcoinPublicKey(properties);
    };

    StarcoinPublicKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.public_key);
        return writer;
    };

    StarcoinPublicKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    StarcoinPublicKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.StarcoinPublicKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.public_key = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("public_key"))
            throw $util.ProtocolError("missing required 'public_key'", { instance: message });
        return message;
    };

    StarcoinPublicKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    StarcoinPublicKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.public_key && typeof message.public_key.length === "number" || $util.isString(message.public_key)))
            return "public_key: buffer expected";
        return null;
    };

    StarcoinPublicKey.fromObject = function fromObject(object) {
        if (object instanceof $root.StarcoinPublicKey)
            return object;
        var message = new $root.StarcoinPublicKey();
        if (object.public_key != null)
            if (typeof object.public_key === "string")
                $util.base64.decode(object.public_key, message.public_key = $util.newBuffer($util.base64.length(object.public_key)), 0);
            else if (object.public_key.length)
                message.public_key = object.public_key;
        return message;
    };

    StarcoinPublicKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.public_key = "";
            else {
                object.public_key = [];
                if (options.bytes !== Array)
                    object.public_key = $util.newBuffer(object.public_key);
            }
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            object.public_key = options.bytes === String ? $util.base64.encode(message.public_key, 0, message.public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.public_key) : message.public_key;
        return object;
    };

    StarcoinPublicKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return StarcoinPublicKey;
})();

$root.StarcoinSignTx = (function() {

    function StarcoinSignTx(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    StarcoinSignTx.prototype.address_n = $util.emptyArray;
    StarcoinSignTx.prototype.raw_tx = $util.newBuffer([]);

    StarcoinSignTx.create = function create(properties) {
        return new StarcoinSignTx(properties);
    };

    StarcoinSignTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).bytes(message.raw_tx);
        return writer;
    };

    StarcoinSignTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    StarcoinSignTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.StarcoinSignTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.raw_tx = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("raw_tx"))
            throw $util.ProtocolError("missing required 'raw_tx'", { instance: message });
        return message;
    };

    StarcoinSignTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    StarcoinSignTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!(message.raw_tx && typeof message.raw_tx.length === "number" || $util.isString(message.raw_tx)))
            return "raw_tx: buffer expected";
        return null;
    };

    StarcoinSignTx.fromObject = function fromObject(object) {
        if (object instanceof $root.StarcoinSignTx)
            return object;
        var message = new $root.StarcoinSignTx();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".StarcoinSignTx.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.raw_tx != null)
            if (typeof object.raw_tx === "string")
                $util.base64.decode(object.raw_tx, message.raw_tx = $util.newBuffer($util.base64.length(object.raw_tx)), 0);
            else if (object.raw_tx.length)
                message.raw_tx = object.raw_tx;
        return message;
    };

    StarcoinSignTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            if (options.bytes === String)
                object.raw_tx = "";
            else {
                object.raw_tx = [];
                if (options.bytes !== Array)
                    object.raw_tx = $util.newBuffer(object.raw_tx);
            }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.raw_tx != null && message.hasOwnProperty("raw_tx"))
            object.raw_tx = options.bytes === String ? $util.base64.encode(message.raw_tx, 0, message.raw_tx.length) : options.bytes === Array ? Array.prototype.slice.call(message.raw_tx) : message.raw_tx;
        return object;
    };

    StarcoinSignTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return StarcoinSignTx;
})();

$root.StarcoinSignedTx = (function() {

    function StarcoinSignedTx(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    StarcoinSignedTx.prototype.public_key = $util.newBuffer([]);
    StarcoinSignedTx.prototype.signature = $util.newBuffer([]);

    StarcoinSignedTx.create = function create(properties) {
        return new StarcoinSignedTx(properties);
    };

    StarcoinSignedTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.public_key);
        writer.uint32(18).bytes(message.signature);
        return writer;
    };

    StarcoinSignedTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    StarcoinSignedTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.StarcoinSignedTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.public_key = reader.bytes();
                break;
            case 2:
                message.signature = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("public_key"))
            throw $util.ProtocolError("missing required 'public_key'", { instance: message });
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        return message;
    };

    StarcoinSignedTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    StarcoinSignedTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.public_key && typeof message.public_key.length === "number" || $util.isString(message.public_key)))
            return "public_key: buffer expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        return null;
    };

    StarcoinSignedTx.fromObject = function fromObject(object) {
        if (object instanceof $root.StarcoinSignedTx)
            return object;
        var message = new $root.StarcoinSignedTx();
        if (object.public_key != null)
            if (typeof object.public_key === "string")
                $util.base64.decode(object.public_key, message.public_key = $util.newBuffer($util.base64.length(object.public_key)), 0);
            else if (object.public_key.length)
                message.public_key = object.public_key;
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        return message;
    };

    StarcoinSignedTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.public_key = "";
            else {
                object.public_key = [];
                if (options.bytes !== Array)
                    object.public_key = $util.newBuffer(object.public_key);
            }
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
        }
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            object.public_key = options.bytes === String ? $util.base64.encode(message.public_key, 0, message.public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.public_key) : message.public_key;
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        return object;
    };

    StarcoinSignedTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return StarcoinSignedTx;
})();

$root.StarcoinSignMessage = (function() {

    function StarcoinSignMessage(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    StarcoinSignMessage.prototype.address_n = $util.emptyArray;
    StarcoinSignMessage.prototype.message = $util.newBuffer([]);

    StarcoinSignMessage.create = function create(properties) {
        return new StarcoinSignMessage(properties);
    };

    StarcoinSignMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
            writer.uint32(18).bytes(message.message);
        return writer;
    };

    StarcoinSignMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    StarcoinSignMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.StarcoinSignMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.message = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    StarcoinSignMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    StarcoinSignMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.message != null && message.hasOwnProperty("message"))
            if (!(message.message && typeof message.message.length === "number" || $util.isString(message.message)))
                return "message: buffer expected";
        return null;
    };

    StarcoinSignMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.StarcoinSignMessage)
            return object;
        var message = new $root.StarcoinSignMessage();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".StarcoinSignMessage.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.message != null)
            if (typeof object.message === "string")
                $util.base64.decode(object.message, message.message = $util.newBuffer($util.base64.length(object.message)), 0);
            else if (object.message.length)
                message.message = object.message;
        return message;
    };

    StarcoinSignMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            if (options.bytes === String)
                object.message = "";
            else {
                object.message = [];
                if (options.bytes !== Array)
                    object.message = $util.newBuffer(object.message);
            }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.message != null && message.hasOwnProperty("message"))
            object.message = options.bytes === String ? $util.base64.encode(message.message, 0, message.message.length) : options.bytes === Array ? Array.prototype.slice.call(message.message) : message.message;
        return object;
    };

    StarcoinSignMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return StarcoinSignMessage;
})();

$root.StarcoinMessageSignature = (function() {

    function StarcoinMessageSignature(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    StarcoinMessageSignature.prototype.public_key = $util.newBuffer([]);
    StarcoinMessageSignature.prototype.signature = $util.newBuffer([]);

    StarcoinMessageSignature.create = function create(properties) {
        return new StarcoinMessageSignature(properties);
    };

    StarcoinMessageSignature.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.public_key);
        writer.uint32(18).bytes(message.signature);
        return writer;
    };

    StarcoinMessageSignature.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    StarcoinMessageSignature.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.StarcoinMessageSignature();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.public_key = reader.bytes();
                break;
            case 2:
                message.signature = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("public_key"))
            throw $util.ProtocolError("missing required 'public_key'", { instance: message });
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        return message;
    };

    StarcoinMessageSignature.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    StarcoinMessageSignature.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.public_key && typeof message.public_key.length === "number" || $util.isString(message.public_key)))
            return "public_key: buffer expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        return null;
    };

    StarcoinMessageSignature.fromObject = function fromObject(object) {
        if (object instanceof $root.StarcoinMessageSignature)
            return object;
        var message = new $root.StarcoinMessageSignature();
        if (object.public_key != null)
            if (typeof object.public_key === "string")
                $util.base64.decode(object.public_key, message.public_key = $util.newBuffer($util.base64.length(object.public_key)), 0);
            else if (object.public_key.length)
                message.public_key = object.public_key;
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        return message;
    };

    StarcoinMessageSignature.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.public_key = "";
            else {
                object.public_key = [];
                if (options.bytes !== Array)
                    object.public_key = $util.newBuffer(object.public_key);
            }
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
        }
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            object.public_key = options.bytes === String ? $util.base64.encode(message.public_key, 0, message.public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.public_key) : message.public_key;
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        return object;
    };

    StarcoinMessageSignature.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return StarcoinMessageSignature;
})();

$root.StarcoinVerifyMessage = (function() {

    function StarcoinVerifyMessage(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    StarcoinVerifyMessage.prototype.public_key = $util.newBuffer([]);
    StarcoinVerifyMessage.prototype.signature = $util.newBuffer([]);
    StarcoinVerifyMessage.prototype.message = $util.newBuffer([]);

    StarcoinVerifyMessage.create = function create(properties) {
        return new StarcoinVerifyMessage(properties);
    };

    StarcoinVerifyMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.public_key != null && Object.hasOwnProperty.call(message, "public_key"))
            writer.uint32(10).bytes(message.public_key);
        if (message.signature != null && Object.hasOwnProperty.call(message, "signature"))
            writer.uint32(18).bytes(message.signature);
        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
            writer.uint32(26).bytes(message.message);
        return writer;
    };

    StarcoinVerifyMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    StarcoinVerifyMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.StarcoinVerifyMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.public_key = reader.bytes();
                break;
            case 2:
                message.signature = reader.bytes();
                break;
            case 3:
                message.message = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    StarcoinVerifyMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    StarcoinVerifyMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            if (!(message.public_key && typeof message.public_key.length === "number" || $util.isString(message.public_key)))
                return "public_key: buffer expected";
        if (message.signature != null && message.hasOwnProperty("signature"))
            if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
                return "signature: buffer expected";
        if (message.message != null && message.hasOwnProperty("message"))
            if (!(message.message && typeof message.message.length === "number" || $util.isString(message.message)))
                return "message: buffer expected";
        return null;
    };

    StarcoinVerifyMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.StarcoinVerifyMessage)
            return object;
        var message = new $root.StarcoinVerifyMessage();
        if (object.public_key != null)
            if (typeof object.public_key === "string")
                $util.base64.decode(object.public_key, message.public_key = $util.newBuffer($util.base64.length(object.public_key)), 0);
            else if (object.public_key.length)
                message.public_key = object.public_key;
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        if (object.message != null)
            if (typeof object.message === "string")
                $util.base64.decode(object.message, message.message = $util.newBuffer($util.base64.length(object.message)), 0);
            else if (object.message.length)
                message.message = object.message;
        return message;
    };

    StarcoinVerifyMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.public_key = "";
            else {
                object.public_key = [];
                if (options.bytes !== Array)
                    object.public_key = $util.newBuffer(object.public_key);
            }
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
            if (options.bytes === String)
                object.message = "";
            else {
                object.message = [];
                if (options.bytes !== Array)
                    object.message = $util.newBuffer(object.message);
            }
        }
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            object.public_key = options.bytes === String ? $util.base64.encode(message.public_key, 0, message.public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.public_key) : message.public_key;
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        if (message.message != null && message.hasOwnProperty("message"))
            object.message = options.bytes === String ? $util.base64.encode(message.message, 0, message.message.length) : options.bytes === Array ? Array.prototype.slice.call(message.message) : message.message;
        return object;
    };

    StarcoinVerifyMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return StarcoinVerifyMessage;
})();

$root.StellarAssetType = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "NATIVE"] = 0;
    values[valuesById[1] = "ALPHANUM4"] = 1;
    values[valuesById[2] = "ALPHANUM12"] = 2;
    return values;
})();

$root.StellarAsset = (function() {

    function StellarAsset(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    StellarAsset.prototype.type = 0;
    StellarAsset.prototype.code = "";
    StellarAsset.prototype.issuer = "";

    StellarAsset.create = function create(properties) {
        return new StellarAsset(properties);
    };

    StellarAsset.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).int32(message.type);
        if (message.code != null && Object.hasOwnProperty.call(message, "code"))
            writer.uint32(18).string(message.code);
        if (message.issuer != null && Object.hasOwnProperty.call(message, "issuer"))
            writer.uint32(26).string(message.issuer);
        return writer;
    };

    StellarAsset.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    StellarAsset.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.StellarAsset();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.type = reader.int32();
                break;
            case 2:
                message.code = reader.string();
                break;
            case 3:
                message.issuer = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("type"))
            throw $util.ProtocolError("missing required 'type'", { instance: message });
        return message;
    };

    StellarAsset.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    StellarAsset.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        switch (message.type) {
        default:
            return "type: enum value expected";
        case 0:
        case 1:
        case 2:
            break;
        }
        if (message.code != null && message.hasOwnProperty("code"))
            if (!$util.isString(message.code))
                return "code: string expected";
        if (message.issuer != null && message.hasOwnProperty("issuer"))
            if (!$util.isString(message.issuer))
                return "issuer: string expected";
        return null;
    };

    StellarAsset.fromObject = function fromObject(object) {
        if (object instanceof $root.StellarAsset)
            return object;
        var message = new $root.StellarAsset();
        switch (object.type) {
        case "NATIVE":
        case 0:
            message.type = 0;
            break;
        case "ALPHANUM4":
        case 1:
            message.type = 1;
            break;
        case "ALPHANUM12":
        case 2:
            message.type = 2;
            break;
        }
        if (object.code != null)
            message.code = String(object.code);
        if (object.issuer != null)
            message.issuer = String(object.issuer);
        return message;
    };

    StellarAsset.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.type = options.enums === String ? "NATIVE" : 0;
            object.code = "";
            object.issuer = "";
        }
        if (message.type != null && message.hasOwnProperty("type"))
            object.type = options.enums === String ? $root.StellarAssetType[message.type] : message.type;
        if (message.code != null && message.hasOwnProperty("code"))
            object.code = message.code;
        if (message.issuer != null && message.hasOwnProperty("issuer"))
            object.issuer = message.issuer;
        return object;
    };

    StellarAsset.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return StellarAsset;
})();

$root.StellarGetAddress = (function() {

    function StellarGetAddress(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    StellarGetAddress.prototype.address_n = $util.emptyArray;
    StellarGetAddress.prototype.show_display = false;

    StellarGetAddress.create = function create(properties) {
        return new StellarGetAddress(properties);
    };

    StellarGetAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(16).bool(message.show_display);
        return writer;
    };

    StellarGetAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    StellarGetAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.StellarGetAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.show_display = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    StellarGetAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    StellarGetAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        return null;
    };

    StellarGetAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.StellarGetAddress)
            return object;
        var message = new $root.StellarGetAddress();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".StellarGetAddress.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        return message;
    };

    StellarGetAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            object.show_display = false;
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        return object;
    };

    StellarGetAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return StellarGetAddress;
})();

$root.StellarAddress = (function() {

    function StellarAddress(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    StellarAddress.prototype.address = "";

    StellarAddress.create = function create(properties) {
        return new StellarAddress(properties);
    };

    StellarAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.address);
        return writer;
    };

    StellarAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    StellarAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.StellarAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("address"))
            throw $util.ProtocolError("missing required 'address'", { instance: message });
        return message;
    };

    StellarAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    StellarAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.address))
            return "address: string expected";
        return null;
    };

    StellarAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.StellarAddress)
            return object;
        var message = new $root.StellarAddress();
        if (object.address != null)
            message.address = String(object.address);
        return message;
    };

    StellarAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.address = "";
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    StellarAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return StellarAddress;
})();

$root.StellarSignTx = (function() {

    function StellarSignTx(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    StellarSignTx.prototype.address_n = $util.emptyArray;
    StellarSignTx.prototype.network_passphrase = "";
    StellarSignTx.prototype.source_account = "";
    StellarSignTx.prototype.fee = 0;
    StellarSignTx.prototype.sequence_number = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    StellarSignTx.prototype.timebounds_start = 0;
    StellarSignTx.prototype.timebounds_end = 0;
    StellarSignTx.prototype.memo_type = 0;
    StellarSignTx.prototype.memo_text = "";
    StellarSignTx.prototype.memo_id = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    StellarSignTx.prototype.memo_hash = $util.newBuffer([]);
    StellarSignTx.prototype.num_operations = 0;

    StellarSignTx.create = function create(properties) {
        return new StellarSignTx(properties);
    };

    StellarSignTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(16).uint32(message.address_n[i]);
        writer.uint32(26).string(message.network_passphrase);
        writer.uint32(34).string(message.source_account);
        writer.uint32(40).uint32(message.fee);
        writer.uint32(48).uint64(message.sequence_number);
        writer.uint32(64).uint32(message.timebounds_start);
        writer.uint32(72).uint32(message.timebounds_end);
        writer.uint32(80).int32(message.memo_type);
        if (message.memo_text != null && Object.hasOwnProperty.call(message, "memo_text"))
            writer.uint32(90).string(message.memo_text);
        if (message.memo_id != null && Object.hasOwnProperty.call(message, "memo_id"))
            writer.uint32(96).uint64(message.memo_id);
        if (message.memo_hash != null && Object.hasOwnProperty.call(message, "memo_hash"))
            writer.uint32(106).bytes(message.memo_hash);
        writer.uint32(112).uint32(message.num_operations);
        return writer;
    };

    StellarSignTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    StellarSignTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.StellarSignTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 2:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 3:
                message.network_passphrase = reader.string();
                break;
            case 4:
                message.source_account = reader.string();
                break;
            case 5:
                message.fee = reader.uint32();
                break;
            case 6:
                message.sequence_number = reader.uint64();
                break;
            case 8:
                message.timebounds_start = reader.uint32();
                break;
            case 9:
                message.timebounds_end = reader.uint32();
                break;
            case 10:
                message.memo_type = reader.int32();
                break;
            case 11:
                message.memo_text = reader.string();
                break;
            case 12:
                message.memo_id = reader.uint64();
                break;
            case 13:
                message.memo_hash = reader.bytes();
                break;
            case 14:
                message.num_operations = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("network_passphrase"))
            throw $util.ProtocolError("missing required 'network_passphrase'", { instance: message });
        if (!message.hasOwnProperty("source_account"))
            throw $util.ProtocolError("missing required 'source_account'", { instance: message });
        if (!message.hasOwnProperty("fee"))
            throw $util.ProtocolError("missing required 'fee'", { instance: message });
        if (!message.hasOwnProperty("sequence_number"))
            throw $util.ProtocolError("missing required 'sequence_number'", { instance: message });
        if (!message.hasOwnProperty("timebounds_start"))
            throw $util.ProtocolError("missing required 'timebounds_start'", { instance: message });
        if (!message.hasOwnProperty("timebounds_end"))
            throw $util.ProtocolError("missing required 'timebounds_end'", { instance: message });
        if (!message.hasOwnProperty("memo_type"))
            throw $util.ProtocolError("missing required 'memo_type'", { instance: message });
        if (!message.hasOwnProperty("num_operations"))
            throw $util.ProtocolError("missing required 'num_operations'", { instance: message });
        return message;
    };

    StellarSignTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    StellarSignTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!$util.isString(message.network_passphrase))
            return "network_passphrase: string expected";
        if (!$util.isString(message.source_account))
            return "source_account: string expected";
        if (!$util.isInteger(message.fee))
            return "fee: integer expected";
        if (!$util.isInteger(message.sequence_number) && !(message.sequence_number && $util.isInteger(message.sequence_number.low) && $util.isInteger(message.sequence_number.high)))
            return "sequence_number: integer|Long expected";
        if (!$util.isInteger(message.timebounds_start))
            return "timebounds_start: integer expected";
        if (!$util.isInteger(message.timebounds_end))
            return "timebounds_end: integer expected";
        switch (message.memo_type) {
        default:
            return "memo_type: enum value expected";
        case 0:
        case 1:
        case 2:
        case 3:
        case 4:
            break;
        }
        if (message.memo_text != null && message.hasOwnProperty("memo_text"))
            if (!$util.isString(message.memo_text))
                return "memo_text: string expected";
        if (message.memo_id != null && message.hasOwnProperty("memo_id"))
            if (!$util.isInteger(message.memo_id) && !(message.memo_id && $util.isInteger(message.memo_id.low) && $util.isInteger(message.memo_id.high)))
                return "memo_id: integer|Long expected";
        if (message.memo_hash != null && message.hasOwnProperty("memo_hash"))
            if (!(message.memo_hash && typeof message.memo_hash.length === "number" || $util.isString(message.memo_hash)))
                return "memo_hash: buffer expected";
        if (!$util.isInteger(message.num_operations))
            return "num_operations: integer expected";
        return null;
    };

    StellarSignTx.fromObject = function fromObject(object) {
        if (object instanceof $root.StellarSignTx)
            return object;
        var message = new $root.StellarSignTx();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".StellarSignTx.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.network_passphrase != null)
            message.network_passphrase = String(object.network_passphrase);
        if (object.source_account != null)
            message.source_account = String(object.source_account);
        if (object.fee != null)
            message.fee = object.fee >>> 0;
        if (object.sequence_number != null)
            if ($util.Long)
                (message.sequence_number = $util.Long.fromValue(object.sequence_number)).unsigned = true;
            else if (typeof object.sequence_number === "string")
                message.sequence_number = parseInt(object.sequence_number, 10);
            else if (typeof object.sequence_number === "number")
                message.sequence_number = object.sequence_number;
            else if (typeof object.sequence_number === "object")
                message.sequence_number = new $util.LongBits(object.sequence_number.low >>> 0, object.sequence_number.high >>> 0).toNumber(true);
        if (object.timebounds_start != null)
            message.timebounds_start = object.timebounds_start >>> 0;
        if (object.timebounds_end != null)
            message.timebounds_end = object.timebounds_end >>> 0;
        switch (object.memo_type) {
        case "NONE":
        case 0:
            message.memo_type = 0;
            break;
        case "TEXT":
        case 1:
            message.memo_type = 1;
            break;
        case "ID":
        case 2:
            message.memo_type = 2;
            break;
        case "HASH":
        case 3:
            message.memo_type = 3;
            break;
        case "RETURN":
        case 4:
            message.memo_type = 4;
            break;
        }
        if (object.memo_text != null)
            message.memo_text = String(object.memo_text);
        if (object.memo_id != null)
            if ($util.Long)
                (message.memo_id = $util.Long.fromValue(object.memo_id)).unsigned = true;
            else if (typeof object.memo_id === "string")
                message.memo_id = parseInt(object.memo_id, 10);
            else if (typeof object.memo_id === "number")
                message.memo_id = object.memo_id;
            else if (typeof object.memo_id === "object")
                message.memo_id = new $util.LongBits(object.memo_id.low >>> 0, object.memo_id.high >>> 0).toNumber(true);
        if (object.memo_hash != null)
            if (typeof object.memo_hash === "string")
                $util.base64.decode(object.memo_hash, message.memo_hash = $util.newBuffer($util.base64.length(object.memo_hash)), 0);
            else if (object.memo_hash.length)
                message.memo_hash = object.memo_hash;
        if (object.num_operations != null)
            message.num_operations = object.num_operations >>> 0;
        return message;
    };

    StellarSignTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            object.network_passphrase = "";
            object.source_account = "";
            object.fee = 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.sequence_number = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.sequence_number = options.longs === String ? "0" : 0;
            object.timebounds_start = 0;
            object.timebounds_end = 0;
            object.memo_type = options.enums === String ? "NONE" : 0;
            object.memo_text = "";
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.memo_id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.memo_id = options.longs === String ? "0" : 0;
            if (options.bytes === String)
                object.memo_hash = "";
            else {
                object.memo_hash = [];
                if (options.bytes !== Array)
                    object.memo_hash = $util.newBuffer(object.memo_hash);
            }
            object.num_operations = 0;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.network_passphrase != null && message.hasOwnProperty("network_passphrase"))
            object.network_passphrase = message.network_passphrase;
        if (message.source_account != null && message.hasOwnProperty("source_account"))
            object.source_account = message.source_account;
        if (message.fee != null && message.hasOwnProperty("fee"))
            object.fee = message.fee;
        if (message.sequence_number != null && message.hasOwnProperty("sequence_number"))
            if (typeof message.sequence_number === "number")
                object.sequence_number = options.longs === String ? String(message.sequence_number) : message.sequence_number;
            else
                object.sequence_number = options.longs === String ? $util.Long.prototype.toString.call(message.sequence_number) : options.longs === Number ? new $util.LongBits(message.sequence_number.low >>> 0, message.sequence_number.high >>> 0).toNumber(true) : message.sequence_number;
        if (message.timebounds_start != null && message.hasOwnProperty("timebounds_start"))
            object.timebounds_start = message.timebounds_start;
        if (message.timebounds_end != null && message.hasOwnProperty("timebounds_end"))
            object.timebounds_end = message.timebounds_end;
        if (message.memo_type != null && message.hasOwnProperty("memo_type"))
            object.memo_type = options.enums === String ? $root.StellarSignTx.StellarMemoType[message.memo_type] : message.memo_type;
        if (message.memo_text != null && message.hasOwnProperty("memo_text"))
            object.memo_text = message.memo_text;
        if (message.memo_id != null && message.hasOwnProperty("memo_id"))
            if (typeof message.memo_id === "number")
                object.memo_id = options.longs === String ? String(message.memo_id) : message.memo_id;
            else
                object.memo_id = options.longs === String ? $util.Long.prototype.toString.call(message.memo_id) : options.longs === Number ? new $util.LongBits(message.memo_id.low >>> 0, message.memo_id.high >>> 0).toNumber(true) : message.memo_id;
        if (message.memo_hash != null && message.hasOwnProperty("memo_hash"))
            object.memo_hash = options.bytes === String ? $util.base64.encode(message.memo_hash, 0, message.memo_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.memo_hash) : message.memo_hash;
        if (message.num_operations != null && message.hasOwnProperty("num_operations"))
            object.num_operations = message.num_operations;
        return object;
    };

    StellarSignTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    StellarSignTx.StellarMemoType = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "NONE"] = 0;
        values[valuesById[1] = "TEXT"] = 1;
        values[valuesById[2] = "ID"] = 2;
        values[valuesById[3] = "HASH"] = 3;
        values[valuesById[4] = "RETURN"] = 4;
        return values;
    })();

    return StellarSignTx;
})();

$root.StellarTxOpRequest = (function() {

    function StellarTxOpRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    StellarTxOpRequest.create = function create(properties) {
        return new StellarTxOpRequest(properties);
    };

    StellarTxOpRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    StellarTxOpRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    StellarTxOpRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.StellarTxOpRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    StellarTxOpRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    StellarTxOpRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    StellarTxOpRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.StellarTxOpRequest)
            return object;
        return new $root.StellarTxOpRequest();
    };

    StellarTxOpRequest.toObject = function toObject() {
        return {};
    };

    StellarTxOpRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return StellarTxOpRequest;
})();

$root.StellarPaymentOp = (function() {

    function StellarPaymentOp(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    StellarPaymentOp.prototype.source_account = "";
    StellarPaymentOp.prototype.destination_account = "";
    StellarPaymentOp.prototype.asset = null;
    StellarPaymentOp.prototype.amount = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    StellarPaymentOp.create = function create(properties) {
        return new StellarPaymentOp(properties);
    };

    StellarPaymentOp.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.source_account != null && Object.hasOwnProperty.call(message, "source_account"))
            writer.uint32(10).string(message.source_account);
        writer.uint32(18).string(message.destination_account);
        $root.StellarAsset.encode(message.asset, writer.uint32(26).fork()).ldelim();
        writer.uint32(32).sint64(message.amount);
        return writer;
    };

    StellarPaymentOp.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    StellarPaymentOp.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.StellarPaymentOp();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.source_account = reader.string();
                break;
            case 2:
                message.destination_account = reader.string();
                break;
            case 3:
                message.asset = $root.StellarAsset.decode(reader, reader.uint32());
                break;
            case 4:
                message.amount = reader.sint64();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("destination_account"))
            throw $util.ProtocolError("missing required 'destination_account'", { instance: message });
        if (!message.hasOwnProperty("asset"))
            throw $util.ProtocolError("missing required 'asset'", { instance: message });
        if (!message.hasOwnProperty("amount"))
            throw $util.ProtocolError("missing required 'amount'", { instance: message });
        return message;
    };

    StellarPaymentOp.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    StellarPaymentOp.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.source_account != null && message.hasOwnProperty("source_account"))
            if (!$util.isString(message.source_account))
                return "source_account: string expected";
        if (!$util.isString(message.destination_account))
            return "destination_account: string expected";
        {
            var error = $root.StellarAsset.verify(message.asset);
            if (error)
                return "asset." + error;
        }
        if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
            return "amount: integer|Long expected";
        return null;
    };

    StellarPaymentOp.fromObject = function fromObject(object) {
        if (object instanceof $root.StellarPaymentOp)
            return object;
        var message = new $root.StellarPaymentOp();
        if (object.source_account != null)
            message.source_account = String(object.source_account);
        if (object.destination_account != null)
            message.destination_account = String(object.destination_account);
        if (object.asset != null) {
            if (typeof object.asset !== "object")
                throw TypeError(".StellarPaymentOp.asset: object expected");
            message.asset = $root.StellarAsset.fromObject(object.asset);
        }
        if (object.amount != null)
            if ($util.Long)
                (message.amount = $util.Long.fromValue(object.amount)).unsigned = false;
            else if (typeof object.amount === "string")
                message.amount = parseInt(object.amount, 10);
            else if (typeof object.amount === "number")
                message.amount = object.amount;
            else if (typeof object.amount === "object")
                message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber();
        return message;
    };

    StellarPaymentOp.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.source_account = "";
            object.destination_account = "";
            object.asset = null;
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.amount = options.longs === String ? "0" : 0;
        }
        if (message.source_account != null && message.hasOwnProperty("source_account"))
            object.source_account = message.source_account;
        if (message.destination_account != null && message.hasOwnProperty("destination_account"))
            object.destination_account = message.destination_account;
        if (message.asset != null && message.hasOwnProperty("asset"))
            object.asset = $root.StellarAsset.toObject(message.asset, options);
        if (message.amount != null && message.hasOwnProperty("amount"))
            if (typeof message.amount === "number")
                object.amount = options.longs === String ? String(message.amount) : message.amount;
            else
                object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber() : message.amount;
        return object;
    };

    StellarPaymentOp.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return StellarPaymentOp;
})();

$root.StellarCreateAccountOp = (function() {

    function StellarCreateAccountOp(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    StellarCreateAccountOp.prototype.source_account = "";
    StellarCreateAccountOp.prototype.new_account = "";
    StellarCreateAccountOp.prototype.starting_balance = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    StellarCreateAccountOp.create = function create(properties) {
        return new StellarCreateAccountOp(properties);
    };

    StellarCreateAccountOp.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.source_account != null && Object.hasOwnProperty.call(message, "source_account"))
            writer.uint32(10).string(message.source_account);
        writer.uint32(18).string(message.new_account);
        writer.uint32(24).sint64(message.starting_balance);
        return writer;
    };

    StellarCreateAccountOp.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    StellarCreateAccountOp.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.StellarCreateAccountOp();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.source_account = reader.string();
                break;
            case 2:
                message.new_account = reader.string();
                break;
            case 3:
                message.starting_balance = reader.sint64();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("new_account"))
            throw $util.ProtocolError("missing required 'new_account'", { instance: message });
        if (!message.hasOwnProperty("starting_balance"))
            throw $util.ProtocolError("missing required 'starting_balance'", { instance: message });
        return message;
    };

    StellarCreateAccountOp.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    StellarCreateAccountOp.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.source_account != null && message.hasOwnProperty("source_account"))
            if (!$util.isString(message.source_account))
                return "source_account: string expected";
        if (!$util.isString(message.new_account))
            return "new_account: string expected";
        if (!$util.isInteger(message.starting_balance) && !(message.starting_balance && $util.isInteger(message.starting_balance.low) && $util.isInteger(message.starting_balance.high)))
            return "starting_balance: integer|Long expected";
        return null;
    };

    StellarCreateAccountOp.fromObject = function fromObject(object) {
        if (object instanceof $root.StellarCreateAccountOp)
            return object;
        var message = new $root.StellarCreateAccountOp();
        if (object.source_account != null)
            message.source_account = String(object.source_account);
        if (object.new_account != null)
            message.new_account = String(object.new_account);
        if (object.starting_balance != null)
            if ($util.Long)
                (message.starting_balance = $util.Long.fromValue(object.starting_balance)).unsigned = false;
            else if (typeof object.starting_balance === "string")
                message.starting_balance = parseInt(object.starting_balance, 10);
            else if (typeof object.starting_balance === "number")
                message.starting_balance = object.starting_balance;
            else if (typeof object.starting_balance === "object")
                message.starting_balance = new $util.LongBits(object.starting_balance.low >>> 0, object.starting_balance.high >>> 0).toNumber();
        return message;
    };

    StellarCreateAccountOp.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.source_account = "";
            object.new_account = "";
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.starting_balance = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.starting_balance = options.longs === String ? "0" : 0;
        }
        if (message.source_account != null && message.hasOwnProperty("source_account"))
            object.source_account = message.source_account;
        if (message.new_account != null && message.hasOwnProperty("new_account"))
            object.new_account = message.new_account;
        if (message.starting_balance != null && message.hasOwnProperty("starting_balance"))
            if (typeof message.starting_balance === "number")
                object.starting_balance = options.longs === String ? String(message.starting_balance) : message.starting_balance;
            else
                object.starting_balance = options.longs === String ? $util.Long.prototype.toString.call(message.starting_balance) : options.longs === Number ? new $util.LongBits(message.starting_balance.low >>> 0, message.starting_balance.high >>> 0).toNumber() : message.starting_balance;
        return object;
    };

    StellarCreateAccountOp.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return StellarCreateAccountOp;
})();

$root.StellarPathPaymentStrictReceiveOp = (function() {

    function StellarPathPaymentStrictReceiveOp(properties) {
        this.paths = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    StellarPathPaymentStrictReceiveOp.prototype.source_account = "";
    StellarPathPaymentStrictReceiveOp.prototype.send_asset = null;
    StellarPathPaymentStrictReceiveOp.prototype.send_max = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    StellarPathPaymentStrictReceiveOp.prototype.destination_account = "";
    StellarPathPaymentStrictReceiveOp.prototype.destination_asset = null;
    StellarPathPaymentStrictReceiveOp.prototype.destination_amount = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    StellarPathPaymentStrictReceiveOp.prototype.paths = $util.emptyArray;

    StellarPathPaymentStrictReceiveOp.create = function create(properties) {
        return new StellarPathPaymentStrictReceiveOp(properties);
    };

    StellarPathPaymentStrictReceiveOp.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.source_account != null && Object.hasOwnProperty.call(message, "source_account"))
            writer.uint32(10).string(message.source_account);
        $root.StellarAsset.encode(message.send_asset, writer.uint32(18).fork()).ldelim();
        writer.uint32(24).sint64(message.send_max);
        writer.uint32(34).string(message.destination_account);
        $root.StellarAsset.encode(message.destination_asset, writer.uint32(42).fork()).ldelim();
        writer.uint32(48).sint64(message.destination_amount);
        if (message.paths != null && message.paths.length)
            for (var i = 0; i < message.paths.length; ++i)
                $root.StellarAsset.encode(message.paths[i], writer.uint32(58).fork()).ldelim();
        return writer;
    };

    StellarPathPaymentStrictReceiveOp.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    StellarPathPaymentStrictReceiveOp.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.StellarPathPaymentStrictReceiveOp();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.source_account = reader.string();
                break;
            case 2:
                message.send_asset = $root.StellarAsset.decode(reader, reader.uint32());
                break;
            case 3:
                message.send_max = reader.sint64();
                break;
            case 4:
                message.destination_account = reader.string();
                break;
            case 5:
                message.destination_asset = $root.StellarAsset.decode(reader, reader.uint32());
                break;
            case 6:
                message.destination_amount = reader.sint64();
                break;
            case 7:
                if (!(message.paths && message.paths.length))
                    message.paths = [];
                message.paths.push($root.StellarAsset.decode(reader, reader.uint32()));
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("send_asset"))
            throw $util.ProtocolError("missing required 'send_asset'", { instance: message });
        if (!message.hasOwnProperty("send_max"))
            throw $util.ProtocolError("missing required 'send_max'", { instance: message });
        if (!message.hasOwnProperty("destination_account"))
            throw $util.ProtocolError("missing required 'destination_account'", { instance: message });
        if (!message.hasOwnProperty("destination_asset"))
            throw $util.ProtocolError("missing required 'destination_asset'", { instance: message });
        if (!message.hasOwnProperty("destination_amount"))
            throw $util.ProtocolError("missing required 'destination_amount'", { instance: message });
        return message;
    };

    StellarPathPaymentStrictReceiveOp.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    StellarPathPaymentStrictReceiveOp.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.source_account != null && message.hasOwnProperty("source_account"))
            if (!$util.isString(message.source_account))
                return "source_account: string expected";
        {
            var error = $root.StellarAsset.verify(message.send_asset);
            if (error)
                return "send_asset." + error;
        }
        if (!$util.isInteger(message.send_max) && !(message.send_max && $util.isInteger(message.send_max.low) && $util.isInteger(message.send_max.high)))
            return "send_max: integer|Long expected";
        if (!$util.isString(message.destination_account))
            return "destination_account: string expected";
        {
            var error = $root.StellarAsset.verify(message.destination_asset);
            if (error)
                return "destination_asset." + error;
        }
        if (!$util.isInteger(message.destination_amount) && !(message.destination_amount && $util.isInteger(message.destination_amount.low) && $util.isInteger(message.destination_amount.high)))
            return "destination_amount: integer|Long expected";
        if (message.paths != null && message.hasOwnProperty("paths")) {
            if (!Array.isArray(message.paths))
                return "paths: array expected";
            for (var i = 0; i < message.paths.length; ++i) {
                var error = $root.StellarAsset.verify(message.paths[i]);
                if (error)
                    return "paths." + error;
            }
        }
        return null;
    };

    StellarPathPaymentStrictReceiveOp.fromObject = function fromObject(object) {
        if (object instanceof $root.StellarPathPaymentStrictReceiveOp)
            return object;
        var message = new $root.StellarPathPaymentStrictReceiveOp();
        if (object.source_account != null)
            message.source_account = String(object.source_account);
        if (object.send_asset != null) {
            if (typeof object.send_asset !== "object")
                throw TypeError(".StellarPathPaymentStrictReceiveOp.send_asset: object expected");
            message.send_asset = $root.StellarAsset.fromObject(object.send_asset);
        }
        if (object.send_max != null)
            if ($util.Long)
                (message.send_max = $util.Long.fromValue(object.send_max)).unsigned = false;
            else if (typeof object.send_max === "string")
                message.send_max = parseInt(object.send_max, 10);
            else if (typeof object.send_max === "number")
                message.send_max = object.send_max;
            else if (typeof object.send_max === "object")
                message.send_max = new $util.LongBits(object.send_max.low >>> 0, object.send_max.high >>> 0).toNumber();
        if (object.destination_account != null)
            message.destination_account = String(object.destination_account);
        if (object.destination_asset != null) {
            if (typeof object.destination_asset !== "object")
                throw TypeError(".StellarPathPaymentStrictReceiveOp.destination_asset: object expected");
            message.destination_asset = $root.StellarAsset.fromObject(object.destination_asset);
        }
        if (object.destination_amount != null)
            if ($util.Long)
                (message.destination_amount = $util.Long.fromValue(object.destination_amount)).unsigned = false;
            else if (typeof object.destination_amount === "string")
                message.destination_amount = parseInt(object.destination_amount, 10);
            else if (typeof object.destination_amount === "number")
                message.destination_amount = object.destination_amount;
            else if (typeof object.destination_amount === "object")
                message.destination_amount = new $util.LongBits(object.destination_amount.low >>> 0, object.destination_amount.high >>> 0).toNumber();
        if (object.paths) {
            if (!Array.isArray(object.paths))
                throw TypeError(".StellarPathPaymentStrictReceiveOp.paths: array expected");
            message.paths = [];
            for (var i = 0; i < object.paths.length; ++i) {
                if (typeof object.paths[i] !== "object")
                    throw TypeError(".StellarPathPaymentStrictReceiveOp.paths: object expected");
                message.paths[i] = $root.StellarAsset.fromObject(object.paths[i]);
            }
        }
        return message;
    };

    StellarPathPaymentStrictReceiveOp.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.paths = [];
        if (options.defaults) {
            object.source_account = "";
            object.send_asset = null;
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.send_max = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.send_max = options.longs === String ? "0" : 0;
            object.destination_account = "";
            object.destination_asset = null;
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.destination_amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.destination_amount = options.longs === String ? "0" : 0;
        }
        if (message.source_account != null && message.hasOwnProperty("source_account"))
            object.source_account = message.source_account;
        if (message.send_asset != null && message.hasOwnProperty("send_asset"))
            object.send_asset = $root.StellarAsset.toObject(message.send_asset, options);
        if (message.send_max != null && message.hasOwnProperty("send_max"))
            if (typeof message.send_max === "number")
                object.send_max = options.longs === String ? String(message.send_max) : message.send_max;
            else
                object.send_max = options.longs === String ? $util.Long.prototype.toString.call(message.send_max) : options.longs === Number ? new $util.LongBits(message.send_max.low >>> 0, message.send_max.high >>> 0).toNumber() : message.send_max;
        if (message.destination_account != null && message.hasOwnProperty("destination_account"))
            object.destination_account = message.destination_account;
        if (message.destination_asset != null && message.hasOwnProperty("destination_asset"))
            object.destination_asset = $root.StellarAsset.toObject(message.destination_asset, options);
        if (message.destination_amount != null && message.hasOwnProperty("destination_amount"))
            if (typeof message.destination_amount === "number")
                object.destination_amount = options.longs === String ? String(message.destination_amount) : message.destination_amount;
            else
                object.destination_amount = options.longs === String ? $util.Long.prototype.toString.call(message.destination_amount) : options.longs === Number ? new $util.LongBits(message.destination_amount.low >>> 0, message.destination_amount.high >>> 0).toNumber() : message.destination_amount;
        if (message.paths && message.paths.length) {
            object.paths = [];
            for (var j = 0; j < message.paths.length; ++j)
                object.paths[j] = $root.StellarAsset.toObject(message.paths[j], options);
        }
        return object;
    };

    StellarPathPaymentStrictReceiveOp.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return StellarPathPaymentStrictReceiveOp;
})();

$root.StellarPathPaymentStrictSendOp = (function() {

    function StellarPathPaymentStrictSendOp(properties) {
        this.paths = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    StellarPathPaymentStrictSendOp.prototype.source_account = "";
    StellarPathPaymentStrictSendOp.prototype.send_asset = null;
    StellarPathPaymentStrictSendOp.prototype.send_amount = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    StellarPathPaymentStrictSendOp.prototype.destination_account = "";
    StellarPathPaymentStrictSendOp.prototype.destination_asset = null;
    StellarPathPaymentStrictSendOp.prototype.destination_min = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    StellarPathPaymentStrictSendOp.prototype.paths = $util.emptyArray;

    StellarPathPaymentStrictSendOp.create = function create(properties) {
        return new StellarPathPaymentStrictSendOp(properties);
    };

    StellarPathPaymentStrictSendOp.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.source_account != null && Object.hasOwnProperty.call(message, "source_account"))
            writer.uint32(10).string(message.source_account);
        $root.StellarAsset.encode(message.send_asset, writer.uint32(18).fork()).ldelim();
        writer.uint32(24).sint64(message.send_amount);
        writer.uint32(34).string(message.destination_account);
        $root.StellarAsset.encode(message.destination_asset, writer.uint32(42).fork()).ldelim();
        writer.uint32(48).sint64(message.destination_min);
        if (message.paths != null && message.paths.length)
            for (var i = 0; i < message.paths.length; ++i)
                $root.StellarAsset.encode(message.paths[i], writer.uint32(58).fork()).ldelim();
        return writer;
    };

    StellarPathPaymentStrictSendOp.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    StellarPathPaymentStrictSendOp.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.StellarPathPaymentStrictSendOp();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.source_account = reader.string();
                break;
            case 2:
                message.send_asset = $root.StellarAsset.decode(reader, reader.uint32());
                break;
            case 3:
                message.send_amount = reader.sint64();
                break;
            case 4:
                message.destination_account = reader.string();
                break;
            case 5:
                message.destination_asset = $root.StellarAsset.decode(reader, reader.uint32());
                break;
            case 6:
                message.destination_min = reader.sint64();
                break;
            case 7:
                if (!(message.paths && message.paths.length))
                    message.paths = [];
                message.paths.push($root.StellarAsset.decode(reader, reader.uint32()));
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("send_asset"))
            throw $util.ProtocolError("missing required 'send_asset'", { instance: message });
        if (!message.hasOwnProperty("send_amount"))
            throw $util.ProtocolError("missing required 'send_amount'", { instance: message });
        if (!message.hasOwnProperty("destination_account"))
            throw $util.ProtocolError("missing required 'destination_account'", { instance: message });
        if (!message.hasOwnProperty("destination_asset"))
            throw $util.ProtocolError("missing required 'destination_asset'", { instance: message });
        if (!message.hasOwnProperty("destination_min"))
            throw $util.ProtocolError("missing required 'destination_min'", { instance: message });
        return message;
    };

    StellarPathPaymentStrictSendOp.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    StellarPathPaymentStrictSendOp.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.source_account != null && message.hasOwnProperty("source_account"))
            if (!$util.isString(message.source_account))
                return "source_account: string expected";
        {
            var error = $root.StellarAsset.verify(message.send_asset);
            if (error)
                return "send_asset." + error;
        }
        if (!$util.isInteger(message.send_amount) && !(message.send_amount && $util.isInteger(message.send_amount.low) && $util.isInteger(message.send_amount.high)))
            return "send_amount: integer|Long expected";
        if (!$util.isString(message.destination_account))
            return "destination_account: string expected";
        {
            var error = $root.StellarAsset.verify(message.destination_asset);
            if (error)
                return "destination_asset." + error;
        }
        if (!$util.isInteger(message.destination_min) && !(message.destination_min && $util.isInteger(message.destination_min.low) && $util.isInteger(message.destination_min.high)))
            return "destination_min: integer|Long expected";
        if (message.paths != null && message.hasOwnProperty("paths")) {
            if (!Array.isArray(message.paths))
                return "paths: array expected";
            for (var i = 0; i < message.paths.length; ++i) {
                var error = $root.StellarAsset.verify(message.paths[i]);
                if (error)
                    return "paths." + error;
            }
        }
        return null;
    };

    StellarPathPaymentStrictSendOp.fromObject = function fromObject(object) {
        if (object instanceof $root.StellarPathPaymentStrictSendOp)
            return object;
        var message = new $root.StellarPathPaymentStrictSendOp();
        if (object.source_account != null)
            message.source_account = String(object.source_account);
        if (object.send_asset != null) {
            if (typeof object.send_asset !== "object")
                throw TypeError(".StellarPathPaymentStrictSendOp.send_asset: object expected");
            message.send_asset = $root.StellarAsset.fromObject(object.send_asset);
        }
        if (object.send_amount != null)
            if ($util.Long)
                (message.send_amount = $util.Long.fromValue(object.send_amount)).unsigned = false;
            else if (typeof object.send_amount === "string")
                message.send_amount = parseInt(object.send_amount, 10);
            else if (typeof object.send_amount === "number")
                message.send_amount = object.send_amount;
            else if (typeof object.send_amount === "object")
                message.send_amount = new $util.LongBits(object.send_amount.low >>> 0, object.send_amount.high >>> 0).toNumber();
        if (object.destination_account != null)
            message.destination_account = String(object.destination_account);
        if (object.destination_asset != null) {
            if (typeof object.destination_asset !== "object")
                throw TypeError(".StellarPathPaymentStrictSendOp.destination_asset: object expected");
            message.destination_asset = $root.StellarAsset.fromObject(object.destination_asset);
        }
        if (object.destination_min != null)
            if ($util.Long)
                (message.destination_min = $util.Long.fromValue(object.destination_min)).unsigned = false;
            else if (typeof object.destination_min === "string")
                message.destination_min = parseInt(object.destination_min, 10);
            else if (typeof object.destination_min === "number")
                message.destination_min = object.destination_min;
            else if (typeof object.destination_min === "object")
                message.destination_min = new $util.LongBits(object.destination_min.low >>> 0, object.destination_min.high >>> 0).toNumber();
        if (object.paths) {
            if (!Array.isArray(object.paths))
                throw TypeError(".StellarPathPaymentStrictSendOp.paths: array expected");
            message.paths = [];
            for (var i = 0; i < object.paths.length; ++i) {
                if (typeof object.paths[i] !== "object")
                    throw TypeError(".StellarPathPaymentStrictSendOp.paths: object expected");
                message.paths[i] = $root.StellarAsset.fromObject(object.paths[i]);
            }
        }
        return message;
    };

    StellarPathPaymentStrictSendOp.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.paths = [];
        if (options.defaults) {
            object.source_account = "";
            object.send_asset = null;
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.send_amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.send_amount = options.longs === String ? "0" : 0;
            object.destination_account = "";
            object.destination_asset = null;
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.destination_min = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.destination_min = options.longs === String ? "0" : 0;
        }
        if (message.source_account != null && message.hasOwnProperty("source_account"))
            object.source_account = message.source_account;
        if (message.send_asset != null && message.hasOwnProperty("send_asset"))
            object.send_asset = $root.StellarAsset.toObject(message.send_asset, options);
        if (message.send_amount != null && message.hasOwnProperty("send_amount"))
            if (typeof message.send_amount === "number")
                object.send_amount = options.longs === String ? String(message.send_amount) : message.send_amount;
            else
                object.send_amount = options.longs === String ? $util.Long.prototype.toString.call(message.send_amount) : options.longs === Number ? new $util.LongBits(message.send_amount.low >>> 0, message.send_amount.high >>> 0).toNumber() : message.send_amount;
        if (message.destination_account != null && message.hasOwnProperty("destination_account"))
            object.destination_account = message.destination_account;
        if (message.destination_asset != null && message.hasOwnProperty("destination_asset"))
            object.destination_asset = $root.StellarAsset.toObject(message.destination_asset, options);
        if (message.destination_min != null && message.hasOwnProperty("destination_min"))
            if (typeof message.destination_min === "number")
                object.destination_min = options.longs === String ? String(message.destination_min) : message.destination_min;
            else
                object.destination_min = options.longs === String ? $util.Long.prototype.toString.call(message.destination_min) : options.longs === Number ? new $util.LongBits(message.destination_min.low >>> 0, message.destination_min.high >>> 0).toNumber() : message.destination_min;
        if (message.paths && message.paths.length) {
            object.paths = [];
            for (var j = 0; j < message.paths.length; ++j)
                object.paths[j] = $root.StellarAsset.toObject(message.paths[j], options);
        }
        return object;
    };

    StellarPathPaymentStrictSendOp.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return StellarPathPaymentStrictSendOp;
})();

$root.StellarManageSellOfferOp = (function() {

    function StellarManageSellOfferOp(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    StellarManageSellOfferOp.prototype.source_account = "";
    StellarManageSellOfferOp.prototype.selling_asset = null;
    StellarManageSellOfferOp.prototype.buying_asset = null;
    StellarManageSellOfferOp.prototype.amount = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    StellarManageSellOfferOp.prototype.price_n = 0;
    StellarManageSellOfferOp.prototype.price_d = 0;
    StellarManageSellOfferOp.prototype.offer_id = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    StellarManageSellOfferOp.create = function create(properties) {
        return new StellarManageSellOfferOp(properties);
    };

    StellarManageSellOfferOp.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.source_account != null && Object.hasOwnProperty.call(message, "source_account"))
            writer.uint32(10).string(message.source_account);
        $root.StellarAsset.encode(message.selling_asset, writer.uint32(18).fork()).ldelim();
        $root.StellarAsset.encode(message.buying_asset, writer.uint32(26).fork()).ldelim();
        writer.uint32(32).sint64(message.amount);
        writer.uint32(40).uint32(message.price_n);
        writer.uint32(48).uint32(message.price_d);
        writer.uint32(56).uint64(message.offer_id);
        return writer;
    };

    StellarManageSellOfferOp.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    StellarManageSellOfferOp.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.StellarManageSellOfferOp();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.source_account = reader.string();
                break;
            case 2:
                message.selling_asset = $root.StellarAsset.decode(reader, reader.uint32());
                break;
            case 3:
                message.buying_asset = $root.StellarAsset.decode(reader, reader.uint32());
                break;
            case 4:
                message.amount = reader.sint64();
                break;
            case 5:
                message.price_n = reader.uint32();
                break;
            case 6:
                message.price_d = reader.uint32();
                break;
            case 7:
                message.offer_id = reader.uint64();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("selling_asset"))
            throw $util.ProtocolError("missing required 'selling_asset'", { instance: message });
        if (!message.hasOwnProperty("buying_asset"))
            throw $util.ProtocolError("missing required 'buying_asset'", { instance: message });
        if (!message.hasOwnProperty("amount"))
            throw $util.ProtocolError("missing required 'amount'", { instance: message });
        if (!message.hasOwnProperty("price_n"))
            throw $util.ProtocolError("missing required 'price_n'", { instance: message });
        if (!message.hasOwnProperty("price_d"))
            throw $util.ProtocolError("missing required 'price_d'", { instance: message });
        if (!message.hasOwnProperty("offer_id"))
            throw $util.ProtocolError("missing required 'offer_id'", { instance: message });
        return message;
    };

    StellarManageSellOfferOp.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    StellarManageSellOfferOp.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.source_account != null && message.hasOwnProperty("source_account"))
            if (!$util.isString(message.source_account))
                return "source_account: string expected";
        {
            var error = $root.StellarAsset.verify(message.selling_asset);
            if (error)
                return "selling_asset." + error;
        }
        {
            var error = $root.StellarAsset.verify(message.buying_asset);
            if (error)
                return "buying_asset." + error;
        }
        if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
            return "amount: integer|Long expected";
        if (!$util.isInteger(message.price_n))
            return "price_n: integer expected";
        if (!$util.isInteger(message.price_d))
            return "price_d: integer expected";
        if (!$util.isInteger(message.offer_id) && !(message.offer_id && $util.isInteger(message.offer_id.low) && $util.isInteger(message.offer_id.high)))
            return "offer_id: integer|Long expected";
        return null;
    };

    StellarManageSellOfferOp.fromObject = function fromObject(object) {
        if (object instanceof $root.StellarManageSellOfferOp)
            return object;
        var message = new $root.StellarManageSellOfferOp();
        if (object.source_account != null)
            message.source_account = String(object.source_account);
        if (object.selling_asset != null) {
            if (typeof object.selling_asset !== "object")
                throw TypeError(".StellarManageSellOfferOp.selling_asset: object expected");
            message.selling_asset = $root.StellarAsset.fromObject(object.selling_asset);
        }
        if (object.buying_asset != null) {
            if (typeof object.buying_asset !== "object")
                throw TypeError(".StellarManageSellOfferOp.buying_asset: object expected");
            message.buying_asset = $root.StellarAsset.fromObject(object.buying_asset);
        }
        if (object.amount != null)
            if ($util.Long)
                (message.amount = $util.Long.fromValue(object.amount)).unsigned = false;
            else if (typeof object.amount === "string")
                message.amount = parseInt(object.amount, 10);
            else if (typeof object.amount === "number")
                message.amount = object.amount;
            else if (typeof object.amount === "object")
                message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber();
        if (object.price_n != null)
            message.price_n = object.price_n >>> 0;
        if (object.price_d != null)
            message.price_d = object.price_d >>> 0;
        if (object.offer_id != null)
            if ($util.Long)
                (message.offer_id = $util.Long.fromValue(object.offer_id)).unsigned = true;
            else if (typeof object.offer_id === "string")
                message.offer_id = parseInt(object.offer_id, 10);
            else if (typeof object.offer_id === "number")
                message.offer_id = object.offer_id;
            else if (typeof object.offer_id === "object")
                message.offer_id = new $util.LongBits(object.offer_id.low >>> 0, object.offer_id.high >>> 0).toNumber(true);
        return message;
    };

    StellarManageSellOfferOp.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.source_account = "";
            object.selling_asset = null;
            object.buying_asset = null;
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.amount = options.longs === String ? "0" : 0;
            object.price_n = 0;
            object.price_d = 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.offer_id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.offer_id = options.longs === String ? "0" : 0;
        }
        if (message.source_account != null && message.hasOwnProperty("source_account"))
            object.source_account = message.source_account;
        if (message.selling_asset != null && message.hasOwnProperty("selling_asset"))
            object.selling_asset = $root.StellarAsset.toObject(message.selling_asset, options);
        if (message.buying_asset != null && message.hasOwnProperty("buying_asset"))
            object.buying_asset = $root.StellarAsset.toObject(message.buying_asset, options);
        if (message.amount != null && message.hasOwnProperty("amount"))
            if (typeof message.amount === "number")
                object.amount = options.longs === String ? String(message.amount) : message.amount;
            else
                object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber() : message.amount;
        if (message.price_n != null && message.hasOwnProperty("price_n"))
            object.price_n = message.price_n;
        if (message.price_d != null && message.hasOwnProperty("price_d"))
            object.price_d = message.price_d;
        if (message.offer_id != null && message.hasOwnProperty("offer_id"))
            if (typeof message.offer_id === "number")
                object.offer_id = options.longs === String ? String(message.offer_id) : message.offer_id;
            else
                object.offer_id = options.longs === String ? $util.Long.prototype.toString.call(message.offer_id) : options.longs === Number ? new $util.LongBits(message.offer_id.low >>> 0, message.offer_id.high >>> 0).toNumber(true) : message.offer_id;
        return object;
    };

    StellarManageSellOfferOp.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return StellarManageSellOfferOp;
})();

$root.StellarManageBuyOfferOp = (function() {

    function StellarManageBuyOfferOp(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    StellarManageBuyOfferOp.prototype.source_account = "";
    StellarManageBuyOfferOp.prototype.selling_asset = null;
    StellarManageBuyOfferOp.prototype.buying_asset = null;
    StellarManageBuyOfferOp.prototype.amount = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    StellarManageBuyOfferOp.prototype.price_n = 0;
    StellarManageBuyOfferOp.prototype.price_d = 0;
    StellarManageBuyOfferOp.prototype.offer_id = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    StellarManageBuyOfferOp.create = function create(properties) {
        return new StellarManageBuyOfferOp(properties);
    };

    StellarManageBuyOfferOp.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.source_account != null && Object.hasOwnProperty.call(message, "source_account"))
            writer.uint32(10).string(message.source_account);
        $root.StellarAsset.encode(message.selling_asset, writer.uint32(18).fork()).ldelim();
        $root.StellarAsset.encode(message.buying_asset, writer.uint32(26).fork()).ldelim();
        writer.uint32(32).sint64(message.amount);
        writer.uint32(40).uint32(message.price_n);
        writer.uint32(48).uint32(message.price_d);
        writer.uint32(56).uint64(message.offer_id);
        return writer;
    };

    StellarManageBuyOfferOp.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    StellarManageBuyOfferOp.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.StellarManageBuyOfferOp();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.source_account = reader.string();
                break;
            case 2:
                message.selling_asset = $root.StellarAsset.decode(reader, reader.uint32());
                break;
            case 3:
                message.buying_asset = $root.StellarAsset.decode(reader, reader.uint32());
                break;
            case 4:
                message.amount = reader.sint64();
                break;
            case 5:
                message.price_n = reader.uint32();
                break;
            case 6:
                message.price_d = reader.uint32();
                break;
            case 7:
                message.offer_id = reader.uint64();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("selling_asset"))
            throw $util.ProtocolError("missing required 'selling_asset'", { instance: message });
        if (!message.hasOwnProperty("buying_asset"))
            throw $util.ProtocolError("missing required 'buying_asset'", { instance: message });
        if (!message.hasOwnProperty("amount"))
            throw $util.ProtocolError("missing required 'amount'", { instance: message });
        if (!message.hasOwnProperty("price_n"))
            throw $util.ProtocolError("missing required 'price_n'", { instance: message });
        if (!message.hasOwnProperty("price_d"))
            throw $util.ProtocolError("missing required 'price_d'", { instance: message });
        if (!message.hasOwnProperty("offer_id"))
            throw $util.ProtocolError("missing required 'offer_id'", { instance: message });
        return message;
    };

    StellarManageBuyOfferOp.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    StellarManageBuyOfferOp.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.source_account != null && message.hasOwnProperty("source_account"))
            if (!$util.isString(message.source_account))
                return "source_account: string expected";
        {
            var error = $root.StellarAsset.verify(message.selling_asset);
            if (error)
                return "selling_asset." + error;
        }
        {
            var error = $root.StellarAsset.verify(message.buying_asset);
            if (error)
                return "buying_asset." + error;
        }
        if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
            return "amount: integer|Long expected";
        if (!$util.isInteger(message.price_n))
            return "price_n: integer expected";
        if (!$util.isInteger(message.price_d))
            return "price_d: integer expected";
        if (!$util.isInteger(message.offer_id) && !(message.offer_id && $util.isInteger(message.offer_id.low) && $util.isInteger(message.offer_id.high)))
            return "offer_id: integer|Long expected";
        return null;
    };

    StellarManageBuyOfferOp.fromObject = function fromObject(object) {
        if (object instanceof $root.StellarManageBuyOfferOp)
            return object;
        var message = new $root.StellarManageBuyOfferOp();
        if (object.source_account != null)
            message.source_account = String(object.source_account);
        if (object.selling_asset != null) {
            if (typeof object.selling_asset !== "object")
                throw TypeError(".StellarManageBuyOfferOp.selling_asset: object expected");
            message.selling_asset = $root.StellarAsset.fromObject(object.selling_asset);
        }
        if (object.buying_asset != null) {
            if (typeof object.buying_asset !== "object")
                throw TypeError(".StellarManageBuyOfferOp.buying_asset: object expected");
            message.buying_asset = $root.StellarAsset.fromObject(object.buying_asset);
        }
        if (object.amount != null)
            if ($util.Long)
                (message.amount = $util.Long.fromValue(object.amount)).unsigned = false;
            else if (typeof object.amount === "string")
                message.amount = parseInt(object.amount, 10);
            else if (typeof object.amount === "number")
                message.amount = object.amount;
            else if (typeof object.amount === "object")
                message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber();
        if (object.price_n != null)
            message.price_n = object.price_n >>> 0;
        if (object.price_d != null)
            message.price_d = object.price_d >>> 0;
        if (object.offer_id != null)
            if ($util.Long)
                (message.offer_id = $util.Long.fromValue(object.offer_id)).unsigned = true;
            else if (typeof object.offer_id === "string")
                message.offer_id = parseInt(object.offer_id, 10);
            else if (typeof object.offer_id === "number")
                message.offer_id = object.offer_id;
            else if (typeof object.offer_id === "object")
                message.offer_id = new $util.LongBits(object.offer_id.low >>> 0, object.offer_id.high >>> 0).toNumber(true);
        return message;
    };

    StellarManageBuyOfferOp.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.source_account = "";
            object.selling_asset = null;
            object.buying_asset = null;
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.amount = options.longs === String ? "0" : 0;
            object.price_n = 0;
            object.price_d = 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.offer_id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.offer_id = options.longs === String ? "0" : 0;
        }
        if (message.source_account != null && message.hasOwnProperty("source_account"))
            object.source_account = message.source_account;
        if (message.selling_asset != null && message.hasOwnProperty("selling_asset"))
            object.selling_asset = $root.StellarAsset.toObject(message.selling_asset, options);
        if (message.buying_asset != null && message.hasOwnProperty("buying_asset"))
            object.buying_asset = $root.StellarAsset.toObject(message.buying_asset, options);
        if (message.amount != null && message.hasOwnProperty("amount"))
            if (typeof message.amount === "number")
                object.amount = options.longs === String ? String(message.amount) : message.amount;
            else
                object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber() : message.amount;
        if (message.price_n != null && message.hasOwnProperty("price_n"))
            object.price_n = message.price_n;
        if (message.price_d != null && message.hasOwnProperty("price_d"))
            object.price_d = message.price_d;
        if (message.offer_id != null && message.hasOwnProperty("offer_id"))
            if (typeof message.offer_id === "number")
                object.offer_id = options.longs === String ? String(message.offer_id) : message.offer_id;
            else
                object.offer_id = options.longs === String ? $util.Long.prototype.toString.call(message.offer_id) : options.longs === Number ? new $util.LongBits(message.offer_id.low >>> 0, message.offer_id.high >>> 0).toNumber(true) : message.offer_id;
        return object;
    };

    StellarManageBuyOfferOp.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return StellarManageBuyOfferOp;
})();

$root.StellarCreatePassiveSellOfferOp = (function() {

    function StellarCreatePassiveSellOfferOp(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    StellarCreatePassiveSellOfferOp.prototype.source_account = "";
    StellarCreatePassiveSellOfferOp.prototype.selling_asset = null;
    StellarCreatePassiveSellOfferOp.prototype.buying_asset = null;
    StellarCreatePassiveSellOfferOp.prototype.amount = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    StellarCreatePassiveSellOfferOp.prototype.price_n = 0;
    StellarCreatePassiveSellOfferOp.prototype.price_d = 0;

    StellarCreatePassiveSellOfferOp.create = function create(properties) {
        return new StellarCreatePassiveSellOfferOp(properties);
    };

    StellarCreatePassiveSellOfferOp.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.source_account != null && Object.hasOwnProperty.call(message, "source_account"))
            writer.uint32(10).string(message.source_account);
        $root.StellarAsset.encode(message.selling_asset, writer.uint32(18).fork()).ldelim();
        $root.StellarAsset.encode(message.buying_asset, writer.uint32(26).fork()).ldelim();
        writer.uint32(32).sint64(message.amount);
        writer.uint32(40).uint32(message.price_n);
        writer.uint32(48).uint32(message.price_d);
        return writer;
    };

    StellarCreatePassiveSellOfferOp.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    StellarCreatePassiveSellOfferOp.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.StellarCreatePassiveSellOfferOp();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.source_account = reader.string();
                break;
            case 2:
                message.selling_asset = $root.StellarAsset.decode(reader, reader.uint32());
                break;
            case 3:
                message.buying_asset = $root.StellarAsset.decode(reader, reader.uint32());
                break;
            case 4:
                message.amount = reader.sint64();
                break;
            case 5:
                message.price_n = reader.uint32();
                break;
            case 6:
                message.price_d = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("selling_asset"))
            throw $util.ProtocolError("missing required 'selling_asset'", { instance: message });
        if (!message.hasOwnProperty("buying_asset"))
            throw $util.ProtocolError("missing required 'buying_asset'", { instance: message });
        if (!message.hasOwnProperty("amount"))
            throw $util.ProtocolError("missing required 'amount'", { instance: message });
        if (!message.hasOwnProperty("price_n"))
            throw $util.ProtocolError("missing required 'price_n'", { instance: message });
        if (!message.hasOwnProperty("price_d"))
            throw $util.ProtocolError("missing required 'price_d'", { instance: message });
        return message;
    };

    StellarCreatePassiveSellOfferOp.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    StellarCreatePassiveSellOfferOp.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.source_account != null && message.hasOwnProperty("source_account"))
            if (!$util.isString(message.source_account))
                return "source_account: string expected";
        {
            var error = $root.StellarAsset.verify(message.selling_asset);
            if (error)
                return "selling_asset." + error;
        }
        {
            var error = $root.StellarAsset.verify(message.buying_asset);
            if (error)
                return "buying_asset." + error;
        }
        if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
            return "amount: integer|Long expected";
        if (!$util.isInteger(message.price_n))
            return "price_n: integer expected";
        if (!$util.isInteger(message.price_d))
            return "price_d: integer expected";
        return null;
    };

    StellarCreatePassiveSellOfferOp.fromObject = function fromObject(object) {
        if (object instanceof $root.StellarCreatePassiveSellOfferOp)
            return object;
        var message = new $root.StellarCreatePassiveSellOfferOp();
        if (object.source_account != null)
            message.source_account = String(object.source_account);
        if (object.selling_asset != null) {
            if (typeof object.selling_asset !== "object")
                throw TypeError(".StellarCreatePassiveSellOfferOp.selling_asset: object expected");
            message.selling_asset = $root.StellarAsset.fromObject(object.selling_asset);
        }
        if (object.buying_asset != null) {
            if (typeof object.buying_asset !== "object")
                throw TypeError(".StellarCreatePassiveSellOfferOp.buying_asset: object expected");
            message.buying_asset = $root.StellarAsset.fromObject(object.buying_asset);
        }
        if (object.amount != null)
            if ($util.Long)
                (message.amount = $util.Long.fromValue(object.amount)).unsigned = false;
            else if (typeof object.amount === "string")
                message.amount = parseInt(object.amount, 10);
            else if (typeof object.amount === "number")
                message.amount = object.amount;
            else if (typeof object.amount === "object")
                message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber();
        if (object.price_n != null)
            message.price_n = object.price_n >>> 0;
        if (object.price_d != null)
            message.price_d = object.price_d >>> 0;
        return message;
    };

    StellarCreatePassiveSellOfferOp.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.source_account = "";
            object.selling_asset = null;
            object.buying_asset = null;
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.amount = options.longs === String ? "0" : 0;
            object.price_n = 0;
            object.price_d = 0;
        }
        if (message.source_account != null && message.hasOwnProperty("source_account"))
            object.source_account = message.source_account;
        if (message.selling_asset != null && message.hasOwnProperty("selling_asset"))
            object.selling_asset = $root.StellarAsset.toObject(message.selling_asset, options);
        if (message.buying_asset != null && message.hasOwnProperty("buying_asset"))
            object.buying_asset = $root.StellarAsset.toObject(message.buying_asset, options);
        if (message.amount != null && message.hasOwnProperty("amount"))
            if (typeof message.amount === "number")
                object.amount = options.longs === String ? String(message.amount) : message.amount;
            else
                object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber() : message.amount;
        if (message.price_n != null && message.hasOwnProperty("price_n"))
            object.price_n = message.price_n;
        if (message.price_d != null && message.hasOwnProperty("price_d"))
            object.price_d = message.price_d;
        return object;
    };

    StellarCreatePassiveSellOfferOp.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return StellarCreatePassiveSellOfferOp;
})();

$root.StellarSetOptionsOp = (function() {

    function StellarSetOptionsOp(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    StellarSetOptionsOp.prototype.source_account = "";
    StellarSetOptionsOp.prototype.inflation_destination_account = "";
    StellarSetOptionsOp.prototype.clear_flags = 0;
    StellarSetOptionsOp.prototype.set_flags = 0;
    StellarSetOptionsOp.prototype.master_weight = 0;
    StellarSetOptionsOp.prototype.low_threshold = 0;
    StellarSetOptionsOp.prototype.medium_threshold = 0;
    StellarSetOptionsOp.prototype.high_threshold = 0;
    StellarSetOptionsOp.prototype.home_domain = "";
    StellarSetOptionsOp.prototype.signer_type = 0;
    StellarSetOptionsOp.prototype.signer_key = $util.newBuffer([]);
    StellarSetOptionsOp.prototype.signer_weight = 0;

    StellarSetOptionsOp.create = function create(properties) {
        return new StellarSetOptionsOp(properties);
    };

    StellarSetOptionsOp.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.source_account != null && Object.hasOwnProperty.call(message, "source_account"))
            writer.uint32(10).string(message.source_account);
        if (message.inflation_destination_account != null && Object.hasOwnProperty.call(message, "inflation_destination_account"))
            writer.uint32(18).string(message.inflation_destination_account);
        if (message.clear_flags != null && Object.hasOwnProperty.call(message, "clear_flags"))
            writer.uint32(24).uint32(message.clear_flags);
        if (message.set_flags != null && Object.hasOwnProperty.call(message, "set_flags"))
            writer.uint32(32).uint32(message.set_flags);
        if (message.master_weight != null && Object.hasOwnProperty.call(message, "master_weight"))
            writer.uint32(40).uint32(message.master_weight);
        if (message.low_threshold != null && Object.hasOwnProperty.call(message, "low_threshold"))
            writer.uint32(48).uint32(message.low_threshold);
        if (message.medium_threshold != null && Object.hasOwnProperty.call(message, "medium_threshold"))
            writer.uint32(56).uint32(message.medium_threshold);
        if (message.high_threshold != null && Object.hasOwnProperty.call(message, "high_threshold"))
            writer.uint32(64).uint32(message.high_threshold);
        if (message.home_domain != null && Object.hasOwnProperty.call(message, "home_domain"))
            writer.uint32(74).string(message.home_domain);
        if (message.signer_type != null && Object.hasOwnProperty.call(message, "signer_type"))
            writer.uint32(80).int32(message.signer_type);
        if (message.signer_key != null && Object.hasOwnProperty.call(message, "signer_key"))
            writer.uint32(90).bytes(message.signer_key);
        if (message.signer_weight != null && Object.hasOwnProperty.call(message, "signer_weight"))
            writer.uint32(96).uint32(message.signer_weight);
        return writer;
    };

    StellarSetOptionsOp.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    StellarSetOptionsOp.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.StellarSetOptionsOp();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.source_account = reader.string();
                break;
            case 2:
                message.inflation_destination_account = reader.string();
                break;
            case 3:
                message.clear_flags = reader.uint32();
                break;
            case 4:
                message.set_flags = reader.uint32();
                break;
            case 5:
                message.master_weight = reader.uint32();
                break;
            case 6:
                message.low_threshold = reader.uint32();
                break;
            case 7:
                message.medium_threshold = reader.uint32();
                break;
            case 8:
                message.high_threshold = reader.uint32();
                break;
            case 9:
                message.home_domain = reader.string();
                break;
            case 10:
                message.signer_type = reader.int32();
                break;
            case 11:
                message.signer_key = reader.bytes();
                break;
            case 12:
                message.signer_weight = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    StellarSetOptionsOp.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    StellarSetOptionsOp.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.source_account != null && message.hasOwnProperty("source_account"))
            if (!$util.isString(message.source_account))
                return "source_account: string expected";
        if (message.inflation_destination_account != null && message.hasOwnProperty("inflation_destination_account"))
            if (!$util.isString(message.inflation_destination_account))
                return "inflation_destination_account: string expected";
        if (message.clear_flags != null && message.hasOwnProperty("clear_flags"))
            if (!$util.isInteger(message.clear_flags))
                return "clear_flags: integer expected";
        if (message.set_flags != null && message.hasOwnProperty("set_flags"))
            if (!$util.isInteger(message.set_flags))
                return "set_flags: integer expected";
        if (message.master_weight != null && message.hasOwnProperty("master_weight"))
            if (!$util.isInteger(message.master_weight))
                return "master_weight: integer expected";
        if (message.low_threshold != null && message.hasOwnProperty("low_threshold"))
            if (!$util.isInteger(message.low_threshold))
                return "low_threshold: integer expected";
        if (message.medium_threshold != null && message.hasOwnProperty("medium_threshold"))
            if (!$util.isInteger(message.medium_threshold))
                return "medium_threshold: integer expected";
        if (message.high_threshold != null && message.hasOwnProperty("high_threshold"))
            if (!$util.isInteger(message.high_threshold))
                return "high_threshold: integer expected";
        if (message.home_domain != null && message.hasOwnProperty("home_domain"))
            if (!$util.isString(message.home_domain))
                return "home_domain: string expected";
        if (message.signer_type != null && message.hasOwnProperty("signer_type"))
            switch (message.signer_type) {
            default:
                return "signer_type: enum value expected";
            case 0:
            case 1:
            case 2:
                break;
            }
        if (message.signer_key != null && message.hasOwnProperty("signer_key"))
            if (!(message.signer_key && typeof message.signer_key.length === "number" || $util.isString(message.signer_key)))
                return "signer_key: buffer expected";
        if (message.signer_weight != null && message.hasOwnProperty("signer_weight"))
            if (!$util.isInteger(message.signer_weight))
                return "signer_weight: integer expected";
        return null;
    };

    StellarSetOptionsOp.fromObject = function fromObject(object) {
        if (object instanceof $root.StellarSetOptionsOp)
            return object;
        var message = new $root.StellarSetOptionsOp();
        if (object.source_account != null)
            message.source_account = String(object.source_account);
        if (object.inflation_destination_account != null)
            message.inflation_destination_account = String(object.inflation_destination_account);
        if (object.clear_flags != null)
            message.clear_flags = object.clear_flags >>> 0;
        if (object.set_flags != null)
            message.set_flags = object.set_flags >>> 0;
        if (object.master_weight != null)
            message.master_weight = object.master_weight >>> 0;
        if (object.low_threshold != null)
            message.low_threshold = object.low_threshold >>> 0;
        if (object.medium_threshold != null)
            message.medium_threshold = object.medium_threshold >>> 0;
        if (object.high_threshold != null)
            message.high_threshold = object.high_threshold >>> 0;
        if (object.home_domain != null)
            message.home_domain = String(object.home_domain);
        switch (object.signer_type) {
        case "ACCOUNT":
        case 0:
            message.signer_type = 0;
            break;
        case "PRE_AUTH":
        case 1:
            message.signer_type = 1;
            break;
        case "HASH":
        case 2:
            message.signer_type = 2;
            break;
        }
        if (object.signer_key != null)
            if (typeof object.signer_key === "string")
                $util.base64.decode(object.signer_key, message.signer_key = $util.newBuffer($util.base64.length(object.signer_key)), 0);
            else if (object.signer_key.length)
                message.signer_key = object.signer_key;
        if (object.signer_weight != null)
            message.signer_weight = object.signer_weight >>> 0;
        return message;
    };

    StellarSetOptionsOp.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.source_account = "";
            object.inflation_destination_account = "";
            object.clear_flags = 0;
            object.set_flags = 0;
            object.master_weight = 0;
            object.low_threshold = 0;
            object.medium_threshold = 0;
            object.high_threshold = 0;
            object.home_domain = "";
            object.signer_type = options.enums === String ? "ACCOUNT" : 0;
            if (options.bytes === String)
                object.signer_key = "";
            else {
                object.signer_key = [];
                if (options.bytes !== Array)
                    object.signer_key = $util.newBuffer(object.signer_key);
            }
            object.signer_weight = 0;
        }
        if (message.source_account != null && message.hasOwnProperty("source_account"))
            object.source_account = message.source_account;
        if (message.inflation_destination_account != null && message.hasOwnProperty("inflation_destination_account"))
            object.inflation_destination_account = message.inflation_destination_account;
        if (message.clear_flags != null && message.hasOwnProperty("clear_flags"))
            object.clear_flags = message.clear_flags;
        if (message.set_flags != null && message.hasOwnProperty("set_flags"))
            object.set_flags = message.set_flags;
        if (message.master_weight != null && message.hasOwnProperty("master_weight"))
            object.master_weight = message.master_weight;
        if (message.low_threshold != null && message.hasOwnProperty("low_threshold"))
            object.low_threshold = message.low_threshold;
        if (message.medium_threshold != null && message.hasOwnProperty("medium_threshold"))
            object.medium_threshold = message.medium_threshold;
        if (message.high_threshold != null && message.hasOwnProperty("high_threshold"))
            object.high_threshold = message.high_threshold;
        if (message.home_domain != null && message.hasOwnProperty("home_domain"))
            object.home_domain = message.home_domain;
        if (message.signer_type != null && message.hasOwnProperty("signer_type"))
            object.signer_type = options.enums === String ? $root.StellarSetOptionsOp.StellarSignerType[message.signer_type] : message.signer_type;
        if (message.signer_key != null && message.hasOwnProperty("signer_key"))
            object.signer_key = options.bytes === String ? $util.base64.encode(message.signer_key, 0, message.signer_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.signer_key) : message.signer_key;
        if (message.signer_weight != null && message.hasOwnProperty("signer_weight"))
            object.signer_weight = message.signer_weight;
        return object;
    };

    StellarSetOptionsOp.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    StellarSetOptionsOp.StellarSignerType = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "ACCOUNT"] = 0;
        values[valuesById[1] = "PRE_AUTH"] = 1;
        values[valuesById[2] = "HASH"] = 2;
        return values;
    })();

    return StellarSetOptionsOp;
})();

$root.StellarChangeTrustOp = (function() {

    function StellarChangeTrustOp(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    StellarChangeTrustOp.prototype.source_account = "";
    StellarChangeTrustOp.prototype.asset = null;
    StellarChangeTrustOp.prototype.limit = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    StellarChangeTrustOp.create = function create(properties) {
        return new StellarChangeTrustOp(properties);
    };

    StellarChangeTrustOp.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.source_account != null && Object.hasOwnProperty.call(message, "source_account"))
            writer.uint32(10).string(message.source_account);
        $root.StellarAsset.encode(message.asset, writer.uint32(18).fork()).ldelim();
        writer.uint32(24).uint64(message.limit);
        return writer;
    };

    StellarChangeTrustOp.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    StellarChangeTrustOp.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.StellarChangeTrustOp();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.source_account = reader.string();
                break;
            case 2:
                message.asset = $root.StellarAsset.decode(reader, reader.uint32());
                break;
            case 3:
                message.limit = reader.uint64();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("asset"))
            throw $util.ProtocolError("missing required 'asset'", { instance: message });
        if (!message.hasOwnProperty("limit"))
            throw $util.ProtocolError("missing required 'limit'", { instance: message });
        return message;
    };

    StellarChangeTrustOp.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    StellarChangeTrustOp.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.source_account != null && message.hasOwnProperty("source_account"))
            if (!$util.isString(message.source_account))
                return "source_account: string expected";
        {
            var error = $root.StellarAsset.verify(message.asset);
            if (error)
                return "asset." + error;
        }
        if (!$util.isInteger(message.limit) && !(message.limit && $util.isInteger(message.limit.low) && $util.isInteger(message.limit.high)))
            return "limit: integer|Long expected";
        return null;
    };

    StellarChangeTrustOp.fromObject = function fromObject(object) {
        if (object instanceof $root.StellarChangeTrustOp)
            return object;
        var message = new $root.StellarChangeTrustOp();
        if (object.source_account != null)
            message.source_account = String(object.source_account);
        if (object.asset != null) {
            if (typeof object.asset !== "object")
                throw TypeError(".StellarChangeTrustOp.asset: object expected");
            message.asset = $root.StellarAsset.fromObject(object.asset);
        }
        if (object.limit != null)
            if ($util.Long)
                (message.limit = $util.Long.fromValue(object.limit)).unsigned = true;
            else if (typeof object.limit === "string")
                message.limit = parseInt(object.limit, 10);
            else if (typeof object.limit === "number")
                message.limit = object.limit;
            else if (typeof object.limit === "object")
                message.limit = new $util.LongBits(object.limit.low >>> 0, object.limit.high >>> 0).toNumber(true);
        return message;
    };

    StellarChangeTrustOp.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.source_account = "";
            object.asset = null;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.limit = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.limit = options.longs === String ? "0" : 0;
        }
        if (message.source_account != null && message.hasOwnProperty("source_account"))
            object.source_account = message.source_account;
        if (message.asset != null && message.hasOwnProperty("asset"))
            object.asset = $root.StellarAsset.toObject(message.asset, options);
        if (message.limit != null && message.hasOwnProperty("limit"))
            if (typeof message.limit === "number")
                object.limit = options.longs === String ? String(message.limit) : message.limit;
            else
                object.limit = options.longs === String ? $util.Long.prototype.toString.call(message.limit) : options.longs === Number ? new $util.LongBits(message.limit.low >>> 0, message.limit.high >>> 0).toNumber(true) : message.limit;
        return object;
    };

    StellarChangeTrustOp.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return StellarChangeTrustOp;
})();

$root.StellarAllowTrustOp = (function() {

    function StellarAllowTrustOp(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    StellarAllowTrustOp.prototype.source_account = "";
    StellarAllowTrustOp.prototype.trusted_account = "";
    StellarAllowTrustOp.prototype.asset_type = 0;
    StellarAllowTrustOp.prototype.asset_code = "";
    StellarAllowTrustOp.prototype.is_authorized = false;

    StellarAllowTrustOp.create = function create(properties) {
        return new StellarAllowTrustOp(properties);
    };

    StellarAllowTrustOp.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.source_account != null && Object.hasOwnProperty.call(message, "source_account"))
            writer.uint32(10).string(message.source_account);
        writer.uint32(18).string(message.trusted_account);
        writer.uint32(24).int32(message.asset_type);
        if (message.asset_code != null && Object.hasOwnProperty.call(message, "asset_code"))
            writer.uint32(34).string(message.asset_code);
        writer.uint32(40).bool(message.is_authorized);
        return writer;
    };

    StellarAllowTrustOp.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    StellarAllowTrustOp.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.StellarAllowTrustOp();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.source_account = reader.string();
                break;
            case 2:
                message.trusted_account = reader.string();
                break;
            case 3:
                message.asset_type = reader.int32();
                break;
            case 4:
                message.asset_code = reader.string();
                break;
            case 5:
                message.is_authorized = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("trusted_account"))
            throw $util.ProtocolError("missing required 'trusted_account'", { instance: message });
        if (!message.hasOwnProperty("asset_type"))
            throw $util.ProtocolError("missing required 'asset_type'", { instance: message });
        if (!message.hasOwnProperty("is_authorized"))
            throw $util.ProtocolError("missing required 'is_authorized'", { instance: message });
        return message;
    };

    StellarAllowTrustOp.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    StellarAllowTrustOp.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.source_account != null && message.hasOwnProperty("source_account"))
            if (!$util.isString(message.source_account))
                return "source_account: string expected";
        if (!$util.isString(message.trusted_account))
            return "trusted_account: string expected";
        switch (message.asset_type) {
        default:
            return "asset_type: enum value expected";
        case 0:
        case 1:
        case 2:
            break;
        }
        if (message.asset_code != null && message.hasOwnProperty("asset_code"))
            if (!$util.isString(message.asset_code))
                return "asset_code: string expected";
        if (typeof message.is_authorized !== "boolean")
            return "is_authorized: boolean expected";
        return null;
    };

    StellarAllowTrustOp.fromObject = function fromObject(object) {
        if (object instanceof $root.StellarAllowTrustOp)
            return object;
        var message = new $root.StellarAllowTrustOp();
        if (object.source_account != null)
            message.source_account = String(object.source_account);
        if (object.trusted_account != null)
            message.trusted_account = String(object.trusted_account);
        switch (object.asset_type) {
        case "NATIVE":
        case 0:
            message.asset_type = 0;
            break;
        case "ALPHANUM4":
        case 1:
            message.asset_type = 1;
            break;
        case "ALPHANUM12":
        case 2:
            message.asset_type = 2;
            break;
        }
        if (object.asset_code != null)
            message.asset_code = String(object.asset_code);
        if (object.is_authorized != null)
            message.is_authorized = Boolean(object.is_authorized);
        return message;
    };

    StellarAllowTrustOp.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.source_account = "";
            object.trusted_account = "";
            object.asset_type = options.enums === String ? "NATIVE" : 0;
            object.asset_code = "";
            object.is_authorized = false;
        }
        if (message.source_account != null && message.hasOwnProperty("source_account"))
            object.source_account = message.source_account;
        if (message.trusted_account != null && message.hasOwnProperty("trusted_account"))
            object.trusted_account = message.trusted_account;
        if (message.asset_type != null && message.hasOwnProperty("asset_type"))
            object.asset_type = options.enums === String ? $root.StellarAssetType[message.asset_type] : message.asset_type;
        if (message.asset_code != null && message.hasOwnProperty("asset_code"))
            object.asset_code = message.asset_code;
        if (message.is_authorized != null && message.hasOwnProperty("is_authorized"))
            object.is_authorized = message.is_authorized;
        return object;
    };

    StellarAllowTrustOp.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return StellarAllowTrustOp;
})();

$root.StellarAccountMergeOp = (function() {

    function StellarAccountMergeOp(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    StellarAccountMergeOp.prototype.source_account = "";
    StellarAccountMergeOp.prototype.destination_account = "";

    StellarAccountMergeOp.create = function create(properties) {
        return new StellarAccountMergeOp(properties);
    };

    StellarAccountMergeOp.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.source_account != null && Object.hasOwnProperty.call(message, "source_account"))
            writer.uint32(10).string(message.source_account);
        writer.uint32(18).string(message.destination_account);
        return writer;
    };

    StellarAccountMergeOp.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    StellarAccountMergeOp.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.StellarAccountMergeOp();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.source_account = reader.string();
                break;
            case 2:
                message.destination_account = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("destination_account"))
            throw $util.ProtocolError("missing required 'destination_account'", { instance: message });
        return message;
    };

    StellarAccountMergeOp.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    StellarAccountMergeOp.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.source_account != null && message.hasOwnProperty("source_account"))
            if (!$util.isString(message.source_account))
                return "source_account: string expected";
        if (!$util.isString(message.destination_account))
            return "destination_account: string expected";
        return null;
    };

    StellarAccountMergeOp.fromObject = function fromObject(object) {
        if (object instanceof $root.StellarAccountMergeOp)
            return object;
        var message = new $root.StellarAccountMergeOp();
        if (object.source_account != null)
            message.source_account = String(object.source_account);
        if (object.destination_account != null)
            message.destination_account = String(object.destination_account);
        return message;
    };

    StellarAccountMergeOp.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.source_account = "";
            object.destination_account = "";
        }
        if (message.source_account != null && message.hasOwnProperty("source_account"))
            object.source_account = message.source_account;
        if (message.destination_account != null && message.hasOwnProperty("destination_account"))
            object.destination_account = message.destination_account;
        return object;
    };

    StellarAccountMergeOp.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return StellarAccountMergeOp;
})();

$root.StellarManageDataOp = (function() {

    function StellarManageDataOp(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    StellarManageDataOp.prototype.source_account = "";
    StellarManageDataOp.prototype.key = "";
    StellarManageDataOp.prototype.value = $util.newBuffer([]);

    StellarManageDataOp.create = function create(properties) {
        return new StellarManageDataOp(properties);
    };

    StellarManageDataOp.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.source_account != null && Object.hasOwnProperty.call(message, "source_account"))
            writer.uint32(10).string(message.source_account);
        writer.uint32(18).string(message.key);
        if (message.value != null && Object.hasOwnProperty.call(message, "value"))
            writer.uint32(26).bytes(message.value);
        return writer;
    };

    StellarManageDataOp.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    StellarManageDataOp.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.StellarManageDataOp();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.source_account = reader.string();
                break;
            case 2:
                message.key = reader.string();
                break;
            case 3:
                message.value = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("key"))
            throw $util.ProtocolError("missing required 'key'", { instance: message });
        return message;
    };

    StellarManageDataOp.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    StellarManageDataOp.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.source_account != null && message.hasOwnProperty("source_account"))
            if (!$util.isString(message.source_account))
                return "source_account: string expected";
        if (!$util.isString(message.key))
            return "key: string expected";
        if (message.value != null && message.hasOwnProperty("value"))
            if (!(message.value && typeof message.value.length === "number" || $util.isString(message.value)))
                return "value: buffer expected";
        return null;
    };

    StellarManageDataOp.fromObject = function fromObject(object) {
        if (object instanceof $root.StellarManageDataOp)
            return object;
        var message = new $root.StellarManageDataOp();
        if (object.source_account != null)
            message.source_account = String(object.source_account);
        if (object.key != null)
            message.key = String(object.key);
        if (object.value != null)
            if (typeof object.value === "string")
                $util.base64.decode(object.value, message.value = $util.newBuffer($util.base64.length(object.value)), 0);
            else if (object.value.length)
                message.value = object.value;
        return message;
    };

    StellarManageDataOp.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.source_account = "";
            object.key = "";
            if (options.bytes === String)
                object.value = "";
            else {
                object.value = [];
                if (options.bytes !== Array)
                    object.value = $util.newBuffer(object.value);
            }
        }
        if (message.source_account != null && message.hasOwnProperty("source_account"))
            object.source_account = message.source_account;
        if (message.key != null && message.hasOwnProperty("key"))
            object.key = message.key;
        if (message.value != null && message.hasOwnProperty("value"))
            object.value = options.bytes === String ? $util.base64.encode(message.value, 0, message.value.length) : options.bytes === Array ? Array.prototype.slice.call(message.value) : message.value;
        return object;
    };

    StellarManageDataOp.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return StellarManageDataOp;
})();

$root.StellarBumpSequenceOp = (function() {

    function StellarBumpSequenceOp(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    StellarBumpSequenceOp.prototype.source_account = "";
    StellarBumpSequenceOp.prototype.bump_to = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    StellarBumpSequenceOp.create = function create(properties) {
        return new StellarBumpSequenceOp(properties);
    };

    StellarBumpSequenceOp.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.source_account != null && Object.hasOwnProperty.call(message, "source_account"))
            writer.uint32(10).string(message.source_account);
        writer.uint32(16).uint64(message.bump_to);
        return writer;
    };

    StellarBumpSequenceOp.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    StellarBumpSequenceOp.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.StellarBumpSequenceOp();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.source_account = reader.string();
                break;
            case 2:
                message.bump_to = reader.uint64();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("bump_to"))
            throw $util.ProtocolError("missing required 'bump_to'", { instance: message });
        return message;
    };

    StellarBumpSequenceOp.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    StellarBumpSequenceOp.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.source_account != null && message.hasOwnProperty("source_account"))
            if (!$util.isString(message.source_account))
                return "source_account: string expected";
        if (!$util.isInteger(message.bump_to) && !(message.bump_to && $util.isInteger(message.bump_to.low) && $util.isInteger(message.bump_to.high)))
            return "bump_to: integer|Long expected";
        return null;
    };

    StellarBumpSequenceOp.fromObject = function fromObject(object) {
        if (object instanceof $root.StellarBumpSequenceOp)
            return object;
        var message = new $root.StellarBumpSequenceOp();
        if (object.source_account != null)
            message.source_account = String(object.source_account);
        if (object.bump_to != null)
            if ($util.Long)
                (message.bump_to = $util.Long.fromValue(object.bump_to)).unsigned = true;
            else if (typeof object.bump_to === "string")
                message.bump_to = parseInt(object.bump_to, 10);
            else if (typeof object.bump_to === "number")
                message.bump_to = object.bump_to;
            else if (typeof object.bump_to === "object")
                message.bump_to = new $util.LongBits(object.bump_to.low >>> 0, object.bump_to.high >>> 0).toNumber(true);
        return message;
    };

    StellarBumpSequenceOp.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.source_account = "";
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.bump_to = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.bump_to = options.longs === String ? "0" : 0;
        }
        if (message.source_account != null && message.hasOwnProperty("source_account"))
            object.source_account = message.source_account;
        if (message.bump_to != null && message.hasOwnProperty("bump_to"))
            if (typeof message.bump_to === "number")
                object.bump_to = options.longs === String ? String(message.bump_to) : message.bump_to;
            else
                object.bump_to = options.longs === String ? $util.Long.prototype.toString.call(message.bump_to) : options.longs === Number ? new $util.LongBits(message.bump_to.low >>> 0, message.bump_to.high >>> 0).toNumber(true) : message.bump_to;
        return object;
    };

    StellarBumpSequenceOp.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return StellarBumpSequenceOp;
})();

$root.StellarSignedTx = (function() {

    function StellarSignedTx(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    StellarSignedTx.prototype.public_key = $util.newBuffer([]);
    StellarSignedTx.prototype.signature = $util.newBuffer([]);

    StellarSignedTx.create = function create(properties) {
        return new StellarSignedTx(properties);
    };

    StellarSignedTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.public_key);
        writer.uint32(18).bytes(message.signature);
        return writer;
    };

    StellarSignedTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    StellarSignedTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.StellarSignedTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.public_key = reader.bytes();
                break;
            case 2:
                message.signature = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("public_key"))
            throw $util.ProtocolError("missing required 'public_key'", { instance: message });
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        return message;
    };

    StellarSignedTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    StellarSignedTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.public_key && typeof message.public_key.length === "number" || $util.isString(message.public_key)))
            return "public_key: buffer expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        return null;
    };

    StellarSignedTx.fromObject = function fromObject(object) {
        if (object instanceof $root.StellarSignedTx)
            return object;
        var message = new $root.StellarSignedTx();
        if (object.public_key != null)
            if (typeof object.public_key === "string")
                $util.base64.decode(object.public_key, message.public_key = $util.newBuffer($util.base64.length(object.public_key)), 0);
            else if (object.public_key.length)
                message.public_key = object.public_key;
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        return message;
    };

    StellarSignedTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.public_key = "";
            else {
                object.public_key = [];
                if (options.bytes !== Array)
                    object.public_key = $util.newBuffer(object.public_key);
            }
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
        }
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            object.public_key = options.bytes === String ? $util.base64.encode(message.public_key, 0, message.public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.public_key) : message.public_key;
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        return object;
    };

    StellarSignedTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return StellarSignedTx;
})();

$root.SuiGetAddress = (function() {

    function SuiGetAddress(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    SuiGetAddress.prototype.address_n = $util.emptyArray;
    SuiGetAddress.prototype.show_display = false;

    SuiGetAddress.create = function create(properties) {
        return new SuiGetAddress(properties);
    };

    SuiGetAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(16).bool(message.show_display);
        return writer;
    };

    SuiGetAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    SuiGetAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SuiGetAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.show_display = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    SuiGetAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    SuiGetAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        return null;
    };

    SuiGetAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.SuiGetAddress)
            return object;
        var message = new $root.SuiGetAddress();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".SuiGetAddress.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        return message;
    };

    SuiGetAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            object.show_display = false;
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        return object;
    };

    SuiGetAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SuiGetAddress;
})();

$root.SuiAddress = (function() {

    function SuiAddress(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    SuiAddress.prototype.address = "";

    SuiAddress.create = function create(properties) {
        return new SuiAddress(properties);
    };

    SuiAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address != null && Object.hasOwnProperty.call(message, "address"))
            writer.uint32(10).string(message.address);
        return writer;
    };

    SuiAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    SuiAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SuiAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    SuiAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    SuiAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address != null && message.hasOwnProperty("address"))
            if (!$util.isString(message.address))
                return "address: string expected";
        return null;
    };

    SuiAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.SuiAddress)
            return object;
        var message = new $root.SuiAddress();
        if (object.address != null)
            message.address = String(object.address);
        return message;
    };

    SuiAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.address = "";
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    SuiAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SuiAddress;
})();

$root.SuiSignTx = (function() {

    function SuiSignTx(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    SuiSignTx.prototype.address_n = $util.emptyArray;
    SuiSignTx.prototype.raw_tx = $util.newBuffer([]);
    SuiSignTx.prototype.data_initial_chunk = $util.newBuffer([]);
    SuiSignTx.prototype.data_length = 0;

    SuiSignTx.create = function create(properties) {
        return new SuiSignTx(properties);
    };

    SuiSignTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).bytes(message.raw_tx);
        if (message.data_initial_chunk != null && Object.hasOwnProperty.call(message, "data_initial_chunk"))
            writer.uint32(26).bytes(message.data_initial_chunk);
        if (message.data_length != null && Object.hasOwnProperty.call(message, "data_length"))
            writer.uint32(32).uint32(message.data_length);
        return writer;
    };

    SuiSignTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    SuiSignTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SuiSignTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.raw_tx = reader.bytes();
                break;
            case 3:
                message.data_initial_chunk = reader.bytes();
                break;
            case 4:
                message.data_length = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("raw_tx"))
            throw $util.ProtocolError("missing required 'raw_tx'", { instance: message });
        return message;
    };

    SuiSignTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    SuiSignTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!(message.raw_tx && typeof message.raw_tx.length === "number" || $util.isString(message.raw_tx)))
            return "raw_tx: buffer expected";
        if (message.data_initial_chunk != null && message.hasOwnProperty("data_initial_chunk"))
            if (!(message.data_initial_chunk && typeof message.data_initial_chunk.length === "number" || $util.isString(message.data_initial_chunk)))
                return "data_initial_chunk: buffer expected";
        if (message.data_length != null && message.hasOwnProperty("data_length"))
            if (!$util.isInteger(message.data_length))
                return "data_length: integer expected";
        return null;
    };

    SuiSignTx.fromObject = function fromObject(object) {
        if (object instanceof $root.SuiSignTx)
            return object;
        var message = new $root.SuiSignTx();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".SuiSignTx.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.raw_tx != null)
            if (typeof object.raw_tx === "string")
                $util.base64.decode(object.raw_tx, message.raw_tx = $util.newBuffer($util.base64.length(object.raw_tx)), 0);
            else if (object.raw_tx.length)
                message.raw_tx = object.raw_tx;
        if (object.data_initial_chunk != null)
            if (typeof object.data_initial_chunk === "string")
                $util.base64.decode(object.data_initial_chunk, message.data_initial_chunk = $util.newBuffer($util.base64.length(object.data_initial_chunk)), 0);
            else if (object.data_initial_chunk.length)
                message.data_initial_chunk = object.data_initial_chunk;
        if (object.data_length != null)
            message.data_length = object.data_length >>> 0;
        return message;
    };

    SuiSignTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            if (options.bytes === String)
                object.raw_tx = "";
            else {
                object.raw_tx = [];
                if (options.bytes !== Array)
                    object.raw_tx = $util.newBuffer(object.raw_tx);
            }
            if (options.bytes === String)
                object.data_initial_chunk = "";
            else {
                object.data_initial_chunk = [];
                if (options.bytes !== Array)
                    object.data_initial_chunk = $util.newBuffer(object.data_initial_chunk);
            }
            object.data_length = 0;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.raw_tx != null && message.hasOwnProperty("raw_tx"))
            object.raw_tx = options.bytes === String ? $util.base64.encode(message.raw_tx, 0, message.raw_tx.length) : options.bytes === Array ? Array.prototype.slice.call(message.raw_tx) : message.raw_tx;
        if (message.data_initial_chunk != null && message.hasOwnProperty("data_initial_chunk"))
            object.data_initial_chunk = options.bytes === String ? $util.base64.encode(message.data_initial_chunk, 0, message.data_initial_chunk.length) : options.bytes === Array ? Array.prototype.slice.call(message.data_initial_chunk) : message.data_initial_chunk;
        if (message.data_length != null && message.hasOwnProperty("data_length"))
            object.data_length = message.data_length;
        return object;
    };

    SuiSignTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SuiSignTx;
})();

$root.SuiSignedTx = (function() {

    function SuiSignedTx(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    SuiSignedTx.prototype.public_key = $util.newBuffer([]);
    SuiSignedTx.prototype.signature = $util.newBuffer([]);

    SuiSignedTx.create = function create(properties) {
        return new SuiSignedTx(properties);
    };

    SuiSignedTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.public_key);
        writer.uint32(18).bytes(message.signature);
        return writer;
    };

    SuiSignedTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    SuiSignedTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SuiSignedTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.public_key = reader.bytes();
                break;
            case 2:
                message.signature = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("public_key"))
            throw $util.ProtocolError("missing required 'public_key'", { instance: message });
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        return message;
    };

    SuiSignedTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    SuiSignedTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.public_key && typeof message.public_key.length === "number" || $util.isString(message.public_key)))
            return "public_key: buffer expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        return null;
    };

    SuiSignedTx.fromObject = function fromObject(object) {
        if (object instanceof $root.SuiSignedTx)
            return object;
        var message = new $root.SuiSignedTx();
        if (object.public_key != null)
            if (typeof object.public_key === "string")
                $util.base64.decode(object.public_key, message.public_key = $util.newBuffer($util.base64.length(object.public_key)), 0);
            else if (object.public_key.length)
                message.public_key = object.public_key;
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        return message;
    };

    SuiSignedTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.public_key = "";
            else {
                object.public_key = [];
                if (options.bytes !== Array)
                    object.public_key = $util.newBuffer(object.public_key);
            }
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
        }
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            object.public_key = options.bytes === String ? $util.base64.encode(message.public_key, 0, message.public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.public_key) : message.public_key;
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        return object;
    };

    SuiSignedTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SuiSignedTx;
})();

$root.SuiTxRequest = (function() {

    function SuiTxRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    SuiTxRequest.prototype.data_length = 0;
    SuiTxRequest.prototype.public_key = $util.newBuffer([]);
    SuiTxRequest.prototype.signature = $util.newBuffer([]);

    SuiTxRequest.create = function create(properties) {
        return new SuiTxRequest(properties);
    };

    SuiTxRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.data_length != null && Object.hasOwnProperty.call(message, "data_length"))
            writer.uint32(8).uint32(message.data_length);
        if (message.public_key != null && Object.hasOwnProperty.call(message, "public_key"))
            writer.uint32(18).bytes(message.public_key);
        if (message.signature != null && Object.hasOwnProperty.call(message, "signature"))
            writer.uint32(26).bytes(message.signature);
        return writer;
    };

    SuiTxRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    SuiTxRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SuiTxRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.data_length = reader.uint32();
                break;
            case 2:
                message.public_key = reader.bytes();
                break;
            case 3:
                message.signature = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    SuiTxRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    SuiTxRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.data_length != null && message.hasOwnProperty("data_length"))
            if (!$util.isInteger(message.data_length))
                return "data_length: integer expected";
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            if (!(message.public_key && typeof message.public_key.length === "number" || $util.isString(message.public_key)))
                return "public_key: buffer expected";
        if (message.signature != null && message.hasOwnProperty("signature"))
            if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
                return "signature: buffer expected";
        return null;
    };

    SuiTxRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.SuiTxRequest)
            return object;
        var message = new $root.SuiTxRequest();
        if (object.data_length != null)
            message.data_length = object.data_length >>> 0;
        if (object.public_key != null)
            if (typeof object.public_key === "string")
                $util.base64.decode(object.public_key, message.public_key = $util.newBuffer($util.base64.length(object.public_key)), 0);
            else if (object.public_key.length)
                message.public_key = object.public_key;
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        return message;
    };

    SuiTxRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.data_length = 0;
            if (options.bytes === String)
                object.public_key = "";
            else {
                object.public_key = [];
                if (options.bytes !== Array)
                    object.public_key = $util.newBuffer(object.public_key);
            }
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
        }
        if (message.data_length != null && message.hasOwnProperty("data_length"))
            object.data_length = message.data_length;
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            object.public_key = options.bytes === String ? $util.base64.encode(message.public_key, 0, message.public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.public_key) : message.public_key;
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        return object;
    };

    SuiTxRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SuiTxRequest;
})();

$root.SuiTxAck = (function() {

    function SuiTxAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    SuiTxAck.prototype.data_chunk = $util.newBuffer([]);

    SuiTxAck.create = function create(properties) {
        return new SuiTxAck(properties);
    };

    SuiTxAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.data_chunk);
        return writer;
    };

    SuiTxAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    SuiTxAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SuiTxAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.data_chunk = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("data_chunk"))
            throw $util.ProtocolError("missing required 'data_chunk'", { instance: message });
        return message;
    };

    SuiTxAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    SuiTxAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.data_chunk && typeof message.data_chunk.length === "number" || $util.isString(message.data_chunk)))
            return "data_chunk: buffer expected";
        return null;
    };

    SuiTxAck.fromObject = function fromObject(object) {
        if (object instanceof $root.SuiTxAck)
            return object;
        var message = new $root.SuiTxAck();
        if (object.data_chunk != null)
            if (typeof object.data_chunk === "string")
                $util.base64.decode(object.data_chunk, message.data_chunk = $util.newBuffer($util.base64.length(object.data_chunk)), 0);
            else if (object.data_chunk.length)
                message.data_chunk = object.data_chunk;
        return message;
    };

    SuiTxAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.data_chunk = "";
            else {
                object.data_chunk = [];
                if (options.bytes !== Array)
                    object.data_chunk = $util.newBuffer(object.data_chunk);
            }
        if (message.data_chunk != null && message.hasOwnProperty("data_chunk"))
            object.data_chunk = options.bytes === String ? $util.base64.encode(message.data_chunk, 0, message.data_chunk.length) : options.bytes === Array ? Array.prototype.slice.call(message.data_chunk) : message.data_chunk;
        return object;
    };

    SuiTxAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SuiTxAck;
})();

$root.SuiSignMessage = (function() {

    function SuiSignMessage(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    SuiSignMessage.prototype.address_n = $util.emptyArray;
    SuiSignMessage.prototype.message = $util.newBuffer([]);

    SuiSignMessage.create = function create(properties) {
        return new SuiSignMessage(properties);
    };

    SuiSignMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).bytes(message.message);
        return writer;
    };

    SuiSignMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    SuiSignMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SuiSignMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.message = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("message"))
            throw $util.ProtocolError("missing required 'message'", { instance: message });
        return message;
    };

    SuiSignMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    SuiSignMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!(message.message && typeof message.message.length === "number" || $util.isString(message.message)))
            return "message: buffer expected";
        return null;
    };

    SuiSignMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.SuiSignMessage)
            return object;
        var message = new $root.SuiSignMessage();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".SuiSignMessage.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.message != null)
            if (typeof object.message === "string")
                $util.base64.decode(object.message, message.message = $util.newBuffer($util.base64.length(object.message)), 0);
            else if (object.message.length)
                message.message = object.message;
        return message;
    };

    SuiSignMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            if (options.bytes === String)
                object.message = "";
            else {
                object.message = [];
                if (options.bytes !== Array)
                    object.message = $util.newBuffer(object.message);
            }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.message != null && message.hasOwnProperty("message"))
            object.message = options.bytes === String ? $util.base64.encode(message.message, 0, message.message.length) : options.bytes === Array ? Array.prototype.slice.call(message.message) : message.message;
        return object;
    };

    SuiSignMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SuiSignMessage;
})();

$root.SuiMessageSignature = (function() {

    function SuiMessageSignature(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    SuiMessageSignature.prototype.signature = $util.newBuffer([]);
    SuiMessageSignature.prototype.address = "";

    SuiMessageSignature.create = function create(properties) {
        return new SuiMessageSignature(properties);
    };

    SuiMessageSignature.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.signature);
        writer.uint32(18).string(message.address);
        return writer;
    };

    SuiMessageSignature.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    SuiMessageSignature.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SuiMessageSignature();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.signature = reader.bytes();
                break;
            case 2:
                message.address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        if (!message.hasOwnProperty("address"))
            throw $util.ProtocolError("missing required 'address'", { instance: message });
        return message;
    };

    SuiMessageSignature.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    SuiMessageSignature.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        if (!$util.isString(message.address))
            return "address: string expected";
        return null;
    };

    SuiMessageSignature.fromObject = function fromObject(object) {
        if (object instanceof $root.SuiMessageSignature)
            return object;
        var message = new $root.SuiMessageSignature();
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        if (object.address != null)
            message.address = String(object.address);
        return message;
    };

    SuiMessageSignature.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
            object.address = "";
        }
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    SuiMessageSignature.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SuiMessageSignature;
})();

$root.TezosGetAddress = (function() {

    function TezosGetAddress(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    TezosGetAddress.prototype.address_n = $util.emptyArray;
    TezosGetAddress.prototype.show_display = false;

    TezosGetAddress.create = function create(properties) {
        return new TezosGetAddress(properties);
    };

    TezosGetAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(16).bool(message.show_display);
        return writer;
    };

    TezosGetAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    TezosGetAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TezosGetAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.show_display = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    TezosGetAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    TezosGetAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        return null;
    };

    TezosGetAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.TezosGetAddress)
            return object;
        var message = new $root.TezosGetAddress();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".TezosGetAddress.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        return message;
    };

    TezosGetAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            object.show_display = false;
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        return object;
    };

    TezosGetAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return TezosGetAddress;
})();

$root.TezosAddress = (function() {

    function TezosAddress(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    TezosAddress.prototype.address = "";

    TezosAddress.create = function create(properties) {
        return new TezosAddress(properties);
    };

    TezosAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.address);
        return writer;
    };

    TezosAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    TezosAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TezosAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("address"))
            throw $util.ProtocolError("missing required 'address'", { instance: message });
        return message;
    };

    TezosAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    TezosAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.address))
            return "address: string expected";
        return null;
    };

    TezosAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.TezosAddress)
            return object;
        var message = new $root.TezosAddress();
        if (object.address != null)
            message.address = String(object.address);
        return message;
    };

    TezosAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.address = "";
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    TezosAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return TezosAddress;
})();

$root.TezosGetPublicKey = (function() {

    function TezosGetPublicKey(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    TezosGetPublicKey.prototype.address_n = $util.emptyArray;
    TezosGetPublicKey.prototype.show_display = false;

    TezosGetPublicKey.create = function create(properties) {
        return new TezosGetPublicKey(properties);
    };

    TezosGetPublicKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(16).bool(message.show_display);
        return writer;
    };

    TezosGetPublicKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    TezosGetPublicKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TezosGetPublicKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.show_display = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    TezosGetPublicKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    TezosGetPublicKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        return null;
    };

    TezosGetPublicKey.fromObject = function fromObject(object) {
        if (object instanceof $root.TezosGetPublicKey)
            return object;
        var message = new $root.TezosGetPublicKey();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".TezosGetPublicKey.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        return message;
    };

    TezosGetPublicKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            object.show_display = false;
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        return object;
    };

    TezosGetPublicKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return TezosGetPublicKey;
})();

$root.TezosPublicKey = (function() {

    function TezosPublicKey(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    TezosPublicKey.prototype.public_key = "";

    TezosPublicKey.create = function create(properties) {
        return new TezosPublicKey(properties);
    };

    TezosPublicKey.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.public_key);
        return writer;
    };

    TezosPublicKey.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    TezosPublicKey.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TezosPublicKey();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.public_key = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("public_key"))
            throw $util.ProtocolError("missing required 'public_key'", { instance: message });
        return message;
    };

    TezosPublicKey.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    TezosPublicKey.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.public_key))
            return "public_key: string expected";
        return null;
    };

    TezosPublicKey.fromObject = function fromObject(object) {
        if (object instanceof $root.TezosPublicKey)
            return object;
        var message = new $root.TezosPublicKey();
        if (object.public_key != null)
            message.public_key = String(object.public_key);
        return message;
    };

    TezosPublicKey.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.public_key = "";
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            object.public_key = message.public_key;
        return object;
    };

    TezosPublicKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return TezosPublicKey;
})();

$root.TezosSignTx = (function() {

    function TezosSignTx(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    TezosSignTx.prototype.address_n = $util.emptyArray;
    TezosSignTx.prototype.branch = $util.newBuffer([]);
    TezosSignTx.prototype.reveal = null;
    TezosSignTx.prototype.transaction = null;
    TezosSignTx.prototype.origination = null;
    TezosSignTx.prototype.delegation = null;
    TezosSignTx.prototype.proposal = null;
    TezosSignTx.prototype.ballot = null;

    TezosSignTx.create = function create(properties) {
        return new TezosSignTx(properties);
    };

    TezosSignTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).bytes(message.branch);
        if (message.reveal != null && Object.hasOwnProperty.call(message, "reveal"))
            $root.TezosSignTx.TezosRevealOp.encode(message.reveal, writer.uint32(26).fork()).ldelim();
        if (message.transaction != null && Object.hasOwnProperty.call(message, "transaction"))
            $root.TezosSignTx.TezosTransactionOp.encode(message.transaction, writer.uint32(34).fork()).ldelim();
        if (message.origination != null && Object.hasOwnProperty.call(message, "origination"))
            $root.TezosSignTx.TezosOriginationOp.encode(message.origination, writer.uint32(42).fork()).ldelim();
        if (message.delegation != null && Object.hasOwnProperty.call(message, "delegation"))
            $root.TezosSignTx.TezosDelegationOp.encode(message.delegation, writer.uint32(50).fork()).ldelim();
        if (message.proposal != null && Object.hasOwnProperty.call(message, "proposal"))
            $root.TezosSignTx.TezosProposalOp.encode(message.proposal, writer.uint32(58).fork()).ldelim();
        if (message.ballot != null && Object.hasOwnProperty.call(message, "ballot"))
            $root.TezosSignTx.TezosBallotOp.encode(message.ballot, writer.uint32(66).fork()).ldelim();
        return writer;
    };

    TezosSignTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    TezosSignTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TezosSignTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.branch = reader.bytes();
                break;
            case 3:
                message.reveal = $root.TezosSignTx.TezosRevealOp.decode(reader, reader.uint32());
                break;
            case 4:
                message.transaction = $root.TezosSignTx.TezosTransactionOp.decode(reader, reader.uint32());
                break;
            case 5:
                message.origination = $root.TezosSignTx.TezosOriginationOp.decode(reader, reader.uint32());
                break;
            case 6:
                message.delegation = $root.TezosSignTx.TezosDelegationOp.decode(reader, reader.uint32());
                break;
            case 7:
                message.proposal = $root.TezosSignTx.TezosProposalOp.decode(reader, reader.uint32());
                break;
            case 8:
                message.ballot = $root.TezosSignTx.TezosBallotOp.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("branch"))
            throw $util.ProtocolError("missing required 'branch'", { instance: message });
        return message;
    };

    TezosSignTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    TezosSignTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!(message.branch && typeof message.branch.length === "number" || $util.isString(message.branch)))
            return "branch: buffer expected";
        if (message.reveal != null && message.hasOwnProperty("reveal")) {
            var error = $root.TezosSignTx.TezosRevealOp.verify(message.reveal);
            if (error)
                return "reveal." + error;
        }
        if (message.transaction != null && message.hasOwnProperty("transaction")) {
            var error = $root.TezosSignTx.TezosTransactionOp.verify(message.transaction);
            if (error)
                return "transaction." + error;
        }
        if (message.origination != null && message.hasOwnProperty("origination")) {
            var error = $root.TezosSignTx.TezosOriginationOp.verify(message.origination);
            if (error)
                return "origination." + error;
        }
        if (message.delegation != null && message.hasOwnProperty("delegation")) {
            var error = $root.TezosSignTx.TezosDelegationOp.verify(message.delegation);
            if (error)
                return "delegation." + error;
        }
        if (message.proposal != null && message.hasOwnProperty("proposal")) {
            var error = $root.TezosSignTx.TezosProposalOp.verify(message.proposal);
            if (error)
                return "proposal." + error;
        }
        if (message.ballot != null && message.hasOwnProperty("ballot")) {
            var error = $root.TezosSignTx.TezosBallotOp.verify(message.ballot);
            if (error)
                return "ballot." + error;
        }
        return null;
    };

    TezosSignTx.fromObject = function fromObject(object) {
        if (object instanceof $root.TezosSignTx)
            return object;
        var message = new $root.TezosSignTx();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".TezosSignTx.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.branch != null)
            if (typeof object.branch === "string")
                $util.base64.decode(object.branch, message.branch = $util.newBuffer($util.base64.length(object.branch)), 0);
            else if (object.branch.length)
                message.branch = object.branch;
        if (object.reveal != null) {
            if (typeof object.reveal !== "object")
                throw TypeError(".TezosSignTx.reveal: object expected");
            message.reveal = $root.TezosSignTx.TezosRevealOp.fromObject(object.reveal);
        }
        if (object.transaction != null) {
            if (typeof object.transaction !== "object")
                throw TypeError(".TezosSignTx.transaction: object expected");
            message.transaction = $root.TezosSignTx.TezosTransactionOp.fromObject(object.transaction);
        }
        if (object.origination != null) {
            if (typeof object.origination !== "object")
                throw TypeError(".TezosSignTx.origination: object expected");
            message.origination = $root.TezosSignTx.TezosOriginationOp.fromObject(object.origination);
        }
        if (object.delegation != null) {
            if (typeof object.delegation !== "object")
                throw TypeError(".TezosSignTx.delegation: object expected");
            message.delegation = $root.TezosSignTx.TezosDelegationOp.fromObject(object.delegation);
        }
        if (object.proposal != null) {
            if (typeof object.proposal !== "object")
                throw TypeError(".TezosSignTx.proposal: object expected");
            message.proposal = $root.TezosSignTx.TezosProposalOp.fromObject(object.proposal);
        }
        if (object.ballot != null) {
            if (typeof object.ballot !== "object")
                throw TypeError(".TezosSignTx.ballot: object expected");
            message.ballot = $root.TezosSignTx.TezosBallotOp.fromObject(object.ballot);
        }
        return message;
    };

    TezosSignTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            if (options.bytes === String)
                object.branch = "";
            else {
                object.branch = [];
                if (options.bytes !== Array)
                    object.branch = $util.newBuffer(object.branch);
            }
            object.reveal = null;
            object.transaction = null;
            object.origination = null;
            object.delegation = null;
            object.proposal = null;
            object.ballot = null;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.branch != null && message.hasOwnProperty("branch"))
            object.branch = options.bytes === String ? $util.base64.encode(message.branch, 0, message.branch.length) : options.bytes === Array ? Array.prototype.slice.call(message.branch) : message.branch;
        if (message.reveal != null && message.hasOwnProperty("reveal"))
            object.reveal = $root.TezosSignTx.TezosRevealOp.toObject(message.reveal, options);
        if (message.transaction != null && message.hasOwnProperty("transaction"))
            object.transaction = $root.TezosSignTx.TezosTransactionOp.toObject(message.transaction, options);
        if (message.origination != null && message.hasOwnProperty("origination"))
            object.origination = $root.TezosSignTx.TezosOriginationOp.toObject(message.origination, options);
        if (message.delegation != null && message.hasOwnProperty("delegation"))
            object.delegation = $root.TezosSignTx.TezosDelegationOp.toObject(message.delegation, options);
        if (message.proposal != null && message.hasOwnProperty("proposal"))
            object.proposal = $root.TezosSignTx.TezosProposalOp.toObject(message.proposal, options);
        if (message.ballot != null && message.hasOwnProperty("ballot"))
            object.ballot = $root.TezosSignTx.TezosBallotOp.toObject(message.ballot, options);
        return object;
    };

    TezosSignTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    TezosSignTx.TezosContractID = (function() {

        function TezosContractID(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        TezosContractID.prototype.tag = 0;
        TezosContractID.prototype.hash = $util.newBuffer([]);

        TezosContractID.create = function create(properties) {
            return new TezosContractID(properties);
        };

        TezosContractID.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(8).int32(message.tag);
            writer.uint32(18).bytes(message.hash);
            return writer;
        };

        TezosContractID.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        TezosContractID.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TezosSignTx.TezosContractID();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.tag = reader.int32();
                    break;
                case 2:
                    message.hash = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("tag"))
                throw $util.ProtocolError("missing required 'tag'", { instance: message });
            if (!message.hasOwnProperty("hash"))
                throw $util.ProtocolError("missing required 'hash'", { instance: message });
            return message;
        };

        TezosContractID.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        TezosContractID.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            switch (message.tag) {
            default:
                return "tag: enum value expected";
            case 0:
            case 1:
                break;
            }
            if (!(message.hash && typeof message.hash.length === "number" || $util.isString(message.hash)))
                return "hash: buffer expected";
            return null;
        };

        TezosContractID.fromObject = function fromObject(object) {
            if (object instanceof $root.TezosSignTx.TezosContractID)
                return object;
            var message = new $root.TezosSignTx.TezosContractID();
            switch (object.tag) {
            case "Implicit":
            case 0:
                message.tag = 0;
                break;
            case "Originated":
            case 1:
                message.tag = 1;
                break;
            }
            if (object.hash != null)
                if (typeof object.hash === "string")
                    $util.base64.decode(object.hash, message.hash = $util.newBuffer($util.base64.length(object.hash)), 0);
                else if (object.hash.length)
                    message.hash = object.hash;
            return message;
        };

        TezosContractID.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.tag = options.enums === String ? "Implicit" : 0;
                if (options.bytes === String)
                    object.hash = "";
                else {
                    object.hash = [];
                    if (options.bytes !== Array)
                        object.hash = $util.newBuffer(object.hash);
                }
            }
            if (message.tag != null && message.hasOwnProperty("tag"))
                object.tag = options.enums === String ? $root.TezosSignTx.TezosContractID.TezosContractType[message.tag] : message.tag;
            if (message.hash != null && message.hasOwnProperty("hash"))
                object.hash = options.bytes === String ? $util.base64.encode(message.hash, 0, message.hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.hash) : message.hash;
            return object;
        };

        TezosContractID.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        TezosContractID.TezosContractType = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "Implicit"] = 0;
            values[valuesById[1] = "Originated"] = 1;
            return values;
        })();

        return TezosContractID;
    })();

    TezosSignTx.TezosRevealOp = (function() {

        function TezosRevealOp(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        TezosRevealOp.prototype.source = $util.newBuffer([]);
        TezosRevealOp.prototype.fee = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        TezosRevealOp.prototype.counter = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        TezosRevealOp.prototype.gas_limit = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        TezosRevealOp.prototype.storage_limit = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        TezosRevealOp.prototype.public_key = $util.newBuffer([]);

        TezosRevealOp.create = function create(properties) {
            return new TezosRevealOp(properties);
        };

        TezosRevealOp.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(16).uint64(message.fee);
            writer.uint32(24).uint64(message.counter);
            writer.uint32(32).uint64(message.gas_limit);
            writer.uint32(40).uint64(message.storage_limit);
            writer.uint32(50).bytes(message.public_key);
            writer.uint32(58).bytes(message.source);
            return writer;
        };

        TezosRevealOp.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        TezosRevealOp.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TezosSignTx.TezosRevealOp();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 7:
                    message.source = reader.bytes();
                    break;
                case 2:
                    message.fee = reader.uint64();
                    break;
                case 3:
                    message.counter = reader.uint64();
                    break;
                case 4:
                    message.gas_limit = reader.uint64();
                    break;
                case 5:
                    message.storage_limit = reader.uint64();
                    break;
                case 6:
                    message.public_key = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("source"))
                throw $util.ProtocolError("missing required 'source'", { instance: message });
            if (!message.hasOwnProperty("fee"))
                throw $util.ProtocolError("missing required 'fee'", { instance: message });
            if (!message.hasOwnProperty("counter"))
                throw $util.ProtocolError("missing required 'counter'", { instance: message });
            if (!message.hasOwnProperty("gas_limit"))
                throw $util.ProtocolError("missing required 'gas_limit'", { instance: message });
            if (!message.hasOwnProperty("storage_limit"))
                throw $util.ProtocolError("missing required 'storage_limit'", { instance: message });
            if (!message.hasOwnProperty("public_key"))
                throw $util.ProtocolError("missing required 'public_key'", { instance: message });
            return message;
        };

        TezosRevealOp.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        TezosRevealOp.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!(message.source && typeof message.source.length === "number" || $util.isString(message.source)))
                return "source: buffer expected";
            if (!$util.isInteger(message.fee) && !(message.fee && $util.isInteger(message.fee.low) && $util.isInteger(message.fee.high)))
                return "fee: integer|Long expected";
            if (!$util.isInteger(message.counter) && !(message.counter && $util.isInteger(message.counter.low) && $util.isInteger(message.counter.high)))
                return "counter: integer|Long expected";
            if (!$util.isInteger(message.gas_limit) && !(message.gas_limit && $util.isInteger(message.gas_limit.low) && $util.isInteger(message.gas_limit.high)))
                return "gas_limit: integer|Long expected";
            if (!$util.isInteger(message.storage_limit) && !(message.storage_limit && $util.isInteger(message.storage_limit.low) && $util.isInteger(message.storage_limit.high)))
                return "storage_limit: integer|Long expected";
            if (!(message.public_key && typeof message.public_key.length === "number" || $util.isString(message.public_key)))
                return "public_key: buffer expected";
            return null;
        };

        TezosRevealOp.fromObject = function fromObject(object) {
            if (object instanceof $root.TezosSignTx.TezosRevealOp)
                return object;
            var message = new $root.TezosSignTx.TezosRevealOp();
            if (object.source != null)
                if (typeof object.source === "string")
                    $util.base64.decode(object.source, message.source = $util.newBuffer($util.base64.length(object.source)), 0);
                else if (object.source.length)
                    message.source = object.source;
            if (object.fee != null)
                if ($util.Long)
                    (message.fee = $util.Long.fromValue(object.fee)).unsigned = true;
                else if (typeof object.fee === "string")
                    message.fee = parseInt(object.fee, 10);
                else if (typeof object.fee === "number")
                    message.fee = object.fee;
                else if (typeof object.fee === "object")
                    message.fee = new $util.LongBits(object.fee.low >>> 0, object.fee.high >>> 0).toNumber(true);
            if (object.counter != null)
                if ($util.Long)
                    (message.counter = $util.Long.fromValue(object.counter)).unsigned = true;
                else if (typeof object.counter === "string")
                    message.counter = parseInt(object.counter, 10);
                else if (typeof object.counter === "number")
                    message.counter = object.counter;
                else if (typeof object.counter === "object")
                    message.counter = new $util.LongBits(object.counter.low >>> 0, object.counter.high >>> 0).toNumber(true);
            if (object.gas_limit != null)
                if ($util.Long)
                    (message.gas_limit = $util.Long.fromValue(object.gas_limit)).unsigned = true;
                else if (typeof object.gas_limit === "string")
                    message.gas_limit = parseInt(object.gas_limit, 10);
                else if (typeof object.gas_limit === "number")
                    message.gas_limit = object.gas_limit;
                else if (typeof object.gas_limit === "object")
                    message.gas_limit = new $util.LongBits(object.gas_limit.low >>> 0, object.gas_limit.high >>> 0).toNumber(true);
            if (object.storage_limit != null)
                if ($util.Long)
                    (message.storage_limit = $util.Long.fromValue(object.storage_limit)).unsigned = true;
                else if (typeof object.storage_limit === "string")
                    message.storage_limit = parseInt(object.storage_limit, 10);
                else if (typeof object.storage_limit === "number")
                    message.storage_limit = object.storage_limit;
                else if (typeof object.storage_limit === "object")
                    message.storage_limit = new $util.LongBits(object.storage_limit.low >>> 0, object.storage_limit.high >>> 0).toNumber(true);
            if (object.public_key != null)
                if (typeof object.public_key === "string")
                    $util.base64.decode(object.public_key, message.public_key = $util.newBuffer($util.base64.length(object.public_key)), 0);
                else if (object.public_key.length)
                    message.public_key = object.public_key;
            return message;
        };

        TezosRevealOp.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.fee = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.fee = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.counter = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.counter = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.gas_limit = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.gas_limit = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.storage_limit = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.storage_limit = options.longs === String ? "0" : 0;
                if (options.bytes === String)
                    object.public_key = "";
                else {
                    object.public_key = [];
                    if (options.bytes !== Array)
                        object.public_key = $util.newBuffer(object.public_key);
                }
                if (options.bytes === String)
                    object.source = "";
                else {
                    object.source = [];
                    if (options.bytes !== Array)
                        object.source = $util.newBuffer(object.source);
                }
            }
            if (message.fee != null && message.hasOwnProperty("fee"))
                if (typeof message.fee === "number")
                    object.fee = options.longs === String ? String(message.fee) : message.fee;
                else
                    object.fee = options.longs === String ? $util.Long.prototype.toString.call(message.fee) : options.longs === Number ? new $util.LongBits(message.fee.low >>> 0, message.fee.high >>> 0).toNumber(true) : message.fee;
            if (message.counter != null && message.hasOwnProperty("counter"))
                if (typeof message.counter === "number")
                    object.counter = options.longs === String ? String(message.counter) : message.counter;
                else
                    object.counter = options.longs === String ? $util.Long.prototype.toString.call(message.counter) : options.longs === Number ? new $util.LongBits(message.counter.low >>> 0, message.counter.high >>> 0).toNumber(true) : message.counter;
            if (message.gas_limit != null && message.hasOwnProperty("gas_limit"))
                if (typeof message.gas_limit === "number")
                    object.gas_limit = options.longs === String ? String(message.gas_limit) : message.gas_limit;
                else
                    object.gas_limit = options.longs === String ? $util.Long.prototype.toString.call(message.gas_limit) : options.longs === Number ? new $util.LongBits(message.gas_limit.low >>> 0, message.gas_limit.high >>> 0).toNumber(true) : message.gas_limit;
            if (message.storage_limit != null && message.hasOwnProperty("storage_limit"))
                if (typeof message.storage_limit === "number")
                    object.storage_limit = options.longs === String ? String(message.storage_limit) : message.storage_limit;
                else
                    object.storage_limit = options.longs === String ? $util.Long.prototype.toString.call(message.storage_limit) : options.longs === Number ? new $util.LongBits(message.storage_limit.low >>> 0, message.storage_limit.high >>> 0).toNumber(true) : message.storage_limit;
            if (message.public_key != null && message.hasOwnProperty("public_key"))
                object.public_key = options.bytes === String ? $util.base64.encode(message.public_key, 0, message.public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.public_key) : message.public_key;
            if (message.source != null && message.hasOwnProperty("source"))
                object.source = options.bytes === String ? $util.base64.encode(message.source, 0, message.source.length) : options.bytes === Array ? Array.prototype.slice.call(message.source) : message.source;
            return object;
        };

        TezosRevealOp.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TezosRevealOp;
    })();

    TezosSignTx.TezosTransactionOp = (function() {

        function TezosTransactionOp(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        TezosTransactionOp.prototype.source = $util.newBuffer([]);
        TezosTransactionOp.prototype.fee = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        TezosTransactionOp.prototype.counter = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        TezosTransactionOp.prototype.gas_limit = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        TezosTransactionOp.prototype.storage_limit = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        TezosTransactionOp.prototype.amount = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        TezosTransactionOp.prototype.destination = null;
        TezosTransactionOp.prototype.parameters = $util.newBuffer([]);
        TezosTransactionOp.prototype.parameters_manager = null;

        TezosTransactionOp.create = function create(properties) {
            return new TezosTransactionOp(properties);
        };

        TezosTransactionOp.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(16).uint64(message.fee);
            writer.uint32(24).uint64(message.counter);
            writer.uint32(32).uint64(message.gas_limit);
            writer.uint32(40).uint64(message.storage_limit);
            writer.uint32(48).uint64(message.amount);
            $root.TezosSignTx.TezosContractID.encode(message.destination, writer.uint32(58).fork()).ldelim();
            if (message.parameters != null && Object.hasOwnProperty.call(message, "parameters"))
                writer.uint32(66).bytes(message.parameters);
            writer.uint32(74).bytes(message.source);
            if (message.parameters_manager != null && Object.hasOwnProperty.call(message, "parameters_manager"))
                $root.TezosSignTx.TezosTransactionOp.TezosParametersManager.encode(message.parameters_manager, writer.uint32(82).fork()).ldelim();
            return writer;
        };

        TezosTransactionOp.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        TezosTransactionOp.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TezosSignTx.TezosTransactionOp();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 9:
                    message.source = reader.bytes();
                    break;
                case 2:
                    message.fee = reader.uint64();
                    break;
                case 3:
                    message.counter = reader.uint64();
                    break;
                case 4:
                    message.gas_limit = reader.uint64();
                    break;
                case 5:
                    message.storage_limit = reader.uint64();
                    break;
                case 6:
                    message.amount = reader.uint64();
                    break;
                case 7:
                    message.destination = $root.TezosSignTx.TezosContractID.decode(reader, reader.uint32());
                    break;
                case 8:
                    message.parameters = reader.bytes();
                    break;
                case 10:
                    message.parameters_manager = $root.TezosSignTx.TezosTransactionOp.TezosParametersManager.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("source"))
                throw $util.ProtocolError("missing required 'source'", { instance: message });
            if (!message.hasOwnProperty("fee"))
                throw $util.ProtocolError("missing required 'fee'", { instance: message });
            if (!message.hasOwnProperty("counter"))
                throw $util.ProtocolError("missing required 'counter'", { instance: message });
            if (!message.hasOwnProperty("gas_limit"))
                throw $util.ProtocolError("missing required 'gas_limit'", { instance: message });
            if (!message.hasOwnProperty("storage_limit"))
                throw $util.ProtocolError("missing required 'storage_limit'", { instance: message });
            if (!message.hasOwnProperty("amount"))
                throw $util.ProtocolError("missing required 'amount'", { instance: message });
            if (!message.hasOwnProperty("destination"))
                throw $util.ProtocolError("missing required 'destination'", { instance: message });
            return message;
        };

        TezosTransactionOp.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        TezosTransactionOp.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!(message.source && typeof message.source.length === "number" || $util.isString(message.source)))
                return "source: buffer expected";
            if (!$util.isInteger(message.fee) && !(message.fee && $util.isInteger(message.fee.low) && $util.isInteger(message.fee.high)))
                return "fee: integer|Long expected";
            if (!$util.isInteger(message.counter) && !(message.counter && $util.isInteger(message.counter.low) && $util.isInteger(message.counter.high)))
                return "counter: integer|Long expected";
            if (!$util.isInteger(message.gas_limit) && !(message.gas_limit && $util.isInteger(message.gas_limit.low) && $util.isInteger(message.gas_limit.high)))
                return "gas_limit: integer|Long expected";
            if (!$util.isInteger(message.storage_limit) && !(message.storage_limit && $util.isInteger(message.storage_limit.low) && $util.isInteger(message.storage_limit.high)))
                return "storage_limit: integer|Long expected";
            if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
                return "amount: integer|Long expected";
            {
                var error = $root.TezosSignTx.TezosContractID.verify(message.destination);
                if (error)
                    return "destination." + error;
            }
            if (message.parameters != null && message.hasOwnProperty("parameters"))
                if (!(message.parameters && typeof message.parameters.length === "number" || $util.isString(message.parameters)))
                    return "parameters: buffer expected";
            if (message.parameters_manager != null && message.hasOwnProperty("parameters_manager")) {
                var error = $root.TezosSignTx.TezosTransactionOp.TezosParametersManager.verify(message.parameters_manager);
                if (error)
                    return "parameters_manager." + error;
            }
            return null;
        };

        TezosTransactionOp.fromObject = function fromObject(object) {
            if (object instanceof $root.TezosSignTx.TezosTransactionOp)
                return object;
            var message = new $root.TezosSignTx.TezosTransactionOp();
            if (object.source != null)
                if (typeof object.source === "string")
                    $util.base64.decode(object.source, message.source = $util.newBuffer($util.base64.length(object.source)), 0);
                else if (object.source.length)
                    message.source = object.source;
            if (object.fee != null)
                if ($util.Long)
                    (message.fee = $util.Long.fromValue(object.fee)).unsigned = true;
                else if (typeof object.fee === "string")
                    message.fee = parseInt(object.fee, 10);
                else if (typeof object.fee === "number")
                    message.fee = object.fee;
                else if (typeof object.fee === "object")
                    message.fee = new $util.LongBits(object.fee.low >>> 0, object.fee.high >>> 0).toNumber(true);
            if (object.counter != null)
                if ($util.Long)
                    (message.counter = $util.Long.fromValue(object.counter)).unsigned = true;
                else if (typeof object.counter === "string")
                    message.counter = parseInt(object.counter, 10);
                else if (typeof object.counter === "number")
                    message.counter = object.counter;
                else if (typeof object.counter === "object")
                    message.counter = new $util.LongBits(object.counter.low >>> 0, object.counter.high >>> 0).toNumber(true);
            if (object.gas_limit != null)
                if ($util.Long)
                    (message.gas_limit = $util.Long.fromValue(object.gas_limit)).unsigned = true;
                else if (typeof object.gas_limit === "string")
                    message.gas_limit = parseInt(object.gas_limit, 10);
                else if (typeof object.gas_limit === "number")
                    message.gas_limit = object.gas_limit;
                else if (typeof object.gas_limit === "object")
                    message.gas_limit = new $util.LongBits(object.gas_limit.low >>> 0, object.gas_limit.high >>> 0).toNumber(true);
            if (object.storage_limit != null)
                if ($util.Long)
                    (message.storage_limit = $util.Long.fromValue(object.storage_limit)).unsigned = true;
                else if (typeof object.storage_limit === "string")
                    message.storage_limit = parseInt(object.storage_limit, 10);
                else if (typeof object.storage_limit === "number")
                    message.storage_limit = object.storage_limit;
                else if (typeof object.storage_limit === "object")
                    message.storage_limit = new $util.LongBits(object.storage_limit.low >>> 0, object.storage_limit.high >>> 0).toNumber(true);
            if (object.amount != null)
                if ($util.Long)
                    (message.amount = $util.Long.fromValue(object.amount)).unsigned = true;
                else if (typeof object.amount === "string")
                    message.amount = parseInt(object.amount, 10);
                else if (typeof object.amount === "number")
                    message.amount = object.amount;
                else if (typeof object.amount === "object")
                    message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber(true);
            if (object.destination != null) {
                if (typeof object.destination !== "object")
                    throw TypeError(".TezosSignTx.TezosTransactionOp.destination: object expected");
                message.destination = $root.TezosSignTx.TezosContractID.fromObject(object.destination);
            }
            if (object.parameters != null)
                if (typeof object.parameters === "string")
                    $util.base64.decode(object.parameters, message.parameters = $util.newBuffer($util.base64.length(object.parameters)), 0);
                else if (object.parameters.length)
                    message.parameters = object.parameters;
            if (object.parameters_manager != null) {
                if (typeof object.parameters_manager !== "object")
                    throw TypeError(".TezosSignTx.TezosTransactionOp.parameters_manager: object expected");
                message.parameters_manager = $root.TezosSignTx.TezosTransactionOp.TezosParametersManager.fromObject(object.parameters_manager);
            }
            return message;
        };

        TezosTransactionOp.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.fee = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.fee = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.counter = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.counter = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.gas_limit = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.gas_limit = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.storage_limit = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.storage_limit = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.amount = options.longs === String ? "0" : 0;
                object.destination = null;
                if (options.bytes === String)
                    object.parameters = "";
                else {
                    object.parameters = [];
                    if (options.bytes !== Array)
                        object.parameters = $util.newBuffer(object.parameters);
                }
                if (options.bytes === String)
                    object.source = "";
                else {
                    object.source = [];
                    if (options.bytes !== Array)
                        object.source = $util.newBuffer(object.source);
                }
                object.parameters_manager = null;
            }
            if (message.fee != null && message.hasOwnProperty("fee"))
                if (typeof message.fee === "number")
                    object.fee = options.longs === String ? String(message.fee) : message.fee;
                else
                    object.fee = options.longs === String ? $util.Long.prototype.toString.call(message.fee) : options.longs === Number ? new $util.LongBits(message.fee.low >>> 0, message.fee.high >>> 0).toNumber(true) : message.fee;
            if (message.counter != null && message.hasOwnProperty("counter"))
                if (typeof message.counter === "number")
                    object.counter = options.longs === String ? String(message.counter) : message.counter;
                else
                    object.counter = options.longs === String ? $util.Long.prototype.toString.call(message.counter) : options.longs === Number ? new $util.LongBits(message.counter.low >>> 0, message.counter.high >>> 0).toNumber(true) : message.counter;
            if (message.gas_limit != null && message.hasOwnProperty("gas_limit"))
                if (typeof message.gas_limit === "number")
                    object.gas_limit = options.longs === String ? String(message.gas_limit) : message.gas_limit;
                else
                    object.gas_limit = options.longs === String ? $util.Long.prototype.toString.call(message.gas_limit) : options.longs === Number ? new $util.LongBits(message.gas_limit.low >>> 0, message.gas_limit.high >>> 0).toNumber(true) : message.gas_limit;
            if (message.storage_limit != null && message.hasOwnProperty("storage_limit"))
                if (typeof message.storage_limit === "number")
                    object.storage_limit = options.longs === String ? String(message.storage_limit) : message.storage_limit;
                else
                    object.storage_limit = options.longs === String ? $util.Long.prototype.toString.call(message.storage_limit) : options.longs === Number ? new $util.LongBits(message.storage_limit.low >>> 0, message.storage_limit.high >>> 0).toNumber(true) : message.storage_limit;
            if (message.amount != null && message.hasOwnProperty("amount"))
                if (typeof message.amount === "number")
                    object.amount = options.longs === String ? String(message.amount) : message.amount;
                else
                    object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber(true) : message.amount;
            if (message.destination != null && message.hasOwnProperty("destination"))
                object.destination = $root.TezosSignTx.TezosContractID.toObject(message.destination, options);
            if (message.parameters != null && message.hasOwnProperty("parameters"))
                object.parameters = options.bytes === String ? $util.base64.encode(message.parameters, 0, message.parameters.length) : options.bytes === Array ? Array.prototype.slice.call(message.parameters) : message.parameters;
            if (message.source != null && message.hasOwnProperty("source"))
                object.source = options.bytes === String ? $util.base64.encode(message.source, 0, message.source.length) : options.bytes === Array ? Array.prototype.slice.call(message.source) : message.source;
            if (message.parameters_manager != null && message.hasOwnProperty("parameters_manager"))
                object.parameters_manager = $root.TezosSignTx.TezosTransactionOp.TezosParametersManager.toObject(message.parameters_manager, options);
            return object;
        };

        TezosTransactionOp.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        TezosTransactionOp.TezosParametersManager = (function() {

            function TezosParametersManager(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            TezosParametersManager.prototype.set_delegate = $util.newBuffer([]);
            TezosParametersManager.prototype.cancel_delegate = false;
            TezosParametersManager.prototype.transfer = null;

            TezosParametersManager.create = function create(properties) {
                return new TezosParametersManager(properties);
            };

            TezosParametersManager.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.set_delegate != null && Object.hasOwnProperty.call(message, "set_delegate"))
                    writer.uint32(10).bytes(message.set_delegate);
                if (message.cancel_delegate != null && Object.hasOwnProperty.call(message, "cancel_delegate"))
                    writer.uint32(16).bool(message.cancel_delegate);
                if (message.transfer != null && Object.hasOwnProperty.call(message, "transfer"))
                    $root.TezosSignTx.TezosTransactionOp.TezosParametersManager.TezosManagerTransfer.encode(message.transfer, writer.uint32(26).fork()).ldelim();
                return writer;
            };

            TezosParametersManager.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            TezosParametersManager.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TezosSignTx.TezosTransactionOp.TezosParametersManager();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.set_delegate = reader.bytes();
                        break;
                    case 2:
                        message.cancel_delegate = reader.bool();
                        break;
                    case 3:
                        message.transfer = $root.TezosSignTx.TezosTransactionOp.TezosParametersManager.TezosManagerTransfer.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            TezosParametersManager.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            TezosParametersManager.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.set_delegate != null && message.hasOwnProperty("set_delegate"))
                    if (!(message.set_delegate && typeof message.set_delegate.length === "number" || $util.isString(message.set_delegate)))
                        return "set_delegate: buffer expected";
                if (message.cancel_delegate != null && message.hasOwnProperty("cancel_delegate"))
                    if (typeof message.cancel_delegate !== "boolean")
                        return "cancel_delegate: boolean expected";
                if (message.transfer != null && message.hasOwnProperty("transfer")) {
                    var error = $root.TezosSignTx.TezosTransactionOp.TezosParametersManager.TezosManagerTransfer.verify(message.transfer);
                    if (error)
                        return "transfer." + error;
                }
                return null;
            };

            TezosParametersManager.fromObject = function fromObject(object) {
                if (object instanceof $root.TezosSignTx.TezosTransactionOp.TezosParametersManager)
                    return object;
                var message = new $root.TezosSignTx.TezosTransactionOp.TezosParametersManager();
                if (object.set_delegate != null)
                    if (typeof object.set_delegate === "string")
                        $util.base64.decode(object.set_delegate, message.set_delegate = $util.newBuffer($util.base64.length(object.set_delegate)), 0);
                    else if (object.set_delegate.length)
                        message.set_delegate = object.set_delegate;
                if (object.cancel_delegate != null)
                    message.cancel_delegate = Boolean(object.cancel_delegate);
                if (object.transfer != null) {
                    if (typeof object.transfer !== "object")
                        throw TypeError(".TezosSignTx.TezosTransactionOp.TezosParametersManager.transfer: object expected");
                    message.transfer = $root.TezosSignTx.TezosTransactionOp.TezosParametersManager.TezosManagerTransfer.fromObject(object.transfer);
                }
                return message;
            };

            TezosParametersManager.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    if (options.bytes === String)
                        object.set_delegate = "";
                    else {
                        object.set_delegate = [];
                        if (options.bytes !== Array)
                            object.set_delegate = $util.newBuffer(object.set_delegate);
                    }
                    object.cancel_delegate = false;
                    object.transfer = null;
                }
                if (message.set_delegate != null && message.hasOwnProperty("set_delegate"))
                    object.set_delegate = options.bytes === String ? $util.base64.encode(message.set_delegate, 0, message.set_delegate.length) : options.bytes === Array ? Array.prototype.slice.call(message.set_delegate) : message.set_delegate;
                if (message.cancel_delegate != null && message.hasOwnProperty("cancel_delegate"))
                    object.cancel_delegate = message.cancel_delegate;
                if (message.transfer != null && message.hasOwnProperty("transfer"))
                    object.transfer = $root.TezosSignTx.TezosTransactionOp.TezosParametersManager.TezosManagerTransfer.toObject(message.transfer, options);
                return object;
            };

            TezosParametersManager.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            TezosParametersManager.TezosManagerTransfer = (function() {

                function TezosManagerTransfer(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                TezosManagerTransfer.prototype.destination = null;
                TezosManagerTransfer.prototype.amount = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

                TezosManagerTransfer.create = function create(properties) {
                    return new TezosManagerTransfer(properties);
                };

                TezosManagerTransfer.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    $root.TezosSignTx.TezosContractID.encode(message.destination, writer.uint32(10).fork()).ldelim();
                    writer.uint32(16).uint64(message.amount);
                    return writer;
                };

                TezosManagerTransfer.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                TezosManagerTransfer.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TezosSignTx.TezosTransactionOp.TezosParametersManager.TezosManagerTransfer();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.destination = $root.TezosSignTx.TezosContractID.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.amount = reader.uint64();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    if (!message.hasOwnProperty("destination"))
                        throw $util.ProtocolError("missing required 'destination'", { instance: message });
                    if (!message.hasOwnProperty("amount"))
                        throw $util.ProtocolError("missing required 'amount'", { instance: message });
                    return message;
                };

                TezosManagerTransfer.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                TezosManagerTransfer.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    {
                        var error = $root.TezosSignTx.TezosContractID.verify(message.destination);
                        if (error)
                            return "destination." + error;
                    }
                    if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
                        return "amount: integer|Long expected";
                    return null;
                };

                TezosManagerTransfer.fromObject = function fromObject(object) {
                    if (object instanceof $root.TezosSignTx.TezosTransactionOp.TezosParametersManager.TezosManagerTransfer)
                        return object;
                    var message = new $root.TezosSignTx.TezosTransactionOp.TezosParametersManager.TezosManagerTransfer();
                    if (object.destination != null) {
                        if (typeof object.destination !== "object")
                            throw TypeError(".TezosSignTx.TezosTransactionOp.TezosParametersManager.TezosManagerTransfer.destination: object expected");
                        message.destination = $root.TezosSignTx.TezosContractID.fromObject(object.destination);
                    }
                    if (object.amount != null)
                        if ($util.Long)
                            (message.amount = $util.Long.fromValue(object.amount)).unsigned = true;
                        else if (typeof object.amount === "string")
                            message.amount = parseInt(object.amount, 10);
                        else if (typeof object.amount === "number")
                            message.amount = object.amount;
                        else if (typeof object.amount === "object")
                            message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber(true);
                    return message;
                };

                TezosManagerTransfer.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.destination = null;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, true);
                            object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.amount = options.longs === String ? "0" : 0;
                    }
                    if (message.destination != null && message.hasOwnProperty("destination"))
                        object.destination = $root.TezosSignTx.TezosContractID.toObject(message.destination, options);
                    if (message.amount != null && message.hasOwnProperty("amount"))
                        if (typeof message.amount === "number")
                            object.amount = options.longs === String ? String(message.amount) : message.amount;
                        else
                            object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber(true) : message.amount;
                    return object;
                };

                TezosManagerTransfer.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return TezosManagerTransfer;
            })();

            return TezosParametersManager;
        })();

        return TezosTransactionOp;
    })();

    TezosSignTx.TezosOriginationOp = (function() {

        function TezosOriginationOp(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        TezosOriginationOp.prototype.source = $util.newBuffer([]);
        TezosOriginationOp.prototype.fee = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        TezosOriginationOp.prototype.counter = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        TezosOriginationOp.prototype.gas_limit = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        TezosOriginationOp.prototype.storage_limit = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        TezosOriginationOp.prototype.manager_pubkey = $util.newBuffer([]);
        TezosOriginationOp.prototype.balance = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        TezosOriginationOp.prototype.spendable = false;
        TezosOriginationOp.prototype.delegatable = false;
        TezosOriginationOp.prototype.delegate = $util.newBuffer([]);
        TezosOriginationOp.prototype.script = $util.newBuffer([]);

        TezosOriginationOp.create = function create(properties) {
            return new TezosOriginationOp(properties);
        };

        TezosOriginationOp.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(16).uint64(message.fee);
            writer.uint32(24).uint64(message.counter);
            writer.uint32(32).uint64(message.gas_limit);
            writer.uint32(40).uint64(message.storage_limit);
            if (message.manager_pubkey != null && Object.hasOwnProperty.call(message, "manager_pubkey"))
                writer.uint32(50).bytes(message.manager_pubkey);
            writer.uint32(56).uint64(message.balance);
            if (message.spendable != null && Object.hasOwnProperty.call(message, "spendable"))
                writer.uint32(64).bool(message.spendable);
            if (message.delegatable != null && Object.hasOwnProperty.call(message, "delegatable"))
                writer.uint32(72).bool(message.delegatable);
            if (message.delegate != null && Object.hasOwnProperty.call(message, "delegate"))
                writer.uint32(82).bytes(message.delegate);
            writer.uint32(90).bytes(message.script);
            writer.uint32(98).bytes(message.source);
            return writer;
        };

        TezosOriginationOp.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        TezosOriginationOp.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TezosSignTx.TezosOriginationOp();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 12:
                    message.source = reader.bytes();
                    break;
                case 2:
                    message.fee = reader.uint64();
                    break;
                case 3:
                    message.counter = reader.uint64();
                    break;
                case 4:
                    message.gas_limit = reader.uint64();
                    break;
                case 5:
                    message.storage_limit = reader.uint64();
                    break;
                case 6:
                    message.manager_pubkey = reader.bytes();
                    break;
                case 7:
                    message.balance = reader.uint64();
                    break;
                case 8:
                    message.spendable = reader.bool();
                    break;
                case 9:
                    message.delegatable = reader.bool();
                    break;
                case 10:
                    message.delegate = reader.bytes();
                    break;
                case 11:
                    message.script = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("source"))
                throw $util.ProtocolError("missing required 'source'", { instance: message });
            if (!message.hasOwnProperty("fee"))
                throw $util.ProtocolError("missing required 'fee'", { instance: message });
            if (!message.hasOwnProperty("counter"))
                throw $util.ProtocolError("missing required 'counter'", { instance: message });
            if (!message.hasOwnProperty("gas_limit"))
                throw $util.ProtocolError("missing required 'gas_limit'", { instance: message });
            if (!message.hasOwnProperty("storage_limit"))
                throw $util.ProtocolError("missing required 'storage_limit'", { instance: message });
            if (!message.hasOwnProperty("balance"))
                throw $util.ProtocolError("missing required 'balance'", { instance: message });
            if (!message.hasOwnProperty("script"))
                throw $util.ProtocolError("missing required 'script'", { instance: message });
            return message;
        };

        TezosOriginationOp.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        TezosOriginationOp.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!(message.source && typeof message.source.length === "number" || $util.isString(message.source)))
                return "source: buffer expected";
            if (!$util.isInteger(message.fee) && !(message.fee && $util.isInteger(message.fee.low) && $util.isInteger(message.fee.high)))
                return "fee: integer|Long expected";
            if (!$util.isInteger(message.counter) && !(message.counter && $util.isInteger(message.counter.low) && $util.isInteger(message.counter.high)))
                return "counter: integer|Long expected";
            if (!$util.isInteger(message.gas_limit) && !(message.gas_limit && $util.isInteger(message.gas_limit.low) && $util.isInteger(message.gas_limit.high)))
                return "gas_limit: integer|Long expected";
            if (!$util.isInteger(message.storage_limit) && !(message.storage_limit && $util.isInteger(message.storage_limit.low) && $util.isInteger(message.storage_limit.high)))
                return "storage_limit: integer|Long expected";
            if (message.manager_pubkey != null && message.hasOwnProperty("manager_pubkey"))
                if (!(message.manager_pubkey && typeof message.manager_pubkey.length === "number" || $util.isString(message.manager_pubkey)))
                    return "manager_pubkey: buffer expected";
            if (!$util.isInteger(message.balance) && !(message.balance && $util.isInteger(message.balance.low) && $util.isInteger(message.balance.high)))
                return "balance: integer|Long expected";
            if (message.spendable != null && message.hasOwnProperty("spendable"))
                if (typeof message.spendable !== "boolean")
                    return "spendable: boolean expected";
            if (message.delegatable != null && message.hasOwnProperty("delegatable"))
                if (typeof message.delegatable !== "boolean")
                    return "delegatable: boolean expected";
            if (message.delegate != null && message.hasOwnProperty("delegate"))
                if (!(message.delegate && typeof message.delegate.length === "number" || $util.isString(message.delegate)))
                    return "delegate: buffer expected";
            if (!(message.script && typeof message.script.length === "number" || $util.isString(message.script)))
                return "script: buffer expected";
            return null;
        };

        TezosOriginationOp.fromObject = function fromObject(object) {
            if (object instanceof $root.TezosSignTx.TezosOriginationOp)
                return object;
            var message = new $root.TezosSignTx.TezosOriginationOp();
            if (object.source != null)
                if (typeof object.source === "string")
                    $util.base64.decode(object.source, message.source = $util.newBuffer($util.base64.length(object.source)), 0);
                else if (object.source.length)
                    message.source = object.source;
            if (object.fee != null)
                if ($util.Long)
                    (message.fee = $util.Long.fromValue(object.fee)).unsigned = true;
                else if (typeof object.fee === "string")
                    message.fee = parseInt(object.fee, 10);
                else if (typeof object.fee === "number")
                    message.fee = object.fee;
                else if (typeof object.fee === "object")
                    message.fee = new $util.LongBits(object.fee.low >>> 0, object.fee.high >>> 0).toNumber(true);
            if (object.counter != null)
                if ($util.Long)
                    (message.counter = $util.Long.fromValue(object.counter)).unsigned = true;
                else if (typeof object.counter === "string")
                    message.counter = parseInt(object.counter, 10);
                else if (typeof object.counter === "number")
                    message.counter = object.counter;
                else if (typeof object.counter === "object")
                    message.counter = new $util.LongBits(object.counter.low >>> 0, object.counter.high >>> 0).toNumber(true);
            if (object.gas_limit != null)
                if ($util.Long)
                    (message.gas_limit = $util.Long.fromValue(object.gas_limit)).unsigned = true;
                else if (typeof object.gas_limit === "string")
                    message.gas_limit = parseInt(object.gas_limit, 10);
                else if (typeof object.gas_limit === "number")
                    message.gas_limit = object.gas_limit;
                else if (typeof object.gas_limit === "object")
                    message.gas_limit = new $util.LongBits(object.gas_limit.low >>> 0, object.gas_limit.high >>> 0).toNumber(true);
            if (object.storage_limit != null)
                if ($util.Long)
                    (message.storage_limit = $util.Long.fromValue(object.storage_limit)).unsigned = true;
                else if (typeof object.storage_limit === "string")
                    message.storage_limit = parseInt(object.storage_limit, 10);
                else if (typeof object.storage_limit === "number")
                    message.storage_limit = object.storage_limit;
                else if (typeof object.storage_limit === "object")
                    message.storage_limit = new $util.LongBits(object.storage_limit.low >>> 0, object.storage_limit.high >>> 0).toNumber(true);
            if (object.manager_pubkey != null)
                if (typeof object.manager_pubkey === "string")
                    $util.base64.decode(object.manager_pubkey, message.manager_pubkey = $util.newBuffer($util.base64.length(object.manager_pubkey)), 0);
                else if (object.manager_pubkey.length)
                    message.manager_pubkey = object.manager_pubkey;
            if (object.balance != null)
                if ($util.Long)
                    (message.balance = $util.Long.fromValue(object.balance)).unsigned = true;
                else if (typeof object.balance === "string")
                    message.balance = parseInt(object.balance, 10);
                else if (typeof object.balance === "number")
                    message.balance = object.balance;
                else if (typeof object.balance === "object")
                    message.balance = new $util.LongBits(object.balance.low >>> 0, object.balance.high >>> 0).toNumber(true);
            if (object.spendable != null)
                message.spendable = Boolean(object.spendable);
            if (object.delegatable != null)
                message.delegatable = Boolean(object.delegatable);
            if (object.delegate != null)
                if (typeof object.delegate === "string")
                    $util.base64.decode(object.delegate, message.delegate = $util.newBuffer($util.base64.length(object.delegate)), 0);
                else if (object.delegate.length)
                    message.delegate = object.delegate;
            if (object.script != null)
                if (typeof object.script === "string")
                    $util.base64.decode(object.script, message.script = $util.newBuffer($util.base64.length(object.script)), 0);
                else if (object.script.length)
                    message.script = object.script;
            return message;
        };

        TezosOriginationOp.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.fee = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.fee = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.counter = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.counter = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.gas_limit = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.gas_limit = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.storage_limit = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.storage_limit = options.longs === String ? "0" : 0;
                if (options.bytes === String)
                    object.manager_pubkey = "";
                else {
                    object.manager_pubkey = [];
                    if (options.bytes !== Array)
                        object.manager_pubkey = $util.newBuffer(object.manager_pubkey);
                }
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.balance = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.balance = options.longs === String ? "0" : 0;
                object.spendable = false;
                object.delegatable = false;
                if (options.bytes === String)
                    object.delegate = "";
                else {
                    object.delegate = [];
                    if (options.bytes !== Array)
                        object.delegate = $util.newBuffer(object.delegate);
                }
                if (options.bytes === String)
                    object.script = "";
                else {
                    object.script = [];
                    if (options.bytes !== Array)
                        object.script = $util.newBuffer(object.script);
                }
                if (options.bytes === String)
                    object.source = "";
                else {
                    object.source = [];
                    if (options.bytes !== Array)
                        object.source = $util.newBuffer(object.source);
                }
            }
            if (message.fee != null && message.hasOwnProperty("fee"))
                if (typeof message.fee === "number")
                    object.fee = options.longs === String ? String(message.fee) : message.fee;
                else
                    object.fee = options.longs === String ? $util.Long.prototype.toString.call(message.fee) : options.longs === Number ? new $util.LongBits(message.fee.low >>> 0, message.fee.high >>> 0).toNumber(true) : message.fee;
            if (message.counter != null && message.hasOwnProperty("counter"))
                if (typeof message.counter === "number")
                    object.counter = options.longs === String ? String(message.counter) : message.counter;
                else
                    object.counter = options.longs === String ? $util.Long.prototype.toString.call(message.counter) : options.longs === Number ? new $util.LongBits(message.counter.low >>> 0, message.counter.high >>> 0).toNumber(true) : message.counter;
            if (message.gas_limit != null && message.hasOwnProperty("gas_limit"))
                if (typeof message.gas_limit === "number")
                    object.gas_limit = options.longs === String ? String(message.gas_limit) : message.gas_limit;
                else
                    object.gas_limit = options.longs === String ? $util.Long.prototype.toString.call(message.gas_limit) : options.longs === Number ? new $util.LongBits(message.gas_limit.low >>> 0, message.gas_limit.high >>> 0).toNumber(true) : message.gas_limit;
            if (message.storage_limit != null && message.hasOwnProperty("storage_limit"))
                if (typeof message.storage_limit === "number")
                    object.storage_limit = options.longs === String ? String(message.storage_limit) : message.storage_limit;
                else
                    object.storage_limit = options.longs === String ? $util.Long.prototype.toString.call(message.storage_limit) : options.longs === Number ? new $util.LongBits(message.storage_limit.low >>> 0, message.storage_limit.high >>> 0).toNumber(true) : message.storage_limit;
            if (message.manager_pubkey != null && message.hasOwnProperty("manager_pubkey"))
                object.manager_pubkey = options.bytes === String ? $util.base64.encode(message.manager_pubkey, 0, message.manager_pubkey.length) : options.bytes === Array ? Array.prototype.slice.call(message.manager_pubkey) : message.manager_pubkey;
            if (message.balance != null && message.hasOwnProperty("balance"))
                if (typeof message.balance === "number")
                    object.balance = options.longs === String ? String(message.balance) : message.balance;
                else
                    object.balance = options.longs === String ? $util.Long.prototype.toString.call(message.balance) : options.longs === Number ? new $util.LongBits(message.balance.low >>> 0, message.balance.high >>> 0).toNumber(true) : message.balance;
            if (message.spendable != null && message.hasOwnProperty("spendable"))
                object.spendable = message.spendable;
            if (message.delegatable != null && message.hasOwnProperty("delegatable"))
                object.delegatable = message.delegatable;
            if (message.delegate != null && message.hasOwnProperty("delegate"))
                object.delegate = options.bytes === String ? $util.base64.encode(message.delegate, 0, message.delegate.length) : options.bytes === Array ? Array.prototype.slice.call(message.delegate) : message.delegate;
            if (message.script != null && message.hasOwnProperty("script"))
                object.script = options.bytes === String ? $util.base64.encode(message.script, 0, message.script.length) : options.bytes === Array ? Array.prototype.slice.call(message.script) : message.script;
            if (message.source != null && message.hasOwnProperty("source"))
                object.source = options.bytes === String ? $util.base64.encode(message.source, 0, message.source.length) : options.bytes === Array ? Array.prototype.slice.call(message.source) : message.source;
            return object;
        };

        TezosOriginationOp.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TezosOriginationOp;
    })();

    TezosSignTx.TezosDelegationOp = (function() {

        function TezosDelegationOp(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        TezosDelegationOp.prototype.source = $util.newBuffer([]);
        TezosDelegationOp.prototype.fee = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        TezosDelegationOp.prototype.counter = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        TezosDelegationOp.prototype.gas_limit = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        TezosDelegationOp.prototype.storage_limit = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        TezosDelegationOp.prototype.delegate = $util.newBuffer([]);

        TezosDelegationOp.create = function create(properties) {
            return new TezosDelegationOp(properties);
        };

        TezosDelegationOp.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(16).uint64(message.fee);
            writer.uint32(24).uint64(message.counter);
            writer.uint32(32).uint64(message.gas_limit);
            writer.uint32(40).uint64(message.storage_limit);
            writer.uint32(50).bytes(message.delegate);
            writer.uint32(58).bytes(message.source);
            return writer;
        };

        TezosDelegationOp.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        TezosDelegationOp.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TezosSignTx.TezosDelegationOp();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 7:
                    message.source = reader.bytes();
                    break;
                case 2:
                    message.fee = reader.uint64();
                    break;
                case 3:
                    message.counter = reader.uint64();
                    break;
                case 4:
                    message.gas_limit = reader.uint64();
                    break;
                case 5:
                    message.storage_limit = reader.uint64();
                    break;
                case 6:
                    message.delegate = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("source"))
                throw $util.ProtocolError("missing required 'source'", { instance: message });
            if (!message.hasOwnProperty("fee"))
                throw $util.ProtocolError("missing required 'fee'", { instance: message });
            if (!message.hasOwnProperty("counter"))
                throw $util.ProtocolError("missing required 'counter'", { instance: message });
            if (!message.hasOwnProperty("gas_limit"))
                throw $util.ProtocolError("missing required 'gas_limit'", { instance: message });
            if (!message.hasOwnProperty("storage_limit"))
                throw $util.ProtocolError("missing required 'storage_limit'", { instance: message });
            if (!message.hasOwnProperty("delegate"))
                throw $util.ProtocolError("missing required 'delegate'", { instance: message });
            return message;
        };

        TezosDelegationOp.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        TezosDelegationOp.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!(message.source && typeof message.source.length === "number" || $util.isString(message.source)))
                return "source: buffer expected";
            if (!$util.isInteger(message.fee) && !(message.fee && $util.isInteger(message.fee.low) && $util.isInteger(message.fee.high)))
                return "fee: integer|Long expected";
            if (!$util.isInteger(message.counter) && !(message.counter && $util.isInteger(message.counter.low) && $util.isInteger(message.counter.high)))
                return "counter: integer|Long expected";
            if (!$util.isInteger(message.gas_limit) && !(message.gas_limit && $util.isInteger(message.gas_limit.low) && $util.isInteger(message.gas_limit.high)))
                return "gas_limit: integer|Long expected";
            if (!$util.isInteger(message.storage_limit) && !(message.storage_limit && $util.isInteger(message.storage_limit.low) && $util.isInteger(message.storage_limit.high)))
                return "storage_limit: integer|Long expected";
            if (!(message.delegate && typeof message.delegate.length === "number" || $util.isString(message.delegate)))
                return "delegate: buffer expected";
            return null;
        };

        TezosDelegationOp.fromObject = function fromObject(object) {
            if (object instanceof $root.TezosSignTx.TezosDelegationOp)
                return object;
            var message = new $root.TezosSignTx.TezosDelegationOp();
            if (object.source != null)
                if (typeof object.source === "string")
                    $util.base64.decode(object.source, message.source = $util.newBuffer($util.base64.length(object.source)), 0);
                else if (object.source.length)
                    message.source = object.source;
            if (object.fee != null)
                if ($util.Long)
                    (message.fee = $util.Long.fromValue(object.fee)).unsigned = true;
                else if (typeof object.fee === "string")
                    message.fee = parseInt(object.fee, 10);
                else if (typeof object.fee === "number")
                    message.fee = object.fee;
                else if (typeof object.fee === "object")
                    message.fee = new $util.LongBits(object.fee.low >>> 0, object.fee.high >>> 0).toNumber(true);
            if (object.counter != null)
                if ($util.Long)
                    (message.counter = $util.Long.fromValue(object.counter)).unsigned = true;
                else if (typeof object.counter === "string")
                    message.counter = parseInt(object.counter, 10);
                else if (typeof object.counter === "number")
                    message.counter = object.counter;
                else if (typeof object.counter === "object")
                    message.counter = new $util.LongBits(object.counter.low >>> 0, object.counter.high >>> 0).toNumber(true);
            if (object.gas_limit != null)
                if ($util.Long)
                    (message.gas_limit = $util.Long.fromValue(object.gas_limit)).unsigned = true;
                else if (typeof object.gas_limit === "string")
                    message.gas_limit = parseInt(object.gas_limit, 10);
                else if (typeof object.gas_limit === "number")
                    message.gas_limit = object.gas_limit;
                else if (typeof object.gas_limit === "object")
                    message.gas_limit = new $util.LongBits(object.gas_limit.low >>> 0, object.gas_limit.high >>> 0).toNumber(true);
            if (object.storage_limit != null)
                if ($util.Long)
                    (message.storage_limit = $util.Long.fromValue(object.storage_limit)).unsigned = true;
                else if (typeof object.storage_limit === "string")
                    message.storage_limit = parseInt(object.storage_limit, 10);
                else if (typeof object.storage_limit === "number")
                    message.storage_limit = object.storage_limit;
                else if (typeof object.storage_limit === "object")
                    message.storage_limit = new $util.LongBits(object.storage_limit.low >>> 0, object.storage_limit.high >>> 0).toNumber(true);
            if (object.delegate != null)
                if (typeof object.delegate === "string")
                    $util.base64.decode(object.delegate, message.delegate = $util.newBuffer($util.base64.length(object.delegate)), 0);
                else if (object.delegate.length)
                    message.delegate = object.delegate;
            return message;
        };

        TezosDelegationOp.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.fee = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.fee = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.counter = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.counter = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.gas_limit = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.gas_limit = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.storage_limit = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.storage_limit = options.longs === String ? "0" : 0;
                if (options.bytes === String)
                    object.delegate = "";
                else {
                    object.delegate = [];
                    if (options.bytes !== Array)
                        object.delegate = $util.newBuffer(object.delegate);
                }
                if (options.bytes === String)
                    object.source = "";
                else {
                    object.source = [];
                    if (options.bytes !== Array)
                        object.source = $util.newBuffer(object.source);
                }
            }
            if (message.fee != null && message.hasOwnProperty("fee"))
                if (typeof message.fee === "number")
                    object.fee = options.longs === String ? String(message.fee) : message.fee;
                else
                    object.fee = options.longs === String ? $util.Long.prototype.toString.call(message.fee) : options.longs === Number ? new $util.LongBits(message.fee.low >>> 0, message.fee.high >>> 0).toNumber(true) : message.fee;
            if (message.counter != null && message.hasOwnProperty("counter"))
                if (typeof message.counter === "number")
                    object.counter = options.longs === String ? String(message.counter) : message.counter;
                else
                    object.counter = options.longs === String ? $util.Long.prototype.toString.call(message.counter) : options.longs === Number ? new $util.LongBits(message.counter.low >>> 0, message.counter.high >>> 0).toNumber(true) : message.counter;
            if (message.gas_limit != null && message.hasOwnProperty("gas_limit"))
                if (typeof message.gas_limit === "number")
                    object.gas_limit = options.longs === String ? String(message.gas_limit) : message.gas_limit;
                else
                    object.gas_limit = options.longs === String ? $util.Long.prototype.toString.call(message.gas_limit) : options.longs === Number ? new $util.LongBits(message.gas_limit.low >>> 0, message.gas_limit.high >>> 0).toNumber(true) : message.gas_limit;
            if (message.storage_limit != null && message.hasOwnProperty("storage_limit"))
                if (typeof message.storage_limit === "number")
                    object.storage_limit = options.longs === String ? String(message.storage_limit) : message.storage_limit;
                else
                    object.storage_limit = options.longs === String ? $util.Long.prototype.toString.call(message.storage_limit) : options.longs === Number ? new $util.LongBits(message.storage_limit.low >>> 0, message.storage_limit.high >>> 0).toNumber(true) : message.storage_limit;
            if (message.delegate != null && message.hasOwnProperty("delegate"))
                object.delegate = options.bytes === String ? $util.base64.encode(message.delegate, 0, message.delegate.length) : options.bytes === Array ? Array.prototype.slice.call(message.delegate) : message.delegate;
            if (message.source != null && message.hasOwnProperty("source"))
                object.source = options.bytes === String ? $util.base64.encode(message.source, 0, message.source.length) : options.bytes === Array ? Array.prototype.slice.call(message.source) : message.source;
            return object;
        };

        TezosDelegationOp.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TezosDelegationOp;
    })();

    TezosSignTx.TezosProposalOp = (function() {

        function TezosProposalOp(properties) {
            this.proposals = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        TezosProposalOp.prototype.source = $util.newBuffer([]);
        TezosProposalOp.prototype.period = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        TezosProposalOp.prototype.proposals = $util.emptyArray;

        TezosProposalOp.create = function create(properties) {
            return new TezosProposalOp(properties);
        };

        TezosProposalOp.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(10).bytes(message.source);
            writer.uint32(16).uint64(message.period);
            if (message.proposals != null && message.proposals.length)
                for (var i = 0; i < message.proposals.length; ++i)
                    writer.uint32(34).bytes(message.proposals[i]);
            return writer;
        };

        TezosProposalOp.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        TezosProposalOp.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TezosSignTx.TezosProposalOp();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.source = reader.bytes();
                    break;
                case 2:
                    message.period = reader.uint64();
                    break;
                case 4:
                    if (!(message.proposals && message.proposals.length))
                        message.proposals = [];
                    message.proposals.push(reader.bytes());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("source"))
                throw $util.ProtocolError("missing required 'source'", { instance: message });
            if (!message.hasOwnProperty("period"))
                throw $util.ProtocolError("missing required 'period'", { instance: message });
            return message;
        };

        TezosProposalOp.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        TezosProposalOp.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!(message.source && typeof message.source.length === "number" || $util.isString(message.source)))
                return "source: buffer expected";
            if (!$util.isInteger(message.period) && !(message.period && $util.isInteger(message.period.low) && $util.isInteger(message.period.high)))
                return "period: integer|Long expected";
            if (message.proposals != null && message.hasOwnProperty("proposals")) {
                if (!Array.isArray(message.proposals))
                    return "proposals: array expected";
                for (var i = 0; i < message.proposals.length; ++i)
                    if (!(message.proposals[i] && typeof message.proposals[i].length === "number" || $util.isString(message.proposals[i])))
                        return "proposals: buffer[] expected";
            }
            return null;
        };

        TezosProposalOp.fromObject = function fromObject(object) {
            if (object instanceof $root.TezosSignTx.TezosProposalOp)
                return object;
            var message = new $root.TezosSignTx.TezosProposalOp();
            if (object.source != null)
                if (typeof object.source === "string")
                    $util.base64.decode(object.source, message.source = $util.newBuffer($util.base64.length(object.source)), 0);
                else if (object.source.length)
                    message.source = object.source;
            if (object.period != null)
                if ($util.Long)
                    (message.period = $util.Long.fromValue(object.period)).unsigned = true;
                else if (typeof object.period === "string")
                    message.period = parseInt(object.period, 10);
                else if (typeof object.period === "number")
                    message.period = object.period;
                else if (typeof object.period === "object")
                    message.period = new $util.LongBits(object.period.low >>> 0, object.period.high >>> 0).toNumber(true);
            if (object.proposals) {
                if (!Array.isArray(object.proposals))
                    throw TypeError(".TezosSignTx.TezosProposalOp.proposals: array expected");
                message.proposals = [];
                for (var i = 0; i < object.proposals.length; ++i)
                    if (typeof object.proposals[i] === "string")
                        $util.base64.decode(object.proposals[i], message.proposals[i] = $util.newBuffer($util.base64.length(object.proposals[i])), 0);
                    else if (object.proposals[i].length)
                        message.proposals[i] = object.proposals[i];
            }
            return message;
        };

        TezosProposalOp.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.proposals = [];
            if (options.defaults) {
                if (options.bytes === String)
                    object.source = "";
                else {
                    object.source = [];
                    if (options.bytes !== Array)
                        object.source = $util.newBuffer(object.source);
                }
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.period = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.period = options.longs === String ? "0" : 0;
            }
            if (message.source != null && message.hasOwnProperty("source"))
                object.source = options.bytes === String ? $util.base64.encode(message.source, 0, message.source.length) : options.bytes === Array ? Array.prototype.slice.call(message.source) : message.source;
            if (message.period != null && message.hasOwnProperty("period"))
                if (typeof message.period === "number")
                    object.period = options.longs === String ? String(message.period) : message.period;
                else
                    object.period = options.longs === String ? $util.Long.prototype.toString.call(message.period) : options.longs === Number ? new $util.LongBits(message.period.low >>> 0, message.period.high >>> 0).toNumber(true) : message.period;
            if (message.proposals && message.proposals.length) {
                object.proposals = [];
                for (var j = 0; j < message.proposals.length; ++j)
                    object.proposals[j] = options.bytes === String ? $util.base64.encode(message.proposals[j], 0, message.proposals[j].length) : options.bytes === Array ? Array.prototype.slice.call(message.proposals[j]) : message.proposals[j];
            }
            return object;
        };

        TezosProposalOp.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TezosProposalOp;
    })();

    TezosSignTx.TezosBallotOp = (function() {

        function TezosBallotOp(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        TezosBallotOp.prototype.source = $util.newBuffer([]);
        TezosBallotOp.prototype.period = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        TezosBallotOp.prototype.proposal = $util.newBuffer([]);
        TezosBallotOp.prototype.ballot = 0;

        TezosBallotOp.create = function create(properties) {
            return new TezosBallotOp(properties);
        };

        TezosBallotOp.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(10).bytes(message.source);
            writer.uint32(16).uint64(message.period);
            writer.uint32(26).bytes(message.proposal);
            writer.uint32(32).int32(message.ballot);
            return writer;
        };

        TezosBallotOp.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        TezosBallotOp.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TezosSignTx.TezosBallotOp();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.source = reader.bytes();
                    break;
                case 2:
                    message.period = reader.uint64();
                    break;
                case 3:
                    message.proposal = reader.bytes();
                    break;
                case 4:
                    message.ballot = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("source"))
                throw $util.ProtocolError("missing required 'source'", { instance: message });
            if (!message.hasOwnProperty("period"))
                throw $util.ProtocolError("missing required 'period'", { instance: message });
            if (!message.hasOwnProperty("proposal"))
                throw $util.ProtocolError("missing required 'proposal'", { instance: message });
            if (!message.hasOwnProperty("ballot"))
                throw $util.ProtocolError("missing required 'ballot'", { instance: message });
            return message;
        };

        TezosBallotOp.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        TezosBallotOp.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!(message.source && typeof message.source.length === "number" || $util.isString(message.source)))
                return "source: buffer expected";
            if (!$util.isInteger(message.period) && !(message.period && $util.isInteger(message.period.low) && $util.isInteger(message.period.high)))
                return "period: integer|Long expected";
            if (!(message.proposal && typeof message.proposal.length === "number" || $util.isString(message.proposal)))
                return "proposal: buffer expected";
            switch (message.ballot) {
            default:
                return "ballot: enum value expected";
            case 0:
            case 1:
            case 2:
                break;
            }
            return null;
        };

        TezosBallotOp.fromObject = function fromObject(object) {
            if (object instanceof $root.TezosSignTx.TezosBallotOp)
                return object;
            var message = new $root.TezosSignTx.TezosBallotOp();
            if (object.source != null)
                if (typeof object.source === "string")
                    $util.base64.decode(object.source, message.source = $util.newBuffer($util.base64.length(object.source)), 0);
                else if (object.source.length)
                    message.source = object.source;
            if (object.period != null)
                if ($util.Long)
                    (message.period = $util.Long.fromValue(object.period)).unsigned = true;
                else if (typeof object.period === "string")
                    message.period = parseInt(object.period, 10);
                else if (typeof object.period === "number")
                    message.period = object.period;
                else if (typeof object.period === "object")
                    message.period = new $util.LongBits(object.period.low >>> 0, object.period.high >>> 0).toNumber(true);
            if (object.proposal != null)
                if (typeof object.proposal === "string")
                    $util.base64.decode(object.proposal, message.proposal = $util.newBuffer($util.base64.length(object.proposal)), 0);
                else if (object.proposal.length)
                    message.proposal = object.proposal;
            switch (object.ballot) {
            case "Yay":
            case 0:
                message.ballot = 0;
                break;
            case "Nay":
            case 1:
                message.ballot = 1;
                break;
            case "Pass":
            case 2:
                message.ballot = 2;
                break;
            }
            return message;
        };

        TezosBallotOp.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if (options.bytes === String)
                    object.source = "";
                else {
                    object.source = [];
                    if (options.bytes !== Array)
                        object.source = $util.newBuffer(object.source);
                }
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.period = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.period = options.longs === String ? "0" : 0;
                if (options.bytes === String)
                    object.proposal = "";
                else {
                    object.proposal = [];
                    if (options.bytes !== Array)
                        object.proposal = $util.newBuffer(object.proposal);
                }
                object.ballot = options.enums === String ? "Yay" : 0;
            }
            if (message.source != null && message.hasOwnProperty("source"))
                object.source = options.bytes === String ? $util.base64.encode(message.source, 0, message.source.length) : options.bytes === Array ? Array.prototype.slice.call(message.source) : message.source;
            if (message.period != null && message.hasOwnProperty("period"))
                if (typeof message.period === "number")
                    object.period = options.longs === String ? String(message.period) : message.period;
                else
                    object.period = options.longs === String ? $util.Long.prototype.toString.call(message.period) : options.longs === Number ? new $util.LongBits(message.period.low >>> 0, message.period.high >>> 0).toNumber(true) : message.period;
            if (message.proposal != null && message.hasOwnProperty("proposal"))
                object.proposal = options.bytes === String ? $util.base64.encode(message.proposal, 0, message.proposal.length) : options.bytes === Array ? Array.prototype.slice.call(message.proposal) : message.proposal;
            if (message.ballot != null && message.hasOwnProperty("ballot"))
                object.ballot = options.enums === String ? $root.TezosSignTx.TezosBallotOp.TezosBallotType[message.ballot] : message.ballot;
            return object;
        };

        TezosBallotOp.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        TezosBallotOp.TezosBallotType = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "Yay"] = 0;
            values[valuesById[1] = "Nay"] = 1;
            values[valuesById[2] = "Pass"] = 2;
            return values;
        })();

        return TezosBallotOp;
    })();

    return TezosSignTx;
})();

$root.TezosSignedTx = (function() {

    function TezosSignedTx(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    TezosSignedTx.prototype.signature = "";
    TezosSignedTx.prototype.sig_op_contents = $util.newBuffer([]);
    TezosSignedTx.prototype.operation_hash = "";

    TezosSignedTx.create = function create(properties) {
        return new TezosSignedTx(properties);
    };

    TezosSignedTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.signature);
        writer.uint32(18).bytes(message.sig_op_contents);
        writer.uint32(26).string(message.operation_hash);
        return writer;
    };

    TezosSignedTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    TezosSignedTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TezosSignedTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.signature = reader.string();
                break;
            case 2:
                message.sig_op_contents = reader.bytes();
                break;
            case 3:
                message.operation_hash = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        if (!message.hasOwnProperty("sig_op_contents"))
            throw $util.ProtocolError("missing required 'sig_op_contents'", { instance: message });
        if (!message.hasOwnProperty("operation_hash"))
            throw $util.ProtocolError("missing required 'operation_hash'", { instance: message });
        return message;
    };

    TezosSignedTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    TezosSignedTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.signature))
            return "signature: string expected";
        if (!(message.sig_op_contents && typeof message.sig_op_contents.length === "number" || $util.isString(message.sig_op_contents)))
            return "sig_op_contents: buffer expected";
        if (!$util.isString(message.operation_hash))
            return "operation_hash: string expected";
        return null;
    };

    TezosSignedTx.fromObject = function fromObject(object) {
        if (object instanceof $root.TezosSignedTx)
            return object;
        var message = new $root.TezosSignedTx();
        if (object.signature != null)
            message.signature = String(object.signature);
        if (object.sig_op_contents != null)
            if (typeof object.sig_op_contents === "string")
                $util.base64.decode(object.sig_op_contents, message.sig_op_contents = $util.newBuffer($util.base64.length(object.sig_op_contents)), 0);
            else if (object.sig_op_contents.length)
                message.sig_op_contents = object.sig_op_contents;
        if (object.operation_hash != null)
            message.operation_hash = String(object.operation_hash);
        return message;
    };

    TezosSignedTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.signature = "";
            if (options.bytes === String)
                object.sig_op_contents = "";
            else {
                object.sig_op_contents = [];
                if (options.bytes !== Array)
                    object.sig_op_contents = $util.newBuffer(object.sig_op_contents);
            }
            object.operation_hash = "";
        }
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = message.signature;
        if (message.sig_op_contents != null && message.hasOwnProperty("sig_op_contents"))
            object.sig_op_contents = options.bytes === String ? $util.base64.encode(message.sig_op_contents, 0, message.sig_op_contents.length) : options.bytes === Array ? Array.prototype.slice.call(message.sig_op_contents) : message.sig_op_contents;
        if (message.operation_hash != null && message.hasOwnProperty("operation_hash"))
            object.operation_hash = message.operation_hash;
        return object;
    };

    TezosSignedTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return TezosSignedTx;
})();

$root.TonWalletVersion = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[3] = "V4R2"] = 3;
    return values;
})();

$root.TonWorkChain = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "BASECHAIN"] = 0;
    values[valuesById[1] = "MASTERCHAIN"] = 1;
    return values;
})();

$root.TonGetAddress = (function() {

    function TonGetAddress(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    TonGetAddress.prototype.address_n = $util.emptyArray;
    TonGetAddress.prototype.show_display = false;
    TonGetAddress.prototype.wallet_version = 3;
    TonGetAddress.prototype.is_bounceable = false;
    TonGetAddress.prototype.is_testnet_only = false;
    TonGetAddress.prototype.workchain = 0;
    TonGetAddress.prototype.wallet_id = 698983191;

    TonGetAddress.create = function create(properties) {
        return new TonGetAddress(properties);
    };

    TonGetAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(16).bool(message.show_display);
        if (message.wallet_version != null && Object.hasOwnProperty.call(message, "wallet_version"))
            writer.uint32(24).int32(message.wallet_version);
        if (message.is_bounceable != null && Object.hasOwnProperty.call(message, "is_bounceable"))
            writer.uint32(32).bool(message.is_bounceable);
        if (message.is_testnet_only != null && Object.hasOwnProperty.call(message, "is_testnet_only"))
            writer.uint32(40).bool(message.is_testnet_only);
        if (message.workchain != null && Object.hasOwnProperty.call(message, "workchain"))
            writer.uint32(48).int32(message.workchain);
        if (message.wallet_id != null && Object.hasOwnProperty.call(message, "wallet_id"))
            writer.uint32(56).uint32(message.wallet_id);
        return writer;
    };

    TonGetAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    TonGetAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TonGetAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.show_display = reader.bool();
                break;
            case 3:
                message.wallet_version = reader.int32();
                break;
            case 4:
                message.is_bounceable = reader.bool();
                break;
            case 5:
                message.is_testnet_only = reader.bool();
                break;
            case 6:
                message.workchain = reader.int32();
                break;
            case 7:
                message.wallet_id = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    TonGetAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    TonGetAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        if (message.wallet_version != null && message.hasOwnProperty("wallet_version"))
            switch (message.wallet_version) {
            default:
                return "wallet_version: enum value expected";
            case 3:
                break;
            }
        if (message.is_bounceable != null && message.hasOwnProperty("is_bounceable"))
            if (typeof message.is_bounceable !== "boolean")
                return "is_bounceable: boolean expected";
        if (message.is_testnet_only != null && message.hasOwnProperty("is_testnet_only"))
            if (typeof message.is_testnet_only !== "boolean")
                return "is_testnet_only: boolean expected";
        if (message.workchain != null && message.hasOwnProperty("workchain"))
            switch (message.workchain) {
            default:
                return "workchain: enum value expected";
            case 0:
            case 1:
                break;
            }
        if (message.wallet_id != null && message.hasOwnProperty("wallet_id"))
            if (!$util.isInteger(message.wallet_id))
                return "wallet_id: integer expected";
        return null;
    };

    TonGetAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.TonGetAddress)
            return object;
        var message = new $root.TonGetAddress();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".TonGetAddress.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        switch (object.wallet_version) {
        case "V4R2":
        case 3:
            message.wallet_version = 3;
            break;
        }
        if (object.is_bounceable != null)
            message.is_bounceable = Boolean(object.is_bounceable);
        if (object.is_testnet_only != null)
            message.is_testnet_only = Boolean(object.is_testnet_only);
        switch (object.workchain) {
        case "BASECHAIN":
        case 0:
            message.workchain = 0;
            break;
        case "MASTERCHAIN":
        case 1:
            message.workchain = 1;
            break;
        }
        if (object.wallet_id != null)
            message.wallet_id = object.wallet_id >>> 0;
        return message;
    };

    TonGetAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            object.show_display = false;
            object.wallet_version = options.enums === String ? "V4R2" : 3;
            object.is_bounceable = false;
            object.is_testnet_only = false;
            object.workchain = options.enums === String ? "BASECHAIN" : 0;
            object.wallet_id = 698983191;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        if (message.wallet_version != null && message.hasOwnProperty("wallet_version"))
            object.wallet_version = options.enums === String ? $root.TonWalletVersion[message.wallet_version] : message.wallet_version;
        if (message.is_bounceable != null && message.hasOwnProperty("is_bounceable"))
            object.is_bounceable = message.is_bounceable;
        if (message.is_testnet_only != null && message.hasOwnProperty("is_testnet_only"))
            object.is_testnet_only = message.is_testnet_only;
        if (message.workchain != null && message.hasOwnProperty("workchain"))
            object.workchain = options.enums === String ? $root.TonWorkChain[message.workchain] : message.workchain;
        if (message.wallet_id != null && message.hasOwnProperty("wallet_id"))
            object.wallet_id = message.wallet_id;
        return object;
    };

    TonGetAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return TonGetAddress;
})();

$root.TonAddress = (function() {

    function TonAddress(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    TonAddress.prototype.public_key = $util.newBuffer([]);
    TonAddress.prototype.address = "";

    TonAddress.create = function create(properties) {
        return new TonAddress(properties);
    };

    TonAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.public_key);
        writer.uint32(18).string(message.address);
        return writer;
    };

    TonAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    TonAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TonAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.public_key = reader.bytes();
                break;
            case 2:
                message.address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("public_key"))
            throw $util.ProtocolError("missing required 'public_key'", { instance: message });
        if (!message.hasOwnProperty("address"))
            throw $util.ProtocolError("missing required 'address'", { instance: message });
        return message;
    };

    TonAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    TonAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.public_key && typeof message.public_key.length === "number" || $util.isString(message.public_key)))
            return "public_key: buffer expected";
        if (!$util.isString(message.address))
            return "address: string expected";
        return null;
    };

    TonAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.TonAddress)
            return object;
        var message = new $root.TonAddress();
        if (object.public_key != null)
            if (typeof object.public_key === "string")
                $util.base64.decode(object.public_key, message.public_key = $util.newBuffer($util.base64.length(object.public_key)), 0);
            else if (object.public_key.length)
                message.public_key = object.public_key;
        if (object.address != null)
            message.address = String(object.address);
        return message;
    };

    TonAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.public_key = "";
            else {
                object.public_key = [];
                if (options.bytes !== Array)
                    object.public_key = $util.newBuffer(object.public_key);
            }
            object.address = "";
        }
        if (message.public_key != null && message.hasOwnProperty("public_key"))
            object.public_key = options.bytes === String ? $util.base64.encode(message.public_key, 0, message.public_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.public_key) : message.public_key;
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    TonAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return TonAddress;
})();

$root.TonSignMessage = (function() {

    function TonSignMessage(properties) {
        this.address_n = [];
        this.ext_destination = [];
        this.ext_ton_amount = [];
        this.ext_payload = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    TonSignMessage.prototype.address_n = $util.emptyArray;
    TonSignMessage.prototype.destination = "";
    TonSignMessage.prototype.jetton_master_address = "";
    TonSignMessage.prototype.jetton_wallet_address = "";
    TonSignMessage.prototype.ton_amount = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    TonSignMessage.prototype.jetton_amount = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    TonSignMessage.prototype.fwd_fee = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    TonSignMessage.prototype.comment = "";
    TonSignMessage.prototype.is_raw_data = false;
    TonSignMessage.prototype.mode = 3;
    TonSignMessage.prototype.seqno = 0;
    TonSignMessage.prototype.expire_at = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    TonSignMessage.prototype.wallet_version = 3;
    TonSignMessage.prototype.wallet_id = 698983191;
    TonSignMessage.prototype.workchain = 0;
    TonSignMessage.prototype.is_bounceable = false;
    TonSignMessage.prototype.is_testnet_only = false;
    TonSignMessage.prototype.ext_destination = $util.emptyArray;
    TonSignMessage.prototype.ext_ton_amount = $util.emptyArray;
    TonSignMessage.prototype.ext_payload = $util.emptyArray;
    TonSignMessage.prototype.jetton_amount_bytes = $util.newBuffer([]);
    TonSignMessage.prototype.init_data_initial_chunk = $util.newBuffer([]);
    TonSignMessage.prototype.init_data_length = 0;
    TonSignMessage.prototype.signing_message_repr = $util.newBuffer([]);

    TonSignMessage.create = function create(properties) {
        return new TonSignMessage(properties);
    };

    TonSignMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).string(message.destination);
        if (message.jetton_master_address != null && Object.hasOwnProperty.call(message, "jetton_master_address"))
            writer.uint32(26).string(message.jetton_master_address);
        if (message.jetton_wallet_address != null && Object.hasOwnProperty.call(message, "jetton_wallet_address"))
            writer.uint32(34).string(message.jetton_wallet_address);
        writer.uint32(40).uint64(message.ton_amount);
        if (message.jetton_amount != null && Object.hasOwnProperty.call(message, "jetton_amount"))
            writer.uint32(48).uint64(message.jetton_amount);
        if (message.fwd_fee != null && Object.hasOwnProperty.call(message, "fwd_fee"))
            writer.uint32(56).uint64(message.fwd_fee);
        if (message.comment != null && Object.hasOwnProperty.call(message, "comment"))
            writer.uint32(66).string(message.comment);
        if (message.is_raw_data != null && Object.hasOwnProperty.call(message, "is_raw_data"))
            writer.uint32(72).bool(message.is_raw_data);
        if (message.mode != null && Object.hasOwnProperty.call(message, "mode"))
            writer.uint32(80).uint32(message.mode);
        writer.uint32(88).uint32(message.seqno);
        writer.uint32(96).uint64(message.expire_at);
        if (message.wallet_version != null && Object.hasOwnProperty.call(message, "wallet_version"))
            writer.uint32(104).int32(message.wallet_version);
        if (message.wallet_id != null && Object.hasOwnProperty.call(message, "wallet_id"))
            writer.uint32(112).uint32(message.wallet_id);
        if (message.workchain != null && Object.hasOwnProperty.call(message, "workchain"))
            writer.uint32(120).int32(message.workchain);
        if (message.is_bounceable != null && Object.hasOwnProperty.call(message, "is_bounceable"))
            writer.uint32(128).bool(message.is_bounceable);
        if (message.is_testnet_only != null && Object.hasOwnProperty.call(message, "is_testnet_only"))
            writer.uint32(136).bool(message.is_testnet_only);
        if (message.ext_destination != null && message.ext_destination.length)
            for (var i = 0; i < message.ext_destination.length; ++i)
                writer.uint32(146).string(message.ext_destination[i]);
        if (message.ext_ton_amount != null && message.ext_ton_amount.length)
            for (var i = 0; i < message.ext_ton_amount.length; ++i)
                writer.uint32(152).uint64(message.ext_ton_amount[i]);
        if (message.ext_payload != null && message.ext_payload.length)
            for (var i = 0; i < message.ext_payload.length; ++i)
                writer.uint32(162).string(message.ext_payload[i]);
        if (message.jetton_amount_bytes != null && Object.hasOwnProperty.call(message, "jetton_amount_bytes"))
            writer.uint32(170).bytes(message.jetton_amount_bytes);
        if (message.init_data_initial_chunk != null && Object.hasOwnProperty.call(message, "init_data_initial_chunk"))
            writer.uint32(178).bytes(message.init_data_initial_chunk);
        if (message.init_data_length != null && Object.hasOwnProperty.call(message, "init_data_length"))
            writer.uint32(184).uint32(message.init_data_length);
        if (message.signing_message_repr != null && Object.hasOwnProperty.call(message, "signing_message_repr"))
            writer.uint32(194).bytes(message.signing_message_repr);
        return writer;
    };

    TonSignMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    TonSignMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TonSignMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.destination = reader.string();
                break;
            case 3:
                message.jetton_master_address = reader.string();
                break;
            case 4:
                message.jetton_wallet_address = reader.string();
                break;
            case 5:
                message.ton_amount = reader.uint64();
                break;
            case 6:
                message.jetton_amount = reader.uint64();
                break;
            case 7:
                message.fwd_fee = reader.uint64();
                break;
            case 8:
                message.comment = reader.string();
                break;
            case 9:
                message.is_raw_data = reader.bool();
                break;
            case 10:
                message.mode = reader.uint32();
                break;
            case 11:
                message.seqno = reader.uint32();
                break;
            case 12:
                message.expire_at = reader.uint64();
                break;
            case 13:
                message.wallet_version = reader.int32();
                break;
            case 14:
                message.wallet_id = reader.uint32();
                break;
            case 15:
                message.workchain = reader.int32();
                break;
            case 16:
                message.is_bounceable = reader.bool();
                break;
            case 17:
                message.is_testnet_only = reader.bool();
                break;
            case 18:
                if (!(message.ext_destination && message.ext_destination.length))
                    message.ext_destination = [];
                message.ext_destination.push(reader.string());
                break;
            case 19:
                if (!(message.ext_ton_amount && message.ext_ton_amount.length))
                    message.ext_ton_amount = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.ext_ton_amount.push(reader.uint64());
                } else
                    message.ext_ton_amount.push(reader.uint64());
                break;
            case 20:
                if (!(message.ext_payload && message.ext_payload.length))
                    message.ext_payload = [];
                message.ext_payload.push(reader.string());
                break;
            case 21:
                message.jetton_amount_bytes = reader.bytes();
                break;
            case 22:
                message.init_data_initial_chunk = reader.bytes();
                break;
            case 23:
                message.init_data_length = reader.uint32();
                break;
            case 24:
                message.signing_message_repr = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("destination"))
            throw $util.ProtocolError("missing required 'destination'", { instance: message });
        if (!message.hasOwnProperty("ton_amount"))
            throw $util.ProtocolError("missing required 'ton_amount'", { instance: message });
        if (!message.hasOwnProperty("seqno"))
            throw $util.ProtocolError("missing required 'seqno'", { instance: message });
        if (!message.hasOwnProperty("expire_at"))
            throw $util.ProtocolError("missing required 'expire_at'", { instance: message });
        return message;
    };

    TonSignMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    TonSignMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!$util.isString(message.destination))
            return "destination: string expected";
        if (message.jetton_master_address != null && message.hasOwnProperty("jetton_master_address"))
            if (!$util.isString(message.jetton_master_address))
                return "jetton_master_address: string expected";
        if (message.jetton_wallet_address != null && message.hasOwnProperty("jetton_wallet_address"))
            if (!$util.isString(message.jetton_wallet_address))
                return "jetton_wallet_address: string expected";
        if (!$util.isInteger(message.ton_amount) && !(message.ton_amount && $util.isInteger(message.ton_amount.low) && $util.isInteger(message.ton_amount.high)))
            return "ton_amount: integer|Long expected";
        if (message.jetton_amount != null && message.hasOwnProperty("jetton_amount"))
            if (!$util.isInteger(message.jetton_amount) && !(message.jetton_amount && $util.isInteger(message.jetton_amount.low) && $util.isInteger(message.jetton_amount.high)))
                return "jetton_amount: integer|Long expected";
        if (message.fwd_fee != null && message.hasOwnProperty("fwd_fee"))
            if (!$util.isInteger(message.fwd_fee) && !(message.fwd_fee && $util.isInteger(message.fwd_fee.low) && $util.isInteger(message.fwd_fee.high)))
                return "fwd_fee: integer|Long expected";
        if (message.comment != null && message.hasOwnProperty("comment"))
            if (!$util.isString(message.comment))
                return "comment: string expected";
        if (message.is_raw_data != null && message.hasOwnProperty("is_raw_data"))
            if (typeof message.is_raw_data !== "boolean")
                return "is_raw_data: boolean expected";
        if (message.mode != null && message.hasOwnProperty("mode"))
            if (!$util.isInteger(message.mode))
                return "mode: integer expected";
        if (!$util.isInteger(message.seqno))
            return "seqno: integer expected";
        if (!$util.isInteger(message.expire_at) && !(message.expire_at && $util.isInteger(message.expire_at.low) && $util.isInteger(message.expire_at.high)))
            return "expire_at: integer|Long expected";
        if (message.wallet_version != null && message.hasOwnProperty("wallet_version"))
            switch (message.wallet_version) {
            default:
                return "wallet_version: enum value expected";
            case 3:
                break;
            }
        if (message.wallet_id != null && message.hasOwnProperty("wallet_id"))
            if (!$util.isInteger(message.wallet_id))
                return "wallet_id: integer expected";
        if (message.workchain != null && message.hasOwnProperty("workchain"))
            switch (message.workchain) {
            default:
                return "workchain: enum value expected";
            case 0:
            case 1:
                break;
            }
        if (message.is_bounceable != null && message.hasOwnProperty("is_bounceable"))
            if (typeof message.is_bounceable !== "boolean")
                return "is_bounceable: boolean expected";
        if (message.is_testnet_only != null && message.hasOwnProperty("is_testnet_only"))
            if (typeof message.is_testnet_only !== "boolean")
                return "is_testnet_only: boolean expected";
        if (message.ext_destination != null && message.hasOwnProperty("ext_destination")) {
            if (!Array.isArray(message.ext_destination))
                return "ext_destination: array expected";
            for (var i = 0; i < message.ext_destination.length; ++i)
                if (!$util.isString(message.ext_destination[i]))
                    return "ext_destination: string[] expected";
        }
        if (message.ext_ton_amount != null && message.hasOwnProperty("ext_ton_amount")) {
            if (!Array.isArray(message.ext_ton_amount))
                return "ext_ton_amount: array expected";
            for (var i = 0; i < message.ext_ton_amount.length; ++i)
                if (!$util.isInteger(message.ext_ton_amount[i]) && !(message.ext_ton_amount[i] && $util.isInteger(message.ext_ton_amount[i].low) && $util.isInteger(message.ext_ton_amount[i].high)))
                    return "ext_ton_amount: integer|Long[] expected";
        }
        if (message.ext_payload != null && message.hasOwnProperty("ext_payload")) {
            if (!Array.isArray(message.ext_payload))
                return "ext_payload: array expected";
            for (var i = 0; i < message.ext_payload.length; ++i)
                if (!$util.isString(message.ext_payload[i]))
                    return "ext_payload: string[] expected";
        }
        if (message.jetton_amount_bytes != null && message.hasOwnProperty("jetton_amount_bytes"))
            if (!(message.jetton_amount_bytes && typeof message.jetton_amount_bytes.length === "number" || $util.isString(message.jetton_amount_bytes)))
                return "jetton_amount_bytes: buffer expected";
        if (message.init_data_initial_chunk != null && message.hasOwnProperty("init_data_initial_chunk"))
            if (!(message.init_data_initial_chunk && typeof message.init_data_initial_chunk.length === "number" || $util.isString(message.init_data_initial_chunk)))
                return "init_data_initial_chunk: buffer expected";
        if (message.init_data_length != null && message.hasOwnProperty("init_data_length"))
            if (!$util.isInteger(message.init_data_length))
                return "init_data_length: integer expected";
        if (message.signing_message_repr != null && message.hasOwnProperty("signing_message_repr"))
            if (!(message.signing_message_repr && typeof message.signing_message_repr.length === "number" || $util.isString(message.signing_message_repr)))
                return "signing_message_repr: buffer expected";
        return null;
    };

    TonSignMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.TonSignMessage)
            return object;
        var message = new $root.TonSignMessage();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".TonSignMessage.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.destination != null)
            message.destination = String(object.destination);
        if (object.jetton_master_address != null)
            message.jetton_master_address = String(object.jetton_master_address);
        if (object.jetton_wallet_address != null)
            message.jetton_wallet_address = String(object.jetton_wallet_address);
        if (object.ton_amount != null)
            if ($util.Long)
                (message.ton_amount = $util.Long.fromValue(object.ton_amount)).unsigned = true;
            else if (typeof object.ton_amount === "string")
                message.ton_amount = parseInt(object.ton_amount, 10);
            else if (typeof object.ton_amount === "number")
                message.ton_amount = object.ton_amount;
            else if (typeof object.ton_amount === "object")
                message.ton_amount = new $util.LongBits(object.ton_amount.low >>> 0, object.ton_amount.high >>> 0).toNumber(true);
        if (object.jetton_amount != null)
            if ($util.Long)
                (message.jetton_amount = $util.Long.fromValue(object.jetton_amount)).unsigned = true;
            else if (typeof object.jetton_amount === "string")
                message.jetton_amount = parseInt(object.jetton_amount, 10);
            else if (typeof object.jetton_amount === "number")
                message.jetton_amount = object.jetton_amount;
            else if (typeof object.jetton_amount === "object")
                message.jetton_amount = new $util.LongBits(object.jetton_amount.low >>> 0, object.jetton_amount.high >>> 0).toNumber(true);
        if (object.fwd_fee != null)
            if ($util.Long)
                (message.fwd_fee = $util.Long.fromValue(object.fwd_fee)).unsigned = true;
            else if (typeof object.fwd_fee === "string")
                message.fwd_fee = parseInt(object.fwd_fee, 10);
            else if (typeof object.fwd_fee === "number")
                message.fwd_fee = object.fwd_fee;
            else if (typeof object.fwd_fee === "object")
                message.fwd_fee = new $util.LongBits(object.fwd_fee.low >>> 0, object.fwd_fee.high >>> 0).toNumber(true);
        if (object.comment != null)
            message.comment = String(object.comment);
        if (object.is_raw_data != null)
            message.is_raw_data = Boolean(object.is_raw_data);
        if (object.mode != null)
            message.mode = object.mode >>> 0;
        if (object.seqno != null)
            message.seqno = object.seqno >>> 0;
        if (object.expire_at != null)
            if ($util.Long)
                (message.expire_at = $util.Long.fromValue(object.expire_at)).unsigned = true;
            else if (typeof object.expire_at === "string")
                message.expire_at = parseInt(object.expire_at, 10);
            else if (typeof object.expire_at === "number")
                message.expire_at = object.expire_at;
            else if (typeof object.expire_at === "object")
                message.expire_at = new $util.LongBits(object.expire_at.low >>> 0, object.expire_at.high >>> 0).toNumber(true);
        switch (object.wallet_version) {
        case "V4R2":
        case 3:
            message.wallet_version = 3;
            break;
        }
        if (object.wallet_id != null)
            message.wallet_id = object.wallet_id >>> 0;
        switch (object.workchain) {
        case "BASECHAIN":
        case 0:
            message.workchain = 0;
            break;
        case "MASTERCHAIN":
        case 1:
            message.workchain = 1;
            break;
        }
        if (object.is_bounceable != null)
            message.is_bounceable = Boolean(object.is_bounceable);
        if (object.is_testnet_only != null)
            message.is_testnet_only = Boolean(object.is_testnet_only);
        if (object.ext_destination) {
            if (!Array.isArray(object.ext_destination))
                throw TypeError(".TonSignMessage.ext_destination: array expected");
            message.ext_destination = [];
            for (var i = 0; i < object.ext_destination.length; ++i)
                message.ext_destination[i] = String(object.ext_destination[i]);
        }
        if (object.ext_ton_amount) {
            if (!Array.isArray(object.ext_ton_amount))
                throw TypeError(".TonSignMessage.ext_ton_amount: array expected");
            message.ext_ton_amount = [];
            for (var i = 0; i < object.ext_ton_amount.length; ++i)
                if ($util.Long)
                    (message.ext_ton_amount[i] = $util.Long.fromValue(object.ext_ton_amount[i])).unsigned = true;
                else if (typeof object.ext_ton_amount[i] === "string")
                    message.ext_ton_amount[i] = parseInt(object.ext_ton_amount[i], 10);
                else if (typeof object.ext_ton_amount[i] === "number")
                    message.ext_ton_amount[i] = object.ext_ton_amount[i];
                else if (typeof object.ext_ton_amount[i] === "object")
                    message.ext_ton_amount[i] = new $util.LongBits(object.ext_ton_amount[i].low >>> 0, object.ext_ton_amount[i].high >>> 0).toNumber(true);
        }
        if (object.ext_payload) {
            if (!Array.isArray(object.ext_payload))
                throw TypeError(".TonSignMessage.ext_payload: array expected");
            message.ext_payload = [];
            for (var i = 0; i < object.ext_payload.length; ++i)
                message.ext_payload[i] = String(object.ext_payload[i]);
        }
        if (object.jetton_amount_bytes != null)
            if (typeof object.jetton_amount_bytes === "string")
                $util.base64.decode(object.jetton_amount_bytes, message.jetton_amount_bytes = $util.newBuffer($util.base64.length(object.jetton_amount_bytes)), 0);
            else if (object.jetton_amount_bytes.length)
                message.jetton_amount_bytes = object.jetton_amount_bytes;
        if (object.init_data_initial_chunk != null)
            if (typeof object.init_data_initial_chunk === "string")
                $util.base64.decode(object.init_data_initial_chunk, message.init_data_initial_chunk = $util.newBuffer($util.base64.length(object.init_data_initial_chunk)), 0);
            else if (object.init_data_initial_chunk.length)
                message.init_data_initial_chunk = object.init_data_initial_chunk;
        if (object.init_data_length != null)
            message.init_data_length = object.init_data_length >>> 0;
        if (object.signing_message_repr != null)
            if (typeof object.signing_message_repr === "string")
                $util.base64.decode(object.signing_message_repr, message.signing_message_repr = $util.newBuffer($util.base64.length(object.signing_message_repr)), 0);
            else if (object.signing_message_repr.length)
                message.signing_message_repr = object.signing_message_repr;
        return message;
    };

    TonSignMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults) {
            object.address_n = [];
            object.ext_destination = [];
            object.ext_ton_amount = [];
            object.ext_payload = [];
        }
        if (options.defaults) {
            object.destination = "";
            object.jetton_master_address = "";
            object.jetton_wallet_address = "";
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.ton_amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.ton_amount = options.longs === String ? "0" : 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.jetton_amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.jetton_amount = options.longs === String ? "0" : 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.fwd_fee = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.fwd_fee = options.longs === String ? "0" : 0;
            object.comment = "";
            object.is_raw_data = false;
            object.mode = 3;
            object.seqno = 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.expire_at = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.expire_at = options.longs === String ? "0" : 0;
            object.wallet_version = options.enums === String ? "V4R2" : 3;
            object.wallet_id = 698983191;
            object.workchain = options.enums === String ? "BASECHAIN" : 0;
            object.is_bounceable = false;
            object.is_testnet_only = false;
            if (options.bytes === String)
                object.jetton_amount_bytes = "";
            else {
                object.jetton_amount_bytes = [];
                if (options.bytes !== Array)
                    object.jetton_amount_bytes = $util.newBuffer(object.jetton_amount_bytes);
            }
            if (options.bytes === String)
                object.init_data_initial_chunk = "";
            else {
                object.init_data_initial_chunk = [];
                if (options.bytes !== Array)
                    object.init_data_initial_chunk = $util.newBuffer(object.init_data_initial_chunk);
            }
            object.init_data_length = 0;
            if (options.bytes === String)
                object.signing_message_repr = "";
            else {
                object.signing_message_repr = [];
                if (options.bytes !== Array)
                    object.signing_message_repr = $util.newBuffer(object.signing_message_repr);
            }
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.destination != null && message.hasOwnProperty("destination"))
            object.destination = message.destination;
        if (message.jetton_master_address != null && message.hasOwnProperty("jetton_master_address"))
            object.jetton_master_address = message.jetton_master_address;
        if (message.jetton_wallet_address != null && message.hasOwnProperty("jetton_wallet_address"))
            object.jetton_wallet_address = message.jetton_wallet_address;
        if (message.ton_amount != null && message.hasOwnProperty("ton_amount"))
            if (typeof message.ton_amount === "number")
                object.ton_amount = options.longs === String ? String(message.ton_amount) : message.ton_amount;
            else
                object.ton_amount = options.longs === String ? $util.Long.prototype.toString.call(message.ton_amount) : options.longs === Number ? new $util.LongBits(message.ton_amount.low >>> 0, message.ton_amount.high >>> 0).toNumber(true) : message.ton_amount;
        if (message.jetton_amount != null && message.hasOwnProperty("jetton_amount"))
            if (typeof message.jetton_amount === "number")
                object.jetton_amount = options.longs === String ? String(message.jetton_amount) : message.jetton_amount;
            else
                object.jetton_amount = options.longs === String ? $util.Long.prototype.toString.call(message.jetton_amount) : options.longs === Number ? new $util.LongBits(message.jetton_amount.low >>> 0, message.jetton_amount.high >>> 0).toNumber(true) : message.jetton_amount;
        if (message.fwd_fee != null && message.hasOwnProperty("fwd_fee"))
            if (typeof message.fwd_fee === "number")
                object.fwd_fee = options.longs === String ? String(message.fwd_fee) : message.fwd_fee;
            else
                object.fwd_fee = options.longs === String ? $util.Long.prototype.toString.call(message.fwd_fee) : options.longs === Number ? new $util.LongBits(message.fwd_fee.low >>> 0, message.fwd_fee.high >>> 0).toNumber(true) : message.fwd_fee;
        if (message.comment != null && message.hasOwnProperty("comment"))
            object.comment = message.comment;
        if (message.is_raw_data != null && message.hasOwnProperty("is_raw_data"))
            object.is_raw_data = message.is_raw_data;
        if (message.mode != null && message.hasOwnProperty("mode"))
            object.mode = message.mode;
        if (message.seqno != null && message.hasOwnProperty("seqno"))
            object.seqno = message.seqno;
        if (message.expire_at != null && message.hasOwnProperty("expire_at"))
            if (typeof message.expire_at === "number")
                object.expire_at = options.longs === String ? String(message.expire_at) : message.expire_at;
            else
                object.expire_at = options.longs === String ? $util.Long.prototype.toString.call(message.expire_at) : options.longs === Number ? new $util.LongBits(message.expire_at.low >>> 0, message.expire_at.high >>> 0).toNumber(true) : message.expire_at;
        if (message.wallet_version != null && message.hasOwnProperty("wallet_version"))
            object.wallet_version = options.enums === String ? $root.TonWalletVersion[message.wallet_version] : message.wallet_version;
        if (message.wallet_id != null && message.hasOwnProperty("wallet_id"))
            object.wallet_id = message.wallet_id;
        if (message.workchain != null && message.hasOwnProperty("workchain"))
            object.workchain = options.enums === String ? $root.TonWorkChain[message.workchain] : message.workchain;
        if (message.is_bounceable != null && message.hasOwnProperty("is_bounceable"))
            object.is_bounceable = message.is_bounceable;
        if (message.is_testnet_only != null && message.hasOwnProperty("is_testnet_only"))
            object.is_testnet_only = message.is_testnet_only;
        if (message.ext_destination && message.ext_destination.length) {
            object.ext_destination = [];
            for (var j = 0; j < message.ext_destination.length; ++j)
                object.ext_destination[j] = message.ext_destination[j];
        }
        if (message.ext_ton_amount && message.ext_ton_amount.length) {
            object.ext_ton_amount = [];
            for (var j = 0; j < message.ext_ton_amount.length; ++j)
                if (typeof message.ext_ton_amount[j] === "number")
                    object.ext_ton_amount[j] = options.longs === String ? String(message.ext_ton_amount[j]) : message.ext_ton_amount[j];
                else
                    object.ext_ton_amount[j] = options.longs === String ? $util.Long.prototype.toString.call(message.ext_ton_amount[j]) : options.longs === Number ? new $util.LongBits(message.ext_ton_amount[j].low >>> 0, message.ext_ton_amount[j].high >>> 0).toNumber(true) : message.ext_ton_amount[j];
        }
        if (message.ext_payload && message.ext_payload.length) {
            object.ext_payload = [];
            for (var j = 0; j < message.ext_payload.length; ++j)
                object.ext_payload[j] = message.ext_payload[j];
        }
        if (message.jetton_amount_bytes != null && message.hasOwnProperty("jetton_amount_bytes"))
            object.jetton_amount_bytes = options.bytes === String ? $util.base64.encode(message.jetton_amount_bytes, 0, message.jetton_amount_bytes.length) : options.bytes === Array ? Array.prototype.slice.call(message.jetton_amount_bytes) : message.jetton_amount_bytes;
        if (message.init_data_initial_chunk != null && message.hasOwnProperty("init_data_initial_chunk"))
            object.init_data_initial_chunk = options.bytes === String ? $util.base64.encode(message.init_data_initial_chunk, 0, message.init_data_initial_chunk.length) : options.bytes === Array ? Array.prototype.slice.call(message.init_data_initial_chunk) : message.init_data_initial_chunk;
        if (message.init_data_length != null && message.hasOwnProperty("init_data_length"))
            object.init_data_length = message.init_data_length;
        if (message.signing_message_repr != null && message.hasOwnProperty("signing_message_repr"))
            object.signing_message_repr = options.bytes === String ? $util.base64.encode(message.signing_message_repr, 0, message.signing_message_repr.length) : options.bytes === Array ? Array.prototype.slice.call(message.signing_message_repr) : message.signing_message_repr;
        return object;
    };

    TonSignMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return TonSignMessage;
})();

$root.TonSignedMessage = (function() {

    function TonSignedMessage(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    TonSignedMessage.prototype.signature = $util.newBuffer([]);
    TonSignedMessage.prototype.signing_message = $util.newBuffer([]);
    TonSignedMessage.prototype.init_data_length = 0;

    TonSignedMessage.create = function create(properties) {
        return new TonSignedMessage(properties);
    };

    TonSignedMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.signature != null && Object.hasOwnProperty.call(message, "signature"))
            writer.uint32(10).bytes(message.signature);
        if (message.signing_message != null && Object.hasOwnProperty.call(message, "signing_message"))
            writer.uint32(18).bytes(message.signing_message);
        if (message.init_data_length != null && Object.hasOwnProperty.call(message, "init_data_length"))
            writer.uint32(24).uint32(message.init_data_length);
        return writer;
    };

    TonSignedMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    TonSignedMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TonSignedMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.signature = reader.bytes();
                break;
            case 2:
                message.signing_message = reader.bytes();
                break;
            case 3:
                message.init_data_length = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    TonSignedMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    TonSignedMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.signature != null && message.hasOwnProperty("signature"))
            if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
                return "signature: buffer expected";
        if (message.signing_message != null && message.hasOwnProperty("signing_message"))
            if (!(message.signing_message && typeof message.signing_message.length === "number" || $util.isString(message.signing_message)))
                return "signing_message: buffer expected";
        if (message.init_data_length != null && message.hasOwnProperty("init_data_length"))
            if (!$util.isInteger(message.init_data_length))
                return "init_data_length: integer expected";
        return null;
    };

    TonSignedMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.TonSignedMessage)
            return object;
        var message = new $root.TonSignedMessage();
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        if (object.signing_message != null)
            if (typeof object.signing_message === "string")
                $util.base64.decode(object.signing_message, message.signing_message = $util.newBuffer($util.base64.length(object.signing_message)), 0);
            else if (object.signing_message.length)
                message.signing_message = object.signing_message;
        if (object.init_data_length != null)
            message.init_data_length = object.init_data_length >>> 0;
        return message;
    };

    TonSignedMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
            if (options.bytes === String)
                object.signing_message = "";
            else {
                object.signing_message = [];
                if (options.bytes !== Array)
                    object.signing_message = $util.newBuffer(object.signing_message);
            }
            object.init_data_length = 0;
        }
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        if (message.signing_message != null && message.hasOwnProperty("signing_message"))
            object.signing_message = options.bytes === String ? $util.base64.encode(message.signing_message, 0, message.signing_message.length) : options.bytes === Array ? Array.prototype.slice.call(message.signing_message) : message.signing_message;
        if (message.init_data_length != null && message.hasOwnProperty("init_data_length"))
            object.init_data_length = message.init_data_length;
        return object;
    };

    TonSignedMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return TonSignedMessage;
})();

$root.TonTxAck = (function() {

    function TonTxAck(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    TonTxAck.prototype.init_data_chunk = $util.newBuffer([]);

    TonTxAck.create = function create(properties) {
        return new TonTxAck(properties);
    };

    TonTxAck.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.init_data_chunk);
        return writer;
    };

    TonTxAck.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    TonTxAck.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TonTxAck();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.init_data_chunk = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("init_data_chunk"))
            throw $util.ProtocolError("missing required 'init_data_chunk'", { instance: message });
        return message;
    };

    TonTxAck.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    TonTxAck.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.init_data_chunk && typeof message.init_data_chunk.length === "number" || $util.isString(message.init_data_chunk)))
            return "init_data_chunk: buffer expected";
        return null;
    };

    TonTxAck.fromObject = function fromObject(object) {
        if (object instanceof $root.TonTxAck)
            return object;
        var message = new $root.TonTxAck();
        if (object.init_data_chunk != null)
            if (typeof object.init_data_chunk === "string")
                $util.base64.decode(object.init_data_chunk, message.init_data_chunk = $util.newBuffer($util.base64.length(object.init_data_chunk)), 0);
            else if (object.init_data_chunk.length)
                message.init_data_chunk = object.init_data_chunk;
        return message;
    };

    TonTxAck.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.init_data_chunk = "";
            else {
                object.init_data_chunk = [];
                if (options.bytes !== Array)
                    object.init_data_chunk = $util.newBuffer(object.init_data_chunk);
            }
        if (message.init_data_chunk != null && message.hasOwnProperty("init_data_chunk"))
            object.init_data_chunk = options.bytes === String ? $util.base64.encode(message.init_data_chunk, 0, message.init_data_chunk.length) : options.bytes === Array ? Array.prototype.slice.call(message.init_data_chunk) : message.init_data_chunk;
        return object;
    };

    TonTxAck.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return TonTxAck;
})();

$root.TonSignProof = (function() {

    function TonSignProof(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    TonSignProof.prototype.address_n = $util.emptyArray;
    TonSignProof.prototype.appdomain = $util.newBuffer([]);
    TonSignProof.prototype.comment = $util.newBuffer([]);
    TonSignProof.prototype.expire_at = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    TonSignProof.prototype.wallet_version = 3;
    TonSignProof.prototype.wallet_id = 698983191;
    TonSignProof.prototype.workchain = 0;
    TonSignProof.prototype.is_bounceable = false;
    TonSignProof.prototype.is_testnet_only = false;

    TonSignProof.create = function create(properties) {
        return new TonSignProof(properties);
    };

    TonSignProof.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).bytes(message.appdomain);
        if (message.comment != null && Object.hasOwnProperty.call(message, "comment"))
            writer.uint32(26).bytes(message.comment);
        writer.uint32(32).uint64(message.expire_at);
        if (message.wallet_version != null && Object.hasOwnProperty.call(message, "wallet_version"))
            writer.uint32(40).int32(message.wallet_version);
        if (message.wallet_id != null && Object.hasOwnProperty.call(message, "wallet_id"))
            writer.uint32(48).uint32(message.wallet_id);
        if (message.workchain != null && Object.hasOwnProperty.call(message, "workchain"))
            writer.uint32(56).int32(message.workchain);
        if (message.is_bounceable != null && Object.hasOwnProperty.call(message, "is_bounceable"))
            writer.uint32(64).bool(message.is_bounceable);
        if (message.is_testnet_only != null && Object.hasOwnProperty.call(message, "is_testnet_only"))
            writer.uint32(72).bool(message.is_testnet_only);
        return writer;
    };

    TonSignProof.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    TonSignProof.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TonSignProof();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.appdomain = reader.bytes();
                break;
            case 3:
                message.comment = reader.bytes();
                break;
            case 4:
                message.expire_at = reader.uint64();
                break;
            case 5:
                message.wallet_version = reader.int32();
                break;
            case 6:
                message.wallet_id = reader.uint32();
                break;
            case 7:
                message.workchain = reader.int32();
                break;
            case 8:
                message.is_bounceable = reader.bool();
                break;
            case 9:
                message.is_testnet_only = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("appdomain"))
            throw $util.ProtocolError("missing required 'appdomain'", { instance: message });
        if (!message.hasOwnProperty("expire_at"))
            throw $util.ProtocolError("missing required 'expire_at'", { instance: message });
        return message;
    };

    TonSignProof.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    TonSignProof.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!(message.appdomain && typeof message.appdomain.length === "number" || $util.isString(message.appdomain)))
            return "appdomain: buffer expected";
        if (message.comment != null && message.hasOwnProperty("comment"))
            if (!(message.comment && typeof message.comment.length === "number" || $util.isString(message.comment)))
                return "comment: buffer expected";
        if (!$util.isInteger(message.expire_at) && !(message.expire_at && $util.isInteger(message.expire_at.low) && $util.isInteger(message.expire_at.high)))
            return "expire_at: integer|Long expected";
        if (message.wallet_version != null && message.hasOwnProperty("wallet_version"))
            switch (message.wallet_version) {
            default:
                return "wallet_version: enum value expected";
            case 3:
                break;
            }
        if (message.wallet_id != null && message.hasOwnProperty("wallet_id"))
            if (!$util.isInteger(message.wallet_id))
                return "wallet_id: integer expected";
        if (message.workchain != null && message.hasOwnProperty("workchain"))
            switch (message.workchain) {
            default:
                return "workchain: enum value expected";
            case 0:
            case 1:
                break;
            }
        if (message.is_bounceable != null && message.hasOwnProperty("is_bounceable"))
            if (typeof message.is_bounceable !== "boolean")
                return "is_bounceable: boolean expected";
        if (message.is_testnet_only != null && message.hasOwnProperty("is_testnet_only"))
            if (typeof message.is_testnet_only !== "boolean")
                return "is_testnet_only: boolean expected";
        return null;
    };

    TonSignProof.fromObject = function fromObject(object) {
        if (object instanceof $root.TonSignProof)
            return object;
        var message = new $root.TonSignProof();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".TonSignProof.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.appdomain != null)
            if (typeof object.appdomain === "string")
                $util.base64.decode(object.appdomain, message.appdomain = $util.newBuffer($util.base64.length(object.appdomain)), 0);
            else if (object.appdomain.length)
                message.appdomain = object.appdomain;
        if (object.comment != null)
            if (typeof object.comment === "string")
                $util.base64.decode(object.comment, message.comment = $util.newBuffer($util.base64.length(object.comment)), 0);
            else if (object.comment.length)
                message.comment = object.comment;
        if (object.expire_at != null)
            if ($util.Long)
                (message.expire_at = $util.Long.fromValue(object.expire_at)).unsigned = true;
            else if (typeof object.expire_at === "string")
                message.expire_at = parseInt(object.expire_at, 10);
            else if (typeof object.expire_at === "number")
                message.expire_at = object.expire_at;
            else if (typeof object.expire_at === "object")
                message.expire_at = new $util.LongBits(object.expire_at.low >>> 0, object.expire_at.high >>> 0).toNumber(true);
        switch (object.wallet_version) {
        case "V4R2":
        case 3:
            message.wallet_version = 3;
            break;
        }
        if (object.wallet_id != null)
            message.wallet_id = object.wallet_id >>> 0;
        switch (object.workchain) {
        case "BASECHAIN":
        case 0:
            message.workchain = 0;
            break;
        case "MASTERCHAIN":
        case 1:
            message.workchain = 1;
            break;
        }
        if (object.is_bounceable != null)
            message.is_bounceable = Boolean(object.is_bounceable);
        if (object.is_testnet_only != null)
            message.is_testnet_only = Boolean(object.is_testnet_only);
        return message;
    };

    TonSignProof.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            if (options.bytes === String)
                object.appdomain = "";
            else {
                object.appdomain = [];
                if (options.bytes !== Array)
                    object.appdomain = $util.newBuffer(object.appdomain);
            }
            if (options.bytes === String)
                object.comment = "";
            else {
                object.comment = [];
                if (options.bytes !== Array)
                    object.comment = $util.newBuffer(object.comment);
            }
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.expire_at = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.expire_at = options.longs === String ? "0" : 0;
            object.wallet_version = options.enums === String ? "V4R2" : 3;
            object.wallet_id = 698983191;
            object.workchain = options.enums === String ? "BASECHAIN" : 0;
            object.is_bounceable = false;
            object.is_testnet_only = false;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.appdomain != null && message.hasOwnProperty("appdomain"))
            object.appdomain = options.bytes === String ? $util.base64.encode(message.appdomain, 0, message.appdomain.length) : options.bytes === Array ? Array.prototype.slice.call(message.appdomain) : message.appdomain;
        if (message.comment != null && message.hasOwnProperty("comment"))
            object.comment = options.bytes === String ? $util.base64.encode(message.comment, 0, message.comment.length) : options.bytes === Array ? Array.prototype.slice.call(message.comment) : message.comment;
        if (message.expire_at != null && message.hasOwnProperty("expire_at"))
            if (typeof message.expire_at === "number")
                object.expire_at = options.longs === String ? String(message.expire_at) : message.expire_at;
            else
                object.expire_at = options.longs === String ? $util.Long.prototype.toString.call(message.expire_at) : options.longs === Number ? new $util.LongBits(message.expire_at.low >>> 0, message.expire_at.high >>> 0).toNumber(true) : message.expire_at;
        if (message.wallet_version != null && message.hasOwnProperty("wallet_version"))
            object.wallet_version = options.enums === String ? $root.TonWalletVersion[message.wallet_version] : message.wallet_version;
        if (message.wallet_id != null && message.hasOwnProperty("wallet_id"))
            object.wallet_id = message.wallet_id;
        if (message.workchain != null && message.hasOwnProperty("workchain"))
            object.workchain = options.enums === String ? $root.TonWorkChain[message.workchain] : message.workchain;
        if (message.is_bounceable != null && message.hasOwnProperty("is_bounceable"))
            object.is_bounceable = message.is_bounceable;
        if (message.is_testnet_only != null && message.hasOwnProperty("is_testnet_only"))
            object.is_testnet_only = message.is_testnet_only;
        return object;
    };

    TonSignProof.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return TonSignProof;
})();

$root.TonSignedProof = (function() {

    function TonSignedProof(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    TonSignedProof.prototype.signature = $util.newBuffer([]);

    TonSignedProof.create = function create(properties) {
        return new TonSignedProof(properties);
    };

    TonSignedProof.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.signature != null && Object.hasOwnProperty.call(message, "signature"))
            writer.uint32(10).bytes(message.signature);
        return writer;
    };

    TonSignedProof.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    TonSignedProof.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TonSignedProof();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.signature = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    TonSignedProof.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    TonSignedProof.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.signature != null && message.hasOwnProperty("signature"))
            if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
                return "signature: buffer expected";
        return null;
    };

    TonSignedProof.fromObject = function fromObject(object) {
        if (object instanceof $root.TonSignedProof)
            return object;
        var message = new $root.TonSignedProof();
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        return message;
    };

    TonSignedProof.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        return object;
    };

    TonSignedProof.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return TonSignedProof;
})();

$root.TronGetAddress = (function() {

    function TronGetAddress(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    TronGetAddress.prototype.address_n = $util.emptyArray;
    TronGetAddress.prototype.show_display = false;

    TronGetAddress.create = function create(properties) {
        return new TronGetAddress(properties);
    };

    TronGetAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        if (message.show_display != null && Object.hasOwnProperty.call(message, "show_display"))
            writer.uint32(16).bool(message.show_display);
        return writer;
    };

    TronGetAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    TronGetAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TronGetAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.show_display = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    TronGetAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    TronGetAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            if (typeof message.show_display !== "boolean")
                return "show_display: boolean expected";
        return null;
    };

    TronGetAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.TronGetAddress)
            return object;
        var message = new $root.TronGetAddress();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".TronGetAddress.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.show_display != null)
            message.show_display = Boolean(object.show_display);
        return message;
    };

    TronGetAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults)
            object.show_display = false;
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.show_display != null && message.hasOwnProperty("show_display"))
            object.show_display = message.show_display;
        return object;
    };

    TronGetAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return TronGetAddress;
})();

$root.TronAddress = (function() {

    function TronAddress(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    TronAddress.prototype.address = "";

    TronAddress.create = function create(properties) {
        return new TronAddress(properties);
    };

    TronAddress.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address != null && Object.hasOwnProperty.call(message, "address"))
            writer.uint32(10).string(message.address);
        return writer;
    };

    TronAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    TronAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TronAddress();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    TronAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    TronAddress.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address != null && message.hasOwnProperty("address"))
            if (!$util.isString(message.address))
                return "address: string expected";
        return null;
    };

    TronAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.TronAddress)
            return object;
        var message = new $root.TronAddress();
        if (object.address != null)
            message.address = String(object.address);
        return message;
    };

    TronAddress.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.address = "";
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        return object;
    };

    TronAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return TronAddress;
})();

$root.TronSignTx = (function() {

    function TronSignTx(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    TronSignTx.prototype.address_n = $util.emptyArray;
    TronSignTx.prototype.ref_block_bytes = $util.newBuffer([]);
    TronSignTx.prototype.ref_block_hash = $util.newBuffer([]);
    TronSignTx.prototype.expiration = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    TronSignTx.prototype.data = $util.newBuffer([]);
    TronSignTx.prototype.contract = null;
    TronSignTx.prototype.timestamp = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    TronSignTx.prototype.fee_limit = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    TronSignTx.create = function create(properties) {
        return new TronSignTx(properties);
    };

    TronSignTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).bytes(message.ref_block_bytes);
        writer.uint32(26).bytes(message.ref_block_hash);
        writer.uint32(32).uint64(message.expiration);
        if (message.data != null && Object.hasOwnProperty.call(message, "data"))
            writer.uint32(42).bytes(message.data);
        $root.TronSignTx.TronContract.encode(message.contract, writer.uint32(50).fork()).ldelim();
        writer.uint32(56).uint64(message.timestamp);
        if (message.fee_limit != null && Object.hasOwnProperty.call(message, "fee_limit"))
            writer.uint32(64).uint64(message.fee_limit);
        return writer;
    };

    TronSignTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    TronSignTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TronSignTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.ref_block_bytes = reader.bytes();
                break;
            case 3:
                message.ref_block_hash = reader.bytes();
                break;
            case 4:
                message.expiration = reader.uint64();
                break;
            case 5:
                message.data = reader.bytes();
                break;
            case 6:
                message.contract = $root.TronSignTx.TronContract.decode(reader, reader.uint32());
                break;
            case 7:
                message.timestamp = reader.uint64();
                break;
            case 8:
                message.fee_limit = reader.uint64();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("ref_block_bytes"))
            throw $util.ProtocolError("missing required 'ref_block_bytes'", { instance: message });
        if (!message.hasOwnProperty("ref_block_hash"))
            throw $util.ProtocolError("missing required 'ref_block_hash'", { instance: message });
        if (!message.hasOwnProperty("expiration"))
            throw $util.ProtocolError("missing required 'expiration'", { instance: message });
        if (!message.hasOwnProperty("contract"))
            throw $util.ProtocolError("missing required 'contract'", { instance: message });
        if (!message.hasOwnProperty("timestamp"))
            throw $util.ProtocolError("missing required 'timestamp'", { instance: message });
        return message;
    };

    TronSignTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    TronSignTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!(message.ref_block_bytes && typeof message.ref_block_bytes.length === "number" || $util.isString(message.ref_block_bytes)))
            return "ref_block_bytes: buffer expected";
        if (!(message.ref_block_hash && typeof message.ref_block_hash.length === "number" || $util.isString(message.ref_block_hash)))
            return "ref_block_hash: buffer expected";
        if (!$util.isInteger(message.expiration) && !(message.expiration && $util.isInteger(message.expiration.low) && $util.isInteger(message.expiration.high)))
            return "expiration: integer|Long expected";
        if (message.data != null && message.hasOwnProperty("data"))
            if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
                return "data: buffer expected";
        {
            var error = $root.TronSignTx.TronContract.verify(message.contract);
            if (error)
                return "contract." + error;
        }
        if (!$util.isInteger(message.timestamp) && !(message.timestamp && $util.isInteger(message.timestamp.low) && $util.isInteger(message.timestamp.high)))
            return "timestamp: integer|Long expected";
        if (message.fee_limit != null && message.hasOwnProperty("fee_limit"))
            if (!$util.isInteger(message.fee_limit) && !(message.fee_limit && $util.isInteger(message.fee_limit.low) && $util.isInteger(message.fee_limit.high)))
                return "fee_limit: integer|Long expected";
        return null;
    };

    TronSignTx.fromObject = function fromObject(object) {
        if (object instanceof $root.TronSignTx)
            return object;
        var message = new $root.TronSignTx();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".TronSignTx.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.ref_block_bytes != null)
            if (typeof object.ref_block_bytes === "string")
                $util.base64.decode(object.ref_block_bytes, message.ref_block_bytes = $util.newBuffer($util.base64.length(object.ref_block_bytes)), 0);
            else if (object.ref_block_bytes.length)
                message.ref_block_bytes = object.ref_block_bytes;
        if (object.ref_block_hash != null)
            if (typeof object.ref_block_hash === "string")
                $util.base64.decode(object.ref_block_hash, message.ref_block_hash = $util.newBuffer($util.base64.length(object.ref_block_hash)), 0);
            else if (object.ref_block_hash.length)
                message.ref_block_hash = object.ref_block_hash;
        if (object.expiration != null)
            if ($util.Long)
                (message.expiration = $util.Long.fromValue(object.expiration)).unsigned = true;
            else if (typeof object.expiration === "string")
                message.expiration = parseInt(object.expiration, 10);
            else if (typeof object.expiration === "number")
                message.expiration = object.expiration;
            else if (typeof object.expiration === "object")
                message.expiration = new $util.LongBits(object.expiration.low >>> 0, object.expiration.high >>> 0).toNumber(true);
        if (object.data != null)
            if (typeof object.data === "string")
                $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
            else if (object.data.length)
                message.data = object.data;
        if (object.contract != null) {
            if (typeof object.contract !== "object")
                throw TypeError(".TronSignTx.contract: object expected");
            message.contract = $root.TronSignTx.TronContract.fromObject(object.contract);
        }
        if (object.timestamp != null)
            if ($util.Long)
                (message.timestamp = $util.Long.fromValue(object.timestamp)).unsigned = true;
            else if (typeof object.timestamp === "string")
                message.timestamp = parseInt(object.timestamp, 10);
            else if (typeof object.timestamp === "number")
                message.timestamp = object.timestamp;
            else if (typeof object.timestamp === "object")
                message.timestamp = new $util.LongBits(object.timestamp.low >>> 0, object.timestamp.high >>> 0).toNumber(true);
        if (object.fee_limit != null)
            if ($util.Long)
                (message.fee_limit = $util.Long.fromValue(object.fee_limit)).unsigned = true;
            else if (typeof object.fee_limit === "string")
                message.fee_limit = parseInt(object.fee_limit, 10);
            else if (typeof object.fee_limit === "number")
                message.fee_limit = object.fee_limit;
            else if (typeof object.fee_limit === "object")
                message.fee_limit = new $util.LongBits(object.fee_limit.low >>> 0, object.fee_limit.high >>> 0).toNumber(true);
        return message;
    };

    TronSignTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            if (options.bytes === String)
                object.ref_block_bytes = "";
            else {
                object.ref_block_bytes = [];
                if (options.bytes !== Array)
                    object.ref_block_bytes = $util.newBuffer(object.ref_block_bytes);
            }
            if (options.bytes === String)
                object.ref_block_hash = "";
            else {
                object.ref_block_hash = [];
                if (options.bytes !== Array)
                    object.ref_block_hash = $util.newBuffer(object.ref_block_hash);
            }
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.expiration = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.expiration = options.longs === String ? "0" : 0;
            if (options.bytes === String)
                object.data = "";
            else {
                object.data = [];
                if (options.bytes !== Array)
                    object.data = $util.newBuffer(object.data);
            }
            object.contract = null;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.timestamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.timestamp = options.longs === String ? "0" : 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.fee_limit = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.fee_limit = options.longs === String ? "0" : 0;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.ref_block_bytes != null && message.hasOwnProperty("ref_block_bytes"))
            object.ref_block_bytes = options.bytes === String ? $util.base64.encode(message.ref_block_bytes, 0, message.ref_block_bytes.length) : options.bytes === Array ? Array.prototype.slice.call(message.ref_block_bytes) : message.ref_block_bytes;
        if (message.ref_block_hash != null && message.hasOwnProperty("ref_block_hash"))
            object.ref_block_hash = options.bytes === String ? $util.base64.encode(message.ref_block_hash, 0, message.ref_block_hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.ref_block_hash) : message.ref_block_hash;
        if (message.expiration != null && message.hasOwnProperty("expiration"))
            if (typeof message.expiration === "number")
                object.expiration = options.longs === String ? String(message.expiration) : message.expiration;
            else
                object.expiration = options.longs === String ? $util.Long.prototype.toString.call(message.expiration) : options.longs === Number ? new $util.LongBits(message.expiration.low >>> 0, message.expiration.high >>> 0).toNumber(true) : message.expiration;
        if (message.data != null && message.hasOwnProperty("data"))
            object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
        if (message.contract != null && message.hasOwnProperty("contract"))
            object.contract = $root.TronSignTx.TronContract.toObject(message.contract, options);
        if (message.timestamp != null && message.hasOwnProperty("timestamp"))
            if (typeof message.timestamp === "number")
                object.timestamp = options.longs === String ? String(message.timestamp) : message.timestamp;
            else
                object.timestamp = options.longs === String ? $util.Long.prototype.toString.call(message.timestamp) : options.longs === Number ? new $util.LongBits(message.timestamp.low >>> 0, message.timestamp.high >>> 0).toNumber(true) : message.timestamp;
        if (message.fee_limit != null && message.hasOwnProperty("fee_limit"))
            if (typeof message.fee_limit === "number")
                object.fee_limit = options.longs === String ? String(message.fee_limit) : message.fee_limit;
            else
                object.fee_limit = options.longs === String ? $util.Long.prototype.toString.call(message.fee_limit) : options.longs === Number ? new $util.LongBits(message.fee_limit.low >>> 0, message.fee_limit.high >>> 0).toNumber(true) : message.fee_limit;
        return object;
    };

    TronSignTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    TronSignTx.TronContract = (function() {

        function TronContract(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        TronContract.prototype.transfer_contract = null;
        TronContract.prototype.vote_witness_contract = null;
        TronContract.prototype.freeze_balance_contract = null;
        TronContract.prototype.unfreeze_balance_contract = null;
        TronContract.prototype.withdraw_balance_contract = null;
        TronContract.prototype.trigger_smart_contract = null;
        TronContract.prototype.freeze_balance_v2_contract = null;
        TronContract.prototype.unfreeze_balance_v2_contract = null;
        TronContract.prototype.withdraw_expire_unfreeze_contract = null;
        TronContract.prototype.delegate_resource_contract = null;
        TronContract.prototype.undelegate_resource_contract = null;
        TronContract.prototype.cancel_all_unfreeze_v2_contract = null;
        TronContract.prototype.provider = $util.newBuffer([]);
        TronContract.prototype.contract_name = $util.newBuffer([]);
        TronContract.prototype.permission_id = 0;

        TronContract.create = function create(properties) {
            return new TronContract(properties);
        };

        TronContract.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.transfer_contract != null && Object.hasOwnProperty.call(message, "transfer_contract"))
                $root.TronSignTx.TronContract.TronTransferContract.encode(message.transfer_contract, writer.uint32(18).fork()).ldelim();
            if (message.provider != null && Object.hasOwnProperty.call(message, "provider"))
                writer.uint32(26).bytes(message.provider);
            if (message.vote_witness_contract != null && Object.hasOwnProperty.call(message, "vote_witness_contract"))
                $root.TronSignTx.TronContract.TronVoteWitnessContract.encode(message.vote_witness_contract, writer.uint32(34).fork()).ldelim();
            if (message.contract_name != null && Object.hasOwnProperty.call(message, "contract_name"))
                writer.uint32(42).bytes(message.contract_name);
            if (message.permission_id != null && Object.hasOwnProperty.call(message, "permission_id"))
                writer.uint32(48).uint32(message.permission_id);
            if (message.freeze_balance_contract != null && Object.hasOwnProperty.call(message, "freeze_balance_contract"))
                $root.TronSignTx.TronContract.TronFreezeBalanceContract.encode(message.freeze_balance_contract, writer.uint32(90).fork()).ldelim();
            if (message.unfreeze_balance_contract != null && Object.hasOwnProperty.call(message, "unfreeze_balance_contract"))
                $root.TronSignTx.TronContract.TronUnfreezeBalanceContract.encode(message.unfreeze_balance_contract, writer.uint32(98).fork()).ldelim();
            if (message.withdraw_balance_contract != null && Object.hasOwnProperty.call(message, "withdraw_balance_contract"))
                $root.TronSignTx.TronContract.TronWithdrawBalanceContract.encode(message.withdraw_balance_contract, writer.uint32(106).fork()).ldelim();
            if (message.trigger_smart_contract != null && Object.hasOwnProperty.call(message, "trigger_smart_contract"))
                $root.TronSignTx.TronContract.TronTriggerSmartContract.encode(message.trigger_smart_contract, writer.uint32(250).fork()).ldelim();
            if (message.freeze_balance_v2_contract != null && Object.hasOwnProperty.call(message, "freeze_balance_v2_contract"))
                $root.TronSignTx.TronContract.TronFreezeBalanceV2Contract.encode(message.freeze_balance_v2_contract, writer.uint32(434).fork()).ldelim();
            if (message.unfreeze_balance_v2_contract != null && Object.hasOwnProperty.call(message, "unfreeze_balance_v2_contract"))
                $root.TronSignTx.TronContract.TronUnfreezeBalanceV2Contract.encode(message.unfreeze_balance_v2_contract, writer.uint32(442).fork()).ldelim();
            if (message.withdraw_expire_unfreeze_contract != null && Object.hasOwnProperty.call(message, "withdraw_expire_unfreeze_contract"))
                $root.TronSignTx.TronContract.TronWithdrawExpireUnfreezeContract.encode(message.withdraw_expire_unfreeze_contract, writer.uint32(450).fork()).ldelim();
            if (message.delegate_resource_contract != null && Object.hasOwnProperty.call(message, "delegate_resource_contract"))
                $root.TronSignTx.TronContract.TronDelegateResourceContract.encode(message.delegate_resource_contract, writer.uint32(458).fork()).ldelim();
            if (message.undelegate_resource_contract != null && Object.hasOwnProperty.call(message, "undelegate_resource_contract"))
                $root.TronSignTx.TronContract.TronUnDelegateResourceContract.encode(message.undelegate_resource_contract, writer.uint32(466).fork()).ldelim();
            if (message.cancel_all_unfreeze_v2_contract != null && Object.hasOwnProperty.call(message, "cancel_all_unfreeze_v2_contract"))
                $root.TronSignTx.TronContract.TronCancelAllUnfreezeV2Contract.encode(message.cancel_all_unfreeze_v2_contract, writer.uint32(474).fork()).ldelim();
            return writer;
        };

        TronContract.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        TronContract.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TronSignTx.TronContract();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 2:
                    message.transfer_contract = $root.TronSignTx.TronContract.TronTransferContract.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.vote_witness_contract = $root.TronSignTx.TronContract.TronVoteWitnessContract.decode(reader, reader.uint32());
                    break;
                case 11:
                    message.freeze_balance_contract = $root.TronSignTx.TronContract.TronFreezeBalanceContract.decode(reader, reader.uint32());
                    break;
                case 12:
                    message.unfreeze_balance_contract = $root.TronSignTx.TronContract.TronUnfreezeBalanceContract.decode(reader, reader.uint32());
                    break;
                case 13:
                    message.withdraw_balance_contract = $root.TronSignTx.TronContract.TronWithdrawBalanceContract.decode(reader, reader.uint32());
                    break;
                case 31:
                    message.trigger_smart_contract = $root.TronSignTx.TronContract.TronTriggerSmartContract.decode(reader, reader.uint32());
                    break;
                case 54:
                    message.freeze_balance_v2_contract = $root.TronSignTx.TronContract.TronFreezeBalanceV2Contract.decode(reader, reader.uint32());
                    break;
                case 55:
                    message.unfreeze_balance_v2_contract = $root.TronSignTx.TronContract.TronUnfreezeBalanceV2Contract.decode(reader, reader.uint32());
                    break;
                case 56:
                    message.withdraw_expire_unfreeze_contract = $root.TronSignTx.TronContract.TronWithdrawExpireUnfreezeContract.decode(reader, reader.uint32());
                    break;
                case 57:
                    message.delegate_resource_contract = $root.TronSignTx.TronContract.TronDelegateResourceContract.decode(reader, reader.uint32());
                    break;
                case 58:
                    message.undelegate_resource_contract = $root.TronSignTx.TronContract.TronUnDelegateResourceContract.decode(reader, reader.uint32());
                    break;
                case 59:
                    message.cancel_all_unfreeze_v2_contract = $root.TronSignTx.TronContract.TronCancelAllUnfreezeV2Contract.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.provider = reader.bytes();
                    break;
                case 5:
                    message.contract_name = reader.bytes();
                    break;
                case 6:
                    message.permission_id = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        TronContract.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        TronContract.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.transfer_contract != null && message.hasOwnProperty("transfer_contract")) {
                var error = $root.TronSignTx.TronContract.TronTransferContract.verify(message.transfer_contract);
                if (error)
                    return "transfer_contract." + error;
            }
            if (message.vote_witness_contract != null && message.hasOwnProperty("vote_witness_contract")) {
                var error = $root.TronSignTx.TronContract.TronVoteWitnessContract.verify(message.vote_witness_contract);
                if (error)
                    return "vote_witness_contract." + error;
            }
            if (message.freeze_balance_contract != null && message.hasOwnProperty("freeze_balance_contract")) {
                var error = $root.TronSignTx.TronContract.TronFreezeBalanceContract.verify(message.freeze_balance_contract);
                if (error)
                    return "freeze_balance_contract." + error;
            }
            if (message.unfreeze_balance_contract != null && message.hasOwnProperty("unfreeze_balance_contract")) {
                var error = $root.TronSignTx.TronContract.TronUnfreezeBalanceContract.verify(message.unfreeze_balance_contract);
                if (error)
                    return "unfreeze_balance_contract." + error;
            }
            if (message.withdraw_balance_contract != null && message.hasOwnProperty("withdraw_balance_contract")) {
                var error = $root.TronSignTx.TronContract.TronWithdrawBalanceContract.verify(message.withdraw_balance_contract);
                if (error)
                    return "withdraw_balance_contract." + error;
            }
            if (message.trigger_smart_contract != null && message.hasOwnProperty("trigger_smart_contract")) {
                var error = $root.TronSignTx.TronContract.TronTriggerSmartContract.verify(message.trigger_smart_contract);
                if (error)
                    return "trigger_smart_contract." + error;
            }
            if (message.freeze_balance_v2_contract != null && message.hasOwnProperty("freeze_balance_v2_contract")) {
                var error = $root.TronSignTx.TronContract.TronFreezeBalanceV2Contract.verify(message.freeze_balance_v2_contract);
                if (error)
                    return "freeze_balance_v2_contract." + error;
            }
            if (message.unfreeze_balance_v2_contract != null && message.hasOwnProperty("unfreeze_balance_v2_contract")) {
                var error = $root.TronSignTx.TronContract.TronUnfreezeBalanceV2Contract.verify(message.unfreeze_balance_v2_contract);
                if (error)
                    return "unfreeze_balance_v2_contract." + error;
            }
            if (message.withdraw_expire_unfreeze_contract != null && message.hasOwnProperty("withdraw_expire_unfreeze_contract")) {
                var error = $root.TronSignTx.TronContract.TronWithdrawExpireUnfreezeContract.verify(message.withdraw_expire_unfreeze_contract);
                if (error)
                    return "withdraw_expire_unfreeze_contract." + error;
            }
            if (message.delegate_resource_contract != null && message.hasOwnProperty("delegate_resource_contract")) {
                var error = $root.TronSignTx.TronContract.TronDelegateResourceContract.verify(message.delegate_resource_contract);
                if (error)
                    return "delegate_resource_contract." + error;
            }
            if (message.undelegate_resource_contract != null && message.hasOwnProperty("undelegate_resource_contract")) {
                var error = $root.TronSignTx.TronContract.TronUnDelegateResourceContract.verify(message.undelegate_resource_contract);
                if (error)
                    return "undelegate_resource_contract." + error;
            }
            if (message.cancel_all_unfreeze_v2_contract != null && message.hasOwnProperty("cancel_all_unfreeze_v2_contract")) {
                var error = $root.TronSignTx.TronContract.TronCancelAllUnfreezeV2Contract.verify(message.cancel_all_unfreeze_v2_contract);
                if (error)
                    return "cancel_all_unfreeze_v2_contract." + error;
            }
            if (message.provider != null && message.hasOwnProperty("provider"))
                if (!(message.provider && typeof message.provider.length === "number" || $util.isString(message.provider)))
                    return "provider: buffer expected";
            if (message.contract_name != null && message.hasOwnProperty("contract_name"))
                if (!(message.contract_name && typeof message.contract_name.length === "number" || $util.isString(message.contract_name)))
                    return "contract_name: buffer expected";
            if (message.permission_id != null && message.hasOwnProperty("permission_id"))
                if (!$util.isInteger(message.permission_id))
                    return "permission_id: integer expected";
            return null;
        };

        TronContract.fromObject = function fromObject(object) {
            if (object instanceof $root.TronSignTx.TronContract)
                return object;
            var message = new $root.TronSignTx.TronContract();
            if (object.transfer_contract != null) {
                if (typeof object.transfer_contract !== "object")
                    throw TypeError(".TronSignTx.TronContract.transfer_contract: object expected");
                message.transfer_contract = $root.TronSignTx.TronContract.TronTransferContract.fromObject(object.transfer_contract);
            }
            if (object.vote_witness_contract != null) {
                if (typeof object.vote_witness_contract !== "object")
                    throw TypeError(".TronSignTx.TronContract.vote_witness_contract: object expected");
                message.vote_witness_contract = $root.TronSignTx.TronContract.TronVoteWitnessContract.fromObject(object.vote_witness_contract);
            }
            if (object.freeze_balance_contract != null) {
                if (typeof object.freeze_balance_contract !== "object")
                    throw TypeError(".TronSignTx.TronContract.freeze_balance_contract: object expected");
                message.freeze_balance_contract = $root.TronSignTx.TronContract.TronFreezeBalanceContract.fromObject(object.freeze_balance_contract);
            }
            if (object.unfreeze_balance_contract != null) {
                if (typeof object.unfreeze_balance_contract !== "object")
                    throw TypeError(".TronSignTx.TronContract.unfreeze_balance_contract: object expected");
                message.unfreeze_balance_contract = $root.TronSignTx.TronContract.TronUnfreezeBalanceContract.fromObject(object.unfreeze_balance_contract);
            }
            if (object.withdraw_balance_contract != null) {
                if (typeof object.withdraw_balance_contract !== "object")
                    throw TypeError(".TronSignTx.TronContract.withdraw_balance_contract: object expected");
                message.withdraw_balance_contract = $root.TronSignTx.TronContract.TronWithdrawBalanceContract.fromObject(object.withdraw_balance_contract);
            }
            if (object.trigger_smart_contract != null) {
                if (typeof object.trigger_smart_contract !== "object")
                    throw TypeError(".TronSignTx.TronContract.trigger_smart_contract: object expected");
                message.trigger_smart_contract = $root.TronSignTx.TronContract.TronTriggerSmartContract.fromObject(object.trigger_smart_contract);
            }
            if (object.freeze_balance_v2_contract != null) {
                if (typeof object.freeze_balance_v2_contract !== "object")
                    throw TypeError(".TronSignTx.TronContract.freeze_balance_v2_contract: object expected");
                message.freeze_balance_v2_contract = $root.TronSignTx.TronContract.TronFreezeBalanceV2Contract.fromObject(object.freeze_balance_v2_contract);
            }
            if (object.unfreeze_balance_v2_contract != null) {
                if (typeof object.unfreeze_balance_v2_contract !== "object")
                    throw TypeError(".TronSignTx.TronContract.unfreeze_balance_v2_contract: object expected");
                message.unfreeze_balance_v2_contract = $root.TronSignTx.TronContract.TronUnfreezeBalanceV2Contract.fromObject(object.unfreeze_balance_v2_contract);
            }
            if (object.withdraw_expire_unfreeze_contract != null) {
                if (typeof object.withdraw_expire_unfreeze_contract !== "object")
                    throw TypeError(".TronSignTx.TronContract.withdraw_expire_unfreeze_contract: object expected");
                message.withdraw_expire_unfreeze_contract = $root.TronSignTx.TronContract.TronWithdrawExpireUnfreezeContract.fromObject(object.withdraw_expire_unfreeze_contract);
            }
            if (object.delegate_resource_contract != null) {
                if (typeof object.delegate_resource_contract !== "object")
                    throw TypeError(".TronSignTx.TronContract.delegate_resource_contract: object expected");
                message.delegate_resource_contract = $root.TronSignTx.TronContract.TronDelegateResourceContract.fromObject(object.delegate_resource_contract);
            }
            if (object.undelegate_resource_contract != null) {
                if (typeof object.undelegate_resource_contract !== "object")
                    throw TypeError(".TronSignTx.TronContract.undelegate_resource_contract: object expected");
                message.undelegate_resource_contract = $root.TronSignTx.TronContract.TronUnDelegateResourceContract.fromObject(object.undelegate_resource_contract);
            }
            if (object.cancel_all_unfreeze_v2_contract != null) {
                if (typeof object.cancel_all_unfreeze_v2_contract !== "object")
                    throw TypeError(".TronSignTx.TronContract.cancel_all_unfreeze_v2_contract: object expected");
                message.cancel_all_unfreeze_v2_contract = $root.TronSignTx.TronContract.TronCancelAllUnfreezeV2Contract.fromObject(object.cancel_all_unfreeze_v2_contract);
            }
            if (object.provider != null)
                if (typeof object.provider === "string")
                    $util.base64.decode(object.provider, message.provider = $util.newBuffer($util.base64.length(object.provider)), 0);
                else if (object.provider.length)
                    message.provider = object.provider;
            if (object.contract_name != null)
                if (typeof object.contract_name === "string")
                    $util.base64.decode(object.contract_name, message.contract_name = $util.newBuffer($util.base64.length(object.contract_name)), 0);
                else if (object.contract_name.length)
                    message.contract_name = object.contract_name;
            if (object.permission_id != null)
                message.permission_id = object.permission_id >>> 0;
            return message;
        };

        TronContract.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.transfer_contract = null;
                if (options.bytes === String)
                    object.provider = "";
                else {
                    object.provider = [];
                    if (options.bytes !== Array)
                        object.provider = $util.newBuffer(object.provider);
                }
                object.vote_witness_contract = null;
                if (options.bytes === String)
                    object.contract_name = "";
                else {
                    object.contract_name = [];
                    if (options.bytes !== Array)
                        object.contract_name = $util.newBuffer(object.contract_name);
                }
                object.permission_id = 0;
                object.freeze_balance_contract = null;
                object.unfreeze_balance_contract = null;
                object.withdraw_balance_contract = null;
                object.trigger_smart_contract = null;
                object.freeze_balance_v2_contract = null;
                object.unfreeze_balance_v2_contract = null;
                object.withdraw_expire_unfreeze_contract = null;
                object.delegate_resource_contract = null;
                object.undelegate_resource_contract = null;
                object.cancel_all_unfreeze_v2_contract = null;
            }
            if (message.transfer_contract != null && message.hasOwnProperty("transfer_contract"))
                object.transfer_contract = $root.TronSignTx.TronContract.TronTransferContract.toObject(message.transfer_contract, options);
            if (message.provider != null && message.hasOwnProperty("provider"))
                object.provider = options.bytes === String ? $util.base64.encode(message.provider, 0, message.provider.length) : options.bytes === Array ? Array.prototype.slice.call(message.provider) : message.provider;
            if (message.vote_witness_contract != null && message.hasOwnProperty("vote_witness_contract"))
                object.vote_witness_contract = $root.TronSignTx.TronContract.TronVoteWitnessContract.toObject(message.vote_witness_contract, options);
            if (message.contract_name != null && message.hasOwnProperty("contract_name"))
                object.contract_name = options.bytes === String ? $util.base64.encode(message.contract_name, 0, message.contract_name.length) : options.bytes === Array ? Array.prototype.slice.call(message.contract_name) : message.contract_name;
            if (message.permission_id != null && message.hasOwnProperty("permission_id"))
                object.permission_id = message.permission_id;
            if (message.freeze_balance_contract != null && message.hasOwnProperty("freeze_balance_contract"))
                object.freeze_balance_contract = $root.TronSignTx.TronContract.TronFreezeBalanceContract.toObject(message.freeze_balance_contract, options);
            if (message.unfreeze_balance_contract != null && message.hasOwnProperty("unfreeze_balance_contract"))
                object.unfreeze_balance_contract = $root.TronSignTx.TronContract.TronUnfreezeBalanceContract.toObject(message.unfreeze_balance_contract, options);
            if (message.withdraw_balance_contract != null && message.hasOwnProperty("withdraw_balance_contract"))
                object.withdraw_balance_contract = $root.TronSignTx.TronContract.TronWithdrawBalanceContract.toObject(message.withdraw_balance_contract, options);
            if (message.trigger_smart_contract != null && message.hasOwnProperty("trigger_smart_contract"))
                object.trigger_smart_contract = $root.TronSignTx.TronContract.TronTriggerSmartContract.toObject(message.trigger_smart_contract, options);
            if (message.freeze_balance_v2_contract != null && message.hasOwnProperty("freeze_balance_v2_contract"))
                object.freeze_balance_v2_contract = $root.TronSignTx.TronContract.TronFreezeBalanceV2Contract.toObject(message.freeze_balance_v2_contract, options);
            if (message.unfreeze_balance_v2_contract != null && message.hasOwnProperty("unfreeze_balance_v2_contract"))
                object.unfreeze_balance_v2_contract = $root.TronSignTx.TronContract.TronUnfreezeBalanceV2Contract.toObject(message.unfreeze_balance_v2_contract, options);
            if (message.withdraw_expire_unfreeze_contract != null && message.hasOwnProperty("withdraw_expire_unfreeze_contract"))
                object.withdraw_expire_unfreeze_contract = $root.TronSignTx.TronContract.TronWithdrawExpireUnfreezeContract.toObject(message.withdraw_expire_unfreeze_contract, options);
            if (message.delegate_resource_contract != null && message.hasOwnProperty("delegate_resource_contract"))
                object.delegate_resource_contract = $root.TronSignTx.TronContract.TronDelegateResourceContract.toObject(message.delegate_resource_contract, options);
            if (message.undelegate_resource_contract != null && message.hasOwnProperty("undelegate_resource_contract"))
                object.undelegate_resource_contract = $root.TronSignTx.TronContract.TronUnDelegateResourceContract.toObject(message.undelegate_resource_contract, options);
            if (message.cancel_all_unfreeze_v2_contract != null && message.hasOwnProperty("cancel_all_unfreeze_v2_contract"))
                object.cancel_all_unfreeze_v2_contract = $root.TronSignTx.TronContract.TronCancelAllUnfreezeV2Contract.toObject(message.cancel_all_unfreeze_v2_contract, options);
            return object;
        };

        TronContract.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        TronContract.TronTransferContract = (function() {

            function TronTransferContract(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            TronTransferContract.prototype.to_address = "";
            TronTransferContract.prototype.amount = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

            TronTransferContract.create = function create(properties) {
                return new TronTransferContract(properties);
            };

            TronTransferContract.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.to_address != null && Object.hasOwnProperty.call(message, "to_address"))
                    writer.uint32(18).string(message.to_address);
                if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
                    writer.uint32(24).uint64(message.amount);
                return writer;
            };

            TronTransferContract.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            TronTransferContract.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TronSignTx.TronContract.TronTransferContract();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 2:
                        message.to_address = reader.string();
                        break;
                    case 3:
                        message.amount = reader.uint64();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            TronTransferContract.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            TronTransferContract.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.to_address != null && message.hasOwnProperty("to_address"))
                    if (!$util.isString(message.to_address))
                        return "to_address: string expected";
                if (message.amount != null && message.hasOwnProperty("amount"))
                    if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
                        return "amount: integer|Long expected";
                return null;
            };

            TronTransferContract.fromObject = function fromObject(object) {
                if (object instanceof $root.TronSignTx.TronContract.TronTransferContract)
                    return object;
                var message = new $root.TronSignTx.TronContract.TronTransferContract();
                if (object.to_address != null)
                    message.to_address = String(object.to_address);
                if (object.amount != null)
                    if ($util.Long)
                        (message.amount = $util.Long.fromValue(object.amount)).unsigned = true;
                    else if (typeof object.amount === "string")
                        message.amount = parseInt(object.amount, 10);
                    else if (typeof object.amount === "number")
                        message.amount = object.amount;
                    else if (typeof object.amount === "object")
                        message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber(true);
                return message;
            };

            TronTransferContract.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.to_address = "";
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, true);
                        object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.amount = options.longs === String ? "0" : 0;
                }
                if (message.to_address != null && message.hasOwnProperty("to_address"))
                    object.to_address = message.to_address;
                if (message.amount != null && message.hasOwnProperty("amount"))
                    if (typeof message.amount === "number")
                        object.amount = options.longs === String ? String(message.amount) : message.amount;
                    else
                        object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber(true) : message.amount;
                return object;
            };

            TronTransferContract.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return TronTransferContract;
        })();

        TronContract.TronTriggerSmartContract = (function() {

            function TronTriggerSmartContract(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            TronTriggerSmartContract.prototype.contract_address = "";
            TronTriggerSmartContract.prototype.call_value = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
            TronTriggerSmartContract.prototype.data = $util.newBuffer([]);
            TronTriggerSmartContract.prototype.call_token_value = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
            TronTriggerSmartContract.prototype.asset_id = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

            TronTriggerSmartContract.create = function create(properties) {
                return new TronTriggerSmartContract(properties);
            };

            TronTriggerSmartContract.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.contract_address != null && Object.hasOwnProperty.call(message, "contract_address"))
                    writer.uint32(18).string(message.contract_address);
                if (message.call_value != null && Object.hasOwnProperty.call(message, "call_value"))
                    writer.uint32(24).uint64(message.call_value);
                if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                    writer.uint32(34).bytes(message.data);
                if (message.call_token_value != null && Object.hasOwnProperty.call(message, "call_token_value"))
                    writer.uint32(40).uint64(message.call_token_value);
                if (message.asset_id != null && Object.hasOwnProperty.call(message, "asset_id"))
                    writer.uint32(48).uint64(message.asset_id);
                return writer;
            };

            TronTriggerSmartContract.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            TronTriggerSmartContract.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TronSignTx.TronContract.TronTriggerSmartContract();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 2:
                        message.contract_address = reader.string();
                        break;
                    case 3:
                        message.call_value = reader.uint64();
                        break;
                    case 4:
                        message.data = reader.bytes();
                        break;
                    case 5:
                        message.call_token_value = reader.uint64();
                        break;
                    case 6:
                        message.asset_id = reader.uint64();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            TronTriggerSmartContract.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            TronTriggerSmartContract.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.contract_address != null && message.hasOwnProperty("contract_address"))
                    if (!$util.isString(message.contract_address))
                        return "contract_address: string expected";
                if (message.call_value != null && message.hasOwnProperty("call_value"))
                    if (!$util.isInteger(message.call_value) && !(message.call_value && $util.isInteger(message.call_value.low) && $util.isInteger(message.call_value.high)))
                        return "call_value: integer|Long expected";
                if (message.data != null && message.hasOwnProperty("data"))
                    if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
                        return "data: buffer expected";
                if (message.call_token_value != null && message.hasOwnProperty("call_token_value"))
                    if (!$util.isInteger(message.call_token_value) && !(message.call_token_value && $util.isInteger(message.call_token_value.low) && $util.isInteger(message.call_token_value.high)))
                        return "call_token_value: integer|Long expected";
                if (message.asset_id != null && message.hasOwnProperty("asset_id"))
                    if (!$util.isInteger(message.asset_id) && !(message.asset_id && $util.isInteger(message.asset_id.low) && $util.isInteger(message.asset_id.high)))
                        return "asset_id: integer|Long expected";
                return null;
            };

            TronTriggerSmartContract.fromObject = function fromObject(object) {
                if (object instanceof $root.TronSignTx.TronContract.TronTriggerSmartContract)
                    return object;
                var message = new $root.TronSignTx.TronContract.TronTriggerSmartContract();
                if (object.contract_address != null)
                    message.contract_address = String(object.contract_address);
                if (object.call_value != null)
                    if ($util.Long)
                        (message.call_value = $util.Long.fromValue(object.call_value)).unsigned = true;
                    else if (typeof object.call_value === "string")
                        message.call_value = parseInt(object.call_value, 10);
                    else if (typeof object.call_value === "number")
                        message.call_value = object.call_value;
                    else if (typeof object.call_value === "object")
                        message.call_value = new $util.LongBits(object.call_value.low >>> 0, object.call_value.high >>> 0).toNumber(true);
                if (object.data != null)
                    if (typeof object.data === "string")
                        $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
                    else if (object.data.length)
                        message.data = object.data;
                if (object.call_token_value != null)
                    if ($util.Long)
                        (message.call_token_value = $util.Long.fromValue(object.call_token_value)).unsigned = true;
                    else if (typeof object.call_token_value === "string")
                        message.call_token_value = parseInt(object.call_token_value, 10);
                    else if (typeof object.call_token_value === "number")
                        message.call_token_value = object.call_token_value;
                    else if (typeof object.call_token_value === "object")
                        message.call_token_value = new $util.LongBits(object.call_token_value.low >>> 0, object.call_token_value.high >>> 0).toNumber(true);
                if (object.asset_id != null)
                    if ($util.Long)
                        (message.asset_id = $util.Long.fromValue(object.asset_id)).unsigned = true;
                    else if (typeof object.asset_id === "string")
                        message.asset_id = parseInt(object.asset_id, 10);
                    else if (typeof object.asset_id === "number")
                        message.asset_id = object.asset_id;
                    else if (typeof object.asset_id === "object")
                        message.asset_id = new $util.LongBits(object.asset_id.low >>> 0, object.asset_id.high >>> 0).toNumber(true);
                return message;
            };

            TronTriggerSmartContract.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.contract_address = "";
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, true);
                        object.call_value = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.call_value = options.longs === String ? "0" : 0;
                    if (options.bytes === String)
                        object.data = "";
                    else {
                        object.data = [];
                        if (options.bytes !== Array)
                            object.data = $util.newBuffer(object.data);
                    }
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, true);
                        object.call_token_value = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.call_token_value = options.longs === String ? "0" : 0;
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, true);
                        object.asset_id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.asset_id = options.longs === String ? "0" : 0;
                }
                if (message.contract_address != null && message.hasOwnProperty("contract_address"))
                    object.contract_address = message.contract_address;
                if (message.call_value != null && message.hasOwnProperty("call_value"))
                    if (typeof message.call_value === "number")
                        object.call_value = options.longs === String ? String(message.call_value) : message.call_value;
                    else
                        object.call_value = options.longs === String ? $util.Long.prototype.toString.call(message.call_value) : options.longs === Number ? new $util.LongBits(message.call_value.low >>> 0, message.call_value.high >>> 0).toNumber(true) : message.call_value;
                if (message.data != null && message.hasOwnProperty("data"))
                    object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
                if (message.call_token_value != null && message.hasOwnProperty("call_token_value"))
                    if (typeof message.call_token_value === "number")
                        object.call_token_value = options.longs === String ? String(message.call_token_value) : message.call_token_value;
                    else
                        object.call_token_value = options.longs === String ? $util.Long.prototype.toString.call(message.call_token_value) : options.longs === Number ? new $util.LongBits(message.call_token_value.low >>> 0, message.call_token_value.high >>> 0).toNumber(true) : message.call_token_value;
                if (message.asset_id != null && message.hasOwnProperty("asset_id"))
                    if (typeof message.asset_id === "number")
                        object.asset_id = options.longs === String ? String(message.asset_id) : message.asset_id;
                    else
                        object.asset_id = options.longs === String ? $util.Long.prototype.toString.call(message.asset_id) : options.longs === Number ? new $util.LongBits(message.asset_id.low >>> 0, message.asset_id.high >>> 0).toNumber(true) : message.asset_id;
                return object;
            };

            TronTriggerSmartContract.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return TronTriggerSmartContract;
        })();

        TronContract.TronResourceCode = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "BANDWIDTH"] = 0;
            values[valuesById[1] = "ENERGY"] = 1;
            values[valuesById[2] = "TRON_POWER"] = 2;
            return values;
        })();

        TronContract.TronFreezeBalanceContract = (function() {

            function TronFreezeBalanceContract(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            TronFreezeBalanceContract.prototype.frozen_balance = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
            TronFreezeBalanceContract.prototype.frozen_duration = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
            TronFreezeBalanceContract.prototype.resource = 0;
            TronFreezeBalanceContract.prototype.receiver_address = "";

            TronFreezeBalanceContract.create = function create(properties) {
                return new TronFreezeBalanceContract(properties);
            };

            TronFreezeBalanceContract.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.frozen_balance != null && Object.hasOwnProperty.call(message, "frozen_balance"))
                    writer.uint32(8).uint64(message.frozen_balance);
                if (message.frozen_duration != null && Object.hasOwnProperty.call(message, "frozen_duration"))
                    writer.uint32(16).uint64(message.frozen_duration);
                if (message.resource != null && Object.hasOwnProperty.call(message, "resource"))
                    writer.uint32(24).int32(message.resource);
                if (message.receiver_address != null && Object.hasOwnProperty.call(message, "receiver_address"))
                    writer.uint32(34).string(message.receiver_address);
                return writer;
            };

            TronFreezeBalanceContract.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            TronFreezeBalanceContract.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TronSignTx.TronContract.TronFreezeBalanceContract();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.frozen_balance = reader.uint64();
                        break;
                    case 2:
                        message.frozen_duration = reader.uint64();
                        break;
                    case 3:
                        message.resource = reader.int32();
                        break;
                    case 4:
                        message.receiver_address = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            TronFreezeBalanceContract.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            TronFreezeBalanceContract.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.frozen_balance != null && message.hasOwnProperty("frozen_balance"))
                    if (!$util.isInteger(message.frozen_balance) && !(message.frozen_balance && $util.isInteger(message.frozen_balance.low) && $util.isInteger(message.frozen_balance.high)))
                        return "frozen_balance: integer|Long expected";
                if (message.frozen_duration != null && message.hasOwnProperty("frozen_duration"))
                    if (!$util.isInteger(message.frozen_duration) && !(message.frozen_duration && $util.isInteger(message.frozen_duration.low) && $util.isInteger(message.frozen_duration.high)))
                        return "frozen_duration: integer|Long expected";
                if (message.resource != null && message.hasOwnProperty("resource"))
                    switch (message.resource) {
                    default:
                        return "resource: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                        break;
                    }
                if (message.receiver_address != null && message.hasOwnProperty("receiver_address"))
                    if (!$util.isString(message.receiver_address))
                        return "receiver_address: string expected";
                return null;
            };

            TronFreezeBalanceContract.fromObject = function fromObject(object) {
                if (object instanceof $root.TronSignTx.TronContract.TronFreezeBalanceContract)
                    return object;
                var message = new $root.TronSignTx.TronContract.TronFreezeBalanceContract();
                if (object.frozen_balance != null)
                    if ($util.Long)
                        (message.frozen_balance = $util.Long.fromValue(object.frozen_balance)).unsigned = true;
                    else if (typeof object.frozen_balance === "string")
                        message.frozen_balance = parseInt(object.frozen_balance, 10);
                    else if (typeof object.frozen_balance === "number")
                        message.frozen_balance = object.frozen_balance;
                    else if (typeof object.frozen_balance === "object")
                        message.frozen_balance = new $util.LongBits(object.frozen_balance.low >>> 0, object.frozen_balance.high >>> 0).toNumber(true);
                if (object.frozen_duration != null)
                    if ($util.Long)
                        (message.frozen_duration = $util.Long.fromValue(object.frozen_duration)).unsigned = true;
                    else if (typeof object.frozen_duration === "string")
                        message.frozen_duration = parseInt(object.frozen_duration, 10);
                    else if (typeof object.frozen_duration === "number")
                        message.frozen_duration = object.frozen_duration;
                    else if (typeof object.frozen_duration === "object")
                        message.frozen_duration = new $util.LongBits(object.frozen_duration.low >>> 0, object.frozen_duration.high >>> 0).toNumber(true);
                switch (object.resource) {
                case "BANDWIDTH":
                case 0:
                    message.resource = 0;
                    break;
                case "ENERGY":
                case 1:
                    message.resource = 1;
                    break;
                case "TRON_POWER":
                case 2:
                    message.resource = 2;
                    break;
                }
                if (object.receiver_address != null)
                    message.receiver_address = String(object.receiver_address);
                return message;
            };

            TronFreezeBalanceContract.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, true);
                        object.frozen_balance = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.frozen_balance = options.longs === String ? "0" : 0;
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, true);
                        object.frozen_duration = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.frozen_duration = options.longs === String ? "0" : 0;
                    object.resource = options.enums === String ? "BANDWIDTH" : 0;
                    object.receiver_address = "";
                }
                if (message.frozen_balance != null && message.hasOwnProperty("frozen_balance"))
                    if (typeof message.frozen_balance === "number")
                        object.frozen_balance = options.longs === String ? String(message.frozen_balance) : message.frozen_balance;
                    else
                        object.frozen_balance = options.longs === String ? $util.Long.prototype.toString.call(message.frozen_balance) : options.longs === Number ? new $util.LongBits(message.frozen_balance.low >>> 0, message.frozen_balance.high >>> 0).toNumber(true) : message.frozen_balance;
                if (message.frozen_duration != null && message.hasOwnProperty("frozen_duration"))
                    if (typeof message.frozen_duration === "number")
                        object.frozen_duration = options.longs === String ? String(message.frozen_duration) : message.frozen_duration;
                    else
                        object.frozen_duration = options.longs === String ? $util.Long.prototype.toString.call(message.frozen_duration) : options.longs === Number ? new $util.LongBits(message.frozen_duration.low >>> 0, message.frozen_duration.high >>> 0).toNumber(true) : message.frozen_duration;
                if (message.resource != null && message.hasOwnProperty("resource"))
                    object.resource = options.enums === String ? $root.TronSignTx.TronContract.TronResourceCode[message.resource] : message.resource;
                if (message.receiver_address != null && message.hasOwnProperty("receiver_address"))
                    object.receiver_address = message.receiver_address;
                return object;
            };

            TronFreezeBalanceContract.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return TronFreezeBalanceContract;
        })();

        TronContract.TronUnfreezeBalanceContract = (function() {

            function TronUnfreezeBalanceContract(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            TronUnfreezeBalanceContract.prototype.resource = 0;
            TronUnfreezeBalanceContract.prototype.receiver_address = "";

            TronUnfreezeBalanceContract.create = function create(properties) {
                return new TronUnfreezeBalanceContract(properties);
            };

            TronUnfreezeBalanceContract.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.resource != null && Object.hasOwnProperty.call(message, "resource"))
                    writer.uint32(8).int32(message.resource);
                if (message.receiver_address != null && Object.hasOwnProperty.call(message, "receiver_address"))
                    writer.uint32(18).string(message.receiver_address);
                return writer;
            };

            TronUnfreezeBalanceContract.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            TronUnfreezeBalanceContract.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TronSignTx.TronContract.TronUnfreezeBalanceContract();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.resource = reader.int32();
                        break;
                    case 2:
                        message.receiver_address = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            TronUnfreezeBalanceContract.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            TronUnfreezeBalanceContract.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.resource != null && message.hasOwnProperty("resource"))
                    switch (message.resource) {
                    default:
                        return "resource: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                        break;
                    }
                if (message.receiver_address != null && message.hasOwnProperty("receiver_address"))
                    if (!$util.isString(message.receiver_address))
                        return "receiver_address: string expected";
                return null;
            };

            TronUnfreezeBalanceContract.fromObject = function fromObject(object) {
                if (object instanceof $root.TronSignTx.TronContract.TronUnfreezeBalanceContract)
                    return object;
                var message = new $root.TronSignTx.TronContract.TronUnfreezeBalanceContract();
                switch (object.resource) {
                case "BANDWIDTH":
                case 0:
                    message.resource = 0;
                    break;
                case "ENERGY":
                case 1:
                    message.resource = 1;
                    break;
                case "TRON_POWER":
                case 2:
                    message.resource = 2;
                    break;
                }
                if (object.receiver_address != null)
                    message.receiver_address = String(object.receiver_address);
                return message;
            };

            TronUnfreezeBalanceContract.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.resource = options.enums === String ? "BANDWIDTH" : 0;
                    object.receiver_address = "";
                }
                if (message.resource != null && message.hasOwnProperty("resource"))
                    object.resource = options.enums === String ? $root.TronSignTx.TronContract.TronResourceCode[message.resource] : message.resource;
                if (message.receiver_address != null && message.hasOwnProperty("receiver_address"))
                    object.receiver_address = message.receiver_address;
                return object;
            };

            TronUnfreezeBalanceContract.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return TronUnfreezeBalanceContract;
        })();

        TronContract.TronWithdrawBalanceContract = (function() {

            function TronWithdrawBalanceContract(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            TronWithdrawBalanceContract.prototype.owner_address = $util.newBuffer([]);

            TronWithdrawBalanceContract.create = function create(properties) {
                return new TronWithdrawBalanceContract(properties);
            };

            TronWithdrawBalanceContract.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.owner_address != null && Object.hasOwnProperty.call(message, "owner_address"))
                    writer.uint32(10).bytes(message.owner_address);
                return writer;
            };

            TronWithdrawBalanceContract.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            TronWithdrawBalanceContract.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TronSignTx.TronContract.TronWithdrawBalanceContract();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.owner_address = reader.bytes();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            TronWithdrawBalanceContract.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            TronWithdrawBalanceContract.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.owner_address != null && message.hasOwnProperty("owner_address"))
                    if (!(message.owner_address && typeof message.owner_address.length === "number" || $util.isString(message.owner_address)))
                        return "owner_address: buffer expected";
                return null;
            };

            TronWithdrawBalanceContract.fromObject = function fromObject(object) {
                if (object instanceof $root.TronSignTx.TronContract.TronWithdrawBalanceContract)
                    return object;
                var message = new $root.TronSignTx.TronContract.TronWithdrawBalanceContract();
                if (object.owner_address != null)
                    if (typeof object.owner_address === "string")
                        $util.base64.decode(object.owner_address, message.owner_address = $util.newBuffer($util.base64.length(object.owner_address)), 0);
                    else if (object.owner_address.length)
                        message.owner_address = object.owner_address;
                return message;
            };

            TronWithdrawBalanceContract.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults)
                    if (options.bytes === String)
                        object.owner_address = "";
                    else {
                        object.owner_address = [];
                        if (options.bytes !== Array)
                            object.owner_address = $util.newBuffer(object.owner_address);
                    }
                if (message.owner_address != null && message.hasOwnProperty("owner_address"))
                    object.owner_address = options.bytes === String ? $util.base64.encode(message.owner_address, 0, message.owner_address.length) : options.bytes === Array ? Array.prototype.slice.call(message.owner_address) : message.owner_address;
                return object;
            };

            TronWithdrawBalanceContract.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return TronWithdrawBalanceContract;
        })();

        TronContract.TronFreezeBalanceV2Contract = (function() {

            function TronFreezeBalanceV2Contract(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            TronFreezeBalanceV2Contract.prototype.frozen_balance = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
            TronFreezeBalanceV2Contract.prototype.resource = 0;

            TronFreezeBalanceV2Contract.create = function create(properties) {
                return new TronFreezeBalanceV2Contract(properties);
            };

            TronFreezeBalanceV2Contract.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.frozen_balance != null && Object.hasOwnProperty.call(message, "frozen_balance"))
                    writer.uint32(16).uint64(message.frozen_balance);
                if (message.resource != null && Object.hasOwnProperty.call(message, "resource"))
                    writer.uint32(24).int32(message.resource);
                return writer;
            };

            TronFreezeBalanceV2Contract.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            TronFreezeBalanceV2Contract.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TronSignTx.TronContract.TronFreezeBalanceV2Contract();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 2:
                        message.frozen_balance = reader.uint64();
                        break;
                    case 3:
                        message.resource = reader.int32();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            TronFreezeBalanceV2Contract.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            TronFreezeBalanceV2Contract.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.frozen_balance != null && message.hasOwnProperty("frozen_balance"))
                    if (!$util.isInteger(message.frozen_balance) && !(message.frozen_balance && $util.isInteger(message.frozen_balance.low) && $util.isInteger(message.frozen_balance.high)))
                        return "frozen_balance: integer|Long expected";
                if (message.resource != null && message.hasOwnProperty("resource"))
                    switch (message.resource) {
                    default:
                        return "resource: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                        break;
                    }
                return null;
            };

            TronFreezeBalanceV2Contract.fromObject = function fromObject(object) {
                if (object instanceof $root.TronSignTx.TronContract.TronFreezeBalanceV2Contract)
                    return object;
                var message = new $root.TronSignTx.TronContract.TronFreezeBalanceV2Contract();
                if (object.frozen_balance != null)
                    if ($util.Long)
                        (message.frozen_balance = $util.Long.fromValue(object.frozen_balance)).unsigned = true;
                    else if (typeof object.frozen_balance === "string")
                        message.frozen_balance = parseInt(object.frozen_balance, 10);
                    else if (typeof object.frozen_balance === "number")
                        message.frozen_balance = object.frozen_balance;
                    else if (typeof object.frozen_balance === "object")
                        message.frozen_balance = new $util.LongBits(object.frozen_balance.low >>> 0, object.frozen_balance.high >>> 0).toNumber(true);
                switch (object.resource) {
                case "BANDWIDTH":
                case 0:
                    message.resource = 0;
                    break;
                case "ENERGY":
                case 1:
                    message.resource = 1;
                    break;
                case "TRON_POWER":
                case 2:
                    message.resource = 2;
                    break;
                }
                return message;
            };

            TronFreezeBalanceV2Contract.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, true);
                        object.frozen_balance = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.frozen_balance = options.longs === String ? "0" : 0;
                    object.resource = options.enums === String ? "BANDWIDTH" : 0;
                }
                if (message.frozen_balance != null && message.hasOwnProperty("frozen_balance"))
                    if (typeof message.frozen_balance === "number")
                        object.frozen_balance = options.longs === String ? String(message.frozen_balance) : message.frozen_balance;
                    else
                        object.frozen_balance = options.longs === String ? $util.Long.prototype.toString.call(message.frozen_balance) : options.longs === Number ? new $util.LongBits(message.frozen_balance.low >>> 0, message.frozen_balance.high >>> 0).toNumber(true) : message.frozen_balance;
                if (message.resource != null && message.hasOwnProperty("resource"))
                    object.resource = options.enums === String ? $root.TronSignTx.TronContract.TronResourceCode[message.resource] : message.resource;
                return object;
            };

            TronFreezeBalanceV2Contract.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return TronFreezeBalanceV2Contract;
        })();

        TronContract.TronUnfreezeBalanceV2Contract = (function() {

            function TronUnfreezeBalanceV2Contract(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            TronUnfreezeBalanceV2Contract.prototype.unfreeze_balance = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
            TronUnfreezeBalanceV2Contract.prototype.resource = 0;

            TronUnfreezeBalanceV2Contract.create = function create(properties) {
                return new TronUnfreezeBalanceV2Contract(properties);
            };

            TronUnfreezeBalanceV2Contract.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.unfreeze_balance != null && Object.hasOwnProperty.call(message, "unfreeze_balance"))
                    writer.uint32(16).uint64(message.unfreeze_balance);
                if (message.resource != null && Object.hasOwnProperty.call(message, "resource"))
                    writer.uint32(24).int32(message.resource);
                return writer;
            };

            TronUnfreezeBalanceV2Contract.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            TronUnfreezeBalanceV2Contract.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TronSignTx.TronContract.TronUnfreezeBalanceV2Contract();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 2:
                        message.unfreeze_balance = reader.uint64();
                        break;
                    case 3:
                        message.resource = reader.int32();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            TronUnfreezeBalanceV2Contract.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            TronUnfreezeBalanceV2Contract.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.unfreeze_balance != null && message.hasOwnProperty("unfreeze_balance"))
                    if (!$util.isInteger(message.unfreeze_balance) && !(message.unfreeze_balance && $util.isInteger(message.unfreeze_balance.low) && $util.isInteger(message.unfreeze_balance.high)))
                        return "unfreeze_balance: integer|Long expected";
                if (message.resource != null && message.hasOwnProperty("resource"))
                    switch (message.resource) {
                    default:
                        return "resource: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                        break;
                    }
                return null;
            };

            TronUnfreezeBalanceV2Contract.fromObject = function fromObject(object) {
                if (object instanceof $root.TronSignTx.TronContract.TronUnfreezeBalanceV2Contract)
                    return object;
                var message = new $root.TronSignTx.TronContract.TronUnfreezeBalanceV2Contract();
                if (object.unfreeze_balance != null)
                    if ($util.Long)
                        (message.unfreeze_balance = $util.Long.fromValue(object.unfreeze_balance)).unsigned = true;
                    else if (typeof object.unfreeze_balance === "string")
                        message.unfreeze_balance = parseInt(object.unfreeze_balance, 10);
                    else if (typeof object.unfreeze_balance === "number")
                        message.unfreeze_balance = object.unfreeze_balance;
                    else if (typeof object.unfreeze_balance === "object")
                        message.unfreeze_balance = new $util.LongBits(object.unfreeze_balance.low >>> 0, object.unfreeze_balance.high >>> 0).toNumber(true);
                switch (object.resource) {
                case "BANDWIDTH":
                case 0:
                    message.resource = 0;
                    break;
                case "ENERGY":
                case 1:
                    message.resource = 1;
                    break;
                case "TRON_POWER":
                case 2:
                    message.resource = 2;
                    break;
                }
                return message;
            };

            TronUnfreezeBalanceV2Contract.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, true);
                        object.unfreeze_balance = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.unfreeze_balance = options.longs === String ? "0" : 0;
                    object.resource = options.enums === String ? "BANDWIDTH" : 0;
                }
                if (message.unfreeze_balance != null && message.hasOwnProperty("unfreeze_balance"))
                    if (typeof message.unfreeze_balance === "number")
                        object.unfreeze_balance = options.longs === String ? String(message.unfreeze_balance) : message.unfreeze_balance;
                    else
                        object.unfreeze_balance = options.longs === String ? $util.Long.prototype.toString.call(message.unfreeze_balance) : options.longs === Number ? new $util.LongBits(message.unfreeze_balance.low >>> 0, message.unfreeze_balance.high >>> 0).toNumber(true) : message.unfreeze_balance;
                if (message.resource != null && message.hasOwnProperty("resource"))
                    object.resource = options.enums === String ? $root.TronSignTx.TronContract.TronResourceCode[message.resource] : message.resource;
                return object;
            };

            TronUnfreezeBalanceV2Contract.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return TronUnfreezeBalanceV2Contract;
        })();

        TronContract.TronWithdrawExpireUnfreezeContract = (function() {

            function TronWithdrawExpireUnfreezeContract(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            TronWithdrawExpireUnfreezeContract.create = function create(properties) {
                return new TronWithdrawExpireUnfreezeContract(properties);
            };

            TronWithdrawExpireUnfreezeContract.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            TronWithdrawExpireUnfreezeContract.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            TronWithdrawExpireUnfreezeContract.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TronSignTx.TronContract.TronWithdrawExpireUnfreezeContract();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            TronWithdrawExpireUnfreezeContract.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            TronWithdrawExpireUnfreezeContract.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            TronWithdrawExpireUnfreezeContract.fromObject = function fromObject(object) {
                if (object instanceof $root.TronSignTx.TronContract.TronWithdrawExpireUnfreezeContract)
                    return object;
                return new $root.TronSignTx.TronContract.TronWithdrawExpireUnfreezeContract();
            };

            TronWithdrawExpireUnfreezeContract.toObject = function toObject() {
                return {};
            };

            TronWithdrawExpireUnfreezeContract.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return TronWithdrawExpireUnfreezeContract;
        })();

        TronContract.TronDelegateResourceContract = (function() {

            function TronDelegateResourceContract(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            TronDelegateResourceContract.prototype.resource = 0;
            TronDelegateResourceContract.prototype.balance = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
            TronDelegateResourceContract.prototype.receiver_address = "";
            TronDelegateResourceContract.prototype.lock = false;
            TronDelegateResourceContract.prototype.lock_period = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

            TronDelegateResourceContract.create = function create(properties) {
                return new TronDelegateResourceContract(properties);
            };

            TronDelegateResourceContract.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.resource != null && Object.hasOwnProperty.call(message, "resource"))
                    writer.uint32(16).int32(message.resource);
                if (message.balance != null && Object.hasOwnProperty.call(message, "balance"))
                    writer.uint32(24).uint64(message.balance);
                if (message.receiver_address != null && Object.hasOwnProperty.call(message, "receiver_address"))
                    writer.uint32(34).string(message.receiver_address);
                if (message.lock != null && Object.hasOwnProperty.call(message, "lock"))
                    writer.uint32(40).bool(message.lock);
                if (message.lock_period != null && Object.hasOwnProperty.call(message, "lock_period"))
                    writer.uint32(48).uint64(message.lock_period);
                return writer;
            };

            TronDelegateResourceContract.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            TronDelegateResourceContract.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TronSignTx.TronContract.TronDelegateResourceContract();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 2:
                        message.resource = reader.int32();
                        break;
                    case 3:
                        message.balance = reader.uint64();
                        break;
                    case 4:
                        message.receiver_address = reader.string();
                        break;
                    case 5:
                        message.lock = reader.bool();
                        break;
                    case 6:
                        message.lock_period = reader.uint64();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            TronDelegateResourceContract.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            TronDelegateResourceContract.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.resource != null && message.hasOwnProperty("resource"))
                    switch (message.resource) {
                    default:
                        return "resource: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                        break;
                    }
                if (message.balance != null && message.hasOwnProperty("balance"))
                    if (!$util.isInteger(message.balance) && !(message.balance && $util.isInteger(message.balance.low) && $util.isInteger(message.balance.high)))
                        return "balance: integer|Long expected";
                if (message.receiver_address != null && message.hasOwnProperty("receiver_address"))
                    if (!$util.isString(message.receiver_address))
                        return "receiver_address: string expected";
                if (message.lock != null && message.hasOwnProperty("lock"))
                    if (typeof message.lock !== "boolean")
                        return "lock: boolean expected";
                if (message.lock_period != null && message.hasOwnProperty("lock_period"))
                    if (!$util.isInteger(message.lock_period) && !(message.lock_period && $util.isInteger(message.lock_period.low) && $util.isInteger(message.lock_period.high)))
                        return "lock_period: integer|Long expected";
                return null;
            };

            TronDelegateResourceContract.fromObject = function fromObject(object) {
                if (object instanceof $root.TronSignTx.TronContract.TronDelegateResourceContract)
                    return object;
                var message = new $root.TronSignTx.TronContract.TronDelegateResourceContract();
                switch (object.resource) {
                case "BANDWIDTH":
                case 0:
                    message.resource = 0;
                    break;
                case "ENERGY":
                case 1:
                    message.resource = 1;
                    break;
                case "TRON_POWER":
                case 2:
                    message.resource = 2;
                    break;
                }
                if (object.balance != null)
                    if ($util.Long)
                        (message.balance = $util.Long.fromValue(object.balance)).unsigned = true;
                    else if (typeof object.balance === "string")
                        message.balance = parseInt(object.balance, 10);
                    else if (typeof object.balance === "number")
                        message.balance = object.balance;
                    else if (typeof object.balance === "object")
                        message.balance = new $util.LongBits(object.balance.low >>> 0, object.balance.high >>> 0).toNumber(true);
                if (object.receiver_address != null)
                    message.receiver_address = String(object.receiver_address);
                if (object.lock != null)
                    message.lock = Boolean(object.lock);
                if (object.lock_period != null)
                    if ($util.Long)
                        (message.lock_period = $util.Long.fromValue(object.lock_period)).unsigned = true;
                    else if (typeof object.lock_period === "string")
                        message.lock_period = parseInt(object.lock_period, 10);
                    else if (typeof object.lock_period === "number")
                        message.lock_period = object.lock_period;
                    else if (typeof object.lock_period === "object")
                        message.lock_period = new $util.LongBits(object.lock_period.low >>> 0, object.lock_period.high >>> 0).toNumber(true);
                return message;
            };

            TronDelegateResourceContract.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.resource = options.enums === String ? "BANDWIDTH" : 0;
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, true);
                        object.balance = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.balance = options.longs === String ? "0" : 0;
                    object.receiver_address = "";
                    object.lock = false;
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, true);
                        object.lock_period = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.lock_period = options.longs === String ? "0" : 0;
                }
                if (message.resource != null && message.hasOwnProperty("resource"))
                    object.resource = options.enums === String ? $root.TronSignTx.TronContract.TronResourceCode[message.resource] : message.resource;
                if (message.balance != null && message.hasOwnProperty("balance"))
                    if (typeof message.balance === "number")
                        object.balance = options.longs === String ? String(message.balance) : message.balance;
                    else
                        object.balance = options.longs === String ? $util.Long.prototype.toString.call(message.balance) : options.longs === Number ? new $util.LongBits(message.balance.low >>> 0, message.balance.high >>> 0).toNumber(true) : message.balance;
                if (message.receiver_address != null && message.hasOwnProperty("receiver_address"))
                    object.receiver_address = message.receiver_address;
                if (message.lock != null && message.hasOwnProperty("lock"))
                    object.lock = message.lock;
                if (message.lock_period != null && message.hasOwnProperty("lock_period"))
                    if (typeof message.lock_period === "number")
                        object.lock_period = options.longs === String ? String(message.lock_period) : message.lock_period;
                    else
                        object.lock_period = options.longs === String ? $util.Long.prototype.toString.call(message.lock_period) : options.longs === Number ? new $util.LongBits(message.lock_period.low >>> 0, message.lock_period.high >>> 0).toNumber(true) : message.lock_period;
                return object;
            };

            TronDelegateResourceContract.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return TronDelegateResourceContract;
        })();

        TronContract.TronUnDelegateResourceContract = (function() {

            function TronUnDelegateResourceContract(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            TronUnDelegateResourceContract.prototype.resource = 0;
            TronUnDelegateResourceContract.prototype.balance = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
            TronUnDelegateResourceContract.prototype.receiver_address = "";

            TronUnDelegateResourceContract.create = function create(properties) {
                return new TronUnDelegateResourceContract(properties);
            };

            TronUnDelegateResourceContract.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.resource != null && Object.hasOwnProperty.call(message, "resource"))
                    writer.uint32(16).int32(message.resource);
                if (message.balance != null && Object.hasOwnProperty.call(message, "balance"))
                    writer.uint32(24).uint64(message.balance);
                if (message.receiver_address != null && Object.hasOwnProperty.call(message, "receiver_address"))
                    writer.uint32(34).string(message.receiver_address);
                return writer;
            };

            TronUnDelegateResourceContract.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            TronUnDelegateResourceContract.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TronSignTx.TronContract.TronUnDelegateResourceContract();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 2:
                        message.resource = reader.int32();
                        break;
                    case 3:
                        message.balance = reader.uint64();
                        break;
                    case 4:
                        message.receiver_address = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            TronUnDelegateResourceContract.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            TronUnDelegateResourceContract.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.resource != null && message.hasOwnProperty("resource"))
                    switch (message.resource) {
                    default:
                        return "resource: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                        break;
                    }
                if (message.balance != null && message.hasOwnProperty("balance"))
                    if (!$util.isInteger(message.balance) && !(message.balance && $util.isInteger(message.balance.low) && $util.isInteger(message.balance.high)))
                        return "balance: integer|Long expected";
                if (message.receiver_address != null && message.hasOwnProperty("receiver_address"))
                    if (!$util.isString(message.receiver_address))
                        return "receiver_address: string expected";
                return null;
            };

            TronUnDelegateResourceContract.fromObject = function fromObject(object) {
                if (object instanceof $root.TronSignTx.TronContract.TronUnDelegateResourceContract)
                    return object;
                var message = new $root.TronSignTx.TronContract.TronUnDelegateResourceContract();
                switch (object.resource) {
                case "BANDWIDTH":
                case 0:
                    message.resource = 0;
                    break;
                case "ENERGY":
                case 1:
                    message.resource = 1;
                    break;
                case "TRON_POWER":
                case 2:
                    message.resource = 2;
                    break;
                }
                if (object.balance != null)
                    if ($util.Long)
                        (message.balance = $util.Long.fromValue(object.balance)).unsigned = true;
                    else if (typeof object.balance === "string")
                        message.balance = parseInt(object.balance, 10);
                    else if (typeof object.balance === "number")
                        message.balance = object.balance;
                    else if (typeof object.balance === "object")
                        message.balance = new $util.LongBits(object.balance.low >>> 0, object.balance.high >>> 0).toNumber(true);
                if (object.receiver_address != null)
                    message.receiver_address = String(object.receiver_address);
                return message;
            };

            TronUnDelegateResourceContract.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.resource = options.enums === String ? "BANDWIDTH" : 0;
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, true);
                        object.balance = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.balance = options.longs === String ? "0" : 0;
                    object.receiver_address = "";
                }
                if (message.resource != null && message.hasOwnProperty("resource"))
                    object.resource = options.enums === String ? $root.TronSignTx.TronContract.TronResourceCode[message.resource] : message.resource;
                if (message.balance != null && message.hasOwnProperty("balance"))
                    if (typeof message.balance === "number")
                        object.balance = options.longs === String ? String(message.balance) : message.balance;
                    else
                        object.balance = options.longs === String ? $util.Long.prototype.toString.call(message.balance) : options.longs === Number ? new $util.LongBits(message.balance.low >>> 0, message.balance.high >>> 0).toNumber(true) : message.balance;
                if (message.receiver_address != null && message.hasOwnProperty("receiver_address"))
                    object.receiver_address = message.receiver_address;
                return object;
            };

            TronUnDelegateResourceContract.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return TronUnDelegateResourceContract;
        })();

        TronContract.TronCancelAllUnfreezeV2Contract = (function() {

            function TronCancelAllUnfreezeV2Contract(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            TronCancelAllUnfreezeV2Contract.create = function create(properties) {
                return new TronCancelAllUnfreezeV2Contract(properties);
            };

            TronCancelAllUnfreezeV2Contract.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            TronCancelAllUnfreezeV2Contract.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            TronCancelAllUnfreezeV2Contract.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TronSignTx.TronContract.TronCancelAllUnfreezeV2Contract();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            TronCancelAllUnfreezeV2Contract.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            TronCancelAllUnfreezeV2Contract.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            TronCancelAllUnfreezeV2Contract.fromObject = function fromObject(object) {
                if (object instanceof $root.TronSignTx.TronContract.TronCancelAllUnfreezeV2Contract)
                    return object;
                return new $root.TronSignTx.TronContract.TronCancelAllUnfreezeV2Contract();
            };

            TronCancelAllUnfreezeV2Contract.toObject = function toObject() {
                return {};
            };

            TronCancelAllUnfreezeV2Contract.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return TronCancelAllUnfreezeV2Contract;
        })();

        TronContract.TronVoteWitnessContract = (function() {

            function TronVoteWitnessContract(properties) {
                this.votes = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            TronVoteWitnessContract.prototype.votes = $util.emptyArray;
            TronVoteWitnessContract.prototype.support = false;

            TronVoteWitnessContract.create = function create(properties) {
                return new TronVoteWitnessContract(properties);
            };

            TronVoteWitnessContract.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.votes != null && message.votes.length)
                    for (var i = 0; i < message.votes.length; ++i)
                        $root.TronSignTx.TronContract.TronVoteWitnessContract.Vote.encode(message.votes[i], writer.uint32(18).fork()).ldelim();
                if (message.support != null && Object.hasOwnProperty.call(message, "support"))
                    writer.uint32(24).bool(message.support);
                return writer;
            };

            TronVoteWitnessContract.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            TronVoteWitnessContract.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TronSignTx.TronContract.TronVoteWitnessContract();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 2:
                        if (!(message.votes && message.votes.length))
                            message.votes = [];
                        message.votes.push($root.TronSignTx.TronContract.TronVoteWitnessContract.Vote.decode(reader, reader.uint32()));
                        break;
                    case 3:
                        message.support = reader.bool();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            TronVoteWitnessContract.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            TronVoteWitnessContract.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.votes != null && message.hasOwnProperty("votes")) {
                    if (!Array.isArray(message.votes))
                        return "votes: array expected";
                    for (var i = 0; i < message.votes.length; ++i) {
                        var error = $root.TronSignTx.TronContract.TronVoteWitnessContract.Vote.verify(message.votes[i]);
                        if (error)
                            return "votes." + error;
                    }
                }
                if (message.support != null && message.hasOwnProperty("support"))
                    if (typeof message.support !== "boolean")
                        return "support: boolean expected";
                return null;
            };

            TronVoteWitnessContract.fromObject = function fromObject(object) {
                if (object instanceof $root.TronSignTx.TronContract.TronVoteWitnessContract)
                    return object;
                var message = new $root.TronSignTx.TronContract.TronVoteWitnessContract();
                if (object.votes) {
                    if (!Array.isArray(object.votes))
                        throw TypeError(".TronSignTx.TronContract.TronVoteWitnessContract.votes: array expected");
                    message.votes = [];
                    for (var i = 0; i < object.votes.length; ++i) {
                        if (typeof object.votes[i] !== "object")
                            throw TypeError(".TronSignTx.TronContract.TronVoteWitnessContract.votes: object expected");
                        message.votes[i] = $root.TronSignTx.TronContract.TronVoteWitnessContract.Vote.fromObject(object.votes[i]);
                    }
                }
                if (object.support != null)
                    message.support = Boolean(object.support);
                return message;
            };

            TronVoteWitnessContract.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.votes = [];
                if (options.defaults)
                    object.support = false;
                if (message.votes && message.votes.length) {
                    object.votes = [];
                    for (var j = 0; j < message.votes.length; ++j)
                        object.votes[j] = $root.TronSignTx.TronContract.TronVoteWitnessContract.Vote.toObject(message.votes[j], options);
                }
                if (message.support != null && message.hasOwnProperty("support"))
                    object.support = message.support;
                return object;
            };

            TronVoteWitnessContract.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            TronVoteWitnessContract.Vote = (function() {

                function Vote(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                Vote.prototype.vote_address = "";
                Vote.prototype.vote_count = 0;

                Vote.create = function create(properties) {
                    return new Vote(properties);
                };

                Vote.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    writer.uint32(10).string(message.vote_address);
                    writer.uint32(16).uint32(message.vote_count);
                    return writer;
                };

                Vote.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                Vote.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TronSignTx.TronContract.TronVoteWitnessContract.Vote();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.vote_address = reader.string();
                            break;
                        case 2:
                            message.vote_count = reader.uint32();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    if (!message.hasOwnProperty("vote_address"))
                        throw $util.ProtocolError("missing required 'vote_address'", { instance: message });
                    if (!message.hasOwnProperty("vote_count"))
                        throw $util.ProtocolError("missing required 'vote_count'", { instance: message });
                    return message;
                };

                Vote.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                Vote.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (!$util.isString(message.vote_address))
                        return "vote_address: string expected";
                    if (!$util.isInteger(message.vote_count))
                        return "vote_count: integer expected";
                    return null;
                };

                Vote.fromObject = function fromObject(object) {
                    if (object instanceof $root.TronSignTx.TronContract.TronVoteWitnessContract.Vote)
                        return object;
                    var message = new $root.TronSignTx.TronContract.TronVoteWitnessContract.Vote();
                    if (object.vote_address != null)
                        message.vote_address = String(object.vote_address);
                    if (object.vote_count != null)
                        message.vote_count = object.vote_count >>> 0;
                    return message;
                };

                Vote.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.vote_address = "";
                        object.vote_count = 0;
                    }
                    if (message.vote_address != null && message.hasOwnProperty("vote_address"))
                        object.vote_address = message.vote_address;
                    if (message.vote_count != null && message.hasOwnProperty("vote_count"))
                        object.vote_count = message.vote_count;
                    return object;
                };

                Vote.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return Vote;
            })();

            return TronVoteWitnessContract;
        })();

        return TronContract;
    })();

    return TronSignTx;
})();

$root.TronSignedTx = (function() {

    function TronSignedTx(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    TronSignedTx.prototype.signature = $util.newBuffer([]);
    TronSignedTx.prototype.serialized_tx = $util.newBuffer([]);

    TronSignedTx.create = function create(properties) {
        return new TronSignedTx(properties);
    };

    TronSignedTx.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.signature);
        if (message.serialized_tx != null && Object.hasOwnProperty.call(message, "serialized_tx"))
            writer.uint32(18).bytes(message.serialized_tx);
        return writer;
    };

    TronSignedTx.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    TronSignedTx.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TronSignedTx();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.signature = reader.bytes();
                break;
            case 2:
                message.serialized_tx = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        return message;
    };

    TronSignedTx.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    TronSignedTx.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        if (message.serialized_tx != null && message.hasOwnProperty("serialized_tx"))
            if (!(message.serialized_tx && typeof message.serialized_tx.length === "number" || $util.isString(message.serialized_tx)))
                return "serialized_tx: buffer expected";
        return null;
    };

    TronSignedTx.fromObject = function fromObject(object) {
        if (object instanceof $root.TronSignedTx)
            return object;
        var message = new $root.TronSignedTx();
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        if (object.serialized_tx != null)
            if (typeof object.serialized_tx === "string")
                $util.base64.decode(object.serialized_tx, message.serialized_tx = $util.newBuffer($util.base64.length(object.serialized_tx)), 0);
            else if (object.serialized_tx.length)
                message.serialized_tx = object.serialized_tx;
        return message;
    };

    TronSignedTx.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
            if (options.bytes === String)
                object.serialized_tx = "";
            else {
                object.serialized_tx = [];
                if (options.bytes !== Array)
                    object.serialized_tx = $util.newBuffer(object.serialized_tx);
            }
        }
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        if (message.serialized_tx != null && message.hasOwnProperty("serialized_tx"))
            object.serialized_tx = options.bytes === String ? $util.base64.encode(message.serialized_tx, 0, message.serialized_tx.length) : options.bytes === Array ? Array.prototype.slice.call(message.serialized_tx) : message.serialized_tx;
        return object;
    };

    TronSignedTx.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return TronSignedTx;
})();

$root.TronMessageType = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[1] = "V1"] = 1;
    values[valuesById[2] = "V2"] = 2;
    return values;
})();

$root.TronSignMessage = (function() {

    function TronSignMessage(properties) {
        this.address_n = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    TronSignMessage.prototype.address_n = $util.emptyArray;
    TronSignMessage.prototype.message = $util.newBuffer([]);
    TronSignMessage.prototype.message_type = 1;

    TronSignMessage.create = function create(properties) {
        return new TronSignMessage(properties);
    };

    TronSignMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.address_n != null && message.address_n.length)
            for (var i = 0; i < message.address_n.length; ++i)
                writer.uint32(8).uint32(message.address_n[i]);
        writer.uint32(18).bytes(message.message);
        if (message.message_type != null && Object.hasOwnProperty.call(message, "message_type"))
            writer.uint32(24).int32(message.message_type);
        return writer;
    };

    TronSignMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    TronSignMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TronSignMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.address_n && message.address_n.length))
                    message.address_n = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.address_n.push(reader.uint32());
                } else
                    message.address_n.push(reader.uint32());
                break;
            case 2:
                message.message = reader.bytes();
                break;
            case 3:
                message.message_type = reader.int32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("message"))
            throw $util.ProtocolError("missing required 'message'", { instance: message });
        return message;
    };

    TronSignMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    TronSignMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.address_n != null && message.hasOwnProperty("address_n")) {
            if (!Array.isArray(message.address_n))
                return "address_n: array expected";
            for (var i = 0; i < message.address_n.length; ++i)
                if (!$util.isInteger(message.address_n[i]))
                    return "address_n: integer[] expected";
        }
        if (!(message.message && typeof message.message.length === "number" || $util.isString(message.message)))
            return "message: buffer expected";
        if (message.message_type != null && message.hasOwnProperty("message_type"))
            switch (message.message_type) {
            default:
                return "message_type: enum value expected";
            case 1:
            case 2:
                break;
            }
        return null;
    };

    TronSignMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.TronSignMessage)
            return object;
        var message = new $root.TronSignMessage();
        if (object.address_n) {
            if (!Array.isArray(object.address_n))
                throw TypeError(".TronSignMessage.address_n: array expected");
            message.address_n = [];
            for (var i = 0; i < object.address_n.length; ++i)
                message.address_n[i] = object.address_n[i] >>> 0;
        }
        if (object.message != null)
            if (typeof object.message === "string")
                $util.base64.decode(object.message, message.message = $util.newBuffer($util.base64.length(object.message)), 0);
            else if (object.message.length)
                message.message = object.message;
        switch (object.message_type) {
        case "V1":
        case 1:
            message.message_type = 1;
            break;
        case "V2":
        case 2:
            message.message_type = 2;
            break;
        }
        return message;
    };

    TronSignMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.address_n = [];
        if (options.defaults) {
            if (options.bytes === String)
                object.message = "";
            else {
                object.message = [];
                if (options.bytes !== Array)
                    object.message = $util.newBuffer(object.message);
            }
            object.message_type = options.enums === String ? "V1" : 1;
        }
        if (message.address_n && message.address_n.length) {
            object.address_n = [];
            for (var j = 0; j < message.address_n.length; ++j)
                object.address_n[j] = message.address_n[j];
        }
        if (message.message != null && message.hasOwnProperty("message"))
            object.message = options.bytes === String ? $util.base64.encode(message.message, 0, message.message.length) : options.bytes === Array ? Array.prototype.slice.call(message.message) : message.message;
        if (message.message_type != null && message.hasOwnProperty("message_type"))
            object.message_type = options.enums === String ? $root.TronMessageType[message.message_type] : message.message_type;
        return object;
    };

    TronSignMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return TronSignMessage;
})();

$root.TronMessageSignature = (function() {

    function TronMessageSignature(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    TronMessageSignature.prototype.address = $util.newBuffer([]);
    TronMessageSignature.prototype.signature = $util.newBuffer([]);

    TronMessageSignature.create = function create(properties) {
        return new TronMessageSignature(properties);
    };

    TronMessageSignature.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.address);
        writer.uint32(18).bytes(message.signature);
        return writer;
    };

    TronMessageSignature.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    TronMessageSignature.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TronMessageSignature();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.address = reader.bytes();
                break;
            case 2:
                message.signature = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("address"))
            throw $util.ProtocolError("missing required 'address'", { instance: message });
        if (!message.hasOwnProperty("signature"))
            throw $util.ProtocolError("missing required 'signature'", { instance: message });
        return message;
    };

    TronMessageSignature.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    TronMessageSignature.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.address && typeof message.address.length === "number" || $util.isString(message.address)))
            return "address: buffer expected";
        if (!(message.signature && typeof message.signature.length === "number" || $util.isString(message.signature)))
            return "signature: buffer expected";
        return null;
    };

    TronMessageSignature.fromObject = function fromObject(object) {
        if (object instanceof $root.TronMessageSignature)
            return object;
        var message = new $root.TronMessageSignature();
        if (object.address != null)
            if (typeof object.address === "string")
                $util.base64.decode(object.address, message.address = $util.newBuffer($util.base64.length(object.address)), 0);
            else if (object.address.length)
                message.address = object.address;
        if (object.signature != null)
            if (typeof object.signature === "string")
                $util.base64.decode(object.signature, message.signature = $util.newBuffer($util.base64.length(object.signature)), 0);
            else if (object.signature.length)
                message.signature = object.signature;
        return message;
    };

    TronMessageSignature.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.address = "";
            else {
                object.address = [];
                if (options.bytes !== Array)
                    object.address = $util.newBuffer(object.address);
            }
            if (options.bytes === String)
                object.signature = "";
            else {
                object.signature = [];
                if (options.bytes !== Array)
                    object.signature = $util.newBuffer(object.signature);
            }
        }
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = options.bytes === String ? $util.base64.encode(message.address, 0, message.address.length) : options.bytes === Array ? Array.prototype.slice.call(message.address) : message.address;
        if (message.signature != null && message.hasOwnProperty("signature"))
            object.signature = options.bytes === String ? $util.base64.encode(message.signature, 0, message.signature.length) : options.bytes === Array ? Array.prototype.slice.call(message.signature) : message.signature;
        return object;
    };

    TronMessageSignature.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return TronMessageSignature;
})();

$root.UiAnimationType = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "Unknown"] = 0;
    values[valuesById[1] = "Signing"] = 1;
    return values;
})();

$root.UiAnimationCommand = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "CommandUnknown"] = 0;
    values[valuesById[1] = "Start"] = 1;
    values[valuesById[2] = "Stop"] = 2;
    values[valuesById[3] = "Refresh"] = 3;
    return values;
})();

$root.UiAnimationRequest = (function() {

    function UiAnimationRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    UiAnimationRequest.prototype.command = 0;
    UiAnimationRequest.prototype.type = 0;

    UiAnimationRequest.create = function create(properties) {
        return new UiAnimationRequest(properties);
    };

    UiAnimationRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).int32(message.command);
        if (message.type != null && Object.hasOwnProperty.call(message, "type"))
            writer.uint32(16).int32(message.type);
        return writer;
    };

    UiAnimationRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    UiAnimationRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.UiAnimationRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.command = reader.int32();
                break;
            case 2:
                message.type = reader.int32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("command"))
            throw $util.ProtocolError("missing required 'command'", { instance: message });
        return message;
    };

    UiAnimationRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    UiAnimationRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        switch (message.command) {
        default:
            return "command: enum value expected";
        case 0:
        case 1:
        case 2:
        case 3:
            break;
        }
        if (message.type != null && message.hasOwnProperty("type"))
            switch (message.type) {
            default:
                return "type: enum value expected";
            case 0:
            case 1:
                break;
            }
        return null;
    };

    UiAnimationRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.UiAnimationRequest)
            return object;
        var message = new $root.UiAnimationRequest();
        switch (object.command) {
        case "CommandUnknown":
        case 0:
            message.command = 0;
            break;
        case "Start":
        case 1:
            message.command = 1;
            break;
        case "Stop":
        case 2:
            message.command = 2;
            break;
        case "Refresh":
        case 3:
            message.command = 3;
            break;
        }
        switch (object.type) {
        case "Unknown":
        case 0:
            message.type = 0;
            break;
        case "Signing":
        case 1:
            message.type = 1;
            break;
        }
        return message;
    };

    UiAnimationRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.command = options.enums === String ? "CommandUnknown" : 0;
            object.type = options.enums === String ? "Unknown" : 0;
        }
        if (message.command != null && message.hasOwnProperty("command"))
            object.command = options.enums === String ? $root.UiAnimationCommand[message.command] : message.command;
        if (message.type != null && message.hasOwnProperty("type"))
            object.type = options.enums === String ? $root.UiAnimationType[message.type] : message.type;
        return object;
    };

    UiAnimationRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return UiAnimationRequest;
})();

$root.WebAuthnListResidentCredentials = (function() {

    function WebAuthnListResidentCredentials(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    WebAuthnListResidentCredentials.create = function create(properties) {
        return new WebAuthnListResidentCredentials(properties);
    };

    WebAuthnListResidentCredentials.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    WebAuthnListResidentCredentials.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    WebAuthnListResidentCredentials.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.WebAuthnListResidentCredentials();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    WebAuthnListResidentCredentials.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    WebAuthnListResidentCredentials.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    WebAuthnListResidentCredentials.fromObject = function fromObject(object) {
        if (object instanceof $root.WebAuthnListResidentCredentials)
            return object;
        return new $root.WebAuthnListResidentCredentials();
    };

    WebAuthnListResidentCredentials.toObject = function toObject() {
        return {};
    };

    WebAuthnListResidentCredentials.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return WebAuthnListResidentCredentials;
})();

$root.WebAuthnAddResidentCredential = (function() {

    function WebAuthnAddResidentCredential(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    WebAuthnAddResidentCredential.prototype.credential_id = $util.newBuffer([]);

    WebAuthnAddResidentCredential.create = function create(properties) {
        return new WebAuthnAddResidentCredential(properties);
    };

    WebAuthnAddResidentCredential.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.credential_id != null && Object.hasOwnProperty.call(message, "credential_id"))
            writer.uint32(10).bytes(message.credential_id);
        return writer;
    };

    WebAuthnAddResidentCredential.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    WebAuthnAddResidentCredential.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.WebAuthnAddResidentCredential();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.credential_id = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    WebAuthnAddResidentCredential.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    WebAuthnAddResidentCredential.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.credential_id != null && message.hasOwnProperty("credential_id"))
            if (!(message.credential_id && typeof message.credential_id.length === "number" || $util.isString(message.credential_id)))
                return "credential_id: buffer expected";
        return null;
    };

    WebAuthnAddResidentCredential.fromObject = function fromObject(object) {
        if (object instanceof $root.WebAuthnAddResidentCredential)
            return object;
        var message = new $root.WebAuthnAddResidentCredential();
        if (object.credential_id != null)
            if (typeof object.credential_id === "string")
                $util.base64.decode(object.credential_id, message.credential_id = $util.newBuffer($util.base64.length(object.credential_id)), 0);
            else if (object.credential_id.length)
                message.credential_id = object.credential_id;
        return message;
    };

    WebAuthnAddResidentCredential.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.credential_id = "";
            else {
                object.credential_id = [];
                if (options.bytes !== Array)
                    object.credential_id = $util.newBuffer(object.credential_id);
            }
        if (message.credential_id != null && message.hasOwnProperty("credential_id"))
            object.credential_id = options.bytes === String ? $util.base64.encode(message.credential_id, 0, message.credential_id.length) : options.bytes === Array ? Array.prototype.slice.call(message.credential_id) : message.credential_id;
        return object;
    };

    WebAuthnAddResidentCredential.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return WebAuthnAddResidentCredential;
})();

$root.WebAuthnRemoveResidentCredential = (function() {

    function WebAuthnRemoveResidentCredential(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    WebAuthnRemoveResidentCredential.prototype.index = 0;

    WebAuthnRemoveResidentCredential.create = function create(properties) {
        return new WebAuthnRemoveResidentCredential(properties);
    };

    WebAuthnRemoveResidentCredential.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.index != null && Object.hasOwnProperty.call(message, "index"))
            writer.uint32(8).uint32(message.index);
        return writer;
    };

    WebAuthnRemoveResidentCredential.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    WebAuthnRemoveResidentCredential.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.WebAuthnRemoveResidentCredential();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.index = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    WebAuthnRemoveResidentCredential.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    WebAuthnRemoveResidentCredential.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.index != null && message.hasOwnProperty("index"))
            if (!$util.isInteger(message.index))
                return "index: integer expected";
        return null;
    };

    WebAuthnRemoveResidentCredential.fromObject = function fromObject(object) {
        if (object instanceof $root.WebAuthnRemoveResidentCredential)
            return object;
        var message = new $root.WebAuthnRemoveResidentCredential();
        if (object.index != null)
            message.index = object.index >>> 0;
        return message;
    };

    WebAuthnRemoveResidentCredential.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.index = 0;
        if (message.index != null && message.hasOwnProperty("index"))
            object.index = message.index;
        return object;
    };

    WebAuthnRemoveResidentCredential.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return WebAuthnRemoveResidentCredential;
})();

$root.WebAuthnCredentials = (function() {

    function WebAuthnCredentials(properties) {
        this.credentials = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    WebAuthnCredentials.prototype.credentials = $util.emptyArray;

    WebAuthnCredentials.create = function create(properties) {
        return new WebAuthnCredentials(properties);
    };

    WebAuthnCredentials.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.credentials != null && message.credentials.length)
            for (var i = 0; i < message.credentials.length; ++i)
                $root.WebAuthnCredentials.WebAuthnCredential.encode(message.credentials[i], writer.uint32(10).fork()).ldelim();
        return writer;
    };

    WebAuthnCredentials.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    WebAuthnCredentials.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.WebAuthnCredentials();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.credentials && message.credentials.length))
                    message.credentials = [];
                message.credentials.push($root.WebAuthnCredentials.WebAuthnCredential.decode(reader, reader.uint32()));
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    WebAuthnCredentials.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    WebAuthnCredentials.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.credentials != null && message.hasOwnProperty("credentials")) {
            if (!Array.isArray(message.credentials))
                return "credentials: array expected";
            for (var i = 0; i < message.credentials.length; ++i) {
                var error = $root.WebAuthnCredentials.WebAuthnCredential.verify(message.credentials[i]);
                if (error)
                    return "credentials." + error;
            }
        }
        return null;
    };

    WebAuthnCredentials.fromObject = function fromObject(object) {
        if (object instanceof $root.WebAuthnCredentials)
            return object;
        var message = new $root.WebAuthnCredentials();
        if (object.credentials) {
            if (!Array.isArray(object.credentials))
                throw TypeError(".WebAuthnCredentials.credentials: array expected");
            message.credentials = [];
            for (var i = 0; i < object.credentials.length; ++i) {
                if (typeof object.credentials[i] !== "object")
                    throw TypeError(".WebAuthnCredentials.credentials: object expected");
                message.credentials[i] = $root.WebAuthnCredentials.WebAuthnCredential.fromObject(object.credentials[i]);
            }
        }
        return message;
    };

    WebAuthnCredentials.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.credentials = [];
        if (message.credentials && message.credentials.length) {
            object.credentials = [];
            for (var j = 0; j < message.credentials.length; ++j)
                object.credentials[j] = $root.WebAuthnCredentials.WebAuthnCredential.toObject(message.credentials[j], options);
        }
        return object;
    };

    WebAuthnCredentials.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    WebAuthnCredentials.WebAuthnCredential = (function() {

        function WebAuthnCredential(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        WebAuthnCredential.prototype.index = 0;
        WebAuthnCredential.prototype.id = $util.newBuffer([]);
        WebAuthnCredential.prototype.rp_id = "";
        WebAuthnCredential.prototype.rp_name = "";
        WebAuthnCredential.prototype.user_id = $util.newBuffer([]);
        WebAuthnCredential.prototype.user_name = "";
        WebAuthnCredential.prototype.user_display_name = "";
        WebAuthnCredential.prototype.creation_time = 0;
        WebAuthnCredential.prototype.hmac_secret = false;
        WebAuthnCredential.prototype.use_sign_count = false;
        WebAuthnCredential.prototype.algorithm = 0;
        WebAuthnCredential.prototype.curve = 0;

        WebAuthnCredential.create = function create(properties) {
            return new WebAuthnCredential(properties);
        };

        WebAuthnCredential.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.index != null && Object.hasOwnProperty.call(message, "index"))
                writer.uint32(8).uint32(message.index);
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(18).bytes(message.id);
            if (message.rp_id != null && Object.hasOwnProperty.call(message, "rp_id"))
                writer.uint32(26).string(message.rp_id);
            if (message.rp_name != null && Object.hasOwnProperty.call(message, "rp_name"))
                writer.uint32(34).string(message.rp_name);
            if (message.user_id != null && Object.hasOwnProperty.call(message, "user_id"))
                writer.uint32(42).bytes(message.user_id);
            if (message.user_name != null && Object.hasOwnProperty.call(message, "user_name"))
                writer.uint32(50).string(message.user_name);
            if (message.user_display_name != null && Object.hasOwnProperty.call(message, "user_display_name"))
                writer.uint32(58).string(message.user_display_name);
            if (message.creation_time != null && Object.hasOwnProperty.call(message, "creation_time"))
                writer.uint32(64).uint32(message.creation_time);
            if (message.hmac_secret != null && Object.hasOwnProperty.call(message, "hmac_secret"))
                writer.uint32(72).bool(message.hmac_secret);
            if (message.use_sign_count != null && Object.hasOwnProperty.call(message, "use_sign_count"))
                writer.uint32(80).bool(message.use_sign_count);
            if (message.algorithm != null && Object.hasOwnProperty.call(message, "algorithm"))
                writer.uint32(88).sint32(message.algorithm);
            if (message.curve != null && Object.hasOwnProperty.call(message, "curve"))
                writer.uint32(96).sint32(message.curve);
            return writer;
        };

        WebAuthnCredential.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        WebAuthnCredential.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.WebAuthnCredentials.WebAuthnCredential();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.index = reader.uint32();
                    break;
                case 2:
                    message.id = reader.bytes();
                    break;
                case 3:
                    message.rp_id = reader.string();
                    break;
                case 4:
                    message.rp_name = reader.string();
                    break;
                case 5:
                    message.user_id = reader.bytes();
                    break;
                case 6:
                    message.user_name = reader.string();
                    break;
                case 7:
                    message.user_display_name = reader.string();
                    break;
                case 8:
                    message.creation_time = reader.uint32();
                    break;
                case 9:
                    message.hmac_secret = reader.bool();
                    break;
                case 10:
                    message.use_sign_count = reader.bool();
                    break;
                case 11:
                    message.algorithm = reader.sint32();
                    break;
                case 12:
                    message.curve = reader.sint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        WebAuthnCredential.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        WebAuthnCredential.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.index != null && message.hasOwnProperty("index"))
                if (!$util.isInteger(message.index))
                    return "index: integer expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!(message.id && typeof message.id.length === "number" || $util.isString(message.id)))
                    return "id: buffer expected";
            if (message.rp_id != null && message.hasOwnProperty("rp_id"))
                if (!$util.isString(message.rp_id))
                    return "rp_id: string expected";
            if (message.rp_name != null && message.hasOwnProperty("rp_name"))
                if (!$util.isString(message.rp_name))
                    return "rp_name: string expected";
            if (message.user_id != null && message.hasOwnProperty("user_id"))
                if (!(message.user_id && typeof message.user_id.length === "number" || $util.isString(message.user_id)))
                    return "user_id: buffer expected";
            if (message.user_name != null && message.hasOwnProperty("user_name"))
                if (!$util.isString(message.user_name))
                    return "user_name: string expected";
            if (message.user_display_name != null && message.hasOwnProperty("user_display_name"))
                if (!$util.isString(message.user_display_name))
                    return "user_display_name: string expected";
            if (message.creation_time != null && message.hasOwnProperty("creation_time"))
                if (!$util.isInteger(message.creation_time))
                    return "creation_time: integer expected";
            if (message.hmac_secret != null && message.hasOwnProperty("hmac_secret"))
                if (typeof message.hmac_secret !== "boolean")
                    return "hmac_secret: boolean expected";
            if (message.use_sign_count != null && message.hasOwnProperty("use_sign_count"))
                if (typeof message.use_sign_count !== "boolean")
                    return "use_sign_count: boolean expected";
            if (message.algorithm != null && message.hasOwnProperty("algorithm"))
                if (!$util.isInteger(message.algorithm))
                    return "algorithm: integer expected";
            if (message.curve != null && message.hasOwnProperty("curve"))
                if (!$util.isInteger(message.curve))
                    return "curve: integer expected";
            return null;
        };

        WebAuthnCredential.fromObject = function fromObject(object) {
            if (object instanceof $root.WebAuthnCredentials.WebAuthnCredential)
                return object;
            var message = new $root.WebAuthnCredentials.WebAuthnCredential();
            if (object.index != null)
                message.index = object.index >>> 0;
            if (object.id != null)
                if (typeof object.id === "string")
                    $util.base64.decode(object.id, message.id = $util.newBuffer($util.base64.length(object.id)), 0);
                else if (object.id.length)
                    message.id = object.id;
            if (object.rp_id != null)
                message.rp_id = String(object.rp_id);
            if (object.rp_name != null)
                message.rp_name = String(object.rp_name);
            if (object.user_id != null)
                if (typeof object.user_id === "string")
                    $util.base64.decode(object.user_id, message.user_id = $util.newBuffer($util.base64.length(object.user_id)), 0);
                else if (object.user_id.length)
                    message.user_id = object.user_id;
            if (object.user_name != null)
                message.user_name = String(object.user_name);
            if (object.user_display_name != null)
                message.user_display_name = String(object.user_display_name);
            if (object.creation_time != null)
                message.creation_time = object.creation_time >>> 0;
            if (object.hmac_secret != null)
                message.hmac_secret = Boolean(object.hmac_secret);
            if (object.use_sign_count != null)
                message.use_sign_count = Boolean(object.use_sign_count);
            if (object.algorithm != null)
                message.algorithm = object.algorithm | 0;
            if (object.curve != null)
                message.curve = object.curve | 0;
            return message;
        };

        WebAuthnCredential.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.index = 0;
                if (options.bytes === String)
                    object.id = "";
                else {
                    object.id = [];
                    if (options.bytes !== Array)
                        object.id = $util.newBuffer(object.id);
                }
                object.rp_id = "";
                object.rp_name = "";
                if (options.bytes === String)
                    object.user_id = "";
                else {
                    object.user_id = [];
                    if (options.bytes !== Array)
                        object.user_id = $util.newBuffer(object.user_id);
                }
                object.user_name = "";
                object.user_display_name = "";
                object.creation_time = 0;
                object.hmac_secret = false;
                object.use_sign_count = false;
                object.algorithm = 0;
                object.curve = 0;
            }
            if (message.index != null && message.hasOwnProperty("index"))
                object.index = message.index;
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = options.bytes === String ? $util.base64.encode(message.id, 0, message.id.length) : options.bytes === Array ? Array.prototype.slice.call(message.id) : message.id;
            if (message.rp_id != null && message.hasOwnProperty("rp_id"))
                object.rp_id = message.rp_id;
            if (message.rp_name != null && message.hasOwnProperty("rp_name"))
                object.rp_name = message.rp_name;
            if (message.user_id != null && message.hasOwnProperty("user_id"))
                object.user_id = options.bytes === String ? $util.base64.encode(message.user_id, 0, message.user_id.length) : options.bytes === Array ? Array.prototype.slice.call(message.user_id) : message.user_id;
            if (message.user_name != null && message.hasOwnProperty("user_name"))
                object.user_name = message.user_name;
            if (message.user_display_name != null && message.hasOwnProperty("user_display_name"))
                object.user_display_name = message.user_display_name;
            if (message.creation_time != null && message.hasOwnProperty("creation_time"))
                object.creation_time = message.creation_time;
            if (message.hmac_secret != null && message.hasOwnProperty("hmac_secret"))
                object.hmac_secret = message.hmac_secret;
            if (message.use_sign_count != null && message.hasOwnProperty("use_sign_count"))
                object.use_sign_count = message.use_sign_count;
            if (message.algorithm != null && message.hasOwnProperty("algorithm"))
                object.algorithm = message.algorithm;
            if (message.curve != null && message.hasOwnProperty("curve"))
                object.curve = message.curve;
            return object;
        };

        WebAuthnCredential.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return WebAuthnCredential;
    })();

    return WebAuthnCredentials;
})();

$root.MessageType = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "MessageType_Initialize"] = 0;
    values[valuesById[4] = "MessageType_ChangePin"] = 4;
    values[valuesById[5] = "MessageType_WipeDevice"] = 5;
    values[valuesById[9] = "MessageType_GetEntropy"] = 9;
    values[valuesById[10] = "MessageType_Entropy"] = 10;
    values[valuesById[13] = "MessageType_LoadDevice"] = 13;
    values[valuesById[14] = "MessageType_ResetDevice"] = 14;
    values[valuesById[16] = "MessageType_SetBusy"] = 16;
    values[valuesById[17] = "MessageType_Features"] = 17;
    values[valuesById[20] = "MessageType_Cancel"] = 20;
    values[valuesById[24] = "MessageType_LockDevice"] = 24;
    values[valuesById[25] = "MessageType_ApplySettings"] = 25;
    values[valuesById[26] = "MessageType_ButtonRequest"] = 26;
    values[valuesById[27] = "MessageType_ButtonAck"] = 27;
    values[valuesById[28] = "MessageType_ApplyFlags"] = 28;
    values[valuesById[31] = "MessageType_GetNonce"] = 31;
    values[valuesById[33] = "MessageType_Nonce"] = 33;
    values[valuesById[34] = "MessageType_BackupDevice"] = 34;
    values[valuesById[35] = "MessageType_EntropyRequest"] = 35;
    values[valuesById[36] = "MessageType_EntropyAck"] = 36;
    values[valuesById[41] = "MessageType_PassphraseRequest"] = 41;
    values[valuesById[42] = "MessageType_PassphraseAck"] = 42;
    values[valuesById[45] = "MessageType_RecoveryDevice"] = 45;
    values[valuesById[46] = "MessageType_WordRequest"] = 46;
    values[valuesById[47] = "MessageType_WordAck"] = 47;
    values[valuesById[55] = "MessageType_GetFeatures"] = 55;
    values[valuesById[79] = "MessageType_SdProtect"] = 79;
    values[valuesById[82] = "MessageType_ChangeWipeCode"] = 82;
    values[valuesById[84] = "MessageType_DoPreauthorized"] = 84;
    values[valuesById[85] = "MessageType_PreauthorizedRequest"] = 85;
    values[valuesById[86] = "MessageType_CancelAuthorization"] = 86;
    values[valuesById[88] = "MessageType_GetFirmwareHash"] = 88;
    values[valuesById[89] = "MessageType_FirmwareHash"] = 89;
    values[valuesById[93] = "MessageType_UnlockPath"] = 93;
    values[valuesById[94] = "MessageType_UnlockedPathRequest"] = 94;
    values[valuesById[63] = "MessageType_SetU2FCounter"] = 63;
    values[valuesById[80] = "MessageType_GetNextU2FCounter"] = 80;
    values[valuesById[81] = "MessageType_NextU2FCounter"] = 81;
    values[valuesById[77] = "MessageType_Deprecated_PassphraseStateRequest"] = 77;
    values[valuesById[78] = "MessageType_Deprecated_PassphraseStateAck"] = 78;
    values[valuesById[11] = "MessageType_GetPublicKey"] = 11;
    values[valuesById[12] = "MessageType_PublicKey"] = 12;
    values[valuesById[15] = "MessageType_SignTx"] = 15;
    values[valuesById[21] = "MessageType_TxRequest"] = 21;
    values[valuesById[22] = "MessageType_TxAck"] = 22;
    values[valuesById[29] = "MessageType_GetAddress"] = 29;
    values[valuesById[30] = "MessageType_Address"] = 30;
    values[valuesById[37] = "MessageType_TxAckPaymentRequest"] = 37;
    values[valuesById[38] = "MessageType_SignMessage"] = 38;
    values[valuesById[39] = "MessageType_VerifyMessage"] = 39;
    values[valuesById[40] = "MessageType_MessageSignature"] = 40;
    values[valuesById[43] = "MessageType_GetOwnershipId"] = 43;
    values[valuesById[44] = "MessageType_OwnershipId"] = 44;
    values[valuesById[49] = "MessageType_GetOwnershipProof"] = 49;
    values[valuesById[50] = "MessageType_OwnershipProof"] = 50;
    values[valuesById[51] = "MessageType_AuthorizeCoinJoin"] = 51;
    values[valuesById[10052] = "MessageType_SignPsbt"] = 10052;
    values[valuesById[10053] = "MessageType_SignedPsbt"] = 10053;
    values[valuesById[23] = "MessageType_CipherKeyValue"] = 23;
    values[valuesById[48] = "MessageType_CipheredKeyValue"] = 48;
    values[valuesById[53] = "MessageType_SignIdentity"] = 53;
    values[valuesById[54] = "MessageType_SignedIdentity"] = 54;
    values[valuesById[61] = "MessageType_GetECDHSessionKey"] = 61;
    values[valuesById[62] = "MessageType_ECDHSessionKey"] = 62;
    values[valuesById[71] = "MessageType_CosiCommit"] = 71;
    values[valuesById[72] = "MessageType_CosiCommitment"] = 72;
    values[valuesById[73] = "MessageType_CosiSign"] = 73;
    values[valuesById[74] = "MessageType_CosiSignature"] = 74;
    values[valuesById[10016] = "MessageType_BatchGetPublickeys"] = 10016;
    values[valuesById[10017] = "MessageType_EcdsaPublicKeys"] = 10017;
    values[valuesById[450] = "MessageType_EthereumGetPublicKey"] = 450;
    values[valuesById[451] = "MessageType_EthereumPublicKey"] = 451;
    values[valuesById[56] = "MessageType_EthereumGetAddress"] = 56;
    values[valuesById[57] = "MessageType_EthereumAddress"] = 57;
    values[valuesById[58] = "MessageType_EthereumSignTx"] = 58;
    values[valuesById[452] = "MessageType_EthereumSignTxEIP1559"] = 452;
    values[valuesById[59] = "MessageType_EthereumTxRequest"] = 59;
    values[valuesById[60] = "MessageType_EthereumTxAck"] = 60;
    values[valuesById[64] = "MessageType_EthereumSignMessage"] = 64;
    values[valuesById[65] = "MessageType_EthereumVerifyMessage"] = 65;
    values[valuesById[66] = "MessageType_EthereumMessageSignature"] = 66;
    values[valuesById[464] = "MessageType_EthereumSignTypedData"] = 464;
    values[valuesById[465] = "MessageType_EthereumTypedDataStructRequest"] = 465;
    values[valuesById[466] = "MessageType_EthereumTypedDataStructAck"] = 466;
    values[valuesById[467] = "MessageType_EthereumTypedDataValueRequest"] = 467;
    values[valuesById[468] = "MessageType_EthereumTypedDataValueAck"] = 468;
    values[valuesById[469] = "MessageType_EthereumTypedDataSignature"] = 469;
    values[valuesById[470] = "MessageType_EthereumSignTypedHash"] = 470;
    values[valuesById[20100] = "MessageType_EthereumGetPublicKeyOneKey"] = 20100;
    values[valuesById[20101] = "MessageType_EthereumPublicKeyOneKey"] = 20101;
    values[valuesById[20102] = "MessageType_EthereumGetAddressOneKey"] = 20102;
    values[valuesById[20103] = "MessageType_EthereumAddressOneKey"] = 20103;
    values[valuesById[20104] = "MessageType_EthereumSignTxOneKey"] = 20104;
    values[valuesById[20105] = "MessageType_EthereumSignTxEIP1559OneKey"] = 20105;
    values[valuesById[20106] = "MessageType_EthereumTxRequestOneKey"] = 20106;
    values[valuesById[20107] = "MessageType_EthereumTxAckOneKey"] = 20107;
    values[valuesById[20108] = "MessageType_EthereumSignMessageOneKey"] = 20108;
    values[valuesById[20109] = "MessageType_EthereumVerifyMessageOneKey"] = 20109;
    values[valuesById[20110] = "MessageType_EthereumMessageSignatureOneKey"] = 20110;
    values[valuesById[20111] = "MessageType_EthereumSignTypedDataOneKey"] = 20111;
    values[valuesById[20112] = "MessageType_EthereumTypedDataStructRequestOneKey"] = 20112;
    values[valuesById[20113] = "MessageType_EthereumTypedDataStructAckOneKey"] = 20113;
    values[valuesById[20114] = "MessageType_EthereumTypedDataValueRequestOneKey"] = 20114;
    values[valuesById[20115] = "MessageType_EthereumTypedDataValueAckOneKey"] = 20115;
    values[valuesById[20116] = "MessageType_EthereumTypedDataSignatureOneKey"] = 20116;
    values[valuesById[20117] = "MessageType_EthereumSignTypedHashOneKey"] = 20117;
    values[valuesById[20118] = "MessageType_EthereumGnosisSafeTxAck"] = 20118;
    values[valuesById[20119] = "MessageType_EthereumGnosisSafeTxRequest"] = 20119;
    values[valuesById[20120] = "MessageType_EthereumSignTxEIP7702OneKey"] = 20120;
    values[valuesById[20121] = "MessageType_EthereumSignTypedDataQR"] = 20121;
    values[valuesById[67] = "MessageType_NEMGetAddress"] = 67;
    values[valuesById[68] = "MessageType_NEMAddress"] = 68;
    values[valuesById[69] = "MessageType_NEMSignTx"] = 69;
    values[valuesById[70] = "MessageType_NEMSignedTx"] = 70;
    values[valuesById[75] = "MessageType_NEMDecryptMessage"] = 75;
    values[valuesById[76] = "MessageType_NEMDecryptedMessage"] = 76;
    values[valuesById[150] = "MessageType_TezosGetAddress"] = 150;
    values[valuesById[151] = "MessageType_TezosAddress"] = 151;
    values[valuesById[152] = "MessageType_TezosSignTx"] = 152;
    values[valuesById[153] = "MessageType_TezosSignedTx"] = 153;
    values[valuesById[154] = "MessageType_TezosGetPublicKey"] = 154;
    values[valuesById[155] = "MessageType_TezosPublicKey"] = 155;
    values[valuesById[202] = "MessageType_StellarSignTx"] = 202;
    values[valuesById[203] = "MessageType_StellarTxOpRequest"] = 203;
    values[valuesById[207] = "MessageType_StellarGetAddress"] = 207;
    values[valuesById[208] = "MessageType_StellarAddress"] = 208;
    values[valuesById[210] = "MessageType_StellarCreateAccountOp"] = 210;
    values[valuesById[211] = "MessageType_StellarPaymentOp"] = 211;
    values[valuesById[212] = "MessageType_StellarPathPaymentStrictReceiveOp"] = 212;
    values[valuesById[213] = "MessageType_StellarManageSellOfferOp"] = 213;
    values[valuesById[214] = "MessageType_StellarCreatePassiveSellOfferOp"] = 214;
    values[valuesById[215] = "MessageType_StellarSetOptionsOp"] = 215;
    values[valuesById[216] = "MessageType_StellarChangeTrustOp"] = 216;
    values[valuesById[217] = "MessageType_StellarAllowTrustOp"] = 217;
    values[valuesById[218] = "MessageType_StellarAccountMergeOp"] = 218;
    values[valuesById[220] = "MessageType_StellarManageDataOp"] = 220;
    values[valuesById[221] = "MessageType_StellarBumpSequenceOp"] = 221;
    values[valuesById[222] = "MessageType_StellarManageBuyOfferOp"] = 222;
    values[valuesById[223] = "MessageType_StellarPathPaymentStrictSendOp"] = 223;
    values[valuesById[230] = "MessageType_StellarSignedTx"] = 230;
    values[valuesById[305] = "MessageType_CardanoGetPublicKey"] = 305;
    values[valuesById[306] = "MessageType_CardanoPublicKey"] = 306;
    values[valuesById[307] = "MessageType_CardanoGetAddress"] = 307;
    values[valuesById[308] = "MessageType_CardanoAddress"] = 308;
    values[valuesById[313] = "MessageType_CardanoTxItemAck"] = 313;
    values[valuesById[314] = "MessageType_CardanoTxAuxiliaryDataSupplement"] = 314;
    values[valuesById[315] = "MessageType_CardanoTxWitnessRequest"] = 315;
    values[valuesById[316] = "MessageType_CardanoTxWitnessResponse"] = 316;
    values[valuesById[317] = "MessageType_CardanoTxHostAck"] = 317;
    values[valuesById[318] = "MessageType_CardanoTxBodyHash"] = 318;
    values[valuesById[319] = "MessageType_CardanoSignTxFinished"] = 319;
    values[valuesById[320] = "MessageType_CardanoSignTxInit"] = 320;
    values[valuesById[321] = "MessageType_CardanoTxInput"] = 321;
    values[valuesById[322] = "MessageType_CardanoTxOutput"] = 322;
    values[valuesById[323] = "MessageType_CardanoAssetGroup"] = 323;
    values[valuesById[324] = "MessageType_CardanoToken"] = 324;
    values[valuesById[325] = "MessageType_CardanoTxCertificate"] = 325;
    values[valuesById[326] = "MessageType_CardanoTxWithdrawal"] = 326;
    values[valuesById[327] = "MessageType_CardanoTxAuxiliaryData"] = 327;
    values[valuesById[328] = "MessageType_CardanoPoolOwner"] = 328;
    values[valuesById[329] = "MessageType_CardanoPoolRelayParameters"] = 329;
    values[valuesById[330] = "MessageType_CardanoGetNativeScriptHash"] = 330;
    values[valuesById[331] = "MessageType_CardanoNativeScriptHash"] = 331;
    values[valuesById[332] = "MessageType_CardanoTxMint"] = 332;
    values[valuesById[333] = "MessageType_CardanoTxCollateralInput"] = 333;
    values[valuesById[334] = "MessageType_CardanoTxRequiredSigner"] = 334;
    values[valuesById[335] = "MessageType_CardanoTxInlineDatumChunk"] = 335;
    values[valuesById[336] = "MessageType_CardanoTxReferenceScriptChunk"] = 336;
    values[valuesById[337] = "MessageType_CardanoTxReferenceInput"] = 337;
    values[valuesById[350] = "MessageType_CardanoSignMessage"] = 350;
    values[valuesById[351] = "MessageType_CardanoMessageSignature"] = 351;
    values[valuesById[400] = "MessageType_RippleGetAddress"] = 400;
    values[valuesById[401] = "MessageType_RippleAddress"] = 401;
    values[valuesById[402] = "MessageType_RippleSignTx"] = 402;
    values[valuesById[403] = "MessageType_RippleSignedTx"] = 403;
    values[valuesById[501] = "MessageType_MoneroTransactionInitRequest"] = 501;
    values[valuesById[502] = "MessageType_MoneroTransactionInitAck"] = 502;
    values[valuesById[503] = "MessageType_MoneroTransactionSetInputRequest"] = 503;
    values[valuesById[504] = "MessageType_MoneroTransactionSetInputAck"] = 504;
    values[valuesById[507] = "MessageType_MoneroTransactionInputViniRequest"] = 507;
    values[valuesById[508] = "MessageType_MoneroTransactionInputViniAck"] = 508;
    values[valuesById[509] = "MessageType_MoneroTransactionAllInputsSetRequest"] = 509;
    values[valuesById[510] = "MessageType_MoneroTransactionAllInputsSetAck"] = 510;
    values[valuesById[511] = "MessageType_MoneroTransactionSetOutputRequest"] = 511;
    values[valuesById[512] = "MessageType_MoneroTransactionSetOutputAck"] = 512;
    values[valuesById[513] = "MessageType_MoneroTransactionAllOutSetRequest"] = 513;
    values[valuesById[514] = "MessageType_MoneroTransactionAllOutSetAck"] = 514;
    values[valuesById[515] = "MessageType_MoneroTransactionSignInputRequest"] = 515;
    values[valuesById[516] = "MessageType_MoneroTransactionSignInputAck"] = 516;
    values[valuesById[517] = "MessageType_MoneroTransactionFinalRequest"] = 517;
    values[valuesById[518] = "MessageType_MoneroTransactionFinalAck"] = 518;
    values[valuesById[530] = "MessageType_MoneroKeyImageExportInitRequest"] = 530;
    values[valuesById[531] = "MessageType_MoneroKeyImageExportInitAck"] = 531;
    values[valuesById[532] = "MessageType_MoneroKeyImageSyncStepRequest"] = 532;
    values[valuesById[533] = "MessageType_MoneroKeyImageSyncStepAck"] = 533;
    values[valuesById[534] = "MessageType_MoneroKeyImageSyncFinalRequest"] = 534;
    values[valuesById[535] = "MessageType_MoneroKeyImageSyncFinalAck"] = 535;
    values[valuesById[540] = "MessageType_MoneroGetAddress"] = 540;
    values[valuesById[541] = "MessageType_MoneroAddress"] = 541;
    values[valuesById[542] = "MessageType_MoneroGetWatchKey"] = 542;
    values[valuesById[543] = "MessageType_MoneroWatchKey"] = 543;
    values[valuesById[546] = "MessageType_DebugMoneroDiagRequest"] = 546;
    values[valuesById[547] = "MessageType_DebugMoneroDiagAck"] = 547;
    values[valuesById[550] = "MessageType_MoneroGetTxKeyRequest"] = 550;
    values[valuesById[551] = "MessageType_MoneroGetTxKeyAck"] = 551;
    values[valuesById[552] = "MessageType_MoneroLiveRefreshStartRequest"] = 552;
    values[valuesById[553] = "MessageType_MoneroLiveRefreshStartAck"] = 553;
    values[valuesById[554] = "MessageType_MoneroLiveRefreshStepRequest"] = 554;
    values[valuesById[555] = "MessageType_MoneroLiveRefreshStepAck"] = 555;
    values[valuesById[556] = "MessageType_MoneroLiveRefreshFinalRequest"] = 556;
    values[valuesById[557] = "MessageType_MoneroLiveRefreshFinalAck"] = 557;
    values[valuesById[600] = "MessageType_EosGetPublicKey"] = 600;
    values[valuesById[601] = "MessageType_EosPublicKey"] = 601;
    values[valuesById[602] = "MessageType_EosSignTx"] = 602;
    values[valuesById[603] = "MessageType_EosTxActionRequest"] = 603;
    values[valuesById[604] = "MessageType_EosTxActionAck"] = 604;
    values[valuesById[605] = "MessageType_EosSignedTx"] = 605;
    values[valuesById[700] = "MessageType_BinanceGetAddress"] = 700;
    values[valuesById[701] = "MessageType_BinanceAddress"] = 701;
    values[valuesById[702] = "MessageType_BinanceGetPublicKey"] = 702;
    values[valuesById[703] = "MessageType_BinancePublicKey"] = 703;
    values[valuesById[704] = "MessageType_BinanceSignTx"] = 704;
    values[valuesById[705] = "MessageType_BinanceTxRequest"] = 705;
    values[valuesById[706] = "MessageType_BinanceTransferMsg"] = 706;
    values[valuesById[707] = "MessageType_BinanceOrderMsg"] = 707;
    values[valuesById[708] = "MessageType_BinanceCancelMsg"] = 708;
    values[valuesById[709] = "MessageType_BinanceSignedTx"] = 709;
    values[valuesById[10300] = "MessageType_StarcoinGetAddress"] = 10300;
    values[valuesById[10301] = "MessageType_StarcoinAddress"] = 10301;
    values[valuesById[10302] = "MessageType_StarcoinGetPublicKey"] = 10302;
    values[valuesById[10303] = "MessageType_StarcoinPublicKey"] = 10303;
    values[valuesById[10304] = "MessageType_StarcoinSignTx"] = 10304;
    values[valuesById[10305] = "MessageType_StarcoinSignedTx"] = 10305;
    values[valuesById[10306] = "MessageType_StarcoinSignMessage"] = 10306;
    values[valuesById[10307] = "MessageType_StarcoinMessageSignature"] = 10307;
    values[valuesById[10308] = "MessageType_StarcoinVerifyMessage"] = 10308;
    values[valuesById[10112] = "MessageType_ConfluxGetAddress"] = 10112;
    values[valuesById[10113] = "MessageType_ConfluxAddress"] = 10113;
    values[valuesById[10114] = "MessageType_ConfluxSignTx"] = 10114;
    values[valuesById[10115] = "MessageType_ConfluxTxRequest"] = 10115;
    values[valuesById[10116] = "MessageType_ConfluxTxAck"] = 10116;
    values[valuesById[10117] = "MessageType_ConfluxSignMessage"] = 10117;
    values[valuesById[10118] = "MessageType_ConfluxSignMessageCIP23"] = 10118;
    values[valuesById[10119] = "MessageType_ConfluxMessageSignature"] = 10119;
    values[valuesById[10501] = "MessageType_TronGetAddress"] = 10501;
    values[valuesById[10502] = "MessageType_TronAddress"] = 10502;
    values[valuesById[10503] = "MessageType_TronSignTx"] = 10503;
    values[valuesById[10504] = "MessageType_TronSignedTx"] = 10504;
    values[valuesById[10505] = "MessageType_TronSignMessage"] = 10505;
    values[valuesById[10506] = "MessageType_TronMessageSignature"] = 10506;
    values[valuesById[10701] = "MessageType_NearGetAddress"] = 10701;
    values[valuesById[10702] = "MessageType_NearAddress"] = 10702;
    values[valuesById[10703] = "MessageType_NearSignTx"] = 10703;
    values[valuesById[10704] = "MessageType_NearSignedTx"] = 10704;
    values[valuesById[10600] = "MessageType_AptosGetAddress"] = 10600;
    values[valuesById[10601] = "MessageType_AptosAddress"] = 10601;
    values[valuesById[10602] = "MessageType_AptosSignTx"] = 10602;
    values[valuesById[10603] = "MessageType_AptosSignedTx"] = 10603;
    values[valuesById[10604] = "MessageType_AptosSignMessage"] = 10604;
    values[valuesById[10605] = "MessageType_AptosMessageSignature"] = 10605;
    values[valuesById[10606] = "MessageType_AptosSignSIWAMessage"] = 10606;
    values[valuesById[800] = "MessageType_WebAuthnListResidentCredentials"] = 800;
    values[valuesById[801] = "MessageType_WebAuthnCredentials"] = 801;
    values[valuesById[802] = "MessageType_WebAuthnAddResidentCredential"] = 802;
    values[valuesById[803] = "MessageType_WebAuthnRemoveResidentCredential"] = 803;
    values[valuesById[10100] = "MessageType_SolanaGetAddress"] = 10100;
    values[valuesById[10101] = "MessageType_SolanaAddress"] = 10101;
    values[valuesById[10102] = "MessageType_SolanaSignTx"] = 10102;
    values[valuesById[10103] = "MessageType_SolanaSignedTx"] = 10103;
    values[valuesById[10104] = "MessageType_SolanaSignOffChainMessage"] = 10104;
    values[valuesById[10105] = "MessageType_SolanaMessageSignature"] = 10105;
    values[valuesById[10106] = "MessageType_SolanaSignUnsafeMessage"] = 10106;
    values[valuesById[10800] = "MessageType_CosmosGetAddress"] = 10800;
    values[valuesById[10801] = "MessageType_CosmosAddress"] = 10801;
    values[valuesById[10802] = "MessageType_CosmosSignTx"] = 10802;
    values[valuesById[10803] = "MessageType_CosmosSignedTx"] = 10803;
    values[valuesById[10900] = "MessageType_AlgorandGetAddress"] = 10900;
    values[valuesById[10901] = "MessageType_AlgorandAddress"] = 10901;
    values[valuesById[10902] = "MessageType_AlgorandSignTx"] = 10902;
    values[valuesById[10903] = "MessageType_AlgorandSignedTx"] = 10903;
    values[valuesById[11000] = "MessageType_PolkadotGetAddress"] = 11000;
    values[valuesById[11001] = "MessageType_PolkadotAddress"] = 11001;
    values[valuesById[11002] = "MessageType_PolkadotSignTx"] = 11002;
    values[valuesById[11003] = "MessageType_PolkadotSignedTx"] = 11003;
    values[valuesById[11100] = "MessageType_SuiGetAddress"] = 11100;
    values[valuesById[11101] = "MessageType_SuiAddress"] = 11101;
    values[valuesById[11102] = "MessageType_SuiSignTx"] = 11102;
    values[valuesById[11103] = "MessageType_SuiSignedTx"] = 11103;
    values[valuesById[11104] = "MessageType_SuiSignMessage"] = 11104;
    values[valuesById[11105] = "MessageType_SuiMessageSignature"] = 11105;
    values[valuesById[11106] = "MessageType_SuiTxRequest"] = 11106;
    values[valuesById[11107] = "MessageType_SuiTxAck"] = 11107;
    values[valuesById[11200] = "MessageType_FilecoinGetAddress"] = 11200;
    values[valuesById[11201] = "MessageType_FilecoinAddress"] = 11201;
    values[valuesById[11202] = "MessageType_FilecoinSignTx"] = 11202;
    values[valuesById[11203] = "MessageType_FilecoinSignedTx"] = 11203;
    values[valuesById[11300] = "MessageType_KaspaGetAddress"] = 11300;
    values[valuesById[11301] = "MessageType_KaspaAddress"] = 11301;
    values[valuesById[11302] = "MessageType_KaspaSignTx"] = 11302;
    values[valuesById[11303] = "MessageType_KaspaSignedTx"] = 11303;
    values[valuesById[11304] = "MessageType_KaspaTxInputRequest"] = 11304;
    values[valuesById[11305] = "MessageType_KaspaTxInputAck"] = 11305;
    values[valuesById[11400] = "MessageType_NexaGetAddress"] = 11400;
    values[valuesById[11401] = "MessageType_NexaAddress"] = 11401;
    values[valuesById[11402] = "MessageType_NexaSignTx"] = 11402;
    values[valuesById[11403] = "MessageType_NexaSignedTx"] = 11403;
    values[valuesById[11404] = "MessageType_NexaTxInputRequest"] = 11404;
    values[valuesById[11405] = "MessageType_NexaTxInputAck"] = 11405;
    values[valuesById[11500] = "MessageType_NostrGetPublicKey"] = 11500;
    values[valuesById[11501] = "MessageType_NostrPublicKey"] = 11501;
    values[valuesById[11502] = "MessageType_NostrSignEvent"] = 11502;
    values[valuesById[11503] = "MessageType_NostrSignedEvent"] = 11503;
    values[valuesById[11504] = "MessageType_NostrEncryptMessage"] = 11504;
    values[valuesById[11505] = "MessageType_NostrEncryptedMessage"] = 11505;
    values[valuesById[11506] = "MessageType_NostrDecryptMessage"] = 11506;
    values[valuesById[11507] = "MessageType_NostrDecryptedMessage"] = 11507;
    values[valuesById[11508] = "MessageType_NostrSignSchnorr"] = 11508;
    values[valuesById[11509] = "MessageType_NostrSignedSchnorr"] = 11509;
    values[valuesById[11600] = "MessageType_LnurlAuth"] = 11600;
    values[valuesById[11601] = "MessageType_LnurlAuthResp"] = 11601;
    values[valuesById[11701] = "MessageType_NervosGetAddress"] = 11701;
    values[valuesById[11702] = "MessageType_NervosAddress"] = 11702;
    values[valuesById[11703] = "MessageType_NervosSignTx"] = 11703;
    values[valuesById[11704] = "MessageType_NervosSignedTx"] = 11704;
    values[valuesById[11705] = "MessageType_NervosTxRequest"] = 11705;
    values[valuesById[11706] = "MessageType_NervosTxAck"] = 11706;
    values[valuesById[11901] = "MessageType_TonGetAddress"] = 11901;
    values[valuesById[11902] = "MessageType_TonAddress"] = 11902;
    values[valuesById[11903] = "MessageType_TonSignMessage"] = 11903;
    values[valuesById[11904] = "MessageType_TonSignedMessage"] = 11904;
    values[valuesById[11905] = "MessageType_TonSignProof"] = 11905;
    values[valuesById[11906] = "MessageType_TonSignedProof"] = 11906;
    values[valuesById[11907] = "MessageType_TonTxAck"] = 11907;
    values[valuesById[12101] = "MessageType_AlephiumGetAddress"] = 12101;
    values[valuesById[12102] = "MessageType_AlephiumAddress"] = 12102;
    values[valuesById[12103] = "MessageType_AlephiumSignTx"] = 12103;
    values[valuesById[12104] = "MessageType_AlephiumSignedTx"] = 12104;
    values[valuesById[12105] = "MessageType_AlephiumTxRequest"] = 12105;
    values[valuesById[12106] = "MessageType_AlephiumTxAck"] = 12106;
    values[valuesById[12107] = "MessageType_AlephiumBytecodeRequest"] = 12107;
    values[valuesById[12108] = "MessageType_AlephiumBytecodeAck"] = 12108;
    values[valuesById[12109] = "MessageType_AlephiumSignMessage"] = 12109;
    values[valuesById[12110] = "MessageType_AlephiumMessageSignature"] = 12110;
    values[valuesById[12201] = "MessageType_BenfenGetAddress"] = 12201;
    values[valuesById[12202] = "MessageType_BenfenAddress"] = 12202;
    values[valuesById[12203] = "MessageType_BenfenSignTx"] = 12203;
    values[valuesById[12204] = "MessageType_BenfenSignedTx"] = 12204;
    values[valuesById[12205] = "MessageType_BenfenSignMessage"] = 12205;
    values[valuesById[12206] = "MessageType_BenfenMessageSignature"] = 12206;
    values[valuesById[12207] = "MessageType_BenfenTxRequest"] = 12207;
    values[valuesById[12208] = "MessageType_BenfenTxAck"] = 12208;
    values[valuesById[12301] = "MessageType_NeoGetAddress"] = 12301;
    values[valuesById[12302] = "MessageType_NeoAddress"] = 12302;
    values[valuesById[12303] = "MessageType_NeoSignTx"] = 12303;
    values[valuesById[12304] = "MessageType_NeoSignedTx"] = 12304;
    values[valuesById[60000] = "MessageType_DeviceFactoryInfoSet"] = 60000;
    values[valuesById[60001] = "MessageType_DeviceFactoryInfoGet"] = 60001;
    values[valuesById[60002] = "MessageType_DeviceFactoryInfo"] = 60002;
    values[valuesById[60003] = "MessageType_DeviceFactoryPermanentLock"] = 60003;
    values[valuesById[60004] = "MessageType_DeviceFactoryTest"] = 60004;
    values[valuesById[60200] = "MessageType_ProtocolInfoRequest"] = 60200;
    values[valuesById[60201] = "MessageType_ProtocolInfo"] = 60201;
    values[valuesById[60206] = "MessageType_Ping"] = 60206;
    values[valuesById[60207] = "MessageType_Success"] = 60207;
    values[valuesById[60208] = "MessageType_Failure"] = 60208;
    values[valuesById[60400] = "MessageType_DeviceReboot"] = 60400;
    values[valuesById[60410] = "MessageType_DeviceSettings"] = 60410;
    values[valuesById[60411] = "MessageType_DeviceSettingsGet"] = 60411;
    values[valuesById[60412] = "MessageType_DeviceSettingsSet"] = 60412;
    values[valuesById[60413] = "MessageType_DeviceSettingsPageShow"] = 60413;
    values[valuesById[60420] = "MessageType_DeviceCertificate"] = 60420;
    values[valuesById[60421] = "MessageType_DeviceCertificateWrite"] = 60421;
    values[valuesById[60422] = "MessageType_DeviceCertificateRead"] = 60422;
    values[valuesById[60423] = "MessageType_DeviceCertificateSignature"] = 60423;
    values[valuesById[60424] = "MessageType_DeviceCertificateSign"] = 60424;
    values[valuesById[60440] = "MessageType_DeviceMiscUsbMscControl"] = 60440;
    values[valuesById[60450] = "MessageType_DeviceFindMyTokenState"] = 60450;
    values[valuesById[60451] = "MessageType_DeviceFindMyTokenUpdate"] = 60451;
    values[valuesById[60452] = "MessageType_DeviceFindMyTokenStateGet"] = 60452;
    values[valuesById[60461] = "MessageType_DeviceAnimationControl"] = 60461;
    values[valuesById[60600] = "MessageType_DeviceInfoGet"] = 60600;
    values[valuesById[60601] = "MessageType_DeviceInfo"] = 60601;
    values[valuesById[60602] = "MessageType_DeviceStatusGet"] = 60602;
    values[valuesById[60603] = "MessageType_DeviceStatus"] = 60603;
    values[valuesById[60800] = "MessageType_FilesystemPermissionFix"] = 60800;
    values[valuesById[60801] = "MessageType_FilesystemPathInfo"] = 60801;
    values[valuesById[60802] = "MessageType_FilesystemPathInfoQuery"] = 60802;
    values[valuesById[60803] = "MessageType_FilesystemFile"] = 60803;
    values[valuesById[60804] = "MessageType_FilesystemFileRead"] = 60804;
    values[valuesById[60805] = "MessageType_FilesystemFileWrite"] = 60805;
    values[valuesById[60806] = "MessageType_FilesystemFileDelete"] = 60806;
    values[valuesById[60807] = "MessageType_FilesystemDir"] = 60807;
    values[valuesById[60808] = "MessageType_FilesystemDirList"] = 60808;
    values[valuesById[60809] = "MessageType_FilesystemDirMake"] = 60809;
    values[valuesById[60810] = "MessageType_FilesystemDirRemove"] = 60810;
    values[valuesById[60811] = "MessageType_FilesystemFormat"] = 60811;
    values[valuesById[61000] = "MessageType_DeviceFirmwareUpdateStage"] = 61000;
    values[valuesById[61001] = "MessageType_DeviceFirmwareUpdateRequest"] = 61001;
    values[valuesById[61002] = "MessageType_DeviceFirmwareUpdateStatusGet"] = 61002;
    values[valuesById[61003] = "MessageType_DeviceFirmwareUpdateStatus"] = 61003;
    values[valuesById[61200] = "MessageType_DeviceSessionGet"] = 61200;
    values[valuesById[61201] = "MessageType_DeviceSession"] = 61201;
    values[valuesById[61202] = "MessageType_DeviceSessionAskPin"] = 61202;
    values[valuesById[61203] = "MessageType_DeviceSessionAskPassphrase"] = 61203;
    values[valuesById[61400] = "MessageType_PortfolioUpdate"] = 61400;
    values[valuesById[61500] = "MessageType_NftUpdate"] = 61500;
    values[valuesById[61600] = "MessageType_OnboardingStatusGet"] = 61600;
    values[valuesById[61601] = "MessageType_OnboardingStatus"] = 61601;
    return values;
})();

$root.ProtocolInfoRequest = (function() {

    function ProtocolInfoRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ProtocolInfoRequest.prototype.eventless_wallet_session = false;

    ProtocolInfoRequest.create = function create(properties) {
        return new ProtocolInfoRequest(properties);
    };

    ProtocolInfoRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.eventless_wallet_session != null && Object.hasOwnProperty.call(message, "eventless_wallet_session"))
            writer.uint32(8).bool(message.eventless_wallet_session);
        return writer;
    };

    ProtocolInfoRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ProtocolInfoRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ProtocolInfoRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.eventless_wallet_session = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    ProtocolInfoRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ProtocolInfoRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.eventless_wallet_session != null && message.hasOwnProperty("eventless_wallet_session"))
            if (typeof message.eventless_wallet_session !== "boolean")
                return "eventless_wallet_session: boolean expected";
        return null;
    };

    ProtocolInfoRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.ProtocolInfoRequest)
            return object;
        var message = new $root.ProtocolInfoRequest();
        if (object.eventless_wallet_session != null)
            message.eventless_wallet_session = Boolean(object.eventless_wallet_session);
        return message;
    };

    ProtocolInfoRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.eventless_wallet_session = false;
        if (message.eventless_wallet_session != null && message.hasOwnProperty("eventless_wallet_session"))
            object.eventless_wallet_session = message.eventless_wallet_session;
        return object;
    };

    ProtocolInfoRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ProtocolInfoRequest;
})();

$root.ProtocolInfo = (function() {

    function ProtocolInfo(properties) {
        this.supported_messages = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ProtocolInfo.prototype.version = 0;
    ProtocolInfo.prototype.build_fingerprint = "";
    ProtocolInfo.prototype.supported_messages = $util.emptyArray;

    ProtocolInfo.create = function create(properties) {
        return new ProtocolInfo(properties);
    };

    ProtocolInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).uint32(message.version);
        writer.uint32(18).string(message.build_fingerprint);
        if (message.supported_messages != null && message.supported_messages.length)
            for (var i = 0; i < message.supported_messages.length; ++i)
                writer.uint32(24).uint32(message.supported_messages[i]);
        return writer;
    };

    ProtocolInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ProtocolInfo.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ProtocolInfo();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.version = reader.uint32();
                break;
            case 2:
                message.build_fingerprint = reader.string();
                break;
            case 3:
                if (!(message.supported_messages && message.supported_messages.length))
                    message.supported_messages = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.supported_messages.push(reader.uint32());
                } else
                    message.supported_messages.push(reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("version"))
            throw $util.ProtocolError("missing required 'version'", { instance: message });
        if (!message.hasOwnProperty("build_fingerprint"))
            throw $util.ProtocolError("missing required 'build_fingerprint'", { instance: message });
        return message;
    };

    ProtocolInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ProtocolInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isInteger(message.version))
            return "version: integer expected";
        if (!$util.isString(message.build_fingerprint))
            return "build_fingerprint: string expected";
        if (message.supported_messages != null && message.hasOwnProperty("supported_messages")) {
            if (!Array.isArray(message.supported_messages))
                return "supported_messages: array expected";
            for (var i = 0; i < message.supported_messages.length; ++i)
                if (!$util.isInteger(message.supported_messages[i]))
                    return "supported_messages: integer[] expected";
        }
        return null;
    };

    ProtocolInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.ProtocolInfo)
            return object;
        var message = new $root.ProtocolInfo();
        if (object.version != null)
            message.version = object.version >>> 0;
        if (object.build_fingerprint != null)
            message.build_fingerprint = String(object.build_fingerprint);
        if (object.supported_messages) {
            if (!Array.isArray(object.supported_messages))
                throw TypeError(".ProtocolInfo.supported_messages: array expected");
            message.supported_messages = [];
            for (var i = 0; i < object.supported_messages.length; ++i)
                message.supported_messages[i] = object.supported_messages[i] >>> 0;
        }
        return message;
    };

    ProtocolInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.supported_messages = [];
        if (options.defaults) {
            object.version = 0;
            object.build_fingerprint = "";
        }
        if (message.version != null && message.hasOwnProperty("version"))
            object.version = message.version;
        if (message.build_fingerprint != null && message.hasOwnProperty("build_fingerprint"))
            object.build_fingerprint = message.build_fingerprint;
        if (message.supported_messages && message.supported_messages.length) {
            object.supported_messages = [];
            for (var j = 0; j < message.supported_messages.length; ++j)
                object.supported_messages[j] = message.supported_messages[j];
        }
        return object;
    };

    ProtocolInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ProtocolInfo;
})();

$root.Ping = (function() {

    function Ping(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    Ping.prototype.message = "";

    Ping.create = function create(properties) {
        return new Ping(properties);
    };

    Ping.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
            writer.uint32(10).string(message.message);
        return writer;
    };

    Ping.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    Ping.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Ping();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.message = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    Ping.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    Ping.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.message != null && message.hasOwnProperty("message"))
            if (!$util.isString(message.message))
                return "message: string expected";
        return null;
    };

    Ping.fromObject = function fromObject(object) {
        if (object instanceof $root.Ping)
            return object;
        var message = new $root.Ping();
        if (object.message != null)
            message.message = String(object.message);
        return message;
    };

    Ping.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.message = "";
        if (message.message != null && message.hasOwnProperty("message"))
            object.message = message.message;
        return object;
    };

    Ping.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return Ping;
})();

$root.Success = (function() {

    function Success(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    Success.prototype.message = "";

    Success.create = function create(properties) {
        return new Success(properties);
    };

    Success.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
            writer.uint32(10).string(message.message);
        return writer;
    };

    Success.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    Success.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Success();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.message = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    Success.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    Success.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.message != null && message.hasOwnProperty("message"))
            if (!$util.isString(message.message))
                return "message: string expected";
        return null;
    };

    Success.fromObject = function fromObject(object) {
        if (object instanceof $root.Success)
            return object;
        var message = new $root.Success();
        if (object.message != null)
            message.message = String(object.message);
        return message;
    };

    Success.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.message = "";
        if (message.message != null && message.hasOwnProperty("message"))
            object.message = message.message;
        return object;
    };

    Success.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return Success;
})();

$root.Failure = (function() {

    function Failure(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    Failure.prototype.code = 1;
    Failure.prototype.subcode = 0;
    Failure.prototype.message = "";

    Failure.create = function create(properties) {
        return new Failure(properties);
    };

    Failure.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).int32(message.code);
        if (message.subcode != null && Object.hasOwnProperty.call(message, "subcode"))
            writer.uint32(16).uint32(message.subcode);
        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
            writer.uint32(26).string(message.message);
        return writer;
    };

    Failure.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    Failure.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Failure();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.code = reader.int32();
                break;
            case 2:
                message.subcode = reader.uint32();
                break;
            case 3:
                message.message = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("code"))
            throw $util.ProtocolError("missing required 'code'", { instance: message });
        return message;
    };

    Failure.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    Failure.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        switch (message.code) {
        default:
            return "code: enum value expected";
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        }
        if (message.subcode != null && message.hasOwnProperty("subcode"))
            if (!$util.isInteger(message.subcode))
                return "subcode: integer expected";
        if (message.message != null && message.hasOwnProperty("message"))
            if (!$util.isString(message.message))
                return "message: string expected";
        return null;
    };

    Failure.fromObject = function fromObject(object) {
        if (object instanceof $root.Failure)
            return object;
        var message = new $root.Failure();
        switch (object.code) {
        case "Failure_InvalidMessage":
        case 1:
            message.code = 1;
            break;
        case "Failure_UndefinedError":
        case 2:
            message.code = 2;
            break;
        case "Failure_UsageError":
        case 3:
            message.code = 3;
            break;
        case "Failure_DataError":
        case 4:
            message.code = 4;
            break;
        case "Failure_ProcessError":
        case 5:
            message.code = 5;
            break;
        }
        if (object.subcode != null)
            message.subcode = object.subcode >>> 0;
        if (object.message != null)
            message.message = String(object.message);
        return message;
    };

    Failure.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.code = options.enums === String ? "Failure_InvalidMessage" : 1;
            object.subcode = 0;
            object.message = "";
        }
        if (message.code != null && message.hasOwnProperty("code"))
            object.code = options.enums === String ? $root.Failure.FailureType[message.code] : message.code;
        if (message.subcode != null && message.hasOwnProperty("subcode"))
            object.subcode = message.subcode;
        if (message.message != null && message.hasOwnProperty("message"))
            object.message = message.message;
        return object;
    };

    Failure.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    Failure.FailureType = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[1] = "Failure_InvalidMessage"] = 1;
        values[valuesById[2] = "Failure_UndefinedError"] = 2;
        values[valuesById[3] = "Failure_UsageError"] = 3;
        values[valuesById[4] = "Failure_DataError"] = 4;
        values[valuesById[5] = "Failure_ProcessError"] = 5;
        return values;
    })();

    return Failure;
})();

$root.DeviceErrorCode = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "DeviceError_None"] = 0;
    values[valuesById[1] = "DeviceError_Busy"] = 1;
    values[valuesById[2] = "DeviceError_NotInitialized"] = 2;
    values[valuesById[3] = "DeviceError_ActionCancelled"] = 3;
    values[valuesById[4] = "DeviceError_PinAlreadyUsed"] = 4;
    values[valuesById[5] = "DeviceError_PersistFailed"] = 5;
    values[valuesById[6] = "DeviceError_SeError"] = 6;
    values[valuesById[7] = "DeviceError_InvalidLanguage"] = 7;
    values[valuesById[8] = "DeviceError_WallpaperNotUsable"] = 8;
    values[valuesById[9] = "DeviceError_DeviceLocked"] = 9;
    return values;
})();

$root.DeviceRebootType = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "Normal"] = 0;
    values[valuesById[1] = "Romloader"] = 1;
    values[valuesById[2] = "Bootloader"] = 2;
    return values;
})();

$root.DeviceReboot = (function() {

    function DeviceReboot(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DeviceReboot.prototype.reboot_type = 0;

    DeviceReboot.create = function create(properties) {
        return new DeviceReboot(properties);
    };

    DeviceReboot.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).int32(message.reboot_type);
        return writer;
    };

    DeviceReboot.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DeviceReboot.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DeviceReboot();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.reboot_type = reader.int32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("reboot_type"))
            throw $util.ProtocolError("missing required 'reboot_type'", { instance: message });
        return message;
    };

    DeviceReboot.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DeviceReboot.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        switch (message.reboot_type) {
        default:
            return "reboot_type: enum value expected";
        case 0:
        case 1:
        case 2:
            break;
        }
        return null;
    };

    DeviceReboot.fromObject = function fromObject(object) {
        if (object instanceof $root.DeviceReboot)
            return object;
        var message = new $root.DeviceReboot();
        switch (object.reboot_type) {
        case "Normal":
        case 0:
            message.reboot_type = 0;
            break;
        case "Romloader":
        case 1:
            message.reboot_type = 1;
            break;
        case "Bootloader":
        case 2:
            message.reboot_type = 2;
            break;
        }
        return message;
    };

    DeviceReboot.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.reboot_type = options.enums === String ? "Normal" : 0;
        if (message.reboot_type != null && message.hasOwnProperty("reboot_type"))
            object.reboot_type = options.enums === String ? $root.DeviceRebootType[message.reboot_type] : message.reboot_type;
        return object;
    };

    DeviceReboot.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DeviceReboot;
})();

$root.DeviceSettings = (function() {

    function DeviceSettings(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DeviceSettings.prototype.bt_enable = false;
    DeviceSettings.prototype.language = "";
    DeviceSettings.prototype.wallpaper_path = "";
    DeviceSettings.prototype.brightness = 0;
    DeviceSettings.prototype.animation_enable = false;
    DeviceSettings.prototype.tap_to_wake = false;
    DeviceSettings.prototype.haptic_feedback = false;
    DeviceSettings.prototype.device_name_display_enabled = false;
    DeviceSettings.prototype.airgap_mode = false;
    DeviceSettings.prototype.usb_lock_enable = false;
    DeviceSettings.prototype.random_keypad = false;
    DeviceSettings.prototype.passphrase_enable = false;
    DeviceSettings.prototype.fido_enabled = false;
    DeviceSettings.prototype.autolock_delay_ms = 0;
    DeviceSettings.prototype.autoshutdown_delay_ms = 0;
    DeviceSettings.prototype.label = "";

    DeviceSettings.create = function create(properties) {
        return new DeviceSettings(properties);
    };

    DeviceSettings.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.bt_enable != null && Object.hasOwnProperty.call(message, "bt_enable"))
            writer.uint32(8).bool(message.bt_enable);
        if (message.language != null && Object.hasOwnProperty.call(message, "language"))
            writer.uint32(18).string(message.language);
        if (message.wallpaper_path != null && Object.hasOwnProperty.call(message, "wallpaper_path"))
            writer.uint32(26).string(message.wallpaper_path);
        if (message.brightness != null && Object.hasOwnProperty.call(message, "brightness"))
            writer.uint32(32).uint32(message.brightness);
        if (message.animation_enable != null && Object.hasOwnProperty.call(message, "animation_enable"))
            writer.uint32(40).bool(message.animation_enable);
        if (message.tap_to_wake != null && Object.hasOwnProperty.call(message, "tap_to_wake"))
            writer.uint32(48).bool(message.tap_to_wake);
        if (message.haptic_feedback != null && Object.hasOwnProperty.call(message, "haptic_feedback"))
            writer.uint32(56).bool(message.haptic_feedback);
        if (message.device_name_display_enabled != null && Object.hasOwnProperty.call(message, "device_name_display_enabled"))
            writer.uint32(64).bool(message.device_name_display_enabled);
        if (message.airgap_mode != null && Object.hasOwnProperty.call(message, "airgap_mode"))
            writer.uint32(72).bool(message.airgap_mode);
        if (message.usb_lock_enable != null && Object.hasOwnProperty.call(message, "usb_lock_enable"))
            writer.uint32(80).bool(message.usb_lock_enable);
        if (message.random_keypad != null && Object.hasOwnProperty.call(message, "random_keypad"))
            writer.uint32(88).bool(message.random_keypad);
        if (message.passphrase_enable != null && Object.hasOwnProperty.call(message, "passphrase_enable"))
            writer.uint32(800).bool(message.passphrase_enable);
        if (message.fido_enabled != null && Object.hasOwnProperty.call(message, "fido_enabled"))
            writer.uint32(808).bool(message.fido_enabled);
        if (message.autolock_delay_ms != null && Object.hasOwnProperty.call(message, "autolock_delay_ms"))
            writer.uint32(816).uint32(message.autolock_delay_ms);
        if (message.autoshutdown_delay_ms != null && Object.hasOwnProperty.call(message, "autoshutdown_delay_ms"))
            writer.uint32(824).uint32(message.autoshutdown_delay_ms);
        if (message.label != null && Object.hasOwnProperty.call(message, "label"))
            writer.uint32(834).string(message.label);
        return writer;
    };

    DeviceSettings.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DeviceSettings.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DeviceSettings();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.bt_enable = reader.bool();
                break;
            case 2:
                message.language = reader.string();
                break;
            case 3:
                message.wallpaper_path = reader.string();
                break;
            case 4:
                message.brightness = reader.uint32();
                break;
            case 5:
                message.animation_enable = reader.bool();
                break;
            case 6:
                message.tap_to_wake = reader.bool();
                break;
            case 7:
                message.haptic_feedback = reader.bool();
                break;
            case 8:
                message.device_name_display_enabled = reader.bool();
                break;
            case 9:
                message.airgap_mode = reader.bool();
                break;
            case 10:
                message.usb_lock_enable = reader.bool();
                break;
            case 11:
                message.random_keypad = reader.bool();
                break;
            case 100:
                message.passphrase_enable = reader.bool();
                break;
            case 101:
                message.fido_enabled = reader.bool();
                break;
            case 102:
                message.autolock_delay_ms = reader.uint32();
                break;
            case 103:
                message.autoshutdown_delay_ms = reader.uint32();
                break;
            case 104:
                message.label = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    DeviceSettings.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DeviceSettings.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.bt_enable != null && message.hasOwnProperty("bt_enable"))
            if (typeof message.bt_enable !== "boolean")
                return "bt_enable: boolean expected";
        if (message.language != null && message.hasOwnProperty("language"))
            if (!$util.isString(message.language))
                return "language: string expected";
        if (message.wallpaper_path != null && message.hasOwnProperty("wallpaper_path"))
            if (!$util.isString(message.wallpaper_path))
                return "wallpaper_path: string expected";
        if (message.brightness != null && message.hasOwnProperty("brightness"))
            if (!$util.isInteger(message.brightness))
                return "brightness: integer expected";
        if (message.animation_enable != null && message.hasOwnProperty("animation_enable"))
            if (typeof message.animation_enable !== "boolean")
                return "animation_enable: boolean expected";
        if (message.tap_to_wake != null && message.hasOwnProperty("tap_to_wake"))
            if (typeof message.tap_to_wake !== "boolean")
                return "tap_to_wake: boolean expected";
        if (message.haptic_feedback != null && message.hasOwnProperty("haptic_feedback"))
            if (typeof message.haptic_feedback !== "boolean")
                return "haptic_feedback: boolean expected";
        if (message.device_name_display_enabled != null && message.hasOwnProperty("device_name_display_enabled"))
            if (typeof message.device_name_display_enabled !== "boolean")
                return "device_name_display_enabled: boolean expected";
        if (message.airgap_mode != null && message.hasOwnProperty("airgap_mode"))
            if (typeof message.airgap_mode !== "boolean")
                return "airgap_mode: boolean expected";
        if (message.usb_lock_enable != null && message.hasOwnProperty("usb_lock_enable"))
            if (typeof message.usb_lock_enable !== "boolean")
                return "usb_lock_enable: boolean expected";
        if (message.random_keypad != null && message.hasOwnProperty("random_keypad"))
            if (typeof message.random_keypad !== "boolean")
                return "random_keypad: boolean expected";
        if (message.passphrase_enable != null && message.hasOwnProperty("passphrase_enable"))
            if (typeof message.passphrase_enable !== "boolean")
                return "passphrase_enable: boolean expected";
        if (message.fido_enabled != null && message.hasOwnProperty("fido_enabled"))
            if (typeof message.fido_enabled !== "boolean")
                return "fido_enabled: boolean expected";
        if (message.autolock_delay_ms != null && message.hasOwnProperty("autolock_delay_ms"))
            if (!$util.isInteger(message.autolock_delay_ms))
                return "autolock_delay_ms: integer expected";
        if (message.autoshutdown_delay_ms != null && message.hasOwnProperty("autoshutdown_delay_ms"))
            if (!$util.isInteger(message.autoshutdown_delay_ms))
                return "autoshutdown_delay_ms: integer expected";
        if (message.label != null && message.hasOwnProperty("label"))
            if (!$util.isString(message.label))
                return "label: string expected";
        return null;
    };

    DeviceSettings.fromObject = function fromObject(object) {
        if (object instanceof $root.DeviceSettings)
            return object;
        var message = new $root.DeviceSettings();
        if (object.bt_enable != null)
            message.bt_enable = Boolean(object.bt_enable);
        if (object.language != null)
            message.language = String(object.language);
        if (object.wallpaper_path != null)
            message.wallpaper_path = String(object.wallpaper_path);
        if (object.brightness != null)
            message.brightness = object.brightness >>> 0;
        if (object.animation_enable != null)
            message.animation_enable = Boolean(object.animation_enable);
        if (object.tap_to_wake != null)
            message.tap_to_wake = Boolean(object.tap_to_wake);
        if (object.haptic_feedback != null)
            message.haptic_feedback = Boolean(object.haptic_feedback);
        if (object.device_name_display_enabled != null)
            message.device_name_display_enabled = Boolean(object.device_name_display_enabled);
        if (object.airgap_mode != null)
            message.airgap_mode = Boolean(object.airgap_mode);
        if (object.usb_lock_enable != null)
            message.usb_lock_enable = Boolean(object.usb_lock_enable);
        if (object.random_keypad != null)
            message.random_keypad = Boolean(object.random_keypad);
        if (object.passphrase_enable != null)
            message.passphrase_enable = Boolean(object.passphrase_enable);
        if (object.fido_enabled != null)
            message.fido_enabled = Boolean(object.fido_enabled);
        if (object.autolock_delay_ms != null)
            message.autolock_delay_ms = object.autolock_delay_ms >>> 0;
        if (object.autoshutdown_delay_ms != null)
            message.autoshutdown_delay_ms = object.autoshutdown_delay_ms >>> 0;
        if (object.label != null)
            message.label = String(object.label);
        return message;
    };

    DeviceSettings.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.bt_enable = false;
            object.language = "";
            object.wallpaper_path = "";
            object.brightness = 0;
            object.animation_enable = false;
            object.tap_to_wake = false;
            object.haptic_feedback = false;
            object.device_name_display_enabled = false;
            object.airgap_mode = false;
            object.usb_lock_enable = false;
            object.random_keypad = false;
            object.passphrase_enable = false;
            object.fido_enabled = false;
            object.autolock_delay_ms = 0;
            object.autoshutdown_delay_ms = 0;
            object.label = "";
        }
        if (message.bt_enable != null && message.hasOwnProperty("bt_enable"))
            object.bt_enable = message.bt_enable;
        if (message.language != null && message.hasOwnProperty("language"))
            object.language = message.language;
        if (message.wallpaper_path != null && message.hasOwnProperty("wallpaper_path"))
            object.wallpaper_path = message.wallpaper_path;
        if (message.brightness != null && message.hasOwnProperty("brightness"))
            object.brightness = message.brightness;
        if (message.animation_enable != null && message.hasOwnProperty("animation_enable"))
            object.animation_enable = message.animation_enable;
        if (message.tap_to_wake != null && message.hasOwnProperty("tap_to_wake"))
            object.tap_to_wake = message.tap_to_wake;
        if (message.haptic_feedback != null && message.hasOwnProperty("haptic_feedback"))
            object.haptic_feedback = message.haptic_feedback;
        if (message.device_name_display_enabled != null && message.hasOwnProperty("device_name_display_enabled"))
            object.device_name_display_enabled = message.device_name_display_enabled;
        if (message.airgap_mode != null && message.hasOwnProperty("airgap_mode"))
            object.airgap_mode = message.airgap_mode;
        if (message.usb_lock_enable != null && message.hasOwnProperty("usb_lock_enable"))
            object.usb_lock_enable = message.usb_lock_enable;
        if (message.random_keypad != null && message.hasOwnProperty("random_keypad"))
            object.random_keypad = message.random_keypad;
        if (message.passphrase_enable != null && message.hasOwnProperty("passphrase_enable"))
            object.passphrase_enable = message.passphrase_enable;
        if (message.fido_enabled != null && message.hasOwnProperty("fido_enabled"))
            object.fido_enabled = message.fido_enabled;
        if (message.autolock_delay_ms != null && message.hasOwnProperty("autolock_delay_ms"))
            object.autolock_delay_ms = message.autolock_delay_ms;
        if (message.autoshutdown_delay_ms != null && message.hasOwnProperty("autoshutdown_delay_ms"))
            object.autoshutdown_delay_ms = message.autoshutdown_delay_ms;
        if (message.label != null && message.hasOwnProperty("label"))
            object.label = message.label;
        return object;
    };

    DeviceSettings.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DeviceSettings;
})();

$root.DeviceSettingsGet = (function() {

    function DeviceSettingsGet(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DeviceSettingsGet.create = function create(properties) {
        return new DeviceSettingsGet(properties);
    };

    DeviceSettingsGet.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    DeviceSettingsGet.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DeviceSettingsGet.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DeviceSettingsGet();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    DeviceSettingsGet.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DeviceSettingsGet.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    DeviceSettingsGet.fromObject = function fromObject(object) {
        if (object instanceof $root.DeviceSettingsGet)
            return object;
        return new $root.DeviceSettingsGet();
    };

    DeviceSettingsGet.toObject = function toObject() {
        return {};
    };

    DeviceSettingsGet.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DeviceSettingsGet;
})();

$root.DeviceSettingsSet = (function() {

    function DeviceSettingsSet(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DeviceSettingsSet.prototype.settings = null;

    DeviceSettingsSet.create = function create(properties) {
        return new DeviceSettingsSet(properties);
    };

    DeviceSettingsSet.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        $root.DeviceSettings.encode(message.settings, writer.uint32(10).fork()).ldelim();
        return writer;
    };

    DeviceSettingsSet.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DeviceSettingsSet.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DeviceSettingsSet();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.settings = $root.DeviceSettings.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("settings"))
            throw $util.ProtocolError("missing required 'settings'", { instance: message });
        return message;
    };

    DeviceSettingsSet.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DeviceSettingsSet.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        {
            var error = $root.DeviceSettings.verify(message.settings);
            if (error)
                return "settings." + error;
        }
        return null;
    };

    DeviceSettingsSet.fromObject = function fromObject(object) {
        if (object instanceof $root.DeviceSettingsSet)
            return object;
        var message = new $root.DeviceSettingsSet();
        if (object.settings != null) {
            if (typeof object.settings !== "object")
                throw TypeError(".DeviceSettingsSet.settings: object expected");
            message.settings = $root.DeviceSettings.fromObject(object.settings);
        }
        return message;
    };

    DeviceSettingsSet.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.settings = null;
        if (message.settings != null && message.hasOwnProperty("settings"))
            object.settings = $root.DeviceSettings.toObject(message.settings, options);
        return object;
    };

    DeviceSettingsSet.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DeviceSettingsSet;
})();

$root.DeviceSettingsPage = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "DeviceReset"] = 0;
    values[valuesById[1] = "DevicePinChange"] = 1;
    values[valuesById[2] = "DevicePassphrase"] = 2;
    values[valuesById[3] = "DeviceAirgap"] = 3;
    return values;
})();

$root.DeviceSettingsPageShow = (function() {

    function DeviceSettingsPageShow(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DeviceSettingsPageShow.prototype.page = 0;
    DeviceSettingsPageShow.prototype.field_name = "";

    DeviceSettingsPageShow.create = function create(properties) {
        return new DeviceSettingsPageShow(properties);
    };

    DeviceSettingsPageShow.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).int32(message.page);
        if (message.field_name != null && Object.hasOwnProperty.call(message, "field_name"))
            writer.uint32(18).string(message.field_name);
        return writer;
    };

    DeviceSettingsPageShow.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DeviceSettingsPageShow.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DeviceSettingsPageShow();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.page = reader.int32();
                break;
            case 2:
                message.field_name = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("page"))
            throw $util.ProtocolError("missing required 'page'", { instance: message });
        return message;
    };

    DeviceSettingsPageShow.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DeviceSettingsPageShow.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        switch (message.page) {
        default:
            return "page: enum value expected";
        case 0:
        case 1:
        case 2:
        case 3:
            break;
        }
        if (message.field_name != null && message.hasOwnProperty("field_name"))
            if (!$util.isString(message.field_name))
                return "field_name: string expected";
        return null;
    };

    DeviceSettingsPageShow.fromObject = function fromObject(object) {
        if (object instanceof $root.DeviceSettingsPageShow)
            return object;
        var message = new $root.DeviceSettingsPageShow();
        switch (object.page) {
        case "DeviceReset":
        case 0:
            message.page = 0;
            break;
        case "DevicePinChange":
        case 1:
            message.page = 1;
            break;
        case "DevicePassphrase":
        case 2:
            message.page = 2;
            break;
        case "DeviceAirgap":
        case 3:
            message.page = 3;
            break;
        }
        if (object.field_name != null)
            message.field_name = String(object.field_name);
        return message;
    };

    DeviceSettingsPageShow.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.page = options.enums === String ? "DeviceReset" : 0;
            object.field_name = "";
        }
        if (message.page != null && message.hasOwnProperty("page"))
            object.page = options.enums === String ? $root.DeviceSettingsPage[message.page] : message.page;
        if (message.field_name != null && message.hasOwnProperty("field_name"))
            object.field_name = message.field_name;
        return object;
    };

    DeviceSettingsPageShow.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DeviceSettingsPageShow;
})();

$root.DeviceCertificate = (function() {

    function DeviceCertificate(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DeviceCertificate.prototype.cert_and_pubkey = $util.newBuffer([]);
    DeviceCertificate.prototype.private_key = $util.newBuffer([]);

    DeviceCertificate.create = function create(properties) {
        return new DeviceCertificate(properties);
    };

    DeviceCertificate.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.cert_and_pubkey);
        if (message.private_key != null && Object.hasOwnProperty.call(message, "private_key"))
            writer.uint32(18).bytes(message.private_key);
        return writer;
    };

    DeviceCertificate.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DeviceCertificate.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DeviceCertificate();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.cert_and_pubkey = reader.bytes();
                break;
            case 2:
                message.private_key = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("cert_and_pubkey"))
            throw $util.ProtocolError("missing required 'cert_and_pubkey'", { instance: message });
        return message;
    };

    DeviceCertificate.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DeviceCertificate.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.cert_and_pubkey && typeof message.cert_and_pubkey.length === "number" || $util.isString(message.cert_and_pubkey)))
            return "cert_and_pubkey: buffer expected";
        if (message.private_key != null && message.hasOwnProperty("private_key"))
            if (!(message.private_key && typeof message.private_key.length === "number" || $util.isString(message.private_key)))
                return "private_key: buffer expected";
        return null;
    };

    DeviceCertificate.fromObject = function fromObject(object) {
        if (object instanceof $root.DeviceCertificate)
            return object;
        var message = new $root.DeviceCertificate();
        if (object.cert_and_pubkey != null)
            if (typeof object.cert_and_pubkey === "string")
                $util.base64.decode(object.cert_and_pubkey, message.cert_and_pubkey = $util.newBuffer($util.base64.length(object.cert_and_pubkey)), 0);
            else if (object.cert_and_pubkey.length)
                message.cert_and_pubkey = object.cert_and_pubkey;
        if (object.private_key != null)
            if (typeof object.private_key === "string")
                $util.base64.decode(object.private_key, message.private_key = $util.newBuffer($util.base64.length(object.private_key)), 0);
            else if (object.private_key.length)
                message.private_key = object.private_key;
        return message;
    };

    DeviceCertificate.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.cert_and_pubkey = "";
            else {
                object.cert_and_pubkey = [];
                if (options.bytes !== Array)
                    object.cert_and_pubkey = $util.newBuffer(object.cert_and_pubkey);
            }
            if (options.bytes === String)
                object.private_key = "";
            else {
                object.private_key = [];
                if (options.bytes !== Array)
                    object.private_key = $util.newBuffer(object.private_key);
            }
        }
        if (message.cert_and_pubkey != null && message.hasOwnProperty("cert_and_pubkey"))
            object.cert_and_pubkey = options.bytes === String ? $util.base64.encode(message.cert_and_pubkey, 0, message.cert_and_pubkey.length) : options.bytes === Array ? Array.prototype.slice.call(message.cert_and_pubkey) : message.cert_and_pubkey;
        if (message.private_key != null && message.hasOwnProperty("private_key"))
            object.private_key = options.bytes === String ? $util.base64.encode(message.private_key, 0, message.private_key.length) : options.bytes === Array ? Array.prototype.slice.call(message.private_key) : message.private_key;
        return object;
    };

    DeviceCertificate.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DeviceCertificate;
})();

$root.DeviceCertificateWrite = (function() {

    function DeviceCertificateWrite(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DeviceCertificateWrite.prototype.cert = null;

    DeviceCertificateWrite.create = function create(properties) {
        return new DeviceCertificateWrite(properties);
    };

    DeviceCertificateWrite.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        $root.DeviceCertificate.encode(message.cert, writer.uint32(10).fork()).ldelim();
        return writer;
    };

    DeviceCertificateWrite.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DeviceCertificateWrite.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DeviceCertificateWrite();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.cert = $root.DeviceCertificate.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("cert"))
            throw $util.ProtocolError("missing required 'cert'", { instance: message });
        return message;
    };

    DeviceCertificateWrite.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DeviceCertificateWrite.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        {
            var error = $root.DeviceCertificate.verify(message.cert);
            if (error)
                return "cert." + error;
        }
        return null;
    };

    DeviceCertificateWrite.fromObject = function fromObject(object) {
        if (object instanceof $root.DeviceCertificateWrite)
            return object;
        var message = new $root.DeviceCertificateWrite();
        if (object.cert != null) {
            if (typeof object.cert !== "object")
                throw TypeError(".DeviceCertificateWrite.cert: object expected");
            message.cert = $root.DeviceCertificate.fromObject(object.cert);
        }
        return message;
    };

    DeviceCertificateWrite.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.cert = null;
        if (message.cert != null && message.hasOwnProperty("cert"))
            object.cert = $root.DeviceCertificate.toObject(message.cert, options);
        return object;
    };

    DeviceCertificateWrite.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DeviceCertificateWrite;
})();

$root.DeviceCertificateRead = (function() {

    function DeviceCertificateRead(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DeviceCertificateRead.create = function create(properties) {
        return new DeviceCertificateRead(properties);
    };

    DeviceCertificateRead.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    DeviceCertificateRead.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DeviceCertificateRead.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DeviceCertificateRead();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    DeviceCertificateRead.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DeviceCertificateRead.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    DeviceCertificateRead.fromObject = function fromObject(object) {
        if (object instanceof $root.DeviceCertificateRead)
            return object;
        return new $root.DeviceCertificateRead();
    };

    DeviceCertificateRead.toObject = function toObject() {
        return {};
    };

    DeviceCertificateRead.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DeviceCertificateRead;
})();

$root.DeviceCertificateSignature = (function() {

    function DeviceCertificateSignature(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DeviceCertificateSignature.prototype.data = $util.newBuffer([]);

    DeviceCertificateSignature.create = function create(properties) {
        return new DeviceCertificateSignature(properties);
    };

    DeviceCertificateSignature.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.data);
        return writer;
    };

    DeviceCertificateSignature.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DeviceCertificateSignature.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DeviceCertificateSignature();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.data = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("data"))
            throw $util.ProtocolError("missing required 'data'", { instance: message });
        return message;
    };

    DeviceCertificateSignature.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DeviceCertificateSignature.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
            return "data: buffer expected";
        return null;
    };

    DeviceCertificateSignature.fromObject = function fromObject(object) {
        if (object instanceof $root.DeviceCertificateSignature)
            return object;
        var message = new $root.DeviceCertificateSignature();
        if (object.data != null)
            if (typeof object.data === "string")
                $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
            else if (object.data.length)
                message.data = object.data;
        return message;
    };

    DeviceCertificateSignature.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.data = "";
            else {
                object.data = [];
                if (options.bytes !== Array)
                    object.data = $util.newBuffer(object.data);
            }
        if (message.data != null && message.hasOwnProperty("data"))
            object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
        return object;
    };

    DeviceCertificateSignature.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DeviceCertificateSignature;
})();

$root.DeviceCertificateSign = (function() {

    function DeviceCertificateSign(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DeviceCertificateSign.prototype.data = $util.newBuffer([]);

    DeviceCertificateSign.create = function create(properties) {
        return new DeviceCertificateSign(properties);
    };

    DeviceCertificateSign.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.data);
        return writer;
    };

    DeviceCertificateSign.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DeviceCertificateSign.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DeviceCertificateSign();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.data = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("data"))
            throw $util.ProtocolError("missing required 'data'", { instance: message });
        return message;
    };

    DeviceCertificateSign.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DeviceCertificateSign.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
            return "data: buffer expected";
        return null;
    };

    DeviceCertificateSign.fromObject = function fromObject(object) {
        if (object instanceof $root.DeviceCertificateSign)
            return object;
        var message = new $root.DeviceCertificateSign();
        if (object.data != null)
            if (typeof object.data === "string")
                $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
            else if (object.data.length)
                message.data = object.data;
        return message;
    };

    DeviceCertificateSign.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.data = "";
            else {
                object.data = [];
                if (options.bytes !== Array)
                    object.data = $util.newBuffer(object.data);
            }
        if (message.data != null && message.hasOwnProperty("data"))
            object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
        return object;
    };

    DeviceCertificateSign.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DeviceCertificateSign;
})();

$root.DeviceMiscUsbMscControl = (function() {

    function DeviceMiscUsbMscControl(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DeviceMiscUsbMscControl.prototype.enable = false;

    DeviceMiscUsbMscControl.create = function create(properties) {
        return new DeviceMiscUsbMscControl(properties);
    };

    DeviceMiscUsbMscControl.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).bool(message.enable);
        return writer;
    };

    DeviceMiscUsbMscControl.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DeviceMiscUsbMscControl.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DeviceMiscUsbMscControl();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.enable = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("enable"))
            throw $util.ProtocolError("missing required 'enable'", { instance: message });
        return message;
    };

    DeviceMiscUsbMscControl.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DeviceMiscUsbMscControl.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (typeof message.enable !== "boolean")
            return "enable: boolean expected";
        return null;
    };

    DeviceMiscUsbMscControl.fromObject = function fromObject(object) {
        if (object instanceof $root.DeviceMiscUsbMscControl)
            return object;
        var message = new $root.DeviceMiscUsbMscControl();
        if (object.enable != null)
            message.enable = Boolean(object.enable);
        return message;
    };

    DeviceMiscUsbMscControl.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.enable = false;
        if (message.enable != null && message.hasOwnProperty("enable"))
            object.enable = message.enable;
        return object;
    };

    DeviceMiscUsbMscControl.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DeviceMiscUsbMscControl;
})();

$root.DeviceFindMyTokenUpdate = (function() {

    function DeviceFindMyTokenUpdate(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DeviceFindMyTokenUpdate.prototype.token = $util.newBuffer([]);

    DeviceFindMyTokenUpdate.create = function create(properties) {
        return new DeviceFindMyTokenUpdate(properties);
    };

    DeviceFindMyTokenUpdate.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.token);
        return writer;
    };

    DeviceFindMyTokenUpdate.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DeviceFindMyTokenUpdate.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DeviceFindMyTokenUpdate();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.token = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("token"))
            throw $util.ProtocolError("missing required 'token'", { instance: message });
        return message;
    };

    DeviceFindMyTokenUpdate.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DeviceFindMyTokenUpdate.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.token && typeof message.token.length === "number" || $util.isString(message.token)))
            return "token: buffer expected";
        return null;
    };

    DeviceFindMyTokenUpdate.fromObject = function fromObject(object) {
        if (object instanceof $root.DeviceFindMyTokenUpdate)
            return object;
        var message = new $root.DeviceFindMyTokenUpdate();
        if (object.token != null)
            if (typeof object.token === "string")
                $util.base64.decode(object.token, message.token = $util.newBuffer($util.base64.length(object.token)), 0);
            else if (object.token.length)
                message.token = object.token;
        return message;
    };

    DeviceFindMyTokenUpdate.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.token = "";
            else {
                object.token = [];
                if (options.bytes !== Array)
                    object.token = $util.newBuffer(object.token);
            }
        if (message.token != null && message.hasOwnProperty("token"))
            object.token = options.bytes === String ? $util.base64.encode(message.token, 0, message.token.length) : options.bytes === Array ? Array.prototype.slice.call(message.token) : message.token;
        return object;
    };

    DeviceFindMyTokenUpdate.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DeviceFindMyTokenUpdate;
})();

$root.DeviceFindMyTokenStateGet = (function() {

    function DeviceFindMyTokenStateGet(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DeviceFindMyTokenStateGet.create = function create(properties) {
        return new DeviceFindMyTokenStateGet(properties);
    };

    DeviceFindMyTokenStateGet.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    DeviceFindMyTokenStateGet.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DeviceFindMyTokenStateGet.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DeviceFindMyTokenStateGet();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    DeviceFindMyTokenStateGet.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DeviceFindMyTokenStateGet.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    DeviceFindMyTokenStateGet.fromObject = function fromObject(object) {
        if (object instanceof $root.DeviceFindMyTokenStateGet)
            return object;
        return new $root.DeviceFindMyTokenStateGet();
    };

    DeviceFindMyTokenStateGet.toObject = function toObject() {
        return {};
    };

    DeviceFindMyTokenStateGet.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DeviceFindMyTokenStateGet;
})();

$root.DeviceFindMyTokenState = (function() {

    function DeviceFindMyTokenState(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DeviceFindMyTokenState.prototype.burned = false;

    DeviceFindMyTokenState.create = function create(properties) {
        return new DeviceFindMyTokenState(properties);
    };

    DeviceFindMyTokenState.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).bool(message.burned);
        return writer;
    };

    DeviceFindMyTokenState.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DeviceFindMyTokenState.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DeviceFindMyTokenState();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.burned = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("burned"))
            throw $util.ProtocolError("missing required 'burned'", { instance: message });
        return message;
    };

    DeviceFindMyTokenState.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DeviceFindMyTokenState.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (typeof message.burned !== "boolean")
            return "burned: boolean expected";
        return null;
    };

    DeviceFindMyTokenState.fromObject = function fromObject(object) {
        if (object instanceof $root.DeviceFindMyTokenState)
            return object;
        var message = new $root.DeviceFindMyTokenState();
        if (object.burned != null)
            message.burned = Boolean(object.burned);
        return message;
    };

    DeviceFindMyTokenState.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.burned = false;
        if (message.burned != null && message.hasOwnProperty("burned"))
            object.burned = message.burned;
        return object;
    };

    DeviceFindMyTokenState.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DeviceFindMyTokenState;
})();

$root.DeviceAnimationAction = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "AnimationAction_Unknown"] = 0;
    values[valuesById[1] = "AnimationAction_Start"] = 1;
    values[valuesById[2] = "AnimationAction_Stop"] = 2;
    return values;
})();

$root.DeviceAnimationControl = (function() {

    function DeviceAnimationControl(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DeviceAnimationControl.prototype.action = 0;
    DeviceAnimationControl.prototype.timeout_ms = 0;

    DeviceAnimationControl.create = function create(properties) {
        return new DeviceAnimationControl(properties);
    };

    DeviceAnimationControl.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).int32(message.action);
        if (message.timeout_ms != null && Object.hasOwnProperty.call(message, "timeout_ms"))
            writer.uint32(16).uint32(message.timeout_ms);
        return writer;
    };

    DeviceAnimationControl.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DeviceAnimationControl.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DeviceAnimationControl();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.action = reader.int32();
                break;
            case 2:
                message.timeout_ms = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("action"))
            throw $util.ProtocolError("missing required 'action'", { instance: message });
        return message;
    };

    DeviceAnimationControl.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DeviceAnimationControl.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        switch (message.action) {
        default:
            return "action: enum value expected";
        case 0:
        case 1:
        case 2:
            break;
        }
        if (message.timeout_ms != null && message.hasOwnProperty("timeout_ms"))
            if (!$util.isInteger(message.timeout_ms))
                return "timeout_ms: integer expected";
        return null;
    };

    DeviceAnimationControl.fromObject = function fromObject(object) {
        if (object instanceof $root.DeviceAnimationControl)
            return object;
        var message = new $root.DeviceAnimationControl();
        switch (object.action) {
        case "AnimationAction_Unknown":
        case 0:
            message.action = 0;
            break;
        case "AnimationAction_Start":
        case 1:
            message.action = 1;
            break;
        case "AnimationAction_Stop":
        case 2:
            message.action = 2;
            break;
        }
        if (object.timeout_ms != null)
            message.timeout_ms = object.timeout_ms >>> 0;
        return message;
    };

    DeviceAnimationControl.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.action = options.enums === String ? "AnimationAction_Unknown" : 0;
            object.timeout_ms = 0;
        }
        if (message.action != null && message.hasOwnProperty("action"))
            object.action = options.enums === String ? $root.DeviceAnimationAction[message.action] : message.action;
        if (message.timeout_ms != null && message.hasOwnProperty("timeout_ms"))
            object.timeout_ms = message.timeout_ms;
        return object;
    };

    DeviceAnimationControl.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DeviceAnimationControl;
})();

$root.DeviceFactoryAck = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "FACTORY_ACK_SUCCESS"] = 0;
    values[valuesById[1] = "FACTORY_ACK_FAIL"] = 1;
    return values;
})();

$root.DeviceFactoryInfoManufactureTime = (function() {

    function DeviceFactoryInfoManufactureTime(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DeviceFactoryInfoManufactureTime.prototype.year = 0;
    DeviceFactoryInfoManufactureTime.prototype.month = 0;
    DeviceFactoryInfoManufactureTime.prototype.day = 0;
    DeviceFactoryInfoManufactureTime.prototype.hour = 0;
    DeviceFactoryInfoManufactureTime.prototype.minute = 0;
    DeviceFactoryInfoManufactureTime.prototype.second = 0;

    DeviceFactoryInfoManufactureTime.create = function create(properties) {
        return new DeviceFactoryInfoManufactureTime(properties);
    };

    DeviceFactoryInfoManufactureTime.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).uint32(message.year);
        writer.uint32(16).uint32(message.month);
        writer.uint32(24).uint32(message.day);
        writer.uint32(32).uint32(message.hour);
        writer.uint32(40).uint32(message.minute);
        writer.uint32(48).uint32(message.second);
        return writer;
    };

    DeviceFactoryInfoManufactureTime.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DeviceFactoryInfoManufactureTime.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DeviceFactoryInfoManufactureTime();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.year = reader.uint32();
                break;
            case 2:
                message.month = reader.uint32();
                break;
            case 3:
                message.day = reader.uint32();
                break;
            case 4:
                message.hour = reader.uint32();
                break;
            case 5:
                message.minute = reader.uint32();
                break;
            case 6:
                message.second = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("year"))
            throw $util.ProtocolError("missing required 'year'", { instance: message });
        if (!message.hasOwnProperty("month"))
            throw $util.ProtocolError("missing required 'month'", { instance: message });
        if (!message.hasOwnProperty("day"))
            throw $util.ProtocolError("missing required 'day'", { instance: message });
        if (!message.hasOwnProperty("hour"))
            throw $util.ProtocolError("missing required 'hour'", { instance: message });
        if (!message.hasOwnProperty("minute"))
            throw $util.ProtocolError("missing required 'minute'", { instance: message });
        if (!message.hasOwnProperty("second"))
            throw $util.ProtocolError("missing required 'second'", { instance: message });
        return message;
    };

    DeviceFactoryInfoManufactureTime.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DeviceFactoryInfoManufactureTime.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isInteger(message.year))
            return "year: integer expected";
        if (!$util.isInteger(message.month))
            return "month: integer expected";
        if (!$util.isInteger(message.day))
            return "day: integer expected";
        if (!$util.isInteger(message.hour))
            return "hour: integer expected";
        if (!$util.isInteger(message.minute))
            return "minute: integer expected";
        if (!$util.isInteger(message.second))
            return "second: integer expected";
        return null;
    };

    DeviceFactoryInfoManufactureTime.fromObject = function fromObject(object) {
        if (object instanceof $root.DeviceFactoryInfoManufactureTime)
            return object;
        var message = new $root.DeviceFactoryInfoManufactureTime();
        if (object.year != null)
            message.year = object.year >>> 0;
        if (object.month != null)
            message.month = object.month >>> 0;
        if (object.day != null)
            message.day = object.day >>> 0;
        if (object.hour != null)
            message.hour = object.hour >>> 0;
        if (object.minute != null)
            message.minute = object.minute >>> 0;
        if (object.second != null)
            message.second = object.second >>> 0;
        return message;
    };

    DeviceFactoryInfoManufactureTime.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.year = 0;
            object.month = 0;
            object.day = 0;
            object.hour = 0;
            object.minute = 0;
            object.second = 0;
        }
        if (message.year != null && message.hasOwnProperty("year"))
            object.year = message.year;
        if (message.month != null && message.hasOwnProperty("month"))
            object.month = message.month;
        if (message.day != null && message.hasOwnProperty("day"))
            object.day = message.day;
        if (message.hour != null && message.hasOwnProperty("hour"))
            object.hour = message.hour;
        if (message.minute != null && message.hasOwnProperty("minute"))
            object.minute = message.minute;
        if (message.second != null && message.hasOwnProperty("second"))
            object.second = message.second;
        return object;
    };

    DeviceFactoryInfoManufactureTime.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DeviceFactoryInfoManufactureTime;
})();

$root.DeviceFactoryInfo = (function() {

    function DeviceFactoryInfo(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DeviceFactoryInfo.prototype.version = 0;
    DeviceFactoryInfo.prototype.serial_number = "";
    DeviceFactoryInfo.prototype.factory_test_completed = false;
    DeviceFactoryInfo.prototype.factory_burn_in_completed = false;
    DeviceFactoryInfo.prototype.manufacture_time = null;
    DeviceFactoryInfo.prototype.data = $util.newBuffer([]);

    DeviceFactoryInfo.create = function create(properties) {
        return new DeviceFactoryInfo(properties);
    };

    DeviceFactoryInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.version != null && Object.hasOwnProperty.call(message, "version"))
            writer.uint32(8).uint32(message.version);
        if (message.serial_number != null && Object.hasOwnProperty.call(message, "serial_number"))
            writer.uint32(18).string(message.serial_number);
        if (message.factory_burn_in_completed != null && Object.hasOwnProperty.call(message, "factory_burn_in_completed"))
            writer.uint32(24).bool(message.factory_burn_in_completed);
        if (message.factory_test_completed != null && Object.hasOwnProperty.call(message, "factory_test_completed"))
            writer.uint32(32).bool(message.factory_test_completed);
        if (message.manufacture_time != null && Object.hasOwnProperty.call(message, "manufacture_time"))
            $root.DeviceFactoryInfoManufactureTime.encode(message.manufacture_time, writer.uint32(42).fork()).ldelim();
        if (message.data != null && Object.hasOwnProperty.call(message, "data"))
            writer.uint32(802).bytes(message.data);
        return writer;
    };

    DeviceFactoryInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DeviceFactoryInfo.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DeviceFactoryInfo();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.version = reader.uint32();
                break;
            case 2:
                message.serial_number = reader.string();
                break;
            case 4:
                message.factory_test_completed = reader.bool();
                break;
            case 3:
                message.factory_burn_in_completed = reader.bool();
                break;
            case 5:
                message.manufacture_time = $root.DeviceFactoryInfoManufactureTime.decode(reader, reader.uint32());
                break;
            case 100:
                message.data = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    DeviceFactoryInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DeviceFactoryInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.version != null && message.hasOwnProperty("version"))
            if (!$util.isInteger(message.version))
                return "version: integer expected";
        if (message.serial_number != null && message.hasOwnProperty("serial_number"))
            if (!$util.isString(message.serial_number))
                return "serial_number: string expected";
        if (message.factory_test_completed != null && message.hasOwnProperty("factory_test_completed"))
            if (typeof message.factory_test_completed !== "boolean")
                return "factory_test_completed: boolean expected";
        if (message.factory_burn_in_completed != null && message.hasOwnProperty("factory_burn_in_completed"))
            if (typeof message.factory_burn_in_completed !== "boolean")
                return "factory_burn_in_completed: boolean expected";
        if (message.manufacture_time != null && message.hasOwnProperty("manufacture_time")) {
            var error = $root.DeviceFactoryInfoManufactureTime.verify(message.manufacture_time);
            if (error)
                return "manufacture_time." + error;
        }
        if (message.data != null && message.hasOwnProperty("data"))
            if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
                return "data: buffer expected";
        return null;
    };

    DeviceFactoryInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.DeviceFactoryInfo)
            return object;
        var message = new $root.DeviceFactoryInfo();
        if (object.version != null)
            message.version = object.version >>> 0;
        if (object.serial_number != null)
            message.serial_number = String(object.serial_number);
        if (object.factory_test_completed != null)
            message.factory_test_completed = Boolean(object.factory_test_completed);
        if (object.factory_burn_in_completed != null)
            message.factory_burn_in_completed = Boolean(object.factory_burn_in_completed);
        if (object.manufacture_time != null) {
            if (typeof object.manufacture_time !== "object")
                throw TypeError(".DeviceFactoryInfo.manufacture_time: object expected");
            message.manufacture_time = $root.DeviceFactoryInfoManufactureTime.fromObject(object.manufacture_time);
        }
        if (object.data != null)
            if (typeof object.data === "string")
                $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
            else if (object.data.length)
                message.data = object.data;
        return message;
    };

    DeviceFactoryInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.version = 0;
            object.serial_number = "";
            object.factory_burn_in_completed = false;
            object.factory_test_completed = false;
            object.manufacture_time = null;
            if (options.bytes === String)
                object.data = "";
            else {
                object.data = [];
                if (options.bytes !== Array)
                    object.data = $util.newBuffer(object.data);
            }
        }
        if (message.version != null && message.hasOwnProperty("version"))
            object.version = message.version;
        if (message.serial_number != null && message.hasOwnProperty("serial_number"))
            object.serial_number = message.serial_number;
        if (message.factory_burn_in_completed != null && message.hasOwnProperty("factory_burn_in_completed"))
            object.factory_burn_in_completed = message.factory_burn_in_completed;
        if (message.factory_test_completed != null && message.hasOwnProperty("factory_test_completed"))
            object.factory_test_completed = message.factory_test_completed;
        if (message.manufacture_time != null && message.hasOwnProperty("manufacture_time"))
            object.manufacture_time = $root.DeviceFactoryInfoManufactureTime.toObject(message.manufacture_time, options);
        if (message.data != null && message.hasOwnProperty("data"))
            object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
        return object;
    };

    DeviceFactoryInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DeviceFactoryInfo;
})();

$root.DeviceFactoryInfoSet = (function() {

    function DeviceFactoryInfoSet(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DeviceFactoryInfoSet.prototype.info = null;
    DeviceFactoryInfoSet.prototype.full_data = false;

    DeviceFactoryInfoSet.create = function create(properties) {
        return new DeviceFactoryInfoSet(properties);
    };

    DeviceFactoryInfoSet.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        $root.DeviceFactoryInfo.encode(message.info, writer.uint32(10).fork()).ldelim();
        if (message.full_data != null && Object.hasOwnProperty.call(message, "full_data"))
            writer.uint32(16).bool(message.full_data);
        return writer;
    };

    DeviceFactoryInfoSet.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DeviceFactoryInfoSet.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DeviceFactoryInfoSet();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.info = $root.DeviceFactoryInfo.decode(reader, reader.uint32());
                break;
            case 2:
                message.full_data = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("info"))
            throw $util.ProtocolError("missing required 'info'", { instance: message });
        return message;
    };

    DeviceFactoryInfoSet.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DeviceFactoryInfoSet.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        {
            var error = $root.DeviceFactoryInfo.verify(message.info);
            if (error)
                return "info." + error;
        }
        if (message.full_data != null && message.hasOwnProperty("full_data"))
            if (typeof message.full_data !== "boolean")
                return "full_data: boolean expected";
        return null;
    };

    DeviceFactoryInfoSet.fromObject = function fromObject(object) {
        if (object instanceof $root.DeviceFactoryInfoSet)
            return object;
        var message = new $root.DeviceFactoryInfoSet();
        if (object.info != null) {
            if (typeof object.info !== "object")
                throw TypeError(".DeviceFactoryInfoSet.info: object expected");
            message.info = $root.DeviceFactoryInfo.fromObject(object.info);
        }
        if (object.full_data != null)
            message.full_data = Boolean(object.full_data);
        return message;
    };

    DeviceFactoryInfoSet.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.info = null;
            object.full_data = false;
        }
        if (message.info != null && message.hasOwnProperty("info"))
            object.info = $root.DeviceFactoryInfo.toObject(message.info, options);
        if (message.full_data != null && message.hasOwnProperty("full_data"))
            object.full_data = message.full_data;
        return object;
    };

    DeviceFactoryInfoSet.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DeviceFactoryInfoSet;
})();

$root.DeviceFactoryInfoGet = (function() {

    function DeviceFactoryInfoGet(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DeviceFactoryInfoGet.prototype.full_data = false;

    DeviceFactoryInfoGet.create = function create(properties) {
        return new DeviceFactoryInfoGet(properties);
    };

    DeviceFactoryInfoGet.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.full_data != null && Object.hasOwnProperty.call(message, "full_data"))
            writer.uint32(8).bool(message.full_data);
        return writer;
    };

    DeviceFactoryInfoGet.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DeviceFactoryInfoGet.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DeviceFactoryInfoGet();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.full_data = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    DeviceFactoryInfoGet.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DeviceFactoryInfoGet.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.full_data != null && message.hasOwnProperty("full_data"))
            if (typeof message.full_data !== "boolean")
                return "full_data: boolean expected";
        return null;
    };

    DeviceFactoryInfoGet.fromObject = function fromObject(object) {
        if (object instanceof $root.DeviceFactoryInfoGet)
            return object;
        var message = new $root.DeviceFactoryInfoGet();
        if (object.full_data != null)
            message.full_data = Boolean(object.full_data);
        return message;
    };

    DeviceFactoryInfoGet.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.full_data = false;
        if (message.full_data != null && message.hasOwnProperty("full_data"))
            object.full_data = message.full_data;
        return object;
    };

    DeviceFactoryInfoGet.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DeviceFactoryInfoGet;
})();

$root.DeviceFactoryPermanentLock = (function() {

    function DeviceFactoryPermanentLock(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DeviceFactoryPermanentLock.prototype.check_a = $util.newBuffer([]);
    DeviceFactoryPermanentLock.prototype.check_b = $util.newBuffer([]);

    DeviceFactoryPermanentLock.create = function create(properties) {
        return new DeviceFactoryPermanentLock(properties);
    };

    DeviceFactoryPermanentLock.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).bytes(message.check_a);
        writer.uint32(18).bytes(message.check_b);
        return writer;
    };

    DeviceFactoryPermanentLock.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DeviceFactoryPermanentLock.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DeviceFactoryPermanentLock();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.check_a = reader.bytes();
                break;
            case 2:
                message.check_b = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("check_a"))
            throw $util.ProtocolError("missing required 'check_a'", { instance: message });
        if (!message.hasOwnProperty("check_b"))
            throw $util.ProtocolError("missing required 'check_b'", { instance: message });
        return message;
    };

    DeviceFactoryPermanentLock.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DeviceFactoryPermanentLock.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.check_a && typeof message.check_a.length === "number" || $util.isString(message.check_a)))
            return "check_a: buffer expected";
        if (!(message.check_b && typeof message.check_b.length === "number" || $util.isString(message.check_b)))
            return "check_b: buffer expected";
        return null;
    };

    DeviceFactoryPermanentLock.fromObject = function fromObject(object) {
        if (object instanceof $root.DeviceFactoryPermanentLock)
            return object;
        var message = new $root.DeviceFactoryPermanentLock();
        if (object.check_a != null)
            if (typeof object.check_a === "string")
                $util.base64.decode(object.check_a, message.check_a = $util.newBuffer($util.base64.length(object.check_a)), 0);
            else if (object.check_a.length)
                message.check_a = object.check_a;
        if (object.check_b != null)
            if (typeof object.check_b === "string")
                $util.base64.decode(object.check_b, message.check_b = $util.newBuffer($util.base64.length(object.check_b)), 0);
            else if (object.check_b.length)
                message.check_b = object.check_b;
        return message;
    };

    DeviceFactoryPermanentLock.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.check_a = "";
            else {
                object.check_a = [];
                if (options.bytes !== Array)
                    object.check_a = $util.newBuffer(object.check_a);
            }
            if (options.bytes === String)
                object.check_b = "";
            else {
                object.check_b = [];
                if (options.bytes !== Array)
                    object.check_b = $util.newBuffer(object.check_b);
            }
        }
        if (message.check_a != null && message.hasOwnProperty("check_a"))
            object.check_a = options.bytes === String ? $util.base64.encode(message.check_a, 0, message.check_a.length) : options.bytes === Array ? Array.prototype.slice.call(message.check_a) : message.check_a;
        if (message.check_b != null && message.hasOwnProperty("check_b"))
            object.check_b = options.bytes === String ? $util.base64.encode(message.check_b, 0, message.check_b.length) : options.bytes === Array ? Array.prototype.slice.call(message.check_b) : message.check_b;
        return object;
    };

    DeviceFactoryPermanentLock.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DeviceFactoryPermanentLock;
})();

$root.DeviceFactoryTest = (function() {

    function DeviceFactoryTest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DeviceFactoryTest.prototype.burn_in_test = false;

    DeviceFactoryTest.create = function create(properties) {
        return new DeviceFactoryTest(properties);
    };

    DeviceFactoryTest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).bool(message.burn_in_test);
        return writer;
    };

    DeviceFactoryTest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DeviceFactoryTest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DeviceFactoryTest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.burn_in_test = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("burn_in_test"))
            throw $util.ProtocolError("missing required 'burn_in_test'", { instance: message });
        return message;
    };

    DeviceFactoryTest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DeviceFactoryTest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (typeof message.burn_in_test !== "boolean")
            return "burn_in_test: boolean expected";
        return null;
    };

    DeviceFactoryTest.fromObject = function fromObject(object) {
        if (object instanceof $root.DeviceFactoryTest)
            return object;
        var message = new $root.DeviceFactoryTest();
        if (object.burn_in_test != null)
            message.burn_in_test = Boolean(object.burn_in_test);
        return message;
    };

    DeviceFactoryTest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.burn_in_test = false;
        if (message.burn_in_test != null && message.hasOwnProperty("burn_in_test"))
            object.burn_in_test = message.burn_in_test;
        return object;
    };

    DeviceFactoryTest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DeviceFactoryTest;
})();

$root.DeviceFirmwareTargetType = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "FW_MGMT_TARGET_INVALID"] = 0;
    values[valuesById[1] = "FW_MGMT_TARGET_CRATE"] = 1;
    values[valuesById[2] = "FW_MGMT_TARGET_ROMLOADER"] = 2;
    values[valuesById[3] = "FW_MGMT_TARGET_BOOTLOADER"] = 3;
    values[valuesById[4] = "FW_MGMT_TARGET_APPLICATION_P1"] = 4;
    values[valuesById[5] = "FW_MGMT_TARGET_APPLICATION_P2"] = 5;
    values[valuesById[6] = "FW_MGMT_TARGET_COPROCESSOR"] = 6;
    values[valuesById[7] = "FW_MGMT_TARGET_SE01"] = 7;
    values[valuesById[8] = "FW_MGMT_TARGET_SE02"] = 8;
    values[valuesById[9] = "FW_MGMT_TARGET_SE03"] = 9;
    values[valuesById[10] = "FW_MGMT_TARGET_SE04"] = 10;
    return values;
})();

$root.DeviceFirmwareUpdateTaskStatus = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "FW_MGMT_UPDATER_TASK_STATUS_PENDING"] = 0;
    values[valuesById[1] = "FW_MGMT_UPDATER_TASK_STATUS_IN_PROGRESS"] = 1;
    values[valuesById[2] = "FW_MGMT_UPDATER_TASK_STATUS_FINISHED"] = 2;
    values[valuesById[3] = "FW_MGMT_UPDATER_TASK_STATUS_FAILED_FILE_NOT_FOUND"] = 3;
    values[valuesById[4] = "FW_MGMT_UPDATER_TASK_STATUS_FAILED_FILE_READ"] = 4;
    values[valuesById[5] = "FW_MGMT_UPDATER_TASK_STATUS_FAILED_FILE_WRITE"] = 5;
    values[valuesById[6] = "FW_MGMT_UPDATER_TASK_STATUS_FAILED_VERIFY"] = 6;
    values[valuesById[7] = "FW_MGMT_UPDATER_TASK_STATUS_FAILED_INSTALL"] = 7;
    values[valuesById[8] = "FW_MGMT_UPDATER_TASK_STATUS_FAILED_ABORT"] = 8;
    values[valuesById[9] = "FW_MGMT_UPDATER_TASK_STATUS_FAILED_BUSY"] = 9;
    values[valuesById[10] = "FW_MGMT_UPDATER_TASK_STATUS_FAILED_ENTRY_OUT_OF_BOUNDS"] = 10;
    return values;
})();

$root.DeviceFirmwareUpdatePhase = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "FW_MGMT_UPDATER_PHASE_PREPARE"] = 0;
    values[valuesById[1] = "FW_MGMT_UPDATER_PHASE_INSTALL"] = 1;
    values[valuesById[2] = "FW_MGMT_UPDATER_PHASE_VERIFY"] = 2;
    return values;
})();

$root.DeviceFirmwareTarget = (function() {

    function DeviceFirmwareTarget(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DeviceFirmwareTarget.prototype.target_id = 0;
    DeviceFirmwareTarget.prototype.path = "";

    DeviceFirmwareTarget.create = function create(properties) {
        return new DeviceFirmwareTarget(properties);
    };

    DeviceFirmwareTarget.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).int32(message.target_id);
        writer.uint32(18).string(message.path);
        return writer;
    };

    DeviceFirmwareTarget.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DeviceFirmwareTarget.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DeviceFirmwareTarget();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.target_id = reader.int32();
                break;
            case 2:
                message.path = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("target_id"))
            throw $util.ProtocolError("missing required 'target_id'", { instance: message });
        if (!message.hasOwnProperty("path"))
            throw $util.ProtocolError("missing required 'path'", { instance: message });
        return message;
    };

    DeviceFirmwareTarget.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DeviceFirmwareTarget.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        switch (message.target_id) {
        default:
            return "target_id: enum value expected";
        case 0:
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
        case 6:
        case 7:
        case 8:
        case 9:
        case 10:
            break;
        }
        if (!$util.isString(message.path))
            return "path: string expected";
        return null;
    };

    DeviceFirmwareTarget.fromObject = function fromObject(object) {
        if (object instanceof $root.DeviceFirmwareTarget)
            return object;
        var message = new $root.DeviceFirmwareTarget();
        switch (object.target_id) {
        case "FW_MGMT_TARGET_INVALID":
        case 0:
            message.target_id = 0;
            break;
        case "FW_MGMT_TARGET_CRATE":
        case 1:
            message.target_id = 1;
            break;
        case "FW_MGMT_TARGET_ROMLOADER":
        case 2:
            message.target_id = 2;
            break;
        case "FW_MGMT_TARGET_BOOTLOADER":
        case 3:
            message.target_id = 3;
            break;
        case "FW_MGMT_TARGET_APPLICATION_P1":
        case 4:
            message.target_id = 4;
            break;
        case "FW_MGMT_TARGET_APPLICATION_P2":
        case 5:
            message.target_id = 5;
            break;
        case "FW_MGMT_TARGET_COPROCESSOR":
        case 6:
            message.target_id = 6;
            break;
        case "FW_MGMT_TARGET_SE01":
        case 7:
            message.target_id = 7;
            break;
        case "FW_MGMT_TARGET_SE02":
        case 8:
            message.target_id = 8;
            break;
        case "FW_MGMT_TARGET_SE03":
        case 9:
            message.target_id = 9;
            break;
        case "FW_MGMT_TARGET_SE04":
        case 10:
            message.target_id = 10;
            break;
        }
        if (object.path != null)
            message.path = String(object.path);
        return message;
    };

    DeviceFirmwareTarget.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.target_id = options.enums === String ? "FW_MGMT_TARGET_INVALID" : 0;
            object.path = "";
        }
        if (message.target_id != null && message.hasOwnProperty("target_id"))
            object.target_id = options.enums === String ? $root.DeviceFirmwareTargetType[message.target_id] : message.target_id;
        if (message.path != null && message.hasOwnProperty("path"))
            object.path = message.path;
        return object;
    };

    DeviceFirmwareTarget.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DeviceFirmwareTarget;
})();

$root.DeviceFirmwareUpdateStage = (function() {

    function DeviceFirmwareUpdateStage(properties) {
        this.targets = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DeviceFirmwareUpdateStage.prototype.targets = $util.emptyArray;

    DeviceFirmwareUpdateStage.create = function create(properties) {
        return new DeviceFirmwareUpdateStage(properties);
    };

    DeviceFirmwareUpdateStage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.targets != null && message.targets.length)
            for (var i = 0; i < message.targets.length; ++i)
                $root.DeviceFirmwareTarget.encode(message.targets[i], writer.uint32(10).fork()).ldelim();
        return writer;
    };

    DeviceFirmwareUpdateStage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DeviceFirmwareUpdateStage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DeviceFirmwareUpdateStage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.targets && message.targets.length))
                    message.targets = [];
                message.targets.push($root.DeviceFirmwareTarget.decode(reader, reader.uint32()));
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    DeviceFirmwareUpdateStage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DeviceFirmwareUpdateStage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.targets != null && message.hasOwnProperty("targets")) {
            if (!Array.isArray(message.targets))
                return "targets: array expected";
            for (var i = 0; i < message.targets.length; ++i) {
                var error = $root.DeviceFirmwareTarget.verify(message.targets[i]);
                if (error)
                    return "targets." + error;
            }
        }
        return null;
    };

    DeviceFirmwareUpdateStage.fromObject = function fromObject(object) {
        if (object instanceof $root.DeviceFirmwareUpdateStage)
            return object;
        var message = new $root.DeviceFirmwareUpdateStage();
        if (object.targets) {
            if (!Array.isArray(object.targets))
                throw TypeError(".DeviceFirmwareUpdateStage.targets: array expected");
            message.targets = [];
            for (var i = 0; i < object.targets.length; ++i) {
                if (typeof object.targets[i] !== "object")
                    throw TypeError(".DeviceFirmwareUpdateStage.targets: object expected");
                message.targets[i] = $root.DeviceFirmwareTarget.fromObject(object.targets[i]);
            }
        }
        return message;
    };

    DeviceFirmwareUpdateStage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.targets = [];
        if (message.targets && message.targets.length) {
            object.targets = [];
            for (var j = 0; j < message.targets.length; ++j)
                object.targets[j] = $root.DeviceFirmwareTarget.toObject(message.targets[j], options);
        }
        return object;
    };

    DeviceFirmwareUpdateStage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DeviceFirmwareUpdateStage;
})();

$root.DeviceFirmwareUpdateRequest = (function() {

    function DeviceFirmwareUpdateRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DeviceFirmwareUpdateRequest.prototype.reboot_after_update = false;

    DeviceFirmwareUpdateRequest.create = function create(properties) {
        return new DeviceFirmwareUpdateRequest(properties);
    };

    DeviceFirmwareUpdateRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.reboot_after_update != null && Object.hasOwnProperty.call(message, "reboot_after_update"))
            writer.uint32(8).bool(message.reboot_after_update);
        return writer;
    };

    DeviceFirmwareUpdateRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DeviceFirmwareUpdateRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DeviceFirmwareUpdateRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.reboot_after_update = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    DeviceFirmwareUpdateRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DeviceFirmwareUpdateRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.reboot_after_update != null && message.hasOwnProperty("reboot_after_update"))
            if (typeof message.reboot_after_update !== "boolean")
                return "reboot_after_update: boolean expected";
        return null;
    };

    DeviceFirmwareUpdateRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.DeviceFirmwareUpdateRequest)
            return object;
        var message = new $root.DeviceFirmwareUpdateRequest();
        if (object.reboot_after_update != null)
            message.reboot_after_update = Boolean(object.reboot_after_update);
        return message;
    };

    DeviceFirmwareUpdateRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.reboot_after_update = false;
        if (message.reboot_after_update != null && message.hasOwnProperty("reboot_after_update"))
            object.reboot_after_update = message.reboot_after_update;
        return object;
    };

    DeviceFirmwareUpdateRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DeviceFirmwareUpdateRequest;
})();

$root.DeviceFirmwareUpdatePhaseInfo = (function() {

    function DeviceFirmwareUpdatePhaseInfo(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DeviceFirmwareUpdatePhaseInfo.prototype.phase = 0;
    DeviceFirmwareUpdatePhaseInfo.prototype.progress_percent = 0;

    DeviceFirmwareUpdatePhaseInfo.create = function create(properties) {
        return new DeviceFirmwareUpdatePhaseInfo(properties);
    };

    DeviceFirmwareUpdatePhaseInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).int32(message.phase);
        writer.uint32(16).uint32(message.progress_percent);
        return writer;
    };

    DeviceFirmwareUpdatePhaseInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DeviceFirmwareUpdatePhaseInfo.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DeviceFirmwareUpdatePhaseInfo();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.phase = reader.int32();
                break;
            case 2:
                message.progress_percent = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("phase"))
            throw $util.ProtocolError("missing required 'phase'", { instance: message });
        if (!message.hasOwnProperty("progress_percent"))
            throw $util.ProtocolError("missing required 'progress_percent'", { instance: message });
        return message;
    };

    DeviceFirmwareUpdatePhaseInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DeviceFirmwareUpdatePhaseInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        switch (message.phase) {
        default:
            return "phase: enum value expected";
        case 0:
        case 1:
        case 2:
            break;
        }
        if (!$util.isInteger(message.progress_percent))
            return "progress_percent: integer expected";
        return null;
    };

    DeviceFirmwareUpdatePhaseInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.DeviceFirmwareUpdatePhaseInfo)
            return object;
        var message = new $root.DeviceFirmwareUpdatePhaseInfo();
        switch (object.phase) {
        case "FW_MGMT_UPDATER_PHASE_PREPARE":
        case 0:
            message.phase = 0;
            break;
        case "FW_MGMT_UPDATER_PHASE_INSTALL":
        case 1:
            message.phase = 1;
            break;
        case "FW_MGMT_UPDATER_PHASE_VERIFY":
        case 2:
            message.phase = 2;
            break;
        }
        if (object.progress_percent != null)
            message.progress_percent = object.progress_percent >>> 0;
        return message;
    };

    DeviceFirmwareUpdatePhaseInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.phase = options.enums === String ? "FW_MGMT_UPDATER_PHASE_PREPARE" : 0;
            object.progress_percent = 0;
        }
        if (message.phase != null && message.hasOwnProperty("phase"))
            object.phase = options.enums === String ? $root.DeviceFirmwareUpdatePhase[message.phase] : message.phase;
        if (message.progress_percent != null && message.hasOwnProperty("progress_percent"))
            object.progress_percent = message.progress_percent;
        return object;
    };

    DeviceFirmwareUpdatePhaseInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DeviceFirmwareUpdatePhaseInfo;
})();

$root.DeviceFirmwareUpdateRecord = (function() {

    function DeviceFirmwareUpdateRecord(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DeviceFirmwareUpdateRecord.prototype.target_id = 0;
    DeviceFirmwareUpdateRecord.prototype.status = 0;
    DeviceFirmwareUpdateRecord.prototype.progress_percent = 0;
    DeviceFirmwareUpdateRecord.prototype.phase_info = null;
    DeviceFirmwareUpdateRecord.prototype.payload_version = 0;
    DeviceFirmwareUpdateRecord.prototype.path = "";

    DeviceFirmwareUpdateRecord.create = function create(properties) {
        return new DeviceFirmwareUpdateRecord(properties);
    };

    DeviceFirmwareUpdateRecord.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).int32(message.target_id);
        if (message.status != null && Object.hasOwnProperty.call(message, "status"))
            writer.uint32(80).int32(message.status);
        if (message.progress_percent != null && Object.hasOwnProperty.call(message, "progress_percent"))
            writer.uint32(88).uint32(message.progress_percent);
        if (message.phase_info != null && Object.hasOwnProperty.call(message, "phase_info"))
            $root.DeviceFirmwareUpdatePhaseInfo.encode(message.phase_info, writer.uint32(98).fork()).ldelim();
        if (message.payload_version != null && Object.hasOwnProperty.call(message, "payload_version"))
            writer.uint32(160).uint32(message.payload_version);
        if (message.path != null && Object.hasOwnProperty.call(message, "path"))
            writer.uint32(242).string(message.path);
        return writer;
    };

    DeviceFirmwareUpdateRecord.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DeviceFirmwareUpdateRecord.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DeviceFirmwareUpdateRecord();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.target_id = reader.int32();
                break;
            case 10:
                message.status = reader.int32();
                break;
            case 11:
                message.progress_percent = reader.uint32();
                break;
            case 12:
                message.phase_info = $root.DeviceFirmwareUpdatePhaseInfo.decode(reader, reader.uint32());
                break;
            case 20:
                message.payload_version = reader.uint32();
                break;
            case 30:
                message.path = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("target_id"))
            throw $util.ProtocolError("missing required 'target_id'", { instance: message });
        return message;
    };

    DeviceFirmwareUpdateRecord.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DeviceFirmwareUpdateRecord.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        switch (message.target_id) {
        default:
            return "target_id: enum value expected";
        case 0:
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
        case 6:
        case 7:
        case 8:
        case 9:
        case 10:
            break;
        }
        if (message.status != null && message.hasOwnProperty("status"))
            switch (message.status) {
            default:
                return "status: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
            case 8:
            case 9:
            case 10:
                break;
            }
        if (message.progress_percent != null && message.hasOwnProperty("progress_percent"))
            if (!$util.isInteger(message.progress_percent))
                return "progress_percent: integer expected";
        if (message.phase_info != null && message.hasOwnProperty("phase_info")) {
            var error = $root.DeviceFirmwareUpdatePhaseInfo.verify(message.phase_info);
            if (error)
                return "phase_info." + error;
        }
        if (message.payload_version != null && message.hasOwnProperty("payload_version"))
            if (!$util.isInteger(message.payload_version))
                return "payload_version: integer expected";
        if (message.path != null && message.hasOwnProperty("path"))
            if (!$util.isString(message.path))
                return "path: string expected";
        return null;
    };

    DeviceFirmwareUpdateRecord.fromObject = function fromObject(object) {
        if (object instanceof $root.DeviceFirmwareUpdateRecord)
            return object;
        var message = new $root.DeviceFirmwareUpdateRecord();
        switch (object.target_id) {
        case "FW_MGMT_TARGET_INVALID":
        case 0:
            message.target_id = 0;
            break;
        case "FW_MGMT_TARGET_CRATE":
        case 1:
            message.target_id = 1;
            break;
        case "FW_MGMT_TARGET_ROMLOADER":
        case 2:
            message.target_id = 2;
            break;
        case "FW_MGMT_TARGET_BOOTLOADER":
        case 3:
            message.target_id = 3;
            break;
        case "FW_MGMT_TARGET_APPLICATION_P1":
        case 4:
            message.target_id = 4;
            break;
        case "FW_MGMT_TARGET_APPLICATION_P2":
        case 5:
            message.target_id = 5;
            break;
        case "FW_MGMT_TARGET_COPROCESSOR":
        case 6:
            message.target_id = 6;
            break;
        case "FW_MGMT_TARGET_SE01":
        case 7:
            message.target_id = 7;
            break;
        case "FW_MGMT_TARGET_SE02":
        case 8:
            message.target_id = 8;
            break;
        case "FW_MGMT_TARGET_SE03":
        case 9:
            message.target_id = 9;
            break;
        case "FW_MGMT_TARGET_SE04":
        case 10:
            message.target_id = 10;
            break;
        }
        switch (object.status) {
        case "FW_MGMT_UPDATER_TASK_STATUS_PENDING":
        case 0:
            message.status = 0;
            break;
        case "FW_MGMT_UPDATER_TASK_STATUS_IN_PROGRESS":
        case 1:
            message.status = 1;
            break;
        case "FW_MGMT_UPDATER_TASK_STATUS_FINISHED":
        case 2:
            message.status = 2;
            break;
        case "FW_MGMT_UPDATER_TASK_STATUS_FAILED_FILE_NOT_FOUND":
        case 3:
            message.status = 3;
            break;
        case "FW_MGMT_UPDATER_TASK_STATUS_FAILED_FILE_READ":
        case 4:
            message.status = 4;
            break;
        case "FW_MGMT_UPDATER_TASK_STATUS_FAILED_FILE_WRITE":
        case 5:
            message.status = 5;
            break;
        case "FW_MGMT_UPDATER_TASK_STATUS_FAILED_VERIFY":
        case 6:
            message.status = 6;
            break;
        case "FW_MGMT_UPDATER_TASK_STATUS_FAILED_INSTALL":
        case 7:
            message.status = 7;
            break;
        case "FW_MGMT_UPDATER_TASK_STATUS_FAILED_ABORT":
        case 8:
            message.status = 8;
            break;
        case "FW_MGMT_UPDATER_TASK_STATUS_FAILED_BUSY":
        case 9:
            message.status = 9;
            break;
        case "FW_MGMT_UPDATER_TASK_STATUS_FAILED_ENTRY_OUT_OF_BOUNDS":
        case 10:
            message.status = 10;
            break;
        }
        if (object.progress_percent != null)
            message.progress_percent = object.progress_percent >>> 0;
        if (object.phase_info != null) {
            if (typeof object.phase_info !== "object")
                throw TypeError(".DeviceFirmwareUpdateRecord.phase_info: object expected");
            message.phase_info = $root.DeviceFirmwareUpdatePhaseInfo.fromObject(object.phase_info);
        }
        if (object.payload_version != null)
            message.payload_version = object.payload_version >>> 0;
        if (object.path != null)
            message.path = String(object.path);
        return message;
    };

    DeviceFirmwareUpdateRecord.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.target_id = options.enums === String ? "FW_MGMT_TARGET_INVALID" : 0;
            object.status = options.enums === String ? "FW_MGMT_UPDATER_TASK_STATUS_PENDING" : 0;
            object.progress_percent = 0;
            object.phase_info = null;
            object.payload_version = 0;
            object.path = "";
        }
        if (message.target_id != null && message.hasOwnProperty("target_id"))
            object.target_id = options.enums === String ? $root.DeviceFirmwareTargetType[message.target_id] : message.target_id;
        if (message.status != null && message.hasOwnProperty("status"))
            object.status = options.enums === String ? $root.DeviceFirmwareUpdateTaskStatus[message.status] : message.status;
        if (message.progress_percent != null && message.hasOwnProperty("progress_percent"))
            object.progress_percent = message.progress_percent;
        if (message.phase_info != null && message.hasOwnProperty("phase_info"))
            object.phase_info = $root.DeviceFirmwareUpdatePhaseInfo.toObject(message.phase_info, options);
        if (message.payload_version != null && message.hasOwnProperty("payload_version"))
            object.payload_version = message.payload_version;
        if (message.path != null && message.hasOwnProperty("path"))
            object.path = message.path;
        return object;
    };

    DeviceFirmwareUpdateRecord.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DeviceFirmwareUpdateRecord;
})();

$root.DeviceFirmwareUpdateRecordFields = (function() {

    function DeviceFirmwareUpdateRecordFields(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DeviceFirmwareUpdateRecordFields.prototype.status = false;
    DeviceFirmwareUpdateRecordFields.prototype.progress_percent = false;
    DeviceFirmwareUpdateRecordFields.prototype.phase_info = false;
    DeviceFirmwareUpdateRecordFields.prototype.payload_version = false;
    DeviceFirmwareUpdateRecordFields.prototype.path = false;

    DeviceFirmwareUpdateRecordFields.create = function create(properties) {
        return new DeviceFirmwareUpdateRecordFields(properties);
    };

    DeviceFirmwareUpdateRecordFields.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.status != null && Object.hasOwnProperty.call(message, "status"))
            writer.uint32(80).bool(message.status);
        if (message.progress_percent != null && Object.hasOwnProperty.call(message, "progress_percent"))
            writer.uint32(88).bool(message.progress_percent);
        if (message.phase_info != null && Object.hasOwnProperty.call(message, "phase_info"))
            writer.uint32(96).bool(message.phase_info);
        if (message.payload_version != null && Object.hasOwnProperty.call(message, "payload_version"))
            writer.uint32(160).bool(message.payload_version);
        if (message.path != null && Object.hasOwnProperty.call(message, "path"))
            writer.uint32(240).bool(message.path);
        return writer;
    };

    DeviceFirmwareUpdateRecordFields.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DeviceFirmwareUpdateRecordFields.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DeviceFirmwareUpdateRecordFields();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 10:
                message.status = reader.bool();
                break;
            case 11:
                message.progress_percent = reader.bool();
                break;
            case 12:
                message.phase_info = reader.bool();
                break;
            case 20:
                message.payload_version = reader.bool();
                break;
            case 30:
                message.path = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    DeviceFirmwareUpdateRecordFields.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DeviceFirmwareUpdateRecordFields.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.status != null && message.hasOwnProperty("status"))
            if (typeof message.status !== "boolean")
                return "status: boolean expected";
        if (message.progress_percent != null && message.hasOwnProperty("progress_percent"))
            if (typeof message.progress_percent !== "boolean")
                return "progress_percent: boolean expected";
        if (message.phase_info != null && message.hasOwnProperty("phase_info"))
            if (typeof message.phase_info !== "boolean")
                return "phase_info: boolean expected";
        if (message.payload_version != null && message.hasOwnProperty("payload_version"))
            if (typeof message.payload_version !== "boolean")
                return "payload_version: boolean expected";
        if (message.path != null && message.hasOwnProperty("path"))
            if (typeof message.path !== "boolean")
                return "path: boolean expected";
        return null;
    };

    DeviceFirmwareUpdateRecordFields.fromObject = function fromObject(object) {
        if (object instanceof $root.DeviceFirmwareUpdateRecordFields)
            return object;
        var message = new $root.DeviceFirmwareUpdateRecordFields();
        if (object.status != null)
            message.status = Boolean(object.status);
        if (object.progress_percent != null)
            message.progress_percent = Boolean(object.progress_percent);
        if (object.phase_info != null)
            message.phase_info = Boolean(object.phase_info);
        if (object.payload_version != null)
            message.payload_version = Boolean(object.payload_version);
        if (object.path != null)
            message.path = Boolean(object.path);
        return message;
    };

    DeviceFirmwareUpdateRecordFields.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.status = false;
            object.progress_percent = false;
            object.phase_info = false;
            object.payload_version = false;
            object.path = false;
        }
        if (message.status != null && message.hasOwnProperty("status"))
            object.status = message.status;
        if (message.progress_percent != null && message.hasOwnProperty("progress_percent"))
            object.progress_percent = message.progress_percent;
        if (message.phase_info != null && message.hasOwnProperty("phase_info"))
            object.phase_info = message.phase_info;
        if (message.payload_version != null && message.hasOwnProperty("payload_version"))
            object.payload_version = message.payload_version;
        if (message.path != null && message.hasOwnProperty("path"))
            object.path = message.path;
        return object;
    };

    DeviceFirmwareUpdateRecordFields.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DeviceFirmwareUpdateRecordFields;
})();

$root.DeviceFirmwareUpdateStatusGet = (function() {

    function DeviceFirmwareUpdateStatusGet(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DeviceFirmwareUpdateStatusGet.prototype.fields = null;

    DeviceFirmwareUpdateStatusGet.create = function create(properties) {
        return new DeviceFirmwareUpdateStatusGet(properties);
    };

    DeviceFirmwareUpdateStatusGet.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.fields != null && Object.hasOwnProperty.call(message, "fields"))
            $root.DeviceFirmwareUpdateRecordFields.encode(message.fields, writer.uint32(10).fork()).ldelim();
        return writer;
    };

    DeviceFirmwareUpdateStatusGet.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DeviceFirmwareUpdateStatusGet.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DeviceFirmwareUpdateStatusGet();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.fields = $root.DeviceFirmwareUpdateRecordFields.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    DeviceFirmwareUpdateStatusGet.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DeviceFirmwareUpdateStatusGet.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.fields != null && message.hasOwnProperty("fields")) {
            var error = $root.DeviceFirmwareUpdateRecordFields.verify(message.fields);
            if (error)
                return "fields." + error;
        }
        return null;
    };

    DeviceFirmwareUpdateStatusGet.fromObject = function fromObject(object) {
        if (object instanceof $root.DeviceFirmwareUpdateStatusGet)
            return object;
        var message = new $root.DeviceFirmwareUpdateStatusGet();
        if (object.fields != null) {
            if (typeof object.fields !== "object")
                throw TypeError(".DeviceFirmwareUpdateStatusGet.fields: object expected");
            message.fields = $root.DeviceFirmwareUpdateRecordFields.fromObject(object.fields);
        }
        return message;
    };

    DeviceFirmwareUpdateStatusGet.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.fields = null;
        if (message.fields != null && message.hasOwnProperty("fields"))
            object.fields = $root.DeviceFirmwareUpdateRecordFields.toObject(message.fields, options);
        return object;
    };

    DeviceFirmwareUpdateStatusGet.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DeviceFirmwareUpdateStatusGet;
})();

$root.DeviceFirmwareUpdateStatus = (function() {

    function DeviceFirmwareUpdateStatus(properties) {
        this.records = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DeviceFirmwareUpdateStatus.prototype.records = $util.emptyArray;

    DeviceFirmwareUpdateStatus.create = function create(properties) {
        return new DeviceFirmwareUpdateStatus(properties);
    };

    DeviceFirmwareUpdateStatus.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.records != null && message.records.length)
            for (var i = 0; i < message.records.length; ++i)
                $root.DeviceFirmwareUpdateRecord.encode(message.records[i], writer.uint32(10).fork()).ldelim();
        return writer;
    };

    DeviceFirmwareUpdateStatus.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DeviceFirmwareUpdateStatus.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DeviceFirmwareUpdateStatus();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.records && message.records.length))
                    message.records = [];
                message.records.push($root.DeviceFirmwareUpdateRecord.decode(reader, reader.uint32()));
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    DeviceFirmwareUpdateStatus.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DeviceFirmwareUpdateStatus.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.records != null && message.hasOwnProperty("records")) {
            if (!Array.isArray(message.records))
                return "records: array expected";
            for (var i = 0; i < message.records.length; ++i) {
                var error = $root.DeviceFirmwareUpdateRecord.verify(message.records[i]);
                if (error)
                    return "records." + error;
            }
        }
        return null;
    };

    DeviceFirmwareUpdateStatus.fromObject = function fromObject(object) {
        if (object instanceof $root.DeviceFirmwareUpdateStatus)
            return object;
        var message = new $root.DeviceFirmwareUpdateStatus();
        if (object.records) {
            if (!Array.isArray(object.records))
                throw TypeError(".DeviceFirmwareUpdateStatus.records: array expected");
            message.records = [];
            for (var i = 0; i < object.records.length; ++i) {
                if (typeof object.records[i] !== "object")
                    throw TypeError(".DeviceFirmwareUpdateStatus.records: object expected");
                message.records[i] = $root.DeviceFirmwareUpdateRecord.fromObject(object.records[i]);
            }
        }
        return message;
    };

    DeviceFirmwareUpdateStatus.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.records = [];
        if (message.records && message.records.length) {
            object.records = [];
            for (var j = 0; j < message.records.length; ++j)
                object.records[j] = $root.DeviceFirmwareUpdateRecord.toObject(message.records[j], options);
        }
        return object;
    };

    DeviceFirmwareUpdateStatus.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DeviceFirmwareUpdateStatus;
})();

$root.DeviceType = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "CLASSIC1"] = 0;
    values[valuesById[1] = "CLASSIC1S"] = 1;
    values[valuesById[2] = "MINI"] = 2;
    values[valuesById[3] = "TOUCH"] = 3;
    values[valuesById[5] = "PRO"] = 5;
    values[valuesById[6] = "CLASSIC1S_PURE"] = 6;
    values[valuesById[7] = "PRO2"] = 7;
    values[valuesById[8] = "NEO"] = 8;
    return values;
})();

$root.DeviceSeType = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "THD89"] = 0;
    values[valuesById[1] = "SE608A"] = 1;
    return values;
})();

$root.DeviceSEState = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "BOOT"] = 0;
    values[valuesById[51] = "APP_FACTORY"] = 51;
    values[valuesById[85] = "APP"] = 85;
    return values;
})();

$root.DeviceFirmwareImageInfo = (function() {

    function DeviceFirmwareImageInfo(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DeviceFirmwareImageInfo.prototype.version = "";
    DeviceFirmwareImageInfo.prototype.build_id = "";
    DeviceFirmwareImageInfo.prototype.hash = $util.newBuffer([]);

    DeviceFirmwareImageInfo.create = function create(properties) {
        return new DeviceFirmwareImageInfo(properties);
    };

    DeviceFirmwareImageInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.version != null && Object.hasOwnProperty.call(message, "version"))
            writer.uint32(82).string(message.version);
        if (message.build_id != null && Object.hasOwnProperty.call(message, "build_id"))
            writer.uint32(162).string(message.build_id);
        if (message.hash != null && Object.hasOwnProperty.call(message, "hash"))
            writer.uint32(242).bytes(message.hash);
        return writer;
    };

    DeviceFirmwareImageInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DeviceFirmwareImageInfo.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DeviceFirmwareImageInfo();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 10:
                message.version = reader.string();
                break;
            case 20:
                message.build_id = reader.string();
                break;
            case 30:
                message.hash = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    DeviceFirmwareImageInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DeviceFirmwareImageInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.version != null && message.hasOwnProperty("version"))
            if (!$util.isString(message.version))
                return "version: string expected";
        if (message.build_id != null && message.hasOwnProperty("build_id"))
            if (!$util.isString(message.build_id))
                return "build_id: string expected";
        if (message.hash != null && message.hasOwnProperty("hash"))
            if (!(message.hash && typeof message.hash.length === "number" || $util.isString(message.hash)))
                return "hash: buffer expected";
        return null;
    };

    DeviceFirmwareImageInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.DeviceFirmwareImageInfo)
            return object;
        var message = new $root.DeviceFirmwareImageInfo();
        if (object.version != null)
            message.version = String(object.version);
        if (object.build_id != null)
            message.build_id = String(object.build_id);
        if (object.hash != null)
            if (typeof object.hash === "string")
                $util.base64.decode(object.hash, message.hash = $util.newBuffer($util.base64.length(object.hash)), 0);
            else if (object.hash.length)
                message.hash = object.hash;
        return message;
    };

    DeviceFirmwareImageInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.version = "";
            object.build_id = "";
            if (options.bytes === String)
                object.hash = "";
            else {
                object.hash = [];
                if (options.bytes !== Array)
                    object.hash = $util.newBuffer(object.hash);
            }
        }
        if (message.version != null && message.hasOwnProperty("version"))
            object.version = message.version;
        if (message.build_id != null && message.hasOwnProperty("build_id"))
            object.build_id = message.build_id;
        if (message.hash != null && message.hasOwnProperty("hash"))
            object.hash = options.bytes === String ? $util.base64.encode(message.hash, 0, message.hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.hash) : message.hash;
        return object;
    };

    DeviceFirmwareImageInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DeviceFirmwareImageInfo;
})();

$root.DeviceHardwareInfo = (function() {

    function DeviceHardwareInfo(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DeviceHardwareInfo.prototype.Device_type = 0;
    DeviceHardwareInfo.prototype.serial_no = "";
    DeviceHardwareInfo.prototype.hardware_version = "";
    DeviceHardwareInfo.prototype.hardware_version_raw_adc = 0;

    DeviceHardwareInfo.create = function create(properties) {
        return new DeviceHardwareInfo(properties);
    };

    DeviceHardwareInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Device_type != null && Object.hasOwnProperty.call(message, "Device_type"))
            writer.uint32(80).int32(message.Device_type);
        if (message.serial_no != null && Object.hasOwnProperty.call(message, "serial_no"))
            writer.uint32(162).string(message.serial_no);
        if (message.hardware_version != null && Object.hasOwnProperty.call(message, "hardware_version"))
            writer.uint32(802).string(message.hardware_version);
        if (message.hardware_version_raw_adc != null && Object.hasOwnProperty.call(message, "hardware_version_raw_adc"))
            writer.uint32(880).uint32(message.hardware_version_raw_adc);
        return writer;
    };

    DeviceHardwareInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DeviceHardwareInfo.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DeviceHardwareInfo();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 10:
                message.Device_type = reader.int32();
                break;
            case 20:
                message.serial_no = reader.string();
                break;
            case 100:
                message.hardware_version = reader.string();
                break;
            case 110:
                message.hardware_version_raw_adc = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    DeviceHardwareInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DeviceHardwareInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Device_type != null && message.hasOwnProperty("Device_type"))
            switch (message.Device_type) {
            default:
                return "Device_type: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 5:
            case 6:
            case 7:
            case 8:
                break;
            }
        if (message.serial_no != null && message.hasOwnProperty("serial_no"))
            if (!$util.isString(message.serial_no))
                return "serial_no: string expected";
        if (message.hardware_version != null && message.hasOwnProperty("hardware_version"))
            if (!$util.isString(message.hardware_version))
                return "hardware_version: string expected";
        if (message.hardware_version_raw_adc != null && message.hasOwnProperty("hardware_version_raw_adc"))
            if (!$util.isInteger(message.hardware_version_raw_adc))
                return "hardware_version_raw_adc: integer expected";
        return null;
    };

    DeviceHardwareInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.DeviceHardwareInfo)
            return object;
        var message = new $root.DeviceHardwareInfo();
        switch (object.Device_type) {
        case "CLASSIC1":
        case 0:
            message.Device_type = 0;
            break;
        case "CLASSIC1S":
        case 1:
            message.Device_type = 1;
            break;
        case "MINI":
        case 2:
            message.Device_type = 2;
            break;
        case "TOUCH":
        case 3:
            message.Device_type = 3;
            break;
        case "PRO":
        case 5:
            message.Device_type = 5;
            break;
        case "CLASSIC1S_PURE":
        case 6:
            message.Device_type = 6;
            break;
        case "PRO2":
        case 7:
            message.Device_type = 7;
            break;
        case "NEO":
        case 8:
            message.Device_type = 8;
            break;
        }
        if (object.serial_no != null)
            message.serial_no = String(object.serial_no);
        if (object.hardware_version != null)
            message.hardware_version = String(object.hardware_version);
        if (object.hardware_version_raw_adc != null)
            message.hardware_version_raw_adc = object.hardware_version_raw_adc >>> 0;
        return message;
    };

    DeviceHardwareInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.Device_type = options.enums === String ? "CLASSIC1" : 0;
            object.serial_no = "";
            object.hardware_version = "";
            object.hardware_version_raw_adc = 0;
        }
        if (message.Device_type != null && message.hasOwnProperty("Device_type"))
            object.Device_type = options.enums === String ? $root.DeviceType[message.Device_type] : message.Device_type;
        if (message.serial_no != null && message.hasOwnProperty("serial_no"))
            object.serial_no = message.serial_no;
        if (message.hardware_version != null && message.hasOwnProperty("hardware_version"))
            object.hardware_version = message.hardware_version;
        if (message.hardware_version_raw_adc != null && message.hasOwnProperty("hardware_version_raw_adc"))
            object.hardware_version_raw_adc = message.hardware_version_raw_adc;
        return object;
    };

    DeviceHardwareInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DeviceHardwareInfo;
})();

$root.DeviceMainMcuInfo = (function() {

    function DeviceMainMcuInfo(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DeviceMainMcuInfo.prototype.romloader = null;
    DeviceMainMcuInfo.prototype.bootloader = null;
    DeviceMainMcuInfo.prototype.application = null;
    DeviceMainMcuInfo.prototype.application_data = null;

    DeviceMainMcuInfo.create = function create(properties) {
        return new DeviceMainMcuInfo(properties);
    };

    DeviceMainMcuInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.romloader != null && Object.hasOwnProperty.call(message, "romloader"))
            $root.DeviceFirmwareImageInfo.encode(message.romloader, writer.uint32(82).fork()).ldelim();
        if (message.bootloader != null && Object.hasOwnProperty.call(message, "bootloader"))
            $root.DeviceFirmwareImageInfo.encode(message.bootloader, writer.uint32(162).fork()).ldelim();
        if (message.application != null && Object.hasOwnProperty.call(message, "application"))
            $root.DeviceFirmwareImageInfo.encode(message.application, writer.uint32(242).fork()).ldelim();
        if (message.application_data != null && Object.hasOwnProperty.call(message, "application_data"))
            $root.DeviceFirmwareImageInfo.encode(message.application_data, writer.uint32(322).fork()).ldelim();
        return writer;
    };

    DeviceMainMcuInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DeviceMainMcuInfo.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DeviceMainMcuInfo();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 10:
                message.romloader = $root.DeviceFirmwareImageInfo.decode(reader, reader.uint32());
                break;
            case 20:
                message.bootloader = $root.DeviceFirmwareImageInfo.decode(reader, reader.uint32());
                break;
            case 30:
                message.application = $root.DeviceFirmwareImageInfo.decode(reader, reader.uint32());
                break;
            case 40:
                message.application_data = $root.DeviceFirmwareImageInfo.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    DeviceMainMcuInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DeviceMainMcuInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.romloader != null && message.hasOwnProperty("romloader")) {
            var error = $root.DeviceFirmwareImageInfo.verify(message.romloader);
            if (error)
                return "romloader." + error;
        }
        if (message.bootloader != null && message.hasOwnProperty("bootloader")) {
            var error = $root.DeviceFirmwareImageInfo.verify(message.bootloader);
            if (error)
                return "bootloader." + error;
        }
        if (message.application != null && message.hasOwnProperty("application")) {
            var error = $root.DeviceFirmwareImageInfo.verify(message.application);
            if (error)
                return "application." + error;
        }
        if (message.application_data != null && message.hasOwnProperty("application_data")) {
            var error = $root.DeviceFirmwareImageInfo.verify(message.application_data);
            if (error)
                return "application_data." + error;
        }
        return null;
    };

    DeviceMainMcuInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.DeviceMainMcuInfo)
            return object;
        var message = new $root.DeviceMainMcuInfo();
        if (object.romloader != null) {
            if (typeof object.romloader !== "object")
                throw TypeError(".DeviceMainMcuInfo.romloader: object expected");
            message.romloader = $root.DeviceFirmwareImageInfo.fromObject(object.romloader);
        }
        if (object.bootloader != null) {
            if (typeof object.bootloader !== "object")
                throw TypeError(".DeviceMainMcuInfo.bootloader: object expected");
            message.bootloader = $root.DeviceFirmwareImageInfo.fromObject(object.bootloader);
        }
        if (object.application != null) {
            if (typeof object.application !== "object")
                throw TypeError(".DeviceMainMcuInfo.application: object expected");
            message.application = $root.DeviceFirmwareImageInfo.fromObject(object.application);
        }
        if (object.application_data != null) {
            if (typeof object.application_data !== "object")
                throw TypeError(".DeviceMainMcuInfo.application_data: object expected");
            message.application_data = $root.DeviceFirmwareImageInfo.fromObject(object.application_data);
        }
        return message;
    };

    DeviceMainMcuInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.romloader = null;
            object.bootloader = null;
            object.application = null;
            object.application_data = null;
        }
        if (message.romloader != null && message.hasOwnProperty("romloader"))
            object.romloader = $root.DeviceFirmwareImageInfo.toObject(message.romloader, options);
        if (message.bootloader != null && message.hasOwnProperty("bootloader"))
            object.bootloader = $root.DeviceFirmwareImageInfo.toObject(message.bootloader, options);
        if (message.application != null && message.hasOwnProperty("application"))
            object.application = $root.DeviceFirmwareImageInfo.toObject(message.application, options);
        if (message.application_data != null && message.hasOwnProperty("application_data"))
            object.application_data = $root.DeviceFirmwareImageInfo.toObject(message.application_data, options);
        return object;
    };

    DeviceMainMcuInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DeviceMainMcuInfo;
})();

$root.DeviceCoprocessorInfo = (function() {

    function DeviceCoprocessorInfo(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DeviceCoprocessorInfo.prototype.bootloader = null;
    DeviceCoprocessorInfo.prototype.application = null;
    DeviceCoprocessorInfo.prototype.bt_adv_name = "";
    DeviceCoprocessorInfo.prototype.bt_mac = $util.newBuffer([]);

    DeviceCoprocessorInfo.create = function create(properties) {
        return new DeviceCoprocessorInfo(properties);
    };

    DeviceCoprocessorInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.bootloader != null && Object.hasOwnProperty.call(message, "bootloader"))
            $root.DeviceFirmwareImageInfo.encode(message.bootloader, writer.uint32(162).fork()).ldelim();
        if (message.application != null && Object.hasOwnProperty.call(message, "application"))
            $root.DeviceFirmwareImageInfo.encode(message.application, writer.uint32(242).fork()).ldelim();
        if (message.bt_adv_name != null && Object.hasOwnProperty.call(message, "bt_adv_name"))
            writer.uint32(802).string(message.bt_adv_name);
        if (message.bt_mac != null && Object.hasOwnProperty.call(message, "bt_mac"))
            writer.uint32(882).bytes(message.bt_mac);
        return writer;
    };

    DeviceCoprocessorInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DeviceCoprocessorInfo.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DeviceCoprocessorInfo();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 20:
                message.bootloader = $root.DeviceFirmwareImageInfo.decode(reader, reader.uint32());
                break;
            case 30:
                message.application = $root.DeviceFirmwareImageInfo.decode(reader, reader.uint32());
                break;
            case 100:
                message.bt_adv_name = reader.string();
                break;
            case 110:
                message.bt_mac = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    DeviceCoprocessorInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DeviceCoprocessorInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.bootloader != null && message.hasOwnProperty("bootloader")) {
            var error = $root.DeviceFirmwareImageInfo.verify(message.bootloader);
            if (error)
                return "bootloader." + error;
        }
        if (message.application != null && message.hasOwnProperty("application")) {
            var error = $root.DeviceFirmwareImageInfo.verify(message.application);
            if (error)
                return "application." + error;
        }
        if (message.bt_adv_name != null && message.hasOwnProperty("bt_adv_name"))
            if (!$util.isString(message.bt_adv_name))
                return "bt_adv_name: string expected";
        if (message.bt_mac != null && message.hasOwnProperty("bt_mac"))
            if (!(message.bt_mac && typeof message.bt_mac.length === "number" || $util.isString(message.bt_mac)))
                return "bt_mac: buffer expected";
        return null;
    };

    DeviceCoprocessorInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.DeviceCoprocessorInfo)
            return object;
        var message = new $root.DeviceCoprocessorInfo();
        if (object.bootloader != null) {
            if (typeof object.bootloader !== "object")
                throw TypeError(".DeviceCoprocessorInfo.bootloader: object expected");
            message.bootloader = $root.DeviceFirmwareImageInfo.fromObject(object.bootloader);
        }
        if (object.application != null) {
            if (typeof object.application !== "object")
                throw TypeError(".DeviceCoprocessorInfo.application: object expected");
            message.application = $root.DeviceFirmwareImageInfo.fromObject(object.application);
        }
        if (object.bt_adv_name != null)
            message.bt_adv_name = String(object.bt_adv_name);
        if (object.bt_mac != null)
            if (typeof object.bt_mac === "string")
                $util.base64.decode(object.bt_mac, message.bt_mac = $util.newBuffer($util.base64.length(object.bt_mac)), 0);
            else if (object.bt_mac.length)
                message.bt_mac = object.bt_mac;
        return message;
    };

    DeviceCoprocessorInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.bootloader = null;
            object.application = null;
            object.bt_adv_name = "";
            if (options.bytes === String)
                object.bt_mac = "";
            else {
                object.bt_mac = [];
                if (options.bytes !== Array)
                    object.bt_mac = $util.newBuffer(object.bt_mac);
            }
        }
        if (message.bootloader != null && message.hasOwnProperty("bootloader"))
            object.bootloader = $root.DeviceFirmwareImageInfo.toObject(message.bootloader, options);
        if (message.application != null && message.hasOwnProperty("application"))
            object.application = $root.DeviceFirmwareImageInfo.toObject(message.application, options);
        if (message.bt_adv_name != null && message.hasOwnProperty("bt_adv_name"))
            object.bt_adv_name = message.bt_adv_name;
        if (message.bt_mac != null && message.hasOwnProperty("bt_mac"))
            object.bt_mac = options.bytes === String ? $util.base64.encode(message.bt_mac, 0, message.bt_mac.length) : options.bytes === Array ? Array.prototype.slice.call(message.bt_mac) : message.bt_mac;
        return object;
    };

    DeviceCoprocessorInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DeviceCoprocessorInfo;
})();

$root.DeviceSEInfo = (function() {

    function DeviceSEInfo(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DeviceSEInfo.prototype.bootloader = null;
    DeviceSEInfo.prototype.application = null;
    DeviceSEInfo.prototype.type = 0;
    DeviceSEInfo.prototype.state = 0;

    DeviceSEInfo.create = function create(properties) {
        return new DeviceSEInfo(properties);
    };

    DeviceSEInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.bootloader != null && Object.hasOwnProperty.call(message, "bootloader"))
            $root.DeviceFirmwareImageInfo.encode(message.bootloader, writer.uint32(162).fork()).ldelim();
        if (message.application != null && Object.hasOwnProperty.call(message, "application"))
            $root.DeviceFirmwareImageInfo.encode(message.application, writer.uint32(242).fork()).ldelim();
        if (message.type != null && Object.hasOwnProperty.call(message, "type"))
            writer.uint32(800).int32(message.type);
        if (message.state != null && Object.hasOwnProperty.call(message, "state"))
            writer.uint32(880).int32(message.state);
        return writer;
    };

    DeviceSEInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DeviceSEInfo.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DeviceSEInfo();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 20:
                message.bootloader = $root.DeviceFirmwareImageInfo.decode(reader, reader.uint32());
                break;
            case 30:
                message.application = $root.DeviceFirmwareImageInfo.decode(reader, reader.uint32());
                break;
            case 100:
                message.type = reader.int32();
                break;
            case 110:
                message.state = reader.int32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    DeviceSEInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DeviceSEInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.bootloader != null && message.hasOwnProperty("bootloader")) {
            var error = $root.DeviceFirmwareImageInfo.verify(message.bootloader);
            if (error)
                return "bootloader." + error;
        }
        if (message.application != null && message.hasOwnProperty("application")) {
            var error = $root.DeviceFirmwareImageInfo.verify(message.application);
            if (error)
                return "application." + error;
        }
        if (message.type != null && message.hasOwnProperty("type"))
            switch (message.type) {
            default:
                return "type: enum value expected";
            case 0:
            case 1:
                break;
            }
        if (message.state != null && message.hasOwnProperty("state"))
            switch (message.state) {
            default:
                return "state: enum value expected";
            case 0:
            case 51:
            case 85:
                break;
            }
        return null;
    };

    DeviceSEInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.DeviceSEInfo)
            return object;
        var message = new $root.DeviceSEInfo();
        if (object.bootloader != null) {
            if (typeof object.bootloader !== "object")
                throw TypeError(".DeviceSEInfo.bootloader: object expected");
            message.bootloader = $root.DeviceFirmwareImageInfo.fromObject(object.bootloader);
        }
        if (object.application != null) {
            if (typeof object.application !== "object")
                throw TypeError(".DeviceSEInfo.application: object expected");
            message.application = $root.DeviceFirmwareImageInfo.fromObject(object.application);
        }
        switch (object.type) {
        case "THD89":
        case 0:
            message.type = 0;
            break;
        case "SE608A":
        case 1:
            message.type = 1;
            break;
        }
        switch (object.state) {
        case "BOOT":
        case 0:
            message.state = 0;
            break;
        case "APP_FACTORY":
        case 51:
            message.state = 51;
            break;
        case "APP":
        case 85:
            message.state = 85;
            break;
        }
        return message;
    };

    DeviceSEInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.bootloader = null;
            object.application = null;
            object.type = options.enums === String ? "THD89" : 0;
            object.state = options.enums === String ? "BOOT" : 0;
        }
        if (message.bootloader != null && message.hasOwnProperty("bootloader"))
            object.bootloader = $root.DeviceFirmwareImageInfo.toObject(message.bootloader, options);
        if (message.application != null && message.hasOwnProperty("application"))
            object.application = $root.DeviceFirmwareImageInfo.toObject(message.application, options);
        if (message.type != null && message.hasOwnProperty("type"))
            object.type = options.enums === String ? $root.DeviceSeType[message.type] : message.type;
        if (message.state != null && message.hasOwnProperty("state"))
            object.state = options.enums === String ? $root.DeviceSEState[message.state] : message.state;
        return object;
    };

    DeviceSEInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DeviceSEInfo;
})();

$root.DeviceInfoTargets = (function() {

    function DeviceInfoTargets(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DeviceInfoTargets.prototype.hw = false;
    DeviceInfoTargets.prototype.main_mcu = false;
    DeviceInfoTargets.prototype.coprocessor = false;
    DeviceInfoTargets.prototype.se1 = false;
    DeviceInfoTargets.prototype.se2 = false;
    DeviceInfoTargets.prototype.se3 = false;
    DeviceInfoTargets.prototype.se4 = false;

    DeviceInfoTargets.create = function create(properties) {
        return new DeviceInfoTargets(properties);
    };

    DeviceInfoTargets.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.hw != null && Object.hasOwnProperty.call(message, "hw"))
            writer.uint32(800).bool(message.hw);
        if (message.main_mcu != null && Object.hasOwnProperty.call(message, "main_mcu"))
            writer.uint32(1600).bool(message.main_mcu);
        if (message.coprocessor != null && Object.hasOwnProperty.call(message, "coprocessor"))
            writer.uint32(2400).bool(message.coprocessor);
        if (message.se1 != null && Object.hasOwnProperty.call(message, "se1"))
            writer.uint32(3200).bool(message.se1);
        if (message.se2 != null && Object.hasOwnProperty.call(message, "se2"))
            writer.uint32(3280).bool(message.se2);
        if (message.se3 != null && Object.hasOwnProperty.call(message, "se3"))
            writer.uint32(3360).bool(message.se3);
        if (message.se4 != null && Object.hasOwnProperty.call(message, "se4"))
            writer.uint32(3440).bool(message.se4);
        return writer;
    };

    DeviceInfoTargets.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DeviceInfoTargets.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DeviceInfoTargets();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 100:
                message.hw = reader.bool();
                break;
            case 200:
                message.main_mcu = reader.bool();
                break;
            case 300:
                message.coprocessor = reader.bool();
                break;
            case 400:
                message.se1 = reader.bool();
                break;
            case 410:
                message.se2 = reader.bool();
                break;
            case 420:
                message.se3 = reader.bool();
                break;
            case 430:
                message.se4 = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    DeviceInfoTargets.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DeviceInfoTargets.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.hw != null && message.hasOwnProperty("hw"))
            if (typeof message.hw !== "boolean")
                return "hw: boolean expected";
        if (message.main_mcu != null && message.hasOwnProperty("main_mcu"))
            if (typeof message.main_mcu !== "boolean")
                return "main_mcu: boolean expected";
        if (message.coprocessor != null && message.hasOwnProperty("coprocessor"))
            if (typeof message.coprocessor !== "boolean")
                return "coprocessor: boolean expected";
        if (message.se1 != null && message.hasOwnProperty("se1"))
            if (typeof message.se1 !== "boolean")
                return "se1: boolean expected";
        if (message.se2 != null && message.hasOwnProperty("se2"))
            if (typeof message.se2 !== "boolean")
                return "se2: boolean expected";
        if (message.se3 != null && message.hasOwnProperty("se3"))
            if (typeof message.se3 !== "boolean")
                return "se3: boolean expected";
        if (message.se4 != null && message.hasOwnProperty("se4"))
            if (typeof message.se4 !== "boolean")
                return "se4: boolean expected";
        return null;
    };

    DeviceInfoTargets.fromObject = function fromObject(object) {
        if (object instanceof $root.DeviceInfoTargets)
            return object;
        var message = new $root.DeviceInfoTargets();
        if (object.hw != null)
            message.hw = Boolean(object.hw);
        if (object.main_mcu != null)
            message.main_mcu = Boolean(object.main_mcu);
        if (object.coprocessor != null)
            message.coprocessor = Boolean(object.coprocessor);
        if (object.se1 != null)
            message.se1 = Boolean(object.se1);
        if (object.se2 != null)
            message.se2 = Boolean(object.se2);
        if (object.se3 != null)
            message.se3 = Boolean(object.se3);
        if (object.se4 != null)
            message.se4 = Boolean(object.se4);
        return message;
    };

    DeviceInfoTargets.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.hw = false;
            object.main_mcu = false;
            object.coprocessor = false;
            object.se1 = false;
            object.se2 = false;
            object.se3 = false;
            object.se4 = false;
        }
        if (message.hw != null && message.hasOwnProperty("hw"))
            object.hw = message.hw;
        if (message.main_mcu != null && message.hasOwnProperty("main_mcu"))
            object.main_mcu = message.main_mcu;
        if (message.coprocessor != null && message.hasOwnProperty("coprocessor"))
            object.coprocessor = message.coprocessor;
        if (message.se1 != null && message.hasOwnProperty("se1"))
            object.se1 = message.se1;
        if (message.se2 != null && message.hasOwnProperty("se2"))
            object.se2 = message.se2;
        if (message.se3 != null && message.hasOwnProperty("se3"))
            object.se3 = message.se3;
        if (message.se4 != null && message.hasOwnProperty("se4"))
            object.se4 = message.se4;
        return object;
    };

    DeviceInfoTargets.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DeviceInfoTargets;
})();

$root.DeviceInfoTypes = (function() {

    function DeviceInfoTypes(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DeviceInfoTypes.prototype.version = false;
    DeviceInfoTypes.prototype.build_id = false;
    DeviceInfoTypes.prototype.hash = false;
    DeviceInfoTypes.prototype.specific = false;

    DeviceInfoTypes.create = function create(properties) {
        return new DeviceInfoTypes(properties);
    };

    DeviceInfoTypes.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.version != null && Object.hasOwnProperty.call(message, "version"))
            writer.uint32(80).bool(message.version);
        if (message.build_id != null && Object.hasOwnProperty.call(message, "build_id"))
            writer.uint32(160).bool(message.build_id);
        if (message.hash != null && Object.hasOwnProperty.call(message, "hash"))
            writer.uint32(240).bool(message.hash);
        if (message.specific != null && Object.hasOwnProperty.call(message, "specific"))
            writer.uint32(320).bool(message.specific);
        return writer;
    };

    DeviceInfoTypes.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DeviceInfoTypes.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DeviceInfoTypes();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 10:
                message.version = reader.bool();
                break;
            case 20:
                message.build_id = reader.bool();
                break;
            case 30:
                message.hash = reader.bool();
                break;
            case 40:
                message.specific = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    DeviceInfoTypes.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DeviceInfoTypes.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.version != null && message.hasOwnProperty("version"))
            if (typeof message.version !== "boolean")
                return "version: boolean expected";
        if (message.build_id != null && message.hasOwnProperty("build_id"))
            if (typeof message.build_id !== "boolean")
                return "build_id: boolean expected";
        if (message.hash != null && message.hasOwnProperty("hash"))
            if (typeof message.hash !== "boolean")
                return "hash: boolean expected";
        if (message.specific != null && message.hasOwnProperty("specific"))
            if (typeof message.specific !== "boolean")
                return "specific: boolean expected";
        return null;
    };

    DeviceInfoTypes.fromObject = function fromObject(object) {
        if (object instanceof $root.DeviceInfoTypes)
            return object;
        var message = new $root.DeviceInfoTypes();
        if (object.version != null)
            message.version = Boolean(object.version);
        if (object.build_id != null)
            message.build_id = Boolean(object.build_id);
        if (object.hash != null)
            message.hash = Boolean(object.hash);
        if (object.specific != null)
            message.specific = Boolean(object.specific);
        return message;
    };

    DeviceInfoTypes.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.version = false;
            object.build_id = false;
            object.hash = false;
            object.specific = false;
        }
        if (message.version != null && message.hasOwnProperty("version"))
            object.version = message.version;
        if (message.build_id != null && message.hasOwnProperty("build_id"))
            object.build_id = message.build_id;
        if (message.hash != null && message.hasOwnProperty("hash"))
            object.hash = message.hash;
        if (message.specific != null && message.hasOwnProperty("specific"))
            object.specific = message.specific;
        return object;
    };

    DeviceInfoTypes.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DeviceInfoTypes;
})();

$root.DeviceInfoGet = (function() {

    function DeviceInfoGet(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DeviceInfoGet.prototype.targets = null;
    DeviceInfoGet.prototype.types = null;

    DeviceInfoGet.create = function create(properties) {
        return new DeviceInfoGet(properties);
    };

    DeviceInfoGet.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.targets != null && Object.hasOwnProperty.call(message, "targets"))
            $root.DeviceInfoTargets.encode(message.targets, writer.uint32(10).fork()).ldelim();
        if (message.types != null && Object.hasOwnProperty.call(message, "types"))
            $root.DeviceInfoTypes.encode(message.types, writer.uint32(18).fork()).ldelim();
        return writer;
    };

    DeviceInfoGet.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DeviceInfoGet.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DeviceInfoGet();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.targets = $root.DeviceInfoTargets.decode(reader, reader.uint32());
                break;
            case 2:
                message.types = $root.DeviceInfoTypes.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    DeviceInfoGet.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DeviceInfoGet.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.targets != null && message.hasOwnProperty("targets")) {
            var error = $root.DeviceInfoTargets.verify(message.targets);
            if (error)
                return "targets." + error;
        }
        if (message.types != null && message.hasOwnProperty("types")) {
            var error = $root.DeviceInfoTypes.verify(message.types);
            if (error)
                return "types." + error;
        }
        return null;
    };

    DeviceInfoGet.fromObject = function fromObject(object) {
        if (object instanceof $root.DeviceInfoGet)
            return object;
        var message = new $root.DeviceInfoGet();
        if (object.targets != null) {
            if (typeof object.targets !== "object")
                throw TypeError(".DeviceInfoGet.targets: object expected");
            message.targets = $root.DeviceInfoTargets.fromObject(object.targets);
        }
        if (object.types != null) {
            if (typeof object.types !== "object")
                throw TypeError(".DeviceInfoGet.types: object expected");
            message.types = $root.DeviceInfoTypes.fromObject(object.types);
        }
        return message;
    };

    DeviceInfoGet.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.targets = null;
            object.types = null;
        }
        if (message.targets != null && message.hasOwnProperty("targets"))
            object.targets = $root.DeviceInfoTargets.toObject(message.targets, options);
        if (message.types != null && message.hasOwnProperty("types"))
            object.types = $root.DeviceInfoTypes.toObject(message.types, options);
        return object;
    };

    DeviceInfoGet.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DeviceInfoGet;
})();

$root.DeviceInfo = (function() {

    function DeviceInfo(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DeviceInfo.prototype.protocol_version = 0;
    DeviceInfo.prototype.hw = null;
    DeviceInfo.prototype.main_mcu = null;
    DeviceInfo.prototype.coprocessor = null;
    DeviceInfo.prototype.se1 = null;
    DeviceInfo.prototype.se2 = null;
    DeviceInfo.prototype.se3 = null;
    DeviceInfo.prototype.se4 = null;

    DeviceInfo.create = function create(properties) {
        return new DeviceInfo(properties);
    };

    DeviceInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).uint32(message.protocol_version);
        if (message.hw != null && Object.hasOwnProperty.call(message, "hw"))
            $root.DeviceHardwareInfo.encode(message.hw, writer.uint32(802).fork()).ldelim();
        if (message.main_mcu != null && Object.hasOwnProperty.call(message, "main_mcu"))
            $root.DeviceMainMcuInfo.encode(message.main_mcu, writer.uint32(1602).fork()).ldelim();
        if (message.coprocessor != null && Object.hasOwnProperty.call(message, "coprocessor"))
            $root.DeviceCoprocessorInfo.encode(message.coprocessor, writer.uint32(2402).fork()).ldelim();
        if (message.se1 != null && Object.hasOwnProperty.call(message, "se1"))
            $root.DeviceSEInfo.encode(message.se1, writer.uint32(3202).fork()).ldelim();
        if (message.se2 != null && Object.hasOwnProperty.call(message, "se2"))
            $root.DeviceSEInfo.encode(message.se2, writer.uint32(3282).fork()).ldelim();
        if (message.se3 != null && Object.hasOwnProperty.call(message, "se3"))
            $root.DeviceSEInfo.encode(message.se3, writer.uint32(3362).fork()).ldelim();
        if (message.se4 != null && Object.hasOwnProperty.call(message, "se4"))
            $root.DeviceSEInfo.encode(message.se4, writer.uint32(3442).fork()).ldelim();
        return writer;
    };

    DeviceInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DeviceInfo.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DeviceInfo();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.protocol_version = reader.uint32();
                break;
            case 100:
                message.hw = $root.DeviceHardwareInfo.decode(reader, reader.uint32());
                break;
            case 200:
                message.main_mcu = $root.DeviceMainMcuInfo.decode(reader, reader.uint32());
                break;
            case 300:
                message.coprocessor = $root.DeviceCoprocessorInfo.decode(reader, reader.uint32());
                break;
            case 400:
                message.se1 = $root.DeviceSEInfo.decode(reader, reader.uint32());
                break;
            case 410:
                message.se2 = $root.DeviceSEInfo.decode(reader, reader.uint32());
                break;
            case 420:
                message.se3 = $root.DeviceSEInfo.decode(reader, reader.uint32());
                break;
            case 430:
                message.se4 = $root.DeviceSEInfo.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("protocol_version"))
            throw $util.ProtocolError("missing required 'protocol_version'", { instance: message });
        return message;
    };

    DeviceInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DeviceInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isInteger(message.protocol_version))
            return "protocol_version: integer expected";
        if (message.hw != null && message.hasOwnProperty("hw")) {
            var error = $root.DeviceHardwareInfo.verify(message.hw);
            if (error)
                return "hw." + error;
        }
        if (message.main_mcu != null && message.hasOwnProperty("main_mcu")) {
            var error = $root.DeviceMainMcuInfo.verify(message.main_mcu);
            if (error)
                return "main_mcu." + error;
        }
        if (message.coprocessor != null && message.hasOwnProperty("coprocessor")) {
            var error = $root.DeviceCoprocessorInfo.verify(message.coprocessor);
            if (error)
                return "coprocessor." + error;
        }
        if (message.se1 != null && message.hasOwnProperty("se1")) {
            var error = $root.DeviceSEInfo.verify(message.se1);
            if (error)
                return "se1." + error;
        }
        if (message.se2 != null && message.hasOwnProperty("se2")) {
            var error = $root.DeviceSEInfo.verify(message.se2);
            if (error)
                return "se2." + error;
        }
        if (message.se3 != null && message.hasOwnProperty("se3")) {
            var error = $root.DeviceSEInfo.verify(message.se3);
            if (error)
                return "se3." + error;
        }
        if (message.se4 != null && message.hasOwnProperty("se4")) {
            var error = $root.DeviceSEInfo.verify(message.se4);
            if (error)
                return "se4." + error;
        }
        return null;
    };

    DeviceInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.DeviceInfo)
            return object;
        var message = new $root.DeviceInfo();
        if (object.protocol_version != null)
            message.protocol_version = object.protocol_version >>> 0;
        if (object.hw != null) {
            if (typeof object.hw !== "object")
                throw TypeError(".DeviceInfo.hw: object expected");
            message.hw = $root.DeviceHardwareInfo.fromObject(object.hw);
        }
        if (object.main_mcu != null) {
            if (typeof object.main_mcu !== "object")
                throw TypeError(".DeviceInfo.main_mcu: object expected");
            message.main_mcu = $root.DeviceMainMcuInfo.fromObject(object.main_mcu);
        }
        if (object.coprocessor != null) {
            if (typeof object.coprocessor !== "object")
                throw TypeError(".DeviceInfo.coprocessor: object expected");
            message.coprocessor = $root.DeviceCoprocessorInfo.fromObject(object.coprocessor);
        }
        if (object.se1 != null) {
            if (typeof object.se1 !== "object")
                throw TypeError(".DeviceInfo.se1: object expected");
            message.se1 = $root.DeviceSEInfo.fromObject(object.se1);
        }
        if (object.se2 != null) {
            if (typeof object.se2 !== "object")
                throw TypeError(".DeviceInfo.se2: object expected");
            message.se2 = $root.DeviceSEInfo.fromObject(object.se2);
        }
        if (object.se3 != null) {
            if (typeof object.se3 !== "object")
                throw TypeError(".DeviceInfo.se3: object expected");
            message.se3 = $root.DeviceSEInfo.fromObject(object.se3);
        }
        if (object.se4 != null) {
            if (typeof object.se4 !== "object")
                throw TypeError(".DeviceInfo.se4: object expected");
            message.se4 = $root.DeviceSEInfo.fromObject(object.se4);
        }
        return message;
    };

    DeviceInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.protocol_version = 0;
            object.hw = null;
            object.main_mcu = null;
            object.coprocessor = null;
            object.se1 = null;
            object.se2 = null;
            object.se3 = null;
            object.se4 = null;
        }
        if (message.protocol_version != null && message.hasOwnProperty("protocol_version"))
            object.protocol_version = message.protocol_version;
        if (message.hw != null && message.hasOwnProperty("hw"))
            object.hw = $root.DeviceHardwareInfo.toObject(message.hw, options);
        if (message.main_mcu != null && message.hasOwnProperty("main_mcu"))
            object.main_mcu = $root.DeviceMainMcuInfo.toObject(message.main_mcu, options);
        if (message.coprocessor != null && message.hasOwnProperty("coprocessor"))
            object.coprocessor = $root.DeviceCoprocessorInfo.toObject(message.coprocessor, options);
        if (message.se1 != null && message.hasOwnProperty("se1"))
            object.se1 = $root.DeviceSEInfo.toObject(message.se1, options);
        if (message.se2 != null && message.hasOwnProperty("se2"))
            object.se2 = $root.DeviceSEInfo.toObject(message.se2, options);
        if (message.se3 != null && message.hasOwnProperty("se3"))
            object.se3 = $root.DeviceSEInfo.toObject(message.se3, options);
        if (message.se4 != null && message.hasOwnProperty("se4"))
            object.se4 = $root.DeviceSEInfo.toObject(message.se4, options);
        return object;
    };

    DeviceInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DeviceInfo;
})();

$root.DeviceSessionErrorCode = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "DeviceSessionError_None"] = 0;
    values[valuesById[1] = "DeviceSessionError_UserCancelled"] = 1;
    values[valuesById[2] = "DeviceSessionError_InvalidSession"] = 2;
    values[valuesById[3] = "DeviceSessionError_AttachPinUnavailable"] = 3;
    values[valuesById[4] = "DeviceSessionError_PassphraseDisabled"] = 4;
    values[valuesById[5] = "DeviceSessionError_Busy"] = 5;
    return values;
})();

$root.DeviceSessionSeedDomain = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[1] = "SeedDomain_Standard"] = 1;
    values[valuesById[2] = "SeedDomain_Cardano"] = 2;
    return values;
})();

$root.DeviceSessionGet = (function() {

    function DeviceSessionGet(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DeviceSessionGet.prototype.session_id = $util.newBuffer([]);
    DeviceSessionGet.prototype.btc_test_address = "";

    DeviceSessionGet.create = function create(properties) {
        return new DeviceSessionGet(properties);
    };

    DeviceSessionGet.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.session_id != null && Object.hasOwnProperty.call(message, "session_id"))
            writer.uint32(10).bytes(message.session_id);
        if (message.btc_test_address != null && Object.hasOwnProperty.call(message, "btc_test_address"))
            writer.uint32(18).string(message.btc_test_address);
        return writer;
    };

    DeviceSessionGet.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DeviceSessionGet.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DeviceSessionGet();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.session_id = reader.bytes();
                break;
            case 2:
                message.btc_test_address = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    DeviceSessionGet.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DeviceSessionGet.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.session_id != null && message.hasOwnProperty("session_id"))
            if (!(message.session_id && typeof message.session_id.length === "number" || $util.isString(message.session_id)))
                return "session_id: buffer expected";
        if (message.btc_test_address != null && message.hasOwnProperty("btc_test_address"))
            if (!$util.isString(message.btc_test_address))
                return "btc_test_address: string expected";
        return null;
    };

    DeviceSessionGet.fromObject = function fromObject(object) {
        if (object instanceof $root.DeviceSessionGet)
            return object;
        var message = new $root.DeviceSessionGet();
        if (object.session_id != null)
            if (typeof object.session_id === "string")
                $util.base64.decode(object.session_id, message.session_id = $util.newBuffer($util.base64.length(object.session_id)), 0);
            else if (object.session_id.length)
                message.session_id = object.session_id;
        if (object.btc_test_address != null)
            message.btc_test_address = String(object.btc_test_address);
        return message;
    };

    DeviceSessionGet.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.session_id = "";
            else {
                object.session_id = [];
                if (options.bytes !== Array)
                    object.session_id = $util.newBuffer(object.session_id);
            }
            object.btc_test_address = "";
        }
        if (message.session_id != null && message.hasOwnProperty("session_id"))
            object.session_id = options.bytes === String ? $util.base64.encode(message.session_id, 0, message.session_id.length) : options.bytes === Array ? Array.prototype.slice.call(message.session_id) : message.session_id;
        if (message.btc_test_address != null && message.hasOwnProperty("btc_test_address"))
            object.btc_test_address = message.btc_test_address;
        return object;
    };

    DeviceSessionGet.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DeviceSessionGet;
})();

$root.DeviceSession = (function() {

    function DeviceSession(properties) {
        this.seed_domains = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DeviceSession.prototype.session_id = $util.newBuffer([]);
    DeviceSession.prototype.btc_test_address = "";
    DeviceSession.prototype.seed_domains = $util.emptyArray;

    DeviceSession.create = function create(properties) {
        return new DeviceSession(properties);
    };

    DeviceSession.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.session_id != null && Object.hasOwnProperty.call(message, "session_id"))
            writer.uint32(10).bytes(message.session_id);
        if (message.btc_test_address != null && Object.hasOwnProperty.call(message, "btc_test_address"))
            writer.uint32(18).string(message.btc_test_address);
        if (message.seed_domains != null && message.seed_domains.length) {
            writer.uint32(26).fork();
            for (var i = 0; i < message.seed_domains.length; ++i)
                writer.int32(message.seed_domains[i]);
            writer.ldelim();
        }
        return writer;
    };

    DeviceSession.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DeviceSession.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DeviceSession();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.session_id = reader.bytes();
                break;
            case 2:
                message.btc_test_address = reader.string();
                break;
            case 3:
                if (!(message.seed_domains && message.seed_domains.length))
                    message.seed_domains = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.seed_domains.push(reader.int32());
                } else
                    message.seed_domains.push(reader.int32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    DeviceSession.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DeviceSession.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.session_id != null && message.hasOwnProperty("session_id"))
            if (!(message.session_id && typeof message.session_id.length === "number" || $util.isString(message.session_id)))
                return "session_id: buffer expected";
        if (message.btc_test_address != null && message.hasOwnProperty("btc_test_address"))
            if (!$util.isString(message.btc_test_address))
                return "btc_test_address: string expected";
        if (message.seed_domains != null && message.hasOwnProperty("seed_domains")) {
            if (!Array.isArray(message.seed_domains))
                return "seed_domains: array expected";
            for (var i = 0; i < message.seed_domains.length; ++i)
                switch (message.seed_domains[i]) {
                default:
                    return "seed_domains: enum value[] expected";
                case 1:
                case 2:
                    break;
                }
        }
        return null;
    };

    DeviceSession.fromObject = function fromObject(object) {
        if (object instanceof $root.DeviceSession)
            return object;
        var message = new $root.DeviceSession();
        if (object.session_id != null)
            if (typeof object.session_id === "string")
                $util.base64.decode(object.session_id, message.session_id = $util.newBuffer($util.base64.length(object.session_id)), 0);
            else if (object.session_id.length)
                message.session_id = object.session_id;
        if (object.btc_test_address != null)
            message.btc_test_address = String(object.btc_test_address);
        if (object.seed_domains) {
            if (!Array.isArray(object.seed_domains))
                throw TypeError(".DeviceSession.seed_domains: array expected");
            message.seed_domains = [];
            for (var i = 0; i < object.seed_domains.length; ++i)
                switch (object.seed_domains[i]) {
                default:
                case "SeedDomain_Standard":
                case 1:
                    message.seed_domains[i] = 1;
                    break;
                case "SeedDomain_Cardano":
                case 2:
                    message.seed_domains[i] = 2;
                    break;
                }
        }
        return message;
    };

    DeviceSession.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.seed_domains = [];
        if (options.defaults) {
            if (options.bytes === String)
                object.session_id = "";
            else {
                object.session_id = [];
                if (options.bytes !== Array)
                    object.session_id = $util.newBuffer(object.session_id);
            }
            object.btc_test_address = "";
        }
        if (message.session_id != null && message.hasOwnProperty("session_id"))
            object.session_id = options.bytes === String ? $util.base64.encode(message.session_id, 0, message.session_id.length) : options.bytes === Array ? Array.prototype.slice.call(message.session_id) : message.session_id;
        if (message.btc_test_address != null && message.hasOwnProperty("btc_test_address"))
            object.btc_test_address = message.btc_test_address;
        if (message.seed_domains && message.seed_domains.length) {
            object.seed_domains = [];
            for (var j = 0; j < message.seed_domains.length; ++j)
                object.seed_domains[j] = options.enums === String ? $root.DeviceSessionSeedDomain[message.seed_domains[j]] : message.seed_domains[j];
        }
        return object;
    };

    DeviceSession.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DeviceSession;
})();

$root.DeviceSessionPinType = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[1] = "Any"] = 1;
    values[valuesById[2] = "Main"] = 2;
    values[valuesById[3] = "AttachToPin"] = 3;
    return values;
})();

$root.DeviceSessionAskPin = (function() {

    function DeviceSessionAskPin(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DeviceSessionAskPin.prototype.type = 1;

    DeviceSessionAskPin.create = function create(properties) {
        return new DeviceSessionAskPin(properties);
    };

    DeviceSessionAskPin.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.type != null && Object.hasOwnProperty.call(message, "type"))
            writer.uint32(8).int32(message.type);
        return writer;
    };

    DeviceSessionAskPin.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DeviceSessionAskPin.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DeviceSessionAskPin();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.type = reader.int32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    DeviceSessionAskPin.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DeviceSessionAskPin.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.type != null && message.hasOwnProperty("type"))
            switch (message.type) {
            default:
                return "type: enum value expected";
            case 1:
            case 2:
            case 3:
                break;
            }
        return null;
    };

    DeviceSessionAskPin.fromObject = function fromObject(object) {
        if (object instanceof $root.DeviceSessionAskPin)
            return object;
        var message = new $root.DeviceSessionAskPin();
        switch (object.type) {
        case "Any":
        case 1:
            message.type = 1;
            break;
        case "Main":
        case 2:
            message.type = 2;
            break;
        case "AttachToPin":
        case 3:
            message.type = 3;
            break;
        }
        return message;
    };

    DeviceSessionAskPin.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.type = options.enums === String ? "Any" : 1;
        if (message.type != null && message.hasOwnProperty("type"))
            object.type = options.enums === String ? $root.DeviceSessionPinType[message.type] : message.type;
        return object;
    };

    DeviceSessionAskPin.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DeviceSessionAskPin;
})();

$root.DeviceSessionAskPassphrase = (function() {

    function DeviceSessionAskPassphrase(properties) {
        this.seed_domains = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DeviceSessionAskPassphrase.prototype.passphrase = "";
    DeviceSessionAskPassphrase.prototype.on_device = false;
    DeviceSessionAskPassphrase.prototype.seed_domains = $util.emptyArray;

    DeviceSessionAskPassphrase.create = function create(properties) {
        return new DeviceSessionAskPassphrase(properties);
    };

    DeviceSessionAskPassphrase.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.passphrase != null && Object.hasOwnProperty.call(message, "passphrase"))
            writer.uint32(10).string(message.passphrase);
        writer.uint32(16).bool(message.on_device);
        if (message.seed_domains != null && message.seed_domains.length) {
            writer.uint32(26).fork();
            for (var i = 0; i < message.seed_domains.length; ++i)
                writer.int32(message.seed_domains[i]);
            writer.ldelim();
        }
        return writer;
    };

    DeviceSessionAskPassphrase.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DeviceSessionAskPassphrase.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DeviceSessionAskPassphrase();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.passphrase = reader.string();
                break;
            case 2:
                message.on_device = reader.bool();
                break;
            case 3:
                if (!(message.seed_domains && message.seed_domains.length))
                    message.seed_domains = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.seed_domains.push(reader.int32());
                } else
                    message.seed_domains.push(reader.int32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("on_device"))
            throw $util.ProtocolError("missing required 'on_device'", { instance: message });
        return message;
    };

    DeviceSessionAskPassphrase.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DeviceSessionAskPassphrase.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.passphrase != null && message.hasOwnProperty("passphrase"))
            if (!$util.isString(message.passphrase))
                return "passphrase: string expected";
        if (typeof message.on_device !== "boolean")
            return "on_device: boolean expected";
        if (message.seed_domains != null && message.hasOwnProperty("seed_domains")) {
            if (!Array.isArray(message.seed_domains))
                return "seed_domains: array expected";
            for (var i = 0; i < message.seed_domains.length; ++i)
                switch (message.seed_domains[i]) {
                default:
                    return "seed_domains: enum value[] expected";
                case 1:
                case 2:
                    break;
                }
        }
        return null;
    };

    DeviceSessionAskPassphrase.fromObject = function fromObject(object) {
        if (object instanceof $root.DeviceSessionAskPassphrase)
            return object;
        var message = new $root.DeviceSessionAskPassphrase();
        if (object.passphrase != null)
            message.passphrase = String(object.passphrase);
        if (object.on_device != null)
            message.on_device = Boolean(object.on_device);
        if (object.seed_domains) {
            if (!Array.isArray(object.seed_domains))
                throw TypeError(".DeviceSessionAskPassphrase.seed_domains: array expected");
            message.seed_domains = [];
            for (var i = 0; i < object.seed_domains.length; ++i)
                switch (object.seed_domains[i]) {
                default:
                case "SeedDomain_Standard":
                case 1:
                    message.seed_domains[i] = 1;
                    break;
                case "SeedDomain_Cardano":
                case 2:
                    message.seed_domains[i] = 2;
                    break;
                }
        }
        return message;
    };

    DeviceSessionAskPassphrase.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.seed_domains = [];
        if (options.defaults) {
            object.passphrase = "";
            object.on_device = false;
        }
        if (message.passphrase != null && message.hasOwnProperty("passphrase"))
            object.passphrase = message.passphrase;
        if (message.on_device != null && message.hasOwnProperty("on_device"))
            object.on_device = message.on_device;
        if (message.seed_domains && message.seed_domains.length) {
            object.seed_domains = [];
            for (var j = 0; j < message.seed_domains.length; ++j)
                object.seed_domains[j] = options.enums === String ? $root.DeviceSessionSeedDomain[message.seed_domains[j]] : message.seed_domains[j];
        }
        return object;
    };

    DeviceSessionAskPassphrase.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DeviceSessionAskPassphrase;
})();

$root.DeviceSessionAskPin_FailureSubCodes = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[1] = "UserCancel"] = 1;
    return values;
})();

$root.DeviceStatus = (function() {

    function DeviceStatus(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DeviceStatus.prototype.device_id = "";
    DeviceStatus.prototype.unlocked = false;
    DeviceStatus.prototype.init_states = false;
    DeviceStatus.prototype.backup_required = false;
    DeviceStatus.prototype.passphrase_enabled = false;
    DeviceStatus.prototype.attach_to_pin_enabled = false;
    DeviceStatus.prototype.unlocked_by_attach_to_pin = false;

    DeviceStatus.create = function create(properties) {
        return new DeviceStatus(properties);
    };

    DeviceStatus.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.device_id != null && Object.hasOwnProperty.call(message, "device_id"))
            writer.uint32(10).string(message.device_id);
        if (message.unlocked != null && Object.hasOwnProperty.call(message, "unlocked"))
            writer.uint32(16).bool(message.unlocked);
        if (message.init_states != null && Object.hasOwnProperty.call(message, "init_states"))
            writer.uint32(24).bool(message.init_states);
        if (message.backup_required != null && Object.hasOwnProperty.call(message, "backup_required"))
            writer.uint32(32).bool(message.backup_required);
        if (message.passphrase_enabled != null && Object.hasOwnProperty.call(message, "passphrase_enabled"))
            writer.uint32(80).bool(message.passphrase_enabled);
        if (message.attach_to_pin_enabled != null && Object.hasOwnProperty.call(message, "attach_to_pin_enabled"))
            writer.uint32(88).bool(message.attach_to_pin_enabled);
        if (message.unlocked_by_attach_to_pin != null && Object.hasOwnProperty.call(message, "unlocked_by_attach_to_pin"))
            writer.uint32(96).bool(message.unlocked_by_attach_to_pin);
        return writer;
    };

    DeviceStatus.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DeviceStatus.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DeviceStatus();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.device_id = reader.string();
                break;
            case 2:
                message.unlocked = reader.bool();
                break;
            case 3:
                message.init_states = reader.bool();
                break;
            case 4:
                message.backup_required = reader.bool();
                break;
            case 10:
                message.passphrase_enabled = reader.bool();
                break;
            case 11:
                message.attach_to_pin_enabled = reader.bool();
                break;
            case 12:
                message.unlocked_by_attach_to_pin = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    DeviceStatus.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DeviceStatus.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.device_id != null && message.hasOwnProperty("device_id"))
            if (!$util.isString(message.device_id))
                return "device_id: string expected";
        if (message.unlocked != null && message.hasOwnProperty("unlocked"))
            if (typeof message.unlocked !== "boolean")
                return "unlocked: boolean expected";
        if (message.init_states != null && message.hasOwnProperty("init_states"))
            if (typeof message.init_states !== "boolean")
                return "init_states: boolean expected";
        if (message.backup_required != null && message.hasOwnProperty("backup_required"))
            if (typeof message.backup_required !== "boolean")
                return "backup_required: boolean expected";
        if (message.passphrase_enabled != null && message.hasOwnProperty("passphrase_enabled"))
            if (typeof message.passphrase_enabled !== "boolean")
                return "passphrase_enabled: boolean expected";
        if (message.attach_to_pin_enabled != null && message.hasOwnProperty("attach_to_pin_enabled"))
            if (typeof message.attach_to_pin_enabled !== "boolean")
                return "attach_to_pin_enabled: boolean expected";
        if (message.unlocked_by_attach_to_pin != null && message.hasOwnProperty("unlocked_by_attach_to_pin"))
            if (typeof message.unlocked_by_attach_to_pin !== "boolean")
                return "unlocked_by_attach_to_pin: boolean expected";
        return null;
    };

    DeviceStatus.fromObject = function fromObject(object) {
        if (object instanceof $root.DeviceStatus)
            return object;
        var message = new $root.DeviceStatus();
        if (object.device_id != null)
            message.device_id = String(object.device_id);
        if (object.unlocked != null)
            message.unlocked = Boolean(object.unlocked);
        if (object.init_states != null)
            message.init_states = Boolean(object.init_states);
        if (object.backup_required != null)
            message.backup_required = Boolean(object.backup_required);
        if (object.passphrase_enabled != null)
            message.passphrase_enabled = Boolean(object.passphrase_enabled);
        if (object.attach_to_pin_enabled != null)
            message.attach_to_pin_enabled = Boolean(object.attach_to_pin_enabled);
        if (object.unlocked_by_attach_to_pin != null)
            message.unlocked_by_attach_to_pin = Boolean(object.unlocked_by_attach_to_pin);
        return message;
    };

    DeviceStatus.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.device_id = "";
            object.unlocked = false;
            object.init_states = false;
            object.backup_required = false;
            object.passphrase_enabled = false;
            object.attach_to_pin_enabled = false;
            object.unlocked_by_attach_to_pin = false;
        }
        if (message.device_id != null && message.hasOwnProperty("device_id"))
            object.device_id = message.device_id;
        if (message.unlocked != null && message.hasOwnProperty("unlocked"))
            object.unlocked = message.unlocked;
        if (message.init_states != null && message.hasOwnProperty("init_states"))
            object.init_states = message.init_states;
        if (message.backup_required != null && message.hasOwnProperty("backup_required"))
            object.backup_required = message.backup_required;
        if (message.passphrase_enabled != null && message.hasOwnProperty("passphrase_enabled"))
            object.passphrase_enabled = message.passphrase_enabled;
        if (message.attach_to_pin_enabled != null && message.hasOwnProperty("attach_to_pin_enabled"))
            object.attach_to_pin_enabled = message.attach_to_pin_enabled;
        if (message.unlocked_by_attach_to_pin != null && message.hasOwnProperty("unlocked_by_attach_to_pin"))
            object.unlocked_by_attach_to_pin = message.unlocked_by_attach_to_pin;
        return object;
    };

    DeviceStatus.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DeviceStatus;
})();

$root.DeviceStatusGet = (function() {

    function DeviceStatusGet(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    DeviceStatusGet.create = function create(properties) {
        return new DeviceStatusGet(properties);
    };

    DeviceStatusGet.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    DeviceStatusGet.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    DeviceStatusGet.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DeviceStatusGet();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    DeviceStatusGet.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    DeviceStatusGet.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    DeviceStatusGet.fromObject = function fromObject(object) {
        if (object instanceof $root.DeviceStatusGet)
            return object;
        return new $root.DeviceStatusGet();
    };

    DeviceStatusGet.toObject = function toObject() {
        return {};
    };

    DeviceStatusGet.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DeviceStatusGet;
})();

$root.FilesystemPermissionFix = (function() {

    function FilesystemPermissionFix(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    FilesystemPermissionFix.create = function create(properties) {
        return new FilesystemPermissionFix(properties);
    };

    FilesystemPermissionFix.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    FilesystemPermissionFix.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    FilesystemPermissionFix.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.FilesystemPermissionFix();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    FilesystemPermissionFix.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    FilesystemPermissionFix.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    FilesystemPermissionFix.fromObject = function fromObject(object) {
        if (object instanceof $root.FilesystemPermissionFix)
            return object;
        return new $root.FilesystemPermissionFix();
    };

    FilesystemPermissionFix.toObject = function toObject() {
        return {};
    };

    FilesystemPermissionFix.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return FilesystemPermissionFix;
})();

$root.FilesystemPathInfo = (function() {

    function FilesystemPathInfo(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    FilesystemPathInfo.prototype.exist = false;
    FilesystemPathInfo.prototype.size = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    FilesystemPathInfo.prototype.year = 0;
    FilesystemPathInfo.prototype.month = 0;
    FilesystemPathInfo.prototype.day = 0;
    FilesystemPathInfo.prototype.hour = 0;
    FilesystemPathInfo.prototype.minute = 0;
    FilesystemPathInfo.prototype.second = 0;
    FilesystemPathInfo.prototype.readonly = false;
    FilesystemPathInfo.prototype.hidden = false;
    FilesystemPathInfo.prototype.system = false;
    FilesystemPathInfo.prototype.archive = false;
    FilesystemPathInfo.prototype.directory = false;

    FilesystemPathInfo.create = function create(properties) {
        return new FilesystemPathInfo(properties);
    };

    FilesystemPathInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).bool(message.exist);
        writer.uint32(16).uint64(message.size);
        writer.uint32(24).uint32(message.year);
        writer.uint32(32).uint32(message.month);
        writer.uint32(40).uint32(message.day);
        writer.uint32(48).uint32(message.hour);
        writer.uint32(56).uint32(message.minute);
        writer.uint32(64).uint32(message.second);
        writer.uint32(72).bool(message.readonly);
        writer.uint32(80).bool(message.hidden);
        writer.uint32(88).bool(message.system);
        writer.uint32(96).bool(message.archive);
        writer.uint32(104).bool(message.directory);
        return writer;
    };

    FilesystemPathInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    FilesystemPathInfo.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.FilesystemPathInfo();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.exist = reader.bool();
                break;
            case 2:
                message.size = reader.uint64();
                break;
            case 3:
                message.year = reader.uint32();
                break;
            case 4:
                message.month = reader.uint32();
                break;
            case 5:
                message.day = reader.uint32();
                break;
            case 6:
                message.hour = reader.uint32();
                break;
            case 7:
                message.minute = reader.uint32();
                break;
            case 8:
                message.second = reader.uint32();
                break;
            case 9:
                message.readonly = reader.bool();
                break;
            case 10:
                message.hidden = reader.bool();
                break;
            case 11:
                message.system = reader.bool();
                break;
            case 12:
                message.archive = reader.bool();
                break;
            case 13:
                message.directory = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("exist"))
            throw $util.ProtocolError("missing required 'exist'", { instance: message });
        if (!message.hasOwnProperty("size"))
            throw $util.ProtocolError("missing required 'size'", { instance: message });
        if (!message.hasOwnProperty("year"))
            throw $util.ProtocolError("missing required 'year'", { instance: message });
        if (!message.hasOwnProperty("month"))
            throw $util.ProtocolError("missing required 'month'", { instance: message });
        if (!message.hasOwnProperty("day"))
            throw $util.ProtocolError("missing required 'day'", { instance: message });
        if (!message.hasOwnProperty("hour"))
            throw $util.ProtocolError("missing required 'hour'", { instance: message });
        if (!message.hasOwnProperty("minute"))
            throw $util.ProtocolError("missing required 'minute'", { instance: message });
        if (!message.hasOwnProperty("second"))
            throw $util.ProtocolError("missing required 'second'", { instance: message });
        if (!message.hasOwnProperty("readonly"))
            throw $util.ProtocolError("missing required 'readonly'", { instance: message });
        if (!message.hasOwnProperty("hidden"))
            throw $util.ProtocolError("missing required 'hidden'", { instance: message });
        if (!message.hasOwnProperty("system"))
            throw $util.ProtocolError("missing required 'system'", { instance: message });
        if (!message.hasOwnProperty("archive"))
            throw $util.ProtocolError("missing required 'archive'", { instance: message });
        if (!message.hasOwnProperty("directory"))
            throw $util.ProtocolError("missing required 'directory'", { instance: message });
        return message;
    };

    FilesystemPathInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    FilesystemPathInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (typeof message.exist !== "boolean")
            return "exist: boolean expected";
        if (!$util.isInteger(message.size) && !(message.size && $util.isInteger(message.size.low) && $util.isInteger(message.size.high)))
            return "size: integer|Long expected";
        if (!$util.isInteger(message.year))
            return "year: integer expected";
        if (!$util.isInteger(message.month))
            return "month: integer expected";
        if (!$util.isInteger(message.day))
            return "day: integer expected";
        if (!$util.isInteger(message.hour))
            return "hour: integer expected";
        if (!$util.isInteger(message.minute))
            return "minute: integer expected";
        if (!$util.isInteger(message.second))
            return "second: integer expected";
        if (typeof message.readonly !== "boolean")
            return "readonly: boolean expected";
        if (typeof message.hidden !== "boolean")
            return "hidden: boolean expected";
        if (typeof message.system !== "boolean")
            return "system: boolean expected";
        if (typeof message.archive !== "boolean")
            return "archive: boolean expected";
        if (typeof message.directory !== "boolean")
            return "directory: boolean expected";
        return null;
    };

    FilesystemPathInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.FilesystemPathInfo)
            return object;
        var message = new $root.FilesystemPathInfo();
        if (object.exist != null)
            message.exist = Boolean(object.exist);
        if (object.size != null)
            if ($util.Long)
                (message.size = $util.Long.fromValue(object.size)).unsigned = true;
            else if (typeof object.size === "string")
                message.size = parseInt(object.size, 10);
            else if (typeof object.size === "number")
                message.size = object.size;
            else if (typeof object.size === "object")
                message.size = new $util.LongBits(object.size.low >>> 0, object.size.high >>> 0).toNumber(true);
        if (object.year != null)
            message.year = object.year >>> 0;
        if (object.month != null)
            message.month = object.month >>> 0;
        if (object.day != null)
            message.day = object.day >>> 0;
        if (object.hour != null)
            message.hour = object.hour >>> 0;
        if (object.minute != null)
            message.minute = object.minute >>> 0;
        if (object.second != null)
            message.second = object.second >>> 0;
        if (object.readonly != null)
            message.readonly = Boolean(object.readonly);
        if (object.hidden != null)
            message.hidden = Boolean(object.hidden);
        if (object.system != null)
            message.system = Boolean(object.system);
        if (object.archive != null)
            message.archive = Boolean(object.archive);
        if (object.directory != null)
            message.directory = Boolean(object.directory);
        return message;
    };

    FilesystemPathInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.exist = false;
            if ($util.Long) {
                var long = new $util.Long(0, 0, true);
                object.size = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.size = options.longs === String ? "0" : 0;
            object.year = 0;
            object.month = 0;
            object.day = 0;
            object.hour = 0;
            object.minute = 0;
            object.second = 0;
            object.readonly = false;
            object.hidden = false;
            object.system = false;
            object.archive = false;
            object.directory = false;
        }
        if (message.exist != null && message.hasOwnProperty("exist"))
            object.exist = message.exist;
        if (message.size != null && message.hasOwnProperty("size"))
            if (typeof message.size === "number")
                object.size = options.longs === String ? String(message.size) : message.size;
            else
                object.size = options.longs === String ? $util.Long.prototype.toString.call(message.size) : options.longs === Number ? new $util.LongBits(message.size.low >>> 0, message.size.high >>> 0).toNumber(true) : message.size;
        if (message.year != null && message.hasOwnProperty("year"))
            object.year = message.year;
        if (message.month != null && message.hasOwnProperty("month"))
            object.month = message.month;
        if (message.day != null && message.hasOwnProperty("day"))
            object.day = message.day;
        if (message.hour != null && message.hasOwnProperty("hour"))
            object.hour = message.hour;
        if (message.minute != null && message.hasOwnProperty("minute"))
            object.minute = message.minute;
        if (message.second != null && message.hasOwnProperty("second"))
            object.second = message.second;
        if (message.readonly != null && message.hasOwnProperty("readonly"))
            object.readonly = message.readonly;
        if (message.hidden != null && message.hasOwnProperty("hidden"))
            object.hidden = message.hidden;
        if (message.system != null && message.hasOwnProperty("system"))
            object.system = message.system;
        if (message.archive != null && message.hasOwnProperty("archive"))
            object.archive = message.archive;
        if (message.directory != null && message.hasOwnProperty("directory"))
            object.directory = message.directory;
        return object;
    };

    FilesystemPathInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return FilesystemPathInfo;
})();

$root.FilesystemPathInfoQuery = (function() {

    function FilesystemPathInfoQuery(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    FilesystemPathInfoQuery.prototype.path = "";

    FilesystemPathInfoQuery.create = function create(properties) {
        return new FilesystemPathInfoQuery(properties);
    };

    FilesystemPathInfoQuery.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.path);
        return writer;
    };

    FilesystemPathInfoQuery.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    FilesystemPathInfoQuery.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.FilesystemPathInfoQuery();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.path = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("path"))
            throw $util.ProtocolError("missing required 'path'", { instance: message });
        return message;
    };

    FilesystemPathInfoQuery.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    FilesystemPathInfoQuery.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.path))
            return "path: string expected";
        return null;
    };

    FilesystemPathInfoQuery.fromObject = function fromObject(object) {
        if (object instanceof $root.FilesystemPathInfoQuery)
            return object;
        var message = new $root.FilesystemPathInfoQuery();
        if (object.path != null)
            message.path = String(object.path);
        return message;
    };

    FilesystemPathInfoQuery.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.path = "";
        if (message.path != null && message.hasOwnProperty("path"))
            object.path = message.path;
        return object;
    };

    FilesystemPathInfoQuery.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return FilesystemPathInfoQuery;
})();

$root.FilesystemFile = (function() {

    function FilesystemFile(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    FilesystemFile.prototype.path = "";
    FilesystemFile.prototype.offset = 0;
    FilesystemFile.prototype.total_size = 0;
    FilesystemFile.prototype.data = $util.newBuffer([]);
    FilesystemFile.prototype.data_hash = 0;
    FilesystemFile.prototype.processed_byte = 0;

    FilesystemFile.create = function create(properties) {
        return new FilesystemFile(properties);
    };

    FilesystemFile.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.path);
        writer.uint32(16).uint32(message.offset);
        writer.uint32(24).uint32(message.total_size);
        if (message.data != null && Object.hasOwnProperty.call(message, "data"))
            writer.uint32(34).bytes(message.data);
        if (message.data_hash != null && Object.hasOwnProperty.call(message, "data_hash"))
            writer.uint32(40).uint32(message.data_hash);
        if (message.processed_byte != null && Object.hasOwnProperty.call(message, "processed_byte"))
            writer.uint32(48).uint32(message.processed_byte);
        return writer;
    };

    FilesystemFile.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    FilesystemFile.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.FilesystemFile();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.path = reader.string();
                break;
            case 2:
                message.offset = reader.uint32();
                break;
            case 3:
                message.total_size = reader.uint32();
                break;
            case 4:
                message.data = reader.bytes();
                break;
            case 5:
                message.data_hash = reader.uint32();
                break;
            case 6:
                message.processed_byte = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("path"))
            throw $util.ProtocolError("missing required 'path'", { instance: message });
        if (!message.hasOwnProperty("offset"))
            throw $util.ProtocolError("missing required 'offset'", { instance: message });
        if (!message.hasOwnProperty("total_size"))
            throw $util.ProtocolError("missing required 'total_size'", { instance: message });
        return message;
    };

    FilesystemFile.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    FilesystemFile.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.path))
            return "path: string expected";
        if (!$util.isInteger(message.offset))
            return "offset: integer expected";
        if (!$util.isInteger(message.total_size))
            return "total_size: integer expected";
        if (message.data != null && message.hasOwnProperty("data"))
            if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
                return "data: buffer expected";
        if (message.data_hash != null && message.hasOwnProperty("data_hash"))
            if (!$util.isInteger(message.data_hash))
                return "data_hash: integer expected";
        if (message.processed_byte != null && message.hasOwnProperty("processed_byte"))
            if (!$util.isInteger(message.processed_byte))
                return "processed_byte: integer expected";
        return null;
    };

    FilesystemFile.fromObject = function fromObject(object) {
        if (object instanceof $root.FilesystemFile)
            return object;
        var message = new $root.FilesystemFile();
        if (object.path != null)
            message.path = String(object.path);
        if (object.offset != null)
            message.offset = object.offset >>> 0;
        if (object.total_size != null)
            message.total_size = object.total_size >>> 0;
        if (object.data != null)
            if (typeof object.data === "string")
                $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
            else if (object.data.length)
                message.data = object.data;
        if (object.data_hash != null)
            message.data_hash = object.data_hash >>> 0;
        if (object.processed_byte != null)
            message.processed_byte = object.processed_byte >>> 0;
        return message;
    };

    FilesystemFile.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.path = "";
            object.offset = 0;
            object.total_size = 0;
            if (options.bytes === String)
                object.data = "";
            else {
                object.data = [];
                if (options.bytes !== Array)
                    object.data = $util.newBuffer(object.data);
            }
            object.data_hash = 0;
            object.processed_byte = 0;
        }
        if (message.path != null && message.hasOwnProperty("path"))
            object.path = message.path;
        if (message.offset != null && message.hasOwnProperty("offset"))
            object.offset = message.offset;
        if (message.total_size != null && message.hasOwnProperty("total_size"))
            object.total_size = message.total_size;
        if (message.data != null && message.hasOwnProperty("data"))
            object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
        if (message.data_hash != null && message.hasOwnProperty("data_hash"))
            object.data_hash = message.data_hash;
        if (message.processed_byte != null && message.hasOwnProperty("processed_byte"))
            object.processed_byte = message.processed_byte;
        return object;
    };

    FilesystemFile.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return FilesystemFile;
})();

$root.FilesystemFileRead = (function() {

    function FilesystemFileRead(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    FilesystemFileRead.prototype.file = null;
    FilesystemFileRead.prototype.chunk_len = 0;
    FilesystemFileRead.prototype.ui_percentage = 0;

    FilesystemFileRead.create = function create(properties) {
        return new FilesystemFileRead(properties);
    };

    FilesystemFileRead.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        $root.FilesystemFile.encode(message.file, writer.uint32(10).fork()).ldelim();
        if (message.chunk_len != null && Object.hasOwnProperty.call(message, "chunk_len"))
            writer.uint32(16).uint32(message.chunk_len);
        if (message.ui_percentage != null && Object.hasOwnProperty.call(message, "ui_percentage"))
            writer.uint32(24).uint32(message.ui_percentage);
        return writer;
    };

    FilesystemFileRead.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    FilesystemFileRead.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.FilesystemFileRead();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.file = $root.FilesystemFile.decode(reader, reader.uint32());
                break;
            case 2:
                message.chunk_len = reader.uint32();
                break;
            case 3:
                message.ui_percentage = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("file"))
            throw $util.ProtocolError("missing required 'file'", { instance: message });
        return message;
    };

    FilesystemFileRead.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    FilesystemFileRead.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        {
            var error = $root.FilesystemFile.verify(message.file);
            if (error)
                return "file." + error;
        }
        if (message.chunk_len != null && message.hasOwnProperty("chunk_len"))
            if (!$util.isInteger(message.chunk_len))
                return "chunk_len: integer expected";
        if (message.ui_percentage != null && message.hasOwnProperty("ui_percentage"))
            if (!$util.isInteger(message.ui_percentage))
                return "ui_percentage: integer expected";
        return null;
    };

    FilesystemFileRead.fromObject = function fromObject(object) {
        if (object instanceof $root.FilesystemFileRead)
            return object;
        var message = new $root.FilesystemFileRead();
        if (object.file != null) {
            if (typeof object.file !== "object")
                throw TypeError(".FilesystemFileRead.file: object expected");
            message.file = $root.FilesystemFile.fromObject(object.file);
        }
        if (object.chunk_len != null)
            message.chunk_len = object.chunk_len >>> 0;
        if (object.ui_percentage != null)
            message.ui_percentage = object.ui_percentage >>> 0;
        return message;
    };

    FilesystemFileRead.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.file = null;
            object.chunk_len = 0;
            object.ui_percentage = 0;
        }
        if (message.file != null && message.hasOwnProperty("file"))
            object.file = $root.FilesystemFile.toObject(message.file, options);
        if (message.chunk_len != null && message.hasOwnProperty("chunk_len"))
            object.chunk_len = message.chunk_len;
        if (message.ui_percentage != null && message.hasOwnProperty("ui_percentage"))
            object.ui_percentage = message.ui_percentage;
        return object;
    };

    FilesystemFileRead.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return FilesystemFileRead;
})();

$root.FilesystemFileWrite = (function() {

    function FilesystemFileWrite(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    FilesystemFileWrite.prototype.file = null;
    FilesystemFileWrite.prototype.overwrite = false;
    FilesystemFileWrite.prototype.append = false;
    FilesystemFileWrite.prototype.ui_percentage = 0;

    FilesystemFileWrite.create = function create(properties) {
        return new FilesystemFileWrite(properties);
    };

    FilesystemFileWrite.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        $root.FilesystemFile.encode(message.file, writer.uint32(10).fork()).ldelim();
        writer.uint32(16).bool(message.overwrite);
        writer.uint32(24).bool(message.append);
        if (message.ui_percentage != null && Object.hasOwnProperty.call(message, "ui_percentage"))
            writer.uint32(32).uint32(message.ui_percentage);
        return writer;
    };

    FilesystemFileWrite.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    FilesystemFileWrite.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.FilesystemFileWrite();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.file = $root.FilesystemFile.decode(reader, reader.uint32());
                break;
            case 2:
                message.overwrite = reader.bool();
                break;
            case 3:
                message.append = reader.bool();
                break;
            case 4:
                message.ui_percentage = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("file"))
            throw $util.ProtocolError("missing required 'file'", { instance: message });
        if (!message.hasOwnProperty("overwrite"))
            throw $util.ProtocolError("missing required 'overwrite'", { instance: message });
        if (!message.hasOwnProperty("append"))
            throw $util.ProtocolError("missing required 'append'", { instance: message });
        return message;
    };

    FilesystemFileWrite.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    FilesystemFileWrite.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        {
            var error = $root.FilesystemFile.verify(message.file);
            if (error)
                return "file." + error;
        }
        if (typeof message.overwrite !== "boolean")
            return "overwrite: boolean expected";
        if (typeof message.append !== "boolean")
            return "append: boolean expected";
        if (message.ui_percentage != null && message.hasOwnProperty("ui_percentage"))
            if (!$util.isInteger(message.ui_percentage))
                return "ui_percentage: integer expected";
        return null;
    };

    FilesystemFileWrite.fromObject = function fromObject(object) {
        if (object instanceof $root.FilesystemFileWrite)
            return object;
        var message = new $root.FilesystemFileWrite();
        if (object.file != null) {
            if (typeof object.file !== "object")
                throw TypeError(".FilesystemFileWrite.file: object expected");
            message.file = $root.FilesystemFile.fromObject(object.file);
        }
        if (object.overwrite != null)
            message.overwrite = Boolean(object.overwrite);
        if (object.append != null)
            message.append = Boolean(object.append);
        if (object.ui_percentage != null)
            message.ui_percentage = object.ui_percentage >>> 0;
        return message;
    };

    FilesystemFileWrite.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.file = null;
            object.overwrite = false;
            object.append = false;
            object.ui_percentage = 0;
        }
        if (message.file != null && message.hasOwnProperty("file"))
            object.file = $root.FilesystemFile.toObject(message.file, options);
        if (message.overwrite != null && message.hasOwnProperty("overwrite"))
            object.overwrite = message.overwrite;
        if (message.append != null && message.hasOwnProperty("append"))
            object.append = message.append;
        if (message.ui_percentage != null && message.hasOwnProperty("ui_percentage"))
            object.ui_percentage = message.ui_percentage;
        return object;
    };

    FilesystemFileWrite.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return FilesystemFileWrite;
})();

$root.FilesystemFileDelete = (function() {

    function FilesystemFileDelete(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    FilesystemFileDelete.prototype.path = "";

    FilesystemFileDelete.create = function create(properties) {
        return new FilesystemFileDelete(properties);
    };

    FilesystemFileDelete.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.path);
        return writer;
    };

    FilesystemFileDelete.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    FilesystemFileDelete.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.FilesystemFileDelete();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.path = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("path"))
            throw $util.ProtocolError("missing required 'path'", { instance: message });
        return message;
    };

    FilesystemFileDelete.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    FilesystemFileDelete.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.path))
            return "path: string expected";
        return null;
    };

    FilesystemFileDelete.fromObject = function fromObject(object) {
        if (object instanceof $root.FilesystemFileDelete)
            return object;
        var message = new $root.FilesystemFileDelete();
        if (object.path != null)
            message.path = String(object.path);
        return message;
    };

    FilesystemFileDelete.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.path = "";
        if (message.path != null && message.hasOwnProperty("path"))
            object.path = message.path;
        return object;
    };

    FilesystemFileDelete.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return FilesystemFileDelete;
})();

$root.FilesystemDir = (function() {

    function FilesystemDir(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    FilesystemDir.prototype.path = "";
    FilesystemDir.prototype.child_dirs = "";
    FilesystemDir.prototype.child_files = "";

    FilesystemDir.create = function create(properties) {
        return new FilesystemDir(properties);
    };

    FilesystemDir.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.path);
        if (message.child_dirs != null && Object.hasOwnProperty.call(message, "child_dirs"))
            writer.uint32(18).string(message.child_dirs);
        if (message.child_files != null && Object.hasOwnProperty.call(message, "child_files"))
            writer.uint32(26).string(message.child_files);
        return writer;
    };

    FilesystemDir.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    FilesystemDir.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.FilesystemDir();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.path = reader.string();
                break;
            case 2:
                message.child_dirs = reader.string();
                break;
            case 3:
                message.child_files = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("path"))
            throw $util.ProtocolError("missing required 'path'", { instance: message });
        return message;
    };

    FilesystemDir.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    FilesystemDir.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.path))
            return "path: string expected";
        if (message.child_dirs != null && message.hasOwnProperty("child_dirs"))
            if (!$util.isString(message.child_dirs))
                return "child_dirs: string expected";
        if (message.child_files != null && message.hasOwnProperty("child_files"))
            if (!$util.isString(message.child_files))
                return "child_files: string expected";
        return null;
    };

    FilesystemDir.fromObject = function fromObject(object) {
        if (object instanceof $root.FilesystemDir)
            return object;
        var message = new $root.FilesystemDir();
        if (object.path != null)
            message.path = String(object.path);
        if (object.child_dirs != null)
            message.child_dirs = String(object.child_dirs);
        if (object.child_files != null)
            message.child_files = String(object.child_files);
        return message;
    };

    FilesystemDir.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.path = "";
            object.child_dirs = "";
            object.child_files = "";
        }
        if (message.path != null && message.hasOwnProperty("path"))
            object.path = message.path;
        if (message.child_dirs != null && message.hasOwnProperty("child_dirs"))
            object.child_dirs = message.child_dirs;
        if (message.child_files != null && message.hasOwnProperty("child_files"))
            object.child_files = message.child_files;
        return object;
    };

    FilesystemDir.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return FilesystemDir;
})();

$root.FilesystemDirList = (function() {

    function FilesystemDirList(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    FilesystemDirList.prototype.path = "";
    FilesystemDirList.prototype.depth = 0;

    FilesystemDirList.create = function create(properties) {
        return new FilesystemDirList(properties);
    };

    FilesystemDirList.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.path);
        if (message.depth != null && Object.hasOwnProperty.call(message, "depth"))
            writer.uint32(16).uint32(message.depth);
        return writer;
    };

    FilesystemDirList.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    FilesystemDirList.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.FilesystemDirList();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.path = reader.string();
                break;
            case 2:
                message.depth = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("path"))
            throw $util.ProtocolError("missing required 'path'", { instance: message });
        return message;
    };

    FilesystemDirList.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    FilesystemDirList.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.path))
            return "path: string expected";
        if (message.depth != null && message.hasOwnProperty("depth"))
            if (!$util.isInteger(message.depth))
                return "depth: integer expected";
        return null;
    };

    FilesystemDirList.fromObject = function fromObject(object) {
        if (object instanceof $root.FilesystemDirList)
            return object;
        var message = new $root.FilesystemDirList();
        if (object.path != null)
            message.path = String(object.path);
        if (object.depth != null)
            message.depth = object.depth >>> 0;
        return message;
    };

    FilesystemDirList.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.path = "";
            object.depth = 0;
        }
        if (message.path != null && message.hasOwnProperty("path"))
            object.path = message.path;
        if (message.depth != null && message.hasOwnProperty("depth"))
            object.depth = message.depth;
        return object;
    };

    FilesystemDirList.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return FilesystemDirList;
})();

$root.FilesystemDirMake = (function() {

    function FilesystemDirMake(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    FilesystemDirMake.prototype.path = "";

    FilesystemDirMake.create = function create(properties) {
        return new FilesystemDirMake(properties);
    };

    FilesystemDirMake.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.path);
        return writer;
    };

    FilesystemDirMake.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    FilesystemDirMake.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.FilesystemDirMake();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.path = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("path"))
            throw $util.ProtocolError("missing required 'path'", { instance: message });
        return message;
    };

    FilesystemDirMake.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    FilesystemDirMake.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.path))
            return "path: string expected";
        return null;
    };

    FilesystemDirMake.fromObject = function fromObject(object) {
        if (object instanceof $root.FilesystemDirMake)
            return object;
        var message = new $root.FilesystemDirMake();
        if (object.path != null)
            message.path = String(object.path);
        return message;
    };

    FilesystemDirMake.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.path = "";
        if (message.path != null && message.hasOwnProperty("path"))
            object.path = message.path;
        return object;
    };

    FilesystemDirMake.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return FilesystemDirMake;
})();

$root.FilesystemDirRemove = (function() {

    function FilesystemDirRemove(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    FilesystemDirRemove.prototype.path = "";

    FilesystemDirRemove.create = function create(properties) {
        return new FilesystemDirRemove(properties);
    };

    FilesystemDirRemove.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.path);
        return writer;
    };

    FilesystemDirRemove.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    FilesystemDirRemove.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.FilesystemDirRemove();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.path = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("path"))
            throw $util.ProtocolError("missing required 'path'", { instance: message });
        return message;
    };

    FilesystemDirRemove.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    FilesystemDirRemove.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.path))
            return "path: string expected";
        return null;
    };

    FilesystemDirRemove.fromObject = function fromObject(object) {
        if (object instanceof $root.FilesystemDirRemove)
            return object;
        var message = new $root.FilesystemDirRemove();
        if (object.path != null)
            message.path = String(object.path);
        return message;
    };

    FilesystemDirRemove.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.path = "";
        if (message.path != null && message.hasOwnProperty("path"))
            object.path = message.path;
        return object;
    };

    FilesystemDirRemove.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return FilesystemDirRemove;
})();

$root.FilesystemFormat = (function() {

    function FilesystemFormat(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    FilesystemFormat.prototype.data = false;
    FilesystemFormat.prototype.user = false;

    FilesystemFormat.create = function create(properties) {
        return new FilesystemFormat(properties);
    };

    FilesystemFormat.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).bool(message.data);
        writer.uint32(16).bool(message.user);
        return writer;
    };

    FilesystemFormat.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    FilesystemFormat.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.FilesystemFormat();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.data = reader.bool();
                break;
            case 2:
                message.user = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("data"))
            throw $util.ProtocolError("missing required 'data'", { instance: message });
        if (!message.hasOwnProperty("user"))
            throw $util.ProtocolError("missing required 'user'", { instance: message });
        return message;
    };

    FilesystemFormat.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    FilesystemFormat.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (typeof message.data !== "boolean")
            return "data: boolean expected";
        if (typeof message.user !== "boolean")
            return "user: boolean expected";
        return null;
    };

    FilesystemFormat.fromObject = function fromObject(object) {
        if (object instanceof $root.FilesystemFormat)
            return object;
        var message = new $root.FilesystemFormat();
        if (object.data != null)
            message.data = Boolean(object.data);
        if (object.user != null)
            message.user = Boolean(object.user);
        return message;
    };

    FilesystemFormat.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.data = false;
            object.user = false;
        }
        if (message.data != null && message.hasOwnProperty("data"))
            object.data = message.data;
        if (message.user != null && message.hasOwnProperty("user"))
            object.user = message.user;
        return object;
    };

    FilesystemFormat.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return FilesystemFormat;
})();

$root.InternalMyAddressRequest = (function() {

    function InternalMyAddressRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    InternalMyAddressRequest.prototype.coin_type = 0;
    InternalMyAddressRequest.prototype.chain_id = 0;
    InternalMyAddressRequest.prototype.account_index = 0;
    InternalMyAddressRequest.prototype.derive_type = 0;

    InternalMyAddressRequest.create = function create(properties) {
        return new InternalMyAddressRequest(properties);
    };

    InternalMyAddressRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).uint32(message.coin_type);
        writer.uint32(16).uint32(message.chain_id);
        writer.uint32(24).uint32(message.account_index);
        writer.uint32(32).uint32(message.derive_type);
        return writer;
    };

    InternalMyAddressRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    InternalMyAddressRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.InternalMyAddressRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.coin_type = reader.uint32();
                break;
            case 2:
                message.chain_id = reader.uint32();
                break;
            case 3:
                message.account_index = reader.uint32();
                break;
            case 4:
                message.derive_type = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("coin_type"))
            throw $util.ProtocolError("missing required 'coin_type'", { instance: message });
        if (!message.hasOwnProperty("chain_id"))
            throw $util.ProtocolError("missing required 'chain_id'", { instance: message });
        if (!message.hasOwnProperty("account_index"))
            throw $util.ProtocolError("missing required 'account_index'", { instance: message });
        if (!message.hasOwnProperty("derive_type"))
            throw $util.ProtocolError("missing required 'derive_type'", { instance: message });
        return message;
    };

    InternalMyAddressRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    InternalMyAddressRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isInteger(message.coin_type))
            return "coin_type: integer expected";
        if (!$util.isInteger(message.chain_id))
            return "chain_id: integer expected";
        if (!$util.isInteger(message.account_index))
            return "account_index: integer expected";
        if (!$util.isInteger(message.derive_type))
            return "derive_type: integer expected";
        return null;
    };

    InternalMyAddressRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.InternalMyAddressRequest)
            return object;
        var message = new $root.InternalMyAddressRequest();
        if (object.coin_type != null)
            message.coin_type = object.coin_type >>> 0;
        if (object.chain_id != null)
            message.chain_id = object.chain_id >>> 0;
        if (object.account_index != null)
            message.account_index = object.account_index >>> 0;
        if (object.derive_type != null)
            message.derive_type = object.derive_type >>> 0;
        return message;
    };

    InternalMyAddressRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.coin_type = 0;
            object.chain_id = 0;
            object.account_index = 0;
            object.derive_type = 0;
        }
        if (message.coin_type != null && message.hasOwnProperty("coin_type"))
            object.coin_type = message.coin_type;
        if (message.chain_id != null && message.hasOwnProperty("chain_id"))
            object.chain_id = message.chain_id;
        if (message.account_index != null && message.hasOwnProperty("account_index"))
            object.account_index = message.account_index;
        if (message.derive_type != null && message.hasOwnProperty("derive_type"))
            object.derive_type = message.derive_type;
        return object;
    };

    InternalMyAddressRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return InternalMyAddressRequest;
})();

$root.NftUpdate = (function() {

    function NftUpdate(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NftUpdate.prototype.file_name_no_ext = "";

    NftUpdate.create = function create(properties) {
        return new NftUpdate(properties);
    };

    NftUpdate.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.file_name_no_ext);
        return writer;
    };

    NftUpdate.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NftUpdate.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NftUpdate();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.file_name_no_ext = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("file_name_no_ext"))
            throw $util.ProtocolError("missing required 'file_name_no_ext'", { instance: message });
        return message;
    };

    NftUpdate.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NftUpdate.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.file_name_no_ext))
            return "file_name_no_ext: string expected";
        return null;
    };

    NftUpdate.fromObject = function fromObject(object) {
        if (object instanceof $root.NftUpdate)
            return object;
        var message = new $root.NftUpdate();
        if (object.file_name_no_ext != null)
            message.file_name_no_ext = String(object.file_name_no_ext);
        return message;
    };

    NftUpdate.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.file_name_no_ext = "";
        if (message.file_name_no_ext != null && message.hasOwnProperty("file_name_no_ext"))
            object.file_name_no_ext = message.file_name_no_ext;
        return object;
    };

    NftUpdate.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NftUpdate;
})();

$root.OnboardingStep = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "ONBOARDING_STEP_UNKNOWN"] = 0;
    values[valuesById[1] = "ONBOARDING_STEP_CHECKING"] = 1;
    values[valuesById[2] = "ONBOARDING_STEP_PERSONALIZATION"] = 2;
    values[valuesById[3] = "ONBOARDING_STEP_PIN"] = 3;
    values[valuesById[4] = "ONBOARDING_STEP_SETUP"] = 4;
    values[valuesById[5] = "ONBOARDING_STEP_DONE"] = 5;
    return values;
})();

$root.OnboardingPhase = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "ONBOARDING_PHASE_UNKNOWN"] = 0;
    values[valuesById[1] = "ONBOARDING_PHASE_SAFETY_CHECK"] = 1;
    values[valuesById[2] = "ONBOARDING_PHASE_PIN_SETUP"] = 2;
    values[valuesById[3] = "ONBOARDING_PHASE_FINGERPRINT_SETUP"] = 3;
    values[valuesById[4] = "ONBOARDING_PHASE_SETUP_CHOICE"] = 4;
    values[valuesById[5] = "ONBOARDING_PHASE_WALLET_CREATE_START"] = 5;
    values[valuesById[6] = "ONBOARDING_PHASE_RECOVERY_PHRASE_VIEW"] = 6;
    values[valuesById[7] = "ONBOARDING_PHASE_RECOVERY_PHRASE_CONFIRM"] = 7;
    values[valuesById[8] = "ONBOARDING_PHASE_RESTORE_METHOD_CHOICE"] = 8;
    values[valuesById[9] = "ONBOARDING_PHASE_RECOVERY_PHRASE_RESTORE"] = 9;
    values[valuesById[10] = "ONBOARDING_PHASE_SEEDCARD_RESTORE"] = 10;
    values[valuesById[11] = "ONBOARDING_PHASE_WALLET_READY"] = 11;
    values[valuesById[12] = "ONBOARDING_PHASE_SEEDCARD_BACKUP_PROMPT"] = 12;
    values[valuesById[13] = "ONBOARDING_PHASE_SEEDCARD_BACKUP"] = 13;
    return values;
})();

$root.OnboardingSetupKind = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "ONBOARDING_SETUP_KIND_UNKNOWN"] = 0;
    values[valuesById[1] = "ONBOARDING_SETUP_KIND_CHOICE"] = 1;
    values[valuesById[2] = "ONBOARDING_SETUP_KIND_CREATE"] = 2;
    values[valuesById[3] = "ONBOARDING_SETUP_KIND_RESTORE"] = 3;
    return values;
})();

$root.OnboardingSetupMethod = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "ONBOARDING_SETUP_METHOD_UNKNOWN"] = 0;
    values[valuesById[1] = "ONBOARDING_SETUP_METHOD_RECOVERY_PHRASE"] = 1;
    values[valuesById[2] = "ONBOARDING_SETUP_METHOD_SEEDCARD"] = 2;
    return values;
})();

$root.OnboardingSetupStatus = (function() {

    function OnboardingSetupStatus(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    OnboardingSetupStatus.prototype.kind = 0;
    OnboardingSetupStatus.prototype.method = 0;

    OnboardingSetupStatus.create = function create(properties) {
        return new OnboardingSetupStatus(properties);
    };

    OnboardingSetupStatus.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.kind != null && Object.hasOwnProperty.call(message, "kind"))
            writer.uint32(8).int32(message.kind);
        if (message.method != null && Object.hasOwnProperty.call(message, "method"))
            writer.uint32(16).int32(message.method);
        return writer;
    };

    OnboardingSetupStatus.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    OnboardingSetupStatus.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.OnboardingSetupStatus();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.kind = reader.int32();
                break;
            case 2:
                message.method = reader.int32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    OnboardingSetupStatus.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    OnboardingSetupStatus.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.kind != null && message.hasOwnProperty("kind"))
            switch (message.kind) {
            default:
                return "kind: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
                break;
            }
        if (message.method != null && message.hasOwnProperty("method"))
            switch (message.method) {
            default:
                return "method: enum value expected";
            case 0:
            case 1:
            case 2:
                break;
            }
        return null;
    };

    OnboardingSetupStatus.fromObject = function fromObject(object) {
        if (object instanceof $root.OnboardingSetupStatus)
            return object;
        var message = new $root.OnboardingSetupStatus();
        switch (object.kind) {
        case "ONBOARDING_SETUP_KIND_UNKNOWN":
        case 0:
            message.kind = 0;
            break;
        case "ONBOARDING_SETUP_KIND_CHOICE":
        case 1:
            message.kind = 1;
            break;
        case "ONBOARDING_SETUP_KIND_CREATE":
        case 2:
            message.kind = 2;
            break;
        case "ONBOARDING_SETUP_KIND_RESTORE":
        case 3:
            message.kind = 3;
            break;
        }
        switch (object.method) {
        case "ONBOARDING_SETUP_METHOD_UNKNOWN":
        case 0:
            message.method = 0;
            break;
        case "ONBOARDING_SETUP_METHOD_RECOVERY_PHRASE":
        case 1:
            message.method = 1;
            break;
        case "ONBOARDING_SETUP_METHOD_SEEDCARD":
        case 2:
            message.method = 2;
            break;
        }
        return message;
    };

    OnboardingSetupStatus.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.kind = options.enums === String ? "ONBOARDING_SETUP_KIND_UNKNOWN" : 0;
            object.method = options.enums === String ? "ONBOARDING_SETUP_METHOD_UNKNOWN" : 0;
        }
        if (message.kind != null && message.hasOwnProperty("kind"))
            object.kind = options.enums === String ? $root.OnboardingSetupKind[message.kind] : message.kind;
        if (message.method != null && message.hasOwnProperty("method"))
            object.method = options.enums === String ? $root.OnboardingSetupMethod[message.method] : message.method;
        return object;
    };

    OnboardingSetupStatus.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return OnboardingSetupStatus;
})();

$root.OnboardingStatusGet = (function() {

    function OnboardingStatusGet(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    OnboardingStatusGet.create = function create(properties) {
        return new OnboardingStatusGet(properties);
    };

    OnboardingStatusGet.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    OnboardingStatusGet.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    OnboardingStatusGet.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.OnboardingStatusGet();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    OnboardingStatusGet.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    OnboardingStatusGet.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    OnboardingStatusGet.fromObject = function fromObject(object) {
        if (object instanceof $root.OnboardingStatusGet)
            return object;
        return new $root.OnboardingStatusGet();
    };

    OnboardingStatusGet.toObject = function toObject() {
        return {};
    };

    OnboardingStatusGet.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return OnboardingStatusGet;
})();

$root.OnboardingStatus = (function() {

    function OnboardingStatus(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    OnboardingStatus.prototype.step = 0;
    OnboardingStatus.prototype.phase = 0;
    OnboardingStatus.prototype.setup = null;
    OnboardingStatus.prototype.pin_set = false;
    OnboardingStatus.prototype.wallet_initialized = false;

    OnboardingStatus.create = function create(properties) {
        return new OnboardingStatus(properties);
    };

    OnboardingStatus.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.step != null && Object.hasOwnProperty.call(message, "step"))
            writer.uint32(8).int32(message.step);
        if (message.phase != null && Object.hasOwnProperty.call(message, "phase"))
            writer.uint32(16).int32(message.phase);
        if (message.setup != null && Object.hasOwnProperty.call(message, "setup"))
            $root.OnboardingSetupStatus.encode(message.setup, writer.uint32(26).fork()).ldelim();
        if (message.pin_set != null && Object.hasOwnProperty.call(message, "pin_set"))
            writer.uint32(32).bool(message.pin_set);
        if (message.wallet_initialized != null && Object.hasOwnProperty.call(message, "wallet_initialized"))
            writer.uint32(40).bool(message.wallet_initialized);
        return writer;
    };

    OnboardingStatus.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    OnboardingStatus.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.OnboardingStatus();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.step = reader.int32();
                break;
            case 2:
                message.phase = reader.int32();
                break;
            case 3:
                message.setup = $root.OnboardingSetupStatus.decode(reader, reader.uint32());
                break;
            case 4:
                message.pin_set = reader.bool();
                break;
            case 5:
                message.wallet_initialized = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    OnboardingStatus.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    OnboardingStatus.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.step != null && message.hasOwnProperty("step"))
            switch (message.step) {
            default:
                return "step: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
                break;
            }
        if (message.phase != null && message.hasOwnProperty("phase"))
            switch (message.phase) {
            default:
                return "phase: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
            case 8:
            case 9:
            case 10:
            case 11:
            case 12:
            case 13:
                break;
            }
        if (message.setup != null && message.hasOwnProperty("setup")) {
            var error = $root.OnboardingSetupStatus.verify(message.setup);
            if (error)
                return "setup." + error;
        }
        if (message.pin_set != null && message.hasOwnProperty("pin_set"))
            if (typeof message.pin_set !== "boolean")
                return "pin_set: boolean expected";
        if (message.wallet_initialized != null && message.hasOwnProperty("wallet_initialized"))
            if (typeof message.wallet_initialized !== "boolean")
                return "wallet_initialized: boolean expected";
        return null;
    };

    OnboardingStatus.fromObject = function fromObject(object) {
        if (object instanceof $root.OnboardingStatus)
            return object;
        var message = new $root.OnboardingStatus();
        switch (object.step) {
        case "ONBOARDING_STEP_UNKNOWN":
        case 0:
            message.step = 0;
            break;
        case "ONBOARDING_STEP_CHECKING":
        case 1:
            message.step = 1;
            break;
        case "ONBOARDING_STEP_PERSONALIZATION":
        case 2:
            message.step = 2;
            break;
        case "ONBOARDING_STEP_PIN":
        case 3:
            message.step = 3;
            break;
        case "ONBOARDING_STEP_SETUP":
        case 4:
            message.step = 4;
            break;
        case "ONBOARDING_STEP_DONE":
        case 5:
            message.step = 5;
            break;
        }
        switch (object.phase) {
        case "ONBOARDING_PHASE_UNKNOWN":
        case 0:
            message.phase = 0;
            break;
        case "ONBOARDING_PHASE_SAFETY_CHECK":
        case 1:
            message.phase = 1;
            break;
        case "ONBOARDING_PHASE_PIN_SETUP":
        case 2:
            message.phase = 2;
            break;
        case "ONBOARDING_PHASE_FINGERPRINT_SETUP":
        case 3:
            message.phase = 3;
            break;
        case "ONBOARDING_PHASE_SETUP_CHOICE":
        case 4:
            message.phase = 4;
            break;
        case "ONBOARDING_PHASE_WALLET_CREATE_START":
        case 5:
            message.phase = 5;
            break;
        case "ONBOARDING_PHASE_RECOVERY_PHRASE_VIEW":
        case 6:
            message.phase = 6;
            break;
        case "ONBOARDING_PHASE_RECOVERY_PHRASE_CONFIRM":
        case 7:
            message.phase = 7;
            break;
        case "ONBOARDING_PHASE_RESTORE_METHOD_CHOICE":
        case 8:
            message.phase = 8;
            break;
        case "ONBOARDING_PHASE_RECOVERY_PHRASE_RESTORE":
        case 9:
            message.phase = 9;
            break;
        case "ONBOARDING_PHASE_SEEDCARD_RESTORE":
        case 10:
            message.phase = 10;
            break;
        case "ONBOARDING_PHASE_WALLET_READY":
        case 11:
            message.phase = 11;
            break;
        case "ONBOARDING_PHASE_SEEDCARD_BACKUP_PROMPT":
        case 12:
            message.phase = 12;
            break;
        case "ONBOARDING_PHASE_SEEDCARD_BACKUP":
        case 13:
            message.phase = 13;
            break;
        }
        if (object.setup != null) {
            if (typeof object.setup !== "object")
                throw TypeError(".OnboardingStatus.setup: object expected");
            message.setup = $root.OnboardingSetupStatus.fromObject(object.setup);
        }
        if (object.pin_set != null)
            message.pin_set = Boolean(object.pin_set);
        if (object.wallet_initialized != null)
            message.wallet_initialized = Boolean(object.wallet_initialized);
        return message;
    };

    OnboardingStatus.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.step = options.enums === String ? "ONBOARDING_STEP_UNKNOWN" : 0;
            object.phase = options.enums === String ? "ONBOARDING_PHASE_UNKNOWN" : 0;
            object.setup = null;
            object.pin_set = false;
            object.wallet_initialized = false;
        }
        if (message.step != null && message.hasOwnProperty("step"))
            object.step = options.enums === String ? $root.OnboardingStep[message.step] : message.step;
        if (message.phase != null && message.hasOwnProperty("phase"))
            object.phase = options.enums === String ? $root.OnboardingPhase[message.phase] : message.phase;
        if (message.setup != null && message.hasOwnProperty("setup"))
            object.setup = $root.OnboardingSetupStatus.toObject(message.setup, options);
        if (message.pin_set != null && message.hasOwnProperty("pin_set"))
            object.pin_set = message.pin_set;
        if (message.wallet_initialized != null && message.hasOwnProperty("wallet_initialized"))
            object.wallet_initialized = message.wallet_initialized;
        return object;
    };

    OnboardingStatus.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return OnboardingStatus;
})();

$root.PortfolioUpdate = (function() {

    function PortfolioUpdate(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    PortfolioUpdate.create = function create(properties) {
        return new PortfolioUpdate(properties);
    };

    PortfolioUpdate.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    PortfolioUpdate.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    PortfolioUpdate.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.PortfolioUpdate();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    PortfolioUpdate.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    PortfolioUpdate.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    PortfolioUpdate.fromObject = function fromObject(object) {
        if (object instanceof $root.PortfolioUpdate)
            return object;
        return new $root.PortfolioUpdate();
    };

    PortfolioUpdate.toObject = function toObject() {
        return {};
    };

    PortfolioUpdate.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return PortfolioUpdate;
})();

$root.ViewAmount = (function() {

    function ViewAmount(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ViewAmount.prototype.is_unlimited = false;
    ViewAmount.prototype.num = "";

    ViewAmount.create = function create(properties) {
        return new ViewAmount(properties);
    };

    ViewAmount.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).bool(message.is_unlimited);
        writer.uint32(18).string(message.num);
        return writer;
    };

    ViewAmount.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ViewAmount.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ViewAmount();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.is_unlimited = reader.bool();
                break;
            case 2:
                message.num = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("is_unlimited"))
            throw $util.ProtocolError("missing required 'is_unlimited'", { instance: message });
        if (!message.hasOwnProperty("num"))
            throw $util.ProtocolError("missing required 'num'", { instance: message });
        return message;
    };

    ViewAmount.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ViewAmount.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (typeof message.is_unlimited !== "boolean")
            return "is_unlimited: boolean expected";
        if (!$util.isString(message.num))
            return "num: string expected";
        return null;
    };

    ViewAmount.fromObject = function fromObject(object) {
        if (object instanceof $root.ViewAmount)
            return object;
        var message = new $root.ViewAmount();
        if (object.is_unlimited != null)
            message.is_unlimited = Boolean(object.is_unlimited);
        if (object.num != null)
            message.num = String(object.num);
        return message;
    };

    ViewAmount.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.is_unlimited = false;
            object.num = "";
        }
        if (message.is_unlimited != null && message.hasOwnProperty("is_unlimited"))
            object.is_unlimited = message.is_unlimited;
        if (message.num != null && message.hasOwnProperty("num"))
            object.num = message.num;
        return object;
    };

    ViewAmount.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ViewAmount;
})();

$root.ViewDetail = (function() {

    function ViewDetail(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ViewDetail.prototype.key = 0;
    ViewDetail.prototype.value = "";
    ViewDetail.prototype.is_overview = false;
    ViewDetail.prototype.has_icon = false;

    ViewDetail.create = function create(properties) {
        return new ViewDetail(properties);
    };

    ViewDetail.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).uint32(message.key);
        writer.uint32(18).string(message.value);
        writer.uint32(24).bool(message.is_overview);
        writer.uint32(32).bool(message.has_icon);
        return writer;
    };

    ViewDetail.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ViewDetail.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ViewDetail();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.key = reader.uint32();
                break;
            case 2:
                message.value = reader.string();
                break;
            case 3:
                message.is_overview = reader.bool();
                break;
            case 4:
                message.has_icon = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("key"))
            throw $util.ProtocolError("missing required 'key'", { instance: message });
        if (!message.hasOwnProperty("value"))
            throw $util.ProtocolError("missing required 'value'", { instance: message });
        if (!message.hasOwnProperty("is_overview"))
            throw $util.ProtocolError("missing required 'is_overview'", { instance: message });
        if (!message.hasOwnProperty("has_icon"))
            throw $util.ProtocolError("missing required 'has_icon'", { instance: message });
        return message;
    };

    ViewDetail.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ViewDetail.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isInteger(message.key))
            return "key: integer expected";
        if (!$util.isString(message.value))
            return "value: string expected";
        if (typeof message.is_overview !== "boolean")
            return "is_overview: boolean expected";
        if (typeof message.has_icon !== "boolean")
            return "has_icon: boolean expected";
        return null;
    };

    ViewDetail.fromObject = function fromObject(object) {
        if (object instanceof $root.ViewDetail)
            return object;
        var message = new $root.ViewDetail();
        if (object.key != null)
            message.key = object.key >>> 0;
        if (object.value != null)
            message.value = String(object.value);
        if (object.is_overview != null)
            message.is_overview = Boolean(object.is_overview);
        if (object.has_icon != null)
            message.has_icon = Boolean(object.has_icon);
        return message;
    };

    ViewDetail.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.key = 0;
            object.value = "";
            object.is_overview = false;
            object.has_icon = false;
        }
        if (message.key != null && message.hasOwnProperty("key"))
            object.key = message.key;
        if (message.value != null && message.hasOwnProperty("value"))
            object.value = message.value;
        if (message.is_overview != null && message.hasOwnProperty("is_overview"))
            object.is_overview = message.is_overview;
        if (message.has_icon != null && message.hasOwnProperty("has_icon"))
            object.has_icon = message.has_icon;
        return object;
    };

    ViewDetail.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ViewDetail;
})();

$root.ViewCustomField = (function() {

    function ViewCustomField(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ViewCustomField.prototype.key = "";
    ViewCustomField.prototype.value = "";

    ViewCustomField.create = function create(properties) {
        return new ViewCustomField(properties);
    };

    ViewCustomField.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.key);
        writer.uint32(18).string(message.value);
        return writer;
    };

    ViewCustomField.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ViewCustomField.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ViewCustomField();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.key = reader.string();
                break;
            case 2:
                message.value = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("key"))
            throw $util.ProtocolError("missing required 'key'", { instance: message });
        if (!message.hasOwnProperty("value"))
            throw $util.ProtocolError("missing required 'value'", { instance: message });
        return message;
    };

    ViewCustomField.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ViewCustomField.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.key))
            return "key: string expected";
        if (!$util.isString(message.value))
            return "value: string expected";
        return null;
    };

    ViewCustomField.fromObject = function fromObject(object) {
        if (object instanceof $root.ViewCustomField)
            return object;
        var message = new $root.ViewCustomField();
        if (object.key != null)
            message.key = String(object.key);
        if (object.value != null)
            message.value = String(object.value);
        return message;
    };

    ViewCustomField.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.key = "";
            object.value = "";
        }
        if (message.key != null && message.hasOwnProperty("key"))
            object.key = message.key;
        if (message.value != null && message.hasOwnProperty("value"))
            object.value = message.value;
        return object;
    };

    ViewCustomField.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ViewCustomField;
})();

$root.ViewTipType = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "Default"] = 0;
    values[valuesById[1] = "Highlight"] = 1;
    values[valuesById[2] = "Recommend"] = 2;
    values[valuesById[3] = "Warning"] = 3;
    values[valuesById[4] = "Danger"] = 4;
    return values;
})();

$root.ViewTip = (function() {

    function ViewTip(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ViewTip.prototype.type = 0;
    ViewTip.prototype.text = "";
    ViewTip.prototype.text_id = 0;
    ViewTip.prototype.text_arg = "";

    ViewTip.create = function create(properties) {
        return new ViewTip(properties);
    };

    ViewTip.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).int32(message.type);
        if (message.text != null && Object.hasOwnProperty.call(message, "text"))
            writer.uint32(18).string(message.text);
        if (message.text_id != null && Object.hasOwnProperty.call(message, "text_id"))
            writer.uint32(24).uint32(message.text_id);
        if (message.text_arg != null && Object.hasOwnProperty.call(message, "text_arg"))
            writer.uint32(34).string(message.text_arg);
        return writer;
    };

    ViewTip.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ViewTip.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ViewTip();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.type = reader.int32();
                break;
            case 2:
                message.text = reader.string();
                break;
            case 3:
                message.text_id = reader.uint32();
                break;
            case 4:
                message.text_arg = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("type"))
            throw $util.ProtocolError("missing required 'type'", { instance: message });
        return message;
    };

    ViewTip.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ViewTip.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        switch (message.type) {
        default:
            return "type: enum value expected";
        case 0:
        case 1:
        case 2:
        case 3:
        case 4:
            break;
        }
        if (message.text != null && message.hasOwnProperty("text"))
            if (!$util.isString(message.text))
                return "text: string expected";
        if (message.text_id != null && message.hasOwnProperty("text_id"))
            if (!$util.isInteger(message.text_id))
                return "text_id: integer expected";
        if (message.text_arg != null && message.hasOwnProperty("text_arg"))
            if (!$util.isString(message.text_arg))
                return "text_arg: string expected";
        return null;
    };

    ViewTip.fromObject = function fromObject(object) {
        if (object instanceof $root.ViewTip)
            return object;
        var message = new $root.ViewTip();
        switch (object.type) {
        case "Default":
        case 0:
            message.type = 0;
            break;
        case "Highlight":
        case 1:
            message.type = 1;
            break;
        case "Recommend":
        case 2:
            message.type = 2;
            break;
        case "Warning":
        case 3:
            message.type = 3;
            break;
        case "Danger":
        case 4:
            message.type = 4;
            break;
        }
        if (object.text != null)
            message.text = String(object.text);
        if (object.text_id != null)
            message.text_id = object.text_id >>> 0;
        if (object.text_arg != null)
            message.text_arg = String(object.text_arg);
        return message;
    };

    ViewTip.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.type = options.enums === String ? "Default" : 0;
            object.text = "";
            object.text_id = 0;
            object.text_arg = "";
        }
        if (message.type != null && message.hasOwnProperty("type"))
            object.type = options.enums === String ? $root.ViewTipType[message.type] : message.type;
        if (message.text != null && message.hasOwnProperty("text"))
            object.text = message.text;
        if (message.text_id != null && message.hasOwnProperty("text_id"))
            object.text_id = message.text_id;
        if (message.text_arg != null && message.hasOwnProperty("text_arg"))
            object.text_arg = message.text_arg;
        return object;
    };

    ViewTip.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ViewTip;
})();

$root.ViewActionCard = (function() {

    function ViewActionCard(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ViewActionCard.prototype.initial_data = "";

    ViewActionCard.create = function create(properties) {
        return new ViewActionCard(properties);
    };

    ViewActionCard.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(10).string(message.initial_data);
        return writer;
    };

    ViewActionCard.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ViewActionCard.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ViewActionCard();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.initial_data = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("initial_data"))
            throw $util.ProtocolError("missing required 'initial_data'", { instance: message });
        return message;
    };

    ViewActionCard.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ViewActionCard.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.initial_data))
            return "initial_data: string expected";
        return null;
    };

    ViewActionCard.fromObject = function fromObject(object) {
        if (object instanceof $root.ViewActionCard)
            return object;
        var message = new $root.ViewActionCard();
        if (object.initial_data != null)
            message.initial_data = String(object.initial_data);
        return message;
    };

    ViewActionCard.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.initial_data = "";
        if (message.initial_data != null && message.hasOwnProperty("initial_data"))
            object.initial_data = message.initial_data;
        return object;
    };

    ViewActionCard.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ViewActionCard;
})();

$root.ViewContentPreview = (function() {

    function ViewContentPreview(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ViewContentPreview.prototype.content_key = 0;
    ViewContentPreview.prototype.preview = $util.newBuffer([]);
    ViewContentPreview.prototype.total_bytes = 0;

    ViewContentPreview.create = function create(properties) {
        return new ViewContentPreview(properties);
    };

    ViewContentPreview.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).uint32(message.content_key);
        writer.uint32(18).bytes(message.preview);
        if (message.total_bytes != null && Object.hasOwnProperty.call(message, "total_bytes"))
            writer.uint32(24).uint32(message.total_bytes);
        return writer;
    };

    ViewContentPreview.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ViewContentPreview.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ViewContentPreview();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.content_key = reader.uint32();
                break;
            case 2:
                message.preview = reader.bytes();
                break;
            case 3:
                message.total_bytes = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("content_key"))
            throw $util.ProtocolError("missing required 'content_key'", { instance: message });
        if (!message.hasOwnProperty("preview"))
            throw $util.ProtocolError("missing required 'preview'", { instance: message });
        return message;
    };

    ViewContentPreview.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ViewContentPreview.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isInteger(message.content_key))
            return "content_key: integer expected";
        if (!(message.preview && typeof message.preview.length === "number" || $util.isString(message.preview)))
            return "preview: buffer expected";
        if (message.total_bytes != null && message.hasOwnProperty("total_bytes"))
            if (!$util.isInteger(message.total_bytes))
                return "total_bytes: integer expected";
        return null;
    };

    ViewContentPreview.fromObject = function fromObject(object) {
        if (object instanceof $root.ViewContentPreview)
            return object;
        var message = new $root.ViewContentPreview();
        if (object.content_key != null)
            message.content_key = object.content_key >>> 0;
        if (object.preview != null)
            if (typeof object.preview === "string")
                $util.base64.decode(object.preview, message.preview = $util.newBuffer($util.base64.length(object.preview)), 0);
            else if (object.preview.length)
                message.preview = object.preview;
        if (object.total_bytes != null)
            message.total_bytes = object.total_bytes >>> 0;
        return message;
    };

    ViewContentPreview.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.content_key = 0;
            if (options.bytes === String)
                object.preview = "";
            else {
                object.preview = [];
                if (options.bytes !== Array)
                    object.preview = $util.newBuffer(object.preview);
            }
            object.total_bytes = 0;
        }
        if (message.content_key != null && message.hasOwnProperty("content_key"))
            object.content_key = message.content_key;
        if (message.preview != null && message.hasOwnProperty("preview"))
            object.preview = options.bytes === String ? $util.base64.encode(message.preview, 0, message.preview.length) : options.bytes === Array ? Array.prototype.slice.call(message.preview) : message.preview;
        if (message.total_bytes != null && message.hasOwnProperty("total_bytes"))
            object.total_bytes = message.total_bytes;
        return object;
    };

    ViewContentPreview.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ViewContentPreview;
})();

$root.ViewContentEntry = (function() {

    function ViewContentEntry(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ViewContentEntry.prototype.entry_key = 0;
    ViewContentEntry.prototype.value = $util.newBuffer([]);

    ViewContentEntry.create = function create(properties) {
        return new ViewContentEntry(properties);
    };

    ViewContentEntry.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).uint32(message.entry_key);
        writer.uint32(18).bytes(message.value);
        return writer;
    };

    ViewContentEntry.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ViewContentEntry.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ViewContentEntry();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.entry_key = reader.uint32();
                break;
            case 2:
                message.value = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("entry_key"))
            throw $util.ProtocolError("missing required 'entry_key'", { instance: message });
        if (!message.hasOwnProperty("value"))
            throw $util.ProtocolError("missing required 'value'", { instance: message });
        return message;
    };

    ViewContentEntry.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ViewContentEntry.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isInteger(message.entry_key))
            return "entry_key: integer expected";
        if (!(message.value && typeof message.value.length === "number" || $util.isString(message.value)))
            return "value: buffer expected";
        return null;
    };

    ViewContentEntry.fromObject = function fromObject(object) {
        if (object instanceof $root.ViewContentEntry)
            return object;
        var message = new $root.ViewContentEntry();
        if (object.entry_key != null)
            message.entry_key = object.entry_key >>> 0;
        if (object.value != null)
            if (typeof object.value === "string")
                $util.base64.decode(object.value, message.value = $util.newBuffer($util.base64.length(object.value)), 0);
            else if (object.value.length)
                message.value = object.value;
        return message;
    };

    ViewContentEntry.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.entry_key = 0;
            if (options.bytes === String)
                object.value = "";
            else {
                object.value = [];
                if (options.bytes !== Array)
                    object.value = $util.newBuffer(object.value);
            }
        }
        if (message.entry_key != null && message.hasOwnProperty("entry_key"))
            object.entry_key = message.entry_key;
        if (message.value != null && message.hasOwnProperty("value"))
            object.value = options.bytes === String ? $util.base64.encode(message.value, 0, message.value.length) : options.bytes === Array ? Array.prototype.slice.call(message.value) : message.value;
        return object;
    };

    ViewContentEntry.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ViewContentEntry;
})();

$root.ViewContentPage = (function() {

    function ViewContentPage(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ViewContentPage.prototype.page_index = 0;
    ViewContentPage.prototype.page_count = 0;
    ViewContentPage.prototype.chunk = $util.newBuffer([]);
    ViewContentPage.prototype.entry = null;

    ViewContentPage.create = function create(properties) {
        return new ViewContentPage(properties);
    };

    ViewContentPage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).uint32(message.page_index);
        writer.uint32(16).uint32(message.page_count);
        if (message.chunk != null && Object.hasOwnProperty.call(message, "chunk"))
            writer.uint32(26).bytes(message.chunk);
        if (message.entry != null && Object.hasOwnProperty.call(message, "entry"))
            $root.ViewContentEntry.encode(message.entry, writer.uint32(34).fork()).ldelim();
        return writer;
    };

    ViewContentPage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ViewContentPage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ViewContentPage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.page_index = reader.uint32();
                break;
            case 2:
                message.page_count = reader.uint32();
                break;
            case 3:
                message.chunk = reader.bytes();
                break;
            case 4:
                message.entry = $root.ViewContentEntry.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("page_index"))
            throw $util.ProtocolError("missing required 'page_index'", { instance: message });
        if (!message.hasOwnProperty("page_count"))
            throw $util.ProtocolError("missing required 'page_count'", { instance: message });
        return message;
    };

    ViewContentPage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ViewContentPage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isInteger(message.page_index))
            return "page_index: integer expected";
        if (!$util.isInteger(message.page_count))
            return "page_count: integer expected";
        if (message.chunk != null && message.hasOwnProperty("chunk"))
            if (!(message.chunk && typeof message.chunk.length === "number" || $util.isString(message.chunk)))
                return "chunk: buffer expected";
        if (message.entry != null && message.hasOwnProperty("entry")) {
            var error = $root.ViewContentEntry.verify(message.entry);
            if (error)
                return "entry." + error;
        }
        return null;
    };

    ViewContentPage.fromObject = function fromObject(object) {
        if (object instanceof $root.ViewContentPage)
            return object;
        var message = new $root.ViewContentPage();
        if (object.page_index != null)
            message.page_index = object.page_index >>> 0;
        if (object.page_count != null)
            message.page_count = object.page_count >>> 0;
        if (object.chunk != null)
            if (typeof object.chunk === "string")
                $util.base64.decode(object.chunk, message.chunk = $util.newBuffer($util.base64.length(object.chunk)), 0);
            else if (object.chunk.length)
                message.chunk = object.chunk;
        if (object.entry != null) {
            if (typeof object.entry !== "object")
                throw TypeError(".ViewContentPage.entry: object expected");
            message.entry = $root.ViewContentEntry.fromObject(object.entry);
        }
        return message;
    };

    ViewContentPage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.page_index = 0;
            object.page_count = 0;
            if (options.bytes === String)
                object.chunk = "";
            else {
                object.chunk = [];
                if (options.bytes !== Array)
                    object.chunk = $util.newBuffer(object.chunk);
            }
            object.entry = null;
        }
        if (message.page_index != null && message.hasOwnProperty("page_index"))
            object.page_index = message.page_index;
        if (message.page_count != null && message.hasOwnProperty("page_count"))
            object.page_count = message.page_count;
        if (message.chunk != null && message.hasOwnProperty("chunk"))
            object.chunk = options.bytes === String ? $util.base64.encode(message.chunk, 0, message.chunk.length) : options.bytes === Array ? Array.prototype.slice.call(message.chunk) : message.chunk;
        if (message.entry != null && message.hasOwnProperty("entry"))
            object.entry = $root.ViewContentEntry.toObject(message.entry, options);
        return object;
    };

    ViewContentPage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ViewContentPage;
})();

$root.ViewSignLayout = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "LayoutDefault"] = 0;
    values[valuesById[1] = "LayoutSafeTxCreate"] = 1;
    values[valuesById[2] = "LayoutFinalConfirm"] = 2;
    values[valuesById[3] = "Layout7702"] = 3;
    values[valuesById[4] = "LayoutFlat"] = 4;
    values[valuesById[5] = "LayoutEthApprove"] = 5;
    return values;
})();

$root.ViewSignPage = (function() {

    function ViewSignPage(properties) {
        this.general = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ViewSignPage.prototype.title = "";
    ViewSignPage.prototype.amount = null;
    ViewSignPage.prototype.general = $util.emptyArray;
    ViewSignPage.prototype.tip = null;
    ViewSignPage.prototype.action_card = null;
    ViewSignPage.prototype.slide_to_confirm = true;
    ViewSignPage.prototype.layout = 0;
    ViewSignPage.prototype.title_id = 0;
    ViewSignPage.prototype.title_arg = "";
    ViewSignPage.prototype.content = null;
    ViewSignPage.prototype.custom_field = null;

    ViewSignPage.create = function create(properties) {
        return new ViewSignPage(properties);
    };

    ViewSignPage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.title != null && Object.hasOwnProperty.call(message, "title"))
            writer.uint32(10).string(message.title);
        if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
            $root.ViewAmount.encode(message.amount, writer.uint32(18).fork()).ldelim();
        if (message.general != null && message.general.length)
            for (var i = 0; i < message.general.length; ++i)
                $root.ViewDetail.encode(message.general[i], writer.uint32(26).fork()).ldelim();
        if (message.tip != null && Object.hasOwnProperty.call(message, "tip"))
            $root.ViewTip.encode(message.tip, writer.uint32(34).fork()).ldelim();
        if (message.action_card != null && Object.hasOwnProperty.call(message, "action_card"))
            $root.ViewActionCard.encode(message.action_card, writer.uint32(42).fork()).ldelim();
        if (message.slide_to_confirm != null && Object.hasOwnProperty.call(message, "slide_to_confirm"))
            writer.uint32(48).bool(message.slide_to_confirm);
        if (message.layout != null && Object.hasOwnProperty.call(message, "layout"))
            writer.uint32(56).int32(message.layout);
        if (message.title_id != null && Object.hasOwnProperty.call(message, "title_id"))
            writer.uint32(64).uint32(message.title_id);
        if (message.title_arg != null && Object.hasOwnProperty.call(message, "title_arg"))
            writer.uint32(74).string(message.title_arg);
        if (message.content != null && Object.hasOwnProperty.call(message, "content"))
            $root.ViewContentPreview.encode(message.content, writer.uint32(82).fork()).ldelim();
        if (message.custom_field != null && Object.hasOwnProperty.call(message, "custom_field"))
            $root.ViewCustomField.encode(message.custom_field, writer.uint32(90).fork()).ldelim();
        return writer;
    };

    ViewSignPage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ViewSignPage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ViewSignPage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.title = reader.string();
                break;
            case 2:
                message.amount = $root.ViewAmount.decode(reader, reader.uint32());
                break;
            case 3:
                if (!(message.general && message.general.length))
                    message.general = [];
                message.general.push($root.ViewDetail.decode(reader, reader.uint32()));
                break;
            case 4:
                message.tip = $root.ViewTip.decode(reader, reader.uint32());
                break;
            case 5:
                message.action_card = $root.ViewActionCard.decode(reader, reader.uint32());
                break;
            case 6:
                message.slide_to_confirm = reader.bool();
                break;
            case 7:
                message.layout = reader.int32();
                break;
            case 8:
                message.title_id = reader.uint32();
                break;
            case 9:
                message.title_arg = reader.string();
                break;
            case 10:
                message.content = $root.ViewContentPreview.decode(reader, reader.uint32());
                break;
            case 11:
                message.custom_field = $root.ViewCustomField.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    ViewSignPage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ViewSignPage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.title != null && message.hasOwnProperty("title"))
            if (!$util.isString(message.title))
                return "title: string expected";
        if (message.amount != null && message.hasOwnProperty("amount")) {
            var error = $root.ViewAmount.verify(message.amount);
            if (error)
                return "amount." + error;
        }
        if (message.general != null && message.hasOwnProperty("general")) {
            if (!Array.isArray(message.general))
                return "general: array expected";
            for (var i = 0; i < message.general.length; ++i) {
                var error = $root.ViewDetail.verify(message.general[i]);
                if (error)
                    return "general." + error;
            }
        }
        if (message.tip != null && message.hasOwnProperty("tip")) {
            var error = $root.ViewTip.verify(message.tip);
            if (error)
                return "tip." + error;
        }
        if (message.action_card != null && message.hasOwnProperty("action_card")) {
            var error = $root.ViewActionCard.verify(message.action_card);
            if (error)
                return "action_card." + error;
        }
        if (message.slide_to_confirm != null && message.hasOwnProperty("slide_to_confirm"))
            if (typeof message.slide_to_confirm !== "boolean")
                return "slide_to_confirm: boolean expected";
        if (message.layout != null && message.hasOwnProperty("layout"))
            switch (message.layout) {
            default:
                return "layout: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
                break;
            }
        if (message.title_id != null && message.hasOwnProperty("title_id"))
            if (!$util.isInteger(message.title_id))
                return "title_id: integer expected";
        if (message.title_arg != null && message.hasOwnProperty("title_arg"))
            if (!$util.isString(message.title_arg))
                return "title_arg: string expected";
        if (message.content != null && message.hasOwnProperty("content")) {
            var error = $root.ViewContentPreview.verify(message.content);
            if (error)
                return "content." + error;
        }
        if (message.custom_field != null && message.hasOwnProperty("custom_field")) {
            var error = $root.ViewCustomField.verify(message.custom_field);
            if (error)
                return "custom_field." + error;
        }
        return null;
    };

    ViewSignPage.fromObject = function fromObject(object) {
        if (object instanceof $root.ViewSignPage)
            return object;
        var message = new $root.ViewSignPage();
        if (object.title != null)
            message.title = String(object.title);
        if (object.amount != null) {
            if (typeof object.amount !== "object")
                throw TypeError(".ViewSignPage.amount: object expected");
            message.amount = $root.ViewAmount.fromObject(object.amount);
        }
        if (object.general) {
            if (!Array.isArray(object.general))
                throw TypeError(".ViewSignPage.general: array expected");
            message.general = [];
            for (var i = 0; i < object.general.length; ++i) {
                if (typeof object.general[i] !== "object")
                    throw TypeError(".ViewSignPage.general: object expected");
                message.general[i] = $root.ViewDetail.fromObject(object.general[i]);
            }
        }
        if (object.tip != null) {
            if (typeof object.tip !== "object")
                throw TypeError(".ViewSignPage.tip: object expected");
            message.tip = $root.ViewTip.fromObject(object.tip);
        }
        if (object.action_card != null) {
            if (typeof object.action_card !== "object")
                throw TypeError(".ViewSignPage.action_card: object expected");
            message.action_card = $root.ViewActionCard.fromObject(object.action_card);
        }
        if (object.slide_to_confirm != null)
            message.slide_to_confirm = Boolean(object.slide_to_confirm);
        switch (object.layout) {
        case "LayoutDefault":
        case 0:
            message.layout = 0;
            break;
        case "LayoutSafeTxCreate":
        case 1:
            message.layout = 1;
            break;
        case "LayoutFinalConfirm":
        case 2:
            message.layout = 2;
            break;
        case "Layout7702":
        case 3:
            message.layout = 3;
            break;
        case "LayoutFlat":
        case 4:
            message.layout = 4;
            break;
        case "LayoutEthApprove":
        case 5:
            message.layout = 5;
            break;
        }
        if (object.title_id != null)
            message.title_id = object.title_id >>> 0;
        if (object.title_arg != null)
            message.title_arg = String(object.title_arg);
        if (object.content != null) {
            if (typeof object.content !== "object")
                throw TypeError(".ViewSignPage.content: object expected");
            message.content = $root.ViewContentPreview.fromObject(object.content);
        }
        if (object.custom_field != null) {
            if (typeof object.custom_field !== "object")
                throw TypeError(".ViewSignPage.custom_field: object expected");
            message.custom_field = $root.ViewCustomField.fromObject(object.custom_field);
        }
        return message;
    };

    ViewSignPage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.general = [];
        if (options.defaults) {
            object.title = "";
            object.amount = null;
            object.tip = null;
            object.action_card = null;
            object.slide_to_confirm = true;
            object.layout = options.enums === String ? "LayoutDefault" : 0;
            object.title_id = 0;
            object.title_arg = "";
            object.content = null;
            object.custom_field = null;
        }
        if (message.title != null && message.hasOwnProperty("title"))
            object.title = message.title;
        if (message.amount != null && message.hasOwnProperty("amount"))
            object.amount = $root.ViewAmount.toObject(message.amount, options);
        if (message.general && message.general.length) {
            object.general = [];
            for (var j = 0; j < message.general.length; ++j)
                object.general[j] = $root.ViewDetail.toObject(message.general[j], options);
        }
        if (message.tip != null && message.hasOwnProperty("tip"))
            object.tip = $root.ViewTip.toObject(message.tip, options);
        if (message.action_card != null && message.hasOwnProperty("action_card"))
            object.action_card = $root.ViewActionCard.toObject(message.action_card, options);
        if (message.slide_to_confirm != null && message.hasOwnProperty("slide_to_confirm"))
            object.slide_to_confirm = message.slide_to_confirm;
        if (message.layout != null && message.hasOwnProperty("layout"))
            object.layout = options.enums === String ? $root.ViewSignLayout[message.layout] : message.layout;
        if (message.title_id != null && message.hasOwnProperty("title_id"))
            object.title_id = message.title_id;
        if (message.title_arg != null && message.hasOwnProperty("title_arg"))
            object.title_arg = message.title_arg;
        if (message.content != null && message.hasOwnProperty("content"))
            object.content = $root.ViewContentPreview.toObject(message.content, options);
        if (message.custom_field != null && message.hasOwnProperty("custom_field"))
            object.custom_field = $root.ViewCustomField.toObject(message.custom_field, options);
        return object;
    };

    ViewSignPage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ViewSignPage;
})();

$root.ViewWarningPage = (function() {

    function ViewWarningPage(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ViewWarningPage.prototype.title_id = 0;
    ViewWarningPage.prototype.text_id = 0;
    ViewWarningPage.prototype.text_arg = "";
    ViewWarningPage.prototype.cancellable = false;

    ViewWarningPage.create = function create(properties) {
        return new ViewWarningPage(properties);
    };

    ViewWarningPage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).uint32(message.title_id);
        writer.uint32(16).uint32(message.text_id);
        if (message.text_arg != null && Object.hasOwnProperty.call(message, "text_arg"))
            writer.uint32(26).string(message.text_arg);
        if (message.cancellable != null && Object.hasOwnProperty.call(message, "cancellable"))
            writer.uint32(32).bool(message.cancellable);
        return writer;
    };

    ViewWarningPage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ViewWarningPage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ViewWarningPage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.title_id = reader.uint32();
                break;
            case 2:
                message.text_id = reader.uint32();
                break;
            case 3:
                message.text_arg = reader.string();
                break;
            case 4:
                message.cancellable = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("title_id"))
            throw $util.ProtocolError("missing required 'title_id'", { instance: message });
        if (!message.hasOwnProperty("text_id"))
            throw $util.ProtocolError("missing required 'text_id'", { instance: message });
        return message;
    };

    ViewWarningPage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ViewWarningPage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isInteger(message.title_id))
            return "title_id: integer expected";
        if (!$util.isInteger(message.text_id))
            return "text_id: integer expected";
        if (message.text_arg != null && message.hasOwnProperty("text_arg"))
            if (!$util.isString(message.text_arg))
                return "text_arg: string expected";
        if (message.cancellable != null && message.hasOwnProperty("cancellable"))
            if (typeof message.cancellable !== "boolean")
                return "cancellable: boolean expected";
        return null;
    };

    ViewWarningPage.fromObject = function fromObject(object) {
        if (object instanceof $root.ViewWarningPage)
            return object;
        var message = new $root.ViewWarningPage();
        if (object.title_id != null)
            message.title_id = object.title_id >>> 0;
        if (object.text_id != null)
            message.text_id = object.text_id >>> 0;
        if (object.text_arg != null)
            message.text_arg = String(object.text_arg);
        if (object.cancellable != null)
            message.cancellable = Boolean(object.cancellable);
        return message;
    };

    ViewWarningPage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.title_id = 0;
            object.text_id = 0;
            object.text_arg = "";
            object.cancellable = false;
        }
        if (message.title_id != null && message.hasOwnProperty("title_id"))
            object.title_id = message.title_id;
        if (message.text_id != null && message.hasOwnProperty("text_id"))
            object.text_id = message.text_id;
        if (message.text_arg != null && message.hasOwnProperty("text_arg"))
            object.text_arg = message.text_arg;
        if (message.cancellable != null && message.hasOwnProperty("cancellable"))
            object.cancellable = message.cancellable;
        return object;
    };

    ViewWarningPage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ViewWarningPage;
})();

$root.ViewVerifyPage = (function() {

    function ViewVerifyPage(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ViewVerifyPage.prototype.title = "";
    ViewVerifyPage.prototype.address = "";
    ViewVerifyPage.prototype.path = "";
    ViewVerifyPage.prototype.network = "";
    ViewVerifyPage.prototype.derive_type = "";
    ViewVerifyPage.prototype.value_key = 0;
    ViewVerifyPage.prototype.title_id = 0;
    ViewVerifyPage.prototype.chain_id = 0;
    ViewVerifyPage.prototype.content = null;

    ViewVerifyPage.create = function create(properties) {
        return new ViewVerifyPage(properties);
    };

    ViewVerifyPage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.title != null && Object.hasOwnProperty.call(message, "title"))
            writer.uint32(10).string(message.title);
        writer.uint32(18).string(message.address);
        writer.uint32(26).string(message.path);
        if (message.network != null && Object.hasOwnProperty.call(message, "network"))
            writer.uint32(34).string(message.network);
        if (message.derive_type != null && Object.hasOwnProperty.call(message, "derive_type"))
            writer.uint32(42).string(message.derive_type);
        if (message.value_key != null && Object.hasOwnProperty.call(message, "value_key"))
            writer.uint32(48).uint32(message.value_key);
        if (message.title_id != null && Object.hasOwnProperty.call(message, "title_id"))
            writer.uint32(56).uint32(message.title_id);
        if (message.chain_id != null && Object.hasOwnProperty.call(message, "chain_id"))
            writer.uint32(64).uint32(message.chain_id);
        if (message.content != null && Object.hasOwnProperty.call(message, "content"))
            $root.ViewContentPreview.encode(message.content, writer.uint32(74).fork()).ldelim();
        return writer;
    };

    ViewVerifyPage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ViewVerifyPage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ViewVerifyPage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.title = reader.string();
                break;
            case 2:
                message.address = reader.string();
                break;
            case 3:
                message.path = reader.string();
                break;
            case 4:
                message.network = reader.string();
                break;
            case 5:
                message.derive_type = reader.string();
                break;
            case 6:
                message.value_key = reader.uint32();
                break;
            case 7:
                message.title_id = reader.uint32();
                break;
            case 8:
                message.chain_id = reader.uint32();
                break;
            case 9:
                message.content = $root.ViewContentPreview.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("address"))
            throw $util.ProtocolError("missing required 'address'", { instance: message });
        if (!message.hasOwnProperty("path"))
            throw $util.ProtocolError("missing required 'path'", { instance: message });
        return message;
    };

    ViewVerifyPage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ViewVerifyPage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.title != null && message.hasOwnProperty("title"))
            if (!$util.isString(message.title))
                return "title: string expected";
        if (!$util.isString(message.address))
            return "address: string expected";
        if (!$util.isString(message.path))
            return "path: string expected";
        if (message.network != null && message.hasOwnProperty("network"))
            if (!$util.isString(message.network))
                return "network: string expected";
        if (message.derive_type != null && message.hasOwnProperty("derive_type"))
            if (!$util.isString(message.derive_type))
                return "derive_type: string expected";
        if (message.value_key != null && message.hasOwnProperty("value_key"))
            if (!$util.isInteger(message.value_key))
                return "value_key: integer expected";
        if (message.title_id != null && message.hasOwnProperty("title_id"))
            if (!$util.isInteger(message.title_id))
                return "title_id: integer expected";
        if (message.chain_id != null && message.hasOwnProperty("chain_id"))
            if (!$util.isInteger(message.chain_id))
                return "chain_id: integer expected";
        if (message.content != null && message.hasOwnProperty("content")) {
            var error = $root.ViewContentPreview.verify(message.content);
            if (error)
                return "content." + error;
        }
        return null;
    };

    ViewVerifyPage.fromObject = function fromObject(object) {
        if (object instanceof $root.ViewVerifyPage)
            return object;
        var message = new $root.ViewVerifyPage();
        if (object.title != null)
            message.title = String(object.title);
        if (object.address != null)
            message.address = String(object.address);
        if (object.path != null)
            message.path = String(object.path);
        if (object.network != null)
            message.network = String(object.network);
        if (object.derive_type != null)
            message.derive_type = String(object.derive_type);
        if (object.value_key != null)
            message.value_key = object.value_key >>> 0;
        if (object.title_id != null)
            message.title_id = object.title_id >>> 0;
        if (object.chain_id != null)
            message.chain_id = object.chain_id >>> 0;
        if (object.content != null) {
            if (typeof object.content !== "object")
                throw TypeError(".ViewVerifyPage.content: object expected");
            message.content = $root.ViewContentPreview.fromObject(object.content);
        }
        return message;
    };

    ViewVerifyPage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.title = "";
            object.address = "";
            object.path = "";
            object.network = "";
            object.derive_type = "";
            object.value_key = 0;
            object.title_id = 0;
            object.chain_id = 0;
            object.content = null;
        }
        if (message.title != null && message.hasOwnProperty("title"))
            object.title = message.title;
        if (message.address != null && message.hasOwnProperty("address"))
            object.address = message.address;
        if (message.path != null && message.hasOwnProperty("path"))
            object.path = message.path;
        if (message.network != null && message.hasOwnProperty("network"))
            object.network = message.network;
        if (message.derive_type != null && message.hasOwnProperty("derive_type"))
            object.derive_type = message.derive_type;
        if (message.value_key != null && message.hasOwnProperty("value_key"))
            object.value_key = message.value_key;
        if (message.title_id != null && message.hasOwnProperty("title_id"))
            object.title_id = message.title_id;
        if (message.chain_id != null && message.hasOwnProperty("chain_id"))
            object.chain_id = message.chain_id;
        if (message.content != null && message.hasOwnProperty("content"))
            object.content = $root.ViewContentPreview.toObject(message.content, options);
        return object;
    };

    ViewVerifyPage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ViewVerifyPage;
})();

$root.google = (function() {

    var google = {};

    google.protobuf = (function() {

        var protobuf = {};

        protobuf.FileDescriptorSet = (function() {

            function FileDescriptorSet(properties) {
                this.file = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            FileDescriptorSet.prototype.file = $util.emptyArray;

            FileDescriptorSet.create = function create(properties) {
                return new FileDescriptorSet(properties);
            };

            FileDescriptorSet.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.file != null && message.file.length)
                    for (var i = 0; i < message.file.length; ++i)
                        $root.google.protobuf.FileDescriptorProto.encode(message.file[i], writer.uint32(10).fork()).ldelim();
                return writer;
            };

            FileDescriptorSet.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            FileDescriptorSet.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.FileDescriptorSet();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (!(message.file && message.file.length))
                            message.file = [];
                        message.file.push($root.google.protobuf.FileDescriptorProto.decode(reader, reader.uint32()));
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            FileDescriptorSet.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            FileDescriptorSet.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.file != null && message.hasOwnProperty("file")) {
                    if (!Array.isArray(message.file))
                        return "file: array expected";
                    for (var i = 0; i < message.file.length; ++i) {
                        var error = $root.google.protobuf.FileDescriptorProto.verify(message.file[i]);
                        if (error)
                            return "file." + error;
                    }
                }
                return null;
            };

            FileDescriptorSet.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.FileDescriptorSet)
                    return object;
                var message = new $root.google.protobuf.FileDescriptorSet();
                if (object.file) {
                    if (!Array.isArray(object.file))
                        throw TypeError(".google.protobuf.FileDescriptorSet.file: array expected");
                    message.file = [];
                    for (var i = 0; i < object.file.length; ++i) {
                        if (typeof object.file[i] !== "object")
                            throw TypeError(".google.protobuf.FileDescriptorSet.file: object expected");
                        message.file[i] = $root.google.protobuf.FileDescriptorProto.fromObject(object.file[i]);
                    }
                }
                return message;
            };

            FileDescriptorSet.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.file = [];
                if (message.file && message.file.length) {
                    object.file = [];
                    for (var j = 0; j < message.file.length; ++j)
                        object.file[j] = $root.google.protobuf.FileDescriptorProto.toObject(message.file[j], options);
                }
                return object;
            };

            FileDescriptorSet.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return FileDescriptorSet;
        })();

        protobuf.FileDescriptorProto = (function() {

            function FileDescriptorProto(properties) {
                this.dependency = [];
                this.public_dependency = [];
                this.weak_dependency = [];
                this.message_type = [];
                this.enum_type = [];
                this.service = [];
                this.extension = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            FileDescriptorProto.prototype.name = "";
            FileDescriptorProto.prototype["package"] = "";
            FileDescriptorProto.prototype.dependency = $util.emptyArray;
            FileDescriptorProto.prototype.public_dependency = $util.emptyArray;
            FileDescriptorProto.prototype.weak_dependency = $util.emptyArray;
            FileDescriptorProto.prototype.message_type = $util.emptyArray;
            FileDescriptorProto.prototype.enum_type = $util.emptyArray;
            FileDescriptorProto.prototype.service = $util.emptyArray;
            FileDescriptorProto.prototype.extension = $util.emptyArray;
            FileDescriptorProto.prototype.options = null;
            FileDescriptorProto.prototype.source_code_info = null;
            FileDescriptorProto.prototype.syntax = "";

            FileDescriptorProto.create = function create(properties) {
                return new FileDescriptorProto(properties);
            };

            FileDescriptorProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                    writer.uint32(10).string(message.name);
                if (message["package"] != null && Object.hasOwnProperty.call(message, "package"))
                    writer.uint32(18).string(message["package"]);
                if (message.dependency != null && message.dependency.length)
                    for (var i = 0; i < message.dependency.length; ++i)
                        writer.uint32(26).string(message.dependency[i]);
                if (message.message_type != null && message.message_type.length)
                    for (var i = 0; i < message.message_type.length; ++i)
                        $root.google.protobuf.DescriptorProto.encode(message.message_type[i], writer.uint32(34).fork()).ldelim();
                if (message.enum_type != null && message.enum_type.length)
                    for (var i = 0; i < message.enum_type.length; ++i)
                        $root.google.protobuf.EnumDescriptorProto.encode(message.enum_type[i], writer.uint32(42).fork()).ldelim();
                if (message.service != null && message.service.length)
                    for (var i = 0; i < message.service.length; ++i)
                        $root.google.protobuf.ServiceDescriptorProto.encode(message.service[i], writer.uint32(50).fork()).ldelim();
                if (message.extension != null && message.extension.length)
                    for (var i = 0; i < message.extension.length; ++i)
                        $root.google.protobuf.FieldDescriptorProto.encode(message.extension[i], writer.uint32(58).fork()).ldelim();
                if (message.options != null && Object.hasOwnProperty.call(message, "options"))
                    $root.google.protobuf.FileOptions.encode(message.options, writer.uint32(66).fork()).ldelim();
                if (message.source_code_info != null && Object.hasOwnProperty.call(message, "source_code_info"))
                    $root.google.protobuf.SourceCodeInfo.encode(message.source_code_info, writer.uint32(74).fork()).ldelim();
                if (message.public_dependency != null && message.public_dependency.length)
                    for (var i = 0; i < message.public_dependency.length; ++i)
                        writer.uint32(80).int32(message.public_dependency[i]);
                if (message.weak_dependency != null && message.weak_dependency.length)
                    for (var i = 0; i < message.weak_dependency.length; ++i)
                        writer.uint32(88).int32(message.weak_dependency[i]);
                if (message.syntax != null && Object.hasOwnProperty.call(message, "syntax"))
                    writer.uint32(98).string(message.syntax);
                return writer;
            };

            FileDescriptorProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            FileDescriptorProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.FileDescriptorProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.name = reader.string();
                        break;
                    case 2:
                        message["package"] = reader.string();
                        break;
                    case 3:
                        if (!(message.dependency && message.dependency.length))
                            message.dependency = [];
                        message.dependency.push(reader.string());
                        break;
                    case 10:
                        if (!(message.public_dependency && message.public_dependency.length))
                            message.public_dependency = [];
                        if ((tag & 7) === 2) {
                            var end2 = reader.uint32() + reader.pos;
                            while (reader.pos < end2)
                                message.public_dependency.push(reader.int32());
                        } else
                            message.public_dependency.push(reader.int32());
                        break;
                    case 11:
                        if (!(message.weak_dependency && message.weak_dependency.length))
                            message.weak_dependency = [];
                        if ((tag & 7) === 2) {
                            var end2 = reader.uint32() + reader.pos;
                            while (reader.pos < end2)
                                message.weak_dependency.push(reader.int32());
                        } else
                            message.weak_dependency.push(reader.int32());
                        break;
                    case 4:
                        if (!(message.message_type && message.message_type.length))
                            message.message_type = [];
                        message.message_type.push($root.google.protobuf.DescriptorProto.decode(reader, reader.uint32()));
                        break;
                    case 5:
                        if (!(message.enum_type && message.enum_type.length))
                            message.enum_type = [];
                        message.enum_type.push($root.google.protobuf.EnumDescriptorProto.decode(reader, reader.uint32()));
                        break;
                    case 6:
                        if (!(message.service && message.service.length))
                            message.service = [];
                        message.service.push($root.google.protobuf.ServiceDescriptorProto.decode(reader, reader.uint32()));
                        break;
                    case 7:
                        if (!(message.extension && message.extension.length))
                            message.extension = [];
                        message.extension.push($root.google.protobuf.FieldDescriptorProto.decode(reader, reader.uint32()));
                        break;
                    case 8:
                        message.options = $root.google.protobuf.FileOptions.decode(reader, reader.uint32());
                        break;
                    case 9:
                        message.source_code_info = $root.google.protobuf.SourceCodeInfo.decode(reader, reader.uint32());
                        break;
                    case 12:
                        message.syntax = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            FileDescriptorProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            FileDescriptorProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.name != null && message.hasOwnProperty("name"))
                    if (!$util.isString(message.name))
                        return "name: string expected";
                if (message["package"] != null && message.hasOwnProperty("package"))
                    if (!$util.isString(message["package"]))
                        return "package: string expected";
                if (message.dependency != null && message.hasOwnProperty("dependency")) {
                    if (!Array.isArray(message.dependency))
                        return "dependency: array expected";
                    for (var i = 0; i < message.dependency.length; ++i)
                        if (!$util.isString(message.dependency[i]))
                            return "dependency: string[] expected";
                }
                if (message.public_dependency != null && message.hasOwnProperty("public_dependency")) {
                    if (!Array.isArray(message.public_dependency))
                        return "public_dependency: array expected";
                    for (var i = 0; i < message.public_dependency.length; ++i)
                        if (!$util.isInteger(message.public_dependency[i]))
                            return "public_dependency: integer[] expected";
                }
                if (message.weak_dependency != null && message.hasOwnProperty("weak_dependency")) {
                    if (!Array.isArray(message.weak_dependency))
                        return "weak_dependency: array expected";
                    for (var i = 0; i < message.weak_dependency.length; ++i)
                        if (!$util.isInteger(message.weak_dependency[i]))
                            return "weak_dependency: integer[] expected";
                }
                if (message.message_type != null && message.hasOwnProperty("message_type")) {
                    if (!Array.isArray(message.message_type))
                        return "message_type: array expected";
                    for (var i = 0; i < message.message_type.length; ++i) {
                        var error = $root.google.protobuf.DescriptorProto.verify(message.message_type[i]);
                        if (error)
                            return "message_type." + error;
                    }
                }
                if (message.enum_type != null && message.hasOwnProperty("enum_type")) {
                    if (!Array.isArray(message.enum_type))
                        return "enum_type: array expected";
                    for (var i = 0; i < message.enum_type.length; ++i) {
                        var error = $root.google.protobuf.EnumDescriptorProto.verify(message.enum_type[i]);
                        if (error)
                            return "enum_type." + error;
                    }
                }
                if (message.service != null && message.hasOwnProperty("service")) {
                    if (!Array.isArray(message.service))
                        return "service: array expected";
                    for (var i = 0; i < message.service.length; ++i) {
                        var error = $root.google.protobuf.ServiceDescriptorProto.verify(message.service[i]);
                        if (error)
                            return "service." + error;
                    }
                }
                if (message.extension != null && message.hasOwnProperty("extension")) {
                    if (!Array.isArray(message.extension))
                        return "extension: array expected";
                    for (var i = 0; i < message.extension.length; ++i) {
                        var error = $root.google.protobuf.FieldDescriptorProto.verify(message.extension[i]);
                        if (error)
                            return "extension." + error;
                    }
                }
                if (message.options != null && message.hasOwnProperty("options")) {
                    var error = $root.google.protobuf.FileOptions.verify(message.options);
                    if (error)
                        return "options." + error;
                }
                if (message.source_code_info != null && message.hasOwnProperty("source_code_info")) {
                    var error = $root.google.protobuf.SourceCodeInfo.verify(message.source_code_info);
                    if (error)
                        return "source_code_info." + error;
                }
                if (message.syntax != null && message.hasOwnProperty("syntax"))
                    if (!$util.isString(message.syntax))
                        return "syntax: string expected";
                return null;
            };

            FileDescriptorProto.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.FileDescriptorProto)
                    return object;
                var message = new $root.google.protobuf.FileDescriptorProto();
                if (object.name != null)
                    message.name = String(object.name);
                if (object["package"] != null)
                    message["package"] = String(object["package"]);
                if (object.dependency) {
                    if (!Array.isArray(object.dependency))
                        throw TypeError(".google.protobuf.FileDescriptorProto.dependency: array expected");
                    message.dependency = [];
                    for (var i = 0; i < object.dependency.length; ++i)
                        message.dependency[i] = String(object.dependency[i]);
                }
                if (object.public_dependency) {
                    if (!Array.isArray(object.public_dependency))
                        throw TypeError(".google.protobuf.FileDescriptorProto.public_dependency: array expected");
                    message.public_dependency = [];
                    for (var i = 0; i < object.public_dependency.length; ++i)
                        message.public_dependency[i] = object.public_dependency[i] | 0;
                }
                if (object.weak_dependency) {
                    if (!Array.isArray(object.weak_dependency))
                        throw TypeError(".google.protobuf.FileDescriptorProto.weak_dependency: array expected");
                    message.weak_dependency = [];
                    for (var i = 0; i < object.weak_dependency.length; ++i)
                        message.weak_dependency[i] = object.weak_dependency[i] | 0;
                }
                if (object.message_type) {
                    if (!Array.isArray(object.message_type))
                        throw TypeError(".google.protobuf.FileDescriptorProto.message_type: array expected");
                    message.message_type = [];
                    for (var i = 0; i < object.message_type.length; ++i) {
                        if (typeof object.message_type[i] !== "object")
                            throw TypeError(".google.protobuf.FileDescriptorProto.message_type: object expected");
                        message.message_type[i] = $root.google.protobuf.DescriptorProto.fromObject(object.message_type[i]);
                    }
                }
                if (object.enum_type) {
                    if (!Array.isArray(object.enum_type))
                        throw TypeError(".google.protobuf.FileDescriptorProto.enum_type: array expected");
                    message.enum_type = [];
                    for (var i = 0; i < object.enum_type.length; ++i) {
                        if (typeof object.enum_type[i] !== "object")
                            throw TypeError(".google.protobuf.FileDescriptorProto.enum_type: object expected");
                        message.enum_type[i] = $root.google.protobuf.EnumDescriptorProto.fromObject(object.enum_type[i]);
                    }
                }
                if (object.service) {
                    if (!Array.isArray(object.service))
                        throw TypeError(".google.protobuf.FileDescriptorProto.service: array expected");
                    message.service = [];
                    for (var i = 0; i < object.service.length; ++i) {
                        if (typeof object.service[i] !== "object")
                            throw TypeError(".google.protobuf.FileDescriptorProto.service: object expected");
                        message.service[i] = $root.google.protobuf.ServiceDescriptorProto.fromObject(object.service[i]);
                    }
                }
                if (object.extension) {
                    if (!Array.isArray(object.extension))
                        throw TypeError(".google.protobuf.FileDescriptorProto.extension: array expected");
                    message.extension = [];
                    for (var i = 0; i < object.extension.length; ++i) {
                        if (typeof object.extension[i] !== "object")
                            throw TypeError(".google.protobuf.FileDescriptorProto.extension: object expected");
                        message.extension[i] = $root.google.protobuf.FieldDescriptorProto.fromObject(object.extension[i]);
                    }
                }
                if (object.options != null) {
                    if (typeof object.options !== "object")
                        throw TypeError(".google.protobuf.FileDescriptorProto.options: object expected");
                    message.options = $root.google.protobuf.FileOptions.fromObject(object.options);
                }
                if (object.source_code_info != null) {
                    if (typeof object.source_code_info !== "object")
                        throw TypeError(".google.protobuf.FileDescriptorProto.source_code_info: object expected");
                    message.source_code_info = $root.google.protobuf.SourceCodeInfo.fromObject(object.source_code_info);
                }
                if (object.syntax != null)
                    message.syntax = String(object.syntax);
                return message;
            };

            FileDescriptorProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults) {
                    object.dependency = [];
                    object.message_type = [];
                    object.enum_type = [];
                    object.service = [];
                    object.extension = [];
                    object.public_dependency = [];
                    object.weak_dependency = [];
                }
                if (options.defaults) {
                    object.name = "";
                    object["package"] = "";
                    object.options = null;
                    object.source_code_info = null;
                    object.syntax = "";
                }
                if (message.name != null && message.hasOwnProperty("name"))
                    object.name = message.name;
                if (message["package"] != null && message.hasOwnProperty("package"))
                    object["package"] = message["package"];
                if (message.dependency && message.dependency.length) {
                    object.dependency = [];
                    for (var j = 0; j < message.dependency.length; ++j)
                        object.dependency[j] = message.dependency[j];
                }
                if (message.message_type && message.message_type.length) {
                    object.message_type = [];
                    for (var j = 0; j < message.message_type.length; ++j)
                        object.message_type[j] = $root.google.protobuf.DescriptorProto.toObject(message.message_type[j], options);
                }
                if (message.enum_type && message.enum_type.length) {
                    object.enum_type = [];
                    for (var j = 0; j < message.enum_type.length; ++j)
                        object.enum_type[j] = $root.google.protobuf.EnumDescriptorProto.toObject(message.enum_type[j], options);
                }
                if (message.service && message.service.length) {
                    object.service = [];
                    for (var j = 0; j < message.service.length; ++j)
                        object.service[j] = $root.google.protobuf.ServiceDescriptorProto.toObject(message.service[j], options);
                }
                if (message.extension && message.extension.length) {
                    object.extension = [];
                    for (var j = 0; j < message.extension.length; ++j)
                        object.extension[j] = $root.google.protobuf.FieldDescriptorProto.toObject(message.extension[j], options);
                }
                if (message.options != null && message.hasOwnProperty("options"))
                    object.options = $root.google.protobuf.FileOptions.toObject(message.options, options);
                if (message.source_code_info != null && message.hasOwnProperty("source_code_info"))
                    object.source_code_info = $root.google.protobuf.SourceCodeInfo.toObject(message.source_code_info, options);
                if (message.public_dependency && message.public_dependency.length) {
                    object.public_dependency = [];
                    for (var j = 0; j < message.public_dependency.length; ++j)
                        object.public_dependency[j] = message.public_dependency[j];
                }
                if (message.weak_dependency && message.weak_dependency.length) {
                    object.weak_dependency = [];
                    for (var j = 0; j < message.weak_dependency.length; ++j)
                        object.weak_dependency[j] = message.weak_dependency[j];
                }
                if (message.syntax != null && message.hasOwnProperty("syntax"))
                    object.syntax = message.syntax;
                return object;
            };

            FileDescriptorProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return FileDescriptorProto;
        })();

        protobuf.DescriptorProto = (function() {

            function DescriptorProto(properties) {
                this.field = [];
                this.extension = [];
                this.nested_type = [];
                this.enum_type = [];
                this.extension_range = [];
                this.oneof_decl = [];
                this.reserved_range = [];
                this.reserved_name = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            DescriptorProto.prototype.name = "";
            DescriptorProto.prototype.field = $util.emptyArray;
            DescriptorProto.prototype.extension = $util.emptyArray;
            DescriptorProto.prototype.nested_type = $util.emptyArray;
            DescriptorProto.prototype.enum_type = $util.emptyArray;
            DescriptorProto.prototype.extension_range = $util.emptyArray;
            DescriptorProto.prototype.oneof_decl = $util.emptyArray;
            DescriptorProto.prototype.options = null;
            DescriptorProto.prototype.reserved_range = $util.emptyArray;
            DescriptorProto.prototype.reserved_name = $util.emptyArray;

            DescriptorProto.create = function create(properties) {
                return new DescriptorProto(properties);
            };

            DescriptorProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                    writer.uint32(10).string(message.name);
                if (message.field != null && message.field.length)
                    for (var i = 0; i < message.field.length; ++i)
                        $root.google.protobuf.FieldDescriptorProto.encode(message.field[i], writer.uint32(18).fork()).ldelim();
                if (message.nested_type != null && message.nested_type.length)
                    for (var i = 0; i < message.nested_type.length; ++i)
                        $root.google.protobuf.DescriptorProto.encode(message.nested_type[i], writer.uint32(26).fork()).ldelim();
                if (message.enum_type != null && message.enum_type.length)
                    for (var i = 0; i < message.enum_type.length; ++i)
                        $root.google.protobuf.EnumDescriptorProto.encode(message.enum_type[i], writer.uint32(34).fork()).ldelim();
                if (message.extension_range != null && message.extension_range.length)
                    for (var i = 0; i < message.extension_range.length; ++i)
                        $root.google.protobuf.DescriptorProto.ExtensionRange.encode(message.extension_range[i], writer.uint32(42).fork()).ldelim();
                if (message.extension != null && message.extension.length)
                    for (var i = 0; i < message.extension.length; ++i)
                        $root.google.protobuf.FieldDescriptorProto.encode(message.extension[i], writer.uint32(50).fork()).ldelim();
                if (message.options != null && Object.hasOwnProperty.call(message, "options"))
                    $root.google.protobuf.MessageOptions.encode(message.options, writer.uint32(58).fork()).ldelim();
                if (message.oneof_decl != null && message.oneof_decl.length)
                    for (var i = 0; i < message.oneof_decl.length; ++i)
                        $root.google.protobuf.OneofDescriptorProto.encode(message.oneof_decl[i], writer.uint32(66).fork()).ldelim();
                if (message.reserved_range != null && message.reserved_range.length)
                    for (var i = 0; i < message.reserved_range.length; ++i)
                        $root.google.protobuf.DescriptorProto.ReservedRange.encode(message.reserved_range[i], writer.uint32(74).fork()).ldelim();
                if (message.reserved_name != null && message.reserved_name.length)
                    for (var i = 0; i < message.reserved_name.length; ++i)
                        writer.uint32(82).string(message.reserved_name[i]);
                return writer;
            };

            DescriptorProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            DescriptorProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.DescriptorProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.name = reader.string();
                        break;
                    case 2:
                        if (!(message.field && message.field.length))
                            message.field = [];
                        message.field.push($root.google.protobuf.FieldDescriptorProto.decode(reader, reader.uint32()));
                        break;
                    case 6:
                        if (!(message.extension && message.extension.length))
                            message.extension = [];
                        message.extension.push($root.google.protobuf.FieldDescriptorProto.decode(reader, reader.uint32()));
                        break;
                    case 3:
                        if (!(message.nested_type && message.nested_type.length))
                            message.nested_type = [];
                        message.nested_type.push($root.google.protobuf.DescriptorProto.decode(reader, reader.uint32()));
                        break;
                    case 4:
                        if (!(message.enum_type && message.enum_type.length))
                            message.enum_type = [];
                        message.enum_type.push($root.google.protobuf.EnumDescriptorProto.decode(reader, reader.uint32()));
                        break;
                    case 5:
                        if (!(message.extension_range && message.extension_range.length))
                            message.extension_range = [];
                        message.extension_range.push($root.google.protobuf.DescriptorProto.ExtensionRange.decode(reader, reader.uint32()));
                        break;
                    case 8:
                        if (!(message.oneof_decl && message.oneof_decl.length))
                            message.oneof_decl = [];
                        message.oneof_decl.push($root.google.protobuf.OneofDescriptorProto.decode(reader, reader.uint32()));
                        break;
                    case 7:
                        message.options = $root.google.protobuf.MessageOptions.decode(reader, reader.uint32());
                        break;
                    case 9:
                        if (!(message.reserved_range && message.reserved_range.length))
                            message.reserved_range = [];
                        message.reserved_range.push($root.google.protobuf.DescriptorProto.ReservedRange.decode(reader, reader.uint32()));
                        break;
                    case 10:
                        if (!(message.reserved_name && message.reserved_name.length))
                            message.reserved_name = [];
                        message.reserved_name.push(reader.string());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            DescriptorProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            DescriptorProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.name != null && message.hasOwnProperty("name"))
                    if (!$util.isString(message.name))
                        return "name: string expected";
                if (message.field != null && message.hasOwnProperty("field")) {
                    if (!Array.isArray(message.field))
                        return "field: array expected";
                    for (var i = 0; i < message.field.length; ++i) {
                        var error = $root.google.protobuf.FieldDescriptorProto.verify(message.field[i]);
                        if (error)
                            return "field." + error;
                    }
                }
                if (message.extension != null && message.hasOwnProperty("extension")) {
                    if (!Array.isArray(message.extension))
                        return "extension: array expected";
                    for (var i = 0; i < message.extension.length; ++i) {
                        var error = $root.google.protobuf.FieldDescriptorProto.verify(message.extension[i]);
                        if (error)
                            return "extension." + error;
                    }
                }
                if (message.nested_type != null && message.hasOwnProperty("nested_type")) {
                    if (!Array.isArray(message.nested_type))
                        return "nested_type: array expected";
                    for (var i = 0; i < message.nested_type.length; ++i) {
                        var error = $root.google.protobuf.DescriptorProto.verify(message.nested_type[i]);
                        if (error)
                            return "nested_type." + error;
                    }
                }
                if (message.enum_type != null && message.hasOwnProperty("enum_type")) {
                    if (!Array.isArray(message.enum_type))
                        return "enum_type: array expected";
                    for (var i = 0; i < message.enum_type.length; ++i) {
                        var error = $root.google.protobuf.EnumDescriptorProto.verify(message.enum_type[i]);
                        if (error)
                            return "enum_type." + error;
                    }
                }
                if (message.extension_range != null && message.hasOwnProperty("extension_range")) {
                    if (!Array.isArray(message.extension_range))
                        return "extension_range: array expected";
                    for (var i = 0; i < message.extension_range.length; ++i) {
                        var error = $root.google.protobuf.DescriptorProto.ExtensionRange.verify(message.extension_range[i]);
                        if (error)
                            return "extension_range." + error;
                    }
                }
                if (message.oneof_decl != null && message.hasOwnProperty("oneof_decl")) {
                    if (!Array.isArray(message.oneof_decl))
                        return "oneof_decl: array expected";
                    for (var i = 0; i < message.oneof_decl.length; ++i) {
                        var error = $root.google.protobuf.OneofDescriptorProto.verify(message.oneof_decl[i]);
                        if (error)
                            return "oneof_decl." + error;
                    }
                }
                if (message.options != null && message.hasOwnProperty("options")) {
                    var error = $root.google.protobuf.MessageOptions.verify(message.options);
                    if (error)
                        return "options." + error;
                }
                if (message.reserved_range != null && message.hasOwnProperty("reserved_range")) {
                    if (!Array.isArray(message.reserved_range))
                        return "reserved_range: array expected";
                    for (var i = 0; i < message.reserved_range.length; ++i) {
                        var error = $root.google.protobuf.DescriptorProto.ReservedRange.verify(message.reserved_range[i]);
                        if (error)
                            return "reserved_range." + error;
                    }
                }
                if (message.reserved_name != null && message.hasOwnProperty("reserved_name")) {
                    if (!Array.isArray(message.reserved_name))
                        return "reserved_name: array expected";
                    for (var i = 0; i < message.reserved_name.length; ++i)
                        if (!$util.isString(message.reserved_name[i]))
                            return "reserved_name: string[] expected";
                }
                return null;
            };

            DescriptorProto.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.DescriptorProto)
                    return object;
                var message = new $root.google.protobuf.DescriptorProto();
                if (object.name != null)
                    message.name = String(object.name);
                if (object.field) {
                    if (!Array.isArray(object.field))
                        throw TypeError(".google.protobuf.DescriptorProto.field: array expected");
                    message.field = [];
                    for (var i = 0; i < object.field.length; ++i) {
                        if (typeof object.field[i] !== "object")
                            throw TypeError(".google.protobuf.DescriptorProto.field: object expected");
                        message.field[i] = $root.google.protobuf.FieldDescriptorProto.fromObject(object.field[i]);
                    }
                }
                if (object.extension) {
                    if (!Array.isArray(object.extension))
                        throw TypeError(".google.protobuf.DescriptorProto.extension: array expected");
                    message.extension = [];
                    for (var i = 0; i < object.extension.length; ++i) {
                        if (typeof object.extension[i] !== "object")
                            throw TypeError(".google.protobuf.DescriptorProto.extension: object expected");
                        message.extension[i] = $root.google.protobuf.FieldDescriptorProto.fromObject(object.extension[i]);
                    }
                }
                if (object.nested_type) {
                    if (!Array.isArray(object.nested_type))
                        throw TypeError(".google.protobuf.DescriptorProto.nested_type: array expected");
                    message.nested_type = [];
                    for (var i = 0; i < object.nested_type.length; ++i) {
                        if (typeof object.nested_type[i] !== "object")
                            throw TypeError(".google.protobuf.DescriptorProto.nested_type: object expected");
                        message.nested_type[i] = $root.google.protobuf.DescriptorProto.fromObject(object.nested_type[i]);
                    }
                }
                if (object.enum_type) {
                    if (!Array.isArray(object.enum_type))
                        throw TypeError(".google.protobuf.DescriptorProto.enum_type: array expected");
                    message.enum_type = [];
                    for (var i = 0; i < object.enum_type.length; ++i) {
                        if (typeof object.enum_type[i] !== "object")
                            throw TypeError(".google.protobuf.DescriptorProto.enum_type: object expected");
                        message.enum_type[i] = $root.google.protobuf.EnumDescriptorProto.fromObject(object.enum_type[i]);
                    }
                }
                if (object.extension_range) {
                    if (!Array.isArray(object.extension_range))
                        throw TypeError(".google.protobuf.DescriptorProto.extension_range: array expected");
                    message.extension_range = [];
                    for (var i = 0; i < object.extension_range.length; ++i) {
                        if (typeof object.extension_range[i] !== "object")
                            throw TypeError(".google.protobuf.DescriptorProto.extension_range: object expected");
                        message.extension_range[i] = $root.google.protobuf.DescriptorProto.ExtensionRange.fromObject(object.extension_range[i]);
                    }
                }
                if (object.oneof_decl) {
                    if (!Array.isArray(object.oneof_decl))
                        throw TypeError(".google.protobuf.DescriptorProto.oneof_decl: array expected");
                    message.oneof_decl = [];
                    for (var i = 0; i < object.oneof_decl.length; ++i) {
                        if (typeof object.oneof_decl[i] !== "object")
                            throw TypeError(".google.protobuf.DescriptorProto.oneof_decl: object expected");
                        message.oneof_decl[i] = $root.google.protobuf.OneofDescriptorProto.fromObject(object.oneof_decl[i]);
                    }
                }
                if (object.options != null) {
                    if (typeof object.options !== "object")
                        throw TypeError(".google.protobuf.DescriptorProto.options: object expected");
                    message.options = $root.google.protobuf.MessageOptions.fromObject(object.options);
                }
                if (object.reserved_range) {
                    if (!Array.isArray(object.reserved_range))
                        throw TypeError(".google.protobuf.DescriptorProto.reserved_range: array expected");
                    message.reserved_range = [];
                    for (var i = 0; i < object.reserved_range.length; ++i) {
                        if (typeof object.reserved_range[i] !== "object")
                            throw TypeError(".google.protobuf.DescriptorProto.reserved_range: object expected");
                        message.reserved_range[i] = $root.google.protobuf.DescriptorProto.ReservedRange.fromObject(object.reserved_range[i]);
                    }
                }
                if (object.reserved_name) {
                    if (!Array.isArray(object.reserved_name))
                        throw TypeError(".google.protobuf.DescriptorProto.reserved_name: array expected");
                    message.reserved_name = [];
                    for (var i = 0; i < object.reserved_name.length; ++i)
                        message.reserved_name[i] = String(object.reserved_name[i]);
                }
                return message;
            };

            DescriptorProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults) {
                    object.field = [];
                    object.nested_type = [];
                    object.enum_type = [];
                    object.extension_range = [];
                    object.extension = [];
                    object.oneof_decl = [];
                    object.reserved_range = [];
                    object.reserved_name = [];
                }
                if (options.defaults) {
                    object.name = "";
                    object.options = null;
                }
                if (message.name != null && message.hasOwnProperty("name"))
                    object.name = message.name;
                if (message.field && message.field.length) {
                    object.field = [];
                    for (var j = 0; j < message.field.length; ++j)
                        object.field[j] = $root.google.protobuf.FieldDescriptorProto.toObject(message.field[j], options);
                }
                if (message.nested_type && message.nested_type.length) {
                    object.nested_type = [];
                    for (var j = 0; j < message.nested_type.length; ++j)
                        object.nested_type[j] = $root.google.protobuf.DescriptorProto.toObject(message.nested_type[j], options);
                }
                if (message.enum_type && message.enum_type.length) {
                    object.enum_type = [];
                    for (var j = 0; j < message.enum_type.length; ++j)
                        object.enum_type[j] = $root.google.protobuf.EnumDescriptorProto.toObject(message.enum_type[j], options);
                }
                if (message.extension_range && message.extension_range.length) {
                    object.extension_range = [];
                    for (var j = 0; j < message.extension_range.length; ++j)
                        object.extension_range[j] = $root.google.protobuf.DescriptorProto.ExtensionRange.toObject(message.extension_range[j], options);
                }
                if (message.extension && message.extension.length) {
                    object.extension = [];
                    for (var j = 0; j < message.extension.length; ++j)
                        object.extension[j] = $root.google.protobuf.FieldDescriptorProto.toObject(message.extension[j], options);
                }
                if (message.options != null && message.hasOwnProperty("options"))
                    object.options = $root.google.protobuf.MessageOptions.toObject(message.options, options);
                if (message.oneof_decl && message.oneof_decl.length) {
                    object.oneof_decl = [];
                    for (var j = 0; j < message.oneof_decl.length; ++j)
                        object.oneof_decl[j] = $root.google.protobuf.OneofDescriptorProto.toObject(message.oneof_decl[j], options);
                }
                if (message.reserved_range && message.reserved_range.length) {
                    object.reserved_range = [];
                    for (var j = 0; j < message.reserved_range.length; ++j)
                        object.reserved_range[j] = $root.google.protobuf.DescriptorProto.ReservedRange.toObject(message.reserved_range[j], options);
                }
                if (message.reserved_name && message.reserved_name.length) {
                    object.reserved_name = [];
                    for (var j = 0; j < message.reserved_name.length; ++j)
                        object.reserved_name[j] = message.reserved_name[j];
                }
                return object;
            };

            DescriptorProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            DescriptorProto.ExtensionRange = (function() {

                function ExtensionRange(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                ExtensionRange.prototype.start = 0;
                ExtensionRange.prototype.end = 0;

                ExtensionRange.create = function create(properties) {
                    return new ExtensionRange(properties);
                };

                ExtensionRange.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.start != null && Object.hasOwnProperty.call(message, "start"))
                        writer.uint32(8).int32(message.start);
                    if (message.end != null && Object.hasOwnProperty.call(message, "end"))
                        writer.uint32(16).int32(message.end);
                    return writer;
                };

                ExtensionRange.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                ExtensionRange.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.DescriptorProto.ExtensionRange();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.start = reader.int32();
                            break;
                        case 2:
                            message.end = reader.int32();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                ExtensionRange.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                ExtensionRange.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.start != null && message.hasOwnProperty("start"))
                        if (!$util.isInteger(message.start))
                            return "start: integer expected";
                    if (message.end != null && message.hasOwnProperty("end"))
                        if (!$util.isInteger(message.end))
                            return "end: integer expected";
                    return null;
                };

                ExtensionRange.fromObject = function fromObject(object) {
                    if (object instanceof $root.google.protobuf.DescriptorProto.ExtensionRange)
                        return object;
                    var message = new $root.google.protobuf.DescriptorProto.ExtensionRange();
                    if (object.start != null)
                        message.start = object.start | 0;
                    if (object.end != null)
                        message.end = object.end | 0;
                    return message;
                };

                ExtensionRange.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.start = 0;
                        object.end = 0;
                    }
                    if (message.start != null && message.hasOwnProperty("start"))
                        object.start = message.start;
                    if (message.end != null && message.hasOwnProperty("end"))
                        object.end = message.end;
                    return object;
                };

                ExtensionRange.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return ExtensionRange;
            })();

            DescriptorProto.ReservedRange = (function() {

                function ReservedRange(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                ReservedRange.prototype.start = 0;
                ReservedRange.prototype.end = 0;

                ReservedRange.create = function create(properties) {
                    return new ReservedRange(properties);
                };

                ReservedRange.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.start != null && Object.hasOwnProperty.call(message, "start"))
                        writer.uint32(8).int32(message.start);
                    if (message.end != null && Object.hasOwnProperty.call(message, "end"))
                        writer.uint32(16).int32(message.end);
                    return writer;
                };

                ReservedRange.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                ReservedRange.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.DescriptorProto.ReservedRange();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.start = reader.int32();
                            break;
                        case 2:
                            message.end = reader.int32();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                ReservedRange.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                ReservedRange.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.start != null && message.hasOwnProperty("start"))
                        if (!$util.isInteger(message.start))
                            return "start: integer expected";
                    if (message.end != null && message.hasOwnProperty("end"))
                        if (!$util.isInteger(message.end))
                            return "end: integer expected";
                    return null;
                };

                ReservedRange.fromObject = function fromObject(object) {
                    if (object instanceof $root.google.protobuf.DescriptorProto.ReservedRange)
                        return object;
                    var message = new $root.google.protobuf.DescriptorProto.ReservedRange();
                    if (object.start != null)
                        message.start = object.start | 0;
                    if (object.end != null)
                        message.end = object.end | 0;
                    return message;
                };

                ReservedRange.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.start = 0;
                        object.end = 0;
                    }
                    if (message.start != null && message.hasOwnProperty("start"))
                        object.start = message.start;
                    if (message.end != null && message.hasOwnProperty("end"))
                        object.end = message.end;
                    return object;
                };

                ReservedRange.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return ReservedRange;
            })();

            return DescriptorProto;
        })();

        protobuf.FieldDescriptorProto = (function() {

            function FieldDescriptorProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            FieldDescriptorProto.prototype.name = "";
            FieldDescriptorProto.prototype.number = 0;
            FieldDescriptorProto.prototype.label = 1;
            FieldDescriptorProto.prototype.type = 1;
            FieldDescriptorProto.prototype.type_name = "";
            FieldDescriptorProto.prototype.extendee = "";
            FieldDescriptorProto.prototype.default_value = "";
            FieldDescriptorProto.prototype.oneof_index = 0;
            FieldDescriptorProto.prototype.json_name = "";
            FieldDescriptorProto.prototype.options = null;

            FieldDescriptorProto.create = function create(properties) {
                return new FieldDescriptorProto(properties);
            };

            FieldDescriptorProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                    writer.uint32(10).string(message.name);
                if (message.extendee != null && Object.hasOwnProperty.call(message, "extendee"))
                    writer.uint32(18).string(message.extendee);
                if (message.number != null && Object.hasOwnProperty.call(message, "number"))
                    writer.uint32(24).int32(message.number);
                if (message.label != null && Object.hasOwnProperty.call(message, "label"))
                    writer.uint32(32).int32(message.label);
                if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                    writer.uint32(40).int32(message.type);
                if (message.type_name != null && Object.hasOwnProperty.call(message, "type_name"))
                    writer.uint32(50).string(message.type_name);
                if (message.default_value != null && Object.hasOwnProperty.call(message, "default_value"))
                    writer.uint32(58).string(message.default_value);
                if (message.options != null && Object.hasOwnProperty.call(message, "options"))
                    $root.google.protobuf.FieldOptions.encode(message.options, writer.uint32(66).fork()).ldelim();
                if (message.oneof_index != null && Object.hasOwnProperty.call(message, "oneof_index"))
                    writer.uint32(72).int32(message.oneof_index);
                if (message.json_name != null && Object.hasOwnProperty.call(message, "json_name"))
                    writer.uint32(82).string(message.json_name);
                return writer;
            };

            FieldDescriptorProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            FieldDescriptorProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.FieldDescriptorProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.name = reader.string();
                        break;
                    case 3:
                        message.number = reader.int32();
                        break;
                    case 4:
                        message.label = reader.int32();
                        break;
                    case 5:
                        message.type = reader.int32();
                        break;
                    case 6:
                        message.type_name = reader.string();
                        break;
                    case 2:
                        message.extendee = reader.string();
                        break;
                    case 7:
                        message.default_value = reader.string();
                        break;
                    case 9:
                        message.oneof_index = reader.int32();
                        break;
                    case 10:
                        message.json_name = reader.string();
                        break;
                    case 8:
                        message.options = $root.google.protobuf.FieldOptions.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            FieldDescriptorProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            FieldDescriptorProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.name != null && message.hasOwnProperty("name"))
                    if (!$util.isString(message.name))
                        return "name: string expected";
                if (message.number != null && message.hasOwnProperty("number"))
                    if (!$util.isInteger(message.number))
                        return "number: integer expected";
                if (message.label != null && message.hasOwnProperty("label"))
                    switch (message.label) {
                    default:
                        return "label: enum value expected";
                    case 1:
                    case 2:
                    case 3:
                        break;
                    }
                if (message.type != null && message.hasOwnProperty("type"))
                    switch (message.type) {
                    default:
                        return "type: enum value expected";
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                    case 6:
                    case 7:
                    case 8:
                    case 9:
                    case 10:
                    case 11:
                    case 12:
                    case 13:
                    case 14:
                    case 15:
                    case 16:
                    case 17:
                    case 18:
                        break;
                    }
                if (message.type_name != null && message.hasOwnProperty("type_name"))
                    if (!$util.isString(message.type_name))
                        return "type_name: string expected";
                if (message.extendee != null && message.hasOwnProperty("extendee"))
                    if (!$util.isString(message.extendee))
                        return "extendee: string expected";
                if (message.default_value != null && message.hasOwnProperty("default_value"))
                    if (!$util.isString(message.default_value))
                        return "default_value: string expected";
                if (message.oneof_index != null && message.hasOwnProperty("oneof_index"))
                    if (!$util.isInteger(message.oneof_index))
                        return "oneof_index: integer expected";
                if (message.json_name != null && message.hasOwnProperty("json_name"))
                    if (!$util.isString(message.json_name))
                        return "json_name: string expected";
                if (message.options != null && message.hasOwnProperty("options")) {
                    var error = $root.google.protobuf.FieldOptions.verify(message.options);
                    if (error)
                        return "options." + error;
                }
                return null;
            };

            FieldDescriptorProto.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.FieldDescriptorProto)
                    return object;
                var message = new $root.google.protobuf.FieldDescriptorProto();
                if (object.name != null)
                    message.name = String(object.name);
                if (object.number != null)
                    message.number = object.number | 0;
                switch (object.label) {
                case "LABEL_OPTIONAL":
                case 1:
                    message.label = 1;
                    break;
                case "LABEL_REQUIRED":
                case 2:
                    message.label = 2;
                    break;
                case "LABEL_REPEATED":
                case 3:
                    message.label = 3;
                    break;
                }
                switch (object.type) {
                case "TYPE_DOUBLE":
                case 1:
                    message.type = 1;
                    break;
                case "TYPE_FLOAT":
                case 2:
                    message.type = 2;
                    break;
                case "TYPE_INT64":
                case 3:
                    message.type = 3;
                    break;
                case "TYPE_UINT64":
                case 4:
                    message.type = 4;
                    break;
                case "TYPE_INT32":
                case 5:
                    message.type = 5;
                    break;
                case "TYPE_FIXED64":
                case 6:
                    message.type = 6;
                    break;
                case "TYPE_FIXED32":
                case 7:
                    message.type = 7;
                    break;
                case "TYPE_BOOL":
                case 8:
                    message.type = 8;
                    break;
                case "TYPE_STRING":
                case 9:
                    message.type = 9;
                    break;
                case "TYPE_GROUP":
                case 10:
                    message.type = 10;
                    break;
                case "TYPE_MESSAGE":
                case 11:
                    message.type = 11;
                    break;
                case "TYPE_BYTES":
                case 12:
                    message.type = 12;
                    break;
                case "TYPE_UINT32":
                case 13:
                    message.type = 13;
                    break;
                case "TYPE_ENUM":
                case 14:
                    message.type = 14;
                    break;
                case "TYPE_SFIXED32":
                case 15:
                    message.type = 15;
                    break;
                case "TYPE_SFIXED64":
                case 16:
                    message.type = 16;
                    break;
                case "TYPE_SINT32":
                case 17:
                    message.type = 17;
                    break;
                case "TYPE_SINT64":
                case 18:
                    message.type = 18;
                    break;
                }
                if (object.type_name != null)
                    message.type_name = String(object.type_name);
                if (object.extendee != null)
                    message.extendee = String(object.extendee);
                if (object.default_value != null)
                    message.default_value = String(object.default_value);
                if (object.oneof_index != null)
                    message.oneof_index = object.oneof_index | 0;
                if (object.json_name != null)
                    message.json_name = String(object.json_name);
                if (object.options != null) {
                    if (typeof object.options !== "object")
                        throw TypeError(".google.protobuf.FieldDescriptorProto.options: object expected");
                    message.options = $root.google.protobuf.FieldOptions.fromObject(object.options);
                }
                return message;
            };

            FieldDescriptorProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.name = "";
                    object.extendee = "";
                    object.number = 0;
                    object.label = options.enums === String ? "LABEL_OPTIONAL" : 1;
                    object.type = options.enums === String ? "TYPE_DOUBLE" : 1;
                    object.type_name = "";
                    object.default_value = "";
                    object.options = null;
                    object.oneof_index = 0;
                    object.json_name = "";
                }
                if (message.name != null && message.hasOwnProperty("name"))
                    object.name = message.name;
                if (message.extendee != null && message.hasOwnProperty("extendee"))
                    object.extendee = message.extendee;
                if (message.number != null && message.hasOwnProperty("number"))
                    object.number = message.number;
                if (message.label != null && message.hasOwnProperty("label"))
                    object.label = options.enums === String ? $root.google.protobuf.FieldDescriptorProto.Label[message.label] : message.label;
                if (message.type != null && message.hasOwnProperty("type"))
                    object.type = options.enums === String ? $root.google.protobuf.FieldDescriptorProto.Type[message.type] : message.type;
                if (message.type_name != null && message.hasOwnProperty("type_name"))
                    object.type_name = message.type_name;
                if (message.default_value != null && message.hasOwnProperty("default_value"))
                    object.default_value = message.default_value;
                if (message.options != null && message.hasOwnProperty("options"))
                    object.options = $root.google.protobuf.FieldOptions.toObject(message.options, options);
                if (message.oneof_index != null && message.hasOwnProperty("oneof_index"))
                    object.oneof_index = message.oneof_index;
                if (message.json_name != null && message.hasOwnProperty("json_name"))
                    object.json_name = message.json_name;
                return object;
            };

            FieldDescriptorProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            FieldDescriptorProto.Type = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[1] = "TYPE_DOUBLE"] = 1;
                values[valuesById[2] = "TYPE_FLOAT"] = 2;
                values[valuesById[3] = "TYPE_INT64"] = 3;
                values[valuesById[4] = "TYPE_UINT64"] = 4;
                values[valuesById[5] = "TYPE_INT32"] = 5;
                values[valuesById[6] = "TYPE_FIXED64"] = 6;
                values[valuesById[7] = "TYPE_FIXED32"] = 7;
                values[valuesById[8] = "TYPE_BOOL"] = 8;
                values[valuesById[9] = "TYPE_STRING"] = 9;
                values[valuesById[10] = "TYPE_GROUP"] = 10;
                values[valuesById[11] = "TYPE_MESSAGE"] = 11;
                values[valuesById[12] = "TYPE_BYTES"] = 12;
                values[valuesById[13] = "TYPE_UINT32"] = 13;
                values[valuesById[14] = "TYPE_ENUM"] = 14;
                values[valuesById[15] = "TYPE_SFIXED32"] = 15;
                values[valuesById[16] = "TYPE_SFIXED64"] = 16;
                values[valuesById[17] = "TYPE_SINT32"] = 17;
                values[valuesById[18] = "TYPE_SINT64"] = 18;
                return values;
            })();

            FieldDescriptorProto.Label = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[1] = "LABEL_OPTIONAL"] = 1;
                values[valuesById[2] = "LABEL_REQUIRED"] = 2;
                values[valuesById[3] = "LABEL_REPEATED"] = 3;
                return values;
            })();

            return FieldDescriptorProto;
        })();

        protobuf.OneofDescriptorProto = (function() {

            function OneofDescriptorProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            OneofDescriptorProto.prototype.name = "";
            OneofDescriptorProto.prototype.options = null;

            OneofDescriptorProto.create = function create(properties) {
                return new OneofDescriptorProto(properties);
            };

            OneofDescriptorProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                    writer.uint32(10).string(message.name);
                if (message.options != null && Object.hasOwnProperty.call(message, "options"))
                    $root.google.protobuf.OneofOptions.encode(message.options, writer.uint32(18).fork()).ldelim();
                return writer;
            };

            OneofDescriptorProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            OneofDescriptorProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.OneofDescriptorProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.name = reader.string();
                        break;
                    case 2:
                        message.options = $root.google.protobuf.OneofOptions.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            OneofDescriptorProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            OneofDescriptorProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.name != null && message.hasOwnProperty("name"))
                    if (!$util.isString(message.name))
                        return "name: string expected";
                if (message.options != null && message.hasOwnProperty("options")) {
                    var error = $root.google.protobuf.OneofOptions.verify(message.options);
                    if (error)
                        return "options." + error;
                }
                return null;
            };

            OneofDescriptorProto.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.OneofDescriptorProto)
                    return object;
                var message = new $root.google.protobuf.OneofDescriptorProto();
                if (object.name != null)
                    message.name = String(object.name);
                if (object.options != null) {
                    if (typeof object.options !== "object")
                        throw TypeError(".google.protobuf.OneofDescriptorProto.options: object expected");
                    message.options = $root.google.protobuf.OneofOptions.fromObject(object.options);
                }
                return message;
            };

            OneofDescriptorProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.name = "";
                    object.options = null;
                }
                if (message.name != null && message.hasOwnProperty("name"))
                    object.name = message.name;
                if (message.options != null && message.hasOwnProperty("options"))
                    object.options = $root.google.protobuf.OneofOptions.toObject(message.options, options);
                return object;
            };

            OneofDescriptorProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return OneofDescriptorProto;
        })();

        protobuf.EnumDescriptorProto = (function() {

            function EnumDescriptorProto(properties) {
                this.value = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            EnumDescriptorProto.prototype.name = "";
            EnumDescriptorProto.prototype.value = $util.emptyArray;
            EnumDescriptorProto.prototype.options = null;

            EnumDescriptorProto.create = function create(properties) {
                return new EnumDescriptorProto(properties);
            };

            EnumDescriptorProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                    writer.uint32(10).string(message.name);
                if (message.value != null && message.value.length)
                    for (var i = 0; i < message.value.length; ++i)
                        $root.google.protobuf.EnumValueDescriptorProto.encode(message.value[i], writer.uint32(18).fork()).ldelim();
                if (message.options != null && Object.hasOwnProperty.call(message, "options"))
                    $root.google.protobuf.EnumOptions.encode(message.options, writer.uint32(26).fork()).ldelim();
                return writer;
            };

            EnumDescriptorProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            EnumDescriptorProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.EnumDescriptorProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.name = reader.string();
                        break;
                    case 2:
                        if (!(message.value && message.value.length))
                            message.value = [];
                        message.value.push($root.google.protobuf.EnumValueDescriptorProto.decode(reader, reader.uint32()));
                        break;
                    case 3:
                        message.options = $root.google.protobuf.EnumOptions.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            EnumDescriptorProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            EnumDescriptorProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.name != null && message.hasOwnProperty("name"))
                    if (!$util.isString(message.name))
                        return "name: string expected";
                if (message.value != null && message.hasOwnProperty("value")) {
                    if (!Array.isArray(message.value))
                        return "value: array expected";
                    for (var i = 0; i < message.value.length; ++i) {
                        var error = $root.google.protobuf.EnumValueDescriptorProto.verify(message.value[i]);
                        if (error)
                            return "value." + error;
                    }
                }
                if (message.options != null && message.hasOwnProperty("options")) {
                    var error = $root.google.protobuf.EnumOptions.verify(message.options);
                    if (error)
                        return "options." + error;
                }
                return null;
            };

            EnumDescriptorProto.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.EnumDescriptorProto)
                    return object;
                var message = new $root.google.protobuf.EnumDescriptorProto();
                if (object.name != null)
                    message.name = String(object.name);
                if (object.value) {
                    if (!Array.isArray(object.value))
                        throw TypeError(".google.protobuf.EnumDescriptorProto.value: array expected");
                    message.value = [];
                    for (var i = 0; i < object.value.length; ++i) {
                        if (typeof object.value[i] !== "object")
                            throw TypeError(".google.protobuf.EnumDescriptorProto.value: object expected");
                        message.value[i] = $root.google.protobuf.EnumValueDescriptorProto.fromObject(object.value[i]);
                    }
                }
                if (object.options != null) {
                    if (typeof object.options !== "object")
                        throw TypeError(".google.protobuf.EnumDescriptorProto.options: object expected");
                    message.options = $root.google.protobuf.EnumOptions.fromObject(object.options);
                }
                return message;
            };

            EnumDescriptorProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.value = [];
                if (options.defaults) {
                    object.name = "";
                    object.options = null;
                }
                if (message.name != null && message.hasOwnProperty("name"))
                    object.name = message.name;
                if (message.value && message.value.length) {
                    object.value = [];
                    for (var j = 0; j < message.value.length; ++j)
                        object.value[j] = $root.google.protobuf.EnumValueDescriptorProto.toObject(message.value[j], options);
                }
                if (message.options != null && message.hasOwnProperty("options"))
                    object.options = $root.google.protobuf.EnumOptions.toObject(message.options, options);
                return object;
            };

            EnumDescriptorProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return EnumDescriptorProto;
        })();

        protobuf.EnumValueDescriptorProto = (function() {

            function EnumValueDescriptorProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            EnumValueDescriptorProto.prototype.name = "";
            EnumValueDescriptorProto.prototype.number = 0;
            EnumValueDescriptorProto.prototype.options = null;

            EnumValueDescriptorProto.create = function create(properties) {
                return new EnumValueDescriptorProto(properties);
            };

            EnumValueDescriptorProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                    writer.uint32(10).string(message.name);
                if (message.number != null && Object.hasOwnProperty.call(message, "number"))
                    writer.uint32(16).int32(message.number);
                if (message.options != null && Object.hasOwnProperty.call(message, "options"))
                    $root.google.protobuf.EnumValueOptions.encode(message.options, writer.uint32(26).fork()).ldelim();
                return writer;
            };

            EnumValueDescriptorProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            EnumValueDescriptorProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.EnumValueDescriptorProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.name = reader.string();
                        break;
                    case 2:
                        message.number = reader.int32();
                        break;
                    case 3:
                        message.options = $root.google.protobuf.EnumValueOptions.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            EnumValueDescriptorProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            EnumValueDescriptorProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.name != null && message.hasOwnProperty("name"))
                    if (!$util.isString(message.name))
                        return "name: string expected";
                if (message.number != null && message.hasOwnProperty("number"))
                    if (!$util.isInteger(message.number))
                        return "number: integer expected";
                if (message.options != null && message.hasOwnProperty("options")) {
                    var error = $root.google.protobuf.EnumValueOptions.verify(message.options);
                    if (error)
                        return "options." + error;
                }
                return null;
            };

            EnumValueDescriptorProto.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.EnumValueDescriptorProto)
                    return object;
                var message = new $root.google.protobuf.EnumValueDescriptorProto();
                if (object.name != null)
                    message.name = String(object.name);
                if (object.number != null)
                    message.number = object.number | 0;
                if (object.options != null) {
                    if (typeof object.options !== "object")
                        throw TypeError(".google.protobuf.EnumValueDescriptorProto.options: object expected");
                    message.options = $root.google.protobuf.EnumValueOptions.fromObject(object.options);
                }
                return message;
            };

            EnumValueDescriptorProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.name = "";
                    object.number = 0;
                    object.options = null;
                }
                if (message.name != null && message.hasOwnProperty("name"))
                    object.name = message.name;
                if (message.number != null && message.hasOwnProperty("number"))
                    object.number = message.number;
                if (message.options != null && message.hasOwnProperty("options"))
                    object.options = $root.google.protobuf.EnumValueOptions.toObject(message.options, options);
                return object;
            };

            EnumValueDescriptorProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return EnumValueDescriptorProto;
        })();

        protobuf.ServiceDescriptorProto = (function() {

            function ServiceDescriptorProto(properties) {
                this.method = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            ServiceDescriptorProto.prototype.name = "";
            ServiceDescriptorProto.prototype.method = $util.emptyArray;
            ServiceDescriptorProto.prototype.options = null;

            ServiceDescriptorProto.create = function create(properties) {
                return new ServiceDescriptorProto(properties);
            };

            ServiceDescriptorProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                    writer.uint32(10).string(message.name);
                if (message.method != null && message.method.length)
                    for (var i = 0; i < message.method.length; ++i)
                        $root.google.protobuf.MethodDescriptorProto.encode(message.method[i], writer.uint32(18).fork()).ldelim();
                if (message.options != null && Object.hasOwnProperty.call(message, "options"))
                    $root.google.protobuf.ServiceOptions.encode(message.options, writer.uint32(26).fork()).ldelim();
                return writer;
            };

            ServiceDescriptorProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            ServiceDescriptorProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.ServiceDescriptorProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.name = reader.string();
                        break;
                    case 2:
                        if (!(message.method && message.method.length))
                            message.method = [];
                        message.method.push($root.google.protobuf.MethodDescriptorProto.decode(reader, reader.uint32()));
                        break;
                    case 3:
                        message.options = $root.google.protobuf.ServiceOptions.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            ServiceDescriptorProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            ServiceDescriptorProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.name != null && message.hasOwnProperty("name"))
                    if (!$util.isString(message.name))
                        return "name: string expected";
                if (message.method != null && message.hasOwnProperty("method")) {
                    if (!Array.isArray(message.method))
                        return "method: array expected";
                    for (var i = 0; i < message.method.length; ++i) {
                        var error = $root.google.protobuf.MethodDescriptorProto.verify(message.method[i]);
                        if (error)
                            return "method." + error;
                    }
                }
                if (message.options != null && message.hasOwnProperty("options")) {
                    var error = $root.google.protobuf.ServiceOptions.verify(message.options);
                    if (error)
                        return "options." + error;
                }
                return null;
            };

            ServiceDescriptorProto.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.ServiceDescriptorProto)
                    return object;
                var message = new $root.google.protobuf.ServiceDescriptorProto();
                if (object.name != null)
                    message.name = String(object.name);
                if (object.method) {
                    if (!Array.isArray(object.method))
                        throw TypeError(".google.protobuf.ServiceDescriptorProto.method: array expected");
                    message.method = [];
                    for (var i = 0; i < object.method.length; ++i) {
                        if (typeof object.method[i] !== "object")
                            throw TypeError(".google.protobuf.ServiceDescriptorProto.method: object expected");
                        message.method[i] = $root.google.protobuf.MethodDescriptorProto.fromObject(object.method[i]);
                    }
                }
                if (object.options != null) {
                    if (typeof object.options !== "object")
                        throw TypeError(".google.protobuf.ServiceDescriptorProto.options: object expected");
                    message.options = $root.google.protobuf.ServiceOptions.fromObject(object.options);
                }
                return message;
            };

            ServiceDescriptorProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.method = [];
                if (options.defaults) {
                    object.name = "";
                    object.options = null;
                }
                if (message.name != null && message.hasOwnProperty("name"))
                    object.name = message.name;
                if (message.method && message.method.length) {
                    object.method = [];
                    for (var j = 0; j < message.method.length; ++j)
                        object.method[j] = $root.google.protobuf.MethodDescriptorProto.toObject(message.method[j], options);
                }
                if (message.options != null && message.hasOwnProperty("options"))
                    object.options = $root.google.protobuf.ServiceOptions.toObject(message.options, options);
                return object;
            };

            ServiceDescriptorProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return ServiceDescriptorProto;
        })();

        protobuf.MethodDescriptorProto = (function() {

            function MethodDescriptorProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            MethodDescriptorProto.prototype.name = "";
            MethodDescriptorProto.prototype.input_type = "";
            MethodDescriptorProto.prototype.output_type = "";
            MethodDescriptorProto.prototype.options = null;
            MethodDescriptorProto.prototype.client_streaming = false;
            MethodDescriptorProto.prototype.server_streaming = false;

            MethodDescriptorProto.create = function create(properties) {
                return new MethodDescriptorProto(properties);
            };

            MethodDescriptorProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                    writer.uint32(10).string(message.name);
                if (message.input_type != null && Object.hasOwnProperty.call(message, "input_type"))
                    writer.uint32(18).string(message.input_type);
                if (message.output_type != null && Object.hasOwnProperty.call(message, "output_type"))
                    writer.uint32(26).string(message.output_type);
                if (message.options != null && Object.hasOwnProperty.call(message, "options"))
                    $root.google.protobuf.MethodOptions.encode(message.options, writer.uint32(34).fork()).ldelim();
                if (message.client_streaming != null && Object.hasOwnProperty.call(message, "client_streaming"))
                    writer.uint32(40).bool(message.client_streaming);
                if (message.server_streaming != null && Object.hasOwnProperty.call(message, "server_streaming"))
                    writer.uint32(48).bool(message.server_streaming);
                return writer;
            };

            MethodDescriptorProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            MethodDescriptorProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.MethodDescriptorProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.name = reader.string();
                        break;
                    case 2:
                        message.input_type = reader.string();
                        break;
                    case 3:
                        message.output_type = reader.string();
                        break;
                    case 4:
                        message.options = $root.google.protobuf.MethodOptions.decode(reader, reader.uint32());
                        break;
                    case 5:
                        message.client_streaming = reader.bool();
                        break;
                    case 6:
                        message.server_streaming = reader.bool();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            MethodDescriptorProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            MethodDescriptorProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.name != null && message.hasOwnProperty("name"))
                    if (!$util.isString(message.name))
                        return "name: string expected";
                if (message.input_type != null && message.hasOwnProperty("input_type"))
                    if (!$util.isString(message.input_type))
                        return "input_type: string expected";
                if (message.output_type != null && message.hasOwnProperty("output_type"))
                    if (!$util.isString(message.output_type))
                        return "output_type: string expected";
                if (message.options != null && message.hasOwnProperty("options")) {
                    var error = $root.google.protobuf.MethodOptions.verify(message.options);
                    if (error)
                        return "options." + error;
                }
                if (message.client_streaming != null && message.hasOwnProperty("client_streaming"))
                    if (typeof message.client_streaming !== "boolean")
                        return "client_streaming: boolean expected";
                if (message.server_streaming != null && message.hasOwnProperty("server_streaming"))
                    if (typeof message.server_streaming !== "boolean")
                        return "server_streaming: boolean expected";
                return null;
            };

            MethodDescriptorProto.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.MethodDescriptorProto)
                    return object;
                var message = new $root.google.protobuf.MethodDescriptorProto();
                if (object.name != null)
                    message.name = String(object.name);
                if (object.input_type != null)
                    message.input_type = String(object.input_type);
                if (object.output_type != null)
                    message.output_type = String(object.output_type);
                if (object.options != null) {
                    if (typeof object.options !== "object")
                        throw TypeError(".google.protobuf.MethodDescriptorProto.options: object expected");
                    message.options = $root.google.protobuf.MethodOptions.fromObject(object.options);
                }
                if (object.client_streaming != null)
                    message.client_streaming = Boolean(object.client_streaming);
                if (object.server_streaming != null)
                    message.server_streaming = Boolean(object.server_streaming);
                return message;
            };

            MethodDescriptorProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.name = "";
                    object.input_type = "";
                    object.output_type = "";
                    object.options = null;
                    object.client_streaming = false;
                    object.server_streaming = false;
                }
                if (message.name != null && message.hasOwnProperty("name"))
                    object.name = message.name;
                if (message.input_type != null && message.hasOwnProperty("input_type"))
                    object.input_type = message.input_type;
                if (message.output_type != null && message.hasOwnProperty("output_type"))
                    object.output_type = message.output_type;
                if (message.options != null && message.hasOwnProperty("options"))
                    object.options = $root.google.protobuf.MethodOptions.toObject(message.options, options);
                if (message.client_streaming != null && message.hasOwnProperty("client_streaming"))
                    object.client_streaming = message.client_streaming;
                if (message.server_streaming != null && message.hasOwnProperty("server_streaming"))
                    object.server_streaming = message.server_streaming;
                return object;
            };

            MethodDescriptorProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return MethodDescriptorProto;
        })();

        protobuf.FileOptions = (function() {

            function FileOptions(properties) {
                this.uninterpreted_option = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            FileOptions.prototype.java_package = "";
            FileOptions.prototype.java_outer_classname = "";
            FileOptions.prototype.java_multiple_files = false;
            FileOptions.prototype.java_generate_equals_and_hash = false;
            FileOptions.prototype.java_string_check_utf8 = false;
            FileOptions.prototype.optimize_for = 1;
            FileOptions.prototype.go_package = "";
            FileOptions.prototype.cc_generic_services = false;
            FileOptions.prototype.java_generic_services = false;
            FileOptions.prototype.py_generic_services = false;
            FileOptions.prototype.deprecated = false;
            FileOptions.prototype.cc_enable_arenas = false;
            FileOptions.prototype.objc_class_prefix = "";
            FileOptions.prototype.csharp_namespace = "";
            FileOptions.prototype.uninterpreted_option = $util.emptyArray;
            FileOptions.prototype[".include_in_bitcoin_only"] = false;

            FileOptions.create = function create(properties) {
                return new FileOptions(properties);
            };

            FileOptions.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.java_package != null && Object.hasOwnProperty.call(message, "java_package"))
                    writer.uint32(10).string(message.java_package);
                if (message.java_outer_classname != null && Object.hasOwnProperty.call(message, "java_outer_classname"))
                    writer.uint32(66).string(message.java_outer_classname);
                if (message.optimize_for != null && Object.hasOwnProperty.call(message, "optimize_for"))
                    writer.uint32(72).int32(message.optimize_for);
                if (message.java_multiple_files != null && Object.hasOwnProperty.call(message, "java_multiple_files"))
                    writer.uint32(80).bool(message.java_multiple_files);
                if (message.go_package != null && Object.hasOwnProperty.call(message, "go_package"))
                    writer.uint32(90).string(message.go_package);
                if (message.cc_generic_services != null && Object.hasOwnProperty.call(message, "cc_generic_services"))
                    writer.uint32(128).bool(message.cc_generic_services);
                if (message.java_generic_services != null && Object.hasOwnProperty.call(message, "java_generic_services"))
                    writer.uint32(136).bool(message.java_generic_services);
                if (message.py_generic_services != null && Object.hasOwnProperty.call(message, "py_generic_services"))
                    writer.uint32(144).bool(message.py_generic_services);
                if (message.java_generate_equals_and_hash != null && Object.hasOwnProperty.call(message, "java_generate_equals_and_hash"))
                    writer.uint32(160).bool(message.java_generate_equals_and_hash);
                if (message.deprecated != null && Object.hasOwnProperty.call(message, "deprecated"))
                    writer.uint32(184).bool(message.deprecated);
                if (message.java_string_check_utf8 != null && Object.hasOwnProperty.call(message, "java_string_check_utf8"))
                    writer.uint32(216).bool(message.java_string_check_utf8);
                if (message.cc_enable_arenas != null && Object.hasOwnProperty.call(message, "cc_enable_arenas"))
                    writer.uint32(248).bool(message.cc_enable_arenas);
                if (message.objc_class_prefix != null && Object.hasOwnProperty.call(message, "objc_class_prefix"))
                    writer.uint32(290).string(message.objc_class_prefix);
                if (message.csharp_namespace != null && Object.hasOwnProperty.call(message, "csharp_namespace"))
                    writer.uint32(298).string(message.csharp_namespace);
                if (message.uninterpreted_option != null && message.uninterpreted_option.length)
                    for (var i = 0; i < message.uninterpreted_option.length; ++i)
                        $root.google.protobuf.UninterpretedOption.encode(message.uninterpreted_option[i], writer.uint32(7994).fork()).ldelim();
                if (message[".include_in_bitcoin_only"] != null && Object.hasOwnProperty.call(message, ".include_in_bitcoin_only"))
                    writer.uint32(480000).bool(message[".include_in_bitcoin_only"]);
                return writer;
            };

            FileOptions.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            FileOptions.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.FileOptions();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.java_package = reader.string();
                        break;
                    case 8:
                        message.java_outer_classname = reader.string();
                        break;
                    case 10:
                        message.java_multiple_files = reader.bool();
                        break;
                    case 20:
                        message.java_generate_equals_and_hash = reader.bool();
                        break;
                    case 27:
                        message.java_string_check_utf8 = reader.bool();
                        break;
                    case 9:
                        message.optimize_for = reader.int32();
                        break;
                    case 11:
                        message.go_package = reader.string();
                        break;
                    case 16:
                        message.cc_generic_services = reader.bool();
                        break;
                    case 17:
                        message.java_generic_services = reader.bool();
                        break;
                    case 18:
                        message.py_generic_services = reader.bool();
                        break;
                    case 23:
                        message.deprecated = reader.bool();
                        break;
                    case 31:
                        message.cc_enable_arenas = reader.bool();
                        break;
                    case 36:
                        message.objc_class_prefix = reader.string();
                        break;
                    case 37:
                        message.csharp_namespace = reader.string();
                        break;
                    case 999:
                        if (!(message.uninterpreted_option && message.uninterpreted_option.length))
                            message.uninterpreted_option = [];
                        message.uninterpreted_option.push($root.google.protobuf.UninterpretedOption.decode(reader, reader.uint32()));
                        break;
                    case 60000:
                        message[".include_in_bitcoin_only"] = reader.bool();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            FileOptions.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            FileOptions.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.java_package != null && message.hasOwnProperty("java_package"))
                    if (!$util.isString(message.java_package))
                        return "java_package: string expected";
                if (message.java_outer_classname != null && message.hasOwnProperty("java_outer_classname"))
                    if (!$util.isString(message.java_outer_classname))
                        return "java_outer_classname: string expected";
                if (message.java_multiple_files != null && message.hasOwnProperty("java_multiple_files"))
                    if (typeof message.java_multiple_files !== "boolean")
                        return "java_multiple_files: boolean expected";
                if (message.java_generate_equals_and_hash != null && message.hasOwnProperty("java_generate_equals_and_hash"))
                    if (typeof message.java_generate_equals_and_hash !== "boolean")
                        return "java_generate_equals_and_hash: boolean expected";
                if (message.java_string_check_utf8 != null && message.hasOwnProperty("java_string_check_utf8"))
                    if (typeof message.java_string_check_utf8 !== "boolean")
                        return "java_string_check_utf8: boolean expected";
                if (message.optimize_for != null && message.hasOwnProperty("optimize_for"))
                    switch (message.optimize_for) {
                    default:
                        return "optimize_for: enum value expected";
                    case 1:
                    case 2:
                    case 3:
                        break;
                    }
                if (message.go_package != null && message.hasOwnProperty("go_package"))
                    if (!$util.isString(message.go_package))
                        return "go_package: string expected";
                if (message.cc_generic_services != null && message.hasOwnProperty("cc_generic_services"))
                    if (typeof message.cc_generic_services !== "boolean")
                        return "cc_generic_services: boolean expected";
                if (message.java_generic_services != null && message.hasOwnProperty("java_generic_services"))
                    if (typeof message.java_generic_services !== "boolean")
                        return "java_generic_services: boolean expected";
                if (message.py_generic_services != null && message.hasOwnProperty("py_generic_services"))
                    if (typeof message.py_generic_services !== "boolean")
                        return "py_generic_services: boolean expected";
                if (message.deprecated != null && message.hasOwnProperty("deprecated"))
                    if (typeof message.deprecated !== "boolean")
                        return "deprecated: boolean expected";
                if (message.cc_enable_arenas != null && message.hasOwnProperty("cc_enable_arenas"))
                    if (typeof message.cc_enable_arenas !== "boolean")
                        return "cc_enable_arenas: boolean expected";
                if (message.objc_class_prefix != null && message.hasOwnProperty("objc_class_prefix"))
                    if (!$util.isString(message.objc_class_prefix))
                        return "objc_class_prefix: string expected";
                if (message.csharp_namespace != null && message.hasOwnProperty("csharp_namespace"))
                    if (!$util.isString(message.csharp_namespace))
                        return "csharp_namespace: string expected";
                if (message.uninterpreted_option != null && message.hasOwnProperty("uninterpreted_option")) {
                    if (!Array.isArray(message.uninterpreted_option))
                        return "uninterpreted_option: array expected";
                    for (var i = 0; i < message.uninterpreted_option.length; ++i) {
                        var error = $root.google.protobuf.UninterpretedOption.verify(message.uninterpreted_option[i]);
                        if (error)
                            return "uninterpreted_option." + error;
                    }
                }
                if (message[".include_in_bitcoin_only"] != null && message.hasOwnProperty(".include_in_bitcoin_only"))
                    if (typeof message[".include_in_bitcoin_only"] !== "boolean")
                        return ".include_in_bitcoin_only: boolean expected";
                return null;
            };

            FileOptions.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.FileOptions)
                    return object;
                var message = new $root.google.protobuf.FileOptions();
                if (object.java_package != null)
                    message.java_package = String(object.java_package);
                if (object.java_outer_classname != null)
                    message.java_outer_classname = String(object.java_outer_classname);
                if (object.java_multiple_files != null)
                    message.java_multiple_files = Boolean(object.java_multiple_files);
                if (object.java_generate_equals_and_hash != null)
                    message.java_generate_equals_and_hash = Boolean(object.java_generate_equals_and_hash);
                if (object.java_string_check_utf8 != null)
                    message.java_string_check_utf8 = Boolean(object.java_string_check_utf8);
                switch (object.optimize_for) {
                case "SPEED":
                case 1:
                    message.optimize_for = 1;
                    break;
                case "CODE_SIZE":
                case 2:
                    message.optimize_for = 2;
                    break;
                case "LITE_RUNTIME":
                case 3:
                    message.optimize_for = 3;
                    break;
                }
                if (object.go_package != null)
                    message.go_package = String(object.go_package);
                if (object.cc_generic_services != null)
                    message.cc_generic_services = Boolean(object.cc_generic_services);
                if (object.java_generic_services != null)
                    message.java_generic_services = Boolean(object.java_generic_services);
                if (object.py_generic_services != null)
                    message.py_generic_services = Boolean(object.py_generic_services);
                if (object.deprecated != null)
                    message.deprecated = Boolean(object.deprecated);
                if (object.cc_enable_arenas != null)
                    message.cc_enable_arenas = Boolean(object.cc_enable_arenas);
                if (object.objc_class_prefix != null)
                    message.objc_class_prefix = String(object.objc_class_prefix);
                if (object.csharp_namespace != null)
                    message.csharp_namespace = String(object.csharp_namespace);
                if (object.uninterpreted_option) {
                    if (!Array.isArray(object.uninterpreted_option))
                        throw TypeError(".google.protobuf.FileOptions.uninterpreted_option: array expected");
                    message.uninterpreted_option = [];
                    for (var i = 0; i < object.uninterpreted_option.length; ++i) {
                        if (typeof object.uninterpreted_option[i] !== "object")
                            throw TypeError(".google.protobuf.FileOptions.uninterpreted_option: object expected");
                        message.uninterpreted_option[i] = $root.google.protobuf.UninterpretedOption.fromObject(object.uninterpreted_option[i]);
                    }
                }
                if (object[".include_in_bitcoin_only"] != null)
                    message[".include_in_bitcoin_only"] = Boolean(object[".include_in_bitcoin_only"]);
                return message;
            };

            FileOptions.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.uninterpreted_option = [];
                if (options.defaults) {
                    object.java_package = "";
                    object.java_outer_classname = "";
                    object.optimize_for = options.enums === String ? "SPEED" : 1;
                    object.java_multiple_files = false;
                    object.go_package = "";
                    object.cc_generic_services = false;
                    object.java_generic_services = false;
                    object.py_generic_services = false;
                    object.java_generate_equals_and_hash = false;
                    object.deprecated = false;
                    object.java_string_check_utf8 = false;
                    object.cc_enable_arenas = false;
                    object.objc_class_prefix = "";
                    object.csharp_namespace = "";
                    object[".include_in_bitcoin_only"] = false;
                }
                if (message.java_package != null && message.hasOwnProperty("java_package"))
                    object.java_package = message.java_package;
                if (message.java_outer_classname != null && message.hasOwnProperty("java_outer_classname"))
                    object.java_outer_classname = message.java_outer_classname;
                if (message.optimize_for != null && message.hasOwnProperty("optimize_for"))
                    object.optimize_for = options.enums === String ? $root.google.protobuf.FileOptions.OptimizeMode[message.optimize_for] : message.optimize_for;
                if (message.java_multiple_files != null && message.hasOwnProperty("java_multiple_files"))
                    object.java_multiple_files = message.java_multiple_files;
                if (message.go_package != null && message.hasOwnProperty("go_package"))
                    object.go_package = message.go_package;
                if (message.cc_generic_services != null && message.hasOwnProperty("cc_generic_services"))
                    object.cc_generic_services = message.cc_generic_services;
                if (message.java_generic_services != null && message.hasOwnProperty("java_generic_services"))
                    object.java_generic_services = message.java_generic_services;
                if (message.py_generic_services != null && message.hasOwnProperty("py_generic_services"))
                    object.py_generic_services = message.py_generic_services;
                if (message.java_generate_equals_and_hash != null && message.hasOwnProperty("java_generate_equals_and_hash"))
                    object.java_generate_equals_and_hash = message.java_generate_equals_and_hash;
                if (message.deprecated != null && message.hasOwnProperty("deprecated"))
                    object.deprecated = message.deprecated;
                if (message.java_string_check_utf8 != null && message.hasOwnProperty("java_string_check_utf8"))
                    object.java_string_check_utf8 = message.java_string_check_utf8;
                if (message.cc_enable_arenas != null && message.hasOwnProperty("cc_enable_arenas"))
                    object.cc_enable_arenas = message.cc_enable_arenas;
                if (message.objc_class_prefix != null && message.hasOwnProperty("objc_class_prefix"))
                    object.objc_class_prefix = message.objc_class_prefix;
                if (message.csharp_namespace != null && message.hasOwnProperty("csharp_namespace"))
                    object.csharp_namespace = message.csharp_namespace;
                if (message.uninterpreted_option && message.uninterpreted_option.length) {
                    object.uninterpreted_option = [];
                    for (var j = 0; j < message.uninterpreted_option.length; ++j)
                        object.uninterpreted_option[j] = $root.google.protobuf.UninterpretedOption.toObject(message.uninterpreted_option[j], options);
                }
                if (message[".include_in_bitcoin_only"] != null && message.hasOwnProperty(".include_in_bitcoin_only"))
                    object[".include_in_bitcoin_only"] = message[".include_in_bitcoin_only"];
                return object;
            };

            FileOptions.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            FileOptions.OptimizeMode = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[1] = "SPEED"] = 1;
                values[valuesById[2] = "CODE_SIZE"] = 2;
                values[valuesById[3] = "LITE_RUNTIME"] = 3;
                return values;
            })();

            return FileOptions;
        })();

        protobuf.MessageOptions = (function() {

            function MessageOptions(properties) {
                this.uninterpreted_option = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            MessageOptions.prototype.message_set_wire_format = false;
            MessageOptions.prototype.no_standard_descriptor_accessor = false;
            MessageOptions.prototype.deprecated = false;
            MessageOptions.prototype.map_entry = false;
            MessageOptions.prototype.uninterpreted_option = $util.emptyArray;
            MessageOptions.prototype[".experimental_message"] = false;
            MessageOptions.prototype[".wire_type"] = 0;

            MessageOptions.create = function create(properties) {
                return new MessageOptions(properties);
            };

            MessageOptions.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.message_set_wire_format != null && Object.hasOwnProperty.call(message, "message_set_wire_format"))
                    writer.uint32(8).bool(message.message_set_wire_format);
                if (message.no_standard_descriptor_accessor != null && Object.hasOwnProperty.call(message, "no_standard_descriptor_accessor"))
                    writer.uint32(16).bool(message.no_standard_descriptor_accessor);
                if (message.deprecated != null && Object.hasOwnProperty.call(message, "deprecated"))
                    writer.uint32(24).bool(message.deprecated);
                if (message.map_entry != null && Object.hasOwnProperty.call(message, "map_entry"))
                    writer.uint32(56).bool(message.map_entry);
                if (message.uninterpreted_option != null && message.uninterpreted_option.length)
                    for (var i = 0; i < message.uninterpreted_option.length; ++i)
                        $root.google.protobuf.UninterpretedOption.encode(message.uninterpreted_option[i], writer.uint32(7994).fork()).ldelim();
                if (message[".experimental_message"] != null && Object.hasOwnProperty.call(message, ".experimental_message"))
                    writer.uint32(416008).bool(message[".experimental_message"]);
                if (message[".wire_type"] != null && Object.hasOwnProperty.call(message, ".wire_type"))
                    writer.uint32(416016).uint32(message[".wire_type"]);
                return writer;
            };

            MessageOptions.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            MessageOptions.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.MessageOptions();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.message_set_wire_format = reader.bool();
                        break;
                    case 2:
                        message.no_standard_descriptor_accessor = reader.bool();
                        break;
                    case 3:
                        message.deprecated = reader.bool();
                        break;
                    case 7:
                        message.map_entry = reader.bool();
                        break;
                    case 999:
                        if (!(message.uninterpreted_option && message.uninterpreted_option.length))
                            message.uninterpreted_option = [];
                        message.uninterpreted_option.push($root.google.protobuf.UninterpretedOption.decode(reader, reader.uint32()));
                        break;
                    case 52001:
                        message[".experimental_message"] = reader.bool();
                        break;
                    case 52002:
                        message[".wire_type"] = reader.uint32();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            MessageOptions.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            MessageOptions.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.message_set_wire_format != null && message.hasOwnProperty("message_set_wire_format"))
                    if (typeof message.message_set_wire_format !== "boolean")
                        return "message_set_wire_format: boolean expected";
                if (message.no_standard_descriptor_accessor != null && message.hasOwnProperty("no_standard_descriptor_accessor"))
                    if (typeof message.no_standard_descriptor_accessor !== "boolean")
                        return "no_standard_descriptor_accessor: boolean expected";
                if (message.deprecated != null && message.hasOwnProperty("deprecated"))
                    if (typeof message.deprecated !== "boolean")
                        return "deprecated: boolean expected";
                if (message.map_entry != null && message.hasOwnProperty("map_entry"))
                    if (typeof message.map_entry !== "boolean")
                        return "map_entry: boolean expected";
                if (message.uninterpreted_option != null && message.hasOwnProperty("uninterpreted_option")) {
                    if (!Array.isArray(message.uninterpreted_option))
                        return "uninterpreted_option: array expected";
                    for (var i = 0; i < message.uninterpreted_option.length; ++i) {
                        var error = $root.google.protobuf.UninterpretedOption.verify(message.uninterpreted_option[i]);
                        if (error)
                            return "uninterpreted_option." + error;
                    }
                }
                if (message[".experimental_message"] != null && message.hasOwnProperty(".experimental_message"))
                    if (typeof message[".experimental_message"] !== "boolean")
                        return ".experimental_message: boolean expected";
                if (message[".wire_type"] != null && message.hasOwnProperty(".wire_type"))
                    if (!$util.isInteger(message[".wire_type"]))
                        return ".wire_type: integer expected";
                return null;
            };

            MessageOptions.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.MessageOptions)
                    return object;
                var message = new $root.google.protobuf.MessageOptions();
                if (object.message_set_wire_format != null)
                    message.message_set_wire_format = Boolean(object.message_set_wire_format);
                if (object.no_standard_descriptor_accessor != null)
                    message.no_standard_descriptor_accessor = Boolean(object.no_standard_descriptor_accessor);
                if (object.deprecated != null)
                    message.deprecated = Boolean(object.deprecated);
                if (object.map_entry != null)
                    message.map_entry = Boolean(object.map_entry);
                if (object.uninterpreted_option) {
                    if (!Array.isArray(object.uninterpreted_option))
                        throw TypeError(".google.protobuf.MessageOptions.uninterpreted_option: array expected");
                    message.uninterpreted_option = [];
                    for (var i = 0; i < object.uninterpreted_option.length; ++i) {
                        if (typeof object.uninterpreted_option[i] !== "object")
                            throw TypeError(".google.protobuf.MessageOptions.uninterpreted_option: object expected");
                        message.uninterpreted_option[i] = $root.google.protobuf.UninterpretedOption.fromObject(object.uninterpreted_option[i]);
                    }
                }
                if (object[".experimental_message"] != null)
                    message[".experimental_message"] = Boolean(object[".experimental_message"]);
                if (object[".wire_type"] != null)
                    message[".wire_type"] = object[".wire_type"] >>> 0;
                return message;
            };

            MessageOptions.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.uninterpreted_option = [];
                if (options.defaults) {
                    object.message_set_wire_format = false;
                    object.no_standard_descriptor_accessor = false;
                    object.deprecated = false;
                    object.map_entry = false;
                    object[".experimental_message"] = false;
                    object[".wire_type"] = 0;
                }
                if (message.message_set_wire_format != null && message.hasOwnProperty("message_set_wire_format"))
                    object.message_set_wire_format = message.message_set_wire_format;
                if (message.no_standard_descriptor_accessor != null && message.hasOwnProperty("no_standard_descriptor_accessor"))
                    object.no_standard_descriptor_accessor = message.no_standard_descriptor_accessor;
                if (message.deprecated != null && message.hasOwnProperty("deprecated"))
                    object.deprecated = message.deprecated;
                if (message.map_entry != null && message.hasOwnProperty("map_entry"))
                    object.map_entry = message.map_entry;
                if (message.uninterpreted_option && message.uninterpreted_option.length) {
                    object.uninterpreted_option = [];
                    for (var j = 0; j < message.uninterpreted_option.length; ++j)
                        object.uninterpreted_option[j] = $root.google.protobuf.UninterpretedOption.toObject(message.uninterpreted_option[j], options);
                }
                if (message[".experimental_message"] != null && message.hasOwnProperty(".experimental_message"))
                    object[".experimental_message"] = message[".experimental_message"];
                if (message[".wire_type"] != null && message.hasOwnProperty(".wire_type"))
                    object[".wire_type"] = message[".wire_type"];
                return object;
            };

            MessageOptions.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return MessageOptions;
        })();

        protobuf.FieldOptions = (function() {

            function FieldOptions(properties) {
                this.uninterpreted_option = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            FieldOptions.prototype.ctype = 0;
            FieldOptions.prototype.packed = false;
            FieldOptions.prototype.jstype = 0;
            FieldOptions.prototype.lazy = false;
            FieldOptions.prototype.deprecated = false;
            FieldOptions.prototype.weak = false;
            FieldOptions.prototype.uninterpreted_option = $util.emptyArray;
            FieldOptions.prototype[".experimental_field"] = false;

            FieldOptions.create = function create(properties) {
                return new FieldOptions(properties);
            };

            FieldOptions.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.ctype != null && Object.hasOwnProperty.call(message, "ctype"))
                    writer.uint32(8).int32(message.ctype);
                if (message.packed != null && Object.hasOwnProperty.call(message, "packed"))
                    writer.uint32(16).bool(message.packed);
                if (message.deprecated != null && Object.hasOwnProperty.call(message, "deprecated"))
                    writer.uint32(24).bool(message.deprecated);
                if (message.lazy != null && Object.hasOwnProperty.call(message, "lazy"))
                    writer.uint32(40).bool(message.lazy);
                if (message.jstype != null && Object.hasOwnProperty.call(message, "jstype"))
                    writer.uint32(48).int32(message.jstype);
                if (message.weak != null && Object.hasOwnProperty.call(message, "weak"))
                    writer.uint32(80).bool(message.weak);
                if (message.uninterpreted_option != null && message.uninterpreted_option.length)
                    for (var i = 0; i < message.uninterpreted_option.length; ++i)
                        $root.google.protobuf.UninterpretedOption.encode(message.uninterpreted_option[i], writer.uint32(7994).fork()).ldelim();
                if (message[".experimental_field"] != null && Object.hasOwnProperty.call(message, ".experimental_field"))
                    writer.uint32(424008).bool(message[".experimental_field"]);
                return writer;
            };

            FieldOptions.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            FieldOptions.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.FieldOptions();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.ctype = reader.int32();
                        break;
                    case 2:
                        message.packed = reader.bool();
                        break;
                    case 6:
                        message.jstype = reader.int32();
                        break;
                    case 5:
                        message.lazy = reader.bool();
                        break;
                    case 3:
                        message.deprecated = reader.bool();
                        break;
                    case 10:
                        message.weak = reader.bool();
                        break;
                    case 999:
                        if (!(message.uninterpreted_option && message.uninterpreted_option.length))
                            message.uninterpreted_option = [];
                        message.uninterpreted_option.push($root.google.protobuf.UninterpretedOption.decode(reader, reader.uint32()));
                        break;
                    case 53001:
                        message[".experimental_field"] = reader.bool();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            FieldOptions.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            FieldOptions.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.ctype != null && message.hasOwnProperty("ctype"))
                    switch (message.ctype) {
                    default:
                        return "ctype: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                        break;
                    }
                if (message.packed != null && message.hasOwnProperty("packed"))
                    if (typeof message.packed !== "boolean")
                        return "packed: boolean expected";
                if (message.jstype != null && message.hasOwnProperty("jstype"))
                    switch (message.jstype) {
                    default:
                        return "jstype: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                        break;
                    }
                if (message.lazy != null && message.hasOwnProperty("lazy"))
                    if (typeof message.lazy !== "boolean")
                        return "lazy: boolean expected";
                if (message.deprecated != null && message.hasOwnProperty("deprecated"))
                    if (typeof message.deprecated !== "boolean")
                        return "deprecated: boolean expected";
                if (message.weak != null && message.hasOwnProperty("weak"))
                    if (typeof message.weak !== "boolean")
                        return "weak: boolean expected";
                if (message.uninterpreted_option != null && message.hasOwnProperty("uninterpreted_option")) {
                    if (!Array.isArray(message.uninterpreted_option))
                        return "uninterpreted_option: array expected";
                    for (var i = 0; i < message.uninterpreted_option.length; ++i) {
                        var error = $root.google.protobuf.UninterpretedOption.verify(message.uninterpreted_option[i]);
                        if (error)
                            return "uninterpreted_option." + error;
                    }
                }
                if (message[".experimental_field"] != null && message.hasOwnProperty(".experimental_field"))
                    if (typeof message[".experimental_field"] !== "boolean")
                        return ".experimental_field: boolean expected";
                return null;
            };

            FieldOptions.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.FieldOptions)
                    return object;
                var message = new $root.google.protobuf.FieldOptions();
                switch (object.ctype) {
                case "STRING":
                case 0:
                    message.ctype = 0;
                    break;
                case "CORD":
                case 1:
                    message.ctype = 1;
                    break;
                case "STRING_PIECE":
                case 2:
                    message.ctype = 2;
                    break;
                }
                if (object.packed != null)
                    message.packed = Boolean(object.packed);
                switch (object.jstype) {
                case "JS_NORMAL":
                case 0:
                    message.jstype = 0;
                    break;
                case "JS_STRING":
                case 1:
                    message.jstype = 1;
                    break;
                case "JS_NUMBER":
                case 2:
                    message.jstype = 2;
                    break;
                }
                if (object.lazy != null)
                    message.lazy = Boolean(object.lazy);
                if (object.deprecated != null)
                    message.deprecated = Boolean(object.deprecated);
                if (object.weak != null)
                    message.weak = Boolean(object.weak);
                if (object.uninterpreted_option) {
                    if (!Array.isArray(object.uninterpreted_option))
                        throw TypeError(".google.protobuf.FieldOptions.uninterpreted_option: array expected");
                    message.uninterpreted_option = [];
                    for (var i = 0; i < object.uninterpreted_option.length; ++i) {
                        if (typeof object.uninterpreted_option[i] !== "object")
                            throw TypeError(".google.protobuf.FieldOptions.uninterpreted_option: object expected");
                        message.uninterpreted_option[i] = $root.google.protobuf.UninterpretedOption.fromObject(object.uninterpreted_option[i]);
                    }
                }
                if (object[".experimental_field"] != null)
                    message[".experimental_field"] = Boolean(object[".experimental_field"]);
                return message;
            };

            FieldOptions.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.uninterpreted_option = [];
                if (options.defaults) {
                    object.ctype = options.enums === String ? "STRING" : 0;
                    object.packed = false;
                    object.deprecated = false;
                    object.lazy = false;
                    object.jstype = options.enums === String ? "JS_NORMAL" : 0;
                    object.weak = false;
                    object[".experimental_field"] = false;
                }
                if (message.ctype != null && message.hasOwnProperty("ctype"))
                    object.ctype = options.enums === String ? $root.google.protobuf.FieldOptions.CType[message.ctype] : message.ctype;
                if (message.packed != null && message.hasOwnProperty("packed"))
                    object.packed = message.packed;
                if (message.deprecated != null && message.hasOwnProperty("deprecated"))
                    object.deprecated = message.deprecated;
                if (message.lazy != null && message.hasOwnProperty("lazy"))
                    object.lazy = message.lazy;
                if (message.jstype != null && message.hasOwnProperty("jstype"))
                    object.jstype = options.enums === String ? $root.google.protobuf.FieldOptions.JSType[message.jstype] : message.jstype;
                if (message.weak != null && message.hasOwnProperty("weak"))
                    object.weak = message.weak;
                if (message.uninterpreted_option && message.uninterpreted_option.length) {
                    object.uninterpreted_option = [];
                    for (var j = 0; j < message.uninterpreted_option.length; ++j)
                        object.uninterpreted_option[j] = $root.google.protobuf.UninterpretedOption.toObject(message.uninterpreted_option[j], options);
                }
                if (message[".experimental_field"] != null && message.hasOwnProperty(".experimental_field"))
                    object[".experimental_field"] = message[".experimental_field"];
                return object;
            };

            FieldOptions.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            FieldOptions.CType = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "STRING"] = 0;
                values[valuesById[1] = "CORD"] = 1;
                values[valuesById[2] = "STRING_PIECE"] = 2;
                return values;
            })();

            FieldOptions.JSType = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "JS_NORMAL"] = 0;
                values[valuesById[1] = "JS_STRING"] = 1;
                values[valuesById[2] = "JS_NUMBER"] = 2;
                return values;
            })();

            return FieldOptions;
        })();

        protobuf.OneofOptions = (function() {

            function OneofOptions(properties) {
                this.uninterpreted_option = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            OneofOptions.prototype.uninterpreted_option = $util.emptyArray;

            OneofOptions.create = function create(properties) {
                return new OneofOptions(properties);
            };

            OneofOptions.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.uninterpreted_option != null && message.uninterpreted_option.length)
                    for (var i = 0; i < message.uninterpreted_option.length; ++i)
                        $root.google.protobuf.UninterpretedOption.encode(message.uninterpreted_option[i], writer.uint32(7994).fork()).ldelim();
                return writer;
            };

            OneofOptions.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            OneofOptions.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.OneofOptions();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 999:
                        if (!(message.uninterpreted_option && message.uninterpreted_option.length))
                            message.uninterpreted_option = [];
                        message.uninterpreted_option.push($root.google.protobuf.UninterpretedOption.decode(reader, reader.uint32()));
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            OneofOptions.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            OneofOptions.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.uninterpreted_option != null && message.hasOwnProperty("uninterpreted_option")) {
                    if (!Array.isArray(message.uninterpreted_option))
                        return "uninterpreted_option: array expected";
                    for (var i = 0; i < message.uninterpreted_option.length; ++i) {
                        var error = $root.google.protobuf.UninterpretedOption.verify(message.uninterpreted_option[i]);
                        if (error)
                            return "uninterpreted_option." + error;
                    }
                }
                return null;
            };

            OneofOptions.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.OneofOptions)
                    return object;
                var message = new $root.google.protobuf.OneofOptions();
                if (object.uninterpreted_option) {
                    if (!Array.isArray(object.uninterpreted_option))
                        throw TypeError(".google.protobuf.OneofOptions.uninterpreted_option: array expected");
                    message.uninterpreted_option = [];
                    for (var i = 0; i < object.uninterpreted_option.length; ++i) {
                        if (typeof object.uninterpreted_option[i] !== "object")
                            throw TypeError(".google.protobuf.OneofOptions.uninterpreted_option: object expected");
                        message.uninterpreted_option[i] = $root.google.protobuf.UninterpretedOption.fromObject(object.uninterpreted_option[i]);
                    }
                }
                return message;
            };

            OneofOptions.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.uninterpreted_option = [];
                if (message.uninterpreted_option && message.uninterpreted_option.length) {
                    object.uninterpreted_option = [];
                    for (var j = 0; j < message.uninterpreted_option.length; ++j)
                        object.uninterpreted_option[j] = $root.google.protobuf.UninterpretedOption.toObject(message.uninterpreted_option[j], options);
                }
                return object;
            };

            OneofOptions.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return OneofOptions;
        })();

        protobuf.EnumOptions = (function() {

            function EnumOptions(properties) {
                this.uninterpreted_option = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            EnumOptions.prototype.allow_alias = false;
            EnumOptions.prototype.deprecated = false;
            EnumOptions.prototype.uninterpreted_option = $util.emptyArray;
            EnumOptions.prototype[".has_bitcoin_only_values"] = false;

            EnumOptions.create = function create(properties) {
                return new EnumOptions(properties);
            };

            EnumOptions.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.allow_alias != null && Object.hasOwnProperty.call(message, "allow_alias"))
                    writer.uint32(16).bool(message.allow_alias);
                if (message.deprecated != null && Object.hasOwnProperty.call(message, "deprecated"))
                    writer.uint32(24).bool(message.deprecated);
                if (message.uninterpreted_option != null && message.uninterpreted_option.length)
                    for (var i = 0; i < message.uninterpreted_option.length; ++i)
                        $root.google.protobuf.UninterpretedOption.encode(message.uninterpreted_option[i], writer.uint32(7994).fork()).ldelim();
                if (message[".has_bitcoin_only_values"] != null && Object.hasOwnProperty.call(message, ".has_bitcoin_only_values"))
                    writer.uint32(408008).bool(message[".has_bitcoin_only_values"]);
                return writer;
            };

            EnumOptions.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            EnumOptions.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.EnumOptions();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 2:
                        message.allow_alias = reader.bool();
                        break;
                    case 3:
                        message.deprecated = reader.bool();
                        break;
                    case 999:
                        if (!(message.uninterpreted_option && message.uninterpreted_option.length))
                            message.uninterpreted_option = [];
                        message.uninterpreted_option.push($root.google.protobuf.UninterpretedOption.decode(reader, reader.uint32()));
                        break;
                    case 51001:
                        message[".has_bitcoin_only_values"] = reader.bool();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            EnumOptions.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            EnumOptions.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.allow_alias != null && message.hasOwnProperty("allow_alias"))
                    if (typeof message.allow_alias !== "boolean")
                        return "allow_alias: boolean expected";
                if (message.deprecated != null && message.hasOwnProperty("deprecated"))
                    if (typeof message.deprecated !== "boolean")
                        return "deprecated: boolean expected";
                if (message.uninterpreted_option != null && message.hasOwnProperty("uninterpreted_option")) {
                    if (!Array.isArray(message.uninterpreted_option))
                        return "uninterpreted_option: array expected";
                    for (var i = 0; i < message.uninterpreted_option.length; ++i) {
                        var error = $root.google.protobuf.UninterpretedOption.verify(message.uninterpreted_option[i]);
                        if (error)
                            return "uninterpreted_option." + error;
                    }
                }
                if (message[".has_bitcoin_only_values"] != null && message.hasOwnProperty(".has_bitcoin_only_values"))
                    if (typeof message[".has_bitcoin_only_values"] !== "boolean")
                        return ".has_bitcoin_only_values: boolean expected";
                return null;
            };

            EnumOptions.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.EnumOptions)
                    return object;
                var message = new $root.google.protobuf.EnumOptions();
                if (object.allow_alias != null)
                    message.allow_alias = Boolean(object.allow_alias);
                if (object.deprecated != null)
                    message.deprecated = Boolean(object.deprecated);
                if (object.uninterpreted_option) {
                    if (!Array.isArray(object.uninterpreted_option))
                        throw TypeError(".google.protobuf.EnumOptions.uninterpreted_option: array expected");
                    message.uninterpreted_option = [];
                    for (var i = 0; i < object.uninterpreted_option.length; ++i) {
                        if (typeof object.uninterpreted_option[i] !== "object")
                            throw TypeError(".google.protobuf.EnumOptions.uninterpreted_option: object expected");
                        message.uninterpreted_option[i] = $root.google.protobuf.UninterpretedOption.fromObject(object.uninterpreted_option[i]);
                    }
                }
                if (object[".has_bitcoin_only_values"] != null)
                    message[".has_bitcoin_only_values"] = Boolean(object[".has_bitcoin_only_values"]);
                return message;
            };

            EnumOptions.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.uninterpreted_option = [];
                if (options.defaults) {
                    object.allow_alias = false;
                    object.deprecated = false;
                    object[".has_bitcoin_only_values"] = false;
                }
                if (message.allow_alias != null && message.hasOwnProperty("allow_alias"))
                    object.allow_alias = message.allow_alias;
                if (message.deprecated != null && message.hasOwnProperty("deprecated"))
                    object.deprecated = message.deprecated;
                if (message.uninterpreted_option && message.uninterpreted_option.length) {
                    object.uninterpreted_option = [];
                    for (var j = 0; j < message.uninterpreted_option.length; ++j)
                        object.uninterpreted_option[j] = $root.google.protobuf.UninterpretedOption.toObject(message.uninterpreted_option[j], options);
                }
                if (message[".has_bitcoin_only_values"] != null && message.hasOwnProperty(".has_bitcoin_only_values"))
                    object[".has_bitcoin_only_values"] = message[".has_bitcoin_only_values"];
                return object;
            };

            EnumOptions.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return EnumOptions;
        })();

        protobuf.EnumValueOptions = (function() {

            function EnumValueOptions(properties) {
                this.uninterpreted_option = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            EnumValueOptions.prototype.deprecated = false;
            EnumValueOptions.prototype.uninterpreted_option = $util.emptyArray;
            EnumValueOptions.prototype[".wire_in"] = false;
            EnumValueOptions.prototype[".wire_out"] = false;
            EnumValueOptions.prototype[".wire_debug_in"] = false;
            EnumValueOptions.prototype[".wire_debug_out"] = false;
            EnumValueOptions.prototype[".wire_tiny"] = false;
            EnumValueOptions.prototype[".wire_bootloader"] = false;
            EnumValueOptions.prototype[".wire_no_fsm"] = false;
            EnumValueOptions.prototype[".bitcoin_only"] = false;

            EnumValueOptions.create = function create(properties) {
                return new EnumValueOptions(properties);
            };

            EnumValueOptions.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.deprecated != null && Object.hasOwnProperty.call(message, "deprecated"))
                    writer.uint32(8).bool(message.deprecated);
                if (message.uninterpreted_option != null && message.uninterpreted_option.length)
                    for (var i = 0; i < message.uninterpreted_option.length; ++i)
                        $root.google.protobuf.UninterpretedOption.encode(message.uninterpreted_option[i], writer.uint32(7994).fork()).ldelim();
                if (message[".wire_in"] != null && Object.hasOwnProperty.call(message, ".wire_in"))
                    writer.uint32(400016).bool(message[".wire_in"]);
                if (message[".wire_out"] != null && Object.hasOwnProperty.call(message, ".wire_out"))
                    writer.uint32(400024).bool(message[".wire_out"]);
                if (message[".wire_debug_in"] != null && Object.hasOwnProperty.call(message, ".wire_debug_in"))
                    writer.uint32(400032).bool(message[".wire_debug_in"]);
                if (message[".wire_debug_out"] != null && Object.hasOwnProperty.call(message, ".wire_debug_out"))
                    writer.uint32(400040).bool(message[".wire_debug_out"]);
                if (message[".wire_tiny"] != null && Object.hasOwnProperty.call(message, ".wire_tiny"))
                    writer.uint32(400048).bool(message[".wire_tiny"]);
                if (message[".wire_bootloader"] != null && Object.hasOwnProperty.call(message, ".wire_bootloader"))
                    writer.uint32(400056).bool(message[".wire_bootloader"]);
                if (message[".wire_no_fsm"] != null && Object.hasOwnProperty.call(message, ".wire_no_fsm"))
                    writer.uint32(400064).bool(message[".wire_no_fsm"]);
                if (message[".bitcoin_only"] != null && Object.hasOwnProperty.call(message, ".bitcoin_only"))
                    writer.uint32(480000).bool(message[".bitcoin_only"]);
                return writer;
            };

            EnumValueOptions.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            EnumValueOptions.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.EnumValueOptions();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.deprecated = reader.bool();
                        break;
                    case 999:
                        if (!(message.uninterpreted_option && message.uninterpreted_option.length))
                            message.uninterpreted_option = [];
                        message.uninterpreted_option.push($root.google.protobuf.UninterpretedOption.decode(reader, reader.uint32()));
                        break;
                    case 50002:
                        message[".wire_in"] = reader.bool();
                        break;
                    case 50003:
                        message[".wire_out"] = reader.bool();
                        break;
                    case 50004:
                        message[".wire_debug_in"] = reader.bool();
                        break;
                    case 50005:
                        message[".wire_debug_out"] = reader.bool();
                        break;
                    case 50006:
                        message[".wire_tiny"] = reader.bool();
                        break;
                    case 50007:
                        message[".wire_bootloader"] = reader.bool();
                        break;
                    case 50008:
                        message[".wire_no_fsm"] = reader.bool();
                        break;
                    case 60000:
                        message[".bitcoin_only"] = reader.bool();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            EnumValueOptions.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            EnumValueOptions.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.deprecated != null && message.hasOwnProperty("deprecated"))
                    if (typeof message.deprecated !== "boolean")
                        return "deprecated: boolean expected";
                if (message.uninterpreted_option != null && message.hasOwnProperty("uninterpreted_option")) {
                    if (!Array.isArray(message.uninterpreted_option))
                        return "uninterpreted_option: array expected";
                    for (var i = 0; i < message.uninterpreted_option.length; ++i) {
                        var error = $root.google.protobuf.UninterpretedOption.verify(message.uninterpreted_option[i]);
                        if (error)
                            return "uninterpreted_option." + error;
                    }
                }
                if (message[".wire_in"] != null && message.hasOwnProperty(".wire_in"))
                    if (typeof message[".wire_in"] !== "boolean")
                        return ".wire_in: boolean expected";
                if (message[".wire_out"] != null && message.hasOwnProperty(".wire_out"))
                    if (typeof message[".wire_out"] !== "boolean")
                        return ".wire_out: boolean expected";
                if (message[".wire_debug_in"] != null && message.hasOwnProperty(".wire_debug_in"))
                    if (typeof message[".wire_debug_in"] !== "boolean")
                        return ".wire_debug_in: boolean expected";
                if (message[".wire_debug_out"] != null && message.hasOwnProperty(".wire_debug_out"))
                    if (typeof message[".wire_debug_out"] !== "boolean")
                        return ".wire_debug_out: boolean expected";
                if (message[".wire_tiny"] != null && message.hasOwnProperty(".wire_tiny"))
                    if (typeof message[".wire_tiny"] !== "boolean")
                        return ".wire_tiny: boolean expected";
                if (message[".wire_bootloader"] != null && message.hasOwnProperty(".wire_bootloader"))
                    if (typeof message[".wire_bootloader"] !== "boolean")
                        return ".wire_bootloader: boolean expected";
                if (message[".wire_no_fsm"] != null && message.hasOwnProperty(".wire_no_fsm"))
                    if (typeof message[".wire_no_fsm"] !== "boolean")
                        return ".wire_no_fsm: boolean expected";
                if (message[".bitcoin_only"] != null && message.hasOwnProperty(".bitcoin_only"))
                    if (typeof message[".bitcoin_only"] !== "boolean")
                        return ".bitcoin_only: boolean expected";
                return null;
            };

            EnumValueOptions.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.EnumValueOptions)
                    return object;
                var message = new $root.google.protobuf.EnumValueOptions();
                if (object.deprecated != null)
                    message.deprecated = Boolean(object.deprecated);
                if (object.uninterpreted_option) {
                    if (!Array.isArray(object.uninterpreted_option))
                        throw TypeError(".google.protobuf.EnumValueOptions.uninterpreted_option: array expected");
                    message.uninterpreted_option = [];
                    for (var i = 0; i < object.uninterpreted_option.length; ++i) {
                        if (typeof object.uninterpreted_option[i] !== "object")
                            throw TypeError(".google.protobuf.EnumValueOptions.uninterpreted_option: object expected");
                        message.uninterpreted_option[i] = $root.google.protobuf.UninterpretedOption.fromObject(object.uninterpreted_option[i]);
                    }
                }
                if (object[".wire_in"] != null)
                    message[".wire_in"] = Boolean(object[".wire_in"]);
                if (object[".wire_out"] != null)
                    message[".wire_out"] = Boolean(object[".wire_out"]);
                if (object[".wire_debug_in"] != null)
                    message[".wire_debug_in"] = Boolean(object[".wire_debug_in"]);
                if (object[".wire_debug_out"] != null)
                    message[".wire_debug_out"] = Boolean(object[".wire_debug_out"]);
                if (object[".wire_tiny"] != null)
                    message[".wire_tiny"] = Boolean(object[".wire_tiny"]);
                if (object[".wire_bootloader"] != null)
                    message[".wire_bootloader"] = Boolean(object[".wire_bootloader"]);
                if (object[".wire_no_fsm"] != null)
                    message[".wire_no_fsm"] = Boolean(object[".wire_no_fsm"]);
                if (object[".bitcoin_only"] != null)
                    message[".bitcoin_only"] = Boolean(object[".bitcoin_only"]);
                return message;
            };

            EnumValueOptions.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.uninterpreted_option = [];
                if (options.defaults) {
                    object.deprecated = false;
                    object[".wire_in"] = false;
                    object[".wire_out"] = false;
                    object[".wire_debug_in"] = false;
                    object[".wire_debug_out"] = false;
                    object[".wire_tiny"] = false;
                    object[".wire_bootloader"] = false;
                    object[".wire_no_fsm"] = false;
                    object[".bitcoin_only"] = false;
                }
                if (message.deprecated != null && message.hasOwnProperty("deprecated"))
                    object.deprecated = message.deprecated;
                if (message.uninterpreted_option && message.uninterpreted_option.length) {
                    object.uninterpreted_option = [];
                    for (var j = 0; j < message.uninterpreted_option.length; ++j)
                        object.uninterpreted_option[j] = $root.google.protobuf.UninterpretedOption.toObject(message.uninterpreted_option[j], options);
                }
                if (message[".wire_in"] != null && message.hasOwnProperty(".wire_in"))
                    object[".wire_in"] = message[".wire_in"];
                if (message[".wire_out"] != null && message.hasOwnProperty(".wire_out"))
                    object[".wire_out"] = message[".wire_out"];
                if (message[".wire_debug_in"] != null && message.hasOwnProperty(".wire_debug_in"))
                    object[".wire_debug_in"] = message[".wire_debug_in"];
                if (message[".wire_debug_out"] != null && message.hasOwnProperty(".wire_debug_out"))
                    object[".wire_debug_out"] = message[".wire_debug_out"];
                if (message[".wire_tiny"] != null && message.hasOwnProperty(".wire_tiny"))
                    object[".wire_tiny"] = message[".wire_tiny"];
                if (message[".wire_bootloader"] != null && message.hasOwnProperty(".wire_bootloader"))
                    object[".wire_bootloader"] = message[".wire_bootloader"];
                if (message[".wire_no_fsm"] != null && message.hasOwnProperty(".wire_no_fsm"))
                    object[".wire_no_fsm"] = message[".wire_no_fsm"];
                if (message[".bitcoin_only"] != null && message.hasOwnProperty(".bitcoin_only"))
                    object[".bitcoin_only"] = message[".bitcoin_only"];
                return object;
            };

            EnumValueOptions.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return EnumValueOptions;
        })();

        protobuf.ServiceOptions = (function() {

            function ServiceOptions(properties) {
                this.uninterpreted_option = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            ServiceOptions.prototype.deprecated = false;
            ServiceOptions.prototype.uninterpreted_option = $util.emptyArray;

            ServiceOptions.create = function create(properties) {
                return new ServiceOptions(properties);
            };

            ServiceOptions.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.deprecated != null && Object.hasOwnProperty.call(message, "deprecated"))
                    writer.uint32(264).bool(message.deprecated);
                if (message.uninterpreted_option != null && message.uninterpreted_option.length)
                    for (var i = 0; i < message.uninterpreted_option.length; ++i)
                        $root.google.protobuf.UninterpretedOption.encode(message.uninterpreted_option[i], writer.uint32(7994).fork()).ldelim();
                return writer;
            };

            ServiceOptions.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            ServiceOptions.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.ServiceOptions();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 33:
                        message.deprecated = reader.bool();
                        break;
                    case 999:
                        if (!(message.uninterpreted_option && message.uninterpreted_option.length))
                            message.uninterpreted_option = [];
                        message.uninterpreted_option.push($root.google.protobuf.UninterpretedOption.decode(reader, reader.uint32()));
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            ServiceOptions.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            ServiceOptions.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.deprecated != null && message.hasOwnProperty("deprecated"))
                    if (typeof message.deprecated !== "boolean")
                        return "deprecated: boolean expected";
                if (message.uninterpreted_option != null && message.hasOwnProperty("uninterpreted_option")) {
                    if (!Array.isArray(message.uninterpreted_option))
                        return "uninterpreted_option: array expected";
                    for (var i = 0; i < message.uninterpreted_option.length; ++i) {
                        var error = $root.google.protobuf.UninterpretedOption.verify(message.uninterpreted_option[i]);
                        if (error)
                            return "uninterpreted_option." + error;
                    }
                }
                return null;
            };

            ServiceOptions.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.ServiceOptions)
                    return object;
                var message = new $root.google.protobuf.ServiceOptions();
                if (object.deprecated != null)
                    message.deprecated = Boolean(object.deprecated);
                if (object.uninterpreted_option) {
                    if (!Array.isArray(object.uninterpreted_option))
                        throw TypeError(".google.protobuf.ServiceOptions.uninterpreted_option: array expected");
                    message.uninterpreted_option = [];
                    for (var i = 0; i < object.uninterpreted_option.length; ++i) {
                        if (typeof object.uninterpreted_option[i] !== "object")
                            throw TypeError(".google.protobuf.ServiceOptions.uninterpreted_option: object expected");
                        message.uninterpreted_option[i] = $root.google.protobuf.UninterpretedOption.fromObject(object.uninterpreted_option[i]);
                    }
                }
                return message;
            };

            ServiceOptions.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.uninterpreted_option = [];
                if (options.defaults)
                    object.deprecated = false;
                if (message.deprecated != null && message.hasOwnProperty("deprecated"))
                    object.deprecated = message.deprecated;
                if (message.uninterpreted_option && message.uninterpreted_option.length) {
                    object.uninterpreted_option = [];
                    for (var j = 0; j < message.uninterpreted_option.length; ++j)
                        object.uninterpreted_option[j] = $root.google.protobuf.UninterpretedOption.toObject(message.uninterpreted_option[j], options);
                }
                return object;
            };

            ServiceOptions.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return ServiceOptions;
        })();

        protobuf.MethodOptions = (function() {

            function MethodOptions(properties) {
                this.uninterpreted_option = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            MethodOptions.prototype.deprecated = false;
            MethodOptions.prototype.uninterpreted_option = $util.emptyArray;

            MethodOptions.create = function create(properties) {
                return new MethodOptions(properties);
            };

            MethodOptions.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.deprecated != null && Object.hasOwnProperty.call(message, "deprecated"))
                    writer.uint32(264).bool(message.deprecated);
                if (message.uninterpreted_option != null && message.uninterpreted_option.length)
                    for (var i = 0; i < message.uninterpreted_option.length; ++i)
                        $root.google.protobuf.UninterpretedOption.encode(message.uninterpreted_option[i], writer.uint32(7994).fork()).ldelim();
                return writer;
            };

            MethodOptions.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            MethodOptions.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.MethodOptions();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 33:
                        message.deprecated = reader.bool();
                        break;
                    case 999:
                        if (!(message.uninterpreted_option && message.uninterpreted_option.length))
                            message.uninterpreted_option = [];
                        message.uninterpreted_option.push($root.google.protobuf.UninterpretedOption.decode(reader, reader.uint32()));
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            MethodOptions.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            MethodOptions.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.deprecated != null && message.hasOwnProperty("deprecated"))
                    if (typeof message.deprecated !== "boolean")
                        return "deprecated: boolean expected";
                if (message.uninterpreted_option != null && message.hasOwnProperty("uninterpreted_option")) {
                    if (!Array.isArray(message.uninterpreted_option))
                        return "uninterpreted_option: array expected";
                    for (var i = 0; i < message.uninterpreted_option.length; ++i) {
                        var error = $root.google.protobuf.UninterpretedOption.verify(message.uninterpreted_option[i]);
                        if (error)
                            return "uninterpreted_option." + error;
                    }
                }
                return null;
            };

            MethodOptions.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.MethodOptions)
                    return object;
                var message = new $root.google.protobuf.MethodOptions();
                if (object.deprecated != null)
                    message.deprecated = Boolean(object.deprecated);
                if (object.uninterpreted_option) {
                    if (!Array.isArray(object.uninterpreted_option))
                        throw TypeError(".google.protobuf.MethodOptions.uninterpreted_option: array expected");
                    message.uninterpreted_option = [];
                    for (var i = 0; i < object.uninterpreted_option.length; ++i) {
                        if (typeof object.uninterpreted_option[i] !== "object")
                            throw TypeError(".google.protobuf.MethodOptions.uninterpreted_option: object expected");
                        message.uninterpreted_option[i] = $root.google.protobuf.UninterpretedOption.fromObject(object.uninterpreted_option[i]);
                    }
                }
                return message;
            };

            MethodOptions.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.uninterpreted_option = [];
                if (options.defaults)
                    object.deprecated = false;
                if (message.deprecated != null && message.hasOwnProperty("deprecated"))
                    object.deprecated = message.deprecated;
                if (message.uninterpreted_option && message.uninterpreted_option.length) {
                    object.uninterpreted_option = [];
                    for (var j = 0; j < message.uninterpreted_option.length; ++j)
                        object.uninterpreted_option[j] = $root.google.protobuf.UninterpretedOption.toObject(message.uninterpreted_option[j], options);
                }
                return object;
            };

            MethodOptions.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return MethodOptions;
        })();

        protobuf.UninterpretedOption = (function() {

            function UninterpretedOption(properties) {
                this.name = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            UninterpretedOption.prototype.name = $util.emptyArray;
            UninterpretedOption.prototype.identifier_value = "";
            UninterpretedOption.prototype.positive_int_value = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
            UninterpretedOption.prototype.negative_int_value = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
            UninterpretedOption.prototype.double_value = 0;
            UninterpretedOption.prototype.string_value = $util.newBuffer([]);
            UninterpretedOption.prototype.aggregate_value = "";

            UninterpretedOption.create = function create(properties) {
                return new UninterpretedOption(properties);
            };

            UninterpretedOption.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.name != null && message.name.length)
                    for (var i = 0; i < message.name.length; ++i)
                        $root.google.protobuf.UninterpretedOption.NamePart.encode(message.name[i], writer.uint32(18).fork()).ldelim();
                if (message.identifier_value != null && Object.hasOwnProperty.call(message, "identifier_value"))
                    writer.uint32(26).string(message.identifier_value);
                if (message.positive_int_value != null && Object.hasOwnProperty.call(message, "positive_int_value"))
                    writer.uint32(32).uint64(message.positive_int_value);
                if (message.negative_int_value != null && Object.hasOwnProperty.call(message, "negative_int_value"))
                    writer.uint32(40).int64(message.negative_int_value);
                if (message.double_value != null && Object.hasOwnProperty.call(message, "double_value"))
                    writer.uint32(49).double(message.double_value);
                if (message.string_value != null && Object.hasOwnProperty.call(message, "string_value"))
                    writer.uint32(58).bytes(message.string_value);
                if (message.aggregate_value != null && Object.hasOwnProperty.call(message, "aggregate_value"))
                    writer.uint32(66).string(message.aggregate_value);
                return writer;
            };

            UninterpretedOption.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            UninterpretedOption.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.UninterpretedOption();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 2:
                        if (!(message.name && message.name.length))
                            message.name = [];
                        message.name.push($root.google.protobuf.UninterpretedOption.NamePart.decode(reader, reader.uint32()));
                        break;
                    case 3:
                        message.identifier_value = reader.string();
                        break;
                    case 4:
                        message.positive_int_value = reader.uint64();
                        break;
                    case 5:
                        message.negative_int_value = reader.int64();
                        break;
                    case 6:
                        message.double_value = reader.double();
                        break;
                    case 7:
                        message.string_value = reader.bytes();
                        break;
                    case 8:
                        message.aggregate_value = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            UninterpretedOption.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            UninterpretedOption.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.name != null && message.hasOwnProperty("name")) {
                    if (!Array.isArray(message.name))
                        return "name: array expected";
                    for (var i = 0; i < message.name.length; ++i) {
                        var error = $root.google.protobuf.UninterpretedOption.NamePart.verify(message.name[i]);
                        if (error)
                            return "name." + error;
                    }
                }
                if (message.identifier_value != null && message.hasOwnProperty("identifier_value"))
                    if (!$util.isString(message.identifier_value))
                        return "identifier_value: string expected";
                if (message.positive_int_value != null && message.hasOwnProperty("positive_int_value"))
                    if (!$util.isInteger(message.positive_int_value) && !(message.positive_int_value && $util.isInteger(message.positive_int_value.low) && $util.isInteger(message.positive_int_value.high)))
                        return "positive_int_value: integer|Long expected";
                if (message.negative_int_value != null && message.hasOwnProperty("negative_int_value"))
                    if (!$util.isInteger(message.negative_int_value) && !(message.negative_int_value && $util.isInteger(message.negative_int_value.low) && $util.isInteger(message.negative_int_value.high)))
                        return "negative_int_value: integer|Long expected";
                if (message.double_value != null && message.hasOwnProperty("double_value"))
                    if (typeof message.double_value !== "number")
                        return "double_value: number expected";
                if (message.string_value != null && message.hasOwnProperty("string_value"))
                    if (!(message.string_value && typeof message.string_value.length === "number" || $util.isString(message.string_value)))
                        return "string_value: buffer expected";
                if (message.aggregate_value != null && message.hasOwnProperty("aggregate_value"))
                    if (!$util.isString(message.aggregate_value))
                        return "aggregate_value: string expected";
                return null;
            };

            UninterpretedOption.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.UninterpretedOption)
                    return object;
                var message = new $root.google.protobuf.UninterpretedOption();
                if (object.name) {
                    if (!Array.isArray(object.name))
                        throw TypeError(".google.protobuf.UninterpretedOption.name: array expected");
                    message.name = [];
                    for (var i = 0; i < object.name.length; ++i) {
                        if (typeof object.name[i] !== "object")
                            throw TypeError(".google.protobuf.UninterpretedOption.name: object expected");
                        message.name[i] = $root.google.protobuf.UninterpretedOption.NamePart.fromObject(object.name[i]);
                    }
                }
                if (object.identifier_value != null)
                    message.identifier_value = String(object.identifier_value);
                if (object.positive_int_value != null)
                    if ($util.Long)
                        (message.positive_int_value = $util.Long.fromValue(object.positive_int_value)).unsigned = true;
                    else if (typeof object.positive_int_value === "string")
                        message.positive_int_value = parseInt(object.positive_int_value, 10);
                    else if (typeof object.positive_int_value === "number")
                        message.positive_int_value = object.positive_int_value;
                    else if (typeof object.positive_int_value === "object")
                        message.positive_int_value = new $util.LongBits(object.positive_int_value.low >>> 0, object.positive_int_value.high >>> 0).toNumber(true);
                if (object.negative_int_value != null)
                    if ($util.Long)
                        (message.negative_int_value = $util.Long.fromValue(object.negative_int_value)).unsigned = false;
                    else if (typeof object.negative_int_value === "string")
                        message.negative_int_value = parseInt(object.negative_int_value, 10);
                    else if (typeof object.negative_int_value === "number")
                        message.negative_int_value = object.negative_int_value;
                    else if (typeof object.negative_int_value === "object")
                        message.negative_int_value = new $util.LongBits(object.negative_int_value.low >>> 0, object.negative_int_value.high >>> 0).toNumber();
                if (object.double_value != null)
                    message.double_value = Number(object.double_value);
                if (object.string_value != null)
                    if (typeof object.string_value === "string")
                        $util.base64.decode(object.string_value, message.string_value = $util.newBuffer($util.base64.length(object.string_value)), 0);
                    else if (object.string_value.length)
                        message.string_value = object.string_value;
                if (object.aggregate_value != null)
                    message.aggregate_value = String(object.aggregate_value);
                return message;
            };

            UninterpretedOption.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.name = [];
                if (options.defaults) {
                    object.identifier_value = "";
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, true);
                        object.positive_int_value = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.positive_int_value = options.longs === String ? "0" : 0;
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.negative_int_value = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.negative_int_value = options.longs === String ? "0" : 0;
                    object.double_value = 0;
                    if (options.bytes === String)
                        object.string_value = "";
                    else {
                        object.string_value = [];
                        if (options.bytes !== Array)
                            object.string_value = $util.newBuffer(object.string_value);
                    }
                    object.aggregate_value = "";
                }
                if (message.name && message.name.length) {
                    object.name = [];
                    for (var j = 0; j < message.name.length; ++j)
                        object.name[j] = $root.google.protobuf.UninterpretedOption.NamePart.toObject(message.name[j], options);
                }
                if (message.identifier_value != null && message.hasOwnProperty("identifier_value"))
                    object.identifier_value = message.identifier_value;
                if (message.positive_int_value != null && message.hasOwnProperty("positive_int_value"))
                    if (typeof message.positive_int_value === "number")
                        object.positive_int_value = options.longs === String ? String(message.positive_int_value) : message.positive_int_value;
                    else
                        object.positive_int_value = options.longs === String ? $util.Long.prototype.toString.call(message.positive_int_value) : options.longs === Number ? new $util.LongBits(message.positive_int_value.low >>> 0, message.positive_int_value.high >>> 0).toNumber(true) : message.positive_int_value;
                if (message.negative_int_value != null && message.hasOwnProperty("negative_int_value"))
                    if (typeof message.negative_int_value === "number")
                        object.negative_int_value = options.longs === String ? String(message.negative_int_value) : message.negative_int_value;
                    else
                        object.negative_int_value = options.longs === String ? $util.Long.prototype.toString.call(message.negative_int_value) : options.longs === Number ? new $util.LongBits(message.negative_int_value.low >>> 0, message.negative_int_value.high >>> 0).toNumber() : message.negative_int_value;
                if (message.double_value != null && message.hasOwnProperty("double_value"))
                    object.double_value = options.json && !isFinite(message.double_value) ? String(message.double_value) : message.double_value;
                if (message.string_value != null && message.hasOwnProperty("string_value"))
                    object.string_value = options.bytes === String ? $util.base64.encode(message.string_value, 0, message.string_value.length) : options.bytes === Array ? Array.prototype.slice.call(message.string_value) : message.string_value;
                if (message.aggregate_value != null && message.hasOwnProperty("aggregate_value"))
                    object.aggregate_value = message.aggregate_value;
                return object;
            };

            UninterpretedOption.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            UninterpretedOption.NamePart = (function() {

                function NamePart(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                NamePart.prototype.name_part = "";
                NamePart.prototype.is_extension = false;

                NamePart.create = function create(properties) {
                    return new NamePart(properties);
                };

                NamePart.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    writer.uint32(10).string(message.name_part);
                    writer.uint32(16).bool(message.is_extension);
                    return writer;
                };

                NamePart.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                NamePart.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.UninterpretedOption.NamePart();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.name_part = reader.string();
                            break;
                        case 2:
                            message.is_extension = reader.bool();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    if (!message.hasOwnProperty("name_part"))
                        throw $util.ProtocolError("missing required 'name_part'", { instance: message });
                    if (!message.hasOwnProperty("is_extension"))
                        throw $util.ProtocolError("missing required 'is_extension'", { instance: message });
                    return message;
                };

                NamePart.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                NamePart.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (!$util.isString(message.name_part))
                        return "name_part: string expected";
                    if (typeof message.is_extension !== "boolean")
                        return "is_extension: boolean expected";
                    return null;
                };

                NamePart.fromObject = function fromObject(object) {
                    if (object instanceof $root.google.protobuf.UninterpretedOption.NamePart)
                        return object;
                    var message = new $root.google.protobuf.UninterpretedOption.NamePart();
                    if (object.name_part != null)
                        message.name_part = String(object.name_part);
                    if (object.is_extension != null)
                        message.is_extension = Boolean(object.is_extension);
                    return message;
                };

                NamePart.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.name_part = "";
                        object.is_extension = false;
                    }
                    if (message.name_part != null && message.hasOwnProperty("name_part"))
                        object.name_part = message.name_part;
                    if (message.is_extension != null && message.hasOwnProperty("is_extension"))
                        object.is_extension = message.is_extension;
                    return object;
                };

                NamePart.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return NamePart;
            })();

            return UninterpretedOption;
        })();

        protobuf.SourceCodeInfo = (function() {

            function SourceCodeInfo(properties) {
                this.location = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            SourceCodeInfo.prototype.location = $util.emptyArray;

            SourceCodeInfo.create = function create(properties) {
                return new SourceCodeInfo(properties);
            };

            SourceCodeInfo.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.location != null && message.location.length)
                    for (var i = 0; i < message.location.length; ++i)
                        $root.google.protobuf.SourceCodeInfo.Location.encode(message.location[i], writer.uint32(10).fork()).ldelim();
                return writer;
            };

            SourceCodeInfo.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            SourceCodeInfo.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.SourceCodeInfo();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (!(message.location && message.location.length))
                            message.location = [];
                        message.location.push($root.google.protobuf.SourceCodeInfo.Location.decode(reader, reader.uint32()));
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            SourceCodeInfo.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            SourceCodeInfo.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.location != null && message.hasOwnProperty("location")) {
                    if (!Array.isArray(message.location))
                        return "location: array expected";
                    for (var i = 0; i < message.location.length; ++i) {
                        var error = $root.google.protobuf.SourceCodeInfo.Location.verify(message.location[i]);
                        if (error)
                            return "location." + error;
                    }
                }
                return null;
            };

            SourceCodeInfo.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.SourceCodeInfo)
                    return object;
                var message = new $root.google.protobuf.SourceCodeInfo();
                if (object.location) {
                    if (!Array.isArray(object.location))
                        throw TypeError(".google.protobuf.SourceCodeInfo.location: array expected");
                    message.location = [];
                    for (var i = 0; i < object.location.length; ++i) {
                        if (typeof object.location[i] !== "object")
                            throw TypeError(".google.protobuf.SourceCodeInfo.location: object expected");
                        message.location[i] = $root.google.protobuf.SourceCodeInfo.Location.fromObject(object.location[i]);
                    }
                }
                return message;
            };

            SourceCodeInfo.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.location = [];
                if (message.location && message.location.length) {
                    object.location = [];
                    for (var j = 0; j < message.location.length; ++j)
                        object.location[j] = $root.google.protobuf.SourceCodeInfo.Location.toObject(message.location[j], options);
                }
                return object;
            };

            SourceCodeInfo.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            SourceCodeInfo.Location = (function() {

                function Location(properties) {
                    this.path = [];
                    this.span = [];
                    this.leading_detached_comments = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                Location.prototype.path = $util.emptyArray;
                Location.prototype.span = $util.emptyArray;
                Location.prototype.leading_comments = "";
                Location.prototype.trailing_comments = "";
                Location.prototype.leading_detached_comments = $util.emptyArray;

                Location.create = function create(properties) {
                    return new Location(properties);
                };

                Location.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.path != null && message.path.length) {
                        writer.uint32(10).fork();
                        for (var i = 0; i < message.path.length; ++i)
                            writer.int32(message.path[i]);
                        writer.ldelim();
                    }
                    if (message.span != null && message.span.length) {
                        writer.uint32(18).fork();
                        for (var i = 0; i < message.span.length; ++i)
                            writer.int32(message.span[i]);
                        writer.ldelim();
                    }
                    if (message.leading_comments != null && Object.hasOwnProperty.call(message, "leading_comments"))
                        writer.uint32(26).string(message.leading_comments);
                    if (message.trailing_comments != null && Object.hasOwnProperty.call(message, "trailing_comments"))
                        writer.uint32(34).string(message.trailing_comments);
                    if (message.leading_detached_comments != null && message.leading_detached_comments.length)
                        for (var i = 0; i < message.leading_detached_comments.length; ++i)
                            writer.uint32(50).string(message.leading_detached_comments[i]);
                    return writer;
                };

                Location.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                Location.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.SourceCodeInfo.Location();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            if (!(message.path && message.path.length))
                                message.path = [];
                            if ((tag & 7) === 2) {
                                var end2 = reader.uint32() + reader.pos;
                                while (reader.pos < end2)
                                    message.path.push(reader.int32());
                            } else
                                message.path.push(reader.int32());
                            break;
                        case 2:
                            if (!(message.span && message.span.length))
                                message.span = [];
                            if ((tag & 7) === 2) {
                                var end2 = reader.uint32() + reader.pos;
                                while (reader.pos < end2)
                                    message.span.push(reader.int32());
                            } else
                                message.span.push(reader.int32());
                            break;
                        case 3:
                            message.leading_comments = reader.string();
                            break;
                        case 4:
                            message.trailing_comments = reader.string();
                            break;
                        case 6:
                            if (!(message.leading_detached_comments && message.leading_detached_comments.length))
                                message.leading_detached_comments = [];
                            message.leading_detached_comments.push(reader.string());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                Location.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                Location.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.path != null && message.hasOwnProperty("path")) {
                        if (!Array.isArray(message.path))
                            return "path: array expected";
                        for (var i = 0; i < message.path.length; ++i)
                            if (!$util.isInteger(message.path[i]))
                                return "path: integer[] expected";
                    }
                    if (message.span != null && message.hasOwnProperty("span")) {
                        if (!Array.isArray(message.span))
                            return "span: array expected";
                        for (var i = 0; i < message.span.length; ++i)
                            if (!$util.isInteger(message.span[i]))
                                return "span: integer[] expected";
                    }
                    if (message.leading_comments != null && message.hasOwnProperty("leading_comments"))
                        if (!$util.isString(message.leading_comments))
                            return "leading_comments: string expected";
                    if (message.trailing_comments != null && message.hasOwnProperty("trailing_comments"))
                        if (!$util.isString(message.trailing_comments))
                            return "trailing_comments: string expected";
                    if (message.leading_detached_comments != null && message.hasOwnProperty("leading_detached_comments")) {
                        if (!Array.isArray(message.leading_detached_comments))
                            return "leading_detached_comments: array expected";
                        for (var i = 0; i < message.leading_detached_comments.length; ++i)
                            if (!$util.isString(message.leading_detached_comments[i]))
                                return "leading_detached_comments: string[] expected";
                    }
                    return null;
                };

                Location.fromObject = function fromObject(object) {
                    if (object instanceof $root.google.protobuf.SourceCodeInfo.Location)
                        return object;
                    var message = new $root.google.protobuf.SourceCodeInfo.Location();
                    if (object.path) {
                        if (!Array.isArray(object.path))
                            throw TypeError(".google.protobuf.SourceCodeInfo.Location.path: array expected");
                        message.path = [];
                        for (var i = 0; i < object.path.length; ++i)
                            message.path[i] = object.path[i] | 0;
                    }
                    if (object.span) {
                        if (!Array.isArray(object.span))
                            throw TypeError(".google.protobuf.SourceCodeInfo.Location.span: array expected");
                        message.span = [];
                        for (var i = 0; i < object.span.length; ++i)
                            message.span[i] = object.span[i] | 0;
                    }
                    if (object.leading_comments != null)
                        message.leading_comments = String(object.leading_comments);
                    if (object.trailing_comments != null)
                        message.trailing_comments = String(object.trailing_comments);
                    if (object.leading_detached_comments) {
                        if (!Array.isArray(object.leading_detached_comments))
                            throw TypeError(".google.protobuf.SourceCodeInfo.Location.leading_detached_comments: array expected");
                        message.leading_detached_comments = [];
                        for (var i = 0; i < object.leading_detached_comments.length; ++i)
                            message.leading_detached_comments[i] = String(object.leading_detached_comments[i]);
                    }
                    return message;
                };

                Location.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults) {
                        object.path = [];
                        object.span = [];
                        object.leading_detached_comments = [];
                    }
                    if (options.defaults) {
                        object.leading_comments = "";
                        object.trailing_comments = "";
                    }
                    if (message.path && message.path.length) {
                        object.path = [];
                        for (var j = 0; j < message.path.length; ++j)
                            object.path[j] = message.path[j];
                    }
                    if (message.span && message.span.length) {
                        object.span = [];
                        for (var j = 0; j < message.span.length; ++j)
                            object.span[j] = message.span[j];
                    }
                    if (message.leading_comments != null && message.hasOwnProperty("leading_comments"))
                        object.leading_comments = message.leading_comments;
                    if (message.trailing_comments != null && message.hasOwnProperty("trailing_comments"))
                        object.trailing_comments = message.trailing_comments;
                    if (message.leading_detached_comments && message.leading_detached_comments.length) {
                        object.leading_detached_comments = [];
                        for (var j = 0; j < message.leading_detached_comments.length; ++j)
                            object.leading_detached_comments[j] = message.leading_detached_comments[j];
                    }
                    return object;
                };

                Location.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return Location;
            })();

            return SourceCodeInfo;
        })();

        protobuf.GeneratedCodeInfo = (function() {

            function GeneratedCodeInfo(properties) {
                this.annotation = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            GeneratedCodeInfo.prototype.annotation = $util.emptyArray;

            GeneratedCodeInfo.create = function create(properties) {
                return new GeneratedCodeInfo(properties);
            };

            GeneratedCodeInfo.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.annotation != null && message.annotation.length)
                    for (var i = 0; i < message.annotation.length; ++i)
                        $root.google.protobuf.GeneratedCodeInfo.Annotation.encode(message.annotation[i], writer.uint32(10).fork()).ldelim();
                return writer;
            };

            GeneratedCodeInfo.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            GeneratedCodeInfo.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.GeneratedCodeInfo();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (!(message.annotation && message.annotation.length))
                            message.annotation = [];
                        message.annotation.push($root.google.protobuf.GeneratedCodeInfo.Annotation.decode(reader, reader.uint32()));
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            GeneratedCodeInfo.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            GeneratedCodeInfo.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.annotation != null && message.hasOwnProperty("annotation")) {
                    if (!Array.isArray(message.annotation))
                        return "annotation: array expected";
                    for (var i = 0; i < message.annotation.length; ++i) {
                        var error = $root.google.protobuf.GeneratedCodeInfo.Annotation.verify(message.annotation[i]);
                        if (error)
                            return "annotation." + error;
                    }
                }
                return null;
            };

            GeneratedCodeInfo.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.GeneratedCodeInfo)
                    return object;
                var message = new $root.google.protobuf.GeneratedCodeInfo();
                if (object.annotation) {
                    if (!Array.isArray(object.annotation))
                        throw TypeError(".google.protobuf.GeneratedCodeInfo.annotation: array expected");
                    message.annotation = [];
                    for (var i = 0; i < object.annotation.length; ++i) {
                        if (typeof object.annotation[i] !== "object")
                            throw TypeError(".google.protobuf.GeneratedCodeInfo.annotation: object expected");
                        message.annotation[i] = $root.google.protobuf.GeneratedCodeInfo.Annotation.fromObject(object.annotation[i]);
                    }
                }
                return message;
            };

            GeneratedCodeInfo.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.annotation = [];
                if (message.annotation && message.annotation.length) {
                    object.annotation = [];
                    for (var j = 0; j < message.annotation.length; ++j)
                        object.annotation[j] = $root.google.protobuf.GeneratedCodeInfo.Annotation.toObject(message.annotation[j], options);
                }
                return object;
            };

            GeneratedCodeInfo.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            GeneratedCodeInfo.Annotation = (function() {

                function Annotation(properties) {
                    this.path = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                Annotation.prototype.path = $util.emptyArray;
                Annotation.prototype.source_file = "";
                Annotation.prototype.begin = 0;
                Annotation.prototype.end = 0;

                Annotation.create = function create(properties) {
                    return new Annotation(properties);
                };

                Annotation.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.path != null && message.path.length) {
                        writer.uint32(10).fork();
                        for (var i = 0; i < message.path.length; ++i)
                            writer.int32(message.path[i]);
                        writer.ldelim();
                    }
                    if (message.source_file != null && Object.hasOwnProperty.call(message, "source_file"))
                        writer.uint32(18).string(message.source_file);
                    if (message.begin != null && Object.hasOwnProperty.call(message, "begin"))
                        writer.uint32(24).int32(message.begin);
                    if (message.end != null && Object.hasOwnProperty.call(message, "end"))
                        writer.uint32(32).int32(message.end);
                    return writer;
                };

                Annotation.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                Annotation.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.GeneratedCodeInfo.Annotation();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            if (!(message.path && message.path.length))
                                message.path = [];
                            if ((tag & 7) === 2) {
                                var end2 = reader.uint32() + reader.pos;
                                while (reader.pos < end2)
                                    message.path.push(reader.int32());
                            } else
                                message.path.push(reader.int32());
                            break;
                        case 2:
                            message.source_file = reader.string();
                            break;
                        case 3:
                            message.begin = reader.int32();
                            break;
                        case 4:
                            message.end = reader.int32();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                Annotation.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                Annotation.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.path != null && message.hasOwnProperty("path")) {
                        if (!Array.isArray(message.path))
                            return "path: array expected";
                        for (var i = 0; i < message.path.length; ++i)
                            if (!$util.isInteger(message.path[i]))
                                return "path: integer[] expected";
                    }
                    if (message.source_file != null && message.hasOwnProperty("source_file"))
                        if (!$util.isString(message.source_file))
                            return "source_file: string expected";
                    if (message.begin != null && message.hasOwnProperty("begin"))
                        if (!$util.isInteger(message.begin))
                            return "begin: integer expected";
                    if (message.end != null && message.hasOwnProperty("end"))
                        if (!$util.isInteger(message.end))
                            return "end: integer expected";
                    return null;
                };

                Annotation.fromObject = function fromObject(object) {
                    if (object instanceof $root.google.protobuf.GeneratedCodeInfo.Annotation)
                        return object;
                    var message = new $root.google.protobuf.GeneratedCodeInfo.Annotation();
                    if (object.path) {
                        if (!Array.isArray(object.path))
                            throw TypeError(".google.protobuf.GeneratedCodeInfo.Annotation.path: array expected");
                        message.path = [];
                        for (var i = 0; i < object.path.length; ++i)
                            message.path[i] = object.path[i] | 0;
                    }
                    if (object.source_file != null)
                        message.source_file = String(object.source_file);
                    if (object.begin != null)
                        message.begin = object.begin | 0;
                    if (object.end != null)
                        message.end = object.end | 0;
                    return message;
                };

                Annotation.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.path = [];
                    if (options.defaults) {
                        object.source_file = "";
                        object.begin = 0;
                        object.end = 0;
                    }
                    if (message.path && message.path.length) {
                        object.path = [];
                        for (var j = 0; j < message.path.length; ++j)
                            object.path[j] = message.path[j];
                    }
                    if (message.source_file != null && message.hasOwnProperty("source_file"))
                        object.source_file = message.source_file;
                    if (message.begin != null && message.hasOwnProperty("begin"))
                        object.begin = message.begin;
                    if (message.end != null && message.hasOwnProperty("end"))
                        object.end = message.end;
                    return object;
                };

                Annotation.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return Annotation;
            })();

            return GeneratedCodeInfo;
        })();

        return protobuf;
    })();

    return google;
})();
return {".AlephiumGetAddress": $root["AlephiumGetAddress"],
".AlephiumAddress": $root["AlephiumAddress"],
".AlephiumSignTx": $root["AlephiumSignTx"],
".AlephiumSignedTx": $root["AlephiumSignedTx"],
".AlephiumTxRequest": $root["AlephiumTxRequest"],
".AlephiumTxAck": $root["AlephiumTxAck"],
".AlephiumBytecodeRequest": $root["AlephiumBytecodeRequest"],
".AlephiumBytecodeAck": $root["AlephiumBytecodeAck"],
".AlephiumSignMessage": $root["AlephiumSignMessage"],
".AlephiumMessageSignature": $root["AlephiumMessageSignature"],
".AlgorandGetAddress": $root["AlgorandGetAddress"],
".AlgorandAddress": $root["AlgorandAddress"],
".AlgorandSignTx": $root["AlgorandSignTx"],
".AlgorandSignedTx": $root["AlgorandSignedTx"],
".AptosGetAddress": $root["AptosGetAddress"],
".AptosAddress": $root["AptosAddress"],
".AptosSignTx": $root["AptosSignTx"],
".AptosSignedTx": $root["AptosSignedTx"],
".AptosSignMessage": $root["AptosSignMessage"],
".AptosSignMessage.AptosMessagePayload": $root["AptosSignMessage"]["AptosMessagePayload"],
".AptosSignSIWAMessage": $root["AptosSignSIWAMessage"],
".AptosMessageSignature": $root["AptosMessageSignature"],
".BenfenGetAddress": $root["BenfenGetAddress"],
".BenfenAddress": $root["BenfenAddress"],
".BenfenSignTx": $root["BenfenSignTx"],
".BenfenSignedTx": $root["BenfenSignedTx"],
".BenfenTxRequest": $root["BenfenTxRequest"],
".BenfenTxAck": $root["BenfenTxAck"],
".BenfenSignMessage": $root["BenfenSignMessage"],
".BenfenMessageSignature": $root["BenfenMessageSignature"],
".BinanceGetAddress": $root["BinanceGetAddress"],
".BinanceAddress": $root["BinanceAddress"],
".BinanceGetPublicKey": $root["BinanceGetPublicKey"],
".BinancePublicKey": $root["BinancePublicKey"],
".BinanceSignTx": $root["BinanceSignTx"],
".BinanceTxRequest": $root["BinanceTxRequest"],
".BinanceTransferMsg": $root["BinanceTransferMsg"],
".BinanceTransferMsg.BinanceInputOutput": $root["BinanceTransferMsg"]["BinanceInputOutput"],
".BinanceTransferMsg.BinanceCoin": $root["BinanceTransferMsg"]["BinanceCoin"],
".BinanceOrderMsg": $root["BinanceOrderMsg"],
".BinanceCancelMsg": $root["BinanceCancelMsg"],
".BinanceSignedTx": $root["BinanceSignedTx"],
".MultisigRedeemScriptType": $root["MultisigRedeemScriptType"],
".MultisigRedeemScriptType.HDNodePathType": $root["MultisigRedeemScriptType"]["HDNodePathType"],
".GetPublicKey": $root["GetPublicKey"],
".PublicKey": $root["PublicKey"],
".GetAddress": $root["GetAddress"],
".Address": $root["Address"],
".GetOwnershipId": $root["GetOwnershipId"],
".OwnershipId": $root["OwnershipId"],
".SignMessage": $root["SignMessage"],
".MessageSignature": $root["MessageSignature"],
".VerifyMessage": $root["VerifyMessage"],
".SignTx": $root["SignTx"],
".SignTx.CoinJoinRequest": $root["SignTx"]["CoinJoinRequest"],
".TxRequest": $root["TxRequest"],
".TxRequest.TxRequestDetailsType": $root["TxRequest"]["TxRequestDetailsType"],
".TxRequest.TxRequestSerializedType": $root["TxRequest"]["TxRequestSerializedType"],
".TxAck": $root["TxAck"],
".TxAck.TransactionType": $root["TxAck"]["TransactionType"],
".TxAck.TransactionType.TxInputType": $root["TxAck"]["TransactionType"]["TxInputType"],
".TxAck.TransactionType.TxOutputBinType": $root["TxAck"]["TransactionType"]["TxOutputBinType"],
".TxAck.TransactionType.TxOutputType": $root["TxAck"]["TransactionType"]["TxOutputType"],
".TxInput": $root["TxInput"],
".TxOutput": $root["TxOutput"],
".PrevTx": $root["PrevTx"],
".PrevInput": $root["PrevInput"],
".PrevOutput": $root["PrevOutput"],
".TxAckPaymentRequest": $root["TxAckPaymentRequest"],
".TxAckPaymentRequest.PaymentRequestMemo": $root["TxAckPaymentRequest"]["PaymentRequestMemo"],
".TxAckPaymentRequest.TextMemo": $root["TxAckPaymentRequest"]["TextMemo"],
".TxAckPaymentRequest.RefundMemo": $root["TxAckPaymentRequest"]["RefundMemo"],
".TxAckPaymentRequest.CoinPurchaseMemo": $root["TxAckPaymentRequest"]["CoinPurchaseMemo"],
".TxAckInput": $root["TxAckInput"],
".TxAckInput.TxAckInputWrapper": $root["TxAckInput"]["TxAckInputWrapper"],
".TxAckOutput": $root["TxAckOutput"],
".TxAckOutput.TxAckOutputWrapper": $root["TxAckOutput"]["TxAckOutputWrapper"],
".TxAckPrevMeta": $root["TxAckPrevMeta"],
".TxAckPrevInput": $root["TxAckPrevInput"],
".TxAckPrevInput.TxAckPrevInputWrapper": $root["TxAckPrevInput"]["TxAckPrevInputWrapper"],
".TxAckPrevOutput": $root["TxAckPrevOutput"],
".TxAckPrevOutput.TxAckPrevOutputWrapper": $root["TxAckPrevOutput"]["TxAckPrevOutputWrapper"],
".TxAckPrevExtraData": $root["TxAckPrevExtraData"],
".TxAckPrevExtraData.TxAckPrevExtraDataWrapper": $root["TxAckPrevExtraData"]["TxAckPrevExtraDataWrapper"],
".GetOwnershipProof": $root["GetOwnershipProof"],
".OwnershipProof": $root["OwnershipProof"],
".AuthorizeCoinJoin": $root["AuthorizeCoinJoin"],
".SignPsbt": $root["SignPsbt"],
".SignedPsbt": $root["SignedPsbt"],
".ButtonRequest": $root["ButtonRequest"],
".ButtonAck": $root["ButtonAck"],
".CardanoBlockchainPointerType": $root["CardanoBlockchainPointerType"],
".CardanoNativeScript": $root["CardanoNativeScript"],
".CardanoGetNativeScriptHash": $root["CardanoGetNativeScriptHash"],
".CardanoNativeScriptHash": $root["CardanoNativeScriptHash"],
".CardanoAddressParametersType": $root["CardanoAddressParametersType"],
".CardanoGetAddress": $root["CardanoGetAddress"],
".CardanoAddress": $root["CardanoAddress"],
".CardanoGetPublicKey": $root["CardanoGetPublicKey"],
".CardanoPublicKey": $root["CardanoPublicKey"],
".CardanoSignTxInit": $root["CardanoSignTxInit"],
".CardanoTxInput": $root["CardanoTxInput"],
".CardanoTxOutput": $root["CardanoTxOutput"],
".CardanoAssetGroup": $root["CardanoAssetGroup"],
".CardanoToken": $root["CardanoToken"],
".CardanoTxInlineDatumChunk": $root["CardanoTxInlineDatumChunk"],
".CardanoTxReferenceScriptChunk": $root["CardanoTxReferenceScriptChunk"],
".CardanoPoolOwner": $root["CardanoPoolOwner"],
".CardanoPoolRelayParameters": $root["CardanoPoolRelayParameters"],
".CardanoPoolMetadataType": $root["CardanoPoolMetadataType"],
".CardanoPoolParametersType": $root["CardanoPoolParametersType"],
".CardanoDRep": $root["CardanoDRep"],
".CardanoTxCertificate": $root["CardanoTxCertificate"],
".CardanoTxWithdrawal": $root["CardanoTxWithdrawal"],
".CardanoCVoteRegistrationDelegation": $root["CardanoCVoteRegistrationDelegation"],
".CardanoCVoteRegistrationParametersType": $root["CardanoCVoteRegistrationParametersType"],
".CardanoTxAuxiliaryData": $root["CardanoTxAuxiliaryData"],
".CardanoTxMint": $root["CardanoTxMint"],
".CardanoTxCollateralInput": $root["CardanoTxCollateralInput"],
".CardanoTxRequiredSigner": $root["CardanoTxRequiredSigner"],
".CardanoTxReferenceInput": $root["CardanoTxReferenceInput"],
".CardanoTxItemAck": $root["CardanoTxItemAck"],
".CardanoTxAuxiliaryDataSupplement": $root["CardanoTxAuxiliaryDataSupplement"],
".CardanoTxWitnessRequest": $root["CardanoTxWitnessRequest"],
".CardanoTxWitnessResponse": $root["CardanoTxWitnessResponse"],
".CardanoTxHostAck": $root["CardanoTxHostAck"],
".CardanoTxBodyHash": $root["CardanoTxBodyHash"],
".CardanoSignTxFinished": $root["CardanoSignTxFinished"],
".CardanoSignMessage": $root["CardanoSignMessage"],
".CardanoMessageSignature": $root["CardanoMessageSignature"],
".ConfluxGetAddress": $root["ConfluxGetAddress"],
".ConfluxAddress": $root["ConfluxAddress"],
".ConfluxSignTx": $root["ConfluxSignTx"],
".ConfluxTxRequest": $root["ConfluxTxRequest"],
".ConfluxTxAck": $root["ConfluxTxAck"],
".ConfluxSignMessage": $root["ConfluxSignMessage"],
".ConfluxMessageSignature": $root["ConfluxMessageSignature"],
".ConfluxSignMessageCIP23": $root["ConfluxSignMessageCIP23"],
".CosmosGetAddress": $root["CosmosGetAddress"],
".CosmosAddress": $root["CosmosAddress"],
".CosmosSignTx": $root["CosmosSignTx"],
".CosmosSignedTx": $root["CosmosSignedTx"],
".HDNodeType": $root["HDNodeType"],
".CipherKeyValue": $root["CipherKeyValue"],
".CipheredKeyValue": $root["CipheredKeyValue"],
".IdentityType": $root["IdentityType"],
".SignIdentity": $root["SignIdentity"],
".SignedIdentity": $root["SignedIdentity"],
".GetECDHSessionKey": $root["GetECDHSessionKey"],
".ECDHSessionKey": $root["ECDHSessionKey"],
".CosiCommit": $root["CosiCommit"],
".CosiCommitment": $root["CosiCommitment"],
".CosiSign": $root["CosiSign"],
".CosiSignature": $root["CosiSignature"],
".BatchGetPublickeys": $root["BatchGetPublickeys"],
".BatchGetPublickeys.Path": $root["BatchGetPublickeys"]["Path"],
".EcdsaPublicKeys": $root["EcdsaPublicKeys"],
".EosGetPublicKey": $root["EosGetPublicKey"],
".EosPublicKey": $root["EosPublicKey"],
".EosSignTx": $root["EosSignTx"],
".EosSignTx.EosTxHeader": $root["EosSignTx"]["EosTxHeader"],
".EosTxActionRequest": $root["EosTxActionRequest"],
".EosTxActionAck": $root["EosTxActionAck"],
".EosTxActionAck.EosAsset": $root["EosTxActionAck"]["EosAsset"],
".EosTxActionAck.EosPermissionLevel": $root["EosTxActionAck"]["EosPermissionLevel"],
".EosTxActionAck.EosAuthorizationKey": $root["EosTxActionAck"]["EosAuthorizationKey"],
".EosTxActionAck.EosAuthorizationAccount": $root["EosTxActionAck"]["EosAuthorizationAccount"],
".EosTxActionAck.EosAuthorizationWait": $root["EosTxActionAck"]["EosAuthorizationWait"],
".EosTxActionAck.EosAuthorization": $root["EosTxActionAck"]["EosAuthorization"],
".EosTxActionAck.EosActionCommon": $root["EosTxActionAck"]["EosActionCommon"],
".EosTxActionAck.EosActionTransfer": $root["EosTxActionAck"]["EosActionTransfer"],
".EosTxActionAck.EosActionDelegate": $root["EosTxActionAck"]["EosActionDelegate"],
".EosTxActionAck.EosActionUndelegate": $root["EosTxActionAck"]["EosActionUndelegate"],
".EosTxActionAck.EosActionRefund": $root["EosTxActionAck"]["EosActionRefund"],
".EosTxActionAck.EosActionBuyRam": $root["EosTxActionAck"]["EosActionBuyRam"],
".EosTxActionAck.EosActionBuyRamBytes": $root["EosTxActionAck"]["EosActionBuyRamBytes"],
".EosTxActionAck.EosActionSellRam": $root["EosTxActionAck"]["EosActionSellRam"],
".EosTxActionAck.EosActionVoteProducer": $root["EosTxActionAck"]["EosActionVoteProducer"],
".EosTxActionAck.EosActionUpdateAuth": $root["EosTxActionAck"]["EosActionUpdateAuth"],
".EosTxActionAck.EosActionDeleteAuth": $root["EosTxActionAck"]["EosActionDeleteAuth"],
".EosTxActionAck.EosActionLinkAuth": $root["EosTxActionAck"]["EosActionLinkAuth"],
".EosTxActionAck.EosActionUnlinkAuth": $root["EosTxActionAck"]["EosActionUnlinkAuth"],
".EosTxActionAck.EosActionNewAccount": $root["EosTxActionAck"]["EosActionNewAccount"],
".EosTxActionAck.EosActionUnknown": $root["EosTxActionAck"]["EosActionUnknown"],
".EosSignedTx": $root["EosSignedTx"],
".EthereumNetworkInfo": $root["EthereumNetworkInfo"],
".EthereumTokenInfo": $root["EthereumTokenInfo"],
".EthereumDefinitions": $root["EthereumDefinitions"],
".EthereumSignTypedDataOneKey": $root["EthereumSignTypedDataOneKey"],
".EthereumTypedDataStructRequestOneKey": $root["EthereumTypedDataStructRequestOneKey"],
".EthereumTypedDataStructAckOneKey": $root["EthereumTypedDataStructAckOneKey"],
".EthereumTypedDataStructAckOneKey.EthereumStructMemberOneKey": $root["EthereumTypedDataStructAckOneKey"]["EthereumStructMemberOneKey"],
".EthereumTypedDataStructAckOneKey.EthereumFieldTypeOneKey": $root["EthereumTypedDataStructAckOneKey"]["EthereumFieldTypeOneKey"],
".EthereumTypedDataValueRequestOneKey": $root["EthereumTypedDataValueRequestOneKey"],
".EthereumTypedDataValueAckOneKey": $root["EthereumTypedDataValueAckOneKey"],
".EthereumGnosisSafeTxRequest": $root["EthereumGnosisSafeTxRequest"],
".EthereumGnosisSafeTxAck": $root["EthereumGnosisSafeTxAck"],
".EthereumSignTypedDataQR": $root["EthereumSignTypedDataQR"],
".EthereumSignTypedData": $root["EthereumSignTypedData"],
".EthereumTypedDataStructRequest": $root["EthereumTypedDataStructRequest"],
".EthereumTypedDataStructAck": $root["EthereumTypedDataStructAck"],
".EthereumTypedDataStructAck.EthereumStructMember": $root["EthereumTypedDataStructAck"]["EthereumStructMember"],
".EthereumTypedDataStructAck.EthereumFieldType": $root["EthereumTypedDataStructAck"]["EthereumFieldType"],
".EthereumTypedDataValueRequest": $root["EthereumTypedDataValueRequest"],
".EthereumTypedDataValueAck": $root["EthereumTypedDataValueAck"],
".EthereumGetPublicKeyOneKey": $root["EthereumGetPublicKeyOneKey"],
".EthereumPublicKeyOneKey": $root["EthereumPublicKeyOneKey"],
".EthereumGetAddressOneKey": $root["EthereumGetAddressOneKey"],
".EthereumAddressOneKey": $root["EthereumAddressOneKey"],
".EthereumSignTxOneKey": $root["EthereumSignTxOneKey"],
".EthereumAccessListOneKey": $root["EthereumAccessListOneKey"],
".EthereumSignTxEIP1559OneKey": $root["EthereumSignTxEIP1559OneKey"],
".EthereumAuthorizationSignature": $root["EthereumAuthorizationSignature"],
".EthereumSignTxEIP7702OneKey": $root["EthereumSignTxEIP7702OneKey"],
".EthereumSignTxEIP7702OneKey.EthereumAuthorizationOneKey": $root["EthereumSignTxEIP7702OneKey"]["EthereumAuthorizationOneKey"],
".EthereumTxRequestOneKey": $root["EthereumTxRequestOneKey"],
".EthereumTxAckOneKey": $root["EthereumTxAckOneKey"],
".EthereumSignMessageOneKey": $root["EthereumSignMessageOneKey"],
".EthereumMessageSignatureOneKey": $root["EthereumMessageSignatureOneKey"],
".EthereumVerifyMessageOneKey": $root["EthereumVerifyMessageOneKey"],
".EthereumSignTypedHashOneKey": $root["EthereumSignTypedHashOneKey"],
".EthereumTypedDataSignatureOneKey": $root["EthereumTypedDataSignatureOneKey"],
".EthereumGetPublicKey": $root["EthereumGetPublicKey"],
".EthereumPublicKey": $root["EthereumPublicKey"],
".EthereumGetAddress": $root["EthereumGetAddress"],
".EthereumAddress": $root["EthereumAddress"],
".EthereumSignTx": $root["EthereumSignTx"],
".EthereumSignTxEIP1559": $root["EthereumSignTxEIP1559"],
".EthereumSignTxEIP1559.EthereumAccessList": $root["EthereumSignTxEIP1559"]["EthereumAccessList"],
".EthereumTxRequest": $root["EthereumTxRequest"],
".EthereumTxAck": $root["EthereumTxAck"],
".EthereumSignMessage": $root["EthereumSignMessage"],
".EthereumMessageSignature": $root["EthereumMessageSignature"],
".EthereumVerifyMessage": $root["EthereumVerifyMessage"],
".EthereumSignTypedHash": $root["EthereumSignTypedHash"],
".EthereumTypedDataSignature": $root["EthereumTypedDataSignature"],
".FilecoinGetAddress": $root["FilecoinGetAddress"],
".FilecoinAddress": $root["FilecoinAddress"],
".FilecoinSignTx": $root["FilecoinSignTx"],
".FilecoinSignedTx": $root["FilecoinSignedTx"],
".KaspaGetAddress": $root["KaspaGetAddress"],
".KaspaAddress": $root["KaspaAddress"],
".KaspaSignTx": $root["KaspaSignTx"],
".KaspaTxInputRequest": $root["KaspaTxInputRequest"],
".KaspaTxInputAck": $root["KaspaTxInputAck"],
".KaspaSignedTx": $root["KaspaSignedTx"],
".LnurlAuth": $root["LnurlAuth"],
".LnurlAuthResp": $root["LnurlAuthResp"],
".Initialize": $root["Initialize"],
".GetFeatures": $root["GetFeatures"],
".OnekeyGetFeatures": $root["OnekeyGetFeatures"],
".Features": $root["Features"],
".OnekeyFeatures": $root["OnekeyFeatures"],
".LockDevice": $root["LockDevice"],
".SetBusy": $root["SetBusy"],
".ApplySettings": $root["ApplySettings"],
".ApplyFlags": $root["ApplyFlags"],
".ChangePin": $root["ChangePin"],
".ChangeWipeCode": $root["ChangeWipeCode"],
".SdProtect": $root["SdProtect"],
".Cancel": $root["Cancel"],
".GetEntropy": $root["GetEntropy"],
".Entropy": $root["Entropy"],
".GetFirmwareHash": $root["GetFirmwareHash"],
".FirmwareHash": $root["FirmwareHash"],
".WipeDevice": $root["WipeDevice"],
".LoadDevice": $root["LoadDevice"],
".ResetDevice": $root["ResetDevice"],
".BackupDevice": $root["BackupDevice"],
".EntropyRequest": $root["EntropyRequest"],
".EntropyAck": $root["EntropyAck"],
".RecoveryDevice": $root["RecoveryDevice"],
".WordRequest": $root["WordRequest"],
".WordAck": $root["WordAck"],
".SetU2FCounter": $root["SetU2FCounter"],
".GetNextU2FCounter": $root["GetNextU2FCounter"],
".NextU2FCounter": $root["NextU2FCounter"],
".DoPreauthorized": $root["DoPreauthorized"],
".PreauthorizedRequest": $root["PreauthorizedRequest"],
".CancelAuthorization": $root["CancelAuthorization"],
".GetNonce": $root["GetNonce"],
".Nonce": $root["Nonce"],
".WriteSEPrivateKey": $root["WriteSEPrivateKey"],
".ReadSEPublicKey": $root["ReadSEPublicKey"],
".SEPublicKey": $root["SEPublicKey"],
".WriteSEPublicCert": $root["WriteSEPublicCert"],
".ReadSEPublicCert": $root["ReadSEPublicCert"],
".SEPublicCert": $root["SEPublicCert"],
".SESignMessage": $root["SESignMessage"],
".SEMessageSignature": $root["SEMessageSignature"],
".ResourceUpload": $root["ResourceUpload"],
".ZoomRequest": $root["ZoomRequest"],
".BlurRequest": $root["BlurRequest"],
".ResourceRequest": $root["ResourceRequest"],
".ResourceAck": $root["ResourceAck"],
".ResourceUpdate": $root["ResourceUpdate"],
".ListResDir": $root["ListResDir"],
".FileInfoList": $root["FileInfoList"],
".FileInfoList.FileInfo": $root["FileInfoList"]["FileInfo"],
".UnlockPath": $root["UnlockPath"],
".UnlockedPathRequest": $root["UnlockedPathRequest"],
".GetPassphraseState": $root["GetPassphraseState"],
".PassphraseState": $root["PassphraseState"],
".UnLockDevice": $root["UnLockDevice"],
".UnLockDeviceResponse": $root["UnLockDeviceResponse"],
".MoneroTransactionSourceEntry": $root["MoneroTransactionSourceEntry"],
".MoneroTransactionSourceEntry.MoneroOutputEntry": $root["MoneroTransactionSourceEntry"]["MoneroOutputEntry"],
".MoneroTransactionSourceEntry.MoneroOutputEntry.MoneroRctKeyPublic": $root["MoneroTransactionSourceEntry"]["MoneroOutputEntry"]["MoneroRctKeyPublic"],
".MoneroTransactionSourceEntry.MoneroMultisigKLRki": $root["MoneroTransactionSourceEntry"]["MoneroMultisigKLRki"],
".MoneroTransactionDestinationEntry": $root["MoneroTransactionDestinationEntry"],
".MoneroTransactionDestinationEntry.MoneroAccountPublicAddress": $root["MoneroTransactionDestinationEntry"]["MoneroAccountPublicAddress"],
".MoneroTransactionRsigData": $root["MoneroTransactionRsigData"],
".MoneroGetAddress": $root["MoneroGetAddress"],
".MoneroAddress": $root["MoneroAddress"],
".MoneroGetWatchKey": $root["MoneroGetWatchKey"],
".MoneroWatchKey": $root["MoneroWatchKey"],
".MoneroTransactionInitRequest": $root["MoneroTransactionInitRequest"],
".MoneroTransactionInitRequest.MoneroTransactionData": $root["MoneroTransactionInitRequest"]["MoneroTransactionData"],
".MoneroTransactionInitAck": $root["MoneroTransactionInitAck"],
".MoneroTransactionSetInputRequest": $root["MoneroTransactionSetInputRequest"],
".MoneroTransactionSetInputAck": $root["MoneroTransactionSetInputAck"],
".MoneroTransactionInputViniRequest": $root["MoneroTransactionInputViniRequest"],
".MoneroTransactionInputViniAck": $root["MoneroTransactionInputViniAck"],
".MoneroTransactionAllInputsSetRequest": $root["MoneroTransactionAllInputsSetRequest"],
".MoneroTransactionAllInputsSetAck": $root["MoneroTransactionAllInputsSetAck"],
".MoneroTransactionSetOutputRequest": $root["MoneroTransactionSetOutputRequest"],
".MoneroTransactionSetOutputAck": $root["MoneroTransactionSetOutputAck"],
".MoneroTransactionAllOutSetRequest": $root["MoneroTransactionAllOutSetRequest"],
".MoneroTransactionAllOutSetAck": $root["MoneroTransactionAllOutSetAck"],
".MoneroTransactionAllOutSetAck.MoneroRingCtSig": $root["MoneroTransactionAllOutSetAck"]["MoneroRingCtSig"],
".MoneroTransactionSignInputRequest": $root["MoneroTransactionSignInputRequest"],
".MoneroTransactionSignInputAck": $root["MoneroTransactionSignInputAck"],
".MoneroTransactionFinalRequest": $root["MoneroTransactionFinalRequest"],
".MoneroTransactionFinalAck": $root["MoneroTransactionFinalAck"],
".MoneroKeyImageExportInitRequest": $root["MoneroKeyImageExportInitRequest"],
".MoneroKeyImageExportInitRequest.MoneroSubAddressIndicesList": $root["MoneroKeyImageExportInitRequest"]["MoneroSubAddressIndicesList"],
".MoneroKeyImageExportInitAck": $root["MoneroKeyImageExportInitAck"],
".MoneroKeyImageSyncStepRequest": $root["MoneroKeyImageSyncStepRequest"],
".MoneroKeyImageSyncStepRequest.MoneroTransferDetails": $root["MoneroKeyImageSyncStepRequest"]["MoneroTransferDetails"],
".MoneroKeyImageSyncStepAck": $root["MoneroKeyImageSyncStepAck"],
".MoneroKeyImageSyncStepAck.MoneroExportedKeyImage": $root["MoneroKeyImageSyncStepAck"]["MoneroExportedKeyImage"],
".MoneroKeyImageSyncFinalRequest": $root["MoneroKeyImageSyncFinalRequest"],
".MoneroKeyImageSyncFinalAck": $root["MoneroKeyImageSyncFinalAck"],
".MoneroGetTxKeyRequest": $root["MoneroGetTxKeyRequest"],
".MoneroGetTxKeyAck": $root["MoneroGetTxKeyAck"],
".MoneroLiveRefreshStartRequest": $root["MoneroLiveRefreshStartRequest"],
".MoneroLiveRefreshStartAck": $root["MoneroLiveRefreshStartAck"],
".MoneroLiveRefreshStepRequest": $root["MoneroLiveRefreshStepRequest"],
".MoneroLiveRefreshStepAck": $root["MoneroLiveRefreshStepAck"],
".MoneroLiveRefreshFinalRequest": $root["MoneroLiveRefreshFinalRequest"],
".MoneroLiveRefreshFinalAck": $root["MoneroLiveRefreshFinalAck"],
".DebugMoneroDiagRequest": $root["DebugMoneroDiagRequest"],
".DebugMoneroDiagAck": $root["DebugMoneroDiagAck"],
".NearGetAddress": $root["NearGetAddress"],
".NearAddress": $root["NearAddress"],
".NearSignTx": $root["NearSignTx"],
".NearSignedTx": $root["NearSignedTx"],
".NEMGetAddress": $root["NEMGetAddress"],
".NEMAddress": $root["NEMAddress"],
".NEMSignTx": $root["NEMSignTx"],
".NEMSignTx.NEMTransactionCommon": $root["NEMSignTx"]["NEMTransactionCommon"],
".NEMSignTx.NEMTransfer": $root["NEMSignTx"]["NEMTransfer"],
".NEMSignTx.NEMTransfer.NEMMosaic": $root["NEMSignTx"]["NEMTransfer"]["NEMMosaic"],
".NEMSignTx.NEMProvisionNamespace": $root["NEMSignTx"]["NEMProvisionNamespace"],
".NEMSignTx.NEMMosaicCreation": $root["NEMSignTx"]["NEMMosaicCreation"],
".NEMSignTx.NEMMosaicCreation.NEMMosaicDefinition": $root["NEMSignTx"]["NEMMosaicCreation"]["NEMMosaicDefinition"],
".NEMSignTx.NEMMosaicSupplyChange": $root["NEMSignTx"]["NEMMosaicSupplyChange"],
".NEMSignTx.NEMAggregateModification": $root["NEMSignTx"]["NEMAggregateModification"],
".NEMSignTx.NEMAggregateModification.NEMCosignatoryModification": $root["NEMSignTx"]["NEMAggregateModification"]["NEMCosignatoryModification"],
".NEMSignTx.NEMImportanceTransfer": $root["NEMSignTx"]["NEMImportanceTransfer"],
".NEMSignedTx": $root["NEMSignedTx"],
".NEMDecryptMessage": $root["NEMDecryptMessage"],
".NEMDecryptedMessage": $root["NEMDecryptedMessage"],
".NeoGetAddress": $root["NeoGetAddress"],
".NeoAddress": $root["NeoAddress"],
".NeoSignTx": $root["NeoSignTx"],
".NeoSignedTx": $root["NeoSignedTx"],
".NervosGetAddress": $root["NervosGetAddress"],
".NervosAddress": $root["NervosAddress"],
".NervosSignTx": $root["NervosSignTx"],
".NervosSignedTx": $root["NervosSignedTx"],
".NervosTxRequest": $root["NervosTxRequest"],
".NervosTxAck": $root["NervosTxAck"],
".NexaGetAddress": $root["NexaGetAddress"],
".NexaAddress": $root["NexaAddress"],
".NexaSignTx": $root["NexaSignTx"],
".NexaTxInputRequest": $root["NexaTxInputRequest"],
".NexaTxInputAck": $root["NexaTxInputAck"],
".NexaSignedTx": $root["NexaSignedTx"],
".NostrGetPublicKey": $root["NostrGetPublicKey"],
".NostrPublicKey": $root["NostrPublicKey"],
".NostrSignEvent": $root["NostrSignEvent"],
".NostrSignedEvent": $root["NostrSignedEvent"],
".NostrSignSchnorr": $root["NostrSignSchnorr"],
".NostrSignedSchnorr": $root["NostrSignedSchnorr"],
".NostrEncryptMessage": $root["NostrEncryptMessage"],
".NostrEncryptedMessage": $root["NostrEncryptedMessage"],
".NostrDecryptMessage": $root["NostrDecryptMessage"],
".NostrDecryptedMessage": $root["NostrDecryptedMessage"],
".PassphraseRequest": $root["PassphraseRequest"],
".PassphraseAck": $root["PassphraseAck"],
".PolkadotGetAddress": $root["PolkadotGetAddress"],
".PolkadotAddress": $root["PolkadotAddress"],
".PolkadotSignTx": $root["PolkadotSignTx"],
".PolkadotSignedTx": $root["PolkadotSignedTx"],
".RippleGetAddress": $root["RippleGetAddress"],
".RippleAddress": $root["RippleAddress"],
".RippleSignTx": $root["RippleSignTx"],
".RippleSignTx.RipplePayment": $root["RippleSignTx"]["RipplePayment"],
".RippleSignedTx": $root["RippleSignedTx"],
".SolanaGetAddress": $root["SolanaGetAddress"],
".SolanaAddress": $root["SolanaAddress"],
".SolanaSignTx": $root["SolanaSignTx"],
".SolanaSignedTx": $root["SolanaSignedTx"],
".SolanaSignOffChainMessage": $root["SolanaSignOffChainMessage"],
".SolanaSignUnsafeMessage": $root["SolanaSignUnsafeMessage"],
".SolanaMessageSignature": $root["SolanaMessageSignature"],
".StarcoinGetAddress": $root["StarcoinGetAddress"],
".StarcoinAddress": $root["StarcoinAddress"],
".StarcoinGetPublicKey": $root["StarcoinGetPublicKey"],
".StarcoinPublicKey": $root["StarcoinPublicKey"],
".StarcoinSignTx": $root["StarcoinSignTx"],
".StarcoinSignedTx": $root["StarcoinSignedTx"],
".StarcoinSignMessage": $root["StarcoinSignMessage"],
".StarcoinMessageSignature": $root["StarcoinMessageSignature"],
".StarcoinVerifyMessage": $root["StarcoinVerifyMessage"],
".StellarAsset": $root["StellarAsset"],
".StellarGetAddress": $root["StellarGetAddress"],
".StellarAddress": $root["StellarAddress"],
".StellarSignTx": $root["StellarSignTx"],
".StellarTxOpRequest": $root["StellarTxOpRequest"],
".StellarPaymentOp": $root["StellarPaymentOp"],
".StellarCreateAccountOp": $root["StellarCreateAccountOp"],
".StellarPathPaymentStrictReceiveOp": $root["StellarPathPaymentStrictReceiveOp"],
".StellarPathPaymentStrictSendOp": $root["StellarPathPaymentStrictSendOp"],
".StellarManageSellOfferOp": $root["StellarManageSellOfferOp"],
".StellarManageBuyOfferOp": $root["StellarManageBuyOfferOp"],
".StellarCreatePassiveSellOfferOp": $root["StellarCreatePassiveSellOfferOp"],
".StellarSetOptionsOp": $root["StellarSetOptionsOp"],
".StellarChangeTrustOp": $root["StellarChangeTrustOp"],
".StellarAllowTrustOp": $root["StellarAllowTrustOp"],
".StellarAccountMergeOp": $root["StellarAccountMergeOp"],
".StellarManageDataOp": $root["StellarManageDataOp"],
".StellarBumpSequenceOp": $root["StellarBumpSequenceOp"],
".StellarSignedTx": $root["StellarSignedTx"],
".SuiGetAddress": $root["SuiGetAddress"],
".SuiAddress": $root["SuiAddress"],
".SuiSignTx": $root["SuiSignTx"],
".SuiSignedTx": $root["SuiSignedTx"],
".SuiTxRequest": $root["SuiTxRequest"],
".SuiTxAck": $root["SuiTxAck"],
".SuiSignMessage": $root["SuiSignMessage"],
".SuiMessageSignature": $root["SuiMessageSignature"],
".TezosGetAddress": $root["TezosGetAddress"],
".TezosAddress": $root["TezosAddress"],
".TezosGetPublicKey": $root["TezosGetPublicKey"],
".TezosPublicKey": $root["TezosPublicKey"],
".TezosSignTx": $root["TezosSignTx"],
".TezosSignTx.TezosContractID": $root["TezosSignTx"]["TezosContractID"],
".TezosSignTx.TezosRevealOp": $root["TezosSignTx"]["TezosRevealOp"],
".TezosSignTx.TezosTransactionOp": $root["TezosSignTx"]["TezosTransactionOp"],
".TezosSignTx.TezosTransactionOp.TezosParametersManager": $root["TezosSignTx"]["TezosTransactionOp"]["TezosParametersManager"],
".TezosSignTx.TezosTransactionOp.TezosParametersManager.TezosManagerTransfer": $root["TezosSignTx"]["TezosTransactionOp"]["TezosParametersManager"]["TezosManagerTransfer"],
".TezosSignTx.TezosOriginationOp": $root["TezosSignTx"]["TezosOriginationOp"],
".TezosSignTx.TezosDelegationOp": $root["TezosSignTx"]["TezosDelegationOp"],
".TezosSignTx.TezosProposalOp": $root["TezosSignTx"]["TezosProposalOp"],
".TezosSignTx.TezosBallotOp": $root["TezosSignTx"]["TezosBallotOp"],
".TezosSignedTx": $root["TezosSignedTx"],
".TonGetAddress": $root["TonGetAddress"],
".TonAddress": $root["TonAddress"],
".TonSignMessage": $root["TonSignMessage"],
".TonSignedMessage": $root["TonSignedMessage"],
".TonTxAck": $root["TonTxAck"],
".TonSignProof": $root["TonSignProof"],
".TonSignedProof": $root["TonSignedProof"],
".TronGetAddress": $root["TronGetAddress"],
".TronAddress": $root["TronAddress"],
".TronSignTx": $root["TronSignTx"],
".TronSignTx.TronContract": $root["TronSignTx"]["TronContract"],
".TronSignTx.TronContract.TronTransferContract": $root["TronSignTx"]["TronContract"]["TronTransferContract"],
".TronSignTx.TronContract.TronTriggerSmartContract": $root["TronSignTx"]["TronContract"]["TronTriggerSmartContract"],
".TronSignTx.TronContract.TronFreezeBalanceContract": $root["TronSignTx"]["TronContract"]["TronFreezeBalanceContract"],
".TronSignTx.TronContract.TronUnfreezeBalanceContract": $root["TronSignTx"]["TronContract"]["TronUnfreezeBalanceContract"],
".TronSignTx.TronContract.TronWithdrawBalanceContract": $root["TronSignTx"]["TronContract"]["TronWithdrawBalanceContract"],
".TronSignTx.TronContract.TronFreezeBalanceV2Contract": $root["TronSignTx"]["TronContract"]["TronFreezeBalanceV2Contract"],
".TronSignTx.TronContract.TronUnfreezeBalanceV2Contract": $root["TronSignTx"]["TronContract"]["TronUnfreezeBalanceV2Contract"],
".TronSignTx.TronContract.TronWithdrawExpireUnfreezeContract": $root["TronSignTx"]["TronContract"]["TronWithdrawExpireUnfreezeContract"],
".TronSignTx.TronContract.TronDelegateResourceContract": $root["TronSignTx"]["TronContract"]["TronDelegateResourceContract"],
".TronSignTx.TronContract.TronUnDelegateResourceContract": $root["TronSignTx"]["TronContract"]["TronUnDelegateResourceContract"],
".TronSignTx.TronContract.TronCancelAllUnfreezeV2Contract": $root["TronSignTx"]["TronContract"]["TronCancelAllUnfreezeV2Contract"],
".TronSignTx.TronContract.TronVoteWitnessContract": $root["TronSignTx"]["TronContract"]["TronVoteWitnessContract"],
".TronSignTx.TronContract.TronVoteWitnessContract.Vote": $root["TronSignTx"]["TronContract"]["TronVoteWitnessContract"]["Vote"],
".TronSignedTx": $root["TronSignedTx"],
".TronSignMessage": $root["TronSignMessage"],
".TronMessageSignature": $root["TronMessageSignature"],
".UiAnimationRequest": $root["UiAnimationRequest"],
".WebAuthnListResidentCredentials": $root["WebAuthnListResidentCredentials"],
".WebAuthnAddResidentCredential": $root["WebAuthnAddResidentCredential"],
".WebAuthnRemoveResidentCredential": $root["WebAuthnRemoveResidentCredential"],
".WebAuthnCredentials": $root["WebAuthnCredentials"],
".WebAuthnCredentials.WebAuthnCredential": $root["WebAuthnCredentials"]["WebAuthnCredential"],
".ProtocolInfoRequest": $root["ProtocolInfoRequest"],
".ProtocolInfo": $root["ProtocolInfo"],
".Ping": $root["Ping"],
".Success": $root["Success"],
".Failure": $root["Failure"],
".DeviceReboot": $root["DeviceReboot"],
".DeviceSettings": $root["DeviceSettings"],
".DeviceSettingsGet": $root["DeviceSettingsGet"],
".DeviceSettingsSet": $root["DeviceSettingsSet"],
".DeviceSettingsPageShow": $root["DeviceSettingsPageShow"],
".DeviceCertificate": $root["DeviceCertificate"],
".DeviceCertificateWrite": $root["DeviceCertificateWrite"],
".DeviceCertificateRead": $root["DeviceCertificateRead"],
".DeviceCertificateSignature": $root["DeviceCertificateSignature"],
".DeviceCertificateSign": $root["DeviceCertificateSign"],
".DeviceMiscUsbMscControl": $root["DeviceMiscUsbMscControl"],
".DeviceFindMyTokenUpdate": $root["DeviceFindMyTokenUpdate"],
".DeviceFindMyTokenStateGet": $root["DeviceFindMyTokenStateGet"],
".DeviceFindMyTokenState": $root["DeviceFindMyTokenState"],
".DeviceAnimationControl": $root["DeviceAnimationControl"],
".DeviceFactoryInfoManufactureTime": $root["DeviceFactoryInfoManufactureTime"],
".DeviceFactoryInfo": $root["DeviceFactoryInfo"],
".DeviceFactoryInfoSet": $root["DeviceFactoryInfoSet"],
".DeviceFactoryInfoGet": $root["DeviceFactoryInfoGet"],
".DeviceFactoryPermanentLock": $root["DeviceFactoryPermanentLock"],
".DeviceFactoryTest": $root["DeviceFactoryTest"],
".DeviceFirmwareTarget": $root["DeviceFirmwareTarget"],
".DeviceFirmwareUpdateStage": $root["DeviceFirmwareUpdateStage"],
".DeviceFirmwareUpdateRequest": $root["DeviceFirmwareUpdateRequest"],
".DeviceFirmwareUpdatePhaseInfo": $root["DeviceFirmwareUpdatePhaseInfo"],
".DeviceFirmwareUpdateRecord": $root["DeviceFirmwareUpdateRecord"],
".DeviceFirmwareUpdateRecordFields": $root["DeviceFirmwareUpdateRecordFields"],
".DeviceFirmwareUpdateStatusGet": $root["DeviceFirmwareUpdateStatusGet"],
".DeviceFirmwareUpdateStatus": $root["DeviceFirmwareUpdateStatus"],
".DeviceFirmwareImageInfo": $root["DeviceFirmwareImageInfo"],
".DeviceHardwareInfo": $root["DeviceHardwareInfo"],
".DeviceMainMcuInfo": $root["DeviceMainMcuInfo"],
".DeviceCoprocessorInfo": $root["DeviceCoprocessorInfo"],
".DeviceSEInfo": $root["DeviceSEInfo"],
".DeviceInfoTargets": $root["DeviceInfoTargets"],
".DeviceInfoTypes": $root["DeviceInfoTypes"],
".DeviceInfoGet": $root["DeviceInfoGet"],
".DeviceInfo": $root["DeviceInfo"],
".DeviceSessionGet": $root["DeviceSessionGet"],
".DeviceSession": $root["DeviceSession"],
".DeviceSessionAskPin": $root["DeviceSessionAskPin"],
".DeviceSessionAskPassphrase": $root["DeviceSessionAskPassphrase"],
".DeviceStatus": $root["DeviceStatus"],
".DeviceStatusGet": $root["DeviceStatusGet"],
".FilesystemPermissionFix": $root["FilesystemPermissionFix"],
".FilesystemPathInfo": $root["FilesystemPathInfo"],
".FilesystemPathInfoQuery": $root["FilesystemPathInfoQuery"],
".FilesystemFile": $root["FilesystemFile"],
".FilesystemFileRead": $root["FilesystemFileRead"],
".FilesystemFileWrite": $root["FilesystemFileWrite"],
".FilesystemFileDelete": $root["FilesystemFileDelete"],
".FilesystemDir": $root["FilesystemDir"],
".FilesystemDirList": $root["FilesystemDirList"],
".FilesystemDirMake": $root["FilesystemDirMake"],
".FilesystemDirRemove": $root["FilesystemDirRemove"],
".FilesystemFormat": $root["FilesystemFormat"],
".InternalMyAddressRequest": $root["InternalMyAddressRequest"],
".NftUpdate": $root["NftUpdate"],
".OnboardingSetupStatus": $root["OnboardingSetupStatus"],
".OnboardingStatusGet": $root["OnboardingStatusGet"],
".OnboardingStatus": $root["OnboardingStatus"],
".PortfolioUpdate": $root["PortfolioUpdate"],
".ViewAmount": $root["ViewAmount"],
".ViewDetail": $root["ViewDetail"],
".ViewCustomField": $root["ViewCustomField"],
".ViewTip": $root["ViewTip"],
".ViewActionCard": $root["ViewActionCard"],
".ViewContentPreview": $root["ViewContentPreview"],
".ViewContentEntry": $root["ViewContentEntry"],
".ViewContentPage": $root["ViewContentPage"],
".ViewSignPage": $root["ViewSignPage"],
".ViewWarningPage": $root["ViewWarningPage"],
".ViewVerifyPage": $root["ViewVerifyPage"],
".google.protobuf.FileDescriptorSet": $root["google"]["protobuf"]["FileDescriptorSet"],
".google.protobuf.FileDescriptorProto": $root["google"]["protobuf"]["FileDescriptorProto"],
".google.protobuf.DescriptorProto": $root["google"]["protobuf"]["DescriptorProto"],
".google.protobuf.DescriptorProto.ExtensionRange": $root["google"]["protobuf"]["DescriptorProto"]["ExtensionRange"],
".google.protobuf.DescriptorProto.ReservedRange": $root["google"]["protobuf"]["DescriptorProto"]["ReservedRange"],
".google.protobuf.FieldDescriptorProto": $root["google"]["protobuf"]["FieldDescriptorProto"],
".google.protobuf.OneofDescriptorProto": $root["google"]["protobuf"]["OneofDescriptorProto"],
".google.protobuf.EnumDescriptorProto": $root["google"]["protobuf"]["EnumDescriptorProto"],
".google.protobuf.EnumValueDescriptorProto": $root["google"]["protobuf"]["EnumValueDescriptorProto"],
".google.protobuf.ServiceDescriptorProto": $root["google"]["protobuf"]["ServiceDescriptorProto"],
".google.protobuf.MethodDescriptorProto": $root["google"]["protobuf"]["MethodDescriptorProto"],
".google.protobuf.FileOptions": $root["google"]["protobuf"]["FileOptions"],
".google.protobuf.MessageOptions": $root["google"]["protobuf"]["MessageOptions"],
".google.protobuf.FieldOptions": $root["google"]["protobuf"]["FieldOptions"],
".google.protobuf.OneofOptions": $root["google"]["protobuf"]["OneofOptions"],
".google.protobuf.EnumOptions": $root["google"]["protobuf"]["EnumOptions"],
".google.protobuf.EnumValueOptions": $root["google"]["protobuf"]["EnumValueOptions"],
".google.protobuf.ServiceOptions": $root["google"]["protobuf"]["ServiceOptions"],
".google.protobuf.MethodOptions": $root["google"]["protobuf"]["MethodOptions"],
".google.protobuf.UninterpretedOption": $root["google"]["protobuf"]["UninterpretedOption"],
".google.protobuf.UninterpretedOption.NamePart": $root["google"]["protobuf"]["UninterpretedOption"]["NamePart"],
".google.protobuf.SourceCodeInfo": $root["google"]["protobuf"]["SourceCodeInfo"],
".google.protobuf.SourceCodeInfo.Location": $root["google"]["protobuf"]["SourceCodeInfo"]["Location"],
".google.protobuf.GeneratedCodeInfo": $root["google"]["protobuf"]["GeneratedCodeInfo"],
".google.protobuf.GeneratedCodeInfo.Annotation": $root["google"]["protobuf"]["GeneratedCodeInfo"]["Annotation"]};
},
"{\"nested\":{\"LegacyProtocolInfo\":{\"fields\":{\"protobuf_definition\":{\"id\":3,\"type\":\"string\"},\"supported_messages\":{\"id\":2,\"options\":{\"packed\":false},\"rule\":\"repeated\",\"type\":\"uint32\"},\"version\":{\"id\":1,\"rule\":\"required\",\"type\":\"uint32\"}}}}}": function () {
const $protobuf = { ...protobuf, roots: {} };
var $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

var $root = $protobuf.roots["onekey-csp-3"] || ($protobuf.roots["onekey-csp-3"] = {});

$root.LegacyProtocolInfo = (function() {

    function LegacyProtocolInfo(properties) {
        this.supported_messages = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    LegacyProtocolInfo.prototype.version = 0;
    LegacyProtocolInfo.prototype.supported_messages = $util.emptyArray;
    LegacyProtocolInfo.prototype.protobuf_definition = "";

    LegacyProtocolInfo.create = function create(properties) {
        return new LegacyProtocolInfo(properties);
    };

    LegacyProtocolInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(8).uint32(message.version);
        if (message.supported_messages != null && message.supported_messages.length)
            for (var i = 0; i < message.supported_messages.length; ++i)
                writer.uint32(16).uint32(message.supported_messages[i]);
        if (message.protobuf_definition != null && Object.hasOwnProperty.call(message, "protobuf_definition"))
            writer.uint32(26).string(message.protobuf_definition);
        return writer;
    };

    LegacyProtocolInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    LegacyProtocolInfo.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.LegacyProtocolInfo();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.version = reader.uint32();
                break;
            case 2:
                if (!(message.supported_messages && message.supported_messages.length))
                    message.supported_messages = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.supported_messages.push(reader.uint32());
                } else
                    message.supported_messages.push(reader.uint32());
                break;
            case 3:
                message.protobuf_definition = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("version"))
            throw $util.ProtocolError("missing required 'version'", { instance: message });
        return message;
    };

    LegacyProtocolInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    LegacyProtocolInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isInteger(message.version))
            return "version: integer expected";
        if (message.supported_messages != null && message.hasOwnProperty("supported_messages")) {
            if (!Array.isArray(message.supported_messages))
                return "supported_messages: array expected";
            for (var i = 0; i < message.supported_messages.length; ++i)
                if (!$util.isInteger(message.supported_messages[i]))
                    return "supported_messages: integer[] expected";
        }
        if (message.protobuf_definition != null && message.hasOwnProperty("protobuf_definition"))
            if (!$util.isString(message.protobuf_definition))
                return "protobuf_definition: string expected";
        return null;
    };

    LegacyProtocolInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.LegacyProtocolInfo)
            return object;
        var message = new $root.LegacyProtocolInfo();
        if (object.version != null)
            message.version = object.version >>> 0;
        if (object.supported_messages) {
            if (!Array.isArray(object.supported_messages))
                throw TypeError(".LegacyProtocolInfo.supported_messages: array expected");
            message.supported_messages = [];
            for (var i = 0; i < object.supported_messages.length; ++i)
                message.supported_messages[i] = object.supported_messages[i] >>> 0;
        }
        if (object.protobuf_definition != null)
            message.protobuf_definition = String(object.protobuf_definition);
        return message;
    };

    LegacyProtocolInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.supported_messages = [];
        if (options.defaults) {
            object.version = 0;
            object.protobuf_definition = "";
        }
        if (message.version != null && message.hasOwnProperty("version"))
            object.version = message.version;
        if (message.supported_messages && message.supported_messages.length) {
            object.supported_messages = [];
            for (var j = 0; j < message.supported_messages.length; ++j)
                object.supported_messages[j] = message.supported_messages[j];
        }
        if (message.protobuf_definition != null && message.hasOwnProperty("protobuf_definition"))
            object.protobuf_definition = message.protobuf_definition;
        return object;
    };

    LegacyProtocolInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return LegacyProtocolInfo;
})();
return {".LegacyProtocolInfo": $root["LegacyProtocolInfo"]};
}
} };

function parseConfigure(data) {
    const schema = typeof data === 'string' ? JSON.parse(data) : data;
    const key = protobufStatic.schemaKey(schema);
    const createConstructors = protobufStatic.schemas[key];
    const messages = protobuf__namespace.Root.fromJSON(createConstructors ? JSON.parse(JSON.stringify(schema)) : schema);
    if (createConstructors) {
        const constructors = createConstructors();
        const types = [];
        const collect = (namespace) => {
            if (namespace instanceof protobuf__namespace.Type)
                types.push(namespace);
            namespace.nestedArray.forEach(child => {
                if (child instanceof protobuf__namespace.Namespace)
                    collect(child);
            });
        };
        collect(messages);
        types.forEach(type => {
            type.ctor = constructors[type.fullName];
        });
        types.forEach(type => {
            const constructor = constructors[type.fullName];
            type.encode = constructor.encode;
            type.decode = constructor.decode;
            type.verify = constructor.verify;
            type.fromObject = constructor.fromObject;
            type.toObject = constructor.toObject;
            type.setup = () => type;
        });
        messages.resolveAll();
    }
    return messages;
}
const createMessageFromName = (messages, name) => {
    const Message = messages.lookupType(name);
    const MessageType = messages.lookupEnum('MessageType');
    let messageTypeId = MessageType.values[`MessageType_${name}`];
    if (messageTypeId == null && Message.options) {
        messageTypeId = Message.options['(wire_type)'];
    }
    if (!Number.isInteger(messageTypeId)) {
        throw new Error(`MessageType for "${name}" is not defined in protobuf schema`);
    }
    return {
        Message,
        messageTypeId,
    };
};
const createMessageFromType = (messages, typeId) => {
    const MessageType = messages.lookupEnum('MessageType');
    const rawMessageName = MessageType.valuesById[typeId];
    if (!rawMessageName) {
        throw new Error(`MessageType id "${typeId}" is not defined in protobuf schema`);
    }
    const messageName = rawMessageName.replace('MessageType_', '');
    const Message = messages.lookupType(messageName);
    return {
        Message,
        messageName,
    };
};

const PROTOCOL_V1_REPORT_ID = 0x3f;
const PROTOCOL_V1_HEADER_BYTE = 0x23;
const PROTOCOL_V1_CHUNK_PAYLOAD_SIZE = 63;
const PROTOCOL_V1_USB_PACKET_SIZE = PROTOCOL_V1_CHUNK_PAYLOAD_SIZE + 1;
const PROTOCOL_V1_MESSAGE_HEADER_SIZE = 2 + 4;
const PROTOCOL_V1_ENVELOPE_HEADER_SIZE = 1 + 1 + PROTOCOL_V1_MESSAGE_HEADER_SIZE;
const PROTOCOL_V2_FRAME_MAX_BYTES = 4200;
const PROTOCOL_V2_WEBUSB_FILE_CHUNK_SIZE = 4000;
const PROTOCOL_V2_BLE_FILE_CHUNK_SIZE = 1800;
const PROTOCOL_V2_BLE_FIRMWARE_FILE_CHUNK_SIZE = 1960;
const PROTOCOL_V2_BLE_FILE_READ_CHUNK_SIZE = 900;
const PROTOCOL_V2_BLE_FRAME_MAX_BYTES = 2048;
const PROTOCOL_V2_FILE_CHUNK_SIZE = PROTOCOL_V2_WEBUSB_FILE_CHUNK_SIZE;
const PROTOCOL_V2_CHANNEL_USB = 0;
const PROTOCOL_V2_CHANNEL_BLE_UART = 1;
const PROTOCOL_V2_CHANNEL_SOCKET = 2;
const PROTOCOL_V2_PACKET_SRC_COMMAND = 0;
const PROTOCOL_V2_DEFAULT_RESPONSE_TIMEOUT_MS = 5 * 60 * 1000;

function encodeEnvelope(data, options) {
    const { addTrezorHeaders, chunked, messageTypeId } = options;
    const fullSize = (addTrezorHeaders ? PROTOCOL_V1_ENVELOPE_HEADER_SIZE : PROTOCOL_V1_ENVELOPE_HEADER_SIZE - 2) +
        Number(data.limit);
    const encodedByteBuffer = new ByteBuffer__default["default"](fullSize);
    if (addTrezorHeaders) {
        encodedByteBuffer.writeByte(PROTOCOL_V1_HEADER_BYTE);
        encodedByteBuffer.writeByte(PROTOCOL_V1_HEADER_BYTE);
    }
    encodedByteBuffer.writeUint16(messageTypeId);
    encodedByteBuffer.writeUint32(data.limit);
    encodedByteBuffer.append(data.buffer);
    encodedByteBuffer.reset();
    if (chunked === false) {
        return encodedByteBuffer;
    }
    const result = [];
    const size = PROTOCOL_V1_CHUNK_PAYLOAD_SIZE;
    const count = Math.floor((encodedByteBuffer.limit - 1) / size) + 1 || 1;
    for (let i = 0; i < count; i++) {
        const start = i * size;
        const end = Math.min((i + 1) * size, encodedByteBuffer.limit);
        const slice = encodedByteBuffer.slice(start, end);
        slice.compact();
        result.push(slice.buffer);
    }
    return result;
}

function encodeEnvelopeMessage(messages, name, data) {
    const { Message, messageTypeId } = createMessageFromName(messages, name);
    const buffer = encode(Message, data);
    return encodeEnvelope(buffer, {
        addTrezorHeaders: false,
        chunked: false,
        messageTypeId,
    });
}
const encodeMessageChunks = (messages, name, data) => {
    const { Message, messageTypeId } = createMessageFromName(messages, name);
    const buffer = encode(Message, data);
    return encodeEnvelope(buffer, {
        addTrezorHeaders: true,
        chunked: true,
        messageTypeId,
    });
};
const encodeTransportPackets = (messages, name, data) => {
    const encodeBuffers = encodeMessageChunks(messages, name, data);
    const outBuffers = [];
    for (const buf of encodeBuffers) {
        const chunkBuffer = new ByteBuffer__default["default"](PROTOCOL_V1_CHUNK_PAYLOAD_SIZE + 1);
        chunkBuffer.writeByte(PROTOCOL_V1_REPORT_ID);
        chunkBuffer.append(buf);
        chunkBuffer.reset();
        outBuffers.push(chunkBuffer);
    }
    return outBuffers;
};

const readHeader = (buffer) => {
    const typeId = buffer.readUint16();
    const length = buffer.readUint32();
    return { typeId, length };
};
const readHeaderChunked = (buffer) => {
    const sharp1 = buffer.readByte();
    const sharp2 = buffer.readByte();
    const typeId = buffer.readUint16();
    const length = buffer.readUint32();
    return { sharp1, sharp2, typeId, length };
};
const decodeEnvelope = (byteBuffer) => {
    const { typeId } = readHeader(byteBuffer);
    return {
        typeId,
        buffer: byteBuffer,
    };
};
const decodeFirstChunk = (bytes) => {
    const byteBuffer = ByteBuffer__default["default"].wrap(bytes, undefined, undefined, true);
    const { sharp1, sharp2, typeId, length } = readHeaderChunked(byteBuffer);
    if (sharp1 !== PROTOCOL_V1_HEADER_BYTE || sharp2 !== PROTOCOL_V1_HEADER_BYTE) {
        throw new Error("Didn't receive expected header signature.");
    }
    return { length, typeId, restBuffer: byteBuffer };
};

function decodeMessage(messages, data) {
    const bytebuffer = ByteBuffer__default["default"].wrap(data, 'hex');
    const { typeId, buffer } = decodeEnvelope(bytebuffer);
    const { Message, messageName } = createMessageFromType(messages, typeId);
    const message = decode(Message, buffer);
    return {
        message,
        type: messageName,
    };
}

const PROTO_HEAD_SOF = 0x5a;
const PROTO_PRE_HEAD_SIZE = 4;
const PROTO_HEAD_CRC_SIZE = 8;
const CRC8_INIT = 0x30;
const PACKET_SIZE = 4096;
const PROTO_DATA_TYPE_PACKET = 0;
const PROTO_DATA_TYPE_ACK = 1;

const CRC8_TABLE = new Uint8Array([
    0x00, 0x5e, 0xbc, 0xe2, 0x61, 0x3f, 0xdd, 0x83, 0xc2, 0x9c, 0x7e, 0x20, 0xa3, 0xfd, 0x1f, 0x41,
    0x9d, 0xc3, 0x21, 0x7f, 0xfc, 0xa2, 0x40, 0x1e, 0x5f, 0x01, 0xe3, 0xbd, 0x3e, 0x60, 0x82, 0xdc,
    0x23, 0x7d, 0x9f, 0xc1, 0x42, 0x1c, 0xfe, 0xa0, 0xe1, 0xbf, 0x5d, 0x03, 0x80, 0xde, 0x3c, 0x62,
    0xbe, 0xe0, 0x02, 0x5c, 0xdf, 0x81, 0x63, 0x3d, 0x7c, 0x22, 0xc0, 0x9e, 0x1d, 0x43, 0xa1, 0xff,
    0x46, 0x18, 0xfa, 0xa4, 0x27, 0x79, 0x9b, 0xc5, 0x84, 0xda, 0x38, 0x66, 0xe5, 0xbb, 0x59, 0x07,
    0xdb, 0x85, 0x67, 0x39, 0xba, 0xe4, 0x06, 0x58, 0x19, 0x47, 0xa5, 0xfb, 0x78, 0x26, 0xc4, 0x9a,
    0x65, 0x3b, 0xd9, 0x87, 0x04, 0x5a, 0xb8, 0xe6, 0xa7, 0xf9, 0x1b, 0x45, 0xc6, 0x98, 0x7a, 0x24,
    0xf8, 0xa6, 0x44, 0x1a, 0x99, 0xc7, 0x25, 0x7b, 0x3a, 0x64, 0x86, 0xd8, 0x5b, 0x05, 0xe7, 0xb9,
    0x8c, 0xd2, 0x30, 0x6e, 0xed, 0xb3, 0x51, 0x0f, 0x4e, 0x10, 0xf2, 0xac, 0x2f, 0x71, 0x93, 0xcd,
    0x11, 0x4f, 0xad, 0xf3, 0x70, 0x2e, 0xcc, 0x92, 0xd3, 0x8d, 0x6f, 0x31, 0xb2, 0xec, 0x0e, 0x50,
    0xaf, 0xf1, 0x13, 0x4d, 0xce, 0x90, 0x72, 0x2c, 0x6d, 0x33, 0xd1, 0x8f, 0x0c, 0x52, 0xb0, 0xee,
    0x32, 0x6c, 0x8e, 0xd0, 0x53, 0x0d, 0xef, 0xb1, 0xf0, 0xae, 0x4c, 0x12, 0x91, 0xcf, 0x2d, 0x73,
    0xca, 0x94, 0x76, 0x28, 0xab, 0xf5, 0x17, 0x49, 0x08, 0x56, 0xb4, 0xea, 0x69, 0x37, 0xd5, 0x8b,
    0x57, 0x09, 0xeb, 0xb5, 0x36, 0x68, 0x8a, 0xd4, 0x95, 0xcb, 0x29, 0x77, 0xf4, 0xaa, 0x48, 0x16,
    0xe9, 0xb7, 0x55, 0x0b, 0x88, 0xd6, 0x34, 0x6a, 0x2b, 0x75, 0x97, 0xc9, 0x4a, 0x14, 0xf6, 0xa8,
    0x74, 0x2a, 0xc8, 0x96, 0x15, 0x4b, 0xa9, 0xf7, 0xb6, 0xe8, 0x0a, 0x54, 0xd7, 0x89, 0x6b, 0x35,
]);
function crc8(data, len) {
    let crc = CRC8_INIT;
    for (let i = 0; i < len; i++) {
        crc = CRC8_TABLE[crc ^ data[i]];
    }
    return crc;
}

const PROTO_SEQ_DEFAULT = 1;
function nextProtoSeq(current) {
    return current >= 255 ? 1 : current + 1;
}
function encodeFrame(payload, packetSrc, router, seq) {
    const resolvedPacketSrc = packetSrc !== null && packetSrc !== void 0 ? packetSrc : 0;
    const resolvedRouter = router !== null && router !== void 0 ? router : 0;
    const resolvedSeq = seq !== null && seq !== void 0 ? seq : PROTO_SEQ_DEFAULT;
    if (!Number.isInteger(resolvedSeq) || resolvedSeq < 1 || resolvedSeq > 255) {
        throw new Error(`Protocol V2 seq out of range (1-255): ${resolvedSeq}`);
    }
    const payloadLen = payload ? payload.length : 0;
    const frameLen = payloadLen + PROTO_HEAD_CRC_SIZE;
    if (frameLen > PROTOCOL_V2_FRAME_MAX_BYTES) {
        throw new Error(`Protocol V2 frame too large: ${frameLen} > ${PROTOCOL_V2_FRAME_MAX_BYTES}`);
    }
    const frame = new Uint8Array(frameLen);
    frame[0] = PROTO_HEAD_SOF;
    frame[1] = frameLen % 256;
    frame[2] = Math.floor(frameLen / 256) % 256;
    frame[3] = 0;
    frame[4] = resolvedRouter % 256;
    frame[5] = (resolvedPacketSrc % 16) * 4 + (PROTO_DATA_TYPE_PACKET % 4);
    frame[6] = resolvedSeq;
    frame[3] = crc8(frame, 3);
    if (payload && payloadLen > 0) {
        frame.set(payload, 7);
    }
    frame[frameLen - 1] = crc8(frame, frameLen - 1);
    return frame;
}
function encodeProtobufFrame(messageTypeId, pbPayload, packetSrc, router, seq) {
    const payload = new Uint8Array(2 + pbPayload.length);
    payload[0] = messageTypeId % 256;
    payload[1] = Math.floor(messageTypeId / 256) % 256;
    payload.set(pbPayload, 2);
    return encodeFrame(payload, packetSrc, router, seq);
}

function inspectFrameHeader(data) {
    if (data.length < PROTO_HEAD_CRC_SIZE) {
        throw new Error(`Protocol V2 frame too short: ${data.length} bytes`);
    }
    if (data[0] !== PROTO_HEAD_SOF) {
        throw new Error(`Invalid SOF byte: expected 0x5A, got 0x${data[0].toString(16).padStart(2, '0')}`);
    }
    const frameLen = data[1] + data[2] * 256;
    if (data.length !== frameLen) {
        throw new Error(`Protocol V2 frame length mismatch: expected ${frameLen} bytes, got ${data.length}`);
    }
    const expectedHeaderCrc = crc8(data, 3);
    if (data[3] !== expectedHeaderCrc) {
        throw new Error(`Header CRC mismatch: expected 0x${expectedHeaderCrc
            .toString(16)
            .padStart(2, '0')}, got 0x${data[3].toString(16).padStart(2, '0')}`);
    }
    const expectedFrameCrc = crc8(data, frameLen - 1);
    if (data[frameLen - 1] !== expectedFrameCrc) {
        throw new Error(`Frame CRC mismatch: expected 0x${expectedFrameCrc
            .toString(16)
            .padStart(2, '0')}, got 0x${data[frameLen - 1].toString(16).padStart(2, '0')}`);
    }
    const dataType = data[5] & 0x03;
    const packetSrc = (data[5] >> 2) & 0x0f;
    const seq = data[6];
    if (seq === 0) {
        throw new Error('Invalid Protocol V2 sequence: 0 is reserved');
    }
    return {
        frameLen,
        router: data[4],
        packetSrc,
        dataType,
        seq,
    };
}
function isAckFrame(data) {
    if (data.length < 6 || (data[5] & 0x03) !== PROTO_DATA_TYPE_ACK) {
        return false;
    }
    const header = inspectFrameHeader(data);
    if (header.frameLen !== PROTO_HEAD_CRC_SIZE) {
        throw new Error(`Invalid Protocol V2 ACK frame length: ${header.frameLen}`);
    }
    return true;
}
function decodeFrame(data) {
    const { frameLen, router, packetSrc, dataType, seq } = inspectFrameHeader(data);
    if (dataType !== PROTO_DATA_TYPE_PACKET) {
        throw new Error(`Invalid Protocol V2 data type: expected packet, got ${dataType}`);
    }
    const payloadData = data.slice(7, frameLen - 1);
    if (payloadData.length < 2) {
        throw new Error(`Protocol V2 payload too short (need >=2 bytes for messageTypeId)`);
    }
    const messageTypeId = payloadData[0] + payloadData[1] * 256;
    const pbPayload = payloadData.slice(2);
    return { messageTypeId, pbPayload, seq, router, packetSrc, dataType };
}

class ProtocolV2LinkError extends Error {
    constructor(code, message, cause) {
        super(message);
        this.name = 'ProtocolV2LinkError';
        this.code = code;
        this.cause = cause;
    }
}
const isProtocolV2LinkError = (error) => error instanceof ProtocolV2LinkError;
const createProtocolV2LinkDisabledError = (failureCode, firmwareMessage) => Object.assign(new Error(firmwareMessage), {
    name: 'ProtocolV2LinkDisabledError',
    failureCode,
    firmwareMessage,
});
const isProtocolV2LinkDisabledError = (error) => error instanceof Error &&
    error.name === 'ProtocolV2LinkDisabledError' &&
    'failureCode' in error &&
    'firmwareMessage' in error;
const isProtocolV2LinkDisabledFailure = (failureCode, firmwareMessage) => (failureCode === 'Failure_ProcessError' || failureCode === 5) &&
    typeof firmwareMessage === 'string' &&
    firmwareMessage.trim().toLowerCase() === 'link disabled';

function concatUint8Arrays(arrays) {
    const totalLength = arrays.reduce((sum, arr) => sum + arr.length, 0);
    const result = new Uint8Array(totalLength);
    let offset = 0;
    for (const arr of arrays) {
        result.set(arr, offset);
        offset += arr.length;
    }
    return result;
}
class ProtocolV2FrameAssembler {
    constructor(maxFrameBytes = PROTOCOL_V2_FRAME_MAX_BYTES) {
        this.buffer = new Uint8Array(0);
        this.maxFrameBytes = maxFrameBytes;
    }
    reset() {
        this.buffer = new Uint8Array(0);
    }
    push(chunk) {
        this.append(chunk);
        return this.extractFrame();
    }
    drain(chunk = new Uint8Array(0)) {
        this.append(chunk);
        const frames = [];
        for (;;) {
            const frame = this.extractFrame();
            if (!frame)
                break;
            frames.push(frame);
        }
        return frames;
    }
    append(chunk) {
        if (chunk.length > 0) {
            this.buffer = concatUint8Arrays([this.buffer, chunk]);
        }
    }
    extractFrame() {
        if (this.buffer.length < 3)
            return undefined;
        if (this.buffer[0] !== PROTO_HEAD_SOF) {
            this.reset();
            throw new ProtocolV2LinkError('frame', 'Invalid Protocol V2 SOF');
        }
        const expectedLen = this.buffer[1] + this.buffer[2] * 256;
        if (expectedLen < PROTO_HEAD_CRC_SIZE) {
            this.reset();
            throw new ProtocolV2LinkError('frame', `Protocol V2 frame length too small: ${expectedLen}`);
        }
        if (expectedLen > this.maxFrameBytes) {
            this.reset();
            throw new ProtocolV2LinkError('frame', `Protocol V2 frame too large: ${expectedLen}`);
        }
        if (this.buffer.length < PROTO_PRE_HEAD_SIZE)
            return undefined;
        const expectedHeaderCrc = crc8(this.buffer, 3);
        if (this.buffer[3] !== expectedHeaderCrc) {
            this.reset();
            throw new ProtocolV2LinkError('frame', `Protocol V2 header CRC mismatch: expected 0x${expectedHeaderCrc
                .toString(16)
                .padStart(2, '0')}`);
        }
        if (this.buffer.length < expectedLen)
            return undefined;
        const frame = this.buffer.slice(0, expectedLen);
        this.buffer = this.buffer.slice(expectedLen);
        return frame;
    }
}

const defaultWait = (timeoutMs) => new Promise(resolve => {
    setTimeout(resolve, timeoutMs);
});
function writeProtocolV2BleFrame({ frame, packetCapacity, writePacket, assertActive, signal, abortMessage = 'Protocol V2 BLE write aborted', initialDelayMs = 0, burstSize, burstPauseMs = 0, flushDelayMs = 0, wait = defaultWait, }) {
    return __awaiter(this, void 0, void 0, function* () {
        if (!Number.isInteger(packetCapacity) || packetCapacity <= 0) {
            throw new Error('Protocol V2 BLE packet capacity must be a positive integer');
        }
        if (burstSize !== undefined && (!Number.isInteger(burstSize) || burstSize <= 0)) {
            throw new Error('Protocol V2 BLE burst size must be a positive integer');
        }
        const assertWritable = () => {
            assertActive === null || assertActive === void 0 ? void 0 : assertActive();
            if (signal === null || signal === void 0 ? void 0 : signal.aborted) {
                throw new Error(abortMessage);
            }
        };
        if (frame.length > 0 && initialDelayMs > 0) {
            assertWritable();
            yield wait(initialDelayMs);
            assertWritable();
        }
        let packetsWritten = 0;
        for (let offset = 0; offset < frame.length; offset += packetCapacity) {
            assertWritable();
            const packet = frame.slice(offset, offset + packetCapacity);
            yield writePacket(packet, packetsWritten);
            packetsWritten += 1;
            assertWritable();
            const hasMorePackets = offset + packetCapacity < frame.length;
            if (hasMorePackets &&
                burstSize !== undefined &&
                packetsWritten % burstSize === 0 &&
                burstPauseMs > 0) {
                yield wait(burstPauseMs);
                assertWritable();
            }
        }
        if (burstSize !== undefined && packetsWritten > burstSize && flushDelayMs > 0) {
            yield wait(flushDelayMs);
            assertWritable();
        }
    });
}

var protocolV2Codec = /*#__PURE__*/Object.freeze({
    __proto__: null,
    PROTO_HEAD_SOF: PROTO_HEAD_SOF,
    PROTO_PRE_HEAD_SIZE: PROTO_PRE_HEAD_SIZE,
    PROTO_HEAD_CRC_SIZE: PROTO_HEAD_CRC_SIZE,
    CRC8_INIT: CRC8_INIT,
    PACKET_SIZE: PACKET_SIZE,
    PROTO_DATA_TYPE_PACKET: PROTO_DATA_TYPE_PACKET,
    PROTO_DATA_TYPE_ACK: PROTO_DATA_TYPE_ACK,
    CRC8_TABLE: CRC8_TABLE,
    crc8: crc8,
    nextProtoSeq: nextProtoSeq,
    encodeFrame: encodeFrame,
    encodeProtobufFrame: encodeProtobufFrame,
    inspectFrameHeader: inspectFrameHeader,
    isAckFrame: isAckFrame,
    decodeFrame: decodeFrame,
    ProtocolV2LinkError: ProtocolV2LinkError,
    isProtocolV2LinkError: isProtocolV2LinkError,
    createProtocolV2LinkDisabledError: createProtocolV2LinkDisabledError,
    isProtocolV2LinkDisabledError: isProtocolV2LinkDisabledError,
    isProtocolV2LinkDisabledFailure: isProtocolV2LinkDisabledFailure,
    concatUint8Arrays: concatUint8Arrays,
    ProtocolV2FrameAssembler: ProtocolV2FrameAssembler,
    writeProtocolV2BleFrame: writeProtocolV2BleFrame
});

const PROTOCOL_V2_SYS_MESSAGE_THRESHOLD = 60000;
const LEGACY_PROTOCOL_V2_PROTOCOL_INFO = parseConfigure(protobufStatic.legacyProtocolInfoSchema).lookupType('LegacyProtocolInfo');
const decodeLegacyProtocolV2ProtocolInfo = (pbPayload) => {
    var _a;
    const byteBuffer = ByteBuffer__default["default"].wrap(Buffer.from(pbPayload));
    const legacy = decode(LEGACY_PROTOCOL_V2_PROTOCOL_INFO, byteBuffer);
    return {
        version: legacy.version,
        build_fingerprint: '',
        supported_messages: (_a = legacy.supported_messages) !== null && _a !== void 0 ? _a : [],
        protobuf_definition: null,
    };
};
const isLegacyProtocolV2ProtocolInfoWireLayout = (pbPayload) => {
    const reader = protobuf$1.Reader.create(pbPayload);
    let hasVersion = false;
    try {
        while (reader.pos < reader.len) {
            const tag = reader.uint32();
            const fieldNumber = tag >>> 3;
            const wireType = tag & 0x07;
            if (fieldNumber === 1) {
                if (wireType !== 0)
                    return false;
                hasVersion = true;
            }
            else if (fieldNumber === 2) {
                if (wireType !== 0)
                    return false;
            }
            else if (fieldNumber === 3) {
                if (wireType !== 2)
                    return false;
            }
            else {
                return false;
            }
            reader.skipType(wireType);
        }
    }
    catch (_a) {
        return false;
    }
    return hasVersion;
};
const tryDecodeLegacyProtocolV2ProtocolInfo = (messageName, pbPayload) => {
    if (messageName !== 'ProtocolInfo' || !isLegacyProtocolV2ProtocolInfoWireLayout(pbPayload)) {
        return undefined;
    }
    try {
        return decodeLegacyProtocolV2ProtocolInfo(pbPayload);
    }
    catch (_a) {
        return undefined;
    }
};
const resolveProtocolV2EncodeSchema = (name, schemas) => {
    try {
        schemas.protocolV2.lookupType(name);
        return schemas.protocolV2;
    }
    catch (_a) {
        throw new Error(`Protocol V2 message "${name}" is not defined in Protocol V2 schema`);
    }
};
const PROTOCOL_V2_LEGACY_DECODE_ALLOWLIST = new Set([
    'Failure',
    'ButtonRequest',
    'EntropyRequest',
    'PinMatrixRequest',
    'PassphraseRequest',
    'Deprecated_PassphraseStateRequest',
    'WordRequest',
]);
const createProtocolV2MessageFromType = (messageTypeId, schemas) => {
    try {
        return createMessageFromType(schemas.protocolV2, messageTypeId);
    }
    catch (protocolV2Error) {
        let legacyMessage;
        try {
            legacyMessage = createMessageFromType(schemas.protocolV1, messageTypeId);
        }
        catch (_a) {
            throw protocolV2Error;
        }
        if (PROTOCOL_V2_LEGACY_DECODE_ALLOWLIST.has(legacyMessage.messageName)) {
            return legacyMessage;
        }
        throw protocolV2Error;
    }
};
const ProtocolV1 = {
    encodeEnvelope: encodeEnvelopeMessage,
    encodeMessageChunks,
    encodeTransportPackets,
    decodeFirstChunk,
    decodeMessage: decodeMessage,
};
const ProtocolV2 = {
    isAckFrame,
    inspectFrameHeader,
    inspectFrame(schemas, frame) {
        const { messageTypeId, pbPayload, seq, router, packetSrc, dataType } = decodeFrame(frame);
        const { messageName } = createProtocolV2MessageFromType(messageTypeId, schemas);
        return {
            messageName,
            messageTypeId,
            pbPayload,
            seq,
            router,
            packetSrc,
            dataType,
            type: messageName,
        };
    },
    encodeFrame(schemas, name, data, options = {}) {
        const encodeMessages = resolveProtocolV2EncodeSchema(name, schemas);
        const { Message, messageTypeId } = createMessageFromName(encodeMessages, name);
        const pbBuffer = encode(Message, data);
        pbBuffer.reset();
        const rawPbBuffer = pbBuffer.toBuffer();
        const pbBytes = new Uint8Array(rawPbBuffer);
        return encodeProtobufFrame(messageTypeId, pbBytes, options.packetSrc, options.router, options.seq);
    },
    decodeFrame(schemas, frame) {
        const { messageTypeId, pbPayload, seq, messageName } = this.inspectFrame(schemas, frame);
        const { Message } = createProtocolV2MessageFromType(messageTypeId, schemas);
        const rxByteBuffer = ByteBuffer__default["default"].wrap(Buffer.from(pbPayload));
        let message;
        try {
            message = decode(Message, rxByteBuffer);
        }
        catch (cause) {
            const legacyProtocolInfo = tryDecodeLegacyProtocolV2ProtocolInfo(messageName, pbPayload);
            if (legacyProtocolInfo) {
                return {
                    message: legacyProtocolInfo,
                    messageName,
                    messageTypeId,
                    pbPayload,
                    seq,
                    type: messageName,
                };
            }
            const error = new Error(`Protocol V2 protobuf decode failed for "${messageName}" ` +
                `(${messageTypeId}, ${pbPayload.length}-byte payload); ` +
                'the payload is malformed or incompatible with the active SDK schema.');
            error.cause = cause;
            throw error;
        }
        return {
            message,
            messageName,
            messageTypeId,
            pbPayload,
            seq,
            type: messageName,
        };
    },
};

var index$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    decodeEnvelope: decodeEnvelope,
    decodeFirstChunk: decodeFirstChunk,
    encodeEnvelope: encodeEnvelope,
    encodeEnvelopeMessage: encodeEnvelopeMessage,
    encodeMessageChunks: encodeMessageChunks,
    encodeTransportPackets: encodeTransportPackets,
    decodeMessage: decodeMessage
});

class ProtocolV2SequenceCursor {
    constructor() {
        this.current = 0;
    }
    next() {
        this.current = nextProtoSeq(this.current);
        return this.current;
    }
}

const ERROR = 'Wrong result type.';
function info(res) {
    if (typeof res !== 'object' || res == null) {
        throw new Error('Wrong result type.');
    }
    const { version } = res;
    if (typeof version !== 'string') {
        throw new Error(ERROR);
    }
    const configured = !!res.configured;
    return { version, configured };
}
function version(version) {
    if (typeof version !== 'string') {
        throw new Error(ERROR);
    }
    return version.trim();
}
function convertSession(r) {
    if (r == null) {
        return null;
    }
    if (typeof r !== 'string') {
        throw new Error(ERROR);
    }
    return r;
}
function devices(res) {
    if (typeof res !== 'object') {
        throw new Error(ERROR);
    }
    if (!(res instanceof Array)) {
        throw new Error(ERROR);
    }
    return res.map((o) => {
        if (typeof o !== 'object' || o == null) {
            throw new Error(ERROR);
        }
        const { path } = o;
        if (typeof path !== 'string') {
            throw new Error(ERROR);
        }
        const pathS = path.toString();
        return {
            path: pathS,
            session: convertSession(o.session),
            debugSession: convertSession(o.debugSession),
            product: o.product,
            vendor: o.vendor,
            debug: !!o.debug,
        };
    });
}
function acquire(res) {
    if (typeof res !== 'object' || res == null) {
        throw new Error(ERROR);
    }
    const { session } = res;
    if (typeof session !== 'string' && typeof session !== 'number') {
        throw new Error(ERROR);
    }
    return session.toString();
}
function call(res) {
    if (typeof res !== 'object' || res == null) {
        throw new Error(ERROR);
    }
    const { type } = res;
    if (typeof type !== 'string') {
        throw new Error(ERROR);
    }
    const { message } = res;
    if (typeof message !== 'object' || message == null) {
        throw new Error(ERROR);
    }
    return { type, message };
}

var check = /*#__PURE__*/Object.freeze({
    __proto__: null,
    info: info,
    version: version,
    devices: devices,
    acquire: acquire,
    call: call
});

const LogBlockCommand = new Set([
    'PassphraseAck',
    'PinMatrixAck',
    'FilesystemFileWrite',
    'FileWrite',
    'EmmcFileWrite',
    'FirmwareUpload',
    'ResourceAck',
]);

function hexToBytes(hex) {
    const clean = hex.replace(/\s+/g, '');
    if (clean.length % 2 !== 0) {
        throw new Error(`Invalid hex string: odd length ${clean.length}`);
    }
    if (!/^[0-9a-fA-F]*$/.test(clean)) {
        throw new Error('Invalid hex string: contains non-hex characters');
    }
    const bytes = new Uint8Array(clean.length / 2);
    for (let i = 0; i < bytes.length; i += 1) {
        bytes[i] = parseInt(clean.substring(i * 2, i * 2 + 2), 16);
    }
    return bytes;
}
function detectProtocolV2LinkDisabledError({ schemas, assembler, bytes, }) {
    var _a, _b;
    try {
        for (const frame of assembler.drain(bytes)) {
            const response = call(ProtocolV2.decodeFrame(schemas, frame));
            if (response.type === 'Failure') {
                const failureCode = (_a = response.message) === null || _a === void 0 ? void 0 : _a.code;
                const firmwareMessage = (_b = response.message) === null || _b === void 0 ? void 0 : _b.message;
                if (isProtocolV2LinkDisabledFailure(failureCode, firmwareMessage)) {
                    return createProtocolV2LinkDisabledError(failureCode, firmwareMessage);
                }
            }
        }
    }
    catch (_c) {
        assembler.reset();
    }
    return undefined;
}
function bytesToHex(bytes) {
    return Array.from(bytes)
        .map(b => b.toString(16).padStart(2, '0'))
        .join('');
}
const REDUCED_DEBUG_PROTOCOL_V2_CALLS = new Set([
    ...LogBlockCommand,
    'FilesystemFileRead',
    'FileRead',
    'EmmcFileRead',
]);
function shouldReduceProtocolV2Debug(name) {
    return REDUCED_DEBUG_PROTOCOL_V2_CALLS.has(name);
}
const HIGH_THROUGHPUT_PROTOCOL_V2_CALLS = new Set([
    'FilesystemFileWrite',
    'FileWrite',
    'EmmcFileWrite',
    'FirmwareUpload',
    'ResourceAck',
    'FilesystemFileRead',
    'FileRead',
    'EmmcFileRead',
]);
function isProtocolV2HighThroughputCall(name) {
    return HIGH_THROUGHPUT_PROTOCOL_V2_CALLS.has(name);
}
const COMMON_TERMINAL_RESPONSE_TYPES = new Set([
    'Failure',
    'ButtonRequest',
    'EntropyRequest',
    'PinMatrixRequest',
    'PassphraseRequest',
    'Deprecated_PassphraseStateRequest',
    'WordRequest',
]);
function isExpectedTerminalResponse(response, expectedTypes) {
    if (!expectedTypes || expectedTypes.length === 0)
        return true;
    return expectedTypes.includes(response.type) || COMMON_TERMINAL_RESPONSE_TYPES.has(response.type);
}
function getErrorMessage(error) {
    if (!error)
        return '';
    if (typeof error === 'string')
        return error;
    if (typeof error === 'object' && 'message' in error) {
        const { message } = error;
        return typeof message === 'string' ? message : String(message !== null && message !== void 0 ? message : '');
    }
    return String(error);
}
function withProtocolTimeout(promise, timeoutMs, createTimeoutError, onTimeout, abortSignal) {
    return __awaiter(this, void 0, void 0, function* () {
        if (!timeoutMs)
            return promise;
        let timer;
        let abortHandler;
        try {
            return yield Promise.race([
                promise,
                new Promise((_, reject) => {
                    timer = setTimeout(() => {
                        onTimeout === null || onTimeout === void 0 ? void 0 : onTimeout();
                        reject(createTimeoutError());
                    }, timeoutMs);
                }),
                ...(abortSignal
                    ? [
                        new Promise((_, reject) => {
                            abortHandler = () => {
                                reject(new Error('Protocol V2 operation aborted'));
                            };
                            if (abortSignal.aborted) {
                                abortHandler();
                            }
                            else {
                                abortSignal.addEventListener('abort', abortHandler, { once: true });
                            }
                        }),
                    ]
                    : []),
            ]);
        }
        finally {
            if (timer)
                clearTimeout(timer);
            if (abortHandler) {
                abortSignal === null || abortSignal === void 0 ? void 0 : abortSignal.removeEventListener('abort', abortHandler);
            }
        }
    });
}
class ProtocolV2Session {
    constructor(options) {
        var _a;
        this.pendingCall = Promise.resolve();
        this.pendingWrite = Promise.resolve();
        this.options = options;
        this.sequenceCursor = (_a = options.sequenceCursor) !== null && _a !== void 0 ? _a : new ProtocolV2SequenceCursor();
    }
    call(name, data, callOptions = {}) {
        const run = () => this.executeCall(name, data, callOptions);
        const result = this.pendingCall.then(run, run);
        this.pendingCall = result.catch(() => undefined);
        return result;
    }
    sendFlowControl(name, data) {
        const { schemas, router, packetSrc = PROTOCOL_V2_PACKET_SRC_COMMAND, maxFrameBytes, writeFrame, generation = 0, } = this.options;
        const abortController = new AbortController();
        const context = {
            messageName: name,
            highThroughput: false,
            generation,
            signal: abortController.signal,
        };
        const protoSeq = this.sequenceCursor.next();
        const frame = ProtocolV2.encodeFrame(schemas, name, data, {
            packetSrc,
            router,
            seq: protoSeq,
        });
        if (maxFrameBytes !== undefined && frame.length > maxFrameBytes) {
            return Promise.reject(new Error(`Protocol V2 frame too large for transport: ${frame.length} > ${maxFrameBytes}`));
        }
        return this.serializeWrite(() => writeFrame(frame, context)).then(() => ({
            type: 'WriteCompleted',
            message: {},
        }));
    }
    serializeWrite(write) {
        const result = this.pendingWrite.then(write, write);
        this.pendingWrite = result.catch(() => undefined);
        return result;
    }
    executeCall(name, data, callOptions) {
        const { schemas, router, packetSrc = PROTOCOL_V2_PACKET_SRC_COMMAND, maxFrameBytes, prepareCall, writeFrame, readFrame, logger, logPrefix = 'ProtocolV2', createTimeoutError, generation = 0, } = this.options;
        const timeoutMs = callOptions.timeoutMs && callOptions.timeoutMs > 0
            ? callOptions.timeoutMs
            : PROTOCOL_V2_DEFAULT_RESPONSE_TIMEOUT_MS;
        const abortController = new AbortController();
        const shouldReduceDebug = shouldReduceProtocolV2Debug(name);
        const baseCallContext = Object.assign(Object.assign({ messageName: name, timeoutMs, highThroughput: isProtocolV2HighThroughputCall(name) }, (callOptions.writeWithResponse === undefined
            ? {}
            : { writeWithResponse: callOptions.writeWithResponse })), { generation, signal: abortController.signal });
        const runCall = () => __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j;
            if (!this.pendingResponseAfterWrite) {
                yield (prepareCall === null || prepareCall === void 0 ? void 0 : prepareCall(baseCallContext));
            }
            const protoSeq = this.sequenceCursor.next();
            const frame = ProtocolV2.encodeFrame(schemas, name, data, {
                packetSrc,
                router,
                seq: protoSeq,
            });
            if (maxFrameBytes !== undefined && frame.length > maxFrameBytes) {
                throw new Error(`Protocol V2 frame too large for transport: ${frame.length} > ${maxFrameBytes}`);
            }
            const writeStartedAt = Date.now();
            yield this.serializeWrite(() => writeFrame(frame, baseCallContext));
            try {
                (_a = callOptions.onWriteCompleted) === null || _a === void 0 ? void 0 : _a.call(callOptions, {
                    elapsedMs: Math.max(Date.now() - writeStartedAt, 0),
                    frameBytes: frame.byteLength,
                });
            }
            catch (error) {
                (_b = logger === null || logger === void 0 ? void 0 : logger.error) === null || _b === void 0 ? void 0 : _b.call(logger, `${logPrefix} write metrics callback failed: ${String(error)}`);
            }
            if (callOptions.returnAfterWrite) {
                if ((_c = callOptions.expectedTypes) === null || _c === void 0 ? void 0 : _c.length) {
                    this.pendingResponseAfterWrite = {
                        expectedTypes: new Set(callOptions.expectedTypes),
                        onResponse: callOptions.onResponseAfterWrite,
                    };
                }
                return { type: 'WriteCompleted', message: {} };
            }
            while (!abortController.signal.aborted) {
                const rxFrame = yield readFrame(baseCallContext);
                if (abortController.signal.aborted)
                    break;
                let header;
                try {
                    header = ProtocolV2.inspectFrameHeader(rxFrame);
                }
                catch (cause) {
                    throw new ProtocolV2LinkError('frame', `Protocol V2 frame validation failed: ${getErrorMessage(cause)}`, cause);
                }
                if (header.router !== router) {
                    throw new ProtocolV2LinkError('router', `Protocol V2 router mismatch: expected ${router}, got ${header.router}`);
                }
                if (header.packetSrc !== packetSrc) {
                    throw new ProtocolV2LinkError('packet-source', `Protocol V2 packet source mismatch: expected ${packetSrc}, got ${header.packetSrc}`);
                }
                let isAck;
                try {
                    isAck = ProtocolV2.isAckFrame(rxFrame);
                }
                catch (cause) {
                    throw new ProtocolV2LinkError('frame', `Protocol V2 ACK validation failed: ${getErrorMessage(cause)}`, cause);
                }
                if (isAck) {
                    if (header.seq !== protoSeq) {
                        throw new ProtocolV2LinkError('ack-sequence', `Protocol V2 ACK sequence mismatch: expected ${protoSeq}, got ${header.seq}`);
                    }
                }
                else {
                    let decoded;
                    try {
                        decoded = ProtocolV2.decodeFrame(schemas, rxFrame);
                    }
                    catch (cause) {
                        throw new ProtocolV2LinkError('frame', `Protocol V2 frame decode failed: ${getErrorMessage(cause)}`, cause);
                    }
                    if (this.lastResponseSequence === decoded.seq) {
                        throw new ProtocolV2LinkError('response-sequence', `Protocol V2 duplicate response sequence: ${decoded.seq}`);
                    }
                    this.lastResponseSequence = decoded.seq;
                    const response = call(decoded);
                    const { pendingResponseAfterWrite } = this;
                    let belongsToWriteOnlyCall = false;
                    if (pendingResponseAfterWrite) {
                        belongsToWriteOnlyCall = pendingResponseAfterWrite.expectedTypes.has(response.type);
                        if (belongsToWriteOnlyCall || COMMON_TERMINAL_RESPONSE_TYPES.has(response.type)) {
                            this.pendingResponseAfterWrite = undefined;
                            if (belongsToWriteOnlyCall) {
                                try {
                                    (_d = pendingResponseAfterWrite.onResponse) === null || _d === void 0 ? void 0 : _d.call(pendingResponseAfterWrite, response);
                                }
                                catch (error) {
                                    (_e = logger === null || logger === void 0 ? void 0 : logger.error) === null || _e === void 0 ? void 0 : _e.call(logger, `${logPrefix} delayed response callback failed: ${String(error)}`);
                                }
                            }
                        }
                    }
                    if (belongsToWriteOnlyCall) ;
                    else if ((_f = callOptions.intermediateTypes) === null || _f === void 0 ? void 0 : _f.includes(response.type)) {
                        (_g = callOptions.onIntermediateResponse) === null || _g === void 0 ? void 0 : _g.call(callOptions, response);
                    }
                    else if (isExpectedTerminalResponse(response, callOptions.expectedTypes)) {
                        return response;
                    }
                    else if (!shouldReduceDebug) {
                        (_h = logger === null || logger === void 0 ? void 0 : logger.debug) === null || _h === void 0 ? void 0 : _h.call(logger, `[${logPrefix}] skip unexpected response for ${name}: expected=${(_j = callOptions.expectedTypes) === null || _j === void 0 ? void 0 : _j.join('|')} got=${response.type}`);
                    }
                }
            }
            throw new Error(`Protocol V2 read loop cancelled after timeout for ${name}`);
        });
        return withProtocolTimeout(runCall(), timeoutMs, () => createTimeoutError
            ? createTimeoutError(name, timeoutMs)
            : new Error(`Protocol V2 response timeout after ${timeoutMs}ms for ${name}`), () => {
            abortController.abort();
        });
    }
}
function probeProtocolV2({ call, timeoutMs, logger, logPrefix = 'ProtocolV2', onBeforeProbe, onProbeFailed, shouldRethrow, }) {
    var _a, _b, _c;
    return __awaiter(this, void 0, void 0, function* () {
        let probeError;
        try {
            yield (onBeforeProbe === null || onBeforeProbe === void 0 ? void 0 : onBeforeProbe());
            const response = yield call('Ping', { message: 'protocol-v2-probe' }, {
                timeoutMs,
                expectedTypes: ['Success'],
            });
            if (response.type === 'Success') {
                return true;
            }
            if (response.type === 'Failure') {
                const failureCode = (_a = response.message) === null || _a === void 0 ? void 0 : _a.code;
                const firmwareMessage = (_b = response.message) === null || _b === void 0 ? void 0 : _b.message;
                if (isProtocolV2LinkDisabledFailure(failureCode, firmwareMessage)) {
                    throw createProtocolV2LinkDisabledError(failureCode, firmwareMessage);
                }
            }
            probeError = new Error(`unexpected response type ${response.type}`);
        }
        catch (error) {
            if (isProtocolV2LinkDisabledError(error) || (shouldRethrow === null || shouldRethrow === void 0 ? void 0 : shouldRethrow(error))) {
                throw error;
            }
            probeError = error;
        }
        (_c = logger === null || logger === void 0 ? void 0 : logger.debug) === null || _c === void 0 ? void 0 : _c.call(logger, `[${logPrefix}] Protocol V2 probe failed:`, getErrorMessage(probeError));
        yield (onProbeFailed === null || onProbeFailed === void 0 ? void 0 : onProbeFailed(probeError));
        return false;
    });
}

class ProtocolV2LinkManager {
    constructor(options) {
        this.links = new Map();
        this.sequences = new Map();
        this.callQueues = new Map();
        this.generations = new Map();
        this.invalidationReasons = new Map();
        this.invalidations = new Map();
        this.options = options;
    }
    call(key, createAdapter, name, data, options) {
        var _a;
        const generation = (_a = this.generations.get(key)) !== null && _a !== void 0 ? _a : 0;
        const previousQueue = this.callQueues.get(key);
        const timeoutMs = (options === null || options === void 0 ? void 0 : options.timeoutMs) && options.timeoutMs > 0
            ? options.timeoutMs
            : PROTOCOL_V2_DEFAULT_RESPONSE_TIMEOUT_MS;
        const queuedAt = Date.now();
        let queueTimeout;
        let queueTimeoutError;
        const timeoutWhileQueued = new Promise((_, reject) => {
            queueTimeout = setTimeout(() => {
                queueTimeout = undefined;
                queueTimeoutError = this.createQueuedCallTimeoutError(key, name, timeoutMs);
                reject(queueTimeoutError);
            }, timeoutMs);
        });
        const run = () => {
            if (queueTimeout) {
                clearTimeout(queueTimeout);
                queueTimeout = undefined;
            }
            if (queueTimeoutError) {
                throw queueTimeoutError;
            }
            this.assertCallGeneration(key, generation);
            const remainingTimeoutMs = previousQueue ? timeoutMs - (Date.now() - queuedAt) : timeoutMs;
            if (remainingTimeoutMs <= 0) {
                throw this.createQueuedCallTimeoutError(key, name, timeoutMs);
            }
            return this.executeCall(key, createAdapter, name, data, Object.assign(Object.assign({}, options), { timeoutMs: remainingTimeoutMs }));
        };
        const previous = previousQueue !== null && previousQueue !== void 0 ? previousQueue : Promise.resolve();
        const execution = previous.then(run, run);
        const result = Promise.race([execution, timeoutWhileQueued]);
        const queue = execution.catch(() => undefined);
        this.callQueues.set(key, queue);
        execution
            .then(() => this.clearSettledCallQueue(key, queue), () => this.clearSettledCallQueue(key, queue))
            .catch(() => undefined);
        return result;
    }
    sendFlowControl(key, createAdapter, name, data) {
        var _a;
        const generation = (_a = this.generations.get(key)) !== null && _a !== void 0 ? _a : 0;
        this.assertCallGeneration(key, generation);
        return this.getOrCreateLink(key, createAdapter).session.sendFlowControl(name, data);
    }
    invalidateLink(key, reason) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const generation = ((_a = this.generations.get(key)) !== null && _a !== void 0 ? _a : 0) + 1;
            this.generations.set(key, generation);
            this.invalidationReasons.set(key, { generation, reason });
            const pendingInvalidation = this.invalidations.get(key);
            const link = this.links.get(key);
            if (!link) {
                yield pendingInvalidation;
                return;
            }
            this.links.delete(key);
            link.state.invalidatedReason = reason;
            const invalidation = (() => __awaiter(this, void 0, void 0, function* () {
                var _b, _c;
                yield (pendingInvalidation === null || pendingInvalidation === void 0 ? void 0 : pendingInvalidation.catch(() => undefined));
                yield link.adapter.reset(reason);
                yield ((_c = (_b = this.options).onLinkInvalidated) === null || _c === void 0 ? void 0 : _c.call(_b, key, reason));
            }))();
            this.invalidations.set(key, invalidation);
            try {
                yield invalidation;
            }
            finally {
                if (this.invalidations.get(key) === invalidation) {
                    this.invalidations.delete(key);
                }
            }
        });
    }
    invalidateAllLinks(reason) {
        return __awaiter(this, void 0, void 0, function* () {
            const keys = new Set([
                ...this.links.keys(),
                ...this.callQueues.keys(),
                ...this.invalidations.keys(),
            ]);
            yield Promise.all(Array.from(keys, key => this.invalidateLink(key, reason)));
        });
    }
    dispose(reason) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.invalidateAllLinks(reason);
            this.sequences.clear();
            this.callQueues.clear();
            this.invalidations.clear();
        });
    }
    getOrCreateLink(key, createAdapter) {
        const existing = this.links.get(key);
        if (existing)
            return existing;
        const adapter = createAdapter();
        const state = {};
        const assertLinkActive = () => {
            if (state.invalidatedReason) {
                throw new Error(state.invalidatedReason);
            }
        };
        let sequenceCursor = this.sequences.get(key);
        if (!sequenceCursor) {
            sequenceCursor = new ProtocolV2SequenceCursor();
            this.sequences.set(key, sequenceCursor);
        }
        const session = new ProtocolV2Session({
            schemas: this.options.getSchemas(),
            router: adapter.router,
            maxFrameBytes: adapter.maxFrameBytes,
            generation: adapter.generation,
            sequenceCursor,
            prepareCall: (context) => __awaiter(this, void 0, void 0, function* () {
                assertLinkActive();
                yield adapter.prepareCall(context);
                assertLinkActive();
            }),
            writeFrame: (frame, context) => __awaiter(this, void 0, void 0, function* () {
                assertLinkActive();
                yield adapter.writeFrame(frame, context);
                assertLinkActive();
            }),
            readFrame: (context) => __awaiter(this, void 0, void 0, function* () {
                assertLinkActive();
                const frame = yield adapter.readFrame(context);
                assertLinkActive();
                return frame;
            }),
            logger: adapter.logger,
            logPrefix: adapter.logPrefix,
            createTimeoutError: adapter.createTimeoutError,
        });
        const link = { adapter, session, state };
        this.links.set(key, link);
        return link;
    }
    executeCall(key, createAdapter, name, data, options) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                return yield this.getOrCreateLink(key, createAdapter).session.call(name, data, options);
            }
            catch (error) {
                if (this.options.classifyError(error) === 'link-fatal') {
                    const errorMessage = getErrorMessage(error) || 'unknown error';
                    yield this.invalidateLink(key, `Protocol V2 link-fatal error: ${errorMessage}`);
                }
                throw error;
            }
        });
    }
    clearSettledCallQueue(key, queue) {
        if (this.callQueues.get(key) === queue) {
            this.callQueues.delete(key);
        }
    }
    createQueuedCallTimeoutError(key, name, timeoutMs) {
        var _a;
        const adapterTimeoutError = (_a = this.links.get(key)) === null || _a === void 0 ? void 0 : _a.adapter.createTimeoutError;
        return adapterTimeoutError
            ? adapterTimeoutError(name, timeoutMs)
            : new ProtocolV2LinkError('response-timeout', `Protocol V2 call timeout after ${timeoutMs}ms while queued for ${name}`);
    }
    assertCallGeneration(key, generation) {
        var _a;
        const currentGeneration = (_a = this.generations.get(key)) !== null && _a !== void 0 ? _a : 0;
        if (currentGeneration === generation)
            return;
        const invalidation = this.invalidationReasons.get(key);
        const reason = (invalidation === null || invalidation === void 0 ? void 0 : invalidation.generation) === currentGeneration
            ? invalidation.reason
            : 'Protocol V2 link generation changed';
        throw new ProtocolV2LinkError('generation', reason);
    }
}

class ProtocolV2UsbTransportBase {
    constructor(options) {
        this.protocolV2UsbAssemblers = new Map();
        this.protocolV2UsbGenerations = new Map();
        this.protocolV2UsbCancellations = new Map();
        this.protocolV2UsbOptions = options;
        this.protocolV2UsbLinks = new ProtocolV2LinkManager({
            getSchemas: () => this.getProtocolV2UsbSchemas(),
            classifyError: error => (isProtocolV2LinkError(error) ? 'link-fatal' : 'recoverable'),
            onLinkInvalidated: (key, reason) => __awaiter(this, void 0, void 0, function* () {
                var _a;
                (_a = this.protocolV2UsbAssemblers.get(key)) === null || _a === void 0 ? void 0 : _a.reset();
                yield this.resetProtocolV2UsbNativeLink(key, reason);
                yield this.onProtocolV2UsbLinkInvalidated(key, reason);
            }),
        });
    }
    onProtocolV2UsbLinkInvalidated(_key, _reason) {
    }
    rotateProtocolV2UsbGeneration(key, reason) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            yield this.protocolV2UsbLinks.invalidateLink(key, reason);
            const generation = ((_a = this.protocolV2UsbGenerations.get(key)) !== null && _a !== void 0 ? _a : 0) + 1;
            this.protocolV2UsbGenerations.set(key, generation);
            this.protocolV2UsbCancellations.set(key, this.createProtocolV2UsbCancellation(generation));
            this.protocolV2UsbAssemblers.set(key, new ProtocolV2FrameAssembler(this.protocolV2UsbOptions.maxFrameBytes));
            return generation;
        });
    }
    callProtocolV2Usb(key, name, data, options) {
        return this.protocolV2UsbLinks.call(key, () => this.createProtocolV2UsbAdapter(key), name, data, options);
    }
    sendProtocolV2UsbFlowControl(key, name, data) {
        return this.protocolV2UsbLinks.sendFlowControl(key, () => this.createProtocolV2UsbAdapter(key), name, data);
    }
    invalidateProtocolV2UsbLink(key, reason) {
        return this.protocolV2UsbLinks.invalidateLink(key, reason);
    }
    invalidateAllProtocolV2UsbLinks(reason) {
        return this.protocolV2UsbLinks.invalidateAllLinks(reason);
    }
    disposeProtocolV2UsbLinks(reason) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.protocolV2UsbLinks.dispose(reason);
            this.protocolV2UsbAssemblers.clear();
            this.protocolV2UsbGenerations.clear();
            this.protocolV2UsbCancellations.clear();
        });
    }
    createProtocolV2UsbAdapter(key) {
        const generation = this.protocolV2UsbGenerations.get(key);
        if (generation === undefined) {
            throw new Error('Protocol V2 USB generation has not been initialized');
        }
        const cancellation = this.protocolV2UsbCancellations.get(key);
        if (!cancellation || cancellation.generation !== generation) {
            throw new Error('Protocol V2 USB cancellation state has not been initialized');
        }
        const assertCurrentGeneration = () => {
            if (cancellation.reason) {
                throw new ProtocolV2LinkError('generation', cancellation.reason);
            }
            if (this.protocolV2UsbGenerations.get(key) !== generation) {
                throw new ProtocolV2LinkError('generation', 'Protocol V2 USB connection generation changed');
            }
        };
        return {
            router: this.protocolV2UsbOptions.router,
            maxFrameBytes: this.protocolV2UsbOptions.maxFrameBytes,
            generation,
            prepareCall: () => {
                assertCurrentGeneration();
            },
            writeFrame: (frame, context) => __awaiter(this, void 0, void 0, function* () {
                assertCurrentGeneration();
                try {
                    yield this.writeProtocolV2UsbPacket(key, frame, context);
                }
                catch (error) {
                    throw this.createProtocolV2UsbIoError('write', error);
                }
                assertCurrentGeneration();
            }),
            readFrame: (context) => __awaiter(this, void 0, void 0, function* () {
                assertCurrentGeneration();
                const assembler = this.getProtocolV2UsbAssembler(key);
                let frame = assembler.push(new Uint8Array(0));
                while (!frame) {
                    const packetRead = this.readProtocolV2UsbPacket(key, context)
                        .then(packet => ({ packet }))
                        .catch(error => {
                        throw this.createProtocolV2UsbIoError('read', error);
                    });
                    const cancelled = cancellation.promise.then(reason => ({ reason }));
                    const result = yield Promise.race([packetRead, cancelled]);
                    if ('reason' in result) {
                        throw new ProtocolV2LinkError('generation', result.reason);
                    }
                    assertCurrentGeneration();
                    frame = assembler.push(result.packet);
                }
                assertCurrentGeneration();
                return frame;
            }),
            reset: (reason) => {
                var _a;
                cancellation.cancel(reason);
                (_a = this.protocolV2UsbAssemblers.get(key)) === null || _a === void 0 ? void 0 : _a.reset();
            },
            logger: this.getProtocolV2UsbLogger(),
            logPrefix: this.protocolV2UsbOptions.logPrefix,
            createTimeoutError: (messageName, timeoutMs) => this.createProtocolV2UsbTimeoutError(messageName, timeoutMs),
        };
    }
    getProtocolV2UsbAssembler(key) {
        const assembler = this.protocolV2UsbAssemblers.get(key);
        if (!assembler) {
            throw new Error('Protocol V2 USB assembler has not been initialized');
        }
        return assembler;
    }
    createProtocolV2UsbCancellation(generation) {
        let resolveCancellation = () => undefined;
        const cancellation = {
            generation,
            promise: new Promise(resolve => {
                resolveCancellation = resolve;
            }),
            cancel: reason => {
                if (cancellation.reason)
                    return;
                cancellation.reason = reason;
                resolveCancellation(reason);
            },
        };
        return cancellation;
    }
    createProtocolV2UsbIoError(operation, error) {
        if (isProtocolV2LinkError(error))
            return error;
        return new ProtocolV2LinkError('io', `Protocol V2 USB ${operation} failed: ${getErrorMessage(error) || 'unknown error'}`, error);
    }
}

const TRANSPORT_EVENT = {
    DEVICE_DISCONNECT: 'transport-device-disconnect',
};

exports.AptosTransactionType = void 0;
(function (AptosTransactionType) {
    AptosTransactionType[AptosTransactionType["STANDARD"] = 0] = "STANDARD";
    AptosTransactionType[AptosTransactionType["WITH_DATA"] = 1] = "WITH_DATA";
})(exports.AptosTransactionType || (exports.AptosTransactionType = {}));
exports.BinanceOrderType = void 0;
(function (BinanceOrderType) {
    BinanceOrderType[BinanceOrderType["OT_UNKNOWN"] = 0] = "OT_UNKNOWN";
    BinanceOrderType[BinanceOrderType["MARKET"] = 1] = "MARKET";
    BinanceOrderType[BinanceOrderType["LIMIT"] = 2] = "LIMIT";
    BinanceOrderType[BinanceOrderType["OT_RESERVED"] = 3] = "OT_RESERVED";
})(exports.BinanceOrderType || (exports.BinanceOrderType = {}));
exports.BinanceOrderSide = void 0;
(function (BinanceOrderSide) {
    BinanceOrderSide[BinanceOrderSide["SIDE_UNKNOWN"] = 0] = "SIDE_UNKNOWN";
    BinanceOrderSide[BinanceOrderSide["BUY"] = 1] = "BUY";
    BinanceOrderSide[BinanceOrderSide["SELL"] = 2] = "SELL";
})(exports.BinanceOrderSide || (exports.BinanceOrderSide = {}));
exports.BinanceTimeInForce = void 0;
(function (BinanceTimeInForce) {
    BinanceTimeInForce[BinanceTimeInForce["TIF_UNKNOWN"] = 0] = "TIF_UNKNOWN";
    BinanceTimeInForce[BinanceTimeInForce["GTE"] = 1] = "GTE";
    BinanceTimeInForce[BinanceTimeInForce["TIF_RESERVED"] = 2] = "TIF_RESERVED";
    BinanceTimeInForce[BinanceTimeInForce["IOC"] = 3] = "IOC";
})(exports.BinanceTimeInForce || (exports.BinanceTimeInForce = {}));
exports.Enum_InputScriptType = void 0;
(function (Enum_InputScriptType) {
    Enum_InputScriptType[Enum_InputScriptType["SPENDADDRESS"] = 0] = "SPENDADDRESS";
    Enum_InputScriptType[Enum_InputScriptType["SPENDMULTISIG"] = 1] = "SPENDMULTISIG";
    Enum_InputScriptType[Enum_InputScriptType["EXTERNAL"] = 2] = "EXTERNAL";
    Enum_InputScriptType[Enum_InputScriptType["SPENDWITNESS"] = 3] = "SPENDWITNESS";
    Enum_InputScriptType[Enum_InputScriptType["SPENDP2SHWITNESS"] = 4] = "SPENDP2SHWITNESS";
    Enum_InputScriptType[Enum_InputScriptType["SPENDTAPROOT"] = 5] = "SPENDTAPROOT";
})(exports.Enum_InputScriptType || (exports.Enum_InputScriptType = {}));
exports.Enum_OutputScriptType = void 0;
(function (Enum_OutputScriptType) {
    Enum_OutputScriptType[Enum_OutputScriptType["PAYTOADDRESS"] = 0] = "PAYTOADDRESS";
    Enum_OutputScriptType[Enum_OutputScriptType["PAYTOSCRIPTHASH"] = 1] = "PAYTOSCRIPTHASH";
    Enum_OutputScriptType[Enum_OutputScriptType["PAYTOMULTISIG"] = 2] = "PAYTOMULTISIG";
    Enum_OutputScriptType[Enum_OutputScriptType["PAYTOOPRETURN"] = 3] = "PAYTOOPRETURN";
    Enum_OutputScriptType[Enum_OutputScriptType["PAYTOWITNESS"] = 4] = "PAYTOWITNESS";
    Enum_OutputScriptType[Enum_OutputScriptType["PAYTOP2SHWITNESS"] = 5] = "PAYTOP2SHWITNESS";
    Enum_OutputScriptType[Enum_OutputScriptType["PAYTOTAPROOT"] = 6] = "PAYTOTAPROOT";
})(exports.Enum_OutputScriptType || (exports.Enum_OutputScriptType = {}));
exports.DecredStakingSpendType = void 0;
(function (DecredStakingSpendType) {
    DecredStakingSpendType[DecredStakingSpendType["SSGen"] = 0] = "SSGen";
    DecredStakingSpendType[DecredStakingSpendType["SSRTX"] = 1] = "SSRTX";
})(exports.DecredStakingSpendType || (exports.DecredStakingSpendType = {}));
exports.AmountUnit = void 0;
(function (AmountUnit) {
    AmountUnit[AmountUnit["BITCOIN"] = 0] = "BITCOIN";
    AmountUnit[AmountUnit["MILLIBITCOIN"] = 1] = "MILLIBITCOIN";
    AmountUnit[AmountUnit["MICROBITCOIN"] = 2] = "MICROBITCOIN";
    AmountUnit[AmountUnit["SATOSHI"] = 3] = "SATOSHI";
})(exports.AmountUnit || (exports.AmountUnit = {}));
exports.Enum_RequestType = void 0;
(function (Enum_RequestType) {
    Enum_RequestType[Enum_RequestType["TXINPUT"] = 0] = "TXINPUT";
    Enum_RequestType[Enum_RequestType["TXOUTPUT"] = 1] = "TXOUTPUT";
    Enum_RequestType[Enum_RequestType["TXMETA"] = 2] = "TXMETA";
    Enum_RequestType[Enum_RequestType["TXFINISHED"] = 3] = "TXFINISHED";
    Enum_RequestType[Enum_RequestType["TXEXTRADATA"] = 4] = "TXEXTRADATA";
    Enum_RequestType[Enum_RequestType["TXORIGINPUT"] = 5] = "TXORIGINPUT";
    Enum_RequestType[Enum_RequestType["TXORIGOUTPUT"] = 6] = "TXORIGOUTPUT";
    Enum_RequestType[Enum_RequestType["TXPAYMENTREQ"] = 7] = "TXPAYMENTREQ";
})(exports.Enum_RequestType || (exports.Enum_RequestType = {}));
exports.RebootType = void 0;
(function (RebootType) {
    RebootType[RebootType["Normal"] = 0] = "Normal";
    RebootType[RebootType["Boardloader"] = 1] = "Boardloader";
    RebootType[RebootType["BootLoader"] = 2] = "BootLoader";
})(exports.RebootType || (exports.RebootType = {}));
exports.CardanoDerivationType = void 0;
(function (CardanoDerivationType) {
    CardanoDerivationType[CardanoDerivationType["LEDGER"] = 0] = "LEDGER";
    CardanoDerivationType[CardanoDerivationType["ICARUS"] = 1] = "ICARUS";
    CardanoDerivationType[CardanoDerivationType["ICARUS_TREZOR"] = 2] = "ICARUS_TREZOR";
})(exports.CardanoDerivationType || (exports.CardanoDerivationType = {}));
exports.CardanoAddressType = void 0;
(function (CardanoAddressType) {
    CardanoAddressType[CardanoAddressType["BASE"] = 0] = "BASE";
    CardanoAddressType[CardanoAddressType["BASE_SCRIPT_KEY"] = 1] = "BASE_SCRIPT_KEY";
    CardanoAddressType[CardanoAddressType["BASE_KEY_SCRIPT"] = 2] = "BASE_KEY_SCRIPT";
    CardanoAddressType[CardanoAddressType["BASE_SCRIPT_SCRIPT"] = 3] = "BASE_SCRIPT_SCRIPT";
    CardanoAddressType[CardanoAddressType["POINTER"] = 4] = "POINTER";
    CardanoAddressType[CardanoAddressType["POINTER_SCRIPT"] = 5] = "POINTER_SCRIPT";
    CardanoAddressType[CardanoAddressType["ENTERPRISE"] = 6] = "ENTERPRISE";
    CardanoAddressType[CardanoAddressType["ENTERPRISE_SCRIPT"] = 7] = "ENTERPRISE_SCRIPT";
    CardanoAddressType[CardanoAddressType["BYRON"] = 8] = "BYRON";
    CardanoAddressType[CardanoAddressType["REWARD"] = 14] = "REWARD";
    CardanoAddressType[CardanoAddressType["REWARD_SCRIPT"] = 15] = "REWARD_SCRIPT";
})(exports.CardanoAddressType || (exports.CardanoAddressType = {}));
exports.CardanoNativeScriptType = void 0;
(function (CardanoNativeScriptType) {
    CardanoNativeScriptType[CardanoNativeScriptType["PUB_KEY"] = 0] = "PUB_KEY";
    CardanoNativeScriptType[CardanoNativeScriptType["ALL"] = 1] = "ALL";
    CardanoNativeScriptType[CardanoNativeScriptType["ANY"] = 2] = "ANY";
    CardanoNativeScriptType[CardanoNativeScriptType["N_OF_K"] = 3] = "N_OF_K";
    CardanoNativeScriptType[CardanoNativeScriptType["INVALID_BEFORE"] = 4] = "INVALID_BEFORE";
    CardanoNativeScriptType[CardanoNativeScriptType["INVALID_HEREAFTER"] = 5] = "INVALID_HEREAFTER";
})(exports.CardanoNativeScriptType || (exports.CardanoNativeScriptType = {}));
exports.CardanoNativeScriptHashDisplayFormat = void 0;
(function (CardanoNativeScriptHashDisplayFormat) {
    CardanoNativeScriptHashDisplayFormat[CardanoNativeScriptHashDisplayFormat["HIDE"] = 0] = "HIDE";
    CardanoNativeScriptHashDisplayFormat[CardanoNativeScriptHashDisplayFormat["BECH32"] = 1] = "BECH32";
    CardanoNativeScriptHashDisplayFormat[CardanoNativeScriptHashDisplayFormat["POLICY_ID"] = 2] = "POLICY_ID";
})(exports.CardanoNativeScriptHashDisplayFormat || (exports.CardanoNativeScriptHashDisplayFormat = {}));
exports.CardanoTxOutputSerializationFormat = void 0;
(function (CardanoTxOutputSerializationFormat) {
    CardanoTxOutputSerializationFormat[CardanoTxOutputSerializationFormat["ARRAY_LEGACY"] = 0] = "ARRAY_LEGACY";
    CardanoTxOutputSerializationFormat[CardanoTxOutputSerializationFormat["MAP_BABBAGE"] = 1] = "MAP_BABBAGE";
})(exports.CardanoTxOutputSerializationFormat || (exports.CardanoTxOutputSerializationFormat = {}));
exports.CardanoCertificateType = void 0;
(function (CardanoCertificateType) {
    CardanoCertificateType[CardanoCertificateType["STAKE_REGISTRATION"] = 0] = "STAKE_REGISTRATION";
    CardanoCertificateType[CardanoCertificateType["STAKE_DEREGISTRATION"] = 1] = "STAKE_DEREGISTRATION";
    CardanoCertificateType[CardanoCertificateType["STAKE_DELEGATION"] = 2] = "STAKE_DELEGATION";
    CardanoCertificateType[CardanoCertificateType["STAKE_POOL_REGISTRATION"] = 3] = "STAKE_POOL_REGISTRATION";
    CardanoCertificateType[CardanoCertificateType["STAKE_REGISTRATION_CONWAY"] = 7] = "STAKE_REGISTRATION_CONWAY";
    CardanoCertificateType[CardanoCertificateType["STAKE_DEREGISTRATION_CONWAY"] = 8] = "STAKE_DEREGISTRATION_CONWAY";
    CardanoCertificateType[CardanoCertificateType["VOTE_DELEGATION"] = 9] = "VOTE_DELEGATION";
})(exports.CardanoCertificateType || (exports.CardanoCertificateType = {}));
exports.CardanoDRepType = void 0;
(function (CardanoDRepType) {
    CardanoDRepType[CardanoDRepType["KEY_HASH"] = 0] = "KEY_HASH";
    CardanoDRepType[CardanoDRepType["SCRIPT_HASH"] = 1] = "SCRIPT_HASH";
    CardanoDRepType[CardanoDRepType["ABSTAIN"] = 2] = "ABSTAIN";
    CardanoDRepType[CardanoDRepType["NO_CONFIDENCE"] = 3] = "NO_CONFIDENCE";
})(exports.CardanoDRepType || (exports.CardanoDRepType = {}));
exports.CardanoPoolRelayType = void 0;
(function (CardanoPoolRelayType) {
    CardanoPoolRelayType[CardanoPoolRelayType["SINGLE_HOST_IP"] = 0] = "SINGLE_HOST_IP";
    CardanoPoolRelayType[CardanoPoolRelayType["SINGLE_HOST_NAME"] = 1] = "SINGLE_HOST_NAME";
    CardanoPoolRelayType[CardanoPoolRelayType["MULTIPLE_HOST_NAME"] = 2] = "MULTIPLE_HOST_NAME";
})(exports.CardanoPoolRelayType || (exports.CardanoPoolRelayType = {}));
exports.CardanoTxAuxiliaryDataSupplementType = void 0;
(function (CardanoTxAuxiliaryDataSupplementType) {
    CardanoTxAuxiliaryDataSupplementType[CardanoTxAuxiliaryDataSupplementType["NONE"] = 0] = "NONE";
    CardanoTxAuxiliaryDataSupplementType[CardanoTxAuxiliaryDataSupplementType["CVOTE_REGISTRATION_SIGNATURE"] = 1] = "CVOTE_REGISTRATION_SIGNATURE";
})(exports.CardanoTxAuxiliaryDataSupplementType || (exports.CardanoTxAuxiliaryDataSupplementType = {}));
exports.CardanoCVoteRegistrationFormat = void 0;
(function (CardanoCVoteRegistrationFormat) {
    CardanoCVoteRegistrationFormat[CardanoCVoteRegistrationFormat["CIP15"] = 0] = "CIP15";
    CardanoCVoteRegistrationFormat[CardanoCVoteRegistrationFormat["CIP36"] = 1] = "CIP36";
})(exports.CardanoCVoteRegistrationFormat || (exports.CardanoCVoteRegistrationFormat = {}));
exports.CardanoTxSigningMode = void 0;
(function (CardanoTxSigningMode) {
    CardanoTxSigningMode[CardanoTxSigningMode["ORDINARY_TRANSACTION"] = 0] = "ORDINARY_TRANSACTION";
    CardanoTxSigningMode[CardanoTxSigningMode["POOL_REGISTRATION_AS_OWNER"] = 1] = "POOL_REGISTRATION_AS_OWNER";
    CardanoTxSigningMode[CardanoTxSigningMode["MULTISIG_TRANSACTION"] = 2] = "MULTISIG_TRANSACTION";
    CardanoTxSigningMode[CardanoTxSigningMode["PLUTUS_TRANSACTION"] = 3] = "PLUTUS_TRANSACTION";
})(exports.CardanoTxSigningMode || (exports.CardanoTxSigningMode = {}));
exports.CardanoTxWitnessType = void 0;
(function (CardanoTxWitnessType) {
    CardanoTxWitnessType[CardanoTxWitnessType["BYRON_WITNESS"] = 0] = "BYRON_WITNESS";
    CardanoTxWitnessType[CardanoTxWitnessType["SHELLEY_WITNESS"] = 1] = "SHELLEY_WITNESS";
})(exports.CardanoTxWitnessType || (exports.CardanoTxWitnessType = {}));
exports.FailureType = void 0;
(function (FailureType) {
    FailureType[FailureType["Failure_UnexpectedMessage"] = 1] = "Failure_UnexpectedMessage";
    FailureType[FailureType["Failure_ButtonExpected"] = 2] = "Failure_ButtonExpected";
    FailureType[FailureType["Failure_DataError"] = 3] = "Failure_DataError";
    FailureType[FailureType["Failure_ActionCancelled"] = 4] = "Failure_ActionCancelled";
    FailureType[FailureType["Failure_PinExpected"] = 5] = "Failure_PinExpected";
    FailureType[FailureType["Failure_PinCancelled"] = 6] = "Failure_PinCancelled";
    FailureType[FailureType["Failure_PinInvalid"] = 7] = "Failure_PinInvalid";
    FailureType[FailureType["Failure_InvalidSignature"] = 8] = "Failure_InvalidSignature";
    FailureType[FailureType["Failure_ProcessError"] = 9] = "Failure_ProcessError";
    FailureType[FailureType["Failure_NotEnoughFunds"] = 10] = "Failure_NotEnoughFunds";
    FailureType[FailureType["Failure_NotInitialized"] = 11] = "Failure_NotInitialized";
    FailureType[FailureType["Failure_PinMismatch"] = 12] = "Failure_PinMismatch";
    FailureType[FailureType["Failure_WipeCodeMismatch"] = 13] = "Failure_WipeCodeMismatch";
    FailureType[FailureType["Failure_InvalidSession"] = 14] = "Failure_InvalidSession";
    FailureType[FailureType["Failure_FirmwareError"] = 99] = "Failure_FirmwareError";
    FailureType[FailureType["Failure_InvalidMessage"] = 1] = "Failure_InvalidMessage";
    FailureType[FailureType["Failure_UndefinedError"] = 2] = "Failure_UndefinedError";
    FailureType[FailureType["Failure_UsageError"] = 3] = "Failure_UsageError";
})(exports.FailureType || (exports.FailureType = {}));
exports.Enum_ButtonRequestType = void 0;
(function (Enum_ButtonRequestType) {
    Enum_ButtonRequestType[Enum_ButtonRequestType["ButtonRequest_Other"] = 1] = "ButtonRequest_Other";
    Enum_ButtonRequestType[Enum_ButtonRequestType["ButtonRequest_FeeOverThreshold"] = 2] = "ButtonRequest_FeeOverThreshold";
    Enum_ButtonRequestType[Enum_ButtonRequestType["ButtonRequest_ConfirmOutput"] = 3] = "ButtonRequest_ConfirmOutput";
    Enum_ButtonRequestType[Enum_ButtonRequestType["ButtonRequest_ResetDevice"] = 4] = "ButtonRequest_ResetDevice";
    Enum_ButtonRequestType[Enum_ButtonRequestType["ButtonRequest_ConfirmWord"] = 5] = "ButtonRequest_ConfirmWord";
    Enum_ButtonRequestType[Enum_ButtonRequestType["ButtonRequest_WipeDevice"] = 6] = "ButtonRequest_WipeDevice";
    Enum_ButtonRequestType[Enum_ButtonRequestType["ButtonRequest_ProtectCall"] = 7] = "ButtonRequest_ProtectCall";
    Enum_ButtonRequestType[Enum_ButtonRequestType["ButtonRequest_SignTx"] = 8] = "ButtonRequest_SignTx";
    Enum_ButtonRequestType[Enum_ButtonRequestType["ButtonRequest_FirmwareCheck"] = 9] = "ButtonRequest_FirmwareCheck";
    Enum_ButtonRequestType[Enum_ButtonRequestType["ButtonRequest_Address"] = 10] = "ButtonRequest_Address";
    Enum_ButtonRequestType[Enum_ButtonRequestType["ButtonRequest_PublicKey"] = 11] = "ButtonRequest_PublicKey";
    Enum_ButtonRequestType[Enum_ButtonRequestType["ButtonRequest_MnemonicWordCount"] = 12] = "ButtonRequest_MnemonicWordCount";
    Enum_ButtonRequestType[Enum_ButtonRequestType["ButtonRequest_MnemonicInput"] = 13] = "ButtonRequest_MnemonicInput";
    Enum_ButtonRequestType[Enum_ButtonRequestType["_Deprecated_ButtonRequest_PassphraseType"] = 14] = "_Deprecated_ButtonRequest_PassphraseType";
    Enum_ButtonRequestType[Enum_ButtonRequestType["ButtonRequest_UnknownDerivationPath"] = 15] = "ButtonRequest_UnknownDerivationPath";
    Enum_ButtonRequestType[Enum_ButtonRequestType["ButtonRequest_RecoveryHomepage"] = 16] = "ButtonRequest_RecoveryHomepage";
    Enum_ButtonRequestType[Enum_ButtonRequestType["ButtonRequest_Success"] = 17] = "ButtonRequest_Success";
    Enum_ButtonRequestType[Enum_ButtonRequestType["ButtonRequest_Warning"] = 18] = "ButtonRequest_Warning";
    Enum_ButtonRequestType[Enum_ButtonRequestType["ButtonRequest_PassphraseEntry"] = 19] = "ButtonRequest_PassphraseEntry";
    Enum_ButtonRequestType[Enum_ButtonRequestType["ButtonRequest_PinEntry"] = 20] = "ButtonRequest_PinEntry";
    Enum_ButtonRequestType[Enum_ButtonRequestType["ButtonRequest_AttachPin"] = 8000] = "ButtonRequest_AttachPin";
})(exports.Enum_ButtonRequestType || (exports.Enum_ButtonRequestType = {}));
exports.Enum_PinMatrixRequestType = void 0;
(function (Enum_PinMatrixRequestType) {
    Enum_PinMatrixRequestType[Enum_PinMatrixRequestType["PinMatrixRequestType_Current"] = 1] = "PinMatrixRequestType_Current";
    Enum_PinMatrixRequestType[Enum_PinMatrixRequestType["PinMatrixRequestType_NewFirst"] = 2] = "PinMatrixRequestType_NewFirst";
    Enum_PinMatrixRequestType[Enum_PinMatrixRequestType["PinMatrixRequestType_NewSecond"] = 3] = "PinMatrixRequestType_NewSecond";
    Enum_PinMatrixRequestType[Enum_PinMatrixRequestType["PinMatrixRequestType_WipeCodeFirst"] = 4] = "PinMatrixRequestType_WipeCodeFirst";
    Enum_PinMatrixRequestType[Enum_PinMatrixRequestType["PinMatrixRequestType_WipeCodeSecond"] = 5] = "PinMatrixRequestType_WipeCodeSecond";
    Enum_PinMatrixRequestType[Enum_PinMatrixRequestType["PinMatrixRequestType_BackupFirst"] = 6] = "PinMatrixRequestType_BackupFirst";
    Enum_PinMatrixRequestType[Enum_PinMatrixRequestType["PinMatrixRequestType_BackupSecond"] = 7] = "PinMatrixRequestType_BackupSecond";
    Enum_PinMatrixRequestType[Enum_PinMatrixRequestType["PinMatrixRequestType_AttachToPin"] = 8000] = "PinMatrixRequestType_AttachToPin";
})(exports.Enum_PinMatrixRequestType || (exports.Enum_PinMatrixRequestType = {}));
exports.EthereumDefinitionType = void 0;
(function (EthereumDefinitionType) {
    EthereumDefinitionType[EthereumDefinitionType["NETWORK"] = 0] = "NETWORK";
    EthereumDefinitionType[EthereumDefinitionType["TOKEN"] = 1] = "TOKEN";
})(exports.EthereumDefinitionType || (exports.EthereumDefinitionType = {}));
exports.EthereumGnosisSafeTxOperation = void 0;
(function (EthereumGnosisSafeTxOperation) {
    EthereumGnosisSafeTxOperation[EthereumGnosisSafeTxOperation["CALL"] = 0] = "CALL";
    EthereumGnosisSafeTxOperation[EthereumGnosisSafeTxOperation["DELEGATE_CALL"] = 1] = "DELEGATE_CALL";
})(exports.EthereumGnosisSafeTxOperation || (exports.EthereumGnosisSafeTxOperation = {}));
exports.EthereumDataTypeOneKey = void 0;
(function (EthereumDataTypeOneKey) {
    EthereumDataTypeOneKey[EthereumDataTypeOneKey["UINT"] = 1] = "UINT";
    EthereumDataTypeOneKey[EthereumDataTypeOneKey["INT"] = 2] = "INT";
    EthereumDataTypeOneKey[EthereumDataTypeOneKey["BYTES"] = 3] = "BYTES";
    EthereumDataTypeOneKey[EthereumDataTypeOneKey["STRING"] = 4] = "STRING";
    EthereumDataTypeOneKey[EthereumDataTypeOneKey["BOOL"] = 5] = "BOOL";
    EthereumDataTypeOneKey[EthereumDataTypeOneKey["ADDRESS"] = 6] = "ADDRESS";
    EthereumDataTypeOneKey[EthereumDataTypeOneKey["ARRAY"] = 7] = "ARRAY";
    EthereumDataTypeOneKey[EthereumDataTypeOneKey["STRUCT"] = 8] = "STRUCT";
})(exports.EthereumDataTypeOneKey || (exports.EthereumDataTypeOneKey = {}));
exports.EthereumDataType = void 0;
(function (EthereumDataType) {
    EthereumDataType[EthereumDataType["UINT"] = 1] = "UINT";
    EthereumDataType[EthereumDataType["INT"] = 2] = "INT";
    EthereumDataType[EthereumDataType["BYTES"] = 3] = "BYTES";
    EthereumDataType[EthereumDataType["STRING"] = 4] = "STRING";
    EthereumDataType[EthereumDataType["BOOL"] = 5] = "BOOL";
    EthereumDataType[EthereumDataType["ADDRESS"] = 6] = "ADDRESS";
    EthereumDataType[EthereumDataType["ARRAY"] = 7] = "ARRAY";
    EthereumDataType[EthereumDataType["STRUCT"] = 8] = "STRUCT";
})(exports.EthereumDataType || (exports.EthereumDataType = {}));
exports.Enum_KaspaInputScriptType = void 0;
(function (Enum_KaspaInputScriptType) {
    Enum_KaspaInputScriptType[Enum_KaspaInputScriptType["KASPA_SPEND_P2PK_SCHNORR"] = 0] = "KASPA_SPEND_P2PK_SCHNORR";
    Enum_KaspaInputScriptType[Enum_KaspaInputScriptType["KASPA_SPEND_P2PK_ECDSA"] = 1] = "KASPA_SPEND_P2PK_ECDSA";
})(exports.Enum_KaspaInputScriptType || (exports.Enum_KaspaInputScriptType = {}));
exports.Enum_KaspaOutputScriptType = void 0;
(function (Enum_KaspaOutputScriptType) {
    Enum_KaspaOutputScriptType[Enum_KaspaOutputScriptType["KASPA_PAYTOADDRESS"] = 0] = "KASPA_PAYTOADDRESS";
    Enum_KaspaOutputScriptType[Enum_KaspaOutputScriptType["KASPA_PAYTOCHANGE"] = 1] = "KASPA_PAYTOCHANGE";
})(exports.Enum_KaspaOutputScriptType || (exports.Enum_KaspaOutputScriptType = {}));
exports.Enum_KaspaRequestType = void 0;
(function (Enum_KaspaRequestType) {
    Enum_KaspaRequestType[Enum_KaspaRequestType["KASPA_TX_INPUT"] = 0] = "KASPA_TX_INPUT";
    Enum_KaspaRequestType[Enum_KaspaRequestType["KASPA_TX_OUTPUT"] = 1] = "KASPA_TX_OUTPUT";
    Enum_KaspaRequestType[Enum_KaspaRequestType["KASPA_TX_PAYLOAD"] = 2] = "KASPA_TX_PAYLOAD";
    Enum_KaspaRequestType[Enum_KaspaRequestType["KASPA_TX_FINISHED"] = 3] = "KASPA_TX_FINISHED";
    Enum_KaspaRequestType[Enum_KaspaRequestType["KASPA_TX_PREV_META"] = 4] = "KASPA_TX_PREV_META";
})(exports.Enum_KaspaRequestType || (exports.Enum_KaspaRequestType = {}));
exports.Enum_BackupType = void 0;
(function (Enum_BackupType) {
    Enum_BackupType[Enum_BackupType["Bip39"] = 0] = "Bip39";
    Enum_BackupType[Enum_BackupType["Slip39_Basic"] = 1] = "Slip39_Basic";
    Enum_BackupType[Enum_BackupType["Slip39_Advanced"] = 2] = "Slip39_Advanced";
    Enum_BackupType[Enum_BackupType["Slip39_Single_Extendable"] = 3] = "Slip39_Single_Extendable";
    Enum_BackupType[Enum_BackupType["Slip39_Basic_Extendable"] = 4] = "Slip39_Basic_Extendable";
    Enum_BackupType[Enum_BackupType["Slip39_Advanced_Extendable"] = 5] = "Slip39_Advanced_Extendable";
})(exports.Enum_BackupType || (exports.Enum_BackupType = {}));
exports.Enum_SafetyCheckLevel = void 0;
(function (Enum_SafetyCheckLevel) {
    Enum_SafetyCheckLevel[Enum_SafetyCheckLevel["Strict"] = 0] = "Strict";
    Enum_SafetyCheckLevel[Enum_SafetyCheckLevel["PromptAlways"] = 1] = "PromptAlways";
    Enum_SafetyCheckLevel[Enum_SafetyCheckLevel["PromptTemporarily"] = 2] = "PromptTemporarily";
})(exports.Enum_SafetyCheckLevel || (exports.Enum_SafetyCheckLevel = {}));
exports.OneKeyDeviceType = void 0;
(function (OneKeyDeviceType) {
    OneKeyDeviceType[OneKeyDeviceType["CLASSIC"] = 0] = "CLASSIC";
    OneKeyDeviceType[OneKeyDeviceType["CLASSIC1S"] = 1] = "CLASSIC1S";
    OneKeyDeviceType[OneKeyDeviceType["MINI"] = 2] = "MINI";
    OneKeyDeviceType[OneKeyDeviceType["TOUCH"] = 3] = "TOUCH";
    OneKeyDeviceType[OneKeyDeviceType["PRO"] = 5] = "PRO";
    OneKeyDeviceType[OneKeyDeviceType["PURE"] = 6] = "PURE";
})(exports.OneKeyDeviceType || (exports.OneKeyDeviceType = {}));
exports.OneKeySeType = void 0;
(function (OneKeySeType) {
    OneKeySeType[OneKeySeType["THD89"] = 0] = "THD89";
    OneKeySeType[OneKeySeType["SE608A"] = 1] = "SE608A";
})(exports.OneKeySeType || (exports.OneKeySeType = {}));
exports.OneKeySEState = void 0;
(function (OneKeySEState) {
    OneKeySEState[OneKeySEState["BOOT"] = 0] = "BOOT";
    OneKeySEState[OneKeySEState["APP"] = 1] = "APP";
})(exports.OneKeySEState || (exports.OneKeySEState = {}));
exports.Enum_Capability = void 0;
(function (Enum_Capability) {
    Enum_Capability[Enum_Capability["Capability_Bitcoin"] = 1] = "Capability_Bitcoin";
    Enum_Capability[Enum_Capability["Capability_Bitcoin_like"] = 2] = "Capability_Bitcoin_like";
    Enum_Capability[Enum_Capability["Capability_Binance"] = 3] = "Capability_Binance";
    Enum_Capability[Enum_Capability["Capability_Cardano"] = 4] = "Capability_Cardano";
    Enum_Capability[Enum_Capability["Capability_Crypto"] = 5] = "Capability_Crypto";
    Enum_Capability[Enum_Capability["Capability_EOS"] = 6] = "Capability_EOS";
    Enum_Capability[Enum_Capability["Capability_Ethereum"] = 7] = "Capability_Ethereum";
    Enum_Capability[Enum_Capability["Capability_Lisk"] = 8] = "Capability_Lisk";
    Enum_Capability[Enum_Capability["Capability_Monero"] = 9] = "Capability_Monero";
    Enum_Capability[Enum_Capability["Capability_NEM"] = 10] = "Capability_NEM";
    Enum_Capability[Enum_Capability["Capability_Ripple"] = 11] = "Capability_Ripple";
    Enum_Capability[Enum_Capability["Capability_Stellar"] = 12] = "Capability_Stellar";
    Enum_Capability[Enum_Capability["Capability_Tezos"] = 13] = "Capability_Tezos";
    Enum_Capability[Enum_Capability["Capability_U2F"] = 14] = "Capability_U2F";
    Enum_Capability[Enum_Capability["Capability_Shamir"] = 15] = "Capability_Shamir";
    Enum_Capability[Enum_Capability["Capability_ShamirGroups"] = 16] = "Capability_ShamirGroups";
    Enum_Capability[Enum_Capability["Capability_PassphraseEntry"] = 17] = "Capability_PassphraseEntry";
    Enum_Capability[Enum_Capability["Capability_EthereumTypedData"] = 1000] = "Capability_EthereumTypedData";
    Enum_Capability[Enum_Capability["Capability_AttachToPin"] = 8000] = "Capability_AttachToPin";
})(exports.Enum_Capability || (exports.Enum_Capability = {}));
exports.ExportType = void 0;
(function (ExportType) {
    ExportType[ExportType["SeedEncExportType_NO"] = 0] = "SeedEncExportType_NO";
    ExportType[ExportType["SeedEncExportType_YES"] = 1] = "SeedEncExportType_YES";
    ExportType[ExportType["MnemonicPlainExportType_YES"] = 2] = "MnemonicPlainExportType_YES";
})(exports.ExportType || (exports.ExportType = {}));
exports.SdProtectOperationType = void 0;
(function (SdProtectOperationType) {
    SdProtectOperationType[SdProtectOperationType["DISABLE"] = 0] = "DISABLE";
    SdProtectOperationType[SdProtectOperationType["ENABLE"] = 1] = "ENABLE";
    SdProtectOperationType[SdProtectOperationType["REFRESH"] = 2] = "REFRESH";
})(exports.SdProtectOperationType || (exports.SdProtectOperationType = {}));
exports.RecoveryDeviceType = void 0;
(function (RecoveryDeviceType) {
    RecoveryDeviceType[RecoveryDeviceType["RecoveryDeviceType_ScrambledWords"] = 0] = "RecoveryDeviceType_ScrambledWords";
    RecoveryDeviceType[RecoveryDeviceType["RecoveryDeviceType_Matrix"] = 1] = "RecoveryDeviceType_Matrix";
})(exports.RecoveryDeviceType || (exports.RecoveryDeviceType = {}));
exports.Enum_WordRequestType = void 0;
(function (Enum_WordRequestType) {
    Enum_WordRequestType[Enum_WordRequestType["WordRequestType_Plain"] = 0] = "WordRequestType_Plain";
    Enum_WordRequestType[Enum_WordRequestType["WordRequestType_Matrix9"] = 1] = "WordRequestType_Matrix9";
    Enum_WordRequestType[Enum_WordRequestType["WordRequestType_Matrix6"] = 2] = "WordRequestType_Matrix6";
})(exports.Enum_WordRequestType || (exports.Enum_WordRequestType = {}));
exports.SeedRequestType = void 0;
(function (SeedRequestType) {
    SeedRequestType[SeedRequestType["SeedRequestType_Gen"] = 0] = "SeedRequestType_Gen";
    SeedRequestType[SeedRequestType["SeedRequestType_EncExport"] = 1] = "SeedRequestType_EncExport";
    SeedRequestType[SeedRequestType["SeedRequestType_EncImport"] = 2] = "SeedRequestType_EncImport";
})(exports.SeedRequestType || (exports.SeedRequestType = {}));
exports.WL_OperationType = void 0;
(function (WL_OperationType) {
    WL_OperationType[WL_OperationType["WL_OperationType_Add"] = 0] = "WL_OperationType_Add";
    WL_OperationType[WL_OperationType["WL_OperationType_Delete"] = 1] = "WL_OperationType_Delete";
    WL_OperationType[WL_OperationType["WL_OperationType_Inquire"] = 2] = "WL_OperationType_Inquire";
})(exports.WL_OperationType || (exports.WL_OperationType = {}));
exports.ResourceType = void 0;
(function (ResourceType) {
    ResourceType[ResourceType["WallPaper"] = 0] = "WallPaper";
    ResourceType[ResourceType["Nft"] = 1] = "Nft";
})(exports.ResourceType || (exports.ResourceType = {}));
exports.NEMMosaicLevy = void 0;
(function (NEMMosaicLevy) {
    NEMMosaicLevy[NEMMosaicLevy["MosaicLevy_Absolute"] = 1] = "MosaicLevy_Absolute";
    NEMMosaicLevy[NEMMosaicLevy["MosaicLevy_Percentile"] = 2] = "MosaicLevy_Percentile";
})(exports.NEMMosaicLevy || (exports.NEMMosaicLevy = {}));
exports.NEMSupplyChangeType = void 0;
(function (NEMSupplyChangeType) {
    NEMSupplyChangeType[NEMSupplyChangeType["SupplyChange_Increase"] = 1] = "SupplyChange_Increase";
    NEMSupplyChangeType[NEMSupplyChangeType["SupplyChange_Decrease"] = 2] = "SupplyChange_Decrease";
})(exports.NEMSupplyChangeType || (exports.NEMSupplyChangeType = {}));
exports.NEMModificationType = void 0;
(function (NEMModificationType) {
    NEMModificationType[NEMModificationType["CosignatoryModification_Add"] = 1] = "CosignatoryModification_Add";
    NEMModificationType[NEMModificationType["CosignatoryModification_Delete"] = 2] = "CosignatoryModification_Delete";
})(exports.NEMModificationType || (exports.NEMModificationType = {}));
exports.NEMImportanceTransferMode = void 0;
(function (NEMImportanceTransferMode) {
    NEMImportanceTransferMode[NEMImportanceTransferMode["ImportanceTransfer_Activate"] = 1] = "ImportanceTransfer_Activate";
    NEMImportanceTransferMode[NEMImportanceTransferMode["ImportanceTransfer_Deactivate"] = 2] = "ImportanceTransfer_Deactivate";
})(exports.NEMImportanceTransferMode || (exports.NEMImportanceTransferMode = {}));
exports.SolanaOffChainMessageVersion = void 0;
(function (SolanaOffChainMessageVersion) {
    SolanaOffChainMessageVersion[SolanaOffChainMessageVersion["MESSAGE_VERSION_0"] = 0] = "MESSAGE_VERSION_0";
    SolanaOffChainMessageVersion[SolanaOffChainMessageVersion["MESSAGE_VERSION_1"] = 1] = "MESSAGE_VERSION_1";
})(exports.SolanaOffChainMessageVersion || (exports.SolanaOffChainMessageVersion = {}));
exports.SolanaOffChainMessageFormat = void 0;
(function (SolanaOffChainMessageFormat) {
    SolanaOffChainMessageFormat[SolanaOffChainMessageFormat["V0_RESTRICTED_ASCII"] = 0] = "V0_RESTRICTED_ASCII";
    SolanaOffChainMessageFormat[SolanaOffChainMessageFormat["V0_LIMITED_UTF8"] = 1] = "V0_LIMITED_UTF8";
})(exports.SolanaOffChainMessageFormat || (exports.SolanaOffChainMessageFormat = {}));
exports.StellarAssetType = void 0;
(function (StellarAssetType) {
    StellarAssetType[StellarAssetType["NATIVE"] = 0] = "NATIVE";
    StellarAssetType[StellarAssetType["ALPHANUM4"] = 1] = "ALPHANUM4";
    StellarAssetType[StellarAssetType["ALPHANUM12"] = 2] = "ALPHANUM12";
})(exports.StellarAssetType || (exports.StellarAssetType = {}));
exports.StellarMemoType = void 0;
(function (StellarMemoType) {
    StellarMemoType[StellarMemoType["NONE"] = 0] = "NONE";
    StellarMemoType[StellarMemoType["TEXT"] = 1] = "TEXT";
    StellarMemoType[StellarMemoType["ID"] = 2] = "ID";
    StellarMemoType[StellarMemoType["HASH"] = 3] = "HASH";
    StellarMemoType[StellarMemoType["RETURN"] = 4] = "RETURN";
})(exports.StellarMemoType || (exports.StellarMemoType = {}));
exports.StellarSignerType = void 0;
(function (StellarSignerType) {
    StellarSignerType[StellarSignerType["ACCOUNT"] = 0] = "ACCOUNT";
    StellarSignerType[StellarSignerType["PRE_AUTH"] = 1] = "PRE_AUTH";
    StellarSignerType[StellarSignerType["HASH"] = 2] = "HASH";
})(exports.StellarSignerType || (exports.StellarSignerType = {}));
exports.StellarRequestType = void 0;
(function (StellarRequestType) {
    StellarRequestType[StellarRequestType["CALL"] = 0] = "CALL";
    StellarRequestType[StellarRequestType["AUTH"] = 1] = "AUTH";
    StellarRequestType[StellarRequestType["EXT"] = 2] = "EXT";
})(exports.StellarRequestType || (exports.StellarRequestType = {}));
exports.TezosContractType = void 0;
(function (TezosContractType) {
    TezosContractType[TezosContractType["Implicit"] = 0] = "Implicit";
    TezosContractType[TezosContractType["Originated"] = 1] = "Originated";
})(exports.TezosContractType || (exports.TezosContractType = {}));
exports.TezosBallotType = void 0;
(function (TezosBallotType) {
    TezosBallotType[TezosBallotType["Yay"] = 0] = "Yay";
    TezosBallotType[TezosBallotType["Nay"] = 1] = "Nay";
    TezosBallotType[TezosBallotType["Pass"] = 2] = "Pass";
})(exports.TezosBallotType || (exports.TezosBallotType = {}));
exports.TonWalletVersion = void 0;
(function (TonWalletVersion) {
    TonWalletVersion[TonWalletVersion["V4R2"] = 3] = "V4R2";
})(exports.TonWalletVersion || (exports.TonWalletVersion = {}));
exports.TonWorkChain = void 0;
(function (TonWorkChain) {
    TonWorkChain[TonWorkChain["BASECHAIN"] = 0] = "BASECHAIN";
    TonWorkChain[TonWorkChain["MASTERCHAIN"] = 1] = "MASTERCHAIN";
})(exports.TonWorkChain || (exports.TonWorkChain = {}));
exports.TonSignDataType = void 0;
(function (TonSignDataType) {
    TonSignDataType[TonSignDataType["TEXT"] = 0] = "TEXT";
    TonSignDataType[TonSignDataType["BINARY"] = 1] = "BINARY";
    TonSignDataType[TonSignDataType["CELL"] = 2] = "CELL";
})(exports.TonSignDataType || (exports.TonSignDataType = {}));
exports.TronResourceCode = void 0;
(function (TronResourceCode) {
    TronResourceCode[TronResourceCode["BANDWIDTH"] = 0] = "BANDWIDTH";
    TronResourceCode[TronResourceCode["ENERGY"] = 1] = "ENERGY";
    TronResourceCode[TronResourceCode["TRON_POWER"] = 2] = "TRON_POWER";
})(exports.TronResourceCode || (exports.TronResourceCode = {}));
exports.TronMessageType = void 0;
(function (TronMessageType) {
    TronMessageType[TronMessageType["V1"] = 1] = "V1";
    TronMessageType[TronMessageType["V2"] = 2] = "V2";
})(exports.TronMessageType || (exports.TronMessageType = {}));
exports.CommandFlags = void 0;
(function (CommandFlags) {
    CommandFlags[CommandFlags["Default"] = 0] = "Default";
    CommandFlags[CommandFlags["Factory_Only"] = 1] = "Factory_Only";
})(exports.CommandFlags || (exports.CommandFlags = {}));
exports.Enum_CanonicalBitcoinNetwork = void 0;
(function (Enum_CanonicalBitcoinNetwork) {
    Enum_CanonicalBitcoinNetwork[Enum_CanonicalBitcoinNetwork["BITCOIN_MAINNET"] = 0] = "BITCOIN_MAINNET";
    Enum_CanonicalBitcoinNetwork[Enum_CanonicalBitcoinNetwork["BITCOIN_TESTNET"] = 1] = "BITCOIN_TESTNET";
    Enum_CanonicalBitcoinNetwork[Enum_CanonicalBitcoinNetwork["BITCOIN_SIGNET"] = 2] = "BITCOIN_SIGNET";
    Enum_CanonicalBitcoinNetwork[Enum_CanonicalBitcoinNetwork["BITCOIN_REGTEST"] = 3] = "BITCOIN_REGTEST";
})(exports.Enum_CanonicalBitcoinNetwork || (exports.Enum_CanonicalBitcoinNetwork = {}));
exports.MoneroNetworkType = void 0;
(function (MoneroNetworkType) {
    MoneroNetworkType[MoneroNetworkType["MAINNET"] = 0] = "MAINNET";
    MoneroNetworkType[MoneroNetworkType["TESTNET"] = 1] = "TESTNET";
    MoneroNetworkType[MoneroNetworkType["STAGENET"] = 2] = "STAGENET";
    MoneroNetworkType[MoneroNetworkType["FAKECHAIN"] = 3] = "FAKECHAIN";
})(exports.MoneroNetworkType || (exports.MoneroNetworkType = {}));
exports.UiAnimationType = void 0;
(function (UiAnimationType) {
    UiAnimationType[UiAnimationType["Unknown"] = 0] = "Unknown";
    UiAnimationType[UiAnimationType["Signing"] = 1] = "Signing";
})(exports.UiAnimationType || (exports.UiAnimationType = {}));
exports.UiAnimationCommand = void 0;
(function (UiAnimationCommand) {
    UiAnimationCommand[UiAnimationCommand["CommandUnknown"] = 0] = "CommandUnknown";
    UiAnimationCommand[UiAnimationCommand["Start"] = 1] = "Start";
    UiAnimationCommand[UiAnimationCommand["Stop"] = 2] = "Stop";
    UiAnimationCommand[UiAnimationCommand["Refresh"] = 3] = "Refresh";
})(exports.UiAnimationCommand || (exports.UiAnimationCommand = {}));
exports.DeviceErrorCode = void 0;
(function (DeviceErrorCode) {
    DeviceErrorCode[DeviceErrorCode["DeviceError_None"] = 0] = "DeviceError_None";
    DeviceErrorCode[DeviceErrorCode["DeviceError_Busy"] = 1] = "DeviceError_Busy";
    DeviceErrorCode[DeviceErrorCode["DeviceError_NotInitialized"] = 2] = "DeviceError_NotInitialized";
    DeviceErrorCode[DeviceErrorCode["DeviceError_ActionCancelled"] = 3] = "DeviceError_ActionCancelled";
    DeviceErrorCode[DeviceErrorCode["DeviceError_PinAlreadyUsed"] = 4] = "DeviceError_PinAlreadyUsed";
    DeviceErrorCode[DeviceErrorCode["DeviceError_PersistFailed"] = 5] = "DeviceError_PersistFailed";
    DeviceErrorCode[DeviceErrorCode["DeviceError_SeError"] = 6] = "DeviceError_SeError";
    DeviceErrorCode[DeviceErrorCode["DeviceError_InvalidLanguage"] = 7] = "DeviceError_InvalidLanguage";
    DeviceErrorCode[DeviceErrorCode["DeviceError_WallpaperNotUsable"] = 8] = "DeviceError_WallpaperNotUsable";
    DeviceErrorCode[DeviceErrorCode["DeviceError_DeviceLocked"] = 9] = "DeviceError_DeviceLocked";
})(exports.DeviceErrorCode || (exports.DeviceErrorCode = {}));
exports.DeviceRebootType = void 0;
(function (DeviceRebootType) {
    DeviceRebootType[DeviceRebootType["Normal"] = 0] = "Normal";
    DeviceRebootType[DeviceRebootType["Romloader"] = 1] = "Romloader";
    DeviceRebootType[DeviceRebootType["Bootloader"] = 2] = "Bootloader";
})(exports.DeviceRebootType || (exports.DeviceRebootType = {}));
exports.DeviceSettingsPage = void 0;
(function (DeviceSettingsPage) {
    DeviceSettingsPage[DeviceSettingsPage["DeviceReset"] = 0] = "DeviceReset";
    DeviceSettingsPage[DeviceSettingsPage["DevicePinChange"] = 1] = "DevicePinChange";
    DeviceSettingsPage[DeviceSettingsPage["DevicePassphrase"] = 2] = "DevicePassphrase";
    DeviceSettingsPage[DeviceSettingsPage["DeviceAirgap"] = 3] = "DeviceAirgap";
})(exports.DeviceSettingsPage || (exports.DeviceSettingsPage = {}));
exports.DeviceAnimationAction = void 0;
(function (DeviceAnimationAction) {
    DeviceAnimationAction[DeviceAnimationAction["AnimationAction_Unknown"] = 0] = "AnimationAction_Unknown";
    DeviceAnimationAction[DeviceAnimationAction["AnimationAction_Start"] = 1] = "AnimationAction_Start";
    DeviceAnimationAction[DeviceAnimationAction["AnimationAction_Stop"] = 2] = "AnimationAction_Stop";
})(exports.DeviceAnimationAction || (exports.DeviceAnimationAction = {}));
exports.DeviceFactoryAck = void 0;
(function (DeviceFactoryAck) {
    DeviceFactoryAck[DeviceFactoryAck["FACTORY_ACK_SUCCESS"] = 0] = "FACTORY_ACK_SUCCESS";
    DeviceFactoryAck[DeviceFactoryAck["FACTORY_ACK_FAIL"] = 1] = "FACTORY_ACK_FAIL";
})(exports.DeviceFactoryAck || (exports.DeviceFactoryAck = {}));
exports.DeviceFirmwareTargetType = void 0;
(function (DeviceFirmwareTargetType) {
    DeviceFirmwareTargetType[DeviceFirmwareTargetType["FW_MGMT_TARGET_INVALID"] = 0] = "FW_MGMT_TARGET_INVALID";
    DeviceFirmwareTargetType[DeviceFirmwareTargetType["FW_MGMT_TARGET_CRATE"] = 1] = "FW_MGMT_TARGET_CRATE";
    DeviceFirmwareTargetType[DeviceFirmwareTargetType["FW_MGMT_TARGET_ROMLOADER"] = 2] = "FW_MGMT_TARGET_ROMLOADER";
    DeviceFirmwareTargetType[DeviceFirmwareTargetType["FW_MGMT_TARGET_BOOTLOADER"] = 3] = "FW_MGMT_TARGET_BOOTLOADER";
    DeviceFirmwareTargetType[DeviceFirmwareTargetType["FW_MGMT_TARGET_APPLICATION_P1"] = 4] = "FW_MGMT_TARGET_APPLICATION_P1";
    DeviceFirmwareTargetType[DeviceFirmwareTargetType["FW_MGMT_TARGET_APPLICATION_P2"] = 5] = "FW_MGMT_TARGET_APPLICATION_P2";
    DeviceFirmwareTargetType[DeviceFirmwareTargetType["FW_MGMT_TARGET_COPROCESSOR"] = 6] = "FW_MGMT_TARGET_COPROCESSOR";
    DeviceFirmwareTargetType[DeviceFirmwareTargetType["FW_MGMT_TARGET_SE01"] = 7] = "FW_MGMT_TARGET_SE01";
    DeviceFirmwareTargetType[DeviceFirmwareTargetType["FW_MGMT_TARGET_SE02"] = 8] = "FW_MGMT_TARGET_SE02";
    DeviceFirmwareTargetType[DeviceFirmwareTargetType["FW_MGMT_TARGET_SE03"] = 9] = "FW_MGMT_TARGET_SE03";
    DeviceFirmwareTargetType[DeviceFirmwareTargetType["FW_MGMT_TARGET_SE04"] = 10] = "FW_MGMT_TARGET_SE04";
})(exports.DeviceFirmwareTargetType || (exports.DeviceFirmwareTargetType = {}));
exports.DeviceFirmwareUpdateTaskStatus = void 0;
(function (DeviceFirmwareUpdateTaskStatus) {
    DeviceFirmwareUpdateTaskStatus[DeviceFirmwareUpdateTaskStatus["FW_MGMT_UPDATER_TASK_STATUS_PENDING"] = 0] = "FW_MGMT_UPDATER_TASK_STATUS_PENDING";
    DeviceFirmwareUpdateTaskStatus[DeviceFirmwareUpdateTaskStatus["FW_MGMT_UPDATER_TASK_STATUS_IN_PROGRESS"] = 1] = "FW_MGMT_UPDATER_TASK_STATUS_IN_PROGRESS";
    DeviceFirmwareUpdateTaskStatus[DeviceFirmwareUpdateTaskStatus["FW_MGMT_UPDATER_TASK_STATUS_FINISHED"] = 2] = "FW_MGMT_UPDATER_TASK_STATUS_FINISHED";
    DeviceFirmwareUpdateTaskStatus[DeviceFirmwareUpdateTaskStatus["FW_MGMT_UPDATER_TASK_STATUS_FAILED_FILE_NOT_FOUND"] = 3] = "FW_MGMT_UPDATER_TASK_STATUS_FAILED_FILE_NOT_FOUND";
    DeviceFirmwareUpdateTaskStatus[DeviceFirmwareUpdateTaskStatus["FW_MGMT_UPDATER_TASK_STATUS_FAILED_FILE_READ"] = 4] = "FW_MGMT_UPDATER_TASK_STATUS_FAILED_FILE_READ";
    DeviceFirmwareUpdateTaskStatus[DeviceFirmwareUpdateTaskStatus["FW_MGMT_UPDATER_TASK_STATUS_FAILED_FILE_WRITE"] = 5] = "FW_MGMT_UPDATER_TASK_STATUS_FAILED_FILE_WRITE";
    DeviceFirmwareUpdateTaskStatus[DeviceFirmwareUpdateTaskStatus["FW_MGMT_UPDATER_TASK_STATUS_FAILED_VERIFY"] = 6] = "FW_MGMT_UPDATER_TASK_STATUS_FAILED_VERIFY";
    DeviceFirmwareUpdateTaskStatus[DeviceFirmwareUpdateTaskStatus["FW_MGMT_UPDATER_TASK_STATUS_FAILED_INSTALL"] = 7] = "FW_MGMT_UPDATER_TASK_STATUS_FAILED_INSTALL";
    DeviceFirmwareUpdateTaskStatus[DeviceFirmwareUpdateTaskStatus["FW_MGMT_UPDATER_TASK_STATUS_FAILED_ABORT"] = 8] = "FW_MGMT_UPDATER_TASK_STATUS_FAILED_ABORT";
    DeviceFirmwareUpdateTaskStatus[DeviceFirmwareUpdateTaskStatus["FW_MGMT_UPDATER_TASK_STATUS_FAILED_BUSY"] = 9] = "FW_MGMT_UPDATER_TASK_STATUS_FAILED_BUSY";
    DeviceFirmwareUpdateTaskStatus[DeviceFirmwareUpdateTaskStatus["FW_MGMT_UPDATER_TASK_STATUS_FAILED_ENTRY_OUT_OF_BOUNDS"] = 10] = "FW_MGMT_UPDATER_TASK_STATUS_FAILED_ENTRY_OUT_OF_BOUNDS";
})(exports.DeviceFirmwareUpdateTaskStatus || (exports.DeviceFirmwareUpdateTaskStatus = {}));
exports.DeviceFirmwareUpdatePhase = void 0;
(function (DeviceFirmwareUpdatePhase) {
    DeviceFirmwareUpdatePhase[DeviceFirmwareUpdatePhase["FW_MGMT_UPDATER_PHASE_PREPARE"] = 0] = "FW_MGMT_UPDATER_PHASE_PREPARE";
    DeviceFirmwareUpdatePhase[DeviceFirmwareUpdatePhase["FW_MGMT_UPDATER_PHASE_INSTALL"] = 1] = "FW_MGMT_UPDATER_PHASE_INSTALL";
    DeviceFirmwareUpdatePhase[DeviceFirmwareUpdatePhase["FW_MGMT_UPDATER_PHASE_VERIFY"] = 2] = "FW_MGMT_UPDATER_PHASE_VERIFY";
})(exports.DeviceFirmwareUpdatePhase || (exports.DeviceFirmwareUpdatePhase = {}));
exports.DeviceType = void 0;
(function (DeviceType) {
    DeviceType[DeviceType["CLASSIC1"] = 0] = "CLASSIC1";
    DeviceType[DeviceType["CLASSIC1S"] = 1] = "CLASSIC1S";
    DeviceType[DeviceType["MINI"] = 2] = "MINI";
    DeviceType[DeviceType["TOUCH"] = 3] = "TOUCH";
    DeviceType[DeviceType["PRO"] = 5] = "PRO";
    DeviceType[DeviceType["CLASSIC1S_PURE"] = 6] = "CLASSIC1S_PURE";
    DeviceType[DeviceType["PRO2"] = 7] = "PRO2";
    DeviceType[DeviceType["NEO"] = 8] = "NEO";
})(exports.DeviceType || (exports.DeviceType = {}));
exports.DeviceSeType = void 0;
(function (DeviceSeType) {
    DeviceSeType[DeviceSeType["THD89"] = 0] = "THD89";
    DeviceSeType[DeviceSeType["SE608A"] = 1] = "SE608A";
})(exports.DeviceSeType || (exports.DeviceSeType = {}));
exports.DeviceSEState = void 0;
(function (DeviceSEState) {
    DeviceSEState[DeviceSEState["BOOT"] = 0] = "BOOT";
    DeviceSEState[DeviceSEState["APP_FACTORY"] = 51] = "APP_FACTORY";
    DeviceSEState[DeviceSEState["APP"] = 85] = "APP";
})(exports.DeviceSEState || (exports.DeviceSEState = {}));
exports.DeviceSessionErrorCode = void 0;
(function (DeviceSessionErrorCode) {
    DeviceSessionErrorCode[DeviceSessionErrorCode["DeviceSessionError_None"] = 0] = "DeviceSessionError_None";
    DeviceSessionErrorCode[DeviceSessionErrorCode["DeviceSessionError_UserCancelled"] = 1] = "DeviceSessionError_UserCancelled";
    DeviceSessionErrorCode[DeviceSessionErrorCode["DeviceSessionError_InvalidSession"] = 2] = "DeviceSessionError_InvalidSession";
    DeviceSessionErrorCode[DeviceSessionErrorCode["DeviceSessionError_AttachPinUnavailable"] = 3] = "DeviceSessionError_AttachPinUnavailable";
    DeviceSessionErrorCode[DeviceSessionErrorCode["DeviceSessionError_PassphraseDisabled"] = 4] = "DeviceSessionError_PassphraseDisabled";
    DeviceSessionErrorCode[DeviceSessionErrorCode["DeviceSessionError_Busy"] = 5] = "DeviceSessionError_Busy";
})(exports.DeviceSessionErrorCode || (exports.DeviceSessionErrorCode = {}));
exports.DeviceSessionSeedDomain = void 0;
(function (DeviceSessionSeedDomain) {
    DeviceSessionSeedDomain[DeviceSessionSeedDomain["SeedDomain_Standard"] = 1] = "SeedDomain_Standard";
    DeviceSessionSeedDomain[DeviceSessionSeedDomain["SeedDomain_Cardano"] = 2] = "SeedDomain_Cardano";
})(exports.DeviceSessionSeedDomain || (exports.DeviceSessionSeedDomain = {}));
exports.DeviceSessionPinType = void 0;
(function (DeviceSessionPinType) {
    DeviceSessionPinType[DeviceSessionPinType["Any"] = 1] = "Any";
    DeviceSessionPinType[DeviceSessionPinType["Main"] = 2] = "Main";
    DeviceSessionPinType[DeviceSessionPinType["AttachToPin"] = 3] = "AttachToPin";
})(exports.DeviceSessionPinType || (exports.DeviceSessionPinType = {}));
exports.DeviceSessionAskPin_FailureSubCodes = void 0;
(function (DeviceSessionAskPin_FailureSubCodes) {
    DeviceSessionAskPin_FailureSubCodes[DeviceSessionAskPin_FailureSubCodes["UserCancel"] = 1] = "UserCancel";
})(exports.DeviceSessionAskPin_FailureSubCodes || (exports.DeviceSessionAskPin_FailureSubCodes = {}));
exports.OnboardingStep = void 0;
(function (OnboardingStep) {
    OnboardingStep[OnboardingStep["ONBOARDING_STEP_UNKNOWN"] = 0] = "ONBOARDING_STEP_UNKNOWN";
    OnboardingStep[OnboardingStep["ONBOARDING_STEP_CHECKING"] = 1] = "ONBOARDING_STEP_CHECKING";
    OnboardingStep[OnboardingStep["ONBOARDING_STEP_PERSONALIZATION"] = 2] = "ONBOARDING_STEP_PERSONALIZATION";
    OnboardingStep[OnboardingStep["ONBOARDING_STEP_PIN"] = 3] = "ONBOARDING_STEP_PIN";
    OnboardingStep[OnboardingStep["ONBOARDING_STEP_SETUP"] = 4] = "ONBOARDING_STEP_SETUP";
    OnboardingStep[OnboardingStep["ONBOARDING_STEP_DONE"] = 5] = "ONBOARDING_STEP_DONE";
})(exports.OnboardingStep || (exports.OnboardingStep = {}));
exports.OnboardingPhase = void 0;
(function (OnboardingPhase) {
    OnboardingPhase[OnboardingPhase["ONBOARDING_PHASE_UNKNOWN"] = 0] = "ONBOARDING_PHASE_UNKNOWN";
    OnboardingPhase[OnboardingPhase["ONBOARDING_PHASE_SAFETY_CHECK"] = 1] = "ONBOARDING_PHASE_SAFETY_CHECK";
    OnboardingPhase[OnboardingPhase["ONBOARDING_PHASE_PIN_SETUP"] = 2] = "ONBOARDING_PHASE_PIN_SETUP";
    OnboardingPhase[OnboardingPhase["ONBOARDING_PHASE_FINGERPRINT_SETUP"] = 3] = "ONBOARDING_PHASE_FINGERPRINT_SETUP";
    OnboardingPhase[OnboardingPhase["ONBOARDING_PHASE_SETUP_CHOICE"] = 4] = "ONBOARDING_PHASE_SETUP_CHOICE";
    OnboardingPhase[OnboardingPhase["ONBOARDING_PHASE_WALLET_CREATE_START"] = 5] = "ONBOARDING_PHASE_WALLET_CREATE_START";
    OnboardingPhase[OnboardingPhase["ONBOARDING_PHASE_RECOVERY_PHRASE_VIEW"] = 6] = "ONBOARDING_PHASE_RECOVERY_PHRASE_VIEW";
    OnboardingPhase[OnboardingPhase["ONBOARDING_PHASE_RECOVERY_PHRASE_CONFIRM"] = 7] = "ONBOARDING_PHASE_RECOVERY_PHRASE_CONFIRM";
    OnboardingPhase[OnboardingPhase["ONBOARDING_PHASE_RESTORE_METHOD_CHOICE"] = 8] = "ONBOARDING_PHASE_RESTORE_METHOD_CHOICE";
    OnboardingPhase[OnboardingPhase["ONBOARDING_PHASE_RECOVERY_PHRASE_RESTORE"] = 9] = "ONBOARDING_PHASE_RECOVERY_PHRASE_RESTORE";
    OnboardingPhase[OnboardingPhase["ONBOARDING_PHASE_SEEDCARD_RESTORE"] = 10] = "ONBOARDING_PHASE_SEEDCARD_RESTORE";
    OnboardingPhase[OnboardingPhase["ONBOARDING_PHASE_WALLET_READY"] = 11] = "ONBOARDING_PHASE_WALLET_READY";
    OnboardingPhase[OnboardingPhase["ONBOARDING_PHASE_SEEDCARD_BACKUP_PROMPT"] = 12] = "ONBOARDING_PHASE_SEEDCARD_BACKUP_PROMPT";
    OnboardingPhase[OnboardingPhase["ONBOARDING_PHASE_SEEDCARD_BACKUP"] = 13] = "ONBOARDING_PHASE_SEEDCARD_BACKUP";
})(exports.OnboardingPhase || (exports.OnboardingPhase = {}));
exports.OnboardingSetupKind = void 0;
(function (OnboardingSetupKind) {
    OnboardingSetupKind[OnboardingSetupKind["ONBOARDING_SETUP_KIND_UNKNOWN"] = 0] = "ONBOARDING_SETUP_KIND_UNKNOWN";
    OnboardingSetupKind[OnboardingSetupKind["ONBOARDING_SETUP_KIND_CHOICE"] = 1] = "ONBOARDING_SETUP_KIND_CHOICE";
    OnboardingSetupKind[OnboardingSetupKind["ONBOARDING_SETUP_KIND_CREATE"] = 2] = "ONBOARDING_SETUP_KIND_CREATE";
    OnboardingSetupKind[OnboardingSetupKind["ONBOARDING_SETUP_KIND_RESTORE"] = 3] = "ONBOARDING_SETUP_KIND_RESTORE";
})(exports.OnboardingSetupKind || (exports.OnboardingSetupKind = {}));
exports.OnboardingSetupMethod = void 0;
(function (OnboardingSetupMethod) {
    OnboardingSetupMethod[OnboardingSetupMethod["ONBOARDING_SETUP_METHOD_UNKNOWN"] = 0] = "ONBOARDING_SETUP_METHOD_UNKNOWN";
    OnboardingSetupMethod[OnboardingSetupMethod["ONBOARDING_SETUP_METHOD_RECOVERY_PHRASE"] = 1] = "ONBOARDING_SETUP_METHOD_RECOVERY_PHRASE";
    OnboardingSetupMethod[OnboardingSetupMethod["ONBOARDING_SETUP_METHOD_SEEDCARD"] = 2] = "ONBOARDING_SETUP_METHOD_SEEDCARD";
})(exports.OnboardingSetupMethod || (exports.OnboardingSetupMethod = {}));
exports.ViewTipType = void 0;
(function (ViewTipType) {
    ViewTipType[ViewTipType["Default"] = 0] = "Default";
    ViewTipType[ViewTipType["Highlight"] = 1] = "Highlight";
    ViewTipType[ViewTipType["Recommend"] = 2] = "Recommend";
    ViewTipType[ViewTipType["Warning"] = 3] = "Warning";
    ViewTipType[ViewTipType["Danger"] = 4] = "Danger";
})(exports.ViewTipType || (exports.ViewTipType = {}));
exports.ViewSignLayout = void 0;
(function (ViewSignLayout) {
    ViewSignLayout[ViewSignLayout["LayoutDefault"] = 0] = "LayoutDefault";
    ViewSignLayout[ViewSignLayout["LayoutSafeTxCreate"] = 1] = "LayoutSafeTxCreate";
    ViewSignLayout[ViewSignLayout["LayoutFinalConfirm"] = 2] = "LayoutFinalConfirm";
    ViewSignLayout[ViewSignLayout["Layout7702"] = 3] = "Layout7702";
    ViewSignLayout[ViewSignLayout["LayoutFlat"] = 4] = "LayoutFlat";
    ViewSignLayout[ViewSignLayout["LayoutEthApprove"] = 5] = "LayoutEthApprove";
})(exports.ViewSignLayout || (exports.ViewSignLayout = {}));
exports.ProtocolV2FailureType = void 0;
(function (ProtocolV2FailureType) {
    ProtocolV2FailureType[ProtocolV2FailureType["Failure_InvalidMessage"] = 1] = "Failure_InvalidMessage";
    ProtocolV2FailureType[ProtocolV2FailureType["Failure_UndefinedError"] = 2] = "Failure_UndefinedError";
    ProtocolV2FailureType[ProtocolV2FailureType["Failure_UsageError"] = 3] = "Failure_UsageError";
    ProtocolV2FailureType[ProtocolV2FailureType["Failure_DataError"] = 4] = "Failure_DataError";
    ProtocolV2FailureType[ProtocolV2FailureType["Failure_ProcessError"] = 5] = "Failure_ProcessError";
})(exports.ProtocolV2FailureType || (exports.ProtocolV2FailureType = {}));
exports.Enum_ProtocolV2Capability = void 0;
(function (Enum_ProtocolV2Capability) {
    Enum_ProtocolV2Capability[Enum_ProtocolV2Capability["Capability_Bitcoin"] = 1] = "Capability_Bitcoin";
    Enum_ProtocolV2Capability[Enum_ProtocolV2Capability["Capability_Bitcoin_like"] = 2] = "Capability_Bitcoin_like";
    Enum_ProtocolV2Capability[Enum_ProtocolV2Capability["Capability_Binance"] = 3] = "Capability_Binance";
    Enum_ProtocolV2Capability[Enum_ProtocolV2Capability["Capability_Cardano"] = 4] = "Capability_Cardano";
    Enum_ProtocolV2Capability[Enum_ProtocolV2Capability["Capability_Crypto"] = 5] = "Capability_Crypto";
    Enum_ProtocolV2Capability[Enum_ProtocolV2Capability["Capability_EOS"] = 6] = "Capability_EOS";
    Enum_ProtocolV2Capability[Enum_ProtocolV2Capability["Capability_Ethereum"] = 7] = "Capability_Ethereum";
    Enum_ProtocolV2Capability[Enum_ProtocolV2Capability["Capability_Lisk"] = 8] = "Capability_Lisk";
    Enum_ProtocolV2Capability[Enum_ProtocolV2Capability["Capability_Monero"] = 9] = "Capability_Monero";
    Enum_ProtocolV2Capability[Enum_ProtocolV2Capability["Capability_NEM"] = 10] = "Capability_NEM";
    Enum_ProtocolV2Capability[Enum_ProtocolV2Capability["Capability_Ripple"] = 11] = "Capability_Ripple";
    Enum_ProtocolV2Capability[Enum_ProtocolV2Capability["Capability_Stellar"] = 12] = "Capability_Stellar";
    Enum_ProtocolV2Capability[Enum_ProtocolV2Capability["Capability_Tezos"] = 13] = "Capability_Tezos";
    Enum_ProtocolV2Capability[Enum_ProtocolV2Capability["Capability_U2F"] = 14] = "Capability_U2F";
    Enum_ProtocolV2Capability[Enum_ProtocolV2Capability["Capability_Shamir"] = 15] = "Capability_Shamir";
    Enum_ProtocolV2Capability[Enum_ProtocolV2Capability["Capability_ShamirGroups"] = 16] = "Capability_ShamirGroups";
    Enum_ProtocolV2Capability[Enum_ProtocolV2Capability["Capability_PassphraseEntry"] = 17] = "Capability_PassphraseEntry";
    Enum_ProtocolV2Capability[Enum_ProtocolV2Capability["Capability_AttachToPin"] = 18] = "Capability_AttachToPin";
    Enum_ProtocolV2Capability[Enum_ProtocolV2Capability["Capability_EthereumTypedData"] = 1000] = "Capability_EthereumTypedData";
})(exports.Enum_ProtocolV2Capability || (exports.Enum_ProtocolV2Capability = {}));

var messages = /*#__PURE__*/Object.freeze({
    __proto__: null,
    get AptosTransactionType () { return exports.AptosTransactionType; },
    get BinanceOrderType () { return exports.BinanceOrderType; },
    get BinanceOrderSide () { return exports.BinanceOrderSide; },
    get BinanceTimeInForce () { return exports.BinanceTimeInForce; },
    get Enum_InputScriptType () { return exports.Enum_InputScriptType; },
    get Enum_OutputScriptType () { return exports.Enum_OutputScriptType; },
    get DecredStakingSpendType () { return exports.DecredStakingSpendType; },
    get AmountUnit () { return exports.AmountUnit; },
    get Enum_RequestType () { return exports.Enum_RequestType; },
    get RebootType () { return exports.RebootType; },
    get CardanoDerivationType () { return exports.CardanoDerivationType; },
    get CardanoAddressType () { return exports.CardanoAddressType; },
    get CardanoNativeScriptType () { return exports.CardanoNativeScriptType; },
    get CardanoNativeScriptHashDisplayFormat () { return exports.CardanoNativeScriptHashDisplayFormat; },
    get CardanoTxOutputSerializationFormat () { return exports.CardanoTxOutputSerializationFormat; },
    get CardanoCertificateType () { return exports.CardanoCertificateType; },
    get CardanoDRepType () { return exports.CardanoDRepType; },
    get CardanoPoolRelayType () { return exports.CardanoPoolRelayType; },
    get CardanoTxAuxiliaryDataSupplementType () { return exports.CardanoTxAuxiliaryDataSupplementType; },
    get CardanoCVoteRegistrationFormat () { return exports.CardanoCVoteRegistrationFormat; },
    get CardanoTxSigningMode () { return exports.CardanoTxSigningMode; },
    get CardanoTxWitnessType () { return exports.CardanoTxWitnessType; },
    get FailureType () { return exports.FailureType; },
    get Enum_ButtonRequestType () { return exports.Enum_ButtonRequestType; },
    get Enum_PinMatrixRequestType () { return exports.Enum_PinMatrixRequestType; },
    get EthereumDefinitionType () { return exports.EthereumDefinitionType; },
    get EthereumGnosisSafeTxOperation () { return exports.EthereumGnosisSafeTxOperation; },
    get EthereumDataTypeOneKey () { return exports.EthereumDataTypeOneKey; },
    get EthereumDataType () { return exports.EthereumDataType; },
    get Enum_KaspaInputScriptType () { return exports.Enum_KaspaInputScriptType; },
    get Enum_KaspaOutputScriptType () { return exports.Enum_KaspaOutputScriptType; },
    get Enum_KaspaRequestType () { return exports.Enum_KaspaRequestType; },
    get Enum_BackupType () { return exports.Enum_BackupType; },
    get Enum_SafetyCheckLevel () { return exports.Enum_SafetyCheckLevel; },
    get OneKeyDeviceType () { return exports.OneKeyDeviceType; },
    get OneKeySeType () { return exports.OneKeySeType; },
    get OneKeySEState () { return exports.OneKeySEState; },
    get Enum_Capability () { return exports.Enum_Capability; },
    get ExportType () { return exports.ExportType; },
    get SdProtectOperationType () { return exports.SdProtectOperationType; },
    get RecoveryDeviceType () { return exports.RecoveryDeviceType; },
    get Enum_WordRequestType () { return exports.Enum_WordRequestType; },
    get SeedRequestType () { return exports.SeedRequestType; },
    get WL_OperationType () { return exports.WL_OperationType; },
    get ResourceType () { return exports.ResourceType; },
    get NEMMosaicLevy () { return exports.NEMMosaicLevy; },
    get NEMSupplyChangeType () { return exports.NEMSupplyChangeType; },
    get NEMModificationType () { return exports.NEMModificationType; },
    get NEMImportanceTransferMode () { return exports.NEMImportanceTransferMode; },
    get SolanaOffChainMessageVersion () { return exports.SolanaOffChainMessageVersion; },
    get SolanaOffChainMessageFormat () { return exports.SolanaOffChainMessageFormat; },
    get StellarAssetType () { return exports.StellarAssetType; },
    get StellarMemoType () { return exports.StellarMemoType; },
    get StellarSignerType () { return exports.StellarSignerType; },
    get StellarRequestType () { return exports.StellarRequestType; },
    get TezosContractType () { return exports.TezosContractType; },
    get TezosBallotType () { return exports.TezosBallotType; },
    get TonWalletVersion () { return exports.TonWalletVersion; },
    get TonWorkChain () { return exports.TonWorkChain; },
    get TonSignDataType () { return exports.TonSignDataType; },
    get TronResourceCode () { return exports.TronResourceCode; },
    get TronMessageType () { return exports.TronMessageType; },
    get CommandFlags () { return exports.CommandFlags; },
    get Enum_CanonicalBitcoinNetwork () { return exports.Enum_CanonicalBitcoinNetwork; },
    get MoneroNetworkType () { return exports.MoneroNetworkType; },
    get UiAnimationType () { return exports.UiAnimationType; },
    get UiAnimationCommand () { return exports.UiAnimationCommand; },
    get DeviceErrorCode () { return exports.DeviceErrorCode; },
    get DeviceRebootType () { return exports.DeviceRebootType; },
    get DeviceSettingsPage () { return exports.DeviceSettingsPage; },
    get DeviceAnimationAction () { return exports.DeviceAnimationAction; },
    get DeviceFactoryAck () { return exports.DeviceFactoryAck; },
    get DeviceFirmwareTargetType () { return exports.DeviceFirmwareTargetType; },
    get DeviceFirmwareUpdateTaskStatus () { return exports.DeviceFirmwareUpdateTaskStatus; },
    get DeviceFirmwareUpdatePhase () { return exports.DeviceFirmwareUpdatePhase; },
    get DeviceType () { return exports.DeviceType; },
    get DeviceSeType () { return exports.DeviceSeType; },
    get DeviceSEState () { return exports.DeviceSEState; },
    get DeviceSessionErrorCode () { return exports.DeviceSessionErrorCode; },
    get DeviceSessionSeedDomain () { return exports.DeviceSessionSeedDomain; },
    get DeviceSessionPinType () { return exports.DeviceSessionPinType; },
    get DeviceSessionAskPin_FailureSubCodes () { return exports.DeviceSessionAskPin_FailureSubCodes; },
    get OnboardingStep () { return exports.OnboardingStep; },
    get OnboardingPhase () { return exports.OnboardingPhase; },
    get OnboardingSetupKind () { return exports.OnboardingSetupKind; },
    get OnboardingSetupMethod () { return exports.OnboardingSetupMethod; },
    get ViewTipType () { return exports.ViewTipType; },
    get ViewSignLayout () { return exports.ViewSignLayout; },
    get ProtocolV2FailureType () { return exports.ProtocolV2FailureType; },
    get Enum_ProtocolV2Capability () { return exports.Enum_ProtocolV2Capability; }
});

const REDACTED = '[REDACTED]';
const SENSITIVE_LOG_KEYS = new Set([
    'accesstoken',
    'address',
    'apikey',
    'connectid',
    'devicestate',
    'deviceid',
    'entropy',
    'expectedpassphrasestate',
    'mnemonic',
    'passphrase',
    'passphrasestate',
    'password',
    'pin',
    'privatekey',
    'publickey',
    'seed',
    'secret',
    'serialnumber',
    'session',
    'sessionid',
    'signature',
    'token',
    'uuid',
    'walletsessionid',
    'xprv',
    'xpub',
]);
const normalizeLogKey = (key) => key.replace(/[_-]/g, '').toLowerCase();
const isSensitiveLogKey = (key) => {
    const normalizedKey = normalizeLogKey(key);
    return (SENSITIVE_LOG_KEYS.has(normalizedKey) ||
        normalizedKey.endsWith('address') ||
        normalizedKey.endsWith('privatekey') ||
        normalizedKey.endsWith('publickey') ||
        normalizedKey.endsWith('signature'));
};
const isSigningMessage = (messageName) => Boolean(messageName && /(?:sign|txack|transaction)/i.test(messageName));
const redactLogValue = (value, seen) => {
    if (ArrayBuffer.isView(value)) {
        return `[BINARY:${value.byteLength}]`;
    }
    if (value instanceof ArrayBuffer) {
        return `[BINARY:${value.byteLength}]`;
    }
    if (Array.isArray(value)) {
        return value.map(item => redactLogValue(item, seen));
    }
    if (!value || typeof value !== 'object') {
        return value;
    }
    if (seen.has(value)) {
        return '[CIRCULAR]';
    }
    seen.add(value);
    const redacted = Object.fromEntries(Object.entries(value).map(([key, item]) => [
        key,
        isSensitiveLogKey(key) && item !== null && item !== undefined
            ? REDACTED
            : redactLogValue(item, seen),
    ]));
    seen.delete(value);
    return redacted;
};
function getSafeTransportLogPayload(value, messageName) {
    if (isSigningMessage(messageName)) {
        return REDACTED;
    }
    return redactLogValue(value, new WeakSet());
}
function createTransportCallLog(name, protocol, data) {
    return {
        name,
        protocol,
        request: getSafeTransportLogPayload(data, name),
    };
}
const HIGH_VOLUME_CALLS = new Set(['FileWrite', 'FilesystemFileWrite', 'EmmcFileWrite']);
function shouldSuppressHighVolumeCallLog(name) {
    return HIGH_VOLUME_CALLS.has(name);
}

protobuf__namespace.util.Long = require$$1__default["default"];
protobuf__namespace.configure();
var index = {
    check,
    parseConfigure,
    protocolV2: protocolV2Codec,
    ProtocolV1,
    ProtocolV2,
    PROTOCOL_V2_SYS_MESSAGE_THRESHOLD,
    ProtocolV2FrameAssembler,
    ProtocolV2LinkManager,
    ProtocolV2SequenceCursor,
    ProtocolV2Session,
    ProtocolV2UsbTransportBase,
    bytesToHex,
    concatUint8Arrays,
    createMessageFromName,
    createMessageFromType,
    encodeProtobuf: encode,
    decodeProtobuf: decode,
    getErrorMessage,
    hexToBytes,
    probeProtocolV2,
    withProtocolTimeout,
};

exports.LogBlockCommand = LogBlockCommand;
exports.Messages = messages;
exports.PROTOCOL_V1_CHUNK_PAYLOAD_SIZE = PROTOCOL_V1_CHUNK_PAYLOAD_SIZE;
exports.PROTOCOL_V1_ENVELOPE_HEADER_SIZE = PROTOCOL_V1_ENVELOPE_HEADER_SIZE;
exports.PROTOCOL_V1_HEADER_BYTE = PROTOCOL_V1_HEADER_BYTE;
exports.PROTOCOL_V1_MESSAGE_HEADER_SIZE = PROTOCOL_V1_MESSAGE_HEADER_SIZE;
exports.PROTOCOL_V1_REPORT_ID = PROTOCOL_V1_REPORT_ID;
exports.PROTOCOL_V1_USB_PACKET_SIZE = PROTOCOL_V1_USB_PACKET_SIZE;
exports.PROTOCOL_V2_BLE_FILE_CHUNK_SIZE = PROTOCOL_V2_BLE_FILE_CHUNK_SIZE;
exports.PROTOCOL_V2_BLE_FILE_READ_CHUNK_SIZE = PROTOCOL_V2_BLE_FILE_READ_CHUNK_SIZE;
exports.PROTOCOL_V2_BLE_FIRMWARE_FILE_CHUNK_SIZE = PROTOCOL_V2_BLE_FIRMWARE_FILE_CHUNK_SIZE;
exports.PROTOCOL_V2_BLE_FRAME_MAX_BYTES = PROTOCOL_V2_BLE_FRAME_MAX_BYTES;
exports.PROTOCOL_V2_CHANNEL_BLE_UART = PROTOCOL_V2_CHANNEL_BLE_UART;
exports.PROTOCOL_V2_CHANNEL_SOCKET = PROTOCOL_V2_CHANNEL_SOCKET;
exports.PROTOCOL_V2_CHANNEL_USB = PROTOCOL_V2_CHANNEL_USB;
exports.PROTOCOL_V2_DEFAULT_RESPONSE_TIMEOUT_MS = PROTOCOL_V2_DEFAULT_RESPONSE_TIMEOUT_MS;
exports.PROTOCOL_V2_FILE_CHUNK_SIZE = PROTOCOL_V2_FILE_CHUNK_SIZE;
exports.PROTOCOL_V2_FRAME_MAX_BYTES = PROTOCOL_V2_FRAME_MAX_BYTES;
exports.PROTOCOL_V2_PACKET_SRC_COMMAND = PROTOCOL_V2_PACKET_SRC_COMMAND;
exports.PROTOCOL_V2_SYS_MESSAGE_THRESHOLD = PROTOCOL_V2_SYS_MESSAGE_THRESHOLD;
exports.PROTOCOL_V2_WEBUSB_FILE_CHUNK_SIZE = PROTOCOL_V2_WEBUSB_FILE_CHUNK_SIZE;
exports.ProtocolV1 = ProtocolV1;
exports.ProtocolV2 = ProtocolV2;
exports.ProtocolV2FrameAssembler = ProtocolV2FrameAssembler;
exports.ProtocolV2LinkError = ProtocolV2LinkError;
exports.ProtocolV2LinkManager = ProtocolV2LinkManager;
exports.ProtocolV2SequenceCursor = ProtocolV2SequenceCursor;
exports.ProtocolV2Session = ProtocolV2Session;
exports.ProtocolV2UsbTransportBase = ProtocolV2UsbTransportBase;
exports.TRANSPORT_EVENT = TRANSPORT_EVENT;
exports.bytesToHex = bytesToHex;
exports.concatUint8Arrays = concatUint8Arrays;
exports.createProtocolV2LinkDisabledError = createProtocolV2LinkDisabledError;
exports.createTransportCallLog = createTransportCallLog;
exports["default"] = index;
exports.detectProtocolV2LinkDisabledError = detectProtocolV2LinkDisabledError;
exports.getErrorMessage = getErrorMessage;
exports.getSafeTransportLogPayload = getSafeTransportLogPayload;
exports.hexToBytes = hexToBytes;
exports.isProtocolV2HighThroughputCall = isProtocolV2HighThroughputCall;
exports.isProtocolV2LinkDisabledError = isProtocolV2LinkDisabledError;
exports.isProtocolV2LinkDisabledFailure = isProtocolV2LinkDisabledFailure;
exports.isProtocolV2LinkError = isProtocolV2LinkError;
exports.probeProtocolV2 = probeProtocolV2;
exports.protocolV1 = index$1;
exports.protocolV2 = protocolV2Codec;
exports.shouldSuppressHighVolumeCallLog = shouldSuppressHighVolumeCallLog;
exports.withProtocolTimeout = withProtocolTimeout;
exports.writeProtocolV2BleFrame = writeProtocolV2BleFrame;
